
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec261"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec261"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("c1apC", function(module, exports) {
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ module.exports = Worker;

});

parcelRegister("8oWJe", function(module, exports) {
"use strict";
// --------------    FAKE ELEMENTS GWT ASSUMES EXIST   -------------- 
var $61de1ee1cac498ae$var$$wnd;
if (typeof window !== "undefined") $61de1ee1cac498ae$var$$wnd = window;
else if (typeof $parcel$global !== "undefined") $61de1ee1cac498ae$var$$wnd = $parcel$global // nodejs
;
else if (typeof self !== "undefined") $61de1ee1cac498ae$var$$wnd = self // web worker
;
var $61de1ee1cac498ae$var$$moduleName, $61de1ee1cac498ae$var$$moduleBase;
// --------------    WORKAROUND STRICT MODE, SEE #127    -------------- 
var $61de1ee1cac498ae$var$g, $61de1ee1cac498ae$var$i, $61de1ee1cac498ae$var$o;
// --------------    GENERATED CODE    -------------- 
function $61de1ee1cac498ae$var$nb() {}
function $61de1ee1cac498ae$var$xb() {}
function $61de1ee1cac498ae$var$Fd() {}
function $61de1ee1cac498ae$var$$g() {}
function $61de1ee1cac498ae$var$_p() {}
function $61de1ee1cac498ae$var$yq() {}
function $61de1ee1cac498ae$var$Sq() {}
function $61de1ee1cac498ae$var$Es() {}
function $61de1ee1cac498ae$var$Jw() {}
function $61de1ee1cac498ae$var$Vw() {}
function $61de1ee1cac498ae$var$VA() {}
function $61de1ee1cac498ae$var$dA() {}
function $61de1ee1cac498ae$var$MA() {}
function $61de1ee1cac498ae$var$PA() {}
function $61de1ee1cac498ae$var$PB() {}
function $61de1ee1cac498ae$var$bx() {}
function $61de1ee1cac498ae$var$cx() {}
function $61de1ee1cac498ae$var$vy() {}
function $61de1ee1cac498ae$var$Nz() {}
function $61de1ee1cac498ae$var$Yz() {}
function $61de1ee1cac498ae$var$Ylb() {}
function $61de1ee1cac498ae$var$Ymb() {}
function $61de1ee1cac498ae$var$xmb() {}
function $61de1ee1cac498ae$var$Fmb() {}
function $61de1ee1cac498ae$var$Qmb() {}
function $61de1ee1cac498ae$var$gcb() {}
function $61de1ee1cac498ae$var$ccb() {}
function $61de1ee1cac498ae$var$jcb() {}
function $61de1ee1cac498ae$var$jtb() {}
function $61de1ee1cac498ae$var$otb() {}
function $61de1ee1cac498ae$var$qtb() {}
function $61de1ee1cac498ae$var$_fb() {}
function $61de1ee1cac498ae$var$bpb() {}
function $61de1ee1cac498ae$var$kpb() {}
function $61de1ee1cac498ae$var$ppb() {}
function $61de1ee1cac498ae$var$Gpb() {}
function $61de1ee1cac498ae$var$drb() {}
function $61de1ee1cac498ae$var$dzb() {}
function $61de1ee1cac498ae$var$fzb() {}
function $61de1ee1cac498ae$var$fxb() {}
function $61de1ee1cac498ae$var$Vxb() {}
function $61de1ee1cac498ae$var$Ovb() {}
function $61de1ee1cac498ae$var$byb() {}
function $61de1ee1cac498ae$var$zyb() {}
function $61de1ee1cac498ae$var$Zyb() {}
function $61de1ee1cac498ae$var$_yb() {}
function $61de1ee1cac498ae$var$hzb() {}
function $61de1ee1cac498ae$var$jzb() {}
function $61de1ee1cac498ae$var$lzb() {}
function $61de1ee1cac498ae$var$nzb() {}
function $61de1ee1cac498ae$var$rzb() {}
function $61de1ee1cac498ae$var$zzb() {}
function $61de1ee1cac498ae$var$Czb() {}
function $61de1ee1cac498ae$var$Ezb() {}
function $61de1ee1cac498ae$var$Gzb() {}
function $61de1ee1cac498ae$var$Izb() {}
function $61de1ee1cac498ae$var$Mzb() {}
function $61de1ee1cac498ae$var$bBb() {}
function $61de1ee1cac498ae$var$NBb() {}
function $61de1ee1cac498ae$var$PBb() {}
function $61de1ee1cac498ae$var$RBb() {}
function $61de1ee1cac498ae$var$iCb() {}
function $61de1ee1cac498ae$var$OCb() {}
function $61de1ee1cac498ae$var$SCb() {}
function $61de1ee1cac498ae$var$GDb() {}
function $61de1ee1cac498ae$var$JDb() {}
function $61de1ee1cac498ae$var$fEb() {}
function $61de1ee1cac498ae$var$xEb() {}
function $61de1ee1cac498ae$var$CEb() {}
function $61de1ee1cac498ae$var$GEb() {}
function $61de1ee1cac498ae$var$yFb() {}
function $61de1ee1cac498ae$var$KGb() {}
function $61de1ee1cac498ae$var$tIb() {}
function $61de1ee1cac498ae$var$vIb() {}
function $61de1ee1cac498ae$var$xIb() {}
function $61de1ee1cac498ae$var$zIb() {}
function $61de1ee1cac498ae$var$OIb() {}
function $61de1ee1cac498ae$var$SIb() {}
function $61de1ee1cac498ae$var$TJb() {}
function $61de1ee1cac498ae$var$VJb() {}
function $61de1ee1cac498ae$var$XJb() {}
function $61de1ee1cac498ae$var$XKb() {}
function $61de1ee1cac498ae$var$fKb() {}
function $61de1ee1cac498ae$var$VKb() {}
function $61de1ee1cac498ae$var$VLb() {}
function $61de1ee1cac498ae$var$jLb() {}
function $61de1ee1cac498ae$var$nLb() {}
function $61de1ee1cac498ae$var$GLb() {}
function $61de1ee1cac498ae$var$KLb() {}
function $61de1ee1cac498ae$var$MLb() {}
function $61de1ee1cac498ae$var$OLb() {}
function $61de1ee1cac498ae$var$RLb() {}
function $61de1ee1cac498ae$var$YLb() {}
function $61de1ee1cac498ae$var$bMb() {}
function $61de1ee1cac498ae$var$gMb() {}
function $61de1ee1cac498ae$var$lMb() {}
function $61de1ee1cac498ae$var$pMb() {}
function $61de1ee1cac498ae$var$wMb() {}
function $61de1ee1cac498ae$var$zMb() {}
function $61de1ee1cac498ae$var$CMb() {}
function $61de1ee1cac498ae$var$FMb() {}
function $61de1ee1cac498ae$var$LMb() {}
function $61de1ee1cac498ae$var$zNb() {}
function $61de1ee1cac498ae$var$PNb() {}
function $61de1ee1cac498ae$var$kOb() {}
function $61de1ee1cac498ae$var$pOb() {}
function $61de1ee1cac498ae$var$tOb() {}
function $61de1ee1cac498ae$var$yOb() {}
function $61de1ee1cac498ae$var$FOb() {}
function $61de1ee1cac498ae$var$GPb() {}
function $61de1ee1cac498ae$var$aQb() {}
function $61de1ee1cac498ae$var$cQb() {}
function $61de1ee1cac498ae$var$eQb() {}
function $61de1ee1cac498ae$var$gQb() {}
function $61de1ee1cac498ae$var$iQb() {}
function $61de1ee1cac498ae$var$CQb() {}
function $61de1ee1cac498ae$var$MQb() {}
function $61de1ee1cac498ae$var$OQb() {}
function $61de1ee1cac498ae$var$ASb() {}
function $61de1ee1cac498ae$var$fTb() {}
function $61de1ee1cac498ae$var$kTb() {}
function $61de1ee1cac498ae$var$STb() {}
function $61de1ee1cac498ae$var$fUb() {}
function $61de1ee1cac498ae$var$DUb() {}
function $61de1ee1cac498ae$var$VUb() {}
function $61de1ee1cac498ae$var$YUb() {}
function $61de1ee1cac498ae$var$_Ub() {}
function $61de1ee1cac498ae$var$_Wb() {}
function $61de1ee1cac498ae$var$QWb() {}
function $61de1ee1cac498ae$var$XWb() {}
function $61de1ee1cac498ae$var$jVb() {}
function $61de1ee1cac498ae$var$DVb() {}
function $61de1ee1cac498ae$var$VVb() {}
function $61de1ee1cac498ae$var$$Vb() {}
function $61de1ee1cac498ae$var$dXb() {}
function $61de1ee1cac498ae$var$hXb() {}
function $61de1ee1cac498ae$var$lXb() {}
function $61de1ee1cac498ae$var$gYb() {}
function $61de1ee1cac498ae$var$HYb() {}
function $61de1ee1cac498ae$var$SYb() {}
function $61de1ee1cac498ae$var$VYb() {}
function $61de1ee1cac498ae$var$dZb() {}
function $61de1ee1cac498ae$var$P$b() {}
function $61de1ee1cac498ae$var$T$b() {}
function $61de1ee1cac498ae$var$h1b() {}
function $61de1ee1cac498ae$var$m1b() {}
function $61de1ee1cac498ae$var$q1b() {}
function $61de1ee1cac498ae$var$u1b() {}
function $61de1ee1cac498ae$var$y1b() {}
function $61de1ee1cac498ae$var$C1b() {}
function $61de1ee1cac498ae$var$e2b() {}
function $61de1ee1cac498ae$var$g2b() {}
function $61de1ee1cac498ae$var$m2b() {}
function $61de1ee1cac498ae$var$q2b() {}
function $61de1ee1cac498ae$var$u2b() {}
function $61de1ee1cac498ae$var$S2b() {}
function $61de1ee1cac498ae$var$U2b() {}
function $61de1ee1cac498ae$var$W2b() {}
function $61de1ee1cac498ae$var$_2b() {}
function $61de1ee1cac498ae$var$e3b() {}
function $61de1ee1cac498ae$var$h3b() {}
function $61de1ee1cac498ae$var$p3b() {}
function $61de1ee1cac498ae$var$t3b() {}
function $61de1ee1cac498ae$var$w3b() {}
function $61de1ee1cac498ae$var$y3b() {}
function $61de1ee1cac498ae$var$A3b() {}
function $61de1ee1cac498ae$var$M3b() {}
function $61de1ee1cac498ae$var$Q3b() {}
function $61de1ee1cac498ae$var$U3b() {}
function $61de1ee1cac498ae$var$Y3b() {}
function $61de1ee1cac498ae$var$l4b() {}
function $61de1ee1cac498ae$var$q4b() {}
function $61de1ee1cac498ae$var$s4b() {}
function $61de1ee1cac498ae$var$u4b() {}
function $61de1ee1cac498ae$var$w4b() {}
function $61de1ee1cac498ae$var$y4b() {}
function $61de1ee1cac498ae$var$L4b() {}
function $61de1ee1cac498ae$var$N4b() {}
function $61de1ee1cac498ae$var$P4b() {}
function $61de1ee1cac498ae$var$R4b() {}
function $61de1ee1cac498ae$var$T4b() {}
function $61de1ee1cac498ae$var$X4b() {}
function $61de1ee1cac498ae$var$I5b() {}
function $61de1ee1cac498ae$var$Q5b() {}
function $61de1ee1cac498ae$var$T5b() {}
function $61de1ee1cac498ae$var$Z5b() {}
function $61de1ee1cac498ae$var$l6b() {}
function $61de1ee1cac498ae$var$o6b() {}
function $61de1ee1cac498ae$var$t6b() {}
function $61de1ee1cac498ae$var$z6b() {}
function $61de1ee1cac498ae$var$L6b() {}
function $61de1ee1cac498ae$var$M6b() {}
function $61de1ee1cac498ae$var$P6b() {}
function $61de1ee1cac498ae$var$X6b() {}
function $61de1ee1cac498ae$var$$6b() {}
function $61de1ee1cac498ae$var$a7b() {}
function $61de1ee1cac498ae$var$c7b() {}
function $61de1ee1cac498ae$var$g7b() {}
function $61de1ee1cac498ae$var$j7b() {}
function $61de1ee1cac498ae$var$m7b() {}
function $61de1ee1cac498ae$var$r7b() {}
function $61de1ee1cac498ae$var$x7b() {}
function $61de1ee1cac498ae$var$D7b() {}
function $61de1ee1cac498ae$var$D9b() {}
function $61de1ee1cac498ae$var$b9b() {}
function $61de1ee1cac498ae$var$h9b() {}
function $61de1ee1cac498ae$var$j9b() {}
function $61de1ee1cac498ae$var$l9b() {}
function $61de1ee1cac498ae$var$w9b() {}
function $61de1ee1cac498ae$var$F9b() {}
function $61de1ee1cac498ae$var$hac() {}
function $61de1ee1cac498ae$var$jac() {}
function $61de1ee1cac498ae$var$pac() {}
function $61de1ee1cac498ae$var$uac() {}
function $61de1ee1cac498ae$var$Iac() {}
function $61de1ee1cac498ae$var$Kac() {}
function $61de1ee1cac498ae$var$Sac() {}
function $61de1ee1cac498ae$var$obc() {}
function $61de1ee1cac498ae$var$rbc() {}
function $61de1ee1cac498ae$var$vbc() {}
function $61de1ee1cac498ae$var$Fbc() {}
function $61de1ee1cac498ae$var$Jbc() {}
function $61de1ee1cac498ae$var$Xbc() {}
function $61de1ee1cac498ae$var$ccc() {}
function $61de1ee1cac498ae$var$fcc() {}
function $61de1ee1cac498ae$var$lcc() {}
function $61de1ee1cac498ae$var$occ() {}
function $61de1ee1cac498ae$var$tcc() {}
function $61de1ee1cac498ae$var$ycc() {}
function $61de1ee1cac498ae$var$Acc() {}
function $61de1ee1cac498ae$var$Ccc() {}
function $61de1ee1cac498ae$var$Ecc() {}
function $61de1ee1cac498ae$var$Gcc() {}
function $61de1ee1cac498ae$var$Zcc() {}
function $61de1ee1cac498ae$var$_cc() {}
function $61de1ee1cac498ae$var$bdc() {}
function $61de1ee1cac498ae$var$fdc() {}
function $61de1ee1cac498ae$var$jdc() {}
function $61de1ee1cac498ae$var$pdc() {}
function $61de1ee1cac498ae$var$sdc() {}
function $61de1ee1cac498ae$var$ydc() {}
function $61de1ee1cac498ae$var$Adc() {}
function $61de1ee1cac498ae$var$Cdc() {}
function $61de1ee1cac498ae$var$Edc() {}
function $61de1ee1cac498ae$var$Idc() {}
function $61de1ee1cac498ae$var$Ndc() {}
function $61de1ee1cac498ae$var$Qdc() {}
function $61de1ee1cac498ae$var$Sdc() {}
function $61de1ee1cac498ae$var$Udc() {}
function $61de1ee1cac498ae$var$Wdc() {}
function $61de1ee1cac498ae$var$Ydc() {}
function $61de1ee1cac498ae$var$aec() {}
function $61de1ee1cac498ae$var$hec() {}
function $61de1ee1cac498ae$var$jec() {}
function $61de1ee1cac498ae$var$lec() {}
function $61de1ee1cac498ae$var$nec() {}
function $61de1ee1cac498ae$var$uec() {}
function $61de1ee1cac498ae$var$wec() {}
function $61de1ee1cac498ae$var$yec() {}
function $61de1ee1cac498ae$var$Aec() {}
function $61de1ee1cac498ae$var$Fec() {}
function $61de1ee1cac498ae$var$Jec() {}
function $61de1ee1cac498ae$var$Lec() {}
function $61de1ee1cac498ae$var$Nec() {}
function $61de1ee1cac498ae$var$Rec() {}
function $61de1ee1cac498ae$var$Uec() {}
function $61de1ee1cac498ae$var$Zec() {}
function $61de1ee1cac498ae$var$Zfc() {}
function $61de1ee1cac498ae$var$lfc() {}
function $61de1ee1cac498ae$var$tfc() {}
function $61de1ee1cac498ae$var$xfc() {}
function $61de1ee1cac498ae$var$zfc() {}
function $61de1ee1cac498ae$var$Ffc() {}
function $61de1ee1cac498ae$var$Jfc() {}
function $61de1ee1cac498ae$var$Nfc() {}
function $61de1ee1cac498ae$var$Pfc() {}
function $61de1ee1cac498ae$var$Vfc() {}
function $61de1ee1cac498ae$var$_fc() {}
function $61de1ee1cac498ae$var$fgc() {}
function $61de1ee1cac498ae$var$jgc() {}
function $61de1ee1cac498ae$var$lgc() {}
function $61de1ee1cac498ae$var$Bgc() {}
function $61de1ee1cac498ae$var$ehc() {}
function $61de1ee1cac498ae$var$ghc() {}
function $61de1ee1cac498ae$var$ihc() {}
function $61de1ee1cac498ae$var$khc() {}
function $61de1ee1cac498ae$var$mhc() {}
function $61de1ee1cac498ae$var$ohc() {}
function $61de1ee1cac498ae$var$qhc() {}
function $61de1ee1cac498ae$var$yhc() {}
function $61de1ee1cac498ae$var$Ahc() {}
function $61de1ee1cac498ae$var$Ghc() {}
function $61de1ee1cac498ae$var$Ihc() {}
function $61de1ee1cac498ae$var$Khc() {}
function $61de1ee1cac498ae$var$Mhc() {}
function $61de1ee1cac498ae$var$Shc() {}
function $61de1ee1cac498ae$var$Uhc() {}
function $61de1ee1cac498ae$var$Whc() {}
function $61de1ee1cac498ae$var$dic() {}
function $61de1ee1cac498ae$var$dlc() {}
function $61de1ee1cac498ae$var$blc() {}
function $61de1ee1cac498ae$var$flc() {}
function $61de1ee1cac498ae$var$hlc() {}
function $61de1ee1cac498ae$var$jlc() {}
function $61de1ee1cac498ae$var$Glc() {}
function $61de1ee1cac498ae$var$Ilc() {}
function $61de1ee1cac498ae$var$Klc() {}
function $61de1ee1cac498ae$var$Mlc() {}
function $61de1ee1cac498ae$var$Mjc() {}
function $61de1ee1cac498ae$var$Qjc() {}
function $61de1ee1cac498ae$var$Qlc() {}
function $61de1ee1cac498ae$var$Ulc() {}
function $61de1ee1cac498ae$var$Ylc() {}
function $61de1ee1cac498ae$var$Lkc() {}
function $61de1ee1cac498ae$var$Nkc() {}
function $61de1ee1cac498ae$var$Pkc() {}
function $61de1ee1cac498ae$var$Rkc() {}
function $61de1ee1cac498ae$var$Xkc() {}
function $61de1ee1cac498ae$var$_kc() {}
function $61de1ee1cac498ae$var$gmc() {}
function $61de1ee1cac498ae$var$kmc() {}
function $61de1ee1cac498ae$var$zmc() {}
function $61de1ee1cac498ae$var$Fmc() {}
function $61de1ee1cac498ae$var$Wmc() {}
function $61de1ee1cac498ae$var$$mc() {}
function $61de1ee1cac498ae$var$anc() {}
function $61de1ee1cac498ae$var$mnc() {}
function $61de1ee1cac498ae$var$wnc() {}
function $61de1ee1cac498ae$var$Hnc() {}
function $61de1ee1cac498ae$var$Jnc() {}
function $61de1ee1cac498ae$var$Lnc() {}
function $61de1ee1cac498ae$var$Nnc() {}
function $61de1ee1cac498ae$var$Pnc() {}
function $61de1ee1cac498ae$var$Ync() {}
function $61de1ee1cac498ae$var$eoc() {}
function $61de1ee1cac498ae$var$Aoc() {}
function $61de1ee1cac498ae$var$Coc() {}
function $61de1ee1cac498ae$var$Eoc() {}
function $61de1ee1cac498ae$var$Joc() {}
function $61de1ee1cac498ae$var$Loc() {}
function $61de1ee1cac498ae$var$Zoc() {}
function $61de1ee1cac498ae$var$_oc() {}
function $61de1ee1cac498ae$var$bpc() {}
function $61de1ee1cac498ae$var$hpc() {}
function $61de1ee1cac498ae$var$kpc() {}
function $61de1ee1cac498ae$var$ppc() {}
function $61de1ee1cac498ae$var$pFc() {}
function $61de1ee1cac498ae$var$Ryc() {}
function $61de1ee1cac498ae$var$QCc() {}
function $61de1ee1cac498ae$var$PDc() {}
function $61de1ee1cac498ae$var$xGc() {}
function $61de1ee1cac498ae$var$HGc() {}
function $61de1ee1cac498ae$var$JGc() {}
function $61de1ee1cac498ae$var$NGc() {}
function $61de1ee1cac498ae$var$GIc() {}
function $61de1ee1cac498ae$var$iKc() {}
function $61de1ee1cac498ae$var$mKc() {}
function $61de1ee1cac498ae$var$wKc() {}
function $61de1ee1cac498ae$var$yKc() {}
function $61de1ee1cac498ae$var$AKc() {}
function $61de1ee1cac498ae$var$EKc() {}
function $61de1ee1cac498ae$var$KKc() {}
function $61de1ee1cac498ae$var$OKc() {}
function $61de1ee1cac498ae$var$QKc() {}
function $61de1ee1cac498ae$var$SKc() {}
function $61de1ee1cac498ae$var$UKc() {}
function $61de1ee1cac498ae$var$YKc() {}
function $61de1ee1cac498ae$var$aLc() {}
function $61de1ee1cac498ae$var$fLc() {}
function $61de1ee1cac498ae$var$hLc() {}
function $61de1ee1cac498ae$var$nLc() {}
function $61de1ee1cac498ae$var$pLc() {}
function $61de1ee1cac498ae$var$tLc() {}
function $61de1ee1cac498ae$var$vLc() {}
function $61de1ee1cac498ae$var$zLc() {}
function $61de1ee1cac498ae$var$BLc() {}
function $61de1ee1cac498ae$var$DLc() {}
function $61de1ee1cac498ae$var$FLc() {}
function $61de1ee1cac498ae$var$sMc() {}
function $61de1ee1cac498ae$var$JMc() {}
function $61de1ee1cac498ae$var$hNc() {}
function $61de1ee1cac498ae$var$RNc() {}
function $61de1ee1cac498ae$var$ZNc() {}
function $61de1ee1cac498ae$var$_Nc() {}
function $61de1ee1cac498ae$var$bOc() {}
function $61de1ee1cac498ae$var$dOc() {}
function $61de1ee1cac498ae$var$fOc() {}
function $61de1ee1cac498ae$var$hOc() {}
function $61de1ee1cac498ae$var$hRc() {}
function $61de1ee1cac498ae$var$jRc() {}
function $61de1ee1cac498ae$var$KRc() {}
function $61de1ee1cac498ae$var$NRc() {}
function $61de1ee1cac498ae$var$NQc() {}
function $61de1ee1cac498ae$var$LQc() {}
function $61de1ee1cac498ae$var$_Qc() {}
function $61de1ee1cac498ae$var$cPc() {}
function $61de1ee1cac498ae$var$iPc() {}
function $61de1ee1cac498ae$var$kPc() {}
function $61de1ee1cac498ae$var$mPc() {}
function $61de1ee1cac498ae$var$xPc() {}
function $61de1ee1cac498ae$var$zPc() {}
function $61de1ee1cac498ae$var$zSc() {}
function $61de1ee1cac498ae$var$BSc() {}
function $61de1ee1cac498ae$var$GSc() {}
function $61de1ee1cac498ae$var$ISc() {}
function $61de1ee1cac498ae$var$NSc() {}
function $61de1ee1cac498ae$var$TSc() {}
function $61de1ee1cac498ae$var$NTc() {}
function $61de1ee1cac498ae$var$NVc() {}
function $61de1ee1cac498ae$var$oVc() {}
function $61de1ee1cac498ae$var$SVc() {}
function $61de1ee1cac498ae$var$VVc() {}
function $61de1ee1cac498ae$var$XVc() {}
function $61de1ee1cac498ae$var$ZVc() {}
function $61de1ee1cac498ae$var$bWc() {}
function $61de1ee1cac498ae$var$bXc() {}
function $61de1ee1cac498ae$var$CXc() {}
function $61de1ee1cac498ae$var$FXc() {}
function $61de1ee1cac498ae$var$IXc() {}
function $61de1ee1cac498ae$var$MXc() {}
function $61de1ee1cac498ae$var$UXc() {}
function $61de1ee1cac498ae$var$bYc() {}
function $61de1ee1cac498ae$var$fYc() {}
function $61de1ee1cac498ae$var$oYc() {}
function $61de1ee1cac498ae$var$qYc() {}
function $61de1ee1cac498ae$var$uYc() {}
function $61de1ee1cac498ae$var$pZc() {}
function $61de1ee1cac498ae$var$G$c() {}
function $61de1ee1cac498ae$var$h0c() {}
function $61de1ee1cac498ae$var$N0c() {}
function $61de1ee1cac498ae$var$k1c() {}
function $61de1ee1cac498ae$var$I1c() {}
function $61de1ee1cac498ae$var$Q1c() {}
function $61de1ee1cac498ae$var$f2c() {}
function $61de1ee1cac498ae$var$i2c() {}
function $61de1ee1cac498ae$var$k2c() {}
function $61de1ee1cac498ae$var$w2c() {}
function $61de1ee1cac498ae$var$O2c() {}
function $61de1ee1cac498ae$var$S2c() {}
function $61de1ee1cac498ae$var$Z2c() {}
function $61de1ee1cac498ae$var$v3c() {}
function $61de1ee1cac498ae$var$x3c() {}
function $61de1ee1cac498ae$var$R3c() {}
function $61de1ee1cac498ae$var$U3c() {}
function $61de1ee1cac498ae$var$e4c() {}
function $61de1ee1cac498ae$var$w4c() {}
function $61de1ee1cac498ae$var$x4c() {}
function $61de1ee1cac498ae$var$z4c() {}
function $61de1ee1cac498ae$var$B4c() {}
function $61de1ee1cac498ae$var$D4c() {}
function $61de1ee1cac498ae$var$F4c() {}
function $61de1ee1cac498ae$var$H4c() {}
function $61de1ee1cac498ae$var$J4c() {}
function $61de1ee1cac498ae$var$L4c() {}
function $61de1ee1cac498ae$var$N4c() {}
function $61de1ee1cac498ae$var$P4c() {}
function $61de1ee1cac498ae$var$R4c() {}
function $61de1ee1cac498ae$var$T4c() {}
function $61de1ee1cac498ae$var$V4c() {}
function $61de1ee1cac498ae$var$X4c() {}
function $61de1ee1cac498ae$var$Z4c() {}
function $61de1ee1cac498ae$var$_4c() {}
function $61de1ee1cac498ae$var$_7c() {}
function $61de1ee1cac498ae$var$b5c() {}
function $61de1ee1cac498ae$var$d5c() {}
function $61de1ee1cac498ae$var$f5c() {}
function $61de1ee1cac498ae$var$h5c() {}
function $61de1ee1cac498ae$var$H5c() {}
function $61de1ee1cac498ae$var$Hfd() {}
function $61de1ee1cac498ae$var$Zfd() {}
function $61de1ee1cac498ae$var$Zed() {}
function $61de1ee1cac498ae$var$ged() {}
function $61de1ee1cac498ae$var$Jed() {}
function $61de1ee1cac498ae$var$Ned() {}
function $61de1ee1cac498ae$var$Red() {}
function $61de1ee1cac498ae$var$Ved() {}
function $61de1ee1cac498ae$var$bbd() {}
function $61de1ee1cac498ae$var$mdd() {}
function $61de1ee1cac498ae$var$_fd() {}
function $61de1ee1cac498ae$var$fgd() {}
function $61de1ee1cac498ae$var$kgd() {}
function $61de1ee1cac498ae$var$Mgd() {}
function $61de1ee1cac498ae$var$Ahd() {}
function $61de1ee1cac498ae$var$Ald() {}
function $61de1ee1cac498ae$var$Tld() {}
function $61de1ee1cac498ae$var$xkd() {}
function $61de1ee1cac498ae$var$rmd() {}
function $61de1ee1cac498ae$var$knd() {}
function $61de1ee1cac498ae$var$Jod() {}
function $61de1ee1cac498ae$var$JCd() {}
function $61de1ee1cac498ae$var$Bpd() {}
function $61de1ee1cac498ae$var$BFd() {}
function $61de1ee1cac498ae$var$oFd() {}
function $61de1ee1cac498ae$var$bqd() {}
function $61de1ee1cac498ae$var$bvd() {}
function $61de1ee1cac498ae$var$jvd() {}
function $61de1ee1cac498ae$var$yud() {}
function $61de1ee1cac498ae$var$Hxd() {}
function $61de1ee1cac498ae$var$EBd() {}
function $61de1ee1cac498ae$var$aDd() {}
function $61de1ee1cac498ae$var$MGd() {}
function $61de1ee1cac498ae$var$vHd() {}
function $61de1ee1cac498ae$var$RHd() {}
function $61de1ee1cac498ae$var$wNd() {}
function $61de1ee1cac498ae$var$zNd() {}
function $61de1ee1cac498ae$var$CNd() {}
function $61de1ee1cac498ae$var$KNd() {}
function $61de1ee1cac498ae$var$XNd() {}
function $61de1ee1cac498ae$var$$Nd() {}
function $61de1ee1cac498ae$var$HPd() {}
function $61de1ee1cac498ae$var$lUd() {}
function $61de1ee1cac498ae$var$XUd() {}
function $61de1ee1cac498ae$var$DWd() {}
function $61de1ee1cac498ae$var$GWd() {}
function $61de1ee1cac498ae$var$JWd() {}
function $61de1ee1cac498ae$var$MWd() {}
function $61de1ee1cac498ae$var$PWd() {}
function $61de1ee1cac498ae$var$SWd() {}
function $61de1ee1cac498ae$var$VWd() {}
function $61de1ee1cac498ae$var$YWd() {}
function $61de1ee1cac498ae$var$_Wd() {}
function $61de1ee1cac498ae$var$xYd() {}
function $61de1ee1cac498ae$var$BYd() {}
function $61de1ee1cac498ae$var$mZd() {}
function $61de1ee1cac498ae$var$EZd() {}
function $61de1ee1cac498ae$var$GZd() {}
function $61de1ee1cac498ae$var$JZd() {}
function $61de1ee1cac498ae$var$MZd() {}
function $61de1ee1cac498ae$var$PZd() {}
function $61de1ee1cac498ae$var$SZd() {}
function $61de1ee1cac498ae$var$VZd() {}
function $61de1ee1cac498ae$var$YZd() {}
function $61de1ee1cac498ae$var$_Zd() {}
function $61de1ee1cac498ae$var$c$d() {}
function $61de1ee1cac498ae$var$f$d() {}
function $61de1ee1cac498ae$var$i$d() {}
function $61de1ee1cac498ae$var$l$d() {}
function $61de1ee1cac498ae$var$o$d() {}
function $61de1ee1cac498ae$var$r$d() {}
function $61de1ee1cac498ae$var$u$d() {}
function $61de1ee1cac498ae$var$x$d() {}
function $61de1ee1cac498ae$var$A$d() {}
function $61de1ee1cac498ae$var$D$d() {}
function $61de1ee1cac498ae$var$G$d() {}
function $61de1ee1cac498ae$var$J$d() {}
function $61de1ee1cac498ae$var$M$d() {}
function $61de1ee1cac498ae$var$P$d() {}
function $61de1ee1cac498ae$var$S$d() {}
function $61de1ee1cac498ae$var$V$d() {}
function $61de1ee1cac498ae$var$Y$d() {}
function $61de1ee1cac498ae$var$_$d() {}
function $61de1ee1cac498ae$var$c_d() {}
function $61de1ee1cac498ae$var$f_d() {}
function $61de1ee1cac498ae$var$i_d() {}
function $61de1ee1cac498ae$var$l_d() {}
function $61de1ee1cac498ae$var$o_d() {}
function $61de1ee1cac498ae$var$r_d() {}
function $61de1ee1cac498ae$var$u_d() {}
function $61de1ee1cac498ae$var$x_d() {}
function $61de1ee1cac498ae$var$A_d() {}
function $61de1ee1cac498ae$var$D_d() {}
function $61de1ee1cac498ae$var$G_d() {}
function $61de1ee1cac498ae$var$J_d() {}
function $61de1ee1cac498ae$var$M_d() {}
function $61de1ee1cac498ae$var$P_d() {}
function $61de1ee1cac498ae$var$S_d() {}
function $61de1ee1cac498ae$var$V_d() {}
function $61de1ee1cac498ae$var$Y_d() {}
function $61de1ee1cac498ae$var$h5d() {}
function $61de1ee1cac498ae$var$U6d() {}
function $61de1ee1cac498ae$var$U9d() {}
function $61de1ee1cac498ae$var$_8d() {}
function $61de1ee1cac498ae$var$fae() {}
function $61de1ee1cac498ae$var$hae() {}
function $61de1ee1cac498ae$var$kae() {}
function $61de1ee1cac498ae$var$nae() {}
function $61de1ee1cac498ae$var$qae() {}
function $61de1ee1cac498ae$var$tae() {}
function $61de1ee1cac498ae$var$wae() {}
function $61de1ee1cac498ae$var$zae() {}
function $61de1ee1cac498ae$var$Cae() {}
function $61de1ee1cac498ae$var$Fae() {}
function $61de1ee1cac498ae$var$Iae() {}
function $61de1ee1cac498ae$var$Lae() {}
function $61de1ee1cac498ae$var$Oae() {}
function $61de1ee1cac498ae$var$Rae() {}
function $61de1ee1cac498ae$var$Uae() {}
function $61de1ee1cac498ae$var$Xae() {}
function $61de1ee1cac498ae$var$$ae() {}
function $61de1ee1cac498ae$var$bbe() {}
function $61de1ee1cac498ae$var$ebe() {}
function $61de1ee1cac498ae$var$hbe() {}
function $61de1ee1cac498ae$var$kbe() {}
function $61de1ee1cac498ae$var$nbe() {}
function $61de1ee1cac498ae$var$qbe() {}
function $61de1ee1cac498ae$var$tbe() {}
function $61de1ee1cac498ae$var$wbe() {}
function $61de1ee1cac498ae$var$zbe() {}
function $61de1ee1cac498ae$var$Cbe() {}
function $61de1ee1cac498ae$var$Fbe() {}
function $61de1ee1cac498ae$var$Ibe() {}
function $61de1ee1cac498ae$var$Lbe() {}
function $61de1ee1cac498ae$var$Obe() {}
function $61de1ee1cac498ae$var$Rbe() {}
function $61de1ee1cac498ae$var$Ube() {}
function $61de1ee1cac498ae$var$Xbe() {}
function $61de1ee1cac498ae$var$$be() {}
function $61de1ee1cac498ae$var$bce() {}
function $61de1ee1cac498ae$var$ece() {}
function $61de1ee1cac498ae$var$hce() {}
function $61de1ee1cac498ae$var$kce() {}
function $61de1ee1cac498ae$var$nce() {}
function $61de1ee1cac498ae$var$qce() {}
function $61de1ee1cac498ae$var$tce() {}
function $61de1ee1cac498ae$var$wce() {}
function $61de1ee1cac498ae$var$zce() {}
function $61de1ee1cac498ae$var$Cce() {}
function $61de1ee1cac498ae$var$Fce() {}
function $61de1ee1cac498ae$var$Ice() {}
function $61de1ee1cac498ae$var$Lce() {}
function $61de1ee1cac498ae$var$Oce() {}
function $61de1ee1cac498ae$var$Rce() {}
function $61de1ee1cac498ae$var$Uce() {}
function $61de1ee1cac498ae$var$Xce() {}
function $61de1ee1cac498ae$var$ude() {}
function $61de1ee1cac498ae$var$Vge() {}
function $61de1ee1cac498ae$var$dhe() {}
function $61de1ee1cac498ae$var$s_b(a) {}
function $61de1ee1cac498ae$var$jSd(a) {}
function $61de1ee1cac498ae$var$ol() {
    $61de1ee1cac498ae$var$wb();
}
function $61de1ee1cac498ae$var$oPb() {
    $61de1ee1cac498ae$var$nPb();
}
function $61de1ee1cac498ae$var$EPb() {
    $61de1ee1cac498ae$var$CPb();
}
function $61de1ee1cac498ae$var$gFb() {
    $61de1ee1cac498ae$var$fFb();
}
function $61de1ee1cac498ae$var$TRb() {
    $61de1ee1cac498ae$var$SRb();
}
function $61de1ee1cac498ae$var$ySb() {
    $61de1ee1cac498ae$var$wSb();
}
function $61de1ee1cac498ae$var$PSb() {
    $61de1ee1cac498ae$var$OSb();
}
function $61de1ee1cac498ae$var$dTb() {
    $61de1ee1cac498ae$var$bTb();
}
function $61de1ee1cac498ae$var$i4b() {
    $61de1ee1cac498ae$var$b4b();
}
function $61de1ee1cac498ae$var$D2b() {
    $61de1ee1cac498ae$var$x2b();
}
function $61de1ee1cac498ae$var$J6b() {
    $61de1ee1cac498ae$var$D6b();
}
function $61de1ee1cac498ae$var$u9b() {
    $61de1ee1cac498ae$var$q9b();
}
function $61de1ee1cac498ae$var$$9b() {
    $61de1ee1cac498ae$var$I9b();
}
function $61de1ee1cac498ae$var$Umc() {
    $61de1ee1cac498ae$var$Imc();
}
function $61de1ee1cac498ae$var$abc() {
    $61de1ee1cac498ae$var$Vac();
}
function $61de1ee1cac498ae$var$ZCc() {
    $61de1ee1cac498ae$var$VCc();
}
function $61de1ee1cac498ae$var$kCc() {
    $61de1ee1cac498ae$var$hCc();
}
function $61de1ee1cac498ae$var$rCc() {
    $61de1ee1cac498ae$var$oCc();
}
function $61de1ee1cac498ae$var$Tcc() {
    $61de1ee1cac498ae$var$Occ();
}
function $61de1ee1cac498ae$var$xkc() {
    $61de1ee1cac498ae$var$gkc();
}
function $61de1ee1cac498ae$var$xDc() {
    $61de1ee1cac498ae$var$rDc();
}
function $61de1ee1cac498ae$var$iDc() {
    $61de1ee1cac498ae$var$cDc();
}
function $61de1ee1cac498ae$var$kwc() {
    $61de1ee1cac498ae$var$jwc();
}
function $61de1ee1cac498ae$var$tJc() {
    $61de1ee1cac498ae$var$jJc();
}
function $61de1ee1cac498ae$var$dJc() {
    $61de1ee1cac498ae$var$aJc();
}
function $61de1ee1cac498ae$var$Pyc() {
    $61de1ee1cac498ae$var$Nyc();
}
function $61de1ee1cac498ae$var$VBc() {
    $61de1ee1cac498ae$var$SBc();
}
function $61de1ee1cac498ae$var$CFc() {
    $61de1ee1cac498ae$var$yFc();
}
function $61de1ee1cac498ae$var$CUc() {
    $61de1ee1cac498ae$var$wUc();
}
function $61de1ee1cac498ae$var$lUc() {
    $61de1ee1cac498ae$var$fUc();
}
function $61de1ee1cac498ae$var$sUc() {
    $61de1ee1cac498ae$var$pUc();
}
function $61de1ee1cac498ae$var$IUc() {
    $61de1ee1cac498ae$var$GUc();
}
function $61de1ee1cac498ae$var$IWc() {
    $61de1ee1cac498ae$var$HWc();
}
function $61de1ee1cac498ae$var$_Wc() {
    $61de1ee1cac498ae$var$ZWc();
}
function $61de1ee1cac498ae$var$fHc() {
    $61de1ee1cac498ae$var$dHc();
}
function $61de1ee1cac498ae$var$f0c() {
    $61de1ee1cac498ae$var$d0c();
}
function $61de1ee1cac498ae$var$B0c() {
    $61de1ee1cac498ae$var$A0c();
}
function $61de1ee1cac498ae$var$L0c() {
    $61de1ee1cac498ae$var$J0c();
}
function $61de1ee1cac498ae$var$LTc() {
    $61de1ee1cac498ae$var$JTc();
}
function $61de1ee1cac498ae$var$sTc() {
    $61de1ee1cac498ae$var$rTc();
}
function $61de1ee1cac498ae$var$KLc() {
    $61de1ee1cac498ae$var$ILc();
}
function $61de1ee1cac498ae$var$wNc() {
    $61de1ee1cac498ae$var$tNc();
}
function $61de1ee1cac498ae$var$PYc() {
    $61de1ee1cac498ae$var$OYc();
}
function $61de1ee1cac498ae$var$nZc() {
    $61de1ee1cac498ae$var$lZc();
}
function $61de1ee1cac498ae$var$q3c() {
    $61de1ee1cac498ae$var$p3c();
}
function $61de1ee1cac498ae$var$Z7c() {
    $61de1ee1cac498ae$var$X7c();
}
function $61de1ee1cac498ae$var$Z9c() {
    $61de1ee1cac498ae$var$Y9c();
}
function $61de1ee1cac498ae$var$_ad() {
    $61de1ee1cac498ae$var$Zad();
}
function $61de1ee1cac498ae$var$kdd() {
    $61de1ee1cac498ae$var$idd();
}
function $61de1ee1cac498ae$var$$md() {
    $61de1ee1cac498ae$var$Smd();
}
function $61de1ee1cac498ae$var$HGd() {
    $61de1ee1cac498ae$var$tGd();
}
function $61de1ee1cac498ae$var$hLd() {
    $61de1ee1cac498ae$var$NKd();
}
function $61de1ee1cac498ae$var$J6d() {
    $61de1ee1cac498ae$var$Uge();
}
function $61de1ee1cac498ae$var$Mvb(a) {
    $61de1ee1cac498ae$var$uCb(a);
}
function $61de1ee1cac498ae$var$Yb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$cc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$cj(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ij(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Dj(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$df(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$kf(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ah(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$lh(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$th(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ph(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$vi(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ci(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Fk(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ln(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ap(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$zp(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Yp(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$qq(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Dq(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$wr(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ir(a) {
    this.b = a;
}
function $61de1ee1cac498ae$var$sj(a) {
    this.c = a;
}
function $61de1ee1cac498ae$var$sw(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$fw(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xw(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Cw(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Qw(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Rw(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Xw(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Xv(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Sv(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$eu(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Zx(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$_x(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xy(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xB(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$HB(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$TB(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$fC(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$wB() {
    this.a = [];
}
function $61de1ee1cac498ae$var$MBb(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$w_b(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$x_b(a, b) {
    a.b = b;
}
function $61de1ee1cac498ae$var$YOb(a, b) {
    a.b = b;
}
function $61de1ee1cac498ae$var$$Ob(a, b) {
    a.b = b;
}
function $61de1ee1cac498ae$var$ZGb(a, b) {
    a.j = b;
}
function $61de1ee1cac498ae$var$qNb(a, b) {
    a.g = b;
}
function $61de1ee1cac498ae$var$rNb(a, b) {
    a.i = b;
}
function $61de1ee1cac498ae$var$dRb(a, b) {
    a.c = b;
}
function $61de1ee1cac498ae$var$eRb(a, b) {
    a.d = b;
}
function $61de1ee1cac498ae$var$z_b(a, b) {
    a.d = b;
}
function $61de1ee1cac498ae$var$y_b(a, b) {
    a.c = b;
}
function $61de1ee1cac498ae$var$__b(a, b) {
    a.k = b;
}
function $61de1ee1cac498ae$var$E0b(a, b) {
    a.c = b;
}
function $61de1ee1cac498ae$var$njc(a, b) {
    a.c = b;
}
function $61de1ee1cac498ae$var$mjc(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$dFc(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$eFc(a, b) {
    a.f = b;
}
function $61de1ee1cac498ae$var$nOc(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$oOc(a, b) {
    a.b = b;
}
function $61de1ee1cac498ae$var$pOc(a, b) {
    a.d = b;
}
function $61de1ee1cac498ae$var$qOc(a, b) {
    a.i = b;
}
function $61de1ee1cac498ae$var$rOc(a, b) {
    a.o = b;
}
function $61de1ee1cac498ae$var$sOc(a, b) {
    a.r = b;
}
function $61de1ee1cac498ae$var$$Pc(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$_Pc(a, b) {
    a.b = b;
}
function $61de1ee1cac498ae$var$DVc(a, b) {
    a.e = b;
}
function $61de1ee1cac498ae$var$EVc(a, b) {
    a.f = b;
}
function $61de1ee1cac498ae$var$FVc(a, b) {
    a.g = b;
}
function $61de1ee1cac498ae$var$SZc(a, b) {
    a.e = b;
}
function $61de1ee1cac498ae$var$TZc(a, b) {
    a.f = b;
}
function $61de1ee1cac498ae$var$c$c(a, b) {
    a.f = b;
}
function $61de1ee1cac498ae$var$bJd(a, b) {
    a.n = b;
}
function $61de1ee1cac498ae$var$A1d(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$J1d(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$B1d(a, b) {
    a.c = b;
}
function $61de1ee1cac498ae$var$K1d(a, b) {
    a.c = b;
}
function $61de1ee1cac498ae$var$L1d(a, b) {
    a.d = b;
}
function $61de1ee1cac498ae$var$M1d(a, b) {
    a.e = b;
}
function $61de1ee1cac498ae$var$N1d(a, b) {
    a.g = b;
}
function $61de1ee1cac498ae$var$d2d(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$e2d(a, b) {
    a.c = b;
}
function $61de1ee1cac498ae$var$f2d(a, b) {
    a.d = b;
}
function $61de1ee1cac498ae$var$g2d(a, b) {
    a.e = b;
}
function $61de1ee1cac498ae$var$h2d(a, b) {
    a.f = b;
}
function $61de1ee1cac498ae$var$i2d(a, b) {
    a.j = b;
}
function $61de1ee1cac498ae$var$Z8d(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$$8d(a, b) {
    a.b = b;
}
function $61de1ee1cac498ae$var$g9d(a, b) {
    a.a = b;
}
function $61de1ee1cac498ae$var$Cic(a) {
    a.b = a.a;
}
function $61de1ee1cac498ae$var$Dg(a) {
    a.c = a.d.d;
}
function $61de1ee1cac498ae$var$vib(a) {
    this.d = a;
}
function $61de1ee1cac498ae$var$eib(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Pib(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Vib(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$$ib(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$mcb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Mcb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Xcb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ndb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$_db(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$teb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Qeb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$djb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Gjb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Njb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Bjb(a) {
    this.b = a;
}
function $61de1ee1cac498ae$var$lnb(a) {
    this.b = a;
}
function $61de1ee1cac498ae$var$Dnb(a) {
    this.b = a;
}
function $61de1ee1cac498ae$var$anb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Mob(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Rob(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$iob(a) {
    this.c = a;
}
function $61de1ee1cac498ae$var$olb(a) {
    this.c = a;
}
function $61de1ee1cac498ae$var$qub(a) {
    this.c = a;
}
function $61de1ee1cac498ae$var$Tub(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Vub(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Xub(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Zub(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$tpb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$_pb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Wqb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$nsb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Rxb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Txb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Xxb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$bzb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$tzb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$vzb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xzb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Kzb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ozb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$iAb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$kAb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$mAb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$BAb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$hBb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$jBb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$nBb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$TBb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$XBb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$QCb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$WCb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$_Cb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$dEb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$QGb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$YGb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$tKb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$CLb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$JMb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$RNb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$kQb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$mQb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$FQb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ETb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$UTb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$dUb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$hUb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$EZb(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$j$b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$v$b(a) {
    this.e = a;
}
function $61de1ee1cac498ae$var$J0b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$M0b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$R0b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$U0b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$i2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$k2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$o2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$s2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$G2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$I2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$K2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$M2b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$W3b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$$3b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$V4b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$u5b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$A7b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$G7b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$J7b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$M7b(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Mbc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Pbc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$lac(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$nac(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$qcc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Gdc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$$dc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$cec(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$_ec(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$pfc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Bfc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Lfc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ygc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Dgc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$shc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$uhc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$whc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Chc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ehc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ohc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Yhc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Tkc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Vkc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Olc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$pnc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$rnc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$dpc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$fpc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$GCc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$KCc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$mDc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$jEc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$HEc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$FEc(a) {
    this.c = a;
}
function $61de1ee1cac498ae$var$qoc(a) {
    this.b = a;
}
function $61de1ee1cac498ae$var$bFc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$GFc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$iGc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$kGc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$mGc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$$Gc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$hIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$lIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$pIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$tIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$zIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$CIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$LIc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$CKc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$IKc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$MKc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$$Kc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$cLc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$jLc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$rLc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xLc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$OMc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ZOc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ZRc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$aSc(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$I$c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$K$c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$M$c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$O$c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$U$c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$n1c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$z1c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$B1c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Q2c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$U2c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$z3c(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$med(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Xed(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$_ed(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Qfd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Bgd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$$gd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$lrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$urd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$vrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$wrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$yrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$zrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ard(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Brd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Crd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Ird(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Krd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Lrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Mrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Nrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Prd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Srd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Yrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Zrd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$_rd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$asd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$bsd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$csd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$dsd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$msd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$osd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$qsd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ssd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Wsd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$Lsd(a) {
    this.b = a;
}
function $61de1ee1cac498ae$var$thd(a) {
    this.f = a;
}
function $61de1ee1cac498ae$var$qtd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$yBd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$GBd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$MBd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$SBd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$iCd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$YMd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$GNd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$EPd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$EQd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$NTd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$qOd(a) {
    this.b = a;
}
function $61de1ee1cac498ae$var$lVd(a) {
    this.c = a;
}
function $61de1ee1cac498ae$var$VVd(a) {
    this.e = a;
}
function $61de1ee1cac498ae$var$iYd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$RYd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$ZYd(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$z0d(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$O0d(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$s0d(a) {
    this.d = a;
}
function $61de1ee1cac498ae$var$W5d(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$cge(a) {
    this.a = a;
}
function $61de1ee1cac498ae$var$xfe(a) {
    this.e = a;
}
function $61de1ee1cac498ae$var$Tfd() {
    this.a = 0;
}
function $61de1ee1cac498ae$var$jkb() {
    $61de1ee1cac498ae$var$Vjb(this);
}
function $61de1ee1cac498ae$var$Rkb() {
    $61de1ee1cac498ae$var$Ckb(this);
}
function $61de1ee1cac498ae$var$Lqb() {
    $61de1ee1cac498ae$var$Uhb(this);
}
function $61de1ee1cac498ae$var$lEb() {
    $61de1ee1cac498ae$var$kEb(this);
}
function $61de1ee1cac498ae$var$A_b() {
    $61de1ee1cac498ae$var$s_b(this);
}
function $61de1ee1cac498ae$var$UQd() {
    this.c = $61de1ee1cac498ae$var$FQd;
}
function $61de1ee1cac498ae$var$v6d(a, b) {
    b.Wb(a);
}
function $61de1ee1cac498ae$var$moc(a, b) {
    a.b += b;
}
function $61de1ee1cac498ae$var$yXb(a) {
    a.b = new $61de1ee1cac498ae$var$Ji;
}
function $61de1ee1cac498ae$var$vbb(a) {
    return a.e;
}
function $61de1ee1cac498ae$var$DB(a) {
    return a.a;
}
function $61de1ee1cac498ae$var$LB(a) {
    return a.a;
}
function $61de1ee1cac498ae$var$ZB(a) {
    return a.a;
}
function $61de1ee1cac498ae$var$lC(a) {
    return a.a;
}
function $61de1ee1cac498ae$var$EC(a) {
    return a.a;
}
function $61de1ee1cac498ae$var$wC() {
    return null;
}
function $61de1ee1cac498ae$var$SB() {
    return null;
}
function $61de1ee1cac498ae$var$hcb() {
    $61de1ee1cac498ae$var$mvd();
    $61de1ee1cac498ae$var$ovd();
}
function $61de1ee1cac498ae$var$zJb(a) {
    a.b.tf(a.e);
}
function $61de1ee1cac498ae$var$j5b(a, b) {
    a.b = b - a.b;
}
function $61de1ee1cac498ae$var$g5b(a, b) {
    a.a = b - a.a;
}
function $61de1ee1cac498ae$var$PXc(a, b) {
    b.ad(a.a);
}
function $61de1ee1cac498ae$var$plc(a, b) {
    $61de1ee1cac498ae$var$G0b(b, a);
}
function $61de1ee1cac498ae$var$hp(a, b, c) {
    a.Od(c, b);
}
function $61de1ee1cac498ae$var$As(a, b) {
    a.e = b;
    b.b = a;
}
function $61de1ee1cac498ae$var$Zl(a) {
    $61de1ee1cac498ae$var$Ql();
    this.a = a;
}
function $61de1ee1cac498ae$var$jq(a) {
    $61de1ee1cac498ae$var$Ql();
    this.a = a;
}
function $61de1ee1cac498ae$var$sq(a) {
    $61de1ee1cac498ae$var$Ql();
    this.a = a;
}
function $61de1ee1cac498ae$var$Fq(a) {
    $61de1ee1cac498ae$var$im();
    this.a = a;
}
function $61de1ee1cac498ae$var$Sz(a) {
    $61de1ee1cac498ae$var$Rz();
    $61de1ee1cac498ae$var$Qz.be(a);
}
function $61de1ee1cac498ae$var$gz() {
    $61de1ee1cac498ae$var$Xy.call(this);
}
function $61de1ee1cac498ae$var$xcb() {
    $61de1ee1cac498ae$var$Xy.call(this);
}
function $61de1ee1cac498ae$var$pcb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$tcb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$Bdb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$Vdb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$Ydb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$Geb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$bgb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$Apb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$Jpb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$utb() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$x2c() {
    $61de1ee1cac498ae$var$gz.call(this);
}
function $61de1ee1cac498ae$var$rQd() {
    this.a = this;
}
function $61de1ee1cac498ae$var$MPd() {
    this.Bb |= 256;
}
function $61de1ee1cac498ae$var$tTb() {
    this.b = new $61de1ee1cac498ae$var$mt;
}
function $61de1ee1cac498ae$var$fA() {
    $61de1ee1cac498ae$var$fA = $61de1ee1cac498ae$var$ccb;
    new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$rcb() {
    $61de1ee1cac498ae$var$pcb.call(this);
}
function $61de1ee1cac498ae$var$dCb(a, b) {
    a.length = b;
}
function $61de1ee1cac498ae$var$Tvb(a, b) {
    $61de1ee1cac498ae$var$Ekb(a.a, b);
}
function $61de1ee1cac498ae$var$sKb(a, b) {
    $61de1ee1cac498ae$var$UHb(a.c, b);
}
function $61de1ee1cac498ae$var$SMc(a, b) {
    $61de1ee1cac498ae$var$Qqb(a.b, b);
}
function $61de1ee1cac498ae$var$vBd(a, b) {
    $61de1ee1cac498ae$var$uAd(a.a, b);
}
function $61de1ee1cac498ae$var$wBd(a, b) {
    $61de1ee1cac498ae$var$vAd(a.a, b);
}
function $61de1ee1cac498ae$var$GLd(a, b) {
    $61de1ee1cac498ae$var$Uhd(a.e, b);
}
function $61de1ee1cac498ae$var$d7d(a) {
    $61de1ee1cac498ae$var$D2d(a.c, a.b);
}
function $61de1ee1cac498ae$var$mj(a, b) {
    a.kc().Nb(b);
}
function $61de1ee1cac498ae$var$Odb(a) {
    this.a = $61de1ee1cac498ae$var$Tdb(a);
}
function $61de1ee1cac498ae$var$Tqb() {
    this.a = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$gyb() {
    this.a = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$Wvb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$KFb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$PFb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$FFb() {
    this.a = new $61de1ee1cac498ae$var$yFb;
}
function $61de1ee1cac498ae$var$pGb() {
    this.a = new $61de1ee1cac498ae$var$MFb;
}
function $61de1ee1cac498ae$var$ZQb() {
    this.a = new $61de1ee1cac498ae$var$MQb;
}
function $61de1ee1cac498ae$var$Gxb() {
    this.a = new $61de1ee1cac498ae$var$Pwb;
}
function $61de1ee1cac498ae$var$jUb() {
    this.a = new $61de1ee1cac498ae$var$PTb;
}
function $61de1ee1cac498ae$var$sDb() {
    this.a = new $61de1ee1cac498ae$var$oDb;
}
function $61de1ee1cac498ae$var$zDb() {
    this.a = new $61de1ee1cac498ae$var$tDb;
}
function $61de1ee1cac498ae$var$CWb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$HXb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$nYb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$BYb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$fLb() {
    this.d = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$vYb() {
    this.a = new $61de1ee1cac498ae$var$Tqb;
}
function $61de1ee1cac498ae$var$a2b() {
    this.a = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$wZb() {
    this.b = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$TCc() {
    this.b = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$zJc() {
    this.e = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$uMc() {
    this.d = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$wdc() {
    this.a = new $61de1ee1cac498ae$var$xkc;
}
function $61de1ee1cac498ae$var$vKc() {
    $61de1ee1cac498ae$var$Rkb.call(this);
}
function $61de1ee1cac498ae$var$twb() {
    $61de1ee1cac498ae$var$Wvb.call(this);
}
function $61de1ee1cac498ae$var$oHb() {
    $61de1ee1cac498ae$var$$Gb.call(this);
}
function $61de1ee1cac498ae$var$LXb() {
    $61de1ee1cac498ae$var$HXb.call(this);
}
function $61de1ee1cac498ae$var$L_b() {
    $61de1ee1cac498ae$var$H_b.call(this);
}
function $61de1ee1cac498ae$var$H_b() {
    $61de1ee1cac498ae$var$A_b.call(this);
}
function $61de1ee1cac498ae$var$p0b() {
    $61de1ee1cac498ae$var$A_b.call(this);
}
function $61de1ee1cac498ae$var$s0b() {
    $61de1ee1cac498ae$var$p0b.call(this);
}
function $61de1ee1cac498ae$var$WMc() {
    $61de1ee1cac498ae$var$VMc.call(this);
}
function $61de1ee1cac498ae$var$bNc() {
    $61de1ee1cac498ae$var$VMc.call(this);
}
function $61de1ee1cac498ae$var$EPc() {
    $61de1ee1cac498ae$var$CPc.call(this);
}
function $61de1ee1cac498ae$var$JPc() {
    $61de1ee1cac498ae$var$CPc.call(this);
}
function $61de1ee1cac498ae$var$OPc() {
    $61de1ee1cac498ae$var$CPc.call(this);
}
function $61de1ee1cac498ae$var$w1c() {
    $61de1ee1cac498ae$var$s1c.call(this);
}
function $61de1ee1cac498ae$var$s7c() {
    $61de1ee1cac498ae$var$Psb.call(this);
}
function $61de1ee1cac498ae$var$apd() {
    $61de1ee1cac498ae$var$Ald.call(this);
}
function $61de1ee1cac498ae$var$ppd() {
    $61de1ee1cac498ae$var$Ald.call(this);
}
function $61de1ee1cac498ae$var$lDd() {
    $61de1ee1cac498ae$var$YCd.call(this);
}
function $61de1ee1cac498ae$var$NDd() {
    $61de1ee1cac498ae$var$YCd.call(this);
}
function $61de1ee1cac498ae$var$mFd() {
    $61de1ee1cac498ae$var$Lqb.call(this);
}
function $61de1ee1cac498ae$var$vFd() {
    $61de1ee1cac498ae$var$Lqb.call(this);
}
function $61de1ee1cac498ae$var$GFd() {
    $61de1ee1cac498ae$var$Lqb.call(this);
}
function $61de1ee1cac498ae$var$KPd() {
    $61de1ee1cac498ae$var$Tqb.call(this);
}
function $61de1ee1cac498ae$var$OJd() {
    $61de1ee1cac498ae$var$hJd.call(this);
}
function $61de1ee1cac498ae$var$aQd() {
    $61de1ee1cac498ae$var$MPd.call(this);
}
function $61de1ee1cac498ae$var$SSd() {
    $61de1ee1cac498ae$var$FId.call(this);
}
function $61de1ee1cac498ae$var$rUd() {
    $61de1ee1cac498ae$var$FId.call(this);
}
function $61de1ee1cac498ae$var$oUd() {
    $61de1ee1cac498ae$var$Lqb.call(this);
}
function $61de1ee1cac498ae$var$NYd() {
    $61de1ee1cac498ae$var$Lqb.call(this);
}
function $61de1ee1cac498ae$var$cZd() {
    $61de1ee1cac498ae$var$Lqb.call(this);
}
function $61de1ee1cac498ae$var$R8d() {
    $61de1ee1cac498ae$var$MGd.call(this);
}
function $61de1ee1cac498ae$var$o9d() {
    $61de1ee1cac498ae$var$MGd.call(this);
}
function $61de1ee1cac498ae$var$i9d() {
    $61de1ee1cac498ae$var$R8d.call(this);
}
function $61de1ee1cac498ae$var$hee() {
    $61de1ee1cac498ae$var$ude.call(this);
}
function $61de1ee1cac498ae$var$Dd(a) {
    $61de1ee1cac498ae$var$yd.call(this, a);
}
function $61de1ee1cac498ae$var$Hd(a) {
    $61de1ee1cac498ae$var$yd.call(this, a);
}
function $61de1ee1cac498ae$var$ph(a) {
    $61de1ee1cac498ae$var$lh.call(this, a);
}
function $61de1ee1cac498ae$var$Sh(a) {
    $61de1ee1cac498ae$var$Wc.call(this, a);
}
function $61de1ee1cac498ae$var$oi(a) {
    $61de1ee1cac498ae$var$Sh.call(this, a);
}
function $61de1ee1cac498ae$var$Ii(a) {
    $61de1ee1cac498ae$var$Wc.call(this, a);
}
function $61de1ee1cac498ae$var$Zdd() {
    this.a = new $61de1ee1cac498ae$var$Psb;
}
function $61de1ee1cac498ae$var$CPc() {
    this.a = new $61de1ee1cac498ae$var$Tqb;
}
function $61de1ee1cac498ae$var$s1c() {
    this.a = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$QSc() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$D2c() {
    this.j = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$QXc() {
    this.a = new $61de1ee1cac498ae$var$UXc;
}
function $61de1ee1cac498ae$var$e_c() {
    this.a = new $61de1ee1cac498ae$var$d_c;
}
function $61de1ee1cac498ae$var$YCd() {
    this.a = new $61de1ee1cac498ae$var$aDd;
}
function $61de1ee1cac498ae$var$_k() {
    $61de1ee1cac498ae$var$_k = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$$k = new $61de1ee1cac498ae$var$al;
}
function $61de1ee1cac498ae$var$Lk() {
    $61de1ee1cac498ae$var$Lk = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Kk = new $61de1ee1cac498ae$var$Mk;
}
function $61de1ee1cac498ae$var$wb() {
    $61de1ee1cac498ae$var$wb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vb = new $61de1ee1cac498ae$var$xb;
}
function $61de1ee1cac498ae$var$hs() {
    $61de1ee1cac498ae$var$hs = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$gs = new $61de1ee1cac498ae$var$is;
}
function $61de1ee1cac498ae$var$rs(a) {
    $61de1ee1cac498ae$var$Sh.call(this, a);
}
function $61de1ee1cac498ae$var$Gp(a) {
    $61de1ee1cac498ae$var$Sh.call(this, a);
}
function $61de1ee1cac498ae$var$xp(a) {
    $61de1ee1cac498ae$var$Lo.call(this, a);
}
function $61de1ee1cac498ae$var$Ep(a) {
    $61de1ee1cac498ae$var$Lo.call(this, a);
}
function $61de1ee1cac498ae$var$Tp(a) {
    $61de1ee1cac498ae$var$Wn.call(this, a);
}
function $61de1ee1cac498ae$var$wx(a) {
    $61de1ee1cac498ae$var$un.call(this, a);
}
function $61de1ee1cac498ae$var$ov(a) {
    $61de1ee1cac498ae$var$dv.call(this, a);
}
function $61de1ee1cac498ae$var$Mv(a) {
    $61de1ee1cac498ae$var$Br.call(this, a);
}
function $61de1ee1cac498ae$var$Ov(a) {
    $61de1ee1cac498ae$var$Br.call(this, a);
}
function $61de1ee1cac498ae$var$Lw(a) {
    $61de1ee1cac498ae$var$Br.call(this, a);
}
function $61de1ee1cac498ae$var$hz(a) {
    $61de1ee1cac498ae$var$Yy.call(this, a);
}
function $61de1ee1cac498ae$var$MB(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$eC() {
    $61de1ee1cac498ae$var$fC.call(this, {});
}
function $61de1ee1cac498ae$var$Ftb(a) {
    $61de1ee1cac498ae$var$Atb();
    this.a = a;
}
function $61de1ee1cac498ae$var$zwb(a) {
    a.b = null;
    a.c = 0;
}
function $61de1ee1cac498ae$var$Vy(a, b) {
    a.e = b;
    $61de1ee1cac498ae$var$Sy(a, b);
}
function $61de1ee1cac498ae$var$LVb(a, b) {
    a.a = b;
    $61de1ee1cac498ae$var$NVb(a);
}
function $61de1ee1cac498ae$var$lIb(a, b, c) {
    a.a[b.g] = c;
}
function $61de1ee1cac498ae$var$vfd(a, b, c) {
    $61de1ee1cac498ae$var$Dfd(c, a, b);
}
function $61de1ee1cac498ae$var$Odc(a, b) {
    $61de1ee1cac498ae$var$rjc(b.i, a.n);
}
function $61de1ee1cac498ae$var$Wyc(a, b) {
    $61de1ee1cac498ae$var$Xyc(a).td(b);
}
function $61de1ee1cac498ae$var$ERb(a, b) {
    return a * a / b;
}
function $61de1ee1cac498ae$var$Xr(a, b) {
    return a.g - b.g;
}
function $61de1ee1cac498ae$var$tC(a) {
    return new $61de1ee1cac498ae$var$TB(a);
}
function $61de1ee1cac498ae$var$vC(a) {
    return new $61de1ee1cac498ae$var$yC(a);
}
function $61de1ee1cac498ae$var$ocb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$qcb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$ucb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$vcb(a) {
    $61de1ee1cac498ae$var$Yy.call(this, a);
}
function $61de1ee1cac498ae$var$fGc(a) {
    $61de1ee1cac498ae$var$LFc();
    this.a = a;
}
function $61de1ee1cac498ae$var$c0d(a) {
    $61de1ee1cac498ae$var$kzd();
    this.a = a;
}
function $61de1ee1cac498ae$var$bhd(a) {
    $61de1ee1cac498ae$var$Rgd();
    this.f = a;
}
function $61de1ee1cac498ae$var$dhd(a) {
    $61de1ee1cac498ae$var$Rgd();
    this.f = a;
}
function $61de1ee1cac498ae$var$Cdb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$Wdb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$Zdb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$Feb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$Heb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$Ccb(a) {
    return $61de1ee1cac498ae$var$uCb(a), a;
}
function $61de1ee1cac498ae$var$Edb(a) {
    return $61de1ee1cac498ae$var$uCb(a), a;
}
function $61de1ee1cac498ae$var$Gdb(a) {
    return $61de1ee1cac498ae$var$uCb(a), a;
}
function $61de1ee1cac498ae$var$jfb(a) {
    return $61de1ee1cac498ae$var$uCb(a), a;
}
function $61de1ee1cac498ae$var$tfb(a) {
    return $61de1ee1cac498ae$var$uCb(a), a;
}
function $61de1ee1cac498ae$var$akb(a) {
    return a.b == a.c;
}
function $61de1ee1cac498ae$var$Hwb(a) {
    return !!a && a.b;
}
function $61de1ee1cac498ae$var$pIb(a) {
    return !!a && a.k;
}
function $61de1ee1cac498ae$var$qIb(a) {
    return !!a && a.j;
}
function $61de1ee1cac498ae$var$amb(a) {
    $61de1ee1cac498ae$var$uCb(a);
    this.a = a;
}
function $61de1ee1cac498ae$var$wVb(a) {
    $61de1ee1cac498ae$var$qVb(a);
    return a;
}
function $61de1ee1cac498ae$var$Blb(a) {
    $61de1ee1cac498ae$var$Glb(a, a.length);
}
function $61de1ee1cac498ae$var$cgb(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$cqd(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$n8d(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$y2c(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$z2c(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$mde(a) {
    $61de1ee1cac498ae$var$hz.call(this, a);
}
function $61de1ee1cac498ae$var$pc(a) {
    $61de1ee1cac498ae$var$qc.call(this, a, 0);
}
function $61de1ee1cac498ae$var$Ji() {
    $61de1ee1cac498ae$var$Ki.call(this, 12, 3);
}
function $61de1ee1cac498ae$var$Kz() {
    $61de1ee1cac498ae$var$Kz = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Jz = new $61de1ee1cac498ae$var$Nz;
}
function $61de1ee1cac498ae$var$jz() {
    $61de1ee1cac498ae$var$jz = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$iz = new $61de1ee1cac498ae$var$nb;
}
function $61de1ee1cac498ae$var$KA() {
    $61de1ee1cac498ae$var$KA = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$JA = new $61de1ee1cac498ae$var$MA;
}
function $61de1ee1cac498ae$var$OB() {
    $61de1ee1cac498ae$var$OB = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$NB = new $61de1ee1cac498ae$var$PB;
}
function $61de1ee1cac498ae$var$jc() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$zh() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$Pi() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$Pj() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$Qj() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$Ym() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$Gb() {
    this.a = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Qb($61de1ee1cac498ae$var$She));
}
function $61de1ee1cac498ae$var$oy(a) {
    $61de1ee1cac498ae$var$Ql();
    this.a = $61de1ee1cac498ae$var$Qb(a);
}
function $61de1ee1cac498ae$var$Bs(a, b) {
    a.Td(b);
    b.Sd(a);
}
function $61de1ee1cac498ae$var$iw(a, b) {
    a.a.ec().Mc(b);
}
function $61de1ee1cac498ae$var$CYb(a, b, c) {
    a.c.lf(b, c);
}
function $61de1ee1cac498ae$var$scb(a) {
    $61de1ee1cac498ae$var$qcb.call(this, a);
}
function $61de1ee1cac498ae$var$Oeb(a) {
    $61de1ee1cac498ae$var$Wdb.call(this, a);
}
function $61de1ee1cac498ae$var$Hfb() {
    $61de1ee1cac498ae$var$mcb.call(this, "");
}
function $61de1ee1cac498ae$var$Ifb() {
    $61de1ee1cac498ae$var$mcb.call(this, "");
}
function $61de1ee1cac498ae$var$Ufb() {
    $61de1ee1cac498ae$var$mcb.call(this, "");
}
function $61de1ee1cac498ae$var$Vfb() {
    $61de1ee1cac498ae$var$mcb.call(this, "");
}
function $61de1ee1cac498ae$var$Xfb(a) {
    $61de1ee1cac498ae$var$qcb.call(this, a);
}
function $61de1ee1cac498ae$var$zob(a) {
    $61de1ee1cac498ae$var$lnb.call(this, a);
}
function $61de1ee1cac498ae$var$Yob(a) {
    $61de1ee1cac498ae$var$Inb.call(this, a);
}
function $61de1ee1cac498ae$var$Gob(a) {
    $61de1ee1cac498ae$var$zob.call(this, a);
}
function $61de1ee1cac498ae$var$Mk() {
    $61de1ee1cac498ae$var$Fk.call(this, null);
}
function $61de1ee1cac498ae$var$al() {
    $61de1ee1cac498ae$var$Fk.call(this, null);
}
function $61de1ee1cac498ae$var$Az() {
    $61de1ee1cac498ae$var$Az = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Rz(), $61de1ee1cac498ae$var$Qz;
}
function $61de1ee1cac498ae$var$wrb() {
    $61de1ee1cac498ae$var$wrb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vrb = $61de1ee1cac498ae$var$yrb();
}
function $61de1ee1cac498ae$var$Mtb(a) {
    return a.a ? a.b : 0;
}
function $61de1ee1cac498ae$var$Vtb(a) {
    return a.a ? a.b : 0;
}
function $61de1ee1cac498ae$var$Lcb(a, b) {
    return a.a - b.a;
}
function $61de1ee1cac498ae$var$Wcb(a, b) {
    return a.a - b.a;
}
function $61de1ee1cac498ae$var$Peb(a, b) {
    return a.a - b.a;
}
function $61de1ee1cac498ae$var$eCb(a, b) {
    return $61de1ee1cac498ae$var$PC(a, b);
}
function $61de1ee1cac498ae$var$GC(a, b) {
    return $61de1ee1cac498ae$var$rdb(a, b);
}
function $61de1ee1cac498ae$var$_B(b, a) {
    return a in b.a;
}
function $61de1ee1cac498ae$var$_Db(a, b) {
    a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$ZDb(a, b) {
    a.b = b;
    return a;
}
function $61de1ee1cac498ae$var$$Db(a, b) {
    a.c = b;
    return a;
}
function $61de1ee1cac498ae$var$aEb(a, b) {
    a.g = b;
    return a;
}
function $61de1ee1cac498ae$var$HGb(a, b) {
    a.a = b;
    return a;
}
function $61de1ee1cac498ae$var$IGb(a, b) {
    a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$JGb(a, b) {
    a.k = b;
    return a;
}
function $61de1ee1cac498ae$var$dLb(a, b) {
    a.a = b;
    return a;
}
function $61de1ee1cac498ae$var$eLb(a, b) {
    a.e = b;
    return a;
}
function $61de1ee1cac498ae$var$zVb(a, b) {
    a.e = b;
    return a;
}
function $61de1ee1cac498ae$var$AVb(a, b) {
    a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$KOb(a, b) {
    a.b = true;
    a.d = b;
}
function $61de1ee1cac498ae$var$DHb(a, b) {
    a.b = new $61de1ee1cac498ae$var$g7c(b);
}
function $61de1ee1cac498ae$var$uvb(a, b, c) {
    b.td(a.a[c]);
}
function $61de1ee1cac498ae$var$zvb(a, b, c) {
    b.we(a.a[c]);
}
function $61de1ee1cac498ae$var$wJc(a, b) {
    return a.b - b.b;
}
function $61de1ee1cac498ae$var$kOc(a, b) {
    return a.g - b.g;
}
function $61de1ee1cac498ae$var$WQc(a, b) {
    return a.s - b.s;
}
function $61de1ee1cac498ae$var$Lic(a, b) {
    return a ? 0 : b - 1;
}
function $61de1ee1cac498ae$var$SFc(a, b) {
    return a ? 0 : b - 1;
}
function $61de1ee1cac498ae$var$RFc(a, b) {
    return a ? b - 1 : 0;
}
function $61de1ee1cac498ae$var$M2c(a, b) {
    return b.Yf(a);
}
function $61de1ee1cac498ae$var$M3c(a, b) {
    a.b = b;
    return a;
}
function $61de1ee1cac498ae$var$L3c(a, b) {
    a.a = b;
    return a;
}
function $61de1ee1cac498ae$var$N3c(a, b) {
    a.c = b;
    return a;
}
function $61de1ee1cac498ae$var$O3c(a, b) {
    a.d = b;
    return a;
}
function $61de1ee1cac498ae$var$P3c(a, b) {
    a.e = b;
    return a;
}
function $61de1ee1cac498ae$var$Q3c(a, b) {
    a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$b4c(a, b) {
    a.a = b;
    return a;
}
function $61de1ee1cac498ae$var$c4c(a, b) {
    a.b = b;
    return a;
}
function $61de1ee1cac498ae$var$d4c(a, b) {
    a.c = b;
    return a;
}
function $61de1ee1cac498ae$var$z5c(a, b) {
    a.c = b;
    return a;
}
function $61de1ee1cac498ae$var$y5c(a, b) {
    a.b = b;
    return a;
}
function $61de1ee1cac498ae$var$A5c(a, b) {
    a.d = b;
    return a;
}
function $61de1ee1cac498ae$var$B5c(a, b) {
    a.e = b;
    return a;
}
function $61de1ee1cac498ae$var$C5c(a, b) {
    a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$D5c(a, b) {
    a.g = b;
    return a;
}
function $61de1ee1cac498ae$var$E5c(a, b) {
    a.a = b;
    return a;
}
function $61de1ee1cac498ae$var$F5c(a, b) {
    a.i = b;
    return a;
}
function $61de1ee1cac498ae$var$G5c(a, b) {
    a.j = b;
    return a;
}
function $61de1ee1cac498ae$var$Vdd(a, b) {
    a.k = b;
    return a;
}
function $61de1ee1cac498ae$var$Wdd(a, b) {
    a.j = b;
    return a;
}
function $61de1ee1cac498ae$var$ykc(a, b) {
    $61de1ee1cac498ae$var$gkc();
    $61de1ee1cac498ae$var$F0b(b, a);
}
function $61de1ee1cac498ae$var$T$c(a, b, c) {
    $61de1ee1cac498ae$var$R$c(a.a, b, c);
}
function $61de1ee1cac498ae$var$RGc(a) {
    $61de1ee1cac498ae$var$cEc.call(this, a);
}
function $61de1ee1cac498ae$var$iHc(a) {
    $61de1ee1cac498ae$var$cEc.call(this, a);
}
function $61de1ee1cac498ae$var$t7c(a) {
    $61de1ee1cac498ae$var$Qsb.call(this, a);
}
function $61de1ee1cac498ae$var$aPb(a) {
    $61de1ee1cac498ae$var$_Ob.call(this, a);
}
function $61de1ee1cac498ae$var$Ixd(a) {
    $61de1ee1cac498ae$var$zud.call(this, a);
}
function $61de1ee1cac498ae$var$dCd(a) {
    $61de1ee1cac498ae$var$ZBd.call(this, a);
}
function $61de1ee1cac498ae$var$fCd(a) {
    $61de1ee1cac498ae$var$ZBd.call(this, a);
}
function $61de1ee1cac498ae$var$p_b() {
    $61de1ee1cac498ae$var$q_b.call(this, "");
}
function $61de1ee1cac498ae$var$d7c() {
    this.a = 0;
    this.b = 0;
}
function $61de1ee1cac498ae$var$aPc() {
    this.b = 0;
    this.a = 0;
}
function $61de1ee1cac498ae$var$NJd(a, b) {
    a.b = 0;
    $61de1ee1cac498ae$var$DId(a, b);
}
function $61de1ee1cac498ae$var$X1d(a, b) {
    a.c = b;
    a.b = true;
}
function $61de1ee1cac498ae$var$Oc(a, b) {
    return a.c._b(b);
}
function $61de1ee1cac498ae$var$gdb(a) {
    return a.e && a.e();
}
function $61de1ee1cac498ae$var$Vd(a) {
    return !a ? null : a.d;
}
function $61de1ee1cac498ae$var$sn(a, b) {
    return $61de1ee1cac498ae$var$Gv(a.b, b);
}
function $61de1ee1cac498ae$var$Fv(a) {
    return !a ? null : a.g;
}
function $61de1ee1cac498ae$var$Kv(a) {
    return !a ? null : a.i;
}
function $61de1ee1cac498ae$var$hdb(a) {
    $61de1ee1cac498ae$var$fdb(a);
    return a.o;
}
function $61de1ee1cac498ae$var$Fhd() {
    $61de1ee1cac498ae$var$Fhd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ehd = $61de1ee1cac498ae$var$ond();
}
function $61de1ee1cac498ae$var$Hhd() {
    $61de1ee1cac498ae$var$Hhd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ghd = $61de1ee1cac498ae$var$Cod();
}
function $61de1ee1cac498ae$var$LFd() {
    $61de1ee1cac498ae$var$LFd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$KFd = $61de1ee1cac498ae$var$qZd();
}
function $61de1ee1cac498ae$var$p8d() {
    $61de1ee1cac498ae$var$p8d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$o8d = $61de1ee1cac498ae$var$Y9d();
}
function $61de1ee1cac498ae$var$r8d() {
    $61de1ee1cac498ae$var$r8d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$q8d = $61de1ee1cac498ae$var$dae();
}
function $61de1ee1cac498ae$var$mvd() {
    $61de1ee1cac498ae$var$mvd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$lvd = $61de1ee1cac498ae$var$n4c();
}
function $61de1ee1cac498ae$var$Srb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$enb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$fnb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$gnb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$jnb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$Cnb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$Uqb(a) {
    this.a = new $61de1ee1cac498ae$var$Mqb(a);
}
function $61de1ee1cac498ae$var$tgb(a) {
    $61de1ee1cac498ae$var$lgb();
    $61de1ee1cac498ae$var$ngb(this, a);
}
function $61de1ee1cac498ae$var$Hxb(a) {
    this.a = new $61de1ee1cac498ae$var$Qwb(a);
}
function $61de1ee1cac498ae$var$_ub(a, b) {
    while(a.ye(b));
}
function $61de1ee1cac498ae$var$Sub(a, b) {
    while(a.sd(b));
}
function $61de1ee1cac498ae$var$Bfb(a, b) {
    a.a += b;
    return a;
}
function $61de1ee1cac498ae$var$Cfb(a, b) {
    a.a += b;
    return a;
}
function $61de1ee1cac498ae$var$Ffb(a, b) {
    a.a += b;
    return a;
}
function $61de1ee1cac498ae$var$Lfb(a, b) {
    a.a += b;
    return a;
}
function $61de1ee1cac498ae$var$WAb(a) {
    $61de1ee1cac498ae$var$Tzb(a);
    return a.a;
}
function $61de1ee1cac498ae$var$Wsb(a) {
    return a.b != a.d.c;
}
function $61de1ee1cac498ae$var$pD(a) {
    return a.l | a.m << 22;
}
function $61de1ee1cac498ae$var$aIc(a, b) {
    return a.d[b.p];
}
function $61de1ee1cac498ae$var$h2c(a, b) {
    return $61de1ee1cac498ae$var$c2c(a, b);
}
function $61de1ee1cac498ae$var$cCb(a, b, c) {
    a.splice(b, c);
}
function $61de1ee1cac498ae$var$WHb(a) {
    a.c ? $61de1ee1cac498ae$var$VHb(a) : $61de1ee1cac498ae$var$XHb(a);
}
function $61de1ee1cac498ae$var$jVc(a) {
    this.a = 0;
    this.b = a;
}
function $61de1ee1cac498ae$var$ZUc() {
    this.a = new $61de1ee1cac498ae$var$L2c($61de1ee1cac498ae$var$K$);
}
function $61de1ee1cac498ae$var$tRc() {
    this.b = new $61de1ee1cac498ae$var$L2c($61de1ee1cac498ae$var$h$);
}
function $61de1ee1cac498ae$var$Q$c() {
    this.b = new $61de1ee1cac498ae$var$L2c($61de1ee1cac498ae$var$J_);
}
function $61de1ee1cac498ae$var$d_c() {
    this.b = new $61de1ee1cac498ae$var$L2c($61de1ee1cac498ae$var$J_);
}
function $61de1ee1cac498ae$var$OCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$PCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$QCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$RCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$SCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$TCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$UCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$VCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$WCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$XCd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
}
function $61de1ee1cac498ae$var$ahe() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
}
function $61de1ee1cac498ae$var$bhe() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
}
function $61de1ee1cac498ae$var$Rge(a) {
    this.a = new $61de1ee1cac498ae$var$ege(a);
}
function $61de1ee1cac498ae$var$ege(a) {
    $61de1ee1cac498ae$var$dge(this, a, $61de1ee1cac498ae$var$Vee());
}
function $61de1ee1cac498ae$var$Fhe(a) {
    return !a || $61de1ee1cac498ae$var$Ehe(a);
}
function $61de1ee1cac498ae$var$dde(a) {
    return $61de1ee1cac498ae$var$$ce[a] != -1;
}
function $61de1ee1cac498ae$var$Iz() {
    $61de1ee1cac498ae$var$xz != 0 && ($61de1ee1cac498ae$var$xz = 0);
    $61de1ee1cac498ae$var$zz = -1;
}
function $61de1ee1cac498ae$var$Ybb() {
    $61de1ee1cac498ae$var$Wbb == null && ($61de1ee1cac498ae$var$Wbb = []);
}
function $61de1ee1cac498ae$var$ONd(a, b) {
    $61de1ee1cac498ae$var$Rxd($61de1ee1cac498ae$var$ZKd(a.a), b);
}
function $61de1ee1cac498ae$var$TNd(a, b) {
    $61de1ee1cac498ae$var$Rxd($61de1ee1cac498ae$var$ZKd(a.a), b);
}
function $61de1ee1cac498ae$var$Yf(a, b) {
    $61de1ee1cac498ae$var$zf.call(this, a, b);
}
function $61de1ee1cac498ae$var$$f(a, b) {
    $61de1ee1cac498ae$var$Yf.call(this, a, b);
}
function $61de1ee1cac498ae$var$Hf(a, b) {
    this.b = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$rk(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$ek(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$gk(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$pk(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$yk(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Ak(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Fj(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$_j(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$dr(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$zr(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$So(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$qp(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$$q(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$$r(a, b) {
    this.f = a;
    this.g = b;
}
function $61de1ee1cac498ae$var$ne(a, b) {
    this.e = a;
    this.d = b;
}
function $61de1ee1cac498ae$var$Wo(a, b) {
    this.g = a;
    this.i = b;
}
function $61de1ee1cac498ae$var$bu(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$qu(a, b) {
    this.a = a;
    this.f = b;
}
function $61de1ee1cac498ae$var$qv(a, b) {
    this.b = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$ox(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Px(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$mC(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Wc(a) {
    $61de1ee1cac498ae$var$Lb(a.dc());
    this.c = a;
}
function $61de1ee1cac498ae$var$rf(a) {
    this.b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 83);
}
function $61de1ee1cac498ae$var$Zv(a) {
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 83);
}
function $61de1ee1cac498ae$var$dv(a) {
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 15);
}
function $61de1ee1cac498ae$var$$u(a) {
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 15);
}
function $61de1ee1cac498ae$var$Br(a) {
    this.b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 47);
}
function $61de1ee1cac498ae$var$eB() {
    this.q = new $61de1ee1cac498ae$var$$wnd.Date;
}
function $61de1ee1cac498ae$var$Zfb() {
    $61de1ee1cac498ae$var$Zfb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Yfb = new $61de1ee1cac498ae$var$jcb;
}
function $61de1ee1cac498ae$var$Emb() {
    $61de1ee1cac498ae$var$Emb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Dmb = new $61de1ee1cac498ae$var$Fmb;
}
function $61de1ee1cac498ae$var$Vhb(a) {
    return a.f.c + a.g.c;
}
function $61de1ee1cac498ae$var$hnb(a, b) {
    return a.b.Hc(b);
}
function $61de1ee1cac498ae$var$inb(a, b) {
    return a.b.Ic(b);
}
function $61de1ee1cac498ae$var$knb(a, b) {
    return a.b.Qc(b);
}
function $61de1ee1cac498ae$var$Dob(a, b) {
    return a.b.Hc(b);
}
function $61de1ee1cac498ae$var$dob(a, b) {
    return a.c.uc(b);
}
function $61de1ee1cac498ae$var$Rqb(a, b) {
    return a.a._b(b);
}
function $61de1ee1cac498ae$var$fob(a, b) {
    return $61de1ee1cac498ae$var$pb(a.c, b);
}
function $61de1ee1cac498ae$var$jt(a, b) {
    return $61de1ee1cac498ae$var$Mhb(a.b, b);
}
function $61de1ee1cac498ae$var$Lp(a, b) {
    return a > b && b < $61de1ee1cac498ae$var$Iie;
}
function $61de1ee1cac498ae$var$Ryb(a, b) {
    return a.Gc(b), a;
}
function $61de1ee1cac498ae$var$Syb(a, b) {
    return $61de1ee1cac498ae$var$ye(a, b), a;
}
function $61de1ee1cac498ae$var$sC(a) {
    return $61de1ee1cac498ae$var$GB(), a ? $61de1ee1cac498ae$var$FB : $61de1ee1cac498ae$var$EB;
}
function $61de1ee1cac498ae$var$Mqb(a) {
    $61de1ee1cac498ae$var$Whb.call(this, a, 0);
}
function $61de1ee1cac498ae$var$Pwb() {
    $61de1ee1cac498ae$var$Qwb.call(this, null);
}
function $61de1ee1cac498ae$var$yAb() {
    $61de1ee1cac498ae$var$Vzb.call(this, null);
}
function $61de1ee1cac498ae$var$Gqb(a) {
    this.c = a;
    $61de1ee1cac498ae$var$Dqb(this);
}
function $61de1ee1cac498ae$var$Psb() {
    $61de1ee1cac498ae$var$Csb(this);
    $61de1ee1cac498ae$var$Osb(this);
}
function $61de1ee1cac498ae$var$MAb(a, b) {
    $61de1ee1cac498ae$var$Tzb(a);
    a.a.Nb(b);
}
function $61de1ee1cac498ae$var$Myb(a, b) {
    a.Gc(b);
    return a;
}
function $61de1ee1cac498ae$var$qDb(a, b) {
    a.a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$wDb(a, b) {
    a.a.d = b;
    return a;
}
function $61de1ee1cac498ae$var$xDb(a, b) {
    a.a.g = b;
    return a;
}
function $61de1ee1cac498ae$var$yDb(a, b) {
    a.a.j = b;
    return a;
}
function $61de1ee1cac498ae$var$BFb(a, b) {
    a.a.a = b;
    return a;
}
function $61de1ee1cac498ae$var$CFb(a, b) {
    a.a.d = b;
    return a;
}
function $61de1ee1cac498ae$var$DFb(a, b) {
    a.a.e = b;
    return a;
}
function $61de1ee1cac498ae$var$EFb(a, b) {
    a.a.g = b;
    return a;
}
function $61de1ee1cac498ae$var$oGb(a, b) {
    a.a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$TGb(a) {
    a.b = false;
    return a;
}
function $61de1ee1cac498ae$var$Ltb() {
    $61de1ee1cac498ae$var$Ltb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ktb = new $61de1ee1cac498ae$var$Otb;
}
function $61de1ee1cac498ae$var$Utb() {
    $61de1ee1cac498ae$var$Utb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ttb = new $61de1ee1cac498ae$var$Wtb;
}
function $61de1ee1cac498ae$var$$xb() {
    $61de1ee1cac498ae$var$$xb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Zxb = new $61de1ee1cac498ae$var$byb;
}
function $61de1ee1cac498ae$var$$Yb() {
    $61de1ee1cac498ae$var$$Yb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ZYb = new $61de1ee1cac498ae$var$dZb;
}
function $61de1ee1cac498ae$var$cPb() {
    $61de1ee1cac498ae$var$cPb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$bPb = new $61de1ee1cac498ae$var$dPb;
}
function $61de1ee1cac498ae$var$EAb() {
    $61de1ee1cac498ae$var$EAb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$DAb = new $61de1ee1cac498ae$var$PBb;
}
function $61de1ee1cac498ae$var$a$b() {
    $61de1ee1cac498ae$var$a$b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$_Zb = new $61de1ee1cac498ae$var$P$b;
}
function $61de1ee1cac498ae$var$FDb() {
    $61de1ee1cac498ae$var$FDb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$EDb = new $61de1ee1cac498ae$var$GDb;
}
function $61de1ee1cac498ae$var$xUb() {
    $61de1ee1cac498ae$var$xUb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$wUb = new $61de1ee1cac498ae$var$DUb;
}
function $61de1ee1cac498ae$var$x2b() {
    $61de1ee1cac498ae$var$x2b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$w2b = new $61de1ee1cac498ae$var$d7c;
}
function $61de1ee1cac498ae$var$iVb() {
    $61de1ee1cac498ae$var$iVb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$hVb = new $61de1ee1cac498ae$var$jVb;
}
function $61de1ee1cac498ae$var$nVb() {
    $61de1ee1cac498ae$var$nVb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$mVb = new $61de1ee1cac498ae$var$OVb;
}
function $61de1ee1cac498ae$var$LWb() {
    $61de1ee1cac498ae$var$LWb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$KWb = new $61de1ee1cac498ae$var$QWb;
}
function $61de1ee1cac498ae$var$b4b() {
    $61de1ee1cac498ae$var$b4b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$a4b = new $61de1ee1cac498ae$var$l4b;
}
function $61de1ee1cac498ae$var$q9b() {
    $61de1ee1cac498ae$var$q9b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$p9b = new $61de1ee1cac498ae$var$w9b;
}
function $61de1ee1cac498ae$var$qgc() {
    $61de1ee1cac498ae$var$qgc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$pgc = new $61de1ee1cac498ae$var$dic;
}
function $61de1ee1cac498ae$var$Imc() {
    $61de1ee1cac498ae$var$Imc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Hmc = new $61de1ee1cac498ae$var$Wmc;
}
function $61de1ee1cac498ae$var$GUc() {
    $61de1ee1cac498ae$var$GUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$FUc = new $61de1ee1cac498ae$var$j3c;
}
function $61de1ee1cac498ae$var$i_c() {
    $61de1ee1cac498ae$var$i_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$h_c = new $61de1ee1cac498ae$var$k_c;
}
function $61de1ee1cac498ae$var$s_c() {
    $61de1ee1cac498ae$var$s_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$r_c = new $61de1ee1cac498ae$var$t_c;
}
function $61de1ee1cac498ae$var$R0c() {
    $61de1ee1cac498ae$var$R0c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Q0c = new $61de1ee1cac498ae$var$T0c;
}
function $61de1ee1cac498ae$var$Vyc() {
    $61de1ee1cac498ae$var$Vyc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Uyc = new $61de1ee1cac498ae$var$Ved;
}
function $61de1ee1cac498ae$var$DCc() {
    $61de1ee1cac498ae$var$vCc();
    this.c = new $61de1ee1cac498ae$var$Ji;
}
function $61de1ee1cac498ae$var$k_c() {
    $61de1ee1cac498ae$var$$r.call(this, $61de1ee1cac498ae$var$Une, 0);
}
function $61de1ee1cac498ae$var$r4c(a, b) {
    $61de1ee1cac498ae$var$Xrb(a.c.b, b.c, b);
}
function $61de1ee1cac498ae$var$s4c(a, b) {
    $61de1ee1cac498ae$var$Xrb(a.c.c, b.b, b);
}
function $61de1ee1cac498ae$var$B3c(a, b, c) {
    $61de1ee1cac498ae$var$Shb(a.d, b.f, c);
}
function $61de1ee1cac498ae$var$kKb(a, b, c, d) {
    $61de1ee1cac498ae$var$jKb(a, d, b, c);
}
function $61de1ee1cac498ae$var$E3b(a, b, c, d) {
    $61de1ee1cac498ae$var$J3b(d, a, b, c);
}
function $61de1ee1cac498ae$var$e9b(a, b, c, d) {
    $61de1ee1cac498ae$var$f9b(d, a, b, c);
}
function $61de1ee1cac498ae$var$g3c(a, b) {
    a.a = b.g;
    return a;
}
function $61de1ee1cac498ae$var$DQd(a, b) {
    return $61de1ee1cac498ae$var$qA(a.a, b);
}
function $61de1ee1cac498ae$var$nQd(a) {
    return a.b ? a.b : a.a;
}
function $61de1ee1cac498ae$var$$Oc(a) {
    return (a.c + a.a) / 2;
}
function $61de1ee1cac498ae$var$Pgd() {
    $61de1ee1cac498ae$var$Pgd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ogd = new $61de1ee1cac498ae$var$Ahd;
}
function $61de1ee1cac498ae$var$AFd() {
    $61de1ee1cac498ae$var$AFd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$zFd = new $61de1ee1cac498ae$var$BFd;
}
function $61de1ee1cac498ae$var$tFd() {
    $61de1ee1cac498ae$var$tFd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$sFd = new $61de1ee1cac498ae$var$vFd;
}
function $61de1ee1cac498ae$var$EFd() {
    $61de1ee1cac498ae$var$EFd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$DFd = new $61de1ee1cac498ae$var$GFd;
}
function $61de1ee1cac498ae$var$yFd() {
    $61de1ee1cac498ae$var$yFd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xFd = new $61de1ee1cac498ae$var$oUd;
}
function $61de1ee1cac498ae$var$JFd() {
    $61de1ee1cac498ae$var$JFd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$IFd = new $61de1ee1cac498ae$var$cZd;
}
function $61de1ee1cac498ae$var$nRd() {
    $61de1ee1cac498ae$var$nRd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$mRd = new $61de1ee1cac498ae$var$u4d;
}
function $61de1ee1cac498ae$var$LRd() {
    $61de1ee1cac498ae$var$LRd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$KRd = new $61de1ee1cac498ae$var$y4d;
}
function $61de1ee1cac498ae$var$g5d() {
    $61de1ee1cac498ae$var$g5d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$f5d = new $61de1ee1cac498ae$var$h5d;
}
function $61de1ee1cac498ae$var$Q6d() {
    $61de1ee1cac498ae$var$Q6d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$P6d = new $61de1ee1cac498ae$var$U6d;
}
function $61de1ee1cac498ae$var$pEd() {
    $61de1ee1cac498ae$var$pEd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$oEd = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$tZd() {
    $61de1ee1cac498ae$var$tZd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$rZd = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$Xge() {
    $61de1ee1cac498ae$var$Xge = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Wge = new $61de1ee1cac498ae$var$dhe;
}
function $61de1ee1cac498ae$var$Hz(a) {
    $61de1ee1cac498ae$var$$wnd.clearTimeout(a);
}
function $61de1ee1cac498ae$var$jw(a) {
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 224);
}
function $61de1ee1cac498ae$var$Lv(a) {
    return $61de1ee1cac498ae$var$BD(a, 42).cd();
}
function $61de1ee1cac498ae$var$sib(a) {
    return a.b < a.d.gc();
}
function $61de1ee1cac498ae$var$Lpb(a, b) {
    return $61de1ee1cac498ae$var$tqb(a.a, b);
}
function $61de1ee1cac498ae$var$Dbb(a, b) {
    return $61de1ee1cac498ae$var$ybb(a, b) > 0;
}
function $61de1ee1cac498ae$var$Gbb(a, b) {
    return $61de1ee1cac498ae$var$ybb(a, b) < 0;
}
function $61de1ee1cac498ae$var$Crb(a, b) {
    return a.a.get(b);
}
function $61de1ee1cac498ae$var$icb(b, a) {
    return a.split(b);
}
function $61de1ee1cac498ae$var$Vrb(a, b) {
    return $61de1ee1cac498ae$var$Mhb(a.e, b);
}
function $61de1ee1cac498ae$var$Nvb(a) {
    return $61de1ee1cac498ae$var$uCb(a), false;
}
function $61de1ee1cac498ae$var$Rub(a) {
    $61de1ee1cac498ae$var$Kub.call(this, a, 21);
}
function $61de1ee1cac498ae$var$wcb(a, b) {
    $61de1ee1cac498ae$var$Zy.call(this, a, b);
}
function $61de1ee1cac498ae$var$mxb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Gyb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$zx(a) {
    $61de1ee1cac498ae$var$yx();
    $61de1ee1cac498ae$var$Wn.call(this, a);
}
function $61de1ee1cac498ae$var$zlb(a, b) {
    $61de1ee1cac498ae$var$Dlb(a, a.length, b);
}
function $61de1ee1cac498ae$var$Alb(a, b) {
    $61de1ee1cac498ae$var$Flb(a, a.length, b);
}
function $61de1ee1cac498ae$var$ABb(a, b, c) {
    b.ud(a.a.Ge(c));
}
function $61de1ee1cac498ae$var$uBb(a, b, c) {
    b.we(a.a.Fe(c));
}
function $61de1ee1cac498ae$var$GBb(a, b, c) {
    b.td(a.a.Kb(c));
}
function $61de1ee1cac498ae$var$Zq(a, b, c) {
    a.Mb(c) && b.td(c);
}
function $61de1ee1cac498ae$var$aCb(a, b, c) {
    a.splice(b, 0, c);
}
function $61de1ee1cac498ae$var$lDb(a, b) {
    return $61de1ee1cac498ae$var$uqb(a.e, b);
}
function $61de1ee1cac498ae$var$pjb(a, b) {
    this.d = a;
    this.e = b;
}
function $61de1ee1cac498ae$var$kqb(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$VBb(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$BEb(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$sBb(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$yBb(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$EBb(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$KBb(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$aDb(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$tMb(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$oOb(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$SOb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$SMb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$NEb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$VEb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$sFb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$hHb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$OHb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$FIb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$wLb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$YRb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$zTb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$rUb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$oWb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$SXb(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$k0b(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$z5b(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$T8b(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$ibc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Cec(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$rfc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Rfc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Tfc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$bgc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$ngc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Qhc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$$hc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Z0b(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$ZVb(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$Dfc(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$dgc(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$Bmc(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$cWb(a, b) {
    this.c = a;
    this.d = b;
}
function $61de1ee1cac498ae$var$I$b(a, b) {
    this.e = a;
    this.d = b;
}
function $61de1ee1cac498ae$var$Unc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Oic(a, b) {
    this.b = b;
    this.c = a;
}
function $61de1ee1cac498ae$var$Bjc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Yjc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Gkc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Bpc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Jpc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Tpc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$cqc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$oqc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$yqc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Hqc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Uqc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$arc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$mrc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$zrc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Prc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Yrc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$fsc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$nsc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$nzc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$zzc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Kzc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Xzc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Dtc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$lAc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$uAc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$CAc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$LAc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$UAc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$aBc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$uBc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$DBc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$MBc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$sGc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$VIc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$EIc(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$qKc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$GKc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$lLc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$mMc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$fMc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$ZLc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$ZMc(a, b) {
    this.b = a;
    this.d = b;
}
function $61de1ee1cac498ae$var$IOc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$GQc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$PQc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$RQc(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$ARc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$rSc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$TTc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$_Tc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$RUc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$uVc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$hWc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$rWc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$kXc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$uXc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$AYc(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$l$c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Z$c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$D_c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$O_c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$c1c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$cVb(a, b) {
    return $61de1ee1cac498ae$var$uqb(a.c, b);
}
function $61de1ee1cac498ae$var$nnc(a, b) {
    return $61de1ee1cac498ae$var$uqb(b.b, a);
}
function $61de1ee1cac498ae$var$x1c(a, b) {
    return -a.b.Je(b);
}
function $61de1ee1cac498ae$var$D3c(a, b) {
    return $61de1ee1cac498ae$var$uqb(a.g, b);
}
function $61de1ee1cac498ae$var$O5c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$a6c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$m2c(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$W2c(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$f7c(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$G7c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$j8c(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$iad(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$rad(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Bad(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Nad(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$ibd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$tbd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Ibd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Ubd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$gcd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$scd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Ycd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$udd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Jdd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Eed(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$bfd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$dfd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$ffd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Kfd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Mfd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Ofd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$vgd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$qgd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$jrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$krd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$mrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$nrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$qrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$rrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$srd(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$trd(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$Drd(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$Frd(a, b) {
    this.b = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$Hrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Jrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Ord(a, b) {
    $61de1ee1cac498ae$var$Xqd(a.a, $61de1ee1cac498ae$var$BD(b, 56));
}
function $61de1ee1cac498ae$var$BIc(a, b) {
    $61de1ee1cac498ae$var$gIc(a.a, $61de1ee1cac498ae$var$BD(b, 11));
}
function $61de1ee1cac498ae$var$fIc(a, b) {
    $61de1ee1cac498ae$var$FHc();
    return b != a;
}
function $61de1ee1cac498ae$var$Arb() {
    $61de1ee1cac498ae$var$wrb();
    return new $61de1ee1cac498ae$var$vrb;
}
function $61de1ee1cac498ae$var$CMc() {
    $61de1ee1cac498ae$var$wMc();
    this.b = new $61de1ee1cac498ae$var$Tqb;
}
function $61de1ee1cac498ae$var$NNc() {
    $61de1ee1cac498ae$var$FNc();
    this.a = new $61de1ee1cac498ae$var$Tqb;
}
function $61de1ee1cac498ae$var$eCc() {
    $61de1ee1cac498ae$var$ZBc();
    $61de1ee1cac498ae$var$aCc.call(this);
}
function $61de1ee1cac498ae$var$Dsd(a, b) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
}
function $61de1ee1cac498ae$var$Urd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Wrd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$kGd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$nGd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$bUd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$zVd(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$C1d(a, b) {
    this.d = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$MLd(a, b) {
    this.d = a;
    this.e = b;
}
function $61de1ee1cac498ae$var$Wud(a, b) {
    this.f = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$f7d(a, b) {
    this.b = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$_zd(a, b) {
    this.i = a;
    this.g = b;
}
function $61de1ee1cac498ae$var$Y1d(a, b) {
    this.e = a;
    this.a = b;
}
function $61de1ee1cac498ae$var$c8d(a, b) {
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$$Id(a, b) {
    a.i = null;
    $61de1ee1cac498ae$var$_Id(a, b);
}
function $61de1ee1cac498ae$var$ivd(a, b) {
    !!a && $61de1ee1cac498ae$var$Rhb($61de1ee1cac498ae$var$cvd, a, b);
}
function $61de1ee1cac498ae$var$hCd(a, b) {
    return $61de1ee1cac498ae$var$qAd(a.a, b);
}
function $61de1ee1cac498ae$var$e7d(a) {
    return $61de1ee1cac498ae$var$R2d(a.c, a.b);
}
function $61de1ee1cac498ae$var$Wd(a) {
    return !a ? null : a.dd();
}
function $61de1ee1cac498ae$var$PD(a) {
    return a == null ? null : a;
}
function $61de1ee1cac498ae$var$KD(a) {
    return typeof a === $61de1ee1cac498ae$var$Khe;
}
function $61de1ee1cac498ae$var$LD(a) {
    return typeof a === $61de1ee1cac498ae$var$Lhe;
}
function $61de1ee1cac498ae$var$ND(a) {
    return typeof a === $61de1ee1cac498ae$var$Mhe;
}
function $61de1ee1cac498ae$var$Em(a, b) {
    return a.Hd().Xb(b);
}
function $61de1ee1cac498ae$var$Kq(a, b) {
    return $61de1ee1cac498ae$var$hr(a.Kc(), b);
}
function $61de1ee1cac498ae$var$Bbb(a, b) {
    return $61de1ee1cac498ae$var$ybb(a, b) == 0;
}
function $61de1ee1cac498ae$var$Ebb(a, b) {
    return $61de1ee1cac498ae$var$ybb(a, b) >= 0;
}
function $61de1ee1cac498ae$var$Kbb(a, b) {
    return $61de1ee1cac498ae$var$ybb(a, b) != 0;
}
function $61de1ee1cac498ae$var$Jdb(a) {
    return "" + ($61de1ee1cac498ae$var$uCb(a), a);
}
function $61de1ee1cac498ae$var$pfb(a, b) {
    return a.substr(b);
}
function $61de1ee1cac498ae$var$cg(a) {
    $61de1ee1cac498ae$var$ag(a);
    return a.d.gc();
}
function $61de1ee1cac498ae$var$oVb(a) {
    $61de1ee1cac498ae$var$pVb(a, a.c);
    return a;
}
function $61de1ee1cac498ae$var$RD(a) {
    $61de1ee1cac498ae$var$CCb(a == null);
    return a;
}
function $61de1ee1cac498ae$var$Dfb(a, b) {
    a.a += "" + b;
    return a;
}
function $61de1ee1cac498ae$var$Efb(a, b) {
    a.a += "" + b;
    return a;
}
function $61de1ee1cac498ae$var$Nfb(a, b) {
    a.a += "" + b;
    return a;
}
function $61de1ee1cac498ae$var$Pfb(a, b) {
    a.a += "" + b;
    return a;
}
function $61de1ee1cac498ae$var$Qfb(a, b) {
    a.a += "" + b;
    return a;
}
function $61de1ee1cac498ae$var$Mfb(a, b) {
    return a.a += "" + b, a;
}
function $61de1ee1cac498ae$var$Esb(a, b) {
    $61de1ee1cac498ae$var$Gsb(a, b, a.a, a.a.a);
}
function $61de1ee1cac498ae$var$Fsb(a, b) {
    $61de1ee1cac498ae$var$Gsb(a, b, a.c.b, a.c);
}
function $61de1ee1cac498ae$var$Mqd(a, b, c) {
    $61de1ee1cac498ae$var$Rpd(b, $61de1ee1cac498ae$var$kqd(a, c));
}
function $61de1ee1cac498ae$var$Nqd(a, b, c) {
    $61de1ee1cac498ae$var$Rpd(b, $61de1ee1cac498ae$var$kqd(a, c));
}
function $61de1ee1cac498ae$var$Dhe(a, b) {
    $61de1ee1cac498ae$var$Hhe(new $61de1ee1cac498ae$var$Fyd(a), b);
}
function $61de1ee1cac498ae$var$cB(a, b) {
    a.q.setTime($61de1ee1cac498ae$var$Sbb(b));
}
function $61de1ee1cac498ae$var$fvb(a, b) {
    $61de1ee1cac498ae$var$bvb.call(this, a, b);
}
function $61de1ee1cac498ae$var$jvb(a, b) {
    $61de1ee1cac498ae$var$bvb.call(this, a, b);
}
function $61de1ee1cac498ae$var$nvb(a, b) {
    $61de1ee1cac498ae$var$bvb.call(this, a, b);
}
function $61de1ee1cac498ae$var$Nqb(a) {
    $61de1ee1cac498ae$var$Uhb(this);
    $61de1ee1cac498ae$var$Ld(this, a);
}
function $61de1ee1cac498ae$var$wmb(a) {
    $61de1ee1cac498ae$var$tCb(a, 0);
    return null;
}
function $61de1ee1cac498ae$var$X6c(a) {
    a.a = 0;
    a.b = 0;
    return a;
}
function $61de1ee1cac498ae$var$f3c(a, b) {
    a.a = b.g + 1;
    return a;
}
function $61de1ee1cac498ae$var$PJc(a, b) {
    return a.j[b.p] == 2;
}
function $61de1ee1cac498ae$var$_Pb(a) {
    return $61de1ee1cac498ae$var$VPb($61de1ee1cac498ae$var$BD(a, 79));
}
function $61de1ee1cac498ae$var$yJb() {
    $61de1ee1cac498ae$var$yJb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xJb = $61de1ee1cac498ae$var$as($61de1ee1cac498ae$var$wJb());
}
function $61de1ee1cac498ae$var$Y8b() {
    $61de1ee1cac498ae$var$Y8b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$X8b = $61de1ee1cac498ae$var$as($61de1ee1cac498ae$var$W8b());
}
function $61de1ee1cac498ae$var$mt() {
    this.b = new $61de1ee1cac498ae$var$Mqb($61de1ee1cac498ae$var$Cv(12));
}
function $61de1ee1cac498ae$var$Otb() {
    this.b = 0;
    this.a = false;
}
function $61de1ee1cac498ae$var$Wtb() {
    this.b = 0;
    this.a = false;
}
function $61de1ee1cac498ae$var$sl(a) {
    this.a = a;
    $61de1ee1cac498ae$var$ol.call(this);
}
function $61de1ee1cac498ae$var$vl(a) {
    this.a = a;
    $61de1ee1cac498ae$var$ol.call(this);
}
function $61de1ee1cac498ae$var$Nsd(a, b) {
    $61de1ee1cac498ae$var$Msd.call(this, a, b);
}
function $61de1ee1cac498ae$var$$zd(a, b) {
    $61de1ee1cac498ae$var$Cyd.call(this, a, b);
}
function $61de1ee1cac498ae$var$nNd(a, b) {
    $61de1ee1cac498ae$var$_zd.call(this, a, b);
}
function $61de1ee1cac498ae$var$s4d(a, b) {
    $61de1ee1cac498ae$var$p4d.call(this, a, b);
}
function $61de1ee1cac498ae$var$w4d(a, b) {
    $61de1ee1cac498ae$var$qRd.call(this, a, b);
}
function $61de1ee1cac498ae$var$rEd(a, b) {
    $61de1ee1cac498ae$var$pEd();
    $61de1ee1cac498ae$var$Rhb($61de1ee1cac498ae$var$oEd, a, b);
}
function $61de1ee1cac498ae$var$lcb(a, b) {
    return $61de1ee1cac498ae$var$qfb(a.a, 0, b);
}
function $61de1ee1cac498ae$var$ww(a, b) {
    return a.a.a.a.cc(b);
}
function $61de1ee1cac498ae$var$mb(a, b) {
    return $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b);
}
function $61de1ee1cac498ae$var$Mdb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.a, b.a);
}
function $61de1ee1cac498ae$var$$db(a, b) {
    return $61de1ee1cac498ae$var$beb(a.a, b.a);
}
function $61de1ee1cac498ae$var$seb(a, b) {
    return $61de1ee1cac498ae$var$ueb(a.a, b.a);
}
function $61de1ee1cac498ae$var$hfb(a, b) {
    return a.indexOf(b);
}
function $61de1ee1cac498ae$var$Ny(a, b) {
    return a == b ? 0 : a ? 1 : -1;
}
function $61de1ee1cac498ae$var$kB(a) {
    return a < 10 ? "0" + a : "" + a;
}
function $61de1ee1cac498ae$var$Mq(a) {
    return $61de1ee1cac498ae$var$Qb(a), new $61de1ee1cac498ae$var$sl(a);
}
function $61de1ee1cac498ae$var$SC(a) {
    return $61de1ee1cac498ae$var$TC(a.l, a.m, a.h);
}
function $61de1ee1cac498ae$var$Hdb(a) {
    return $61de1ee1cac498ae$var$QD(($61de1ee1cac498ae$var$uCb(a), a));
}
function $61de1ee1cac498ae$var$Idb(a) {
    return $61de1ee1cac498ae$var$QD(($61de1ee1cac498ae$var$uCb(a), a));
}
function $61de1ee1cac498ae$var$NIb(a, b) {
    return $61de1ee1cac498ae$var$beb(a.g, b.g);
}
function $61de1ee1cac498ae$var$Fbb(a) {
    return typeof a === $61de1ee1cac498ae$var$Lhe;
}
function $61de1ee1cac498ae$var$mWb(a) {
    return a == $61de1ee1cac498ae$var$hWb || a == $61de1ee1cac498ae$var$kWb;
}
function $61de1ee1cac498ae$var$nWb(a) {
    return a == $61de1ee1cac498ae$var$hWb || a == $61de1ee1cac498ae$var$iWb;
}
function $61de1ee1cac498ae$var$G1b(a) {
    return $61de1ee1cac498ae$var$Jkb(a.b.b, a, 0);
}
function $61de1ee1cac498ae$var$lrb(a) {
    this.a = $61de1ee1cac498ae$var$Arb();
    this.b = a;
}
function $61de1ee1cac498ae$var$Frb(a) {
    this.a = $61de1ee1cac498ae$var$Arb();
    this.b = a;
}
function $61de1ee1cac498ae$var$swb(a, b) {
    $61de1ee1cac498ae$var$Ekb(a.a, b);
    return b;
}
function $61de1ee1cac498ae$var$Z1c(a, b) {
    $61de1ee1cac498ae$var$Ekb(a.c, b);
    return a;
}
function $61de1ee1cac498ae$var$E2c(a, b) {
    $61de1ee1cac498ae$var$d3c(a.a, b);
    return a;
}
function $61de1ee1cac498ae$var$_gc(a, b) {
    $61de1ee1cac498ae$var$Hgc();
    return b.a += a;
}
function $61de1ee1cac498ae$var$bhc(a, b) {
    $61de1ee1cac498ae$var$Hgc();
    return b.a += a;
}
function $61de1ee1cac498ae$var$ahc(a, b) {
    $61de1ee1cac498ae$var$Hgc();
    return b.c += a;
}
function $61de1ee1cac498ae$var$Nlb(a, b) {
    $61de1ee1cac498ae$var$Klb(a, 0, a.length, b);
}
function $61de1ee1cac498ae$var$zsb() {
    $61de1ee1cac498ae$var$Wqb.call(this, new $61de1ee1cac498ae$var$$rb);
}
function $61de1ee1cac498ae$var$I_b() {
    $61de1ee1cac498ae$var$B_b.call(this, 0, 0, 0, 0);
}
function $61de1ee1cac498ae$var$I6c() {
    $61de1ee1cac498ae$var$J6c.call(this, 0, 0, 0, 0);
}
function $61de1ee1cac498ae$var$g7c(a) {
    this.a = a.a;
    this.b = a.b;
}
function $61de1ee1cac498ae$var$fad(a) {
    return a == $61de1ee1cac498ae$var$aad || a == $61de1ee1cac498ae$var$bad;
}
function $61de1ee1cac498ae$var$gad(a) {
    return a == $61de1ee1cac498ae$var$dad || a == $61de1ee1cac498ae$var$_9c;
}
function $61de1ee1cac498ae$var$Jzc(a) {
    return a == $61de1ee1cac498ae$var$Fzc || a == $61de1ee1cac498ae$var$Ezc;
}
function $61de1ee1cac498ae$var$fcd(a) {
    return a != $61de1ee1cac498ae$var$bcd && a != $61de1ee1cac498ae$var$ccd;
}
function $61de1ee1cac498ae$var$oid(a) {
    return a.Lg() && a.Mg();
}
function $61de1ee1cac498ae$var$Gfd(a) {
    return $61de1ee1cac498ae$var$Kkd($61de1ee1cac498ae$var$BD(a, 118));
}
function $61de1ee1cac498ae$var$k3c(a) {
    return $61de1ee1cac498ae$var$d3c(new $61de1ee1cac498ae$var$j3c, a);
}
function $61de1ee1cac498ae$var$y2d(a, b) {
    return new $61de1ee1cac498ae$var$p4d(b, a);
}
function $61de1ee1cac498ae$var$z2d(a, b) {
    return new $61de1ee1cac498ae$var$p4d(b, a);
}
function $61de1ee1cac498ae$var$ukd(a, b, c) {
    $61de1ee1cac498ae$var$vkd(a, b);
    $61de1ee1cac498ae$var$wkd(a, c);
}
function $61de1ee1cac498ae$var$_kd(a, b, c) {
    $61de1ee1cac498ae$var$cld(a, b);
    $61de1ee1cac498ae$var$ald(a, c);
}
function $61de1ee1cac498ae$var$bld(a, b, c) {
    $61de1ee1cac498ae$var$dld(a, b);
    $61de1ee1cac498ae$var$eld(a, c);
}
function $61de1ee1cac498ae$var$gmd(a, b, c) {
    $61de1ee1cac498ae$var$hmd(a, b);
    $61de1ee1cac498ae$var$imd(a, c);
}
function $61de1ee1cac498ae$var$nmd(a, b, c) {
    $61de1ee1cac498ae$var$omd(a, b);
    $61de1ee1cac498ae$var$pmd(a, c);
}
function $61de1ee1cac498ae$var$iKd(a, b) {
    $61de1ee1cac498ae$var$$Jd(a, b);
    $61de1ee1cac498ae$var$_Jd(a, a.D);
}
function $61de1ee1cac498ae$var$_ud(a) {
    $61de1ee1cac498ae$var$Wud.call(this, a, true);
}
function $61de1ee1cac498ae$var$Xg(a, b, c) {
    $61de1ee1cac498ae$var$Vg.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$Ygb(a) {
    $61de1ee1cac498ae$var$Hgb();
    $61de1ee1cac498ae$var$Zgb.call(this, a);
}
function $61de1ee1cac498ae$var$rxb() {
    $61de1ee1cac498ae$var$mxb.call(this, "Head", 1);
}
function $61de1ee1cac498ae$var$wxb() {
    $61de1ee1cac498ae$var$mxb.call(this, "Tail", 3);
}
function $61de1ee1cac498ae$var$Ckb(a) {
    a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
}
function $61de1ee1cac498ae$var$Vjb(a) {
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 8, 5, 1);
}
function $61de1ee1cac498ae$var$MGb(a) {
    $61de1ee1cac498ae$var$Hkb(a.xf(), new $61de1ee1cac498ae$var$QGb(a));
}
function $61de1ee1cac498ae$var$xtb(a) {
    return a != null ? $61de1ee1cac498ae$var$tb(a) : 0;
}
function $61de1ee1cac498ae$var$b2b(a, b) {
    return $61de1ee1cac498ae$var$ntd(b, $61de1ee1cac498ae$var$mpd(a));
}
function $61de1ee1cac498ae$var$c2b(a, b) {
    return $61de1ee1cac498ae$var$ntd(b, $61de1ee1cac498ae$var$mpd(a));
}
function $61de1ee1cac498ae$var$dAb(a, b) {
    return a[a.length] = b;
}
function $61de1ee1cac498ae$var$gAb(a, b) {
    return a[a.length] = b;
}
function $61de1ee1cac498ae$var$Vq(a) {
    return $61de1ee1cac498ae$var$lr(a.b.Kc(), a.a);
}
function $61de1ee1cac498ae$var$dqd(a, b) {
    return $61de1ee1cac498ae$var$_o($61de1ee1cac498ae$var$qo(a.d), b);
}
function $61de1ee1cac498ae$var$eqd(a, b) {
    return $61de1ee1cac498ae$var$_o($61de1ee1cac498ae$var$qo(a.g), b);
}
function $61de1ee1cac498ae$var$fqd(a, b) {
    return $61de1ee1cac498ae$var$_o($61de1ee1cac498ae$var$qo(a.j), b);
}
function $61de1ee1cac498ae$var$Osd(a, b) {
    $61de1ee1cac498ae$var$Msd.call(this, a.b, b);
}
function $61de1ee1cac498ae$var$q0b(a) {
    $61de1ee1cac498ae$var$B_b.call(this, a, a, a, a);
}
function $61de1ee1cac498ae$var$HOb(a) {
    a.b && $61de1ee1cac498ae$var$LOb(a);
    return a.a;
}
function $61de1ee1cac498ae$var$IOb(a) {
    a.b && $61de1ee1cac498ae$var$LOb(a);
    return a.c;
}
function $61de1ee1cac498ae$var$uyb(a, b) {
    if ($61de1ee1cac498ae$var$lyb) return;
    a.b = b;
}
function $61de1ee1cac498ae$var$lzd(a, b, c) {
    $61de1ee1cac498ae$var$NC(a, b, c);
    return c;
}
function $61de1ee1cac498ae$var$mBc(a, b, c) {
    $61de1ee1cac498ae$var$NC(a.c[b.g], b.g, c);
}
function $61de1ee1cac498ae$var$_Hd(a, b, c) {
    $61de1ee1cac498ae$var$BD(a.c, 69).Xh(b, c);
}
function $61de1ee1cac498ae$var$wfd(a, b, c) {
    $61de1ee1cac498ae$var$bld(c, c.i + a, c.j + b);
}
function $61de1ee1cac498ae$var$UOd(a, b) {
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$VKd(a.a), $61de1ee1cac498ae$var$XOd(b));
}
function $61de1ee1cac498ae$var$bTd(a, b) {
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$QSd(a.a), $61de1ee1cac498ae$var$eTd(b));
}
function $61de1ee1cac498ae$var$Lge(a) {
    $61de1ee1cac498ae$var$wfe();
    $61de1ee1cac498ae$var$xfe.call(this, a);
}
function $61de1ee1cac498ae$var$CAd(a) {
    return a == null ? 0 : $61de1ee1cac498ae$var$tb(a);
}
function $61de1ee1cac498ae$var$fNc() {
    $61de1ee1cac498ae$var$fNc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$eNc = new $61de1ee1cac498ae$var$Rpb($61de1ee1cac498ae$var$v1);
}
function $61de1ee1cac498ae$var$h0d() {
    $61de1ee1cac498ae$var$h0d = $61de1ee1cac498ae$var$ccb;
    new $61de1ee1cac498ae$var$i0d;
    new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$i0d() {
    new $61de1ee1cac498ae$var$Lqb;
    new $61de1ee1cac498ae$var$Lqb;
    new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$GA() {
    $61de1ee1cac498ae$var$GA = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$fA();
    $61de1ee1cac498ae$var$FA = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$Iy() {
    $61de1ee1cac498ae$var$Iy = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$$wnd.Math.log(2);
}
function $61de1ee1cac498ae$var$UVd() {
    $61de1ee1cac498ae$var$UVd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$TVd = ($61de1ee1cac498ae$var$AFd(), $61de1ee1cac498ae$var$zFd);
}
function $61de1ee1cac498ae$var$_ge() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$Cxe));
}
function $61de1ee1cac498ae$var$ohe() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$Cxe));
}
function $61de1ee1cac498ae$var$che() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$Dxe));
}
function $61de1ee1cac498ae$var$rhe() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$Dxe));
}
function $61de1ee1cac498ae$var$Mg(a) {
    this.a = a;
    $61de1ee1cac498ae$var$Gg.call(this, a);
}
function $61de1ee1cac498ae$var$up(a) {
    this.a = a;
    $61de1ee1cac498ae$var$rf.call(this, a);
}
function $61de1ee1cac498ae$var$Bp(a) {
    this.a = a;
    $61de1ee1cac498ae$var$rf.call(this, a);
}
function $61de1ee1cac498ae$var$Okb(a, b) {
    $61de1ee1cac498ae$var$Mlb(a.c, a.c.length, b);
}
function $61de1ee1cac498ae$var$llb(a) {
    return a.a < a.c.c.length;
}
function $61de1ee1cac498ae$var$Eqb(a) {
    return a.a < a.c.a.length;
}
function $61de1ee1cac498ae$var$Ntb(a, b) {
    return a.a ? a.b : b.De();
}
function $61de1ee1cac498ae$var$beb(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $61de1ee1cac498ae$var$Deb(a, b) {
    return $61de1ee1cac498ae$var$ybb(a, b) > 0 ? a : b;
}
function $61de1ee1cac498ae$var$TC(a, b, c) {
    return {
        l: a,
        m: b,
        h: c
    };
}
function $61de1ee1cac498ae$var$Ctb(a, b) {
    a.a != null && $61de1ee1cac498ae$var$BIc(b, a.a);
}
function $61de1ee1cac498ae$var$Csb(a) {
    a.a = new $61de1ee1cac498ae$var$jtb;
    a.c = new $61de1ee1cac498ae$var$jtb;
}
function $61de1ee1cac498ae$var$hDb(a) {
    this.b = a;
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$dOb(a) {
    this.b = new $61de1ee1cac498ae$var$pOb;
    this.a = a;
}
function $61de1ee1cac498ae$var$q_b(a) {
    $61de1ee1cac498ae$var$n_b.call(this);
    this.a = a;
}
function $61de1ee1cac498ae$var$txb() {
    $61de1ee1cac498ae$var$mxb.call(this, "Range", 2);
}
function $61de1ee1cac498ae$var$bUb() {
    $61de1ee1cac498ae$var$ZTb();
    this.a = new $61de1ee1cac498ae$var$L2c($61de1ee1cac498ae$var$zP);
}
function $61de1ee1cac498ae$var$Bh(a, b) {
    $61de1ee1cac498ae$var$Qb(b);
    $61de1ee1cac498ae$var$Ah(a).Jc(new $61de1ee1cac498ae$var$Vw);
}
function $61de1ee1cac498ae$var$fKc(a, b) {
    $61de1ee1cac498ae$var$FJc();
    return b.n.b += a;
}
function $61de1ee1cac498ae$var$Tgc(a, b, c) {
    return $61de1ee1cac498ae$var$Rhb(a.g, c, b);
}
function $61de1ee1cac498ae$var$LJc(a, b, c) {
    return $61de1ee1cac498ae$var$Rhb(a.k, c, b);
}
function $61de1ee1cac498ae$var$r1c(a, b) {
    return $61de1ee1cac498ae$var$Rhb(a.a, b.a, b);
}
function $61de1ee1cac498ae$var$jBc(a, b, c) {
    return $61de1ee1cac498ae$var$hBc(b, c, a.c);
}
function $61de1ee1cac498ae$var$E6c(a) {
    return new $61de1ee1cac498ae$var$f7c(a.c, a.d);
}
function $61de1ee1cac498ae$var$F6c(a) {
    return new $61de1ee1cac498ae$var$f7c(a.c, a.d);
}
function $61de1ee1cac498ae$var$R6c(a) {
    return new $61de1ee1cac498ae$var$f7c(a.a, a.b);
}
function $61de1ee1cac498ae$var$CQd(a, b) {
    return $61de1ee1cac498ae$var$hA(a.a, b, null);
}
function $61de1ee1cac498ae$var$fec(a) {
    $61de1ee1cac498ae$var$QZb(a, null);
    $61de1ee1cac498ae$var$RZb(a, null);
}
function $61de1ee1cac498ae$var$AOc(a) {
    $61de1ee1cac498ae$var$BOc(a, null);
    $61de1ee1cac498ae$var$COc(a, null);
}
function $61de1ee1cac498ae$var$u4d() {
    $61de1ee1cac498ae$var$qRd.call(this, null, null);
}
function $61de1ee1cac498ae$var$y4d() {
    $61de1ee1cac498ae$var$RRd.call(this, null, null);
}
function $61de1ee1cac498ae$var$a7d(a) {
    this.a = a;
    $61de1ee1cac498ae$var$Lqb.call(this);
}
function $61de1ee1cac498ae$var$Pp(a) {
    this.b = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$iob(a));
}
function $61de1ee1cac498ae$var$Py(a) {
    a.j = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$VI, $61de1ee1cac498ae$var$nie, 310, 0, 0, 1);
}
function $61de1ee1cac498ae$var$oAd(a, b, c) {
    a.c.Vc(b, $61de1ee1cac498ae$var$BD(c, 133));
}
function $61de1ee1cac498ae$var$GAd(a, b, c) {
    a.c.ji(b, $61de1ee1cac498ae$var$BD(c, 133));
}
function $61de1ee1cac498ae$var$JLd(a, b) {
    $61de1ee1cac498ae$var$Uxd(a);
    a.Gc($61de1ee1cac498ae$var$BD(b, 15));
}
function $61de1ee1cac498ae$var$b7d(a, b) {
    return $61de1ee1cac498ae$var$t2d(a.c, a.b, b);
}
function $61de1ee1cac498ae$var$Bv(a, b) {
    return new $61de1ee1cac498ae$var$Qv(a.Kc(), b);
}
function $61de1ee1cac498ae$var$Lq(a, b) {
    return $61de1ee1cac498ae$var$rr(a.Kc(), b) != -1;
}
function $61de1ee1cac498ae$var$Sqb(a, b) {
    return a.a.Bc(b) != null;
}
function $61de1ee1cac498ae$var$pr(a) {
    return a.Ob() ? a.Pb() : null;
}
function $61de1ee1cac498ae$var$yfb(a) {
    return $61de1ee1cac498ae$var$zfb(a, 0, a.length);
}
function $61de1ee1cac498ae$var$JD(a, b) {
    return a != null && $61de1ee1cac498ae$var$AD(a, b);
}
function $61de1ee1cac498ae$var$$A(a, b) {
    a.q.setHours(b);
    $61de1ee1cac498ae$var$YA(a, b);
}
function $61de1ee1cac498ae$var$Yrb(a, b) {
    if (a.c) {
        $61de1ee1cac498ae$var$jsb(b);
        $61de1ee1cac498ae$var$isb(b);
    }
}
function $61de1ee1cac498ae$var$nk(a, b, c) {
    $61de1ee1cac498ae$var$BD(a.Kb(c), 164).Nb(b);
}
function $61de1ee1cac498ae$var$RJc(a, b, c) {
    $61de1ee1cac498ae$var$SJc(a, b, c);
    return c;
}
function $61de1ee1cac498ae$var$Eub(a, b, c) {
    a.a = b ^ 1502;
    a.b = c ^ $61de1ee1cac498ae$var$kke;
}
function $61de1ee1cac498ae$var$xHb(a, b, c) {
    return a.a[b.g][c.g];
}
function $61de1ee1cac498ae$var$REc(a, b) {
    return a.a[b.c.p][b.p];
}
function $61de1ee1cac498ae$var$aEc(a, b) {
    return a.e[b.c.p][b.p];
}
function $61de1ee1cac498ae$var$tEc(a, b) {
    return a.c[b.c.p][b.p];
}
function $61de1ee1cac498ae$var$OJc(a, b) {
    return a.j[b.p] = $61de1ee1cac498ae$var$aKc(b);
}
function $61de1ee1cac498ae$var$k5c(a, b) {
    return $61de1ee1cac498ae$var$cfb(a.f, b.tg());
}
function $61de1ee1cac498ae$var$Isd(a, b) {
    return $61de1ee1cac498ae$var$cfb(a.b, b.tg());
}
function $61de1ee1cac498ae$var$Sfd(a, b) {
    return a.a < $61de1ee1cac498ae$var$Kcb(b) ? -1 : 1;
}
function $61de1ee1cac498ae$var$ZDc(a, b, c) {
    return c ? b != 0 : b != a - 1;
}
function $61de1ee1cac498ae$var$_6c(a, b, c) {
    a.a = b;
    a.b = c;
    return a;
}
function $61de1ee1cac498ae$var$Y6c(a, b) {
    a.a *= b;
    a.b *= b;
    return a;
}
function $61de1ee1cac498ae$var$mud(a, b, c) {
    $61de1ee1cac498ae$var$NC(a.g, b, c);
    return c;
}
function $61de1ee1cac498ae$var$CHb(a, b, c, d) {
    $61de1ee1cac498ae$var$NC(a.a[b.g], c.g, d);
}
function $61de1ee1cac498ae$var$EQb(a, b) {
    $61de1ee1cac498ae$var$O6c(b, a.a.a.a, a.a.a.b);
}
function $61de1ee1cac498ae$var$Ozd(a) {
    a.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a.b.a, 4), 126);
}
function $61de1ee1cac498ae$var$Wzd(a) {
    a.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a.b.a, 4), 126);
}
function $61de1ee1cac498ae$var$otd(a) {
    $61de1ee1cac498ae$var$ytb(a, $61de1ee1cac498ae$var$hue);
    $61de1ee1cac498ae$var$Rld(a, $61de1ee1cac498ae$var$gtd(a));
}
function $61de1ee1cac498ae$var$Atb() {
    $61de1ee1cac498ae$var$Atb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ztb = new $61de1ee1cac498ae$var$Ftb(null);
}
function $61de1ee1cac498ae$var$Ivb() {
    $61de1ee1cac498ae$var$Ivb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ivb();
    $61de1ee1cac498ae$var$Hvb = new $61de1ee1cac498ae$var$Ovb;
}
function $61de1ee1cac498ae$var$FId() {
    this.Bb |= 256;
    this.Bb |= 512;
}
function $61de1ee1cac498ae$var$Fyd(a) {
    this.i = a;
    this.f = this.i.j;
}
function $61de1ee1cac498ae$var$xMd(a, b, c) {
    $61de1ee1cac498ae$var$pMd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$BMd(a, b, c) {
    $61de1ee1cac498ae$var$xMd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$K4d(a, b, c) {
    $61de1ee1cac498ae$var$xMd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$N4d(a, b, c) {
    $61de1ee1cac498ae$var$BMd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$X4d(a, b, c) {
    $61de1ee1cac498ae$var$pMd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$_4d(a, b, c) {
    $61de1ee1cac498ae$var$pMd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$C4d(a, b, c) {
    $61de1ee1cac498ae$var$k2d.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$G4d(a, b, c) {
    $61de1ee1cac498ae$var$k2d.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$I4d(a, b, c) {
    $61de1ee1cac498ae$var$C4d.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$c5d(a, b, c) {
    $61de1ee1cac498ae$var$X4d.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$zf(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$rf.call(this, b);
}
function $61de1ee1cac498ae$var$aj(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$pc.call(this, b);
}
function $61de1ee1cac498ae$var$kj(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$pc.call(this, b);
}
function $61de1ee1cac498ae$var$Jj(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$pc.call(this, b);
}
function $61de1ee1cac498ae$var$Rj(a) {
    this.a = a;
    $61de1ee1cac498ae$var$sj.call(this, a.d);
}
function $61de1ee1cac498ae$var$she(a) {
    this.c = a;
    this.a = this.c.a;
}
function $61de1ee1cac498ae$var$xl(a, b) {
    this.a = b;
    $61de1ee1cac498ae$var$pc.call(this, a);
}
function $61de1ee1cac498ae$var$Qo(a, b) {
    this.a = b;
    $61de1ee1cac498ae$var$Lo.call(this, a);
}
function $61de1ee1cac498ae$var$op(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$Lo.call(this, b);
}
function $61de1ee1cac498ae$var$rj(a, b) {
    return $61de1ee1cac498ae$var$Rl($61de1ee1cac498ae$var$Xm(a.c)).Xb(b);
}
function $61de1ee1cac498ae$var$Eb(a, b) {
    return $61de1ee1cac498ae$var$Db(a, new $61de1ee1cac498ae$var$Ufb, b).a;
}
function $61de1ee1cac498ae$var$ur(a, b) {
    $61de1ee1cac498ae$var$Qb(b);
    return new $61de1ee1cac498ae$var$Gr(a, b);
}
function $61de1ee1cac498ae$var$Gr(a, b) {
    this.a = b;
    $61de1ee1cac498ae$var$Br.call(this, a);
}
function $61de1ee1cac498ae$var$Hs(a) {
    this.b = a;
    this.a = this.b.a.e;
}
function $61de1ee1cac498ae$var$Eg(a) {
    a.b.Qb();
    --a.d.f.d;
    $61de1ee1cac498ae$var$bg(a.d);
}
function $61de1ee1cac498ae$var$Uk(a) {
    $61de1ee1cac498ae$var$Fk.call(this, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 35));
}
function $61de1ee1cac498ae$var$il(a) {
    $61de1ee1cac498ae$var$Fk.call(this, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 35));
}
function $61de1ee1cac498ae$var$is() {
    $61de1ee1cac498ae$var$$r.call(this, "INSTANCE", 0);
}
function $61de1ee1cac498ae$var$Lb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Vdb);
}
function $61de1ee1cac498ae$var$Ub(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
}
function $61de1ee1cac498ae$var$ot(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
}
function $61de1ee1cac498ae$var$I6d() {
    $61de1ee1cac498ae$var$I6d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$g5d();
    $61de1ee1cac498ae$var$H6d = new $61de1ee1cac498ae$var$J6d;
}
function $61de1ee1cac498ae$var$Bcb() {
    $61de1ee1cac498ae$var$Bcb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$zcb = false;
    $61de1ee1cac498ae$var$Acb = true;
}
function $61de1ee1cac498ae$var$Jfb(a) {
    $61de1ee1cac498ae$var$mcb.call(this, ($61de1ee1cac498ae$var$uCb(a), a));
}
function $61de1ee1cac498ae$var$Wfb(a) {
    $61de1ee1cac498ae$var$mcb.call(this, ($61de1ee1cac498ae$var$uCb(a), a));
}
function $61de1ee1cac498ae$var$Inb(a) {
    $61de1ee1cac498ae$var$lnb.call(this, a);
    this.a = a;
}
function $61de1ee1cac498ae$var$Xnb(a) {
    $61de1ee1cac498ae$var$Dnb.call(this, a);
    this.a = a;
}
function $61de1ee1cac498ae$var$Zob(a) {
    $61de1ee1cac498ae$var$zob.call(this, a);
    this.a = a;
}
function $61de1ee1cac498ae$var$Xy() {
    $61de1ee1cac498ae$var$Py(this);
    $61de1ee1cac498ae$var$Ry(this);
    this._d();
}
function $61de1ee1cac498ae$var$Qv(a, b) {
    this.a = b;
    $61de1ee1cac498ae$var$Br.call(this, a);
}
function $61de1ee1cac498ae$var$au(a, b) {
    return new $61de1ee1cac498ae$var$xu(a.a, a.b, b);
}
function $61de1ee1cac498ae$var$kfb(a, b) {
    return a.lastIndexOf(b);
}
function $61de1ee1cac498ae$var$ifb(a, b, c) {
    return a.indexOf(b, c);
}
function $61de1ee1cac498ae$var$xfb(a) {
    return a == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(a);
}
function $61de1ee1cac498ae$var$nz(a) {
    return a == null ? null : a.name;
}
function $61de1ee1cac498ae$var$Etb(a) {
    return a.a != null ? a.a : null;
}
function $61de1ee1cac498ae$var$or(a) {
    return $61de1ee1cac498ae$var$Wsb(a.a) ? $61de1ee1cac498ae$var$nr(a) : null;
}
function $61de1ee1cac498ae$var$Fxb(a, b) {
    return $61de1ee1cac498ae$var$Jwb(a.a, b) != null;
}
function $61de1ee1cac498ae$var$uqb(a, b) {
    return !!b && a.b[b.g] == b;
}
function $61de1ee1cac498ae$var$FCb(a) {
    return a.$H || (a.$H = ++$61de1ee1cac498ae$var$ECb);
}
function $61de1ee1cac498ae$var$aD(a) {
    return a.l + a.m * $61de1ee1cac498ae$var$Hje + a.h * $61de1ee1cac498ae$var$Ije;
}
function $61de1ee1cac498ae$var$pDb(a, b) {
    $61de1ee1cac498ae$var$Ekb(b.a, a.a);
    return a.a;
}
function $61de1ee1cac498ae$var$vDb(a, b) {
    $61de1ee1cac498ae$var$Ekb(b.b, a.a);
    return a.a;
}
function $61de1ee1cac498ae$var$nGb(a, b) {
    $61de1ee1cac498ae$var$Ekb(b.a, a.a);
    return a.a;
}
function $61de1ee1cac498ae$var$Btb(a) {
    $61de1ee1cac498ae$var$sCb(a.a != null);
    return a.a;
}
function $61de1ee1cac498ae$var$Asb(a) {
    $61de1ee1cac498ae$var$Wqb.call(this, new $61de1ee1cac498ae$var$_rb(a));
}
function $61de1ee1cac498ae$var$GUb(a, b) {
    $61de1ee1cac498ae$var$HUb.call(this, a, b, null);
}
function $61de1ee1cac498ae$var$cxb(a) {
    this.a = a;
    $61de1ee1cac498ae$var$Bjb.call(this, a);
}
function $61de1ee1cac498ae$var$CKb() {
    $61de1ee1cac498ae$var$CKb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$BKb = new $61de1ee1cac498ae$var$Msd($61de1ee1cac498ae$var$tle, 0);
}
function $61de1ee1cac498ae$var$NFb(a, b) {
    ++a.b;
    return $61de1ee1cac498ae$var$Ekb(a.a, b);
}
function $61de1ee1cac498ae$var$OFb(a, b) {
    ++a.b;
    return $61de1ee1cac498ae$var$Lkb(a.a, b);
}
function $61de1ee1cac498ae$var$n6b(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.n.a, b.n.a);
}
function $61de1ee1cac498ae$var$WKb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.c.d, b.c.d);
}
function $61de1ee1cac498ae$var$gLb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.c.c, b.c.c);
}
function $61de1ee1cac498ae$var$zXb(a, b) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.b, b), 15);
}
function $61de1ee1cac498ae$var$s7b(a, b) {
    return a.n.b = ($61de1ee1cac498ae$var$uCb(b), b);
}
function $61de1ee1cac498ae$var$t7b(a, b) {
    return a.n.b = ($61de1ee1cac498ae$var$uCb(b), b);
}
function $61de1ee1cac498ae$var$a1b(a) {
    return $61de1ee1cac498ae$var$llb(a.a) || $61de1ee1cac498ae$var$llb(a.b);
}
function $61de1ee1cac498ae$var$fBc(a, b, c) {
    return $61de1ee1cac498ae$var$gBc(a, b, c, a.b);
}
function $61de1ee1cac498ae$var$iBc(a, b, c) {
    return $61de1ee1cac498ae$var$gBc(a, b, c, a.c);
}
function $61de1ee1cac498ae$var$i3c(a, b, c) {
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$B2c(a, b), 21).Fc(c);
}
function $61de1ee1cac498ae$var$xBd(a, b, c) {
    $61de1ee1cac498ae$var$vAd(a.a, c);
    $61de1ee1cac498ae$var$uAd(a.a, b);
}
function $61de1ee1cac498ae$var$qRd(a, b) {
    $61de1ee1cac498ae$var$nRd();
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$RRd(a, b) {
    $61de1ee1cac498ae$var$LRd();
    this.b = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$hhd(a, b) {
    $61de1ee1cac498ae$var$Rgd();
    this.f = b;
    this.d = a;
}
function $61de1ee1cac498ae$var$qc(a, b) {
    $61de1ee1cac498ae$var$Sb(b, a);
    this.d = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$n5b(a) {
    var b;
    b = a.a;
    a.a = a.b;
    a.b = b;
}
function $61de1ee1cac498ae$var$chc(a) {
    $61de1ee1cac498ae$var$Hgc();
    return !!a && !a.dc();
}
function $61de1ee1cac498ae$var$Afe(a) {
    ++$61de1ee1cac498ae$var$vfe;
    return new $61de1ee1cac498ae$var$lge(3, a);
}
function $61de1ee1cac498ae$var$jm(a, b) {
    return new $61de1ee1cac498ae$var$Vp(a, a.gc(), b);
}
function $61de1ee1cac498ae$var$ns(a) {
    $61de1ee1cac498ae$var$hs();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$qs(), $61de1ee1cac498ae$var$ps), a);
}
function $61de1ee1cac498ae$var$Oyd(a) {
    this.d = a;
    $61de1ee1cac498ae$var$Fyd.call(this, a);
}
function $61de1ee1cac498ae$var$$yd(a) {
    this.c = a;
    $61de1ee1cac498ae$var$Fyd.call(this, a);
}
function $61de1ee1cac498ae$var$bzd(a) {
    this.c = a;
    $61de1ee1cac498ae$var$Oyd.call(this, a);
}
function $61de1ee1cac498ae$var$sgc() {
    $61de1ee1cac498ae$var$qgc();
    this.b = new $61de1ee1cac498ae$var$ygc(this);
}
function $61de1ee1cac498ae$var$Pu(a) {
    $61de1ee1cac498ae$var$Xj(a, $61de1ee1cac498ae$var$Jie);
    return new $61de1ee1cac498ae$var$Skb(a);
}
function $61de1ee1cac498ae$var$Vz(a) {
    $61de1ee1cac498ae$var$Rz();
    return parseInt(a) || -1;
}
function $61de1ee1cac498ae$var$qfb(a, b, c) {
    return a.substr(b, c - b);
}
function $61de1ee1cac498ae$var$gfb(a, b, c) {
    return $61de1ee1cac498ae$var$ifb(a, $61de1ee1cac498ae$var$wfb(b), c);
}
function $61de1ee1cac498ae$var$Pkb(a) {
    return $61de1ee1cac498ae$var$ZBb(a.c, a.c.length);
}
function $61de1ee1cac498ae$var$Yr(a) {
    return a.f != null ? a.f : "" + a.g;
}
function $61de1ee1cac498ae$var$Zr(a) {
    return a.f != null ? a.f : "" + a.g;
}
function $61de1ee1cac498ae$var$Hsb(a) {
    $61de1ee1cac498ae$var$sCb(a.b != 0);
    return a.a.a.c;
}
function $61de1ee1cac498ae$var$Isb(a) {
    $61de1ee1cac498ae$var$sCb(a.b != 0);
    return a.c.b.c;
}
function $61de1ee1cac498ae$var$Cmd(a) {
    $61de1ee1cac498ae$var$JD(a, 150) && $61de1ee1cac498ae$var$BD(a, 150).Gh();
}
function $61de1ee1cac498ae$var$Wwb(a) {
    return a.b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$tib(a.a), 42);
}
function $61de1ee1cac498ae$var$Ptb(a) {
    $61de1ee1cac498ae$var$Ltb();
    this.b = a;
    this.a = true;
}
function $61de1ee1cac498ae$var$Xtb(a) {
    $61de1ee1cac498ae$var$Utb();
    this.b = a;
    this.a = true;
}
function $61de1ee1cac498ae$var$Trb(a) {
    a.d = new $61de1ee1cac498ae$var$ksb(a);
    a.e = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$mkb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
}
function $61de1ee1cac498ae$var$lCb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Vdb);
}
function $61de1ee1cac498ae$var$yCb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
}
function $61de1ee1cac498ae$var$qCb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$tcb);
}
function $61de1ee1cac498ae$var$sCb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
}
function $61de1ee1cac498ae$var$ksb(a) {
    $61de1ee1cac498ae$var$lsb.call(this, a, null, null);
}
function $61de1ee1cac498ae$var$dPb() {
    $61de1ee1cac498ae$var$$r.call(this, "POLYOMINO", 0);
}
function $61de1ee1cac498ae$var$Cg(a, b, c, d) {
    $61de1ee1cac498ae$var$qg.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$zkc(a, b) {
    $61de1ee1cac498ae$var$gkc();
    return $61de1ee1cac498ae$var$Rc(a, b.e, b);
}
function $61de1ee1cac498ae$var$azc(a, b, c) {
    $61de1ee1cac498ae$var$Vyc();
    return c.qg(a, b);
}
function $61de1ee1cac498ae$var$wNb(a, b) {
    return !!a.q && $61de1ee1cac498ae$var$Mhb(a.q, b);
}
function $61de1ee1cac498ae$var$JRb(a, b) {
    return a > 0 ? b * b / a : b * b * 100;
}
function $61de1ee1cac498ae$var$CRb(a, b) {
    return a > 0 ? b / (a * a) : b * 100;
}
function $61de1ee1cac498ae$var$G2c(a, b, c) {
    return $61de1ee1cac498ae$var$Ekb(b, $61de1ee1cac498ae$var$I2c(a, c));
}
function $61de1ee1cac498ae$var$t3c(a, b, c) {
    $61de1ee1cac498ae$var$p3c();
    a.Xe(b) && c.td(a);
}
function $61de1ee1cac498ae$var$St(a, b, c) {
    var d;
    d = a.Zc(b);
    d.Rb(c);
}
function $61de1ee1cac498ae$var$O6c(a, b, c) {
    a.a += b;
    a.b += c;
    return a;
}
function $61de1ee1cac498ae$var$Z6c(a, b, c) {
    a.a *= b;
    a.b *= c;
    return a;
}
function $61de1ee1cac498ae$var$b7c(a, b, c) {
    a.a -= b;
    a.b -= c;
    return a;
}
function $61de1ee1cac498ae$var$a7c(a, b) {
    a.a = b.a;
    a.b = b.b;
    return a;
}
function $61de1ee1cac498ae$var$V6c(a) {
    a.a = -a.a;
    a.b = -a.b;
    return a;
}
function $61de1ee1cac498ae$var$Dic(a) {
    this.c = a;
    this.a = 1;
    this.b = 1;
}
function $61de1ee1cac498ae$var$xed(a) {
    this.c = a;
    $61de1ee1cac498ae$var$dld(a, 0);
    $61de1ee1cac498ae$var$eld(a, 0);
}
function $61de1ee1cac498ae$var$u7c(a) {
    $61de1ee1cac498ae$var$Psb.call(this);
    $61de1ee1cac498ae$var$n7c(this, a);
}
function $61de1ee1cac498ae$var$AXb(a) {
    $61de1ee1cac498ae$var$xXb();
    $61de1ee1cac498ae$var$yXb(this);
    this.mf(a);
}
function $61de1ee1cac498ae$var$GRd(a, b) {
    $61de1ee1cac498ae$var$nRd();
    $61de1ee1cac498ae$var$qRd.call(this, a, b);
}
function $61de1ee1cac498ae$var$dSd(a, b) {
    $61de1ee1cac498ae$var$LRd();
    $61de1ee1cac498ae$var$RRd.call(this, a, b);
}
function $61de1ee1cac498ae$var$hSd(a, b) {
    $61de1ee1cac498ae$var$LRd();
    $61de1ee1cac498ae$var$RRd.call(this, a, b);
}
function $61de1ee1cac498ae$var$fSd(a, b) {
    $61de1ee1cac498ae$var$LRd();
    $61de1ee1cac498ae$var$dSd.call(this, a, b);
}
function $61de1ee1cac498ae$var$sId(a, b, c) {
    $61de1ee1cac498ae$var$dId.call(this, a, b, c, 2);
}
function $61de1ee1cac498ae$var$zXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$nXd.call(this, a, b);
}
function $61de1ee1cac498ae$var$BXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$zXd.call(this, a, b);
}
function $61de1ee1cac498ae$var$DXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$zXd.call(this, a, b);
}
function $61de1ee1cac498ae$var$FXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$DXd.call(this, a, b);
}
function $61de1ee1cac498ae$var$PXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$nXd.call(this, a, b);
}
function $61de1ee1cac498ae$var$RXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$PXd.call(this, a, b);
}
function $61de1ee1cac498ae$var$XXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$nXd.call(this, a, b);
}
function $61de1ee1cac498ae$var$pAd(a, b) {
    return a.c.Fc($61de1ee1cac498ae$var$BD(b, 133));
}
function $61de1ee1cac498ae$var$w1d(a, b, c) {
    return $61de1ee1cac498ae$var$V1d($61de1ee1cac498ae$var$p1d(a, b), c);
}
function $61de1ee1cac498ae$var$N2d(a, b, c) {
    return b.Qk(a.e, a.c, c);
}
function $61de1ee1cac498ae$var$P2d(a, b, c) {
    return b.Rk(a.e, a.c, c);
}
function $61de1ee1cac498ae$var$a3d(a, b) {
    return $61de1ee1cac498ae$var$xid(a.e, $61de1ee1cac498ae$var$BD(b, 49));
}
function $61de1ee1cac498ae$var$aTd(a, b, c) {
    $61de1ee1cac498ae$var$vtd($61de1ee1cac498ae$var$QSd(a.a), b, $61de1ee1cac498ae$var$eTd(c));
}
function $61de1ee1cac498ae$var$TOd(a, b, c) {
    $61de1ee1cac498ae$var$vtd($61de1ee1cac498ae$var$VKd(a.a), b, $61de1ee1cac498ae$var$XOd(c));
}
function $61de1ee1cac498ae$var$ypb(a, b) {
    b.$modCount = a.$modCount;
}
function $61de1ee1cac498ae$var$MUc() {
    $61de1ee1cac498ae$var$MUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$LUc = new $61de1ee1cac498ae$var$Lsd("root");
}
function $61de1ee1cac498ae$var$LCd() {
    $61de1ee1cac498ae$var$LCd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$KCd = new $61de1ee1cac498ae$var$lDd;
    new $61de1ee1cac498ae$var$NDd;
}
function $61de1ee1cac498ae$var$KVc() {
    this.a = new $61de1ee1cac498ae$var$Hp;
    this.b = new $61de1ee1cac498ae$var$Hp;
}
function $61de1ee1cac498ae$var$FUd() {
    $61de1ee1cac498ae$var$hJd.call(this);
    this.Bb |= $61de1ee1cac498ae$var$Tje;
}
function $61de1ee1cac498ae$var$t_c() {
    $61de1ee1cac498ae$var$$r.call(this, "GROW_TREE", 0);
}
function $61de1ee1cac498ae$var$C9d(a) {
    return a == null ? null : $61de1ee1cac498ae$var$cde(a);
}
function $61de1ee1cac498ae$var$G9d(a) {
    return a == null ? null : $61de1ee1cac498ae$var$jde(a);
}
function $61de1ee1cac498ae$var$J9d(a) {
    return a == null ? null : $61de1ee1cac498ae$var$fcb(a);
}
function $61de1ee1cac498ae$var$K9d(a) {
    return a == null ? null : $61de1ee1cac498ae$var$fcb(a);
}
function $61de1ee1cac498ae$var$fdb(a) {
    if (a.o != null) return;
    $61de1ee1cac498ae$var$vdb(a);
}
function $61de1ee1cac498ae$var$DD(a) {
    $61de1ee1cac498ae$var$CCb(a == null || $61de1ee1cac498ae$var$KD(a));
    return a;
}
function $61de1ee1cac498ae$var$ED(a) {
    $61de1ee1cac498ae$var$CCb(a == null || $61de1ee1cac498ae$var$LD(a));
    return a;
}
function $61de1ee1cac498ae$var$GD(a) {
    $61de1ee1cac498ae$var$CCb(a == null || $61de1ee1cac498ae$var$ND(a));
    return a;
}
function $61de1ee1cac498ae$var$gB(a) {
    this.q = new $61de1ee1cac498ae$var$$wnd.Date($61de1ee1cac498ae$var$Sbb(a));
}
function $61de1ee1cac498ae$var$Mf(a, b) {
    this.c = a;
    $61de1ee1cac498ae$var$ne.call(this, a, b);
}
function $61de1ee1cac498ae$var$Sf(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$Mf.call(this, a, b);
}
function $61de1ee1cac498ae$var$Hg(a, b) {
    this.d = a;
    $61de1ee1cac498ae$var$Dg(this);
    this.b = b;
}
function $61de1ee1cac498ae$var$bAb(a, b) {
    $61de1ee1cac498ae$var$Vzb.call(this, a);
    this.a = b;
}
function $61de1ee1cac498ae$var$vAb(a, b) {
    $61de1ee1cac498ae$var$Vzb.call(this, a);
    this.a = b;
}
function $61de1ee1cac498ae$var$sNb(a) {
    $61de1ee1cac498ae$var$pNb.call(this, 0, 0);
    this.f = a;
}
function $61de1ee1cac498ae$var$Vg(a, b, c) {
    $61de1ee1cac498ae$var$dg.call(this, a, b, c, null);
}
function $61de1ee1cac498ae$var$Yg(a, b, c) {
    $61de1ee1cac498ae$var$dg.call(this, a, b, c, null);
}
function $61de1ee1cac498ae$var$Pxb(a, b, c) {
    return a.ue(b, c) <= 0 ? c : b;
}
function $61de1ee1cac498ae$var$Qxb(a, b, c) {
    return a.ue(b, c) <= 0 ? b : c;
}
function $61de1ee1cac498ae$var$g4c(a, b) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(a.b, b), 149);
}
function $61de1ee1cac498ae$var$i4c(a, b) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(a.c, b), 229);
}
function $61de1ee1cac498ae$var$wic(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, a.b), 287);
}
function $61de1ee1cac498ae$var$B6c(a) {
    return new $61de1ee1cac498ae$var$f7c(a.c, a.d + a.a);
}
function $61de1ee1cac498ae$var$eLc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$Jzc($61de1ee1cac498ae$var$BD(a, 197));
}
function $61de1ee1cac498ae$var$$Jb() {
    $61de1ee1cac498ae$var$$Jb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ZJb = $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd));
}
function $61de1ee1cac498ae$var$fOb(a, b) {
    b.a ? $61de1ee1cac498ae$var$gOb(a, b) : $61de1ee1cac498ae$var$Fxb(a.a, b.b);
}
function $61de1ee1cac498ae$var$qyb(a, b) {
    if ($61de1ee1cac498ae$var$lyb) return;
    $61de1ee1cac498ae$var$Ekb(a.a, b);
}
function $61de1ee1cac498ae$var$F2b(a, b) {
    $61de1ee1cac498ae$var$x2b();
    return $61de1ee1cac498ae$var$f_b(b.d.i, a);
}
function $61de1ee1cac498ae$var$_9b(a, b) {
    $61de1ee1cac498ae$var$I9b();
    return new $61de1ee1cac498ae$var$gac(b, a);
}
function $61de1ee1cac498ae$var$_Hb(a, b) {
    $61de1ee1cac498ae$var$ytb(b, $61de1ee1cac498ae$var$lle);
    a.f = b;
    return a;
}
function $61de1ee1cac498ae$var$Kld(a, b, c) {
    c = $61de1ee1cac498ae$var$_hd(a, b, 3, c);
    return c;
}
function $61de1ee1cac498ae$var$bmd(a, b, c) {
    c = $61de1ee1cac498ae$var$_hd(a, b, 6, c);
    return c;
}
function $61de1ee1cac498ae$var$kpd(a, b, c) {
    c = $61de1ee1cac498ae$var$_hd(a, b, 9, c);
    return c;
}
function $61de1ee1cac498ae$var$Cvd(a, b, c) {
    ++a.j;
    a.Ki();
    $61de1ee1cac498ae$var$Atd(a, b, c);
}
function $61de1ee1cac498ae$var$Avd(a, b, c) {
    ++a.j;
    a.Hi(b, a.oi(b, c));
}
function $61de1ee1cac498ae$var$bRd(a, b, c) {
    var d;
    d = a.Zc(b);
    d.Rb(c);
}
function $61de1ee1cac498ae$var$c7d(a, b, c) {
    return $61de1ee1cac498ae$var$C2d(a.c, a.b, b, c);
}
function $61de1ee1cac498ae$var$DAd(a, b) {
    return (b & $61de1ee1cac498ae$var$Ohe) % a.d.length;
}
function $61de1ee1cac498ae$var$Msd(a, b) {
    $61de1ee1cac498ae$var$Lsd.call(this, a);
    this.a = b;
}
function $61de1ee1cac498ae$var$uVd(a, b) {
    $61de1ee1cac498ae$var$lVd.call(this, a);
    this.a = b;
}
function $61de1ee1cac498ae$var$sYd(a, b) {
    $61de1ee1cac498ae$var$lVd.call(this, a);
    this.a = b;
}
function $61de1ee1cac498ae$var$zyd(a, b) {
    this.c = a;
    $61de1ee1cac498ae$var$zud.call(this, b);
}
function $61de1ee1cac498ae$var$YOd(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$qOd.call(this, b);
}
function $61de1ee1cac498ae$var$fTd(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$qOd.call(this, b);
}
function $61de1ee1cac498ae$var$Xp(a) {
    this.a = ($61de1ee1cac498ae$var$Xj(a, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(a));
}
function $61de1ee1cac498ae$var$cq(a) {
    this.a = ($61de1ee1cac498ae$var$Xj(a, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(a));
}
function $61de1ee1cac498ae$var$LA(a) {
    !a.a && (a.a = new $61de1ee1cac498ae$var$VA);
    return a.a;
}
function $61de1ee1cac498ae$var$XMb(a) {
    if (a > 8) return 0;
    return a + 1;
}
function $61de1ee1cac498ae$var$Ecb(a, b) {
    $61de1ee1cac498ae$var$Bcb();
    return a == b ? 0 : a ? 1 : -1;
}
function $61de1ee1cac498ae$var$Opb(a, b, c) {
    return $61de1ee1cac498ae$var$Npb(a, $61de1ee1cac498ae$var$BD(b, 22), c);
}
function $61de1ee1cac498ae$var$Bz(a, b, c) {
    var d;
    return a.apply(b, c);
}
function $61de1ee1cac498ae$var$Sfb(a, b, c) {
    a.a += $61de1ee1cac498ae$var$zfb(b, 0, c);
    return a;
}
function $61de1ee1cac498ae$var$ijb(a, b) {
    var c;
    c = a.e;
    a.e = b;
    return c;
}
function $61de1ee1cac498ae$var$trb(a, b) {
    var c;
    c = a[$61de1ee1cac498ae$var$hke];
    c.call(a, b);
}
function $61de1ee1cac498ae$var$urb(a, b) {
    var c;
    c = a[$61de1ee1cac498ae$var$hke];
    c.call(a, b);
}
function $61de1ee1cac498ae$var$Aib(a, b) {
    a.a.Vc(a.b, b);
    ++a.b;
    a.c = -1;
}
function $61de1ee1cac498ae$var$Urb(a) {
    $61de1ee1cac498ae$var$Uhb(a.e);
    a.d.b = a.d;
    a.d.a = a.d;
}
function $61de1ee1cac498ae$var$_f(a) {
    a.b ? $61de1ee1cac498ae$var$_f(a.b) : a.f.c.zc(a.e, a.d);
}
function $61de1ee1cac498ae$var$_Ab(a, b, c) {
    $61de1ee1cac498ae$var$EAb();
    $61de1ee1cac498ae$var$MBb(a, b.Ce(a.a, c));
}
function $61de1ee1cac498ae$var$Bxb(a, b) {
    return $61de1ee1cac498ae$var$Vd($61de1ee1cac498ae$var$Cwb(a.a, b, true));
}
function $61de1ee1cac498ae$var$Cxb(a, b) {
    return $61de1ee1cac498ae$var$Vd($61de1ee1cac498ae$var$Dwb(a.a, b, true));
}
function $61de1ee1cac498ae$var$_Bb(a, b) {
    return $61de1ee1cac498ae$var$eCb(new Array(b), a);
}
function $61de1ee1cac498ae$var$HD(a) {
    return String.fromCharCode(a);
}
function $61de1ee1cac498ae$var$mz(a) {
    return a == null ? null : a.message;
}
function $61de1ee1cac498ae$var$gRb() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.b = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$iTb() {
    this.a = new $61de1ee1cac498ae$var$MQb;
    this.b = new $61de1ee1cac498ae$var$tTb;
}
function $61de1ee1cac498ae$var$tDb() {
    this.b = new $61de1ee1cac498ae$var$d7c;
    this.c = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$_Qb() {
    this.d = new $61de1ee1cac498ae$var$d7c;
    this.e = new $61de1ee1cac498ae$var$d7c;
}
function $61de1ee1cac498ae$var$n_b() {
    this.n = new $61de1ee1cac498ae$var$d7c;
    this.o = new $61de1ee1cac498ae$var$d7c;
}
function $61de1ee1cac498ae$var$$Gb() {
    this.n = new $61de1ee1cac498ae$var$p0b;
    this.i = new $61de1ee1cac498ae$var$I6c;
}
function $61de1ee1cac498ae$var$sec() {
    this.a = new $61de1ee1cac498ae$var$Umc;
    this.b = new $61de1ee1cac498ae$var$mnc;
}
function $61de1ee1cac498ae$var$NIc() {
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.d = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$LDc() {
    this.b = new $61de1ee1cac498ae$var$Tqb;
    this.a = new $61de1ee1cac498ae$var$Tqb;
}
function $61de1ee1cac498ae$var$hSc() {
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.a = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$HRc() {
    this.b = new $61de1ee1cac498ae$var$tRc;
    this.a = new $61de1ee1cac498ae$var$hRc;
}
function $61de1ee1cac498ae$var$aHb() {
    $61de1ee1cac498ae$var$$Gb.call(this);
    this.a = new $61de1ee1cac498ae$var$d7c;
}
function $61de1ee1cac498ae$var$Ywb(a) {
    $61de1ee1cac498ae$var$Zwb.call(this, a, ($61de1ee1cac498ae$var$lxb(), $61de1ee1cac498ae$var$hxb));
}
function $61de1ee1cac498ae$var$J_b(a, b, c, d) {
    $61de1ee1cac498ae$var$B_b.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$sqd(a, b, c) {
    c != null && $61de1ee1cac498ae$var$kmd(b, $61de1ee1cac498ae$var$Wqd(a, c));
}
function $61de1ee1cac498ae$var$tqd(a, b, c) {
    c != null && $61de1ee1cac498ae$var$lmd(b, $61de1ee1cac498ae$var$Wqd(a, c));
}
function $61de1ee1cac498ae$var$Tod(a, b, c) {
    c = $61de1ee1cac498ae$var$_hd(a, b, 11, c);
    return c;
}
function $61de1ee1cac498ae$var$P6c(a, b) {
    a.a += b.a;
    a.b += b.b;
    return a;
}
function $61de1ee1cac498ae$var$c7c(a, b) {
    a.a -= b.a;
    a.b -= b.b;
    return a;
}
function $61de1ee1cac498ae$var$u7b(a, b) {
    return a.n.a = ($61de1ee1cac498ae$var$uCb(b), b) + 10;
}
function $61de1ee1cac498ae$var$v7b(a, b) {
    return a.n.a = ($61de1ee1cac498ae$var$uCb(b), b) + 10;
}
function $61de1ee1cac498ae$var$dLd(a, b) {
    return b == a || $61de1ee1cac498ae$var$pud($61de1ee1cac498ae$var$UKd(b), a);
}
function $61de1ee1cac498ae$var$PYd(a, b) {
    return $61de1ee1cac498ae$var$Rhb(a.a, b, "") == null;
}
function $61de1ee1cac498ae$var$E2b(a, b) {
    $61de1ee1cac498ae$var$x2b();
    return !$61de1ee1cac498ae$var$f_b(b.d.i, a);
}
function $61de1ee1cac498ae$var$rjc(a, b) {
    $61de1ee1cac498ae$var$fad(a.f) ? $61de1ee1cac498ae$var$sjc(a, b) : $61de1ee1cac498ae$var$tjc(a, b);
}
function $61de1ee1cac498ae$var$h1d(a, b) {
    var c;
    c = b.Hh(a.a);
    return c;
}
function $61de1ee1cac498ae$var$Cyd(a, b) {
    $61de1ee1cac498ae$var$qcb.call(this, $61de1ee1cac498ae$var$gve + a + $61de1ee1cac498ae$var$mue + b);
}
function $61de1ee1cac498ae$var$gUd(a, b, c, d) {
    $61de1ee1cac498ae$var$cUd.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$Q4d(a, b, c, d) {
    $61de1ee1cac498ae$var$cUd.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$U4d(a, b, c, d) {
    $61de1ee1cac498ae$var$Q4d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$n5d(a, b, c, d) {
    $61de1ee1cac498ae$var$i5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$p5d(a, b, c, d) {
    $61de1ee1cac498ae$var$i5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$v5d(a, b, c, d) {
    $61de1ee1cac498ae$var$i5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$t5d(a, b, c, d) {
    $61de1ee1cac498ae$var$p5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$A5d(a, b, c, d) {
    $61de1ee1cac498ae$var$p5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$y5d(a, b, c, d) {
    $61de1ee1cac498ae$var$v5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$D5d(a, b, c, d) {
    $61de1ee1cac498ae$var$A5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$d6d(a, b, c, d) {
    $61de1ee1cac498ae$var$Y5d.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$Vp(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$qc.call(this, b, c);
}
function $61de1ee1cac498ae$var$tk(a, b, c) {
    this.c = b;
    this.b = c;
    this.a = a;
}
function $61de1ee1cac498ae$var$ik(a, b, c) {
    return a.d = $61de1ee1cac498ae$var$BD(b.Kb(c), 164);
}
function $61de1ee1cac498ae$var$j6d(a, b) {
    return a.Aj().Nh().Kh(a, b);
}
function $61de1ee1cac498ae$var$h6d(a, b) {
    return a.Aj().Nh().Ih(a, b);
}
function $61de1ee1cac498ae$var$Fdb(a, b) {
    return $61de1ee1cac498ae$var$uCb(a), $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b);
}
function $61de1ee1cac498ae$var$dfb(a, b) {
    return $61de1ee1cac498ae$var$uCb(a), $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b);
}
function $61de1ee1cac498ae$var$Dxb(a, b) {
    return $61de1ee1cac498ae$var$Vd($61de1ee1cac498ae$var$Cwb(a.a, b, false));
}
function $61de1ee1cac498ae$var$Exb(a, b) {
    return $61de1ee1cac498ae$var$Vd($61de1ee1cac498ae$var$Dwb(a.a, b, false));
}
function $61de1ee1cac498ae$var$vBb(a, b) {
    return a.b.sd(new $61de1ee1cac498ae$var$yBb(a, b));
}
function $61de1ee1cac498ae$var$BBb(a, b) {
    return a.b.sd(new $61de1ee1cac498ae$var$EBb(a, b));
}
function $61de1ee1cac498ae$var$HBb(a, b) {
    return a.b.sd(new $61de1ee1cac498ae$var$KBb(a, b));
}
function $61de1ee1cac498ae$var$lfb(a, b, c) {
    return a.lastIndexOf(b, c);
}
function $61de1ee1cac498ae$var$uTb(a, b, c) {
    return $61de1ee1cac498ae$var$Kdb(a[b.b], a[c.b]);
}
function $61de1ee1cac498ae$var$RTb(a, b) {
    return $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Cwc), a);
}
function $61de1ee1cac498ae$var$fmc(a, b) {
    return $61de1ee1cac498ae$var$beb(b.a.d.p, a.a.d.p);
}
function $61de1ee1cac498ae$var$emc(a, b) {
    return $61de1ee1cac498ae$var$beb(a.a.d.p, b.a.d.p);
}
function $61de1ee1cac498ae$var$_Oc(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.c - a.s, b.c - b.s);
}
function $61de1ee1cac498ae$var$S_b(a) {
    return !a.c ? -1 : $61de1ee1cac498ae$var$Jkb(a.c.a, a, 0);
}
function $61de1ee1cac498ae$var$Vxd(a) {
    return a < 100 ? null : new $61de1ee1cac498ae$var$Ixd(a);
}
function $61de1ee1cac498ae$var$ecd(a) {
    return a == $61de1ee1cac498ae$var$Zbd || a == $61de1ee1cac498ae$var$_bd || a == $61de1ee1cac498ae$var$$bd;
}
function $61de1ee1cac498ae$var$zAd(a, b) {
    return $61de1ee1cac498ae$var$JD(b, 15) && $61de1ee1cac498ae$var$Btd(a.c, b);
}
function $61de1ee1cac498ae$var$vyb(a, b) {
    if ($61de1ee1cac498ae$var$lyb) return;
    !!b && (a.d = b);
}
function $61de1ee1cac498ae$var$ujb(a, b) {
    var c;
    c = b;
    return !!$61de1ee1cac498ae$var$Awb(a, c);
}
function $61de1ee1cac498ae$var$czd(a, b) {
    this.c = a;
    $61de1ee1cac498ae$var$Pyd.call(this, a, b);
}
function $61de1ee1cac498ae$var$fBb(a) {
    this.c = a;
    $61de1ee1cac498ae$var$nvb.call(this, $61de1ee1cac498ae$var$rie, 0);
}
function $61de1ee1cac498ae$var$Avb(a, b) {
    $61de1ee1cac498ae$var$Bvb.call(this, a, a.length, b);
}
function $61de1ee1cac498ae$var$aId(a, b, c) {
    return $61de1ee1cac498ae$var$BD(a.c, 69).lk(b, c);
}
function $61de1ee1cac498ae$var$bId(a, b, c) {
    return $61de1ee1cac498ae$var$BD(a.c, 69).mk(b, c);
}
function $61de1ee1cac498ae$var$O2d(a, b, c) {
    return $61de1ee1cac498ae$var$N2d(a, $61de1ee1cac498ae$var$BD(b, 332), c);
}
function $61de1ee1cac498ae$var$Q2d(a, b, c) {
    return $61de1ee1cac498ae$var$P2d(a, $61de1ee1cac498ae$var$BD(b, 332), c);
}
function $61de1ee1cac498ae$var$i3d(a, b, c) {
    return $61de1ee1cac498ae$var$h3d(a, $61de1ee1cac498ae$var$BD(b, 332), c);
}
function $61de1ee1cac498ae$var$k3d(a, b, c) {
    return $61de1ee1cac498ae$var$j3d(a, $61de1ee1cac498ae$var$BD(b, 332), c);
}
function $61de1ee1cac498ae$var$tn(a, b) {
    return b == null ? null : $61de1ee1cac498ae$var$Hv(a.b, b);
}
function $61de1ee1cac498ae$var$Kcb(a) {
    return $61de1ee1cac498ae$var$LD(a) ? ($61de1ee1cac498ae$var$uCb(a), a) : a.ke();
}
function $61de1ee1cac498ae$var$Ldb(a) {
    return !isNaN(a) && !isFinite(a);
}
function $61de1ee1cac498ae$var$Wn(a) {
    $61de1ee1cac498ae$var$Ql();
    this.a = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$zob(a));
}
function $61de1ee1cac498ae$var$dIc(a) {
    $61de1ee1cac498ae$var$FHc();
    this.d = a;
    this.a = new $61de1ee1cac498ae$var$jkb;
}
function $61de1ee1cac498ae$var$xqb(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$Nrb(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$$sb(a, b, c) {
    this.d = a;
    this.b = c;
    this.a = b;
}
function $61de1ee1cac498ae$var$Qsb(a) {
    $61de1ee1cac498ae$var$Csb(this);
    $61de1ee1cac498ae$var$Osb(this);
    $61de1ee1cac498ae$var$ye(this, a);
}
function $61de1ee1cac498ae$var$Tkb(a) {
    $61de1ee1cac498ae$var$Ckb(this);
    $61de1ee1cac498ae$var$bCb(this.c, 0, a.Pc());
}
function $61de1ee1cac498ae$var$Xwb(a) {
    $61de1ee1cac498ae$var$uib(a.a);
    $61de1ee1cac498ae$var$Kwb(a.c, a.b);
    a.b = null;
}
function $61de1ee1cac498ae$var$iyb(a) {
    this.a = a;
    $61de1ee1cac498ae$var$Zfb();
    $61de1ee1cac498ae$var$Cbb(Date.now());
}
function $61de1ee1cac498ae$var$JCb() {
    $61de1ee1cac498ae$var$JCb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$GCb = new $61de1ee1cac498ae$var$nb;
    $61de1ee1cac498ae$var$ICb = new $61de1ee1cac498ae$var$nb;
}
function $61de1ee1cac498ae$var$ntb() {
    $61de1ee1cac498ae$var$ntb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ltb = new $61de1ee1cac498ae$var$otb;
    $61de1ee1cac498ae$var$mtb = new $61de1ee1cac498ae$var$qtb;
}
function $61de1ee1cac498ae$var$kzd() {
    $61de1ee1cac498ae$var$kzd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$jzd = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
}
function $61de1ee1cac498ae$var$tGd() {
    $61de1ee1cac498ae$var$tGd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$sGd = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
}
function $61de1ee1cac498ae$var$$Gd() {
    $61de1ee1cac498ae$var$$Gd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ZGd = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
}
function $61de1ee1cac498ae$var$Ql() {
    $61de1ee1cac498ae$var$Ql = $61de1ee1cac498ae$var$ccb;
    new $61de1ee1cac498ae$var$Zl(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb));
}
function $61de1ee1cac498ae$var$pxb(a) {
    $61de1ee1cac498ae$var$lxb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$zxb(), $61de1ee1cac498ae$var$yxb), a);
}
function $61de1ee1cac498ae$var$Hyb(a) {
    $61de1ee1cac498ae$var$Fyb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Kyb(), $61de1ee1cac498ae$var$Jyb), a);
}
function $61de1ee1cac498ae$var$OEb(a) {
    $61de1ee1cac498ae$var$MEb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$REb(), $61de1ee1cac498ae$var$QEb), a);
}
function $61de1ee1cac498ae$var$WEb(a) {
    $61de1ee1cac498ae$var$UEb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$ZEb(), $61de1ee1cac498ae$var$YEb), a);
}
function $61de1ee1cac498ae$var$tFb(a) {
    $61de1ee1cac498ae$var$rFb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$wFb(), $61de1ee1cac498ae$var$vFb), a);
}
function $61de1ee1cac498ae$var$iHb(a) {
    $61de1ee1cac498ae$var$gHb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$lHb(), $61de1ee1cac498ae$var$kHb), a);
}
function $61de1ee1cac498ae$var$PHb(a) {
    $61de1ee1cac498ae$var$NHb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$SHb(), $61de1ee1cac498ae$var$RHb), a);
}
function $61de1ee1cac498ae$var$GIb(a) {
    $61de1ee1cac498ae$var$EIb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$JIb(), $61de1ee1cac498ae$var$IIb), a);
}
function $61de1ee1cac498ae$var$vJb(a) {
    $61de1ee1cac498ae$var$qJb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$yJb(), $61de1ee1cac498ae$var$xJb), a);
}
function $61de1ee1cac498ae$var$xLb(a) {
    $61de1ee1cac498ae$var$vLb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$ALb(), $61de1ee1cac498ae$var$zLb), a);
}
function $61de1ee1cac498ae$var$TMb(a) {
    $61de1ee1cac498ae$var$RMb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$WMb(), $61de1ee1cac498ae$var$VMb), a);
}
function $61de1ee1cac498ae$var$TOb(a) {
    $61de1ee1cac498ae$var$ROb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$WOb(), $61de1ee1cac498ae$var$VOb), a);
}
function $61de1ee1cac498ae$var$ePb(a) {
    $61de1ee1cac498ae$var$cPb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$hPb(), $61de1ee1cac498ae$var$gPb), a);
}
function $61de1ee1cac498ae$var$ZRb(a) {
    $61de1ee1cac498ae$var$XRb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$aSb(), $61de1ee1cac498ae$var$_Rb), a);
}
function $61de1ee1cac498ae$var$ATb(a) {
    $61de1ee1cac498ae$var$yTb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$DTb(), $61de1ee1cac498ae$var$CTb), a);
}
function $61de1ee1cac498ae$var$sUb(a) {
    $61de1ee1cac498ae$var$qUb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$vUb(), $61de1ee1cac498ae$var$uUb), a);
}
function $61de1ee1cac498ae$var$rWb(a) {
    $61de1ee1cac498ae$var$lWb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$uWb(), $61de1ee1cac498ae$var$tWb), a);
}
function $61de1ee1cac498ae$var$TXb(a) {
    $61de1ee1cac498ae$var$RXb();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$WXb(), $61de1ee1cac498ae$var$VXb), a);
}
function $61de1ee1cac498ae$var$Mb(a, b) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb(b));
}
function $61de1ee1cac498ae$var$l0b(a) {
    $61de1ee1cac498ae$var$j0b();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$o0b(), $61de1ee1cac498ae$var$n0b), a);
}
function $61de1ee1cac498ae$var$r0b(a) {
    $61de1ee1cac498ae$var$B_b.call(this, a.d, a.c, a.a, a.b);
}
function $61de1ee1cac498ae$var$K_b(a) {
    $61de1ee1cac498ae$var$B_b.call(this, a.d, a.c, a.a, a.b);
}
function $61de1ee1cac498ae$var$mKb(a, b, c) {
    this.b = a;
    this.c = b;
    this.a = c;
}
function $61de1ee1cac498ae$var$BZb(a, b, c) {
    this.b = a;
    this.a = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$TNb(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$uOb(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$S3b(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$Z6b(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$n9b(a, b, c) {
    this.b = a;
    this.a = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$x$b(a, b, c) {
    this.e = b;
    this.b = a;
    this.d = c;
}
function $61de1ee1cac498ae$var$$Ab(a, b, c) {
    $61de1ee1cac498ae$var$EAb();
    a.a.Od(b, c);
    return b;
}
function $61de1ee1cac498ae$var$LGb(a) {
    var b;
    b = new $61de1ee1cac498ae$var$KGb;
    b.e = a;
    return b;
}
function $61de1ee1cac498ae$var$iLb(a) {
    var b;
    b = new $61de1ee1cac498ae$var$fLb;
    b.b = a;
    return b;
}
function $61de1ee1cac498ae$var$D6b() {
    $61de1ee1cac498ae$var$D6b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$B6b = new $61de1ee1cac498ae$var$M6b;
    $61de1ee1cac498ae$var$C6b = new $61de1ee1cac498ae$var$P6b;
}
function $61de1ee1cac498ae$var$Hgc() {
    $61de1ee1cac498ae$var$Hgc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Fgc = new $61de1ee1cac498ae$var$ghc;
    $61de1ee1cac498ae$var$Ggc = new $61de1ee1cac498ae$var$ihc;
}
function $61de1ee1cac498ae$var$jbc(a) {
    $61de1ee1cac498ae$var$gbc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$mbc(), $61de1ee1cac498ae$var$lbc), a);
}
function $61de1ee1cac498ae$var$Cjc(a) {
    $61de1ee1cac498ae$var$Ajc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Fjc(), $61de1ee1cac498ae$var$Ejc), a);
}
function $61de1ee1cac498ae$var$Clc(a) {
    $61de1ee1cac498ae$var$Alc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Flc(), $61de1ee1cac498ae$var$Elc), a);
}
function $61de1ee1cac498ae$var$Cpc(a) {
    $61de1ee1cac498ae$var$Apc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Fpc(), $61de1ee1cac498ae$var$Epc), a);
}
function $61de1ee1cac498ae$var$Kpc(a) {
    $61de1ee1cac498ae$var$Ipc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Npc(), $61de1ee1cac498ae$var$Mpc), a);
}
function $61de1ee1cac498ae$var$Wpc(a) {
    $61de1ee1cac498ae$var$Rpc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Zpc(), $61de1ee1cac498ae$var$Ypc), a);
}
function $61de1ee1cac498ae$var$$jc(a) {
    $61de1ee1cac498ae$var$Xjc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$bkc(), $61de1ee1cac498ae$var$akc), a);
}
function $61de1ee1cac498ae$var$Hkc(a) {
    $61de1ee1cac498ae$var$Fkc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Kkc(), $61de1ee1cac498ae$var$Jkc), a);
}
function $61de1ee1cac498ae$var$dqc(a) {
    $61de1ee1cac498ae$var$bqc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$gqc(), $61de1ee1cac498ae$var$fqc), a);
}
function $61de1ee1cac498ae$var$rqc(a) {
    $61de1ee1cac498ae$var$mqc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$uqc(), $61de1ee1cac498ae$var$tqc), a);
}
function $61de1ee1cac498ae$var$zqc(a) {
    $61de1ee1cac498ae$var$xqc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Cqc(), $61de1ee1cac498ae$var$Bqc), a);
}
function $61de1ee1cac498ae$var$Iqc(a) {
    $61de1ee1cac498ae$var$Gqc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Lqc(), $61de1ee1cac498ae$var$Kqc), a);
}
function $61de1ee1cac498ae$var$Vqc(a) {
    $61de1ee1cac498ae$var$Sqc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Yqc(), $61de1ee1cac498ae$var$Xqc), a);
}
function $61de1ee1cac498ae$var$brc(a) {
    $61de1ee1cac498ae$var$_qc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$erc(), $61de1ee1cac498ae$var$drc), a);
}
function $61de1ee1cac498ae$var$nrc(a) {
    $61de1ee1cac498ae$var$lrc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$qrc(), $61de1ee1cac498ae$var$prc), a);
}
function $61de1ee1cac498ae$var$Arc(a) {
    $61de1ee1cac498ae$var$yrc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Drc(), $61de1ee1cac498ae$var$Crc), a);
}
function $61de1ee1cac498ae$var$Qrc(a) {
    $61de1ee1cac498ae$var$Orc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Trc(), $61de1ee1cac498ae$var$Src), a);
}
function $61de1ee1cac498ae$var$Zrc(a) {
    $61de1ee1cac498ae$var$Xrc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$asc(), $61de1ee1cac498ae$var$_rc), a);
}
function $61de1ee1cac498ae$var$gsc(a) {
    $61de1ee1cac498ae$var$esc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$jsc(), $61de1ee1cac498ae$var$isc), a);
}
function $61de1ee1cac498ae$var$osc(a) {
    $61de1ee1cac498ae$var$msc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$rsc(), $61de1ee1cac498ae$var$qsc), a);
}
function $61de1ee1cac498ae$var$Etc(a) {
    $61de1ee1cac498ae$var$Ctc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Htc(), $61de1ee1cac498ae$var$Gtc), a);
}
function $61de1ee1cac498ae$var$qzc(a) {
    $61de1ee1cac498ae$var$lzc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$tzc(), $61de1ee1cac498ae$var$szc), a);
}
function $61de1ee1cac498ae$var$Azc(a) {
    $61de1ee1cac498ae$var$xzc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Dzc(), $61de1ee1cac498ae$var$Czc), a);
}
function $61de1ee1cac498ae$var$Mzc(a) {
    $61de1ee1cac498ae$var$Izc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Pzc(), $61de1ee1cac498ae$var$Ozc), a);
}
function $61de1ee1cac498ae$var$MAc(a) {
    $61de1ee1cac498ae$var$KAc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$PAc(), $61de1ee1cac498ae$var$OAc), a);
}
function $61de1ee1cac498ae$var$mAc(a) {
    $61de1ee1cac498ae$var$kAc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$pAc(), $61de1ee1cac498ae$var$oAc), a);
}
function $61de1ee1cac498ae$var$vAc(a) {
    $61de1ee1cac498ae$var$tAc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$yAc(), $61de1ee1cac498ae$var$xAc), a);
}
function $61de1ee1cac498ae$var$DAc(a) {
    $61de1ee1cac498ae$var$BAc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$GAc(), $61de1ee1cac498ae$var$FAc), a);
}
function $61de1ee1cac498ae$var$VAc(a) {
    $61de1ee1cac498ae$var$TAc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$YAc(), $61de1ee1cac498ae$var$XAc), a);
}
function $61de1ee1cac498ae$var$$zc(a) {
    $61de1ee1cac498ae$var$Vzc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$bAc(), $61de1ee1cac498ae$var$aAc), a);
}
function $61de1ee1cac498ae$var$bBc(a) {
    $61de1ee1cac498ae$var$_Ac();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$eBc(), $61de1ee1cac498ae$var$dBc), a);
}
function $61de1ee1cac498ae$var$vBc(a) {
    $61de1ee1cac498ae$var$tBc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$yBc(), $61de1ee1cac498ae$var$xBc), a);
}
function $61de1ee1cac498ae$var$EBc(a) {
    $61de1ee1cac498ae$var$CBc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$HBc(), $61de1ee1cac498ae$var$GBc), a);
}
function $61de1ee1cac498ae$var$NBc(a) {
    $61de1ee1cac498ae$var$LBc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$QBc(), $61de1ee1cac498ae$var$PBc), a);
}
function $61de1ee1cac498ae$var$tGc(a) {
    $61de1ee1cac498ae$var$rGc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$wGc(), $61de1ee1cac498ae$var$vGc), a);
}
function $61de1ee1cac498ae$var$WIc(a) {
    $61de1ee1cac498ae$var$UIc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$ZIc(), $61de1ee1cac498ae$var$YIc), a);
}
function $61de1ee1cac498ae$var$$Lc(a) {
    $61de1ee1cac498ae$var$YLc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$bMc(), $61de1ee1cac498ae$var$aMc), a);
}
function $61de1ee1cac498ae$var$gMc(a) {
    $61de1ee1cac498ae$var$eMc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$jMc(), $61de1ee1cac498ae$var$iMc), a);
}
function $61de1ee1cac498ae$var$JOc(a) {
    $61de1ee1cac498ae$var$HOc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$MOc(), $61de1ee1cac498ae$var$LOc), a);
}
function $61de1ee1cac498ae$var$HQc(a) {
    $61de1ee1cac498ae$var$FQc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$KQc(), $61de1ee1cac498ae$var$JQc), a);
}
function $61de1ee1cac498ae$var$DRc(a) {
    $61de1ee1cac498ae$var$yRc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$GRc(), $61de1ee1cac498ae$var$FRc), a);
}
function $61de1ee1cac498ae$var$tSc(a) {
    $61de1ee1cac498ae$var$qSc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$wSc(), $61de1ee1cac498ae$var$vSc), a);
}
function $61de1ee1cac498ae$var$UTc(a) {
    $61de1ee1cac498ae$var$STc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$XTc(), $61de1ee1cac498ae$var$WTc), a);
}
function $61de1ee1cac498ae$var$UUc(a) {
    $61de1ee1cac498ae$var$PUc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$XUc(), $61de1ee1cac498ae$var$WUc), a);
}
function $61de1ee1cac498ae$var$aUc(a) {
    $61de1ee1cac498ae$var$$Tc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$dUc(), $61de1ee1cac498ae$var$cUc), a);
}
function $61de1ee1cac498ae$var$wVc(a) {
    $61de1ee1cac498ae$var$tVc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$zVc(), $61de1ee1cac498ae$var$yVc), a);
}
function $61de1ee1cac498ae$var$iWc(a) {
    $61de1ee1cac498ae$var$fWc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$lWc(), $61de1ee1cac498ae$var$kWc), a);
}
function $61de1ee1cac498ae$var$sWc(a) {
    $61de1ee1cac498ae$var$pWc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$vWc(), $61de1ee1cac498ae$var$uWc), a);
}
function $61de1ee1cac498ae$var$lXc(a) {
    $61de1ee1cac498ae$var$iXc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$oXc(), $61de1ee1cac498ae$var$nXc), a);
}
function $61de1ee1cac498ae$var$vXc(a) {
    $61de1ee1cac498ae$var$sXc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$yXc(), $61de1ee1cac498ae$var$xXc), a);
}
function $61de1ee1cac498ae$var$BYc(a) {
    $61de1ee1cac498ae$var$zYc();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$EYc(), $61de1ee1cac498ae$var$DYc), a);
}
function $61de1ee1cac498ae$var$m$c(a) {
    $61de1ee1cac498ae$var$k$c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$p$c(), $61de1ee1cac498ae$var$o$c), a);
}
function $61de1ee1cac498ae$var$$$c(a) {
    $61de1ee1cac498ae$var$Y$c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$b_c(), $61de1ee1cac498ae$var$a_c), a);
}
function $61de1ee1cac498ae$var$n_c(a) {
    $61de1ee1cac498ae$var$i_c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$q_c(), $61de1ee1cac498ae$var$p_c), a);
}
function $61de1ee1cac498ae$var$w_c(a) {
    $61de1ee1cac498ae$var$s_c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$z_c(), $61de1ee1cac498ae$var$y_c), a);
}
function $61de1ee1cac498ae$var$E_c(a) {
    $61de1ee1cac498ae$var$C_c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$H_c(), $61de1ee1cac498ae$var$G_c), a);
}
function $61de1ee1cac498ae$var$P_c(a) {
    $61de1ee1cac498ae$var$N_c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$S_c(), $61de1ee1cac498ae$var$R_c), a);
}
function $61de1ee1cac498ae$var$W0c(a) {
    $61de1ee1cac498ae$var$R0c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Z0c(), $61de1ee1cac498ae$var$Y0c), a);
}
function $61de1ee1cac498ae$var$f1c(a) {
    $61de1ee1cac498ae$var$a1c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$i1c(), $61de1ee1cac498ae$var$h1c), a);
}
function $61de1ee1cac498ae$var$P5c(a) {
    $61de1ee1cac498ae$var$N5c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$S5c(), $61de1ee1cac498ae$var$R5c), a);
}
function $61de1ee1cac498ae$var$b6c(a) {
    $61de1ee1cac498ae$var$_5c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$e6c(), $61de1ee1cac498ae$var$d6c), a);
}
function $61de1ee1cac498ae$var$H7c(a) {
    $61de1ee1cac498ae$var$F7c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$K7c(), $61de1ee1cac498ae$var$J7c), a);
}
function $61de1ee1cac498ae$var$k8c(a) {
    $61de1ee1cac498ae$var$i8c();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$n8c(), $61de1ee1cac498ae$var$m8c), a);
}
function $61de1ee1cac498ae$var$V8b(a) {
    $61de1ee1cac498ae$var$S8b();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Y8b(), $61de1ee1cac498ae$var$X8b), a);
}
function $61de1ee1cac498ae$var$A5b(a) {
    $61de1ee1cac498ae$var$y5b();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$D5b(), $61de1ee1cac498ae$var$C5b), a);
}
function $61de1ee1cac498ae$var$jad(a) {
    $61de1ee1cac498ae$var$ead();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$mad(), $61de1ee1cac498ae$var$lad), a);
}
function $61de1ee1cac498ae$var$sad(a) {
    $61de1ee1cac498ae$var$qad();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$vad(), $61de1ee1cac498ae$var$uad), a);
}
function $61de1ee1cac498ae$var$Cad(a) {
    $61de1ee1cac498ae$var$Aad();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Fad(), $61de1ee1cac498ae$var$Ead), a);
}
function $61de1ee1cac498ae$var$Oad(a) {
    $61de1ee1cac498ae$var$Mad();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Rad(), $61de1ee1cac498ae$var$Qad), a);
}
function $61de1ee1cac498ae$var$jbd(a) {
    $61de1ee1cac498ae$var$hbd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$mbd(), $61de1ee1cac498ae$var$lbd), a);
}
function $61de1ee1cac498ae$var$ubd(a) {
    $61de1ee1cac498ae$var$rbd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$xbd(), $61de1ee1cac498ae$var$wbd), a);
}
function $61de1ee1cac498ae$var$Kbd(a) {
    $61de1ee1cac498ae$var$Hbd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Nbd(), $61de1ee1cac498ae$var$Mbd), a);
}
function $61de1ee1cac498ae$var$Vbd(a) {
    $61de1ee1cac498ae$var$Tbd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Ybd(), $61de1ee1cac498ae$var$Xbd), a);
}
function $61de1ee1cac498ae$var$hcd(a) {
    $61de1ee1cac498ae$var$dcd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$kcd(), $61de1ee1cac498ae$var$jcd), a);
}
function $61de1ee1cac498ae$var$vcd(a) {
    $61de1ee1cac498ae$var$rcd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$ycd(), $61de1ee1cac498ae$var$xcd), a);
}
function $61de1ee1cac498ae$var$vdd(a) {
    $61de1ee1cac498ae$var$tdd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$ydd(), $61de1ee1cac498ae$var$xdd), a);
}
function $61de1ee1cac498ae$var$Kdd(a) {
    $61de1ee1cac498ae$var$Idd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Ndd(), $61de1ee1cac498ae$var$Mdd), a);
}
function $61de1ee1cac498ae$var$$cd(a) {
    $61de1ee1cac498ae$var$Ucd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$cdd(), $61de1ee1cac498ae$var$bdd), a);
}
function $61de1ee1cac498ae$var$Fed(a) {
    $61de1ee1cac498ae$var$Ded();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Ied(), $61de1ee1cac498ae$var$Hed), a);
}
function $61de1ee1cac498ae$var$rgd(a) {
    $61de1ee1cac498ae$var$pgd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$ugd(), $61de1ee1cac498ae$var$tgd), a);
}
function $61de1ee1cac498ae$var$Esd(a) {
    $61de1ee1cac498ae$var$Csd();
    return $61de1ee1cac498ae$var$es(($61de1ee1cac498ae$var$Hsd(), $61de1ee1cac498ae$var$Gsd), a);
}
function $61de1ee1cac498ae$var$Yoc(a, b) {
    return ($61de1ee1cac498ae$var$uCb(a), a) + ($61de1ee1cac498ae$var$uCb(b), b);
}
function $61de1ee1cac498ae$var$NNd(a, b) {
    $61de1ee1cac498ae$var$Zfb();
    return $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$ZKd(a.a), b);
}
function $61de1ee1cac498ae$var$SNd(a, b) {
    $61de1ee1cac498ae$var$Zfb();
    return $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$ZKd(a.a), b);
}
function $61de1ee1cac498ae$var$bPc(a, b) {
    this.c = a;
    this.a = b;
    this.b = b - a;
}
function $61de1ee1cac498ae$var$nYc(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$L1c(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$T1c(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$Rrd(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$zCd(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$IVd(a, b, c) {
    this.e = a;
    this.a = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$kWd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$cWd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$HXd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$oXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$TXd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$oXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$ZXd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$oXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$JXd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$HXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$LXd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$HXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$NXd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$LXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$VXd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$TXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$_Xd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$ZXd.call(this, a, b, c);
}
function $61de1ee1cac498ae$var$$j(a, b) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Qb(b);
    return new $61de1ee1cac498ae$var$_j(a, b);
}
function $61de1ee1cac498ae$var$Nq(a, b) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Qb(b);
    return new $61de1ee1cac498ae$var$Wq(a, b);
}
function $61de1ee1cac498ae$var$Rq(a, b) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Qb(b);
    return new $61de1ee1cac498ae$var$ar(a, b);
}
function $61de1ee1cac498ae$var$lr(a, b) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Qb(b);
    return new $61de1ee1cac498ae$var$zr(a, b);
}
function $61de1ee1cac498ae$var$BD(a, b) {
    $61de1ee1cac498ae$var$CCb(a == null || $61de1ee1cac498ae$var$AD(a, b));
    return a;
}
function $61de1ee1cac498ae$var$Nu(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$fr(b, a);
    return b;
}
function $61de1ee1cac498ae$var$Ex(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Tqb;
    $61de1ee1cac498ae$var$fr(b, a);
    return b;
}
function $61de1ee1cac498ae$var$Hx(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Gxb;
    $61de1ee1cac498ae$var$Jq(b, a);
    return b;
}
function $61de1ee1cac498ae$var$Ru(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$Jq(b, a);
    return b;
}
function $61de1ee1cac498ae$var$YEc(a) {
    !a.e && (a.e = new $61de1ee1cac498ae$var$Rkb);
    return a.e;
}
function $61de1ee1cac498ae$var$SMd(a) {
    !a.c && (a.c = new $61de1ee1cac498ae$var$xYd);
    return a.c;
}
function $61de1ee1cac498ae$var$Ekb(a, b) {
    a.c[a.c.length] = b;
    return true;
}
function $61de1ee1cac498ae$var$WA(a, b) {
    this.c = a;
    this.b = b;
    this.a = false;
}
function $61de1ee1cac498ae$var$Gg(a) {
    this.d = a;
    $61de1ee1cac498ae$var$Dg(this);
    this.b = $61de1ee1cac498ae$var$ed(a.d);
}
function $61de1ee1cac498ae$var$pzb() {
    this.a = ";,;";
    this.b = "";
    this.c = "";
}
function $61de1ee1cac498ae$var$Bvb(a, b, c) {
    $61de1ee1cac498ae$var$qvb.call(this, b, c);
    this.a = a;
}
function $61de1ee1cac498ae$var$fAb(a, b, c) {
    this.b = a;
    $61de1ee1cac498ae$var$fvb.call(this, b, c);
}
function $61de1ee1cac498ae$var$lsb(a, b, c) {
    this.c = a;
    $61de1ee1cac498ae$var$pjb.call(this, b, c);
}
function $61de1ee1cac498ae$var$bCb(a, b, c) {
    $61de1ee1cac498ae$var$$Bb(c, 0, a, b, c.length, false);
}
function $61de1ee1cac498ae$var$HVb(a, b, c, d, e) {
    a.b = b;
    a.c = c;
    a.d = d;
    a.a = e;
}
function $61de1ee1cac498ae$var$eBb(a, b) {
    if (b) {
        a.b = b;
        a.a = ($61de1ee1cac498ae$var$Tzb(b), b.a);
    }
}
function $61de1ee1cac498ae$var$v_b(a, b, c, d, e) {
    a.d = b;
    a.c = c;
    a.a = d;
    a.b = e;
}
function $61de1ee1cac498ae$var$h5b(a) {
    var b, c;
    b = a.b;
    c = a.c;
    a.b = c;
    a.c = b;
}
function $61de1ee1cac498ae$var$k5b(a) {
    var b, c;
    c = a.d;
    b = a.a;
    a.d = b;
    a.a = c;
}
function $61de1ee1cac498ae$var$Lbb(a) {
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$iD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a));
}
function $61de1ee1cac498ae$var$rlc(a, b) {
    return $61de1ee1cac498ae$var$beb($61de1ee1cac498ae$var$D0b(a.d), $61de1ee1cac498ae$var$D0b(b.d));
}
function $61de1ee1cac498ae$var$uic(a, b) {
    return b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? a.c : a.d;
}
function $61de1ee1cac498ae$var$FHc() {
    $61de1ee1cac498ae$var$FHc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$DHc = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd);
    $61de1ee1cac498ae$var$EHc = $61de1ee1cac498ae$var$zcd;
}
function $61de1ee1cac498ae$var$DRb() {
    this.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ksd(($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$vSb))));
}
function $61de1ee1cac498ae$var$aBb(a) {
    return $61de1ee1cac498ae$var$EAb(), $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, a, 5, 1);
}
function $61de1ee1cac498ae$var$C6c(a) {
    return new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d + a.a);
}
function $61de1ee1cac498ae$var$Vmc(a, b) {
    $61de1ee1cac498ae$var$Imc();
    return $61de1ee1cac498ae$var$beb(a.d.p, b.d.p);
}
function $61de1ee1cac498ae$var$Lsb(a) {
    $61de1ee1cac498ae$var$sCb(a.b != 0);
    return $61de1ee1cac498ae$var$Nsb(a, a.a.a);
}
function $61de1ee1cac498ae$var$Msb(a) {
    $61de1ee1cac498ae$var$sCb(a.b != 0);
    return $61de1ee1cac498ae$var$Nsb(a, a.c.b);
}
function $61de1ee1cac498ae$var$rCb(a, b) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$ucb(b));
}
function $61de1ee1cac498ae$var$mCb(a, b) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb(b));
}
function $61de1ee1cac498ae$var$dWb(a, b, c) {
    $61de1ee1cac498ae$var$cWb.call(this, a, b);
    this.b = c;
}
function $61de1ee1cac498ae$var$pMd(a, b, c) {
    $61de1ee1cac498ae$var$MLd.call(this, a, b);
    this.c = c;
}
function $61de1ee1cac498ae$var$Dnc(a, b, c) {
    $61de1ee1cac498ae$var$Cnc.call(this, b, c);
    this.d = a;
}
function $61de1ee1cac498ae$var$_Gd(a) {
    $61de1ee1cac498ae$var$$Gd();
    $61de1ee1cac498ae$var$MGd.call(this);
    this.th(a);
}
function $61de1ee1cac498ae$var$PNd(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$nNd.call(this, b, c);
}
function $61de1ee1cac498ae$var$UNd(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$nNd.call(this, b, c);
}
function $61de1ee1cac498ae$var$k2d(a, b, c) {
    $61de1ee1cac498ae$var$MLd.call(this, a, b);
    this.c = c;
}
function $61de1ee1cac498ae$var$y1d() {
    $61de1ee1cac498ae$var$T0d();
    $61de1ee1cac498ae$var$z1d.call(this, ($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd));
}
function $61de1ee1cac498ae$var$gFd(a) {
    return a != null && !$61de1ee1cac498ae$var$OEd(a, $61de1ee1cac498ae$var$CEd, $61de1ee1cac498ae$var$DEd);
}
function $61de1ee1cac498ae$var$dFd(a, b) {
    return ($61de1ee1cac498ae$var$jFd(a) << 4 | $61de1ee1cac498ae$var$jFd(b)) & $61de1ee1cac498ae$var$aje;
}
function $61de1ee1cac498ae$var$ln(a, b) {
    return $61de1ee1cac498ae$var$Vm(), $61de1ee1cac498ae$var$Wj(a, b), new $61de1ee1cac498ae$var$iy(a, b);
}
function $61de1ee1cac498ae$var$Sdd(a, b) {
    var c;
    if (a.n) {
        c = b;
        $61de1ee1cac498ae$var$Ekb(a.f, c);
    }
}
function $61de1ee1cac498ae$var$Upd(a, b, c) {
    var d;
    d = new $61de1ee1cac498ae$var$yC(c);
    $61de1ee1cac498ae$var$cC(a, b, d);
}
function $61de1ee1cac498ae$var$WUd(a, b) {
    var c;
    c = a.c;
    $61de1ee1cac498ae$var$VUd(a, b);
    return c;
}
function $61de1ee1cac498ae$var$Ydd(a, b) {
    b < 0 ? a.g = -1 : a.g = b;
    return a;
}
function $61de1ee1cac498ae$var$$6c(a, b) {
    $61de1ee1cac498ae$var$W6c(a);
    a.a *= b;
    a.b *= b;
    return a;
}
function $61de1ee1cac498ae$var$G6c(a, b, c, d, e) {
    a.c = b;
    a.d = c;
    a.b = d;
    a.a = e;
}
function $61de1ee1cac498ae$var$Dsb(a, b) {
    $61de1ee1cac498ae$var$Gsb(a, b, a.c.b, a.c);
    return true;
}
function $61de1ee1cac498ae$var$jsb(a) {
    a.a.b = a.b;
    a.b.a = a.a;
    a.a = a.b = null;
}
function $61de1ee1cac498ae$var$Aq(a) {
    this.b = a;
    this.a = $61de1ee1cac498ae$var$Wm(this.b.a).Ed();
}
function $61de1ee1cac498ae$var$Wq(a, b) {
    this.b = a;
    this.a = b;
    $61de1ee1cac498ae$var$ol.call(this);
}
function $61de1ee1cac498ae$var$ar(a, b) {
    this.a = a;
    this.b = b;
    $61de1ee1cac498ae$var$ol.call(this);
}
function $61de1ee1cac498ae$var$vvb(a, b) {
    $61de1ee1cac498ae$var$qvb.call(this, b, 1040);
    this.a = a;
}
function $61de1ee1cac498ae$var$Eeb(a) {
    return a == 0 || isNaN(a) ? a : a < 0 ? -1 : 1;
}
function $61de1ee1cac498ae$var$WPb(a) {
    $61de1ee1cac498ae$var$QPb();
    return $61de1ee1cac498ae$var$jtd(a) == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$ltd(a));
}
function $61de1ee1cac498ae$var$XPb(a) {
    $61de1ee1cac498ae$var$QPb();
    return $61de1ee1cac498ae$var$ltd(a) == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$jtd(a));
}
function $61de1ee1cac498ae$var$iYb(a, b) {
    return $61de1ee1cac498ae$var$hYb(a, new $61de1ee1cac498ae$var$cWb(b.a, b.b));
}
function $61de1ee1cac498ae$var$NZb(a) {
    return !$61de1ee1cac498ae$var$OZb(a) && a.c.i.c == a.d.i.c;
}
function $61de1ee1cac498ae$var$_Gb(a) {
    var b;
    b = a.n;
    return a.a.b + b.d + b.a;
}
function $61de1ee1cac498ae$var$YHb(a) {
    var b;
    b = a.n;
    return a.e.b + b.d + b.a;
}
function $61de1ee1cac498ae$var$ZHb(a) {
    var b;
    b = a.n;
    return a.e.a + b.b + b.c;
}
function $61de1ee1cac498ae$var$zfe(a) {
    $61de1ee1cac498ae$var$wfe();
    ++$61de1ee1cac498ae$var$vfe;
    return new $61de1ee1cac498ae$var$ige(0, a);
}
function $61de1ee1cac498ae$var$o_b(a) {
    if (a.a) return a.a;
    return $61de1ee1cac498ae$var$JZb(a);
}
function $61de1ee1cac498ae$var$CCb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cdb(null));
}
function $61de1ee1cac498ae$var$X6d() {
    $61de1ee1cac498ae$var$X6d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$W6d = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$anb($61de1ee1cac498ae$var$Fwe));
}
function $61de1ee1cac498ae$var$ex() {
    $61de1ee1cac498ae$var$ex = $61de1ee1cac498ae$var$ccb;
    new $61de1ee1cac498ae$var$gx(($61de1ee1cac498ae$var$_k(), $61de1ee1cac498ae$var$$k), ($61de1ee1cac498ae$var$Lk(), $61de1ee1cac498ae$var$Kk));
}
function $61de1ee1cac498ae$var$oeb() {
    $61de1ee1cac498ae$var$oeb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$neb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$JI, $61de1ee1cac498ae$var$nie, 19, 256, 0, 1);
}
function $61de1ee1cac498ae$var$d$c(a, b, c, d) {
    $61de1ee1cac498ae$var$e$c.call(this, a, b, c, d, 0, 0);
}
function $61de1ee1cac498ae$var$sQc(a, b, c) {
    return $61de1ee1cac498ae$var$Rhb(a.b, $61de1ee1cac498ae$var$BD(c.b, 17), b);
}
function $61de1ee1cac498ae$var$tQc(a, b, c) {
    return $61de1ee1cac498ae$var$Rhb(a.b, $61de1ee1cac498ae$var$BD(c.b, 17), b);
}
function $61de1ee1cac498ae$var$xfd(a, b) {
    return $61de1ee1cac498ae$var$Ekb(a, new $61de1ee1cac498ae$var$f7c(b.a, b.b));
}
function $61de1ee1cac498ae$var$Bic(a, b) {
    return a.c < b.c ? -1 : a.c == b.c ? 0 : 1;
}
function $61de1ee1cac498ae$var$B0b(a) {
    return a.e.c.length + a.g.c.length;
}
function $61de1ee1cac498ae$var$D0b(a) {
    return a.e.c.length - a.g.c.length;
}
function $61de1ee1cac498ae$var$Ojc(a) {
    return a.b.c.length - a.e.c.length;
}
function $61de1ee1cac498ae$var$dKc(a) {
    $61de1ee1cac498ae$var$FJc();
    return ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Ecd).Hc(a.j);
}
function $61de1ee1cac498ae$var$lHd(a) {
    $61de1ee1cac498ae$var$$Gd();
    $61de1ee1cac498ae$var$_Gd.call(this, a);
    this.a = -1;
}
function $61de1ee1cac498ae$var$R7d(a, b) {
    $61de1ee1cac498ae$var$f7d.call(this, a, b);
    this.a = this;
}
function $61de1ee1cac498ae$var$odb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$ldb(a, b);
    c.i = 2;
    return c;
}
function $61de1ee1cac498ae$var$Evd(a, b) {
    var c;
    ++a.j;
    c = a.Ti(b);
    return c;
}
function $61de1ee1cac498ae$var$e3c(a, b, c) {
    a.a = -1;
    $61de1ee1cac498ae$var$i3c(a, b.g, c);
    return a;
}
function $61de1ee1cac498ae$var$Qrd(a, b, c) {
    $61de1ee1cac498ae$var$Kqd(a.a, a.b, a.c, $61de1ee1cac498ae$var$BD(b, 202), c);
}
function $61de1ee1cac498ae$var$OHd(a, b) {
    $61de1ee1cac498ae$var$PHd(a, b == null ? null : ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$SUd(a, b) {
    $61de1ee1cac498ae$var$UUd(a, b == null ? null : ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$TUd(a, b) {
    $61de1ee1cac498ae$var$UUd(a, b == null ? null : ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$Zj(a, b, c) {
    return new $61de1ee1cac498ae$var$tk($61de1ee1cac498ae$var$oAb(a).Ie(), c, b);
}
function $61de1ee1cac498ae$var$IC(a, b, c, d, e, f) {
    return $61de1ee1cac498ae$var$JC(a, b, c, d, e, 0, f);
}
function $61de1ee1cac498ae$var$Ucb() {
    $61de1ee1cac498ae$var$Ucb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Tcb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$xI, $61de1ee1cac498ae$var$nie, 217, 256, 0, 1);
}
function $61de1ee1cac498ae$var$Ceb() {
    $61de1ee1cac498ae$var$Ceb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Beb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$MI, $61de1ee1cac498ae$var$nie, 162, 256, 0, 1);
}
function $61de1ee1cac498ae$var$Yeb() {
    $61de1ee1cac498ae$var$Yeb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Xeb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UI, $61de1ee1cac498ae$var$nie, 184, 256, 0, 1);
}
function $61de1ee1cac498ae$var$ddb() {
    $61de1ee1cac498ae$var$ddb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$cdb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yI, $61de1ee1cac498ae$var$nie, 172, 128, 0, 1);
}
function $61de1ee1cac498ae$var$IVb() {
    $61de1ee1cac498ae$var$HVb(this, false, false, false, false);
}
function $61de1ee1cac498ae$var$my(a) {
    $61de1ee1cac498ae$var$im();
    this.a = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$anb($61de1ee1cac498ae$var$Qb(a)));
}
function $61de1ee1cac498ae$var$ir(a) {
    $61de1ee1cac498ae$var$Qb(a);
    while(a.Ob()){
        a.Pb();
        a.Qb();
    }
}
function $61de1ee1cac498ae$var$Tw(a) {
    a.a.cd();
    $61de1ee1cac498ae$var$BD(a.a.dd(), 14).gc();
    $61de1ee1cac498ae$var$zh();
}
function $61de1ee1cac498ae$var$mf(a) {
    this.c = a;
    this.b = this.c.d.vc().Kc();
}
function $61de1ee1cac498ae$var$fqb(a) {
    this.c = a;
    this.a = new $61de1ee1cac498ae$var$Gqb(this.c.a);
}
function $61de1ee1cac498ae$var$Vqb(a) {
    this.a = new $61de1ee1cac498ae$var$Mqb(a.gc());
    $61de1ee1cac498ae$var$ye(this, a);
}
function $61de1ee1cac498ae$var$Bsb(a) {
    $61de1ee1cac498ae$var$Wqb.call(this, new $61de1ee1cac498ae$var$$rb);
    $61de1ee1cac498ae$var$ye(this, a);
}
function $61de1ee1cac498ae$var$Rfb(a, b) {
    a.a += $61de1ee1cac498ae$var$zfb(b, 0, b.length);
    return a;
}
function $61de1ee1cac498ae$var$Ikb(a, b) {
    $61de1ee1cac498ae$var$tCb(b, a.c.length);
    return a.c[b];
}
function $61de1ee1cac498ae$var$$lb(a, b) {
    $61de1ee1cac498ae$var$tCb(b, a.a.length);
    return a.a[b];
}
function $61de1ee1cac498ae$var$YAb(a, b) {
    $61de1ee1cac498ae$var$EAb();
    $61de1ee1cac498ae$var$Vzb.call(this, a);
    this.a = b;
}
function $61de1ee1cac498ae$var$Qyb(a, b) {
    return $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Aeb(a.a).a, b.a));
}
function $61de1ee1cac498ae$var$jpb(a, b) {
    return $61de1ee1cac498ae$var$uCb(a), $61de1ee1cac498ae$var$Fcb(a, ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$opb(a, b) {
    return $61de1ee1cac498ae$var$uCb(b), $61de1ee1cac498ae$var$Fcb(b, ($61de1ee1cac498ae$var$uCb(a), a));
}
function $61de1ee1cac498ae$var$Oyb(a, b) {
    return $61de1ee1cac498ae$var$NC(b, 0, $61de1ee1cac498ae$var$Bzb(b[0], $61de1ee1cac498ae$var$Aeb(1)));
}
function $61de1ee1cac498ae$var$Bzb(a, b) {
    return $61de1ee1cac498ae$var$Qyb($61de1ee1cac498ae$var$BD(a, 162), $61de1ee1cac498ae$var$BD(b, 162));
}
function $61de1ee1cac498ae$var$vic(a) {
    return a.c - $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, a.b), 287).b;
}
function $61de1ee1cac498ae$var$uNb(a) {
    return !a.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : a.q;
}
function $61de1ee1cac498ae$var$Xi(a) {
    return a.e.Hd().gc() * a.c.Hd().gc();
}
function $61de1ee1cac498ae$var$onc(a, b, c) {
    return $61de1ee1cac498ae$var$beb(b.d[a.g], c.d[a.g]);
}
function $61de1ee1cac498ae$var$YHc(a, b, c) {
    return $61de1ee1cac498ae$var$beb(a.d[b.p], a.d[c.p]);
}
function $61de1ee1cac498ae$var$ZHc(a, b, c) {
    return $61de1ee1cac498ae$var$beb(a.d[b.p], a.d[c.p]);
}
function $61de1ee1cac498ae$var$$Hc(a, b, c) {
    return $61de1ee1cac498ae$var$beb(a.d[b.p], a.d[c.p]);
}
function $61de1ee1cac498ae$var$_Hc(a, b, c) {
    return $61de1ee1cac498ae$var$beb(a.d[b.p], a.d[c.p]);
}
function $61de1ee1cac498ae$var$q$c(a, b, c) {
    return $61de1ee1cac498ae$var$$wnd.Math.min(c / a, 1 / b);
}
function $61de1ee1cac498ae$var$sEc(a, b) {
    return a ? 0 : $61de1ee1cac498ae$var$$wnd.Math.max(0, b - 1);
}
function $61de1ee1cac498ae$var$Elb(a, b) {
    var c;
    for(c = 0; c < b; ++c)a[c] = -1;
}
function $61de1ee1cac498ae$var$bVc(a) {
    var b;
    b = $61de1ee1cac498ae$var$hVc(a);
    return !b ? a : $61de1ee1cac498ae$var$bVc(b);
}
function $61de1ee1cac498ae$var$Voc(a, b) {
    a.a == null && $61de1ee1cac498ae$var$Toc(a);
    return a.a[b];
}
function $61de1ee1cac498ae$var$qed(a) {
    if (a.c) return a.c.f;
    return a.e.b;
}
function $61de1ee1cac498ae$var$red(a) {
    if (a.c) return a.c.g;
    return a.e.a;
}
function $61de1ee1cac498ae$var$pFd(a) {
    $61de1ee1cac498ae$var$zud.call(this, a.gc());
    $61de1ee1cac498ae$var$ytd(this, a);
}
function $61de1ee1cac498ae$var$nXd(a, b) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$VVd.call(this, b);
    this.a = a;
}
function $61de1ee1cac498ae$var$KYd(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$xMd.call(this, b, c, 2);
}
function $61de1ee1cac498ae$var$B_b(a, b, c, d) {
    $61de1ee1cac498ae$var$s_b(this);
    $61de1ee1cac498ae$var$v_b(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$ige(a, b) {
    $61de1ee1cac498ae$var$wfe();
    $61de1ee1cac498ae$var$xfe.call(this, a);
    this.a = b;
}
function $61de1ee1cac498ae$var$jgd(a) {
    this.b = new $61de1ee1cac498ae$var$Psb;
    this.a = a;
    this.c = -1;
}
function $61de1ee1cac498ae$var$MOb() {
    this.d = new $61de1ee1cac498ae$var$f7c(0, 0);
    this.e = new $61de1ee1cac498ae$var$Tqb;
}
function $61de1ee1cac498ae$var$Nr(a) {
    $61de1ee1cac498ae$var$qc.call(this, 0, 0);
    this.a = a;
    this.b = 0;
}
function $61de1ee1cac498ae$var$ejc(a) {
    this.a = a;
    this.c = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$$ic(this);
}
function $61de1ee1cac498ae$var$ju(a) {
    if (a.e.c != a.b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
}
function $61de1ee1cac498ae$var$bt(a) {
    if (a.c.e != a.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
}
function $61de1ee1cac498ae$var$Tbb(a) {
    if ($61de1ee1cac498ae$var$Fbb(a)) return a | 0;
    return $61de1ee1cac498ae$var$pD(a);
}
function $61de1ee1cac498ae$var$Bfe(a, b) {
    $61de1ee1cac498ae$var$wfe();
    ++$61de1ee1cac498ae$var$vfe;
    return new $61de1ee1cac498ae$var$rge(a, b);
}
function $61de1ee1cac498ae$var$SEd(a, b) {
    return a == null ? b == null : $61de1ee1cac498ae$var$dfb(a, b);
}
function $61de1ee1cac498ae$var$TEd(a, b) {
    return a == null ? b == null : $61de1ee1cac498ae$var$efb(a, b);
}
function $61de1ee1cac498ae$var$Npb(a, b, c) {
    $61de1ee1cac498ae$var$rqb(a.a, b);
    return $61de1ee1cac498ae$var$Qpb(a, b.g, c);
}
function $61de1ee1cac498ae$var$Mlb(a, b, c) {
    $61de1ee1cac498ae$var$oCb(0, b, a.length);
    $61de1ee1cac498ae$var$Klb(a, 0, b, c);
}
function $61de1ee1cac498ae$var$Dkb(a, b, c) {
    $61de1ee1cac498ae$var$wCb(b, a.c.length);
    $61de1ee1cac498ae$var$aCb(a.c, b, c);
}
function $61de1ee1cac498ae$var$Dlb(a, b, c) {
    var d;
    for(d = 0; d < b; ++d)a[d] = c;
}
function $61de1ee1cac498ae$var$qqb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$pqb(a);
    $61de1ee1cac498ae$var$nmb(c, b);
    return c;
}
function $61de1ee1cac498ae$var$Oz(a, b) {
    !a && (a = []);
    a[a.length] = b;
    return a;
}
function $61de1ee1cac498ae$var$Brb(a, b) {
    return !(a.a.get(b) === undefined);
}
function $61de1ee1cac498ae$var$Wyb(a, b) {
    return $61de1ee1cac498ae$var$Nyb(new $61de1ee1cac498ae$var$rzb, new $61de1ee1cac498ae$var$bzb(a), b);
}
function $61de1ee1cac498ae$var$Itb(a) {
    return a == null ? $61de1ee1cac498ae$var$ztb : new $61de1ee1cac498ae$var$Ftb($61de1ee1cac498ae$var$uCb(a));
}
function $61de1ee1cac498ae$var$tqb(a, b) {
    return $61de1ee1cac498ae$var$JD(b, 22) && $61de1ee1cac498ae$var$uqb(a, $61de1ee1cac498ae$var$BD(b, 22));
}
function $61de1ee1cac498ae$var$vqb(a, b) {
    return $61de1ee1cac498ae$var$JD(b, 22) && $61de1ee1cac498ae$var$wqb(a, $61de1ee1cac498ae$var$BD(b, 22));
}
function $61de1ee1cac498ae$var$Aub(a) {
    return $61de1ee1cac498ae$var$Cub(a, 26) * $61de1ee1cac498ae$var$ike + $61de1ee1cac498ae$var$Cub(a, 27) * $61de1ee1cac498ae$var$jke;
}
function $61de1ee1cac498ae$var$MC(a) {
    return Array.isArray(a) && a.im === $61de1ee1cac498ae$var$gcb;
}
function $61de1ee1cac498ae$var$bg(a) {
    a.b ? $61de1ee1cac498ae$var$bg(a.b) : a.d.dc() && a.f.c.Bc(a.e);
}
function $61de1ee1cac498ae$var$$Nb(a, b) {
    $61de1ee1cac498ae$var$P6c(a.c, b);
    a.b.c += b.a;
    a.b.d += b.b;
}
function $61de1ee1cac498ae$var$ZNb(a, b) {
    $61de1ee1cac498ae$var$$Nb(a, $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), a.c));
}
function $61de1ee1cac498ae$var$BLb(a, b) {
    this.b = new $61de1ee1cac498ae$var$Psb;
    this.a = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$OVb() {
    this.b = new $61de1ee1cac498ae$var$$Vb;
    this.c = new $61de1ee1cac498ae$var$SVb(this);
}
function $61de1ee1cac498ae$var$oEb() {
    this.d = new $61de1ee1cac498ae$var$CEb;
    this.e = new $61de1ee1cac498ae$var$uEb(this);
}
function $61de1ee1cac498ae$var$aCc() {
    $61de1ee1cac498ae$var$ZBc();
    this.f = new $61de1ee1cac498ae$var$Psb;
    this.e = new $61de1ee1cac498ae$var$Psb;
}
function $61de1ee1cac498ae$var$$Jc() {
    $61de1ee1cac498ae$var$FJc();
    this.k = new $61de1ee1cac498ae$var$Lqb;
    this.d = new $61de1ee1cac498ae$var$Tqb;
}
function $61de1ee1cac498ae$var$Rgd() {
    $61de1ee1cac498ae$var$Rgd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Qgd = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c), 0);
}
function $61de1ee1cac498ae$var$Mr() {
    $61de1ee1cac498ae$var$Mr = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Lr = new $61de1ee1cac498ae$var$Nr($61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1));
}
function $61de1ee1cac498ae$var$gfc(a, b, c) {
    $61de1ee1cac498ae$var$bfc(c, a, 1);
    $61de1ee1cac498ae$var$Ekb(b, new $61de1ee1cac498ae$var$Tfc(c, a));
}
function $61de1ee1cac498ae$var$hfc(a, b, c) {
    $61de1ee1cac498ae$var$cfc(c, a, 1);
    $61de1ee1cac498ae$var$Ekb(b, new $61de1ee1cac498ae$var$dgc(c, a));
}
function $61de1ee1cac498ae$var$R$c(a, b, c) {
    return $61de1ee1cac498ae$var$Qqb(a, new $61de1ee1cac498ae$var$aDb(b.a, c.a));
}
function $61de1ee1cac498ae$var$ACc(a, b, c) {
    return -$61de1ee1cac498ae$var$beb(a.f[b.p], a.f[c.p]);
}
function $61de1ee1cac498ae$var$mHb(a, b, c) {
    var d;
    if (a) {
        d = a.i;
        d.c = b;
        d.b = c;
    }
}
function $61de1ee1cac498ae$var$nHb(a, b, c) {
    var d;
    if (a) {
        d = a.i;
        d.d = b;
        d.a = c;
    }
}
function $61de1ee1cac498ae$var$c3c(a, b, c) {
    a.a = -1;
    $61de1ee1cac498ae$var$i3c(a, b.g + 1, c);
    return a;
}
function $61de1ee1cac498ae$var$Dod(a, b, c) {
    c = $61de1ee1cac498ae$var$_hd(a, $61de1ee1cac498ae$var$BD(b, 49), 7, c);
    return c;
}
function $61de1ee1cac498ae$var$JHd(a, b, c) {
    c = $61de1ee1cac498ae$var$_hd(a, $61de1ee1cac498ae$var$BD(b, 49), 3, c);
    return c;
}
function $61de1ee1cac498ae$var$JMd(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$BMd.call(this, b, c, 22);
}
function $61de1ee1cac498ae$var$UTd(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$BMd.call(this, b, c, 14);
}
function $61de1ee1cac498ae$var$eXd(a, b, c, d) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$nWd.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$lXd(a, b, c, d) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$nWd.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$FNd(a, b) {
    (b.Bb & $61de1ee1cac498ae$var$ote) != 0 && !a.a.o && (a.a.o = b);
}
function $61de1ee1cac498ae$var$MD(a) {
    return a != null && $61de1ee1cac498ae$var$OD(a) && !(a.im === $61de1ee1cac498ae$var$gcb);
}
function $61de1ee1cac498ae$var$ID(a) {
    return !Array.isArray(a) && a.im === $61de1ee1cac498ae$var$gcb;
}
function $61de1ee1cac498ae$var$ed(a) {
    return $61de1ee1cac498ae$var$JD(a, 15) ? $61de1ee1cac498ae$var$BD(a, 15).Yc() : a.Kc();
}
function $61de1ee1cac498ae$var$De(a) {
    return a.Qc($61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, a.gc(), 5, 1));
}
function $61de1ee1cac498ae$var$u1d(a, b) {
    return $61de1ee1cac498ae$var$W1d($61de1ee1cac498ae$var$p1d(a, b)) ? b.Qh() : null;
}
function $61de1ee1cac498ae$var$uvd(a) {
    a ? $61de1ee1cac498ae$var$Ty(a, ($61de1ee1cac498ae$var$Zfb(), $61de1ee1cac498ae$var$Yfb), "") : ($61de1ee1cac498ae$var$Zfb(), $61de1ee1cac498ae$var$Yfb);
}
function $61de1ee1cac498ae$var$Sr(a) {
    this.a = ($61de1ee1cac498ae$var$Mr(), $61de1ee1cac498ae$var$Lr);
    this.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 47);
}
function $61de1ee1cac498ae$var$qg(a, b, c, d) {
    this.a = a;
    $61de1ee1cac498ae$var$dg.call(this, a, b, c, d);
}
function $61de1ee1cac498ae$var$Yge(a) {
    $61de1ee1cac498ae$var$Xge();
    this.a = 0;
    this.b = a - 1;
    this.c = 1;
}
function $61de1ee1cac498ae$var$Yy(a) {
    $61de1ee1cac498ae$var$Py(this);
    this.g = a;
    $61de1ee1cac498ae$var$Ry(this);
    this._d();
}
function $61de1ee1cac498ae$var$Wm(a) {
    if (a.c) return a.c;
    return a.c = a.Id();
}
function $61de1ee1cac498ae$var$Xm(a) {
    if (a.d) return a.d;
    return a.d = a.Jd();
}
function $61de1ee1cac498ae$var$Rl(a) {
    var b;
    b = a.c;
    return !b ? a.c = a.Dd() : b;
}
function $61de1ee1cac498ae$var$fe(a) {
    var b;
    b = a.f;
    return !b ? a.f = a.Dc() : b;
}
function $61de1ee1cac498ae$var$Ec(a) {
    var b;
    b = a.i;
    return !b ? a.i = a.bc() : b;
}
function $61de1ee1cac498ae$var$Ffe(a) {
    $61de1ee1cac498ae$var$wfe();
    ++$61de1ee1cac498ae$var$vfe;
    return new $61de1ee1cac498ae$var$Hge(10, a, 0);
}
function $61de1ee1cac498ae$var$Ubb(a) {
    if ($61de1ee1cac498ae$var$Fbb(a)) return "" + a;
    return $61de1ee1cac498ae$var$qD(a);
}
function $61de1ee1cac498ae$var$a4d(a) {
    if (a.e.j != a.d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
}
function $61de1ee1cac498ae$var$Nbb(a, b) {
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$kD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, b));
}
function $61de1ee1cac498ae$var$Obb(a, b) {
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$lD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, b));
}
function $61de1ee1cac498ae$var$Pbb(a, b) {
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$mD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, b));
}
function $61de1ee1cac498ae$var$Dcb(a, b) {
    return $61de1ee1cac498ae$var$Ecb(($61de1ee1cac498ae$var$uCb(a), a), ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$Ddb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(($61de1ee1cac498ae$var$uCb(a), a), ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$fx(a, b) {
    return $61de1ee1cac498ae$var$Qb(b), a.a.Ad(b) && !a.b.Ad(b);
}
function $61de1ee1cac498ae$var$dD(a, b) {
    return $61de1ee1cac498ae$var$TC(a.l & b.l, a.m & b.m, a.h & b.h);
}
function $61de1ee1cac498ae$var$jD(a, b) {
    return $61de1ee1cac498ae$var$TC(a.l | b.l, a.m | b.m, a.h | b.h);
}
function $61de1ee1cac498ae$var$rD(a, b) {
    return $61de1ee1cac498ae$var$TC(a.l ^ b.l, a.m ^ b.m, a.h ^ b.h);
}
function $61de1ee1cac498ae$var$QAb(a, b) {
    return $61de1ee1cac498ae$var$TAb(a, ($61de1ee1cac498ae$var$uCb(b), new $61de1ee1cac498ae$var$Rxb(b)));
}
function $61de1ee1cac498ae$var$RAb(a, b) {
    return $61de1ee1cac498ae$var$TAb(a, ($61de1ee1cac498ae$var$uCb(b), new $61de1ee1cac498ae$var$Txb(b)));
}
function $61de1ee1cac498ae$var$g1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).e.c.length != 0;
}
function $61de1ee1cac498ae$var$l1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).g.c.length != 0;
}
function $61de1ee1cac498ae$var$bac(a, b) {
    $61de1ee1cac498ae$var$I9b();
    return $61de1ee1cac498ae$var$Kdb(b.a.o.a, a.a.o.a);
}
function $61de1ee1cac498ae$var$Rnc(a, b, c) {
    return $61de1ee1cac498ae$var$Snc(a, $61de1ee1cac498ae$var$BD(b, 11), $61de1ee1cac498ae$var$BD(c, 11));
}
function $61de1ee1cac498ae$var$koc(a) {
    if (a.e) return $61de1ee1cac498ae$var$poc(a.e);
    return null;
}
function $61de1ee1cac498ae$var$Iub(a) {
    if (!a.d) {
        a.d = a.b.Kc();
        a.c = a.b.gc();
    }
}
function $61de1ee1cac498ae$var$pBb(a, b, c) {
    if (a.a.Mb(c)) {
        a.b = true;
        b.td(c);
    }
}
function $61de1ee1cac498ae$var$_vb(a, b) {
    if (a < 0 || a >= b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$rcb);
}
function $61de1ee1cac498ae$var$Pyb(a, b, c) {
    $61de1ee1cac498ae$var$NC(b, 0, $61de1ee1cac498ae$var$Bzb(b[0], c[0]));
    return b;
}
function $61de1ee1cac498ae$var$_yc(a, b, c) {
    b.Ye(c, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ohb(a.b, c))) * a.a);
}
function $61de1ee1cac498ae$var$n6c(a, b, c) {
    $61de1ee1cac498ae$var$i6c();
    return $61de1ee1cac498ae$var$m6c(a, b) && $61de1ee1cac498ae$var$m6c(a, c);
}
function $61de1ee1cac498ae$var$tcd(a) {
    $61de1ee1cac498ae$var$rcd();
    return !a.Hc($61de1ee1cac498ae$var$ncd) && !a.Hc($61de1ee1cac498ae$var$pcd);
}
function $61de1ee1cac498ae$var$D6c(a) {
    return new $61de1ee1cac498ae$var$f7c(a.c + a.b / 2, a.d + a.a / 2);
}
function $61de1ee1cac498ae$var$oOd(a, b) {
    return b.kh() ? $61de1ee1cac498ae$var$xid(a.b, $61de1ee1cac498ae$var$BD(b, 49)) : b;
}
function $61de1ee1cac498ae$var$bvb(a, b) {
    this.e = a;
    this.d = (b & 64) != 0 ? b | $61de1ee1cac498ae$var$oie : b;
}
function $61de1ee1cac498ae$var$qvb(a, b) {
    this.c = 0;
    this.d = a;
    this.b = b | 64 | $61de1ee1cac498ae$var$oie;
}
function $61de1ee1cac498ae$var$gub(a) {
    this.b = new $61de1ee1cac498ae$var$Skb(11);
    this.a = ($61de1ee1cac498ae$var$ipb(), a);
}
function $61de1ee1cac498ae$var$Qwb(a) {
    this.b = null;
    this.a = ($61de1ee1cac498ae$var$ipb(), !a ? $61de1ee1cac498ae$var$fpb : a);
}
function $61de1ee1cac498ae$var$nHc(a) {
    this.a = $61de1ee1cac498ae$var$lHc(a.a);
    this.b = new $61de1ee1cac498ae$var$Tkb(a.b);
}
function $61de1ee1cac498ae$var$Pzd(a) {
    this.b = a;
    $61de1ee1cac498ae$var$Oyd.call(this, a);
    $61de1ee1cac498ae$var$Ozd(this);
}
function $61de1ee1cac498ae$var$Xzd(a) {
    this.b = a;
    $61de1ee1cac498ae$var$bzd.call(this, a);
    $61de1ee1cac498ae$var$Wzd(this);
}
function $61de1ee1cac498ae$var$jUd(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$gUd.call(this, b, c, 5, 6);
}
function $61de1ee1cac498ae$var$Y5d(a, b, c, d) {
    this.b = a;
    $61de1ee1cac498ae$var$xMd.call(this, b, c, d);
}
function $61de1ee1cac498ae$var$nSd(a, b, c, d, e) {
    $61de1ee1cac498ae$var$oSd.call(this, a, b, c, d, e, -1);
}
function $61de1ee1cac498ae$var$DSd(a, b, c, d, e) {
    $61de1ee1cac498ae$var$ESd.call(this, a, b, c, d, e, -1);
}
function $61de1ee1cac498ae$var$cUd(a, b, c, d) {
    $61de1ee1cac498ae$var$xMd.call(this, a, b, c);
    this.b = d;
}
function $61de1ee1cac498ae$var$i5d(a, b, c, d) {
    $61de1ee1cac498ae$var$pMd.call(this, a, b, c);
    this.b = d;
}
function $61de1ee1cac498ae$var$x0d(a) {
    $61de1ee1cac498ae$var$Wud.call(this, a, false);
    this.a = false;
}
function $61de1ee1cac498ae$var$Lj(a, b) {
    this.b = a;
    $61de1ee1cac498ae$var$sj.call(this, a.b);
    this.a = b;
}
function $61de1ee1cac498ae$var$px(a, b) {
    $61de1ee1cac498ae$var$im();
    $61de1ee1cac498ae$var$ox.call(this, a, $61de1ee1cac498ae$var$Dm(new $61de1ee1cac498ae$var$amb(b)));
}
function $61de1ee1cac498ae$var$Cfe(a, b) {
    $61de1ee1cac498ae$var$wfe();
    ++$61de1ee1cac498ae$var$vfe;
    return new $61de1ee1cac498ae$var$Dge(a, b, 0);
}
function $61de1ee1cac498ae$var$Efe(a, b) {
    $61de1ee1cac498ae$var$wfe();
    ++$61de1ee1cac498ae$var$vfe;
    return new $61de1ee1cac498ae$var$Dge(6, a, b);
}
function $61de1ee1cac498ae$var$nfb(a, b) {
    return $61de1ee1cac498ae$var$dfb(a.substr(0, b.length), b);
}
function $61de1ee1cac498ae$var$Mhb(a, b) {
    return $61de1ee1cac498ae$var$ND(b) ? $61de1ee1cac498ae$var$Qhb(a, b) : !!$61de1ee1cac498ae$var$irb(a.f, b);
}
function $61de1ee1cac498ae$var$Rrb(a, b) {
    $61de1ee1cac498ae$var$uCb(b);
    while(a.Ob())b.td(a.Pb());
}
function $61de1ee1cac498ae$var$Vgb(a, b, c) {
    $61de1ee1cac498ae$var$Hgb();
    this.e = a;
    this.d = b;
    this.a = c;
}
function $61de1ee1cac498ae$var$amc(a, b, c, d) {
    var e;
    e = a.i;
    e.i = b;
    e.a = c;
    e.b = d;
}
function $61de1ee1cac498ae$var$xJc(a) {
    var b;
    b = a;
    while(b.f)b = b.f;
    return b;
}
function $61de1ee1cac498ae$var$fkb(a) {
    var b;
    b = $61de1ee1cac498ae$var$bkb(a);
    $61de1ee1cac498ae$var$sCb(b != null);
    return b;
}
function $61de1ee1cac498ae$var$gkb(a) {
    var b;
    b = $61de1ee1cac498ae$var$ckb(a);
    $61de1ee1cac498ae$var$sCb(b != null);
    return b;
}
function $61de1ee1cac498ae$var$cv(a, b) {
    var c;
    c = a.a.gc();
    $61de1ee1cac498ae$var$Sb(b, c);
    return c - b;
}
function $61de1ee1cac498ae$var$Glb(a, b) {
    var c;
    for(c = 0; c < b; ++c)a[c] = false;
}
function $61de1ee1cac498ae$var$Clb(a, b, c, d) {
    var e;
    for(e = b; e < c; ++e)a[e] = d;
}
function $61de1ee1cac498ae$var$ylb(a, b, c, d) {
    $61de1ee1cac498ae$var$oCb(b, c, a.length);
    $61de1ee1cac498ae$var$Clb(a, b, c, d);
}
function $61de1ee1cac498ae$var$Vvb(a, b, c) {
    $61de1ee1cac498ae$var$_vb(c, a.a.c.length);
    $61de1ee1cac498ae$var$Nkb(a.a, c, b);
}
function $61de1ee1cac498ae$var$Lyb(a, b, c) {
    this.c = a;
    this.a = b;
    $61de1ee1cac498ae$var$mmb();
    this.b = c;
}
function $61de1ee1cac498ae$var$Qpb(a, b, c) {
    var d;
    d = a.b[b];
    a.b[b] = c;
    return d;
}
function $61de1ee1cac498ae$var$Qqb(a, b) {
    var c;
    c = a.a.zc(b, a);
    return c == null;
}
function $61de1ee1cac498ae$var$zjb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    return a.d;
}
function $61de1ee1cac498ae$var$vCb(a, b) {
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb(b));
}
function $61de1ee1cac498ae$var$Goc(a, b) {
    if (!b) return false;
    return $61de1ee1cac498ae$var$ye(a, b);
}
function $61de1ee1cac498ae$var$K2c(a, b, c) {
    $61de1ee1cac498ae$var$C2c(a, b.g, c);
    $61de1ee1cac498ae$var$rqb(a.c, b);
    return a;
}
function $61de1ee1cac498ae$var$vVb(a) {
    $61de1ee1cac498ae$var$tVb(a, ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad));
    a.d = true;
    return a;
}
function $61de1ee1cac498ae$var$c2d(a) {
    !a.j && $61de1ee1cac498ae$var$i2d(a, $61de1ee1cac498ae$var$d1d(a.g, a.b));
    return a.j;
}
function $61de1ee1cac498ae$var$nlb(a) {
    $61de1ee1cac498ae$var$yCb(a.b != -1);
    $61de1ee1cac498ae$var$Kkb(a.c, a.a = a.b);
    a.b = -1;
}
function $61de1ee1cac498ae$var$Uhb(a) {
    a.f = new $61de1ee1cac498ae$var$lrb(a);
    a.g = new $61de1ee1cac498ae$var$Frb(a);
    $61de1ee1cac498ae$var$zpb(a);
}
function $61de1ee1cac498ae$var$Plb(a) {
    return new $61de1ee1cac498ae$var$YAb(null, $61de1ee1cac498ae$var$Olb(a, a.length));
}
function $61de1ee1cac498ae$var$ul(a) {
    return new $61de1ee1cac498ae$var$Sr(new $61de1ee1cac498ae$var$xl(a.a.length, a.a));
}
function $61de1ee1cac498ae$var$iD(a) {
    return $61de1ee1cac498ae$var$TC(~a.l & $61de1ee1cac498ae$var$Eje, ~a.m & $61de1ee1cac498ae$var$Eje, ~a.h & $61de1ee1cac498ae$var$Fje);
}
function $61de1ee1cac498ae$var$OD(a) {
    return typeof a === $61de1ee1cac498ae$var$Jhe || typeof a === $61de1ee1cac498ae$var$Nhe;
}
function $61de1ee1cac498ae$var$D9d(a) {
    return a == $61de1ee1cac498ae$var$Pje ? $61de1ee1cac498ae$var$Nwe : a == $61de1ee1cac498ae$var$Qje ? "-INF" : "" + a;
}
function $61de1ee1cac498ae$var$F9d(a) {
    return a == $61de1ee1cac498ae$var$Pje ? $61de1ee1cac498ae$var$Nwe : a == $61de1ee1cac498ae$var$Qje ? "-INF" : "" + a;
}
function $61de1ee1cac498ae$var$yRb(a, b) {
    return a > 0 ? $61de1ee1cac498ae$var$$wnd.Math.log(a / b) : -100;
}
function $61de1ee1cac498ae$var$ueb(a, b) {
    return $61de1ee1cac498ae$var$ybb(a, b) < 0 ? -1 : $61de1ee1cac498ae$var$ybb(a, b) > 0 ? 1 : 0;
}
function $61de1ee1cac498ae$var$HMb(a, b, c) {
    return $61de1ee1cac498ae$var$IMb(a, $61de1ee1cac498ae$var$BD(b, 46), $61de1ee1cac498ae$var$BD(c, 167));
}
function $61de1ee1cac498ae$var$iq(a, b) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rl($61de1ee1cac498ae$var$Wm(a.a)).Xb(b), 42).cd();
}
function $61de1ee1cac498ae$var$Olb(a, b) {
    return $61de1ee1cac498ae$var$avb(b, a.length), new $61de1ee1cac498ae$var$vvb(a, b);
}
function $61de1ee1cac498ae$var$Pyd(a, b) {
    this.d = a;
    $61de1ee1cac498ae$var$Fyd.call(this, a);
    this.e = b;
}
function $61de1ee1cac498ae$var$Lub(a) {
    this.d = ($61de1ee1cac498ae$var$uCb(a), a);
    this.a = 0;
    this.c = $61de1ee1cac498ae$var$rie;
}
function $61de1ee1cac498ae$var$rge(a, b) {
    $61de1ee1cac498ae$var$xfe.call(this, 1);
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$Rzb(a, b) {
    !a.c ? $61de1ee1cac498ae$var$Ekb(a.b, b) : $61de1ee1cac498ae$var$Rzb(a.c, b);
    return a;
}
function $61de1ee1cac498ae$var$uB(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$tB(a, b);
    $61de1ee1cac498ae$var$vB(a, b, c);
    return d;
}
function $61de1ee1cac498ae$var$ZBb(a, b) {
    var c;
    c = a.slice(0, b);
    return $61de1ee1cac498ae$var$PC(c, a);
}
function $61de1ee1cac498ae$var$Flb(a, b, c) {
    var d;
    for(d = 0; d < b; ++d)$61de1ee1cac498ae$var$NC(a, d, c);
}
function $61de1ee1cac498ae$var$ffb(a, b, c, d, e) {
    while(b < c)d[e++] = $61de1ee1cac498ae$var$bfb(a, b++);
}
function $61de1ee1cac498ae$var$hLb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.c.c + a.c.b, b.c.c + b.c.b);
}
function $61de1ee1cac498ae$var$Axb(a, b) {
    return $61de1ee1cac498ae$var$Iwb(a.a, b, ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb)) == null;
}
function $61de1ee1cac498ae$var$Vsb(a, b) {
    $61de1ee1cac498ae$var$Gsb(a.d, b, a.b.b, a.b);
    ++a.a;
    a.c = null;
}
function $61de1ee1cac498ae$var$d3d(a, b) {
    $61de1ee1cac498ae$var$JLd(a, $61de1ee1cac498ae$var$JD(b, 153) ? b : $61de1ee1cac498ae$var$BD(b, 1937).gl());
}
function $61de1ee1cac498ae$var$hkc(a, b) {
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb(a.Oc(), new $61de1ee1cac498ae$var$Rkc), new $61de1ee1cac498ae$var$Tkc(b));
}
function $61de1ee1cac498ae$var$kkc(a, b, c, d, e) {
    $61de1ee1cac498ae$var$jkc(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(b.k, c), 15), c, d, e);
}
function $61de1ee1cac498ae$var$lOc(a) {
    a.s = NaN;
    a.c = NaN;
    $61de1ee1cac498ae$var$mOc(a, a.e);
    $61de1ee1cac498ae$var$mOc(a, a.j);
}
function $61de1ee1cac498ae$var$it(a) {
    a.a = null;
    a.e = null;
    $61de1ee1cac498ae$var$Uhb(a.b);
    a.d = 0;
    ++a.c;
}
function $61de1ee1cac498ae$var$gKc(a) {
    return $61de1ee1cac498ae$var$$wnd.Math.abs(a.d.e - a.e.e) - a.a;
}
function $61de1ee1cac498ae$var$MAd(a, b, c) {
    return $61de1ee1cac498ae$var$BD(a.c._c(b, $61de1ee1cac498ae$var$BD(c, 133)), 42);
}
function $61de1ee1cac498ae$var$os() {
    $61de1ee1cac498ae$var$hs();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$yG, 1), $61de1ee1cac498ae$var$Kie, 538, 0, [
        $61de1ee1cac498ae$var$gs
    ]);
}
function $61de1ee1cac498ae$var$VPb(a) {
    $61de1ee1cac498ae$var$QPb();
    return $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$jtd(a)) == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$ltd(a));
}
function $61de1ee1cac498ae$var$aRb(a) {
    $61de1ee1cac498ae$var$_Qb.call(this);
    this.a = a;
    $61de1ee1cac498ae$var$Ekb(a.a, this);
}
function $61de1ee1cac498ae$var$tPc(a, b) {
    this.d = $61de1ee1cac498ae$var$DPc(a);
    this.c = b;
    this.a = 0.5 * b;
}
function $61de1ee1cac498ae$var$A6d() {
    $61de1ee1cac498ae$var$$rb.call(this);
    this.a = true;
    this.b = true;
}
function $61de1ee1cac498ae$var$aLd(a) {
    return (a.i == null && $61de1ee1cac498ae$var$TKd(a), a.i).length;
}
function $61de1ee1cac498ae$var$oRd(a) {
    return $61de1ee1cac498ae$var$JD(a, 99) && ($61de1ee1cac498ae$var$BD(a, 18).Bb & $61de1ee1cac498ae$var$ote) != 0;
}
function $61de1ee1cac498ae$var$w2d(a, b) {
    ++a.j;
    $61de1ee1cac498ae$var$t3d(a, a.i, b);
    $61de1ee1cac498ae$var$v2d(a, $61de1ee1cac498ae$var$BD(b, 332));
}
function $61de1ee1cac498ae$var$vId(a, b) {
    b = a.nk(null, b);
    return $61de1ee1cac498ae$var$uId(a, null, b);
}
function $61de1ee1cac498ae$var$ytd(a, b) {
    a.hi() && (b = $61de1ee1cac498ae$var$Dtd(a, b));
    return a.Wh(b);
}
function $61de1ee1cac498ae$var$mdb(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$ldb(a, b);
    $61de1ee1cac498ae$var$zdb(c, d);
    return d;
}
function $61de1ee1cac498ae$var$ldb(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$jdb;
    c.j = a;
    c.d = b;
    return c;
}
function $61de1ee1cac498ae$var$Qb(a) {
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Geb);
    return a;
}
function $61de1ee1cac498ae$var$Fc(a) {
    var b;
    b = a.j;
    return !b ? a.j = new $61de1ee1cac498ae$var$Cw(a) : b;
}
function $61de1ee1cac498ae$var$Vi(a) {
    var b;
    b = a.f;
    return !b ? a.f = new $61de1ee1cac498ae$var$Rj(a) : b;
}
function $61de1ee1cac498ae$var$ci(a) {
    var b;
    return b = a.k, !b ? a.k = new $61de1ee1cac498ae$var$th(a) : b;
}
function $61de1ee1cac498ae$var$Uc(a) {
    var b;
    return b = a.k, !b ? a.k = new $61de1ee1cac498ae$var$th(a) : b;
}
function $61de1ee1cac498ae$var$Pc(a) {
    var b;
    return b = a.g, !b ? a.g = new $61de1ee1cac498ae$var$lh(a) : b;
}
function $61de1ee1cac498ae$var$Yi(a) {
    var b;
    return b = a.i, !b ? a.i = new $61de1ee1cac498ae$var$Ci(a) : b;
}
function $61de1ee1cac498ae$var$qo(a) {
    var b;
    b = a.d;
    return !b ? a.d = new $61de1ee1cac498ae$var$ap(a) : b;
}
function $61de1ee1cac498ae$var$Fb(a) {
    $61de1ee1cac498ae$var$Qb(a);
    return $61de1ee1cac498ae$var$JD(a, 475) ? $61de1ee1cac498ae$var$BD(a, 475) : $61de1ee1cac498ae$var$fcb(a);
}
function $61de1ee1cac498ae$var$Ix(a) {
    if ($61de1ee1cac498ae$var$JD(a, 607)) return a;
    return new $61de1ee1cac498ae$var$by(a);
}
function $61de1ee1cac498ae$var$qj(a, b) {
    $61de1ee1cac498ae$var$Pb(b, a.c.b.c.gc());
    return new $61de1ee1cac498ae$var$Fj(a, b);
}
function $61de1ee1cac498ae$var$Dfe(a, b, c) {
    $61de1ee1cac498ae$var$wfe();
    ++$61de1ee1cac498ae$var$vfe;
    return new $61de1ee1cac498ae$var$zge(a, b, c);
}
function $61de1ee1cac498ae$var$NC(a, b, c) {
    $61de1ee1cac498ae$var$qCb(c == null || $61de1ee1cac498ae$var$FC(a, c));
    return a[b] = c;
}
function $61de1ee1cac498ae$var$bv(a, b) {
    var c;
    c = a.a.gc();
    $61de1ee1cac498ae$var$Pb(b, c);
    return c - 1 - b;
}
function $61de1ee1cac498ae$var$Afb(a, b) {
    a.a += String.fromCharCode(b);
    return a;
}
function $61de1ee1cac498ae$var$Kfb(a, b) {
    a.a += String.fromCharCode(b);
    return a;
}
function $61de1ee1cac498ae$var$ovb(a, b) {
    $61de1ee1cac498ae$var$uCb(b);
    while(a.c < a.d)a.ze(b, a.c++);
}
function $61de1ee1cac498ae$var$Ohb(a, b) {
    return $61de1ee1cac498ae$var$ND(b) ? $61de1ee1cac498ae$var$Phb(a, b) : $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, b));
}
function $61de1ee1cac498ae$var$ZPb(a, b) {
    $61de1ee1cac498ae$var$QPb();
    return a == $61de1ee1cac498ae$var$jtd(b) ? $61de1ee1cac498ae$var$ltd(b) : $61de1ee1cac498ae$var$jtd(b);
}
function $61de1ee1cac498ae$var$isd(a, b) {
    $61de1ee1cac498ae$var$Qpd(a, new $61de1ee1cac498ae$var$yC(b.f != null ? b.f : "" + b.g));
}
function $61de1ee1cac498ae$var$ksd(a, b) {
    $61de1ee1cac498ae$var$Qpd(a, new $61de1ee1cac498ae$var$yC(b.f != null ? b.f : "" + b.g));
}
function $61de1ee1cac498ae$var$dVb(a) {
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.c = a;
}
function $61de1ee1cac498ae$var$H1b(a) {
    this.c = new $61de1ee1cac498ae$var$d7c;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.b = a;
}
function $61de1ee1cac498ae$var$pRb(a) {
    $61de1ee1cac498ae$var$_Qb.call(this);
    this.a = new $61de1ee1cac498ae$var$d7c;
    this.c = a;
}
function $61de1ee1cac498ae$var$yC(a) {
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Geb);
    this.a = a;
}
function $61de1ee1cac498ae$var$HA(a) {
    $61de1ee1cac498ae$var$fA();
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.a = a;
    $61de1ee1cac498ae$var$sA(this, a);
}
function $61de1ee1cac498ae$var$v4c(a) {
    this.c = a;
    this.a = new $61de1ee1cac498ae$var$Psb;
    this.b = new $61de1ee1cac498ae$var$Psb;
}
function $61de1ee1cac498ae$var$GB() {
    $61de1ee1cac498ae$var$GB = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$EB = new $61de1ee1cac498ae$var$HB(false);
    $61de1ee1cac498ae$var$FB = new $61de1ee1cac498ae$var$HB(true);
}
function $61de1ee1cac498ae$var$im() {
    $61de1ee1cac498ae$var$im = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ql();
    $61de1ee1cac498ae$var$hm = new $61de1ee1cac498ae$var$ux(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb));
}
function $61de1ee1cac498ae$var$yx() {
    $61de1ee1cac498ae$var$yx = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ql();
    $61de1ee1cac498ae$var$xx = new $61de1ee1cac498ae$var$zx(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$lmb));
}
function $61de1ee1cac498ae$var$NFd() {
    $61de1ee1cac498ae$var$NFd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$MFd = $61de1ee1cac498ae$var$BZd();
    !!($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$PFd) && $61de1ee1cac498ae$var$DZd();
}
function $61de1ee1cac498ae$var$aac(a, b) {
    $61de1ee1cac498ae$var$I9b();
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a, b.d), 15).Fc(b);
}
function $61de1ee1cac498ae$var$pTb(a, b, c, d) {
    return c == 0 || (c - d) / c < a.e || b >= a.g;
}
function $61de1ee1cac498ae$var$NHc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$THc(a, b, c);
    return $61de1ee1cac498ae$var$MHc(a, d);
}
function $61de1ee1cac498ae$var$Qpd(a, b) {
    var c;
    c = a.a.length;
    $61de1ee1cac498ae$var$tB(a, c);
    $61de1ee1cac498ae$var$vB(a, c, b);
}
function $61de1ee1cac498ae$var$gCb(a, b) {
    var c;
    c = console[a];
    c.call(console, b);
}
function $61de1ee1cac498ae$var$Bvd(a, b) {
    var c;
    ++a.j;
    c = a.Vi();
    a.Ii(a.oi(c, b));
}
function $61de1ee1cac498ae$var$E1c(a, b, c) {
    $61de1ee1cac498ae$var$BD(b.b, 65);
    $61de1ee1cac498ae$var$Hkb(b.a, new $61de1ee1cac498ae$var$L1c(a, c, b));
}
function $61de1ee1cac498ae$var$oXd(a, b, c) {
    $61de1ee1cac498ae$var$VVd.call(this, b);
    this.a = a;
    this.b = c;
}
function $61de1ee1cac498ae$var$Dge(a, b, c) {
    $61de1ee1cac498ae$var$xfe.call(this, a);
    this.a = b;
    this.b = c;
}
function $61de1ee1cac498ae$var$dYd(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$lVd.call(this, b);
    this.b = c;
}
function $61de1ee1cac498ae$var$f0d(a, b, c) {
    this.a = a;
    $61de1ee1cac498ae$var$mxd.call(this, 8, b, null, c);
}
function $61de1ee1cac498ae$var$z1d(a) {
    this.a = ($61de1ee1cac498ae$var$uCb($61de1ee1cac498ae$var$Rve), $61de1ee1cac498ae$var$Rve);
    this.b = a;
    new $61de1ee1cac498ae$var$oUd;
}
function $61de1ee1cac498ae$var$ct(a) {
    this.c = a;
    this.b = this.c.a;
    this.a = this.c.e;
}
function $61de1ee1cac498ae$var$usb(a) {
    this.c = a;
    this.b = a.a.d.a;
    $61de1ee1cac498ae$var$ypb(a.a.e, this);
}
function $61de1ee1cac498ae$var$uib(a) {
    $61de1ee1cac498ae$var$yCb(a.c != -1);
    a.d.$c(a.c);
    a.b = a.c;
    a.c = -1;
}
function $61de1ee1cac498ae$var$U6c(a) {
    return $61de1ee1cac498ae$var$$wnd.Math.sqrt(a.a * a.a + a.b * a.b);
}
function $61de1ee1cac498ae$var$Uvb(a, b) {
    return $61de1ee1cac498ae$var$_vb(b, a.a.c.length), $61de1ee1cac498ae$var$Ikb(a.a, b);
}
function $61de1ee1cac498ae$var$Hb(a, b) {
    return $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b) || a != null && $61de1ee1cac498ae$var$pb(a, b);
}
function $61de1ee1cac498ae$var$oAb(a) {
    if (0 >= a) return new $61de1ee1cac498ae$var$yAb;
    return $61de1ee1cac498ae$var$pAb(a - 1);
}
function $61de1ee1cac498ae$var$Nfe(a) {
    if (!$61de1ee1cac498ae$var$bfe) return false;
    return $61de1ee1cac498ae$var$Qhb($61de1ee1cac498ae$var$bfe, a);
}
function $61de1ee1cac498ae$var$Ehe(a) {
    if (a) return a.dc();
    return !a.Kc().Ob();
}
function $61de1ee1cac498ae$var$Q_b(a) {
    if (!a.a && !!a.c) return a.c.b;
    return a.a;
}
function $61de1ee1cac498ae$var$LHd(a) {
    !a.a && (a.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$m5, a, 4));
    return a.a;
}
function $61de1ee1cac498ae$var$LQd(a) {
    !a.d && (a.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, a, 1));
    return a.d;
}
function $61de1ee1cac498ae$var$uCb(a) {
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Geb);
    return a;
}
function $61de1ee1cac498ae$var$Qzb(a) {
    if (!a.c) {
        a.d = true;
        $61de1ee1cac498ae$var$Szb(a);
    } else a.c.He();
}
function $61de1ee1cac498ae$var$Tzb(a) {
    if (!a.c) {
        $61de1ee1cac498ae$var$Uzb(a);
        a.d = true;
    } else $61de1ee1cac498ae$var$Tzb(a.c);
}
function $61de1ee1cac498ae$var$Kpb(a) {
    $61de1ee1cac498ae$var$Ae(a.a);
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, a.b.length, 5, 1);
}
function $61de1ee1cac498ae$var$qlc(a, b) {
    return $61de1ee1cac498ae$var$beb(b.j.c.length, a.j.c.length);
}
function $61de1ee1cac498ae$var$igd(a, b) {
    a.c < 0 || a.b.b < a.c ? $61de1ee1cac498ae$var$Fsb(a.b, b) : a.a._e(b);
}
function $61de1ee1cac498ae$var$Did(a, b) {
    var c;
    c = a.Yg(b);
    c >= 0 ? a.Bh(c) : $61de1ee1cac498ae$var$vid(a, b);
}
function $61de1ee1cac498ae$var$WHc(a) {
    var b, c;
    b = a.c.i.c;
    c = a.d.i.c;
    return b == c;
}
function $61de1ee1cac498ae$var$Wwd(a) {
    if (a.p != 4) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return a.e;
}
function $61de1ee1cac498ae$var$Vwd(a) {
    if (a.p != 3) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return a.e;
}
function $61de1ee1cac498ae$var$Ywd(a) {
    if (a.p != 6) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return a.f;
}
function $61de1ee1cac498ae$var$fxd(a) {
    if (a.p != 6) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return a.k;
}
function $61de1ee1cac498ae$var$cxd(a) {
    if (a.p != 3) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return a.j;
}
function $61de1ee1cac498ae$var$dxd(a) {
    if (a.p != 4) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return a.j;
}
function $61de1ee1cac498ae$var$AYd(a) {
    !a.b && (a.b = new $61de1ee1cac498ae$var$RYd(new $61de1ee1cac498ae$var$NYd));
    return a.b;
}
function $61de1ee1cac498ae$var$$1d(a) {
    a.c == -2 && $61de1ee1cac498ae$var$e2d(a, $61de1ee1cac498ae$var$X0d(a.g, a.b));
    return a.c;
}
function $61de1ee1cac498ae$var$pdb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$ldb("", a);
    c.n = b;
    c.i = 1;
    return c;
}
function $61de1ee1cac498ae$var$MNb(a, b) {
    $61de1ee1cac498ae$var$$Nb($61de1ee1cac498ae$var$BD(b.b, 65), a);
    $61de1ee1cac498ae$var$Hkb(b.a, new $61de1ee1cac498ae$var$RNb(a));
}
function $61de1ee1cac498ae$var$Cnd(a, b) {
    $61de1ee1cac498ae$var$wtd((!a.a && (a.a = new $61de1ee1cac498ae$var$fTd(a, a)), a.a), b);
}
function $61de1ee1cac498ae$var$Qzd(a, b) {
    this.b = a;
    $61de1ee1cac498ae$var$Pyd.call(this, a, b);
    $61de1ee1cac498ae$var$Ozd(this);
}
function $61de1ee1cac498ae$var$Yzd(a, b) {
    this.b = a;
    $61de1ee1cac498ae$var$czd.call(this, a, b);
    $61de1ee1cac498ae$var$Wzd(this);
}
function $61de1ee1cac498ae$var$Ms(a, b, c, d) {
    $61de1ee1cac498ae$var$Wo.call(this, a, b);
    this.d = c;
    this.a = d;
}
function $61de1ee1cac498ae$var$$o(a, b, c, d) {
    $61de1ee1cac498ae$var$Wo.call(this, a, c);
    this.a = b;
    this.f = d;
}
function $61de1ee1cac498ae$var$iy(a, b) {
    $61de1ee1cac498ae$var$Pp.call(this, $61de1ee1cac498ae$var$umb($61de1ee1cac498ae$var$Qb(a), $61de1ee1cac498ae$var$Qb(b)));
    this.a = b;
}
function $61de1ee1cac498ae$var$cae() {
    $61de1ee1cac498ae$var$fod.call(this, $61de1ee1cac498ae$var$Ewe, ($61de1ee1cac498ae$var$p8d(), $61de1ee1cac498ae$var$o8d));
    $61de1ee1cac498ae$var$$9d(this);
}
function $61de1ee1cac498ae$var$AZd() {
    $61de1ee1cac498ae$var$fod.call(this, $61de1ee1cac498ae$var$_ve, ($61de1ee1cac498ae$var$LFd(), $61de1ee1cac498ae$var$KFd));
    $61de1ee1cac498ae$var$uZd(this);
}
function $61de1ee1cac498ae$var$T0c() {
    $61de1ee1cac498ae$var$$r.call(this, "DELAUNAY_TRIANGULATION", 0);
}
function $61de1ee1cac498ae$var$vfb(a) {
    return String.fromCharCode.apply(null, a);
}
function $61de1ee1cac498ae$var$Rhb(a, b, c) {
    return $61de1ee1cac498ae$var$ND(b) ? $61de1ee1cac498ae$var$Shb(a, b, c) : $61de1ee1cac498ae$var$jrb(a.f, b, c);
}
function $61de1ee1cac498ae$var$tmb(a) {
    $61de1ee1cac498ae$var$mmb();
    return !a ? ($61de1ee1cac498ae$var$ipb(), $61de1ee1cac498ae$var$ipb(), $61de1ee1cac498ae$var$hpb) : a.ve();
}
function $61de1ee1cac498ae$var$d2c(a, b, c) {
    $61de1ee1cac498ae$var$Y1c();
    return c.pg(a, $61de1ee1cac498ae$var$BD(b.cd(), 146));
}
function $61de1ee1cac498ae$var$ix(a, b) {
    $61de1ee1cac498ae$var$ex();
    return new $61de1ee1cac498ae$var$gx(new $61de1ee1cac498ae$var$il(a), new $61de1ee1cac498ae$var$Uk(b));
}
function $61de1ee1cac498ae$var$Iu(a) {
    $61de1ee1cac498ae$var$Xj(a, $61de1ee1cac498ae$var$Mie);
    return $61de1ee1cac498ae$var$Oy($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$wbb(5, a), a / 10 | 0));
}
function $61de1ee1cac498ae$var$Vm() {
    $61de1ee1cac498ae$var$Vm = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Um = new $61de1ee1cac498ae$var$wx($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$CK, 1), $61de1ee1cac498ae$var$zie, 42, 0, []));
}
function $61de1ee1cac498ae$var$hob(a) {
    !a.d && (a.d = new $61de1ee1cac498ae$var$lnb(a.c.Cc()));
    return a.d;
}
function $61de1ee1cac498ae$var$eob(a) {
    !a.a && (a.a = new $61de1ee1cac498ae$var$Gob(a.c.vc()));
    return a.a;
}
function $61de1ee1cac498ae$var$gob(a) {
    !a.b && (a.b = new $61de1ee1cac498ae$var$zob(a.c.ec()));
    return a.b;
}
function $61de1ee1cac498ae$var$keb(a, b) {
    while(b-- > 0)a = a << 1 | (a < 0 ? 1 : 0);
    return a;
}
function $61de1ee1cac498ae$var$wtb(a, b) {
    return $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b) || a != null && $61de1ee1cac498ae$var$pb(a, b);
}
function $61de1ee1cac498ae$var$Gbc(a, b) {
    return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$BD(b.b, 19).a < a ? true : false;
}
function $61de1ee1cac498ae$var$Hbc(a, b) {
    return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$BD(b.a, 19).a < a ? true : false;
}
function $61de1ee1cac498ae$var$Mpb(a, b) {
    return $61de1ee1cac498ae$var$tqb(a.a, b) ? a.b[$61de1ee1cac498ae$var$BD(b, 22).g] : null;
}
function $61de1ee1cac498ae$var$kcb(a, b, c, d) {
    a.a = $61de1ee1cac498ae$var$qfb(a.a, 0, b) + ("" + d) + $61de1ee1cac498ae$var$pfb(a.a, c);
}
function $61de1ee1cac498ae$var$OJb(a, b) {
    a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd)) && $61de1ee1cac498ae$var$MJb(a, b);
    $61de1ee1cac498ae$var$QJb(a, b);
}
function $61de1ee1cac498ae$var$bfb(a, b) {
    $61de1ee1cac498ae$var$BCb(b, a.length);
    return a.charCodeAt(b);
}
function $61de1ee1cac498ae$var$vtb() {
    $61de1ee1cac498ae$var$hz.call(this, "There is no more element.");
}
function $61de1ee1cac498ae$var$xkb(a) {
    this.d = a;
    this.a = this.d.b;
    this.b = this.d.c;
}
function $61de1ee1cac498ae$var$kEb(a) {
    a.b = false;
    a.c = false;
    a.d = false;
    a.a = false;
}
function $61de1ee1cac498ae$var$Znd(a, b, c, d) {
    $61de1ee1cac498ae$var$Ynd(a, b, c, false);
    $61de1ee1cac498ae$var$LPd(a, d);
    return a;
}
function $61de1ee1cac498ae$var$h3c(a) {
    a.j.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.a = -1;
    return a;
}
function $61de1ee1cac498ae$var$Old(a) {
    !a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8));
    return a.c;
}
function $61de1ee1cac498ae$var$Nld(a) {
    !a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7));
    return a.b;
}
function $61de1ee1cac498ae$var$Kkd(a) {
    !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7));
    return a.n;
}
function $61de1ee1cac498ae$var$Yod(a) {
    !a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9));
    return a.c;
}
function $61de1ee1cac498ae$var$a2d(a) {
    a.e == $61de1ee1cac498ae$var$Gwe && $61de1ee1cac498ae$var$g2d(a, $61de1ee1cac498ae$var$a1d(a.g, a.b));
    return a.e;
}
function $61de1ee1cac498ae$var$b2d(a) {
    a.f == $61de1ee1cac498ae$var$Gwe && $61de1ee1cac498ae$var$h2d(a, $61de1ee1cac498ae$var$b1d(a.g, a.b));
    return a.f;
}
function $61de1ee1cac498ae$var$Ah(a) {
    var b;
    b = a.b;
    !b && (a.b = b = new $61de1ee1cac498ae$var$Ph(a));
    return b;
}
function $61de1ee1cac498ae$var$Ae(a) {
    var b;
    for(b = a.Kc(); b.Ob();){
        b.Pb();
        b.Qb();
    }
}
function $61de1ee1cac498ae$var$Fg(a) {
    $61de1ee1cac498ae$var$ag(a.d);
    if (a.d.d != a.c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
}
function $61de1ee1cac498ae$var$Xx(a, b) {
    this.b = a;
    this.c = b;
    this.a = new $61de1ee1cac498ae$var$Gqb(this.b);
}
function $61de1ee1cac498ae$var$Zeb(a, b, c) {
    this.a = $61de1ee1cac498ae$var$Zie;
    this.d = a;
    this.b = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$Mub(a, b) {
    this.d = ($61de1ee1cac498ae$var$uCb(a), a);
    this.a = 16449;
    this.c = b;
}
function $61de1ee1cac498ae$var$nqd(a, b) {
    $61de1ee1cac498ae$var$ctd(a, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$Xpd(b, "x")), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$Xpd(b, "y")));
}
function $61de1ee1cac498ae$var$Aqd(a, b) {
    $61de1ee1cac498ae$var$ctd(a, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$Xpd(b, "x")), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$Xpd(b, "y")));
}
function $61de1ee1cac498ae$var$JAb(a, b) {
    $61de1ee1cac498ae$var$Uzb(a);
    return new $61de1ee1cac498ae$var$YAb(a, new $61de1ee1cac498ae$var$qBb(b, a.a));
}
function $61de1ee1cac498ae$var$NAb(a, b) {
    $61de1ee1cac498ae$var$Uzb(a);
    return new $61de1ee1cac498ae$var$YAb(a, new $61de1ee1cac498ae$var$IBb(b, a.a));
}
function $61de1ee1cac498ae$var$OAb(a, b) {
    $61de1ee1cac498ae$var$Uzb(a);
    return new $61de1ee1cac498ae$var$bAb(a, new $61de1ee1cac498ae$var$wBb(b, a.a));
}
function $61de1ee1cac498ae$var$PAb(a, b) {
    $61de1ee1cac498ae$var$Uzb(a);
    return new $61de1ee1cac498ae$var$vAb(a, new $61de1ee1cac498ae$var$CBb(b, a.a));
}
function $61de1ee1cac498ae$var$Cy(a, b) {
    return new $61de1ee1cac498ae$var$Ay($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 62), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(b), 62));
}
function $61de1ee1cac498ae$var$PWb(a, b) {
    $61de1ee1cac498ae$var$LWb();
    return $61de1ee1cac498ae$var$Kdb(($61de1ee1cac498ae$var$uCb(a), a), ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$fPb() {
    $61de1ee1cac498ae$var$cPb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$GO, 1), $61de1ee1cac498ae$var$Kie, 481, 0, [
        $61de1ee1cac498ae$var$bPb
    ]);
}
function $61de1ee1cac498ae$var$o_c() {
    $61de1ee1cac498ae$var$i_c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$N_, 1), $61de1ee1cac498ae$var$Kie, 482, 0, [
        $61de1ee1cac498ae$var$h_c
    ]);
}
function $61de1ee1cac498ae$var$x_c() {
    $61de1ee1cac498ae$var$s_c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O_, 1), $61de1ee1cac498ae$var$Kie, 551, 0, [
        $61de1ee1cac498ae$var$r_c
    ]);
}
function $61de1ee1cac498ae$var$X0c() {
    $61de1ee1cac498ae$var$R0c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$W_, 1), $61de1ee1cac498ae$var$Kie, 530, 0, [
        $61de1ee1cac498ae$var$Q0c
    ]);
}
function $61de1ee1cac498ae$var$cEc(a) {
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$nie, 48, a, 0, 2);
}
function $61de1ee1cac498ae$var$l$b(a, b, c, d) {
    this.a = a;
    this.e = b;
    this.d = c;
    this.c = d;
}
function $61de1ee1cac498ae$var$QIc(a, b, c, d) {
    this.a = a;
    this.c = b;
    this.b = c;
    this.d = d;
}
function $61de1ee1cac498ae$var$rKc(a, b, c, d) {
    this.c = a;
    this.b = b;
    this.a = c;
    this.d = d;
}
function $61de1ee1cac498ae$var$WKc(a, b, c, d) {
    this.c = a;
    this.b = b;
    this.d = c;
    this.a = d;
}
function $61de1ee1cac498ae$var$J6c(a, b, c, d) {
    this.c = a;
    this.d = b;
    this.b = c;
    this.a = d;
}
function $61de1ee1cac498ae$var$gPc(a, b, c, d) {
    this.a = a;
    this.d = b;
    this.c = c;
    this.b = d;
}
function $61de1ee1cac498ae$var$Blc(a, b, c, d) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
    this.a = c;
    this.b = d;
}
function $61de1ee1cac498ae$var$Ggd(a, b, c, d) {
    this.a = a;
    this.c = b;
    this.d = c;
    this.b = d;
}
function $61de1ee1cac498ae$var$pec(a, b, c) {
    $61de1ee1cac498ae$var$Pmc(a.a, c);
    $61de1ee1cac498ae$var$dmc(c);
    $61de1ee1cac498ae$var$enc(a.b, c);
    $61de1ee1cac498ae$var$xmc(b, c);
}
function $61de1ee1cac498ae$var$Pid(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$QEd(a);
    e = b.Kh(c, d);
    return e;
}
function $61de1ee1cac498ae$var$KPb(a, b) {
    var c, d;
    c = a / b;
    d = $61de1ee1cac498ae$var$QD(c);
    c > d && ++d;
    return d;
}
function $61de1ee1cac498ae$var$Nnd(a) {
    var b, c;
    c = (b = new $61de1ee1cac498ae$var$UQd, b);
    $61de1ee1cac498ae$var$NQd(c, a);
    return c;
}
function $61de1ee1cac498ae$var$Ond(a) {
    var b, c;
    c = (b = new $61de1ee1cac498ae$var$UQd, b);
    $61de1ee1cac498ae$var$RQd(c, a);
    return c;
}
function $61de1ee1cac498ae$var$hqd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Ohb(a.f, b);
    $61de1ee1cac498ae$var$Yqd(b, c);
    return null;
}
function $61de1ee1cac498ae$var$JZb(a) {
    var b;
    b = $61de1ee1cac498ae$var$P2b(a);
    if (b) return b;
    return null;
}
function $61de1ee1cac498ae$var$Wod(a) {
    !a.b && (a.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, a, 12, 3));
    return a.b;
}
function $61de1ee1cac498ae$var$YEd(a) {
    return a != null && $61de1ee1cac498ae$var$hnb($61de1ee1cac498ae$var$GEd, a.toLowerCase());
}
function $61de1ee1cac498ae$var$ied(a, b) {
    return $61de1ee1cac498ae$var$Kdb($61de1ee1cac498ae$var$red(a) * $61de1ee1cac498ae$var$qed(a), $61de1ee1cac498ae$var$red(b) * $61de1ee1cac498ae$var$qed(b));
}
function $61de1ee1cac498ae$var$jed(a, b) {
    return $61de1ee1cac498ae$var$Kdb($61de1ee1cac498ae$var$red(a) * $61de1ee1cac498ae$var$qed(a), $61de1ee1cac498ae$var$red(b) * $61de1ee1cac498ae$var$qed(b));
}
function $61de1ee1cac498ae$var$wEb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.d.c + a.d.b / 2, b.d.c + b.d.b / 2);
}
function $61de1ee1cac498ae$var$UVb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a.g.c + a.g.b / 2, b.g.c + b.g.b / 2);
}
function $61de1ee1cac498ae$var$pQb(a, b, c) {
    c.a ? $61de1ee1cac498ae$var$eld(a, b.b - a.f / 2) : $61de1ee1cac498ae$var$dld(a, b.a - a.g / 2);
}
function $61de1ee1cac498ae$var$prd(a, b, c, d) {
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
}
function $61de1ee1cac498ae$var$ord(a, b, c, d) {
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
}
function $61de1ee1cac498ae$var$JVd(a, b, c, d) {
    this.e = a;
    this.a = b;
    this.c = c;
    this.d = d;
}
function $61de1ee1cac498ae$var$ZVd(a, b, c, d) {
    this.a = a;
    this.c = b;
    this.d = c;
    this.b = d;
}
function $61de1ee1cac498ae$var$cXd(a, b, c, d) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$mWd.call(this, b, c, d);
    this.a = a;
}
function $61de1ee1cac498ae$var$jXd(a, b, c, d) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$mWd.call(this, b, c, d);
    this.a = a;
}
function $61de1ee1cac498ae$var$Ng(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$Hg.call(this, a, $61de1ee1cac498ae$var$BD(a.d, 15).Zc(b));
}
function $61de1ee1cac498ae$var$ZBd(a) {
    this.f = a;
    this.c = this.f.e;
    a.f > 0 && $61de1ee1cac498ae$var$YBd(this);
}
function $61de1ee1cac498ae$var$lBb(a, b, c, d) {
    this.b = a;
    this.c = d;
    $61de1ee1cac498ae$var$nvb.call(this, b, c);
}
function $61de1ee1cac498ae$var$tib(a) {
    $61de1ee1cac498ae$var$sCb(a.b < a.d.gc());
    return a.d.Xb(a.c = a.b++);
}
function $61de1ee1cac498ae$var$Osb(a) {
    a.a.a = a.c;
    a.c.b = a.a;
    a.a.b = a.c.a = null;
    a.b = 0;
}
function $61de1ee1cac498ae$var$u_b(a, b) {
    a.b = b.b;
    a.c = b.c;
    a.d = b.d;
    a.a = b.a;
    return a;
}
function $61de1ee1cac498ae$var$Ry(a) {
    if (a.n) {
        a.e !== $61de1ee1cac498ae$var$Sie && a._d();
        a.j = null;
    }
    return a;
}
function $61de1ee1cac498ae$var$FD(a) {
    $61de1ee1cac498ae$var$CCb(a == null || $61de1ee1cac498ae$var$OD(a) && !(a.im === $61de1ee1cac498ae$var$gcb));
    return a;
}
function $61de1ee1cac498ae$var$p4b(a) {
    this.b = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Gkb(this.b, this.b);
    this.a = a;
}
function $61de1ee1cac498ae$var$QPb() {
    $61de1ee1cac498ae$var$QPb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$PPb = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$OPb = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$NPb = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$mmb() {
    $61de1ee1cac498ae$var$mmb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$jmb = new $61de1ee1cac498ae$var$xmb;
    $61de1ee1cac498ae$var$kmb = new $61de1ee1cac498ae$var$Qmb;
    $61de1ee1cac498ae$var$lmb = new $61de1ee1cac498ae$var$Ymb;
}
function $61de1ee1cac498ae$var$ipb() {
    $61de1ee1cac498ae$var$ipb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$fpb = new $61de1ee1cac498ae$var$kpb;
    $61de1ee1cac498ae$var$gpb = new $61de1ee1cac498ae$var$kpb;
    $61de1ee1cac498ae$var$hpb = new $61de1ee1cac498ae$var$ppb;
}
function $61de1ee1cac498ae$var$ODb() {
    $61de1ee1cac498ae$var$ODb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$LDb = new $61de1ee1cac498ae$var$JDb;
    $61de1ee1cac498ae$var$NDb = new $61de1ee1cac498ae$var$oEb;
    $61de1ee1cac498ae$var$MDb = new $61de1ee1cac498ae$var$fEb;
}
function $61de1ee1cac498ae$var$MCb() {
    if ($61de1ee1cac498ae$var$HCb == 256) {
        $61de1ee1cac498ae$var$GCb = $61de1ee1cac498ae$var$ICb;
        $61de1ee1cac498ae$var$ICb = new $61de1ee1cac498ae$var$nb;
        $61de1ee1cac498ae$var$HCb = 0;
    }
    ++$61de1ee1cac498ae$var$HCb;
}
function $61de1ee1cac498ae$var$nd(a) {
    var b;
    return b = a.f, !b ? a.f = new $61de1ee1cac498ae$var$ne(a, a.c) : b;
}
function $61de1ee1cac498ae$var$d2b(a) {
    return $61de1ee1cac498ae$var$Qld(a) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$gxc))));
}
function $61de1ee1cac498ae$var$mcc(a, b) {
    return $61de1ee1cac498ae$var$Rc(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Nxc)), 19), b);
}
function $61de1ee1cac498ae$var$POc(a, b) {
    return $61de1ee1cac498ae$var$vPc(a.j, b.s, b.c) + $61de1ee1cac498ae$var$vPc(b.e, a.s, a.c);
}
function $61de1ee1cac498ae$var$ooc(a, b) {
    if (!!a.e && !a.e.a) {
        $61de1ee1cac498ae$var$moc(a.e, b);
        $61de1ee1cac498ae$var$ooc(a.e, b);
    }
}
function $61de1ee1cac498ae$var$noc(a, b) {
    if (!!a.d && !a.d.a) {
        $61de1ee1cac498ae$var$moc(a.d, b);
        $61de1ee1cac498ae$var$noc(a.d, b);
    }
}
function $61de1ee1cac498ae$var$hed(a, b) {
    return -$61de1ee1cac498ae$var$Kdb($61de1ee1cac498ae$var$red(a) * $61de1ee1cac498ae$var$qed(a), $61de1ee1cac498ae$var$red(b) * $61de1ee1cac498ae$var$qed(b));
}
function $61de1ee1cac498ae$var$cgd(a) {
    return $61de1ee1cac498ae$var$BD(a.cd(), 146).tg() + ":" + $61de1ee1cac498ae$var$fcb(a.dd());
}
function $61de1ee1cac498ae$var$Zgc(a) {
    $61de1ee1cac498ae$var$Hgc();
    var b;
    b = $61de1ee1cac498ae$var$BD(a.g, 10);
    b.n.a = a.d.c + b.d.b;
}
function $61de1ee1cac498ae$var$wgc(a, b, c) {
    $61de1ee1cac498ae$var$qgc();
    return $61de1ee1cac498ae$var$iEb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, b), 522), c);
}
function $61de1ee1cac498ae$var$Y2c(a, b) {
    $61de1ee1cac498ae$var$rb(a);
    $61de1ee1cac498ae$var$rb(b);
    return $61de1ee1cac498ae$var$Xr($61de1ee1cac498ae$var$BD(a, 22), $61de1ee1cac498ae$var$BD(b, 22));
}
function $61de1ee1cac498ae$var$oic(a, b, c) {
    a.i = 0;
    a.e = 0;
    if (b == c) return;
    $61de1ee1cac498ae$var$kic(a, b, c);
}
function $61de1ee1cac498ae$var$pic(a, b, c) {
    a.i = 0;
    a.e = 0;
    if (b == c) return;
    $61de1ee1cac498ae$var$lic(a, b, c);
}
function $61de1ee1cac498ae$var$Spd(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$Kcb(c);
    e = new $61de1ee1cac498ae$var$TB(d);
    $61de1ee1cac498ae$var$cC(a, b, e);
}
function $61de1ee1cac498ae$var$FSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$ESd.call(this, a, b, c, d, e, f ? -2 : -1);
}
function $61de1ee1cac498ae$var$U5d(a, b, c, d) {
    $61de1ee1cac498ae$var$MLd.call(this, b, c);
    this.b = a;
    this.a = d;
}
function $61de1ee1cac498ae$var$QRc(a, b) {
    new $61de1ee1cac498ae$var$Psb;
    this.a = new $61de1ee1cac498ae$var$s7c;
    this.b = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$Hec(a, b) {
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Qsc)), 15).Fc(b);
    return b;
}
function $61de1ee1cac498ae$var$Rb(a, b) {
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb(b));
    return a;
}
function $61de1ee1cac498ae$var$WKd(a) {
    !a.q && (a.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, a, 11, 10));
    return a.q;
}
function $61de1ee1cac498ae$var$ZKd(a) {
    !a.s && (a.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, a, 21, 17));
    return a.s;
}
function $61de1ee1cac498ae$var$Vod(a) {
    !a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11));
    return a.a;
}
function $61de1ee1cac498ae$var$Dx(a) {
    return $61de1ee1cac498ae$var$JD(a, 14) ? new $61de1ee1cac498ae$var$Vqb($61de1ee1cac498ae$var$BD(a, 14)) : $61de1ee1cac498ae$var$Ex(a.Kc());
}
function $61de1ee1cac498ae$var$Ni(a) {
    return new $61de1ee1cac498ae$var$aj(a, a.e.Hd().gc() * a.c.Hd().gc());
}
function $61de1ee1cac498ae$var$Zi(a) {
    return new $61de1ee1cac498ae$var$kj(a, a.e.Hd().gc() * a.c.Hd().gc());
}
function $61de1ee1cac498ae$var$rz(a) {
    return !!a && !!a.hashCode ? a.hashCode() : $61de1ee1cac498ae$var$FCb(a);
}
function $61de1ee1cac498ae$var$Qhb(a, b) {
    return b == null ? !!$61de1ee1cac498ae$var$irb(a.f, null) : $61de1ee1cac498ae$var$Brb(a.g, b);
}
function $61de1ee1cac498ae$var$Oq(a) {
    $61de1ee1cac498ae$var$Qb(a);
    return $61de1ee1cac498ae$var$mr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(a.a.Kc(), new $61de1ee1cac498ae$var$Sq)));
}
function $61de1ee1cac498ae$var$vmb(a) {
    $61de1ee1cac498ae$var$mmb();
    return $61de1ee1cac498ae$var$JD(a, 54) ? new $61de1ee1cac498ae$var$Yob(a) : new $61de1ee1cac498ae$var$Inb(a);
}
function $61de1ee1cac498ae$var$VDb(a, b, c) {
    if (a.f) return a.f.Ne(b, c);
    return false;
}
function $61de1ee1cac498ae$var$Gfb(a, b) {
    a.a = $61de1ee1cac498ae$var$qfb(a.a, 0, b) + "" + $61de1ee1cac498ae$var$pfb(a.a, b + 1);
    return a;
}
function $61de1ee1cac498ae$var$fVb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Sqb(a.a, b);
    c && (b.d = null);
    return c;
}
function $61de1ee1cac498ae$var$zpb(a) {
    var b, c;
    c = a;
    b = c.$modCount | 0;
    c.$modCount = b + 1;
}
function $61de1ee1cac498ae$var$pu(a) {
    this.b = a;
    this.c = a;
    a.e = null;
    a.c = null;
    this.a = 1;
}
function $61de1ee1cac498ae$var$hOb(a) {
    this.b = a;
    this.a = new $61de1ee1cac498ae$var$Hxb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(new $61de1ee1cac498ae$var$kOb), 62));
}
function $61de1ee1cac498ae$var$uEb(a) {
    this.c = a;
    this.b = new $61de1ee1cac498ae$var$Hxb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(new $61de1ee1cac498ae$var$xEb), 62));
}
function $61de1ee1cac498ae$var$SVb(a) {
    this.c = a;
    this.b = new $61de1ee1cac498ae$var$Hxb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(new $61de1ee1cac498ae$var$VVb), 62));
}
function $61de1ee1cac498ae$var$FYb() {
    this.a = new $61de1ee1cac498ae$var$HXb;
    this.b = new $61de1ee1cac498ae$var$LXb;
    this.d = new $61de1ee1cac498ae$var$SYb;
}
function $61de1ee1cac498ae$var$UZb() {
    this.a = new $61de1ee1cac498ae$var$s7c;
    this.b = ($61de1ee1cac498ae$var$Xj(3, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(3));
}
function $61de1ee1cac498ae$var$VMc() {
    this.b = new $61de1ee1cac498ae$var$Tqb;
    this.d = new $61de1ee1cac498ae$var$Psb;
    this.e = new $61de1ee1cac498ae$var$twb;
}
function $61de1ee1cac498ae$var$K6c(a) {
    this.c = a.c;
    this.d = a.d;
    this.b = a.b;
    this.a = a.a;
}
function $61de1ee1cac498ae$var$Ay(a, b) {
    $61de1ee1cac498ae$var$oi.call(this, new $61de1ee1cac498ae$var$Qwb(a));
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$eod() {
    $61de1ee1cac498ae$var$bod(this, new $61de1ee1cac498ae$var$$md);
    this.wb = ($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd);
    $61de1ee1cac498ae$var$LFd();
}
function $61de1ee1cac498ae$var$eHc(a) {
    $61de1ee1cac498ae$var$Odd(a, "No crossing minimization", 1);
    $61de1ee1cac498ae$var$Qdd(a);
}
function $61de1ee1cac498ae$var$Gz(a) {
    $61de1ee1cac498ae$var$Az();
    $61de1ee1cac498ae$var$$wnd.setTimeout(function() {
        throw a;
    }, 0);
}
function $61de1ee1cac498ae$var$_Kd(a) {
    if (!a.u) {
        $61de1ee1cac498ae$var$$Kd(a);
        a.u = new $61de1ee1cac498ae$var$YOd(a, a);
    }
    return a.u;
}
function $61de1ee1cac498ae$var$wjd(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26);
    return !b ? a.zh() : b;
}
function $61de1ee1cac498ae$var$Jsd(a, b) {
    return $61de1ee1cac498ae$var$JD(b, 146) && $61de1ee1cac498ae$var$dfb(a.b, $61de1ee1cac498ae$var$BD(b, 146).tg());
}
function $61de1ee1cac498ae$var$t0d(a, b) {
    return a.a ? b.Wg().Kc() : $61de1ee1cac498ae$var$BD(b.Wg(), 69).Zh();
}
function $61de1ee1cac498ae$var$u3b(a) {
    return a.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) && $61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Csc));
}
function $61de1ee1cac498ae$var$ux(a) {
    this.a = ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$JD(a, 54) ? new $61de1ee1cac498ae$var$Yob(a) : new $61de1ee1cac498ae$var$Inb(a));
}
function $61de1ee1cac498ae$var$Rz() {
    $61de1ee1cac498ae$var$Rz = $61de1ee1cac498ae$var$ccb;
    var a, b;
    b = !$61de1ee1cac498ae$var$Xz();
    a = new $61de1ee1cac498ae$var$dA;
    $61de1ee1cac498ae$var$Qz = b ? new $61de1ee1cac498ae$var$Yz : a;
}
function $61de1ee1cac498ae$var$Wy(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$hdb(a.gm);
    return b == null ? c : c + ": " + b;
}
function $61de1ee1cac498ae$var$Eob(a, b) {
    var c;
    c = a.b.Qc(b);
    $61de1ee1cac498ae$var$Fob(c, a.b.gc());
    return c;
}
function $61de1ee1cac498ae$var$ytb(a, b) {
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb(b));
    return a;
}
function $61de1ee1cac498ae$var$irb(a, b) {
    return $61de1ee1cac498ae$var$grb(a, b, $61de1ee1cac498ae$var$hrb(a, b == null ? 0 : a.b.se(b)));
}
function $61de1ee1cac498ae$var$ofb(a, b, c) {
    return c >= 0 && $61de1ee1cac498ae$var$dfb(a.substr(c, b.length), b);
}
function $61de1ee1cac498ae$var$H2d(a, b, c, d, e, f, g) {
    return new $61de1ee1cac498ae$var$O7d(a.e, b, c, d, e, f, g);
}
function $61de1ee1cac498ae$var$Cxd(a, b, c, d, e, f) {
    this.a = a;
    $61de1ee1cac498ae$var$nxd.call(this, b, c, d, e, f);
}
function $61de1ee1cac498ae$var$vyd(a, b, c, d, e, f) {
    this.a = a;
    $61de1ee1cac498ae$var$nxd.call(this, b, c, d, e, f);
}
function $61de1ee1cac498ae$var$$Ec(a, b) {
    this.g = a;
    this.d = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$OQ, 1), $61de1ee1cac498ae$var$kne, 10, 0, [
        b
    ]);
}
function $61de1ee1cac498ae$var$KVd(a, b) {
    this.e = a;
    this.a = $61de1ee1cac498ae$var$SI;
    this.b = $61de1ee1cac498ae$var$R5d(b);
    this.c = b;
}
function $61de1ee1cac498ae$var$cIb(a, b) {
    $61de1ee1cac498ae$var$$Gb.call(this);
    $61de1ee1cac498ae$var$THb(this);
    this.a = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$kBc(a, b, c, d) {
    $61de1ee1cac498ae$var$NC(a.c[b.g], c.g, d);
    $61de1ee1cac498ae$var$NC(a.c[c.g], b.g, d);
}
function $61de1ee1cac498ae$var$nBc(a, b, c, d) {
    $61de1ee1cac498ae$var$NC(a.c[b.g], b.g, c);
    $61de1ee1cac498ae$var$NC(a.b[b.g], b.g, d);
}
function $61de1ee1cac498ae$var$cBc() {
    $61de1ee1cac498ae$var$_Ac();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$fX, 1), $61de1ee1cac498ae$var$Kie, 376, 0, [
        $61de1ee1cac498ae$var$$Ac,
        $61de1ee1cac498ae$var$ZAc
    ]);
}
function $61de1ee1cac498ae$var$crc() {
    $61de1ee1cac498ae$var$_qc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$MW, 1), $61de1ee1cac498ae$var$Kie, 479, 0, [
        $61de1ee1cac498ae$var$$qc,
        $61de1ee1cac498ae$var$Zqc
    ]);
}
function $61de1ee1cac498ae$var$Aqc() {
    $61de1ee1cac498ae$var$xqc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$JW, 1), $61de1ee1cac498ae$var$Kie, 419, 0, [
        $61de1ee1cac498ae$var$vqc,
        $61de1ee1cac498ae$var$wqc
    ]);
}
function $61de1ee1cac498ae$var$Lpc() {
    $61de1ee1cac498ae$var$Ipc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$FW, 1), $61de1ee1cac498ae$var$Kie, 422, 0, [
        $61de1ee1cac498ae$var$Gpc,
        $61de1ee1cac498ae$var$Hpc
    ]);
}
function $61de1ee1cac498ae$var$psc() {
    $61de1ee1cac498ae$var$msc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SW, 1), $61de1ee1cac498ae$var$Kie, 420, 0, [
        $61de1ee1cac498ae$var$ksc,
        $61de1ee1cac498ae$var$lsc
    ]);
}
function $61de1ee1cac498ae$var$EAc() {
    $61de1ee1cac498ae$var$BAc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$cX, 1), $61de1ee1cac498ae$var$Kie, 421, 0, [
        $61de1ee1cac498ae$var$zAc,
        $61de1ee1cac498ae$var$AAc
    ]);
}
function $61de1ee1cac498ae$var$XIc() {
    $61de1ee1cac498ae$var$UIc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$mY, 1), $61de1ee1cac498ae$var$Kie, 523, 0, [
        $61de1ee1cac498ae$var$TIc,
        $61de1ee1cac498ae$var$SIc
    ]);
}
function $61de1ee1cac498ae$var$KOc() {
    $61de1ee1cac498ae$var$HOc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$DZ, 1), $61de1ee1cac498ae$var$Kie, 520, 0, [
        $61de1ee1cac498ae$var$GOc,
        $61de1ee1cac498ae$var$FOc
    ]);
}
function $61de1ee1cac498ae$var$_Lc() {
    $61de1ee1cac498ae$var$YLc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$fZ, 1), $61de1ee1cac498ae$var$Kie, 516, 0, [
        $61de1ee1cac498ae$var$XLc,
        $61de1ee1cac498ae$var$WLc
    ]);
}
function $61de1ee1cac498ae$var$hMc() {
    $61de1ee1cac498ae$var$eMc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$gZ, 1), $61de1ee1cac498ae$var$Kie, 515, 0, [
        $61de1ee1cac498ae$var$cMc,
        $61de1ee1cac498ae$var$dMc
    ]);
}
function $61de1ee1cac498ae$var$IQc() {
    $61de1ee1cac498ae$var$FQc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$YZ, 1), $61de1ee1cac498ae$var$Kie, 455, 0, [
        $61de1ee1cac498ae$var$DQc,
        $61de1ee1cac498ae$var$EQc
    ]);
}
function $61de1ee1cac498ae$var$bUc() {
    $61de1ee1cac498ae$var$$Tc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F$, 1), $61de1ee1cac498ae$var$Kie, 425, 0, [
        $61de1ee1cac498ae$var$ZTc,
        $61de1ee1cac498ae$var$YTc
    ]);
}
function $61de1ee1cac498ae$var$VTc() {
    $61de1ee1cac498ae$var$STc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E$, 1), $61de1ee1cac498ae$var$Kie, 480, 0, [
        $61de1ee1cac498ae$var$QTc,
        $61de1ee1cac498ae$var$RTc
    ]);
}
function $61de1ee1cac498ae$var$VUc() {
    $61de1ee1cac498ae$var$PUc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$K$, 1), $61de1ee1cac498ae$var$Kie, 495, 0, [
        $61de1ee1cac498ae$var$NUc,
        $61de1ee1cac498ae$var$OUc
    ]);
}
function $61de1ee1cac498ae$var$jWc() {
    $61de1ee1cac498ae$var$fWc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$X$, 1), $61de1ee1cac498ae$var$Kie, 426, 0, [
        $61de1ee1cac498ae$var$dWc,
        $61de1ee1cac498ae$var$eWc
    ]);
}
function $61de1ee1cac498ae$var$g1c() {
    $61de1ee1cac498ae$var$a1c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$X_, 1), $61de1ee1cac498ae$var$Kie, 429, 0, [
        $61de1ee1cac498ae$var$_0c,
        $61de1ee1cac498ae$var$$0c
    ]);
}
function $61de1ee1cac498ae$var$F_c() {
    $61de1ee1cac498ae$var$C_c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$P_, 1), $61de1ee1cac498ae$var$Kie, 430, 0, [
        $61de1ee1cac498ae$var$B_c,
        $61de1ee1cac498ae$var$A_c
    ]);
}
function $61de1ee1cac498ae$var$PEb() {
    $61de1ee1cac498ae$var$MEb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$aN, 1), $61de1ee1cac498ae$var$Kie, 428, 0, [
        $61de1ee1cac498ae$var$LEb,
        $61de1ee1cac498ae$var$KEb
    ]);
}
function $61de1ee1cac498ae$var$XEb() {
    $61de1ee1cac498ae$var$UEb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bN, 1), $61de1ee1cac498ae$var$Kie, 427, 0, [
        $61de1ee1cac498ae$var$SEb,
        $61de1ee1cac498ae$var$TEb
    ]);
}
function $61de1ee1cac498ae$var$$Rb() {
    $61de1ee1cac498ae$var$XRb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$gP, 1), $61de1ee1cac498ae$var$Kie, 424, 0, [
        $61de1ee1cac498ae$var$VRb,
        $61de1ee1cac498ae$var$WRb
    ]);
}
function $61de1ee1cac498ae$var$B5b() {
    $61de1ee1cac498ae$var$y5b();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZR, 1), $61de1ee1cac498ae$var$Kie, 511, 0, [
        $61de1ee1cac498ae$var$x5b,
        $61de1ee1cac498ae$var$w5b
    ]);
}
function $61de1ee1cac498ae$var$lid(a, b, c, d) {
    return c >= 0 ? a.jh(b, c, d) : a.Sg(null, c, d);
}
function $61de1ee1cac498ae$var$hgd(a) {
    if (a.b.b == 0) return a.a.$e();
    return $61de1ee1cac498ae$var$Lsb(a.b);
}
function $61de1ee1cac498ae$var$Xwd(a) {
    if (a.p != 5) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.f);
}
function $61de1ee1cac498ae$var$exd(a) {
    if (a.p != 5) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.k);
}
function $61de1ee1cac498ae$var$pNd(a) {
    $61de1ee1cac498ae$var$PD(a.a) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$NKd(), $61de1ee1cac498ae$var$MKd)) && $61de1ee1cac498ae$var$qNd(a);
    return a.a;
}
function $61de1ee1cac498ae$var$by(a) {
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 271);
    this.b = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$Zob(a));
}
function $61de1ee1cac498ae$var$bQc(a, b) {
    $61de1ee1cac498ae$var$$Pc(this, new $61de1ee1cac498ae$var$f7c(a.a, a.b));
    $61de1ee1cac498ae$var$_Pc(this, $61de1ee1cac498ae$var$Ru(b));
}
function $61de1ee1cac498ae$var$FQc() {
    $61de1ee1cac498ae$var$FQc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$DQc = new $61de1ee1cac498ae$var$GQc($61de1ee1cac498ae$var$jle, 0);
    $61de1ee1cac498ae$var$EQc = new $61de1ee1cac498ae$var$GQc($61de1ee1cac498ae$var$kle, 1);
}
function $61de1ee1cac498ae$var$YLc() {
    $61de1ee1cac498ae$var$YLc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$XLc = new $61de1ee1cac498ae$var$ZLc($61de1ee1cac498ae$var$kle, 0);
    $61de1ee1cac498ae$var$WLc = new $61de1ee1cac498ae$var$ZLc($61de1ee1cac498ae$var$jle, 1);
}
function $61de1ee1cac498ae$var$Hp() {
    $61de1ee1cac498ae$var$Gp.call(this, new $61de1ee1cac498ae$var$Mqb($61de1ee1cac498ae$var$Cv(12)));
    $61de1ee1cac498ae$var$Lb(true);
    this.a = 2;
}
function $61de1ee1cac498ae$var$Hge(a, b, c) {
    $61de1ee1cac498ae$var$wfe();
    $61de1ee1cac498ae$var$xfe.call(this, a);
    this.b = b;
    this.a = c;
}
function $61de1ee1cac498ae$var$cWd(a, b, c) {
    $61de1ee1cac498ae$var$UVd();
    $61de1ee1cac498ae$var$VVd.call(this, b);
    this.a = a;
    this.b = c;
}
function $61de1ee1cac498ae$var$aIb(a) {
    $61de1ee1cac498ae$var$$Gb.call(this);
    $61de1ee1cac498ae$var$THb(this);
    this.a = a;
    this.c = true;
}
function $61de1ee1cac498ae$var$isb(a) {
    var b;
    b = a.c.d.b;
    a.b = b;
    a.a = a.c.d;
    b.a = a.c.d.b = a;
}
function $61de1ee1cac498ae$var$$Cb(a) {
    var b;
    $61de1ee1cac498ae$var$NGb(a.a);
    $61de1ee1cac498ae$var$MGb(a.a);
    b = new $61de1ee1cac498ae$var$YGb(a.a);
    $61de1ee1cac498ae$var$UGb(b);
}
function $61de1ee1cac498ae$var$iKb(a, b) {
    $61de1ee1cac498ae$var$hKb(a, true);
    $61de1ee1cac498ae$var$Hkb(a.e.wf(), new $61de1ee1cac498ae$var$mKb(a, true, b));
}
function $61de1ee1cac498ae$var$tlb(a, b) {
    $61de1ee1cac498ae$var$pCb(b);
    return $61de1ee1cac498ae$var$vlb(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b, 15, 1), b);
}
function $61de1ee1cac498ae$var$YPb(a, b) {
    $61de1ee1cac498ae$var$QPb();
    return a == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$jtd(b)) || a == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$ltd(b));
}
function $61de1ee1cac498ae$var$Phb(a, b) {
    return b == null ? $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, null)) : $61de1ee1cac498ae$var$Crb(a.g, b);
}
function $61de1ee1cac498ae$var$Ksb(a) {
    return a.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(a.b != 0), $61de1ee1cac498ae$var$Nsb(a, a.a.a));
}
function $61de1ee1cac498ae$var$QD(a) {
    return Math.max(Math.min(a, $61de1ee1cac498ae$var$Ohe), -2147483648) | 0;
}
function $61de1ee1cac498ae$var$uz(a, b) {
    var c = $61de1ee1cac498ae$var$tz[a.charCodeAt(0)];
    return c == null ? a : c;
}
function $61de1ee1cac498ae$var$Cx(a, b) {
    $61de1ee1cac498ae$var$Rb(a, "set1");
    $61de1ee1cac498ae$var$Rb(b, "set2");
    return new $61de1ee1cac498ae$var$Px(a, b);
}
function $61de1ee1cac498ae$var$QUb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$zUb(a.f, b);
    return $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$V6c(c), a.f.d);
}
function $61de1ee1cac498ae$var$Jwb(a, b) {
    var c, d;
    c = b;
    d = new $61de1ee1cac498ae$var$fxb;
    $61de1ee1cac498ae$var$Lwb(a, c, d);
    return d.d;
}
function $61de1ee1cac498ae$var$NJb(a, b, c, d) {
    var e;
    e = new $61de1ee1cac498ae$var$aHb;
    b.a[c.g] = e;
    $61de1ee1cac498ae$var$Npb(a.b, d, e);
}
function $61de1ee1cac498ae$var$zid(a, b, c) {
    var d;
    d = a.Yg(b);
    d >= 0 ? a.sh(d, c) : $61de1ee1cac498ae$var$uid(a, b, c);
}
function $61de1ee1cac498ae$var$hvd(a, b, c) {
    $61de1ee1cac498ae$var$evd();
    !!a && $61de1ee1cac498ae$var$Rhb($61de1ee1cac498ae$var$dvd, a, b);
    !!a && $61de1ee1cac498ae$var$Rhb($61de1ee1cac498ae$var$cvd, a, c);
}
function $61de1ee1cac498ae$var$g_c(a, b, c) {
    this.i = new $61de1ee1cac498ae$var$Rkb;
    this.b = a;
    this.g = b;
    this.a = c;
}
function $61de1ee1cac498ae$var$VZc(a, b, c) {
    this.c = new $61de1ee1cac498ae$var$Rkb;
    this.e = a;
    this.f = b;
    this.b = c;
}
function $61de1ee1cac498ae$var$b$c(a, b, c) {
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.e = a;
    this.f = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$Zy(a, b) {
    $61de1ee1cac498ae$var$Py(this);
    this.f = b;
    this.g = a;
    $61de1ee1cac498ae$var$Ry(this);
    this._d();
}
function $61de1ee1cac498ae$var$ZA(a, b) {
    var c;
    c = a.q.getHours();
    a.q.setDate(b);
    $61de1ee1cac498ae$var$YA(a, c);
}
function $61de1ee1cac498ae$var$no(a, b) {
    var c;
    $61de1ee1cac498ae$var$Qb(b);
    for(c = a.a; c; c = c.c)b.Od(c.g, c.i);
}
function $61de1ee1cac498ae$var$Fx(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Uqb($61de1ee1cac498ae$var$Cv(a.length));
    $61de1ee1cac498ae$var$nmb(b, a);
    return b;
}
function $61de1ee1cac498ae$var$ecb(a) {
    function b() {}
    b.prototype = a || {};
    return new b;
}
function $61de1ee1cac498ae$var$dkb(a, b) {
    if ($61de1ee1cac498ae$var$Zjb(a, b)) {
        $61de1ee1cac498ae$var$wkb(a);
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$aC(a, b) {
    if (b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Geb);
    return $61de1ee1cac498ae$var$bC(a, b);
}
function $61de1ee1cac498ae$var$tdb(a) {
    if (a.qe()) return null;
    var b = a.n;
    return $61de1ee1cac498ae$var$_bb[b];
}
function $61de1ee1cac498ae$var$Mld(a) {
    if (a.Db >> 16 != 3) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 33);
}
function $61de1ee1cac498ae$var$mpd(a) {
    if (a.Db >> 16 != 9) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 33);
}
function $61de1ee1cac498ae$var$fmd(a) {
    if (a.Db >> 16 != 6) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 79);
}
function $61de1ee1cac498ae$var$Ind(a) {
    if (a.Db >> 16 != 7) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 235);
}
function $61de1ee1cac498ae$var$Fod(a) {
    if (a.Db >> 16 != 7) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 160);
}
function $61de1ee1cac498ae$var$Xod(a) {
    if (a.Db >> 16 != 11) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 33);
}
function $61de1ee1cac498ae$var$nid(a, b) {
    var c;
    c = a.Yg(b);
    return c >= 0 ? a.lh(c) : $61de1ee1cac498ae$var$tid(a, b);
}
function $61de1ee1cac498ae$var$Dtd(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$Bsb(b);
    $61de1ee1cac498ae$var$Ve(c, a);
    return new $61de1ee1cac498ae$var$Tkb(c);
}
function $61de1ee1cac498ae$var$Uud(a) {
    var b;
    b = a.d;
    b = a.si(a.f);
    $61de1ee1cac498ae$var$wtd(a, b);
    return b.Ob();
}
function $61de1ee1cac498ae$var$t_b(a, b) {
    a.b += b.b;
    a.c += b.c;
    a.d += b.d;
    a.a += b.a;
    return a;
}
function $61de1ee1cac498ae$var$A4b(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.abs(a) < $61de1ee1cac498ae$var$$wnd.Math.abs(b) ? a : b;
}
function $61de1ee1cac498ae$var$Zod(a) {
    return !a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a.i > 0;
}
function $61de1ee1cac498ae$var$oDb() {
    this.a = new $61de1ee1cac498ae$var$zsb;
    this.e = new $61de1ee1cac498ae$var$Tqb;
    this.g = 0;
    this.i = 0;
}
function $61de1ee1cac498ae$var$BGc(a) {
    this.a = a;
    this.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SX, $61de1ee1cac498ae$var$nie, 1944, a.e.length, 0, 2);
}
function $61de1ee1cac498ae$var$RHc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$SHc(a, b, c);
    a.b = new $61de1ee1cac498ae$var$BHc(d.c.length);
}
function $61de1ee1cac498ae$var$eMc() {
    $61de1ee1cac498ae$var$eMc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$cMc = new $61de1ee1cac498ae$var$fMc($61de1ee1cac498ae$var$vle, 0);
    $61de1ee1cac498ae$var$dMc = new $61de1ee1cac498ae$var$fMc("UP", 1);
}
function $61de1ee1cac498ae$var$STc() {
    $61de1ee1cac498ae$var$STc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$QTc = new $61de1ee1cac498ae$var$TTc($61de1ee1cac498ae$var$Yqe, 0);
    $61de1ee1cac498ae$var$RTc = new $61de1ee1cac498ae$var$TTc("FAN", 1);
}
function $61de1ee1cac498ae$var$evd() {
    $61de1ee1cac498ae$var$evd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$dvd = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$cvd = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$ivd($61de1ee1cac498ae$var$hK, new $61de1ee1cac498ae$var$jvd);
}
function $61de1ee1cac498ae$var$Swd(a) {
    if (a.p != 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Kbb(a.f, 0);
}
function $61de1ee1cac498ae$var$_wd(a) {
    if (a.p != 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Kbb(a.k, 0);
}
function $61de1ee1cac498ae$var$MHd(a) {
    if (a.Db >> 16 != 3) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 147);
}
function $61de1ee1cac498ae$var$ZJd(a) {
    if (a.Db >> 16 != 6) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 235);
}
function $61de1ee1cac498ae$var$WId(a) {
    if (a.Db >> 16 != 17) return null;
    return $61de1ee1cac498ae$var$BD(a.Cb, 26);
}
function $61de1ee1cac498ae$var$rdb(a, b) {
    var c = a.a = a.a || [];
    return c[b] || (c[b] = a.le(b));
}
function $61de1ee1cac498ae$var$hrb(a, b) {
    var c;
    c = a.a.get(b);
    return c == null ? new Array : c;
}
function $61de1ee1cac498ae$var$aB(a, b) {
    var c;
    c = a.q.getHours();
    a.q.setMonth(b);
    $61de1ee1cac498ae$var$YA(a, c);
}
function $61de1ee1cac498ae$var$Shb(a, b, c) {
    return b == null ? $61de1ee1cac498ae$var$jrb(a.f, null, c) : $61de1ee1cac498ae$var$Drb(a.g, b, c);
}
function $61de1ee1cac498ae$var$FLd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$pSd(a.e, b, a.aj(), c, d, e, f);
}
function $61de1ee1cac498ae$var$Tfb(a, b, c) {
    a.a = $61de1ee1cac498ae$var$qfb(a.a, 0, b) + ("" + c) + $61de1ee1cac498ae$var$pfb(a.a, b);
    return a;
}
function $61de1ee1cac498ae$var$bq(a, b, c) {
    $61de1ee1cac498ae$var$Ekb(a.a, ($61de1ee1cac498ae$var$Vm(), $61de1ee1cac498ae$var$Wj(b, c), new $61de1ee1cac498ae$var$Wo(b, c)));
    return a;
}
function $61de1ee1cac498ae$var$uu(a) {
    $61de1ee1cac498ae$var$ot(a.c);
    a.e = a.a = a.c;
    a.c = a.c.c;
    ++a.d;
    return a.a.f;
}
function $61de1ee1cac498ae$var$vu(a) {
    $61de1ee1cac498ae$var$ot(a.e);
    a.c = a.a = a.e;
    a.e = a.e.e;
    --a.d;
    return a.a.f;
}
function $61de1ee1cac498ae$var$RZb(a, b) {
    !!a.d && $61de1ee1cac498ae$var$Lkb(a.d.e, a);
    a.d = b;
    !!a.d && $61de1ee1cac498ae$var$Ekb(a.d.e, a);
}
function $61de1ee1cac498ae$var$QZb(a, b) {
    !!a.c && $61de1ee1cac498ae$var$Lkb(a.c.g, a);
    a.c = b;
    !!a.c && $61de1ee1cac498ae$var$Ekb(a.c.g, a);
}
function $61de1ee1cac498ae$var$$_b(a, b) {
    !!a.c && $61de1ee1cac498ae$var$Lkb(a.c.a, a);
    a.c = b;
    !!a.c && $61de1ee1cac498ae$var$Ekb(a.c.a, a);
}
function $61de1ee1cac498ae$var$F0b(a, b) {
    !!a.i && $61de1ee1cac498ae$var$Lkb(a.i.j, a);
    a.i = b;
    !!a.i && $61de1ee1cac498ae$var$Ekb(a.i.j, a);
}
function $61de1ee1cac498ae$var$jDb(a, b, c) {
    this.a = b;
    this.c = a;
    this.b = ($61de1ee1cac498ae$var$Qb(c), new $61de1ee1cac498ae$var$Tkb(c));
}
function $61de1ee1cac498ae$var$qXb(a, b, c) {
    this.a = b;
    this.c = a;
    this.b = ($61de1ee1cac498ae$var$Qb(c), new $61de1ee1cac498ae$var$Tkb(c));
}
function $61de1ee1cac498ae$var$aOb(a, b) {
    this.a = a;
    this.c = $61de1ee1cac498ae$var$R6c(this.a);
    this.b = new $61de1ee1cac498ae$var$K6c(b);
}
function $61de1ee1cac498ae$var$IAb(a) {
    var b;
    $61de1ee1cac498ae$var$Uzb(a);
    b = new $61de1ee1cac498ae$var$Tqb;
    return $61de1ee1cac498ae$var$JAb(a, new $61de1ee1cac498ae$var$jBb(b));
}
function $61de1ee1cac498ae$var$wCb(a, b) {
    if (a < 0 || a > b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Ake + a + $61de1ee1cac498ae$var$Bke + b));
}
function $61de1ee1cac498ae$var$Ppb(a, b) {
    return $61de1ee1cac498ae$var$vqb(a.a, b) ? $61de1ee1cac498ae$var$Qpb(a, $61de1ee1cac498ae$var$BD(b, 22).g, null) : null;
}
function $61de1ee1cac498ae$var$WUb(a) {
    $61de1ee1cac498ae$var$LUb();
    return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$BD(a.a, 81).d.e != 0 ? true : false;
}
function $61de1ee1cac498ae$var$qs() {
    $61de1ee1cac498ae$var$qs = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ps = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$hs(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$yG, 1), $61de1ee1cac498ae$var$Kie, 538, 0, [
        $61de1ee1cac498ae$var$gs
    ])));
}
function $61de1ee1cac498ae$var$SBc() {
    $61de1ee1cac498ae$var$SBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$RBc = $61de1ee1cac498ae$var$c3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$J8b));
}
function $61de1ee1cac498ae$var$ZBc() {
    $61de1ee1cac498ae$var$ZBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$YBc = $61de1ee1cac498ae$var$c3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$J8b));
}
function $61de1ee1cac498ae$var$oCc() {
    $61de1ee1cac498ae$var$oCc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$nCc = $61de1ee1cac498ae$var$c3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$J8b));
}
function $61de1ee1cac498ae$var$aJc() {
    $61de1ee1cac498ae$var$aJc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$_Ic = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$h8b));
}
function $61de1ee1cac498ae$var$FJc() {
    $61de1ee1cac498ae$var$FJc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$EJc = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$h8b));
}
function $61de1ee1cac498ae$var$ILc() {
    $61de1ee1cac498ae$var$ILc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$HLc = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$h8b));
}
function $61de1ee1cac498ae$var$wMc() {
    $61de1ee1cac498ae$var$wMc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vMc = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$h8b));
}
function $61de1ee1cac498ae$var$fUc() {
    $61de1ee1cac498ae$var$fUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$eUc = $61de1ee1cac498ae$var$c3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$yRc(), $61de1ee1cac498ae$var$xRc), ($61de1ee1cac498ae$var$qSc(), $61de1ee1cac498ae$var$kSc));
}
function $61de1ee1cac498ae$var$DOc(a, b, c, d) {
    this.c = a;
    this.d = d;
    $61de1ee1cac498ae$var$BOc(this, b);
    $61de1ee1cac498ae$var$COc(this, c);
}
function $61de1ee1cac498ae$var$W3c(a) {
    this.c = new $61de1ee1cac498ae$var$Psb;
    this.b = a.b;
    this.d = a.c;
    this.a = a.a;
}
function $61de1ee1cac498ae$var$e7c(a) {
    this.a = $61de1ee1cac498ae$var$$wnd.Math.cos(a);
    this.b = $61de1ee1cac498ae$var$$wnd.Math.sin(a);
}
function $61de1ee1cac498ae$var$BOc(a, b) {
    !!a.a && $61de1ee1cac498ae$var$Lkb(a.a.k, a);
    a.a = b;
    !!a.a && $61de1ee1cac498ae$var$Ekb(a.a.k, a);
}
function $61de1ee1cac498ae$var$COc(a, b) {
    !!a.b && $61de1ee1cac498ae$var$Lkb(a.b.f, a);
    a.b = b;
    !!a.b && $61de1ee1cac498ae$var$Ekb(a.b.f, a);
}
function $61de1ee1cac498ae$var$D1c(a, b) {
    $61de1ee1cac498ae$var$E1c(a, a.b, a.c);
    $61de1ee1cac498ae$var$BD(a.b.b, 65);
    !!b && $61de1ee1cac498ae$var$BD(b.b, 65).b;
}
function $61de1ee1cac498ae$var$BUd(a, b) {
    $61de1ee1cac498ae$var$CUd(a, b);
    $61de1ee1cac498ae$var$JD(a.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(a.Cb, 88)), 2);
}
function $61de1ee1cac498ae$var$cJd(a, b) {
    $61de1ee1cac498ae$var$JD(a.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(a.Cb, 88)), 4);
    $61de1ee1cac498ae$var$pnd(a, b);
}
function $61de1ee1cac498ae$var$lKd(a, b) {
    $61de1ee1cac498ae$var$JD(a.Cb, 179) && ($61de1ee1cac498ae$var$BD(a.Cb, 179).tb = null);
    $61de1ee1cac498ae$var$pnd(a, b);
}
function $61de1ee1cac498ae$var$T2d(a, b) {
    return $61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$YId(b) ? new $61de1ee1cac498ae$var$R7d(b, a) : new $61de1ee1cac498ae$var$f7d(b, a);
}
function $61de1ee1cac498ae$var$jsd(a, b) {
    var c, d;
    c = b.c;
    d = c != null;
    d && $61de1ee1cac498ae$var$Qpd(a, new $61de1ee1cac498ae$var$yC(b.c));
}
function $61de1ee1cac498ae$var$XOd(a) {
    var b, c;
    c = ($61de1ee1cac498ae$var$LFd(), b = new $61de1ee1cac498ae$var$UQd, b);
    $61de1ee1cac498ae$var$NQd(c, a);
    return c;
}
function $61de1ee1cac498ae$var$eTd(a) {
    var b, c;
    c = ($61de1ee1cac498ae$var$LFd(), b = new $61de1ee1cac498ae$var$UQd, b);
    $61de1ee1cac498ae$var$NQd(c, a);
    return c;
}
function $61de1ee1cac498ae$var$yCc(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$H1b(a);
    b.c[b.c.length] = c;
    return c;
}
function $61de1ee1cac498ae$var$Aw(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$nd(a.a), b), 14);
    return !c ? 0 : c.gc();
}
function $61de1ee1cac498ae$var$UAb(a) {
    var b;
    $61de1ee1cac498ae$var$Uzb(a);
    b = ($61de1ee1cac498ae$var$ipb(), $61de1ee1cac498ae$var$ipb(), $61de1ee1cac498ae$var$gpb);
    return $61de1ee1cac498ae$var$VAb(a, b);
}
function $61de1ee1cac498ae$var$nr(a) {
    var b;
    while(true){
        b = a.Pb();
        if (!a.Ob()) return b;
    }
}
function $61de1ee1cac498ae$var$Ki(a, b) {
    $61de1ee1cac498ae$var$Ii.call(this, new $61de1ee1cac498ae$var$Mqb($61de1ee1cac498ae$var$Cv(a)));
    $61de1ee1cac498ae$var$Xj(b, $61de1ee1cac498ae$var$mie);
    this.a = b;
}
function $61de1ee1cac498ae$var$Jib(a, b, c) {
    $61de1ee1cac498ae$var$xCb(b, c, a.gc());
    this.c = a;
    this.a = b;
    this.b = c - b;
}
function $61de1ee1cac498ae$var$Mkb(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$xCb(b, c, a.c.length);
    d = c - b;
    $61de1ee1cac498ae$var$cCb(a.c, b, d);
}
function $61de1ee1cac498ae$var$Fub(a, b) {
    $61de1ee1cac498ae$var$Eub(a, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Obb(b, 24), $61de1ee1cac498ae$var$nke)), $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$xbb(b, $61de1ee1cac498ae$var$nke)));
}
function $61de1ee1cac498ae$var$tCb(a, b) {
    if (a < 0 || a >= b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Ake + a + $61de1ee1cac498ae$var$Bke + b));
}
function $61de1ee1cac498ae$var$BCb(a, b) {
    if (a < 0 || a >= b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Xfb($61de1ee1cac498ae$var$Ake + a + $61de1ee1cac498ae$var$Bke + b));
}
function $61de1ee1cac498ae$var$Kub(a, b) {
    this.b = ($61de1ee1cac498ae$var$uCb(a), a);
    this.a = (b & $61de1ee1cac498ae$var$Rje) == 0 ? b | 64 | $61de1ee1cac498ae$var$oie : b;
}
function $61de1ee1cac498ae$var$kkb(a) {
    $61de1ee1cac498ae$var$Vjb(this);
    $61de1ee1cac498ae$var$dCb(this.a, $61de1ee1cac498ae$var$geb($61de1ee1cac498ae$var$$wnd.Math.max(8, a)) << 1);
}
function $61de1ee1cac498ae$var$A0b(a) {
    return $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ]));
}
function $61de1ee1cac498ae$var$Iyb() {
    $61de1ee1cac498ae$var$Fyb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        $61de1ee1cac498ae$var$Cyb,
        $61de1ee1cac498ae$var$Dyb,
        $61de1ee1cac498ae$var$Eyb
    ]);
}
function $61de1ee1cac498ae$var$jHb() {
    $61de1ee1cac498ae$var$gHb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ]);
}
function $61de1ee1cac498ae$var$QHb() {
    $61de1ee1cac498ae$var$NHb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$sN, 1), $61de1ee1cac498ae$var$Kie, 461, 0, [
        $61de1ee1cac498ae$var$LHb,
        $61de1ee1cac498ae$var$KHb,
        $61de1ee1cac498ae$var$MHb
    ]);
}
function $61de1ee1cac498ae$var$HIb() {
    $61de1ee1cac498ae$var$EIb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$zN, 1), $61de1ee1cac498ae$var$Kie, 462, 0, [
        $61de1ee1cac498ae$var$DIb,
        $61de1ee1cac498ae$var$CIb,
        $61de1ee1cac498ae$var$BIb
    ]);
}
function $61de1ee1cac498ae$var$UXb() {
    $61de1ee1cac498ae$var$RXb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$hQ, 1), $61de1ee1cac498ae$var$Kie, 423, 0, [
        $61de1ee1cac498ae$var$QXb,
        $61de1ee1cac498ae$var$PXb,
        $61de1ee1cac498ae$var$OXb
    ]);
}
function $61de1ee1cac498ae$var$BTb() {
    $61de1ee1cac498ae$var$yTb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$oP, 1), $61de1ee1cac498ae$var$Kie, 379, 0, [
        $61de1ee1cac498ae$var$wTb,
        $61de1ee1cac498ae$var$vTb,
        $61de1ee1cac498ae$var$xTb
    ]);
}
function $61de1ee1cac498ae$var$Bzc() {
    $61de1ee1cac498ae$var$xzc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZW, 1), $61de1ee1cac498ae$var$Kie, 378, 0, [
        $61de1ee1cac498ae$var$uzc,
        $61de1ee1cac498ae$var$vzc,
        $61de1ee1cac498ae$var$wzc
    ]);
}
function $61de1ee1cac498ae$var$Xpc() {
    $61de1ee1cac498ae$var$Rpc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$GW, 1), $61de1ee1cac498ae$var$Kie, 314, 0, [
        $61de1ee1cac498ae$var$Ppc,
        $61de1ee1cac498ae$var$Opc,
        $61de1ee1cac498ae$var$Qpc
    ]);
}
function $61de1ee1cac498ae$var$eqc() {
    $61de1ee1cac498ae$var$bqc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$HW, 1), $61de1ee1cac498ae$var$Kie, 337, 0, [
        $61de1ee1cac498ae$var$$pc,
        $61de1ee1cac498ae$var$aqc,
        $61de1ee1cac498ae$var$_pc
    ]);
}
function $61de1ee1cac498ae$var$Jqc() {
    $61de1ee1cac498ae$var$Gqc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KW, 1), $61de1ee1cac498ae$var$Kie, 450, 0, [
        $61de1ee1cac498ae$var$Eqc,
        $61de1ee1cac498ae$var$Dqc,
        $61de1ee1cac498ae$var$Fqc
    ]);
}
function $61de1ee1cac498ae$var$Ikc() {
    $61de1ee1cac498ae$var$Fkc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$vV, 1), $61de1ee1cac498ae$var$Kie, 361, 0, [
        $61de1ee1cac498ae$var$Ekc,
        $61de1ee1cac498ae$var$Dkc,
        $61de1ee1cac498ae$var$Ckc
    ]);
}
function $61de1ee1cac498ae$var$hsc() {
    $61de1ee1cac498ae$var$esc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$RW, 1), $61de1ee1cac498ae$var$Kie, 303, 0, [
        $61de1ee1cac498ae$var$csc,
        $61de1ee1cac498ae$var$dsc,
        $61de1ee1cac498ae$var$bsc
    ]);
}
function $61de1ee1cac498ae$var$$rc() {
    $61de1ee1cac498ae$var$Xrc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$QW, 1), $61de1ee1cac498ae$var$Kie, 292, 0, [
        $61de1ee1cac498ae$var$Vrc,
        $61de1ee1cac498ae$var$Wrc,
        $61de1ee1cac498ae$var$Urc
    ]);
}
function $61de1ee1cac498ae$var$NAc() {
    $61de1ee1cac498ae$var$KAc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$dX, 1), $61de1ee1cac498ae$var$Kie, 452, 0, [
        $61de1ee1cac498ae$var$JAc,
        $61de1ee1cac498ae$var$HAc,
        $61de1ee1cac498ae$var$IAc
    ]);
}
function $61de1ee1cac498ae$var$wAc() {
    $61de1ee1cac498ae$var$tAc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bX, 1), $61de1ee1cac498ae$var$Kie, 339, 0, [
        $61de1ee1cac498ae$var$rAc,
        $61de1ee1cac498ae$var$qAc,
        $61de1ee1cac498ae$var$sAc
    ]);
}
function $61de1ee1cac498ae$var$WAc() {
    $61de1ee1cac498ae$var$TAc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$eX, 1), $61de1ee1cac498ae$var$Kie, 375, 0, [
        $61de1ee1cac498ae$var$QAc,
        $61de1ee1cac498ae$var$RAc,
        $61de1ee1cac498ae$var$SAc
    ]);
}
function $61de1ee1cac498ae$var$OBc() {
    $61de1ee1cac498ae$var$LBc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$jX, 1), $61de1ee1cac498ae$var$Kie, 377, 0, [
        $61de1ee1cac498ae$var$JBc,
        $61de1ee1cac498ae$var$KBc,
        $61de1ee1cac498ae$var$IBc
    ]);
}
function $61de1ee1cac498ae$var$wBc() {
    $61de1ee1cac498ae$var$tBc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$hX, 1), $61de1ee1cac498ae$var$Kie, 336, 0, [
        $61de1ee1cac498ae$var$qBc,
        $61de1ee1cac498ae$var$rBc,
        $61de1ee1cac498ae$var$sBc
    ]);
}
function $61de1ee1cac498ae$var$FBc() {
    $61de1ee1cac498ae$var$CBc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$iX, 1), $61de1ee1cac498ae$var$Kie, 338, 0, [
        $61de1ee1cac498ae$var$BBc,
        $61de1ee1cac498ae$var$zBc,
        $61de1ee1cac498ae$var$ABc
    ]);
}
function $61de1ee1cac498ae$var$uGc() {
    $61de1ee1cac498ae$var$rGc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PX, 1), $61de1ee1cac498ae$var$Kie, 454, 0, [
        $61de1ee1cac498ae$var$oGc,
        $61de1ee1cac498ae$var$pGc,
        $61de1ee1cac498ae$var$qGc
    ]);
}
function $61de1ee1cac498ae$var$xVc() {
    $61de1ee1cac498ae$var$tVc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O$, 1), $61de1ee1cac498ae$var$Kie, 442, 0, [
        $61de1ee1cac498ae$var$sVc,
        $61de1ee1cac498ae$var$qVc,
        $61de1ee1cac498ae$var$rVc
    ]);
}
function $61de1ee1cac498ae$var$tWc() {
    $61de1ee1cac498ae$var$pWc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$Y$, 1), $61de1ee1cac498ae$var$Kie, 380, 0, [
        $61de1ee1cac498ae$var$mWc,
        $61de1ee1cac498ae$var$nWc,
        $61de1ee1cac498ae$var$oWc
    ]);
}
function $61de1ee1cac498ae$var$CYc() {
    $61de1ee1cac498ae$var$zYc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$q_, 1), $61de1ee1cac498ae$var$Kie, 381, 0, [
        $61de1ee1cac498ae$var$xYc,
        $61de1ee1cac498ae$var$yYc,
        $61de1ee1cac498ae$var$wYc
    ]);
}
function $61de1ee1cac498ae$var$wXc() {
    $61de1ee1cac498ae$var$sXc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$b_, 1), $61de1ee1cac498ae$var$Kie, 293, 0, [
        $61de1ee1cac498ae$var$qXc,
        $61de1ee1cac498ae$var$rXc,
        $61de1ee1cac498ae$var$pXc
    ]);
}
function $61de1ee1cac498ae$var$_$c() {
    $61de1ee1cac498ae$var$Y$c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$J_, 1), $61de1ee1cac498ae$var$Kie, 437, 0, [
        $61de1ee1cac498ae$var$V$c,
        $61de1ee1cac498ae$var$W$c,
        $61de1ee1cac498ae$var$X$c
    ]);
}
function $61de1ee1cac498ae$var$kbd() {
    $61de1ee1cac498ae$var$hbd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$z1, 1), $61de1ee1cac498ae$var$Kie, 334, 0, [
        $61de1ee1cac498ae$var$fbd,
        $61de1ee1cac498ae$var$ebd,
        $61de1ee1cac498ae$var$gbd
    ]);
}
function $61de1ee1cac498ae$var$tad() {
    $61de1ee1cac498ae$var$qad();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$u1, 1), $61de1ee1cac498ae$var$Kie, 272, 0, [
        $61de1ee1cac498ae$var$nad,
        $61de1ee1cac498ae$var$oad,
        $61de1ee1cac498ae$var$pad
    ]);
}
function $61de1ee1cac498ae$var$o3d(a, b) {
    return $61de1ee1cac498ae$var$p3d(a, b, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0);
}
function $61de1ee1cac498ae$var$LZc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$MZc(a, b, false);
    return d.b <= b && d.a <= c;
}
function $61de1ee1cac498ae$var$tMc(a, b, c) {
    var d;
    d = new $61de1ee1cac498ae$var$sMc;
    d.b = b;
    d.a = c;
    ++b.b;
    $61de1ee1cac498ae$var$Ekb(a.d, d);
}
function $61de1ee1cac498ae$var$fs(a, b) {
    var c;
    c = ($61de1ee1cac498ae$var$uCb(a), a).g;
    $61de1ee1cac498ae$var$lCb(!!c);
    $61de1ee1cac498ae$var$uCb(b);
    return c(b);
}
function $61de1ee1cac498ae$var$av(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$cv(a, b);
    c = a.a.Zc(d);
    return new $61de1ee1cac498ae$var$qv(a, c);
}
function $61de1ee1cac498ae$var$cKd(a) {
    if (a.Db >> 16 != 6) return null;
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$aid(a), 235);
}
function $61de1ee1cac498ae$var$Uwd(a) {
    if (a.p != 2) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.f) & $61de1ee1cac498ae$var$aje;
}
function $61de1ee1cac498ae$var$bxd(a) {
    if (a.p != 2) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.k) & $61de1ee1cac498ae$var$aje;
}
function $61de1ee1cac498ae$var$Z1d(a) {
    a.a == ($61de1ee1cac498ae$var$T0d(), $61de1ee1cac498ae$var$S0d) && $61de1ee1cac498ae$var$d2d(a, $61de1ee1cac498ae$var$U0d(a.g, a.b));
    return a.a;
}
function $61de1ee1cac498ae$var$_1d(a) {
    a.d == ($61de1ee1cac498ae$var$T0d(), $61de1ee1cac498ae$var$S0d) && $61de1ee1cac498ae$var$f2d(a, $61de1ee1cac498ae$var$Y0d(a.g, a.b));
    return a.d;
}
function $61de1ee1cac498ae$var$mlb(a) {
    $61de1ee1cac498ae$var$sCb(a.a < a.c.c.length);
    a.b = a.a++;
    return a.c.c[a.b];
}
function $61de1ee1cac498ae$var$hEb(a, b) {
    a.b = a.b | b.b;
    a.c = a.c | b.c;
    a.d = a.d | b.d;
    a.a = a.a | b.a;
}
function $61de1ee1cac498ae$var$xbb(a, b) {
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$dD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b));
}
function $61de1ee1cac498ae$var$Mbb(a, b) {
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$jD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b));
}
function $61de1ee1cac498ae$var$Vbb(a, b) {
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$rD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b));
}
function $61de1ee1cac498ae$var$Dub(a) {
    return $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Nbb($61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$Cub(a, 32)), 32), $61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$Cub(a, 32)));
}
function $61de1ee1cac498ae$var$Mu(a) {
    $61de1ee1cac498ae$var$Qb(a);
    return $61de1ee1cac498ae$var$JD(a, 14) ? new $61de1ee1cac498ae$var$Tkb($61de1ee1cac498ae$var$BD(a, 14)) : $61de1ee1cac498ae$var$Nu(a.Kc());
}
function $61de1ee1cac498ae$var$EWb(a, b) {
    $61de1ee1cac498ae$var$AWb();
    return a.c == b.c ? $61de1ee1cac498ae$var$Kdb(b.d, a.d) : $61de1ee1cac498ae$var$Kdb(a.c, b.c);
}
function $61de1ee1cac498ae$var$FWb(a, b) {
    $61de1ee1cac498ae$var$AWb();
    return a.c == b.c ? $61de1ee1cac498ae$var$Kdb(a.d, b.d) : $61de1ee1cac498ae$var$Kdb(a.c, b.c);
}
function $61de1ee1cac498ae$var$HWb(a, b) {
    $61de1ee1cac498ae$var$AWb();
    return a.c == b.c ? $61de1ee1cac498ae$var$Kdb(a.d, b.d) : $61de1ee1cac498ae$var$Kdb(b.c, a.c);
}
function $61de1ee1cac498ae$var$GWb(a, b) {
    $61de1ee1cac498ae$var$AWb();
    return a.c == b.c ? $61de1ee1cac498ae$var$Kdb(b.d, a.d) : $61de1ee1cac498ae$var$Kdb(b.c, a.c);
}
function $61de1ee1cac498ae$var$WGb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(a.a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Q9c))));
    $61de1ee1cac498ae$var$XGb(a, b, c);
}
function $61de1ee1cac498ae$var$Rgc(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b), 57);
    $61de1ee1cac498ae$var$Hkb(b.d, new $61de1ee1cac498ae$var$Qhc(a, c));
}
function $61de1ee1cac498ae$var$GYb(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$d_b(a);
    d = $61de1ee1cac498ae$var$d_b(b);
    return c < d ? -1 : c > d ? 1 : 0;
}
function $61de1ee1cac498ae$var$bjc(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$ajc(b);
    d = c;
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.c, d), 19).a;
}
function $61de1ee1cac498ae$var$iSc(a, b) {
    var c;
    c = a + "";
    while(c.length < b)c = "0" + c;
    return c;
}
function $61de1ee1cac498ae$var$WRc(a) {
    return a.c == null || a.c.length == 0 ? "n_" + a.g : "n_" + a.c;
}
function $61de1ee1cac498ae$var$oRb(a) {
    return a.c == null || a.c.length == 0 ? "n_" + a.b : "n_" + a.c;
}
function $61de1ee1cac498ae$var$qz(a, b) {
    return !!a && !!a.equals ? a.equals(b) : $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b);
}
function $61de1ee1cac498ae$var$dkd(a, b) {
    if (b == 0) return !!a.o && a.o.f != 0;
    return $61de1ee1cac498ae$var$mid(a, b);
}
function $61de1ee1cac498ae$var$Tdd(a, b, c) {
    var d;
    if (a.n && !!b && !!c) {
        d = new $61de1ee1cac498ae$var$kgd;
        $61de1ee1cac498ae$var$Ekb(a.e, d);
    }
}
function $61de1ee1cac498ae$var$cIc(a, b, c) {
    var d;
    d = a.d[b.p];
    a.d[b.p] = a.d[c.p];
    a.d[c.p] = d;
}
function $61de1ee1cac498ae$var$kxd(a, b, c) {
    this.d = a;
    this.j = b;
    this.e = c;
    this.o = -1;
    this.p = 3;
}
function $61de1ee1cac498ae$var$lxd(a, b, c) {
    this.d = a;
    this.k = b;
    this.f = c;
    this.o = -1;
    this.p = 5;
}
function $61de1ee1cac498ae$var$zge(a, b, c) {
    $61de1ee1cac498ae$var$xfe.call(this, 25);
    this.b = a;
    this.a = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$$fe(a) {
    $61de1ee1cac498ae$var$wfe();
    $61de1ee1cac498ae$var$xfe.call(this, a);
    this.c = false;
    this.a = false;
}
function $61de1ee1cac498ae$var$sSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$rSd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$uSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$tSd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$wSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$vSd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$ySd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$xSd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$ASd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$zSd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$CSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$BSd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$HSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$GSd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$JSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$ISd.call(this, a, b, c, d, e);
    f && (this.o = -2);
}
function $61de1ee1cac498ae$var$nWd(a, b, c, d) {
    $61de1ee1cac498ae$var$VVd.call(this, c);
    this.b = a;
    this.c = b;
    this.d = d;
}
function $61de1ee1cac498ae$var$x$c(a, b) {
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.d = new $61de1ee1cac498ae$var$Rkb;
    this.f = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$PTb() {
    this.c = new $61de1ee1cac498ae$var$bUb;
    this.a = new $61de1ee1cac498ae$var$FYb;
    this.b = new $61de1ee1cac498ae$var$wZb;
    $61de1ee1cac498ae$var$$Yb();
}
function $61de1ee1cac498ae$var$b2c() {
    $61de1ee1cac498ae$var$Y1c();
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.a = new $61de1ee1cac498ae$var$Lqb;
    this.c = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$j2d(a, b) {
    this.g = a;
    this.d = ($61de1ee1cac498ae$var$T0d(), $61de1ee1cac498ae$var$S0d);
    this.a = $61de1ee1cac498ae$var$S0d;
    this.b = b;
}
function $61de1ee1cac498ae$var$O1d(a, b) {
    this.f = a;
    this.a = ($61de1ee1cac498ae$var$T0d(), $61de1ee1cac498ae$var$R0d);
    this.c = $61de1ee1cac498ae$var$R0d;
    this.b = b;
}
function $61de1ee1cac498ae$var$h9d(a, b) {
    !a.c && (a.c = new $61de1ee1cac498ae$var$u3d(a, 0));
    $61de1ee1cac498ae$var$f3d(a.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$I8d), b);
}
function $61de1ee1cac498ae$var$$Tc() {
    $61de1ee1cac498ae$var$$Tc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ZTc = new $61de1ee1cac498ae$var$_Tc("DFS", 0);
    $61de1ee1cac498ae$var$YTc = new $61de1ee1cac498ae$var$_Tc("BFS", 1);
}
function $61de1ee1cac498ae$var$Cc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD(a.Zb().xc(b), 14);
    return !!d && d.Hc(c);
}
function $61de1ee1cac498ae$var$Gc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD(a.Zb().xc(b), 14);
    return !!d && d.Mc(c);
}
function $61de1ee1cac498ae$var$Ofb(a, b, c, d) {
    a.a += "" + $61de1ee1cac498ae$var$qfb(b == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(b), c, d);
    return a;
}
function $61de1ee1cac498ae$var$Xnd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$Ynd(a, b, c, f);
    $61de1ee1cac498ae$var$eLd(a, d);
    $61de1ee1cac498ae$var$fLd(a, e);
    return a;
}
function $61de1ee1cac498ae$var$Ysb(a) {
    $61de1ee1cac498ae$var$sCb(a.b.b != a.d.a);
    a.c = a.b = a.b.b;
    --a.a;
    return a.c.c;
}
function $61de1ee1cac498ae$var$Jgb(a) {
    while(a.d > 0 && a.a[--a.d] == 0);
    a.a[a.d++] == 0 && (a.e = 0);
}
function $61de1ee1cac498ae$var$wwb(a) {
    return !a.a ? a.c : a.e.length == 0 ? a.a.a : a.a.a + ("" + a.e);
}
function $61de1ee1cac498ae$var$RSd(a) {
    return !!a.a && $61de1ee1cac498ae$var$QSd(a.a.a).i != 0 && !(!!a.b && $61de1ee1cac498ae$var$QTd(a.b));
}
function $61de1ee1cac498ae$var$cLd(a) {
    return !!a.u && $61de1ee1cac498ae$var$VKd(a.u.a).i != 0 && !(!!a.n && $61de1ee1cac498ae$var$FMd(a.n));
}
function $61de1ee1cac498ae$var$$i(a) {
    return $61de1ee1cac498ae$var$Zj(a.e.Hd().gc() * a.c.Hd().gc(), 16, new $61de1ee1cac498ae$var$ij(a));
}
function $61de1ee1cac498ae$var$XA(a, b) {
    return $61de1ee1cac498ae$var$ueb($61de1ee1cac498ae$var$Cbb(a.q.getTime()), $61de1ee1cac498ae$var$Cbb(b.q.getTime()));
}
function $61de1ee1cac498ae$var$k_b(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$AQ, $61de1ee1cac498ae$var$jne, 17, a.c.length, 0, 1)), 474);
}
function $61de1ee1cac498ae$var$l_b(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, a.c.length, 0, 1)), 193);
}
function $61de1ee1cac498ae$var$cKc(a) {
    $61de1ee1cac498ae$var$FJc();
    return !$61de1ee1cac498ae$var$OZb(a) && !(!$61de1ee1cac498ae$var$OZb(a) && a.c.i.c == a.d.i.c);
}
function $61de1ee1cac498ae$var$kDb(a, b, c) {
    var d;
    d = ($61de1ee1cac498ae$var$Qb(a), new $61de1ee1cac498ae$var$Tkb(a));
    $61de1ee1cac498ae$var$iDb(new $61de1ee1cac498ae$var$jDb(d, b, c));
}
function $61de1ee1cac498ae$var$rXb(a, b, c) {
    var d;
    d = ($61de1ee1cac498ae$var$Qb(a), new $61de1ee1cac498ae$var$Tkb(a));
    $61de1ee1cac498ae$var$pXb(new $61de1ee1cac498ae$var$qXb(d, b, c));
}
function $61de1ee1cac498ae$var$Nwb(a, b) {
    var c;
    c = 1 - b;
    a.a[c] = $61de1ee1cac498ae$var$Owb(a.a[c], c);
    return $61de1ee1cac498ae$var$Owb(a, b);
}
function $61de1ee1cac498ae$var$YXc(a, b) {
    var c;
    a.e = new $61de1ee1cac498ae$var$QXc;
    c = $61de1ee1cac498ae$var$gVc(b);
    $61de1ee1cac498ae$var$Okb(c, a.c);
    $61de1ee1cac498ae$var$ZXc(a, c, 0);
}
function $61de1ee1cac498ae$var$o4c(a, b, c, d) {
    var e;
    e = new $61de1ee1cac498ae$var$w4c;
    e.a = b;
    e.b = c;
    e.c = d;
    $61de1ee1cac498ae$var$Dsb(a.a, e);
}
function $61de1ee1cac498ae$var$p4c(a, b, c, d) {
    var e;
    e = new $61de1ee1cac498ae$var$w4c;
    e.a = b;
    e.b = c;
    e.c = d;
    $61de1ee1cac498ae$var$Dsb(a.b, e);
}
function $61de1ee1cac498ae$var$i6d(a) {
    var b, c, d;
    b = new $61de1ee1cac498ae$var$A6d;
    c = $61de1ee1cac498ae$var$s6d(b, a);
    $61de1ee1cac498ae$var$z6d(b);
    d = c;
    return d;
}
function $61de1ee1cac498ae$var$vZd() {
    var a, b, c;
    b = (c = (a = new $61de1ee1cac498ae$var$UQd, a), c);
    $61de1ee1cac498ae$var$Ekb($61de1ee1cac498ae$var$rZd, b);
    return b;
}
function $61de1ee1cac498ae$var$H2c(a) {
    a.j.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Ae(a.c);
    $61de1ee1cac498ae$var$h3c(a.a);
    return a;
}
function $61de1ee1cac498ae$var$tgc(a) {
    $61de1ee1cac498ae$var$qgc();
    if ($61de1ee1cac498ae$var$JD(a.g, 10)) return $61de1ee1cac498ae$var$BD(a.g, 10);
    return null;
}
function $61de1ee1cac498ae$var$Zw(a) {
    if ($61de1ee1cac498ae$var$Ah(a).dc()) return false;
    $61de1ee1cac498ae$var$Bh(a, new $61de1ee1cac498ae$var$bx);
    return true;
}
function $61de1ee1cac498ae$var$_y(b) {
    if (!("stack" in b)) try {
        throw b;
    } catch (a) {}
    return b;
}
function $61de1ee1cac498ae$var$Pb(a, b) {
    if (a < 0 || a >= b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Ib(a, b)));
    return a;
}
function $61de1ee1cac498ae$var$Tb(a, b, c) {
    if (a < 0 || b < a || b > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Kb(a, b, c)));
}
function $61de1ee1cac498ae$var$eVb(a, b) {
    $61de1ee1cac498ae$var$Qqb(a.a, b);
    if (b.d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz($61de1ee1cac498ae$var$Hke));
    b.d = a;
}
function $61de1ee1cac498ae$var$xpb(a, b) {
    if (b.$modCount != a.$modCount) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
}
function $61de1ee1cac498ae$var$$pb(a, b) {
    if ($61de1ee1cac498ae$var$JD(b, 42)) return $61de1ee1cac498ae$var$Jd(a.a, $61de1ee1cac498ae$var$BD(b, 42));
    return false;
}
function $61de1ee1cac498ae$var$dib(a, b) {
    if ($61de1ee1cac498ae$var$JD(b, 42)) return $61de1ee1cac498ae$var$Jd(a.a, $61de1ee1cac498ae$var$BD(b, 42));
    return false;
}
function $61de1ee1cac498ae$var$msb(a, b) {
    if ($61de1ee1cac498ae$var$JD(b, 42)) return $61de1ee1cac498ae$var$Jd(a.a, $61de1ee1cac498ae$var$BD(b, 42));
    return false;
}
function $61de1ee1cac498ae$var$qAb(a, b) {
    if (a.a <= a.b) {
        b.ud(a.a++);
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Sbb(a) {
    var b;
    if ($61de1ee1cac498ae$var$Fbb(a)) {
        b = a;
        return b == -0 ? 0 : b;
    }
    return $61de1ee1cac498ae$var$oD(a);
}
function $61de1ee1cac498ae$var$tAb(a) {
    var b;
    $61de1ee1cac498ae$var$Tzb(a);
    b = new $61de1ee1cac498ae$var$drb;
    $61de1ee1cac498ae$var$_ub(a.a, new $61de1ee1cac498ae$var$BAb(b));
    return b;
}
function $61de1ee1cac498ae$var$Yzb(a) {
    var b;
    $61de1ee1cac498ae$var$Tzb(a);
    b = new $61de1ee1cac498ae$var$Gpb;
    $61de1ee1cac498ae$var$_ub(a.a, new $61de1ee1cac498ae$var$mAb(b));
    return b;
}
function $61de1ee1cac498ae$var$Bib(a, b) {
    this.a = a;
    $61de1ee1cac498ae$var$vib.call(this, a);
    $61de1ee1cac498ae$var$wCb(b, a.gc());
    this.b = b;
}
function $61de1ee1cac498ae$var$orb(a) {
    this.e = a;
    this.b = this.e.a.entries();
    this.a = new Array;
}
function $61de1ee1cac498ae$var$Oi(a) {
    return $61de1ee1cac498ae$var$Zj(a.e.Hd().gc() * a.c.Hd().gc(), 273, new $61de1ee1cac498ae$var$cj(a));
}
function $61de1ee1cac498ae$var$Qu(a) {
    return new $61de1ee1cac498ae$var$Skb(($61de1ee1cac498ae$var$Xj(a, $61de1ee1cac498ae$var$Mie), $61de1ee1cac498ae$var$Oy($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$wbb(5, a), a / 10 | 0))));
}
function $61de1ee1cac498ae$var$m_b(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$aR, $61de1ee1cac498ae$var$lne, 11, a.c.length, 0, 1)), 1943);
}
function $61de1ee1cac498ae$var$sMb(a, b, c) {
    return c.f.c.length > 0 ? $61de1ee1cac498ae$var$HMb(a.a, b, c) : $61de1ee1cac498ae$var$HMb(a.b, b, c);
}
function $61de1ee1cac498ae$var$SZb(a, b, c) {
    !!a.d && $61de1ee1cac498ae$var$Lkb(a.d.e, a);
    a.d = b;
    !!a.d && $61de1ee1cac498ae$var$Dkb(a.d.e, c, a);
}
function $61de1ee1cac498ae$var$a5b(a, b) {
    $61de1ee1cac498ae$var$i5b(b, a);
    $61de1ee1cac498ae$var$k5b(a.d);
    $61de1ee1cac498ae$var$k5b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$wxc)), 207));
}
function $61de1ee1cac498ae$var$_4b(a, b) {
    $61de1ee1cac498ae$var$f5b(b, a);
    $61de1ee1cac498ae$var$h5b(a.d);
    $61de1ee1cac498ae$var$h5b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$wxc)), 207));
}
function $61de1ee1cac498ae$var$Ypd(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$aC(a, b);
    d = null;
    !!c && (d = c.fe());
    return d;
}
function $61de1ee1cac498ae$var$Zpd(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$tB(a, b);
    d = null;
    !!c && (d = c.ie());
    return d;
}
function $61de1ee1cac498ae$var$$pd(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$aC(a, b);
    d = null;
    !!c && (d = c.ie());
    return d;
}
function $61de1ee1cac498ae$var$_pd(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$aC(a, b);
    d = null;
    !!c && (d = $61de1ee1cac498ae$var$aqd(c));
    return d;
}
function $61de1ee1cac498ae$var$Tqd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$Wpd(c);
    $61de1ee1cac498ae$var$ro(a.g, d, b);
    $61de1ee1cac498ae$var$ro(a.i, b, c);
    return b;
}
function $61de1ee1cac498ae$var$Ez(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$Cz();
    try {
        return $61de1ee1cac498ae$var$Bz(a, b, c);
    } finally{
        $61de1ee1cac498ae$var$Fz(d);
    }
}
function $61de1ee1cac498ae$var$C6d(a) {
    var b;
    b = a.Wg();
    this.a = $61de1ee1cac498ae$var$JD(b, 69) ? $61de1ee1cac498ae$var$BD(b, 69).Zh() : b.Kc();
}
function $61de1ee1cac498ae$var$j3c() {
    $61de1ee1cac498ae$var$D2c.call(this);
    this.j.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    this.a = -1;
}
function $61de1ee1cac498ae$var$mxd(a, b, c, d) {
    this.d = a;
    this.n = b;
    this.g = c;
    this.o = d;
    this.p = -1;
}
function $61de1ee1cac498ae$var$jk(a, b, c, d) {
    this.e = d;
    this.d = null;
    this.c = a;
    this.a = b;
    this.b = c;
}
function $61de1ee1cac498ae$var$uEc(a, b, c) {
    this.d = new $61de1ee1cac498ae$var$HEc(this);
    this.e = a;
    this.i = b;
    this.f = c;
}
function $61de1ee1cac498ae$var$msc() {
    $61de1ee1cac498ae$var$msc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ksc = new $61de1ee1cac498ae$var$nsc($61de1ee1cac498ae$var$gle, 0);
    $61de1ee1cac498ae$var$lsc = new $61de1ee1cac498ae$var$nsc("TOP_LEFT", 1);
}
function $61de1ee1cac498ae$var$cDc() {
    $61de1ee1cac498ae$var$cDc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$bDc = $61de1ee1cac498ae$var$ix($61de1ee1cac498ae$var$meb(1), $61de1ee1cac498ae$var$meb(4));
    $61de1ee1cac498ae$var$aDc = $61de1ee1cac498ae$var$ix($61de1ee1cac498ae$var$meb(1), $61de1ee1cac498ae$var$meb(2));
}
function $61de1ee1cac498ae$var$z_c() {
    $61de1ee1cac498ae$var$z_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$y_c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$s_c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O_, 1), $61de1ee1cac498ae$var$Kie, 551, 0, [
        $61de1ee1cac498ae$var$r_c
    ])));
}
function $61de1ee1cac498ae$var$q_c() {
    $61de1ee1cac498ae$var$q_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$p_c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$i_c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$N_, 1), $61de1ee1cac498ae$var$Kie, 482, 0, [
        $61de1ee1cac498ae$var$h_c
    ])));
}
function $61de1ee1cac498ae$var$Z0c() {
    $61de1ee1cac498ae$var$Z0c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Y0c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$R0c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$W_, 1), $61de1ee1cac498ae$var$Kie, 530, 0, [
        $61de1ee1cac498ae$var$Q0c
    ])));
}
function $61de1ee1cac498ae$var$hPb() {
    $61de1ee1cac498ae$var$hPb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$gPb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$cPb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$GO, 1), $61de1ee1cac498ae$var$Kie, 481, 0, [
        $61de1ee1cac498ae$var$bPb
    ])));
}
function $61de1ee1cac498ae$var$yLb() {
    $61de1ee1cac498ae$var$vLb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PN, 1), $61de1ee1cac498ae$var$Kie, 406, 0, [
        $61de1ee1cac498ae$var$uLb,
        $61de1ee1cac498ae$var$rLb,
        $61de1ee1cac498ae$var$sLb,
        $61de1ee1cac498ae$var$tLb
    ]);
}
function $61de1ee1cac498ae$var$qxb() {
    $61de1ee1cac498ae$var$lxb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$iL, 1), $61de1ee1cac498ae$var$Kie, 297, 0, [
        $61de1ee1cac498ae$var$hxb,
        $61de1ee1cac498ae$var$ixb,
        $61de1ee1cac498ae$var$jxb,
        $61de1ee1cac498ae$var$kxb
    ]);
}
function $61de1ee1cac498ae$var$UOb() {
    $61de1ee1cac498ae$var$ROb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$CO, 1), $61de1ee1cac498ae$var$Kie, 394, 0, [
        $61de1ee1cac498ae$var$OOb,
        $61de1ee1cac498ae$var$NOb,
        $61de1ee1cac498ae$var$POb,
        $61de1ee1cac498ae$var$QOb
    ]);
}
function $61de1ee1cac498ae$var$UMb() {
    $61de1ee1cac498ae$var$RMb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$jO, 1), $61de1ee1cac498ae$var$Kie, 323, 0, [
        $61de1ee1cac498ae$var$OMb,
        $61de1ee1cac498ae$var$NMb,
        $61de1ee1cac498ae$var$PMb,
        $61de1ee1cac498ae$var$QMb
    ]);
}
function $61de1ee1cac498ae$var$sWb() {
    $61de1ee1cac498ae$var$lWb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SP, 1), $61de1ee1cac498ae$var$Kie, 405, 0, [
        $61de1ee1cac498ae$var$hWb,
        $61de1ee1cac498ae$var$kWb,
        $61de1ee1cac498ae$var$iWb,
        $61de1ee1cac498ae$var$jWb
    ]);
}
function $61de1ee1cac498ae$var$kbc() {
    $61de1ee1cac498ae$var$gbc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$VS, 1), $61de1ee1cac498ae$var$Kie, 360, 0, [
        $61de1ee1cac498ae$var$fbc,
        $61de1ee1cac498ae$var$dbc,
        $61de1ee1cac498ae$var$ebc,
        $61de1ee1cac498ae$var$cbc
    ]);
}
function $61de1ee1cac498ae$var$Vc(a, b, c, d) {
    return $61de1ee1cac498ae$var$JD(c, 54) ? new $61de1ee1cac498ae$var$Cg(a, b, c, d) : new $61de1ee1cac498ae$var$qg(a, b, c, d);
}
function $61de1ee1cac498ae$var$Djc() {
    $61de1ee1cac498ae$var$Ajc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$mV, 1), $61de1ee1cac498ae$var$Kie, 411, 0, [
        $61de1ee1cac498ae$var$wjc,
        $61de1ee1cac498ae$var$xjc,
        $61de1ee1cac498ae$var$yjc,
        $61de1ee1cac498ae$var$zjc
    ]);
}
function $61de1ee1cac498ae$var$okc(a) {
    var b;
    return a.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd) && (b = $61de1ee1cac498ae$var$pkc(a), $61de1ee1cac498ae$var$uqb(b, $61de1ee1cac498ae$var$zcd));
}
function $61de1ee1cac498ae$var$Mdc(a, b) {
    var c;
    c = b.a;
    $61de1ee1cac498ae$var$QZb(c, b.c.d);
    $61de1ee1cac498ae$var$RZb(c, b.d.d);
    $61de1ee1cac498ae$var$q7c(c.a, a.n);
}
function $61de1ee1cac498ae$var$Smc(a, b) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$QAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.k, b), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113);
}
function $61de1ee1cac498ae$var$Tmc(a, b) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$RAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.k, b), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113);
}
function $61de1ee1cac498ae$var$_w(a) {
    return new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$rmb($61de1ee1cac498ae$var$BD(a.a.dd(), 14).gc(), a.a.cd()), 16);
}
function $61de1ee1cac498ae$var$Qq(a) {
    if ($61de1ee1cac498ae$var$JD(a, 14)) return $61de1ee1cac498ae$var$BD(a, 14).dc();
    return !a.Kc().Ob();
}
function $61de1ee1cac498ae$var$ugc(a) {
    $61de1ee1cac498ae$var$qgc();
    if ($61de1ee1cac498ae$var$JD(a.g, 145)) return $61de1ee1cac498ae$var$BD(a.g, 145);
    return null;
}
function $61de1ee1cac498ae$var$Ko(a) {
    if (a.e.g != a.b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
    return !!a.c && a.d > 0;
}
function $61de1ee1cac498ae$var$Xsb(a) {
    $61de1ee1cac498ae$var$sCb(a.b != a.d.c);
    a.c = a.b;
    a.b = a.b.a;
    ++a.a;
    return a.c.c;
}
function $61de1ee1cac498ae$var$Xjb(a, b) {
    $61de1ee1cac498ae$var$uCb(b);
    $61de1ee1cac498ae$var$NC(a.a, a.c, b);
    a.c = a.c + 1 & a.a.length - 1;
    $61de1ee1cac498ae$var$_jb(a);
}
function $61de1ee1cac498ae$var$Wjb(a, b) {
    $61de1ee1cac498ae$var$uCb(b);
    a.b = a.b - 1 & a.a.length - 1;
    $61de1ee1cac498ae$var$NC(a.a, a.b, b);
    $61de1ee1cac498ae$var$_jb(a);
}
function $61de1ee1cac498ae$var$A2c(a, b) {
    var c;
    for(c = a.j.c.length; c < b; c++)$61de1ee1cac498ae$var$Ekb(a.j, a.rg());
}
function $61de1ee1cac498ae$var$gBc(a, b, c, d) {
    var e;
    e = d[b.g][c.g];
    return $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.a, e)));
}
function $61de1ee1cac498ae$var$goc(a, b, c, d, e) {
    this.i = a;
    this.a = b;
    this.e = c;
    this.j = d;
    this.f = e;
}
function $61de1ee1cac498ae$var$DZc(a, b, c, d, e) {
    this.a = a;
    this.e = b;
    this.f = c;
    this.b = d;
    this.g = e;
}
function $61de1ee1cac498ae$var$Fz(a) {
    a && $61de1ee1cac498ae$var$Mz(($61de1ee1cac498ae$var$Kz(), $61de1ee1cac498ae$var$Jz));
    --$61de1ee1cac498ae$var$xz;
    if (a) {
        if ($61de1ee1cac498ae$var$zz != -1) {
            $61de1ee1cac498ae$var$Hz($61de1ee1cac498ae$var$zz);
            $61de1ee1cac498ae$var$zz = -1;
        }
    }
}
function $61de1ee1cac498ae$var$Nzc() {
    $61de1ee1cac498ae$var$Izc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$$W, 1), $61de1ee1cac498ae$var$Kie, 197, 0, [
        $61de1ee1cac498ae$var$Gzc,
        $61de1ee1cac498ae$var$Hzc,
        $61de1ee1cac498ae$var$Fzc,
        $61de1ee1cac498ae$var$Ezc
    ]);
}
function $61de1ee1cac498ae$var$ERc() {
    $61de1ee1cac498ae$var$yRc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$h$, 1), $61de1ee1cac498ae$var$Kie, 393, 0, [
        $61de1ee1cac498ae$var$uRc,
        $61de1ee1cac498ae$var$vRc,
        $61de1ee1cac498ae$var$wRc,
        $61de1ee1cac498ae$var$xRc
    ]);
}
function $61de1ee1cac498ae$var$mXc() {
    $61de1ee1cac498ae$var$iXc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$a_, 1), $61de1ee1cac498ae$var$Kie, 340, 0, [
        $61de1ee1cac498ae$var$hXc,
        $61de1ee1cac498ae$var$fXc,
        $61de1ee1cac498ae$var$gXc,
        $61de1ee1cac498ae$var$eXc
    ]);
}
function $61de1ee1cac498ae$var$wdd() {
    $61de1ee1cac498ae$var$tdd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$I1, 1), $61de1ee1cac498ae$var$Kie, 374, 0, [
        $61de1ee1cac498ae$var$rdd,
        $61de1ee1cac498ae$var$sdd,
        $61de1ee1cac498ae$var$qdd,
        $61de1ee1cac498ae$var$pdd
    ]);
}
function $61de1ee1cac498ae$var$vbd() {
    $61de1ee1cac498ae$var$rbd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$A1, 1), $61de1ee1cac498ae$var$Kie, 285, 0, [
        $61de1ee1cac498ae$var$qbd,
        $61de1ee1cac498ae$var$nbd,
        $61de1ee1cac498ae$var$obd,
        $61de1ee1cac498ae$var$pbd
    ]);
}
function $61de1ee1cac498ae$var$Dad() {
    $61de1ee1cac498ae$var$Aad();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$v1, 1), $61de1ee1cac498ae$var$Kie, 218, 0, [
        $61de1ee1cac498ae$var$zad,
        $61de1ee1cac498ae$var$xad,
        $61de1ee1cac498ae$var$wad,
        $61de1ee1cac498ae$var$yad
    ]);
}
function $61de1ee1cac498ae$var$Ged() {
    $61de1ee1cac498ae$var$Ded();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O1, 1), $61de1ee1cac498ae$var$Kie, 311, 0, [
        $61de1ee1cac498ae$var$Ced,
        $61de1ee1cac498ae$var$zed,
        $61de1ee1cac498ae$var$Bed,
        $61de1ee1cac498ae$var$Aed
    ]);
}
function $61de1ee1cac498ae$var$sgd() {
    $61de1ee1cac498ae$var$pgd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$k2, 1), $61de1ee1cac498ae$var$Kie, 396, 0, [
        $61de1ee1cac498ae$var$mgd,
        $61de1ee1cac498ae$var$ngd,
        $61de1ee1cac498ae$var$lgd,
        $61de1ee1cac498ae$var$ogd
    ]);
}
function $61de1ee1cac498ae$var$gvd(a) {
    $61de1ee1cac498ae$var$evd();
    return $61de1ee1cac498ae$var$Mhb($61de1ee1cac498ae$var$dvd, a) ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb($61de1ee1cac498ae$var$dvd, a), 331).ug() : null;
}
function $61de1ee1cac498ae$var$cid(a, b, c) {
    return b < 0 ? $61de1ee1cac498ae$var$tid(a, c) : $61de1ee1cac498ae$var$BD(c, 66).Nj().Sj(a, a.yh(), b);
}
function $61de1ee1cac498ae$var$Sqd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$Wpd(c);
    $61de1ee1cac498ae$var$ro(a.d, d, b);
    $61de1ee1cac498ae$var$Rhb(a.e, b, c);
    return b;
}
function $61de1ee1cac498ae$var$Uqd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$Wpd(c);
    $61de1ee1cac498ae$var$ro(a.j, d, b);
    $61de1ee1cac498ae$var$Rhb(a.k, b, c);
    return b;
}
function $61de1ee1cac498ae$var$dtd(a) {
    var b, c;
    b = ($61de1ee1cac498ae$var$Fhd(), c = new $61de1ee1cac498ae$var$Tld, c);
    !!a && $61de1ee1cac498ae$var$Rld(b, a);
    return b;
}
function $61de1ee1cac498ae$var$wud(a) {
    var b;
    b = a.ri(a.i);
    a.i > 0 && $61de1ee1cac498ae$var$$fb(a.g, 0, b, 0, a.i);
    return b;
}
function $61de1ee1cac498ae$var$qEd(a, b) {
    $61de1ee1cac498ae$var$pEd();
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb($61de1ee1cac498ae$var$oEd, a), 55);
    return !c || c.wj(b);
}
function $61de1ee1cac498ae$var$Twd(a) {
    if (a.p != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.f) << 24 >> 24;
}
function $61de1ee1cac498ae$var$axd(a) {
    if (a.p != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.k) << 24 >> 24;
}
function $61de1ee1cac498ae$var$gxd(a) {
    if (a.p != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.k) << 16 >> 16;
}
function $61de1ee1cac498ae$var$Zwd(a) {
    if (a.p != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    return $61de1ee1cac498ae$var$Tbb(a.f) << 16 >> 16;
}
function $61de1ee1cac498ae$var$sr(a) {
    var b;
    b = 0;
    while(a.Ob()){
        a.Pb();
        b = $61de1ee1cac498ae$var$wbb(b, 1);
    }
    return $61de1ee1cac498ae$var$Oy(b);
}
function $61de1ee1cac498ae$var$nx(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$Vfb;
    a.xd(c);
    c.a += "..";
    b.yd(c);
    return c.a;
}
function $61de1ee1cac498ae$var$Sgc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, c), 57);
    $61de1ee1cac498ae$var$Ekb(a.a.c, new $61de1ee1cac498ae$var$vgd(b, d));
}
function $61de1ee1cac498ae$var$VCb(a, b, c) {
    return $61de1ee1cac498ae$var$Ddb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, b))), $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, c))));
}
function $61de1ee1cac498ae$var$E2d(a, b, c) {
    return $61de1ee1cac498ae$var$F2d(a, b, c, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0);
}
function $61de1ee1cac498ae$var$L2d(a, b, c) {
    return $61de1ee1cac498ae$var$M2d(a, b, c, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0);
}
function $61de1ee1cac498ae$var$q3d(a, b, c) {
    return $61de1ee1cac498ae$var$r3d(a, b, c, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0);
}
function $61de1ee1cac498ae$var$JJc(a, b) {
    return a == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) && b == $61de1ee1cac498ae$var$h0b ? 4 : a == $61de1ee1cac498ae$var$h0b || b == $61de1ee1cac498ae$var$h0b ? 8 : 32;
}
function $61de1ee1cac498ae$var$Nd(a, b) {
    return $61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(a) ? "(this Map)" : b == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(b);
}
function $61de1ee1cac498ae$var$kFd(a, b) {
    return $61de1ee1cac498ae$var$BD(b == null ? $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, null)) : $61de1ee1cac498ae$var$Crb(a.g, b), 281);
}
function $61de1ee1cac498ae$var$Rqd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$Wpd(c);
    $61de1ee1cac498ae$var$Rhb(a.b, d, b);
    $61de1ee1cac498ae$var$Rhb(a.c, b, c);
    return b;
}
function $61de1ee1cac498ae$var$Bfd(a, b) {
    var c;
    c = b;
    while(c){
        $61de1ee1cac498ae$var$O6c(a, c.i, c.j);
        c = $61de1ee1cac498ae$var$Xod(c);
    }
    return a;
}
function $61de1ee1cac498ae$var$kt(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$vmb($61de1ee1cac498ae$var$Nu(new $61de1ee1cac498ae$var$wu(a, b)));
    $61de1ee1cac498ae$var$ir(new $61de1ee1cac498ae$var$wu(a, b));
    return c;
}
function $61de1ee1cac498ae$var$R6d(a, b) {
    $61de1ee1cac498ae$var$Q6d();
    var c;
    c = $61de1ee1cac498ae$var$BD(a, 66).Mj();
    $61de1ee1cac498ae$var$kVd(c, b);
    return c.Ok(b);
}
function $61de1ee1cac498ae$var$TOc(a, b, c, d, e) {
    var f;
    f = $61de1ee1cac498ae$var$OOc(e, c, d);
    $61de1ee1cac498ae$var$Ekb(b, $61de1ee1cac498ae$var$tOc(e, f));
    $61de1ee1cac498ae$var$XOc(a, e, b);
}
function $61de1ee1cac498ae$var$mic(a, b, c) {
    a.i = 0;
    a.e = 0;
    if (b == c) return;
    $61de1ee1cac498ae$var$lic(a, b, c);
    $61de1ee1cac498ae$var$kic(a, b, c);
}
function $61de1ee1cac498ae$var$dB(a, b) {
    var c;
    c = a.q.getHours();
    a.q.setFullYear(b + $61de1ee1cac498ae$var$nje);
    $61de1ee1cac498ae$var$YA(a, c);
}
function $61de1ee1cac498ae$var$dC(d, a, b) {
    if (b) {
        var c = b.ee();
        d.a[a] = c(b);
    } else delete d.a[a];
}
function $61de1ee1cac498ae$var$vB(d, a, b) {
    if (b) {
        var c = b.ee();
        b = c(b);
    } else b = undefined;
    d.a[a] = b;
}
function $61de1ee1cac498ae$var$pCb(a) {
    if (a < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Feb("Negative array size: " + a));
}
function $61de1ee1cac498ae$var$VKd(a) {
    if (!a.n) {
        $61de1ee1cac498ae$var$$Kd(a);
        a.n = new $61de1ee1cac498ae$var$JMd(a, $61de1ee1cac498ae$var$j5, a);
        $61de1ee1cac498ae$var$_Kd(a);
    }
    return a.n;
}
function $61de1ee1cac498ae$var$Fqb(a) {
    $61de1ee1cac498ae$var$sCb(a.a < a.c.a.length);
    a.b = a.a;
    $61de1ee1cac498ae$var$Dqb(a);
    return a.c.b[a.b];
}
function $61de1ee1cac498ae$var$Yjb(a) {
    if (a.b == a.c) return;
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 8, 5, 1);
    a.b = 0;
    a.c = 0;
}
function $61de1ee1cac498ae$var$AQb(a) {
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.c = new $61de1ee1cac498ae$var$Lqb;
    this.d = new $61de1ee1cac498ae$var$Lqb;
    this.a = a;
}
function $61de1ee1cac498ae$var$lge(a, b) {
    $61de1ee1cac498ae$var$wfe();
    $61de1ee1cac498ae$var$xfe.call(this, a);
    this.a = b;
    this.c = -1;
    this.b = -1;
}
function $61de1ee1cac498ae$var$lSd(a, b, c, d) {
    $61de1ee1cac498ae$var$kxd.call(this, 1, c, d);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$mSd(a, b, c, d) {
    $61de1ee1cac498ae$var$lxd.call(this, 1, c, d);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$O7d(a, b, c, d, e, f, g) {
    $61de1ee1cac498ae$var$nxd.call(this, b, d, e, f, g);
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$LVd(a, b, c) {
    this.e = a;
    this.a = $61de1ee1cac498ae$var$SI;
    this.b = $61de1ee1cac498ae$var$R5d(b);
    this.c = b;
    this.d = c;
}
function $61de1ee1cac498ae$var$Lo(a) {
    this.e = a;
    this.c = this.e.a;
    this.b = this.e.g;
    this.d = this.e.i;
}
function $61de1ee1cac498ae$var$nYd(a) {
    this.c = a;
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$wId(a), 148);
    this.b = this.a.Aj().Nh();
}
function $61de1ee1cac498ae$var$Irb(a) {
    this.d = a;
    this.b = this.d.a.entries();
    this.a = this.b.next();
}
function $61de1ee1cac498ae$var$$rb() {
    $61de1ee1cac498ae$var$Lqb.call(this);
    $61de1ee1cac498ae$var$Trb(this);
    this.d.b = this.d;
    this.d.a = this.d;
}
function $61de1ee1cac498ae$var$mRb(a, b) {
    $61de1ee1cac498ae$var$_Qb.call(this);
    this.a = a;
    this.b = b;
    $61de1ee1cac498ae$var$Ekb(this.a.b, this);
}
function $61de1ee1cac498ae$var$uFd(a, b) {
    var c;
    return c = b != null ? $61de1ee1cac498ae$var$Phb(a, b) : $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, b)), $61de1ee1cac498ae$var$RD(c);
}
function $61de1ee1cac498ae$var$FFd(a, b) {
    var c;
    return c = b != null ? $61de1ee1cac498ae$var$Phb(a, b) : $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, b)), $61de1ee1cac498ae$var$RD(c);
}
function $61de1ee1cac498ae$var$Fob(a, b) {
    var c;
    for(c = 0; c < b; ++c)$61de1ee1cac498ae$var$NC(a, c, new $61de1ee1cac498ae$var$Rob($61de1ee1cac498ae$var$BD(a[c], 42)));
}
function $61de1ee1cac498ae$var$Lgb(a, b) {
    var c;
    for(c = a.d - 1; c >= 0 && a.a[c] === b[c]; c--);
    return c < 0;
}
function $61de1ee1cac498ae$var$Ucc(a, b) {
    $61de1ee1cac498ae$var$Occ();
    var c;
    c = a.j.g - b.j.g;
    if (c != 0) return c;
    return 0;
}
function $61de1ee1cac498ae$var$Dtb(a, b) {
    $61de1ee1cac498ae$var$uCb(b);
    if (a.a != null) return $61de1ee1cac498ae$var$Itb(b.Kb(a.a));
    return $61de1ee1cac498ae$var$ztb;
}
function $61de1ee1cac498ae$var$Gx(a) {
    var b;
    if (a) return new $61de1ee1cac498ae$var$Bsb(a);
    b = new $61de1ee1cac498ae$var$zsb;
    $61de1ee1cac498ae$var$Jq(b, a);
    return b;
}
function $61de1ee1cac498ae$var$GAb(a, b) {
    var c;
    return b.b.Kb($61de1ee1cac498ae$var$SAb(a, b.c.Ee(), (c = new $61de1ee1cac498ae$var$TBb(b), c)));
}
function $61de1ee1cac498ae$var$Hub(a) {
    $61de1ee1cac498ae$var$zub();
    $61de1ee1cac498ae$var$Eub(this, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Obb(a, 24), $61de1ee1cac498ae$var$nke)), $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$xbb(a, $61de1ee1cac498ae$var$nke)));
}
function $61de1ee1cac498ae$var$REb() {
    $61de1ee1cac498ae$var$REb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$QEb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$MEb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$aN, 1), $61de1ee1cac498ae$var$Kie, 428, 0, [
        $61de1ee1cac498ae$var$LEb,
        $61de1ee1cac498ae$var$KEb
    ])));
}
function $61de1ee1cac498ae$var$ZEb() {
    $61de1ee1cac498ae$var$ZEb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$YEb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$UEb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bN, 1), $61de1ee1cac498ae$var$Kie, 427, 0, [
        $61de1ee1cac498ae$var$SEb,
        $61de1ee1cac498ae$var$TEb
    ])));
}
function $61de1ee1cac498ae$var$aSb() {
    $61de1ee1cac498ae$var$aSb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$_Rb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$XRb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$gP, 1), $61de1ee1cac498ae$var$Kie, 424, 0, [
        $61de1ee1cac498ae$var$VRb,
        $61de1ee1cac498ae$var$WRb
    ])));
}
function $61de1ee1cac498ae$var$D5b() {
    $61de1ee1cac498ae$var$D5b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$C5b = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$y5b(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZR, 1), $61de1ee1cac498ae$var$Kie, 511, 0, [
        $61de1ee1cac498ae$var$x5b,
        $61de1ee1cac498ae$var$w5b
    ])));
}
function $61de1ee1cac498ae$var$Cqc() {
    $61de1ee1cac498ae$var$Cqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Bqc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$xqc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$JW, 1), $61de1ee1cac498ae$var$Kie, 419, 0, [
        $61de1ee1cac498ae$var$vqc,
        $61de1ee1cac498ae$var$wqc
    ])));
}
function $61de1ee1cac498ae$var$erc() {
    $61de1ee1cac498ae$var$erc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$drc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$_qc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$MW, 1), $61de1ee1cac498ae$var$Kie, 479, 0, [
        $61de1ee1cac498ae$var$$qc,
        $61de1ee1cac498ae$var$Zqc
    ])));
}
function $61de1ee1cac498ae$var$eBc() {
    $61de1ee1cac498ae$var$eBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$dBc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$_Ac(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$fX, 1), $61de1ee1cac498ae$var$Kie, 376, 0, [
        $61de1ee1cac498ae$var$$Ac,
        $61de1ee1cac498ae$var$ZAc
    ])));
}
function $61de1ee1cac498ae$var$GAc() {
    $61de1ee1cac498ae$var$GAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$FAc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$BAc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$cX, 1), $61de1ee1cac498ae$var$Kie, 421, 0, [
        $61de1ee1cac498ae$var$zAc,
        $61de1ee1cac498ae$var$AAc
    ])));
}
function $61de1ee1cac498ae$var$Npc() {
    $61de1ee1cac498ae$var$Npc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Mpc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Ipc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$FW, 1), $61de1ee1cac498ae$var$Kie, 422, 0, [
        $61de1ee1cac498ae$var$Gpc,
        $61de1ee1cac498ae$var$Hpc
    ])));
}
function $61de1ee1cac498ae$var$rsc() {
    $61de1ee1cac498ae$var$rsc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qsc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$msc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SW, 1), $61de1ee1cac498ae$var$Kie, 420, 0, [
        $61de1ee1cac498ae$var$ksc,
        $61de1ee1cac498ae$var$lsc
    ])));
}
function $61de1ee1cac498ae$var$MOc() {
    $61de1ee1cac498ae$var$MOc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$LOc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$DZ, 1), $61de1ee1cac498ae$var$Kie, 520, 0, [
        $61de1ee1cac498ae$var$GOc,
        $61de1ee1cac498ae$var$FOc
    ])));
}
function $61de1ee1cac498ae$var$ZIc() {
    $61de1ee1cac498ae$var$ZIc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$YIc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$UIc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$mY, 1), $61de1ee1cac498ae$var$Kie, 523, 0, [
        $61de1ee1cac498ae$var$TIc,
        $61de1ee1cac498ae$var$SIc
    ])));
}
function $61de1ee1cac498ae$var$bMc() {
    $61de1ee1cac498ae$var$bMc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$aMc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$fZ, 1), $61de1ee1cac498ae$var$Kie, 516, 0, [
        $61de1ee1cac498ae$var$XLc,
        $61de1ee1cac498ae$var$WLc
    ])));
}
function $61de1ee1cac498ae$var$jMc() {
    $61de1ee1cac498ae$var$jMc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$iMc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$gZ, 1), $61de1ee1cac498ae$var$Kie, 515, 0, [
        $61de1ee1cac498ae$var$cMc,
        $61de1ee1cac498ae$var$dMc
    ])));
}
function $61de1ee1cac498ae$var$KQc() {
    $61de1ee1cac498ae$var$KQc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$JQc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$YZ, 1), $61de1ee1cac498ae$var$Kie, 455, 0, [
        $61de1ee1cac498ae$var$DQc,
        $61de1ee1cac498ae$var$EQc
    ])));
}
function $61de1ee1cac498ae$var$dUc() {
    $61de1ee1cac498ae$var$dUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$cUc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$$Tc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F$, 1), $61de1ee1cac498ae$var$Kie, 425, 0, [
        $61de1ee1cac498ae$var$ZTc,
        $61de1ee1cac498ae$var$YTc
    ])));
}
function $61de1ee1cac498ae$var$XUc() {
    $61de1ee1cac498ae$var$XUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$WUc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$PUc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$K$, 1), $61de1ee1cac498ae$var$Kie, 495, 0, [
        $61de1ee1cac498ae$var$NUc,
        $61de1ee1cac498ae$var$OUc
    ])));
}
function $61de1ee1cac498ae$var$XTc() {
    $61de1ee1cac498ae$var$XTc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$WTc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$STc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E$, 1), $61de1ee1cac498ae$var$Kie, 480, 0, [
        $61de1ee1cac498ae$var$QTc,
        $61de1ee1cac498ae$var$RTc
    ])));
}
function $61de1ee1cac498ae$var$lWc() {
    $61de1ee1cac498ae$var$lWc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$kWc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$fWc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$X$, 1), $61de1ee1cac498ae$var$Kie, 426, 0, [
        $61de1ee1cac498ae$var$dWc,
        $61de1ee1cac498ae$var$eWc
    ])));
}
function $61de1ee1cac498ae$var$i1c() {
    $61de1ee1cac498ae$var$i1c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$h1c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$a1c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$X_, 1), $61de1ee1cac498ae$var$Kie, 429, 0, [
        $61de1ee1cac498ae$var$_0c,
        $61de1ee1cac498ae$var$$0c
    ])));
}
function $61de1ee1cac498ae$var$H_c() {
    $61de1ee1cac498ae$var$H_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$G_c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$C_c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$P_, 1), $61de1ee1cac498ae$var$Kie, 430, 0, [
        $61de1ee1cac498ae$var$B_c,
        $61de1ee1cac498ae$var$A_c
    ])));
}
function $61de1ee1cac498ae$var$UIc() {
    $61de1ee1cac498ae$var$UIc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$TIc = new $61de1ee1cac498ae$var$VIc("UPPER", 0);
    $61de1ee1cac498ae$var$SIc = new $61de1ee1cac498ae$var$VIc("LOWER", 1);
}
function $61de1ee1cac498ae$var$Lqd(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$eC;
    $61de1ee1cac498ae$var$Spd(c, "x", b.a);
    $61de1ee1cac498ae$var$Spd(c, "y", b.b);
    $61de1ee1cac498ae$var$Qpd(a, c);
}
function $61de1ee1cac498ae$var$Oqd(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$eC;
    $61de1ee1cac498ae$var$Spd(c, "x", b.a);
    $61de1ee1cac498ae$var$Spd(c, "y", b.b);
    $61de1ee1cac498ae$var$Qpd(a, c);
}
function $61de1ee1cac498ae$var$Jic(a, b) {
    var c, d;
    d = false;
    do {
        c = $61de1ee1cac498ae$var$Mic(a, b);
        d = d | c;
    }while (c);
    return d;
}
function $61de1ee1cac498ae$var$zHc(a, b) {
    var c, d;
    c = b;
    d = 0;
    while(c > 0){
        d += a.a[c];
        c -= c & -c;
    }
    return d;
}
function $61de1ee1cac498ae$var$Cfd(a, b) {
    var c;
    c = b;
    while(c){
        $61de1ee1cac498ae$var$O6c(a, -c.i, -c.j);
        c = $61de1ee1cac498ae$var$Xod(c);
    }
    return a;
}
function $61de1ee1cac498ae$var$reb(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$uCb(b);
    for(d = a.Kc(); d.Ob();){
        c = d.Pb();
        b.td(c);
    }
}
function $61de1ee1cac498ae$var$me(a, b) {
    var c;
    c = b.cd();
    return new $61de1ee1cac498ae$var$Wo(c, a.e.pc(c, $61de1ee1cac498ae$var$BD(b.dd(), 14)));
}
function $61de1ee1cac498ae$var$Gsb(a, b, c, d) {
    var e;
    e = new $61de1ee1cac498ae$var$jtb;
    e.c = b;
    e.b = c;
    e.a = d;
    d.b = c.a = e;
    ++a.b;
}
function $61de1ee1cac498ae$var$Nkb(a, b, c) {
    var d;
    d = ($61de1ee1cac498ae$var$tCb(b, a.c.length), a.c[b]);
    a.c[b] = c;
    return d;
}
function $61de1ee1cac498ae$var$lFd(a, b, c) {
    return $61de1ee1cac498ae$var$BD(b == null ? $61de1ee1cac498ae$var$jrb(a.f, null, c) : $61de1ee1cac498ae$var$Drb(a.g, b, c), 281);
}
function $61de1ee1cac498ae$var$fRb(a) {
    return !!a.c && !!a.d ? $61de1ee1cac498ae$var$oRb(a.c) + "->" + $61de1ee1cac498ae$var$oRb(a.d) : "e_" + $61de1ee1cac498ae$var$FCb(a);
}
function $61de1ee1cac498ae$var$FAb(a, b) {
    return ($61de1ee1cac498ae$var$Uzb(a), $61de1ee1cac498ae$var$WAb(new $61de1ee1cac498ae$var$YAb(a, new $61de1ee1cac498ae$var$qBb(b, a.a)))).sd($61de1ee1cac498ae$var$DAb);
}
function $61de1ee1cac498ae$var$tUb() {
    $61de1ee1cac498ae$var$qUb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$zP, 1), $61de1ee1cac498ae$var$Kie, 356, 0, [
        $61de1ee1cac498ae$var$lUb,
        $61de1ee1cac498ae$var$mUb,
        $61de1ee1cac498ae$var$nUb,
        $61de1ee1cac498ae$var$oUb,
        $61de1ee1cac498ae$var$pUb
    ]);
}
function $61de1ee1cac498ae$var$_cd() {
    $61de1ee1cac498ae$var$Ucd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ]);
}
function $61de1ee1cac498ae$var$Dz(b) {
    $61de1ee1cac498ae$var$Az();
    return function() {
        var a;
        return $61de1ee1cac498ae$var$Ez(b, this, arguments);
    };
}
function $61de1ee1cac498ae$var$sz() {
    if (Date.now) return Date.now();
    return (new Date).getTime();
}
function $61de1ee1cac498ae$var$OZb(a) {
    if (!a.c || !a.d) return false;
    return !!a.c.i && a.c.i == a.d.i;
}
function $61de1ee1cac498ae$var$pv(a) {
    if (!a.c.Sb()) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    a.a = true;
    return a.c.Ub();
}
function $61de1ee1cac498ae$var$ko(a) {
    a.i = 0;
    $61de1ee1cac498ae$var$Alb(a.b, null);
    $61de1ee1cac498ae$var$Alb(a.c, null);
    a.a = null;
    a.e = null;
    ++a.g;
}
function $61de1ee1cac498ae$var$ycb(a) {
    $61de1ee1cac498ae$var$wcb.call(this, a == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(a), $61de1ee1cac498ae$var$JD(a, 78) ? $61de1ee1cac498ae$var$BD(a, 78) : null);
}
function $61de1ee1cac498ae$var$PYb(a) {
    $61de1ee1cac498ae$var$MYb();
    $61de1ee1cac498ae$var$yXb(this);
    this.a = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$NYb(this, a);
    $61de1ee1cac498ae$var$Dsb(this.a, a);
}
function $61de1ee1cac498ae$var$jYb() {
    $61de1ee1cac498ae$var$Ckb(this);
    this.b = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Pje, $61de1ee1cac498ae$var$Pje);
    this.a = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Qje, $61de1ee1cac498ae$var$Qje);
}
function $61de1ee1cac498ae$var$rAb(a, b) {
    this.c = 0;
    this.b = b;
    $61de1ee1cac498ae$var$jvb.call(this, a, 17493);
    this.a = this.c;
}
function $61de1ee1cac498ae$var$wyb(a) {
    $61de1ee1cac498ae$var$oyb();
    if ($61de1ee1cac498ae$var$lyb) return;
    this.c = a;
    this.e = true;
    this.a = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$oyb() {
    $61de1ee1cac498ae$var$oyb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$lyb = true;
    $61de1ee1cac498ae$var$jyb = false;
    $61de1ee1cac498ae$var$kyb = false;
    $61de1ee1cac498ae$var$nyb = false;
    $61de1ee1cac498ae$var$myb = false;
}
function $61de1ee1cac498ae$var$C3c(a, b) {
    if ($61de1ee1cac498ae$var$JD(b, 149)) return $61de1ee1cac498ae$var$dfb(a.c, $61de1ee1cac498ae$var$BD(b, 149).c);
    return false;
}
function $61de1ee1cac498ae$var$zUc(a, b) {
    var c;
    c = 0;
    !!a && (c += a.f.a / 2);
    !!b && (c += b.f.a / 2);
    return c;
}
function $61de1ee1cac498ae$var$j4c(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(a.d, b), 23);
    return c ? c : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(a.e, b), 23);
}
function $61de1ee1cac498ae$var$Lzd(a) {
    this.b = a;
    $61de1ee1cac498ae$var$Fyd.call(this, a);
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126);
}
function $61de1ee1cac498ae$var$Uzd(a) {
    this.b = a;
    $61de1ee1cac498ae$var$$yd.call(this, a);
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126);
}
function $61de1ee1cac498ae$var$$Kd(a) {
    if (!a.t) {
        a.t = new $61de1ee1cac498ae$var$YMd(a);
        $61de1ee1cac498ae$var$vtd(new $61de1ee1cac498ae$var$c0d(a), 0, a.t);
    }
    return a.t;
}
function $61de1ee1cac498ae$var$kad() {
    $61de1ee1cac498ae$var$ead();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t1, 1), $61de1ee1cac498ae$var$Kie, 103, 0, [
        $61de1ee1cac498ae$var$cad,
        $61de1ee1cac498ae$var$bad,
        $61de1ee1cac498ae$var$aad,
        $61de1ee1cac498ae$var$_9c,
        $61de1ee1cac498ae$var$dad
    ]);
}
function $61de1ee1cac498ae$var$Wbd() {
    $61de1ee1cac498ae$var$Tbd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C1, 1), $61de1ee1cac498ae$var$Kie, 249, 0, [
        $61de1ee1cac498ae$var$Qbd,
        $61de1ee1cac498ae$var$Sbd,
        $61de1ee1cac498ae$var$Obd,
        $61de1ee1cac498ae$var$Pbd,
        $61de1ee1cac498ae$var$Rbd
    ]);
}
function $61de1ee1cac498ae$var$Q5c() {
    $61de1ee1cac498ae$var$N5c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$L5c,
        $61de1ee1cac498ae$var$K5c,
        $61de1ee1cac498ae$var$I5c,
        $61de1ee1cac498ae$var$M5c,
        $61de1ee1cac498ae$var$J5c
    ]);
}
function $61de1ee1cac498ae$var$Q_c() {
    $61de1ee1cac498ae$var$N_c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$Q_, 1), $61de1ee1cac498ae$var$Kie, 316, 0, [
        $61de1ee1cac498ae$var$I_c,
        $61de1ee1cac498ae$var$J_c,
        $61de1ee1cac498ae$var$M_c,
        $61de1ee1cac498ae$var$K_c,
        $61de1ee1cac498ae$var$L_c
    ]);
}
function $61de1ee1cac498ae$var$_zc() {
    $61de1ee1cac498ae$var$Vzc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$_W, 1), $61de1ee1cac498ae$var$Kie, 315, 0, [
        $61de1ee1cac498ae$var$Uzc,
        $61de1ee1cac498ae$var$Rzc,
        $61de1ee1cac498ae$var$Szc,
        $61de1ee1cac498ae$var$Qzc,
        $61de1ee1cac498ae$var$Tzc
    ]);
}
function $61de1ee1cac498ae$var$sqc() {
    $61de1ee1cac498ae$var$mqc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$IW, 1), $61de1ee1cac498ae$var$Kie, 335, 0, [
        $61de1ee1cac498ae$var$iqc,
        $61de1ee1cac498ae$var$hqc,
        $61de1ee1cac498ae$var$kqc,
        $61de1ee1cac498ae$var$lqc,
        $61de1ee1cac498ae$var$jqc
    ]);
}
function $61de1ee1cac498ae$var$n$c() {
    $61de1ee1cac498ae$var$k$c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$y_, 1), $61de1ee1cac498ae$var$Kie, 355, 0, [
        $61de1ee1cac498ae$var$g$c,
        $61de1ee1cac498ae$var$f$c,
        $61de1ee1cac498ae$var$i$c,
        $61de1ee1cac498ae$var$h$c,
        $61de1ee1cac498ae$var$j$c
    ]);
}
function $61de1ee1cac498ae$var$_jc() {
    $61de1ee1cac498ae$var$Xjc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$uV, 1), $61de1ee1cac498ae$var$Kie, 363, 0, [
        $61de1ee1cac498ae$var$Tjc,
        $61de1ee1cac498ae$var$Vjc,
        $61de1ee1cac498ae$var$Wjc,
        $61de1ee1cac498ae$var$Ujc,
        $61de1ee1cac498ae$var$Sjc
    ]);
}
function $61de1ee1cac498ae$var$Ftc() {
    $61de1ee1cac498ae$var$Ctc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$TW, 1), $61de1ee1cac498ae$var$Kie, 163, 0, [
        $61de1ee1cac498ae$var$Btc,
        $61de1ee1cac498ae$var$xtc,
        $61de1ee1cac498ae$var$ytc,
        $61de1ee1cac498ae$var$ztc,
        $61de1ee1cac498ae$var$Atc
    ]);
}
function $61de1ee1cac498ae$var$T0d() {
    $61de1ee1cac498ae$var$T0d = $61de1ee1cac498ae$var$ccb;
    var a, b;
    $61de1ee1cac498ae$var$R0d = ($61de1ee1cac498ae$var$LFd(), b = new $61de1ee1cac498ae$var$MPd, b);
    $61de1ee1cac498ae$var$S0d = (a = new $61de1ee1cac498ae$var$OJd, a);
}
function $61de1ee1cac498ae$var$yUd(a) {
    var b;
    if (!a.c) {
        b = a.r;
        $61de1ee1cac498ae$var$JD(b, 88) && (a.c = $61de1ee1cac498ae$var$BD(b, 26));
    }
    return a.c;
}
function $61de1ee1cac498ae$var$zc(a) {
    a.e = 3;
    a.d = a.Yb();
    if (a.e != 2) {
        a.e = 0;
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$RC(a) {
    var b, c, d;
    b = a & $61de1ee1cac498ae$var$Eje;
    c = a >> 22 & $61de1ee1cac498ae$var$Eje;
    d = a < 0 ? $61de1ee1cac498ae$var$Fje : 0;
    return $61de1ee1cac498ae$var$TC(b, c, d);
}
function $61de1ee1cac498ae$var$uy(a) {
    var b, c, d, e;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$Qzb(b);
    }
}
function $61de1ee1cac498ae$var$Tc(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Iv(a.c, b), 14);
    if (c) {
        d = c.gc();
        c.$b();
        a.d -= d;
    }
}
function $61de1ee1cac498ae$var$tjb(a, b) {
    var c, d;
    c = b.cd();
    d = $61de1ee1cac498ae$var$Awb(a, c);
    return !!d && $61de1ee1cac498ae$var$wtb(d.e, b.dd());
}
function $61de1ee1cac498ae$var$Qgb(a, b) {
    if (b == 0 || a.e == 0) return a;
    return b > 0 ? $61de1ee1cac498ae$var$ihb(a, b) : $61de1ee1cac498ae$var$lhb(a, -b);
}
function $61de1ee1cac498ae$var$Rgb(a, b) {
    if (b == 0 || a.e == 0) return a;
    return b > 0 ? $61de1ee1cac498ae$var$lhb(a, b) : $61de1ee1cac498ae$var$ihb(a, -b);
}
function $61de1ee1cac498ae$var$Rr(a) {
    if ($61de1ee1cac498ae$var$Qr(a)) {
        a.c = a.a;
        return a.a.Pb();
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
}
function $61de1ee1cac498ae$var$Yac(a) {
    var b, c;
    b = a.c.i;
    c = a.d.i;
    return b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) && c.k == $61de1ee1cac498ae$var$e0b;
}
function $61de1ee1cac498ae$var$kZb(a) {
    var b;
    b = new $61de1ee1cac498ae$var$UZb;
    $61de1ee1cac498ae$var$tNb(b, a);
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc), null);
    return b;
}
function $61de1ee1cac498ae$var$hid(a, b, c) {
    var d;
    return d = a.Yg(b), d >= 0 ? a._g(d, c, true) : $61de1ee1cac498ae$var$sid(a, b, c);
}
function $61de1ee1cac498ae$var$uHb(a, b, c, d) {
    var e;
    for(e = 0; e < $61de1ee1cac498ae$var$rHb; e++)$61de1ee1cac498ae$var$nHb(a.a[b.g][e], c, d[b.g]);
}
function $61de1ee1cac498ae$var$vHb(a, b, c, d) {
    var e;
    for(e = 0; e < $61de1ee1cac498ae$var$sHb; e++)$61de1ee1cac498ae$var$mHb(a.a[e][b.g], c, d[b.g]);
}
function $61de1ee1cac498ae$var$vSd(a, b, c, d, e) {
    $61de1ee1cac498ae$var$kxd.call(this, b, d, e);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$zSd(a, b, c, d, e) {
    $61de1ee1cac498ae$var$lxd.call(this, b, d, e);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$ISd(a, b, c, d, e) {
    $61de1ee1cac498ae$var$oxd.call(this, b, d, e);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$qSd(a, b, c, d, e) {
    $61de1ee1cac498ae$var$oxd.call(this, b, d, e);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.b = c;
}
function $61de1ee1cac498ae$var$mWd(a, b, c) {
    $61de1ee1cac498ae$var$VVd.call(this, c);
    this.b = a;
    this.c = b;
    this.d = ($61de1ee1cac498ae$var$CWd(), $61de1ee1cac498ae$var$AWd);
}
function $61de1ee1cac498ae$var$oxd(a, b, c) {
    this.d = a;
    this.k = b ? 1 : 0;
    this.f = c ? 1 : 0;
    this.o = -1;
    this.p = 0;
}
function $61de1ee1cac498ae$var$_6d(a, b, c) {
    var d;
    d = new $61de1ee1cac498ae$var$a7d(a.a);
    $61de1ee1cac498ae$var$Ld(d, a.a.a);
    $61de1ee1cac498ae$var$jrb(d.f, b, c);
    a.a.a = d;
}
function $61de1ee1cac498ae$var$lud(a, b) {
    a.qi(a.i + 1);
    $61de1ee1cac498ae$var$mud(a, a.i, a.oi(a.i, b));
    a.bi(a.i++, b);
    a.ci();
}
function $61de1ee1cac498ae$var$oud(a) {
    var b, c;
    ++a.j;
    b = a.g;
    c = a.i;
    a.g = null;
    a.i = 0;
    a.di(c, b);
    a.ci();
}
function $61de1ee1cac498ae$var$Ou(a) {
    var b, c;
    $61de1ee1cac498ae$var$Qb(a);
    b = $61de1ee1cac498ae$var$Iu(a.length);
    c = new $61de1ee1cac498ae$var$Skb(b);
    $61de1ee1cac498ae$var$nmb(c, a);
    return c;
}
function $61de1ee1cac498ae$var$km(a) {
    var b;
    b = ($61de1ee1cac498ae$var$Qb(a), a ? new $61de1ee1cac498ae$var$Tkb(a) : $61de1ee1cac498ae$var$Nu(a.Kc()));
    $61de1ee1cac498ae$var$smb(b);
    return $61de1ee1cac498ae$var$Dm(b);
}
function $61de1ee1cac498ae$var$Kkb(a, b) {
    var c;
    c = ($61de1ee1cac498ae$var$tCb(b, a.c.length), a.c[b]);
    $61de1ee1cac498ae$var$cCb(a.c, b, 1);
    return c;
}
function $61de1ee1cac498ae$var$Qc(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD(a.c.xc(b), 14);
    !c && (c = a.ic(b));
    return a.pc(b, c);
}
function $61de1ee1cac498ae$var$cfb(a, b) {
    var c, d;
    c = ($61de1ee1cac498ae$var$uCb(a), a);
    d = ($61de1ee1cac498ae$var$uCb(b), b);
    return c == d ? 0 : c < d ? -1 : 1;
}
function $61de1ee1cac498ae$var$Fpb(a) {
    var b;
    b = a.e + a.f;
    if (isNaN(b) && $61de1ee1cac498ae$var$Ldb(a.d)) return a.d;
    return b;
}
function $61de1ee1cac498ae$var$uwb(a, b) {
    !a.a ? a.a = new $61de1ee1cac498ae$var$Wfb(a.d) : $61de1ee1cac498ae$var$Qfb(a.a, a.b);
    $61de1ee1cac498ae$var$Nfb(a.a, b);
    return a;
}
function $61de1ee1cac498ae$var$Sb(a, b) {
    if (a < 0 || a > b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Jb(a, b, "index")));
    return a;
}
function $61de1ee1cac498ae$var$zhb(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b, 15, 1);
    $61de1ee1cac498ae$var$Ahb(e, a, b, c, d);
    return e;
}
function $61de1ee1cac498ae$var$_A(a, b) {
    var c;
    c = a.q.getHours() + (b / 60 | 0);
    a.q.setMinutes(b);
    $61de1ee1cac498ae$var$YA(a, c);
}
function $61de1ee1cac498ae$var$A$c(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$S6c(b.a, a.d.d.c), $61de1ee1cac498ae$var$S6c(b.b, a.d.d.c));
}
function $61de1ee1cac498ae$var$Thb(a, b) {
    return $61de1ee1cac498ae$var$ND(b) ? b == null ? $61de1ee1cac498ae$var$krb(a.f, null) : $61de1ee1cac498ae$var$Erb(a.g, b) : $61de1ee1cac498ae$var$krb(a.f, b);
}
function $61de1ee1cac498ae$var$b1b(a) {
    this.c = a;
    this.a = new $61de1ee1cac498ae$var$olb(this.c.a);
    this.b = new $61de1ee1cac498ae$var$olb(this.c.b);
}
function $61de1ee1cac498ae$var$kRb() {
    this.e = new $61de1ee1cac498ae$var$Rkb;
    this.c = new $61de1ee1cac498ae$var$Rkb;
    this.d = new $61de1ee1cac498ae$var$Rkb;
    this.b = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$MFb() {
    this.g = new $61de1ee1cac498ae$var$PFb;
    this.b = new $61de1ee1cac498ae$var$PFb;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.k = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$Gjc(a, b, c) {
    this.a = a;
    this.c = b;
    this.d = c;
    $61de1ee1cac498ae$var$Ekb(b.e, this);
    $61de1ee1cac498ae$var$Ekb(c.b, this);
}
function $61de1ee1cac498ae$var$wBb(a, b) {
    $61de1ee1cac498ae$var$fvb.call(this, b.rd(), b.qd() & -6);
    $61de1ee1cac498ae$var$uCb(a);
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$CBb(a, b) {
    $61de1ee1cac498ae$var$jvb.call(this, b.rd(), b.qd() & -6);
    $61de1ee1cac498ae$var$uCb(a);
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$IBb(a, b) {
    $61de1ee1cac498ae$var$nvb.call(this, b.rd(), b.qd() & -6);
    $61de1ee1cac498ae$var$uCb(a);
    this.a = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$BQc(a, b, c) {
    this.a = a;
    this.b = b;
    this.c = c;
    $61de1ee1cac498ae$var$Ekb(a.t, this);
    $61de1ee1cac498ae$var$Ekb(b.i, this);
}
function $61de1ee1cac498ae$var$SRc() {
    this.b = new $61de1ee1cac498ae$var$Psb;
    this.a = new $61de1ee1cac498ae$var$Psb;
    this.b = new $61de1ee1cac498ae$var$Psb;
    this.a = new $61de1ee1cac498ae$var$Psb;
}
function $61de1ee1cac498ae$var$g6c() {
    $61de1ee1cac498ae$var$g6c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$f6c = new $61de1ee1cac498ae$var$Lsd("org.eclipse.elk.labels.labelManager");
}
function $61de1ee1cac498ae$var$Vac() {
    $61de1ee1cac498ae$var$Vac = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Uac = new $61de1ee1cac498ae$var$Msd("separateLayerConnections", ($61de1ee1cac498ae$var$gbc(), $61de1ee1cac498ae$var$fbc));
}
function $61de1ee1cac498ae$var$HOc() {
    $61de1ee1cac498ae$var$HOc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$GOc = new $61de1ee1cac498ae$var$IOc("REGULAR", 0);
    $61de1ee1cac498ae$var$FOc = new $61de1ee1cac498ae$var$IOc("CRITICAL", 1);
}
function $61de1ee1cac498ae$var$_Ac() {
    $61de1ee1cac498ae$var$_Ac = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$$Ac = new $61de1ee1cac498ae$var$aBc("STACKED", 0);
    $61de1ee1cac498ae$var$ZAc = new $61de1ee1cac498ae$var$aBc("SEQUENCED", 1);
}
function $61de1ee1cac498ae$var$C_c() {
    $61de1ee1cac498ae$var$C_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$B_c = new $61de1ee1cac498ae$var$D_c("FIXED", 0);
    $61de1ee1cac498ae$var$A_c = new $61de1ee1cac498ae$var$D_c("CENTER_NODE", 1);
}
function $61de1ee1cac498ae$var$PHc(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$VHc(a, b);
    a.b = new $61de1ee1cac498ae$var$BHc(c.c.length);
    return $61de1ee1cac498ae$var$OHc(a, c);
}
function $61de1ee1cac498ae$var$KAd(a, b, c) {
    var d;
    ++a.e;
    --a.f;
    d = $61de1ee1cac498ae$var$BD(a.d[b].$c(c), 133);
    return d.dd();
}
function $61de1ee1cac498ae$var$JJd(a) {
    var b;
    if (!a.a) {
        b = a.r;
        $61de1ee1cac498ae$var$JD(b, 148) && (a.a = $61de1ee1cac498ae$var$BD(b, 148));
    }
    return a.a;
}
function $61de1ee1cac498ae$var$poc(a) {
    if (a.a) {
        if (a.e) return $61de1ee1cac498ae$var$poc(a.e);
    } else return a;
    return null;
}
function $61de1ee1cac498ae$var$ODc(a, b) {
    if (a.p < b.p) return 1;
    else if (a.p > b.p) return -1;
    return 0;
}
function $61de1ee1cac498ae$var$pvb(a, b) {
    $61de1ee1cac498ae$var$uCb(b);
    if (a.c < a.d) {
        a.ze(b, a.c++);
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$QYd(a, b) {
    if ($61de1ee1cac498ae$var$Mhb(a.a, b)) {
        $61de1ee1cac498ae$var$Thb(a.a, b);
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$fd(a) {
    var b, c;
    b = a.cd();
    c = $61de1ee1cac498ae$var$BD(a.dd(), 14);
    return $61de1ee1cac498ae$var$$j(c.Nc(), new $61de1ee1cac498ae$var$ah(b));
}
function $61de1ee1cac498ae$var$sqb(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$ZBb(a.b, a.b.length), 9);
    return new $61de1ee1cac498ae$var$xqb(a.a, b, a.c);
}
function $61de1ee1cac498ae$var$_zb(a) {
    var b;
    $61de1ee1cac498ae$var$Uzb(a);
    b = new $61de1ee1cac498ae$var$fAb(a, a.a.e, a.a.d | 4);
    return new $61de1ee1cac498ae$var$bAb(a, b);
}
function $61de1ee1cac498ae$var$HAb(a) {
    var b;
    $61de1ee1cac498ae$var$Tzb(a);
    b = 0;
    while(a.a.sd(new $61de1ee1cac498ae$var$RBb))b = $61de1ee1cac498ae$var$wbb(b, 1);
    return b;
}
function $61de1ee1cac498ae$var$UDc(a, b, c) {
    var d, e;
    d = 0;
    for(e = 0; e < b.length; e++)d += a.$f(b[e], d, c);
}
function $61de1ee1cac498ae$var$QJb(a, b) {
    var c;
    if (a.C) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124).n;
        c.d = a.C.d;
        c.a = a.C.a;
    }
}
function $61de1ee1cac498ae$var$Mi(a, b, c) {
    $61de1ee1cac498ae$var$Pb(b, a.e.Hd().gc());
    $61de1ee1cac498ae$var$Pb(c, a.c.Hd().gc());
    return a.a[b][c];
}
function $61de1ee1cac498ae$var$Ugb(a, b) {
    $61de1ee1cac498ae$var$Hgb();
    this.e = a;
    this.d = 1;
    this.a = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        b
    ]);
}
function $61de1ee1cac498ae$var$dg(a, b, c, d) {
    this.f = a;
    this.e = b;
    this.d = c;
    this.b = d;
    this.c = !d ? null : d.d;
}
function $61de1ee1cac498ae$var$o5b(a) {
    var b, c, d, e;
    e = a.d;
    b = a.a;
    c = a.b;
    d = a.c;
    a.d = c;
    a.a = d;
    a.b = e;
    a.c = b;
}
function $61de1ee1cac498ae$var$Y2d(a, b, c, d) {
    $61de1ee1cac498ae$var$X2d(a, b, c, $61de1ee1cac498ae$var$M2d(a, b, d, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0));
}
function $61de1ee1cac498ae$var$tac(a, b) {
    $61de1ee1cac498ae$var$Odd(b, "Label management", 1);
    $61de1ee1cac498ae$var$RD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$g6c(), $61de1ee1cac498ae$var$f6c)));
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$Skb(a) {
    $61de1ee1cac498ae$var$Ckb(this);
    $61de1ee1cac498ae$var$mCb(a >= 0, "Initial capacity must not be negative");
}
function $61de1ee1cac498ae$var$lHb() {
    $61de1ee1cac498ae$var$lHb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$kHb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ])));
}
function $61de1ee1cac498ae$var$SHb() {
    $61de1ee1cac498ae$var$SHb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$RHb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$sN, 1), $61de1ee1cac498ae$var$Kie, 461, 0, [
        $61de1ee1cac498ae$var$LHb,
        $61de1ee1cac498ae$var$KHb,
        $61de1ee1cac498ae$var$MHb
    ])));
}
function $61de1ee1cac498ae$var$JIb() {
    $61de1ee1cac498ae$var$JIb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$IIb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$zN, 1), $61de1ee1cac498ae$var$Kie, 462, 0, [
        $61de1ee1cac498ae$var$DIb,
        $61de1ee1cac498ae$var$CIb,
        $61de1ee1cac498ae$var$BIb
    ])));
}
function $61de1ee1cac498ae$var$Kyb() {
    $61de1ee1cac498ae$var$Kyb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Jyb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        $61de1ee1cac498ae$var$Cyb,
        $61de1ee1cac498ae$var$Dyb,
        $61de1ee1cac498ae$var$Eyb
    ])));
}
function $61de1ee1cac498ae$var$DTb() {
    $61de1ee1cac498ae$var$DTb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$CTb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$yTb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$oP, 1), $61de1ee1cac498ae$var$Kie, 379, 0, [
        $61de1ee1cac498ae$var$wTb,
        $61de1ee1cac498ae$var$vTb,
        $61de1ee1cac498ae$var$xTb
    ])));
}
function $61de1ee1cac498ae$var$WXb() {
    $61de1ee1cac498ae$var$WXb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$VXb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$hQ, 1), $61de1ee1cac498ae$var$Kie, 423, 0, [
        $61de1ee1cac498ae$var$QXb,
        $61de1ee1cac498ae$var$PXb,
        $61de1ee1cac498ae$var$OXb
    ])));
}
function $61de1ee1cac498ae$var$Zpc() {
    $61de1ee1cac498ae$var$Zpc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ypc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Rpc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$GW, 1), $61de1ee1cac498ae$var$Kie, 314, 0, [
        $61de1ee1cac498ae$var$Ppc,
        $61de1ee1cac498ae$var$Opc,
        $61de1ee1cac498ae$var$Qpc
    ])));
}
function $61de1ee1cac498ae$var$gqc() {
    $61de1ee1cac498ae$var$gqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$fqc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$bqc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$HW, 1), $61de1ee1cac498ae$var$Kie, 337, 0, [
        $61de1ee1cac498ae$var$$pc,
        $61de1ee1cac498ae$var$aqc,
        $61de1ee1cac498ae$var$_pc
    ])));
}
function $61de1ee1cac498ae$var$Lqc() {
    $61de1ee1cac498ae$var$Lqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Kqc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KW, 1), $61de1ee1cac498ae$var$Kie, 450, 0, [
        $61de1ee1cac498ae$var$Eqc,
        $61de1ee1cac498ae$var$Dqc,
        $61de1ee1cac498ae$var$Fqc
    ])));
}
function $61de1ee1cac498ae$var$Kkc() {
    $61de1ee1cac498ae$var$Kkc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Jkc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$vV, 1), $61de1ee1cac498ae$var$Kie, 361, 0, [
        $61de1ee1cac498ae$var$Ekc,
        $61de1ee1cac498ae$var$Dkc,
        $61de1ee1cac498ae$var$Ckc
    ])));
}
function $61de1ee1cac498ae$var$jsc() {
    $61de1ee1cac498ae$var$jsc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$isc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$RW, 1), $61de1ee1cac498ae$var$Kie, 303, 0, [
        $61de1ee1cac498ae$var$csc,
        $61de1ee1cac498ae$var$dsc,
        $61de1ee1cac498ae$var$bsc
    ])));
}
function $61de1ee1cac498ae$var$asc() {
    $61de1ee1cac498ae$var$asc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$_rc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Xrc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$QW, 1), $61de1ee1cac498ae$var$Kie, 292, 0, [
        $61de1ee1cac498ae$var$Vrc,
        $61de1ee1cac498ae$var$Wrc,
        $61de1ee1cac498ae$var$Urc
    ])));
}
function $61de1ee1cac498ae$var$Dzc() {
    $61de1ee1cac498ae$var$Dzc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Czc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$xzc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZW, 1), $61de1ee1cac498ae$var$Kie, 378, 0, [
        $61de1ee1cac498ae$var$uzc,
        $61de1ee1cac498ae$var$vzc,
        $61de1ee1cac498ae$var$wzc
    ])));
}
function $61de1ee1cac498ae$var$YAc() {
    $61de1ee1cac498ae$var$YAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$XAc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$TAc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$eX, 1), $61de1ee1cac498ae$var$Kie, 375, 0, [
        $61de1ee1cac498ae$var$QAc,
        $61de1ee1cac498ae$var$RAc,
        $61de1ee1cac498ae$var$SAc
    ])));
}
function $61de1ee1cac498ae$var$yAc() {
    $61de1ee1cac498ae$var$yAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xAc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bX, 1), $61de1ee1cac498ae$var$Kie, 339, 0, [
        $61de1ee1cac498ae$var$rAc,
        $61de1ee1cac498ae$var$qAc,
        $61de1ee1cac498ae$var$sAc
    ])));
}
function $61de1ee1cac498ae$var$PAc() {
    $61de1ee1cac498ae$var$PAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$OAc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$dX, 1), $61de1ee1cac498ae$var$Kie, 452, 0, [
        $61de1ee1cac498ae$var$JAc,
        $61de1ee1cac498ae$var$HAc,
        $61de1ee1cac498ae$var$IAc
    ])));
}
function $61de1ee1cac498ae$var$QBc() {
    $61de1ee1cac498ae$var$QBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$PBc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$LBc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$jX, 1), $61de1ee1cac498ae$var$Kie, 377, 0, [
        $61de1ee1cac498ae$var$JBc,
        $61de1ee1cac498ae$var$KBc,
        $61de1ee1cac498ae$var$IBc
    ])));
}
function $61de1ee1cac498ae$var$yBc() {
    $61de1ee1cac498ae$var$yBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xBc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$tBc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$hX, 1), $61de1ee1cac498ae$var$Kie, 336, 0, [
        $61de1ee1cac498ae$var$qBc,
        $61de1ee1cac498ae$var$rBc,
        $61de1ee1cac498ae$var$sBc
    ])));
}
function $61de1ee1cac498ae$var$HBc() {
    $61de1ee1cac498ae$var$HBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$GBc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$CBc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$iX, 1), $61de1ee1cac498ae$var$Kie, 338, 0, [
        $61de1ee1cac498ae$var$BBc,
        $61de1ee1cac498ae$var$zBc,
        $61de1ee1cac498ae$var$ABc
    ])));
}
function $61de1ee1cac498ae$var$wGc() {
    $61de1ee1cac498ae$var$wGc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vGc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PX, 1), $61de1ee1cac498ae$var$Kie, 454, 0, [
        $61de1ee1cac498ae$var$oGc,
        $61de1ee1cac498ae$var$pGc,
        $61de1ee1cac498ae$var$qGc
    ])));
}
function $61de1ee1cac498ae$var$zVc() {
    $61de1ee1cac498ae$var$zVc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$yVc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$tVc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O$, 1), $61de1ee1cac498ae$var$Kie, 442, 0, [
        $61de1ee1cac498ae$var$sVc,
        $61de1ee1cac498ae$var$qVc,
        $61de1ee1cac498ae$var$rVc
    ])));
}
function $61de1ee1cac498ae$var$vWc() {
    $61de1ee1cac498ae$var$vWc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$uWc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$pWc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$Y$, 1), $61de1ee1cac498ae$var$Kie, 380, 0, [
        $61de1ee1cac498ae$var$mWc,
        $61de1ee1cac498ae$var$nWc,
        $61de1ee1cac498ae$var$oWc
    ])));
}
function $61de1ee1cac498ae$var$EYc() {
    $61de1ee1cac498ae$var$EYc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$DYc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$zYc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$q_, 1), $61de1ee1cac498ae$var$Kie, 381, 0, [
        $61de1ee1cac498ae$var$xYc,
        $61de1ee1cac498ae$var$yYc,
        $61de1ee1cac498ae$var$wYc
    ])));
}
function $61de1ee1cac498ae$var$yXc() {
    $61de1ee1cac498ae$var$yXc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xXc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$sXc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$b_, 1), $61de1ee1cac498ae$var$Kie, 293, 0, [
        $61de1ee1cac498ae$var$qXc,
        $61de1ee1cac498ae$var$rXc,
        $61de1ee1cac498ae$var$pXc
    ])));
}
function $61de1ee1cac498ae$var$b_c() {
    $61de1ee1cac498ae$var$b_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$a_c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Y$c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$J_, 1), $61de1ee1cac498ae$var$Kie, 437, 0, [
        $61de1ee1cac498ae$var$V$c,
        $61de1ee1cac498ae$var$W$c,
        $61de1ee1cac498ae$var$X$c
    ])));
}
function $61de1ee1cac498ae$var$mbd() {
    $61de1ee1cac498ae$var$mbd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$lbd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$z1, 1), $61de1ee1cac498ae$var$Kie, 334, 0, [
        $61de1ee1cac498ae$var$fbd,
        $61de1ee1cac498ae$var$ebd,
        $61de1ee1cac498ae$var$gbd
    ])));
}
function $61de1ee1cac498ae$var$vad() {
    $61de1ee1cac498ae$var$vad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$uad = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$u1, 1), $61de1ee1cac498ae$var$Kie, 272, 0, [
        $61de1ee1cac498ae$var$nad,
        $61de1ee1cac498ae$var$oad,
        $61de1ee1cac498ae$var$pad
    ])));
}
function $61de1ee1cac498ae$var$icd() {
    $61de1ee1cac498ae$var$dcd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$D1, 1), $61de1ee1cac498ae$var$Kie, 98, 0, [
        $61de1ee1cac498ae$var$ccd,
        $61de1ee1cac498ae$var$bcd,
        $61de1ee1cac498ae$var$acd,
        $61de1ee1cac498ae$var$Zbd,
        $61de1ee1cac498ae$var$_bd,
        $61de1ee1cac498ae$var$$bd
    ]);
}
function $61de1ee1cac498ae$var$ikd(a, b) {
    return !a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$qAd(a.o, b);
}
function $61de1ee1cac498ae$var$NAd(a) {
    !a.g && (a.g = new $61de1ee1cac498ae$var$JCd);
    !a.g.d && (a.g.d = new $61de1ee1cac498ae$var$MBd(a));
    return a.g.d;
}
function $61de1ee1cac498ae$var$yAd(a) {
    !a.g && (a.g = new $61de1ee1cac498ae$var$JCd);
    !a.g.a && (a.g.a = new $61de1ee1cac498ae$var$SBd(a));
    return a.g.a;
}
function $61de1ee1cac498ae$var$EAd(a) {
    !a.g && (a.g = new $61de1ee1cac498ae$var$JCd);
    !a.g.b && (a.g.b = new $61de1ee1cac498ae$var$GBd(a));
    return a.g.b;
}
function $61de1ee1cac498ae$var$FAd(a) {
    !a.g && (a.g = new $61de1ee1cac498ae$var$JCd);
    !a.g.c && (a.g.c = new $61de1ee1cac498ae$var$iCd(a));
    return a.g.c;
}
function $61de1ee1cac498ae$var$A2d(a, b, c) {
    var d, e;
    e = new $61de1ee1cac498ae$var$p4d(b, a);
    for(d = 0; d < c; ++d)$61de1ee1cac498ae$var$d4d(e);
    return e;
}
function $61de1ee1cac498ae$var$Atd(a, b, c) {
    var d, e;
    if (c != null) for(d = 0; d < b; ++d){
        e = c[d];
        a.fi(d, e);
    }
}
function $61de1ee1cac498ae$var$uhb(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b + 1, 15, 1);
    $61de1ee1cac498ae$var$vhb(e, a, b, c, d);
    return e;
}
function $61de1ee1cac498ae$var$KC(a, b, c, d, e, f) {
    var g;
    g = $61de1ee1cac498ae$var$LC(e, d);
    e != 10 && $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC(a, f), b, c, e, g);
    return g;
}
function $61de1ee1cac498ae$var$bYd(a, b, c, d) {
    !!c && (d = c.gh(b, $61de1ee1cac498ae$var$bLd(c.Tg(), a.c.Lj()), null, d));
    return d;
}
function $61de1ee1cac498ae$var$cYd(a, b, c, d) {
    !!c && (d = c.ih(b, $61de1ee1cac498ae$var$bLd(c.Tg(), a.c.Lj()), null, d));
    return d;
}
function $61de1ee1cac498ae$var$KNb(a, b, c) {
    $61de1ee1cac498ae$var$BD(a.b, 65);
    $61de1ee1cac498ae$var$BD(a.b, 65);
    $61de1ee1cac498ae$var$BD(a.b, 65);
    $61de1ee1cac498ae$var$Hkb(a.a, new $61de1ee1cac498ae$var$TNb(c, b, a));
}
function $61de1ee1cac498ae$var$ACb(a, b, c) {
    if (a < 0 || b > c || b < a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Xfb($61de1ee1cac498ae$var$xke + a + $61de1ee1cac498ae$var$zke + b + $61de1ee1cac498ae$var$oke + c));
}
function $61de1ee1cac498ae$var$zCb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Unable to add element to queue"));
}
function $61de1ee1cac498ae$var$Vzb(a) {
    if (!a) {
        this.c = null;
        this.b = new $61de1ee1cac498ae$var$Rkb;
    } else {
        this.c = a;
        this.b = null;
    }
}
function $61de1ee1cac498ae$var$exb(a, b) {
    $61de1ee1cac498ae$var$pjb.call(this, a, b);
    this.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$dL, $61de1ee1cac498ae$var$zie, 436, 2, 0, 1);
    this.b = true;
}
function $61de1ee1cac498ae$var$_rb(a) {
    $61de1ee1cac498ae$var$Whb.call(this, a, 0);
    $61de1ee1cac498ae$var$Trb(this);
    this.d.b = this.d;
    this.d.a = this.d;
}
function $61de1ee1cac498ae$var$VRc(a) {
    var b;
    b = a.b;
    if (b.b == 0) return null;
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(b, 0), 188).b;
}
function $61de1ee1cac498ae$var$Kwb(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$fxb;
    c.c = true;
    c.d = b.dd();
    return $61de1ee1cac498ae$var$Lwb(a, b.cd(), c);
}
function $61de1ee1cac498ae$var$bB(a, b) {
    var c;
    c = a.q.getHours() + (b / 3600 | 0);
    a.q.setSeconds(b);
    $61de1ee1cac498ae$var$YA(a, c);
}
function $61de1ee1cac498ae$var$zGc(a, b, c) {
    var d;
    d = a.b[c.c.p][c.p];
    d.b += b.b;
    d.c += b.c;
    d.a += b.a;
    ++d.a;
}
function $61de1ee1cac498ae$var$S6c(a, b) {
    var c, d;
    c = a.a - b.a;
    d = a.b - b.b;
    return $61de1ee1cac498ae$var$$wnd.Math.sqrt(c * c + d * d);
}
function $61de1ee1cac498ae$var$Ipc() {
    $61de1ee1cac498ae$var$Ipc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Gpc = new $61de1ee1cac498ae$var$Jpc("QUADRATIC", 0);
    $61de1ee1cac498ae$var$Hpc = new $61de1ee1cac498ae$var$Jpc("SCANLINE", 1);
}
function $61de1ee1cac498ae$var$hCc() {
    $61de1ee1cac498ae$var$hCc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$gCc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$n8b)), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$J8b);
}
function $61de1ee1cac498ae$var$l8c() {
    $61de1ee1cac498ae$var$i8c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$r1, 1), $61de1ee1cac498ae$var$Kie, 291, 0, [
        $61de1ee1cac498ae$var$h8c,
        $61de1ee1cac498ae$var$g8c,
        $61de1ee1cac498ae$var$f8c,
        $61de1ee1cac498ae$var$d8c,
        $61de1ee1cac498ae$var$c8c,
        $61de1ee1cac498ae$var$e8c
    ]);
}
function $61de1ee1cac498ae$var$I7c() {
    $61de1ee1cac498ae$var$F7c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$o1, 1), $61de1ee1cac498ae$var$Kie, 248, 0, [
        $61de1ee1cac498ae$var$z7c,
        $61de1ee1cac498ae$var$C7c,
        $61de1ee1cac498ae$var$D7c,
        $61de1ee1cac498ae$var$E7c,
        $61de1ee1cac498ae$var$A7c,
        $61de1ee1cac498ae$var$B7c
    ]);
}
function $61de1ee1cac498ae$var$Dpc() {
    $61de1ee1cac498ae$var$Apc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$EW, 1), $61de1ee1cac498ae$var$Kie, 227, 0, [
        $61de1ee1cac498ae$var$wpc,
        $61de1ee1cac498ae$var$ypc,
        $61de1ee1cac498ae$var$vpc,
        $61de1ee1cac498ae$var$xpc,
        $61de1ee1cac498ae$var$zpc,
        $61de1ee1cac498ae$var$upc
    ]);
}
function $61de1ee1cac498ae$var$Brc() {
    $61de1ee1cac498ae$var$yrc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$OW, 1), $61de1ee1cac498ae$var$Kie, 275, 0, [
        $61de1ee1cac498ae$var$wrc,
        $61de1ee1cac498ae$var$trc,
        $61de1ee1cac498ae$var$xrc,
        $61de1ee1cac498ae$var$vrc,
        $61de1ee1cac498ae$var$urc,
        $61de1ee1cac498ae$var$rrc
    ]);
}
function $61de1ee1cac498ae$var$orc() {
    $61de1ee1cac498ae$var$lrc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$NW, 1), $61de1ee1cac498ae$var$Kie, 274, 0, [
        $61de1ee1cac498ae$var$irc,
        $61de1ee1cac498ae$var$hrc,
        $61de1ee1cac498ae$var$krc,
        $61de1ee1cac498ae$var$grc,
        $61de1ee1cac498ae$var$jrc,
        $61de1ee1cac498ae$var$frc
    ]);
}
function $61de1ee1cac498ae$var$rzc() {
    $61de1ee1cac498ae$var$lzc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$YW, 1), $61de1ee1cac498ae$var$Kie, 313, 0, [
        $61de1ee1cac498ae$var$jzc,
        $61de1ee1cac498ae$var$hzc,
        $61de1ee1cac498ae$var$fzc,
        $61de1ee1cac498ae$var$gzc,
        $61de1ee1cac498ae$var$kzc,
        $61de1ee1cac498ae$var$izc
    ]);
}
function $61de1ee1cac498ae$var$Wqc() {
    $61de1ee1cac498ae$var$Sqc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LW, 1), $61de1ee1cac498ae$var$Kie, 276, 0, [
        $61de1ee1cac498ae$var$Nqc,
        $61de1ee1cac498ae$var$Mqc,
        $61de1ee1cac498ae$var$Pqc,
        $61de1ee1cac498ae$var$Oqc,
        $61de1ee1cac498ae$var$Rqc,
        $61de1ee1cac498ae$var$Qqc
    ]);
}
function $61de1ee1cac498ae$var$uSc() {
    $61de1ee1cac498ae$var$qSc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t$, 1), $61de1ee1cac498ae$var$Kie, 327, 0, [
        $61de1ee1cac498ae$var$pSc,
        $61de1ee1cac498ae$var$lSc,
        $61de1ee1cac498ae$var$nSc,
        $61de1ee1cac498ae$var$mSc,
        $61de1ee1cac498ae$var$oSc,
        $61de1ee1cac498ae$var$kSc
    ]);
}
function $61de1ee1cac498ae$var$wcd() {
    $61de1ee1cac498ae$var$rcd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E1, 1), $61de1ee1cac498ae$var$Kie, 273, 0, [
        $61de1ee1cac498ae$var$pcd,
        $61de1ee1cac498ae$var$ncd,
        $61de1ee1cac498ae$var$ocd,
        $61de1ee1cac498ae$var$mcd,
        $61de1ee1cac498ae$var$lcd,
        $61de1ee1cac498ae$var$qcd
    ]);
}
function $61de1ee1cac498ae$var$Pad() {
    $61de1ee1cac498ae$var$Mad();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w1, 1), $61de1ee1cac498ae$var$Kie, 312, 0, [
        $61de1ee1cac498ae$var$Kad,
        $61de1ee1cac498ae$var$Iad,
        $61de1ee1cac498ae$var$Lad,
        $61de1ee1cac498ae$var$Gad,
        $61de1ee1cac498ae$var$Jad,
        $61de1ee1cac498ae$var$Had
    ]);
}
function $61de1ee1cac498ae$var$m0b() {
    $61de1ee1cac498ae$var$j0b();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$NQ, 1), $61de1ee1cac498ae$var$Kie, 267, 0, [
        $61de1ee1cac498ae$var$h0b,
        $61de1ee1cac498ae$var$g0b,
        $61de1ee1cac498ae$var$e0b,
        $61de1ee1cac498ae$var$i0b,
        $61de1ee1cac498ae$var$f0b,
        $61de1ee1cac498ae$var$d0b
    ]);
}
function $61de1ee1cac498ae$var$mib(a) {
    $61de1ee1cac498ae$var$yCb(!!a.c);
    $61de1ee1cac498ae$var$xpb(a.e, a);
    a.c.Qb();
    a.c = null;
    a.b = $61de1ee1cac498ae$var$kib(a);
    $61de1ee1cac498ae$var$ypb(a.e, a);
}
function $61de1ee1cac498ae$var$tsb(a) {
    $61de1ee1cac498ae$var$xpb(a.c.a.e, a);
    $61de1ee1cac498ae$var$sCb(a.b != a.c.a.d);
    a.a = a.b;
    a.b = a.b.a;
    return a.a;
}
function $61de1ee1cac498ae$var$kSd(a) {
    var b;
    if (!a.a && a.b != -1) {
        b = a.c.Tg();
        a.a = $61de1ee1cac498ae$var$XKd(b, a.b);
    }
    return a.a;
}
function $61de1ee1cac498ae$var$wtd(a, b) {
    if (a.hi() && a.Hc(b)) return false;
    else {
        a.Yh(b);
        return true;
    }
}
function $61de1ee1cac498ae$var$$Hb(a, b) {
    $61de1ee1cac498ae$var$ytb(b, "Horizontal alignment cannot be null");
    a.b = b;
    return a;
}
function $61de1ee1cac498ae$var$Lfe(a, b, c) {
    $61de1ee1cac498ae$var$wfe();
    var d;
    d = $61de1ee1cac498ae$var$Kfe(a, b);
    c && !!d && $61de1ee1cac498ae$var$Nfe(a) && (d = null);
    return d;
}
function $61de1ee1cac498ae$var$vXb(a, b, c) {
    var d, e;
    for(e = a.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 37);
        $61de1ee1cac498ae$var$uXb(d, b, c);
    }
}
function $61de1ee1cac498ae$var$tXb(a, b) {
    var c, d;
    for(d = b.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 37);
        $61de1ee1cac498ae$var$sXb(a, c, 0, 0);
    }
}
function $61de1ee1cac498ae$var$ojc(a, b, c) {
    var d;
    a.d[b.g] = c;
    d = a.g.c;
    d[b.g] = $61de1ee1cac498ae$var$$wnd.Math.max(d[b.g], c + 1);
}
function $61de1ee1cac498ae$var$KZc(a, b) {
    var c, d, e;
    e = a.r;
    d = a.d;
    c = $61de1ee1cac498ae$var$MZc(a, b, true);
    return c.b != e || c.a != d;
}
function $61de1ee1cac498ae$var$Jjc(a, b) {
    $61de1ee1cac498ae$var$Vrb(a.e, b) || $61de1ee1cac498ae$var$Xrb(a.e, b, new $61de1ee1cac498ae$var$Pjc(b));
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(a.e, b), 113);
}
function $61de1ee1cac498ae$var$Byb(a, b, c, d) {
    $61de1ee1cac498ae$var$uCb(a);
    $61de1ee1cac498ae$var$uCb(b);
    $61de1ee1cac498ae$var$uCb(c);
    $61de1ee1cac498ae$var$uCb(d);
    return new $61de1ee1cac498ae$var$Lyb(a, b, new $61de1ee1cac498ae$var$Vxb);
}
function $61de1ee1cac498ae$var$dId(a, b, c, d) {
    this.rj();
    this.a = b;
    this.b = a;
    this.c = new $61de1ee1cac498ae$var$Y5d(this, b, c, d);
}
function $61de1ee1cac498ae$var$oSd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$mxd.call(this, b, d, e, f);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.b = c;
}
function $61de1ee1cac498ae$var$ESd(a, b, c, d, e, f) {
    $61de1ee1cac498ae$var$mxd.call(this, b, d, e, f);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$Bqd(a, b, c) {
    var d, e, f;
    d = $61de1ee1cac498ae$var$aC(a, c);
    e = null;
    !!d && (e = $61de1ee1cac498ae$var$aqd(d));
    f = e;
    $61de1ee1cac498ae$var$Vqd(b, c, f);
}
function $61de1ee1cac498ae$var$Cqd(a, b, c) {
    var d, e, f;
    d = $61de1ee1cac498ae$var$aC(a, c);
    e = null;
    !!d && (e = $61de1ee1cac498ae$var$aqd(d));
    f = e;
    $61de1ee1cac498ae$var$Vqd(b, c, f);
}
function $61de1ee1cac498ae$var$v1d(a, b, c) {
    var d, e;
    e = (d = $61de1ee1cac498ae$var$nUd(a.b, b), d);
    return !e ? null : $61de1ee1cac498ae$var$V1d($61de1ee1cac498ae$var$p1d(a, e), c);
}
function $61de1ee1cac498ae$var$gid(a, b) {
    var c;
    return c = a.Yg(b), c >= 0 ? a._g(c, true, true) : $61de1ee1cac498ae$var$sid(a, b, true);
}
function $61de1ee1cac498ae$var$s6b(a, b) {
    return $61de1ee1cac498ae$var$Kdb($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$htc)))), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$htc))));
}
function $61de1ee1cac498ae$var$pUc() {
    $61de1ee1cac498ae$var$pUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$oUc = $61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$g3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$yRc(), $61de1ee1cac498ae$var$vRc)), ($61de1ee1cac498ae$var$qSc(), $61de1ee1cac498ae$var$pSc)), $61de1ee1cac498ae$var$lSc);
}
function $61de1ee1cac498ae$var$IHc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$SHc(a, b, c);
    a.b = new $61de1ee1cac498ae$var$BHc(d.c.length);
    return $61de1ee1cac498ae$var$KHc(a, d);
}
function $61de1ee1cac498ae$var$qhe(a) {
    if (a.b <= 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    --a.b;
    a.a -= a.c.c;
    return $61de1ee1cac498ae$var$meb(a.a);
}
function $61de1ee1cac498ae$var$ptd(a) {
    var b;
    if (!a.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$vtb);
    b = a.a;
    a.a = $61de1ee1cac498ae$var$Xod(a.a);
    return b;
}
function $61de1ee1cac498ae$var$dBb(a) {
    while(!a.a){
        if (!$61de1ee1cac498ae$var$HBb(a.c, new $61de1ee1cac498ae$var$hBb(a))) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$vr(a) {
    var b;
    $61de1ee1cac498ae$var$Qb(a);
    if ($61de1ee1cac498ae$var$JD(a, 198)) {
        b = $61de1ee1cac498ae$var$BD(a, 198);
        return b;
    }
    return new $61de1ee1cac498ae$var$wr(a);
}
function $61de1ee1cac498ae$var$r3c(a) {
    $61de1ee1cac498ae$var$p3c();
    $61de1ee1cac498ae$var$BD(a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$x9c)), 174).Fc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ocd));
    a.Ye($61de1ee1cac498ae$var$w9c, null);
}
function $61de1ee1cac498ae$var$p3c() {
    $61de1ee1cac498ae$var$p3c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$m3c = new $61de1ee1cac498ae$var$v3c;
    $61de1ee1cac498ae$var$o3c = new $61de1ee1cac498ae$var$x3c;
    $61de1ee1cac498ae$var$n3c = $61de1ee1cac498ae$var$mn(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$w9c), $61de1ee1cac498ae$var$m3c, $61de1ee1cac498ae$var$b9c, $61de1ee1cac498ae$var$o3c);
}
function $61de1ee1cac498ae$var$fWc() {
    $61de1ee1cac498ae$var$fWc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$dWc = new $61de1ee1cac498ae$var$hWc("LEAF_NUMBER", 0);
    $61de1ee1cac498ae$var$eWc = new $61de1ee1cac498ae$var$hWc("NODE_SIZE", 1);
}
function $61de1ee1cac498ae$var$UMc(a, b, c) {
    a.a = b;
    a.c = c;
    a.b.a.$b();
    $61de1ee1cac498ae$var$Osb(a.d);
    a.e.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
}
function $61de1ee1cac498ae$var$yHc(a) {
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b + 1, 15, 1);
    a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b, 15, 1);
    a.d = 0;
}
function $61de1ee1cac498ae$var$MWb(a, b) {
    if (a.a.ue(b.d, a.b) > 0) {
        $61de1ee1cac498ae$var$Ekb(a.c, new $61de1ee1cac498ae$var$dWb(b.c, b.d, a.d));
        a.b = b.d;
    }
}
function $61de1ee1cac498ae$var$nud(a, b) {
    if (a.g == null || b >= a.i) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$$zd(b, a.i));
    return a.g[b];
}
function $61de1ee1cac498ae$var$pOd(a, b, c) {
    $61de1ee1cac498ae$var$Itd(a, c);
    if (c != null && !a.wj(c)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$tcb);
    return c;
}
function $61de1ee1cac498ae$var$KLd(a) {
    var b;
    if (a.Ek()) for(b = a.i - 1; b >= 0; --b)$61de1ee1cac498ae$var$qud(a, b);
    return $61de1ee1cac498ae$var$wud(a);
}
function $61de1ee1cac498ae$var$Bwb(a) {
    var b, c;
    if (!a.b) return null;
    c = a.b;
    while(b = c.a[0])c = b;
    return c;
}
function $61de1ee1cac498ae$var$ulb(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$pCb(b);
    return c = (d = a.slice(0, b), $61de1ee1cac498ae$var$PC(d, a)), c.length = b, c;
}
function $61de1ee1cac498ae$var$Klb(a, b, c, d) {
    var e;
    d = ($61de1ee1cac498ae$var$ipb(), !d ? $61de1ee1cac498ae$var$fpb : d);
    e = a.slice(b, c);
    $61de1ee1cac498ae$var$Llb(e, a, b, c, -b, d);
}
function $61de1ee1cac498ae$var$bid(a, b, c, d, e) {
    return b < 0 ? $61de1ee1cac498ae$var$sid(a, c, d) : $61de1ee1cac498ae$var$BD(c, 66).Nj().Pj(a, a.yh(), b, d, e);
}
function $61de1ee1cac498ae$var$hZd(a) {
    if ($61de1ee1cac498ae$var$JD(a, 172)) return "" + $61de1ee1cac498ae$var$BD(a, 172).a;
    return a == null ? null : $61de1ee1cac498ae$var$fcb(a);
}
function $61de1ee1cac498ae$var$iZd(a) {
    if ($61de1ee1cac498ae$var$JD(a, 172)) return "" + $61de1ee1cac498ae$var$BD(a, 172).a;
    return a == null ? null : $61de1ee1cac498ae$var$fcb(a);
}
function $61de1ee1cac498ae$var$nDb(a, b) {
    if (b.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz($61de1ee1cac498ae$var$Hke));
    $61de1ee1cac498ae$var$Qqb(a.a, b);
    b.a = a;
    !a.j && (a.j = b);
}
function $61de1ee1cac498ae$var$qBb(a, b) {
    $61de1ee1cac498ae$var$nvb.call(this, b.rd(), b.qd() & -16449);
    $61de1ee1cac498ae$var$uCb(a);
    this.a = a;
    this.c = b;
}
function $61de1ee1cac498ae$var$Ti(a, b) {
    var c, d;
    d = b / a.c.Hd().gc() | 0;
    c = b % a.c.Hd().gc();
    return $61de1ee1cac498ae$var$Mi(a, d, c);
}
function $61de1ee1cac498ae$var$NHb() {
    $61de1ee1cac498ae$var$NHb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$LHb = new $61de1ee1cac498ae$var$OHb($61de1ee1cac498ae$var$jle, 0);
    $61de1ee1cac498ae$var$KHb = new $61de1ee1cac498ae$var$OHb($61de1ee1cac498ae$var$gle, 1);
    $61de1ee1cac498ae$var$MHb = new $61de1ee1cac498ae$var$OHb($61de1ee1cac498ae$var$kle, 2);
}
function $61de1ee1cac498ae$var$lxb() {
    $61de1ee1cac498ae$var$lxb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$hxb = new $61de1ee1cac498ae$var$mxb("All", 0);
    $61de1ee1cac498ae$var$ixb = new $61de1ee1cac498ae$var$rxb;
    $61de1ee1cac498ae$var$jxb = new $61de1ee1cac498ae$var$txb;
    $61de1ee1cac498ae$var$kxb = new $61de1ee1cac498ae$var$wxb;
}
function $61de1ee1cac498ae$var$zxb() {
    $61de1ee1cac498ae$var$zxb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$yxb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$lxb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$iL, 1), $61de1ee1cac498ae$var$Kie, 297, 0, [
        $61de1ee1cac498ae$var$hxb,
        $61de1ee1cac498ae$var$ixb,
        $61de1ee1cac498ae$var$jxb,
        $61de1ee1cac498ae$var$kxb
    ])));
}
function $61de1ee1cac498ae$var$uWb() {
    $61de1ee1cac498ae$var$uWb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$tWb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$lWb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SP, 1), $61de1ee1cac498ae$var$Kie, 405, 0, [
        $61de1ee1cac498ae$var$hWb,
        $61de1ee1cac498ae$var$kWb,
        $61de1ee1cac498ae$var$iWb,
        $61de1ee1cac498ae$var$jWb
    ])));
}
function $61de1ee1cac498ae$var$ALb() {
    $61de1ee1cac498ae$var$ALb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$zLb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PN, 1), $61de1ee1cac498ae$var$Kie, 406, 0, [
        $61de1ee1cac498ae$var$uLb,
        $61de1ee1cac498ae$var$rLb,
        $61de1ee1cac498ae$var$sLb,
        $61de1ee1cac498ae$var$tLb
    ])));
}
function $61de1ee1cac498ae$var$WMb() {
    $61de1ee1cac498ae$var$WMb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$VMb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$RMb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$jO, 1), $61de1ee1cac498ae$var$Kie, 323, 0, [
        $61de1ee1cac498ae$var$OMb,
        $61de1ee1cac498ae$var$NMb,
        $61de1ee1cac498ae$var$PMb,
        $61de1ee1cac498ae$var$QMb
    ])));
}
function $61de1ee1cac498ae$var$WOb() {
    $61de1ee1cac498ae$var$WOb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$VOb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$ROb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$CO, 1), $61de1ee1cac498ae$var$Kie, 394, 0, [
        $61de1ee1cac498ae$var$OOb,
        $61de1ee1cac498ae$var$NOb,
        $61de1ee1cac498ae$var$POb,
        $61de1ee1cac498ae$var$QOb
    ])));
}
function $61de1ee1cac498ae$var$GRc() {
    $61de1ee1cac498ae$var$GRc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$FRc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$yRc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$h$, 1), $61de1ee1cac498ae$var$Kie, 393, 0, [
        $61de1ee1cac498ae$var$uRc,
        $61de1ee1cac498ae$var$vRc,
        $61de1ee1cac498ae$var$wRc,
        $61de1ee1cac498ae$var$xRc
    ])));
}
function $61de1ee1cac498ae$var$mbc() {
    $61de1ee1cac498ae$var$mbc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$lbc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$gbc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$VS, 1), $61de1ee1cac498ae$var$Kie, 360, 0, [
        $61de1ee1cac498ae$var$fbc,
        $61de1ee1cac498ae$var$dbc,
        $61de1ee1cac498ae$var$ebc,
        $61de1ee1cac498ae$var$cbc
    ])));
}
function $61de1ee1cac498ae$var$oXc() {
    $61de1ee1cac498ae$var$oXc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$nXc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$iXc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$a_, 1), $61de1ee1cac498ae$var$Kie, 340, 0, [
        $61de1ee1cac498ae$var$hXc,
        $61de1ee1cac498ae$var$fXc,
        $61de1ee1cac498ae$var$gXc,
        $61de1ee1cac498ae$var$eXc
    ])));
}
function $61de1ee1cac498ae$var$Fjc() {
    $61de1ee1cac498ae$var$Fjc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ejc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$mV, 1), $61de1ee1cac498ae$var$Kie, 411, 0, [
        $61de1ee1cac498ae$var$wjc,
        $61de1ee1cac498ae$var$xjc,
        $61de1ee1cac498ae$var$yjc,
        $61de1ee1cac498ae$var$zjc
    ])));
}
function $61de1ee1cac498ae$var$Pzc() {
    $61de1ee1cac498ae$var$Pzc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ozc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Izc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$$W, 1), $61de1ee1cac498ae$var$Kie, 197, 0, [
        $61de1ee1cac498ae$var$Gzc,
        $61de1ee1cac498ae$var$Hzc,
        $61de1ee1cac498ae$var$Fzc,
        $61de1ee1cac498ae$var$Ezc
    ])));
}
function $61de1ee1cac498ae$var$ugd() {
    $61de1ee1cac498ae$var$ugd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$tgd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$k2, 1), $61de1ee1cac498ae$var$Kie, 396, 0, [
        $61de1ee1cac498ae$var$mgd,
        $61de1ee1cac498ae$var$ngd,
        $61de1ee1cac498ae$var$lgd,
        $61de1ee1cac498ae$var$ogd
    ])));
}
function $61de1ee1cac498ae$var$xbd() {
    $61de1ee1cac498ae$var$xbd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$wbd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$A1, 1), $61de1ee1cac498ae$var$Kie, 285, 0, [
        $61de1ee1cac498ae$var$qbd,
        $61de1ee1cac498ae$var$nbd,
        $61de1ee1cac498ae$var$obd,
        $61de1ee1cac498ae$var$pbd
    ])));
}
function $61de1ee1cac498ae$var$Fad() {
    $61de1ee1cac498ae$var$Fad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ead = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$v1, 1), $61de1ee1cac498ae$var$Kie, 218, 0, [
        $61de1ee1cac498ae$var$zad,
        $61de1ee1cac498ae$var$xad,
        $61de1ee1cac498ae$var$wad,
        $61de1ee1cac498ae$var$yad
    ])));
}
function $61de1ee1cac498ae$var$Ied() {
    $61de1ee1cac498ae$var$Ied = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Hed = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Ded(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O1, 1), $61de1ee1cac498ae$var$Kie, 311, 0, [
        $61de1ee1cac498ae$var$Ced,
        $61de1ee1cac498ae$var$zed,
        $61de1ee1cac498ae$var$Bed,
        $61de1ee1cac498ae$var$Aed
    ])));
}
function $61de1ee1cac498ae$var$ydd() {
    $61de1ee1cac498ae$var$ydd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xdd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$I1, 1), $61de1ee1cac498ae$var$Kie, 374, 0, [
        $61de1ee1cac498ae$var$rdd,
        $61de1ee1cac498ae$var$sdd,
        $61de1ee1cac498ae$var$qdd,
        $61de1ee1cac498ae$var$pdd
    ])));
}
function $61de1ee1cac498ae$var$A9d() {
    $61de1ee1cac498ae$var$A9d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Smd();
    $61de1ee1cac498ae$var$x9d = $61de1ee1cac498ae$var$Pje;
    $61de1ee1cac498ae$var$w9d = $61de1ee1cac498ae$var$Qje;
    $61de1ee1cac498ae$var$z9d = new $61de1ee1cac498ae$var$Ndb($61de1ee1cac498ae$var$Pje);
    $61de1ee1cac498ae$var$y9d = new $61de1ee1cac498ae$var$Ndb($61de1ee1cac498ae$var$Qje);
}
function $61de1ee1cac498ae$var$_qc() {
    $61de1ee1cac498ae$var$_qc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$$qc = new $61de1ee1cac498ae$var$arc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$Zqc = new $61de1ee1cac498ae$var$arc("IMPROVE_STRAIGHTNESS", 1);
}
function $61de1ee1cac498ae$var$eIc(a, b) {
    $61de1ee1cac498ae$var$FHc();
    return $61de1ee1cac498ae$var$Ekb(a, new $61de1ee1cac498ae$var$vgd(b, $61de1ee1cac498ae$var$meb(b.e.c.length + b.g.c.length)));
}
function $61de1ee1cac498ae$var$gIc(a, b) {
    $61de1ee1cac498ae$var$FHc();
    return $61de1ee1cac498ae$var$Ekb(a, new $61de1ee1cac498ae$var$vgd(b, $61de1ee1cac498ae$var$meb(b.e.c.length + b.g.c.length)));
}
function $61de1ee1cac498ae$var$PC(a, b) {
    $61de1ee1cac498ae$var$HC(b) != 10 && $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$rb(b), b.hm, b.__elementTypeId$, $61de1ee1cac498ae$var$HC(b), a);
    return a;
}
function $61de1ee1cac498ae$var$Lkb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Jkb(a, b, 0);
    if (c == -1) return false;
    $61de1ee1cac498ae$var$Kkb(a, c);
    return true;
}
function $61de1ee1cac498ae$var$Zrb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Thb(a.e, b), 387);
    if (c) {
        $61de1ee1cac498ae$var$jsb(c);
        return c.e;
    }
    return null;
}
function $61de1ee1cac498ae$var$Jbb(a) {
    var b;
    if ($61de1ee1cac498ae$var$Fbb(a)) {
        b = 0 - a;
        if (!isNaN(b)) return b;
    }
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$hD(a));
}
function $61de1ee1cac498ae$var$Jkb(a, b, c) {
    for(; c < a.c.length; ++c){
        if ($61de1ee1cac498ae$var$wtb(b, a.c[c])) return c;
    }
    return -1;
}
function $61de1ee1cac498ae$var$SAb(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$Tzb(a);
    d = new $61de1ee1cac498ae$var$NBb;
    d.a = b;
    a.a.Nb(new $61de1ee1cac498ae$var$VBb(d, c));
    return d.a;
}
function $61de1ee1cac498ae$var$aAb(a) {
    var b;
    $61de1ee1cac498ae$var$Tzb(a);
    b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, 0, 15, 1);
    $61de1ee1cac498ae$var$_ub(a.a, new $61de1ee1cac498ae$var$kAb(b));
    return b;
}
function $61de1ee1cac498ae$var$ajc(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, 0), 11);
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
    return b;
}
function $61de1ee1cac498ae$var$yc(a) {
    var b;
    if (!$61de1ee1cac498ae$var$xc(a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    a.e = 1;
    b = a.d;
    a.d = null;
    return b;
}
function $61de1ee1cac498ae$var$wu(a, b) {
    var c;
    this.f = a;
    this.b = b;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 283);
    this.c = !c ? null : c.b;
}
function $61de1ee1cac498ae$var$Ygc() {
    $61de1ee1cac498ae$var$Hgc();
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.f = new $61de1ee1cac498ae$var$Lqb;
    this.g = new $61de1ee1cac498ae$var$Lqb;
    this.e = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$Tnc(a, b) {
    this.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, a.a.c.length, 0, 1);
    $61de1ee1cac498ae$var$Qkb(a.a, this.a);
    this.b = b;
}
function $61de1ee1cac498ae$var$zoc(a) {
    var b;
    for(b = a.p + 1; b < a.c.a.c.length; ++b)--$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.c.a, b), 10).p;
}
function $61de1ee1cac498ae$var$Rwd(a) {
    var b;
    b = a.Ai();
    b != null && a.d != -1 && $61de1ee1cac498ae$var$BD(b, 92).Ng(a);
    !!a.i && a.i.Fi();
}
function $61de1ee1cac498ae$var$rFd(a) {
    $61de1ee1cac498ae$var$Py(this);
    this.g = !a ? null : $61de1ee1cac498ae$var$Wy(a, a.$d());
    this.f = a;
    $61de1ee1cac498ae$var$Ry(this);
    this._d();
}
function $61de1ee1cac498ae$var$pSd(a, b, c, d, e, f, g) {
    $61de1ee1cac498ae$var$nxd.call(this, b, d, e, f, g);
    $61de1ee1cac498ae$var$jSd(this);
    this.c = a;
    this.b = c;
}
function $61de1ee1cac498ae$var$Ayb(a, b, c, d, e) {
    $61de1ee1cac498ae$var$uCb(a);
    $61de1ee1cac498ae$var$uCb(b);
    $61de1ee1cac498ae$var$uCb(c);
    $61de1ee1cac498ae$var$uCb(d);
    $61de1ee1cac498ae$var$uCb(e);
    return new $61de1ee1cac498ae$var$Lyb(a, b, d);
}
function $61de1ee1cac498ae$var$B2c(a, b) {
    if (b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$ese + b));
    $61de1ee1cac498ae$var$A2c(a, b + 1);
    return $61de1ee1cac498ae$var$Ikb(a.j, b);
}
function $61de1ee1cac498ae$var$Ob(a, b, c, d) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$hc(b, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        c,
        d
    ]))));
}
function $61de1ee1cac498ae$var$dDb(a, b) {
    return $61de1ee1cac498ae$var$wtb(b, $61de1ee1cac498ae$var$Ikb(a.f, 0)) || $61de1ee1cac498ae$var$wtb(b, $61de1ee1cac498ae$var$Ikb(a.f, 1)) || $61de1ee1cac498ae$var$wtb(b, $61de1ee1cac498ae$var$Ikb(a.f, 2));
}
function $61de1ee1cac498ae$var$ghd(a, b) {
    $61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(a.f, 33).We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$t9c)), 98)) && $61de1ee1cac498ae$var$NCd($61de1ee1cac498ae$var$Yod($61de1ee1cac498ae$var$BD(a.f, 33)), b);
}
function $61de1ee1cac498ae$var$p1d(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD(b, 675);
    d = c.Oh();
    !d && c.Rh(d = new $61de1ee1cac498ae$var$Y1d(a, b));
    return d;
}
function $61de1ee1cac498ae$var$q1d(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD(b, 677);
    d = c.pk();
    !d && c.tk(d = new $61de1ee1cac498ae$var$j2d(a, b));
    return d;
}
function $61de1ee1cac498ae$var$QSd(a) {
    if (!a.b) {
        a.b = new $61de1ee1cac498ae$var$UTd(a, $61de1ee1cac498ae$var$j5, a);
        !a.a && (a.a = new $61de1ee1cac498ae$var$fTd(a, a));
    }
    return a.b;
}
function $61de1ee1cac498ae$var$yTb() {
    $61de1ee1cac498ae$var$yTb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$wTb = new $61de1ee1cac498ae$var$zTb("XY", 0);
    $61de1ee1cac498ae$var$vTb = new $61de1ee1cac498ae$var$zTb("X", 1);
    $61de1ee1cac498ae$var$xTb = new $61de1ee1cac498ae$var$zTb("Y", 2);
}
function $61de1ee1cac498ae$var$EIb() {
    $61de1ee1cac498ae$var$EIb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$DIb = new $61de1ee1cac498ae$var$FIb("TOP", 0);
    $61de1ee1cac498ae$var$CIb = new $61de1ee1cac498ae$var$FIb($61de1ee1cac498ae$var$gle, 1);
    $61de1ee1cac498ae$var$BIb = new $61de1ee1cac498ae$var$FIb($61de1ee1cac498ae$var$mle, 2);
}
function $61de1ee1cac498ae$var$esc() {
    $61de1ee1cac498ae$var$esc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$csc = new $61de1ee1cac498ae$var$fsc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$dsc = new $61de1ee1cac498ae$var$fsc("TOP", 1);
    $61de1ee1cac498ae$var$bsc = new $61de1ee1cac498ae$var$fsc($61de1ee1cac498ae$var$mle, 2);
}
function $61de1ee1cac498ae$var$BAc() {
    $61de1ee1cac498ae$var$BAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$zAc = new $61de1ee1cac498ae$var$CAc("INPUT_ORDER", 0);
    $61de1ee1cac498ae$var$AAc = new $61de1ee1cac498ae$var$CAc("PORT_DEGREE", 1);
}
function $61de1ee1cac498ae$var$wD() {
    $61de1ee1cac498ae$var$wD = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$sD = $61de1ee1cac498ae$var$TC($61de1ee1cac498ae$var$Eje, $61de1ee1cac498ae$var$Eje, 524287);
    $61de1ee1cac498ae$var$tD = $61de1ee1cac498ae$var$TC(0, 0, $61de1ee1cac498ae$var$Gje);
    $61de1ee1cac498ae$var$uD = $61de1ee1cac498ae$var$RC(1);
    $61de1ee1cac498ae$var$RC(2);
    $61de1ee1cac498ae$var$vD = $61de1ee1cac498ae$var$RC(0);
}
function $61de1ee1cac498ae$var$WDc(a, b, c) {
    a.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$$Dc(a, b, c);
    a.a.c.length == 0 || $61de1ee1cac498ae$var$TDc(a, b);
}
function $61de1ee1cac498ae$var$rfb(a) {
    var b, c;
    c = a.length;
    b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, c, 15, 1);
    $61de1ee1cac498ae$var$ffb(a, 0, c, b, 0);
    return b;
}
function $61de1ee1cac498ae$var$Aid(a) {
    var b;
    if (!a.dh()) {
        b = $61de1ee1cac498ae$var$aLd(a.Tg()) - a.Ah();
        a.ph().bk(b);
    }
    return a.Pg();
}
function $61de1ee1cac498ae$var$xjd(a) {
    var b;
    b = $61de1ee1cac498ae$var$CD($61de1ee1cac498ae$var$Ajd(a, 32));
    if (b == null) {
        $61de1ee1cac498ae$var$yjd(a);
        b = $61de1ee1cac498ae$var$CD($61de1ee1cac498ae$var$Ajd(a, 32));
    }
    return b;
}
function $61de1ee1cac498ae$var$iid(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$bLd(a.d, b);
    return c >= 0 ? $61de1ee1cac498ae$var$fid(a, c, true, true) : $61de1ee1cac498ae$var$sid(a, b, true);
}
function $61de1ee1cac498ae$var$vgc(a, b) {
    $61de1ee1cac498ae$var$qgc();
    var c, d;
    c = $61de1ee1cac498ae$var$ugc(a);
    d = $61de1ee1cac498ae$var$ugc(b);
    return !!c && !!d && !$61de1ee1cac498ae$var$omb(c.k, d.k);
}
function $61de1ee1cac498ae$var$Gqd(a, b) {
    $61de1ee1cac498ae$var$dld(a, b == null || $61de1ee1cac498ae$var$Ldb(($61de1ee1cac498ae$var$uCb(b), b)) || isNaN(($61de1ee1cac498ae$var$uCb(b), b)) ? 0 : ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$Hqd(a, b) {
    $61de1ee1cac498ae$var$eld(a, b == null || $61de1ee1cac498ae$var$Ldb(($61de1ee1cac498ae$var$uCb(b), b)) || isNaN(($61de1ee1cac498ae$var$uCb(b), b)) ? 0 : ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$Iqd(a, b) {
    $61de1ee1cac498ae$var$cld(a, b == null || $61de1ee1cac498ae$var$Ldb(($61de1ee1cac498ae$var$uCb(b), b)) || isNaN(($61de1ee1cac498ae$var$uCb(b), b)) ? 0 : ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$Jqd(a, b) {
    $61de1ee1cac498ae$var$ald(a, b == null || $61de1ee1cac498ae$var$Ldb(($61de1ee1cac498ae$var$uCb(b), b)) || isNaN(($61de1ee1cac498ae$var$uCb(b), b)) ? 0 : ($61de1ee1cac498ae$var$uCb(b), b));
}
function $61de1ee1cac498ae$var$agd(a) {
    (!this.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : this.q).Ac(!a.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : a.q);
}
function $61de1ee1cac498ae$var$S2d(a, b) {
    return $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0 ? new $61de1ee1cac498ae$var$s4d(b, a) : new $61de1ee1cac498ae$var$p4d(b, a);
}
function $61de1ee1cac498ae$var$U2d(a, b) {
    return $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0 ? new $61de1ee1cac498ae$var$s4d(b, a) : new $61de1ee1cac498ae$var$p4d(b, a);
}
function $61de1ee1cac498ae$var$INb(a, b) {
    $61de1ee1cac498ae$var$HNb = new $61de1ee1cac498ae$var$tOb;
    $61de1ee1cac498ae$var$FNb = b;
    $61de1ee1cac498ae$var$GNb = a;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GNb.b, 65);
    $61de1ee1cac498ae$var$KNb($61de1ee1cac498ae$var$GNb, $61de1ee1cac498ae$var$HNb, null);
    $61de1ee1cac498ae$var$JNb($61de1ee1cac498ae$var$GNb);
}
function $61de1ee1cac498ae$var$uud(a, b, c) {
    var d;
    d = a.g[b];
    $61de1ee1cac498ae$var$mud(a, b, a.oi(b, c));
    a.gi(b, c, d);
    a.ci();
    return d;
}
function $61de1ee1cac498ae$var$Ftd(a, b) {
    var c;
    c = a.Xc(b);
    if (c >= 0) {
        a.$c(c);
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$YId(a) {
    var b;
    if (a.d != a.r) {
        b = $61de1ee1cac498ae$var$wId(a);
        a.e = !!b && b.Cj() == $61de1ee1cac498ae$var$Bve;
        a.d = b;
    }
    return a.e;
}
function $61de1ee1cac498ae$var$fr(a, b) {
    var c;
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Qb(b);
    c = false;
    while(b.Ob())c = c | a.Fc(b.Pb());
    return c;
}
function $61de1ee1cac498ae$var$Wrb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, b), 387);
    if (c) {
        $61de1ee1cac498ae$var$Yrb(a, c);
        return c.e;
    }
    return null;
}
function $61de1ee1cac498ae$var$UA(a) {
    var b, c;
    b = a / 60 | 0;
    c = a % 60;
    if (c == 0) return "" + b;
    return "" + b + ":" + ("" + c);
}
function $61de1ee1cac498ae$var$LAb(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$Uzb(a);
    d = new $61de1ee1cac498ae$var$IBb(b, a.a);
    c = new $61de1ee1cac498ae$var$fBb(d);
    return new $61de1ee1cac498ae$var$YAb(a, c);
}
function $61de1ee1cac498ae$var$tB(d, a) {
    var b = d.a[a];
    var c = ($61de1ee1cac498ae$var$rC(), $61de1ee1cac498ae$var$qC)[typeof b];
    return c ? c(b) : $61de1ee1cac498ae$var$xC(typeof b);
}
function $61de1ee1cac498ae$var$yzc(a) {
    switch(a.g){
        case 0:
            return $61de1ee1cac498ae$var$Ohe;
        case 1:
            return -1;
        default:
            return 0;
    }
}
function $61de1ee1cac498ae$var$oD(a) {
    if ($61de1ee1cac498ae$var$eD(a, ($61de1ee1cac498ae$var$wD(), $61de1ee1cac498ae$var$vD)) < 0) return -$61de1ee1cac498ae$var$aD($61de1ee1cac498ae$var$hD(a));
    return a.l + a.m * $61de1ee1cac498ae$var$Hje + a.h * $61de1ee1cac498ae$var$Ije;
}
function $61de1ee1cac498ae$var$HC(a) {
    return a.__elementTypeCategory$ == null ? 10 : a.__elementTypeCategory$;
}
function $61de1ee1cac498ae$var$dub(a) {
    var b;
    b = a.b.c.length == 0 ? null : $61de1ee1cac498ae$var$Ikb(a.b, 0);
    b != null && $61de1ee1cac498ae$var$fub(a, 0);
    return b;
}
function $61de1ee1cac498ae$var$uA(a, b) {
    while(b[0] < a.length && $61de1ee1cac498ae$var$hfb(" 	\r\n", $61de1ee1cac498ae$var$wfb($61de1ee1cac498ae$var$bfb(a, b[0]))) >= 0)++b[0];
}
function $61de1ee1cac498ae$var$sgb(a, b) {
    this.e = b;
    this.a = $61de1ee1cac498ae$var$vgb(a);
    this.a < 54 ? this.f = $61de1ee1cac498ae$var$Sbb(a) : this.c = $61de1ee1cac498ae$var$ghb(a);
}
function $61de1ee1cac498ae$var$vge(a, b, c, d) {
    $61de1ee1cac498ae$var$wfe();
    $61de1ee1cac498ae$var$xfe.call(this, 26);
    this.c = a;
    this.a = b;
    this.d = c;
    this.b = d;
}
function $61de1ee1cac498ae$var$EA(a, b, c) {
    var d, e;
    d = 10;
    for(e = 0; e < c - 1; e++){
        b < d && (a.a += "0", a);
        d *= 10;
    }
    a.a += b;
}
function $61de1ee1cac498ae$var$Hhe(a, b) {
    var c;
    c = 0;
    while(a.e != a.i.gc()){
        $61de1ee1cac498ae$var$Qrd(b, $61de1ee1cac498ae$var$Dyd(a), $61de1ee1cac498ae$var$meb(c));
        c != $61de1ee1cac498ae$var$Ohe && ++c;
    }
}
function $61de1ee1cac498ae$var$xHc(a, b) {
    var c;
    ++a.d;
    ++a.c[b];
    c = b + 1;
    while(c < a.a.length){
        ++a.a[c];
        c += c & -c;
    }
}
function $61de1ee1cac498ae$var$Qgc(a, b) {
    var c, d, e;
    e = b.c.i;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.f, e), 57);
    d = c.d.c - c.e.c;
    $61de1ee1cac498ae$var$p7c(b.a, d, 0);
}
function $61de1ee1cac498ae$var$Scb(a) {
    var b, c;
    b = a + 128;
    c = ($61de1ee1cac498ae$var$Ucb(), $61de1ee1cac498ae$var$Tcb)[b];
    !c && (c = $61de1ee1cac498ae$var$Tcb[b] = new $61de1ee1cac498ae$var$Mcb(a));
    return c;
}
function $61de1ee1cac498ae$var$es(a, b) {
    var c;
    $61de1ee1cac498ae$var$uCb(b);
    c = a[":" + b];
    $61de1ee1cac498ae$var$nCb(!!c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        b
    ]));
    return c;
}
function $61de1ee1cac498ae$var$Mz(a) {
    var b, c;
    if (a.b) {
        c = null;
        do {
            b = a.b;
            a.b = null;
            c = $61de1ee1cac498ae$var$Pz(b, c);
        }while (a.b);
        a.b = c;
    }
}
function $61de1ee1cac498ae$var$Lz(a) {
    var b, c;
    if (a.a) {
        c = null;
        do {
            b = a.a;
            a.a = null;
            c = $61de1ee1cac498ae$var$Pz(b, c);
        }while (a.a);
        a.a = c;
    }
}
function $61de1ee1cac498ae$var$Dqb(a) {
    var b;
    ++a.a;
    for(b = a.c.a.length; a.a < b; ++a.a){
        if (a.c.b[a.a]) return;
    }
}
function $61de1ee1cac498ae$var$S9b(a, b) {
    var c, d;
    d = b.c;
    for(c = d + 1; c <= b.f; c++)a.a[c] > a.a[d] && (d = c);
    return d;
}
function $61de1ee1cac498ae$var$fic(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Jy(a.e.c, b.e.c);
    if (c == 0) return $61de1ee1cac498ae$var$Kdb(a.e.d, b.e.d);
    return c;
}
function $61de1ee1cac498ae$var$Ogb(a, b) {
    if (b.e == 0) return $61de1ee1cac498ae$var$Ggb;
    if (a.e == 0) return $61de1ee1cac498ae$var$Ggb;
    return $61de1ee1cac498ae$var$Dhb(), $61de1ee1cac498ae$var$Ehb(a, b);
}
function $61de1ee1cac498ae$var$nCb(a, b) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$DCb("Enum constant undefined: %s", b)));
}
function $61de1ee1cac498ae$var$AWb() {
    $61de1ee1cac498ae$var$AWb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xWb = new $61de1ee1cac498ae$var$XWb;
    $61de1ee1cac498ae$var$yWb = new $61de1ee1cac498ae$var$_Wb;
    $61de1ee1cac498ae$var$vWb = new $61de1ee1cac498ae$var$dXb;
    $61de1ee1cac498ae$var$wWb = new $61de1ee1cac498ae$var$hXb;
    $61de1ee1cac498ae$var$zWb = new $61de1ee1cac498ae$var$lXb;
}
function $61de1ee1cac498ae$var$UEb() {
    $61de1ee1cac498ae$var$UEb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$SEb = new $61de1ee1cac498ae$var$VEb("BY_SIZE", 0);
    $61de1ee1cac498ae$var$TEb = new $61de1ee1cac498ae$var$VEb("BY_SIZE_AND_SHAPE", 1);
}
function $61de1ee1cac498ae$var$XRb() {
    $61de1ee1cac498ae$var$XRb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$VRb = new $61de1ee1cac498ae$var$YRb("EADES", 0);
    $61de1ee1cac498ae$var$WRb = new $61de1ee1cac498ae$var$YRb("FRUCHTERMAN_REINGOLD", 1);
}
function $61de1ee1cac498ae$var$xqc() {
    $61de1ee1cac498ae$var$xqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vqc = new $61de1ee1cac498ae$var$yqc("READING_DIRECTION", 0);
    $61de1ee1cac498ae$var$wqc = new $61de1ee1cac498ae$var$yqc("ROTATION", 1);
}
function $61de1ee1cac498ae$var$uqc() {
    $61de1ee1cac498ae$var$uqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$tqc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$IW, 1), $61de1ee1cac498ae$var$Kie, 335, 0, [
        $61de1ee1cac498ae$var$iqc,
        $61de1ee1cac498ae$var$hqc,
        $61de1ee1cac498ae$var$kqc,
        $61de1ee1cac498ae$var$lqc,
        $61de1ee1cac498ae$var$jqc
    ])));
}
function $61de1ee1cac498ae$var$bAc() {
    $61de1ee1cac498ae$var$bAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$aAc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Vzc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$_W, 1), $61de1ee1cac498ae$var$Kie, 315, 0, [
        $61de1ee1cac498ae$var$Uzc,
        $61de1ee1cac498ae$var$Rzc,
        $61de1ee1cac498ae$var$Szc,
        $61de1ee1cac498ae$var$Qzc,
        $61de1ee1cac498ae$var$Tzc
    ])));
}
function $61de1ee1cac498ae$var$bkc() {
    $61de1ee1cac498ae$var$bkc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$akc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Xjc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$uV, 1), $61de1ee1cac498ae$var$Kie, 363, 0, [
        $61de1ee1cac498ae$var$Tjc,
        $61de1ee1cac498ae$var$Vjc,
        $61de1ee1cac498ae$var$Wjc,
        $61de1ee1cac498ae$var$Ujc,
        $61de1ee1cac498ae$var$Sjc
    ])));
}
function $61de1ee1cac498ae$var$Htc() {
    $61de1ee1cac498ae$var$Htc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Gtc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$TW, 1), $61de1ee1cac498ae$var$Kie, 163, 0, [
        $61de1ee1cac498ae$var$Btc,
        $61de1ee1cac498ae$var$xtc,
        $61de1ee1cac498ae$var$ytc,
        $61de1ee1cac498ae$var$ztc,
        $61de1ee1cac498ae$var$Atc
    ])));
}
function $61de1ee1cac498ae$var$S_c() {
    $61de1ee1cac498ae$var$S_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$R_c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$N_c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$Q_, 1), $61de1ee1cac498ae$var$Kie, 316, 0, [
        $61de1ee1cac498ae$var$I_c,
        $61de1ee1cac498ae$var$J_c,
        $61de1ee1cac498ae$var$M_c,
        $61de1ee1cac498ae$var$K_c,
        $61de1ee1cac498ae$var$L_c
    ])));
}
function $61de1ee1cac498ae$var$S5c() {
    $61de1ee1cac498ae$var$S5c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$R5c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$L5c,
        $61de1ee1cac498ae$var$K5c,
        $61de1ee1cac498ae$var$I5c,
        $61de1ee1cac498ae$var$M5c,
        $61de1ee1cac498ae$var$J5c
    ])));
}
function $61de1ee1cac498ae$var$p$c() {
    $61de1ee1cac498ae$var$p$c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$o$c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$k$c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$y_, 1), $61de1ee1cac498ae$var$Kie, 355, 0, [
        $61de1ee1cac498ae$var$g$c,
        $61de1ee1cac498ae$var$f$c,
        $61de1ee1cac498ae$var$i$c,
        $61de1ee1cac498ae$var$h$c,
        $61de1ee1cac498ae$var$j$c
    ])));
}
function $61de1ee1cac498ae$var$vUb() {
    $61de1ee1cac498ae$var$vUb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$uUb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$zP, 1), $61de1ee1cac498ae$var$Kie, 356, 0, [
        $61de1ee1cac498ae$var$lUb,
        $61de1ee1cac498ae$var$mUb,
        $61de1ee1cac498ae$var$nUb,
        $61de1ee1cac498ae$var$oUb,
        $61de1ee1cac498ae$var$pUb
    ])));
}
function $61de1ee1cac498ae$var$mad() {
    $61de1ee1cac498ae$var$mad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$lad = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t1, 1), $61de1ee1cac498ae$var$Kie, 103, 0, [
        $61de1ee1cac498ae$var$cad,
        $61de1ee1cac498ae$var$bad,
        $61de1ee1cac498ae$var$aad,
        $61de1ee1cac498ae$var$_9c,
        $61de1ee1cac498ae$var$dad
    ])));
}
function $61de1ee1cac498ae$var$Ybd() {
    $61de1ee1cac498ae$var$Ybd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Xbd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Tbd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C1, 1), $61de1ee1cac498ae$var$Kie, 249, 0, [
        $61de1ee1cac498ae$var$Qbd,
        $61de1ee1cac498ae$var$Sbd,
        $61de1ee1cac498ae$var$Obd,
        $61de1ee1cac498ae$var$Pbd,
        $61de1ee1cac498ae$var$Rbd
    ])));
}
function $61de1ee1cac498ae$var$cdd() {
    $61de1ee1cac498ae$var$cdd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$bdd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])));
}
function $61de1ee1cac498ae$var$_1c(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, b), 134);
    if (!c) {
        c = new $61de1ee1cac498ae$var$zNb;
        $61de1ee1cac498ae$var$Rhb(a.a, b, c);
    }
    return c;
}
function $61de1ee1cac498ae$var$hoc(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$usc)), 305);
    if (b) return b.a == a;
    return false;
}
function $61de1ee1cac498ae$var$ioc(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$usc)), 305);
    if (b) return b.i == a;
    return false;
}
function $61de1ee1cac498ae$var$Jub(a, b) {
    $61de1ee1cac498ae$var$uCb(b);
    $61de1ee1cac498ae$var$Iub(a);
    if (a.d.Ob()) {
        b.td(a.d.Pb());
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Oy(a) {
    if ($61de1ee1cac498ae$var$ybb(a, $61de1ee1cac498ae$var$Ohe) > 0) return $61de1ee1cac498ae$var$Ohe;
    if ($61de1ee1cac498ae$var$ybb(a, $61de1ee1cac498ae$var$Rie) < 0) return $61de1ee1cac498ae$var$Rie;
    return $61de1ee1cac498ae$var$Tbb(a);
}
function $61de1ee1cac498ae$var$Cv(a) {
    if (a < 3) {
        $61de1ee1cac498ae$var$Xj(a, $61de1ee1cac498ae$var$Hie);
        return a + 1;
    }
    if (a < $61de1ee1cac498ae$var$Iie) return $61de1ee1cac498ae$var$QD(a / 0.75 + 1);
    return $61de1ee1cac498ae$var$Ohe;
}
function $61de1ee1cac498ae$var$XKd(a, b) {
    var c;
    c = (a.i == null && $61de1ee1cac498ae$var$TKd(a), a.i);
    return b >= 0 && b < c.length ? c[b] : null;
}
function $61de1ee1cac498ae$var$cC(a, b, c) {
    var d;
    if (b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Geb);
    d = $61de1ee1cac498ae$var$aC(a, b);
    $61de1ee1cac498ae$var$dC(a, b, c);
    return d;
}
function $61de1ee1cac498ae$var$Emc(a) {
    a.a >= -0.01 && a.a <= $61de1ee1cac498ae$var$ple && (a.a = 0);
    a.b >= -0.01 && a.b <= $61de1ee1cac498ae$var$ple && (a.b = 0);
    return a;
}
function $61de1ee1cac498ae$var$sfb(a, b) {
    return b == ($61de1ee1cac498ae$var$ntb(), $61de1ee1cac498ae$var$ntb(), $61de1ee1cac498ae$var$mtb) ? a.toLocaleLowerCase() : a.toLowerCase();
}
function $61de1ee1cac498ae$var$idb(a) {
    return ((a.i & 2) != 0 ? "interface " : (a.i & 1) != 0 ? "" : "class ") + ($61de1ee1cac498ae$var$fdb(a), a.o);
}
function $61de1ee1cac498ae$var$Pnd(a) {
    var b, c;
    c = (b = new $61de1ee1cac498ae$var$SSd, b);
    $61de1ee1cac498ae$var$wtd((!a.q && (a.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, a, 11, 10)), a.q), c);
}
function $61de1ee1cac498ae$var$Pdd(a, b) {
    var c;
    c = b > 0 ? b - 1 : b;
    return $61de1ee1cac498ae$var$Vdd($61de1ee1cac498ae$var$Wdd($61de1ee1cac498ae$var$Xdd($61de1ee1cac498ae$var$Ydd(new $61de1ee1cac498ae$var$Zdd, c), a.n), a.j), a.k);
}
function $61de1ee1cac498ae$var$u2d(a, b, c, d) {
    var e;
    a.j = -1;
    $61de1ee1cac498ae$var$Qxd(a, $61de1ee1cac498ae$var$I2d(a, b, c), ($61de1ee1cac498ae$var$Q6d(), e = $61de1ee1cac498ae$var$BD(b, 66).Mj(), e.Ok(d)));
}
function $61de1ee1cac498ae$var$VWb(a) {
    this.g = a;
    this.f = new $61de1ee1cac498ae$var$Rkb;
    this.a = $61de1ee1cac498ae$var$$wnd.Math.min(this.g.c.c, this.g.d.c);
}
function $61de1ee1cac498ae$var$mDb(a) {
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.c = new $61de1ee1cac498ae$var$Rkb;
    this.d = new $61de1ee1cac498ae$var$Rkb;
    this.e = a;
}
function $61de1ee1cac498ae$var$Cnc(a, b) {
    this.a = new $61de1ee1cac498ae$var$Lqb;
    this.e = new $61de1ee1cac498ae$var$Lqb;
    this.b = ($61de1ee1cac498ae$var$xzc(), $61de1ee1cac498ae$var$wzc);
    this.c = a;
    this.b = b;
}
function $61de1ee1cac498ae$var$bIb(a, b, c) {
    $61de1ee1cac498ae$var$$Gb.call(this);
    $61de1ee1cac498ae$var$THb(this);
    this.a = a;
    this.c = c;
    this.b = b.d;
    this.f = b.e;
}
function $61de1ee1cac498ae$var$yd(a) {
    this.d = a;
    this.c = a.c.vc().Kc();
    this.b = null;
    this.a = null;
    this.e = ($61de1ee1cac498ae$var$hs(), $61de1ee1cac498ae$var$gs);
}
function $61de1ee1cac498ae$var$zud(a) {
    if (a < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Illegal Capacity: " + a));
    this.g = this.ri(a);
}
function $61de1ee1cac498ae$var$avb(a, b) {
    if (0 > a || a > b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$scb("fromIndex: 0, toIndex: " + a + $61de1ee1cac498ae$var$oke + b));
}
function $61de1ee1cac498ae$var$Gs(a) {
    var b;
    if (a.a == a.b.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    b = a.a;
    a.c = b;
    a.a = a.a.e;
    return b;
}
function $61de1ee1cac498ae$var$Zsb(a) {
    var b;
    $61de1ee1cac498ae$var$yCb(!!a.c);
    b = a.c.a;
    $61de1ee1cac498ae$var$Nsb(a.d, a.c);
    a.b == a.c ? a.b = b : --a.a;
    a.c = null;
}
function $61de1ee1cac498ae$var$VAb(a, b) {
    var c;
    $61de1ee1cac498ae$var$Uzb(a);
    c = new $61de1ee1cac498ae$var$lBb(a, a.a.rd(), a.a.qd() | 4, b);
    return new $61de1ee1cac498ae$var$YAb(a, c);
}
function $61de1ee1cac498ae$var$ke(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv(a.d, b), 14);
    if (!c) return null;
    d = b;
    return a.e.pc(d, c);
}
function $61de1ee1cac498ae$var$xac(a, b) {
    var c, d;
    for(d = a.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 70);
        $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ssc), b);
    }
}
function $61de1ee1cac498ae$var$t9b(a) {
    var b;
    b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Zwc))));
    if (b < 0) {
        b = 0;
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Zwc, b);
    }
    return b;
}
function $61de1ee1cac498ae$var$ifc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$$wnd.Math.max(0, a.b / 2 - 0.5);
    $61de1ee1cac498ae$var$cfc(c, d, 1);
    $61de1ee1cac498ae$var$Ekb(b, new $61de1ee1cac498ae$var$rfc(c, d));
}
function $61de1ee1cac498ae$var$NMc(a, b, c) {
    var d;
    d = a.a.e[$61de1ee1cac498ae$var$BD(b.a, 10).p] - a.a.e[$61de1ee1cac498ae$var$BD(c.a, 10).p];
    return $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$Eeb(d));
}
function $61de1ee1cac498ae$var$iZb(a, b, c, d, e, f) {
    var g;
    g = $61de1ee1cac498ae$var$kZb(d);
    $61de1ee1cac498ae$var$QZb(g, e);
    $61de1ee1cac498ae$var$RZb(g, f);
    $61de1ee1cac498ae$var$Rc(a.a, d, new $61de1ee1cac498ae$var$BZb(g, b, c.f));
}
function $61de1ee1cac498ae$var$Bid(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$YKd(a.Tg(), b);
    if (!c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b + $61de1ee1cac498ae$var$lte));
    return c;
}
function $61de1ee1cac498ae$var$ntd(a, b) {
    var c;
    c = a;
    while($61de1ee1cac498ae$var$Xod(c)){
        c = $61de1ee1cac498ae$var$Xod(c);
        if (c == b) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Uw(a, b) {
    var c, d, e;
    d = b.a.cd();
    c = $61de1ee1cac498ae$var$BD(b.a.dd(), 14).gc();
    for(e = 0; e < c; e++)a.td(d);
}
function $61de1ee1cac498ae$var$Hkb(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$uCb(b);
    for(d = a.c, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        b.td(c);
    }
}
function $61de1ee1cac498ae$var$Nsb(a, b) {
    var c;
    c = b.c;
    b.a.b = b.b;
    b.b.a = b.a;
    b.a = b.b = null;
    b.c = null;
    --a.b;
    return c;
}
function $61de1ee1cac498ae$var$wqb(a, b) {
    if (!!b && a.b[b.g] == b) {
        $61de1ee1cac498ae$var$NC(a.b, b.g, null);
        --a.c;
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$lo(a, b) {
    return !!$61de1ee1cac498ae$var$vo(a, b, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(b == null ? 0 : $61de1ee1cac498ae$var$tb(b), $61de1ee1cac498ae$var$Fie)), 15))));
}
function $61de1ee1cac498ae$var$w$b(a, b) {
    $61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a.e, 10), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98)) && ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Okb($61de1ee1cac498ae$var$BD(a.e, 10).j, b));
}
function $61de1ee1cac498ae$var$THb(a) {
    a.b = ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$KHb);
    a.f = ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$CIb);
    a.d = ($61de1ee1cac498ae$var$Xj(2, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(2));
    a.e = new $61de1ee1cac498ae$var$d7c;
}
function $61de1ee1cac498ae$var$gHb() {
    $61de1ee1cac498ae$var$gHb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$dHb = new $61de1ee1cac498ae$var$hHb("BEGIN", 0);
    $61de1ee1cac498ae$var$eHb = new $61de1ee1cac498ae$var$hHb($61de1ee1cac498ae$var$gle, 1);
    $61de1ee1cac498ae$var$fHb = new $61de1ee1cac498ae$var$hHb("END", 2);
}
function $61de1ee1cac498ae$var$qad() {
    $61de1ee1cac498ae$var$qad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$nad = new $61de1ee1cac498ae$var$rad($61de1ee1cac498ae$var$gle, 0);
    $61de1ee1cac498ae$var$oad = new $61de1ee1cac498ae$var$rad("HEAD", 1);
    $61de1ee1cac498ae$var$pad = new $61de1ee1cac498ae$var$rad("TAIL", 2);
}
function $61de1ee1cac498ae$var$Fsd() {
    $61de1ee1cac498ae$var$Csd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O3, 1), $61de1ee1cac498ae$var$Kie, 237, 0, [
        $61de1ee1cac498ae$var$Bsd,
        $61de1ee1cac498ae$var$ysd,
        $61de1ee1cac498ae$var$zsd,
        $61de1ee1cac498ae$var$xsd,
        $61de1ee1cac498ae$var$Asd,
        $61de1ee1cac498ae$var$vsd,
        $61de1ee1cac498ae$var$usd,
        $61de1ee1cac498ae$var$wsd
    ]);
}
function $61de1ee1cac498ae$var$c6c() {
    $61de1ee1cac498ae$var$_5c();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$f1, 1), $61de1ee1cac498ae$var$Kie, 277, 0, [
        $61de1ee1cac498ae$var$$5c,
        $61de1ee1cac498ae$var$T5c,
        $61de1ee1cac498ae$var$X5c,
        $61de1ee1cac498ae$var$Z5c,
        $61de1ee1cac498ae$var$U5c,
        $61de1ee1cac498ae$var$V5c,
        $61de1ee1cac498ae$var$W5c,
        $61de1ee1cac498ae$var$Y5c
    ]);
}
function $61de1ee1cac498ae$var$Dlc() {
    $61de1ee1cac498ae$var$Alc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KV, 1), $61de1ee1cac498ae$var$Kie, 270, 0, [
        $61de1ee1cac498ae$var$tlc,
        $61de1ee1cac498ae$var$wlc,
        $61de1ee1cac498ae$var$slc,
        $61de1ee1cac498ae$var$zlc,
        $61de1ee1cac498ae$var$vlc,
        $61de1ee1cac498ae$var$ulc,
        $61de1ee1cac498ae$var$ylc,
        $61de1ee1cac498ae$var$xlc
    ]);
}
function $61de1ee1cac498ae$var$nAc() {
    $61de1ee1cac498ae$var$kAc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$aX, 1), $61de1ee1cac498ae$var$Kie, 260, 0, [
        $61de1ee1cac498ae$var$iAc,
        $61de1ee1cac498ae$var$dAc,
        $61de1ee1cac498ae$var$gAc,
        $61de1ee1cac498ae$var$eAc,
        $61de1ee1cac498ae$var$fAc,
        $61de1ee1cac498ae$var$cAc,
        $61de1ee1cac498ae$var$hAc,
        $61de1ee1cac498ae$var$jAc
    ]);
}
function $61de1ee1cac498ae$var$kcd() {
    $61de1ee1cac498ae$var$kcd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$jcd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$D1, 1), $61de1ee1cac498ae$var$Kie, 98, 0, [
        $61de1ee1cac498ae$var$ccd,
        $61de1ee1cac498ae$var$bcd,
        $61de1ee1cac498ae$var$acd,
        $61de1ee1cac498ae$var$Zbd,
        $61de1ee1cac498ae$var$_bd,
        $61de1ee1cac498ae$var$$bd
    ])));
}
function $61de1ee1cac498ae$var$tHb() {
    $61de1ee1cac498ae$var$tHb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$sHb = ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ])).length;
    $61de1ee1cac498ae$var$rHb = $61de1ee1cac498ae$var$sHb;
}
function $61de1ee1cac498ae$var$wed(a) {
    this.b = ($61de1ee1cac498ae$var$Qb(a), new $61de1ee1cac498ae$var$Tkb(a));
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.d = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$d7c;
}
function $61de1ee1cac498ae$var$W6c(a) {
    var b;
    b = $61de1ee1cac498ae$var$$wnd.Math.sqrt(a.a * a.a + a.b * a.b);
    if (b > 0) {
        a.a /= b;
        a.b /= b;
    }
    return a;
}
function $61de1ee1cac498ae$var$bKd(a) {
    var b;
    if (a.w) return a.w;
    else {
        b = $61de1ee1cac498ae$var$cKd(a);
        !!b && !b.kh() && (a.w = b);
        return b;
    }
}
function $61de1ee1cac498ae$var$gZd(a) {
    var b;
    if (a == null) return null;
    else {
        b = $61de1ee1cac498ae$var$BD(a, 190);
        return $61de1ee1cac498ae$var$Umd(b, b.length);
    }
}
function $61de1ee1cac498ae$var$qud(a, b) {
    if (a.g == null || b >= a.i) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$$zd(b, a.i));
    return a.li(b, a.g[b]);
}
function $61de1ee1cac498ae$var$Mmc(a) {
    var b, c;
    b = a.a.d.j;
    c = a.c.d.j;
    while(b != c){
        $61de1ee1cac498ae$var$rqb(a.b, b);
        b = $61de1ee1cac498ae$var$Xcd(b);
    }
    $61de1ee1cac498ae$var$rqb(a.b, b);
}
function $61de1ee1cac498ae$var$Jmc(a) {
    var b;
    for(b = 0; b < a.c.length; b++)($61de1ee1cac498ae$var$tCb(b, a.c.length), $61de1ee1cac498ae$var$BD(a.c[b], 11)).p = b;
}
function $61de1ee1cac498ae$var$bEc(a, b, c) {
    var d, e, f;
    e = b[c];
    for(d = 0; d < e.length; d++){
        f = e[d];
        a.e[f.c.p][f.p] = d;
    }
}
function $61de1ee1cac498ae$var$ZEc(a, b) {
    var c, d, e, f;
    for(d = a.d, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        $61de1ee1cac498ae$var$REc(a.g, c).a = b;
    }
}
function $61de1ee1cac498ae$var$q7c(a, b) {
    var c, d;
    for(d = $61de1ee1cac498ae$var$Jsb(a, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
        $61de1ee1cac498ae$var$P6c(c, b);
    }
    return a;
}
function $61de1ee1cac498ae$var$zUb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b), 8)), $61de1ee1cac498ae$var$E6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.f, b), 460).b));
    return c;
}
function $61de1ee1cac498ae$var$lib(a) {
    var b;
    $61de1ee1cac498ae$var$xpb(a.e, a);
    $61de1ee1cac498ae$var$sCb(a.b);
    a.c = a.a;
    b = $61de1ee1cac498ae$var$BD(a.a.Pb(), 42);
    a.b = $61de1ee1cac498ae$var$kib(a);
    return b;
}
function $61de1ee1cac498ae$var$CD(a) {
    var b;
    $61de1ee1cac498ae$var$CCb(a == null || Array.isArray(a) && (b = $61de1ee1cac498ae$var$HC(a), !(b >= 14 && b <= 16)));
    return a;
}
function $61de1ee1cac498ae$var$dcb(a, b, c) {
    var d = function() {
        return a.apply(d, arguments);
    };
    b.apply(d, c);
    return d;
}
function $61de1ee1cac498ae$var$TLc(a, b, c) {
    var d, e;
    d = b;
    do {
        e = $61de1ee1cac498ae$var$Edb(a.p[d.p]) + c;
        a.p[d.p] = e;
        d = a.a[d.p];
    }while (d != b);
}
function $61de1ee1cac498ae$var$NQd(a, b) {
    var c, d;
    d = a.a;
    c = $61de1ee1cac498ae$var$OQd(a, b, null);
    d != b && !a.e && (c = $61de1ee1cac498ae$var$QQd(a, b, c));
    !!c && c.Fi();
}
function $61de1ee1cac498ae$var$ADb(a, b) {
    return $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Qie), $61de1ee1cac498ae$var$$wnd.Math.abs(a - b) <= $61de1ee1cac498ae$var$Qie || a == b || isNaN(a) && isNaN(b);
}
function $61de1ee1cac498ae$var$Ky(a, b) {
    $61de1ee1cac498ae$var$Iy();
    $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Qie);
    return $61de1ee1cac498ae$var$$wnd.Math.abs(a - b) <= $61de1ee1cac498ae$var$Qie || a == b || isNaN(a) && isNaN(b);
}
function $61de1ee1cac498ae$var$Akc(a, b) {
    $61de1ee1cac498ae$var$gkc();
    return $61de1ee1cac498ae$var$beb(a.b.c.length - a.e.c.length, b.b.c.length - b.e.c.length);
}
function $61de1ee1cac498ae$var$oo(a, b) {
    return $61de1ee1cac498ae$var$Kv($61de1ee1cac498ae$var$uo(a, b, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(b == null ? 0 : $61de1ee1cac498ae$var$tb(b), $61de1ee1cac498ae$var$Fie)), 15)))));
}
function $61de1ee1cac498ae$var$o0b() {
    $61de1ee1cac498ae$var$o0b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$n0b = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$NQ, 1), $61de1ee1cac498ae$var$Kie, 267, 0, [
        $61de1ee1cac498ae$var$h0b,
        $61de1ee1cac498ae$var$g0b,
        $61de1ee1cac498ae$var$e0b,
        $61de1ee1cac498ae$var$i0b,
        $61de1ee1cac498ae$var$f0b,
        $61de1ee1cac498ae$var$d0b
    ])));
}
function $61de1ee1cac498ae$var$n8c() {
    $61de1ee1cac498ae$var$n8c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$m8c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$r1, 1), $61de1ee1cac498ae$var$Kie, 291, 0, [
        $61de1ee1cac498ae$var$h8c,
        $61de1ee1cac498ae$var$g8c,
        $61de1ee1cac498ae$var$f8c,
        $61de1ee1cac498ae$var$d8c,
        $61de1ee1cac498ae$var$c8c,
        $61de1ee1cac498ae$var$e8c
    ])));
}
function $61de1ee1cac498ae$var$K7c() {
    $61de1ee1cac498ae$var$K7c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$J7c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$o1, 1), $61de1ee1cac498ae$var$Kie, 248, 0, [
        $61de1ee1cac498ae$var$z7c,
        $61de1ee1cac498ae$var$C7c,
        $61de1ee1cac498ae$var$D7c,
        $61de1ee1cac498ae$var$E7c,
        $61de1ee1cac498ae$var$A7c,
        $61de1ee1cac498ae$var$B7c
    ])));
}
function $61de1ee1cac498ae$var$Fpc() {
    $61de1ee1cac498ae$var$Fpc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Epc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Apc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$EW, 1), $61de1ee1cac498ae$var$Kie, 227, 0, [
        $61de1ee1cac498ae$var$wpc,
        $61de1ee1cac498ae$var$ypc,
        $61de1ee1cac498ae$var$vpc,
        $61de1ee1cac498ae$var$xpc,
        $61de1ee1cac498ae$var$zpc,
        $61de1ee1cac498ae$var$upc
    ])));
}
function $61de1ee1cac498ae$var$Drc() {
    $61de1ee1cac498ae$var$Drc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Crc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$yrc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$OW, 1), $61de1ee1cac498ae$var$Kie, 275, 0, [
        $61de1ee1cac498ae$var$wrc,
        $61de1ee1cac498ae$var$trc,
        $61de1ee1cac498ae$var$xrc,
        $61de1ee1cac498ae$var$vrc,
        $61de1ee1cac498ae$var$urc,
        $61de1ee1cac498ae$var$rrc
    ])));
}
function $61de1ee1cac498ae$var$qrc() {
    $61de1ee1cac498ae$var$qrc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$prc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$lrc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$NW, 1), $61de1ee1cac498ae$var$Kie, 274, 0, [
        $61de1ee1cac498ae$var$irc,
        $61de1ee1cac498ae$var$hrc,
        $61de1ee1cac498ae$var$krc,
        $61de1ee1cac498ae$var$grc,
        $61de1ee1cac498ae$var$jrc,
        $61de1ee1cac498ae$var$frc
    ])));
}
function $61de1ee1cac498ae$var$tzc() {
    $61de1ee1cac498ae$var$tzc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$szc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$lzc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$YW, 1), $61de1ee1cac498ae$var$Kie, 313, 0, [
        $61de1ee1cac498ae$var$jzc,
        $61de1ee1cac498ae$var$hzc,
        $61de1ee1cac498ae$var$fzc,
        $61de1ee1cac498ae$var$gzc,
        $61de1ee1cac498ae$var$kzc,
        $61de1ee1cac498ae$var$izc
    ])));
}
function $61de1ee1cac498ae$var$Yqc() {
    $61de1ee1cac498ae$var$Yqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Xqc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Sqc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LW, 1), $61de1ee1cac498ae$var$Kie, 276, 0, [
        $61de1ee1cac498ae$var$Nqc,
        $61de1ee1cac498ae$var$Mqc,
        $61de1ee1cac498ae$var$Pqc,
        $61de1ee1cac498ae$var$Oqc,
        $61de1ee1cac498ae$var$Rqc,
        $61de1ee1cac498ae$var$Qqc
    ])));
}
function $61de1ee1cac498ae$var$wSc() {
    $61de1ee1cac498ae$var$wSc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vSc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$qSc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t$, 1), $61de1ee1cac498ae$var$Kie, 327, 0, [
        $61de1ee1cac498ae$var$pSc,
        $61de1ee1cac498ae$var$lSc,
        $61de1ee1cac498ae$var$nSc,
        $61de1ee1cac498ae$var$mSc,
        $61de1ee1cac498ae$var$oSc,
        $61de1ee1cac498ae$var$kSc
    ])));
}
function $61de1ee1cac498ae$var$ycd() {
    $61de1ee1cac498ae$var$ycd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xcd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E1, 1), $61de1ee1cac498ae$var$Kie, 273, 0, [
        $61de1ee1cac498ae$var$pcd,
        $61de1ee1cac498ae$var$ncd,
        $61de1ee1cac498ae$var$ocd,
        $61de1ee1cac498ae$var$mcd,
        $61de1ee1cac498ae$var$lcd,
        $61de1ee1cac498ae$var$qcd
    ])));
}
function $61de1ee1cac498ae$var$Rad() {
    $61de1ee1cac498ae$var$Rad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Qad = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Mad(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w1, 1), $61de1ee1cac498ae$var$Kie, 312, 0, [
        $61de1ee1cac498ae$var$Kad,
        $61de1ee1cac498ae$var$Iad,
        $61de1ee1cac498ae$var$Lad,
        $61de1ee1cac498ae$var$Gad,
        $61de1ee1cac498ae$var$Jad,
        $61de1ee1cac498ae$var$Had
    ])));
}
function $61de1ee1cac498ae$var$Lbd() {
    $61de1ee1cac498ae$var$Hbd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
        $61de1ee1cac498ae$var$zbd,
        $61de1ee1cac498ae$var$ybd,
        $61de1ee1cac498ae$var$Bbd,
        $61de1ee1cac498ae$var$Gbd,
        $61de1ee1cac498ae$var$Fbd,
        $61de1ee1cac498ae$var$Ebd,
        $61de1ee1cac498ae$var$Cbd,
        $61de1ee1cac498ae$var$Dbd,
        $61de1ee1cac498ae$var$Abd
    ]);
}
function $61de1ee1cac498ae$var$vkd(a, b) {
    var c;
    c = a.a;
    a.a = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 0, c, a.a));
}
function $61de1ee1cac498ae$var$wkd(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 1, c, a.b));
}
function $61de1ee1cac498ae$var$hmd(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 3, c, a.b));
}
function $61de1ee1cac498ae$var$ald(a, b) {
    var c;
    c = a.f;
    a.f = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 3, c, a.f));
}
function $61de1ee1cac498ae$var$cld(a, b) {
    var c;
    c = a.g;
    a.g = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 4, c, a.g));
}
function $61de1ee1cac498ae$var$dld(a, b) {
    var c;
    c = a.i;
    a.i = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 5, c, a.i));
}
function $61de1ee1cac498ae$var$eld(a, b) {
    var c;
    c = a.j;
    a.j = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 6, c, a.j));
}
function $61de1ee1cac498ae$var$omd(a, b) {
    var c;
    c = a.j;
    a.j = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 1, c, a.j));
}
function $61de1ee1cac498ae$var$imd(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 4, c, a.c));
}
function $61de1ee1cac498ae$var$pmd(a, b) {
    var c;
    c = a.k;
    a.k = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$lSd(a, 2, c, a.k));
}
function $61de1ee1cac498ae$var$qQd(a, b) {
    var c;
    c = a.d;
    a.d = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$mSd(a, 2, c, a.d));
}
function $61de1ee1cac498ae$var$AId(a, b) {
    var c;
    c = a.s;
    a.s = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$mSd(a, 4, c, a.s));
}
function $61de1ee1cac498ae$var$DId(a, b) {
    var c;
    c = a.t;
    a.t = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$mSd(a, 5, c, a.t));
}
function $61de1ee1cac498ae$var$_Jd(a, b) {
    var c;
    c = a.F;
    a.F = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 5, c, b));
}
function $61de1ee1cac498ae$var$izd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(($61de1ee1cac498ae$var$pEd(), $61de1ee1cac498ae$var$oEd), a), 55);
    return c ? c.xj(b) : $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, b, 5, 1);
}
function $61de1ee1cac498ae$var$Xpd(a, b) {
    var c, d;
    c = b in a.a;
    if (c) {
        d = $61de1ee1cac498ae$var$aC(a, b).he();
        if (d) return d.a;
    }
    return null;
}
function $61de1ee1cac498ae$var$ftd(a, b) {
    var c, d, e;
    c = (d = ($61de1ee1cac498ae$var$Fhd(), e = new $61de1ee1cac498ae$var$Jod, e), !!b && $61de1ee1cac498ae$var$God(d, b), d);
    $61de1ee1cac498ae$var$Hod(c, a);
    return c;
}
function $61de1ee1cac498ae$var$LLd(a, b, c) {
    $61de1ee1cac498ae$var$Itd(a, c);
    if (!a.Bk() && c != null && !a.wj(c)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$tcb);
    return c;
}
function $61de1ee1cac498ae$var$Xdd(a, b) {
    a.n = b;
    if (a.n) {
        a.f = new $61de1ee1cac498ae$var$Rkb;
        a.e = new $61de1ee1cac498ae$var$Rkb;
    } else {
        a.f = null;
        a.e = null;
    }
    return a;
}
function $61de1ee1cac498ae$var$ndb(a, b, c, d, e, f) {
    var g;
    g = $61de1ee1cac498ae$var$ldb(a, b);
    $61de1ee1cac498ae$var$zdb(c, g);
    g.i = e ? 8 : 0;
    g.f = d;
    g.e = e;
    g.g = f;
    return g;
}
function $61de1ee1cac498ae$var$rSd(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 1;
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$tSd(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 2;
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$BSd(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 6;
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$GSd(a, b, c, d, e) {
    this.d = b;
    this.k = d;
    this.f = e;
    this.o = -1;
    this.p = 7;
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$xSd(a, b, c, d, e) {
    this.d = b;
    this.j = d;
    this.e = e;
    this.o = -1;
    this.p = 4;
    this.c = a;
    this.a = c;
}
function $61de1ee1cac498ae$var$rDb(a, b) {
    var c, d, e, f;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        $61de1ee1cac498ae$var$nDb(a.a, c);
    }
    return a;
}
function $61de1ee1cac498ae$var$pl(a) {
    var b, c, d, e;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$Qb(b);
    }
    return new $61de1ee1cac498ae$var$vl(a);
}
function $61de1ee1cac498ae$var$Uz(a) {
    var b = /function(?:\s+([\w$]+))?\s*\(/;
    var c = b.exec(a);
    return c && c[1] || $61de1ee1cac498ae$var$Xie;
}
function $61de1ee1cac498ae$var$zdb(a, b) {
    var c;
    if (!a) return;
    b.n = a;
    var d = $61de1ee1cac498ae$var$tdb(b);
    if (!d) {
        $61de1ee1cac498ae$var$_bb[a] = [
            b
        ];
        return;
    }
    d.gm = b;
}
function $61de1ee1cac498ae$var$vlb(a, b, c) {
    var d, e;
    e = a.length;
    d = $61de1ee1cac498ae$var$$wnd.Math.min(c, e);
    $61de1ee1cac498ae$var$$Bb(a, 0, b, 0, d, true);
    return b;
}
function $61de1ee1cac498ae$var$RPb(a, b, c) {
    var d, e;
    for(e = b.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 79);
        $61de1ee1cac498ae$var$Qqb(a, $61de1ee1cac498ae$var$BD(c.Kb(d), 33));
    }
}
function $61de1ee1cac498ae$var$Xbb() {
    $61de1ee1cac498ae$var$Ybb();
    var a = $61de1ee1cac498ae$var$Wbb;
    for(var b = 0; b < arguments.length; b++)a.push(arguments[b]);
}
function $61de1ee1cac498ae$var$n7c(a, b) {
    var c, d, e, f;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        $61de1ee1cac498ae$var$Gsb(a, c, a.c.b, a.c);
    }
}
function $61de1ee1cac498ae$var$s$c(a, b) {
    a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.b, b.d);
    a.e += b.r + (a.a.c.length == 0 ? 0 : a.c);
    $61de1ee1cac498ae$var$Ekb(a.a, b);
}
function $61de1ee1cac498ae$var$wkb(a) {
    $61de1ee1cac498ae$var$yCb(a.c >= 0);
    if ($61de1ee1cac498ae$var$ekb(a.d, a.c) < 0) {
        a.a = a.a - 1 & a.d.a.length - 1;
        a.b = a.d.c;
    }
    a.c = -1;
}
function $61de1ee1cac498ae$var$pgb(a) {
    if (a.a < 54) return a.f < 0 ? -1 : a.f > 0 ? 1 : 0;
    return (!a.c && (a.c = $61de1ee1cac498ae$var$fhb(a.f)), a.c).e;
}
function $61de1ee1cac498ae$var$My(a) {
    if (!(a >= 0)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("tolerance (" + a + ") must be >= 0"));
    return a;
}
function $61de1ee1cac498ae$var$n4c() {
    if (!$61de1ee1cac498ae$var$f4c) {
        $61de1ee1cac498ae$var$f4c = new $61de1ee1cac498ae$var$m4c;
        $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$f4c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$Z9c
        ]));
    }
    return $61de1ee1cac498ae$var$f4c;
}
function $61de1ee1cac498ae$var$KAc() {
    $61de1ee1cac498ae$var$KAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$JAc = new $61de1ee1cac498ae$var$LAc($61de1ee1cac498ae$var$ole, 0);
    $61de1ee1cac498ae$var$HAc = new $61de1ee1cac498ae$var$LAc("INPUT", 1);
    $61de1ee1cac498ae$var$IAc = new $61de1ee1cac498ae$var$LAc("OUTPUT", 2);
}
function $61de1ee1cac498ae$var$bqc() {
    $61de1ee1cac498ae$var$bqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$$pc = new $61de1ee1cac498ae$var$cqc("ARD", 0);
    $61de1ee1cac498ae$var$aqc = new $61de1ee1cac498ae$var$cqc("MSD", 1);
    $61de1ee1cac498ae$var$_pc = new $61de1ee1cac498ae$var$cqc("MANUAL", 2);
}
function $61de1ee1cac498ae$var$rGc() {
    $61de1ee1cac498ae$var$rGc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$oGc = new $61de1ee1cac498ae$var$sGc("BARYCENTER", 0);
    $61de1ee1cac498ae$var$pGc = new $61de1ee1cac498ae$var$sGc($61de1ee1cac498ae$var$Bne, 1);
    $61de1ee1cac498ae$var$qGc = new $61de1ee1cac498ae$var$sGc($61de1ee1cac498ae$var$Cne, 2);
}
function $61de1ee1cac498ae$var$ztd(a, b) {
    var c;
    c = a.gc();
    if (b < 0 || b > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(b, c));
    return new $61de1ee1cac498ae$var$czd(a, b);
}
function $61de1ee1cac498ae$var$JAd(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$JD(b, 42)) return a.c.Mc(b);
    else {
        c = $61de1ee1cac498ae$var$qAd(a, b);
        $61de1ee1cac498ae$var$LAd(a, b);
        return c;
    }
}
function $61de1ee1cac498ae$var$$nd(a, b, c) {
    $61de1ee1cac498ae$var$yId(a, b);
    $61de1ee1cac498ae$var$pnd(a, c);
    $61de1ee1cac498ae$var$AId(a, 0);
    $61de1ee1cac498ae$var$DId(a, 1);
    $61de1ee1cac498ae$var$CId(a, true);
    $61de1ee1cac498ae$var$BId(a, true);
    return a;
}
function $61de1ee1cac498ae$var$Xj(a, b) {
    if (a < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb(b + " cannot be negative but was: " + a));
    return a;
}
function $61de1ee1cac498ae$var$Bt(a, b) {
    var c, d;
    for(c = 0, d = a.gc(); c < d; ++c){
        if ($61de1ee1cac498ae$var$wtb(b, a.Xb(c))) return c;
    }
    return -1;
}
function $61de1ee1cac498ae$var$Nc(a) {
    var b, c;
    for(c = a.c.Cc().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 14);
        b.$b();
    }
    a.c.$b();
    a.d = 0;
}
function $61de1ee1cac498ae$var$Ri(a) {
    var b, c, d, e;
    for(c = a.a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$Flb(b, b.length, null);
    }
}
function $61de1ee1cac498ae$var$ieb(a) {
    var b, c;
    if (a == 0) return 32;
    else {
        c = 0;
        for(b = 1; (b & a) == 0; b <<= 1)++c;
        return c;
    }
}
function $61de1ee1cac498ae$var$NGb(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$ahd(a)); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 680);
        b.Gf();
    }
}
function $61de1ee1cac498ae$var$CUb(a) {
    $61de1ee1cac498ae$var$xUb();
    this.g = new $61de1ee1cac498ae$var$Lqb;
    this.f = new $61de1ee1cac498ae$var$Lqb;
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.c = new $61de1ee1cac498ae$var$Hp;
    this.i = a;
}
function $61de1ee1cac498ae$var$XZb() {
    this.f = new $61de1ee1cac498ae$var$d7c;
    this.d = new $61de1ee1cac498ae$var$s0b;
    this.c = new $61de1ee1cac498ae$var$d7c;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.b = new $61de1ee1cac498ae$var$Rkb;
}
function $61de1ee1cac498ae$var$c6d(a, b, c, d) {
    this.rj();
    this.a = b;
    this.b = a;
    this.c = null;
    this.c = new $61de1ee1cac498ae$var$d6d(this, b, c, d);
}
function $61de1ee1cac498ae$var$nxd(a, b, c, d, e) {
    this.d = a;
    this.n = b;
    this.g = c;
    this.o = d;
    this.p = -1;
    e || (this.o = -2 - d - 1);
}
function $61de1ee1cac498ae$var$hJd() {
    $61de1ee1cac498ae$var$FId.call(this);
    this.n = -1;
    this.g = null;
    this.i = null;
    this.j = null;
    this.Bb |= $61de1ee1cac498ae$var$zte;
}
function $61de1ee1cac498ae$var$Ldd() {
    $61de1ee1cac498ae$var$Idd();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$J1, 1), $61de1ee1cac498ae$var$Kie, 259, 0, [
        $61de1ee1cac498ae$var$Bdd,
        $61de1ee1cac498ae$var$Ddd,
        $61de1ee1cac498ae$var$Add,
        $61de1ee1cac498ae$var$Edd,
        $61de1ee1cac498ae$var$Fdd,
        $61de1ee1cac498ae$var$Hdd,
        $61de1ee1cac498ae$var$Gdd,
        $61de1ee1cac498ae$var$Cdd,
        $61de1ee1cac498ae$var$zdd
    ]);
}
function $61de1ee1cac498ae$var$uFb() {
    $61de1ee1cac498ae$var$rFb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$dN, 1), $61de1ee1cac498ae$var$Kie, 250, 0, [
        $61de1ee1cac498ae$var$qFb,
        $61de1ee1cac498ae$var$lFb,
        $61de1ee1cac498ae$var$mFb,
        $61de1ee1cac498ae$var$kFb,
        $61de1ee1cac498ae$var$oFb,
        $61de1ee1cac498ae$var$pFb,
        $61de1ee1cac498ae$var$nFb,
        $61de1ee1cac498ae$var$jFb,
        $61de1ee1cac498ae$var$iFb
    ]);
}
function $61de1ee1cac498ae$var$qeb() {
    $61de1ee1cac498ae$var$qeb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$peb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        0,
        8,
        4,
        12,
        2,
        10,
        6,
        14,
        1,
        9,
        5,
        13,
        3,
        11,
        7,
        15
    ]);
}
function $61de1ee1cac498ae$var$vCc() {
    $61de1ee1cac498ae$var$vCc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$uCc = $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$Z7b)), $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$w8b), $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$v8b);
}
function $61de1ee1cac498ae$var$VCc() {
    $61de1ee1cac498ae$var$VCc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$UCc = $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$Z7b)), $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$w8b), $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$v8b);
}
function $61de1ee1cac498ae$var$rDc() {
    $61de1ee1cac498ae$var$rDc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qDc = $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$Z7b)), $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$w8b), $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$v8b);
}
function $61de1ee1cac498ae$var$yFc() {
    $61de1ee1cac498ae$var$yFc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xFc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$z8b)), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$p8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$y8b);
}
function $61de1ee1cac498ae$var$Rpc() {
    $61de1ee1cac498ae$var$Rpc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ppc = new $61de1ee1cac498ae$var$Tpc("LAYER_SWEEP", 0);
    $61de1ee1cac498ae$var$Opc = new $61de1ee1cac498ae$var$Tpc($61de1ee1cac498ae$var$Tne, 1);
    $61de1ee1cac498ae$var$Qpc = new $61de1ee1cac498ae$var$Tpc($61de1ee1cac498ae$var$ane, 2);
}
function $61de1ee1cac498ae$var$RLc(a, b) {
    var c, d;
    c = a.c;
    d = b.e[a.p];
    if (d > 0) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.a, d - 1), 10);
    return null;
}
function $61de1ee1cac498ae$var$Lkd(a, b) {
    var c;
    c = a.k;
    a.k = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 2, c, a.k));
}
function $61de1ee1cac498ae$var$kmd(a, b) {
    var c;
    c = a.f;
    a.f = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 8, c, a.f));
}
function $61de1ee1cac498ae$var$lmd(a, b) {
    var c;
    c = a.i;
    a.i = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 7, c, a.i));
}
function $61de1ee1cac498ae$var$Hod(a, b) {
    var c;
    c = a.a;
    a.a = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 8, c, a.a));
}
function $61de1ee1cac498ae$var$zpd(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 0, c, a.b));
}
function $61de1ee1cac498ae$var$UUd(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 0, c, a.b));
}
function $61de1ee1cac498ae$var$VUd(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 1, c, a.c));
}
function $61de1ee1cac498ae$var$Apd(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 1, c, a.c));
}
function $61de1ee1cac498ae$var$pQd(a, b) {
    var c;
    c = a.c;
    a.c = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 4, c, a.c));
}
function $61de1ee1cac498ae$var$PHd(a, b) {
    var c;
    c = a.d;
    a.d = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 1, c, a.d));
}
function $61de1ee1cac498ae$var$jKd(a, b) {
    var c;
    c = a.D;
    a.D = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 2, c, a.D));
}
function $61de1ee1cac498ae$var$Rdd(a, b) {
    if (a.r > 0 && a.c < a.r) {
        a.c += b;
        !!a.i && a.i.d > 0 && a.g != 0 && $61de1ee1cac498ae$var$Rdd(a.i, b / a.r * a.i.d);
    }
}
function $61de1ee1cac498ae$var$dge(a, b, c) {
    var d;
    a.b = b;
    a.a = c;
    d = (a.a & 512) == 512 ? new $61de1ee1cac498ae$var$hee : new $61de1ee1cac498ae$var$ude;
    a.c = $61de1ee1cac498ae$var$ode(d, a.b, a.a);
}
function $61de1ee1cac498ae$var$g3d(a, b) {
    return $61de1ee1cac498ae$var$T6d(a.e, b) ? ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$YId(b) ? new $61de1ee1cac498ae$var$R7d(b, a) : new $61de1ee1cac498ae$var$f7d(b, a)) : new $61de1ee1cac498ae$var$c8d(b, a);
}
function $61de1ee1cac498ae$var$_o(a, b) {
    return $61de1ee1cac498ae$var$Fv($61de1ee1cac498ae$var$vo(a.a, b, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(b == null ? 0 : $61de1ee1cac498ae$var$tb(b), $61de1ee1cac498ae$var$Fie)), 15)))));
}
function $61de1ee1cac498ae$var$Nyb(a, b, c) {
    return $61de1ee1cac498ae$var$Ayb(a, new $61de1ee1cac498ae$var$Kzb(b), new $61de1ee1cac498ae$var$Mzb, new $61de1ee1cac498ae$var$Ozb(c), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, []));
}
function $61de1ee1cac498ae$var$pAb(a) {
    var b, c;
    if (0 > a) return new $61de1ee1cac498ae$var$yAb;
    b = a + 1;
    c = new $61de1ee1cac498ae$var$rAb(b, a);
    return new $61de1ee1cac498ae$var$vAb(null, c);
}
function $61de1ee1cac498ae$var$umb(a, b) {
    $61de1ee1cac498ae$var$mmb();
    var c;
    c = new $61de1ee1cac498ae$var$Mqb(1);
    $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$Shb(c, a, b) : $61de1ee1cac498ae$var$jrb(c.f, a, b);
    return new $61de1ee1cac498ae$var$iob(c);
}
function $61de1ee1cac498ae$var$aMb(a, b) {
    var c, d;
    c = a.o + a.p;
    d = b.o + b.p;
    if (c < d) return -1;
    if (c == d) return 0;
    return 1;
}
function $61de1ee1cac498ae$var$P2b(a) {
    var b;
    b = $61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc));
    if ($61de1ee1cac498ae$var$JD(b, 160)) return $61de1ee1cac498ae$var$O2b($61de1ee1cac498ae$var$BD(b, 160));
    return null;
}
function $61de1ee1cac498ae$var$Kp(a) {
    var b;
    a = $61de1ee1cac498ae$var$$wnd.Math.max(a, 2);
    b = $61de1ee1cac498ae$var$geb(a);
    if (a > b) {
        b <<= 1;
        return b > 0 ? b : $61de1ee1cac498ae$var$Iie;
    }
    return b;
}
function $61de1ee1cac498ae$var$xc(a) {
    $61de1ee1cac498ae$var$Ub(a.e != 3);
    switch(a.e){
        case 2:
            return false;
        case 0:
            return true;
    }
    return $61de1ee1cac498ae$var$zc(a);
}
function $61de1ee1cac498ae$var$T6c(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$JD(b, 8)) {
        c = $61de1ee1cac498ae$var$BD(b, 8);
        return a.a == c.a && a.b == c.b;
    } else return false;
}
function $61de1ee1cac498ae$var$_Mb(a, b, c) {
    var d, e, f;
    f = b >> 5;
    e = b & 31;
    d = $61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Pbb(a.n[c][f], $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Nbb(e, 1))), 3);
    return d;
}
function $61de1ee1cac498ae$var$IAd(a, b) {
    var c, d;
    for(d = b.vc().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 42);
        $61de1ee1cac498ae$var$HAd(a, c.cd(), c.dd());
    }
}
function $61de1ee1cac498ae$var$N1c(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$tOb;
    $61de1ee1cac498ae$var$BD(b.b, 65);
    $61de1ee1cac498ae$var$BD(b.b, 65);
    $61de1ee1cac498ae$var$BD(b.b, 65);
    $61de1ee1cac498ae$var$Hkb(b.a, new $61de1ee1cac498ae$var$T1c(a, c, b));
}
function $61de1ee1cac498ae$var$DUd(a, b) {
    var c;
    c = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 21, c, a.b));
}
function $61de1ee1cac498ae$var$jmd(a, b) {
    var c;
    c = a.d;
    a.d = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 11, c, a.d));
}
function $61de1ee1cac498ae$var$_Id(a, b) {
    var c;
    c = a.j;
    a.j = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 13, c, a.j));
}
function $61de1ee1cac498ae$var$$jb(a, b, c) {
    var d, e, f;
    f = a.a.length - 1;
    for(e = a.b, d = 0; d < c; e = e + 1 & f, ++d)$61de1ee1cac498ae$var$NC(b, d, a.a[e]);
}
function $61de1ee1cac498ae$var$rqb(a, b) {
    var c;
    $61de1ee1cac498ae$var$uCb(b);
    c = b.g;
    if (!a.b[c]) {
        $61de1ee1cac498ae$var$NC(a.b, c, b);
        ++a.c;
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$eub(a, b) {
    var c;
    c = b == null ? -1 : $61de1ee1cac498ae$var$Jkb(a.b, b, 0);
    if (c < 0) return false;
    $61de1ee1cac498ae$var$fub(a, c);
    return true;
}
function $61de1ee1cac498ae$var$fub(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Kkb(a.b, a.b.c.length - 1);
    if (b < a.b.c.length) {
        $61de1ee1cac498ae$var$Nkb(a.b, b, c);
        $61de1ee1cac498ae$var$bub(a, b);
    }
}
function $61de1ee1cac498ae$var$eyb(a, b) {
    (($61de1ee1cac498ae$var$oyb(), $61de1ee1cac498ae$var$lyb) ? null : b.c).length == 0 && $61de1ee1cac498ae$var$qyb(b, new $61de1ee1cac498ae$var$zyb);
    $61de1ee1cac498ae$var$Shb(a.a, $61de1ee1cac498ae$var$lyb ? null : b.c, b);
}
function $61de1ee1cac498ae$var$M5b(a, b) {
    $61de1ee1cac498ae$var$Odd(b, "Hierarchical port constraint processing", 1);
    $61de1ee1cac498ae$var$N5b(a);
    $61de1ee1cac498ae$var$P5b(a);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$GOb(a, b) {
    var c, d;
    for(d = b.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 266);
        a.b = true;
        $61de1ee1cac498ae$var$Qqb(a.e, c);
        c.b = a;
    }
}
function $61de1ee1cac498ae$var$Owb(a, b) {
    var c, d;
    c = 1 - b;
    d = a.a[c];
    a.a[c] = d.a[b];
    d.a[b] = a;
    a.b = true;
    d.b = false;
    return d;
}
function $61de1ee1cac498ae$var$Gec(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ayc)), 8);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$ayc), 8);
    return $61de1ee1cac498ae$var$Kdb(c.b, d.b);
}
function $61de1ee1cac498ae$var$jfc(a) {
    $61de1ee1cac498ae$var$oEb.call(this);
    this.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$lyc))));
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Swc), 218);
}
function $61de1ee1cac498ae$var$XGc(a, b, c) {
    $61de1ee1cac498ae$var$uEc.call(this, a, b, c);
    this.a = new $61de1ee1cac498ae$var$Lqb;
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.d = new $61de1ee1cac498ae$var$$Gc(this);
}
function $61de1ee1cac498ae$var$ku(a) {
    this.e = a;
    this.d = new $61de1ee1cac498ae$var$Uqb($61de1ee1cac498ae$var$Cv($61de1ee1cac498ae$var$Ec(this.e).gc()));
    this.c = this.e.a;
    this.b = this.e.c;
}
function $61de1ee1cac498ae$var$BHc(a) {
    this.b = a;
    this.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a + 1, 15, 1);
    this.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a, 15, 1);
    this.d = 0;
}
function $61de1ee1cac498ae$var$THc(a, b, c) {
    var d;
    d = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$UHc(a, b, d, c, true, true);
    a.b = new $61de1ee1cac498ae$var$BHc(d.c.length);
    return d;
}
function $61de1ee1cac498ae$var$nMc(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.c, b), 458);
    if (!c) {
        c = new $61de1ee1cac498ae$var$uMc;
        c.c = b;
        $61de1ee1cac498ae$var$Rhb(a.c, c.c, c);
    }
    return c;
}
function $61de1ee1cac498ae$var$$B(e, a) {
    var b = e.a;
    var c = 0;
    for(var d in b)b.hasOwnProperty(d) && (a[c++] = d);
    return a;
}
function $61de1ee1cac498ae$var$pRd(a) {
    var b;
    if (a.b == null) return $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$KRd;
    b = a.Lk() ? a.Kk() : a.Jk();
    return b;
}
function $61de1ee1cac498ae$var$r$c(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$Fyd(a); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 33);
        $61de1ee1cac498ae$var$dld(b, 0);
        $61de1ee1cac498ae$var$eld(b, 0);
    }
}
function $61de1ee1cac498ae$var$HSb() {
    $61de1ee1cac498ae$var$HSb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$FSb = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Ime);
    $61de1ee1cac498ae$var$GSb = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Jme);
    $61de1ee1cac498ae$var$ESb = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Kme);
    $61de1ee1cac498ae$var$DSb = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Lme);
}
function $61de1ee1cac498ae$var$y5b() {
    $61de1ee1cac498ae$var$y5b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$x5b = new $61de1ee1cac498ae$var$z5b("TO_INTERNAL_LTR", 0);
    $61de1ee1cac498ae$var$w5b = new $61de1ee1cac498ae$var$z5b("TO_INPUT_DIRECTION", 1);
}
function $61de1ee1cac498ae$var$PUc() {
    $61de1ee1cac498ae$var$PUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$NUc = new $61de1ee1cac498ae$var$RUc("P1_NODE_PLACEMENT", 0);
    $61de1ee1cac498ae$var$OUc = new $61de1ee1cac498ae$var$RUc("P2_EDGE_ROUTING", 1);
}
function $61de1ee1cac498ae$var$Fkc() {
    $61de1ee1cac498ae$var$Fkc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ekc = new $61de1ee1cac498ae$var$Gkc("START", 0);
    $61de1ee1cac498ae$var$Dkc = new $61de1ee1cac498ae$var$Gkc("MIDDLE", 1);
    $61de1ee1cac498ae$var$Ckc = new $61de1ee1cac498ae$var$Gkc("END", 2);
}
function $61de1ee1cac498ae$var$I9b() {
    $61de1ee1cac498ae$var$I9b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$H9b = new $61de1ee1cac498ae$var$Msd("edgelabelcenterednessanalysis.includelabel", ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb));
}
function $61de1ee1cac498ae$var$Zyc(a, b) {
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(new $61de1ee1cac498ae$var$Pib(a.b), 1)), new $61de1ee1cac498ae$var$bfd(a, b)), new $61de1ee1cac498ae$var$ffd(a, b));
}
function $61de1ee1cac498ae$var$$Xc() {
    this.c = new $61de1ee1cac498ae$var$jVc(0);
    this.b = new $61de1ee1cac498ae$var$jVc($61de1ee1cac498ae$var$Tqe);
    this.d = new $61de1ee1cac498ae$var$jVc($61de1ee1cac498ae$var$Sqe);
    this.a = new $61de1ee1cac498ae$var$jVc($61de1ee1cac498ae$var$cme);
}
function $61de1ee1cac498ae$var$$Fc(a) {
    var b, c;
    for(c = a.c.a.ec().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 214);
        $61de1ee1cac498ae$var$eFc(b, new $61de1ee1cac498ae$var$oHc(b.e));
    }
}
function $61de1ee1cac498ae$var$ZFc(a) {
    var b, c;
    for(c = a.c.a.ec().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 214);
        $61de1ee1cac498ae$var$dFc(b, new $61de1ee1cac498ae$var$nHc(b.f));
    }
}
function $61de1ee1cac498ae$var$pnd(a, b) {
    var c;
    c = a.zb;
    a.zb = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 1, c, a.zb));
}
function $61de1ee1cac498ae$var$cod(a, b) {
    var c;
    c = a.xb;
    a.xb = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 3, c, a.xb));
}
function $61de1ee1cac498ae$var$dod(a, b) {
    var c;
    c = a.yb;
    a.yb = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 2, c, a.yb));
}
function $61de1ee1cac498ae$var$Knd(a, b) {
    var c, d;
    c = (d = new $61de1ee1cac498ae$var$OJd, d);
    c.n = b;
    $61de1ee1cac498ae$var$wtd((!a.s && (a.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, a, 21, 17)), a.s), c);
}
function $61de1ee1cac498ae$var$Qnd(a, b) {
    var c, d;
    d = (c = new $61de1ee1cac498ae$var$FUd, c);
    d.n = b;
    $61de1ee1cac498ae$var$wtd((!a.s && (a.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, a, 21, 17)), a.s), d);
}
function $61de1ee1cac498ae$var$ktb(a, b) {
    var c, d;
    c = a.Pc();
    $61de1ee1cac498ae$var$Klb(c, 0, c.length, b);
    for(d = 0; d < c.length; d++)a._c(d, c[d]);
}
function $61de1ee1cac498ae$var$ye(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$uCb(b);
    c = false;
    for(e = b.Kc(); e.Ob();){
        d = e.Pb();
        c = c | a.Fc(d);
    }
    return c;
}
function $61de1ee1cac498ae$var$Bx(a) {
    var b, c, d;
    b = 0;
    for(d = a.Kc(); d.Ob();){
        c = d.Pb();
        b += c != null ? $61de1ee1cac498ae$var$tb(c) : 0;
        b = ~~b;
    }
    return b;
}
function $61de1ee1cac498ae$var$SA(a) {
    var b;
    if (a == 0) return "UTC";
    if (a < 0) {
        a = -a;
        b = "UTC+";
    } else b = "UTC-";
    return b + $61de1ee1cac498ae$var$UA(a);
}
function $61de1ee1cac498ae$var$Jq(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$JD(b, 14)) {
        c = $61de1ee1cac498ae$var$BD(b, 14);
        return a.Gc(c);
    }
    return $61de1ee1cac498ae$var$fr(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(b), 20).Kc());
}
function $61de1ee1cac498ae$var$Bnc(a, b, c) {
    $61de1ee1cac498ae$var$Cnc.call(this, b, c);
    this.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, a.a.c.length, 0, 1);
    $61de1ee1cac498ae$var$Qkb(a.a, this.d);
}
function $61de1ee1cac498ae$var$IMc(a) {
    a.a = null;
    a.e = null;
    a.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.f.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.c = null;
}
function $61de1ee1cac498ae$var$gKd(a, b) {
    if (b) {
        if (a.B == null) {
            a.B = a.D;
            a.D = null;
        }
    } else if (a.B != null) {
        a.D = a.B;
        a.B = null;
    }
}
function $61de1ee1cac498ae$var$Poc(a, b) {
    return $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$TAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.c.b, 16)), new $61de1ee1cac498ae$var$fpc(a)), b))));
}
function $61de1ee1cac498ae$var$Soc(a, b) {
    return $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$TAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.c.b, 16)), new $61de1ee1cac498ae$var$dpc(a)), b))));
}
function $61de1ee1cac498ae$var$Q2b(a, b) {
    $61de1ee1cac498ae$var$Odd(b, $61de1ee1cac498ae$var$zne, 1);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.b, 16)), new $61de1ee1cac498ae$var$U2b), new $61de1ee1cac498ae$var$W2b);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$SXc(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$SWc)), 19);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$SWc), 19);
    return $61de1ee1cac498ae$var$beb(c.a, d.a);
}
function $61de1ee1cac498ae$var$p7c(a, b, c) {
    var d, e;
    for(e = $61de1ee1cac498ae$var$Jsb(a, 0); e.b != e.d.c;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(e), 8);
        d.a += b;
        d.b += c;
    }
    return a;
}
function $61de1ee1cac498ae$var$uo(a, b, c) {
    var d;
    for(d = a.b[c & a.f]; d; d = d.b){
        if (c == d.a && $61de1ee1cac498ae$var$Hb(b, d.g)) return d;
    }
    return null;
}
function $61de1ee1cac498ae$var$vo(a, b, c) {
    var d;
    for(d = a.c[c & a.f]; d; d = d.d){
        if (c == d.f && $61de1ee1cac498ae$var$Hb(b, d.i)) return d;
    }
    return null;
}
function $61de1ee1cac498ae$var$khb(a, b, c) {
    var d, e, f;
    d = 0;
    for(e = 0; e < c; e++){
        f = b[e];
        a[e] = f << 1 | d;
        d = f >>> 31;
    }
    d != 0 && (a[c] = d);
}
function $61de1ee1cac498ae$var$rmb(a, b) {
    $61de1ee1cac498ae$var$mmb();
    var c, d;
    d = new $61de1ee1cac498ae$var$Rkb;
    for(c = 0; c < a; ++c)d.c[d.c.length] = b;
    return new $61de1ee1cac498ae$var$Yob(d);
}
function $61de1ee1cac498ae$var$Zzb(a) {
    var b;
    b = $61de1ee1cac498ae$var$Yzb(a);
    if ($61de1ee1cac498ae$var$Bbb(b.a, 0)) return $61de1ee1cac498ae$var$Ltb(), $61de1ee1cac498ae$var$Ltb(), $61de1ee1cac498ae$var$Ktb;
    return $61de1ee1cac498ae$var$Ltb(), new $61de1ee1cac498ae$var$Ptb(b.b);
}
function $61de1ee1cac498ae$var$$zb(a) {
    var b;
    b = $61de1ee1cac498ae$var$Yzb(a);
    if ($61de1ee1cac498ae$var$Bbb(b.a, 0)) return $61de1ee1cac498ae$var$Ltb(), $61de1ee1cac498ae$var$Ltb(), $61de1ee1cac498ae$var$Ktb;
    return $61de1ee1cac498ae$var$Ltb(), new $61de1ee1cac498ae$var$Ptb(b.c);
}
function $61de1ee1cac498ae$var$uAb(a) {
    var b;
    b = $61de1ee1cac498ae$var$tAb(a);
    if ($61de1ee1cac498ae$var$Bbb(b.a, 0)) return $61de1ee1cac498ae$var$Utb(), $61de1ee1cac498ae$var$Utb(), $61de1ee1cac498ae$var$Ttb;
    return $61de1ee1cac498ae$var$Utb(), new $61de1ee1cac498ae$var$Xtb(b.b);
}
function $61de1ee1cac498ae$var$zZb(a) {
    if (a.b.c.i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.b.c.i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
    return a.b.c;
}
function $61de1ee1cac498ae$var$AZb(a) {
    if (a.b.d.i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.b.d.i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
    return a.b.d;
}
function $61de1ee1cac498ae$var$Vnd(a, b, c, d, e, f, g, h, i, j, k, l, m) {
    $61de1ee1cac498ae$var$aod(a, b, c, d, e, f, g, h, i, j, k, l, m);
    $61de1ee1cac498ae$var$MJd(a, false);
    return a;
}
function $61de1ee1cac498ae$var$tJb(a, b, c, d, e, f, g) {
    $61de1ee1cac498ae$var$$r.call(this, a, b);
    this.d = c;
    this.e = d;
    this.c = e;
    this.b = f;
    this.a = $61de1ee1cac498ae$var$Ou(g);
}
function $61de1ee1cac498ae$var$$bb(a, b) {
    typeof window === $61de1ee1cac498ae$var$Jhe && typeof window["$gwt"] === $61de1ee1cac498ae$var$Jhe && (window["$gwt"][a] = b);
}
function $61de1ee1cac498ae$var$pWb(a, b) {
    $61de1ee1cac498ae$var$lWb();
    return a == $61de1ee1cac498ae$var$hWb && b == $61de1ee1cac498ae$var$kWb || a == $61de1ee1cac498ae$var$kWb && b == $61de1ee1cac498ae$var$hWb || a == $61de1ee1cac498ae$var$jWb && b == $61de1ee1cac498ae$var$iWb || a == $61de1ee1cac498ae$var$iWb && b == $61de1ee1cac498ae$var$jWb;
}
function $61de1ee1cac498ae$var$qWb(a, b) {
    $61de1ee1cac498ae$var$lWb();
    return a == $61de1ee1cac498ae$var$hWb && b == $61de1ee1cac498ae$var$iWb || a == $61de1ee1cac498ae$var$hWb && b == $61de1ee1cac498ae$var$jWb || a == $61de1ee1cac498ae$var$kWb && b == $61de1ee1cac498ae$var$jWb || a == $61de1ee1cac498ae$var$kWb && b == $61de1ee1cac498ae$var$iWb;
}
function $61de1ee1cac498ae$var$IJb(a, b) {
    return $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$ple), $61de1ee1cac498ae$var$$wnd.Math.abs(0 - b) <= $61de1ee1cac498ae$var$ple || 0 == b || isNaN(0) && isNaN(b) ? 0 : a / b;
}
function $61de1ee1cac498ae$var$Rrc() {
    $61de1ee1cac498ae$var$Orc();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PW, 1), $61de1ee1cac498ae$var$Kie, 256, 0, [
        $61de1ee1cac498ae$var$Frc,
        $61de1ee1cac498ae$var$Hrc,
        $61de1ee1cac498ae$var$Irc,
        $61de1ee1cac498ae$var$Jrc,
        $61de1ee1cac498ae$var$Krc,
        $61de1ee1cac498ae$var$Lrc,
        $61de1ee1cac498ae$var$Nrc,
        $61de1ee1cac498ae$var$Erc,
        $61de1ee1cac498ae$var$Grc,
        $61de1ee1cac498ae$var$Mrc
    ]);
}
function $61de1ee1cac498ae$var$NKd() {
    $61de1ee1cac498ae$var$NKd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$KKd = new $61de1ee1cac498ae$var$KPd;
    $61de1ee1cac498ae$var$MKd = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t5, 1), $61de1ee1cac498ae$var$Mve, 170, 0, []);
    $61de1ee1cac498ae$var$LKd = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$n5, 1), $61de1ee1cac498ae$var$Nve, 59, 0, []);
}
function $61de1ee1cac498ae$var$CBc() {
    $61de1ee1cac498ae$var$CBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$BBc = new $61de1ee1cac498ae$var$DBc("NO", 0);
    $61de1ee1cac498ae$var$zBc = new $61de1ee1cac498ae$var$DBc("GREEDY", 1);
    $61de1ee1cac498ae$var$ABc = new $61de1ee1cac498ae$var$DBc("LOOK_BACK", 2);
}
function $61de1ee1cac498ae$var$z0b() {
    $61de1ee1cac498ae$var$z0b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$w0b = new $61de1ee1cac498ae$var$m1b;
    $61de1ee1cac498ae$var$u0b = new $61de1ee1cac498ae$var$h1b;
    $61de1ee1cac498ae$var$v0b = new $61de1ee1cac498ae$var$q1b;
    $61de1ee1cac498ae$var$t0b = new $61de1ee1cac498ae$var$u1b;
    $61de1ee1cac498ae$var$x0b = new $61de1ee1cac498ae$var$y1b;
    $61de1ee1cac498ae$var$y0b = new $61de1ee1cac498ae$var$C1b;
}
function $61de1ee1cac498ae$var$J9b(a) {
    var b, c, d;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$olb(a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 29);
        b.p = d;
        ++d;
    }
}
function $61de1ee1cac498ae$var$nfd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$sfd(a);
    return $61de1ee1cac498ae$var$mfd(new $61de1ee1cac498ae$var$f7c(c.c, c.d), new $61de1ee1cac498ae$var$f7c(c.b, c.a), a.rf(), b, a.Hf());
}
function $61de1ee1cac498ae$var$Udd(a, b) {
    var c;
    if (a.b) return null;
    else {
        c = $61de1ee1cac498ae$var$Pdd(a, a.g);
        $61de1ee1cac498ae$var$Dsb(a.a, c);
        c.i = a;
        a.d = b;
        return c;
    }
}
function $61de1ee1cac498ae$var$kUc(a, b, c) {
    $61de1ee1cac498ae$var$Odd(c, "DFS Treeifying phase", 1);
    $61de1ee1cac498ae$var$jUc(a, b);
    $61de1ee1cac498ae$var$hUc(a, b);
    a.a = null;
    a.b = null;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$zic(a, b, c) {
    this.g = a;
    this.d = b;
    this.e = c;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$xic(this);
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(this.a, null);
}
function $61de1ee1cac498ae$var$Aud(a) {
    this.i = a.gc();
    if (this.i > 0) {
        this.g = this.ri(this.i + (this.i / 8 | 0) + 1);
        a.Qc(this.g);
    }
}
function $61de1ee1cac498ae$var$u3d(a, b) {
    $61de1ee1cac498ae$var$k2d.call(this, $61de1ee1cac498ae$var$D9, a, b);
    this.b = this;
    this.a = $61de1ee1cac498ae$var$S6d(a.Tg(), $61de1ee1cac498ae$var$XKd(this.e.Tg(), this.c));
}
function $61de1ee1cac498ae$var$Ld(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$uCb(b);
    for(d = b.vc().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 42);
        a.zc(c.cd(), c.dd());
    }
}
function $61de1ee1cac498ae$var$G2d(a, b, c) {
    var d;
    for(d = c.Kc(); d.Ob();){
        if (!$61de1ee1cac498ae$var$E2d(a, b, d.Pb())) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$sVd(a, b, c, d, e) {
    var f;
    if (c) {
        f = $61de1ee1cac498ae$var$bLd(b.Tg(), a.c);
        e = c.gh(b, -1 - (f == -1 ? d : f), null, e);
    }
    return e;
}
function $61de1ee1cac498ae$var$tVd(a, b, c, d, e) {
    var f;
    if (c) {
        f = $61de1ee1cac498ae$var$bLd(b.Tg(), a.c);
        e = c.ih(b, -1 - (f == -1 ? d : f), null, e);
    }
    return e;
}
function $61de1ee1cac498ae$var$Mgb(a) {
    var b;
    if (a.b == -2) {
        if (a.e == 0) b = -1;
        else {
            for(b = 0; a.a[b] == 0; b++);
        }
        a.b = b;
    }
    return a.b;
}
function $61de1ee1cac498ae$var$Z4b(a) {
    switch(a.g){
        case 2:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd;
        case 4:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd;
        default:
            return a;
    }
}
function $61de1ee1cac498ae$var$$4b(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd;
        case 3:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd;
        default:
            return a;
    }
}
function $61de1ee1cac498ae$var$nkc(a) {
    var b, c, d;
    return a.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) && (b = $61de1ee1cac498ae$var$pkc(a), c = $61de1ee1cac498ae$var$uqb(b, $61de1ee1cac498ae$var$zcd), d = $61de1ee1cac498ae$var$uqb(b, $61de1ee1cac498ae$var$Tcd), d || d && c);
}
function $61de1ee1cac498ae$var$oqb(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$BD(a.e && a.e(), 9);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$ZBb(b, b.length), 9);
    return new $61de1ee1cac498ae$var$xqb(b, c, b.length);
}
function $61de1ee1cac498ae$var$l7b(a, b) {
    $61de1ee1cac498ae$var$Odd(b, $61de1ee1cac498ae$var$zne, 1);
    $61de1ee1cac498ae$var$UGb($61de1ee1cac498ae$var$TGb(new $61de1ee1cac498ae$var$YGb(($61de1ee1cac498ae$var$a$b(), new $61de1ee1cac498ae$var$l$b(a, false, false, new $61de1ee1cac498ae$var$T$b)))));
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$Fcb(a, b) {
    $61de1ee1cac498ae$var$Bcb();
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$cfb(a, $61de1ee1cac498ae$var$GD(b)) : $61de1ee1cac498ae$var$LD(a) ? $61de1ee1cac498ae$var$Ddb(a, $61de1ee1cac498ae$var$ED(b)) : $61de1ee1cac498ae$var$KD(a) ? $61de1ee1cac498ae$var$Dcb(a, $61de1ee1cac498ae$var$DD(b)) : a.wd(b);
}
function $61de1ee1cac498ae$var$WZc(a, b) {
    b.q = a;
    a.d = $61de1ee1cac498ae$var$$wnd.Math.max(a.d, b.r);
    a.b += b.d + (a.a.c.length == 0 ? 0 : a.c);
    $61de1ee1cac498ae$var$Ekb(a.a, b);
}
function $61de1ee1cac498ae$var$m6c(a, b) {
    var c, d, e, f;
    e = a.c;
    c = a.c + a.b;
    f = a.d;
    d = a.d + a.a;
    return b.a > e && b.a < c && b.b > f && b.b < d;
}
function $61de1ee1cac498ae$var$Ynd(a, b, c, d) {
    $61de1ee1cac498ae$var$JD(a.Cb, 179) && ($61de1ee1cac498ae$var$BD(a.Cb, 179).tb = null);
    $61de1ee1cac498ae$var$pnd(a, c);
    !!b && $61de1ee1cac498ae$var$hKd(a, b);
    d && a.xk(true);
}
function $61de1ee1cac498ae$var$Yqd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD(b, 183);
    $61de1ee1cac498ae$var$Spd(c, "x", a.i);
    $61de1ee1cac498ae$var$Spd(c, "y", a.j);
    $61de1ee1cac498ae$var$Spd(c, $61de1ee1cac498ae$var$Gte, a.g);
    $61de1ee1cac498ae$var$Spd(c, $61de1ee1cac498ae$var$Fte, a.f);
}
function $61de1ee1cac498ae$var$LFc() {
    $61de1ee1cac498ae$var$LFc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$KFc = $61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$f3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$z8b)), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$p8b), $61de1ee1cac498ae$var$pUb), $61de1ee1cac498ae$var$y8b);
}
function $61de1ee1cac498ae$var$dHc() {
    $61de1ee1cac498ae$var$dHc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$cHc = $61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$f3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$z8b)), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$p8b), $61de1ee1cac498ae$var$pUb), $61de1ee1cac498ae$var$y8b);
}
function $61de1ee1cac498ae$var$sXc() {
    $61de1ee1cac498ae$var$sXc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qXc = new $61de1ee1cac498ae$var$uXc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$rXc = new $61de1ee1cac498ae$var$uXc("POLAR_COORDINATE", 1);
    $61de1ee1cac498ae$var$pXc = new $61de1ee1cac498ae$var$uXc("ID", 2);
}
function $61de1ee1cac498ae$var$TAc() {
    $61de1ee1cac498ae$var$TAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$QAc = new $61de1ee1cac498ae$var$UAc("EQUALLY", 0);
    $61de1ee1cac498ae$var$RAc = new $61de1ee1cac498ae$var$UAc($61de1ee1cac498ae$var$xle, 1);
    $61de1ee1cac498ae$var$SAc = new $61de1ee1cac498ae$var$UAc("NORTH_SOUTH", 2);
}
function $61de1ee1cac498ae$var$pAc() {
    $61de1ee1cac498ae$var$pAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$oAc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$kAc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$aX, 1), $61de1ee1cac498ae$var$Kie, 260, 0, [
        $61de1ee1cac498ae$var$iAc,
        $61de1ee1cac498ae$var$dAc,
        $61de1ee1cac498ae$var$gAc,
        $61de1ee1cac498ae$var$eAc,
        $61de1ee1cac498ae$var$fAc,
        $61de1ee1cac498ae$var$cAc,
        $61de1ee1cac498ae$var$hAc,
        $61de1ee1cac498ae$var$jAc
    ])));
}
function $61de1ee1cac498ae$var$Flc() {
    $61de1ee1cac498ae$var$Flc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Elc = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Alc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KV, 1), $61de1ee1cac498ae$var$Kie, 270, 0, [
        $61de1ee1cac498ae$var$tlc,
        $61de1ee1cac498ae$var$wlc,
        $61de1ee1cac498ae$var$slc,
        $61de1ee1cac498ae$var$zlc,
        $61de1ee1cac498ae$var$vlc,
        $61de1ee1cac498ae$var$ulc,
        $61de1ee1cac498ae$var$ylc,
        $61de1ee1cac498ae$var$xlc
    ])));
}
function $61de1ee1cac498ae$var$e6c() {
    $61de1ee1cac498ae$var$e6c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$d6c = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$f1, 1), $61de1ee1cac498ae$var$Kie, 277, 0, [
        $61de1ee1cac498ae$var$$5c,
        $61de1ee1cac498ae$var$T5c,
        $61de1ee1cac498ae$var$X5c,
        $61de1ee1cac498ae$var$Z5c,
        $61de1ee1cac498ae$var$U5c,
        $61de1ee1cac498ae$var$V5c,
        $61de1ee1cac498ae$var$W5c,
        $61de1ee1cac498ae$var$Y5c
    ])));
}
function $61de1ee1cac498ae$var$Hsd() {
    $61de1ee1cac498ae$var$Hsd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Gsd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Csd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O3, 1), $61de1ee1cac498ae$var$Kie, 237, 0, [
        $61de1ee1cac498ae$var$Bsd,
        $61de1ee1cac498ae$var$ysd,
        $61de1ee1cac498ae$var$zsd,
        $61de1ee1cac498ae$var$xsd,
        $61de1ee1cac498ae$var$Asd,
        $61de1ee1cac498ae$var$vsd,
        $61de1ee1cac498ae$var$usd,
        $61de1ee1cac498ae$var$wsd
    ])));
}
function $61de1ee1cac498ae$var$XNb() {
    $61de1ee1cac498ae$var$XNb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$VNb = new $61de1ee1cac498ae$var$Msd("debugSVG", ($61de1ee1cac498ae$var$Bcb(), false));
    $61de1ee1cac498ae$var$WNb = new $61de1ee1cac498ae$var$Msd("overlapsExisted", true);
}
function $61de1ee1cac498ae$var$Xyb(a, b) {
    return $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$tzb(a), new $61de1ee1cac498ae$var$vzb(b), new $61de1ee1cac498ae$var$xzb(b), new $61de1ee1cac498ae$var$zzb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, []));
}
function $61de1ee1cac498ae$var$hyb() {
    var a;
    if (!$61de1ee1cac498ae$var$dyb) {
        $61de1ee1cac498ae$var$dyb = new $61de1ee1cac498ae$var$gyb;
        a = new $61de1ee1cac498ae$var$wyb("");
        $61de1ee1cac498ae$var$uyb(a, ($61de1ee1cac498ae$var$$xb(), $61de1ee1cac498ae$var$Zxb));
        $61de1ee1cac498ae$var$eyb($61de1ee1cac498ae$var$dyb, a);
    }
    return $61de1ee1cac498ae$var$dyb;
}
function $61de1ee1cac498ae$var$hr(a, b) {
    var c;
    $61de1ee1cac498ae$var$Qb(b);
    while(a.Ob()){
        c = a.Pb();
        if (!$61de1ee1cac498ae$var$QNc($61de1ee1cac498ae$var$BD(c, 10))) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$T3c(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$h4c($61de1ee1cac498ae$var$n4c(), a);
    if (c) {
        $61de1ee1cac498ae$var$jkd(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$F9c), c);
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$d3c(a, b) {
    var c;
    for(c = 0; c < b.j.c.length; c++)$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$B2c(a, c), 21).Gc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$B2c(b, c), 14));
    return a;
}
function $61de1ee1cac498ae$var$M9b(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$olb(b.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        a.a[c.p] = $61de1ee1cac498ae$var$_$b(c);
    }
}
function $61de1ee1cac498ae$var$stb(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$uCb(b);
    for(d = a.vc().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 42);
        b.Od(c.cd(), c.dd());
    }
}
function $61de1ee1cac498ae$var$cId(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$JD(b, 83)) {
        $61de1ee1cac498ae$var$BD(a.c, 76).Xj();
        c = $61de1ee1cac498ae$var$BD(b, 83);
        $61de1ee1cac498ae$var$IAd(a, c);
    } else $61de1ee1cac498ae$var$BD(a.c, 76).Wb(b);
}
function $61de1ee1cac498ae$var$Su(a) {
    return $61de1ee1cac498ae$var$JD(a, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(a, 152)) : $61de1ee1cac498ae$var$JD(a, 131) ? $61de1ee1cac498ae$var$BD(a, 131).a : $61de1ee1cac498ae$var$JD(a, 54) ? new $61de1ee1cac498ae$var$ov(a) : new $61de1ee1cac498ae$var$dv(a);
}
function $61de1ee1cac498ae$var$fac(a, b) {
    return b < a.b.gc() ? $61de1ee1cac498ae$var$BD(a.b.Xb(b), 10) : b == a.b.gc() ? a.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.e, b - a.b.gc() - 1), 10);
}
function $61de1ee1cac498ae$var$crb(a, b) {
    a.a = $61de1ee1cac498ae$var$wbb(a.a, 1);
    a.c = $61de1ee1cac498ae$var$$wnd.Math.min(a.c, b);
    a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.b, b);
    a.d = $61de1ee1cac498ae$var$wbb(a.d, b);
}
function $61de1ee1cac498ae$var$n3b(a, b) {
    var c;
    $61de1ee1cac498ae$var$Odd(b, "Edge and layer constraint edge reversal", 1);
    c = $61de1ee1cac498ae$var$m3b(a);
    $61de1ee1cac498ae$var$l3b(c);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$tAd(a) {
    var b;
    if (a.d == null) {
        ++a.e;
        a.f = 0;
        $61de1ee1cac498ae$var$sAd(null);
    } else {
        ++a.e;
        b = a.d;
        a.d = null;
        a.f = 0;
        $61de1ee1cac498ae$var$sAd(b);
    }
}
function $61de1ee1cac498ae$var$zbb(a) {
    var b;
    b = a.h;
    if (b == 0) return a.l + a.m * $61de1ee1cac498ae$var$Hje;
    if (b == $61de1ee1cac498ae$var$Fje) return a.l + a.m * $61de1ee1cac498ae$var$Hje - $61de1ee1cac498ae$var$Ije;
    return a;
}
function $61de1ee1cac498ae$var$aKb(a) {
    $61de1ee1cac498ae$var$$Jb();
    if (a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$pdd))) {
        if (!a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Ddd))) return $61de1ee1cac498ae$var$_Jb(a);
    }
    return null;
}
function $61de1ee1cac498ae$var$Zgb(a) {
    $61de1ee1cac498ae$var$uCb(a);
    if (a.length == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb("Zero length BigInteger"));
    $61de1ee1cac498ae$var$dhb(this, a);
}
function $61de1ee1cac498ae$var$Vb(a) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("no calls to next() since the last call to remove()"));
}
function $61de1ee1cac498ae$var$Cbb(a) {
    if ($61de1ee1cac498ae$var$Kje < a && a < $61de1ee1cac498ae$var$Ije) return a < 0 ? $61de1ee1cac498ae$var$$wnd.Math.ceil(a) : $61de1ee1cac498ae$var$$wnd.Math.floor(a);
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$fD(a));
}
function $61de1ee1cac498ae$var$Yyb(a, b) {
    var c, d, e;
    c = a.c.Ee();
    for(e = b.Kc(); e.Ob();){
        d = e.Pb();
        a.a.Od(c, d);
    }
    return a.b.Kb(c);
}
function $61de1ee1cac498ae$var$Uhd(a, b) {
    var c, d, e;
    c = a.Jg();
    if (c != null && a.Mg()) for(d = 0, e = c.length; d < e; ++d)c[d].ui(b);
}
function $61de1ee1cac498ae$var$f_b(a, b) {
    var c, d;
    c = a;
    d = $61de1ee1cac498ae$var$Q_b(c).e;
    while(d){
        c = d;
        if (c == b) return true;
        d = $61de1ee1cac498ae$var$Q_b(c).e;
    }
    return false;
}
function $61de1ee1cac498ae$var$lDc(a, b, c) {
    var d, e;
    d = a.a.f[b.p];
    e = a.a.f[c.p];
    if (d < e) return -1;
    if (d == e) return 0;
    return 1;
}
function $61de1ee1cac498ae$var$Si(a, b, c) {
    var d, e;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$tn(a.d, b), 19);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$tn(a.b, c), 19);
    return !e || !d ? null : $61de1ee1cac498ae$var$Mi(a, e.a, d.a);
}
function $61de1ee1cac498ae$var$cYc(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$Fyd(a); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 33);
        $61de1ee1cac498ae$var$bld(c, c.i + b.b, c.j + b.d);
    }
}
function $61de1ee1cac498ae$var$qjc(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 70);
        $61de1ee1cac498ae$var$Ekb(a.d, c);
        $61de1ee1cac498ae$var$ujc(a, c);
    }
}
function $61de1ee1cac498ae$var$pQc(a, b) {
    var c, d;
    d = new $61de1ee1cac498ae$var$Rkb;
    c = b;
    do {
        d.c[d.c.length] = c;
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.k, c), 17);
    }while (c);
    return d;
}
function $61de1ee1cac498ae$var$Ajd(a, b) {
    var c;
    if ((a.Db & b) != 0) {
        c = $61de1ee1cac498ae$var$zjd(a, b);
        return c == -1 ? a.Eb : $61de1ee1cac498ae$var$CD(a.Eb)[c];
    } else return null;
}
function $61de1ee1cac498ae$var$Lnd(a, b) {
    var c, d;
    c = (d = new $61de1ee1cac498ae$var$hLd, d);
    c.G = b;
    !a.rb && (a.rb = new $61de1ee1cac498ae$var$jUd(a, $61de1ee1cac498ae$var$d5, a));
    $61de1ee1cac498ae$var$wtd(a.rb, c);
    return c;
}
function $61de1ee1cac498ae$var$Mnd(a, b) {
    var c, d;
    c = (d = new $61de1ee1cac498ae$var$MPd, d);
    c.G = b;
    !a.rb && (a.rb = new $61de1ee1cac498ae$var$jUd(a, $61de1ee1cac498ae$var$d5, a));
    $61de1ee1cac498ae$var$wtd(a.rb, c);
    return c;
}
function $61de1ee1cac498ae$var$Hkd(a, b) {
    switch(b){
        case 1:
            return !!a.n && a.n.i != 0;
        case 2:
            return a.k != null;
    }
    return $61de1ee1cac498ae$var$dkd(a, b);
}
function $61de1ee1cac498ae$var$gNc(a) {
    switch(a.a.g){
        case 1:
            return new $61de1ee1cac498ae$var$NNc;
        case 3:
            return new $61de1ee1cac498ae$var$vQc;
        default:
            return new $61de1ee1cac498ae$var$wNc;
    }
}
function $61de1ee1cac498ae$var$MRd(a) {
    var b;
    if (a.g > 1 || a.Ob()) {
        ++a.a;
        a.g = 0;
        b = a.i;
        a.Ob();
        return b;
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
}
function $61de1ee1cac498ae$var$kNc(a) {
    $61de1ee1cac498ae$var$fNc();
    var b;
    if (!$61de1ee1cac498ae$var$Lpb($61de1ee1cac498ae$var$eNc, a)) {
        b = new $61de1ee1cac498ae$var$hNc;
        b.a = a;
        $61de1ee1cac498ae$var$Opb($61de1ee1cac498ae$var$eNc, a, b);
    }
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb($61de1ee1cac498ae$var$eNc, a), 635);
}
function $61de1ee1cac498ae$var$Rbb(a) {
    var b, c, d, e;
    e = a;
    d = 0;
    if (e < 0) {
        e += $61de1ee1cac498ae$var$Ije;
        d = $61de1ee1cac498ae$var$Fje;
    }
    c = $61de1ee1cac498ae$var$QD(e / $61de1ee1cac498ae$var$Hje);
    b = $61de1ee1cac498ae$var$QD(e - c * $61de1ee1cac498ae$var$Hje);
    return $61de1ee1cac498ae$var$TC(b, c, d);
}
function $61de1ee1cac498ae$var$Ox(a) {
    var b, c, d;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Gqb(a.a); c.a < c.c.a.length;){
        b = $61de1ee1cac498ae$var$Fqb(c);
        a.b.Hc(b) && ++d;
    }
    return d;
}
function $61de1ee1cac498ae$var$Ku(a) {
    var b, c, d;
    b = 1;
    for(d = a.Kc(); d.Ob();){
        c = d.Pb();
        b = 31 * b + (c == null ? 0 : $61de1ee1cac498ae$var$tb(c));
        b = ~~b;
    }
    return b;
}
function $61de1ee1cac498ae$var$Zwb(a, b) {
    var c;
    this.c = a;
    c = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Ewb(a, c, b, a.b, null, false, null, false);
    this.a = new $61de1ee1cac498ae$var$Bib(c, 0);
}
function $61de1ee1cac498ae$var$p4d(a, b) {
    this.b = a;
    this.e = b;
    this.d = b.j;
    this.f = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(a, 66).Oj());
    this.k = $61de1ee1cac498ae$var$S6d(b.e.Tg(), a);
}
function $61de1ee1cac498ae$var$xwb(a, b, c) {
    this.b = ($61de1ee1cac498ae$var$uCb(a), a);
    this.d = ($61de1ee1cac498ae$var$uCb(b), b);
    this.e = ($61de1ee1cac498ae$var$uCb(c), c);
    this.c = this.d + ("" + this.e);
}
function $61de1ee1cac498ae$var$xRb() {
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ksd(($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$eSb)), 19).a;
    this.c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$uSb)));
    this.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$qSb)));
}
function $61de1ee1cac498ae$var$Nbd() {
    $61de1ee1cac498ae$var$Nbd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Mbd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Hbd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
        $61de1ee1cac498ae$var$zbd,
        $61de1ee1cac498ae$var$ybd,
        $61de1ee1cac498ae$var$Bbd,
        $61de1ee1cac498ae$var$Gbd,
        $61de1ee1cac498ae$var$Fbd,
        $61de1ee1cac498ae$var$Ebd,
        $61de1ee1cac498ae$var$Cbd,
        $61de1ee1cac498ae$var$Dbd,
        $61de1ee1cac498ae$var$Abd
    ])));
}
function $61de1ee1cac498ae$var$wFb() {
    $61de1ee1cac498ae$var$wFb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vFb = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$rFb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$dN, 1), $61de1ee1cac498ae$var$Kie, 250, 0, [
        $61de1ee1cac498ae$var$qFb,
        $61de1ee1cac498ae$var$lFb,
        $61de1ee1cac498ae$var$mFb,
        $61de1ee1cac498ae$var$kFb,
        $61de1ee1cac498ae$var$oFb,
        $61de1ee1cac498ae$var$pFb,
        $61de1ee1cac498ae$var$nFb,
        $61de1ee1cac498ae$var$jFb,
        $61de1ee1cac498ae$var$iFb
    ])));
}
function $61de1ee1cac498ae$var$vLb() {
    $61de1ee1cac498ae$var$vLb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$uLb = new $61de1ee1cac498ae$var$wLb("UP", 0);
    $61de1ee1cac498ae$var$rLb = new $61de1ee1cac498ae$var$wLb($61de1ee1cac498ae$var$vle, 1);
    $61de1ee1cac498ae$var$sLb = new $61de1ee1cac498ae$var$wLb($61de1ee1cac498ae$var$jle, 2);
    $61de1ee1cac498ae$var$tLb = new $61de1ee1cac498ae$var$wLb($61de1ee1cac498ae$var$kle, 3);
}
function $61de1ee1cac498ae$var$rTc() {
    $61de1ee1cac498ae$var$rTc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qTc = ($61de1ee1cac498ae$var$STc(), $61de1ee1cac498ae$var$QTc);
    $61de1ee1cac498ae$var$pTc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Zqe, $61de1ee1cac498ae$var$qTc);
    $61de1ee1cac498ae$var$oTc = ($61de1ee1cac498ae$var$$Tc(), $61de1ee1cac498ae$var$ZTc);
    $61de1ee1cac498ae$var$nTc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$$qe, $61de1ee1cac498ae$var$oTc);
}
function $61de1ee1cac498ae$var$Xrc() {
    $61de1ee1cac498ae$var$Xrc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Vrc = new $61de1ee1cac498ae$var$Yrc("ONE_SIDED", 0);
    $61de1ee1cac498ae$var$Wrc = new $61de1ee1cac498ae$var$Yrc("TWO_SIDED", 1);
    $61de1ee1cac498ae$var$Urc = new $61de1ee1cac498ae$var$Yrc("OFF", 2);
}
function $61de1ee1cac498ae$var$TQc(a) {
    a.r = new $61de1ee1cac498ae$var$Tqb;
    a.w = new $61de1ee1cac498ae$var$Tqb;
    a.t = new $61de1ee1cac498ae$var$Rkb;
    a.i = new $61de1ee1cac498ae$var$Rkb;
    a.d = new $61de1ee1cac498ae$var$Tqb;
    a.a = new $61de1ee1cac498ae$var$I6c;
    a.c = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$uOc(a) {
    this.n = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$Psb;
    this.j = new $61de1ee1cac498ae$var$Psb;
    this.k = new $61de1ee1cac498ae$var$Rkb;
    this.f = new $61de1ee1cac498ae$var$Rkb;
    this.p = a;
}
function $61de1ee1cac498ae$var$PEc(a, b) {
    if (a.c) {
        $61de1ee1cac498ae$var$QEc(a, b, true);
        $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b, 16)), new $61de1ee1cac498ae$var$bFc(a));
    }
    $61de1ee1cac498ae$var$QEc(a, b, false);
}
function $61de1ee1cac498ae$var$wFc(a, b, c) {
    return a == ($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$qGc) ? new $61de1ee1cac498ae$var$pFc : $61de1ee1cac498ae$var$Cub(b, 1) != 0 ? new $61de1ee1cac498ae$var$iHc(c.length) : new $61de1ee1cac498ae$var$RGc(c.length);
}
function $61de1ee1cac498ae$var$tNb(a, b) {
    var c;
    if (!b) return a;
    c = b.Ve();
    c.dc() || (!a.q ? a.q = new $61de1ee1cac498ae$var$Nqb(c) : $61de1ee1cac498ae$var$Ld(a.q, c));
    return a;
}
function $61de1ee1cac498ae$var$Erb(a, b) {
    var c;
    c = a.a.get(b);
    if (c === undefined) ++a.d;
    else {
        $61de1ee1cac498ae$var$urb(a.a, b);
        --a.c;
        $61de1ee1cac498ae$var$zpb(a.b);
    }
    return c;
}
function $61de1ee1cac498ae$var$UYb(a, b) {
    var c, d, e;
    c = b.p - a.p;
    if (c == 0) {
        d = a.f.a * a.f.b;
        e = b.f.a * b.f.b;
        return $61de1ee1cac498ae$var$Kdb(d, e);
    }
    return c;
}
function $61de1ee1cac498ae$var$XLb(a, b) {
    var c, d;
    c = a.f.c.length;
    d = b.f.c.length;
    if (c < d) return -1;
    if (c == d) return 0;
    return 1;
}
function $61de1ee1cac498ae$var$KZb(a) {
    if (a.b.c.length != 0 && !!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, 0), 70).a) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, 0), 70).a;
    return $61de1ee1cac498ae$var$JZb(a);
}
function $61de1ee1cac498ae$var$Pq(a) {
    var b;
    if (a) {
        b = a;
        if (b.dc()) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
        return b.Xb(b.gc() - 1);
    }
    return $61de1ee1cac498ae$var$nr(a.Kc());
}
function $61de1ee1cac498ae$var$vgb(a) {
    var b;
    $61de1ee1cac498ae$var$ybb(a, 0) < 0 && (a = $61de1ee1cac498ae$var$Lbb(a));
    return b = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Obb(a, 32)), 64 - (b != 0 ? $61de1ee1cac498ae$var$heb(b) : $61de1ee1cac498ae$var$heb($61de1ee1cac498ae$var$Tbb(a)) + 32);
}
function $61de1ee1cac498ae$var$QNc(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
    return a.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) && (b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) || b == $61de1ee1cac498ae$var$zcd);
}
function $61de1ee1cac498ae$var$bZb(a, b, c) {
    var d, e;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
    if (e) {
        d = new $61de1ee1cac498ae$var$s7c;
        $61de1ee1cac498ae$var$o7c(d, 0, e);
        $61de1ee1cac498ae$var$q7c(d, c);
        $61de1ee1cac498ae$var$ye(b, d);
    }
}
function $61de1ee1cac498ae$var$M_b(a, b, c) {
    var d, e, f, g;
    g = $61de1ee1cac498ae$var$Q_b(a);
    d = g.d;
    e = g.c;
    f = a.n;
    b && (f.a = f.a - d.b - e.a);
    c && (f.b = f.b - d.d - e.b);
}
function $61de1ee1cac498ae$var$dcc(a, b) {
    var c, d;
    c = a.j;
    d = b.j;
    return c != d ? c.g - d.g : a.p == b.p ? 0 : c == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? a.p - b.p : b.p - a.p;
}
function $61de1ee1cac498ae$var$dmc(a) {
    var b, c;
    $61de1ee1cac498ae$var$bmc(a);
    for(c = new $61de1ee1cac498ae$var$olb(a.d); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 101);
        !!b.i && $61de1ee1cac498ae$var$cmc(b);
    }
}
function $61de1ee1cac498ae$var$lBc(a, b, c, d, e) {
    $61de1ee1cac498ae$var$NC(a.c[b.g], c.g, d);
    $61de1ee1cac498ae$var$NC(a.c[c.g], b.g, d);
    $61de1ee1cac498ae$var$NC(a.b[b.g], c.g, e);
    $61de1ee1cac498ae$var$NC(a.b[c.g], b.g, e);
}
function $61de1ee1cac498ae$var$G1c(a, b, c, d) {
    $61de1ee1cac498ae$var$BD(c.b, 65);
    $61de1ee1cac498ae$var$BD(c.b, 65);
    $61de1ee1cac498ae$var$BD(d.b, 65);
    $61de1ee1cac498ae$var$BD(d.b, 65);
    $61de1ee1cac498ae$var$BD(d.b, 65);
    $61de1ee1cac498ae$var$Hkb(d.a, new $61de1ee1cac498ae$var$L1c(a, b, d));
}
function $61de1ee1cac498ae$var$WDb(a, b) {
    a.d == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad) || a.d == $61de1ee1cac498ae$var$dad ? $61de1ee1cac498ae$var$BD(b.a, 57).c.Fc($61de1ee1cac498ae$var$BD(b.b, 57)) : $61de1ee1cac498ae$var$BD(b.b, 57).c.Fc($61de1ee1cac498ae$var$BD(b.a, 57));
}
function $61de1ee1cac498ae$var$Gkd(a, b, c, d) {
    if (c == 1) return !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), $61de1ee1cac498ae$var$Txd(a.n, b, d);
    return $61de1ee1cac498ae$var$ckd(a, b, c, d);
}
function $61de1ee1cac498ae$var$Gnd(a, b) {
    var c, d;
    d = (c = new $61de1ee1cac498ae$var$BYd, c);
    $61de1ee1cac498ae$var$pnd(d, b);
    $61de1ee1cac498ae$var$wtd((!a.A && (a.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, a, 7)), a.A), d);
    return d;
}
function $61de1ee1cac498ae$var$Zqd(a, b, c) {
    var d, e, f, g;
    f = null;
    g = b;
    e = $61de1ee1cac498ae$var$Ypd(g, $61de1ee1cac498ae$var$Jte);
    d = new $61de1ee1cac498ae$var$jrd(a, c);
    f = ($61de1ee1cac498ae$var$lqd(d.a, d.b, e), e);
    return f;
}
function $61de1ee1cac498ae$var$KJd(a) {
    var b;
    if (!a.a || (a.Bb & 1) == 0 && a.a.kh()) {
        b = $61de1ee1cac498ae$var$wId(a);
        $61de1ee1cac498ae$var$JD(b, 148) && (a.a = $61de1ee1cac498ae$var$BD(b, 148));
    }
    return a.a;
}
function $61de1ee1cac498ae$var$Be(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$uCb(b);
    for(d = b.Kc(); d.Ob();){
        c = d.Pb();
        if (!a.Hc(c)) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$cD(a, b) {
    var c, d, e;
    c = a.l + b.l;
    d = a.m + b.m + (c >> 22);
    e = a.h + b.h + (d >> 22);
    return $61de1ee1cac498ae$var$TC(c & $61de1ee1cac498ae$var$Eje, d & $61de1ee1cac498ae$var$Eje, e & $61de1ee1cac498ae$var$Fje);
}
function $61de1ee1cac498ae$var$nD(a, b) {
    var c, d, e;
    c = a.l - b.l;
    d = a.m - b.m + (c >> 22);
    e = a.h - b.h + (d >> 22);
    return $61de1ee1cac498ae$var$TC(c & $61de1ee1cac498ae$var$Eje, d & $61de1ee1cac498ae$var$Eje, e & $61de1ee1cac498ae$var$Fje);
}
function $61de1ee1cac498ae$var$bdb(a) {
    var b;
    if (a < 128) {
        b = ($61de1ee1cac498ae$var$ddb(), $61de1ee1cac498ae$var$cdb)[a];
        !b && (b = $61de1ee1cac498ae$var$cdb[a] = new $61de1ee1cac498ae$var$Xcb(a));
        return b;
    }
    return new $61de1ee1cac498ae$var$Xcb(a);
}
function $61de1ee1cac498ae$var$ubb(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 78)) return a;
    b = a && a.__java$exception;
    if (!b) {
        b = new $61de1ee1cac498ae$var$lz(a);
        $61de1ee1cac498ae$var$Sz(b);
    }
    return b;
}
function $61de1ee1cac498ae$var$btd(a) {
    if ($61de1ee1cac498ae$var$JD(a, 186)) return $61de1ee1cac498ae$var$BD(a, 118);
    else if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb($61de1ee1cac498ae$var$gue));
    else return null;
}
function $61de1ee1cac498ae$var$Zjb(a, b) {
    if (b == null) return false;
    while(a.a != a.b){
        if ($61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$vkb(a))) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$kib(a) {
    if (a.a.Ob()) return true;
    if (a.a != a.d) return false;
    a.a = new $61de1ee1cac498ae$var$orb(a.e.f);
    return a.a.Ob();
}
function $61de1ee1cac498ae$var$Gkb(a, b) {
    var c, d;
    c = b.Pc();
    d = c.length;
    if (d == 0) return false;
    $61de1ee1cac498ae$var$bCb(a.c, a.c.length, c);
    return true;
}
function $61de1ee1cac498ae$var$Vyb(a, b, c) {
    var d, e;
    for(e = b.vc().Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 42);
        a.yc(d.cd(), d.dd(), c);
    }
    return a;
}
function $61de1ee1cac498ae$var$yac(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 70);
        $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ssc), b);
    }
}
function $61de1ee1cac498ae$var$FZc(a, b, c) {
    var d, e;
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 33);
        $61de1ee1cac498ae$var$bld(d, d.i + b, d.j + c);
    }
}
function $61de1ee1cac498ae$var$Nb(a, b) {
    if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$hc("value already present: %s", $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        b
    ]))));
}
function $61de1ee1cac498ae$var$mEb(a, b) {
    if (!a || !b || a == b) return false;
    return $61de1ee1cac498ae$var$CDb(a.d.c, b.d.c + b.d.b) && $61de1ee1cac498ae$var$CDb(b.d.c, a.d.c + a.d.b);
}
function $61de1ee1cac498ae$var$xyb() {
    $61de1ee1cac498ae$var$oyb();
    if ($61de1ee1cac498ae$var$lyb) return new $61de1ee1cac498ae$var$wyb(null);
    return $61de1ee1cac498ae$var$fyb($61de1ee1cac498ae$var$hyb(), "com.google.common.base.Strings");
}
function $61de1ee1cac498ae$var$J2c(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Pu(b.a.gc());
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$VAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b, 1)), a.i), new $61de1ee1cac498ae$var$W2c(a, c));
    return c;
}
function $61de1ee1cac498ae$var$Hnd(a) {
    var b, c;
    c = (b = new $61de1ee1cac498ae$var$BYd, b);
    $61de1ee1cac498ae$var$pnd(c, "T");
    $61de1ee1cac498ae$var$wtd((!a.d && (a.d = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, a, 11)), a.d), c);
    return c;
}
function $61de1ee1cac498ae$var$Etd(a) {
    var b, c, d, e;
    b = 1;
    for(c = 0, e = a.gc(); c < e; ++c){
        d = a.ki(c);
        b = 31 * b + (d == null ? 0 : $61de1ee1cac498ae$var$tb(d));
    }
    return b;
}
function $61de1ee1cac498ae$var$Wi(a, b, c, d) {
    var e;
    $61de1ee1cac498ae$var$Pb(b, a.e.Hd().gc());
    $61de1ee1cac498ae$var$Pb(c, a.c.Hd().gc());
    e = a.a[b][c];
    $61de1ee1cac498ae$var$NC(a.a[b], c, d);
    return e;
}
function $61de1ee1cac498ae$var$OC(a, b, c, d, e) {
    e.gm = a;
    e.hm = b;
    e.im = $61de1ee1cac498ae$var$gcb;
    e.__elementTypeId$ = c;
    e.__elementTypeCategory$ = d;
    return e;
}
function $61de1ee1cac498ae$var$p6c(a, b, c, d, e) {
    $61de1ee1cac498ae$var$i6c();
    return $61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$A6c(a, b, c, d, e), $61de1ee1cac498ae$var$A6c(c, d, a, b, $61de1ee1cac498ae$var$V6c(new $61de1ee1cac498ae$var$f7c(e.a, e.b))));
}
function $61de1ee1cac498ae$var$gbc() {
    $61de1ee1cac498ae$var$gbc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$fbc = new $61de1ee1cac498ae$var$ibc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$dbc = new $61de1ee1cac498ae$var$ibc($61de1ee1cac498ae$var$Gne, 1);
    $61de1ee1cac498ae$var$ebc = new $61de1ee1cac498ae$var$ibc($61de1ee1cac498ae$var$Hne, 2);
    $61de1ee1cac498ae$var$cbc = new $61de1ee1cac498ae$var$ibc("BOTH", 3);
}
function $61de1ee1cac498ae$var$Ajc() {
    $61de1ee1cac498ae$var$Ajc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$wjc = new $61de1ee1cac498ae$var$Bjc($61de1ee1cac498ae$var$gle, 0);
    $61de1ee1cac498ae$var$xjc = new $61de1ee1cac498ae$var$Bjc($61de1ee1cac498ae$var$jle, 1);
    $61de1ee1cac498ae$var$yjc = new $61de1ee1cac498ae$var$Bjc($61de1ee1cac498ae$var$kle, 2);
    $61de1ee1cac498ae$var$zjc = new $61de1ee1cac498ae$var$Bjc("TOP", 3);
}
function $61de1ee1cac498ae$var$lWb() {
    $61de1ee1cac498ae$var$lWb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$hWb = new $61de1ee1cac498ae$var$oWb("Q1", 0);
    $61de1ee1cac498ae$var$kWb = new $61de1ee1cac498ae$var$oWb("Q4", 1);
    $61de1ee1cac498ae$var$iWb = new $61de1ee1cac498ae$var$oWb("Q2", 2);
    $61de1ee1cac498ae$var$jWb = new $61de1ee1cac498ae$var$oWb("Q3", 3);
}
function $61de1ee1cac498ae$var$LBc() {
    $61de1ee1cac498ae$var$LBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$JBc = new $61de1ee1cac498ae$var$MBc("OFF", 0);
    $61de1ee1cac498ae$var$KBc = new $61de1ee1cac498ae$var$MBc("SINGLE_EDGE", 1);
    $61de1ee1cac498ae$var$IBc = new $61de1ee1cac498ae$var$MBc("MULTI_EDGE", 2);
}
function $61de1ee1cac498ae$var$a1c() {
    $61de1ee1cac498ae$var$a1c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$_0c = new $61de1ee1cac498ae$var$c1c("MINIMUM_SPANNING_TREE", 0);
    $61de1ee1cac498ae$var$$0c = new $61de1ee1cac498ae$var$c1c("MAXIMUM_SPANNING_TREE", 1);
}
function $61de1ee1cac498ae$var$Y1c() {
    $61de1ee1cac498ae$var$Y1c = $61de1ee1cac498ae$var$ccb;
    new $61de1ee1cac498ae$var$Lsd("org.eclipse.elk.addLayoutConfig");
    $61de1ee1cac498ae$var$W1c = new $61de1ee1cac498ae$var$k2c;
    $61de1ee1cac498ae$var$V1c = new $61de1ee1cac498ae$var$f2c;
    $61de1ee1cac498ae$var$X1c = new $61de1ee1cac498ae$var$i2c;
}
function $61de1ee1cac498ae$var$URc(a) {
    var b, c, d;
    b = new $61de1ee1cac498ae$var$Psb;
    for(d = $61de1ee1cac498ae$var$Jsb(a.d, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 188);
        $61de1ee1cac498ae$var$Dsb(b, c.c);
    }
    return b;
}
function $61de1ee1cac498ae$var$dVc(a) {
    var b, c, d, e;
    e = new $61de1ee1cac498ae$var$Rkb;
    for(d = a.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 33);
        b = $61de1ee1cac498ae$var$gVc(c);
        $61de1ee1cac498ae$var$Gkb(e, b);
    }
    return e;
}
function $61de1ee1cac498ae$var$xcc(a) {
    var b;
    $61de1ee1cac498ae$var$PZb(a, true);
    b = $61de1ee1cac498ae$var$_ie;
    $61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$cyc)) && (b += $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$cyc), 19).a);
    $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$cyc, $61de1ee1cac498ae$var$meb(b));
}
function $61de1ee1cac498ae$var$q1c(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$Uhb(a.a);
    $61de1ee1cac498ae$var$Hkb(c.i, new $61de1ee1cac498ae$var$B1c(a));
    d = new $61de1ee1cac498ae$var$hDb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, b.b), 65));
    $61de1ee1cac498ae$var$p1c(a, d, b);
    c.f = d;
}
function $61de1ee1cac498ae$var$QLc(a, b) {
    var c, d;
    c = a.c;
    d = b.e[a.p];
    if (d < c.a.c.length - 1) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.a, d + 1), 10);
    return null;
}
function $61de1ee1cac498ae$var$rr(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$Rb(b, "predicate");
    for(d = 0; a.Ob(); d++){
        c = a.Pb();
        if (b.Lb(c)) return d;
    }
    return -1;
}
function $61de1ee1cac498ae$var$ZEd(a, b) {
    var c, d;
    d = 0;
    if (a < 64 && a <= b) {
        b = b < 64 ? b : 63;
        for(c = a; c <= b; c++)d = $61de1ee1cac498ae$var$Mbb(d, $61de1ee1cac498ae$var$Nbb(1, c));
    }
    return d;
}
function $61de1ee1cac498ae$var$pmb(a) {
    $61de1ee1cac498ae$var$mmb();
    var b, c, d;
    d = 0;
    for(c = a.Kc(); c.Ob();){
        b = c.Pb();
        d = d + (b != null ? $61de1ee1cac498ae$var$tb(b) : 0);
        d = d | 0;
    }
    return d;
}
function $61de1ee1cac498ae$var$etd(a) {
    var b, c;
    c = ($61de1ee1cac498ae$var$Fhd(), b = new $61de1ee1cac498ae$var$rmd, b);
    !!a && $61de1ee1cac498ae$var$wtd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a), c);
    return c;
}
function $61de1ee1cac498ae$var$TA(a) {
    var b;
    b = new $61de1ee1cac498ae$var$PA;
    b.a = a;
    b.b = $61de1ee1cac498ae$var$RA(a);
    b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, 2, 6, 1);
    b.c[0] = $61de1ee1cac498ae$var$SA(a);
    b.c[1] = $61de1ee1cac498ae$var$SA(a);
    return b;
}
function $61de1ee1cac498ae$var$fkd(a, b) {
    switch(b){
        case 0:
            !a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0));
            a.o.c.$b();
            return;
    }
    $61de1ee1cac498ae$var$Cid(a, b);
}
function $61de1ee1cac498ae$var$jEb(a, b, c) {
    switch(c.g){
        case 2:
            a.b = b;
            break;
        case 1:
            a.c = b;
            break;
        case 4:
            a.d = b;
            break;
        case 3:
            a.a = b;
    }
}
function $61de1ee1cac498ae$var$sbd(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$obd;
        case 2:
            return $61de1ee1cac498ae$var$nbd;
        case 3:
            return $61de1ee1cac498ae$var$pbd;
        default:
            return $61de1ee1cac498ae$var$qbd;
    }
}
function $61de1ee1cac498ae$var$Zac(a) {
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163).g){
        case 2:
        case 4:
            return true;
        default:
            return false;
    }
}
function $61de1ee1cac498ae$var$Trc() {
    $61de1ee1cac498ae$var$Trc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Src = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PW, 1), $61de1ee1cac498ae$var$Kie, 256, 0, [
        $61de1ee1cac498ae$var$Frc,
        $61de1ee1cac498ae$var$Hrc,
        $61de1ee1cac498ae$var$Irc,
        $61de1ee1cac498ae$var$Jrc,
        $61de1ee1cac498ae$var$Krc,
        $61de1ee1cac498ae$var$Lrc,
        $61de1ee1cac498ae$var$Nrc,
        $61de1ee1cac498ae$var$Erc,
        $61de1ee1cac498ae$var$Grc,
        $61de1ee1cac498ae$var$Mrc
    ])));
}
function $61de1ee1cac498ae$var$Ndd() {
    $61de1ee1cac498ae$var$Ndd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Mdd = $61de1ee1cac498ae$var$as(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$J1, 1), $61de1ee1cac498ae$var$Kie, 259, 0, [
        $61de1ee1cac498ae$var$Bdd,
        $61de1ee1cac498ae$var$Ddd,
        $61de1ee1cac498ae$var$Add,
        $61de1ee1cac498ae$var$Edd,
        $61de1ee1cac498ae$var$Fdd,
        $61de1ee1cac498ae$var$Hdd,
        $61de1ee1cac498ae$var$Gdd,
        $61de1ee1cac498ae$var$Cdd,
        $61de1ee1cac498ae$var$zdd
    ])));
}
function $61de1ee1cac498ae$var$wUc() {
    $61de1ee1cac498ae$var$wUc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$vUc = $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$g3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$yRc(), $61de1ee1cac498ae$var$vRc), ($61de1ee1cac498ae$var$qSc(), $61de1ee1cac498ae$var$pSc)), $61de1ee1cac498ae$var$wRc), $61de1ee1cac498ae$var$mSc), $61de1ee1cac498ae$var$nSc), $61de1ee1cac498ae$var$xRc, $61de1ee1cac498ae$var$oSc);
}
function $61de1ee1cac498ae$var$Gqc() {
    $61de1ee1cac498ae$var$Gqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Eqc = new $61de1ee1cac498ae$var$Hqc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$Dqc = new $61de1ee1cac498ae$var$Hqc("INCOMING_ONLY", 1);
    $61de1ee1cac498ae$var$Fqc = new $61de1ee1cac498ae$var$Hqc("OUTGOING_ONLY", 2);
}
function $61de1ee1cac498ae$var$rC() {
    $61de1ee1cac498ae$var$rC = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qC = {
        "boolean": $61de1ee1cac498ae$var$sC,
        "number": $61de1ee1cac498ae$var$tC,
        "string": $61de1ee1cac498ae$var$vC,
        "object": $61de1ee1cac498ae$var$uC,
        "function": $61de1ee1cac498ae$var$uC,
        "undefined": $61de1ee1cac498ae$var$wC
    };
}
function $61de1ee1cac498ae$var$Whb(a, b) {
    $61de1ee1cac498ae$var$mCb(a >= 0, "Negative initial capacity");
    $61de1ee1cac498ae$var$mCb(b >= 0, "Non-positive load factor");
    $61de1ee1cac498ae$var$Uhb(this);
}
function $61de1ee1cac498ae$var$_Ed(a, b, c) {
    if (a >= 128) return false;
    return a < 64 ? $61de1ee1cac498ae$var$Kbb($61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Nbb(1, a), c), 0) : $61de1ee1cac498ae$var$Kbb($61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Nbb(1, a - 64), b), 0);
}
function $61de1ee1cac498ae$var$bOb(a, b) {
    if (!a || !b || a == b) return false;
    return $61de1ee1cac498ae$var$Jy(a.b.c, b.b.c + b.b.b) < 0 && $61de1ee1cac498ae$var$Jy(b.b.c, a.b.c + a.b.b) < 0;
}
function $61de1ee1cac498ae$var$I4b(a) {
    var b, c, d;
    c = a.n;
    d = a.o;
    b = a.d;
    return new $61de1ee1cac498ae$var$J6c(c.a - b.b, c.b - b.d, d.a + (b.b + b.c), d.b + (b.d + b.a));
}
function $61de1ee1cac498ae$var$$ic(a) {
    var b, c, d, e;
    for(c = a.a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$djc(a, b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd));
        $61de1ee1cac498ae$var$djc(a, b, $61de1ee1cac498ae$var$Acd);
    }
}
function $61de1ee1cac498ae$var$Uy(a) {
    var b, c, d, e;
    for(b = (a.j == null && (a.j = ($61de1ee1cac498ae$var$Rz(), e = $61de1ee1cac498ae$var$Qz.ce(a), $61de1ee1cac498ae$var$Tz(e))), a.j), c = 0, d = b.length; c < d; ++c);
}
function $61de1ee1cac498ae$var$hD(a) {
    var b, c, d;
    b = ~a.l + 1 & $61de1ee1cac498ae$var$Eje;
    c = ~a.m + (b == 0 ? 1 : 0) & $61de1ee1cac498ae$var$Eje;
    d = ~a.h + (b == 0 && c == 0 ? 1 : 0) & $61de1ee1cac498ae$var$Fje;
    return $61de1ee1cac498ae$var$TC(b, c, d);
}
function $61de1ee1cac498ae$var$C$c(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b.a), 46).a, 65);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b.b), 46).a, 65);
    return $61de1ee1cac498ae$var$_Nb(c, d);
}
function $61de1ee1cac498ae$var$xtd(a, b, c) {
    var d;
    d = a.gc();
    if (b > d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(b, d));
    a.hi() && (c = $61de1ee1cac498ae$var$Dtd(a, c));
    return a.Vh(b, c);
}
function $61de1ee1cac498ae$var$xNb(a, b, c) {
    return c == null ? (!a.q && (a.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Thb(a.q, b)) : (!a.q && (a.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Rhb(a.q, b, c)), a;
}
function $61de1ee1cac498ae$var$yNb(a, b, c) {
    c == null ? (!a.q && (a.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Thb(a.q, b)) : (!a.q && (a.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Rhb(a.q, b, c));
    return a;
}
function $61de1ee1cac498ae$var$TQb(a) {
    var b, c;
    c = new $61de1ee1cac498ae$var$kRb;
    $61de1ee1cac498ae$var$tNb(c, a);
    $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$FSb), a);
    b = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$VQb(a, c, b);
    $61de1ee1cac498ae$var$UQb(a, c, b);
    return c;
}
function $61de1ee1cac498ae$var$j6c(a) {
    $61de1ee1cac498ae$var$i6c();
    var b, c, d;
    c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$m1, $61de1ee1cac498ae$var$nie, 8, 2, 0, 1);
    d = 0;
    for(b = 0; b < 2; b++){
        d += 0.5;
        c[b] = $61de1ee1cac498ae$var$r6c(d, a);
    }
    return c;
}
function $61de1ee1cac498ae$var$Mic(a, b) {
    var c, d, e, f;
    c = false;
    d = a.a[b].length;
    for(f = 0; f < d - 1; f++){
        e = f + 1;
        c = c | $61de1ee1cac498ae$var$Nic(a, b, f, e);
    }
    return c;
}
function $61de1ee1cac498ae$var$nNb(a, b, c, d, e) {
    var f, g;
    for(g = c; g <= e; g++)for(f = b; f <= d; f++)$61de1ee1cac498ae$var$YMb(a, f, g) || $61de1ee1cac498ae$var$aNb(a, f, g, true, false);
}
function $61de1ee1cac498ae$var$rNd(a, b) {
    this.b = a;
    $61de1ee1cac498ae$var$nNd.call(this, ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).o), 10), 18), b.i), b.g);
    this.a = ($61de1ee1cac498ae$var$NKd(), $61de1ee1cac498ae$var$MKd);
}
function $61de1ee1cac498ae$var$hj(a, b) {
    this.c = a;
    this.d = b;
    this.b = this.d / this.c.c.Hd().gc() | 0;
    this.a = this.d % this.c.c.Hd().gc();
}
function $61de1ee1cac498ae$var$jdb() {
    ++$61de1ee1cac498ae$var$edb;
    this.o = null;
    this.k = null;
    this.j = null;
    this.d = null;
    this.b = null;
    this.n = null;
    this.a = null;
}
function $61de1ee1cac498ae$var$fB(a, b, c) {
    this.q = new $61de1ee1cac498ae$var$$wnd.Date;
    this.q.setFullYear(a + $61de1ee1cac498ae$var$nje, b, c);
    this.q.setHours(0, 0, 0, 0);
    $61de1ee1cac498ae$var$YA(this, 0);
}
function $61de1ee1cac498ae$var$tAc() {
    $61de1ee1cac498ae$var$tAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$rAc = new $61de1ee1cac498ae$var$uAc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$qAc = new $61de1ee1cac498ae$var$uAc("NODES_AND_EDGES", 1);
    $61de1ee1cac498ae$var$sAc = new $61de1ee1cac498ae$var$uAc("PREFER_EDGES", 2);
}
function $61de1ee1cac498ae$var$RA(a) {
    var b;
    if (a == 0) return "Etc/GMT";
    if (a < 0) {
        a = -a;
        b = "Etc/GMT-";
    } else b = "Etc/GMT+";
    return b + $61de1ee1cac498ae$var$UA(a);
}
function $61de1ee1cac498ae$var$geb(a) {
    var b;
    if (a < 0) return $61de1ee1cac498ae$var$Rie;
    else if (a == 0) return 0;
    else {
        for(b = $61de1ee1cac498ae$var$Iie; (b & a) == 0; b >>= 1);
        return b;
    }
}
function $61de1ee1cac498ae$var$$C(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$heb(a.h);
    if (c == 32) {
        b = $61de1ee1cac498ae$var$heb(a.m);
        return b == 32 ? $61de1ee1cac498ae$var$heb(a.l) + 32 : b + 20 - 10;
    } else return c - 12;
}
function $61de1ee1cac498ae$var$bkb(a) {
    var b;
    b = a.a[a.b];
    if (b == null) return null;
    $61de1ee1cac498ae$var$NC(a.a, a.b, null);
    a.b = a.b + 1 & a.a.length - 1;
    return b;
}
function $61de1ee1cac498ae$var$EDc(a) {
    var b, c;
    b = a.t - a.k[a.o.p] * a.d + a.j[a.o.p] > a.f;
    c = a.u + a.e[a.o.p] * a.d > a.f * a.s * a.d;
    return b || c;
}
function $61de1ee1cac498ae$var$Iwb(a, b, c) {
    var d, e;
    d = new $61de1ee1cac498ae$var$exb(b, c);
    e = new $61de1ee1cac498ae$var$fxb;
    a.b = $61de1ee1cac498ae$var$Gwb(a, a.b, d, e);
    e.b || ++a.c;
    a.b.b = false;
    return e.d;
}
function $61de1ee1cac498ae$var$djc(a, b, c) {
    var d, e, f, g;
    g = $61de1ee1cac498ae$var$CHc(b, c);
    f = 0;
    for(e = g.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 11);
        $61de1ee1cac498ae$var$Rhb(a.c, d, $61de1ee1cac498ae$var$meb(f++));
    }
}
function $61de1ee1cac498ae$var$xVb(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        b.g.c = -b.g.c - b.g.b;
    }
    $61de1ee1cac498ae$var$sVb(a);
}
function $61de1ee1cac498ae$var$XDb(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        b.d.c = -b.d.c - b.d.b;
    }
    $61de1ee1cac498ae$var$RDb(a);
}
function $61de1ee1cac498ae$var$AUd(a) {
    var b;
    if (!a.c || (a.Bb & 1) == 0 && (a.c.Db & 64) != 0) {
        b = $61de1ee1cac498ae$var$wId(a);
        $61de1ee1cac498ae$var$JD(b, 88) && (a.c = $61de1ee1cac498ae$var$BD(b, 26));
    }
    return a.c;
}
function $61de1ee1cac498ae$var$ZC(a) {
    var b, c, d;
    b = ~a.l + 1 & $61de1ee1cac498ae$var$Eje;
    c = ~a.m + (b == 0 ? 1 : 0) & $61de1ee1cac498ae$var$Eje;
    d = ~a.h + (b == 0 && c == 0 ? 1 : 0) & $61de1ee1cac498ae$var$Fje;
    a.l = b;
    a.m = c;
    a.h = d;
}
function $61de1ee1cac498ae$var$l7c(a) {
    var b, c, d, e, f;
    b = new $61de1ee1cac498ae$var$d7c;
    for(d = a, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        b.a += c.a;
        b.b += c.b;
    }
    return b;
}
function $61de1ee1cac498ae$var$nmb(a, b) {
    $61de1ee1cac498ae$var$mmb();
    var c, d, e, f, g;
    g = false;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        g = g | a.Fc(c);
    }
    return g;
}
function $61de1ee1cac498ae$var$w6c(a) {
    $61de1ee1cac498ae$var$i6c();
    var b, c;
    c = -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000;
    for(b = 0; b < a.length; b++)a[b] > c && (c = a[b]);
    return c;
}
function $61de1ee1cac498ae$var$SHc(a, b, c) {
    var d;
    d = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$UHc(a, b, d, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd), true, false);
    $61de1ee1cac498ae$var$UHc(a, c, d, $61de1ee1cac498ae$var$Tcd, false, false);
    return d;
}
function $61de1ee1cac498ae$var$crd(a, b, c) {
    var d, e, f, g;
    f = null;
    g = b;
    e = $61de1ee1cac498ae$var$Ypd(g, "labels");
    d = new $61de1ee1cac498ae$var$Hrd(a, c);
    f = ($61de1ee1cac498ae$var$Dqd(d.a, d.b, e), e);
    return f;
}
function $61de1ee1cac498ae$var$j1d(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$r1d(a, b, c, d);
    if (!e) {
        e = $61de1ee1cac498ae$var$i1d(a, c, d);
        if (!!e && !$61de1ee1cac498ae$var$e1d(a, b, e)) return null;
    }
    return e;
}
function $61de1ee1cac498ae$var$m1d(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$s1d(a, b, c, d);
    if (!e) {
        e = $61de1ee1cac498ae$var$l1d(a, c, d);
        if (!!e && !$61de1ee1cac498ae$var$e1d(a, b, e)) return null;
    }
    return e;
}
function $61de1ee1cac498ae$var$Xb(a, b) {
    var c;
    for(c = 0; c < a.a.a.length; c++){
        if (!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$$lb(a.a, c), 169).Lb(b)) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$Cb(a, b, c) {
    $61de1ee1cac498ae$var$Qb(b);
    if (c.Ob()) {
        $61de1ee1cac498ae$var$Mfb(b, $61de1ee1cac498ae$var$Fb(c.Pb()));
        while(c.Ob()){
            $61de1ee1cac498ae$var$Mfb(b, a.a);
            $61de1ee1cac498ae$var$Mfb(b, $61de1ee1cac498ae$var$Fb(c.Pb()));
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$qmb(a) {
    $61de1ee1cac498ae$var$mmb();
    var b, c, d;
    d = 1;
    for(c = a.Kc(); c.Ob();){
        b = c.Pb();
        d = 31 * d + (b != null ? $61de1ee1cac498ae$var$tb(b) : 0);
        d = d | 0;
    }
    return d;
}
function $61de1ee1cac498ae$var$WC(a, b, c, d, e) {
    var f;
    f = $61de1ee1cac498ae$var$lD(a, b);
    c && $61de1ee1cac498ae$var$ZC(f);
    if (e) {
        a = $61de1ee1cac498ae$var$YC(a, b);
        d ? $61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$hD(a) : $61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$TC(a.l, a.m, a.h);
    }
    return f;
}
function $61de1ee1cac498ae$var$Xzb(b, c) {
    var d;
    try {
        c.Vd();
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 78)) {
            d = a;
            b.c[b.c.length] = d;
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$jRb(a, b, c) {
    var d, e;
    if ($61de1ee1cac498ae$var$JD(b, 144) && !!c) {
        d = $61de1ee1cac498ae$var$BD(b, 144);
        e = c;
        return a.a[d.b][e.b] + a.a[e.b][d.b];
    }
    return 0;
}
function $61de1ee1cac498ae$var$xld(a, b) {
    switch(b){
        case 7:
            return !!a.e && a.e.i != 0;
        case 8:
            return !!a.d && a.d.i != 0;
    }
    return $61de1ee1cac498ae$var$Ykd(a, b);
}
function $61de1ee1cac498ae$var$YQb(a, b) {
    switch(b.g){
        case 0:
            $61de1ee1cac498ae$var$JD(a.b, 631) || (a.b = new $61de1ee1cac498ae$var$xRb);
            break;
        case 1:
            $61de1ee1cac498ae$var$JD(a.b, 632) || (a.b = new $61de1ee1cac498ae$var$DRb);
    }
}
function $61de1ee1cac498ae$var$Ghe(a, b) {
    while(a.g == null && !a.c ? $61de1ee1cac498ae$var$Uud(a) : a.g == null || a.i != 0 && $61de1ee1cac498ae$var$BD(a.g[a.i - 1], 47).Ob())$61de1ee1cac498ae$var$Ord(b, $61de1ee1cac498ae$var$Vud(a));
}
function $61de1ee1cac498ae$var$kic(a, b, c) {
    a.g = $61de1ee1cac498ae$var$qic(a, b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd), a.b);
    a.d = $61de1ee1cac498ae$var$qic(a, c, $61de1ee1cac498ae$var$zcd, a.b);
    if (a.g.c == 0 || a.d.c == 0) return;
    $61de1ee1cac498ae$var$nic(a);
}
function $61de1ee1cac498ae$var$lic(a, b, c) {
    a.g = $61de1ee1cac498ae$var$qic(a, b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd), a.j);
    a.d = $61de1ee1cac498ae$var$qic(a, c, $61de1ee1cac498ae$var$Tcd, a.j);
    if (a.g.c == 0 || a.d.c == 0) return;
    $61de1ee1cac498ae$var$nic(a);
}
function $61de1ee1cac498ae$var$$yc(a, b, c) {
    return !$61de1ee1cac498ae$var$WAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.c, 16)), new $61de1ee1cac498ae$var$Xxb(new $61de1ee1cac498ae$var$dfd(b, c)))).sd(($61de1ee1cac498ae$var$EAb(), $61de1ee1cac498ae$var$DAb));
}
function $61de1ee1cac498ae$var$KAb(a) {
    var b;
    $61de1ee1cac498ae$var$Tzb(a);
    b = new $61de1ee1cac498ae$var$NBb;
    if (a.a.sd(b)) return $61de1ee1cac498ae$var$Atb(), new $61de1ee1cac498ae$var$Ftb($61de1ee1cac498ae$var$uCb(b.a));
    return $61de1ee1cac498ae$var$Atb(), $61de1ee1cac498ae$var$Atb(), $61de1ee1cac498ae$var$ztb;
}
function $61de1ee1cac498ae$var$nA(a) {
    var b;
    if (a.b <= 0) return false;
    b = $61de1ee1cac498ae$var$hfb("MLydhHmsSDkK", $61de1ee1cac498ae$var$wfb($61de1ee1cac498ae$var$bfb(a.c, 0)));
    return b > 1 || b >= 0 && a.b < 3;
}
function $61de1ee1cac498ae$var$w7c(a) {
    var b, c, d;
    b = new $61de1ee1cac498ae$var$s7c;
    for(d = $61de1ee1cac498ae$var$Jsb(a, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
        $61de1ee1cac498ae$var$St(b, 0, new $61de1ee1cac498ae$var$g7c(c));
    }
    return b;
}
function $61de1ee1cac498ae$var$qVb(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        b.f.$b();
    }
    $61de1ee1cac498ae$var$LVb(a.b, a);
    $61de1ee1cac498ae$var$rVb(a);
}
function $61de1ee1cac498ae$var$tb(a) {
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$LCb(a) : $61de1ee1cac498ae$var$LD(a) ? $61de1ee1cac498ae$var$Hdb(a) : $61de1ee1cac498ae$var$KD(a) ? ($61de1ee1cac498ae$var$uCb(a), a) ? 1231 : 1237 : $61de1ee1cac498ae$var$ID(a) ? a.Hb() : $61de1ee1cac498ae$var$MC(a) ? $61de1ee1cac498ae$var$FCb(a) : $61de1ee1cac498ae$var$rz(a);
}
function $61de1ee1cac498ae$var$rb(a) {
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$ZI : $61de1ee1cac498ae$var$LD(a) ? $61de1ee1cac498ae$var$BI : $61de1ee1cac498ae$var$KD(a) ? $61de1ee1cac498ae$var$wI : $61de1ee1cac498ae$var$ID(a) ? a.gm : $61de1ee1cac498ae$var$MC(a) ? a.gm : a.gm || Array.isArray(a) && $61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PH, 1) || $61de1ee1cac498ae$var$PH;
}
function $61de1ee1cac498ae$var$j_c(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$Q1c;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Mre + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$S0c(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$k1c;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Mre + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$ekd(a, b, c) {
    switch(b){
        case 0:
            !a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0));
            $61de1ee1cac498ae$var$cId(a.o, c);
            return;
    }
    $61de1ee1cac498ae$var$yid(a, b, c);
}
function $61de1ee1cac498ae$var$XRc(a, b, c) {
    this.g = a;
    this.e = new $61de1ee1cac498ae$var$d7c;
    this.f = new $61de1ee1cac498ae$var$d7c;
    this.d = new $61de1ee1cac498ae$var$Psb;
    this.b = new $61de1ee1cac498ae$var$Psb;
    this.a = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$PZc(a, b, c, d) {
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.n = new $61de1ee1cac498ae$var$Rkb;
    this.i = d;
    this.j = c;
    this.s = a;
    this.t = b;
    this.r = 0;
    this.d = 0;
}
function $61de1ee1cac498ae$var$nib(a) {
    this.e = a;
    this.d = new $61de1ee1cac498ae$var$Irb(this.e.g);
    this.a = this.d;
    this.b = $61de1ee1cac498ae$var$kib(this);
    this.$modCount = a.$modCount;
}
function $61de1ee1cac498ae$var$Pr(a) {
    while(!a.d || !a.d.Ob()){
        if (!!a.b && !$61de1ee1cac498ae$var$akb(a.b)) a.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(a.b), 47);
        else return null;
    }
    return a.d;
}
function $61de1ee1cac498ae$var$Xyc(a) {
    $61de1ee1cac498ae$var$Ekb(a.c, ($61de1ee1cac498ae$var$Y1c(), $61de1ee1cac498ae$var$W1c));
    if ($61de1ee1cac498ae$var$Ky(a.a, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ksd(($61de1ee1cac498ae$var$dzc(), $61de1ee1cac498ae$var$bzc)))))) return new $61de1ee1cac498ae$var$Zed;
    return new $61de1ee1cac498ae$var$_ed(a);
}
function $61de1ee1cac498ae$var$bRc(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$Sqe;
        default:
        case 2:
            return 0;
        case 3:
            return $61de1ee1cac498ae$var$cme;
        case 4:
            return $61de1ee1cac498ae$var$Tqe;
    }
}
function $61de1ee1cac498ae$var$Ife() {
    $61de1ee1cac498ae$var$wfe();
    var a;
    if ($61de1ee1cac498ae$var$dfe) return $61de1ee1cac498ae$var$dfe;
    a = $61de1ee1cac498ae$var$Afe($61de1ee1cac498ae$var$Kfe("M", true));
    a = $61de1ee1cac498ae$var$Bfe($61de1ee1cac498ae$var$Kfe("M", false), a);
    $61de1ee1cac498ae$var$dfe = a;
    return $61de1ee1cac498ae$var$dfe;
}
function $61de1ee1cac498ae$var$Awb(a, b) {
    var c, d, e;
    e = a.b;
    while(e){
        c = a.a.ue(b, e.d);
        if (c == 0) return e;
        d = c < 0 ? 0 : 1;
        e = e.a[d];
    }
    return null;
}
function $61de1ee1cac498ae$var$Tyb(a, b, c) {
    var d, e;
    d = ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$_Pb(c) ? true : false);
    e = $61de1ee1cac498ae$var$BD(b.xc(d), 15);
    if (!e) {
        e = new $61de1ee1cac498ae$var$Rkb;
        b.zc(d, e);
    }
    e.Fc(c);
}
function $61de1ee1cac498ae$var$dYc(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$lZc(), $61de1ee1cac498ae$var$UYc)), 19).a;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$UYc), 19).a;
    return c == d ? -1 : c < d ? -1 : c > d ? 1 : 0;
}
function $61de1ee1cac498ae$var$NYb(a, b) {
    if ($61de1ee1cac498ae$var$OYb(a, b)) {
        $61de1ee1cac498ae$var$Rc(a.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21), b);
        $61de1ee1cac498ae$var$Dsb(a.a, b);
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$d3b(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
    if (b) {
        c = b.c;
        $61de1ee1cac498ae$var$Lkb(c.a, b);
        c.a.c.length == 0 && $61de1ee1cac498ae$var$Lkb($61de1ee1cac498ae$var$Q_b(b).b, c);
    }
}
function $61de1ee1cac498ae$var$syb(a) {
    if ($61de1ee1cac498ae$var$lyb) return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$qL, $61de1ee1cac498ae$var$tke, 572, 0, 0, 1);
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(a.a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$qL, $61de1ee1cac498ae$var$tke, 572, a.a.c.length, 0, 1)), 842);
}
function $61de1ee1cac498ae$var$mn(a, b, c, d) {
    $61de1ee1cac498ae$var$Vm();
    return new $61de1ee1cac498ae$var$wx($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$CK, 1), $61de1ee1cac498ae$var$zie, 42, 0, [
        ($61de1ee1cac498ae$var$Wj(a, b), new $61de1ee1cac498ae$var$Wo(a, b)),
        ($61de1ee1cac498ae$var$Wj(c, d), new $61de1ee1cac498ae$var$Wo(c, d))
    ]));
}
function $61de1ee1cac498ae$var$Dnd(a, b, c) {
    var d, e;
    e = (d = new $61de1ee1cac498ae$var$SSd, d);
    $61de1ee1cac498ae$var$$nd(e, b, c);
    $61de1ee1cac498ae$var$wtd((!a.q && (a.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, a, 11, 10)), a.q), e);
    return e;
}
function $61de1ee1cac498ae$var$Zmd(a) {
    var b, c, d, e;
    e = $61de1ee1cac498ae$var$icb($61de1ee1cac498ae$var$Rmd, a);
    c = e.length;
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, c, 6, 1);
    for(b = 0; b < c; ++b)d[b] = e[b];
    return d;
}
function $61de1ee1cac498ae$var$l4c(a, b) {
    var c, d, e, f, g;
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        g = new $61de1ee1cac498ae$var$v4c(a);
        c.Qe(g);
        $61de1ee1cac498ae$var$q4c(g);
    }
    $61de1ee1cac498ae$var$Uhb(a.f);
}
function $61de1ee1cac498ae$var$hw(a, b) {
    var c;
    if (b === a) return true;
    if ($61de1ee1cac498ae$var$JD(b, 224)) {
        c = $61de1ee1cac498ae$var$BD(b, 224);
        return $61de1ee1cac498ae$var$pb(a.Zb(), c.Zb());
    }
    return false;
}
function $61de1ee1cac498ae$var$aub(a, b) {
    var c;
    if (b * 2 + 1 >= a.b.c.length) return;
    $61de1ee1cac498ae$var$aub(a, 2 * b + 1);
    c = 2 * b + 2;
    c < a.b.c.length && $61de1ee1cac498ae$var$aub(a, c);
    $61de1ee1cac498ae$var$bub(a, b);
}
function $61de1ee1cac498ae$var$Ss(a, b, c) {
    var d, e;
    this.g = a;
    this.c = b;
    this.a = this;
    this.d = this;
    e = $61de1ee1cac498ae$var$Kp(c);
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BG, $61de1ee1cac498ae$var$Gie, 330, e, 0, 1);
    this.b = d;
}
function $61de1ee1cac498ae$var$whb(a, b, c) {
    var d;
    for(d = c - 1; d >= 0 && a[d] === b[d]; d--);
    return d < 0 ? 0 : $61de1ee1cac498ae$var$Gbb($61de1ee1cac498ae$var$xbb(a[d], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(b[d], $61de1ee1cac498ae$var$Yje)) ? -1 : 1;
}
function $61de1ee1cac498ae$var$UFc(a, b) {
    var c, d;
    for(d = $61de1ee1cac498ae$var$Jsb(a, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 214);
        if (c.e.length > 0) {
            b.td(c);
            c.i && $61de1ee1cac498ae$var$_Fc(c);
        }
    }
}
function $61de1ee1cac498ae$var$nzd(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a.a, 4), 126);
    c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$$3, $61de1ee1cac498ae$var$hve, 415, b, 0, 1);
    d != null && $61de1ee1cac498ae$var$$fb(d, 0, c, 0, d.length);
    return c;
}
function $61de1ee1cac498ae$var$JEd(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$NEd((a.f & 256) != 0, a.i, a.a, a.d, (a.f & 16) != 0, a.j, a.g, b);
    a.e != null || (c.c = a);
    return c;
}
function $61de1ee1cac498ae$var$Dc(a, b) {
    var c, d;
    for(d = a.Zb().Cc().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 14);
        if (c.Hc(b)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$oNb(a, b, c, d, e) {
    var f, g;
    for(g = c; g <= e; g++)for(f = b; f <= d; f++){
        if ($61de1ee1cac498ae$var$YMb(a, f, g)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Tt(a, b, c) {
    var d, e, f, g;
    $61de1ee1cac498ae$var$uCb(c);
    g = false;
    f = a.Zc(b);
    for(e = c.Kc(); e.Ob();){
        d = e.Pb();
        f.Rb(d);
        g = true;
    }
    return g;
}
function $61de1ee1cac498ae$var$Dv(a, b) {
    var c;
    if (a === b) return true;
    else if ($61de1ee1cac498ae$var$JD(b, 83)) {
        c = $61de1ee1cac498ae$var$BD(b, 83);
        return $61de1ee1cac498ae$var$Ax($61de1ee1cac498ae$var$Wm(a), c.vc());
    }
    return false;
}
function $61de1ee1cac498ae$var$Nhb(a, b, c) {
    var d, e;
    for(e = c.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 42);
        if (a.re(b, d.dd())) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Hic(a, b, c) {
    if (!a.d[b.p][c.p]) {
        $61de1ee1cac498ae$var$Gic(a, b, c);
        a.d[b.p][c.p] = true;
        a.d[c.p][b.p] = true;
    }
    return a.a[b.p][c.p];
}
function $61de1ee1cac498ae$var$Itd(a, b) {
    if (!a.ai() && b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The 'no null' constraint is violated"));
    return b;
}
function $61de1ee1cac498ae$var$$Jd(a, b) {
    if (a.D == null && a.B != null) {
        a.D = a.B;
        a.B = null;
    }
    $61de1ee1cac498ae$var$jKd(a, b == null ? null : ($61de1ee1cac498ae$var$uCb(b), b));
    !!a.C && a.yk(null);
}
function $61de1ee1cac498ae$var$XHc(a, b) {
    var c;
    if (!a || a == b || !$61de1ee1cac498ae$var$wNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Psc))) return false;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Psc)), 10);
    return c != a;
}
function $61de1ee1cac498ae$var$b4d(a) {
    switch(a.i){
        case 2:
            return true;
        case 1:
            return false;
        case -1:
            ++a.c;
        default:
            return a.pl();
    }
}
function $61de1ee1cac498ae$var$c4d(a) {
    switch(a.i){
        case -2:
            return true;
        case -1:
            return false;
        case 1:
            --a.c;
        default:
            return a.ql();
    }
}
function $61de1ee1cac498ae$var$Xdb(a) {
    $61de1ee1cac498ae$var$Zy.call(this, "The given string does not match the expected format for individual spacings.", a);
}
function $61de1ee1cac498ae$var$pgd() {
    $61de1ee1cac498ae$var$pgd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$mgd = new $61de1ee1cac498ae$var$qgd("ELK", 0);
    $61de1ee1cac498ae$var$ngd = new $61de1ee1cac498ae$var$qgd("JSON", 1);
    $61de1ee1cac498ae$var$lgd = new $61de1ee1cac498ae$var$qgd("DOT", 2);
    $61de1ee1cac498ae$var$ogd = new $61de1ee1cac498ae$var$qgd("SVG", 3);
}
function $61de1ee1cac498ae$var$pWc() {
    $61de1ee1cac498ae$var$pWc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$mWc = new $61de1ee1cac498ae$var$rWc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$nWc = new $61de1ee1cac498ae$var$rWc("RADIAL_COMPACTION", 1);
    $61de1ee1cac498ae$var$oWc = new $61de1ee1cac498ae$var$rWc("WEDGE_COMPACTION", 2);
}
function $61de1ee1cac498ae$var$Fyb() {
    $61de1ee1cac498ae$var$Fyb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Cyb = new $61de1ee1cac498ae$var$Gyb("CONCURRENT", 0);
    $61de1ee1cac498ae$var$Dyb = new $61de1ee1cac498ae$var$Gyb("IDENTITY_FINISH", 1);
    $61de1ee1cac498ae$var$Eyb = new $61de1ee1cac498ae$var$Gyb("UNORDERED", 2);
}
function $61de1ee1cac498ae$var$nPb() {
    $61de1ee1cac498ae$var$nPb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$kPb = ($61de1ee1cac498ae$var$cPb(), $61de1ee1cac498ae$var$bPb);
    $61de1ee1cac498ae$var$jPb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Tle, $61de1ee1cac498ae$var$kPb);
    $61de1ee1cac498ae$var$iPb = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Ule);
    $61de1ee1cac498ae$var$lPb = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Vle);
    $61de1ee1cac498ae$var$mPb = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Wle);
}
function $61de1ee1cac498ae$var$Occ() {
    $61de1ee1cac498ae$var$Occ = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Mcc = new $61de1ee1cac498ae$var$Zcc;
    $61de1ee1cac498ae$var$Ncc = new $61de1ee1cac498ae$var$_cc;
    $61de1ee1cac498ae$var$Lcc = new $61de1ee1cac498ae$var$bdc;
    $61de1ee1cac498ae$var$Kcc = new $61de1ee1cac498ae$var$fdc;
    $61de1ee1cac498ae$var$Jcc = new $61de1ee1cac498ae$var$jdc;
    $61de1ee1cac498ae$var$Icc = ($61de1ee1cac498ae$var$uCb($61de1ee1cac498ae$var$Jcc), new $61de1ee1cac498ae$var$bpb);
}
function $61de1ee1cac498ae$var$tBc() {
    $61de1ee1cac498ae$var$tBc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qBc = new $61de1ee1cac498ae$var$uBc("CONSERVATIVE", 0);
    $61de1ee1cac498ae$var$rBc = new $61de1ee1cac498ae$var$uBc("CONSERVATIVE_SOFT", 1);
    $61de1ee1cac498ae$var$sBc = new $61de1ee1cac498ae$var$uBc("SLOPPY", 2);
}
function $61de1ee1cac498ae$var$Zad() {
    $61de1ee1cac498ae$var$Zad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Xad = new $61de1ee1cac498ae$var$q0b(15);
    $61de1ee1cac498ae$var$Wad = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c), $61de1ee1cac498ae$var$Xad);
    $61de1ee1cac498ae$var$Yad = $61de1ee1cac498ae$var$C9c;
    $61de1ee1cac498ae$var$Sad = $61de1ee1cac498ae$var$s8c;
    $61de1ee1cac498ae$var$Tad = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$Vad = $61de1ee1cac498ae$var$_8c;
    $61de1ee1cac498ae$var$Uad = $61de1ee1cac498ae$var$$8c;
}
function $61de1ee1cac498ae$var$o7c(a, b, c) {
    var d, e, f;
    d = new $61de1ee1cac498ae$var$Psb;
    for(f = $61de1ee1cac498ae$var$Jsb(c, 0); f.b != f.d.c;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 8);
        $61de1ee1cac498ae$var$Dsb(d, new $61de1ee1cac498ae$var$g7c(e));
    }
    $61de1ee1cac498ae$var$Tt(a, b, d);
}
function $61de1ee1cac498ae$var$r7c(a) {
    var b, c, d;
    b = 0;
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$m1, $61de1ee1cac498ae$var$nie, 8, a.b, 0, 1);
    c = $61de1ee1cac498ae$var$Jsb(a, 0);
    while(c.b != c.d.c)d[b++] = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(c), 8);
    return d;
}
function $61de1ee1cac498ae$var$$Pd(a) {
    var b;
    b = (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, a, 9, 5)), a.a);
    if (b.i != 0) return $61de1ee1cac498ae$var$nQd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(b, 0), 678));
    return null;
}
function $61de1ee1cac498ae$var$Ly(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$wbb(a, b);
    if ($61de1ee1cac498ae$var$Gbb($61de1ee1cac498ae$var$Vbb(a, b), 0) | $61de1ee1cac498ae$var$Ebb($61de1ee1cac498ae$var$Vbb(a, c), 0)) return c;
    return $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$rie, $61de1ee1cac498ae$var$Vbb($61de1ee1cac498ae$var$Pbb(c, 63), 1));
}
function $61de1ee1cac498ae$var$Yyc(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Ksd(($61de1ee1cac498ae$var$dzc(), $61de1ee1cac498ae$var$bzc)) != null && b.wg() != null ? $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b.wg())) / $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$bzc))) : 1;
    $61de1ee1cac498ae$var$Rhb(a.b, b, c);
}
function $61de1ee1cac498ae$var$le(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD(a.d.Bc(b), 14);
    if (!c) return null;
    d = a.e.hc();
    d.Gc(c);
    a.e.d -= c.gc();
    c.$b();
    return d;
}
function $61de1ee1cac498ae$var$AHc(a, b) {
    var c, d;
    d = a.c[b];
    if (d == 0) return;
    a.c[b] = 0;
    a.d -= d;
    c = b + 1;
    while(c < a.a.length){
        a.a[c] -= d;
        c += c & -c;
    }
}
function $61de1ee1cac498ae$var$rwb(a) {
    var b;
    b = a.a.c.length;
    if (b > 0) return $61de1ee1cac498ae$var$_vb(b - 1, a.a.c.length), $61de1ee1cac498ae$var$Kkb(a.a, b - 1);
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Jpb);
}
function $61de1ee1cac498ae$var$C2c(a, b, c) {
    if (b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$ese + b));
    if (b < a.j.c.length) $61de1ee1cac498ae$var$Nkb(a.j, b, c);
    else {
        $61de1ee1cac498ae$var$A2c(a, b);
        $61de1ee1cac498ae$var$Ekb(a.j, c);
    }
}
function $61de1ee1cac498ae$var$oCb(a, b, c) {
    if (a > b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$xke + a + $61de1ee1cac498ae$var$yke + b));
    if (a < 0 || b > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$scb($61de1ee1cac498ae$var$xke + a + $61de1ee1cac498ae$var$zke + b + $61de1ee1cac498ae$var$oke + c));
}
function $61de1ee1cac498ae$var$j5c(a) {
    if (!a.a || (a.a.i & 8) == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Enumeration class expected for layout option " + a.f));
}
function $61de1ee1cac498ae$var$vud(a) {
    var b;
    ++a.j;
    if (a.i == 0) a.g = null;
    else if (a.i < a.g.length) {
        b = a.g;
        a.g = a.ri(a.i);
        $61de1ee1cac498ae$var$$fb(b, 0, a.g, 0, a.i);
    }
}
function $61de1ee1cac498ae$var$hkb(a, b) {
    var c, d;
    c = a.a.length - 1;
    a.c = a.c - 1 & c;
    while(b != a.c){
        d = b + 1 & c;
        $61de1ee1cac498ae$var$NC(a.a, b, a.a[d]);
        b = d;
    }
    $61de1ee1cac498ae$var$NC(a.a, a.c, null);
}
function $61de1ee1cac498ae$var$ikb(a, b) {
    var c, d;
    c = a.a.length - 1;
    while(b != a.b){
        d = b - 1 & c;
        $61de1ee1cac498ae$var$NC(a.a, b, a.a[d]);
        b = d;
    }
    $61de1ee1cac498ae$var$NC(a.a, a.b, null);
    a.b = a.b + 1 & c;
}
function $61de1ee1cac498ae$var$Fkb(a, b, c) {
    var d, e;
    $61de1ee1cac498ae$var$wCb(b, a.c.length);
    d = c.Pc();
    e = d.length;
    if (e == 0) return false;
    $61de1ee1cac498ae$var$bCb(a.c, b, d);
    return true;
}
function $61de1ee1cac498ae$var$VEd(a) {
    var b, c;
    if (a == null) return null;
    for(b = 0, c = a.length; b < c; b++){
        if (!$61de1ee1cac498ae$var$gFd(a[b])) return a[b];
    }
    return null;
}
function $61de1ee1cac498ae$var$grb(a, b, c) {
    var d, e, f, g;
    for(e = c, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        if (a.b.re(b, d.cd())) return d;
    }
    return null;
}
function $61de1ee1cac498ae$var$Hlb(a) {
    var b, c, d, e, f;
    f = 1;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        f = 31 * f + (b != null ? $61de1ee1cac498ae$var$tb(b) : 0);
        f = f | 0;
    }
    return f;
}
function $61de1ee1cac498ae$var$as(a) {
    var b, c, d, e, f;
    b = {};
    for(d = a, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        b[":" + (c.f != null ? c.f : "" + c.g)] = c;
    }
    return b;
}
function $61de1ee1cac498ae$var$gr(a) {
    var b;
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Mb(true, "numberToAdvance must be nonnegative");
    for(b = 0; b < 0 && $61de1ee1cac498ae$var$Qr(a); b++)$61de1ee1cac498ae$var$Rr(a);
    return b;
}
function $61de1ee1cac498ae$var$eDc(a) {
    var b, c, d;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(a.a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
        b.c.i == b.d.i || ++d;
    }
    return d;
}
function $61de1ee1cac498ae$var$HZb(a, b) {
    var c, d, e;
    c = a;
    e = 0;
    do {
        if (c == b) return e;
        d = c.e;
        if (!d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Vdb);
        c = $61de1ee1cac498ae$var$Q_b(d);
        ++e;
    }while (true);
}
function $61de1ee1cac498ae$var$w$c(a, b) {
    var c, d, e;
    e = b - a.f;
    for(d = new $61de1ee1cac498ae$var$olb(a.d); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 443);
        $61de1ee1cac498ae$var$_Zc(c, c.e, c.f + e);
    }
    a.f = b;
}
function $61de1ee1cac498ae$var$aRc(a, b, c) {
    if ($61de1ee1cac498ae$var$$wnd.Math.abs(b - a) < $61de1ee1cac498ae$var$Rqe || $61de1ee1cac498ae$var$$wnd.Math.abs(c - a) < $61de1ee1cac498ae$var$Rqe) return true;
    return b - a > $61de1ee1cac498ae$var$Rqe ? a - c > $61de1ee1cac498ae$var$Rqe : c - a > $61de1ee1cac498ae$var$Rqe;
}
function $61de1ee1cac498ae$var$pHb(a, b) {
    if (!a) return 0;
    if (b && !a.j) return 0;
    if ($61de1ee1cac498ae$var$JD(a, 124)) {
        if ($61de1ee1cac498ae$var$BD(a, 124).a.b == 0) return 0;
    }
    return a.Re();
}
function $61de1ee1cac498ae$var$qHb(a, b) {
    if (!a) return 0;
    if (b && !a.k) return 0;
    if ($61de1ee1cac498ae$var$JD(a, 124)) {
        if ($61de1ee1cac498ae$var$BD(a, 124).a.a == 0) return 0;
    }
    return a.Se();
}
function $61de1ee1cac498ae$var$fhb(a) {
    $61de1ee1cac498ae$var$Hgb();
    if (a < 0) {
        if (a != -1) return new $61de1ee1cac498ae$var$Tgb(-1, -a);
        return $61de1ee1cac498ae$var$Bgb;
    } else return a <= 10 ? $61de1ee1cac498ae$var$Dgb[$61de1ee1cac498ae$var$QD(a)] : new $61de1ee1cac498ae$var$Tgb(1, a);
}
function $61de1ee1cac498ae$var$xC(a) {
    $61de1ee1cac498ae$var$rC();
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$MB("Unexpected typeof result '" + a + "'; please report this bug to the GWT team"));
}
function $61de1ee1cac498ae$var$lz(a) {
    $61de1ee1cac498ae$var$jz();
    $61de1ee1cac498ae$var$Py(this);
    $61de1ee1cac498ae$var$Ry(this);
    this.e = a;
    $61de1ee1cac498ae$var$Sy(this, a);
    this.g = a == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(a);
    this.a = "";
    this.b = a;
    this.a = "";
}
function $61de1ee1cac498ae$var$F$c() {
    this.a = new $61de1ee1cac498ae$var$G$c;
    this.f = new $61de1ee1cac498ae$var$I$c(this);
    this.b = new $61de1ee1cac498ae$var$K$c(this);
    this.i = new $61de1ee1cac498ae$var$M$c(this);
    this.e = new $61de1ee1cac498ae$var$O$c(this);
}
function $61de1ee1cac498ae$var$ss() {
    $61de1ee1cac498ae$var$rs.call(this, new $61de1ee1cac498ae$var$_rb($61de1ee1cac498ae$var$Cv(16)));
    $61de1ee1cac498ae$var$Xj(2, $61de1ee1cac498ae$var$mie);
    this.b = 2;
    this.a = new $61de1ee1cac498ae$var$Ms(null, null, 0, null);
    $61de1ee1cac498ae$var$As(this.a, this.a);
}
function $61de1ee1cac498ae$var$xzc() {
    $61de1ee1cac498ae$var$xzc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$uzc = new $61de1ee1cac498ae$var$zzc("DUMMY_NODE_OVER", 0);
    $61de1ee1cac498ae$var$vzc = new $61de1ee1cac498ae$var$zzc("DUMMY_NODE_UNDER", 1);
    $61de1ee1cac498ae$var$wzc = new $61de1ee1cac498ae$var$zzc("EQUAL", 2);
}
function $61de1ee1cac498ae$var$LUb() {
    $61de1ee1cac498ae$var$LUb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$JUb = $61de1ee1cac498ae$var$Fx($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t1, 1), $61de1ee1cac498ae$var$Kie, 103, 0, [
        ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad),
        $61de1ee1cac498ae$var$bad
    ]));
    $61de1ee1cac498ae$var$KUb = $61de1ee1cac498ae$var$Fx($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t1, 1), $61de1ee1cac498ae$var$Kie, 103, 0, [
        $61de1ee1cac498ae$var$dad,
        $61de1ee1cac498ae$var$_9c
    ]));
}
function $61de1ee1cac498ae$var$VQc(a) {
    return ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Lcd).Hc(a.j) ? $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$qtc)))) : $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ])).b;
}
function $61de1ee1cac498ae$var$DOb(a) {
    var b, c, d, e;
    d = a.b.a;
    for(c = d.a.ec().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 561);
        e = new $61de1ee1cac498ae$var$MPb(b, a.e, a.f);
        $61de1ee1cac498ae$var$Ekb(a.g, e);
    }
}
function $61de1ee1cac498ae$var$yId(a, b) {
    var c, d, e;
    d = a.nk(b, null);
    e = null;
    if (b) {
        e = ($61de1ee1cac498ae$var$LFd(), c = new $61de1ee1cac498ae$var$UQd, c);
        $61de1ee1cac498ae$var$NQd(e, a.r);
    }
    d = $61de1ee1cac498ae$var$xId(a, e, d);
    !!d && d.Fi();
}
function $61de1ee1cac498ae$var$VFc(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$Cub(a.d, 1) != 0;
    c = true;
    while(c){
        c = false;
        c = b.c.Tf(b.e, d);
        c = c | $61de1ee1cac498ae$var$dGc(a, b, d, false);
        d = !d;
    }
    $61de1ee1cac498ae$var$$Fc(a);
}
function $61de1ee1cac498ae$var$wZc(a, b) {
    var c, d, e;
    d = false;
    c = b.q.d;
    if (b.d < a.b) {
        e = $61de1ee1cac498ae$var$ZZc(b.q, a.b);
        if (b.q.d > e) {
            $61de1ee1cac498ae$var$$Zc(b.q, e);
            d = c != b.q.d;
        }
    }
    return d;
}
function $61de1ee1cac498ae$var$PVc(a, b) {
    var c, d, e, f, g, h, i, j;
    i = b.i;
    j = b.j;
    d = a.f;
    e = d.i;
    f = d.j;
    g = i - e;
    h = j - f;
    c = $61de1ee1cac498ae$var$$wnd.Math.sqrt(g * g + h * h);
    return c;
}
function $61de1ee1cac498ae$var$Rnd(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$jid(a);
    if (!d) {
        !$61de1ee1cac498ae$var$And && ($61de1ee1cac498ae$var$And = new $61de1ee1cac498ae$var$lUd);
        c = ($61de1ee1cac498ae$var$IEd(), $61de1ee1cac498ae$var$PEd(b));
        d = new $61de1ee1cac498ae$var$s0d(c);
        $61de1ee1cac498ae$var$wtd(d.Vk(), a);
    }
    return d;
}
function $61de1ee1cac498ae$var$Sc(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD(a.c.Bc(b), 14);
    if (!c) return a.jc();
    d = a.hc();
    d.Gc(c);
    a.d -= c.gc();
    c.$b();
    return a.mc(d);
}
function $61de1ee1cac498ae$var$j7c(a, b) {
    var c;
    for(c = 0; c < b.length; c++){
        if (a == ($61de1ee1cac498ae$var$BCb(c, b.length), b.charCodeAt(c))) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$E_b(a, b) {
    var c;
    for(c = 0; c < b.length; c++){
        if (a == ($61de1ee1cac498ae$var$BCb(c, b.length), b.charCodeAt(c))) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$hFd(a) {
    var b, c;
    if (a == null) return false;
    for(b = 0, c = a.length; b < c; b++){
        if (!$61de1ee1cac498ae$var$gFd(a[b])) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$Ngb(a) {
    var b;
    if (a.c != 0) return a.c;
    for(b = 0; b < a.a.length; b++)a.c = a.c * 33 + (a.a[b] & -1);
    a.c = a.c * a.e;
    return a.c;
}
function $61de1ee1cac498ae$var$vkb(a) {
    var b;
    $61de1ee1cac498ae$var$sCb(a.a != a.b);
    b = a.d.a[a.a];
    $61de1ee1cac498ae$var$mkb(a.b == a.d.c && b != null);
    a.c = a.a;
    a.a = a.a + 1 & a.d.a.length - 1;
    return b;
}
function $61de1ee1cac498ae$var$phe(a) {
    var b;
    if (!(a.c.c < 0 ? a.a >= a.c.b : a.a <= a.c.b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    b = a.a;
    a.a += a.c.c;
    ++a.b;
    return $61de1ee1cac498ae$var$meb(b);
}
function $61de1ee1cac498ae$var$BWb(a) {
    var b;
    b = new $61de1ee1cac498ae$var$VWb(a);
    $61de1ee1cac498ae$var$rXb(a.a, $61de1ee1cac498ae$var$zWb, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bQ, 1), $61de1ee1cac498ae$var$Uhe, 369, 0, [
        b
    ])));
    !!b.d && $61de1ee1cac498ae$var$Ekb(b.f, b.d);
    return b.f;
}
function $61de1ee1cac498ae$var$Z1b(a) {
    var b;
    b = new $61de1ee1cac498ae$var$q_b(a.a);
    $61de1ee1cac498ae$var$tNb(b, a);
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), a);
    b.o.a = a.g;
    b.o.b = a.f;
    b.n.a = a.i;
    b.n.b = a.j;
    return b;
}
function $61de1ee1cac498ae$var$A9b(a, b, c, d) {
    var e, f;
    for(f = a.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 70);
        e.n.a = b.a + (d.a - e.o.a) / 2;
        e.n.b = b.b;
        b.b += e.o.b + c;
    }
}
function $61de1ee1cac498ae$var$UDb(a, b, c) {
    var d, e;
    for(e = b.a.a.ec().Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 57);
        if ($61de1ee1cac498ae$var$VDb(a, d, c)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$JDc(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$olb(a.r); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        if (a.n[b.p] <= 0) return b;
    }
    return null;
}
function $61de1ee1cac498ae$var$cVc(a) {
    var b, c, d, e;
    e = new $61de1ee1cac498ae$var$Tqb;
    for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 33);
        b = $61de1ee1cac498ae$var$fVc(c);
        $61de1ee1cac498ae$var$ye(e, b);
    }
    return e;
}
function $61de1ee1cac498ae$var$zFc(a) {
    var b;
    b = $61de1ee1cac498ae$var$k3c($61de1ee1cac498ae$var$xFc);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Krc)) && $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$H8b));
    return b;
}
function $61de1ee1cac498ae$var$qKb(a, b, c) {
    var d;
    d = new $61de1ee1cac498ae$var$AJb(a, b);
    $61de1ee1cac498ae$var$Rc(a.r, b.Hf(), d);
    if (c && !$61de1ee1cac498ae$var$tcd(a.u)) {
        d.c = new $61de1ee1cac498ae$var$aIb(a.d);
        $61de1ee1cac498ae$var$Hkb(b.wf(), new $61de1ee1cac498ae$var$tKb(d));
    }
}
function $61de1ee1cac498ae$var$ybb(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$Fbb(a) && $61de1ee1cac498ae$var$Fbb(b)) {
        c = a - b;
        if (!isNaN(c)) return c;
    }
    return $61de1ee1cac498ae$var$eD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b);
}
function $61de1ee1cac498ae$var$bFd(a, b) {
    return b < a.length && ($61de1ee1cac498ae$var$BCb(b, a.length), a.charCodeAt(b) != 63) && ($61de1ee1cac498ae$var$BCb(b, a.length), a.charCodeAt(b) != 35);
}
function $61de1ee1cac498ae$var$Kic(a, b, c, d) {
    var e, f;
    a.a = b;
    f = d ? 0 : 1;
    a.f = (e = new $61de1ee1cac498ae$var$Iic(a.c, a.a, c, f), new $61de1ee1cac498ae$var$jjc(c, a.a, e, a.e, a.b, a.c == ($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$pGc)));
}
function $61de1ee1cac498ae$var$Tmd(a, b, c) {
    var d, e;
    e = a.a;
    a.a = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 1, e, b);
        !c ? c = d : c.Ei(d);
    }
    return c;
}
function $61de1ee1cac498ae$var$GQd(a, b, c) {
    var d, e;
    e = a.b;
    a.b = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 3, e, b);
        !c ? c = d : c.Ei(d);
    }
    return c;
}
function $61de1ee1cac498ae$var$IQd(a, b, c) {
    var d, e;
    e = a.f;
    a.f = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 0, e, b);
        !c ? c = d : c.Ei(d);
    }
    return c;
}
function $61de1ee1cac498ae$var$xid(a, b) {
    var c, d, e, f;
    f = (e = a ? $61de1ee1cac498ae$var$jid(a) : null, $61de1ee1cac498ae$var$q6d((d = b, e && e.Xk(), d)));
    if (f == b) {
        c = $61de1ee1cac498ae$var$jid(a);
        !!c && c.Xk();
    }
    return f;
}
function $61de1ee1cac498ae$var$x6c(a, b) {
    var c, d, e;
    e = 1;
    c = a;
    d = b >= 0 ? b : -b;
    while(d > 0)if (d % 2 == 0) {
        c *= c;
        d = d / 2 | 0;
    } else {
        e *= c;
        d -= 1;
    }
    return b < 0 ? 1 / e : e;
}
function $61de1ee1cac498ae$var$y6c(a, b) {
    var c, d, e;
    e = 1;
    c = a;
    d = b >= 0 ? b : -b;
    while(d > 0)if (d % 2 == 0) {
        c *= c;
        d = d / 2 | 0;
    } else {
        e *= c;
        d -= 1;
    }
    return b < 0 ? 1 / e : e;
}
function $61de1ee1cac498ae$var$sAd(a) {
    var b, c, d, e;
    if (a != null) for(c = 0; c < a.length; ++c){
        b = a[c];
        if (b) {
            $61de1ee1cac498ae$var$BD(b.g, 367);
            e = b.i;
            for(d = 0; d < e; ++d);
        }
    }
}
function $61de1ee1cac498ae$var$YZc(a) {
    var b, c, d;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$olb(a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 187);
        d = $61de1ee1cac498ae$var$$wnd.Math.max(d, b.g);
    }
    return d;
}
function $61de1ee1cac498ae$var$eGc(a) {
    var b, c, d;
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 214);
        b = c.c.Rf() ? c.f : c.a;
        !!b && $61de1ee1cac498ae$var$mHc(b, c.j);
    }
}
function $61de1ee1cac498ae$var$hbd() {
    $61de1ee1cac498ae$var$hbd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$fbd = new $61de1ee1cac498ae$var$ibd("INHERIT", 0);
    $61de1ee1cac498ae$var$ebd = new $61de1ee1cac498ae$var$ibd("INCLUDE_CHILDREN", 1);
    $61de1ee1cac498ae$var$gbd = new $61de1ee1cac498ae$var$ibd("SEPARATE_CHILDREN", 2);
}
function $61de1ee1cac498ae$var$Jkd(a, b) {
    switch(b){
        case 1:
            !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7));
            $61de1ee1cac498ae$var$Uxd(a.n);
            return;
        case 2:
            $61de1ee1cac498ae$var$Lkd(a, null);
            return;
    }
    $61de1ee1cac498ae$var$fkd(a, b);
}
function $61de1ee1cac498ae$var$Dm(a) {
    var b;
    switch(a.gc()){
        case 0:
            return $61de1ee1cac498ae$var$hm;
        case 1:
            return new $61de1ee1cac498ae$var$my($61de1ee1cac498ae$var$Qb(a.Xb(0)));
        default:
            b = a;
            return new $61de1ee1cac498ae$var$ux(b);
    }
}
function $61de1ee1cac498ae$var$Vn(a) {
    $61de1ee1cac498ae$var$Ql();
    switch(a.gc()){
        case 0:
            return $61de1ee1cac498ae$var$yx(), $61de1ee1cac498ae$var$xx;
        case 1:
            return new $61de1ee1cac498ae$var$oy(a.Kc().Pb());
        default:
            return new $61de1ee1cac498ae$var$zx(a);
    }
}
function $61de1ee1cac498ae$var$Up(a) {
    $61de1ee1cac498ae$var$Ql();
    switch(a.c){
        case 0:
            return $61de1ee1cac498ae$var$yx(), $61de1ee1cac498ae$var$xx;
        case 1:
            return new $61de1ee1cac498ae$var$oy($61de1ee1cac498ae$var$qr(new $61de1ee1cac498ae$var$Gqb(a)));
        default:
            return new $61de1ee1cac498ae$var$Tp(a);
    }
}
function $61de1ee1cac498ae$var$Hv(b, c) {
    $61de1ee1cac498ae$var$Qb(b);
    try {
        return b.xc(c);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 205) || $61de1ee1cac498ae$var$JD(a, 173)) return null;
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Iv(b, c) {
    $61de1ee1cac498ae$var$Qb(b);
    try {
        return b.Bc(c);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 205) || $61de1ee1cac498ae$var$JD(a, 173)) return null;
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Ck(b, c) {
    $61de1ee1cac498ae$var$Qb(b);
    try {
        return b.Hc(c);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 205) || $61de1ee1cac498ae$var$JD(a, 173)) return false;
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Dk(b, c) {
    $61de1ee1cac498ae$var$Qb(b);
    try {
        return b.Mc(c);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 205) || $61de1ee1cac498ae$var$JD(a, 173)) return false;
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Gv(b, c) {
    $61de1ee1cac498ae$var$Qb(b);
    try {
        return b._b(c);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 205) || $61de1ee1cac498ae$var$JD(a, 173)) return false;
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$KXb(a, b) {
    var c;
    if (a.a.c.length > 0) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, a.a.c.length - 1), 570);
        if ($61de1ee1cac498ae$var$NYb(c, b)) return;
    }
    $61de1ee1cac498ae$var$Ekb(a.a, new $61de1ee1cac498ae$var$PYb(b));
}
function $61de1ee1cac498ae$var$$gc(a) {
    $61de1ee1cac498ae$var$Hgc();
    var b, c;
    b = a.d.c - a.e.c;
    c = $61de1ee1cac498ae$var$BD(a.g, 145);
    $61de1ee1cac498ae$var$Hkb(c.b, new $61de1ee1cac498ae$var$shc(b));
    $61de1ee1cac498ae$var$Hkb(c.c, new $61de1ee1cac498ae$var$uhc(b));
    $61de1ee1cac498ae$var$reb(c.i, new $61de1ee1cac498ae$var$whc(b));
}
function $61de1ee1cac498ae$var$gic(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Ufb;
    b.a += "VerticalSegment ";
    $61de1ee1cac498ae$var$Pfb(b, a.e);
    b.a += " ";
    $61de1ee1cac498ae$var$Qfb(b, $61de1ee1cac498ae$var$Eb(new $61de1ee1cac498ae$var$Gb, new $61de1ee1cac498ae$var$olb(a.k)));
    return b.a;
}
function $61de1ee1cac498ae$var$u4c(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(a.c.c, ""), 229);
    if (!b) {
        b = new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, ""), "Other"));
        $61de1ee1cac498ae$var$Xrb(a.c.c, "", b);
    }
    return b;
}
function $61de1ee1cac498ae$var$qnd(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$Eid(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(a));
    b.a += " (name: ";
    $61de1ee1cac498ae$var$Efb(b, a.zb);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$Jnd(a, b, c) {
    var d, e;
    e = a.sb;
    a.sb = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 4, e, b);
        !c ? c = d : c.Ei(d);
    }
    return c;
}
function $61de1ee1cac498ae$var$_ic(a, b) {
    var c, d, e;
    c = 0;
    for(e = $61de1ee1cac498ae$var$V_b(a, b).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 11);
        c += $61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)) != null ? 1 : 0;
    }
    return c;
}
function $61de1ee1cac498ae$var$vPc(a, b, c) {
    var d, e, f;
    d = 0;
    for(f = $61de1ee1cac498ae$var$Jsb(a, 0); f.b != f.d.c;){
        e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(f)));
        if (e > c) break;
        else e >= b && ++d;
    }
    return d;
}
function $61de1ee1cac498ae$var$RTd(a, b, c) {
    var d, e;
    d = new $61de1ee1cac498ae$var$pSd(a.e, 3, 13, null, (e = b.c, e ? e : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd)), $61de1ee1cac498ae$var$HLd(a, b), false);
    !c ? c = d : c.Ei(d);
    return c;
}
function $61de1ee1cac498ae$var$STd(a, b, c) {
    var d, e;
    d = new $61de1ee1cac498ae$var$pSd(a.e, 4, 13, (e = b.c, e ? e : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd)), null, $61de1ee1cac498ae$var$HLd(a, b), false);
    !c ? c = d : c.Ei(d);
    return c;
}
function $61de1ee1cac498ae$var$zId(a, b, c) {
    var d, e;
    e = a.r;
    a.r = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 8, e, a.r);
        !c ? c = d : c.Ei(d);
    }
    return c;
}
function $61de1ee1cac498ae$var$o1d(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD(b, 676);
    d = c.vk();
    !d && c.wk(d = $61de1ee1cac498ae$var$JD(b, 88) ? new $61de1ee1cac498ae$var$C1d(a, $61de1ee1cac498ae$var$BD(b, 26)) : new $61de1ee1cac498ae$var$O1d(a, $61de1ee1cac498ae$var$BD(b, 148)));
    return d;
}
function $61de1ee1cac498ae$var$kud(a, b, c) {
    var d;
    a.qi(a.i + 1);
    d = a.oi(b, c);
    b != a.i && $61de1ee1cac498ae$var$$fb(a.g, b, a.g, b + 1, a.i - b);
    $61de1ee1cac498ae$var$NC(a.g, b, d);
    ++a.i;
    a.bi(b, c);
    a.ci();
}
function $61de1ee1cac498ae$var$vwb(a, b) {
    var c;
    if (b.a) {
        c = b.a.a.length;
        !a.a ? a.a = new $61de1ee1cac498ae$var$Wfb(a.d) : $61de1ee1cac498ae$var$Qfb(a.a, a.b);
        $61de1ee1cac498ae$var$Ofb(a.a, b.a, b.d.length, c);
    }
    return a;
}
function $61de1ee1cac498ae$var$__d(a, b) {
    var c, d, e, f;
    b.vi(a.a);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a.a, 8), 1936);
    if (f != null) for(c = f, d = 0, e = c.length; d < e; ++d)null.jm();
}
function $61de1ee1cac498ae$var$TAb(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$NBb;
    if (!a.a.sd(c)) {
        $61de1ee1cac498ae$var$Tzb(a);
        return $61de1ee1cac498ae$var$Atb(), $61de1ee1cac498ae$var$Atb(), $61de1ee1cac498ae$var$ztb;
    }
    return $61de1ee1cac498ae$var$Atb(), new $61de1ee1cac498ae$var$Ftb($61de1ee1cac498ae$var$uCb($61de1ee1cac498ae$var$SAb(a, c.a, b)));
}
function $61de1ee1cac498ae$var$CHc(a, b) {
    switch(b.g){
        case 2:
        case 1:
            return $61de1ee1cac498ae$var$V_b(a, b);
        case 3:
        case 4:
            return $61de1ee1cac498ae$var$Su($61de1ee1cac498ae$var$V_b(a, b));
    }
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
}
function $61de1ee1cac498ae$var$pb(a, b) {
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$dfb(a, b) : $61de1ee1cac498ae$var$LD(a) ? $61de1ee1cac498ae$var$Fdb(a, b) : $61de1ee1cac498ae$var$KD(a) ? ($61de1ee1cac498ae$var$uCb(a), $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b)) : $61de1ee1cac498ae$var$ID(a) ? a.Fb(b) : $61de1ee1cac498ae$var$MC(a) ? $61de1ee1cac498ae$var$mb(a, b) : $61de1ee1cac498ae$var$qz(a, b);
}
function $61de1ee1cac498ae$var$r6d(a) {
    return !a ? null : (a.i & 1) != 0 ? a == $61de1ee1cac498ae$var$sbb ? $61de1ee1cac498ae$var$wI : a == $61de1ee1cac498ae$var$WD ? $61de1ee1cac498ae$var$JI : a == $61de1ee1cac498ae$var$VD ? $61de1ee1cac498ae$var$FI : a == $61de1ee1cac498ae$var$UD ? $61de1ee1cac498ae$var$BI : a == $61de1ee1cac498ae$var$XD ? $61de1ee1cac498ae$var$MI : a == $61de1ee1cac498ae$var$rbb ? $61de1ee1cac498ae$var$UI : a == $61de1ee1cac498ae$var$SD ? $61de1ee1cac498ae$var$xI : $61de1ee1cac498ae$var$yI : a;
}
function $61de1ee1cac498ae$var$Fhb(a, b, c, d, e) {
    if (b == 0 || d == 0) return;
    b == 1 ? e[d] = $61de1ee1cac498ae$var$Hhb(e, c, d, a[0]) : d == 1 ? e[b] = $61de1ee1cac498ae$var$Hhb(e, a, b, c[0]) : $61de1ee1cac498ae$var$Ghb(a, c, e, b, d);
}
function $61de1ee1cac498ae$var$c6b(a, b) {
    var c;
    if (a.c.length == 0) return;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, a.c.length, 0, 1)), 193);
    $61de1ee1cac498ae$var$Nlb(c, new $61de1ee1cac498ae$var$o6b);
    $61de1ee1cac498ae$var$_5b(c, b);
}
function $61de1ee1cac498ae$var$i6b(a, b) {
    var c;
    if (a.c.length == 0) return;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, a.c.length, 0, 1)), 193);
    $61de1ee1cac498ae$var$Nlb(c, new $61de1ee1cac498ae$var$t6b);
    $61de1ee1cac498ae$var$_5b(c, b);
}
function $61de1ee1cac498ae$var$Ekd(a, b, c, d) {
    switch(b){
        case 1:
            return !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), a.n;
        case 2:
            return a.k;
    }
    return $61de1ee1cac498ae$var$bkd(a, b, c, d);
}
function $61de1ee1cac498ae$var$ead() {
    $61de1ee1cac498ae$var$ead = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$cad = new $61de1ee1cac498ae$var$iad($61de1ee1cac498ae$var$ole, 0);
    $61de1ee1cac498ae$var$bad = new $61de1ee1cac498ae$var$iad($61de1ee1cac498ae$var$kle, 1);
    $61de1ee1cac498ae$var$aad = new $61de1ee1cac498ae$var$iad($61de1ee1cac498ae$var$jle, 2);
    $61de1ee1cac498ae$var$_9c = new $61de1ee1cac498ae$var$iad($61de1ee1cac498ae$var$vle, 3);
    $61de1ee1cac498ae$var$dad = new $61de1ee1cac498ae$var$iad("UP", 4);
}
function $61de1ee1cac498ae$var$RXb() {
    $61de1ee1cac498ae$var$RXb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$QXb = new $61de1ee1cac498ae$var$SXb($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$PXb = new $61de1ee1cac498ae$var$SXb("INSIDE_PORT_SIDE_GROUPS", 1);
    $61de1ee1cac498ae$var$OXb = new $61de1ee1cac498ae$var$SXb("FORCE_MODEL_ORDER", 2);
}
function $61de1ee1cac498ae$var$xCb(a, b, c) {
    if (a < 0 || b > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$xke + a + $61de1ee1cac498ae$var$zke + b + ", size: " + c));
    if (a > b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$xke + a + $61de1ee1cac498ae$var$yke + b));
}
function $61de1ee1cac498ae$var$eid(a, b, c) {
    if (b < 0) $61de1ee1cac498ae$var$vid(a, c);
    else {
        if (!c.Ij()) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + c.ne() + $61de1ee1cac498ae$var$jte));
        $61de1ee1cac498ae$var$BD(c, 66).Nj().Vj(a, a.yh(), b);
    }
}
function $61de1ee1cac498ae$var$Jlb(a, b, c, d, e, f, g, h) {
    var i;
    i = c;
    while(f < g)i >= d || b < c && h.ue(a[b], a[i]) <= 0 ? $61de1ee1cac498ae$var$NC(e, f++, a[b++]) : $61de1ee1cac498ae$var$NC(e, f++, a[i++]);
}
function $61de1ee1cac498ae$var$yZb(a, b, c, d, e, f) {
    this.e = new $61de1ee1cac498ae$var$Rkb;
    this.f = ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$JAc);
    $61de1ee1cac498ae$var$Ekb(this.e, a);
    this.d = b;
    this.a = c;
    this.b = d;
    this.f = e;
    this.c = f;
}
function $61de1ee1cac498ae$var$VOd(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$Fyd(a); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 26);
        if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(c)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$uJb(a) {
    $61de1ee1cac498ae$var$qJb();
    var b, c, d, e;
    for(c = $61de1ee1cac498ae$var$wJb(), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        if ($61de1ee1cac498ae$var$Jkb(b.a, a, 0) != -1) return b;
    }
    return $61de1ee1cac498ae$var$pJb;
}
function $61de1ee1cac498ae$var$jFd(a) {
    if (a >= 65 && a <= 70) return a - 65 + 10;
    if (a >= 97 && a <= 102) return a - 97 + 10;
    if (a >= 48 && a <= 57) return a - 48;
    return 0;
}
function $61de1ee1cac498ae$var$QHd(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$Eid(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(a));
    b.a += " (source: ";
    $61de1ee1cac498ae$var$Efb(b, a.d);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$OQd(a, b, c) {
    var d, e;
    e = a.a;
    a.a = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 5, e, a.a);
        !c ? c = d : $61de1ee1cac498ae$var$Qwd(c, d);
    }
    return c;
}
function $61de1ee1cac498ae$var$BId(a, b) {
    var c;
    c = (a.Bb & 256) != 0;
    b ? a.Bb |= 256 : a.Bb &= -257;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 2, c, b));
}
function $61de1ee1cac498ae$var$eLd(a, b) {
    var c;
    c = (a.Bb & 256) != 0;
    b ? a.Bb |= 256 : a.Bb &= -257;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 8, c, b));
}
function $61de1ee1cac498ae$var$LPd(a, b) {
    var c;
    c = (a.Bb & 256) != 0;
    b ? a.Bb |= 256 : a.Bb &= -257;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 8, c, b));
}
function $61de1ee1cac498ae$var$CId(a, b) {
    var c;
    c = (a.Bb & 512) != 0;
    b ? a.Bb |= 512 : a.Bb &= -513;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 3, c, b));
}
function $61de1ee1cac498ae$var$fLd(a, b) {
    var c;
    c = (a.Bb & 512) != 0;
    b ? a.Bb |= 512 : a.Bb &= -513;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 9, c, b));
}
function $61de1ee1cac498ae$var$N7d(a, b) {
    var c;
    if (a.b == -1 && !!a.a) {
        c = a.a.Gj();
        a.b = !c ? $61de1ee1cac498ae$var$bLd(a.c.Tg(), a.a) : a.c.Xg(a.a.aj(), c);
    }
    return a.c.Og(a.b, b);
}
function $61de1ee1cac498ae$var$meb(a) {
    var b, c;
    if (a > -129 && a < 128) {
        b = a + 128;
        c = ($61de1ee1cac498ae$var$oeb(), $61de1ee1cac498ae$var$neb)[b];
        !c && (c = $61de1ee1cac498ae$var$neb[b] = new $61de1ee1cac498ae$var$_db(a));
        return c;
    }
    return new $61de1ee1cac498ae$var$_db(a);
}
function $61de1ee1cac498ae$var$Web(a) {
    var b, c;
    if (a > -129 && a < 128) {
        b = a + 128;
        c = ($61de1ee1cac498ae$var$Yeb(), $61de1ee1cac498ae$var$Xeb)[b];
        !c && (c = $61de1ee1cac498ae$var$Xeb[b] = new $61de1ee1cac498ae$var$Qeb(a));
        return c;
    }
    return new $61de1ee1cac498ae$var$Qeb(a);
}
function $61de1ee1cac498ae$var$L5b(a) {
    var b, c;
    b = a.k;
    if (b == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
        return c == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || c == $61de1ee1cac498ae$var$Rcd;
    }
    return false;
}
function $61de1ee1cac498ae$var$i1d(a, b, c) {
    var d, e, f;
    f = (e = $61de1ee1cac498ae$var$nUd(a.b, b), e);
    if (f) {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$V1d($61de1ee1cac498ae$var$p1d(a, f), ""), 26);
        if (d) return $61de1ee1cac498ae$var$r1d(a, d, b, c);
    }
    return null;
}
function $61de1ee1cac498ae$var$l1d(a, b, c) {
    var d, e, f;
    f = (e = $61de1ee1cac498ae$var$nUd(a.b, b), e);
    if (f) {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$V1d($61de1ee1cac498ae$var$p1d(a, f), ""), 26);
        if (d) return $61de1ee1cac498ae$var$s1d(a, d, b, c);
    }
    return null;
}
function $61de1ee1cac498ae$var$cTd(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$Fyd(a); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 138);
        if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(c)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$vtd(a, b, c) {
    var d;
    d = a.gc();
    if (b > d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(b, d));
    if (a.hi() && a.Hc(c)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$kue));
    a.Xh(b, c);
}
function $61de1ee1cac498ae$var$iqd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$oo(a.i, b);
    if (c == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("Node did not exist in input."));
    $61de1ee1cac498ae$var$Yqd(b, c);
    return null;
}
function $61de1ee1cac498ae$var$$hd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$YKd(a, b);
    if ($61de1ee1cac498ae$var$JD(c, 322)) return $61de1ee1cac498ae$var$BD(c, 34);
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b + "' is not a valid attribute"));
}
function $61de1ee1cac498ae$var$V2d(a, b, c) {
    var d, e;
    e = $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0 ? new $61de1ee1cac498ae$var$s4d(b, a) : new $61de1ee1cac498ae$var$p4d(b, a);
    for(d = 0; d < c; ++d)$61de1ee1cac498ae$var$d4d(e);
    return e;
}
function $61de1ee1cac498ae$var$ede(a) {
    var b, c, d;
    d = 0;
    c = a.length;
    for(b = 0; b < c; b++)a[b] == 32 || a[b] == 13 || a[b] == 10 || a[b] == 9 || (a[d++] = a[b]);
    return d;
}
function $61de1ee1cac498ae$var$lYb(a) {
    var b, c, d;
    b = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 594);
        $61de1ee1cac498ae$var$Gkb(b, $61de1ee1cac498ae$var$BD(c.jf(), 14));
    }
    return b;
}
function $61de1ee1cac498ae$var$SSc(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$gTc)), 15);
    for(d = b.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 188);
        $61de1ee1cac498ae$var$Dsb(c.b.d, c);
        $61de1ee1cac498ae$var$Dsb(c.c.b, c);
    }
}
function $61de1ee1cac498ae$var$b5b(a) {
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Osc)), 303).g){
        case 1:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Osc, ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$bsc));
            break;
        case 2:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Osc, ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$dsc));
    }
}
function $61de1ee1cac498ae$var$_Fc(a) {
    var b;
    if (a.g) {
        b = a.c.Rf() ? a.f : a.a;
        $61de1ee1cac498ae$var$bGc(b.a, a.o, true);
        $61de1ee1cac498ae$var$bGc(b.a, a.o, false);
        $61de1ee1cac498ae$var$yNb(a.o, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$Zbd));
    }
}
function $61de1ee1cac498ae$var$loc(a) {
    var b;
    if (!a.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Cannot offset an unassigned cut."));
    b = a.c - a.b;
    a.b += b;
    $61de1ee1cac498ae$var$noc(a, b);
    $61de1ee1cac498ae$var$ooc(a, b);
}
function $61de1ee1cac498ae$var$ckb(a) {
    var b;
    b = a.a[a.c - 1 & a.a.length - 1];
    if (b == null) return null;
    a.c = a.c - 1 & a.a.length - 1;
    $61de1ee1cac498ae$var$NC(a.a, a.c, null);
    return b;
}
function $61de1ee1cac498ae$var$zGb(a) {
    var b, c;
    for(c = a.p.a.ec().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 213);
        if (b.f && a.b[b.c] < -0.0000000001) return b;
    }
    return null;
}
function $61de1ee1cac498ae$var$bLb(a, b) {
    switch(a.b.g){
        case 0:
        case 1:
            return b;
        case 2:
        case 3:
            return new $61de1ee1cac498ae$var$J6c(b.d, 0, b.a, b.b);
        default:
            return null;
    }
}
function $61de1ee1cac498ae$var$had(a) {
    switch(a.g){
        case 2:
            return $61de1ee1cac498ae$var$bad;
        case 1:
            return $61de1ee1cac498ae$var$aad;
        case 4:
            return $61de1ee1cac498ae$var$_9c;
        case 3:
            return $61de1ee1cac498ae$var$dad;
        default:
            return $61de1ee1cac498ae$var$cad;
    }
}
function $61de1ee1cac498ae$var$Vcd(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$Tcd;
        case 2:
            return $61de1ee1cac498ae$var$Acd;
        case 3:
            return $61de1ee1cac498ae$var$zcd;
        case 4:
            return $61de1ee1cac498ae$var$Rcd;
        default:
            return $61de1ee1cac498ae$var$Scd;
    }
}
function $61de1ee1cac498ae$var$Wcd(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$Rcd;
        case 2:
            return $61de1ee1cac498ae$var$Tcd;
        case 3:
            return $61de1ee1cac498ae$var$Acd;
        case 4:
            return $61de1ee1cac498ae$var$zcd;
        default:
            return $61de1ee1cac498ae$var$Scd;
    }
}
function $61de1ee1cac498ae$var$Xcd(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$zcd;
        case 2:
            return $61de1ee1cac498ae$var$Rcd;
        case 3:
            return $61de1ee1cac498ae$var$Tcd;
        case 4:
            return $61de1ee1cac498ae$var$Acd;
        default:
            return $61de1ee1cac498ae$var$Scd;
    }
}
function $61de1ee1cac498ae$var$DPc(a) {
    switch(a){
        case 0:
            return new $61de1ee1cac498ae$var$OPc;
        case 1:
            return new $61de1ee1cac498ae$var$EPc;
        case 2:
            return new $61de1ee1cac498ae$var$JPc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Vdb);
    }
}
function $61de1ee1cac498ae$var$Kdb(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    if (a == b) return a == 0 ? $61de1ee1cac498ae$var$Kdb(1 / a, 1 / b) : 0;
    return isNaN(a) ? isNaN(b) ? 0 : 1 : -1;
}
function $61de1ee1cac498ae$var$f4b(a, b) {
    $61de1ee1cac498ae$var$Odd(b, "Sort end labels", 1);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.b, 16)), new $61de1ee1cac498ae$var$q4b), new $61de1ee1cac498ae$var$s4b), new $61de1ee1cac498ae$var$u4b);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$Wxd(a, b, c) {
    var d, e;
    if (a.ej()) {
        e = a.fj();
        d = $61de1ee1cac498ae$var$sud(a, b, c);
        a.$i(a.Zi(7, $61de1ee1cac498ae$var$meb(c), d, b, e));
        return d;
    } else return $61de1ee1cac498ae$var$sud(a, b, c);
}
function $61de1ee1cac498ae$var$vAd(a, b) {
    var c, d, e;
    if (a.d == null) {
        ++a.e;
        --a.f;
    } else {
        e = b.cd();
        c = b.Sh();
        d = (c & $61de1ee1cac498ae$var$Ohe) % a.d.length;
        $61de1ee1cac498ae$var$KAd(a, d, $61de1ee1cac498ae$var$xAd(a, d, c, e));
    }
}
function $61de1ee1cac498ae$var$ZId(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$zte) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$zte : a.Bb &= -1025;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 10, c, b));
}
function $61de1ee1cac498ae$var$dJd(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$Rje) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$Rje : a.Bb &= -4097;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 12, c, b));
}
function $61de1ee1cac498ae$var$eJd(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$Cve) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$Cve : a.Bb &= -8193;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 15, c, b));
}
function $61de1ee1cac498ae$var$fJd(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$Dve) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$Dve : a.Bb &= -2049;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 11, c, b));
}
function $61de1ee1cac498ae$var$jOb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Kdb(a.b.c, b.b.c);
    if (c != 0) return c;
    c = $61de1ee1cac498ae$var$Kdb(a.a.a, b.a.a);
    if (c != 0) return c;
    return $61de1ee1cac498ae$var$Kdb(a.a.b, b.a.b);
}
function $61de1ee1cac498ae$var$jqd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Ohb(a.k, b);
    if (c == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("Port did not exist in input."));
    $61de1ee1cac498ae$var$Yqd(b, c);
    return null;
}
function $61de1ee1cac498ae$var$k6d(a) {
    var b, c;
    for(c = $61de1ee1cac498ae$var$l6d($61de1ee1cac498ae$var$bKd(a)).Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$GD(c.Pb());
        if ($61de1ee1cac498ae$var$Dmd(a, b)) return $61de1ee1cac498ae$var$uFd(($61de1ee1cac498ae$var$tFd(), $61de1ee1cac498ae$var$sFd), b);
    }
    return null;
}
function $61de1ee1cac498ae$var$n3d(a, b) {
    var c, d, e, f, g;
    g = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    f = 0;
    c = $61de1ee1cac498ae$var$BD(a.g, 119);
    for(e = 0; e < a.i; ++e){
        d = c[e];
        g.rl(d.ak()) && ++f;
    }
    return f;
}
function $61de1ee1cac498ae$var$Vsd(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$BD(b.We(a.a), 35);
    e = $61de1ee1cac498ae$var$BD(c.We(a.a), 35);
    return d != null && e != null ? $61de1ee1cac498ae$var$Fcb(d, e) : d != null ? -1 : e != null ? 1 : 0;
}
function $61de1ee1cac498ae$var$ved(a, b, c) {
    var d, e;
    if (a.c) $61de1ee1cac498ae$var$Efd(a.c, b, c);
    else for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 157);
        $61de1ee1cac498ae$var$ved(d, b, c);
    }
}
function $61de1ee1cac498ae$var$RUb(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 46);
        $61de1ee1cac498ae$var$Lkb(a.b.b, c.b);
        $61de1ee1cac498ae$var$fVb($61de1ee1cac498ae$var$BD(c.a, 189), $61de1ee1cac498ae$var$BD(c.b, 81));
    }
}
function $61de1ee1cac498ae$var$tr(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$Kfb(new $61de1ee1cac498ae$var$Ufb, 91);
    b = true;
    while(a.Ob()){
        b || (c.a += $61de1ee1cac498ae$var$She, c);
        b = false;
        $61de1ee1cac498ae$var$Pfb(c, a.Pb());
    }
    return (c.a += "]", c).a;
}
function $61de1ee1cac498ae$var$aJd(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$oie) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$oie : a.Bb &= -16385;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 16, c, b));
}
function $61de1ee1cac498ae$var$MJd(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$ote) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$ote : a.Bb &= -32769;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 18, c, b));
}
function $61de1ee1cac498ae$var$CUd(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$ote) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$ote : a.Bb &= -32769;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 18, c, b));
}
function $61de1ee1cac498ae$var$EUd(a, b) {
    var c;
    c = (a.Bb & $61de1ee1cac498ae$var$Tje) != 0;
    b ? a.Bb |= $61de1ee1cac498ae$var$Tje : a.Bb &= -65537;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$qSd(a, 1, 20, c, b));
}
function $61de1ee1cac498ae$var$Tee(a) {
    var b;
    b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, 2, 15, 1);
    a -= $61de1ee1cac498ae$var$Tje;
    b[0] = (a >> 10) + $61de1ee1cac498ae$var$Uje & $61de1ee1cac498ae$var$aje;
    b[1] = (a & 1023) + 56320 & $61de1ee1cac498ae$var$aje;
    return $61de1ee1cac498ae$var$zfb(b, 0, b.length);
}
function $61de1ee1cac498ae$var$a_b(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lwc)), 103);
    if (c == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad)) {
        b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$owc)));
        return b >= 1 ? $61de1ee1cac498ae$var$bad : $61de1ee1cac498ae$var$_9c;
    }
    return c;
}
function $61de1ee1cac498ae$var$rec(a) {
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Swc)), 218).g){
        case 1:
            return new $61de1ee1cac498ae$var$Fmc;
        case 3:
            return new $61de1ee1cac498ae$var$wnc;
        default:
            return new $61de1ee1cac498ae$var$zmc;
    }
}
function $61de1ee1cac498ae$var$Uzb(a) {
    if (a.c) $61de1ee1cac498ae$var$Uzb(a.c);
    else if (a.d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Stream already terminated, can't be modified or used"));
}
function $61de1ee1cac498ae$var$Mkd(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$Eid(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(a));
    b.a += " (identifier: ";
    $61de1ee1cac498ae$var$Efb(b, a.k);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$ctd(a, b, c) {
    var d, e;
    d = ($61de1ee1cac498ae$var$Fhd(), e = new $61de1ee1cac498ae$var$xkd, e);
    $61de1ee1cac498ae$var$vkd(d, b);
    $61de1ee1cac498ae$var$wkd(d, c);
    !!a && $61de1ee1cac498ae$var$wtd((!a.a && (a.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, a, 5)), a.a), d);
    return d;
}
function $61de1ee1cac498ae$var$ttb(a, b, c, d) {
    var e, f;
    $61de1ee1cac498ae$var$uCb(d);
    $61de1ee1cac498ae$var$uCb(c);
    e = a.xc(b);
    f = e == null ? c : $61de1ee1cac498ae$var$Myb($61de1ee1cac498ae$var$BD(e, 15), $61de1ee1cac498ae$var$BD(c, 14));
    f == null ? a.Bc(b) : a.zc(b, f);
    return f;
}
function $61de1ee1cac498ae$var$pqb(a) {
    var b, c, d, e;
    c = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb((d = a.gm, e = d.f, e == $61de1ee1cac498ae$var$CI ? d : e)), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0));
    $61de1ee1cac498ae$var$rqb(c, a);
    return c;
}
function $61de1ee1cac498ae$var$hDc(a, b, c) {
    var d, e;
    for(e = a.a.ec().Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 10);
        if ($61de1ee1cac498ae$var$Be(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b, d.p), 14))) return d;
    }
    return null;
}
function $61de1ee1cac498ae$var$Db(b, c, d) {
    var e;
    try {
        $61de1ee1cac498ae$var$Cb(b, c, d);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 597)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$ycb(e));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    return c;
}
function $61de1ee1cac498ae$var$Qbb(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$Fbb(a) && $61de1ee1cac498ae$var$Fbb(b)) {
        c = a - b;
        if ($61de1ee1cac498ae$var$Kje < c && c < $61de1ee1cac498ae$var$Ije) return c;
    }
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$nD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b));
}
function $61de1ee1cac498ae$var$wbb(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$Fbb(a) && $61de1ee1cac498ae$var$Fbb(b)) {
        c = a + b;
        if ($61de1ee1cac498ae$var$Kje < c && c < $61de1ee1cac498ae$var$Ije) return c;
    }
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$cD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b));
}
function $61de1ee1cac498ae$var$Ibb(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$Fbb(a) && $61de1ee1cac498ae$var$Fbb(b)) {
        c = a * b;
        if ($61de1ee1cac498ae$var$Kje < c && c < $61de1ee1cac498ae$var$Ije) return c;
    }
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$gD($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b));
}
function $61de1ee1cac498ae$var$V_b(a, b) {
    var c;
    a.i || $61de1ee1cac498ae$var$N_b(a);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.g, b), 46);
    return !c ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb) : new $61de1ee1cac498ae$var$Jib(a.j, $61de1ee1cac498ae$var$BD(c.a, 19).a, $61de1ee1cac498ae$var$BD(c.b, 19).a);
}
function $61de1ee1cac498ae$var$Drb(a, b, c) {
    var d;
    d = a.a.get(b);
    a.a.set(b, c === undefined ? null : c);
    if (d === undefined) {
        ++a.c;
        $61de1ee1cac498ae$var$zpb(a.b);
    } else ++a.d;
    return d;
}
function $61de1ee1cac498ae$var$kNb(a, b, c) {
    a.n = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$XD, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$Sje
    ], [
        364,
        25
    ], 14, [
        c,
        $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(b / 32))
    ], 2);
    a.o = b;
    a.p = c;
    a.j = b - 1 >> 1;
    a.k = c - 1 >> 1;
}
function $61de1ee1cac498ae$var$Gub() {
    $61de1ee1cac498ae$var$zub();
    var a, b, c;
    c = $61de1ee1cac498ae$var$yub++ + Date.now();
    a = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.floor(c * $61de1ee1cac498ae$var$lke)) & $61de1ee1cac498ae$var$nke;
    b = $61de1ee1cac498ae$var$QD(c - a * $61de1ee1cac498ae$var$mke);
    this.a = a ^ 1502;
    this.b = b ^ $61de1ee1cac498ae$var$kke;
}
function $61de1ee1cac498ae$var$O_b(a) {
    var b, c, d;
    b = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$olb(a.j); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 11);
        $61de1ee1cac498ae$var$Ekb(b, c.b);
    }
    return $61de1ee1cac498ae$var$Qb(b), new $61de1ee1cac498ae$var$sl(b);
}
function $61de1ee1cac498ae$var$R_b(a) {
    var b, c, d;
    b = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$olb(a.j); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 11);
        $61de1ee1cac498ae$var$Ekb(b, c.e);
    }
    return $61de1ee1cac498ae$var$Qb(b), new $61de1ee1cac498ae$var$sl(b);
}
function $61de1ee1cac498ae$var$U_b(a) {
    var b, c, d;
    b = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$olb(a.j); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 11);
        $61de1ee1cac498ae$var$Ekb(b, c.g);
    }
    return $61de1ee1cac498ae$var$Qb(b), new $61de1ee1cac498ae$var$sl(b);
}
function $61de1ee1cac498ae$var$n6d(a) {
    var b, c;
    for(c = $61de1ee1cac498ae$var$o6d($61de1ee1cac498ae$var$bKd($61de1ee1cac498ae$var$WId(a))).Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$GD(c.Pb());
        if ($61de1ee1cac498ae$var$Dmd(a, b)) return $61de1ee1cac498ae$var$FFd(($61de1ee1cac498ae$var$EFd(), $61de1ee1cac498ae$var$DFd), b);
    }
    return null;
}
function $61de1ee1cac498ae$var$wm(a) {
    var b, c, d;
    for(c = 0, d = a.length; c < d; c++){
        if (a[c] == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb("at index " + c));
    }
    b = a;
    return new $61de1ee1cac498ae$var$amb(b);
}
function $61de1ee1cac498ae$var$wid(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$YKd(a.Tg(), b);
    if ($61de1ee1cac498ae$var$JD(c, 99)) return $61de1ee1cac498ae$var$BD(c, 18);
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b + "' is not a valid reference"));
}
function $61de1ee1cac498ae$var$Tdb(a) {
    var b;
    b = $61de1ee1cac498ae$var$Hcb(a);
    if (b > 3.4028234663852886E38) return $61de1ee1cac498ae$var$Pje;
    else if (b < -340282346638528860000000000000000000000) return $61de1ee1cac498ae$var$Qje;
    return b;
}
function $61de1ee1cac498ae$var$aeb(a) {
    a -= a >> 1 & 1431655765;
    a = (a >> 2 & 858993459) + (a & 858993459);
    a = (a >> 4) + a & 252645135;
    a += a >> 8;
    a += a >> 16;
    return a & 63;
}
function $61de1ee1cac498ae$var$Ev(a) {
    var b, c, d, e;
    b = new $61de1ee1cac498ae$var$cq(a.Hd().gc());
    e = 0;
    for(d = $61de1ee1cac498ae$var$vr(a.Hd().Kc()); d.Ob();){
        c = d.Pb();
        $61de1ee1cac498ae$var$bq(b, c, $61de1ee1cac498ae$var$meb(e++));
    }
    return $61de1ee1cac498ae$var$fn(b.a);
}
function $61de1ee1cac498ae$var$Uyb(a, b) {
    var c, d, e;
    e = new $61de1ee1cac498ae$var$Lqb;
    for(d = b.vc().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 42);
        $61de1ee1cac498ae$var$Rhb(e, c.cd(), $61de1ee1cac498ae$var$Yyb(a, $61de1ee1cac498ae$var$BD(c.dd(), 15)));
    }
    return e;
}
function $61de1ee1cac498ae$var$EZc(a, b) {
    a.n.c.length == 0 && $61de1ee1cac498ae$var$Ekb(a.n, new $61de1ee1cac498ae$var$VZc(a.s, a.t, a.i));
    $61de1ee1cac498ae$var$Ekb(a.b, b);
    $61de1ee1cac498ae$var$QZc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.n, a.n.c.length - 1), 211), b);
    $61de1ee1cac498ae$var$GZc(a, b);
}
function $61de1ee1cac498ae$var$LFb(a) {
    if (a.c != a.b.b || a.i != a.g.b) {
        a.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        $61de1ee1cac498ae$var$Gkb(a.a, a.b);
        $61de1ee1cac498ae$var$Gkb(a.a, a.g);
        a.c = a.b.b;
        a.i = a.g.b;
    }
    return a.a;
}
function $61de1ee1cac498ae$var$Ycc(a, b) {
    var c, d, e;
    e = 0;
    for(d = $61de1ee1cac498ae$var$BD(b.Kb(a), 20).Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 17);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc)))) || ++e;
    }
    return e;
}
function $61de1ee1cac498ae$var$efc(a, b) {
    var c, d, e;
    d = $61de1ee1cac498ae$var$tgc(b);
    e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$lyc))));
    c = $61de1ee1cac498ae$var$$wnd.Math.max(0, e / 2 - 0.5);
    $61de1ee1cac498ae$var$cfc(b, c, 1);
    $61de1ee1cac498ae$var$Ekb(a, new $61de1ee1cac498ae$var$Dfc(b, c));
}
function $61de1ee1cac498ae$var$Ctc() {
    $61de1ee1cac498ae$var$Ctc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Btc = new $61de1ee1cac498ae$var$Dtc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$xtc = new $61de1ee1cac498ae$var$Dtc("FIRST", 1);
    $61de1ee1cac498ae$var$ytc = new $61de1ee1cac498ae$var$Dtc($61de1ee1cac498ae$var$Gne, 2);
    $61de1ee1cac498ae$var$ztc = new $61de1ee1cac498ae$var$Dtc("LAST", 3);
    $61de1ee1cac498ae$var$Atc = new $61de1ee1cac498ae$var$Dtc($61de1ee1cac498ae$var$Hne, 4);
}
function $61de1ee1cac498ae$var$Aad() {
    $61de1ee1cac498ae$var$Aad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$zad = new $61de1ee1cac498ae$var$Bad($61de1ee1cac498ae$var$ole, 0);
    $61de1ee1cac498ae$var$xad = new $61de1ee1cac498ae$var$Bad("POLYLINE", 1);
    $61de1ee1cac498ae$var$wad = new $61de1ee1cac498ae$var$Bad("ORTHOGONAL", 2);
    $61de1ee1cac498ae$var$yad = new $61de1ee1cac498ae$var$Bad("SPLINES", 3);
}
function $61de1ee1cac498ae$var$zYc() {
    $61de1ee1cac498ae$var$zYc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xYc = new $61de1ee1cac498ae$var$AYc("ASPECT_RATIO_DRIVEN", 0);
    $61de1ee1cac498ae$var$yYc = new $61de1ee1cac498ae$var$AYc("MAX_SCALE_DRIVEN", 1);
    $61de1ee1cac498ae$var$wYc = new $61de1ee1cac498ae$var$AYc("AREA_DRIVEN", 2);
}
function $61de1ee1cac498ae$var$Y$c() {
    $61de1ee1cac498ae$var$Y$c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$V$c = new $61de1ee1cac498ae$var$Z$c("P1_STRUCTURE", 0);
    $61de1ee1cac498ae$var$W$c = new $61de1ee1cac498ae$var$Z$c("P2_PROCESSING_ORDER", 1);
    $61de1ee1cac498ae$var$X$c = new $61de1ee1cac498ae$var$Z$c("P3_EXECUTION", 2);
}
function $61de1ee1cac498ae$var$tVc() {
    $61de1ee1cac498ae$var$tVc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$sVc = new $61de1ee1cac498ae$var$uVc("OVERLAP_REMOVAL", 0);
    $61de1ee1cac498ae$var$qVc = new $61de1ee1cac498ae$var$uVc("COMPACTION", 1);
    $61de1ee1cac498ae$var$rVc = new $61de1ee1cac498ae$var$uVc("GRAPH_SIZE_CALCULATION", 2);
}
function $61de1ee1cac498ae$var$Jy(a, b) {
    $61de1ee1cac498ae$var$Iy();
    return $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Qie), $61de1ee1cac498ae$var$$wnd.Math.abs(a - b) <= $61de1ee1cac498ae$var$Qie || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(a), isNaN(b));
}
function $61de1ee1cac498ae$var$yOc(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$Jsb(a, 0);
    while(c.b != c.d.c){
        d = $61de1ee1cac498ae$var$Gdb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(c)));
        if (d == b) return;
        else if (d > b) {
            $61de1ee1cac498ae$var$Ysb(c);
            break;
        }
    }
    $61de1ee1cac498ae$var$Vsb(c, b);
}
function $61de1ee1cac498ae$var$t4c(a, b) {
    var c, d, e, f, g;
    c = b.f;
    $61de1ee1cac498ae$var$Xrb(a.c.d, c, b);
    if (b.g != null) for(e = b.g, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        $61de1ee1cac498ae$var$Xrb(a.c.e, d, b);
    }
}
function $61de1ee1cac498ae$var$Ilb(a, b, c, d) {
    var e, f, g;
    for(e = b + 1; e < c; ++e)for(f = e; f > b && d.ue(a[f - 1], a[f]) > 0; --f){
        g = a[f];
        $61de1ee1cac498ae$var$NC(a, f, a[f - 1]);
        $61de1ee1cac498ae$var$NC(a, f - 1, g);
    }
}
function $61de1ee1cac498ae$var$did(a, b, c, d) {
    if (b < 0) $61de1ee1cac498ae$var$uid(a, c, d);
    else {
        if (!c.Ij()) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + c.ne() + $61de1ee1cac498ae$var$jte));
        $61de1ee1cac498ae$var$BD(c, 66).Nj().Tj(a, a.yh(), b, d);
    }
}
function $61de1ee1cac498ae$var$xFb(a, b) {
    if (b == a.d) return a.e;
    else if (b == a.e) return a.d;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Node " + b + " not part of edge " + a));
}
function $61de1ee1cac498ae$var$iEb(a, b) {
    switch(b.g){
        case 2:
            return a.b;
        case 1:
            return a.c;
        case 4:
            return a.d;
        case 3:
            return a.a;
        default:
            return false;
    }
}
function $61de1ee1cac498ae$var$GVb(a, b) {
    switch(b.g){
        case 2:
            return a.b;
        case 1:
            return a.c;
        case 4:
            return a.d;
        case 3:
            return a.a;
        default:
            return false;
    }
}
function $61de1ee1cac498ae$var$Xkd(a, b, c, d) {
    switch(b){
        case 3:
            return a.f;
        case 4:
            return a.g;
        case 5:
            return a.i;
        case 6:
            return a.j;
    }
    return $61de1ee1cac498ae$var$Ekd(a, b, c, d);
}
function $61de1ee1cac498ae$var$Ljc(a) {
    if (a.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) return false;
    return $61de1ee1cac498ae$var$FAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)))), new $61de1ee1cac498ae$var$Mjc);
}
function $61de1ee1cac498ae$var$MEd(a) {
    if (a.e == null) return a;
    else !a.c && (a.c = new $61de1ee1cac498ae$var$NEd((a.f & 256) != 0, a.i, a.a, a.d, (a.f & 16) != 0, a.j, a.g, null));
    return a.c;
}
function $61de1ee1cac498ae$var$VC(a, b) {
    if (a.h == $61de1ee1cac498ae$var$Gje && a.m == 0 && a.l == 0) {
        b && ($61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$TC(0, 0, 0));
        return $61de1ee1cac498ae$var$SC(($61de1ee1cac498ae$var$wD(), $61de1ee1cac498ae$var$uD));
    }
    b && ($61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$TC(a.l, a.m, a.h));
    return $61de1ee1cac498ae$var$TC(0, 0, 0);
}
function $61de1ee1cac498ae$var$fcb(a) {
    var b;
    if (Array.isArray(a) && a.im === $61de1ee1cac498ae$var$gcb) return $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$rb(a)) + "@" + (b = $61de1ee1cac498ae$var$tb(a) >>> 0, b.toString(16));
    return a.toString();
}
function $61de1ee1cac498ae$var$Rpb(a) {
    var b;
    this.a = (b = $61de1ee1cac498ae$var$BD(a.e && a.e(), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0));
    this.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, this.a.a.length, 5, 1);
}
function $61de1ee1cac498ae$var$_Ob(a) {
    var b, c, d;
    this.a = new $61de1ee1cac498ae$var$zsb;
    for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 14);
        b = new $61de1ee1cac498ae$var$MOb;
        $61de1ee1cac498ae$var$GOb(b, c);
        $61de1ee1cac498ae$var$Qqb(this.a, b);
    }
}
function $61de1ee1cac498ae$var$cKb(a) {
    $61de1ee1cac498ae$var$$Jb();
    var b, c, d, e;
    b = a.o.b;
    for(d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd)), 21), 84).Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 111);
        e = c.e;
        e.b += b;
    }
}
function $61de1ee1cac498ae$var$ag(a) {
    var b;
    if (a.b) {
        $61de1ee1cac498ae$var$ag(a.b);
        if (a.b.d != a.c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
    } else if (a.d.dc()) {
        b = $61de1ee1cac498ae$var$BD(a.f.c.xc(a.e), 14);
        !!b && (a.d = b);
    }
}
function $61de1ee1cac498ae$var$fFd(a) {
    var b;
    if (a == null) return true;
    b = a.length;
    return b > 0 && ($61de1ee1cac498ae$var$BCb(b - 1, a.length), a.charCodeAt(b - 1) == 58) && !$61de1ee1cac498ae$var$OEd(a, $61de1ee1cac498ae$var$CEd, $61de1ee1cac498ae$var$DEd);
}
function $61de1ee1cac498ae$var$OEd(a, b, c) {
    var d, e;
    for(d = 0, e = a.length; d < e; d++){
        if ($61de1ee1cac498ae$var$_Ed(($61de1ee1cac498ae$var$BCb(d, a.length), a.charCodeAt(d)), b, c)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$JOb(a, b) {
    var c, d;
    for(d = a.e.a.ec().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 266);
        if ($61de1ee1cac498ae$var$t6c(b, c.d) || $61de1ee1cac498ae$var$o6c(b, c.d)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Q9b(a, b) {
    var c, d, e;
    d = $61de1ee1cac498ae$var$N9b(a, b);
    e = d[d.length - 1] / 2;
    for(c = 0; c < d.length; c++){
        if (d[c] >= e) return b.c + c;
    }
    return b.c + b.b.gc();
}
function $61de1ee1cac498ae$var$NCd(a, b) {
    $61de1ee1cac498ae$var$LCd();
    var c, d, e, f;
    d = $61de1ee1cac498ae$var$KLd(a);
    e = b;
    $61de1ee1cac498ae$var$Klb(d, 0, d.length, e);
    for(c = 0; c < d.length; c++){
        f = $61de1ee1cac498ae$var$MCd(a, d[c], c);
        c != f && $61de1ee1cac498ae$var$Wxd(a, c, f);
    }
}
function $61de1ee1cac498ae$var$EHb(a, b) {
    var c, d, e, f, g, h;
    d = 0;
    c = 0;
    for(f = b, g = 0, h = f.length; g < h; ++g){
        e = f[g];
        if (e > 0) {
            d += e;
            ++c;
        }
    }
    c > 1 && (d += a.d * (c - 1));
    return d;
}
function $61de1ee1cac498ae$var$Htd(a) {
    var b, c, d;
    d = new $61de1ee1cac498ae$var$Hfb;
    d.a += "[";
    for(b = 0, c = a.gc(); b < c;){
        $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$xfb(a.ki(b)));
        ++b < c && (d.a += $61de1ee1cac498ae$var$She, d);
    }
    d.a += "]";
    return d.a;
}
function $61de1ee1cac498ae$var$fsd(a) {
    var b, c, d, e, f;
    f = $61de1ee1cac498ae$var$hsd(a);
    c = $61de1ee1cac498ae$var$Fhe(a.c);
    d = !c;
    if (d) {
        e = new $61de1ee1cac498ae$var$wB;
        $61de1ee1cac498ae$var$cC(f, "knownLayouters", e);
        b = new $61de1ee1cac498ae$var$qsd(e);
        $61de1ee1cac498ae$var$reb(a.c, b);
    }
    return f;
}
function $61de1ee1cac498ae$var$Ce(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$uCb(b);
    c = false;
    for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
        e = $61de1ee1cac498ae$var$mlb(d);
        if ($61de1ee1cac498ae$var$ze(b, e, false)) {
            $61de1ee1cac498ae$var$nlb(d);
            c = true;
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$UGb(a) {
    var b, c, d;
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(a.a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Q9c))));
    for(c = new $61de1ee1cac498ae$var$olb(a.a.xf()); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 680);
        $61de1ee1cac498ae$var$XGb(a, b, d);
    }
}
function $61de1ee1cac498ae$var$MUb(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 46);
        $61de1ee1cac498ae$var$Ekb(a.b.b, $61de1ee1cac498ae$var$BD(c.b, 81));
        $61de1ee1cac498ae$var$eVb($61de1ee1cac498ae$var$BD(c.a, 189), $61de1ee1cac498ae$var$BD(c.b, 81));
    }
}
function $61de1ee1cac498ae$var$XCc(a, b, c) {
    var d, e;
    e = a.a.b;
    for(d = e.c.length; d < c; d++)$61de1ee1cac498ae$var$Dkb(e, 0, new $61de1ee1cac498ae$var$H1b(a.a));
    $61de1ee1cac498ae$var$$_b(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e, e.c.length - c), 29));
    a.b[b.p] = c;
}
function $61de1ee1cac498ae$var$JTb(a, b, c) {
    var d;
    d = c;
    !d && (d = $61de1ee1cac498ae$var$Ydd(new $61de1ee1cac498ae$var$Zdd, 0));
    $61de1ee1cac498ae$var$Odd(d, $61de1ee1cac498ae$var$Vme, 2);
    $61de1ee1cac498ae$var$qZb(a.b, b, $61de1ee1cac498ae$var$Udd(d, 1));
    $61de1ee1cac498ae$var$LTb(a, b, $61de1ee1cac498ae$var$Udd(d, 1));
    $61de1ee1cac498ae$var$_Yb(b, $61de1ee1cac498ae$var$Udd(d, 1));
    $61de1ee1cac498ae$var$Qdd(d);
}
function $61de1ee1cac498ae$var$eKc(a, b, c, d, e) {
    $61de1ee1cac498ae$var$FJc();
    $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, 0), e.d.e - a), b), e.d));
    $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, 0), c - e.a.e), e.a), d));
}
function $61de1ee1cac498ae$var$e$c(a, b, c, d, e, f) {
    this.a = a;
    this.c = b;
    this.b = c;
    this.f = d;
    this.d = e;
    this.e = f;
    this.c > 0 && this.b > 0 && $61de1ee1cac498ae$var$q$c(this.c, this.b, this.a);
}
function $61de1ee1cac498ae$var$ezc(a) {
    $61de1ee1cac498ae$var$dzc();
    this.c = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$h0, 1), $61de1ee1cac498ae$var$Uhe, 831, 0, [
        $61de1ee1cac498ae$var$Uyc
    ]));
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.a = a;
    $61de1ee1cac498ae$var$Rhb(this.b, $61de1ee1cac498ae$var$bzc, 1);
    $61de1ee1cac498ae$var$Hkb($61de1ee1cac498ae$var$czc, new $61de1ee1cac498ae$var$Xed(this));
}
function $61de1ee1cac498ae$var$I2c(a, b) {
    var c;
    if (a.d) {
        if ($61de1ee1cac498ae$var$Mhb(a.b, b)) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 51);
        else {
            c = b.Kf();
            $61de1ee1cac498ae$var$Rhb(a.b, b, c);
            return c;
        }
    } else return b.Kf();
}
function $61de1ee1cac498ae$var$Kgb(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b)) return true;
    if ($61de1ee1cac498ae$var$JD(b, 91)) {
        c = $61de1ee1cac498ae$var$BD(b, 91);
        return a.e == c.e && a.d == c.d && $61de1ee1cac498ae$var$Lgb(a, c.a);
    }
    return false;
}
function $61de1ee1cac498ae$var$Zcd(a) {
    $61de1ee1cac498ae$var$Ucd();
    switch(a.g){
        case 4:
            return $61de1ee1cac498ae$var$Acd;
        case 1:
            return $61de1ee1cac498ae$var$zcd;
        case 3:
            return $61de1ee1cac498ae$var$Rcd;
        case 2:
            return $61de1ee1cac498ae$var$Tcd;
        default:
            return $61de1ee1cac498ae$var$Scd;
    }
}
function $61de1ee1cac498ae$var$Ykd(a, b) {
    switch(b){
        case 3:
            return a.f != 0;
        case 4:
            return a.g != 0;
        case 5:
            return a.i != 0;
        case 6:
            return a.j != 0;
    }
    return $61de1ee1cac498ae$var$Hkd(a, b);
}
function $61de1ee1cac498ae$var$gWc(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$FXc;
        case 1:
            return new $61de1ee1cac498ae$var$IXc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$jre + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$QUc(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$CXc;
        case 1:
            return new $61de1ee1cac498ae$var$MXc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Dne + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$b1c(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$s1c;
        case 1:
            return new $61de1ee1cac498ae$var$w1c;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Mre + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$qWc(a) {
    switch(a.g){
        case 1:
            return new $61de1ee1cac498ae$var$SVc;
        case 2:
            return new $61de1ee1cac498ae$var$KVc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$jre + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$ryb(a) {
    var b, c;
    if (a.b) return a.b;
    c = $61de1ee1cac498ae$var$lyb ? null : a.d;
    while(c){
        b = $61de1ee1cac498ae$var$lyb ? null : c.b;
        if (b) return b;
        c = $61de1ee1cac498ae$var$lyb ? null : c.d;
    }
    return $61de1ee1cac498ae$var$$xb(), $61de1ee1cac498ae$var$Zxb;
}
function $61de1ee1cac498ae$var$hhb(a) {
    var b, c, d;
    if (a.e == 0) return 0;
    b = a.d << 5;
    c = a.a[a.d - 1];
    if (a.e < 0) {
        d = $61de1ee1cac498ae$var$Mgb(a);
        if (d == a.d - 1) {
            --c;
            c = c | 0;
        }
    }
    b -= $61de1ee1cac498ae$var$heb(c);
    return b;
}
function $61de1ee1cac498ae$var$bhb(a) {
    var b, c, d;
    if (a < $61de1ee1cac498ae$var$Fgb.length) return $61de1ee1cac498ae$var$Fgb[a];
    c = a >> 5;
    b = a & 31;
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, c + 1, 15, 1);
    d[c] = 1 << b;
    return new $61de1ee1cac498ae$var$Vgb(1, c + 1, d);
}
function $61de1ee1cac498ae$var$O2b(a) {
    var b, c, d;
    c = a.zg();
    if (c) {
        b = a.Ug();
        if ($61de1ee1cac498ae$var$JD(b, 160)) {
            d = $61de1ee1cac498ae$var$O2b($61de1ee1cac498ae$var$BD(b, 160));
            if (d != null) return d + "." + c;
        }
        return c;
    }
    return null;
}
function $61de1ee1cac498ae$var$ze(a, b, c) {
    var d, e;
    for(e = a.Kc(); e.Ob();){
        d = e.Pb();
        if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(d) || b != null && $61de1ee1cac498ae$var$pb(b, d)) {
            c && e.Qb();
            return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$zvd(a, b, c) {
    var d, e;
    ++a.j;
    if (c.dc()) return false;
    else {
        for(e = c.Kc(); e.Ob();){
            d = e.Pb();
            a.Hi(b, a.oi(b, d));
            ++b;
        }
        return true;
    }
}
function $61de1ee1cac498ae$var$yA(a, b, c, d) {
    var e, f;
    f = c - b;
    if (f < 3) while(f < 3){
        a *= 10;
        ++f;
    }
    else {
        e = 1;
        while(f > 3){
            e *= 10;
            --f;
        }
        a = (a + (e >> 1)) / e | 0;
    }
    d.i = a;
    return true;
}
function $61de1ee1cac498ae$var$XUb(a) {
    $61de1ee1cac498ae$var$LUb();
    return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$GVb($61de1ee1cac498ae$var$BD(a.a, 81).j, $61de1ee1cac498ae$var$BD(a.b, 103)) || $61de1ee1cac498ae$var$BD(a.a, 81).d.e != 0 && $61de1ee1cac498ae$var$GVb($61de1ee1cac498ae$var$BD(a.a, 81).j, $61de1ee1cac498ae$var$BD(a.b, 103)) ? true : false;
}
function $61de1ee1cac498ae$var$s3c(a) {
    $61de1ee1cac498ae$var$p3c();
    if ($61de1ee1cac498ae$var$BD(a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$b9c)), 174).Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Gdd))) {
        $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$x9c), 174).Fc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$qcd));
        $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$b9c), 174).Mc($61de1ee1cac498ae$var$Gdd);
    }
}
function $61de1ee1cac498ae$var$Gxd(a, b) {
    var c, d;
    if (!b) return false;
    else {
        for(c = 0; c < a.i; ++c){
            d = $61de1ee1cac498ae$var$BD(a.g[c], 366);
            if (d.Di(b)) return false;
        }
        return $61de1ee1cac498ae$var$wtd(a, b);
    }
}
function $61de1ee1cac498ae$var$pvd(a) {
    var b, c, d, e;
    b = new $61de1ee1cac498ae$var$wB;
    for(e = new $61de1ee1cac498ae$var$Dnb(a.b.Kc()); e.b.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.b.Pb(), 686);
        c = $61de1ee1cac498ae$var$lsd(d);
        $61de1ee1cac498ae$var$uB(b, b.a.length, c);
    }
    return b.a;
}
function $61de1ee1cac498ae$var$cLb(a) {
    var b;
    !a.c && (a.c = new $61de1ee1cac498ae$var$VKb);
    $61de1ee1cac498ae$var$Okb(a.d, new $61de1ee1cac498ae$var$jLb);
    $61de1ee1cac498ae$var$_Kb(a);
    b = $61de1ee1cac498ae$var$UKb(a);
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.d, 16)), new $61de1ee1cac498ae$var$CLb(a));
    return b;
}
function $61de1ee1cac498ae$var$mKd(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$qnd(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$qnd(a));
    b.a += " (instanceClassName: ";
    $61de1ee1cac498ae$var$Efb(b, a.D);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$Pqd(a, b) {
    var c, d, e, f;
    if (b) {
        e = $61de1ee1cac498ae$var$Xpd(b, "x");
        c = new $61de1ee1cac498ae$var$bsd(a);
        $61de1ee1cac498ae$var$hmd(c.a, ($61de1ee1cac498ae$var$uCb(e), e));
        f = $61de1ee1cac498ae$var$Xpd(b, "y");
        d = new $61de1ee1cac498ae$var$csd(a);
        $61de1ee1cac498ae$var$imd(d.a, ($61de1ee1cac498ae$var$uCb(f), f));
    }
}
function $61de1ee1cac498ae$var$Eqd(a, b) {
    var c, d, e, f;
    if (b) {
        e = $61de1ee1cac498ae$var$Xpd(b, "x");
        c = new $61de1ee1cac498ae$var$Yrd(a);
        $61de1ee1cac498ae$var$omd(c.a, ($61de1ee1cac498ae$var$uCb(e), e));
        f = $61de1ee1cac498ae$var$Xpd(b, "y");
        d = new $61de1ee1cac498ae$var$_rd(a);
        $61de1ee1cac498ae$var$pmd(d.a, ($61de1ee1cac498ae$var$uCb(f), f));
    }
}
function $61de1ee1cac498ae$var$bLd(a, b) {
    var c, d, e;
    c = (a.i == null && $61de1ee1cac498ae$var$TKd(a), a.i);
    d = b.aj();
    if (d != -1) for(e = c.length; d < e; ++d){
        if (c[d] == b) return d;
    }
    return -1;
}
function $61de1ee1cac498ae$var$tNd(a) {
    var b, c, d, e, f;
    c = $61de1ee1cac498ae$var$BD(a.g, 674);
    for(d = a.i - 1; d >= 0; --d){
        b = c[d];
        for(e = 0; e < d; ++e){
            f = c[e];
            if ($61de1ee1cac498ae$var$uNd(a, b, f)) {
                $61de1ee1cac498ae$var$tud(a, d);
                break;
            }
        }
    }
}
function $61de1ee1cac498ae$var$jCb(b) {
    var c = b.e;
    function d(a) {
        if (!a || a.length == 0) return "";
        return "	" + a.join("\n	");
    }
    return c && (c.stack || d(b[$61de1ee1cac498ae$var$Yie]));
}
function $61de1ee1cac498ae$var$nm(a) {
    $61de1ee1cac498ae$var$im();
    var b;
    b = a.Pc();
    switch(b.length){
        case 0:
            return $61de1ee1cac498ae$var$hm;
        case 1:
            return new $61de1ee1cac498ae$var$my($61de1ee1cac498ae$var$Qb(b[0]));
        default:
            return new $61de1ee1cac498ae$var$ux($61de1ee1cac498ae$var$wm(b));
    }
}
function $61de1ee1cac498ae$var$W_b(a, b) {
    switch(b.g){
        case 1:
            return $61de1ee1cac498ae$var$Nq(a.j, ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$u0b));
        case 2:
            return $61de1ee1cac498ae$var$Nq(a.j, ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$w0b));
        default:
            return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
    }
}
function $61de1ee1cac498ae$var$$kd(a, b) {
    switch(b){
        case 3:
            $61de1ee1cac498ae$var$ald(a, 0);
            return;
        case 4:
            $61de1ee1cac498ae$var$cld(a, 0);
            return;
        case 5:
            $61de1ee1cac498ae$var$dld(a, 0);
            return;
        case 6:
            $61de1ee1cac498ae$var$eld(a, 0);
            return;
    }
    $61de1ee1cac498ae$var$Jkd(a, b);
}
function $61de1ee1cac498ae$var$dzc() {
    $61de1ee1cac498ae$var$dzc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Vyc();
    $61de1ee1cac498ae$var$bzc = ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc);
    $61de1ee1cac498ae$var$czc = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$Q3, 1), $61de1ee1cac498ae$var$zqe, 146, 0, [
        $61de1ee1cac498ae$var$kyc,
        $61de1ee1cac498ae$var$lyc,
        $61de1ee1cac498ae$var$nyc,
        $61de1ee1cac498ae$var$oyc,
        $61de1ee1cac498ae$var$ryc,
        $61de1ee1cac498ae$var$syc,
        $61de1ee1cac498ae$var$tyc,
        $61de1ee1cac498ae$var$uyc,
        $61de1ee1cac498ae$var$xyc,
        $61de1ee1cac498ae$var$zyc,
        $61de1ee1cac498ae$var$myc,
        $61de1ee1cac498ae$var$pyc,
        $61de1ee1cac498ae$var$wyc
    ]));
}
function $61de1ee1cac498ae$var$Y9b(a) {
    var b, c;
    b = a.d == ($61de1ee1cac498ae$var$Apc(), $61de1ee1cac498ae$var$vpc);
    c = $61de1ee1cac498ae$var$U9b(a);
    b && !c || !b && c ? $61de1ee1cac498ae$var$yNb(a.a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mwc), ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$D7c)) : $61de1ee1cac498ae$var$yNb(a.a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mwc), ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$C7c));
}
function $61de1ee1cac498ae$var$XAb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb(a, $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    return c.Qc($61de1ee1cac498ae$var$aBb(c.gc()));
}
function $61de1ee1cac498ae$var$Ded() {
    $61de1ee1cac498ae$var$Ded = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Ced = new $61de1ee1cac498ae$var$Eed("SIMPLE", 0);
    $61de1ee1cac498ae$var$zed = new $61de1ee1cac498ae$var$Eed("GROUP_DEC", 1);
    $61de1ee1cac498ae$var$Bed = new $61de1ee1cac498ae$var$Eed("GROUP_MIXED", 2);
    $61de1ee1cac498ae$var$Aed = new $61de1ee1cac498ae$var$Eed("GROUP_INC", 3);
}
function $61de1ee1cac498ae$var$CWd() {
    $61de1ee1cac498ae$var$CWd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$AWd = new $61de1ee1cac498ae$var$DWd;
    $61de1ee1cac498ae$var$tWd = new $61de1ee1cac498ae$var$GWd;
    $61de1ee1cac498ae$var$uWd = new $61de1ee1cac498ae$var$JWd;
    $61de1ee1cac498ae$var$vWd = new $61de1ee1cac498ae$var$MWd;
    $61de1ee1cac498ae$var$wWd = new $61de1ee1cac498ae$var$PWd;
    $61de1ee1cac498ae$var$xWd = new $61de1ee1cac498ae$var$SWd;
    $61de1ee1cac498ae$var$yWd = new $61de1ee1cac498ae$var$VWd;
    $61de1ee1cac498ae$var$zWd = new $61de1ee1cac498ae$var$YWd;
    $61de1ee1cac498ae$var$BWd = new $61de1ee1cac498ae$var$_Wd;
}
function $61de1ee1cac498ae$var$FHb(a, b, c) {
    $61de1ee1cac498ae$var$tHb();
    $61de1ee1cac498ae$var$oHb.call(this);
    this.a = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$oN, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$ile
    ], [
        595,
        212
    ], 0, [
        $61de1ee1cac498ae$var$sHb,
        $61de1ee1cac498ae$var$rHb
    ], 2);
    this.c = new $61de1ee1cac498ae$var$I6c;
    this.g = a;
    this.f = b;
    this.d = c;
}
function $61de1ee1cac498ae$var$pNb(a, b) {
    this.n = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$XD, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$Sje
    ], [
        364,
        25
    ], 14, [
        b,
        $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(a / 32))
    ], 2);
    this.o = a;
    this.p = b;
    this.j = a - 1 >> 1;
    this.k = b - 1 >> 1;
}
function $61de1ee1cac498ae$var$r3b(a, b) {
    $61de1ee1cac498ae$var$Odd(b, "End label post-processing", 1);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.b, 16)), new $61de1ee1cac498ae$var$w3b), new $61de1ee1cac498ae$var$y3b), new $61de1ee1cac498ae$var$A3b);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$NLc(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$Edb(a.p[b.i.p]) + $61de1ee1cac498ae$var$Edb(a.d[b.i.p]) + b.n.b + b.a.b;
    e = $61de1ee1cac498ae$var$Edb(a.p[c.i.p]) + $61de1ee1cac498ae$var$Edb(a.d[c.i.p]) + c.n.b + c.a.b;
    return e - d;
}
function $61de1ee1cac498ae$var$xhb(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$xbb(c, $61de1ee1cac498ae$var$Yje);
    for(e = 0; $61de1ee1cac498ae$var$ybb(d, 0) != 0 && e < b; e++){
        d = $61de1ee1cac498ae$var$wbb(d, $61de1ee1cac498ae$var$xbb(a[e], $61de1ee1cac498ae$var$Yje));
        a[e] = $61de1ee1cac498ae$var$Tbb(d);
        d = $61de1ee1cac498ae$var$Obb(d, 32);
    }
    return $61de1ee1cac498ae$var$Tbb(d);
}
function $61de1ee1cac498ae$var$$Ed(a) {
    var b, c, d, e;
    e = 0;
    for(c = 0, d = a.length; c < d; c++){
        b = ($61de1ee1cac498ae$var$BCb(c, a.length), a.charCodeAt(c));
        b < 64 && (e = $61de1ee1cac498ae$var$Mbb(e, $61de1ee1cac498ae$var$Nbb(1, b)));
    }
    return e;
}
function $61de1ee1cac498ae$var$S9d(a) {
    var b;
    return a == null ? null : new $61de1ee1cac498ae$var$Ygb((b = $61de1ee1cac498ae$var$Qge(a, true), b.length > 0 && ($61de1ee1cac498ae$var$BCb(0, b.length), b.charCodeAt(0) == 43) ? b.substr(1) : b));
}
function $61de1ee1cac498ae$var$T9d(a) {
    var b;
    return a == null ? null : new $61de1ee1cac498ae$var$Ygb((b = $61de1ee1cac498ae$var$Qge(a, true), b.length > 0 && ($61de1ee1cac498ae$var$BCb(0, b.length), b.charCodeAt(0) == 43) ? b.substr(1) : b));
}
function $61de1ee1cac498ae$var$xud(a, b) {
    var c;
    if (a.i > 0) {
        if (b.length < a.i) {
            c = $61de1ee1cac498ae$var$izd($61de1ee1cac498ae$var$rb(b).c, a.i);
            b = c;
        }
        $61de1ee1cac498ae$var$$fb(a.g, 0, b, 0, a.i);
    }
    b.length > a.i && $61de1ee1cac498ae$var$NC(b, a.i, null);
    return b;
}
function $61de1ee1cac498ae$var$Sxd(a, b, c) {
    var d, e, f;
    if (a.ej()) {
        d = a.i;
        f = a.fj();
        $61de1ee1cac498ae$var$kud(a, d, b);
        e = a.Zi(3, null, b, d, f);
        !c ? c = e : c.Ei(e);
    } else $61de1ee1cac498ae$var$kud(a, a.i, b);
    return c;
}
function $61de1ee1cac498ae$var$HMd(a, b, c) {
    var d, e;
    d = new $61de1ee1cac498ae$var$pSd(a.e, 4, 10, (e = b.c, $61de1ee1cac498ae$var$JD(e, 88) ? $61de1ee1cac498ae$var$BD(e, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd)), null, $61de1ee1cac498ae$var$HLd(a, b), false);
    !c ? c = d : c.Ei(d);
    return c;
}
function $61de1ee1cac498ae$var$GMd(a, b, c) {
    var d, e;
    d = new $61de1ee1cac498ae$var$pSd(a.e, 3, 10, null, (e = b.c, $61de1ee1cac498ae$var$JD(e, 88) ? $61de1ee1cac498ae$var$BD(e, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd)), $61de1ee1cac498ae$var$HLd(a, b), false);
    !c ? c = d : c.Ei(d);
    return c;
}
function $61de1ee1cac498ae$var$_Jb(a) {
    $61de1ee1cac498ae$var$$Jb();
    var b;
    b = new $61de1ee1cac498ae$var$g7c($61de1ee1cac498ae$var$BD(a.e.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$_8c)), 8));
    if (a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Bdd))) {
        b.a <= 0 && (b.a = 20);
        b.b <= 0 && (b.b = 20);
    }
    return b;
}
function $61de1ee1cac498ae$var$Lzc(a) {
    $61de1ee1cac498ae$var$Izc();
    var b;
    (!a.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : a.q)._b(($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Cxc)) ? b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Cxc), 197) : b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), $61de1ee1cac498ae$var$Dxc), 197);
    return b;
}
function $61de1ee1cac498ae$var$pBc(a, b) {
    var c, d;
    d = null;
    if ($61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$qyc))) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$qyc), 94);
        c.Xe(b) && (d = c.We(b));
    }
    d == null && (d = $61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), b));
    return d;
}
function $61de1ee1cac498ae$var$Ze(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$JD(b, 42)) {
        c = $61de1ee1cac498ae$var$BD(b, 42);
        d = c.cd();
        e = $61de1ee1cac498ae$var$Hv(a.Rc(), d);
        return $61de1ee1cac498ae$var$Hb(e, c.dd()) && (e != null || a.Rc()._b(d));
    }
    return false;
}
function $61de1ee1cac498ae$var$qAd(a, b) {
    var c, d, e;
    if (a.f > 0) {
        a.qj();
        d = b == null ? 0 : $61de1ee1cac498ae$var$tb(b);
        e = (d & $61de1ee1cac498ae$var$Ohe) % a.d.length;
        c = $61de1ee1cac498ae$var$xAd(a, e, d, b);
        return c != -1;
    } else return false;
}
function $61de1ee1cac498ae$var$AAd(a, b) {
    var c, d, e;
    if (a.f > 0) {
        a.qj();
        d = b == null ? 0 : $61de1ee1cac498ae$var$tb(b);
        e = (d & $61de1ee1cac498ae$var$Ohe) % a.d.length;
        c = $61de1ee1cac498ae$var$wAd(a, e, d, b);
        if (c) return c.dd();
    }
    return null;
}
function $61de1ee1cac498ae$var$R2d(a, b) {
    var c, d, e, f;
    f = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    c = $61de1ee1cac498ae$var$BD(a.g, 119);
    for(e = 0; e < a.i; ++e){
        d = c[e];
        if (f.rl(d.ak())) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$B6d(a) {
    if (a.b == null) {
        while(a.a.Ob()){
            a.b = a.a.Pb();
            if (!$61de1ee1cac498ae$var$BD(a.b, 49).Zg()) return true;
        }
        a.b = null;
        return false;
    } else return true;
}
function $61de1ee1cac498ae$var$Myd(b, c) {
    b.mj();
    try {
        b.d.Vc(b.e++, c);
        b.f = b.d.j;
        b.g = -1;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$IA(a, b) {
    $61de1ee1cac498ae$var$GA();
    var c, d;
    c = $61de1ee1cac498ae$var$LA(($61de1ee1cac498ae$var$KA(), $61de1ee1cac498ae$var$KA(), $61de1ee1cac498ae$var$JA));
    d = null;
    b == c && (d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$FA, a), 615));
    if (!d) {
        d = new $61de1ee1cac498ae$var$HA(a);
        b == c && $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$FA, a, d);
    }
    return d;
}
function $61de1ee1cac498ae$var$Epb(a, b) {
    var c, d;
    a.a = $61de1ee1cac498ae$var$wbb(a.a, 1);
    a.c = $61de1ee1cac498ae$var$$wnd.Math.min(a.c, b);
    a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.b, b);
    a.d += b;
    c = b - a.f;
    d = a.e + c;
    a.f = d - a.e - c;
    a.e = d;
}
function $61de1ee1cac498ae$var$ogb(a, b) {
    var c;
    a.c = b;
    a.a = $61de1ee1cac498ae$var$hhb(b);
    a.a < 54 && (a.f = (c = b.d > 1 ? $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$Nbb(b.a[1], 32), $61de1ee1cac498ae$var$xbb(b.a[0], $61de1ee1cac498ae$var$Yje)) : $61de1ee1cac498ae$var$xbb(b.a[0], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$Sbb($61de1ee1cac498ae$var$Ibb(b.e, c))));
}
function $61de1ee1cac498ae$var$Hbb(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$Fbb(a) && $61de1ee1cac498ae$var$Fbb(b)) {
        c = a % b;
        if ($61de1ee1cac498ae$var$Kje < c && c < $61de1ee1cac498ae$var$Ije) return c;
    }
    return $61de1ee1cac498ae$var$zbb(($61de1ee1cac498ae$var$UC($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b, true), $61de1ee1cac498ae$var$QC));
}
function $61de1ee1cac498ae$var$p5b(a, b) {
    var c;
    $61de1ee1cac498ae$var$m5b(b);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Rwc)), 276);
    !!c && $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Rwc, $61de1ee1cac498ae$var$Tqc(c));
    $61de1ee1cac498ae$var$n5b(a.c);
    $61de1ee1cac498ae$var$n5b(a.f);
    $61de1ee1cac498ae$var$o5b(a.d);
    $61de1ee1cac498ae$var$o5b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$wxc), 207));
}
function $61de1ee1cac498ae$var$rHc(a) {
    this.e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.length, 15, 1);
    this.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, a.length, 16, 1);
    this.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, a.length, 16, 1);
    this.f = 0;
}
function $61de1ee1cac498ae$var$BDc(a) {
    var b, c;
    a.j = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, a.p.c.length, 15, 1);
    for(c = new $61de1ee1cac498ae$var$olb(a.p); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        a.j[b.p] = b.o.b / a.i;
    }
}
function $61de1ee1cac498ae$var$yic(a) {
    var b;
    if (a.c == 0) return;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, a.b), 287);
    b.b == 1 ? (++a.b, a.b < a.a.c.length && $61de1ee1cac498ae$var$Cic($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, a.b), 287))) : --b.b;
    --a.c;
}
function $61de1ee1cac498ae$var$eac(a) {
    var b;
    b = a.a;
    do {
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17).d.i;
        b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) && $61de1ee1cac498ae$var$Ekb(a.e, b);
    }while (b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b));
}
function $61de1ee1cac498ae$var$idd() {
    $61de1ee1cac498ae$var$idd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$fdd = new $61de1ee1cac498ae$var$q0b(15);
    $61de1ee1cac498ae$var$edd = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c), $61de1ee1cac498ae$var$fdd);
    $61de1ee1cac498ae$var$hdd = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$T9c, 15);
    $61de1ee1cac498ae$var$gdd = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$E9c, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$ddd = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$r8c, $61de1ee1cac498ae$var$tme);
}
function $61de1ee1cac498ae$var$tdd() {
    $61de1ee1cac498ae$var$tdd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$rdd = new $61de1ee1cac498ae$var$udd("PORTS", 0);
    $61de1ee1cac498ae$var$sdd = new $61de1ee1cac498ae$var$udd("PORT_LABELS", 1);
    $61de1ee1cac498ae$var$qdd = new $61de1ee1cac498ae$var$udd("NODE_LABELS", 2);
    $61de1ee1cac498ae$var$pdd = new $61de1ee1cac498ae$var$udd("MINIMUM_SIZE", 3);
}
function $61de1ee1cac498ae$var$Ree(a, b) {
    var c, d;
    d = b.length;
    for(c = 0; c < d; c += 2)$61de1ee1cac498ae$var$Ufe(a, ($61de1ee1cac498ae$var$BCb(c, b.length), b.charCodeAt(c)), ($61de1ee1cac498ae$var$BCb(c + 1, b.length), b.charCodeAt(c + 1)));
}
function $61de1ee1cac498ae$var$_Zc(a, b, c) {
    var d, e, f, g;
    f = b - a.e;
    g = c - a.f;
    for(e = new $61de1ee1cac498ae$var$olb(a.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 187);
        $61de1ee1cac498ae$var$OZc(d, d.s + f, d.t + g);
    }
    a.e = b;
    a.f = c;
}
function $61de1ee1cac498ae$var$jUc(a, b) {
    var c, d, e, f;
    f = b.b.b;
    a.a = new $61de1ee1cac498ae$var$Psb;
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, f, 15, 1);
    c = 0;
    for(e = $61de1ee1cac498ae$var$Jsb(b.b, 0); e.b != e.d.c;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(e), 86);
        d.g = c++;
    }
}
function $61de1ee1cac498ae$var$ihb(a, b) {
    var c, d, e, f;
    c = b >> 5;
    b &= 31;
    e = a.d + c + (b == 0 ? 0 : 1);
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, e, 15, 1);
    $61de1ee1cac498ae$var$jhb(d, a.a, c, b);
    f = new $61de1ee1cac498ae$var$Vgb(a.e, e, d);
    $61de1ee1cac498ae$var$Jgb(f);
    return f;
}
function $61de1ee1cac498ae$var$Ofe(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$Zee, b), 117);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$$ee, b), 117);
    if (c) {
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$Zee, a, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$$ee, a, e);
    } else {
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$$ee, a, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$Zee, a, e);
    }
}
function $61de1ee1cac498ae$var$Cwb(a, b, c) {
    var d, e, f;
    e = null;
    f = a.b;
    while(f){
        d = a.a.ue(b, f.d);
        if (c && d == 0) return f;
        if (d >= 0) f = f.a[1];
        else {
            e = f;
            f = f.a[0];
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$Dwb(a, b, c) {
    var d, e, f;
    e = null;
    f = a.b;
    while(f){
        d = a.a.ue(b, f.d);
        if (c && d == 0) return f;
        if (d <= 0) f = f.a[0];
        else {
            e = f;
            f = f.a[1];
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$Nic(a, b, c, d) {
    var e, f, g;
    e = false;
    if ($61de1ee1cac498ae$var$fjc(a.f, c, d)) {
        $61de1ee1cac498ae$var$ijc(a.f, a.a[b][c], a.a[b][d]);
        f = a.a[b];
        g = f[d];
        f[d] = f[c];
        f[c] = g;
        e = true;
    }
    return e;
}
function $61de1ee1cac498ae$var$QHc(a, b, c, d, e) {
    var f, g, h;
    g = e;
    while(b.b != b.c){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(b), 10);
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$V_b(f, d).Xb(0), 11);
        a.d[h.p] = g++;
        c.c[c.c.length] = h;
    }
    return g;
}
function $61de1ee1cac498ae$var$hBc(a, b, c) {
    var d, e, f, g, h;
    g = a.k;
    h = b.k;
    d = c[g.g][h.g];
    e = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(a, d));
    f = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(b, d));
    return $61de1ee1cac498ae$var$$wnd.Math.max(($61de1ee1cac498ae$var$uCb(e), e), ($61de1ee1cac498ae$var$uCb(f), f));
}
function $61de1ee1cac498ae$var$zZc(a, b, c) {
    var d, e, f, g;
    d = c / a.c.length;
    e = 0;
    for(g = new $61de1ee1cac498ae$var$olb(a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 200);
        $61de1ee1cac498ae$var$w$c(f, f.f + d * e);
        $61de1ee1cac498ae$var$t$c(f, b, d);
        ++e;
    }
}
function $61de1ee1cac498ae$var$hnc(a, b, c) {
    var d, e, f, g;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, c), 177);
    d = 0;
    for(g = new $61de1ee1cac498ae$var$olb(b.j); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 113);
        e[f.d.p] && ++d;
    }
    return d;
}
function $61de1ee1cac498ae$var$mzd(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a.a, 4), 126);
    if (b != null) {
        c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$$3, $61de1ee1cac498ae$var$hve, 415, b.length, 0, 1);
        $61de1ee1cac498ae$var$$fb(b, 0, c, 0, b.length);
        return c;
    } else return $61de1ee1cac498ae$var$jzd;
}
function $61de1ee1cac498ae$var$Cz() {
    var a;
    if ($61de1ee1cac498ae$var$xz != 0) {
        a = $61de1ee1cac498ae$var$sz();
        if (a - $61de1ee1cac498ae$var$yz > 2000) {
            $61de1ee1cac498ae$var$yz = a;
            $61de1ee1cac498ae$var$zz = $61de1ee1cac498ae$var$$wnd.setTimeout($61de1ee1cac498ae$var$Iz, 10);
        }
    }
    if ($61de1ee1cac498ae$var$xz++ == 0) {
        $61de1ee1cac498ae$var$Lz(($61de1ee1cac498ae$var$Kz(), $61de1ee1cac498ae$var$Jz));
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$wCc(a, b) {
    var c, d, e;
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
        e = c.d.i;
        if (e.c == b) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$Ek(b, c) {
    var d, e;
    if ($61de1ee1cac498ae$var$JD(c, 245)) {
        e = $61de1ee1cac498ae$var$BD(c, 245);
        try {
            d = b.vd(e);
            return d == 0;
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if (!$61de1ee1cac498ae$var$JD(a, 205)) throw $61de1ee1cac498ae$var$vbb(a);
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$Xz() {
    if (Error.stackTraceLimit > 0) {
        $61de1ee1cac498ae$var$$wnd.Error.stackTraceLimit = Error.stackTraceLimit = 64;
        return true;
    }
    return "stack" in new Error;
}
function $61de1ee1cac498ae$var$BDb(a, b) {
    return $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Qie), ($61de1ee1cac498ae$var$$wnd.Math.abs(a - b) <= $61de1ee1cac498ae$var$Qie || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(a), isNaN(b))) > 0;
}
function $61de1ee1cac498ae$var$DDb(a, b) {
    return $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Qie), ($61de1ee1cac498ae$var$$wnd.Math.abs(a - b) <= $61de1ee1cac498ae$var$Qie || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(a), isNaN(b))) < 0;
}
function $61de1ee1cac498ae$var$CDb(a, b) {
    return $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Qie), ($61de1ee1cac498ae$var$$wnd.Math.abs(a - b) <= $61de1ee1cac498ae$var$Qie || a == b || isNaN(a) && isNaN(b) ? 0 : a < b ? -1 : a > b ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(a), isNaN(b))) <= 0;
}
function $61de1ee1cac498ae$var$ydb(a, b) {
    var c = 0;
    while(!b[c] || b[c] == "")c++;
    var d = b[c++];
    for(; c < b.length; c++){
        if (!b[c] || b[c] == "") continue;
        d += a + b[c];
    }
    return d;
}
function $61de1ee1cac498ae$var$zfb(a, b, c) {
    var d, e, f, g;
    f = b + c;
    $61de1ee1cac498ae$var$ACb(b, f, a.length);
    g = "";
    for(e = b; e < f;){
        d = $61de1ee1cac498ae$var$$wnd.Math.min(e + 10000, f);
        g += $61de1ee1cac498ae$var$vfb(a.slice(e, d));
        e = d;
    }
    return g;
}
function $61de1ee1cac498ae$var$N9d(a) {
    var b, c, d, e, f;
    if (a == null) return null;
    f = new $61de1ee1cac498ae$var$Rkb;
    for(c = $61de1ee1cac498ae$var$Zmd(a), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$Ekb(f, $61de1ee1cac498ae$var$Qge(b, true));
    }
    return f;
}
function $61de1ee1cac498ae$var$Q9d(a) {
    var b, c, d, e, f;
    if (a == null) return null;
    f = new $61de1ee1cac498ae$var$Rkb;
    for(c = $61de1ee1cac498ae$var$Zmd(a), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$Ekb(f, $61de1ee1cac498ae$var$Qge(b, true));
    }
    return f;
}
function $61de1ee1cac498ae$var$R9d(a) {
    var b, c, d, e, f;
    if (a == null) return null;
    f = new $61de1ee1cac498ae$var$Rkb;
    for(c = $61de1ee1cac498ae$var$Zmd(a), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$Ekb(f, $61de1ee1cac498ae$var$Qge(b, true));
    }
    return f;
}
function $61de1ee1cac498ae$var$ted(a, b) {
    var c, d, e;
    if (a.c) $61de1ee1cac498ae$var$cld(a.c, b);
    else {
        c = b - $61de1ee1cac498ae$var$red(a);
        for(e = new $61de1ee1cac498ae$var$olb(a.d); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 157);
            $61de1ee1cac498ae$var$ted(d, $61de1ee1cac498ae$var$red(d) + c);
        }
    }
}
function $61de1ee1cac498ae$var$sed(a, b) {
    var c, d, e;
    if (a.c) $61de1ee1cac498ae$var$ald(a.c, b);
    else {
        c = b - $61de1ee1cac498ae$var$qed(a);
        for(e = new $61de1ee1cac498ae$var$olb(a.a); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 157);
            $61de1ee1cac498ae$var$sed(d, $61de1ee1cac498ae$var$qed(d) + c);
        }
    }
}
function $61de1ee1cac498ae$var$t6d(a, b) {
    var c, d, e, f;
    e = new $61de1ee1cac498ae$var$Skb(b.gc());
    for(d = b.Kc(); d.Ob();){
        c = d.Pb();
        f = $61de1ee1cac498ae$var$s6d(a, $61de1ee1cac498ae$var$BD(c, 56));
        !!f && (e.c[e.c.length] = f);
    }
    return e;
}
function $61de1ee1cac498ae$var$LAd(a, b) {
    var c, d, e;
    a.qj();
    d = b == null ? 0 : $61de1ee1cac498ae$var$tb(b);
    e = (d & $61de1ee1cac498ae$var$Ohe) % a.d.length;
    c = $61de1ee1cac498ae$var$wAd(a, e, d, b);
    if (c) {
        $61de1ee1cac498ae$var$JAd(a, c);
        return c.dd();
    } else return null;
}
function $61de1ee1cac498ae$var$rde(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$sde(a);
    b = null;
    while(a.c == 2){
        $61de1ee1cac498ae$var$nde(a);
        if (!b) {
            b = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Lge(2));
            $61de1ee1cac498ae$var$Kge(b, c);
            c = b;
        }
        c.$l($61de1ee1cac498ae$var$sde(a));
    }
    return c;
}
function $61de1ee1cac498ae$var$Wpd(a) {
    var b, c, d;
    d = null;
    b = $61de1ee1cac498ae$var$Vte in a.a;
    c = !b;
    if (c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("Every element must have an id."));
    d = $61de1ee1cac498ae$var$Vpd($61de1ee1cac498ae$var$aC(a, $61de1ee1cac498ae$var$Vte));
    return d;
}
function $61de1ee1cac498ae$var$jid(a) {
    var b, c, d;
    d = a.Zg();
    if (!d) {
        b = 0;
        for(c = a.eh(); c; c = c.eh()){
            if (++b > $61de1ee1cac498ae$var$Wje) return c.fh();
            d = c.Zg();
            if (!!d || c == a) break;
        }
    }
    return d;
}
function $61de1ee1cac498ae$var$fvd(a) {
    $61de1ee1cac498ae$var$evd();
    if ($61de1ee1cac498ae$var$JD(a, 156)) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb($61de1ee1cac498ae$var$cvd, $61de1ee1cac498ae$var$hK), 288).vg(a);
    if ($61de1ee1cac498ae$var$Mhb($61de1ee1cac498ae$var$cvd, $61de1ee1cac498ae$var$rb(a))) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb($61de1ee1cac498ae$var$cvd, $61de1ee1cac498ae$var$rb(a)), 288).vg(a);
    return null;
}
function $61de1ee1cac498ae$var$fZd(a) {
    if ($61de1ee1cac498ae$var$efb($61de1ee1cac498ae$var$kse, a)) return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Acb;
    else if ($61de1ee1cac498ae$var$efb($61de1ee1cac498ae$var$lse, a)) return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Expecting true or false"));
}
function $61de1ee1cac498ae$var$uDc(a, b) {
    if (b.c == a) return b.d;
    else if (b.d == a) return b.c;
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Input edge is not connected to the input port."));
}
function $61de1ee1cac498ae$var$Igb(a, b) {
    if (a.e > b.e) return 1;
    if (a.e < b.e) return -1;
    if (a.d > b.d) return a.e;
    if (a.d < b.d) return -b.e;
    return a.e * $61de1ee1cac498ae$var$whb(a.a, b.a, a.d);
}
function $61de1ee1cac498ae$var$Zcb(a) {
    if (a >= 48 && a < 48 + $61de1ee1cac498ae$var$$wnd.Math.min(10, 10)) return a - 48;
    if (a >= 97 && a < 97) return a - 97 + 10;
    if (a >= 65 && a < 65) return a - 65 + 10;
    return -1;
}
function $61de1ee1cac498ae$var$Ue(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(a)) return true;
    if (!$61de1ee1cac498ae$var$JD(b, 21)) return false;
    c = $61de1ee1cac498ae$var$BD(b, 21);
    if (c.gc() != a.gc()) return false;
    return a.Ic(c);
}
function $61de1ee1cac498ae$var$ekb(a, b) {
    var c, d, e, f;
    d = a.a.length - 1;
    c = b - a.b & d;
    f = a.c - b & d;
    e = a.c - a.b & d;
    $61de1ee1cac498ae$var$mkb(c < e);
    if (c >= f) {
        $61de1ee1cac498ae$var$hkb(a, b);
        return -1;
    } else {
        $61de1ee1cac498ae$var$ikb(a, b);
        return 1;
    }
}
function $61de1ee1cac498ae$var$lA(a, b) {
    var c, d;
    c = ($61de1ee1cac498ae$var$BCb(b, a.length), a.charCodeAt(b));
    d = b + 1;
    while(d < a.length && ($61de1ee1cac498ae$var$BCb(d, a.length), a.charCodeAt(d) == c))++d;
    return d - b;
}
function $61de1ee1cac498ae$var$sJb(a) {
    switch(a.g){
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
            return true;
        default:
            return false;
    }
}
function $61de1ee1cac498ae$var$bC(f, a) {
    var b = f.a;
    var c;
    a = String(a);
    b.hasOwnProperty(a) && (c = b[a]);
    var d = ($61de1ee1cac498ae$var$rC(), $61de1ee1cac498ae$var$qC)[typeof c];
    var e = d ? d(c) : $61de1ee1cac498ae$var$xC(typeof c);
    return e;
}
function $61de1ee1cac498ae$var$b3c(a, b) {
    if (a.a < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Did not call before(...) or after(...) before calling add(...)."));
    $61de1ee1cac498ae$var$i3c(a, a.a, b);
    return a;
}
function $61de1ee1cac498ae$var$VOc(a, b, c, d) {
    var e, f;
    if (b.c.length == 0) return;
    e = $61de1ee1cac498ae$var$ROc(c, d);
    f = $61de1ee1cac498ae$var$QOc(b);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$VAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(f, 1)), new $61de1ee1cac498ae$var$cPc), new $61de1ee1cac498ae$var$gPc(a, c, e, d));
}
function $61de1ee1cac498ae$var$Cjd(a, b, c) {
    var d;
    if ((a.Db & b) != 0) {
        if (c == null) $61de1ee1cac498ae$var$Bjd(a, b);
        else {
            d = $61de1ee1cac498ae$var$zjd(a, b);
            d == -1 ? a.Eb = c : $61de1ee1cac498ae$var$NC($61de1ee1cac498ae$var$CD(a.Eb), d, c);
        }
    } else c != null && $61de1ee1cac498ae$var$vjd(a, b, c);
}
function $61de1ee1cac498ae$var$yjd(a) {
    var b, c;
    if ((a.Db & 32) == 0) {
        c = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), $61de1ee1cac498ae$var$aLd(!b ? a.zh() : b) - $61de1ee1cac498ae$var$aLd(a.zh()));
        c != 0 && $61de1ee1cac498ae$var$Cjd(a, 32, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, c, 5, 1));
    }
    return a;
}
function $61de1ee1cac498ae$var$W1d(a) {
    var b;
    a.b || $61de1ee1cac498ae$var$X1d(a, (b = $61de1ee1cac498ae$var$h1d(a.e, a.a), !b || !$61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$lse, $61de1ee1cac498ae$var$AAd((!b.b && (b.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, b)), b.b), "qualified"))));
    return a.c;
}
function $61de1ee1cac498ae$var$dTd(a, b, c) {
    var d, e, f;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$QSd(a.a), b), 87);
    f = (e = d.c, e ? e : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd));
    (f.kh() ? $61de1ee1cac498ae$var$xid(a.b, $61de1ee1cac498ae$var$BD(f, 49)) : f) == c ? $61de1ee1cac498ae$var$KQd(d) : $61de1ee1cac498ae$var$NQd(d, c);
    return f;
}
function $61de1ee1cac498ae$var$fCb(a, b) {
    (!b && console.groupCollapsed != null ? console.groupCollapsed : console.group != null ? console.group : console.log).call(console, a);
}
function $61de1ee1cac498ae$var$NNb(a, b, c, d) {
    d == a ? ($61de1ee1cac498ae$var$BD(c.b, 65), $61de1ee1cac498ae$var$BD(c.b, 65), $61de1ee1cac498ae$var$BD(d.b, 65), $61de1ee1cac498ae$var$BD(d.b, 65).c.b) : ($61de1ee1cac498ae$var$BD(c.b, 65), $61de1ee1cac498ae$var$BD(c.b, 65), $61de1ee1cac498ae$var$BD(d.b, 65), $61de1ee1cac498ae$var$BD(d.b, 65).c.b);
    $61de1ee1cac498ae$var$KNb(d, b, a);
}
function $61de1ee1cac498ae$var$EOb(a) {
    var b, c, d;
    b = 0;
    for(c = new $61de1ee1cac498ae$var$olb(a.g); c.a < c.c.c.length;){
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 562);
        ++b;
    }
    d = new $61de1ee1cac498ae$var$ENb(a.g, $61de1ee1cac498ae$var$Edb(a.a), a.c);
    $61de1ee1cac498ae$var$ELb(d);
    a.g = d.b;
    a.d = d.a;
}
function $61de1ee1cac498ae$var$ymc(a, b, c) {
    b.b = $61de1ee1cac498ae$var$$wnd.Math.max(b.b, -c.a);
    b.c = $61de1ee1cac498ae$var$$wnd.Math.max(b.c, c.a - a.a);
    b.d = $61de1ee1cac498ae$var$$wnd.Math.max(b.d, -c.b);
    b.a = $61de1ee1cac498ae$var$$wnd.Math.max(b.a, c.b - a.b);
}
function $61de1ee1cac498ae$var$MIc(a, b) {
    if (a.e < b.e) return -1;
    else if (a.e > b.e) return 1;
    else if (a.f < b.f) return -1;
    else if (a.f > b.f) return 1;
    return $61de1ee1cac498ae$var$tb(a) - $61de1ee1cac498ae$var$tb(b);
}
function $61de1ee1cac498ae$var$efb(a, b) {
    $61de1ee1cac498ae$var$uCb(a);
    if (b == null) return false;
    if ($61de1ee1cac498ae$var$dfb(a, b)) return true;
    return a.length == b.length && $61de1ee1cac498ae$var$dfb(a.toLowerCase(), b.toLowerCase());
}
function $61de1ee1cac498ae$var$x6d(a, b) {
    var c, d, e, f;
    for(d = 0, e = b.gc(); d < e; ++d){
        c = b.il(d);
        if ($61de1ee1cac498ae$var$JD(c, 99) && ($61de1ee1cac498ae$var$BD(c, 18).Bb & $61de1ee1cac498ae$var$ote) != 0) {
            f = b.jl(d);
            f != null && $61de1ee1cac498ae$var$s6d(a, $61de1ee1cac498ae$var$BD(f, 56));
        }
    }
}
function $61de1ee1cac498ae$var$p1c(a, b, c) {
    var d, e, f;
    for(f = new $61de1ee1cac498ae$var$olb(c.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 221);
        d = new $61de1ee1cac498ae$var$hDb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, e.b), 65));
        $61de1ee1cac498ae$var$Ekb(b.a, d);
        $61de1ee1cac498ae$var$p1c(a, d, e);
    }
}
function $61de1ee1cac498ae$var$Aeb(a) {
    var b, c;
    if ($61de1ee1cac498ae$var$ybb(a, -129) > 0 && $61de1ee1cac498ae$var$ybb(a, 128) < 0) {
        b = $61de1ee1cac498ae$var$Tbb(a) + 128;
        c = ($61de1ee1cac498ae$var$Ceb(), $61de1ee1cac498ae$var$Beb)[b];
        !c && (c = $61de1ee1cac498ae$var$Beb[b] = new $61de1ee1cac498ae$var$teb(a));
        return c;
    }
    return new $61de1ee1cac498ae$var$teb(a);
}
function $61de1ee1cac498ae$var$_0d(a, b) {
    var c, d;
    c = b.Hh(a.a);
    if (c) {
        d = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$fue));
        if (d != null) return d;
    }
    return b.ne();
}
function $61de1ee1cac498ae$var$a1d(a, b) {
    var c, d;
    c = b.Hh(a.a);
    if (c) {
        d = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$fue));
        if (d != null) return d;
    }
    return b.ne();
}
function $61de1ee1cac498ae$var$FMc(a, b) {
    $61de1ee1cac498ae$var$wMc();
    var c, d;
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
        if (c.d.i == b || c.c.i == b) return c;
    }
    return null;
}
function $61de1ee1cac498ae$var$HUb(a, b, c) {
    this.c = a;
    this.f = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$d7c;
    this.j = new $61de1ee1cac498ae$var$IVb;
    this.n = new $61de1ee1cac498ae$var$IVb;
    this.b = b;
    this.g = new $61de1ee1cac498ae$var$J6c(b.c, b.d, b.b, b.a);
    this.a = c;
}
function $61de1ee1cac498ae$var$gVb(a) {
    var b, c, d, e;
    this.a = new $61de1ee1cac498ae$var$zsb;
    this.d = new $61de1ee1cac498ae$var$Tqb;
    this.e = 0;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !this.f && (this.f = b);
        $61de1ee1cac498ae$var$eVb(this, b);
    }
}
function $61de1ee1cac498ae$var$Xgb(a) {
    $61de1ee1cac498ae$var$Hgb();
    if (a.length == 0) {
        this.e = 0;
        this.d = 1;
        this.a = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
            0
        ]);
    } else {
        this.e = 1;
        this.d = a.length;
        this.a = a;
        $61de1ee1cac498ae$var$Jgb(this);
    }
}
function $61de1ee1cac498ae$var$mIb(a, b, c) {
    $61de1ee1cac498ae$var$oHb.call(this);
    this.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$oN, $61de1ee1cac498ae$var$ile, 212, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ])).length, 0, 1);
    this.b = a;
    this.d = b;
    this.c = c;
}
function $61de1ee1cac498ae$var$Kjc(a) {
    this.d = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$$rb;
    this.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])).length, 15, 1);
    this.b = a;
}
function $61de1ee1cac498ae$var$Vbc(a) {
    var b, c, d, e, f, g;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
    $61de1ee1cac498ae$var$yNb(g, $61de1ee1cac498ae$var$qtc, a.i.n.b);
    b = $61de1ee1cac498ae$var$k_b(a.e);
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        $61de1ee1cac498ae$var$RZb(c, g);
    }
}
function $61de1ee1cac498ae$var$Wbc(a) {
    var b, c, d, e, f, g;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
    $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$qtc, a.i.n.b);
    b = $61de1ee1cac498ae$var$k_b(a.g);
    for(e = b, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        $61de1ee1cac498ae$var$QZb(d, c);
    }
}
function $61de1ee1cac498ae$var$vcc(a) {
    var b, c;
    if ($61de1ee1cac498ae$var$wNb(a.d.i, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Nxc))) {
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.c.i, $61de1ee1cac498ae$var$Nxc), 19);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.d.i, $61de1ee1cac498ae$var$Nxc), 19);
        return $61de1ee1cac498ae$var$beb(b.a, c.a) > 0;
    } else return false;
}
function $61de1ee1cac498ae$var$q2c(a) {
    var b;
    if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$J8c))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$fbd))) {
        if (!$61de1ee1cac498ae$var$Xod(a)) $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$J8c, $61de1ee1cac498ae$var$gbd);
        else {
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd($61de1ee1cac498ae$var$Xod(a), $61de1ee1cac498ae$var$J8c), 334);
            $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$J8c, b);
        }
    }
}
function $61de1ee1cac498ae$var$ijc(a, b, c) {
    var d, e;
    $61de1ee1cac498ae$var$bIc(a.e, b, c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    $61de1ee1cac498ae$var$bIc(a.i, b, c, $61de1ee1cac498ae$var$zcd);
    if (a.a) {
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$$sc), 11);
        $61de1ee1cac498ae$var$cIc(a.g, e, d);
    }
}
function $61de1ee1cac498ae$var$OEc(a, b, c) {
    var d, e, f;
    d = b.c.p;
    f = b.p;
    a.b[d][f] = new $61de1ee1cac498ae$var$$Ec(a, b);
    if (c) {
        a.a[d][f] = new $61de1ee1cac498ae$var$FEc(b);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Psc)), 10);
        !!e && $61de1ee1cac498ae$var$Rc(a.d, e, b);
    }
}
function $61de1ee1cac498ae$var$TPb(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$Ekb($61de1ee1cac498ae$var$PPb, a);
    b.Fc(a);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb($61de1ee1cac498ae$var$OPb, a), 21);
    if (c) for(e = c.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 33);
        $61de1ee1cac498ae$var$Jkb($61de1ee1cac498ae$var$PPb, d, 0) != -1 || $61de1ee1cac498ae$var$TPb(d, b);
    }
}
function $61de1ee1cac498ae$var$tyb(a, b, c) {
    var d;
    ($61de1ee1cac498ae$var$jyb ? ($61de1ee1cac498ae$var$ryb(a), true) : $61de1ee1cac498ae$var$kyb ? ($61de1ee1cac498ae$var$$xb(), true) : $61de1ee1cac498ae$var$nyb ? ($61de1ee1cac498ae$var$$xb(), true) : $61de1ee1cac498ae$var$myb && ($61de1ee1cac498ae$var$$xb(), false)) && (d = new $61de1ee1cac498ae$var$iyb(b), d.b = c, $61de1ee1cac498ae$var$pyb(a, d), undefined);
}
function $61de1ee1cac498ae$var$xKb(a, b) {
    var c;
    c = !a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd)) || a.q == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd);
    a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd)) ? c ? $61de1ee1cac498ae$var$vKb(a, b) : $61de1ee1cac498ae$var$zKb(a, b) : a.u.Hc($61de1ee1cac498ae$var$pcd) && (c ? $61de1ee1cac498ae$var$wKb(a, b) : $61de1ee1cac498ae$var$AKb(a, b));
}
function $61de1ee1cac498ae$var$b0d(a, b) {
    var c, d;
    ++a.j;
    if (b != null) {
        c = (d = a.a.Cb, $61de1ee1cac498ae$var$JD(d, 97) ? $61de1ee1cac498ae$var$BD(d, 97).Jg() : null);
        if ($61de1ee1cac498ae$var$xlb(b, c)) {
            $61de1ee1cac498ae$var$Cjd(a.a, 4, c);
            return;
        }
    }
    $61de1ee1cac498ae$var$Cjd(a.a, 4, $61de1ee1cac498ae$var$BD(b, 126));
}
function $61de1ee1cac498ae$var$dYb(a, b, c) {
    return new $61de1ee1cac498ae$var$J6c($61de1ee1cac498ae$var$$wnd.Math.min(a.a, b.a) - c / 2, $61de1ee1cac498ae$var$$wnd.Math.min(a.b, b.b) - c / 2, $61de1ee1cac498ae$var$$wnd.Math.abs(a.a - b.a) + c, $61de1ee1cac498ae$var$$wnd.Math.abs(a.b - b.b) + c);
}
function $61de1ee1cac498ae$var$k4b(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$beb(a.a.c.p, b.a.c.p);
    if (c != 0) return c;
    d = $61de1ee1cac498ae$var$beb(a.a.d.i.p, b.a.d.i.p);
    if (d != 0) return d;
    return $61de1ee1cac498ae$var$beb(b.a.d.p, a.a.d.p);
}
function $61de1ee1cac498ae$var$_Dc(a, b, c) {
    var d, e, f, g;
    f = b.j;
    g = c.j;
    if (f != g) return f.g - g.g;
    else {
        d = a.f[b.p];
        e = a.f[c.p];
        return d == 0 && e == 0 ? 0 : d == 0 ? -1 : e == 0 ? 1 : $61de1ee1cac498ae$var$Kdb(d, e);
    }
}
function $61de1ee1cac498ae$var$HFb(a, b, c) {
    var d, e, f;
    if (c[b.d]) return;
    c[b.d] = true;
    for(e = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$LFb(b)); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 213);
        f = $61de1ee1cac498ae$var$xFb(d, b);
        $61de1ee1cac498ae$var$HFb(a, f, c);
    }
}
function $61de1ee1cac498ae$var$umc(a, b, c) {
    var d;
    d = c[a.g][b];
    switch(a.g){
        case 1:
        case 3:
            return new $61de1ee1cac498ae$var$f7c(0, d);
        case 2:
        case 4:
            return new $61de1ee1cac498ae$var$f7c(d, 0);
        default:
            return null;
    }
}
function $61de1ee1cac498ae$var$r2c(b, c, d) {
    var e, f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hgd(c.f), 209);
    try {
        f.Ze(b, d);
        $61de1ee1cac498ae$var$igd(c.f, f);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 102)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(e);
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Vqd(a, b, c) {
    var d, e, f, g, h, i;
    d = null;
    h = $61de1ee1cac498ae$var$k4c($61de1ee1cac498ae$var$n4c(), b);
    f = null;
    if (h) {
        e = null;
        i = $61de1ee1cac498ae$var$o5c(h, c);
        g = null;
        i != null && (g = a.Ye(h, i));
        e = g;
        f = e;
    }
    d = f;
    return d;
}
function $61de1ee1cac498ae$var$TTd(a, b, c, d) {
    var e, f, g;
    e = new $61de1ee1cac498ae$var$pSd(a.e, 1, 13, (g = b.c, g ? g : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd)), (f = c.c, f ? f : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd)), $61de1ee1cac498ae$var$HLd(a, b), false);
    !d ? d = e : d.Ei(e);
    return d;
}
function $61de1ee1cac498ae$var$UEd(a, b, c, d) {
    var e;
    e = a.length;
    if (b >= e) return e;
    for(b = b > 0 ? b : 0; b < e; b++){
        if ($61de1ee1cac498ae$var$_Ed(($61de1ee1cac498ae$var$BCb(b, a.length), a.charCodeAt(b)), c, d)) break;
    }
    return b;
}
function $61de1ee1cac498ae$var$Qkb(a, b) {
    var c, d;
    d = a.c.length;
    b.length < d && (b = $61de1ee1cac498ae$var$eCb(new Array(d), b));
    for(c = 0; c < d; ++c)$61de1ee1cac498ae$var$NC(b, c, a.c[c]);
    b.length > d && $61de1ee1cac498ae$var$NC(b, d, null);
    return b;
}
function $61de1ee1cac498ae$var$_lb(a, b) {
    var c, d;
    d = a.a.length;
    b.length < d && (b = $61de1ee1cac498ae$var$eCb(new Array(d), b));
    for(c = 0; c < d; ++c)$61de1ee1cac498ae$var$NC(b, c, a.a[c]);
    b.length > d && $61de1ee1cac498ae$var$NC(b, d, null);
    return b;
}
function $61de1ee1cac498ae$var$Xrb(a, b, c) {
    var d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, b), 387);
    if (!e) {
        d = new $61de1ee1cac498ae$var$lsb(a, b, c);
        $61de1ee1cac498ae$var$Rhb(a.e, b, d);
        $61de1ee1cac498ae$var$isb(d);
        return null;
    } else {
        f = $61de1ee1cac498ae$var$ijb(e, c);
        $61de1ee1cac498ae$var$Yrb(a, e);
        return f;
    }
}
function $61de1ee1cac498ae$var$P9d(a) {
    var b;
    if (a == null) return null;
    b = $61de1ee1cac498ae$var$ide($61de1ee1cac498ae$var$Qge(a, true));
    if (b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$n8d("Invalid hexBinary value: '" + a + "'"));
    return b;
}
function $61de1ee1cac498ae$var$ghb(a) {
    $61de1ee1cac498ae$var$Hgb();
    if ($61de1ee1cac498ae$var$ybb(a, 0) < 0) {
        if ($61de1ee1cac498ae$var$ybb(a, -1) != 0) return new $61de1ee1cac498ae$var$Wgb(-1, $61de1ee1cac498ae$var$Jbb(a));
        return $61de1ee1cac498ae$var$Bgb;
    } else return $61de1ee1cac498ae$var$ybb(a, 10) <= 0 ? $61de1ee1cac498ae$var$Dgb[$61de1ee1cac498ae$var$Tbb(a)] : new $61de1ee1cac498ae$var$Wgb(1, a);
}
function $61de1ee1cac498ae$var$wJb() {
    $61de1ee1cac498ae$var$qJb();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$DN, 1), $61de1ee1cac498ae$var$Kie, 159, 0, [
        $61de1ee1cac498ae$var$nJb,
        $61de1ee1cac498ae$var$mJb,
        $61de1ee1cac498ae$var$oJb,
        $61de1ee1cac498ae$var$eJb,
        $61de1ee1cac498ae$var$dJb,
        $61de1ee1cac498ae$var$fJb,
        $61de1ee1cac498ae$var$iJb,
        $61de1ee1cac498ae$var$hJb,
        $61de1ee1cac498ae$var$gJb,
        $61de1ee1cac498ae$var$lJb,
        $61de1ee1cac498ae$var$kJb,
        $61de1ee1cac498ae$var$jJb,
        $61de1ee1cac498ae$var$bJb,
        $61de1ee1cac498ae$var$aJb,
        $61de1ee1cac498ae$var$cJb,
        $61de1ee1cac498ae$var$$Ib,
        $61de1ee1cac498ae$var$ZIb,
        $61de1ee1cac498ae$var$_Ib,
        $61de1ee1cac498ae$var$XIb,
        $61de1ee1cac498ae$var$WIb,
        $61de1ee1cac498ae$var$YIb,
        $61de1ee1cac498ae$var$pJb
    ]);
}
function $61de1ee1cac498ae$var$vjc(a) {
    var b;
    this.d = new $61de1ee1cac498ae$var$Rkb;
    this.j = new $61de1ee1cac498ae$var$d7c;
    this.g = new $61de1ee1cac498ae$var$d7c;
    b = a.g.b;
    this.f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(b), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lwc)), 103);
    this.e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$c_b(b, $61de1ee1cac498ae$var$ryc)));
}
function $61de1ee1cac498ae$var$Pjc(a) {
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$Rkb;
    this.d = a;
    this.a = !$61de1ee1cac498ae$var$WAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$b1b(a.b))), new $61de1ee1cac498ae$var$Xxb(new $61de1ee1cac498ae$var$Qjc))).sd(($61de1ee1cac498ae$var$EAb(), $61de1ee1cac498ae$var$DAb));
}
function $61de1ee1cac498ae$var$N5c() {
    $61de1ee1cac498ae$var$N5c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$L5c = new $61de1ee1cac498ae$var$O5c("PARENTS", 0);
    $61de1ee1cac498ae$var$K5c = new $61de1ee1cac498ae$var$O5c("NODES", 1);
    $61de1ee1cac498ae$var$I5c = new $61de1ee1cac498ae$var$O5c("EDGES", 2);
    $61de1ee1cac498ae$var$M5c = new $61de1ee1cac498ae$var$O5c("PORTS", 3);
    $61de1ee1cac498ae$var$J5c = new $61de1ee1cac498ae$var$O5c("LABELS", 4);
}
function $61de1ee1cac498ae$var$Tbd() {
    $61de1ee1cac498ae$var$Tbd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Qbd = new $61de1ee1cac498ae$var$Ubd("DISTRIBUTED", 0);
    $61de1ee1cac498ae$var$Sbd = new $61de1ee1cac498ae$var$Ubd("JUSTIFIED", 1);
    $61de1ee1cac498ae$var$Obd = new $61de1ee1cac498ae$var$Ubd("BEGIN", 2);
    $61de1ee1cac498ae$var$Pbd = new $61de1ee1cac498ae$var$Ubd($61de1ee1cac498ae$var$gle, 3);
    $61de1ee1cac498ae$var$Rbd = new $61de1ee1cac498ae$var$Ubd("END", 4);
}
function $61de1ee1cac498ae$var$UMd(a) {
    var b;
    b = a.yi(null);
    switch(b){
        case 10:
            return 0;
        case 15:
            return 1;
        case 14:
            return 2;
        case 11:
            return 3;
        case 21:
            return 4;
    }
    return -1;
}
function $61de1ee1cac498ae$var$cYb(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$dad;
        case 4:
            return $61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad;
        case 2:
            return $61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$bad;
        case 3:
            return $61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$_9c;
    }
    return $61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad;
}
function $61de1ee1cac498ae$var$kA(a, b, c) {
    var d;
    d = c.q.getFullYear() - $61de1ee1cac498ae$var$nje + $61de1ee1cac498ae$var$nje;
    d < 0 && (d = -d);
    switch(b){
        case 1:
            a.a += d;
            break;
        case 2:
            $61de1ee1cac498ae$var$EA(a, d % 100, 2);
            break;
        default:
            $61de1ee1cac498ae$var$EA(a, d, b);
    }
}
function $61de1ee1cac498ae$var$Jsb(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$wCb(b, a.b);
    if (b >= a.b >> 1) {
        d = a.c;
        for(c = a.b; c > b; --c)d = d.b;
    } else {
        d = a.a.a;
        for(c = 0; c < b; ++c)d = d.a;
    }
    return new $61de1ee1cac498ae$var$$sb(a, b, d);
}
function $61de1ee1cac498ae$var$MEb() {
    $61de1ee1cac498ae$var$MEb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$LEb = new $61de1ee1cac498ae$var$NEb("NUM_OF_EXTERNAL_SIDES_THAN_NUM_OF_EXTENSIONS_LAST", 0);
    $61de1ee1cac498ae$var$KEb = new $61de1ee1cac498ae$var$NEb("CORNER_CASES_THAN_SINGLE_SIDE_LAST", 1);
}
function $61de1ee1cac498ae$var$h4b(a) {
    var b, c, d, e;
    d = $61de1ee1cac498ae$var$c4b(a);
    $61de1ee1cac498ae$var$Okb(d, $61de1ee1cac498ae$var$a4b);
    e = a.d;
    e.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    for(c = new $61de1ee1cac498ae$var$olb(d); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 456);
        $61de1ee1cac498ae$var$Gkb(e, b.b);
    }
}
function $61de1ee1cac498ae$var$gkd(a) {
    var b, c, d;
    d = (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), a.o);
    for(c = d.c.Kc(); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD(c.nj(), 42);
        b.dd();
    }
    return $61de1ee1cac498ae$var$FAd(d);
}
function $61de1ee1cac498ae$var$N5b(a) {
    var b;
    if (!$61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98))) return;
    b = a.b;
    $61de1ee1cac498ae$var$O5b(($61de1ee1cac498ae$var$tCb(0, b.c.length), $61de1ee1cac498ae$var$BD(b.c[0], 29)));
    $61de1ee1cac498ae$var$O5b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b, b.c.length - 1), 29));
}
function $61de1ee1cac498ae$var$Roc(a, b) {
    var c, d, e, f;
    c = 0;
    for(e = new $61de1ee1cac498ae$var$olb(b.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        f = d.o.a + d.d.c + d.d.b + a.j;
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, f);
    }
    return c;
}
function $61de1ee1cac498ae$var$XEd(a) {
    var b, c, d, e;
    e = 0;
    for(c = 0, d = a.length; c < d; c++){
        b = ($61de1ee1cac498ae$var$BCb(c, a.length), a.charCodeAt(c));
        b >= 64 && b < 128 && (e = $61de1ee1cac498ae$var$Mbb(e, $61de1ee1cac498ae$var$Nbb(1, b - 64)));
    }
    return e;
}
function $61de1ee1cac498ae$var$c_b(a, b) {
    var c, d;
    d = null;
    if ($61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$O9c))) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$O9c), 94);
        c.Xe(b) && (d = c.We(b));
    }
    d == null && !!$61de1ee1cac498ae$var$Q_b(a) && (d = $61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), b));
    return d;
}
function $61de1ee1cac498ae$var$oQc(a, b) {
    var c, d, e;
    e = b.d.i;
    d = e.k;
    if (d == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) || d == $61de1ee1cac498ae$var$d0b) return;
    c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(e).a.Kc(), new $61de1ee1cac498ae$var$Sq));
    $61de1ee1cac498ae$var$Qr(c) && $61de1ee1cac498ae$var$Rhb(a.k, b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17));
}
function $61de1ee1cac498ae$var$mid(a, b) {
    var c, d, e;
    d = $61de1ee1cac498ae$var$XKd(a.Tg(), b);
    c = b - a.Ah();
    return c < 0 ? (e = a.Yg(d), e >= 0 ? a.lh(e) : $61de1ee1cac498ae$var$tid(a, d)) : c < 0 ? $61de1ee1cac498ae$var$tid(a, d) : $61de1ee1cac498ae$var$BD(d, 66).Nj().Sj(a, a.yh(), c);
}
function $61de1ee1cac498ae$var$Ksd(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a.a, 4)) {
        b = $61de1ee1cac498ae$var$fvd(a.a);
        if (b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$mse + a.b + "'. " + $61de1ee1cac498ae$var$ise + ($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$Y3), $61de1ee1cac498ae$var$Y3.k) + $61de1ee1cac498ae$var$jse));
        return b;
    } else return a.a;
}
function $61de1ee1cac498ae$var$L9d(a) {
    var b;
    if (a == null) return null;
    b = $61de1ee1cac498ae$var$bde($61de1ee1cac498ae$var$Qge(a, true));
    if (b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$n8d("Invalid base64Binary value: '" + a + "'"));
    return b;
}
function $61de1ee1cac498ae$var$Dyd(b) {
    var c;
    try {
        c = b.i.Xb(b.e);
        b.mj();
        b.g = b.e++;
        return c;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            b.mj();
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Zyd(b) {
    var c;
    try {
        c = b.c.ki(b.e);
        b.mj();
        b.g = b.e++;
        return c;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            b.mj();
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$CPb() {
    $61de1ee1cac498ae$var$CPb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$BPb = ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$K9c);
    $61de1ee1cac498ae$var$vPb = $61de1ee1cac498ae$var$G8c;
    $61de1ee1cac498ae$var$qPb = $61de1ee1cac498ae$var$r8c;
    $61de1ee1cac498ae$var$wPb = $61de1ee1cac498ae$var$f9c;
    $61de1ee1cac498ae$var$zPb = ($61de1ee1cac498ae$var$fFb(), $61de1ee1cac498ae$var$bFb);
    $61de1ee1cac498ae$var$yPb = $61de1ee1cac498ae$var$_Eb;
    $61de1ee1cac498ae$var$APb = $61de1ee1cac498ae$var$dFb;
    $61de1ee1cac498ae$var$xPb = $61de1ee1cac498ae$var$$Eb;
    $61de1ee1cac498ae$var$sPb = ($61de1ee1cac498ae$var$nPb(), $61de1ee1cac498ae$var$jPb);
    $61de1ee1cac498ae$var$rPb = $61de1ee1cac498ae$var$iPb;
    $61de1ee1cac498ae$var$tPb = $61de1ee1cac498ae$var$lPb;
    $61de1ee1cac498ae$var$uPb = $61de1ee1cac498ae$var$mPb;
}
function $61de1ee1cac498ae$var$NWb(a) {
    $61de1ee1cac498ae$var$LWb();
    this.c = new $61de1ee1cac498ae$var$Rkb;
    this.d = a;
    switch(a.g){
        case 0:
        case 2:
            this.a = $61de1ee1cac498ae$var$tmb($61de1ee1cac498ae$var$KWb);
            this.b = $61de1ee1cac498ae$var$Pje;
            break;
        case 3:
        case 1:
            this.a = $61de1ee1cac498ae$var$KWb;
            this.b = $61de1ee1cac498ae$var$Qje;
    }
}
function $61de1ee1cac498ae$var$ued(a, b, c) {
    var d, e;
    if (a.c) {
        $61de1ee1cac498ae$var$dld(a.c, a.c.i + b);
        $61de1ee1cac498ae$var$eld(a.c, a.c.j + c);
    } else for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 157);
        $61de1ee1cac498ae$var$ued(d, b, c);
    }
}
function $61de1ee1cac498ae$var$KEd(a, b) {
    var c, d;
    if (a.j.length != b.j.length) return false;
    for(c = 0, d = a.j.length; c < d; c++){
        if (!$61de1ee1cac498ae$var$dfb(a.j[c], b.j[c])) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$gA(a, b, c) {
    var d;
    if (b.a.length > 0) {
        $61de1ee1cac498ae$var$Ekb(a.b, new $61de1ee1cac498ae$var$WA(b.a, c));
        d = b.a.length;
        0 < d ? b.a = b.a.substr(0, 0) : 0 > d && (b.a += $61de1ee1cac498ae$var$yfb($61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, -d, 15, 1)));
    }
}
function $61de1ee1cac498ae$var$JKb(a, b) {
    var c, d, e;
    c = a.o;
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 111);
        d.e.a = $61de1ee1cac498ae$var$DKb(d, c.a);
        d.e.b = c.b * $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d.b.We($61de1ee1cac498ae$var$BKb)));
    }
}
function $61de1ee1cac498ae$var$S5b(a, b) {
    var c, d, e, f;
    e = a.k;
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$htc))));
    f = b.k;
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$htc)));
    return f != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) ? -1 : e != $61de1ee1cac498ae$var$e0b ? 1 : c == d ? 0 : c < d ? -1 : 1;
}
function $61de1ee1cac498ae$var$B$c(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b.a), 46).a, 65);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b.b), 46).a, 65);
    return $61de1ee1cac498ae$var$S6c(b.a, b.b) - $61de1ee1cac498ae$var$S6c(b.a, $61de1ee1cac498ae$var$E6c(c.b)) - $61de1ee1cac498ae$var$S6c(b.b, $61de1ee1cac498ae$var$E6c(d.b));
}
function $61de1ee1cac498ae$var$aZb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
    if ($61de1ee1cac498ae$var$Lq(b, $61de1ee1cac498ae$var$ZYb)) {
        if (!c) {
            c = new $61de1ee1cac498ae$var$s7c;
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$jxc, c);
        } else $61de1ee1cac498ae$var$Osb(c);
    } else !!c && $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$jxc, null);
    return c;
}
function $61de1ee1cac498ae$var$a0b(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Ufb;
    b.a += "n";
    a.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) && $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += "(", b), $61de1ee1cac498ae$var$Zr(a.k).toLowerCase()), ")");
    $61de1ee1cac498ae$var$Qfb((b.a += "_", b), $61de1ee1cac498ae$var$P_b(a));
    return b.a;
}
function $61de1ee1cac498ae$var$Kdc(a, b) {
    $61de1ee1cac498ae$var$Odd(b, "Self-Loop post-processing", 1);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.b, 16)), new $61de1ee1cac498ae$var$Qdc), new $61de1ee1cac498ae$var$Sdc), new $61de1ee1cac498ae$var$Udc), new $61de1ee1cac498ae$var$Wdc);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$kid(a, b, c, d) {
    var e;
    if (c >= 0) return a.hh(b, c, d);
    else {
        !!a.eh() && (d = (e = a.Vg(), e >= 0 ? a.Qg(d) : a.eh().ih(a, -1 - e, null, d)));
        return a.Sg(b, c, d);
    }
}
function $61de1ee1cac498ae$var$zld(a, b) {
    switch(b){
        case 7:
            !a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4));
            $61de1ee1cac498ae$var$Uxd(a.e);
            return;
        case 8:
            !a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5));
            $61de1ee1cac498ae$var$Uxd(a.d);
            return;
    }
    $61de1ee1cac498ae$var$$kd(a, b);
}
function $61de1ee1cac498ae$var$Ut(b, c) {
    var d;
    d = b.Zc(c);
    try {
        return d.Pb();
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 109)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb("Can't get element " + c));
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Tgb(a, b) {
    this.e = a;
    if (b < $61de1ee1cac498ae$var$Zje) {
        this.d = 1;
        this.a = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
            b | 0
        ]);
    } else {
        this.d = 2;
        this.a = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
            b % $61de1ee1cac498ae$var$Zje | 0,
            b / $61de1ee1cac498ae$var$Zje | 0
        ]);
    }
}
function $61de1ee1cac498ae$var$omb(a, b) {
    $61de1ee1cac498ae$var$mmb();
    var c, d, e, f;
    c = a;
    f = b;
    if ($61de1ee1cac498ae$var$JD(a, 21) && !$61de1ee1cac498ae$var$JD(b, 21)) {
        c = b;
        f = a;
    }
    for(e = c.Kc(); e.Ob();){
        d = e.Pb();
        if (f.Hc(d)) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$Txd(a, b, c) {
    var d, e, f, g;
    d = a.Xc(b);
    if (d != -1) {
        if (a.ej()) {
            f = a.fj();
            g = $61de1ee1cac498ae$var$tud(a, d);
            e = a.Zi(4, g, null, d, f);
            !c ? c = e : c.Ei(e);
        } else $61de1ee1cac498ae$var$tud(a, d);
    }
    return c;
}
function $61de1ee1cac498ae$var$uwd(a, b, c) {
    var d, e, f, g;
    d = a.Xc(b);
    if (d != -1) {
        if (a.ej()) {
            f = a.fj();
            g = $61de1ee1cac498ae$var$Evd(a, d);
            e = a.Zi(4, g, null, d, f);
            !c ? c = e : c.Ei(e);
        } else $61de1ee1cac498ae$var$Evd(a, d);
    }
    return c;
}
function $61de1ee1cac498ae$var$PJb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124).n;
    switch(b.g){
        case 1:
            a.t >= 0 && (c.d = a.t);
            break;
        case 3:
            a.t >= 0 && (c.a = a.t);
    }
    if (a.C) {
        c.b = a.C.b;
        c.c = a.C.c;
    }
}
function $61de1ee1cac498ae$var$RMb() {
    $61de1ee1cac498ae$var$RMb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$OMb = new $61de1ee1cac498ae$var$SMb($61de1ee1cac498ae$var$xle, 0);
    $61de1ee1cac498ae$var$NMb = new $61de1ee1cac498ae$var$SMb($61de1ee1cac498ae$var$yle, 1);
    $61de1ee1cac498ae$var$PMb = new $61de1ee1cac498ae$var$SMb($61de1ee1cac498ae$var$zle, 2);
    $61de1ee1cac498ae$var$QMb = new $61de1ee1cac498ae$var$SMb($61de1ee1cac498ae$var$Ale, 3);
    $61de1ee1cac498ae$var$OMb.a = false;
    $61de1ee1cac498ae$var$NMb.a = true;
    $61de1ee1cac498ae$var$PMb.a = false;
    $61de1ee1cac498ae$var$QMb.a = true;
}
function $61de1ee1cac498ae$var$ROb() {
    $61de1ee1cac498ae$var$ROb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$OOb = new $61de1ee1cac498ae$var$SOb($61de1ee1cac498ae$var$xle, 0);
    $61de1ee1cac498ae$var$NOb = new $61de1ee1cac498ae$var$SOb($61de1ee1cac498ae$var$yle, 1);
    $61de1ee1cac498ae$var$POb = new $61de1ee1cac498ae$var$SOb($61de1ee1cac498ae$var$zle, 2);
    $61de1ee1cac498ae$var$QOb = new $61de1ee1cac498ae$var$SOb($61de1ee1cac498ae$var$Ale, 3);
    $61de1ee1cac498ae$var$OOb.a = false;
    $61de1ee1cac498ae$var$NOb.a = true;
    $61de1ee1cac498ae$var$POb.a = false;
    $61de1ee1cac498ae$var$QOb.a = true;
}
function $61de1ee1cac498ae$var$dac(a) {
    var b;
    b = a.a;
    do {
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17).c.i;
        b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) && a.b.Fc(b);
    }while (b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b));
    a.b = $61de1ee1cac498ae$var$Su(a.b);
}
function $61de1ee1cac498ae$var$CDc(a) {
    var b, c, d;
    d = a.c.a;
    a.p = ($61de1ee1cac498ae$var$Qb(d), new $61de1ee1cac498ae$var$Tkb(d));
    for(c = new $61de1ee1cac498ae$var$olb(d); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        b.p = $61de1ee1cac498ae$var$GDc(b).a;
    }
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(a.p, new $61de1ee1cac498ae$var$PDc);
}
function $61de1ee1cac498ae$var$eVc(a) {
    var b, c, d, e;
    d = 0;
    e = $61de1ee1cac498ae$var$gVc(a);
    if (e.c.length == 0) return 1;
    else for(c = new $61de1ee1cac498ae$var$olb(e); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 33);
        d += $61de1ee1cac498ae$var$eVc(b);
    }
    return d;
}
function $61de1ee1cac498ae$var$JJb(a, b) {
    var c, d, e;
    e = 0;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc();
    while(d.Ob()){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 111);
        e += c.d.b + c.b.rf().a + c.d.c;
        d.Ob() && (e += a.w);
    }
    return e;
}
function $61de1ee1cac498ae$var$RKb(a, b) {
    var c, d, e;
    e = 0;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc();
    while(d.Ob()){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 111);
        e += c.d.d + c.b.rf().b + c.d.a;
        d.Ob() && (e += a.w);
    }
    return e;
}
function $61de1ee1cac498ae$var$SOc(a, b, c, d) {
    if (b.a < d.a) return true;
    else if (b.a == d.a) {
        if (b.b < d.b) return true;
        else if (b.b == d.b) {
            if (a.b > c.b) return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$AD(a, b) {
    if ($61de1ee1cac498ae$var$ND(a)) return !!$61de1ee1cac498ae$var$zD[b];
    else if (a.hm) return !!a.hm[b];
    else if ($61de1ee1cac498ae$var$LD(a)) return !!$61de1ee1cac498ae$var$yD[b];
    else if ($61de1ee1cac498ae$var$KD(a)) return !!$61de1ee1cac498ae$var$xD[b];
    return false;
}
function $61de1ee1cac498ae$var$jkd(a, b, c) {
    c == null ? (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$LAd(a.o, b)) : (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$HAd(a.o, b, c));
    return a;
}
function $61de1ee1cac498ae$var$jKb(a, b, c, d) {
    var e, f;
    f = b.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$W8c)) ? $61de1ee1cac498ae$var$BD(b.We($61de1ee1cac498ae$var$W8c), 21) : a.j;
    e = $61de1ee1cac498ae$var$uJb(f);
    if (e == ($61de1ee1cac498ae$var$qJb(), $61de1ee1cac498ae$var$pJb)) return;
    if (c && !$61de1ee1cac498ae$var$sJb(e)) return;
    $61de1ee1cac498ae$var$UHb($61de1ee1cac498ae$var$lKb(a, e, d), b);
}
function $61de1ee1cac498ae$var$fid(a, b, c, d) {
    var e, f, g;
    f = $61de1ee1cac498ae$var$XKd(a.Tg(), b);
    e = b - a.Ah();
    return e < 0 ? (g = a.Yg(f), g >= 0 ? a._g(g, c, true) : $61de1ee1cac498ae$var$sid(a, f, c)) : $61de1ee1cac498ae$var$BD(f, 66).Nj().Pj(a, a.yh(), e, c, d);
}
function $61de1ee1cac498ae$var$u6d(a, b, c, d) {
    var e, f, g;
    if (c.mh(b)) {
        $61de1ee1cac498ae$var$Q6d();
        if ($61de1ee1cac498ae$var$YId(b)) {
            e = $61de1ee1cac498ae$var$BD(c.ah(b), 153);
            $61de1ee1cac498ae$var$x6d(a, e);
        } else {
            f = (g = b, !g ? null : $61de1ee1cac498ae$var$BD(d, 49).xh(g));
            !!f && $61de1ee1cac498ae$var$v6d(c.ah(b), f);
        }
    }
}
function $61de1ee1cac498ae$var$H3b(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$uLb;
        case 3:
            return $61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$rLb;
        case 2:
            return $61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$tLb;
        case 4:
            return $61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$sLb;
        default:
            return null;
    }
}
function $61de1ee1cac498ae$var$kCb(a) {
    switch(typeof a){
        case $61de1ee1cac498ae$var$Mhe:
            return $61de1ee1cac498ae$var$LCb(a);
        case $61de1ee1cac498ae$var$Lhe:
            return $61de1ee1cac498ae$var$QD(a);
        case $61de1ee1cac498ae$var$Khe:
            return $61de1ee1cac498ae$var$Bcb(), a ? 1231 : 1237;
        default:
            return a == null ? 0 : $61de1ee1cac498ae$var$FCb(a);
    }
}
function $61de1ee1cac498ae$var$Gic(a, b, c) {
    if (a.e) switch(a.b){
        case 1:
            $61de1ee1cac498ae$var$oic(a.c, b, c);
            break;
        case 0:
            $61de1ee1cac498ae$var$pic(a.c, b, c);
    }
    else $61de1ee1cac498ae$var$mic(a.c, b, c);
    a.a[b.p][c.p] = a.c.i;
    a.a[c.p][b.p] = a.c.e;
}
function $61de1ee1cac498ae$var$lHc(a) {
    var b, c;
    if (a == null) return null;
    c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$nie, 193, a.length, 0, 2);
    for(b = 0; b < c.length; b++)c[b] = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$ulb(a[b], a[b].length), 193);
    return c;
}
function $61de1ee1cac498ae$var$d4d(a) {
    var b;
    if ($61de1ee1cac498ae$var$b4d(a)) {
        $61de1ee1cac498ae$var$a4d(a);
        if (a.Lk()) {
            b = $61de1ee1cac498ae$var$b3d(a.e, a.b, a.c, a.a, a.j);
            a.j = b;
        }
        a.g = a.a;
        ++a.a;
        ++a.c;
        a.i = 0;
        return a.j;
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
}
function $61de1ee1cac498ae$var$fMb(a, b) {
    var c, d, e, f;
    f = a.o;
    c = a.p;
    f < c ? f *= f : c *= c;
    d = f + c;
    f = b.o;
    c = b.p;
    f < c ? f *= f : c *= c;
    e = f + c;
    if (d < e) return -1;
    if (d == e) return 0;
    return 1;
}
function $61de1ee1cac498ae$var$HLd(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$rud(a, b);
    if (e >= 0) return e;
    if (a.Fk()) for(d = 0; d < a.i; ++d){
        c = a.Gk($61de1ee1cac498ae$var$BD(a.g[d], 56));
        if ($61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD(b)) return d;
    }
    return -1;
}
function $61de1ee1cac498ae$var$Gtd(a, b, c) {
    var d, e;
    e = a.gc();
    if (b >= e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(b, e));
    if (a.hi()) {
        d = a.Xc(c);
        if (d >= 0 && d != b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$kue));
    }
    return a.mi(b, c);
}
function $61de1ee1cac498ae$var$gx(a, b) {
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a), 245);
    this.b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(b), 245);
    if (a.vd(b) > 0 || a == ($61de1ee1cac498ae$var$Lk(), $61de1ee1cac498ae$var$Kk) || b == ($61de1ee1cac498ae$var$_k(), $61de1ee1cac498ae$var$$k)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Invalid range: " + $61de1ee1cac498ae$var$nx(a, b)));
}
function $61de1ee1cac498ae$var$mYb(a) {
    var b, c;
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.c = a;
    this.a = false;
    for(c = new $61de1ee1cac498ae$var$olb(a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        this.a = this.a | b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
    }
}
function $61de1ee1cac498ae$var$GFb(a, b) {
    var c, d, e;
    c = $61de1ee1cac498ae$var$nGb(new $61de1ee1cac498ae$var$pGb, a);
    for(e = new $61de1ee1cac498ae$var$olb(b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 121);
        $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 0), 0), c), d));
    }
    return c;
}
function $61de1ee1cac498ae$var$Nac(a, b, c) {
    var d, e, f;
    for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur((b ? $61de1ee1cac498ae$var$R_b(a) : $61de1ee1cac498ae$var$U_b(a)).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
        f = b ? d.c.i : d.d.i;
        f.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b) && $61de1ee1cac498ae$var$$_b(f, c);
    }
}
function $61de1ee1cac498ae$var$Izc() {
    $61de1ee1cac498ae$var$Izc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Gzc = new $61de1ee1cac498ae$var$Kzc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$Hzc = new $61de1ee1cac498ae$var$Kzc("PORT_POSITION", 1);
    $61de1ee1cac498ae$var$Fzc = new $61de1ee1cac498ae$var$Kzc("NODE_SIZE_WHERE_SPACE_PERMITS", 2);
    $61de1ee1cac498ae$var$Ezc = new $61de1ee1cac498ae$var$Kzc("NODE_SIZE", 3);
}
function $61de1ee1cac498ae$var$F7c() {
    $61de1ee1cac498ae$var$F7c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$z7c = new $61de1ee1cac498ae$var$G7c("AUTOMATIC", 0);
    $61de1ee1cac498ae$var$C7c = new $61de1ee1cac498ae$var$G7c($61de1ee1cac498ae$var$jle, 1);
    $61de1ee1cac498ae$var$D7c = new $61de1ee1cac498ae$var$G7c($61de1ee1cac498ae$var$kle, 2);
    $61de1ee1cac498ae$var$E7c = new $61de1ee1cac498ae$var$G7c("TOP", 3);
    $61de1ee1cac498ae$var$A7c = new $61de1ee1cac498ae$var$G7c($61de1ee1cac498ae$var$mle, 4);
    $61de1ee1cac498ae$var$B7c = new $61de1ee1cac498ae$var$G7c($61de1ee1cac498ae$var$gle, 5);
}
function $61de1ee1cac498ae$var$Hhb(a, b, c, d) {
    $61de1ee1cac498ae$var$Dhb();
    var e, f;
    e = 0;
    for(f = 0; f < c; f++){
        e = $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$xbb(b[f], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(d, $61de1ee1cac498ae$var$Yje)), $61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Tbb(e), $61de1ee1cac498ae$var$Yje));
        a[f] = $61de1ee1cac498ae$var$Tbb(e);
        e = $61de1ee1cac498ae$var$Pbb(e, 32);
    }
    return $61de1ee1cac498ae$var$Tbb(e);
}
function $61de1ee1cac498ae$var$zHb(a, b, c) {
    var d, e;
    e = 0;
    for(d = 0; d < $61de1ee1cac498ae$var$rHb; d++)e = $61de1ee1cac498ae$var$$wnd.Math.max(e, $61de1ee1cac498ae$var$pHb(a.a[b.g][d], c));
    b == ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$eHb) && !!a.b && (e = $61de1ee1cac498ae$var$$wnd.Math.max(e, a.b.b));
    return e;
}
function $61de1ee1cac498ae$var$Bub(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$lCb(b > 0);
    if ((b & -b) == b) return $61de1ee1cac498ae$var$QD(b * $61de1ee1cac498ae$var$Cub(a, 31) * 4.6566128730773926E-10);
    do {
        c = $61de1ee1cac498ae$var$Cub(a, 31);
        d = c % b;
    }while (c - d + (b - 1) < 0);
    return $61de1ee1cac498ae$var$QD(d);
}
function $61de1ee1cac498ae$var$LCb(a) {
    $61de1ee1cac498ae$var$JCb();
    var b, c, d;
    c = ":" + a;
    d = $61de1ee1cac498ae$var$ICb[c];
    if (d != null) return $61de1ee1cac498ae$var$QD(($61de1ee1cac498ae$var$uCb(d), d));
    d = $61de1ee1cac498ae$var$GCb[c];
    b = d == null ? $61de1ee1cac498ae$var$KCb(a) : $61de1ee1cac498ae$var$QD(($61de1ee1cac498ae$var$uCb(d), d));
    $61de1ee1cac498ae$var$MCb();
    $61de1ee1cac498ae$var$ICb[c] = b;
    return b;
}
function $61de1ee1cac498ae$var$qZb(a, b, c) {
    $61de1ee1cac498ae$var$Odd(c, "Compound graph preprocessor", 1);
    a.a = new $61de1ee1cac498ae$var$Hp;
    $61de1ee1cac498ae$var$vZb(a, b, null);
    $61de1ee1cac498ae$var$pZb(a, b);
    $61de1ee1cac498ae$var$uZb(a);
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$zsc), a.a);
    a.a = null;
    $61de1ee1cac498ae$var$Uhb(a.b);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$X$b(a, b, c) {
    switch(c.g){
        case 1:
            a.a = b.a / 2;
            a.b = 0;
            break;
        case 2:
            a.a = b.a;
            a.b = b.b / 2;
            break;
        case 3:
            a.a = b.a / 2;
            a.b = b.b;
            break;
        case 4:
            a.a = 0;
            a.b = b.b / 2;
    }
}
function $61de1ee1cac498ae$var$tkc(a) {
    var b, c, d;
    for(d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.a, ($61de1ee1cac498ae$var$Xjc(), $61de1ee1cac498ae$var$Vjc)), 15).Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 101);
        b = $61de1ee1cac498ae$var$Bkc(c);
        $61de1ee1cac498ae$var$kkc(a, c, b[0], ($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$Ckc), 0);
        $61de1ee1cac498ae$var$kkc(a, c, b[1], $61de1ee1cac498ae$var$Ekc, 1);
    }
}
function $61de1ee1cac498ae$var$ukc(a) {
    var b, c, d;
    for(d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.a, ($61de1ee1cac498ae$var$Xjc(), $61de1ee1cac498ae$var$Wjc)), 15).Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 101);
        b = $61de1ee1cac498ae$var$Bkc(c);
        $61de1ee1cac498ae$var$kkc(a, c, b[0], ($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$Ckc), 0);
        $61de1ee1cac498ae$var$kkc(a, c, b[1], $61de1ee1cac498ae$var$Ekc, 1);
    }
}
function $61de1ee1cac498ae$var$tXc(a) {
    switch(a.g){
        case 0:
            return null;
        case 1:
            return new $61de1ee1cac498ae$var$$Xc;
        case 2:
            return new $61de1ee1cac498ae$var$QXc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$jre + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$OZc(a, b, c) {
    var d, e;
    $61de1ee1cac498ae$var$FZc(a, b - a.s, c - a.t);
    for(e = new $61de1ee1cac498ae$var$olb(a.n); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 211);
        $61de1ee1cac498ae$var$SZc(d, d.e + b - a.s);
        $61de1ee1cac498ae$var$TZc(d, d.f + c - a.t);
    }
    a.s = b;
    a.t = c;
}
function $61de1ee1cac498ae$var$JFb(a) {
    var b, c, d, e, f;
    c = 0;
    for(e = new $61de1ee1cac498ae$var$olb(a.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 121);
        d.d = c++;
    }
    b = $61de1ee1cac498ae$var$IFb(a);
    f = null;
    b.c.length > 1 && (f = $61de1ee1cac498ae$var$GFb(a, b));
    return f;
}
function $61de1ee1cac498ae$var$dmd(a) {
    var b;
    if (!!a.f && a.f.kh()) {
        b = $61de1ee1cac498ae$var$BD(a.f, 49);
        a.f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$xid(a, b), 82);
        a.f != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 9, 8, b, a.f));
    }
    return a.f;
}
function $61de1ee1cac498ae$var$emd(a) {
    var b;
    if (!!a.i && a.i.kh()) {
        b = $61de1ee1cac498ae$var$BD(a.i, 49);
        a.i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$xid(a, b), 82);
        a.i != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 9, 7, b, a.i));
    }
    return a.i;
}
function $61de1ee1cac498ae$var$zUd(a) {
    var b;
    if (!!a.b && (a.b.Db & 64) != 0) {
        b = a.b;
        a.b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$xid(a, b), 18);
        a.b != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 9, 21, b, a.b));
    }
    return a.b;
}
function $61de1ee1cac498ae$var$uAd(a, b) {
    var c, d, e;
    if (a.d == null) {
        ++a.e;
        ++a.f;
    } else {
        d = b.Sh();
        $61de1ee1cac498ae$var$BAd(a, a.f + 1);
        e = (d & $61de1ee1cac498ae$var$Ohe) % a.d.length;
        c = a.d[e];
        !c && (c = a.d[e] = a.uj());
        c.Fc(b);
        ++a.f;
    }
}
function $61de1ee1cac498ae$var$m3d(a, b, c) {
    var d;
    if (b.Kj()) return false;
    else if (b.Zj() != -2) {
        d = b.zj();
        return d == null ? c == null : $61de1ee1cac498ae$var$pb(d, c);
    } else return b.Hj() == a.e.Tg() && c == null;
}
function $61de1ee1cac498ae$var$wo() {
    var a;
    $61de1ee1cac498ae$var$Xj(16, $61de1ee1cac498ae$var$Hie);
    a = $61de1ee1cac498ae$var$Kp(16);
    this.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$GF, $61de1ee1cac498ae$var$Gie, 317, a, 0, 1);
    this.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$GF, $61de1ee1cac498ae$var$Gie, 317, a, 0, 1);
    this.a = null;
    this.e = null;
    this.i = 0;
    this.f = a - 1;
    this.g = 0;
}
function $61de1ee1cac498ae$var$b0b(a) {
    $61de1ee1cac498ae$var$n_b.call(this);
    this.k = ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
    this.j = ($61de1ee1cac498ae$var$Xj(6, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(6));
    this.b = ($61de1ee1cac498ae$var$Xj(2, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(2));
    this.d = new $61de1ee1cac498ae$var$L_b;
    this.f = new $61de1ee1cac498ae$var$s0b;
    this.a = a;
}
function $61de1ee1cac498ae$var$Scc(a) {
    var b, c;
    if (a.c.length <= 1) return;
    b = $61de1ee1cac498ae$var$Pcc(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd));
    $61de1ee1cac498ae$var$Rcc(a, $61de1ee1cac498ae$var$BD(b.a, 19).a, $61de1ee1cac498ae$var$BD(b.b, 19).a);
    c = $61de1ee1cac498ae$var$Pcc(a, $61de1ee1cac498ae$var$Tcd);
    $61de1ee1cac498ae$var$Rcc(a, $61de1ee1cac498ae$var$BD(c.a, 19).a, $61de1ee1cac498ae$var$BD(c.b, 19).a);
}
function $61de1ee1cac498ae$var$Vzc() {
    $61de1ee1cac498ae$var$Vzc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Uzc = new $61de1ee1cac498ae$var$Xzc("SIMPLE", 0);
    $61de1ee1cac498ae$var$Rzc = new $61de1ee1cac498ae$var$Xzc($61de1ee1cac498ae$var$Tne, 1);
    $61de1ee1cac498ae$var$Szc = new $61de1ee1cac498ae$var$Xzc("LINEAR_SEGMENTS", 2);
    $61de1ee1cac498ae$var$Qzc = new $61de1ee1cac498ae$var$Xzc("BRANDES_KOEPF", 3);
    $61de1ee1cac498ae$var$Tzc = new $61de1ee1cac498ae$var$Xzc($61de1ee1cac498ae$var$Aqe, 4);
}
function $61de1ee1cac498ae$var$XDc(a, b, c) {
    if (!$61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98))) {
        $61de1ee1cac498ae$var$WDc(a, b, $61de1ee1cac498ae$var$Y_b(b, c));
        $61de1ee1cac498ae$var$WDc(a, b, $61de1ee1cac498ae$var$Y_b(b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd)));
        $61de1ee1cac498ae$var$WDc(a, b, $61de1ee1cac498ae$var$Y_b(b, $61de1ee1cac498ae$var$Acd));
        $61de1ee1cac498ae$var$mmb();
        $61de1ee1cac498ae$var$Okb(b.j, new $61de1ee1cac498ae$var$jEc(a));
    }
}
function $61de1ee1cac498ae$var$HVc(a, b, c, d) {
    var e, f, g;
    e = d ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.a, b), 21) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.b, b), 21);
    for(g = e.Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 33);
        if ($61de1ee1cac498ae$var$BVc(a, c, f)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$FMd(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$Fyd(a); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 87);
        if (!!b.e || (!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d).i != 0) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$QTd(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$Fyd(a); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 87);
        if (!!b.e || (!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d).i != 0) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$FDc(a) {
    var b, c, d;
    b = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.c.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
        b += $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(c).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
    }
    return b / a.c.a.c.length;
}
function $61de1ee1cac498ae$var$UPc(a) {
    var b, c;
    a.c || $61de1ee1cac498ae$var$XPc(a);
    c = new $61de1ee1cac498ae$var$s7c;
    b = new $61de1ee1cac498ae$var$olb(a.a);
    $61de1ee1cac498ae$var$mlb(b);
    while(b.a < b.c.c.length)$61de1ee1cac498ae$var$Dsb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(b), 407).a);
    $61de1ee1cac498ae$var$sCb(c.b != 0);
    $61de1ee1cac498ae$var$Nsb(c, c.c.b);
    return c;
}
function $61de1ee1cac498ae$var$J0c() {
    $61de1ee1cac498ae$var$J0c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$I0c = ($61de1ee1cac498ae$var$A0c(), $61de1ee1cac498ae$var$z0c);
    $61de1ee1cac498ae$var$G0c = new $61de1ee1cac498ae$var$q0b(8);
    new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c), $61de1ee1cac498ae$var$G0c);
    new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$T9c, 8);
    $61de1ee1cac498ae$var$H0c = $61de1ee1cac498ae$var$x0c;
    $61de1ee1cac498ae$var$E0c = $61de1ee1cac498ae$var$n0c;
    $61de1ee1cac498ae$var$F0c = $61de1ee1cac498ae$var$o0c;
    $61de1ee1cac498ae$var$D0c = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$y8c, ($61de1ee1cac498ae$var$Bcb(), false));
}
function $61de1ee1cac498ae$var$uld(a, b, c, d) {
    switch(b){
        case 7:
            return !a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4)), a.e;
        case 8:
            return !a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5)), a.d;
    }
    return $61de1ee1cac498ae$var$Xkd(a, b, c, d);
}
function $61de1ee1cac498ae$var$JQd(a) {
    var b;
    if (!!a.a && a.a.kh()) {
        b = $61de1ee1cac498ae$var$BD(a.a, 49);
        a.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$xid(a, b), 138);
        a.a != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 9, 5, b, a.a));
    }
    return a.a;
}
function $61de1ee1cac498ae$var$yde(a) {
    if (a < 48) return -1;
    if (a > 102) return -1;
    if (a <= 57) return a - 48;
    if (a < 65) return -1;
    if (a <= 70) return a - 65 + 10;
    if (a < 97) return -1;
    return a - 97 + 10;
}
function $61de1ee1cac498ae$var$Wj(a, b) {
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb("null key in entry: null=" + b));
    else if (b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb("null value in entry: " + a + "=null"));
}
function $61de1ee1cac498ae$var$kr(a, b) {
    var c, d;
    while(a.Ob()){
        if (!b.Ob()) return false;
        c = a.Pb();
        d = b.Pb();
        if (!($61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD(d) || c != null && $61de1ee1cac498ae$var$pb(c, d))) return false;
    }
    return !b.Ob();
}
function $61de1ee1cac498ae$var$jIb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        $61de1ee1cac498ae$var$pHb(a.a[0], b),
        $61de1ee1cac498ae$var$pHb(a.a[1], b),
        $61de1ee1cac498ae$var$pHb(a.a[2], b)
    ]);
    if (a.d) {
        c[0] = $61de1ee1cac498ae$var$$wnd.Math.max(c[0], c[2]);
        c[2] = c[0];
    }
    return c;
}
function $61de1ee1cac498ae$var$kIb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        $61de1ee1cac498ae$var$qHb(a.a[0], b),
        $61de1ee1cac498ae$var$qHb(a.a[1], b),
        $61de1ee1cac498ae$var$qHb(a.a[2], b)
    ]);
    if (a.d) {
        c[0] = $61de1ee1cac498ae$var$$wnd.Math.max(c[0], c[2]);
        c[2] = c[0];
    }
    return c;
}
function $61de1ee1cac498ae$var$mqc() {
    $61de1ee1cac498ae$var$mqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$iqc = new $61de1ee1cac498ae$var$oqc("GREEDY", 0);
    $61de1ee1cac498ae$var$hqc = new $61de1ee1cac498ae$var$oqc($61de1ee1cac498ae$var$Une, 1);
    $61de1ee1cac498ae$var$kqc = new $61de1ee1cac498ae$var$oqc($61de1ee1cac498ae$var$Tne, 2);
    $61de1ee1cac498ae$var$lqc = new $61de1ee1cac498ae$var$oqc("MODEL_ORDER", 3);
    $61de1ee1cac498ae$var$jqc = new $61de1ee1cac498ae$var$oqc("GREEDY_MODEL_ORDER", 4);
}
function $61de1ee1cac498ae$var$iUc(a, b) {
    var c, d, e;
    a.b[b.g] = 1;
    for(d = $61de1ee1cac498ae$var$Jsb(b.d, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 188);
        e = c.c;
        a.b[e.g] == 1 ? $61de1ee1cac498ae$var$Dsb(a.a, c) : a.b[e.g] == 2 ? a.b[e.g] = 1 : $61de1ee1cac498ae$var$iUc(a, e);
    }
}
function $61de1ee1cac498ae$var$V9b(a, b) {
    var c, d, e;
    e = new $61de1ee1cac498ae$var$Skb(b.gc());
    for(d = b.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 286);
        c.c == c.f ? $61de1ee1cac498ae$var$K9b(a, c, c.c) : $61de1ee1cac498ae$var$L9b(a, c) || (e.c[e.c.length] = c);
    }
    return e;
}
function $61de1ee1cac498ae$var$IZc(a, b, c) {
    var d, e, f, g, h;
    h = a.r + b;
    a.r += b;
    a.d += c;
    d = c / a.n.c.length;
    e = 0;
    for(g = new $61de1ee1cac498ae$var$olb(a.n); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 211);
        $61de1ee1cac498ae$var$RZc(f, h, d, e);
        ++e;
    }
}
function $61de1ee1cac498ae$var$tEb(a) {
    var b, c, d;
    $61de1ee1cac498ae$var$zwb(a.b.a);
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$PM, $61de1ee1cac498ae$var$Uhe, 57, a.c.c.a.b.c.length, 0, 1);
    b = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.c.c.a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 57);
        c.f = b++;
    }
}
function $61de1ee1cac498ae$var$RVb(a) {
    var b, c, d;
    $61de1ee1cac498ae$var$zwb(a.b.a);
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$IP, $61de1ee1cac498ae$var$Uhe, 81, a.c.a.a.b.c.length, 0, 1);
    b = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.c.a.a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 81);
        c.i = b++;
    }
}
function $61de1ee1cac498ae$var$P1c(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$Odd(c, "Shrinking tree compaction", 1);
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$XNb(), $61de1ee1cac498ae$var$VNb))))) {
        $61de1ee1cac498ae$var$N1c(a, b.f);
        $61de1ee1cac498ae$var$INb(b.f, (d = b.c, d));
    } else $61de1ee1cac498ae$var$INb(b.f, b.c);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$mr(a) {
    var b;
    b = $61de1ee1cac498ae$var$gr(a);
    if (!$61de1ee1cac498ae$var$Qr(a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb("position (0) must be less than the number of elements that remained (" + b + ")"));
    return $61de1ee1cac498ae$var$Rr(a);
}
function $61de1ee1cac498ae$var$hNb(b, c, d) {
    var e;
    try {
        return $61de1ee1cac498ae$var$YMb(b, c + b.j, d + b.k);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb(e.g + $61de1ee1cac498ae$var$Gle + c + $61de1ee1cac498ae$var$She + d + ")."));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$iNb(b, c, d) {
    var e;
    try {
        return $61de1ee1cac498ae$var$ZMb(b, c + b.j, d + b.k);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb(e.g + $61de1ee1cac498ae$var$Gle + c + $61de1ee1cac498ae$var$She + d + ")."));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$jNb(b, c, d) {
    var e;
    try {
        return $61de1ee1cac498ae$var$$Mb(b, c + b.j, d + b.k);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb(e.g + $61de1ee1cac498ae$var$Gle + c + $61de1ee1cac498ae$var$She + d + ")."));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$s5b(a) {
    switch(a.g){
        case 1:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd;
        case 4:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd;
        case 3:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd;
        case 2:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd;
        default:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd;
    }
}
function $61de1ee1cac498ae$var$cjc(a, b, c) {
    if (b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) && c.k == $61de1ee1cac498ae$var$g0b) {
        a.d = $61de1ee1cac498ae$var$_ic(b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd));
        a.b = $61de1ee1cac498ae$var$_ic(b, $61de1ee1cac498ae$var$Acd);
    }
    if (c.k == $61de1ee1cac498ae$var$h0b && b.k == $61de1ee1cac498ae$var$g0b) {
        a.d = $61de1ee1cac498ae$var$_ic(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
        a.b = $61de1ee1cac498ae$var$_ic(c, $61de1ee1cac498ae$var$Rcd);
    }
}
function $61de1ee1cac498ae$var$gjc(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$V_b(a, b);
    for(d = e.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 11);
        if ($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)) != null || $61de1ee1cac498ae$var$a1b(new $61de1ee1cac498ae$var$b1b(c.b))) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$QZc(a, b) {
    $61de1ee1cac498ae$var$dld(b, a.e + a.d + (a.c.c.length == 0 ? 0 : a.b));
    $61de1ee1cac498ae$var$eld(b, a.f);
    a.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.a, b.f);
    a.d += b.g + (a.c.c.length == 0 ? 0 : a.b);
    $61de1ee1cac498ae$var$Ekb(a.c, b);
    return true;
}
function $61de1ee1cac498ae$var$XZc(a, b, c) {
    var d, e, f, g;
    g = 0;
    d = c / a.a.c.length;
    for(f = new $61de1ee1cac498ae$var$olb(a.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 187);
        $61de1ee1cac498ae$var$OZc(e, e.s, e.t + g * d);
        $61de1ee1cac498ae$var$IZc(e, a.d - e.r + b, d);
        ++g;
    }
}
function $61de1ee1cac498ae$var$H4b(a) {
    var b, c, d, e, f;
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        b = 0;
        for(f = new $61de1ee1cac498ae$var$olb(c.a); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
            e.p = b++;
        }
    }
}
function $61de1ee1cac498ae$var$r6c(a, b) {
    var c, d, e, f, g, h;
    e = b.length - 1;
    g = 0;
    h = 0;
    for(d = 0; d <= e; d++){
        f = b[d];
        c = $61de1ee1cac498ae$var$k6c(e, d) * $61de1ee1cac498ae$var$x6c(1 - a, e - d) * $61de1ee1cac498ae$var$x6c(a, d);
        g += f.a * c;
        h += f.b * c;
    }
    return new $61de1ee1cac498ae$var$f7c(g, h);
}
function $61de1ee1cac498ae$var$jud(a, b) {
    var c, d, e, f, g;
    c = b.gc();
    a.qi(a.i + c);
    f = b.Kc();
    g = a.i;
    a.i += c;
    for(d = g; d < a.i; ++d){
        e = f.Pb();
        $61de1ee1cac498ae$var$mud(a, d, a.oi(d, e));
        a.bi(d, e);
        a.ci();
    }
    return c != 0;
}
function $61de1ee1cac498ae$var$twd(a, b, c) {
    var d, e, f;
    if (a.ej()) {
        d = a.Vi();
        f = a.fj();
        ++a.j;
        a.Hi(d, a.oi(d, b));
        e = a.Zi(3, null, b, d, f);
        !c ? c = e : c.Ei(e);
    } else $61de1ee1cac498ae$var$Avd(a, a.Vi(), b);
    return c;
}
function $61de1ee1cac498ae$var$WOd(a, b, c) {
    var d, e, f;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$VKd(a.a), b), 87);
    f = (e = d.c, $61de1ee1cac498ae$var$JD(e, 88) ? $61de1ee1cac498ae$var$BD(e, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
    ((f.Db & 64) != 0 ? $61de1ee1cac498ae$var$xid(a.b, f) : f) == c ? $61de1ee1cac498ae$var$KQd(d) : $61de1ee1cac498ae$var$NQd(d, c);
    return f;
}
function $61de1ee1cac498ae$var$Ewb(a, b, c, d, e, f, g, h) {
    var i, j;
    if (!d) return;
    i = d.a[0];
    !!i && $61de1ee1cac498ae$var$Ewb(a, b, c, i, e, f, g, h);
    $61de1ee1cac498ae$var$Fwb(a, c, d.d, e, f, g, h) && b.Fc(d);
    j = d.a[1];
    !!j && $61de1ee1cac498ae$var$Ewb(a, b, c, j, e, f, g, h);
}
function $61de1ee1cac498ae$var$eAb(a, b) {
    var c;
    if (!a.a) {
        c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, 0, 15, 1);
        $61de1ee1cac498ae$var$_ub(a.b.a, new $61de1ee1cac498ae$var$iAb(c));
        c.sort($61de1ee1cac498ae$var$dcb($61de1ee1cac498ae$var$Ylb.prototype.te, $61de1ee1cac498ae$var$Ylb, []));
        a.a = new $61de1ee1cac498ae$var$Avb(c, a.d);
    }
    return $61de1ee1cac498ae$var$pvb(a.a, b);
}
function $61de1ee1cac498ae$var$YMb(b, c, d) {
    try {
        return $61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$_Mb(b, c, d), 1);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 320)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Dle + b.o + "*" + b.p + $61de1ee1cac498ae$var$Ele + c + $61de1ee1cac498ae$var$She + d + $61de1ee1cac498ae$var$Fle));
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$ZMb(b, c, d) {
    try {
        return $61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$_Mb(b, c, d), 0);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 320)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Dle + b.o + "*" + b.p + $61de1ee1cac498ae$var$Ele + c + $61de1ee1cac498ae$var$She + d + $61de1ee1cac498ae$var$Fle));
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$$Mb(b, c, d) {
    try {
        return $61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$_Mb(b, c, d), 2);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 320)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Dle + b.o + "*" + b.p + $61de1ee1cac498ae$var$Ele + c + $61de1ee1cac498ae$var$She + d + $61de1ee1cac498ae$var$Fle));
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$Nyd(b, c) {
    if (b.g == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    b.mj();
    try {
        b.d._c(b.g, c);
        b.f = b.d.j;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$rJc(a, b, c) {
    $61de1ee1cac498ae$var$Odd(c, "Linear segments node placement", 1);
    a.b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    $61de1ee1cac498ae$var$sJc(a, b);
    $61de1ee1cac498ae$var$nJc(a, b);
    $61de1ee1cac498ae$var$kJc(a, b);
    $61de1ee1cac498ae$var$qJc(a);
    a.a = null;
    a.b = null;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$Ee(a, b) {
    var c, d, e, f;
    f = a.gc();
    b.length < f && (b = $61de1ee1cac498ae$var$eCb(new Array(f), b));
    e = b;
    d = a.Kc();
    for(c = 0; c < f; ++c)$61de1ee1cac498ae$var$NC(e, c, d.Pb());
    b.length > f && $61de1ee1cac498ae$var$NC(b, f, null);
    return b;
}
function $61de1ee1cac498ae$var$Lu(a, b) {
    var c, d;
    d = a.gc();
    if (b == null) for(c = 0; c < d; c++){
        if (a.Xb(c) == null) return c;
    }
    else for(c = 0; c < d; c++){
        if ($61de1ee1cac498ae$var$pb(b, a.Xb(c))) return c;
    }
    return -1;
}
function $61de1ee1cac498ae$var$Jd(a, b) {
    var c, d, e;
    c = b.cd();
    e = b.dd();
    d = a.xc(c);
    if (!($61de1ee1cac498ae$var$PD(e) === $61de1ee1cac498ae$var$PD(d) || e != null && $61de1ee1cac498ae$var$pb(e, d))) return false;
    if (d == null && !a._b(c)) return false;
    return true;
}
function $61de1ee1cac498ae$var$YC(a, b) {
    var c, d, e;
    if (b <= 22) {
        c = a.l & (1 << b) - 1;
        d = e = 0;
    } else if (b <= 44) {
        c = a.l;
        d = a.m & (1 << b - 22) - 1;
        e = 0;
    } else {
        c = a.l;
        d = a.m;
        e = a.h & (1 << b - 44) - 1;
    }
    return $61de1ee1cac498ae$var$TC(c, d, e);
}
function $61de1ee1cac498ae$var$yKb(a, b) {
    switch(b.g){
        case 1:
            return a.f.n.d + a.t;
        case 3:
            return a.f.n.a + a.t;
        case 2:
            return a.f.n.c + a.s;
        case 4:
            return a.f.n.b + a.s;
        default:
            return 0;
    }
}
function $61de1ee1cac498ae$var$aLb(a, b) {
    var c, d;
    d = b.c;
    c = b.a;
    switch(a.b.g){
        case 0:
            c.d = a.e - d.a - d.d;
            break;
        case 1:
            c.d += a.e;
            break;
        case 2:
            c.c = a.e - d.a - d.d;
            break;
        case 3:
            c.c = a.e + d.d;
    }
}
function $61de1ee1cac498ae$var$ZOb(a, b, c, d) {
    var e, f;
    this.a = b;
    this.c = d;
    e = a.a;
    $61de1ee1cac498ae$var$YOb(this, new $61de1ee1cac498ae$var$f7c(-e.c, -e.d));
    $61de1ee1cac498ae$var$P6c(this.b, c);
    f = d / 2;
    b.a ? $61de1ee1cac498ae$var$b7c(this.b, 0, f) : $61de1ee1cac498ae$var$b7c(this.b, f, 0);
    $61de1ee1cac498ae$var$Ekb(a.c, this);
}
function $61de1ee1cac498ae$var$iXc() {
    $61de1ee1cac498ae$var$iXc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$hXc = new $61de1ee1cac498ae$var$kXc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$fXc = new $61de1ee1cac498ae$var$kXc($61de1ee1cac498ae$var$Vne, 1);
    $61de1ee1cac498ae$var$gXc = new $61de1ee1cac498ae$var$kXc("EDGE_LENGTH_BY_POSITION", 2);
    $61de1ee1cac498ae$var$eXc = new $61de1ee1cac498ae$var$kXc("CROSSING_MINIMIZATION_BY_POSITION", 3);
}
function $61de1ee1cac498ae$var$Wqd(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.g, b), 33);
    if (c) return c;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.j, b), 118);
    if (d) return d;
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("Referenced shape does not exist: " + b));
}
function $61de1ee1cac498ae$var$rTb(a, b) {
    if (a.c == b) return a.d;
    else if (a.d == b) return a.c;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Node 'one' must be either source or target of edge 'edge'."));
}
function $61de1ee1cac498ae$var$TMc(a, b) {
    if (a.c.i == b) return a.d.i;
    else if (a.d.i == b) return a.c.i;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Node " + b + " is neither source nor target of edge " + a));
}
function $61de1ee1cac498ae$var$_lc(a, b) {
    var c;
    switch(b.g){
        case 2:
        case 4:
            c = a.a;
            a.c.d.n.b < c.d.n.b && (c = a.c);
            $61de1ee1cac498ae$var$amc(a, b, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$zjc), c);
            break;
        case 1:
        case 3:
            $61de1ee1cac498ae$var$amc(a, b, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$wjc), null);
    }
}
function $61de1ee1cac498ae$var$smc(a, b, c, d, e, f) {
    var g, h, i, j, k;
    g = $61de1ee1cac498ae$var$qmc(b, c, f);
    h = c == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || c == $61de1ee1cac498ae$var$Tcd ? -1 : 1;
    j = a[c.g];
    for(k = 0; k < j.length; k++){
        i = j[k];
        i > 0 && (i += e);
        j[k] = g;
        g += h * (i + d);
    }
}
function $61de1ee1cac498ae$var$Uoc(a) {
    var b, c, d;
    d = a.f;
    a.n = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, d, 15, 1);
    a.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, d, 15, 1);
    for(b = 0; b < d; b++){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.c.b, b), 29);
        a.n[b] = $61de1ee1cac498ae$var$Roc(a, c);
        a.d[b] = $61de1ee1cac498ae$var$Qoc(a, c);
    }
}
function $61de1ee1cac498ae$var$zjd(a, b) {
    var c, d, e;
    e = 0;
    for(d = 2; d < b; d <<= 1)(a.Db & d) != 0 && ++e;
    if (e == 0) {
        for(c = b <<= 1; c <= 128; c <<= 1){
            if ((a.Db & c) != 0) return 0;
        }
        return -1;
    } else return e;
}
function $61de1ee1cac498ae$var$s3d(a, b) {
    var c, d, e, f, g;
    g = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    f = null;
    c = $61de1ee1cac498ae$var$BD(a.g, 119);
    for(e = 0; e < a.i; ++e){
        d = c[e];
        if (g.rl(d.ak())) {
            !f && (f = new $61de1ee1cac498ae$var$yud);
            $61de1ee1cac498ae$var$wtd(f, d);
        }
    }
    !!f && $61de1ee1cac498ae$var$Yxd(a, f);
}
function $61de1ee1cac498ae$var$H9d(a) {
    var b, c, d;
    if (!a) return null;
    if (a.dc()) return "";
    d = new $61de1ee1cac498ae$var$Hfb;
    for(c = a.Kc(); c.Ob();){
        b = c.Pb();
        $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$GD(b));
        d.a += " ";
    }
    return $61de1ee1cac498ae$var$lcb(d, d.a.length - 1);
}
function $61de1ee1cac498ae$var$Ty(a, b, c) {
    var d, e, f, g, h;
    $61de1ee1cac498ae$var$Uy(a);
    for(e = (a.k == null && (a.k = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$_I, $61de1ee1cac498ae$var$nie, 78, 0, 0, 1)), a.k), f = 0, g = e.length; f < g; ++f){
        d = e[f];
        $61de1ee1cac498ae$var$Ty(d, b, "	" + c);
    }
    h = a.f;
    !!h && $61de1ee1cac498ae$var$Ty(h, b, c);
}
function $61de1ee1cac498ae$var$LC(a, b) {
    var c = new Array(b);
    var d;
    switch(a){
        case 14:
        case 15:
            d = 0;
            break;
        case 16:
            d = false;
            break;
        default:
            return c;
    }
    for(var e = 0; e < b; ++e)c[e] = d;
    return c;
}
function $61de1ee1cac498ae$var$PDb(a) {
    var b, c, d;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        b.c.$b();
    }
    $61de1ee1cac498ae$var$fad(a.d) ? d = a.a.c : d = a.a.d;
    $61de1ee1cac498ae$var$Hkb(d, new $61de1ee1cac498ae$var$dEb(a));
    a.c.Me(a);
    $61de1ee1cac498ae$var$QDb(a);
}
function $61de1ee1cac498ae$var$sRb(a) {
    var b, c, d, e;
    for(c = new $61de1ee1cac498ae$var$olb(a.e.c); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 282);
        for(e = new $61de1ee1cac498ae$var$olb(b.b); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 447);
            $61de1ee1cac498ae$var$lRb(d);
        }
        $61de1ee1cac498ae$var$cRb(b);
    }
}
function $61de1ee1cac498ae$var$a$c(a) {
    var b, c, d, e, f;
    d = 0;
    f = 0;
    e = 0;
    for(c = new $61de1ee1cac498ae$var$olb(a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 187);
        f = $61de1ee1cac498ae$var$$wnd.Math.max(f, b.r);
        d += b.d + (e > 0 ? a.c : 0);
        ++e;
    }
    a.b = d;
    a.d = f;
}
function $61de1ee1cac498ae$var$BZc(a, b) {
    var c, d, e, f, g;
    d = 0;
    e = 0;
    c = 0;
    for(g = new $61de1ee1cac498ae$var$olb(b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 200);
        d = $61de1ee1cac498ae$var$$wnd.Math.max(d, f.e);
        e += f.b + (c > 0 ? a.g : 0);
        ++c;
    }
    a.c = e;
    a.d = d;
}
function $61de1ee1cac498ae$var$AHb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        $61de1ee1cac498ae$var$zHb(a, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$dHb), b),
        $61de1ee1cac498ae$var$zHb(a, $61de1ee1cac498ae$var$eHb, b),
        $61de1ee1cac498ae$var$zHb(a, $61de1ee1cac498ae$var$fHb, b)
    ]);
    if (a.f) {
        c[0] = $61de1ee1cac498ae$var$$wnd.Math.max(c[0], c[2]);
        c[2] = c[0];
    }
    return c;
}
function $61de1ee1cac498ae$var$lNb(b, c, d) {
    var e;
    try {
        $61de1ee1cac498ae$var$aNb(b, c + b.j, d + b.k, false, true);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb(e.g + $61de1ee1cac498ae$var$Gle + c + $61de1ee1cac498ae$var$She + d + ")."));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$mNb(b, c, d) {
    var e;
    try {
        $61de1ee1cac498ae$var$aNb(b, c + b.j, d + b.k, true, false);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb(e.g + $61de1ee1cac498ae$var$Gle + c + $61de1ee1cac498ae$var$She + d + ")."));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$d5b(a) {
    var b;
    if (!$61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$xxc))) return;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$xxc), 21);
    if (b.Hc(($61de1ee1cac498ae$var$Hbd(), $61de1ee1cac498ae$var$zbd))) {
        b.Mc($61de1ee1cac498ae$var$zbd);
        b.Fc($61de1ee1cac498ae$var$Bbd);
    } else if (b.Hc($61de1ee1cac498ae$var$Bbd)) {
        b.Mc($61de1ee1cac498ae$var$Bbd);
        b.Fc($61de1ee1cac498ae$var$zbd);
    }
}
function $61de1ee1cac498ae$var$e5b(a) {
    var b;
    if (!$61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$xxc))) return;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$xxc), 21);
    if (b.Hc(($61de1ee1cac498ae$var$Hbd(), $61de1ee1cac498ae$var$Gbd))) {
        b.Mc($61de1ee1cac498ae$var$Gbd);
        b.Fc($61de1ee1cac498ae$var$Ebd);
    } else if (b.Hc($61de1ee1cac498ae$var$Ebd)) {
        b.Mc($61de1ee1cac498ae$var$Ebd);
        b.Fc($61de1ee1cac498ae$var$Gbd);
    }
}
function $61de1ee1cac498ae$var$udc(a, b, c) {
    $61de1ee1cac498ae$var$Odd(c, "Self-Loop ordering", 1);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.b, 16)), new $61de1ee1cac498ae$var$ydc), new $61de1ee1cac498ae$var$Adc), new $61de1ee1cac498ae$var$Cdc), new $61de1ee1cac498ae$var$Edc), new $61de1ee1cac498ae$var$Gdc(a));
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$ikc(a, b, c, d) {
    var e, f;
    for(e = b; e < a.c.length; e++){
        f = ($61de1ee1cac498ae$var$tCb(e, a.c.length), $61de1ee1cac498ae$var$BD(a.c[e], 11));
        if (c.Mb(f)) d.c[d.c.length] = f;
        else return e;
    }
    return a.c.length;
}
function $61de1ee1cac498ae$var$Kmc(a, b, c, d) {
    var e, f, g, h;
    a.a == null && $61de1ee1cac498ae$var$Nmc(a, b);
    g = b.b.j.c.length;
    f = c.d.p;
    h = d.d.p;
    e = h - 1;
    e < 0 && (e = g - 1);
    return f <= e ? a.a[e] - a.a[f] : a.a[g - 1] - a.a[f] + a.a[e];
}
function $61de1ee1cac498ae$var$ehd(a) {
    var b, c;
    if (!a.b) {
        a.b = $61de1ee1cac498ae$var$Qu($61de1ee1cac498ae$var$BD(a.f, 33).Ag().i);
        for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$BD(a.f, 33).Ag()); c.e != c.i.gc();){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 137);
            $61de1ee1cac498ae$var$Ekb(a.b, new $61de1ee1cac498ae$var$dhd(b));
        }
    }
    return a.b;
}
function $61de1ee1cac498ae$var$fhd(a) {
    var b, c;
    if (!a.e) {
        a.e = $61de1ee1cac498ae$var$Qu($61de1ee1cac498ae$var$Yod($61de1ee1cac498ae$var$BD(a.f, 33)).i);
        for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Yod($61de1ee1cac498ae$var$BD(a.f, 33))); c.e != c.i.gc();){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 118);
            $61de1ee1cac498ae$var$Ekb(a.e, new $61de1ee1cac498ae$var$thd(b));
        }
    }
    return a.e;
}
function $61de1ee1cac498ae$var$ahd(a) {
    var b, c;
    if (!a.a) {
        a.a = $61de1ee1cac498ae$var$Qu($61de1ee1cac498ae$var$Vod($61de1ee1cac498ae$var$BD(a.f, 33)).i);
        for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Vod($61de1ee1cac498ae$var$BD(a.f, 33))); c.e != c.i.gc();){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 33);
            $61de1ee1cac498ae$var$Ekb(a.a, new $61de1ee1cac498ae$var$hhd(a, b));
        }
    }
    return a.a;
}
function $61de1ee1cac498ae$var$dKd(b) {
    var c;
    if (!b.C && (b.D != null || b.B != null)) {
        c = $61de1ee1cac498ae$var$eKd(b);
        if (c) b.yk(c);
        else try {
            b.yk(null);
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if (!$61de1ee1cac498ae$var$JD(a, 60)) throw $61de1ee1cac498ae$var$vbb(a);
        }
    }
    return b.C;
}
function $61de1ee1cac498ae$var$GJb(a) {
    switch(a.q.g){
        case 5:
            $61de1ee1cac498ae$var$DJb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
            $61de1ee1cac498ae$var$DJb(a, $61de1ee1cac498ae$var$Rcd);
            break;
        case 4:
            $61de1ee1cac498ae$var$EJb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
            $61de1ee1cac498ae$var$EJb(a, $61de1ee1cac498ae$var$Rcd);
            break;
        default:
            $61de1ee1cac498ae$var$FJb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
            $61de1ee1cac498ae$var$FJb(a, $61de1ee1cac498ae$var$Rcd);
    }
}
function $61de1ee1cac498ae$var$PKb(a) {
    switch(a.q.g){
        case 5:
            $61de1ee1cac498ae$var$MKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            $61de1ee1cac498ae$var$MKb(a, $61de1ee1cac498ae$var$Tcd);
            break;
        case 4:
            $61de1ee1cac498ae$var$NKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            $61de1ee1cac498ae$var$NKb(a, $61de1ee1cac498ae$var$Tcd);
            break;
        default:
            $61de1ee1cac498ae$var$OKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            $61de1ee1cac498ae$var$OKb(a, $61de1ee1cac498ae$var$Tcd);
    }
}
function $61de1ee1cac498ae$var$EXb(a, b) {
    var c, d, e;
    e = new $61de1ee1cac498ae$var$d7c;
    for(d = a.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 37);
        $61de1ee1cac498ae$var$uXb(c, e.a, 0);
        e.a += c.f.a + b;
        e.b = $61de1ee1cac498ae$var$$wnd.Math.max(e.b, c.f.b);
    }
    e.b > 0 && (e.b += b);
    return e;
}
function $61de1ee1cac498ae$var$GXb(a, b) {
    var c, d, e;
    e = new $61de1ee1cac498ae$var$d7c;
    for(d = a.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 37);
        $61de1ee1cac498ae$var$uXb(c, 0, e.b);
        e.b += c.f.b + b;
        e.a = $61de1ee1cac498ae$var$$wnd.Math.max(e.a, c.f.a);
    }
    e.a > 0 && (e.a += b);
    return e;
}
function $61de1ee1cac498ae$var$d_b(a) {
    var b, c, d;
    d = $61de1ee1cac498ae$var$Ohe;
    for(c = new $61de1ee1cac498ae$var$olb(a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        $61de1ee1cac498ae$var$wNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) && (d = $61de1ee1cac498ae$var$$wnd.Math.min(d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Zsc), 19).a));
    }
    return d;
}
function $61de1ee1cac498ae$var$pHc(a, b) {
    var c, d;
    if (b.length == 0) return 0;
    c = $61de1ee1cac498ae$var$NHc(a.a, b[0], ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    c += $61de1ee1cac498ae$var$NHc(a.a, b[b.length - 1], $61de1ee1cac498ae$var$zcd);
    for(d = 0; d < b.length; d++)c += $61de1ee1cac498ae$var$qHc(a, d, b);
    return c;
}
function $61de1ee1cac498ae$var$vQc() {
    $61de1ee1cac498ae$var$hQc();
    this.c = new $61de1ee1cac498ae$var$Rkb;
    this.i = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$zsb;
    this.f = new $61de1ee1cac498ae$var$zsb;
    this.g = new $61de1ee1cac498ae$var$zsb;
    this.j = new $61de1ee1cac498ae$var$Rkb;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.k = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$aKd(a, b) {
    var c, d;
    if (a.Db >> 16 == 6) return a.Cb.ih(a, 5, $61de1ee1cac498ae$var$o5, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? a.zh() : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$Wz(a) {
    $61de1ee1cac498ae$var$Rz();
    var b = a.e;
    if (b && b.stack) {
        var c = b.stack;
        var d = b + "\n";
        c.substring(0, d.length) == d && (c = c.substring(d.length));
        return c.split("\n");
    }
    return [];
}
function $61de1ee1cac498ae$var$jeb(a) {
    var b;
    b = ($61de1ee1cac498ae$var$qeb(), $61de1ee1cac498ae$var$peb);
    return b[a >>> 28] | b[a >> 24 & 15] << 4 | b[a >> 20 & 15] << 8 | b[a >> 16 & 15] << 12 | b[a >> 12 & 15] << 16 | b[a >> 8 & 15] << 20 | b[a >> 4 & 15] << 24 | b[a & 15] << 28;
}
function $61de1ee1cac498ae$var$_jb(a) {
    var b, c, d;
    if (a.b != a.c) return;
    d = a.a.length;
    c = $61de1ee1cac498ae$var$geb($61de1ee1cac498ae$var$$wnd.Math.max(8, d)) << 1;
    if (a.b != 0) {
        b = $61de1ee1cac498ae$var$_Bb(a.a, c);
        $61de1ee1cac498ae$var$$jb(a, b, d);
        a.a = b;
        a.b = 0;
    } else $61de1ee1cac498ae$var$dCb(a.a, c);
    a.c = d;
}
function $61de1ee1cac498ae$var$DKb(a, b) {
    var c;
    c = a.b;
    return c.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c)) ? c.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? -c.rf().a - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c.We($61de1ee1cac498ae$var$s9c))) : b + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c.We($61de1ee1cac498ae$var$s9c))) : c.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? -c.rf().a : b;
}
function $61de1ee1cac498ae$var$P_b(a) {
    var b;
    if (a.b.c.length != 0 && !!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, 0), 70).a) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, 0), 70).a;
    b = $61de1ee1cac498ae$var$JZb(a);
    if (b != null) return b;
    return "" + (!a.c ? -1 : $61de1ee1cac498ae$var$Jkb(a.c.a, a, 0));
}
function $61de1ee1cac498ae$var$C0b(a) {
    var b;
    if (a.f.c.length != 0 && !!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.f, 0), 70).a) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.f, 0), 70).a;
    b = $61de1ee1cac498ae$var$JZb(a);
    if (b != null) return b;
    return "" + (!a.i ? -1 : $61de1ee1cac498ae$var$Jkb(a.i.j, a, 0));
}
function $61de1ee1cac498ae$var$Ogc(a, b) {
    var c, d;
    if (b < 0 || b >= a.gc()) return null;
    for(c = b; c < a.gc(); ++c){
        d = $61de1ee1cac498ae$var$BD(a.Xb(c), 128);
        if (c == a.gc() - 1 || !d.o) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(c), d);
    }
    return null;
}
function $61de1ee1cac498ae$var$uoc(a, b, c) {
    var d, e, f, g, h;
    f = a.c;
    h = c ? b : a;
    d = c ? a : b;
    for(e = h.p + 1; e < d.p; ++e){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(f.a, e), 10);
        if (!(g.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$d0b) || $61de1ee1cac498ae$var$voc(g))) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$u$c(a) {
    var b, c, d, e, f;
    f = 0;
    e = $61de1ee1cac498ae$var$Qje;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$olb(a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 187);
        f += b.r + (d > 0 ? a.c : 0);
        e = $61de1ee1cac498ae$var$$wnd.Math.max(e, b.d);
        ++d;
    }
    a.e = f;
    a.b = e;
}
function $61de1ee1cac498ae$var$shd(a) {
    var b, c;
    if (!a.b) {
        a.b = $61de1ee1cac498ae$var$Qu($61de1ee1cac498ae$var$BD(a.f, 118).Ag().i);
        for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$BD(a.f, 118).Ag()); c.e != c.i.gc();){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 137);
            $61de1ee1cac498ae$var$Ekb(a.b, new $61de1ee1cac498ae$var$dhd(b));
        }
    }
    return a.b;
}
function $61de1ee1cac498ae$var$Ctd(a, b) {
    var c, d, e;
    if (b.dc()) return $61de1ee1cac498ae$var$LCd(), $61de1ee1cac498ae$var$LCd(), $61de1ee1cac498ae$var$KCd;
    else {
        c = new $61de1ee1cac498ae$var$zyd(a, b.gc());
        for(e = new $61de1ee1cac498ae$var$Fyd(a); e.e != e.i.gc();){
            d = $61de1ee1cac498ae$var$Dyd(e);
            b.Hc(d) && $61de1ee1cac498ae$var$wtd(c, d);
        }
        return c;
    }
}
function $61de1ee1cac498ae$var$bkd(a, b, c, d) {
    if (b == 0) return d ? (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), a.o) : (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$FAd(a.o));
    return $61de1ee1cac498ae$var$fid(a, b, c, d);
}
function $61de1ee1cac498ae$var$Tnd(a) {
    var b, c;
    if (a.rb) for(b = 0, c = a.rb.i; b < c; ++b)$61de1ee1cac498ae$var$Cmd($61de1ee1cac498ae$var$qud(a.rb, b));
    if (a.vb) for(b = 0, c = a.vb.i; b < c; ++b)$61de1ee1cac498ae$var$Cmd($61de1ee1cac498ae$var$qud(a.vb, b));
    $61de1ee1cac498ae$var$u1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a);
    a.Bb |= 1;
}
function $61de1ee1cac498ae$var$_nd(a, b, c, d, e, f, g, h, i, j, k, l, m, n) {
    $61de1ee1cac498ae$var$aod(a, b, d, null, e, f, g, h, i, j, m, true, n);
    $61de1ee1cac498ae$var$CUd(a, k);
    $61de1ee1cac498ae$var$JD(a.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(a.Cb, 88)), 2);
    !!c && $61de1ee1cac498ae$var$DUd(a, c);
    $61de1ee1cac498ae$var$EUd(a, l);
    return a;
}
function $61de1ee1cac498ae$var$jZd(b) {
    var c, d;
    if (b == null) return null;
    d = 0;
    try {
        d = $61de1ee1cac498ae$var$Icb(b, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe) & $61de1ee1cac498ae$var$aje;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 127)) {
            c = $61de1ee1cac498ae$var$rfb(b);
            d = c[0];
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    return $61de1ee1cac498ae$var$bdb(d);
}
function $61de1ee1cac498ae$var$kZd(b) {
    var c, d;
    if (b == null) return null;
    d = 0;
    try {
        d = $61de1ee1cac498ae$var$Icb(b, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe) & $61de1ee1cac498ae$var$aje;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 127)) {
            c = $61de1ee1cac498ae$var$rfb(b);
            d = c[0];
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    return $61de1ee1cac498ae$var$bdb(d);
}
function $61de1ee1cac498ae$var$bD(a, b) {
    var c, d, e;
    e = a.h - b.h;
    if (e < 0) return false;
    c = a.l - b.l;
    d = a.m - b.m + (c >> 22);
    e += d >> 22;
    if (e < 0) return false;
    a.l = c & $61de1ee1cac498ae$var$Eje;
    a.m = d & $61de1ee1cac498ae$var$Eje;
    a.h = e & $61de1ee1cac498ae$var$Fje;
    return true;
}
function $61de1ee1cac498ae$var$Fwb(a, b, c, d, e, f, g) {
    var h, i;
    if (b.Ae() && (i = a.a.ue(c, d), i < 0 || !e && i == 0)) return false;
    if (b.Be() && (h = a.a.ue(c, f), h > 0 || !g && h == 0)) return false;
    return true;
}
function $61de1ee1cac498ae$var$Vcc(a, b) {
    $61de1ee1cac498ae$var$Occ();
    var c;
    c = a.j.g - b.j.g;
    if (c != 0) return 0;
    switch(a.j.g){
        case 2:
            return $61de1ee1cac498ae$var$Ycc(b, $61de1ee1cac498ae$var$Ncc) - $61de1ee1cac498ae$var$Ycc(a, $61de1ee1cac498ae$var$Ncc);
        case 4:
            return $61de1ee1cac498ae$var$Ycc(a, $61de1ee1cac498ae$var$Mcc) - $61de1ee1cac498ae$var$Ycc(b, $61de1ee1cac498ae$var$Mcc);
    }
    return 0;
}
function $61de1ee1cac498ae$var$Tqc(a) {
    switch(a.g){
        case 0:
            return $61de1ee1cac498ae$var$Mqc;
        case 1:
            return $61de1ee1cac498ae$var$Nqc;
        case 2:
            return $61de1ee1cac498ae$var$Oqc;
        case 3:
            return $61de1ee1cac498ae$var$Pqc;
        case 4:
            return $61de1ee1cac498ae$var$Qqc;
        case 5:
            return $61de1ee1cac498ae$var$Rqc;
        default:
            return null;
    }
}
function $61de1ee1cac498ae$var$End(a, b, c) {
    var d, e;
    d = (e = new $61de1ee1cac498ae$var$rUd, $61de1ee1cac498ae$var$yId(e, b), $61de1ee1cac498ae$var$pnd(e, c), $61de1ee1cac498ae$var$wtd((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, a, 12, 10)), a.c), e), e);
    $61de1ee1cac498ae$var$AId(d, 0);
    $61de1ee1cac498ae$var$DId(d, 1);
    $61de1ee1cac498ae$var$CId(d, true);
    $61de1ee1cac498ae$var$BId(d, true);
    return d;
}
function $61de1ee1cac498ae$var$tud(a, b) {
    var c, d;
    if (b >= a.i) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$$zd(b, a.i));
    ++a.j;
    c = a.g[b];
    d = a.i - b - 1;
    d > 0 && $61de1ee1cac498ae$var$$fb(a.g, b + 1, a.g, b, d);
    $61de1ee1cac498ae$var$NC(a.g, --a.i, null);
    a.fi(b, c);
    a.ci();
    return c;
}
function $61de1ee1cac498ae$var$UId(a, b) {
    var c, d;
    if (a.Db >> 16 == 17) return a.Cb.ih(a, 21, $61de1ee1cac498ae$var$c5, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? a.zh() : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$iDb(a) {
    var b, c, d, e;
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(a.c, a.a);
    for(e = new $61de1ee1cac498ae$var$olb(a.c); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$mlb(e);
        for(c = new $61de1ee1cac498ae$var$olb(a.b); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 679);
            b.Ke(d);
        }
    }
}
function $61de1ee1cac498ae$var$pXb(a) {
    var b, c, d, e;
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(a.c, a.a);
    for(e = new $61de1ee1cac498ae$var$olb(a.c); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$mlb(e);
        for(c = new $61de1ee1cac498ae$var$olb(a.b); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 369);
            b.Ke(d);
        }
    }
}
function $61de1ee1cac498ae$var$AGb(a) {
    var b, c, d, e, f;
    e = $61de1ee1cac498ae$var$Ohe;
    f = null;
    for(d = new $61de1ee1cac498ae$var$olb(a.d); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 213);
        if (c.d.j ^ c.e.j) {
            b = c.e.e - c.d.e - c.a;
            if (b < e) {
                e = b;
                f = c;
            }
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$OSb() {
    $61de1ee1cac498ae$var$OSb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$MSb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Mme, ($61de1ee1cac498ae$var$Bcb(), false));
    $61de1ee1cac498ae$var$ISb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Nme, 100);
    $61de1ee1cac498ae$var$KSb = ($61de1ee1cac498ae$var$yTb(), $61de1ee1cac498ae$var$wTb);
    $61de1ee1cac498ae$var$JSb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ome, $61de1ee1cac498ae$var$KSb);
    $61de1ee1cac498ae$var$LSb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Pme, $61de1ee1cac498ae$var$qme);
    $61de1ee1cac498ae$var$NSb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Qme, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Ohe));
}
function $61de1ee1cac498ae$var$ric(a, b, c) {
    var d, e, f, g, h, i, j, k;
    j = 0;
    for(e = a.a[b], f = 0, g = e.length; f < g; ++f){
        d = e[f];
        k = $61de1ee1cac498ae$var$CHc(d, c);
        for(i = k.Kc(); i.Ob();){
            h = $61de1ee1cac498ae$var$BD(i.Pb(), 11);
            $61de1ee1cac498ae$var$Rhb(a.f, h, $61de1ee1cac498ae$var$meb(j++));
        }
    }
}
function $61de1ee1cac498ae$var$uqd(a, b, c) {
    var d, e, f, g;
    if (c) {
        e = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(e);
        for(g = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 19);
            $61de1ee1cac498ae$var$Rc(a, b, $61de1ee1cac498ae$var$Vpd($61de1ee1cac498ae$var$tB(c, f.a)));
        }
    }
}
function $61de1ee1cac498ae$var$vqd(a, b, c) {
    var d, e, f, g;
    if (c) {
        e = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(e);
        for(g = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 19);
            $61de1ee1cac498ae$var$Rc(a, b, $61de1ee1cac498ae$var$Vpd($61de1ee1cac498ae$var$tB(c, f.a)));
        }
    }
}
function $61de1ee1cac498ae$var$Bkc(a) {
    $61de1ee1cac498ae$var$gkc();
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ee($61de1ee1cac498ae$var$Ec(a.k), $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$F1, $61de1ee1cac498ae$var$bne, 61, 2, 0, 1)), 122);
    $61de1ee1cac498ae$var$Klb(b, 0, b.length, null);
    if (b[0] == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) && b[1] == $61de1ee1cac498ae$var$Tcd) {
        $61de1ee1cac498ae$var$NC(b, 0, $61de1ee1cac498ae$var$Tcd);
        $61de1ee1cac498ae$var$NC(b, 1, $61de1ee1cac498ae$var$Acd);
    }
    return b;
}
function $61de1ee1cac498ae$var$JHc(a, b, c) {
    var d, e, f;
    e = $61de1ee1cac498ae$var$HHc(a, b, c);
    f = $61de1ee1cac498ae$var$KHc(a, e);
    $61de1ee1cac498ae$var$yHc(a.b);
    $61de1ee1cac498ae$var$cIc(a, b, c);
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(e, new $61de1ee1cac498ae$var$hIc(a));
    d = $61de1ee1cac498ae$var$KHc(a, e);
    $61de1ee1cac498ae$var$yHc(a.b);
    $61de1ee1cac498ae$var$cIc(a, c, b);
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(f), $61de1ee1cac498ae$var$meb(d));
}
function $61de1ee1cac498ae$var$jJc() {
    $61de1ee1cac498ae$var$jJc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$gJc = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$h8b));
    $61de1ee1cac498ae$var$hJc = new $61de1ee1cac498ae$var$Msd("linearSegments.inputPrio", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$iJc = new $61de1ee1cac498ae$var$Msd("linearSegments.outputPrio", $61de1ee1cac498ae$var$meb(0));
}
function $61de1ee1cac498ae$var$yRc() {
    $61de1ee1cac498ae$var$yRc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$uRc = new $61de1ee1cac498ae$var$ARc("P1_TREEIFICATION", 0);
    $61de1ee1cac498ae$var$vRc = new $61de1ee1cac498ae$var$ARc("P2_NODE_ORDERING", 1);
    $61de1ee1cac498ae$var$wRc = new $61de1ee1cac498ae$var$ARc("P3_NODE_PLACEMENT", 2);
    $61de1ee1cac498ae$var$xRc = new $61de1ee1cac498ae$var$ARc("P4_EDGE_ROUTING", 3);
}
function $61de1ee1cac498ae$var$ZWc() {
    $61de1ee1cac498ae$var$ZWc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$UWc = ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$C9c);
    $61de1ee1cac498ae$var$XWc = $61de1ee1cac498ae$var$T9c;
    $61de1ee1cac498ae$var$NWc = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$OWc = $61de1ee1cac498ae$var$_8c;
    $61de1ee1cac498ae$var$PWc = $61de1ee1cac498ae$var$b9c;
    $61de1ee1cac498ae$var$MWc = $61de1ee1cac498ae$var$W8c;
    $61de1ee1cac498ae$var$QWc = $61de1ee1cac498ae$var$e9c;
    $61de1ee1cac498ae$var$TWc = $61de1ee1cac498ae$var$x9c;
    $61de1ee1cac498ae$var$KWc = ($61de1ee1cac498ae$var$HWc(), $61de1ee1cac498ae$var$wWc);
    $61de1ee1cac498ae$var$LWc = $61de1ee1cac498ae$var$xWc;
    $61de1ee1cac498ae$var$RWc = $61de1ee1cac498ae$var$zWc;
    $61de1ee1cac498ae$var$SWc = $61de1ee1cac498ae$var$BWc;
    $61de1ee1cac498ae$var$VWc = $61de1ee1cac498ae$var$CWc;
    $61de1ee1cac498ae$var$WWc = $61de1ee1cac498ae$var$DWc;
    $61de1ee1cac498ae$var$YWc = $61de1ee1cac498ae$var$FWc;
}
function $61de1ee1cac498ae$var$rbd() {
    $61de1ee1cac498ae$var$rbd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qbd = new $61de1ee1cac498ae$var$tbd("UNKNOWN", 0);
    $61de1ee1cac498ae$var$nbd = new $61de1ee1cac498ae$var$tbd("ABOVE", 1);
    $61de1ee1cac498ae$var$obd = new $61de1ee1cac498ae$var$tbd("BELOW", 2);
    $61de1ee1cac498ae$var$pbd = new $61de1ee1cac498ae$var$tbd("INLINE", 3);
    new $61de1ee1cac498ae$var$Msd("org.eclipse.elk.labelSide", $61de1ee1cac498ae$var$qbd);
}
function $61de1ee1cac498ae$var$rud(a, b) {
    var c;
    if (a.ni() && b != null) for(c = 0; c < a.i; ++c){
        if ($61de1ee1cac498ae$var$pb(b, a.g[c])) return c;
    }
    else for(c = 0; c < a.i; ++c){
        if ($61de1ee1cac498ae$var$PD(a.g[c]) === $61de1ee1cac498ae$var$PD(b)) return c;
    }
    return -1;
}
function $61de1ee1cac498ae$var$DZb(a, b, c) {
    var d, e;
    if (b.c == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc) && c.c == $61de1ee1cac498ae$var$HAc) return -1;
    else if (b.c == $61de1ee1cac498ae$var$HAc && c.c == $61de1ee1cac498ae$var$IAc) return 1;
    d = $61de1ee1cac498ae$var$HZb(b.a, a.a);
    e = $61de1ee1cac498ae$var$HZb(c.a, a.a);
    return b.c == $61de1ee1cac498ae$var$IAc ? e - d : d - e;
}
function $61de1ee1cac498ae$var$Z_b(a, b, c) {
    if (!!c && (b < 0 || b > c.a.c.length)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("index must be >= 0 and <= layer node count"));
    !!a.c && $61de1ee1cac498ae$var$Lkb(a.c.a, a);
    a.c = c;
    !!c && $61de1ee1cac498ae$var$Dkb(c.a, b, a);
}
function $61de1ee1cac498ae$var$p7b(a, b) {
    var c, d, e;
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
        e = $61de1ee1cac498ae$var$BD(b.Kb(c), 10);
        return new $61de1ee1cac498ae$var$cc($61de1ee1cac498ae$var$Qb(e.n.b + e.o.b / 2));
    }
    return $61de1ee1cac498ae$var$wb(), $61de1ee1cac498ae$var$wb(), $61de1ee1cac498ae$var$vb;
}
function $61de1ee1cac498ae$var$rMc(a, b) {
    this.c = new $61de1ee1cac498ae$var$Lqb;
    this.a = a;
    this.b = b;
    this.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$yxc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$_qc(), $61de1ee1cac498ae$var$Zqc)) ? this.e = new $61de1ee1cac498ae$var$bNc : this.e = new $61de1ee1cac498ae$var$WMc;
}
function $61de1ee1cac498ae$var$$dd(a, b) {
    var c, d, e, f;
    f = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 33);
        f += $61de1ee1cac498ae$var$$wnd.Math.pow(c.g * c.f - b, 2);
    }
    e = $61de1ee1cac498ae$var$$wnd.Math.sqrt(f / (a.c.length - 1));
    return e;
}
function $61de1ee1cac498ae$var$bgd(a, b) {
    var c, d;
    d = null;
    if (a.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$O9c))) {
        c = $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$O9c), 94);
        c.Xe(b) && (d = c.We(b));
    }
    d == null && !!a.yf() && (d = a.yf().We(b));
    d == null && (d = $61de1ee1cac498ae$var$Ksd(b));
    return d;
}
function $61de1ee1cac498ae$var$Vt(b, c) {
    var d, e;
    d = b.Zc(c);
    try {
        e = d.Pb();
        d.Qb();
        return e;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 109)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb("Can't remove element " + c));
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$qA(a, b) {
    var c, d, e;
    d = new $61de1ee1cac498ae$var$eB;
    e = new $61de1ee1cac498ae$var$fB(d.q.getFullYear() - $61de1ee1cac498ae$var$nje, d.q.getMonth(), d.q.getDate());
    c = $61de1ee1cac498ae$var$pA(a, b, e);
    if (c == 0 || c < b.length) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb(b));
    return e;
}
function $61de1ee1cac498ae$var$_tb(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$uCb(b);
    $61de1ee1cac498ae$var$lCb(b != a);
    e = a.b.c.length;
    for(d = b.Kc(); d.Ob();){
        c = d.Pb();
        $61de1ee1cac498ae$var$Ekb(a.b, $61de1ee1cac498ae$var$uCb(c));
    }
    if (e != a.b.c.length) {
        $61de1ee1cac498ae$var$aub(a, 0);
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$bTb() {
    $61de1ee1cac498ae$var$bTb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$VSb = ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$O8c);
    new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$B8c, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$YSb = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$ZSb = $61de1ee1cac498ae$var$_8c;
    $61de1ee1cac498ae$var$$Sb = $61de1ee1cac498ae$var$b9c;
    $61de1ee1cac498ae$var$XSb = $61de1ee1cac498ae$var$W8c;
    $61de1ee1cac498ae$var$_Sb = $61de1ee1cac498ae$var$e9c;
    $61de1ee1cac498ae$var$aTb = $61de1ee1cac498ae$var$x9c;
    $61de1ee1cac498ae$var$USb = ($61de1ee1cac498ae$var$OSb(), $61de1ee1cac498ae$var$MSb);
    $61de1ee1cac498ae$var$SSb = $61de1ee1cac498ae$var$JSb;
    $61de1ee1cac498ae$var$TSb = $61de1ee1cac498ae$var$LSb;
    $61de1ee1cac498ae$var$WSb = $61de1ee1cac498ae$var$NSb;
    $61de1ee1cac498ae$var$RSb = $61de1ee1cac498ae$var$ISb;
}
function $61de1ee1cac498ae$var$MZb(a, b) {
    if (b == a.c) return a.d;
    else if (b == a.d) return a.c;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("'port' must be either the source port or target port of the edge."));
}
function $61de1ee1cac498ae$var$C3b(a, b, c) {
    var d, e;
    e = a.o;
    d = a.d;
    switch(b.g){
        case 1:
            return -d.d - c;
        case 3:
            return e.b + d.a + c;
        case 2:
            return e.a + d.c + c;
        case 4:
            return -d.b - c;
        default:
            return 0;
    }
}
function $61de1ee1cac498ae$var$H6b(a, b, c, d) {
    var e, f, g, h;
    $61de1ee1cac498ae$var$$_b(b, $61de1ee1cac498ae$var$BD(d.Xb(0), 29));
    h = d.bd(1, d.gc());
    for(f = $61de1ee1cac498ae$var$BD(c.Kb(b), 20).Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 17);
        g = e.c.i == b ? e.d.i : e.c.i;
        $61de1ee1cac498ae$var$H6b(a, g, c, h);
    }
}
function $61de1ee1cac498ae$var$Xec(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Lqb;
    if ($61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ttc))) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ttc), 83);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.j, 16)), new $61de1ee1cac498ae$var$Zec), new $61de1ee1cac498ae$var$_ec(b));
    $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$ttc, b);
    return b;
}
function $61de1ee1cac498ae$var$cmd(a, b) {
    var c, d;
    if (a.Db >> 16 == 6) return a.Cb.ih(a, 6, $61de1ee1cac498ae$var$B2, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Lhd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$Eod(a, b) {
    var c, d;
    if (a.Db >> 16 == 7) return a.Cb.ih(a, 1, $61de1ee1cac498ae$var$C2, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Nhd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$lpd(a, b) {
    var c, d;
    if (a.Db >> 16 == 9) return a.Cb.ih(a, 9, $61de1ee1cac498ae$var$E2, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Phd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$mQd(a, b) {
    var c, d;
    if (a.Db >> 16 == 5) return a.Cb.ih(a, 9, $61de1ee1cac498ae$var$h5, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$KHd(a, b) {
    var c, d;
    if (a.Db >> 16 == 3) return a.Cb.ih(a, 0, $61de1ee1cac498ae$var$k5, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$Snd(a, b) {
    var c, d;
    if (a.Db >> 16 == 7) return a.Cb.ih(a, 6, $61de1ee1cac498ae$var$o5, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$ird() {
    this.a = new $61de1ee1cac498ae$var$bqd;
    this.g = new $61de1ee1cac498ae$var$wo;
    this.j = new $61de1ee1cac498ae$var$wo;
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.d = new $61de1ee1cac498ae$var$wo;
    this.i = new $61de1ee1cac498ae$var$wo;
    this.k = new $61de1ee1cac498ae$var$Lqb;
    this.c = new $61de1ee1cac498ae$var$Lqb;
    this.e = new $61de1ee1cac498ae$var$Lqb;
    this.f = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$MCd(a, b, c) {
    var d, e, f;
    c < 0 && (c = 0);
    f = a.i;
    for(e = c; e < f; e++){
        d = $61de1ee1cac498ae$var$qud(a, e);
        if (b == null) {
            if (d == null) return e;
        } else if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(d) || $61de1ee1cac498ae$var$pb(b, d)) return e;
    }
    return -1;
}
function $61de1ee1cac498ae$var$b1d(a, b) {
    var c, d;
    c = b.Hh(a.a);
    if (!c) return null;
    else {
        d = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$Awe));
        return $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Bwe, d) ? $61de1ee1cac498ae$var$u1d(a, $61de1ee1cac498ae$var$bKd(b.Hj())) : d;
    }
}
function $61de1ee1cac498ae$var$p6d(a, b) {
    var c, d;
    if (b) {
        if (b == a) return true;
        c = 0;
        for(d = $61de1ee1cac498ae$var$BD(b, 49).eh(); !!d && d != b; d = d.eh()){
            if (++c > $61de1ee1cac498ae$var$Wje) return $61de1ee1cac498ae$var$p6d(a, d);
            if (d == a) return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$HKb(a) {
    $61de1ee1cac498ae$var$CKb();
    switch(a.q.g){
        case 5:
            $61de1ee1cac498ae$var$EKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
            $61de1ee1cac498ae$var$EKb(a, $61de1ee1cac498ae$var$Rcd);
            break;
        case 4:
            $61de1ee1cac498ae$var$FKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
            $61de1ee1cac498ae$var$FKb(a, $61de1ee1cac498ae$var$Rcd);
            break;
        default:
            $61de1ee1cac498ae$var$GKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
            $61de1ee1cac498ae$var$GKb(a, $61de1ee1cac498ae$var$Rcd);
    }
}
function $61de1ee1cac498ae$var$LKb(a) {
    $61de1ee1cac498ae$var$CKb();
    switch(a.q.g){
        case 5:
            $61de1ee1cac498ae$var$IKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            $61de1ee1cac498ae$var$IKb(a, $61de1ee1cac498ae$var$Tcd);
            break;
        case 4:
            $61de1ee1cac498ae$var$JKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            $61de1ee1cac498ae$var$JKb(a, $61de1ee1cac498ae$var$Tcd);
            break;
        default:
            $61de1ee1cac498ae$var$KKb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            $61de1ee1cac498ae$var$KKb(a, $61de1ee1cac498ae$var$Tcd);
    }
}
function $61de1ee1cac498ae$var$XQb(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$pSb)), 19);
    if (b) {
        c = b.a;
        c == 0 ? $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$GSb), new $61de1ee1cac498ae$var$Gub) : $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$GSb), new $61de1ee1cac498ae$var$Hub(c));
    } else $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$GSb), new $61de1ee1cac498ae$var$Hub(1));
}
function $61de1ee1cac498ae$var$V$b(a, b) {
    var c;
    c = a.i;
    switch(b.g){
        case 1:
            return -(a.n.b + a.o.b);
        case 2:
            return a.n.a - c.o.a;
        case 3:
            return a.n.b - c.o.b;
        case 4:
            return -(a.n.a + a.o.a);
    }
    return 0;
}
function $61de1ee1cac498ae$var$hbc(a, b) {
    switch(a.g){
        case 0:
            return b == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc) ? $61de1ee1cac498ae$var$dbc : $61de1ee1cac498ae$var$ebc;
        case 1:
            return b == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc) ? $61de1ee1cac498ae$var$dbc : $61de1ee1cac498ae$var$cbc;
        case 2:
            return b == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc) ? $61de1ee1cac498ae$var$cbc : $61de1ee1cac498ae$var$ebc;
        default:
            return $61de1ee1cac498ae$var$cbc;
    }
}
function $61de1ee1cac498ae$var$v$c(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$Lkb(a.a, b);
    a.e -= b.r + (a.a.c.length == 0 ? 0 : a.c);
    e = $61de1ee1cac498ae$var$ere;
    for(d = new $61de1ee1cac498ae$var$olb(a.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 187);
        e = $61de1ee1cac498ae$var$$wnd.Math.max(e, c.d);
    }
    a.b = e;
}
function $61de1ee1cac498ae$var$Lld(a, b) {
    var c, d;
    if (a.Db >> 16 == 3) return a.Cb.ih(a, 12, $61de1ee1cac498ae$var$E2, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Khd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$Uod(a, b) {
    var c, d;
    if (a.Db >> 16 == 11) return a.Cb.ih(a, 10, $61de1ee1cac498ae$var$E2, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Ohd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$PSd(a, b) {
    var c, d;
    if (a.Db >> 16 == 10) return a.Cb.ih(a, 11, $61de1ee1cac498ae$var$c5, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$qUd(a, b) {
    var c, d;
    if (a.Db >> 16 == 10) return a.Cb.ih(a, 12, $61de1ee1cac498ae$var$n5, b);
    return d = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !c ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd) : c), a.Db >> 16), 18)), a.Cb.ih(a, d.n, d.f, b);
}
function $61de1ee1cac498ae$var$wId(a) {
    var b;
    if ((a.Bb & 1) == 0 && !!a.r && a.r.kh()) {
        b = $61de1ee1cac498ae$var$BD(a.r, 49);
        a.r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$xid(a, b), 138);
        a.r != b && (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 9, 8, b, a.r));
    }
    return a.r;
}
function $61de1ee1cac498ae$var$yHb(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        $61de1ee1cac498ae$var$BHb(a, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$dHb), b, c),
        $61de1ee1cac498ae$var$BHb(a, $61de1ee1cac498ae$var$eHb, b, c),
        $61de1ee1cac498ae$var$BHb(a, $61de1ee1cac498ae$var$fHb, b, c)
    ]);
    if (a.f) {
        d[0] = $61de1ee1cac498ae$var$$wnd.Math.max(d[0], d[2]);
        d[2] = d[0];
    }
    return d;
}
function $61de1ee1cac498ae$var$O9b(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$V9b(a, b);
    if (e.c.length == 0) return;
    $61de1ee1cac498ae$var$Okb(e, new $61de1ee1cac498ae$var$pac);
    c = e.c.length;
    for(d = 0; d < c; d++)$61de1ee1cac498ae$var$K9b(a, ($61de1ee1cac498ae$var$tCb(d, e.c.length), $61de1ee1cac498ae$var$BD(e.c[d], 286)), $61de1ee1cac498ae$var$R9b(a, e, d));
}
function $61de1ee1cac498ae$var$qkc(a) {
    var b, c, d, e;
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.a, ($61de1ee1cac498ae$var$Xjc(), $61de1ee1cac498ae$var$Sjc)), 15).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 101);
        for(c = $61de1ee1cac498ae$var$Ec(d.k).Kc(); c.Ob();){
            b = $61de1ee1cac498ae$var$BD(c.Pb(), 61);
            $61de1ee1cac498ae$var$kkc(a, d, b, ($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$Dkc), 1);
        }
    }
}
function $61de1ee1cac498ae$var$voc(a) {
    var b, c;
    if (a.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
        if (!$61de1ee1cac498ae$var$OZb(b) && a.c == $61de1ee1cac498ae$var$LZb(b, a).c) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$JNc(a) {
    var b, c;
    if (a.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
        if (!$61de1ee1cac498ae$var$OZb(b) && b.c.i.c == b.d.i.c) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$HUc(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Odd(b, "Dull edge routing", 1);
    for(f = $61de1ee1cac498ae$var$Jsb(a.b, 0); f.b != f.d.c;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 86);
        for(d = $61de1ee1cac498ae$var$Jsb(e.d, 0); d.b != d.d.c;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 188);
            $61de1ee1cac498ae$var$Osb(c.a);
        }
    }
}
function $61de1ee1cac498ae$var$xqd(a, b) {
    var c, d, e, f, g;
    if (b) {
        e = b.a.length;
        c = new $61de1ee1cac498ae$var$Yge(e);
        for(g = (c.b - c.a) * c.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(c); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 19);
            d = $61de1ee1cac498ae$var$Zpd(b, f.a);
            !!d && $61de1ee1cac498ae$var$ard(a, d);
        }
    }
}
function $61de1ee1cac498ae$var$DZd() {
    $61de1ee1cac498ae$var$tZd();
    var a, b;
    $61de1ee1cac498ae$var$xZd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd));
    $61de1ee1cac498ae$var$wZd($61de1ee1cac498ae$var$MFd);
    $61de1ee1cac498ae$var$Tnd($61de1ee1cac498ae$var$MFd);
    $61de1ee1cac498ae$var$FQd = ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd);
    for(b = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$rZd); b.a < b.c.c.length;){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(b), 241);
        $61de1ee1cac498ae$var$QQd(a, $61de1ee1cac498ae$var$YFd, null);
    }
    return true;
}
function $61de1ee1cac498ae$var$eD(a, b) {
    var c, d, e, f, g, h, i, j;
    i = a.h >> 19;
    j = b.h >> 19;
    if (i != j) return j - i;
    e = a.h;
    h = b.h;
    if (e != h) return e - h;
    d = a.m;
    g = b.m;
    if (d != g) return d - g;
    c = a.l;
    f = b.l;
    return c - f;
}
function $61de1ee1cac498ae$var$fFb() {
    $61de1ee1cac498ae$var$fFb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$eFb = ($61de1ee1cac498ae$var$rFb(), $61de1ee1cac498ae$var$oFb);
    $61de1ee1cac498ae$var$dFb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Yke, $61de1ee1cac498ae$var$eFb);
    $61de1ee1cac498ae$var$cFb = ($61de1ee1cac498ae$var$UEb(), $61de1ee1cac498ae$var$TEb);
    $61de1ee1cac498ae$var$bFb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Zke, $61de1ee1cac498ae$var$cFb);
    $61de1ee1cac498ae$var$aFb = ($61de1ee1cac498ae$var$MEb(), $61de1ee1cac498ae$var$LEb);
    $61de1ee1cac498ae$var$_Eb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$$ke, $61de1ee1cac498ae$var$aFb);
    $61de1ee1cac498ae$var$$Eb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$_ke, ($61de1ee1cac498ae$var$Bcb(), true));
}
function $61de1ee1cac498ae$var$cfc(a, b, c) {
    var d, e;
    d = b * c;
    if ($61de1ee1cac498ae$var$JD(a.g, 145)) {
        e = $61de1ee1cac498ae$var$ugc(a);
        if (e.f.d) e.f.a || (a.d.a += d + $61de1ee1cac498ae$var$ple);
        else {
            a.d.d -= d + $61de1ee1cac498ae$var$ple;
            a.d.a += d + $61de1ee1cac498ae$var$ple;
        }
    } else if ($61de1ee1cac498ae$var$JD(a.g, 10)) {
        a.d.d -= d;
        a.d.a += 2 * d;
    }
}
function $61de1ee1cac498ae$var$vmc(a, b, c) {
    var d, e, f, g, h;
    e = a[c.g];
    for(h = new $61de1ee1cac498ae$var$olb(b.d); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 101);
        f = g.i;
        if (!!f && f.i == c) {
            d = g.d[c.g];
            e[d] = $61de1ee1cac498ae$var$$wnd.Math.max(e[d], f.j.b);
        }
    }
}
function $61de1ee1cac498ae$var$AZc(a, b) {
    var c, d, e, f, g;
    d = 0;
    e = 0;
    c = 0;
    for(g = new $61de1ee1cac498ae$var$olb(b.d); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 443);
        $61de1ee1cac498ae$var$a$c(f);
        d = $61de1ee1cac498ae$var$$wnd.Math.max(d, f.b);
        e += f.d + (c > 0 ? a.g : 0);
        ++c;
    }
    b.b = d;
    b.e = e;
}
function $61de1ee1cac498ae$var$to(a) {
    var b, c, d;
    d = a.b;
    if ($61de1ee1cac498ae$var$Lp(a.i, d.length)) {
        c = d.length * 2;
        a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$GF, $61de1ee1cac498ae$var$Gie, 317, c, 0, 1);
        a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$GF, $61de1ee1cac498ae$var$Gie, 317, c, 0, 1);
        a.f = c - 1;
        a.i = 0;
        for(b = a.a; b; b = b.c)$61de1ee1cac498ae$var$po(a, b, b);
        ++a.g;
    }
}
function $61de1ee1cac498ae$var$cNb(a, b, c, d) {
    var e, f, g, h;
    for(e = 0; e < b.o; e++){
        f = e - b.j + c;
        for(g = 0; g < b.p; g++){
            h = g - b.k + d;
            $61de1ee1cac498ae$var$YMb(b, e, g) ? $61de1ee1cac498ae$var$jNb(a, f, h) || $61de1ee1cac498ae$var$lNb(a, f, h) : $61de1ee1cac498ae$var$$Mb(b, e, g) && ($61de1ee1cac498ae$var$hNb(a, f, h) || $61de1ee1cac498ae$var$mNb(a, f, h));
        }
    }
}
function $61de1ee1cac498ae$var$Ooc(a, b, c) {
    var d;
    d = b.c.i;
    if (d.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Vsc), 11));
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Wsc, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Wsc), 11));
    } else {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), b.c);
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Wsc, c.d);
    }
}
function $61de1ee1cac498ae$var$l6c(a, b, c) {
    $61de1ee1cac498ae$var$i6c();
    var d, e, f, g, h, i;
    g = b / 2;
    f = c / 2;
    d = $61de1ee1cac498ae$var$$wnd.Math.abs(a.a);
    e = $61de1ee1cac498ae$var$$wnd.Math.abs(a.b);
    h = 1;
    i = 1;
    d > g && (h = g / d);
    e > f && (i = f / e);
    $61de1ee1cac498ae$var$Y6c(a, $61de1ee1cac498ae$var$$wnd.Math.min(h, i));
    return a;
}
function $61de1ee1cac498ae$var$ond() {
    $61de1ee1cac498ae$var$Smd();
    var b, c;
    try {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$yte), 2014);
        if (c) return c;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 102)) {
            b = a;
            $61de1ee1cac498ae$var$uvd(($61de1ee1cac498ae$var$h0d(), b));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    return new $61de1ee1cac498ae$var$knd;
}
function $61de1ee1cac498ae$var$Y9d() {
    $61de1ee1cac498ae$var$A9d();
    var b, c;
    try {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$Ewe), 2024);
        if (c) return c;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 102)) {
            b = a;
            $61de1ee1cac498ae$var$uvd(($61de1ee1cac498ae$var$h0d(), b));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    return new $61de1ee1cac498ae$var$U9d;
}
function $61de1ee1cac498ae$var$qZd() {
    $61de1ee1cac498ae$var$Smd();
    var b, c;
    try {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$_ve), 1941);
        if (c) return c;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 102)) {
            b = a;
            $61de1ee1cac498ae$var$uvd(($61de1ee1cac498ae$var$h0d(), b));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    return new $61de1ee1cac498ae$var$mZd;
}
function $61de1ee1cac498ae$var$HQd(a, b, c) {
    var d, e;
    e = a.e;
    a.e = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 4, e, b);
        !c ? c = d : c.Ei(d);
    }
    e != b && (b ? c = $61de1ee1cac498ae$var$QQd(a, $61de1ee1cac498ae$var$MQd(a, b), c) : c = $61de1ee1cac498ae$var$QQd(a, a.a, c));
    return c;
}
function $61de1ee1cac498ae$var$nB() {
    $61de1ee1cac498ae$var$eB.call(this);
    this.e = -1;
    this.a = false;
    this.p = $61de1ee1cac498ae$var$Rie;
    this.k = -1;
    this.c = -1;
    this.b = -1;
    this.g = false;
    this.f = -1;
    this.j = -1;
    this.n = -1;
    this.i = -1;
    this.d = -1;
    this.o = $61de1ee1cac498ae$var$Rie;
}
function $61de1ee1cac498ae$var$qEb(a, b) {
    var c, d, e;
    d = a.b.d.d;
    a.a || (d += a.b.d.a);
    e = b.b.d.d;
    b.a || (e += b.b.d.a);
    c = $61de1ee1cac498ae$var$Kdb(d, e);
    if (c == 0) {
        if (!a.a && b.a) return -1;
        else if (!b.a && a.a) return 1;
    }
    return c;
}
function $61de1ee1cac498ae$var$eOb(a, b) {
    var c, d, e;
    d = a.b.b.d;
    a.a || (d += a.b.b.a);
    e = b.b.b.d;
    b.a || (e += b.b.b.a);
    c = $61de1ee1cac498ae$var$Kdb(d, e);
    if (c == 0) {
        if (!a.a && b.a) return -1;
        else if (!b.a && a.a) return 1;
    }
    return c;
}
function $61de1ee1cac498ae$var$PVb(a, b) {
    var c, d, e;
    d = a.b.g.d;
    a.a || (d += a.b.g.a);
    e = b.b.g.d;
    b.a || (e += b.b.g.a);
    c = $61de1ee1cac498ae$var$Kdb(d, e);
    if (c == 0) {
        if (!a.a && b.a) return -1;
        else if (!b.a && a.a) return 1;
    }
    return c;
}
function $61de1ee1cac498ae$var$ZTb() {
    $61de1ee1cac498ae$var$ZTb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$WTb = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$oUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$m8b)), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$q8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$x8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$a8b);
    $61de1ee1cac498ae$var$YTb = $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$S7b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$b8b);
    $61de1ee1cac498ae$var$XTb = $61de1ee1cac498ae$var$c3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$d8b);
}
function $61de1ee1cac498ae$var$s3b(a) {
    var b, c, d, e, f;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Csc)), 83);
    f = a.n;
    for(d = b.Cc().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 306);
        e = c.i;
        e.c += f.a;
        e.d += f.b;
        c.c ? $61de1ee1cac498ae$var$VHb(c) : $61de1ee1cac498ae$var$XHb(c);
    }
    $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Csc, null);
}
function $61de1ee1cac498ae$var$qmc(a, b, c) {
    var d, e;
    e = a.b;
    d = e.d;
    switch(b.g){
        case 1:
            return -d.d - c;
        case 2:
            return e.o.a + d.c + c;
        case 3:
            return e.o.b + d.a + c;
        case 4:
            return -d.b - c;
        default:
            return -1;
    }
}
function $61de1ee1cac498ae$var$BXc(a) {
    var b, c, d, e, f;
    d = 0;
    e = $61de1ee1cac498ae$var$dme;
    if (a.b) for(b = 0; b < 360; b++){
        c = b * 0.017453292519943295;
        $61de1ee1cac498ae$var$zXc(a, a.d, 0, 0, $61de1ee1cac498ae$var$dre, c);
        f = a.b.ig(a.d);
        if (f < e) {
            d = c;
            e = f;
        }
    }
    $61de1ee1cac498ae$var$zXc(a, a.d, 0, 0, $61de1ee1cac498ae$var$dre, d);
}
function $61de1ee1cac498ae$var$E$c(a, b) {
    var c, d, e, f;
    f = new $61de1ee1cac498ae$var$Lqb;
    b.e = null;
    b.f = null;
    for(d = new $61de1ee1cac498ae$var$olb(b.i); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 65);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, c.a), 46);
        c.a = $61de1ee1cac498ae$var$D6c(c.b);
        $61de1ee1cac498ae$var$Rhb(f, c.a, e);
    }
    a.g = f;
}
function $61de1ee1cac498ae$var$t$c(a, b, c) {
    var d, e, f, g, h, i;
    e = b - a.e;
    f = e / a.d.c.length;
    g = 0;
    for(i = new $61de1ee1cac498ae$var$olb(a.d); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 443);
        d = a.b - h.b + c;
        $61de1ee1cac498ae$var$_Zc(h, h.e + g * f, h.f);
        $61de1ee1cac498ae$var$XZc(h, f, d);
        ++g;
    }
}
function $61de1ee1cac498ae$var$YBd(a) {
    var b;
    a.f.qj();
    if (a.b != -1) {
        ++a.b;
        b = a.f.d[a.a];
        if (a.b < b.i) return;
        ++a.a;
    }
    for(; a.a < a.f.d.length; ++a.a){
        b = a.f.d[a.a];
        if (!!b && b.i != 0) {
            a.b = 0;
            return;
        }
    }
    a.b = -1;
}
function $61de1ee1cac498ae$var$j0d(a, b) {
    var c, d, e;
    e = b.c.length;
    c = $61de1ee1cac498ae$var$l0d(a, e == 0 ? "" : ($61de1ee1cac498ae$var$tCb(0, b.c.length), $61de1ee1cac498ae$var$GD(b.c[0])));
    for(d = 1; d < e && !!c; ++d)c = $61de1ee1cac498ae$var$BD(c, 49).oh(($61de1ee1cac498ae$var$tCb(d, b.c.length), $61de1ee1cac498ae$var$GD(b.c[d])));
    return c;
}
function $61de1ee1cac498ae$var$rEc(a, b) {
    var c, d;
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
        a.c[c.c.p][c.p].a = $61de1ee1cac498ae$var$Aub(a.i);
        a.c[c.c.p][c.p].d = $61de1ee1cac498ae$var$Edb(a.c[c.c.p][c.p].a);
        a.c[c.c.p][c.p].b = 1;
    }
}
function $61de1ee1cac498ae$var$_dd(a, b) {
    var c, d, e, f;
    f = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 157);
        f += $61de1ee1cac498ae$var$$wnd.Math.pow($61de1ee1cac498ae$var$red(c) * $61de1ee1cac498ae$var$qed(c) - b, 2);
    }
    e = $61de1ee1cac498ae$var$$wnd.Math.sqrt(f / (a.c.length - 1));
    return e;
}
function $61de1ee1cac498ae$var$LHc(a, b, c, d) {
    var e, f, g;
    f = $61de1ee1cac498ae$var$GHc(a, b, c, d);
    g = $61de1ee1cac498ae$var$MHc(a, f);
    $61de1ee1cac498ae$var$bIc(a, b, c, d);
    $61de1ee1cac498ae$var$yHc(a.b);
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(f, new $61de1ee1cac498ae$var$lIc(a));
    e = $61de1ee1cac498ae$var$MHc(a, f);
    $61de1ee1cac498ae$var$bIc(a, c, b, d);
    $61de1ee1cac498ae$var$yHc(a.b);
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(g), $61de1ee1cac498ae$var$meb(e));
}
function $61de1ee1cac498ae$var$cJc(a, b, c) {
    var d, e;
    $61de1ee1cac498ae$var$Odd(c, "Interactive node placement", 1);
    a.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    for(e = new $61de1ee1cac498ae$var$olb(b.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        $61de1ee1cac498ae$var$bJc(a, d);
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$MVc(a, b) {
    var c;
    $61de1ee1cac498ae$var$Odd(b, "General Compactor", 1);
    b.n && !!a && $61de1ee1cac498ae$var$Tdd(b, $61de1ee1cac498ae$var$i6d(a), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    c = $61de1ee1cac498ae$var$qWc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$LWc)), 380));
    c.hg(a);
    b.n && !!a && $61de1ee1cac498ae$var$Tdd(b, $61de1ee1cac498ae$var$i6d(a), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
}
function $61de1ee1cac498ae$var$Dfd(a, b, c) {
    var d, e;
    $61de1ee1cac498ae$var$nmd(a, a.j + b, a.k + c);
    for(e = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, a, 5)), a.a)); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 469);
        $61de1ee1cac498ae$var$ukd(d, d.a + b, d.b + c);
    }
    $61de1ee1cac498ae$var$gmd(a, a.b + b, a.c + c);
}
function $61de1ee1cac498ae$var$vld(a, b, c, d) {
    switch(c){
        case 7:
            return !a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4)), $61de1ee1cac498ae$var$Sxd(a.e, b, d);
        case 8:
            return !a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5)), $61de1ee1cac498ae$var$Sxd(a.d, b, d);
    }
    return $61de1ee1cac498ae$var$Fkd(a, b, c, d);
}
function $61de1ee1cac498ae$var$wld(a, b, c, d) {
    switch(c){
        case 7:
            return !a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4)), $61de1ee1cac498ae$var$Txd(a.e, b, d);
        case 8:
            return !a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5)), $61de1ee1cac498ae$var$Txd(a.d, b, d);
    }
    return $61de1ee1cac498ae$var$Gkd(a, b, c, d);
}
function $61de1ee1cac498ae$var$lqd(a, b, c) {
    var d, e, f, g, h;
    if (c) {
        f = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(f);
        for(h = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            e = $61de1ee1cac498ae$var$Zpd(c, g.a);
            !!e && $61de1ee1cac498ae$var$drd(a, e, b);
        }
    }
}
function $61de1ee1cac498ae$var$HAd(a, b, c) {
    var d, e, f, g, h;
    a.qj();
    f = b == null ? 0 : $61de1ee1cac498ae$var$tb(b);
    if (a.f > 0) {
        g = (f & $61de1ee1cac498ae$var$Ohe) % a.d.length;
        e = $61de1ee1cac498ae$var$wAd(a, g, f, b);
        if (e) {
            h = e.ed(c);
            return h;
        }
    }
    d = a.tj(f, b, c);
    a.c.Fc(d);
    return null;
}
function $61de1ee1cac498ae$var$t1d(a, b) {
    var c, d, e, f;
    switch($61de1ee1cac498ae$var$o1d(a, b)._k()){
        case 3:
        case 2:
            c = $61de1ee1cac498ae$var$OKd(b);
            for(e = 0, f = c.i; e < f; ++e){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(c, e), 34);
                if ($61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d(a, d)) == 5) return d;
            }
            break;
    }
    return null;
}
function $61de1ee1cac498ae$var$Qs(a) {
    var b, c, d, e, f;
    if ($61de1ee1cac498ae$var$Lp(a.f, a.b.length)) {
        d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BG, $61de1ee1cac498ae$var$Gie, 330, a.b.length * 2, 0, 1);
        a.b = d;
        e = d.length - 1;
        for(c = a.a; c != a; c = c.Rd()){
            f = $61de1ee1cac498ae$var$BD(c, 330);
            b = f.d & e;
            f.a = d[b];
            d[b] = f;
        }
    }
}
function $61de1ee1cac498ae$var$DJb(a, b) {
    var c, d, e, f;
    f = 0;
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 111);
        f = $61de1ee1cac498ae$var$$wnd.Math.max(f, d.e.a + d.b.rf().a);
    }
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    c.n.b = 0;
    c.a.a = f;
}
function $61de1ee1cac498ae$var$MKb(a, b) {
    var c, d, e, f;
    c = 0;
    for(f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, e.e.b + e.b.rf().b);
    }
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    d.n.d = 0;
    d.a.b = c;
}
function $61de1ee1cac498ae$var$INc(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21);
    b = $61de1ee1cac498ae$var$k3c($61de1ee1cac498ae$var$zNc);
    c.Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Lrc)) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$CNc);
    c.Hc($61de1ee1cac498ae$var$Nrc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$ENc);
    c.Hc($61de1ee1cac498ae$var$Erc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$ANc);
    c.Hc($61de1ee1cac498ae$var$Grc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$BNc);
    return b;
}
function $61de1ee1cac498ae$var$j1c(a, b) {
    var c;
    $61de1ee1cac498ae$var$Odd(b, "Delaunay triangulation", 1);
    c = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Hkb(a.i, new $61de1ee1cac498ae$var$n1c(c));
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$XNb(), $61de1ee1cac498ae$var$VNb))));
    !a.e ? a.e = $61de1ee1cac498ae$var$NCb(c) : $61de1ee1cac498ae$var$ye(a.e, $61de1ee1cac498ae$var$NCb(c));
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$q6c(a) {
    if (a < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The input must be positive"));
    else return a < $61de1ee1cac498ae$var$h6c.length ? $61de1ee1cac498ae$var$Sbb($61de1ee1cac498ae$var$h6c[a]) : $61de1ee1cac498ae$var$$wnd.Math.sqrt($61de1ee1cac498ae$var$dre * a) * ($61de1ee1cac498ae$var$y6c(a, a) / $61de1ee1cac498ae$var$x6c(2.718281828459045, a));
}
function $61de1ee1cac498ae$var$pud(a, b) {
    var c;
    if (a.ni() && b != null) for(c = 0; c < a.i; ++c){
        if ($61de1ee1cac498ae$var$pb(b, a.g[c])) return true;
    }
    else for(c = 0; c < a.i; ++c){
        if ($61de1ee1cac498ae$var$PD(a.g[c]) === $61de1ee1cac498ae$var$PD(b)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$jr(a, b) {
    if (b == null) while(a.a.Ob()){
        if ($61de1ee1cac498ae$var$BD(a.a.Pb(), 42).dd() == null) return true;
    }
    else while(a.a.Ob()){
        if ($61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$BD(a.a.Pb(), 42).dd())) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$zy(a, b) {
    var c, d, e;
    if (b === a) return true;
    else if ($61de1ee1cac498ae$var$JD(b, 664)) {
        e = $61de1ee1cac498ae$var$BD(b, 1947);
        return $61de1ee1cac498ae$var$Ue((d = a.g, !d ? a.g = new $61de1ee1cac498ae$var$vi(a) : d), (c = e.g, !c ? e.g = new $61de1ee1cac498ae$var$vi(e) : c));
    } else return false;
}
function $61de1ee1cac498ae$var$Tz(a) {
    var b, c, d, e;
    b = "Sz";
    c = "ez";
    e = $61de1ee1cac498ae$var$$wnd.Math.min(a.length, 5);
    for(d = e - 1; d >= 0; d--)if ($61de1ee1cac498ae$var$dfb(a[d].d, b) || $61de1ee1cac498ae$var$dfb(a[d].d, c)) {
        a.length >= d + 1 && a.splice(0, d + 1);
        break;
    }
    return a;
}
function $61de1ee1cac498ae$var$Abb(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$Fbb(a) && $61de1ee1cac498ae$var$Fbb(b)) {
        c = a / b;
        if ($61de1ee1cac498ae$var$Kje < c && c < $61de1ee1cac498ae$var$Ije) return c < 0 ? $61de1ee1cac498ae$var$$wnd.Math.ceil(c) : $61de1ee1cac498ae$var$$wnd.Math.floor(c);
    }
    return $61de1ee1cac498ae$var$zbb($61de1ee1cac498ae$var$UC($61de1ee1cac498ae$var$Fbb(a) ? $61de1ee1cac498ae$var$Rbb(a) : a, $61de1ee1cac498ae$var$Fbb(b) ? $61de1ee1cac498ae$var$Rbb(b) : b, false));
}
function $61de1ee1cac498ae$var$LZb(a, b) {
    if (b == a.c.i) return a.d.i;
    else if (b == a.d.i) return a.c.i;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("'node' must either be the source node or target node of the edge."));
}
function $61de1ee1cac498ae$var$C2b(a) {
    var b, c, d, e;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$xsc)), 37);
    if (e) {
        d = new $61de1ee1cac498ae$var$d7c;
        b = $61de1ee1cac498ae$var$Q_b(a.c.i);
        while(b != e){
            c = b.e;
            b = $61de1ee1cac498ae$var$Q_b(c);
            $61de1ee1cac498ae$var$O6c($61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$P6c(d, c.n), b.c), b.d.b, b.d.d);
        }
        return d;
    }
    return $61de1ee1cac498ae$var$w2b;
}
function $61de1ee1cac498ae$var$Ldc(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ntc)), 403);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.d, 16)), new $61de1ee1cac498ae$var$Ydc), new $61de1ee1cac498ae$var$$dc(a));
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.d, 16)), new $61de1ee1cac498ae$var$aec), new $61de1ee1cac498ae$var$cec(a));
}
function $61de1ee1cac498ae$var$woc(a, b) {
    var c, d, e, f;
    e = b ? $61de1ee1cac498ae$var$U_b(a) : $61de1ee1cac498ae$var$R_b(a);
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(e.a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
        f = $61de1ee1cac498ae$var$LZb(c, a);
        if (f.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) && f.c != a.c) return f;
    }
    return null;
}
function $61de1ee1cac498ae$var$HDc(a) {
    var b, c, d;
    for(c = new $61de1ee1cac498ae$var$olb(a.p); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        if (b.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) continue;
        d = b.o.b;
        a.i = $61de1ee1cac498ae$var$$wnd.Math.min(a.i, d);
        a.g = $61de1ee1cac498ae$var$$wnd.Math.max(a.g, d);
    }
}
function $61de1ee1cac498ae$var$oEc(a, b, c) {
    var d, e, f;
    for(f = new $61de1ee1cac498ae$var$olb(b); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        a.c[d.c.p][d.p].e = false;
    }
    for(e = new $61de1ee1cac498ae$var$olb(b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        $61de1ee1cac498ae$var$nEc(a, d, c);
    }
}
function $61de1ee1cac498ae$var$WOc(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$vPc(b.j, c.s, c.c) + $61de1ee1cac498ae$var$vPc(c.e, b.s, b.c);
    e = $61de1ee1cac498ae$var$vPc(c.j, b.s, b.c) + $61de1ee1cac498ae$var$vPc(b.e, c.s, c.c);
    if (d == e) {
        if (d > 0) {
            a.b += 2;
            a.a += d;
        }
    } else {
        a.b += 1;
        a.a += $61de1ee1cac498ae$var$$wnd.Math.min(d, e);
    }
}
function $61de1ee1cac498ae$var$Rpd(a, b) {
    var c, d;
    d = false;
    if ($61de1ee1cac498ae$var$ND(b)) {
        d = true;
        $61de1ee1cac498ae$var$Qpd(a, new $61de1ee1cac498ae$var$yC($61de1ee1cac498ae$var$GD(b)));
    }
    if (!d) {
        if ($61de1ee1cac498ae$var$JD(b, 236)) {
            d = true;
            $61de1ee1cac498ae$var$Qpd(a, (c = $61de1ee1cac498ae$var$Kcb($61de1ee1cac498ae$var$BD(b, 236)), new $61de1ee1cac498ae$var$TB(c)));
        }
    }
    if (!d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$vcb($61de1ee1cac498ae$var$Ute));
}
function $61de1ee1cac498ae$var$IMd(a, b, c, d) {
    var e, f, g;
    e = new $61de1ee1cac498ae$var$pSd(a.e, 1, 10, (g = b.c, $61de1ee1cac498ae$var$JD(g, 88) ? $61de1ee1cac498ae$var$BD(g, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd)), (f = c.c, $61de1ee1cac498ae$var$JD(f, 88) ? $61de1ee1cac498ae$var$BD(f, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd)), $61de1ee1cac498ae$var$HLd(a, b), false);
    !d ? d = e : d.Ei(e);
    return d;
}
function $61de1ee1cac498ae$var$T_b(a) {
    var b, c;
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ixc)), 420).g){
        case 0:
            b = a.n;
            c = a.o;
            return new $61de1ee1cac498ae$var$f7c(b.a + c.a / 2, b.b + c.b / 2);
        case 1:
            return new $61de1ee1cac498ae$var$g7c(a.n);
        default:
            return null;
    }
}
function $61de1ee1cac498ae$var$lrc() {
    $61de1ee1cac498ae$var$lrc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$irc = new $61de1ee1cac498ae$var$mrc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$hrc = new $61de1ee1cac498ae$var$mrc("LEFTUP", 1);
    $61de1ee1cac498ae$var$krc = new $61de1ee1cac498ae$var$mrc("RIGHTUP", 2);
    $61de1ee1cac498ae$var$grc = new $61de1ee1cac498ae$var$mrc("LEFTDOWN", 3);
    $61de1ee1cac498ae$var$jrc = new $61de1ee1cac498ae$var$mrc("RIGHTDOWN", 4);
    $61de1ee1cac498ae$var$frc = new $61de1ee1cac498ae$var$mrc("BALANCED", 5);
}
function $61de1ee1cac498ae$var$FFc(a, b, c) {
    var d, e, f;
    d = $61de1ee1cac498ae$var$Kdb(a.a[b.p], a.a[c.p]);
    if (d == 0) {
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Qsc)), 15);
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Qsc), 15);
        if (e.Hc(c)) return -1;
        else if (f.Hc(b)) return 1;
    }
    return d;
}
function $61de1ee1cac498ae$var$jXc(a) {
    switch(a.g){
        case 1:
            return new $61de1ee1cac498ae$var$XVc;
        case 2:
            return new $61de1ee1cac498ae$var$ZVc;
        case 3:
            return new $61de1ee1cac498ae$var$VVc;
        case 0:
            return null;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$jre + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$Ikd(a, b, c) {
    switch(b){
        case 1:
            !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7));
            $61de1ee1cac498ae$var$Uxd(a.n);
            !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7));
            $61de1ee1cac498ae$var$ytd(a.n, $61de1ee1cac498ae$var$BD(c, 14));
            return;
        case 2:
            $61de1ee1cac498ae$var$Lkd(a, $61de1ee1cac498ae$var$GD(c));
            return;
    }
    $61de1ee1cac498ae$var$ekd(a, b, c);
}
function $61de1ee1cac498ae$var$Zkd(a, b, c) {
    switch(b){
        case 3:
            $61de1ee1cac498ae$var$ald(a, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c)));
            return;
        case 4:
            $61de1ee1cac498ae$var$cld(a, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c)));
            return;
        case 5:
            $61de1ee1cac498ae$var$dld(a, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c)));
            return;
        case 6:
            $61de1ee1cac498ae$var$eld(a, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c)));
            return;
    }
    $61de1ee1cac498ae$var$Ikd(a, b, c);
}
function $61de1ee1cac498ae$var$Fnd(a, b, c) {
    var d, e, f;
    f = (d = new $61de1ee1cac498ae$var$rUd, d);
    e = $61de1ee1cac498ae$var$xId(f, b, null);
    !!e && e.Fi();
    $61de1ee1cac498ae$var$pnd(f, c);
    $61de1ee1cac498ae$var$wtd((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, a, 12, 10)), a.c), f);
    $61de1ee1cac498ae$var$AId(f, 0);
    $61de1ee1cac498ae$var$DId(f, 1);
    $61de1ee1cac498ae$var$CId(f, true);
    $61de1ee1cac498ae$var$BId(f, true);
}
function $61de1ee1cac498ae$var$mUd(a, b) {
    var c, d, e;
    c = $61de1ee1cac498ae$var$Crb(a.g, b);
    if ($61de1ee1cac498ae$var$JD(c, 235)) {
        e = $61de1ee1cac498ae$var$BD(c, 235);
        e.Qh() == null && undefined;
        return e.Nh();
    } else if ($61de1ee1cac498ae$var$JD(c, 498)) {
        d = $61de1ee1cac498ae$var$BD(c, 1938);
        e = d.b;
        return e;
    } else return null;
}
function $61de1ee1cac498ae$var$Ui(a, b, c, d) {
    var e, f;
    $61de1ee1cac498ae$var$Qb(b);
    $61de1ee1cac498ae$var$Qb(c);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$tn(a.d, b), 19);
    $61de1ee1cac498ae$var$Ob(!!f, "Row %s not in %s", b, a.e);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$tn(a.b, c), 19);
    $61de1ee1cac498ae$var$Ob(!!e, "Column %s not in %s", c, a.c);
    return $61de1ee1cac498ae$var$Wi(a, f.a, e.a, d);
}
function $61de1ee1cac498ae$var$JC(a, b, c, d, e, f, g) {
    var h, i, j, k, l;
    k = e[f];
    j = f == g - 1;
    h = j ? d : 0;
    l = $61de1ee1cac498ae$var$LC(h, k);
    d != 10 && $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC(a, g - f), b[f], c[f], h, l);
    if (!j) {
        ++f;
        for(i = 0; i < k; ++i)l[i] = $61de1ee1cac498ae$var$JC(a, b, c, d, e, f, g);
    }
    return l;
}
function $61de1ee1cac498ae$var$Eyd(b) {
    if (b.g == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    b.mj();
    try {
        b.i.$c(b.g);
        b.f = b.i.j;
        b.g < b.e && --b.e;
        b.g = -1;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$hYb(a, b) {
    a.b.a = $61de1ee1cac498ae$var$$wnd.Math.min(a.b.a, b.c);
    a.b.b = $61de1ee1cac498ae$var$$wnd.Math.min(a.b.b, b.d);
    a.a.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.a.a, b.c);
    a.a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.a.b, b.d);
    return a.c[a.c.length] = b, true;
}
function $61de1ee1cac498ae$var$nZb(a) {
    var b, c, d, e;
    e = -1;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$olb(a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 243);
        if (b.c == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc)) {
            e = d == 0 ? 0 : d - 1;
            break;
        } else d == a.c.length - 1 && (e = d);
        d += 1;
    }
    return e;
}
function $61de1ee1cac498ae$var$UZc(a) {
    var b, c, d, e;
    e = 0;
    b = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.c); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 33);
        $61de1ee1cac498ae$var$dld(c, a.e + e);
        $61de1ee1cac498ae$var$eld(c, a.f);
        e += c.g + a.b;
        b = $61de1ee1cac498ae$var$$wnd.Math.max(b, c.f + a.b);
    }
    a.d = e - a.b;
    a.a = b - a.b;
}
function $61de1ee1cac498ae$var$bEb(a) {
    var b, c, d;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        d = b.d.c;
        b.d.c = b.d.d;
        b.d.d = d;
        d = b.d.b;
        b.d.b = b.d.a;
        b.d.a = d;
        d = b.b.a;
        b.b.a = b.b.b;
        b.b.b = d;
    }
    $61de1ee1cac498ae$var$RDb(a);
}
function $61de1ee1cac498ae$var$BVb(a) {
    var b, c, d;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        d = b.g.c;
        b.g.c = b.g.d;
        b.g.d = d;
        d = b.g.b;
        b.g.b = b.g.a;
        b.g.a = d;
        d = b.e.a;
        b.e.a = b.e.b;
        b.e.b = d;
    }
    $61de1ee1cac498ae$var$sVb(a);
}
function $61de1ee1cac498ae$var$Lmc(a) {
    var b, c, d, e, f;
    f = $61de1ee1cac498ae$var$Ec(a.k);
    for(c = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        if (b != $61de1ee1cac498ae$var$Scd && !f.Hc(b)) return b;
    }
    return null;
}
function $61de1ee1cac498ae$var$znc(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Etb($61de1ee1cac498ae$var$KAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.j, 16)), new $61de1ee1cac498ae$var$Pnc))), 11);
    if (d) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d.e, 0), 17);
        if (c) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)), 19).a;
    }
    return $61de1ee1cac498ae$var$yzc(a.b);
}
function $61de1ee1cac498ae$var$CCc(a, b) {
    var c, d, e, f;
    for(f = new $61de1ee1cac498ae$var$olb(b.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        $61de1ee1cac498ae$var$Blb(a.d);
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(e).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
            $61de1ee1cac498ae$var$zCc(a, e, c.d.i);
        }
    }
}
function $61de1ee1cac498ae$var$NZc(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$Lkb(a.b, b);
    for(d = new $61de1ee1cac498ae$var$olb(a.n); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 211);
        if ($61de1ee1cac498ae$var$Jkb(c.c, b, 0) != -1) {
            $61de1ee1cac498ae$var$Lkb(c.c, b);
            $61de1ee1cac498ae$var$UZc(c);
            c.c.c.length == 0 && $61de1ee1cac498ae$var$Lkb(a.n, c);
            break;
        }
    }
    $61de1ee1cac498ae$var$HZc(a);
}
function $61de1ee1cac498ae$var$$Zc(a, b) {
    var c, d, e, f, g;
    g = a.f;
    e = 0;
    f = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 187);
        $61de1ee1cac498ae$var$OZc(c, a.e, g);
        $61de1ee1cac498ae$var$KZc(c, b);
        f = $61de1ee1cac498ae$var$$wnd.Math.max(f, c.r);
        g += c.d + a.c;
        e = g;
    }
    a.d = f;
    a.b = e;
}
function $61de1ee1cac498ae$var$hVc(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$$sd(a);
    if ($61de1ee1cac498ae$var$Qq(c)) return null;
    else {
        b = ($61de1ee1cac498ae$var$Qb(c), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(c.a.Kc(), new $61de1ee1cac498ae$var$Sq))), 79));
        return $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.b && (b.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 4, 7)), b.b), 0), 82));
    }
}
function $61de1ee1cac498ae$var$XId(a) {
    var b;
    if (!a.o) {
        b = a.Lj();
        b ? a.o = new $61de1ee1cac498ae$var$dYd(a, a, null) : a.rk() ? a.o = new $61de1ee1cac498ae$var$uVd(a, null) : $61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a)) == 1 ? a.o = new $61de1ee1cac498ae$var$nYd(a) : a.o = new $61de1ee1cac498ae$var$sYd(a, null);
    }
    return a.o;
}
function $61de1ee1cac498ae$var$w6d(a, b, c, d) {
    var e, f, g, h, i;
    if (c.mh(b)) {
        e = (g = b, !g ? null : $61de1ee1cac498ae$var$BD(d, 49).xh(g));
        if (e) {
            i = c.ah(b);
            h = b.t;
            if (h > 1 || h == -1) {
                f = $61de1ee1cac498ae$var$BD(i, 15);
                e.Wb($61de1ee1cac498ae$var$t6d(a, f));
            } else e.Wb($61de1ee1cac498ae$var$s6d(a, $61de1ee1cac498ae$var$BD(i, 56)));
        }
    }
}
function $61de1ee1cac498ae$var$Zbb(b, c, d, e) {
    $61de1ee1cac498ae$var$Ybb();
    var f = $61de1ee1cac498ae$var$Wbb;
    $61de1ee1cac498ae$var$$moduleName = c;
    $61de1ee1cac498ae$var$$moduleBase = d;
    $61de1ee1cac498ae$var$tbb = e;
    function g() {
        for(var a = 0; a < f.length; a++)f[a]();
    }
    if (b) try {
        $61de1ee1cac498ae$var$Ihe(g)();
    } catch (a) {
        b(c, a);
    }
    else $61de1ee1cac498ae$var$Ihe(g)();
}
function $61de1ee1cac498ae$var$Kgc(a) {
    var b, c, d, e, f;
    for(d = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(a.b).a); d.b;){
        c = $61de1ee1cac498ae$var$lib(d);
        b = $61de1ee1cac498ae$var$BD(c.cd(), 10);
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(c.dd(), 46).a, 10);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(c.dd(), 46).b, 8);
        $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(b.n), $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$R6c(f.n), e));
    }
}
function $61de1ee1cac498ae$var$llc(a) {
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vwc)), 375).g){
        case 1:
            $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.d, 16)), new $61de1ee1cac498ae$var$Glc), new $61de1ee1cac498ae$var$Ilc), new $61de1ee1cac498ae$var$Klc);
            break;
        case 2:
            $61de1ee1cac498ae$var$nlc(a);
            break;
        case 0:
            $61de1ee1cac498ae$var$mlc(a);
    }
}
function $61de1ee1cac498ae$var$KXc(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$Odd(c, "Straight Line Edge Routing", 1);
    c.n && !!b && $61de1ee1cac498ae$var$Tdd(c, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$MUc(), $61de1ee1cac498ae$var$LUc)), 33);
    $61de1ee1cac498ae$var$LXc(a, d);
    c.n && !!b && $61de1ee1cac498ae$var$Tdd(c, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
}
function $61de1ee1cac498ae$var$i8c() {
    $61de1ee1cac498ae$var$i8c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$h8c = new $61de1ee1cac498ae$var$j8c("V_TOP", 0);
    $61de1ee1cac498ae$var$g8c = new $61de1ee1cac498ae$var$j8c("V_CENTER", 1);
    $61de1ee1cac498ae$var$f8c = new $61de1ee1cac498ae$var$j8c("V_BOTTOM", 2);
    $61de1ee1cac498ae$var$d8c = new $61de1ee1cac498ae$var$j8c("H_LEFT", 3);
    $61de1ee1cac498ae$var$c8c = new $61de1ee1cac498ae$var$j8c("H_CENTER", 4);
    $61de1ee1cac498ae$var$e8c = new $61de1ee1cac498ae$var$j8c("H_RIGHT", 5);
}
function $61de1ee1cac498ae$var$gLd(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$mKd(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$mKd(a));
    b.a += " (abstract: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & 256) != 0);
    b.a += ", interface: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & 512) != 0);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$l3d(a, b, c, d) {
    var e, f, g, h;
    if ($61de1ee1cac498ae$var$oid(a.e)) {
        e = b.ak();
        h = b.dd();
        f = c.dd();
        g = $61de1ee1cac498ae$var$H2d(a, 1, e, h, f, e.$j() ? $61de1ee1cac498ae$var$M2d(a, e, f, $61de1ee1cac498ae$var$JD(e, 99) && ($61de1ee1cac498ae$var$BD(e, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0) : -1, true);
        d ? d.Ei(g) : d = g;
    }
    return d;
}
function $61de1ee1cac498ae$var$kz(a) {
    var b;
    if (a.c == null) {
        b = $61de1ee1cac498ae$var$PD(a.b) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$iz) ? null : a.b;
        a.d = b == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$MD(b) ? $61de1ee1cac498ae$var$nz($61de1ee1cac498ae$var$FD(b)) : $61de1ee1cac498ae$var$ND(b) ? $61de1ee1cac498ae$var$Vie : $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$rb(b));
        a.a = a.a + ": " + ($61de1ee1cac498ae$var$MD(b) ? $61de1ee1cac498ae$var$mz($61de1ee1cac498ae$var$FD(b)) : b + "");
        a.c = "(" + a.d + ") " + a.a;
    }
}
function $61de1ee1cac498ae$var$Wgb(a, b) {
    this.e = a;
    if ($61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$xbb(b, -4294967296), 0)) {
        this.d = 1;
        this.a = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
            $61de1ee1cac498ae$var$Tbb(b)
        ]);
    } else {
        this.d = 2;
        this.a = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
            $61de1ee1cac498ae$var$Tbb(b),
            $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Obb(b, 32))
        ]);
    }
}
function $61de1ee1cac498ae$var$yrb() {
    function b() {
        try {
            return (new Map).entries().next().done;
        } catch (a) {
            return false;
        }
    }
    if (typeof Map === $61de1ee1cac498ae$var$Nhe && Map.prototype.entries && b()) return Map;
    else return $61de1ee1cac498ae$var$zrb();
}
function $61de1ee1cac498ae$var$VPc(a, b) {
    var c, d, e, f;
    f = new $61de1ee1cac498ae$var$Bib(a.e, 0);
    c = 0;
    while(f.b < f.d.gc()){
        d = $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$sCb(f.b < f.d.gc()), $61de1ee1cac498ae$var$ED(f.d.Xb(f.c = f.b++))));
        e = d - b;
        if (e > $61de1ee1cac498ae$var$Oqe) return c;
        else e > -0.000001 && ++c;
    }
    return c;
}
function $61de1ee1cac498ae$var$PQd(a, b) {
    var c;
    if (b != a.b) {
        c = null;
        !!a.b && (c = $61de1ee1cac498ae$var$lid(a.b, a, -4, c));
        !!b && (c = $61de1ee1cac498ae$var$kid(b, a, -4, c));
        c = $61de1ee1cac498ae$var$GQd(a, b, c);
        !!c && c.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 3, b, b));
}
function $61de1ee1cac498ae$var$SQd(a, b) {
    var c;
    if (b != a.f) {
        c = null;
        !!a.f && (c = $61de1ee1cac498ae$var$lid(a.f, a, -1, c));
        !!b && (c = $61de1ee1cac498ae$var$kid(b, a, -1, c));
        c = $61de1ee1cac498ae$var$IQd(a, b, c);
        !!c && c.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 0, b, b));
}
function $61de1ee1cac498ae$var$E9d(a) {
    var b, c, d;
    if (a == null) return null;
    c = $61de1ee1cac498ae$var$BD(a, 15);
    if (c.dc()) return "";
    d = new $61de1ee1cac498ae$var$Hfb;
    for(b = c.Kc(); b.Ob();){
        $61de1ee1cac498ae$var$Efb(d, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$GD(b.Pb())));
        d.a += " ";
    }
    return $61de1ee1cac498ae$var$lcb(d, d.a.length - 1);
}
function $61de1ee1cac498ae$var$I9d(a) {
    var b, c, d;
    if (a == null) return null;
    c = $61de1ee1cac498ae$var$BD(a, 15);
    if (c.dc()) return "";
    d = new $61de1ee1cac498ae$var$Hfb;
    for(b = c.Kc(); b.Ob();){
        $61de1ee1cac498ae$var$Efb(d, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$GD(b.Pb())));
        d.a += " ";
    }
    return $61de1ee1cac498ae$var$lcb(d, d.a.length - 1);
}
function $61de1ee1cac498ae$var$qEc(a, b, c) {
    var d, e;
    d = a.c[b.c.p][b.p];
    e = a.c[c.c.p][c.p];
    if (d.a != null && e.a != null) return $61de1ee1cac498ae$var$Ddb(d.a, e.a);
    else if (d.a != null) return -1;
    else if (e.a != null) return 1;
    return 0;
}
function $61de1ee1cac498ae$var$zqd(a, b) {
    var c, d, e, f, g, h;
    if (b) {
        f = b.a.length;
        c = new $61de1ee1cac498ae$var$Yge(f);
        for(h = (c.b - c.a) * c.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(c); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            e = $61de1ee1cac498ae$var$Zpd(b, g.a);
            d = new $61de1ee1cac498ae$var$Crd(a);
            $61de1ee1cac498ae$var$Aqd(d.a, e);
        }
    }
}
function $61de1ee1cac498ae$var$Qqd(a, b) {
    var c, d, e, f, g, h;
    if (b) {
        f = b.a.length;
        c = new $61de1ee1cac498ae$var$Yge(f);
        for(h = (c.b - c.a) * c.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(c); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            e = $61de1ee1cac498ae$var$Zpd(b, g.a);
            d = new $61de1ee1cac498ae$var$lrd(a);
            $61de1ee1cac498ae$var$nqd(d.a, e);
        }
    }
}
function $61de1ee1cac498ae$var$eFd(b) {
    var c;
    if (b != null && b.length > 0 && $61de1ee1cac498ae$var$bfb(b, b.length - 1) == 33) try {
        c = $61de1ee1cac498ae$var$PEd($61de1ee1cac498ae$var$qfb(b, 0, b.length - 1));
        return c.e == null;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if (!$61de1ee1cac498ae$var$JD(a, 32)) throw $61de1ee1cac498ae$var$vbb(a);
    }
    return false;
}
function $61de1ee1cac498ae$var$h3d(a, b, c) {
    var d, e, f;
    d = b.ak();
    f = b.dd();
    e = d.$j() ? $61de1ee1cac498ae$var$H2d(a, 3, d, null, f, $61de1ee1cac498ae$var$M2d(a, d, f, $61de1ee1cac498ae$var$JD(d, 99) && ($61de1ee1cac498ae$var$BD(d, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0), true) : $61de1ee1cac498ae$var$H2d(a, 1, d, d.zj(), f, -1, true);
    c ? c.Ei(e) : c = e;
    return c;
}
function $61de1ee1cac498ae$var$Vee() {
    var a, b, c;
    b = 0;
    for(a = 0; a < 1; a++){
        c = $61de1ee1cac498ae$var$Uee(($61de1ee1cac498ae$var$BCb(a, 1), "X".charCodeAt(a)));
        if (c == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde("Unknown Option: " + "X".substr(a)));
        b |= c;
    }
    return b;
}
function $61de1ee1cac498ae$var$mZb(a, b, c) {
    var d, e, f;
    d = $61de1ee1cac498ae$var$Q_b(b);
    e = $61de1ee1cac498ae$var$a_b(d);
    f = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(f, b);
    switch(c.g){
        case 1:
            $61de1ee1cac498ae$var$G0b(f, $61de1ee1cac498ae$var$Wcd($61de1ee1cac498ae$var$Zcd(e)));
            break;
        case 2:
            $61de1ee1cac498ae$var$G0b(f, $61de1ee1cac498ae$var$Zcd(e));
    }
    $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Uxc), $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Uxc)));
    return f;
}
function $61de1ee1cac498ae$var$U9b(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(a.a).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(a.a).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17);
    return $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc)))) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$ltc)));
}
function $61de1ee1cac498ae$var$Xjc() {
    $61de1ee1cac498ae$var$Xjc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Tjc = new $61de1ee1cac498ae$var$Yjc("ONE_SIDE", 0);
    $61de1ee1cac498ae$var$Vjc = new $61de1ee1cac498ae$var$Yjc("TWO_SIDES_CORNER", 1);
    $61de1ee1cac498ae$var$Wjc = new $61de1ee1cac498ae$var$Yjc("TWO_SIDES_OPPOSING", 2);
    $61de1ee1cac498ae$var$Ujc = new $61de1ee1cac498ae$var$Yjc("THREE_SIDES", 3);
    $61de1ee1cac498ae$var$Sjc = new $61de1ee1cac498ae$var$Yjc("FOUR_SIDES", 4);
}
function $61de1ee1cac498ae$var$jkc(a, b, c, d, e) {
    var f, g;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb(b.Oc(), new $61de1ee1cac498ae$var$_kc), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, c, d), 15);
    e == 0 ? g.Wc(0, f) : g.Gc(f);
}
function $61de1ee1cac498ae$var$KDc(a, b) {
    var c, d, e, f, g;
    for(f = new $61de1ee1cac498ae$var$olb(b.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(e).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
            g = c.c.i.p;
            a.n[g] = a.n[g] - 1;
        }
    }
}
function $61de1ee1cac498ae$var$cnc(a, b) {
    var c, d, e, f, g;
    for(f = new $61de1ee1cac498ae$var$olb(b.d); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 101);
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.c, e), 112).o;
        for(d = new $61de1ee1cac498ae$var$Gqb(e.b); d.a < d.c.a.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Fqb(d), 61);
            $61de1ee1cac498ae$var$ojc(e, c, g);
        }
    }
}
function $61de1ee1cac498ae$var$HJc(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$olb(a.e.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 29);
        $61de1ee1cac498ae$var$YJc(a, b);
    }
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.e.b, 16)), new $61de1ee1cac498ae$var$YKc), new $61de1ee1cac498ae$var$tLc), new $61de1ee1cac498ae$var$vLc), new $61de1ee1cac498ae$var$xLc(a));
}
function $61de1ee1cac498ae$var$Qwd(a, b) {
    if (!b) return false;
    else {
        if (a.Di(b)) return false;
        if (!a.i) {
            if ($61de1ee1cac498ae$var$JD(b, 143)) {
                a.i = $61de1ee1cac498ae$var$BD(b, 143);
                return true;
            } else {
                a.i = new $61de1ee1cac498ae$var$Hxd;
                return a.i.Ei(b);
            }
        } else return a.i.Ei(b);
    }
}
function $61de1ee1cac498ae$var$B9d(a) {
    a = $61de1ee1cac498ae$var$Qge(a, true);
    if ($61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$kse, a) || $61de1ee1cac498ae$var$dfb("1", a)) return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Acb;
    else if ($61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$lse, a) || $61de1ee1cac498ae$var$dfb("0", a)) return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb;
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$n8d("Invalid boolean value: '" + a + "'"));
}
function $61de1ee1cac498ae$var$Kd(a, b, c) {
    var d, e, f;
    for(e = a.vc().Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 42);
        f = d.cd();
        if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(f) || b != null && $61de1ee1cac498ae$var$pb(b, f)) {
            if (c) {
                d = new $61de1ee1cac498ae$var$pjb(d.cd(), d.dd());
                e.Qb();
            }
            return d;
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$dKb(a) {
    $61de1ee1cac498ae$var$$Jb();
    var b, c, d;
    if (!a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Add))) return;
    d = a.f.i;
    b = new $61de1ee1cac498ae$var$K6c(a.a.c);
    c = new $61de1ee1cac498ae$var$p0b;
    c.b = b.c - d.c;
    c.d = b.d - d.d;
    c.c = d.c + d.b - (b.c + b.b);
    c.a = d.d + d.a - (b.d + b.a);
    a.e.Ff(c);
}
function $61de1ee1cac498ae$var$LNb(a, b, c, d) {
    var e, f, g;
    g = $61de1ee1cac498ae$var$$wnd.Math.min(c, $61de1ee1cac498ae$var$ONb($61de1ee1cac498ae$var$BD(a.b, 65), b, c, d));
    for(f = new $61de1ee1cac498ae$var$olb(a.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 221);
        e != b && (g = $61de1ee1cac498ae$var$$wnd.Math.min(g, $61de1ee1cac498ae$var$LNb(e, b, g, d)));
    }
    return g;
}
function $61de1ee1cac498ae$var$WZb(a) {
    var b, c, d, e;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$nie, 193, a.b.c.length, 0, 2);
    d = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    while(d.b < d.d.gc()){
        b = ($61de1ee1cac498ae$var$sCb(d.b < d.d.gc()), $61de1ee1cac498ae$var$BD(d.d.Xb(d.c = d.b++), 29));
        c = d.b - 1;
        e[c] = $61de1ee1cac498ae$var$l_b(b.a);
    }
    return e;
}
function $61de1ee1cac498ae$var$K3b(a, b, c, d, e) {
    var f, g, h, i;
    g = $61de1ee1cac498ae$var$eLb($61de1ee1cac498ae$var$dLb($61de1ee1cac498ae$var$iLb($61de1ee1cac498ae$var$H3b(c)), d), $61de1ee1cac498ae$var$C3b(a, c, e));
    for(i = $61de1ee1cac498ae$var$Y_b(a, c).Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 11);
        if (b[h.p]) {
            f = b[h.p].i;
            $61de1ee1cac498ae$var$Ekb(g.d, new $61de1ee1cac498ae$var$BLb(f, $61de1ee1cac498ae$var$bLb(g, f)));
        }
    }
    $61de1ee1cac498ae$var$cLb(g);
}
function $61de1ee1cac498ae$var$sic(a, b) {
    this.f = new $61de1ee1cac498ae$var$Lqb;
    this.b = new $61de1ee1cac498ae$var$Lqb;
    this.j = new $61de1ee1cac498ae$var$Lqb;
    this.a = a;
    this.c = b;
    this.c > 0 && $61de1ee1cac498ae$var$ric(this, this.c - 1, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
    this.c < this.a.length - 1 && $61de1ee1cac498ae$var$ric(this, this.c + 1, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
}
function $61de1ee1cac498ae$var$SEc(a) {
    a.length > 0 && a[0].length > 0 && (this.c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a[0][0]), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Rsc)))));
    this.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$CX, $61de1ee1cac498ae$var$nie, 2018, a.length, 0, 2);
    this.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$FX, $61de1ee1cac498ae$var$nie, 2019, a.length, 0, 2);
    this.d = new $61de1ee1cac498ae$var$ss;
}
function $61de1ee1cac498ae$var$tKc(a) {
    if (a.c.length == 0) return false;
    if (($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 17)).c.i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) return true;
    return $61de1ee1cac498ae$var$FAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a, 16)), new $61de1ee1cac498ae$var$wKc), new $61de1ee1cac498ae$var$yKc);
}
function $61de1ee1cac498ae$var$rRc(a, b, c) {
    $61de1ee1cac498ae$var$Odd(c, "Tree layout", 1);
    $61de1ee1cac498ae$var$H2c(a.b);
    $61de1ee1cac498ae$var$K2c(a.b, ($61de1ee1cac498ae$var$yRc(), $61de1ee1cac498ae$var$uRc), $61de1ee1cac498ae$var$uRc);
    $61de1ee1cac498ae$var$K2c(a.b, $61de1ee1cac498ae$var$vRc, $61de1ee1cac498ae$var$vRc);
    $61de1ee1cac498ae$var$K2c(a.b, $61de1ee1cac498ae$var$wRc, $61de1ee1cac498ae$var$wRc);
    $61de1ee1cac498ae$var$K2c(a.b, $61de1ee1cac498ae$var$xRc, $61de1ee1cac498ae$var$xRc);
    a.a = $61de1ee1cac498ae$var$F2c(a.b, b);
    $61de1ee1cac498ae$var$sRc(a, b, $61de1ee1cac498ae$var$Udd(c, 1));
    $61de1ee1cac498ae$var$Qdd(c);
    return b;
}
function $61de1ee1cac498ae$var$HXc(a, b) {
    var c, d, e, f, g, h, i;
    h = $61de1ee1cac498ae$var$gVc(b);
    f = b.f;
    i = b.g;
    g = $61de1ee1cac498ae$var$$wnd.Math.sqrt(f * f + i * i);
    e = 0;
    for(d = new $61de1ee1cac498ae$var$olb(h); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 33);
        e += $61de1ee1cac498ae$var$HXc(a, c);
    }
    return $61de1ee1cac498ae$var$$wnd.Math.max(e, g);
}
function $61de1ee1cac498ae$var$dcd() {
    $61de1ee1cac498ae$var$dcd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ccd = new $61de1ee1cac498ae$var$gcd($61de1ee1cac498ae$var$ole, 0);
    $61de1ee1cac498ae$var$bcd = new $61de1ee1cac498ae$var$gcd("FREE", 1);
    $61de1ee1cac498ae$var$acd = new $61de1ee1cac498ae$var$gcd("FIXED_SIDE", 2);
    $61de1ee1cac498ae$var$Zbd = new $61de1ee1cac498ae$var$gcd("FIXED_ORDER", 3);
    $61de1ee1cac498ae$var$_bd = new $61de1ee1cac498ae$var$gcd("FIXED_RATIO", 4);
    $61de1ee1cac498ae$var$$bd = new $61de1ee1cac498ae$var$gcd("FIXED_POS", 5);
}
function $61de1ee1cac498ae$var$c1d(a, b) {
    var c, d, e;
    c = b.Hh(a.a);
    if (c) {
        e = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$Cwe));
        for(d = 1; d < ($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$N6d).length; ++d){
            if ($61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$N6d[d], e)) return d;
        }
    }
    return 0;
}
function $61de1ee1cac498ae$var$Qlb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$uwb(f, "" + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$Wlb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$uwb(f, "" + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$Md(a) {
    var b, c, d;
    d = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "{", "}");
    for(c = a.vc().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 42);
        $61de1ee1cac498ae$var$uwb(d, $61de1ee1cac498ae$var$Nd(a, b.cd()) + "=" + $61de1ee1cac498ae$var$Nd(a, b.dd()));
    }
    return !d.a ? d.c : d.e.length == 0 ? d.a.a : d.a.a + ("" + d.e);
}
function $61de1ee1cac498ae$var$EGb(a) {
    var b, c, d, e;
    while(!$61de1ee1cac498ae$var$akb(a.o)){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(a.o), 46);
        d = $61de1ee1cac498ae$var$BD(c.a, 121);
        b = $61de1ee1cac498ae$var$BD(c.b, 213);
        e = $61de1ee1cac498ae$var$xFb(b, d);
        if (b.e == d) {
            $61de1ee1cac498ae$var$NFb(e.g, b);
            d.e = e.e + b.a;
        } else {
            $61de1ee1cac498ae$var$NFb(e.b, b);
            d.e = e.e - b.a;
        }
        $61de1ee1cac498ae$var$Ekb(a.e.a, d);
    }
}
function $61de1ee1cac498ae$var$F6b(a, b) {
    var c, d, e;
    c = null;
    for(e = $61de1ee1cac498ae$var$BD(b.Kb(a), 20).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 17);
        if (!c) c = d.c.i == a ? d.d.i : d.c.i;
        else {
            if ((d.c.i == a ? d.d.i : d.c.i) != c) return false;
        }
    }
    return true;
}
function $61de1ee1cac498ae$var$uPc(a, b) {
    var c, d, e, f, g;
    c = $61de1ee1cac498ae$var$WNc(a, false, b);
    for(e = new $61de1ee1cac498ae$var$olb(c); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 129);
        d.d == 0 ? ($61de1ee1cac498ae$var$BOc(d, null), $61de1ee1cac498ae$var$COc(d, null)) : (f = d.a, g = d.b, $61de1ee1cac498ae$var$BOc(d, g), $61de1ee1cac498ae$var$COc(d, f), undefined);
    }
}
function $61de1ee1cac498ae$var$qQc(a) {
    var b, c;
    b = new $61de1ee1cac498ae$var$j3c;
    $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$cQc);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21);
    c.Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Nrc)) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$gQc);
    c.Hc($61de1ee1cac498ae$var$Erc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$dQc);
    c.Hc($61de1ee1cac498ae$var$Lrc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$fQc);
    c.Hc($61de1ee1cac498ae$var$Grc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$eQc);
    return b;
}
function $61de1ee1cac498ae$var$Xac(a) {
    var b, c, d, e;
    $61de1ee1cac498ae$var$Wac(a);
    for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
        d = b.c.i == a;
        e = d ? b.d : b.c;
        d ? $61de1ee1cac498ae$var$RZb(b, null) : $61de1ee1cac498ae$var$QZb(b, null);
        $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ctc), e);
        $61de1ee1cac498ae$var$_ac(a, e.i);
    }
}
function $61de1ee1cac498ae$var$wmc(a, b, c, d) {
    var e, f;
    f = b.i;
    e = c[f.g][a.d[f.g]];
    switch(f.g){
        case 1:
            e -= d + b.j.b;
            b.g.b = e;
            break;
        case 3:
            e += d;
            b.g.b = e;
            break;
        case 4:
            e -= d + b.j.a;
            b.g.a = e;
            break;
        case 2:
            e += d;
            b.g.a = e;
    }
}
function $61de1ee1cac498ae$var$aVc(a) {
    var b, c, d;
    for(c = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 33);
        d = $61de1ee1cac498ae$var$$sd(b);
        if (!$61de1ee1cac498ae$var$Qr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(d.a.Kc(), new $61de1ee1cac498ae$var$Sq)))) return b;
    }
    return null;
}
function $61de1ee1cac498ae$var$Cod() {
    var a;
    if ($61de1ee1cac498ae$var$yod) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$nUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$yte), 2016);
    a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$Phb(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$yte), 555) ? $61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$xFd, $61de1ee1cac498ae$var$yte) : new $61de1ee1cac498ae$var$Bod, 555);
    $61de1ee1cac498ae$var$yod = true;
    $61de1ee1cac498ae$var$zod(a);
    $61de1ee1cac498ae$var$Aod(a);
    $61de1ee1cac498ae$var$Tnd(a);
    $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$xFd, $61de1ee1cac498ae$var$yte, a);
    return a;
}
function $61de1ee1cac498ae$var$t3d(a, b, c) {
    var d, e;
    if (a.j == 0) return c;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$LLd(a, b, c), 72);
    d = c.ak();
    if (!d.Ij() || !a.a.rl(d)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Invalid entry feature '" + d.Hj().zb + "." + d.ne() + "'"));
    return e;
}
function $61de1ee1cac498ae$var$Qi(a, b) {
    var c, d, e, f, g, h, i, j;
    for(h = a.a, i = 0, j = h.length; i < j; ++i){
        g = h[i];
        for(d = g, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(c) || b != null && $61de1ee1cac498ae$var$pb(b, c)) return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$qhb(a) {
    var b, c, d;
    if ($61de1ee1cac498ae$var$ybb(a, 0) >= 0) {
        c = $61de1ee1cac498ae$var$Abb(a, $61de1ee1cac498ae$var$Jje);
        d = $61de1ee1cac498ae$var$Hbb(a, $61de1ee1cac498ae$var$Jje);
    } else {
        b = $61de1ee1cac498ae$var$Pbb(a, 1);
        c = $61de1ee1cac498ae$var$Abb(b, 500000000);
        d = $61de1ee1cac498ae$var$Hbb(b, 500000000);
        d = $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Nbb(d, 1), $61de1ee1cac498ae$var$xbb(a, 1));
    }
    return $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$Nbb(d, 32), $61de1ee1cac498ae$var$xbb(c, $61de1ee1cac498ae$var$Yje));
}
function $61de1ee1cac498ae$var$oQb(a, b, c) {
    var d, e;
    d = ($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Nsb(b, b.a.a), 8));
    switch(c.g){
        case 0:
            d.b = 0;
            break;
        case 2:
            d.b = a.f;
            break;
        case 3:
            d.a = 0;
            break;
        default:
            d.a = a.g;
    }
    e = $61de1ee1cac498ae$var$Jsb(b, 0);
    $61de1ee1cac498ae$var$Vsb(e, d);
    return b;
}
function $61de1ee1cac498ae$var$pmc(a, b, c, d) {
    var e, f, g, h, i;
    i = a.b;
    f = b.d;
    g = f.j;
    h = $61de1ee1cac498ae$var$umc(g, i.d[g.g], c);
    e = $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$R6c(f.n), f.a);
    switch(f.j.g){
        case 1:
        case 3:
            h.a += e.a;
            break;
        case 2:
        case 4:
            h.b += e.b;
    }
    $61de1ee1cac498ae$var$Gsb(d, h, d.c.b, d.c);
}
function $61de1ee1cac498ae$var$yJc(a, b, c) {
    var d, e, f, g;
    g = $61de1ee1cac498ae$var$Jkb(a.e, b, 0);
    f = new $61de1ee1cac498ae$var$zJc;
    f.b = c;
    d = new $61de1ee1cac498ae$var$Bib(a.e, g);
    while(d.b < d.d.gc()){
        e = ($61de1ee1cac498ae$var$sCb(d.b < d.d.gc()), $61de1ee1cac498ae$var$BD(d.d.Xb(d.c = d.b++), 10));
        e.p = c;
        $61de1ee1cac498ae$var$Ekb(f.e, e);
        $61de1ee1cac498ae$var$uib(d);
    }
    return f;
}
function $61de1ee1cac498ae$var$sYc(a, b, c, d) {
    var e, f, g, h, i;
    e = null;
    f = 0;
    for(h = new $61de1ee1cac498ae$var$olb(b); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 33);
        i = g.i + g.g;
        if (a < g.j + g.f + d) {
            !e ? e = g : c.i - i < c.i - f && (e = g);
            f = e.i + e.g;
        }
    }
    return !e ? 0 : f + d;
}
function $61de1ee1cac498ae$var$tYc(a, b, c, d) {
    var e, f, g, h, i;
    f = null;
    e = 0;
    for(h = new $61de1ee1cac498ae$var$olb(b); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 33);
        i = g.j + g.f;
        if (a < g.i + g.g + d) {
            !f ? f = g : c.j - i < c.j - e && (f = g);
            e = f.j + f.f;
        }
    }
    return !f ? 0 : e + d;
}
function $61de1ee1cac498ae$var$mA(a) {
    var b, c, d;
    b = false;
    d = a.b.c.length;
    for(c = 0; c < d; c++){
        if ($61de1ee1cac498ae$var$nA($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, c), 434))) {
            if (!b && c + 1 < d && $61de1ee1cac498ae$var$nA($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, c + 1), 434))) {
                b = true;
                $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, c), 434).a = true;
            }
        } else b = false;
    }
}
function $61de1ee1cac498ae$var$Ahb(a, b, c, d, e) {
    var f, g;
    f = 0;
    for(g = 0; g < e; g++){
        f = $61de1ee1cac498ae$var$wbb(f, $61de1ee1cac498ae$var$Qbb($61de1ee1cac498ae$var$xbb(b[g], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(d[g], $61de1ee1cac498ae$var$Yje)));
        a[g] = $61de1ee1cac498ae$var$Tbb(f);
        f = $61de1ee1cac498ae$var$Obb(f, 32);
    }
    for(; g < c; g++){
        f = $61de1ee1cac498ae$var$wbb(f, $61de1ee1cac498ae$var$xbb(b[g], $61de1ee1cac498ae$var$Yje));
        a[g] = $61de1ee1cac498ae$var$Tbb(f);
        f = $61de1ee1cac498ae$var$Obb(f, 32);
    }
}
function $61de1ee1cac498ae$var$Jhb(a, b) {
    $61de1ee1cac498ae$var$Dhb();
    var c, d;
    d = ($61de1ee1cac498ae$var$Hgb(), $61de1ee1cac498ae$var$Cgb);
    c = a;
    for(; b > 1; b >>= 1){
        (b & 1) != 0 && (d = $61de1ee1cac498ae$var$Ogb(d, c));
        c.d == 1 ? c = $61de1ee1cac498ae$var$Ogb(c, c) : c = new $61de1ee1cac498ae$var$Xgb($61de1ee1cac498ae$var$Lhb(c.a, c.d, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, c.d << 1, 15, 1)));
    }
    d = $61de1ee1cac498ae$var$Ogb(d, c);
    return d;
}
function $61de1ee1cac498ae$var$zub() {
    $61de1ee1cac498ae$var$zub = $61de1ee1cac498ae$var$ccb;
    var a, b, c, d;
    $61de1ee1cac498ae$var$wub = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, 25, 15, 1);
    $61de1ee1cac498ae$var$xub = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, 33, 15, 1);
    d = 1.52587890625E-5;
    for(b = 32; b >= 0; b--){
        $61de1ee1cac498ae$var$xub[b] = d;
        d *= 0.5;
    }
    c = 1;
    for(a = 24; a >= 0; a--){
        $61de1ee1cac498ae$var$wub[a] = c;
        c *= 0.5;
    }
}
function $61de1ee1cac498ae$var$S1b(a) {
    var b, c;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$fxc))))) for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 79);
        if ($61de1ee1cac498ae$var$Qld(b)) {
            if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$gxc)))) return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$kjc(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$Qqb(a.f, b)) {
        b.b = a;
        d = b.c;
        $61de1ee1cac498ae$var$Jkb(a.j, d, 0) != -1 || $61de1ee1cac498ae$var$Ekb(a.j, d);
        e = b.d;
        $61de1ee1cac498ae$var$Jkb(a.j, e, 0) != -1 || $61de1ee1cac498ae$var$Ekb(a.j, e);
        c = b.a.b;
        if (c.c.length != 0) {
            !a.i && (a.i = new $61de1ee1cac498ae$var$vjc(a));
            $61de1ee1cac498ae$var$qjc(a.i, c);
        }
    }
}
function $61de1ee1cac498ae$var$rmc(a) {
    var b, c, d, e, f;
    c = a.c.d;
    d = c.j;
    e = a.d.d;
    f = e.j;
    if (d == f) return c.p < e.p ? 0 : 1;
    else if ($61de1ee1cac498ae$var$Xcd(d) == f) return 0;
    else if ($61de1ee1cac498ae$var$Vcd(d) == f) return 1;
    else {
        b = a.b;
        return $61de1ee1cac498ae$var$uqb(b.b, $61de1ee1cac498ae$var$Xcd(d)) ? 0 : 1;
    }
}
function $61de1ee1cac498ae$var$lzc() {
    $61de1ee1cac498ae$var$lzc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$jzc = new $61de1ee1cac498ae$var$nzc($61de1ee1cac498ae$var$Aqe, 0);
    $61de1ee1cac498ae$var$hzc = new $61de1ee1cac498ae$var$nzc("LONGEST_PATH", 1);
    $61de1ee1cac498ae$var$fzc = new $61de1ee1cac498ae$var$nzc("COFFMAN_GRAHAM", 2);
    $61de1ee1cac498ae$var$gzc = new $61de1ee1cac498ae$var$nzc($61de1ee1cac498ae$var$Tne, 3);
    $61de1ee1cac498ae$var$kzc = new $61de1ee1cac498ae$var$nzc("STRETCH_WIDTH", 4);
    $61de1ee1cac498ae$var$izc = new $61de1ee1cac498ae$var$nzc("MIN_WIDTH", 5);
}
function $61de1ee1cac498ae$var$E3c(a) {
    var b;
    this.d = new $61de1ee1cac498ae$var$Lqb;
    this.c = a.c;
    this.e = a.d;
    this.b = a.b;
    this.f = new $61de1ee1cac498ae$var$jgd(a.e);
    this.a = a.a;
    !a.f ? this.g = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$O3), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0)) : this.g = a.f;
}
function $61de1ee1cac498ae$var$grd(a, b) {
    var c, d, e, f, g, h;
    e = a;
    g = $61de1ee1cac498ae$var$$pd(e, "layoutOptions");
    !g && (g = $61de1ee1cac498ae$var$$pd(e, $61de1ee1cac498ae$var$Dte));
    if (g) {
        h = g;
        d = null;
        !!h && (d = (f = $61de1ee1cac498ae$var$$B(h, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, 0, 6, 1)), new $61de1ee1cac498ae$var$mC(h, f)));
        if (d) {
            c = new $61de1ee1cac498ae$var$Drd(h, b);
            $61de1ee1cac498ae$var$reb(d, c);
        }
    }
}
function $61de1ee1cac498ae$var$atd(a) {
    if ($61de1ee1cac498ae$var$JD(a, 239)) return $61de1ee1cac498ae$var$BD(a, 33);
    else if ($61de1ee1cac498ae$var$JD(a, 186)) return $61de1ee1cac498ae$var$mpd($61de1ee1cac498ae$var$BD(a, 118));
    else if (!a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Heb($61de1ee1cac498ae$var$gue));
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb("Only support nodes and ports."));
}
function $61de1ee1cac498ae$var$CA(a, b, c, d) {
    if (b >= 0 && $61de1ee1cac498ae$var$dfb(a.substr(b, 3), "GMT")) {
        c[0] = b + 3;
        return $61de1ee1cac498ae$var$tA(a, c, d);
    }
    if (b >= 0 && $61de1ee1cac498ae$var$dfb(a.substr(b, 3), "UTC")) {
        c[0] = b + 3;
        return $61de1ee1cac498ae$var$tA(a, c, d);
    }
    return $61de1ee1cac498ae$var$tA(a, c, d);
}
function $61de1ee1cac498ae$var$tjc(a, b) {
    var c, d, e, f, g;
    f = a.g.a;
    g = a.g.b;
    for(d = new $61de1ee1cac498ae$var$olb(a.d); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 70);
        e = c.n;
        e.a = f;
        a.i == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? e.b = g + a.j.b - c.o.b : e.b = g;
        $61de1ee1cac498ae$var$P6c(e, b);
        f += c.o.a + a.e;
    }
}
function $61de1ee1cac498ae$var$Odd(a, b, c) {
    if (a.b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("The task is already done."));
    else if (a.p != null) return false;
    else {
        a.p = b;
        a.r = c;
        a.k && (a.o = ($61de1ee1cac498ae$var$Zfb(), $61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Cbb(Date.now()), $61de1ee1cac498ae$var$_ie)));
        return true;
    }
}
function $61de1ee1cac498ae$var$hsd(a) {
    var b, c, d, e, f, g, h;
    h = new $61de1ee1cac498ae$var$eC;
    c = a.tg();
    e = c != null;
    e && $61de1ee1cac498ae$var$Upd(h, $61de1ee1cac498ae$var$Vte, a.tg());
    d = a.ne();
    f = d != null;
    f && $61de1ee1cac498ae$var$Upd(h, $61de1ee1cac498ae$var$fue, a.ne());
    b = a.sg();
    g = b != null;
    g && $61de1ee1cac498ae$var$Upd(h, "description", a.sg());
    return h;
}
function $61de1ee1cac498ae$var$uId(a, b, c) {
    var d, e, f;
    f = a.q;
    a.q = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        e = new $61de1ee1cac498ae$var$nSd(a, 1, 9, f, b);
        !c ? c = e : c.Ei(e);
    }
    if (!b) !!a.r && (c = a.nk(null, c));
    else {
        d = b.c;
        d != a.r && (c = a.nk(d, c));
    }
    return c;
}
function $61de1ee1cac498ae$var$IYd(a, b, c) {
    var d, e, f, g, h;
    c = (h = b, $61de1ee1cac498ae$var$kid(h, a.e, -1 - a.c, c));
    g = $61de1ee1cac498ae$var$AYd(a.a);
    for(f = (d = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(g.a).a), new $61de1ee1cac498ae$var$ZYd(d)); f.a.b;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$lib(f.a).cd(), 87);
        c = $61de1ee1cac498ae$var$QQd(e, $61de1ee1cac498ae$var$MQd(e, a.a), c);
    }
    return c;
}
function $61de1ee1cac498ae$var$JYd(a, b, c) {
    var d, e, f, g, h;
    c = (h = b, $61de1ee1cac498ae$var$lid(h, a.e, -1 - a.c, c));
    g = $61de1ee1cac498ae$var$AYd(a.a);
    for(f = (d = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(g.a).a), new $61de1ee1cac498ae$var$ZYd(d)); f.a.b;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$lib(f.a).cd(), 87);
        c = $61de1ee1cac498ae$var$QQd(e, $61de1ee1cac498ae$var$MQd(e, a.a), c);
    }
    return c;
}
function $61de1ee1cac498ae$var$jhb(a, b, c, d) {
    var e, f, g;
    if (d == 0) $61de1ee1cac498ae$var$$fb(b, 0, a, c, a.length - c);
    else {
        g = 32 - d;
        a[a.length - 1] = 0;
        for(f = a.length - 1; f > c; f--){
            a[f] |= b[f - c - 1] >>> g;
            a[f - 1] = b[f - c - 1] << d;
        }
    }
    for(e = 0; e < c; e++)a[e] = 0;
}
function $61de1ee1cac498ae$var$LJb(a) {
    var b, c, d, e, f;
    b = 0;
    c = 0;
    for(f = a.Kc(); f.Ob();){
        d = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        b = $61de1ee1cac498ae$var$$wnd.Math.max(b, d.d.b);
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, d.d.c);
    }
    for(e = a.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 111);
        d.d.b = b;
        d.d.c = c;
    }
}
function $61de1ee1cac498ae$var$TKb(a) {
    var b, c, d, e, f;
    c = 0;
    b = 0;
    for(f = a.Kc(); f.Ob();){
        d = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, d.d.d);
        b = $61de1ee1cac498ae$var$$wnd.Math.max(b, d.d.a);
    }
    for(e = a.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 111);
        d.d.d = c;
        d.d.a = b;
    }
}
function $61de1ee1cac498ae$var$rpc(a, b) {
    var c, d, e, f;
    f = new $61de1ee1cac498ae$var$Rkb;
    e = 0;
    d = b.Kc();
    while(d.Ob()){
        c = $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD(d.Pb(), 19).a + e);
        while(c.a < a.f && !$61de1ee1cac498ae$var$Voc(a, c.a)){
            c = $61de1ee1cac498ae$var$meb(c.a + 1);
            ++e;
        }
        if (c.a >= a.f) break;
        f.c[f.c.length] = c;
    }
    return f;
}
function $61de1ee1cac498ae$var$sfd(a) {
    var b, c, d, e;
    b = null;
    for(e = new $61de1ee1cac498ae$var$olb(a.wf()); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 181);
        c = new $61de1ee1cac498ae$var$J6c(d.qf().a, d.qf().b, d.rf().a, d.rf().b);
        !b ? b = c : $61de1ee1cac498ae$var$H6c(b, c);
    }
    !b && (b = new $61de1ee1cac498ae$var$I6c);
    return b;
}
function $61de1ee1cac498ae$var$Fkd(a, b, c, d) {
    var e, f;
    if (c == 1) return !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), $61de1ee1cac498ae$var$Sxd(a.n, b, d);
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !e ? a.zh() : e), c), 66), f.Nj().Qj(a, $61de1ee1cac498ae$var$yjd(a), c - $61de1ee1cac498ae$var$aLd(a.zh()), b, d);
}
function $61de1ee1cac498ae$var$iud(a, b, c) {
    var d, e, f, g, h;
    d = c.gc();
    a.qi(a.i + d);
    h = a.i - b;
    h > 0 && $61de1ee1cac498ae$var$$fb(a.g, b, a.g, b + d, h);
    g = c.Kc();
    a.i += d;
    for(e = 0; e < d; ++e){
        f = g.Pb();
        $61de1ee1cac498ae$var$mud(a, b, a.oi(b, f));
        a.bi(b, f);
        a.ci();
        ++b;
    }
    return d != 0;
}
function $61de1ee1cac498ae$var$xId(a, b, c) {
    var d;
    if (b != a.q) {
        !!a.q && (c = $61de1ee1cac498ae$var$lid(a.q, a, -10, c));
        !!b && (c = $61de1ee1cac498ae$var$kid(b, a, -10, c));
        c = $61de1ee1cac498ae$var$uId(a, b, c);
    } else if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        d = new $61de1ee1cac498ae$var$nSd(a, 1, 9, b, b);
        !c ? c = d : c.Ei(d);
    }
    return c;
}
function $61de1ee1cac498ae$var$Yj(a, b, c, d) {
    $61de1ee1cac498ae$var$Mb((c & $61de1ee1cac498ae$var$oie) == 0, "flatMap does not support SUBSIZED characteristic");
    $61de1ee1cac498ae$var$Mb((c & 4) == 0, "flatMap does not support SORTED characteristic");
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Qb(b);
    return new $61de1ee1cac498ae$var$jk(a, c, d, b);
}
function $61de1ee1cac498ae$var$Qy(a, b) {
    $61de1ee1cac498ae$var$vCb(b, "Cannot suppress a null exception.");
    $61de1ee1cac498ae$var$mCb(b != a, "Exception can not suppress itself.");
    if (a.i) return;
    a.k == null ? a.k = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$_I, 1), $61de1ee1cac498ae$var$nie, 78, 0, [
        b
    ]) : a.k[a.k.length] = b;
}
function $61de1ee1cac498ae$var$oA(a, b, c, d) {
    var e, f, g, h, i, j;
    g = c.length;
    f = 0;
    e = -1;
    j = $61de1ee1cac498ae$var$sfb(a.substr(b), ($61de1ee1cac498ae$var$ntb(), $61de1ee1cac498ae$var$ltb));
    for(h = 0; h < g; ++h){
        i = c[h].length;
        if (i > f && $61de1ee1cac498ae$var$nfb(j, $61de1ee1cac498ae$var$sfb(c[h], $61de1ee1cac498ae$var$ltb))) {
            e = h;
            f = i;
        }
    }
    e >= 0 && (d[0] = b + f);
    return e;
}
function $61de1ee1cac498ae$var$MIb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$NIb(a.b.Hf(), b.b.Hf());
    if (c != 0) return c;
    switch(a.b.Hf().g){
        case 1:
        case 2:
            return $61de1ee1cac498ae$var$beb(a.b.sf(), b.b.sf());
        case 3:
        case 4:
            return $61de1ee1cac498ae$var$beb(b.b.sf(), a.b.sf());
    }
    return 0;
}
function $61de1ee1cac498ae$var$iRb(a) {
    var b, c, d;
    d = a.e.c.length;
    a.a = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$WD, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$oje
    ], [
        48,
        25
    ], 15, [
        d,
        d
    ], 2);
    for(c = new $61de1ee1cac498ae$var$olb(a.c); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 282);
        a.a[b.c.b][b.d.b] += $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$oSb)), 19).a;
    }
}
function $61de1ee1cac498ae$var$H1c(a, b, c) {
    $61de1ee1cac498ae$var$Odd(c, "Grow Tree", 1);
    a.b = b.f;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$XNb(), $61de1ee1cac498ae$var$VNb))))) {
        a.c = new $61de1ee1cac498ae$var$tOb;
        $61de1ee1cac498ae$var$D1c(a, null);
    } else a.c = new $61de1ee1cac498ae$var$tOb;
    a.a = false;
    $61de1ee1cac498ae$var$F1c(a, b.f);
    $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$WNb, ($61de1ee1cac498ae$var$Bcb(), a.a ? true : false));
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$Umd(a, b) {
    var c, d, e, f, g;
    if (a == null) return null;
    else {
        g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, 2 * b, 15, 1);
        for(d = 0, e = 0; d < b; ++d){
            c = a[d] >> 4 & 15;
            f = a[d] & 15;
            g[e++] = $61de1ee1cac498ae$var$Qmd[c];
            g[e++] = $61de1ee1cac498ae$var$Qmd[f];
        }
        return $61de1ee1cac498ae$var$zfb(g, 0, g.length);
    }
}
function $61de1ee1cac498ae$var$j3d(a, b, c) {
    var d, e, f;
    d = b.ak();
    f = b.dd();
    e = d.$j() ? $61de1ee1cac498ae$var$H2d(a, 4, d, f, null, $61de1ee1cac498ae$var$M2d(a, d, f, $61de1ee1cac498ae$var$JD(d, 99) && ($61de1ee1cac498ae$var$BD(d, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0), true) : $61de1ee1cac498ae$var$H2d(a, d.Kj() ? 2 : 1, d, f, d.zj(), -1, true);
    c ? c.Ei(e) : c = e;
    return c;
}
function $61de1ee1cac498ae$var$wfb(a) {
    var b, c;
    if (a >= $61de1ee1cac498ae$var$Tje) {
        b = $61de1ee1cac498ae$var$Uje + (a - $61de1ee1cac498ae$var$Tje >> 10 & 1023) & $61de1ee1cac498ae$var$aje;
        c = 56320 + (a - $61de1ee1cac498ae$var$Tje & 1023) & $61de1ee1cac498ae$var$aje;
        return String.fromCharCode(b) + ("" + String.fromCharCode(c));
    } else return String.fromCharCode(a & $61de1ee1cac498ae$var$aje);
}
function $61de1ee1cac498ae$var$bKb(a, b) {
    $61de1ee1cac498ae$var$$Jb();
    var c, d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    if (e.gc() >= 2) {
        d = $61de1ee1cac498ae$var$BD(e.Kc().Pb(), 111);
        c = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$mcd));
        f = a.u.Hc($61de1ee1cac498ae$var$qcd);
        return !d.a && !c && (e.gc() == 2 || f);
    } else return false;
}
function $61de1ee1cac498ae$var$IVc(a, b, c, d, e) {
    var f, g, h;
    f = $61de1ee1cac498ae$var$JVc(a, b, c, d, e);
    h = false;
    while(!f){
        $61de1ee1cac498ae$var$AVc(a, e, true);
        h = true;
        f = $61de1ee1cac498ae$var$JVc(a, b, c, d, e);
    }
    h && $61de1ee1cac498ae$var$AVc(a, e, false);
    g = $61de1ee1cac498ae$var$dVc(e);
    if (g.c.length != 0) {
        !!a.d && a.d.lg(g);
        $61de1ee1cac498ae$var$IVc(a, e, c, d, g);
    }
}
function $61de1ee1cac498ae$var$Mad() {
    $61de1ee1cac498ae$var$Mad = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Kad = new $61de1ee1cac498ae$var$Nad($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$Iad = new $61de1ee1cac498ae$var$Nad("DIRECTED", 1);
    $61de1ee1cac498ae$var$Lad = new $61de1ee1cac498ae$var$Nad("UNDIRECTED", 2);
    $61de1ee1cac498ae$var$Gad = new $61de1ee1cac498ae$var$Nad("ASSOCIATION", 3);
    $61de1ee1cac498ae$var$Jad = new $61de1ee1cac498ae$var$Nad("GENERALIZATION", 4);
    $61de1ee1cac498ae$var$Had = new $61de1ee1cac498ae$var$Nad("DEPENDENCY", 5);
}
function $61de1ee1cac498ae$var$kfd(a, b) {
    var c;
    if (!$61de1ee1cac498ae$var$mpd(a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$Sse));
    c = $61de1ee1cac498ae$var$mpd(a);
    switch(b.g){
        case 1:
            return -(a.j + a.f);
        case 2:
            return a.i - c.g;
        case 3:
            return a.j - c.f;
        case 4:
            return -(a.i + a.g);
    }
    return 0;
}
function $61de1ee1cac498ae$var$cub(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$uCb(b);
    d = a.b.c.length;
    $61de1ee1cac498ae$var$Ekb(a.b, b);
    while(d > 0){
        c = d;
        d = (d - 1) / 2 | 0;
        if (a.a.ue($61de1ee1cac498ae$var$Ikb(a.b, d), b) <= 0) {
            $61de1ee1cac498ae$var$Nkb(a.b, c, b);
            return true;
        }
        $61de1ee1cac498ae$var$Nkb(a.b, c, $61de1ee1cac498ae$var$Ikb(a.b, d));
    }
    $61de1ee1cac498ae$var$Nkb(a.b, d, b);
    return true;
}
function $61de1ee1cac498ae$var$BHb(a, b, c, d) {
    var e, f;
    e = 0;
    if (!c) for(f = 0; f < $61de1ee1cac498ae$var$sHb; f++)e = $61de1ee1cac498ae$var$$wnd.Math.max(e, $61de1ee1cac498ae$var$qHb(a.a[f][b.g], d));
    else e = $61de1ee1cac498ae$var$qHb(a.a[c.g][b.g], d);
    b == ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$eHb) && !!a.b && (e = $61de1ee1cac498ae$var$$wnd.Math.max(e, a.b.a));
    return e;
}
function $61de1ee1cac498ae$var$knc(a, b) {
    var c, d, e, f, g, h;
    e = a.i;
    f = b.i;
    if (!e || !f) return false;
    if (e.i != f.i || e.i == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) || e.i == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)) return false;
    g = e.g.a;
    c = g + e.j.a;
    h = f.g.a;
    d = h + f.j.a;
    return g <= d && c >= h;
}
function $61de1ee1cac498ae$var$Tpd(a, b, c, d) {
    var e;
    e = false;
    if ($61de1ee1cac498ae$var$ND(d)) {
        e = true;
        $61de1ee1cac498ae$var$Upd(b, c, $61de1ee1cac498ae$var$GD(d));
    }
    if (!e) {
        if ($61de1ee1cac498ae$var$KD(d)) {
            e = true;
            $61de1ee1cac498ae$var$Tpd(a, b, c, d);
        }
    }
    if (!e) {
        if ($61de1ee1cac498ae$var$JD(d, 236)) {
            e = true;
            $61de1ee1cac498ae$var$Spd(b, c, $61de1ee1cac498ae$var$BD(d, 236));
        }
    }
    if (!e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$vcb($61de1ee1cac498ae$var$Ute));
}
function $61de1ee1cac498ae$var$W0d(a, b) {
    var c, d, e;
    c = b.Hh(a.a);
    if (c) {
        e = $61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$Sve);
        if (e != null) for(d = 1; d < ($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$K6d).length; ++d){
            if ($61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$K6d[d], e)) return d;
        }
    }
    return 0;
}
function $61de1ee1cac498ae$var$X0d(a, b) {
    var c, d, e;
    c = b.Hh(a.a);
    if (c) {
        e = $61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$Sve);
        if (e != null) for(d = 1; d < ($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$L6d).length; ++d){
            if ($61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$L6d[d], e)) return d;
        }
    }
    return 0;
}
function $61de1ee1cac498ae$var$Ve(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$uCb(b);
    f = a.a.gc();
    if (f < b.gc()) for(c = a.a.ec().Kc(); c.Ob();){
        d = c.Pb();
        b.Hc(d) && c.Qb();
    }
    else for(e = b.Kc(); e.Ob();){
        d = e.Pb();
        a.a.Bc(d);
    }
    return f != a.a.gc();
}
function $61de1ee1cac498ae$var$bYb(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ])));
    b = a.i.d;
    switch(a.j.g){
        case 1:
            c.b -= b.d;
            break;
        case 2:
            c.a += b.c;
            break;
        case 3:
            c.b += b.a;
            break;
        case 4:
            c.a -= b.b;
    }
    return c;
}
function $61de1ee1cac498ae$var$P9b(a) {
    var b;
    b = ($61de1ee1cac498ae$var$I9b(), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17).c.i);
    while(b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)){
        $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Tsc), ($61de1ee1cac498ae$var$Bcb(), true));
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17).c.i;
    }
}
function $61de1ee1cac498ae$var$bIc(a, b, c, d) {
    var e, f, g, h;
    h = $61de1ee1cac498ae$var$CHc(b, d);
    for(g = h.Kc(); g.Ob();){
        e = $61de1ee1cac498ae$var$BD(g.Pb(), 11);
        a.d[e.p] = a.d[e.p] + a.c[c.p];
    }
    h = $61de1ee1cac498ae$var$CHc(c, d);
    for(f = h.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 11);
        a.d[e.p] = a.d[e.p] - a.c[b.p];
    }
}
function $61de1ee1cac498ae$var$Efd(a, b, c) {
    var d, e;
    for(e = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 33);
        $61de1ee1cac498ae$var$bld(d, d.i + b, d.j + c);
    }
    $61de1ee1cac498ae$var$reb((!a.b && (a.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, a, 12, 3)), a.b), new $61de1ee1cac498ae$var$Kfd(b, c));
}
function $61de1ee1cac498ae$var$Mwb(a, b, c, d) {
    var e, f;
    f = b;
    e = f.d == null || a.a.ue(c.d, f.d) > 0 ? 1 : 0;
    while(f.a[e] != c){
        f = f.a[e];
        e = a.a.ue(c.d, f.d) > 0 ? 1 : 0;
    }
    f.a[e] = d;
    d.b = c.b;
    d.a[0] = c.a[0];
    d.a[1] = c.a[1];
    c.a[0] = null;
    c.a[1] = null;
}
function $61de1ee1cac498ae$var$ucd(a) {
    $61de1ee1cac498ae$var$rcd();
    var b, c;
    b = $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$ncd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E1, 1), $61de1ee1cac498ae$var$Kie, 273, 0, [
        $61de1ee1cac498ae$var$pcd
    ]));
    if ($61de1ee1cac498ae$var$Ox($61de1ee1cac498ae$var$Cx(b, a)) > 1) return false;
    c = $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$mcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E1, 1), $61de1ee1cac498ae$var$Kie, 273, 0, [
        $61de1ee1cac498ae$var$lcd,
        $61de1ee1cac498ae$var$qcd
    ]));
    if ($61de1ee1cac498ae$var$Ox($61de1ee1cac498ae$var$Cx(c, a)) > 1) return false;
    return true;
}
function $61de1ee1cac498ae$var$fod(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Phb(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), a);
    $61de1ee1cac498ae$var$JD(c, 498) ? $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$xFd, a, new $61de1ee1cac498ae$var$bUd(this, b)) : $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$xFd, a, this);
    $61de1ee1cac498ae$var$bod(this, b);
    if (b == ($61de1ee1cac498ae$var$LFd(), $61de1ee1cac498ae$var$KFd)) {
        this.wb = $61de1ee1cac498ae$var$BD(this, 1939);
        $61de1ee1cac498ae$var$BD(b, 1941);
    } else this.wb = ($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd);
}
function $61de1ee1cac498ae$var$lZd(b) {
    var c, d, e;
    if (b == null) return null;
    c = null;
    for(d = 0; d < $61de1ee1cac498ae$var$Pmd.length; ++d)try {
        return $61de1ee1cac498ae$var$DQd($61de1ee1cac498ae$var$Pmd[d], b);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 32)) {
            e = a;
            c = e;
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$rFd(c));
}
function $61de1ee1cac498ae$var$Dpb() {
    $61de1ee1cac498ae$var$Dpb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Bpb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ]);
    $61de1ee1cac498ae$var$Cpb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        $61de1ee1cac498ae$var$fje,
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]);
}
function $61de1ee1cac498ae$var$yyb(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$dfb(typeof b, $61de1ee1cac498ae$var$uke) ? null : new $61de1ee1cac498ae$var$iCb;
    if (!b) return;
    $61de1ee1cac498ae$var$$xb();
    c = (d = 900, d >= $61de1ee1cac498ae$var$_ie ? "error" : d >= 900 ? "warn" : d >= 800 ? "info" : "log");
    $61de1ee1cac498ae$var$gCb(c, a.a);
    !!a.b && $61de1ee1cac498ae$var$hCb(b, c, a.b, "Exception: ", true);
}
function $61de1ee1cac498ae$var$vNb(a, b) {
    var c, d;
    d = (!a.q && (a.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Ohb(a.q, b));
    if (d != null) return d;
    c = b.wg();
    $61de1ee1cac498ae$var$JD(c, 4) && (c == null ? (!a.q && (a.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Thb(a.q, b)) : (!a.q && (a.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Rhb(a.q, b, c)), a);
    return c;
}
function $61de1ee1cac498ae$var$qUb() {
    $61de1ee1cac498ae$var$qUb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$lUb = new $61de1ee1cac498ae$var$rUb("P1_CYCLE_BREAKING", 0);
    $61de1ee1cac498ae$var$mUb = new $61de1ee1cac498ae$var$rUb("P2_LAYERING", 1);
    $61de1ee1cac498ae$var$nUb = new $61de1ee1cac498ae$var$rUb("P3_NODE_ORDERING", 2);
    $61de1ee1cac498ae$var$oUb = new $61de1ee1cac498ae$var$rUb("P4_NODE_PLACEMENT", 3);
    $61de1ee1cac498ae$var$pUb = new $61de1ee1cac498ae$var$rUb("P5_EDGE_ROUTING", 4);
}
function $61de1ee1cac498ae$var$SUb(a, b) {
    var c, d, e, f, g;
    e = b == 1 ? $61de1ee1cac498ae$var$KUb : $61de1ee1cac498ae$var$JUb;
    for(d = e.a.ec().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 103);
        for(g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.f.c, c), 21).Kc(); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 46);
            $61de1ee1cac498ae$var$Lkb(a.b.b, f.b);
            $61de1ee1cac498ae$var$Lkb(a.b.a, $61de1ee1cac498ae$var$BD(f.b, 81).d);
        }
    }
}
function $61de1ee1cac498ae$var$IWb(a, b) {
    $61de1ee1cac498ae$var$AWb();
    var c;
    if (a.c == b.c) {
        if (a.b == b.b || $61de1ee1cac498ae$var$pWb(a.b, b.b)) {
            c = $61de1ee1cac498ae$var$mWb(a.b) ? 1 : -1;
            if (a.a && !b.a) return c;
            else if (!a.a && b.a) return -c;
        }
        return $61de1ee1cac498ae$var$beb(a.b.g, b.b.g);
    } else return $61de1ee1cac498ae$var$Kdb(a.c, b.c);
}
function $61de1ee1cac498ae$var$y6b(a, b) {
    var c;
    $61de1ee1cac498ae$var$Odd(b, "Hierarchical port position processing", 1);
    c = a.b;
    c.c.length > 0 && $61de1ee1cac498ae$var$x6b(($61de1ee1cac498ae$var$tCb(0, c.c.length), $61de1ee1cac498ae$var$BD(c.c[0], 29)), a);
    c.c.length > 1 && $61de1ee1cac498ae$var$x6b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c, c.c.length - 1), 29), a);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$RVc(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$CVc(a, b)) return true;
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 33);
        e = $61de1ee1cac498ae$var$hVc(c);
        if ($61de1ee1cac498ae$var$BVc(a, c, e)) return true;
        if ($61de1ee1cac498ae$var$PVc(a, c) - a.g <= a.a) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$d0c() {
    $61de1ee1cac498ae$var$d0c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$c0c = ($61de1ee1cac498ae$var$A0c(), $61de1ee1cac498ae$var$z0c);
    $61de1ee1cac498ae$var$__c = $61de1ee1cac498ae$var$v0c;
    $61de1ee1cac498ae$var$$_c = $61de1ee1cac498ae$var$t0c;
    $61de1ee1cac498ae$var$Y_c = $61de1ee1cac498ae$var$p0c;
    $61de1ee1cac498ae$var$Z_c = $61de1ee1cac498ae$var$r0c;
    $61de1ee1cac498ae$var$X_c = new $61de1ee1cac498ae$var$q0b(8);
    $61de1ee1cac498ae$var$W_c = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c), $61de1ee1cac498ae$var$X_c);
    $61de1ee1cac498ae$var$a0c = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$T9c, 8);
    $61de1ee1cac498ae$var$b0c = $61de1ee1cac498ae$var$x0c;
    $61de1ee1cac498ae$var$T_c = $61de1ee1cac498ae$var$k0c;
    $61de1ee1cac498ae$var$U_c = $61de1ee1cac498ae$var$m0c;
    $61de1ee1cac498ae$var$V_c = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$y8c, ($61de1ee1cac498ae$var$Bcb(), false));
}
function $61de1ee1cac498ae$var$X7c() {
    $61de1ee1cac498ae$var$X7c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$U7c = new $61de1ee1cac498ae$var$q0b(15);
    $61de1ee1cac498ae$var$T7c = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c), $61de1ee1cac498ae$var$U7c);
    $61de1ee1cac498ae$var$W7c = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$T9c, 15);
    $61de1ee1cac498ae$var$V7c = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$D9c, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$O7c = $61de1ee1cac498ae$var$I8c;
    $61de1ee1cac498ae$var$Q7c = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$S7c = $61de1ee1cac498ae$var$b9c;
    $61de1ee1cac498ae$var$L7c = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$r8c, $61de1ee1cac498ae$var$pse);
    $61de1ee1cac498ae$var$P7c = $61de1ee1cac498ae$var$O8c;
    $61de1ee1cac498ae$var$R7c = $61de1ee1cac498ae$var$_8c;
    $61de1ee1cac498ae$var$M7c = $61de1ee1cac498ae$var$t8c;
    $61de1ee1cac498ae$var$N7c = $61de1ee1cac498ae$var$w8c;
}
function $61de1ee1cac498ae$var$jtd(a) {
    if ((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c).i != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$iue));
    return $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82));
}
function $61de1ee1cac498ae$var$ktd(a) {
    if ((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c).i != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$iue));
    return $61de1ee1cac498ae$var$btd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82));
}
function $61de1ee1cac498ae$var$mtd(a) {
    if ((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c).i != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$iue));
    return $61de1ee1cac498ae$var$btd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c), 0), 82));
}
function $61de1ee1cac498ae$var$ltd(a) {
    if ((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i != 1 || (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c).i != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$iue));
    return $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c), 0), 82));
}
function $61de1ee1cac498ae$var$Dvd(a, b, c) {
    var d, e, f;
    ++a.j;
    e = a.Vi();
    if (b >= e || b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$lue + b + $61de1ee1cac498ae$var$mue + e));
    if (c >= e || c < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$nue + c + $61de1ee1cac498ae$var$mue + e));
    b != c ? d = (f = a.Ti(c), a.Hi(b, f), f) : d = a.Oi(c);
    return d;
}
function $61de1ee1cac498ae$var$m6d(a) {
    var b, c, d;
    d = a;
    if (a) {
        b = 0;
        for(c = a.Ug(); c; c = c.Ug()){
            if (++b > $61de1ee1cac498ae$var$Wje) return $61de1ee1cac498ae$var$m6d(c);
            d = c;
            if (c == a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("There is a cycle in the containment hierarchy of " + a));
        }
    }
    return d;
}
function $61de1ee1cac498ae$var$Fe(a) {
    var b, c, d;
    d = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a.Kc(); c.Ob();){
        b = c.Pb();
        $61de1ee1cac498ae$var$uwb(d, $61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(a) ? "(this Collection)" : b == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(b));
    }
    return !d.a ? d.c : d.e.length == 0 ? d.a.a : d.a.a + ("" + d.e);
}
function $61de1ee1cac498ae$var$CVc(a, b) {
    var c, d;
    d = false;
    if (b.gc() < 2) return false;
    for(c = 0; c < b.gc(); c++)c < b.gc() - 1 ? d = d | $61de1ee1cac498ae$var$BVc(a, $61de1ee1cac498ae$var$BD(b.Xb(c), 33), $61de1ee1cac498ae$var$BD(b.Xb(c + 1), 33)) : d = d | $61de1ee1cac498ae$var$BVc(a, $61de1ee1cac498ae$var$BD(b.Xb(c), 33), $61de1ee1cac498ae$var$BD(b.Xb(0), 33));
    return d;
}
function $61de1ee1cac498ae$var$Ymd(a, b) {
    var c;
    if (b != a.a) {
        c = null;
        !!a.a && (c = $61de1ee1cac498ae$var$BD(a.a, 49).ih(a, 4, $61de1ee1cac498ae$var$o5, c));
        !!b && (c = $61de1ee1cac498ae$var$BD(b, 49).gh(a, 4, $61de1ee1cac498ae$var$o5, c));
        c = $61de1ee1cac498ae$var$Tmd(a, b, c);
        !!c && c.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 1, b, b));
}
function $61de1ee1cac498ae$var$RQd(a, b) {
    var c;
    if (b != a.e) {
        !!a.e && $61de1ee1cac498ae$var$QYd($61de1ee1cac498ae$var$AYd(a.e), a);
        !!b && (!b.b && (b.b = new $61de1ee1cac498ae$var$RYd(new $61de1ee1cac498ae$var$NYd)), $61de1ee1cac498ae$var$PYd(b.b, a));
        c = $61de1ee1cac498ae$var$HQd(a, b, null);
        !!c && c.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 4, b, b));
}
function $61de1ee1cac498ae$var$ufb(a) {
    var b, c, d;
    c = a.length;
    d = 0;
    while(d < c && ($61de1ee1cac498ae$var$BCb(d, a.length), a.charCodeAt(d) <= 32))++d;
    b = c;
    while(b > d && ($61de1ee1cac498ae$var$BCb(b - 1, a.length), a.charCodeAt(b - 1) <= 32))--b;
    return d > 0 || b < c ? a.substr(d, b - d) : a;
}
function $61de1ee1cac498ae$var$ujc(a, b) {
    var c;
    c = b.o;
    if ($61de1ee1cac498ae$var$fad(a.f)) {
        a.j.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.j.a, c.a);
        a.j.b += c.b;
        a.d.c.length > 1 && (a.j.b += a.e);
    } else {
        a.j.a += c.a;
        a.j.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.j.b, c.b);
        a.d.c.length > 1 && (a.j.a += a.e);
    }
}
function $61de1ee1cac498ae$var$gkc() {
    $61de1ee1cac498ae$var$gkc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$dkc = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd),
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd
    ]);
    $61de1ee1cac498ae$var$ckc = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ]);
    $61de1ee1cac498ae$var$ekc = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd,
        $61de1ee1cac498ae$var$Acd
    ]);
    $61de1ee1cac498ae$var$fkc = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Tcd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd
    ]);
}
function $61de1ee1cac498ae$var$omc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    g = a.c.d;
    h = a.d.d;
    if (g.j == h.j) return;
    k = a.b;
    e = g.j;
    i = null;
    while(e != h.j){
        i = b == 0 ? $61de1ee1cac498ae$var$Xcd(e) : $61de1ee1cac498ae$var$Vcd(e);
        f = $61de1ee1cac498ae$var$umc(e, k.d[e.g], c);
        j = $61de1ee1cac498ae$var$umc(i, k.d[i.g], c);
        $61de1ee1cac498ae$var$Dsb(d, $61de1ee1cac498ae$var$P6c(f, j));
        e = i;
    }
}
function $61de1ee1cac498ae$var$oFc(a, b, c, d) {
    var e, f, g, h, i;
    g = $61de1ee1cac498ae$var$JHc(a.a, b, c);
    h = $61de1ee1cac498ae$var$BD(g.a, 19).a;
    f = $61de1ee1cac498ae$var$BD(g.b, 19).a;
    if (d) {
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$gtc), 10);
        if (!!i && !!e) {
            $61de1ee1cac498ae$var$mic(a.b, i, e);
            h += a.b.i;
            f += a.b.e;
        }
    }
    return h > f;
}
function $61de1ee1cac498ae$var$oHc(a) {
    var b, c, d, e, f, g, h, i, j;
    this.a = $61de1ee1cac498ae$var$lHc(a);
    this.b = new $61de1ee1cac498ae$var$Rkb;
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        f = new $61de1ee1cac498ae$var$Rkb;
        $61de1ee1cac498ae$var$Ekb(this.b, f);
        for(h = b, i = 0, j = h.length; i < j; ++i){
            g = h[i];
            $61de1ee1cac498ae$var$Ekb(f, new $61de1ee1cac498ae$var$Tkb(g.j));
        }
    }
}
function $61de1ee1cac498ae$var$qHc(a, b, c) {
    var d, e, f;
    f = 0;
    d = c[b];
    if (b < c.length - 1) {
        e = c[b + 1];
        if (a.b[b]) {
            f = $61de1ee1cac498ae$var$KIc(a.d, d, e);
            f += $61de1ee1cac498ae$var$NHc(a.a, d, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            f += $61de1ee1cac498ae$var$NHc(a.a, e, $61de1ee1cac498ae$var$Tcd);
        } else f = $61de1ee1cac498ae$var$IHc(a.a, d, e);
    }
    a.c[b] && (f += $61de1ee1cac498ae$var$PHc(a.a, d));
    return f;
}
function $61de1ee1cac498ae$var$jZb(a, b, c, d, e) {
    var f, g, h, i;
    i = null;
    for(h = new $61de1ee1cac498ae$var$olb(d); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 441);
        if (g != c && $61de1ee1cac498ae$var$Jkb(g.e, e, 0) != -1) {
            i = g;
            break;
        }
    }
    f = $61de1ee1cac498ae$var$kZb(e);
    $61de1ee1cac498ae$var$QZb(f, c.b);
    $61de1ee1cac498ae$var$RZb(f, i.b);
    $61de1ee1cac498ae$var$Rc(a.a, e, new $61de1ee1cac498ae$var$BZb(f, b, c.f));
}
function $61de1ee1cac498ae$var$nic(a) {
    while(a.g.c != 0 && a.d.c != 0){
        if ($61de1ee1cac498ae$var$wic(a.g).c > $61de1ee1cac498ae$var$wic(a.d).c) {
            a.i += a.g.c;
            $61de1ee1cac498ae$var$yic(a.d);
        } else if ($61de1ee1cac498ae$var$wic(a.d).c > $61de1ee1cac498ae$var$wic(a.g).c) {
            a.e += a.d.c;
            $61de1ee1cac498ae$var$yic(a.g);
        } else {
            a.i += $61de1ee1cac498ae$var$vic(a.g);
            a.e += $61de1ee1cac498ae$var$vic(a.d);
            $61de1ee1cac498ae$var$yic(a.g);
            $61de1ee1cac498ae$var$yic(a.d);
        }
    }
}
function $61de1ee1cac498ae$var$XOc(a, b, c) {
    var d, e, f, g;
    f = b.q;
    g = b.r;
    new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc), b, f, 1);
    new $61de1ee1cac498ae$var$DOc($61de1ee1cac498ae$var$FOc, f, g, 1);
    for(e = new $61de1ee1cac498ae$var$olb(c); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 112);
        if (d != f && d != b && d != g) {
            $61de1ee1cac498ae$var$pPc(a.a, d, b);
            $61de1ee1cac498ae$var$pPc(a.a, d, g);
        }
    }
}
function $61de1ee1cac498ae$var$XQc(a, b, c, d) {
    a.a.d = $61de1ee1cac498ae$var$$wnd.Math.min(b, c);
    a.a.a = $61de1ee1cac498ae$var$$wnd.Math.max(b, d) - a.a.d;
    if (b < c) {
        a.b = 0.5 * (b + c);
        a.g = $61de1ee1cac498ae$var$Qqe * a.b + 0.9 * b;
        a.f = $61de1ee1cac498ae$var$Qqe * a.b + 0.9 * c;
    } else {
        a.b = 0.5 * (b + d);
        a.g = $61de1ee1cac498ae$var$Qqe * a.b + 0.9 * d;
        a.f = $61de1ee1cac498ae$var$Qqe * a.b + 0.9 * b;
    }
}
function $61de1ee1cac498ae$var$acb() {
    $61de1ee1cac498ae$var$_bb = {};
    !Array.isArray && (Array.isArray = function(a) {
        return Object.prototype.toString.call(a) === "[object Array]";
    });
    function b() {
        return (new Date).getTime();
    }
    !Date.now && (Date.now = b);
}
function $61de1ee1cac498ae$var$$Tb(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$dtc), d);
    c = b.e;
    !!c && ($61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.a, 16)), new $61de1ee1cac498ae$var$dUb(a)), $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.b, 16)), new $61de1ee1cac498ae$var$fUb), new $61de1ee1cac498ae$var$hUb(a)));
}
function $61de1ee1cac498ae$var$_$b(a) {
    var b, c, d, e;
    if ($61de1ee1cac498ae$var$gad($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lwc)), 103))) return 0;
    b = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
        if (c.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) {
            e = c.o.a;
            b = $61de1ee1cac498ae$var$$wnd.Math.max(b, e);
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$c5b(a) {
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163).g){
        case 1:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ztc));
            break;
        case 2:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$Atc));
            break;
        case 3:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$xtc));
            break;
        case 4:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc));
    }
}
function $61de1ee1cac498ae$var$yrc() {
    $61de1ee1cac498ae$var$yrc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$wrc = new $61de1ee1cac498ae$var$zrc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$trc = new $61de1ee1cac498ae$var$zrc($61de1ee1cac498ae$var$jle, 1);
    $61de1ee1cac498ae$var$xrc = new $61de1ee1cac498ae$var$zrc($61de1ee1cac498ae$var$kle, 2);
    $61de1ee1cac498ae$var$vrc = new $61de1ee1cac498ae$var$zrc("LEFT_RIGHT_CONSTRAINT_LOCKING", 3);
    $61de1ee1cac498ae$var$urc = new $61de1ee1cac498ae$var$zrc("LEFT_RIGHT_CONNECTION_LOCKING", 4);
    $61de1ee1cac498ae$var$rrc = new $61de1ee1cac498ae$var$zrc($61de1ee1cac498ae$var$Vne, 5);
}
function $61de1ee1cac498ae$var$qRc(a, b, c) {
    var d, e, f, g, h, i, j;
    h = c.a / 2;
    f = c.b / 2;
    d = $61de1ee1cac498ae$var$$wnd.Math.abs(b.a - a.a);
    e = $61de1ee1cac498ae$var$$wnd.Math.abs(b.b - a.b);
    i = 1;
    j = 1;
    d > h && (i = h / d);
    e > f && (j = f / e);
    g = $61de1ee1cac498ae$var$$wnd.Math.min(i, j);
    a.a += g * (b.a - a.a);
    a.b += g * (b.b - a.b);
}
function $61de1ee1cac498ae$var$sZc(a, b, c, d, e) {
    var f, g;
    g = false;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.b, 0), 33);
    while($61de1ee1cac498ae$var$yZc(a, b, f, d, e)){
        g = true;
        $61de1ee1cac498ae$var$NZc(c, f);
        if (c.b.c.length == 0) break;
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.b, 0), 33);
    }
    c.b.c.length == 0 && $61de1ee1cac498ae$var$v$c(c.j, c);
    g && $61de1ee1cac498ae$var$a$c(b.q);
    return g;
}
function $61de1ee1cac498ae$var$t6c(a, b) {
    $61de1ee1cac498ae$var$i6c();
    var c, d, e, f;
    if (b.b < 2) return false;
    f = $61de1ee1cac498ae$var$Jsb(b, 0);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 8);
    d = c;
    while(f.b != f.d.c){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 8);
        if ($61de1ee1cac498ae$var$s6c(a, d, e)) return true;
        d = e;
    }
    if ($61de1ee1cac498ae$var$s6c(a, d, c)) return true;
    return false;
}
function $61de1ee1cac498ae$var$ckd(a, b, c, d) {
    var e, f;
    if (c == 0) return !a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$bId(a.o, b, d);
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a, 16), 26), !e ? a.zh() : e), c), 66), f.Nj().Rj(a, $61de1ee1cac498ae$var$yjd(a), c - $61de1ee1cac498ae$var$aLd(a.zh()), b, d);
}
function $61de1ee1cac498ae$var$bod(a, b) {
    var c;
    if (b != a.sb) {
        c = null;
        !!a.sb && (c = $61de1ee1cac498ae$var$BD(a.sb, 49).ih(a, 1, $61de1ee1cac498ae$var$i5, c));
        !!b && (c = $61de1ee1cac498ae$var$BD(b, 49).gh(a, 1, $61de1ee1cac498ae$var$i5, c));
        c = $61de1ee1cac498ae$var$Jnd(a, b, c);
        !!c && c.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 4, b, b));
}
function $61de1ee1cac498ae$var$yqd(a, b) {
    var c, d, e, f;
    if (b) {
        e = $61de1ee1cac498ae$var$Xpd(b, "x");
        c = new $61de1ee1cac498ae$var$zrd(a);
        $61de1ee1cac498ae$var$hmd(c.a, ($61de1ee1cac498ae$var$uCb(e), e));
        f = $61de1ee1cac498ae$var$Xpd(b, "y");
        d = new $61de1ee1cac498ae$var$Ard(a);
        $61de1ee1cac498ae$var$imd(d.a, ($61de1ee1cac498ae$var$uCb(f), f));
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("All edge sections need an end point."));
}
function $61de1ee1cac498ae$var$wqd(a, b) {
    var c, d, e, f;
    if (b) {
        e = $61de1ee1cac498ae$var$Xpd(b, "x");
        c = new $61de1ee1cac498ae$var$wrd(a);
        $61de1ee1cac498ae$var$omd(c.a, ($61de1ee1cac498ae$var$uCb(e), e));
        f = $61de1ee1cac498ae$var$Xpd(b, "y");
        d = new $61de1ee1cac498ae$var$xrd(a);
        $61de1ee1cac498ae$var$pmd(d.a, ($61de1ee1cac498ae$var$uCb(f), f));
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("All edge sections need a start point."));
}
function $61de1ee1cac498ae$var$pyb(a, b) {
    var c, d, e, f, g, h, i;
    for(d = $61de1ee1cac498ae$var$syb(a), f = 0, h = d.length; f < h; ++f)$61de1ee1cac498ae$var$yyb(b);
    i = !$61de1ee1cac498ae$var$lyb && a.e ? $61de1ee1cac498ae$var$lyb ? null : a.d : null;
    while(i){
        for(c = $61de1ee1cac498ae$var$syb(i), e = 0, g = c.length; e < g; ++e)$61de1ee1cac498ae$var$yyb(b);
        i = !$61de1ee1cac498ae$var$lyb && i.e ? $61de1ee1cac498ae$var$lyb ? null : i.d : null;
    }
}
function $61de1ee1cac498ae$var$j0b() {
    $61de1ee1cac498ae$var$j0b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$h0b = new $61de1ee1cac498ae$var$k0b("NORMAL", 0);
    $61de1ee1cac498ae$var$g0b = new $61de1ee1cac498ae$var$k0b("LONG_EDGE", 1);
    $61de1ee1cac498ae$var$e0b = new $61de1ee1cac498ae$var$k0b("EXTERNAL_PORT", 2);
    $61de1ee1cac498ae$var$i0b = new $61de1ee1cac498ae$var$k0b("NORTH_SOUTH_PORT", 3);
    $61de1ee1cac498ae$var$f0b = new $61de1ee1cac498ae$var$k0b("LABEL", 4);
    $61de1ee1cac498ae$var$d0b = new $61de1ee1cac498ae$var$k0b("BREAKING_POINT", 5);
}
function $61de1ee1cac498ae$var$g4b(a) {
    var b, c, d, e;
    b = false;
    if ($61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Csc))) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Csc), 83);
        for(e = new $61de1ee1cac498ae$var$olb(a.j); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 11);
            if ($61de1ee1cac498ae$var$e4b(d)) {
                if (!b) {
                    $61de1ee1cac498ae$var$d4b($61de1ee1cac498ae$var$Q_b(a));
                    b = true;
                }
                $61de1ee1cac498ae$var$h4b($61de1ee1cac498ae$var$BD(c.xc(d), 306));
            }
        }
    }
}
function $61de1ee1cac498ae$var$qec(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$Odd(c, "Self-Loop routing", 1);
    d = $61de1ee1cac498ae$var$rec(b);
    $61de1ee1cac498ae$var$RD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$g6c(), $61de1ee1cac498ae$var$f6c)));
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.b, 16)), new $61de1ee1cac498ae$var$uec), new $61de1ee1cac498ae$var$wec), new $61de1ee1cac498ae$var$yec), new $61de1ee1cac498ae$var$Aec), new $61de1ee1cac498ae$var$Cec(a, d));
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$gsd(a) {
    var b, c, d, e, f, g, h, i, j;
    j = $61de1ee1cac498ae$var$hsd(a);
    c = a.e;
    f = c != null;
    f && $61de1ee1cac498ae$var$Upd(j, $61de1ee1cac498ae$var$eue, a.e);
    h = a.k;
    g = !!h;
    g && $61de1ee1cac498ae$var$Upd(j, "type", $61de1ee1cac498ae$var$Zr(a.k));
    d = $61de1ee1cac498ae$var$Fhe(a.j);
    e = !d;
    if (e) {
        i = new $61de1ee1cac498ae$var$wB;
        $61de1ee1cac498ae$var$cC(j, $61de1ee1cac498ae$var$Mte, i);
        b = new $61de1ee1cac498ae$var$ssd(i);
        $61de1ee1cac498ae$var$reb(a.j, b);
    }
    return j;
}
function $61de1ee1cac498ae$var$Jv(a) {
    var b, c, d, e;
    e = $61de1ee1cac498ae$var$Kfb(($61de1ee1cac498ae$var$Xj(a.gc(), "size"), new $61de1ee1cac498ae$var$Vfb), 123);
    d = true;
    for(c = $61de1ee1cac498ae$var$Wm(a).Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 42);
        d || (e.a += $61de1ee1cac498ae$var$She, e);
        d = false;
        $61de1ee1cac498ae$var$Pfb($61de1ee1cac498ae$var$Kfb($61de1ee1cac498ae$var$Pfb(e, b.cd()), 61), b.dd());
    }
    return (e.a += "}", e).a;
}
function $61de1ee1cac498ae$var$kD(a, b) {
    var c, d, e;
    b &= 63;
    if (b < 22) {
        c = a.l << b;
        d = a.m << b | a.l >> 22 - b;
        e = a.h << b | a.m >> 22 - b;
    } else if (b < 44) {
        c = 0;
        d = a.l << b - 22;
        e = a.m << b - 22 | a.l >> 44 - b;
    } else {
        c = 0;
        d = 0;
        e = a.l << b - 44;
    }
    return $61de1ee1cac498ae$var$TC(c & $61de1ee1cac498ae$var$Eje, d & $61de1ee1cac498ae$var$Eje, e & $61de1ee1cac498ae$var$Fje);
}
function $61de1ee1cac498ae$var$Hcb(a) {
    $61de1ee1cac498ae$var$Gcb == null && ($61de1ee1cac498ae$var$Gcb = new RegExp("^\\s*[+-]?(NaN|Infinity|((\\d+\\.?\\d*)|(\\.\\d+))([eE][+-]?\\d+)?[dDfF]?)\\s*$"));
    if (!$61de1ee1cac498ae$var$Gcb.test(a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + a + '"'));
    return parseFloat(a);
}
function $61de1ee1cac498ae$var$IFb(a) {
    var b, c, d, e;
    b = new $61de1ee1cac498ae$var$Rkb;
    c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, a.a.c.length, 16, 1);
    $61de1ee1cac498ae$var$Glb(c, c.length);
    for(e = new $61de1ee1cac498ae$var$olb(a.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 121);
        if (!c[d.d]) {
            b.c[b.c.length] = d;
            $61de1ee1cac498ae$var$HFb(a, d, c);
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$Nmc(a, b) {
    var c, d, e, f;
    f = b.b.j;
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, f.c.length, 15, 1);
    e = 0;
    for(d = 0; d < f.c.length; d++){
        c = ($61de1ee1cac498ae$var$tCb(d, f.c.length), $61de1ee1cac498ae$var$BD(f.c[d], 11));
        c.e.c.length == 0 && c.g.c.length == 0 ? e += 1 : e += 3;
        a.a[d] = e;
    }
}
function $61de1ee1cac498ae$var$Sqc() {
    $61de1ee1cac498ae$var$Sqc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Nqc = new $61de1ee1cac498ae$var$Uqc("ALWAYS_UP", 0);
    $61de1ee1cac498ae$var$Mqc = new $61de1ee1cac498ae$var$Uqc("ALWAYS_DOWN", 1);
    $61de1ee1cac498ae$var$Pqc = new $61de1ee1cac498ae$var$Uqc("DIRECTION_UP", 2);
    $61de1ee1cac498ae$var$Oqc = new $61de1ee1cac498ae$var$Uqc("DIRECTION_DOWN", 3);
    $61de1ee1cac498ae$var$Rqc = new $61de1ee1cac498ae$var$Uqc("SMART_UP", 4);
    $61de1ee1cac498ae$var$Qqc = new $61de1ee1cac498ae$var$Uqc("SMART_DOWN", 5);
}
function $61de1ee1cac498ae$var$k6c(a, b) {
    if (a < 0 || b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("k and n must be positive"));
    else if (b > a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("k must be smaller than n"));
    else return b == 0 || b == a ? 1 : a == 0 ? 0 : $61de1ee1cac498ae$var$q6c(a) / ($61de1ee1cac498ae$var$q6c(b) * $61de1ee1cac498ae$var$q6c(a - b));
}
function $61de1ee1cac498ae$var$jfd(a, b) {
    var c, d, e, f;
    c = new $61de1ee1cac498ae$var$_ud(a);
    while(c.g == null && !c.c ? $61de1ee1cac498ae$var$Uud(c) : c.g == null || c.i != 0 && $61de1ee1cac498ae$var$BD(c.g[c.i - 1], 47).Ob()){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Vud(c), 56);
        if ($61de1ee1cac498ae$var$JD(f, 160)) {
            d = $61de1ee1cac498ae$var$BD(f, 160);
            for(e = 0; e < b.length; e++)b[e].og(d);
        }
    }
}
function $61de1ee1cac498ae$var$fld(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$Mkd(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Mkd(a));
    b.a += " (height: ";
    $61de1ee1cac498ae$var$Bfb(b, a.f);
    b.a += ", width: ";
    $61de1ee1cac498ae$var$Bfb(b, a.g);
    b.a += ", x: ";
    $61de1ee1cac498ae$var$Bfb(b, a.i);
    b.a += ", y: ";
    $61de1ee1cac498ae$var$Bfb(b, a.j);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$un(a) {
    var b, c, d, e, f, g, h;
    b = new $61de1ee1cac498ae$var$$rb;
    for(d = a, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        g = $61de1ee1cac498ae$var$Qb(c.cd());
        h = $61de1ee1cac498ae$var$Xrb(b, g, $61de1ee1cac498ae$var$Qb(c.dd()));
        if (h != null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("duplicate key: " + g));
    }
    this.b = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$iob(b));
}
function $61de1ee1cac498ae$var$Rlb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        $61de1ee1cac498ae$var$uwb(f, String.fromCharCode(b));
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$SRb() {
    $61de1ee1cac498ae$var$SRb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$MRb = ($61de1ee1cac498ae$var$XRb(), $61de1ee1cac498ae$var$WRb);
    $61de1ee1cac498ae$var$LRb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$mme, $61de1ee1cac498ae$var$MRb);
    $61de1ee1cac498ae$var$meb(1);
    $61de1ee1cac498ae$var$KRb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$nme, $61de1ee1cac498ae$var$meb(300));
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$PRb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ome, $61de1ee1cac498ae$var$meb(0));
    new $61de1ee1cac498ae$var$Tfd;
    $61de1ee1cac498ae$var$QRb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$pme, $61de1ee1cac498ae$var$qme);
    new $61de1ee1cac498ae$var$Tfd;
    $61de1ee1cac498ae$var$NRb = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$rme, 5);
    $61de1ee1cac498ae$var$RRb = $61de1ee1cac498ae$var$WRb;
    $61de1ee1cac498ae$var$ORb = $61de1ee1cac498ae$var$VRb;
}
function $61de1ee1cac498ae$var$NUb(a, b) {
    var c, d, e, f, g;
    e = b == 1 ? $61de1ee1cac498ae$var$KUb : $61de1ee1cac498ae$var$JUb;
    for(d = e.a.ec().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 103);
        for(g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.f.c, c), 21).Kc(); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 46);
            $61de1ee1cac498ae$var$Ekb(a.b.b, $61de1ee1cac498ae$var$BD(f.b, 81));
            $61de1ee1cac498ae$var$Ekb(a.b.a, $61de1ee1cac498ae$var$BD(f.b, 81).d);
        }
    }
}
function $61de1ee1cac498ae$var$kVd(a, b) {
    var c;
    if (b != null && !a.c.Yj().wj(b)) {
        c = $61de1ee1cac498ae$var$JD(b, 56) ? $61de1ee1cac498ae$var$BD(b, 56).Tg().zb : $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$rb(b));
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cdb($61de1ee1cac498ae$var$ite + a.c.ne() + "'s type '" + a.c.Yj().ne() + "' does not permit a value of type '" + c + "'"));
    }
}
function $61de1ee1cac498ae$var$cZb(a, b, c) {
    var d, e;
    e = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    while(e.b < e.d.gc()){
        d = ($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), $61de1ee1cac498ae$var$BD(e.d.Xb(e.c = e.b++), 70));
        if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$btc))) !== $61de1ee1cac498ae$var$PD(b)) continue;
        $61de1ee1cac498ae$var$Y$b(d.n, $61de1ee1cac498ae$var$Q_b(a.c.i), c);
        $61de1ee1cac498ae$var$uib(e);
        $61de1ee1cac498ae$var$Ekb(b.b, d);
    }
}
function $61de1ee1cac498ae$var$vdc(a, b) {
    if (b.a) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$dtc)), 98).g){
        case 0:
        case 1:
            $61de1ee1cac498ae$var$llc(b);
        case 2:
            $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.d, 16)), new $61de1ee1cac498ae$var$Idc);
            $61de1ee1cac498ae$var$wkc(a.a, b);
    }
    else $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.d, 16)), new $61de1ee1cac498ae$var$Idc);
}
function $61de1ee1cac498ae$var$Znc(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$$wnd.Math.sqrt((a.k == null && (a.k = $61de1ee1cac498ae$var$Soc(a, new $61de1ee1cac498ae$var$bpc)), $61de1ee1cac498ae$var$Edb(a.k) / (a.b * (a.g == null && (a.g = $61de1ee1cac498ae$var$Poc(a, new $61de1ee1cac498ae$var$_oc)), $61de1ee1cac498ae$var$Edb(a.g)))));
    b = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$$wnd.Math.round(c)));
    b = $61de1ee1cac498ae$var$$wnd.Math.min(b, a.f);
    return b;
}
function $61de1ee1cac498ae$var$H0b() {
    $61de1ee1cac498ae$var$z0b();
    $61de1ee1cac498ae$var$n_b.call(this);
    this.j = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd);
    this.a = new $61de1ee1cac498ae$var$d7c;
    new $61de1ee1cac498ae$var$L_b;
    this.f = ($61de1ee1cac498ae$var$Xj(2, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(2));
    this.e = ($61de1ee1cac498ae$var$Xj(4, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(4));
    this.g = ($61de1ee1cac498ae$var$Xj(4, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(4));
    this.b = new $61de1ee1cac498ae$var$Z0b(this.e, this.g);
}
function $61de1ee1cac498ae$var$j3b(a, b) {
    var c, d;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc))))) return false;
    d = b.c.i;
    if (a == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$xtc)) {
        if (d.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) return false;
    }
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163);
    if (c == $61de1ee1cac498ae$var$ytc) return false;
    return true;
}
function $61de1ee1cac498ae$var$k3b(a, b) {
    var c, d;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc))))) return false;
    d = b.d.i;
    if (a == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ztc)) {
        if (d.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) return false;
    }
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163);
    if (c == $61de1ee1cac498ae$var$Atc) return false;
    return true;
}
function $61de1ee1cac498ae$var$L3b(a, b) {
    var c, d, e, f, g, h, i;
    g = a.d;
    i = a.o;
    h = new $61de1ee1cac498ae$var$J6c(-g.b, -g.d, g.b + i.a + g.c, g.d + i.b + g.a);
    for(d = b, e = 0, f = d.length; e < f; ++e){
        c = d[e];
        !!c && $61de1ee1cac498ae$var$H6c(h, c.i);
    }
    g.b = -h.c;
    g.d = -h.d;
    g.c = h.b - g.b - i.a;
    g.a = h.a - g.d - i.b;
}
function $61de1ee1cac498ae$var$N_c() {
    $61de1ee1cac498ae$var$N_c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$I_c = new $61de1ee1cac498ae$var$O_c("CENTER_DISTANCE", 0);
    $61de1ee1cac498ae$var$J_c = new $61de1ee1cac498ae$var$O_c("CIRCLE_UNDERLAP", 1);
    $61de1ee1cac498ae$var$M_c = new $61de1ee1cac498ae$var$O_c("RECTANGLE_UNDERLAP", 2);
    $61de1ee1cac498ae$var$K_c = new $61de1ee1cac498ae$var$O_c("INVERTED_OVERLAP", 3);
    $61de1ee1cac498ae$var$L_c = new $61de1ee1cac498ae$var$O_c("MINIMUM_ROOT_DISTANCE", 4);
}
function $61de1ee1cac498ae$var$jde(a) {
    $61de1ee1cac498ae$var$hde();
    var b, c, d, e, f;
    if (a == null) return null;
    d = a.length;
    e = d * 2;
    b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, e, 15, 1);
    for(c = 0; c < d; c++){
        f = a[c];
        f < 0 && (f += 256);
        b[c * 2] = $61de1ee1cac498ae$var$gde[f >> 4];
        b[c * 2 + 1] = $61de1ee1cac498ae$var$gde[f & 15];
    }
    return $61de1ee1cac498ae$var$zfb(b, 0, b.length);
}
function $61de1ee1cac498ae$var$fn(a) {
    $61de1ee1cac498ae$var$Vm();
    var b, c, d;
    d = a.c.length;
    switch(d){
        case 0:
            return $61de1ee1cac498ae$var$Um;
        case 1:
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qr(new $61de1ee1cac498ae$var$olb(a)), 42);
            return $61de1ee1cac498ae$var$ln(b.cd(), b.dd());
        default:
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$CK, $61de1ee1cac498ae$var$zie, 42, a.c.length, 0, 1)), 165);
            return new $61de1ee1cac498ae$var$wx(c);
    }
}
function $61de1ee1cac498ae$var$ITb(a) {
    var b, c, d, e, f, g;
    b = new $61de1ee1cac498ae$var$jkb;
    c = new $61de1ee1cac498ae$var$jkb;
    $61de1ee1cac498ae$var$Wjb(b, a);
    $61de1ee1cac498ae$var$Wjb(c, a);
    while(c.b != c.c){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(c), 37);
        for(g = new $61de1ee1cac498ae$var$olb(e.a); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
            if (f.e) {
                d = f.e;
                $61de1ee1cac498ae$var$Wjb(b, d);
                $61de1ee1cac498ae$var$Wjb(c, d);
            }
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$Y_b(a, b) {
    switch(b.g){
        case 1:
            return $61de1ee1cac498ae$var$Nq(a.j, ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$v0b));
        case 2:
            return $61de1ee1cac498ae$var$Nq(a.j, ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$t0b));
        case 3:
            return $61de1ee1cac498ae$var$Nq(a.j, ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$x0b));
        case 4:
            return $61de1ee1cac498ae$var$Nq(a.j, ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$y0b));
        default:
            return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
    }
}
function $61de1ee1cac498ae$var$tic(a, b) {
    var c, d, e;
    c = $61de1ee1cac498ae$var$uic(b, a.e);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g.f, c), 19).a;
    e = a.a.c.length - 1;
    if (a.a.c.length != 0 && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, e), 287).c == d) {
        ++$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, e), 287).a;
        ++$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, e), 287).b;
    } else $61de1ee1cac498ae$var$Ekb(a.a, new $61de1ee1cac498ae$var$Dic(d));
}
function $61de1ee1cac498ae$var$VGc(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$UGc(a, b, c);
    if (d != 0) return d;
    if ($61de1ee1cac498ae$var$wNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) && $61de1ee1cac498ae$var$wNb(c, $61de1ee1cac498ae$var$Zsc)) {
        e = $61de1ee1cac498ae$var$beb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Zsc), 19).a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Zsc), 19).a);
        e < 0 ? $61de1ee1cac498ae$var$WGc(a, b, c) : e > 0 && $61de1ee1cac498ae$var$WGc(a, c, b);
        return e;
    }
    return $61de1ee1cac498ae$var$TGc(a, b, c);
}
function $61de1ee1cac498ae$var$MSc(a, b, c) {
    var d, e, f, g;
    if (b.b != 0) {
        d = new $61de1ee1cac498ae$var$Psb;
        for(g = $61de1ee1cac498ae$var$Jsb(b, 0); g.b != g.d.c;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 86);
            $61de1ee1cac498ae$var$ye(d, $61de1ee1cac498ae$var$URc(f));
            e = f.e;
            e.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$kTc)), 19).a;
            e.b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$lTc), 19).a;
        }
        $61de1ee1cac498ae$var$MSc(a, d, $61de1ee1cac498ae$var$Udd(c, d.b / a.a | 0));
    }
}
function $61de1ee1cac498ae$var$JZc(a, b) {
    var c, d, e, f, g;
    if (a.e <= b) return a.g;
    if ($61de1ee1cac498ae$var$LZc(a, a.g, b)) return a.g;
    f = a.r;
    d = a.g;
    g = a.r;
    e = (f - d) / 2 + d;
    while(d + 1 < f){
        c = $61de1ee1cac498ae$var$MZc(a, e, false);
        if (c.b <= e && c.a <= b) {
            g = e;
            f = e;
        } else d = e;
        e = (f - d) / 2 + d;
    }
    return g;
}
function $61de1ee1cac498ae$var$t2c(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$o2c(a, b, true);
    $61de1ee1cac498ae$var$Odd(c, "Recursive Graph Layout", d);
    $61de1ee1cac498ae$var$jfd(b, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$g2, 1), $61de1ee1cac498ae$var$Uhe, 527, 0, [
        new $61de1ee1cac498ae$var$q3c
    ]));
    $61de1ee1cac498ae$var$ikd(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$F9c)) || $61de1ee1cac498ae$var$jfd(b, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$g2, 1), $61de1ee1cac498ae$var$Uhe, 527, 0, [
        new $61de1ee1cac498ae$var$U3c
    ]));
    $61de1ee1cac498ae$var$u2c(a, b, null, c);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$Qdd(a) {
    var b;
    if (a.p == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("The task has not begun yet."));
    if (!a.b) {
        if (a.k) {
            b = ($61de1ee1cac498ae$var$Zfb(), $61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Cbb(Date.now()), $61de1ee1cac498ae$var$_ie));
            a.q = $61de1ee1cac498ae$var$Sbb($61de1ee1cac498ae$var$Qbb(b, a.o)) * 1.0E-9;
        }
        a.c < a.r && $61de1ee1cac498ae$var$Rdd(a, a.r - a.c);
        a.b = true;
    }
}
function $61de1ee1cac498ae$var$ofd(a) {
    var b, c, d;
    d = new $61de1ee1cac498ae$var$s7c;
    $61de1ee1cac498ae$var$Dsb(d, new $61de1ee1cac498ae$var$f7c(a.j, a.k));
    for(c = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, a, 5)), a.a)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 469);
        $61de1ee1cac498ae$var$Dsb(d, new $61de1ee1cac498ae$var$f7c(b.a, b.b));
    }
    $61de1ee1cac498ae$var$Dsb(d, new $61de1ee1cac498ae$var$f7c(a.b, a.c));
    return d;
}
function $61de1ee1cac498ae$var$qqd(a, b, c, d, e) {
    var f, g, h, i, j, k;
    if (e) {
        i = e.a.length;
        f = new $61de1ee1cac498ae$var$Yge(i);
        for(k = (f.b - f.a) * f.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(f); k.Ob();){
            j = $61de1ee1cac498ae$var$BD(k.Pb(), 19);
            h = $61de1ee1cac498ae$var$Zpd(e, j.a);
            g = new $61de1ee1cac498ae$var$prd(a, b, c, d);
            $61de1ee1cac498ae$var$rqd(g.a, g.b, g.c, g.d, h);
        }
    }
}
function $61de1ee1cac498ae$var$Ax(b, c) {
    var d;
    if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(c)) return true;
    if ($61de1ee1cac498ae$var$JD(c, 21)) {
        d = $61de1ee1cac498ae$var$BD(c, 21);
        try {
            return b.gc() == d.gc() && b.Ic(d);
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if ($61de1ee1cac498ae$var$JD(a, 173) || $61de1ee1cac498ae$var$JD(a, 205)) return false;
            else throw $61de1ee1cac498ae$var$vbb(a);
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$UHb(a, b) {
    var c;
    $61de1ee1cac498ae$var$Ekb(a.d, b);
    c = b.rf();
    if (a.c) {
        a.e.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.e.a, c.a);
        a.e.b += c.b;
        a.d.c.length > 1 && (a.e.b += a.a);
    } else {
        a.e.a += c.a;
        a.e.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.e.b, c.b);
        a.d.c.length > 1 && (a.e.a += a.a);
    }
}
function $61de1ee1cac498ae$var$cmc(a) {
    var b, c, d, e;
    e = a.i;
    b = e.b;
    d = e.j;
    c = e.g;
    switch(e.a.g){
        case 0:
            c.a = (a.g.b.o.a - d.a) / 2;
            break;
        case 1:
            c.a = b.d.n.a + b.d.a.a;
            break;
        case 2:
            c.a = b.d.n.a + b.d.a.a - d.a;
            break;
        case 3:
            c.b = b.d.n.b + b.d.a.b;
    }
}
function $61de1ee1cac498ae$var$Q6c(a, b, c, d, e) {
    if (d < b || e < c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The highx must be bigger then lowx and the highy must be bigger then lowy"));
    a.a < b ? a.a = b : a.a > d && (a.a = d);
    a.b < c ? a.b = c : a.b > e && (a.b = e);
    return a;
}
function $61de1ee1cac498ae$var$lsd(a) {
    if ($61de1ee1cac498ae$var$JD(a, 149)) return $61de1ee1cac498ae$var$esd($61de1ee1cac498ae$var$BD(a, 149));
    else if ($61de1ee1cac498ae$var$JD(a, 229)) return $61de1ee1cac498ae$var$fsd($61de1ee1cac498ae$var$BD(a, 229));
    else if ($61de1ee1cac498ae$var$JD(a, 23)) return $61de1ee1cac498ae$var$gsd($61de1ee1cac498ae$var$BD(a, 23));
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Xte + $61de1ee1cac498ae$var$Fe(new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        a
    ])))));
}
function $61de1ee1cac498ae$var$mhb(a, b, c, d, e) {
    var f, g, h;
    f = true;
    for(g = 0; g < d; g++)f = f & c[g] == 0;
    if (e == 0) {
        $61de1ee1cac498ae$var$$fb(c, d, a, 0, b);
        g = b;
    } else {
        h = 32 - e;
        f = f & c[g] << h == 0;
        for(g = 0; g < b - 1; g++)a[g] = c[g + d] >>> e | c[g + d + 1] << h;
        a[g] = c[g + d] >>> e;
        ++g;
    }
    return f;
}
function $61de1ee1cac498ae$var$zMc(a, b, c, d) {
    var e, f, g;
    if (b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
        g = e.c.i.k;
        if (g == $61de1ee1cac498ae$var$g0b && a.c.a[e.c.i.c.p] == d && a.c.a[b.c.p] == c) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$mD(a, b) {
    var c, d, e, f;
    b &= 63;
    c = a.h & $61de1ee1cac498ae$var$Fje;
    if (b < 22) {
        f = c >>> b;
        e = a.m >> b | c << 22 - b;
        d = a.l >> b | a.m << 22 - b;
    } else if (b < 44) {
        f = 0;
        e = c >>> b - 22;
        d = a.m >> b - 22 | a.h << 44 - b;
    } else {
        f = 0;
        e = 0;
        d = c >>> b - 44;
    }
    return $61de1ee1cac498ae$var$TC(d & $61de1ee1cac498ae$var$Eje, e & $61de1ee1cac498ae$var$Eje, f & $61de1ee1cac498ae$var$Fje);
}
function $61de1ee1cac498ae$var$Iic(a, b, c, d) {
    var e;
    this.b = d;
    this.e = a == ($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$pGc);
    e = b[c];
    this.d = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$sbb, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$dle
    ], [
        177,
        25
    ], 16, [
        e.length,
        e.length
    ], 2);
    this.a = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$WD, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$oje
    ], [
        48,
        25
    ], 15, [
        e.length,
        e.length
    ], 2);
    this.c = new $61de1ee1cac498ae$var$sic(b, c);
}
function $61de1ee1cac498ae$var$ljc(a) {
    var b, c, d;
    a.k = new $61de1ee1cac498ae$var$Ki(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])).length, a.j.c.length);
    for(d = new $61de1ee1cac498ae$var$olb(a.j); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 113);
        b = c.d.j;
        $61de1ee1cac498ae$var$Rc(a.k, b, c);
    }
    a.e = $61de1ee1cac498ae$var$Zjc($61de1ee1cac498ae$var$Ec(a.k));
}
function $61de1ee1cac498ae$var$UQc(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$Qqb(a.d, b);
    c = new $61de1ee1cac498ae$var$_Qc;
    $61de1ee1cac498ae$var$Rhb(a.c, b, c);
    c.f = $61de1ee1cac498ae$var$VQc(b.c);
    c.a = $61de1ee1cac498ae$var$VQc(b.d);
    c.d = ($61de1ee1cac498ae$var$hQc(), e = b.c.i.k, e == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) || e == $61de1ee1cac498ae$var$d0b);
    c.e = (d = b.d.i.k, d == $61de1ee1cac498ae$var$h0b || d == $61de1ee1cac498ae$var$d0b);
    c.b = b.c.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd);
    c.c = b.d.j == $61de1ee1cac498ae$var$zcd;
}
function $61de1ee1cac498ae$var$BGb(a) {
    var b, c, d, e, f;
    f = $61de1ee1cac498ae$var$Ohe;
    e = $61de1ee1cac498ae$var$Ohe;
    for(d = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$LFb(a)); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 213);
        b = c.e.e - c.d.e;
        c.e == a && b < e ? e = b : b < f && (f = b);
    }
    e == $61de1ee1cac498ae$var$Ohe && (e = -1);
    f == $61de1ee1cac498ae$var$Ohe && (f = -1);
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(e), $61de1ee1cac498ae$var$meb(f));
}
function $61de1ee1cac498ae$var$zQb(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$dme;
    d = ($61de1ee1cac498ae$var$ROb(), $61de1ee1cac498ae$var$OOb);
    e = $61de1ee1cac498ae$var$$wnd.Math.abs(a.b);
    c = $61de1ee1cac498ae$var$$wnd.Math.abs(b.f - a.b);
    if (c < e) {
        e = c;
        d = $61de1ee1cac498ae$var$POb;
    }
    c = $61de1ee1cac498ae$var$$wnd.Math.abs(a.a);
    if (c < e) {
        e = c;
        d = $61de1ee1cac498ae$var$QOb;
    }
    c = $61de1ee1cac498ae$var$$wnd.Math.abs(b.g - a.a);
    if (c < e) {
        e = c;
        d = $61de1ee1cac498ae$var$NOb;
    }
    return d;
}
function $61de1ee1cac498ae$var$L9b(a, b) {
    var c, d, e, f;
    c = b.a.o.a;
    f = new $61de1ee1cac498ae$var$Jib($61de1ee1cac498ae$var$Q_b(b.a).b, b.c, b.f + 1);
    for(e = new $61de1ee1cac498ae$var$vib(f); e.b < e.d.gc();){
        d = ($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), $61de1ee1cac498ae$var$BD(e.d.Xb(e.c = e.b++), 29));
        if (d.c.a >= c) {
            $61de1ee1cac498ae$var$K9b(a, b, d.p);
            return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$Iod(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$fld(a);
    b = new $61de1ee1cac498ae$var$Wfb($61de1ee1cac498ae$var$dte);
    !a.a || $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += ' "', b), a.a), '"');
    $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb((b.a += " (", b), a.i), ","), a.j), " | "), a.g), ","), a.f), ")");
    return b.a;
}
function $61de1ee1cac498ae$var$Z2d(a, b, c) {
    var d, e, f, g, h;
    h = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    e = $61de1ee1cac498ae$var$BD(a.g, 119);
    d = 0;
    for(g = 0; g < a.i; ++g){
        f = e[g];
        if (h.rl(f.ak())) {
            if (d == c) {
                $61de1ee1cac498ae$var$Xxd(a, g);
                return $61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? f : f.dd();
            }
            ++d;
        }
    }
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$gve + c + $61de1ee1cac498ae$var$mue + d));
}
function $61de1ee1cac498ae$var$sde(a) {
    var b, c, d;
    b = a.c;
    if (b == 2 || b == 7 || b == 1) return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$ffe;
    else {
        d = $61de1ee1cac498ae$var$qde(a);
        c = null;
        while((b = a.c) != 2 && b != 7 && b != 1){
            if (!c) {
                c = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Lge(1));
                $61de1ee1cac498ae$var$Kge(c, d);
                d = c;
            }
            $61de1ee1cac498ae$var$Kge(c, $61de1ee1cac498ae$var$qde(a));
        }
        return d;
    }
}
function $61de1ee1cac498ae$var$Kb(a, b, c) {
    if (a < 0 || a > c) return $61de1ee1cac498ae$var$Jb(a, c, "start index");
    if (b < 0 || b > c) return $61de1ee1cac498ae$var$Jb(b, c, "end index");
    return $61de1ee1cac498ae$var$hc("end index (%s) must not be less than start index (%s)", $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        $61de1ee1cac498ae$var$meb(b),
        $61de1ee1cac498ae$var$meb(a)
    ]));
}
function $61de1ee1cac498ae$var$Pz(b, c) {
    var d, e, f, g;
    for(e = 0, f = b.length; e < f; e++){
        g = b[e];
        try {
            g[1] ? g[0].jm() && (c = $61de1ee1cac498ae$var$Oz(c, g)) : g[0].jm();
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if ($61de1ee1cac498ae$var$JD(a, 78)) {
                d = a;
                $61de1ee1cac498ae$var$Az();
                $61de1ee1cac498ae$var$Gz($61de1ee1cac498ae$var$JD(d, 477) ? $61de1ee1cac498ae$var$BD(d, 477).ae() : d);
            } else throw $61de1ee1cac498ae$var$vbb(a);
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$K9b(a, b, c) {
    var d, e, f;
    c != b.c + b.b.gc() && $61de1ee1cac498ae$var$Z9b(b.a, $61de1ee1cac498ae$var$fac(b, c - b.c));
    f = b.a.c.p;
    a.a[f] = $61de1ee1cac498ae$var$$wnd.Math.max(a.a[f], b.a.o.a);
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ktc)), 15).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 70);
        $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$H9b, ($61de1ee1cac498ae$var$Bcb(), true));
    }
}
function $61de1ee1cac498ae$var$Wec(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$Vec(b);
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Xsc), e);
    if (e) {
        d = $61de1ee1cac498ae$var$Ohe;
        !!$61de1ee1cac498ae$var$irb(a.f, e) && (d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, e)), 19).a);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.g, 0), 17);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$ltc))) || $61de1ee1cac498ae$var$Rhb(a, e, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Zsc), 19).a, d)));
    }
}
function $61de1ee1cac498ae$var$iCc(a, b, c) {
    var d, e, f, g, h;
    b.p = -1;
    for(h = $61de1ee1cac498ae$var$W_b(b, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)).Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 11);
        for(e = new $61de1ee1cac498ae$var$olb(g.g); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
            f = d.d.i;
            b != f && (f.p < 0 ? c.Fc(d) : f.p > 0 && $61de1ee1cac498ae$var$iCc(a, f, c));
        }
    }
    b.p = 0;
}
function $61de1ee1cac498ae$var$p5c(a) {
    var b;
    this.c = new $61de1ee1cac498ae$var$Psb;
    this.f = a.e;
    this.e = a.d;
    this.i = a.g;
    this.d = a.c;
    this.b = a.b;
    this.k = a.j;
    this.a = a.a;
    !a.i ? this.j = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$e1), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0)) : this.j = a.i;
    this.g = a.f;
}
function $61de1ee1cac498ae$var$Wb(a) {
    var b, c, d, e;
    b = $61de1ee1cac498ae$var$Kfb($61de1ee1cac498ae$var$Qfb(new $61de1ee1cac498ae$var$Wfb("Predicates."), "and"), 40);
    c = true;
    for(e = new $61de1ee1cac498ae$var$vib(a); e.b < e.d.gc();){
        d = ($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), e.d.Xb(e.c = e.b++));
        c || (b.a += ",", b);
        b.a += "" + d;
        c = false;
    }
    return (b.a += ")", b).a;
}
function $61de1ee1cac498ae$var$Rcc(a, b, c) {
    var d, e, f;
    if (c <= b + 2) return;
    e = (c - b) / 2 | 0;
    for(d = 0; d < e; ++d){
        f = ($61de1ee1cac498ae$var$tCb(b + d, a.c.length), $61de1ee1cac498ae$var$BD(a.c[b + d], 11));
        $61de1ee1cac498ae$var$Nkb(a, b + d, ($61de1ee1cac498ae$var$tCb(c - d - 1, a.c.length), $61de1ee1cac498ae$var$BD(a.c[c - d - 1], 11)));
        $61de1ee1cac498ae$var$tCb(c - d - 1, a.c.length);
        a.c[c - d - 1] = f;
    }
}
function $61de1ee1cac498ae$var$hjc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    f = a.d.p;
    h = f.e;
    i = f.r;
    a.g = new $61de1ee1cac498ae$var$dIc(i);
    g = a.d.o.c.p;
    d = g > 0 ? h[g - 1] : $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, 0, 0, 1);
    e = h[g];
    j = g < h.length - 1 ? h[g + 1] : $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, 0, 0, 1);
    k = b == c - 1;
    k ? $61de1ee1cac498ae$var$RHc(a.g, e, j) : $61de1ee1cac498ae$var$RHc(a.g, d, e);
}
function $61de1ee1cac498ae$var$pjc(a) {
    var b;
    this.j = new $61de1ee1cac498ae$var$Rkb;
    this.f = new $61de1ee1cac498ae$var$Tqb;
    this.b = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$F1), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0));
    this.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])).length, 15, 1);
    this.g = a;
}
function $61de1ee1cac498ae$var$QVc(a, b) {
    var c, d, e;
    if (b.c.length != 0) {
        c = $61de1ee1cac498ae$var$RVc(a, b);
        e = false;
        while(!c){
            $61de1ee1cac498ae$var$AVc(a, b, true);
            e = true;
            c = $61de1ee1cac498ae$var$RVc(a, b);
        }
        e && $61de1ee1cac498ae$var$AVc(a, b, false);
        d = $61de1ee1cac498ae$var$dVc(b);
        !!a.b && a.b.lg(d);
        a.a = $61de1ee1cac498ae$var$PVc(a, ($61de1ee1cac498ae$var$tCb(0, b.c.length), $61de1ee1cac498ae$var$BD(b.c[0], 33)));
        $61de1ee1cac498ae$var$QVc(a, d);
    }
}
function $61de1ee1cac498ae$var$Cid(a, b) {
    var c, d, e;
    d = $61de1ee1cac498ae$var$XKd(a.Tg(), b);
    c = b - a.Ah();
    if (c < 0) {
        if (!d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$mte + b + $61de1ee1cac498ae$var$nte));
        else if (d.Ij()) {
            e = a.Yg(d);
            e >= 0 ? a.Bh(e) : $61de1ee1cac498ae$var$vid(a, d);
        } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + d.ne() + $61de1ee1cac498ae$var$jte));
    } else $61de1ee1cac498ae$var$eid(a, c, d);
}
function $61de1ee1cac498ae$var$aqd(a) {
    var b, c;
    c = null;
    b = false;
    if ($61de1ee1cac498ae$var$JD(a, 204)) {
        b = true;
        c = $61de1ee1cac498ae$var$BD(a, 204).a;
    }
    if (!b) {
        if ($61de1ee1cac498ae$var$JD(a, 258)) {
            b = true;
            c = "" + $61de1ee1cac498ae$var$BD(a, 258).a;
        }
    }
    if (!b) {
        if ($61de1ee1cac498ae$var$JD(a, 483)) {
            b = true;
            c = "" + $61de1ee1cac498ae$var$BD(a, 483).a;
        }
    }
    if (!b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$vcb($61de1ee1cac498ae$var$Ute));
    return c;
}
function $61de1ee1cac498ae$var$ORd(a, b) {
    var c, d;
    if (a.f) {
        while(b.Ob()){
            c = $61de1ee1cac498ae$var$BD(b.Pb(), 72);
            d = c.ak();
            if ($61de1ee1cac498ae$var$JD(d, 99) && ($61de1ee1cac498ae$var$BD(d, 18).Bb & $61de1ee1cac498ae$var$ote) != 0 && (!a.e || d.Gj() != $61de1ee1cac498ae$var$x2 || d.aj() != 0) && c.dd() != null) {
                b.Ub();
                return true;
            }
        }
        return false;
    } else return b.Ob();
}
function $61de1ee1cac498ae$var$QRd(a, b) {
    var c, d;
    if (a.f) {
        while(b.Sb()){
            c = $61de1ee1cac498ae$var$BD(b.Ub(), 72);
            d = c.ak();
            if ($61de1ee1cac498ae$var$JD(d, 99) && ($61de1ee1cac498ae$var$BD(d, 18).Bb & $61de1ee1cac498ae$var$ote) != 0 && (!a.e || d.Gj() != $61de1ee1cac498ae$var$x2 || d.aj() != 0) && c.dd() != null) {
                b.Pb();
                return true;
            }
        }
        return false;
    } else return b.Sb();
}
function $61de1ee1cac498ae$var$I2d(a, b, c) {
    var d, e, f, g, h, i;
    i = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    d = 0;
    h = a.i;
    e = $61de1ee1cac498ae$var$BD(a.g, 119);
    for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.rl(f.ak())) {
            if (c == d) return g;
            ++d;
            h = g + 1;
        }
    }
    if (c == d) return h;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$gve + c + $61de1ee1cac498ae$var$mue + d));
}
function $61de1ee1cac498ae$var$d9b(a, b) {
    var c, d, e, f;
    if (a.f.c.length == 0) return null;
    else {
        f = new $61de1ee1cac498ae$var$I6c;
        for(d = new $61de1ee1cac498ae$var$olb(a.f); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 70);
            e = c.o;
            f.b = $61de1ee1cac498ae$var$$wnd.Math.max(f.b, e.a);
            f.a += e.b;
        }
        f.a += (a.f.c.length - 1) * b;
        return f;
    }
}
function $61de1ee1cac498ae$var$QJc(a, b, c) {
    var d, e, f;
    for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(c).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
        if (!(!$61de1ee1cac498ae$var$OZb(d) && !(!$61de1ee1cac498ae$var$OZb(d) && d.c.i.c == d.d.i.c))) continue;
        f = $61de1ee1cac498ae$var$IJc(a, d, c, new $61de1ee1cac498ae$var$vKc);
        f.c.length > 1 && (b.c[b.c.length] = f);
    }
}
function $61de1ee1cac498ae$var$TJc(a) {
    var b, c, d, e;
    c = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$ye(c, a.o);
    d = new $61de1ee1cac498ae$var$twb;
    while(c.b != 0){
        b = $61de1ee1cac498ae$var$BD(c.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(c.b != 0), $61de1ee1cac498ae$var$Nsb(c, c.a.a)), 508);
        e = $61de1ee1cac498ae$var$KJc(a, b, true);
        e && $61de1ee1cac498ae$var$Ekb(d.a, b);
    }
    while(d.a.c.length != 0){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$rwb(d), 508);
        $61de1ee1cac498ae$var$KJc(a, b, false);
    }
}
function $61de1ee1cac498ae$var$_5c() {
    $61de1ee1cac498ae$var$_5c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$$5c = new $61de1ee1cac498ae$var$a6c($61de1ee1cac498ae$var$ole, 0);
    $61de1ee1cac498ae$var$T5c = new $61de1ee1cac498ae$var$a6c("BOOLEAN", 1);
    $61de1ee1cac498ae$var$X5c = new $61de1ee1cac498ae$var$a6c("INT", 2);
    $61de1ee1cac498ae$var$Z5c = new $61de1ee1cac498ae$var$a6c("STRING", 3);
    $61de1ee1cac498ae$var$U5c = new $61de1ee1cac498ae$var$a6c("DOUBLE", 4);
    $61de1ee1cac498ae$var$V5c = new $61de1ee1cac498ae$var$a6c("ENUM", 5);
    $61de1ee1cac498ae$var$W5c = new $61de1ee1cac498ae$var$a6c("ENUMSET", 6);
    $61de1ee1cac498ae$var$Y5c = new $61de1ee1cac498ae$var$a6c("OBJECT", 7);
}
function $61de1ee1cac498ae$var$H6c(a, b) {
    var c, d, e, f, g;
    d = $61de1ee1cac498ae$var$$wnd.Math.min(a.c, b.c);
    f = $61de1ee1cac498ae$var$$wnd.Math.min(a.d, b.d);
    e = $61de1ee1cac498ae$var$$wnd.Math.max(a.c + a.b, b.c + b.b);
    g = $61de1ee1cac498ae$var$$wnd.Math.max(a.d + a.a, b.d + b.a);
    if (e < d) {
        c = d;
        d = e;
        e = c;
    }
    if (g < f) {
        c = f;
        f = g;
        g = c;
    }
    $61de1ee1cac498ae$var$G6c(a, d, f, e - d, g - f);
}
function $61de1ee1cac498ae$var$O6d() {
    $61de1ee1cac498ae$var$O6d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$L6d = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$swe,
        $61de1ee1cac498ae$var$twe,
        $61de1ee1cac498ae$var$uwe,
        $61de1ee1cac498ae$var$vwe,
        $61de1ee1cac498ae$var$wwe,
        $61de1ee1cac498ae$var$xwe,
        $61de1ee1cac498ae$var$eue
    ]);
    $61de1ee1cac498ae$var$K6d = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$swe,
        "empty",
        $61de1ee1cac498ae$var$twe,
        $61de1ee1cac498ae$var$Qve,
        "elementOnly"
    ]);
    $61de1ee1cac498ae$var$N6d = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$swe,
        "preserve",
        "replace",
        $61de1ee1cac498ae$var$ywe
    ]);
    $61de1ee1cac498ae$var$M6d = new $61de1ee1cac498ae$var$y1d;
}
function $61de1ee1cac498ae$var$Y$b(a, b, c) {
    var d, e, f;
    if (b == c) return;
    d = b;
    do {
        $61de1ee1cac498ae$var$P6c(a, d.c);
        e = d.e;
        if (e) {
            f = d.d;
            $61de1ee1cac498ae$var$O6c(a, f.b, f.d);
            $61de1ee1cac498ae$var$P6c(a, e.n);
            d = $61de1ee1cac498ae$var$Q_b(e);
        }
    }while (e);
    d = c;
    do {
        $61de1ee1cac498ae$var$c7c(a, d.c);
        e = d.e;
        if (e) {
            f = d.d;
            $61de1ee1cac498ae$var$b7c(a, f.b, f.d);
            $61de1ee1cac498ae$var$c7c(a, e.n);
            d = $61de1ee1cac498ae$var$Q_b(e);
        }
    }while (e);
}
function $61de1ee1cac498ae$var$qic(a, b, c, d) {
    var e, f, g, h, i;
    if (d.f.c + d.g.c == 0) for(g = a.a[a.c], h = 0, i = g.length; h < i; ++h){
        f = g[h];
        $61de1ee1cac498ae$var$Rhb(d, f, new $61de1ee1cac498ae$var$zic(a, f, c));
    }
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(d.f, b)), 663);
    e.b = 0;
    e.c = e.f;
    e.c == 0 || $61de1ee1cac498ae$var$Cic($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e.a, e.b), 287));
    return e;
}
function $61de1ee1cac498ae$var$Apc() {
    $61de1ee1cac498ae$var$Apc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$wpc = new $61de1ee1cac498ae$var$Bpc("MEDIAN_LAYER", 0);
    $61de1ee1cac498ae$var$ypc = new $61de1ee1cac498ae$var$Bpc("TAIL_LAYER", 1);
    $61de1ee1cac498ae$var$vpc = new $61de1ee1cac498ae$var$Bpc("HEAD_LAYER", 2);
    $61de1ee1cac498ae$var$xpc = new $61de1ee1cac498ae$var$Bpc("SPACE_EFFICIENT_LAYER", 3);
    $61de1ee1cac498ae$var$zpc = new $61de1ee1cac498ae$var$Bpc("WIDEST_LAYER", 4);
    $61de1ee1cac498ae$var$upc = new $61de1ee1cac498ae$var$Bpc("CENTER_LAYER", 5);
}
function $61de1ee1cac498ae$var$rJb(a) {
    switch(a.g){
        case 0:
        case 1:
        case 2:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd;
        case 3:
        case 4:
        case 5:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd;
        case 6:
        case 7:
        case 8:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd;
        case 9:
        case 10:
        case 11:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd;
        default:
            return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd;
    }
}
function $61de1ee1cac498ae$var$sKc(a, b) {
    var c;
    if (a.c.length == 0) return false;
    c = $61de1ee1cac498ae$var$Lzc(($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 17)).c.i);
    $61de1ee1cac498ae$var$FJc();
    if (c == ($61de1ee1cac498ae$var$Izc(), $61de1ee1cac498ae$var$Fzc) || c == $61de1ee1cac498ae$var$Ezc) return true;
    return $61de1ee1cac498ae$var$FAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a, 16)), new $61de1ee1cac498ae$var$AKc), new $61de1ee1cac498ae$var$CKc(b));
}
function $61de1ee1cac498ae$var$cRc(a, b, c) {
    var d, e, f;
    if (!a.b[b.g]) {
        a.b[b.g] = true;
        d = c;
        !d && (d = new $61de1ee1cac498ae$var$SRc);
        $61de1ee1cac498ae$var$Dsb(d.b, b);
        for(f = a.a[b.g].Kc(); f.Ob();){
            e = $61de1ee1cac498ae$var$BD(f.Pb(), 188);
            e.b != b && $61de1ee1cac498ae$var$cRc(a, e.b, d);
            e.c != b && $61de1ee1cac498ae$var$cRc(a, e.c, d);
            $61de1ee1cac498ae$var$Dsb(d.a, e);
        }
        return d;
    }
    return null;
}
function $61de1ee1cac498ae$var$qSc() {
    $61de1ee1cac498ae$var$qSc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$pSc = new $61de1ee1cac498ae$var$rSc("ROOT_PROC", 0);
    $61de1ee1cac498ae$var$lSc = new $61de1ee1cac498ae$var$rSc("FAN_PROC", 1);
    $61de1ee1cac498ae$var$nSc = new $61de1ee1cac498ae$var$rSc("NEIGHBORS_PROC", 2);
    $61de1ee1cac498ae$var$mSc = new $61de1ee1cac498ae$var$rSc("LEVEL_HEIGHT", 3);
    $61de1ee1cac498ae$var$oSc = new $61de1ee1cac498ae$var$rSc("NODE_POSITION_PROC", 4);
    $61de1ee1cac498ae$var$kSc = new $61de1ee1cac498ae$var$rSc("DETREEIFYING_PROC", 5);
}
function $61de1ee1cac498ae$var$kqd(a, b) {
    if ($61de1ee1cac498ae$var$JD(b, 239)) return $61de1ee1cac498ae$var$eqd(a, $61de1ee1cac498ae$var$BD(b, 33));
    else if ($61de1ee1cac498ae$var$JD(b, 186)) return $61de1ee1cac498ae$var$fqd(a, $61de1ee1cac498ae$var$BD(b, 118));
    else if ($61de1ee1cac498ae$var$JD(b, 439)) return $61de1ee1cac498ae$var$dqd(a, $61de1ee1cac498ae$var$BD(b, 202));
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Xte + $61de1ee1cac498ae$var$Fe(new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        b
    ])))));
}
function $61de1ee1cac498ae$var$xu(a, b, c) {
    var d, e;
    this.f = a;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 283);
    e = !d ? 0 : d.a;
    $61de1ee1cac498ae$var$Sb(c, e);
    if (c >= (e / 2 | 0)) {
        this.e = !d ? null : d.c;
        this.d = e;
        while(c++ < e)$61de1ee1cac498ae$var$vu(this);
    } else {
        this.c = !d ? null : d.b;
        while(c-- > 0)$61de1ee1cac498ae$var$uu(this);
    }
    this.b = b;
    this.a = null;
}
function $61de1ee1cac498ae$var$rEb(a, b) {
    var c, d;
    b.a ? $61de1ee1cac498ae$var$sEb(a, b) : (c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Exb(a.b, b.b), 57), !!c && c == a.a[b.b.f] && !!c.a && c.a != b.b.a && c.c.Fc(b.b), d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dxb(a.b, b.b), 57), !!d && a.a[d.f] == b.b && !!d.a && d.a != b.b.a && b.b.c.Fc(d), $61de1ee1cac498ae$var$Fxb(a.b, b.b), undefined);
}
function $61de1ee1cac498ae$var$FJb(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).dc()) {
        c.n.b = 0;
        c.n.c = 0;
        return;
    }
    c.n.b = a.C.b;
    c.n.c = a.C.c;
    a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd)) && $61de1ee1cac498ae$var$KJb(a, b);
    d = $61de1ee1cac498ae$var$JJb(a, b);
    $61de1ee1cac498ae$var$KIb(a, b) == ($61de1ee1cac498ae$var$Tbd(), $61de1ee1cac498ae$var$Qbd) && (d += 2 * a.w);
    c.a.a = d;
}
function $61de1ee1cac498ae$var$OKb(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).dc()) {
        c.n.d = 0;
        c.n.a = 0;
        return;
    }
    c.n.d = a.C.d;
    c.n.a = a.C.a;
    a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd)) && $61de1ee1cac498ae$var$SKb(a, b);
    d = $61de1ee1cac498ae$var$RKb(a, b);
    $61de1ee1cac498ae$var$KIb(a, b) == ($61de1ee1cac498ae$var$Tbd(), $61de1ee1cac498ae$var$Qbd) && (d += 2 * a.w);
    c.a.b = d;
}
function $61de1ee1cac498ae$var$cOb(a, b) {
    var c, d, e, f;
    f = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 65);
        $61de1ee1cac498ae$var$Ekb(f, new $61de1ee1cac498ae$var$oOb(c, true));
        $61de1ee1cac498ae$var$Ekb(f, new $61de1ee1cac498ae$var$oOb(c, false));
    }
    e = new $61de1ee1cac498ae$var$hOb(a);
    $61de1ee1cac498ae$var$zwb(e.a.a);
    $61de1ee1cac498ae$var$kDb(f, a.b, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$JM, 1), $61de1ee1cac498ae$var$Uhe, 679, 0, [
        e
    ])));
}
function $61de1ee1cac498ae$var$rQb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q;
    i = a.a;
    n = a.b;
    j = b.a;
    o = b.b;
    k = c.a;
    p = c.b;
    l = d.a;
    q = d.b;
    f = i * o - n * j;
    g = k * q - p * l;
    e = (i - j) * (p - q) - (n - o) * (k - l);
    h = (f * (k - l) - g * (i - j)) / e;
    m = (f * (p - q) - g * (n - o)) / e;
    return new $61de1ee1cac498ae$var$f7c(h, m);
}
function $61de1ee1cac498ae$var$TBc(a, b) {
    var c, d, e;
    if (a.d[b.p]) return;
    a.d[b.p] = true;
    a.a[b.p] = true;
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
        if ($61de1ee1cac498ae$var$OZb(c)) continue;
        e = c.d.i;
        a.a[e.p] ? $61de1ee1cac498ae$var$Ekb(a.b, c) : $61de1ee1cac498ae$var$TBc(a, e);
    }
    a.a[b.p] = false;
}
function $61de1ee1cac498ae$var$pCc(a, b, c) {
    var d;
    d = 0;
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163).g){
        case 2:
            d = 2 * -c + a.a;
            ++a.a;
            break;
        case 1:
            d = -c;
            break;
        case 3:
            d = c;
            break;
        case 4:
            d = 2 * c + a.b;
            ++a.b;
    }
    $61de1ee1cac498ae$var$wNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) && (d += $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Zsc), 19).a);
    return d;
}
function $61de1ee1cac498ae$var$jOc(a, b, c) {
    var d, e, f;
    c.zc(b, a);
    $61de1ee1cac498ae$var$Ekb(a.n, b);
    f = a.p.eg(b);
    b.j == a.p.fg() ? $61de1ee1cac498ae$var$yOc(a.e, f) : $61de1ee1cac498ae$var$yOc(a.j, f);
    $61de1ee1cac498ae$var$lOc(a);
    for(e = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
        new $61de1ee1cac498ae$var$J0b(b),
        new $61de1ee1cac498ae$var$R0b(b)
    ]))); $61de1ee1cac498ae$var$Qr(e);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 11);
        c._b(d) || $61de1ee1cac498ae$var$jOc(a, d, c);
    }
}
function $61de1ee1cac498ae$var$rfd(a) {
    var b, c, d;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Y8c)), 21);
    if (c.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$pdd))) {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$b9c), 21);
        b = new $61de1ee1cac498ae$var$g7c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$_8c), 8));
        if (d.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Bdd))) {
            b.a <= 0 && (b.a = 20);
            b.b <= 0 && (b.b = 20);
        }
        return b;
    } else return new $61de1ee1cac498ae$var$d7c;
}
function $61de1ee1cac498ae$var$PKd(a) {
    var b, c, d;
    if (!a.b) {
        d = new $61de1ee1cac498ae$var$$Nd;
        for(c = new $61de1ee1cac498ae$var$$yd($61de1ee1cac498ae$var$SKd(a)); c.e != c.i.gc();){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Zyd(c), 18);
            (b.Bb & $61de1ee1cac498ae$var$ote) != 0 && $61de1ee1cac498ae$var$wtd(d, b);
        }
        $61de1ee1cac498ae$var$vud(d);
        a.b = new $61de1ee1cac498ae$var$nNd(($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).o), 8), 18), d.i), d.g);
        $61de1ee1cac498ae$var$$Kd(a).b &= -9;
    }
    return a.b;
}
function $61de1ee1cac498ae$var$Rmc(a, b) {
    var c, d, e, f, g, h, i, j;
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ee($61de1ee1cac498ae$var$Ec(b.k), $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$F1, $61de1ee1cac498ae$var$bne, 61, 2, 0, 1)), 122);
    j = b.g;
    c = $61de1ee1cac498ae$var$Tmc(b, i[0]);
    e = $61de1ee1cac498ae$var$Smc(b, i[1]);
    d = $61de1ee1cac498ae$var$Kmc(a, j, c, e);
    f = $61de1ee1cac498ae$var$Tmc(b, i[1]);
    h = $61de1ee1cac498ae$var$Smc(b, i[0]);
    g = $61de1ee1cac498ae$var$Kmc(a, j, f, h);
    if (d <= g) {
        b.a = c;
        b.c = e;
    } else {
        b.a = f;
        b.c = h;
    }
}
function $61de1ee1cac498ae$var$ESc(a, b, c) {
    var d, e, f;
    $61de1ee1cac498ae$var$Odd(c, "Processor set neighbors", 1);
    a.a = b.b.b == 0 ? 1 : b.b.b;
    e = null;
    d = $61de1ee1cac498ae$var$Jsb(b.b, 0);
    while(!e && d.b != d.d.c){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 86);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc)))) && (e = f);
    }
    !!e && $61de1ee1cac498ae$var$FSc(a, new $61de1ee1cac498ae$var$ZRc(e), c);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$PEd(a) {
    $61de1ee1cac498ae$var$IEd();
    var b, c, d, e;
    d = $61de1ee1cac498ae$var$hfb(a, $61de1ee1cac498ae$var$wfb(35));
    b = d == -1 ? a : a.substr(0, d);
    c = d == -1 ? null : a.substr(d + 1);
    e = $61de1ee1cac498ae$var$kFd($61de1ee1cac498ae$var$HEd, b);
    if (!e) {
        e = $61de1ee1cac498ae$var$aFd(b);
        $61de1ee1cac498ae$var$lFd($61de1ee1cac498ae$var$HEd, b, e);
        c != null && (e = $61de1ee1cac498ae$var$JEd(e, c));
    } else c != null && (e = $61de1ee1cac498ae$var$JEd(e, ($61de1ee1cac498ae$var$uCb(c), c)));
    return e;
}
function $61de1ee1cac498ae$var$smb(a) {
    var h;
    $61de1ee1cac498ae$var$mmb();
    var b, c, d, e, f, g;
    if ($61de1ee1cac498ae$var$JD(a, 54)) for(e = 0, d = a.gc() - 1; e < d; ++e, --d){
        h = a.Xb(e);
        a._c(e, a.Xb(d));
        a._c(d, h);
    }
    else {
        b = a.Yc();
        f = a.Zc(a.gc());
        while(b.Tb() < f.Vb()){
            c = b.Pb();
            g = f.Ub();
            b.Wb(g);
            f.Wb(c);
        }
    }
}
function $61de1ee1cac498ae$var$I3b(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$Odd(b, "End label pre-processing", 1);
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$nyc))));
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ryc)));
    e = $61de1ee1cac498ae$var$gad($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Lwc), 103));
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.b, 16)), new $61de1ee1cac498ae$var$Q3b), new $61de1ee1cac498ae$var$S3b(c, d, e));
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$NFc(a, b) {
    var c, d, e, f, g, h;
    h = 0;
    f = new $61de1ee1cac498ae$var$jkb;
    $61de1ee1cac498ae$var$Wjb(f, b);
    while(f.b != f.c){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(f), 214);
        h += $61de1ee1cac498ae$var$pHc(g.d, g.e);
        for(e = new $61de1ee1cac498ae$var$olb(g.b); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 37);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, d.p), 214);
            c.s || (h += $61de1ee1cac498ae$var$NFc(a, c));
        }
    }
    return h;
}
function $61de1ee1cac498ae$var$YQc(a, b, c) {
    var d, e;
    $61de1ee1cac498ae$var$TQc(this);
    b == ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$DQc) ? $61de1ee1cac498ae$var$Qqb(this.r, a.c) : $61de1ee1cac498ae$var$Qqb(this.w, a.c);
    c == $61de1ee1cac498ae$var$DQc ? $61de1ee1cac498ae$var$Qqb(this.r, a.d) : $61de1ee1cac498ae$var$Qqb(this.w, a.d);
    $61de1ee1cac498ae$var$UQc(this, a);
    d = $61de1ee1cac498ae$var$VQc(a.c);
    e = $61de1ee1cac498ae$var$VQc(a.d);
    $61de1ee1cac498ae$var$XQc(this, d, e, e);
    this.o = ($61de1ee1cac498ae$var$hQc(), $61de1ee1cac498ae$var$$wnd.Math.abs(d - e) < 0.2);
}
function $61de1ee1cac498ae$var$a0d(a, b, c) {
    var d, e, f, g, h, i;
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a.a, 8), 1936);
    if (h != null) for(e = h, f = 0, g = e.length; f < g; ++f)null.jm();
    d = c;
    if ((a.a.Db & 1) == 0) {
        i = new $61de1ee1cac498ae$var$f0d(a, c, b);
        d.ui(i);
    }
    $61de1ee1cac498ae$var$JD(d, 672) ? $61de1ee1cac498ae$var$BD(d, 672).wi(a.a) : d.ti() == a.a && d.vi(null);
}
function $61de1ee1cac498ae$var$dae() {
    var a;
    if ($61de1ee1cac498ae$var$Z9d) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$nUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$Ewe), 1945);
    $61de1ee1cac498ae$var$eae();
    a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$Phb(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$Ewe), 586) ? $61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$xFd, $61de1ee1cac498ae$var$Ewe) : new $61de1ee1cac498ae$var$cae, 586);
    $61de1ee1cac498ae$var$Z9d = true;
    $61de1ee1cac498ae$var$aae(a);
    $61de1ee1cac498ae$var$bae(a);
    $61de1ee1cac498ae$var$Rhb(($61de1ee1cac498ae$var$JFd(), $61de1ee1cac498ae$var$IFd), a, new $61de1ee1cac498ae$var$fae);
    $61de1ee1cac498ae$var$Tnd(a);
    $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$xFd, $61de1ee1cac498ae$var$Ewe, a);
    return a;
}
function $61de1ee1cac498ae$var$xA(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$oA(a, c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$rje,
        $61de1ee1cac498ae$var$sje,
        $61de1ee1cac498ae$var$tje,
        $61de1ee1cac498ae$var$uje,
        $61de1ee1cac498ae$var$vje,
        $61de1ee1cac498ae$var$wje,
        $61de1ee1cac498ae$var$xje
    ]), b);
    e < 0 && (e = $61de1ee1cac498ae$var$oA(a, c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ]), b));
    if (e < 0) return false;
    d.d = e;
    return true;
}
function $61de1ee1cac498ae$var$AA(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$oA(a, c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$rje,
        $61de1ee1cac498ae$var$sje,
        $61de1ee1cac498ae$var$tje,
        $61de1ee1cac498ae$var$uje,
        $61de1ee1cac498ae$var$vje,
        $61de1ee1cac498ae$var$wje,
        $61de1ee1cac498ae$var$xje
    ]), b);
    e < 0 && (e = $61de1ee1cac498ae$var$oA(a, c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ]), b));
    if (e < 0) return false;
    d.d = e;
    return true;
}
function $61de1ee1cac498ae$var$NVb(a) {
    var b, c, d;
    $61de1ee1cac498ae$var$KVb(a);
    d = new $61de1ee1cac498ae$var$Rkb;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        $61de1ee1cac498ae$var$Ekb(d, new $61de1ee1cac498ae$var$ZVb(b, true));
        $61de1ee1cac498ae$var$Ekb(d, new $61de1ee1cac498ae$var$ZVb(b, false));
    }
    $61de1ee1cac498ae$var$RVb(a.c);
    $61de1ee1cac498ae$var$rXb(d, a.b, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bQ, 1), $61de1ee1cac498ae$var$Uhe, 369, 0, [
        a.c
    ])));
    $61de1ee1cac498ae$var$MVb(a);
}
function $61de1ee1cac498ae$var$c4b(a) {
    var b, c, d, e;
    c = new $61de1ee1cac498ae$var$Lqb;
    for(e = new $61de1ee1cac498ae$var$olb(a.d); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 181);
        b = $61de1ee1cac498ae$var$BD(d.We(($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Dsc)), 17);
        !!$61de1ee1cac498ae$var$irb(c.f, b) || $61de1ee1cac498ae$var$Rhb(c, b, new $61de1ee1cac498ae$var$p4b(b));
        $61de1ee1cac498ae$var$Ekb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(c.f, b)), 456).b, d);
    }
    return new $61de1ee1cac498ae$var$Tkb(new $61de1ee1cac498ae$var$$ib(c));
}
function $61de1ee1cac498ae$var$Gac(a, b) {
    var c, d, e, f, g;
    d = new $61de1ee1cac498ae$var$kkb(a.j.c.length);
    c = null;
    for(f = new $61de1ee1cac498ae$var$olb(a.j); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 11);
        if (e.j != c) {
            d.b == d.c || $61de1ee1cac498ae$var$Hac(d, c, b);
            $61de1ee1cac498ae$var$Yjb(d);
            c = e.j;
        }
        g = $61de1ee1cac498ae$var$N3b(e);
        !!g && $61de1ee1cac498ae$var$Xjb(d, g);
    }
    d.b == d.c || $61de1ee1cac498ae$var$Hac(d, c, b);
}
function $61de1ee1cac498ae$var$wbc(a, b) {
    var c, d, e;
    d = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    while(d.b < d.d.gc()){
        c = ($61de1ee1cac498ae$var$sCb(d.b < d.d.gc()), $61de1ee1cac498ae$var$BD(d.d.Xb(d.c = d.b++), 70));
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc)), 272);
        if (e == ($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$oad)) {
            $61de1ee1cac498ae$var$uib(d);
            $61de1ee1cac498ae$var$Ekb(b.b, c);
            $61de1ee1cac498ae$var$wNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Dsc)) || $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$Dsc, a);
        }
    }
}
function $61de1ee1cac498ae$var$GDc(a) {
    var b, c, d, e, f;
    b = $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
    for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
        c = d.c.i;
        f = $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(c).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
        b = $61de1ee1cac498ae$var$$wnd.Math.max(b, f);
    }
    return $61de1ee1cac498ae$var$meb(b);
}
function $61de1ee1cac498ae$var$rUc(a, b, c) {
    var d, e, f, g;
    $61de1ee1cac498ae$var$Odd(c, "Processor arrange node", 1);
    e = null;
    f = new $61de1ee1cac498ae$var$Psb;
    d = $61de1ee1cac498ae$var$Jsb(b.b, 0);
    while(!e && d.b != d.d.c){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 86);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc)))) && (e = g);
    }
    $61de1ee1cac498ae$var$Gsb(f, e, f.c.b, f.c);
    $61de1ee1cac498ae$var$qUc(a, f, $61de1ee1cac498ae$var$Udd(c, 1));
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$Ffd(a, b, c) {
    var d, e, f;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$w8c)), 21);
    e = 0;
    f = 0;
    b.a > c.a && (d.Hc(($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$c8c)) ? e = (b.a - c.a) / 2 : d.Hc($61de1ee1cac498ae$var$e8c) && (e = b.a - c.a));
    b.b > c.b && (d.Hc(($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$g8c)) ? f = (b.b - c.b) / 2 : d.Hc($61de1ee1cac498ae$var$f8c) && (f = b.b - c.b));
    $61de1ee1cac498ae$var$Efd(a, e, f);
}
function $61de1ee1cac498ae$var$aod(a, b, c, d, e, f, g, h, i, j, k, l, m) {
    $61de1ee1cac498ae$var$JD(a.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(a.Cb, 88)), 4);
    $61de1ee1cac498ae$var$pnd(a, c);
    a.f = g;
    $61de1ee1cac498ae$var$dJd(a, h);
    $61de1ee1cac498ae$var$fJd(a, i);
    $61de1ee1cac498ae$var$ZId(a, j);
    $61de1ee1cac498ae$var$eJd(a, k);
    $61de1ee1cac498ae$var$CId(a, l);
    $61de1ee1cac498ae$var$aJd(a, m);
    $61de1ee1cac498ae$var$BId(a, true);
    $61de1ee1cac498ae$var$AId(a, e);
    a.ok(f);
    $61de1ee1cac498ae$var$yId(a, b);
    d != null && (a.i = null, $61de1ee1cac498ae$var$_Id(a, d));
}
function $61de1ee1cac498ae$var$PRd(a) {
    var b, c;
    if (a.f) {
        while(a.n > 0){
            b = $61de1ee1cac498ae$var$BD(a.k.Xb(a.n - 1), 72);
            c = b.ak();
            if ($61de1ee1cac498ae$var$JD(c, 99) && ($61de1ee1cac498ae$var$BD(c, 18).Bb & $61de1ee1cac498ae$var$ote) != 0 && (!a.e || c.Gj() != $61de1ee1cac498ae$var$x2 || c.aj() != 0) && b.dd() != null) return true;
            else --a.n;
        }
        return false;
    } else return a.n > 0;
}
function $61de1ee1cac498ae$var$Jb(a, b, c) {
    if (a < 0) return $61de1ee1cac498ae$var$hc($61de1ee1cac498ae$var$The, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        c,
        $61de1ee1cac498ae$var$meb(a)
    ]));
    else if (b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Vhe + b));
    else return $61de1ee1cac498ae$var$hc("%s (%s) must not be greater than size (%s)", $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        c,
        $61de1ee1cac498ae$var$meb(a),
        $61de1ee1cac498ae$var$meb(b)
    ]));
}
function $61de1ee1cac498ae$var$Llb(a, b, c, d, e, f) {
    var g, h, i, j;
    g = d - c;
    if (g < 7) {
        $61de1ee1cac498ae$var$Ilb(b, c, d, f);
        return;
    }
    i = c + e;
    h = d + e;
    j = i + (h - i >> 1);
    $61de1ee1cac498ae$var$Llb(b, a, i, j, -e, f);
    $61de1ee1cac498ae$var$Llb(b, a, j, h, -e, f);
    if (f.ue(a[j - 1], a[j]) <= 0) {
        while(c < d)$61de1ee1cac498ae$var$NC(b, c++, a[i++]);
        return;
    }
    $61de1ee1cac498ae$var$Jlb(a, i, j, h, b, c, d, f);
}
function $61de1ee1cac498ae$var$nEb(a, b) {
    var c, d, e;
    e = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$olb(a.c.a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 57);
        if (b.Lb(c)) {
            $61de1ee1cac498ae$var$Ekb(e, new $61de1ee1cac498ae$var$BEb(c, true));
            $61de1ee1cac498ae$var$Ekb(e, new $61de1ee1cac498ae$var$BEb(c, false));
        }
    }
    $61de1ee1cac498ae$var$tEb(a.e);
    $61de1ee1cac498ae$var$kDb(e, a.d, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$JM, 1), $61de1ee1cac498ae$var$Uhe, 679, 0, [
        a.e
    ])));
}
function $61de1ee1cac498ae$var$gnc(a, b) {
    var c, d, e, f, g, h, i;
    i = b.d;
    e = b.b.j;
    for(h = new $61de1ee1cac498ae$var$olb(i); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 101);
        f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, e.c.length, 16, 1);
        $61de1ee1cac498ae$var$Rhb(a.b, g, f);
        c = g.a.d.p - 1;
        d = g.c.d.p;
        while(c != d){
            c = (c + 1) % e.c.length;
            f[c] = true;
        }
    }
}
function $61de1ee1cac498ae$var$tOc(a, b) {
    a.r = new $61de1ee1cac498ae$var$uOc(a.p);
    $61de1ee1cac498ae$var$sOc(a.r, a);
    $61de1ee1cac498ae$var$ye(a.r.j, a.j);
    $61de1ee1cac498ae$var$Osb(a.j);
    $61de1ee1cac498ae$var$Dsb(a.j, b);
    $61de1ee1cac498ae$var$Dsb(a.r.e, b);
    $61de1ee1cac498ae$var$lOc(a);
    $61de1ee1cac498ae$var$lOc(a.r);
    while(a.f.c.length != 0)$61de1ee1cac498ae$var$AOc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.f, 0), 129));
    while(a.k.c.length != 0)$61de1ee1cac498ae$var$AOc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.k, 0), 129));
    return a.r;
}
function $61de1ee1cac498ae$var$yid(a, b, c) {
    var d, e, f;
    e = $61de1ee1cac498ae$var$XKd(a.Tg(), b);
    d = b - a.Ah();
    if (d < 0) {
        if (!e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$mte + b + $61de1ee1cac498ae$var$nte));
        else if (e.Ij()) {
            f = a.Yg(e);
            f >= 0 ? a.sh(f, c) : $61de1ee1cac498ae$var$uid(a, e, c);
        } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + e.ne() + $61de1ee1cac498ae$var$jte));
    } else $61de1ee1cac498ae$var$did(a, d, e, c);
}
function $61de1ee1cac498ae$var$q6d(b) {
    var c, d, e, f;
    d = $61de1ee1cac498ae$var$BD(b, 49).qh();
    if (d) try {
        e = null;
        c = $61de1ee1cac498ae$var$nUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$LEd($61de1ee1cac498ae$var$MEd(d)));
        if (c) {
            f = c.rh();
            !!f && (e = f.Wk($61de1ee1cac498ae$var$tfb(d.e)));
        }
        if (!!e && e != b) return $61de1ee1cac498ae$var$q6d(e);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if (!$61de1ee1cac498ae$var$JD(a, 60)) throw $61de1ee1cac498ae$var$vbb(a);
    }
    return b;
}
function $61de1ee1cac498ae$var$jrb(a, b, c) {
    var d, e, f, g;
    g = b == null ? 0 : a.b.se(b);
    e = (d = a.a.get(g), d == null ? new Array : d);
    if (e.length == 0) a.a.set(g, e);
    else {
        f = $61de1ee1cac498ae$var$grb(a, b, e);
        if (f) return f.ed(c);
    }
    $61de1ee1cac498ae$var$NC(e, e.length, new $61de1ee1cac498ae$var$pjb(b, c));
    ++a.c;
    $61de1ee1cac498ae$var$zpb(a.b);
    return null;
}
function $61de1ee1cac498ae$var$YUc(a, b) {
    var c, d;
    $61de1ee1cac498ae$var$H2c(a.a);
    $61de1ee1cac498ae$var$K2c(a.a, ($61de1ee1cac498ae$var$PUc(), $61de1ee1cac498ae$var$NUc), $61de1ee1cac498ae$var$NUc);
    $61de1ee1cac498ae$var$K2c(a.a, $61de1ee1cac498ae$var$OUc, $61de1ee1cac498ae$var$OUc);
    d = new $61de1ee1cac498ae$var$j3c;
    $61de1ee1cac498ae$var$e3c(d, $61de1ee1cac498ae$var$OUc, ($61de1ee1cac498ae$var$tVc(), $61de1ee1cac498ae$var$sVc));
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$LWc))) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$pWc(), $61de1ee1cac498ae$var$mWc)) && $61de1ee1cac498ae$var$e3c(d, $61de1ee1cac498ae$var$OUc, $61de1ee1cac498ae$var$qVc);
    $61de1ee1cac498ae$var$e3c(d, $61de1ee1cac498ae$var$OUc, $61de1ee1cac498ae$var$rVc);
    $61de1ee1cac498ae$var$E2c(a.a, d);
    c = $61de1ee1cac498ae$var$F2c(a.a, b);
    return c;
}
function $61de1ee1cac498ae$var$uC(a) {
    if (!a) return $61de1ee1cac498ae$var$OB(), $61de1ee1cac498ae$var$NB;
    var b = a.valueOf ? a.valueOf() : a;
    if (b !== a) {
        var c = $61de1ee1cac498ae$var$qC[typeof b];
        return c ? c(b) : $61de1ee1cac498ae$var$xC(typeof b);
    } else if (a instanceof Array || a instanceof $61de1ee1cac498ae$var$$wnd.Array) return new $61de1ee1cac498ae$var$xB(a);
    else return new $61de1ee1cac498ae$var$fC(a);
}
function $61de1ee1cac498ae$var$RJb(a, b, c) {
    var d, e, f;
    f = a.o;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.p, c), 244);
    e = d.i;
    e.b = $61de1ee1cac498ae$var$gIb(d);
    e.a = $61de1ee1cac498ae$var$fIb(d);
    e.b = $61de1ee1cac498ae$var$$wnd.Math.max(e.b, f.a);
    e.b > f.a && !b && (e.b = f.a);
    e.c = -(e.b - f.a) / 2;
    switch(c.g){
        case 1:
            e.d = -e.a;
            break;
        case 3:
            e.d = f.b;
    }
    $61de1ee1cac498ae$var$hIb(d);
    $61de1ee1cac498ae$var$iIb(d);
}
function $61de1ee1cac498ae$var$SJb(a, b, c) {
    var d, e, f;
    f = a.o;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.p, c), 244);
    e = d.i;
    e.b = $61de1ee1cac498ae$var$gIb(d);
    e.a = $61de1ee1cac498ae$var$fIb(d);
    e.a = $61de1ee1cac498ae$var$$wnd.Math.max(e.a, f.b);
    e.a > f.b && !b && (e.a = f.b);
    e.d = -(e.a - f.b) / 2;
    switch(c.g){
        case 4:
            e.c = -e.b;
            break;
        case 2:
            e.c = f.a;
    }
    $61de1ee1cac498ae$var$hIb(d);
    $61de1ee1cac498ae$var$iIb(d);
}
function $61de1ee1cac498ae$var$Jgc(a, b) {
    var c, d, e, f, g;
    if (b.dc()) return;
    e = $61de1ee1cac498ae$var$BD(b.Xb(0), 128);
    if (b.gc() == 1) {
        $61de1ee1cac498ae$var$Igc(a, e, e, 1, 0, b);
        return;
    }
    c = 1;
    while(c < b.gc())if (e.j || !e.o) {
        f = $61de1ee1cac498ae$var$Ogc(b, c);
        if (f) {
            d = $61de1ee1cac498ae$var$BD(f.a, 19).a;
            g = $61de1ee1cac498ae$var$BD(f.b, 128);
            $61de1ee1cac498ae$var$Igc(a, e, g, c, d, b);
            c = d + 1;
            e = g;
        }
    }
}
function $61de1ee1cac498ae$var$mlc(a) {
    var b, c, d, e, f, g;
    g = new $61de1ee1cac498ae$var$Tkb(a.d);
    $61de1ee1cac498ae$var$Okb(g, new $61de1ee1cac498ae$var$Qlc);
    b = ($61de1ee1cac498ae$var$Alc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KV, 1), $61de1ee1cac498ae$var$Kie, 270, 0, [
        $61de1ee1cac498ae$var$tlc,
        $61de1ee1cac498ae$var$wlc,
        $61de1ee1cac498ae$var$slc,
        $61de1ee1cac498ae$var$zlc,
        $61de1ee1cac498ae$var$vlc,
        $61de1ee1cac498ae$var$ulc,
        $61de1ee1cac498ae$var$ylc,
        $61de1ee1cac498ae$var$xlc
    ]));
    c = 0;
    for(f = new $61de1ee1cac498ae$var$olb(g); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 101);
        d = b[c % b.length];
        $61de1ee1cac498ae$var$olc(e, d);
        ++c;
    }
}
function $61de1ee1cac498ae$var$o6c(a, b) {
    $61de1ee1cac498ae$var$i6c();
    var c, d, e, f;
    if (b.b < 2) return false;
    f = $61de1ee1cac498ae$var$Jsb(b, 0);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 8);
    d = c;
    while(f.b != f.d.c){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 8);
        if (!($61de1ee1cac498ae$var$m6c(a, d) && $61de1ee1cac498ae$var$m6c(a, e))) return false;
        d = e;
    }
    if (!($61de1ee1cac498ae$var$m6c(a, d) && $61de1ee1cac498ae$var$m6c(a, c))) return false;
    return true;
}
function $61de1ee1cac498ae$var$hrd(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = null;
    l = a;
    g = $61de1ee1cac498ae$var$Xpd(l, "x");
    c = new $61de1ee1cac498ae$var$Krd(b);
    $61de1ee1cac498ae$var$Gqd(c.a, g);
    h = $61de1ee1cac498ae$var$Xpd(l, "y");
    d = new $61de1ee1cac498ae$var$Lrd(b);
    $61de1ee1cac498ae$var$Hqd(d.a, h);
    i = $61de1ee1cac498ae$var$Xpd(l, $61de1ee1cac498ae$var$Gte);
    e = new $61de1ee1cac498ae$var$Mrd(b);
    $61de1ee1cac498ae$var$Iqd(e.a, i);
    j = $61de1ee1cac498ae$var$Xpd(l, $61de1ee1cac498ae$var$Fte);
    f = new $61de1ee1cac498ae$var$Nrd(b);
    k = ($61de1ee1cac498ae$var$Jqd(f.a, j), j);
    return k;
}
function $61de1ee1cac498ae$var$XMd(a, b) {
    $61de1ee1cac498ae$var$TMd(a, b);
    (a.b & 1) != 0 && (a.a.a = null);
    (a.b & 2) != 0 && (a.a.f = null);
    if ((a.b & 4) != 0) {
        a.a.g = null;
        a.a.i = null;
    }
    if ((a.b & 16) != 0) {
        a.a.d = null;
        a.a.e = null;
    }
    (a.b & 8) != 0 && (a.a.b = null);
    if ((a.b & 32) != 0) {
        a.a.j = null;
        a.a.c = null;
    }
}
function $61de1ee1cac498ae$var$l0d(b, c) {
    var d, e, f;
    f = 0;
    if (c.length > 0) try {
        f = $61de1ee1cac498ae$var$Icb(c, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 127)) {
            e = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$rFd(e));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
    d = (!b.a && (b.a = new $61de1ee1cac498ae$var$z0d(b)), b.a);
    return f < d.i && f >= 0 ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(d, f), 56) : null;
}
function $61de1ee1cac498ae$var$Ib(a, b) {
    if (a < 0) return $61de1ee1cac498ae$var$hc($61de1ee1cac498ae$var$The, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        "index",
        $61de1ee1cac498ae$var$meb(a)
    ]));
    else if (b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Vhe + b));
    else return $61de1ee1cac498ae$var$hc("%s (%s) must be less than size (%s)", $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        "index",
        $61de1ee1cac498ae$var$meb(a),
        $61de1ee1cac498ae$var$meb(b)
    ]));
}
function $61de1ee1cac498ae$var$Slb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new $61de1ee1cac498ae$var$Wfb(f.d) : $61de1ee1cac498ae$var$Qfb(f.a, f.b);
        $61de1ee1cac498ae$var$Nfb(f.a, "" + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$Tlb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new $61de1ee1cac498ae$var$Wfb(f.d) : $61de1ee1cac498ae$var$Qfb(f.a, f.b);
        $61de1ee1cac498ae$var$Nfb(f.a, "" + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$Ulb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new $61de1ee1cac498ae$var$Wfb(f.d) : $61de1ee1cac498ae$var$Qfb(f.a, f.b);
        $61de1ee1cac498ae$var$Nfb(f.a, "" + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$Xlb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new $61de1ee1cac498ae$var$Wfb(f.d) : $61de1ee1cac498ae$var$Qfb(f.a, f.b);
        $61de1ee1cac498ae$var$Nfb(f.a, "" + b);
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$bub(a, b) {
    var c, d, e, f, g, h;
    c = a.b.c.length;
    e = $61de1ee1cac498ae$var$Ikb(a.b, b);
    while(b * 2 + 1 < c){
        d = (f = 2 * b + 1, g = f + 1, h = f, g < c && a.a.ue($61de1ee1cac498ae$var$Ikb(a.b, g), $61de1ee1cac498ae$var$Ikb(a.b, f)) < 0 && (h = g), h);
        if (a.a.ue(e, $61de1ee1cac498ae$var$Ikb(a.b, d)) < 0) break;
        $61de1ee1cac498ae$var$Nkb(a.b, b, $61de1ee1cac498ae$var$Ikb(a.b, d));
        b = d;
    }
    $61de1ee1cac498ae$var$Nkb(a.b, b, e);
}
function $61de1ee1cac498ae$var$$Bb(a, b, c, d, e, f) {
    var g, h, i, j, k;
    if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(c)) {
        a = a.slice(b, b + e);
        b = 0;
    }
    i = c;
    for(h = b, j = b + e; h < j;){
        g = $61de1ee1cac498ae$var$$wnd.Math.min(h + 10000, j);
        e = g - h;
        k = a.slice(h, g);
        k.splice(0, 0, d, f ? e : 0);
        Array.prototype.splice.apply(i, k);
        h = g;
        d += e;
    }
}
function $61de1ee1cac498ae$var$xGb(a, b, c) {
    var d, e;
    d = c.d;
    e = c.e;
    if (a.g[d.d] <= a.i[b.d] && a.i[b.d] <= a.i[d.d] && a.g[e.d] <= a.i[b.d] && a.i[b.d] <= a.i[e.d]) {
        if (a.i[d.d] < a.i[e.d]) return false;
        return true;
    }
    if (a.i[d.d] < a.i[e.d]) return true;
    return false;
}
function $61de1ee1cac498ae$var$cRb(a) {
    var b, c, d, e, f, g, h;
    d = a.a.c.length;
    if (d > 0) {
        g = a.c.d;
        h = a.d.d;
        e = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(h.a, h.b), g), 1 / (d + 1));
        f = new $61de1ee1cac498ae$var$f7c(g.a, g.b);
        for(c = new $61de1ee1cac498ae$var$olb(a.a); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 559);
            b.d.a = f.a;
            b.d.b = f.b;
            $61de1ee1cac498ae$var$P6c(f, e);
        }
    }
}
function $61de1ee1cac498ae$var$YNb(a, b, c) {
    var d, e, f, g, h, i;
    i = $61de1ee1cac498ae$var$Pje;
    for(f = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$wOb(a.b)); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 168);
        for(h = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$wOb(b.b)); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 168);
            d = $61de1ee1cac498ae$var$p6c(e.a, e.b, g.a, g.b, c);
            i = $61de1ee1cac498ae$var$$wnd.Math.min(i, d);
        }
    }
    return i;
}
function $61de1ee1cac498ae$var$G0b(a, b) {
    if (!b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Geb);
    a.j = b;
    if (!a.d) switch(a.j.g){
        case 1:
            a.a.a = a.o.a / 2;
            a.a.b = 0;
            break;
        case 2:
            a.a.a = a.o.a;
            a.a.b = a.o.b / 2;
            break;
        case 3:
            a.a.a = a.o.a / 2;
            a.a.b = a.o.b;
            break;
        case 4:
            a.a.a = 0;
            a.a.b = a.o.b / 2;
    }
}
function $61de1ee1cac498ae$var$dfc(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$JD(b.g, 10) && $61de1ee1cac498ae$var$BD(b.g, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) return $61de1ee1cac498ae$var$Pje;
    e = $61de1ee1cac498ae$var$ugc(b);
    if (e) return $61de1ee1cac498ae$var$$wnd.Math.max(0, a.b / 2 - 0.5);
    c = $61de1ee1cac498ae$var$tgc(b);
    if (c) {
        d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc))));
        return $61de1ee1cac498ae$var$$wnd.Math.max(0, d / 2 - 0.5);
    }
    return $61de1ee1cac498ae$var$Pje;
}
function $61de1ee1cac498ae$var$ffc(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$JD(b.g, 10) && $61de1ee1cac498ae$var$BD(b.g, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) return $61de1ee1cac498ae$var$Pje;
    e = $61de1ee1cac498ae$var$ugc(b);
    if (e) return $61de1ee1cac498ae$var$$wnd.Math.max(0, a.b / 2 - 0.5);
    c = $61de1ee1cac498ae$var$tgc(b);
    if (c) {
        d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc))));
        return $61de1ee1cac498ae$var$$wnd.Math.max(0, d / 2 - 0.5);
    }
    return $61de1ee1cac498ae$var$Pje;
}
function $61de1ee1cac498ae$var$xic(a) {
    var b, c, d, e, f, g;
    g = $61de1ee1cac498ae$var$CHc(a.d, a.e);
    for(f = g.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 11);
        d = a.e == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? e.e : e.g;
        for(c = new $61de1ee1cac498ae$var$olb(d); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 17);
            if (!$61de1ee1cac498ae$var$OZb(b) && b.c.i.c != b.d.i.c) {
                $61de1ee1cac498ae$var$tic(a, b);
                ++a.f;
                ++a.c;
            }
        }
    }
}
function $61de1ee1cac498ae$var$tpc(a, b) {
    var c, d;
    if (b.dc()) return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
    d = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Ekb(d, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Rie));
    for(c = 1; c < a.f; ++c){
        a.a == null && $61de1ee1cac498ae$var$Toc(a);
        a.a[c] && $61de1ee1cac498ae$var$Ekb(d, $61de1ee1cac498ae$var$meb(c));
    }
    if (d.c.length == 1) return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
    $61de1ee1cac498ae$var$Ekb(d, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Ohe));
    return $61de1ee1cac498ae$var$spc(b, d);
}
function $61de1ee1cac498ae$var$MJc(a, b) {
    var c, d, e, f, g, h, i;
    g = b.c.i.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
    i = g ? b.d : b.c;
    c = $61de1ee1cac498ae$var$MZb(b, i).i;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.k, i), 121);
    d = a.i[c.p].a;
    if ($61de1ee1cac498ae$var$S_b(i.i) < (!c.c ? -1 : $61de1ee1cac498ae$var$Jkb(c.c.a, c, 0))) {
        f = e;
        h = d;
    } else {
        f = d;
        h = e;
    }
    $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 0), 4), f), h));
}
function $61de1ee1cac498ae$var$oqd(a, b, c) {
    var d, e, f, g, h, i;
    if (c) {
        e = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(e);
        for(h = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            i = $61de1ee1cac498ae$var$Wqd(a, $61de1ee1cac498ae$var$Vpd($61de1ee1cac498ae$var$tB(c, g.a)));
            if (i) {
                f = (!b.b && (b.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 4, 7)), b.b);
                $61de1ee1cac498ae$var$wtd(f, i);
            }
        }
    }
}
function $61de1ee1cac498ae$var$pqd(a, b, c) {
    var d, e, f, g, h, i;
    if (c) {
        e = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(e);
        for(h = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            i = $61de1ee1cac498ae$var$Wqd(a, $61de1ee1cac498ae$var$Vpd($61de1ee1cac498ae$var$tB(c, g.a)));
            if (i) {
                f = (!b.c && (b.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 5, 8)), b.c);
                $61de1ee1cac498ae$var$wtd(f, i);
            }
        }
    }
}
function $61de1ee1cac498ae$var$po(a, b, c) {
    var d, e;
    d = b.a & a.f;
    b.b = a.b[d];
    a.b[d] = b;
    e = b.f & a.f;
    b.d = a.c[e];
    a.c[e] = b;
    if (!c) {
        b.e = a.e;
        b.c = null;
        !a.e ? a.a = b : a.e.c = b;
        a.e = b;
    } else {
        b.e = c.e;
        !b.e ? a.a = b : b.e.c = b;
        b.c = c.c;
        !b.c ? a.e = b : b.c.e = b;
    }
    ++a.i;
    ++a.g;
}
function $61de1ee1cac498ae$var$qr(a) {
    var b, c, d;
    b = a.Pb();
    if (!a.Ob()) return b;
    d = $61de1ee1cac498ae$var$Pfb($61de1ee1cac498ae$var$Qfb(new $61de1ee1cac498ae$var$Ufb, "expected one element but was: <"), b);
    for(c = 0; c < 4 && a.Ob(); c++)$61de1ee1cac498ae$var$Pfb((d.a += $61de1ee1cac498ae$var$She, d), a.Pb());
    a.Ob() && (d.a += ", ...", d);
    d.a += ">";
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb(d.a));
}
function $61de1ee1cac498ae$var$lt(a, b) {
    var c;
    b.d ? b.d.b = b.b : a.a = b.b;
    b.b ? b.b.d = b.d : a.e = b.d;
    if (!b.e && !b.c) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Thb(a.b, b.a), 283);
        c.a = 0;
        ++a.c;
    } else {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b.a), 283);
        --c.a;
        !b.e ? c.b = b.c : b.e.c = b.c;
        !b.c ? c.c = b.e : b.c.e = b.e;
    }
    --a.d;
}
function $61de1ee1cac498ae$var$OA(a) {
    var b, c;
    c = -a.a;
    b = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$TD, 1), $61de1ee1cac498ae$var$$ie, 25, 15, [
        43,
        48,
        48,
        48,
        48
    ]);
    if (c < 0) {
        b[0] = 45;
        c = -c;
    }
    b[1] = b[1] + ((c / 60 | 0) / 10 | 0) & $61de1ee1cac498ae$var$aje;
    b[2] = b[2] + (c / 60 | 0) % 10 & $61de1ee1cac498ae$var$aje;
    b[3] = b[3] + (c % 60 / 10 | 0) & $61de1ee1cac498ae$var$aje;
    b[4] = b[4] + c % 10 & $61de1ee1cac498ae$var$aje;
    return $61de1ee1cac498ae$var$zfb(b, 0, b.length);
}
function $61de1ee1cac498ae$var$uRb(a, b, c) {
    var d, e;
    d = b.d;
    e = c.d;
    while(d.a - e.a == 0 && d.b - e.b == 0){
        d.a += $61de1ee1cac498ae$var$Cub(a, 26) * $61de1ee1cac498ae$var$ike + $61de1ee1cac498ae$var$Cub(a, 27) * $61de1ee1cac498ae$var$jke - 0.5;
        d.b += $61de1ee1cac498ae$var$Cub(a, 26) * $61de1ee1cac498ae$var$ike + $61de1ee1cac498ae$var$Cub(a, 27) * $61de1ee1cac498ae$var$jke - 0.5;
        e.a += $61de1ee1cac498ae$var$Cub(a, 26) * $61de1ee1cac498ae$var$ike + $61de1ee1cac498ae$var$Cub(a, 27) * $61de1ee1cac498ae$var$jke - 0.5;
        e.b += $61de1ee1cac498ae$var$Cub(a, 26) * $61de1ee1cac498ae$var$ike + $61de1ee1cac498ae$var$Cub(a, 27) * $61de1ee1cac498ae$var$jke - 0.5;
    }
}
function $61de1ee1cac498ae$var$N_b(a) {
    var b, c, d, e;
    a.g = new $61de1ee1cac498ae$var$Rpb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb($61de1ee1cac498ae$var$F1), 290));
    d = 0;
    c = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd);
    b = 0;
    for(; b < a.j.c.length; b++){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, b), 11);
        if (e.j != c) {
            d != b && $61de1ee1cac498ae$var$Npb(a.g, c, new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(d), $61de1ee1cac498ae$var$meb(b)));
            c = e.j;
            d = b;
        }
    }
    $61de1ee1cac498ae$var$Npb(a.g, c, new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(d), $61de1ee1cac498ae$var$meb(b)));
}
function $61de1ee1cac498ae$var$d4b(a) {
    var b, c, d, e, f, g, h;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$olb(a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 29);
        for(f = new $61de1ee1cac498ae$var$olb(b.a); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
            e.p = d++;
            for(h = new $61de1ee1cac498ae$var$olb(e.j); h.a < h.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
                g.p = d++;
            }
        }
    }
}
function $61de1ee1cac498ae$var$qPc(a, b, c, d, e) {
    var f, g, h, i, j;
    if (b) for(h = b.Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 10);
        for(j = $61de1ee1cac498ae$var$X_b(g, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc), c).Kc(); j.Ob();){
            i = $61de1ee1cac498ae$var$BD(j.Pb(), 11);
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(e.f, i)), 112);
            if (!f) {
                f = new $61de1ee1cac498ae$var$uOc(a.d);
                d.c[d.c.length] = f;
                $61de1ee1cac498ae$var$jOc(f, i, e);
            }
        }
    }
}
function $61de1ee1cac498ae$var$vid(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a.Tg(), b);
    if (e) {
        $61de1ee1cac498ae$var$Q6d();
        $61de1ee1cac498ae$var$BD(e, 66).Oj() || (e = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, e)));
        d = (c = a.Yg(e), $61de1ee1cac498ae$var$BD(c >= 0 ? a._g(c, true, true) : $61de1ee1cac498ae$var$sid(a, e, true), 153));
        $61de1ee1cac498ae$var$BD(d, 215).ol(b);
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b.ne() + $61de1ee1cac498ae$var$jte));
}
function $61de1ee1cac498ae$var$ugb(a) {
    var b, c;
    if (a > -140737488355328 && a < 140737488355328) {
        if (a == 0) return 0;
        b = a < 0;
        b && (a = -a);
        c = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.floor($61de1ee1cac498ae$var$$wnd.Math.log(a) / 0.6931471805599453));
        (!b || a != $61de1ee1cac498ae$var$$wnd.Math.pow(2, c)) && ++c;
        return c;
    }
    return $61de1ee1cac498ae$var$vgb($61de1ee1cac498ae$var$Cbb(a));
}
function $61de1ee1cac498ae$var$QOc(a) {
    var b, c, d, e, f, g, h;
    f = new $61de1ee1cac498ae$var$zsb;
    for(c = new $61de1ee1cac498ae$var$olb(a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 129);
        g = b.a;
        h = b.b;
        if (f.a._b(g) || f.a._b(h)) continue;
        e = g;
        d = h;
        if (g.e.b + g.j.b > 2 && h.e.b + h.j.b <= 2) {
            e = h;
            d = g;
        }
        f.a.zc(e, f);
        e.q = d;
    }
    return f;
}
function $61de1ee1cac498ae$var$K5b(a, b) {
    var c, d, e;
    d = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$tNb(d, b);
    $61de1ee1cac498ae$var$yNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Gsc), b);
    $61de1ee1cac498ae$var$yNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
    $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$B7c));
    $61de1ee1cac498ae$var$__b(d, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b));
    c = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(c, d);
    $61de1ee1cac498ae$var$G0b(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    e = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(e, d);
    $61de1ee1cac498ae$var$G0b(e, $61de1ee1cac498ae$var$zcd);
    return d;
}
function $61de1ee1cac498ae$var$Spc(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$fGc(($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$oGc));
        case 1:
            return new $61de1ee1cac498ae$var$CFc;
        case 2:
            return new $61de1ee1cac498ae$var$fHc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("No implementation is available for the crossing minimizer " + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$tDc(a, b) {
    var c, d, e, f, g;
    a.c[b.p] = true;
    $61de1ee1cac498ae$var$Ekb(a.a, b);
    for(g = new $61de1ee1cac498ae$var$olb(b.j); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 11);
        for(d = new $61de1ee1cac498ae$var$b1b(f.b); $61de1ee1cac498ae$var$llb(d.a) || $61de1ee1cac498ae$var$llb(d.b);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(d.a) ? $61de1ee1cac498ae$var$mlb(d.a) : $61de1ee1cac498ae$var$mlb(d.b), 17);
            e = $61de1ee1cac498ae$var$uDc(f, c).i;
            a.c[e.p] || $61de1ee1cac498ae$var$tDc(a, e);
        }
    }
}
function $61de1ee1cac498ae$var$_Uc(a) {
    var b, c, d, e, f, g, h;
    g = 0;
    for(c = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 33);
        h = b.g;
        e = b.f;
        d = $61de1ee1cac498ae$var$$wnd.Math.sqrt(h * h + e * e);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(d, g);
        f = $61de1ee1cac498ae$var$_Uc(b);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(f, g);
    }
    return g;
}
function $61de1ee1cac498ae$var$rcd() {
    $61de1ee1cac498ae$var$rcd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$pcd = new $61de1ee1cac498ae$var$scd("OUTSIDE", 0);
    $61de1ee1cac498ae$var$ncd = new $61de1ee1cac498ae$var$scd("INSIDE", 1);
    $61de1ee1cac498ae$var$ocd = new $61de1ee1cac498ae$var$scd("NEXT_TO_PORT_IF_POSSIBLE", 2);
    $61de1ee1cac498ae$var$mcd = new $61de1ee1cac498ae$var$scd("ALWAYS_SAME_SIDE", 3);
    $61de1ee1cac498ae$var$lcd = new $61de1ee1cac498ae$var$scd("ALWAYS_OTHER_SAME_SIDE", 4);
    $61de1ee1cac498ae$var$qcd = new $61de1ee1cac498ae$var$scd("SPACE_EFFICIENT", 5);
}
function $61de1ee1cac498ae$var$drd(a, b, c) {
    var d, e, f, h, i, j;
    d = $61de1ee1cac498ae$var$Tqd(a, (e = ($61de1ee1cac498ae$var$Fhd(), f = new $61de1ee1cac498ae$var$apd, f), !!c && $61de1ee1cac498ae$var$$od(e, c), e), b);
    $61de1ee1cac498ae$var$Lkd(d, $61de1ee1cac498ae$var$_pd(b, $61de1ee1cac498ae$var$Vte));
    $61de1ee1cac498ae$var$grd(b, d);
    $61de1ee1cac498ae$var$brd(b, d);
    $61de1ee1cac498ae$var$hrd(b, d);
    $61de1ee1cac498ae$var$g = null;
    h = b;
    i = $61de1ee1cac498ae$var$Ypd(h, "ports");
    j = new $61de1ee1cac498ae$var$Jrd(a, d);
    $61de1ee1cac498ae$var$Fqd(j.a, j.b, i);
    $61de1ee1cac498ae$var$crd(a, b, d);
    $61de1ee1cac498ae$var$Zqd(a, b, d);
    return d;
}
function $61de1ee1cac498ae$var$NA(a) {
    var b, c;
    c = -a.a;
    b = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$TD, 1), $61de1ee1cac498ae$var$$ie, 25, 15, [
        43,
        48,
        48,
        58,
        48,
        48
    ]);
    if (c < 0) {
        b[0] = 45;
        c = -c;
    }
    b[1] = b[1] + ((c / 60 | 0) / 10 | 0) & $61de1ee1cac498ae$var$aje;
    b[2] = b[2] + (c / 60 | 0) % 10 & $61de1ee1cac498ae$var$aje;
    b[4] = b[4] + (c % 60 / 10 | 0) & $61de1ee1cac498ae$var$aje;
    b[5] = b[5] + c % 10 & $61de1ee1cac498ae$var$aje;
    return $61de1ee1cac498ae$var$zfb(b, 0, b.length);
}
function $61de1ee1cac498ae$var$QA(a) {
    var b;
    b = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$TD, 1), $61de1ee1cac498ae$var$$ie, 25, 15, [
        71,
        77,
        84,
        45,
        48,
        48,
        58,
        48,
        48
    ]);
    if (a <= 0) {
        b[3] = 43;
        a = -a;
    }
    b[4] = b[4] + ((a / 60 | 0) / 10 | 0) & $61de1ee1cac498ae$var$aje;
    b[5] = b[5] + (a / 60 | 0) % 10 & $61de1ee1cac498ae$var$aje;
    b[7] = b[7] + (a % 60 / 10 | 0) & $61de1ee1cac498ae$var$aje;
    b[8] = b[8] + a % 10 & $61de1ee1cac498ae$var$aje;
    return $61de1ee1cac498ae$var$zfb(b, 0, b.length);
}
function $61de1ee1cac498ae$var$Vlb(a) {
    var b, c, d, e, f;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    f = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(c = a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        !f.a ? f.a = new $61de1ee1cac498ae$var$Wfb(f.d) : $61de1ee1cac498ae$var$Qfb(f.a, f.b);
        $61de1ee1cac498ae$var$Nfb(f.a, "" + $61de1ee1cac498ae$var$Ubb(b));
    }
    return !f.a ? f.c : f.e.length == 0 ? f.a.a : f.a.a + ("" + f.e);
}
function $61de1ee1cac498ae$var$DGb(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$Ohe;
    for(d = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$LFb(b)); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 213);
        if (c.f && !a.c[c.c]) {
            a.c[c.c] = true;
            e = $61de1ee1cac498ae$var$$wnd.Math.min(e, $61de1ee1cac498ae$var$DGb(a, $61de1ee1cac498ae$var$xFb(c, b)));
        }
    }
    a.i[b.d] = a.j;
    a.g[b.d] = $61de1ee1cac498ae$var$$wnd.Math.min(e, a.j++);
    return a.g[b.d];
}
function $61de1ee1cac498ae$var$EKb(a, b) {
    var c, d, e;
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 111);
        d.e.b = (c = d.b, c.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c)) ? c.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? -c.rf().b - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c.We($61de1ee1cac498ae$var$s9c))) : $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(c.We($61de1ee1cac498ae$var$s9c))) : c.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? -c.rf().b : 0);
    }
}
function $61de1ee1cac498ae$var$LPb(a) {
    var b, c, d, e, f, g, h;
    c = $61de1ee1cac498ae$var$IOb(a.e);
    f = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$b7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$HOb(a.e)), a.d * a.a, a.c * a.b), -0.5);
    b = c.a - f.a;
    e = c.b - f.b;
    for(h = 0; h < a.c; h++){
        d = b;
        for(g = 0; g < a.d; g++){
            $61de1ee1cac498ae$var$JOb(a.e, new $61de1ee1cac498ae$var$J6c(d, e, a.a, a.b)) && $61de1ee1cac498ae$var$aNb(a, g, h, false, true);
            d += a.a;
        }
        e += a.b;
    }
}
function $61de1ee1cac498ae$var$s2c(a) {
    var b, c, d;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$M8c))))) {
        d = new $61de1ee1cac498ae$var$Rkb;
        for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 79);
            $61de1ee1cac498ae$var$Qld(b) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$N8c))) && (d.c[d.c.length] = b);
        }
        return d;
    } else return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
}
function $61de1ee1cac498ae$var$Vpd(a) {
    var b, c;
    c = false;
    if ($61de1ee1cac498ae$var$JD(a, 204)) {
        c = true;
        return $61de1ee1cac498ae$var$BD(a, 204).a;
    }
    if (!c) {
        if ($61de1ee1cac498ae$var$JD(a, 258)) {
            b = $61de1ee1cac498ae$var$BD(a, 258).a % 1 == 0;
            if (b) {
                c = true;
                return $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Idb($61de1ee1cac498ae$var$BD(a, 258).a));
            }
        }
    }
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("Id must be a string or an integer: '" + a + "'."));
}
function $61de1ee1cac498ae$var$k0d(a, b) {
    var c, d, e, f, g, h;
    f = null;
    for(e = new $61de1ee1cac498ae$var$x0d((!a.a && (a.a = new $61de1ee1cac498ae$var$z0d(a)), a.a)); $61de1ee1cac498ae$var$u0d(e);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Vud(e), 56);
        d = (g = c.Tg(), h = ($61de1ee1cac498ae$var$OKd(g), g.o), !h || !c.mh(h) ? null : $61de1ee1cac498ae$var$h6d($61de1ee1cac498ae$var$KJd(h), c.ah(h)));
        if (d != null) {
            if ($61de1ee1cac498ae$var$dfb(d, b)) {
                f = c;
                break;
            }
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$Bw(a, b, c) {
    var d, e, f, g, h;
    $61de1ee1cac498ae$var$Xj(c, "occurrences");
    if (c == 0) return h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$nd(a.a), b), 14), !h ? 0 : h.gc();
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$nd(a.a), b), 14);
    if (!g) return 0;
    f = g.gc();
    if (c >= f) g.$b();
    else {
        e = g.Kc();
        for(d = 0; d < c; d++){
            e.Pb();
            e.Qb();
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$ax(a, b, c) {
    var d, e, f, g;
    $61de1ee1cac498ae$var$Xj(c, "oldCount");
    $61de1ee1cac498ae$var$Xj(0, "newCount");
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$nd(a.a), b), 14);
    if ((!d ? 0 : d.gc()) == c) {
        $61de1ee1cac498ae$var$Xj(0, "count");
        e = (f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$nd(a.a), b), 14), !f ? 0 : f.gc());
        g = -e;
        g > 0 ? $61de1ee1cac498ae$var$zh() : g < 0 && $61de1ee1cac498ae$var$Bw(a, b, -g);
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$fIb(a) {
    var b, c, d, e, f, g, h;
    h = 0;
    if (a.b == 0) {
        g = $61de1ee1cac498ae$var$jIb(a, true);
        b = 0;
        for(d = g, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if (c > 0) {
                h += c;
                ++b;
            }
        }
        b > 1 && (h += a.c * (b - 1));
    } else h = $61de1ee1cac498ae$var$Mtb($61de1ee1cac498ae$var$Zzb($61de1ee1cac498ae$var$OAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$Plb(a.a), new $61de1ee1cac498ae$var$xIb), new $61de1ee1cac498ae$var$zIb)));
    return h > 0 ? h + a.n.d + a.n.a : 0;
}
function $61de1ee1cac498ae$var$gIb(a) {
    var b, c, d, e, f, g, h;
    h = 0;
    if (a.b == 0) h = $61de1ee1cac498ae$var$Mtb($61de1ee1cac498ae$var$Zzb($61de1ee1cac498ae$var$OAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$Plb(a.a), new $61de1ee1cac498ae$var$tIb), new $61de1ee1cac498ae$var$vIb)));
    else {
        g = $61de1ee1cac498ae$var$kIb(a, true);
        b = 0;
        for(d = g, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if (c > 0) {
                h += c;
                ++b;
            }
        }
        b > 1 && (h += a.c * (b - 1));
    }
    return h > 0 ? h + a.n.b + a.n.c : 0;
}
function $61de1ee1cac498ae$var$MJb(a, b) {
    var c, d, e, f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    c = f.a;
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 111);
        !!d.c && (c.a = $61de1ee1cac498ae$var$$wnd.Math.max(c.a, $61de1ee1cac498ae$var$ZHb(d.c)));
    }
    if (c.a > 0) switch(b.g){
        case 2:
            f.n.c = a.s;
            break;
        case 4:
            f.n.b = a.s;
    }
}
function $61de1ee1cac498ae$var$NQb(a, b) {
    var c, d, e;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$oSb)), 19).a - $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$oSb), 19).a;
    if (c == 0) {
        d = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$DSb)), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ESb), 8));
        e = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$DSb), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$ESb), 8));
        return $61de1ee1cac498ae$var$Kdb(d.a * d.b, e.a * e.b);
    }
    return c;
}
function $61de1ee1cac498ae$var$iRc(a, b) {
    var c, d, e;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$ETc)), 19).a - $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ETc), 19).a;
    if (c == 0) {
        d = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$VSc)), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$WSc), 8));
        e = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$VSc), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$WSc), 8));
        return $61de1ee1cac498ae$var$Kdb(d.a * d.b, e.a * e.b);
    }
    return c;
}
function $61de1ee1cac498ae$var$TZb(a) {
    var b, c;
    c = new $61de1ee1cac498ae$var$Ufb;
    c.a += "e_";
    b = $61de1ee1cac498ae$var$KZb(a);
    b != null && (c.a += "" + b, c);
    if (!!a.c && !!a.d) {
        $61de1ee1cac498ae$var$Qfb((c.a += " ", c), $61de1ee1cac498ae$var$C0b(a.c));
        $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Pfb((c.a += "[", c), a.c.i), "]");
        $61de1ee1cac498ae$var$Qfb((c.a += $61de1ee1cac498ae$var$gne, c), $61de1ee1cac498ae$var$C0b(a.d));
        $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Pfb((c.a += "[", c), a.d.i), "]");
    }
    return c.a;
}
function $61de1ee1cac498ae$var$zRc(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$lUc;
        case 1:
            return new $61de1ee1cac498ae$var$sUc;
        case 2:
            return new $61de1ee1cac498ae$var$CUc;
        case 3:
            return new $61de1ee1cac498ae$var$IUc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("No implementation is available for the layout phase " + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$mfd(a, b, c, d, e) {
    var f;
    f = 0;
    switch(e.g){
        case 1:
            f = $61de1ee1cac498ae$var$$wnd.Math.max(0, b.b + a.b - (c.b + d));
            break;
        case 3:
            f = $61de1ee1cac498ae$var$$wnd.Math.max(0, -a.b - d);
            break;
        case 2:
            f = $61de1ee1cac498ae$var$$wnd.Math.max(0, -a.a - d);
            break;
        case 4:
            f = $61de1ee1cac498ae$var$$wnd.Math.max(0, b.a + a.a - (c.a + d));
    }
    return f;
}
function $61de1ee1cac498ae$var$mqd(a, b, c) {
    var d, e, f, g, h;
    if (c) {
        e = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(e);
        for(h = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            f = $61de1ee1cac498ae$var$Zpd(c, g.a);
            $61de1ee1cac498ae$var$Lte in f.a || $61de1ee1cac498ae$var$Mte in f.a ? $61de1ee1cac498ae$var$$qd(a, f, b) : $61de1ee1cac498ae$var$erd(a, f, b);
            $61de1ee1cac498ae$var$otd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, $61de1ee1cac498ae$var$Wpd(f)), 79));
        }
    }
}
function $61de1ee1cac498ae$var$LJd(a) {
    var b, c;
    switch(a.b){
        case -1:
            return true;
        case 0:
            c = a.t;
            if (c > 1 || c == -1) {
                a.b = -1;
                return true;
            } else {
                b = $61de1ee1cac498ae$var$wId(a);
                if (!!b && ($61de1ee1cac498ae$var$Q6d(), b.Cj() == $61de1ee1cac498ae$var$Bve)) {
                    a.b = -1;
                    return true;
                } else {
                    a.b = 1;
                    return false;
                }
            }
        default:
        case 1:
            return false;
    }
}
function $61de1ee1cac498ae$var$k1d(a, b) {
    var c, d, e, f, g;
    d = (!b.s && (b.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, b, 21, 17)), b.s);
    f = null;
    for(e = 0, g = d.i; e < g; ++e){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(d, e), 170);
        switch($61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d(a, c))){
            case 2:
            case 3:
                !f && (f = new $61de1ee1cac498ae$var$Rkb);
                f.c[f.c.length] = c;
        }
    }
    return !f ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb) : f;
}
function $61de1ee1cac498ae$var$tde(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$nde(a);
    if (a.c != 0 || a.a != 123) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Fue))));
    f = b == 112;
    d = a.d;
    c = $61de1ee1cac498ae$var$gfb(a.i, 125, d);
    if (c < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Gue))));
    e = $61de1ee1cac498ae$var$qfb(a.i, d, c);
    a.d = c + 1;
    return $61de1ee1cac498ae$var$Lfe(e, f, (a.e & 512) == 512);
}
function $61de1ee1cac498ae$var$QTb(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Iwc)), 314);
    if (b == ($61de1ee1cac498ae$var$Rpc(), $61de1ee1cac498ae$var$Ppc)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$z2c("The hierarchy aware processor " + b + " in child node " + a + " is only allowed if the root node specifies the same hierarchical processor."));
}
function $61de1ee1cac498ae$var$dhc(a, b) {
    $61de1ee1cac498ae$var$Hgc();
    var c, d, e, f, g, h;
    c = null;
    for(g = b.Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 128);
        if (f.o) continue;
        d = $61de1ee1cac498ae$var$F6c(f.a);
        e = $61de1ee1cac498ae$var$C6c(f.a);
        h = new $61de1ee1cac498ae$var$hic(d, e, null, $61de1ee1cac498ae$var$BD(f.d.a.ec().Kc().Pb(), 17));
        $61de1ee1cac498ae$var$Ekb(h.c, f.a);
        a.c[a.c.length] = h;
        !!c && $61de1ee1cac498ae$var$Ekb(c.d, h);
        c = h;
    }
}
function $61de1ee1cac498ae$var$hKd(a, b) {
    var c, d, e;
    if (!b) {
        $61de1ee1cac498ae$var$jKd(a, null);
        $61de1ee1cac498ae$var$_Jd(a, null);
    } else if ((b.i & 4) != 0) {
        d = "[]";
        for(c = b.c;; c = c.c){
            if ((c.i & 4) == 0) {
                e = $61de1ee1cac498ae$var$jfb(($61de1ee1cac498ae$var$fdb(c), c.o + d));
                $61de1ee1cac498ae$var$jKd(a, e);
                $61de1ee1cac498ae$var$_Jd(a, e);
                break;
            }
            d += "[]";
        }
    } else {
        e = $61de1ee1cac498ae$var$jfb(($61de1ee1cac498ae$var$fdb(b), b.o));
        $61de1ee1cac498ae$var$jKd(a, e);
        $61de1ee1cac498ae$var$_Jd(a, e);
    }
    a.yk(b);
}
function $61de1ee1cac498ae$var$b3d(a, b, c, d, e) {
    var f, g, h, i;
    i = $61de1ee1cac498ae$var$a3d(a, $61de1ee1cac498ae$var$BD(e, 56));
    if ($61de1ee1cac498ae$var$PD(i) !== $61de1ee1cac498ae$var$PD(e)) {
        h = $61de1ee1cac498ae$var$BD(a.g[c], 72);
        f = $61de1ee1cac498ae$var$R6d(b, i);
        $61de1ee1cac498ae$var$mud(a, c, $61de1ee1cac498ae$var$t3d(a, c, f));
        if ($61de1ee1cac498ae$var$oid(a.e)) {
            g = $61de1ee1cac498ae$var$H2d(a, 9, f.ak(), e, i, d, false);
            $61de1ee1cac498ae$var$Qwd(g, new $61de1ee1cac498ae$var$pSd(a.e, 9, a.c, h, f, d, false));
            $61de1ee1cac498ae$var$Rwd(g);
        }
        return i;
    }
    return e;
}
function $61de1ee1cac498ae$var$xCc(a, b, c) {
    var d, e, f, g, h, i;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.c, b), 15);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.c, c), 15);
    f = d.Zc(d.gc());
    g = e.Zc(e.gc());
    while(f.Sb() && g.Sb()){
        h = $61de1ee1cac498ae$var$BD(f.Ub(), 19);
        i = $61de1ee1cac498ae$var$BD(g.Ub(), 19);
        if (h != i) return $61de1ee1cac498ae$var$beb(h.a, i.a);
    }
    return !f.Ob() && !g.Ob() ? 0 : f.Ob() ? 1 : -1;
}
function $61de1ee1cac498ae$var$m5c(c, d) {
    var e, f, g;
    try {
        g = $61de1ee1cac498ae$var$fs(c.a, d);
        return g;
    } catch (b) {
        b = $61de1ee1cac498ae$var$ubb(b);
        if ($61de1ee1cac498ae$var$JD(b, 32)) {
            try {
                f = $61de1ee1cac498ae$var$Icb(d, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe);
                e = $61de1ee1cac498ae$var$gdb(c.a);
                if (f >= 0 && f < e.length) return e[f];
            } catch (a) {
                a = $61de1ee1cac498ae$var$ubb(a);
                if (!$61de1ee1cac498ae$var$JD(a, 127)) throw $61de1ee1cac498ae$var$vbb(a);
            }
            return null;
        } else throw $61de1ee1cac498ae$var$vbb(b);
    }
}
function $61de1ee1cac498ae$var$tid(a, b) {
    var c, d, e;
    e = $61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a.Tg(), b);
    if (e) {
        $61de1ee1cac498ae$var$Q6d();
        $61de1ee1cac498ae$var$BD(e, 66).Oj() || (e = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, e)));
        d = (c = a.Yg(e), $61de1ee1cac498ae$var$BD(c >= 0 ? a._g(c, true, true) : $61de1ee1cac498ae$var$sid(a, e, true), 153));
        return $61de1ee1cac498ae$var$BD(d, 215).ll(b);
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b.ne() + $61de1ee1cac498ae$var$lte));
}
function $61de1ee1cac498ae$var$BZd() {
    $61de1ee1cac498ae$var$tZd();
    var a;
    if ($61de1ee1cac498ae$var$sZd) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$nUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$_ve), 1939);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$CK, new $61de1ee1cac498ae$var$J_d);
    $61de1ee1cac498ae$var$CZd();
    a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$Phb(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$_ve), 547) ? $61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$xFd, $61de1ee1cac498ae$var$_ve) : new $61de1ee1cac498ae$var$AZd, 547);
    $61de1ee1cac498ae$var$sZd = true;
    $61de1ee1cac498ae$var$yZd(a);
    $61de1ee1cac498ae$var$zZd(a);
    $61de1ee1cac498ae$var$Rhb(($61de1ee1cac498ae$var$JFd(), $61de1ee1cac498ae$var$IFd), a, new $61de1ee1cac498ae$var$EZd);
    $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$xFd, $61de1ee1cac498ae$var$_ve, a);
    return a;
}
function $61de1ee1cac498ae$var$v2d(a, b) {
    var c, d, e, f;
    a.j = -1;
    if ($61de1ee1cac498ae$var$oid(a.e)) {
        c = a.i;
        f = a.i != 0;
        $61de1ee1cac498ae$var$lud(a, b);
        d = new $61de1ee1cac498ae$var$pSd(a.e, 3, a.c, null, b, c, f);
        e = b.Qk(a.e, a.c, null);
        e = $61de1ee1cac498ae$var$h3d(a, b, e);
        if (!e) $61de1ee1cac498ae$var$Uhd(a.e, d);
        else {
            e.Ei(d);
            e.Fi();
        }
    } else {
        $61de1ee1cac498ae$var$lud(a, b);
        e = b.Qk(a.e, a.c, null);
        !!e && e.Fi();
    }
}
function $61de1ee1cac498ae$var$rA(a, b) {
    var c, d, e;
    e = 0;
    d = b[0];
    if (d >= a.length) return -1;
    c = ($61de1ee1cac498ae$var$BCb(d, a.length), a.charCodeAt(d));
    while(c >= 48 && c <= 57){
        e = e * 10 + (c - 48);
        ++d;
        if (d >= a.length) break;
        c = ($61de1ee1cac498ae$var$BCb(d, a.length), a.charCodeAt(d));
    }
    d > b[0] ? b[0] = d : e = -1;
    return e;
}
function $61de1ee1cac498ae$var$vMb(a) {
    var b, c, d, e, f;
    e = $61de1ee1cac498ae$var$BD(a.a, 19).a;
    f = $61de1ee1cac498ae$var$BD(a.b, 19).a;
    c = e;
    d = f;
    b = $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$$wnd.Math.abs(e), $61de1ee1cac498ae$var$$wnd.Math.abs(f));
    if (e <= 0 && e == f) {
        c = 0;
        d = f - 1;
    } else if (e == -b && f != b) {
        c = f;
        d = e;
        f >= 0 && ++c;
    } else {
        c = -f;
        d = e;
    }
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(c), $61de1ee1cac498ae$var$meb(d));
}
function $61de1ee1cac498ae$var$fNb(a, b, c, d) {
    var e, f, g, h, i, j;
    for(e = 0; e < b.o; e++){
        f = e - b.j + c;
        for(g = 0; g < b.p; g++){
            h = g - b.k + d;
            if ((i = f, j = h, i += a.j, j += a.k, i >= 0 && j >= 0 && i < a.o && j < a.p) && (!$61de1ee1cac498ae$var$ZMb(b, e, g) && $61de1ee1cac498ae$var$hNb(a, f, h) || $61de1ee1cac498ae$var$YMb(b, e, g) && !$61de1ee1cac498ae$var$iNb(a, f, h))) return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$LNc(a, b, c) {
    var d, e, f, g, h;
    g = a.c;
    h = a.d;
    f = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        g.i.n,
        g.n,
        g.a
    ])).b;
    e = (f + $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        h.i.n,
        h.n,
        h.a
    ])).b) / 2;
    d = null;
    g.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) ? d = new $61de1ee1cac498ae$var$f7c(b + g.i.c.c.a + c, e) : d = new $61de1ee1cac498ae$var$f7c(b - c, e);
    $61de1ee1cac498ae$var$St(a.a, 0, d);
}
function $61de1ee1cac498ae$var$Qld(a) {
    var b, c, d, e;
    b = null;
    for(d = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
        (!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b),
        (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c)
    ]))); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 82);
        e = $61de1ee1cac498ae$var$atd(c);
        if (!b) b = e;
        else if (b != e) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$sud(a, b, c) {
    var d;
    ++a.j;
    if (b >= a.i) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$lue + b + $61de1ee1cac498ae$var$mue + a.i));
    if (c >= a.i) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$nue + c + $61de1ee1cac498ae$var$mue + a.i));
    d = a.g[c];
    if (b != c) {
        b < c ? $61de1ee1cac498ae$var$$fb(a.g, b, a.g, b + 1, c - b) : $61de1ee1cac498ae$var$$fb(a.g, c + 1, a.g, c, b - c);
        $61de1ee1cac498ae$var$NC(a.g, b, d);
        a.ei(b, d, c);
        a.ci();
    }
    return d;
}
function $61de1ee1cac498ae$var$Rc(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD(a.c.xc(b), 14);
    if (!d) {
        d = a.ic(b);
        if (d.Fc(c)) {
            ++a.d;
            a.c.zc(b, d);
            return true;
        } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$ycb("New Collection violated the Collection spec"));
    } else if (d.Fc(c)) {
        ++a.d;
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$heb(a) {
    var b, c, d;
    if (a < 0) return 0;
    else if (a == 0) return 32;
    else {
        d = -(a >> 16);
        b = d >> 16 & 16;
        c = 16 - b;
        a = a >> b;
        d = a - 256;
        b = d >> 16 & 8;
        c += b;
        a <<= b;
        d = a - $61de1ee1cac498ae$var$Rje;
        b = d >> 16 & 4;
        c += b;
        a <<= b;
        d = a - $61de1ee1cac498ae$var$oie;
        b = d >> 16 & 2;
        c += b;
        a <<= b;
        d = a >> 14;
        b = d & ~(d >> 1);
        return c + 2 - b;
    }
}
function $61de1ee1cac498ae$var$$Pb(a) {
    $61de1ee1cac498ae$var$QPb();
    var b, c, d, e;
    $61de1ee1cac498ae$var$PPb = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$OPb = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$NPb = new $61de1ee1cac498ae$var$Rkb;
    b = (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a);
    $61de1ee1cac498ae$var$SPb(b);
    for(e = new $61de1ee1cac498ae$var$Fyd(b); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 33);
        if ($61de1ee1cac498ae$var$Jkb($61de1ee1cac498ae$var$PPb, d, 0) == -1) {
            c = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$Ekb($61de1ee1cac498ae$var$NPb, c);
            $61de1ee1cac498ae$var$TPb(d, c);
        }
    }
    return $61de1ee1cac498ae$var$NPb;
}
function $61de1ee1cac498ae$var$BQb(a, b, c) {
    var d, e, f, g;
    a.a = c.b.d;
    if ($61de1ee1cac498ae$var$JD(b, 352)) {
        e = $61de1ee1cac498ae$var$itd($61de1ee1cac498ae$var$BD(b, 79), false, false);
        f = $61de1ee1cac498ae$var$ofd(e);
        d = new $61de1ee1cac498ae$var$FQb(a);
        $61de1ee1cac498ae$var$reb(f, d);
        $61de1ee1cac498ae$var$ifd(f, e);
        b.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Q8c)) != null && $61de1ee1cac498ae$var$reb($61de1ee1cac498ae$var$BD(b.We($61de1ee1cac498ae$var$Q8c), 74), d);
    } else {
        g = $61de1ee1cac498ae$var$BD(b, 470);
        g.Hg(g.Dg() + a.a.a);
        g.Ig(g.Eg() + a.a.b);
    }
}
function $61de1ee1cac498ae$var$_5b(a, b) {
    var c, d, e, f, g, h, i, j;
    j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$zyc))));
    i = a[0].n.a + a[0].o.a + a[0].d.c + j;
    for(h = 1; h < a.length; h++){
        d = a[h].n;
        e = a[h].o;
        c = a[h].d;
        f = d.a - c.b - i;
        f < 0 && (d.a -= f);
        g = b.f;
        g.a = $61de1ee1cac498ae$var$$wnd.Math.max(g.a, d.a + e.a);
        i = d.a + e.a + c.c + j;
    }
}
function $61de1ee1cac498ae$var$D$c(a, b) {
    var c, d, e, f, g, h;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b.a), 46).a, 65);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, b.b), 46).a, 65);
    f = d.b;
    g = e.b;
    c = $61de1ee1cac498ae$var$z6c(f, g);
    if (c >= 0) return c;
    h = $61de1ee1cac498ae$var$U6c($61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(g.c + g.b / 2, g.d + g.a / 2), new $61de1ee1cac498ae$var$f7c(f.c + f.b / 2, f.d + f.a / 2)));
    return -($61de1ee1cac498ae$var$xOb(f, g) - 1) * h;
}
function $61de1ee1cac498ae$var$ufd(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, (!c.a && (c.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, c, 6, 6)), new $61de1ee1cac498ae$var$Kub(c.a, 16))), new $61de1ee1cac498ae$var$Mfd(a, b));
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, (!c.n && (c.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, c, 1, 7)), new $61de1ee1cac498ae$var$Kub(c.n, 16))), new $61de1ee1cac498ae$var$Ofd(a, b));
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(c, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Q8c)), 74);
    !!d && $61de1ee1cac498ae$var$p7c(d, a, b);
}
function $61de1ee1cac498ae$var$sid(a, b, c) {
    var d, e, f;
    f = $61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a.Tg(), b);
    if (f) {
        $61de1ee1cac498ae$var$Q6d();
        $61de1ee1cac498ae$var$BD(f, 66).Oj() || (f = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, f)));
        e = (d = a.Yg(f), $61de1ee1cac498ae$var$BD(d >= 0 ? a._g(d, true, true) : $61de1ee1cac498ae$var$sid(a, f, true), 153));
        return $61de1ee1cac498ae$var$BD(e, 215).hl(b, c);
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b.ne() + $61de1ee1cac498ae$var$lte));
}
function $61de1ee1cac498ae$var$wAd(a, b, c, d) {
    var e, f, g, h, i;
    e = a.d[b];
    if (e) {
        f = e.g;
        i = e.i;
        if (d != null) for(h = 0; h < i; ++h){
            g = $61de1ee1cac498ae$var$BD(f[h], 133);
            if (g.Sh() == c && $61de1ee1cac498ae$var$pb(d, g.cd())) return g;
        }
        else for(h = 0; h < i; ++h){
            g = $61de1ee1cac498ae$var$BD(f[h], 133);
            if ($61de1ee1cac498ae$var$PD(g.cd()) === $61de1ee1cac498ae$var$PD(d)) return g;
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$Pgb(a, b) {
    var c;
    if (b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$ocb("Negative exponent"));
    if (b == 0) return $61de1ee1cac498ae$var$Cgb;
    else if (b == 1 || $61de1ee1cac498ae$var$Kgb(a, $61de1ee1cac498ae$var$Cgb) || $61de1ee1cac498ae$var$Kgb(a, $61de1ee1cac498ae$var$Ggb)) return a;
    if (!$61de1ee1cac498ae$var$Sgb(a, 0)) {
        c = 1;
        while(!$61de1ee1cac498ae$var$Sgb(a, c))++c;
        return $61de1ee1cac498ae$var$Ogb($61de1ee1cac498ae$var$bhb(c * b), $61de1ee1cac498ae$var$Pgb($61de1ee1cac498ae$var$Rgb(a, c), b));
    }
    return $61de1ee1cac498ae$var$Jhb(a, b);
}
function $61de1ee1cac498ae$var$xlb(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b)) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;
    for(c = 0; c < a.length; ++c){
        d = a[c];
        e = b[c];
        if (!($61de1ee1cac498ae$var$PD(d) === $61de1ee1cac498ae$var$PD(e) || d != null && $61de1ee1cac498ae$var$pb(d, e))) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$CVb(a) {
    $61de1ee1cac498ae$var$nVb();
    var b, c, d;
    this.b = $61de1ee1cac498ae$var$mVb;
    this.c = ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad);
    this.f = ($61de1ee1cac498ae$var$iVb(), $61de1ee1cac498ae$var$hVb);
    this.a = a;
    $61de1ee1cac498ae$var$zVb(this, new $61de1ee1cac498ae$var$DVb);
    $61de1ee1cac498ae$var$sVb(this);
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 81);
        if (!c.d) {
            b = new $61de1ee1cac498ae$var$gVb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$IP, 1), $61de1ee1cac498ae$var$Uhe, 81, 0, [
                c
            ]));
            $61de1ee1cac498ae$var$Ekb(a.a, b);
        }
    }
}
function $61de1ee1cac498ae$var$D3b(a, b, c) {
    var d, e, f, g, h, i;
    if (!a || a.c.length == 0) return null;
    f = new $61de1ee1cac498ae$var$cIb(b, !c);
    for(e = new $61de1ee1cac498ae$var$olb(a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 70);
        $61de1ee1cac498ae$var$UHb(f, ($61de1ee1cac498ae$var$a$b(), new $61de1ee1cac498ae$var$v$b(d)));
    }
    g = f.i;
    g.a = (i = f.n, f.e.b + i.d + i.a);
    g.b = (h = f.n, f.e.a + h.b + h.c);
    return f;
}
function $61de1ee1cac498ae$var$O5b(a) {
    var b, c, d, e, f, g, h;
    h = $61de1ee1cac498ae$var$l_b(a.a);
    $61de1ee1cac498ae$var$Nlb(h, new $61de1ee1cac498ae$var$T5b);
    c = null;
    for(e = h, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        if (d.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) break;
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
        if (b != ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) && b != $61de1ee1cac498ae$var$zcd) continue;
        !!c && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Qsc), 15).Fc(d);
        c = d;
    }
}
function $61de1ee1cac498ae$var$YOc(a, b, c) {
    var d, e, f, g, h, i, j;
    i = ($61de1ee1cac498ae$var$tCb(b, a.c.length), $61de1ee1cac498ae$var$BD(a.c[b], 329));
    $61de1ee1cac498ae$var$Kkb(a, b);
    if (i.b / 2 >= c) {
        d = b;
        j = (i.c + i.a) / 2;
        g = j - c;
        if (i.c <= j - c) {
            e = new $61de1ee1cac498ae$var$bPc(i.c, g);
            $61de1ee1cac498ae$var$Dkb(a, d++, e);
        }
        h = j + c;
        if (h <= i.a) {
            f = new $61de1ee1cac498ae$var$bPc(h, i.a);
            $61de1ee1cac498ae$var$wCb(d, a.c.length);
            $61de1ee1cac498ae$var$aCb(a.c, d, f);
        }
    }
}
function $61de1ee1cac498ae$var$u0d(a) {
    var b;
    if (!a.c && a.g == null) {
        a.d = a.si(a.f);
        $61de1ee1cac498ae$var$wtd(a, a.d);
        b = a.d;
    } else {
        if (a.g == null) return true;
        else if (a.i == 0) return false;
        else b = $61de1ee1cac498ae$var$BD(a.g[a.i - 1], 47);
    }
    if (b == a.b && null.km >= null.jm()) {
        $61de1ee1cac498ae$var$Vud(a);
        return $61de1ee1cac498ae$var$u0d(a);
    } else return b.Ob();
}
function $61de1ee1cac498ae$var$KTb(a, b, c) {
    var d, e, f, g, h;
    h = c;
    !h && (h = $61de1ee1cac498ae$var$Ydd(new $61de1ee1cac498ae$var$Zdd, 0));
    $61de1ee1cac498ae$var$Odd(h, $61de1ee1cac498ae$var$Vme, 1);
    $61de1ee1cac498ae$var$aUb(a.c, b);
    g = $61de1ee1cac498ae$var$EYb(a.a, b);
    if (g.gc() == 1) $61de1ee1cac498ae$var$MTb($61de1ee1cac498ae$var$BD(g.Xb(0), 37), h);
    else {
        f = 1 / g.gc();
        for(e = g.Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 37);
            $61de1ee1cac498ae$var$MTb(d, $61de1ee1cac498ae$var$Udd(h, f));
        }
    }
    $61de1ee1cac498ae$var$CYb(a.a, g, b);
    $61de1ee1cac498ae$var$NTb(b);
    $61de1ee1cac498ae$var$Qdd(h);
}
function $61de1ee1cac498ae$var$qYb(a) {
    this.a = a;
    if (a.c.i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
        this.c = a.c;
        this.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.c.i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
    } else if (a.d.i.k == $61de1ee1cac498ae$var$e0b) {
        this.c = a.d;
        this.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.d.i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Edge " + a + " is not an external edge."));
}
function $61de1ee1cac498ae$var$oQd(a, b) {
    var c, d, e;
    e = a.b;
    a.b = b;
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 3, e, a.b));
    if (!b) {
        $61de1ee1cac498ae$var$pnd(a, null);
        $61de1ee1cac498ae$var$qQd(a, 0);
        $61de1ee1cac498ae$var$pQd(a, null);
    } else if (b != a) {
        $61de1ee1cac498ae$var$pnd(a, b.zb);
        $61de1ee1cac498ae$var$qQd(a, b.d);
        c = (d = b.c, d == null ? b.zb : d);
        $61de1ee1cac498ae$var$pQd(a, c == null || $61de1ee1cac498ae$var$dfb(c, b.zb) ? null : c);
    }
}
function $61de1ee1cac498ae$var$NRd(a) {
    var b, c;
    if (a.f) {
        while(a.n < a.o){
            b = $61de1ee1cac498ae$var$BD(!a.j ? a.k.Xb(a.n) : a.j.pi(a.n), 72);
            c = b.ak();
            if ($61de1ee1cac498ae$var$JD(c, 99) && ($61de1ee1cac498ae$var$BD(c, 18).Bb & $61de1ee1cac498ae$var$ote) != 0 && (!a.e || c.Gj() != $61de1ee1cac498ae$var$x2 || c.aj() != 0) && b.dd() != null) return true;
            else ++a.n;
        }
        return false;
    } else return a.n < a.o;
}
function $61de1ee1cac498ae$var$_i(a, b) {
    var c;
    this.e = ($61de1ee1cac498ae$var$im(), $61de1ee1cac498ae$var$Qb(a), $61de1ee1cac498ae$var$im(), $61de1ee1cac498ae$var$nm(a));
    this.c = ($61de1ee1cac498ae$var$Qb(b), $61de1ee1cac498ae$var$nm(b));
    $61de1ee1cac498ae$var$Lb(this.e.Hd().dc() == this.c.Hd().dc());
    this.d = $61de1ee1cac498ae$var$Ev(this.e);
    this.b = $61de1ee1cac498ae$var$Ev(this.c);
    c = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$SI, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$Uhe
    ], [
        5,
        1
    ], 5, [
        this.e.Hd().gc(),
        this.c.Hd().gc()
    ], 2);
    this.a = c;
    $61de1ee1cac498ae$var$Ri(this);
}
function $61de1ee1cac498ae$var$vz(b) {
    var c = (!$61de1ee1cac498ae$var$tz && ($61de1ee1cac498ae$var$tz = $61de1ee1cac498ae$var$wz()), $61de1ee1cac498ae$var$tz);
    var d = b.replace(/[\x00-\x1f\xad\u0600-\u0603\u06dd\u070f\u17b4\u17b5\u200b-\u200f\u2028-\u202e\u2060-\u2064\u206a-\u206f\ufeff\ufff9-\ufffb"\\]/g, function(a) {
        return $61de1ee1cac498ae$var$uz(a, c);
    });
    return '"' + d + '"';
}
function $61de1ee1cac498ae$var$cEb(a) {
    $61de1ee1cac498ae$var$ODb();
    var b, c;
    this.b = $61de1ee1cac498ae$var$LDb;
    this.c = $61de1ee1cac498ae$var$NDb;
    this.g = ($61de1ee1cac498ae$var$FDb(), $61de1ee1cac498ae$var$EDb);
    this.d = ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad);
    this.a = a;
    $61de1ee1cac498ae$var$RDb(this);
    for(c = new $61de1ee1cac498ae$var$olb(a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        !b.a && $61de1ee1cac498ae$var$pDb($61de1ee1cac498ae$var$rDb(new $61de1ee1cac498ae$var$sDb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PM, 1), $61de1ee1cac498ae$var$Uhe, 57, 0, [
            b
        ])), a);
        b.e = new $61de1ee1cac498ae$var$K6c(b.d);
    }
}
function $61de1ee1cac498ae$var$HQb(a) {
    var b, c, d, e, f, g;
    e = a.e.c.length;
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, e, 0, 1);
    for(g = new $61de1ee1cac498ae$var$olb(a.e); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 144);
        d[f.b] = new $61de1ee1cac498ae$var$Psb;
    }
    for(c = new $61de1ee1cac498ae$var$olb(a.c); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 282);
        d[b.c.b].Fc(b);
        d[b.d.b].Fc(b);
    }
    return d;
}
function $61de1ee1cac498ae$var$fDc(a) {
    var b, c, d, e, f, g, h;
    h = $61de1ee1cac498ae$var$Pu(a.c.length);
    for(e = new $61de1ee1cac498ae$var$olb(a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        g = new $61de1ee1cac498ae$var$Tqb;
        f = $61de1ee1cac498ae$var$U_b(d);
        for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(f.a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
            b.c.i == b.d.i || $61de1ee1cac498ae$var$Qqb(g, b.d.i);
        }
        h.c[h.c.length] = g;
    }
    return h;
}
function $61de1ee1cac498ae$var$ozd(a, b) {
    var c, d, e, f, g;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(a.a, 4), 126);
    g = c == null ? 0 : c.length;
    if (b >= g) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(b, g));
    e = c[b];
    if (g == 1) d = null;
    else {
        d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$$3, $61de1ee1cac498ae$var$hve, 415, g - 1, 0, 1);
        $61de1ee1cac498ae$var$$fb(c, 0, d, 0, b);
        f = g - b - 1;
        f > 0 && $61de1ee1cac498ae$var$$fb(c, b + 1, d, b, f);
    }
    $61de1ee1cac498ae$var$b0d(a, d);
    $61de1ee1cac498ae$var$a0d(a, b, e);
    return e;
}
function $61de1ee1cac498ae$var$m8d() {
    $61de1ee1cac498ae$var$m8d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$k8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$r8d(), $61de1ee1cac498ae$var$q8d).qb), 6), 34);
    $61de1ee1cac498ae$var$h8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 3), 34);
    $61de1ee1cac498ae$var$i8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 4), 34);
    $61de1ee1cac498ae$var$j8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 5), 18);
    $61de1ee1cac498ae$var$XId($61de1ee1cac498ae$var$k8d);
    $61de1ee1cac498ae$var$XId($61de1ee1cac498ae$var$h8d);
    $61de1ee1cac498ae$var$XId($61de1ee1cac498ae$var$i8d);
    $61de1ee1cac498ae$var$XId($61de1ee1cac498ae$var$j8d);
    $61de1ee1cac498ae$var$l8d = new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t5, 1), $61de1ee1cac498ae$var$Mve, 170, 0, [
        $61de1ee1cac498ae$var$k8d,
        $61de1ee1cac498ae$var$h8d
    ]));
}
function $61de1ee1cac498ae$var$AJb(a, b) {
    var c;
    this.d = new $61de1ee1cac498ae$var$H_b;
    this.b = b;
    this.e = new $61de1ee1cac498ae$var$g7c(b.qf());
    c = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ocd));
    a.u.Hc($61de1ee1cac498ae$var$ncd) ? a.D ? this.a = c && !b.If() : this.a = true : a.u.Hc($61de1ee1cac498ae$var$pcd) ? c ? this.a = !(b.zf().Kc().Ob() || b.Bf().Kc().Ob()) : this.a = false : this.a = false;
}
function $61de1ee1cac498ae$var$IKb(a, b) {
    var c, d, e, f;
    c = a.o.a;
    for(f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        e.e.a = (d = e.b, d.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c)) ? d.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? -d.rf().a - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d.We($61de1ee1cac498ae$var$s9c))) : c + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d.We($61de1ee1cac498ae$var$s9c))) : d.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? -d.rf().a : c);
    }
}
function $61de1ee1cac498ae$var$Q1b(a, b) {
    var c, d, e, f;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lwc)), 103);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$$xc), 61);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Vxc), 98);
    if (e != ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$bcd) && e != $61de1ee1cac498ae$var$ccd) {
        if (f == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd)) {
            f = $61de1ee1cac498ae$var$lfd(b, c);
            f == $61de1ee1cac498ae$var$Scd && (f = $61de1ee1cac498ae$var$Zcd(c));
        }
    } else {
        d = $61de1ee1cac498ae$var$M1b(b);
        d > 0 ? f = $61de1ee1cac498ae$var$Zcd(c) : f = $61de1ee1cac498ae$var$Wcd($61de1ee1cac498ae$var$Zcd(c));
    }
    $61de1ee1cac498ae$var$jkd(b, $61de1ee1cac498ae$var$$xc, f);
}
function $61de1ee1cac498ae$var$olc(a, b) {
    var c, d, e, f, g;
    g = a.j;
    b.a != b.b && $61de1ee1cac498ae$var$Okb(g, new $61de1ee1cac498ae$var$Ulc);
    e = g.c.length / 2 | 0;
    for(d = 0; d < e; d++){
        f = ($61de1ee1cac498ae$var$tCb(d, g.c.length), $61de1ee1cac498ae$var$BD(g.c[d], 113));
        f.c && $61de1ee1cac498ae$var$G0b(f.d, b.a);
    }
    for(c = e; c < g.c.length; c++){
        f = ($61de1ee1cac498ae$var$tCb(c, g.c.length), $61de1ee1cac498ae$var$BD(g.c[c], 113));
        f.c && $61de1ee1cac498ae$var$G0b(f.d, b.b);
    }
}
function $61de1ee1cac498ae$var$TGc(a, b, c) {
    var d, e, f;
    d = a.c[b.c.p][b.p];
    e = a.c[c.c.p][c.p];
    if (d.a != null && e.a != null) {
        f = $61de1ee1cac498ae$var$Ddb(d.a, e.a);
        f < 0 ? $61de1ee1cac498ae$var$WGc(a, b, c) : f > 0 && $61de1ee1cac498ae$var$WGc(a, c, b);
        return f;
    } else if (d.a != null) {
        $61de1ee1cac498ae$var$WGc(a, b, c);
        return -1;
    } else if (e.a != null) {
        $61de1ee1cac498ae$var$WGc(a, c, b);
        return 1;
    }
    return 0;
}
function $61de1ee1cac498ae$var$swd(a, b) {
    var c, d, e, f;
    if (a.ej()) {
        c = a.Vi();
        f = a.fj();
        ++a.j;
        a.Hi(c, a.oi(c, b));
        d = a.Zi(3, null, b, c, f);
        if (a.bj()) {
            e = a.cj(b, null);
            if (!e) a.$i(d);
            else {
                e.Ei(d);
                e.Fi();
            }
        } else a.$i(d);
    } else {
        $61de1ee1cac498ae$var$Bvd(a, b);
        if (a.bj()) {
            e = a.cj(b, null);
            !!e && e.Fi();
        }
    }
}
function $61de1ee1cac498ae$var$D2d(a, b) {
    var c, d, e, f, g;
    g = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    e = new $61de1ee1cac498ae$var$yud;
    c = $61de1ee1cac498ae$var$BD(a.g, 119);
    for(f = a.i; --f >= 0;){
        d = c[f];
        g.rl(d.ak()) && $61de1ee1cac498ae$var$wtd(e, d);
    }
    !$61de1ee1cac498ae$var$Yxd(a, e) && $61de1ee1cac498ae$var$oid(a.e) && $61de1ee1cac498ae$var$GLd(a, b.$j() ? $61de1ee1cac498ae$var$H2d(a, 6, b, ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb), null, -1, false) : $61de1ee1cac498ae$var$H2d(a, b.Kj() ? 2 : 1, b, null, null, -1, false));
}
function $61de1ee1cac498ae$var$Dhb() {
    $61de1ee1cac498ae$var$Dhb = $61de1ee1cac498ae$var$ccb;
    var a, b;
    $61de1ee1cac498ae$var$Bhb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$cJ, $61de1ee1cac498ae$var$nie, 91, 32, 0, 1);
    $61de1ee1cac498ae$var$Chb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$cJ, $61de1ee1cac498ae$var$nie, 91, 32, 0, 1);
    a = 1;
    for(b = 0; b <= 18; b++){
        $61de1ee1cac498ae$var$Bhb[b] = $61de1ee1cac498ae$var$ghb(a);
        $61de1ee1cac498ae$var$Chb[b] = $61de1ee1cac498ae$var$ghb($61de1ee1cac498ae$var$Nbb(a, b));
        a = $61de1ee1cac498ae$var$Ibb(a, 5);
    }
    for(; b < $61de1ee1cac498ae$var$Chb.length; b++){
        $61de1ee1cac498ae$var$Bhb[b] = $61de1ee1cac498ae$var$Ogb($61de1ee1cac498ae$var$Bhb[b - 1], $61de1ee1cac498ae$var$Bhb[1]);
        $61de1ee1cac498ae$var$Chb[b] = $61de1ee1cac498ae$var$Ogb($61de1ee1cac498ae$var$Chb[b - 1], ($61de1ee1cac498ae$var$Hgb(), $61de1ee1cac498ae$var$Egb));
    }
}
function $61de1ee1cac498ae$var$K4b(a, b) {
    var c, d, e, f, g;
    if (a.a == ($61de1ee1cac498ae$var$yrc(), $61de1ee1cac498ae$var$wrc)) return true;
    f = b.a.c;
    c = b.a.c + b.a.b;
    if (b.j) {
        d = b.A;
        g = d.c.c.a - d.o.a / 2;
        e = f - (d.n.a + d.o.a);
        if (e > g) return false;
    }
    if (b.q) {
        d = b.C;
        g = d.c.c.a - d.o.a / 2;
        e = d.n.a - c;
        if (e > g) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$wcc(a, b) {
    var c;
    $61de1ee1cac498ae$var$Odd(b, "Partition preprocessing", 1);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.a, 16)), new $61de1ee1cac498ae$var$Acc), new $61de1ee1cac498ae$var$Ccc), new $61de1ee1cac498ae$var$Ecc), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    $61de1ee1cac498ae$var$MAb(c.Oc(), new $61de1ee1cac498ae$var$Gcc);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$DMc(a) {
    $61de1ee1cac498ae$var$wMc();
    var b, c, d, e, f, g, h;
    c = new $61de1ee1cac498ae$var$$rb;
    for(e = new $61de1ee1cac498ae$var$olb(a.e.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        for(g = new $61de1ee1cac498ae$var$olb(d.a); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
            h = a.g[f.p];
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(c, h), 15);
            if (!b) {
                b = new $61de1ee1cac498ae$var$Rkb;
                $61de1ee1cac498ae$var$Xrb(c, h, b);
            }
            b.Fc(f);
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$dRc(a, b) {
    var c, d, e, f, g;
    e = b.b.b;
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, e, 0, 1);
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, e, 16, 1);
    for(g = $61de1ee1cac498ae$var$Jsb(b.b, 0); g.b != g.d.c;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 86);
        a.a[f.g] = new $61de1ee1cac498ae$var$Psb;
    }
    for(d = $61de1ee1cac498ae$var$Jsb(b.a, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 188);
        a.a[c.b.g].Fc(c);
        a.a[c.c.g].Fc(c);
    }
}
function $61de1ee1cac498ae$var$qmd(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$Eid(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(a));
    b.a += " (startX: ";
    $61de1ee1cac498ae$var$Bfb(b, a.j);
    b.a += ", startY: ";
    $61de1ee1cac498ae$var$Bfb(b, a.k);
    b.a += ", endX: ";
    $61de1ee1cac498ae$var$Bfb(b, a.b);
    b.a += ", endY: ";
    $61de1ee1cac498ae$var$Bfb(b, a.c);
    b.a += ", identifier: ";
    $61de1ee1cac498ae$var$Efb(b, a.d);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$EId(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$qnd(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$qnd(a));
    b.a += " (ordered: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & 256) != 0);
    b.a += ", unique: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & 512) != 0);
    b.a += ", lowerBound: ";
    $61de1ee1cac498ae$var$Cfb(b, a.s);
    b.a += ", upperBound: ";
    $61de1ee1cac498ae$var$Cfb(b, a.t);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$Wnd(a, b, c, d, e, f, g, h) {
    var i;
    $61de1ee1cac498ae$var$JD(a.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(a.Cb, 88)), 4);
    $61de1ee1cac498ae$var$pnd(a, c);
    a.f = d;
    $61de1ee1cac498ae$var$dJd(a, e);
    $61de1ee1cac498ae$var$fJd(a, f);
    $61de1ee1cac498ae$var$ZId(a, g);
    $61de1ee1cac498ae$var$eJd(a, false);
    $61de1ee1cac498ae$var$CId(a, true);
    $61de1ee1cac498ae$var$aJd(a, h);
    $61de1ee1cac498ae$var$BId(a, true);
    $61de1ee1cac498ae$var$AId(a, 0);
    a.b = 0;
    $61de1ee1cac498ae$var$DId(a, 1);
    i = $61de1ee1cac498ae$var$xId(a, b, null);
    !!i && i.Fi();
    $61de1ee1cac498ae$var$MJd(a, false);
    return a;
}
function $61de1ee1cac498ae$var$fyb(a, b) {
    var c, d, e, f;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.a, b), 512);
    if (!c) {
        d = new $61de1ee1cac498ae$var$wyb(b);
        e = ($61de1ee1cac498ae$var$oyb(), $61de1ee1cac498ae$var$lyb) ? null : d.c;
        f = $61de1ee1cac498ae$var$qfb(e, 0, $61de1ee1cac498ae$var$$wnd.Math.max(0, $61de1ee1cac498ae$var$kfb(e, $61de1ee1cac498ae$var$wfb(46))));
        $61de1ee1cac498ae$var$vyb(d, $61de1ee1cac498ae$var$fyb(a, f));
        ($61de1ee1cac498ae$var$lyb ? null : d.c).length == 0 && $61de1ee1cac498ae$var$qyb(d, new $61de1ee1cac498ae$var$zyb);
        $61de1ee1cac498ae$var$Shb(a.a, $61de1ee1cac498ae$var$lyb ? null : d.c, d);
        return d;
    }
    return c;
}
function $61de1ee1cac498ae$var$BOb(a, b) {
    var c;
    a.b = b;
    a.g = new $61de1ee1cac498ae$var$Rkb;
    c = $61de1ee1cac498ae$var$COb(a.b);
    a.e = c;
    a.f = c;
    a.c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a.b, ($61de1ee1cac498ae$var$fFb(), $61de1ee1cac498ae$var$$Eb))));
    a.a = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$r8c)));
    a.a == null && (a.a = 1);
    $61de1ee1cac498ae$var$Edb(a.a) > 1 ? a.e *= $61de1ee1cac498ae$var$Edb(a.a) : a.f /= $61de1ee1cac498ae$var$Edb(a.a);
    $61de1ee1cac498ae$var$DOb(a);
    $61de1ee1cac498ae$var$EOb(a);
    $61de1ee1cac498ae$var$AOb(a);
    $61de1ee1cac498ae$var$yNb(a.b, ($61de1ee1cac498ae$var$CPb(), $61de1ee1cac498ae$var$uPb), a.g);
}
function $61de1ee1cac498ae$var$Y5b(a, b, c) {
    var d, e, f, g, h, i;
    d = 0;
    i = c;
    if (!b) {
        d = c * (a.c.length - 1);
        i *= -1;
    }
    for(f = new $61de1ee1cac498ae$var$olb(a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mwc), ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$B7c));
        e.o.a = d;
        for(h = $61de1ee1cac498ae$var$Y_b(e, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)).Kc(); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 11);
            g.n.a = d;
        }
        d += i;
    }
}
function $61de1ee1cac498ae$var$Qxd(a, b, c) {
    var d, e, f;
    if (a.ej()) {
        f = a.fj();
        $61de1ee1cac498ae$var$kud(a, b, c);
        d = a.Zi(3, null, c, b, f);
        if (a.bj()) {
            e = a.cj(c, null);
            a.ij() && (e = a.jj(c, e));
            if (!e) a.$i(d);
            else {
                e.Ei(d);
                e.Fi();
            }
        } else a.$i(d);
    } else {
        $61de1ee1cac498ae$var$kud(a, b, c);
        if (a.bj()) {
            e = a.cj(c, null);
            !!e && e.Fi();
        }
    }
}
function $61de1ee1cac498ae$var$ILd(a, b, c) {
    var d, e, f, g, h, i;
    h = a.Gk(c);
    if (h != c) {
        g = a.g[b];
        i = h;
        $61de1ee1cac498ae$var$mud(a, b, a.oi(b, i));
        f = g;
        a.gi(b, i, f);
        if (a.rk()) {
            d = c;
            e = a.dj(d, null);
            !$61de1ee1cac498ae$var$BD(h, 49).eh() && (e = a.cj(i, e));
            !!e && e.Fi();
        }
        $61de1ee1cac498ae$var$oid(a.e) && $61de1ee1cac498ae$var$GLd(a, a.Zi(9, c, h, b, false));
        return h;
    } else return c;
}
function $61de1ee1cac498ae$var$pVb(a, b) {
    var c, d, e, f;
    for(d = new $61de1ee1cac498ae$var$olb(a.a.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 189);
        c.g = true;
    }
    for(f = new $61de1ee1cac498ae$var$olb(a.a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 81);
        e.k = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(a.e.Kb(new $61de1ee1cac498ae$var$vgd(e, b))));
        e.d.g = e.d.g & $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(a.e.Kb(new $61de1ee1cac498ae$var$vgd(e, b))));
    }
    return a;
}
function $61de1ee1cac498ae$var$pkc(a) {
    var b, c, d, e, f;
    c = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$F1), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0));
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
    if (f) for(e = new $61de1ee1cac498ae$var$olb(f.j); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 11);
        $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$$sc)) === $61de1ee1cac498ae$var$PD(a) && $61de1ee1cac498ae$var$a1b(new $61de1ee1cac498ae$var$b1b(d.b)) && $61de1ee1cac498ae$var$rqb(c, d.j);
    }
    return c;
}
function $61de1ee1cac498ae$var$zCc(a, b, c) {
    var d, e, f, g, h;
    if (a.d[c.p]) return;
    for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(c).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
        h = d.d.i;
        for(g = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(g);){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(g), 17);
            f.c.i == b && (a.a[f.p] = true);
        }
        $61de1ee1cac498ae$var$zCc(a, b, h);
    }
    a.d[c.p] = true;
}
function $61de1ee1cac498ae$var$Bjd(a, b) {
    var c, d, e, f, g, h, i;
    d = $61de1ee1cac498ae$var$aeb(a.Db & 254);
    if (d == 1) a.Eb = null;
    else {
        f = $61de1ee1cac498ae$var$CD(a.Eb);
        if (d == 2) {
            e = $61de1ee1cac498ae$var$zjd(a, b);
            a.Eb = f[e == 0 ? 1 : 0];
        } else {
            g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, d - 1, 5, 1);
            for(c = 2, h = 0, i = 0; c <= 128; c <<= 1)c == b ? ++h : (a.Db & c) != 0 && (g[i++] = f[h++]);
            a.Eb = g;
        }
    }
    a.Db &= ~b;
}
function $61de1ee1cac498ae$var$n1d(a, b) {
    var c, d, e, f, g;
    d = (!b.s && (b.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, b, 21, 17)), b.s);
    f = null;
    for(e = 0, g = d.i; e < g; ++e){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(d, e), 170);
        switch($61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d(a, c))){
            case 4:
            case 5:
            case 6:
                !f && (f = new $61de1ee1cac498ae$var$Rkb);
                f.c[f.c.length] = c;
                break;
        }
    }
    return !f ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb) : f;
}
function $61de1ee1cac498ae$var$Uee(a) {
    var b;
    b = 0;
    switch(a){
        case 105:
            b = 2;
            break;
        case 109:
            b = 8;
            break;
        case 115:
            b = 4;
            break;
        case 120:
            b = 16;
            break;
        case 117:
            b = 32;
            break;
        case 119:
            b = 64;
            break;
        case 70:
            b = 256;
            break;
        case 72:
            b = 128;
            break;
        case 88:
            b = 512;
            break;
        case 44:
            b = $61de1ee1cac498ae$var$zte;
    }
    return b;
}
function $61de1ee1cac498ae$var$Ghb(a, b, c, d, e) {
    var f, g, h, i;
    if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b) && d == e) {
        $61de1ee1cac498ae$var$Lhb(a, d, c);
        return;
    }
    for(h = 0; h < d; h++){
        g = 0;
        f = a[h];
        for(i = 0; i < e; i++){
            g = $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$xbb(f, $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(b[i], $61de1ee1cac498ae$var$Yje)), $61de1ee1cac498ae$var$xbb(c[h + i], $61de1ee1cac498ae$var$Yje)), $61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Tbb(g), $61de1ee1cac498ae$var$Yje));
            c[h + i] = $61de1ee1cac498ae$var$Tbb(g);
            g = $61de1ee1cac498ae$var$Pbb(g, 32);
        }
        c[h + e] = $61de1ee1cac498ae$var$Tbb(g);
    }
}
function $61de1ee1cac498ae$var$COb(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    k = 0;
    j = 0;
    e = a.a;
    h = e.a.gc();
    for(d = e.a.ec().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 561);
        b = (c.b && $61de1ee1cac498ae$var$LOb(c), c.a);
        l = b.a;
        g = b.b;
        k += l + g;
        j += l * g;
    }
    i = $61de1ee1cac498ae$var$$wnd.Math.sqrt(400 * h * j - 4 * j + k * k) + k;
    f = 2 * (100 * h - 1);
    if (f == 0) return i;
    return i / f;
}
function $61de1ee1cac498ae$var$mOc(a, b) {
    if (b.b != 0) {
        isNaN(a.s) ? a.s = $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$ED(b.a.a.c))) : a.s = $61de1ee1cac498ae$var$$wnd.Math.min(a.s, $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$ED(b.a.a.c))));
        isNaN(a.c) ? a.c = $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$ED(b.c.b.c))) : a.c = $61de1ee1cac498ae$var$$wnd.Math.max(a.c, $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$ED(b.c.b.c))));
    }
}
function $61de1ee1cac498ae$var$Pld(a) {
    var b, c, d, e;
    b = null;
    for(d = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
        (!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b),
        (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c)
    ]))); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 82);
        e = $61de1ee1cac498ae$var$atd(c);
        if (!b) b = $61de1ee1cac498ae$var$Xod(e);
        else if (b != $61de1ee1cac498ae$var$Xod(e)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Rxd(a, b) {
    var c, d, e, f;
    if (a.ej()) {
        c = a.i;
        f = a.fj();
        $61de1ee1cac498ae$var$lud(a, b);
        d = a.Zi(3, null, b, c, f);
        if (a.bj()) {
            e = a.cj(b, null);
            a.ij() && (e = a.jj(b, e));
            if (!e) a.$i(d);
            else {
                e.Ei(d);
                e.Fi();
            }
        } else a.$i(d);
    } else {
        $61de1ee1cac498ae$var$lud(a, b);
        if (a.bj()) {
            e = a.cj(b, null);
            !!e && e.Fi();
        }
    }
}
function $61de1ee1cac498ae$var$rwd(a, b, c) {
    var d, e, f;
    if (a.ej()) {
        f = a.fj();
        ++a.j;
        a.Hi(b, a.oi(b, c));
        d = a.Zi(3, null, c, b, f);
        if (a.bj()) {
            e = a.cj(c, null);
            if (!e) a.$i(d);
            else {
                e.Ei(d);
                e.Fi();
            }
        } else a.$i(d);
    } else {
        ++a.j;
        a.Hi(b, a.oi(b, c));
        if (a.bj()) {
            e = a.cj(c, null);
            !!e && e.Fi();
        }
    }
}
function $61de1ee1cac498ae$var$Wee(a) {
    var b, c, d, e;
    e = a.length;
    b = null;
    for(d = 0; d < e; d++){
        c = ($61de1ee1cac498ae$var$BCb(d, a.length), a.charCodeAt(d));
        if ($61de1ee1cac498ae$var$hfb(".*+?{[()|\\^$", $61de1ee1cac498ae$var$wfb(c)) >= 0) {
            if (!b) {
                b = new $61de1ee1cac498ae$var$Ifb;
                d > 0 && $61de1ee1cac498ae$var$Efb(b, a.substr(0, d));
            }
            b.a += "\\";
            $61de1ee1cac498ae$var$Afb(b, c & $61de1ee1cac498ae$var$aje);
        } else !!b && $61de1ee1cac498ae$var$Afb(b, c & $61de1ee1cac498ae$var$aje);
    }
    return b ? b.a : a;
}
function $61de1ee1cac498ae$var$l5c(a) {
    var b;
    if (!a.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("IDataType class expected for layout option " + a.f));
    b = $61de1ee1cac498ae$var$gvd(a.a);
    if (b == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Couldn't create new instance of property '" + a.f + "'. " + $61de1ee1cac498ae$var$ise + ($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$Y3), $61de1ee1cac498ae$var$Y3.k) + $61de1ee1cac498ae$var$jse));
    return $61de1ee1cac498ae$var$BD(b, 414);
}
function $61de1ee1cac498ae$var$aid(a) {
    var b, c, d, e, f;
    f = a.eh();
    if (f) {
        if (f.kh()) {
            e = $61de1ee1cac498ae$var$xid(a, f);
            if (e != f) {
                c = a.Vg();
                d = (b = a.Vg(), b >= 0 ? a.Qg(null) : a.eh().ih(a, -1 - b, null, null));
                a.Rg($61de1ee1cac498ae$var$BD(e, 49), c);
                !!d && d.Fi();
                a.Lg() && a.Mg() && c > -1 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 9, c, f, e));
                return e;
            }
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$nTb(a) {
    var b, c, d, e, f, g, h, i;
    g = 0;
    f = a.f.e;
    for(d = 0; d < f.c.length; ++d){
        h = ($61de1ee1cac498ae$var$tCb(d, f.c.length), $61de1ee1cac498ae$var$BD(f.c[d], 144));
        for(e = d + 1; e < f.c.length; ++e){
            i = ($61de1ee1cac498ae$var$tCb(e, f.c.length), $61de1ee1cac498ae$var$BD(f.c[e], 144));
            c = $61de1ee1cac498ae$var$S6c(h.d, i.d);
            b = c - a.a[h.b][i.b];
            g += a.i[h.b][i.b] * b * b;
        }
    }
    return g;
}
function $61de1ee1cac498ae$var$_ac(a, b) {
    var c;
    if ($61de1ee1cac498ae$var$wNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc))) return;
    c = $61de1ee1cac498ae$var$hbc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Uac), 360), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$mxc), 163));
    $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$Uac, c);
    if ($61de1ee1cac498ae$var$Qr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)))) return;
    switch(c.g){
        case 1:
            $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$xtc));
            break;
        case 2:
            $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ztc));
    }
}
function $61de1ee1cac498ae$var$wkc(a, b) {
    var c;
    $61de1ee1cac498ae$var$mkc(a);
    a.a = (c = new $61de1ee1cac498ae$var$Ji, $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.d, 16)), new $61de1ee1cac498ae$var$Vkc(c)), c);
    $61de1ee1cac498ae$var$rkc(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Wwc)), 376));
    $61de1ee1cac498ae$var$tkc(a);
    $61de1ee1cac498ae$var$skc(a);
    $61de1ee1cac498ae$var$qkc(a);
    $61de1ee1cac498ae$var$ukc(a);
    $61de1ee1cac498ae$var$vkc(a, b);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, $61de1ee1cac498ae$var$$i($61de1ee1cac498ae$var$Yi(a.b).a)), new $61de1ee1cac498ae$var$Lkc), new $61de1ee1cac498ae$var$Nkc);
    b.a = false;
    a.a = null;
}
function $61de1ee1cac498ae$var$Bod() {
    $61de1ee1cac498ae$var$fod.call(this, $61de1ee1cac498ae$var$yte, ($61de1ee1cac498ae$var$Fhd(), $61de1ee1cac498ae$var$Ehd));
    this.p = null;
    this.a = null;
    this.f = null;
    this.n = null;
    this.g = null;
    this.c = null;
    this.i = null;
    this.j = null;
    this.d = null;
    this.b = null;
    this.e = null;
    this.k = null;
    this.o = null;
    this.s = null;
    this.q = false;
    this.r = false;
}
function $61de1ee1cac498ae$var$Csd() {
    $61de1ee1cac498ae$var$Csd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Bsd = new $61de1ee1cac498ae$var$Dsd($61de1ee1cac498ae$var$Wne, 0);
    $61de1ee1cac498ae$var$ysd = new $61de1ee1cac498ae$var$Dsd("INSIDE_SELF_LOOPS", 1);
    $61de1ee1cac498ae$var$zsd = new $61de1ee1cac498ae$var$Dsd("MULTI_EDGES", 2);
    $61de1ee1cac498ae$var$xsd = new $61de1ee1cac498ae$var$Dsd("EDGE_LABELS", 3);
    $61de1ee1cac498ae$var$Asd = new $61de1ee1cac498ae$var$Dsd("PORTS", 4);
    $61de1ee1cac498ae$var$vsd = new $61de1ee1cac498ae$var$Dsd("COMPOUND", 5);
    $61de1ee1cac498ae$var$usd = new $61de1ee1cac498ae$var$Dsd("CLUSTERS", 6);
    $61de1ee1cac498ae$var$wsd = new $61de1ee1cac498ae$var$Dsd("DISCONNECTED", 7);
}
function $61de1ee1cac498ae$var$Sgb(a, b) {
    var c, d, e;
    if (b == 0) return (a.a[0] & 1) != 0;
    if (b < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$ocb("Negative bit address"));
    e = b >> 5;
    if (e >= a.d) return a.e < 0;
    c = a.a[e];
    b = 1 << (b & 31);
    if (a.e < 0) {
        d = $61de1ee1cac498ae$var$Mgb(a);
        if (e < d) return false;
        else d == e ? c = -c : c = ~c;
    }
    return (c & b) != 0;
}
function $61de1ee1cac498ae$var$O1c(a, b, c, d) {
    var e;
    $61de1ee1cac498ae$var$BD(c.b, 65);
    $61de1ee1cac498ae$var$BD(c.b, 65);
    $61de1ee1cac498ae$var$BD(d.b, 65);
    $61de1ee1cac498ae$var$BD(d.b, 65);
    e = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD(c.b, 65).c), $61de1ee1cac498ae$var$BD(d.b, 65).c);
    $61de1ee1cac498ae$var$$6c(e, $61de1ee1cac498ae$var$YNb($61de1ee1cac498ae$var$BD(c.b, 65), $61de1ee1cac498ae$var$BD(d.b, 65), e));
    $61de1ee1cac498ae$var$BD(d.b, 65);
    $61de1ee1cac498ae$var$BD(d.b, 65);
    $61de1ee1cac498ae$var$BD(d.b, 65).c.a, e.a;
    $61de1ee1cac498ae$var$BD(d.b, 65).c.b, e.b;
    $61de1ee1cac498ae$var$BD(d.b, 65);
    $61de1ee1cac498ae$var$Hkb(d.a, new $61de1ee1cac498ae$var$T1c(a, b, d));
}
function $61de1ee1cac498ae$var$vNd(a, b) {
    var c, d, e, f, g, h, i;
    f = b.e;
    if (f) {
        c = $61de1ee1cac498ae$var$aid(f);
        d = $61de1ee1cac498ae$var$BD(a.g, 674);
        for(g = 0; g < a.i; ++g){
            i = d[g];
            if ($61de1ee1cac498ae$var$JQd(i) == c) {
                e = (!i.d && (i.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, i, 1)), i.d);
                h = $61de1ee1cac498ae$var$BD(c.ah($61de1ee1cac498ae$var$Nid(f, f.Cb, f.Db >> 16)), 15).Xc(f);
                if (h < e.i) return $61de1ee1cac498ae$var$vNd(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(e, h), 87));
            }
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$bcb(a, b, c) {
    var d = $61de1ee1cac498ae$var$_bb, h;
    var e = d[a];
    var f = e instanceof Array ? e[0] : null;
    if (e && !f) $61de1ee1cac498ae$var$_ = e;
    else {
        $61de1ee1cac498ae$var$_ = (h = b && b.prototype, !h && (h = $61de1ee1cac498ae$var$_bb[b]), $61de1ee1cac498ae$var$ecb(h));
        $61de1ee1cac498ae$var$_.hm = c;
        !b && ($61de1ee1cac498ae$var$_.im = $61de1ee1cac498ae$var$gcb);
        d[a] = $61de1ee1cac498ae$var$_;
    }
    for(var g = 3; g < arguments.length; ++g)arguments[g].prototype = $61de1ee1cac498ae$var$_;
    f && ($61de1ee1cac498ae$var$_.gm = f);
}
function $61de1ee1cac498ae$var$Qr(a) {
    var b;
    while(!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(a.a), 47).Ob()){
        a.d = $61de1ee1cac498ae$var$Pr(a);
        if (!a.d) return false;
        a.a = $61de1ee1cac498ae$var$BD(a.d.Pb(), 47);
        if ($61de1ee1cac498ae$var$JD(a.a, 39)) {
            b = $61de1ee1cac498ae$var$BD(a.a, 39);
            a.a = b.a;
            !a.b && (a.b = new $61de1ee1cac498ae$var$jkb);
            $61de1ee1cac498ae$var$Wjb(a.b, a.d);
            if (b.b) while(!$61de1ee1cac498ae$var$akb(b.b))$61de1ee1cac498ae$var$Wjb(a.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gkb(b.b), 47));
            a.d = b.d;
        }
    }
    return true;
}
function $61de1ee1cac498ae$var$krb(a, b) {
    var c, d, e, f, g;
    f = b == null ? 0 : a.b.se(b);
    d = (c = a.a.get(f), c == null ? new Array : c);
    for(g = 0; g < d.length; g++){
        e = d[g];
        if (a.b.re(b, e.cd())) {
            if (d.length == 1) {
                d.length = 0;
                $61de1ee1cac498ae$var$trb(a.a, f);
            } else d.splice(g, 1);
            --a.c;
            $61de1ee1cac498ae$var$zpb(a.b);
            return e.dd();
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$GGb(a, b) {
    var c, d, e, f;
    e = 1;
    b.j = true;
    f = null;
    for(d = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$LFb(b)); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 213);
        if (!a.c[c.c]) {
            a.c[c.c] = true;
            f = $61de1ee1cac498ae$var$xFb(c, b);
            if (c.f) e += $61de1ee1cac498ae$var$GGb(a, f);
            else if (!f.j && c.a == c.e.e - c.d.e) {
                c.f = true;
                $61de1ee1cac498ae$var$Qqb(a.p, c);
                e += $61de1ee1cac498ae$var$GGb(a, f);
            }
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$MVb(a) {
    var b, c, d;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        d = ($61de1ee1cac498ae$var$uCb(0), 0);
        if (d > 0) {
            !($61de1ee1cac498ae$var$fad(a.a.c) && b.n.d) && !($61de1ee1cac498ae$var$gad(a.a.c) && b.n.b) && (b.g.d += $61de1ee1cac498ae$var$$wnd.Math.max(0, d / 2 - 0.5));
            !($61de1ee1cac498ae$var$fad(a.a.c) && b.n.a) && !($61de1ee1cac498ae$var$gad(a.a.c) && b.n.c) && (b.g.a -= d - 1);
        }
    }
}
function $61de1ee1cac498ae$var$N3b(a) {
    var b, c, d, e, f;
    e = new $61de1ee1cac498ae$var$Rkb;
    f = $61de1ee1cac498ae$var$O3b(a, e);
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
    if (b) for(d = new $61de1ee1cac498ae$var$olb(b.j); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 11);
        $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$$sc)) === $61de1ee1cac498ae$var$PD(a) && (f = $61de1ee1cac498ae$var$$wnd.Math.max(f, $61de1ee1cac498ae$var$O3b(c, e)));
    }
    e.c.length == 0 || $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Ysc, f);
    return f != -1 ? e : null;
}
function $61de1ee1cac498ae$var$a9b(a, b, c) {
    var d, e, f, g, h, i;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.e, 0), 17).c;
    d = f.i;
    e = d.k;
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.g, 0), 17).d;
    g = i.i;
    h = g.k;
    e == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) ? $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Vsc), 11)) : $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), f);
    h == $61de1ee1cac498ae$var$g0b ? $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Wsc), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$Wsc), 11)) : $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Wsc), i);
}
function $61de1ee1cac498ae$var$Rs(a, b) {
    var c, d, e, f;
    f = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(b == null ? 0 : $61de1ee1cac498ae$var$tb(b), $61de1ee1cac498ae$var$Fie)), 15)));
    c = f & a.b.length - 1;
    e = null;
    for(d = a.b[c]; d; e = d, d = d.a)if (d.d == f && $61de1ee1cac498ae$var$Hb(d.i, b)) {
        !e ? a.b[c] = d.a : e.a = d.a;
        $61de1ee1cac498ae$var$Bs(d.c, d.f);
        $61de1ee1cac498ae$var$As(d.b, d.e);
        --a.f;
        ++a.e;
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$lD(a, b) {
    var c, d, e, f, g;
    b &= 63;
    c = a.h;
    d = (c & $61de1ee1cac498ae$var$Gje) != 0;
    d && (c |= -1048576);
    if (b < 22) {
        g = c >> b;
        f = a.m >> b | c << 22 - b;
        e = a.l >> b | a.m << 22 - b;
    } else if (b < 44) {
        g = d ? $61de1ee1cac498ae$var$Fje : 0;
        f = c >> b - 22;
        e = a.m >> b - 22 | c << 44 - b;
    } else {
        g = d ? $61de1ee1cac498ae$var$Fje : 0;
        f = d ? $61de1ee1cac498ae$var$Eje : 0;
        e = c >> b - 44;
    }
    return $61de1ee1cac498ae$var$TC(e & $61de1ee1cac498ae$var$Eje, f & $61de1ee1cac498ae$var$Eje, g & $61de1ee1cac498ae$var$Fje);
}
function $61de1ee1cac498ae$var$XOb(a) {
    var b, c, d, e, f, g;
    this.c = new $61de1ee1cac498ae$var$Rkb;
    this.d = a;
    d = $61de1ee1cac498ae$var$Pje;
    e = $61de1ee1cac498ae$var$Pje;
    b = $61de1ee1cac498ae$var$Qje;
    c = $61de1ee1cac498ae$var$Qje;
    for(g = $61de1ee1cac498ae$var$Jsb(a, 0); g.b != g.d.c;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 8);
        d = $61de1ee1cac498ae$var$$wnd.Math.min(d, f.a);
        e = $61de1ee1cac498ae$var$$wnd.Math.min(e, f.b);
        b = $61de1ee1cac498ae$var$$wnd.Math.max(b, f.a);
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, f.b);
    }
    this.a = new $61de1ee1cac498ae$var$J6c(d, e, b - d, c - e);
}
function $61de1ee1cac498ae$var$Dac(a, b) {
    var c, d, e, f, g, h;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        for(h = new $61de1ee1cac498ae$var$olb(e.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            g.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b) && $61de1ee1cac498ae$var$zac(g, b);
            for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
                $61de1ee1cac498ae$var$yac(c, b);
            }
        }
    }
}
function $61de1ee1cac498ae$var$Xoc(a) {
    var b, c, d;
    this.c = a;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lwc)), 103);
    b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$owc)));
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Dyc)));
    d == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad) || d == $61de1ee1cac498ae$var$bad || d == $61de1ee1cac498ae$var$cad ? this.b = b * c : this.b = 1 / (b * c);
    this.j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$wyc)));
    this.e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$vyc)));
    this.f = a.b.c.length;
}
function $61de1ee1cac498ae$var$ADc(a) {
    var b, c;
    a.e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.p.c.length, 15, 1);
    a.k = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.p.c.length, 15, 1);
    for(c = new $61de1ee1cac498ae$var$olb(a.p); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        a.e[b.p] = $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
        a.k[b.p] = $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
    }
}
function $61de1ee1cac498ae$var$DDc(a) {
    var b, c, d, e, f, g;
    e = 0;
    a.q = new $61de1ee1cac498ae$var$Rkb;
    b = new $61de1ee1cac498ae$var$Tqb;
    for(g = new $61de1ee1cac498ae$var$olb(a.p); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        f.p = e;
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(f).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
            $61de1ee1cac498ae$var$Qqb(b, c.d.i);
        }
        b.a.Bc(f);
        $61de1ee1cac498ae$var$Ekb(a.q, new $61de1ee1cac498ae$var$Vqb(b));
        b.a.$b();
        ++e;
    }
}
function $61de1ee1cac498ae$var$JTc() {
    $61de1ee1cac498ae$var$JTc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$CTc = new $61de1ee1cac498ae$var$q0b(20);
    $61de1ee1cac498ae$var$BTc = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c), $61de1ee1cac498ae$var$CTc);
    $61de1ee1cac498ae$var$HTc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$T9c, 20);
    $61de1ee1cac498ae$var$uTc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$r8c, $61de1ee1cac498ae$var$tme);
    $61de1ee1cac498ae$var$ETc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$D9c, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$GTc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$H9c, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$vTc = $61de1ee1cac498ae$var$y8c;
    $61de1ee1cac498ae$var$xTc = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$yTc = $61de1ee1cac498ae$var$_8c;
    $61de1ee1cac498ae$var$zTc = $61de1ee1cac498ae$var$b9c;
    $61de1ee1cac498ae$var$wTc = $61de1ee1cac498ae$var$W8c;
    $61de1ee1cac498ae$var$ATc = $61de1ee1cac498ae$var$e9c;
    $61de1ee1cac498ae$var$DTc = $61de1ee1cac498ae$var$x9c;
    $61de1ee1cac498ae$var$ITc = ($61de1ee1cac498ae$var$rTc(), $61de1ee1cac498ae$var$pTc);
    $61de1ee1cac498ae$var$FTc = $61de1ee1cac498ae$var$nTc;
}
function $61de1ee1cac498ae$var$RBd(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (a.a.f > 0 && $61de1ee1cac498ae$var$JD(b, 42)) {
        a.a.qj();
        j = $61de1ee1cac498ae$var$BD(b, 42);
        i = j.cd();
        f = i == null ? 0 : $61de1ee1cac498ae$var$tb(i);
        g = $61de1ee1cac498ae$var$DAd(a.a, f);
        c = a.a.d[g];
        if (c) {
            d = $61de1ee1cac498ae$var$BD(c.g, 367);
            k = c.i;
            for(h = 0; h < k; ++h){
                e = d[h];
                if (e.Sh() == f && e.Fb(j)) {
                    $61de1ee1cac498ae$var$RBd(a, j);
                    return true;
                }
            }
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$skc(a) {
    var b, c, d, e;
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.a, ($61de1ee1cac498ae$var$Xjc(), $61de1ee1cac498ae$var$Ujc)), 15).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 101);
        c = (b = $61de1ee1cac498ae$var$Ec(d.k), b.Hc(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) ? b.Hc($61de1ee1cac498ae$var$zcd) ? b.Hc($61de1ee1cac498ae$var$Rcd) ? b.Hc($61de1ee1cac498ae$var$Tcd) ? null : $61de1ee1cac498ae$var$dkc : $61de1ee1cac498ae$var$fkc : $61de1ee1cac498ae$var$ekc : $61de1ee1cac498ae$var$ckc);
        $61de1ee1cac498ae$var$kkc(a, d, c[0], ($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$Ckc), 0);
        $61de1ee1cac498ae$var$kkc(a, d, c[1], $61de1ee1cac498ae$var$Dkc, 1);
        $61de1ee1cac498ae$var$kkc(a, d, c[2], $61de1ee1cac498ae$var$Ekc, 1);
    }
}
function $61de1ee1cac498ae$var$enc(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$fnc(b);
    $61de1ee1cac498ae$var$inc(a, b, c);
    $61de1ee1cac498ae$var$uPc(a.a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(b.b), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$jtc)), 230));
    $61de1ee1cac498ae$var$dnc(a);
    $61de1ee1cac498ae$var$cnc(a, b);
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b.b.j.c.length, 15, 1);
    $61de1ee1cac498ae$var$lnc(a, b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd), d, c);
    $61de1ee1cac498ae$var$lnc(a, b, $61de1ee1cac498ae$var$zcd, d, c);
    $61de1ee1cac498ae$var$lnc(a, b, $61de1ee1cac498ae$var$Rcd, d, c);
    $61de1ee1cac498ae$var$lnc(a, b, $61de1ee1cac498ae$var$Tcd, d, c);
    a.a = null;
    a.c = null;
    a.b = null;
}
function $61de1ee1cac498ae$var$OYc() {
    $61de1ee1cac498ae$var$OYc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$LYc = ($61de1ee1cac498ae$var$zYc(), $61de1ee1cac498ae$var$yYc);
    $61de1ee1cac498ae$var$KYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Bre, $61de1ee1cac498ae$var$LYc);
    $61de1ee1cac498ae$var$IYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Cre, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$FYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Dre, $61de1ee1cac498ae$var$meb(-1));
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$GYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ere, $61de1ee1cac498ae$var$meb(-1));
    $61de1ee1cac498ae$var$JYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Fre, false);
    $61de1ee1cac498ae$var$MYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Gre, true);
    $61de1ee1cac498ae$var$HYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Hre, false);
    $61de1ee1cac498ae$var$NYc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ire, -1);
}
function $61de1ee1cac498ae$var$yld(a, b, c) {
    switch(b){
        case 7:
            !a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4));
            $61de1ee1cac498ae$var$Uxd(a.e);
            !a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4));
            $61de1ee1cac498ae$var$ytd(a.e, $61de1ee1cac498ae$var$BD(c, 14));
            return;
        case 8:
            !a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5));
            $61de1ee1cac498ae$var$Uxd(a.d);
            !a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5));
            $61de1ee1cac498ae$var$ytd(a.d, $61de1ee1cac498ae$var$BD(c, 14));
            return;
    }
    $61de1ee1cac498ae$var$Zkd(a, b, c);
}
function $61de1ee1cac498ae$var$At(a, b) {
    var c, d, e, f, g;
    if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(a)) return true;
    if (!$61de1ee1cac498ae$var$JD(b, 15)) return false;
    g = $61de1ee1cac498ae$var$BD(b, 15);
    if (a.gc() != g.gc()) return false;
    f = g.Kc();
    for(d = a.Kc(); d.Ob();){
        c = d.Pb();
        e = f.Pb();
        if (!($61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD(e) || c != null && $61de1ee1cac498ae$var$pb(c, e))) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$U6b(a, b) {
    var c, d, e, f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$LAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.b, 16)), new $61de1ee1cac498ae$var$$6b), new $61de1ee1cac498ae$var$a7b), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    f.Jc(new $61de1ee1cac498ae$var$c7b);
    c = 0;
    for(e = f.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 11);
        d.p == -1 && $61de1ee1cac498ae$var$T6b(a, d, c++);
    }
}
function $61de1ee1cac498ae$var$Wzc(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$KLc;
        case 1:
            return new $61de1ee1cac498ae$var$dJc;
        case 2:
            return new $61de1ee1cac498ae$var$tJc;
        case 3:
            return new $61de1ee1cac498ae$var$CMc;
        case 4:
            return new $61de1ee1cac498ae$var$$Jc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("No implementation is available for the node placer " + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$nqc(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$aCc;
        case 1:
            return new $61de1ee1cac498ae$var$VBc;
        case 2:
            return new $61de1ee1cac498ae$var$kCc;
        case 3:
            return new $61de1ee1cac498ae$var$rCc;
        case 4:
            return new $61de1ee1cac498ae$var$eCc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("No implementation is available for the cycle breaker " + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$HWc() {
    $61de1ee1cac498ae$var$HWc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$BWc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$lre, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$CWc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$mre, 0);
    $61de1ee1cac498ae$var$yWc = ($61de1ee1cac498ae$var$pWc(), $61de1ee1cac498ae$var$mWc);
    $61de1ee1cac498ae$var$xWc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$nre, $61de1ee1cac498ae$var$yWc);
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$wWc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ore, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$EWc = ($61de1ee1cac498ae$var$sXc(), $61de1ee1cac498ae$var$qXc);
    $61de1ee1cac498ae$var$DWc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$pre, $61de1ee1cac498ae$var$EWc);
    $61de1ee1cac498ae$var$GWc = ($61de1ee1cac498ae$var$fWc(), $61de1ee1cac498ae$var$eWc);
    $61de1ee1cac498ae$var$FWc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$qre, $61de1ee1cac498ae$var$GWc);
    $61de1ee1cac498ae$var$AWc = ($61de1ee1cac498ae$var$iXc(), $61de1ee1cac498ae$var$hXc);
    $61de1ee1cac498ae$var$zWc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$rre, $61de1ee1cac498ae$var$AWc);
}
function $61de1ee1cac498ae$var$XXb(a, b, c) {
    var d;
    d = null;
    !!b && (d = b.d);
    $61de1ee1cac498ae$var$hYb(a, new $61de1ee1cac498ae$var$cWb(b.n.a - d.b + c.a, b.n.b - d.d + c.b));
    $61de1ee1cac498ae$var$hYb(a, new $61de1ee1cac498ae$var$cWb(b.n.a - d.b + c.a, b.n.b + b.o.b + d.a + c.b));
    $61de1ee1cac498ae$var$hYb(a, new $61de1ee1cac498ae$var$cWb(b.n.a + b.o.a + d.c + c.a, b.n.b - d.d + c.b));
    $61de1ee1cac498ae$var$hYb(a, new $61de1ee1cac498ae$var$cWb(b.n.a + b.o.a + d.c + c.a, b.n.b + b.o.b + d.a + c.b));
}
function $61de1ee1cac498ae$var$T6b(a, b, c) {
    var d, e, f;
    b.p = c;
    for(f = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
        new $61de1ee1cac498ae$var$J0b(b),
        new $61de1ee1cac498ae$var$R0b(b)
    ]))); $61de1ee1cac498ae$var$Qr(f);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 11);
        d.p == -1 && $61de1ee1cac498ae$var$T6b(a, d, c);
    }
    if (b.i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) for(e = new $61de1ee1cac498ae$var$olb(b.i.j); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 11);
        d != b && d.p == -1 && $61de1ee1cac498ae$var$T6b(a, d, c);
    }
}
function $61de1ee1cac498ae$var$rPc(a) {
    var b, c, d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$IAb($61de1ee1cac498ae$var$UAb(a)), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    d = $61de1ee1cac498ae$var$dme;
    if (e.gc() >= 2) {
        c = e.Kc();
        b = $61de1ee1cac498ae$var$ED(c.Pb());
        while(c.Ob()){
            f = b;
            b = $61de1ee1cac498ae$var$ED(c.Pb());
            d = $61de1ee1cac498ae$var$$wnd.Math.min(d, ($61de1ee1cac498ae$var$uCb(b), b) - ($61de1ee1cac498ae$var$uCb(f), f));
        }
    }
    return d;
}
function $61de1ee1cac498ae$var$gUc(a, b) {
    var c, d, e, f, g;
    d = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$Gsb(d, b, d.c.b, d.c);
    do {
        c = ($61de1ee1cac498ae$var$sCb(d.b != 0), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Nsb(d, d.a.a), 86));
        a.b[c.g] = 1;
        for(f = $61de1ee1cac498ae$var$Jsb(c.d, 0); f.b != f.d.c;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 188);
            g = e.c;
            a.b[g.g] == 1 ? $61de1ee1cac498ae$var$Dsb(a.a, e) : a.b[g.g] == 2 ? a.b[g.g] = 1 : $61de1ee1cac498ae$var$Gsb(d, g, d.c.b, d.c);
        }
    }while (d.b != 0);
}
function $61de1ee1cac498ae$var$Ju(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$Qb(a))) return true;
    if (!$61de1ee1cac498ae$var$JD(b, 15)) return false;
    d = $61de1ee1cac498ae$var$BD(b, 15);
    e = a.gc();
    if (e != d.gc()) return false;
    if ($61de1ee1cac498ae$var$JD(d, 54)) {
        for(c = 0; c < e; c++){
            if (!$61de1ee1cac498ae$var$Hb(a.Xb(c), d.Xb(c))) return false;
        }
        return true;
    } else return $61de1ee1cac498ae$var$kr(a.Kc(), d.Kc());
}
function $61de1ee1cac498ae$var$Aac(a, b) {
    var c, d;
    if (a.c.length != 0) {
        if (a.c.length == 2) {
            $61de1ee1cac498ae$var$zac(($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 10)), ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd));
            $61de1ee1cac498ae$var$zac(($61de1ee1cac498ae$var$tCb(1, a.c.length), $61de1ee1cac498ae$var$BD(a.c[1], 10)), $61de1ee1cac498ae$var$obd);
        } else for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
            $61de1ee1cac498ae$var$zac(c, b);
        }
        a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    }
}
function $61de1ee1cac498ae$var$uKc(a) {
    var b, c;
    if (a.c.length != 2) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Order only allowed for two paths."));
    b = ($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 17));
    c = ($61de1ee1cac498ae$var$tCb(1, a.c.length), $61de1ee1cac498ae$var$BD(a.c[1], 17));
    if (b.d.i != c.c.i) {
        a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        a.c[a.c.length] = c;
        a.c[a.c.length] = b;
    }
}
function $61de1ee1cac498ae$var$EMc(a, b) {
    var c, d, e, f, g, h;
    d = new $61de1ee1cac498ae$var$$rb;
    g = $61de1ee1cac498ae$var$Gx(new $61de1ee1cac498ae$var$amb(a.g));
    for(f = g.a.ec().Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 10);
        if (!e) {
            $61de1ee1cac498ae$var$Sdd(b, "There are no classes in a balanced layout.");
            break;
        }
        h = a.j[e.p];
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(d, h), 15);
        if (!c) {
            c = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$Xrb(d, h, c);
        }
        c.Fc(e);
    }
    return d;
}
function $61de1ee1cac498ae$var$Dqd(a, b, c) {
    var d, e, f, g, h, i, j;
    if (c) {
        f = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(f);
        for(h = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            i = $61de1ee1cac498ae$var$Zpd(c, g.a);
            if (i) {
                j = $61de1ee1cac498ae$var$ftd($61de1ee1cac498ae$var$_pd(i, $61de1ee1cac498ae$var$Ite), b);
                $61de1ee1cac498ae$var$Rhb(a.f, j, i);
                e = $61de1ee1cac498ae$var$Vte in i.a;
                e && $61de1ee1cac498ae$var$Lkd(j, $61de1ee1cac498ae$var$_pd(i, $61de1ee1cac498ae$var$Vte));
                $61de1ee1cac498ae$var$grd(i, j);
                $61de1ee1cac498ae$var$hrd(i, j);
            }
        }
    }
}
function $61de1ee1cac498ae$var$ndc(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, "Port side processing", 1);
    for(g = new $61de1ee1cac498ae$var$olb(a.a); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        $61de1ee1cac498ae$var$odc(e);
    }
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        for(f = new $61de1ee1cac498ae$var$olb(c.a); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
            $61de1ee1cac498ae$var$odc(e);
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$bfc(a, b, c) {
    var d, e, f, g, h;
    e = a.f;
    !e && (e = $61de1ee1cac498ae$var$BD(a.a.a.ec().Kc().Pb(), 57));
    $61de1ee1cac498ae$var$cfc(e, b, c);
    if (a.a.a.gc() == 1) return;
    d = b * c;
    for(g = a.a.a.ec().Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 57);
        if (f != e) {
            h = $61de1ee1cac498ae$var$ugc(f);
            if (h.f.d) {
                f.d.d += d + $61de1ee1cac498ae$var$ple;
                f.d.a -= d + $61de1ee1cac498ae$var$ple;
            } else h.f.a && (f.d.a -= d + $61de1ee1cac498ae$var$ple);
        }
    }
}
function $61de1ee1cac498ae$var$tQb(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n;
    g = c - a;
    h = d - b;
    f = $61de1ee1cac498ae$var$$wnd.Math.atan2(g, h);
    i = f + $61de1ee1cac498ae$var$cme;
    j = f - $61de1ee1cac498ae$var$cme;
    k = e * $61de1ee1cac498ae$var$$wnd.Math.sin(i) + a;
    m = e * $61de1ee1cac498ae$var$$wnd.Math.cos(i) + b;
    l = e * $61de1ee1cac498ae$var$$wnd.Math.sin(j) + a;
    n = e * $61de1ee1cac498ae$var$$wnd.Math.cos(j) + b;
    return $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        new $61de1ee1cac498ae$var$f7c(k, m),
        new $61de1ee1cac498ae$var$f7c(l, n)
    ]));
}
function $61de1ee1cac498ae$var$OLc(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    e = c;
    k = b;
    f = k;
    do {
        f = a.a[f.p];
        h = (l = a.g[f.p], $61de1ee1cac498ae$var$Edb(a.p[l.p]) + $61de1ee1cac498ae$var$Edb(a.d[f.p]) - f.d.d);
        i = $61de1ee1cac498ae$var$RLc(f, d);
        if (i) {
            g = (j = a.g[i.p], $61de1ee1cac498ae$var$Edb(a.p[j.p]) + $61de1ee1cac498ae$var$Edb(a.d[i.p]) + i.o.b + i.d.a);
            e = $61de1ee1cac498ae$var$$wnd.Math.min(e, h - (g + $61de1ee1cac498ae$var$jBc(a.k, f, i)));
        }
    }while (k != f);
    return e;
}
function $61de1ee1cac498ae$var$PLc(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    e = c;
    k = b;
    f = k;
    do {
        f = a.a[f.p];
        g = (l = a.g[f.p], $61de1ee1cac498ae$var$Edb(a.p[l.p]) + $61de1ee1cac498ae$var$Edb(a.d[f.p]) + f.o.b + f.d.a);
        i = $61de1ee1cac498ae$var$QLc(f, d);
        if (i) {
            h = (j = a.g[i.p], $61de1ee1cac498ae$var$Edb(a.p[j.p]) + $61de1ee1cac498ae$var$Edb(a.d[i.p]) - i.d.d);
            e = $61de1ee1cac498ae$var$$wnd.Math.min(e, h - (g + $61de1ee1cac498ae$var$jBc(a.k, f, i)));
        }
    }while (k != f);
    return e;
}
function $61de1ee1cac498ae$var$hkd(a, b) {
    var c, d;
    d = (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$AAd(a.o, b));
    if (d != null) return d;
    c = b.wg();
    $61de1ee1cac498ae$var$JD(c, 4) && (c == null ? (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$LAd(a.o, b)) : (!a.o && (a.o = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd), $61de1ee1cac498ae$var$S2, a, 0)), $61de1ee1cac498ae$var$HAd(a.o, b, c)), a);
    return c;
}
function $61de1ee1cac498ae$var$Hbd() {
    $61de1ee1cac498ae$var$Hbd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$zbd = new $61de1ee1cac498ae$var$Ibd("H_LEFT", 0);
    $61de1ee1cac498ae$var$ybd = new $61de1ee1cac498ae$var$Ibd("H_CENTER", 1);
    $61de1ee1cac498ae$var$Bbd = new $61de1ee1cac498ae$var$Ibd("H_RIGHT", 2);
    $61de1ee1cac498ae$var$Gbd = new $61de1ee1cac498ae$var$Ibd("V_TOP", 3);
    $61de1ee1cac498ae$var$Fbd = new $61de1ee1cac498ae$var$Ibd("V_CENTER", 4);
    $61de1ee1cac498ae$var$Ebd = new $61de1ee1cac498ae$var$Ibd("V_BOTTOM", 5);
    $61de1ee1cac498ae$var$Cbd = new $61de1ee1cac498ae$var$Ibd("INSIDE", 6);
    $61de1ee1cac498ae$var$Dbd = new $61de1ee1cac498ae$var$Ibd("OUTSIDE", 7);
    $61de1ee1cac498ae$var$Abd = new $61de1ee1cac498ae$var$Ibd("H_PRIORITY", 8);
}
function $61de1ee1cac498ae$var$o6d(a) {
    var b, c, d, e, f, g, h;
    b = a.Hh($61de1ee1cac498ae$var$_ve);
    if (b) {
        h = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!b.b && (b.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, b)), b.b), "settingDelegates"));
        if (h != null) {
            c = new $61de1ee1cac498ae$var$Rkb;
            for(e = $61de1ee1cac498ae$var$mfb(h, "\\w+"), f = 0, g = e.length; f < g; ++f){
                d = e[f];
                c.c[c.c.length] = d;
            }
            return c;
        }
    }
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
}
function $61de1ee1cac498ae$var$sGb(a, b) {
    var c, d, e, f, g, h, i;
    if (!b.f) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The input edge is not a tree edge."));
    f = null;
    e = $61de1ee1cac498ae$var$Ohe;
    for(d = new $61de1ee1cac498ae$var$olb(a.d); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 213);
        h = c.d;
        i = c.e;
        if ($61de1ee1cac498ae$var$xGb(a, h, b) && !$61de1ee1cac498ae$var$xGb(a, i, b)) {
            g = i.e - h.e - c.a;
            if (g < e) {
                e = g;
                f = c;
            }
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$qTb(a) {
    var b, c, d, e, f, g;
    if (a.f.e.c.length <= 1) return;
    b = 0;
    e = $61de1ee1cac498ae$var$nTb(a);
    c = $61de1ee1cac498ae$var$Pje;
    do {
        b > 0 && (e = c);
        for(g = new $61de1ee1cac498ae$var$olb(a.f.e); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 144);
            if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$bTb(), $61de1ee1cac498ae$var$USb))))) continue;
            d = $61de1ee1cac498ae$var$mTb(a, f);
            $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(f.d), d);
        }
        c = $61de1ee1cac498ae$var$nTb(a);
    }while (!$61de1ee1cac498ae$var$pTb(a, b++, e, c));
}
function $61de1ee1cac498ae$var$$ac(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$Odd(b, "Layer constraint preprocessing", 1);
    c = new $61de1ee1cac498ae$var$Rkb;
    e = new $61de1ee1cac498ae$var$Bib(a.a, 0);
    while(e.b < e.d.gc()){
        d = ($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), $61de1ee1cac498ae$var$BD(e.d.Xb(e.c = e.b++), 10));
        if ($61de1ee1cac498ae$var$Zac(d)) {
            $61de1ee1cac498ae$var$Xac(d);
            c.c[c.c.length] = d;
            $61de1ee1cac498ae$var$uib(e);
        }
    }
    c.c.length == 0 || $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Lsc), c);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$sjc(a, b) {
    var c, d, e, f, g;
    f = a.g.a;
    g = a.g.b;
    for(d = new $61de1ee1cac498ae$var$olb(a.d); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 70);
        e = c.n;
        a.a == ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$xjc) || a.i == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) ? e.a = f : a.a == $61de1ee1cac498ae$var$yjc || a.i == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? e.a = f + a.j.a - c.o.a : e.a = f + (a.j.a - c.o.a) / 2;
        e.b = g;
        $61de1ee1cac498ae$var$P6c(e, b);
        g += c.o.b + a.e;
    }
}
function $61de1ee1cac498ae$var$LSc(a, b, c) {
    var d, e, f, g;
    $61de1ee1cac498ae$var$Odd(c, "Processor set coordinates", 1);
    a.a = b.b.b == 0 ? 1 : b.b.b;
    f = null;
    d = $61de1ee1cac498ae$var$Jsb(b.b, 0);
    while(!f && d.b != d.d.c){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 86);
        if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc))))) {
            f = g;
            e = g.e;
            e.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$kTc), 19).a;
            e.b = 0;
        }
    }
    $61de1ee1cac498ae$var$MSc(a, $61de1ee1cac498ae$var$URc(f), $61de1ee1cac498ae$var$Udd(c, 1));
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$xSc(a, b, c) {
    var d, e, f;
    $61de1ee1cac498ae$var$Odd(c, "Processor determine the height for each level", 1);
    a.a = b.b.b == 0 ? 1 : b.b.b;
    e = null;
    d = $61de1ee1cac498ae$var$Jsb(b.b, 0);
    while(!e && d.b != d.d.c){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 86);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc)))) && (e = f);
    }
    !!e && $61de1ee1cac498ae$var$ySc(a, $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$q$, 1), $61de1ee1cac498ae$var$fme, 86, 0, [
        e
    ])), c);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$brd(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    j = a;
    i = $61de1ee1cac498ae$var$$pd(j, "individualSpacings");
    if (i) {
        d = $61de1ee1cac498ae$var$ikd(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$O9c));
        g = !d;
        if (g) {
            e = new $61de1ee1cac498ae$var$_fd;
            $61de1ee1cac498ae$var$jkd(b, $61de1ee1cac498ae$var$O9c, e);
        }
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$O9c), 373);
        l = i;
        f = null;
        !!l && (f = (k = $61de1ee1cac498ae$var$$B(l, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, 0, 6, 1)), new $61de1ee1cac498ae$var$mC(l, k)));
        if (f) {
            c = new $61de1ee1cac498ae$var$Frd(l, h);
            $61de1ee1cac498ae$var$reb(f, c);
        }
    }
}
function $61de1ee1cac498ae$var$frd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    i = null;
    l = a;
    k = null;
    if ($61de1ee1cac498ae$var$cue in l.a || $61de1ee1cac498ae$var$due in l.a || $61de1ee1cac498ae$var$Ote in l.a) {
        j = null;
        m = $61de1ee1cac498ae$var$etd(b);
        g = $61de1ee1cac498ae$var$$pd(l, $61de1ee1cac498ae$var$cue);
        c = new $61de1ee1cac498ae$var$Ird(m);
        $61de1ee1cac498ae$var$Eqd(c.a, g);
        h = $61de1ee1cac498ae$var$$pd(l, $61de1ee1cac498ae$var$due);
        d = new $61de1ee1cac498ae$var$asd(m);
        $61de1ee1cac498ae$var$Pqd(d.a, h);
        f = $61de1ee1cac498ae$var$Ypd(l, $61de1ee1cac498ae$var$Ote);
        e = new $61de1ee1cac498ae$var$dsd(m);
        j = ($61de1ee1cac498ae$var$Qqd(e.a, f), f);
        k = j;
    }
    i = k;
    return i;
}
function $61de1ee1cac498ae$var$$w(a, b) {
    var c, d, e;
    if (b === a) return true;
    if ($61de1ee1cac498ae$var$JD(b, 543)) {
        e = $61de1ee1cac498ae$var$BD(b, 835);
        if (a.a.d != e.a.d || $61de1ee1cac498ae$var$Ah(a).gc() != $61de1ee1cac498ae$var$Ah(e).gc()) return false;
        for(d = $61de1ee1cac498ae$var$Ah(e).Kc(); d.Ob();){
            c = $61de1ee1cac498ae$var$BD(d.Pb(), 416);
            if ($61de1ee1cac498ae$var$Aw(a, c.a.cd()) != $61de1ee1cac498ae$var$BD(c.a.dd(), 14).gc()) return false;
        }
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$BMb(a) {
    var b, c, d, e;
    d = $61de1ee1cac498ae$var$BD(a.a, 19).a;
    e = $61de1ee1cac498ae$var$BD(a.b, 19).a;
    b = d;
    c = e;
    if (d == 0 && e == 0) c -= 1;
    else {
        if (d == -1 && e <= 0) {
            b = 0;
            c -= 2;
        } else if (d <= 0 && e > 0) {
            b -= 1;
            c -= 1;
        } else {
            if (d >= 0 && e < 0) {
                b += 1;
                c += 1;
            } else if (d > 0 && e >= 0) {
                b -= 1;
                c += 1;
            } else {
                b += 1;
                c -= 1;
            }
        }
    }
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(b), $61de1ee1cac498ae$var$meb(c));
}
function $61de1ee1cac498ae$var$PIc(a, b) {
    if (a.c < b.c) return -1;
    else if (a.c > b.c) return 1;
    else if (a.b < b.b) return -1;
    else if (a.b > b.b) return 1;
    else if (a.a != b.a) return $61de1ee1cac498ae$var$tb(a.a) - $61de1ee1cac498ae$var$tb(b.a);
    else if (a.d == ($61de1ee1cac498ae$var$UIc(), $61de1ee1cac498ae$var$TIc) && b.d == $61de1ee1cac498ae$var$SIc) return -1;
    else if (a.d == $61de1ee1cac498ae$var$SIc && b.d == $61de1ee1cac498ae$var$TIc) return 1;
    return 0;
}
function $61de1ee1cac498ae$var$aNc(a, b) {
    var c, d, e, f, g;
    f = b.a;
    f.c.i == b.b ? g = f.d : g = f.c;
    f.c.i == b.b ? d = f.c : d = f.d;
    e = $61de1ee1cac498ae$var$NLc(a.a, g, d);
    if (e > 0 && e < $61de1ee1cac498ae$var$dme) {
        c = $61de1ee1cac498ae$var$OLc(a.a, d.i, e, a.c);
        $61de1ee1cac498ae$var$TLc(a.a, d.i, -c);
        return c > 0;
    } else if (e < 0 && -e < $61de1ee1cac498ae$var$dme) {
        c = $61de1ee1cac498ae$var$PLc(a.a, d.i, -e, a.c);
        $61de1ee1cac498ae$var$TLc(a.a, d.i, c);
        return c > 0;
    }
    return false;
}
function $61de1ee1cac498ae$var$RZc(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    e = (b - a.d) / a.c.c.length;
    f = 0;
    a.a += c;
    a.d = b;
    for(l = new $61de1ee1cac498ae$var$olb(a.c); l.a < l.c.c.length;){
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 33);
        j = k.g;
        i = k.f;
        $61de1ee1cac498ae$var$dld(k, k.i + f * e);
        $61de1ee1cac498ae$var$eld(k, k.j + d * c);
        $61de1ee1cac498ae$var$cld(k, k.g + e);
        $61de1ee1cac498ae$var$ald(k, a.a);
        ++f;
        h = k.g;
        g = k.f;
        $61de1ee1cac498ae$var$Ffd(k, new $61de1ee1cac498ae$var$f7c(h, g), new $61de1ee1cac498ae$var$f7c(j, i));
    }
}
function $61de1ee1cac498ae$var$Xmd(a) {
    var b, c, d, e, f, g, h;
    if (a == null) return null;
    h = a.length;
    e = (h + 1) / 2 | 0;
    g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, e, 15, 1);
    h % 2 != 0 && (g[--e] = $61de1ee1cac498ae$var$jnd(($61de1ee1cac498ae$var$BCb(h - 1, a.length), a.charCodeAt(h - 1))));
    for(c = 0, d = 0; c < e; ++c){
        b = $61de1ee1cac498ae$var$jnd($61de1ee1cac498ae$var$bfb(a, d++));
        f = $61de1ee1cac498ae$var$jnd($61de1ee1cac498ae$var$bfb(a, d++));
        g[c] = (b << 4 | f) << 24 >> 24;
    }
    return g;
}
function $61de1ee1cac498ae$var$vdb(a) {
    if (a.pe()) {
        var b = a.c;
        b.qe() ? a.o = "[" + b.n : !b.pe() ? a.o = "[L" + b.ne() + ";" : a.o = "[" + b.ne();
        a.b = b.me() + "[]";
        a.k = b.oe() + "[]";
        return;
    }
    var c = a.j;
    var d = a.d;
    d = d.split("/");
    a.o = $61de1ee1cac498ae$var$ydb(".", [
        c,
        $61de1ee1cac498ae$var$ydb("$", d)
    ]);
    a.b = $61de1ee1cac498ae$var$ydb(".", [
        c,
        $61de1ee1cac498ae$var$ydb(".", d)
    ]);
    a.k = d[d.length - 1];
}
function $61de1ee1cac498ae$var$qGb(a, b) {
    var c, d, e, f, g;
    g = null;
    for(f = new $61de1ee1cac498ae$var$olb(a.e.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 121);
        if (e.b.a.c.length == e.g.a.c.length) {
            d = e.e;
            g = $61de1ee1cac498ae$var$BGb(e);
            for(c = e.e - $61de1ee1cac498ae$var$BD(g.a, 19).a + 1; c < e.e + $61de1ee1cac498ae$var$BD(g.b, 19).a; c++)b[c] < b[d] && (d = c);
            if (b[d] < b[e.e]) {
                --b[e.e];
                ++b[d];
                e.e = d;
            }
        }
    }
}
function $61de1ee1cac498ae$var$SLc(a) {
    var b, c, d, e, f, g, h, i;
    e = $61de1ee1cac498ae$var$Pje;
    d = $61de1ee1cac498ae$var$Qje;
    for(c = new $61de1ee1cac498ae$var$olb(a.e.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 29);
        for(g = new $61de1ee1cac498ae$var$olb(b.a); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
            i = $61de1ee1cac498ae$var$Edb(a.p[f.p]);
            h = i + $61de1ee1cac498ae$var$Edb(a.b[a.g[f.p].p]);
            e = $61de1ee1cac498ae$var$$wnd.Math.min(e, i);
            d = $61de1ee1cac498ae$var$$wnd.Math.max(d, h);
        }
    }
    return d - e;
}
function $61de1ee1cac498ae$var$r1d(a, b, c, d) {
    var e, f, g, h, i, j;
    i = null;
    e = $61de1ee1cac498ae$var$f1d(a, b);
    for(h = 0, j = e.gc(); h < j; ++h){
        f = $61de1ee1cac498ae$var$BD(e.Xb(h), 170);
        if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(a, f)))) {
            g = $61de1ee1cac498ae$var$b2d($61de1ee1cac498ae$var$q1d(a, f));
            if (c == null) {
                if (g == null) return f;
                else !i && (i = f);
            } else if ($61de1ee1cac498ae$var$dfb(c, g)) return f;
            else g == null && !i && (i = f);
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$s1d(a, b, c, d) {
    var e, f, g, h, i, j;
    i = null;
    e = $61de1ee1cac498ae$var$g1d(a, b);
    for(h = 0, j = e.gc(); h < j; ++h){
        f = $61de1ee1cac498ae$var$BD(e.Xb(h), 170);
        if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(a, f)))) {
            g = $61de1ee1cac498ae$var$b2d($61de1ee1cac498ae$var$q1d(a, f));
            if (c == null) {
                if (g == null) return f;
                else !i && (i = f);
            } else if ($61de1ee1cac498ae$var$dfb(c, g)) return f;
            else g == null && !i && (i = f);
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$p3d(a, b, c) {
    var d, e, f, g, h, i;
    g = new $61de1ee1cac498ae$var$yud;
    h = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    d = $61de1ee1cac498ae$var$BD(a.g, 119);
    $61de1ee1cac498ae$var$Q6d();
    if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) for(f = 0; f < a.i; ++f){
        e = d[f];
        h.rl(e.ak()) && $61de1ee1cac498ae$var$wtd(g, e);
    }
    else for(f = 0; f < a.i; ++f){
        e = d[f];
        if (h.rl(e.ak())) {
            i = e.dd();
            $61de1ee1cac498ae$var$wtd(g, c ? $61de1ee1cac498ae$var$b3d(a, b, f, g.i, i) : i);
        }
    }
    return $61de1ee1cac498ae$var$wud(g);
}
function $61de1ee1cac498ae$var$T9b(a, b) {
    var c, d, e, f, g;
    c = new $61de1ee1cac498ae$var$Rpb($61de1ee1cac498ae$var$EW);
    for(e = ($61de1ee1cac498ae$var$Apc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$EW, 1), $61de1ee1cac498ae$var$Kie, 227, 0, [
        $61de1ee1cac498ae$var$wpc,
        $61de1ee1cac498ae$var$ypc,
        $61de1ee1cac498ae$var$vpc,
        $61de1ee1cac498ae$var$xpc,
        $61de1ee1cac498ae$var$zpc,
        $61de1ee1cac498ae$var$upc
    ])), f = 0, g = e.length; f < g; ++f){
        d = e[f];
        $61de1ee1cac498ae$var$Opb(c, d, new $61de1ee1cac498ae$var$Rkb);
    }
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.b, 16)), new $61de1ee1cac498ae$var$hac), new $61de1ee1cac498ae$var$jac), new $61de1ee1cac498ae$var$lac(b)), new $61de1ee1cac498ae$var$nac(c));
    return c;
}
function $61de1ee1cac498ae$var$AVc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    for(f = b.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 33);
        k = e.i + e.g / 2;
        m = e.j + e.f / 2;
        i = a.f;
        g = i.i + i.g / 2;
        h = i.j + i.f / 2;
        j = k - g;
        l = m - h;
        d = $61de1ee1cac498ae$var$$wnd.Math.sqrt(j * j + l * l);
        j *= a.e / d;
        l *= a.e / d;
        if (c) {
            k -= j;
            m -= l;
        } else {
            k += j;
            m += l;
        }
        $61de1ee1cac498ae$var$dld(e, k - e.g / 2);
        $61de1ee1cac498ae$var$eld(e, m - e.f / 2);
    }
}
function $61de1ee1cac498ae$var$Yfe(a) {
    var b, c, d;
    if (a.c) return;
    if (a.b == null) return;
    for(b = a.b.length - 4; b >= 0; b -= 2){
        for(c = 0; c <= b; c += 2)if (a.b[c] > a.b[c + 2] || a.b[c] === a.b[c + 2] && a.b[c + 1] > a.b[c + 3]) {
            d = a.b[c + 2];
            a.b[c + 2] = a.b[c];
            a.b[c] = d;
            d = a.b[c + 3];
            a.b[c + 3] = a.b[c + 1];
            a.b[c + 1] = d;
        }
    }
    a.c = true;
}
function $61de1ee1cac498ae$var$UUb(a, b) {
    var c, d, e, f, g, h, i, j;
    g = b == 1 ? $61de1ee1cac498ae$var$KUb : $61de1ee1cac498ae$var$JUb;
    for(f = g.a.ec().Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 103);
        for(i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.f.c, e), 21).Kc(); i.Ob();){
            h = $61de1ee1cac498ae$var$BD(i.Pb(), 46);
            d = $61de1ee1cac498ae$var$BD(h.b, 81);
            j = $61de1ee1cac498ae$var$BD(h.a, 189);
            c = j.c;
            switch(e.g){
                case 2:
                case 1:
                    d.g.d += c;
                    break;
                case 4:
                case 3:
                    d.g.c += c;
            }
        }
    }
}
function $61de1ee1cac498ae$var$PFc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = -1;
    k = 0;
    for(g = a, h = 0, i = g.length; h < i; ++h){
        f = g[h];
        c = new $61de1ee1cac498ae$var$Dnc(j == -1 ? a[0] : a[j], b, ($61de1ee1cac498ae$var$xzc(), $61de1ee1cac498ae$var$wzc));
        for(d = 0; d < f.length; d++)for(e = d + 1; e < f.length; e++)$61de1ee1cac498ae$var$wNb(f[d], ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) && $61de1ee1cac498ae$var$wNb(f[e], $61de1ee1cac498ae$var$Zsc) && $61de1ee1cac498ae$var$ync(c, f[d], f[e]) > 0 && ++k;
        ++j;
    }
    return k;
}
function $61de1ee1cac498ae$var$Eid(a) {
    var b, c;
    c = new $61de1ee1cac498ae$var$Wfb($61de1ee1cac498ae$var$hdb(a.gm));
    c.a += "@";
    $61de1ee1cac498ae$var$Qfb(c, (b = $61de1ee1cac498ae$var$tb(a) >>> 0, b.toString(16)));
    if (a.kh()) {
        c.a += " (eProxyURI: ";
        $61de1ee1cac498ae$var$Pfb(c, a.qh());
        if (a.$g()) {
            c.a += " eClass: ";
            $61de1ee1cac498ae$var$Pfb(c, a.$g());
        }
        c.a += ")";
    } else if (a.$g()) {
        c.a += " (eClass: ";
        $61de1ee1cac498ae$var$Pfb(c, a.$g());
        c.a += ")";
    }
    return c.a;
}
function $61de1ee1cac498ae$var$TDb(a) {
    var b, c, d, e;
    if (a.e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb(($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$TM), $61de1ee1cac498ae$var$Jke + $61de1ee1cac498ae$var$TM.k + $61de1ee1cac498ae$var$Kke)));
    a.d == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad) && $61de1ee1cac498ae$var$SDb(a, $61de1ee1cac498ae$var$aad);
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 307);
        b.g = b.i;
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 57);
        d.i = $61de1ee1cac498ae$var$Qje;
    }
    a.b.Le(a);
    return a;
}
function $61de1ee1cac498ae$var$TPc(a, b) {
    var c, d, e, f, g;
    if (b < 2 * a.b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The knot vector must have at least two time the dimension elements."));
    a.f = 1;
    for(e = 0; e < a.b; e++)$61de1ee1cac498ae$var$Ekb(a.e, 0);
    g = b + 1 - 2 * a.b;
    c = g;
    for(f = 1; f < g; f++)$61de1ee1cac498ae$var$Ekb(a.e, f / c);
    if (a.d) for(d = 0; d < a.b; d++)$61de1ee1cac498ae$var$Ekb(a.e, 1);
}
function $61de1ee1cac498ae$var$ard(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = b;
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_o($61de1ee1cac498ae$var$qo(a.i), j), 33);
    if (!k) {
        e = $61de1ee1cac498ae$var$_pd(j, $61de1ee1cac498ae$var$Vte);
        h = "Unable to find elk node for json object '" + e;
        i = h + "' Panic!";
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(i));
    }
    f = $61de1ee1cac498ae$var$Ypd(j, "edges");
    c = new $61de1ee1cac498ae$var$krd(a, k);
    $61de1ee1cac498ae$var$mqd(c.a, c.b, f);
    g = $61de1ee1cac498ae$var$Ypd(j, $61de1ee1cac498ae$var$Jte);
    d = new $61de1ee1cac498ae$var$vrd(a);
    $61de1ee1cac498ae$var$xqd(d.a, g);
}
function $61de1ee1cac498ae$var$xAd(a, b, c, d) {
    var e, f, g, h, i;
    if (d != null) {
        e = a.d[b];
        if (e) {
            f = e.g;
            i = e.i;
            for(h = 0; h < i; ++h){
                g = $61de1ee1cac498ae$var$BD(f[h], 133);
                if (g.Sh() == c && $61de1ee1cac498ae$var$pb(d, g.cd())) return h;
            }
        }
    } else {
        e = a.d[b];
        if (e) {
            f = e.g;
            i = e.i;
            for(h = 0; h < i; ++h){
                g = $61de1ee1cac498ae$var$BD(f[h], 133);
                if ($61de1ee1cac498ae$var$PD(g.cd()) === $61de1ee1cac498ae$var$PD(d)) return h;
            }
        }
    }
    return -1;
}
function $61de1ee1cac498ae$var$nUd(a, b) {
    var c, d, e;
    c = b == null ? $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(a.f, null)) : $61de1ee1cac498ae$var$Crb(a.g, b);
    if ($61de1ee1cac498ae$var$JD(c, 235)) {
        e = $61de1ee1cac498ae$var$BD(c, 235);
        e.Qh() == null && undefined;
        return e;
    } else if ($61de1ee1cac498ae$var$JD(c, 498)) {
        d = $61de1ee1cac498ae$var$BD(c, 1938);
        e = d.a;
        !!e && (e.yb == null ? undefined : b == null ? $61de1ee1cac498ae$var$jrb(a.f, null, e) : $61de1ee1cac498ae$var$Drb(a.g, b, e));
        return e;
    } else return null;
}
function $61de1ee1cac498ae$var$ide(a) {
    $61de1ee1cac498ae$var$hde();
    var b, c, d, e, f, g, h;
    if (a == null) return null;
    e = a.length;
    if (e % 2 != 0) return null;
    b = $61de1ee1cac498ae$var$rfb(a);
    f = e / 2 | 0;
    c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, f, 15, 1);
    for(d = 0; d < f; d++){
        g = $61de1ee1cac498ae$var$fde[b[d * 2]];
        if (g == -1) return null;
        h = $61de1ee1cac498ae$var$fde[b[d * 2 + 1]];
        if (h == -1) return null;
        c[d] = (g << 4 | h) << 24 >> 24;
    }
    return c;
}
function $61de1ee1cac498ae$var$lKb(a, b, c) {
    var d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.i, b), 306);
    if (!e) {
        e = new $61de1ee1cac498ae$var$bIb(a.d, b, c);
        $61de1ee1cac498ae$var$Npb(a.i, b, e);
        if ($61de1ee1cac498ae$var$sJb(b)) $61de1ee1cac498ae$var$CHb(a.a, b.c, b.b, e);
        else {
            f = $61de1ee1cac498ae$var$rJb(b);
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.p, f), 244);
            switch(f.g){
                case 1:
                case 3:
                    e.j = true;
                    $61de1ee1cac498ae$var$lIb(d, b.b, e);
                    break;
                case 4:
                case 2:
                    e.k = true;
                    $61de1ee1cac498ae$var$lIb(d, b.c, e);
            }
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$r3d(a, b, c, d) {
    var e, f, g, h, i, j;
    h = new $61de1ee1cac498ae$var$yud;
    i = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    e = $61de1ee1cac498ae$var$BD(a.g, 119);
    $61de1ee1cac498ae$var$Q6d();
    if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) for(g = 0; g < a.i; ++g){
        f = e[g];
        i.rl(f.ak()) && $61de1ee1cac498ae$var$wtd(h, f);
    }
    else for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.rl(f.ak())) {
            j = f.dd();
            $61de1ee1cac498ae$var$wtd(h, d ? $61de1ee1cac498ae$var$b3d(a, b, g, h.i, j) : j);
        }
    }
    return $61de1ee1cac498ae$var$xud(h, c);
}
function $61de1ee1cac498ae$var$YCc(a, b) {
    var c, d, e, f, g, h, i, j;
    e = a.b[b.p];
    if (e >= 0) return e;
    else {
        f = 1;
        for(h = new $61de1ee1cac498ae$var$olb(b.j); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
            for(d = new $61de1ee1cac498ae$var$olb(g.g); d.a < d.c.c.length;){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 17);
                j = c.d.i;
                if (b != j) {
                    i = $61de1ee1cac498ae$var$YCc(a, j);
                    f = $61de1ee1cac498ae$var$$wnd.Math.max(f, i + 1);
                }
            }
        }
        $61de1ee1cac498ae$var$XCc(a, b, f);
        return f;
    }
}
function $61de1ee1cac498ae$var$YGc(a, b, c) {
    var d, e, f;
    for(d = 1; d < a.c.length; d++){
        f = ($61de1ee1cac498ae$var$tCb(d, a.c.length), $61de1ee1cac498ae$var$BD(a.c[d], 10));
        e = d;
        while(e > 0 && b.ue(($61de1ee1cac498ae$var$tCb(e - 1, a.c.length), $61de1ee1cac498ae$var$BD(a.c[e - 1], 10)), f) > 0){
            $61de1ee1cac498ae$var$Nkb(a, e, ($61de1ee1cac498ae$var$tCb(e - 1, a.c.length), $61de1ee1cac498ae$var$BD(a.c[e - 1], 10)));
            --e;
        }
        $61de1ee1cac498ae$var$tCb(e, a.c.length);
        a.c[e] = f;
    }
    c.a = new $61de1ee1cac498ae$var$Lqb;
    c.b = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$n5c(a, b, c) {
    var d, e, f, g, h, i, j, k;
    k = (d = $61de1ee1cac498ae$var$BD(b.e && b.e(), 9), new $61de1ee1cac498ae$var$xqb(d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(d, d.length), 9), 0));
    i = $61de1ee1cac498ae$var$mfb(c, "[\\[\\]\\s,]+");
    for(f = i, g = 0, h = f.length; g < h; ++g){
        e = f[g];
        if ($61de1ee1cac498ae$var$ufb(e).length == 0) continue;
        j = $61de1ee1cac498ae$var$m5c(a, e);
        if (j == null) return null;
        else $61de1ee1cac498ae$var$rqb(k, $61de1ee1cac498ae$var$BD(j, 22));
    }
    return k;
}
function $61de1ee1cac498ae$var$KVb(a) {
    var b, c, d;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        d = ($61de1ee1cac498ae$var$uCb(0), 0);
        if (d > 0) {
            !($61de1ee1cac498ae$var$fad(a.a.c) && b.n.d) && !($61de1ee1cac498ae$var$gad(a.a.c) && b.n.b) && (b.g.d -= $61de1ee1cac498ae$var$$wnd.Math.max(0, d / 2 - 0.5));
            !($61de1ee1cac498ae$var$fad(a.a.c) && b.n.a) && !($61de1ee1cac498ae$var$gad(a.a.c) && b.n.c) && (b.g.a += $61de1ee1cac498ae$var$$wnd.Math.max(0, d - 1));
        }
    }
}
function $61de1ee1cac498ae$var$Hac(a, b, c) {
    var d, e;
    if ((a.c - a.b & a.a.length - 1) == 2) {
        if (b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || b == $61de1ee1cac498ae$var$zcd) {
            $61de1ee1cac498ae$var$xac($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bkb(a), 15), ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd));
            $61de1ee1cac498ae$var$xac($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bkb(a), 15), $61de1ee1cac498ae$var$obd);
        } else {
            $61de1ee1cac498ae$var$xac($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bkb(a), 15), ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$obd));
            $61de1ee1cac498ae$var$xac($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bkb(a), 15), $61de1ee1cac498ae$var$nbd);
        }
    } else for(e = new $61de1ee1cac498ae$var$xkb(a); e.a != e.b;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vkb(e), 15);
        $61de1ee1cac498ae$var$xac(d, c);
    }
}
function $61de1ee1cac498ae$var$htd(a, b) {
    var c, d, e, f, g, h, i;
    e = $61de1ee1cac498ae$var$Nu(new $61de1ee1cac498ae$var$qtd(a));
    h = new $61de1ee1cac498ae$var$Bib(e, e.c.length);
    f = $61de1ee1cac498ae$var$Nu(new $61de1ee1cac498ae$var$qtd(b));
    i = new $61de1ee1cac498ae$var$Bib(f, f.c.length);
    g = null;
    while(h.b > 0 && i.b > 0){
        c = ($61de1ee1cac498ae$var$sCb(h.b > 0), $61de1ee1cac498ae$var$BD(h.a.Xb(h.c = --h.b), 33));
        d = ($61de1ee1cac498ae$var$sCb(i.b > 0), $61de1ee1cac498ae$var$BD(i.a.Xb(i.c = --i.b), 33));
        if (c == d) g = c;
        else break;
    }
    return g;
}
function $61de1ee1cac498ae$var$Cub(a, b) {
    var c, d, e, f, g, h;
    f = a.a * $61de1ee1cac498ae$var$kke + a.b * 1502;
    h = a.b * $61de1ee1cac498ae$var$kke + 11;
    c = $61de1ee1cac498ae$var$$wnd.Math.floor(h * $61de1ee1cac498ae$var$lke);
    f += c;
    h -= c * $61de1ee1cac498ae$var$mke;
    f %= $61de1ee1cac498ae$var$mke;
    a.a = f;
    a.b = h;
    if (b <= 24) return $61de1ee1cac498ae$var$$wnd.Math.floor(a.a * $61de1ee1cac498ae$var$wub[b]);
    else {
        e = a.a * (1 << b - 24);
        g = $61de1ee1cac498ae$var$$wnd.Math.floor(a.b * $61de1ee1cac498ae$var$xub[b]);
        d = e + g;
        d >= 2147483648 && (d -= $61de1ee1cac498ae$var$Zje);
        return d;
    }
}
function $61de1ee1cac498ae$var$Zic(a, b, c) {
    var d, e, f, g;
    if ($61de1ee1cac498ae$var$bjc(a, b) > $61de1ee1cac498ae$var$bjc(a, c)) {
        d = $61de1ee1cac498ae$var$V_b(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
        a.d = d.dc() ? 0 : $61de1ee1cac498ae$var$B0b($61de1ee1cac498ae$var$BD(d.Xb(0), 11));
        g = $61de1ee1cac498ae$var$V_b(b, $61de1ee1cac498ae$var$Tcd);
        a.b = g.dc() ? 0 : $61de1ee1cac498ae$var$B0b($61de1ee1cac498ae$var$BD(g.Xb(0), 11));
    } else {
        e = $61de1ee1cac498ae$var$V_b(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
        a.d = e.dc() ? 0 : $61de1ee1cac498ae$var$B0b($61de1ee1cac498ae$var$BD(e.Xb(0), 11));
        f = $61de1ee1cac498ae$var$V_b(b, $61de1ee1cac498ae$var$zcd);
        a.b = f.dc() ? 0 : $61de1ee1cac498ae$var$B0b($61de1ee1cac498ae$var$BD(f.Xb(0), 11));
    }
}
function $61de1ee1cac498ae$var$l6d(a) {
    var b, c, d, e, f, g, h;
    if (a) {
        b = a.Hh($61de1ee1cac498ae$var$_ve);
        if (b) {
            g = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!b.b && (b.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, b)), b.b), "conversionDelegates"));
            if (g != null) {
                h = new $61de1ee1cac498ae$var$Rkb;
                for(d = $61de1ee1cac498ae$var$mfb(g, "\\w+"), e = 0, f = d.length; e < f; ++e){
                    c = d[e];
                    h.c[h.c.length] = c;
                }
                return h;
            }
        }
    }
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
}
function $61de1ee1cac498ae$var$FKb(a, b) {
    var c, d, e, f;
    c = a.o.a;
    for(f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        e.e.a = c * $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(e.b.We($61de1ee1cac498ae$var$BKb)));
        e.e.b = (d = e.b, d.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c)) ? d.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? -d.rf().b - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d.We($61de1ee1cac498ae$var$s9c))) : $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d.We($61de1ee1cac498ae$var$s9c))) : d.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? -d.rf().b : 0);
    }
}
function $61de1ee1cac498ae$var$Woc(a) {
    var b, c, d, e, f, g, h, i;
    b = true;
    e = null;
    f = null;
    j: for(i = new $61de1ee1cac498ae$var$olb(a.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
            if (!!e && e != h) {
                b = false;
                break j;
            }
            e = h;
            g = c.c.i;
            if (!!f && f != g) {
                b = false;
                break j;
            }
            f = g;
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$OOc(a, b, c) {
    var d, e, f, g, h, i;
    f = -1;
    h = -1;
    for(g = 0; g < b.c.length; g++){
        e = ($61de1ee1cac498ae$var$tCb(g, b.c.length), $61de1ee1cac498ae$var$BD(b.c[g], 329));
        if (e.c > a.c) break;
        else if (e.a >= a.s) {
            f < 0 && (f = g);
            h = g;
        }
    }
    i = (a.s + a.c) / 2;
    if (f >= 0) {
        d = $61de1ee1cac498ae$var$NOc(a, b, f, h);
        i = $61de1ee1cac498ae$var$$Oc(($61de1ee1cac498ae$var$tCb(d, b.c.length), $61de1ee1cac498ae$var$BD(b.c[d], 329)));
        $61de1ee1cac498ae$var$YOc(b, d, c);
    }
    return i;
}
function $61de1ee1cac498ae$var$lZc() {
    $61de1ee1cac498ae$var$lZc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$RYc = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$r8c), 1.3);
    $61de1ee1cac498ae$var$VYc = $61de1ee1cac498ae$var$I8c;
    $61de1ee1cac498ae$var$gZc = new $61de1ee1cac498ae$var$q0b(15);
    $61de1ee1cac498ae$var$fZc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$f9c, $61de1ee1cac498ae$var$gZc);
    $61de1ee1cac498ae$var$jZc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$T9c, 15);
    $61de1ee1cac498ae$var$SYc = $61de1ee1cac498ae$var$w8c;
    $61de1ee1cac498ae$var$_Yc = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$aZc = $61de1ee1cac498ae$var$_8c;
    $61de1ee1cac498ae$var$bZc = $61de1ee1cac498ae$var$b9c;
    $61de1ee1cac498ae$var$$Yc = $61de1ee1cac498ae$var$W8c;
    $61de1ee1cac498ae$var$cZc = $61de1ee1cac498ae$var$e9c;
    $61de1ee1cac498ae$var$hZc = $61de1ee1cac498ae$var$x9c;
    $61de1ee1cac498ae$var$eZc = ($61de1ee1cac498ae$var$OYc(), $61de1ee1cac498ae$var$KYc);
    $61de1ee1cac498ae$var$ZYc = $61de1ee1cac498ae$var$IYc;
    $61de1ee1cac498ae$var$dZc = $61de1ee1cac498ae$var$JYc;
    $61de1ee1cac498ae$var$iZc = $61de1ee1cac498ae$var$MYc;
    $61de1ee1cac498ae$var$WYc = $61de1ee1cac498ae$var$HYc;
    $61de1ee1cac498ae$var$XYc = $61de1ee1cac498ae$var$O8c;
    $61de1ee1cac498ae$var$YYc = $61de1ee1cac498ae$var$P8c;
    $61de1ee1cac498ae$var$UYc = $61de1ee1cac498ae$var$GYc;
    $61de1ee1cac498ae$var$TYc = $61de1ee1cac498ae$var$FYc;
    $61de1ee1cac498ae$var$kZc = $61de1ee1cac498ae$var$NYc;
}
function $61de1ee1cac498ae$var$Bnd(a, b, c) {
    var d, e, f, g, h, i, j;
    g = (f = new $61de1ee1cac498ae$var$RHd, f);
    $61de1ee1cac498ae$var$PHd(g, ($61de1ee1cac498ae$var$uCb(b), b));
    j = (!g.b && (g.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, g)), g.b);
    for(i = 1; i < c.length; i += 2)$61de1ee1cac498ae$var$HAd(j, c[i - 1], c[i]);
    d = (!a.Ab && (a.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, a, 0, 3)), a.Ab);
    for(h = 0; h < 0; ++h){
        e = $61de1ee1cac498ae$var$LHd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(d, d.i - 1), 590));
        d = e;
    }
    $61de1ee1cac498ae$var$wtd(d, g);
}
function $61de1ee1cac498ae$var$MPb(a, b, c) {
    var d, e, f;
    $61de1ee1cac498ae$var$sNb.call(this, new $61de1ee1cac498ae$var$Rkb);
    this.a = b;
    this.b = c;
    this.e = a;
    d = (a.b && $61de1ee1cac498ae$var$LOb(a), a.a);
    this.d = $61de1ee1cac498ae$var$KPb(d.a, this.a);
    this.c = $61de1ee1cac498ae$var$KPb(d.b, this.b);
    $61de1ee1cac498ae$var$kNb(this, this.d, this.c);
    $61de1ee1cac498ae$var$LPb(this);
    for(f = this.e.e.a.ec().Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 266);
        e.c.c.length > 0 && $61de1ee1cac498ae$var$JPb(this, e);
    }
}
function $61de1ee1cac498ae$var$IQb(a, b, c, d, e, f) {
    var g, h, i;
    if (!e[b.b]) {
        e[b.b] = true;
        g = d;
        !g && (g = new $61de1ee1cac498ae$var$kRb);
        $61de1ee1cac498ae$var$Ekb(g.e, b);
        for(i = f[b.b].Kc(); i.Ob();){
            h = $61de1ee1cac498ae$var$BD(i.Pb(), 282);
            if (h.d == c || h.c == c) continue;
            h.c != b && $61de1ee1cac498ae$var$IQb(a, h.c, b, g, e, f);
            h.d != b && $61de1ee1cac498ae$var$IQb(a, h.d, b, g, e, f);
            $61de1ee1cac498ae$var$Ekb(g.c, h);
            $61de1ee1cac498ae$var$Gkb(g.d, h.b);
        }
        return g;
    }
    return null;
}
function $61de1ee1cac498ae$var$e4b(a) {
    var b, c, d, e, f, g, h;
    b = 0;
    for(e = new $61de1ee1cac498ae$var$olb(a.e); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
        c = $61de1ee1cac498ae$var$FAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(d.b, 16)), new $61de1ee1cac498ae$var$w4b);
        c && ++b;
    }
    for(g = new $61de1ee1cac498ae$var$olb(a.g); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
        h = $61de1ee1cac498ae$var$FAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(f.b, 16)), new $61de1ee1cac498ae$var$y4b);
        h && ++b;
    }
    return b >= 2;
}
function $61de1ee1cac498ae$var$gec(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Odd(b, "Self-Loop pre-processing", 1);
    for(d = new $61de1ee1cac498ae$var$olb(a.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
        if ($61de1ee1cac498ae$var$Ljc(c)) {
            e = (f = new $61de1ee1cac498ae$var$Kjc(c), $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ntc), f), $61de1ee1cac498ae$var$Hjc(f), f);
            $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(e.d, 16)), new $61de1ee1cac498ae$var$jec), new $61de1ee1cac498ae$var$lec), new $61de1ee1cac498ae$var$nec);
            $61de1ee1cac498ae$var$eec(e);
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$vnc(a, b, c, d, e) {
    var f, g, h, i, j, k;
    f = a.c.d.j;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(c, 0), 8);
    for(k = 1; k < c.b; k++){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(c, k), 8);
        $61de1ee1cac498ae$var$Gsb(d, g, d.c.b, d.c);
        h = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$g7c(g), j), 0.5);
        i = $61de1ee1cac498ae$var$Y6c(new $61de1ee1cac498ae$var$e7c($61de1ee1cac498ae$var$bRc(f)), e);
        $61de1ee1cac498ae$var$P6c(h, i);
        $61de1ee1cac498ae$var$Gsb(d, h, d.c.b, d.c);
        g = j;
        f = b == 0 ? $61de1ee1cac498ae$var$Xcd(f) : $61de1ee1cac498ae$var$Vcd(f);
    }
    $61de1ee1cac498ae$var$Dsb(d, ($61de1ee1cac498ae$var$sCb(c.b != 0), $61de1ee1cac498ae$var$BD(c.c.b.c, 8)));
}
function $61de1ee1cac498ae$var$Jbd(a) {
    $61de1ee1cac498ae$var$Hbd();
    var b, c, d;
    c = $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
        $61de1ee1cac498ae$var$Dbd
    ]));
    if ($61de1ee1cac498ae$var$Ox($61de1ee1cac498ae$var$Cx(c, a)) > 1) return false;
    b = $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$zbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
        $61de1ee1cac498ae$var$ybd,
        $61de1ee1cac498ae$var$Bbd
    ]));
    if ($61de1ee1cac498ae$var$Ox($61de1ee1cac498ae$var$Cx(b, a)) > 1) return false;
    d = $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Gbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
        $61de1ee1cac498ae$var$Fbd,
        $61de1ee1cac498ae$var$Ebd
    ]));
    if ($61de1ee1cac498ae$var$Ox($61de1ee1cac498ae$var$Cx(d, a)) > 1) return false;
    return true;
}
function $61de1ee1cac498ae$var$U0d(a, b) {
    var c, d, e;
    c = b.Hh(a.a);
    if (c) {
        e = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), "affiliation"));
        if (e != null) {
            d = $61de1ee1cac498ae$var$kfb(e, $61de1ee1cac498ae$var$wfb(35));
            return d == -1 ? $61de1ee1cac498ae$var$l1d(a, $61de1ee1cac498ae$var$u1d(a, $61de1ee1cac498ae$var$bKd(b.Hj())), e) : d == 0 ? $61de1ee1cac498ae$var$l1d(a, null, e.substr(1)) : $61de1ee1cac498ae$var$l1d(a, e.substr(0, d), e.substr(d + 1));
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$ic(b) {
    var c, d, e;
    try {
        return b == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(b);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 102)) {
            c = a;
            e = $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$rb(b)) + "@" + (d = ($61de1ee1cac498ae$var$Zfb(), $61de1ee1cac498ae$var$kCb(b)) >>> 0, d.toString(16));
            $61de1ee1cac498ae$var$tyb($61de1ee1cac498ae$var$xyb(), ($61de1ee1cac498ae$var$$xb(), "Exception during lenientFormat for " + e), c);
            return "<" + e + " threw " + $61de1ee1cac498ae$var$hdb(c.gm) + ">";
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$mzc(a) {
    switch(a.g){
        case 0:
            return new $61de1ee1cac498ae$var$xDc;
        case 1:
            return new $61de1ee1cac498ae$var$ZCc;
        case 2:
            return new $61de1ee1cac498ae$var$DCc;
        case 3:
            return new $61de1ee1cac498ae$var$QCc;
        case 4:
            return new $61de1ee1cac498ae$var$LDc;
        case 5:
            return new $61de1ee1cac498ae$var$iDc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("No implementation is available for the layerer " + (a.f != null ? a.f : "" + a.g)));
    }
}
function $61de1ee1cac498ae$var$AQc(a, b, c) {
    var d, e, f;
    for(f = new $61de1ee1cac498ae$var$olb(a.t); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 268);
        if (d.b.s < 0 && d.c > 0) {
            d.b.n -= d.c;
            d.b.n <= 0 && d.b.u > 0 && $61de1ee1cac498ae$var$Dsb(b, d.b);
        }
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.i); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 268);
        if (d.a.s < 0 && d.c > 0) {
            d.a.u -= d.c;
            d.a.u <= 0 && d.a.n > 0 && $61de1ee1cac498ae$var$Dsb(c, d.a);
        }
    }
}
function $61de1ee1cac498ae$var$Vud(a) {
    var b, c, d, e, f;
    if (a.g == null) {
        a.d = a.si(a.f);
        $61de1ee1cac498ae$var$wtd(a, a.d);
        if (a.c) {
            f = a.f;
            return f;
        }
    }
    b = $61de1ee1cac498ae$var$BD(a.g[a.i - 1], 47);
    e = b.Pb();
    a.e = b;
    c = a.si(e);
    if (c.Ob()) {
        a.d = c;
        $61de1ee1cac498ae$var$wtd(a, c);
    } else {
        a.d = null;
        while(!b.Ob()){
            $61de1ee1cac498ae$var$NC(a.g, --a.i, null);
            if (a.i == 0) break;
            d = $61de1ee1cac498ae$var$BD(a.g[a.i - 1], 47);
            b = d;
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$r2d(a, b) {
    var c, d, e, f, g, h;
    d = b;
    e = d.ak();
    if ($61de1ee1cac498ae$var$T6d(a.e, e)) {
        if (e.hi() && $61de1ee1cac498ae$var$E2d(a, e, d.dd())) return false;
    } else {
        h = $61de1ee1cac498ae$var$S6d(a.e.Tg(), e);
        c = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(f = 0; f < a.i; ++f){
            g = c[f];
            if (h.rl(g.ak())) {
                if ($61de1ee1cac498ae$var$pb(g, d)) return false;
                else {
                    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(a, f, b), 72);
                    return true;
                }
            }
        }
    }
    return $61de1ee1cac498ae$var$wtd(a, b);
}
function $61de1ee1cac498ae$var$r9b(a, b, c, d) {
    var e, f, g, h;
    e = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$__b(e, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b));
    $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), b);
    $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$ktc, d);
    $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
    $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$Vsc, b.c);
    $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$Wsc, b.d);
    $61de1ee1cac498ae$var$zbc(b, e);
    h = $61de1ee1cac498ae$var$$wnd.Math.floor(c / 2);
    for(g = new $61de1ee1cac498ae$var$olb(e.j); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 11);
        f.n.b = h;
    }
    return e;
}
function $61de1ee1cac498ae$var$wac(a, b) {
    var c, d, e, f, g, h, i, j, k;
    i = $61de1ee1cac498ae$var$Pu(a.c - a.b & a.a.length - 1);
    j = null;
    k = null;
    for(f = new $61de1ee1cac498ae$var$xkb(a); f.a != f.b;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vkb(f), 10);
        c = (h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc)), 11), !h ? null : h.i);
        d = (g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$Wsc), 11), !g ? null : g.i);
        if (j != c || k != d) {
            $61de1ee1cac498ae$var$Aac(i, b);
            j = c;
            k = d;
        }
        i.c[i.c.length] = e;
    }
    $61de1ee1cac498ae$var$Aac(i, b);
}
function $61de1ee1cac498ae$var$HNc(a) {
    var b, c, d, e, f, g, h;
    b = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(c).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            if (a == e.d.i.c && e.c.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)) {
                g = $61de1ee1cac498ae$var$A0b(e.c).b;
                h = $61de1ee1cac498ae$var$A0b(e.d).b;
                b = $61de1ee1cac498ae$var$$wnd.Math.max(b, $61de1ee1cac498ae$var$$wnd.Math.abs(h - g));
            }
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$aWc(a, b, c) {
    var d, e, f;
    $61de1ee1cac498ae$var$Odd(c, "Remove overlaps", 1);
    c.n && !!b && $61de1ee1cac498ae$var$Tdd(c, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$MUc(), $61de1ee1cac498ae$var$LUc)), 33);
    a.f = d;
    a.a = $61de1ee1cac498ae$var$tXc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$WWc)), 293));
    e = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$T9c)));
    $61de1ee1cac498ae$var$FVc(a, ($61de1ee1cac498ae$var$uCb(e), e));
    f = $61de1ee1cac498ae$var$gVc(d);
    $61de1ee1cac498ae$var$_Vc(a, b, f, c);
    c.n && !!b && $61de1ee1cac498ae$var$Tdd(c, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
}
function $61de1ee1cac498ae$var$aYb(a, b, c) {
    switch(c.g){
        case 1:
            return new $61de1ee1cac498ae$var$f7c(b.a, $61de1ee1cac498ae$var$$wnd.Math.min(a.d.b, b.b));
        case 2:
            return new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$$wnd.Math.max(a.c.a, b.a), b.b);
        case 3:
            return new $61de1ee1cac498ae$var$f7c(b.a, $61de1ee1cac498ae$var$$wnd.Math.max(a.c.b, b.b));
        case 4:
            return new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$$wnd.Math.min(b.a, a.d.a), b.b);
    }
    return new $61de1ee1cac498ae$var$f7c(b.a, b.b);
}
function $61de1ee1cac498ae$var$mFc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    l = d ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) : ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd);
    e = false;
    for(i = b[c], j = 0, k = i.length; j < k; ++j){
        h = i[j];
        if ($61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98))) continue;
        g = h.e;
        m = !$61de1ee1cac498ae$var$V_b(h, l).dc() && !!g;
        if (m) {
            f = $61de1ee1cac498ae$var$WZb(g);
            a.b = new $61de1ee1cac498ae$var$sic(f, d ? 0 : f.length - 1);
        }
        e = e | $61de1ee1cac498ae$var$nFc(a, h, l, m);
    }
    return e;
}
function $61de1ee1cac498ae$var$$sd(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$Pu(1 + (!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c).i);
    $61de1ee1cac498ae$var$Ekb(b, (!a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5)), a.d));
    for(d = new $61de1ee1cac498ae$var$Fyd((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 118);
        $61de1ee1cac498ae$var$Ekb(b, (!c.d && (c.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, c, 8, 5)), c.d));
    }
    return $61de1ee1cac498ae$var$Qb(b), new $61de1ee1cac498ae$var$sl(b);
}
function $61de1ee1cac498ae$var$_sd(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$Pu(1 + (!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c).i);
    $61de1ee1cac498ae$var$Ekb(b, (!a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4)), a.e));
    for(d = new $61de1ee1cac498ae$var$Fyd((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 118);
        $61de1ee1cac498ae$var$Ekb(b, (!c.e && (c.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, c, 7, 4)), c.e));
    }
    return $61de1ee1cac498ae$var$Qb(b), new $61de1ee1cac498ae$var$sl(b);
}
function $61de1ee1cac498ae$var$M9d(a) {
    var b, c, d, e;
    if (a == null) return null;
    else {
        d = $61de1ee1cac498ae$var$Qge(a, true);
        e = $61de1ee1cac498ae$var$Nwe.length;
        if ($61de1ee1cac498ae$var$dfb(d.substr(d.length - e, e), $61de1ee1cac498ae$var$Nwe)) {
            c = d.length;
            if (c == 4) {
                b = ($61de1ee1cac498ae$var$BCb(0, d.length), d.charCodeAt(0));
                if (b == 43) return $61de1ee1cac498ae$var$x9d;
                else if (b == 45) return $61de1ee1cac498ae$var$w9d;
            } else if (c == 3) return $61de1ee1cac498ae$var$x9d;
        }
        return $61de1ee1cac498ae$var$Hcb(d);
    }
}
function $61de1ee1cac498ae$var$aKc(a) {
    var b, c, d, e;
    b = 0;
    c = 0;
    for(e = new $61de1ee1cac498ae$var$olb(a.j); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 11);
        b = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$wbb(b, $61de1ee1cac498ae$var$HAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(d.e, 16)), new $61de1ee1cac498ae$var$nLc))));
        c = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$wbb(c, $61de1ee1cac498ae$var$HAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(d.g, 16)), new $61de1ee1cac498ae$var$pLc))));
        if (b > 1 || c > 1) return 2;
    }
    if (b + c == 1) return 2;
    return 0;
}
function $61de1ee1cac498ae$var$WQb(a, b, c) {
    var d, e, f, g, h;
    $61de1ee1cac498ae$var$Odd(c, "ELK Force", 1);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$jSb)))) || $61de1ee1cac498ae$var$$Cb((d = new $61de1ee1cac498ae$var$_Cb(($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd(b))), d));
    h = $61de1ee1cac498ae$var$TQb(b);
    $61de1ee1cac498ae$var$XQb(h);
    $61de1ee1cac498ae$var$YQb(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, $61de1ee1cac498ae$var$fSb), 424));
    g = $61de1ee1cac498ae$var$LQb(a.a, h);
    for(f = g.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 231);
        $61de1ee1cac498ae$var$tRb(a.b, e, $61de1ee1cac498ae$var$Udd(c, 1 / g.gc()));
    }
    h = $61de1ee1cac498ae$var$KQb(g);
    $61de1ee1cac498ae$var$SQb(h);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$yoc(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, "Breaking Point Processor", 1);
    $61de1ee1cac498ae$var$xoc(a);
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Jyc))))) {
        for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
            c = 0;
            for(g = new $61de1ee1cac498ae$var$olb(d.a); g.a < g.c.c.length;){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
                f.p = c++;
            }
        }
        $61de1ee1cac498ae$var$soc(a);
        $61de1ee1cac498ae$var$toc(a, true);
        $61de1ee1cac498ae$var$toc(a, false);
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$$1c(a, b, c) {
    var d, e, f, g, h, i;
    h = a.c;
    for(g = (!c.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : c.q).vc().Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 42);
        d = !$61de1ee1cac498ae$var$WAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(h, 16)), new $61de1ee1cac498ae$var$Xxb(new $61de1ee1cac498ae$var$m2c(b, f)))).sd(($61de1ee1cac498ae$var$EAb(), $61de1ee1cac498ae$var$DAb));
        if (d) {
            i = f.dd();
            if ($61de1ee1cac498ae$var$JD(i, 4)) {
                e = $61de1ee1cac498ae$var$fvd(i);
                e != null && (i = e);
            }
            b.Ye($61de1ee1cac498ae$var$BD(f.cd(), 146), i);
        }
    }
}
function $61de1ee1cac498ae$var$MQd(a, b) {
    var c, d, e, f, g;
    if (!b) return null;
    else {
        f = $61de1ee1cac498ae$var$JD(a.Cb, 88) || $61de1ee1cac498ae$var$JD(a.Cb, 99);
        g = !f && $61de1ee1cac498ae$var$JD(a.Cb, 322);
        for(d = new $61de1ee1cac498ae$var$Fyd((!b.a && (b.a = new $61de1ee1cac498ae$var$KYd(b, $61de1ee1cac498ae$var$j5, b)), b.a)); d.e != d.i.gc();){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 87);
            e = $61de1ee1cac498ae$var$KQd(c);
            if (f ? $61de1ee1cac498ae$var$JD(e, 88) : g ? $61de1ee1cac498ae$var$JD(e, 148) : !!e) return e;
        }
        return f ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd);
    }
}
function $61de1ee1cac498ae$var$g3b(a, b) {
    var c, d, e, f, g, h;
    $61de1ee1cac498ae$var$Odd(b, "Constraints Postprocessor", 1);
    g = 0;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        h = 0;
        for(d = new $61de1ee1cac498ae$var$olb(e.a); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
            if (c.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) {
                $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$nxc), $61de1ee1cac498ae$var$meb(g));
                $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$Gwc, $61de1ee1cac498ae$var$meb(h));
                ++h;
            }
        }
        ++g;
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$eRc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    i = new $61de1ee1cac498ae$var$f7c(c, d);
    $61de1ee1cac498ae$var$c7c(i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$WSc)), 8));
    for(k = $61de1ee1cac498ae$var$Jsb(b.b, 0); k.b != k.d.c;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(k), 86);
        $61de1ee1cac498ae$var$P6c(j.e, i);
        $61de1ee1cac498ae$var$Dsb(a.b, j);
    }
    for(h = $61de1ee1cac498ae$var$Jsb(b.a, 0); h.b != h.d.c;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(h), 188);
        for(f = $61de1ee1cac498ae$var$Jsb(g.a, 0); f.b != f.d.c;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 8);
            $61de1ee1cac498ae$var$P6c(e, i);
        }
        $61de1ee1cac498ae$var$Dsb(a.a, g);
    }
}
function $61de1ee1cac498ae$var$uid(a, b, c) {
    var d, e, f;
    f = $61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a.Tg(), b);
    if (f) {
        $61de1ee1cac498ae$var$Q6d();
        if (!$61de1ee1cac498ae$var$BD(f, 66).Oj()) {
            f = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, f));
            if (!f) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b.ne() + $61de1ee1cac498ae$var$jte));
        }
        e = (d = a.Yg(f), $61de1ee1cac498ae$var$BD(d >= 0 ? a._g(d, true, true) : $61de1ee1cac498ae$var$sid(a, f, true), 153));
        $61de1ee1cac498ae$var$BD(e, 215).ml(b, c);
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + b.ne() + $61de1ee1cac498ae$var$jte));
}
function $61de1ee1cac498ae$var$ROc(a, b) {
    var c, d, e, f, g;
    c = new $61de1ee1cac498ae$var$Rkb;
    e = $61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a, 16)), new $61de1ee1cac498ae$var$iPc);
    f = $61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a, 16)), new $61de1ee1cac498ae$var$kPc);
    g = $61de1ee1cac498ae$var$aAb($61de1ee1cac498ae$var$_zb($61de1ee1cac498ae$var$OAb($61de1ee1cac498ae$var$ty($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xM, 1), $61de1ee1cac498ae$var$Uhe, 833, 0, [
        e,
        f
    ])), new $61de1ee1cac498ae$var$mPc)));
    for(d = 1; d < g.length; d++)g[d] - g[d - 1] >= 2 * b && $61de1ee1cac498ae$var$Ekb(c, new $61de1ee1cac498ae$var$bPc(g[d - 1] + b, g[d] - b));
    return c;
}
function $61de1ee1cac498ae$var$AXc(a, b, c) {
    $61de1ee1cac498ae$var$Odd(c, "Eades radial", 1);
    c.n && !!b && $61de1ee1cac498ae$var$Tdd(c, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    a.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$MUc(), $61de1ee1cac498ae$var$LUc)), 33);
    a.c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$VWc))));
    a.e = $61de1ee1cac498ae$var$tXc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$WWc), 293));
    a.a = $61de1ee1cac498ae$var$gWc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$YWc), 426));
    a.b = $61de1ee1cac498ae$var$jXc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$RWc), 340));
    $61de1ee1cac498ae$var$BXc(a);
    c.n && !!b && $61de1ee1cac498ae$var$Tdd(c, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
}
function $61de1ee1cac498ae$var$Fqd(a, b, c) {
    var d, e, f, g, h, j, k, l;
    if (c) {
        f = c.a.length;
        d = new $61de1ee1cac498ae$var$Yge(f);
        for(h = (d.b - d.a) * d.c < 0 ? ($61de1ee1cac498ae$var$Xge(), $61de1ee1cac498ae$var$Wge) : new $61de1ee1cac498ae$var$she(d); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
            e = $61de1ee1cac498ae$var$Zpd(c, g.a);
            !!e && ($61de1ee1cac498ae$var$i = null, j = $61de1ee1cac498ae$var$Uqd(a, (k = ($61de1ee1cac498ae$var$Fhd(), l = new $61de1ee1cac498ae$var$ppd, l), !!b && $61de1ee1cac498ae$var$npd(k, b), k), e), $61de1ee1cac498ae$var$Lkd(j, $61de1ee1cac498ae$var$_pd(e, $61de1ee1cac498ae$var$Vte)), $61de1ee1cac498ae$var$grd(e, j), $61de1ee1cac498ae$var$hrd(e, j), $61de1ee1cac498ae$var$crd(a, e, j));
        }
    }
}
function $61de1ee1cac498ae$var$UKd(a) {
    var b, c, d, e, f, g;
    if (!a.j) {
        g = new $61de1ee1cac498ae$var$HPd;
        b = $61de1ee1cac498ae$var$KKd;
        f = b.a.zc(a, b);
        if (f == null) {
            for(d = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$_Kd(a)); d.e != d.i.gc();){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 26);
                e = $61de1ee1cac498ae$var$UKd(c);
                $61de1ee1cac498ae$var$ytd(g, e);
                $61de1ee1cac498ae$var$wtd(g, c);
            }
            b.a.Bc(a);
        }
        $61de1ee1cac498ae$var$vud(g);
        a.j = new $61de1ee1cac498ae$var$nNd(($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).o), 11), 18), g.i), g.g);
        $61de1ee1cac498ae$var$$Kd(a).b &= -33;
    }
    return a.j;
}
function $61de1ee1cac498ae$var$O9d(a) {
    var b, c, d, e;
    if (a == null) return null;
    else {
        d = $61de1ee1cac498ae$var$Qge(a, true);
        e = $61de1ee1cac498ae$var$Nwe.length;
        if ($61de1ee1cac498ae$var$dfb(d.substr(d.length - e, e), $61de1ee1cac498ae$var$Nwe)) {
            c = d.length;
            if (c == 4) {
                b = ($61de1ee1cac498ae$var$BCb(0, d.length), d.charCodeAt(0));
                if (b == 43) return $61de1ee1cac498ae$var$z9d;
                else if (b == 45) return $61de1ee1cac498ae$var$y9d;
            } else if (c == 3) return $61de1ee1cac498ae$var$z9d;
        }
        return new $61de1ee1cac498ae$var$Odb(d);
    }
}
function $61de1ee1cac498ae$var$_C(a) {
    var b, c, d;
    c = a.l;
    if ((c & c - 1) != 0) return -1;
    d = a.m;
    if ((d & d - 1) != 0) return -1;
    b = a.h;
    if ((b & b - 1) != 0) return -1;
    if (b == 0 && d == 0 && c == 0) return -1;
    if (b == 0 && d == 0 && c != 0) return $61de1ee1cac498ae$var$ieb(c);
    if (b == 0 && d != 0 && c == 0) return $61de1ee1cac498ae$var$ieb(d) + 22;
    if (b != 0 && d == 0 && c == 0) return $61de1ee1cac498ae$var$ieb(b) + 44;
    return -1;
}
function $61de1ee1cac498ae$var$qbc(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, "Edge joining", 1);
    c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Byc))));
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        g = new $61de1ee1cac498ae$var$Bib(d.a, 0);
        while(g.b < g.d.gc()){
            f = ($61de1ee1cac498ae$var$sCb(g.b < g.d.gc()), $61de1ee1cac498ae$var$BD(g.d.Xb(g.c = g.b++), 10));
            if (f.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) {
                $61de1ee1cac498ae$var$sbc(f, c);
                $61de1ee1cac498ae$var$uib(g);
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$c_c(a, b, c) {
    var d, e;
    $61de1ee1cac498ae$var$H2c(a.b);
    $61de1ee1cac498ae$var$K2c(a.b, ($61de1ee1cac498ae$var$Y$c(), $61de1ee1cac498ae$var$V$c), ($61de1ee1cac498ae$var$R0c(), $61de1ee1cac498ae$var$Q0c));
    $61de1ee1cac498ae$var$K2c(a.b, $61de1ee1cac498ae$var$W$c, b.g);
    $61de1ee1cac498ae$var$K2c(a.b, $61de1ee1cac498ae$var$X$c, b.a);
    a.a = $61de1ee1cac498ae$var$F2c(a.b, b);
    $61de1ee1cac498ae$var$Odd(c, "Compaction by shrinking a tree", a.a.c.length);
    if (b.i.c.length > 1) for(e = new $61de1ee1cac498ae$var$olb(a.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 51);
        d.pf(b, $61de1ee1cac498ae$var$Udd(c, 1));
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$mo(a, b) {
    var c, d, e, f, g;
    e = b.a & a.f;
    f = null;
    for(d = a.b[e];; d = d.b){
        if (d == b) {
            !f ? a.b[e] = b.b : f.b = b.b;
            break;
        }
        f = d;
    }
    g = b.f & a.f;
    f = null;
    for(c = a.c[g];; c = c.d){
        if (c == b) {
            !f ? a.c[g] = b.d : f.d = b.d;
            break;
        }
        f = c;
    }
    !b.e ? a.a = b.c : b.e.c = b.c;
    !b.c ? a.e = b.e : b.c.e = b.e;
    --a.i;
    ++a.g;
}
function $61de1ee1cac498ae$var$eNb(a) {
    var b, c, d, e, f, g, h, i, j, k;
    c = a.o;
    b = a.p;
    g = $61de1ee1cac498ae$var$Ohe;
    e = $61de1ee1cac498ae$var$Rie;
    h = $61de1ee1cac498ae$var$Ohe;
    f = $61de1ee1cac498ae$var$Rie;
    for(j = 0; j < c; ++j){
        for(k = 0; k < b; ++k)if ($61de1ee1cac498ae$var$YMb(a, j, k)) {
            g = $61de1ee1cac498ae$var$$wnd.Math.min(g, j);
            e = $61de1ee1cac498ae$var$$wnd.Math.max(e, j);
            h = $61de1ee1cac498ae$var$$wnd.Math.min(h, k);
            f = $61de1ee1cac498ae$var$$wnd.Math.max(f, k);
        }
    }
    i = e - g + 1;
    d = f - h + 1;
    return new $61de1ee1cac498ae$var$Ggd($61de1ee1cac498ae$var$meb(g), $61de1ee1cac498ae$var$meb(h), $61de1ee1cac498ae$var$meb(i), $61de1ee1cac498ae$var$meb(d));
}
function $61de1ee1cac498ae$var$DWb(a, b) {
    var c, d, e, f;
    f = new $61de1ee1cac498ae$var$Bib(a, 0);
    c = ($61de1ee1cac498ae$var$sCb(f.b < f.d.gc()), $61de1ee1cac498ae$var$BD(f.d.Xb(f.c = f.b++), 140));
    while(f.b < f.d.gc()){
        d = ($61de1ee1cac498ae$var$sCb(f.b < f.d.gc()), $61de1ee1cac498ae$var$BD(f.d.Xb(f.c = f.b++), 140));
        e = new $61de1ee1cac498ae$var$dWb(d.c, c.d, b);
        $61de1ee1cac498ae$var$sCb(f.b > 0);
        f.a.Xb(f.c = --f.b);
        $61de1ee1cac498ae$var$Aib(f, e);
        $61de1ee1cac498ae$var$sCb(f.b < f.d.gc());
        f.d.Xb(f.c = f.b++);
        e.a = false;
        c = d;
    }
}
function $61de1ee1cac498ae$var$Y2b(a) {
    var b, c, d, e, f, g;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vsc)), 11);
    for(g = new $61de1ee1cac498ae$var$olb(a.j); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 11);
        for(d = new $61de1ee1cac498ae$var$olb(f.g); d.a < d.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 17);
            $61de1ee1cac498ae$var$RZb(b, e);
            return f;
        }
        for(c = new $61de1ee1cac498ae$var$olb(f.e); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 17);
            $61de1ee1cac498ae$var$QZb(b, e);
            return f;
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$iA(a, b, c) {
    var d, e;
    d = $61de1ee1cac498ae$var$Cbb(c.q.getTime());
    if ($61de1ee1cac498ae$var$ybb(d, 0) < 0) {
        e = $61de1ee1cac498ae$var$_ie - $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Hbb($61de1ee1cac498ae$var$Jbb(d), $61de1ee1cac498ae$var$_ie));
        e == $61de1ee1cac498ae$var$_ie && (e = 0);
    } else e = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Hbb(d, $61de1ee1cac498ae$var$_ie));
    if (b == 1) {
        e = $61de1ee1cac498ae$var$$wnd.Math.min((e + 50) / 100 | 0, 9);
        $61de1ee1cac498ae$var$Kfb(a, 48 + e & $61de1ee1cac498ae$var$aje);
    } else if (b == 2) {
        e = $61de1ee1cac498ae$var$$wnd.Math.min((e + 5) / 10 | 0, 99);
        $61de1ee1cac498ae$var$EA(a, e, 2);
    } else {
        $61de1ee1cac498ae$var$EA(a, e, 3);
        b > 3 && $61de1ee1cac498ae$var$EA(a, 0, b - 3);
    }
}
function $61de1ee1cac498ae$var$cUb(a) {
    var b, c, d, e;
    if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$axc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd))) return !a.e && $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Cwc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Xrc(), $61de1ee1cac498ae$var$Urc));
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Dwc), 292);
    e = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Hwc))) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Iwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Rpc(), $61de1ee1cac498ae$var$Opc));
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Bwc), 19).a;
    c = a.a.c.length;
    return !e && d != ($61de1ee1cac498ae$var$Xrc(), $61de1ee1cac498ae$var$Urc) && (b == 0 || b > c);
}
function $61de1ee1cac498ae$var$lkc(a) {
    var b, c;
    c = 0;
    for(; c < a.c.length; c++){
        if ($61de1ee1cac498ae$var$Ojc(($61de1ee1cac498ae$var$tCb(c, a.c.length), $61de1ee1cac498ae$var$BD(a.c[c], 113))) > 0) break;
    }
    if (c > 0 && c < a.c.length - 1) return c;
    b = 0;
    for(; b < a.c.length; b++){
        if ($61de1ee1cac498ae$var$Ojc(($61de1ee1cac498ae$var$tCb(b, a.c.length), $61de1ee1cac498ae$var$BD(a.c[b], 113))) > 0) break;
    }
    if (b > 0 && c < a.c.length - 1) return b;
    return a.c.length / 2 | 0;
}
function $61de1ee1cac498ae$var$mmd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 6 && !!b) {
        if ($61de1ee1cac498ae$var$p6d(a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ste + $61de1ee1cac498ae$var$qmd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? $61de1ee1cac498ae$var$cmd(a, d) : a.Cb.ih(a, -1 - c, null, d)));
        !!b && (d = $61de1ee1cac498ae$var$kid(b, a, 6, d));
        d = $61de1ee1cac498ae$var$bmd(a, b, d);
        !!d && d.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 6, b, b));
}
function $61de1ee1cac498ae$var$npd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 9 && !!b) {
        if ($61de1ee1cac498ae$var$p6d(a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ste + $61de1ee1cac498ae$var$opd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? $61de1ee1cac498ae$var$lpd(a, d) : a.Cb.ih(a, -1 - c, null, d)));
        !!b && (d = $61de1ee1cac498ae$var$kid(b, a, 9, d));
        d = $61de1ee1cac498ae$var$kpd(a, b, d);
        !!d && d.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 9, b, b));
}
function $61de1ee1cac498ae$var$Rld(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 3 && !!b) {
        if ($61de1ee1cac498ae$var$p6d(a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ste + $61de1ee1cac498ae$var$Sld(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? $61de1ee1cac498ae$var$Lld(a, d) : a.Cb.ih(a, -1 - c, null, d)));
        !!b && (d = $61de1ee1cac498ae$var$kid(b, a, 12, d));
        d = $61de1ee1cac498ae$var$Kld(a, b, d);
        !!d && d.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 3, b, b));
}
function $61de1ee1cac498ae$var$VId(b) {
    var c, d, e, f, g;
    e = $61de1ee1cac498ae$var$wId(b);
    g = b.j;
    if (g == null && !!e) return b.$j() ? null : e.zj();
    else if ($61de1ee1cac498ae$var$JD(e, 148)) {
        d = e.Aj();
        if (d) {
            f = d.Nh();
            if (f != b.i) {
                c = $61de1ee1cac498ae$var$BD(e, 148);
                if (c.Ej()) try {
                    b.g = f.Kh(c, g);
                } catch (a) {
                    a = $61de1ee1cac498ae$var$ubb(a);
                    if ($61de1ee1cac498ae$var$JD(a, 78)) b.g = null;
                    else throw $61de1ee1cac498ae$var$vbb(a);
                }
                b.i = f;
            }
        }
        return b.g;
    }
    return null;
}
function $61de1ee1cac498ae$var$wOb(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Ekb(b, new $61de1ee1cac498ae$var$aDb(new $61de1ee1cac498ae$var$f7c(a.c, a.d), new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d)));
    $61de1ee1cac498ae$var$Ekb(b, new $61de1ee1cac498ae$var$aDb(new $61de1ee1cac498ae$var$f7c(a.c, a.d), new $61de1ee1cac498ae$var$f7c(a.c, a.d + a.a)));
    $61de1ee1cac498ae$var$Ekb(b, new $61de1ee1cac498ae$var$aDb(new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d + a.a), new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d)));
    $61de1ee1cac498ae$var$Ekb(b, new $61de1ee1cac498ae$var$aDb(new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d + a.a), new $61de1ee1cac498ae$var$f7c(a.c, a.d + a.a)));
    return b;
}
function $61de1ee1cac498ae$var$IJc(a, b, c, d) {
    var e, f, g;
    g = $61de1ee1cac498ae$var$LZb(b, c);
    d.c[d.c.length] = b;
    if (a.j[g.p] == -1 || a.j[g.p] == 2 || a.a[b.p]) return d;
    a.j[g.p] = -1;
    for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
        if (!(!$61de1ee1cac498ae$var$OZb(e) && !(!$61de1ee1cac498ae$var$OZb(e) && e.c.i.c == e.d.i.c)) || e == b) continue;
        return $61de1ee1cac498ae$var$IJc(a, e, g, d);
    }
    return d;
}
function $61de1ee1cac498ae$var$vQb(a, b, c) {
    var d, e, f;
    for(f = b.a.ec().Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 79);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, e), 266);
        !d && ($61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$jtd(e)) == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$ltd(e)) ? $61de1ee1cac498ae$var$uQb(a, e, c) : $61de1ee1cac498ae$var$jtd(e) == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$ltd(e)) ? $61de1ee1cac498ae$var$Ohb(a.c, e) == null && $61de1ee1cac498ae$var$Ohb(a.b, $61de1ee1cac498ae$var$ltd(e)) != null && $61de1ee1cac498ae$var$xQb(a, e, c, false) : $61de1ee1cac498ae$var$Ohb(a.d, e) == null && $61de1ee1cac498ae$var$Ohb(a.b, $61de1ee1cac498ae$var$jtd(e)) != null && $61de1ee1cac498ae$var$xQb(a, e, c, true));
    }
}
function $61de1ee1cac498ae$var$jcc(a, b) {
    var c, d, e, f, g, h, i;
    for(e = a.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 10);
        h = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$F0b(h, d);
        $61de1ee1cac498ae$var$G0b(h, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
        $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ftc), ($61de1ee1cac498ae$var$Bcb(), true));
        for(g = b.Kc(); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 10);
            i = new $61de1ee1cac498ae$var$H0b;
            $61de1ee1cac498ae$var$F0b(i, f);
            $61de1ee1cac498ae$var$G0b(i, $61de1ee1cac498ae$var$Tcd);
            $61de1ee1cac498ae$var$yNb(i, $61de1ee1cac498ae$var$ftc, true);
            c = new $61de1ee1cac498ae$var$UZb;
            $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$ftc, true);
            $61de1ee1cac498ae$var$QZb(c, h);
            $61de1ee1cac498ae$var$RZb(c, i);
        }
    }
}
function $61de1ee1cac498ae$var$jnc(a, b, c, d) {
    var e, f, g, h;
    e = $61de1ee1cac498ae$var$hnc(a, b, c);
    f = $61de1ee1cac498ae$var$hnc(a, c, b);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.c, b), 112);
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.c, c), 112);
    if (e < f) new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$GOc), g, h, f - e);
    else if (f < e) new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$GOc), h, g, e - f);
    else if (e != 0 || !(!b.i || !c.i) && d[b.i.c][c.i.c]) {
        new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$GOc), g, h, 0);
        new $61de1ee1cac498ae$var$DOc($61de1ee1cac498ae$var$GOc, h, g, 0);
    }
}
function $61de1ee1cac498ae$var$Qoc(a, b) {
    var c, d, e, f, g, h, i;
    e = 0;
    for(g = new $61de1ee1cac498ae$var$olb(b.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        e += f.o.b + f.d.a + f.d.d + a.e;
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(f).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
            if (c.c.i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b)) {
                i = c.c.i;
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 10);
                e += h.o.b + h.d.a + h.d.d;
            }
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$WNc(a, b, c) {
    var d, e, f, g, h, i, j;
    f = new $61de1ee1cac498ae$var$Rkb;
    j = new $61de1ee1cac498ae$var$Psb;
    g = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$XNc(a, j, g, b);
    $61de1ee1cac498ae$var$VNc(a, j, g, b, c);
    for(i = new $61de1ee1cac498ae$var$olb(a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 112);
        for(e = new $61de1ee1cac498ae$var$olb(h.k); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 129);
            (!b || d.c == ($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc)) && h.g > d.b.g && (f.c[f.c.length] = d);
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$k$c() {
    $61de1ee1cac498ae$var$k$c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$g$c = new $61de1ee1cac498ae$var$l$c("CANDIDATE_POSITION_LAST_PLACED_RIGHT", 0);
    $61de1ee1cac498ae$var$f$c = new $61de1ee1cac498ae$var$l$c("CANDIDATE_POSITION_LAST_PLACED_BELOW", 1);
    $61de1ee1cac498ae$var$i$c = new $61de1ee1cac498ae$var$l$c("CANDIDATE_POSITION_WHOLE_DRAWING_RIGHT", 2);
    $61de1ee1cac498ae$var$h$c = new $61de1ee1cac498ae$var$l$c("CANDIDATE_POSITION_WHOLE_DRAWING_BELOW", 3);
    $61de1ee1cac498ae$var$j$c = new $61de1ee1cac498ae$var$l$c("WHOLE_DRAWING", 4);
}
function $61de1ee1cac498ae$var$Xqd(a, b) {
    if ($61de1ee1cac498ae$var$JD(b, 239)) return $61de1ee1cac498ae$var$iqd(a, $61de1ee1cac498ae$var$BD(b, 33));
    else if ($61de1ee1cac498ae$var$JD(b, 186)) return $61de1ee1cac498ae$var$jqd(a, $61de1ee1cac498ae$var$BD(b, 118));
    else if ($61de1ee1cac498ae$var$JD(b, 354)) return $61de1ee1cac498ae$var$hqd(a, $61de1ee1cac498ae$var$BD(b, 137));
    else if ($61de1ee1cac498ae$var$JD(b, 352)) return $61de1ee1cac498ae$var$gqd(a, $61de1ee1cac498ae$var$BD(b, 79));
    else if (b) return null;
    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Xte + $61de1ee1cac498ae$var$Fe(new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        b
    ])))));
}
function $61de1ee1cac498ae$var$aic(a) {
    var b, c, d, e, f, g, h;
    f = new $61de1ee1cac498ae$var$Psb;
    for(e = new $61de1ee1cac498ae$var$olb(a.d.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 121);
        d.b.a.c.length == 0 && $61de1ee1cac498ae$var$Gsb(f, d, f.c.b, f.c);
    }
    if (f.b > 1) {
        b = $61de1ee1cac498ae$var$nGb((c = new $61de1ee1cac498ae$var$pGb, ++a.b, c), a.d);
        for(h = $61de1ee1cac498ae$var$Jsb(f, 0); h.b != h.d.c;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(h), 121);
            $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 1), 0), b), g));
        }
    }
}
function $61de1ee1cac498ae$var$$od(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 11 && !!b) {
        if ($61de1ee1cac498ae$var$p6d(a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ste + $61de1ee1cac498ae$var$_od(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? $61de1ee1cac498ae$var$Uod(a, d) : a.Cb.ih(a, -1 - c, null, d)));
        !!b && (d = $61de1ee1cac498ae$var$kid(b, a, 10, d));
        d = $61de1ee1cac498ae$var$Tod(a, b, d);
        !!d && d.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 11, b, b));
}
function $61de1ee1cac498ae$var$uZb(a) {
    var b, c, d, e;
    for(d = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(a.b).a); d.b;){
        c = $61de1ee1cac498ae$var$lib(d);
        e = $61de1ee1cac498ae$var$BD(c.cd(), 11);
        b = $61de1ee1cac498ae$var$BD(c.dd(), 10);
        $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), e);
        $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$gtc, b);
        $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$Nsc, ($61de1ee1cac498ae$var$Bcb(), true));
        $61de1ee1cac498ae$var$G0b(e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Hsc), 61));
        $61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Hsc);
        $61de1ee1cac498ae$var$yNb(e.i, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$acd));
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(e.i), $61de1ee1cac498ae$var$Ksc), 21).Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Krc));
    }
}
function $61de1ee1cac498ae$var$G4b(a, b, c) {
    var d, e, f, g, h, i;
    f = 0;
    g = 0;
    if (a.c) for(i = new $61de1ee1cac498ae$var$olb(a.d.i.j); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 11);
        f += h.e.c.length;
    }
    else f = 1;
    if (a.d) for(i = new $61de1ee1cac498ae$var$olb(a.c.i.j); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 11);
        g += h.g.c.length;
    }
    else g = 1;
    e = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$Eeb(g - f));
    d = (c + b) / 2 + (c - b) * (0.4 * e);
    return d;
}
function $61de1ee1cac498ae$var$Zjc(a) {
    $61de1ee1cac498ae$var$Xjc();
    var b, c;
    if (a.Hc(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Port sides must not contain UNDEFINED"));
    switch(a.gc()){
        case 1:
            return $61de1ee1cac498ae$var$Tjc;
        case 2:
            b = a.Hc($61de1ee1cac498ae$var$zcd) && a.Hc($61de1ee1cac498ae$var$Tcd);
            c = a.Hc($61de1ee1cac498ae$var$Acd) && a.Hc($61de1ee1cac498ae$var$Rcd);
            return b || c ? $61de1ee1cac498ae$var$Wjc : $61de1ee1cac498ae$var$Vjc;
        case 3:
            return $61de1ee1cac498ae$var$Ujc;
        case 4:
            return $61de1ee1cac498ae$var$Sjc;
        default:
            return null;
    }
}
function $61de1ee1cac498ae$var$Hoc(a, b, c) {
    var d, e, f, g, h;
    $61de1ee1cac498ae$var$Odd(c, "Breaking Point Removing", 1);
    a.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Swc)), 218);
    for(f = new $61de1ee1cac498ae$var$olb(b.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        for(h = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$Mu(e.a)); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            if ($61de1ee1cac498ae$var$hoc(g)) {
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$usc)), 305);
                !d.d && $61de1ee1cac498ae$var$Ioc(a, d);
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$s6c(a, b, c) {
    $61de1ee1cac498ae$var$i6c();
    if ($61de1ee1cac498ae$var$m6c(a, b) && $61de1ee1cac498ae$var$m6c(a, c)) return false;
    return $61de1ee1cac498ae$var$u6c(new $61de1ee1cac498ae$var$f7c(a.c, a.d), new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d), b, c) || $61de1ee1cac498ae$var$u6c(new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d), new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d + a.a), b, c) || $61de1ee1cac498ae$var$u6c(new $61de1ee1cac498ae$var$f7c(a.c + a.b, a.d + a.a), new $61de1ee1cac498ae$var$f7c(a.c, a.d + a.a), b, c) || $61de1ee1cac498ae$var$u6c(new $61de1ee1cac498ae$var$f7c(a.c, a.d + a.a), new $61de1ee1cac498ae$var$f7c(a.c, a.d), b, c);
}
function $61de1ee1cac498ae$var$x1d(a, b) {
    var c, d, e, f;
    if (!a.dc()) for(c = 0, d = a.gc(); c < d; ++c){
        f = $61de1ee1cac498ae$var$GD(a.Xb(c));
        if (f == null ? b == null : $61de1ee1cac498ae$var$dfb(f.substr(0, 3), "!##") ? b != null && (e = b.length, !$61de1ee1cac498ae$var$dfb(f.substr(f.length - e, e), b) || f.length != b.length + 3) && !$61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Ewe, b) : $61de1ee1cac498ae$var$dfb(f, $61de1ee1cac498ae$var$Fwe) && !$61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Ewe, b) || $61de1ee1cac498ae$var$dfb(f, b)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$J3b(a, b, c, d) {
    var e, f, g, h, i, j;
    g = a.j.c.length;
    i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$tN, $61de1ee1cac498ae$var$ile, 306, g, 0, 1);
    for(h = 0; h < g; h++){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, h), 11);
        f.p = h;
        i[h] = $61de1ee1cac498ae$var$D3b($61de1ee1cac498ae$var$N3b(f), c, d);
    }
    $61de1ee1cac498ae$var$F3b(a, i, c, b, d);
    j = new $61de1ee1cac498ae$var$Lqb;
    for(e = 0; e < i.length; e++)!!i[e] && $61de1ee1cac498ae$var$Rhb(j, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, e), 11), i[e]);
    if (j.f.c + j.g.c != 0) {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Csc), j);
        $61de1ee1cac498ae$var$L3b(a, i);
    }
}
function $61de1ee1cac498ae$var$Lgc(a, b, c) {
    var d, e, f;
    for(e = new $61de1ee1cac498ae$var$olb(a.a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 57);
        f = $61de1ee1cac498ae$var$tgc(d);
        if (f) {
            if (f.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61).g){
                case 4:
                    f.n.a = b.a;
                    break;
                case 2:
                    f.n.a = c.a - (f.o.a + f.d.c);
                    break;
                case 1:
                    f.n.b = b.b;
                    break;
                case 3:
                    f.n.b = c.b - (f.o.b + f.d.a);
            }
        }
    }
}
function $61de1ee1cac498ae$var$kAc() {
    $61de1ee1cac498ae$var$kAc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$iAc = new $61de1ee1cac498ae$var$lAc($61de1ee1cac498ae$var$ane, 0);
    $61de1ee1cac498ae$var$dAc = new $61de1ee1cac498ae$var$lAc("NIKOLOV", 1);
    $61de1ee1cac498ae$var$gAc = new $61de1ee1cac498ae$var$lAc("NIKOLOV_PIXEL", 2);
    $61de1ee1cac498ae$var$eAc = new $61de1ee1cac498ae$var$lAc("NIKOLOV_IMPROVED", 3);
    $61de1ee1cac498ae$var$fAc = new $61de1ee1cac498ae$var$lAc("NIKOLOV_IMPROVED_PIXEL", 4);
    $61de1ee1cac498ae$var$cAc = new $61de1ee1cac498ae$var$lAc("DUMMYNODE_PERCENTAGE", 5);
    $61de1ee1cac498ae$var$hAc = new $61de1ee1cac498ae$var$lAc("NODECOUNT_PERCENTAGE", 6);
    $61de1ee1cac498ae$var$jAc = new $61de1ee1cac498ae$var$lAc("NO_BOUNDARY", 7);
}
function $61de1ee1cac498ae$var$led(a, b, c) {
    var d, e, f, g, h;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$X7c(), $61de1ee1cac498ae$var$V7c)), 19);
    !e && (e = $61de1ee1cac498ae$var$meb(0));
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(c, $61de1ee1cac498ae$var$V7c), 19);
    !f && (f = $61de1ee1cac498ae$var$meb(0));
    if (e.a > f.a) return -1;
    else if (e.a < f.a) return 1;
    else {
        if (a.a) {
            d = $61de1ee1cac498ae$var$Kdb(b.j, c.j);
            if (d != 0) return d;
            d = $61de1ee1cac498ae$var$Kdb(b.i, c.i);
            if (d != 0) return d;
        }
        g = b.g * b.f;
        h = c.g * c.f;
        return $61de1ee1cac498ae$var$Kdb(g, h);
    }
}
function $61de1ee1cac498ae$var$BAd(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    ++a.e;
    i = a.d == null ? 0 : a.d.length;
    if (b > i) {
        k = a.d;
        a.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$y4, $61de1ee1cac498ae$var$jve, 63, 2 * i + 4, 0, 1);
        for(f = 0; f < i; ++f){
            j = k[f];
            if (j) {
                d = j.g;
                l = j.i;
                for(h = 0; h < l; ++h){
                    e = $61de1ee1cac498ae$var$BD(d[h], 133);
                    g = $61de1ee1cac498ae$var$DAd(a, e.Sh());
                    c = a.d[g];
                    !c && (c = a.d[g] = a.uj());
                    c.Fc(e);
                }
            }
        }
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$o2d(a, b, c) {
    var d, e, f, g, h, i;
    e = c;
    f = e.ak();
    if ($61de1ee1cac498ae$var$T6d(a.e, f)) {
        if (f.hi()) {
            d = $61de1ee1cac498ae$var$BD(a.g, 119);
            for(g = 0; g < a.i; ++g){
                h = d[g];
                if ($61de1ee1cac498ae$var$pb(h, e) && g != b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$kue));
            }
        }
    } else {
        i = $61de1ee1cac498ae$var$S6d(a.e.Tg(), f);
        d = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(g = 0; g < a.i; ++g){
            h = d[g];
            if (i.rl(h.ak())) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Hwe));
        }
    }
    $61de1ee1cac498ae$var$vtd(a, b, c);
}
function $61de1ee1cac498ae$var$OYb(a, b) {
    var c, d, e, f, g, h;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(($61de1ee1cac498ae$var$xXb(), $61de1ee1cac498ae$var$wXb), c), 21);
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc($61de1ee1cac498ae$var$LYb, c), 21);
    for(f = g.Kc(); f.Ob();){
        d = $61de1ee1cac498ae$var$BD(f.Pb(), 21);
        if (!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.b, d), 15).dc()) return false;
    }
    for(e = h.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 21);
        if (!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.b, d), 15).dc()) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$scc(a, b) {
    var c, d, e, f, g, h;
    $61de1ee1cac498ae$var$Odd(b, "Partition postprocessing", 1);
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        for(f = new $61de1ee1cac498ae$var$olb(c.a); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
            h = new $61de1ee1cac498ae$var$olb(e.j);
            while(h.a < h.c.c.length){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
                $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ftc)))) && $61de1ee1cac498ae$var$nlb(h);
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$ZZc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (a.a.c.length == 1) return $61de1ee1cac498ae$var$JZc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, 0), 187), b);
    g = $61de1ee1cac498ae$var$YZc(a);
    i = 0;
    j = a.d;
    f = g;
    k = a.d;
    h = (j - f) / 2 + f;
    while(f + 1 < j){
        i = 0;
        for(d = new $61de1ee1cac498ae$var$olb(a.a); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 187);
            i += (e = $61de1ee1cac498ae$var$MZc(c, h, false), e.a);
        }
        if (i < b) {
            k = h;
            j = h;
        } else f = h;
        h = (j - f) / 2 + f;
    }
    return k;
}
function $61de1ee1cac498ae$var$fD(a) {
    var b, c, d, e, f;
    if (isNaN(a)) return $61de1ee1cac498ae$var$wD(), $61de1ee1cac498ae$var$vD;
    if (a < -9223372036854776000) return $61de1ee1cac498ae$var$wD(), $61de1ee1cac498ae$var$tD;
    if (a >= 9223372036854775807) return $61de1ee1cac498ae$var$wD(), $61de1ee1cac498ae$var$sD;
    e = false;
    if (a < 0) {
        e = true;
        a = -a;
    }
    d = 0;
    if (a >= $61de1ee1cac498ae$var$Ije) {
        d = $61de1ee1cac498ae$var$QD(a / $61de1ee1cac498ae$var$Ije);
        a -= d * $61de1ee1cac498ae$var$Ije;
    }
    c = 0;
    if (a >= $61de1ee1cac498ae$var$Hje) {
        c = $61de1ee1cac498ae$var$QD(a / $61de1ee1cac498ae$var$Hje);
        a -= c * $61de1ee1cac498ae$var$Hje;
    }
    b = $61de1ee1cac498ae$var$QD(a);
    f = $61de1ee1cac498ae$var$TC(b, c, d);
    e && $61de1ee1cac498ae$var$ZC(f);
    return f;
}
function $61de1ee1cac498ae$var$rKb(a, b) {
    var c, d, e, f;
    c = !b || !a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd));
    f = 0;
    for(e = new $61de1ee1cac498ae$var$olb(a.e.Cf()); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 838);
        if (d.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Label and node size calculator can only be used with ports that have port sides assigned."));
        d.vf(f++);
        $61de1ee1cac498ae$var$qKb(a, d, c);
    }
}
function $61de1ee1cac498ae$var$V0d(a, b) {
    var c, d, e, f, g;
    e = b.Hh(a.a);
    if (e) {
        d = (!e.b && (e.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, e)), e.b);
        c = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd(d, $61de1ee1cac498ae$var$cwe));
        if (c != null) {
            f = c.lastIndexOf("#");
            g = f == -1 ? $61de1ee1cac498ae$var$w1d(a, b.Aj(), c) : f == 0 ? $61de1ee1cac498ae$var$v1d(a, null, c.substr(1)) : $61de1ee1cac498ae$var$v1d(a, c.substr(0, f), c.substr(f + 1));
            if ($61de1ee1cac498ae$var$JD(g, 148)) return $61de1ee1cac498ae$var$BD(g, 148);
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$Z0d(a, b) {
    var c, d, e, f, g;
    d = b.Hh(a.a);
    if (d) {
        c = (!d.b && (d.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, d)), d.b);
        f = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd(c, $61de1ee1cac498ae$var$zwe));
        if (f != null) {
            e = f.lastIndexOf("#");
            g = e == -1 ? $61de1ee1cac498ae$var$w1d(a, b.Aj(), f) : e == 0 ? $61de1ee1cac498ae$var$v1d(a, null, f.substr(1)) : $61de1ee1cac498ae$var$v1d(a, f.substr(0, e), f.substr(e + 1));
            if ($61de1ee1cac498ae$var$JD(g, 148)) return $61de1ee1cac498ae$var$BD(g, 148);
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$RDb(a) {
    var b, c, d, e, f;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 307);
        b.j = null;
        for(f = b.a.a.ec().Kc(); f.Ob();){
            d = $61de1ee1cac498ae$var$BD(f.Pb(), 57);
            $61de1ee1cac498ae$var$X6c(d.b);
            (!b.j || d.d.c < b.j.d.c) && (b.j = d);
        }
        for(e = b.a.a.ec().Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 57);
            d.b.a = d.d.c - b.j.d.c;
            d.b.b = d.d.d - b.j.d.d;
        }
    }
    return a;
}
function $61de1ee1cac498ae$var$sVb(a) {
    var b, c, d, e, f;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 189);
        b.f = null;
        for(f = b.a.a.ec().Kc(); f.Ob();){
            d = $61de1ee1cac498ae$var$BD(f.Pb(), 81);
            $61de1ee1cac498ae$var$X6c(d.e);
            (!b.f || d.g.c < b.f.g.c) && (b.f = d);
        }
        for(e = b.a.a.ec().Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 81);
            d.e.a = d.g.c - b.f.g.c;
            d.e.b = d.g.d - b.f.g.d;
        }
    }
    return a;
}
function $61de1ee1cac498ae$var$EMb(a) {
    var b, c, d;
    c = $61de1ee1cac498ae$var$BD(a.a, 19).a;
    d = $61de1ee1cac498ae$var$BD(a.b, 19).a;
    b = $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$$wnd.Math.abs(c), $61de1ee1cac498ae$var$$wnd.Math.abs(d));
    if (c < b && d == -b) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(c + 1), $61de1ee1cac498ae$var$meb(d));
    if (c == b && d < b) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(c), $61de1ee1cac498ae$var$meb(d + 1));
    if (c >= -b && d == b) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(c - 1), $61de1ee1cac498ae$var$meb(d));
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(c), $61de1ee1cac498ae$var$meb(d - 1));
}
function $61de1ee1cac498ae$var$W8b() {
    $61de1ee1cac498ae$var$S8b();
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$AS, 1), $61de1ee1cac498ae$var$Kie, 77, 0, [
        $61de1ee1cac498ae$var$Y7b,
        $61de1ee1cac498ae$var$V7b,
        $61de1ee1cac498ae$var$Z7b,
        $61de1ee1cac498ae$var$n8b,
        $61de1ee1cac498ae$var$G8b,
        $61de1ee1cac498ae$var$r8b,
        $61de1ee1cac498ae$var$M8b,
        $61de1ee1cac498ae$var$w8b,
        $61de1ee1cac498ae$var$E8b,
        $61de1ee1cac498ae$var$i8b,
        $61de1ee1cac498ae$var$A8b,
        $61de1ee1cac498ae$var$v8b,
        $61de1ee1cac498ae$var$F8b,
        $61de1ee1cac498ae$var$e8b,
        $61de1ee1cac498ae$var$O8b,
        $61de1ee1cac498ae$var$P7b,
        $61de1ee1cac498ae$var$z8b,
        $61de1ee1cac498ae$var$I8b,
        $61de1ee1cac498ae$var$o8b,
        $61de1ee1cac498ae$var$H8b,
        $61de1ee1cac498ae$var$Q8b,
        $61de1ee1cac498ae$var$C8b,
        $61de1ee1cac498ae$var$Q7b,
        $61de1ee1cac498ae$var$D8b,
        $61de1ee1cac498ae$var$R8b,
        $61de1ee1cac498ae$var$K8b,
        $61de1ee1cac498ae$var$P8b,
        $61de1ee1cac498ae$var$p8b,
        $61de1ee1cac498ae$var$b8b,
        $61de1ee1cac498ae$var$q8b,
        $61de1ee1cac498ae$var$m8b,
        $61de1ee1cac498ae$var$N8b,
        $61de1ee1cac498ae$var$T7b,
        $61de1ee1cac498ae$var$_7b,
        $61de1ee1cac498ae$var$t8b,
        $61de1ee1cac498ae$var$S7b,
        $61de1ee1cac498ae$var$u8b,
        $61de1ee1cac498ae$var$k8b,
        $61de1ee1cac498ae$var$f8b,
        $61de1ee1cac498ae$var$x8b,
        $61de1ee1cac498ae$var$h8b,
        $61de1ee1cac498ae$var$W7b,
        $61de1ee1cac498ae$var$U7b,
        $61de1ee1cac498ae$var$l8b,
        $61de1ee1cac498ae$var$g8b,
        $61de1ee1cac498ae$var$y8b,
        $61de1ee1cac498ae$var$L8b,
        $61de1ee1cac498ae$var$R7b,
        $61de1ee1cac498ae$var$B8b,
        $61de1ee1cac498ae$var$j8b,
        $61de1ee1cac498ae$var$s8b,
        $61de1ee1cac498ae$var$c8b,
        $61de1ee1cac498ae$var$a8b,
        $61de1ee1cac498ae$var$J8b,
        $61de1ee1cac498ae$var$$7b,
        $61de1ee1cac498ae$var$d8b,
        $61de1ee1cac498ae$var$X7b
    ]);
}
function $61de1ee1cac498ae$var$Yic(a, b, c) {
    a.d = 0;
    a.b = 0;
    b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b) && c.k == $61de1ee1cac498ae$var$i0b && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 10) == $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$$sc), 10) && ($61de1ee1cac498ae$var$ajc(b).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? $61de1ee1cac498ae$var$Zic(a, b, c) : $61de1ee1cac498ae$var$Zic(a, c, b));
    b.k == $61de1ee1cac498ae$var$i0b && c.k == $61de1ee1cac498ae$var$g0b ? $61de1ee1cac498ae$var$ajc(b).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? a.d = 1 : a.b = 1 : c.k == $61de1ee1cac498ae$var$i0b && b.k == $61de1ee1cac498ae$var$g0b && ($61de1ee1cac498ae$var$ajc(c).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? a.b = 1 : a.d = 1);
    $61de1ee1cac498ae$var$cjc(a, b, c);
}
function $61de1ee1cac498ae$var$esd(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    l = $61de1ee1cac498ae$var$hsd(a);
    b = a.a;
    i = b != null;
    i && $61de1ee1cac498ae$var$Upd(l, "category", a.a);
    e = $61de1ee1cac498ae$var$Fhe(new $61de1ee1cac498ae$var$Pib(a.d));
    g = !e;
    if (g) {
        j = new $61de1ee1cac498ae$var$wB;
        $61de1ee1cac498ae$var$cC(l, "knownOptions", j);
        c = new $61de1ee1cac498ae$var$msd(j);
        $61de1ee1cac498ae$var$reb(new $61de1ee1cac498ae$var$Pib(a.d), c);
    }
    f = $61de1ee1cac498ae$var$Fhe(a.g);
    h = !f;
    if (h) {
        k = new $61de1ee1cac498ae$var$wB;
        $61de1ee1cac498ae$var$cC(l, "supportedFeatures", k);
        d = new $61de1ee1cac498ae$var$osd(k);
        $61de1ee1cac498ae$var$reb(a.g, d);
    }
    return l;
}
function $61de1ee1cac498ae$var$ty(a) {
    var b, c, d, e, f, g, h, i, j;
    d = false;
    b = 336;
    c = 0;
    f = new $61de1ee1cac498ae$var$Xp(a.length);
    for(h = a, i = 0, j = h.length; i < j; ++i){
        g = h[i];
        d = d | ($61de1ee1cac498ae$var$Uzb(g), false);
        e = ($61de1ee1cac498ae$var$Tzb(g), g.a);
        $61de1ee1cac498ae$var$Ekb(f.a, $61de1ee1cac498ae$var$Qb(e));
        b &= e.qd();
        c = $61de1ee1cac498ae$var$Ly(c, e.rd());
    }
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rzb(new $61de1ee1cac498ae$var$YAb(null, $61de1ee1cac498ae$var$Yj(new $61de1ee1cac498ae$var$Kub(($61de1ee1cac498ae$var$im(), $61de1ee1cac498ae$var$nm(f.a)), 16), new $61de1ee1cac498ae$var$vy, b, c)), new $61de1ee1cac498ae$var$xy(a)), 670), 833);
}
function $61de1ee1cac498ae$var$UWb(a, b) {
    var c;
    if (!!a.d && (b.c != a.e.c || $61de1ee1cac498ae$var$qWb(a.e.b, b.b))) {
        $61de1ee1cac498ae$var$Ekb(a.f, a.d);
        a.a = a.d.c + a.d.b;
        a.d = null;
        a.e = null;
    }
    $61de1ee1cac498ae$var$nWb(b.b) ? a.c = b : a.b = b;
    if (b.b == ($61de1ee1cac498ae$var$lWb(), $61de1ee1cac498ae$var$hWb) && !b.a || b.b == $61de1ee1cac498ae$var$iWb && b.a || b.b == $61de1ee1cac498ae$var$jWb && b.a || b.b == $61de1ee1cac498ae$var$kWb && !b.a) {
        if (!!a.c && !!a.b) {
            c = new $61de1ee1cac498ae$var$J6c(a.a, a.c.d, b.c - a.a, a.b.d - a.c.d);
            a.d = c;
            a.e = b;
        }
    }
}
function $61de1ee1cac498ae$var$L2c(a) {
    var b;
    $61de1ee1cac498ae$var$D2c.call(this);
    this.i = new $61de1ee1cac498ae$var$Z2c;
    this.g = a;
    this.f = $61de1ee1cac498ae$var$BD(a.e && a.e(), 9).length;
    if (this.f == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("There must be at least one phase in the phase enumeration."));
    this.c = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb(this.g), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0));
    this.a = new $61de1ee1cac498ae$var$j3c;
    this.b = new $61de1ee1cac498ae$var$Lqb;
}
function $61de1ee1cac498ae$var$God(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 7 && !!b) {
        if ($61de1ee1cac498ae$var$p6d(a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ste + $61de1ee1cac498ae$var$Iod(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? $61de1ee1cac498ae$var$Eod(a, d) : a.Cb.ih(a, -1 - c, null, d)));
        !!b && (d = $61de1ee1cac498ae$var$BD(b, 49).gh(a, 1, $61de1ee1cac498ae$var$C2, d));
        d = $61de1ee1cac498ae$var$Dod(a, b, d);
        !!d && d.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 7, b, b));
}
function $61de1ee1cac498ae$var$NHd(a, b) {
    var c, d;
    if (b != a.Cb || a.Db >> 16 != 3 && !!b) {
        if ($61de1ee1cac498ae$var$p6d(a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ste + $61de1ee1cac498ae$var$QHd(a)));
        d = null;
        !!a.Cb && (d = (c = a.Db >> 16, c >= 0 ? $61de1ee1cac498ae$var$KHd(a, d) : a.Cb.ih(a, -1 - c, null, d)));
        !!b && (d = $61de1ee1cac498ae$var$BD(b, 49).gh(a, 0, $61de1ee1cac498ae$var$k5, d));
        d = $61de1ee1cac498ae$var$JHd(a, b, d);
        !!d && d.Fi();
    } else (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 3, b, b));
}
function $61de1ee1cac498ae$var$Ehb(a, b) {
    $61de1ee1cac498ae$var$Dhb();
    var c, d, e, f, g, h, i, j, k;
    if (b.d > a.d) {
        h = a;
        a = b;
        b = h;
    }
    if (b.d < 63) return $61de1ee1cac498ae$var$Ihb(a, b);
    g = (a.d & -2) << 4;
    j = $61de1ee1cac498ae$var$Rgb(a, g);
    k = $61de1ee1cac498ae$var$Rgb(b, g);
    d = $61de1ee1cac498ae$var$yhb(a, $61de1ee1cac498ae$var$Qgb(j, g));
    e = $61de1ee1cac498ae$var$yhb(b, $61de1ee1cac498ae$var$Qgb(k, g));
    i = $61de1ee1cac498ae$var$Ehb(j, k);
    c = $61de1ee1cac498ae$var$Ehb(d, e);
    f = $61de1ee1cac498ae$var$Ehb($61de1ee1cac498ae$var$yhb(j, d), $61de1ee1cac498ae$var$yhb(e, k));
    f = $61de1ee1cac498ae$var$thb($61de1ee1cac498ae$var$thb(f, i), c);
    f = $61de1ee1cac498ae$var$Qgb(f, g);
    i = $61de1ee1cac498ae$var$Qgb(i, g << 1);
    return $61de1ee1cac498ae$var$thb($61de1ee1cac498ae$var$thb(i, f), c);
}
function $61de1ee1cac498ae$var$aGc(a, b, c) {
    var d, e, f, g, h;
    g = $61de1ee1cac498ae$var$CHc(a, c);
    h = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, b.length, 0, 1);
    d = 0;
    for(f = g.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 11);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Nsc)))) && (h[d++] = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$gtc), 10));
    }
    if (d < b.length) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Expected " + b.length + " hierarchical ports, but found only " + d + "."));
    return h;
}
function $61de1ee1cac498ae$var$Und(a, b) {
    var c, d, e, f, g, h;
    if (!a.tb) {
        f = (!a.rb && (a.rb = new $61de1ee1cac498ae$var$jUd(a, $61de1ee1cac498ae$var$d5, a)), a.rb);
        h = new $61de1ee1cac498ae$var$Mqb(f.i);
        for(e = new $61de1ee1cac498ae$var$Fyd(f); e.e != e.i.gc();){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 138);
            g = d.ne();
            c = $61de1ee1cac498ae$var$BD(g == null ? $61de1ee1cac498ae$var$jrb(h.f, null, d) : $61de1ee1cac498ae$var$Drb(h.g, g, d), 138);
            !!c && (g == null ? $61de1ee1cac498ae$var$jrb(h.f, null, c) : $61de1ee1cac498ae$var$Drb(h.g, g, c));
        }
        a.tb = h;
    }
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.tb, b), 138);
}
function $61de1ee1cac498ae$var$YKd(a, b) {
    var c, d, e, f, g;
    (a.i == null && $61de1ee1cac498ae$var$TKd(a), a.i).length;
    if (!a.p) {
        g = new $61de1ee1cac498ae$var$Mqb((3 * a.g.i / 2 | 0) + 1);
        for(e = new $61de1ee1cac498ae$var$$yd(a.g); e.e != e.i.gc();){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Zyd(e), 170);
            f = d.ne();
            c = $61de1ee1cac498ae$var$BD(f == null ? $61de1ee1cac498ae$var$jrb(g.f, null, d) : $61de1ee1cac498ae$var$Drb(g.g, f, d), 170);
            !!c && (f == null ? $61de1ee1cac498ae$var$jrb(g.f, null, c) : $61de1ee1cac498ae$var$Drb(g.g, f, c));
        }
        a.p = g;
    }
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.p, b), 170);
}
function $61de1ee1cac498ae$var$hCb(a, b, c, d, e) {
    var f, g, h, i, j;
    $61de1ee1cac498ae$var$fCb(d + $61de1ee1cac498ae$var$Wy(c, c.$d()), e);
    $61de1ee1cac498ae$var$gCb(b, $61de1ee1cac498ae$var$jCb(c));
    f = c.f;
    !!f && $61de1ee1cac498ae$var$hCb(a, b, f, "Caused by: ", false);
    for(h = (c.k == null && (c.k = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$_I, $61de1ee1cac498ae$var$nie, 78, 0, 0, 1)), c.k), i = 0, j = h.length; i < j; ++i){
        g = h[i];
        $61de1ee1cac498ae$var$hCb(a, b, g, "Suppressed: ", false);
    }
    console.groupEnd != null && console.groupEnd.call(console);
}
function $61de1ee1cac498ae$var$dGc(a, b, c, d) {
    var e, f, g, h, i;
    i = b.e;
    h = i.length;
    g = b.q._f(i, c ? 0 : h - 1, c);
    e = i[c ? 0 : h - 1];
    g = g | $61de1ee1cac498ae$var$cGc(a, e, c, d);
    for(f = c ? 1 : h - 2; c ? f < h : f >= 0; f += c ? 1 : -1){
        g = g | b.c.Sf(i, f, c, d && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Jsc)))) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$mtc)))));
        g = g | b.q._f(i, f, c);
        g = g | $61de1ee1cac498ae$var$cGc(a, i[f], c, d);
    }
    $61de1ee1cac498ae$var$Qqb(a.c, b);
    return g;
}
function $61de1ee1cac498ae$var$o3b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    for(k = $61de1ee1cac498ae$var$m_b(a.j), l = 0, m = k.length; l < m; ++l){
        j = k[l];
        if (c == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc) || c == $61de1ee1cac498ae$var$JAc) {
            i = $61de1ee1cac498ae$var$k_b(j.g);
            for(e = i, f = 0, g = e.length; f < g; ++f){
                d = e[f];
                $61de1ee1cac498ae$var$k3b(b, d) && $61de1ee1cac498ae$var$PZb(d, true);
            }
        }
        if (c == $61de1ee1cac498ae$var$IAc || c == $61de1ee1cac498ae$var$JAc) {
            h = $61de1ee1cac498ae$var$k_b(j.e);
            for(e = h, f = 0, g = e.length; f < g; ++f){
                d = e[f];
                $61de1ee1cac498ae$var$j3b(b, d) && $61de1ee1cac498ae$var$PZb(d, true);
            }
        }
    }
}
function $61de1ee1cac498ae$var$Qmc(a) {
    var b, c;
    b = null;
    c = null;
    switch($61de1ee1cac498ae$var$Lmc(a).g){
        case 1:
            b = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd);
            c = $61de1ee1cac498ae$var$Tcd;
            break;
        case 2:
            b = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd);
            c = $61de1ee1cac498ae$var$Acd;
            break;
        case 3:
            b = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd);
            c = $61de1ee1cac498ae$var$zcd;
            break;
        case 4:
            b = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd);
            c = $61de1ee1cac498ae$var$Rcd;
    }
    $61de1ee1cac498ae$var$mjc(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$RAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.k, b), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113));
    $61de1ee1cac498ae$var$njc(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$QAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.k, c), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113));
}
function $61de1ee1cac498ae$var$a6b(a) {
    var b, c, d, e, f, g;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, 0), 11);
    if (e.e.c.length + e.g.c.length == 0) a.n.a = 0;
    else {
        g = 0;
        for(d = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
            new $61de1ee1cac498ae$var$J0b(e),
            new $61de1ee1cac498ae$var$R0b(e)
        ]))); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 11);
            g += c.i.n.a + c.n.a + c.a.a;
        }
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Txc)), 8);
        f = !b ? 0 : b.a;
        a.n.a = g / (e.e.c.length + e.g.c.length) - f;
    }
}
function $61de1ee1cac498ae$var$F1c(a, b) {
    var c, d, e;
    for(d = new $61de1ee1cac498ae$var$olb(b.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 221);
        $61de1ee1cac498ae$var$$Nb($61de1ee1cac498ae$var$BD(c.b, 65), $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD(b.b, 65).c), $61de1ee1cac498ae$var$BD(b.b, 65).a));
        e = $61de1ee1cac498ae$var$xOb($61de1ee1cac498ae$var$BD(b.b, 65).b, $61de1ee1cac498ae$var$BD(c.b, 65).b);
        e > 1 && (a.a = true);
        $61de1ee1cac498ae$var$ZNb($61de1ee1cac498ae$var$BD(c.b, 65), $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD(b.b, 65).c), $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD(c.b, 65).a), $61de1ee1cac498ae$var$BD(b.b, 65).a), e)));
        $61de1ee1cac498ae$var$D1c(a, b);
        $61de1ee1cac498ae$var$F1c(a, c);
    }
}
function $61de1ee1cac498ae$var$rVb(a) {
    var b, c, d, e, f, g, h;
    for(f = new $61de1ee1cac498ae$var$olb(a.a.a); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 189);
        d.e = 0;
        d.d.a.$b();
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.a.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 189);
        for(c = d.a.a.ec().Kc(); c.Ob();){
            b = $61de1ee1cac498ae$var$BD(c.Pb(), 81);
            for(h = b.f.Kc(); h.Ob();){
                g = $61de1ee1cac498ae$var$BD(h.Pb(), 81);
                if (g.d != d) {
                    $61de1ee1cac498ae$var$Qqb(d.d, g);
                    ++g.d.e;
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$bcc(a) {
    var b, c, d, e, f, g, h, i;
    i = a.j.c.length;
    c = 0;
    b = i;
    e = 2 * i;
    for(h = new $61de1ee1cac498ae$var$olb(a.j); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        switch(g.j.g){
            case 2:
            case 4:
                g.p = -1;
                break;
            case 1:
            case 3:
                d = g.e.c.length;
                f = g.g.c.length;
                d > 0 && f > 0 ? g.p = b++ : d > 0 ? g.p = c++ : f > 0 ? g.p = e++ : g.p = c++;
        }
    }
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(a.j, new $61de1ee1cac498ae$var$fcc);
}
function $61de1ee1cac498ae$var$Vec(a) {
    var b, c;
    c = null;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.g, 0), 17);
    do {
        c = b.d.i;
        if ($61de1ee1cac498ae$var$wNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Wsc))) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Wsc), 11).i;
        if (c.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) && $61de1ee1cac498ae$var$Qr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(c).a.Kc(), new $61de1ee1cac498ae$var$Sq)))) b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(c).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17);
        else if (c.k != $61de1ee1cac498ae$var$h0b) return null;
    }while (!!c && c.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b));
    return c;
}
function $61de1ee1cac498ae$var$Omc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    h = b.j;
    g = b.g;
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(h, h.c.length - 1), 113);
    k = ($61de1ee1cac498ae$var$tCb(0, h.c.length), $61de1ee1cac498ae$var$BD(h.c[0], 113));
    j = $61de1ee1cac498ae$var$Kmc(a, g, i, k);
    for(f = 1; f < h.c.length; f++){
        c = ($61de1ee1cac498ae$var$tCb(f - 1, h.c.length), $61de1ee1cac498ae$var$BD(h.c[f - 1], 113));
        e = ($61de1ee1cac498ae$var$tCb(f, h.c.length), $61de1ee1cac498ae$var$BD(h.c[f], 113));
        d = $61de1ee1cac498ae$var$Kmc(a, g, c, e);
        if (d > j) {
            i = c;
            k = e;
            j = d;
        }
    }
    b.a = k;
    b.c = i;
}
function $61de1ee1cac498ae$var$sEb(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$Axb(a.b, b.b);
    if (!d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Invalid hitboxes for scanline constraint calculation."));
    ($61de1ee1cac498ae$var$mEb(b.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Cxb(a.b, b.b), 57)) || $61de1ee1cac498ae$var$mEb(b.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Bxb(a.b, b.b), 57))) && ($61de1ee1cac498ae$var$Zfb(), b.b);
    a.a[b.b.f] = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Exb(a.b, b.b), 57);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dxb(a.b, b.b), 57);
    !!c && (a.a[c.f] = b.b);
}
function $61de1ee1cac498ae$var$AFb(a) {
    if (!a.a.d || !a.a.e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb(($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$fN), $61de1ee1cac498ae$var$fN.k + " must have a source and target " + ($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$jN), $61de1ee1cac498ae$var$jN.k) + " specified.")));
    if (a.a.d == a.a.e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Network simplex does not support self-loops: " + a.a + " " + a.a.d + " " + a.a.e));
    $61de1ee1cac498ae$var$NFb(a.a.d.g, a.a);
    $61de1ee1cac498ae$var$NFb(a.a.e.b, a.a);
    return a.a;
}
function $61de1ee1cac498ae$var$HHc(a, b, c) {
    var d, e, f, g, h, i, j;
    j = new $61de1ee1cac498ae$var$Hxb(new $61de1ee1cac498ae$var$tIc(a));
    for(g = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$aR, 1), $61de1ee1cac498ae$var$lne, 11, 0, [
        b,
        c
    ]), h = 0, i = g.length; h < i; ++h){
        f = g[h];
        $61de1ee1cac498ae$var$Iwb(j.a, f, ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb));
        for(e = new $61de1ee1cac498ae$var$b1b(f.b); $61de1ee1cac498ae$var$llb(e.a) || $61de1ee1cac498ae$var$llb(e.b);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(e.a) ? $61de1ee1cac498ae$var$mlb(e.a) : $61de1ee1cac498ae$var$mlb(e.b), 17);
            d.c == d.d || $61de1ee1cac498ae$var$Axb(j, f == d.c ? d.d : d.c);
        }
    }
    return $61de1ee1cac498ae$var$Qb(j), new $61de1ee1cac498ae$var$Tkb(j);
}
function $61de1ee1cac498ae$var$oPc(a, b, c) {
    var d, e, f, g, h, i;
    d = 0;
    if (b.b != 0 && c.b != 0) {
        f = $61de1ee1cac498ae$var$Jsb(b, 0);
        g = $61de1ee1cac498ae$var$Jsb(c, 0);
        h = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(f)));
        i = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(g)));
        e = true;
        do {
            if (h > i - a.b && h < i + a.b) return -1;
            else h > i - a.a && h < i + a.a && ++d;
            h <= i && f.b != f.d.c ? h = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(f))) : i <= h && g.b != g.d.c ? i = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(g))) : e = false;
        }while (e);
    }
    return d;
}
function $61de1ee1cac498ae$var$F3b(a, b, c, d, e) {
    var f, g, h, i;
    i = (f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$F1), 9), new $61de1ee1cac498ae$var$xqb(f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(f, f.length), 9), 0));
    for(h = new $61de1ee1cac498ae$var$olb(a.j); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        if (b[g.p]) {
            $61de1ee1cac498ae$var$G3b(g, b[g.p], d);
            $61de1ee1cac498ae$var$rqb(i, g.j);
        }
    }
    if (e) {
        $61de1ee1cac498ae$var$K3b(a, b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd), 2 * c, d);
        $61de1ee1cac498ae$var$K3b(a, b, $61de1ee1cac498ae$var$Tcd, 2 * c, d);
    } else {
        $61de1ee1cac498ae$var$K3b(a, b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd), 2 * c, d);
        $61de1ee1cac498ae$var$K3b(a, b, $61de1ee1cac498ae$var$Rcd, 2 * c, d);
    }
}
function $61de1ee1cac498ae$var$Szb(a) {
    var b, c, d, e, f;
    f = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Hkb(a.b, new $61de1ee1cac498ae$var$XBb(f));
    a.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    if (f.c.length != 0) {
        b = ($61de1ee1cac498ae$var$tCb(0, f.c.length), $61de1ee1cac498ae$var$BD(f.c[0], 78));
        for(c = 1, d = f.c.length; c < d; ++c){
            e = ($61de1ee1cac498ae$var$tCb(c, f.c.length), $61de1ee1cac498ae$var$BD(f.c[c], 78));
            e != b && $61de1ee1cac498ae$var$Qy(b, e);
        }
        if ($61de1ee1cac498ae$var$JD(b, 60)) throw $61de1ee1cac498ae$var$vbb($61de1ee1cac498ae$var$BD(b, 60));
        if ($61de1ee1cac498ae$var$JD(b, 289)) throw $61de1ee1cac498ae$var$vbb($61de1ee1cac498ae$var$BD(b, 289));
    }
}
function $61de1ee1cac498ae$var$DCb(a, b) {
    var c, d, e, f;
    a = a == null ? $61de1ee1cac498ae$var$Xhe : ($61de1ee1cac498ae$var$uCb(a), a);
    c = new $61de1ee1cac498ae$var$Vfb;
    f = 0;
    d = 0;
    while(d < b.length){
        e = a.indexOf("%s", f);
        if (e == -1) break;
        $61de1ee1cac498ae$var$Qfb(c, a.substr(f, e - f));
        $61de1ee1cac498ae$var$Pfb(c, b[d++]);
        f = e + 2;
    }
    $61de1ee1cac498ae$var$Qfb(c, a.substr(f));
    if (d < b.length) {
        c.a += " [";
        $61de1ee1cac498ae$var$Pfb(c, b[d++]);
        while(d < b.length){
            c.a += $61de1ee1cac498ae$var$She;
            $61de1ee1cac498ae$var$Pfb(c, b[d++]);
        }
        c.a += "]";
    }
    return c.a;
}
function $61de1ee1cac498ae$var$KCb(a) {
    var b, c, d, e;
    b = 0;
    d = a.length;
    e = d - 4;
    c = 0;
    while(c < e){
        b = ($61de1ee1cac498ae$var$BCb(c + 3, a.length), a.charCodeAt(c + 3) + ($61de1ee1cac498ae$var$BCb(c + 2, a.length), 31 * (a.charCodeAt(c + 2) + ($61de1ee1cac498ae$var$BCb(c + 1, a.length), 31 * (a.charCodeAt(c + 1) + ($61de1ee1cac498ae$var$BCb(c, a.length), 31 * (a.charCodeAt(c) + 31 * b)))))));
        b = b | 0;
        c += 4;
    }
    while(c < d)b = b * 31 + $61de1ee1cac498ae$var$bfb(a, c++);
    b = b | 0;
    return b;
}
function $61de1ee1cac498ae$var$Rac(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
        if (b.d.i.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c($61de1ee1cac498ae$var$Fne + $61de1ee1cac498ae$var$P_b(a) + "' has its layer constraint set to LAST, but has at least one outgoing edge that " + " does not go to a LAST_SEPARATE node. That must not happen."));
    }
}
function $61de1ee1cac498ae$var$jQc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    i = 0;
    for(k = new $61de1ee1cac498ae$var$olb(a.a); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
        h = 0;
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(j).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            l = $61de1ee1cac498ae$var$A0b(e.c).b;
            m = $61de1ee1cac498ae$var$A0b(e.d).b;
            h = $61de1ee1cac498ae$var$$wnd.Math.max(h, $61de1ee1cac498ae$var$$wnd.Math.abs(m - l));
        }
        i = $61de1ee1cac498ae$var$$wnd.Math.max(i, h);
    }
    g = d * $61de1ee1cac498ae$var$$wnd.Math.min(1, b / c) * i;
    return g;
}
function $61de1ee1cac498ae$var$See(a) {
    var b;
    b = new $61de1ee1cac498ae$var$Ifb;
    (a & 256) != 0 && (b.a += "F", b);
    (a & 128) != 0 && (b.a += "H", b);
    (a & 512) != 0 && (b.a += "X", b);
    (a & 2) != 0 && (b.a += "i", b);
    (a & 8) != 0 && (b.a += "m", b);
    (a & 4) != 0 && (b.a += "s", b);
    (a & 32) != 0 && (b.a += "u", b);
    (a & 64) != 0 && (b.a += "w", b);
    (a & 16) != 0 && (b.a += "x", b);
    (a & $61de1ee1cac498ae$var$zte) != 0 && (b.a += ",", b);
    return $61de1ee1cac498ae$var$jfb(b.a);
}
function $61de1ee1cac498ae$var$F5b(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Odd(b, "Resize child graph to fit parent.", 1);
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        $61de1ee1cac498ae$var$Gkb(a.a, c.a);
        c.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    }
    for(f = new $61de1ee1cac498ae$var$olb(a.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        $61de1ee1cac498ae$var$$_b(e, null);
    }
    a.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$G5b(a);
    !!a.e && $61de1ee1cac498ae$var$E5b(a.e, a);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$eec(a) {
    var b, c, d, e, f, g, h, i, j;
    d = a.b;
    f = d.e;
    g = $61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98));
    c = !!f && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc));
    if (g || c) return;
    for(j = (h = new $61de1ee1cac498ae$var$$ib(a.e).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(h)); j.a.Ob();){
        i = (b = $61de1ee1cac498ae$var$BD(j.a.Pb(), 42), $61de1ee1cac498ae$var$BD(b.dd(), 113));
        if (i.a) {
            e = i.d;
            $61de1ee1cac498ae$var$F0b(e, null);
            i.c = true;
            a.a = true;
        }
    }
}
function $61de1ee1cac498ae$var$QFc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    m = -1;
    n = 0;
    for(j = a, k = 0, l = j.length; k < l; ++k){
        i = j[k];
        for(f = i, g = 0, h = f.length; g < h; ++g){
            e = f[g];
            b = new $61de1ee1cac498ae$var$Unc(m == -1 ? a[0] : a[m], $61de1ee1cac498ae$var$Xec(e));
            for(c = 0; c < e.j.c.length; c++)for(d = c + 1; d < e.j.c.length; d++)$61de1ee1cac498ae$var$Rnc(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e.j, c), 11), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e.j, d), 11)) > 0 && ++n;
        }
        ++m;
    }
    return n;
}
function $61de1ee1cac498ae$var$hUc(a, b) {
    var c, d, e, f, g;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$FTc)), 425);
    for(f = $61de1ee1cac498ae$var$Jsb(b.b, 0); f.b != f.d.c;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 86);
        if (a.b[e.g] == 0) {
            switch(g.g){
                case 0:
                    $61de1ee1cac498ae$var$iUc(a, e);
                    break;
                case 1:
                    $61de1ee1cac498ae$var$gUc(a, e);
            }
            a.b[e.g] = 2;
        }
    }
    for(d = $61de1ee1cac498ae$var$Jsb(a.a, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 188);
        $61de1ee1cac498ae$var$ze(c.b.d, c, true);
        $61de1ee1cac498ae$var$ze(c.c.b, c, true);
    }
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$gTc), a.a);
}
function $61de1ee1cac498ae$var$S6d(a, b) {
    $61de1ee1cac498ae$var$Q6d();
    var c, d, e, f;
    if (!b) return $61de1ee1cac498ae$var$P6d;
    else if (b == ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$N8d) || (b == $61de1ee1cac498ae$var$v8d || b == $61de1ee1cac498ae$var$t8d || b == $61de1ee1cac498ae$var$u8d) && a != $61de1ee1cac498ae$var$s8d) return new $61de1ee1cac498ae$var$Z6d(a, b);
    else {
        d = $61de1ee1cac498ae$var$BD(b, 677);
        c = d.pk();
        if (!c) {
            $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), b));
            c = d.pk();
        }
        f = (!c.i && (c.i = new $61de1ee1cac498ae$var$Lqb), c.i);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(f.f, a)), 1942);
        !e && $61de1ee1cac498ae$var$Rhb(f, a, e = new $61de1ee1cac498ae$var$Z6d(a, b));
        return e;
    }
}
function $61de1ee1cac498ae$var$Tbc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
    j = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        i.i.n,
        i.n,
        i.a
    ])).a;
    k = a.i.n.b;
    c = $61de1ee1cac498ae$var$k_b(a.e);
    for(e = c, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        $61de1ee1cac498ae$var$RZb(d, i);
        $61de1ee1cac498ae$var$Fsb(d.a, new $61de1ee1cac498ae$var$f7c(j, k));
        if (b) {
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
            if (!h) {
                h = new $61de1ee1cac498ae$var$s7c;
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$jxc, h);
            }
            $61de1ee1cac498ae$var$Dsb(h, new $61de1ee1cac498ae$var$f7c(j, k));
        }
    }
}
function $61de1ee1cac498ae$var$Ubc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
    j = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        e.i.n,
        e.n,
        e.a
    ])).a;
    k = a.i.n.b;
    c = $61de1ee1cac498ae$var$k_b(a.g);
    for(g = c, h = 0, i = g.length; h < i; ++h){
        f = g[h];
        $61de1ee1cac498ae$var$QZb(f, e);
        $61de1ee1cac498ae$var$Esb(f.a, new $61de1ee1cac498ae$var$f7c(j, k));
        if (b) {
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
            if (!d) {
                d = new $61de1ee1cac498ae$var$s7c;
                $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$jxc, d);
            }
            $61de1ee1cac498ae$var$Dsb(d, new $61de1ee1cac498ae$var$f7c(j, k));
        }
    }
}
function $61de1ee1cac498ae$var$TFc(a, b) {
    var c, d, e, f, g, h;
    a.b = new $61de1ee1cac498ae$var$Rkb;
    a.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$jtc)), 230);
    a.e = $61de1ee1cac498ae$var$Dub(a.d);
    f = new $61de1ee1cac498ae$var$Psb;
    e = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KQ, 1), $61de1ee1cac498ae$var$cne, 37, 0, [
        b
    ]));
    g = 0;
    while(g < e.c.length){
        d = ($61de1ee1cac498ae$var$tCb(g, e.c.length), $61de1ee1cac498ae$var$BD(e.c[g], 37));
        d.p = g++;
        c = new $61de1ee1cac498ae$var$fFc(d, a.a, a.b);
        $61de1ee1cac498ae$var$Gkb(e, c.b);
        $61de1ee1cac498ae$var$Ekb(a.b, c);
        c.s && (h = $61de1ee1cac498ae$var$Jsb(f, 0), $61de1ee1cac498ae$var$Vsb(h, c));
    }
    a.c = new $61de1ee1cac498ae$var$Tqb;
    return f;
}
function $61de1ee1cac498ae$var$HJb(a, b) {
    var c, d, e, f, g, h;
    for(g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 111);
        c = f.c ? $61de1ee1cac498ae$var$ZHb(f.c) : 0;
        if (c > 0) {
            if (f.a) {
                h = f.b.rf().a;
                if (c > h) {
                    e = (c - h) / 2;
                    f.d.b = e;
                    f.d.c = e;
                }
            } else f.d.c = a.s + c;
        } else if ($61de1ee1cac498ae$var$tcd(a.u)) {
            d = $61de1ee1cac498ae$var$sfd(f.b);
            d.c < 0 && (f.d.b = -d.c);
            d.c + d.b > f.b.rf().a && (f.d.c = d.c + d.b - f.b.rf().a);
        }
    }
}
function $61de1ee1cac498ae$var$Eec(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Odd(b, "Semi-Interactive Crossing Minimization Processor", 1);
    c = false;
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        f = $61de1ee1cac498ae$var$TAb($61de1ee1cac498ae$var$VAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(d.a, 16)), new $61de1ee1cac498ae$var$Jec), new $61de1ee1cac498ae$var$Lec), new $61de1ee1cac498ae$var$Nec), new $61de1ee1cac498ae$var$Rec);
        c = c | f.a != null;
    }
    c && $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Rsc), ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$sRc(a, b, c) {
    var d, e, f, g, h;
    e = c;
    !e && (e = new $61de1ee1cac498ae$var$Zdd);
    $61de1ee1cac498ae$var$Odd(e, "Layout", a.a.c.length);
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$vTc))))) {
        $61de1ee1cac498ae$var$Zfb();
        for(d = 0; d < a.a.c.length; d++){
            h = (d < 10 ? "0" : "") + d++;
            $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$rb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, d), 51)));
        }
    }
    for(g = new $61de1ee1cac498ae$var$olb(a.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 51);
        f.pf(b, $61de1ee1cac498ae$var$Udd(e, 1));
    }
    $61de1ee1cac498ae$var$Qdd(e);
}
function $61de1ee1cac498ae$var$yMb(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$BD(a.a, 19).a;
    c = $61de1ee1cac498ae$var$BD(a.b, 19).a;
    if (b >= 0) {
        if (b == c) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(-b - 1), $61de1ee1cac498ae$var$meb(-b - 1));
        if (b == -c) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(-b), $61de1ee1cac498ae$var$meb(c + 1));
    }
    if ($61de1ee1cac498ae$var$$wnd.Math.abs(b) > $61de1ee1cac498ae$var$$wnd.Math.abs(c)) {
        if (b < 0) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(-b), $61de1ee1cac498ae$var$meb(c));
        return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(-b), $61de1ee1cac498ae$var$meb(c + 1));
    }
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(b + 1), $61de1ee1cac498ae$var$meb(c));
}
function $61de1ee1cac498ae$var$q5b(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163);
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Osc)), 303);
    if (c == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc)) {
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, $61de1ee1cac498ae$var$Btc);
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Osc, ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$dsc));
    } else if (c == $61de1ee1cac498ae$var$Atc) {
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, $61de1ee1cac498ae$var$Btc);
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Osc, ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$bsc));
    } else if (b == ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$dsc)) {
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, $61de1ee1cac498ae$var$ytc);
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Osc, $61de1ee1cac498ae$var$csc);
    } else if (b == $61de1ee1cac498ae$var$bsc) {
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mxc, $61de1ee1cac498ae$var$Atc);
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Osc, $61de1ee1cac498ae$var$csc);
    }
}
function $61de1ee1cac498ae$var$FNc() {
    $61de1ee1cac498ae$var$FNc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$DNc = new $61de1ee1cac498ae$var$RNc;
    $61de1ee1cac498ae$var$zNc = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$o8b));
    $61de1ee1cac498ae$var$CNc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$C8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$B8b);
    $61de1ee1cac498ae$var$ENc = $61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$g3c($61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$lUb, $61de1ee1cac498ae$var$M8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$L8b), $61de1ee1cac498ae$var$oUb), $61de1ee1cac498ae$var$K8b), $61de1ee1cac498ae$var$N8b);
    $61de1ee1cac498ae$var$ANc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$r8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$t8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$u8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$s8b);
    $61de1ee1cac498ae$var$BNc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$u8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$_7b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$$7b);
}
function $61de1ee1cac498ae$var$hQc() {
    $61de1ee1cac498ae$var$hQc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$cQc = $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$c3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$c8b)), $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$o8b);
    $61de1ee1cac498ae$var$gQc = $61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$g3c($61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$lUb, $61de1ee1cac498ae$var$M8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$L8b), $61de1ee1cac498ae$var$oUb), $61de1ee1cac498ae$var$K8b), $61de1ee1cac498ae$var$N8b);
    $61de1ee1cac498ae$var$dQc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$r8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$t8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$u8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$s8b);
    $61de1ee1cac498ae$var$fQc = $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$C8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$B8b);
    $61de1ee1cac498ae$var$eQc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$u8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$_7b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$$7b);
}
function $61de1ee1cac498ae$var$GNc(a, b, c, d, e) {
    var f, g;
    if ((!$61de1ee1cac498ae$var$OZb(b) && b.c.i.c == b.d.i.c || !$61de1ee1cac498ae$var$T6c($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        e.i.n,
        e.n,
        e.a
    ])), c)) && !$61de1ee1cac498ae$var$OZb(b)) {
        b.c == e ? $61de1ee1cac498ae$var$St(b.a, 0, new $61de1ee1cac498ae$var$g7c(c)) : $61de1ee1cac498ae$var$Dsb(b.a, new $61de1ee1cac498ae$var$g7c(c));
        if (d && !$61de1ee1cac498ae$var$Rqb(a.a, c)) {
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
            if (!g) {
                g = new $61de1ee1cac498ae$var$s7c;
                $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$jxc, g);
            }
            f = new $61de1ee1cac498ae$var$g7c(c);
            $61de1ee1cac498ae$var$Gsb(g, f, g.c.b, g.c);
            $61de1ee1cac498ae$var$Qqb(a.a, f);
        }
    }
}
function $61de1ee1cac498ae$var$Qac(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
        if (b.c.i.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c($61de1ee1cac498ae$var$Fne + $61de1ee1cac498ae$var$P_b(a) + "' has its layer constraint set to FIRST, but has at least one incoming edge that " + " does not come from a FIRST_SEPARATE node. That must not happen."));
    }
}
function $61de1ee1cac498ae$var$vjd(a, b, c) {
    var d, e, f, g, h, i, j;
    e = $61de1ee1cac498ae$var$aeb(a.Db & 254);
    if (e == 0) a.Eb = c;
    else {
        if (e == 1) {
            h = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 2, 5, 1);
            f = $61de1ee1cac498ae$var$zjd(a, b);
            if (f == 0) {
                h[0] = c;
                h[1] = a.Eb;
            } else {
                h[0] = a.Eb;
                h[1] = c;
            }
        } else {
            h = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, e + 1, 5, 1);
            g = $61de1ee1cac498ae$var$CD(a.Eb);
            for(d = 2, i = 0, j = 0; d <= 128; d <<= 1)d == b ? h[j++] = c : (a.Db & d) != 0 && (h[j++] = g[i++]);
        }
        a.Eb = h;
    }
    a.Db |= b;
}
function $61de1ee1cac498ae$var$ENb(a, b, c) {
    var d, e, f, g;
    this.b = new $61de1ee1cac498ae$var$Rkb;
    e = 0;
    d = 0;
    for(g = new $61de1ee1cac498ae$var$olb(a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 167);
        c && $61de1ee1cac498ae$var$rMb(f);
        $61de1ee1cac498ae$var$Ekb(this.b, f);
        e += f.o;
        d += f.p;
    }
    if (this.b.c.length > 0) {
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(this.b, 0), 167);
        e += f.o;
        d += f.p;
    }
    e *= 2;
    d *= 2;
    b > 1 ? e = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(e * b)) : d = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(d / b));
    this.a = new $61de1ee1cac498ae$var$pNb(e, d);
}
function $61de1ee1cac498ae$var$Igc(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m, n, o, p, q, r;
    k = d;
    if (b.j && b.o) {
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.f, b.A), 57);
        p = n.d.c + n.d.b;
        --k;
    } else p = b.a.c + b.a.b;
    l = e;
    if (c.q && c.o) {
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.f, c.C), 57);
        j = n.d.c;
        ++l;
    } else j = c.a.c;
    q = j - p;
    i = $61de1ee1cac498ae$var$$wnd.Math.max(2, l - k);
    h = q / i;
    o = p + h;
    for(m = k; m < l; ++m){
        g = $61de1ee1cac498ae$var$BD(f.Xb(m), 128);
        r = g.a.b;
        g.a.c = o - r / 2;
        o += h;
    }
}
function $61de1ee1cac498ae$var$UHc(a, b, c, d, e, f) {
    var g, h, i, j, k, l;
    j = c.c.length;
    f && (a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b.length, 15, 1));
    for(g = e ? 0 : b.length - 1; e ? g < b.length : g >= 0; g += e ? 1 : -1){
        h = b[g];
        i = d == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) ? e ? $61de1ee1cac498ae$var$V_b(h, d) : $61de1ee1cac498ae$var$Su($61de1ee1cac498ae$var$V_b(h, d)) : e ? $61de1ee1cac498ae$var$Su($61de1ee1cac498ae$var$V_b(h, d)) : $61de1ee1cac498ae$var$V_b(h, d);
        f && (a.c[h.p] = i.gc());
        for(l = i.Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 11);
            a.d[k.p] = j++;
        }
        $61de1ee1cac498ae$var$Gkb(c, i);
    }
}
function $61de1ee1cac498ae$var$aQc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    f = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(a.b.Kc().Pb()));
    j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Pq(b.b)));
    d = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$R6c(a.a), j - c);
    e = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$R6c(b.a), c - f);
    k = $61de1ee1cac498ae$var$P6c(d, e);
    $61de1ee1cac498ae$var$Y6c(k, 1 / (j - f));
    this.a = k;
    this.b = new $61de1ee1cac498ae$var$Rkb;
    h = true;
    g = a.b.Kc();
    g.Pb();
    while(g.Ob()){
        i = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(g.Pb()));
        if (h && i - c > $61de1ee1cac498ae$var$Oqe) {
            this.b.Fc(c);
            h = false;
        }
        this.b.Fc(i);
    }
    h && this.b.Fc(c);
}
function $61de1ee1cac498ae$var$vGb(a) {
    var b, c, d, e;
    $61de1ee1cac498ae$var$yGb(a, a.n);
    if (a.d.c.length > 0) {
        $61de1ee1cac498ae$var$Blb(a.c);
        while($61de1ee1cac498ae$var$GGb(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(new $61de1ee1cac498ae$var$olb(a.e.a)), 121)) < a.e.a.c.length){
            b = $61de1ee1cac498ae$var$AGb(a);
            e = b.e.e - b.d.e - b.a;
            b.e.j && (e = -e);
            for(d = new $61de1ee1cac498ae$var$olb(a.e.a); d.a < d.c.c.length;){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 121);
                c.j && (c.e += e);
            }
            $61de1ee1cac498ae$var$Blb(a.c);
        }
        $61de1ee1cac498ae$var$Blb(a.c);
        $61de1ee1cac498ae$var$DGb(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(new $61de1ee1cac498ae$var$olb(a.e.a)), 121));
        $61de1ee1cac498ae$var$rGb(a);
    }
}
function $61de1ee1cac498ae$var$rkc(a, b) {
    var c, d, e, f, g;
    for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.a, ($61de1ee1cac498ae$var$Xjc(), $61de1ee1cac498ae$var$Tjc)), 15).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 101);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d.j, 0), 113).d.j;
        f = new $61de1ee1cac498ae$var$Tkb(d.j);
        $61de1ee1cac498ae$var$Okb(f, new $61de1ee1cac498ae$var$Xkc);
        switch(b.g){
            case 1:
                $61de1ee1cac498ae$var$jkc(a, f, c, ($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$Dkc), 1);
                break;
            case 0:
                g = $61de1ee1cac498ae$var$lkc(f);
                $61de1ee1cac498ae$var$jkc(a, new $61de1ee1cac498ae$var$Jib(f, 0, g), c, ($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$Dkc), 0);
                $61de1ee1cac498ae$var$jkc(a, new $61de1ee1cac498ae$var$Jib(f, g, f.c.length), c, $61de1ee1cac498ae$var$Dkc, 1);
        }
    }
}
function $61de1ee1cac498ae$var$c2c(a, b) {
    $61de1ee1cac498ae$var$Y1c();
    var c, d;
    c = $61de1ee1cac498ae$var$j4c($61de1ee1cac498ae$var$n4c(), b.tg());
    if (c) {
        d = c.j;
        if ($61de1ee1cac498ae$var$JD(a, 239)) return $61de1ee1cac498ae$var$Zod($61de1ee1cac498ae$var$BD(a, 33)) ? $61de1ee1cac498ae$var$uqb(d, ($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$K5c)) || $61de1ee1cac498ae$var$uqb(d, $61de1ee1cac498ae$var$L5c) : $61de1ee1cac498ae$var$uqb(d, ($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$K5c));
        else if ($61de1ee1cac498ae$var$JD(a, 352)) return $61de1ee1cac498ae$var$uqb(d, ($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$I5c));
        else if ($61de1ee1cac498ae$var$JD(a, 186)) return $61de1ee1cac498ae$var$uqb(d, ($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$M5c));
        else if ($61de1ee1cac498ae$var$JD(a, 354)) return $61de1ee1cac498ae$var$uqb(d, ($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$J5c));
    }
    return true;
}
function $61de1ee1cac498ae$var$c3d(a, b, c) {
    var d, e, f, g, h, i;
    e = c;
    f = e.ak();
    if ($61de1ee1cac498ae$var$T6d(a.e, f)) {
        if (f.hi()) {
            d = $61de1ee1cac498ae$var$BD(a.g, 119);
            for(g = 0; g < a.i; ++g){
                h = d[g];
                if ($61de1ee1cac498ae$var$pb(h, e) && g != b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$kue));
            }
        }
    } else {
        i = $61de1ee1cac498ae$var$S6d(a.e.Tg(), f);
        d = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(g = 0; g < a.i; ++g){
            h = d[g];
            if (i.rl(h.ak()) && g != b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Hwe));
        }
    }
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(a, b, c), 72);
}
function $61de1ee1cac498ae$var$Sy(d, b) {
    if (b instanceof Object) try {
        b.__java$exception = d;
        if (navigator.userAgent.toLowerCase().indexOf("msie") != -1 && $doc.documentMode < 9) return;
        var c = d;
        Object.defineProperties(b, {
            cause: {
                get: function() {
                    var a = c.Zd();
                    return a && a.Xd();
                }
            },
            suppressed: {
                get: function() {
                    return c.Yd();
                }
            }
        });
    } catch (a) {}
}
function $61de1ee1cac498ae$var$lhb(a, b) {
    var c, d, e, f, g;
    d = b >> 5;
    b &= 31;
    if (d >= a.d) return a.e < 0 ? ($61de1ee1cac498ae$var$Hgb(), $61de1ee1cac498ae$var$Bgb) : ($61de1ee1cac498ae$var$Hgb(), $61de1ee1cac498ae$var$Ggb);
    f = a.d - d;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, f + 1, 15, 1);
    $61de1ee1cac498ae$var$mhb(e, f, a.a, d, b);
    if (a.e < 0) {
        for(c = 0; c < d && a.a[c] == 0; c++);
        if (c < d || b > 0 && a.a[c] << 32 - b != 0) {
            for(c = 0; c < f && e[c] == -1; c++)e[c] = 0;
            c == f && ++f;
            ++e[c];
        }
    }
    g = new $61de1ee1cac498ae$var$Vgb(a.e, f, e);
    $61de1ee1cac498ae$var$Jgb(g);
    return g;
}
function $61de1ee1cac498ae$var$UPb(a) {
    var b, c, d, e;
    e = $61de1ee1cac498ae$var$mpd(a);
    c = new $61de1ee1cac498ae$var$kQb(e);
    d = new $61de1ee1cac498ae$var$mQb(e);
    b = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Gkb(b, (!a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5)), a.d));
    $61de1ee1cac498ae$var$Gkb(b, (!a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4)), a.e));
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b, 16)), c), d), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Eyb),
        $61de1ee1cac498ae$var$Dyb
    ]))), 21);
}
function $61de1ee1cac498ae$var$p2d(a, b, c, d) {
    var e, f, g, h, i;
    h = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj());
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        if (b.hi() && $61de1ee1cac498ae$var$F2d(a, b, d, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$kue));
    } else {
        i = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
        e = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(g = 0; g < a.i; ++g){
            f = e[g];
            if (i.rl(f.ak())) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Hwe));
        }
    }
    $61de1ee1cac498ae$var$vtd(a, $61de1ee1cac498ae$var$I2d(a, b, c), h ? $61de1ee1cac498ae$var$BD(d, 72) : $61de1ee1cac498ae$var$R6d(b, d));
}
function $61de1ee1cac498ae$var$T6d(a, b) {
    $61de1ee1cac498ae$var$Q6d();
    var c, d, e;
    if (b.$j()) return true;
    else if (b.Zj() == -2) {
        if (b == ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$k8d) || b == $61de1ee1cac498ae$var$h8d || b == $61de1ee1cac498ae$var$i8d || b == $61de1ee1cac498ae$var$j8d) return true;
        else {
            e = a.Tg();
            if ($61de1ee1cac498ae$var$bLd(e, b) >= 0) return false;
            else {
                c = $61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), e, b);
                if (!c) return true;
                else {
                    d = c.Zj();
                    return (d > 1 || d == -1) && $61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, c)) != 3;
                }
            }
        }
    } else return false;
}
function $61de1ee1cac498ae$var$R1b(a, b, c, d) {
    var e, f, g, h, i;
    h = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.b && (b.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 4, 7)), b.b), 0), 82));
    i = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.c && (b.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 5, 8)), b.c), 0), 82));
    if ($61de1ee1cac498ae$var$Xod(h) == $61de1ee1cac498ae$var$Xod(i)) return null;
    if ($61de1ee1cac498ae$var$ntd(i, h)) return null;
    g = $61de1ee1cac498ae$var$Mld(b);
    if (g == c) return d;
    else {
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, g), 10);
        if (f) {
            e = f.e;
            if (e) return e;
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$Cac(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Rwc)), 276);
    $61de1ee1cac498ae$var$Odd(b, "Label side selection (" + c + ")", 1);
    switch(c.g){
        case 0:
            $61de1ee1cac498ae$var$Dac(a, ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd));
            break;
        case 1:
            $61de1ee1cac498ae$var$Dac(a, ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$obd));
            break;
        case 2:
            $61de1ee1cac498ae$var$Bac(a, ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd));
            break;
        case 3:
            $61de1ee1cac498ae$var$Bac(a, ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$obd));
            break;
        case 4:
            $61de1ee1cac498ae$var$Eac(a, ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd));
            break;
        case 5:
            $61de1ee1cac498ae$var$Eac(a, ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$obd));
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$bGc(a, b, c) {
    var d, e, f, g, h, i;
    d = $61de1ee1cac498ae$var$RFc(c, a.length);
    g = a[d];
    if (g[0].k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) return;
    f = $61de1ee1cac498ae$var$SFc(c, g.length);
    i = b.j;
    for(e = 0; e < i.c.length; e++){
        h = ($61de1ee1cac498ae$var$tCb(e, i.c.length), $61de1ee1cac498ae$var$BD(i.c[e], 11));
        if ((c ? h.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) : h.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Nsc))))) {
            $61de1ee1cac498ae$var$Nkb(i, e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g[f], ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11));
            f += c ? 1 : -1;
        }
    }
}
function $61de1ee1cac498ae$var$rQc(a, b) {
    var c, d, e, f, g;
    g = new $61de1ee1cac498ae$var$Rkb;
    c = b;
    do {
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, c), 128);
        f.B = c.c;
        f.D = c.d;
        g.c[g.c.length] = f;
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.k, c), 17);
    }while (c);
    d = ($61de1ee1cac498ae$var$tCb(0, g.c.length), $61de1ee1cac498ae$var$BD(g.c[0], 128));
    d.j = true;
    d.A = $61de1ee1cac498ae$var$BD(d.d.a.ec().Kc().Pb(), 17).c.i;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g, g.c.length - 1), 128);
    e.q = true;
    e.C = $61de1ee1cac498ae$var$BD(e.d.a.ec().Kc().Pb(), 17).d.i;
    return g;
}
function $61de1ee1cac498ae$var$$wd(a) {
    if (a.g == null) switch(a.p){
        case 0:
            a.g = $61de1ee1cac498ae$var$Swd(a) ? ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Acb) : ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb);
            break;
        case 1:
            a.g = $61de1ee1cac498ae$var$Scb($61de1ee1cac498ae$var$Twd(a));
            break;
        case 2:
            a.g = $61de1ee1cac498ae$var$bdb($61de1ee1cac498ae$var$Uwd(a));
            break;
        case 3:
            a.g = $61de1ee1cac498ae$var$Vwd(a);
            break;
        case 4:
            a.g = new $61de1ee1cac498ae$var$Ndb($61de1ee1cac498ae$var$Wwd(a));
            break;
        case 6:
            a.g = $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$Ywd(a));
            break;
        case 5:
            a.g = $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Xwd(a));
            break;
        case 7:
            a.g = $61de1ee1cac498ae$var$Web($61de1ee1cac498ae$var$Zwd(a));
    }
    return a.g;
}
function $61de1ee1cac498ae$var$hxd(a) {
    if (a.n == null) switch(a.p){
        case 0:
            a.n = $61de1ee1cac498ae$var$_wd(a) ? ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Acb) : ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb);
            break;
        case 1:
            a.n = $61de1ee1cac498ae$var$Scb($61de1ee1cac498ae$var$axd(a));
            break;
        case 2:
            a.n = $61de1ee1cac498ae$var$bdb($61de1ee1cac498ae$var$bxd(a));
            break;
        case 3:
            a.n = $61de1ee1cac498ae$var$cxd(a);
            break;
        case 4:
            a.n = new $61de1ee1cac498ae$var$Ndb($61de1ee1cac498ae$var$dxd(a));
            break;
        case 6:
            a.n = $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$fxd(a));
            break;
        case 5:
            a.n = $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$exd(a));
            break;
        case 7:
            a.n = $61de1ee1cac498ae$var$Web($61de1ee1cac498ae$var$gxd(a));
    }
    return a.n;
}
function $61de1ee1cac498ae$var$QDb(a) {
    var b, c, d, e, f, g, h;
    for(f = new $61de1ee1cac498ae$var$olb(a.a.a); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 307);
        d.g = 0;
        d.i = 0;
        d.e.a.$b();
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.a.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 307);
        for(c = d.a.a.ec().Kc(); c.Ob();){
            b = $61de1ee1cac498ae$var$BD(c.Pb(), 57);
            for(h = b.c.Kc(); h.Ob();){
                g = $61de1ee1cac498ae$var$BD(h.Pb(), 57);
                if (g.a != d) {
                    $61de1ee1cac498ae$var$Qqb(d.e, g);
                    ++g.a.g;
                    ++g.a.i;
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$gOb(a, b) {
    var c, d, e, f, g, h;
    h = $61de1ee1cac498ae$var$Axb(a.a, b.b);
    if (!h) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Invalid hitboxes for scanline overlap calculation."));
    g = false;
    for(f = (d = new $61de1ee1cac498ae$var$Ywb(new $61de1ee1cac498ae$var$cxb(new $61de1ee1cac498ae$var$Gjb(a.a.a).a).b), new $61de1ee1cac498ae$var$Njb(d)); $61de1ee1cac498ae$var$sib(f.a.a);){
        e = (c = $61de1ee1cac498ae$var$Wwb(f.a), $61de1ee1cac498ae$var$BD(c.cd(), 65));
        if ($61de1ee1cac498ae$var$bOb(b.b, e)) {
            $61de1ee1cac498ae$var$T$c(a.b.a, b.b, e);
            g = true;
        } else {
            if (g) break;
        }
    }
}
function $61de1ee1cac498ae$var$G5b(a) {
    var b, c, d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fxc)), 21);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ixc), 21);
    c = new $61de1ee1cac498ae$var$f7c(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
    b = new $61de1ee1cac498ae$var$g7c(c);
    if (e.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$pdd))) {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Hxc), 8);
        if (f.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Bdd))) {
            d.a <= 0 && (d.a = 20);
            d.b <= 0 && (d.b = 20);
        }
        b.a = $61de1ee1cac498ae$var$$wnd.Math.max(c.a, d.a);
        b.b = $61de1ee1cac498ae$var$$wnd.Math.max(c.b, d.b);
    }
    $61de1ee1cac498ae$var$H5b(a, c, b);
}
function $61de1ee1cac498ae$var$toc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    e = b ? new $61de1ee1cac498ae$var$Coc : new $61de1ee1cac498ae$var$Eoc;
    f = false;
    do {
        f = false;
        j = b ? $61de1ee1cac498ae$var$Su(a.b) : a.b;
        for(i = j.Kc(); i.Ob();){
            h = $61de1ee1cac498ae$var$BD(i.Pb(), 29);
            m = $61de1ee1cac498ae$var$Mu(h.a);
            b || new $61de1ee1cac498ae$var$ov(m);
            for(l = new $61de1ee1cac498ae$var$olb(m); l.a < l.c.c.length;){
                k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 10);
                if (e.Mb(k)) {
                    d = k;
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$usc)), 305);
                    g = b ? c.b : c.k;
                    f = $61de1ee1cac498ae$var$roc(d, g, b, false);
                }
            }
        }
    }while (f);
}
function $61de1ee1cac498ae$var$WCc(a, b, c) {
    var d, e, f, g, h;
    $61de1ee1cac498ae$var$Odd(c, "Longest path layering", 1);
    a.a = b;
    h = a.a.a;
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, h.c.length, 15, 1);
    d = 0;
    for(g = new $61de1ee1cac498ae$var$olb(h); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        e.p = d;
        a.b[d] = -1;
        ++d;
    }
    for(f = new $61de1ee1cac498ae$var$olb(h); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        $61de1ee1cac498ae$var$YCc(a, e);
    }
    h.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.a = null;
    a.b = null;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$QVb(a, b) {
    var c, d, e;
    b.a ? ($61de1ee1cac498ae$var$Axb(a.b, b.b), a.a[b.b.i] = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Exb(a.b, b.b), 81), c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dxb(a.b, b.b), 81), !!c && (a.a[c.i] = b.b), undefined) : (d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Exb(a.b, b.b), 81), !!d && d == a.a[b.b.i] && !!d.d && d.d != b.b.d && d.f.Fc(b.b), e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dxb(a.b, b.b), 81), !!e && a.a[e.i] == b.b && !!e.d && e.d != b.b.d && b.b.f.Fc(e), $61de1ee1cac498ae$var$Fxb(a.b, b.b), undefined);
}
function $61de1ee1cac498ae$var$zbc(a, b) {
    var c, d, e, f, g, h;
    f = a.d;
    h = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Zwc))));
    if (h < 0) {
        h = 0;
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Zwc, h);
    }
    b.o.b = h;
    g = $61de1ee1cac498ae$var$$wnd.Math.floor(h / 2);
    d = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$G0b(d, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    $61de1ee1cac498ae$var$F0b(d, b);
    d.n.b = g;
    e = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$G0b(e, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$F0b(e, b);
    e.n.b = g;
    $61de1ee1cac498ae$var$RZb(a, d);
    c = new $61de1ee1cac498ae$var$UZb;
    $61de1ee1cac498ae$var$tNb(c, a);
    $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$jxc, null);
    $61de1ee1cac498ae$var$QZb(c, e);
    $61de1ee1cac498ae$var$RZb(c, f);
    $61de1ee1cac498ae$var$ybc(b, a, c);
    $61de1ee1cac498ae$var$wbc(a, c);
    return c;
}
function $61de1ee1cac498ae$var$uNc(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21);
    b = new $61de1ee1cac498ae$var$j3c;
    if (c.Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Irc))) {
        $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$oNc);
        $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$qNc);
    }
    if (c.Hc($61de1ee1cac498ae$var$Krc) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$$wc))))) {
        $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$qNc);
        c.Hc($61de1ee1cac498ae$var$Lrc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$rNc);
    }
    c.Hc($61de1ee1cac498ae$var$Hrc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$nNc);
    c.Hc($61de1ee1cac498ae$var$Nrc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$sNc);
    c.Hc($61de1ee1cac498ae$var$Jrc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$pNc);
    c.Hc($61de1ee1cac498ae$var$Erc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$lNc);
    c.Hc($61de1ee1cac498ae$var$Grc) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$mNc);
    return b;
}
function $61de1ee1cac498ae$var$Ihb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    d = a.d;
    f = b.d;
    h = d + f;
    i = a.e != b.e ? -1 : 1;
    if (h == 2) {
        k = $61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$xbb(a.a[0], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(b.a[0], $61de1ee1cac498ae$var$Yje));
        m = $61de1ee1cac498ae$var$Tbb(k);
        l = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Pbb(k, 32));
        return l == 0 ? new $61de1ee1cac498ae$var$Ugb(i, m) : new $61de1ee1cac498ae$var$Vgb(i, 2, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
            m,
            l
        ]));
    }
    c = a.a;
    e = b.a;
    g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, h, 15, 1);
    $61de1ee1cac498ae$var$Fhb(c, d, e, f, g);
    j = new $61de1ee1cac498ae$var$Vgb(i, h, g);
    $61de1ee1cac498ae$var$Jgb(j);
    return j;
}
function $61de1ee1cac498ae$var$Gwb(a, b, c, d) {
    var e, f;
    if (!b) return c;
    else {
        e = a.a.ue(c.d, b.d);
        if (e == 0) {
            d.d = $61de1ee1cac498ae$var$ijb(b, c.e);
            d.b = true;
            return b;
        }
        f = e < 0 ? 0 : 1;
        b.a[f] = $61de1ee1cac498ae$var$Gwb(a, b.a[f], c, d);
        if ($61de1ee1cac498ae$var$Hwb(b.a[f])) {
            if ($61de1ee1cac498ae$var$Hwb(b.a[1 - f])) {
                b.b = true;
                b.a[0].b = false;
                b.a[1].b = false;
            } else $61de1ee1cac498ae$var$Hwb(b.a[f].a[f]) ? b = $61de1ee1cac498ae$var$Owb(b, 1 - f) : $61de1ee1cac498ae$var$Hwb(b.a[f].a[1 - f]) && (b = $61de1ee1cac498ae$var$Nwb(b, 1 - f));
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$wHb(a, b, c) {
    var d, e, f, g;
    e = a.i;
    d = a.n;
    $61de1ee1cac498ae$var$vHb(a, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$dHb), e.c + d.b, c);
    $61de1ee1cac498ae$var$vHb(a, $61de1ee1cac498ae$var$fHb, e.c + e.b - d.c - c[2], c);
    g = e.b - d.b - d.c;
    if (c[0] > 0) {
        c[0] += a.d;
        g -= c[0];
    }
    if (c[2] > 0) {
        c[2] += a.d;
        g -= c[2];
    }
    f = $61de1ee1cac498ae$var$$wnd.Math.max(0, g);
    c[1] = $61de1ee1cac498ae$var$$wnd.Math.max(c[1], g);
    $61de1ee1cac498ae$var$vHb(a, $61de1ee1cac498ae$var$eHb, e.c + d.b + c[0] - (c[1] - g) / 2, c);
    if (b == $61de1ee1cac498ae$var$eHb) {
        a.c.b = f;
        a.c.c = e.c + d.b + (f - g) / 2;
    }
}
function $61de1ee1cac498ae$var$AYb() {
    this.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])).length, 15, 1);
    this.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ]).length, 15, 1);
    this.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ]).length, 15, 1);
    $61de1ee1cac498ae$var$zlb(this.c, $61de1ee1cac498ae$var$Pje);
    $61de1ee1cac498ae$var$zlb(this.b, $61de1ee1cac498ae$var$Qje);
    $61de1ee1cac498ae$var$zlb(this.a, $61de1ee1cac498ae$var$Qje);
}
function $61de1ee1cac498ae$var$Ufe(a, b, c) {
    var d, e, f, g;
    if (b <= c) {
        e = b;
        f = c;
    } else {
        e = c;
        f = b;
    }
    d = 0;
    if (a.b == null) {
        a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, 2, 15, 1);
        a.b[0] = e;
        a.b[1] = f;
        a.c = true;
    } else {
        d = a.b.length;
        if (a.b[d - 1] + 1 == e) {
            a.b[d - 1] = f;
            return;
        }
        g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, d + 2, 15, 1);
        $61de1ee1cac498ae$var$$fb(a.b, 0, g, 0, d);
        a.b = g;
        a.b[d - 1] >= e && (a.c = false, a.a = false);
        a.b[d++] = e;
        a.b[d] = f;
        a.c || $61de1ee1cac498ae$var$Yfe(a);
    }
}
function $61de1ee1cac498ae$var$inc(a, b, c) {
    var d, e, f, g, h, i, j;
    j = b.d;
    a.a = new $61de1ee1cac498ae$var$Skb(j.c.length);
    a.c = new $61de1ee1cac498ae$var$Lqb;
    for(h = new $61de1ee1cac498ae$var$olb(j); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 101);
        f = new $61de1ee1cac498ae$var$uOc(null);
        $61de1ee1cac498ae$var$Ekb(a.a, f);
        $61de1ee1cac498ae$var$Rhb(a.c, g, f);
    }
    a.b = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$gnc(a, b);
    for(d = 0; d < j.c.length - 1; d++){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.d, d), 101);
        for(e = d + 1; e < j.c.length; e++)$61de1ee1cac498ae$var$jnc(a, i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.d, e), 101), c);
    }
}
function $61de1ee1cac498ae$var$ySc(a, b, c) {
    var d, e, f, g, h, i;
    if (!$61de1ee1cac498ae$var$Qq(b)) {
        i = $61de1ee1cac498ae$var$Udd(c, ($61de1ee1cac498ae$var$JD(b, 14) ? $61de1ee1cac498ae$var$BD(b, 14).gc() : $61de1ee1cac498ae$var$sr(b.Kc())) / a.a | 0);
        $61de1ee1cac498ae$var$Odd(i, $61de1ee1cac498ae$var$Xqe, 1);
        h = new $61de1ee1cac498ae$var$BSc;
        g = 0;
        for(f = b.Kc(); f.Ob();){
            d = $61de1ee1cac498ae$var$BD(f.Pb(), 86);
            h = $61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                h,
                new $61de1ee1cac498ae$var$ZRc(d)
            ]));
            g < d.f.b && (g = d.f.b);
        }
        for(e = b.Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 86);
            $61de1ee1cac498ae$var$yNb(d, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$bTc), g);
        }
        $61de1ee1cac498ae$var$Qdd(i);
        $61de1ee1cac498ae$var$ySc(a, h, c);
    }
}
function $61de1ee1cac498ae$var$bJc(a, b) {
    var c, d, e, f, g, h, i;
    c = $61de1ee1cac498ae$var$Qje;
    h = ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
    for(e = new $61de1ee1cac498ae$var$olb(b.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        f = d.k;
        if (f != $61de1ee1cac498ae$var$h0b) {
            g = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$atc)));
            if (g == null) {
                c = $61de1ee1cac498ae$var$$wnd.Math.max(c, 0);
                d.n.b = c + $61de1ee1cac498ae$var$iBc(a.a, f, h);
            } else d.n.b = ($61de1ee1cac498ae$var$uCb(g), g);
        }
        i = $61de1ee1cac498ae$var$iBc(a.a, f, h);
        d.n.b < c + i + d.d.d && (d.n.b = c + i + d.d.d);
        c = d.n.b + d.o.b + d.d.a;
        h = f;
    }
}
function $61de1ee1cac498ae$var$uQb(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    f = $61de1ee1cac498ae$var$itd(b, false, false);
    j = $61de1ee1cac498ae$var$ofd(f);
    l = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$CPb(), $61de1ee1cac498ae$var$vPb))));
    e = $61de1ee1cac498ae$var$sQb(j, l + a.a);
    k = new $61de1ee1cac498ae$var$XOb(e);
    $61de1ee1cac498ae$var$tNb(k, b);
    $61de1ee1cac498ae$var$Rhb(a.b, b, k);
    c.c[c.c.length] = k;
    i = (!b.n && (b.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, b, 1, 7)), b.n);
    for(h = new $61de1ee1cac498ae$var$Fyd(i); h.e != h.i.gc();){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(h), 137);
        d = $61de1ee1cac498ae$var$wQb(a, g, true, 0, 0);
        c.c[c.c.length] = d;
    }
    return k;
}
function $61de1ee1cac498ae$var$JVc(a, b, c, d, e) {
    var f, g, h, i, j, k;
    !!a.d && a.d.lg(e);
    f = $61de1ee1cac498ae$var$BD(e.Xb(0), 33);
    if ($61de1ee1cac498ae$var$HVc(a, c, f, false)) return true;
    g = $61de1ee1cac498ae$var$BD(e.Xb(e.gc() - 1), 33);
    if ($61de1ee1cac498ae$var$HVc(a, d, g, true)) return true;
    if ($61de1ee1cac498ae$var$CVc(a, e)) return true;
    for(k = e.Kc(); k.Ob();){
        j = $61de1ee1cac498ae$var$BD(k.Pb(), 33);
        for(i = b.Kc(); i.Ob();){
            h = $61de1ee1cac498ae$var$BD(i.Pb(), 33);
            if ($61de1ee1cac498ae$var$BVc(a, j, h)) return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$qid(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    m = b.c.length;
    l = (j = a.Yg(c), $61de1ee1cac498ae$var$BD(j >= 0 ? a._g(j, false, true) : $61de1ee1cac498ae$var$sid(a, c, false), 58));
    n: for(f = l.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 56);
        for(k = 0; k < m; ++k){
            g = ($61de1ee1cac498ae$var$tCb(k, b.c.length), $61de1ee1cac498ae$var$BD(b.c[k], 72));
            i = g.dd();
            h = g.ak();
            d = e.bh(h, false);
            if (i == null ? d != null : !$61de1ee1cac498ae$var$pb(i, d)) continue n;
        }
        return e;
    }
    return null;
}
function $61de1ee1cac498ae$var$V6b(a, b, c, d) {
    var e, f, g, h;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Y_b(b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)).Kc().Pb(), 11);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Y_b(b, $61de1ee1cac498ae$var$zcd).Kc().Pb(), 11);
    for(h = new $61de1ee1cac498ae$var$olb(a.j); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        while(g.e.c.length != 0)$61de1ee1cac498ae$var$RZb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g.e, 0), 17), e);
        while(g.g.c.length != 0)$61de1ee1cac498ae$var$QZb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g.g, 0), 17), f);
    }
    c || $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), null);
    d || $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Wsc), null);
}
function $61de1ee1cac498ae$var$itd(a, b, c) {
    var d, e;
    if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i == 0) return $61de1ee1cac498ae$var$etd(a);
    else {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a), 0), 202);
        if (b) {
            $61de1ee1cac498ae$var$Uxd((!d.a && (d.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, d, 5)), d.a));
            $61de1ee1cac498ae$var$omd(d, 0);
            $61de1ee1cac498ae$var$pmd(d, 0);
            $61de1ee1cac498ae$var$hmd(d, 0);
            $61de1ee1cac498ae$var$imd(d, 0);
        }
        if (c) {
            e = (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a);
            while(e.i > 1)$61de1ee1cac498ae$var$Xxd(e, e.i - 1);
        }
        return d;
    }
}
function $61de1ee1cac498ae$var$Z2b(a, b) {
    var c, d, e, f, g, h, i;
    $61de1ee1cac498ae$var$Odd(b, "Comment post-processing", 1);
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        d = new $61de1ee1cac498ae$var$Rkb;
        for(h = new $61de1ee1cac498ae$var$olb(e.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vtc)), 15);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$tsc), 15);
            if (!!i || !!c) {
                $61de1ee1cac498ae$var$$2b(g, i, c);
                !!i && $61de1ee1cac498ae$var$Gkb(d, i);
                !!c && $61de1ee1cac498ae$var$Gkb(d, c);
            }
        }
        $61de1ee1cac498ae$var$Gkb(e.a, d);
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$Eac(a, b) {
    var c, d, e, f, g, h, i;
    c = new $61de1ee1cac498ae$var$jkb;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        i = true;
        d = 0;
        for(h = new $61de1ee1cac498ae$var$olb(e.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            switch(g.k.g){
                case 4:
                    ++d;
                case 1:
                    $61de1ee1cac498ae$var$Xjb(c, g);
                    break;
                case 0:
                    $61de1ee1cac498ae$var$Gac(g, b);
                default:
                    c.b == c.c || $61de1ee1cac498ae$var$Fac(c, d, i, false, b);
                    i = false;
                    d = 0;
            }
        }
        c.b == c.c || $61de1ee1cac498ae$var$Fac(c, d, i, true, b);
    }
}
function $61de1ee1cac498ae$var$Ebc(a, b) {
    var c, d, e, f, g, h, i;
    e = new $61de1ee1cac498ae$var$Rkb;
    for(c = 0; c <= a.i; c++){
        d = new $61de1ee1cac498ae$var$H1b(b);
        d.p = a.i - c;
        e.c[e.c.length] = d;
    }
    for(h = new $61de1ee1cac498ae$var$olb(a.o); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
        $61de1ee1cac498ae$var$$_b(g, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e, a.i - a.f[g.p]), 29));
    }
    f = new $61de1ee1cac498ae$var$olb(e);
    while(f.a < f.c.c.length){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        i.a.c.length == 0 && $61de1ee1cac498ae$var$nlb(f);
    }
    b.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Gkb(b.b, e);
}
function $61de1ee1cac498ae$var$KHc(a, b) {
    var c, d, e, f, g, h;
    c = 0;
    for(h = new $61de1ee1cac498ae$var$olb(b); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        $61de1ee1cac498ae$var$AHc(a.b, a.d[g.p]);
        for(e = new $61de1ee1cac498ae$var$b1b(g.b); $61de1ee1cac498ae$var$llb(e.a) || $61de1ee1cac498ae$var$llb(e.b);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(e.a) ? $61de1ee1cac498ae$var$mlb(e.a) : $61de1ee1cac498ae$var$mlb(e.b), 17);
            f = $61de1ee1cac498ae$var$aIc(a, g == d.c ? d.d : d.c);
            if (f > a.d[g.p]) {
                c += $61de1ee1cac498ae$var$zHc(a.b, f);
                $61de1ee1cac498ae$var$Wjb(a.a, $61de1ee1cac498ae$var$meb(f));
            }
        }
        while(!$61de1ee1cac498ae$var$akb(a.a))$61de1ee1cac498ae$var$xHc(a.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(a.a), 19).a);
    }
    return c;
}
function $61de1ee1cac498ae$var$o2c(a, b, c) {
    var d, e, f, g;
    f = (!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a).i;
    for(e = new $61de1ee1cac498ae$var$Fyd((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a)); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 33);
        (!d.a && (d.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, d, 10, 11)), d.a).i == 0 || (f += $61de1ee1cac498ae$var$o2c(a, d, false));
    }
    if (c) {
        g = $61de1ee1cac498ae$var$Xod(b);
        while(g){
            f += (!g.a && (g.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, g, 10, 11)), g.a).i;
            g = $61de1ee1cac498ae$var$Xod(g);
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$Xxd(a, b) {
    var c, d, e, f;
    if (a.ej()) {
        d = null;
        e = a.fj();
        a.ij() && (d = a.kj(a.pi(b), null));
        c = a.Zi(4, f = $61de1ee1cac498ae$var$tud(a, b), null, b, e);
        if (a.bj() && f != null) {
            d = a.dj(f, d);
            if (!d) a.$i(c);
            else {
                d.Ei(c);
                d.Fi();
            }
        } else if (!d) a.$i(c);
        else {
            d.Ei(c);
            d.Fi();
        }
        return f;
    } else {
        f = $61de1ee1cac498ae$var$tud(a, b);
        if (a.bj() && f != null) {
            d = a.dj(f, null);
            !!d && d.Fi();
        }
        return f;
    }
}
function $61de1ee1cac498ae$var$UKb(a) {
    var b, c, d, e, f, g, h, i, j, k;
    j = a.a;
    b = new $61de1ee1cac498ae$var$Tqb;
    i = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.d); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 222);
        k = 0;
        $61de1ee1cac498ae$var$ktb(c.b, new $61de1ee1cac498ae$var$XKb);
        for(g = $61de1ee1cac498ae$var$Jsb(c.b, 0); g.b != g.d.c;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 222);
            if (b.a._b(f)) {
                e = c.c;
                h = f.c;
                k < h.d + h.a + j && k + e.a + j > h.d && (k = h.d + h.a + j);
            }
        }
        c.c.d = k;
        b.a.zc(c, b);
        i = $61de1ee1cac498ae$var$$wnd.Math.max(i, c.c.d + c.c.a);
    }
    return i;
}
function $61de1ee1cac498ae$var$Orc() {
    $61de1ee1cac498ae$var$Orc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Frc = new $61de1ee1cac498ae$var$Prc("COMMENTS", 0);
    $61de1ee1cac498ae$var$Hrc = new $61de1ee1cac498ae$var$Prc("EXTERNAL_PORTS", 1);
    $61de1ee1cac498ae$var$Irc = new $61de1ee1cac498ae$var$Prc("HYPEREDGES", 2);
    $61de1ee1cac498ae$var$Jrc = new $61de1ee1cac498ae$var$Prc("HYPERNODES", 3);
    $61de1ee1cac498ae$var$Krc = new $61de1ee1cac498ae$var$Prc("NON_FREE_PORTS", 4);
    $61de1ee1cac498ae$var$Lrc = new $61de1ee1cac498ae$var$Prc("NORTH_SOUTH_PORTS", 5);
    $61de1ee1cac498ae$var$Nrc = new $61de1ee1cac498ae$var$Prc($61de1ee1cac498ae$var$Wne, 6);
    $61de1ee1cac498ae$var$Erc = new $61de1ee1cac498ae$var$Prc("CENTER_LABELS", 7);
    $61de1ee1cac498ae$var$Grc = new $61de1ee1cac498ae$var$Prc("END_LABELS", 8);
    $61de1ee1cac498ae$var$Mrc = new $61de1ee1cac498ae$var$Prc("PARTITIONS", 9);
}
function $61de1ee1cac498ae$var$gVc(a) {
    var b, c, d, e, f;
    e = new $61de1ee1cac498ae$var$Rkb;
    b = new $61de1ee1cac498ae$var$Vqb((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a));
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 79);
        if (!$61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$qud((!c.b && (c.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 4, 7)), c.b), 0), 186)) {
            f = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!c.c && (c.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 5, 8)), c.c), 0), 82));
            b.a._b(f) || (e.c[e.c.length] = f);
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$fVc(a) {
    var b, c, d, e, f, g;
    f = new $61de1ee1cac498ae$var$Tqb;
    b = new $61de1ee1cac498ae$var$Vqb((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a));
    for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 79);
        if (!$61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$qud((!d.b && (d.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 4, 7)), d.b), 0), 186)) {
            g = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c), 0), 82));
            b.a._b(g) || (c = f.a.zc(g, f), c);
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$zA(a, b, c, d, e) {
    if (d < 0) {
        d = $61de1ee1cac498ae$var$oA(a, e, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
            $61de1ee1cac498ae$var$bje,
            $61de1ee1cac498ae$var$cje,
            $61de1ee1cac498ae$var$dje,
            $61de1ee1cac498ae$var$eje,
            $61de1ee1cac498ae$var$fje,
            $61de1ee1cac498ae$var$gje,
            $61de1ee1cac498ae$var$hje,
            $61de1ee1cac498ae$var$ije,
            $61de1ee1cac498ae$var$jje,
            $61de1ee1cac498ae$var$kje,
            $61de1ee1cac498ae$var$lje,
            $61de1ee1cac498ae$var$mje
        ]), b);
        d < 0 && (d = $61de1ee1cac498ae$var$oA(a, e, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            $61de1ee1cac498ae$var$fje,
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]), b));
        if (d < 0) return false;
        c.k = d;
        return true;
    } else if (d > 0) {
        c.k = d - 1;
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$BA(a, b, c, d, e) {
    if (d < 0) {
        d = $61de1ee1cac498ae$var$oA(a, e, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
            $61de1ee1cac498ae$var$bje,
            $61de1ee1cac498ae$var$cje,
            $61de1ee1cac498ae$var$dje,
            $61de1ee1cac498ae$var$eje,
            $61de1ee1cac498ae$var$fje,
            $61de1ee1cac498ae$var$gje,
            $61de1ee1cac498ae$var$hje,
            $61de1ee1cac498ae$var$ije,
            $61de1ee1cac498ae$var$jje,
            $61de1ee1cac498ae$var$kje,
            $61de1ee1cac498ae$var$lje,
            $61de1ee1cac498ae$var$mje
        ]), b);
        d < 0 && (d = $61de1ee1cac498ae$var$oA(a, e, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            $61de1ee1cac498ae$var$fje,
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ]), b));
        if (d < 0) return false;
        c.k = d;
        return true;
    } else if (d > 0) {
        c.k = d - 1;
        return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$DA(a, b, c, d, e, f) {
    var g, h, i, j;
    h = 32;
    if (d < 0) {
        if (b[0] >= a.length) return false;
        h = $61de1ee1cac498ae$var$bfb(a, b[0]);
        if (h != 43 && h != 45) return false;
        ++b[0];
        d = $61de1ee1cac498ae$var$rA(a, b);
        if (d < 0) return false;
        h == 45 && (d = -d);
    }
    if (h == 32 && b[0] - c == 2 && e.b == 2) {
        i = new $61de1ee1cac498ae$var$eB;
        j = i.q.getFullYear() - $61de1ee1cac498ae$var$nje + $61de1ee1cac498ae$var$nje - 80;
        g = j % 100;
        f.a = d == g;
        d += (j / 100 | 0) * 100 + (d < g ? 100 : 0);
    }
    f.p = d;
    return true;
}
function $61de1ee1cac498ae$var$L1b(a, b) {
    var c, d, e, f, g;
    if (!$61de1ee1cac498ae$var$Xod(a)) return;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fxc)), 174);
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$Vxc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$ccd)) && $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$Vxc, $61de1ee1cac498ae$var$bcd);
    d = ($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd($61de1ee1cac498ae$var$Xod(a)));
    f = new $61de1ee1cac498ae$var$hhd(!$61de1ee1cac498ae$var$Xod(a) ? null : new $61de1ee1cac498ae$var$bhd($61de1ee1cac498ae$var$Xod(a)), a);
    e = $61de1ee1cac498ae$var$PGb(d, f, false, true);
    $61de1ee1cac498ae$var$rqb(g, ($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$pdd));
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Hxc), 8);
    c.a = $61de1ee1cac498ae$var$$wnd.Math.max(e.a, c.a);
    c.b = $61de1ee1cac498ae$var$$wnd.Math.max(e.b, c.b);
}
function $61de1ee1cac498ae$var$Pac(a, b, c) {
    var d, e, f, g, h, i;
    for(g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Lsc)), 15).Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 10);
        switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163).g){
            case 2:
                $61de1ee1cac498ae$var$$_b(f, b);
                break;
            case 4:
                $61de1ee1cac498ae$var$$_b(f, c);
        }
        for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(f).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
            if (!!d.c && !!d.d) continue;
            h = !d.d;
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$ctc), 11);
            h ? $61de1ee1cac498ae$var$RZb(d, i) : $61de1ee1cac498ae$var$QZb(d, i);
        }
    }
}
function $61de1ee1cac498ae$var$Alc() {
    $61de1ee1cac498ae$var$Alc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$tlc = new $61de1ee1cac498ae$var$Blc($61de1ee1cac498ae$var$xle, 0, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd), $61de1ee1cac498ae$var$Acd);
    $61de1ee1cac498ae$var$wlc = new $61de1ee1cac498ae$var$Blc($61de1ee1cac498ae$var$zle, 1, $61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$Rcd);
    $61de1ee1cac498ae$var$slc = new $61de1ee1cac498ae$var$Blc($61de1ee1cac498ae$var$yle, 2, $61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$zlc = new $61de1ee1cac498ae$var$Blc($61de1ee1cac498ae$var$Ale, 3, $61de1ee1cac498ae$var$Tcd, $61de1ee1cac498ae$var$Tcd);
    $61de1ee1cac498ae$var$vlc = new $61de1ee1cac498ae$var$Blc("NORTH_WEST_CORNER", 4, $61de1ee1cac498ae$var$Tcd, $61de1ee1cac498ae$var$Acd);
    $61de1ee1cac498ae$var$ulc = new $61de1ee1cac498ae$var$Blc("NORTH_EAST_CORNER", 5, $61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$ylc = new $61de1ee1cac498ae$var$Blc("SOUTH_WEST_CORNER", 6, $61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$Tcd);
    $61de1ee1cac498ae$var$xlc = new $61de1ee1cac498ae$var$Blc("SOUTH_EAST_CORNER", 7, $61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$Rcd);
}
function $61de1ee1cac498ae$var$i6c() {
    $61de1ee1cac498ae$var$i6c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$h6c = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$XD, 1), $61de1ee1cac498ae$var$Sje, 25, 14, [
        1,
        1,
        2,
        6,
        24,
        120,
        720,
        5040,
        40320,
        362880,
        3628800,
        39916800,
        479001600,
        6227020800,
        87178291200,
        1307674368000,
        {
            l: 3506176,
            m: 794077,
            h: 1
        },
        {
            l: 884736,
            m: 916411,
            h: 20
        },
        {
            l: 3342336,
            m: 3912489,
            h: 363
        },
        {
            l: 589824,
            m: 3034138,
            h: 6914
        },
        {
            l: 3407872,
            m: 1962506,
            h: 138294
        }
    ]);
    $61de1ee1cac498ae$var$$wnd.Math.pow(2, -65);
}
function $61de1ee1cac498ae$var$Pcc(a, b) {
    var c, d, e, f, g;
    if (a.c.length == 0) return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(0), $61de1ee1cac498ae$var$meb(0));
    c = ($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 11)).j;
    g = 0;
    f = b.g;
    d = b.g + 1;
    while(g < a.c.length - 1 && c.g < f){
        ++g;
        c = ($61de1ee1cac498ae$var$tCb(g, a.c.length), $61de1ee1cac498ae$var$BD(a.c[g], 11)).j;
    }
    e = g;
    while(e < a.c.length - 1 && c.g < d){
        ++e;
        c = ($61de1ee1cac498ae$var$tCb(g, a.c.length), $61de1ee1cac498ae$var$BD(a.c[g], 11)).j;
    }
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(g), $61de1ee1cac498ae$var$meb(e));
}
function $61de1ee1cac498ae$var$R9b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = b.c.length;
    g = ($61de1ee1cac498ae$var$tCb(c, b.c.length), $61de1ee1cac498ae$var$BD(b.c[c], 286));
    h = g.a.o.a;
    l = g.c;
    m = 0;
    for(j = g.c; j <= g.f; j++){
        if (h <= a.a[j]) return j;
        k = a.a[j];
        i = null;
        for(e = c + 1; e < f; e++){
            d = ($61de1ee1cac498ae$var$tCb(e, b.c.length), $61de1ee1cac498ae$var$BD(b.c[e], 286));
            d.c <= j && d.f >= j && (i = d);
        }
        !!i && (k = $61de1ee1cac498ae$var$$wnd.Math.max(k, i.a.o.a));
        if (k > m) {
            l = j;
            m = k;
        }
    }
    return l;
}
function $61de1ee1cac498ae$var$ode(a, b, c) {
    var d, e, f;
    a.e = c;
    a.d = 0;
    a.b = 0;
    a.f = 1;
    a.i = b;
    (a.e & 16) == 16 && (a.i = $61de1ee1cac498ae$var$Xee(a.i));
    a.j = a.i.length;
    $61de1ee1cac498ae$var$nde(a);
    f = $61de1ee1cac498ae$var$rde(a);
    if (a.d != a.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$sue))));
    if (a.g) {
        for(d = 0; d < a.g.a.c.length; d++){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(a.g, d), 584);
            if (a.f <= e.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$tue))));
        }
        a.g.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    }
    return f;
}
function $61de1ee1cac498ae$var$_Pd(a, b) {
    var c, d, e;
    if (b == null) for(d = (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, a, 9, 5)), new $61de1ee1cac498ae$var$Fyd(a.a)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 678);
        e = c.c;
        if ((e == null ? c.zb : e) == null) return c;
    }
    else for(d = (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, a, 9, 5)), new $61de1ee1cac498ae$var$Fyd(a.a)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 678);
        if ($61de1ee1cac498ae$var$dfb(b, (e = c.c, e == null ? c.zb : e))) return c;
    }
    return null;
}
function $61de1ee1cac498ae$var$KIb(a, b) {
    var c;
    c = null;
    switch(b.g){
        case 1:
            a.e.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$o9c)) && (c = $61de1ee1cac498ae$var$BD(a.e.We($61de1ee1cac498ae$var$o9c), 249));
            break;
        case 3:
            a.e.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$p9c)) && (c = $61de1ee1cac498ae$var$BD(a.e.We($61de1ee1cac498ae$var$p9c), 249));
            break;
        case 2:
            a.e.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$n9c)) && (c = $61de1ee1cac498ae$var$BD(a.e.We($61de1ee1cac498ae$var$n9c), 249));
            break;
        case 4:
            a.e.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$q9c)) && (c = $61de1ee1cac498ae$var$BD(a.e.We($61de1ee1cac498ae$var$q9c), 249));
    }
    !c && (c = $61de1ee1cac498ae$var$BD(a.e.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$l9c)), 249));
    return c;
}
function $61de1ee1cac498ae$var$OCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    b.p = 1;
    f = b.c;
    for(l = $61de1ee1cac498ae$var$W_b(b, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)).Kc(); l.Ob();){
        k = $61de1ee1cac498ae$var$BD(l.Pb(), 11);
        for(e = new $61de1ee1cac498ae$var$olb(k.g); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
            j = d.d.i;
            if (b != j) {
                g = j.c;
                if (g.p <= f.p) {
                    h = f.p + 1;
                    if (h == c.b.c.length) {
                        i = new $61de1ee1cac498ae$var$H1b(c);
                        i.p = h;
                        $61de1ee1cac498ae$var$Ekb(c.b, i);
                        $61de1ee1cac498ae$var$$_b(j, i);
                    } else {
                        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.b, h), 29);
                        $61de1ee1cac498ae$var$$_b(j, i);
                    }
                    $61de1ee1cac498ae$var$OCc(a, j, c);
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$ZXc(a, b, c) {
    var d, e, f, g, h, i;
    e = c;
    f = 0;
    for(h = new $61de1ee1cac498ae$var$olb(b); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 33);
        $61de1ee1cac498ae$var$jkd(g, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$SWc), $61de1ee1cac498ae$var$meb(e++));
        i = $61de1ee1cac498ae$var$gVc(g);
        d = $61de1ee1cac498ae$var$$wnd.Math.atan2(g.j + g.f / 2, g.i + g.g / 2);
        d += d < 0 ? $61de1ee1cac498ae$var$dre : 0;
        d < 0.7853981633974483 || d > $61de1ee1cac498ae$var$vre ? $61de1ee1cac498ae$var$Okb(i, a.b) : d <= $61de1ee1cac498ae$var$vre && d > $61de1ee1cac498ae$var$wre ? $61de1ee1cac498ae$var$Okb(i, a.d) : d <= $61de1ee1cac498ae$var$wre && d > $61de1ee1cac498ae$var$xre ? $61de1ee1cac498ae$var$Okb(i, a.c) : d <= $61de1ee1cac498ae$var$xre && $61de1ee1cac498ae$var$Okb(i, a.a);
        f = $61de1ee1cac498ae$var$ZXc(a, i, f);
    }
    return e;
}
function $61de1ee1cac498ae$var$Hgb() {
    $61de1ee1cac498ae$var$Hgb = $61de1ee1cac498ae$var$ccb;
    var a;
    $61de1ee1cac498ae$var$Cgb = new $61de1ee1cac498ae$var$Ugb(1, 1);
    $61de1ee1cac498ae$var$Egb = new $61de1ee1cac498ae$var$Ugb(1, 10);
    $61de1ee1cac498ae$var$Ggb = new $61de1ee1cac498ae$var$Ugb(0, 0);
    $61de1ee1cac498ae$var$Bgb = new $61de1ee1cac498ae$var$Ugb(-1, 1);
    $61de1ee1cac498ae$var$Dgb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$cJ, 1), $61de1ee1cac498ae$var$nie, 91, 0, [
        $61de1ee1cac498ae$var$Ggb,
        $61de1ee1cac498ae$var$Cgb,
        new $61de1ee1cac498ae$var$Ugb(1, 2),
        new $61de1ee1cac498ae$var$Ugb(1, 3),
        new $61de1ee1cac498ae$var$Ugb(1, 4),
        new $61de1ee1cac498ae$var$Ugb(1, 5),
        new $61de1ee1cac498ae$var$Ugb(1, 6),
        new $61de1ee1cac498ae$var$Ugb(1, 7),
        new $61de1ee1cac498ae$var$Ugb(1, 8),
        new $61de1ee1cac498ae$var$Ugb(1, 9),
        $61de1ee1cac498ae$var$Egb
    ]);
    $61de1ee1cac498ae$var$Fgb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$cJ, $61de1ee1cac498ae$var$nie, 91, 32, 0, 1);
    for(a = 0; a < $61de1ee1cac498ae$var$Fgb.length; a++)$61de1ee1cac498ae$var$Fgb[a] = $61de1ee1cac498ae$var$ghb($61de1ee1cac498ae$var$Nbb(1, a));
}
function $61de1ee1cac498ae$var$B9b(a, b, c, d, e, f) {
    var g, h, i, j;
    h = !$61de1ee1cac498ae$var$WAb($61de1ee1cac498ae$var$JAb(a.Oc(), new $61de1ee1cac498ae$var$Xxb(new $61de1ee1cac498ae$var$F9b))).sd(($61de1ee1cac498ae$var$EAb(), $61de1ee1cac498ae$var$DAb));
    g = a;
    f == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$dad) && (g = $61de1ee1cac498ae$var$JD(g, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(g, 152)) : $61de1ee1cac498ae$var$JD(g, 131) ? $61de1ee1cac498ae$var$BD(g, 131).a : $61de1ee1cac498ae$var$JD(g, 54) ? new $61de1ee1cac498ae$var$ov(g) : new $61de1ee1cac498ae$var$dv(g));
    for(j = g.Kc(); j.Ob();){
        i = $61de1ee1cac498ae$var$BD(j.Pb(), 70);
        i.n.a = b.a;
        h ? i.n.b = b.b + (d.b - i.o.b) / 2 : e ? i.n.b = b.b : i.n.b = b.b + d.b - i.o.b;
        b.a += i.o.a + c;
    }
}
function $61de1ee1cac498ae$var$UOc(a, b, c, d) {
    var e, f, g, h, i, j;
    e = (d.c + d.a) / 2;
    $61de1ee1cac498ae$var$Osb(b.j);
    $61de1ee1cac498ae$var$Dsb(b.j, e);
    $61de1ee1cac498ae$var$Osb(c.e);
    $61de1ee1cac498ae$var$Dsb(c.e, e);
    j = new $61de1ee1cac498ae$var$aPc;
    for(h = new $61de1ee1cac498ae$var$olb(a.f); h.a < h.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 129);
        i = f.a;
        $61de1ee1cac498ae$var$WOc(j, b, i);
        $61de1ee1cac498ae$var$WOc(j, c, i);
    }
    for(g = new $61de1ee1cac498ae$var$olb(a.k); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 129);
        i = f.b;
        $61de1ee1cac498ae$var$WOc(j, b, i);
        $61de1ee1cac498ae$var$WOc(j, c, i);
    }
    j.b += 2;
    j.a += $61de1ee1cac498ae$var$POc(b, a.q);
    j.a += $61de1ee1cac498ae$var$POc(a.q, c);
    return j;
}
function $61de1ee1cac498ae$var$FSc(a, b, c) {
    var d, e, f, g, h;
    if (!$61de1ee1cac498ae$var$Qq(b)) {
        h = $61de1ee1cac498ae$var$Udd(c, ($61de1ee1cac498ae$var$JD(b, 14) ? $61de1ee1cac498ae$var$BD(b, 14).gc() : $61de1ee1cac498ae$var$sr(b.Kc())) / a.a | 0);
        $61de1ee1cac498ae$var$Odd(h, $61de1ee1cac498ae$var$Xqe, 1);
        g = new $61de1ee1cac498ae$var$ISc;
        f = null;
        for(e = b.Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 86);
            g = $61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                g,
                new $61de1ee1cac498ae$var$ZRc(d)
            ]));
            if (f) {
                $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$hTc), d);
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$_Sc, f);
                if ($61de1ee1cac498ae$var$VRc(d) == $61de1ee1cac498ae$var$VRc(f)) {
                    $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$iTc, d);
                    $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$aTc, f);
                }
            }
            f = d;
        }
        $61de1ee1cac498ae$var$Qdd(h);
        $61de1ee1cac498ae$var$FSc(a, g, c);
    }
}
function $61de1ee1cac498ae$var$VHb(a) {
    var b, c, d, e, f, g, h;
    c = a.i;
    b = a.n;
    h = c.d;
    a.f == ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$CIb) ? h += (c.a - a.e.b) / 2 : a.f == $61de1ee1cac498ae$var$BIb && (h += c.a - a.e.b);
    for(e = new $61de1ee1cac498ae$var$olb(a.d); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 181);
        g = d.rf();
        f = new $61de1ee1cac498ae$var$d7c;
        f.b = h;
        h += g.b + a.a;
        switch(a.b.g){
            case 0:
                f.a = c.c + b.b;
                break;
            case 1:
                f.a = c.c + b.b + (c.b - g.a) / 2;
                break;
            case 2:
                f.a = c.c + c.b - b.c - g.a;
        }
        d.tf(f);
    }
}
function $61de1ee1cac498ae$var$XHb(a) {
    var b, c, d, e, f, g, h;
    c = a.i;
    b = a.n;
    h = c.c;
    a.b == ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$KHb) ? h += (c.b - a.e.a) / 2 : a.b == $61de1ee1cac498ae$var$MHb && (h += c.b - a.e.a);
    for(e = new $61de1ee1cac498ae$var$olb(a.d); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 181);
        g = d.rf();
        f = new $61de1ee1cac498ae$var$d7c;
        f.a = h;
        h += g.a + a.a;
        switch(a.f.g){
            case 0:
                f.b = c.d + b.d;
                break;
            case 1:
                f.b = c.d + b.d + (c.a - g.b) / 2;
                break;
            case 2:
                f.b = c.d + c.a - b.a - g.b;
        }
        d.tf(f);
    }
}
function $61de1ee1cac498ae$var$D4b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    k = c.a.c;
    g = c.a.c + c.a.b;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(c.c, b), 459);
    n = f.f;
    o = f.a;
    i = new $61de1ee1cac498ae$var$f7c(k, n);
    l = new $61de1ee1cac498ae$var$f7c(g, o);
    e = k;
    c.p || (e += a.c);
    e += c.F + c.v * a.b;
    j = new $61de1ee1cac498ae$var$f7c(e, n);
    m = new $61de1ee1cac498ae$var$f7c(e, o);
    $61de1ee1cac498ae$var$n7c(b.a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        i,
        j
    ]));
    h = c.d.a.gc() > 1;
    if (h) {
        d = new $61de1ee1cac498ae$var$f7c(e, c.b);
        $61de1ee1cac498ae$var$Dsb(b.a, d);
    }
    $61de1ee1cac498ae$var$n7c(b.a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        m,
        l
    ]));
}
function $61de1ee1cac498ae$var$jdd(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$Rse), "ELK Randomizer"), 'Distributes the nodes randomly on the plane, leading to very obfuscating layouts. Can be useful to demonstrate the power of "real" layout algorithms.'), new $61de1ee1cac498ae$var$mdd)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rse, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$fdd);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rse, $61de1ee1cac498ae$var$wme, 15);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rse, $61de1ee1cac498ae$var$yme, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rse, $61de1ee1cac498ae$var$_le, $61de1ee1cac498ae$var$tme);
}
function $61de1ee1cac498ae$var$hde() {
    $61de1ee1cac498ae$var$hde = $61de1ee1cac498ae$var$ccb;
    var a, b, c, d, e, f;
    $61de1ee1cac498ae$var$fde = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, 255, 15, 1);
    $61de1ee1cac498ae$var$gde = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, 16, 15, 1);
    for(b = 0; b < 255; b++)$61de1ee1cac498ae$var$fde[b] = -1;
    for(c = 57; c >= 48; c--)$61de1ee1cac498ae$var$fde[c] = c - 48 << 24 >> 24;
    for(d = 70; d >= 65; d--)$61de1ee1cac498ae$var$fde[d] = d - 65 + 10 << 24 >> 24;
    for(e = 102; e >= 97; e--)$61de1ee1cac498ae$var$fde[e] = e - 97 + 10 << 24 >> 24;
    for(f = 0; f < 10; f++)$61de1ee1cac498ae$var$gde[f] = 48 + f & $61de1ee1cac498ae$var$aje;
    for(a = 10; a <= 15; a++)$61de1ee1cac498ae$var$gde[a] = 65 + a - 10 & $61de1ee1cac498ae$var$aje;
}
function $61de1ee1cac498ae$var$BVc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    h = b.i - a.g / 2;
    i = c.i - a.g / 2;
    j = b.j - a.g / 2;
    k = c.j - a.g / 2;
    f = b.g + a.g / 2;
    g = c.g + a.g / 2;
    d = b.f + a.g / 2;
    e = c.f + a.g / 2;
    if (h < i + g && i < h && j < k + e && k < j) return true;
    else if (i < h + f && h < i && k < j + d && j < k) return true;
    else if (h < i + g && i < h && j < k && k < j + d) return true;
    else if (i < h + f && h < i && j < k + e && k < j) return true;
    return false;
}
function $61de1ee1cac498ae$var$NTb(a) {
    var b, c, d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fxc)), 21);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ixc), 21);
    c = new $61de1ee1cac498ae$var$f7c(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
    b = new $61de1ee1cac498ae$var$g7c(c);
    if (e.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$pdd))) {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Hxc), 8);
        if (f.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Bdd))) {
            d.a <= 0 && (d.a = 20);
            d.b <= 0 && (d.b = 20);
        }
        b.a = $61de1ee1cac498ae$var$$wnd.Math.max(c.a, d.a);
        b.b = $61de1ee1cac498ae$var$$wnd.Math.max(c.b, d.b);
    }
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Gxc))) || $61de1ee1cac498ae$var$OTb(a, c, b);
}
function $61de1ee1cac498ae$var$NJc(a, b) {
    var c, d, e, f;
    for(f = $61de1ee1cac498ae$var$V_b(b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd)).Kc(); f.Ob();){
        d = $61de1ee1cac498ae$var$BD(f.Pb(), 11);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
        !!c && $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 0), 0.1), a.i[b.p].d), a.i[c.p].a));
    }
    for(e = $61de1ee1cac498ae$var$V_b(b, $61de1ee1cac498ae$var$Acd).Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 11);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
        !!c && $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 0), 0.1), a.i[c.p].d), a.i[b.p].a));
    }
}
function $61de1ee1cac498ae$var$QKd(a) {
    var b, c, d, e, f, g;
    if (!a.c) {
        g = new $61de1ee1cac498ae$var$wNd;
        b = $61de1ee1cac498ae$var$KKd;
        f = b.a.zc(a, b);
        if (f == null) {
            for(d = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$VKd(a)); d.e != d.i.gc();){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 87);
                e = $61de1ee1cac498ae$var$KQd(c);
                $61de1ee1cac498ae$var$JD(e, 88) && $61de1ee1cac498ae$var$ytd(g, $61de1ee1cac498ae$var$QKd($61de1ee1cac498ae$var$BD(e, 26)));
                $61de1ee1cac498ae$var$wtd(g, c);
            }
            b.a.Bc(a);
            b.a.gc() == 0 && undefined;
        }
        $61de1ee1cac498ae$var$tNd(g);
        $61de1ee1cac498ae$var$vud(g);
        a.c = new $61de1ee1cac498ae$var$nNd(($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).o), 15), 18), g.i), g.g);
        $61de1ee1cac498ae$var$$Kd(a).b &= -33;
    }
    return a.c;
}
function $61de1ee1cac498ae$var$eee(a) {
    var b;
    if (a.c != 10) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$uue))));
    b = a.a;
    switch(b){
        case 110:
            b = 10;
            break;
        case 114:
            b = 13;
            break;
        case 116:
            b = 9;
            break;
        case 92:
        case 124:
        case 46:
        case 94:
        case 45:
        case 63:
        case 42:
        case 43:
        case 123:
        case 125:
        case 40:
        case 41:
        case 91:
        case 93:
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
    }
    return b;
}
function $61de1ee1cac498ae$var$qD(a) {
    var b, c, d, e, f;
    if (a.l == 0 && a.m == 0 && a.h == 0) return "0";
    if (a.h == $61de1ee1cac498ae$var$Gje && a.m == 0 && a.l == 0) return "-9223372036854775808";
    if (a.h >> 19 != 0) return "-" + $61de1ee1cac498ae$var$qD($61de1ee1cac498ae$var$hD(a));
    c = a;
    d = "";
    while(!(c.l == 0 && c.m == 0 && c.h == 0)){
        e = $61de1ee1cac498ae$var$RC($61de1ee1cac498ae$var$Jje);
        c = $61de1ee1cac498ae$var$UC(c, e, true);
        b = "" + $61de1ee1cac498ae$var$pD($61de1ee1cac498ae$var$QC);
        if (!(c.l == 0 && c.m == 0 && c.h == 0)) {
            f = 9 - b.length;
            for(; f > 0; f--)b = "0" + b;
        }
        d = b + d;
    }
    return d;
}
function $61de1ee1cac498ae$var$xrb() {
    if (!Object.create || !Object.getOwnPropertyNames) return false;
    var a = "__proto__";
    var b = Object.create(null);
    if (b[a] !== undefined) return false;
    var c = Object.getOwnPropertyNames(b);
    if (c.length != 0) return false;
    b[a] = 42;
    if (b[a] !== 42) return false;
    if (Object.getOwnPropertyNames(b).length == 0) return false;
    return true;
}
function $61de1ee1cac498ae$var$Pgc(a) {
    var b, c, d, e, f, g, h;
    b = false;
    c = 0;
    for(e = new $61de1ee1cac498ae$var$olb(a.d.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        d.p = c++;
        for(g = new $61de1ee1cac498ae$var$olb(d.a); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
            !b && !$61de1ee1cac498ae$var$Qq($61de1ee1cac498ae$var$O_b(f)) && (b = true);
        }
    }
    h = $61de1ee1cac498ae$var$qqb(($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$t1, 1), $61de1ee1cac498ae$var$Kie, 103, 0, [
        $61de1ee1cac498ae$var$aad,
        $61de1ee1cac498ae$var$bad
    ]));
    if (!b) {
        $61de1ee1cac498ae$var$rqb(h, $61de1ee1cac498ae$var$dad);
        $61de1ee1cac498ae$var$rqb(h, $61de1ee1cac498ae$var$_9c);
    }
    a.a = new $61de1ee1cac498ae$var$mDb(h);
    $61de1ee1cac498ae$var$Uhb(a.f);
    $61de1ee1cac498ae$var$Uhb(a.b);
    $61de1ee1cac498ae$var$Uhb(a.e);
    $61de1ee1cac498ae$var$Uhb(a.g);
}
function $61de1ee1cac498ae$var$_Xb(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    d = c.c;
    e = c.d;
    h = $61de1ee1cac498ae$var$A0b(b.c);
    i = $61de1ee1cac498ae$var$A0b(b.d);
    if (d == b.c) {
        h = $61de1ee1cac498ae$var$aYb(a, h, e);
        i = $61de1ee1cac498ae$var$bYb(b.d);
    } else {
        h = $61de1ee1cac498ae$var$bYb(b.c);
        i = $61de1ee1cac498ae$var$aYb(a, i, e);
    }
    j = new $61de1ee1cac498ae$var$t7c(b.a);
    $61de1ee1cac498ae$var$Gsb(j, h, j.a, j.a.a);
    $61de1ee1cac498ae$var$Gsb(j, i, j.c.b, j.c);
    g = b.c == d;
    l = new $61de1ee1cac498ae$var$BYb;
    for(f = 0; f < j.b - 1; ++f){
        k = new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(j, f), 8), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(j, f + 1), 8));
        g && f == 0 || !g && f == j.b - 2 ? l.b = k : $61de1ee1cac498ae$var$Ekb(l.a, k);
    }
    return l;
}
function $61de1ee1cac498ae$var$O$b(a, b) {
    var c, d, e, f;
    f = a.j.g - b.j.g;
    if (f != 0) return f;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Wxc)), 19);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Wxc), 19);
    if (!!c && !!d) {
        e = c.a - d.a;
        if (e != 0) return e;
    }
    switch(a.j.g){
        case 1:
            return $61de1ee1cac498ae$var$Kdb(a.n.a, b.n.a);
        case 2:
            return $61de1ee1cac498ae$var$Kdb(a.n.b, b.n.b);
        case 3:
            return $61de1ee1cac498ae$var$Kdb(b.n.a, a.n.a);
        case 4:
            return $61de1ee1cac498ae$var$Kdb(b.n.b, a.n.b);
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$ine));
    }
}
function $61de1ee1cac498ae$var$G6b(a, b, c, d) {
    var e, f, g, h, i;
    if ($61de1ee1cac498ae$var$sr(($61de1ee1cac498ae$var$D6b(), new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)))) >= a.a) return -1;
    if (!$61de1ee1cac498ae$var$F6b(b, c)) return -1;
    if ($61de1ee1cac498ae$var$Qq($61de1ee1cac498ae$var$BD(d.Kb(b), 20))) return 1;
    e = 0;
    for(g = $61de1ee1cac498ae$var$BD(d.Kb(b), 20).Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 17);
        i = f.c.i == b ? f.d.i : f.c.i;
        h = $61de1ee1cac498ae$var$G6b(a, i, c, d);
        if (h == -1) return -1;
        e = $61de1ee1cac498ae$var$$wnd.Math.max(e, h);
        if (e > a.c - 1) return -1;
    }
    return e + 1;
}
function $61de1ee1cac498ae$var$Btd(a, b) {
    var c, d, e, f, g, h;
    if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(a)) return true;
    if (!$61de1ee1cac498ae$var$JD(b, 15)) return false;
    d = $61de1ee1cac498ae$var$BD(b, 15);
    h = a.gc();
    if (d.gc() != h) return false;
    g = d.Kc();
    if (a.ni()) for(c = 0; c < h; ++c){
        e = a.ki(c);
        f = g.Pb();
        if (e == null ? f != null : !$61de1ee1cac498ae$var$pb(e, f)) return false;
    }
    else for(c = 0; c < h; ++c){
        e = a.ki(c);
        f = g.Pb();
        if ($61de1ee1cac498ae$var$PD(e) !== $61de1ee1cac498ae$var$PD(f)) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$rAd(a, b) {
    var c, d, e, f, g, h;
    if (a.f > 0) {
        a.qj();
        if (b != null) for(f = 0; f < a.d.length; ++f){
            c = a.d[f];
            if (c) {
                d = $61de1ee1cac498ae$var$BD(c.g, 367);
                h = c.i;
                for(g = 0; g < h; ++g){
                    e = d[g];
                    if ($61de1ee1cac498ae$var$pb(b, e.dd())) return true;
                }
            }
        }
        else for(f = 0; f < a.d.length; ++f){
            c = a.d[f];
            if (c) {
                d = $61de1ee1cac498ae$var$BD(c.g, 367);
                h = c.i;
                for(g = 0; g < h; ++g){
                    e = d[g];
                    if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(e.dd())) return true;
                }
            }
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$e6b(a, b, c) {
    var d, e, f, g;
    $61de1ee1cac498ae$var$Odd(c, "Orthogonally routing hierarchical port edges", 1);
    a.a = 0;
    d = $61de1ee1cac498ae$var$h6b(b);
    $61de1ee1cac498ae$var$k6b(b, d);
    $61de1ee1cac498ae$var$j6b(a, b, d);
    $61de1ee1cac498ae$var$f6b(b);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    f = b.b;
    $61de1ee1cac498ae$var$d6b(($61de1ee1cac498ae$var$tCb(0, f.c.length), $61de1ee1cac498ae$var$BD(f.c[0], 29)), e, b);
    $61de1ee1cac498ae$var$d6b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(f, f.c.length - 1), 29), e, b);
    g = b.b;
    $61de1ee1cac498ae$var$b6b(($61de1ee1cac498ae$var$tCb(0, g.c.length), $61de1ee1cac498ae$var$BD(g.c[0], 29)));
    $61de1ee1cac498ae$var$b6b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g, g.c.length - 1), 29));
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$jnd(a) {
    switch(a){
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return a - 48 << 24 >> 24;
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
            return a - 97 + 10 << 24 >> 24;
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
            return a - 65 + 10 << 24 >> 24;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb("Invalid hexadecimal"));
    }
}
function $61de1ee1cac498ae$var$AUc(a, b, c) {
    var d, e, f, g;
    $61de1ee1cac498ae$var$Odd(c, "Processor order nodes", 2);
    a.a = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$HTc))));
    e = new $61de1ee1cac498ae$var$Psb;
    for(g = $61de1ee1cac498ae$var$Jsb(b.b, 0); g.b != g.d.c;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 86);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc)))) && $61de1ee1cac498ae$var$Gsb(e, f, e.c.b, e.c);
    }
    d = ($61de1ee1cac498ae$var$sCb(e.b != 0), $61de1ee1cac498ae$var$BD(e.a.a.c, 86));
    $61de1ee1cac498ae$var$yUc(a, d);
    !c.b && $61de1ee1cac498ae$var$Rdd(c, 1);
    $61de1ee1cac498ae$var$BUc(a, d, 0 - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$bTc)))) / 2, 0);
    !c.b && $61de1ee1cac498ae$var$Rdd(c, 1);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$rFb() {
    $61de1ee1cac498ae$var$rFb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$qFb = new $61de1ee1cac498ae$var$sFb("SPIRAL", 0);
    $61de1ee1cac498ae$var$lFb = new $61de1ee1cac498ae$var$sFb("LINE_BY_LINE", 1);
    $61de1ee1cac498ae$var$mFb = new $61de1ee1cac498ae$var$sFb("MANHATTAN", 2);
    $61de1ee1cac498ae$var$kFb = new $61de1ee1cac498ae$var$sFb("JITTER", 3);
    $61de1ee1cac498ae$var$oFb = new $61de1ee1cac498ae$var$sFb("QUADRANTS_LINE_BY_LINE", 4);
    $61de1ee1cac498ae$var$pFb = new $61de1ee1cac498ae$var$sFb("QUADRANTS_MANHATTAN", 5);
    $61de1ee1cac498ae$var$nFb = new $61de1ee1cac498ae$var$sFb("QUADRANTS_JITTER", 6);
    $61de1ee1cac498ae$var$jFb = new $61de1ee1cac498ae$var$sFb("COMBINE_LINE_BY_LINE_MANHATTAN", 7);
    $61de1ee1cac498ae$var$iFb = new $61de1ee1cac498ae$var$sFb("COMBINE_JITTER_MANHATTAN", 8);
}
function $61de1ee1cac498ae$var$roc(a, b, c, d) {
    var e, f, g, h, i, j;
    i = $61de1ee1cac498ae$var$woc(a, c);
    j = $61de1ee1cac498ae$var$woc(b, c);
    e = false;
    while(!!i && !!j){
        if (d || $61de1ee1cac498ae$var$uoc(i, j, c)) {
            g = $61de1ee1cac498ae$var$woc(i, c);
            h = $61de1ee1cac498ae$var$woc(j, c);
            $61de1ee1cac498ae$var$zoc(b);
            $61de1ee1cac498ae$var$zoc(a);
            f = i.c;
            $61de1ee1cac498ae$var$sbc(i, false);
            $61de1ee1cac498ae$var$sbc(j, false);
            if (c) {
                $61de1ee1cac498ae$var$Z_b(b, j.p, f);
                b.p = j.p;
                $61de1ee1cac498ae$var$Z_b(a, i.p + 1, f);
                a.p = i.p;
            } else {
                $61de1ee1cac498ae$var$Z_b(a, i.p, f);
                a.p = i.p;
                $61de1ee1cac498ae$var$Z_b(b, j.p + 1, f);
                b.p = j.p;
            }
            $61de1ee1cac498ae$var$$_b(i, null);
            $61de1ee1cac498ae$var$$_b(j, null);
            i = g;
            j = h;
            e = true;
        } else break;
    }
    return e;
}
function $61de1ee1cac498ae$var$VDc(a, b, c, d) {
    var e, f, g, h, i;
    e = false;
    f = false;
    for(h = new $61de1ee1cac498ae$var$olb(d.j); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc))) === $61de1ee1cac498ae$var$PD(c) && (g.g.c.length == 0 ? g.e.c.length == 0 || (e = true) : f = true);
    }
    i = 0;
    e && e ^ f ? i = c.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? -a.e[d.c.p][d.p] : b - a.e[d.c.p][d.p] : f && e ^ f ? i = a.e[d.c.p][d.p] + 1 : e && f && (i = c.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? 0 : b / 2);
    return i;
}
function $61de1ee1cac498ae$var$NEd(a, b, c, d, e, f, g, h) {
    var i, j, k;
    i = 0;
    b != null && (i ^= $61de1ee1cac498ae$var$LCb(b.toLowerCase()));
    c != null && (i ^= $61de1ee1cac498ae$var$LCb(c));
    d != null && (i ^= $61de1ee1cac498ae$var$LCb(d));
    g != null && (i ^= $61de1ee1cac498ae$var$LCb(g));
    h != null && (i ^= $61de1ee1cac498ae$var$LCb(h));
    for(j = 0, k = f.length; j < k; j++)i ^= $61de1ee1cac498ae$var$LCb(f[j]);
    a ? i |= 256 : i &= -257;
    e ? i |= 16 : i &= -17;
    this.f = i;
    this.i = b == null ? null : ($61de1ee1cac498ae$var$uCb(b), b);
    this.a = c;
    this.d = d;
    this.j = f;
    this.g = g;
    this.e = h;
}
function $61de1ee1cac498ae$var$X_b(a, b, c) {
    var d, e;
    e = null;
    switch(b.g){
        case 1:
            e = ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$u0b);
            break;
        case 2:
            e = ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$w0b);
    }
    d = null;
    switch(c.g){
        case 1:
            d = ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$v0b);
            break;
        case 2:
            d = ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$t0b);
            break;
        case 3:
            d = ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$x0b);
            break;
        case 4:
            d = ($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$y0b);
    }
    return !!e && !!d ? $61de1ee1cac498ae$var$Nq(a.j, new $61de1ee1cac498ae$var$Yb(new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$_D, 1), $61de1ee1cac498ae$var$Uhe, 169, 0, [
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(e), 169),
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(d), 169)
    ])))) : ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb);
}
function $61de1ee1cac498ae$var$t5b(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Hxc)), 8);
    $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Hxc, new $61de1ee1cac498ae$var$f7c(b.b, b.a));
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$mwc), 248).g){
        case 1:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$E7c));
            break;
        case 2:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$A7c));
            break;
        case 3:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$C7c));
            break;
        case 4:
            $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$D7c));
    }
    if ((!a.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : a.q)._b($61de1ee1cac498ae$var$ayc)) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ayc), 8);
        d = c.a;
        c.a = c.b;
        c.b = d;
    }
}
function $61de1ee1cac498ae$var$jjc(a, b, c, d, e, f) {
    this.b = c;
    this.d = e;
    if (a >= b.length) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb("Greedy SwitchDecider: Free layer not in graph."));
    this.c = b[a];
    this.e = new $61de1ee1cac498ae$var$dIc(d);
    $61de1ee1cac498ae$var$THc(this.e, this.c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    this.i = new $61de1ee1cac498ae$var$dIc(d);
    $61de1ee1cac498ae$var$THc(this.i, this.c, $61de1ee1cac498ae$var$zcd);
    this.f = new $61de1ee1cac498ae$var$ejc(this.c);
    this.a = !f && e.i && !e.s && this.c[0].k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b);
    this.a && $61de1ee1cac498ae$var$hjc(this, a, b.length);
}
function $61de1ee1cac498ae$var$hKb(a, b) {
    var c, d, e, f, g, h;
    f = !a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$zdd));
    g = a.B.Hc($61de1ee1cac498ae$var$Cdd);
    a.a = new $61de1ee1cac498ae$var$FHb(g, f, a.c);
    !!a.n && $61de1ee1cac498ae$var$u_b(a.a.n, a.n);
    $61de1ee1cac498ae$var$lIb(a.g, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$eHb), a.a);
    if (!b) {
        d = new $61de1ee1cac498ae$var$mIb(1, f, a.c);
        d.n.a = a.k;
        $61de1ee1cac498ae$var$Npb(a.p, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd), d);
        e = new $61de1ee1cac498ae$var$mIb(1, f, a.c);
        e.n.d = a.k;
        $61de1ee1cac498ae$var$Npb(a.p, $61de1ee1cac498ae$var$Rcd, e);
        h = new $61de1ee1cac498ae$var$mIb(0, f, a.c);
        h.n.c = a.k;
        $61de1ee1cac498ae$var$Npb(a.p, $61de1ee1cac498ae$var$Tcd, h);
        c = new $61de1ee1cac498ae$var$mIb(0, f, a.c);
        c.n.b = a.k;
        $61de1ee1cac498ae$var$Npb(a.p, $61de1ee1cac498ae$var$zcd, c);
    }
}
function $61de1ee1cac498ae$var$Vgc(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Swc)), 218);
    switch(b.g){
        case 2:
            c = $61de1ee1cac498ae$var$Ngc(a);
            break;
        case 3:
            c = (d = new $61de1ee1cac498ae$var$Rkb, $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$LAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.d.b, 16)), new $61de1ee1cac498ae$var$Shc), new $61de1ee1cac498ae$var$Uhc), new $61de1ee1cac498ae$var$Whc), new $61de1ee1cac498ae$var$ehc), new $61de1ee1cac498ae$var$Yhc(d)), d);
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Compaction not supported for " + b + " edges."));
    }
    $61de1ee1cac498ae$var$Ugc(a, c);
    $61de1ee1cac498ae$var$reb(new $61de1ee1cac498ae$var$Pib(a.g), new $61de1ee1cac498ae$var$Ehc(a));
}
function $61de1ee1cac498ae$var$a2c(a, b) {
    var c;
    c = new $61de1ee1cac498ae$var$zNb;
    !!b && $61de1ee1cac498ae$var$tNb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$C2), 94));
    $61de1ee1cac498ae$var$JD(b, 470) && $61de1ee1cac498ae$var$tNb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$G2), 94));
    if ($61de1ee1cac498ae$var$JD(b, 354)) {
        $61de1ee1cac498ae$var$tNb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$D2), 94));
        return c;
    }
    $61de1ee1cac498ae$var$JD(b, 82) && $61de1ee1cac498ae$var$tNb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$z2), 94));
    if ($61de1ee1cac498ae$var$JD(b, 239)) {
        $61de1ee1cac498ae$var$tNb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$E2), 94));
        return c;
    }
    if ($61de1ee1cac498ae$var$JD(b, 186)) {
        $61de1ee1cac498ae$var$tNb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$F2), 94));
        return c;
    }
    $61de1ee1cac498ae$var$JD(b, 352) && $61de1ee1cac498ae$var$tNb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$B2), 94));
    return c;
}
function $61de1ee1cac498ae$var$wSb() {
    $61de1ee1cac498ae$var$wSb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$oSb = new $61de1ee1cac498ae$var$Osd(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$D9c), $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$uSb = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$T9c, 80);
    $61de1ee1cac498ae$var$tSb = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$M9c, 5);
    $61de1ee1cac498ae$var$bSb = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$r8c, $61de1ee1cac498ae$var$tme);
    $61de1ee1cac498ae$var$pSb = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$E9c, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$sSb = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$H9c, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$lSb = new $61de1ee1cac498ae$var$q0b(50);
    $61de1ee1cac498ae$var$kSb = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$f9c, $61de1ee1cac498ae$var$lSb);
    $61de1ee1cac498ae$var$dSb = $61de1ee1cac498ae$var$O8c;
    $61de1ee1cac498ae$var$mSb = $61de1ee1cac498ae$var$t9c;
    $61de1ee1cac498ae$var$cSb = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$B8c, false);
    $61de1ee1cac498ae$var$jSb = $61de1ee1cac498ae$var$e9c;
    $61de1ee1cac498ae$var$iSb = $61de1ee1cac498ae$var$b9c;
    $61de1ee1cac498ae$var$hSb = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$gSb = $61de1ee1cac498ae$var$W8c;
    $61de1ee1cac498ae$var$nSb = $61de1ee1cac498ae$var$x9c;
    $61de1ee1cac498ae$var$fSb = ($61de1ee1cac498ae$var$SRb(), $61de1ee1cac498ae$var$LRb);
    $61de1ee1cac498ae$var$vSb = $61de1ee1cac498ae$var$QRb;
    $61de1ee1cac498ae$var$eSb = $61de1ee1cac498ae$var$KRb;
    $61de1ee1cac498ae$var$qSb = $61de1ee1cac498ae$var$NRb;
    $61de1ee1cac498ae$var$rSb = $61de1ee1cac498ae$var$PRb;
}
function $61de1ee1cac498ae$var$ZXb(a) {
    var b, c, d, e, f, g, h, i;
    i = new $61de1ee1cac498ae$var$jYb;
    for(h = new $61de1ee1cac498ae$var$olb(a.a); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
        if (g.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) continue;
        $61de1ee1cac498ae$var$XXb(i, g, new $61de1ee1cac498ae$var$d7c);
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            if (e.c.i.k == $61de1ee1cac498ae$var$e0b || e.d.i.k == $61de1ee1cac498ae$var$e0b) continue;
            for(d = $61de1ee1cac498ae$var$Jsb(e.a, 0); d.b != d.d.c;){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
                b = c;
                $61de1ee1cac498ae$var$hYb(i, new $61de1ee1cac498ae$var$cWb(b.a, b.b));
            }
        }
    }
    return i;
}
function $61de1ee1cac498ae$var$A0c() {
    $61de1ee1cac498ae$var$A0c = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$z0c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Qre);
    $61de1ee1cac498ae$var$y0c = ($61de1ee1cac498ae$var$R0c(), $61de1ee1cac498ae$var$Q0c);
    $61de1ee1cac498ae$var$x0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Vre, $61de1ee1cac498ae$var$y0c);
    $61de1ee1cac498ae$var$w0c = ($61de1ee1cac498ae$var$a1c(), $61de1ee1cac498ae$var$_0c);
    $61de1ee1cac498ae$var$v0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Rre, $61de1ee1cac498ae$var$w0c);
    $61de1ee1cac498ae$var$u0c = ($61de1ee1cac498ae$var$N_c(), $61de1ee1cac498ae$var$J_c);
    $61de1ee1cac498ae$var$t0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Sre, $61de1ee1cac498ae$var$u0c);
    $61de1ee1cac498ae$var$p0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Tre, null);
    $61de1ee1cac498ae$var$s0c = ($61de1ee1cac498ae$var$C_c(), $61de1ee1cac498ae$var$A_c);
    $61de1ee1cac498ae$var$r0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ure, $61de1ee1cac498ae$var$s0c);
    $61de1ee1cac498ae$var$l0c = ($61de1ee1cac498ae$var$i_c(), $61de1ee1cac498ae$var$h_c);
    $61de1ee1cac498ae$var$k0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Wre, $61de1ee1cac498ae$var$l0c);
    $61de1ee1cac498ae$var$m0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Xre, ($61de1ee1cac498ae$var$Bcb(), false));
    $61de1ee1cac498ae$var$n0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Yre, $61de1ee1cac498ae$var$meb(64));
    $61de1ee1cac498ae$var$o0c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Zre, true);
    $61de1ee1cac498ae$var$q0c = $61de1ee1cac498ae$var$B_c;
}
function $61de1ee1cac498ae$var$Toc(a) {
    var b, c, d, e, f, g;
    if (a.a != null) return;
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, a.c.b.c.length, 16, 1);
    a.a[0] = false;
    if ($61de1ee1cac498ae$var$wNb(a.c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lyc))) {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.c, $61de1ee1cac498ae$var$Lyc), 15);
        for(c = d.Kc(); c.Ob();){
            b = $61de1ee1cac498ae$var$BD(c.Pb(), 19).a;
            b > 0 && b < a.a.length && (a.a[b] = false);
        }
    } else {
        g = new $61de1ee1cac498ae$var$olb(a.c.b);
        g.a < g.c.c.length && $61de1ee1cac498ae$var$mlb(g);
        e = 1;
        while(g.a < g.c.c.length){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
            a.a[e++] = $61de1ee1cac498ae$var$Woc(f);
        }
    }
}
function $61de1ee1cac498ae$var$TMd(a, b) {
    var c, d, e, f;
    e = a.b;
    switch(b){
        case 1:
            a.b |= 1;
            a.b |= 4;
            a.b |= 8;
            break;
        case 2:
            a.b |= 2;
            a.b |= 4;
            a.b |= 8;
            break;
        case 4:
            a.b |= 1;
            a.b |= 2;
            a.b |= 4;
            a.b |= 8;
            break;
        case 3:
            a.b |= 16;
            a.b |= 8;
            break;
        case 0:
            a.b |= 32;
            a.b |= 16;
            a.b |= 8;
            a.b |= 1;
            a.b |= 2;
            a.b |= 4;
            break;
    }
    if (a.b != e && !!a.c) for(d = new $61de1ee1cac498ae$var$Fyd(a.c); d.e != d.i.gc();){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 473);
        c = $61de1ee1cac498ae$var$$Kd(f);
        $61de1ee1cac498ae$var$XMd(c, b);
    }
}
function $61de1ee1cac498ae$var$cGc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    e = false;
    for(g = b, h = 0, i = g.length; h < i; ++h){
        f = g[h];
        $61de1ee1cac498ae$var$Ccb(($61de1ee1cac498ae$var$Bcb(), f.e ? true : false)) && !$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, f.e.p), 214).s && (e = e | (j = f.e, k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, j.p), 214), l = k.e, m = $61de1ee1cac498ae$var$SFc(c, l.length), n = l[m][0], n.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) ? l[m] = $61de1ee1cac498ae$var$aGc(f, l[m], c ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) : ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)) : k.c.Tf(l, c), o = $61de1ee1cac498ae$var$dGc(a, k, c, d), $61de1ee1cac498ae$var$bGc(k.e, k.o, c), o));
    }
    return e;
}
function $61de1ee1cac498ae$var$p2c(a, b) {
    var c, d, e, f, g;
    f = (!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a).i;
    for(e = new $61de1ee1cac498ae$var$Fyd((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a)); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 33);
        if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(d, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$J8c))) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$gbd))) {
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$F9c), 149);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$F9c), 149);
            (g == c || !!g && $61de1ee1cac498ae$var$C3c(g, c)) && (!d.a && (d.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, d, 10, 11)), d.a).i != 0 && (f += $61de1ee1cac498ae$var$p2c(a, d));
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$nlc(a) {
    var b, c, d, e, f, g, h;
    d = 0;
    h = 0;
    for(g = new $61de1ee1cac498ae$var$olb(a.d); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 101);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(f.j, 16)), new $61de1ee1cac498ae$var$Ylc), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
            ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
        ]))), 15);
        c = null;
        if (d <= h) {
            c = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd);
            d += e.gc();
        } else if (h < d) {
            c = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd);
            h += e.gc();
        }
        b = c;
        $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb(e.Oc(), new $61de1ee1cac498ae$var$Mlc), new $61de1ee1cac498ae$var$Olc(b));
    }
}
function $61de1ee1cac498ae$var$mkc(a) {
    var b, c, d, e, f, g, h, i;
    a.b = new $61de1ee1cac498ae$var$_i(new $61de1ee1cac498ae$var$amb(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ]))), new $61de1ee1cac498ae$var$amb(($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$vV, 1), $61de1ee1cac498ae$var$Kie, 361, 0, [
        $61de1ee1cac498ae$var$Ekc,
        $61de1ee1cac498ae$var$Dkc,
        $61de1ee1cac498ae$var$Ckc
    ]))));
    for(g = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ]), h = 0, i = g.length; h < i; ++h){
        f = g[h];
        for(c = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$vV, 1), $61de1ee1cac498ae$var$Kie, 361, 0, [
            $61de1ee1cac498ae$var$Ekc,
            $61de1ee1cac498ae$var$Dkc,
            $61de1ee1cac498ae$var$Ckc
        ]), d = 0, e = c.length; d < e; ++d){
            b = c[d];
            $61de1ee1cac498ae$var$Ui(a.b, f, b, new $61de1ee1cac498ae$var$Rkb);
        }
    }
}
function $61de1ee1cac498ae$var$KJb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    h = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$pcd));
    c = a.u.Hc($61de1ee1cac498ae$var$mcd);
    d = a.u.Hc($61de1ee1cac498ae$var$lcd);
    j = a.u.Hc($61de1ee1cac498ae$var$qcd);
    l = a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Hdd));
    k = !c && !d && (j || g.gc() == 2);
    $61de1ee1cac498ae$var$HJb(a, b);
    e = null;
    i = null;
    if (h) {
        f = g.Kc();
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        i = e;
        while(f.Ob())i = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        e.d.b = 0;
        i.d.c = 0;
        k && !e.a && (e.d.c = 0);
    }
    if (l) {
        $61de1ee1cac498ae$var$LJb(g);
        if (h) {
            e.d.b = 0;
            i.d.c = 0;
        }
    }
}
function $61de1ee1cac498ae$var$SKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    h = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$pcd));
    c = a.u.Hc($61de1ee1cac498ae$var$mcd);
    d = a.u.Hc($61de1ee1cac498ae$var$lcd);
    i = a.u.Hc($61de1ee1cac498ae$var$qcd);
    l = a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Hdd));
    j = !c && !d && (i || g.gc() == 2);
    $61de1ee1cac498ae$var$QKb(a, b);
    k = null;
    e = null;
    if (h) {
        f = g.Kc();
        k = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        e = k;
        while(f.Ob())e = $61de1ee1cac498ae$var$BD(f.Pb(), 111);
        k.d.d = 0;
        e.d.a = 0;
        j && !k.a && (k.d.a = 0);
    }
    if (l) {
        $61de1ee1cac498ae$var$TKb(g);
        if (h) {
            k.d.d = 0;
            e.d.a = 0;
        }
    }
}
function $61de1ee1cac498ae$var$oJc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    e = b.k;
    if (b.p >= 0) return false;
    else {
        b.p = c.b;
        $61de1ee1cac498ae$var$Ekb(c.e, b);
    }
    if (e == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) || e == $61de1ee1cac498ae$var$i0b) for(g = new $61de1ee1cac498ae$var$olb(b.j); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 11);
        for(k = (d = new $61de1ee1cac498ae$var$olb(new $61de1ee1cac498ae$var$R0b(f).a.g), new $61de1ee1cac498ae$var$U0b(d)); $61de1ee1cac498ae$var$llb(k.a);){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k.a), 17).d;
            h = j.i;
            i = h.k;
            if (b.c != h.c) {
                if (i == $61de1ee1cac498ae$var$g0b || i == $61de1ee1cac498ae$var$i0b) {
                    if ($61de1ee1cac498ae$var$oJc(a, h, c)) return true;
                }
            }
        }
    }
    return true;
}
function $61de1ee1cac498ae$var$gJd(a) {
    var b;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$EId(a);
    b = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$EId(a));
    b.a += " (changeable: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & $61de1ee1cac498ae$var$zte) != 0);
    b.a += ", volatile: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & $61de1ee1cac498ae$var$Dve) != 0);
    b.a += ", transient: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & $61de1ee1cac498ae$var$Rje) != 0);
    b.a += ", defaultValueLiteral: ";
    $61de1ee1cac498ae$var$Efb(b, a.j);
    b.a += ", unsettable: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & $61de1ee1cac498ae$var$Cve) != 0);
    b.a += ", derived: ";
    $61de1ee1cac498ae$var$Ffb(b, (a.Bb & $61de1ee1cac498ae$var$oie) != 0);
    b.a += ")";
    return b.a;
}
function $61de1ee1cac498ae$var$AOb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    e = $61de1ee1cac498ae$var$eNb(a.d);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.b, ($61de1ee1cac498ae$var$CPb(), $61de1ee1cac498ae$var$wPb)), 116);
    h = g.b + g.c;
    i = g.d + g.a;
    k = e.d.a * a.e + h;
    j = e.b.a * a.f + i;
    $61de1ee1cac498ae$var$$Ob(a.b, new $61de1ee1cac498ae$var$f7c(k, j));
    for(m = new $61de1ee1cac498ae$var$olb(a.g); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 562);
        b = l.g - e.a.a;
        c = l.i - e.c.a;
        d = $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$Z6c(new $61de1ee1cac498ae$var$f7c(b, c), l.a, l.b), $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$b7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$HOb(l.e)), l.d * l.a, l.c * l.b), -0.5));
        f = $61de1ee1cac498ae$var$IOb(l.e);
        $61de1ee1cac498ae$var$KOb(l.e, $61de1ee1cac498ae$var$c7c(d, f));
    }
}
function $61de1ee1cac498ae$var$tmc(a, b, c, d) {
    var e, f, g, h, i;
    i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$nie, 104, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])).length, 0, 2);
    for(f = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Scd,
        $61de1ee1cac498ae$var$Acd,
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ]), g = 0, h = f.length; g < h; ++g){
        e = f[g];
        i[e.g] = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, a.c[e.g], 15, 1);
    }
    $61de1ee1cac498ae$var$vmc(i, a, $61de1ee1cac498ae$var$Acd);
    $61de1ee1cac498ae$var$vmc(i, a, $61de1ee1cac498ae$var$Rcd);
    $61de1ee1cac498ae$var$smc(i, a, $61de1ee1cac498ae$var$Acd, b, c, d);
    $61de1ee1cac498ae$var$smc(i, a, $61de1ee1cac498ae$var$zcd, b, c, d);
    $61de1ee1cac498ae$var$smc(i, a, $61de1ee1cac498ae$var$Rcd, b, c, d);
    $61de1ee1cac498ae$var$smc(i, a, $61de1ee1cac498ae$var$Tcd, b, c, d);
    return i;
}
function $61de1ee1cac498ae$var$UGc(a, b, c) {
    if ($61de1ee1cac498ae$var$Mhb(a.a, b)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, b), 53), c)) return 1;
    } else $61de1ee1cac498ae$var$Rhb(a.a, b, new $61de1ee1cac498ae$var$Tqb);
    if ($61de1ee1cac498ae$var$Mhb(a.a, c)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, c), 53), b)) return -1;
    } else $61de1ee1cac498ae$var$Rhb(a.a, c, new $61de1ee1cac498ae$var$Tqb);
    if ($61de1ee1cac498ae$var$Mhb(a.b, b)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 53), c)) return -1;
    } else $61de1ee1cac498ae$var$Rhb(a.b, b, new $61de1ee1cac498ae$var$Tqb);
    if ($61de1ee1cac498ae$var$Mhb(a.b, c)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, c), 53), b)) return 1;
    } else $61de1ee1cac498ae$var$Rhb(a.b, c, new $61de1ee1cac498ae$var$Tqb);
    return 0;
}
function $61de1ee1cac498ae$var$x2d(a, b, c, d) {
    var e, f, g, h, i, j;
    if (c == null) {
        e = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(h = 0; h < a.i; ++h){
            g = e[h];
            if (g.ak() == b) return $61de1ee1cac498ae$var$Txd(a, g, d);
        }
    }
    f = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? $61de1ee1cac498ae$var$BD(c, 72) : $61de1ee1cac498ae$var$R6d(b, c));
    if ($61de1ee1cac498ae$var$oid(a.e)) {
        j = !$61de1ee1cac498ae$var$R2d(a, b);
        d = $61de1ee1cac498ae$var$Sxd(a, f, d);
        i = b.$j() ? $61de1ee1cac498ae$var$H2d(a, 3, b, null, c, $61de1ee1cac498ae$var$M2d(a, b, c, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0), j) : $61de1ee1cac498ae$var$H2d(a, 1, b, b.zj(), c, -1, j);
        d ? d.Ei(i) : d = i;
    } else d = $61de1ee1cac498ae$var$Sxd(a, f, d);
    return d;
}
function $61de1ee1cac498ae$var$CJb(a) {
    var b, c, d, e, f, g;
    if (a.q == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$_bd) || a.q == $61de1ee1cac498ae$var$$bd) return;
    e = a.f.n.d + $61de1ee1cac498ae$var$_Gb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)), 124)) + a.c;
    b = a.f.n.a + $61de1ee1cac498ae$var$_Gb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Rcd), 124)) + a.c;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$zcd), 124);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Tcd), 124);
    f = $61de1ee1cac498ae$var$$wnd.Math.max(0, d.n.d - e);
    f = $61de1ee1cac498ae$var$$wnd.Math.max(f, g.n.d - e);
    c = $61de1ee1cac498ae$var$$wnd.Math.max(0, d.n.a - b);
    c = $61de1ee1cac498ae$var$$wnd.Math.max(c, g.n.a - b);
    d.n.d = f;
    g.n.d = f;
    d.n.a = c;
    g.n.a = c;
}
function $61de1ee1cac498ae$var$rdc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    $61de1ee1cac498ae$var$Odd(b, "Restoring reversed edges", 1);
    for(i = new $61de1ee1cac498ae$var$olb(a.b); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 29);
        for(k = new $61de1ee1cac498ae$var$olb(h.a); k.a < k.c.c.length;){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
            for(m = new $61de1ee1cac498ae$var$olb(j.j); m.a < m.c.c.length;){
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 11);
                g = $61de1ee1cac498ae$var$k_b(l.g);
                for(d = g, e = 0, f = d.length; e < f; ++e){
                    c = d[e];
                    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc)))) && $61de1ee1cac498ae$var$PZb(c, false);
                }
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$m4c() {
    this.b = new $61de1ee1cac498ae$var$$rb;
    this.d = new $61de1ee1cac498ae$var$$rb;
    this.e = new $61de1ee1cac498ae$var$$rb;
    this.c = new $61de1ee1cac498ae$var$$rb;
    this.a = new $61de1ee1cac498ae$var$Lqb;
    this.f = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$m1, new $61de1ee1cac498ae$var$x4c, new $61de1ee1cac498ae$var$z4c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$l1, new $61de1ee1cac498ae$var$V4c, new $61de1ee1cac498ae$var$X4c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$i1, new $61de1ee1cac498ae$var$Z4c, new $61de1ee1cac498ae$var$_4c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$j1, new $61de1ee1cac498ae$var$b5c, new $61de1ee1cac498ae$var$d5c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$i2, new $61de1ee1cac498ae$var$f5c, new $61de1ee1cac498ae$var$h5c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$DJ, new $61de1ee1cac498ae$var$B4c, new $61de1ee1cac498ae$var$D4c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$xK, new $61de1ee1cac498ae$var$F4c, new $61de1ee1cac498ae$var$H4c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$jK, new $61de1ee1cac498ae$var$J4c, new $61de1ee1cac498ae$var$L4c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$uK, new $61de1ee1cac498ae$var$N4c, new $61de1ee1cac498ae$var$P4c);
    $61de1ee1cac498ae$var$hvd($61de1ee1cac498ae$var$kL, new $61de1ee1cac498ae$var$R4c, new $61de1ee1cac498ae$var$T4c);
}
function $61de1ee1cac498ae$var$R5d(a) {
    var b, c, d, e, f, g;
    f = 0;
    b = $61de1ee1cac498ae$var$wId(a);
    !!b.Bj() && (f |= 4);
    (a.Bb & $61de1ee1cac498ae$var$Cve) != 0 && (f |= 2);
    if ($61de1ee1cac498ae$var$JD(a, 99)) {
        c = $61de1ee1cac498ae$var$BD(a, 18);
        e = $61de1ee1cac498ae$var$zUd(c);
        (c.Bb & $61de1ee1cac498ae$var$ote) != 0 && (f |= 32);
        if (e) {
            $61de1ee1cac498ae$var$aLd($61de1ee1cac498ae$var$WId(e));
            f |= 8;
            g = e.t;
            (g > 1 || g == -1) && (f |= 16);
            (e.Bb & $61de1ee1cac498ae$var$ote) != 0 && (f |= 64);
        }
        (c.Bb & $61de1ee1cac498ae$var$Tje) != 0 && (f |= $61de1ee1cac498ae$var$Dve);
        f |= $61de1ee1cac498ae$var$zte;
    } else if ($61de1ee1cac498ae$var$JD(b, 457)) f |= 512;
    else {
        d = b.Bj();
        !!d && (d.i & 1) != 0 && (f |= 256);
    }
    (a.Bb & 512) != 0 && (f |= 128);
    return f;
}
function $61de1ee1cac498ae$var$hc(a, b) {
    var c, d, e, f, g;
    a = a == null ? $61de1ee1cac498ae$var$Xhe : ($61de1ee1cac498ae$var$uCb(a), a);
    for(e = 0; e < b.length; e++)b[e] = $61de1ee1cac498ae$var$ic(b[e]);
    c = new $61de1ee1cac498ae$var$Vfb;
    g = 0;
    d = 0;
    while(d < b.length){
        f = a.indexOf("%s", g);
        if (f == -1) break;
        c.a += "" + $61de1ee1cac498ae$var$qfb(a == null ? $61de1ee1cac498ae$var$Xhe : ($61de1ee1cac498ae$var$uCb(a), a), g, f);
        $61de1ee1cac498ae$var$Pfb(c, b[d++]);
        g = f + 2;
    }
    $61de1ee1cac498ae$var$Ofb(c, a, g, a.length);
    if (d < b.length) {
        c.a += " [";
        $61de1ee1cac498ae$var$Pfb(c, b[d++]);
        while(d < b.length){
            c.a += $61de1ee1cac498ae$var$She;
            $61de1ee1cac498ae$var$Pfb(c, b[d++]);
        }
        c.a += "]";
    }
    return c.a;
}
function $61de1ee1cac498ae$var$m3b(a) {
    var b, c, d, e, f;
    f = new $61de1ee1cac498ae$var$Skb(a.a.c.length);
    for(e = new $61de1ee1cac498ae$var$olb(a.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163);
        b = null;
        switch(c.g){
            case 1:
            case 2:
                b = ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Fqc);
                break;
            case 3:
            case 4:
                b = ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Dqc);
        }
        if (b) {
            $61de1ee1cac498ae$var$yNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Bsc), ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Fqc));
            b == $61de1ee1cac498ae$var$Dqc ? $61de1ee1cac498ae$var$o3b(d, c, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc)) : b == $61de1ee1cac498ae$var$Fqc && $61de1ee1cac498ae$var$o3b(d, c, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc));
        } else f.c[f.c.length] = d;
    }
    return f;
}
function $61de1ee1cac498ae$var$MHc(a, b) {
    var c, d, e, f, g, h, i;
    c = 0;
    for(i = new $61de1ee1cac498ae$var$olb(b); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 11);
        $61de1ee1cac498ae$var$AHc(a.b, a.d[h.p]);
        g = 0;
        for(e = new $61de1ee1cac498ae$var$b1b(h.b); $61de1ee1cac498ae$var$llb(e.a) || $61de1ee1cac498ae$var$llb(e.b);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(e.a) ? $61de1ee1cac498ae$var$mlb(e.a) : $61de1ee1cac498ae$var$mlb(e.b), 17);
            if ($61de1ee1cac498ae$var$WHc(d)) {
                f = $61de1ee1cac498ae$var$aIc(a, h == d.c ? d.d : d.c);
                if (f > a.d[h.p]) {
                    c += $61de1ee1cac498ae$var$zHc(a.b, f);
                    $61de1ee1cac498ae$var$Wjb(a.a, $61de1ee1cac498ae$var$meb(f));
                }
            } else ++g;
        }
        c += a.b.d * g;
        while(!$61de1ee1cac498ae$var$akb(a.a))$61de1ee1cac498ae$var$xHc(a.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(a.a), 19).a);
    }
    return c;
}
function $61de1ee1cac498ae$var$Y6d(a, b) {
    var c;
    if (a.f == $61de1ee1cac498ae$var$W6d) {
        c = $61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), b));
        return a.e ? c == 4 && b != ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$k8d) && b != ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$h8d) && b != ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$i8d) && b != ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$j8d) : c == 2;
    }
    if (!!a.d && (a.d.Hc(b) || a.d.Hc($61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), b))) || a.d.Hc($61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a.b, b)))) return true;
    if (a.f) {
        if ($61de1ee1cac498ae$var$x1d(($61de1ee1cac498ae$var$O6d(), a.f), $61de1ee1cac498ae$var$b2d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, b)))) {
            c = $61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, b));
            return a.e ? c == 4 : c == 2;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$iVc(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(c, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$C9c)), 8);
    i = g.a;
    k = g.b + a;
    e = $61de1ee1cac498ae$var$$wnd.Math.atan2(k, i);
    e < 0 && (e += $61de1ee1cac498ae$var$dre);
    e += b;
    e > $61de1ee1cac498ae$var$dre && (e -= $61de1ee1cac498ae$var$dre);
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$C9c), 8);
    j = h.a;
    l = h.b + a;
    f = $61de1ee1cac498ae$var$$wnd.Math.atan2(l, j);
    f < 0 && (f += $61de1ee1cac498ae$var$dre);
    f += b;
    f > $61de1ee1cac498ae$var$dre && (f -= $61de1ee1cac498ae$var$dre);
    return $61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My(1.0E-10), $61de1ee1cac498ae$var$$wnd.Math.abs(e - f) <= 1.0E-10 || e == f || isNaN(e) && isNaN(f) ? 0 : e < f ? -1 : e > f ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(e), isNaN(f));
}
function $61de1ee1cac498ae$var$YDb(a) {
    var b, c, d, e, f, g, h;
    h = new $61de1ee1cac498ae$var$Lqb;
    for(d = new $61de1ee1cac498ae$var$olb(a.a.b); d.a < d.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 57);
        $61de1ee1cac498ae$var$Rhb(h, b, new $61de1ee1cac498ae$var$Rkb);
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.a.b); e.a < e.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 57);
        b.i = $61de1ee1cac498ae$var$Qje;
        for(g = b.c.Kc(); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 57);
            $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(h.f, f)), 15).Fc(b);
        }
    }
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        b.c.$b();
        b.c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(h.f, b)), 15);
    }
    $61de1ee1cac498ae$var$QDb(a);
}
function $61de1ee1cac498ae$var$yVb(a) {
    var b, c, d, e, f, g, h;
    h = new $61de1ee1cac498ae$var$Lqb;
    for(d = new $61de1ee1cac498ae$var$olb(a.a.b); d.a < d.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 81);
        $61de1ee1cac498ae$var$Rhb(h, b, new $61de1ee1cac498ae$var$Rkb);
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.a.b); e.a < e.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 81);
        b.o = $61de1ee1cac498ae$var$Qje;
        for(g = b.f.Kc(); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 81);
            $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(h.f, f)), 15).Fc(b);
        }
    }
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        b.f.$b();
        b.f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(h.f, b)), 15);
    }
    $61de1ee1cac498ae$var$rVb(a);
}
function $61de1ee1cac498ae$var$dNb(a, b, c, d) {
    var e, f;
    $61de1ee1cac498ae$var$cNb(a, b, c, d);
    $61de1ee1cac498ae$var$qNb(b, a.j - b.j + c);
    $61de1ee1cac498ae$var$rNb(b, a.k - b.k + d);
    for(f = new $61de1ee1cac498ae$var$olb(b.f); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 324);
        switch(e.a.g){
            case 0:
                $61de1ee1cac498ae$var$nNb(a, b.g + e.b.a, 0, b.g + e.c.a, b.i - 1);
                break;
            case 1:
                $61de1ee1cac498ae$var$nNb(a, b.g + b.o, b.i + e.b.a, a.o - 1, b.i + e.c.a);
                break;
            case 2:
                $61de1ee1cac498ae$var$nNb(a, b.g + e.b.a, b.i + b.p, b.g + e.c.a, a.p - 1);
                break;
            default:
                $61de1ee1cac498ae$var$nNb(a, 0, b.i + e.b.a, b.g - 1, b.i + e.c.a);
        }
    }
}
function $61de1ee1cac498ae$var$aNb(b, c, d, e, f) {
    var g, h, i;
    try {
        if (c >= b.o) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$rcb);
        i = c >> 5;
        h = c & 31;
        g = $61de1ee1cac498ae$var$Nbb(1, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Nbb(h, 1)));
        f ? b.n[d][i] = $61de1ee1cac498ae$var$Mbb(b.n[d][i], g) : b.n[d][i] = $61de1ee1cac498ae$var$xbb(b.n[d][i], $61de1ee1cac498ae$var$Lbb(g));
        g = $61de1ee1cac498ae$var$Nbb(g, 1);
        e ? b.n[d][i] = $61de1ee1cac498ae$var$Mbb(b.n[d][i], g) : b.n[d][i] = $61de1ee1cac498ae$var$xbb(b.n[d][i], $61de1ee1cac498ae$var$Lbb(g));
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 320)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$Dle + b.o + "*" + b.p + $61de1ee1cac498ae$var$Ele + c + $61de1ee1cac498ae$var$She + d + $61de1ee1cac498ae$var$Fle));
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$BUc(a, b, c, d) {
    var e, f, g;
    if (b) {
        f = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$fTc)))) + d;
        g = c + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$bTc))) / 2;
        $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$kTc, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$$wnd.Math.round(f)))));
        $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$lTc, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$$wnd.Math.round(g)))));
        b.d.b == 0 || $61de1ee1cac498ae$var$BUc(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$pr((e = $61de1ee1cac498ae$var$Jsb(new $61de1ee1cac498ae$var$ZRc(b).a.d, 0), new $61de1ee1cac498ae$var$aSc(e))), 86), c + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$bTc))) + a.a, d + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$cTc))));
        $61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$iTc) != null && $61de1ee1cac498ae$var$BUc(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$iTc), 86), c, d);
    }
}
function $61de1ee1cac498ae$var$N9b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    i = $61de1ee1cac498ae$var$Q_b(b.a);
    e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(i, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$pyc)))) * 2;
    k = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$wyc)));
    j = $61de1ee1cac498ae$var$$wnd.Math.max(e, k);
    f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, b.f - b.c + 1, 15, 1);
    d = -j;
    c = 0;
    for(h = b.b.Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 10);
        d += a.a[g.c.p] + j;
        f[c++] = d;
    }
    d += a.a[b.a.c.p] + j;
    f[c++] = d;
    for(m = new $61de1ee1cac498ae$var$olb(b.e); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
        d += a.a[l.c.p] + j;
        f[c++] = d;
    }
    return f;
}
function $61de1ee1cac498ae$var$GHc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    m = new $61de1ee1cac498ae$var$Hxb(new $61de1ee1cac498ae$var$pIc(a));
    for(h = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$OQ, 1), $61de1ee1cac498ae$var$kne, 10, 0, [
        b,
        c
    ]), i = 0, j = h.length; i < j; ++i){
        g = h[i];
        for(l = $61de1ee1cac498ae$var$CHc(g, d).Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 11);
            for(f = new $61de1ee1cac498ae$var$b1b(k.b); $61de1ee1cac498ae$var$llb(f.a) || $61de1ee1cac498ae$var$llb(f.b);){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(f.a) ? $61de1ee1cac498ae$var$mlb(f.a) : $61de1ee1cac498ae$var$mlb(f.b), 17);
                if (!$61de1ee1cac498ae$var$OZb(e)) {
                    $61de1ee1cac498ae$var$Iwb(m.a, k, ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb));
                    $61de1ee1cac498ae$var$WHc(e) && $61de1ee1cac498ae$var$Axb(m, k == e.c ? e.d : e.c);
                }
            }
        }
    }
    return $61de1ee1cac498ae$var$Qb(m), new $61de1ee1cac498ae$var$Tkb(m);
}
function $61de1ee1cac498ae$var$zhd(a, b) {
    var c, d, e, f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$A9c)), 61).g - $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$A9c), 61).g;
    if (f != 0) return f;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$v9c), 19);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$v9c), 19);
    if (!!c && !!d) {
        e = c.a - d.a;
        if (e != 0) return e;
    }
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$A9c), 61).g){
        case 1:
            return $61de1ee1cac498ae$var$Kdb(a.i, b.i);
        case 2:
            return $61de1ee1cac498ae$var$Kdb(a.j, b.j);
        case 3:
            return $61de1ee1cac498ae$var$Kdb(b.i, a.i);
        case 4:
            return $61de1ee1cac498ae$var$Kdb(b.j, a.j);
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$ine));
    }
}
function $61de1ee1cac498ae$var$_od(a) {
    var b, c, d;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$fld(a);
    b = new $61de1ee1cac498ae$var$Wfb($61de1ee1cac498ae$var$ete);
    c = a.k;
    if (!c) {
        !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7));
        if (a.n.i > 0) {
            d = (!a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(a.n, 0), 137)).a;
            !d || $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += ' "', b), d), '"');
        }
    } else $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += ' "', b), c), '"');
    $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb((b.a += " (", b), a.i), ","), a.j), " | "), a.g), ","), a.f), ")");
    return b.a;
}
function $61de1ee1cac498ae$var$opd(a) {
    var b, c, d;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$fld(a);
    b = new $61de1ee1cac498ae$var$Wfb($61de1ee1cac498ae$var$fte);
    c = a.k;
    if (!c) {
        !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7));
        if (a.n.i > 0) {
            d = (!a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(a.n, 0), 137)).a;
            !d || $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += ' "', b), d), '"');
        }
    } else $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += ' "', b), c), '"');
    $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Lfb((b.a += " (", b), a.i), ","), a.j), " | "), a.g), ","), a.f), ")");
    return b.a;
}
function $61de1ee1cac498ae$var$h4c(a, b) {
    var c, d, e, f, g, h, i;
    if (b == null || b.length == 0) return null;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.a, b), 149);
    if (!e) {
        for(d = (h = new $61de1ee1cac498ae$var$$ib(a.b).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(h)); d.a.Ob();){
            c = (f = $61de1ee1cac498ae$var$BD(d.a.Pb(), 42), $61de1ee1cac498ae$var$BD(f.dd(), 149));
            g = c.c;
            i = b.length;
            if ($61de1ee1cac498ae$var$dfb(g.substr(g.length - i, i), b) && (b.length == g.length || $61de1ee1cac498ae$var$bfb(g, g.length - b.length - 1) == 46)) {
                if (e) return null;
                e = c;
            }
        }
        !!e && $61de1ee1cac498ae$var$Shb(a.a, b, e);
    }
    return e;
}
function $61de1ee1cac498ae$var$QLb(a, b) {
    var c, d, e, f;
    c = new $61de1ee1cac498ae$var$VLb;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.f, 16)), c), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Eyb),
        $61de1ee1cac498ae$var$Dyb
    ]))), 21);
    e = d.gc();
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.f, 16)), c), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        $61de1ee1cac498ae$var$Eyb,
        $61de1ee1cac498ae$var$Dyb
    ]))), 21);
    f = d.gc();
    if (e < f) return -1;
    if (e == f) return 0;
    return 1;
}
function $61de1ee1cac498ae$var$r5b(a) {
    var b, c, d;
    if (!$61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$xxc))) return;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$xxc), 21);
    if (d.dc()) return;
    c = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$B1), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0));
    d.Hc(($61de1ee1cac498ae$var$Hbd(), $61de1ee1cac498ae$var$Cbd)) ? $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$Cbd) : $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$Dbd);
    d.Hc($61de1ee1cac498ae$var$Abd) || $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$Abd);
    d.Hc($61de1ee1cac498ae$var$zbd) ? $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$Gbd) : d.Hc($61de1ee1cac498ae$var$ybd) ? $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$Fbd) : d.Hc($61de1ee1cac498ae$var$Bbd) && $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$Ebd);
    d.Hc($61de1ee1cac498ae$var$Gbd) ? $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$zbd) : d.Hc($61de1ee1cac498ae$var$Fbd) ? $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$ybd) : d.Hc($61de1ee1cac498ae$var$Ebd) && $61de1ee1cac498ae$var$rqb(c, $61de1ee1cac498ae$var$Bbd);
    $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$xxc, c);
}
function $61de1ee1cac498ae$var$kHc(a) {
    var b, c, d, e, f, g, h;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Psc)), 10);
    d = a.j;
    c = ($61de1ee1cac498ae$var$tCb(0, d.c.length), $61de1ee1cac498ae$var$BD(d.c[0], 11));
    for(g = new $61de1ee1cac498ae$var$olb(e.j); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 11);
        if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$$sc))) {
            if (f.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) && a.p > e.p) {
                $61de1ee1cac498ae$var$G0b(f, $61de1ee1cac498ae$var$Rcd);
                if (f.d) {
                    h = f.o.b;
                    b = f.a.b;
                    f.a.b = h - b;
                }
            } else if (f.j == $61de1ee1cac498ae$var$Rcd && e.p > a.p) {
                $61de1ee1cac498ae$var$G0b(f, $61de1ee1cac498ae$var$Acd);
                if (f.d) {
                    h = f.o.b;
                    b = f.a.b;
                    f.a.b = -(h - b);
                }
            }
            break;
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$NOc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    f = c;
    if (c < d) {
        m = (n = new $61de1ee1cac498ae$var$uOc(a.p), o = new $61de1ee1cac498ae$var$uOc(a.p), $61de1ee1cac498ae$var$ye(n.e, a.e), n.q = a.q, n.r = o, $61de1ee1cac498ae$var$lOc(n), $61de1ee1cac498ae$var$ye(o.j, a.j), o.r = n, $61de1ee1cac498ae$var$lOc(o), new $61de1ee1cac498ae$var$vgd(n, o));
        l = $61de1ee1cac498ae$var$BD(m.a, 112);
        k = $61de1ee1cac498ae$var$BD(m.b, 112);
        e = ($61de1ee1cac498ae$var$tCb(f, b.c.length), $61de1ee1cac498ae$var$BD(b.c[f], 329));
        g = $61de1ee1cac498ae$var$UOc(a, l, k, e);
        for(j = c + 1; j <= d; j++){
            h = ($61de1ee1cac498ae$var$tCb(j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[j], 329));
            i = $61de1ee1cac498ae$var$UOc(a, l, k, h);
            if ($61de1ee1cac498ae$var$SOc(h, i, e, g)) {
                e = h;
                g = i;
            }
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$wQb(a, b, c, d, e) {
    var f, g, h, i, j, k, l;
    if (!($61de1ee1cac498ae$var$JD(b, 239) || $61de1ee1cac498ae$var$JD(b, 354) || $61de1ee1cac498ae$var$JD(b, 186))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Method only works for ElkNode-, ElkLabel and ElkPort-objects."));
    g = a.a / 2;
    i = b.i + d - g;
    k = b.j + e - g;
    j = i + b.g + a.a;
    l = k + b.f + a.a;
    f = new $61de1ee1cac498ae$var$s7c;
    $61de1ee1cac498ae$var$Dsb(f, new $61de1ee1cac498ae$var$f7c(i, k));
    $61de1ee1cac498ae$var$Dsb(f, new $61de1ee1cac498ae$var$f7c(i, l));
    $61de1ee1cac498ae$var$Dsb(f, new $61de1ee1cac498ae$var$f7c(j, l));
    $61de1ee1cac498ae$var$Dsb(f, new $61de1ee1cac498ae$var$f7c(j, k));
    h = new $61de1ee1cac498ae$var$XOb(f);
    $61de1ee1cac498ae$var$tNb(h, b);
    c && $61de1ee1cac498ae$var$Rhb(a.b, b, h);
    return h;
}
function $61de1ee1cac498ae$var$uXb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = new $61de1ee1cac498ae$var$f7c(b, c);
    for(k = new $61de1ee1cac498ae$var$olb(a.a); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
        $61de1ee1cac498ae$var$P6c(j.n, f);
        for(m = new $61de1ee1cac498ae$var$olb(j.j); m.a < m.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 11);
            for(e = new $61de1ee1cac498ae$var$olb(l.g); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                $61de1ee1cac498ae$var$q7c(d.a, f);
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
                !!g && $61de1ee1cac498ae$var$q7c(g, f);
                for(i = new $61de1ee1cac498ae$var$olb(d.b); i.a < i.c.c.length;){
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 70);
                    $61de1ee1cac498ae$var$P6c(h.n, f);
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$g_b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = new $61de1ee1cac498ae$var$f7c(b, c);
    for(k = new $61de1ee1cac498ae$var$olb(a.a); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
        $61de1ee1cac498ae$var$P6c(j.n, f);
        for(m = new $61de1ee1cac498ae$var$olb(j.j); m.a < m.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 11);
            for(e = new $61de1ee1cac498ae$var$olb(l.g); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                $61de1ee1cac498ae$var$q7c(d.a, f);
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
                !!g && $61de1ee1cac498ae$var$q7c(g, f);
                for(i = new $61de1ee1cac498ae$var$olb(d.b); i.a < i.c.c.length;){
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 70);
                    $61de1ee1cac498ae$var$P6c(h.n, f);
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$N1b(a) {
    if ((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$z2c("Edges must have a source."));
    else if ((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c).i == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$z2c("Edges must have a target."));
    else {
        !a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7));
        if (!(a.b.i <= 1 && (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c.i <= 1))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$z2c("Hyperedges are not supported."));
    }
}
function $61de1ee1cac498ae$var$OFc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    l = 0;
    f = new $61de1ee1cac498ae$var$jkb;
    $61de1ee1cac498ae$var$Wjb(f, b);
    while(f.b != f.c){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(f), 214);
        j = 0;
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ywc)), 339);
        g = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$uwc)));
        h = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$vwc)));
        if (k != ($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) {
            j += g * $61de1ee1cac498ae$var$PFc(i.e, k);
            j += h * $61de1ee1cac498ae$var$QFc(i.e);
        }
        l += $61de1ee1cac498ae$var$pHc(i.d, i.e) + j;
        for(e = new $61de1ee1cac498ae$var$olb(i.b); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 37);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, d.p), 214);
            c.s || (l += $61de1ee1cac498ae$var$NFc(a, c));
        }
    }
    return l;
}
function $61de1ee1cac498ae$var$dhb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    n = b.length;
    i = n;
    $61de1ee1cac498ae$var$BCb(0, b.length);
    if (b.charCodeAt(0) == 45) {
        l = -1;
        m = 1;
        --n;
    } else {
        l = 1;
        m = 0;
    }
    f = ($61de1ee1cac498ae$var$phb(), $61de1ee1cac498ae$var$ohb)[10];
    e = n / f | 0;
    q = n % f;
    q != 0 && ++e;
    h = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, e, 15, 1);
    c = $61de1ee1cac498ae$var$nhb[8];
    g = 0;
    o = m + (q == 0 ? f : q);
    for(p = m; p < i; p = o, o = p + f){
        d = $61de1ee1cac498ae$var$Icb(b.substr(p, o - p), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe);
        j = ($61de1ee1cac498ae$var$Dhb(), $61de1ee1cac498ae$var$Hhb(h, h, g, c));
        j += $61de1ee1cac498ae$var$xhb(h, g, d);
        h[g++] = j;
    }
    k = g;
    a.e = l;
    a.d = k;
    a.a = h;
    $61de1ee1cac498ae$var$Jgb(a);
}
function $61de1ee1cac498ae$var$SGb(a, b, c, d, e, f, g) {
    a.c = d.qf().a;
    a.d = d.qf().b;
    if (e) {
        a.c += e.qf().a;
        a.d += e.qf().b;
    }
    a.b = b.rf().a;
    a.a = b.rf().b;
    if (!e) c ? a.c -= g + b.rf().a : a.c += d.rf().a + g;
    else switch(e.Hf().g){
        case 0:
        case 2:
            a.c += e.rf().a + g + f.a + g;
            break;
        case 4:
            a.c -= g + f.a + g + b.rf().a;
            break;
        case 1:
            a.c += e.rf().a + g;
            a.d -= g + f.b + g + b.rf().b;
            break;
        case 3:
            a.c += e.rf().a + g;
            a.d += e.rf().b + g + f.b + g;
    }
}
function $61de1ee1cac498ae$var$gac(a, b) {
    var c, d;
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$Rkb;
    this.a = a;
    this.d = b;
    $61de1ee1cac498ae$var$dac(this);
    $61de1ee1cac498ae$var$eac(this);
    this.b.dc() ? this.c = a.c.p : this.c = $61de1ee1cac498ae$var$BD(this.b.Xb(0), 10).c.p;
    this.e.c.length == 0 ? this.f = a.c.p : this.f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(this.e, this.e.c.length - 1), 10).c.p;
    for(d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ktc)), 15).Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 70);
        if ($61de1ee1cac498ae$var$wNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Owc))) {
            this.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Owc), 227);
            break;
        }
    }
}
function $61de1ee1cac498ae$var$Anc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, b), 53);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, c), 53);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, b), 53);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, c), 53);
    d.a.zc(c, d);
    g.a.zc(b, g);
    for(k = f.a.ec().Kc(); k.Ob();){
        j = $61de1ee1cac498ae$var$BD(k.Pb(), 10);
        d.a.zc(j, d);
        $61de1ee1cac498ae$var$Qqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, j), 53), b);
        $61de1ee1cac498ae$var$ye($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, j), 53), e);
    }
    for(i = e.a.ec().Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 10);
        g.a.zc(h, g);
        $61de1ee1cac498ae$var$Qqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, h), 53), c);
        $61de1ee1cac498ae$var$ye($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, h), 53), f);
    }
}
function $61de1ee1cac498ae$var$WGc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, b), 53);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, c), 53);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 53);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, c), 53);
    d.a.zc(c, d);
    g.a.zc(b, g);
    for(k = f.a.ec().Kc(); k.Ob();){
        j = $61de1ee1cac498ae$var$BD(k.Pb(), 10);
        d.a.zc(j, d);
        $61de1ee1cac498ae$var$Qqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, j), 53), b);
        $61de1ee1cac498ae$var$ye($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, j), 53), e);
    }
    for(i = e.a.ec().Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 10);
        g.a.zc(h, g);
        $61de1ee1cac498ae$var$Qqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, h), 53), c);
        $61de1ee1cac498ae$var$ye($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, h), 53), f);
    }
}
function $61de1ee1cac498ae$var$doc(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$Odd(b, "Breaking Point Insertion", 1);
    d = new $61de1ee1cac498ae$var$Xoc(a);
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Gyc)), 337).g){
        case 2:
            e = new $61de1ee1cac498ae$var$hpc;
        case 0:
            e = new $61de1ee1cac498ae$var$Ync;
            break;
        default:
            e = new $61de1ee1cac498ae$var$kpc;
    }
    c = e.Vf(a, d);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Iyc))) && (c = $61de1ee1cac498ae$var$coc(a, c));
    if (!e.Wf() && $61de1ee1cac498ae$var$wNb(a, $61de1ee1cac498ae$var$Myc)) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Myc), 338).g){
        case 2:
            c = $61de1ee1cac498ae$var$tpc(d, c);
            break;
        case 1:
            c = $61de1ee1cac498ae$var$rpc(d, c);
    }
    if (c.dc()) {
        $61de1ee1cac498ae$var$Qdd(b);
        return;
    }
    $61de1ee1cac498ae$var$aoc(a, c);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$$qd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    k = null;
    m = b;
    l = $61de1ee1cac498ae$var$Rqd(a, $61de1ee1cac498ae$var$dtd(c), m);
    $61de1ee1cac498ae$var$Lkd(l, $61de1ee1cac498ae$var$_pd(m, $61de1ee1cac498ae$var$Vte));
    g = $61de1ee1cac498ae$var$Ypd(m, $61de1ee1cac498ae$var$Lte);
    d = new $61de1ee1cac498ae$var$mrd(a, l);
    $61de1ee1cac498ae$var$oqd(d.a, d.b, g);
    h = $61de1ee1cac498ae$var$Ypd(m, $61de1ee1cac498ae$var$Mte);
    e = new $61de1ee1cac498ae$var$nrd(a, l);
    $61de1ee1cac498ae$var$pqd(e.a, e.b, h);
    if ((!l.b && (l.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, l, 4, 7)), l.b).i == 0 || (!l.c && (l.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, l, 5, 8)), l.c).i == 0) {
        f = $61de1ee1cac498ae$var$_pd(m, $61de1ee1cac498ae$var$Vte);
        i = $61de1ee1cac498ae$var$Zte + f;
        j = i + $61de1ee1cac498ae$var$$te;
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(j));
    }
    $61de1ee1cac498ae$var$grd(m, l);
    $61de1ee1cac498ae$var$_qd(a, m, l);
    k = $61de1ee1cac498ae$var$crd(a, m, l);
    return k;
}
function $61de1ee1cac498ae$var$yGb(a, b) {
    var c, d, e, f, g, h, i;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.e.a.c.length, 15, 1);
    for(g = new $61de1ee1cac498ae$var$olb(a.e.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 121);
        e[f.d] += f.b.a.c.length;
    }
    h = $61de1ee1cac498ae$var$Ru(b);
    while(h.b != 0){
        f = $61de1ee1cac498ae$var$BD(h.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(h.b != 0), $61de1ee1cac498ae$var$Nsb(h, h.a.a)), 121);
        for(d = $61de1ee1cac498ae$var$vr(new $61de1ee1cac498ae$var$olb(f.g.a)); d.Ob();){
            c = $61de1ee1cac498ae$var$BD(d.Pb(), 213);
            i = c.e;
            i.e = $61de1ee1cac498ae$var$$wnd.Math.max(i.e, f.e + c.a);
            --e[i.d];
            e[i.d] == 0 && $61de1ee1cac498ae$var$Gsb(h, i, h.c.b, h.c);
        }
    }
}
function $61de1ee1cac498ae$var$CGb(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    c = $61de1ee1cac498ae$var$Rie;
    e = $61de1ee1cac498ae$var$Ohe;
    for(h = new $61de1ee1cac498ae$var$olb(a.e.a); h.a < h.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 121);
        e = $61de1ee1cac498ae$var$$wnd.Math.min(e, f.e);
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, f.e);
    }
    b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, c - e + 1, 15, 1);
    for(g = new $61de1ee1cac498ae$var$olb(a.e.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 121);
        f.e -= e;
        ++b[f.e];
    }
    d = 0;
    if (a.k != null) for(j = a.k, k = 0, l = j.length; k < l; ++k){
        i = j[k];
        b[d++] += i;
        if (b.length == d) break;
    }
    return b;
}
function $61de1ee1cac498ae$var$ixd(a) {
    switch(a.d){
        case 9:
        case 8:
            return true;
        case 3:
        case 5:
        case 4:
        case 6:
            return false;
        case 7:
            return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hxd(a), 19).a == a.o;
        case 1:
        case 2:
            if (a.o == -2) return false;
            else switch(a.p){
                case 0:
                case 1:
                case 2:
                case 6:
                case 5:
                case 7:
                    return $61de1ee1cac498ae$var$Bbb(a.k, a.f);
                case 3:
                case 4:
                    return a.j == a.e;
                default:
                    return a.n == null ? a.g == null : $61de1ee1cac498ae$var$pb(a.n, a.g);
            }
        default:
            return false;
    }
}
function $61de1ee1cac498ae$var$$ad(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$Qse), "ELK Fixed"), "Keeps the current layout as it is, without any automatic modification. Optional coordinates can be given for nodes and edge bend points."), new $61de1ee1cac498ae$var$bbd)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Qse, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$Xad);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Qse, $61de1ee1cac498ae$var$uqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Yad));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Qse, $61de1ee1cac498ae$var$use, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Sad));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Qse, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Tad));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Qse, $61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Vad));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Qse, $61de1ee1cac498ae$var$bqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Uad));
}
function $61de1ee1cac498ae$var$ro(a, b, c) {
    var d, e, f, g, h;
    d = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(b == null ? 0 : $61de1ee1cac498ae$var$tb(b), $61de1ee1cac498ae$var$Fie)), 15)));
    h = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(c == null ? 0 : $61de1ee1cac498ae$var$tb(c), $61de1ee1cac498ae$var$Fie)), 15)));
    f = $61de1ee1cac498ae$var$uo(a, b, d);
    if (!!f && h == f.f && $61de1ee1cac498ae$var$Hb(c, f.i)) return c;
    g = $61de1ee1cac498ae$var$vo(a, c, h);
    if (g) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("value already present: " + c));
    e = new $61de1ee1cac498ae$var$$o(b, d, c, h);
    if (f) {
        $61de1ee1cac498ae$var$mo(a, f);
        $61de1ee1cac498ae$var$po(a, e, f);
        f.e = null;
        f.c = null;
        return f.i;
    } else {
        $61de1ee1cac498ae$var$po(a, e, null);
        $61de1ee1cac498ae$var$to(a);
        return null;
    }
}
function $61de1ee1cac498ae$var$E4b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    k = c.a.c;
    g = c.a.c + c.a.b;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(c.c, b), 459);
    n = f.f;
    o = f.a;
    f.b ? i = new $61de1ee1cac498ae$var$f7c(g, n) : i = new $61de1ee1cac498ae$var$f7c(k, n);
    f.c ? l = new $61de1ee1cac498ae$var$f7c(k, o) : l = new $61de1ee1cac498ae$var$f7c(g, o);
    e = k;
    c.p || (e += a.c);
    e += c.F + c.v * a.b;
    j = new $61de1ee1cac498ae$var$f7c(e, n);
    m = new $61de1ee1cac498ae$var$f7c(e, o);
    $61de1ee1cac498ae$var$n7c(b.a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        i,
        j
    ]));
    h = c.d.a.gc() > 1;
    if (h) {
        d = new $61de1ee1cac498ae$var$f7c(e, c.b);
        $61de1ee1cac498ae$var$Dsb(b.a, d);
    }
    $61de1ee1cac498ae$var$n7c(b.a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        m,
        l
    ]));
}
function $61de1ee1cac498ae$var$Nid(a, b, c) {
    var d, e, f, g, h, i;
    if (!b) return null;
    else {
        if (c <= -1) {
            d = $61de1ee1cac498ae$var$XKd(b.Tg(), -1 - c);
            if ($61de1ee1cac498ae$var$JD(d, 99)) return $61de1ee1cac498ae$var$BD(d, 18);
            else {
                g = $61de1ee1cac498ae$var$BD(b.ah(d), 153);
                for(h = 0, i = g.gc(); h < i; ++h)if ($61de1ee1cac498ae$var$PD(g.jl(h)) === $61de1ee1cac498ae$var$PD(a)) {
                    e = g.il(h);
                    if ($61de1ee1cac498ae$var$JD(e, 99)) {
                        f = $61de1ee1cac498ae$var$BD(e, 18);
                        if ((f.Bb & $61de1ee1cac498ae$var$ote) != 0) return f;
                    }
                }
                throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("The containment feature could not be located"));
            }
        } else return $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd(a.Tg(), c), 18));
    }
}
function $61de1ee1cac498ae$var$Xee(a) {
    var b, c, d, e, f;
    d = a.length;
    b = new $61de1ee1cac498ae$var$Ifb;
    f = 0;
    while(f < d){
        c = $61de1ee1cac498ae$var$bfb(a, f++);
        if (c == 9 || c == 10 || c == 12 || c == 13 || c == 32) continue;
        if (c == 35) {
            while(f < d){
                c = $61de1ee1cac498ae$var$bfb(a, f++);
                if (c == 13 || c == 10) break;
            }
            continue;
        }
        if (c == 92 && f < d) {
            if ((e = ($61de1ee1cac498ae$var$BCb(f, a.length), a.charCodeAt(f))) == 35 || e == 9 || e == 10 || e == 12 || e == 13 || e == 32) {
                $61de1ee1cac498ae$var$Afb(b, e & $61de1ee1cac498ae$var$aje);
                ++f;
            } else {
                b.a += "\\";
                $61de1ee1cac498ae$var$Afb(b, e & $61de1ee1cac498ae$var$aje);
                ++f;
            }
        } else $61de1ee1cac498ae$var$Afb(b, c & $61de1ee1cac498ae$var$aje);
    }
    return b.a;
}
function $61de1ee1cac498ae$var$GVc(a, b) {
    var c, d, e;
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 33);
        $61de1ee1cac498ae$var$Rc(a.a, c, c);
        $61de1ee1cac498ae$var$Rc(a.b, c, c);
        e = $61de1ee1cac498ae$var$gVc(c);
        if (e.c.length != 0) {
            !!a.d && a.d.lg(e);
            $61de1ee1cac498ae$var$Rc(a.a, c, ($61de1ee1cac498ae$var$tCb(0, e.c.length), $61de1ee1cac498ae$var$BD(e.c[0], 33)));
            $61de1ee1cac498ae$var$Rc(a.b, c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e, e.c.length - 1), 33));
            while($61de1ee1cac498ae$var$dVc(e).c.length != 0){
                e = $61de1ee1cac498ae$var$dVc(e);
                !!a.d && a.d.lg(e);
                $61de1ee1cac498ae$var$Rc(a.a, c, ($61de1ee1cac498ae$var$tCb(0, e.c.length), $61de1ee1cac498ae$var$BD(e.c[0], 33)));
                $61de1ee1cac498ae$var$Rc(a.b, c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e, e.c.length - 1), 33));
            }
        }
    }
}
function $61de1ee1cac498ae$var$fnc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    c = 0;
    for(h = new $61de1ee1cac498ae$var$olb(a.d); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 101);
        !!g.i && (g.i.c = c++);
    }
    b = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$sbb, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$dle
    ], [
        177,
        25
    ], 16, [
        c,
        c
    ], 2);
    k = a.d;
    for(e = 0; e < k.c.length; e++){
        i = ($61de1ee1cac498ae$var$tCb(e, k.c.length), $61de1ee1cac498ae$var$BD(k.c[e], 101));
        if (i.i) for(f = e + 1; f < k.c.length; f++){
            j = ($61de1ee1cac498ae$var$tCb(f, k.c.length), $61de1ee1cac498ae$var$BD(k.c[f], 101));
            if (j.i) {
                d = $61de1ee1cac498ae$var$knc(i, j);
                b[i.i.c][j.i.c] = d;
                b[j.i.c][i.i.c] = d;
            }
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$ht(a, b, c, d) {
    var e, f, g;
    g = new $61de1ee1cac498ae$var$qu(b, c);
    if (!a.a) {
        a.a = a.e = g;
        $61de1ee1cac498ae$var$Rhb(a.b, b, new $61de1ee1cac498ae$var$pu(g));
        ++a.c;
    } else if (!d) {
        a.e.b = g;
        g.d = a.e;
        a.e = g;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 283);
        if (!e) {
            $61de1ee1cac498ae$var$Rhb(a.b, b, e = new $61de1ee1cac498ae$var$pu(g));
            ++a.c;
        } else {
            ++e.a;
            f = e.c;
            f.c = g;
            g.e = f;
            e.c = g;
        }
    } else {
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 283);
        ++e.a;
        g.d = d.d;
        g.e = d.e;
        g.b = d;
        g.c = d;
        !d.e ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, b), 283).b = g : d.e.c = g;
        !d.d ? a.a = g : d.d.b = g;
        d.d = g;
        d.e = g;
    }
    ++a.d;
    return g;
}
function $61de1ee1cac498ae$var$mfb(a, b) {
    var c, d, e, f, g, h, i, j;
    c = new RegExp(b, "g");
    i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, 0, 6, 1);
    d = 0;
    j = a;
    f = null;
    while(true){
        h = c.exec(j);
        if (h == null || j == "") {
            i[d] = j;
            break;
        } else {
            g = h.index;
            i[d] = j.substr(0, g);
            j = $61de1ee1cac498ae$var$qfb(j, g + h[0].length, j.length);
            c.lastIndex = 0;
            if (f == j) {
                i[d] = j.substr(0, 1);
                j = j.substr(1);
            }
            f = j;
            ++d;
        }
    }
    if (a.length > 0) {
        e = i.length;
        while(e > 0 && i[e - 1] == "")--e;
        e < i.length && (i.length = e);
    }
    return i;
}
function $61de1ee1cac498ae$var$f1d(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    l = $61de1ee1cac498ae$var$_Kd(b);
    j = null;
    e = false;
    for(h = 0, k = $61de1ee1cac498ae$var$VKd(l.a).i; h < k; ++h){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$nOd(l, h, (f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$VKd(l.a), h), 87), i = f.c, $61de1ee1cac498ae$var$JD(i, 88) ? $61de1ee1cac498ae$var$BD(i, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd))), 26);
        c = $61de1ee1cac498ae$var$f1d(a, g);
        if (!c.dc()) {
            if (!j) j = c;
            else {
                if (!e) {
                    e = true;
                    j = new $61de1ee1cac498ae$var$pFd(j);
                }
                j.Gc(c);
            }
        }
    }
    d = $61de1ee1cac498ae$var$k1d(a, b);
    if (d.dc()) return !j ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb) : j;
    else {
        if (!j) return d;
        else {
            e || (j = new $61de1ee1cac498ae$var$pFd(j));
            j.Gc(d);
            return j;
        }
    }
}
function $61de1ee1cac498ae$var$g1d(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    l = $61de1ee1cac498ae$var$_Kd(b);
    j = null;
    d = false;
    for(h = 0, k = $61de1ee1cac498ae$var$VKd(l.a).i; h < k; ++h){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$nOd(l, h, (e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$VKd(l.a), h), 87), i = e.c, $61de1ee1cac498ae$var$JD(i, 88) ? $61de1ee1cac498ae$var$BD(i, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd))), 26);
        c = $61de1ee1cac498ae$var$g1d(a, f);
        if (!c.dc()) {
            if (!j) j = c;
            else {
                if (!d) {
                    d = true;
                    j = new $61de1ee1cac498ae$var$pFd(j);
                }
                j.Gc(c);
            }
        }
    }
    g = $61de1ee1cac498ae$var$n1d(a, b);
    if (g.dc()) return !j ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb) : j;
    else {
        if (!j) return g;
        else {
            d || (j = new $61de1ee1cac498ae$var$pFd(j));
            j.Gc(g);
            return j;
        }
    }
}
function $61de1ee1cac498ae$var$B2d(a, b, c) {
    var d, e, f, g, h, i;
    if ($61de1ee1cac498ae$var$JD(b, 72)) return $61de1ee1cac498ae$var$Txd(a, b, c);
    else {
        h = null;
        f = null;
        d = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(g = 0; g < a.i; ++g){
            e = d[g];
            if ($61de1ee1cac498ae$var$pb(b, e.dd())) {
                f = e.ak();
                if ($61de1ee1cac498ae$var$JD(f, 99) && ($61de1ee1cac498ae$var$BD(f, 18).Bb & $61de1ee1cac498ae$var$ote) != 0) {
                    h = e;
                    break;
                }
            }
        }
        if (h) {
            if ($61de1ee1cac498ae$var$oid(a.e)) {
                i = f.$j() ? $61de1ee1cac498ae$var$H2d(a, 4, f, b, null, $61de1ee1cac498ae$var$M2d(a, f, b, $61de1ee1cac498ae$var$JD(f, 99) && ($61de1ee1cac498ae$var$BD(f, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0), true) : $61de1ee1cac498ae$var$H2d(a, f.Kj() ? 2 : 1, f, b, f.zj(), -1, true);
                c ? c.Ei(i) : c = i;
            }
            c = $61de1ee1cac498ae$var$B2d(a, h, c);
        }
        return c;
    }
}
function $61de1ee1cac498ae$var$pKb(a) {
    var b, c, d, e;
    d = a.o;
    $61de1ee1cac498ae$var$$Jb();
    if (a.A.dc() || $61de1ee1cac498ae$var$pb(a.A, $61de1ee1cac498ae$var$ZJb)) e = d.a;
    else {
        e = $61de1ee1cac498ae$var$gIb(a.f);
        if (a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$qdd)) && !a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Edd))) {
            e = $61de1ee1cac498ae$var$$wnd.Math.max(e, $61de1ee1cac498ae$var$gIb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.p, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)), 244)));
            e = $61de1ee1cac498ae$var$$wnd.Math.max(e, $61de1ee1cac498ae$var$gIb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.p, $61de1ee1cac498ae$var$Rcd), 244)));
        }
        b = $61de1ee1cac498ae$var$aKb(a);
        !!b && (e = $61de1ee1cac498ae$var$$wnd.Math.max(e, b.a));
    }
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(a.e.yf().We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$$8c)))) ? d.a = $61de1ee1cac498ae$var$$wnd.Math.max(d.a, e) : d.a = e;
    c = a.f.i;
    c.c = 0;
    c.b = e;
    $61de1ee1cac498ae$var$hIb(a.f);
}
function $61de1ee1cac498ae$var$$0d(a, b) {
    var c, d, e, f, g, h, i, j, k;
    c = b.Hh(a.a);
    if (c) {
        i = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), "memberTypes"));
        if (i != null) {
            j = new $61de1ee1cac498ae$var$Rkb;
            for(f = $61de1ee1cac498ae$var$mfb(i, "\\w"), g = 0, h = f.length; g < h; ++g){
                e = f[g];
                d = e.lastIndexOf("#");
                k = d == -1 ? $61de1ee1cac498ae$var$w1d(a, b.Aj(), e) : d == 0 ? $61de1ee1cac498ae$var$v1d(a, null, e.substr(1)) : $61de1ee1cac498ae$var$v1d(a, e.substr(0, d), e.substr(d + 1));
                $61de1ee1cac498ae$var$JD(k, 148) && $61de1ee1cac498ae$var$Ekb(j, $61de1ee1cac498ae$var$BD(k, 148));
            }
            return j;
        }
    }
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
}
function $61de1ee1cac498ae$var$tRb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    $61de1ee1cac498ae$var$Odd(c, $61de1ee1cac498ae$var$kme, 1);
    a.bf(b);
    f = 0;
    while(a.df(f)){
        for(k = new $61de1ee1cac498ae$var$olb(b.e); k.a < k.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 144);
            for(h = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                b.e,
                b.d,
                b.b
            ]))); $61de1ee1cac498ae$var$Qr(h);){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(h), 357);
                if (g != i) {
                    e = a.af(g, i);
                    !!e && $61de1ee1cac498ae$var$P6c(i.a, e);
                }
            }
        }
        for(j = new $61de1ee1cac498ae$var$olb(b.e); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 144);
            d = i.a;
            $61de1ee1cac498ae$var$Q6c(d, -a.d, -a.d, a.d, a.d);
            $61de1ee1cac498ae$var$P6c(i.d, d);
            $61de1ee1cac498ae$var$X6c(d);
        }
        a.cf();
        ++f;
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$$2d(a, b, c) {
    var d, e, f, g;
    g = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    d = $61de1ee1cac498ae$var$BD(a.g, 119);
    $61de1ee1cac498ae$var$Q6d();
    if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) for(f = 0; f < a.i; ++f){
        e = d[f];
        if (g.rl(e.ak())) {
            if ($61de1ee1cac498ae$var$pb(e, c)) {
                $61de1ee1cac498ae$var$Xxd(a, f);
                return true;
            }
        }
    }
    else if (c != null) for(f = 0; f < a.i; ++f){
        e = d[f];
        if (g.rl(e.ak())) {
            if ($61de1ee1cac498ae$var$pb(c, e.dd())) {
                $61de1ee1cac498ae$var$Xxd(a, f);
                return true;
            }
        }
    }
    else for(f = 0; f < a.i; ++f){
        e = d[f];
        if (g.rl(e.ak())) {
            if (e.dd() == null) {
                $61de1ee1cac498ae$var$Xxd(a, f);
                return true;
            }
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$sDc(a, b) {
    var c, d, e, f, g;
    a.c == null || a.c.length < b.c.length ? a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, b.c.length, 16, 1) : $61de1ee1cac498ae$var$Blb(a.c);
    a.a = new $61de1ee1cac498ae$var$Rkb;
    d = 0;
    for(g = new $61de1ee1cac498ae$var$olb(b); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        e.p = d++;
    }
    c = new $61de1ee1cac498ae$var$Psb;
    for(f = new $61de1ee1cac498ae$var$olb(b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        if (!a.c[e.p]) {
            $61de1ee1cac498ae$var$tDc(a, e);
            c.b == 0 || ($61de1ee1cac498ae$var$sCb(c.b != 0), $61de1ee1cac498ae$var$BD(c.a.a.c, 15)).gc() < a.a.c.length ? $61de1ee1cac498ae$var$Esb(c, a.a) : $61de1ee1cac498ae$var$Fsb(c, a.a);
            a.a = new $61de1ee1cac498ae$var$Rkb;
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$jYc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(b, 0), 33);
    $61de1ee1cac498ae$var$dld(g, 0);
    $61de1ee1cac498ae$var$eld(g, 0);
    m = new $61de1ee1cac498ae$var$Rkb;
    m.c[m.c.length] = g;
    h = g;
    f = new $61de1ee1cac498ae$var$d$c(a.a, g.g, g.f, ($61de1ee1cac498ae$var$k$c(), $61de1ee1cac498ae$var$j$c));
    for(n = 1; n < b.i; n++){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(b, n), 33);
        i = $61de1ee1cac498ae$var$kYc(a, $61de1ee1cac498ae$var$g$c, o, h, f, m, c);
        j = $61de1ee1cac498ae$var$kYc(a, $61de1ee1cac498ae$var$f$c, o, h, f, m, c);
        k = $61de1ee1cac498ae$var$kYc(a, $61de1ee1cac498ae$var$i$c, o, h, f, m, c);
        l = $61de1ee1cac498ae$var$kYc(a, $61de1ee1cac498ae$var$h$c, o, h, f, m, c);
        e = $61de1ee1cac498ae$var$mYc(a, i, j, k, l, o, h, d);
        $61de1ee1cac498ae$var$dld(o, e.d);
        $61de1ee1cac498ae$var$eld(o, e.e);
        $61de1ee1cac498ae$var$c$c(e, $61de1ee1cac498ae$var$j$c);
        f = e;
        h = o;
        m.c[m.c.length] = o;
    }
    return f;
}
function $61de1ee1cac498ae$var$K0c(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$ase), "ELK SPOrE Overlap Removal"), 'A node overlap removal algorithm proposed by Nachmanson et al. in "Node overlap removal by growing a tree".'), new $61de1ee1cac498ae$var$N0c)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ase, $61de1ee1cac498ae$var$Qre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$I0c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ase, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$G0c);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ase, $61de1ee1cac498ae$var$wme, 8);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ase, $61de1ee1cac498ae$var$Vre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$H0c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ase, $61de1ee1cac498ae$var$Yre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$E0c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ase, $61de1ee1cac498ae$var$Zre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$F0c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ase, $61de1ee1cac498ae$var$Zpe, ($61de1ee1cac498ae$var$Bcb(), false));
}
function $61de1ee1cac498ae$var$sXb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    g = $61de1ee1cac498ae$var$O6c(b.c, c, d);
    for(l = new $61de1ee1cac498ae$var$olb(b.a); l.a < l.c.c.length;){
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 10);
        $61de1ee1cac498ae$var$P6c(k.n, g);
        for(n = new $61de1ee1cac498ae$var$olb(k.j); n.a < n.c.c.length;){
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 11);
            for(f = new $61de1ee1cac498ae$var$olb(m.g); f.a < f.c.c.length;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                $61de1ee1cac498ae$var$q7c(e.a, g);
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
                !!h && $61de1ee1cac498ae$var$q7c(h, g);
                for(j = new $61de1ee1cac498ae$var$olb(e.b); j.a < j.c.c.length;){
                    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 70);
                    $61de1ee1cac498ae$var$P6c(i.n, g);
                }
            }
        }
        $61de1ee1cac498ae$var$Ekb(a.a, k);
        k.a = a;
    }
}
function $61de1ee1cac498ae$var$g9b(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, "Node and Port Label Placement and Node Sizing", 1);
    $61de1ee1cac498ae$var$MGb(($61de1ee1cac498ae$var$a$b(), new $61de1ee1cac498ae$var$l$b(a, true, true, new $61de1ee1cac498ae$var$j9b)));
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc))) {
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Yxc)), 21);
        e = f.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ocd));
        g = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Zxc)));
        for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
            $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.a, 16)), new $61de1ee1cac498ae$var$l9b), new $61de1ee1cac498ae$var$n9b(f, e, g));
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$Y0d(a, b) {
    var c, d, e, f, g, h;
    c = b.Hh(a.a);
    if (c) {
        h = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$eue));
        if (h != null) {
            e = $61de1ee1cac498ae$var$kfb(h, $61de1ee1cac498ae$var$wfb(35));
            d = b.Hj();
            if (e == -1) {
                g = $61de1ee1cac498ae$var$u1d(a, $61de1ee1cac498ae$var$bKd(d));
                f = h;
            } else if (e == 0) {
                g = null;
                f = h.substr(1);
            } else {
                g = h.substr(0, e);
                f = h.substr(e + 1);
            }
            switch($61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d(a, b))){
                case 2:
                case 3:
                    return $61de1ee1cac498ae$var$j1d(a, d, g, f);
                case 0:
                case 4:
                case 5:
                case 6:
                    return $61de1ee1cac498ae$var$m1d(a, d, g, f);
            }
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$q2d(a, b, c) {
    var d, e, f, g, h;
    g = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj());
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        if (b.hi() && $61de1ee1cac498ae$var$F2d(a, b, c, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0)) return false;
    } else {
        h = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
        d = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(f = 0; f < a.i; ++f){
            e = d[f];
            if (h.rl(e.ak())) {
                if (g ? $61de1ee1cac498ae$var$pb(e, c) : c == null ? e.dd() == null : $61de1ee1cac498ae$var$pb(c, e.dd())) return false;
                else {
                    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(a, f, g ? $61de1ee1cac498ae$var$BD(c, 72) : $61de1ee1cac498ae$var$R6d(b, c)), 72);
                    return true;
                }
            }
        }
    }
    return $61de1ee1cac498ae$var$wtd(a, g ? $61de1ee1cac498ae$var$BD(c, 72) : $61de1ee1cac498ae$var$R6d(b, c));
}
function $61de1ee1cac498ae$var$uVb(a) {
    var b, c, d, e, f, g, h, i;
    if (a.d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb(($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$LP), $61de1ee1cac498ae$var$Jke + $61de1ee1cac498ae$var$LP.k + $61de1ee1cac498ae$var$Kke)));
    a.c == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad) && $61de1ee1cac498ae$var$tVb(a, $61de1ee1cac498ae$var$aad);
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 189);
        b.e = 0;
    }
    for(g = new $61de1ee1cac498ae$var$olb(a.a.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 81);
        f.o = $61de1ee1cac498ae$var$Qje;
        for(e = f.f.Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 81);
            ++d.d.e;
        }
    }
    $61de1ee1cac498ae$var$JVb(a);
    for(i = new $61de1ee1cac498ae$var$olb(a.a.b); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 81);
        h.k = true;
    }
    return a;
}
function $61de1ee1cac498ae$var$Ijc(a, b) {
    var c, d, e, f, g, h, i, j;
    h = new $61de1ee1cac498ae$var$pjc(a);
    c = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$Gsb(c, b, c.c.b, c.c);
    while(c.b != 0){
        d = $61de1ee1cac498ae$var$BD(c.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(c.b != 0), $61de1ee1cac498ae$var$Nsb(c, c.a.a)), 113);
        d.d.p = 1;
        for(g = new $61de1ee1cac498ae$var$olb(d.e); g.a < g.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 409);
            $61de1ee1cac498ae$var$kjc(h, e);
            j = e.d;
            j.d.p == 0 && $61de1ee1cac498ae$var$Gsb(c, j, c.c.b, c.c);
        }
        for(f = new $61de1ee1cac498ae$var$olb(d.b); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 409);
            $61de1ee1cac498ae$var$kjc(h, e);
            i = e.c;
            i.d.p == 0 && $61de1ee1cac498ae$var$Gsb(c, i, c.c.b, c.c);
        }
    }
    return h;
}
function $61de1ee1cac498ae$var$hfd(a) {
    var b, c, d, e, f;
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$G9c))));
    if (d == 1) return;
    $61de1ee1cac498ae$var$_kd(a, d * a.g, d * a.f);
    c = $61de1ee1cac498ae$var$Mq($61de1ee1cac498ae$var$Rq((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c), new $61de1ee1cac498ae$var$Hfd));
    for(f = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
        (!a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), a.n),
        (!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c),
        c
    ]))); $61de1ee1cac498ae$var$Qr(f);){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 470);
        e.Gg(d * e.Dg(), d * e.Eg());
        e.Fg(d * e.Cg(), d * e.Bg());
        b = $61de1ee1cac498ae$var$BD(e.We($61de1ee1cac498ae$var$r9c), 8);
        if (b) {
            b.a *= d;
            b.b *= d;
        }
    }
}
function $61de1ee1cac498ae$var$Mac(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m;
    for(g = new $61de1ee1cac498ae$var$olb(a.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        m = $61de1ee1cac498ae$var$l_b(f.a);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163).g){
                case 1:
                    $61de1ee1cac498ae$var$Qac(i);
                    $61de1ee1cac498ae$var$$_b(i, b);
                    $61de1ee1cac498ae$var$Nac(i, true, d);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$Rac(i);
                    $61de1ee1cac498ae$var$$_b(i, c);
                    $61de1ee1cac498ae$var$Nac(i, false, e);
            }
        }
    }
    h = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    while(h.b < h.d.gc())($61de1ee1cac498ae$var$sCb(h.b < h.d.gc()), $61de1ee1cac498ae$var$BD(h.d.Xb(h.c = h.b++), 29)).a.c.length == 0 && $61de1ee1cac498ae$var$uib(h);
}
function $61de1ee1cac498ae$var$d1d(a, b) {
    var c, d, e, f, g, h, i;
    c = b.Hh(a.a);
    if (c) {
        i = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!c.b && (c.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, c)), c.b), $61de1ee1cac498ae$var$Dwe));
        if (i != null) {
            d = new $61de1ee1cac498ae$var$Rkb;
            for(f = $61de1ee1cac498ae$var$mfb(i, "\\w"), g = 0, h = f.length; g < h; ++g){
                e = f[g];
                $61de1ee1cac498ae$var$dfb(e, "##other") ? $61de1ee1cac498ae$var$Ekb(d, "!##" + $61de1ee1cac498ae$var$u1d(a, $61de1ee1cac498ae$var$bKd(b.Hj()))) : $61de1ee1cac498ae$var$dfb(e, "##local") ? d.c[d.c.length] = null : $61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Bwe) ? $61de1ee1cac498ae$var$Ekb(d, $61de1ee1cac498ae$var$u1d(a, $61de1ee1cac498ae$var$bKd(b.Hj()))) : d.c[d.c.length] = e;
            }
            return d;
        }
    }
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
}
function $61de1ee1cac498ae$var$kMb(a, b) {
    var c, d, e, f;
    c = new $61de1ee1cac498ae$var$pMb;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.f, 16)), c), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Eyb),
        $61de1ee1cac498ae$var$Dyb
    ]))), 21);
    e = d.gc();
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.f, 16)), c), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        $61de1ee1cac498ae$var$Eyb,
        $61de1ee1cac498ae$var$Dyb
    ]))), 21);
    f = d.gc();
    e = e == 1 ? 1 : 0;
    f = f == 1 ? 1 : 0;
    if (e < f) return -1;
    if (e == f) return 0;
    return 1;
}
function $61de1ee1cac498ae$var$hZb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    h = a.i;
    e = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$fxc))));
    k = 0;
    d = 0;
    for(j = new $61de1ee1cac498ae$var$olb(a.g); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 17);
        g = $61de1ee1cac498ae$var$OZb(i);
        f = g && e && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$gxc)));
        m = i.d.i;
        g && f ? ++d : g && !f ? ++k : $61de1ee1cac498ae$var$Q_b(m).e == h ? ++d : ++k;
    }
    for(c = new $61de1ee1cac498ae$var$olb(a.e); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 17);
        g = $61de1ee1cac498ae$var$OZb(b);
        f = g && e && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$gxc)));
        l = b.c.i;
        g && f ? ++k : g && !f ? ++d : $61de1ee1cac498ae$var$Q_b(l).e == h ? ++k : ++d;
    }
    return k - d;
}
function $61de1ee1cac498ae$var$ULc(a, b, c, d) {
    this.e = a;
    this.k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    this.g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, b, 0, 1);
    this.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BI, $61de1ee1cac498ae$var$nie, 333, b, 7, 1);
    this.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, b, 0, 1);
    this.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BI, $61de1ee1cac498ae$var$nie, 333, b, 7, 1);
    this.j = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, b, 0, 1);
    this.i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BI, $61de1ee1cac498ae$var$nie, 333, b, 7, 1);
    this.p = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BI, $61de1ee1cac498ae$var$nie, 333, b, 7, 1);
    this.n = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$wI, $61de1ee1cac498ae$var$nie, 476, b, 8, 1);
    $61de1ee1cac498ae$var$Alb(this.n, ($61de1ee1cac498ae$var$Bcb(), false));
    this.f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$wI, $61de1ee1cac498ae$var$nie, 476, b, 8, 1);
    $61de1ee1cac498ae$var$Alb(this.f, true);
    this.o = c;
    this.c = d;
}
function $61de1ee1cac498ae$var$X9b(a, b) {
    var c, d, e, f, g, h;
    if (b.dc()) return;
    if ($61de1ee1cac498ae$var$BD(b.Xb(0), 286).d == ($61de1ee1cac498ae$var$Apc(), $61de1ee1cac498ae$var$xpc)) $61de1ee1cac498ae$var$O9b(a, b);
    else for(d = b.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 286);
        switch(c.d.g){
            case 5:
                $61de1ee1cac498ae$var$K9b(a, c, $61de1ee1cac498ae$var$Q9b(a, c));
                break;
            case 0:
                $61de1ee1cac498ae$var$K9b(a, c, (g = c.f - c.c + 1, h = (g - 1) / 2 | 0, c.c + h));
                break;
            case 4:
                $61de1ee1cac498ae$var$K9b(a, c, $61de1ee1cac498ae$var$S9b(a, c));
                break;
            case 2:
                $61de1ee1cac498ae$var$Y9b(c);
                $61de1ee1cac498ae$var$K9b(a, c, (f = $61de1ee1cac498ae$var$U9b(c), f ? c.c : c.f));
                break;
            case 1:
                $61de1ee1cac498ae$var$Y9b(c);
                $61de1ee1cac498ae$var$K9b(a, c, (e = $61de1ee1cac498ae$var$U9b(c), e ? c.f : c.c));
        }
        $61de1ee1cac498ae$var$P9b(c.a);
    }
}
function $61de1ee1cac498ae$var$C4b(a, b) {
    var c, d, e, f, g, h, i;
    if (b.e) return;
    b.e = true;
    for(d = b.d.a.ec().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 17);
        if (b.o && b.d.a.gc() <= 1) {
            g = b.a.c;
            h = b.a.c + b.a.b;
            i = new $61de1ee1cac498ae$var$f7c(g + (h - g) / 2, b.b);
            $61de1ee1cac498ae$var$Dsb($61de1ee1cac498ae$var$BD(b.d.a.ec().Kc().Pb(), 17).a, i);
            continue;
        }
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(b.c, c), 459);
        if (e.b || e.c) {
            $61de1ee1cac498ae$var$E4b(a, c, b);
            continue;
        }
        f = a.d == ($61de1ee1cac498ae$var$tBc(), $61de1ee1cac498ae$var$sBc) && (e.d || e.e) && $61de1ee1cac498ae$var$K4b(a, b) && b.d.a.gc() <= 1;
        f ? $61de1ee1cac498ae$var$F4b(c, b) : $61de1ee1cac498ae$var$D4b(a, c, b);
    }
    b.k && $61de1ee1cac498ae$var$reb(b.d, new $61de1ee1cac498ae$var$X4b);
}
function $61de1ee1cac498ae$var$zXc(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    m = f;
    h = (d + e) / 2 + m;
    q = c * $61de1ee1cac498ae$var$$wnd.Math.cos(h);
    r = c * $61de1ee1cac498ae$var$$wnd.Math.sin(h);
    s = q - b.g / 2;
    t = r - b.f / 2;
    $61de1ee1cac498ae$var$dld(b, s);
    $61de1ee1cac498ae$var$eld(b, t);
    l = a.a.jg(b);
    p = 2 * $61de1ee1cac498ae$var$$wnd.Math.acos(c / c + a.c);
    if (p < e - d) {
        n = p / l;
        g = (d + e - p) / 2;
    } else {
        n = (e - d) / l;
        g = d;
    }
    o = $61de1ee1cac498ae$var$gVc(b);
    if (a.e) {
        a.e.kg(a.d);
        a.e.lg(o);
    }
    for(j = new $61de1ee1cac498ae$var$olb(o); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 33);
        k = a.a.jg(i);
        $61de1ee1cac498ae$var$zXc(a, i, c + a.c, g, g + n * k, f);
        g += n * k;
    }
}
function $61de1ee1cac498ae$var$jA(a, b, c) {
    var d;
    d = c.q.getMonth();
    switch(b){
        case 5:
            $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "J",
                "F",
                "M",
                "A",
                "M",
                "J",
                "J",
                "A",
                "S",
                "O",
                "N",
                "D"
            ])[d]);
            break;
        case 4:
            $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                $61de1ee1cac498ae$var$bje,
                $61de1ee1cac498ae$var$cje,
                $61de1ee1cac498ae$var$dje,
                $61de1ee1cac498ae$var$eje,
                $61de1ee1cac498ae$var$fje,
                $61de1ee1cac498ae$var$gje,
                $61de1ee1cac498ae$var$hje,
                $61de1ee1cac498ae$var$ije,
                $61de1ee1cac498ae$var$jje,
                $61de1ee1cac498ae$var$kje,
                $61de1ee1cac498ae$var$lje,
                $61de1ee1cac498ae$var$mje
            ])[d]);
            break;
        case 3:
            $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                $61de1ee1cac498ae$var$fje,
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ])[d]);
            break;
        default:
            $61de1ee1cac498ae$var$EA(a, d + 1, b);
    }
}
function $61de1ee1cac498ae$var$uGb(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, "Network simplex", 1);
    if (a.e.a.c.length < 1) {
        $61de1ee1cac498ae$var$Qdd(b);
        return;
    }
    for(f = new $61de1ee1cac498ae$var$olb(a.e.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 121);
        e.e = 0;
    }
    g = a.e.a.c.length >= 40;
    g && $61de1ee1cac498ae$var$FGb(a);
    $61de1ee1cac498ae$var$wGb(a);
    $61de1ee1cac498ae$var$vGb(a);
    c = $61de1ee1cac498ae$var$zGb(a);
    d = 0;
    while(!!c && d < a.f){
        $61de1ee1cac498ae$var$tGb(a, c, $61de1ee1cac498ae$var$sGb(a, c));
        c = $61de1ee1cac498ae$var$zGb(a);
        ++d;
    }
    g && $61de1ee1cac498ae$var$EGb(a);
    a.a ? $61de1ee1cac498ae$var$qGb(a, $61de1ee1cac498ae$var$CGb(a)) : $61de1ee1cac498ae$var$CGb(a);
    a.b = null;
    a.d = null;
    a.p = null;
    a.c = null;
    a.g = null;
    a.i = null;
    a.n = null;
    a.o = null;
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$JQb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    i = new $61de1ee1cac498ae$var$f7c(c, d);
    $61de1ee1cac498ae$var$c7c(i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$ESb)), 8));
    for(m = new $61de1ee1cac498ae$var$olb(b.e); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 144);
        $61de1ee1cac498ae$var$P6c(l.d, i);
        $61de1ee1cac498ae$var$Ekb(a.e, l);
    }
    for(h = new $61de1ee1cac498ae$var$olb(b.c); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 282);
        for(f = new $61de1ee1cac498ae$var$olb(g.a); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 559);
            $61de1ee1cac498ae$var$P6c(e.d, i);
        }
        $61de1ee1cac498ae$var$Ekb(a.c, g);
    }
    for(k = new $61de1ee1cac498ae$var$olb(b.d); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 447);
        $61de1ee1cac498ae$var$P6c(j.d, i);
        $61de1ee1cac498ae$var$Ekb(a.d, j);
    }
}
function $61de1ee1cac498ae$var$_Bc(a, b) {
    var c, d, e, f, g, h, i, j;
    for(i = new $61de1ee1cac498ae$var$olb(b.j); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 11);
        for(e = new $61de1ee1cac498ae$var$b1b(h.b); $61de1ee1cac498ae$var$llb(e.a) || $61de1ee1cac498ae$var$llb(e.b);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(e.a) ? $61de1ee1cac498ae$var$mlb(e.a) : $61de1ee1cac498ae$var$mlb(e.b), 17);
            c = d.c == h ? d.d : d.c;
            f = c.i;
            if (b == f) continue;
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$cyc)), 19).a;
            j < 0 && (j = 0);
            g = f.p;
            if (a.b[g] == 0) {
                if (d.d == c) {
                    a.a[g] -= j + 1;
                    a.a[g] <= 0 && a.c[g] > 0 && $61de1ee1cac498ae$var$Dsb(a.f, f);
                } else {
                    a.c[g] -= j + 1;
                    a.c[g] <= 0 && a.a[g] > 0 && $61de1ee1cac498ae$var$Dsb(a.e, f);
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$_Kb(a) {
    var b, c, d, e, f, g, h, i, j;
    h = new $61de1ee1cac498ae$var$Hxb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb(new $61de1ee1cac498ae$var$nLb), 62));
    j = $61de1ee1cac498ae$var$Qje;
    for(c = new $61de1ee1cac498ae$var$olb(a.d); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 222);
        j = b.c.c;
        while(h.a.c != 0){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$zjb($61de1ee1cac498ae$var$Bwb(h.a)), 222);
            if (i.c.c + i.c.b < j) $61de1ee1cac498ae$var$Jwb(h.a, i);
            else break;
        }
        for(g = (e = new $61de1ee1cac498ae$var$Ywb(new $61de1ee1cac498ae$var$cxb(new $61de1ee1cac498ae$var$Gjb(h.a).a).b), new $61de1ee1cac498ae$var$Njb(e)); $61de1ee1cac498ae$var$sib(g.a.a);){
            f = (d = $61de1ee1cac498ae$var$Wwb(g.a), $61de1ee1cac498ae$var$BD(d.cd(), 222));
            $61de1ee1cac498ae$var$Dsb(f.b, b);
            $61de1ee1cac498ae$var$Dsb(b.b, f);
        }
        $61de1ee1cac498ae$var$Iwb(h.a, b, ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb));
    }
}
function $61de1ee1cac498ae$var$QEc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    f = new $61de1ee1cac498ae$var$Skb(b.c.length);
    for(j = new $61de1ee1cac498ae$var$olb(b); j.a < j.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        $61de1ee1cac498ae$var$Ekb(f, a.b[g.c.p][g.p]);
    }
    $61de1ee1cac498ae$var$LEc(a, f, c);
    l = null;
    while(l = $61de1ee1cac498ae$var$MEc(f))$61de1ee1cac498ae$var$NEc(a, $61de1ee1cac498ae$var$BD(l.a, 233), $61de1ee1cac498ae$var$BD(l.b, 233), f);
    b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    for(e = new $61de1ee1cac498ae$var$olb(f); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 233);
        for(h = d.d, i = 0, k = h.length; i < k; ++i){
            g = h[i];
            b.c[b.c.length] = g;
            a.a[g.c.p][g.p].a = $61de1ee1cac498ae$var$REc(d.g, d.d[0]).a;
        }
    }
}
function $61de1ee1cac498ae$var$JRc(a, b) {
    var c, d, e, f;
    if (0 < ($61de1ee1cac498ae$var$JD(a, 14) ? $61de1ee1cac498ae$var$BD(a, 14).gc() : $61de1ee1cac498ae$var$sr(a.Kc()))) {
        e = b;
        if (1 < e) {
            --e;
            f = new $61de1ee1cac498ae$var$KRc;
            for(d = a.Kc(); d.Ob();){
                c = $61de1ee1cac498ae$var$BD(d.Pb(), 86);
                f = $61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                    f,
                    new $61de1ee1cac498ae$var$ZRc(c)
                ]));
            }
            return $61de1ee1cac498ae$var$JRc(f, e);
        }
        if (e < 0) {
            f = new $61de1ee1cac498ae$var$NRc;
            for(d = a.Kc(); d.Ob();){
                c = $61de1ee1cac498ae$var$BD(d.Pb(), 86);
                f = $61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                    f,
                    new $61de1ee1cac498ae$var$ZRc(c)
                ]));
            }
            if (0 < ($61de1ee1cac498ae$var$JD(f, 14) ? $61de1ee1cac498ae$var$BD(f, 14).gc() : $61de1ee1cac498ae$var$sr(f.Kc()))) return $61de1ee1cac498ae$var$JRc(f, e);
        }
    }
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$pr(a.Kc()), 86);
}
function $61de1ee1cac498ae$var$Idd() {
    $61de1ee1cac498ae$var$Idd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Bdd = new $61de1ee1cac498ae$var$Jdd("DEFAULT_MINIMUM_SIZE", 0);
    $61de1ee1cac498ae$var$Ddd = new $61de1ee1cac498ae$var$Jdd("MINIMUM_SIZE_ACCOUNTS_FOR_PADDING", 1);
    $61de1ee1cac498ae$var$Add = new $61de1ee1cac498ae$var$Jdd("COMPUTE_PADDING", 2);
    $61de1ee1cac498ae$var$Edd = new $61de1ee1cac498ae$var$Jdd("OUTSIDE_NODE_LABELS_OVERHANG", 3);
    $61de1ee1cac498ae$var$Fdd = new $61de1ee1cac498ae$var$Jdd("PORTS_OVERHANG", 4);
    $61de1ee1cac498ae$var$Hdd = new $61de1ee1cac498ae$var$Jdd("UNIFORM_PORT_SPACING", 5);
    $61de1ee1cac498ae$var$Gdd = new $61de1ee1cac498ae$var$Jdd("SPACE_EFFICIENT_PORT_LABELS", 6);
    $61de1ee1cac498ae$var$Cdd = new $61de1ee1cac498ae$var$Jdd("FORCE_TABULAR_NODE_LABELS", 7);
    $61de1ee1cac498ae$var$zdd = new $61de1ee1cac498ae$var$Jdd("ASYMMETRICAL", 8);
}
function $61de1ee1cac498ae$var$s6d(a, b) {
    var c, d, e, f, g, h, i, j;
    if (!b) return null;
    else {
        c = (f = b.Tg(), !f ? null : $61de1ee1cac498ae$var$bKd(f).Nh().Jh(f));
        if (c) {
            $61de1ee1cac498ae$var$Xrb(a, b, c);
            e = b.Tg();
            for(i = 0, j = (e.i == null && $61de1ee1cac498ae$var$TKd(e), e.i).length; i < j; ++i){
                h = (d = (e.i == null && $61de1ee1cac498ae$var$TKd(e), e.i), i >= 0 && i < d.length ? d[i] : null);
                if (h.Ij() && !h.Jj()) {
                    if ($61de1ee1cac498ae$var$JD(h, 322)) $61de1ee1cac498ae$var$u6d(a, $61de1ee1cac498ae$var$BD(h, 34), b, c);
                    else {
                        g = $61de1ee1cac498ae$var$BD(h, 18);
                        (g.Bb & $61de1ee1cac498ae$var$ote) != 0 && $61de1ee1cac498ae$var$w6d(a, g, b, c);
                    }
                }
            }
            b.kh() && $61de1ee1cac498ae$var$BD(c, 49).vh($61de1ee1cac498ae$var$BD(b, 49).qh());
        }
        return c;
    }
}
function $61de1ee1cac498ae$var$tGb(a, b, c) {
    var d, e, f;
    if (!b.f) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Given leave edge is no tree edge."));
    if (c.f) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Given enter edge is a tree edge already."));
    b.f = false;
    $61de1ee1cac498ae$var$Sqb(a.p, b);
    c.f = true;
    $61de1ee1cac498ae$var$Qqb(a.p, c);
    d = c.e.e - c.d.e - c.a;
    $61de1ee1cac498ae$var$xGb(a, c.e, b) || (d = -d);
    for(f = new $61de1ee1cac498ae$var$olb(a.e.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 121);
        $61de1ee1cac498ae$var$xGb(a, e, b) || (e.e += d);
    }
    a.j = 1;
    $61de1ee1cac498ae$var$Blb(a.c);
    $61de1ee1cac498ae$var$DGb(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(new $61de1ee1cac498ae$var$olb(a.e.a)), 121));
    $61de1ee1cac498ae$var$rGb(a);
}
function $61de1ee1cac498ae$var$x6b(a, b) {
    var c, d, e, f, g, h;
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    if (!(h == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$_bd) || h == $61de1ee1cac498ae$var$$bd)) return;
    e = new $61de1ee1cac498ae$var$f7c(b.f.a + b.d.b + b.d.c, b.f.b + b.d.d + b.d.a).b;
    for(g = new $61de1ee1cac498ae$var$olb(a.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        if (f.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) continue;
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
        if (c != ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) && c != $61de1ee1cac498ae$var$Tcd) continue;
        d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$htc)));
        h == $61de1ee1cac498ae$var$_bd && (d *= e);
        f.n.b = d - $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$Txc), 8).b;
        $61de1ee1cac498ae$var$M_b(f, false, true);
    }
}
function $61de1ee1cac498ae$var$YDc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    $61de1ee1cac498ae$var$bEc(a, b, c);
    f = b[c];
    n = d ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) : ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd);
    if ($61de1ee1cac498ae$var$ZDc(b.length, c, d)) {
        e = b[d ? c - 1 : c + 1];
        $61de1ee1cac498ae$var$UDc(a, e, d ? ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc) : ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc));
        for(i = f, k = 0, m = i.length; k < m; ++k){
            g = i[k];
            $61de1ee1cac498ae$var$XDc(a, g, n);
        }
        $61de1ee1cac498ae$var$UDc(a, f, d ? ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc) : ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc));
        for(h = e, j = 0, l = h.length; j < l; ++j){
            g = h[j];
            !!g.e || $61de1ee1cac498ae$var$XDc(a, g, $61de1ee1cac498ae$var$Wcd(n));
        }
    } else for(h = f, j = 0, l = h.length; j < l; ++j){
        g = h[j];
        $61de1ee1cac498ae$var$XDc(a, g, n);
    }
    return false;
}
function $61de1ee1cac498ae$var$nFc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    i = $61de1ee1cac498ae$var$V_b(b, c);
    (c == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd) || c == $61de1ee1cac498ae$var$Tcd) && (i = $61de1ee1cac498ae$var$JD(i, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(i, 152)) : $61de1ee1cac498ae$var$JD(i, 131) ? $61de1ee1cac498ae$var$BD(i, 131).a : $61de1ee1cac498ae$var$JD(i, 54) ? new $61de1ee1cac498ae$var$ov(i) : new $61de1ee1cac498ae$var$dv(i));
    g = false;
    do {
        e = false;
        for(f = 0; f < i.gc() - 1; f++){
            j = $61de1ee1cac498ae$var$BD(i.Xb(f), 11);
            h = $61de1ee1cac498ae$var$BD(i.Xb(f + 1), 11);
            if ($61de1ee1cac498ae$var$oFc(a, j, h, d)) {
                g = true;
                $61de1ee1cac498ae$var$cIc(a.a, $61de1ee1cac498ae$var$BD(i.Xb(f), 11), $61de1ee1cac498ae$var$BD(i.Xb(f + 1), 11));
                k = $61de1ee1cac498ae$var$BD(i.Xb(f + 1), 11);
                i._c(f + 1, $61de1ee1cac498ae$var$BD(i.Xb(f), 11));
                i._c(f, k);
                e = true;
            }
        }
    }while (e);
    return g;
}
function $61de1ee1cac498ae$var$W2d(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    if ($61de1ee1cac498ae$var$oid(a.e)) {
        if (b != c) {
            e = $61de1ee1cac498ae$var$BD(a.g, 119);
            n = e[c];
            g = n.ak();
            if ($61de1ee1cac498ae$var$T6d(a.e, g)) {
                o = $61de1ee1cac498ae$var$S6d(a.e.Tg(), g);
                i = -1;
                h = -1;
                d = 0;
                for(j = 0, l = b > c ? b : c; j <= l; ++j)if (j == c) h = d++;
                else {
                    f = e[j];
                    k = o.rl(f.ak());
                    j == b && (i = j == l && !k ? d - 1 : d);
                    k && ++d;
                }
                m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wxd(a, b, c), 72);
                h != i && $61de1ee1cac498ae$var$GLd(a, new $61de1ee1cac498ae$var$ESd(a.e, 7, g, $61de1ee1cac498ae$var$meb(h), n.dd(), i));
                return m;
            }
        }
    } else return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$sud(a, b, c), 72);
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wxd(a, b, c), 72);
}
function $61de1ee1cac498ae$var$Qcc(a, b) {
    var c, d, e, f, g, h, i;
    $61de1ee1cac498ae$var$Odd(b, "Port order processing", 1);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$_xc)), 421);
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        for(f = new $61de1ee1cac498ae$var$olb(c.a); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$Vxc), 98);
            h = e.j;
            if (g == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$Zbd) || g == $61de1ee1cac498ae$var$_bd || g == $61de1ee1cac498ae$var$$bd) {
                $61de1ee1cac498ae$var$mmb();
                $61de1ee1cac498ae$var$Okb(h, $61de1ee1cac498ae$var$Icc);
            } else if (g != $61de1ee1cac498ae$var$bcd && g != $61de1ee1cac498ae$var$ccd) {
                $61de1ee1cac498ae$var$mmb();
                $61de1ee1cac498ae$var$Okb(h, $61de1ee1cac498ae$var$Lcc);
                $61de1ee1cac498ae$var$Scc(h);
                i == ($61de1ee1cac498ae$var$BAc(), $61de1ee1cac498ae$var$AAc) && $61de1ee1cac498ae$var$Okb(h, $61de1ee1cac498ae$var$Kcc);
            }
            e.i = true;
            $61de1ee1cac498ae$var$N_b(e);
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$vDc(a) {
    var b, c, d, e, f, g, h, i;
    i = new $61de1ee1cac498ae$var$Lqb;
    b = new $61de1ee1cac498ae$var$KFb;
    for(g = a.Kc(); g.Ob();){
        e = $61de1ee1cac498ae$var$BD(g.Pb(), 10);
        h = $61de1ee1cac498ae$var$nGb($61de1ee1cac498ae$var$oGb(new $61de1ee1cac498ae$var$pGb, e), b);
        $61de1ee1cac498ae$var$jrb(i.f, e, h);
    }
    for(f = a.Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 10);
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(e).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
            if ($61de1ee1cac498ae$var$OZb(c)) continue;
            $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, $61de1ee1cac498ae$var$$wnd.Math.max(1, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$dyc)), 19).a)), 1), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(i, c.c.i), 121)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(i, c.d.i), 121)));
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$tNc() {
    $61de1ee1cac498ae$var$tNc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$oNc = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$oUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$k8b));
    $61de1ee1cac498ae$var$qNc = $61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$o8b);
    $61de1ee1cac498ae$var$rNc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$C8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$B8b);
    $61de1ee1cac498ae$var$nNc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$e8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$f8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$g8b);
    $61de1ee1cac498ae$var$sNc = $61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$b3c($61de1ee1cac498ae$var$g3c($61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$lUb, $61de1ee1cac498ae$var$M8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$L8b), $61de1ee1cac498ae$var$oUb), $61de1ee1cac498ae$var$K8b), $61de1ee1cac498ae$var$N8b);
    $61de1ee1cac498ae$var$pNc = $61de1ee1cac498ae$var$c3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$l8b);
    $61de1ee1cac498ae$var$lNc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$r8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$t8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$u8b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$s8b);
    $61de1ee1cac498ae$var$mNc = $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$u8b), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$_7b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$$7b);
}
function $61de1ee1cac498ae$var$XC(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m;
    j = $61de1ee1cac498ae$var$$C(b) - $61de1ee1cac498ae$var$$C(a);
    g = $61de1ee1cac498ae$var$kD(b, j);
    i = $61de1ee1cac498ae$var$TC(0, 0, 0);
    while(j >= 0){
        h = $61de1ee1cac498ae$var$bD(a, g);
        if (h) {
            j < 22 ? (i.l |= 1 << j, undefined) : j < 44 ? (i.m |= 1 << j - 22, undefined) : (i.h |= 1 << j - 44, undefined);
            if (a.l == 0 && a.m == 0 && a.h == 0) break;
        }
        k = g.m;
        l = g.h;
        m = g.l;
        g.h = l >>> 1;
        g.m = k >>> 1 | (l & 1) << 21;
        g.l = m >>> 1 | (k & 1) << 21;
        --j;
    }
    c && $61de1ee1cac498ae$var$ZC(i);
    if (f) {
        if (d) {
            $61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$hD(a);
            e && ($61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$nD($61de1ee1cac498ae$var$QC, ($61de1ee1cac498ae$var$wD(), $61de1ee1cac498ae$var$uD)));
        } else $61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$TC(a.l, a.m, a.h);
    }
    return i;
}
function $61de1ee1cac498ae$var$TDc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    j = a.e[b.c.p][b.p] + 1;
    i = b.c.a.c.length + 1;
    for(h = new $61de1ee1cac498ae$var$olb(a.a); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        l = 0;
        f = 0;
        for(e = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
            new $61de1ee1cac498ae$var$J0b(g),
            new $61de1ee1cac498ae$var$R0b(g)
        ]))); $61de1ee1cac498ae$var$Qr(e);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 11);
            if (d.i.c == b.c) {
                l += $61de1ee1cac498ae$var$aEc(a, d.i) + 1;
                ++f;
            }
        }
        c = l / f;
        k = g.j;
        k == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) ? c < j ? a.f[g.p] = a.c - c : a.f[g.p] = a.b + (i - c) : k == $61de1ee1cac498ae$var$Tcd && (c < j ? a.f[g.p] = a.b + c : a.f[g.p] = a.c - (i - c));
    }
}
function $61de1ee1cac498ae$var$Icb(a, b, c) {
    var d, e, f, g, h;
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Xhe));
    f = a.length;
    g = f > 0 && ($61de1ee1cac498ae$var$BCb(0, a.length), a.charCodeAt(0) == 45 || ($61de1ee1cac498ae$var$BCb(0, a.length), a.charCodeAt(0) == 43)) ? 1 : 0;
    for(d = g; d < f; d++){
        if ($61de1ee1cac498ae$var$Zcb(($61de1ee1cac498ae$var$BCb(d, a.length), a.charCodeAt(d))) == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + a + '"'));
    }
    h = parseInt(a, 10);
    e = h < b;
    if (isNaN(h)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + a + '"'));
    else if (e || h > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + a + '"'));
    return h;
}
function $61de1ee1cac498ae$var$dnc(a) {
    var b, c, d, e, f, g, h;
    g = new $61de1ee1cac498ae$var$Psb;
    for(f = new $61de1ee1cac498ae$var$olb(a.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 112);
        $61de1ee1cac498ae$var$pOc(e, e.f.c.length);
        $61de1ee1cac498ae$var$qOc(e, e.k.c.length);
        if (e.i == 0) {
            e.o = 0;
            $61de1ee1cac498ae$var$Gsb(g, e, g.c.b, g.c);
        }
    }
    while(g.b != 0){
        e = $61de1ee1cac498ae$var$BD(g.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(g.b != 0), $61de1ee1cac498ae$var$Nsb(g, g.a.a)), 112);
        d = e.o + 1;
        for(c = new $61de1ee1cac498ae$var$olb(e.f); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 129);
            h = b.a;
            $61de1ee1cac498ae$var$rOc(h, $61de1ee1cac498ae$var$$wnd.Math.max(h.o, d));
            $61de1ee1cac498ae$var$qOc(h, h.i - 1);
            h.i == 0 && $61de1ee1cac498ae$var$Gsb(g, h, g.c.b, g.c);
        }
    }
}
function $61de1ee1cac498ae$var$v2c(a) {
    var b, c, d, e, f, g, h, i;
    for(g = new $61de1ee1cac498ae$var$olb(a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 79);
        d = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!f.b && (f.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, f, 4, 7)), f.b), 0), 82));
        h = d.i;
        i = d.j;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!f.a && (f.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, f, 6, 6)), f.a), 0), 202);
        $61de1ee1cac498ae$var$nmd(e, e.j + h, e.k + i);
        $61de1ee1cac498ae$var$gmd(e, e.b + h, e.c + i);
        for(c = new $61de1ee1cac498ae$var$Fyd((!e.a && (e.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, e, 5)), e.a)); c.e != c.i.gc();){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 469);
            $61de1ee1cac498ae$var$ukd(b, b.a + h, b.b + i);
        }
        $61de1ee1cac498ae$var$p7c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(f, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Q8c)), 74), h, i);
    }
}
function $61de1ee1cac498ae$var$fee(a) {
    var b;
    switch(a){
        case 100:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$nxe, true);
        case 68:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$nxe, false);
        case 119:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$oxe, true);
        case 87:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$oxe, false);
        case 115:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$pxe, true);
        case 83:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$pxe, false);
        case 99:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$qxe, true);
        case 67:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$qxe, false);
        case 105:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$rxe, true);
        case 73:
            return $61de1ee1cac498ae$var$kee($61de1ee1cac498ae$var$rxe, false);
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz((b = a, $61de1ee1cac498ae$var$mxe + b.toString(16))));
    }
}
function $61de1ee1cac498ae$var$$Xb(a) {
    var b, c, d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, 0), 10);
    b = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$Ekb(a.a, b);
    b.o.a = $61de1ee1cac498ae$var$$wnd.Math.max(1, e.o.a);
    b.o.b = $61de1ee1cac498ae$var$$wnd.Math.max(1, e.o.b);
    b.n.a = e.n.a;
    b.n.b = e.n.b;
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61).g){
        case 4:
            b.n.a += 2;
            break;
        case 1:
            b.n.b += 2;
            break;
        case 2:
            b.n.a -= 2;
            break;
        case 3:
            b.n.b -= 2;
    }
    d = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(d, b);
    c = new $61de1ee1cac498ae$var$UZb;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e.j, 0), 11);
    $61de1ee1cac498ae$var$QZb(c, f);
    $61de1ee1cac498ae$var$RZb(c, d);
    $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(d.n), f.n);
    $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(d.a), f.a);
    return b;
}
function $61de1ee1cac498ae$var$Fac(a, b, c, d, e) {
    if (c && (!d || (a.c - a.b & a.a.length - 1) > 1) && b == 1 && $61de1ee1cac498ae$var$BD(a.a[a.b], 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) $61de1ee1cac498ae$var$zac($61de1ee1cac498ae$var$BD(a.a[a.b], 10), ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd));
    else if (d && (!c || (a.c - a.b & a.a.length - 1) > 1) && b == 1 && $61de1ee1cac498ae$var$BD(a.a[a.c - 1 & a.a.length - 1], 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) $61de1ee1cac498ae$var$zac($61de1ee1cac498ae$var$BD(a.a[a.c - 1 & a.a.length - 1], 10), ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$obd));
    else if ((a.c - a.b & a.a.length - 1) == 2) {
        $61de1ee1cac498ae$var$zac($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bkb(a), 10), ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd));
        $61de1ee1cac498ae$var$zac($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bkb(a), 10), $61de1ee1cac498ae$var$obd);
    } else $61de1ee1cac498ae$var$wac(a, e);
    $61de1ee1cac498ae$var$Yjb(a);
}
function $61de1ee1cac498ae$var$pRc(a, b, c) {
    var d, e, f, g, h;
    f = 0;
    for(e = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 33);
        g = "";
        (!d.n && (d.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, d, 1, 7)), d.n).i == 0 || (g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.n && (d.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, d, 1, 7)), d.n), 0), 137).a);
        h = new $61de1ee1cac498ae$var$XRc(f++, b, g);
        $61de1ee1cac498ae$var$tNb(h, d);
        $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$dTc), d);
        h.e.b = d.j + d.f / 2;
        h.f.a = $61de1ee1cac498ae$var$$wnd.Math.max(d.g, 1);
        h.e.a = d.i + d.g / 2;
        h.f.b = $61de1ee1cac498ae$var$$wnd.Math.max(d.f, 1);
        $61de1ee1cac498ae$var$Dsb(b.b, h);
        $61de1ee1cac498ae$var$jrb(c.f, d, h);
    }
}
function $61de1ee1cac498ae$var$B2b(a) {
    var b, c, d, e, f;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 33);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fxc)), 174).Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd));
    if (!a.e) {
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ksc), 21);
        b = new $61de1ee1cac498ae$var$f7c(a.f.a + a.d.b + a.d.c, a.f.b + a.d.d + a.d.a);
        if (e.Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc))) {
            $61de1ee1cac498ae$var$jkd(d, $61de1ee1cac498ae$var$Vxc, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
            $61de1ee1cac498ae$var$Afd(d, b.a, b.b, false, true);
        } else $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$Gxc))) || $61de1ee1cac498ae$var$Afd(d, b.a, b.b, true, true);
    }
    f ? $61de1ee1cac498ae$var$jkd(d, $61de1ee1cac498ae$var$Fxc, $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$sdd)) : $61de1ee1cac498ae$var$jkd(d, $61de1ee1cac498ae$var$Fxc, (c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$I1), 9), new $61de1ee1cac498ae$var$xqb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(c, c.length), 9), 0)));
}
function $61de1ee1cac498ae$var$tA(a, b, c) {
    var d, e, f, g;
    if (b[0] >= a.length) {
        c.o = 0;
        return true;
    }
    switch($61de1ee1cac498ae$var$bfb(a, b[0])){
        case 43:
            e = 1;
            break;
        case 45:
            e = -1;
            break;
        default:
            c.o = 0;
            return true;
    }
    ++b[0];
    f = b[0];
    g = $61de1ee1cac498ae$var$rA(a, b);
    if (g == 0 && b[0] == f) return false;
    if (b[0] < a.length && $61de1ee1cac498ae$var$bfb(a, b[0]) == 58) {
        d = g * 60;
        ++b[0];
        f = b[0];
        g = $61de1ee1cac498ae$var$rA(a, b);
        if (g == 0 && b[0] == f) return false;
        d += g;
    } else {
        d = g;
        d < 24 && b[0] - f <= 2 ? d *= 60 : d = d % 100 + (d / 100 | 0) * 60;
    }
    d *= e;
    c.o = -d;
    return true;
}
function $61de1ee1cac498ae$var$Hjc(a) {
    var b, c, d, e, f, g, h, i, j;
    g = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(a.b).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
        $61de1ee1cac498ae$var$OZb(c) && $61de1ee1cac498ae$var$Ekb(g, new $61de1ee1cac498ae$var$Gjc(c, $61de1ee1cac498ae$var$Jjc(a, c.c), $61de1ee1cac498ae$var$Jjc(a, c.d)));
    }
    for(j = (f = new $61de1ee1cac498ae$var$$ib(a.e).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(f)); j.a.Ob();){
        h = (b = $61de1ee1cac498ae$var$BD(j.a.Pb(), 42), $61de1ee1cac498ae$var$BD(b.dd(), 113));
        h.d.p = 0;
    }
    for(i = (e = new $61de1ee1cac498ae$var$$ib(a.e).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(e)); i.a.Ob();){
        h = (b = $61de1ee1cac498ae$var$BD(i.a.Pb(), 42), $61de1ee1cac498ae$var$BD(b.dd(), 113));
        h.d.p == 0 && $61de1ee1cac498ae$var$Ekb(a.d, $61de1ee1cac498ae$var$Ijc(a, h));
    }
}
function $61de1ee1cac498ae$var$W1b(a) {
    var b, c, d, e, f, g, h;
    f = $61de1ee1cac498ae$var$mpd(a);
    for(e = new $61de1ee1cac498ae$var$Fyd((!a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4)), a.e)); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 79);
        h = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c), 0), 82));
        if (!$61de1ee1cac498ae$var$ntd(h, f)) return true;
    }
    for(c = new $61de1ee1cac498ae$var$Fyd((!a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5)), a.d)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 79);
        g = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.b && (b.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 4, 7)), b.b), 0), 82));
        if (!$61de1ee1cac498ae$var$ntd(g, f)) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$Dmc(a) {
    var b, c, d, e, f, g, h, i;
    i = new $61de1ee1cac498ae$var$s7c;
    b = $61de1ee1cac498ae$var$Jsb(a, 0);
    h = null;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(b), 8);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(b), 8);
    while(b.b != b.d.c){
        h = c;
        c = e;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(b), 8);
        f = $61de1ee1cac498ae$var$Emc($61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(h.a, h.b), c));
        g = $61de1ee1cac498ae$var$Emc($61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(e.a, e.b), c));
        d = 10;
        d = $61de1ee1cac498ae$var$$wnd.Math.min(d, $61de1ee1cac498ae$var$$wnd.Math.abs(f.a + f.b) / 2);
        d = $61de1ee1cac498ae$var$$wnd.Math.min(d, $61de1ee1cac498ae$var$$wnd.Math.abs(g.a + g.b) / 2);
        f.a = $61de1ee1cac498ae$var$Eeb(f.a) * d;
        f.b = $61de1ee1cac498ae$var$Eeb(f.b) * d;
        g.a = $61de1ee1cac498ae$var$Eeb(g.a) * d;
        g.b = $61de1ee1cac498ae$var$Eeb(g.b) * d;
        $61de1ee1cac498ae$var$Dsb(i, $61de1ee1cac498ae$var$P6c(f, c));
        $61de1ee1cac498ae$var$Dsb(i, $61de1ee1cac498ae$var$P6c(g, c));
    }
    return i;
}
function $61de1ee1cac498ae$var$_hd(a, b, c, d) {
    var e, f, g, h, i;
    g = a.eh();
    i = a.Zg();
    e = null;
    if (i) {
        if (!!b && ($61de1ee1cac498ae$var$Nid(a, b, c).Bb & $61de1ee1cac498ae$var$Tje) == 0) {
            d = $61de1ee1cac498ae$var$Txd(i.Vk(), a, d);
            a.uh(null);
            e = b.fh();
        } else i = null;
    } else {
        !!g && (i = g.fh());
        !!b && (e = b.fh());
    }
    i != e && !!i && i.Zk(a);
    h = a.Vg();
    a.Rg(b, c);
    i != e && !!e && e.Yk(a);
    if (a.Lg() && a.Mg()) {
        if (!!g && h >= 0 && h != c) {
            f = new $61de1ee1cac498ae$var$nSd(a, 1, h, g, null);
            !d ? d = f : d.Ei(f);
        }
        if (c >= 0) {
            f = new $61de1ee1cac498ae$var$nSd(a, 1, c, h == c ? g : null, b);
            !d ? d = f : d.Ei(f);
        }
    }
    return d;
}
function $61de1ee1cac498ae$var$LEd(a) {
    var b, c, d;
    if (a.b == null) {
        d = new $61de1ee1cac498ae$var$Hfb;
        if (a.i != null) {
            $61de1ee1cac498ae$var$Efb(d, a.i);
            d.a += ":";
        }
        if ((a.f & 256) != 0) {
            if ((a.f & 256) != 0 && a.a != null) {
                $61de1ee1cac498ae$var$YEd(a.i) || (d.a += "//", d);
                $61de1ee1cac498ae$var$Efb(d, a.a);
            }
            if (a.d != null) {
                d.a += "/";
                $61de1ee1cac498ae$var$Efb(d, a.d);
            }
            (a.f & 16) != 0 && (d.a += "/", d);
            for(b = 0, c = a.j.length; b < c; b++){
                b != 0 && (d.a += "/", d);
                $61de1ee1cac498ae$var$Efb(d, a.j[b]);
            }
            if (a.g != null) {
                d.a += "?";
                $61de1ee1cac498ae$var$Efb(d, a.g);
            }
        } else $61de1ee1cac498ae$var$Efb(d, a.a);
        if (a.e != null) {
            d.a += "#";
            $61de1ee1cac498ae$var$Efb(d, a.e);
        }
        a.b = d.a;
    }
    return a.b;
}
function $61de1ee1cac498ae$var$E5b(a, b) {
    var c, d, e, f, g, h;
    for(e = new $61de1ee1cac498ae$var$olb(b.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        f = $61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc));
        if ($61de1ee1cac498ae$var$JD(f, 11)) {
            g = $61de1ee1cac498ae$var$BD(f, 11);
            h = $61de1ee1cac498ae$var$b_b(b, d, g.o.a, g.o.b);
            g.n.a = h.a;
            g.n.b = h.b;
            $61de1ee1cac498ae$var$G0b(g, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Hsc), 61));
        }
    }
    c = new $61de1ee1cac498ae$var$f7c(b.f.a + b.d.b + b.d.c, b.f.b + b.d.d + b.d.a);
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc))) {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), $61de1ee1cac498ae$var$Ksc), 21).Fc($61de1ee1cac498ae$var$Krc);
        $61de1ee1cac498ae$var$j_b(a, c, false);
    } else $61de1ee1cac498ae$var$j_b(a, c, true);
}
function $61de1ee1cac498ae$var$YFc(a, b, c) {
    var d, e, f, g, h, i;
    $61de1ee1cac498ae$var$Odd(c, "Minimize Crossings " + a.a, 1);
    d = b.b.c.length == 0 || !$61de1ee1cac498ae$var$WAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.b, 16)), new $61de1ee1cac498ae$var$Xxb(new $61de1ee1cac498ae$var$xGc))).sd(($61de1ee1cac498ae$var$EAb(), $61de1ee1cac498ae$var$DAb));
    i = b.b.c.length == 1 && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.b, 0), 29).a.c.length == 1;
    f = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$axc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd));
    if (d || i && !f) {
        $61de1ee1cac498ae$var$Qdd(c);
        return;
    }
    e = $61de1ee1cac498ae$var$TFc(a, b);
    g = (h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(e, 0), 214), h.c.Rf() ? h.c.Lf() ? new $61de1ee1cac498ae$var$kGc(a) : new $61de1ee1cac498ae$var$mGc(a) : new $61de1ee1cac498ae$var$iGc(a));
    $61de1ee1cac498ae$var$UFc(e, g);
    $61de1ee1cac498ae$var$eGc(a);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$so(a, b, c, d) {
    var e, f, g, h, i;
    i = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(b == null ? 0 : $61de1ee1cac498ae$var$tb(b), $61de1ee1cac498ae$var$Fie)), 15)));
    e = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(c == null ? 0 : $61de1ee1cac498ae$var$tb(c), $61de1ee1cac498ae$var$Fie)), 15)));
    h = $61de1ee1cac498ae$var$vo(a, b, i);
    g = $61de1ee1cac498ae$var$uo(a, c, e);
    if (!!h && e == h.a && $61de1ee1cac498ae$var$Hb(c, h.g)) return c;
    else if (!!g && !d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("key already present: " + c));
    !!h && $61de1ee1cac498ae$var$mo(a, h);
    !!g && $61de1ee1cac498ae$var$mo(a, g);
    f = new $61de1ee1cac498ae$var$$o(c, e, b, i);
    $61de1ee1cac498ae$var$po(a, f, g);
    if (g) {
        g.e = null;
        g.c = null;
    }
    if (h) {
        h.e = null;
        h.c = null;
    }
    $61de1ee1cac498ae$var$to(a);
    return !h ? null : h.g;
}
function $61de1ee1cac498ae$var$Lhb(a, b, c) {
    var d, e, f, g, h;
    for(f = 0; f < b; f++){
        d = 0;
        for(h = f + 1; h < b; h++){
            d = $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$xbb(a[f], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(a[h], $61de1ee1cac498ae$var$Yje)), $61de1ee1cac498ae$var$xbb(c[f + h], $61de1ee1cac498ae$var$Yje)), $61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Tbb(d), $61de1ee1cac498ae$var$Yje));
            c[f + h] = $61de1ee1cac498ae$var$Tbb(d);
            d = $61de1ee1cac498ae$var$Pbb(d, 32);
        }
        c[f + b] = $61de1ee1cac498ae$var$Tbb(d);
    }
    $61de1ee1cac498ae$var$khb(c, c, b << 1);
    d = 0;
    for(e = 0, g = 0; e < b; ++e, g++){
        d = $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$xbb(a[e], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(a[e], $61de1ee1cac498ae$var$Yje)), $61de1ee1cac498ae$var$xbb(c[g], $61de1ee1cac498ae$var$Yje)), $61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Tbb(d), $61de1ee1cac498ae$var$Yje));
        c[g] = $61de1ee1cac498ae$var$Tbb(d);
        d = $61de1ee1cac498ae$var$Pbb(d, 32);
        ++g;
        d = $61de1ee1cac498ae$var$wbb(d, $61de1ee1cac498ae$var$xbb(c[g], $61de1ee1cac498ae$var$Yje));
        c[g] = $61de1ee1cac498ae$var$Tbb(d);
        d = $61de1ee1cac498ae$var$Pbb(d, 32);
    }
    return c;
}
function $61de1ee1cac498ae$var$ZJc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if ($61de1ee1cac498ae$var$Qq(b)) return;
    i = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(c.c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$zyc))));
    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$pBc(c.c, $61de1ee1cac498ae$var$yyc), 142);
    !j && (j = new $61de1ee1cac498ae$var$H_b);
    d = c.a;
    e = null;
    for(h = b.Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 11);
        k = 0;
        if (!e) k = j.d;
        else {
            k = i;
            k += e.o.b;
        }
        f = $61de1ee1cac498ae$var$nGb($61de1ee1cac498ae$var$oGb(new $61de1ee1cac498ae$var$pGb, g), a.f);
        $61de1ee1cac498ae$var$Rhb(a.k, g, f);
        $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, 0), $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(k))), d), f));
        e = g;
        d = f;
    }
    $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, 0), $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(j.a + e.o.b))), d), c.d));
}
function $61de1ee1cac498ae$var$uZc(a, b, c, d, e, f, g, h) {
    var i, j, k, l, m, n;
    n = false;
    m = f - c.s;
    k = c.t - b.f + (j = $61de1ee1cac498ae$var$MZc(c, m, false), j.a);
    if (d.g + h > m) return false;
    l = (i = $61de1ee1cac498ae$var$MZc(d, m, false), i.a);
    if (k + h + l <= b.b) {
        $61de1ee1cac498ae$var$KZc(c, f - c.s);
        c.c = true;
        $61de1ee1cac498ae$var$KZc(d, f - c.s);
        $61de1ee1cac498ae$var$OZc(d, c.s, c.t + c.d + h);
        d.k = true;
        $61de1ee1cac498ae$var$WZc(c.q, d);
        n = true;
        if (e) {
            $61de1ee1cac498ae$var$s$c(b, d);
            d.j = b;
            if (a.c.length > g) {
                $61de1ee1cac498ae$var$v$c(($61de1ee1cac498ae$var$tCb(g, a.c.length), $61de1ee1cac498ae$var$BD(a.c[g], 200)), d);
                ($61de1ee1cac498ae$var$tCb(g, a.c.length), $61de1ee1cac498ae$var$BD(a.c[g], 200)).a.c.length == 0 && $61de1ee1cac498ae$var$Kkb(a, g);
            }
        }
    }
    return n;
}
function $61de1ee1cac498ae$var$kcc(a, b) {
    var c, d, e, f, g, h;
    $61de1ee1cac498ae$var$Odd(b, "Partition midprocessing", 1);
    e = new $61de1ee1cac498ae$var$Hp;
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.a, 16)), new $61de1ee1cac498ae$var$occ), new $61de1ee1cac498ae$var$qcc(e));
    if (e.d == 0) return;
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$UAb((f = e.i, new $61de1ee1cac498ae$var$YAb(null, (!f ? e.i = new $61de1ee1cac498ae$var$zf(e, e.c) : f).Nc()))), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    d = h.Kc();
    c = $61de1ee1cac498ae$var$BD(d.Pb(), 19);
    while(d.Ob()){
        g = $61de1ee1cac498ae$var$BD(d.Pb(), 19);
        $61de1ee1cac498ae$var$jcc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(e, c), 21), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(e, g), 21));
        c = g;
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$DYb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if (b.p == 0) {
        b.p = 1;
        g = c;
        if (!g) {
            e = new $61de1ee1cac498ae$var$Rkb;
            f = (d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$F1), 9), new $61de1ee1cac498ae$var$xqb(d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(d, d.length), 9), 0));
            g = new $61de1ee1cac498ae$var$vgd(e, f);
        }
        $61de1ee1cac498ae$var$BD(g.a, 15).Fc(b);
        b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) && $61de1ee1cac498ae$var$BD(g.b, 21).Fc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61));
        for(i = new $61de1ee1cac498ae$var$olb(b.j); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 11);
            for(k = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                new $61de1ee1cac498ae$var$J0b(h),
                new $61de1ee1cac498ae$var$R0b(h)
            ]))); $61de1ee1cac498ae$var$Qr(k);){
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(k), 11);
                $61de1ee1cac498ae$var$DYb(a, j.i, g);
            }
        }
        return g;
    }
    return null;
}
function $61de1ee1cac498ae$var$Dmd(a, b) {
    var c, d, e, f, g;
    if (a.Ab) {
        if (a.Ab) {
            g = a.Ab.i;
            if (g > 0) {
                e = $61de1ee1cac498ae$var$BD(a.Ab.g, 1934);
                if (b == null) for(f = 0; f < g; ++f){
                    c = e[f];
                    if (c.d == null) return c;
                }
                else for(f = 0; f < g; ++f){
                    c = e[f];
                    if ($61de1ee1cac498ae$var$dfb(b, c.d)) return c;
                }
            }
        } else {
            if (b == null) for(d = new $61de1ee1cac498ae$var$Fyd(a.Ab); d.e != d.i.gc();){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 590);
                if (c.d == null) return c;
            }
            else for(d = new $61de1ee1cac498ae$var$Fyd(a.Ab); d.e != d.i.gc();){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 590);
                if ($61de1ee1cac498ae$var$dfb(b, c.d)) return c;
            }
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$gRc(a, b) {
    var c, d, e, f, g, h, i, j;
    j = $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$GTc)));
    if (j == null || ($61de1ee1cac498ae$var$uCb(j), j)) {
        $61de1ee1cac498ae$var$dRc(a, b);
        e = new $61de1ee1cac498ae$var$Rkb;
        for(i = $61de1ee1cac498ae$var$Jsb(b.b, 0); i.b != i.d.c;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(i), 86);
            c = $61de1ee1cac498ae$var$cRc(a, g, null);
            if (c) {
                $61de1ee1cac498ae$var$tNb(c, b);
                e.c[e.c.length] = c;
            }
        }
        a.a = null;
        a.b = null;
        if (e.c.length > 1) for(d = new $61de1ee1cac498ae$var$olb(e); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 135);
            f = 0;
            for(h = $61de1ee1cac498ae$var$Jsb(c.b, 0); h.b != h.d.c;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(h), 86);
                g.g = f++;
            }
        }
        return e;
    }
    return $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$n$, 1), $61de1ee1cac498ae$var$fme, 135, 0, [
        b
    ]));
}
function $61de1ee1cac498ae$var$rqd(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, p, q, r, s, t, u, v;
    n = $61de1ee1cac498ae$var$Sqd(a, $61de1ee1cac498ae$var$etd(b), e);
    $61de1ee1cac498ae$var$jmd(n, $61de1ee1cac498ae$var$_pd(e, $61de1ee1cac498ae$var$Vte));
    $61de1ee1cac498ae$var$o = null;
    p = e;
    q = $61de1ee1cac498ae$var$$pd(p, $61de1ee1cac498ae$var$Yte);
    r = new $61de1ee1cac498ae$var$urd(n);
    $61de1ee1cac498ae$var$wqd(r.a, q);
    s = $61de1ee1cac498ae$var$$pd(p, "endPoint");
    t = new $61de1ee1cac498ae$var$yrd(n);
    $61de1ee1cac498ae$var$yqd(t.a, s);
    u = $61de1ee1cac498ae$var$Ypd(p, $61de1ee1cac498ae$var$Ote);
    v = new $61de1ee1cac498ae$var$Brd(n);
    $61de1ee1cac498ae$var$zqd(v.a, u);
    l = $61de1ee1cac498ae$var$_pd(e, $61de1ee1cac498ae$var$Qte);
    f = new $61de1ee1cac498ae$var$qrd(a, n);
    $61de1ee1cac498ae$var$sqd(f.a, f.b, l);
    m = $61de1ee1cac498ae$var$_pd(e, $61de1ee1cac498ae$var$Pte);
    g = new $61de1ee1cac498ae$var$rrd(a, n);
    $61de1ee1cac498ae$var$tqd(g.a, g.b, m);
    j = $61de1ee1cac498ae$var$Ypd(e, $61de1ee1cac498ae$var$Ste);
    h = new $61de1ee1cac498ae$var$srd(c, n);
    $61de1ee1cac498ae$var$uqd(h.b, h.a, j);
    k = $61de1ee1cac498ae$var$Ypd(e, $61de1ee1cac498ae$var$Rte);
    i = new $61de1ee1cac498ae$var$trd(d, n);
    $61de1ee1cac498ae$var$vqd(i.b, i.a, k);
}
function $61de1ee1cac498ae$var$i_b(a, b, c) {
    var d, e, f, g, h;
    h = null;
    switch(b.g){
        case 1:
            for(e = new $61de1ee1cac498ae$var$olb(a.j); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 11);
                if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Msc))))) return d;
            }
            h = new $61de1ee1cac498ae$var$H0b;
            $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Msc), ($61de1ee1cac498ae$var$Bcb(), true));
            break;
        case 2:
            for(g = new $61de1ee1cac498ae$var$olb(a.j); g.a < g.c.c.length;){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 11);
                if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$etc))))) return f;
            }
            h = new $61de1ee1cac498ae$var$H0b;
            $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$etc), ($61de1ee1cac498ae$var$Bcb(), true));
    }
    if (h) {
        $61de1ee1cac498ae$var$F0b(h, a);
        $61de1ee1cac498ae$var$G0b(h, c);
        $61de1ee1cac498ae$var$X$b(h.n, a.o, c);
    }
    return h;
}
function $61de1ee1cac498ae$var$O3b(a, b) {
    var c, d, e, f, g, h;
    h = -1;
    g = new $61de1ee1cac498ae$var$Psb;
    for(d = new $61de1ee1cac498ae$var$b1b(a.b); $61de1ee1cac498ae$var$llb(d.a) || $61de1ee1cac498ae$var$llb(d.b);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(d.a) ? $61de1ee1cac498ae$var$mlb(d.a) : $61de1ee1cac498ae$var$mlb(d.b), 17);
        h = $61de1ee1cac498ae$var$$wnd.Math.max(h, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Zwc)))));
        c.c == a ? $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.b, 16)), new $61de1ee1cac498ae$var$U3b), new $61de1ee1cac498ae$var$W3b(g)) : $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.b, 16)), new $61de1ee1cac498ae$var$Y3b), new $61de1ee1cac498ae$var$$3b(g));
        for(f = $61de1ee1cac498ae$var$Jsb(g, 0); f.b != f.d.c;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 70);
            $61de1ee1cac498ae$var$wNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Dsc)) || $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$Dsc, c);
        }
        $61de1ee1cac498ae$var$Gkb(b, g);
        $61de1ee1cac498ae$var$Osb(g);
    }
    return h;
}
function $61de1ee1cac498ae$var$_bc(a, b, c, d, e) {
    var f, g, h, i;
    f = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$__b(f, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b));
    $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
    $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), b.c.i);
    g = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$yNb(g, $61de1ee1cac498ae$var$$sc, b.c);
    $61de1ee1cac498ae$var$G0b(g, e);
    $61de1ee1cac498ae$var$F0b(g, f);
    $61de1ee1cac498ae$var$yNb(b.c, $61de1ee1cac498ae$var$gtc, f);
    h = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$__b(h, $61de1ee1cac498ae$var$i0b);
    $61de1ee1cac498ae$var$yNb(h, $61de1ee1cac498ae$var$Vxc, $61de1ee1cac498ae$var$$bd);
    $61de1ee1cac498ae$var$yNb(h, $61de1ee1cac498ae$var$$sc, b.d.i);
    i = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$yNb(i, $61de1ee1cac498ae$var$$sc, b.d);
    $61de1ee1cac498ae$var$G0b(i, e);
    $61de1ee1cac498ae$var$F0b(i, h);
    $61de1ee1cac498ae$var$yNb(b.d, $61de1ee1cac498ae$var$gtc, h);
    $61de1ee1cac498ae$var$QZb(b, g);
    $61de1ee1cac498ae$var$RZb(b, i);
    $61de1ee1cac498ae$var$wCb(0, c.c.length);
    $61de1ee1cac498ae$var$aCb(c.c, 0, f);
    d.c[d.c.length] = h;
    $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$ysc, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$yNb(h, $61de1ee1cac498ae$var$ysc, $61de1ee1cac498ae$var$meb(1));
}
function $61de1ee1cac498ae$var$BPc(a, b, c, d, e) {
    var f, g, h, i, j;
    h = e ? d.b : d.a;
    if ($61de1ee1cac498ae$var$Rqb(a.a, d)) return;
    j = h > c.s && h < c.c;
    i = false;
    if (c.e.b != 0 && c.j.b != 0) {
        i = i | ($61de1ee1cac498ae$var$$wnd.Math.abs(h - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Hsb(c.e)))) < $61de1ee1cac498ae$var$qme && $61de1ee1cac498ae$var$$wnd.Math.abs(h - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Hsb(c.j)))) < $61de1ee1cac498ae$var$qme);
        i = i | ($61de1ee1cac498ae$var$$wnd.Math.abs(h - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Isb(c.e)))) < $61de1ee1cac498ae$var$qme && $61de1ee1cac498ae$var$$wnd.Math.abs(h - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Isb(c.j)))) < $61de1ee1cac498ae$var$qme);
    }
    if (j || i) {
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
        if (!g) {
            g = new $61de1ee1cac498ae$var$s7c;
            $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$jxc, g);
        }
        f = new $61de1ee1cac498ae$var$g7c(d);
        $61de1ee1cac498ae$var$Gsb(g, f, g.c.b, g.c);
        $61de1ee1cac498ae$var$Qqb(a.a, f);
    }
}
function $61de1ee1cac498ae$var$gNb(a, b, c, d) {
    var e, f, g, h, i, j, k;
    if ($61de1ee1cac498ae$var$fNb(a, b, c, d)) return true;
    else for(g = new $61de1ee1cac498ae$var$olb(b.f); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 324);
        h = false;
        i = a.j - b.j + c;
        j = i + b.o;
        k = a.k - b.k + d;
        e = k + b.p;
        switch(f.a.g){
            case 0:
                h = $61de1ee1cac498ae$var$oNb(a, i + f.b.a, 0, i + f.c.a, k - 1);
                break;
            case 1:
                h = $61de1ee1cac498ae$var$oNb(a, j, k + f.b.a, a.o - 1, k + f.c.a);
                break;
            case 2:
                h = $61de1ee1cac498ae$var$oNb(a, i + f.b.a, e, i + f.c.a, a.p - 1);
                break;
            default:
                h = $61de1ee1cac498ae$var$oNb(a, 0, k + f.b.a, i - 1, k + f.c.a);
        }
        if (h) return true;
    }
    return false;
}
function $61de1ee1cac498ae$var$LMc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    for(g = new $61de1ee1cac498ae$var$olb(b.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        for(j = new $61de1ee1cac498ae$var$olb(f.a); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
            k = new $61de1ee1cac498ae$var$Rkb;
            h = 0;
            for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(i).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
                if ($61de1ee1cac498ae$var$OZb(c) || !$61de1ee1cac498ae$var$OZb(c) && c.c.i.c == c.d.i.c) continue;
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$eyc)), 19).a;
                if (e > h) {
                    h = e;
                    k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                }
                e == h && $61de1ee1cac498ae$var$Ekb(k, new $61de1ee1cac498ae$var$vgd(c.c.i, c));
            }
            $61de1ee1cac498ae$var$mmb();
            $61de1ee1cac498ae$var$Okb(k, a.c);
            $61de1ee1cac498ae$var$Dkb(a.b, i.p, k);
        }
    }
}
function $61de1ee1cac498ae$var$MMc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    for(g = new $61de1ee1cac498ae$var$olb(b.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        for(j = new $61de1ee1cac498ae$var$olb(f.a); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
            k = new $61de1ee1cac498ae$var$Rkb;
            h = 0;
            for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(i).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
                if ($61de1ee1cac498ae$var$OZb(c) || !$61de1ee1cac498ae$var$OZb(c) && c.c.i.c == c.d.i.c) continue;
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$eyc)), 19).a;
                if (e > h) {
                    h = e;
                    k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                }
                e == h && $61de1ee1cac498ae$var$Ekb(k, new $61de1ee1cac498ae$var$vgd(c.d.i, c));
            }
            $61de1ee1cac498ae$var$mmb();
            $61de1ee1cac498ae$var$Okb(k, a.c);
            $61de1ee1cac498ae$var$Dkb(a.f, i.p, k);
        }
    }
}
function $61de1ee1cac498ae$var$Y7c(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$qse), "ELK Box"), "Algorithm for packing of unconnected boxes, i.e. graphs without edges."), new $61de1ee1cac498ae$var$_7c)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$U7c);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$wme, 15);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$vme, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$Jre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$O7c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Q7c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$S7c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$_le, $61de1ee1cac498ae$var$pse);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$Ame, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$P7c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$R7c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$rse, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$M7c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$qse, $61de1ee1cac498ae$var$lqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$N7c));
}
function $61de1ee1cac498ae$var$W$b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    e = a.i;
    g = e.o.a;
    f = e.o.b;
    if (g <= 0 && f <= 0) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd;
    j = a.n.a;
    k = a.n.b;
    h = a.o.a;
    c = a.o.b;
    switch(b.g){
        case 2:
        case 1:
            if (j < 0) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd;
            else if (j + h > g) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd;
            break;
        case 4:
        case 3:
            if (k < 0) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd;
            else if (k + c > f) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd;
    }
    i = (j + h / 2) / g;
    d = (k + c / 2) / f;
    return i + d <= 1 && i - d <= 0 ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) : i + d >= 1 && i - d >= 0 ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) : d < 0.5 ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) : ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd);
}
function $61de1ee1cac498ae$var$pJc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    c = false;
    k = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc))));
    o = $61de1ee1cac498ae$var$Qie * k;
    for(e = new $61de1ee1cac498ae$var$olb(b.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        j = new $61de1ee1cac498ae$var$olb(d.a);
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        l = $61de1ee1cac498ae$var$xJc(a.a[f.p]);
        while(j.a < j.c.c.length){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
            m = $61de1ee1cac498ae$var$xJc(a.a[h.p]);
            if (l != m) {
                n = $61de1ee1cac498ae$var$jBc(a.b, f, h);
                g = f.n.b + f.o.b + f.d.a + l.a + n;
                i = h.n.b - h.d.d + m.a;
                if (g > i + o) {
                    p = l.g + m.g;
                    m.a = (m.g * m.a + l.g * l.a) / p;
                    m.g = p;
                    l.f = m;
                    c = true;
                }
            }
            f = h;
            l = m;
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$VGb(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m;
    m = new $61de1ee1cac498ae$var$I6c;
    for(j = b.Kc(); j.Ob();){
        h = $61de1ee1cac498ae$var$BD(j.Pb(), 839);
        for(l = new $61de1ee1cac498ae$var$olb(h.wf()); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 181);
            if ($61de1ee1cac498ae$var$PD(k.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$C8c))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$pad))) {
                $61de1ee1cac498ae$var$SGb(m, k, false, d, e, f, g);
                $61de1ee1cac498ae$var$H6c(a, m);
            }
        }
    }
    for(i = c.Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 839);
        for(l = new $61de1ee1cac498ae$var$olb(h.wf()); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 181);
            if ($61de1ee1cac498ae$var$PD(k.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$C8c))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$oad))) {
                $61de1ee1cac498ae$var$SGb(m, k, true, d, e, f, g);
                $61de1ee1cac498ae$var$H6c(a, m);
            }
        }
    }
}
function $61de1ee1cac498ae$var$oRc(a, b, c) {
    var d, e, f, g, h, i, j;
    for(g = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); g.e != g.i.gc();){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(g), 33);
        for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(f).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 79);
            if (!$61de1ee1cac498ae$var$Pld(d) && !$61de1ee1cac498ae$var$Pld(d) && !$61de1ee1cac498ae$var$Qld(d)) {
                i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(c.f, f)), 86);
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(c, $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c), 0), 82))), 86);
                if (!!i && !!j) {
                    h = new $61de1ee1cac498ae$var$QRc(i, j);
                    $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$dTc), d);
                    $61de1ee1cac498ae$var$tNb(h, d);
                    $61de1ee1cac498ae$var$Dsb(i.d, h);
                    $61de1ee1cac498ae$var$Dsb(j.b, h);
                    $61de1ee1cac498ae$var$Dsb(b.a, h);
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$QKb(a, b) {
    var c, d, e, f, g, h, i, j;
    for(i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 111);
        e = h.c ? $61de1ee1cac498ae$var$YHb(h.c) : 0;
        if (e > 0) {
            if (h.a) {
                j = h.b.rf().b;
                if (e > j) {
                    if (a.v || h.c.d.c.length == 1) {
                        g = (e - j) / 2;
                        h.d.d = g;
                        h.d.a = g;
                    } else {
                        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(h.c.d, 0), 181).rf().b;
                        d = (c - j) / 2;
                        h.d.d = $61de1ee1cac498ae$var$$wnd.Math.max(0, d);
                        h.d.a = e - d - j;
                    }
                }
            } else h.d.a = a.t + e;
        } else if ($61de1ee1cac498ae$var$tcd(a.u)) {
            f = $61de1ee1cac498ae$var$sfd(h.b);
            f.d < 0 && (h.d.d = -f.d);
            f.d + f.a > h.b.rf().b && (h.d.a = f.d + f.a - h.b.rf().b);
        }
    }
}
function $61de1ee1cac498ae$var$FC(a, b) {
    var c;
    switch($61de1ee1cac498ae$var$HC(a)){
        case 6:
            return $61de1ee1cac498ae$var$ND(b);
        case 7:
            return $61de1ee1cac498ae$var$LD(b);
        case 8:
            return $61de1ee1cac498ae$var$KD(b);
        case 3:
            return Array.isArray(b) && (c = $61de1ee1cac498ae$var$HC(b), !(c >= 14 && c <= 16));
        case 11:
            return b != null && typeof b === $61de1ee1cac498ae$var$Nhe;
        case 12:
            return b != null && (typeof b === $61de1ee1cac498ae$var$Jhe || typeof b == $61de1ee1cac498ae$var$Nhe);
        case 0:
            return $61de1ee1cac498ae$var$AD(b, a.__elementTypeId$);
        case 2:
            return $61de1ee1cac498ae$var$OD(b) && !(b.im === $61de1ee1cac498ae$var$gcb);
        case 1:
            return $61de1ee1cac498ae$var$OD(b) && !(b.im === $61de1ee1cac498ae$var$gcb) || $61de1ee1cac498ae$var$AD(b, a.__elementTypeId$);
        default:
            return true;
    }
}
function $61de1ee1cac498ae$var$xOb(a, b) {
    var c, d, e, f;
    d = $61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$$wnd.Math.abs(a.c - (b.c + b.b)), $61de1ee1cac498ae$var$$wnd.Math.abs(a.c + a.b - b.c));
    f = $61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$$wnd.Math.abs(a.d - (b.d + b.a)), $61de1ee1cac498ae$var$$wnd.Math.abs(a.d + a.a - b.d));
    c = $61de1ee1cac498ae$var$$wnd.Math.abs(a.c + a.b / 2 - (b.c + b.b / 2));
    if (c > a.b / 2 + b.b / 2) return 1;
    e = $61de1ee1cac498ae$var$$wnd.Math.abs(a.d + a.a / 2 - (b.d + b.a / 2));
    if (e > a.a / 2 + b.a / 2) return 1;
    if (c == 0 && e == 0) return 0;
    if (c == 0) return f / e + 1;
    if (e == 0) return d / c + 1;
    return $61de1ee1cac498ae$var$$wnd.Math.min(d / c, f / e) + 1;
}
function $61de1ee1cac498ae$var$mgb(a, b) {
    var c, d, e, f, g, h;
    e = $61de1ee1cac498ae$var$pgb(a);
    h = $61de1ee1cac498ae$var$pgb(b);
    if (e == h) {
        if (a.e == b.e && a.a < 54 && b.a < 54) return a.f < b.f ? -1 : a.f > b.f ? 1 : 0;
        d = a.e - b.e;
        c = (a.d > 0 ? a.d : $61de1ee1cac498ae$var$$wnd.Math.floor((a.a - 1) * $61de1ee1cac498ae$var$Xje) + 1) - (b.d > 0 ? b.d : $61de1ee1cac498ae$var$$wnd.Math.floor((b.a - 1) * $61de1ee1cac498ae$var$Xje) + 1);
        if (c > d + 1) return e;
        else if (c < d - 1) return -e;
        else {
            f = (!a.c && (a.c = $61de1ee1cac498ae$var$fhb(a.f)), a.c);
            g = (!b.c && (b.c = $61de1ee1cac498ae$var$fhb(b.f)), b.c);
            d < 0 ? f = $61de1ee1cac498ae$var$Ogb(f, $61de1ee1cac498ae$var$Khb(-d)) : d > 0 && (g = $61de1ee1cac498ae$var$Ogb(g, $61de1ee1cac498ae$var$Khb(d)));
            return $61de1ee1cac498ae$var$Igb(f, g);
        }
    } else return e < h ? -1 : 1;
}
function $61de1ee1cac498ae$var$mTb(a, b) {
    var c, d, e, f, g, h, i;
    f = 0;
    h = 0;
    i = 0;
    for(e = new $61de1ee1cac498ae$var$olb(a.f.e); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 144);
        if (b == d) continue;
        g = a.i[b.b][d.b];
        f += g;
        c = $61de1ee1cac498ae$var$S6c(b.d, d.d);
        c > 0 && a.d != ($61de1ee1cac498ae$var$yTb(), $61de1ee1cac498ae$var$xTb) && (h += g * (d.d.a + a.a[b.b][d.b] * (b.d.a - d.d.a) / c));
        c > 0 && a.d != ($61de1ee1cac498ae$var$yTb(), $61de1ee1cac498ae$var$vTb) && (i += g * (d.d.b + a.a[b.b][d.b] * (b.d.b - d.d.b) / c));
    }
    switch(a.d.g){
        case 1:
            return new $61de1ee1cac498ae$var$f7c(h / f, b.d.b);
        case 2:
            return new $61de1ee1cac498ae$var$f7c(b.d.a, i / f);
        default:
            return new $61de1ee1cac498ae$var$f7c(h / f, i / f);
    }
}
function $61de1ee1cac498ae$var$Wcc(a, b) {
    $61de1ee1cac498ae$var$Occ();
    var c, d, e, f, g;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.i, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    f = a.j.g - b.j.g;
    if (f != 0 || !(g == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$Zbd) || g == $61de1ee1cac498ae$var$_bd || g == $61de1ee1cac498ae$var$$bd)) return 0;
    if (g == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$Zbd)) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Wxc), 19);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Wxc), 19);
        if (!!c && !!d) {
            e = c.a - d.a;
            if (e != 0) return e;
        }
    }
    switch(a.j.g){
        case 1:
            return $61de1ee1cac498ae$var$Kdb(a.n.a, b.n.a);
        case 2:
            return $61de1ee1cac498ae$var$Kdb(a.n.b, b.n.b);
        case 3:
            return $61de1ee1cac498ae$var$Kdb(b.n.a, a.n.a);
        case 4:
            return $61de1ee1cac498ae$var$Kdb(b.n.b, a.n.b);
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$ine));
    }
}
function $61de1ee1cac498ae$var$tfd(a) {
    var b, c, d, e, f, g;
    c = (!a.a && (a.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, a, 5)), a.a).i + 2;
    g = new $61de1ee1cac498ae$var$Skb(c);
    $61de1ee1cac498ae$var$Ekb(g, new $61de1ee1cac498ae$var$f7c(a.j, a.k));
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, (!a.a && (a.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, a, 5)), new $61de1ee1cac498ae$var$Kub(a.a, 16))), new $61de1ee1cac498ae$var$Qfd(g));
    $61de1ee1cac498ae$var$Ekb(g, new $61de1ee1cac498ae$var$f7c(a.b, a.c));
    b = 1;
    while(b < g.c.length - 1){
        d = ($61de1ee1cac498ae$var$tCb(b - 1, g.c.length), $61de1ee1cac498ae$var$BD(g.c[b - 1], 8));
        e = ($61de1ee1cac498ae$var$tCb(b, g.c.length), $61de1ee1cac498ae$var$BD(g.c[b], 8));
        f = ($61de1ee1cac498ae$var$tCb(b + 1, g.c.length), $61de1ee1cac498ae$var$BD(g.c[b + 1], 8));
        d.a == e.a && e.a == f.a || d.b == e.b && e.b == f.b ? $61de1ee1cac498ae$var$Kkb(g, b) : ++b;
    }
    return g;
}
function $61de1ee1cac498ae$var$Xgc(a, b) {
    var c, d, e, f, g, h, i;
    c = $61de1ee1cac498ae$var$vDb($61de1ee1cac498ae$var$yDb($61de1ee1cac498ae$var$wDb($61de1ee1cac498ae$var$xDb(new $61de1ee1cac498ae$var$zDb, b), new $61de1ee1cac498ae$var$K6c(b.e)), $61de1ee1cac498ae$var$Ggc), a.a);
    b.j.c.length == 0 || $61de1ee1cac498ae$var$nDb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.j, 0), 57).a, c);
    i = new $61de1ee1cac498ae$var$lEb;
    $61de1ee1cac498ae$var$Rhb(a.e, c, i);
    g = new $61de1ee1cac498ae$var$Tqb;
    h = new $61de1ee1cac498ae$var$Tqb;
    for(f = new $61de1ee1cac498ae$var$olb(b.k); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
        $61de1ee1cac498ae$var$Qqb(g, e.c);
        $61de1ee1cac498ae$var$Qqb(h, e.d);
    }
    d = g.a.gc() - h.a.gc();
    if (d < 0) {
        $61de1ee1cac498ae$var$jEb(i, true, ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad));
        $61de1ee1cac498ae$var$jEb(i, false, $61de1ee1cac498ae$var$bad);
    } else if (d > 0) {
        $61de1ee1cac498ae$var$jEb(i, false, ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad));
        $61de1ee1cac498ae$var$jEb(i, true, $61de1ee1cac498ae$var$bad);
    }
    $61de1ee1cac498ae$var$Hkb(b.g, new $61de1ee1cac498ae$var$$hc(a, c));
    $61de1ee1cac498ae$var$Rhb(a.g, b, c);
}
function $61de1ee1cac498ae$var$Neb() {
    $61de1ee1cac498ae$var$Neb = $61de1ee1cac498ae$var$ccb;
    var a;
    $61de1ee1cac498ae$var$Jeb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        -1,
        -1,
        30,
        19,
        15,
        13,
        11,
        11,
        10,
        9,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5
    ]);
    $61de1ee1cac498ae$var$Keb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, 37, 15, 1);
    $61de1ee1cac498ae$var$Leb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        -1,
        -1,
        63,
        40,
        32,
        28,
        25,
        23,
        21,
        20,
        19,
        19,
        18,
        18,
        17,
        17,
        16,
        16,
        16,
        15,
        15,
        15,
        15,
        14,
        14,
        14,
        14,
        14,
        14,
        13,
        13,
        13,
        13,
        13,
        13,
        13,
        13
    ]);
    $61de1ee1cac498ae$var$Meb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$XD, $61de1ee1cac498ae$var$Sje, 25, 37, 14, 1);
    for(a = 2; a <= 36; a++){
        $61de1ee1cac498ae$var$Keb[a] = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.pow(a, $61de1ee1cac498ae$var$Jeb[a]));
        $61de1ee1cac498ae$var$Meb[a] = $61de1ee1cac498ae$var$Abb($61de1ee1cac498ae$var$rie, $61de1ee1cac498ae$var$Keb[a]);
    }
}
function $61de1ee1cac498ae$var$pfd(a) {
    var b;
    if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Tse + (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i));
    b = new $61de1ee1cac498ae$var$s7c;
    !!$61de1ee1cac498ae$var$btd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82)) && $61de1ee1cac498ae$var$ye(b, $61de1ee1cac498ae$var$qfd(a, $61de1ee1cac498ae$var$btd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82)), false));
    !!$61de1ee1cac498ae$var$btd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c), 0), 82)) && $61de1ee1cac498ae$var$ye(b, $61de1ee1cac498ae$var$qfd(a, $61de1ee1cac498ae$var$btd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c), 0), 82)), true));
    return b;
}
function $61de1ee1cac498ae$var$_Mc(a, b) {
    var c, d, e, f, g;
    b.d ? e = a.a.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$XLc) ? $61de1ee1cac498ae$var$R_b(b.b) : $61de1ee1cac498ae$var$U_b(b.b) : e = a.a.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc) ? $61de1ee1cac498ae$var$R_b(b.b) : $61de1ee1cac498ae$var$U_b(b.b);
    f = false;
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(e.a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
        g = $61de1ee1cac498ae$var$Ccb(a.a.f[a.a.g[b.b.p].p]);
        if (!g && !$61de1ee1cac498ae$var$OZb(c) && c.c.i.c == c.d.i.c) continue;
        if ($61de1ee1cac498ae$var$Ccb(a.a.n[a.a.g[b.b.p].p]) || $61de1ee1cac498ae$var$Ccb(a.a.n[a.a.g[b.b.p].p])) continue;
        f = true;
        if ($61de1ee1cac498ae$var$Rqb(a.b, a.a.g[$61de1ee1cac498ae$var$TMc(c, b.b).p])) {
            b.c = true;
            b.a = c;
            return b;
        }
    }
    b.c = f;
    b.a = null;
    return b;
}
function $61de1ee1cac498ae$var$bed(a, b, c, d, e) {
    var f, g, h, i, j, k, l;
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(a, new $61de1ee1cac498ae$var$Red);
    h = new $61de1ee1cac498ae$var$Bib(a, 0);
    l = new $61de1ee1cac498ae$var$Rkb;
    f = 0;
    while(h.b < h.d.gc()){
        g = ($61de1ee1cac498ae$var$sCb(h.b < h.d.gc()), $61de1ee1cac498ae$var$BD(h.d.Xb(h.c = h.b++), 157));
        if (l.c.length != 0 && $61de1ee1cac498ae$var$red(g) * $61de1ee1cac498ae$var$qed(g) > f * 2) {
            k = new $61de1ee1cac498ae$var$wed(l);
            j = $61de1ee1cac498ae$var$red(g) / $61de1ee1cac498ae$var$qed(g);
            i = $61de1ee1cac498ae$var$fed(k, b, new $61de1ee1cac498ae$var$p0b, c, d, e, j);
            $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(k.e), i);
            l.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            f = 0;
            l.c[l.c.length] = k;
            l.c[l.c.length] = g;
            f = $61de1ee1cac498ae$var$red(k) * $61de1ee1cac498ae$var$qed(k) + $61de1ee1cac498ae$var$red(g) * $61de1ee1cac498ae$var$qed(g);
        } else {
            l.c[l.c.length] = g;
            f += $61de1ee1cac498ae$var$red(g) * $61de1ee1cac498ae$var$qed(g);
        }
    }
    return l;
}
function $61de1ee1cac498ae$var$qwd(a, b, c) {
    var d, e, f, g, h, i, j;
    d = c.gc();
    if (d == 0) return false;
    else {
        if (a.ej()) {
            i = a.fj();
            $61de1ee1cac498ae$var$zvd(a, b, c);
            g = d == 1 ? a.Zi(3, null, c.Kc().Pb(), b, i) : a.Zi(5, null, c, b, i);
            if (a.bj()) {
                h = d < 100 ? null : new $61de1ee1cac498ae$var$Ixd(d);
                f = b + d;
                for(e = b; e < f; ++e){
                    j = a.Oi(e);
                    h = a.cj(j, h);
                    h;
                }
                if (!h) a.$i(g);
                else {
                    h.Ei(g);
                    h.Fi();
                }
            } else a.$i(g);
        } else {
            $61de1ee1cac498ae$var$zvd(a, b, c);
            if (a.bj()) {
                h = d < 100 ? null : new $61de1ee1cac498ae$var$Ixd(d);
                f = b + d;
                for(e = b; e < f; ++e)h = a.cj(a.Oi(e), h);
                !!h && h.Fi();
            }
        }
        return true;
    }
}
function $61de1ee1cac498ae$var$wwd(a, b, c) {
    var d, e, f, g, h;
    if (a.ej()) {
        e = null;
        f = a.fj();
        d = a.Zi(1, h = (g = a.Ui(b, a.oi(b, c)), g), c, b, f);
        if (a.bj() && !(a.ni() && !!h ? $61de1ee1cac498ae$var$pb(h, c) : $61de1ee1cac498ae$var$PD(h) === $61de1ee1cac498ae$var$PD(c))) {
            !!h && (e = a.dj(h, e));
            e = a.cj(c, e);
            if (!e) a.$i(d);
            else {
                e.Ei(d);
                e.Fi();
            }
        } else if (!e) a.$i(d);
        else {
            e.Ei(d);
            e.Fi();
        }
        return h;
    } else {
        h = (g = a.Ui(b, a.oi(b, c)), g);
        if (a.bj() && !(a.ni() && !!h ? $61de1ee1cac498ae$var$pb(h, c) : $61de1ee1cac498ae$var$PD(h) === $61de1ee1cac498ae$var$PD(c))) {
            e = null;
            !!h && (e = a.dj(h, null));
            e = a.cj(c, e);
            !!e && e.Fi();
        }
        return h;
    }
}
function $61de1ee1cac498ae$var$rRb(a, b) {
    var c, d, e, f, g, h, i, j, k;
    a.e = b;
    a.f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$GSb)), 230);
    $61de1ee1cac498ae$var$iRb(b);
    a.d = $61de1ee1cac498ae$var$$wnd.Math.max(b.e.c.length * 16 + b.c.c.length, 256);
    if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$dSb))))) {
        k = a.e.e.c.length;
        for(i = new $61de1ee1cac498ae$var$olb(b.e); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 144);
            j = h.d;
            j.a = $61de1ee1cac498ae$var$Aub(a.f) * k;
            j.b = $61de1ee1cac498ae$var$Aub(a.f) * k;
        }
    }
    c = b.b;
    for(f = new $61de1ee1cac498ae$var$olb(b.c); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 282);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$rSb), 19).a;
        if (d > 0) {
            for(g = 0; g < d; g++)$61de1ee1cac498ae$var$Ekb(c, new $61de1ee1cac498ae$var$aRb(e));
            $61de1ee1cac498ae$var$cRb(e);
        }
    }
}
function $61de1ee1cac498ae$var$zac(a, b) {
    var c, d, e, f, g, h;
    if (a.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) {
        c = $61de1ee1cac498ae$var$WAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ktc)), 15).Oc(), new $61de1ee1cac498ae$var$Xxb(new $61de1ee1cac498ae$var$Kac))).sd(($61de1ee1cac498ae$var$EAb(), $61de1ee1cac498ae$var$DAb)) ? b : ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$pbd);
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Ssc, c);
        if (c != ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$obd)) {
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$$sc), 17);
            h = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Zwc))));
            g = 0;
            if (c == $61de1ee1cac498ae$var$nbd) g = a.o.b - $61de1ee1cac498ae$var$$wnd.Math.ceil(h / 2);
            else if (c == $61de1ee1cac498ae$var$pbd) {
                a.o.b -= $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), $61de1ee1cac498ae$var$nyc)));
                g = (a.o.b - $61de1ee1cac498ae$var$$wnd.Math.ceil(h)) / 2;
            }
            for(f = new $61de1ee1cac498ae$var$olb(a.j); f.a < f.c.c.length;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 11);
                e.n.b = g;
            }
        }
    }
}
function $61de1ee1cac498ae$var$Uge() {
    $61de1ee1cac498ae$var$Uge = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$g5d();
    $61de1ee1cac498ae$var$Tge = new $61de1ee1cac498ae$var$Vge;
    $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 2), $61de1ee1cac498ae$var$nie, 368, 0, [
        $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 1), $61de1ee1cac498ae$var$Axe, 592, 0, [
            new $61de1ee1cac498ae$var$Rge($61de1ee1cac498ae$var$Xwe)
        ])
    ]);
    $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 2), $61de1ee1cac498ae$var$nie, 368, 0, [
        $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 1), $61de1ee1cac498ae$var$Axe, 592, 0, [
            new $61de1ee1cac498ae$var$Rge($61de1ee1cac498ae$var$Ywe)
        ])
    ]);
    $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 2), $61de1ee1cac498ae$var$nie, 368, 0, [
        $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 1), $61de1ee1cac498ae$var$Axe, 592, 0, [
            new $61de1ee1cac498ae$var$Rge($61de1ee1cac498ae$var$Zwe)
        ]),
        $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 1), $61de1ee1cac498ae$var$Axe, 592, 0, [
            new $61de1ee1cac498ae$var$Rge($61de1ee1cac498ae$var$Ywe)
        ])
    ]);
    new $61de1ee1cac498ae$var$Ygb("-1");
    $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 2), $61de1ee1cac498ae$var$nie, 368, 0, [
        $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$w5, 1), $61de1ee1cac498ae$var$Axe, 592, 0, [
            new $61de1ee1cac498ae$var$Rge("\\c+")
        ])
    ]);
    new $61de1ee1cac498ae$var$Ygb("0");
    new $61de1ee1cac498ae$var$Ygb("0");
    new $61de1ee1cac498ae$var$Ygb("1");
    new $61de1ee1cac498ae$var$Ygb("0");
    new $61de1ee1cac498ae$var$Ygb($61de1ee1cac498ae$var$hxe);
}
function $61de1ee1cac498ae$var$KQd(a) {
    var b, c;
    if (!!a.c && a.c.kh()) {
        c = $61de1ee1cac498ae$var$BD(a.c, 49);
        a.c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$xid(a, c), 138);
        if (a.c != c) {
            (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 9, 2, c, a.c));
            if ($61de1ee1cac498ae$var$JD(a.Cb, 399)) a.Db >> 16 == -15 && a.Cb.nh() && $61de1ee1cac498ae$var$Rwd(new $61de1ee1cac498ae$var$oSd(a.Cb, 9, 13, c, a.c, $61de1ee1cac498ae$var$HLd($61de1ee1cac498ae$var$QSd($61de1ee1cac498ae$var$BD(a.Cb, 59)), a)));
            else if ($61de1ee1cac498ae$var$JD(a.Cb, 88)) {
                if (a.Db >> 16 == -23 && a.Cb.nh()) {
                    b = a.c;
                    $61de1ee1cac498ae$var$JD(b, 88) || (b = ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
                    $61de1ee1cac498ae$var$JD(c, 88) || (c = ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
                    $61de1ee1cac498ae$var$Rwd(new $61de1ee1cac498ae$var$oSd(a.Cb, 9, 10, c, b, $61de1ee1cac498ae$var$HLd($61de1ee1cac498ae$var$VKd($61de1ee1cac498ae$var$BD(a.Cb, 26)), a)));
                }
            }
        }
    }
    return a.c;
}
function $61de1ee1cac498ae$var$f7b(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    $61de1ee1cac498ae$var$Odd(b, "Hypernodes processing", 1);
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        for(h = new $61de1ee1cac498ae$var$olb(d.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$exc)))) && g.j.c.length <= 2) {
                l = 0;
                k = 0;
                c = 0;
                f = 0;
                for(j = new $61de1ee1cac498ae$var$olb(g.j); j.a < j.c.c.length;){
                    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 11);
                    switch(i.j.g){
                        case 1:
                            ++l;
                            break;
                        case 2:
                            ++k;
                            break;
                        case 3:
                            ++c;
                            break;
                        case 4:
                            ++f;
                    }
                }
                l == 0 && c == 0 && $61de1ee1cac498ae$var$e7b(a, g, f <= k);
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$i7b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    $61de1ee1cac498ae$var$Odd(b, "Layer constraint edge reversal", 1);
    for(g = new $61de1ee1cac498ae$var$olb(a.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        k = -1;
        c = new $61de1ee1cac498ae$var$Rkb;
        j = $61de1ee1cac498ae$var$l_b(f.a);
        for(e = 0; e < j.length; e++){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(j[e], ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Osc)), 303);
            if (k == -1) d != ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$dsc) && (k = e);
            else if (d == ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$dsc)) {
                $61de1ee1cac498ae$var$$_b(j[e], null);
                $61de1ee1cac498ae$var$Z_b(j[e], k++, f);
            }
            d == ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$bsc) && $61de1ee1cac498ae$var$Ekb(c, j[e]);
        }
        for(i = new $61de1ee1cac498ae$var$olb(c); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            $61de1ee1cac498ae$var$$_b(h, null);
            $61de1ee1cac498ae$var$$_b(h, f);
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$W6b(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    $61de1ee1cac498ae$var$Odd(c, "Hyperedge merging", 1);
    $61de1ee1cac498ae$var$U6b(a, b);
    i = new $61de1ee1cac498ae$var$Bib(b.b, 0);
    while(i.b < i.d.gc()){
        h = ($61de1ee1cac498ae$var$sCb(i.b < i.d.gc()), $61de1ee1cac498ae$var$BD(i.d.Xb(i.c = i.b++), 29));
        k = h.a;
        if (k.c.length == 0) continue;
        d = null;
        e = null;
        f = null;
        g = null;
        for(j = 0; j < k.c.length; j++){
            d = ($61de1ee1cac498ae$var$tCb(j, k.c.length), $61de1ee1cac498ae$var$BD(k.c[j], 10));
            e = d.k;
            if (e == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) && g == $61de1ee1cac498ae$var$g0b) {
                l = $61de1ee1cac498ae$var$S6b(d, f);
                if (l.a) {
                    $61de1ee1cac498ae$var$V6b(d, f, l.b, l.c);
                    $61de1ee1cac498ae$var$tCb(j, k.c.length);
                    $61de1ee1cac498ae$var$cCb(k.c, j, 1);
                    --j;
                    d = f;
                    e = g;
                }
            }
            f = d;
            g = e;
        }
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$WFc(a, b) {
    var c, d, e;
    d = $61de1ee1cac498ae$var$Cub(a.d, 1) != 0;
    !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Jsc)))) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$mtc))) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ywc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) ? b.c.Tf(b.e, d) : d = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$Jsc)));
    $61de1ee1cac498ae$var$dGc(a, b, d, true);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$mtc))) && $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$mtc, ($61de1ee1cac498ae$var$Bcb(), false));
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$Jsc)))) {
        $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$Jsc, ($61de1ee1cac498ae$var$Bcb(), false));
        $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$mtc, true);
    }
    c = $61de1ee1cac498ae$var$OFc(a, b);
    do {
        $61de1ee1cac498ae$var$$Fc(a);
        if (c == 0) return 0;
        d = !d;
        e = c;
        $61de1ee1cac498ae$var$dGc(a, b, d, false);
        c = $61de1ee1cac498ae$var$OFc(a, b);
    }while (e > c);
    return e;
}
function $61de1ee1cac498ae$var$XFc(a, b) {
    var c, d, e;
    d = $61de1ee1cac498ae$var$Cub(a.d, 1) != 0;
    !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Jsc)))) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$mtc))) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ywc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) ? b.c.Tf(b.e, d) : d = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$Jsc)));
    $61de1ee1cac498ae$var$dGc(a, b, d, true);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$mtc))) && $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$mtc, ($61de1ee1cac498ae$var$Bcb(), false));
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$Jsc)))) {
        $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$Jsc, ($61de1ee1cac498ae$var$Bcb(), false));
        $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$mtc, true);
    }
    c = $61de1ee1cac498ae$var$NFc(a, b);
    do {
        $61de1ee1cac498ae$var$$Fc(a);
        if (c == 0) return 0;
        d = !d;
        e = c;
        $61de1ee1cac498ae$var$dGc(a, b, d, false);
        c = $61de1ee1cac498ae$var$NFc(a, b);
    }while (e > c);
    return e;
}
function $61de1ee1cac498ae$var$uNd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    if (b == c) return true;
    else {
        b = $61de1ee1cac498ae$var$vNd(a, b);
        c = $61de1ee1cac498ae$var$vNd(a, c);
        d = $61de1ee1cac498ae$var$JQd(b);
        if (d) {
            k = $61de1ee1cac498ae$var$JQd(c);
            if (k != d) {
                if (!k) return false;
                else {
                    i = d.Dj();
                    o = k.Dj();
                    return i == o && i != null;
                }
            } else {
                g = (!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d);
                f = g.i;
                m = (!c.d && (c.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, c, 1)), c.d);
                if (f == m.i) for(j = 0; j < f; ++j){
                    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(g, j), 87);
                    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(m, j), 87);
                    if (!$61de1ee1cac498ae$var$uNd(a, e, l)) return false;
                }
                return true;
            }
        } else {
            h = b.e;
            n = c.e;
            return h == n;
        }
    }
}
function $61de1ee1cac498ae$var$X2d(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        l = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
        f = $61de1ee1cac498ae$var$BD(a.g, 119);
        k = null;
        i = -1;
        h = -1;
        e = 0;
        for(j = 0; j < a.i; ++j){
            g = f[j];
            if (l.rl(g.ak())) {
                e == c && (i = j);
                if (e == d) {
                    h = j;
                    k = g.dd();
                }
                ++e;
            }
        }
        if (i == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$lue + c + $61de1ee1cac498ae$var$mue + e));
        if (h == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$nue + d + $61de1ee1cac498ae$var$mue + e));
        $61de1ee1cac498ae$var$Wxd(a, i, h);
        $61de1ee1cac498ae$var$oid(a.e) && $61de1ee1cac498ae$var$GLd(a, $61de1ee1cac498ae$var$H2d(a, 7, b, $61de1ee1cac498ae$var$meb(d), k, c, true));
        return k;
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The feature must be many-valued to support move"));
}
function $61de1ee1cac498ae$var$b_b(a, b, c, d) {
    var e, f, g, h, i;
    i = new $61de1ee1cac498ae$var$g7c(b.n);
    i.a += b.o.a / 2;
    i.b += b.o.b / 2;
    h = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Uxc))));
    f = a.f;
    g = a.d;
    e = a.c;
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61).g){
        case 1:
            i.a += g.b + e.a - c / 2;
            i.b = -d - h;
            b.n.b = -(g.d + h + e.b);
            break;
        case 2:
            i.a = f.a + g.b + g.c + h;
            i.b += g.d + e.b - d / 2;
            b.n.a = f.a + g.c + h - e.a;
            break;
        case 3:
            i.a += g.b + e.a - c / 2;
            i.b = f.b + g.d + g.a + h;
            b.n.b = f.b + g.a + h - e.b;
            break;
        case 4:
            i.a = -c - h;
            i.b += g.d + e.b - d / 2;
            b.n.a = -(g.b + h + e.a);
    }
    return i;
}
function $61de1ee1cac498ae$var$P1b(a) {
    var b, c, d, e, f, g;
    d = new $61de1ee1cac498ae$var$XZb;
    $61de1ee1cac498ae$var$tNb(d, a);
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lwc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad)) && $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$Lwc, $61de1ee1cac498ae$var$a_b(d));
    if ($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$g6c(), $61de1ee1cac498ae$var$f6c)) == null) {
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$m6d(a), 160);
        $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$f6c, $61de1ee1cac498ae$var$RD(g.We($61de1ee1cac498ae$var$f6c)));
    }
    $61de1ee1cac498ae$var$yNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), a);
    $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$Ksc, (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$PW), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0)));
    e = $61de1ee1cac498ae$var$OGb((!$61de1ee1cac498ae$var$Xod(a) || ($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd($61de1ee1cac498ae$var$Xod(a))), $61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$hhd(!$61de1ee1cac498ae$var$Xod(a) ? null : new $61de1ee1cac498ae$var$bhd($61de1ee1cac498ae$var$Xod(a)), a)), $61de1ee1cac498ae$var$bad);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Kxc), 116);
    c = d.d;
    $61de1ee1cac498ae$var$t_b(c, f);
    $61de1ee1cac498ae$var$t_b(c, e);
    return d;
}
function $61de1ee1cac498ae$var$ybc(a, b, c) {
    var d, e;
    d = b.c.i;
    e = c.d.i;
    if (d.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)) {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Vsc), 11));
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Wsc, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Wsc), 11));
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Usc, $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Usc)));
    } else if (d.k == $61de1ee1cac498ae$var$f0b) {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Vsc), 11));
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Wsc, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Wsc), 11));
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Usc, ($61de1ee1cac498ae$var$Bcb(), true));
    } else if (e.k == $61de1ee1cac498ae$var$f0b) {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$Vsc), 11));
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Wsc, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$Wsc), 11));
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Usc, ($61de1ee1cac498ae$var$Bcb(), true));
    } else {
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Vsc), b.c);
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Wsc, c.d);
    }
}
function $61de1ee1cac498ae$var$FGb(a) {
    var b, c, d, e, f, g, h;
    a.o = new $61de1ee1cac498ae$var$jkb;
    d = new $61de1ee1cac498ae$var$Psb;
    for(g = new $61de1ee1cac498ae$var$olb(a.e.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 121);
        $61de1ee1cac498ae$var$LFb(f).c.length == 1 && $61de1ee1cac498ae$var$Gsb(d, f, d.c.b, d.c);
    }
    while(d.b != 0){
        f = $61de1ee1cac498ae$var$BD(d.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(d.b != 0), $61de1ee1cac498ae$var$Nsb(d, d.a.a)), 121);
        if ($61de1ee1cac498ae$var$LFb(f).c.length == 0) continue;
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb($61de1ee1cac498ae$var$LFb(f), 0), 213);
        c = f.g.a.c.length > 0;
        h = $61de1ee1cac498ae$var$xFb(b, f);
        c ? $61de1ee1cac498ae$var$OFb(h.b, b) : $61de1ee1cac498ae$var$OFb(h.g, b);
        $61de1ee1cac498ae$var$LFb(h).c.length == 1 && $61de1ee1cac498ae$var$Gsb(d, h, d.c.b, d.c);
        e = new $61de1ee1cac498ae$var$vgd(f, b);
        $61de1ee1cac498ae$var$Wjb(a.o, e);
        $61de1ee1cac498ae$var$Lkb(a.e.a, f);
    }
}
function $61de1ee1cac498ae$var$_Nb(a, b) {
    var c, d, e, f, g, h, i;
    d = $61de1ee1cac498ae$var$$wnd.Math.abs($61de1ee1cac498ae$var$D6c(a.b).a - $61de1ee1cac498ae$var$D6c(b.b).a);
    h = $61de1ee1cac498ae$var$$wnd.Math.abs($61de1ee1cac498ae$var$D6c(a.b).b - $61de1ee1cac498ae$var$D6c(b.b).b);
    e = 0;
    i = 0;
    c = 1;
    g = 1;
    if (d > a.b.b / 2 + b.b.b / 2) {
        e = $61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$$wnd.Math.abs(a.b.c - (b.b.c + b.b.b)), $61de1ee1cac498ae$var$$wnd.Math.abs(a.b.c + a.b.b - b.b.c));
        c = 1 - e / d;
    }
    if (h > a.b.a / 2 + b.b.a / 2) {
        i = $61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$$wnd.Math.abs(a.b.d - (b.b.d + b.b.a)), $61de1ee1cac498ae$var$$wnd.Math.abs(a.b.d + a.b.a - b.b.d));
        g = 1 - i / h;
    }
    f = $61de1ee1cac498ae$var$$wnd.Math.min(c, g);
    return (1 - f) * $61de1ee1cac498ae$var$$wnd.Math.sqrt(d * d + h * h);
}
function $61de1ee1cac498ae$var$lQc(a) {
    var b, c, d, e;
    $61de1ee1cac498ae$var$nQc(a, a.e, a.f, ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$DQc), true, a.c, a.i);
    $61de1ee1cac498ae$var$nQc(a, a.e, a.f, $61de1ee1cac498ae$var$DQc, false, a.c, a.i);
    $61de1ee1cac498ae$var$nQc(a, a.e, a.f, $61de1ee1cac498ae$var$EQc, true, a.c, a.i);
    $61de1ee1cac498ae$var$nQc(a, a.e, a.f, $61de1ee1cac498ae$var$EQc, false, a.c, a.i);
    $61de1ee1cac498ae$var$mQc(a, a.c, a.e, a.f, a.i);
    d = new $61de1ee1cac498ae$var$Bib(a.i, 0);
    while(d.b < d.d.gc()){
        b = ($61de1ee1cac498ae$var$sCb(d.b < d.d.gc()), $61de1ee1cac498ae$var$BD(d.d.Xb(d.c = d.b++), 128));
        e = new $61de1ee1cac498ae$var$Bib(a.i, d.b);
        while(e.b < e.d.gc()){
            c = ($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), $61de1ee1cac498ae$var$BD(e.d.Xb(e.c = e.b++), 128));
            $61de1ee1cac498ae$var$kQc(b, c);
        }
    }
    $61de1ee1cac498ae$var$wQc(a.i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$jtc)), 230));
    $61de1ee1cac498ae$var$zQc(a.i);
}
function $61de1ee1cac498ae$var$fKd(a, b) {
    var c, d;
    if (b != null) {
        d = $61de1ee1cac498ae$var$dKd(a);
        if (d) {
            if ((d.i & 1) != 0) {
                if (d == $61de1ee1cac498ae$var$sbb) return $61de1ee1cac498ae$var$KD(b);
                else if (d == $61de1ee1cac498ae$var$WD) return $61de1ee1cac498ae$var$JD(b, 19);
                else if (d == $61de1ee1cac498ae$var$VD) return $61de1ee1cac498ae$var$JD(b, 155);
                else if (d == $61de1ee1cac498ae$var$SD) return $61de1ee1cac498ae$var$JD(b, 217);
                else if (d == $61de1ee1cac498ae$var$TD) return $61de1ee1cac498ae$var$JD(b, 172);
                else if (d == $61de1ee1cac498ae$var$UD) return $61de1ee1cac498ae$var$LD(b);
                else if (d == $61de1ee1cac498ae$var$rbb) return $61de1ee1cac498ae$var$JD(b, 184);
                else if (d == $61de1ee1cac498ae$var$XD) return $61de1ee1cac498ae$var$JD(b, 162);
            } else return $61de1ee1cac498ae$var$pEd(), c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb($61de1ee1cac498ae$var$oEd, d), 55), !c || c.wj(b);
        } else if ($61de1ee1cac498ae$var$JD(b, 56)) return a.uk($61de1ee1cac498ae$var$BD(b, 56));
    }
    return false;
}
function $61de1ee1cac498ae$var$ade() {
    $61de1ee1cac498ae$var$ade = $61de1ee1cac498ae$var$ccb;
    var a, b, c, d, e, f, g, h, i;
    $61de1ee1cac498ae$var$$ce = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, 255, 15, 1);
    $61de1ee1cac498ae$var$_ce = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, 64, 15, 1);
    for(b = 0; b < 255; b++)$61de1ee1cac498ae$var$$ce[b] = -1;
    for(c = 90; c >= 65; c--)$61de1ee1cac498ae$var$$ce[c] = c - 65 << 24 >> 24;
    for(d = 122; d >= 97; d--)$61de1ee1cac498ae$var$$ce[d] = d - 97 + 26 << 24 >> 24;
    for(e = 57; e >= 48; e--)$61de1ee1cac498ae$var$$ce[e] = e - 48 + 52 << 24 >> 24;
    $61de1ee1cac498ae$var$$ce[43] = 62;
    $61de1ee1cac498ae$var$$ce[47] = 63;
    for(f = 0; f <= 25; f++)$61de1ee1cac498ae$var$_ce[f] = 65 + f & $61de1ee1cac498ae$var$aje;
    for(g = 26, i = 0; g <= 51; ++g, i++)$61de1ee1cac498ae$var$_ce[g] = 97 + i & $61de1ee1cac498ae$var$aje;
    for(a = 52, h = 0; a <= 61; ++a, h++)$61de1ee1cac498ae$var$_ce[a] = 48 + h & $61de1ee1cac498ae$var$aje;
    $61de1ee1cac498ae$var$_ce[62] = 43;
    $61de1ee1cac498ae$var$_ce[63] = 47;
}
function $61de1ee1cac498ae$var$FXb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    if (a.dc()) return new $61de1ee1cac498ae$var$d7c;
    j = 0;
    l = 0;
    for(e = a.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 37);
        f = d.f;
        j = $61de1ee1cac498ae$var$$wnd.Math.max(j, f.a);
        l += f.a * f.b;
    }
    j = $61de1ee1cac498ae$var$$wnd.Math.max(j, $61de1ee1cac498ae$var$$wnd.Math.sqrt(l) * $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a.Kc().Pb(), 37), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$owc)))));
    m = 0;
    n = 0;
    i = 0;
    c = b;
    for(h = a.Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 37);
        k = g.f;
        if (m + k.a > j) {
            m = 0;
            n += i + b;
            i = 0;
        }
        $61de1ee1cac498ae$var$uXb(g, m, n);
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, m + k.a);
        i = $61de1ee1cac498ae$var$$wnd.Math.max(i, k.b);
        m += k.a + b;
    }
    return new $61de1ee1cac498ae$var$f7c(c + b, n + i + b);
}
function $61de1ee1cac498ae$var$mQc(a, b, c, d, e) {
    var f, g, h, i, j, k, l;
    for(g = new $61de1ee1cac498ae$var$olb(b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
        i = f.c;
        if (c.a._b(i)) j = ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$DQc);
        else if (d.a._b(i)) j = ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$EQc);
        else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Source port must be in one of the port sets."));
        k = f.d;
        if (c.a._b(k)) l = ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$DQc);
        else if (d.a._b(k)) l = ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$EQc);
        else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Target port must be in one of the port sets."));
        h = new $61de1ee1cac498ae$var$YQc(f, j, l);
        $61de1ee1cac498ae$var$Rhb(a.b, f, h);
        e.c[e.c.length] = h;
    }
}
function $61de1ee1cac498ae$var$lfd(a, b) {
    var c, d, e, f, g, h, i;
    if (!$61de1ee1cac498ae$var$mpd(a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$Sse));
    d = $61de1ee1cac498ae$var$mpd(a);
    f = d.g;
    e = d.f;
    if (f <= 0 && e <= 0) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd;
    h = a.i;
    i = a.j;
    switch(b.g){
        case 2:
        case 1:
            if (h < 0) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd;
            else if (h + a.g > f) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd;
            break;
        case 4:
        case 3:
            if (i < 0) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd;
            else if (i + a.f > e) return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd;
    }
    g = (h + a.g / 2) / f;
    c = (i + a.f / 2) / e;
    return g + c <= 1 && g - c <= 0 ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) : g + c >= 1 && g - c >= 0 ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) : c < 0.5 ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) : ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd);
}
function $61de1ee1cac498ae$var$vhb(a, b, c, d, e) {
    var f, g;
    f = $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$xbb(b[0], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(d[0], $61de1ee1cac498ae$var$Yje));
    a[0] = $61de1ee1cac498ae$var$Tbb(f);
    f = $61de1ee1cac498ae$var$Obb(f, 32);
    if (c >= e) {
        for(g = 1; g < e; g++){
            f = $61de1ee1cac498ae$var$wbb(f, $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$xbb(b[g], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(d[g], $61de1ee1cac498ae$var$Yje)));
            a[g] = $61de1ee1cac498ae$var$Tbb(f);
            f = $61de1ee1cac498ae$var$Obb(f, 32);
        }
        for(; g < c; g++){
            f = $61de1ee1cac498ae$var$wbb(f, $61de1ee1cac498ae$var$xbb(b[g], $61de1ee1cac498ae$var$Yje));
            a[g] = $61de1ee1cac498ae$var$Tbb(f);
            f = $61de1ee1cac498ae$var$Obb(f, 32);
        }
    } else {
        for(g = 1; g < c; g++){
            f = $61de1ee1cac498ae$var$wbb(f, $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$xbb(b[g], $61de1ee1cac498ae$var$Yje), $61de1ee1cac498ae$var$xbb(d[g], $61de1ee1cac498ae$var$Yje)));
            a[g] = $61de1ee1cac498ae$var$Tbb(f);
            f = $61de1ee1cac498ae$var$Obb(f, 32);
        }
        for(; g < e; g++){
            f = $61de1ee1cac498ae$var$wbb(f, $61de1ee1cac498ae$var$xbb(d[g], $61de1ee1cac498ae$var$Yje));
            a[g] = $61de1ee1cac498ae$var$Tbb(f);
            f = $61de1ee1cac498ae$var$Obb(f, 32);
        }
    }
    $61de1ee1cac498ae$var$ybb(f, 0) != 0 && (a[g] = $61de1ee1cac498ae$var$Tbb(f));
}
function $61de1ee1cac498ae$var$_fe(a) {
    $61de1ee1cac498ae$var$wfe();
    var b, c, d, e, f, g;
    if (a.e != 4 && a.e != 5) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Token#complementRanges(): must be RANGE: " + a.e));
    f = a;
    $61de1ee1cac498ae$var$Yfe(f);
    $61de1ee1cac498ae$var$Vfe(f);
    d = f.b.length + 2;
    f.b[0] == 0 && (d -= 2);
    c = f.b[f.b.length - 1];
    c == $61de1ee1cac498ae$var$lxe && (d -= 2);
    e = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    e.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, d, 15, 1);
    g = 0;
    if (f.b[0] > 0) {
        e.b[g++] = 0;
        e.b[g++] = f.b[0] - 1;
    }
    for(b = 1; b < f.b.length - 2; b += 2){
        e.b[g++] = f.b[b] + 1;
        e.b[g++] = f.b[b + 1] - 1;
    }
    if (c != $61de1ee1cac498ae$var$lxe) {
        e.b[g++] = c + 1;
        e.b[g] = $61de1ee1cac498ae$var$lxe;
    }
    e.a = true;
    return e;
}
function $61de1ee1cac498ae$var$Pxd(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = c.gc();
    if (d == 0) return false;
    else {
        if (a.ej()) {
            j = a.fj();
            $61de1ee1cac498ae$var$iud(a, b, c);
            g = d == 1 ? a.Zi(3, null, c.Kc().Pb(), b, j) : a.Zi(5, null, c, b, j);
            if (a.bj()) {
                h = d < 100 ? null : new $61de1ee1cac498ae$var$Ixd(d);
                f = b + d;
                for(e = b; e < f; ++e){
                    k = a.g[e];
                    h = a.cj(k, h);
                    h = a.jj(k, h);
                }
                if (!h) a.$i(g);
                else {
                    h.Ei(g);
                    h.Fi();
                }
            } else a.$i(g);
        } else {
            $61de1ee1cac498ae$var$iud(a, b, c);
            if (a.bj()) {
                h = d < 100 ? null : new $61de1ee1cac498ae$var$Ixd(d);
                f = b + d;
                for(e = b; e < f; ++e){
                    i = a.g[e];
                    h = a.cj(i, h);
                }
                !!h && h.Fi();
            }
        }
        return true;
    }
}
function $61de1ee1cac498ae$var$YNc(a, b, c, d) {
    var e, f, g, h, i;
    for(g = new $61de1ee1cac498ae$var$olb(a.k); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 129);
        if (!d || e.c == ($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc)) {
            i = e.b;
            if (i.g < 0 && e.d > 0) {
                $61de1ee1cac498ae$var$pOc(i, i.d - e.d);
                e.c == ($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc) && $61de1ee1cac498ae$var$nOc(i, i.a - e.d);
                i.d <= 0 && i.i > 0 && $61de1ee1cac498ae$var$Gsb(b, i, b.c.b, b.c);
            }
        }
    }
    for(f = new $61de1ee1cac498ae$var$olb(a.f); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 129);
        if (!d || e.c == ($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc)) {
            h = e.a;
            if (h.g < 0 && e.d > 0) {
                $61de1ee1cac498ae$var$qOc(h, h.i - e.d);
                e.c == ($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc) && $61de1ee1cac498ae$var$oOc(h, h.b - e.d);
                h.i <= 0 && h.d > 0 && $61de1ee1cac498ae$var$Gsb(c, h, c.c.b, c.c);
            }
        }
    }
}
function $61de1ee1cac498ae$var$gSc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    $61de1ee1cac498ae$var$Odd(c, "Processor compute fanout", 1);
    $61de1ee1cac498ae$var$Uhb(a.b);
    $61de1ee1cac498ae$var$Uhb(a.a);
    h = null;
    f = $61de1ee1cac498ae$var$Jsb(b.b, 0);
    while(!h && f.b != f.d.c){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(f), 86);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(j, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc)))) && (h = j);
    }
    i = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$Gsb(i, h, i.c.b, i.c);
    $61de1ee1cac498ae$var$fSc(a, i);
    for(k = $61de1ee1cac498ae$var$Jsb(b.b, 0); k.b != k.d.c;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(k), 86);
        g = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$vNb(j, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$$Sc)));
        e = $61de1ee1cac498ae$var$Phb(a.b, g) != null ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.b, g), 19).a : 0;
        $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$ZSc, $61de1ee1cac498ae$var$meb(e));
        d = 1 + ($61de1ee1cac498ae$var$Phb(a.a, g) != null ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.a, g), 19).a : 0);
        $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$XSc, $61de1ee1cac498ae$var$meb(d));
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$WPc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o;
    m = $61de1ee1cac498ae$var$VPc(a, c);
    for(i = 0; i < b; i++){
        $61de1ee1cac498ae$var$Aib(e, c);
        n = new $61de1ee1cac498ae$var$Rkb;
        o = ($61de1ee1cac498ae$var$sCb(d.b < d.d.gc()), $61de1ee1cac498ae$var$BD(d.d.Xb(d.c = d.b++), 407));
        for(k = m + i; k < a.b; k++){
            h = o;
            o = ($61de1ee1cac498ae$var$sCb(d.b < d.d.gc()), $61de1ee1cac498ae$var$BD(d.d.Xb(d.c = d.b++), 407));
            $61de1ee1cac498ae$var$Ekb(n, new $61de1ee1cac498ae$var$aQc(h, o, c));
        }
        for(l = m + i; l < a.b; l++){
            $61de1ee1cac498ae$var$sCb(d.b > 0);
            d.a.Xb(d.c = --d.b);
            l > m + i && $61de1ee1cac498ae$var$uib(d);
        }
        for(g = new $61de1ee1cac498ae$var$olb(n); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 407);
            $61de1ee1cac498ae$var$Aib(d, f);
        }
        if (i < b - 1) for(j = m + i; j < a.b; j++){
            $61de1ee1cac498ae$var$sCb(d.b > 0);
            d.a.Xb(d.c = --d.b);
        }
    }
}
function $61de1ee1cac498ae$var$Jfe() {
    $61de1ee1cac498ae$var$wfe();
    var a, b, c, d, e, f;
    if ($61de1ee1cac498ae$var$gfe) return $61de1ee1cac498ae$var$gfe;
    a = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    $61de1ee1cac498ae$var$Xfe(a, $61de1ee1cac498ae$var$Kfe($61de1ee1cac498ae$var$vxe, true));
    $61de1ee1cac498ae$var$Zfe(a, $61de1ee1cac498ae$var$Kfe("M", true));
    $61de1ee1cac498ae$var$Zfe(a, $61de1ee1cac498ae$var$Kfe("C", true));
    f = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    for(d = 0; d < 11; d++)$61de1ee1cac498ae$var$Ufe(f, d, d);
    b = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    $61de1ee1cac498ae$var$Xfe(b, $61de1ee1cac498ae$var$Kfe("M", true));
    $61de1ee1cac498ae$var$Ufe(b, 4448, 4607);
    $61de1ee1cac498ae$var$Ufe(b, 65438, 65439);
    e = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Lge(2));
    $61de1ee1cac498ae$var$Kge(e, a);
    $61de1ee1cac498ae$var$Kge(e, $61de1ee1cac498ae$var$ffe);
    c = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Lge(2));
    c.$l($61de1ee1cac498ae$var$Bfe(f, $61de1ee1cac498ae$var$Kfe("L", true)));
    c.$l(b);
    c = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(3, c));
    c = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$rge(e, c));
    $61de1ee1cac498ae$var$gfe = c;
    return $61de1ee1cac498ae$var$gfe;
}
function $61de1ee1cac498ae$var$S3c(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$o8c)));
    if ($61de1ee1cac498ae$var$T3c(b, a)) return;
    if (!$61de1ee1cac498ae$var$ikd(a, $61de1ee1cac498ae$var$F9c) && ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a).i != 0 || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$M8c))))) {
        if (b == null || $61de1ee1cac498ae$var$ufb(b).length == 0) {
            if (!$61de1ee1cac498ae$var$T3c($61de1ee1cac498ae$var$sne, a)) {
                c = $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb(new $61de1ee1cac498ae$var$Wfb("Unable to load default layout algorithm "), $61de1ee1cac498ae$var$sne), " for unconfigured node ");
                $61de1ee1cac498ae$var$yfd(a, c);
                throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c(c.a));
            }
        } else {
            c = $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb(new $61de1ee1cac498ae$var$Wfb("Layout algorithm '"), b), "' not found for ");
            $61de1ee1cac498ae$var$yfd(a, c);
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c(c.a));
        }
    }
}
function $61de1ee1cac498ae$var$hIb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    c = a.i;
    b = a.n;
    if (a.b == 0) {
        n = c.c + b.b;
        m = c.b - b.b - b.c;
        for(g = a.a, i = 0, k = g.length; i < k; ++i){
            e = g[i];
            $61de1ee1cac498ae$var$mHb(e, n, m);
        }
    } else {
        d = $61de1ee1cac498ae$var$kIb(a, false);
        $61de1ee1cac498ae$var$mHb(a.a[0], c.c + b.b, d[0]);
        $61de1ee1cac498ae$var$mHb(a.a[2], c.c + c.b - b.c - d[2], d[2]);
        l = c.b - b.b - b.c;
        if (d[0] > 0) {
            l -= d[0] + a.c;
            d[0] += a.c;
        }
        d[2] > 0 && (l -= d[2] + a.c);
        d[1] = $61de1ee1cac498ae$var$$wnd.Math.max(d[1], l);
        $61de1ee1cac498ae$var$mHb(a.a[1], c.c + b.b + d[0] - (d[1] - l) / 2, d[1]);
    }
    for(f = a.a, h = 0, j = f.length; h < j; ++h){
        e = f[h];
        $61de1ee1cac498ae$var$JD(e, 326) && $61de1ee1cac498ae$var$BD(e, 326).Te();
    }
}
function $61de1ee1cac498ae$var$KMc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    l = new $61de1ee1cac498ae$var$JMc;
    l.d = 0;
    for(g = new $61de1ee1cac498ae$var$olb(a.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        l.d += f.a.c.length;
    }
    d = 0;
    e = 0;
    l.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b.c.length, 15, 1);
    j = 0;
    k = 0;
    l.e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, l.d, 15, 1);
    for(c = new $61de1ee1cac498ae$var$olb(a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 29);
        b.p = d++;
        l.a[b.p] = e++;
        k = 0;
        for(i = new $61de1ee1cac498ae$var$olb(b.a); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            h.p = j++;
            l.e[h.p] = k++;
        }
    }
    l.c = new $61de1ee1cac498ae$var$OMc(l);
    l.b = $61de1ee1cac498ae$var$Pu(l.d);
    $61de1ee1cac498ae$var$LMc(l, a);
    l.f = $61de1ee1cac498ae$var$Pu(l.d);
    $61de1ee1cac498ae$var$MMc(l, a);
    return l;
}
function $61de1ee1cac498ae$var$GZc(a, b) {
    var c, d, e, f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.n, a.n.c.length - 1), 211).d;
    a.p = $61de1ee1cac498ae$var$$wnd.Math.min(a.p, b.g);
    a.r = $61de1ee1cac498ae$var$$wnd.Math.max(a.r, f);
    a.g = $61de1ee1cac498ae$var$$wnd.Math.max(a.g, b.g + (a.b.c.length == 1 ? 0 : a.i));
    a.o = $61de1ee1cac498ae$var$$wnd.Math.min(a.o, b.f);
    a.e += b.f + (a.b.c.length == 1 ? 0 : a.i);
    a.f = $61de1ee1cac498ae$var$$wnd.Math.max(a.f, b.f);
    e = a.n.c.length > 0 ? (a.n.c.length - 1) * a.i : 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.n); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 211);
        e += c.a;
    }
    a.d = e;
    a.a = a.e / a.b.c.length - a.i * ((a.b.c.length - 1) / a.b.c.length);
    $61de1ee1cac498ae$var$u$c(a.j);
}
function $61de1ee1cac498ae$var$LQb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$sSb)));
    if (k == null || ($61de1ee1cac498ae$var$uCb(k), k)) {
        l = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, b.e.c.length, 16, 1);
        g = $61de1ee1cac498ae$var$HQb(b);
        e = new $61de1ee1cac498ae$var$Psb;
        for(j = new $61de1ee1cac498ae$var$olb(b.e); j.a < j.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 144);
            c = $61de1ee1cac498ae$var$IQb(a, h, null, null, l, g);
            if (c) {
                $61de1ee1cac498ae$var$tNb(c, b);
                $61de1ee1cac498ae$var$Gsb(e, c, e.c.b, e.c);
            }
        }
        if (e.b > 1) for(d = $61de1ee1cac498ae$var$Jsb(e, 0); d.b != d.d.c;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 231);
            f = 0;
            for(i = new $61de1ee1cac498ae$var$olb(c.e); i.a < i.c.c.length;){
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 144);
                h.b = f++;
            }
        }
        return e;
    }
    return $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$$O, 1), $61de1ee1cac498ae$var$fme, 231, 0, [
        b
    ]));
}
function $61de1ee1cac498ae$var$TKd(a) {
    var b, c, d, e, f, g, h;
    if (!a.g) {
        h = new $61de1ee1cac498ae$var$zNd;
        b = $61de1ee1cac498ae$var$KKd;
        g = b.a.zc(a, b);
        if (g == null) {
            for(d = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$_Kd(a)); d.e != d.i.gc();){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 26);
                $61de1ee1cac498ae$var$ytd(h, $61de1ee1cac498ae$var$TKd(c));
            }
            b.a.Bc(a);
            b.a.gc() == 0 && undefined;
        }
        e = h.i;
        for(f = (!a.s && (a.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, a, 21, 17)), new $61de1ee1cac498ae$var$Fyd(a.s)); f.e != f.i.gc(); ++e)$61de1ee1cac498ae$var$bJd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(f), 449), e);
        $61de1ee1cac498ae$var$ytd(h, (!a.s && (a.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, a, 21, 17)), a.s));
        $61de1ee1cac498ae$var$vud(h);
        a.g = new $61de1ee1cac498ae$var$rNd(a, h);
        a.i = $61de1ee1cac498ae$var$BD(h.g, 247);
        a.i == null && (a.i = $61de1ee1cac498ae$var$MKd);
        a.p = null;
        $61de1ee1cac498ae$var$$Kd(a).b &= -5;
    }
    return a.g;
}
function $61de1ee1cac498ae$var$iIb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
    d = a.i;
    c = a.n;
    if (a.b == 0) {
        b = $61de1ee1cac498ae$var$jIb(a, false);
        $61de1ee1cac498ae$var$nHb(a.a[0], d.d + c.d, b[0]);
        $61de1ee1cac498ae$var$nHb(a.a[2], d.d + d.a - c.a - b[2], b[2]);
        m = d.a - c.d - c.a;
        l = m;
        if (b[0] > 0) {
            b[0] += a.c;
            l -= b[0];
        }
        b[2] > 0 && (l -= b[2] + a.c);
        b[1] = $61de1ee1cac498ae$var$$wnd.Math.max(b[1], l);
        $61de1ee1cac498ae$var$nHb(a.a[1], d.d + c.d + b[0] - (b[1] - l) / 2, b[1]);
    } else {
        o = d.d + c.d;
        n = d.a - c.d - c.a;
        for(g = a.a, i = 0, k = g.length; i < k; ++i){
            e = g[i];
            $61de1ee1cac498ae$var$nHb(e, o, n);
        }
    }
    for(f = a.a, h = 0, j = f.length; h < j; ++h){
        e = f[h];
        $61de1ee1cac498ae$var$JD(e, 326) && $61de1ee1cac498ae$var$BD(e, 326).Ue();
    }
}
function $61de1ee1cac498ae$var$boc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    k = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b.c.length + 1, 15, 1);
    j = new $61de1ee1cac498ae$var$Tqb;
    d = 0;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        k[d++] = j.a.gc();
        for(i = new $61de1ee1cac498ae$var$olb(e.a); i.a < i.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
                b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
                j.a.zc(b, j);
            }
        }
        for(h = new $61de1ee1cac498ae$var$olb(e.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
                b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
                j.a.Bc(b);
            }
        }
    }
    return k;
}
function $61de1ee1cac498ae$var$F2d(a, b, c, d) {
    var e, f, g, h, i;
    i = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    e = $61de1ee1cac498ae$var$BD(a.g, 119);
    $61de1ee1cac498ae$var$Q6d();
    if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.rl(f.ak()) && $61de1ee1cac498ae$var$pb(f, c)) return true;
    }
    else if (c != null) {
        for(h = 0; h < a.i; ++h){
            f = e[h];
            if (i.rl(f.ak()) && $61de1ee1cac498ae$var$pb(c, f.dd())) return true;
        }
        if (d) for(g = 0; g < a.i; ++g){
            f = e[g];
            if (i.rl(f.ak()) && $61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$a3d(a, $61de1ee1cac498ae$var$BD(f.dd(), 56)))) return true;
        }
    } else for(g = 0; g < a.i; ++g){
        f = e[g];
        if (i.rl(f.ak()) && f.dd() == null) return false;
    }
    return false;
}
function $61de1ee1cac498ae$var$e3d(a, b, c, d) {
    var e, f, g, h, i, j;
    j = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    g = $61de1ee1cac498ae$var$BD(a.g, 119);
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        if (b.hi()) {
            f = $61de1ee1cac498ae$var$M2d(a, b, d, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0);
            if (f >= 0 && f != c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$kue));
        }
        e = 0;
        for(i = 0; i < a.i; ++i){
            h = g[i];
            if (j.rl(h.ak())) {
                if (e == c) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(a, i, ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? $61de1ee1cac498ae$var$BD(d, 72) : $61de1ee1cac498ae$var$R6d(b, d))), 72);
                ++e;
            }
        }
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$gve + c + $61de1ee1cac498ae$var$mue + e));
    } else {
        for(i = 0; i < a.i; ++i){
            h = g[i];
            if (j.rl(h.ak())) return $61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? h : h.dd();
        }
        return null;
    }
}
function $61de1ee1cac498ae$var$ONb(a, b, c, d) {
    var e, f, g, h;
    h = c;
    for(g = new $61de1ee1cac498ae$var$olb(b.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 221);
        e = $61de1ee1cac498ae$var$BD(f.b, 65);
        if ($61de1ee1cac498ae$var$Jy(a.b.c, e.b.c + e.b.b) <= 0 && $61de1ee1cac498ae$var$Jy(e.b.c, a.b.c + a.b.b) <= 0 && $61de1ee1cac498ae$var$Jy(a.b.d, e.b.d + e.b.a) <= 0 && $61de1ee1cac498ae$var$Jy(e.b.d, a.b.d + a.b.a) <= 0) {
            if ($61de1ee1cac498ae$var$Jy(e.b.c, a.b.c + a.b.b) == 0 && d.a < 0 || $61de1ee1cac498ae$var$Jy(e.b.c + e.b.b, a.b.c) == 0 && d.a > 0 || $61de1ee1cac498ae$var$Jy(e.b.d, a.b.d + a.b.a) == 0 && d.b < 0 || $61de1ee1cac498ae$var$Jy(e.b.d + e.b.a, a.b.d) == 0 && d.b > 0) {
                h = 0;
                break;
            }
        } else h = $61de1ee1cac498ae$var$$wnd.Math.min(h, $61de1ee1cac498ae$var$YNb(a, e, d));
        h = $61de1ee1cac498ae$var$$wnd.Math.min(h, $61de1ee1cac498ae$var$ONb(a, f, h, d));
    }
    return h;
}
function $61de1ee1cac498ae$var$ifd(a, b) {
    var c, d, e, f, g, h, i;
    if (a.b < 2) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The vector chain must contain at least a source and a target point."));
    e = ($61de1ee1cac498ae$var$sCb(a.b != 0), $61de1ee1cac498ae$var$BD(a.a.a.c, 8));
    $61de1ee1cac498ae$var$nmd(b, e.a, e.b);
    i = new $61de1ee1cac498ae$var$Oyd((!b.a && (b.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, b, 5)), b.a));
    g = $61de1ee1cac498ae$var$Jsb(a, 1);
    while(g.a < a.b - 1){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 8);
        if (i.e != i.i.gc()) c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 469);
        else {
            c = ($61de1ee1cac498ae$var$Fhd(), d = new $61de1ee1cac498ae$var$xkd, d);
            $61de1ee1cac498ae$var$Myd(i, c);
        }
        $61de1ee1cac498ae$var$ukd(c, h.a, h.b);
    }
    while(i.e != i.i.gc()){
        $61de1ee1cac498ae$var$Dyd(i);
        $61de1ee1cac498ae$var$Eyd(i);
    }
    f = ($61de1ee1cac498ae$var$sCb(a.b != 0), $61de1ee1cac498ae$var$BD(a.c.b.c, 8));
    $61de1ee1cac498ae$var$gmd(b, f.a, f.b);
}
function $61de1ee1cac498ae$var$$lc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    c = 0;
    for(e = new $61de1ee1cac498ae$var$olb(($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 101)).g.b.j); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 11);
        d.p = c++;
    }
    b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? $61de1ee1cac498ae$var$Okb(a, new $61de1ee1cac498ae$var$gmc) : $61de1ee1cac498ae$var$Okb(a, new $61de1ee1cac498ae$var$kmc);
    h = 0;
    k = a.c.length - 1;
    while(h < k){
        g = ($61de1ee1cac498ae$var$tCb(h, a.c.length), $61de1ee1cac498ae$var$BD(a.c[h], 101));
        j = ($61de1ee1cac498ae$var$tCb(k, a.c.length), $61de1ee1cac498ae$var$BD(a.c[k], 101));
        f = b == $61de1ee1cac498ae$var$Acd ? g.c : g.a;
        i = b == $61de1ee1cac498ae$var$Acd ? j.a : j.c;
        $61de1ee1cac498ae$var$amc(g, b, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$yjc), f);
        $61de1ee1cac498ae$var$amc(j, b, $61de1ee1cac498ae$var$xjc, i);
        ++h;
        --k;
    }
    h == k && $61de1ee1cac498ae$var$amc(($61de1ee1cac498ae$var$tCb(h, a.c.length), $61de1ee1cac498ae$var$BD(a.c[h], 101)), b, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$wjc), null);
}
function $61de1ee1cac498ae$var$UVc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    l = a.a.i + a.a.g / 2;
    m = a.a.i + a.a.g / 2;
    o = b.i + b.g / 2;
    q = b.j + b.f / 2;
    h = new $61de1ee1cac498ae$var$f7c(o, q);
    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$C9c)), 8);
    j.a = j.a + l;
    j.b = j.b + m;
    f = (h.b - j.b) / (h.a - j.a);
    d = h.b - f * h.a;
    p = c.i + c.g / 2;
    r = c.j + c.f / 2;
    i = new $61de1ee1cac498ae$var$f7c(p, r);
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(c, $61de1ee1cac498ae$var$C9c), 8);
    k.a = k.a + l;
    k.b = k.b + m;
    g = (i.b - k.b) / (i.a - k.a);
    e = i.b - g * i.a;
    n = (d - e) / (g - f);
    if (j.a < n && h.a < n || n < j.a && n < h.a) return false;
    else if (k.a < n && i.a < n || n < k.a && n < i.a) return false;
    return true;
}
function $61de1ee1cac498ae$var$gqd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.c, b), 183);
    if (!m) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd("Edge did not exist in input."));
    j = $61de1ee1cac498ae$var$Wpd(m);
    f = $61de1ee1cac498ae$var$Fhe((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, b, 6, 6)), b.a));
    h = !f;
    if (h) {
        n = new $61de1ee1cac498ae$var$wB;
        c = new $61de1ee1cac498ae$var$Rrd(a, j, n);
        $61de1ee1cac498ae$var$Dhe((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, b, 6, 6)), b.a), c);
        $61de1ee1cac498ae$var$cC(m, $61de1ee1cac498ae$var$Nte, n);
    }
    e = $61de1ee1cac498ae$var$ikd(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Q8c));
    if (e) {
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Q8c), 74);
        g = !k || $61de1ee1cac498ae$var$Ehe(k);
        i = !g;
        if (i) {
            l = new $61de1ee1cac498ae$var$wB;
            d = new $61de1ee1cac498ae$var$Zrd(l);
            $61de1ee1cac498ae$var$reb(k, d);
            $61de1ee1cac498ae$var$cC(m, "junctionPoints", l);
        }
    }
    $61de1ee1cac498ae$var$Upd(m, "container", $61de1ee1cac498ae$var$Mld(b).k);
    return null;
}
function $61de1ee1cac498ae$var$eDb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    this.a = a;
    this.b = b;
    this.c = c;
    this.e = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$GM, 1), $61de1ee1cac498ae$var$Uhe, 168, 0, [
        new $61de1ee1cac498ae$var$aDb(a, b),
        new $61de1ee1cac498ae$var$aDb(b, c),
        new $61de1ee1cac498ae$var$aDb(c, a)
    ]));
    this.f = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        a,
        b,
        c
    ]));
    this.d = (d = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(this.b), this.a), e = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(this.c), this.a), f = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(this.c), this.b), g = d.a * (this.a.a + this.b.a) + d.b * (this.a.b + this.b.b), h = e.a * (this.a.a + this.c.a) + e.b * (this.a.b + this.c.b), i = 2 * (d.a * f.b - d.b * f.a), j = (e.b * g - d.b * h) / i, k = (d.a * h - e.a * g) / i, new $61de1ee1cac498ae$var$f7c(j, k));
}
function $61de1ee1cac498ae$var$nvd(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    m = new $61de1ee1cac498ae$var$yC(a.p);
    $61de1ee1cac498ae$var$cC(b, $61de1ee1cac498ae$var$fue, m);
    if (c && !(!a.f ? null : $61de1ee1cac498ae$var$vmb(a.f)).a.dc()) {
        k = new $61de1ee1cac498ae$var$wB;
        $61de1ee1cac498ae$var$cC(b, "logs", k);
        h = 0;
        for(o = new $61de1ee1cac498ae$var$Dnb((!a.f ? null : $61de1ee1cac498ae$var$vmb(a.f)).b.Kc()); o.b.Ob();){
            n = $61de1ee1cac498ae$var$GD(o.b.Pb());
            l = new $61de1ee1cac498ae$var$yC(n);
            $61de1ee1cac498ae$var$tB(k, h);
            $61de1ee1cac498ae$var$vB(k, h, l);
            ++h;
        }
    }
    if (d) {
        j = new $61de1ee1cac498ae$var$TB(a.q);
        $61de1ee1cac498ae$var$cC(b, "executionTime", j);
    }
    if (!$61de1ee1cac498ae$var$vmb(a.a).a.dc()) {
        g = new $61de1ee1cac498ae$var$wB;
        $61de1ee1cac498ae$var$cC(b, $61de1ee1cac498ae$var$Jte, g);
        h = 0;
        for(f = new $61de1ee1cac498ae$var$Dnb($61de1ee1cac498ae$var$vmb(a.a).b.Kc()); f.b.Ob();){
            e = $61de1ee1cac498ae$var$BD(f.b.Pb(), 1949);
            i = new $61de1ee1cac498ae$var$eC;
            $61de1ee1cac498ae$var$tB(g, h);
            $61de1ee1cac498ae$var$vB(g, h, i);
            $61de1ee1cac498ae$var$nvd(e, i, c, d);
            ++h;
        }
    }
}
function $61de1ee1cac498ae$var$PZb(a, b) {
    var c, d, e, f, g, h;
    f = a.c;
    g = a.d;
    $61de1ee1cac498ae$var$QZb(a, null);
    $61de1ee1cac498ae$var$RZb(a, null);
    b && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Msc)))) ? $61de1ee1cac498ae$var$QZb(a, $61de1ee1cac498ae$var$i_b(g.i, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc), ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd))) : $61de1ee1cac498ae$var$QZb(a, g);
    b && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$etc)))) ? $61de1ee1cac498ae$var$RZb(a, $61de1ee1cac498ae$var$i_b(f.i, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc), ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd))) : $61de1ee1cac498ae$var$RZb(a, f);
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 70);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc)), 272);
        e == ($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$pad) ? $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$Qwc, $61de1ee1cac498ae$var$oad) : e == $61de1ee1cac498ae$var$oad && $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$Qwc, $61de1ee1cac498ae$var$pad);
    }
    h = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc))));
    $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$ltc, ($61de1ee1cac498ae$var$Bcb(), h ? false : true));
    a.a = $61de1ee1cac498ae$var$w7c(a.a);
}
function $61de1ee1cac498ae$var$VQb(a, b, c) {
    var d, e, f, g, h, i;
    d = 0;
    for(f = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); f.e != f.i.gc();){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(f), 33);
        g = "";
        (!e.n && (e.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, e, 1, 7)), e.n).i == 0 || (g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!e.n && (e.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, e, 1, 7)), e.n), 0), 137).a);
        h = new $61de1ee1cac498ae$var$pRb(g);
        $61de1ee1cac498ae$var$tNb(h, e);
        $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$FSb), e);
        h.b = d++;
        h.d.a = e.i + e.g / 2;
        h.d.b = e.j + e.f / 2;
        h.e.a = $61de1ee1cac498ae$var$$wnd.Math.max(e.g, 1);
        h.e.b = $61de1ee1cac498ae$var$$wnd.Math.max(e.f, 1);
        $61de1ee1cac498ae$var$Ekb(b.e, h);
        $61de1ee1cac498ae$var$jrb(c.f, e, h);
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(e, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$mSb)), 98);
        i == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$ccd) && (i = $61de1ee1cac498ae$var$bcd);
    }
}
function $61de1ee1cac498ae$var$XJc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    c = $61de1ee1cac498ae$var$nGb(new $61de1ee1cac498ae$var$pGb, a.f);
    j = a.i[b.c.i.p];
    n = a.i[b.d.i.p];
    i = b.c;
    m = b.d;
    h = i.a.b;
    l = m.a.b;
    j.b || (h += i.n.b);
    n.b || (l += m.n.b);
    k = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.max(0, h - l));
    g = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.max(0, l - h));
    o = (p = $61de1ee1cac498ae$var$$wnd.Math.max(1, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$eyc)), 19).a), q = $61de1ee1cac498ae$var$JJc(b.c.i.k, b.d.i.k), p * q);
    e = $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, o), g), c), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.k, b.c), 121)));
    f = $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, o), k), c), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.k, b.d), 121)));
    d = new $61de1ee1cac498ae$var$qKc(e, f);
    a.c[b.p] = d;
}
function $61de1ee1cac498ae$var$NEc(a, b, c, d) {
    var e, f, g, h, i, j;
    g = new $61de1ee1cac498ae$var$_Ec(a, b, c);
    i = new $61de1ee1cac498ae$var$Bib(d, 0);
    e = false;
    while(i.b < i.d.gc()){
        h = ($61de1ee1cac498ae$var$sCb(i.b < i.d.gc()), $61de1ee1cac498ae$var$BD(i.d.Xb(i.c = i.b++), 233));
        if (h == b || h == c) $61de1ee1cac498ae$var$uib(i);
        else if (!e && $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$REc(h.g, h.d[0]).a) > $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$REc(g.g, g.d[0]).a)) {
            $61de1ee1cac498ae$var$sCb(i.b > 0);
            i.a.Xb(i.c = --i.b);
            $61de1ee1cac498ae$var$Aib(i, g);
            e = true;
        } else if (!!h.e && h.e.gc() > 0) {
            f = (!h.e && (h.e = new $61de1ee1cac498ae$var$Rkb), h.e).Mc(b);
            j = (!h.e && (h.e = new $61de1ee1cac498ae$var$Rkb), h.e).Mc(c);
            if (f || j) {
                (!h.e && (h.e = new $61de1ee1cac498ae$var$Rkb), h.e).Fc(g);
                ++g.c;
            }
        }
    }
    e || (d.c[d.c.length] = g);
}
function $61de1ee1cac498ae$var$odc(a) {
    var b, c, d;
    if ($61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98))) for(c = new $61de1ee1cac498ae$var$olb(a.j); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 11);
        b.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd) && (d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10), d ? $61de1ee1cac498ae$var$G0b(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Hsc), 61)) : b.e.c.length - b.g.c.length < 0 ? $61de1ee1cac498ae$var$G0b(b, $61de1ee1cac498ae$var$zcd) : $61de1ee1cac498ae$var$G0b(b, $61de1ee1cac498ae$var$Tcd));
    }
    else {
        for(c = new $61de1ee1cac498ae$var$olb(a.j); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 11);
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
            d ? $61de1ee1cac498ae$var$G0b(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Hsc), 61)) : b.e.c.length - b.g.c.length < 0 ? $61de1ee1cac498ae$var$G0b(b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)) : $61de1ee1cac498ae$var$G0b(b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
        }
        $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Vxc, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$acd));
    }
}
function $61de1ee1cac498ae$var$age(a) {
    var b, c, d;
    switch(a){
        case 91:
        case 93:
        case 45:
        case 94:
        case 44:
        case 92:
            d = "\\" + String.fromCharCode(a & $61de1ee1cac498ae$var$aje);
            break;
        case 12:
            d = "\\f";
            break;
        case 10:
            d = "\\n";
            break;
        case 13:
            d = "\\r";
            break;
        case 9:
            d = "\\t";
            break;
        case 27:
            d = "\\e";
            break;
        default:
            if (a < 32) {
                c = (b = a >>> 0, "0" + b.toString(16));
                d = "\\x" + $61de1ee1cac498ae$var$qfb(c, c.length - 2, c.length);
            } else if (a >= $61de1ee1cac498ae$var$Tje) {
                c = (b = a >>> 0, "0" + b.toString(16));
                d = "\\v" + $61de1ee1cac498ae$var$qfb(c, c.length - 6, c.length);
            } else d = "" + String.fromCharCode(a & $61de1ee1cac498ae$var$aje);
    }
    return d;
}
function $61de1ee1cac498ae$var$yhb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    g = a.e;
    i = b.e;
    if (i == 0) return a;
    if (g == 0) return b.e == 0 ? b : new $61de1ee1cac498ae$var$Vgb(-b.e, b.d, b.a);
    f = a.d;
    h = b.d;
    if (f + h == 2) {
        c = $61de1ee1cac498ae$var$xbb(a.a[0], $61de1ee1cac498ae$var$Yje);
        d = $61de1ee1cac498ae$var$xbb(b.a[0], $61de1ee1cac498ae$var$Yje);
        g < 0 && (c = $61de1ee1cac498ae$var$Jbb(c));
        i < 0 && (d = $61de1ee1cac498ae$var$Jbb(d));
        return $61de1ee1cac498ae$var$ghb($61de1ee1cac498ae$var$Qbb(c, d));
    }
    e = f != h ? f > h ? 1 : -1 : $61de1ee1cac498ae$var$whb(a.a, b.a, f);
    if (e == -1) {
        l = -i;
        k = g == i ? $61de1ee1cac498ae$var$zhb(b.a, h, a.a, f) : $61de1ee1cac498ae$var$uhb(b.a, h, a.a, f);
    } else {
        l = g;
        if (g == i) {
            if (e == 0) return $61de1ee1cac498ae$var$Hgb(), $61de1ee1cac498ae$var$Ggb;
            k = $61de1ee1cac498ae$var$zhb(a.a, f, b.a, h);
        } else k = $61de1ee1cac498ae$var$uhb(a.a, f, b.a, h);
    }
    j = new $61de1ee1cac498ae$var$Vgb(l, k.length, k);
    $61de1ee1cac498ae$var$Jgb(j);
    return j;
}
function $61de1ee1cac498ae$var$YPc(a) {
    var b, c, d, e, f, g;
    this.e = new $61de1ee1cac498ae$var$Rkb;
    this.a = new $61de1ee1cac498ae$var$Rkb;
    for(c = a.b - 1; c < 3; c++)$61de1ee1cac498ae$var$St(a, 0, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(a, 0), 8));
    if (a.b < 4) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("At (least dimension + 1) control points are necessary!"));
    else {
        this.b = 3;
        this.d = true;
        this.c = false;
        $61de1ee1cac498ae$var$TPc(this, a.b + this.b - 1);
        g = new $61de1ee1cac498ae$var$Rkb;
        f = new $61de1ee1cac498ae$var$olb(this.e);
        for(b = 0; b < this.b - 1; b++)$61de1ee1cac498ae$var$Ekb(g, $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$mlb(f)));
        for(e = $61de1ee1cac498ae$var$Jsb(a, 0); e.b != e.d.c;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(e), 8);
            $61de1ee1cac498ae$var$Ekb(g, $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$mlb(f)));
            $61de1ee1cac498ae$var$Ekb(this.a, new $61de1ee1cac498ae$var$bQc(d, g));
            $61de1ee1cac498ae$var$tCb(0, g.c.length);
            g.c.splice(0, 1);
        }
    }
}
function $61de1ee1cac498ae$var$Bac(a, b) {
    var c, d, e, f, g, h, i, j, k;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        for(h = new $61de1ee1cac498ae$var$olb(e.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            if (g.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) {
                i = (j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17), k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq))), 17), !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc)))) || !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(k, $61de1ee1cac498ae$var$ltc)))) ? b : $61de1ee1cac498ae$var$sbd(b);
                $61de1ee1cac498ae$var$zac(g, i);
            }
            for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
                i = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc)))) ? $61de1ee1cac498ae$var$sbd(b) : b;
                $61de1ee1cac498ae$var$yac(c, i);
            }
        }
    }
}
function $61de1ee1cac498ae$var$yZc(a, b, c, d, e) {
    var f, g, h;
    if (c.f >= b.o && c.f <= b.f || b.a * 0.5 <= c.f && b.a * 1.5 >= c.f) {
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.n, b.n.c.length - 1), 211);
        if (g.e + g.d + c.g + e <= d && (f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.n, b.n.c.length - 1), 211), f.f - a.f + c.f <= a.b || a.a.c.length == 1)) {
            $61de1ee1cac498ae$var$EZc(b, c);
            return true;
        } else if (b.s + c.g <= d && (b.t + b.d + c.f + e <= a.b || a.a.c.length == 1)) {
            $61de1ee1cac498ae$var$Ekb(b.b, c);
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.n, b.n.c.length - 1), 211);
            $61de1ee1cac498ae$var$Ekb(b.n, new $61de1ee1cac498ae$var$VZc(b.s, h.f + h.a + b.i, b.i));
            $61de1ee1cac498ae$var$QZc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.n, b.n.c.length - 1), 211), c);
            $61de1ee1cac498ae$var$GZc(b, c);
            return true;
        }
    }
    return false;
}
function $61de1ee1cac498ae$var$Zxd(a, b, c) {
    var d, e, f, g;
    if (a.ej()) {
        e = null;
        f = a.fj();
        d = a.Zi(1, g = $61de1ee1cac498ae$var$uud(a, b, c), c, b, f);
        if (a.bj() && !(a.ni() && g != null ? $61de1ee1cac498ae$var$pb(g, c) : $61de1ee1cac498ae$var$PD(g) === $61de1ee1cac498ae$var$PD(c))) {
            g != null && (e = a.dj(g, e));
            e = a.cj(c, e);
            a.ij() && (e = a.lj(g, c, e));
            if (!e) a.$i(d);
            else {
                e.Ei(d);
                e.Fi();
            }
        } else {
            a.ij() && (e = a.lj(g, c, e));
            if (!e) a.$i(d);
            else {
                e.Ei(d);
                e.Fi();
            }
        }
        return g;
    } else {
        g = $61de1ee1cac498ae$var$uud(a, b, c);
        if (a.bj() && !(a.ni() && g != null ? $61de1ee1cac498ae$var$pb(g, c) : $61de1ee1cac498ae$var$PD(g) === $61de1ee1cac498ae$var$PD(c))) {
            e = null;
            g != null && (e = a.dj(g, null));
            e = a.cj(c, e);
            !!e && e.Fi();
        }
        return g;
    }
}
function $61de1ee1cac498ae$var$YA(a, b) {
    var c, d, e, f, g, h, i, j;
    b %= 24;
    if (a.q.getHours() != b) {
        d = new $61de1ee1cac498ae$var$$wnd.Date(a.q.getTime());
        d.setDate(d.getDate() + 1);
        h = a.q.getTimezoneOffset() - d.getTimezoneOffset();
        if (h > 0) {
            i = h / 60 | 0;
            j = h % 60;
            e = a.q.getDate();
            c = a.q.getHours();
            c + i >= 24 && ++e;
            f = new $61de1ee1cac498ae$var$$wnd.Date(a.q.getFullYear(), a.q.getMonth(), e, b + i, a.q.getMinutes() + j, a.q.getSeconds(), a.q.getMilliseconds());
            a.q.setTime(f.getTime());
        }
    }
    g = a.q.getTime();
    a.q.setTime(g + 3600000);
    a.q.getHours() != b && a.q.setTime(g);
}
function $61de1ee1cac498ae$var$opc(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, "Path-Like Graph Wrapping", 1);
    if (a.b.c.length == 0) {
        $61de1ee1cac498ae$var$Qdd(b);
        return;
    }
    e = new $61de1ee1cac498ae$var$Xoc(a);
    g = (e.i == null && (e.i = $61de1ee1cac498ae$var$Soc(e, new $61de1ee1cac498ae$var$Zoc)), $61de1ee1cac498ae$var$Edb(e.i) * e.f);
    c = g / (e.i == null && (e.i = $61de1ee1cac498ae$var$Soc(e, new $61de1ee1cac498ae$var$Zoc)), $61de1ee1cac498ae$var$Edb(e.i));
    if (e.b > c) {
        $61de1ee1cac498ae$var$Qdd(b);
        return;
    }
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Gyc)), 337).g){
        case 2:
            f = new $61de1ee1cac498ae$var$hpc;
            break;
        case 0:
            f = new $61de1ee1cac498ae$var$Ync;
            break;
        default:
            f = new $61de1ee1cac498ae$var$kpc;
    }
    d = f.Vf(a, e);
    if (!f.Wf()) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Myc), 338).g){
        case 2:
            d = $61de1ee1cac498ae$var$tpc(e, d);
            break;
        case 1:
            d = $61de1ee1cac498ae$var$rpc(e, d);
    }
    $61de1ee1cac498ae$var$npc(a, e, d);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$MFc(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Fub(a.d, a.e);
    a.c.a.$b();
    if ($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b.j, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$uwc)))) != 0 || $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$uwc))) != 0) {
        c = $61de1ee1cac498ae$var$dme;
        $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$ywc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) && $61de1ee1cac498ae$var$yNb(b.j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Jsc), ($61de1ee1cac498ae$var$Bcb(), true));
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$Ayc), 19).a;
        for(e = 0; e < f; e++){
            d = $61de1ee1cac498ae$var$WFc(a, b);
            if (d < c) {
                c = d;
                $61de1ee1cac498ae$var$ZFc(a);
                if (c == 0) break;
            }
        }
    } else {
        c = $61de1ee1cac498ae$var$Ohe;
        $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$ywc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) && $61de1ee1cac498ae$var$yNb(b.j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Jsc), ($61de1ee1cac498ae$var$Bcb(), true));
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$Ayc), 19).a;
        for(e = 0; e < f; e++){
            d = $61de1ee1cac498ae$var$XFc(a, b);
            if (d < c) {
                c = d;
                $61de1ee1cac498ae$var$ZFc(a);
                if (c == 0) break;
            }
        }
    }
}
function $61de1ee1cac498ae$var$spc(a, b) {
    var c, d, e, f, g, h, i, j;
    g = new $61de1ee1cac498ae$var$Rkb;
    h = 0;
    c = 0;
    i = 0;
    while(h < b.c.length - 1 && c < a.gc()){
        d = $61de1ee1cac498ae$var$BD(a.Xb(c), 19).a + i;
        while(($61de1ee1cac498ae$var$tCb(h + 1, b.c.length), $61de1ee1cac498ae$var$BD(b.c[h + 1], 19)).a < d)++h;
        j = 0;
        f = d - ($61de1ee1cac498ae$var$tCb(h, b.c.length), $61de1ee1cac498ae$var$BD(b.c[h], 19)).a;
        e = ($61de1ee1cac498ae$var$tCb(h + 1, b.c.length), $61de1ee1cac498ae$var$BD(b.c[h + 1], 19)).a - d;
        f > e && ++j;
        $61de1ee1cac498ae$var$Ekb(g, ($61de1ee1cac498ae$var$tCb(h + j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[h + j], 19)));
        i += ($61de1ee1cac498ae$var$tCb(h + j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[h + j], 19)).a - d;
        ++c;
        while(c < a.gc() && $61de1ee1cac498ae$var$BD(a.Xb(c), 19).a + i <= ($61de1ee1cac498ae$var$tCb(h + j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[h + j], 19)).a)++c;
        h += 1 + j;
    }
    return g;
}
function $61de1ee1cac498ae$var$RKd(a) {
    var b, c, d, e, f, g, h;
    if (!a.d) {
        h = new $61de1ee1cac498ae$var$XNd;
        b = $61de1ee1cac498ae$var$KKd;
        f = b.a.zc(a, b);
        if (f == null) {
            for(d = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$_Kd(a)); d.e != d.i.gc();){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 26);
                $61de1ee1cac498ae$var$ytd(h, $61de1ee1cac498ae$var$RKd(c));
            }
            b.a.Bc(a);
            b.a.gc() == 0 && undefined;
        }
        g = h.i;
        for(e = (!a.q && (a.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, a, 11, 10)), new $61de1ee1cac498ae$var$Fyd(a.q)); e.e != e.i.gc(); ++g)$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 399);
        $61de1ee1cac498ae$var$ytd(h, (!a.q && (a.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, a, 11, 10)), a.q));
        $61de1ee1cac498ae$var$vud(h);
        a.d = new $61de1ee1cac498ae$var$nNd(($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).o), 9), 18), h.i), h.g);
        a.e = $61de1ee1cac498ae$var$BD(h.g, 673);
        a.e == null && (a.e = $61de1ee1cac498ae$var$LKd);
        $61de1ee1cac498ae$var$$Kd(a).b &= -17;
    }
    return a.d;
}
function $61de1ee1cac498ae$var$M2d(a, b, c, d) {
    var e, f, g, h, i, j;
    j = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    i = 0;
    e = $61de1ee1cac498ae$var$BD(a.g, 119);
    $61de1ee1cac498ae$var$Q6d();
    if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) for(g = 0; g < a.i; ++g){
        f = e[g];
        if (j.rl(f.ak())) {
            if ($61de1ee1cac498ae$var$pb(f, c)) return i;
            ++i;
        }
    }
    else if (c != null) {
        for(h = 0; h < a.i; ++h){
            f = e[h];
            if (j.rl(f.ak())) {
                if ($61de1ee1cac498ae$var$pb(c, f.dd())) return i;
                ++i;
            }
        }
        if (d) {
            i = 0;
            for(g = 0; g < a.i; ++g){
                f = e[g];
                if (j.rl(f.ak())) {
                    if ($61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$a3d(a, $61de1ee1cac498ae$var$BD(f.dd(), 56)))) return i;
                    ++i;
                }
            }
        }
    } else for(g = 0; g < a.i; ++g){
        f = e[g];
        if (j.rl(f.ak())) {
            if (f.dd() == null) return i;
            ++i;
        }
    }
    return -1;
}
function $61de1ee1cac498ae$var$aed(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n;
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(a, new $61de1ee1cac498ae$var$Jed);
    g = $61de1ee1cac498ae$var$Ru(a);
    n = new $61de1ee1cac498ae$var$Rkb;
    m = new $61de1ee1cac498ae$var$Rkb;
    h = null;
    i = 0;
    while(g.b != 0){
        f = $61de1ee1cac498ae$var$BD(g.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(g.b != 0), $61de1ee1cac498ae$var$Nsb(g, g.a.a)), 157);
        if (!h || $61de1ee1cac498ae$var$red(h) * $61de1ee1cac498ae$var$qed(h) / 2 < $61de1ee1cac498ae$var$red(f) * $61de1ee1cac498ae$var$qed(f)) {
            h = f;
            n.c[n.c.length] = f;
        } else {
            i += $61de1ee1cac498ae$var$red(f) * $61de1ee1cac498ae$var$qed(f);
            m.c[m.c.length] = f;
            if (m.c.length > 1 && (i > $61de1ee1cac498ae$var$red(h) * $61de1ee1cac498ae$var$qed(h) / 2 || g.b == 0)) {
                l = new $61de1ee1cac498ae$var$wed(m);
                k = $61de1ee1cac498ae$var$red(h) / $61de1ee1cac498ae$var$qed(h);
                j = $61de1ee1cac498ae$var$fed(l, b, new $61de1ee1cac498ae$var$p0b, c, d, e, k);
                $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(l.e), j);
                h = l;
                n.c[n.c.length] = l;
                i = 0;
                m.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            }
        }
    }
    $61de1ee1cac498ae$var$Gkb(n, m);
    return n;
}
function $61de1ee1cac498ae$var$y6d(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p;
    if (c.mh(b)) {
        k = (n = b, !n ? null : $61de1ee1cac498ae$var$BD(d, 49).xh(n));
        if (k) {
            p = c.bh(b, a.a);
            o = b.t;
            if (o > 1 || o == -1) {
                l = $61de1ee1cac498ae$var$BD(p, 69);
                m = $61de1ee1cac498ae$var$BD(k, 69);
                if (l.dc()) m.$b();
                else {
                    g = !!$61de1ee1cac498ae$var$zUd(b);
                    f = 0;
                    for(h = a.a ? l.Kc() : l.Zh(); h.Ob();){
                        j = $61de1ee1cac498ae$var$BD(h.Pb(), 56);
                        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wrb(a, j), 56);
                        if (!e) {
                            if (a.b && !g) {
                                m.Xh(f, j);
                                ++f;
                            }
                        } else {
                            if (g) {
                                i = m.Xc(e);
                                i == -1 ? m.Xh(f, e) : f != i && m.ji(f, e);
                            } else m.Xh(f, e);
                            ++f;
                        }
                    }
                }
            } else if (p == null) k.Wb(null);
            else {
                e = $61de1ee1cac498ae$var$Wrb(a, p);
                e == null ? a.b && !$61de1ee1cac498ae$var$zUd(b) && k.Wb(p) : k.Wb(e);
            }
        }
    }
}
function $61de1ee1cac498ae$var$E6b(a, b) {
    var c, d, e, f, g, h, i, j;
    c = new $61de1ee1cac498ae$var$L6b;
    for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
        if ($61de1ee1cac498ae$var$OZb(d)) continue;
        h = d.c.i;
        if ($61de1ee1cac498ae$var$F6b(h, $61de1ee1cac498ae$var$C6b)) {
            j = $61de1ee1cac498ae$var$G6b(a, h, $61de1ee1cac498ae$var$C6b, $61de1ee1cac498ae$var$B6b);
            if (j == -1) continue;
            c.b = $61de1ee1cac498ae$var$$wnd.Math.max(c.b, j);
            !c.a && (c.a = new $61de1ee1cac498ae$var$Rkb);
            $61de1ee1cac498ae$var$Ekb(c.a, h);
        }
    }
    for(g = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(g);){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(g), 17);
        if ($61de1ee1cac498ae$var$OZb(f)) continue;
        i = f.d.i;
        if ($61de1ee1cac498ae$var$F6b(i, $61de1ee1cac498ae$var$B6b)) {
            j = $61de1ee1cac498ae$var$G6b(a, i, $61de1ee1cac498ae$var$B6b, $61de1ee1cac498ae$var$C6b);
            if (j == -1) continue;
            c.d = $61de1ee1cac498ae$var$$wnd.Math.max(c.d, j);
            !c.c && (c.c = new $61de1ee1cac498ae$var$Rkb);
            $61de1ee1cac498ae$var$Ekb(c.c, i);
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$Khb(a) {
    $61de1ee1cac498ae$var$Dhb();
    var b, c, d, e;
    b = $61de1ee1cac498ae$var$QD(a);
    if (a < $61de1ee1cac498ae$var$Chb.length) return $61de1ee1cac498ae$var$Chb[b];
    else if (a <= 50) return $61de1ee1cac498ae$var$Pgb(($61de1ee1cac498ae$var$Hgb(), $61de1ee1cac498ae$var$Egb), b);
    else if (a <= $61de1ee1cac498ae$var$_ie) return $61de1ee1cac498ae$var$Qgb($61de1ee1cac498ae$var$Pgb($61de1ee1cac498ae$var$Bhb[1], b), b);
    if (a > 1000000) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$ocb("power of ten too big"));
    if (a <= $61de1ee1cac498ae$var$Ohe) return $61de1ee1cac498ae$var$Qgb($61de1ee1cac498ae$var$Pgb($61de1ee1cac498ae$var$Bhb[1], b), b);
    d = $61de1ee1cac498ae$var$Pgb($61de1ee1cac498ae$var$Bhb[1], $61de1ee1cac498ae$var$Ohe);
    e = d;
    c = $61de1ee1cac498ae$var$Cbb(a - $61de1ee1cac498ae$var$Ohe);
    b = $61de1ee1cac498ae$var$QD(a % $61de1ee1cac498ae$var$Ohe);
    while($61de1ee1cac498ae$var$ybb(c, $61de1ee1cac498ae$var$Ohe) > 0){
        e = $61de1ee1cac498ae$var$Ogb(e, d);
        c = $61de1ee1cac498ae$var$Qbb(c, $61de1ee1cac498ae$var$Ohe);
    }
    e = $61de1ee1cac498ae$var$Ogb(e, $61de1ee1cac498ae$var$Pgb($61de1ee1cac498ae$var$Bhb[1], b));
    e = $61de1ee1cac498ae$var$Qgb(e, $61de1ee1cac498ae$var$Ohe);
    c = $61de1ee1cac498ae$var$Cbb(a - $61de1ee1cac498ae$var$Ohe);
    while($61de1ee1cac498ae$var$ybb(c, $61de1ee1cac498ae$var$Ohe) > 0){
        e = $61de1ee1cac498ae$var$Qgb(e, $61de1ee1cac498ae$var$Ohe);
        c = $61de1ee1cac498ae$var$Qbb(c, $61de1ee1cac498ae$var$Ohe);
    }
    e = $61de1ee1cac498ae$var$Qgb(e, b);
    return e;
}
function $61de1ee1cac498ae$var$X5b(a, b) {
    var c, d, e, f, g, h, i, j, k;
    $61de1ee1cac498ae$var$Odd(b, "Hierarchical port dummy size processing", 1);
    i = new $61de1ee1cac498ae$var$Rkb;
    k = new $61de1ee1cac498ae$var$Rkb;
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$myc))));
    c = d * 2;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        i.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        for(h = new $61de1ee1cac498ae$var$olb(e.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            if (g.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
                j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? i.c[i.c.length] = g : j == $61de1ee1cac498ae$var$Rcd && (k.c[k.c.length] = g);
            }
        }
        $61de1ee1cac498ae$var$Y5b(i, true, c);
        $61de1ee1cac498ae$var$Y5b(k, false, c);
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$Oac(a, b) {
    var c, d, e, f, g, h, i;
    $61de1ee1cac498ae$var$Odd(b, "Layer constraint postprocessing", 1);
    i = a.b;
    if (i.c.length != 0) {
        d = ($61de1ee1cac498ae$var$tCb(0, i.c.length), $61de1ee1cac498ae$var$BD(i.c[0], 29));
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(i, i.c.length - 1), 29);
        c = new $61de1ee1cac498ae$var$H1b(a);
        f = new $61de1ee1cac498ae$var$H1b(a);
        $61de1ee1cac498ae$var$Mac(a, d, g, c, f);
        c.a.c.length == 0 || ($61de1ee1cac498ae$var$wCb(0, i.c.length), $61de1ee1cac498ae$var$aCb(i.c, 0, c));
        f.a.c.length == 0 || (i.c[i.c.length] = f);
    }
    if ($61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Lsc))) {
        e = new $61de1ee1cac498ae$var$H1b(a);
        h = new $61de1ee1cac498ae$var$H1b(a);
        $61de1ee1cac498ae$var$Pac(a, e, h);
        e.a.c.length == 0 || ($61de1ee1cac498ae$var$wCb(0, i.c.length), $61de1ee1cac498ae$var$aCb(i.c, 0, e));
        h.a.c.length == 0 || (i.c[i.c.length] = h);
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$b6b(a) {
    var b, c, d, e, f, g, h, i, j, k;
    for(i = new $61de1ee1cac498ae$var$olb(a.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        if (h.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) continue;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
        if (e == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) || e == $61de1ee1cac498ae$var$Tcd) for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
            b = c.a;
            if (b.b == 0) continue;
            j = c.c;
            if (j.i == h) {
                f = ($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$BD(b.a.a.c, 8));
                f.b = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    j.i.n,
                    j.n,
                    j.a
                ])).b;
            }
            k = c.d;
            if (k.i == h) {
                g = ($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$BD(b.c.b.c, 8));
                g.b = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    k.i.n,
                    k.n,
                    k.a
                ])).b;
            }
        }
    }
}
function $61de1ee1cac498ae$var$Tec(a, b) {
    var c, d, e, f, g, h, i;
    $61de1ee1cac498ae$var$Odd(b, "Sort By Input Model " + $61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ywc)), 1);
    e = 0;
    for(d = new $61de1ee1cac498ae$var$olb(a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        i = e == 0 ? 0 : e - 1;
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, i), 29);
        for(g = new $61de1ee1cac498ae$var$olb(c.a); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
            if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$Vxc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$Zbd)) && $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$Vxc)) !== $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$$bd)) {
                $61de1ee1cac498ae$var$mmb();
                $61de1ee1cac498ae$var$Okb(f.j, new $61de1ee1cac498ae$var$Tnc(h, $61de1ee1cac498ae$var$Xec(f)));
                $61de1ee1cac498ae$var$Sdd(b, "Node " + f + " ports: " + f.j);
            }
        }
        $61de1ee1cac498ae$var$mmb();
        $61de1ee1cac498ae$var$Okb(c.a, new $61de1ee1cac498ae$var$Bnc(h, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ywc), 339), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$wwc), 378)));
        $61de1ee1cac498ae$var$Sdd(b, "Layer " + e + ": " + c);
        ++e;
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$U1b(a, b) {
    var c, d, e, f;
    f = $61de1ee1cac498ae$var$P1b(b);
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, (!b.c && (b.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, b, 9, 9)), new $61de1ee1cac498ae$var$Kub(b.c, 16))), new $61de1ee1cac498ae$var$i2b(f));
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21);
    $61de1ee1cac498ae$var$O1b(b, e);
    if (e.Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc))) for(d = new $61de1ee1cac498ae$var$Fyd((!b.c && (b.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, b, 9, 9)), b.c)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 118);
        $61de1ee1cac498ae$var$Y1b(a, b, f, c);
    }
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fxc)), 174).gc() != 0 && $61de1ee1cac498ae$var$L1b(b, f);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$Mxc))) && e.Fc($61de1ee1cac498ae$var$Mrc);
    $61de1ee1cac498ae$var$wNb(f, $61de1ee1cac498ae$var$hyc) && $61de1ee1cac498ae$var$Wyc(new $61de1ee1cac498ae$var$ezc($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$hyc)))), f);
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$axc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd)) ? $61de1ee1cac498ae$var$V1b(a, b, f) : $61de1ee1cac498ae$var$T1b(a, b, f);
    return f;
}
function $61de1ee1cac498ae$var$hic(a, b, c, d) {
    var e, f, g;
    this.j = new $61de1ee1cac498ae$var$Rkb;
    this.k = new $61de1ee1cac498ae$var$Rkb;
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.c = new $61de1ee1cac498ae$var$Rkb;
    this.e = new $61de1ee1cac498ae$var$I6c;
    this.i = new $61de1ee1cac498ae$var$s7c;
    this.f = new $61de1ee1cac498ae$var$lEb;
    this.d = new $61de1ee1cac498ae$var$Rkb;
    this.g = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Ekb(this.b, a);
    $61de1ee1cac498ae$var$Ekb(this.b, b);
    this.e.c = $61de1ee1cac498ae$var$$wnd.Math.min(a.a, b.a);
    this.e.d = $61de1ee1cac498ae$var$$wnd.Math.min(a.b, b.b);
    this.e.b = $61de1ee1cac498ae$var$$wnd.Math.abs(a.a - b.a);
    this.e.a = $61de1ee1cac498ae$var$$wnd.Math.abs(a.b - b.b);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
    if (e) for(g = $61de1ee1cac498ae$var$Jsb(e, 0); g.b != g.d.c;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 8);
        $61de1ee1cac498ae$var$ADb(f.a, a.a) && $61de1ee1cac498ae$var$Dsb(this.i, f);
    }
    !!c && $61de1ee1cac498ae$var$Ekb(this.j, c);
    $61de1ee1cac498ae$var$Ekb(this.k, d);
}
function $61de1ee1cac498ae$var$oTb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    k = new $61de1ee1cac498ae$var$gub(new $61de1ee1cac498ae$var$ETb(c));
    h = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, a.f.e.c.length, 16, 1);
    $61de1ee1cac498ae$var$Glb(h, h.length);
    c[b.b] = 0;
    for(j = new $61de1ee1cac498ae$var$olb(a.f.e); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 144);
        i.b != b.b && (c[i.b] = $61de1ee1cac498ae$var$Ohe);
        $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(k, i));
    }
    while(k.b.c.length != 0){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$dub(k), 144);
        h[l.b] = true;
        for(f = $61de1ee1cac498ae$var$au(new $61de1ee1cac498ae$var$bu(a.b, l), 0); f.c;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$uu(f), 282);
            m = $61de1ee1cac498ae$var$rTb(e, l);
            if (h[m.b]) continue;
            $61de1ee1cac498ae$var$wNb(e, ($61de1ee1cac498ae$var$bTb(), $61de1ee1cac498ae$var$RSb)) ? g = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$RSb))) : g = a.c;
            d = c[l.b] + g;
            if (d < c[m.b]) {
                c[m.b] = d;
                $61de1ee1cac498ae$var$eub(k, m);
                $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(k, m));
            }
        }
    }
}
function $61de1ee1cac498ae$var$xMc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    e = true;
    for(g = new $61de1ee1cac498ae$var$olb(a.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        j = $61de1ee1cac498ae$var$Qje;
        k = null;
        for(i = new $61de1ee1cac498ae$var$olb(f.a); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            l = $61de1ee1cac498ae$var$Edb(b.p[h.p]) + $61de1ee1cac498ae$var$Edb(b.d[h.p]) - h.d.d;
            d = $61de1ee1cac498ae$var$Edb(b.p[h.p]) + $61de1ee1cac498ae$var$Edb(b.d[h.p]) + h.o.b + h.d.a;
            if (l > j && d > j) {
                k = h;
                j = $61de1ee1cac498ae$var$Edb(b.p[h.p]) + $61de1ee1cac498ae$var$Edb(b.d[h.p]) + h.o.b + h.d.a;
            } else {
                e = false;
                c.n && $61de1ee1cac498ae$var$Sdd(c, "bk node placement breaks on " + h + " which should have been after " + k);
                break;
            }
        }
        if (!e) break;
    }
    c.n && $61de1ee1cac498ae$var$Sdd(c, b + " is feasible: " + e);
    return e;
}
function $61de1ee1cac498ae$var$XNc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    h = -1;
    for(k = new $61de1ee1cac498ae$var$olb(a); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 112);
        j.g = h--;
        e = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$tAb($61de1ee1cac498ae$var$PAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(j.f, 16)), new $61de1ee1cac498ae$var$ZNc), new $61de1ee1cac498ae$var$_Nc)).d);
        f = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$tAb($61de1ee1cac498ae$var$PAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(j.k, 16)), new $61de1ee1cac498ae$var$bOc), new $61de1ee1cac498ae$var$dOc)).d);
        g = e;
        i = f;
        if (!d) {
            g = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$tAb($61de1ee1cac498ae$var$PAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(j.f, 16)), new $61de1ee1cac498ae$var$fOc)).d);
            i = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$tAb($61de1ee1cac498ae$var$PAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(j.k, 16)), new $61de1ee1cac498ae$var$hOc)).d);
        }
        j.d = g;
        j.a = e;
        j.i = i;
        j.b = f;
        i == 0 ? $61de1ee1cac498ae$var$Gsb(c, j, c.c.b, c.c) : g == 0 && $61de1ee1cac498ae$var$Gsb(b, j, b.c.b, b.c);
    }
}
function $61de1ee1cac498ae$var$$8b(a, b, c, d) {
    var e, f, g, h, i, j, k;
    if (c.d.i == b.i) return;
    e = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$__b(e, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b));
    $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), c);
    $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
    d.c[d.c.length] = e;
    g = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(g, e);
    $61de1ee1cac498ae$var$G0b(g, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    h = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(h, e);
    $61de1ee1cac498ae$var$G0b(h, $61de1ee1cac498ae$var$zcd);
    k = c.d;
    $61de1ee1cac498ae$var$RZb(c, g);
    f = new $61de1ee1cac498ae$var$UZb;
    $61de1ee1cac498ae$var$tNb(f, c);
    $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$jxc, null);
    $61de1ee1cac498ae$var$QZb(f, h);
    $61de1ee1cac498ae$var$RZb(f, k);
    j = new $61de1ee1cac498ae$var$Bib(c.b, 0);
    while(j.b < j.d.gc()){
        i = ($61de1ee1cac498ae$var$sCb(j.b < j.d.gc()), $61de1ee1cac498ae$var$BD(j.d.Xb(j.c = j.b++), 70));
        if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$Qwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$oad))) {
            $61de1ee1cac498ae$var$yNb(i, $61de1ee1cac498ae$var$Dsc, c);
            $61de1ee1cac498ae$var$uib(j);
            $61de1ee1cac498ae$var$Ekb(f.b, i);
        }
    }
    $61de1ee1cac498ae$var$a9b(e, g, h);
}
function $61de1ee1cac498ae$var$Z8b(a, b, c, d) {
    var e, f, g, h, i, j, k;
    if (c.c.i == b.i) return;
    e = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$__b(e, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b));
    $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), c);
    $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
    d.c[d.c.length] = e;
    g = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(g, e);
    $61de1ee1cac498ae$var$G0b(g, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    h = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(h, e);
    $61de1ee1cac498ae$var$G0b(h, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$RZb(c, g);
    f = new $61de1ee1cac498ae$var$UZb;
    $61de1ee1cac498ae$var$tNb(f, c);
    $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$jxc, null);
    $61de1ee1cac498ae$var$QZb(f, h);
    $61de1ee1cac498ae$var$RZb(f, b);
    $61de1ee1cac498ae$var$a9b(e, g, h);
    j = new $61de1ee1cac498ae$var$Bib(c.b, 0);
    while(j.b < j.d.gc()){
        i = ($61de1ee1cac498ae$var$sCb(j.b < j.d.gc()), $61de1ee1cac498ae$var$BD(j.d.Xb(j.c = j.b++), 70));
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$Qwc), 272);
        if (k == ($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$oad)) {
            $61de1ee1cac498ae$var$wNb(i, $61de1ee1cac498ae$var$Dsc) || $61de1ee1cac498ae$var$yNb(i, $61de1ee1cac498ae$var$Dsc, c);
            $61de1ee1cac498ae$var$uib(j);
            $61de1ee1cac498ae$var$Ekb(f.b, i);
        }
    }
}
function $61de1ee1cac498ae$var$dDc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    m = new $61de1ee1cac498ae$var$Rkb;
    r = $61de1ee1cac498ae$var$Gx(d);
    q = b * a.a;
    l = 0;
    o = 0;
    f = new $61de1ee1cac498ae$var$Tqb;
    g = new $61de1ee1cac498ae$var$Tqb;
    h = new $61de1ee1cac498ae$var$Rkb;
    s = 0;
    t = 0;
    n = 0;
    p = 0;
    j = 0;
    k = 0;
    while(r.a.gc() != 0){
        i = $61de1ee1cac498ae$var$hDc(r, e, g);
        if (i) {
            r.a.Bc(i);
            h.c[h.c.length] = i;
            f.a.zc(i, f);
            o = a.f[i.p];
            s += a.e[i.p] - o * a.b;
            l = a.c[i.p];
            t += l * a.b;
            k += o * a.b;
            p += a.e[i.p];
        }
        if (!i || r.a.gc() == 0 || s >= q && a.e[i.p] > o * a.b || t >= c * q) {
            m.c[m.c.length] = h;
            h = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$ye(g, f);
            f.a.$b();
            j -= k;
            n = $61de1ee1cac498ae$var$$wnd.Math.max(n, j * a.b + p);
            j += t;
            s = t;
            t = 0;
            k = 0;
            p = 0;
        }
    }
    return new $61de1ee1cac498ae$var$vgd(n, m);
}
function $61de1ee1cac498ae$var$q4c(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    for(c = (j = new $61de1ee1cac498ae$var$$ib(a.c.b).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(j)); c.a.Ob();){
        b = (h = $61de1ee1cac498ae$var$BD(c.a.Pb(), 42), $61de1ee1cac498ae$var$BD(h.dd(), 149));
        e = b.a;
        e == null && (e = "");
        d = $61de1ee1cac498ae$var$i4c(a.c, e);
        !d && e.length == 0 && (d = $61de1ee1cac498ae$var$u4c(a));
        !!d && !$61de1ee1cac498ae$var$ze(d.c, b, false) && $61de1ee1cac498ae$var$Dsb(d.c, b);
    }
    for(g = $61de1ee1cac498ae$var$Jsb(a.a, 0); g.b != g.d.c;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(g), 478);
        k = $61de1ee1cac498ae$var$j4c(a.c, f.a);
        n = $61de1ee1cac498ae$var$j4c(a.c, f.b);
        !!k && !!n && $61de1ee1cac498ae$var$Dsb(k.c, new $61de1ee1cac498ae$var$vgd(n, f.c));
    }
    $61de1ee1cac498ae$var$Osb(a.a);
    for(m = $61de1ee1cac498ae$var$Jsb(a.b, 0); m.b != m.d.c;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(m), 478);
        b = $61de1ee1cac498ae$var$g4c(a.c, l.a);
        i = $61de1ee1cac498ae$var$j4c(a.c, l.b);
        !!b && !!i && $61de1ee1cac498ae$var$B3c(b, i, l.c);
    }
    $61de1ee1cac498ae$var$Osb(a.b);
}
function $61de1ee1cac498ae$var$qvd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    f = new $61de1ee1cac498ae$var$fC(a);
    g = new $61de1ee1cac498ae$var$ird;
    e = ($61de1ee1cac498ae$var$ko(g.g), $61de1ee1cac498ae$var$ko(g.j), $61de1ee1cac498ae$var$Uhb(g.b), $61de1ee1cac498ae$var$ko(g.d), $61de1ee1cac498ae$var$ko(g.i), $61de1ee1cac498ae$var$Uhb(g.k), $61de1ee1cac498ae$var$Uhb(g.c), $61de1ee1cac498ae$var$Uhb(g.e), n = $61de1ee1cac498ae$var$drd(g, f, null), $61de1ee1cac498ae$var$ard(g, f), n);
    if (b) {
        j = new $61de1ee1cac498ae$var$fC(b);
        h = $61de1ee1cac498ae$var$rvd(j);
        $61de1ee1cac498ae$var$jfd(e, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$g2, 1), $61de1ee1cac498ae$var$Uhe, 527, 0, [
            h
        ]));
    }
    m = false;
    l = false;
    if (c) {
        j = new $61de1ee1cac498ae$var$fC(c);
        $61de1ee1cac498ae$var$que in j.a && (m = $61de1ee1cac498ae$var$aC(j, $61de1ee1cac498ae$var$que).ge().a);
        $61de1ee1cac498ae$var$rue in j.a && (l = $61de1ee1cac498ae$var$aC(j, $61de1ee1cac498ae$var$rue).ge().a);
    }
    k = $61de1ee1cac498ae$var$Vdd($61de1ee1cac498ae$var$Xdd(new $61de1ee1cac498ae$var$Zdd, m), l);
    $61de1ee1cac498ae$var$t2c(new $61de1ee1cac498ae$var$w2c, e, k);
    $61de1ee1cac498ae$var$que in f.a && $61de1ee1cac498ae$var$cC(f, $61de1ee1cac498ae$var$que, null);
    if (m || l) {
        i = new $61de1ee1cac498ae$var$eC;
        $61de1ee1cac498ae$var$nvd(k, i, m, l);
        $61de1ee1cac498ae$var$cC(f, $61de1ee1cac498ae$var$que, i);
    }
    d = new $61de1ee1cac498ae$var$Prd(g);
    $61de1ee1cac498ae$var$Ghe(new $61de1ee1cac498ae$var$_ud(e), d);
}
function $61de1ee1cac498ae$var$pA(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    g = new $61de1ee1cac498ae$var$nB;
    j = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        0
    ]);
    e = -1;
    f = 0;
    d = 0;
    for(i = 0; i < a.b.c.length; ++i){
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, i), 434);
        if (k.b > 0) {
            if (e < 0 && k.a) {
                e = i;
                f = j[0];
                d = 0;
            }
            if (e >= 0) {
                h = k.b;
                if (i == e) {
                    h -= d++;
                    if (h == 0) return 0;
                }
                if (!$61de1ee1cac498ae$var$wA(b, j, k, h, g)) {
                    i = e - 1;
                    j[0] = f;
                    continue;
                }
            } else {
                e = -1;
                if (!$61de1ee1cac498ae$var$wA(b, j, k, 0, g)) return 0;
            }
        } else {
            e = -1;
            if ($61de1ee1cac498ae$var$bfb(k.c, 0) == 32) {
                l = j[0];
                $61de1ee1cac498ae$var$uA(b, j);
                if (j[0] > l) continue;
            } else if ($61de1ee1cac498ae$var$ofb(b, k.c, j[0])) {
                j[0] += k.c.length;
                continue;
            }
            return 0;
        }
    }
    if (!$61de1ee1cac498ae$var$mB(g, c)) return 0;
    return j[0];
}
function $61de1ee1cac498ae$var$SKd(a) {
    var b, c, d, e, f, g, h, i;
    if (!a.f) {
        i = new $61de1ee1cac498ae$var$CNd;
        h = new $61de1ee1cac498ae$var$CNd;
        b = $61de1ee1cac498ae$var$KKd;
        g = b.a.zc(a, b);
        if (g == null) {
            for(f = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$_Kd(a)); f.e != f.i.gc();){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(f), 26);
                $61de1ee1cac498ae$var$ytd(i, $61de1ee1cac498ae$var$SKd(e));
            }
            b.a.Bc(a);
            b.a.gc() == 0 && undefined;
        }
        for(d = (!a.s && (a.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, a, 21, 17)), new $61de1ee1cac498ae$var$Fyd(a.s)); d.e != d.i.gc();){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 170);
            $61de1ee1cac498ae$var$JD(c, 99) && $61de1ee1cac498ae$var$wtd(h, $61de1ee1cac498ae$var$BD(c, 18));
        }
        $61de1ee1cac498ae$var$vud(h);
        a.r = new $61de1ee1cac498ae$var$UNd(a, ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).o), 6), 18), h.i), h.g);
        $61de1ee1cac498ae$var$ytd(i, a.r);
        $61de1ee1cac498ae$var$vud(i);
        a.f = new $61de1ee1cac498ae$var$nNd(($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 5), 18), i.i), i.g);
        $61de1ee1cac498ae$var$$Kd(a).b &= -3;
    }
    return a.f;
}
function $61de1ee1cac498ae$var$rMb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
    g = a.o;
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, g, 15, 1);
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, g, 15, 1);
    c = a.p;
    b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, c, 15, 1);
    f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, c, 15, 1);
    for(j = 0; j < g; j++){
        l = 0;
        while(l < c && !$61de1ee1cac498ae$var$YMb(a, j, l))++l;
        d[j] = l;
    }
    for(k = 0; k < g; k++){
        l = c - 1;
        while(l >= 0 && !$61de1ee1cac498ae$var$YMb(a, k, l))--l;
        e[k] = l;
    }
    for(n = 0; n < c; n++){
        h = 0;
        while(h < g && !$61de1ee1cac498ae$var$YMb(a, h, n))++h;
        b[n] = h;
    }
    for(o = 0; o < c; o++){
        h = g - 1;
        while(h >= 0 && !$61de1ee1cac498ae$var$YMb(a, h, o))--h;
        f[o] = h;
    }
    for(i = 0; i < g; i++)for(m = 0; m < c; m++)i < f[m] && i > b[m] && m < e[i] && m > d[i] && $61de1ee1cac498ae$var$aNb(a, i, m, false, true);
}
function $61de1ee1cac498ae$var$lRb(a) {
    var b, c, d, e, f, g, h, i;
    c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$cSb))));
    f = a.a.c.d;
    h = a.a.d.d;
    if (c) {
        g = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(h.a, h.b), f), 0.5);
        i = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$R6c(a.e), 0.5);
        b = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$f7c(f.a, f.b), g), i);
        $61de1ee1cac498ae$var$a7c(a.d, b);
    } else {
        e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.a, $61de1ee1cac498ae$var$tSb)));
        d = a.d;
        if (f.a >= h.a) {
            if (f.b >= h.b) {
                d.a = h.a + (f.a - h.a) / 2 + e;
                d.b = h.b + (f.b - h.b) / 2 - e - a.e.b;
            } else {
                d.a = h.a + (f.a - h.a) / 2 + e;
                d.b = f.b + (h.b - f.b) / 2 + e;
            }
        } else if (f.b >= h.b) {
            d.a = f.a + (h.a - f.a) / 2 + e;
            d.b = h.b + (f.b - h.b) / 2 + e;
        } else {
            d.a = f.a + (h.a - f.a) / 2 + e;
            d.b = f.b + (h.b - f.b) / 2 - e - a.e.b;
        }
    }
}
function $61de1ee1cac498ae$var$Qge(a, b) {
    var c, d, e, f, g, h, i;
    if (a == null) return null;
    f = a.length;
    if (f == 0) return "";
    i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, f, 15, 1);
    $61de1ee1cac498ae$var$ACb(0, f, a.length);
    $61de1ee1cac498ae$var$ACb(0, f, i.length);
    $61de1ee1cac498ae$var$ffb(a, 0, f, i, 0);
    c = null;
    h = b;
    for(e = 0, g = 0; e < f; e++){
        d = i[e];
        $61de1ee1cac498ae$var$lde();
        if (d <= 32 && ($61de1ee1cac498ae$var$kde[d] & 2) != 0) {
            if (h) {
                !c && (c = new $61de1ee1cac498ae$var$Jfb(a));
                $61de1ee1cac498ae$var$Gfb(c, e - g++);
            } else {
                h = b;
                if (d != 32) {
                    !c && (c = new $61de1ee1cac498ae$var$Jfb(a));
                    $61de1ee1cac498ae$var$kcb(c, e - g, e - g + 1, String.fromCharCode(32));
                }
            }
        } else h = false;
    }
    if (h) {
        if (!c) return a.substr(0, f - 1);
        else {
            f = c.a.length;
            return f > 0 ? $61de1ee1cac498ae$var$qfb(c.a, 0, f - 1) : "";
        }
    } else return !c ? a : c.a;
}
function $61de1ee1cac498ae$var$DPb(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$Yle), "ELK DisCo"), "Layouter for arranging unconnected subgraphs. The subgraphs themselves are, by default, not laid out."), new $61de1ee1cac498ae$var$GPb)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$Zle, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$BPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$$le, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$vPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$_le, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$qPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$wPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$Zke, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$zPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$$ke, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$yPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$Yke, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$APb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$_ke, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$xPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$Tle, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$sPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$Ule, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$rPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$Vle, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$tPb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Yle, $61de1ee1cac498ae$var$Wle, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$uPb));
}
function $61de1ee1cac498ae$var$Zbc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    f = new $61de1ee1cac498ae$var$b0b(a);
    $61de1ee1cac498ae$var$__b(f, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b));
    $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
    e = 0;
    if (b) {
        g = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$yNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), b);
        $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$$sc, b.i);
        $61de1ee1cac498ae$var$G0b(g, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
        $61de1ee1cac498ae$var$F0b(g, f);
        m = $61de1ee1cac498ae$var$k_b(b.e);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            $61de1ee1cac498ae$var$RZb(i, g);
        }
        $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$gtc, f);
        ++e;
    }
    if (c) {
        h = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), c.i);
        $61de1ee1cac498ae$var$yNb(h, $61de1ee1cac498ae$var$$sc, c);
        $61de1ee1cac498ae$var$G0b(h, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
        $61de1ee1cac498ae$var$F0b(h, f);
        m = $61de1ee1cac498ae$var$k_b(c.g);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            $61de1ee1cac498ae$var$QZb(i, h);
        }
        $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$gtc, f);
        ++e;
    }
    $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ysc), $61de1ee1cac498ae$var$meb(e));
    d.c[d.c.length] = f;
    return f;
}
function $61de1ee1cac498ae$var$Smd() {
    $61de1ee1cac498ae$var$Smd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Qmd = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$TD, 1), $61de1ee1cac498ae$var$$ie, 25, 15, [
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        65,
        66,
        67,
        68,
        69,
        70
    ]);
    $61de1ee1cac498ae$var$Rmd = new RegExp("[ 	\n\r\f]+");
    try {
        $61de1ee1cac498ae$var$Pmd = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$c6, 1), $61de1ee1cac498ae$var$Uhe, 2015, 0, [
            new $61de1ee1cac498ae$var$EQd(($61de1ee1cac498ae$var$GA(), $61de1ee1cac498ae$var$IA("yyyy-MM-dd'T'HH:mm:ss'.'SSSZ", $61de1ee1cac498ae$var$LA(($61de1ee1cac498ae$var$KA(), $61de1ee1cac498ae$var$KA(), $61de1ee1cac498ae$var$JA))))),
            new $61de1ee1cac498ae$var$EQd($61de1ee1cac498ae$var$IA("yyyy-MM-dd'T'HH:mm:ss'.'SSS", $61de1ee1cac498ae$var$LA($61de1ee1cac498ae$var$JA))),
            new $61de1ee1cac498ae$var$EQd($61de1ee1cac498ae$var$IA("yyyy-MM-dd'T'HH:mm:ss", $61de1ee1cac498ae$var$LA($61de1ee1cac498ae$var$JA))),
            new $61de1ee1cac498ae$var$EQd($61de1ee1cac498ae$var$IA("yyyy-MM-dd'T'HH:mm", $61de1ee1cac498ae$var$LA($61de1ee1cac498ae$var$JA))),
            new $61de1ee1cac498ae$var$EQd($61de1ee1cac498ae$var$IA("yyyy-MM-dd", $61de1ee1cac498ae$var$LA($61de1ee1cac498ae$var$JA)))
        ]);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if (!$61de1ee1cac498ae$var$JD(a, 78)) throw $61de1ee1cac498ae$var$vbb(a);
    }
}
function $61de1ee1cac498ae$var$qgb(a) {
    var b, c, d, e;
    d = $61de1ee1cac498ae$var$shb((!a.c && (a.c = $61de1ee1cac498ae$var$fhb(a.f)), a.c), 0);
    if (a.e == 0 || a.a == 0 && a.f != -1 && a.e < 0) return d;
    b = $61de1ee1cac498ae$var$pgb(a) < 0 ? 1 : 0;
    c = a.e;
    e = (d.length, $61de1ee1cac498ae$var$$wnd.Math.abs($61de1ee1cac498ae$var$QD(a.e)), new $61de1ee1cac498ae$var$Vfb);
    b == 1 && (e.a += "-", e);
    if (a.e > 0) {
        c -= d.length - b;
        if (c >= 0) {
            e.a += "0.";
            for(; c > $61de1ee1cac498ae$var$egb.length; c -= $61de1ee1cac498ae$var$egb.length)$61de1ee1cac498ae$var$Rfb(e, $61de1ee1cac498ae$var$egb);
            $61de1ee1cac498ae$var$Sfb(e, $61de1ee1cac498ae$var$egb, $61de1ee1cac498ae$var$QD(c));
            $61de1ee1cac498ae$var$Qfb(e, d.substr(b));
        } else {
            c = b - c;
            $61de1ee1cac498ae$var$Qfb(e, $61de1ee1cac498ae$var$qfb(d, b, $61de1ee1cac498ae$var$QD(c)));
            e.a += ".";
            $61de1ee1cac498ae$var$Qfb(e, $61de1ee1cac498ae$var$pfb(d, $61de1ee1cac498ae$var$QD(c)));
        }
    } else {
        $61de1ee1cac498ae$var$Qfb(e, d.substr(b));
        for(; c < -$61de1ee1cac498ae$var$egb.length; c += $61de1ee1cac498ae$var$egb.length)$61de1ee1cac498ae$var$Rfb(e, $61de1ee1cac498ae$var$egb);
        $61de1ee1cac498ae$var$Sfb(e, $61de1ee1cac498ae$var$egb, $61de1ee1cac498ae$var$QD(-c));
    }
    return e.a;
}
function $61de1ee1cac498ae$var$v6c(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    i = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(c.a, c.b), a);
    j = i.a * b.b - i.b * b.a;
    k = b.a * d.b - b.b * d.a;
    l = (i.a * d.b - i.b * d.a) / k;
    m = j / k;
    if (k == 0) {
        if (j == 0) {
            e = $61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$f7c(c.a, c.b), $61de1ee1cac498ae$var$Y6c(new $61de1ee1cac498ae$var$f7c(d.a, d.b), 0.5));
            f = $61de1ee1cac498ae$var$S6c(a, e);
            g = $61de1ee1cac498ae$var$S6c($61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$f7c(a.a, a.b), b), e);
            h = $61de1ee1cac498ae$var$$wnd.Math.sqrt(d.a * d.a + d.b * d.b) * 0.5;
            if (f < g && f <= h) return new $61de1ee1cac498ae$var$f7c(a.a, a.b);
            if (g <= h) return $61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$f7c(a.a, a.b), b);
            return null;
        } else return null;
    } else return l >= 0 && l <= 1 && m >= 0 && m <= 1 ? $61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$f7c(a.a, a.b), $61de1ee1cac498ae$var$Y6c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), l)) : null;
}
function $61de1ee1cac498ae$var$OTb(a, b, c) {
    var d, e, f, g, h;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$zwc)), 21);
    c.a > b.a && (d.Hc(($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$c8c)) ? a.c.a += (c.a - b.a) / 2 : d.Hc($61de1ee1cac498ae$var$e8c) && (a.c.a += c.a - b.a));
    c.b > b.b && (d.Hc(($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$g8c)) ? a.c.b += (c.b - b.b) / 2 : d.Hc($61de1ee1cac498ae$var$f8c) && (a.c.b += c.b - b.b));
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc)) && (c.a > b.a || c.b > b.b)) for(h = new $61de1ee1cac498ae$var$olb(a.a); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
        if (g.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$Hsc), 61);
            e == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) ? g.n.a += c.a - b.a : e == $61de1ee1cac498ae$var$Rcd && (g.n.b += c.b - b.b);
        }
    }
    f = a.d;
    a.f.a = c.a - f.b - f.c;
    a.f.b = c.b - f.d - f.a;
}
function $61de1ee1cac498ae$var$H5b(a, b, c) {
    var d, e, f, g, h;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$zwc)), 21);
    c.a > b.a && (d.Hc(($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$c8c)) ? a.c.a += (c.a - b.a) / 2 : d.Hc($61de1ee1cac498ae$var$e8c) && (a.c.a += c.a - b.a));
    c.b > b.b && (d.Hc(($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$g8c)) ? a.c.b += (c.b - b.b) / 2 : d.Hc($61de1ee1cac498ae$var$f8c) && (a.c.b += c.b - b.b));
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc)) && (c.a > b.a || c.b > b.b)) for(g = new $61de1ee1cac498ae$var$olb(a.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        if (f.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$Hsc), 61);
            e == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) ? f.n.a += c.a - b.a : e == $61de1ee1cac498ae$var$Rcd && (f.n.b += c.b - b.b);
        }
    }
    h = a.d;
    a.f.a = c.a - h.b - h.c;
    a.f.b = c.b - h.d - h.a;
}
function $61de1ee1cac498ae$var$kMc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    b = $61de1ee1cac498ae$var$DMc(a);
    for(k = (h = new $61de1ee1cac498ae$var$Pib(b).a.vc().Kc(), new $61de1ee1cac498ae$var$Vib(h)); k.a.Ob();){
        j = (e = $61de1ee1cac498ae$var$BD(k.a.Pb(), 42), $61de1ee1cac498ae$var$BD(e.cd(), 10));
        l = 0;
        m = 0;
        l = j.d.d;
        m = j.o.b + j.d.a;
        a.d[j.p] = 0;
        c = j;
        while((f = a.a[c.p]) != j){
            d = $61de1ee1cac498ae$var$FMc(c, f);
            i = 0;
            a.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc) ? i = d.d.n.b + d.d.a.b - d.c.n.b - d.c.a.b : i = d.c.n.b + d.c.a.b - d.d.n.b - d.d.a.b;
            g = $61de1ee1cac498ae$var$Edb(a.d[c.p]) + i;
            a.d[f.p] = g;
            l = $61de1ee1cac498ae$var$$wnd.Math.max(l, f.d.d - g);
            m = $61de1ee1cac498ae$var$$wnd.Math.max(m, g + f.o.b + f.d.a);
            c = f;
        }
        c = j;
        do {
            a.d[c.p] = $61de1ee1cac498ae$var$Edb(a.d[c.p]) + l;
            c = a.a[c.p];
        }while (c != j);
        a.b[j.p] = l + m;
    }
}
function $61de1ee1cac498ae$var$LOb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    a.b = false;
    l = $61de1ee1cac498ae$var$Pje;
    i = $61de1ee1cac498ae$var$Qje;
    m = $61de1ee1cac498ae$var$Pje;
    j = $61de1ee1cac498ae$var$Qje;
    for(d = a.e.a.ec().Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 266);
        e = c.a;
        l = $61de1ee1cac498ae$var$$wnd.Math.min(l, e.c);
        i = $61de1ee1cac498ae$var$$wnd.Math.max(i, e.c + e.b);
        m = $61de1ee1cac498ae$var$$wnd.Math.min(m, e.d);
        j = $61de1ee1cac498ae$var$$wnd.Math.max(j, e.d + e.a);
        for(g = new $61de1ee1cac498ae$var$olb(c.c); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 395);
            b = f.a;
            if (b.a) {
                k = e.d + f.b.b;
                h = k + f.c;
                m = $61de1ee1cac498ae$var$$wnd.Math.min(m, k);
                j = $61de1ee1cac498ae$var$$wnd.Math.max(j, h);
            } else {
                k = e.c + f.b.a;
                h = k + f.c;
                l = $61de1ee1cac498ae$var$$wnd.Math.min(l, k);
                i = $61de1ee1cac498ae$var$$wnd.Math.max(i, h);
            }
        }
    }
    a.a = new $61de1ee1cac498ae$var$f7c(i - l, j - m);
    a.c = new $61de1ee1cac498ae$var$f7c(l + a.d.a, m + a.d.b);
}
function $61de1ee1cac498ae$var$xZc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    l = new $61de1ee1cac498ae$var$Rkb;
    k = new $61de1ee1cac498ae$var$x$c(0, c);
    f = 0;
    $61de1ee1cac498ae$var$s$c(k, new $61de1ee1cac498ae$var$PZc(0, 0, k, c));
    e = 0;
    for(j = new $61de1ee1cac498ae$var$Fyd(a); j.e != j.i.gc();){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(j), 33);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k.a, k.a.c.length - 1), 187);
        h = e + i.g + ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k.a, 0), 187).b.c.length == 0 ? 0 : c);
        if (h > b) {
            e = 0;
            f += k.b + c;
            l.c[l.c.length] = k;
            k = new $61de1ee1cac498ae$var$x$c(f, c);
            d = new $61de1ee1cac498ae$var$PZc(0, k.f, k, c);
            $61de1ee1cac498ae$var$s$c(k, d);
            e = 0;
        }
        if (d.b.c.length == 0 || i.f >= d.o && i.f <= d.f || d.a * 0.5 <= i.f && d.a * 1.5 >= i.f) $61de1ee1cac498ae$var$EZc(d, i);
        else {
            g = new $61de1ee1cac498ae$var$PZc(d.s + d.r + c, k.f, k, c);
            $61de1ee1cac498ae$var$s$c(k, g);
            $61de1ee1cac498ae$var$EZc(g, i);
        }
        e = i.i + i.g;
    }
    l.c[l.c.length] = k;
    return l;
}
function $61de1ee1cac498ae$var$OKd(a) {
    var b, c, d, e, f, g, h, i;
    if (!a.a) {
        a.o = null;
        i = new $61de1ee1cac498ae$var$GNd(a);
        b = new $61de1ee1cac498ae$var$KNd;
        c = $61de1ee1cac498ae$var$KKd;
        h = c.a.zc(a, c);
        if (h == null) {
            for(g = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$_Kd(a)); g.e != g.i.gc();){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(g), 26);
                $61de1ee1cac498ae$var$ytd(i, $61de1ee1cac498ae$var$OKd(f));
            }
            c.a.Bc(a);
            c.a.gc() == 0 && undefined;
        }
        for(e = (!a.s && (a.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, a, 21, 17)), new $61de1ee1cac498ae$var$Fyd(a.s)); e.e != e.i.gc();){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 170);
            $61de1ee1cac498ae$var$JD(d, 322) && $61de1ee1cac498ae$var$wtd(b, $61de1ee1cac498ae$var$BD(d, 34));
        }
        $61de1ee1cac498ae$var$vud(b);
        a.k = new $61de1ee1cac498ae$var$PNd(a, ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).o), 7), 18), b.i), b.g);
        $61de1ee1cac498ae$var$ytd(i, a.k);
        $61de1ee1cac498ae$var$vud(i);
        a.a = new $61de1ee1cac498ae$var$nNd(($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 4), 18), i.i), i.g);
        $61de1ee1cac498ae$var$$Kd(a).b &= -2;
    }
    return a.a;
}
function $61de1ee1cac498ae$var$vZc(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m;
    l = false;
    i = $61de1ee1cac498ae$var$ZZc(c.q, b.f + b.b - c.q.f);
    m = e - (c.q.e + i - g);
    if (m < d.g) return false;
    j = f == a.c.length - 1 && m >= ($61de1ee1cac498ae$var$tCb(f, a.c.length), $61de1ee1cac498ae$var$BD(a.c[f], 200)).e;
    k = (h = $61de1ee1cac498ae$var$MZc(d, m, false), h.a);
    if (k > b.b && !j) return false;
    if (j || k <= b.b) {
        if (j && k > b.b) {
            c.d = k;
            $61de1ee1cac498ae$var$KZc(c, $61de1ee1cac498ae$var$JZc(c, k));
        } else {
            $61de1ee1cac498ae$var$$Zc(c.q, i);
            c.c = true;
        }
        $61de1ee1cac498ae$var$KZc(d, e - (c.s + c.r));
        $61de1ee1cac498ae$var$OZc(d, c.q.e + c.q.d, b.f);
        $61de1ee1cac498ae$var$s$c(b, d);
        if (a.c.length > f) {
            $61de1ee1cac498ae$var$v$c(($61de1ee1cac498ae$var$tCb(f, a.c.length), $61de1ee1cac498ae$var$BD(a.c[f], 200)), d);
            ($61de1ee1cac498ae$var$tCb(f, a.c.length), $61de1ee1cac498ae$var$BD(a.c[f], 200)).a.c.length == 0 && $61de1ee1cac498ae$var$Kkb(a, f);
        }
        l = true;
    }
    return l;
}
function $61de1ee1cac498ae$var$C2d(a, b, c, d) {
    var e, f, g, h, i, j, k;
    k = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    e = 0;
    f = $61de1ee1cac498ae$var$BD(a.g, 119);
    i = null;
    $61de1ee1cac498ae$var$Q6d();
    if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) for(h = 0; h < a.i; ++h){
        g = f[h];
        if (k.rl(g.ak())) {
            if ($61de1ee1cac498ae$var$pb(g, c)) {
                i = g;
                break;
            }
            ++e;
        }
    }
    else if (c != null) for(h = 0; h < a.i; ++h){
        g = f[h];
        if (k.rl(g.ak())) {
            if ($61de1ee1cac498ae$var$pb(c, g.dd())) {
                i = g;
                break;
            }
            ++e;
        }
    }
    else for(h = 0; h < a.i; ++h){
        g = f[h];
        if (k.rl(g.ak())) {
            if (g.dd() == null) {
                i = g;
                break;
            }
            ++e;
        }
    }
    if (i) {
        if ($61de1ee1cac498ae$var$oid(a.e)) {
            j = b.$j() ? new $61de1ee1cac498ae$var$O7d(a.e, 4, b, c, null, e, true) : $61de1ee1cac498ae$var$H2d(a, b.Kj() ? 2 : 1, b, c, b.zj(), -1, true);
            d ? d.Ei(j) : d = j;
        }
        d = $61de1ee1cac498ae$var$B2d(a, i, d);
    }
    return d;
}
function $61de1ee1cac498ae$var$kYc(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p;
    o = 0;
    p = 0;
    i = e.c;
    h = e.b;
    k = c.f;
    n = c.g;
    switch(b.g){
        case 0:
            o = d.i + d.g + g;
            a.c ? p = $61de1ee1cac498ae$var$tYc(o, f, d, g) : p = d.j;
            m = $61de1ee1cac498ae$var$$wnd.Math.max(i, o + n);
            j = $61de1ee1cac498ae$var$$wnd.Math.max(h, p + k);
            break;
        case 1:
            p = d.j + d.f + g;
            a.c ? o = $61de1ee1cac498ae$var$sYc(p, f, d, g) : o = d.i;
            m = $61de1ee1cac498ae$var$$wnd.Math.max(i, o + n);
            j = $61de1ee1cac498ae$var$$wnd.Math.max(h, p + k);
            break;
        case 2:
            o = i + g;
            p = 0;
            m = i + g + n;
            j = $61de1ee1cac498ae$var$$wnd.Math.max(h, k);
            break;
        case 3:
            o = 0;
            p = h + g;
            m = $61de1ee1cac498ae$var$$wnd.Math.max(i, n);
            j = h + g + k;
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("IllegalPlacementOption."));
    }
    l = new $61de1ee1cac498ae$var$e$c(a.a, m, j, b, o, p);
    return l;
}
function $61de1ee1cac498ae$var$R2b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    h = a.d;
    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vtc)), 15);
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$tsc), 15);
    if (!l && !b) return;
    f = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$iyc))));
    g = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(a, $61de1ee1cac498ae$var$jyc)));
    m = 0;
    if (l) {
        j = 0;
        for(e = l.Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 10);
            j = $61de1ee1cac498ae$var$$wnd.Math.max(j, d.o.b);
            m += d.o.a;
        }
        m += f * (l.gc() - 1);
        h.d += j + g;
    }
    c = 0;
    if (b) {
        j = 0;
        for(e = b.Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 10);
            j = $61de1ee1cac498ae$var$$wnd.Math.max(j, d.o.b);
            c += d.o.a;
        }
        c += f * (b.gc() - 1);
        h.a += j + g;
    }
    i = $61de1ee1cac498ae$var$$wnd.Math.max(m, c);
    if (i > a.o.a) {
        k = (i - a.o.a) / 2;
        h.b = $61de1ee1cac498ae$var$$wnd.Math.max(h.b, k);
        h.c = $61de1ee1cac498ae$var$$wnd.Math.max(h.c, k);
    }
}
function $61de1ee1cac498ae$var$rvd(a) {
    var b, c, d, e, f, g, h, i;
    f = new $61de1ee1cac498ae$var$b2c;
    $61de1ee1cac498ae$var$Z1c(f, ($61de1ee1cac498ae$var$Y1c(), $61de1ee1cac498ae$var$V1c));
    for(d = (e = $61de1ee1cac498ae$var$$B(a, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, 0, 6, 1)), new $61de1ee1cac498ae$var$vib(new $61de1ee1cac498ae$var$amb(new $61de1ee1cac498ae$var$mC(a, e).b))); d.b < d.d.gc();){
        c = ($61de1ee1cac498ae$var$sCb(d.b < d.d.gc()), $61de1ee1cac498ae$var$GD(d.d.Xb(d.c = d.b++)));
        g = $61de1ee1cac498ae$var$k4c($61de1ee1cac498ae$var$lvd, c);
        if (g) {
            b = $61de1ee1cac498ae$var$aC(a, c);
            b.je() ? h = b.je().a : b.ge() ? h = "" + b.ge().a : b.he() ? h = "" + b.he().a : h = b.Ib();
            i = $61de1ee1cac498ae$var$o5c(g, h);
            if (i != null) {
                ($61de1ee1cac498ae$var$uqb(g.j, ($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$K5c)) || $61de1ee1cac498ae$var$uqb(g.j, $61de1ee1cac498ae$var$L5c)) && $61de1ee1cac498ae$var$xNb($61de1ee1cac498ae$var$_1c(f, $61de1ee1cac498ae$var$E2), g, i);
                $61de1ee1cac498ae$var$uqb(g.j, $61de1ee1cac498ae$var$I5c) && $61de1ee1cac498ae$var$xNb($61de1ee1cac498ae$var$_1c(f, $61de1ee1cac498ae$var$B2), g, i);
                $61de1ee1cac498ae$var$uqb(g.j, $61de1ee1cac498ae$var$M5c) && $61de1ee1cac498ae$var$xNb($61de1ee1cac498ae$var$_1c(f, $61de1ee1cac498ae$var$F2), g, i);
                $61de1ee1cac498ae$var$uqb(g.j, $61de1ee1cac498ae$var$J5c) && $61de1ee1cac498ae$var$xNb($61de1ee1cac498ae$var$_1c(f, $61de1ee1cac498ae$var$D2), g, i);
            }
        }
    }
    return f;
}
function $61de1ee1cac498ae$var$J2d(a, b, c, d) {
    var e, f, g, h, i, j;
    i = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
    f = $61de1ee1cac498ae$var$BD(a.g, 119);
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        e = 0;
        for(h = 0; h < a.i; ++h){
            g = f[h];
            if (i.rl(g.ak())) {
                if (e == c) {
                    $61de1ee1cac498ae$var$Q6d();
                    if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) return g;
                    else {
                        j = g.dd();
                        j != null && d && $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0 && (j = $61de1ee1cac498ae$var$b3d(a, b, h, e, j));
                        return j;
                    }
                }
                ++e;
            }
        }
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$gve + c + $61de1ee1cac498ae$var$mue + e));
    } else {
        e = 0;
        for(h = 0; h < a.i; ++h){
            g = f[h];
            if (i.rl(g.ak())) {
                $61de1ee1cac498ae$var$Q6d();
                if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) return g;
                else {
                    j = g.dd();
                    j != null && d && $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0 && (j = $61de1ee1cac498ae$var$b3d(a, b, h, e, j));
                    return j;
                }
            }
            ++e;
        }
        return b.zj();
    }
}
function $61de1ee1cac498ae$var$K2d(a, b, c) {
    var d, e, f, g, h, i, j, k;
    e = $61de1ee1cac498ae$var$BD(a.g, 119);
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) return $61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? new $61de1ee1cac498ae$var$R7d(b, a) : new $61de1ee1cac498ae$var$f7d(b, a);
    else {
        j = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
        d = 0;
        for(h = 0; h < a.i; ++h){
            f = e[h];
            g = f.ak();
            if (j.rl(g)) {
                $61de1ee1cac498ae$var$Q6d();
                if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) return f;
                else if (g == ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$k8d) || g == $61de1ee1cac498ae$var$h8d) {
                    i = new $61de1ee1cac498ae$var$Wfb($61de1ee1cac498ae$var$fcb(f.dd()));
                    while(++h < a.i){
                        f = e[h];
                        g = f.ak();
                        (g == $61de1ee1cac498ae$var$k8d || g == $61de1ee1cac498ae$var$h8d) && $61de1ee1cac498ae$var$Qfb(i, $61de1ee1cac498ae$var$fcb(f.dd()));
                    }
                    return $61de1ee1cac498ae$var$j6d($61de1ee1cac498ae$var$BD(b.Yj(), 148), i.a);
                } else {
                    k = f.dd();
                    k != null && c && $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0 && (k = $61de1ee1cac498ae$var$b3d(a, b, h, d, k));
                    return k;
                }
            }
            ++d;
        }
        return b.zj();
    }
}
function $61de1ee1cac498ae$var$MZc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    f = 0;
    g = a.t;
    e = 0;
    d = 0;
    i = 0;
    m = 0;
    l = 0;
    if (c) {
        a.n.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        $61de1ee1cac498ae$var$Ekb(a.n, new $61de1ee1cac498ae$var$VZc(a.s, a.t, a.i));
    }
    h = 0;
    for(k = new $61de1ee1cac498ae$var$olb(a.b); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 33);
        if (f + j.g + (h > 0 ? a.i : 0) > b && i > 0) {
            f = 0;
            g += i + a.i;
            e = $61de1ee1cac498ae$var$$wnd.Math.max(e, m);
            d += i + a.i;
            i = 0;
            m = 0;
            if (c) {
                ++l;
                $61de1ee1cac498ae$var$Ekb(a.n, new $61de1ee1cac498ae$var$VZc(a.s, g, a.i));
            }
            h = 0;
        }
        m += j.g + (h > 0 ? a.i : 0);
        i = $61de1ee1cac498ae$var$$wnd.Math.max(i, j.f);
        c && $61de1ee1cac498ae$var$QZc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.n, l), 211), j);
        f += j.g + (h > 0 ? a.i : 0);
        ++h;
    }
    e = $61de1ee1cac498ae$var$$wnd.Math.max(e, m);
    d += i;
    if (c) {
        a.r = e;
        a.d = d;
        $61de1ee1cac498ae$var$u$c(a.j);
    }
    return new $61de1ee1cac498ae$var$J6c(a.s, a.t, e, d);
}
function $61de1ee1cac498ae$var$$fb(a, b, c, d, e) {
    $61de1ee1cac498ae$var$Zfb();
    var f, g, h, i, j, k, l, m, n;
    $61de1ee1cac498ae$var$vCb(a, "src");
    $61de1ee1cac498ae$var$vCb(c, "dest");
    m = $61de1ee1cac498ae$var$rb(a);
    i = $61de1ee1cac498ae$var$rb(c);
    $61de1ee1cac498ae$var$rCb((m.i & 4) != 0, "srcType is not an array");
    $61de1ee1cac498ae$var$rCb((i.i & 4) != 0, "destType is not an array");
    l = m.c;
    g = i.c;
    $61de1ee1cac498ae$var$rCb((l.i & 1) != 0 ? l == g : (g.i & 1) == 0, "Array types don't match");
    n = a.length;
    j = c.length;
    if (b < 0 || d < 0 || e < 0 || b + e > n || d + e > j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$pcb);
    if ((l.i & 1) == 0 && m != i) {
        k = $61de1ee1cac498ae$var$CD(a);
        f = $61de1ee1cac498ae$var$CD(c);
        if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(c) && b < d) {
            b += e;
            for(h = d + e; h-- > d;)$61de1ee1cac498ae$var$NC(f, h, k[--b]);
        } else for(h = d + e; d < h;)$61de1ee1cac498ae$var$NC(f, d++, k[b++]);
    } else e > 0 && $61de1ee1cac498ae$var$$Bb(a, b, c, d, e, true);
}
function $61de1ee1cac498ae$var$phb() {
    $61de1ee1cac498ae$var$phb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$nhb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        $61de1ee1cac498ae$var$Rie,
        1162261467,
        $61de1ee1cac498ae$var$Iie,
        1220703125,
        362797056,
        1977326743,
        $61de1ee1cac498ae$var$Iie,
        387420489,
        $61de1ee1cac498ae$var$Jje,
        214358881,
        429981696,
        815730721,
        1475789056,
        170859375,
        268435456,
        410338673,
        612220032,
        893871739,
        1280000000,
        1801088541,
        113379904,
        148035889,
        191102976,
        244140625,
        308915776,
        387420489,
        481890304,
        594823321,
        729000000,
        887503681,
        $61de1ee1cac498ae$var$Iie,
        1291467969,
        1544804416,
        1838265625,
        60466176
    ]);
    $61de1ee1cac498ae$var$ohb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        -1,
        -1,
        31,
        19,
        15,
        13,
        11,
        11,
        10,
        9,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5
    ]);
}
function $61de1ee1cac498ae$var$soc(a) {
    var b, c, d, e, f, g, h, i;
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        for(g = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$Mu(d.a)); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
            if ($61de1ee1cac498ae$var$ioc(f)) {
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$usc)), 305);
                if (!c.g && !!c.d) {
                    b = c;
                    i = c.d;
                    while(i){
                        $61de1ee1cac498ae$var$roc(i.i, i.k, false, true);
                        $61de1ee1cac498ae$var$zoc(b.a);
                        $61de1ee1cac498ae$var$zoc(i.i);
                        $61de1ee1cac498ae$var$zoc(i.k);
                        $61de1ee1cac498ae$var$zoc(i.b);
                        $61de1ee1cac498ae$var$RZb(i.c, b.c.d);
                        $61de1ee1cac498ae$var$RZb(b.c, null);
                        $61de1ee1cac498ae$var$$_b(b.a, null);
                        $61de1ee1cac498ae$var$$_b(i.i, null);
                        $61de1ee1cac498ae$var$$_b(i.k, null);
                        $61de1ee1cac498ae$var$$_b(i.b, null);
                        h = new $61de1ee1cac498ae$var$goc(b.i, i.a, b.e, i.j, i.f);
                        h.k = b.k;
                        h.n = b.n;
                        h.b = b.b;
                        h.c = i.c;
                        h.g = b.g;
                        h.d = i.d;
                        $61de1ee1cac498ae$var$yNb(b.i, $61de1ee1cac498ae$var$usc, h);
                        $61de1ee1cac498ae$var$yNb(i.a, $61de1ee1cac498ae$var$usc, h);
                        i = i.d;
                        b = h;
                    }
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$Xfe(a, b) {
    var c, d, e, f, g;
    g = $61de1ee1cac498ae$var$BD(b, 136);
    $61de1ee1cac498ae$var$Yfe(a);
    $61de1ee1cac498ae$var$Yfe(g);
    if (g.b == null) return;
    a.c = true;
    if (a.b == null) {
        a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, g.b.length, 15, 1);
        $61de1ee1cac498ae$var$$fb(g.b, 0, a.b, 0, g.b.length);
        return;
    }
    f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b.length + g.b.length, 15, 1);
    for(c = 0, d = 0, e = 0; c < a.b.length || d < g.b.length;){
        if (c >= a.b.length) {
            f[e++] = g.b[d++];
            f[e++] = g.b[d++];
        } else if (d >= g.b.length) {
            f[e++] = a.b[c++];
            f[e++] = a.b[c++];
        } else if (g.b[d] < a.b[c] || g.b[d] === a.b[c] && g.b[d + 1] < a.b[c + 1]) {
            f[e++] = g.b[d++];
            f[e++] = g.b[d++];
        } else {
            f[e++] = a.b[c++];
            f[e++] = a.b[c++];
        }
    }
    a.b = f;
}
function $61de1ee1cac498ae$var$S6b(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Usc))));
    h = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Usc)));
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Vsc), 11);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Vsc), 11);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Wsc), 11);
    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Wsc), 11);
    k = !!d && d == i;
    l = !!e && e == j;
    if (!c && !h) return new $61de1ee1cac498ae$var$Z6b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(new $61de1ee1cac498ae$var$olb(a.j)), 11).p == $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(new $61de1ee1cac498ae$var$olb(b.j)), 11).p, k, l);
    f = (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Usc))) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Tsc)))) && (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Usc))) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Tsc))));
    g = (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Usc))) || !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Tsc)))) && (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Usc))) || !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Tsc))));
    return new $61de1ee1cac498ae$var$Z6b(k && f || l && g, k, l);
}
function $61de1ee1cac498ae$var$HZc(a) {
    var b, c, d, e, f, g, h, i;
    d = 0;
    c = 0;
    i = new $61de1ee1cac498ae$var$Psb;
    b = 0;
    for(h = new $61de1ee1cac498ae$var$olb(a.n); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 211);
        if (g.c.c.length == 0) $61de1ee1cac498ae$var$Gsb(i, g, i.c.b, i.c);
        else {
            d = $61de1ee1cac498ae$var$$wnd.Math.max(d, g.d);
            c += g.a + (b > 0 ? a.i : 0);
        }
        ++b;
    }
    $61de1ee1cac498ae$var$Ce(a.n, i);
    a.d = c;
    a.r = d;
    a.g = 0;
    a.f = 0;
    a.e = 0;
    a.o = $61de1ee1cac498ae$var$Pje;
    a.p = $61de1ee1cac498ae$var$Pje;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 33);
        a.p = $61de1ee1cac498ae$var$$wnd.Math.min(a.p, e.g);
        a.g = $61de1ee1cac498ae$var$$wnd.Math.max(a.g, e.g);
        a.f = $61de1ee1cac498ae$var$$wnd.Math.max(a.f, e.f);
        a.o = $61de1ee1cac498ae$var$$wnd.Math.min(a.o, e.f);
        a.e += e.f + a.i;
    }
    a.a = a.e / a.b.c.length - a.i * ((a.b.c.length - 1) / a.b.c.length);
    $61de1ee1cac498ae$var$u$c(a.j);
}
function $61de1ee1cac498ae$var$Sld(a) {
    var b, c, d, e;
    if ((a.Db & 64) != 0) return $61de1ee1cac498ae$var$Mkd(a);
    b = new $61de1ee1cac498ae$var$Wfb($61de1ee1cac498ae$var$_se);
    d = a.k;
    if (!d) {
        !a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7));
        if (a.n.i > 0) {
            e = (!a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(a.n, 0), 137)).a;
            !e || $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += ' "', b), e), '"');
        }
    } else $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += ' "', b), d), '"');
    c = (!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), !(a.b.i <= 1 && (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c.i <= 1)));
    c ? (b.a += " [", b) : (b.a += " ", b);
    $61de1ee1cac498ae$var$Qfb(b, $61de1ee1cac498ae$var$Eb(new $61de1ee1cac498ae$var$Gb, new $61de1ee1cac498ae$var$Fyd(a.b)));
    c && (b.a += "]", b);
    b.a += $61de1ee1cac498ae$var$gne;
    c && (b.a += "[", b);
    $61de1ee1cac498ae$var$Qfb(b, $61de1ee1cac498ae$var$Eb(new $61de1ee1cac498ae$var$Gb, new $61de1ee1cac498ae$var$Fyd(a.c)));
    c && (b.a += "]", b);
    return b.a;
}
function $61de1ee1cac498ae$var$TQd(a, b) {
    var c, d, e, f, g, h, i;
    if (a.a) {
        h = a.a.ne();
        i = null;
        if (h != null) b.a += "" + h;
        else {
            g = a.a.Dj();
            if (g != null) {
                f = $61de1ee1cac498ae$var$hfb(g, $61de1ee1cac498ae$var$wfb(91));
                if (f != -1) {
                    i = g.substr(f);
                    b.a += "" + $61de1ee1cac498ae$var$qfb(g == null ? $61de1ee1cac498ae$var$Xhe : ($61de1ee1cac498ae$var$uCb(g), g), 0, f);
                } else b.a += "" + g;
            }
        }
        if (!!a.d && a.d.i != 0) {
            e = true;
            b.a += "<";
            for(d = new $61de1ee1cac498ae$var$Fyd(a.d); d.e != d.i.gc();){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 87);
                e ? e = false : (b.a += $61de1ee1cac498ae$var$She, b);
                $61de1ee1cac498ae$var$TQd(c, b);
            }
            b.a += ">";
        }
        i != null && (b.a += "" + i, b);
    } else if (a.e) {
        h = a.e.zb;
        h != null && (b.a += "" + h, b);
    } else {
        b.a += "?";
        if (a.b) {
            b.a += " super ";
            $61de1ee1cac498ae$var$TQd(a.b, b);
        } else if (a.f) {
            b.a += " extends ";
            $61de1ee1cac498ae$var$TQd(a.f, b);
        }
    }
}
function $61de1ee1cac498ae$var$Z9b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    v = a.c;
    w = b.c;
    c = $61de1ee1cac498ae$var$Jkb(v.a, a, 0);
    d = $61de1ee1cac498ae$var$Jkb(w.a, b, 0);
    t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$W_b(a, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc)).Kc().Pb(), 11);
    C = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$W_b(a, $61de1ee1cac498ae$var$IAc).Kc().Pb(), 11);
    u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$W_b(b, $61de1ee1cac498ae$var$HAc).Kc().Pb(), 11);
    D = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$W_b(b, $61de1ee1cac498ae$var$IAc).Kc().Pb(), 11);
    r = $61de1ee1cac498ae$var$k_b(t.e);
    A = $61de1ee1cac498ae$var$k_b(C.g);
    s = $61de1ee1cac498ae$var$k_b(u.e);
    B = $61de1ee1cac498ae$var$k_b(D.g);
    $61de1ee1cac498ae$var$Z_b(a, d, w);
    for(g = s, k = 0, o = g.length; k < o; ++k){
        e = g[k];
        $61de1ee1cac498ae$var$RZb(e, t);
    }
    for(h = B, l = 0, p = h.length; l < p; ++l){
        e = h[l];
        $61de1ee1cac498ae$var$QZb(e, C);
    }
    $61de1ee1cac498ae$var$Z_b(b, c, v);
    for(i = r, m = 0, q = i.length; m < q; ++m){
        e = i[m];
        $61de1ee1cac498ae$var$RZb(e, u);
    }
    for(f = A, j = 0, n = f.length; j < n; ++j){
        e = f[j];
        $61de1ee1cac498ae$var$QZb(e, D);
    }
}
function $61de1ee1cac498ae$var$$$b(a, b, c, d) {
    var e, f, g, h, i, j, k;
    f = $61de1ee1cac498ae$var$a_b(d);
    h = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$uxc))));
    if ((h || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$exc)))) && !$61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Vxc), 98))) {
        e = $61de1ee1cac498ae$var$Zcd(f);
        i = $61de1ee1cac498ae$var$i_b(a, c, c == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc) ? e : $61de1ee1cac498ae$var$Wcd(e));
    } else {
        i = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$F0b(i, a);
        if (b) {
            k = i.n;
            k.a = b.a - a.n.a;
            k.b = b.b - a.n.b;
            $61de1ee1cac498ae$var$Q6c(k, 0, 0, a.o.a, a.o.b);
            $61de1ee1cac498ae$var$G0b(i, $61de1ee1cac498ae$var$W$b(i, f));
        } else {
            e = $61de1ee1cac498ae$var$Zcd(f);
            $61de1ee1cac498ae$var$G0b(i, c == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc) ? e : $61de1ee1cac498ae$var$Wcd(e));
        }
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21);
        j = i.j;
        switch(f.g){
            case 2:
            case 1:
                (j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || j == $61de1ee1cac498ae$var$Rcd) && g.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Lrc));
                break;
            case 4:
            case 3:
                (j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) || j == $61de1ee1cac498ae$var$Tcd) && g.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Lrc));
        }
    }
    return i;
}
function $61de1ee1cac498ae$var$pPc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if ($61de1ee1cac498ae$var$$wnd.Math.abs(b.s - b.c) < $61de1ee1cac498ae$var$qme || $61de1ee1cac498ae$var$$wnd.Math.abs(c.s - c.c) < $61de1ee1cac498ae$var$qme) return 0;
    d = $61de1ee1cac498ae$var$oPc(a, b.j, c.e);
    e = $61de1ee1cac498ae$var$oPc(a, c.j, b.e);
    f = d == -1 || e == -1;
    g = 0;
    if (f) {
        if (d == -1) {
            new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc), c, b, 1);
            ++g;
        }
        if (e == -1) {
            new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc), b, c, 1);
            ++g;
        }
    } else {
        h = $61de1ee1cac498ae$var$vPc(b.j, c.s, c.c);
        h += $61de1ee1cac498ae$var$vPc(c.e, b.s, b.c);
        i = $61de1ee1cac498ae$var$vPc(c.j, b.s, b.c);
        i += $61de1ee1cac498ae$var$vPc(b.e, c.s, c.c);
        j = d + 16 * h;
        k = e + 16 * i;
        if (j < k) new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$GOc), b, c, k - j);
        else if (j > k) new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$GOc), c, b, j - k);
        else if (j > 0 && k > 0) {
            new $61de1ee1cac498ae$var$DOc(($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$GOc), b, c, 0);
            new $61de1ee1cac498ae$var$DOc($61de1ee1cac498ae$var$GOc, c, b, 0);
        }
    }
    return g;
}
function $61de1ee1cac498ae$var$TUb(a, b) {
    var c, d, e, f, g, h;
    for(g = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(a.f.b).a); g.b;){
        f = $61de1ee1cac498ae$var$lib(g);
        e = $61de1ee1cac498ae$var$BD(f.cd(), 594);
        if (b == 1) {
            if (e.gf() != ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$dad) && e.gf() != $61de1ee1cac498ae$var$_9c) continue;
        } else {
            if (e.gf() != ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad) && e.gf() != $61de1ee1cac498ae$var$bad) continue;
        }
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(f.dd(), 46).b, 81);
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(f.dd(), 46).a, 189);
        c = h.c;
        switch(e.gf().g){
            case 2:
                d.g.c = a.e.a;
                d.g.b = $61de1ee1cac498ae$var$$wnd.Math.max(1, d.g.b + c);
                break;
            case 1:
                d.g.c = d.g.c + c;
                d.g.b = $61de1ee1cac498ae$var$$wnd.Math.max(1, d.g.b - c);
                break;
            case 4:
                d.g.d = a.e.b;
                d.g.a = $61de1ee1cac498ae$var$$wnd.Math.max(1, d.g.a + c);
                break;
            case 3:
                d.g.d = d.g.d + c;
                d.g.a = $61de1ee1cac498ae$var$$wnd.Math.max(1, d.g.a - c);
        }
    }
}
function $61de1ee1cac498ae$var$nJc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    h = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b.b.c.length, 15, 1);
    j = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$NQ, $61de1ee1cac498ae$var$Kie, 267, b.b.c.length, 0, 1);
    i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, b.b.c.length, 0, 1);
    for(l = a.a, m = 0, n = l.length; m < n; ++m){
        k = l[m];
        p = 0;
        for(g = new $61de1ee1cac498ae$var$olb(k.e); g.a < g.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
            d = $61de1ee1cac498ae$var$G1b(e.c);
            ++h[d];
            o = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$lyc))));
            h[d] > 0 && !!i[d] && (o = $61de1ee1cac498ae$var$jBc(a.b, i[d], e));
            p = $61de1ee1cac498ae$var$$wnd.Math.max(p, e.c.c.b + o);
        }
        for(f = new $61de1ee1cac498ae$var$olb(k.e); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
            e.n.b = p + e.d.d;
            c = e.c;
            c.c.b = p + e.d.d + e.o.b + e.d.a;
            j[$61de1ee1cac498ae$var$Jkb(c.b.b, c, 0)] = e.k;
            i[$61de1ee1cac498ae$var$Jkb(c.b.b, c, 0)] = e;
        }
    }
}
function $61de1ee1cac498ae$var$LXc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 79);
        if (!$61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$qud((!c.b && (c.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 4, 7)), c.b), 0), 186)) {
            i = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!c.c && (c.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 5, 8)), c.c), 0), 82));
            if (!$61de1ee1cac498ae$var$Pld(c)) {
                g = b.i + b.g / 2;
                h = b.j + b.f / 2;
                k = i.i + i.g / 2;
                l = i.j + i.f / 2;
                m = new $61de1ee1cac498ae$var$d7c;
                m.a = k - g;
                m.b = l - h;
                f = new $61de1ee1cac498ae$var$f7c(m.a, m.b);
                $61de1ee1cac498ae$var$l6c(f, b.g, b.f);
                m.a -= f.a;
                m.b -= f.b;
                g = k - m.a;
                h = l - m.b;
                j = new $61de1ee1cac498ae$var$f7c(m.a, m.b);
                $61de1ee1cac498ae$var$l6c(j, i.g, i.f);
                m.a -= j.a;
                m.b -= j.b;
                k = g + m.a;
                l = h + m.b;
                e = $61de1ee1cac498ae$var$itd(c, true, true);
                $61de1ee1cac498ae$var$omd(e, g);
                $61de1ee1cac498ae$var$pmd(e, h);
                $61de1ee1cac498ae$var$hmd(e, k);
                $61de1ee1cac498ae$var$imd(e, l);
                $61de1ee1cac498ae$var$LXc(a, i);
            }
        }
    }
}
function $61de1ee1cac498ae$var$e0c(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$Pre), "ELK SPOrE Compaction"), "ShrinkTree is a compaction algorithm that maintains the topology of a layout. The relocation of diagram elements is based on contracting a spanning tree."), new $61de1ee1cac498ae$var$h0c)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Qre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$c0c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Rre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$__c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Sre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$$_c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Tre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Y_c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Ure, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Z_c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$X_c);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$wme, 8);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Vre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$b0c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Wre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$T_c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Xre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$U_c));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Pre, $61de1ee1cac498ae$var$Zpe, ($61de1ee1cac498ae$var$Bcb(), false));
}
function $61de1ee1cac498ae$var$JLc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    $61de1ee1cac498ae$var$Odd(b, "Simple node placement", 1);
    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    h = 0;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        g = d.c;
        g.b = 0;
        c = null;
        for(j = new $61de1ee1cac498ae$var$olb(d.a); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
            !!c && (g.b += $61de1ee1cac498ae$var$hBc(i, c, l.c));
            g.b += i.d.d + i.o.b + i.d.a;
            c = i;
        }
        h = $61de1ee1cac498ae$var$$wnd.Math.max(h, g.b);
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        g = d.c;
        k = (h - g.b) / 2;
        c = null;
        for(j = new $61de1ee1cac498ae$var$olb(d.a); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
            !!c && (k += $61de1ee1cac498ae$var$hBc(i, c, l.c));
            k += i.d.d;
            i.n.b = k;
            k += i.o.b + i.d.a;
            c = i;
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$s2d(a, b, c, d) {
    var e, f, g, h, i, j, k, l;
    if (d.gc() == 0) return false;
    i = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj());
    g = i ? d : new $61de1ee1cac498ae$var$zud(d.gc());
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        if (b.hi()) for(k = d.Kc(); k.Ob();){
            j = k.Pb();
            if (!$61de1ee1cac498ae$var$F2d(a, b, j, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0)) {
                f = $61de1ee1cac498ae$var$R6d(b, j);
                g.Fc(f);
            }
        }
        else if (!i) for(k = d.Kc(); k.Ob();){
            j = k.Pb();
            f = $61de1ee1cac498ae$var$R6d(b, j);
            g.Fc(f);
        }
    } else {
        l = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
        e = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(h = 0; h < a.i; ++h){
            f = e[h];
            if (l.rl(f.ak())) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Hwe));
        }
        if (d.gc() > 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Hwe));
        if (!i) {
            f = $61de1ee1cac498ae$var$R6d(b, d.Kc().Pb());
            g.Fc(f);
        }
    }
    return $61de1ee1cac498ae$var$xtd(a, $61de1ee1cac498ae$var$I2d(a, b, c), g);
}
function $61de1ee1cac498ae$var$Pmc(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Jmc(b.b.j);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.d, 16)), new $61de1ee1cac498ae$var$$mc), new $61de1ee1cac498ae$var$anc);
    for(f = new $61de1ee1cac498ae$var$olb(b.d); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 101);
        switch(e.e.g){
            case 0:
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e.j, 0), 113).d.j;
                $61de1ee1cac498ae$var$mjc(e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$RAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(e.k, c), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113));
                $61de1ee1cac498ae$var$njc(e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$QAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(e.k, c), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113));
                break;
            case 1:
                d = $61de1ee1cac498ae$var$Bkc(e);
                $61de1ee1cac498ae$var$mjc(e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$RAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(e.k, d[0]), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113));
                $61de1ee1cac498ae$var$njc(e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$QAb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(e.k, d[1]), 15).Oc(), $61de1ee1cac498ae$var$Hmc)), 113));
                break;
            case 2:
                $61de1ee1cac498ae$var$Rmc(a, e);
                break;
            case 3:
                $61de1ee1cac498ae$var$Qmc(e);
                break;
            case 4:
                $61de1ee1cac498ae$var$Omc(a, e);
        }
        $61de1ee1cac498ae$var$Mmc(e);
    }
    a.a = null;
}
function $61de1ee1cac498ae$var$$Mc(a, b, c) {
    var d, e, f, g, h, i, j, k;
    d = a.a.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc) ? $61de1ee1cac498ae$var$Pje : $61de1ee1cac498ae$var$Qje;
    h = $61de1ee1cac498ae$var$_Mc(a, new $61de1ee1cac498ae$var$ZMc(b, c));
    if (!h.a && h.c) {
        $61de1ee1cac498ae$var$Dsb(a.d, h);
        return d;
    } else if (h.a) {
        e = h.a.c;
        i = h.a.d;
        if (c) {
            j = a.a.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$XLc) ? i : e;
            f = a.a.c == $61de1ee1cac498ae$var$XLc ? e : i;
            g = a.a.g[f.i.p];
            k = $61de1ee1cac498ae$var$Edb(a.a.p[g.p]) + $61de1ee1cac498ae$var$Edb(a.a.d[f.i.p]) + f.n.b + f.a.b - $61de1ee1cac498ae$var$Edb(a.a.d[j.i.p]) - j.n.b - j.a.b;
        } else {
            j = a.a.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc) ? i : e;
            f = a.a.c == $61de1ee1cac498ae$var$WLc ? e : i;
            k = $61de1ee1cac498ae$var$Edb(a.a.p[a.a.g[f.i.p].p]) + $61de1ee1cac498ae$var$Edb(a.a.d[f.i.p]) + f.n.b + f.a.b - $61de1ee1cac498ae$var$Edb(a.a.d[j.i.p]) - j.n.b - j.a.b;
        }
        a.a.n[a.a.g[e.i.p].p] = ($61de1ee1cac498ae$var$Bcb(), true);
        a.a.n[a.a.g[i.i.p].p] = true;
        return k;
    }
    return d;
}
function $61de1ee1cac498ae$var$f3d(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        i = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? new $61de1ee1cac498ae$var$R7d(b, a) : new $61de1ee1cac498ae$var$f7d(b, a));
        $61de1ee1cac498ae$var$D2d(i.c, i.b);
        $61de1ee1cac498ae$var$b7d(i, $61de1ee1cac498ae$var$BD(c, 14));
    } else {
        k = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
        d = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(g = 0; g < a.i; ++g){
            e = d[g];
            f = e.ak();
            if (k.rl(f)) {
                if (f == ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$k8d) || f == $61de1ee1cac498ae$var$h8d) {
                    j = $61de1ee1cac498ae$var$m3d(a, b, c);
                    h = g;
                    j ? $61de1ee1cac498ae$var$Xxd(a, g) : ++g;
                    while(g < a.i){
                        e = d[g];
                        f = e.ak();
                        f == $61de1ee1cac498ae$var$k8d || f == $61de1ee1cac498ae$var$h8d ? $61de1ee1cac498ae$var$Xxd(a, g) : ++g;
                    }
                    j || $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(a, h, $61de1ee1cac498ae$var$R6d(b, c)), 72);
                } else $61de1ee1cac498ae$var$m3d(a, b, c) ? $61de1ee1cac498ae$var$Xxd(a, g) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(a, g, ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? $61de1ee1cac498ae$var$BD(c, 72) : $61de1ee1cac498ae$var$R6d(b, c))), 72);
                return;
            }
        }
        $61de1ee1cac498ae$var$m3d(a, b, c) || $61de1ee1cac498ae$var$wtd(a, ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj() ? $61de1ee1cac498ae$var$BD(c, 72) : $61de1ee1cac498ae$var$R6d(b, c)));
    }
}
function $61de1ee1cac498ae$var$IMb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if (!$61de1ee1cac498ae$var$pb(c, a.b)) {
        a.b = c;
        f = new $61de1ee1cac498ae$var$LMb;
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.f, 16)), f), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
            ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Eyb),
            $61de1ee1cac498ae$var$Dyb
        ]))), 21);
        a.e = true;
        a.f = true;
        a.c = true;
        a.d = true;
        e = g.Hc(($61de1ee1cac498ae$var$RMb(), $61de1ee1cac498ae$var$OMb));
        d = g.Hc($61de1ee1cac498ae$var$PMb);
        e && !d && (a.f = false);
        !e && d && (a.d = false);
        e = g.Hc($61de1ee1cac498ae$var$NMb);
        d = g.Hc($61de1ee1cac498ae$var$QMb);
        e && !d && (a.c = false);
        !e && d && (a.e = false);
    }
    k = $61de1ee1cac498ae$var$BD(a.a.Ce(b, c), 46);
    i = $61de1ee1cac498ae$var$BD(k.a, 19).a;
    j = $61de1ee1cac498ae$var$BD(k.b, 19).a;
    h = false;
    i < 0 ? a.c || (h = true) : a.e || (h = true);
    j < 0 ? a.d || (h = true) : a.f || (h = true);
    return h ? $61de1ee1cac498ae$var$IMb(a, k, c) : k;
}
function $61de1ee1cac498ae$var$oKb(a) {
    var b, c, d, e;
    e = a.o;
    $61de1ee1cac498ae$var$$Jb();
    if (a.A.dc() || $61de1ee1cac498ae$var$pb(a.A, $61de1ee1cac498ae$var$ZJb)) b = e.b;
    else {
        b = $61de1ee1cac498ae$var$fIb(a.f);
        if (a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$qdd)) && !a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Edd))) {
            b = $61de1ee1cac498ae$var$$wnd.Math.max(b, $61de1ee1cac498ae$var$fIb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.p, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)), 244)));
            b = $61de1ee1cac498ae$var$$wnd.Math.max(b, $61de1ee1cac498ae$var$fIb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.p, $61de1ee1cac498ae$var$Tcd), 244)));
        }
        c = $61de1ee1cac498ae$var$aKb(a);
        !!c && (b = $61de1ee1cac498ae$var$$wnd.Math.max(b, c.b));
        if (a.A.Hc($61de1ee1cac498ae$var$rdd)) {
            if (a.q == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$_bd) || a.q == $61de1ee1cac498ae$var$$bd) {
                b = $61de1ee1cac498ae$var$$wnd.Math.max(b, $61de1ee1cac498ae$var$_Gb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)), 124)));
                b = $61de1ee1cac498ae$var$$wnd.Math.max(b, $61de1ee1cac498ae$var$_Gb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Tcd), 124)));
            }
        }
    }
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(a.e.yf().We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$$8c)))) ? e.b = $61de1ee1cac498ae$var$$wnd.Math.max(e.b, b) : e.b = b;
    d = a.f.i;
    d.d = 0;
    d.a = b;
    $61de1ee1cac498ae$var$iIb(a.f);
}
function $61de1ee1cac498ae$var$$Ic(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    for(l = 0; l < b.length; l++){
        for(h = a.Kc(); h.Ob();){
            f = $61de1ee1cac498ae$var$BD(h.Pb(), 225);
            f.Of(l, b);
        }
        for(m = 0; m < b[l].length; m++){
            for(i = a.Kc(); i.Ob();){
                f = $61de1ee1cac498ae$var$BD(i.Pb(), 225);
                f.Pf(l, m, b);
            }
            p = b[l][m].j;
            for(n = 0; n < p.c.length; n++){
                for(j = a.Kc(); j.Ob();){
                    f = $61de1ee1cac498ae$var$BD(j.Pb(), 225);
                    f.Qf(l, m, n, b);
                }
                o = ($61de1ee1cac498ae$var$tCb(n, p.c.length), $61de1ee1cac498ae$var$BD(p.c[n], 11));
                c = 0;
                for(e = new $61de1ee1cac498ae$var$b1b(o.b); $61de1ee1cac498ae$var$llb(e.a) || $61de1ee1cac498ae$var$llb(e.b);){
                    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(e.a) ? $61de1ee1cac498ae$var$mlb(e.a) : $61de1ee1cac498ae$var$mlb(e.b), 17);
                    for(k = a.Kc(); k.Ob();){
                        f = $61de1ee1cac498ae$var$BD(k.Pb(), 225);
                        f.Nf(l, m, n, c++, d, b);
                    }
                }
            }
        }
    }
    for(g = a.Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 225);
        f.Mf();
    }
}
function $61de1ee1cac498ae$var$J4b(a, b) {
    var c, d, e, f, g, h, i;
    a.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$myc))));
    a.c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$pyc)));
    a.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Xwc), 336);
    a.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$swc), 275);
    $61de1ee1cac498ae$var$H4b(b);
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.b, 16)), new $61de1ee1cac498ae$var$N4b), new $61de1ee1cac498ae$var$P4b), new $61de1ee1cac498ae$var$R4b), new $61de1ee1cac498ae$var$T4b), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    for(e = h.Kc(); e.Ob();){
        c = $61de1ee1cac498ae$var$BD(e.Pb(), 17);
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$rtc)), 15);
        g.Jc(new $61de1ee1cac498ae$var$V4b(a));
        $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$rtc, null);
    }
    for(d = h.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 17);
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$stc)), 17);
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$ptc), 15);
        $61de1ee1cac498ae$var$B4b(a, f, i);
        $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$ptc, null);
    }
}
function $61de1ee1cac498ae$var$uZd(a) {
    a.b = null;
    a.a = null;
    a.o = null;
    a.q = null;
    a.v = null;
    a.w = null;
    a.B = null;
    a.p = null;
    a.Q = null;
    a.R = null;
    a.S = null;
    a.T = null;
    a.U = null;
    a.V = null;
    a.W = null;
    a.bb = null;
    a.eb = null;
    a.ab = null;
    a.H = null;
    a.db = null;
    a.c = null;
    a.d = null;
    a.f = null;
    a.n = null;
    a.r = null;
    a.s = null;
    a.u = null;
    a.G = null;
    a.J = null;
    a.e = null;
    a.j = null;
    a.i = null;
    a.g = null;
    a.k = null;
    a.t = null;
    a.F = null;
    a.I = null;
    a.L = null;
    a.M = null;
    a.O = null;
    a.P = null;
    a.$ = null;
    a.N = null;
    a.Z = null;
    a.cb = null;
    a.K = null;
    a.D = null;
    a.A = null;
    a.C = null;
    a._ = null;
    a.fb = null;
    a.X = null;
    a.Y = null;
    a.gb = false;
    a.hb = false;
}
function $61de1ee1cac498ae$var$bKc(a) {
    var b, c, d, e, f, g, h, i, j;
    if (a.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) return false;
    if (a.j.c.length <= 1) return false;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    if (f == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd)) return false;
    e = ($61de1ee1cac498ae$var$Izc(), (!a.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : a.q)._b($61de1ee1cac498ae$var$Cxc) ? d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Cxc), 197) : d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), $61de1ee1cac498ae$var$Dxc), 197), d);
    if (e == $61de1ee1cac498ae$var$Gzc) return false;
    if (!(e == $61de1ee1cac498ae$var$Fzc || e == $61de1ee1cac498ae$var$Ezc)) {
        g = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(a, $61de1ee1cac498ae$var$zyc)));
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$yyc), 142);
        !b && (b = new $61de1ee1cac498ae$var$J_b(g, g, g, g));
        j = $61de1ee1cac498ae$var$V_b(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
        i = b.d + b.a + (j.gc() - 1) * g;
        if (i > a.o.b) return false;
        c = $61de1ee1cac498ae$var$V_b(a, $61de1ee1cac498ae$var$zcd);
        h = b.d + b.a + (c.gc() - 1) * g;
        if (h > a.o.b) return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$thb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    g = a.e;
    i = b.e;
    if (g == 0) return b;
    if (i == 0) return a;
    f = a.d;
    h = b.d;
    if (f + h == 2) {
        c = $61de1ee1cac498ae$var$xbb(a.a[0], $61de1ee1cac498ae$var$Yje);
        d = $61de1ee1cac498ae$var$xbb(b.a[0], $61de1ee1cac498ae$var$Yje);
        if (g == i) {
            k = $61de1ee1cac498ae$var$wbb(c, d);
            o = $61de1ee1cac498ae$var$Tbb(k);
            n = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Pbb(k, 32));
            return n == 0 ? new $61de1ee1cac498ae$var$Ugb(g, o) : new $61de1ee1cac498ae$var$Vgb(g, 2, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
                o,
                n
            ]));
        }
        return $61de1ee1cac498ae$var$ghb(g < 0 ? $61de1ee1cac498ae$var$Qbb(d, c) : $61de1ee1cac498ae$var$Qbb(c, d));
    } else if (g == i) {
        m = g;
        l = f >= h ? $61de1ee1cac498ae$var$uhb(a.a, f, b.a, h) : $61de1ee1cac498ae$var$uhb(b.a, h, a.a, f);
    } else {
        e = f != h ? f > h ? 1 : -1 : $61de1ee1cac498ae$var$whb(a.a, b.a, f);
        if (e == 0) return $61de1ee1cac498ae$var$Hgb(), $61de1ee1cac498ae$var$Ggb;
        if (e == 1) {
            m = g;
            l = $61de1ee1cac498ae$var$zhb(a.a, f, b.a, h);
        } else {
            m = i;
            l = $61de1ee1cac498ae$var$zhb(b.a, h, a.a, f);
        }
    }
    j = new $61de1ee1cac498ae$var$Vgb(m, l.length, l);
    $61de1ee1cac498ae$var$Jgb(j);
    return j;
}
function $61de1ee1cac498ae$var$oZb(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n;
    l = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vxc))));
    m = null;
    f == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc) && d.c.i == c ? m = d.c : f == $61de1ee1cac498ae$var$IAc && d.d.i == c && (m = d.d);
    j = g;
    if (!j || !l || !!m) {
        k = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd);
        m ? k = m.j : $61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Vxc), 98)) && (k = f == $61de1ee1cac498ae$var$HAc ? $61de1ee1cac498ae$var$Tcd : $61de1ee1cac498ae$var$zcd);
        i = $61de1ee1cac498ae$var$lZb(a, b, c, f, k, d);
        h = $61de1ee1cac498ae$var$kZb(($61de1ee1cac498ae$var$Q_b(c), d));
        if (f == $61de1ee1cac498ae$var$HAc) {
            $61de1ee1cac498ae$var$QZb(h, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(i.j, 0), 11));
            $61de1ee1cac498ae$var$RZb(h, e);
        } else {
            $61de1ee1cac498ae$var$QZb(h, e);
            $61de1ee1cac498ae$var$RZb(h, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(i.j, 0), 11));
        }
        j = new $61de1ee1cac498ae$var$yZb(d, h, i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11), f, !m);
    } else {
        $61de1ee1cac498ae$var$Ekb(j.e, d);
        n = $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(j.d, $61de1ee1cac498ae$var$Zwc))), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Zwc))));
        $61de1ee1cac498ae$var$yNb(j.d, $61de1ee1cac498ae$var$Zwc, n);
    }
    $61de1ee1cac498ae$var$Rc(a.a, d, new $61de1ee1cac498ae$var$BZb(j.d, b, f));
    return j;
}
function $61de1ee1cac498ae$var$V1d(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = null;
    !!a.d && (k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.d, b), 138));
    if (!k) {
        f = a.a.Mh();
        l = f.i;
        if (!a.d || $61de1ee1cac498ae$var$Vhb(a.d) != l) {
            i = new $61de1ee1cac498ae$var$Lqb;
            !!a.d && $61de1ee1cac498ae$var$Ld(i, a.d);
            j = i.f.c + i.g.c;
            for(h = j; h < l; ++h){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(f, h), 138);
                e = $61de1ee1cac498ae$var$o1d(a.e, d).ne();
                c = $61de1ee1cac498ae$var$BD(e == null ? $61de1ee1cac498ae$var$jrb(i.f, null, d) : $61de1ee1cac498ae$var$Drb(i.g, e, d), 138);
                !!c && c != d && (e == null ? $61de1ee1cac498ae$var$jrb(i.f, null, c) : $61de1ee1cac498ae$var$Drb(i.g, e, c));
            }
            if (i.f.c + i.g.c != l) for(g = 0; g < j; ++g){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(f, g), 138);
                e = $61de1ee1cac498ae$var$o1d(a.e, d).ne();
                c = $61de1ee1cac498ae$var$BD(e == null ? $61de1ee1cac498ae$var$jrb(i.f, null, d) : $61de1ee1cac498ae$var$Drb(i.g, e, d), 138);
                !!c && c != d && (e == null ? $61de1ee1cac498ae$var$jrb(i.f, null, c) : $61de1ee1cac498ae$var$Drb(i.g, e, c));
            }
            a.d = i;
        }
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.d, b), 138);
    }
    return k;
}
function $61de1ee1cac498ae$var$lZb(a, b, c, d, e, f) {
    var g, h, i, j, k, l;
    g = null;
    j = d == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc) ? f.c : f.d;
    i = $61de1ee1cac498ae$var$a_b(b);
    if (j.i == c) {
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, j), 10);
        if (!g) {
            g = $61de1ee1cac498ae$var$Z$b(j, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98), e, $61de1ee1cac498ae$var$hZb(j), null, j.n, j.o, i, b);
            $61de1ee1cac498ae$var$yNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), j);
            $61de1ee1cac498ae$var$Rhb(a.b, j, g);
        }
    } else {
        g = $61de1ee1cac498ae$var$Z$b((k = new $61de1ee1cac498ae$var$zNb, l = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$lyc)))) / 2, $61de1ee1cac498ae$var$xNb(k, $61de1ee1cac498ae$var$Uxc, l), k), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Vxc), 98), e, d == $61de1ee1cac498ae$var$HAc ? -1 : 1, null, new $61de1ee1cac498ae$var$d7c, new $61de1ee1cac498ae$var$f7c(0, 0), i, b);
        h = $61de1ee1cac498ae$var$mZb(g, c, d);
        $61de1ee1cac498ae$var$yNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), h);
        $61de1ee1cac498ae$var$Rhb(a.b, h, g);
    }
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc));
    $61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98)) ? $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$Vxc, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$acd)) : $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$Vxc, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$bcd));
    return g;
}
function $61de1ee1cac498ae$var$vNc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    $61de1ee1cac498ae$var$Odd(b, "Orthogonal edge routing", 1);
    j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$wyc))));
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$myc)));
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$pyc)));
    m = new $61de1ee1cac498ae$var$tPc(0, c);
    q = 0;
    g = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    h = null;
    k = null;
    i = null;
    l = null;
    do {
        k = g.b < g.d.gc() ? ($61de1ee1cac498ae$var$sCb(g.b < g.d.gc()), $61de1ee1cac498ae$var$BD(g.d.Xb(g.c = g.b++), 29)) : null;
        l = !k ? null : k.a;
        if (h) {
            $61de1ee1cac498ae$var$h_b(h, q);
            q += h.c.a;
        }
        p = !h ? q : q + d;
        o = $61de1ee1cac498ae$var$sPc(m, a, i, l, p);
        e = !h || $61de1ee1cac498ae$var$Kq(i, ($61de1ee1cac498ae$var$FNc(), $61de1ee1cac498ae$var$DNc));
        f = !k || $61de1ee1cac498ae$var$Kq(l, ($61de1ee1cac498ae$var$FNc(), $61de1ee1cac498ae$var$DNc));
        if (o > 0) {
            n = (o - 1) * c;
            !!h && (n += d);
            !!k && (n += d);
            n < j && !e && !f && (n = j);
            q += n;
        } else !e && !f && (q += j);
        h = k;
        i = l;
    }while (k);
    a.f.a = q;
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$IEd() {
    $61de1ee1cac498ae$var$IEd = $61de1ee1cac498ae$var$ccb;
    var a;
    $61de1ee1cac498ae$var$HEd = new $61de1ee1cac498ae$var$mFd;
    $61de1ee1cac498ae$var$BEd = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, 0, 6, 1);
    $61de1ee1cac498ae$var$uEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$ZEd(33, 58), $61de1ee1cac498ae$var$ZEd(1, 26));
    $61de1ee1cac498ae$var$vEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$ZEd(97, 122), $61de1ee1cac498ae$var$ZEd(65, 90));
    $61de1ee1cac498ae$var$wEd = $61de1ee1cac498ae$var$ZEd(48, 57);
    $61de1ee1cac498ae$var$sEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$uEd, 0);
    $61de1ee1cac498ae$var$tEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$vEd, $61de1ee1cac498ae$var$wEd);
    $61de1ee1cac498ae$var$xEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$Mbb(0, $61de1ee1cac498ae$var$ZEd(1, 6)), $61de1ee1cac498ae$var$ZEd(33, 38));
    $61de1ee1cac498ae$var$yEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$wEd, $61de1ee1cac498ae$var$ZEd(65, 70)), $61de1ee1cac498ae$var$ZEd(97, 102));
    $61de1ee1cac498ae$var$EEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$sEd, $61de1ee1cac498ae$var$XEd("-_.!~*'()"));
    $61de1ee1cac498ae$var$FEd = $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$tEd, $61de1ee1cac498ae$var$$Ed("-_.!~*'()"));
    $61de1ee1cac498ae$var$XEd($61de1ee1cac498ae$var$lve);
    $61de1ee1cac498ae$var$$Ed($61de1ee1cac498ae$var$lve);
    $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$EEd, $61de1ee1cac498ae$var$XEd(";:@&=+$,"));
    $61de1ee1cac498ae$var$Mbb($61de1ee1cac498ae$var$FEd, $61de1ee1cac498ae$var$$Ed(";:@&=+$,"));
    $61de1ee1cac498ae$var$zEd = $61de1ee1cac498ae$var$XEd(":/?#");
    $61de1ee1cac498ae$var$AEd = $61de1ee1cac498ae$var$$Ed(":/?#");
    $61de1ee1cac498ae$var$CEd = $61de1ee1cac498ae$var$XEd("/?#");
    $61de1ee1cac498ae$var$DEd = $61de1ee1cac498ae$var$$Ed("/?#");
    a = new $61de1ee1cac498ae$var$Tqb;
    a.a.zc("jar", a);
    a.a.zc("zip", a);
    a.a.zc("archive", a);
    $61de1ee1cac498ae$var$GEd = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$zob(a));
}
function $61de1ee1cac498ae$var$yUc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$cTc), 0);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$aTc), 86);
    if (b.d.b == 0) {
        if (i) {
            k = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$fTc))) + a.a + $61de1ee1cac498ae$var$zUc(i, b);
            $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$fTc, k);
        } else $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$fTc, 0);
    } else {
        for(d = (f = $61de1ee1cac498ae$var$Jsb(new $61de1ee1cac498ae$var$ZRc(b).a.d, 0), new $61de1ee1cac498ae$var$aSc(f)); $61de1ee1cac498ae$var$Wsb(d.a);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d.a), 188).c;
            $61de1ee1cac498ae$var$yUc(a, c);
        }
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$pr((g = $61de1ee1cac498ae$var$Jsb(new $61de1ee1cac498ae$var$ZRc(b).a.d, 0), new $61de1ee1cac498ae$var$aSc(g))), 86);
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$or((e = $61de1ee1cac498ae$var$Jsb(new $61de1ee1cac498ae$var$ZRc(b).a.d, 0), new $61de1ee1cac498ae$var$aSc(e))), 86);
        j = ($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(l, $61de1ee1cac498ae$var$fTc))) + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(h, $61de1ee1cac498ae$var$fTc)))) / 2;
        if (i) {
            k = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$fTc))) + a.a + $61de1ee1cac498ae$var$zUc(i, b);
            $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$fTc, k);
            $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$cTc, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$fTc))) - j);
            $61de1ee1cac498ae$var$xUc(a, b);
        } else $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$fTc, j);
    }
}
function $61de1ee1cac498ae$var$Dbc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    h = 0;
    o = 0;
    i = $61de1ee1cac498ae$var$tlb(a.f, a.f.length);
    f = a.d;
    g = a.i;
    d = a.a;
    e = a.b;
    do {
        n = 0;
        for(k = new $61de1ee1cac498ae$var$olb(a.p); k.a < k.c.c.length;){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
            m = $61de1ee1cac498ae$var$Cbc(a, j);
            c = true;
            (a.q == ($61de1ee1cac498ae$var$kAc(), $61de1ee1cac498ae$var$dAc) || a.q == $61de1ee1cac498ae$var$gAc) && (c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(m.b)));
            if ($61de1ee1cac498ae$var$BD(m.a, 19).a < 0 && c) {
                ++n;
                i = $61de1ee1cac498ae$var$tlb(a.f, a.f.length);
                a.d = a.d + $61de1ee1cac498ae$var$BD(m.a, 19).a;
                o += f - a.d;
                f = a.d + $61de1ee1cac498ae$var$BD(m.a, 19).a;
                g = a.i;
                d = $61de1ee1cac498ae$var$Mu(a.a);
                e = $61de1ee1cac498ae$var$Mu(a.b);
            } else {
                a.f = $61de1ee1cac498ae$var$tlb(i, i.length);
                a.d = f;
                a.a = ($61de1ee1cac498ae$var$Qb(d), d ? new $61de1ee1cac498ae$var$Tkb(d) : $61de1ee1cac498ae$var$Nu(new $61de1ee1cac498ae$var$olb(d)));
                a.b = ($61de1ee1cac498ae$var$Qb(e), e ? new $61de1ee1cac498ae$var$Tkb(e) : $61de1ee1cac498ae$var$Nu(new $61de1ee1cac498ae$var$olb(e)));
                a.i = g;
            }
        }
        ++h;
        l = n != 0 && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b.Kb(new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(o), $61de1ee1cac498ae$var$meb(h)))));
    }while (l);
}
function $61de1ee1cac498ae$var$lYc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    g = a.f;
    m = b.f;
    h = g == ($61de1ee1cac498ae$var$k$c(), $61de1ee1cac498ae$var$f$c) || g == $61de1ee1cac498ae$var$h$c;
    n = m == $61de1ee1cac498ae$var$f$c || m == $61de1ee1cac498ae$var$h$c;
    i = g == $61de1ee1cac498ae$var$g$c || g == $61de1ee1cac498ae$var$i$c;
    o = m == $61de1ee1cac498ae$var$g$c || m == $61de1ee1cac498ae$var$i$c;
    j = g == $61de1ee1cac498ae$var$g$c || g == $61de1ee1cac498ae$var$f$c;
    p = m == $61de1ee1cac498ae$var$g$c || m == $61de1ee1cac498ae$var$f$c;
    if (h && n) return a.f == $61de1ee1cac498ae$var$h$c ? a : b;
    else if (i && o) return a.f == $61de1ee1cac498ae$var$i$c ? a : b;
    else if (j && p) {
        if (g == $61de1ee1cac498ae$var$g$c) {
            l = a;
            k = b;
        } else {
            l = b;
            k = a;
        }
        f = (q = c.j + c.f, r = l.e + d.f, s = $61de1ee1cac498ae$var$$wnd.Math.max(q, r), t = s - $61de1ee1cac498ae$var$$wnd.Math.min(c.j, l.e), u = l.d + d.g - c.i, u * t);
        e = (v = c.i + c.g, w = k.d + d.g, A = $61de1ee1cac498ae$var$$wnd.Math.max(v, w), B = A - $61de1ee1cac498ae$var$$wnd.Math.min(c.i, k.d), C = k.e + d.f - c.j, B * C);
        return f <= e ? a.f == $61de1ee1cac498ae$var$g$c ? a : b : a.f == $61de1ee1cac498ae$var$f$c ? a : b;
    }
    return a;
}
function $61de1ee1cac498ae$var$wGb(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    k = a.e.a.c.length;
    for(g = new $61de1ee1cac498ae$var$olb(a.e.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 121);
        f.j = false;
    }
    a.i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, k, 15, 1);
    a.g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, k, 15, 1);
    a.n = new $61de1ee1cac498ae$var$Rkb;
    e = 0;
    l = new $61de1ee1cac498ae$var$Rkb;
    for(i = new $61de1ee1cac498ae$var$olb(a.e.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 121);
        h.d = e++;
        h.b.a.c.length == 0 && $61de1ee1cac498ae$var$Ekb(a.n, h);
        $61de1ee1cac498ae$var$Gkb(l, h.g);
    }
    b = 0;
    for(d = new $61de1ee1cac498ae$var$olb(l); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 213);
        c.c = b++;
        c.f = false;
    }
    j = l.c.length;
    if (a.b == null || a.b.length < j) {
        a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, j, 15, 1);
        a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, j, 16, 1);
    } else $61de1ee1cac498ae$var$Blb(a.c);
    a.d = l;
    a.p = new $61de1ee1cac498ae$var$Asb($61de1ee1cac498ae$var$Cv(a.d.c.length));
    a.j = 1;
}
function $61de1ee1cac498ae$var$sTb(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (b.e.c.length <= 1) return;
    a.f = b;
    a.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.f, ($61de1ee1cac498ae$var$bTb(), $61de1ee1cac498ae$var$SSb)), 379);
    a.g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.f, $61de1ee1cac498ae$var$WSb), 19).a;
    a.e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.f, $61de1ee1cac498ae$var$TSb)));
    a.c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.f, $61de1ee1cac498ae$var$RSb)));
    $61de1ee1cac498ae$var$it(a.b);
    for(e = new $61de1ee1cac498ae$var$olb(a.f.c); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 282);
        $61de1ee1cac498ae$var$ht(a.b, d.c, d, null);
        $61de1ee1cac498ae$var$ht(a.b, d.d, d, null);
    }
    h = a.f.e.c.length;
    a.a = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$UD, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$Vje
    ], [
        104,
        25
    ], 15, [
        h,
        h
    ], 2);
    for(j = new $61de1ee1cac498ae$var$olb(a.f.e); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 144);
        $61de1ee1cac498ae$var$oTb(a, i, a.a[i.b]);
    }
    a.i = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$UD, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$Vje
    ], [
        104,
        25
    ], 15, [
        h,
        h
    ], 2);
    for(f = 0; f < h; ++f)for(g = 0; g < h; ++g){
        c = a.a[f][g];
        k = 1 / (c * c);
        a.i[f][g] = k;
    }
}
function $61de1ee1cac498ae$var$Vfe(a) {
    var b, c, d, e;
    if (a.b == null || a.b.length <= 2) return;
    if (a.a) return;
    b = 0;
    e = 0;
    while(e < a.b.length){
        if (b != e) {
            a.b[b] = a.b[e++];
            a.b[b + 1] = a.b[e++];
        } else e += 2;
        c = a.b[b + 1];
        while(e < a.b.length){
            if (c + 1 < a.b[e]) break;
            if (c + 1 == a.b[e]) {
                a.b[b + 1] = a.b[e + 1];
                c = a.b[b + 1];
                e += 2;
            } else if (c >= a.b[e + 1]) e += 2;
            else if (c < a.b[e + 1]) {
                a.b[b + 1] = a.b[e + 1];
                c = a.b[b + 1];
                e += 2;
            } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Token#compactRanges(): Internel Error: [" + a.b[b] + "," + a.b[b + 1] + "] [" + a.b[e] + "," + a.b[e + 1] + "]"));
        }
        b += 2;
    }
    if (b != a.b.length) {
        d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b, 15, 1);
        $61de1ee1cac498ae$var$$fb(a.b, 0, d, 0, b);
        a.b = d;
    }
    a.a = true;
}
function $61de1ee1cac498ae$var$pZb(a, b) {
    var c, d, e, f, g, h, i;
    for(g = $61de1ee1cac498ae$var$Ec(a.a).Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 17);
        if (f.b.c.length > 0) {
            d = new $61de1ee1cac498ae$var$Tkb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.a, f), 21));
            $61de1ee1cac498ae$var$mmb();
            $61de1ee1cac498ae$var$Okb(d, new $61de1ee1cac498ae$var$EZb(b));
            e = new $61de1ee1cac498ae$var$Bib(f.b, 0);
            while(e.b < e.d.gc()){
                c = ($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), $61de1ee1cac498ae$var$BD(e.d.Xb(e.c = e.b++), 70));
                h = -1;
                switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc)), 272).g){
                    case 1:
                        h = d.c.length - 1;
                        break;
                    case 0:
                        h = $61de1ee1cac498ae$var$nZb(d);
                        break;
                    case 2:
                        h = 0;
                }
                if (h != -1) {
                    i = ($61de1ee1cac498ae$var$tCb(h, d.c.length), $61de1ee1cac498ae$var$BD(d.c[h], 243));
                    $61de1ee1cac498ae$var$Ekb(i.b.b, c);
                    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(i.b.c.i), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Grc));
                    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(i.b.c.i), $61de1ee1cac498ae$var$Ksc), 21).Fc($61de1ee1cac498ae$var$Erc);
                    $61de1ee1cac498ae$var$uib(e);
                    $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$btc, f);
                }
            }
        }
        $61de1ee1cac498ae$var$QZb(f, null);
        $61de1ee1cac498ae$var$RZb(f, null);
    }
}
function $61de1ee1cac498ae$var$FLb(a, b) {
    var c, d, e, f;
    c = new $61de1ee1cac498ae$var$KLb;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.f, 16)), c), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Eyb),
        $61de1ee1cac498ae$var$Dyb
    ]))), 21);
    e = d.gc();
    e = e == 2 ? 1 : 0;
    e == 1 && $61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$Hbb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb(d.Lc(), new $61de1ee1cac498ae$var$MLb), $61de1ee1cac498ae$var$Xyb($61de1ee1cac498ae$var$Aeb(0), new $61de1ee1cac498ae$var$Czb)), 162).a, 2), 0) && (e = 0);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.f, 16)), c), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$hzb, new $61de1ee1cac498ae$var$jzb, new $61de1ee1cac498ae$var$Gzb, new $61de1ee1cac498ae$var$Izb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        $61de1ee1cac498ae$var$Eyb,
        $61de1ee1cac498ae$var$Dyb
    ]))), 21);
    f = d.gc();
    f = f == 2 ? 1 : 0;
    f == 1 && $61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$Hbb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb(d.Lc(), new $61de1ee1cac498ae$var$OLb), $61de1ee1cac498ae$var$Xyb($61de1ee1cac498ae$var$Aeb(0), new $61de1ee1cac498ae$var$Czb)), 162).a, 2), 0) && (f = 0);
    if (e < f) return -1;
    if (e == f) return 0;
    return 1;
}
function $61de1ee1cac498ae$var$h6b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    j = new $61de1ee1cac498ae$var$Rkb;
    if (!$61de1ee1cac498ae$var$wNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Fsc))) return j;
    for(d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Fsc), 15).Kc(); d.Ob();){
        b = $61de1ee1cac498ae$var$BD(d.Pb(), 10);
        $61de1ee1cac498ae$var$g6b(b, a);
        j.c[j.c.length] = b;
    }
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        for(h = new $61de1ee1cac498ae$var$olb(e.a); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
            if (g.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) continue;
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$Gsc), 10);
            !!i && (k = new $61de1ee1cac498ae$var$H0b, $61de1ee1cac498ae$var$F0b(k, g), l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$Hsc), 61), $61de1ee1cac498ae$var$G0b(k, l), m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(i.j, 0), 11), n = new $61de1ee1cac498ae$var$UZb, $61de1ee1cac498ae$var$QZb(n, k), $61de1ee1cac498ae$var$RZb(n, m), undefined);
        }
    }
    for(c = new $61de1ee1cac498ae$var$olb(j); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 10);
        $61de1ee1cac498ae$var$$_b(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, a.b.c.length - 1), 29));
    }
    return j;
}
function $61de1ee1cac498ae$var$M1b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    b = $61de1ee1cac498ae$var$mpd(a);
    f = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$fxc))));
    k = 0;
    e = 0;
    for(j = new $61de1ee1cac498ae$var$Fyd((!a.e && (a.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 7, 4)), a.e)); j.e != j.i.gc();){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(j), 79);
        h = $61de1ee1cac498ae$var$Qld(i);
        g = h && f && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(i, $61de1ee1cac498ae$var$gxc)));
        m = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!i.c && (i.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, i, 5, 8)), i.c), 0), 82));
        h && g ? ++e : h && !g ? ++k : $61de1ee1cac498ae$var$Xod(m) == b || m == b ? ++e : ++k;
    }
    for(d = new $61de1ee1cac498ae$var$Fyd((!a.d && (a.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, a, 8, 5)), a.d)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 79);
        h = $61de1ee1cac498ae$var$Qld(c);
        g = h && f && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(c, $61de1ee1cac498ae$var$gxc)));
        l = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!c.b && (c.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 4, 7)), c.b), 0), 82));
        h && g ? ++k : h && !g ? ++e : $61de1ee1cac498ae$var$Xod(l) == b || l == b ? ++k : ++e;
    }
    return k - e;
}
function $61de1ee1cac498ae$var$ubc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    $61de1ee1cac498ae$var$Odd(b, "Edge splitting", 1);
    if (a.b.c.length <= 2) {
        $61de1ee1cac498ae$var$Qdd(b);
        return;
    }
    f = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    g = ($61de1ee1cac498ae$var$sCb(f.b < f.d.gc()), $61de1ee1cac498ae$var$BD(f.d.Xb(f.c = f.b++), 29));
    while(f.b < f.d.gc()){
        e = g;
        g = ($61de1ee1cac498ae$var$sCb(f.b < f.d.gc()), $61de1ee1cac498ae$var$BD(f.d.Xb(f.c = f.b++), 29));
        for(i = new $61de1ee1cac498ae$var$olb(e.a); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            for(k = new $61de1ee1cac498ae$var$olb(h.j); k.a < k.c.c.length;){
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 11);
                for(d = new $61de1ee1cac498ae$var$olb(j.g); d.a < d.c.c.length;){
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 17);
                    m = c.d;
                    l = m.i.c;
                    l != e && l != g && $61de1ee1cac498ae$var$zbc(c, (n = new $61de1ee1cac498ae$var$b0b(a), $61de1ee1cac498ae$var$__b(n, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b)), $61de1ee1cac498ae$var$yNb(n, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), c), $61de1ee1cac498ae$var$yNb(n, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd)), $61de1ee1cac498ae$var$$_b(n, g), n));
                }
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$MTb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    h = b.p != null && !b.b;
    h || $61de1ee1cac498ae$var$Odd(b, $61de1ee1cac498ae$var$kme, 1);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$itc)), 15);
    g = 1 / c.gc();
    if (b.n) {
        $61de1ee1cac498ae$var$Sdd(b, "ELK Layered uses the following " + c.gc() + " modules:");
        n = 0;
        for(m = c.Kc(); m.Ob();){
            k = $61de1ee1cac498ae$var$BD(m.Pb(), 51);
            d = (n < 10 ? "0" : "") + n++;
            $61de1ee1cac498ae$var$Sdd(b, "   Slot " + d + ": " + $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$rb(k)));
        }
    }
    o = 0;
    for(l = c.Kc(); l.Ob();){
        k = $61de1ee1cac498ae$var$BD(l.Pb(), 51);
        k.pf(a, $61de1ee1cac498ae$var$Udd(b, g));
        ++o;
    }
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        $61de1ee1cac498ae$var$Gkb(a.a, e.a);
        e.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    }
    for(j = new $61de1ee1cac498ae$var$olb(a.a); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        $61de1ee1cac498ae$var$$_b(i, null);
    }
    a.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    h || $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$kJc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Bxc))));
    v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Ayc), 19).a;
    m = 4;
    e = 3;
    w = 20 / v;
    n = false;
    i = 0;
    g = $61de1ee1cac498ae$var$Ohe;
    do {
        f = i != 1;
        l = i != 0;
        A = 0;
        for(q = a.a, s = 0, u = q.length; s < u; ++s){
            o = q[s];
            o.f = null;
            $61de1ee1cac498ae$var$lJc(a, o, f, l, d);
            A += $61de1ee1cac498ae$var$$wnd.Math.abs(o.a);
        }
        do h = $61de1ee1cac498ae$var$pJc(a, b);
        while (h);
        for(p = a.a, r = 0, t = p.length; r < t; ++r){
            o = p[r];
            c = $61de1ee1cac498ae$var$xJc(o).a;
            if (c != 0) for(k = new $61de1ee1cac498ae$var$olb(o.e); k.a < k.c.c.length;){
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
                j.n.b += c;
            }
        }
        if (i == 0 || i == 1) {
            --m;
            if (m <= 0 && (A < g || -m > v)) {
                i = 2;
                g = $61de1ee1cac498ae$var$Ohe;
            } else if (i == 0) {
                i = 1;
                g = A;
            } else {
                i = 0;
                g = A;
            }
        } else {
            n = A >= g || g - A < w;
            g = A;
            n && --e;
        }
    }while (!(n && e <= 0));
}
function $61de1ee1cac498ae$var$UCb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    o = new $61de1ee1cac498ae$var$Lqb;
    for(f = a.a.ec().Kc(); f.Ob();){
        d = $61de1ee1cac498ae$var$BD(f.Pb(), 168);
        $61de1ee1cac498ae$var$Rhb(o, d, c.Je(d));
    }
    g = ($61de1ee1cac498ae$var$Qb(a), a ? new $61de1ee1cac498ae$var$Tkb(a) : $61de1ee1cac498ae$var$Nu(a.a.ec().Kc()));
    $61de1ee1cac498ae$var$Okb(g, new $61de1ee1cac498ae$var$WCb(o));
    h = $61de1ee1cac498ae$var$Gx(g);
    i = new $61de1ee1cac498ae$var$hDb(b);
    n = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$jrb(n.f, b, i);
    while(h.a.gc() != 0){
        j = null;
        k = null;
        l = null;
        for(e = h.a.ec().Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 168);
            if ($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(o.f, d)))) <= $61de1ee1cac498ae$var$Pje) {
                if ($61de1ee1cac498ae$var$Mhb(n, d.a) && !$61de1ee1cac498ae$var$Mhb(n, d.b)) {
                    k = d.b;
                    l = d.a;
                    j = d;
                    break;
                }
                if ($61de1ee1cac498ae$var$Mhb(n, d.b)) {
                    if (!$61de1ee1cac498ae$var$Mhb(n, d.a)) {
                        k = d.a;
                        l = d.b;
                        j = d;
                        break;
                    }
                }
            }
        }
        if (!j) break;
        m = new $61de1ee1cac498ae$var$hDb(k);
        $61de1ee1cac498ae$var$Ekb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(n.f, l)), 221).a, m);
        $61de1ee1cac498ae$var$jrb(n.f, k, m);
        h.a.Bc(j);
    }
    return i;
}
function $61de1ee1cac498ae$var$UBc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    $61de1ee1cac498ae$var$Odd(c, "Depth-first cycle removal", 1);
    l = b.a;
    k = l.c.length;
    a.c = new $61de1ee1cac498ae$var$Rkb;
    a.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, k, 16, 1);
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, k, 16, 1);
    a.b = new $61de1ee1cac498ae$var$Rkb;
    g = 0;
    for(j = new $61de1ee1cac498ae$var$olb(l); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        i.p = g;
        $61de1ee1cac498ae$var$Qq($61de1ee1cac498ae$var$R_b(i)) && $61de1ee1cac498ae$var$Ekb(a.c, i);
        ++g;
    }
    for(n = new $61de1ee1cac498ae$var$olb(a.c); n.a < n.c.c.length;){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 10);
        $61de1ee1cac498ae$var$TBc(a, m);
    }
    for(f = 0; f < k; f++)if (!a.d[f]) {
        h = ($61de1ee1cac498ae$var$tCb(f, l.c.length), $61de1ee1cac498ae$var$BD(l.c[f], 10));
        $61de1ee1cac498ae$var$TBc(a, h);
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
        $61de1ee1cac498ae$var$PZb(d, true);
        $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Asc), ($61de1ee1cac498ae$var$Bcb(), true));
    }
    a.c = null;
    a.d = null;
    a.a = null;
    a.b = null;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$PSc(a, b) {
    var c, d, e, f, g, h, i;
    a.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    for(d = $61de1ee1cac498ae$var$Jsb(b.b, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 86);
        if (c.b.b == 0) {
            $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc), ($61de1ee1cac498ae$var$Bcb(), true));
            $61de1ee1cac498ae$var$Ekb(a.a, c);
        }
    }
    switch(a.a.c.length){
        case 0:
            e = new $61de1ee1cac498ae$var$XRc(0, b, "DUMMY_ROOT");
            $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc), ($61de1ee1cac498ae$var$Bcb(), true));
            $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$YSc, true);
            $61de1ee1cac498ae$var$Dsb(b.b, e);
            break;
        case 1:
            break;
        default:
            f = new $61de1ee1cac498ae$var$XRc(0, b, "SUPER_ROOT");
            for(h = new $61de1ee1cac498ae$var$olb(a.a); h.a < h.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 86);
                i = new $61de1ee1cac498ae$var$QRc(f, g);
                $61de1ee1cac498ae$var$yNb(i, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$YSc), ($61de1ee1cac498ae$var$Bcb(), true));
                $61de1ee1cac498ae$var$Dsb(f.a.a, i);
                $61de1ee1cac498ae$var$Dsb(f.d, i);
                $61de1ee1cac498ae$var$Dsb(g.b, i);
                $61de1ee1cac498ae$var$yNb(g, $61de1ee1cac498ae$var$jTc, false);
            }
            $61de1ee1cac498ae$var$yNb(f, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$jTc), ($61de1ee1cac498ae$var$Bcb(), true));
            $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$YSc, true);
            $61de1ee1cac498ae$var$Dsb(b.b, f);
    }
}
function $61de1ee1cac498ae$var$z6c(a, b) {
    $61de1ee1cac498ae$var$i6c();
    var c, d, e, f, g, h;
    f = b.c - (a.c + a.b);
    e = a.c - (b.c + b.b);
    g = a.d - (b.d + b.a);
    c = b.d - (a.d + a.a);
    d = $61de1ee1cac498ae$var$$wnd.Math.max(e, f);
    h = $61de1ee1cac498ae$var$$wnd.Math.max(g, c);
    $61de1ee1cac498ae$var$Iy();
    $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe);
    if (($61de1ee1cac498ae$var$$wnd.Math.abs(d) <= $61de1ee1cac498ae$var$Jqe || d == 0 || isNaN(d) && isNaN(0) ? 0 : d < 0 ? -1 : d > 0 ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(d), isNaN(0))) >= 0 ^ ($61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe), ($61de1ee1cac498ae$var$$wnd.Math.abs(h) <= $61de1ee1cac498ae$var$Jqe || h == 0 || isNaN(h) && isNaN(0) ? 0 : h < 0 ? -1 : h > 0 ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(h), isNaN(0))) >= 0)) return $61de1ee1cac498ae$var$$wnd.Math.max(h, d);
    $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe);
    if (($61de1ee1cac498ae$var$$wnd.Math.abs(d) <= $61de1ee1cac498ae$var$Jqe || d == 0 || isNaN(d) && isNaN(0) ? 0 : d < 0 ? -1 : d > 0 ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(d), isNaN(0))) > 0) return $61de1ee1cac498ae$var$$wnd.Math.sqrt(h * h + d * d);
    return -$61de1ee1cac498ae$var$$wnd.Math.sqrt(h * h + d * d);
}
function $61de1ee1cac498ae$var$Kge(a, b) {
    var c, d, e, f, g, h;
    if (!b) return;
    !a.a && (a.a = new $61de1ee1cac498ae$var$Wvb);
    if (a.e == 2) {
        $61de1ee1cac498ae$var$Tvb(a.a, b);
        return;
    }
    if (b.e == 1) {
        for(e = 0; e < b.em(); e++)$61de1ee1cac498ae$var$Kge(a, b.am(e));
        return;
    }
    h = a.a.a.c.length;
    if (h == 0) {
        $61de1ee1cac498ae$var$Tvb(a.a, b);
        return;
    }
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(a.a, h - 1), 117);
    if (!((g.e == 0 || g.e == 10) && (b.e == 0 || b.e == 10))) {
        $61de1ee1cac498ae$var$Tvb(a.a, b);
        return;
    }
    f = b.e == 0 ? 2 : b.bm().length;
    if (g.e == 0) {
        c = new $61de1ee1cac498ae$var$Ifb;
        d = g._l();
        d >= $61de1ee1cac498ae$var$Tje ? $61de1ee1cac498ae$var$Efb(c, $61de1ee1cac498ae$var$Tee(d)) : $61de1ee1cac498ae$var$Afb(c, d & $61de1ee1cac498ae$var$aje);
        g = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Hge(10, null, 0));
        $61de1ee1cac498ae$var$Vvb(a.a, g, h - 1);
    } else {
        c = (g.bm().length, new $61de1ee1cac498ae$var$Ifb);
        $61de1ee1cac498ae$var$Efb(c, g.bm());
    }
    if (b.e == 0) {
        d = b._l();
        d >= $61de1ee1cac498ae$var$Tje ? $61de1ee1cac498ae$var$Efb(c, $61de1ee1cac498ae$var$Tee(d)) : $61de1ee1cac498ae$var$Afb(c, d & $61de1ee1cac498ae$var$aje);
    } else $61de1ee1cac498ae$var$Efb(c, b.bm());
    $61de1ee1cac498ae$var$BD(g, 521).b = c.a;
}
function $61de1ee1cac498ae$var$rgb(a) {
    var b, c, d, e, f;
    if (a.g != null) return a.g;
    if (a.a < 32) {
        a.g = $61de1ee1cac498ae$var$rhb($61de1ee1cac498ae$var$Cbb(a.f), $61de1ee1cac498ae$var$QD(a.e));
        return a.g;
    }
    e = $61de1ee1cac498ae$var$shb((!a.c && (a.c = $61de1ee1cac498ae$var$fhb(a.f)), a.c), 0);
    if (a.e == 0) return e;
    b = (!a.c && (a.c = $61de1ee1cac498ae$var$fhb(a.f)), a.c).e < 0 ? 2 : 1;
    c = e.length;
    d = -a.e + c - b;
    f = new $61de1ee1cac498ae$var$Ufb;
    f.a += "" + e;
    if (a.e > 0 && d >= -6) {
        if (d >= 0) $61de1ee1cac498ae$var$Tfb(f, c - $61de1ee1cac498ae$var$QD(a.e), String.fromCharCode(46));
        else {
            f.a = $61de1ee1cac498ae$var$qfb(f.a, 0, b - 1) + "0." + $61de1ee1cac498ae$var$pfb(f.a, b - 1);
            $61de1ee1cac498ae$var$Tfb(f, b + 1, $61de1ee1cac498ae$var$zfb($61de1ee1cac498ae$var$egb, 0, -$61de1ee1cac498ae$var$QD(d) - 1));
        }
    } else {
        if (c - b >= 1) {
            $61de1ee1cac498ae$var$Tfb(f, b, String.fromCharCode(46));
            ++c;
        }
        $61de1ee1cac498ae$var$Tfb(f, c, String.fromCharCode(69));
        d > 0 && $61de1ee1cac498ae$var$Tfb(f, ++c, String.fromCharCode(43));
        $61de1ee1cac498ae$var$Tfb(f, ++c, "" + $61de1ee1cac498ae$var$Ubb($61de1ee1cac498ae$var$Cbb(d)));
    }
    a.g = f.a;
    return a.g;
}
function $61de1ee1cac498ae$var$npc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (c.dc()) return;
    h = 0;
    m = 0;
    d = c.Kc();
    o = $61de1ee1cac498ae$var$BD(d.Pb(), 19).a;
    while(h < b.f){
        if (h == o) {
            m = 0;
            d.Ob() ? o = $61de1ee1cac498ae$var$BD(d.Pb(), 19).a : o = b.f + 1;
        }
        if (h != m) {
            q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, h), 29);
            n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, m), 29);
            p = $61de1ee1cac498ae$var$Mu(q.a);
            for(l = new $61de1ee1cac498ae$var$olb(p); l.a < l.c.c.length;){
                k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 10);
                $61de1ee1cac498ae$var$Z_b(k, n.a.c.length, n);
                if (m == 0) {
                    g = $61de1ee1cac498ae$var$Mu($61de1ee1cac498ae$var$R_b(k));
                    for(f = new $61de1ee1cac498ae$var$olb(g); f.a < f.c.c.length;){
                        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                        $61de1ee1cac498ae$var$PZb(e, true);
                        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Asc), ($61de1ee1cac498ae$var$Bcb(), true));
                        $61de1ee1cac498ae$var$Noc(a, e, 1);
                    }
                }
            }
        }
        ++m;
        ++h;
    }
    i = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    while(i.b < i.d.gc()){
        j = ($61de1ee1cac498ae$var$sCb(i.b < i.d.gc()), $61de1ee1cac498ae$var$BD(i.d.Xb(i.c = i.b++), 29));
        j.a.c.length == 0 && $61de1ee1cac498ae$var$uib(i);
    }
}
function $61de1ee1cac498ae$var$xmc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    g = b.b;
    k = g.o;
    i = g.d;
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$c_b(g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$lyc))));
    e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$c_b(g, $61de1ee1cac498ae$var$nyc)));
    j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$c_b(g, $61de1ee1cac498ae$var$xyc)));
    h = new $61de1ee1cac498ae$var$L_b;
    $61de1ee1cac498ae$var$v_b(h, i.d, i.c, i.a, i.b);
    m = $61de1ee1cac498ae$var$tmc(b, d, e, j);
    for(r = new $61de1ee1cac498ae$var$olb(b.d); r.a < r.c.c.length;){
        q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(r), 101);
        for(o = q.f.a.ec().Kc(); o.Ob();){
            n = $61de1ee1cac498ae$var$BD(o.Pb(), 409);
            f = n.a;
            l = $61de1ee1cac498ae$var$rmc(n);
            c = (s = new $61de1ee1cac498ae$var$s7c, $61de1ee1cac498ae$var$pmc(n, n.c, m, s), $61de1ee1cac498ae$var$omc(n, l, m, s), $61de1ee1cac498ae$var$pmc(n, n.d, m, s), s);
            c = a.Uf(n, l, c);
            $61de1ee1cac498ae$var$Osb(f.a);
            $61de1ee1cac498ae$var$ye(f.a, c);
            $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c, 16)), new $61de1ee1cac498ae$var$Bmc(k, h));
        }
        p = q.i;
        if (p) {
            $61de1ee1cac498ae$var$wmc(q, p, m, e);
            t = new $61de1ee1cac498ae$var$g7c(p.g);
            $61de1ee1cac498ae$var$ymc(k, h, t);
            $61de1ee1cac498ae$var$P6c(t, p.j);
            $61de1ee1cac498ae$var$ymc(k, h, t);
        }
    }
    $61de1ee1cac498ae$var$v_b(i, h.d, h.c, h.a, h.b);
}
function $61de1ee1cac498ae$var$rgc(a, b, c) {
    var d, e, f;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$swc)), 275);
    if (e == ($61de1ee1cac498ae$var$yrc(), $61de1ee1cac498ae$var$wrc)) return;
    $61de1ee1cac498ae$var$Odd(c, "Horizontal Compaction", 1);
    a.a = b;
    f = new $61de1ee1cac498ae$var$Ygc;
    d = new $61de1ee1cac498ae$var$cEb((f.d = b, f.c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f.d, $61de1ee1cac498ae$var$Swc), 218), $61de1ee1cac498ae$var$Pgc(f), $61de1ee1cac498ae$var$Wgc(f), $61de1ee1cac498ae$var$Vgc(f), f.a));
    $61de1ee1cac498ae$var$aEb(d, a.b);
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$rwc), 422).g){
        case 1:
            $61de1ee1cac498ae$var$$Db(d, new $61de1ee1cac498ae$var$jfc(a.a));
            break;
        default:
            $61de1ee1cac498ae$var$$Db(d, ($61de1ee1cac498ae$var$ODb(), $61de1ee1cac498ae$var$MDb));
    }
    switch(e.g){
        case 1:
            $61de1ee1cac498ae$var$TDb(d);
            break;
        case 2:
            $61de1ee1cac498ae$var$TDb($61de1ee1cac498ae$var$SDb(d, ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$bad)));
            break;
        case 3:
            $61de1ee1cac498ae$var$TDb($61de1ee1cac498ae$var$_Db($61de1ee1cac498ae$var$SDb($61de1ee1cac498ae$var$TDb(d), ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$bad)), new $61de1ee1cac498ae$var$Bgc));
            break;
        case 4:
            $61de1ee1cac498ae$var$TDb($61de1ee1cac498ae$var$_Db($61de1ee1cac498ae$var$SDb($61de1ee1cac498ae$var$TDb(d), ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$bad)), new $61de1ee1cac498ae$var$Dgc(f)));
            break;
        case 5:
            $61de1ee1cac498ae$var$TDb($61de1ee1cac498ae$var$ZDb(d, $61de1ee1cac498ae$var$pgc));
    }
    $61de1ee1cac498ae$var$SDb(d, ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad));
    d.e = true;
    $61de1ee1cac498ae$var$Mgc(f);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$mYc(a, b, c, d, e, f, g, h) {
    var i, j, k, l;
    i = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$z_, 1), $61de1ee1cac498ae$var$Uhe, 220, 0, [
        b,
        c,
        d,
        e
    ]));
    l = null;
    switch(a.b.g){
        case 1:
            l = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$o_, 1), $61de1ee1cac498ae$var$Uhe, 526, 0, [
                new $61de1ee1cac498ae$var$uYc,
                new $61de1ee1cac498ae$var$oYc,
                new $61de1ee1cac498ae$var$qYc
            ]));
            break;
        case 0:
            l = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$o_, 1), $61de1ee1cac498ae$var$Uhe, 526, 0, [
                new $61de1ee1cac498ae$var$qYc,
                new $61de1ee1cac498ae$var$oYc,
                new $61de1ee1cac498ae$var$uYc
            ]));
            break;
        case 2:
            l = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$o_, 1), $61de1ee1cac498ae$var$Uhe, 526, 0, [
                new $61de1ee1cac498ae$var$oYc,
                new $61de1ee1cac498ae$var$uYc,
                new $61de1ee1cac498ae$var$qYc
            ]));
    }
    for(k = new $61de1ee1cac498ae$var$olb(l); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 526);
        i.c.length > 1 && (i = j.mg(i, a.a, h));
    }
    if (i.c.length == 1) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(i, i.c.length - 1), 220);
    if (i.c.length == 2) return $61de1ee1cac498ae$var$lYc(($61de1ee1cac498ae$var$tCb(0, i.c.length), $61de1ee1cac498ae$var$BD(i.c[0], 220)), ($61de1ee1cac498ae$var$tCb(1, i.c.length), $61de1ee1cac498ae$var$BD(i.c[1], 220)), g, f);
    return null;
}
function $61de1ee1cac498ae$var$JNb(a) {
    var b, c, d, e, f, g;
    $61de1ee1cac498ae$var$Hkb(a.a, new $61de1ee1cac498ae$var$PNb);
    for(c = new $61de1ee1cac498ae$var$olb(a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 221);
        d = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD(a.b, 65).c), $61de1ee1cac498ae$var$BD(b.b, 65).c);
        if ($61de1ee1cac498ae$var$FNb) {
            g = $61de1ee1cac498ae$var$BD(a.b, 65).b;
            f = $61de1ee1cac498ae$var$BD(b.b, 65).b;
            if ($61de1ee1cac498ae$var$$wnd.Math.abs(d.a) >= $61de1ee1cac498ae$var$$wnd.Math.abs(d.b)) {
                d.b = 0;
                f.d + f.a > g.d && f.d < g.d + g.a && $61de1ee1cac498ae$var$$6c(d, $61de1ee1cac498ae$var$$wnd.Math.max(g.c - (f.c + f.b), f.c - (g.c + g.b)));
            } else {
                d.a = 0;
                f.c + f.b > g.c && f.c < g.c + g.b && $61de1ee1cac498ae$var$$6c(d, $61de1ee1cac498ae$var$$wnd.Math.max(g.d - (f.d + f.a), f.d - (g.d + g.a)));
            }
        } else $61de1ee1cac498ae$var$$6c(d, $61de1ee1cac498ae$var$_Nb($61de1ee1cac498ae$var$BD(a.b, 65), $61de1ee1cac498ae$var$BD(b.b, 65)));
        e = $61de1ee1cac498ae$var$$wnd.Math.sqrt(d.a * d.a + d.b * d.b);
        e = $61de1ee1cac498ae$var$LNb($61de1ee1cac498ae$var$GNb, b, e, d);
        $61de1ee1cac498ae$var$$6c(d, e);
        $61de1ee1cac498ae$var$$Nb($61de1ee1cac498ae$var$BD(b.b, 65), d);
        $61de1ee1cac498ae$var$Hkb(b.a, new $61de1ee1cac498ae$var$RNb(d));
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GNb.b, 65);
        $61de1ee1cac498ae$var$KNb($61de1ee1cac498ae$var$GNb, $61de1ee1cac498ae$var$HNb, b);
    }
}
function $61de1ee1cac498ae$var$VJc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
    a.f = new $61de1ee1cac498ae$var$KFb;
    j = 0;
    e = 0;
    for(g = new $61de1ee1cac498ae$var$olb(a.e.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        for(i = new $61de1ee1cac498ae$var$olb(f.a); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            h.p = j++;
            for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 17);
                c.p = e++;
            }
            b = $61de1ee1cac498ae$var$bKc(h);
            for(m = new $61de1ee1cac498ae$var$olb(h.j); m.a < m.c.c.length;){
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 11);
                if (b) {
                    o = l.a.b;
                    if (o != $61de1ee1cac498ae$var$$wnd.Math.floor(o)) {
                        k = o - $61de1ee1cac498ae$var$Sbb($61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$$wnd.Math.round(o)));
                        l.a.b -= k;
                    }
                }
                n = l.n.b + l.a.b;
                if (n != $61de1ee1cac498ae$var$$wnd.Math.floor(n)) {
                    k = n - $61de1ee1cac498ae$var$Sbb($61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$$wnd.Math.round(n)));
                    l.n.b -= k;
                }
            }
        }
    }
    a.g = j;
    a.b = e;
    a.i = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$xY, $61de1ee1cac498ae$var$Uhe, 401, j, 0, 1);
    a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$wY, $61de1ee1cac498ae$var$Uhe, 649, e, 0, 1);
    a.d.a.$b();
}
function $61de1ee1cac498ae$var$Uxd(a) {
    var b, c, d, e, f, g, h, i, j;
    if (a.ej()) {
        i = a.fj();
        if (a.i > 0) {
            b = new $61de1ee1cac498ae$var$_zd(a.i, a.g);
            c = a.i;
            f = c < 100 ? null : new $61de1ee1cac498ae$var$Ixd(c);
            if (a.ij()) for(d = 0; d < a.i; ++d){
                g = a.g[d];
                f = a.kj(g, f);
            }
            $61de1ee1cac498ae$var$oud(a);
            e = c == 1 ? a.Zi(4, $61de1ee1cac498ae$var$qud(b, 0), null, 0, i) : a.Zi(6, b, null, -1, i);
            if (a.bj()) {
                for(d = new $61de1ee1cac498ae$var$$yd(b); d.e != d.i.gc();)f = a.dj($61de1ee1cac498ae$var$Zyd(d), f);
                if (!f) a.$i(e);
                else {
                    f.Ei(e);
                    f.Fi();
                }
            } else if (!f) a.$i(e);
            else {
                f.Ei(e);
                f.Fi();
            }
        } else {
            $61de1ee1cac498ae$var$oud(a);
            a.$i(a.Zi(6, ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb), null, -1, i));
        }
    } else if (a.bj()) {
        if (a.i > 0) {
            h = a.g;
            j = a.i;
            $61de1ee1cac498ae$var$oud(a);
            f = j < 100 ? null : new $61de1ee1cac498ae$var$Ixd(j);
            for(d = 0; d < j; ++d){
                g = h[d];
                f = a.dj(g, f);
            }
            !!f && f.Fi();
        } else $61de1ee1cac498ae$var$oud(a);
    } else $61de1ee1cac498ae$var$oud(a);
}
function $61de1ee1cac498ae$var$ZQc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    $61de1ee1cac498ae$var$TQc(this);
    c == ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$DQc) ? $61de1ee1cac498ae$var$Qqb(this.r, a) : $61de1ee1cac498ae$var$Qqb(this.w, a);
    k = $61de1ee1cac498ae$var$Pje;
    j = $61de1ee1cac498ae$var$Qje;
    for(g = b.a.ec().Kc(); g.Ob();){
        e = $61de1ee1cac498ae$var$BD(g.Pb(), 46);
        h = $61de1ee1cac498ae$var$BD(e.a, 455);
        d = $61de1ee1cac498ae$var$BD(e.b, 17);
        i = d.c;
        i == a && (i = d.d);
        h == $61de1ee1cac498ae$var$DQc ? $61de1ee1cac498ae$var$Qqb(this.r, i) : $61de1ee1cac498ae$var$Qqb(this.w, i);
        m = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Lcd).Hc(i.j) ? $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$qtc)))) : $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).b;
        k = $61de1ee1cac498ae$var$$wnd.Math.min(k, m);
        j = $61de1ee1cac498ae$var$$wnd.Math.max(j, m);
    }
    l = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Lcd).Hc(a.j) ? $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$qtc)))) : $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        a.i.n,
        a.n,
        a.a
    ])).b;
    $61de1ee1cac498ae$var$XQc(this, l, k, j);
    for(f = b.a.ec().Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 46);
        $61de1ee1cac498ae$var$UQc(this, $61de1ee1cac498ae$var$BD(e.b, 17));
    }
    this.o = false;
}
function $61de1ee1cac498ae$var$gD(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    c = a.l & 8191;
    d = a.l >> 13 | (a.m & 15) << 9;
    e = a.m >> 4 & 8191;
    f = a.m >> 17 | (a.h & 255) << 5;
    g = (a.h & 1048320) >> 8;
    h = b.l & 8191;
    i = b.l >> 13 | (b.m & 15) << 9;
    j = b.m >> 4 & 8191;
    k = b.m >> 17 | (b.h & 255) << 5;
    l = (b.h & 1048320) >> 8;
    B = c * h;
    C = d * h;
    D = e * h;
    F = f * h;
    G = g * h;
    if (i != 0) {
        C += c * i;
        D += d * i;
        F += e * i;
        G += f * i;
    }
    if (j != 0) {
        D += c * j;
        F += d * j;
        G += e * j;
    }
    if (k != 0) {
        F += c * k;
        G += d * k;
    }
    l != 0 && (G += c * l);
    n = B & $61de1ee1cac498ae$var$Eje;
    o = (C & 511) << 13;
    m = n + o;
    q = B >> 22;
    r = C >> 9;
    s = (D & 262143) << 4;
    t = (F & 31) << 17;
    p = q + r + s + t;
    v = D >> 18;
    w = F >> 5;
    A = (G & 4095) << 8;
    u = v + w + A;
    p += m >> 22;
    m &= $61de1ee1cac498ae$var$Eje;
    u += p >> 22;
    p &= $61de1ee1cac498ae$var$Eje;
    u &= $61de1ee1cac498ae$var$Fje;
    return $61de1ee1cac498ae$var$TC(m, p, u);
}
function $61de1ee1cac498ae$var$o7b(a) {
    var b, c, d, e, f, g, h;
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, 0), 11);
    if (h.g.c.length != 0 && h.e.c.length != 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Interactive layout does not support NORTH/SOUTH ports with incoming _and_ outgoing edges."));
    if (h.g.c.length != 0) {
        f = $61de1ee1cac498ae$var$Pje;
        for(c = new $61de1ee1cac498ae$var$olb(h.g); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 17);
            g = b.d.i;
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$txc)), 142);
            f = $61de1ee1cac498ae$var$$wnd.Math.min(f, g.n.a - d.b);
        }
        return new $61de1ee1cac498ae$var$cc($61de1ee1cac498ae$var$Qb(f));
    }
    if (h.e.c.length != 0) {
        e = $61de1ee1cac498ae$var$Qje;
        for(c = new $61de1ee1cac498ae$var$olb(h.e); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 17);
            g = b.c.i;
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$txc)), 142);
            e = $61de1ee1cac498ae$var$$wnd.Math.max(e, g.n.a + g.o.a + d.c);
        }
        return new $61de1ee1cac498ae$var$cc($61de1ee1cac498ae$var$Qb(e));
    }
    return $61de1ee1cac498ae$var$wb(), $61de1ee1cac498ae$var$wb(), $61de1ee1cac498ae$var$vb;
}
function $61de1ee1cac498ae$var$ELd(a, b) {
    var c, d, e, f, g, h, i;
    if (a.Fk()) {
        if (a.i > 4) {
            if (a.wj(b)) {
                if (a.rk()) {
                    e = $61de1ee1cac498ae$var$BD(b, 49);
                    d = e.Ug();
                    i = d == a.e && (a.Dk() ? e.Og(e.Vg(), a.zk()) == a.Ak() : -1 - e.Vg() == a.aj());
                    if (a.Ek() && !i && !d && !!e.Zg()) for(f = 0; f < a.i; ++f){
                        c = a.Gk($61de1ee1cac498ae$var$BD(a.g[f], 56));
                        if ($61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD(b)) return true;
                    }
                    return i;
                } else if (a.Dk() && !a.Ck()) {
                    g = $61de1ee1cac498ae$var$BD(b, 56).ah($61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD(a.ak(), 18)));
                    if ($61de1ee1cac498ae$var$PD(g) === $61de1ee1cac498ae$var$PD(a.e)) return true;
                    else if (g == null || !$61de1ee1cac498ae$var$BD(g, 56).kh()) return false;
                }
            } else return false;
        }
        h = $61de1ee1cac498ae$var$pud(a, b);
        if (a.Ek() && !h) for(f = 0; f < a.i; ++f){
            e = a.Gk($61de1ee1cac498ae$var$BD(a.g[f], 56));
            if ($61de1ee1cac498ae$var$PD(e) === $61de1ee1cac498ae$var$PD(b)) return true;
        }
        return h;
    } else return $61de1ee1cac498ae$var$pud(a, b);
}
function $61de1ee1cac498ae$var$mHc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    k = new $61de1ee1cac498ae$var$Rkb;
    m = new $61de1ee1cac498ae$var$Tqb;
    g = b.b;
    for(e = 0; e < g.c.length; e++){
        j = ($61de1ee1cac498ae$var$tCb(e, g.c.length), $61de1ee1cac498ae$var$BD(g.c[e], 29)).a;
        k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        for(f = 0; f < j.c.length; f++){
            h = a.a[e][f];
            h.p = f;
            h.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b) && (k.c[k.c.length] = h);
            $61de1ee1cac498ae$var$Nkb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.b, e), 29).a, f, h);
            h.j.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            $61de1ee1cac498ae$var$Gkb(h.j, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, e), 15).Xb(f), 14));
            $61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98)) || $61de1ee1cac498ae$var$yNb(h, $61de1ee1cac498ae$var$Vxc, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$Zbd));
        }
        for(d = new $61de1ee1cac498ae$var$olb(k); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
            l = $61de1ee1cac498ae$var$kHc(c);
            m.a.zc(l, m);
            m.a.zc(c, m);
        }
    }
    for(i = m.a.ec().Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 10);
        $61de1ee1cac498ae$var$mmb();
        $61de1ee1cac498ae$var$Okb(h.j, ($61de1ee1cac498ae$var$Occ(), $61de1ee1cac498ae$var$Icc));
        h.i = true;
        $61de1ee1cac498ae$var$N_b(h);
    }
}
function $61de1ee1cac498ae$var$g6b(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, 0), 11);
    k == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? $61de1ee1cac498ae$var$G0b(d, $61de1ee1cac498ae$var$Rcd) : k == $61de1ee1cac498ae$var$Rcd && $61de1ee1cac498ae$var$G0b(d, $61de1ee1cac498ae$var$Acd);
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fxc)), 174).Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd))) {
        i = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$tyc)));
        j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$uyc)));
        g = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ryc)));
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Yxc), 21);
        if (h.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd))) {
            c = j;
            l = a.o.a / 2 - d.n.a;
            for(f = new $61de1ee1cac498ae$var$olb(d.f); f.a < f.c.c.length;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 70);
                e.n.b = c;
                e.n.a = l - e.o.a / 2;
                c += e.o.b + g;
            }
        } else if (h.Hc($61de1ee1cac498ae$var$pcd)) for(f = new $61de1ee1cac498ae$var$olb(d.f); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 70);
            e.n.a = i + a.o.a - d.n.a;
        }
        $61de1ee1cac498ae$var$WGb(new $61de1ee1cac498ae$var$YGb(($61de1ee1cac498ae$var$a$b(), new $61de1ee1cac498ae$var$l$b(b, false, false, new $61de1ee1cac498ae$var$T$b))), new $61de1ee1cac498ae$var$x$b(null, a, false));
    }
}
function $61de1ee1cac498ae$var$Ugc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (b.c.length == 0) return;
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Mlb(b.c, b.c.length, null);
    e = new $61de1ee1cac498ae$var$olb(b);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 145);
    while(e.a < e.c.c.length){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 145);
        if ($61de1ee1cac498ae$var$ADb(d.e.c, c.e.c) && !($61de1ee1cac498ae$var$DDb($61de1ee1cac498ae$var$B6c(d.e).b, c.e.d) || $61de1ee1cac498ae$var$DDb($61de1ee1cac498ae$var$B6c(c.e).b, d.e.d))) d = ($61de1ee1cac498ae$var$Gkb(d.k, c.k), $61de1ee1cac498ae$var$Gkb(d.b, c.b), $61de1ee1cac498ae$var$Gkb(d.c, c.c), $61de1ee1cac498ae$var$ye(d.i, c.i), $61de1ee1cac498ae$var$Gkb(d.d, c.d), $61de1ee1cac498ae$var$Gkb(d.j, c.j), f = $61de1ee1cac498ae$var$$wnd.Math.min(d.e.c, c.e.c), g = $61de1ee1cac498ae$var$$wnd.Math.min(d.e.d, c.e.d), h = $61de1ee1cac498ae$var$$wnd.Math.max(d.e.c + d.e.b, c.e.c + c.e.b), i = h - f, j = $61de1ee1cac498ae$var$$wnd.Math.max(d.e.d + d.e.a, c.e.d + c.e.a), k = j - g, $61de1ee1cac498ae$var$G6c(d.e, f, g, i, k), $61de1ee1cac498ae$var$hEb(d.f, c.f), !d.a && (d.a = c.a), $61de1ee1cac498ae$var$Gkb(d.g, c.g), $61de1ee1cac498ae$var$Ekb(d.g, c), d);
        else {
            $61de1ee1cac498ae$var$Xgc(a, d);
            d = c;
        }
    }
    $61de1ee1cac498ae$var$Xgc(a, d);
}
function $61de1ee1cac498ae$var$e_b(a, b, c, d) {
    var e, f, g, h, i, j;
    h = a.j;
    if (h == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd) && b != ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$bcd) && b != ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$ccd)) {
        h = $61de1ee1cac498ae$var$W$b(a, c);
        $61de1ee1cac498ae$var$G0b(a, h);
        !(!a.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : a.q)._b(($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Uxc)) && h != $61de1ee1cac498ae$var$Scd && (a.n.a != 0 || a.n.b != 0) && $61de1ee1cac498ae$var$yNb(a, $61de1ee1cac498ae$var$Uxc, $61de1ee1cac498ae$var$V$b(a, h));
    }
    if (b == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$_bd)) {
        j = 0;
        switch(h.g){
            case 1:
            case 3:
                f = a.i.o.a;
                f > 0 && (j = a.n.a / f);
                break;
            case 2:
            case 4:
                e = a.i.o.b;
                e > 0 && (j = a.n.b / e);
        }
        $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$htc), j);
    }
    i = a.o;
    g = a.a;
    if (d) {
        g.a = d.a;
        g.b = d.b;
        a.d = true;
    } else if (b != $61de1ee1cac498ae$var$bcd && b != $61de1ee1cac498ae$var$ccd && h != $61de1ee1cac498ae$var$Scd) switch(h.g){
        case 1:
            g.a = i.a / 2;
            break;
        case 2:
            g.a = i.a;
            g.b = i.b / 2;
            break;
        case 3:
            g.a = i.a / 2;
            g.b = i.b;
            break;
        case 4:
            g.b = i.b / 2;
    }
    else {
        g.a = i.a / 2;
        g.b = i.b / 2;
    }
}
function $61de1ee1cac498ae$var$vwd(a) {
    var b, c, d, e, f, g, h, i, j, k;
    if (a.ej()) {
        k = a.Vi();
        i = a.fj();
        if (k > 0) {
            b = new $61de1ee1cac498ae$var$Aud(a.Gi());
            c = k;
            f = c < 100 ? null : new $61de1ee1cac498ae$var$Ixd(c);
            $61de1ee1cac498ae$var$Cvd(a, c, b.g);
            e = c == 1 ? a.Zi(4, $61de1ee1cac498ae$var$qud(b, 0), null, 0, i) : a.Zi(6, b, null, -1, i);
            if (a.bj()) {
                for(d = new $61de1ee1cac498ae$var$Fyd(b); d.e != d.i.gc();)f = a.dj($61de1ee1cac498ae$var$Dyd(d), f);
                if (!f) a.$i(e);
                else {
                    f.Ei(e);
                    f.Fi();
                }
            } else if (!f) a.$i(e);
            else {
                f.Ei(e);
                f.Fi();
            }
        } else {
            $61de1ee1cac498ae$var$Cvd(a, a.Vi(), a.Wi());
            a.$i(a.Zi(6, ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb), null, -1, i));
        }
    } else if (a.bj()) {
        k = a.Vi();
        if (k > 0) {
            h = a.Wi();
            j = k;
            $61de1ee1cac498ae$var$Cvd(a, k, h);
            f = j < 100 ? null : new $61de1ee1cac498ae$var$Ixd(j);
            for(d = 0; d < j; ++d){
                g = h[d];
                f = a.dj(g, f);
            }
            !!f && f.Fi();
        } else $61de1ee1cac498ae$var$Cvd(a, a.Vi(), a.Wi());
    } else $61de1ee1cac498ae$var$Cvd(a, a.Vi(), a.Wi());
}
function $61de1ee1cac498ae$var$LEc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    for(h = new $61de1ee1cac498ae$var$olb(b); h.a < h.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 233);
        f.e = null;
        f.c = 0;
    }
    i = null;
    for(g = new $61de1ee1cac498ae$var$olb(b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 233);
        l = f.d[0];
        if (c && l.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) continue;
        for(n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(l, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Qsc)), 15).Kc(); n.Ob();){
            m = $61de1ee1cac498ae$var$BD(n.Pb(), 10);
            if (!c || m.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) {
                (!f.e && (f.e = new $61de1ee1cac498ae$var$Rkb), f.e).Fc(a.b[m.c.p][m.p]);
                ++a.b[m.c.p][m.p].c;
            }
        }
        if (!c && l.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) {
            if (i) for(k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.d, i), 21).Kc(); k.Ob();){
                j = $61de1ee1cac498ae$var$BD(k.Pb(), 10);
                for(e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.d, l), 21).Kc(); e.Ob();){
                    d = $61de1ee1cac498ae$var$BD(e.Pb(), 10);
                    $61de1ee1cac498ae$var$YEc(a.b[j.c.p][j.p]).Fc(a.b[d.c.p][d.p]);
                    ++a.b[d.c.p][d.p].c;
                }
            }
            i = l;
        }
    }
}
function $61de1ee1cac498ae$var$OHc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    c = 0;
    k = new $61de1ee1cac498ae$var$Rkb;
    for(h = new $61de1ee1cac498ae$var$olb(b); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        $61de1ee1cac498ae$var$AHc(a.b, a.d[g.p]);
        k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        switch(g.i.k.g){
            case 0:
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
                $61de1ee1cac498ae$var$Hkb(d.j, new $61de1ee1cac498ae$var$xIc(k));
                break;
            case 1:
                $61de1ee1cac498ae$var$Ctb($61de1ee1cac498ae$var$KAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(g.i.j, 16)), new $61de1ee1cac498ae$var$zIc(g))), new $61de1ee1cac498ae$var$CIc(k));
                break;
            case 3:
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
                $61de1ee1cac498ae$var$Ekb(k, new $61de1ee1cac498ae$var$vgd(e, $61de1ee1cac498ae$var$meb(g.e.c.length + g.g.c.length)));
        }
        for(j = new $61de1ee1cac498ae$var$olb(k); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 46);
            f = $61de1ee1cac498ae$var$aIc(a, $61de1ee1cac498ae$var$BD(i.a, 11));
            if (f > a.d[g.p]) {
                c += $61de1ee1cac498ae$var$zHc(a.b, f) * $61de1ee1cac498ae$var$BD(i.b, 19).a;
                $61de1ee1cac498ae$var$Wjb(a.a, $61de1ee1cac498ae$var$meb(f));
            }
        }
        while(!$61de1ee1cac498ae$var$akb(a.a))$61de1ee1cac498ae$var$xHc(a.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$fkb(a.a), 19).a);
    }
    return c;
}
function $61de1ee1cac498ae$var$eed(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q;
    l = new $61de1ee1cac498ae$var$g7c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$X7c(), $61de1ee1cac498ae$var$R7c)), 8));
    l.a = $61de1ee1cac498ae$var$$wnd.Math.max(l.a - c.b - c.c, 0);
    l.b = $61de1ee1cac498ae$var$$wnd.Math.max(l.b - c.d - c.a, 0);
    e = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$L7c));
    (e == null || ($61de1ee1cac498ae$var$uCb(e), e) <= 0) && (e = 1.3);
    h = new $61de1ee1cac498ae$var$Rkb;
    for(o = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); o.e != o.i.gc();){
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(o), 33);
        g = new $61de1ee1cac498ae$var$xed(n);
        h.c[h.c.length] = g;
    }
    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$M7c), 311);
    switch(m.g){
        case 3:
            q = $61de1ee1cac498ae$var$bed(h, b, l.a, l.b, (j = d, $61de1ee1cac498ae$var$uCb(e), e, j));
            break;
        case 1:
            q = $61de1ee1cac498ae$var$aed(h, b, l.a, l.b, (k = d, $61de1ee1cac498ae$var$uCb(e), e, k));
            break;
        default:
            q = $61de1ee1cac498ae$var$ced(h, b, l.a, l.b, (i = d, $61de1ee1cac498ae$var$uCb(e), e, i));
    }
    f = new $61de1ee1cac498ae$var$wed(q);
    p = $61de1ee1cac498ae$var$fed(f, b, c, l.a, l.b, d, ($61de1ee1cac498ae$var$uCb(e), e));
    $61de1ee1cac498ae$var$Afd(a, p.a, p.b, false, true);
}
function $61de1ee1cac498ae$var$vkc(a, b) {
    var c, d, e, f;
    c = b.b;
    f = new $61de1ee1cac498ae$var$Tkb(c.j);
    e = 0;
    d = c.j;
    d.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd), ($61de1ee1cac498ae$var$Fkc(), $61de1ee1cac498ae$var$Ekc)), 15), c);
    e = $61de1ee1cac498ae$var$ikc(f, e, new $61de1ee1cac498ae$var$blc, d);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$Dkc), 15), c);
    e = $61de1ee1cac498ae$var$ikc(f, e, new $61de1ee1cac498ae$var$dlc, d);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$Ckc), 15), c);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$Ekc), 15), c);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$Dkc), 15), c);
    e = $61de1ee1cac498ae$var$ikc(f, e, new $61de1ee1cac498ae$var$flc, d);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$Ckc), 15), c);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$Ekc), 15), c);
    e = $61de1ee1cac498ae$var$ikc(f, e, new $61de1ee1cac498ae$var$hlc, d);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$Dkc), 15), c);
    e = $61de1ee1cac498ae$var$ikc(f, e, new $61de1ee1cac498ae$var$jlc, d);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$Ckc), 15), c);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Tcd, $61de1ee1cac498ae$var$Ekc), 15), c);
    e = $61de1ee1cac498ae$var$ikc(f, e, new $61de1ee1cac498ae$var$Pkc, d);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Tcd, $61de1ee1cac498ae$var$Dkc), 15), c);
    $61de1ee1cac498ae$var$hkc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Si(a.b, $61de1ee1cac498ae$var$Tcd, $61de1ee1cac498ae$var$Ckc), 15), c);
}
function $61de1ee1cac498ae$var$nbc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    $61de1ee1cac498ae$var$Odd(b, "Layer size calculation", 1);
    k = $61de1ee1cac498ae$var$Pje;
    j = $61de1ee1cac498ae$var$Qje;
    e = false;
    for(h = new $61de1ee1cac498ae$var$olb(a.b); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 29);
        i = g.c;
        i.a = 0;
        i.b = 0;
        if (g.a.c.length == 0) continue;
        e = true;
        for(m = new $61de1ee1cac498ae$var$olb(g.a); m.a < m.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
            o = l.o;
            n = l.d;
            i.a = $61de1ee1cac498ae$var$$wnd.Math.max(i.a, o.a + n.b + n.c);
        }
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g.a, 0), 10);
        p = d.n.b - d.d.d;
        d.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) && (p -= $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$yyc)), 142).d);
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g.a, g.a.c.length - 1), 10);
        c = f.n.b + f.o.b + f.d.a;
        f.k == $61de1ee1cac498ae$var$e0b && (c += $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$yyc)), 142).a);
        i.b = c - p;
        k = $61de1ee1cac498ae$var$$wnd.Math.min(k, p);
        j = $61de1ee1cac498ae$var$$wnd.Math.max(j, c);
    }
    if (!e) {
        k = 0;
        j = 0;
    }
    a.f.b = j - k;
    a.c.b -= k;
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$h_b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    f = 0;
    g = 0;
    for(j = new $61de1ee1cac498ae$var$olb(a.a); j.a < j.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        f = $61de1ee1cac498ae$var$$wnd.Math.max(f, h.d.b);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(g, h.d.c);
    }
    for(i = new $61de1ee1cac498ae$var$olb(a.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mwc)), 248);
        switch(c.g){
            case 1:
                o = 0;
                break;
            case 2:
                o = 1;
                break;
            case 5:
                o = 0.5;
                break;
            default:
                d = 0;
                l = 0;
                for(n = new $61de1ee1cac498ae$var$olb(h.j); n.a < n.c.c.length;){
                    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 11);
                    m.e.c.length == 0 || ++d;
                    m.g.c.length == 0 || ++l;
                }
                d + l == 0 ? o = 0.5 : o = l / (d + l);
        }
        q = a.c;
        k = h.o.a;
        r = (q.a - k) * o;
        o > 0.5 ? r -= g * 2 * (o - 0.5) : o < 0.5 && (r += f * 2 * (0.5 - o));
        e = h.d.b;
        r < e && (r = e);
        p = h.d.c;
        r > q.a - p - k && (r = q.a - p - k);
        h.n.a = b + r;
    }
}
function $61de1ee1cac498ae$var$ced(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q;
    h = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, a.c.length, 15, 1);
    m = new $61de1ee1cac498ae$var$gub(new $61de1ee1cac498ae$var$Ned);
    $61de1ee1cac498ae$var$_tb(m, a);
    j = 0;
    p = new $61de1ee1cac498ae$var$Rkb;
    while(m.b.c.length != 0){
        g = $61de1ee1cac498ae$var$BD(m.b.c.length == 0 ? null : $61de1ee1cac498ae$var$Ikb(m.b, 0), 157);
        if (j > 1 && $61de1ee1cac498ae$var$red(g) * $61de1ee1cac498ae$var$qed(g) / 2 > h[0]) {
            f = 0;
            while(f < p.c.length - 1 && $61de1ee1cac498ae$var$red(g) * $61de1ee1cac498ae$var$qed(g) / 2 > h[f])++f;
            o = new $61de1ee1cac498ae$var$Jib(p, 0, f + 1);
            l = new $61de1ee1cac498ae$var$wed(o);
            k = $61de1ee1cac498ae$var$red(g) / $61de1ee1cac498ae$var$qed(g);
            i = $61de1ee1cac498ae$var$fed(l, b, new $61de1ee1cac498ae$var$p0b, c, d, e, k);
            $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(l.e), i);
            $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(m, l));
            n = new $61de1ee1cac498ae$var$Jib(p, f + 1, p.c.length);
            $61de1ee1cac498ae$var$_tb(m, n);
            p.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            j = 0;
            $61de1ee1cac498ae$var$Dlb(h, h.length, 0);
        } else {
            q = m.b.c.length == 0 ? null : $61de1ee1cac498ae$var$Ikb(m.b, 0);
            q != null && $61de1ee1cac498ae$var$fub(m, 0);
            j > 0 && (h[j] = h[j - 1]);
            h[j] += $61de1ee1cac498ae$var$red(g) * $61de1ee1cac498ae$var$qed(g);
            ++j;
            p.c[p.c.length] = g;
        }
    }
    return p;
}
function $61de1ee1cac498ae$var$Wac(a) {
    var b, c, d, e, f;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163);
    if (d == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc)) for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 17);
        if (!$61de1ee1cac498ae$var$Yac(b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c($61de1ee1cac498ae$var$Fne + $61de1ee1cac498ae$var$P_b(a) + "' has its layer constraint set to FIRST_SEPARATE, but has at least one incoming edge. " + "FIRST_SEPARATE nodes must not have incoming edges."));
    }
    else if (d == $61de1ee1cac498ae$var$Atc) for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
        if (!$61de1ee1cac498ae$var$Yac(e)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c($61de1ee1cac498ae$var$Fne + $61de1ee1cac498ae$var$P_b(a) + "' has its layer constraint set to LAST_SEPARATE, but has at least one outgoing edge. " + "LAST_SEPARATE nodes must not have outgoing edges."));
    }
}
function $61de1ee1cac498ae$var$C9b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    $61de1ee1cac498ae$var$Odd(b, "Label dummy removal", 1);
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$nyc))));
    e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ryc)));
    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Lwc), 103);
    for(i = new $61de1ee1cac498ae$var$olb(a.b); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 29);
        l = new $61de1ee1cac498ae$var$Bib(h.a, 0);
        while(l.b < l.d.gc()){
            k = ($61de1ee1cac498ae$var$sCb(l.b < l.d.gc()), $61de1ee1cac498ae$var$BD(l.d.Xb(l.c = l.b++), 10));
            if (k.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b)) {
                m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 17);
                o = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(m, $61de1ee1cac498ae$var$Zwc)));
                g = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(k, $61de1ee1cac498ae$var$Ssc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$obd));
                c = new $61de1ee1cac498ae$var$g7c(k.n);
                g && (c.b += o + d);
                f = new $61de1ee1cac498ae$var$f7c(k.o.a, k.o.b - o - d);
                n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, $61de1ee1cac498ae$var$ktc), 15);
                j == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$dad) || j == $61de1ee1cac498ae$var$_9c ? $61de1ee1cac498ae$var$B9b(n, c, e, f, g, j) : $61de1ee1cac498ae$var$A9b(n, c, e, f);
                $61de1ee1cac498ae$var$Gkb(m.b, n);
                $61de1ee1cac498ae$var$sbc(k, $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Swc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$xad)));
                $61de1ee1cac498ae$var$uib(l);
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$tZb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    i = new $61de1ee1cac498ae$var$Rkb;
    for(f = new $61de1ee1cac498ae$var$olb(b.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
        for(h = new $61de1ee1cac498ae$var$olb(e.j); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
            k = null;
            for(t = $61de1ee1cac498ae$var$k_b(g.g), u = 0, v = t.length; u < v; ++u){
                s = t[u];
                if (!$61de1ee1cac498ae$var$f_b(s.d.i, c)) {
                    r = $61de1ee1cac498ae$var$oZb(a, b, c, s, s.c, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc), k);
                    r != k && (i.c[i.c.length] = r);
                    r.c && (k = r);
                }
            }
            j = null;
            for(o = $61de1ee1cac498ae$var$k_b(g.e), p = 0, q = o.length; p < q; ++p){
                n = o[p];
                if (!$61de1ee1cac498ae$var$f_b(n.c.i, c)) {
                    r = $61de1ee1cac498ae$var$oZb(a, b, c, n, n.d, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc), j);
                    r != j && (i.c[i.c.length] = r);
                    r.c && (j = r);
                }
            }
        }
    }
    for(m = new $61de1ee1cac498ae$var$olb(i); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 441);
        $61de1ee1cac498ae$var$Jkb(b.a, l.a, 0) != -1 || $61de1ee1cac498ae$var$Ekb(b.a, l.a);
        l.c && (d.c[d.c.length] = l);
    }
}
function $61de1ee1cac498ae$var$jCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    $61de1ee1cac498ae$var$Odd(c, "Interactive cycle breaking", 1);
    l = new $61de1ee1cac498ae$var$Rkb;
    for(n = new $61de1ee1cac498ae$var$olb(b.a); n.a < n.c.c.length;){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 10);
        m.p = 1;
        o = $61de1ee1cac498ae$var$T_b(m).a;
        for(k = $61de1ee1cac498ae$var$W_b(m, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)).Kc(); k.Ob();){
            j = $61de1ee1cac498ae$var$BD(k.Pb(), 11);
            for(f = new $61de1ee1cac498ae$var$olb(j.g); f.a < f.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                p = d.d.i;
                if (p != m) {
                    q = $61de1ee1cac498ae$var$T_b(p).a;
                    q < o && (l.c[l.c.length] = d);
                }
            }
        }
    }
    for(g = new $61de1ee1cac498ae$var$olb(l); g.a < g.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
        $61de1ee1cac498ae$var$PZb(d, true);
    }
    l.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    for(i = new $61de1ee1cac498ae$var$olb(b.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        h.p > 0 && $61de1ee1cac498ae$var$iCc(a, h, l);
    }
    for(e = new $61de1ee1cac498ae$var$olb(l); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
        $61de1ee1cac498ae$var$PZb(d, true);
    }
    l.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$_z(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = "";
    if (b.length == 0) return a.de($61de1ee1cac498ae$var$Zie, $61de1ee1cac498ae$var$Xie, -1, -1);
    k = $61de1ee1cac498ae$var$ufb(b);
    $61de1ee1cac498ae$var$dfb(k.substr(0, 3), "at ") && (k = k.substr(3));
    k = k.replace(/\[.*?\]/g, "");
    g = k.indexOf("(");
    if (g == -1) {
        g = k.indexOf("@");
        if (g == -1) {
            j = k;
            k = "";
        } else {
            j = $61de1ee1cac498ae$var$ufb(k.substr(g + 1));
            k = $61de1ee1cac498ae$var$ufb(k.substr(0, g));
        }
    } else {
        c = k.indexOf(")", g);
        j = k.substr(g + 1, c - (g + 1));
        k = $61de1ee1cac498ae$var$ufb(k.substr(0, g));
    }
    g = $61de1ee1cac498ae$var$hfb(k, $61de1ee1cac498ae$var$wfb(46));
    g != -1 && (k = k.substr(g + 1));
    (k.length == 0 || $61de1ee1cac498ae$var$dfb(k, "Anonymous function")) && (k = $61de1ee1cac498ae$var$Xie);
    h = $61de1ee1cac498ae$var$kfb(j, $61de1ee1cac498ae$var$wfb(58));
    e = $61de1ee1cac498ae$var$lfb(j, $61de1ee1cac498ae$var$wfb(58), h - 1);
    i = -1;
    d = -1;
    f = $61de1ee1cac498ae$var$Zie;
    if (h != -1 && e != -1) {
        f = j.substr(0, e);
        i = $61de1ee1cac498ae$var$Vz(j.substr(e + 1, h - (e + 1)));
        d = $61de1ee1cac498ae$var$Vz(j.substr(h + 1));
    }
    return a.de(f, k, i, d);
}
function $61de1ee1cac498ae$var$UC(a, b, c) {
    var d, e, f, g, h, i;
    if (b.l == 0 && b.m == 0 && b.h == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$ocb("divide by zero"));
    if (a.l == 0 && a.m == 0 && a.h == 0) {
        c && ($61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$TC(0, 0, 0));
        return $61de1ee1cac498ae$var$TC(0, 0, 0);
    }
    if (b.h == $61de1ee1cac498ae$var$Gje && b.m == 0 && b.l == 0) return $61de1ee1cac498ae$var$VC(a, c);
    i = false;
    if (b.h >> 19 != 0) {
        b = $61de1ee1cac498ae$var$hD(b);
        i = !i;
    }
    g = $61de1ee1cac498ae$var$_C(b);
    f = false;
    e = false;
    d = false;
    if (a.h == $61de1ee1cac498ae$var$Gje && a.m == 0 && a.l == 0) {
        e = true;
        f = true;
        if (g == -1) {
            a = $61de1ee1cac498ae$var$SC(($61de1ee1cac498ae$var$wD(), $61de1ee1cac498ae$var$sD));
            d = true;
            i = !i;
        } else {
            h = $61de1ee1cac498ae$var$lD(a, g);
            i && $61de1ee1cac498ae$var$ZC(h);
            c && ($61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$TC(0, 0, 0));
            return h;
        }
    } else if (a.h >> 19 != 0) {
        f = true;
        a = $61de1ee1cac498ae$var$hD(a);
        d = true;
        i = !i;
    }
    if (g != -1) return $61de1ee1cac498ae$var$WC(a, g, i, f, c);
    if ($61de1ee1cac498ae$var$eD(a, b) < 0) {
        c && (f ? $61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$hD(a) : $61de1ee1cac498ae$var$QC = $61de1ee1cac498ae$var$TC(a.l, a.m, a.h));
        return $61de1ee1cac498ae$var$TC(0, 0, 0);
    }
    return $61de1ee1cac498ae$var$XC(d ? a : $61de1ee1cac498ae$var$TC(a.l, a.m, a.h), b, i, f, e, c);
}
function $61de1ee1cac498ae$var$F2c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if (a.e && a.c.c < a.f) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Expected " + a.f + " phases to be configured; " + "only found " + a.c.c));
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb(a.g), 9);
    n = $61de1ee1cac498ae$var$Pu(a.f);
    for(f = k, h = 0, j = f.length; h < j; ++h){
        d = f[h];
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$B2c(a, d.g), 246);
        l ? $61de1ee1cac498ae$var$Ekb(n, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$I2c(a, l), 123)) : n.c[n.c.length] = null;
    }
    o = new $61de1ee1cac498ae$var$j3c;
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(n, 16)), new $61de1ee1cac498ae$var$O2c), new $61de1ee1cac498ae$var$Q2c(b)), new $61de1ee1cac498ae$var$S2c), new $61de1ee1cac498ae$var$U2c(o));
    $61de1ee1cac498ae$var$d3c(o, a.a);
    c = new $61de1ee1cac498ae$var$Rkb;
    for(e = k, g = 0, i = e.length; g < i; ++g){
        d = e[g];
        $61de1ee1cac498ae$var$Gkb(c, $61de1ee1cac498ae$var$J2c(a, $61de1ee1cac498ae$var$Dx($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$B2c(o, d.g), 20))));
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(n, d.g), 123);
        !!m && (c.c[c.c.length] = m);
    }
    $61de1ee1cac498ae$var$Gkb(c, $61de1ee1cac498ae$var$J2c(a, $61de1ee1cac498ae$var$Dx($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$B2c(o, k[k.length - 1].g + 1), 20))));
    return c;
}
function $61de1ee1cac498ae$var$qCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    $61de1ee1cac498ae$var$Odd(c, "Model order cycle breaking", 1);
    a.a = 0;
    a.b = 0;
    n = new $61de1ee1cac498ae$var$Rkb;
    k = b.a.c.length;
    for(j = new $61de1ee1cac498ae$var$olb(b.a); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        $61de1ee1cac498ae$var$wNb(i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) && (k = $61de1ee1cac498ae$var$$wnd.Math.max(k, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$Zsc), 19).a + 1));
    }
    for(p = new $61de1ee1cac498ae$var$olb(b.a); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 10);
        g = $61de1ee1cac498ae$var$pCc(a, o, k);
        for(m = $61de1ee1cac498ae$var$W_b(o, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)).Kc(); m.Ob();){
            l = $61de1ee1cac498ae$var$BD(m.Pb(), 11);
            for(f = new $61de1ee1cac498ae$var$olb(l.g); f.a < f.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                q = d.d.i;
                h = $61de1ee1cac498ae$var$pCc(a, q, k);
                h < g && (n.c[n.c.length] = d);
            }
        }
    }
    for(e = new $61de1ee1cac498ae$var$olb(n); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
        $61de1ee1cac498ae$var$PZb(d, true);
        $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Asc), ($61de1ee1cac498ae$var$Bcb(), true));
    }
    n.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$kQc(a, b) {
    var c, d, e, f, g, h, i;
    if (a.g > b.f || b.g > a.f) return;
    c = 0;
    d = 0;
    for(g = a.w.a.ec().Kc(); g.Ob();){
        e = $61de1ee1cac498ae$var$BD(g.Pb(), 11);
        $61de1ee1cac498ae$var$aRc($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, b.g, b.f) && ++c;
    }
    for(h = a.r.a.ec().Kc(); h.Ob();){
        e = $61de1ee1cac498ae$var$BD(h.Pb(), 11);
        $61de1ee1cac498ae$var$aRc($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, b.g, b.f) && --c;
    }
    for(i = b.w.a.ec().Kc(); i.Ob();){
        e = $61de1ee1cac498ae$var$BD(i.Pb(), 11);
        $61de1ee1cac498ae$var$aRc($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, a.g, a.f) && ++d;
    }
    for(f = b.r.a.ec().Kc(); f.Ob();){
        e = $61de1ee1cac498ae$var$BD(f.Pb(), 11);
        $61de1ee1cac498ae$var$aRc($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            e.i.n,
            e.n,
            e.a
        ])).b, a.g, a.f) && --d;
    }
    if (c < d) new $61de1ee1cac498ae$var$BQc(a, b, d - c);
    else if (d < c) new $61de1ee1cac498ae$var$BQc(b, a, c - d);
    else {
        new $61de1ee1cac498ae$var$BQc(b, a, 0);
        new $61de1ee1cac498ae$var$BQc(a, b, 0);
    }
}
function $61de1ee1cac498ae$var$JPb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    j = b.c;
    e = $61de1ee1cac498ae$var$IOb(a.e);
    l = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$b7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$HOb(a.e)), a.d * a.a, a.c * a.b), -0.5);
    c = e.a - l.a;
    d = e.b - l.b;
    g = b.a;
    c = g.c - c;
    d = g.d - d;
    for(i = new $61de1ee1cac498ae$var$olb(j); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 395);
        m = h.b;
        n = c + m.a;
        q = d + m.b;
        o = $61de1ee1cac498ae$var$QD(n / a.a);
        r = $61de1ee1cac498ae$var$QD(q / a.b);
        f = h.a;
        switch(f.g){
            case 0:
                k = ($61de1ee1cac498ae$var$RMb(), $61de1ee1cac498ae$var$OMb);
                break;
            case 1:
                k = ($61de1ee1cac498ae$var$RMb(), $61de1ee1cac498ae$var$NMb);
                break;
            case 2:
                k = ($61de1ee1cac498ae$var$RMb(), $61de1ee1cac498ae$var$PMb);
                break;
            default:
                k = ($61de1ee1cac498ae$var$RMb(), $61de1ee1cac498ae$var$QMb);
        }
        if (f.a) {
            s = $61de1ee1cac498ae$var$QD((q + h.c) / a.b);
            $61de1ee1cac498ae$var$Ekb(a.f, new $61de1ee1cac498ae$var$uOb(k, $61de1ee1cac498ae$var$meb(r), $61de1ee1cac498ae$var$meb(s)));
            f == ($61de1ee1cac498ae$var$ROb(), $61de1ee1cac498ae$var$QOb) ? $61de1ee1cac498ae$var$nNb(a, 0, r, o, s) : $61de1ee1cac498ae$var$nNb(a, o, r, a.d - 1, s);
        } else {
            p = $61de1ee1cac498ae$var$QD((n + h.c) / a.a);
            $61de1ee1cac498ae$var$Ekb(a.f, new $61de1ee1cac498ae$var$uOb(k, $61de1ee1cac498ae$var$meb(o), $61de1ee1cac498ae$var$meb(p)));
            f == ($61de1ee1cac498ae$var$ROb(), $61de1ee1cac498ae$var$OOb) ? $61de1ee1cac498ae$var$nNb(a, o, 0, p, r) : $61de1ee1cac498ae$var$nNb(a, o, r, p, a.c - 1);
        }
    }
}
function $61de1ee1cac498ae$var$coc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    m = new $61de1ee1cac498ae$var$Rkb;
    e = new $61de1ee1cac498ae$var$Rkb;
    p = null;
    for(h = b.Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 19);
        f = new $61de1ee1cac498ae$var$qoc(g.a);
        e.c[e.c.length] = f;
        if (p) {
            f.d = p;
            p.e = f;
        }
        p = f;
    }
    t = $61de1ee1cac498ae$var$boc(a);
    for(k = 0; k < e.c.length; ++k){
        n = null;
        q = $61de1ee1cac498ae$var$poc(($61de1ee1cac498ae$var$tCb(0, e.c.length), $61de1ee1cac498ae$var$BD(e.c[0], 652)));
        c = null;
        d = $61de1ee1cac498ae$var$Pje;
        for(l = 1; l < a.b.c.length; ++l){
            r = q ? $61de1ee1cac498ae$var$$wnd.Math.abs(q.b - l) : $61de1ee1cac498ae$var$$wnd.Math.abs(l - n.b) + 1;
            o = n ? $61de1ee1cac498ae$var$$wnd.Math.abs(l - n.b) : r + 1;
            if (o < r) {
                j = n;
                i = o;
            } else {
                j = q;
                i = r;
            }
            s = (u = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Hyc)))), t[l] + $61de1ee1cac498ae$var$$wnd.Math.pow(i, u));
            if (s < d) {
                d = s;
                c = j;
                c.c = l;
            }
            if (!!q && l == q.b) {
                n = q;
                q = $61de1ee1cac498ae$var$koc(q);
            }
        }
        if (c) {
            $61de1ee1cac498ae$var$Ekb(m, $61de1ee1cac498ae$var$meb(c.c));
            c.a = true;
            $61de1ee1cac498ae$var$loc(c);
        }
    }
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Mlb(m.c, m.c.length, null);
    return m;
}
function $61de1ee1cac498ae$var$qNd(a) {
    var b, c, d, e, f, g, h, i, j, k;
    b = new $61de1ee1cac498ae$var$zNd;
    c = new $61de1ee1cac498ae$var$zNd;
    j = $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Qve, (e = $61de1ee1cac498ae$var$Dmd(a.b, $61de1ee1cac498ae$var$Rve), !e ? null : $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!e.b && (e.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, e)), e.b), $61de1ee1cac498ae$var$Sve))));
    for(i = 0; i < a.i; ++i){
        h = $61de1ee1cac498ae$var$BD(a.g[i], 170);
        if ($61de1ee1cac498ae$var$JD(h, 99)) {
            g = $61de1ee1cac498ae$var$BD(h, 18);
            (g.Bb & $61de1ee1cac498ae$var$ote) != 0 ? ((g.Bb & $61de1ee1cac498ae$var$oie) == 0 || !j && (f = $61de1ee1cac498ae$var$Dmd(g, $61de1ee1cac498ae$var$Rve), (!f ? null : $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!f.b && (f.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, f)), f.b), $61de1ee1cac498ae$var$eue))) == null)) && $61de1ee1cac498ae$var$wtd(b, g) : (k = $61de1ee1cac498ae$var$zUd(g), !!k && (k.Bb & $61de1ee1cac498ae$var$ote) != 0 || ((g.Bb & $61de1ee1cac498ae$var$oie) == 0 || !j && (d = $61de1ee1cac498ae$var$Dmd(g, $61de1ee1cac498ae$var$Rve), (!d ? null : $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$AAd((!d.b && (d.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, d)), d.b), $61de1ee1cac498ae$var$eue))) == null)) && $61de1ee1cac498ae$var$wtd(c, g));
        } else {
            $61de1ee1cac498ae$var$Q6d();
            if ($61de1ee1cac498ae$var$BD(h, 66).Oj()) {
                if (!h.Jj()) {
                    $61de1ee1cac498ae$var$wtd(b, h);
                    $61de1ee1cac498ae$var$wtd(c, h);
                }
            }
        }
    }
    $61de1ee1cac498ae$var$vud(b);
    $61de1ee1cac498ae$var$vud(c);
    a.a = $61de1ee1cac498ae$var$BD(b.g, 247);
    $61de1ee1cac498ae$var$BD(c.g, 247);
}
function $61de1ee1cac498ae$var$LTb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    j = $61de1ee1cac498ae$var$ITb(b);
    q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Iwc)), 314);
    q != ($61de1ee1cac498ae$var$Rpc(), $61de1ee1cac498ae$var$Ppc) && $61de1ee1cac498ae$var$reb(j, new $61de1ee1cac498ae$var$STb);
    r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Cwc), 292);
    $61de1ee1cac498ae$var$reb(j, new $61de1ee1cac498ae$var$UTb(r));
    p = 0;
    k = new $61de1ee1cac498ae$var$Rkb;
    for(f = new $61de1ee1cac498ae$var$xkb(j); f.a != f.b;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vkb(f), 37);
        $61de1ee1cac498ae$var$aUb(a.c, e);
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$itc)), 15);
        p += m.gc();
        d = m.Kc();
        $61de1ee1cac498ae$var$Ekb(k, new $61de1ee1cac498ae$var$vgd(e, d));
    }
    $61de1ee1cac498ae$var$Odd(c, "Recursive hierarchical layout", p);
    o = 0;
    n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k, k.c.length - 1), 46).b, 47);
    while(n.Ob())for(i = new $61de1ee1cac498ae$var$olb(k); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 46);
        m = $61de1ee1cac498ae$var$BD(h.b, 47);
        g = $61de1ee1cac498ae$var$BD(h.a, 37);
        while(m.Ob()){
            l = $61de1ee1cac498ae$var$BD(m.Pb(), 51);
            if ($61de1ee1cac498ae$var$JD(l, 507)) {
                if (!g.e) {
                    l.pf(g, $61de1ee1cac498ae$var$Udd(c, 1));
                    ++o;
                    break;
                } else break;
            } else {
                l.pf(g, $61de1ee1cac498ae$var$Udd(c, 1));
                ++o;
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$rid(b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    j = c.length - 1;
    i = ($61de1ee1cac498ae$var$BCb(j, c.length), c.charCodeAt(j));
    if (i == 93) {
        h = $61de1ee1cac498ae$var$hfb(c, $61de1ee1cac498ae$var$wfb(91));
        if (h >= 0) {
            f = $61de1ee1cac498ae$var$wid(b, c.substr(1, h - 1));
            l = c.substr(h + 1, j - (h + 1));
            return $61de1ee1cac498ae$var$pid(b, l, f);
        }
    } else {
        d = -1;
        $61de1ee1cac498ae$var$Vcb == null && ($61de1ee1cac498ae$var$Vcb = new RegExp("\\d"));
        if ($61de1ee1cac498ae$var$Vcb.test(String.fromCharCode(i))) {
            d = $61de1ee1cac498ae$var$lfb(c, $61de1ee1cac498ae$var$wfb(46), j - 1);
            if (d >= 0) {
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hid(b, $61de1ee1cac498ae$var$Bid(b, c.substr(1, d - 1)), false), 58);
                k = 0;
                try {
                    k = $61de1ee1cac498ae$var$Icb(c.substr(d + 1), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe);
                } catch (a) {
                    a = $61de1ee1cac498ae$var$ubb(a);
                    if ($61de1ee1cac498ae$var$JD(a, 127)) {
                        g = a;
                        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$rFd(g));
                    } else throw $61de1ee1cac498ae$var$vbb(a);
                }
                if (k < e.gc()) {
                    m = e.Xb(k);
                    $61de1ee1cac498ae$var$JD(m, 72) && (m = $61de1ee1cac498ae$var$BD(m, 72).dd());
                    return $61de1ee1cac498ae$var$BD(m, 56);
                }
            }
        }
        if (d < 0) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hid(b, $61de1ee1cac498ae$var$Bid(b, c.substr(1)), false), 56);
    }
    return null;
}
function $61de1ee1cac498ae$var$e1d(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    if ($61de1ee1cac498ae$var$bLd(b, c) >= 0) return c;
    switch($61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d(a, c))){
        case 2:
            if ($61de1ee1cac498ae$var$dfb("", $61de1ee1cac498ae$var$o1d(a, c.Hj()).ne())) {
                i = $61de1ee1cac498ae$var$b2d($61de1ee1cac498ae$var$q1d(a, c));
                h = $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(a, c));
                k = $61de1ee1cac498ae$var$r1d(a, b, i, h);
                if (k) return k;
                e = $61de1ee1cac498ae$var$f1d(a, b);
                for(g = 0, l = e.gc(); g < l; ++g){
                    k = $61de1ee1cac498ae$var$BD(e.Xb(g), 170);
                    if ($61de1ee1cac498ae$var$x1d($61de1ee1cac498ae$var$c2d($61de1ee1cac498ae$var$q1d(a, k)), i)) return k;
                }
            }
            return null;
        case 4:
            if ($61de1ee1cac498ae$var$dfb("", $61de1ee1cac498ae$var$o1d(a, c.Hj()).ne())) {
                for(d = c; d; d = $61de1ee1cac498ae$var$Z1d($61de1ee1cac498ae$var$q1d(a, d))){
                    j = $61de1ee1cac498ae$var$b2d($61de1ee1cac498ae$var$q1d(a, d));
                    h = $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(a, d));
                    k = $61de1ee1cac498ae$var$s1d(a, b, j, h);
                    if (k) return k;
                }
                i = $61de1ee1cac498ae$var$b2d($61de1ee1cac498ae$var$q1d(a, c));
                if ($61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Ewe, i)) return $61de1ee1cac498ae$var$t1d(a, b);
                else {
                    f = $61de1ee1cac498ae$var$g1d(a, b);
                    for(g = 0, l = f.gc(); g < l; ++g){
                        k = $61de1ee1cac498ae$var$BD(f.Xb(g), 170);
                        if ($61de1ee1cac498ae$var$x1d($61de1ee1cac498ae$var$c2d($61de1ee1cac498ae$var$q1d(a, k)), i)) return k;
                    }
                }
            }
            return null;
        default:
            return null;
    }
}
function $61de1ee1cac498ae$var$t2d(a, b, c) {
    var d, e, f, g, h, i, j, k;
    if (c.gc() == 0) return false;
    h = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj());
    f = h ? c : new $61de1ee1cac498ae$var$zud(c.gc());
    if ($61de1ee1cac498ae$var$T6d(a.e, b)) {
        if (b.hi()) for(j = c.Kc(); j.Ob();){
            i = j.Pb();
            if (!$61de1ee1cac498ae$var$F2d(a, b, i, $61de1ee1cac498ae$var$JD(b, 99) && ($61de1ee1cac498ae$var$BD(b, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0)) {
                e = $61de1ee1cac498ae$var$R6d(b, i);
                f.Hc(e) || f.Fc(e);
            }
        }
        else if (!h) for(j = c.Kc(); j.Ob();){
            i = j.Pb();
            e = $61de1ee1cac498ae$var$R6d(b, i);
            f.Fc(e);
        }
    } else {
        if (c.gc() > 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Hwe));
        k = $61de1ee1cac498ae$var$S6d(a.e.Tg(), b);
        d = $61de1ee1cac498ae$var$BD(a.g, 119);
        for(g = 0; g < a.i; ++g){
            e = d[g];
            if (k.rl(e.ak())) {
                if (c.Hc(h ? e : e.dd())) return false;
                else {
                    for(j = c.Kc(); j.Ob();){
                        i = j.Pb();
                        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(a, g, h ? $61de1ee1cac498ae$var$BD(i, 72) : $61de1ee1cac498ae$var$R6d(b, i)), 72);
                    }
                    return true;
                }
            }
        }
        if (!h) {
            e = $61de1ee1cac498ae$var$R6d(b, c.Kc().Pb());
            f.Fc(e);
        }
    }
    return $61de1ee1cac498ae$var$ytd(a, f);
}
function $61de1ee1cac498ae$var$qMc(a, b) {
    var c, d, e, f, g, h, i, j, k;
    k = new $61de1ee1cac498ae$var$Psb;
    for(h = (j = new $61de1ee1cac498ae$var$$ib(a.c).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(j)); h.a.Ob();){
        f = (e = $61de1ee1cac498ae$var$BD(h.a.Pb(), 42), $61de1ee1cac498ae$var$BD(e.dd(), 458));
        f.b == 0 && $61de1ee1cac498ae$var$Gsb(k, f, k.c.b, k.c);
    }
    while(k.b != 0){
        f = $61de1ee1cac498ae$var$BD(k.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(k.b != 0), $61de1ee1cac498ae$var$Nsb(k, k.a.a)), 458);
        f.a == null && (f.a = 0);
        for(d = new $61de1ee1cac498ae$var$olb(f.d); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 654);
            c.b.a == null ? c.b.a = $61de1ee1cac498ae$var$Edb(f.a) + c.a : b.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$cMc) ? c.b.a = $61de1ee1cac498ae$var$$wnd.Math.min($61de1ee1cac498ae$var$Edb(c.b.a), $61de1ee1cac498ae$var$Edb(f.a) + c.a) : c.b.a = $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$Edb(c.b.a), $61de1ee1cac498ae$var$Edb(f.a) + c.a);
            --c.b.b;
            c.b.b == 0 && $61de1ee1cac498ae$var$Dsb(k, c.b);
        }
    }
    for(g = (i = new $61de1ee1cac498ae$var$$ib(a.c).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(i)); g.a.Ob();){
        f = (e = $61de1ee1cac498ae$var$BD(g.a.Pb(), 42), $61de1ee1cac498ae$var$BD(e.dd(), 458));
        b.i[f.c.p] = f.a;
    }
}
function $61de1ee1cac498ae$var$mTc() {
    $61de1ee1cac498ae$var$mTc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$dTc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Ime);
    new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Jme);
    new $61de1ee1cac498ae$var$Msd("DEPTH", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$ZSc = new $61de1ee1cac498ae$var$Msd("FAN", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$XSc = new $61de1ee1cac498ae$var$Msd($61de1ee1cac498ae$var$Yqe, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$jTc = new $61de1ee1cac498ae$var$Msd("ROOT", ($61de1ee1cac498ae$var$Bcb(), false));
    $61de1ee1cac498ae$var$_Sc = new $61de1ee1cac498ae$var$Msd("LEFTNEIGHBOR", null);
    $61de1ee1cac498ae$var$hTc = new $61de1ee1cac498ae$var$Msd("RIGHTNEIGHBOR", null);
    $61de1ee1cac498ae$var$aTc = new $61de1ee1cac498ae$var$Msd("LEFTSIBLING", null);
    $61de1ee1cac498ae$var$iTc = new $61de1ee1cac498ae$var$Msd("RIGHTSIBLING", null);
    $61de1ee1cac498ae$var$YSc = new $61de1ee1cac498ae$var$Msd("DUMMY", false);
    new $61de1ee1cac498ae$var$Msd("LEVEL", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$gTc = new $61de1ee1cac498ae$var$Msd("REMOVABLE_EDGES", new $61de1ee1cac498ae$var$Psb);
    $61de1ee1cac498ae$var$kTc = new $61de1ee1cac498ae$var$Msd("XCOOR", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$lTc = new $61de1ee1cac498ae$var$Msd("YCOOR", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$bTc = new $61de1ee1cac498ae$var$Msd("LEVELHEIGHT", 0);
    $61de1ee1cac498ae$var$$Sc = new $61de1ee1cac498ae$var$Msd("ID", "");
    $61de1ee1cac498ae$var$eTc = new $61de1ee1cac498ae$var$Msd("POSITION", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$fTc = new $61de1ee1cac498ae$var$Msd("PRELIM", 0);
    $61de1ee1cac498ae$var$cTc = new $61de1ee1cac498ae$var$Msd("MODIFIER", 0);
    $61de1ee1cac498ae$var$WSc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Kme);
    $61de1ee1cac498ae$var$VSc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Lme);
}
function $61de1ee1cac498ae$var$MNc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o;
    k = c + b.c.c.a;
    for(n = new $61de1ee1cac498ae$var$olb(b.j); n.a < n.c.c.length;){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 11);
        e = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            m.i.n,
            m.n,
            m.a
        ]));
        if (b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b)) {
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(m, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
            e.a = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                h.i.n,
                h.n,
                h.a
            ])).a;
            b.n.a = e.a;
        }
        g = new $61de1ee1cac498ae$var$f7c(0, e.b);
        if (m.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)) g.a = k;
        else if (m.j == $61de1ee1cac498ae$var$Tcd) g.a = c;
        else continue;
        o = $61de1ee1cac498ae$var$$wnd.Math.abs(e.a - g.a);
        if (o <= d && !$61de1ee1cac498ae$var$JNc(b)) continue;
        f = m.g.c.length + m.e.c.length > 1;
        for(j = new $61de1ee1cac498ae$var$b1b(m.b); $61de1ee1cac498ae$var$llb(j.a) || $61de1ee1cac498ae$var$llb(j.b);){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(j.a) ? $61de1ee1cac498ae$var$mlb(j.a) : $61de1ee1cac498ae$var$mlb(j.b), 17);
            l = i.c == m ? i.d : i.c;
            $61de1ee1cac498ae$var$$wnd.Math.abs($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                l.i.n,
                l.n,
                l.a
            ])).b - g.b) > 1 && $61de1ee1cac498ae$var$GNc(a, i, g, f, m);
        }
    }
}
function $61de1ee1cac498ae$var$XPc(a) {
    var b, c, d, e, f, g;
    e = new $61de1ee1cac498ae$var$Bib(a.e, 0);
    d = new $61de1ee1cac498ae$var$Bib(a.a, 0);
    if (a.d) for(c = 0; c < a.b; c++){
        $61de1ee1cac498ae$var$sCb(e.b < e.d.gc());
        e.d.Xb(e.c = e.b++);
    }
    else for(c = 0; c < a.b - 1; c++){
        $61de1ee1cac498ae$var$sCb(e.b < e.d.gc());
        e.d.Xb(e.c = e.b++);
        $61de1ee1cac498ae$var$uib(e);
    }
    b = $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), $61de1ee1cac498ae$var$ED(e.d.Xb(e.c = e.b++))));
    while(a.f - b > $61de1ee1cac498ae$var$Oqe){
        f = b;
        g = 0;
        while($61de1ee1cac498ae$var$$wnd.Math.abs(b - f) < $61de1ee1cac498ae$var$Oqe){
            ++g;
            b = $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$sCb(e.b < e.d.gc()), $61de1ee1cac498ae$var$ED(e.d.Xb(e.c = e.b++))));
            $61de1ee1cac498ae$var$sCb(d.b < d.d.gc());
            d.d.Xb(d.c = d.b++);
        }
        if (g < a.b) {
            $61de1ee1cac498ae$var$sCb(e.b > 0);
            e.a.Xb(e.c = --e.b);
            $61de1ee1cac498ae$var$WPc(a, a.b - g, f, d, e);
            $61de1ee1cac498ae$var$sCb(e.b < e.d.gc());
            e.d.Xb(e.c = e.b++);
        }
        $61de1ee1cac498ae$var$sCb(d.b > 0);
        d.a.Xb(d.c = --d.b);
    }
    if (!a.d) for(c = 0; c < a.b - 1; c++){
        $61de1ee1cac498ae$var$sCb(e.b < e.d.gc());
        e.d.Xb(e.c = e.b++);
        $61de1ee1cac498ae$var$uib(e);
    }
    a.d = true;
    a.c = true;
}
function $61de1ee1cac498ae$var$Q8d() {
    $61de1ee1cac498ae$var$Q8d = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$s8d = ($61de1ee1cac498ae$var$r8d(), $61de1ee1cac498ae$var$q8d).b;
    $61de1ee1cac498ae$var$v8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.b), 0), 34);
    $61de1ee1cac498ae$var$t8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.b), 1), 34);
    $61de1ee1cac498ae$var$u8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.b), 2), 34);
    $61de1ee1cac498ae$var$F8d = $61de1ee1cac498ae$var$q8d.bb;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.bb), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.bb), 1), 34);
    $61de1ee1cac498ae$var$H8d = $61de1ee1cac498ae$var$q8d.fb;
    $61de1ee1cac498ae$var$I8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.fb), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.fb), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.fb), 2), 18);
    $61de1ee1cac498ae$var$K8d = $61de1ee1cac498ae$var$q8d.qb;
    $61de1ee1cac498ae$var$N8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 1), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 2), 18);
    $61de1ee1cac498ae$var$L8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 3), 34);
    $61de1ee1cac498ae$var$M8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 4), 34);
    $61de1ee1cac498ae$var$P8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 6), 34);
    $61de1ee1cac498ae$var$O8d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$q8d.qb), 5), 18);
    $61de1ee1cac498ae$var$w8d = $61de1ee1cac498ae$var$q8d.j;
    $61de1ee1cac498ae$var$x8d = $61de1ee1cac498ae$var$q8d.k;
    $61de1ee1cac498ae$var$y8d = $61de1ee1cac498ae$var$q8d.q;
    $61de1ee1cac498ae$var$z8d = $61de1ee1cac498ae$var$q8d.w;
    $61de1ee1cac498ae$var$A8d = $61de1ee1cac498ae$var$q8d.B;
    $61de1ee1cac498ae$var$B8d = $61de1ee1cac498ae$var$q8d.A;
    $61de1ee1cac498ae$var$C8d = $61de1ee1cac498ae$var$q8d.C;
    $61de1ee1cac498ae$var$D8d = $61de1ee1cac498ae$var$q8d.D;
    $61de1ee1cac498ae$var$E8d = $61de1ee1cac498ae$var$q8d._;
    $61de1ee1cac498ae$var$G8d = $61de1ee1cac498ae$var$q8d.cb;
    $61de1ee1cac498ae$var$J8d = $61de1ee1cac498ae$var$q8d.hb;
}
function $61de1ee1cac498ae$var$$Dc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    a.c = 0;
    a.b = 0;
    d = 2 * b.c.a.c.length + 1;
    o: for(l = c.Kc(); l.Ob();){
        k = $61de1ee1cac498ae$var$BD(l.Pb(), 11);
        h = k.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || k.j == $61de1ee1cac498ae$var$Rcd;
        n = 0;
        if (h) {
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
            if (!m) continue;
            n += $61de1ee1cac498ae$var$VDc(a, d, k, m);
        } else {
            for(j = new $61de1ee1cac498ae$var$olb(k.g); j.a < j.c.c.length;){
                i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 17);
                e = i.d;
                if (e.i.c == b.c) {
                    $61de1ee1cac498ae$var$Ekb(a.a, k);
                    continue o;
                } else n += a.g[e.p];
            }
            for(g = new $61de1ee1cac498ae$var$olb(k.e); g.a < g.c.c.length;){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
                e = f.c;
                if (e.i.c == b.c) {
                    $61de1ee1cac498ae$var$Ekb(a.a, k);
                    continue o;
                } else n -= a.g[e.p];
            }
        }
        if (k.e.c.length + k.g.c.length > 0) {
            a.f[k.p] = n / (k.e.c.length + k.g.c.length);
            a.c = $61de1ee1cac498ae$var$$wnd.Math.min(a.c, a.f[k.p]);
            a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.b, a.f[k.p]);
        } else h && (a.f[k.p] = n);
    }
}
function $61de1ee1cac498ae$var$$9d(a) {
    a.b = null;
    a.bb = null;
    a.fb = null;
    a.qb = null;
    a.a = null;
    a.c = null;
    a.d = null;
    a.e = null;
    a.f = null;
    a.n = null;
    a.M = null;
    a.L = null;
    a.Q = null;
    a.R = null;
    a.K = null;
    a.db = null;
    a.eb = null;
    a.g = null;
    a.i = null;
    a.j = null;
    a.k = null;
    a.gb = null;
    a.o = null;
    a.p = null;
    a.q = null;
    a.r = null;
    a.$ = null;
    a.ib = null;
    a.S = null;
    a.T = null;
    a.t = null;
    a.s = null;
    a.u = null;
    a.v = null;
    a.w = null;
    a.B = null;
    a.A = null;
    a.C = null;
    a.D = null;
    a.F = null;
    a.G = null;
    a.H = null;
    a.I = null;
    a.J = null;
    a.P = null;
    a.Z = null;
    a.U = null;
    a.V = null;
    a.W = null;
    a.X = null;
    a.Y = null;
    a._ = null;
    a.ab = null;
    a.cb = null;
    a.hb = null;
    a.nb = null;
    a.lb = null;
    a.mb = null;
    a.ob = null;
    a.pb = null;
    a.jb = null;
    a.kb = null;
    a.N = false;
    a.O = false;
}
function $61de1ee1cac498ae$var$l5b(a, b, c) {
    var d, e, f, g;
    $61de1ee1cac498ae$var$Odd(c, "Graph transformation (" + a.a + ")", 1);
    g = $61de1ee1cac498ae$var$Mu(b.a);
    for(f = new $61de1ee1cac498ae$var$olb(b.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        $61de1ee1cac498ae$var$Gkb(g, e.a);
    }
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Mwc)), 419);
    if (d == ($61de1ee1cac498ae$var$xqc(), $61de1ee1cac498ae$var$vqc)) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Lwc), 103).g){
        case 2:
            $61de1ee1cac498ae$var$_4b(b, g);
            break;
        case 3:
            $61de1ee1cac498ae$var$p5b(b, g);
            break;
        case 4:
            if (a.a == ($61de1ee1cac498ae$var$y5b(), $61de1ee1cac498ae$var$x5b)) {
                $61de1ee1cac498ae$var$p5b(b, g);
                $61de1ee1cac498ae$var$a5b(b, g);
            } else {
                $61de1ee1cac498ae$var$a5b(b, g);
                $61de1ee1cac498ae$var$p5b(b, g);
            }
    }
    else if (a.a == ($61de1ee1cac498ae$var$y5b(), $61de1ee1cac498ae$var$x5b)) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Lwc), 103).g){
        case 2:
            $61de1ee1cac498ae$var$_4b(b, g);
            $61de1ee1cac498ae$var$a5b(b, g);
            break;
        case 3:
            $61de1ee1cac498ae$var$p5b(b, g);
            $61de1ee1cac498ae$var$_4b(b, g);
            break;
        case 4:
            $61de1ee1cac498ae$var$_4b(b, g);
            $61de1ee1cac498ae$var$p5b(b, g);
    }
    else switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Lwc), 103).g){
        case 2:
            $61de1ee1cac498ae$var$_4b(b, g);
            $61de1ee1cac498ae$var$a5b(b, g);
            break;
        case 3:
            $61de1ee1cac498ae$var$_4b(b, g);
            $61de1ee1cac498ae$var$p5b(b, g);
            break;
        case 4:
            $61de1ee1cac498ae$var$p5b(b, g);
            $61de1ee1cac498ae$var$_4b(b, g);
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$j6b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    j = new $61de1ee1cac498ae$var$zsb;
    k = new $61de1ee1cac498ae$var$zsb;
    o = new $61de1ee1cac498ae$var$zsb;
    p = new $61de1ee1cac498ae$var$zsb;
    i = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc))));
    f = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$lyc)));
    for(h = new $61de1ee1cac498ae$var$olb(c); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
        if (l == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) {
            k.a.zc(g, k);
            for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
                $61de1ee1cac498ae$var$Qqb(j, d.c.i);
            }
        } else if (l == $61de1ee1cac498ae$var$Rcd) {
            p.a.zc(g, p);
            for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(g).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
                $61de1ee1cac498ae$var$Qqb(o, d.c.i);
            }
        }
    }
    if (j.a.gc() != 0) {
        m = new $61de1ee1cac498ae$var$tPc(2, f);
        n = $61de1ee1cac498ae$var$sPc(m, b, j, k, -i - b.c.b);
        if (n > 0) {
            a.a = i + (n - 1) * f;
            b.c.b += a.a;
            b.f.b += a.a;
        }
    }
    if (o.a.gc() != 0) {
        m = new $61de1ee1cac498ae$var$tPc(1, f);
        n = $61de1ee1cac498ae$var$sPc(m, b, o, p, b.f.b + i - b.c.b);
        n > 0 && (b.f.b += i + (n - 1) * f);
    }
}
function $61de1ee1cac498ae$var$kKd(a, b) {
    var c, d, e, f;
    f = a.F;
    if (b == null) {
        a.F = null;
        $61de1ee1cac498ae$var$$Jd(a, null);
    } else {
        a.F = ($61de1ee1cac498ae$var$uCb(b), b);
        d = $61de1ee1cac498ae$var$hfb(b, $61de1ee1cac498ae$var$wfb(60));
        if (d != -1) {
            e = b.substr(0, d);
            $61de1ee1cac498ae$var$hfb(b, $61de1ee1cac498ae$var$wfb(46)) == -1 && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Khe) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Eve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Fve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Gve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Hve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Ive) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Jve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Kve) && (e = $61de1ee1cac498ae$var$Lve);
            c = $61de1ee1cac498ae$var$kfb(b, $61de1ee1cac498ae$var$wfb(62));
            c != -1 && (e += "" + b.substr(c + 1));
            $61de1ee1cac498ae$var$$Jd(a, e);
        } else {
            e = b;
            if ($61de1ee1cac498ae$var$hfb(b, $61de1ee1cac498ae$var$wfb(46)) == -1) {
                d = $61de1ee1cac498ae$var$hfb(b, $61de1ee1cac498ae$var$wfb(91));
                d != -1 && (e = b.substr(0, d));
                if (!$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Khe) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Eve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Fve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Gve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Hve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Ive) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Jve) && !$61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Kve)) {
                    e = $61de1ee1cac498ae$var$Lve;
                    d != -1 && (e += "" + b.substr(d));
                } else e = b;
            }
            $61de1ee1cac498ae$var$$Jd(a, e);
            e == b && (a.F = a.D);
        }
    }
    (a.Db & 4) != 0 && (a.Db & 1) == 0 && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, 5, f, b));
}
function $61de1ee1cac498ae$var$AMc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    p = b.b.c.length;
    if (p < 3) return;
    n = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, p, 15, 1);
    l = 0;
    for(k = new $61de1ee1cac498ae$var$olb(b.b); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 29);
        n[l++] = j.a.c.length;
    }
    m = new $61de1ee1cac498ae$var$Bib(b.b, 2);
    for(d = 1; d < p - 1; d++){
        c = ($61de1ee1cac498ae$var$sCb(m.b < m.d.gc()), $61de1ee1cac498ae$var$BD(m.d.Xb(m.c = m.b++), 29));
        o = new $61de1ee1cac498ae$var$olb(c.a);
        f = 0;
        h = 0;
        for(i = 0; i < n[d + 1]; i++){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
            if (i == n[d + 1] - 1 || $61de1ee1cac498ae$var$zMc(a, t, d + 1, d)) {
                g = n[d] - 1;
                $61de1ee1cac498ae$var$zMc(a, t, d + 1, d) && (g = a.c.e[$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.c.b, t.p), 15).Xb(0), 46).a, 10).p]);
                while(h <= i){
                    s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.a, h), 10);
                    if (!$61de1ee1cac498ae$var$zMc(a, s, d + 1, d)) for(r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.c.b, s.p), 15).Kc(); r.Ob();){
                        q = $61de1ee1cac498ae$var$BD(r.Pb(), 46);
                        e = a.c.e[$61de1ee1cac498ae$var$BD(q.a, 10).p];
                        (e < f || e > g) && $61de1ee1cac498ae$var$Qqb(a.b, $61de1ee1cac498ae$var$BD(q.b, 17));
                    }
                    ++h;
                }
                f = g;
            }
        }
    }
}
function $61de1ee1cac498ae$var$o5c(b, c) {
    var d;
    if (c == null || $61de1ee1cac498ae$var$dfb(c, $61de1ee1cac498ae$var$Xhe)) return null;
    if (c.length == 0 && b.k != ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$W5c)) return null;
    switch(b.k.g){
        case 1:
            return $61de1ee1cac498ae$var$efb(c, $61de1ee1cac498ae$var$kse) ? ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Acb) : $61de1ee1cac498ae$var$efb(c, $61de1ee1cac498ae$var$lse) ? ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb) : null;
        case 2:
            try {
                return $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Icb(c, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe));
            } catch (a) {
                a = $61de1ee1cac498ae$var$ubb(a);
                if ($61de1ee1cac498ae$var$JD(a, 127)) return null;
                else throw $61de1ee1cac498ae$var$vbb(a);
            }
        case 4:
            try {
                return $61de1ee1cac498ae$var$Hcb(c);
            } catch (a) {
                a = $61de1ee1cac498ae$var$ubb(a);
                if ($61de1ee1cac498ae$var$JD(a, 127)) return null;
                else throw $61de1ee1cac498ae$var$vbb(a);
            }
        case 3:
            return c;
        case 5:
            $61de1ee1cac498ae$var$j5c(b);
            return $61de1ee1cac498ae$var$m5c(b, c);
        case 6:
            $61de1ee1cac498ae$var$j5c(b);
            return $61de1ee1cac498ae$var$n5c(b, b.a, c);
        case 7:
            try {
                d = $61de1ee1cac498ae$var$l5c(b);
                d.Jf(c);
                return d;
            } catch (a) {
                a = $61de1ee1cac498ae$var$ubb(a);
                if ($61de1ee1cac498ae$var$JD(a, 32)) return null;
                else throw $61de1ee1cac498ae$var$vbb(a);
            }
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Invalid type set for this layout option."));
    }
}
function $61de1ee1cac498ae$var$JWb(a) {
    $61de1ee1cac498ae$var$AWb();
    var b, c, d, e, f, g, h;
    h = new $61de1ee1cac498ae$var$CWb;
    for(c = new $61de1ee1cac498ae$var$olb(a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 140);
        (!h.b || b.c >= h.b.c) && (h.b = b);
        if (!h.c || b.c <= h.c.c) {
            h.d = h.c;
            h.c = b;
        }
        (!h.e || b.d >= h.e.d) && (h.e = b);
        (!h.f || b.d <= h.f.d) && (h.f = b);
    }
    d = new $61de1ee1cac498ae$var$NWb(($61de1ee1cac498ae$var$lWb(), $61de1ee1cac498ae$var$hWb));
    $61de1ee1cac498ae$var$rXb(a, $61de1ee1cac498ae$var$yWb, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bQ, 1), $61de1ee1cac498ae$var$Uhe, 369, 0, [
        d
    ])));
    g = new $61de1ee1cac498ae$var$NWb($61de1ee1cac498ae$var$kWb);
    $61de1ee1cac498ae$var$rXb(a, $61de1ee1cac498ae$var$xWb, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bQ, 1), $61de1ee1cac498ae$var$Uhe, 369, 0, [
        g
    ])));
    e = new $61de1ee1cac498ae$var$NWb($61de1ee1cac498ae$var$iWb);
    $61de1ee1cac498ae$var$rXb(a, $61de1ee1cac498ae$var$wWb, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bQ, 1), $61de1ee1cac498ae$var$Uhe, 369, 0, [
        e
    ])));
    f = new $61de1ee1cac498ae$var$NWb($61de1ee1cac498ae$var$jWb);
    $61de1ee1cac498ae$var$rXb(a, $61de1ee1cac498ae$var$vWb, new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$bQ, 1), $61de1ee1cac498ae$var$Uhe, 369, 0, [
        f
    ])));
    $61de1ee1cac498ae$var$DWb(d.c, $61de1ee1cac498ae$var$hWb);
    $61de1ee1cac498ae$var$DWb(e.c, $61de1ee1cac498ae$var$iWb);
    $61de1ee1cac498ae$var$DWb(f.c, $61de1ee1cac498ae$var$jWb);
    $61de1ee1cac498ae$var$DWb(g.c, $61de1ee1cac498ae$var$kWb);
    h.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Gkb(h.a, d.c);
    $61de1ee1cac498ae$var$Gkb(h.a, $61de1ee1cac498ae$var$Su(e.c));
    $61de1ee1cac498ae$var$Gkb(h.a, f.c);
    $61de1ee1cac498ae$var$Gkb(h.a, $61de1ee1cac498ae$var$Su(g.c));
    return h;
}
function $61de1ee1cac498ae$var$jxd(a) {
    var b;
    switch(a.d){
        case 1:
            if (a.hj()) return a.o != -2;
            break;
        case 2:
            if (a.hj()) return a.o == -2;
            break;
        case 3:
        case 5:
        case 4:
        case 6:
        case 7:
            return a.o > -2;
        default:
            return false;
    }
    b = a.gj();
    switch(a.p){
        case 0:
            return b != null && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)) != $61de1ee1cac498ae$var$Kbb(a.k, 0);
        case 1:
            return b != null && $61de1ee1cac498ae$var$BD(b, 217).a != $61de1ee1cac498ae$var$Tbb(a.k) << 24 >> 24;
        case 2:
            return b != null && $61de1ee1cac498ae$var$BD(b, 172).a != ($61de1ee1cac498ae$var$Tbb(a.k) & $61de1ee1cac498ae$var$aje);
        case 6:
            return b != null && $61de1ee1cac498ae$var$Kbb($61de1ee1cac498ae$var$BD(b, 162).a, a.k);
        case 5:
            return b != null && $61de1ee1cac498ae$var$BD(b, 19).a != $61de1ee1cac498ae$var$Tbb(a.k);
        case 7:
            return b != null && $61de1ee1cac498ae$var$BD(b, 184).a != $61de1ee1cac498ae$var$Tbb(a.k) << 16 >> 16;
        case 3:
            return b != null && $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)) != a.j;
        case 4:
            return b != null && $61de1ee1cac498ae$var$BD(b, 155).a != a.j;
        default:
            return b == null ? a.n != null : !$61de1ee1cac498ae$var$pb(b, a.n);
    }
}
function $61de1ee1cac498ae$var$nOd(a, b, c) {
    var d, e, f, g;
    if (a.Fk() && a.Ek()) {
        g = $61de1ee1cac498ae$var$oOd(a, $61de1ee1cac498ae$var$BD(c, 56));
        if ($61de1ee1cac498ae$var$PD(g) !== $61de1ee1cac498ae$var$PD(c)) {
            a.Oi(b);
            a.Ui(b, $61de1ee1cac498ae$var$pOd(a, b, g));
            if (a.rk()) {
                f = (e = $61de1ee1cac498ae$var$BD(c, 49), a.Dk() ? a.Bk() ? e.ih(a.b, $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(a.b), a.aj()), 18)).n, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(a.b), a.aj()).Yj(), 26).Bj(), null) : e.ih(a.b, $61de1ee1cac498ae$var$bLd(e.Tg(), $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(a.b), a.aj()), 18))), null, null) : e.ih(a.b, -1 - a.aj(), null, null));
                !$61de1ee1cac498ae$var$BD(g, 49).eh() && (f = (d = $61de1ee1cac498ae$var$BD(g, 49), a.Dk() ? a.Bk() ? d.gh(a.b, $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(a.b), a.aj()), 18)).n, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(a.b), a.aj()).Yj(), 26).Bj(), f) : d.gh(a.b, $61de1ee1cac498ae$var$bLd(d.Tg(), $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(a.b), a.aj()), 18))), null, f) : d.gh(a.b, -1 - a.aj(), null, f)));
                !!f && f.Fi();
            }
            $61de1ee1cac498ae$var$oid(a.b) && a.$i(a.Zi(9, c, g, b, false));
            return g;
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$Noc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    k = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$oyc))));
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Cyc)));
    m = new $61de1ee1cac498ae$var$_fd;
    $61de1ee1cac498ae$var$yNb(m, $61de1ee1cac498ae$var$oyc, k + d);
    j = b;
    r = j.d;
    p = j.c.i;
    s = j.d.i;
    q = $61de1ee1cac498ae$var$G1b(p.c);
    t = $61de1ee1cac498ae$var$G1b(s.c);
    e = new $61de1ee1cac498ae$var$Rkb;
    for(l = q; l <= t; l++){
        h = new $61de1ee1cac498ae$var$b0b(a);
        $61de1ee1cac498ae$var$__b(h, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b));
        $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), j);
        $61de1ee1cac498ae$var$yNb(h, $61de1ee1cac498ae$var$Vxc, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
        $61de1ee1cac498ae$var$yNb(h, $61de1ee1cac498ae$var$qyc, m);
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b, l), 29);
        l == q ? $61de1ee1cac498ae$var$Z_b(h, n.a.c.length - c, n) : $61de1ee1cac498ae$var$$_b(h, n);
        u = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$Zwc)));
        if (u < 0) {
            u = 0;
            $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$Zwc, u);
        }
        h.o.b = u;
        o = $61de1ee1cac498ae$var$$wnd.Math.floor(u / 2);
        g = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$G0b(g, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
        $61de1ee1cac498ae$var$F0b(g, h);
        g.n.b = o;
        i = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$G0b(i, $61de1ee1cac498ae$var$zcd);
        $61de1ee1cac498ae$var$F0b(i, h);
        i.n.b = o;
        $61de1ee1cac498ae$var$RZb(j, g);
        f = new $61de1ee1cac498ae$var$UZb;
        $61de1ee1cac498ae$var$tNb(f, j);
        $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$jxc, null);
        $61de1ee1cac498ae$var$QZb(f, i);
        $61de1ee1cac498ae$var$RZb(f, r);
        $61de1ee1cac498ae$var$Ooc(h, j, f);
        e.c[e.c.length] = f;
        j = f;
    }
    return e;
}
function $61de1ee1cac498ae$var$sbc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Y_b(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)).Kc().Pb(), 11).e;
    n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Y_b(a, $61de1ee1cac498ae$var$zcd).Kc().Pb(), 11).g;
    h = i.c.length;
    t = $61de1ee1cac498ae$var$A0b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, 0), 11));
    while(h-- > 0){
        p = ($61de1ee1cac498ae$var$tCb(0, i.c.length), $61de1ee1cac498ae$var$BD(i.c[0], 17));
        e = ($61de1ee1cac498ae$var$tCb(0, n.c.length), $61de1ee1cac498ae$var$BD(n.c[0], 17));
        s = e.d.e;
        f = $61de1ee1cac498ae$var$Jkb(s, e, 0);
        $61de1ee1cac498ae$var$SZb(p, e.d, f);
        $61de1ee1cac498ae$var$QZb(e, null);
        $61de1ee1cac498ae$var$RZb(e, null);
        o = p.a;
        b && $61de1ee1cac498ae$var$Dsb(o, new $61de1ee1cac498ae$var$g7c(t));
        for(d = $61de1ee1cac498ae$var$Jsb(e.a, 0); d.b != d.d.c;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
            $61de1ee1cac498ae$var$Dsb(o, new $61de1ee1cac498ae$var$g7c(c));
        }
        r = p.b;
        for(m = new $61de1ee1cac498ae$var$olb(e.b); m.a < m.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 70);
            r.c[r.c.length] = l;
        }
        q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(p, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$jxc), 74);
        if (g) {
            if (!q) {
                q = new $61de1ee1cac498ae$var$s7c;
                $61de1ee1cac498ae$var$yNb(p, $61de1ee1cac498ae$var$jxc, q);
            }
            for(k = $61de1ee1cac498ae$var$Jsb(g, 0); k.b != k.d.c;){
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(k), 8);
                $61de1ee1cac498ae$var$Dsb(q, new $61de1ee1cac498ae$var$g7c(j));
            }
        }
    }
}
function $61de1ee1cac498ae$var$EJb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    if (i.dc()) {
        c.n.b = 0;
        c.n.c = 0;
        return;
    }
    j = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd));
    g = 0;
    h = i.Kc();
    k = null;
    l = 0;
    m = 0;
    while(h.Ob()){
        d = $61de1ee1cac498ae$var$BD(h.Pb(), 111);
        e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d.b.We(($61de1ee1cac498ae$var$CKb(), $61de1ee1cac498ae$var$BKb))));
        f = d.b.rf().a;
        a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd)) && $61de1ee1cac498ae$var$KJb(a, b);
        if (!k) !!a.C && a.C.b > 0 && (g = $61de1ee1cac498ae$var$$wnd.Math.max(g, $61de1ee1cac498ae$var$IJb(a.C.b + d.d.b, e)));
        else {
            n = m + k.d.c + a.w + d.d.b;
            g = $61de1ee1cac498ae$var$$wnd.Math.max(g, ($61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$ple), $61de1ee1cac498ae$var$$wnd.Math.abs(l - e) <= $61de1ee1cac498ae$var$ple || l == e || isNaN(l) && isNaN(e) ? 0 : n / (e - l)));
        }
        k = d;
        l = e;
        m = f;
    }
    if (!!a.C && a.C.c > 0) {
        n = m + a.C.c;
        j && (n += k.d.c);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(g, ($61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$ple), $61de1ee1cac498ae$var$$wnd.Math.abs(l - 1) <= $61de1ee1cac498ae$var$ple || l == 1 || isNaN(l) && isNaN(1) ? 0 : n / (1 - l)));
    }
    c.n.b = 0;
    c.a.a = g;
}
function $61de1ee1cac498ae$var$NKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    if (i.dc()) {
        c.n.d = 0;
        c.n.a = 0;
        return;
    }
    j = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd));
    g = 0;
    a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$sdd)) && $61de1ee1cac498ae$var$SKb(a, b);
    h = i.Kc();
    k = null;
    m = 0;
    l = 0;
    while(h.Ob()){
        d = $61de1ee1cac498ae$var$BD(h.Pb(), 111);
        f = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d.b.We(($61de1ee1cac498ae$var$CKb(), $61de1ee1cac498ae$var$BKb))));
        e = d.b.rf().b;
        if (!k) !!a.C && a.C.d > 0 && (g = $61de1ee1cac498ae$var$$wnd.Math.max(g, $61de1ee1cac498ae$var$IJb(a.C.d + d.d.d, f)));
        else {
            n = l + k.d.a + a.w + d.d.d;
            g = $61de1ee1cac498ae$var$$wnd.Math.max(g, ($61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$ple), $61de1ee1cac498ae$var$$wnd.Math.abs(m - f) <= $61de1ee1cac498ae$var$ple || m == f || isNaN(m) && isNaN(f) ? 0 : n / (f - m)));
        }
        k = d;
        m = f;
        l = e;
    }
    if (!!a.C && a.C.a > 0) {
        n = l + a.C.a;
        j && (n += k.d.a);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(g, ($61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$ple), $61de1ee1cac498ae$var$$wnd.Math.abs(m - 1) <= $61de1ee1cac498ae$var$ple || m == 1 || isNaN(m) && isNaN(1) ? 0 : n / (1 - m)));
    }
    c.n.d = 0;
    c.a.b = g;
}
function $61de1ee1cac498ae$var$_Ec(a, b, c) {
    var d, e, f, g, h, i;
    this.g = a;
    h = b.d.length;
    i = c.d.length;
    this.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$OQ, $61de1ee1cac498ae$var$kne, 10, h + i, 0, 1);
    for(g = 0; g < h; g++)this.d[g] = b.d[g];
    for(f = 0; f < i; f++)this.d[h + f] = c.d[f];
    if (b.e) {
        this.e = $61de1ee1cac498ae$var$Ru(b.e);
        this.e.Mc(c);
        if (c.e) for(e = c.e.Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 233);
            if (d == b) continue;
            else this.e.Hc(d) ? --d.c : this.e.Fc(d);
        }
    } else if (c.e) {
        this.e = $61de1ee1cac498ae$var$Ru(c.e);
        this.e.Mc(b);
    }
    this.f = b.f + c.f;
    this.a = b.a + c.a;
    this.a > 0 ? $61de1ee1cac498ae$var$ZEc(this, this.f / this.a) : $61de1ee1cac498ae$var$REc(b.g, b.d[0]).a != null && $61de1ee1cac498ae$var$REc(c.g, c.d[0]).a != null ? $61de1ee1cac498ae$var$ZEc(this, ($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$REc(b.g, b.d[0]).a) + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$REc(c.g, c.d[0]).a)) / 2) : $61de1ee1cac498ae$var$REc(b.g, b.d[0]).a != null ? $61de1ee1cac498ae$var$ZEc(this, $61de1ee1cac498ae$var$REc(b.g, b.d[0]).a) : $61de1ee1cac498ae$var$REc(c.g, c.d[0]).a != null && $61de1ee1cac498ae$var$ZEc(this, $61de1ee1cac498ae$var$REc(c.g, c.d[0]).a);
}
function $61de1ee1cac498ae$var$BUb(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    a.a = new $61de1ee1cac498ae$var$dVb($61de1ee1cac498ae$var$oqb($61de1ee1cac498ae$var$t1));
    for(d = new $61de1ee1cac498ae$var$olb(b.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 841);
        h = new $61de1ee1cac498ae$var$gVb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$IP, 1), $61de1ee1cac498ae$var$Uhe, 81, 0, []));
        $61de1ee1cac498ae$var$Ekb(a.a.a, h);
        for(j = new $61de1ee1cac498ae$var$olb(c.d); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 110);
            k = new $61de1ee1cac498ae$var$GUb(a, i);
            $61de1ee1cac498ae$var$AUb(k, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c.c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21));
            if (!$61de1ee1cac498ae$var$Mhb(a.g, c)) {
                $61de1ee1cac498ae$var$Rhb(a.g, c, new $61de1ee1cac498ae$var$f7c(i.c, i.d));
                $61de1ee1cac498ae$var$Rhb(a.f, c, k);
            }
            $61de1ee1cac498ae$var$Ekb(a.a.b, k);
            $61de1ee1cac498ae$var$eVb(h, k);
        }
        for(g = new $61de1ee1cac498ae$var$olb(c.b); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 594);
            k = new $61de1ee1cac498ae$var$GUb(a, f.kf());
            $61de1ee1cac498ae$var$Rhb(a.b, f, new $61de1ee1cac498ae$var$vgd(h, k));
            $61de1ee1cac498ae$var$AUb(k, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c.c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21));
            if (f.hf()) {
                l = new $61de1ee1cac498ae$var$HUb(a, f.hf(), 1);
                $61de1ee1cac498ae$var$AUb(l, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c.c, $61de1ee1cac498ae$var$Esc), 21));
                e = new $61de1ee1cac498ae$var$gVb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$IP, 1), $61de1ee1cac498ae$var$Uhe, 81, 0, []));
                $61de1ee1cac498ae$var$eVb(e, l);
                $61de1ee1cac498ae$var$Rc(a.c, f.gf(), new $61de1ee1cac498ae$var$vgd(h, l));
            }
        }
    }
    return a.a;
}
function $61de1ee1cac498ae$var$oBc(a) {
    var b;
    this.a = a;
    b = ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$NQ, 1), $61de1ee1cac498ae$var$Kie, 267, 0, [
        $61de1ee1cac498ae$var$h0b,
        $61de1ee1cac498ae$var$g0b,
        $61de1ee1cac498ae$var$e0b,
        $61de1ee1cac498ae$var$i0b,
        $61de1ee1cac498ae$var$f0b,
        $61de1ee1cac498ae$var$d0b
    ])).length;
    this.b = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$Q3, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$zqe
    ], [
        593,
        146
    ], 0, [
        b,
        b
    ], 2);
    this.c = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$Q3, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$zqe
    ], [
        593,
        146
    ], 0, [
        b,
        b
    ], 2);
    $61de1ee1cac498ae$var$nBc(this, $61de1ee1cac498ae$var$h0b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc), $61de1ee1cac498ae$var$wyc);
    $61de1ee1cac498ae$var$lBc(this, $61de1ee1cac498ae$var$h0b, $61de1ee1cac498ae$var$g0b, $61de1ee1cac498ae$var$oyc, $61de1ee1cac498ae$var$pyc);
    $61de1ee1cac498ae$var$kBc(this, $61de1ee1cac498ae$var$h0b, $61de1ee1cac498ae$var$i0b, $61de1ee1cac498ae$var$oyc);
    $61de1ee1cac498ae$var$kBc(this, $61de1ee1cac498ae$var$h0b, $61de1ee1cac498ae$var$e0b, $61de1ee1cac498ae$var$oyc);
    $61de1ee1cac498ae$var$lBc(this, $61de1ee1cac498ae$var$h0b, $61de1ee1cac498ae$var$f0b, $61de1ee1cac498ae$var$vyc, $61de1ee1cac498ae$var$wyc);
    $61de1ee1cac498ae$var$nBc(this, $61de1ee1cac498ae$var$g0b, $61de1ee1cac498ae$var$lyc, $61de1ee1cac498ae$var$myc);
    $61de1ee1cac498ae$var$kBc(this, $61de1ee1cac498ae$var$g0b, $61de1ee1cac498ae$var$i0b, $61de1ee1cac498ae$var$lyc);
    $61de1ee1cac498ae$var$kBc(this, $61de1ee1cac498ae$var$g0b, $61de1ee1cac498ae$var$e0b, $61de1ee1cac498ae$var$lyc);
    $61de1ee1cac498ae$var$lBc(this, $61de1ee1cac498ae$var$g0b, $61de1ee1cac498ae$var$f0b, $61de1ee1cac498ae$var$oyc, $61de1ee1cac498ae$var$pyc);
    $61de1ee1cac498ae$var$mBc(this, $61de1ee1cac498ae$var$i0b, $61de1ee1cac498ae$var$lyc);
    $61de1ee1cac498ae$var$kBc(this, $61de1ee1cac498ae$var$i0b, $61de1ee1cac498ae$var$e0b, $61de1ee1cac498ae$var$lyc);
    $61de1ee1cac498ae$var$kBc(this, $61de1ee1cac498ae$var$i0b, $61de1ee1cac498ae$var$f0b, $61de1ee1cac498ae$var$syc);
    $61de1ee1cac498ae$var$mBc(this, $61de1ee1cac498ae$var$e0b, $61de1ee1cac498ae$var$zyc);
    $61de1ee1cac498ae$var$lBc(this, $61de1ee1cac498ae$var$e0b, $61de1ee1cac498ae$var$f0b, $61de1ee1cac498ae$var$uyc, $61de1ee1cac498ae$var$tyc);
    $61de1ee1cac498ae$var$nBc(this, $61de1ee1cac498ae$var$f0b, $61de1ee1cac498ae$var$lyc, $61de1ee1cac498ae$var$lyc);
    $61de1ee1cac498ae$var$nBc(this, $61de1ee1cac498ae$var$d0b, $61de1ee1cac498ae$var$lyc, $61de1ee1cac498ae$var$myc);
    $61de1ee1cac498ae$var$lBc(this, $61de1ee1cac498ae$var$d0b, $61de1ee1cac498ae$var$h0b, $61de1ee1cac498ae$var$oyc, $61de1ee1cac498ae$var$pyc);
    $61de1ee1cac498ae$var$lBc(this, $61de1ee1cac498ae$var$d0b, $61de1ee1cac498ae$var$f0b, $61de1ee1cac498ae$var$oyc, $61de1ee1cac498ae$var$pyc);
    $61de1ee1cac498ae$var$lBc(this, $61de1ee1cac498ae$var$d0b, $61de1ee1cac498ae$var$g0b, $61de1ee1cac498ae$var$oyc, $61de1ee1cac498ae$var$pyc);
}
function $61de1ee1cac498ae$var$_2d(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    g = c.ak();
    if ($61de1ee1cac498ae$var$JD(g, 99) && ($61de1ee1cac498ae$var$BD(g, 18).Bb & $61de1ee1cac498ae$var$Tje) != 0) {
        m = $61de1ee1cac498ae$var$BD(c.dd(), 49);
        p = $61de1ee1cac498ae$var$xid(a.e, m);
        if (p != m) {
            k = $61de1ee1cac498ae$var$R6d(g, p);
            $61de1ee1cac498ae$var$mud(a, b, $61de1ee1cac498ae$var$t3d(a, b, k));
            l = null;
            if ($61de1ee1cac498ae$var$oid(a.e)) {
                d = $61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), a.e.Tg(), g);
                if (d != $61de1ee1cac498ae$var$XKd(a.e.Tg(), a.c)) {
                    q = $61de1ee1cac498ae$var$S6d(a.e.Tg(), g);
                    h = 0;
                    f = $61de1ee1cac498ae$var$BD(a.g, 119);
                    for(i = 0; i < b; ++i){
                        e = f[i];
                        q.rl(e.ak()) && ++h;
                    }
                    l = new $61de1ee1cac498ae$var$O7d(a.e, 9, d, m, p, h, false);
                    l.Ei(new $61de1ee1cac498ae$var$pSd(a.e, 9, a.c, c, k, b, false));
                }
            }
            o = $61de1ee1cac498ae$var$BD(g, 18);
            n = $61de1ee1cac498ae$var$zUd(o);
            if (n) {
                l = m.ih(a.e, $61de1ee1cac498ae$var$bLd(m.Tg(), n), null, l);
                l = $61de1ee1cac498ae$var$BD(p, 49).gh(a.e, $61de1ee1cac498ae$var$bLd(p.Tg(), n), null, l);
            } else if ((o.Bb & $61de1ee1cac498ae$var$ote) != 0) {
                j = -1 - $61de1ee1cac498ae$var$bLd(a.e.Tg(), o);
                l = m.ih(a.e, j, null, null);
                !$61de1ee1cac498ae$var$BD(p, 49).eh() && (l = $61de1ee1cac498ae$var$BD(p, 49).gh(a.e, j, null, l));
            }
            !!l && l.Fi();
            return k;
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$yUb(a) {
    var b, c, d, e, f, g, h, i;
    for(f = new $61de1ee1cac498ae$var$olb(a.a.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 81);
        e.b.c = e.g.c;
        e.b.d = e.g.d;
    }
    i = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Pje, $61de1ee1cac498ae$var$Pje);
    b = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Qje, $61de1ee1cac498ae$var$Qje);
    for(d = new $61de1ee1cac498ae$var$olb(a.a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 81);
        i.a = $61de1ee1cac498ae$var$$wnd.Math.min(i.a, c.g.c);
        i.b = $61de1ee1cac498ae$var$$wnd.Math.min(i.b, c.g.d);
        b.a = $61de1ee1cac498ae$var$$wnd.Math.max(b.a, c.g.c + c.g.b);
        b.b = $61de1ee1cac498ae$var$$wnd.Math.max(b.b, c.g.d + c.g.a);
    }
    for(h = $61de1ee1cac498ae$var$Uc(a.c).a.nc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 46);
        c = $61de1ee1cac498ae$var$BD(g.b, 81);
        i.a = $61de1ee1cac498ae$var$$wnd.Math.min(i.a, c.g.c);
        i.b = $61de1ee1cac498ae$var$$wnd.Math.min(i.b, c.g.d);
        b.a = $61de1ee1cac498ae$var$$wnd.Math.max(b.a, c.g.c + c.g.b);
        b.b = $61de1ee1cac498ae$var$$wnd.Math.max(b.b, c.g.d + c.g.a);
    }
    a.d = $61de1ee1cac498ae$var$V6c(new $61de1ee1cac498ae$var$f7c(i.a, i.b));
    a.e = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), i);
    a.a.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.a.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
}
function $61de1ee1cac498ae$var$svd(a) {
    var b, c, d;
    $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
        new $61de1ee1cac498ae$var$Z9c
    ]));
    c = new $61de1ee1cac498ae$var$xB(a);
    for(d = 0; d < c.a.length; ++d){
        b = $61de1ee1cac498ae$var$tB(c, d).je().a;
        $61de1ee1cac498ae$var$dfb(b, "layered") ? $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$kwc
        ])) : $61de1ee1cac498ae$var$dfb(b, "force") ? $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$TRb
        ])) : $61de1ee1cac498ae$var$dfb(b, "stress") ? $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$PSb
        ])) : $61de1ee1cac498ae$var$dfb(b, "mrtree") ? $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$sTc
        ])) : $61de1ee1cac498ae$var$dfb(b, "radial") ? $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$IWc
        ])) : $61de1ee1cac498ae$var$dfb(b, "disco") ? $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$gFb,
            new $61de1ee1cac498ae$var$oPb
        ])) : $61de1ee1cac498ae$var$dfb(b, "sporeOverlap") || $61de1ee1cac498ae$var$dfb(b, "sporeCompaction") ? $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$B0c
        ])) : $61de1ee1cac498ae$var$dfb(b, "rectpacking") && $61de1ee1cac498ae$var$l4c($61de1ee1cac498ae$var$lvd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$C0, 1), $61de1ee1cac498ae$var$Uhe, 130, 0, [
            new $61de1ee1cac498ae$var$PYc
        ]));
    }
}
function $61de1ee1cac498ae$var$j_b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    m = new $61de1ee1cac498ae$var$g7c(a.o);
    r = b.a / m.a;
    h = b.b / m.b;
    p = b.a - m.a;
    f = b.b - m.b;
    if (c) {
        e = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
        for(o = new $61de1ee1cac498ae$var$olb(a.j); o.a < o.c.c.length;){
            n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 11);
            switch(n.j.g){
                case 1:
                    e || (n.n.a *= r);
                    break;
                case 2:
                    n.n.a += p;
                    e || (n.n.b *= h);
                    break;
                case 3:
                    e || (n.n.a *= r);
                    n.n.b += f;
                    break;
                case 4:
                    e || (n.n.b *= h);
            }
        }
    }
    for(j = new $61de1ee1cac498ae$var$olb(a.b); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 70);
        k = i.n.a + i.o.a / 2;
        l = i.n.b + i.o.b / 2;
        q = k / m.a;
        g = l / m.b;
        if (q + g >= 1) {
            if (q - g > 0 && l >= 0) {
                i.n.a += p;
                i.n.b += f * g;
            } else if (q - g < 0 && k >= 0) {
                i.n.a += p * q;
                i.n.b += f;
            }
        }
    }
    a.o.a = b.a;
    a.o.b = b.b;
    $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fxc), ($61de1ee1cac498ae$var$tdd(), d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$I1), 9), new $61de1ee1cac498ae$var$xqb(d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(d, d.length), 9), 0)));
}
function $61de1ee1cac498ae$var$iFd(a, b, c, d, e, f) {
    var g;
    if (!(b == null || !$61de1ee1cac498ae$var$OEd(b, $61de1ee1cac498ae$var$zEd, $61de1ee1cac498ae$var$AEd))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("invalid scheme: " + b));
    if (!a && !(c != null && $61de1ee1cac498ae$var$hfb(c, $61de1ee1cac498ae$var$wfb(35)) == -1 && c.length > 0 && ($61de1ee1cac498ae$var$BCb(0, c.length), c.charCodeAt(0) != 47))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("invalid opaquePart: " + c));
    if (a && !(b != null && $61de1ee1cac498ae$var$hnb($61de1ee1cac498ae$var$GEd, b.toLowerCase())) && !(c == null || !$61de1ee1cac498ae$var$OEd(c, $61de1ee1cac498ae$var$CEd, $61de1ee1cac498ae$var$DEd))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$mve + c));
    if (a && b != null && $61de1ee1cac498ae$var$hnb($61de1ee1cac498ae$var$GEd, b.toLowerCase()) && !$61de1ee1cac498ae$var$eFd(c)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$mve + c));
    if (!$61de1ee1cac498ae$var$fFd(d)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("invalid device: " + d));
    if (!$61de1ee1cac498ae$var$hFd(e)) {
        g = e == null ? "invalid segments: null" : "invalid segment: " + $61de1ee1cac498ae$var$VEd(e);
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb(g));
    }
    if (!(f == null || $61de1ee1cac498ae$var$hfb(f, $61de1ee1cac498ae$var$wfb(35)) == -1)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("invalid query: " + f));
}
function $61de1ee1cac498ae$var$nVc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    $61de1ee1cac498ae$var$Odd(b, "Calculate Graph Size", 1);
    b.n && !!a && $61de1ee1cac498ae$var$Tdd(b, $61de1ee1cac498ae$var$i6d(a), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    h = $61de1ee1cac498ae$var$dme;
    i = $61de1ee1cac498ae$var$dme;
    f = $61de1ee1cac498ae$var$ere;
    g = $61de1ee1cac498ae$var$ere;
    for(l = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); l.e != l.i.gc();){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(l), 33);
        o = j.i;
        p = j.j;
        r = j.g;
        d = j.f;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(j, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$S8c)), 142);
        h = $61de1ee1cac498ae$var$$wnd.Math.min(h, o - e.b);
        i = $61de1ee1cac498ae$var$$wnd.Math.min(i, p - e.d);
        f = $61de1ee1cac498ae$var$$wnd.Math.max(f, o + r + e.c);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(g, p + d + e.a);
    }
    n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c)), 116);
    m = new $61de1ee1cac498ae$var$f7c(h - n.b, i - n.d);
    for(k = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); k.e != k.i.gc();){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(k), 33);
        $61de1ee1cac498ae$var$dld(j, j.i - m.a);
        $61de1ee1cac498ae$var$eld(j, j.j - m.b);
    }
    q = f - h + (n.b + n.c);
    c = g - i + (n.d + n.a);
    $61de1ee1cac498ae$var$cld(a, q);
    $61de1ee1cac498ae$var$ald(a, c);
    b.n && !!a && $61de1ee1cac498ae$var$Tdd(b, $61de1ee1cac498ae$var$i6d(a), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
}
function $61de1ee1cac498ae$var$rGb(a) {
    var b, c, d, e, f, g, h, i, j, k;
    d = new $61de1ee1cac498ae$var$Rkb;
    for(g = new $61de1ee1cac498ae$var$olb(a.e.a); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 121);
        k = 0;
        e.k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        for(c = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$LFb(e)); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 213);
            if (b.f) {
                $61de1ee1cac498ae$var$Ekb(e.k, b);
                ++k;
            }
        }
        k == 1 && (d.c[d.c.length] = e);
    }
    for(f = new $61de1ee1cac498ae$var$olb(d); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 121);
        while(e.k.c.length == 1){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(new $61de1ee1cac498ae$var$olb(e.k)), 213);
            a.b[j.c] = j.g;
            h = j.d;
            i = j.e;
            for(c = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$LFb(e)); c.a < c.c.c.length;){
                b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 213);
                $61de1ee1cac498ae$var$pb(b, j) || (b.f ? h == b.d || i == b.e ? a.b[j.c] -= a.b[b.c] - b.g : a.b[j.c] += a.b[b.c] - b.g : e == h ? b.d == e ? a.b[j.c] += b.g : a.b[j.c] -= b.g : b.d == e ? a.b[j.c] -= b.g : a.b[j.c] += b.g);
            }
            $61de1ee1cac498ae$var$Lkb(h.k, j);
            $61de1ee1cac498ae$var$Lkb(i.k, j);
            h == e ? e = j.e : e = j.d;
        }
    }
}
function $61de1ee1cac498ae$var$k4c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if (b == null || b.length == 0) return null;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb(a.f, b), 23);
    if (!f) {
        for(e = (n = new $61de1ee1cac498ae$var$$ib(a.d).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(n)); e.a.Ob();){
            c = (g = $61de1ee1cac498ae$var$BD(e.a.Pb(), 42), $61de1ee1cac498ae$var$BD(g.dd(), 23));
            h = c.f;
            o = b.length;
            if ($61de1ee1cac498ae$var$dfb(h.substr(h.length - o, o), b) && (b.length == h.length || $61de1ee1cac498ae$var$bfb(h, h.length - b.length - 1) == 46)) {
                if (f) return null;
                f = c;
            }
        }
        if (!f) for(d = (m = new $61de1ee1cac498ae$var$$ib(a.d).a.vc().Kc(), new $61de1ee1cac498ae$var$djb(m)); d.a.Ob();){
            c = (g = $61de1ee1cac498ae$var$BD(d.a.Pb(), 42), $61de1ee1cac498ae$var$BD(g.dd(), 23));
            l = c.g;
            if (l != null) for(i = l, j = 0, k = i.length; j < k; ++j){
                h = i[j];
                o = b.length;
                if ($61de1ee1cac498ae$var$dfb(h.substr(h.length - o, o), b) && (b.length == h.length || $61de1ee1cac498ae$var$bfb(h, h.length - b.length - 1) == 46)) {
                    if (f) return null;
                    f = c;
                }
            }
        }
        !!f && $61de1ee1cac498ae$var$Shb(a.f, b, f);
    }
    return f;
}
function $61de1ee1cac498ae$var$sA(a, b) {
    var c, d, e, f, g;
    c = new $61de1ee1cac498ae$var$Vfb;
    g = false;
    for(f = 0; f < b.length; f++){
        d = ($61de1ee1cac498ae$var$BCb(f, b.length), b.charCodeAt(f));
        if (d == 32) {
            $61de1ee1cac498ae$var$gA(a, c, 0);
            c.a += " ";
            $61de1ee1cac498ae$var$gA(a, c, 0);
            while(f + 1 < b.length && ($61de1ee1cac498ae$var$BCb(f + 1, b.length), b.charCodeAt(f + 1) == 32))++f;
            continue;
        }
        if (g) {
            if (d == 39) {
                if (f + 1 < b.length && ($61de1ee1cac498ae$var$BCb(f + 1, b.length), b.charCodeAt(f + 1) == 39)) {
                    c.a += String.fromCharCode(d);
                    ++f;
                } else g = false;
            } else c.a += String.fromCharCode(d);
            continue;
        }
        if ($61de1ee1cac498ae$var$hfb("GyMLdkHmsSEcDahKzZv", $61de1ee1cac498ae$var$wfb(d)) > 0) {
            $61de1ee1cac498ae$var$gA(a, c, 0);
            c.a += String.fromCharCode(d);
            e = $61de1ee1cac498ae$var$lA(b, f);
            $61de1ee1cac498ae$var$gA(a, c, e);
            f += e - 1;
            continue;
        }
        if (d == 39) {
            if (f + 1 < b.length && ($61de1ee1cac498ae$var$BCb(f + 1, b.length), b.charCodeAt(f + 1) == 39)) {
                c.a += "'";
                ++f;
            } else g = true;
        } else c.a += String.fromCharCode(d);
    }
    $61de1ee1cac498ae$var$gA(a, c, 0);
    $61de1ee1cac498ae$var$mA(a);
}
function $61de1ee1cac498ae$var$wDc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    $61de1ee1cac498ae$var$Odd(c, "Network simplex layering", 1);
    a.b = b;
    r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Ayc)), 19).a * 4;
    q = a.b.a;
    if (q.c.length < 1) {
        $61de1ee1cac498ae$var$Qdd(c);
        return;
    }
    f = $61de1ee1cac498ae$var$sDc(a, q);
    p = null;
    for(e = $61de1ee1cac498ae$var$Jsb(f, 0); e.b != e.d.c;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(e), 15);
        h = r * $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.sqrt(d.gc()));
        g = $61de1ee1cac498ae$var$vDc(d);
        $61de1ee1cac498ae$var$uGb($61de1ee1cac498ae$var$HGb($61de1ee1cac498ae$var$JGb($61de1ee1cac498ae$var$IGb($61de1ee1cac498ae$var$LGb(g), h), p), true), $61de1ee1cac498ae$var$Udd(c, 1));
        m = a.b.b;
        for(o = new $61de1ee1cac498ae$var$olb(g.a); o.a < o.c.c.length;){
            n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 121);
            while(m.c.length <= n.e)$61de1ee1cac498ae$var$Dkb(m, m.c.length, new $61de1ee1cac498ae$var$H1b(a.b));
            k = $61de1ee1cac498ae$var$BD(n.f, 10);
            $61de1ee1cac498ae$var$$_b(k, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(m, n.e), 29));
        }
        if (f.b > 1) {
            p = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b.b.c.length, 15, 1);
            l = 0;
            for(j = new $61de1ee1cac498ae$var$olb(a.b.b); j.a < j.c.c.length;){
                i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 29);
                p[l++] = i.a.c.length;
            }
        }
    }
    q.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.a = null;
    a.b = null;
    a.c = null;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$OUb(a) {
    var b, c, d, e, f, g, h;
    b = 0;
    for(f = new $61de1ee1cac498ae$var$olb(a.b.a); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 189);
        d.b = 0;
        d.c = 0;
    }
    $61de1ee1cac498ae$var$NUb(a, 0);
    $61de1ee1cac498ae$var$MUb(a, a.g);
    $61de1ee1cac498ae$var$sVb(a.c);
    $61de1ee1cac498ae$var$wVb(a.c);
    c = ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad);
    $61de1ee1cac498ae$var$uVb($61de1ee1cac498ae$var$oVb($61de1ee1cac498ae$var$tVb($61de1ee1cac498ae$var$uVb($61de1ee1cac498ae$var$oVb($61de1ee1cac498ae$var$tVb($61de1ee1cac498ae$var$uVb($61de1ee1cac498ae$var$tVb(a.c, c)), $61de1ee1cac498ae$var$had(c)))), c)));
    $61de1ee1cac498ae$var$tVb(a.c, $61de1ee1cac498ae$var$aad);
    $61de1ee1cac498ae$var$RUb(a, a.g);
    $61de1ee1cac498ae$var$SUb(a, 0);
    $61de1ee1cac498ae$var$TUb(a, 0);
    $61de1ee1cac498ae$var$UUb(a, 1);
    $61de1ee1cac498ae$var$NUb(a, 1);
    $61de1ee1cac498ae$var$MUb(a, a.d);
    $61de1ee1cac498ae$var$sVb(a.c);
    for(g = new $61de1ee1cac498ae$var$olb(a.b.a); g.a < g.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 189);
        b += $61de1ee1cac498ae$var$$wnd.Math.abs(d.c);
    }
    for(h = new $61de1ee1cac498ae$var$olb(a.b.a); h.a < h.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 189);
        d.b = 0;
        d.c = 0;
    }
    c = $61de1ee1cac498ae$var$dad;
    $61de1ee1cac498ae$var$uVb($61de1ee1cac498ae$var$oVb($61de1ee1cac498ae$var$tVb($61de1ee1cac498ae$var$uVb($61de1ee1cac498ae$var$oVb($61de1ee1cac498ae$var$tVb($61de1ee1cac498ae$var$uVb($61de1ee1cac498ae$var$wVb($61de1ee1cac498ae$var$tVb(a.c, c))), $61de1ee1cac498ae$var$had(c)))), c)));
    $61de1ee1cac498ae$var$tVb(a.c, $61de1ee1cac498ae$var$aad);
    $61de1ee1cac498ae$var$RUb(a, a.d);
    $61de1ee1cac498ae$var$SUb(a, 1);
    $61de1ee1cac498ae$var$TUb(a, 1);
    $61de1ee1cac498ae$var$UUb(a, 0);
    $61de1ee1cac498ae$var$wVb(a.c);
    for(e = new $61de1ee1cac498ae$var$olb(a.b.a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 189);
        b += $61de1ee1cac498ae$var$$wnd.Math.abs(d.c);
    }
    return b;
}
function $61de1ee1cac498ae$var$Wfe(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = b;
    if (j.b == null || a.b == null) return;
    $61de1ee1cac498ae$var$Yfe(a);
    $61de1ee1cac498ae$var$Vfe(a);
    $61de1ee1cac498ae$var$Yfe(j);
    $61de1ee1cac498ae$var$Vfe(j);
    c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b.length + j.b.length, 15, 1);
    k = 0;
    d = 0;
    g = 0;
    while(d < a.b.length && g < j.b.length){
        e = a.b[d];
        f = a.b[d + 1];
        h = j.b[g];
        i = j.b[g + 1];
        if (f < h) d += 2;
        else if (f >= h && e <= i) {
            if (h <= e && f <= i) {
                c[k++] = e;
                c[k++] = f;
                d += 2;
            } else if (h <= e) {
                c[k++] = e;
                c[k++] = i;
                a.b[d] = i + 1;
                g += 2;
            } else if (f <= i) {
                c[k++] = h;
                c[k++] = f;
                d += 2;
            } else {
                c[k++] = h;
                c[k++] = i;
                a.b[d] = i + 1;
            }
        } else if (i < e) g += 2;
        else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Token#intersectRanges(): Internal Error: [" + a.b[d] + "," + a.b[d + 1] + "] & [" + j.b[g] + "," + j.b[g + 1] + "]"));
    }
    while(d < a.b.length){
        c[k++] = a.b[d++];
        c[k++] = a.b[d++];
    }
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, k, 15, 1);
    $61de1ee1cac498ae$var$$fb(c, 0, a.b, 0, k);
}
function $61de1ee1cac498ae$var$PUb(a) {
    var b, c, d, e, f, g, h;
    b = new $61de1ee1cac498ae$var$Rkb;
    a.g = new $61de1ee1cac498ae$var$Rkb;
    a.d = new $61de1ee1cac498ae$var$Rkb;
    for(g = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(a.f.b).a); g.b;){
        f = $61de1ee1cac498ae$var$lib(g);
        $61de1ee1cac498ae$var$Ekb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(f.dd(), 46).b, 81));
        $61de1ee1cac498ae$var$fad($61de1ee1cac498ae$var$BD(f.cd(), 594).gf()) ? $61de1ee1cac498ae$var$Ekb(a.d, $61de1ee1cac498ae$var$BD(f.dd(), 46)) : $61de1ee1cac498ae$var$Ekb(a.g, $61de1ee1cac498ae$var$BD(f.dd(), 46));
    }
    $61de1ee1cac498ae$var$MUb(a, a.d);
    $61de1ee1cac498ae$var$MUb(a, a.g);
    a.c = new $61de1ee1cac498ae$var$CVb(a.b);
    $61de1ee1cac498ae$var$AVb(a.c, ($61de1ee1cac498ae$var$xUb(), $61de1ee1cac498ae$var$wUb));
    $61de1ee1cac498ae$var$RUb(a, a.d);
    $61de1ee1cac498ae$var$RUb(a, a.g);
    $61de1ee1cac498ae$var$Gkb(b, a.c.a.b);
    a.e = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Pje, $61de1ee1cac498ae$var$Pje);
    a.a = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Qje, $61de1ee1cac498ae$var$Qje);
    for(d = new $61de1ee1cac498ae$var$olb(b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 81);
        a.e.a = $61de1ee1cac498ae$var$$wnd.Math.min(a.e.a, c.g.c);
        a.e.b = $61de1ee1cac498ae$var$$wnd.Math.min(a.e.b, c.g.d);
        a.a.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.a.a, c.g.c + c.g.b);
        a.a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.a.b, c.g.d + c.g.a);
    }
    $61de1ee1cac498ae$var$zVb(a.c, new $61de1ee1cac498ae$var$YUb);
    h = 0;
    do {
        e = $61de1ee1cac498ae$var$OUb(a);
        ++h;
    }while ((h < 2 || e > $61de1ee1cac498ae$var$Qie) && h < 10);
    $61de1ee1cac498ae$var$zVb(a.c, new $61de1ee1cac498ae$var$_Ub);
    $61de1ee1cac498ae$var$OUb(a);
    $61de1ee1cac498ae$var$vVb(a.c);
    $61de1ee1cac498ae$var$yUb(a.f);
}
function $61de1ee1cac498ae$var$sZb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$fxc))))) return;
    for(h = new $61de1ee1cac498ae$var$olb(c.j); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 11);
        m = $61de1ee1cac498ae$var$k_b(g.g);
        for(j = m, k = 0, l = j.length; k < l; ++k){
            i = j[k];
            f = i.d.i == c;
            e = f && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$gxc)));
            if (e) {
                o = i.c;
                n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, o), 10);
                if (!n) {
                    n = $61de1ee1cac498ae$var$Z$b(o, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$bcd), o.j, -1, null, null, o.o, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Lwc), 103), b);
                    $61de1ee1cac498ae$var$yNb(n, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), o);
                    $61de1ee1cac498ae$var$Rhb(a.b, o, n);
                    $61de1ee1cac498ae$var$Ekb(b.a, n);
                }
                q = i.d;
                p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, q), 10);
                if (!p) {
                    p = $61de1ee1cac498ae$var$Z$b(q, ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$bcd), q.j, 1, null, null, q.o, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Lwc), 103), b);
                    $61de1ee1cac498ae$var$yNb(p, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), q);
                    $61de1ee1cac498ae$var$Rhb(a.b, q, p);
                    $61de1ee1cac498ae$var$Ekb(b.a, p);
                }
                d = $61de1ee1cac498ae$var$kZb(i);
                $61de1ee1cac498ae$var$QZb(d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(n.j, 0), 11));
                $61de1ee1cac498ae$var$RZb(d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(p.j, 0), 11));
                $61de1ee1cac498ae$var$Rc(a.a, i, new $61de1ee1cac498ae$var$BZb(d, b, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)));
                $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc));
            }
        }
    }
}
function $61de1ee1cac498ae$var$W9b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    $61de1ee1cac498ae$var$Odd(c, "Label dummy switching", 1);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Owc)), 227);
    $61de1ee1cac498ae$var$J9b(b);
    e = $61de1ee1cac498ae$var$T9b(b, d);
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, b.b.c.length, 15, 1);
    for(h = ($61de1ee1cac498ae$var$Apc(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$EW, 1), $61de1ee1cac498ae$var$Kie, 227, 0, [
        $61de1ee1cac498ae$var$wpc,
        $61de1ee1cac498ae$var$ypc,
        $61de1ee1cac498ae$var$vpc,
        $61de1ee1cac498ae$var$xpc,
        $61de1ee1cac498ae$var$zpc,
        $61de1ee1cac498ae$var$upc
    ])), k = 0, n = h.length; k < n; ++k){
        f = h[k];
        if ((f == $61de1ee1cac498ae$var$zpc || f == $61de1ee1cac498ae$var$upc || f == $61de1ee1cac498ae$var$xpc) && !$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$uqb(e.a, f) ? e.b[f.g] : null, 15).dc()) {
            $61de1ee1cac498ae$var$M9b(a, b);
            break;
        }
    }
    for(i = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$EW, 1), $61de1ee1cac498ae$var$Kie, 227, 0, [
        $61de1ee1cac498ae$var$wpc,
        $61de1ee1cac498ae$var$ypc,
        $61de1ee1cac498ae$var$vpc,
        $61de1ee1cac498ae$var$xpc,
        $61de1ee1cac498ae$var$zpc,
        $61de1ee1cac498ae$var$upc
    ]), l = 0, o = i.length; l < o; ++l){
        f = i[l];
        f == $61de1ee1cac498ae$var$zpc || f == $61de1ee1cac498ae$var$upc || f == $61de1ee1cac498ae$var$xpc || $61de1ee1cac498ae$var$X9b(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$uqb(e.a, f) ? e.b[f.g] : null, 15));
    }
    for(g = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$EW, 1), $61de1ee1cac498ae$var$Kie, 227, 0, [
        $61de1ee1cac498ae$var$wpc,
        $61de1ee1cac498ae$var$ypc,
        $61de1ee1cac498ae$var$vpc,
        $61de1ee1cac498ae$var$xpc,
        $61de1ee1cac498ae$var$zpc,
        $61de1ee1cac498ae$var$upc
    ]), j = 0, m = g.length; j < m; ++j){
        f = g[j];
        (f == $61de1ee1cac498ae$var$zpc || f == $61de1ee1cac498ae$var$upc || f == $61de1ee1cac498ae$var$xpc) && $61de1ee1cac498ae$var$X9b(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$uqb(e.a, f) ? e.b[f.g] : null, 15));
    }
    a.a = null;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$AFc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    switch(a.k.g){
        case 1:
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 17);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$_sc), 74);
            !c ? c = new $61de1ee1cac498ae$var$s7c : $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$ltc))) && (c = $61de1ee1cac498ae$var$w7c(c));
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Vsc), 11);
            if (j) {
                k = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    j.i.n,
                    j.n,
                    j.a
                ]));
                if (b <= k.a) return k.b;
                $61de1ee1cac498ae$var$Gsb(c, k, c.a, c.a.a);
            }
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Wsc), 11);
            if (l) {
                m = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    l.i.n,
                    l.n,
                    l.a
                ]));
                if (m.a <= b) return m.b;
                $61de1ee1cac498ae$var$Gsb(c, m, c.c.b, c.c);
            }
            if (c.b >= 2) {
                i = $61de1ee1cac498ae$var$Jsb(c, 0);
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(i), 8);
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(i), 8);
                while(h.a < b && i.b != i.d.c){
                    g = h;
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(i), 8);
                }
                return g.b + (b - g.a) / (h.a - g.a) * (h.b - g.b);
            }
            break;
        case 3:
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, 0), 11), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11);
            e = f.i;
            switch(f.j.g){
                case 1:
                    return e.n.b;
                case 3:
                    return e.n.b + e.o.b;
            }
    }
    return $61de1ee1cac498ae$var$T_b(a).b;
}
function $61de1ee1cac498ae$var$Wgc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    for(g = new $61de1ee1cac498ae$var$olb(a.d.b); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        for(i = new $61de1ee1cac498ae$var$olb(f.a); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$pwc))))) {
                if (!$61de1ee1cac498ae$var$Qq($61de1ee1cac498ae$var$O_b(h))) {
                    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Oq($61de1ee1cac498ae$var$O_b(h)), 17);
                    k = d.c.i;
                    k == h && (k = d.d.i);
                    l = new $61de1ee1cac498ae$var$vgd(k, $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(h.n), k.n));
                    $61de1ee1cac498ae$var$Rhb(a.b, h, l);
                    continue;
                }
            }
            e = new $61de1ee1cac498ae$var$J6c(h.n.a - h.d.b, h.n.b - h.d.d, h.o.a + h.d.b + h.d.c, h.o.b + h.d.d + h.d.a);
            b = $61de1ee1cac498ae$var$vDb($61de1ee1cac498ae$var$yDb($61de1ee1cac498ae$var$wDb($61de1ee1cac498ae$var$xDb(new $61de1ee1cac498ae$var$zDb, h), e), $61de1ee1cac498ae$var$Fgc), a.a);
            $61de1ee1cac498ae$var$pDb($61de1ee1cac498ae$var$qDb($61de1ee1cac498ae$var$rDb(new $61de1ee1cac498ae$var$sDb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$PM, 1), $61de1ee1cac498ae$var$Uhe, 57, 0, [
                b
            ])), b), a.a);
            j = new $61de1ee1cac498ae$var$lEb;
            $61de1ee1cac498ae$var$Rhb(a.e, b, j);
            c = $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(h).a.Kc(), new $61de1ee1cac498ae$var$Sq))) - $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
            c < 0 ? $61de1ee1cac498ae$var$jEb(j, true, ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$aad)) : c > 0 && $61de1ee1cac498ae$var$jEb(j, true, ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$bad));
            h.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) && $61de1ee1cac498ae$var$kEb(j);
            $61de1ee1cac498ae$var$Rhb(a.f, h, b);
        }
    }
}
function $61de1ee1cac498ae$var$Bbc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    $61de1ee1cac498ae$var$Odd(c, "Node promotion heuristic", 1);
    a.g = b;
    $61de1ee1cac498ae$var$Abc(a);
    a.q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$rxc)), 260);
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.g, $61de1ee1cac498ae$var$qxc), 19).a;
    f = new $61de1ee1cac498ae$var$Jbc;
    switch(a.q.g){
        case 2:
        case 1:
            $61de1ee1cac498ae$var$Dbc(a, f);
            break;
        case 3:
            a.q = ($61de1ee1cac498ae$var$kAc(), $61de1ee1cac498ae$var$jAc);
            $61de1ee1cac498ae$var$Dbc(a, f);
            i = 0;
            for(h = new $61de1ee1cac498ae$var$olb(a.a); h.a < h.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 19);
                i = $61de1ee1cac498ae$var$$wnd.Math.max(i, g.a);
            }
            if (i > a.j) {
                a.q = $61de1ee1cac498ae$var$dAc;
                $61de1ee1cac498ae$var$Dbc(a, f);
            }
            break;
        case 4:
            a.q = ($61de1ee1cac498ae$var$kAc(), $61de1ee1cac498ae$var$jAc);
            $61de1ee1cac498ae$var$Dbc(a, f);
            j = 0;
            for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$mlb(e));
                j = $61de1ee1cac498ae$var$$wnd.Math.max(j, ($61de1ee1cac498ae$var$uCb(d), d));
            }
            if (j > a.k) {
                a.q = $61de1ee1cac498ae$var$gAc;
                $61de1ee1cac498ae$var$Dbc(a, f);
            }
            break;
        case 6:
            m = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(a.f.length * k / 100));
            $61de1ee1cac498ae$var$Dbc(a, new $61de1ee1cac498ae$var$Mbc(m));
            break;
        case 5:
            l = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(a.d * k / 100));
            $61de1ee1cac498ae$var$Dbc(a, new $61de1ee1cac498ae$var$Pbc(l));
            break;
        default:
            $61de1ee1cac498ae$var$Dbc(a, f);
    }
    $61de1ee1cac498ae$var$Ebc(a, b);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$fFc(a, b, c) {
    var d, e, f, g;
    this.j = a;
    this.e = $61de1ee1cac498ae$var$WZb(a);
    this.o = this.j.e;
    this.i = !!this.o;
    this.p = this.i ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c, $61de1ee1cac498ae$var$Q_b(this.o).p), 214) : null;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21);
    this.g = e.Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc));
    this.b = new $61de1ee1cac498ae$var$Rkb;
    this.d = new $61de1ee1cac498ae$var$rHc(this.e);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(this.j, $61de1ee1cac498ae$var$jtc), 230);
    this.q = $61de1ee1cac498ae$var$wFc(b, g, this.e);
    this.k = new $61de1ee1cac498ae$var$BGc(this);
    f = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$qY, 1), $61de1ee1cac498ae$var$Uhe, 225, 0, [
        this,
        this.d,
        this.k,
        this.q
    ]));
    if (b == ($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$oGc) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Awc))))) {
        d = new $61de1ee1cac498ae$var$SEc(this.e);
        f.c[f.c.length] = d;
        this.c = new $61de1ee1cac498ae$var$uEc(d, g, $61de1ee1cac498ae$var$BD(this.q, 402));
    } else if (b == $61de1ee1cac498ae$var$oGc && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Awc))))) {
        d = new $61de1ee1cac498ae$var$SEc(this.e);
        f.c[f.c.length] = d;
        this.c = new $61de1ee1cac498ae$var$XGc(d, g, $61de1ee1cac498ae$var$BD(this.q, 402));
    } else this.c = new $61de1ee1cac498ae$var$Oic(b, this);
    $61de1ee1cac498ae$var$Ekb(f, this.c);
    $61de1ee1cac498ae$var$$Ic(f, this.e);
    this.s = $61de1ee1cac498ae$var$AGc(this.k);
}
function $61de1ee1cac498ae$var$xUc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$pr((g = $61de1ee1cac498ae$var$Jsb(new $61de1ee1cac498ae$var$ZRc(b).a.d, 0), new $61de1ee1cac498ae$var$aSc(g))), 86);
    o = l ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(l, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$_Sc)), 86) : null;
    e = 1;
    while(!!l && !!o){
        i = 0;
        u = 0;
        c = l;
        d = o;
        for(h = 0; h < e; h++){
            c = $61de1ee1cac498ae$var$VRc(c);
            d = $61de1ee1cac498ae$var$VRc(d);
            u += $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$cTc))));
            i += $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$cTc)));
        }
        t = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(o, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$fTc))));
        s = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(l, $61de1ee1cac498ae$var$fTc)));
        m = $61de1ee1cac498ae$var$zUc(l, o);
        n = t + i + a.a + m - s - u;
        if (0 < n) {
            j = b;
            k = 0;
            while(!!j && j != d){
                ++k;
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$aTc), 86);
            }
            if (j) {
                r = n / k;
                j = b;
                while(j != d){
                    q = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$fTc))) + n;
                    $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$fTc, q);
                    p = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$cTc))) + n;
                    $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$cTc, p);
                    n -= r;
                    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$aTc), 86);
                }
            } else return;
        }
        ++e;
        l.d.b == 0 ? l = $61de1ee1cac498ae$var$JRc(new $61de1ee1cac498ae$var$ZRc(b), e) : l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$pr((f = $61de1ee1cac498ae$var$Jsb(new $61de1ee1cac498ae$var$ZRc(l).a.d, 0), new $61de1ee1cac498ae$var$aSc(f))), 86);
        o = l ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(l, $61de1ee1cac498ae$var$_Sc), 86) : null;
    }
}
function $61de1ee1cac498ae$var$Cbc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    i = true;
    e = 0;
    j = a.f[b.p];
    k = b.o.b + a.n;
    c = a.c[b.p][2];
    $61de1ee1cac498ae$var$Nkb(a.a, j, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, j), 19).a - 1 + c));
    $61de1ee1cac498ae$var$Nkb(a.b, j, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ikb(a.b, j))) - k + c * a.e);
    ++j;
    if (j >= a.i) {
        ++a.i;
        $61de1ee1cac498ae$var$Ekb(a.a, $61de1ee1cac498ae$var$meb(1));
        $61de1ee1cac498ae$var$Ekb(a.b, k);
    } else {
        d = a.c[b.p][1];
        $61de1ee1cac498ae$var$Nkb(a.a, j, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, j), 19).a + 1 - d));
        $61de1ee1cac498ae$var$Nkb(a.b, j, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ikb(a.b, j))) + k - d * a.e);
    }
    (a.q == ($61de1ee1cac498ae$var$kAc(), $61de1ee1cac498ae$var$dAc) && ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, j), 19).a > a.j || $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.a, j - 1), 19).a > a.j) || a.q == $61de1ee1cac498ae$var$gAc && ($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ikb(a.b, j))) > a.k || $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ikb(a.b, j - 1))) > a.k)) && (i = false);
    for(g = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(b).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(g);){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(g), 17);
        h = f.c.i;
        if (a.f[h.p] == j) {
            l = $61de1ee1cac498ae$var$Cbc(a, h);
            e = e + $61de1ee1cac498ae$var$BD(l.a, 19).a;
            i = i && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(l.b));
        }
    }
    a.f[b.p] = j;
    e = e + a.c[b.p][0];
    return new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(e), ($61de1ee1cac498ae$var$Bcb(), i ? true : false));
}
function $61de1ee1cac498ae$var$sPc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r;
    l = new $61de1ee1cac498ae$var$Lqb;
    g = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$qPc(a, c, a.d.fg(), g, l);
    $61de1ee1cac498ae$var$qPc(a, d, a.d.gg(), g, l);
    a.b = 0.2 * (p = $61de1ee1cac498ae$var$rPc($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(g, 16)), new $61de1ee1cac498ae$var$xPc)), q = $61de1ee1cac498ae$var$rPc($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(g, 16)), new $61de1ee1cac498ae$var$zPc)), $61de1ee1cac498ae$var$$wnd.Math.min(p, q));
    f = 0;
    for(h = 0; h < g.c.length - 1; h++){
        i = ($61de1ee1cac498ae$var$tCb(h, g.c.length), $61de1ee1cac498ae$var$BD(g.c[h], 112));
        for(o = h + 1; o < g.c.length; o++)f += $61de1ee1cac498ae$var$pPc(a, i, ($61de1ee1cac498ae$var$tCb(o, g.c.length), $61de1ee1cac498ae$var$BD(g.c[o], 112)));
    }
    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$jtc)), 230);
    f >= 2 && (r = $61de1ee1cac498ae$var$WNc(g, true, m), !a.e && (a.e = new $61de1ee1cac498ae$var$ZOc(a)), $61de1ee1cac498ae$var$VOc(a.e, r, g, a.b), undefined);
    $61de1ee1cac498ae$var$uPc(g, m);
    $61de1ee1cac498ae$var$wPc(g);
    n = -1;
    for(k = new $61de1ee1cac498ae$var$olb(g); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 112);
        if ($61de1ee1cac498ae$var$$wnd.Math.abs(j.s - j.c) < $61de1ee1cac498ae$var$qme) continue;
        n = $61de1ee1cac498ae$var$$wnd.Math.max(n, j.o);
        a.d.dg(j, e, a.c);
    }
    a.d.a.a.$b();
    return n + 1;
}
function $61de1ee1cac498ae$var$aUb(a, b) {
    var c, d, e, f, g;
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$lyc))));
    c < 2 && $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$lyc, 2);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Lwc), 103);
    d == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad) && $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$Lwc, $61de1ee1cac498ae$var$a_b(b));
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$fyc), 19);
    e.a == 0 ? $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$jtc), new $61de1ee1cac498ae$var$Gub) : $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$jtc), new $61de1ee1cac498ae$var$Hub(e.a));
    f = $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Axc));
    f == null && $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$Axc, ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Swc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$wad)) ? true : false));
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.a, 16)), new $61de1ee1cac498ae$var$dUb(a));
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.b, 16)), new $61de1ee1cac498ae$var$fUb), new $61de1ee1cac498ae$var$hUb(a));
    g = new $61de1ee1cac498ae$var$oBc(b);
    $61de1ee1cac498ae$var$yNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc), g);
    $61de1ee1cac498ae$var$H2c(a.a);
    $61de1ee1cac498ae$var$K2c(a.a, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Jwc), 246));
    $61de1ee1cac498ae$var$K2c(a.a, $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$sxc), 246));
    $61de1ee1cac498ae$var$K2c(a.a, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Iwc), 246));
    $61de1ee1cac498ae$var$K2c(a.a, $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Exc), 246));
    $61de1ee1cac498ae$var$K2c(a.a, $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$kNc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Swc), 218)));
    $61de1ee1cac498ae$var$E2c(a.a, $61de1ee1cac498ae$var$_Tb(b));
    $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$itc, $61de1ee1cac498ae$var$F2c(a.a, b));
}
function $61de1ee1cac498ae$var$fjc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    if (m = a.c[b], n = a.c[c], (o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(m, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Qsc)), 15), !!o && o.gc() != 0 && o.Hc(n)) || (p = m.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) && n.k != $61de1ee1cac498ae$var$g0b, q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(m, $61de1ee1cac498ae$var$Psc), 10), r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(n, $61de1ee1cac498ae$var$Psc), 10), s = q != r, t = !!q && q != m || !!r && r != n, u = $61de1ee1cac498ae$var$gjc(m, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)), v = $61de1ee1cac498ae$var$gjc(n, $61de1ee1cac498ae$var$Rcd), t = t | ($61de1ee1cac498ae$var$gjc(m, $61de1ee1cac498ae$var$Rcd) || $61de1ee1cac498ae$var$gjc(n, $61de1ee1cac498ae$var$Acd)), w = t && s || u || v, p && w) || m.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b) && n.k == $61de1ee1cac498ae$var$h0b || n.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b) && m.k == $61de1ee1cac498ae$var$h0b) return false;
    k = a.c[b];
    f = a.c[c];
    e = $61de1ee1cac498ae$var$LHc(a.e, k, f, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
    i = $61de1ee1cac498ae$var$LHc(a.i, k, f, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$Yic(a.f, k, f);
    j = $61de1ee1cac498ae$var$Hic(a.b, k, f) + $61de1ee1cac498ae$var$BD(e.a, 19).a + $61de1ee1cac498ae$var$BD(i.a, 19).a + a.f.d;
    h = $61de1ee1cac498ae$var$Hic(a.b, f, k) + $61de1ee1cac498ae$var$BD(e.b, 19).a + $61de1ee1cac498ae$var$BD(i.b, 19).a + a.f.b;
    if (a.a) {
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, $61de1ee1cac498ae$var$$sc), 11);
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$$sc), 11);
        d = $61de1ee1cac498ae$var$JHc(a.g, l, g);
        j += $61de1ee1cac498ae$var$BD(d.a, 19).a;
        h += $61de1ee1cac498ae$var$BD(d.b, 19).a;
    }
    return j > h;
}
function $61de1ee1cac498ae$var$k6b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    g = a.f;
    f = a.d;
    h = g.a + f.b + f.c;
    i = 0 - f.d - a.c.b;
    k = g.b + f.d + f.a - a.c.b;
    j = new $61de1ee1cac498ae$var$Rkb;
    l = new $61de1ee1cac498ae$var$Rkb;
    for(e = new $61de1ee1cac498ae$var$olb(b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        switch(c.g){
            case 1:
            case 2:
            case 3:
                $61de1ee1cac498ae$var$a6b(d);
                break;
            case 4:
                m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Txc), 8);
                n = !m ? 0 : m.a;
                d.n.a = h * $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$htc)))) - n;
                $61de1ee1cac498ae$var$M_b(d, true, false);
                break;
            case 5:
                o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Txc), 8);
                p = !o ? 0 : o.a;
                d.n.a = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$htc)))) - p;
                $61de1ee1cac498ae$var$M_b(d, true, false);
                g.a = $61de1ee1cac498ae$var$$wnd.Math.max(g.a, d.n.a + d.o.a / 2);
        }
        switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61).g){
            case 1:
                d.n.b = i;
                j.c[j.c.length] = d;
                break;
            case 3:
                d.n.b = k;
                l.c[l.c.length] = d;
        }
    }
    switch(c.g){
        case 1:
        case 2:
            $61de1ee1cac498ae$var$c6b(j, a);
            $61de1ee1cac498ae$var$c6b(l, a);
            break;
        case 3:
            $61de1ee1cac498ae$var$i6b(j, a);
            $61de1ee1cac498ae$var$i6b(l, a);
    }
}
function $61de1ee1cac498ae$var$VHc(a, b) {
    var c, d, e, f, g, h, i, j, k, l;
    k = new $61de1ee1cac498ae$var$Rkb;
    l = new $61de1ee1cac498ae$var$jkb;
    f = null;
    e = 0;
    for(d = 0; d < b.length; ++d){
        c = b[d];
        $61de1ee1cac498ae$var$XHc(f, c) && (e = $61de1ee1cac498ae$var$QHc(a, l, k, $61de1ee1cac498ae$var$EHc, e));
        $61de1ee1cac498ae$var$wNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Psc)) && (f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Psc), 10));
        switch(c.k.g){
            case 0:
                for(i = $61de1ee1cac498ae$var$Vq($61de1ee1cac498ae$var$Nq($61de1ee1cac498ae$var$V_b(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)), new $61de1ee1cac498ae$var$GIc)); $61de1ee1cac498ae$var$xc(i);){
                    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$yc(i), 11);
                    a.d[g.p] = e++;
                    k.c[k.c.length] = g;
                }
                e = $61de1ee1cac498ae$var$QHc(a, l, k, $61de1ee1cac498ae$var$EHc, e);
                for(j = $61de1ee1cac498ae$var$Vq($61de1ee1cac498ae$var$Nq($61de1ee1cac498ae$var$V_b(c, $61de1ee1cac498ae$var$Rcd), new $61de1ee1cac498ae$var$GIc)); $61de1ee1cac498ae$var$xc(j);){
                    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$yc(j), 11);
                    a.d[g.p] = e++;
                    k.c[k.c.length] = g;
                }
                break;
            case 3:
                if (!$61de1ee1cac498ae$var$V_b(c, $61de1ee1cac498ae$var$DHc).dc()) {
                    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$V_b(c, $61de1ee1cac498ae$var$DHc).Xb(0), 11);
                    a.d[g.p] = e++;
                    k.c[k.c.length] = g;
                }
                $61de1ee1cac498ae$var$V_b(c, $61de1ee1cac498ae$var$EHc).dc() || $61de1ee1cac498ae$var$Wjb(l, c);
                break;
            case 1:
                for(h = $61de1ee1cac498ae$var$V_b(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)).Kc(); h.Ob();){
                    g = $61de1ee1cac498ae$var$BD(h.Pb(), 11);
                    a.d[g.p] = e++;
                    k.c[k.c.length] = g;
                }
                $61de1ee1cac498ae$var$V_b(c, $61de1ee1cac498ae$var$zcd).Jc(new $61de1ee1cac498ae$var$EIc(l, c));
        }
    }
    $61de1ee1cac498ae$var$QHc(a, l, k, $61de1ee1cac498ae$var$EHc, e);
    return k;
}
function $61de1ee1cac498ae$var$y$c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    j = $61de1ee1cac498ae$var$Pje;
    k = $61de1ee1cac498ae$var$Pje;
    h = $61de1ee1cac498ae$var$Qje;
    i = $61de1ee1cac498ae$var$Qje;
    for(m = new $61de1ee1cac498ae$var$olb(b.i); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 65);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, l.a), 46).b, 33);
        $61de1ee1cac498ae$var$bld(e, l.b.c, l.b.d);
        j = $61de1ee1cac498ae$var$$wnd.Math.min(j, e.i);
        k = $61de1ee1cac498ae$var$$wnd.Math.min(k, e.j);
        h = $61de1ee1cac498ae$var$$wnd.Math.max(h, e.i + e.g);
        i = $61de1ee1cac498ae$var$$wnd.Math.max(i, e.j + e.f);
    }
    n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a.c, ($61de1ee1cac498ae$var$d0c(), $61de1ee1cac498ae$var$W_c)), 116);
    $61de1ee1cac498ae$var$Afd(a.c, h - j + (n.b + n.c), i - k + (n.d + n.a), true, true);
    $61de1ee1cac498ae$var$Efd(a.c, -j + n.b, -k + n.d);
    for(d = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Wod(a.c)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 79);
        g = $61de1ee1cac498ae$var$itd(c, true, true);
        o = $61de1ee1cac498ae$var$jtd(c);
        q = $61de1ee1cac498ae$var$ltd(c);
        p = new $61de1ee1cac498ae$var$f7c(o.i + o.g / 2, o.j + o.f / 2);
        f = new $61de1ee1cac498ae$var$f7c(q.i + q.g / 2, q.j + q.f / 2);
        r = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(f.a, f.b), p);
        $61de1ee1cac498ae$var$l6c(r, o.g, o.f);
        $61de1ee1cac498ae$var$P6c(p, r);
        s = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(p.a, p.b), f);
        $61de1ee1cac498ae$var$l6c(s, q.g, q.f);
        $61de1ee1cac498ae$var$P6c(f, s);
        $61de1ee1cac498ae$var$nmd(g, p.a, p.b);
        $61de1ee1cac498ae$var$gmd(g, f.a, f.b);
    }
}
function $61de1ee1cac498ae$var$EYb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    a.c = a.d;
    o = $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$gyc)));
    n = o == null || ($61de1ee1cac498ae$var$uCb(o), o);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc));
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Vxc), 98);
    c = !(e == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$Zbd) || e == $61de1ee1cac498ae$var$_bd || e == $61de1ee1cac498ae$var$$bd);
    if (n && (c || !f)) {
        for(l = new $61de1ee1cac498ae$var$olb(b.a); l.a < l.c.c.length;){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 10);
            j.p = 0;
        }
        m = new $61de1ee1cac498ae$var$Rkb;
        for(k = new $61de1ee1cac498ae$var$olb(b.a); k.a < k.c.c.length;){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
            d = $61de1ee1cac498ae$var$DYb(a, j, null);
            if (d) {
                i = new $61de1ee1cac498ae$var$XZb;
                $61de1ee1cac498ae$var$tNb(i, b);
                $61de1ee1cac498ae$var$yNb(i, $61de1ee1cac498ae$var$Esc, $61de1ee1cac498ae$var$BD(d.b, 21));
                $61de1ee1cac498ae$var$u_b(i.d, b.d);
                $61de1ee1cac498ae$var$yNb(i, $61de1ee1cac498ae$var$Hxc, null);
                for(h = $61de1ee1cac498ae$var$BD(d.a, 15).Kc(); h.Ob();){
                    g = $61de1ee1cac498ae$var$BD(h.Pb(), 10);
                    $61de1ee1cac498ae$var$Ekb(i.a, g);
                    g.a = i;
                }
                m.Fc(i);
            }
        }
        f && ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$twc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$OXb)) ? a.c = a.b : a.c = a.a);
    } else m = new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KQ, 1), $61de1ee1cac498ae$var$cne, 37, 0, [
        b
    ]));
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$twc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$QXb)) && ($61de1ee1cac498ae$var$mmb(), m.ad(new $61de1ee1cac498ae$var$HYb));
    return m;
}
function $61de1ee1cac498ae$var$KTc(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$Q3c($61de1ee1cac498ae$var$L3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$are), "ELK Mr. Tree"), "Tree-based algorithm provided by the Eclipse Layout Kernel. Computes a spanning tree of the input graph and arranges all nodes according to the resulting parent-children hierarchy. I pity the fool who doesn't use Mr. Tree Layout."), new $61de1ee1cac498ae$var$NTc), $61de1ee1cac498ae$var$bre), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$Csd(), $61de1ee1cac498ae$var$wsd)))));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$CTc);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$wme, 20);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$_le, $61de1ee1cac498ae$var$tme);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$vme, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$zme, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Zpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$vTc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$xTc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$yTc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$zTc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Gme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$wTc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Dme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ATc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Hme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$DTc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$Zqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ITc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$are, $61de1ee1cac498ae$var$$qe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$FTc));
}
function $61de1ee1cac498ae$var$zod(a) {
    if (a.q) return;
    a.q = true;
    a.p = $61de1ee1cac498ae$var$Lnd(a, 0);
    a.a = $61de1ee1cac498ae$var$Lnd(a, 1);
    $61de1ee1cac498ae$var$Qnd(a.a, 0);
    a.f = $61de1ee1cac498ae$var$Lnd(a, 2);
    $61de1ee1cac498ae$var$Qnd(a.f, 1);
    $61de1ee1cac498ae$var$Knd(a.f, 2);
    a.n = $61de1ee1cac498ae$var$Lnd(a, 3);
    $61de1ee1cac498ae$var$Knd(a.n, 3);
    $61de1ee1cac498ae$var$Knd(a.n, 4);
    $61de1ee1cac498ae$var$Knd(a.n, 5);
    $61de1ee1cac498ae$var$Knd(a.n, 6);
    a.g = $61de1ee1cac498ae$var$Lnd(a, 4);
    $61de1ee1cac498ae$var$Qnd(a.g, 7);
    $61de1ee1cac498ae$var$Knd(a.g, 8);
    a.c = $61de1ee1cac498ae$var$Lnd(a, 5);
    $61de1ee1cac498ae$var$Qnd(a.c, 7);
    $61de1ee1cac498ae$var$Qnd(a.c, 8);
    a.i = $61de1ee1cac498ae$var$Lnd(a, 6);
    $61de1ee1cac498ae$var$Qnd(a.i, 9);
    $61de1ee1cac498ae$var$Qnd(a.i, 10);
    $61de1ee1cac498ae$var$Qnd(a.i, 11);
    $61de1ee1cac498ae$var$Qnd(a.i, 12);
    $61de1ee1cac498ae$var$Knd(a.i, 13);
    a.j = $61de1ee1cac498ae$var$Lnd(a, 7);
    $61de1ee1cac498ae$var$Qnd(a.j, 9);
    a.d = $61de1ee1cac498ae$var$Lnd(a, 8);
    $61de1ee1cac498ae$var$Qnd(a.d, 3);
    $61de1ee1cac498ae$var$Qnd(a.d, 4);
    $61de1ee1cac498ae$var$Qnd(a.d, 5);
    $61de1ee1cac498ae$var$Qnd(a.d, 6);
    $61de1ee1cac498ae$var$Knd(a.d, 7);
    $61de1ee1cac498ae$var$Knd(a.d, 8);
    $61de1ee1cac498ae$var$Knd(a.d, 9);
    $61de1ee1cac498ae$var$Knd(a.d, 10);
    a.b = $61de1ee1cac498ae$var$Lnd(a, 9);
    $61de1ee1cac498ae$var$Knd(a.b, 0);
    $61de1ee1cac498ae$var$Knd(a.b, 1);
    a.e = $61de1ee1cac498ae$var$Lnd(a, 10);
    $61de1ee1cac498ae$var$Knd(a.e, 1);
    $61de1ee1cac498ae$var$Knd(a.e, 2);
    $61de1ee1cac498ae$var$Knd(a.e, 3);
    $61de1ee1cac498ae$var$Knd(a.e, 4);
    $61de1ee1cac498ae$var$Qnd(a.e, 5);
    $61de1ee1cac498ae$var$Qnd(a.e, 6);
    $61de1ee1cac498ae$var$Qnd(a.e, 7);
    $61de1ee1cac498ae$var$Qnd(a.e, 8);
    $61de1ee1cac498ae$var$Qnd(a.e, 9);
    $61de1ee1cac498ae$var$Qnd(a.e, 10);
    $61de1ee1cac498ae$var$Knd(a.e, 11);
    a.k = $61de1ee1cac498ae$var$Lnd(a, 11);
    $61de1ee1cac498ae$var$Knd(a.k, 0);
    $61de1ee1cac498ae$var$Knd(a.k, 1);
    a.o = $61de1ee1cac498ae$var$Mnd(a, 12);
    a.s = $61de1ee1cac498ae$var$Mnd(a, 13);
}
function $61de1ee1cac498ae$var$AUb(a, b) {
    b.dc() && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
    $61de1ee1cac498ae$var$pb(b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Gcd)) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, false);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Bcd) && $61de1ee1cac498ae$var$HVb(a.j, false, true, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Ocd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, false, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Qcd) && $61de1ee1cac498ae$var$HVb(a.j, true, false, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Hcd) && $61de1ee1cac498ae$var$HVb(a.j, false, true, true, false);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Ccd) && $61de1ee1cac498ae$var$HVb(a.j, false, true, false, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Pcd) && $61de1ee1cac498ae$var$HVb(a.j, true, false, false, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Ncd) && $61de1ee1cac498ae$var$HVb(a.j, true, false, true, false);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Lcd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Ecd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Lcd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Dcd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Mcd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Kcd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
    $61de1ee1cac498ae$var$pb(b, $61de1ee1cac498ae$var$Jcd) && $61de1ee1cac498ae$var$HVb(a.j, true, true, true, true);
}
function $61de1ee1cac498ae$var$rZb(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q;
    f = new $61de1ee1cac498ae$var$Rkb;
    for(j = new $61de1ee1cac498ae$var$olb(d); j.a < j.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 441);
        g = null;
        if (h.f == ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)) for(o = new $61de1ee1cac498ae$var$olb(h.e); o.a < o.c.c.length;){
            n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 17);
            q = n.d.i;
            if ($61de1ee1cac498ae$var$Q_b(q) == b) $61de1ee1cac498ae$var$iZb(a, b, h, n, h.b, n.d);
            else if (!c || $61de1ee1cac498ae$var$f_b(q, c)) $61de1ee1cac498ae$var$jZb(a, b, h, d, n);
            else {
                m = $61de1ee1cac498ae$var$oZb(a, b, c, n, h.b, $61de1ee1cac498ae$var$IAc, g);
                m != g && (f.c[f.c.length] = m);
                m.c && (g = m);
            }
        }
        else for(l = new $61de1ee1cac498ae$var$olb(h.e); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 17);
            p = k.c.i;
            if ($61de1ee1cac498ae$var$Q_b(p) == b) $61de1ee1cac498ae$var$iZb(a, b, h, k, k.c, h.b);
            else if (!c || $61de1ee1cac498ae$var$f_b(p, c)) continue;
            else {
                m = $61de1ee1cac498ae$var$oZb(a, b, c, k, h.b, $61de1ee1cac498ae$var$HAc, g);
                m != g && (f.c[f.c.length] = m);
                m.c && (g = m);
            }
        }
    }
    for(i = new $61de1ee1cac498ae$var$olb(f); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 441);
        $61de1ee1cac498ae$var$Jkb(b.a, h.a, 0) != -1 || $61de1ee1cac498ae$var$Ekb(b.a, h.a);
        h.c && (e.c[e.c.length] = h);
    }
}
function $61de1ee1cac498ae$var$SJc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    j = new $61de1ee1cac498ae$var$Rkb;
    for(i = new $61de1ee1cac498ae$var$olb(b.a); i.a < i.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        for(m = $61de1ee1cac498ae$var$V_b(g, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)).Kc(); m.Ob();){
            l = $61de1ee1cac498ae$var$BD(m.Pb(), 11);
            for(e = new $61de1ee1cac498ae$var$olb(l.g); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                if (!$61de1ee1cac498ae$var$OZb(d) && d.c.i.c == d.d.i.c || $61de1ee1cac498ae$var$OZb(d) || d.d.i.c != c) continue;
                j.c[j.c.length] = d;
            }
        }
    }
    for(h = $61de1ee1cac498ae$var$Su(c.a).Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 10);
        for(m = $61de1ee1cac498ae$var$V_b(g, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)).Kc(); m.Ob();){
            l = $61de1ee1cac498ae$var$BD(m.Pb(), 11);
            for(e = new $61de1ee1cac498ae$var$olb(l.e); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                if (!$61de1ee1cac498ae$var$OZb(d) && d.c.i.c == d.d.i.c || $61de1ee1cac498ae$var$OZb(d) || d.c.i.c != b) continue;
                k = new $61de1ee1cac498ae$var$Bib(j, j.c.length);
                f = ($61de1ee1cac498ae$var$sCb(k.b > 0), $61de1ee1cac498ae$var$BD(k.a.Xb(k.c = --k.b), 17));
                while(f != d && k.b > 0){
                    a.a[f.p] = true;
                    a.a[d.p] = true;
                    f = ($61de1ee1cac498ae$var$sCb(k.b > 0), $61de1ee1cac498ae$var$BD(k.a.Xb(k.c = --k.b), 17));
                }
                k.b > 0 && $61de1ee1cac498ae$var$uib(k);
            }
        }
    }
}
function $61de1ee1cac498ae$var$Vmd(b, c, d) {
    var e, f, g, h, i, j, k, l, m;
    if (b.a != c.Aj()) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + c.ne() + $61de1ee1cac498ae$var$ute));
    e = $61de1ee1cac498ae$var$o1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), c).$k();
    if (e) return e.Aj().Nh().Ih(e, d);
    h = $61de1ee1cac498ae$var$o1d($61de1ee1cac498ae$var$M6d, c).al();
    if (h) {
        if (d == null) return null;
        i = $61de1ee1cac498ae$var$BD(d, 15);
        if (i.dc()) return "";
        m = new $61de1ee1cac498ae$var$Hfb;
        for(g = i.Kc(); g.Ob();){
            f = g.Pb();
            $61de1ee1cac498ae$var$Efb(m, h.Aj().Nh().Ih(h, f));
            m.a += " ";
        }
        return $61de1ee1cac498ae$var$lcb(m, m.a.length - 1);
    }
    l = $61de1ee1cac498ae$var$o1d($61de1ee1cac498ae$var$M6d, c).bl();
    if (!l.dc()) {
        for(k = l.Kc(); k.Ob();){
            j = $61de1ee1cac498ae$var$BD(k.Pb(), 148);
            if (j.wj(d)) try {
                m = j.Aj().Nh().Ih(j, d);
                if (m != null) return m;
            } catch (a) {
                a = $61de1ee1cac498ae$var$ubb(a);
                if (!$61de1ee1cac498ae$var$JD(a, 102)) throw $61de1ee1cac498ae$var$vbb(a);
            }
        }
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Invalid value: '" + d + "' for datatype :" + c.ne()));
    }
    $61de1ee1cac498ae$var$BD(c, 834).Fj();
    return d == null ? null : $61de1ee1cac498ae$var$JD(d, 172) ? "" + $61de1ee1cac498ae$var$BD(d, 172).a : $61de1ee1cac498ae$var$rb(d) == $61de1ee1cac498ae$var$$J ? $61de1ee1cac498ae$var$CQd($61de1ee1cac498ae$var$Pmd[0], $61de1ee1cac498ae$var$BD(d, 199)) : $61de1ee1cac498ae$var$fcb(d);
}
function $61de1ee1cac498ae$var$zQc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    j = new $61de1ee1cac498ae$var$Psb;
    h = new $61de1ee1cac498ae$var$Psb;
    for(f = new $61de1ee1cac498ae$var$olb(a); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 128);
        d.v = 0;
        d.n = d.i.c.length;
        d.u = d.t.c.length;
        d.n == 0 && $61de1ee1cac498ae$var$Gsb(j, d, j.c.b, j.c);
        d.u == 0 && d.r.a.gc() == 0 && $61de1ee1cac498ae$var$Gsb(h, d, h.c.b, h.c);
    }
    g = -1;
    while(j.b != 0){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Vt(j, 0), 128);
        for(c = new $61de1ee1cac498ae$var$olb(d.t); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 268);
            k = b.b;
            k.v = $61de1ee1cac498ae$var$$wnd.Math.max(k.v, d.v + 1);
            g = $61de1ee1cac498ae$var$$wnd.Math.max(g, k.v);
            --k.n;
            k.n == 0 && $61de1ee1cac498ae$var$Gsb(j, k, j.c.b, j.c);
        }
    }
    if (g > -1) {
        for(e = $61de1ee1cac498ae$var$Jsb(h, 0); e.b != e.d.c;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(e), 128);
            d.v = g;
        }
        while(h.b != 0){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Vt(h, 0), 128);
            for(c = new $61de1ee1cac498ae$var$olb(d.i); c.a < c.c.c.length;){
                b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 268);
                i = b.a;
                if (i.r.a.gc() != 0) continue;
                i.v = $61de1ee1cac498ae$var$$wnd.Math.min(i.v, d.v - 1);
                --i.u;
                i.u == 0 && $61de1ee1cac498ae$var$Gsb(h, i, h.c.b, h.c);
            }
        }
    }
}
function $61de1ee1cac498ae$var$A6c(a, b, c, d, e) {
    var f, g, h, i;
    i = $61de1ee1cac498ae$var$Pje;
    g = false;
    h = $61de1ee1cac498ae$var$v6c(a, $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), a), $61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$f7c(c.a, c.b), e), $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(d.a, d.b), c));
    f = !!h && !($61de1ee1cac498ae$var$$wnd.Math.abs(h.a - a.a) <= $61de1ee1cac498ae$var$nse && $61de1ee1cac498ae$var$$wnd.Math.abs(h.b - a.b) <= $61de1ee1cac498ae$var$nse || $61de1ee1cac498ae$var$$wnd.Math.abs(h.a - b.a) <= $61de1ee1cac498ae$var$nse && $61de1ee1cac498ae$var$$wnd.Math.abs(h.b - b.b) <= $61de1ee1cac498ae$var$nse);
    h = $61de1ee1cac498ae$var$v6c(a, $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), a), c, e);
    !!h && (($61de1ee1cac498ae$var$$wnd.Math.abs(h.a - a.a) <= $61de1ee1cac498ae$var$nse && $61de1ee1cac498ae$var$$wnd.Math.abs(h.b - a.b) <= $61de1ee1cac498ae$var$nse) == ($61de1ee1cac498ae$var$$wnd.Math.abs(h.a - b.a) <= $61de1ee1cac498ae$var$nse && $61de1ee1cac498ae$var$$wnd.Math.abs(h.b - b.b) <= $61de1ee1cac498ae$var$nse) || f ? i = $61de1ee1cac498ae$var$$wnd.Math.min(i, $61de1ee1cac498ae$var$U6c($61de1ee1cac498ae$var$c7c(h, c))) : g = true);
    h = $61de1ee1cac498ae$var$v6c(a, $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), a), d, e);
    !!h && (g || ($61de1ee1cac498ae$var$$wnd.Math.abs(h.a - a.a) <= $61de1ee1cac498ae$var$nse && $61de1ee1cac498ae$var$$wnd.Math.abs(h.b - a.b) <= $61de1ee1cac498ae$var$nse) == ($61de1ee1cac498ae$var$$wnd.Math.abs(h.a - b.a) <= $61de1ee1cac498ae$var$nse && $61de1ee1cac498ae$var$$wnd.Math.abs(h.b - b.b) <= $61de1ee1cac498ae$var$nse) || f) && (i = $61de1ee1cac498ae$var$$wnd.Math.min(i, $61de1ee1cac498ae$var$U6c($61de1ee1cac498ae$var$c7c(h, d))));
    return i;
}
function $61de1ee1cac498ae$var$cTb(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$L3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$Rme), $61de1ee1cac498ae$var$Sme), "Minimizes the stress within a layout using stress majorization. Stress exists if the euclidean distance between a pair of nodes doesn't match their graph theoretic distance, that is, the shortest path between the two nodes. The method allows to specify individual edge lengths."), new $61de1ee1cac498ae$var$fTb), $61de1ee1cac498ae$var$ume)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Ame, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$VSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Cme, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$YSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ZSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$$Sb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Gme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$XSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Dme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$_Sb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Hme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$aTb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Mme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$USb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Ome, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$SSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Pme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$TSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Qme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$WSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Rme, $61de1ee1cac498ae$var$Nme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$RSb));
}
function $61de1ee1cac498ae$var$BFc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    $61de1ee1cac498ae$var$Odd(b, "Interactive crossing minimization", 1);
    g = 0;
    for(f = new $61de1ee1cac498ae$var$olb(a.b); f.a < f.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        d.p = g++;
    }
    m = $61de1ee1cac498ae$var$WZb(a);
    q = new $61de1ee1cac498ae$var$iHc(m.length);
    $61de1ee1cac498ae$var$$Ic(new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$qY, 1), $61de1ee1cac498ae$var$Uhe, 225, 0, [
        q
    ])), m);
    p = 0;
    g = 0;
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        c = 0;
        l = 0;
        for(k = new $61de1ee1cac498ae$var$olb(d.a); k.a < k.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
            if (i.n.a > 0) {
                c += i.n.a + i.o.a / 2;
                ++l;
            }
            for(o = new $61de1ee1cac498ae$var$olb(i.j); o.a < o.c.c.length;){
                n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 11);
                n.p = p++;
            }
        }
        l > 0 && (c /= l);
        r = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, d.a.c.length, 15, 1);
        h = 0;
        for(j = new $61de1ee1cac498ae$var$olb(d.a); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
            i.p = h++;
            r[i.p] = $61de1ee1cac498ae$var$AFc(i, c);
            i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) && $61de1ee1cac498ae$var$yNb(i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$atc), r[i.p]);
        }
        $61de1ee1cac498ae$var$mmb();
        $61de1ee1cac498ae$var$Okb(d.a, new $61de1ee1cac498ae$var$GFc(r));
        $61de1ee1cac498ae$var$YDc(q, m, g, true);
        ++g;
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$Zfe(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (b.e == 5) {
        $61de1ee1cac498ae$var$Wfe(a, b);
        return;
    }
    j = b;
    if (j.b == null || a.b == null) return;
    $61de1ee1cac498ae$var$Yfe(a);
    $61de1ee1cac498ae$var$Vfe(a);
    $61de1ee1cac498ae$var$Yfe(j);
    $61de1ee1cac498ae$var$Vfe(j);
    c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.b.length + j.b.length, 15, 1);
    k = 0;
    d = 0;
    g = 0;
    while(d < a.b.length && g < j.b.length){
        e = a.b[d];
        f = a.b[d + 1];
        h = j.b[g];
        i = j.b[g + 1];
        if (f < h) {
            c[k++] = a.b[d++];
            c[k++] = a.b[d++];
        } else if (f >= h && e <= i) {
            if (h <= e && f <= i) d += 2;
            else if (h <= e) {
                a.b[d] = i + 1;
                g += 2;
            } else if (f <= i) {
                c[k++] = e;
                c[k++] = h - 1;
                d += 2;
            } else {
                c[k++] = e;
                c[k++] = h - 1;
                a.b[d] = i + 1;
                g += 2;
            }
        } else if (i < e) g += 2;
        else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Token#subtractRanges(): Internal Error: [" + a.b[d] + "," + a.b[d + 1] + "] - [" + j.b[g] + "," + j.b[g + 1] + "]"));
    }
    while(d < a.b.length){
        c[k++] = a.b[d++];
        c[k++] = a.b[d++];
    }
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, k, 15, 1);
    $61de1ee1cac498ae$var$$fb(c, 0, a.b, 0, k);
}
function $61de1ee1cac498ae$var$BJb(a) {
    var b, c, d, e, f, g, h;
    if (a.A.dc()) return;
    if (a.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$rdd))) {
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)), 124).k = true;
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Rcd), 124).k = true;
        b = a.q != ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$_bd) && a.q != $61de1ee1cac498ae$var$$bd;
        $61de1ee1cac498ae$var$ZGb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$zcd), 124), b);
        $61de1ee1cac498ae$var$ZGb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Tcd), 124), b);
        $61de1ee1cac498ae$var$ZGb(a.g, b);
        if (a.A.Hc($61de1ee1cac498ae$var$sdd)) {
            $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Acd), 124).j = true;
            $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Rcd), 124).j = true;
            $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$zcd), 124).k = true;
            $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, $61de1ee1cac498ae$var$Tcd), 124).k = true;
            a.g.k = true;
        }
    }
    if (a.A.Hc($61de1ee1cac498ae$var$qdd)) {
        a.a.j = true;
        a.a.k = true;
        a.g.j = true;
        a.g.k = true;
        h = a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Edd));
        for(e = $61de1ee1cac498ae$var$wJb(), f = 0, g = e.length; f < g; ++f){
            d = e[f];
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.i, d), 306);
            if (c) {
                if ($61de1ee1cac498ae$var$sJb(d)) {
                    c.j = true;
                    c.k = true;
                } else {
                    c.j = !h;
                    c.k = !h;
                }
            }
        }
    }
    if (a.A.Hc($61de1ee1cac498ae$var$pdd) && a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Ddd))) {
        a.g.j = true;
        a.g.j = true;
        if (!a.a.j) {
            a.a.j = true;
            a.a.k = true;
            a.a.e = true;
        }
    }
}
function $61de1ee1cac498ae$var$GJc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    for(d = new $61de1ee1cac498ae$var$olb(a.e.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
        for(f = new $61de1ee1cac498ae$var$olb(c.a); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
            n = a.i[e.p];
            j = n.a.e;
            i = n.d.e;
            e.n.b = j;
            r = i - j - e.o.b;
            b = $61de1ee1cac498ae$var$bKc(e);
            m = ($61de1ee1cac498ae$var$Izc(), (!e.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : e.q)._b(($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Cxc)) ? l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$Cxc), 197) : l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(e), $61de1ee1cac498ae$var$Dxc), 197), l);
            b && (m == $61de1ee1cac498ae$var$Fzc || m == $61de1ee1cac498ae$var$Ezc) && (e.o.b += r);
            if (b && (m == $61de1ee1cac498ae$var$Hzc || m == $61de1ee1cac498ae$var$Fzc || m == $61de1ee1cac498ae$var$Ezc)) {
                for(p = new $61de1ee1cac498ae$var$olb(e.j); p.a < p.c.c.length;){
                    o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 11);
                    if (($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Ecd).Hc(o.j)) {
                        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.k, o), 121);
                        o.n.b = k.e - j;
                    }
                }
                for(h = new $61de1ee1cac498ae$var$olb(e.b); h.a < h.c.c.length;){
                    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 70);
                    q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$xxc), 21);
                    q.Hc(($61de1ee1cac498ae$var$Hbd(), $61de1ee1cac498ae$var$Ebd)) ? g.n.b += r : q.Hc($61de1ee1cac498ae$var$Fbd) && (g.n.b += r / 2);
                }
                (m == $61de1ee1cac498ae$var$Fzc || m == $61de1ee1cac498ae$var$Ezc) && $61de1ee1cac498ae$var$V_b(e, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd)).Jc(new $61de1ee1cac498ae$var$$Kc(r));
            }
        }
    }
}
function $61de1ee1cac498ae$var$Lwb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    if (!a.b) return false;
    g = null;
    m = null;
    i = new $61de1ee1cac498ae$var$exb(null, null);
    e = 1;
    i.a[1] = a.b;
    l = i;
    while(l.a[e]){
        j = e;
        h = m;
        m = l;
        l = l.a[e];
        d = a.a.ue(b, l.d);
        e = d < 0 ? 0 : 1;
        d == 0 && (!c.c || $61de1ee1cac498ae$var$wtb(l.e, c.d)) && (g = l);
        if (!(!!l && l.b) && !$61de1ee1cac498ae$var$Hwb(l.a[e])) {
            if ($61de1ee1cac498ae$var$Hwb(l.a[1 - e])) m = m.a[j] = $61de1ee1cac498ae$var$Owb(l, e);
            else if (!$61de1ee1cac498ae$var$Hwb(l.a[1 - e])) {
                n = m.a[1 - j];
                if (n) {
                    if (!$61de1ee1cac498ae$var$Hwb(n.a[1 - j]) && !$61de1ee1cac498ae$var$Hwb(n.a[j])) {
                        m.b = false;
                        n.b = true;
                        l.b = true;
                    } else {
                        f = h.a[1] == m ? 1 : 0;
                        $61de1ee1cac498ae$var$Hwb(n.a[j]) ? h.a[f] = $61de1ee1cac498ae$var$Nwb(m, j) : $61de1ee1cac498ae$var$Hwb(n.a[1 - j]) && (h.a[f] = $61de1ee1cac498ae$var$Owb(m, j));
                        l.b = h.a[f].b = true;
                        h.a[f].a[0].b = false;
                        h.a[f].a[1].b = false;
                    }
                }
            }
        }
    }
    if (g) {
        c.b = true;
        c.d = g.e;
        if (l != g) {
            k = new $61de1ee1cac498ae$var$exb(l.d, l.e);
            $61de1ee1cac498ae$var$Mwb(a, i, g, k);
            m == g && (m = k);
        }
        m.a[m.a[1] == l ? 1 : 0] = l.a[!l.a[0] ? 1 : 0];
        --a.c;
    }
    a.b = i.a[1];
    !!a.b && (a.b.b = false);
    return c.b;
}
function $61de1ee1cac498ae$var$cic(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    for(e = new $61de1ee1cac498ae$var$olb(a.a.a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 57);
        for(i = d.c.Kc(); i.Ob();){
            h = $61de1ee1cac498ae$var$BD(i.Pb(), 57);
            if (d.a == h.a) continue;
            $61de1ee1cac498ae$var$fad(a.a.d) ? l = a.a.g.Oe(d, h) : l = a.a.g.Pe(d, h);
            f = d.b.a + d.d.b + l - h.b.a;
            f = $61de1ee1cac498ae$var$$wnd.Math.ceil(f);
            f = $61de1ee1cac498ae$var$$wnd.Math.max(0, f);
            if ($61de1ee1cac498ae$var$vgc(d, h)) {
                g = $61de1ee1cac498ae$var$nGb(new $61de1ee1cac498ae$var$pGb, a.d);
                j = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(h.b.a - d.b.a));
                b = j - (h.b.a - d.b.a);
                k = $61de1ee1cac498ae$var$ugc(d).a;
                c = d;
                if (!k) {
                    k = $61de1ee1cac498ae$var$ugc(h).a;
                    b = -b;
                    c = h;
                }
                if (k) {
                    c.b.a -= b;
                    k.n.a -= b;
                }
                $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, $61de1ee1cac498ae$var$$wnd.Math.max(0, j)), 1), g), a.c[d.a.d]));
                $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, $61de1ee1cac498ae$var$$wnd.Math.max(0, -j)), 1), g), a.c[h.a.d]));
            } else {
                m = 1;
                ($61de1ee1cac498ae$var$JD(d.g, 145) && $61de1ee1cac498ae$var$JD(h.g, 10) || $61de1ee1cac498ae$var$JD(h.g, 145) && $61de1ee1cac498ae$var$JD(d.g, 10)) && (m = 2);
                $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, $61de1ee1cac498ae$var$QD(f)), m), a.c[d.a.d]), a.c[h.a.d]));
            }
        }
    }
}
function $61de1ee1cac498ae$var$pEc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    if (c) {
        d = -1;
        k = new $61de1ee1cac498ae$var$Bib(b, 0);
        while(k.b < k.d.gc()){
            h = ($61de1ee1cac498ae$var$sCb(k.b < k.d.gc()), $61de1ee1cac498ae$var$BD(k.d.Xb(k.c = k.b++), 10));
            l = a.c[h.c.p][h.p].a;
            if (l == null) {
                g = d + 1;
                f = new $61de1ee1cac498ae$var$Bib(b, k.b);
                while(f.b < f.d.gc()){
                    m = $61de1ee1cac498ae$var$tEc(a, ($61de1ee1cac498ae$var$sCb(f.b < f.d.gc()), $61de1ee1cac498ae$var$BD(f.d.Xb(f.c = f.b++), 10))).a;
                    if (m != null) {
                        g = ($61de1ee1cac498ae$var$uCb(m), m);
                        break;
                    }
                }
                l = (d + g) / 2;
                a.c[h.c.p][h.p].a = l;
                a.c[h.c.p][h.p].d = ($61de1ee1cac498ae$var$uCb(l), l);
                a.c[h.c.p][h.p].b = 1;
            }
            d = ($61de1ee1cac498ae$var$uCb(l), l);
        }
    } else {
        e = 0;
        for(j = new $61de1ee1cac498ae$var$olb(b); j.a < j.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
            a.c[h.c.p][h.p].a != null && (e = $61de1ee1cac498ae$var$$wnd.Math.max(e, $61de1ee1cac498ae$var$Edb(a.c[h.c.p][h.p].a)));
        }
        e += 2;
        for(i = new $61de1ee1cac498ae$var$olb(b); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            if (a.c[h.c.p][h.p].a == null) {
                l = $61de1ee1cac498ae$var$Cub(a.i, 24) * $61de1ee1cac498ae$var$lke * e - 1;
                a.c[h.c.p][h.p].a = l;
                a.c[h.c.p][h.p].d = l;
                a.c[h.c.p][h.p].b = 1;
            }
        }
    }
}
function $61de1ee1cac498ae$var$CZd() {
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$b5, new $61de1ee1cac498ae$var$i$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$a5, new $61de1ee1cac498ae$var$P$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$c5, new $61de1ee1cac498ae$var$u_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$d5, new $61de1ee1cac498ae$var$M_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$f5, new $61de1ee1cac498ae$var$P_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$h5, new $61de1ee1cac498ae$var$S_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$g5, new $61de1ee1cac498ae$var$V_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$i5, new $61de1ee1cac498ae$var$Y_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$k5, new $61de1ee1cac498ae$var$GZd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$l5, new $61de1ee1cac498ae$var$JZd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$m5, new $61de1ee1cac498ae$var$MZd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$n5, new $61de1ee1cac498ae$var$PZd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$o5, new $61de1ee1cac498ae$var$SZd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$p5, new $61de1ee1cac498ae$var$VZd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$q5, new $61de1ee1cac498ae$var$YZd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$t5, new $61de1ee1cac498ae$var$_Zd);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$v5, new $61de1ee1cac498ae$var$c$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$x6, new $61de1ee1cac498ae$var$f$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$j5, new $61de1ee1cac498ae$var$l$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$u5, new $61de1ee1cac498ae$var$o$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$wI, new $61de1ee1cac498ae$var$r$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SD, 1), new $61de1ee1cac498ae$var$u$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$xI, new $61de1ee1cac498ae$var$x$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$yI, new $61de1ee1cac498ae$var$A$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$$J, new $61de1ee1cac498ae$var$D$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$O4, new $61de1ee1cac498ae$var$G$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$BI, new $61de1ee1cac498ae$var$J$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$T4, new $61de1ee1cac498ae$var$M$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$U4, new $61de1ee1cac498ae$var$S$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$O9, new $61de1ee1cac498ae$var$V$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$E9, new $61de1ee1cac498ae$var$Y$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$FI, new $61de1ee1cac498ae$var$_$d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$JI, new $61de1ee1cac498ae$var$c_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$AI, new $61de1ee1cac498ae$var$f_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$MI, new $61de1ee1cac498ae$var$i_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$DK, new $61de1ee1cac498ae$var$l_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$v8, new $61de1ee1cac498ae$var$o_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$u8, new $61de1ee1cac498ae$var$r_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$UI, new $61de1ee1cac498ae$var$x_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$A_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$X4, new $61de1ee1cac498ae$var$D_d);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$V4, new $61de1ee1cac498ae$var$G_d);
}
function $61de1ee1cac498ae$var$hA(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    !c && (c = $61de1ee1cac498ae$var$TA(b.q.getTimezoneOffset()));
    e = (b.q.getTimezoneOffset() - c.a) * 60000;
    h = new $61de1ee1cac498ae$var$gB($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Cbb(b.q.getTime()), e));
    i = h;
    if (h.q.getTimezoneOffset() != b.q.getTimezoneOffset()) {
        e > 0 ? e -= 86400000 : e += 86400000;
        i = new $61de1ee1cac498ae$var$gB($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Cbb(b.q.getTime()), e));
    }
    k = new $61de1ee1cac498ae$var$Vfb;
    j = a.a.length;
    for(f = 0; f < j;){
        d = $61de1ee1cac498ae$var$bfb(a.a, f);
        if (d >= 97 && d <= 122 || d >= 65 && d <= 90) {
            for(g = f + 1; g < j && $61de1ee1cac498ae$var$bfb(a.a, g) == d; ++g);
            $61de1ee1cac498ae$var$vA(k, d, g - f, h, i, c);
            f = g;
        } else if (d == 39) {
            ++f;
            if (f < j && $61de1ee1cac498ae$var$bfb(a.a, f) == 39) {
                k.a += "'";
                ++f;
                continue;
            }
            l = false;
            while(!l){
                g = f;
                while(g < j && $61de1ee1cac498ae$var$bfb(a.a, g) != 39)++g;
                if (g >= j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Missing trailing '"));
                g + 1 < j && $61de1ee1cac498ae$var$bfb(a.a, g + 1) == 39 ? ++g : l = true;
                $61de1ee1cac498ae$var$Qfb(k, $61de1ee1cac498ae$var$qfb(a.a, f, g));
                f = g + 1;
            }
        } else {
            k.a += String.fromCharCode(d);
            ++f;
        }
    }
    return k.a;
}
function $61de1ee1cac498ae$var$MEc(a) {
    var b, c, d, e, f, g, h, i;
    b = null;
    for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 233);
        $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$REc(c.g, c.d[0]).a);
        c.b = null;
        if (!!c.e && c.e.gc() > 0 && c.c == 0) {
            !b && (b = new $61de1ee1cac498ae$var$Rkb);
            b.c[b.c.length] = c;
        }
    }
    if (b) while(b.c.length != 0){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Kkb(b, 0), 233);
        if (!!c.b && c.b.c.length > 0) for(f = (!c.b && (c.b = new $61de1ee1cac498ae$var$Rkb), new $61de1ee1cac498ae$var$olb(c.b)); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 233);
            if ($61de1ee1cac498ae$var$Gdb($61de1ee1cac498ae$var$REc(e.g, e.d[0]).a) == $61de1ee1cac498ae$var$Gdb($61de1ee1cac498ae$var$REc(c.g, c.d[0]).a)) {
                if ($61de1ee1cac498ae$var$Jkb(a, e, 0) > $61de1ee1cac498ae$var$Jkb(a, c, 0)) return new $61de1ee1cac498ae$var$vgd(e, c);
            } else if ($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$REc(e.g, e.d[0]).a) > $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$REc(c.g, c.d[0]).a)) return new $61de1ee1cac498ae$var$vgd(e, c);
        }
        for(h = (!c.e && (c.e = new $61de1ee1cac498ae$var$Rkb), c.e).Kc(); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 233);
            i = (!g.b && (g.b = new $61de1ee1cac498ae$var$Rkb), g.b);
            $61de1ee1cac498ae$var$wCb(0, i.c.length);
            $61de1ee1cac498ae$var$aCb(i.c, 0, c);
            g.c == i.c.length && (b.c[b.c.length] = g);
        }
    }
    return null;
}
function $61de1ee1cac498ae$var$wlb(a, b) {
    var c, d, e, f, g, h, i, j, k;
    if (a == null) return $61de1ee1cac498ae$var$Xhe;
    i = b.a.zc(a, b);
    if (i != null) return "[...]";
    c = new $61de1ee1cac498ae$var$xwb($61de1ee1cac498ae$var$She, "[", "]");
    for(e = a, f = 0, g = e.length; f < g; ++f){
        d = e[f];
        if (d != null && ($61de1ee1cac498ae$var$rb(d).i & 4) != 0) {
            if (Array.isArray(d) && (k = $61de1ee1cac498ae$var$HC(d), !(k >= 14 && k <= 16))) {
                if (b.a._b(d)) {
                    !c.a ? c.a = new $61de1ee1cac498ae$var$Wfb(c.d) : $61de1ee1cac498ae$var$Qfb(c.a, c.b);
                    $61de1ee1cac498ae$var$Nfb(c.a, "[...]");
                } else {
                    h = $61de1ee1cac498ae$var$CD(d);
                    j = new $61de1ee1cac498ae$var$Vqb(b);
                    $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$wlb(h, j));
                }
            } else $61de1ee1cac498ae$var$JD(d, 177) ? $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Xlb($61de1ee1cac498ae$var$BD(d, 177))) : $61de1ee1cac498ae$var$JD(d, 190) ? $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Qlb($61de1ee1cac498ae$var$BD(d, 190))) : $61de1ee1cac498ae$var$JD(d, 195) ? $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Rlb($61de1ee1cac498ae$var$BD(d, 195))) : $61de1ee1cac498ae$var$JD(d, 2012) ? $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Wlb($61de1ee1cac498ae$var$BD(d, 2012))) : $61de1ee1cac498ae$var$JD(d, 48) ? $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Ulb($61de1ee1cac498ae$var$BD(d, 48))) : $61de1ee1cac498ae$var$JD(d, 364) ? $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Vlb($61de1ee1cac498ae$var$BD(d, 364))) : $61de1ee1cac498ae$var$JD(d, 832) ? $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Tlb($61de1ee1cac498ae$var$BD(d, 832))) : $61de1ee1cac498ae$var$JD(d, 104) && $61de1ee1cac498ae$var$uwb(c, $61de1ee1cac498ae$var$Slb($61de1ee1cac498ae$var$BD(d, 104)));
        } else $61de1ee1cac498ae$var$uwb(c, d == null ? $61de1ee1cac498ae$var$Xhe : $61de1ee1cac498ae$var$fcb(d));
    }
    return !c.a ? c.c : c.e.length == 0 ? c.a.a : c.a.a + ("" + c.e);
}
function $61de1ee1cac498ae$var$xQb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    h = $61de1ee1cac498ae$var$itd(b, false, false);
    r = $61de1ee1cac498ae$var$ofd(h);
    d && (r = $61de1ee1cac498ae$var$w7c(r));
    t = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$CPb(), $61de1ee1cac498ae$var$vPb))));
    q = ($61de1ee1cac498ae$var$sCb(r.b != 0), $61de1ee1cac498ae$var$BD(r.a.a.c, 8));
    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(r, 1), 8);
    if (r.b > 2) {
        k = new $61de1ee1cac498ae$var$Rkb;
        $61de1ee1cac498ae$var$Gkb(k, new $61de1ee1cac498ae$var$Jib(r, 1, r.b));
        f = $61de1ee1cac498ae$var$sQb(k, t + a.a);
        s = new $61de1ee1cac498ae$var$XOb(f);
        $61de1ee1cac498ae$var$tNb(s, b);
        c.c[c.c.length] = s;
    } else d ? s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, $61de1ee1cac498ae$var$jtd(b)), 266) : s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, $61de1ee1cac498ae$var$ltd(b)), 266);
    i = $61de1ee1cac498ae$var$jtd(b);
    d && (i = $61de1ee1cac498ae$var$ltd(b));
    g = $61de1ee1cac498ae$var$zQb(q, i);
    j = t + a.a;
    if (g.a) {
        j += $61de1ee1cac498ae$var$$wnd.Math.abs(q.b - l.b);
        p = new $61de1ee1cac498ae$var$f7c(l.a, (l.b + q.b) / 2);
    } else {
        j += $61de1ee1cac498ae$var$$wnd.Math.abs(q.a - l.a);
        p = new $61de1ee1cac498ae$var$f7c((l.a + q.a) / 2, l.b);
    }
    d ? $61de1ee1cac498ae$var$Rhb(a.d, b, new $61de1ee1cac498ae$var$ZOb(s, g, p, j)) : $61de1ee1cac498ae$var$Rhb(a.c, b, new $61de1ee1cac498ae$var$ZOb(s, g, p, j));
    $61de1ee1cac498ae$var$Rhb(a.b, b, s);
    o = (!b.n && (b.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, b, 1, 7)), b.n);
    for(n = new $61de1ee1cac498ae$var$Fyd(o); n.e != n.i.gc();){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(n), 137);
        e = $61de1ee1cac498ae$var$wQb(a, m, true, 0, 0);
        c.c[c.c.length] = e;
    }
}
function $61de1ee1cac498ae$var$wPc(a) {
    var b, c, d, e, f, g, h, i, j, k;
    j = new $61de1ee1cac498ae$var$Rkb;
    h = new $61de1ee1cac498ae$var$Rkb;
    for(g = new $61de1ee1cac498ae$var$olb(a); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 112);
        $61de1ee1cac498ae$var$pOc(e, e.f.c.length);
        $61de1ee1cac498ae$var$qOc(e, e.k.c.length);
        e.d == 0 && (j.c[j.c.length] = e);
        e.i == 0 && e.e.b == 0 && (h.c[h.c.length] = e);
    }
    d = -1;
    while(j.c.length != 0){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Kkb(j, 0), 112);
        for(c = new $61de1ee1cac498ae$var$olb(e.k); c.a < c.c.c.length;){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 129);
            k = b.b;
            $61de1ee1cac498ae$var$rOc(k, $61de1ee1cac498ae$var$$wnd.Math.max(k.o, e.o + 1));
            d = $61de1ee1cac498ae$var$$wnd.Math.max(d, k.o);
            $61de1ee1cac498ae$var$pOc(k, k.d - 1);
            k.d == 0 && (j.c[j.c.length] = k);
        }
    }
    if (d > -1) {
        for(f = new $61de1ee1cac498ae$var$olb(h); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 112);
            e.o = d;
        }
        while(h.c.length != 0){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Kkb(h, 0), 112);
            for(c = new $61de1ee1cac498ae$var$olb(e.f); c.a < c.c.c.length;){
                b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 129);
                i = b.a;
                if (i.e.b > 0) continue;
                $61de1ee1cac498ae$var$rOc(i, $61de1ee1cac498ae$var$$wnd.Math.min(i.o, e.o - 1));
                $61de1ee1cac498ae$var$qOc(i, i.i - 1);
                i.i == 0 && (h.c[h.c.length] = i);
            }
        }
    }
}
function $61de1ee1cac498ae$var$QQd(a, b, c) {
    var d, e, f, g, h, i, j;
    j = a.c;
    !b && (b = $61de1ee1cac498ae$var$FQd);
    a.c = b;
    if ((a.Db & 4) != 0 && (a.Db & 1) == 0) {
        i = new $61de1ee1cac498ae$var$nSd(a, 1, 2, j, a.c);
        !c ? c = i : c.Ei(i);
    }
    if (j != b) {
        if ($61de1ee1cac498ae$var$JD(a.Cb, 284)) {
            if (a.Db >> 16 == -10) c = $61de1ee1cac498ae$var$BD(a.Cb, 284).nk(b, c);
            else if (a.Db >> 16 == -15) {
                !b && (b = ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd));
                !j && (j = ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd));
                if (a.Cb.nh()) {
                    i = new $61de1ee1cac498ae$var$pSd(a.Cb, 1, 13, j, b, $61de1ee1cac498ae$var$HLd($61de1ee1cac498ae$var$QSd($61de1ee1cac498ae$var$BD(a.Cb, 59)), a), false);
                    !c ? c = i : c.Ei(i);
                }
            }
        } else if ($61de1ee1cac498ae$var$JD(a.Cb, 88)) {
            if (a.Db >> 16 == -23) {
                $61de1ee1cac498ae$var$JD(b, 88) || (b = ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
                $61de1ee1cac498ae$var$JD(j, 88) || (j = ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
                if (a.Cb.nh()) {
                    i = new $61de1ee1cac498ae$var$pSd(a.Cb, 1, 10, j, b, $61de1ee1cac498ae$var$HLd($61de1ee1cac498ae$var$VKd($61de1ee1cac498ae$var$BD(a.Cb, 26)), a), false);
                    !c ? c = i : c.Ei(i);
                }
            }
        } else if ($61de1ee1cac498ae$var$JD(a.Cb, 444)) {
            h = $61de1ee1cac498ae$var$BD(a.Cb, 836);
            g = (!h.b && (h.b = new $61de1ee1cac498ae$var$RYd(new $61de1ee1cac498ae$var$NYd)), h.b);
            for(f = (d = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(g.a).a), new $61de1ee1cac498ae$var$ZYd(d)); f.a.b;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$lib(f.a).cd(), 87);
                c = $61de1ee1cac498ae$var$QQd(e, $61de1ee1cac498ae$var$MQd(e, h), c);
            }
        }
    }
    return c;
}
function $61de1ee1cac498ae$var$O1b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    g = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$fxc))));
    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$Yxc), 21);
    i = false;
    j = false;
    l = new $61de1ee1cac498ae$var$Fyd((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c));
    while(l.e != l.i.gc() && (!i || !j)){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(l), 118);
        h = 0;
        for(e = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
            (!f.d && (f.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, f, 8, 5)), f.d),
            (!f.e && (f.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, f, 7, 4)), f.e)
        ]))); $61de1ee1cac498ae$var$Qr(e);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 79);
            k = g && $61de1ee1cac498ae$var$Qld(d) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$gxc)));
            c = $61de1ee1cac498ae$var$ELd((!d.b && (d.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 4, 7)), d.b), f) ? a == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c), 0), 82))) : a == $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.b && (d.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 4, 7)), d.b), 0), 82)));
            if (k || c) {
                ++h;
                if (h > 1) break;
            }
        }
        h > 0 ? i = true : m.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd)) && (!f.n && (f.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, f, 1, 7)), f.n).i > 0 && (i = true);
        h > 1 && (j = true);
    }
    i && b.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc));
    j && b.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Irc));
}
function $61de1ee1cac498ae$var$zfd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Y8c)), 21);
    if (m.dc()) return null;
    h = 0;
    g = 0;
    if (m.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$rdd))) {
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$t9c), 98);
        d = 2;
        c = 2;
        e = 2;
        f = 2;
        b = !$61de1ee1cac498ae$var$Xod(a) ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$z8c), 103) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd($61de1ee1cac498ae$var$Xod(a), $61de1ee1cac498ae$var$z8c), 103);
        for(j = new $61de1ee1cac498ae$var$Fyd((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c)); j.e != j.i.gc();){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(j), 118);
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(i, $61de1ee1cac498ae$var$A9c), 61);
            if (l == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd)) {
                l = $61de1ee1cac498ae$var$lfd(i, b);
                $61de1ee1cac498ae$var$jkd(i, $61de1ee1cac498ae$var$A9c, l);
            }
            if (k == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd)) switch(l.g){
                case 1:
                    d = $61de1ee1cac498ae$var$$wnd.Math.max(d, i.i + i.g);
                    break;
                case 2:
                    c = $61de1ee1cac498ae$var$$wnd.Math.max(c, i.j + i.f);
                    break;
                case 3:
                    e = $61de1ee1cac498ae$var$$wnd.Math.max(e, i.i + i.g);
                    break;
                case 4:
                    f = $61de1ee1cac498ae$var$$wnd.Math.max(f, i.j + i.f);
            }
            else switch(l.g){
                case 1:
                    d += i.g + 2;
                    break;
                case 2:
                    c += i.f + 2;
                    break;
                case 3:
                    e += i.g + 2;
                    break;
                case 4:
                    f += i.f + 2;
            }
        }
        h = $61de1ee1cac498ae$var$$wnd.Math.max(d, e);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(c, f);
    }
    return $61de1ee1cac498ae$var$Afd(a, h, g, true, true);
}
function $61de1ee1cac498ae$var$lnc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$VAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.d, 16)), new $61de1ee1cac498ae$var$pnc(c)), new $61de1ee1cac498ae$var$rnc(c)), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
        ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
    ]))), 15);
    l = $61de1ee1cac498ae$var$Ohe;
    k = $61de1ee1cac498ae$var$Rie;
    for(i = new $61de1ee1cac498ae$var$olb(b.b.j); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 11);
        if (h.j == c) {
            l = $61de1ee1cac498ae$var$$wnd.Math.min(l, h.p);
            k = $61de1ee1cac498ae$var$$wnd.Math.max(k, h.p);
        }
    }
    if (l == $61de1ee1cac498ae$var$Ohe) for(g = 0; g < s.gc(); g++)$61de1ee1cac498ae$var$ojc($61de1ee1cac498ae$var$BD(s.Xb(g), 101), c, g);
    else {
        t = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, e.length, 15, 1);
        $61de1ee1cac498ae$var$Elb(t, t.length);
        for(r = s.Kc(); r.Ob();){
            q = $61de1ee1cac498ae$var$BD(r.Pb(), 101);
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, q), 177);
            j = 0;
            for(p = l; p <= k; p++)f[p] && (j = $61de1ee1cac498ae$var$$wnd.Math.max(j, d[p]));
            if (q.i) {
                n = q.i.c;
                u = new $61de1ee1cac498ae$var$Tqb;
                for(m = 0; m < e.length; m++)e[n][m] && $61de1ee1cac498ae$var$Qqb(u, $61de1ee1cac498ae$var$meb(t[m]));
                while($61de1ee1cac498ae$var$Rqb(u, $61de1ee1cac498ae$var$meb(j)))++j;
            }
            $61de1ee1cac498ae$var$ojc(q, c, j);
            for(o = l; o <= k; o++)f[o] && (d[o] = j + 1);
            !!q.i && (t[q.i.c] = j);
        }
    }
}
function $61de1ee1cac498ae$var$YJc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    e = null;
    for(d = new $61de1ee1cac498ae$var$olb(b.a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
        $61de1ee1cac498ae$var$bKc(c) ? f = (h = $61de1ee1cac498ae$var$nGb($61de1ee1cac498ae$var$oGb(new $61de1ee1cac498ae$var$pGb, c), a.f), i = $61de1ee1cac498ae$var$nGb($61de1ee1cac498ae$var$oGb(new $61de1ee1cac498ae$var$pGb, c), a.f), j = new $61de1ee1cac498ae$var$rKc(c, true, h, i), k = c.o.b, l = ($61de1ee1cac498ae$var$Izc(), (!c.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : c.q)._b(($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Cxc)) ? m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Cxc), 197) : m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(c), $61de1ee1cac498ae$var$Dxc), 197), m), n = 10000, l == $61de1ee1cac498ae$var$Ezc && (n = 1), o = $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, n), $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(k))), h), i)), l == $61de1ee1cac498ae$var$Fzc && $61de1ee1cac498ae$var$Qqb(a.d, o), $61de1ee1cac498ae$var$ZJc(a, $61de1ee1cac498ae$var$Su($61de1ee1cac498ae$var$V_b(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd))), j), $61de1ee1cac498ae$var$ZJc(a, $61de1ee1cac498ae$var$V_b(c, $61de1ee1cac498ae$var$zcd), j), j) : f = (p = $61de1ee1cac498ae$var$nGb($61de1ee1cac498ae$var$oGb(new $61de1ee1cac498ae$var$pGb, c), a.f), $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.j, 16)), new $61de1ee1cac498ae$var$EKc), new $61de1ee1cac498ae$var$GKc(a, p)), new $61de1ee1cac498ae$var$rKc(c, false, p, p));
        a.i[c.p] = f;
        if (e) {
            g = e.c.d.a + $61de1ee1cac498ae$var$jBc(a.n, e.c, c) + c.d.d;
            e.b || (g += e.c.o.b);
            $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil(g))), 0), e.d), f.a));
        }
        e = f;
    }
}
function $61de1ee1cac498ae$var$s9b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    $61de1ee1cac498ae$var$Odd(b, "Label dummy insertions", 1);
    l = new $61de1ee1cac498ae$var$Rkb;
    g = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$nyc))));
    j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ryc)));
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Lwc), 103);
    for(n = new $61de1ee1cac498ae$var$olb(a.a); n.a < n.c.c.length;){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 10);
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(m).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            if (e.c.i != e.d.i && $61de1ee1cac498ae$var$Lq(e.b, $61de1ee1cac498ae$var$p9b)) {
                p = $61de1ee1cac498ae$var$t9b(e);
                o = $61de1ee1cac498ae$var$Pu(e.b.c.length);
                c = $61de1ee1cac498ae$var$r9b(a, e, p, o);
                l.c[l.c.length] = c;
                d = c.o;
                h = new $61de1ee1cac498ae$var$Bib(e.b, 0);
                while(h.b < h.d.gc()){
                    i = ($61de1ee1cac498ae$var$sCb(h.b < h.d.gc()), $61de1ee1cac498ae$var$BD(h.d.Xb(h.c = h.b++), 70));
                    if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$Qwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$nad))) {
                        if (k == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$dad) || k == $61de1ee1cac498ae$var$_9c) {
                            d.a += i.o.a + j;
                            d.b = $61de1ee1cac498ae$var$$wnd.Math.max(d.b, i.o.b);
                        } else {
                            d.a = $61de1ee1cac498ae$var$$wnd.Math.max(d.a, i.o.a);
                            d.b += i.o.b + j;
                        }
                        o.c[o.c.length] = i;
                        $61de1ee1cac498ae$var$uib(h);
                    }
                }
                if (k == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$dad) || k == $61de1ee1cac498ae$var$_9c) {
                    d.a -= j;
                    d.b += g + p;
                } else d.b += g - j + p;
            }
        }
    }
    $61de1ee1cac498ae$var$Gkb(a.a, l);
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$eYb(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    f = new $61de1ee1cac498ae$var$qYb(b);
    l = $61de1ee1cac498ae$var$_Xb(a, b, f);
    n = $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Zwc)))), 1);
    for(k = new $61de1ee1cac498ae$var$olb(l.a); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 46);
        i = $61de1ee1cac498ae$var$dYb($61de1ee1cac498ae$var$BD(j.a, 8), $61de1ee1cac498ae$var$BD(j.b, 8), n);
        $61de1ee1cac498ae$var$o = true;
        $61de1ee1cac498ae$var$o = $61de1ee1cac498ae$var$o & $61de1ee1cac498ae$var$iYb(c, new $61de1ee1cac498ae$var$f7c(i.c, i.d));
        $61de1ee1cac498ae$var$o = $61de1ee1cac498ae$var$o & $61de1ee1cac498ae$var$iYb(c, $61de1ee1cac498ae$var$O6c(new $61de1ee1cac498ae$var$f7c(i.c, i.d), i.b, 0));
        $61de1ee1cac498ae$var$o = $61de1ee1cac498ae$var$o & $61de1ee1cac498ae$var$iYb(c, $61de1ee1cac498ae$var$O6c(new $61de1ee1cac498ae$var$f7c(i.c, i.d), 0, i.a));
        $61de1ee1cac498ae$var$iYb(c, $61de1ee1cac498ae$var$O6c(new $61de1ee1cac498ae$var$f7c(i.c, i.d), i.b, i.a));
    }
    m = f.d;
    h = $61de1ee1cac498ae$var$dYb($61de1ee1cac498ae$var$BD(l.b.a, 8), $61de1ee1cac498ae$var$BD(l.b.b, 8), n);
    if (m == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) || m == $61de1ee1cac498ae$var$zcd) {
        d.c[m.g] = $61de1ee1cac498ae$var$$wnd.Math.min(d.c[m.g], h.d);
        d.b[m.g] = $61de1ee1cac498ae$var$$wnd.Math.max(d.b[m.g], h.d + h.a);
    } else {
        d.c[m.g] = $61de1ee1cac498ae$var$$wnd.Math.min(d.c[m.g], h.c);
        d.b[m.g] = $61de1ee1cac498ae$var$$wnd.Math.max(d.b[m.g], h.c + h.b);
    }
    e = $61de1ee1cac498ae$var$Qje;
    g = f.c.i.d;
    switch(m.g){
        case 4:
            e = g.c;
            break;
        case 2:
            e = g.b;
            break;
        case 1:
            e = g.a;
            break;
        case 3:
            e = g.d;
    }
    d.a[m.g] = $61de1ee1cac498ae$var$$wnd.Math.max(d.a[m.g], e);
    return f;
}
function $61de1ee1cac498ae$var$eKd(b) {
    var c, d, e, f;
    d = b.D != null ? b.D : b.B;
    c = $61de1ee1cac498ae$var$hfb(d, $61de1ee1cac498ae$var$wfb(91));
    if (c != -1) {
        e = d.substr(0, c);
        f = new $61de1ee1cac498ae$var$Hfb;
        do f.a += "[";
        while ((c = $61de1ee1cac498ae$var$gfb(d, 91, ++c)) != -1);
        if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Khe)) f.a += "Z";
        else if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Eve)) f.a += "B";
        else if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Fve)) f.a += "C";
        else if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Gve)) f.a += "D";
        else if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Hve)) f.a += "F";
        else if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Ive)) f.a += "I";
        else if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Jve)) f.a += "J";
        else if ($61de1ee1cac498ae$var$dfb(e, $61de1ee1cac498ae$var$Kve)) f.a += "S";
        else {
            f.a += "L";
            f.a += "" + e;
            f.a += ";";
        }
        try {
            return null;
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if (!$61de1ee1cac498ae$var$JD(a, 60)) throw $61de1ee1cac498ae$var$vbb(a);
        }
    } else if ($61de1ee1cac498ae$var$hfb(d, $61de1ee1cac498ae$var$wfb(46)) == -1) {
        if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Khe)) return $61de1ee1cac498ae$var$sbb;
        else if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Eve)) return $61de1ee1cac498ae$var$SD;
        else if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Fve)) return $61de1ee1cac498ae$var$TD;
        else if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Gve)) return $61de1ee1cac498ae$var$UD;
        else if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Hve)) return $61de1ee1cac498ae$var$VD;
        else if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Ive)) return $61de1ee1cac498ae$var$WD;
        else if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Jve)) return $61de1ee1cac498ae$var$XD;
        else if ($61de1ee1cac498ae$var$dfb(d, $61de1ee1cac498ae$var$Kve)) return $61de1ee1cac498ae$var$rbb;
    }
    return null;
}
function $61de1ee1cac498ae$var$$1b(a, b, c) {
    var d, e, f, g, h, i, j, k;
    j = new $61de1ee1cac498ae$var$b0b(c);
    $61de1ee1cac498ae$var$tNb(j, b);
    $61de1ee1cac498ae$var$yNb(j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), b);
    j.o.a = b.g;
    j.o.b = b.f;
    j.n.a = b.i;
    j.n.b = b.j;
    $61de1ee1cac498ae$var$Ekb(c.a, j);
    $61de1ee1cac498ae$var$Rhb(a.a, b, j);
    ((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a).i != 0 || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$fxc))))) && $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$wsc, ($61de1ee1cac498ae$var$Bcb(), true));
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Ksc), 21);
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(j, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    k == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$ccd) ? $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$Vxc, $61de1ee1cac498ae$var$bcd) : k != $61de1ee1cac498ae$var$bcd && i.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Krc));
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Lwc), 103);
    for(h = new $61de1ee1cac498ae$var$Fyd((!b.c && (b.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, b, 9, 9)), b.c)); h.e != h.i.gc();){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(h), 118);
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(g, $61de1ee1cac498ae$var$Jxc))) || $61de1ee1cac498ae$var$_1b(a, g, j, i, d, k);
    }
    for(f = new $61de1ee1cac498ae$var$Fyd((!b.n && (b.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, b, 1, 7)), b.n)); f.e != f.i.gc();){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(f), 137);
        !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(e, $61de1ee1cac498ae$var$Jxc))) && !!e.a && $61de1ee1cac498ae$var$Ekb(j.b, $61de1ee1cac498ae$var$Z1b(e));
    }
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$pwc))) && i.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Frc));
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$exc)))) {
        i.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Jrc));
        i.Fc($61de1ee1cac498ae$var$Irc);
        $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$Vxc, $61de1ee1cac498ae$var$bcd);
    }
    return j;
}
function $61de1ee1cac498ae$var$F4b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(b.c, a), 459);
    s = b.a.c;
    i = b.a.c + b.a.b;
    C = h.f;
    D = h.a;
    g = C < D;
    p = new $61de1ee1cac498ae$var$f7c(s, C);
    t = new $61de1ee1cac498ae$var$f7c(i, D);
    e = (s + i) / 2;
    q = new $61de1ee1cac498ae$var$f7c(e, C);
    u = new $61de1ee1cac498ae$var$f7c(e, D);
    f = $61de1ee1cac498ae$var$G4b(a, C, D);
    w = $61de1ee1cac498ae$var$A0b(b.B);
    A = new $61de1ee1cac498ae$var$f7c(e, f);
    B = $61de1ee1cac498ae$var$A0b(b.D);
    c = $61de1ee1cac498ae$var$j6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        w,
        A,
        B
    ]));
    n = false;
    r = b.B.i;
    if (!!r && !!r.c && h.d) {
        j = g && r.p < r.c.a.c.length - 1 || !g && r.p > 0;
        if (j) {
            if (j) {
                m = r.p;
                g ? ++m : --m;
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(r.c.a, m), 10);
                d = $61de1ee1cac498ae$var$I4b(l);
                n = !($61de1ee1cac498ae$var$s6c(d, w, c[0]) || $61de1ee1cac498ae$var$n6c(d, w, c[0]));
            }
        } else n = true;
    }
    o = false;
    v = b.D.i;
    if (!!v && !!v.c && h.e) {
        k = g && v.p > 0 || !g && v.p < v.c.a.c.length - 1;
        if (k) {
            m = v.p;
            g ? --m : ++m;
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(v.c.a, m), 10);
            d = $61de1ee1cac498ae$var$I4b(l);
            o = !($61de1ee1cac498ae$var$s6c(d, c[0], B) || $61de1ee1cac498ae$var$n6c(d, c[0], B));
        } else o = true;
    }
    n && o && $61de1ee1cac498ae$var$Dsb(a.a, A);
    n || $61de1ee1cac498ae$var$n7c(a.a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        p,
        q
    ]));
    o || $61de1ee1cac498ae$var$n7c(a.a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        u,
        t
    ]));
}
function $61de1ee1cac498ae$var$yfd(a, b) {
    var c, d, e, f, g, h, i, j;
    if ($61de1ee1cac498ae$var$JD(a.Ug(), 160)) {
        $61de1ee1cac498ae$var$yfd($61de1ee1cac498ae$var$BD(a.Ug(), 160), b);
        b.a += " > ";
    } else b.a += "Root ";
    c = a.Tg().zb;
    $61de1ee1cac498ae$var$dfb(c.substr(0, 3), "Elk") ? $61de1ee1cac498ae$var$Qfb(b, c.substr(3)) : (b.a += "" + c, b);
    e = a.zg();
    if (e) {
        $61de1ee1cac498ae$var$Qfb((b.a += " ", b), e);
        return;
    }
    if ($61de1ee1cac498ae$var$JD(a, 354)) {
        j = $61de1ee1cac498ae$var$BD(a, 137).a;
        if (j) {
            $61de1ee1cac498ae$var$Qfb((b.a += " ", b), j);
            return;
        }
    }
    for(g = new $61de1ee1cac498ae$var$Fyd(a.Ag()); g.e != g.i.gc();){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(g), 137);
        j = f.a;
        if (j) {
            $61de1ee1cac498ae$var$Qfb((b.a += " ", b), j);
            return;
        }
    }
    if ($61de1ee1cac498ae$var$JD(a, 352)) {
        d = $61de1ee1cac498ae$var$BD(a, 79);
        !d.b && (d.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 4, 7));
        if (d.b.i != 0 && (!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c.i != 0)) {
            b.a += " (";
            h = new $61de1ee1cac498ae$var$Oyd((!d.b && (d.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 4, 7)), d.b));
            while(h.e != h.i.gc()){
                h.e > 0 && (b.a += $61de1ee1cac498ae$var$She, b);
                $61de1ee1cac498ae$var$yfd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(h), 160), b);
            }
            b.a += $61de1ee1cac498ae$var$gne;
            i = new $61de1ee1cac498ae$var$Oyd((!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c));
            while(i.e != i.i.gc()){
                i.e > 0 && (b.a += $61de1ee1cac498ae$var$She, b);
                $61de1ee1cac498ae$var$yfd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 160), b);
            }
            b.a += ")";
        }
    }
}
function $61de1ee1cac498ae$var$y2b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 79);
    if (!f) return;
    d = a.a;
    e = new $61de1ee1cac498ae$var$g7c(c);
    $61de1ee1cac498ae$var$P6c(e, $61de1ee1cac498ae$var$C2b(a));
    if ($61de1ee1cac498ae$var$f_b(a.d.i, a.c.i)) {
        m = a.c;
        l = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            m.n,
            m.a
        ]));
        $61de1ee1cac498ae$var$c7c(l, c);
    } else l = $61de1ee1cac498ae$var$A0b(a.c);
    $61de1ee1cac498ae$var$Gsb(d, l, d.a, d.a.a);
    n = $61de1ee1cac498ae$var$A0b(a.d);
    $61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$utc) != null && $61de1ee1cac498ae$var$P6c(n, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$utc), 8));
    $61de1ee1cac498ae$var$Gsb(d, n, d.c.b, d.c);
    $61de1ee1cac498ae$var$q7c(d, e);
    g = $61de1ee1cac498ae$var$itd(f, true, true);
    $61de1ee1cac498ae$var$kmd(g, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!f.b && (f.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, f, 4, 7)), f.b), 0), 82));
    $61de1ee1cac498ae$var$lmd(g, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!f.c && (f.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, f, 5, 8)), f.c), 0), 82));
    $61de1ee1cac498ae$var$ifd(d, g);
    for(k = new $61de1ee1cac498ae$var$olb(a.b); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 70);
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$$sc), 137);
        $61de1ee1cac498ae$var$cld(h, j.o.a);
        $61de1ee1cac498ae$var$ald(h, j.o.b);
        $61de1ee1cac498ae$var$bld(h, j.n.a + e.a, j.n.b + e.b);
        $61de1ee1cac498ae$var$jkd(h, ($61de1ee1cac498ae$var$I9b(), $61de1ee1cac498ae$var$H9b), $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$H9b)));
    }
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
    if (i) {
        $61de1ee1cac498ae$var$q7c(i, e);
        $61de1ee1cac498ae$var$jkd(f, $61de1ee1cac498ae$var$jxc, i);
    } else $61de1ee1cac498ae$var$jkd(f, $61de1ee1cac498ae$var$jxc, null);
    b == ($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$yad) ? $61de1ee1cac498ae$var$jkd(f, $61de1ee1cac498ae$var$Swc, $61de1ee1cac498ae$var$yad) : $61de1ee1cac498ae$var$jkd(f, $61de1ee1cac498ae$var$Swc, null);
}
function $61de1ee1cac498ae$var$mJc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    n = b.c.length;
    m = 0;
    for(l = new $61de1ee1cac498ae$var$olb(a.b); l.a < l.c.c.length;){
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 29);
        r = k.a;
        if (r.c.length == 0) continue;
        q = new $61de1ee1cac498ae$var$olb(r);
        j = 0;
        s = null;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 10);
        f = null;
        while(e){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b, e.p), 257);
            if (f.c >= 0) {
                i = null;
                h = new $61de1ee1cac498ae$var$Bib(k.a, j + 1);
                while(h.b < h.d.gc()){
                    g = ($61de1ee1cac498ae$var$sCb(h.b < h.d.gc()), $61de1ee1cac498ae$var$BD(h.d.Xb(h.c = h.b++), 10));
                    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b, g.p), 257);
                    if (i.d == f.d && i.c < f.c) break;
                    else i = null;
                }
                if (i) {
                    if (s) {
                        $61de1ee1cac498ae$var$Nkb(d, e.p, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d, e.p), 19).a - 1));
                        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c, s.p), 15).Mc(f);
                    }
                    f = $61de1ee1cac498ae$var$yJc(f, e, n++);
                    b.c[b.c.length] = f;
                    $61de1ee1cac498ae$var$Ekb(c, new $61de1ee1cac498ae$var$Rkb);
                    if (s) {
                        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c, s.p), 15).Fc(f);
                        $61de1ee1cac498ae$var$Ekb(d, $61de1ee1cac498ae$var$meb(1));
                    } else $61de1ee1cac498ae$var$Ekb(d, $61de1ee1cac498ae$var$meb(0));
                }
            }
            o = null;
            if (q.a < q.c.c.length) {
                o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 10);
                p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b, o.p), 257);
                $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c, e.p), 15).Fc(p);
                $61de1ee1cac498ae$var$Nkb(d, o.p, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d, o.p), 19).a + 1));
            }
            f.d = m;
            f.c = j++;
            s = e;
            e = o;
        }
        ++m;
    }
}
function $61de1ee1cac498ae$var$u6c(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    i = a;
    k = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), a);
    j = c;
    l = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(d.a, d.b), c);
    m = i.a;
    q = i.b;
    o = j.a;
    s = j.b;
    n = k.a;
    r = k.b;
    p = l.a;
    t = l.b;
    e = p * r - n * t;
    $61de1ee1cac498ae$var$Iy();
    $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe);
    if ($61de1ee1cac498ae$var$$wnd.Math.abs(0 - e) <= $61de1ee1cac498ae$var$Jqe || 0 == e || isNaN(0) && isNaN(e)) return false;
    g = 1 / e * ((m - o) * r - (q - s) * n);
    h = 1 / e * -(-(m - o) * t + (q - s) * p);
    f = ($61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe), ($61de1ee1cac498ae$var$$wnd.Math.abs(0 - g) <= $61de1ee1cac498ae$var$Jqe || 0 == g || isNaN(0) && isNaN(g) ? 0 : 0 < g ? -1 : 0 > g ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(0), isNaN(g))) < 0 && ($61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe), ($61de1ee1cac498ae$var$$wnd.Math.abs(g - 1) <= $61de1ee1cac498ae$var$Jqe || g == 1 || isNaN(g) && isNaN(1) ? 0 : g < 1 ? -1 : g > 1 ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(g), isNaN(1))) < 0) && ($61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe), ($61de1ee1cac498ae$var$$wnd.Math.abs(0 - h) <= $61de1ee1cac498ae$var$Jqe || 0 == h || isNaN(0) && isNaN(h) ? 0 : 0 < h ? -1 : 0 > h ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(0), isNaN(h))) < 0) && ($61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe), ($61de1ee1cac498ae$var$$wnd.Math.abs(h - 1) <= $61de1ee1cac498ae$var$Jqe || h == 1 || isNaN(h) && isNaN(1) ? 0 : h < 1 ? -1 : h > 1 ? 1 : $61de1ee1cac498ae$var$Ny(isNaN(h), isNaN(1))) < 0));
    return f;
}
function $61de1ee1cac498ae$var$z6d(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    for(l = new $61de1ee1cac498ae$var$usb(new $61de1ee1cac498ae$var$nsb(a)); l.b != l.c.a.d;){
        k = $61de1ee1cac498ae$var$tsb(l);
        h = $61de1ee1cac498ae$var$BD(k.d, 56);
        b = $61de1ee1cac498ae$var$BD(k.e, 56);
        g = h.Tg();
        for(p = 0, u = (g.i == null && $61de1ee1cac498ae$var$TKd(g), g.i).length; p < u; ++p){
            j = (f = (g.i == null && $61de1ee1cac498ae$var$TKd(g), g.i), p >= 0 && p < f.length ? f[p] : null);
            if (j.Ij() && !j.Jj()) {
                if ($61de1ee1cac498ae$var$JD(j, 99)) {
                    i = $61de1ee1cac498ae$var$BD(j, 18);
                    (i.Bb & $61de1ee1cac498ae$var$ote) == 0 && (w = $61de1ee1cac498ae$var$zUd(i), !(!!w && (w.Bb & $61de1ee1cac498ae$var$ote) != 0)) && $61de1ee1cac498ae$var$y6d(a, i, h, b);
                } else {
                    $61de1ee1cac498ae$var$Q6d();
                    if ($61de1ee1cac498ae$var$BD(j, 66).Oj()) {
                        c = (v = j, $61de1ee1cac498ae$var$BD(!v ? null : $61de1ee1cac498ae$var$BD(b, 49).xh(v), 153));
                        if (c) {
                            n = $61de1ee1cac498ae$var$BD(h.ah(j), 153);
                            d = c.gc();
                            for(q = 0, o = n.gc(); q < o; ++q){
                                m = n.il(q);
                                if ($61de1ee1cac498ae$var$JD(m, 99)) {
                                    t = n.jl(q);
                                    e = $61de1ee1cac498ae$var$Wrb(a, t);
                                    if (e == null && t != null) {
                                        s = $61de1ee1cac498ae$var$BD(m, 18);
                                        if (!a.b || (s.Bb & $61de1ee1cac498ae$var$ote) != 0 || !!$61de1ee1cac498ae$var$zUd(s)) continue;
                                        e = t;
                                    }
                                    if (!c.dl(m, e)) {
                                        for(r = 0; r < d; ++r)if (c.il(r) == m && $61de1ee1cac498ae$var$PD(c.jl(r)) === $61de1ee1cac498ae$var$PD(e)) {
                                            c.ii(c.gc() - 1, r);
                                            --d;
                                            break;
                                        }
                                    }
                                } else c.dl(n.il(q), n.jl(q));
                            }
                        }
                    }
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$CZc(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p, q, r, s, t;
    r = $61de1ee1cac498ae$var$xZc(b, c, a.g);
    e.n && e.n && !!f && $61de1ee1cac498ae$var$Tdd(e, $61de1ee1cac498ae$var$i6d(f), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    if (a.b) for(q = 0; q < r.c.length; q++){
        l = ($61de1ee1cac498ae$var$tCb(q, r.c.length), $61de1ee1cac498ae$var$BD(r.c[q], 200));
        if (q != 0) {
            n = ($61de1ee1cac498ae$var$tCb(q - 1, r.c.length), $61de1ee1cac498ae$var$BD(r.c[q - 1], 200));
            $61de1ee1cac498ae$var$w$c(l, n.f + n.b + a.g);
        }
        $61de1ee1cac498ae$var$tZc(q, r, c, a.g);
        $61de1ee1cac498ae$var$AZc(a, l);
        e.n && !!f && $61de1ee1cac498ae$var$Tdd(e, $61de1ee1cac498ae$var$i6d(f), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    }
    else for(p = new $61de1ee1cac498ae$var$olb(r); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 200);
        for(k = new $61de1ee1cac498ae$var$olb(o.a); k.a < k.c.c.length;){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 187);
            s = new $61de1ee1cac498ae$var$b$c(j.s, j.t, a.g);
            $61de1ee1cac498ae$var$WZc(s, j);
            $61de1ee1cac498ae$var$Ekb(o.d, s);
        }
    }
    $61de1ee1cac498ae$var$BZc(a, r);
    e.n && e.n && !!f && $61de1ee1cac498ae$var$Tdd(e, $61de1ee1cac498ae$var$i6d(f), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    t = $61de1ee1cac498ae$var$$wnd.Math.max(a.d, d.a - (g.b + g.c));
    m = $61de1ee1cac498ae$var$$wnd.Math.max(a.c, d.b - (g.d + g.a));
    h = m - a.c;
    if (a.e && a.f) {
        i = t / m;
        i < a.a ? t = m * a.a : h += t / a.a - m;
    }
    a.e && $61de1ee1cac498ae$var$zZc(r, t, h);
    e.n && e.n && !!f && $61de1ee1cac498ae$var$Tdd(e, $61de1ee1cac498ae$var$i6d(f), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    return new $61de1ee1cac498ae$var$d$c(a.a, t, a.c + h, ($61de1ee1cac498ae$var$k$c(), $61de1ee1cac498ae$var$j$c));
}
function $61de1ee1cac498ae$var$UJc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    a.j = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, a.g, 15, 1);
    a.o = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.e.b, 16)), new $61de1ee1cac498ae$var$aLc), new $61de1ee1cac498ae$var$cLc(a));
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, a.b, 16, 1);
    $61de1ee1cac498ae$var$TAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.e.b, 16)), new $61de1ee1cac498ae$var$rLc(a));
    d = (l = new $61de1ee1cac498ae$var$Rkb, $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.e.b, 16)), new $61de1ee1cac498ae$var$hLc), new $61de1ee1cac498ae$var$jLc(a)), new $61de1ee1cac498ae$var$lLc(a, l)), l);
    for(i = new $61de1ee1cac498ae$var$olb(d); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 508);
        if (h.c.length <= 1) continue;
        if (h.c.length == 2) {
            $61de1ee1cac498ae$var$uKc(h);
            $61de1ee1cac498ae$var$bKc(($61de1ee1cac498ae$var$tCb(0, h.c.length), $61de1ee1cac498ae$var$BD(h.c[0], 17)).d.i) || $61de1ee1cac498ae$var$Ekb(a.o, h);
            continue;
        }
        if ($61de1ee1cac498ae$var$tKc(h) || $61de1ee1cac498ae$var$sKc(h, new $61de1ee1cac498ae$var$fLc)) continue;
        j = new $61de1ee1cac498ae$var$olb(h);
        e = null;
        while(j.a < j.c.c.length){
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 17);
            c = a.c[b.p];
            !e || j.a >= j.c.c.length ? k = $61de1ee1cac498ae$var$JJc(($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b), $61de1ee1cac498ae$var$g0b) : k = $61de1ee1cac498ae$var$JJc(($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b), $61de1ee1cac498ae$var$g0b);
            k *= 2;
            f = c.a.g;
            c.a.g = $61de1ee1cac498ae$var$$wnd.Math.max(f, f + (k - f));
            g = c.b.g;
            c.b.g = $61de1ee1cac498ae$var$$wnd.Math.max(g, g + (k - g));
            e = b;
        }
    }
}
function $61de1ee1cac498ae$var$VNc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    v = $61de1ee1cac498ae$var$Hx(a);
    k = new $61de1ee1cac498ae$var$Rkb;
    h = a.c.length;
    l = h - 1;
    m = h + 1;
    while(v.a.c != 0){
        while(c.b != 0){
            t = ($61de1ee1cac498ae$var$sCb(c.b != 0), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Nsb(c, c.a.a), 112));
            $61de1ee1cac498ae$var$Jwb(v.a, t);
            t.g = l--;
            $61de1ee1cac498ae$var$YNc(t, b, c, d);
        }
        while(b.b != 0){
            u = ($61de1ee1cac498ae$var$sCb(b.b != 0), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Nsb(b, b.a.a), 112));
            $61de1ee1cac498ae$var$Jwb(v.a, u);
            u.g = m++;
            $61de1ee1cac498ae$var$YNc(u, b, c, d);
        }
        j = $61de1ee1cac498ae$var$Rie;
        for(r = (g = new $61de1ee1cac498ae$var$Ywb(new $61de1ee1cac498ae$var$cxb(new $61de1ee1cac498ae$var$Gjb(v.a).a).b), new $61de1ee1cac498ae$var$Njb(g)); $61de1ee1cac498ae$var$sib(r.a.a);){
            q = (f = $61de1ee1cac498ae$var$Wwb(r.a), $61de1ee1cac498ae$var$BD(f.cd(), 112));
            if (!d && q.b > 0 && q.a <= 0) {
                k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                k.c[k.c.length] = q;
                break;
            }
            p = q.i - q.d;
            if (p >= j) {
                if (p > j) {
                    k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                    j = p;
                }
                k.c[k.c.length] = q;
            }
        }
        if (k.c.length != 0) {
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k, $61de1ee1cac498ae$var$Bub(e, k.c.length)), 112);
            $61de1ee1cac498ae$var$Jwb(v.a, i);
            i.g = m++;
            $61de1ee1cac498ae$var$YNc(i, b, c, d);
            k.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        }
    }
    s = a.c.length + 1;
    for(o = new $61de1ee1cac498ae$var$olb(a); o.a < o.c.c.length;){
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 112);
        n.g < h && (n.g = n.g + s);
    }
}
function $61de1ee1cac498ae$var$SDb(a, b) {
    var c;
    if (a.e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb(($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$TM), $61de1ee1cac498ae$var$Jke + $61de1ee1cac498ae$var$TM.k + $61de1ee1cac498ae$var$Kke)));
    if (!$61de1ee1cac498ae$var$lDb(a.a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz($61de1ee1cac498ae$var$Lke + b + $61de1ee1cac498ae$var$Mke));
    if (b == a.d) return a;
    c = a.d;
    a.d = b;
    switch(c.g){
        case 0:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 1:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$PDb(a);
            }
            break;
        case 2:
            switch(b.g){
                case 1:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$YDb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$PDb(a);
            }
            break;
        case 1:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$YDb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$PDb(a);
            }
            break;
        case 4:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 1:
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$YDb(a);
            }
            break;
        case 3:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 1:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$bEb(a);
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$PDb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$XDb(a);
                    $61de1ee1cac498ae$var$YDb(a);
            }
    }
    return a;
}
function $61de1ee1cac498ae$var$tVb(a, b) {
    var c;
    if (a.d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb(($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$LP), $61de1ee1cac498ae$var$Jke + $61de1ee1cac498ae$var$LP.k + $61de1ee1cac498ae$var$Kke)));
    if (!$61de1ee1cac498ae$var$cVb(a.a, b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz($61de1ee1cac498ae$var$Lke + b + $61de1ee1cac498ae$var$Mke));
    if (b == a.c) return a;
    c = a.c;
    a.c = b;
    switch(c.g){
        case 0:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 1:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
            }
            break;
        case 2:
            switch(b.g){
                case 1:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$yVb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
            }
            break;
        case 1:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$yVb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
            }
            break;
        case 4:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 1:
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 3:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$yVb(a);
            }
            break;
        case 3:
            switch(b.g){
                case 2:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 1:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$BVb(a);
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$qVb(a);
                    break;
                case 4:
                    $61de1ee1cac498ae$var$xVb(a);
                    $61de1ee1cac498ae$var$yVb(a);
            }
    }
    return a;
}
function $61de1ee1cac498ae$var$UQb(a, b, c) {
    var d, e, f, g, h, i, j, k;
    for(i = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); i.e != i.i.gc();){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 33);
        for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 79);
            !d.b && (d.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 4, 7));
            if (!(d.b.i <= 1 && (!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c.i <= 1))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$z2c("Graph must not contain hyperedges."));
            if (!$61de1ee1cac498ae$var$Pld(d) && h != $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c), 0), 82))) {
                j = new $61de1ee1cac498ae$var$gRb;
                $61de1ee1cac498ae$var$tNb(j, d);
                $61de1ee1cac498ae$var$yNb(j, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$FSb), d);
                $61de1ee1cac498ae$var$dRb(j, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(c.f, h)), 144));
                $61de1ee1cac498ae$var$eRb(j, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(c, $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!d.c && (d.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, d, 5, 8)), d.c), 0), 82))), 144));
                $61de1ee1cac498ae$var$Ekb(b.c, j);
                for(g = new $61de1ee1cac498ae$var$Fyd((!d.n && (d.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, d, 1, 7)), d.n)); g.e != g.i.gc();){
                    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(g), 137);
                    k = new $61de1ee1cac498ae$var$mRb(j, f.a);
                    $61de1ee1cac498ae$var$tNb(k, f);
                    $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$FSb, f);
                    k.e.a = $61de1ee1cac498ae$var$$wnd.Math.max(f.g, 1);
                    k.e.b = $61de1ee1cac498ae$var$$wnd.Math.max(f.f, 1);
                    $61de1ee1cac498ae$var$lRb(k);
                    $61de1ee1cac498ae$var$Ekb(b.d, k);
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$OGb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    l = new $61de1ee1cac498ae$var$LIb(a);
    $61de1ee1cac498ae$var$iKb(l, !(b == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$dad) || b == $61de1ee1cac498ae$var$_9c));
    k = l.a;
    m = new $61de1ee1cac498ae$var$p0b;
    for(e = ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ])), g = 0, i = e.length; g < i; ++g){
        c = e[g];
        j = $61de1ee1cac498ae$var$xHb(k, $61de1ee1cac498ae$var$dHb, c);
        !!j && (m.d = $61de1ee1cac498ae$var$$wnd.Math.max(m.d, j.Re()));
    }
    for(d = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ]), f = 0, h = d.length; f < h; ++f){
        c = d[f];
        j = $61de1ee1cac498ae$var$xHb(k, $61de1ee1cac498ae$var$fHb, c);
        !!j && (m.a = $61de1ee1cac498ae$var$$wnd.Math.max(m.a, j.Re()));
    }
    for(p = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ]), r = 0, t = p.length; r < t; ++r){
        n = p[r];
        j = $61de1ee1cac498ae$var$xHb(k, n, $61de1ee1cac498ae$var$dHb);
        !!j && (m.b = $61de1ee1cac498ae$var$$wnd.Math.max(m.b, j.Se()));
    }
    for(o = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ]), q = 0, s = o.length; q < s; ++q){
        n = o[q];
        j = $61de1ee1cac498ae$var$xHb(k, n, $61de1ee1cac498ae$var$fHb);
        !!j && (m.c = $61de1ee1cac498ae$var$$wnd.Math.max(m.c, j.Se()));
    }
    if (m.d > 0) {
        m.d += k.n.d;
        m.d += k.d;
    }
    if (m.a > 0) {
        m.a += k.n.a;
        m.a += k.d;
    }
    if (m.b > 0) {
        m.b += k.n.b;
        m.b += k.d;
    }
    if (m.c > 0) {
        m.c += k.n.c;
        m.c += k.d;
    }
    return m;
}
function $61de1ee1cac498ae$var$d6b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o;
    m = c.d;
    l = c.c;
    f = new $61de1ee1cac498ae$var$f7c(c.f.a + c.d.b + c.d.c, c.f.b + c.d.d + c.d.a);
    g = f.b;
    for(j = new $61de1ee1cac498ae$var$olb(a.a); j.a < j.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        if (h.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) continue;
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, $61de1ee1cac498ae$var$Isc), 8);
        k = h.n;
        switch(d.g){
            case 2:
                k.a = c.f.a + m.c - l.a;
                break;
            case 4:
                k.a = -l.a - m.b;
        }
        o = 0;
        switch(d.g){
            case 2:
            case 4:
                if (b == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$_bd)) {
                    n = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(h, $61de1ee1cac498ae$var$htc)));
                    k.b = f.b * n - $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Txc)), 8).b;
                    o = k.b + e.b;
                    $61de1ee1cac498ae$var$M_b(h, false, true);
                } else if (b == $61de1ee1cac498ae$var$$bd) {
                    k.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(h, $61de1ee1cac498ae$var$htc))) - $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Txc)), 8).b;
                    o = k.b + e.b;
                    $61de1ee1cac498ae$var$M_b(h, false, true);
                }
        }
        g = $61de1ee1cac498ae$var$$wnd.Math.max(g, o);
    }
    c.f.b += g - f.b;
    for(i = new $61de1ee1cac498ae$var$olb(a.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        if (h.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) continue;
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61);
        k = h.n;
        switch(d.g){
            case 1:
                k.b = -l.b - m.d;
                break;
            case 3:
                k.b = c.f.b + m.a - l.b;
        }
    }
}
function $61de1ee1cac498ae$var$nRc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$dTc)), 33);
    j = $61de1ee1cac498ae$var$Ohe;
    k = $61de1ee1cac498ae$var$Ohe;
    h = $61de1ee1cac498ae$var$Rie;
    i = $61de1ee1cac498ae$var$Rie;
    for(w = $61de1ee1cac498ae$var$Jsb(a.b, 0); w.b != w.d.c;){
        u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(w), 86);
        p = u.e;
        q = u.f;
        j = $61de1ee1cac498ae$var$$wnd.Math.min(j, p.a - q.a / 2);
        k = $61de1ee1cac498ae$var$$wnd.Math.min(k, p.b - q.b / 2);
        h = $61de1ee1cac498ae$var$$wnd.Math.max(h, p.a + q.a / 2);
        i = $61de1ee1cac498ae$var$$wnd.Math.max(i, p.b + q.b / 2);
    }
    o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(e, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$BTc)), 116);
    n = new $61de1ee1cac498ae$var$f7c(o.b - j, o.d - k);
    for(v = $61de1ee1cac498ae$var$Jsb(a.b, 0); v.b != v.d.c;){
        u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(v), 86);
        m = $61de1ee1cac498ae$var$vNb(u, $61de1ee1cac498ae$var$dTc);
        if ($61de1ee1cac498ae$var$JD(m, 239)) {
            f = $61de1ee1cac498ae$var$BD(m, 33);
            l = $61de1ee1cac498ae$var$P6c(u.e, n);
            $61de1ee1cac498ae$var$bld(f, l.a - f.g / 2, l.b - f.f / 2);
        }
    }
    for(t = $61de1ee1cac498ae$var$Jsb(a.a, 0); t.b != t.d.c;){
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(t), 188);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(s, $61de1ee1cac498ae$var$dTc), 79);
        if (d) {
            b = s.a;
            r = new $61de1ee1cac498ae$var$g7c(s.b.e);
            $61de1ee1cac498ae$var$Gsb(b, r, b.a, b.a.a);
            A = new $61de1ee1cac498ae$var$g7c(s.c.e);
            $61de1ee1cac498ae$var$Gsb(b, A, b.c.b, b.c);
            $61de1ee1cac498ae$var$qRc(r, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(b, 1), 8), s.b.f);
            $61de1ee1cac498ae$var$qRc(A, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(b, b.b - 2), 8), s.c.f);
            c = $61de1ee1cac498ae$var$itd(d, true, true);
            $61de1ee1cac498ae$var$ifd(b, c);
        }
    }
    B = h - j + (o.b + o.c);
    g = i - k + (o.d + o.a);
    $61de1ee1cac498ae$var$Afd(e, B, g, false, false);
}
function $61de1ee1cac498ae$var$xoc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    l = a.b;
    k = new $61de1ee1cac498ae$var$Bib(l, 0);
    $61de1ee1cac498ae$var$Aib(k, new $61de1ee1cac498ae$var$H1b(a));
    s = false;
    g = 1;
    while(k.b < k.d.gc()){
        j = ($61de1ee1cac498ae$var$sCb(k.b < k.d.gc()), $61de1ee1cac498ae$var$BD(k.d.Xb(k.c = k.b++), 29));
        p = ($61de1ee1cac498ae$var$tCb(g, l.c.length), $61de1ee1cac498ae$var$BD(l.c[g], 29));
        q = $61de1ee1cac498ae$var$Mu(j.a);
        r = q.c.length;
        for(o = new $61de1ee1cac498ae$var$olb(q); o.a < o.c.c.length;){
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
            $61de1ee1cac498ae$var$$_b(m, p);
        }
        if (s) {
            for(n = $61de1ee1cac498ae$var$av(new $61de1ee1cac498ae$var$ov(q), 0); n.c.Sb();){
                m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$pv(n), 10);
                for(f = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$Mu($61de1ee1cac498ae$var$R_b(m))); f.a < f.c.c.length;){
                    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                    $61de1ee1cac498ae$var$PZb(e, true);
                    $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Asc), ($61de1ee1cac498ae$var$Bcb(), true));
                    d = $61de1ee1cac498ae$var$Noc(a, e, r);
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(m, $61de1ee1cac498ae$var$usc), 305);
                    t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d, d.c.length - 1), 17);
                    c.k = t.c.i;
                    c.n = t;
                    c.b = e.d.i;
                    c.c = e;
                }
            }
            s = false;
        } else if (q.c.length != 0) {
            b = ($61de1ee1cac498ae$var$tCb(0, q.c.length), $61de1ee1cac498ae$var$BD(q.c[0], 10));
            if (b.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$d0b)) {
                s = true;
                g = -1;
            }
        }
        ++g;
    }
    h = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    while(h.b < h.d.gc()){
        i = ($61de1ee1cac498ae$var$sCb(h.b < h.d.gc()), $61de1ee1cac498ae$var$BD(h.d.Xb(h.c = h.b++), 29));
        i.a.c.length == 0 && $61de1ee1cac498ae$var$uib(h);
    }
}
function $61de1ee1cac498ae$var$wKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    if (k.gc() <= 2 || b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) || b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)) {
        $61de1ee1cac498ae$var$AKb(a, b);
        return;
    }
    p = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$qcd));
    c = b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? ($61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$uLb) : ($61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$rLb);
    r = b == $61de1ee1cac498ae$var$Acd ? ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb) : ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb);
    d = $61de1ee1cac498ae$var$dLb($61de1ee1cac498ae$var$iLb(c), a.s);
    q = b == $61de1ee1cac498ae$var$Acd ? $61de1ee1cac498ae$var$Pje : $61de1ee1cac498ae$var$Qje;
    for(j = k.Kc(); j.Ob();){
        h = $61de1ee1cac498ae$var$BD(j.Pb(), 111);
        if (!h.c || h.c.d.c.length <= 0) continue;
        o = h.b.rf();
        n = h.e;
        l = h.c;
        m = l.i;
        m.b = (f = l.n, l.e.a + f.b + f.c);
        m.a = (g = l.n, l.e.b + g.d + g.a);
        if (p) {
            m.c = n.a - (e = l.n, l.e.a + e.b + e.c) - a.s;
            p = false;
        } else m.c = n.a + o.a + a.s;
        $61de1ee1cac498ae$var$ytb(r, $61de1ee1cac498ae$var$lle);
        l.f = r;
        $61de1ee1cac498ae$var$$Hb(l, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
        $61de1ee1cac498ae$var$Ekb(d.d, new $61de1ee1cac498ae$var$BLb(m, $61de1ee1cac498ae$var$bLb(d, m)));
        q = b == $61de1ee1cac498ae$var$Acd ? $61de1ee1cac498ae$var$$wnd.Math.min(q, n.b) : $61de1ee1cac498ae$var$$wnd.Math.max(q, n.b + h.b.rf().b);
    }
    q += b == $61de1ee1cac498ae$var$Acd ? -a.t : a.t;
    $61de1ee1cac498ae$var$cLb((d.e = q, d));
    for(i = k.Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 111);
        if (!h.c || h.c.d.c.length <= 0) continue;
        m = h.c.i;
        m.c -= h.e.a;
        m.d -= h.e.b;
    }
}
function $61de1ee1cac498ae$var$IDc(a, b, c) {
    var d;
    $61de1ee1cac498ae$var$Odd(c, "StretchWidth layering", 1);
    if (b.a.c.length == 0) {
        $61de1ee1cac498ae$var$Qdd(c);
        return;
    }
    a.c = b;
    a.t = 0;
    a.u = 0;
    a.i = $61de1ee1cac498ae$var$Pje;
    a.g = $61de1ee1cac498ae$var$Qje;
    a.d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$lyc))));
    $61de1ee1cac498ae$var$CDc(a);
    $61de1ee1cac498ae$var$DDc(a);
    $61de1ee1cac498ae$var$ADc(a);
    $61de1ee1cac498ae$var$HDc(a);
    $61de1ee1cac498ae$var$BDc(a);
    a.i = $61de1ee1cac498ae$var$$wnd.Math.max(1, a.i);
    a.g = $61de1ee1cac498ae$var$$wnd.Math.max(1, a.g);
    a.d = a.d / a.i;
    a.f = a.g / a.i;
    a.s = $61de1ee1cac498ae$var$FDc(a);
    d = new $61de1ee1cac498ae$var$H1b(a.c);
    $61de1ee1cac498ae$var$Ekb(a.c.b, d);
    a.r = $61de1ee1cac498ae$var$Mu(a.p);
    a.n = $61de1ee1cac498ae$var$tlb(a.k, a.k.length);
    while(a.r.c.length != 0){
        a.o = $61de1ee1cac498ae$var$JDc(a);
        if (!a.o || $61de1ee1cac498ae$var$EDc(a) && a.b.a.gc() != 0) {
            $61de1ee1cac498ae$var$KDc(a, d);
            d = new $61de1ee1cac498ae$var$H1b(a.c);
            $61de1ee1cac498ae$var$Ekb(a.c.b, d);
            $61de1ee1cac498ae$var$ye(a.a, a.b);
            a.b.a.$b();
            a.t = a.u;
            a.u = 0;
        } else if ($61de1ee1cac498ae$var$EDc(a)) {
            a.c.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            d = new $61de1ee1cac498ae$var$H1b(a.c);
            $61de1ee1cac498ae$var$Ekb(a.c.b, d);
            a.t = 0;
            a.u = 0;
            a.b.a.$b();
            a.a.a.$b();
            ++a.f;
            a.r = $61de1ee1cac498ae$var$Mu(a.p);
            a.n = $61de1ee1cac498ae$var$tlb(a.k, a.k.length);
        } else {
            $61de1ee1cac498ae$var$$_b(a.o, d);
            $61de1ee1cac498ae$var$Lkb(a.r, a.o);
            $61de1ee1cac498ae$var$Qqb(a.b, a.o);
            a.t = a.t - a.k[a.o.p] * a.d + a.j[a.o.p];
            a.u += a.e[a.o.p] * a.d;
        }
    }
    b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$smb(b.b);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$Mgc(a) {
    var b, c, d, e;
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.a.b, 16)), new $61de1ee1cac498ae$var$khc), new $61de1ee1cac498ae$var$mhc);
    $61de1ee1cac498ae$var$Kgc(a);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.a.b, 16)), new $61de1ee1cac498ae$var$ohc), new $61de1ee1cac498ae$var$qhc);
    if (a.c == ($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$yad)) {
        $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(new $61de1ee1cac498ae$var$Pib(a.f), 1)), new $61de1ee1cac498ae$var$yhc), new $61de1ee1cac498ae$var$Ahc), new $61de1ee1cac498ae$var$Chc(a));
        $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$LAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.d.b, 16)), new $61de1ee1cac498ae$var$Ghc), new $61de1ee1cac498ae$var$Ihc), new $61de1ee1cac498ae$var$Khc), new $61de1ee1cac498ae$var$Mhc), new $61de1ee1cac498ae$var$Ohc(a));
    }
    e = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Pje, $61de1ee1cac498ae$var$Pje);
    b = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Qje, $61de1ee1cac498ae$var$Qje);
    for(d = new $61de1ee1cac498ae$var$olb(a.a.b); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 57);
        e.a = $61de1ee1cac498ae$var$$wnd.Math.min(e.a, c.d.c);
        e.b = $61de1ee1cac498ae$var$$wnd.Math.min(e.b, c.d.d);
        b.a = $61de1ee1cac498ae$var$$wnd.Math.max(b.a, c.d.c + c.d.b);
        b.b = $61de1ee1cac498ae$var$$wnd.Math.max(b.b, c.d.d + c.d.a);
    }
    $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(a.d.c), $61de1ee1cac498ae$var$V6c(new $61de1ee1cac498ae$var$f7c(e.a, e.b)));
    $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(a.d.f), $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(b.a, b.b), e));
    $61de1ee1cac498ae$var$Lgc(a, e, b);
    $61de1ee1cac498ae$var$Uhb(a.f);
    $61de1ee1cac498ae$var$Uhb(a.b);
    $61de1ee1cac498ae$var$Uhb(a.g);
    $61de1ee1cac498ae$var$Uhb(a.e);
    a.a.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.a.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.a = null;
    a.d = null;
}
function $61de1ee1cac498ae$var$vZb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    e = new $61de1ee1cac498ae$var$Rkb;
    for(p = new $61de1ee1cac498ae$var$olb(b.a); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 10);
        n = o.e;
        if (n) {
            d = $61de1ee1cac498ae$var$vZb(a, n, o);
            $61de1ee1cac498ae$var$Gkb(e, d);
            $61de1ee1cac498ae$var$sZb(a, n, o);
            if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(n, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc))) {
                s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
                m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$Yxc), 174).Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd));
                for(r = new $61de1ee1cac498ae$var$olb(o.j); r.a < r.c.c.length;){
                    q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(r), 11);
                    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, q), 10);
                    if (!f) {
                        f = $61de1ee1cac498ae$var$Z$b(q, s, q.j, -(q.e.c.length - q.g.c.length), null, new $61de1ee1cac498ae$var$d7c, q.o, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(n, $61de1ee1cac498ae$var$Lwc), 103), n);
                        $61de1ee1cac498ae$var$yNb(f, $61de1ee1cac498ae$var$$sc, q);
                        $61de1ee1cac498ae$var$Rhb(a.b, q, f);
                        $61de1ee1cac498ae$var$Ekb(n.a, f);
                    }
                    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(f.j, 0), 11);
                    for(k = new $61de1ee1cac498ae$var$olb(q.f); k.a < k.c.c.length;){
                        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 70);
                        h = new $61de1ee1cac498ae$var$p_b;
                        h.o.a = j.o.a;
                        h.o.b = j.o.b;
                        $61de1ee1cac498ae$var$Ekb(g.f, h);
                        if (!m) {
                            t = q.j;
                            l = 0;
                            $61de1ee1cac498ae$var$tcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$Yxc), 21)) && (l = $61de1ee1cac498ae$var$mfd(j.n, j.o, q.o, 0, t));
                            s == ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$bcd) || ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Ecd).Hc(t) ? h.o.a = l : h.o.b = l;
                        }
                    }
                }
            }
        }
    }
    i = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$rZb(a, b, c, e, i);
    !!c && $61de1ee1cac498ae$var$tZb(a, b, c, i);
    return i;
}
function $61de1ee1cac498ae$var$nEc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    if (a.c[b.c.p][b.p].e) return;
    else a.c[b.c.p][b.p].e = true;
    a.c[b.c.p][b.p].b = 0;
    a.c[b.c.p][b.p].d = 0;
    a.c[b.c.p][b.p].a = null;
    for(k = new $61de1ee1cac498ae$var$olb(b.j); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 11);
        l = c ? new $61de1ee1cac498ae$var$J0b(j) : new $61de1ee1cac498ae$var$R0b(j);
        for(i = l.Kc(); i.Ob();){
            h = $61de1ee1cac498ae$var$BD(i.Pb(), 11);
            g = h.i;
            if (g.c == b.c) {
                if (g != b) {
                    $61de1ee1cac498ae$var$nEc(a, g, c);
                    a.c[b.c.p][b.p].b += a.c[g.c.p][g.p].b;
                    a.c[b.c.p][b.p].d += a.c[g.c.p][g.p].d;
                }
            } else {
                a.c[b.c.p][b.p].d += a.g[h.p];
                ++a.c[b.c.p][b.p].b;
            }
        }
    }
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ssc)), 15);
    if (f) for(e = f.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 10);
        if (b.c == d.c) {
            $61de1ee1cac498ae$var$nEc(a, d, c);
            a.c[b.c.p][b.p].b += a.c[d.c.p][d.p].b;
            a.c[b.c.p][b.p].d += a.c[d.c.p][d.p].d;
        }
    }
    if (a.c[b.c.p][b.p].b > 0) {
        a.c[b.c.p][b.p].d += $61de1ee1cac498ae$var$Cub(a.i, 24) * $61de1ee1cac498ae$var$lke * 0.07000000029802322 - 0.03500000014901161;
        a.c[b.c.p][b.p].a = a.c[b.c.p][b.p].d / a.c[b.c.p][b.p].b;
    }
}
function $61de1ee1cac498ae$var$m5b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    for(o = new $61de1ee1cac498ae$var$olb(a); o.a < o.c.c.length;){
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
        $61de1ee1cac498ae$var$n5b(n.n);
        $61de1ee1cac498ae$var$n5b(n.o);
        $61de1ee1cac498ae$var$o5b(n.f);
        $61de1ee1cac498ae$var$r5b(n);
        $61de1ee1cac498ae$var$t5b(n);
        for(q = new $61de1ee1cac498ae$var$olb(n.j); q.a < q.c.c.length;){
            p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 11);
            $61de1ee1cac498ae$var$n5b(p.n);
            $61de1ee1cac498ae$var$n5b(p.a);
            $61de1ee1cac498ae$var$n5b(p.o);
            $61de1ee1cac498ae$var$G0b(p, $61de1ee1cac498ae$var$s5b(p.j));
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(p, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Wxc)), 19);
            !!f && $61de1ee1cac498ae$var$yNb(p, $61de1ee1cac498ae$var$Wxc, $61de1ee1cac498ae$var$meb(-f.a));
            for(e = new $61de1ee1cac498ae$var$olb(p.g); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                for(c = $61de1ee1cac498ae$var$Jsb(d.a, 0); c.b != c.d.c;){
                    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(c), 8);
                    $61de1ee1cac498ae$var$n5b(b);
                }
                i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$jxc), 74);
                if (i) for(h = $61de1ee1cac498ae$var$Jsb(i, 0); h.b != h.d.c;){
                    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(h), 8);
                    $61de1ee1cac498ae$var$n5b(g);
                }
                for(l = new $61de1ee1cac498ae$var$olb(d.b); l.a < l.c.c.length;){
                    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 70);
                    $61de1ee1cac498ae$var$n5b(j.n);
                    $61de1ee1cac498ae$var$n5b(j.o);
                }
            }
            for(m = new $61de1ee1cac498ae$var$olb(p.f); m.a < m.c.c.length;){
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 70);
                $61de1ee1cac498ae$var$n5b(j.n);
                $61de1ee1cac498ae$var$n5b(j.o);
            }
        }
        if (n.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
            $61de1ee1cac498ae$var$yNb(n, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc), $61de1ee1cac498ae$var$s5b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(n, $61de1ee1cac498ae$var$Hsc), 61)));
            $61de1ee1cac498ae$var$q5b(n);
        }
        for(k = new $61de1ee1cac498ae$var$olb(n.b); k.a < k.c.c.length;){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 70);
            $61de1ee1cac498ae$var$r5b(j);
            $61de1ee1cac498ae$var$n5b(j.o);
            $61de1ee1cac498ae$var$n5b(j.n);
        }
    }
}
function $61de1ee1cac498ae$var$yQb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
    a.e = b;
    h = $61de1ee1cac498ae$var$$Pb(b);
    w = new $61de1ee1cac498ae$var$Rkb;
    for(d = new $61de1ee1cac498ae$var$olb(h); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 15);
        A = new $61de1ee1cac498ae$var$Rkb;
        w.c[w.c.length] = A;
        i = new $61de1ee1cac498ae$var$Tqb;
        for(o = c.Kc(); o.Ob();){
            n = $61de1ee1cac498ae$var$BD(o.Pb(), 33);
            f = $61de1ee1cac498ae$var$wQb(a, n, true, 0, 0);
            A.c[A.c.length] = f;
            p = n.i;
            q = n.j;
            new $61de1ee1cac498ae$var$f7c(p, q);
            m = (!n.n && (n.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, n, 1, 7)), n.n);
            for(l = new $61de1ee1cac498ae$var$Fyd(m); l.e != l.i.gc();){
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(l), 137);
                e = $61de1ee1cac498ae$var$wQb(a, j, false, p, q);
                A.c[A.c.length] = e;
            }
            v = (!n.c && (n.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, n, 9, 9)), n.c);
            for(s = new $61de1ee1cac498ae$var$Fyd(v); s.e != s.i.gc();){
                r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(s), 118);
                g = $61de1ee1cac498ae$var$wQb(a, r, false, p, q);
                A.c[A.c.length] = g;
                t = r.i + p;
                u = r.j + q;
                m = (!r.n && (r.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, r, 1, 7)), r.n);
                for(k = new $61de1ee1cac498ae$var$Fyd(m); k.e != k.i.gc();){
                    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(k), 137);
                    e = $61de1ee1cac498ae$var$wQb(a, j, false, t, u);
                    A.c[A.c.length] = e;
                }
            }
            $61de1ee1cac498ae$var$ye(i, $61de1ee1cac498ae$var$Dx($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                $61de1ee1cac498ae$var$_sd(n),
                $61de1ee1cac498ae$var$$sd(n)
            ]))));
        }
        $61de1ee1cac498ae$var$vQb(a, i, A);
    }
    a.f = new $61de1ee1cac498ae$var$aPb(w);
    $61de1ee1cac498ae$var$tNb(a.f, b);
    return a.f;
}
function $61de1ee1cac498ae$var$Kqd(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    D = $61de1ee1cac498ae$var$Ohb(a.e, d);
    if (D == null) {
        D = new $61de1ee1cac498ae$var$eC;
        n = $61de1ee1cac498ae$var$BD(D, 183);
        s = b + "_s";
        t = s + e;
        m = new $61de1ee1cac498ae$var$yC(t);
        $61de1ee1cac498ae$var$cC(n, $61de1ee1cac498ae$var$Vte, m);
    }
    C = $61de1ee1cac498ae$var$BD(D, 183);
    $61de1ee1cac498ae$var$Qpd(c, C);
    G = new $61de1ee1cac498ae$var$eC;
    $61de1ee1cac498ae$var$Spd(G, "x", d.j);
    $61de1ee1cac498ae$var$Spd(G, "y", d.k);
    $61de1ee1cac498ae$var$cC(C, $61de1ee1cac498ae$var$Yte, G);
    A = new $61de1ee1cac498ae$var$eC;
    $61de1ee1cac498ae$var$Spd(A, "x", d.b);
    $61de1ee1cac498ae$var$Spd(A, "y", d.c);
    $61de1ee1cac498ae$var$cC(C, "endPoint", A);
    l = $61de1ee1cac498ae$var$Fhe((!d.a && (d.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, d, 5)), d.a));
    o = !l;
    if (o) {
        w = new $61de1ee1cac498ae$var$wB;
        f = new $61de1ee1cac498ae$var$Srd(w);
        $61de1ee1cac498ae$var$reb((!d.a && (d.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, d, 5)), d.a), f);
        $61de1ee1cac498ae$var$cC(C, $61de1ee1cac498ae$var$Ote, w);
    }
    i = $61de1ee1cac498ae$var$dmd(d);
    u = !!i;
    u && $61de1ee1cac498ae$var$Tpd(a.a, C, $61de1ee1cac498ae$var$Qte, $61de1ee1cac498ae$var$kqd(a, $61de1ee1cac498ae$var$dmd(d)));
    r = $61de1ee1cac498ae$var$emd(d);
    v = !!r;
    v && $61de1ee1cac498ae$var$Tpd(a.a, C, $61de1ee1cac498ae$var$Pte, $61de1ee1cac498ae$var$kqd(a, $61de1ee1cac498ae$var$emd(d)));
    j = (!d.e && (d.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, d, 10, 9)), d.e).i == 0;
    p = !j;
    if (p) {
        B = new $61de1ee1cac498ae$var$wB;
        g = new $61de1ee1cac498ae$var$Urd(a, B);
        $61de1ee1cac498ae$var$reb((!d.e && (d.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, d, 10, 9)), d.e), g);
        $61de1ee1cac498ae$var$cC(C, $61de1ee1cac498ae$var$Ste, B);
    }
    k = (!d.g && (d.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, d, 9, 10)), d.g).i == 0;
    q = !k;
    if (q) {
        F = new $61de1ee1cac498ae$var$wB;
        h = new $61de1ee1cac498ae$var$Wrd(a, F);
        $61de1ee1cac498ae$var$reb((!d.g && (d.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, d, 9, 10)), d.g), h);
        $61de1ee1cac498ae$var$cC(C, $61de1ee1cac498ae$var$Rte, F);
    }
}
function $61de1ee1cac498ae$var$eKb(a) {
    $61de1ee1cac498ae$var$$Jb();
    var b, c, d, e, f, g, h;
    d = a.f.n;
    for(g = $61de1ee1cac498ae$var$ci(a.r).a.nc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 111);
        e = 0;
        if (f.b.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c))) {
            e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(f.b.We($61de1ee1cac498ae$var$s9c)));
            if (e < 0) switch(f.b.Hf().g){
                case 1:
                    d.d = $61de1ee1cac498ae$var$$wnd.Math.max(d.d, -e);
                    break;
                case 3:
                    d.a = $61de1ee1cac498ae$var$$wnd.Math.max(d.a, -e);
                    break;
                case 2:
                    d.c = $61de1ee1cac498ae$var$$wnd.Math.max(d.c, -e);
                    break;
                case 4:
                    d.b = $61de1ee1cac498ae$var$$wnd.Math.max(d.b, -e);
            }
        }
        if ($61de1ee1cac498ae$var$tcd(a.u)) {
            b = $61de1ee1cac498ae$var$nfd(f.b, e);
            h = !$61de1ee1cac498ae$var$BD(a.e.We($61de1ee1cac498ae$var$b9c), 174).Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$zdd));
            c = false;
            switch(f.b.Hf().g){
                case 1:
                    c = b > d.d;
                    d.d = $61de1ee1cac498ae$var$$wnd.Math.max(d.d, b);
                    if (h && c) {
                        d.d = $61de1ee1cac498ae$var$$wnd.Math.max(d.d, d.a);
                        d.a = d.d + e;
                    }
                    break;
                case 3:
                    c = b > d.a;
                    d.a = $61de1ee1cac498ae$var$$wnd.Math.max(d.a, b);
                    if (h && c) {
                        d.a = $61de1ee1cac498ae$var$$wnd.Math.max(d.a, d.d);
                        d.d = d.a + e;
                    }
                    break;
                case 2:
                    c = b > d.c;
                    d.c = $61de1ee1cac498ae$var$$wnd.Math.max(d.c, b);
                    if (h && c) {
                        d.c = $61de1ee1cac498ae$var$$wnd.Math.max(d.b, d.c);
                        d.b = d.c + e;
                    }
                    break;
                case 4:
                    c = b > d.b;
                    d.b = $61de1ee1cac498ae$var$$wnd.Math.max(d.b, b);
                    if (h && c) {
                        d.b = $61de1ee1cac498ae$var$$wnd.Math.max(d.b, d.c);
                        d.c = d.b + e;
                    }
            }
        }
    }
}
function $61de1ee1cac498ae$var$l3b(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    for(j = new $61de1ee1cac498ae$var$olb(a); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163);
        f = null;
        switch(g.g){
            case 1:
            case 2:
                f = ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Fqc);
                break;
            case 3:
            case 4:
                f = ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Dqc);
        }
        if (f) {
            $61de1ee1cac498ae$var$yNb(i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Bsc), ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Fqc));
            f == $61de1ee1cac498ae$var$Dqc ? $61de1ee1cac498ae$var$o3b(i, g, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc)) : f == $61de1ee1cac498ae$var$Fqc && $61de1ee1cac498ae$var$o3b(i, g, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc));
        } else if ($61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$Vxc), 98)) && i.j.c.length != 0) {
            b = true;
            for(l = new $61de1ee1cac498ae$var$olb(i.j); l.a < l.c.c.length;){
                k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 11);
                if (!(k.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) && k.e.c.length - k.g.c.length > 0 || k.j == $61de1ee1cac498ae$var$Tcd && k.e.c.length - k.g.c.length < 0)) {
                    b = false;
                    break;
                }
                for(e = new $61de1ee1cac498ae$var$olb(k.g); e.a < e.c.c.length;){
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c.d.i, $61de1ee1cac498ae$var$mxc), 163);
                    if (h == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ztc) || h == $61de1ee1cac498ae$var$Atc) {
                        b = false;
                        break;
                    }
                }
                for(d = new $61de1ee1cac498ae$var$olb(k.e); d.a < d.c.c.length;){
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 17);
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c.c.i, $61de1ee1cac498ae$var$mxc), 163);
                    if (h == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$xtc) || h == $61de1ee1cac498ae$var$ytc) {
                        b = false;
                        break;
                    }
                }
            }
            b && $61de1ee1cac498ae$var$o3b(i, g, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$JAc));
        }
    }
}
function $61de1ee1cac498ae$var$lJc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    w = 0;
    n = 0;
    for(l = new $61de1ee1cac498ae$var$olb(b.e); l.a < l.c.c.length;){
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 10);
        m = 0;
        h = 0;
        i = c ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, $61de1ee1cac498ae$var$hJc), 19).a : $61de1ee1cac498ae$var$Rie;
        r = d ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, $61de1ee1cac498ae$var$iJc), 19).a : $61de1ee1cac498ae$var$Rie;
        j = $61de1ee1cac498ae$var$$wnd.Math.max(i, r);
        for(t = new $61de1ee1cac498ae$var$olb(k.j); t.a < t.c.c.length;){
            s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(t), 11);
            u = k.n.b + s.n.b + s.a.b;
            if (d) for(g = new $61de1ee1cac498ae$var$olb(s.g); g.a < g.c.c.length;){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
                p = f.d;
                o = p.i;
                if (b != a.a[o.p]) {
                    q = $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$hJc), 19).a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$iJc), 19).a);
                    v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$eyc)), 19).a;
                    if (v >= j && v >= q) {
                        m += o.n.b + p.n.b + p.a.b - u;
                        ++h;
                    }
                }
            }
            if (c) for(g = new $61de1ee1cac498ae$var$olb(s.e); g.a < g.c.c.length;){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
                p = f.c;
                o = p.i;
                if (b != a.a[o.p]) {
                    q = $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$hJc), 19).a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$iJc), 19).a);
                    v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$eyc)), 19).a;
                    if (v >= j && v >= q) {
                        m += o.n.b + p.n.b + p.a.b - u;
                        ++h;
                    }
                }
            }
        }
        if (h > 0) {
            w += m / h;
            ++n;
        }
    }
    if (n > 0) {
        b.a = e * w / n;
        b.g = n;
    } else {
        b.a = 0;
        b.g = 0;
    }
}
function $61de1ee1cac498ae$var$oMc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    for(e = new $61de1ee1cac498ae$var$olb(a.a.b); e.a < e.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        for(i = new $61de1ee1cac498ae$var$olb(c.a); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
            b.j[h.p] = h;
            b.i[h.p] = b.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc) ? $61de1ee1cac498ae$var$Qje : $61de1ee1cac498ae$var$Pje;
        }
    }
    $61de1ee1cac498ae$var$Uhb(a.c);
    g = a.a.b;
    b.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc) && (g = $61de1ee1cac498ae$var$JD(g, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(g, 152)) : $61de1ee1cac498ae$var$JD(g, 131) ? $61de1ee1cac498ae$var$BD(g, 131).a : $61de1ee1cac498ae$var$JD(g, 54) ? new $61de1ee1cac498ae$var$ov(g) : new $61de1ee1cac498ae$var$dv(g));
    $61de1ee1cac498ae$var$UMc(a.e, b, a.b);
    $61de1ee1cac498ae$var$Alb(b.p, null);
    for(f = g.Kc(); f.Ob();){
        c = $61de1ee1cac498ae$var$BD(f.Pb(), 29);
        j = c.a;
        b.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc) && (j = $61de1ee1cac498ae$var$JD(j, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(j, 152)) : $61de1ee1cac498ae$var$JD(j, 131) ? $61de1ee1cac498ae$var$BD(j, 131).a : $61de1ee1cac498ae$var$JD(j, 54) ? new $61de1ee1cac498ae$var$ov(j) : new $61de1ee1cac498ae$var$dv(j));
        for(m = j.Kc(); m.Ob();){
            l = $61de1ee1cac498ae$var$BD(m.Pb(), 10);
            b.g[l.p] == l && $61de1ee1cac498ae$var$pMc(a, l, b);
        }
    }
    $61de1ee1cac498ae$var$qMc(a, b);
    for(d = g.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 29);
        for(m = new $61de1ee1cac498ae$var$olb(c.a); m.a < m.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
            b.p[l.p] = b.p[b.g[l.p].p];
            if (l == b.g[l.p]) {
                k = $61de1ee1cac498ae$var$Edb(b.i[b.j[l.p].p]);
                (b.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc) && k > $61de1ee1cac498ae$var$Qje || b.o == $61de1ee1cac498ae$var$cMc && k < $61de1ee1cac498ae$var$Pje) && (b.p[l.p] = $61de1ee1cac498ae$var$Edb(b.p[l.p]) + k);
            }
        }
    }
    a.e.cg();
}
function $61de1ee1cac498ae$var$PGb(a, b, c, d) {
    var e, f, g, h, i;
    h = new $61de1ee1cac498ae$var$LIb(b);
    $61de1ee1cac498ae$var$rKb(h, d);
    e = true;
    if (!!a && a.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$z8c))) {
        f = $61de1ee1cac498ae$var$BD(a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$z8c)), 103);
        e = f == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad) || f == $61de1ee1cac498ae$var$aad || f == $61de1ee1cac498ae$var$bad;
    }
    $61de1ee1cac498ae$var$hKb(h, false);
    $61de1ee1cac498ae$var$Hkb(h.e.wf(), new $61de1ee1cac498ae$var$mKb(h, false, e));
    $61de1ee1cac498ae$var$NJb(h, h.f, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$dHb), ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
    $61de1ee1cac498ae$var$NJb(h, h.f, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$Rcd);
    $61de1ee1cac498ae$var$NJb(h, h.g, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$Tcd);
    $61de1ee1cac498ae$var$NJb(h, h.g, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$PJb(h, $61de1ee1cac498ae$var$Acd);
    $61de1ee1cac498ae$var$PJb(h, $61de1ee1cac498ae$var$Rcd);
    $61de1ee1cac498ae$var$OJb(h, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$OJb(h, $61de1ee1cac498ae$var$Tcd);
    $61de1ee1cac498ae$var$$Jb();
    g = h.A.Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$pdd)) && h.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Ddd)) ? $61de1ee1cac498ae$var$_Jb(h) : null;
    !!g && $61de1ee1cac498ae$var$DHb(h.a, g);
    $61de1ee1cac498ae$var$eKb(h);
    $61de1ee1cac498ae$var$GJb(h);
    $61de1ee1cac498ae$var$PKb(h);
    $61de1ee1cac498ae$var$BJb(h);
    $61de1ee1cac498ae$var$pKb(h);
    $61de1ee1cac498ae$var$HKb(h);
    $61de1ee1cac498ae$var$xKb(h, $61de1ee1cac498ae$var$Acd);
    $61de1ee1cac498ae$var$xKb(h, $61de1ee1cac498ae$var$Rcd);
    $61de1ee1cac498ae$var$CJb(h);
    $61de1ee1cac498ae$var$oKb(h);
    if (!c) return h.o;
    $61de1ee1cac498ae$var$cKb(h);
    $61de1ee1cac498ae$var$LKb(h);
    $61de1ee1cac498ae$var$xKb(h, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$xKb(h, $61de1ee1cac498ae$var$Tcd);
    i = h.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Edd));
    $61de1ee1cac498ae$var$RJb(h, i, $61de1ee1cac498ae$var$Acd);
    $61de1ee1cac498ae$var$RJb(h, i, $61de1ee1cac498ae$var$Rcd);
    $61de1ee1cac498ae$var$SJb(h, i, $61de1ee1cac498ae$var$zcd);
    $61de1ee1cac498ae$var$SJb(h, i, $61de1ee1cac498ae$var$Tcd);
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(new $61de1ee1cac498ae$var$$ib(h.i), 0)), new $61de1ee1cac498ae$var$TJb);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, $61de1ee1cac498ae$var$ci(h.r).a.oc()), new $61de1ee1cac498ae$var$VJb), new $61de1ee1cac498ae$var$XJb);
    $61de1ee1cac498ae$var$dKb(h);
    h.e.uf(h.o);
    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, $61de1ee1cac498ae$var$ci(h.r).a.oc()), new $61de1ee1cac498ae$var$fKb);
    return h.o;
}
function $61de1ee1cac498ae$var$JVb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    j = $61de1ee1cac498ae$var$Pje;
    for(d = new $61de1ee1cac498ae$var$olb(a.a.b); d.a < d.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 81);
        j = $61de1ee1cac498ae$var$$wnd.Math.min(j, b.d.f.g.c + b.e.a);
    }
    n = new $61de1ee1cac498ae$var$Psb;
    for(g = new $61de1ee1cac498ae$var$olb(a.a.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 189);
        f.i = j;
        f.e == 0 && $61de1ee1cac498ae$var$Gsb(n, f, n.c.b, n.c);
    }
    while(n.b != 0){
        f = $61de1ee1cac498ae$var$BD(n.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(n.b != 0), $61de1ee1cac498ae$var$Nsb(n, n.a.a)), 189);
        e = f.f.g.c;
        for(m = f.a.a.ec().Kc(); m.Ob();){
            k = $61de1ee1cac498ae$var$BD(m.Pb(), 81);
            p = f.i + k.e.a;
            k.d.g || k.g.c < p ? k.o = p : k.o = k.g.c;
        }
        e -= f.f.o;
        f.b += e;
        a.c == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$bad) || a.c == $61de1ee1cac498ae$var$_9c ? f.c += e : f.c -= e;
        for(l = f.a.a.ec().Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 81);
            for(i = k.f.Kc(); i.Ob();){
                h = $61de1ee1cac498ae$var$BD(i.Pb(), 81);
                $61de1ee1cac498ae$var$fad(a.c) ? o = a.f.ef(k, h) : o = a.f.ff(k, h);
                h.d.i = $61de1ee1cac498ae$var$$wnd.Math.max(h.d.i, k.o + k.g.b + o - h.e.a);
                h.k || (h.d.i = $61de1ee1cac498ae$var$$wnd.Math.max(h.d.i, h.g.c - h.e.a));
                --h.d.e;
                h.d.e == 0 && $61de1ee1cac498ae$var$Dsb(n, h.d);
            }
        }
    }
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 81);
        b.g.c = b.o;
    }
}
function $61de1ee1cac498ae$var$ELb(a) {
    var b, c, d, e, f, g, h, i;
    h = a.b;
    b = a.a;
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$fFb(), $61de1ee1cac498ae$var$bFb)), 427).g){
        case 0:
            $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$tpb(new $61de1ee1cac498ae$var$bMb));
            break;
        case 1:
        default:
            $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$tpb(new $61de1ee1cac498ae$var$gMb));
    }
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$_Eb), 428).g){
        case 1:
            $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$YLb);
            $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$lMb);
            $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$GLb);
            break;
        case 0:
        default:
            $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$YLb);
            $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$RLb);
    }
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$dFb), 250).g){
        case 0:
            i = new $61de1ee1cac498ae$var$FMb;
            break;
        case 1:
            i = new $61de1ee1cac498ae$var$zMb;
            break;
        case 2:
            i = new $61de1ee1cac498ae$var$CMb;
            break;
        case 3:
            i = new $61de1ee1cac498ae$var$wMb;
            break;
        case 5:
            i = new $61de1ee1cac498ae$var$JMb(new $61de1ee1cac498ae$var$CMb);
            break;
        case 4:
            i = new $61de1ee1cac498ae$var$JMb(new $61de1ee1cac498ae$var$zMb);
            break;
        case 7:
            i = new $61de1ee1cac498ae$var$tMb(new $61de1ee1cac498ae$var$JMb(new $61de1ee1cac498ae$var$zMb), new $61de1ee1cac498ae$var$JMb(new $61de1ee1cac498ae$var$CMb));
            break;
        case 8:
            i = new $61de1ee1cac498ae$var$tMb(new $61de1ee1cac498ae$var$JMb(new $61de1ee1cac498ae$var$wMb), new $61de1ee1cac498ae$var$JMb(new $61de1ee1cac498ae$var$CMb));
            break;
        case 6:
        default:
            i = new $61de1ee1cac498ae$var$JMb(new $61de1ee1cac498ae$var$wMb);
    }
    for(g = new $61de1ee1cac498ae$var$olb(h); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 167);
        d = 0;
        e = 0;
        c = new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$meb(d), $61de1ee1cac498ae$var$meb(e));
        while($61de1ee1cac498ae$var$gNb(b, f, d, e)){
            c = $61de1ee1cac498ae$var$BD(i.Ce(c, f), 46);
            d = $61de1ee1cac498ae$var$BD(c.a, 19).a;
            e = $61de1ee1cac498ae$var$BD(c.b, 19).a;
        }
        $61de1ee1cac498ae$var$dNb(b, f, d, e);
    }
}
function $61de1ee1cac498ae$var$qQb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
    f = a.f.b;
    m = f.a;
    k = f.b;
    o = a.e.g;
    n = a.e.f;
    $61de1ee1cac498ae$var$_kd(a.e, f.a, f.b);
    w = m / o;
    A = k / n;
    for(j = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Kkd(a.e)); j.e != j.i.gc();){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(j), 137);
        $61de1ee1cac498ae$var$dld(i, i.i * w);
        $61de1ee1cac498ae$var$eld(i, i.j * A);
    }
    for(s = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Yod(a.e)); s.e != s.i.gc();){
        r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(s), 118);
        u = r.i;
        v = r.j;
        u > 0 && $61de1ee1cac498ae$var$dld(r, u * w);
        v > 0 && $61de1ee1cac498ae$var$eld(r, v * A);
    }
    $61de1ee1cac498ae$var$stb(a.b, new $61de1ee1cac498ae$var$CQb);
    b = new $61de1ee1cac498ae$var$Rkb;
    for(h = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(a.c).a); h.b;){
        g = $61de1ee1cac498ae$var$lib(h);
        d = $61de1ee1cac498ae$var$BD(g.cd(), 79);
        c = $61de1ee1cac498ae$var$BD(g.dd(), 395).a;
        e = $61de1ee1cac498ae$var$itd(d, false, false);
        l = $61de1ee1cac498ae$var$oQb($61de1ee1cac498ae$var$jtd(d), $61de1ee1cac498ae$var$ofd(e), c);
        $61de1ee1cac498ae$var$ifd(l, e);
        t = $61de1ee1cac498ae$var$ktd(d);
        if (!!t && $61de1ee1cac498ae$var$Jkb(b, t, 0) == -1) {
            b.c[b.c.length] = t;
            $61de1ee1cac498ae$var$pQb(t, ($61de1ee1cac498ae$var$sCb(l.b != 0), $61de1ee1cac498ae$var$BD(l.a.a.c, 8)), c);
        }
    }
    for(q = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(a.d).a); q.b;){
        p = $61de1ee1cac498ae$var$lib(q);
        d = $61de1ee1cac498ae$var$BD(p.cd(), 79);
        c = $61de1ee1cac498ae$var$BD(p.dd(), 395).a;
        e = $61de1ee1cac498ae$var$itd(d, false, false);
        l = $61de1ee1cac498ae$var$oQb($61de1ee1cac498ae$var$ltd(d), $61de1ee1cac498ae$var$w7c($61de1ee1cac498ae$var$ofd(e)), c);
        l = $61de1ee1cac498ae$var$w7c(l);
        $61de1ee1cac498ae$var$ifd(l, e);
        t = $61de1ee1cac498ae$var$mtd(d);
        if (!!t && $61de1ee1cac498ae$var$Jkb(b, t, 0) == -1) {
            b.c[b.c.length] = t;
            $61de1ee1cac498ae$var$pQb(t, ($61de1ee1cac498ae$var$sCb(l.b != 0), $61de1ee1cac498ae$var$BD(l.c.b.c, 8)), c);
        }
    }
}
function $61de1ee1cac498ae$var$_Vc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    if (c.c.length != 0) {
        o = new $61de1ee1cac498ae$var$Rkb;
        for(n = new $61de1ee1cac498ae$var$olb(c); n.a < n.c.c.length;){
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 33);
            $61de1ee1cac498ae$var$Ekb(o, new $61de1ee1cac498ae$var$f7c(m.i, m.j));
        }
        d.n && !!b && $61de1ee1cac498ae$var$Tdd(d, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
        while($61de1ee1cac498ae$var$CVc(a, c))$61de1ee1cac498ae$var$AVc(a, c, false);
        d.n && !!b && $61de1ee1cac498ae$var$Tdd(d, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
        h = 0;
        i = 0;
        e = null;
        if (c.c.length != 0) {
            e = ($61de1ee1cac498ae$var$tCb(0, c.c.length), $61de1ee1cac498ae$var$BD(c.c[0], 33));
            h = e.i - ($61de1ee1cac498ae$var$tCb(0, o.c.length), $61de1ee1cac498ae$var$BD(o.c[0], 8)).a;
            i = e.j - ($61de1ee1cac498ae$var$tCb(0, o.c.length), $61de1ee1cac498ae$var$BD(o.c[0], 8)).b;
        }
        g = $61de1ee1cac498ae$var$$wnd.Math.sqrt(h * h + i * i);
        l = $61de1ee1cac498ae$var$cVc(c);
        f = 1;
        while(l.a.gc() != 0){
            for(k = l.a.ec().Kc(); k.Ob();){
                j = $61de1ee1cac498ae$var$BD(k.Pb(), 33);
                p = a.f;
                q = p.i + p.g / 2;
                r = p.j + p.f / 2;
                s = j.i + j.g / 2;
                t = j.j + j.f / 2;
                u = s - q;
                v = t - r;
                w = $61de1ee1cac498ae$var$$wnd.Math.sqrt(u * u + v * v);
                A = u / w;
                B = v / w;
                $61de1ee1cac498ae$var$dld(j, j.i + A * g);
                $61de1ee1cac498ae$var$eld(j, j.j + B * g);
            }
            d.n && !!b && $61de1ee1cac498ae$var$Tdd(d, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
            l = $61de1ee1cac498ae$var$cVc(new $61de1ee1cac498ae$var$Tkb(l));
            ++f;
        }
        !!a.a && a.a.lg(new $61de1ee1cac498ae$var$Tkb(l));
        d.n && !!b && $61de1ee1cac498ae$var$Tdd(d, $61de1ee1cac498ae$var$i6d(b), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
        $61de1ee1cac498ae$var$_Vc(a, b, new $61de1ee1cac498ae$var$Tkb(l), d);
    }
}
function $61de1ee1cac498ae$var$$2b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    p = a.n;
    q = a.o;
    m = a.d;
    l = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$pBc(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$iyc))));
    if (b) {
        k = l * (b.gc() - 1);
        n = 0;
        for(i = b.Kc(); i.Ob();){
            g = $61de1ee1cac498ae$var$BD(i.Pb(), 10);
            k += g.o.a;
            n = $61de1ee1cac498ae$var$$wnd.Math.max(n, g.o.b);
        }
        r = p.a - (k - q.a) / 2;
        f = p.b - m.d + n;
        d = q.a / (b.gc() + 1);
        e = d;
        for(h = b.Kc(); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 10);
            g.n.a = r;
            g.n.b = f - g.o.b;
            r += g.o.a + l;
            j = $61de1ee1cac498ae$var$Y2b(g);
            j.n.a = g.o.a / 2 - j.a.a;
            j.n.b = g.o.b;
            o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vsc)), 11);
            if (o.e.c.length + o.g.c.length == 1) {
                o.n.a = e - o.a.a;
                o.n.b = 0;
                $61de1ee1cac498ae$var$F0b(o, a);
            }
            e += d;
        }
    }
    if (c) {
        k = l * (c.gc() - 1);
        n = 0;
        for(i = c.Kc(); i.Ob();){
            g = $61de1ee1cac498ae$var$BD(i.Pb(), 10);
            k += g.o.a;
            n = $61de1ee1cac498ae$var$$wnd.Math.max(n, g.o.b);
        }
        r = p.a - (k - q.a) / 2;
        f = p.b + q.b + m.a - n;
        d = q.a / (c.gc() + 1);
        e = d;
        for(h = c.Kc(); h.Ob();){
            g = $61de1ee1cac498ae$var$BD(h.Pb(), 10);
            g.n.a = r;
            g.n.b = f;
            r += g.o.a + l;
            j = $61de1ee1cac498ae$var$Y2b(g);
            j.n.a = g.o.a / 2 - j.a.a;
            j.n.b = 0;
            o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vsc)), 11);
            if (o.e.c.length + o.g.c.length == 1) {
                o.n.a = e - o.a.a;
                o.n.b = q.b;
                $61de1ee1cac498ae$var$F0b(o, a);
            }
            e += d;
        }
    }
}
function $61de1ee1cac498ae$var$q7b(a, b) {
    var c, d, e, f, g, h;
    if (!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc))) return;
    for(h = new $61de1ee1cac498ae$var$olb(b.a); h.a < h.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 10);
        if (f.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) {
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$txc)), 142);
            a.c = $61de1ee1cac498ae$var$$wnd.Math.min(a.c, f.n.a - e.b);
            a.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.a, f.n.a + f.o.a + e.c);
            a.d = $61de1ee1cac498ae$var$$wnd.Math.min(a.d, f.n.b - e.d);
            a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.b, f.n.b + f.o.b + e.a);
        }
    }
    for(g = new $61de1ee1cac498ae$var$olb(b.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        if (f.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) switch(f.k.g){
            case 2:
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$mxc)), 163);
                if (d == ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc)) {
                    f.n.a = a.c - 10;
                    $61de1ee1cac498ae$var$p7b(f, new $61de1ee1cac498ae$var$x7b).Jb(new $61de1ee1cac498ae$var$A7b(f));
                    break;
                }
                if (d == $61de1ee1cac498ae$var$Atc) {
                    f.n.a = a.a + 10;
                    $61de1ee1cac498ae$var$p7b(f, new $61de1ee1cac498ae$var$D7b).Jb(new $61de1ee1cac498ae$var$G7b(f));
                    break;
                }
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$Osc), 303);
                if (c == ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$dsc)) {
                    $61de1ee1cac498ae$var$o7b(f).Jb(new $61de1ee1cac498ae$var$J7b(f));
                    f.n.b = a.d - 10;
                    break;
                }
                if (c == $61de1ee1cac498ae$var$bsc) {
                    $61de1ee1cac498ae$var$o7b(f).Jb(new $61de1ee1cac498ae$var$M7b(f));
                    f.n.b = a.b + 10;
                    break;
                }
                break;
            default:
                throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The node type " + f.k + " is not supported by the " + $61de1ee1cac498ae$var$zS));
        }
    }
}
function $61de1ee1cac498ae$var$Y1b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q;
    i = new $61de1ee1cac498ae$var$f7c(d.i + d.g / 2, d.j + d.f / 2);
    n = $61de1ee1cac498ae$var$M1b(d);
    o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$$xc), 61);
    if (!$61de1ee1cac498ae$var$hCd($61de1ee1cac498ae$var$gkd(d), $61de1ee1cac498ae$var$Uxc)) {
        d.i == 0 && d.j == 0 ? p = 0 : p = $61de1ee1cac498ae$var$kfd(d, q);
        $61de1ee1cac498ae$var$jkd(d, $61de1ee1cac498ae$var$Uxc, p);
    }
    j = new $61de1ee1cac498ae$var$f7c(b.g, b.f);
    e = $61de1ee1cac498ae$var$Z$b(d, o, q, n, j, i, new $61de1ee1cac498ae$var$f7c(d.g, d.f), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Lwc), 103), c);
    $61de1ee1cac498ae$var$yNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), d);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(e.j, 0), 11);
    $61de1ee1cac498ae$var$E0b(f, $61de1ee1cac498ae$var$W1b(d));
    $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$Yxc, ($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$pcd)));
    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Yxc), 174).Hc($61de1ee1cac498ae$var$ncd);
    for(h = new $61de1ee1cac498ae$var$Fyd((!d.n && (d.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, d, 1, 7)), d.n)); h.e != h.i.gc();){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(h), 137);
        if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(g, $61de1ee1cac498ae$var$Jxc))) && !!g.a) {
            m = $61de1ee1cac498ae$var$Z1b(g);
            $61de1ee1cac498ae$var$Ekb(f.f, m);
            if (!l) {
                k = 0;
                $61de1ee1cac498ae$var$tcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Yxc), 21)) && (k = $61de1ee1cac498ae$var$mfd(new $61de1ee1cac498ae$var$f7c(g.i, g.j), new $61de1ee1cac498ae$var$f7c(g.g, g.f), new $61de1ee1cac498ae$var$f7c(d.g, d.f), 0, q));
                switch(q.g){
                    case 2:
                    case 4:
                        m.o.a = k;
                        break;
                    case 1:
                    case 3:
                        m.o.b = k;
                }
            }
        }
    }
    $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$tyc, $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd($61de1ee1cac498ae$var$Xod(b), $61de1ee1cac498ae$var$tyc)));
    $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$uyc, $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd($61de1ee1cac498ae$var$Xod(b), $61de1ee1cac498ae$var$uyc)));
    $61de1ee1cac498ae$var$yNb(e, $61de1ee1cac498ae$var$ryc, $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd($61de1ee1cac498ae$var$Xod(b), $61de1ee1cac498ae$var$ryc)));
    $61de1ee1cac498ae$var$Ekb(c.a, e);
    $61de1ee1cac498ae$var$Rhb(a.a, d, e);
}
function $61de1ee1cac498ae$var$qUc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    $61de1ee1cac498ae$var$Odd(c, "Processor arrange level", 1);
    k = 0;
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$ktb(b, new $61de1ee1cac498ae$var$Wsd(($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$ZSc)));
    f = b.b;
    h = $61de1ee1cac498ae$var$Jsb(b, b.b);
    j = true;
    while(j && h.b.b != h.d.a){
        r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ysb(h), 86);
        $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(r, $61de1ee1cac498ae$var$ZSc), 19).a == 0 ? --f : j = false;
    }
    v = new $61de1ee1cac498ae$var$Jib(b, 0, f);
    g = new $61de1ee1cac498ae$var$Qsb(v);
    v = new $61de1ee1cac498ae$var$Jib(b, f, b.b);
    i = new $61de1ee1cac498ae$var$Qsb(v);
    if (g.b == 0) for(o = $61de1ee1cac498ae$var$Jsb(i, 0); o.b != o.d.c;){
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(o), 86);
        $61de1ee1cac498ae$var$yNb(n, $61de1ee1cac498ae$var$eTc, $61de1ee1cac498ae$var$meb(k++));
    }
    else {
        l = g.b;
        for(u = $61de1ee1cac498ae$var$Jsb(g, 0); u.b != u.d.c;){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(u), 86);
            $61de1ee1cac498ae$var$yNb(t, $61de1ee1cac498ae$var$eTc, $61de1ee1cac498ae$var$meb(k++));
            d = $61de1ee1cac498ae$var$URc(t);
            $61de1ee1cac498ae$var$qUc(a, d, $61de1ee1cac498ae$var$Udd(c, 1 / l | 0));
            $61de1ee1cac498ae$var$ktb(d, $61de1ee1cac498ae$var$tmb(new $61de1ee1cac498ae$var$Wsd($61de1ee1cac498ae$var$eTc)));
            m = new $61de1ee1cac498ae$var$Psb;
            for(s = $61de1ee1cac498ae$var$Jsb(d, 0); s.b != s.d.c;){
                r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(s), 86);
                for(q = $61de1ee1cac498ae$var$Jsb(t.d, 0); q.b != q.d.c;){
                    p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(q), 188);
                    p.c == r && $61de1ee1cac498ae$var$Gsb(m, p, m.c.b, m.c);
                }
            }
            $61de1ee1cac498ae$var$Osb(t.d);
            $61de1ee1cac498ae$var$ye(t.d, m);
            h = $61de1ee1cac498ae$var$Jsb(i, i.b);
            e = t.d.b;
            j = true;
            while(0 < e && j && h.b.b != h.d.a){
                r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ysb(h), 86);
                if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(r, $61de1ee1cac498ae$var$ZSc), 19).a == 0) {
                    $61de1ee1cac498ae$var$yNb(r, $61de1ee1cac498ae$var$eTc, $61de1ee1cac498ae$var$meb(k++));
                    --e;
                    $61de1ee1cac498ae$var$Zsb(h);
                } else j = false;
            }
        }
    }
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$_8b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    $61de1ee1cac498ae$var$Odd(b, "Inverted port preprocessing", 1);
    k = a.b;
    j = new $61de1ee1cac498ae$var$Bib(k, 0);
    c = null;
    t = new $61de1ee1cac498ae$var$Rkb;
    while(j.b < j.d.gc()){
        s = c;
        c = ($61de1ee1cac498ae$var$sCb(j.b < j.d.gc()), $61de1ee1cac498ae$var$BD(j.d.Xb(j.c = j.b++), 29));
        for(n = new $61de1ee1cac498ae$var$olb(t); n.a < n.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 10);
            $61de1ee1cac498ae$var$$_b(l, s);
        }
        t.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        for(o = new $61de1ee1cac498ae$var$olb(c.a); o.a < o.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
            if (l.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) continue;
            if (!$61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(l, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98))) continue;
            for(r = $61de1ee1cac498ae$var$X_b(l, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc), ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)).Kc(); r.Ob();){
                p = $61de1ee1cac498ae$var$BD(r.Pb(), 11);
                i = p.e;
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(i, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$AQ, $61de1ee1cac498ae$var$jne, 17, i.c.length, 0, 1)), 474);
                for(e = h, f = 0, g = e.length; f < g; ++f){
                    d = e[f];
                    $61de1ee1cac498ae$var$Z8b(a, p, d, t);
                }
            }
            for(q = $61de1ee1cac498ae$var$X_b(l, $61de1ee1cac498ae$var$IAc, $61de1ee1cac498ae$var$Tcd).Kc(); q.Ob();){
                p = $61de1ee1cac498ae$var$BD(q.Pb(), 11);
                i = p.g;
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(i, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$AQ, $61de1ee1cac498ae$var$jne, 17, i.c.length, 0, 1)), 474);
                for(e = h, f = 0, g = e.length; f < g; ++f){
                    d = e[f];
                    $61de1ee1cac498ae$var$$8b(a, p, d, t);
                }
            }
        }
    }
    for(m = new $61de1ee1cac498ae$var$olb(t); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
        $61de1ee1cac498ae$var$$_b(l, c);
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$_1b(a, b, c, d, e, f) {
    var g, h, i, j, k, l;
    j = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$tNb(j, b);
    $61de1ee1cac498ae$var$G0b(j, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$$xc)), 61));
    $61de1ee1cac498ae$var$yNb(j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), b);
    $61de1ee1cac498ae$var$F0b(j, c);
    l = j.o;
    l.a = b.g;
    l.b = b.f;
    k = j.n;
    k.a = b.i;
    k.b = b.j;
    $61de1ee1cac498ae$var$Rhb(a.a, b, j);
    g = $61de1ee1cac498ae$var$FAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, (!b.e && (b.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, b, 7, 4)), new $61de1ee1cac498ae$var$Kub(b.e, 16))), new $61de1ee1cac498ae$var$m2b), new $61de1ee1cac498ae$var$e2b), new $61de1ee1cac498ae$var$o2b(b));
    g || (g = $61de1ee1cac498ae$var$FAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, (!b.d && (b.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, b, 8, 5)), new $61de1ee1cac498ae$var$Kub(b.d, 16))), new $61de1ee1cac498ae$var$q2b), new $61de1ee1cac498ae$var$g2b), new $61de1ee1cac498ae$var$s2b(b)));
    g || (g = $61de1ee1cac498ae$var$FAb(new $61de1ee1cac498ae$var$YAb(null, (!b.e && (b.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, b, 7, 4)), new $61de1ee1cac498ae$var$Kub(b.e, 16))), new $61de1ee1cac498ae$var$u2b));
    $61de1ee1cac498ae$var$yNb(j, $61de1ee1cac498ae$var$Nsc, ($61de1ee1cac498ae$var$Bcb(), g ? true : false));
    $61de1ee1cac498ae$var$e_b(j, f, e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Txc), 8));
    for(i = new $61de1ee1cac498ae$var$Fyd((!b.n && (b.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, b, 1, 7)), b.n)); i.e != i.i.gc();){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 137);
        !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$Jxc))) && !!h.a && $61de1ee1cac498ae$var$Ekb(j.f, $61de1ee1cac498ae$var$Z1b(h));
    }
    switch(e.g){
        case 2:
        case 1:
            (j.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || j.j == $61de1ee1cac498ae$var$Rcd) && d.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Lrc));
            break;
        case 4:
        case 3:
            (j.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) || j.j == $61de1ee1cac498ae$var$Tcd) && d.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Lrc));
    }
    return j;
}
function $61de1ee1cac498ae$var$nQc(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p, q, r, s, t;
    m = null;
    d == ($61de1ee1cac498ae$var$FQc(), $61de1ee1cac498ae$var$DQc) ? m = b : d == $61de1ee1cac498ae$var$EQc && (m = c);
    for(p = m.a.ec().Kc(); p.Ob();){
        o = $61de1ee1cac498ae$var$BD(p.Pb(), 11);
        q = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            o.i.n,
            o.n,
            o.a
        ])).b;
        t = new $61de1ee1cac498ae$var$Tqb;
        h = new $61de1ee1cac498ae$var$Tqb;
        for(j = new $61de1ee1cac498ae$var$b1b(o.b); $61de1ee1cac498ae$var$llb(j.a) || $61de1ee1cac498ae$var$llb(j.b);){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$llb(j.a) ? $61de1ee1cac498ae$var$mlb(j.a) : $61de1ee1cac498ae$var$mlb(j.b), 17);
            if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(i, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ltc)))) != e) continue;
            if ($61de1ee1cac498ae$var$Jkb(f, i, 0) != -1) {
                i.d == o ? r = i.c : r = i.d;
                s = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    r.i.n,
                    r.n,
                    r.a
                ])).b;
                if ($61de1ee1cac498ae$var$$wnd.Math.abs(s - q) < 0.2) continue;
                s < q ? b.a._b(r) ? $61de1ee1cac498ae$var$Qqb(t, new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$DQc, i)) : $61de1ee1cac498ae$var$Qqb(t, new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$EQc, i)) : b.a._b(r) ? $61de1ee1cac498ae$var$Qqb(h, new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$DQc, i)) : $61de1ee1cac498ae$var$Qqb(h, new $61de1ee1cac498ae$var$vgd($61de1ee1cac498ae$var$EQc, i));
            }
        }
        if (t.a.gc() > 1) {
            n = new $61de1ee1cac498ae$var$ZQc(o, t, d);
            $61de1ee1cac498ae$var$reb(t, new $61de1ee1cac498ae$var$PQc(a, n));
            g.c[g.c.length] = n;
            for(l = t.a.ec().Kc(); l.Ob();){
                k = $61de1ee1cac498ae$var$BD(l.Pb(), 46);
                $61de1ee1cac498ae$var$Lkb(f, k.b);
            }
        }
        if (h.a.gc() > 1) {
            n = new $61de1ee1cac498ae$var$ZQc(o, h, d);
            $61de1ee1cac498ae$var$reb(h, new $61de1ee1cac498ae$var$RQc(a, n));
            g.c[g.c.length] = n;
            for(l = h.a.ec().Kc(); l.Ob();){
                k = $61de1ee1cac498ae$var$BD(l.Pb(), 46);
                $61de1ee1cac498ae$var$Lkb(f, k.b);
            }
        }
    }
}
function $61de1ee1cac498ae$var$$Wc(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$L3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$sre), "ELK Radial"), 'A radial layout provider which is based on the algorithm of Peter Eades published in "Drawing free trees.", published by International Institute for Advanced Study of Social Information Science, Fujitsu Limited in 1991. The radial layouter takes a tree and places the nodes in radial order around the root. The nodes of the same tree level are placed on the same radius.'), new $61de1ee1cac498ae$var$bXc), $61de1ee1cac498ae$var$sre)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$uqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$UWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$wme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$XWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$NWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$OWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$PWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$Gme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$MWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$Dme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$QWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$Hme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$TWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$ore, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$KWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$nre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$LWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$rre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$RWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$lre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$SWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$mre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$VWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$pre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$WWc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sre, $61de1ee1cac498ae$var$qre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$YWc));
}
function $61de1ee1cac498ae$var$LIb(a) {
    var b;
    this.r = $61de1ee1cac498ae$var$Cy(new $61de1ee1cac498ae$var$OIb, new $61de1ee1cac498ae$var$SIb);
    this.b = new $61de1ee1cac498ae$var$Rpb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb($61de1ee1cac498ae$var$F1), 290));
    this.p = new $61de1ee1cac498ae$var$Rpb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb($61de1ee1cac498ae$var$F1), 290));
    this.i = new $61de1ee1cac498ae$var$Rpb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qb($61de1ee1cac498ae$var$DN), 290));
    this.e = a;
    this.o = new $61de1ee1cac498ae$var$g7c(a.rf());
    this.D = a.Df() || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$M8c))));
    this.A = $61de1ee1cac498ae$var$BD(a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Y8c)), 21);
    this.B = $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$b9c), 21);
    this.q = $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$t9c), 98);
    this.u = $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$x9c), 21);
    if (!$61de1ee1cac498ae$var$ucd(this.u)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c("Invalid port label placement: " + this.u));
    this.v = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(a.We($61de1ee1cac498ae$var$z9c)));
    this.j = $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$W8c), 21);
    if (!$61de1ee1cac498ae$var$Jbd(this.j)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c("Invalid node label placement: " + this.j));
    this.n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bgd(a, $61de1ee1cac498ae$var$U8c), 116);
    this.k = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$bgd(a, $61de1ee1cac498ae$var$Q9c)));
    this.d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$bgd(a, $61de1ee1cac498ae$var$P9c)));
    this.w = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$bgd(a, $61de1ee1cac498ae$var$X9c)));
    this.s = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$bgd(a, $61de1ee1cac498ae$var$R9c)));
    this.t = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$bgd(a, $61de1ee1cac498ae$var$S9c)));
    this.C = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bgd(a, $61de1ee1cac498ae$var$V9c), 142);
    this.c = 2 * this.d;
    b = !this.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$zdd));
    this.f = new $61de1ee1cac498ae$var$mIb(0, b, 0);
    this.g = new $61de1ee1cac498ae$var$mIb(1, b, 0);
    $61de1ee1cac498ae$var$lIb(this.f, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$eHb), this.g);
}
function $61de1ee1cac498ae$var$Lgd(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    t = 0;
    o = 0;
    n = 0;
    m = 1;
    for(s = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); s.e != s.i.gc();){
        q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(s), 33);
        m += $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(q).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
        B = q.g;
        o = $61de1ee1cac498ae$var$$wnd.Math.max(o, B);
        l = q.f;
        n = $61de1ee1cac498ae$var$$wnd.Math.max(n, l);
        t += B * l;
    }
    p = (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a).i;
    g = t + 2 * d * d * m * p;
    f = $61de1ee1cac498ae$var$$wnd.Math.sqrt(g);
    i = $61de1ee1cac498ae$var$$wnd.Math.max(f * c, o);
    h = $61de1ee1cac498ae$var$$wnd.Math.max(f / c, n);
    for(r = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); r.e != r.i.gc();){
        q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(r), 33);
        C = e.b + ($61de1ee1cac498ae$var$Cub(b, 26) * $61de1ee1cac498ae$var$ike + $61de1ee1cac498ae$var$Cub(b, 27) * $61de1ee1cac498ae$var$jke) * (i - q.g);
        D = e.b + ($61de1ee1cac498ae$var$Cub(b, 26) * $61de1ee1cac498ae$var$ike + $61de1ee1cac498ae$var$Cub(b, 27) * $61de1ee1cac498ae$var$jke) * (h - q.f);
        $61de1ee1cac498ae$var$dld(q, C);
        $61de1ee1cac498ae$var$eld(q, D);
    }
    A = i + (e.b + e.c);
    w = h + (e.d + e.a);
    for(v = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); v.e != v.i.gc();){
        u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(v), 33);
        for(k = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(u).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(k);){
            j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(k), 79);
            $61de1ee1cac498ae$var$Pld(j) || $61de1ee1cac498ae$var$Kgd(j, b, A, w);
        }
    }
    A += e.b + e.c;
    w += e.d + e.a;
    $61de1ee1cac498ae$var$Afd(a, A, w, false, true);
}
function $61de1ee1cac498ae$var$Jcb(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Xhe));
    j = a;
    f = a.length;
    i = false;
    if (f > 0) {
        b = ($61de1ee1cac498ae$var$BCb(0, a.length), a.charCodeAt(0));
        if (b == 45 || b == 43) {
            a = a.substr(1);
            --f;
            i = b == 45;
        }
    }
    if (f == 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + j + '"'));
    while(a.length > 0 && ($61de1ee1cac498ae$var$BCb(0, a.length), a.charCodeAt(0) == 48)){
        a = a.substr(1);
        --f;
    }
    if (f > ($61de1ee1cac498ae$var$Neb(), $61de1ee1cac498ae$var$Leb)[10]) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + j + '"'));
    for(e = 0; e < f; e++){
        if ($61de1ee1cac498ae$var$Zcb(($61de1ee1cac498ae$var$BCb(e, a.length), a.charCodeAt(e))) == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + j + '"'));
    }
    l = 0;
    g = $61de1ee1cac498ae$var$Jeb[10];
    k = $61de1ee1cac498ae$var$Keb[10];
    h = $61de1ee1cac498ae$var$Jbb($61de1ee1cac498ae$var$Meb[10]);
    c = true;
    d = f % g;
    if (d > 0) {
        l = -parseInt(a.substr(0, d), 10);
        a = a.substr(d);
        f -= d;
        c = false;
    }
    while(f >= g){
        d = parseInt(a.substr(0, g), 10);
        a = a.substr(g);
        f -= g;
        if (c) c = false;
        else {
            if ($61de1ee1cac498ae$var$ybb(l, h) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + j + '"'));
            l = $61de1ee1cac498ae$var$Ibb(l, k);
        }
        l = $61de1ee1cac498ae$var$Qbb(l, d);
    }
    if ($61de1ee1cac498ae$var$ybb(l, 0) > 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + j + '"'));
    if (!i) {
        l = $61de1ee1cac498ae$var$Jbb(l);
        if ($61de1ee1cac498ae$var$ybb(l, 0) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + j + '"'));
    }
    return l;
}
function $61de1ee1cac498ae$var$Z6d(a, b) {
    $61de1ee1cac498ae$var$X6d();
    var c, d, e, f, g, h, i;
    this.a = new $61de1ee1cac498ae$var$a7d(this);
    this.b = a;
    this.c = b;
    this.f = $61de1ee1cac498ae$var$c2d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), b));
    if (this.f.dc()) {
        if ((h = $61de1ee1cac498ae$var$t1d($61de1ee1cac498ae$var$M6d, a)) == b) {
            this.e = true;
            this.d = new $61de1ee1cac498ae$var$Rkb;
            this.f = new $61de1ee1cac498ae$var$oFd;
            this.f.Fc($61de1ee1cac498ae$var$Ewe);
            $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$V1d($61de1ee1cac498ae$var$p1d($61de1ee1cac498ae$var$M6d, $61de1ee1cac498ae$var$bKd(a)), ""), 26) == a && this.f.Fc($61de1ee1cac498ae$var$u1d($61de1ee1cac498ae$var$M6d, $61de1ee1cac498ae$var$bKd(a)));
            for(e = $61de1ee1cac498ae$var$g1d($61de1ee1cac498ae$var$M6d, a).Kc(); e.Ob();){
                d = $61de1ee1cac498ae$var$BD(e.Pb(), 170);
                switch($61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, d))){
                    case 4:
                        this.d.Fc(d);
                        break;
                    case 5:
                        this.f.Gc($61de1ee1cac498ae$var$c2d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, d)));
                        break;
                }
            }
        } else {
            $61de1ee1cac498ae$var$Q6d();
            if ($61de1ee1cac498ae$var$BD(b, 66).Oj()) {
                this.e = true;
                this.f = null;
                this.d = new $61de1ee1cac498ae$var$Rkb;
                for(g = 0, i = (a.i == null && $61de1ee1cac498ae$var$TKd(a), a.i).length; g < i; ++g){
                    d = (c = (a.i == null && $61de1ee1cac498ae$var$TKd(a), a.i), g >= 0 && g < c.length ? c[g] : null);
                    for(f = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, d)); f; f = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, f)))f == b && this.d.Fc(d);
                }
            } else if ($61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, b)) == 1 && !!h) {
                this.f = null;
                this.d = ($61de1ee1cac498ae$var$m8d(), $61de1ee1cac498ae$var$l8d);
            } else {
                this.f = null;
                this.e = true;
                this.d = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$anb(b));
            }
        }
    } else {
        this.e = $61de1ee1cac498ae$var$$1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, b)) == 5;
        this.f.Fb($61de1ee1cac498ae$var$W6d) && (this.f = $61de1ee1cac498ae$var$W6d);
    }
}
function $61de1ee1cac498ae$var$zKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    c = 0;
    d = $61de1ee1cac498ae$var$yKb(a, b);
    m = a.s;
    n = a.t;
    for(j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); j.Ob();){
        i = $61de1ee1cac498ae$var$BD(j.Pb(), 111);
        if (!i.c || i.c.d.c.length <= 0) continue;
        o = i.b.rf();
        h = i.b.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c)) ? $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(i.b.We($61de1ee1cac498ae$var$s9c))) : 0;
        k = i.c;
        l = k.i;
        l.b = (g = k.n, k.e.a + g.b + g.c);
        l.a = (f = k.n, k.e.b + f.d + f.a);
        switch(b.g){
            case 1:
                l.c = i.a ? (o.a - l.b) / 2 : o.a + m;
                l.d = o.b + h + d;
                $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$KHb));
                $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb));
                break;
            case 3:
                l.c = i.a ? (o.a - l.b) / 2 : o.a + m;
                l.d = -h - d - l.a;
                $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$KHb));
                $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb));
                break;
            case 2:
                l.c = -h - d - l.b;
                if (i.a) {
                    e = a.v ? l.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k.d, 0), 181).rf().b;
                    l.d = (o.b - e) / 2;
                } else l.d = o.b + n;
                $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
                $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$CIb));
                break;
            case 4:
                l.c = o.a + h + d;
                if (i.a) {
                    e = a.v ? l.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k.d, 0), 181).rf().b;
                    l.d = (o.b - e) / 2;
                } else l.d = o.b + n;
                $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb));
                $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$CIb));
        }
        (b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || b == $61de1ee1cac498ae$var$Rcd) && (c = $61de1ee1cac498ae$var$$wnd.Math.max(c, l.a));
    }
    c > 0 && ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124).a.b = c);
}
function $61de1ee1cac498ae$var$b3b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    $61de1ee1cac498ae$var$Odd(b, "Comment pre-processing", 1);
    c = 0;
    i = new $61de1ee1cac498ae$var$olb(a.a);
    while(i.a < i.c.c.length){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$pwc))))) {
            ++c;
            e = 0;
            d = null;
            j = null;
            for(o = new $61de1ee1cac498ae$var$olb(h.j); o.a < o.c.c.length;){
                m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 11);
                e += m.e.c.length + m.g.c.length;
                if (m.e.c.length == 1) {
                    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(m.e, 0), 17);
                    j = d.c;
                }
                if (m.g.c.length == 1) {
                    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(m.g, 0), 17);
                    j = d.d;
                }
            }
            if (e == 1 && j.e.c.length + j.g.c.length == 1 && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(j.i, $61de1ee1cac498ae$var$pwc)))) {
                $61de1ee1cac498ae$var$c3b(h, d, j, j.i);
                $61de1ee1cac498ae$var$nlb(i);
            } else {
                r = new $61de1ee1cac498ae$var$Rkb;
                for(n = new $61de1ee1cac498ae$var$olb(h.j); n.a < n.c.c.length;){
                    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 11);
                    for(l = new $61de1ee1cac498ae$var$olb(m.g); l.a < l.c.c.length;){
                        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 17);
                        k.d.g.c.length == 0 || (r.c[r.c.length] = k);
                    }
                    for(g = new $61de1ee1cac498ae$var$olb(m.e); g.a < g.c.c.length;){
                        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
                        f.c.e.c.length == 0 || (r.c[r.c.length] = f);
                    }
                }
                for(q = new $61de1ee1cac498ae$var$olb(r); q.a < q.c.c.length;){
                    p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 17);
                    $61de1ee1cac498ae$var$PZb(p, true);
                }
            }
        }
    }
    b.n && $61de1ee1cac498ae$var$Sdd(b, "Found " + c + " comment boxes");
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$f9b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p;
    m = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$tyc))));
    n = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$uyc)));
    l = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ryc)));
    h = a.o;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.j, 0), 11);
    g = f.n;
    p = $61de1ee1cac498ae$var$d9b(f, l);
    if (!p) return;
    if (b.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$ncd))) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61).g){
        case 1:
            p.c = (h.a - p.b) / 2 - g.a;
            p.d = n;
            break;
        case 3:
            p.c = (h.a - p.b) / 2 - g.a;
            p.d = -n - p.a;
            break;
        case 2:
            if (c && f.e.c.length == 0 && f.g.c.length == 0) {
                k = d ? p.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(f.f, 0), 70).o.b;
                p.d = (h.b - k) / 2 - g.b;
            } else p.d = h.b + n - g.b;
            p.c = -m - p.b;
            break;
        case 4:
            if (c && f.e.c.length == 0 && f.g.c.length == 0) {
                k = d ? p.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(f.f, 0), 70).o.b;
                p.d = (h.b - k) / 2 - g.b;
            } else p.d = h.b + n - g.b;
            p.c = m;
    }
    else if (b.Hc($61de1ee1cac498ae$var$pcd)) switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61).g){
        case 1:
        case 3:
            p.c = g.a + m;
            break;
        case 2:
        case 4:
            if (c && !f.c) {
                k = d ? p.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(f.f, 0), 70).o.b;
                p.d = (h.b - k) / 2 - g.b;
            } else p.d = g.b + n;
    }
    e = p.d;
    for(j = new $61de1ee1cac498ae$var$olb(f.f); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 70);
        o = i.n;
        o.a = p.c;
        o.b = e;
        e += i.o.b + l;
    }
}
function $61de1ee1cac498ae$var$eae() {
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$Q9, new $61de1ee1cac498ae$var$Lae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$S9, new $61de1ee1cac498ae$var$qbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$T9, new $61de1ee1cac498ae$var$Xbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$U9, new $61de1ee1cac498ae$var$Cce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Oce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SD, 1), new $61de1ee1cac498ae$var$Rce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$wI, new $61de1ee1cac498ae$var$Uce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$xI, new $61de1ee1cac498ae$var$Xce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$hae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$kae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$nae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$BI, new $61de1ee1cac498ae$var$qae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$tae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$yK, new $61de1ee1cac498ae$var$wae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$yK, new $61de1ee1cac498ae$var$zae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Cae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$FI, new $61de1ee1cac498ae$var$Fae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Iae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Oae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Rae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Uae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Xae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SD, 1), new $61de1ee1cac498ae$var$$ae);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$bbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$ebe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$yK, new $61de1ee1cac498ae$var$hbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$yK, new $61de1ee1cac498ae$var$kbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$nbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$JI, new $61de1ee1cac498ae$var$tbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$wbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$MI, new $61de1ee1cac498ae$var$zbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Cbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Fbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Ibe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Lbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$yK, new $61de1ee1cac498ae$var$Obe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$yK, new $61de1ee1cac498ae$var$Rbe);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Ube);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$$be);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$bce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$ece);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$hce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$kce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$UI, new $61de1ee1cac498ae$var$nce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$qce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$tce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$wce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$UI, new $61de1ee1cac498ae$var$zce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$MI, new $61de1ee1cac498ae$var$Fce);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$ZI, new $61de1ee1cac498ae$var$Ice);
    $61de1ee1cac498ae$var$rEd($61de1ee1cac498ae$var$JI, new $61de1ee1cac498ae$var$Lce);
}
function $61de1ee1cac498ae$var$Bmd(b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    n = c.length;
    if (n > 0) {
        j = ($61de1ee1cac498ae$var$BCb(0, c.length), c.charCodeAt(0));
        if (j != 64) {
            if (j == 37) {
                m = c.lastIndexOf("%");
                k = false;
                if (m != 0 && (m == n - 1 || (k = ($61de1ee1cac498ae$var$BCb(m + 1, c.length), c.charCodeAt(m + 1) == 46)))) {
                    h = c.substr(1, m - 1);
                    u = $61de1ee1cac498ae$var$dfb("%", h) ? null : $61de1ee1cac498ae$var$QEd(h);
                    e = 0;
                    if (k) try {
                        e = $61de1ee1cac498ae$var$Icb(c.substr(m + 2), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe);
                    } catch (a) {
                        a = $61de1ee1cac498ae$var$ubb(a);
                        if ($61de1ee1cac498ae$var$JD(a, 127)) {
                            i = a;
                            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$rFd(i));
                        } else throw $61de1ee1cac498ae$var$vbb(a);
                    }
                    for(r = $61de1ee1cac498ae$var$pRd(b.Wg()); r.Ob();){
                        p = $61de1ee1cac498ae$var$MRd(r);
                        if ($61de1ee1cac498ae$var$JD(p, 510)) {
                            f = $61de1ee1cac498ae$var$BD(p, 590);
                            t = f.d;
                            if ((u == null ? t == null : $61de1ee1cac498ae$var$dfb(u, t)) && e-- == 0) return f;
                        }
                    }
                    return null;
                }
            }
            l = c.lastIndexOf(".");
            o = l == -1 ? c : c.substr(0, l);
            d = 0;
            if (l != -1) try {
                d = $61de1ee1cac498ae$var$Icb(c.substr(l + 1), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe);
            } catch (a) {
                a = $61de1ee1cac498ae$var$ubb(a);
                if ($61de1ee1cac498ae$var$JD(a, 127)) o = c;
                else throw $61de1ee1cac498ae$var$vbb(a);
            }
            o = $61de1ee1cac498ae$var$dfb("%", o) ? null : $61de1ee1cac498ae$var$QEd(o);
            for(q = $61de1ee1cac498ae$var$pRd(b.Wg()); q.Ob();){
                p = $61de1ee1cac498ae$var$MRd(q);
                if ($61de1ee1cac498ae$var$JD(p, 191)) {
                    g = $61de1ee1cac498ae$var$BD(p, 191);
                    s = g.ne();
                    if ((o == null ? s == null : $61de1ee1cac498ae$var$dfb(o, s)) && d-- == 0) return g;
                }
            }
            return null;
        }
    }
    return $61de1ee1cac498ae$var$rid(b, c);
}
function $61de1ee1cac498ae$var$f6b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    w = new $61de1ee1cac498ae$var$Rkb;
    for(o = new $61de1ee1cac498ae$var$olb(a.b); o.a < o.c.c.length;){
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 29);
        for(r = new $61de1ee1cac498ae$var$olb(n.a); r.a < r.c.c.length;){
            p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(r), 10);
            if (p.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) continue;
            if (!$61de1ee1cac498ae$var$wNb(p, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Gsc))) continue;
            s = null;
            u = null;
            t = null;
            for(C = new $61de1ee1cac498ae$var$olb(p.j); C.a < C.c.c.length;){
                B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(C), 11);
                switch(B.j.g){
                    case 4:
                        s = B;
                        break;
                    case 2:
                        u = B;
                        break;
                    default:
                        t = B;
                }
            }
            v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(t.g, 0), 17);
            k = new $61de1ee1cac498ae$var$t7c(v.a);
            j = new $61de1ee1cac498ae$var$g7c(t.n);
            $61de1ee1cac498ae$var$P6c(j, p.n);
            l = $61de1ee1cac498ae$var$Jsb(k, 0);
            $61de1ee1cac498ae$var$Vsb(l, j);
            A = $61de1ee1cac498ae$var$w7c(v.a);
            m = new $61de1ee1cac498ae$var$g7c(t.n);
            $61de1ee1cac498ae$var$P6c(m, p.n);
            $61de1ee1cac498ae$var$Gsb(A, m, A.c.b, A.c);
            D = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(p, $61de1ee1cac498ae$var$Gsc), 10);
            F = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(D.j, 0), 11);
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(s.e, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$AQ, $61de1ee1cac498ae$var$jne, 17, 0, 0, 1)), 474);
            for(d = i, f = 0, h = d.length; f < h; ++f){
                b = d[f];
                $61de1ee1cac498ae$var$RZb(b, F);
                $61de1ee1cac498ae$var$o7c(b.a, b.a.b, k);
            }
            i = $61de1ee1cac498ae$var$k_b(u.g);
            for(c = i, e = 0, g = c.length; e < g; ++e){
                b = c[e];
                $61de1ee1cac498ae$var$QZb(b, F);
                $61de1ee1cac498ae$var$o7c(b.a, 0, A);
            }
            $61de1ee1cac498ae$var$QZb(v, null);
            $61de1ee1cac498ae$var$RZb(v, null);
            w.c[w.c.length] = p;
        }
    }
    for(q = new $61de1ee1cac498ae$var$olb(w); q.a < q.c.c.length;){
        p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 10);
        $61de1ee1cac498ae$var$$_b(p, null);
    }
}
function $61de1ee1cac498ae$var$lgb() {
    $61de1ee1cac498ae$var$lgb = $61de1ee1cac498ae$var$ccb;
    var a, b, c;
    new $61de1ee1cac498ae$var$sgb(1, 0);
    new $61de1ee1cac498ae$var$sgb(10, 0);
    new $61de1ee1cac498ae$var$sgb(0, 0);
    $61de1ee1cac498ae$var$dgb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$bJ, $61de1ee1cac498ae$var$nie, 240, 11, 0, 1);
    $61de1ee1cac498ae$var$egb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, 100, 15, 1);
    $61de1ee1cac498ae$var$fgb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        1,
        5,
        25,
        125,
        625,
        3125,
        15625,
        78125,
        390625,
        1953125,
        9765625,
        48828125,
        244140625,
        1220703125,
        6103515625,
        30517578125,
        152587890625,
        762939453125,
        3814697265625,
        19073486328125,
        95367431640625,
        476837158203125,
        2384185791015625
    ]);
    $61de1ee1cac498ae$var$ggb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, $61de1ee1cac498ae$var$fgb.length, 15, 1);
    $61de1ee1cac498ae$var$hgb = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        1,
        10,
        100,
        $61de1ee1cac498ae$var$_ie,
        10000,
        $61de1ee1cac498ae$var$Wje,
        1000000,
        10000000,
        100000000,
        $61de1ee1cac498ae$var$Jje,
        10000000000,
        100000000000,
        1000000000000,
        10000000000000,
        100000000000000,
        1000000000000000,
        10000000000000000
    ]);
    $61de1ee1cac498ae$var$igb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, $61de1ee1cac498ae$var$hgb.length, 15, 1);
    $61de1ee1cac498ae$var$jgb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$bJ, $61de1ee1cac498ae$var$nie, 240, 11, 0, 1);
    a = 0;
    for(; a < $61de1ee1cac498ae$var$jgb.length; a++){
        $61de1ee1cac498ae$var$dgb[a] = new $61de1ee1cac498ae$var$sgb(a, 0);
        $61de1ee1cac498ae$var$jgb[a] = new $61de1ee1cac498ae$var$sgb(0, a);
        $61de1ee1cac498ae$var$egb[a] = 48;
    }
    for(; a < $61de1ee1cac498ae$var$egb.length; a++)$61de1ee1cac498ae$var$egb[a] = 48;
    for(c = 0; c < $61de1ee1cac498ae$var$ggb.length; c++)$61de1ee1cac498ae$var$ggb[c] = $61de1ee1cac498ae$var$ugb($61de1ee1cac498ae$var$fgb[c]);
    for(b = 0; b < $61de1ee1cac498ae$var$igb.length; b++)$61de1ee1cac498ae$var$igb[b] = $61de1ee1cac498ae$var$ugb($61de1ee1cac498ae$var$hgb[b]);
    $61de1ee1cac498ae$var$Dhb();
}
function $61de1ee1cac498ae$var$zrb() {
    function e() {
        this.obj = this.createObject();
    }
    e.prototype.createObject = function(a) {
        return Object.create(null);
    };
    e.prototype.get = function(a) {
        return this.obj[a];
    };
    e.prototype.set = function(a, b) {
        this.obj[a] = b;
    };
    e.prototype[$61de1ee1cac498ae$var$hke] = function(a) {
        delete this.obj[a];
    };
    e.prototype.keys = function() {
        return Object.getOwnPropertyNames(this.obj);
    };
    e.prototype.entries = function() {
        var b = this.keys();
        var c = this;
        var d = 0;
        return {
            next: function() {
                if (d >= b.length) return {
                    done: true
                };
                var a = b[d++];
                return {
                    value: [
                        a,
                        c.get(a)
                    ],
                    done: false
                };
            }
        };
    };
    if (!$61de1ee1cac498ae$var$xrb()) {
        e.prototype.createObject = function() {
            return {};
        };
        e.prototype.get = function(a) {
            return this.obj[":" + a];
        };
        e.prototype.set = function(a, b) {
            this.obj[":" + a] = b;
        };
        e.prototype[$61de1ee1cac498ae$var$hke] = function(a) {
            delete this.obj[":" + a];
        };
        e.prototype.keys = function() {
            var a = [];
            for(var b in this.obj)b.charCodeAt(0) == 58 && a.push(b.substring(1));
            return a;
        };
    }
    return e;
}
function $61de1ee1cac498ae$var$cde(a) {
    $61de1ee1cac498ae$var$ade();
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (a == null) return null;
    l = a.length * 8;
    if (l == 0) return "";
    h = l % 24;
    n = l / 24 | 0;
    m = h != 0 ? n + 1 : n;
    f = null;
    f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, m * 4, 15, 1);
    j = 0;
    k = 0;
    b = 0;
    c = 0;
    d = 0;
    g = 0;
    e = 0;
    for(i = 0; i < n; i++){
        b = a[e++];
        c = a[e++];
        d = a[e++];
        k = (c & 15) << 24 >> 24;
        j = (b & 3) << 24 >> 24;
        o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
        p = (c & -128) == 0 ? c >> 4 << 24 >> 24 : (c >> 4 ^ 240) << 24 >> 24;
        q = (d & -128) == 0 ? d >> 6 << 24 >> 24 : (d >> 6 ^ 252) << 24 >> 24;
        f[g++] = $61de1ee1cac498ae$var$_ce[o];
        f[g++] = $61de1ee1cac498ae$var$_ce[p | j << 4];
        f[g++] = $61de1ee1cac498ae$var$_ce[k << 2 | q];
        f[g++] = $61de1ee1cac498ae$var$_ce[d & 63];
    }
    if (h == 8) {
        b = a[e];
        j = (b & 3) << 24 >> 24;
        o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
        f[g++] = $61de1ee1cac498ae$var$_ce[o];
        f[g++] = $61de1ee1cac498ae$var$_ce[j << 4];
        f[g++] = 61;
        f[g++] = 61;
    } else if (h == 16) {
        b = a[e];
        c = a[e + 1];
        k = (c & 15) << 24 >> 24;
        j = (b & 3) << 24 >> 24;
        o = (b & -128) == 0 ? b >> 2 << 24 >> 24 : (b >> 2 ^ 192) << 24 >> 24;
        p = (c & -128) == 0 ? c >> 4 << 24 >> 24 : (c >> 4 ^ 240) << 24 >> 24;
        f[g++] = $61de1ee1cac498ae$var$_ce[o];
        f[g++] = $61de1ee1cac498ae$var$_ce[p | j << 4];
        f[g++] = $61de1ee1cac498ae$var$_ce[k << 2];
        f[g++] = 61;
    }
    return $61de1ee1cac498ae$var$zfb(f, 0, f.length);
}
function $61de1ee1cac498ae$var$mB(a, b) {
    var c, d, e, f, g, h, i;
    a.e == 0 && a.p > 0 && (a.p = -(a.p - 1));
    a.p > $61de1ee1cac498ae$var$Rie && $61de1ee1cac498ae$var$dB(b, a.p - $61de1ee1cac498ae$var$nje);
    g = b.q.getDate();
    $61de1ee1cac498ae$var$ZA(b, 1);
    a.k >= 0 && $61de1ee1cac498ae$var$aB(b, a.k);
    if (a.c >= 0) $61de1ee1cac498ae$var$ZA(b, a.c);
    else if (a.k >= 0) {
        i = new $61de1ee1cac498ae$var$fB(b.q.getFullYear() - $61de1ee1cac498ae$var$nje, b.q.getMonth(), 35);
        d = 35 - i.q.getDate();
        $61de1ee1cac498ae$var$ZA(b, $61de1ee1cac498ae$var$$wnd.Math.min(d, g));
    } else $61de1ee1cac498ae$var$ZA(b, g);
    a.f < 0 && (a.f = b.q.getHours());
    a.b > 0 && a.f < 12 && (a.f += 12);
    $61de1ee1cac498ae$var$$A(b, a.f == 24 && a.g ? 0 : a.f);
    a.j >= 0 && $61de1ee1cac498ae$var$_A(b, a.j);
    a.n >= 0 && $61de1ee1cac498ae$var$bB(b, a.n);
    a.i >= 0 && $61de1ee1cac498ae$var$cB(b, $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Abb($61de1ee1cac498ae$var$Cbb(b.q.getTime()), $61de1ee1cac498ae$var$_ie), $61de1ee1cac498ae$var$_ie), a.i));
    if (a.a) {
        e = new $61de1ee1cac498ae$var$eB;
        $61de1ee1cac498ae$var$dB(e, e.q.getFullYear() - $61de1ee1cac498ae$var$nje - 80);
        $61de1ee1cac498ae$var$Gbb($61de1ee1cac498ae$var$Cbb(b.q.getTime()), $61de1ee1cac498ae$var$Cbb(e.q.getTime())) && $61de1ee1cac498ae$var$dB(b, e.q.getFullYear() - $61de1ee1cac498ae$var$nje + 100);
    }
    if (a.d >= 0) {
        if (a.c == -1) {
            c = (7 + a.d - b.q.getDay()) % 7;
            c > 3 && (c -= 7);
            h = b.q.getMonth();
            $61de1ee1cac498ae$var$ZA(b, b.q.getDate() + c);
            b.q.getMonth() != h && $61de1ee1cac498ae$var$ZA(b, b.q.getDate() + (c > 0 ? -7 : 7));
        } else {
            if (b.q.getDay() != a.d) return false;
        }
    }
    if (a.o > $61de1ee1cac498ae$var$Rie) {
        f = b.q.getTimezoneOffset();
        $61de1ee1cac498ae$var$cB(b, $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Cbb(b.q.getTime()), (a.o - f) * 60 * $61de1ee1cac498ae$var$_ie));
    }
    return true;
}
function $61de1ee1cac498ae$var$z2b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    e = $61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc));
    if (!$61de1ee1cac498ae$var$JD(e, 239)) return;
    o = $61de1ee1cac498ae$var$BD(e, 33);
    p = b.e;
    m = new $61de1ee1cac498ae$var$g7c(b.c);
    f = b.d;
    m.a += f.b;
    m.b += f.d;
    u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(o, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Ixc)), 174);
    if ($61de1ee1cac498ae$var$uqb(u, ($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Add))) {
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(o, $61de1ee1cac498ae$var$Kxc), 116);
        $61de1ee1cac498ae$var$w_b(n, f.a);
        $61de1ee1cac498ae$var$z_b(n, f.d);
        $61de1ee1cac498ae$var$x_b(n, f.b);
        $61de1ee1cac498ae$var$y_b(n, f.c);
    }
    c = new $61de1ee1cac498ae$var$Rkb;
    for(k = new $61de1ee1cac498ae$var$olb(b.a); k.a < k.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 10);
        if ($61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$$sc), 239)) $61de1ee1cac498ae$var$A2b(i, m);
        else if ($61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$$sc), 186) && !p) {
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(i, $61de1ee1cac498ae$var$$sc), 118);
            s = $61de1ee1cac498ae$var$b_b(b, i, d.g, d.f);
            $61de1ee1cac498ae$var$bld(d, s.a, s.b);
        }
        for(r = new $61de1ee1cac498ae$var$olb(i.j); r.a < r.c.c.length;){
            q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(r), 11);
            $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(q.g, 16)), new $61de1ee1cac498ae$var$G2b(i)), new $61de1ee1cac498ae$var$I2b(c));
        }
    }
    if (p) for(r = new $61de1ee1cac498ae$var$olb(p.j); r.a < r.c.c.length;){
        q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(r), 11);
        $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(q.g, 16)), new $61de1ee1cac498ae$var$K2b(p)), new $61de1ee1cac498ae$var$M2b(c));
    }
    t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(o, $61de1ee1cac498ae$var$Swc), 218);
    for(h = new $61de1ee1cac498ae$var$olb(c); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
        $61de1ee1cac498ae$var$y2b(g, t, m);
    }
    $61de1ee1cac498ae$var$B2b(b);
    for(j = new $61de1ee1cac498ae$var$olb(b.a); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 10);
        l = i.e;
        !!l && $61de1ee1cac498ae$var$z2b(a, l);
    }
}
function $61de1ee1cac498ae$var$xSb(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$Q3c($61de1ee1cac498ae$var$L3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$ume), "ELK Force"), "Force-based algorithm provided by the Eclipse Layout Kernel. Implements methods that follow physical analogies by simulating forces that move the nodes into a balanced distribution. Currently the original Eades model and the Fruchterman - Reingold model are supported."), new $61de1ee1cac498ae$var$ASb), $61de1ee1cac498ae$var$ume), $61de1ee1cac498ae$var$qqb(($61de1ee1cac498ae$var$Csd(), $61de1ee1cac498ae$var$zsd), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O3, 1), $61de1ee1cac498ae$var$Kie, 237, 0, [
        $61de1ee1cac498ae$var$xsd
    ])))));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$vme, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$wme, 80);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$xme, 5);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$_le, $61de1ee1cac498ae$var$tme);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$yme, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$zme, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$lSb);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Ame, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$dSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Bme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$mSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Cme, false);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Dme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$jSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$iSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$hSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Gme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$gSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$Hme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$nSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$mme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$fSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$pme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$vSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$nme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$eSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$rme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$qSb));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$ume, $61de1ee1cac498ae$var$ome, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$rSb));
}
function $61de1ee1cac498ae$var$GKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).dc()) return;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    i = g.i;
    h = g.n;
    k = $61de1ee1cac498ae$var$KIb(a, b);
    d = i.b - h.b - h.c;
    e = g.a.a;
    f = i.c + h.b;
    n = a.w;
    if ((k == ($61de1ee1cac498ae$var$Tbd(), $61de1ee1cac498ae$var$Qbd) || k == $61de1ee1cac498ae$var$Sbd) && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() == 1) {
        e = k == $61de1ee1cac498ae$var$Qbd ? e - 2 * a.w : e;
        k = $61de1ee1cac498ae$var$Pbd;
    }
    if (d < e && !a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Fdd))) {
        if (k == $61de1ee1cac498ae$var$Qbd) {
            n += (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() + 1);
            f += n;
        } else n += (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() - 1);
    } else {
        if (d < e) {
            e = k == $61de1ee1cac498ae$var$Qbd ? e - 2 * a.w : e;
            k = $61de1ee1cac498ae$var$Pbd;
        }
        switch(k.g){
            case 3:
                f += (d - e) / 2;
                break;
            case 4:
                f += d - e;
                break;
            case 0:
                c = (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() + 1);
                n += $61de1ee1cac498ae$var$$wnd.Math.max(0, c);
                f += n;
                break;
            case 1:
                c = (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() - 1);
                n += $61de1ee1cac498ae$var$$wnd.Math.max(0, c);
        }
    }
    for(m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); m.Ob();){
        l = $61de1ee1cac498ae$var$BD(m.Pb(), 111);
        l.e.a = f + l.d.b;
        l.e.b = (j = l.b, j.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c)) ? j.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? -j.rf().b - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(j.We($61de1ee1cac498ae$var$s9c))) : $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(j.We($61de1ee1cac498ae$var$s9c))) : j.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? -j.rf().b : 0);
        f += l.d.b + l.b.rf().a + l.d.c + n;
    }
}
function $61de1ee1cac498ae$var$KKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).dc()) return;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    i = g.i;
    h = g.n;
    l = $61de1ee1cac498ae$var$KIb(a, b);
    d = i.a - h.d - h.a;
    e = g.a.b;
    f = i.d + h.d;
    o = a.w;
    j = a.o.a;
    if ((l == ($61de1ee1cac498ae$var$Tbd(), $61de1ee1cac498ae$var$Qbd) || l == $61de1ee1cac498ae$var$Sbd) && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() == 1) {
        e = l == $61de1ee1cac498ae$var$Qbd ? e - 2 * a.w : e;
        l = $61de1ee1cac498ae$var$Pbd;
    }
    if (d < e && !a.B.Hc(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Fdd))) {
        if (l == $61de1ee1cac498ae$var$Qbd) {
            o += (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() + 1);
            f += o;
        } else o += (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() - 1);
    } else {
        if (d < e) {
            e = l == $61de1ee1cac498ae$var$Qbd ? e - 2 * a.w : e;
            l = $61de1ee1cac498ae$var$Pbd;
        }
        switch(l.g){
            case 3:
                f += (d - e) / 2;
                break;
            case 4:
                f += d - e;
                break;
            case 0:
                c = (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() + 1);
                o += $61de1ee1cac498ae$var$$wnd.Math.max(0, c);
                f += o;
                break;
            case 1:
                c = (d - e) / ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).gc() - 1);
                o += $61de1ee1cac498ae$var$$wnd.Math.max(0, c);
        }
    }
    for(n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84).Kc(); n.Ob();){
        m = $61de1ee1cac498ae$var$BD(n.Pb(), 111);
        m.e.a = (k = m.b, k.Xe(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c)) ? k.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? -k.rf().a - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(k.We($61de1ee1cac498ae$var$s9c))) : j + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(k.We($61de1ee1cac498ae$var$s9c))) : k.Hf() == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) ? -k.rf().a : j);
        m.e.b = f + m.d.d;
        f += m.d.d + m.b.rf().b + m.d.a + o;
    }
}
function $61de1ee1cac498ae$var$Abc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    a.n = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc))));
    a.e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.g, $61de1ee1cac498ae$var$pyc)));
    a.i = a.g.b.c.length;
    h = a.i - 1;
    m = 0;
    a.j = 0;
    a.k = 0;
    a.a = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$JI, $61de1ee1cac498ae$var$nie, 19, a.i, 0, 1));
    a.b = $61de1ee1cac498ae$var$Ou($61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BI, $61de1ee1cac498ae$var$nie, 333, a.i, 7, 1));
    for(g = new $61de1ee1cac498ae$var$olb(a.g.b); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 29);
        e.p = h;
        for(l = new $61de1ee1cac498ae$var$olb(e.a); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 10);
            k.p = m;
            ++m;
        }
        --h;
    }
    a.f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, m, 15, 1);
    a.c = $61de1ee1cac498ae$var$IC($61de1ee1cac498ae$var$WD, [
        $61de1ee1cac498ae$var$nie,
        $61de1ee1cac498ae$var$oje
    ], [
        48,
        25
    ], 15, [
        m,
        3
    ], 2);
    a.o = new $61de1ee1cac498ae$var$Rkb;
    a.p = new $61de1ee1cac498ae$var$Rkb;
    b = 0;
    a.d = 0;
    for(f = new $61de1ee1cac498ae$var$olb(a.g.b); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 29);
        h = e.p;
        d = 0;
        p = 0;
        i = e.a.c.length;
        j = 0;
        for(l = new $61de1ee1cac498ae$var$olb(e.a); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 10);
            m = k.p;
            a.f[m] = k.c.p;
            j += k.o.b + a.n;
            c = $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(k).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
            o = $61de1ee1cac498ae$var$sr(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(k).a.Kc(), new $61de1ee1cac498ae$var$Sq)));
            a.c[m][0] = o - c;
            a.c[m][1] = c;
            a.c[m][2] = o;
            d += c;
            p += o;
            c > 0 && $61de1ee1cac498ae$var$Ekb(a.p, k);
            $61de1ee1cac498ae$var$Ekb(a.o, k);
        }
        b -= d;
        n = i + b;
        j += b * a.e;
        $61de1ee1cac498ae$var$Nkb(a.a, h, $61de1ee1cac498ae$var$meb(n));
        $61de1ee1cac498ae$var$Nkb(a.b, h, j);
        a.j = $61de1ee1cac498ae$var$$wnd.Math.max(a.j, n);
        a.k = $61de1ee1cac498ae$var$$wnd.Math.max(a.k, j);
        a.d += b;
        b += p;
    }
}
function $61de1ee1cac498ae$var$Ucd() {
    $61de1ee1cac498ae$var$Ucd = $61de1ee1cac498ae$var$ccb;
    var a;
    $61de1ee1cac498ae$var$Scd = new $61de1ee1cac498ae$var$Ycd($61de1ee1cac498ae$var$ole, 0);
    $61de1ee1cac498ae$var$Acd = new $61de1ee1cac498ae$var$Ycd($61de1ee1cac498ae$var$xle, 1);
    $61de1ee1cac498ae$var$zcd = new $61de1ee1cac498ae$var$Ycd($61de1ee1cac498ae$var$yle, 2);
    $61de1ee1cac498ae$var$Rcd = new $61de1ee1cac498ae$var$Ycd($61de1ee1cac498ae$var$zle, 3);
    $61de1ee1cac498ae$var$Tcd = new $61de1ee1cac498ae$var$Ycd($61de1ee1cac498ae$var$Ale, 4);
    $61de1ee1cac498ae$var$Fcd = ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$zob((a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$F1), 9), new $61de1ee1cac498ae$var$xqb(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(a, a.length), 9), 0))));
    $61de1ee1cac498ae$var$Gcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [])));
    $61de1ee1cac498ae$var$Bcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [])));
    $61de1ee1cac498ae$var$Ocd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [])));
    $61de1ee1cac498ae$var$Qcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Tcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [])));
    $61de1ee1cac498ae$var$Lcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Rcd
    ])));
    $61de1ee1cac498ae$var$Ecd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Tcd
    ])));
    $61de1ee1cac498ae$var$Ncd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Tcd
    ])));
    $61de1ee1cac498ae$var$Hcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$zcd
    ])));
    $61de1ee1cac498ae$var$Pcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Tcd
    ])));
    $61de1ee1cac498ae$var$Ccd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Rcd
    ])));
    $61de1ee1cac498ae$var$Kcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Tcd
    ])));
    $61de1ee1cac498ae$var$Dcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])));
    $61de1ee1cac498ae$var$Mcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])));
    $61de1ee1cac498ae$var$Icd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd
    ])));
    $61de1ee1cac498ae$var$Jcd = $61de1ee1cac498ae$var$Up($61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$F1, 1), $61de1ee1cac498ae$var$bne, 61, 0, [
        $61de1ee1cac498ae$var$zcd,
        $61de1ee1cac498ae$var$Rcd,
        $61de1ee1cac498ae$var$Tcd
    ])));
}
function $61de1ee1cac498ae$var$fSc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    if (b.b != 0) {
        n = new $61de1ee1cac498ae$var$Psb;
        h = null;
        o = null;
        d = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.floor($61de1ee1cac498ae$var$$wnd.Math.log(b.b) * $61de1ee1cac498ae$var$$wnd.Math.LOG10E) + 1);
        i = 0;
        for(t = $61de1ee1cac498ae$var$Jsb(b, 0); t.b != t.d.c;){
            r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(t), 86);
            if ($61de1ee1cac498ae$var$PD(o) !== $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(r, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$$Sc)))) {
                o = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$vNb(r, $61de1ee1cac498ae$var$$Sc));
                i = 0;
            }
            o != null ? h = o + $61de1ee1cac498ae$var$iSc(i++, d) : h = $61de1ee1cac498ae$var$iSc(i++, d);
            $61de1ee1cac498ae$var$yNb(r, $61de1ee1cac498ae$var$$Sc, h);
            for(q = (e = $61de1ee1cac498ae$var$Jsb(new $61de1ee1cac498ae$var$ZRc(r).a.d, 0), new $61de1ee1cac498ae$var$aSc(e)); $61de1ee1cac498ae$var$Wsb(q.a);){
                p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(q.a), 188).c;
                $61de1ee1cac498ae$var$Gsb(n, p, n.c.b, n.c);
                $61de1ee1cac498ae$var$yNb(p, $61de1ee1cac498ae$var$$Sc, h);
            }
        }
        m = new $61de1ee1cac498ae$var$Lqb;
        for(g = 0; g < h.length - d; g++)for(s = $61de1ee1cac498ae$var$Jsb(b, 0); s.b != s.d.c;){
            r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(s), 86);
            j = $61de1ee1cac498ae$var$qfb($61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$vNb(r, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$$Sc))), 0, g + 1);
            c = (j == null ? $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(m.f, null)) : $61de1ee1cac498ae$var$Crb(m.g, j)) != null ? $61de1ee1cac498ae$var$BD(j == null ? $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(m.f, null)) : $61de1ee1cac498ae$var$Crb(m.g, j), 19).a + 1 : 1;
            $61de1ee1cac498ae$var$Shb(m, j, $61de1ee1cac498ae$var$meb(c));
        }
        for(l = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(m).a); l.b;){
            k = $61de1ee1cac498ae$var$lib(l);
            f = $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Ohb(a.a, k.cd()) != null ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, k.cd()), 19).a : 0);
            $61de1ee1cac498ae$var$Shb(a.a, $61de1ee1cac498ae$var$GD(k.cd()), $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD(k.dd(), 19).a + f.a));
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.b, k.cd()), 19);
            (!f || f.a < $61de1ee1cac498ae$var$BD(k.dd(), 19).a) && $61de1ee1cac498ae$var$Shb(a.b, $61de1ee1cac498ae$var$GD(k.cd()), $61de1ee1cac498ae$var$BD(k.dd(), 19));
        }
        $61de1ee1cac498ae$var$fSc(a, n);
    }
}
function $61de1ee1cac498ae$var$PCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    $61de1ee1cac498ae$var$Odd(c, "Interactive node layering", 1);
    d = new $61de1ee1cac498ae$var$Rkb;
    for(n = new $61de1ee1cac498ae$var$olb(b.a); n.a < n.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 10);
        j = l.n.a;
        i = j + l.o.a;
        i = $61de1ee1cac498ae$var$$wnd.Math.max(j + 1, i);
        r = new $61de1ee1cac498ae$var$Bib(d, 0);
        e = null;
        while(r.b < r.d.gc()){
            p = ($61de1ee1cac498ae$var$sCb(r.b < r.d.gc()), $61de1ee1cac498ae$var$BD(r.d.Xb(r.c = r.b++), 569));
            if (p.c >= i) {
                $61de1ee1cac498ae$var$sCb(r.b > 0);
                r.a.Xb(r.c = --r.b);
                break;
            } else if (p.a > j) {
                if (!e) {
                    $61de1ee1cac498ae$var$Ekb(p.b, l);
                    p.c = $61de1ee1cac498ae$var$$wnd.Math.min(p.c, j);
                    p.a = $61de1ee1cac498ae$var$$wnd.Math.max(p.a, i);
                    e = p;
                } else {
                    $61de1ee1cac498ae$var$Gkb(e.b, p.b);
                    e.a = $61de1ee1cac498ae$var$$wnd.Math.max(e.a, p.a);
                    $61de1ee1cac498ae$var$uib(r);
                }
            }
        }
        if (!e) {
            e = new $61de1ee1cac498ae$var$TCc;
            e.c = j;
            e.a = i;
            $61de1ee1cac498ae$var$Aib(r, e);
            $61de1ee1cac498ae$var$Ekb(e.b, l);
        }
    }
    h = b.b;
    k = 0;
    for(q = new $61de1ee1cac498ae$var$olb(d); q.a < q.c.c.length;){
        p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 569);
        f = new $61de1ee1cac498ae$var$H1b(b);
        f.p = k++;
        h.c[h.c.length] = f;
        for(o = new $61de1ee1cac498ae$var$olb(p.b); o.a < o.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
            $61de1ee1cac498ae$var$$_b(l, f);
            l.p = 0;
        }
    }
    for(m = new $61de1ee1cac498ae$var$olb(b.a); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
        l.p == 0 && $61de1ee1cac498ae$var$OCc(a, l, b);
    }
    g = new $61de1ee1cac498ae$var$Bib(h, 0);
    while(g.b < g.d.gc())($61de1ee1cac498ae$var$sCb(g.b < g.d.gc()), $61de1ee1cac498ae$var$BD(g.d.Xb(g.c = g.b++), 29)).a.c.length == 0 && $61de1ee1cac498ae$var$uib(g);
    b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$Snc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    if (b.e.c.length != 0 && c.e.c.length != 0) {
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.e, 0), 17).c.i;
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.e, 0), 17).c.i;
        if (d == g) return $61de1ee1cac498ae$var$beb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.e, 0), 17), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)), 19).a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.e, 0), 17), $61de1ee1cac498ae$var$Zsc), 19).a);
        for(k = a.a, l = 0, m = k.length; l < m; ++l){
            j = k[l];
            if (j == d) return 1;
            else if (j == g) return -1;
        }
    }
    if (b.g.c.length != 0 && c.g.c.length != 0) {
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Xsc)), 10);
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Xsc), 10);
        e = 0;
        h = 0;
        $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.g, 0), 17), $61de1ee1cac498ae$var$Zsc) && (e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.g, 0), 17), $61de1ee1cac498ae$var$Zsc), 19).a);
        $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.g, 0), 17), $61de1ee1cac498ae$var$Zsc) && (h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.g, 0), 17), $61de1ee1cac498ae$var$Zsc), 19).a);
        if (!!f && f == i) {
            if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.g, 0), 17), $61de1ee1cac498ae$var$ltc))) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.g, 0), 17), $61de1ee1cac498ae$var$ltc)))) return 1;
            else if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.g, 0), 17), $61de1ee1cac498ae$var$ltc))) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(c.g, 0), 17), $61de1ee1cac498ae$var$ltc)))) return -1;
            return e < h ? -1 : e > h ? 1 : 0;
        }
        if (a.b) {
            a.b._b(f) && (e = $61de1ee1cac498ae$var$BD(a.b.xc(f), 19).a);
            a.b._b(i) && (h = $61de1ee1cac498ae$var$BD(a.b.xc(i), 19).a);
        }
        return e < h ? -1 : e > h ? 1 : 0;
    }
    return b.e.c.length != 0 && c.g.c.length != 0 ? 1 : -1;
}
function $61de1ee1cac498ae$var$acc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A;
    $61de1ee1cac498ae$var$Odd(b, $61de1ee1cac498ae$var$Ine, 1);
    p = new $61de1ee1cac498ae$var$Rkb;
    w = new $61de1ee1cac498ae$var$Rkb;
    for(j = new $61de1ee1cac498ae$var$olb(a.b); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 29);
        r = -1;
        o = $61de1ee1cac498ae$var$l_b(i.a);
        for(l = o, m = 0, n = l.length; m < n; ++m){
            k = l[m];
            ++r;
            if (!(k.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) && $61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98)))) continue;
            $61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(k, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98)) || $61de1ee1cac498ae$var$bcc(k);
            $61de1ee1cac498ae$var$yNb(k, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Psc), k);
            p.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            w.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            c = new $61de1ee1cac498ae$var$Rkb;
            u = new $61de1ee1cac498ae$var$Psb;
            $61de1ee1cac498ae$var$Jq(u, $61de1ee1cac498ae$var$Y_b(k, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)));
            $61de1ee1cac498ae$var$$bc(a, u, p, w, c);
            h = r;
            A = k;
            for(f = new $61de1ee1cac498ae$var$olb(p); f.a < f.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
                $61de1ee1cac498ae$var$Z_b(d, h, i);
                ++r;
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$Psc, k);
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d.j, 0), 11);
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$$sc), 11);
                $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(q, $61de1ee1cac498ae$var$nwc))) || $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Qsc), 15).Fc(A);
            }
            $61de1ee1cac498ae$var$Osb(u);
            for(t = $61de1ee1cac498ae$var$Y_b(k, $61de1ee1cac498ae$var$Rcd).Kc(); t.Ob();){
                s = $61de1ee1cac498ae$var$BD(t.Pb(), 11);
                $61de1ee1cac498ae$var$Gsb(u, s, u.a, u.a.a);
            }
            $61de1ee1cac498ae$var$$bc(a, u, w, null, c);
            v = k;
            for(e = new $61de1ee1cac498ae$var$olb(w); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
                $61de1ee1cac498ae$var$Z_b(d, ++r, i);
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$Psc, k);
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d.j, 0), 11);
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$$sc), 11);
                $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(q, $61de1ee1cac498ae$var$nwc))) || $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(v, $61de1ee1cac498ae$var$Qsc), 15).Fc(d);
            }
            c.c.length == 0 || $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$ssc, c);
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$SQb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$FSb)), 33);
    r = $61de1ee1cac498ae$var$Ohe;
    s = $61de1ee1cac498ae$var$Ohe;
    p = $61de1ee1cac498ae$var$Rie;
    q = $61de1ee1cac498ae$var$Rie;
    for(u = new $61de1ee1cac498ae$var$olb(a.e); u.a < u.c.c.length;){
        t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 144);
        C = t.d;
        D = t.e;
        r = $61de1ee1cac498ae$var$$wnd.Math.min(r, C.a - D.a / 2);
        s = $61de1ee1cac498ae$var$$wnd.Math.min(s, C.b - D.b / 2);
        p = $61de1ee1cac498ae$var$$wnd.Math.max(p, C.a + D.a / 2);
        q = $61de1ee1cac498ae$var$$wnd.Math.max(q, C.b + D.b / 2);
    }
    B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(l, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$kSb)), 116);
    A = new $61de1ee1cac498ae$var$f7c(B.b - r, B.d - s);
    for(h = new $61de1ee1cac498ae$var$olb(a.e); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 144);
        w = $61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$FSb);
        if ($61de1ee1cac498ae$var$JD(w, 239)) {
            n = $61de1ee1cac498ae$var$BD(w, 33);
            v = $61de1ee1cac498ae$var$P6c(g.d, A);
            $61de1ee1cac498ae$var$bld(n, v.a - n.g / 2, v.b - n.f / 2);
        }
    }
    for(d = new $61de1ee1cac498ae$var$olb(a.c); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 282);
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$FSb), 79);
        k = $61de1ee1cac498ae$var$itd(j, true, true);
        F = (H = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(c.d.d), c.c.d), $61de1ee1cac498ae$var$l6c(H, c.c.e.a, c.c.e.b), $61de1ee1cac498ae$var$P6c(H, c.c.d));
        $61de1ee1cac498ae$var$nmd(k, F.a, F.b);
        b = (I = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(c.c.d), c.d.d), $61de1ee1cac498ae$var$l6c(I, c.d.e.a, c.d.e.b), $61de1ee1cac498ae$var$P6c(I, c.d.d));
        $61de1ee1cac498ae$var$gmd(k, b.a, b.b);
    }
    for(f = new $61de1ee1cac498ae$var$olb(a.d); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 447);
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$FSb), 137);
        o = $61de1ee1cac498ae$var$P6c(e.d, A);
        $61de1ee1cac498ae$var$bld(m, o.a, o.b);
    }
    G = p - r + (B.b + B.c);
    i = q - s + (B.d + B.a);
    $61de1ee1cac498ae$var$Afd(l, G, i, false, true);
}
function $61de1ee1cac498ae$var$bmc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    c = null;
    i = null;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Wwc)), 376);
    if (e == ($61de1ee1cac498ae$var$_Ac(), $61de1ee1cac498ae$var$ZAc)) {
        c = new $61de1ee1cac498ae$var$Rkb;
        i = new $61de1ee1cac498ae$var$Rkb;
    }
    for(h = new $61de1ee1cac498ae$var$olb(a.d); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 101);
        f = g.i;
        if (!f) continue;
        switch(g.e.g){
            case 0:
                b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Fqb(new $61de1ee1cac498ae$var$Gqb(g.b)), 61);
                e == $61de1ee1cac498ae$var$ZAc && b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? c.c[c.c.length] = g : e == $61de1ee1cac498ae$var$ZAc && b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd) ? i.c[i.c.length] = g : $61de1ee1cac498ae$var$_lc(g, b);
                break;
            case 1:
                j = g.a.d.j;
                k = g.c.d.j;
                j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) ? $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Acd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$xjc), g.a) : k == $61de1ee1cac498ae$var$Acd ? $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Acd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$yjc), g.c) : j == $61de1ee1cac498ae$var$Rcd ? $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Rcd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$yjc), g.a) : k == $61de1ee1cac498ae$var$Rcd && $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Rcd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$xjc), g.c);
                break;
            case 2:
            case 3:
                d = g.b;
                $61de1ee1cac498ae$var$uqb(d, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) ? $61de1ee1cac498ae$var$uqb(d, $61de1ee1cac498ae$var$Rcd) ? $61de1ee1cac498ae$var$uqb(d, $61de1ee1cac498ae$var$Tcd) ? $61de1ee1cac498ae$var$uqb(d, $61de1ee1cac498ae$var$zcd) || $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Acd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$yjc), g.c) : $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Acd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$xjc), g.a) : $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Acd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$wjc), null) : $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Rcd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$wjc), null);
                break;
            case 4:
                l = g.a.d.j;
                m = g.a.d.j;
                l == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) || m == $61de1ee1cac498ae$var$Acd ? $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Rcd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$wjc), null) : $61de1ee1cac498ae$var$amc(g, $61de1ee1cac498ae$var$Acd, ($61de1ee1cac498ae$var$Ajc(), $61de1ee1cac498ae$var$wjc), null);
        }
    }
    if (c) {
        c.c.length == 0 || $61de1ee1cac498ae$var$$lc(c, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
        i.c.length == 0 || $61de1ee1cac498ae$var$$lc(i, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd));
    }
}
function $61de1ee1cac498ae$var$A2b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 33);
    o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Gwc)), 19).a;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$nxc), 19).a;
    $61de1ee1cac498ae$var$jkd(d, $61de1ee1cac498ae$var$Gwc, $61de1ee1cac498ae$var$meb(o));
    $61de1ee1cac498ae$var$jkd(d, $61de1ee1cac498ae$var$nxc, $61de1ee1cac498ae$var$meb(f));
    $61de1ee1cac498ae$var$dld(d, a.n.a + b.a);
    $61de1ee1cac498ae$var$eld(d, a.n.b + b.b);
    if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$Fxc), 174).gc() != 0 || !!a.e || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), $61de1ee1cac498ae$var$Exc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Vzc(), $61de1ee1cac498ae$var$Tzc)) && $61de1ee1cac498ae$var$Jzc(($61de1ee1cac498ae$var$Izc(), (!a.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : a.q)._b($61de1ee1cac498ae$var$Cxc) ? m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Cxc), 197) : m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(a), $61de1ee1cac498ae$var$Dxc), 197), m))) {
        $61de1ee1cac498ae$var$cld(d, a.o.a);
        $61de1ee1cac498ae$var$ald(d, a.o.b);
    }
    for(l = new $61de1ee1cac498ae$var$olb(a.j); l.a < l.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 11);
        p = $61de1ee1cac498ae$var$vNb(j, $61de1ee1cac498ae$var$$sc);
        if ($61de1ee1cac498ae$var$JD(p, 186)) {
            e = $61de1ee1cac498ae$var$BD(p, 118);
            $61de1ee1cac498ae$var$bld(e, j.n.a, j.n.b);
            $61de1ee1cac498ae$var$jkd(e, $61de1ee1cac498ae$var$$xc, j.j);
        }
    }
    n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$xxc), 174).gc() != 0;
    for(i = new $61de1ee1cac498ae$var$olb(a.b); i.a < i.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 70);
        if (n || $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$xxc), 174).gc() != 0) {
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$$sc), 137);
            $61de1ee1cac498ae$var$_kd(c, g.o.a, g.o.b);
            $61de1ee1cac498ae$var$bld(c, g.n.a, g.n.b);
        }
    }
    if (!$61de1ee1cac498ae$var$tcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Yxc), 21))) for(k = new $61de1ee1cac498ae$var$olb(a.j); k.a < k.c.c.length;){
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 11);
        for(h = new $61de1ee1cac498ae$var$olb(j.f); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 70);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$$sc), 137);
            $61de1ee1cac498ae$var$cld(c, g.o.a);
            $61de1ee1cac498ae$var$ald(c, g.o.b);
            $61de1ee1cac498ae$var$bld(c, g.n.a, g.n.b);
        }
    }
}
function $61de1ee1cac498ae$var$gtd(a) {
    var b, c, d, e, f;
    $61de1ee1cac498ae$var$ytb(a, $61de1ee1cac498ae$var$hue);
    switch((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i + (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c).i){
        case 0:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The edge must have at least one source or target."));
        case 1:
            return (!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i == 0 ? $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c), 0), 82))) : $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82)));
    }
    if ((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b).i == 1 && (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c).i == 1) {
        e = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82));
        f = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c), 0), 82));
        if ($61de1ee1cac498ae$var$Xod(e) == $61de1ee1cac498ae$var$Xod(f)) return $61de1ee1cac498ae$var$Xod(e);
        else if (e == $61de1ee1cac498ae$var$Xod(f)) return e;
        else if (f == $61de1ee1cac498ae$var$Xod(e)) return f;
    }
    d = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
        (!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b),
        (!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c)
    ])));
    b = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 82));
    while($61de1ee1cac498ae$var$Qr(d)){
        c = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 82));
        if (c != b && !$61de1ee1cac498ae$var$ntd(c, b)) {
            if ($61de1ee1cac498ae$var$Xod(c) == $61de1ee1cac498ae$var$Xod(b)) b = $61de1ee1cac498ae$var$Xod(c);
            else {
                b = $61de1ee1cac498ae$var$htd(b, c);
                if (!b) return null;
            }
        }
    }
    return b;
}
function $61de1ee1cac498ae$var$KNc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    $61de1ee1cac498ae$var$Odd(c, "Polyline edge routing", 1);
    q = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Uwc))));
    n = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$wyc)));
    e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$myc)));
    d = $61de1ee1cac498ae$var$$wnd.Math.min(1, e / n);
    t = 0;
    i = 0;
    if (b.b.c.length != 0) {
        u = $61de1ee1cac498ae$var$HNc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.b, 0), 29));
        t = 0.4 * d * u;
    }
    h = new $61de1ee1cac498ae$var$Bib(b.b, 0);
    while(h.b < h.d.gc()){
        g = ($61de1ee1cac498ae$var$sCb(h.b < h.d.gc()), $61de1ee1cac498ae$var$BD(h.d.Xb(h.c = h.b++), 29));
        f = $61de1ee1cac498ae$var$Kq(g, $61de1ee1cac498ae$var$DNc);
        f && t > 0 && (t -= n);
        $61de1ee1cac498ae$var$h_b(g, t);
        k = 0;
        for(m = new $61de1ee1cac498ae$var$olb(g.a); m.a < m.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
            j = 0;
            for(p = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(l).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(p);){
                o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(p), 17);
                r = $61de1ee1cac498ae$var$A0b(o.c).b;
                s = $61de1ee1cac498ae$var$A0b(o.d).b;
                if (g == o.d.i.c && !$61de1ee1cac498ae$var$OZb(o)) {
                    $61de1ee1cac498ae$var$LNc(o, t, 0.4 * d * $61de1ee1cac498ae$var$$wnd.Math.abs(r - s));
                    if (o.c.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)) {
                        r = 0;
                        s = 0;
                    }
                }
                j = $61de1ee1cac498ae$var$$wnd.Math.max(j, $61de1ee1cac498ae$var$$wnd.Math.abs(s - r));
            }
            switch(l.k.g){
                case 0:
                case 4:
                case 1:
                case 3:
                case 5:
                    $61de1ee1cac498ae$var$MNc(a, l, t, q);
            }
            k = $61de1ee1cac498ae$var$$wnd.Math.max(k, j);
        }
        if (h.b < h.d.gc()) {
            u = $61de1ee1cac498ae$var$HNc(($61de1ee1cac498ae$var$sCb(h.b < h.d.gc()), $61de1ee1cac498ae$var$BD(h.d.Xb(h.c = h.b++), 29)));
            k = $61de1ee1cac498ae$var$$wnd.Math.max(k, u);
            $61de1ee1cac498ae$var$sCb(h.b > 0);
            h.a.Xb(h.c = --h.b);
        }
        i = 0.4 * d * k;
        !f && h.b < h.d.gc() && (i += n);
        t += g.c.a + i;
    }
    a.a.a.$b();
    b.f.a = t;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$bic(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    k = new $61de1ee1cac498ae$var$Lqb;
    i = new $61de1ee1cac498ae$var$Hp;
    for(d = new $61de1ee1cac498ae$var$olb(a.a.a.b); d.a < d.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 57);
        j = $61de1ee1cac498ae$var$tgc(b);
        if (j) $61de1ee1cac498ae$var$jrb(k.f, j, b);
        else {
            s = $61de1ee1cac498ae$var$ugc(b);
            if (s) for(f = new $61de1ee1cac498ae$var$olb(s.k); f.a < f.c.c.length;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                $61de1ee1cac498ae$var$Rc(i, e, b);
            }
        }
    }
    for(c = new $61de1ee1cac498ae$var$olb(a.a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        j = $61de1ee1cac498ae$var$tgc(b);
        if (j) for(h = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(j).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(h);){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(h), 17);
            if ($61de1ee1cac498ae$var$OZb(g)) continue;
            o = g.c;
            r = g.d;
            if (($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Lcd).Hc(g.c.j) && $61de1ee1cac498ae$var$Lcd.Hc(g.d.j)) continue;
            p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(k, g.d.i), 57);
            $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 0), 100), a.c[b.a.d]), a.c[p.a.d]));
            if (o.j == $61de1ee1cac498ae$var$Tcd && $61de1ee1cac498ae$var$l1b(($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$w0b, o))) for(m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(i, g), 21).Kc(); m.Ob();){
                l = $61de1ee1cac498ae$var$BD(m.Pb(), 57);
                if (l.d.c < b.d.c) {
                    n = a.c[l.a.d];
                    q = a.c[b.a.d];
                    if (n == q) continue;
                    $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 1), 100), n), q));
                }
            }
            if (r.j == $61de1ee1cac498ae$var$zcd && $61de1ee1cac498ae$var$g1b(($61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$u0b, r))) for(m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(i, g), 21).Kc(); m.Ob();){
                l = $61de1ee1cac498ae$var$BD(m.Pb(), 57);
                if (l.d.c > b.d.c) {
                    n = a.c[b.a.d];
                    q = a.c[l.a.d];
                    if (n == q) continue;
                    $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$EFb($61de1ee1cac498ae$var$BFb(new $61de1ee1cac498ae$var$FFb, 1), 100), n), q));
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$QEd(a) {
    $61de1ee1cac498ae$var$IEd();
    var b, c, d, e, f, g, h, i;
    if (a == null) return null;
    e = $61de1ee1cac498ae$var$hfb(a, $61de1ee1cac498ae$var$wfb(37));
    if (e < 0) return a;
    else {
        i = new $61de1ee1cac498ae$var$Wfb(a.substr(0, e));
        b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, 4, 15, 1);
        h = 0;
        d = 0;
        for(g = a.length; e < g; e++){
            $61de1ee1cac498ae$var$BCb(e, a.length);
            if (a.charCodeAt(e) == 37 && a.length > e + 2 && $61de1ee1cac498ae$var$_Ed(($61de1ee1cac498ae$var$BCb(e + 1, a.length), a.charCodeAt(e + 1)), $61de1ee1cac498ae$var$xEd, $61de1ee1cac498ae$var$yEd) && $61de1ee1cac498ae$var$_Ed(($61de1ee1cac498ae$var$BCb(e + 2, a.length), a.charCodeAt(e + 2)), $61de1ee1cac498ae$var$xEd, $61de1ee1cac498ae$var$yEd)) {
                c = $61de1ee1cac498ae$var$dFd(($61de1ee1cac498ae$var$BCb(e + 1, a.length), a.charCodeAt(e + 1)), ($61de1ee1cac498ae$var$BCb(e + 2, a.length), a.charCodeAt(e + 2)));
                e += 2;
                if (d > 0) (c & 192) == 128 ? b[h++] = c << 24 >> 24 : d = 0;
                else if (c >= 128) {
                    if ((c & 224) == 192) {
                        b[h++] = c << 24 >> 24;
                        d = 2;
                    } else if ((c & 240) == 224) {
                        b[h++] = c << 24 >> 24;
                        d = 3;
                    } else if ((c & 248) == 240) {
                        b[h++] = c << 24 >> 24;
                        d = 4;
                    }
                }
                if (d > 0) {
                    if (h == d) {
                        switch(h){
                            case 2:
                                $61de1ee1cac498ae$var$Kfb(i, ((b[0] & 31) << 6 | b[1] & 63) & $61de1ee1cac498ae$var$aje);
                                break;
                            case 3:
                                $61de1ee1cac498ae$var$Kfb(i, ((b[0] & 15) << 12 | (b[1] & 63) << 6 | b[2] & 63) & $61de1ee1cac498ae$var$aje);
                                break;
                        }
                        h = 0;
                        d = 0;
                    }
                } else {
                    for(f = 0; f < h; ++f)$61de1ee1cac498ae$var$Kfb(i, b[f] & $61de1ee1cac498ae$var$aje);
                    h = 0;
                    i.a += String.fromCharCode(c);
                }
            } else {
                for(f = 0; f < h; ++f)$61de1ee1cac498ae$var$Kfb(i, b[f] & $61de1ee1cac498ae$var$aje);
                h = 0;
                $61de1ee1cac498ae$var$Kfb(i, ($61de1ee1cac498ae$var$BCb(e, a.length), a.charCodeAt(e)));
            }
        }
        return i.a;
    }
}
function $61de1ee1cac498ae$var$wA(a, b, c, d, e) {
    var f, g, h;
    $61de1ee1cac498ae$var$uA(a, b);
    g = b[0];
    f = $61de1ee1cac498ae$var$bfb(c.c, 0);
    h = -1;
    if ($61de1ee1cac498ae$var$nA(c)) {
        if (d > 0) {
            if (g + d > a.length) return false;
            h = $61de1ee1cac498ae$var$rA(a.substr(0, g + d), b);
        } else h = $61de1ee1cac498ae$var$rA(a, b);
    }
    switch(f){
        case 71:
            h = $61de1ee1cac498ae$var$oA(a, g, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                $61de1ee1cac498ae$var$pje,
                $61de1ee1cac498ae$var$qje
            ]), b);
            e.e = h;
            return true;
        case 77:
            return $61de1ee1cac498ae$var$zA(a, b, e, h, g);
        case 76:
            return $61de1ee1cac498ae$var$BA(a, b, e, h, g);
        case 69:
            return $61de1ee1cac498ae$var$xA(a, b, g, e);
        case 99:
            return $61de1ee1cac498ae$var$AA(a, b, g, e);
        case 97:
            h = $61de1ee1cac498ae$var$oA(a, g, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "AM",
                "PM"
            ]), b);
            e.b = h;
            return true;
        case 121:
            return $61de1ee1cac498ae$var$DA(a, b, g, h, c, e);
        case 100:
            if (h <= 0) return false;
            e.c = h;
            return true;
        case 83:
            if (h < 0) return false;
            return $61de1ee1cac498ae$var$yA(h, g, b[0], e);
        case 104:
            h == 12 && (h = 0);
        case 75:
        case 72:
            if (h < 0) return false;
            e.f = h;
            e.g = false;
            return true;
        case 107:
            if (h < 0) return false;
            e.f = h;
            e.g = true;
            return true;
        case 109:
            if (h < 0) return false;
            e.j = h;
            return true;
        case 115:
            if (h < 0) return false;
            e.n = h;
            return true;
        case 90:
            if (g < a.length && ($61de1ee1cac498ae$var$BCb(g, a.length), a.charCodeAt(g) == 90)) {
                ++b[0];
                e.o = 0;
                return true;
            }
        case 122:
        case 118:
            return $61de1ee1cac498ae$var$CA(a, g, b, e);
        default:
            return false;
    }
}
function $61de1ee1cac498ae$var$vKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    if (b == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) || b == $61de1ee1cac498ae$var$Tcd) {
        $61de1ee1cac498ae$var$zKb(a, b);
        return;
    }
    f = b == $61de1ee1cac498ae$var$Acd ? ($61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$rLb) : ($61de1ee1cac498ae$var$vLb(), $61de1ee1cac498ae$var$uLb);
    u = b == $61de1ee1cac498ae$var$Acd ? ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb) : ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb);
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124);
    d = c.i;
    e = d.c + $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        c.n.b,
        a.C.b,
        a.k
    ]));
    r = d.c + d.b - $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        c.n.c,
        a.C.c,
        a.k
    ]));
    g = $61de1ee1cac498ae$var$dLb($61de1ee1cac498ae$var$iLb(f), a.t);
    s = b == $61de1ee1cac498ae$var$Acd ? $61de1ee1cac498ae$var$Qje : $61de1ee1cac498ae$var$Pje;
    for(l = m.Kc(); l.Ob();){
        j = $61de1ee1cac498ae$var$BD(l.Pb(), 111);
        if (!j.c || j.c.d.c.length <= 0) continue;
        q = j.b.rf();
        p = j.e;
        n = j.c;
        o = n.i;
        o.b = (i = n.n, n.e.a + i.b + i.c);
        o.a = (h = n.n, n.e.b + h.d + h.a);
        $61de1ee1cac498ae$var$ytb(u, $61de1ee1cac498ae$var$lle);
        n.f = u;
        $61de1ee1cac498ae$var$$Hb(n, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
        o.c = p.a - (o.b - q.a) / 2;
        v = $61de1ee1cac498ae$var$$wnd.Math.min(e, p.a);
        w = $61de1ee1cac498ae$var$$wnd.Math.max(r, p.a + q.a);
        o.c < v ? o.c = v : o.c + o.b > w && (o.c = w - o.b);
        $61de1ee1cac498ae$var$Ekb(g.d, new $61de1ee1cac498ae$var$BLb(o, $61de1ee1cac498ae$var$bLb(g, o)));
        s = b == $61de1ee1cac498ae$var$Acd ? $61de1ee1cac498ae$var$$wnd.Math.max(s, p.b + j.b.rf().b) : $61de1ee1cac498ae$var$$wnd.Math.min(s, p.b);
    }
    s += b == $61de1ee1cac498ae$var$Acd ? a.t : -a.t;
    t = $61de1ee1cac498ae$var$cLb((g.e = s, g));
    t > 0 && ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Mpb(a.b, b), 124).a.b = t);
    for(k = m.Kc(); k.Ob();){
        j = $61de1ee1cac498ae$var$BD(k.Pb(), 111);
        if (!j.c || j.c.d.c.length <= 0) continue;
        o = j.c.i;
        o.c -= j.e.a;
        o.d -= j.e.b;
    }
}
function $61de1ee1cac498ae$var$SPb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    b = new $61de1ee1cac498ae$var$Lqb;
    for(i = new $61de1ee1cac498ae$var$Fyd(a); i.e != i.i.gc();){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 33);
        c = new $61de1ee1cac498ae$var$Tqb;
        $61de1ee1cac498ae$var$Rhb($61de1ee1cac498ae$var$OPb, h, c);
        n = new $61de1ee1cac498ae$var$aQb;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$$sd(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)))), $61de1ee1cac498ae$var$Wyb(n, $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
            ($61de1ee1cac498ae$var$Fyb(), $61de1ee1cac498ae$var$Dyb)
        ])))), 83);
        $61de1ee1cac498ae$var$RPb(c, $61de1ee1cac498ae$var$BD(e.xc(($61de1ee1cac498ae$var$Bcb(), true)), 14), new $61de1ee1cac498ae$var$cQb);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$BD(e.xc(false), 15).Lc(), new $61de1ee1cac498ae$var$eQb), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
            $61de1ee1cac498ae$var$Dyb
        ]))), 15);
        for(g = d.Kc(); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 79);
            m = $61de1ee1cac498ae$var$ktd(f);
            if (m) {
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(b.f, m)), 21);
                if (!j) {
                    j = $61de1ee1cac498ae$var$UPb(m);
                    $61de1ee1cac498ae$var$jrb(b.f, m, j);
                }
                $61de1ee1cac498ae$var$ye(c, j);
            }
        }
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(h).a.Kc(), new $61de1ee1cac498ae$var$Sq)))), $61de1ee1cac498ae$var$Wyb(n, $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
            $61de1ee1cac498ae$var$Dyb
        ])))), 83);
        $61de1ee1cac498ae$var$RPb(c, $61de1ee1cac498ae$var$BD(e.xc(true), 14), new $61de1ee1cac498ae$var$gQb);
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$BD(e.xc(false), 15).Lc(), new $61de1ee1cac498ae$var$iQb), $61de1ee1cac498ae$var$Byb(new $61de1ee1cac498ae$var$fzb, new $61de1ee1cac498ae$var$dzb, new $61de1ee1cac498ae$var$Ezb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, [
            $61de1ee1cac498ae$var$Dyb
        ]))), 15);
        for(l = d.Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 79);
            m = $61de1ee1cac498ae$var$mtd(k);
            if (m) {
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(b.f, m)), 21);
                if (!j) {
                    j = $61de1ee1cac498ae$var$UPb(m);
                    $61de1ee1cac498ae$var$jrb(b.f, m, j);
                }
                $61de1ee1cac498ae$var$ye(c, j);
            }
        }
    }
}
function $61de1ee1cac498ae$var$rhb(a, b) {
    $61de1ee1cac498ae$var$phb();
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    i = $61de1ee1cac498ae$var$ybb(a, 0) < 0;
    i && (a = $61de1ee1cac498ae$var$Jbb(a));
    if ($61de1ee1cac498ae$var$ybb(a, 0) == 0) switch(b){
        case 0:
            return "0";
        case 1:
            return $61de1ee1cac498ae$var$$je;
        case 2:
            return "0.00";
        case 3:
            return "0.000";
        case 4:
            return "0.0000";
        case 5:
            return "0.00000";
        case 6:
            return "0.000000";
        default:
            n = new $61de1ee1cac498ae$var$Ufb;
            b < 0 ? (n.a += "0E+", n) : (n.a += "0E", n);
            n.a += b == $61de1ee1cac498ae$var$Rie ? "2147483648" : "" + -b;
            return n.a;
    }
    k = 18;
    l = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, k + 1, 15, 1);
    c = k;
    p = a;
    do {
        j = p;
        p = $61de1ee1cac498ae$var$Abb(p, 10);
        l[--c] = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$wbb(48, $61de1ee1cac498ae$var$Qbb(j, $61de1ee1cac498ae$var$Ibb(p, 10)))) & $61de1ee1cac498ae$var$aje;
    }while ($61de1ee1cac498ae$var$ybb(p, 0) != 0);
    e = $61de1ee1cac498ae$var$Qbb($61de1ee1cac498ae$var$Qbb($61de1ee1cac498ae$var$Qbb(k, c), b), 1);
    if (b == 0) {
        i && (l[--c] = 45);
        return $61de1ee1cac498ae$var$zfb(l, c, k - c);
    }
    if (b > 0 && $61de1ee1cac498ae$var$ybb(e, -6) >= 0) {
        if ($61de1ee1cac498ae$var$ybb(e, 0) >= 0) {
            f = c + $61de1ee1cac498ae$var$Tbb(e);
            for(h = k - 1; h >= f; h--)l[h + 1] = l[h];
            l[++f] = 46;
            i && (l[--c] = 45);
            return $61de1ee1cac498ae$var$zfb(l, c, k - c + 1);
        }
        for(g = 2; $61de1ee1cac498ae$var$Gbb(g, $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Jbb(e), 1)); g++)l[--c] = 48;
        l[--c] = 46;
        l[--c] = 48;
        i && (l[--c] = 45);
        return $61de1ee1cac498ae$var$zfb(l, c, k - c);
    }
    o = c + 1;
    d = k;
    m = new $61de1ee1cac498ae$var$Vfb;
    i && (m.a += "-", m);
    if (d - o >= 1) {
        $61de1ee1cac498ae$var$Kfb(m, l[c]);
        m.a += ".";
        m.a += $61de1ee1cac498ae$var$zfb(l, c + 1, k - c - 1);
    } else m.a += $61de1ee1cac498ae$var$zfb(l, c, k - c);
    m.a += "E";
    $61de1ee1cac498ae$var$ybb(e, 0) > 0 && (m.a += "+", m);
    m.a += "" + $61de1ee1cac498ae$var$Ubb(e);
    return m.a;
}
function $61de1ee1cac498ae$var$iQc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    a.e.a.$b();
    a.f.a.$b();
    a.c.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.i.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.g.a.$b();
    if (b) for(g = new $61de1ee1cac498ae$var$olb(b.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        for(l = $61de1ee1cac498ae$var$Y_b(f, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)).Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 11);
            $61de1ee1cac498ae$var$Qqb(a.e, k);
            for(e = new $61de1ee1cac498ae$var$olb(k.g); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                if ($61de1ee1cac498ae$var$OZb(d)) continue;
                $61de1ee1cac498ae$var$Ekb(a.c, d);
                $61de1ee1cac498ae$var$oQc(a, d);
                h = d.c.i.k;
                (h == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) || h == $61de1ee1cac498ae$var$i0b || h == $61de1ee1cac498ae$var$e0b || h == $61de1ee1cac498ae$var$d0b) && $61de1ee1cac498ae$var$Ekb(a.j, d);
                n = d.d;
                m = n.i.c;
                m == c ? $61de1ee1cac498ae$var$Qqb(a.f, n) : m == b ? $61de1ee1cac498ae$var$Qqb(a.e, n) : $61de1ee1cac498ae$var$Lkb(a.c, d);
            }
        }
    }
    if (c) for(g = new $61de1ee1cac498ae$var$olb(c.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 10);
        for(j = new $61de1ee1cac498ae$var$olb(f.j); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 11);
            for(e = new $61de1ee1cac498ae$var$olb(i.g); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                $61de1ee1cac498ae$var$OZb(d) && $61de1ee1cac498ae$var$Qqb(a.g, d);
            }
        }
        for(l = $61de1ee1cac498ae$var$Y_b(f, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)).Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 11);
            $61de1ee1cac498ae$var$Qqb(a.f, k);
            for(e = new $61de1ee1cac498ae$var$olb(k.g); e.a < e.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                if ($61de1ee1cac498ae$var$OZb(d)) continue;
                $61de1ee1cac498ae$var$Ekb(a.c, d);
                $61de1ee1cac498ae$var$oQc(a, d);
                h = d.c.i.k;
                (h == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) || h == $61de1ee1cac498ae$var$i0b || h == $61de1ee1cac498ae$var$e0b || h == $61de1ee1cac498ae$var$d0b) && $61de1ee1cac498ae$var$Ekb(a.j, d);
                n = d.d;
                m = n.i.c;
                m == c ? $61de1ee1cac498ae$var$Qqb(a.f, n) : m == b ? $61de1ee1cac498ae$var$Qqb(a.e, n) : $61de1ee1cac498ae$var$Lkb(a.c, d);
            }
        }
    }
}
function $61de1ee1cac498ae$var$Afd(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    q = new $61de1ee1cac498ae$var$f7c(a.g, a.f);
    p = $61de1ee1cac498ae$var$rfd(a);
    p.a = $61de1ee1cac498ae$var$$wnd.Math.max(p.a, b);
    p.b = $61de1ee1cac498ae$var$$wnd.Math.max(p.b, c);
    w = p.a / q.a;
    k = p.b / q.b;
    u = p.a - q.a;
    i = p.b - q.b;
    if (d) {
        g = !$61de1ee1cac498ae$var$Xod(a) ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$z8c)), 103) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd($61de1ee1cac498ae$var$Xod(a), ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$z8c)), 103);
        h = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$t9c))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
        for(s = new $61de1ee1cac498ae$var$Fyd((!a.c && (a.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, a, 9, 9)), a.c)); s.e != s.i.gc();){
            r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(s), 118);
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(r, $61de1ee1cac498ae$var$A9c), 61);
            if (t == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd)) {
                t = $61de1ee1cac498ae$var$lfd(r, g);
                $61de1ee1cac498ae$var$jkd(r, $61de1ee1cac498ae$var$A9c, t);
            }
            switch(t.g){
                case 1:
                    h || $61de1ee1cac498ae$var$dld(r, r.i * w);
                    break;
                case 2:
                    $61de1ee1cac498ae$var$dld(r, r.i + u);
                    h || $61de1ee1cac498ae$var$eld(r, r.j * k);
                    break;
                case 3:
                    h || $61de1ee1cac498ae$var$dld(r, r.i * w);
                    $61de1ee1cac498ae$var$eld(r, r.j + i);
                    break;
                case 4:
                    h || $61de1ee1cac498ae$var$eld(r, r.j * k);
            }
        }
    }
    $61de1ee1cac498ae$var$_kd(a, p.a, p.b);
    if (e) for(m = new $61de1ee1cac498ae$var$Fyd((!a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), a.n)); m.e != m.i.gc();){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(m), 137);
        n = l.i + l.g / 2;
        o = l.j + l.f / 2;
        v = n / q.a;
        j = o / q.b;
        if (v + j >= 1) {
            if (v - j > 0 && o >= 0) {
                $61de1ee1cac498ae$var$dld(l, l.i + u);
                $61de1ee1cac498ae$var$eld(l, l.j + i * j);
            } else if (v - j < 0 && n >= 0) {
                $61de1ee1cac498ae$var$dld(l, l.i + u * v);
                $61de1ee1cac498ae$var$eld(l, l.j + i);
            }
        }
    }
    $61de1ee1cac498ae$var$jkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$Y8c), ($61de1ee1cac498ae$var$tdd(), f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$I1), 9), new $61de1ee1cac498ae$var$xqb(f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(f, f.length), 9), 0)));
    return new $61de1ee1cac498ae$var$f7c(w, k);
}
function $61de1ee1cac498ae$var$Yfd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o;
    n = $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82)));
    o = $61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c), 0), 82)));
    l = n == o;
    h = new $61de1ee1cac498ae$var$d7c;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Zad(), $61de1ee1cac498ae$var$Sad)), 74);
    if (!!b && b.b >= 2) {
        if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i == 0) {
            c = ($61de1ee1cac498ae$var$Fhd(), e = new $61de1ee1cac498ae$var$rmd, e);
            $61de1ee1cac498ae$var$wtd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a), c);
        } else if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i > 1) {
            m = new $61de1ee1cac498ae$var$Oyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a));
            while(m.e != m.i.gc())$61de1ee1cac498ae$var$Eyd(m);
        }
        $61de1ee1cac498ae$var$ifd(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a), 0), 202));
    }
    if (l) for(d = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a)); d.e != d.i.gc();){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(d), 202);
        for(j = new $61de1ee1cac498ae$var$Fyd((!c.a && (c.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, c, 5)), c.a)); j.e != j.i.gc();){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(j), 469);
            h.a = $61de1ee1cac498ae$var$$wnd.Math.max(h.a, i.a);
            h.b = $61de1ee1cac498ae$var$$wnd.Math.max(h.b, i.b);
        }
    }
    for(g = new $61de1ee1cac498ae$var$Fyd((!a.n && (a.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, a, 1, 7)), a.n)); g.e != g.i.gc();){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(g), 137);
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(f, $61de1ee1cac498ae$var$Yad), 8);
        !!k && $61de1ee1cac498ae$var$bld(f, k.a, k.b);
        if (l) {
            h.a = $61de1ee1cac498ae$var$$wnd.Math.max(h.a, f.i + f.g);
            h.b = $61de1ee1cac498ae$var$$wnd.Math.max(h.b, f.j + f.f);
        }
    }
    return h;
}
function $61de1ee1cac498ae$var$yMc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    t = b.c.length;
    e = new $61de1ee1cac498ae$var$ULc(a.a, c, null, null);
    B = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, t, 15, 1);
    p = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, t, 15, 1);
    o = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, t, 15, 1);
    q = 0;
    for(h = 0; h < t; h++){
        p[h] = $61de1ee1cac498ae$var$Ohe;
        o[h] = $61de1ee1cac498ae$var$Rie;
    }
    for(i = 0; i < t; i++){
        d = ($61de1ee1cac498ae$var$tCb(i, b.c.length), $61de1ee1cac498ae$var$BD(b.c[i], 180));
        B[i] = $61de1ee1cac498ae$var$SLc(d);
        B[q] > B[i] && (q = i);
        for(l = new $61de1ee1cac498ae$var$olb(a.a.b); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 29);
            for(s = new $61de1ee1cac498ae$var$olb(k.a); s.a < s.c.c.length;){
                r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(s), 10);
                w = $61de1ee1cac498ae$var$Edb(d.p[r.p]) + $61de1ee1cac498ae$var$Edb(d.d[r.p]);
                p[i] = $61de1ee1cac498ae$var$$wnd.Math.min(p[i], w);
                o[i] = $61de1ee1cac498ae$var$$wnd.Math.max(o[i], w + r.o.b);
            }
        }
    }
    A = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, t, 15, 1);
    for(j = 0; j < t; j++)($61de1ee1cac498ae$var$tCb(j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[j], 180)).o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$cMc) ? A[j] = p[q] - p[j] : A[j] = o[q] - o[j];
    f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, t, 15, 1);
    for(n = new $61de1ee1cac498ae$var$olb(a.a.b); n.a < n.c.c.length;){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 29);
        for(v = new $61de1ee1cac498ae$var$olb(m.a); v.a < v.c.c.length;){
            u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(v), 10);
            for(g = 0; g < t; g++)f[g] = $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$tCb(g, b.c.length), $61de1ee1cac498ae$var$BD(b.c[g], 180)).p[u.p]) + $61de1ee1cac498ae$var$Edb(($61de1ee1cac498ae$var$tCb(g, b.c.length), $61de1ee1cac498ae$var$BD(b.c[g], 180)).d[u.p]) + A[g];
            f.sort($61de1ee1cac498ae$var$dcb($61de1ee1cac498ae$var$Ylb.prototype.te, $61de1ee1cac498ae$var$Ylb, []));
            e.p[u.p] = (f[1] + f[2]) / 2;
            e.d[u.p] = 0;
        }
    }
    return e;
}
function $61de1ee1cac498ae$var$G3b(a, b, c) {
    var d, e, f, g, h;
    d = b.i;
    f = a.i.o;
    e = a.i.d;
    h = a.n;
    g = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        h,
        a.a
    ]));
    switch(a.j.g){
        case 1:
            $61de1ee1cac498ae$var$_Hb(b, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb));
            d.d = -e.d - c - d.a;
            if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.d, 0), 181).We(($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ssc)), 285) == ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd)) {
                $61de1ee1cac498ae$var$$Hb(b, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
                d.c = g.a - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) - c - d.b;
            } else {
                $61de1ee1cac498ae$var$$Hb(b, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb));
                d.c = g.a + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) + c;
            }
            break;
        case 2:
            $61de1ee1cac498ae$var$$Hb(b, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb));
            d.c = f.a + e.c + c;
            if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.d, 0), 181).We(($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ssc)), 285) == ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd)) {
                $61de1ee1cac498ae$var$_Hb(b, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb));
                d.d = g.b - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) - c - d.a;
            } else {
                $61de1ee1cac498ae$var$_Hb(b, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb));
                d.d = g.b + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) + c;
            }
            break;
        case 3:
            $61de1ee1cac498ae$var$_Hb(b, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb));
            d.d = f.b + e.a + c;
            if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.d, 0), 181).We(($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ssc)), 285) == ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd)) {
                $61de1ee1cac498ae$var$$Hb(b, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
                d.c = g.a - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) - c - d.b;
            } else {
                $61de1ee1cac498ae$var$$Hb(b, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb));
                d.c = g.a + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) + c;
            }
            break;
        case 4:
            $61de1ee1cac498ae$var$$Hb(b, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
            d.c = -e.b - c - d.b;
            if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.d, 0), 181).We(($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ssc)), 285) == ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$nbd)) {
                $61de1ee1cac498ae$var$_Hb(b, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb));
                d.d = g.b - $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) - c - d.a;
            } else {
                $61de1ee1cac498ae$var$_Hb(b, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb));
                d.d = g.b + $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Ysc))) + c;
            }
    }
}
function $61de1ee1cac498ae$var$ded(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    n = 0;
    D = 0;
    for(i = new $61de1ee1cac498ae$var$olb(a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 33);
        $61de1ee1cac498ae$var$zfd(h);
        n = $61de1ee1cac498ae$var$$wnd.Math.max(n, h.g);
        D += h.g * h.f;
    }
    o = D / a.c.length;
    C = $61de1ee1cac498ae$var$$dd(a, o);
    D += a.c.length * C;
    n = $61de1ee1cac498ae$var$$wnd.Math.max(n, $61de1ee1cac498ae$var$$wnd.Math.sqrt(D * g)) + c.b;
    H = c.b;
    I = c.d;
    m = 0;
    k = c.b + c.c;
    B = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$Dsb(B, $61de1ee1cac498ae$var$meb(0));
    w = new $61de1ee1cac498ae$var$Psb;
    j = new $61de1ee1cac498ae$var$Bib(a, 0);
    while(j.b < j.d.gc()){
        h = ($61de1ee1cac498ae$var$sCb(j.b < j.d.gc()), $61de1ee1cac498ae$var$BD(j.d.Xb(j.c = j.b++), 33));
        G = h.g;
        l = h.f;
        if (H + G > n) {
            if (f) {
                $61de1ee1cac498ae$var$Fsb(w, m);
                $61de1ee1cac498ae$var$Fsb(B, $61de1ee1cac498ae$var$meb(j.b - 1));
            }
            H = c.b;
            I += m + b;
            m = 0;
            k = $61de1ee1cac498ae$var$$wnd.Math.max(k, c.b + c.c + G);
        }
        $61de1ee1cac498ae$var$dld(h, H);
        $61de1ee1cac498ae$var$eld(h, I);
        k = $61de1ee1cac498ae$var$$wnd.Math.max(k, H + G + c.c);
        m = $61de1ee1cac498ae$var$$wnd.Math.max(m, l);
        H += G + b;
    }
    k = $61de1ee1cac498ae$var$$wnd.Math.max(k, d);
    F = I + m + c.a;
    if (F < e) {
        m += e - F;
        F = e;
    }
    if (f) {
        H = c.b;
        j = new $61de1ee1cac498ae$var$Bib(a, 0);
        $61de1ee1cac498ae$var$Fsb(B, $61de1ee1cac498ae$var$meb(a.c.length));
        A = $61de1ee1cac498ae$var$Jsb(B, 0);
        r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(A), 19).a;
        $61de1ee1cac498ae$var$Fsb(w, m);
        v = $61de1ee1cac498ae$var$Jsb(w, 0);
        u = 0;
        while(j.b < j.d.gc()){
            if (j.b == r) {
                H = c.b;
                u = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(v)));
                r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(A), 19).a;
            }
            h = ($61de1ee1cac498ae$var$sCb(j.b < j.d.gc()), $61de1ee1cac498ae$var$BD(j.d.Xb(j.c = j.b++), 33));
            s = h.f;
            $61de1ee1cac498ae$var$ald(h, u);
            p = u;
            if (j.b == r) {
                q = k - H - c.c;
                t = h.g;
                $61de1ee1cac498ae$var$cld(h, q);
                $61de1ee1cac498ae$var$Ffd(h, new $61de1ee1cac498ae$var$f7c(q, p), new $61de1ee1cac498ae$var$f7c(t, s));
            }
            H += h.g + b;
        }
    }
    return new $61de1ee1cac498ae$var$f7c(k, F);
}
function $61de1ee1cac498ae$var$_Yb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    $61de1ee1cac498ae$var$Odd(b, "Compound graph postprocessor", 1);
    c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Byc))));
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$zsc)), 224);
    k = new $61de1ee1cac498ae$var$Tqb;
    for(r = h.ec().Kc(); r.Ob();){
        q = $61de1ee1cac498ae$var$BD(r.Pb(), 17);
        g = new $61de1ee1cac498ae$var$Tkb(h.cc(q));
        $61de1ee1cac498ae$var$mmb();
        $61de1ee1cac498ae$var$Okb(g, new $61de1ee1cac498ae$var$EZb(a));
        v = $61de1ee1cac498ae$var$zZb(($61de1ee1cac498ae$var$tCb(0, g.c.length), $61de1ee1cac498ae$var$BD(g.c[0], 243)));
        A = $61de1ee1cac498ae$var$AZb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g, g.c.length - 1), 243));
        t = v.i;
        $61de1ee1cac498ae$var$f_b(A.i, t) ? s = t.e : s = $61de1ee1cac498ae$var$Q_b(t);
        l = $61de1ee1cac498ae$var$aZb(q, g);
        $61de1ee1cac498ae$var$Osb(q.a);
        m = null;
        for(f = new $61de1ee1cac498ae$var$olb(g); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 243);
            p = new $61de1ee1cac498ae$var$d7c;
            $61de1ee1cac498ae$var$Y$b(p, e.a, s);
            n = e.b;
            d = new $61de1ee1cac498ae$var$s7c;
            $61de1ee1cac498ae$var$o7c(d, 0, n.a);
            $61de1ee1cac498ae$var$q7c(d, p);
            u = new $61de1ee1cac498ae$var$g7c($61de1ee1cac498ae$var$A0b(n.c));
            w = new $61de1ee1cac498ae$var$g7c($61de1ee1cac498ae$var$A0b(n.d));
            $61de1ee1cac498ae$var$P6c(u, p);
            $61de1ee1cac498ae$var$P6c(w, p);
            if (m) {
                d.b == 0 ? o = w : o = ($61de1ee1cac498ae$var$sCb(d.b != 0), $61de1ee1cac498ae$var$BD(d.a.a.c, 8));
                B = $61de1ee1cac498ae$var$$wnd.Math.abs(m.a - o.a) > $61de1ee1cac498ae$var$qme;
                C = $61de1ee1cac498ae$var$$wnd.Math.abs(m.b - o.b) > $61de1ee1cac498ae$var$qme;
                (!c && B && C || c && (B || C)) && $61de1ee1cac498ae$var$Dsb(q.a, u);
            }
            $61de1ee1cac498ae$var$ye(q.a, d);
            d.b == 0 ? m = u : m = ($61de1ee1cac498ae$var$sCb(d.b != 0), $61de1ee1cac498ae$var$BD(d.c.b.c, 8));
            $61de1ee1cac498ae$var$bZb(n, l, p);
            if ($61de1ee1cac498ae$var$AZb(e) == A) {
                if ($61de1ee1cac498ae$var$Q_b(A.i) != e.a) {
                    p = new $61de1ee1cac498ae$var$d7c;
                    $61de1ee1cac498ae$var$Y$b(p, $61de1ee1cac498ae$var$Q_b(A.i), s);
                }
                $61de1ee1cac498ae$var$yNb(q, $61de1ee1cac498ae$var$utc, p);
            }
            $61de1ee1cac498ae$var$cZb(n, q, s);
            k.a.zc(n, k);
        }
        $61de1ee1cac498ae$var$QZb(q, v);
        $61de1ee1cac498ae$var$RZb(q, A);
    }
    for(j = k.a.ec().Kc(); j.Ob();){
        i = $61de1ee1cac498ae$var$BD(j.Pb(), 17);
        $61de1ee1cac498ae$var$QZb(i, null);
        $61de1ee1cac498ae$var$RZb(i, null);
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$KQb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    if (a.gc() == 1) return $61de1ee1cac498ae$var$BD(a.Xb(0), 231);
    else if (a.gc() <= 0) return new $61de1ee1cac498ae$var$kRb;
    for(e = a.Kc(); e.Ob();){
        c = $61de1ee1cac498ae$var$BD(e.Pb(), 231);
        o = 0;
        k = $61de1ee1cac498ae$var$Ohe;
        l = $61de1ee1cac498ae$var$Ohe;
        i = $61de1ee1cac498ae$var$Rie;
        j = $61de1ee1cac498ae$var$Rie;
        for(n = new $61de1ee1cac498ae$var$olb(c.e); n.a < n.c.c.length;){
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 144);
            o += $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(m, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$oSb)), 19).a;
            k = $61de1ee1cac498ae$var$$wnd.Math.min(k, m.d.a - m.e.a / 2);
            l = $61de1ee1cac498ae$var$$wnd.Math.min(l, m.d.b - m.e.b / 2);
            i = $61de1ee1cac498ae$var$$wnd.Math.max(i, m.d.a + m.e.a / 2);
            j = $61de1ee1cac498ae$var$$wnd.Math.max(j, m.d.b + m.e.b / 2);
        }
        $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$oSb), $61de1ee1cac498ae$var$meb(o));
        $61de1ee1cac498ae$var$yNb(c, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$ESb), new $61de1ee1cac498ae$var$f7c(k, l));
        $61de1ee1cac498ae$var$yNb(c, $61de1ee1cac498ae$var$DSb, new $61de1ee1cac498ae$var$f7c(i, j));
    }
    $61de1ee1cac498ae$var$mmb();
    a.ad(new $61de1ee1cac498ae$var$OQb);
    p = new $61de1ee1cac498ae$var$kRb;
    $61de1ee1cac498ae$var$tNb(p, $61de1ee1cac498ae$var$BD(a.Xb(0), 94));
    h = 0;
    s = 0;
    for(f = a.Kc(); f.Ob();){
        c = $61de1ee1cac498ae$var$BD(f.Pb(), 231);
        q = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$DSb)), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$ESb), 8));
        h = $61de1ee1cac498ae$var$$wnd.Math.max(h, q.a);
        s += q.a * q.b;
    }
    h = $61de1ee1cac498ae$var$$wnd.Math.max(h, $61de1ee1cac498ae$var$$wnd.Math.sqrt(s) * $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(p, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$bSb)))));
    r = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(p, $61de1ee1cac498ae$var$uSb)));
    t = 0;
    u = 0;
    g = 0;
    b = r;
    for(d = a.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 231);
        q = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$HSb(), $61de1ee1cac498ae$var$DSb)), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$ESb), 8));
        if (t + q.a > h) {
            t = 0;
            u += g + r;
            g = 0;
        }
        $61de1ee1cac498ae$var$JQb(p, c, t, u);
        b = $61de1ee1cac498ae$var$$wnd.Math.max(b, t + q.a);
        g = $61de1ee1cac498ae$var$$wnd.Math.max(g, q.b);
        t += q.a + r;
    }
    return p;
}
function $61de1ee1cac498ae$var$Ioc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    k = new $61de1ee1cac498ae$var$s7c;
    switch(a.a.g){
        case 3:
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$rtc)), 15);
            n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$rtc), 15);
            o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.f, $61de1ee1cac498ae$var$rtc), 15);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.e, $61de1ee1cac498ae$var$ptc), 15);
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$ptc), 15);
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.f, $61de1ee1cac498ae$var$ptc), 15);
            g = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$Gkb(g, m);
            n.Jc(new $61de1ee1cac498ae$var$Loc);
            $61de1ee1cac498ae$var$Gkb(g, $61de1ee1cac498ae$var$JD(n, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(n, 152)) : $61de1ee1cac498ae$var$JD(n, 131) ? $61de1ee1cac498ae$var$BD(n, 131).a : $61de1ee1cac498ae$var$JD(n, 54) ? new $61de1ee1cac498ae$var$ov(n) : new $61de1ee1cac498ae$var$dv(n));
            $61de1ee1cac498ae$var$Gkb(g, o);
            f = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$Gkb(f, c);
            $61de1ee1cac498ae$var$Gkb(f, $61de1ee1cac498ae$var$JD(d, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(d, 152)) : $61de1ee1cac498ae$var$JD(d, 131) ? $61de1ee1cac498ae$var$BD(d, 131).a : $61de1ee1cac498ae$var$JD(d, 54) ? new $61de1ee1cac498ae$var$ov(d) : new $61de1ee1cac498ae$var$dv(d));
            $61de1ee1cac498ae$var$Gkb(f, e);
            $61de1ee1cac498ae$var$yNb(b.f, $61de1ee1cac498ae$var$rtc, g);
            $61de1ee1cac498ae$var$yNb(b.f, $61de1ee1cac498ae$var$ptc, f);
            $61de1ee1cac498ae$var$yNb(b.f, $61de1ee1cac498ae$var$stc, b.f);
            $61de1ee1cac498ae$var$yNb(b.e, $61de1ee1cac498ae$var$rtc, null);
            $61de1ee1cac498ae$var$yNb(b.e, $61de1ee1cac498ae$var$ptc, null);
            $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$rtc, null);
            $61de1ee1cac498ae$var$yNb(b.j, $61de1ee1cac498ae$var$ptc, null);
            break;
        case 1:
            $61de1ee1cac498ae$var$ye(k, b.e.a);
            $61de1ee1cac498ae$var$Dsb(k, b.i.n);
            $61de1ee1cac498ae$var$ye(k, $61de1ee1cac498ae$var$Su(b.j.a));
            $61de1ee1cac498ae$var$Dsb(k, b.a.n);
            $61de1ee1cac498ae$var$ye(k, b.f.a);
            break;
        default:
            $61de1ee1cac498ae$var$ye(k, b.e.a);
            $61de1ee1cac498ae$var$ye(k, $61de1ee1cac498ae$var$Su(b.j.a));
            $61de1ee1cac498ae$var$ye(k, b.f.a);
    }
    $61de1ee1cac498ae$var$Osb(b.f.a);
    $61de1ee1cac498ae$var$ye(b.f.a, k);
    $61de1ee1cac498ae$var$QZb(b.f, b.e.c);
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.e, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.j, $61de1ee1cac498ae$var$jxc), 74);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b.f, $61de1ee1cac498ae$var$jxc), 74);
    if (!!h || !!j || !!i) {
        l = new $61de1ee1cac498ae$var$s7c;
        $61de1ee1cac498ae$var$Goc(l, i);
        $61de1ee1cac498ae$var$Goc(l, j);
        $61de1ee1cac498ae$var$Goc(l, h);
        $61de1ee1cac498ae$var$yNb(b.f, $61de1ee1cac498ae$var$jxc, l);
    }
    $61de1ee1cac498ae$var$QZb(b.j, null);
    $61de1ee1cac498ae$var$RZb(b.j, null);
    $61de1ee1cac498ae$var$QZb(b.e, null);
    $61de1ee1cac498ae$var$RZb(b.e, null);
    $61de1ee1cac498ae$var$$_b(b.a, null);
    $61de1ee1cac498ae$var$$_b(b.i, null);
    !!b.g && $61de1ee1cac498ae$var$Ioc(a, b.g);
}
function $61de1ee1cac498ae$var$bde(a) {
    $61de1ee1cac498ae$var$ade();
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if (a == null) return null;
    f = $61de1ee1cac498ae$var$rfb(a);
    o = $61de1ee1cac498ae$var$ede(f);
    if (o % 4 != 0) return null;
    p = o / 4 | 0;
    if (p == 0) return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, 0, 15, 1);
    l = null;
    b = 0;
    c = 0;
    d = 0;
    e = 0;
    g = 0;
    h = 0;
    i = 0;
    j = 0;
    n = 0;
    m = 0;
    k = 0;
    l = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, p * 3, 15, 1);
    for(; n < p - 1; n++){
        if (!$61de1ee1cac498ae$var$dde(g = f[k++]) || !$61de1ee1cac498ae$var$dde(h = f[k++]) || !$61de1ee1cac498ae$var$dde(i = f[k++]) || !$61de1ee1cac498ae$var$dde(j = f[k++])) return null;
        b = $61de1ee1cac498ae$var$$ce[g];
        c = $61de1ee1cac498ae$var$$ce[h];
        d = $61de1ee1cac498ae$var$$ce[i];
        e = $61de1ee1cac498ae$var$$ce[j];
        l[m++] = (b << 2 | c >> 4) << 24 >> 24;
        l[m++] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
        l[m++] = (d << 6 | e) << 24 >> 24;
    }
    if (!$61de1ee1cac498ae$var$dde(g = f[k++]) || !$61de1ee1cac498ae$var$dde(h = f[k++])) return null;
    b = $61de1ee1cac498ae$var$$ce[g];
    c = $61de1ee1cac498ae$var$$ce[h];
    i = f[k++];
    j = f[k++];
    if ($61de1ee1cac498ae$var$$ce[i] == -1 || $61de1ee1cac498ae$var$$ce[j] == -1) {
        if (i == 61 && j == 61) {
            if ((c & 15) != 0) return null;
            q = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, n * 3 + 1, 15, 1);
            $61de1ee1cac498ae$var$$fb(l, 0, q, 0, n * 3);
            q[m] = (b << 2 | c >> 4) << 24 >> 24;
            return q;
        } else if (i != 61 && j == 61) {
            d = $61de1ee1cac498ae$var$$ce[i];
            if ((d & 3) != 0) return null;
            q = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, n * 3 + 2, 15, 1);
            $61de1ee1cac498ae$var$$fb(l, 0, q, 0, n * 3);
            q[m++] = (b << 2 | c >> 4) << 24 >> 24;
            q[m] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
            return q;
        } else return null;
    } else {
        d = $61de1ee1cac498ae$var$$ce[i];
        e = $61de1ee1cac498ae$var$$ce[j];
        l[m++] = (b << 2 | c >> 4) << 24 >> 24;
        l[m++] = ((c & 15) << 4 | d >> 2 & 15) << 24 >> 24;
        l[m++] = (d << 6 | e) << 24 >> 24;
    }
    return l;
}
function $61de1ee1cac498ae$var$Sbc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    $61de1ee1cac498ae$var$Odd(b, $61de1ee1cac498ae$var$Ine, 1);
    o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Swc)), 218);
    for(e = new $61de1ee1cac498ae$var$olb(a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 29);
        j = $61de1ee1cac498ae$var$l_b(d.a);
        for(g = j, h = 0, i = g.length; h < i; ++h){
            f = g[h];
            if (f.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b)) continue;
            if (o == ($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$yad)) for(l = new $61de1ee1cac498ae$var$olb(f.j); l.a < l.c.c.length;){
                k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 11);
                k.e.c.length == 0 || $61de1ee1cac498ae$var$Vbc(k);
                k.g.c.length == 0 || $61de1ee1cac498ae$var$Wbc(k);
            }
            else if ($61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$vNb(f, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 17)) {
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$$sc), 17);
                r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Y_b(f, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd)).Kc().Pb(), 11);
                s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Y_b(f, $61de1ee1cac498ae$var$zcd).Kc().Pb(), 11);
                t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(r, $61de1ee1cac498ae$var$$sc), 11);
                u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(s, $61de1ee1cac498ae$var$$sc), 11);
                $61de1ee1cac498ae$var$QZb(q, u);
                $61de1ee1cac498ae$var$RZb(q, t);
                v = new $61de1ee1cac498ae$var$g7c(s.i.n);
                v.a = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    u.i.n,
                    u.n,
                    u.a
                ])).a;
                $61de1ee1cac498ae$var$Dsb(q.a, v);
                v = new $61de1ee1cac498ae$var$g7c(r.i.n);
                v.a = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    t.i.n,
                    t.n,
                    t.a
                ])).a;
                $61de1ee1cac498ae$var$Dsb(q.a, v);
            } else {
                if (f.j.c.length >= 2) {
                    p = true;
                    m = new $61de1ee1cac498ae$var$olb(f.j);
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 11);
                    n = null;
                    while(m.a < m.c.c.length){
                        n = c;
                        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 11);
                        if (!$61de1ee1cac498ae$var$pb($61de1ee1cac498ae$var$vNb(n, $61de1ee1cac498ae$var$$sc), $61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$$sc))) {
                            p = false;
                            break;
                        }
                    }
                } else p = false;
                for(l = new $61de1ee1cac498ae$var$olb(f.j); l.a < l.c.c.length;){
                    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 11);
                    k.e.c.length == 0 || $61de1ee1cac498ae$var$Tbc(k, p);
                    k.g.c.length == 0 || $61de1ee1cac498ae$var$Ubc(k, p);
                }
            }
            $61de1ee1cac498ae$var$$_b(f, null);
        }
    }
    $61de1ee1cac498ae$var$Qdd(b);
}
function $61de1ee1cac498ae$var$KJc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    t = a.c[($61de1ee1cac498ae$var$tCb(0, b.c.length), $61de1ee1cac498ae$var$BD(b.c[0], 17)).p];
    A = a.c[($61de1ee1cac498ae$var$tCb(1, b.c.length), $61de1ee1cac498ae$var$BD(b.c[1], 17)).p];
    if (t.a.e.e - t.a.a - (t.b.e.e - t.b.a) == 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) == 0) return false;
    r = t.b.e.f;
    if (!$61de1ee1cac498ae$var$JD(r, 10)) return false;
    q = $61de1ee1cac498ae$var$BD(r, 10);
    v = a.i[q.p];
    w = !q.c ? -1 : $61de1ee1cac498ae$var$Jkb(q.c.a, q, 0);
    f = $61de1ee1cac498ae$var$Pje;
    if (w > 0) {
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(q.c.a, w - 1), 10);
        g = a.i[e.p];
        B = $61de1ee1cac498ae$var$$wnd.Math.ceil($61de1ee1cac498ae$var$jBc(a.n, e, q));
        f = v.a.e - q.d.d - (g.a.e + e.o.b + e.d.a) - B;
    }
    j = $61de1ee1cac498ae$var$Pje;
    if (w < q.c.a.c.length - 1) {
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(q.c.a, w + 1), 10);
        k = a.i[i.p];
        B = $61de1ee1cac498ae$var$$wnd.Math.ceil($61de1ee1cac498ae$var$jBc(a.n, i, q));
        j = k.a.e - i.d.d - (v.a.e + q.o.b + q.d.a) - B;
    }
    if (c && ($61de1ee1cac498ae$var$Iy(), $61de1ee1cac498ae$var$My($61de1ee1cac498ae$var$Jqe), $61de1ee1cac498ae$var$$wnd.Math.abs(f - j) <= $61de1ee1cac498ae$var$Jqe || f == j || isNaN(f) && isNaN(j))) return true;
    d = $61de1ee1cac498ae$var$gKc(t.a);
    h = -$61de1ee1cac498ae$var$gKc(t.b);
    l = -$61de1ee1cac498ae$var$gKc(A.a);
    s = $61de1ee1cac498ae$var$gKc(A.b);
    p = t.a.e.e - t.a.a - (t.b.e.e - t.b.a) > 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) < 0;
    o = t.a.e.e - t.a.a - (t.b.e.e - t.b.a) < 0 && A.a.e.e - A.a.a - (A.b.e.e - A.b.a) > 0;
    n = t.a.e.e + t.b.a < A.b.e.e + A.a.a;
    m = t.a.e.e + t.b.a > A.b.e.e + A.a.a;
    u = 0;
    !p && !o && (m ? f + l > 0 ? u = l : j - d > 0 && (u = d) : n && (f + h > 0 ? u = h : j - s > 0 && (u = s)));
    v.a.e += u;
    v.b && (v.d.e += u);
    return false;
}
function $61de1ee1cac498ae$var$XGb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    d = new $61de1ee1cac498ae$var$J6c(b.qf().a, b.qf().b, b.rf().a, b.rf().b);
    e = new $61de1ee1cac498ae$var$I6c;
    if (a.c) for(g = new $61de1ee1cac498ae$var$olb(b.wf()); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 181);
        e.c = f.qf().a + b.qf().a;
        e.d = f.qf().b + b.qf().b;
        e.b = f.rf().a;
        e.a = f.rf().b;
        $61de1ee1cac498ae$var$H6c(d, e);
    }
    for(j = new $61de1ee1cac498ae$var$olb(b.Cf()); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 838);
        k = i.qf().a + b.qf().a;
        l = i.qf().b + b.qf().b;
        if (a.e) {
            e.c = k;
            e.d = l;
            e.b = i.rf().a;
            e.a = i.rf().b;
            $61de1ee1cac498ae$var$H6c(d, e);
        }
        if (a.d) for(g = new $61de1ee1cac498ae$var$olb(i.wf()); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 181);
            e.c = f.qf().a + k;
            e.d = f.qf().b + l;
            e.b = f.rf().a;
            e.a = f.rf().b;
            $61de1ee1cac498ae$var$H6c(d, e);
        }
        if (a.b) {
            m = new $61de1ee1cac498ae$var$f7c(-c, -c);
            if ($61de1ee1cac498ae$var$BD(b.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$x9c)), 174).Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$pcd))) for(g = new $61de1ee1cac498ae$var$olb(i.wf()); g.a < g.c.c.length;){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 181);
                m.a += f.rf().a + c;
                m.b += f.rf().b + c;
            }
            m.a = $61de1ee1cac498ae$var$$wnd.Math.max(m.a, 0);
            m.b = $61de1ee1cac498ae$var$$wnd.Math.max(m.b, 0);
            $61de1ee1cac498ae$var$VGb(d, i.Bf(), i.zf(), b, i, m, c);
        }
    }
    a.b && $61de1ee1cac498ae$var$VGb(d, b.Bf(), b.zf(), b, null, null, c);
    h = new $61de1ee1cac498ae$var$K_b(b.Af());
    h.d = $61de1ee1cac498ae$var$$wnd.Math.max(0, b.qf().b - d.d);
    h.a = $61de1ee1cac498ae$var$$wnd.Math.max(0, d.d + d.a - (b.qf().b + b.rf().b));
    h.b = $61de1ee1cac498ae$var$$wnd.Math.max(0, b.qf().a - d.c);
    h.c = $61de1ee1cac498ae$var$$wnd.Math.max(0, d.c + d.b - (b.qf().a + b.rf().a));
    b.Ef(h);
}
function $61de1ee1cac498ae$var$wz() {
    var a = [
        "\\u0000",
        "\\u0001",
        "\\u0002",
        "\\u0003",
        "\\u0004",
        "\\u0005",
        "\\u0006",
        "\\u0007",
        "\\b",
        "\\t",
        "\\n",
        "\\u000B",
        "\\f",
        "\\r",
        "\\u000E",
        "\\u000F",
        "\\u0010",
        "\\u0011",
        "\\u0012",
        "\\u0013",
        "\\u0014",
        "\\u0015",
        "\\u0016",
        "\\u0017",
        "\\u0018",
        "\\u0019",
        "\\u001A",
        "\\u001B",
        "\\u001C",
        "\\u001D",
        "\\u001E",
        "\\u001F"
    ];
    a[34] = '\\"';
    a[92] = "\\\\";
    a[173] = "\\u00ad";
    a[1536] = "\\u0600";
    a[1537] = "\\u0601";
    a[1538] = "\\u0602";
    a[1539] = "\\u0603";
    a[1757] = "\\u06dd";
    a[1807] = "\\u070f";
    a[6068] = "\\u17b4";
    a[6069] = "\\u17b5";
    a[8203] = "\\u200b";
    a[8204] = "\\u200c";
    a[8205] = "\\u200d";
    a[8206] = "\\u200e";
    a[8207] = "\\u200f";
    a[8232] = "\\u2028";
    a[8233] = "\\u2029";
    a[8234] = "\\u202a";
    a[8235] = "\\u202b";
    a[8236] = "\\u202c";
    a[8237] = "\\u202d";
    a[8238] = "\\u202e";
    a[8288] = "\\u2060";
    a[8289] = "\\u2061";
    a[8290] = "\\u2062";
    a[8291] = "\\u2063";
    a[8292] = "\\u2064";
    a[8298] = "\\u206a";
    a[8299] = "\\u206b";
    a[8300] = "\\u206c";
    a[8301] = "\\u206d";
    a[8302] = "\\u206e";
    a[8303] = "\\u206f";
    a[65279] = "\\ufeff";
    a[65529] = "\\ufff9";
    a[65530] = "\\ufffa";
    a[65531] = "\\ufffb";
    return a;
}
function $61de1ee1cac498ae$var$pid(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m;
    i = new $61de1ee1cac498ae$var$Rkb;
    l = b.length;
    g = $61de1ee1cac498ae$var$AUd(c);
    for(j = 0; j < l; ++j){
        k = $61de1ee1cac498ae$var$ifb(b, $61de1ee1cac498ae$var$wfb(61), j);
        d = $61de1ee1cac498ae$var$$hd(g, b.substr(j, k - j));
        e = $61de1ee1cac498ae$var$KJd(d);
        f = e.Aj().Nh();
        switch($61de1ee1cac498ae$var$bfb(b, ++k)){
            case 39:
                h = $61de1ee1cac498ae$var$gfb(b, 39, ++k);
                $61de1ee1cac498ae$var$Ekb(i, new $61de1ee1cac498ae$var$kGd(d, $61de1ee1cac498ae$var$Pid(b.substr(k, h - k), f, e)));
                j = h + 1;
                break;
            case 34:
                h = $61de1ee1cac498ae$var$gfb(b, 34, ++k);
                $61de1ee1cac498ae$var$Ekb(i, new $61de1ee1cac498ae$var$kGd(d, $61de1ee1cac498ae$var$Pid(b.substr(k, h - k), f, e)));
                j = h + 1;
                break;
            case 91:
                m = new $61de1ee1cac498ae$var$Rkb;
                $61de1ee1cac498ae$var$Ekb(i, new $61de1ee1cac498ae$var$kGd(d, m));
                n: for(;;){
                    switch($61de1ee1cac498ae$var$bfb(b, ++k)){
                        case 39:
                            h = $61de1ee1cac498ae$var$gfb(b, 39, ++k);
                            $61de1ee1cac498ae$var$Ekb(m, $61de1ee1cac498ae$var$Pid(b.substr(k, h - k), f, e));
                            k = h + 1;
                            break;
                        case 34:
                            h = $61de1ee1cac498ae$var$gfb(b, 34, ++k);
                            $61de1ee1cac498ae$var$Ekb(m, $61de1ee1cac498ae$var$Pid(b.substr(k, h - k), f, e));
                            k = h + 1;
                            break;
                        case 110:
                            ++k;
                            if (b.indexOf("ull", k) == k) m.c[m.c.length] = null;
                            else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz($61de1ee1cac498ae$var$kte));
                            k += 3;
                            break;
                    }
                    if (k < l) switch($61de1ee1cac498ae$var$BCb(k, b.length), b.charCodeAt(k)){
                        case 44:
                            break;
                        case 93:
                            break n;
                        default:
                            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Expecting , or ]"));
                    }
                    else break;
                }
                j = k + 1;
                break;
            case 110:
                ++k;
                if (b.indexOf("ull", k) == k) $61de1ee1cac498ae$var$Ekb(i, new $61de1ee1cac498ae$var$kGd(d, null));
                else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz($61de1ee1cac498ae$var$kte));
                j = k + 3;
                break;
        }
        if (j < l) {
            $61de1ee1cac498ae$var$BCb(j, b.length);
            if (b.charCodeAt(j) != 44) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Expecting ,"));
        } else break;
    }
    return $61de1ee1cac498ae$var$qid(a, i, c);
}
function $61de1ee1cac498ae$var$AKb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(a.r, b), 21), 84);
    g = $61de1ee1cac498ae$var$bKb(a, b);
    c = a.u.Hc(($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$lcd));
    for(i = j.Kc(); i.Ob();){
        h = $61de1ee1cac498ae$var$BD(i.Pb(), 111);
        if (!h.c || h.c.d.c.length <= 0) continue;
        m = h.b.rf();
        k = h.c;
        l = k.i;
        l.b = (f = k.n, k.e.a + f.b + f.c);
        l.a = (e = k.n, k.e.b + e.d + e.a);
        switch(b.g){
            case 1:
                if (h.a) {
                    l.c = (m.a - l.b) / 2;
                    $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$KHb));
                } else if (g || c) {
                    l.c = -l.b - a.s;
                    $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
                } else {
                    l.c = m.a + a.s;
                    $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb));
                }
                l.d = -l.a - a.t;
                $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb));
                break;
            case 3:
                if (h.a) {
                    l.c = (m.a - l.b) / 2;
                    $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$KHb));
                } else if (g || c) {
                    l.c = -l.b - a.s;
                    $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
                } else {
                    l.c = m.a + a.s;
                    $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb));
                }
                l.d = m.b + a.t;
                $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb));
                break;
            case 2:
                if (h.a) {
                    d = a.v ? l.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k.d, 0), 181).rf().b;
                    l.d = (m.b - d) / 2;
                    $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$CIb));
                } else if (g || c) {
                    l.d = -l.a - a.t;
                    $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb));
                } else {
                    l.d = m.b + a.t;
                    $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb));
                }
                l.c = m.a + a.s;
                $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb));
                break;
            case 4:
                if (h.a) {
                    d = a.v ? l.a : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k.d, 0), 181).rf().b;
                    l.d = (m.b - d) / 2;
                    $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$CIb));
                } else if (g || c) {
                    l.d = -l.a - a.t;
                    $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb));
                } else {
                    l.d = m.b + a.t;
                    $61de1ee1cac498ae$var$_Hb(k, ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$DIb));
                }
                l.c = -l.b - a.s;
                $61de1ee1cac498ae$var$$Hb(k, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$MHb));
        }
        g = false;
    }
}
function $61de1ee1cac498ae$var$Kfe(a, b) {
    $61de1ee1cac498ae$var$wfe();
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    if ($61de1ee1cac498ae$var$Vhb($61de1ee1cac498ae$var$Zee) == 0) {
        l = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$lbb, $61de1ee1cac498ae$var$nie, 117, $61de1ee1cac498ae$var$_ee.length, 0, 1);
        for(g = 0; g < l.length; g++)l[g] = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        d = new $61de1ee1cac498ae$var$Ifb;
        for(f = 0; f < $61de1ee1cac498ae$var$Yee.length; f++){
            k = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
            if (f < 84) {
                h = f * 2;
                n = ($61de1ee1cac498ae$var$BCb(h, $61de1ee1cac498ae$var$wxe.length), $61de1ee1cac498ae$var$wxe.charCodeAt(h));
                m = ($61de1ee1cac498ae$var$BCb(h + 1, $61de1ee1cac498ae$var$wxe.length), $61de1ee1cac498ae$var$wxe.charCodeAt(h + 1));
                $61de1ee1cac498ae$var$Ufe(k, n, m);
            } else {
                h = (f - 84) * 2;
                $61de1ee1cac498ae$var$Ufe(k, $61de1ee1cac498ae$var$afe[h], $61de1ee1cac498ae$var$afe[h + 1]);
            }
            i = $61de1ee1cac498ae$var$Yee[f];
            $61de1ee1cac498ae$var$dfb(i, "Specials") && $61de1ee1cac498ae$var$Ufe(k, 65520, 65533);
            if ($61de1ee1cac498ae$var$dfb(i, $61de1ee1cac498ae$var$uxe)) {
                $61de1ee1cac498ae$var$Ufe(k, 983040, 1048573);
                $61de1ee1cac498ae$var$Ufe(k, 1048576, 1114109);
            }
            $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$Zee, i, k);
            $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$$ee, i, $61de1ee1cac498ae$var$_fe(k));
            j = d.a.length;
            0 < j ? d.a = d.a.substr(0, 0) : 0 > j && (d.a += $61de1ee1cac498ae$var$yfb($61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, -j, 15, 1)));
            d.a += "Is";
            if ($61de1ee1cac498ae$var$hfb(i, $61de1ee1cac498ae$var$wfb(32)) >= 0) for(e = 0; e < i.length; e++){
                $61de1ee1cac498ae$var$BCb(e, i.length);
                i.charCodeAt(e) != 32 && $61de1ee1cac498ae$var$Afb(d, ($61de1ee1cac498ae$var$BCb(e, i.length), i.charCodeAt(e)));
            }
            else d.a += "" + i;
            $61de1ee1cac498ae$var$Ofe(d.a, i, true);
        }
        $61de1ee1cac498ae$var$Ofe($61de1ee1cac498ae$var$vxe, "Cn", false);
        $61de1ee1cac498ae$var$Ofe($61de1ee1cac498ae$var$xxe, "Cn", true);
        c = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ufe(c, 0, $61de1ee1cac498ae$var$lxe);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$Zee, "ALL", c);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$$ee, "ALL", $61de1ee1cac498ae$var$_fe(c));
        !$61de1ee1cac498ae$var$bfe && ($61de1ee1cac498ae$var$bfe = new $61de1ee1cac498ae$var$Lqb);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$bfe, $61de1ee1cac498ae$var$vxe, $61de1ee1cac498ae$var$vxe);
        !$61de1ee1cac498ae$var$bfe && ($61de1ee1cac498ae$var$bfe = new $61de1ee1cac498ae$var$Lqb);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$bfe, $61de1ee1cac498ae$var$xxe, $61de1ee1cac498ae$var$xxe);
        !$61de1ee1cac498ae$var$bfe && ($61de1ee1cac498ae$var$bfe = new $61de1ee1cac498ae$var$Lqb);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$bfe, "ALL", "ALL");
    }
    o = b ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$Zee, a), 136) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$$ee, a), 136);
    return o;
}
function $61de1ee1cac498ae$var$c3b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    m = false;
    l = false;
    if ($61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98))) {
        g = false;
        h = false;
        t: for(o = new $61de1ee1cac498ae$var$olb(d.j); o.a < o.c.c.length;){
            n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 11);
            for(q = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                new $61de1ee1cac498ae$var$J0b(n),
                new $61de1ee1cac498ae$var$R0b(n)
            ]))); $61de1ee1cac498ae$var$Qr(q);){
                p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(q), 11);
                if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(p.i, $61de1ee1cac498ae$var$pwc)))) {
                    if (n.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) {
                        g = true;
                        break t;
                    }
                    if (n.j == $61de1ee1cac498ae$var$Rcd) {
                        h = true;
                        break t;
                    }
                }
            }
        }
        m = h && !g;
        l = g && !h;
    }
    if (!m && !l && d.b.c.length != 0) {
        k = 0;
        for(j = new $61de1ee1cac498ae$var$olb(d.b); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 70);
            k += i.n.b + i.o.b / 2;
        }
        k /= d.b.c.length;
        s = k >= d.o.b / 2;
    } else s = !l;
    if (s) {
        r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vtc)), 15);
        if (!r) {
            f = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$vtc, f);
        } else if (m) f = r;
        else {
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$tsc), 15);
            if (!e) {
                f = new $61de1ee1cac498ae$var$Rkb;
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$tsc, f);
            } else r.gc() <= e.gc() ? f = r : f = e;
        }
    } else {
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$tsc)), 15);
        if (!e) {
            f = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$tsc, f);
        } else if (l) f = e;
        else {
            r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$vtc), 15);
            if (!r) {
                f = new $61de1ee1cac498ae$var$Rkb;
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$vtc, f);
            } else e.gc() <= r.gc() ? f = e : f = r;
        }
    }
    f.Fc(a);
    $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vsc), c);
    if (b.d == c) {
        $61de1ee1cac498ae$var$RZb(b, null);
        c.e.c.length + c.g.c.length == 0 && $61de1ee1cac498ae$var$F0b(c, null);
        $61de1ee1cac498ae$var$d3b(c);
    } else {
        $61de1ee1cac498ae$var$QZb(b, null);
        c.e.c.length + c.g.c.length == 0 && $61de1ee1cac498ae$var$F0b(c, null);
    }
    $61de1ee1cac498ae$var$Osb(b.a);
}
function $61de1ee1cac498ae$var$aoc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
    s = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    k = b.Kc();
    o = 0;
    j = $61de1ee1cac498ae$var$BD(k.Pb(), 19).a;
    v = 0;
    c = new $61de1ee1cac498ae$var$Tqb;
    A = new $61de1ee1cac498ae$var$zsb;
    while(s.b < s.d.gc()){
        r = ($61de1ee1cac498ae$var$sCb(s.b < s.d.gc()), $61de1ee1cac498ae$var$BD(s.d.Xb(s.c = s.b++), 29));
        for(u = new $61de1ee1cac498ae$var$olb(r.a); u.a < u.c.c.length;){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 10);
            for(n = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(t).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(n);){
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(n), 17);
                A.a.zc(l, A);
            }
            for(m = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(t).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(m);){
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(m), 17);
                A.a.Bc(l);
            }
        }
        if (o + 1 == j) {
            e = new $61de1ee1cac498ae$var$H1b(a);
            $61de1ee1cac498ae$var$Aib(s, e);
            f = new $61de1ee1cac498ae$var$H1b(a);
            $61de1ee1cac498ae$var$Aib(s, f);
            for(C = A.a.ec().Kc(); C.Ob();){
                B = $61de1ee1cac498ae$var$BD(C.Pb(), 17);
                if (!c.a._b(B)) {
                    ++v;
                    c.a.zc(B, c);
                }
                g = new $61de1ee1cac498ae$var$b0b(a);
                $61de1ee1cac498ae$var$yNb(g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$acd));
                $61de1ee1cac498ae$var$$_b(g, e);
                $61de1ee1cac498ae$var$__b(g, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$d0b));
                p = new $61de1ee1cac498ae$var$H0b;
                $61de1ee1cac498ae$var$F0b(p, g);
                $61de1ee1cac498ae$var$G0b(p, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
                D = new $61de1ee1cac498ae$var$H0b;
                $61de1ee1cac498ae$var$F0b(D, g);
                $61de1ee1cac498ae$var$G0b(D, $61de1ee1cac498ae$var$zcd);
                d = new $61de1ee1cac498ae$var$b0b(a);
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$Vxc, $61de1ee1cac498ae$var$acd);
                $61de1ee1cac498ae$var$$_b(d, f);
                $61de1ee1cac498ae$var$__b(d, $61de1ee1cac498ae$var$d0b);
                q = new $61de1ee1cac498ae$var$H0b;
                $61de1ee1cac498ae$var$F0b(q, d);
                $61de1ee1cac498ae$var$G0b(q, $61de1ee1cac498ae$var$Tcd);
                F = new $61de1ee1cac498ae$var$H0b;
                $61de1ee1cac498ae$var$F0b(F, d);
                $61de1ee1cac498ae$var$G0b(F, $61de1ee1cac498ae$var$zcd);
                w = new $61de1ee1cac498ae$var$UZb;
                $61de1ee1cac498ae$var$QZb(w, B.c);
                $61de1ee1cac498ae$var$RZb(w, p);
                H = new $61de1ee1cac498ae$var$UZb;
                $61de1ee1cac498ae$var$QZb(H, D);
                $61de1ee1cac498ae$var$RZb(H, q);
                $61de1ee1cac498ae$var$QZb(B, F);
                h = new $61de1ee1cac498ae$var$goc(g, d, w, H, B);
                $61de1ee1cac498ae$var$yNb(g, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$usc), h);
                $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$usc, h);
                G = w.c.i;
                if (G.k == $61de1ee1cac498ae$var$d0b) {
                    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(G, $61de1ee1cac498ae$var$usc), 305);
                    i.d = h;
                    h.g = i;
                }
            }
            if (k.Ob()) j = $61de1ee1cac498ae$var$BD(k.Pb(), 19).a;
            else break;
        }
        ++o;
    }
    return $61de1ee1cac498ae$var$meb(v);
}
function $61de1ee1cac498ae$var$T1b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    l = 0;
    for(e = new $61de1ee1cac498ae$var$Fyd((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a)); e.e != e.i.gc();){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 33);
        if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Jxc))))) {
            if (($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$ywc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$lqc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$jqc)) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Awc))) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$twc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$QXb))) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$xwc)))) {
                $61de1ee1cac498ae$var$jkd(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc), $61de1ee1cac498ae$var$meb(l));
                ++l;
            }
            $61de1ee1cac498ae$var$$1b(a, d, c);
        }
    }
    l = 0;
    for(j = new $61de1ee1cac498ae$var$Fyd((!b.b && (b.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, b, 12, 3)), b.b)); j.e != j.i.gc();){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(j), 79);
        if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ywc))) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$lqc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$jqc)) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Awc))) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$twc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$QXb))) {
            $61de1ee1cac498ae$var$jkd(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc), $61de1ee1cac498ae$var$meb(l));
            ++l;
        }
        o = $61de1ee1cac498ae$var$jtd(h);
        p = $61de1ee1cac498ae$var$ltd(h);
        k = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(o, $61de1ee1cac498ae$var$fxc)));
        n = !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$Jxc)));
        m = k && $61de1ee1cac498ae$var$Qld(h) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$gxc)));
        f = $61de1ee1cac498ae$var$Xod(o) == b && $61de1ee1cac498ae$var$Xod(o) == $61de1ee1cac498ae$var$Xod(p);
        g = ($61de1ee1cac498ae$var$Xod(o) == b && p == b) ^ ($61de1ee1cac498ae$var$Xod(p) == b && o == b);
        n && !m && (g || f) && $61de1ee1cac498ae$var$X1b(a, h, b, c);
    }
    if ($61de1ee1cac498ae$var$Xod(b)) for(i = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Wod($61de1ee1cac498ae$var$Xod(b))); i.e != i.i.gc();){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 79);
        o = $61de1ee1cac498ae$var$jtd(h);
        if (o == b && $61de1ee1cac498ae$var$Qld(h)) {
            m = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(o, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$fxc)))) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$gxc)));
            m && $61de1ee1cac498ae$var$X1b(a, h, b, c);
        }
    }
}
function $61de1ee1cac498ae$var$gDc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    $61de1ee1cac498ae$var$Odd(c, "MinWidth layering", 1);
    n = b.b;
    A = b.a;
    I = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$oxc)), 19).a;
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$pxc), 19).a;
    a.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$lyc)));
    a.d = $61de1ee1cac498ae$var$Pje;
    for(u = new $61de1ee1cac498ae$var$olb(A); u.a < u.c.c.length;){
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 10);
        if (s.k != ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b)) continue;
        D = s.o.b;
        a.d = $61de1ee1cac498ae$var$$wnd.Math.min(a.d, D);
    }
    a.d = $61de1ee1cac498ae$var$$wnd.Math.max(1, a.d);
    B = A.c.length;
    a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, B, 15, 1);
    a.f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, B, 15, 1);
    a.e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, B, 15, 1);
    j = 0;
    a.a = 0;
    for(v = new $61de1ee1cac498ae$var$olb(A); v.a < v.c.c.length;){
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(v), 10);
        s.p = j++;
        a.c[s.p] = $61de1ee1cac498ae$var$eDc($61de1ee1cac498ae$var$R_b(s));
        a.f[s.p] = $61de1ee1cac498ae$var$eDc($61de1ee1cac498ae$var$U_b(s));
        a.e[s.p] = s.o.b / a.d;
        a.a += a.e[s.p];
    }
    a.b /= a.d;
    a.a /= B;
    w = $61de1ee1cac498ae$var$fDc(A);
    $61de1ee1cac498ae$var$Okb(A, $61de1ee1cac498ae$var$tmb(new $61de1ee1cac498ae$var$mDc(a)));
    p = $61de1ee1cac498ae$var$Pje;
    o = $61de1ee1cac498ae$var$Ohe;
    g = null;
    H = I;
    G = I;
    f = h;
    e = h;
    if (I < 0) {
        H = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bDc.a.zd(), 19).a;
        G = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bDc.b.zd(), 19).a;
    }
    if (h < 0) {
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$aDc.a.zd(), 19).a;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$aDc.b.zd(), 19).a;
    }
    for(F = H; F <= G; F++)for(d = f; d <= e; d++){
        C = $61de1ee1cac498ae$var$dDc(a, F, d, A, w);
        r = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(C.a));
        m = $61de1ee1cac498ae$var$BD(C.b, 15);
        q = m.gc();
        if (r < p || r == p && q < o) {
            p = r;
            o = q;
            g = m;
        }
    }
    for(l = g.Kc(); l.Ob();){
        k = $61de1ee1cac498ae$var$BD(l.Pb(), 15);
        i = new $61de1ee1cac498ae$var$H1b(b);
        for(t = k.Kc(); t.Ob();){
            s = $61de1ee1cac498ae$var$BD(t.Pb(), 10);
            $61de1ee1cac498ae$var$$_b(s, i);
        }
        n.c[n.c.length] = i;
    }
    $61de1ee1cac498ae$var$smb(n);
    A.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$I6b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    a.b = b;
    a.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$bxc)), 19).a;
    a.c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$dxc), 19).a;
    a.c == 0 && (a.c = $61de1ee1cac498ae$var$Ohe);
    q = new $61de1ee1cac498ae$var$Bib(b.b, 0);
    while(q.b < q.d.gc()){
        p = ($61de1ee1cac498ae$var$sCb(q.b < q.d.gc()), $61de1ee1cac498ae$var$BD(q.d.Xb(q.c = q.b++), 29));
        h = new $61de1ee1cac498ae$var$Rkb;
        k = -1;
        u = -1;
        for(t = new $61de1ee1cac498ae$var$olb(p.a); t.a < t.c.c.length;){
            s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(t), 10);
            if ($61de1ee1cac498ae$var$sr(($61de1ee1cac498ae$var$D6b(), new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b(s).a.Kc(), new $61de1ee1cac498ae$var$Sq)))) >= a.a) {
                d = $61de1ee1cac498ae$var$E6b(a, s);
                k = $61de1ee1cac498ae$var$$wnd.Math.max(k, d.b);
                u = $61de1ee1cac498ae$var$$wnd.Math.max(u, d.d);
                $61de1ee1cac498ae$var$Ekb(h, new $61de1ee1cac498ae$var$vgd(s, d));
            }
        }
        B = new $61de1ee1cac498ae$var$Rkb;
        for(j = 0; j < k; ++j)$61de1ee1cac498ae$var$Dkb(B, 0, ($61de1ee1cac498ae$var$sCb(q.b > 0), q.a.Xb(q.c = --q.b), C = new $61de1ee1cac498ae$var$H1b(a.b), $61de1ee1cac498ae$var$Aib(q, C), $61de1ee1cac498ae$var$sCb(q.b < q.d.gc()), q.d.Xb(q.c = q.b++), C));
        for(g = new $61de1ee1cac498ae$var$olb(h); g.a < g.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 46);
            n = $61de1ee1cac498ae$var$BD(e.b, 571).a;
            if (!n) continue;
            for(m = new $61de1ee1cac498ae$var$olb(n); m.a < m.c.c.length;){
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
                $61de1ee1cac498ae$var$H6b(a, l, $61de1ee1cac498ae$var$B6b, B);
            }
        }
        c = new $61de1ee1cac498ae$var$Rkb;
        for(i = 0; i < u; ++i)$61de1ee1cac498ae$var$Ekb(c, (D = new $61de1ee1cac498ae$var$H1b(a.b), $61de1ee1cac498ae$var$Aib(q, D), D));
        for(f = new $61de1ee1cac498ae$var$olb(h); f.a < f.c.c.length;){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 46);
            A = $61de1ee1cac498ae$var$BD(e.b, 571).c;
            if (!A) continue;
            for(w = new $61de1ee1cac498ae$var$olb(A); w.a < w.c.c.length;){
                v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(w), 10);
                $61de1ee1cac498ae$var$H6b(a, v, $61de1ee1cac498ae$var$C6b, c);
            }
        }
    }
    r = new $61de1ee1cac498ae$var$Bib(b.b, 0);
    while(r.b < r.d.gc()){
        o = ($61de1ee1cac498ae$var$sCb(r.b < r.d.gc()), $61de1ee1cac498ae$var$BD(r.d.Xb(r.c = r.b++), 29));
        o.a.c.length == 0 && $61de1ee1cac498ae$var$uib(r);
    }
}
function $61de1ee1cac498ae$var$uQc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    $61de1ee1cac498ae$var$Odd(c, "Spline edge routing", 1);
    if (b.b.c.length == 0) {
        b.f.a = 0;
        $61de1ee1cac498ae$var$Qdd(c);
        return;
    }
    s = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$wyc))));
    h = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$pyc)));
    g = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$myc)));
    r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Xwc), 336);
    B = r == ($61de1ee1cac498ae$var$tBc(), $61de1ee1cac498ae$var$sBc);
    A = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Ywc)));
    a.d = b;
    a.j.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    a.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Uhb(a.k);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.b, 0), 29);
    k = $61de1ee1cac498ae$var$Kq(i.a, ($61de1ee1cac498ae$var$FNc(), $61de1ee1cac498ae$var$DNc));
    o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(b.b, b.b.c.length - 1), 29);
    l = $61de1ee1cac498ae$var$Kq(o.a, $61de1ee1cac498ae$var$DNc);
    p = new $61de1ee1cac498ae$var$olb(b.b);
    q = null;
    G = 0;
    do {
        t = p.a < p.c.c.length ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 29) : null;
        $61de1ee1cac498ae$var$iQc(a, q, t);
        $61de1ee1cac498ae$var$lQc(a);
        C = $61de1ee1cac498ae$var$Vtb($61de1ee1cac498ae$var$uAb($61de1ee1cac498ae$var$PAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.i, 16)), new $61de1ee1cac498ae$var$LQc), new $61de1ee1cac498ae$var$NQc)));
        F = 0;
        u = G;
        m = !q || k && q == i;
        n = !t || l && t == o;
        if (C > 0) {
            j = 0;
            !!q && (j += h);
            j += (C - 1) * g;
            !!t && (j += h);
            B && !!t && (j = $61de1ee1cac498ae$var$$wnd.Math.max(j, $61de1ee1cac498ae$var$jQc(t, g, s, A)));
            if (j < s && !m && !n) {
                F = (s - j) / 2;
                j = s;
            }
            u += j;
        } else !m && !n && (u += s);
        !!t && $61de1ee1cac498ae$var$h_b(t, u);
        for(w = new $61de1ee1cac498ae$var$olb(a.i); w.a < w.c.c.length;){
            v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(w), 128);
            v.a.c = G;
            v.a.b = u - G;
            v.F = F;
            v.p = !q;
        }
        $61de1ee1cac498ae$var$Gkb(a.a, a.i);
        G = u;
        !!t && (G += t.c.a);
        q = t;
        m = n;
    }while (t);
    for(e = new $61de1ee1cac498ae$var$olb(a.j); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
        f = $61de1ee1cac498ae$var$pQc(a, d);
        $61de1ee1cac498ae$var$yNb(d, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ptc), f);
        D = $61de1ee1cac498ae$var$rQc(a, d);
        $61de1ee1cac498ae$var$yNb(d, $61de1ee1cac498ae$var$rtc, D);
    }
    b.f.a = G;
    a.d = null;
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$Yxd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    p = a.i != 0;
    t = false;
    r = null;
    if ($61de1ee1cac498ae$var$oid(a.e)) {
        k = b.gc();
        if (k > 0) {
            m = k < 100 ? null : new $61de1ee1cac498ae$var$Ixd(k);
            j = new $61de1ee1cac498ae$var$Aud(b);
            o = j.g;
            r = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, k, 15, 1);
            d = 0;
            u = new $61de1ee1cac498ae$var$zud(k);
            for(e = 0; e < a.i; ++e){
                h = a.g[e];
                n = h;
                v: for(s = 0; s < 2; ++s){
                    for(i = k; --i >= 0;)if (n != null ? $61de1ee1cac498ae$var$pb(n, o[i]) : $61de1ee1cac498ae$var$PD(n) === $61de1ee1cac498ae$var$PD(o[i])) {
                        if (r.length <= d) {
                            q = r;
                            r = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, 2 * r.length, 15, 1);
                            $61de1ee1cac498ae$var$$fb(q, 0, r, 0, d);
                        }
                        r[d++] = e;
                        $61de1ee1cac498ae$var$wtd(u, o[i]);
                        break v;
                    }
                    n;
                    if ($61de1ee1cac498ae$var$PD(n) === $61de1ee1cac498ae$var$PD(h)) break;
                }
            }
            j = u;
            o = u.g;
            k = d;
            if (d > r.length) {
                q = r;
                r = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, d, 15, 1);
                $61de1ee1cac498ae$var$$fb(q, 0, r, 0, d);
            }
            if (d > 0) {
                t = true;
                for(f = 0; f < d; ++f){
                    n = o[f];
                    m = $61de1ee1cac498ae$var$k3d(a, $61de1ee1cac498ae$var$BD(n, 72), m);
                }
                for(g = d; --g >= 0;)$61de1ee1cac498ae$var$tud(a, r[g]);
                if (d != k) {
                    for(e = k; --e >= d;)$61de1ee1cac498ae$var$tud(j, e);
                    q = r;
                    r = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, d, 15, 1);
                    $61de1ee1cac498ae$var$$fb(q, 0, r, 0, d);
                }
                b = j;
            }
        }
    } else {
        b = $61de1ee1cac498ae$var$Ctd(a, b);
        for(e = a.i; --e >= 0;)if (b.Hc(a.g[e])) {
            $61de1ee1cac498ae$var$tud(a, e);
            t = true;
        }
    }
    if (t) {
        if (r != null) {
            c = b.gc();
            l = c == 1 ? $61de1ee1cac498ae$var$FLd(a, 4, b.Kc().Pb(), null, r[0], p) : $61de1ee1cac498ae$var$FLd(a, 6, b, r, r[0], p);
            m = c < 100 ? null : new $61de1ee1cac498ae$var$Ixd(c);
            for(e = b.Kc(); e.Ob();){
                n = e.Pb();
                m = $61de1ee1cac498ae$var$Q2d(a, $61de1ee1cac498ae$var$BD(n, 72), m);
            }
            if (!m) $61de1ee1cac498ae$var$Uhd(a.e, l);
            else {
                m.Ei(l);
                m.Fi();
            }
        } else {
            m = $61de1ee1cac498ae$var$Vxd(b.gc());
            for(e = b.Kc(); e.Ob();){
                n = e.Pb();
                m = $61de1ee1cac498ae$var$Q2d(a, $61de1ee1cac498ae$var$BD(n, 72), m);
            }
            !!m && m.Fi();
        }
        return true;
    } else return false;
}
function $61de1ee1cac498ae$var$fYb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    c = new $61de1ee1cac498ae$var$mYb(b);
    c.a || $61de1ee1cac498ae$var$$Xb(b);
    j = $61de1ee1cac498ae$var$ZXb(b);
    i = new $61de1ee1cac498ae$var$Hp;
    q = new $61de1ee1cac498ae$var$AYb;
    for(p = new $61de1ee1cac498ae$var$olb(b.a); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 10);
        for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(o).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 17);
            if (d.c.i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) || d.d.i.k == $61de1ee1cac498ae$var$e0b) {
                k = $61de1ee1cac498ae$var$eYb(a, d, j, q);
                $61de1ee1cac498ae$var$Rc(i, $61de1ee1cac498ae$var$cYb(k.d), k.a);
            }
        }
    }
    g = new $61de1ee1cac498ae$var$Rkb;
    for(t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c.c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21).Kc(); t.Ob();){
        s = $61de1ee1cac498ae$var$BD(t.Pb(), 61);
        n = q.c[s.g];
        m = q.b[s.g];
        h = q.a[s.g];
        f = null;
        r = null;
        switch(s.g){
            case 4:
                f = new $61de1ee1cac498ae$var$J6c(a.d.a, n, j.b.a - a.d.a, m - n);
                r = new $61de1ee1cac498ae$var$J6c(a.d.a, n, h, m - n);
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c + f.b, f.d));
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c + f.b, f.d + f.a));
                break;
            case 2:
                f = new $61de1ee1cac498ae$var$J6c(j.a.a, n, a.c.a - j.a.a, m - n);
                r = new $61de1ee1cac498ae$var$J6c(a.c.a - h, n, h, m - n);
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c, f.d));
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c, f.d + f.a));
                break;
            case 1:
                f = new $61de1ee1cac498ae$var$J6c(n, a.d.b, m - n, j.b.b - a.d.b);
                r = new $61de1ee1cac498ae$var$J6c(n, a.d.b, m - n, h);
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c, f.d + f.a));
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c + f.b, f.d + f.a));
                break;
            case 3:
                f = new $61de1ee1cac498ae$var$J6c(n, j.a.b, m - n, a.c.b - j.a.b);
                r = new $61de1ee1cac498ae$var$J6c(n, a.c.b - h, m - n, h);
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c, f.d));
                $61de1ee1cac498ae$var$iYb(j, new $61de1ee1cac498ae$var$f7c(f.c + f.b, f.d));
        }
        if (f) {
            l = new $61de1ee1cac498ae$var$vYb;
            l.d = s;
            l.b = f;
            l.c = r;
            l.a = $61de1ee1cac498ae$var$Dx($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(i, $61de1ee1cac498ae$var$cYb(s)), 21));
            g.c[g.c.length] = l;
        }
    }
    $61de1ee1cac498ae$var$Gkb(c.b, g);
    c.d = $61de1ee1cac498ae$var$BWb($61de1ee1cac498ae$var$JWb(j));
    return c;
}
function $61de1ee1cac498ae$var$pMc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (c.p[b.p] != null) return;
    h = true;
    c.p[b.p] = 0;
    g = b;
    p = c.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$cMc) ? $61de1ee1cac498ae$var$Qje : $61de1ee1cac498ae$var$Pje;
    do {
        e = a.b.e[g.p];
        f = g.c.a.c.length;
        if (c.o == $61de1ee1cac498ae$var$cMc && e > 0 || c.o == $61de1ee1cac498ae$var$dMc && e < f - 1) {
            i = null;
            j = null;
            c.o == $61de1ee1cac498ae$var$dMc ? i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g.c.a, e + 1), 10) : i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(g.c.a, e - 1), 10);
            j = c.g[i.p];
            $61de1ee1cac498ae$var$pMc(a, j, c);
            p = a.e.bg(p, b, g);
            c.j[b.p] == b && (c.j[b.p] = c.j[j.p]);
            if (c.j[b.p] == c.j[j.p]) {
                o = $61de1ee1cac498ae$var$jBc(a.d, g, i);
                if (c.o == $61de1ee1cac498ae$var$dMc) {
                    d = $61de1ee1cac498ae$var$Edb(c.p[b.p]);
                    l = $61de1ee1cac498ae$var$Edb(c.p[j.p]) + $61de1ee1cac498ae$var$Edb(c.d[i.p]) - i.d.d - o - g.d.a - g.o.b - $61de1ee1cac498ae$var$Edb(c.d[g.p]);
                    if (h) {
                        h = false;
                        c.p[b.p] = $61de1ee1cac498ae$var$$wnd.Math.min(l, p);
                    } else c.p[b.p] = $61de1ee1cac498ae$var$$wnd.Math.min(d, $61de1ee1cac498ae$var$$wnd.Math.min(l, p));
                } else {
                    d = $61de1ee1cac498ae$var$Edb(c.p[b.p]);
                    l = $61de1ee1cac498ae$var$Edb(c.p[j.p]) + $61de1ee1cac498ae$var$Edb(c.d[i.p]) + i.o.b + i.d.a + o + g.d.d - $61de1ee1cac498ae$var$Edb(c.d[g.p]);
                    if (h) {
                        h = false;
                        c.p[b.p] = $61de1ee1cac498ae$var$$wnd.Math.max(l, p);
                    } else c.p[b.p] = $61de1ee1cac498ae$var$$wnd.Math.max(d, $61de1ee1cac498ae$var$$wnd.Math.max(l, p));
                }
            } else {
                o = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$vyc))));
                n = $61de1ee1cac498ae$var$nMc(a, c.j[b.p]);
                k = $61de1ee1cac498ae$var$nMc(a, c.j[j.p]);
                if (c.o == $61de1ee1cac498ae$var$dMc) {
                    m = $61de1ee1cac498ae$var$Edb(c.p[b.p]) + $61de1ee1cac498ae$var$Edb(c.d[g.p]) + g.o.b + g.d.a + o - ($61de1ee1cac498ae$var$Edb(c.p[j.p]) + $61de1ee1cac498ae$var$Edb(c.d[i.p]) - i.d.d);
                    $61de1ee1cac498ae$var$tMc(n, k, m);
                } else {
                    m = $61de1ee1cac498ae$var$Edb(c.p[b.p]) + $61de1ee1cac498ae$var$Edb(c.d[g.p]) - g.d.d - $61de1ee1cac498ae$var$Edb(c.p[j.p]) - $61de1ee1cac498ae$var$Edb(c.d[i.p]) - i.o.b - i.d.a - o;
                    $61de1ee1cac498ae$var$tMc(n, k, m);
                }
            }
        } else p = a.e.bg(p, b, g);
        g = c.a[g.p];
    }while (g != b);
    $61de1ee1cac498ae$var$SMc(a.e, b);
}
function $61de1ee1cac498ae$var$_qd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    t = b;
    s = new $61de1ee1cac498ae$var$Hp;
    u = new $61de1ee1cac498ae$var$Hp;
    k = $61de1ee1cac498ae$var$Ypd(t, $61de1ee1cac498ae$var$Nte);
    d = new $61de1ee1cac498ae$var$ord(a, c, s, u);
    $61de1ee1cac498ae$var$qqd(d.a, d.b, d.c, d.d, k);
    i = (A = s.i, !A ? s.i = new $61de1ee1cac498ae$var$zf(s, s.c) : A);
    for(C = i.Kc(); C.Ob();){
        B = $61de1ee1cac498ae$var$BD(C.Pb(), 202);
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(s, B), 21);
        for(p = e.Kc(); p.Ob();){
            o = p.Pb();
            v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.d, o), 202);
            if (v) {
                h = (!B.e && (B.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, B, 10, 9)), B.e);
                $61de1ee1cac498ae$var$wtd(h, v);
            } else {
                g = $61de1ee1cac498ae$var$_pd(t, $61de1ee1cac498ae$var$Vte);
                m = $61de1ee1cac498ae$var$_te + o + $61de1ee1cac498ae$var$aue + g;
                n = m + $61de1ee1cac498ae$var$$te;
                throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(n));
            }
        }
    }
    j = (w = u.i, !w ? u.i = new $61de1ee1cac498ae$var$zf(u, u.c) : w);
    for(F = j.Kc(); F.Ob();){
        D = $61de1ee1cac498ae$var$BD(F.Pb(), 202);
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(u, D), 21);
        for(r = f.Kc(); r.Ob();){
            q = r.Pb();
            v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.d, q), 202);
            if (v) {
                l = (!D.g && (D.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, D, 9, 10)), D.g);
                $61de1ee1cac498ae$var$wtd(l, v);
            } else {
                g = $61de1ee1cac498ae$var$_pd(t, $61de1ee1cac498ae$var$Vte);
                m = $61de1ee1cac498ae$var$_te + q + $61de1ee1cac498ae$var$aue + g;
                n = m + $61de1ee1cac498ae$var$$te;
                throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(n));
            }
        }
    }
    !c.b && (c.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 4, 7));
    if (c.b.i != 0 && (!c.c && (c.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 5, 8)), c.c.i != 0) && (!c.b && (c.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 4, 7)), c.b.i <= 1 && (!c.c && (c.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 5, 8)), c.c.i <= 1)) && (!c.a && (c.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, c, 6, 6)), c.a).i == 1) {
        G = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!c.a && (c.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, c, 6, 6)), c.a), 0), 202);
        if (!$61de1ee1cac498ae$var$dmd(G) && !$61de1ee1cac498ae$var$emd(G)) {
            $61de1ee1cac498ae$var$kmd(G, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!c.b && (c.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 4, 7)), c.b), 0), 82));
            $61de1ee1cac498ae$var$lmd(G, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!c.c && (c.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, c, 5, 8)), c.c), 0), 82));
        }
    }
}
function $61de1ee1cac498ae$var$qJc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    for(t = a.a, u = 0, v = t.length; u < v; ++u){
        s = t[u];
        j = $61de1ee1cac498ae$var$Ohe;
        k = $61de1ee1cac498ae$var$Ohe;
        for(o = new $61de1ee1cac498ae$var$olb(s.e); o.a < o.c.c.length;){
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
            g = !m.c ? -1 : $61de1ee1cac498ae$var$Jkb(m.c.a, m, 0);
            if (g > 0) {
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(m.c.a, g - 1), 10);
                B = $61de1ee1cac498ae$var$jBc(a.b, m, l);
                q = m.n.b - m.d.d - (l.n.b + l.o.b + l.d.a + B);
            } else q = m.n.b - m.d.d;
            j = $61de1ee1cac498ae$var$$wnd.Math.min(q, j);
            if (g < m.c.a.c.length - 1) {
                l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(m.c.a, g + 1), 10);
                B = $61de1ee1cac498ae$var$jBc(a.b, m, l);
                r = l.n.b - l.d.d - (m.n.b + m.o.b + m.d.a + B);
            } else r = 2 * m.n.b;
            k = $61de1ee1cac498ae$var$$wnd.Math.min(r, k);
        }
        i = $61de1ee1cac498ae$var$Ohe;
        f = false;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(s.e, 0), 10);
        for(D = new $61de1ee1cac498ae$var$olb(e.j); D.a < D.c.c.length;){
            C = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(D), 11);
            p = e.n.b + C.n.b + C.a.b;
            for(d = new $61de1ee1cac498ae$var$olb(C.e); d.a < d.c.c.length;){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 17);
                w = c.c;
                b = w.i.n.b + w.n.b + w.a.b - p;
                if ($61de1ee1cac498ae$var$$wnd.Math.abs(b) < $61de1ee1cac498ae$var$$wnd.Math.abs(i) && $61de1ee1cac498ae$var$$wnd.Math.abs(b) < (b < 0 ? j : k)) {
                    i = b;
                    f = true;
                }
            }
        }
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(s.e, s.e.c.length - 1), 10);
        for(A = new $61de1ee1cac498ae$var$olb(h.j); A.a < A.c.c.length;){
            w = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(A), 11);
            p = h.n.b + w.n.b + w.a.b;
            for(d = new $61de1ee1cac498ae$var$olb(w.g); d.a < d.c.c.length;){
                c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 17);
                C = c.d;
                b = C.i.n.b + C.n.b + C.a.b - p;
                if ($61de1ee1cac498ae$var$$wnd.Math.abs(b) < $61de1ee1cac498ae$var$$wnd.Math.abs(i) && $61de1ee1cac498ae$var$$wnd.Math.abs(b) < (b < 0 ? j : k)) {
                    i = b;
                    f = true;
                }
            }
        }
        if (f && i != 0) for(n = new $61de1ee1cac498ae$var$olb(s.e); n.a < n.c.c.length;){
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 10);
            m.n.b += i;
        }
    }
}
function $61de1ee1cac498ae$var$ync(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    if ($61de1ee1cac498ae$var$Mhb(a.a, b)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, b), 53), c)) return 1;
    } else $61de1ee1cac498ae$var$Rhb(a.a, b, new $61de1ee1cac498ae$var$Tqb);
    if ($61de1ee1cac498ae$var$Mhb(a.a, c)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, c), 53), b)) return -1;
    } else $61de1ee1cac498ae$var$Rhb(a.a, c, new $61de1ee1cac498ae$var$Tqb);
    if ($61de1ee1cac498ae$var$Mhb(a.e, b)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.e, b), 53), c)) return -1;
    } else $61de1ee1cac498ae$var$Rhb(a.e, b, new $61de1ee1cac498ae$var$Tqb);
    if ($61de1ee1cac498ae$var$Mhb(a.e, c)) {
        if ($61de1ee1cac498ae$var$Rqb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, c), 53), b)) return 1;
    } else $61de1ee1cac498ae$var$Rhb(a.e, c, new $61de1ee1cac498ae$var$Tqb);
    if (a.c == ($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$sAc) || !$61de1ee1cac498ae$var$wNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) || !$61de1ee1cac498ae$var$wNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc))) {
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Etb($61de1ee1cac498ae$var$Dtb($61de1ee1cac498ae$var$KAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(b.j, 16)), new $61de1ee1cac498ae$var$Hnc)), new $61de1ee1cac498ae$var$Jnc)), 11);
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Etb($61de1ee1cac498ae$var$Dtb($61de1ee1cac498ae$var$KAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(c.j, 16)), new $61de1ee1cac498ae$var$Lnc)), new $61de1ee1cac498ae$var$Nnc)), 11);
        if (!!i && !!k) {
            h = i.i;
            j = k.i;
            if (!!h && h == j) {
                for(m = new $61de1ee1cac498ae$var$olb(h.j); m.a < m.c.c.length;){
                    l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 11);
                    if (l == i) {
                        $61de1ee1cac498ae$var$Anc(a, c, b);
                        return -1;
                    } else if (l == k) {
                        $61de1ee1cac498ae$var$Anc(a, b, c);
                        return 1;
                    }
                }
                return $61de1ee1cac498ae$var$beb($61de1ee1cac498ae$var$znc(a, b), $61de1ee1cac498ae$var$znc(a, c));
            }
            for(o = a.d, p = 0, q = o.length; p < q; ++p){
                n = o[p];
                if (n == h) {
                    $61de1ee1cac498ae$var$Anc(a, c, b);
                    return -1;
                } else if (n == j) {
                    $61de1ee1cac498ae$var$Anc(a, b, c);
                    return 1;
                }
            }
        }
        if (!$61de1ee1cac498ae$var$wNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) || !$61de1ee1cac498ae$var$wNb(c, $61de1ee1cac498ae$var$Zsc)) {
            e = $61de1ee1cac498ae$var$znc(a, b);
            g = $61de1ee1cac498ae$var$znc(a, c);
            e > g ? $61de1ee1cac498ae$var$Anc(a, b, c) : $61de1ee1cac498ae$var$Anc(a, c, b);
            return e < g ? -1 : e > g ? 1 : 0;
        }
    }
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)), 19).a;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Zsc), 19).a;
    d > f ? $61de1ee1cac498ae$var$Anc(a, b, c) : $61de1ee1cac498ae$var$Anc(a, c, b);
    return d < f ? -1 : d > f ? 1 : 0;
}
function $61de1ee1cac498ae$var$u2c(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$d9c))))) return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
    j = (!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a).i != 0;
    l = $61de1ee1cac498ae$var$s2c(b);
    k = !l.dc();
    if (j || k) {
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$F9c), 149);
        if (!e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$y2c("Resolved algorithm is not set; apply a LayoutAlgorithmResolver before computing layout."));
        s = $61de1ee1cac498ae$var$D3c(e, ($61de1ee1cac498ae$var$Csd(), $61de1ee1cac498ae$var$ysd));
        $61de1ee1cac498ae$var$q2c(b);
        if (!j && k && !s) return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
        i = new $61de1ee1cac498ae$var$Rkb;
        if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$J8c)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd)) && ($61de1ee1cac498ae$var$D3c(e, $61de1ee1cac498ae$var$vsd) || $61de1ee1cac498ae$var$D3c(e, $61de1ee1cac498ae$var$usd))) {
            n = $61de1ee1cac498ae$var$p2c(a, b);
            o = new $61de1ee1cac498ae$var$Psb;
            $61de1ee1cac498ae$var$ye(o, (!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a));
            while(o.b != 0){
                m = $61de1ee1cac498ae$var$BD(o.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(o.b != 0), $61de1ee1cac498ae$var$Nsb(o, o.a.a)), 33);
                $61de1ee1cac498ae$var$q2c(m);
                r = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(m, $61de1ee1cac498ae$var$J8c)) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$gbd);
                if (r || $61de1ee1cac498ae$var$ikd(m, $61de1ee1cac498ae$var$o8c) && !$61de1ee1cac498ae$var$C3c(e, $61de1ee1cac498ae$var$hkd(m, $61de1ee1cac498ae$var$F9c))) {
                    h = $61de1ee1cac498ae$var$u2c(a, m, c, d);
                    $61de1ee1cac498ae$var$Gkb(i, h);
                    $61de1ee1cac498ae$var$jkd(m, $61de1ee1cac498ae$var$J8c, $61de1ee1cac498ae$var$gbd);
                    $61de1ee1cac498ae$var$hfd(m);
                } else $61de1ee1cac498ae$var$ye(o, (!m.a && (m.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, m, 10, 11)), m.a));
            }
        } else {
            n = (!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a).i;
            for(g = new $61de1ee1cac498ae$var$Fyd((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a)); g.e != g.i.gc();){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(g), 33);
                h = $61de1ee1cac498ae$var$u2c(a, f, c, d);
                $61de1ee1cac498ae$var$Gkb(i, h);
                $61de1ee1cac498ae$var$hfd(f);
            }
        }
        for(q = new $61de1ee1cac498ae$var$olb(i); q.a < q.c.c.length;){
            p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 79);
            $61de1ee1cac498ae$var$jkd(p, $61de1ee1cac498ae$var$d9c, ($61de1ee1cac498ae$var$Bcb(), true));
        }
        $61de1ee1cac498ae$var$r2c(b, e, $61de1ee1cac498ae$var$Udd(d, n));
        $61de1ee1cac498ae$var$v2c(i);
        return k && s ? l : ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb);
    } else return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
}
function $61de1ee1cac498ae$var$Z$b(a, b, c, d, e, f, g, h, i) {
    var j, k, l, m, n, o, p;
    n = c;
    k = new $61de1ee1cac498ae$var$b0b(i);
    $61de1ee1cac498ae$var$__b(k, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b));
    $61de1ee1cac498ae$var$yNb(k, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Isc), g);
    $61de1ee1cac498ae$var$yNb(k, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
    p = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(a.We($61de1ee1cac498ae$var$Uxc)));
    $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$Uxc, p);
    l = new $61de1ee1cac498ae$var$H0b;
    $61de1ee1cac498ae$var$F0b(l, k);
    if (!(b != $61de1ee1cac498ae$var$bcd && b != $61de1ee1cac498ae$var$ccd)) {
        d >= 0 ? n = $61de1ee1cac498ae$var$Zcd(h) : n = $61de1ee1cac498ae$var$Wcd($61de1ee1cac498ae$var$Zcd(h));
        a.Ye($61de1ee1cac498ae$var$$xc, n);
    }
    j = new $61de1ee1cac498ae$var$d7c;
    m = false;
    if (a.Xe($61de1ee1cac498ae$var$Txc)) {
        $61de1ee1cac498ae$var$a7c(j, $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$Txc), 8));
        m = true;
    } else $61de1ee1cac498ae$var$_6c(j, g.a / 2, g.b / 2);
    switch(n.g){
        case 4:
            $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$ytc));
            $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$Bsc, ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Fqc));
            k.o.b = g.b;
            p < 0 && (k.o.a = -p);
            $61de1ee1cac498ae$var$G0b(l, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
            m || (j.a = g.a);
            j.a -= g.a;
            break;
        case 2:
            $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$mxc, ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$Atc));
            $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$Bsc, ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Dqc));
            k.o.b = g.b;
            p < 0 && (k.o.a = -p);
            $61de1ee1cac498ae$var$G0b(l, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
            m || (j.a = 0);
            break;
        case 1:
            $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$Osc, ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$dsc));
            k.o.a = g.a;
            p < 0 && (k.o.b = -p);
            $61de1ee1cac498ae$var$G0b(l, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd));
            m || (j.b = g.b);
            j.b -= g.b;
            break;
        case 3:
            $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$Osc, ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$bsc));
            k.o.a = g.a;
            p < 0 && (k.o.b = -p);
            $61de1ee1cac498ae$var$G0b(l, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
            m || (j.b = 0);
    }
    $61de1ee1cac498ae$var$a7c(l.n, j);
    $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$Txc, j);
    if (b == $61de1ee1cac498ae$var$Zbd || b == $61de1ee1cac498ae$var$_bd || b == $61de1ee1cac498ae$var$$bd) {
        o = 0;
        if (b == $61de1ee1cac498ae$var$Zbd && a.Xe($61de1ee1cac498ae$var$Wxc)) switch(n.g){
            case 1:
            case 2:
                o = $61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$Wxc), 19).a;
                break;
            case 3:
            case 4:
                o = -$61de1ee1cac498ae$var$BD(a.We($61de1ee1cac498ae$var$Wxc), 19).a;
        }
        else switch(n.g){
            case 4:
            case 2:
                o = f.b;
                b == $61de1ee1cac498ae$var$_bd && (o /= e.b);
                break;
            case 1:
            case 3:
                o = f.a;
                b == $61de1ee1cac498ae$var$_bd && (o /= e.a);
        }
        $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$htc, o);
    }
    $61de1ee1cac498ae$var$yNb(k, $61de1ee1cac498ae$var$Hsc, n);
    return k;
}
function $61de1ee1cac498ae$var$AGc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a.a.j, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Ewc))));
    if (c < -1 || !a.a.i || $61de1ee1cac498ae$var$ecd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a.a.o, $61de1ee1cac498ae$var$Vxc), 98)) || $61de1ee1cac498ae$var$V_b(a.a.o, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd)).gc() < 2 && $61de1ee1cac498ae$var$V_b(a.a.o, $61de1ee1cac498ae$var$Tcd).gc() < 2) return true;
    if (a.a.c.Rf()) return false;
    v = 0;
    u = 0;
    t = new $61de1ee1cac498ae$var$Rkb;
    for(i = a.a.e, j = 0, k = i.length; j < k; ++j){
        h = i[j];
        for(m = h, n = 0, p = m.length; n < p; ++n){
            l = m[n];
            if (l.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b)) {
                t.c[t.c.length] = l;
                continue;
            }
            d = a.b[l.c.p][l.p];
            if (l.k == $61de1ee1cac498ae$var$e0b) {
                d.b = 1;
                $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(l, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)), 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) && (u += d.a);
            } else {
                C = $61de1ee1cac498ae$var$V_b(l, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
                C.dc() || !$61de1ee1cac498ae$var$Lq(C, new $61de1ee1cac498ae$var$NGc) ? d.c = 1 : (e = $61de1ee1cac498ae$var$V_b(l, $61de1ee1cac498ae$var$zcd), (e.dc() || !$61de1ee1cac498ae$var$Lq(e, new $61de1ee1cac498ae$var$JGc)) && (v += d.a));
            }
            for(g = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(l).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(g);){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(g), 17);
                v += d.c;
                u += d.b;
                B = f.d.i;
                $61de1ee1cac498ae$var$zGc(a, d, B);
            }
            r = $61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
                $61de1ee1cac498ae$var$V_b(l, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)),
                $61de1ee1cac498ae$var$V_b(l, $61de1ee1cac498ae$var$Rcd)
            ]));
            for(A = new $61de1ee1cac498ae$var$Sr(new $61de1ee1cac498ae$var$xl(r.a.length, r.a)); $61de1ee1cac498ae$var$Qr(A);){
                w = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(A), 11);
                s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(w, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
                if (s) {
                    v += d.c;
                    u += d.b;
                    $61de1ee1cac498ae$var$zGc(a, d, s);
                }
            }
        }
        for(o = new $61de1ee1cac498ae$var$olb(t); o.a < o.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
            d = a.b[l.c.p][l.p];
            for(g = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(l).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(g);){
                f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(g), 17);
                v += d.c;
                u += d.b;
                B = f.d.i;
                $61de1ee1cac498ae$var$zGc(a, d, B);
            }
        }
        t.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    }
    b = v + u;
    q = b == 0 ? $61de1ee1cac498ae$var$Pje : (v - u) / b;
    return q >= c;
}
function $61de1ee1cac498ae$var$ovd() {
    $61de1ee1cac498ae$var$mvd();
    function h(f) {
        var g = this;
        this.dispatch = function(a) {
            var b = a.data;
            switch(b.cmd){
                case "algorithms":
                    var c = $61de1ee1cac498ae$var$pvd(($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$lnb(new $61de1ee1cac498ae$var$$ib($61de1ee1cac498ae$var$lvd.b))));
                    f.postMessage({
                        id: b.id,
                        data: c
                    });
                    break;
                case "categories":
                    var d = $61de1ee1cac498ae$var$pvd(($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$lnb(new $61de1ee1cac498ae$var$$ib($61de1ee1cac498ae$var$lvd.c))));
                    f.postMessage({
                        id: b.id,
                        data: d
                    });
                    break;
                case "options":
                    var e = $61de1ee1cac498ae$var$pvd(($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$lnb(new $61de1ee1cac498ae$var$$ib($61de1ee1cac498ae$var$lvd.d))));
                    f.postMessage({
                        id: b.id,
                        data: e
                    });
                    break;
                case "register":
                    $61de1ee1cac498ae$var$svd(b.algorithms);
                    f.postMessage({
                        id: b.id
                    });
                    break;
                case "layout":
                    $61de1ee1cac498ae$var$qvd(b.graph, b.layoutOptions || {}, b.options || {});
                    f.postMessage({
                        id: b.id,
                        data: b.graph
                    });
                    break;
            }
        };
        this.saveDispatch = function(b) {
            try {
                g.dispatch(b);
            } catch (a) {
                f.postMessage({
                    id: b.data.id,
                    error: a
                });
            }
        };
    }
    function j(b) {
        var c = this;
        this.dispatcher = new h({
            postMessage: function(a) {
                c.onmessage({
                    data: a
                });
            }
        });
        this.postMessage = function(a) {
            setTimeout(function() {
                c.dispatcher.saveDispatch({
                    data: a
                });
            }, 0);
        };
    }
    if (typeof document === $61de1ee1cac498ae$var$uke && typeof self !== $61de1ee1cac498ae$var$uke) {
        var i = new h(self);
        self.onmessage = i.saveDispatch;
    } else if ("object" !== $61de1ee1cac498ae$var$uke && module.exports) {
        Object.defineProperty(module.exports, "__esModule", {
            value: true
        });
        module.exports = {
            "default": j,
            Worker: j
        };
    }
}
function $61de1ee1cac498ae$var$aae(a) {
    if (a.N) return;
    a.N = true;
    a.b = $61de1ee1cac498ae$var$Lnd(a, 0);
    $61de1ee1cac498ae$var$Knd(a.b, 0);
    $61de1ee1cac498ae$var$Knd(a.b, 1);
    $61de1ee1cac498ae$var$Knd(a.b, 2);
    a.bb = $61de1ee1cac498ae$var$Lnd(a, 1);
    $61de1ee1cac498ae$var$Knd(a.bb, 0);
    $61de1ee1cac498ae$var$Knd(a.bb, 1);
    a.fb = $61de1ee1cac498ae$var$Lnd(a, 2);
    $61de1ee1cac498ae$var$Knd(a.fb, 3);
    $61de1ee1cac498ae$var$Knd(a.fb, 4);
    $61de1ee1cac498ae$var$Qnd(a.fb, 5);
    a.qb = $61de1ee1cac498ae$var$Lnd(a, 3);
    $61de1ee1cac498ae$var$Knd(a.qb, 0);
    $61de1ee1cac498ae$var$Qnd(a.qb, 1);
    $61de1ee1cac498ae$var$Qnd(a.qb, 2);
    $61de1ee1cac498ae$var$Knd(a.qb, 3);
    $61de1ee1cac498ae$var$Knd(a.qb, 4);
    $61de1ee1cac498ae$var$Qnd(a.qb, 5);
    $61de1ee1cac498ae$var$Knd(a.qb, 6);
    a.a = $61de1ee1cac498ae$var$Mnd(a, 4);
    a.c = $61de1ee1cac498ae$var$Mnd(a, 5);
    a.d = $61de1ee1cac498ae$var$Mnd(a, 6);
    a.e = $61de1ee1cac498ae$var$Mnd(a, 7);
    a.f = $61de1ee1cac498ae$var$Mnd(a, 8);
    a.g = $61de1ee1cac498ae$var$Mnd(a, 9);
    a.i = $61de1ee1cac498ae$var$Mnd(a, 10);
    a.j = $61de1ee1cac498ae$var$Mnd(a, 11);
    a.k = $61de1ee1cac498ae$var$Mnd(a, 12);
    a.n = $61de1ee1cac498ae$var$Mnd(a, 13);
    a.o = $61de1ee1cac498ae$var$Mnd(a, 14);
    a.p = $61de1ee1cac498ae$var$Mnd(a, 15);
    a.q = $61de1ee1cac498ae$var$Mnd(a, 16);
    a.s = $61de1ee1cac498ae$var$Mnd(a, 17);
    a.r = $61de1ee1cac498ae$var$Mnd(a, 18);
    a.t = $61de1ee1cac498ae$var$Mnd(a, 19);
    a.u = $61de1ee1cac498ae$var$Mnd(a, 20);
    a.v = $61de1ee1cac498ae$var$Mnd(a, 21);
    a.w = $61de1ee1cac498ae$var$Mnd(a, 22);
    a.B = $61de1ee1cac498ae$var$Mnd(a, 23);
    a.A = $61de1ee1cac498ae$var$Mnd(a, 24);
    a.C = $61de1ee1cac498ae$var$Mnd(a, 25);
    a.D = $61de1ee1cac498ae$var$Mnd(a, 26);
    a.F = $61de1ee1cac498ae$var$Mnd(a, 27);
    a.G = $61de1ee1cac498ae$var$Mnd(a, 28);
    a.H = $61de1ee1cac498ae$var$Mnd(a, 29);
    a.J = $61de1ee1cac498ae$var$Mnd(a, 30);
    a.I = $61de1ee1cac498ae$var$Mnd(a, 31);
    a.K = $61de1ee1cac498ae$var$Mnd(a, 32);
    a.M = $61de1ee1cac498ae$var$Mnd(a, 33);
    a.L = $61de1ee1cac498ae$var$Mnd(a, 34);
    a.P = $61de1ee1cac498ae$var$Mnd(a, 35);
    a.Q = $61de1ee1cac498ae$var$Mnd(a, 36);
    a.R = $61de1ee1cac498ae$var$Mnd(a, 37);
    a.S = $61de1ee1cac498ae$var$Mnd(a, 38);
    a.T = $61de1ee1cac498ae$var$Mnd(a, 39);
    a.U = $61de1ee1cac498ae$var$Mnd(a, 40);
    a.V = $61de1ee1cac498ae$var$Mnd(a, 41);
    a.X = $61de1ee1cac498ae$var$Mnd(a, 42);
    a.W = $61de1ee1cac498ae$var$Mnd(a, 43);
    a.Y = $61de1ee1cac498ae$var$Mnd(a, 44);
    a.Z = $61de1ee1cac498ae$var$Mnd(a, 45);
    a.$ = $61de1ee1cac498ae$var$Mnd(a, 46);
    a._ = $61de1ee1cac498ae$var$Mnd(a, 47);
    a.ab = $61de1ee1cac498ae$var$Mnd(a, 48);
    a.cb = $61de1ee1cac498ae$var$Mnd(a, 49);
    a.db = $61de1ee1cac498ae$var$Mnd(a, 50);
    a.eb = $61de1ee1cac498ae$var$Mnd(a, 51);
    a.gb = $61de1ee1cac498ae$var$Mnd(a, 52);
    a.hb = $61de1ee1cac498ae$var$Mnd(a, 53);
    a.ib = $61de1ee1cac498ae$var$Mnd(a, 54);
    a.jb = $61de1ee1cac498ae$var$Mnd(a, 55);
    a.kb = $61de1ee1cac498ae$var$Mnd(a, 56);
    a.lb = $61de1ee1cac498ae$var$Mnd(a, 57);
    a.mb = $61de1ee1cac498ae$var$Mnd(a, 58);
    a.nb = $61de1ee1cac498ae$var$Mnd(a, 59);
    a.ob = $61de1ee1cac498ae$var$Mnd(a, 60);
    a.pb = $61de1ee1cac498ae$var$Mnd(a, 61);
}
function $61de1ee1cac498ae$var$f5b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    s = 0;
    if (b.f.a == 0) for(q = new $61de1ee1cac498ae$var$olb(a); q.a < q.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 10);
        s = $61de1ee1cac498ae$var$$wnd.Math.max(s, o.n.a + o.o.a + o.d.c);
    }
    else s = b.f.a - b.c.a;
    s -= b.c.a;
    for(p = new $61de1ee1cac498ae$var$olb(a); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 10);
        $61de1ee1cac498ae$var$g5b(o.n, s - o.o.a);
        $61de1ee1cac498ae$var$h5b(o.f);
        $61de1ee1cac498ae$var$d5b(o);
        (!o.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : o.q)._b(($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ayc)) && $61de1ee1cac498ae$var$g5b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$ayc), 8), s - o.o.a);
        switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$mwc), 248).g){
            case 1:
                $61de1ee1cac498ae$var$yNb(o, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$D7c));
                break;
            case 2:
                $61de1ee1cac498ae$var$yNb(o, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$C7c));
        }
        r = o.o;
        for(u = new $61de1ee1cac498ae$var$olb(o.j); u.a < u.c.c.length;){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 11);
            $61de1ee1cac498ae$var$g5b(t.n, r.a - t.o.a);
            $61de1ee1cac498ae$var$g5b(t.a, t.o.a);
            $61de1ee1cac498ae$var$G0b(t, $61de1ee1cac498ae$var$Z4b(t.j));
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(t, $61de1ee1cac498ae$var$Wxc), 19);
            !!g && $61de1ee1cac498ae$var$yNb(t, $61de1ee1cac498ae$var$Wxc, $61de1ee1cac498ae$var$meb(-g.a));
            for(f = new $61de1ee1cac498ae$var$olb(t.g); f.a < f.c.c.length;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                for(d = $61de1ee1cac498ae$var$Jsb(e.a, 0); d.b != d.d.c;){
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
                    c.a = s - c.a;
                }
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$jxc), 74);
                if (j) for(i = $61de1ee1cac498ae$var$Jsb(j, 0); i.b != i.d.c;){
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(i), 8);
                    h.a = s - h.a;
                }
                for(m = new $61de1ee1cac498ae$var$olb(e.b); m.a < m.c.c.length;){
                    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 70);
                    $61de1ee1cac498ae$var$g5b(k.n, s - k.o.a);
                }
            }
            for(n = new $61de1ee1cac498ae$var$olb(t.f); n.a < n.c.c.length;){
                k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 70);
                $61de1ee1cac498ae$var$g5b(k.n, t.o.a - k.o.a);
            }
        }
        if (o.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
            $61de1ee1cac498ae$var$yNb(o, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc), $61de1ee1cac498ae$var$Z4b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$Hsc), 61)));
            $61de1ee1cac498ae$var$c5b(o);
        }
        for(l = new $61de1ee1cac498ae$var$olb(o.b); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 70);
            $61de1ee1cac498ae$var$d5b(k);
            $61de1ee1cac498ae$var$g5b(k.n, r.a - k.o.a);
        }
    }
}
function $61de1ee1cac498ae$var$i5b(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    s = 0;
    if (b.f.b == 0) for(q = new $61de1ee1cac498ae$var$olb(a); q.a < q.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 10);
        s = $61de1ee1cac498ae$var$$wnd.Math.max(s, o.n.b + o.o.b + o.d.a);
    }
    else s = b.f.b - b.c.b;
    s -= b.c.b;
    for(p = new $61de1ee1cac498ae$var$olb(a); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 10);
        $61de1ee1cac498ae$var$j5b(o.n, s - o.o.b);
        $61de1ee1cac498ae$var$k5b(o.f);
        $61de1ee1cac498ae$var$e5b(o);
        (!o.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : o.q)._b(($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ayc)) && $61de1ee1cac498ae$var$j5b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$ayc), 8), s - o.o.b);
        switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$mwc), 248).g){
            case 3:
                $61de1ee1cac498ae$var$yNb(o, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$A7c));
                break;
            case 4:
                $61de1ee1cac498ae$var$yNb(o, $61de1ee1cac498ae$var$mwc, ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$E7c));
        }
        r = o.o;
        for(u = new $61de1ee1cac498ae$var$olb(o.j); u.a < u.c.c.length;){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 11);
            $61de1ee1cac498ae$var$j5b(t.n, r.b - t.o.b);
            $61de1ee1cac498ae$var$j5b(t.a, t.o.b);
            $61de1ee1cac498ae$var$G0b(t, $61de1ee1cac498ae$var$$4b(t.j));
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(t, $61de1ee1cac498ae$var$Wxc), 19);
            !!g && $61de1ee1cac498ae$var$yNb(t, $61de1ee1cac498ae$var$Wxc, $61de1ee1cac498ae$var$meb(-g.a));
            for(f = new $61de1ee1cac498ae$var$olb(t.g); f.a < f.c.c.length;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 17);
                for(d = $61de1ee1cac498ae$var$Jsb(e.a, 0); d.b != d.d.c;){
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
                    c.b = s - c.b;
                }
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$jxc), 74);
                if (j) for(i = $61de1ee1cac498ae$var$Jsb(j, 0); i.b != i.d.c;){
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(i), 8);
                    h.b = s - h.b;
                }
                for(m = new $61de1ee1cac498ae$var$olb(e.b); m.a < m.c.c.length;){
                    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 70);
                    $61de1ee1cac498ae$var$j5b(k.n, s - k.o.b);
                }
            }
            for(n = new $61de1ee1cac498ae$var$olb(t.f); n.a < n.c.c.length;){
                k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 70);
                $61de1ee1cac498ae$var$j5b(k.n, t.o.b - k.o.b);
            }
        }
        if (o.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
            $61de1ee1cac498ae$var$yNb(o, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc), $61de1ee1cac498ae$var$$4b($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$Hsc), 61)));
            $61de1ee1cac498ae$var$b5b(o);
        }
        for(l = new $61de1ee1cac498ae$var$olb(o.b); l.a < l.c.c.length;){
            k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 70);
            $61de1ee1cac498ae$var$e5b(k);
            $61de1ee1cac498ae$var$j5b(k.n, r.b - k.o.b);
        }
    }
}
function $61de1ee1cac498ae$var$tZc(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n;
    l = false;
    j = a + 1;
    k = ($61de1ee1cac498ae$var$tCb(a, b.c.length), $61de1ee1cac498ae$var$BD(b.c[a], 200));
    g = k.a;
    h = null;
    for(f = 0; f < k.a.c.length; f++){
        e = ($61de1ee1cac498ae$var$tCb(f, g.c.length), $61de1ee1cac498ae$var$BD(g.c[f], 187));
        if (e.c) continue;
        if (e.b.c.length == 0) {
            $61de1ee1cac498ae$var$Zfb();
            $61de1ee1cac498ae$var$v$c(k, e);
            --f;
            l = true;
            continue;
        }
        if (!e.k) {
            !!h && $61de1ee1cac498ae$var$a$c(h);
            h = new $61de1ee1cac498ae$var$b$c(!h ? 0 : h.e + h.d + d, k.f, d);
            $61de1ee1cac498ae$var$OZc(e, h.e + h.d, k.f);
            $61de1ee1cac498ae$var$Ekb(k.d, h);
            $61de1ee1cac498ae$var$WZc(h, e);
            e.k = true;
        }
        i = null;
        i = (n = null, f < k.a.c.length - 1 ? n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(k.a, f + 1), 187) : j < b.c.length && ($61de1ee1cac498ae$var$tCb(j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[j], 200)).a.c.length != 0 && (n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(($61de1ee1cac498ae$var$tCb(j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[j], 200)).a, 0), 187)), n);
        m = false;
        !!i && (m = !$61de1ee1cac498ae$var$pb(i.j, k));
        if (i) {
            if (i.b.c.length == 0) {
                $61de1ee1cac498ae$var$v$c(k, i);
                break;
            } else {
                $61de1ee1cac498ae$var$KZc(e, c - e.s);
                $61de1ee1cac498ae$var$a$c(e.q);
                l = l | $61de1ee1cac498ae$var$sZc(k, e, i, c, d);
            }
            if (i.b.c.length == 0) {
                $61de1ee1cac498ae$var$v$c(($61de1ee1cac498ae$var$tCb(j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[j], 200)), i);
                i = null;
                while(b.c.length > j && ($61de1ee1cac498ae$var$tCb(j, b.c.length), $61de1ee1cac498ae$var$BD(b.c[j], 200)).a.c.length == 0)$61de1ee1cac498ae$var$Lkb(b, ($61de1ee1cac498ae$var$tCb(j, b.c.length), b.c[j]));
            }
            if (!i) {
                --f;
                continue;
            }
            if ($61de1ee1cac498ae$var$uZc(b, k, e, i, m, c, j, d)) {
                l = true;
                continue;
            }
            if (m) {
                if ($61de1ee1cac498ae$var$vZc(b, k, e, i, c, j, d)) {
                    l = true;
                    continue;
                } else if ($61de1ee1cac498ae$var$wZc(k, e)) {
                    e.c = true;
                    l = true;
                    continue;
                }
            } else if ($61de1ee1cac498ae$var$wZc(k, e)) {
                e.c = true;
                l = true;
                continue;
            }
            if (l) continue;
        }
        if ($61de1ee1cac498ae$var$wZc(k, e)) {
            e.c = true;
            l = true;
            !!i && (i.k = false);
            continue;
        } else $61de1ee1cac498ae$var$a$c(e.q);
    }
    return l;
}
function $61de1ee1cac498ae$var$fed(a, b, c, d, e, f, g) {
    var h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I;
    p = 0;
    D = 0;
    for(j = new $61de1ee1cac498ae$var$olb(a.b); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 157);
        !!i.c && $61de1ee1cac498ae$var$zfd(i.c);
        p = $61de1ee1cac498ae$var$$wnd.Math.max(p, $61de1ee1cac498ae$var$red(i));
        D += $61de1ee1cac498ae$var$red(i) * $61de1ee1cac498ae$var$qed(i);
    }
    q = D / a.b.c.length;
    C = $61de1ee1cac498ae$var$_dd(a.b, q);
    D += a.b.c.length * C;
    p = $61de1ee1cac498ae$var$$wnd.Math.max(p, $61de1ee1cac498ae$var$$wnd.Math.sqrt(D * g)) + c.b;
    H = c.b;
    I = c.d;
    n = 0;
    l = c.b + c.c;
    B = new $61de1ee1cac498ae$var$Psb;
    $61de1ee1cac498ae$var$Dsb(B, $61de1ee1cac498ae$var$meb(0));
    w = new $61de1ee1cac498ae$var$Psb;
    k = new $61de1ee1cac498ae$var$Bib(a.b, 0);
    o = null;
    h = new $61de1ee1cac498ae$var$Rkb;
    while(k.b < k.d.gc()){
        i = ($61de1ee1cac498ae$var$sCb(k.b < k.d.gc()), $61de1ee1cac498ae$var$BD(k.d.Xb(k.c = k.b++), 157));
        G = $61de1ee1cac498ae$var$red(i);
        m = $61de1ee1cac498ae$var$qed(i);
        if (H + G > p) {
            if (f) {
                $61de1ee1cac498ae$var$Fsb(w, n);
                $61de1ee1cac498ae$var$Fsb(B, $61de1ee1cac498ae$var$meb(k.b - 1));
                $61de1ee1cac498ae$var$Ekb(a.d, o);
                h.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            }
            H = c.b;
            I += n + b;
            n = 0;
            l = $61de1ee1cac498ae$var$$wnd.Math.max(l, c.b + c.c + G);
        }
        h.c[h.c.length] = i;
        $61de1ee1cac498ae$var$ued(i, H, I);
        l = $61de1ee1cac498ae$var$$wnd.Math.max(l, H + G + c.c);
        n = $61de1ee1cac498ae$var$$wnd.Math.max(n, m);
        H += G + b;
        o = i;
    }
    $61de1ee1cac498ae$var$Gkb(a.a, h);
    $61de1ee1cac498ae$var$Ekb(a.d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(h, h.c.length - 1), 157));
    l = $61de1ee1cac498ae$var$$wnd.Math.max(l, d);
    F = I + n + c.a;
    if (F < e) {
        n += e - F;
        F = e;
    }
    if (f) {
        H = c.b;
        k = new $61de1ee1cac498ae$var$Bib(a.b, 0);
        $61de1ee1cac498ae$var$Fsb(B, $61de1ee1cac498ae$var$meb(a.b.c.length));
        A = $61de1ee1cac498ae$var$Jsb(B, 0);
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(A), 19).a;
        $61de1ee1cac498ae$var$Fsb(w, n);
        v = $61de1ee1cac498ae$var$Jsb(w, 0);
        u = 0;
        while(k.b < k.d.gc()){
            if (k.b == s) {
                H = c.b;
                u = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Xsb(v)));
                s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(A), 19).a;
            }
            i = ($61de1ee1cac498ae$var$sCb(k.b < k.d.gc()), $61de1ee1cac498ae$var$BD(k.d.Xb(k.c = k.b++), 157));
            $61de1ee1cac498ae$var$sed(i, u);
            if (k.b == s) {
                r = l - H - c.c;
                t = $61de1ee1cac498ae$var$red(i);
                $61de1ee1cac498ae$var$ted(i, r);
                $61de1ee1cac498ae$var$ved(i, (r - t) / 2, 0);
            }
            H += $61de1ee1cac498ae$var$red(i) + b;
        }
    }
    return new $61de1ee1cac498ae$var$f7c(l, F);
}
function $61de1ee1cac498ae$var$pde(a) {
    var b, c, d, e, f;
    b = a.c;
    f = null;
    switch(b){
        case 6:
            return a.Vl();
        case 13:
            return a.Wl();
        case 23:
            return a.Nl();
        case 22:
            return a.Sl();
        case 18:
            return a.Pl();
        case 8:
            $61de1ee1cac498ae$var$nde(a);
            f = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$efe);
            break;
        case 9:
            return a.vl(true);
        case 19:
            return a.wl();
        case 10:
            switch(a.a){
                case 100:
                case 68:
                case 119:
                case 87:
                case 115:
                case 83:
                    f = a.ul(a.a);
                    $61de1ee1cac498ae$var$nde(a);
                    return f;
                case 101:
                case 102:
                case 110:
                case 114:
                case 116:
                case 117:
                case 118:
                case 120:
                    c = a.tl();
                    c < $61de1ee1cac498ae$var$Tje ? f = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(0, c)) : f = $61de1ee1cac498ae$var$Ffe($61de1ee1cac498ae$var$Tee(c));
                    break;
                case 99:
                    return a.Fl();
                case 67:
                    return a.Al();
                case 105:
                    return a.Il();
                case 73:
                    return a.Bl();
                case 103:
                    return a.Gl();
                case 88:
                    return a.Cl();
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                    return a.xl();
                case 80:
                case 112:
                    f = $61de1ee1cac498ae$var$tde(a, a.a);
                    if (!f) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Iue))));
                    break;
                default:
                    f = $61de1ee1cac498ae$var$zfe(a.a);
            }
            $61de1ee1cac498ae$var$nde(a);
            break;
        case 0:
            if (a.a == 93 || a.a == 123 || a.a == 125) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Hue))));
            f = $61de1ee1cac498ae$var$zfe(a.a);
            d = a.a;
            $61de1ee1cac498ae$var$nde(a);
            if ((d & 64512) == $61de1ee1cac498ae$var$Uje && a.c == 0 && (a.a & 64512) == 56320) {
                e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, 2, 15, 1);
                e[0] = d & $61de1ee1cac498ae$var$aje;
                e[1] = a.a & $61de1ee1cac498ae$var$aje;
                f = $61de1ee1cac498ae$var$Efe($61de1ee1cac498ae$var$Ffe($61de1ee1cac498ae$var$zfb(e, 0, e.length)), 0);
                $61de1ee1cac498ae$var$nde(a);
            }
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Hue))));
    }
    return f;
}
function $61de1ee1cac498ae$var$e7b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    d = new $61de1ee1cac498ae$var$Rkb;
    e = $61de1ee1cac498ae$var$Ohe;
    f = $61de1ee1cac498ae$var$Ohe;
    g = $61de1ee1cac498ae$var$Ohe;
    if (c) {
        e = a.f.a;
        for(p = new $61de1ee1cac498ae$var$olb(b.j); p.a < p.c.c.length;){
            o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 11);
            for(i = new $61de1ee1cac498ae$var$olb(o.g); i.a < i.c.c.length;){
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 17);
                if (h.a.b != 0) {
                    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hsb(h.a), 8);
                    if (k.a < e) {
                        f = e - k.a;
                        g = $61de1ee1cac498ae$var$Ohe;
                        d.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                        e = k.a;
                    }
                    if (k.a <= e) {
                        d.c[d.c.length] = h;
                        h.a.b > 1 && (g = $61de1ee1cac498ae$var$$wnd.Math.min(g, $61de1ee1cac498ae$var$$wnd.Math.abs($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(h.a, 1), 8).b - k.b)));
                    }
                }
            }
        }
    } else for(p = new $61de1ee1cac498ae$var$olb(b.j); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 11);
        for(i = new $61de1ee1cac498ae$var$olb(o.e); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 17);
            if (h.a.b != 0) {
                m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Isb(h.a), 8);
                if (m.a > e) {
                    f = m.a - e;
                    g = $61de1ee1cac498ae$var$Ohe;
                    d.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                    e = m.a;
                }
                if (m.a >= e) {
                    d.c[d.c.length] = h;
                    h.a.b > 1 && (g = $61de1ee1cac498ae$var$$wnd.Math.min(g, $61de1ee1cac498ae$var$$wnd.Math.abs($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(h.a, h.a.b - 2), 8).b - m.b)));
                }
            }
        }
    }
    if (d.c.length != 0 && f > b.o.a / 2 && g > b.o.b / 2) {
        n = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$F0b(n, b);
        $61de1ee1cac498ae$var$G0b(n, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
        n.n.a = b.o.a / 2;
        r = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$F0b(r, b);
        $61de1ee1cac498ae$var$G0b(r, $61de1ee1cac498ae$var$Rcd);
        r.n.a = b.o.a / 2;
        r.n.b = b.o.b;
        for(i = new $61de1ee1cac498ae$var$olb(d); i.a < i.c.c.length;){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 17);
            if (c) {
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Lsb(h.a), 8);
                q = h.a.b == 0 ? $61de1ee1cac498ae$var$A0b(h.d) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hsb(h.a), 8);
                q.b >= j.b ? $61de1ee1cac498ae$var$QZb(h, r) : $61de1ee1cac498ae$var$QZb(h, n);
            } else {
                j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Msb(h.a), 8);
                q = h.a.b == 0 ? $61de1ee1cac498ae$var$A0b(h.c) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Isb(h.a), 8);
                q.b >= j.b ? $61de1ee1cac498ae$var$RZb(h, r) : $61de1ee1cac498ae$var$RZb(h, n);
            }
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(h, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74);
            !!l && $61de1ee1cac498ae$var$ze(l, j, true);
        }
        b.n.a = e - b.o.a / 2;
    }
}
function $61de1ee1cac498ae$var$erd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K;
    D = null;
    G = b;
    F = $61de1ee1cac498ae$var$Rqd(a, $61de1ee1cac498ae$var$dtd(c), G);
    $61de1ee1cac498ae$var$Lkd(F, $61de1ee1cac498ae$var$_pd(G, $61de1ee1cac498ae$var$Vte));
    H = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.g, $61de1ee1cac498ae$var$Vpd($61de1ee1cac498ae$var$aC(G, $61de1ee1cac498ae$var$Cte))), 33);
    m = $61de1ee1cac498ae$var$aC(G, "sourcePort");
    d = null;
    !!m && (d = $61de1ee1cac498ae$var$Vpd(m));
    I = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.j, d), 118);
    if (!H) {
        h = $61de1ee1cac498ae$var$Wpd(G);
        o = "An edge must have a source node (edge id: '" + h;
        p = o + $61de1ee1cac498ae$var$$te;
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(p));
    }
    if (!!I && !$61de1ee1cac498ae$var$Hb($61de1ee1cac498ae$var$mpd(I), H)) {
        i = $61de1ee1cac498ae$var$_pd(G, $61de1ee1cac498ae$var$Vte);
        q = "The source port of an edge must be a port of the edge's source node (edge id: '" + i;
        r = q + $61de1ee1cac498ae$var$$te;
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(r));
    }
    B = (!F.b && (F.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, F, 4, 7)), F.b);
    f = null;
    I ? f = I : f = H;
    $61de1ee1cac498ae$var$wtd(B, f);
    J = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.g, $61de1ee1cac498ae$var$Vpd($61de1ee1cac498ae$var$aC(G, $61de1ee1cac498ae$var$bue))), 33);
    n = $61de1ee1cac498ae$var$aC(G, "targetPort");
    e = null;
    !!n && (e = $61de1ee1cac498ae$var$Vpd(n));
    K = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$oo(a.j, e), 118);
    if (!J) {
        l = $61de1ee1cac498ae$var$Wpd(G);
        s = "An edge must have a target node (edge id: '" + l;
        t = s + $61de1ee1cac498ae$var$$te;
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(t));
    }
    if (!!K && !$61de1ee1cac498ae$var$Hb($61de1ee1cac498ae$var$mpd(K), J)) {
        j = $61de1ee1cac498ae$var$_pd(G, $61de1ee1cac498ae$var$Vte);
        u = "The target port of an edge must be a port of the edge's target node (edge id: '" + j;
        v = u + $61de1ee1cac498ae$var$$te;
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(v));
    }
    C = (!F.c && (F.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, F, 5, 8)), F.c);
    g = null;
    K ? g = K : g = J;
    $61de1ee1cac498ae$var$wtd(C, g);
    if ((!F.b && (F.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, F, 4, 7)), F.b).i == 0 || (!F.c && (F.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, F, 5, 8)), F.c).i == 0) {
        k = $61de1ee1cac498ae$var$_pd(G, $61de1ee1cac498ae$var$Vte);
        w = $61de1ee1cac498ae$var$Zte + k;
        A = w + $61de1ee1cac498ae$var$$te;
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cqd(A));
    }
    $61de1ee1cac498ae$var$grd(G, F);
    $61de1ee1cac498ae$var$frd(G, F);
    D = $61de1ee1cac498ae$var$crd(a, G, F);
    return D;
}
function $61de1ee1cac498ae$var$DXb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    l = $61de1ee1cac498ae$var$FXb($61de1ee1cac498ae$var$zXb(a, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Fcd)), b);
    o = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Gcd), b);
    u = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Ocd), b);
    B = $61de1ee1cac498ae$var$GXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Qcd), b);
    m = $61de1ee1cac498ae$var$GXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Bcd), b);
    s = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Ncd), b);
    p = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Hcd), b);
    w = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Pcd), b);
    v = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Ccd), b);
    C = $61de1ee1cac498ae$var$GXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Ecd), b);
    r = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Lcd), b);
    t = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Kcd), b);
    A = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Dcd), b);
    D = $61de1ee1cac498ae$var$GXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Mcd), b);
    n = $61de1ee1cac498ae$var$GXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Icd), b);
    q = $61de1ee1cac498ae$var$EXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Jcd), b);
    c = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        s.a,
        B.a,
        w.a,
        D.a
    ]));
    d = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        o.a,
        l.a,
        u.a,
        q.a
    ]));
    e = r.a;
    f = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        p.a,
        m.a,
        v.a,
        n.a
    ]));
    j = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        s.b,
        o.b,
        p.b,
        t.b
    ]));
    i = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        B.b,
        l.b,
        m.b,
        q.b
    ]));
    k = C.b;
    h = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        w.b,
        u.b,
        v.b,
        A.b
    ]));
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Fcd), c + e, j + k);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Jcd), c + e, j + k);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Gcd), c + e, 0);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Ocd), c + e, j + k + i);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Qcd), 0, j + k);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Bcd), c + e + d, j + k);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Hcd), c + e + d, 0);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Pcd), 0, j + k + i);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Ccd), c + e + d, j + k + i);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Ecd), 0, j);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Lcd), c, 0);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Dcd), 0, j + k + i);
    $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$zXb(a, $61de1ee1cac498ae$var$Icd), c + e + d, 0);
    g = new $61de1ee1cac498ae$var$d7c;
    g.a = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        c + d + e + f,
        C.a,
        t.a,
        A.a
    ]));
    g.b = $61de1ee1cac498ae$var$w6c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$UD, 1), $61de1ee1cac498ae$var$Vje, 25, 15, [
        j + i + k + h,
        r.b,
        D.b,
        n.b
    ]));
    return g;
}
function $61de1ee1cac498ae$var$Ngc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    p = new $61de1ee1cac498ae$var$Rkb;
    for(m = new $61de1ee1cac498ae$var$olb(a.d.b); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 29);
        for(o = new $61de1ee1cac498ae$var$olb(l.a); o.a < o.c.c.length;){
            n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 10);
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.f, n), 57);
            for(i = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(n).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(i);){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(i), 17);
                d = $61de1ee1cac498ae$var$Jsb(g.a, 0);
                j = true;
                k = null;
                if (d.b != d.d.c) {
                    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
                    c = null;
                    if (g.c.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) {
                        q = new $61de1ee1cac498ae$var$hic(b, new $61de1ee1cac498ae$var$f7c(b.a, e.d.d), e, g);
                        q.f.a = true;
                        q.a = g.c;
                        p.c[p.c.length] = q;
                    }
                    if (g.c.j == $61de1ee1cac498ae$var$Rcd) {
                        q = new $61de1ee1cac498ae$var$hic(b, new $61de1ee1cac498ae$var$f7c(b.a, e.d.d + e.d.a), e, g);
                        q.f.d = true;
                        q.a = g.c;
                        p.c[p.c.length] = q;
                    }
                    while(d.b != d.d.c){
                        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 8);
                        if (!$61de1ee1cac498ae$var$ADb(b.b, c.b)) {
                            k = new $61de1ee1cac498ae$var$hic(b, c, null, g);
                            p.c[p.c.length] = k;
                            if (j) {
                                j = false;
                                if (c.b < e.d.d) k.f.a = true;
                                else if (c.b > e.d.d + e.d.a) k.f.d = true;
                                else {
                                    k.f.d = true;
                                    k.f.a = true;
                                }
                            }
                        }
                        d.b != d.d.c && (b = c);
                    }
                    if (k) {
                        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.f, g.d.i), 57);
                        if (b.b < f.d.d) k.f.a = true;
                        else if (b.b > f.d.d + f.d.a) k.f.d = true;
                        else {
                            k.f.d = true;
                            k.f.a = true;
                        }
                    }
                }
            }
            for(h = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(n).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(h);){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(h), 17);
                if (g.a.b != 0) {
                    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Isb(g.a), 8);
                    if (g.d.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) {
                        q = new $61de1ee1cac498ae$var$hic(b, new $61de1ee1cac498ae$var$f7c(b.a, e.d.d), e, g);
                        q.f.a = true;
                        q.a = g.d;
                        p.c[p.c.length] = q;
                    }
                    if (g.d.j == $61de1ee1cac498ae$var$Rcd) {
                        q = new $61de1ee1cac498ae$var$hic(b, new $61de1ee1cac498ae$var$f7c(b.a, e.d.d + e.d.a), e, g);
                        q.f.d = true;
                        q.a = g.d;
                        p.c[p.c.length] = q;
                    }
                }
            }
        }
    }
    return p;
}
function $61de1ee1cac498ae$var$WJc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    $61de1ee1cac498ae$var$Odd(c, "Network simplex node placement", 1);
    a.e = b;
    a.n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    $61de1ee1cac498ae$var$VJc(a);
    $61de1ee1cac498ae$var$HJc(a);
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.e.b, 16)), new $61de1ee1cac498ae$var$KKc), new $61de1ee1cac498ae$var$MKc(a));
    $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$LAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.e.b, 16)), new $61de1ee1cac498ae$var$zLc), new $61de1ee1cac498ae$var$BLc), new $61de1ee1cac498ae$var$DLc), new $61de1ee1cac498ae$var$FLc), new $61de1ee1cac498ae$var$IKc(a));
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a.e, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Axc))))) {
        g = $61de1ee1cac498ae$var$Udd(c, 1);
        $61de1ee1cac498ae$var$Odd(g, "Straight Edges Pre-Processing", 1);
        $61de1ee1cac498ae$var$UJc(a);
        $61de1ee1cac498ae$var$Qdd(g);
    }
    $61de1ee1cac498ae$var$JFb(a.f);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Ayc), 19).a * a.f.a.c.length;
    $61de1ee1cac498ae$var$uGb($61de1ee1cac498ae$var$HGb($61de1ee1cac498ae$var$IGb($61de1ee1cac498ae$var$LGb(a.f), f), false), $61de1ee1cac498ae$var$Udd(c, 1));
    if (a.d.a.gc() != 0) {
        g = $61de1ee1cac498ae$var$Udd(c, 1);
        $61de1ee1cac498ae$var$Odd(g, "Flexible Where Space Processing", 1);
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$RAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.f.a, 16)), new $61de1ee1cac498ae$var$OKc), new $61de1ee1cac498ae$var$iKc)), 19).a;
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Btb($61de1ee1cac498ae$var$QAb($61de1ee1cac498ae$var$NAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(a.f.a, 16)), new $61de1ee1cac498ae$var$QKc), new $61de1ee1cac498ae$var$mKc)), 19).a;
        j = i - h;
        k = $61de1ee1cac498ae$var$nGb(new $61de1ee1cac498ae$var$pGb, a.f);
        l = $61de1ee1cac498ae$var$nGb(new $61de1ee1cac498ae$var$pGb, a.f);
        $61de1ee1cac498ae$var$AFb($61de1ee1cac498ae$var$DFb($61de1ee1cac498ae$var$CFb($61de1ee1cac498ae$var$BFb($61de1ee1cac498ae$var$EFb(new $61de1ee1cac498ae$var$FFb, 20000), j), k), l));
        $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$JAb($61de1ee1cac498ae$var$Plb(a.i), new $61de1ee1cac498ae$var$SKc), new $61de1ee1cac498ae$var$UKc), new $61de1ee1cac498ae$var$WKc(h, k, j, l));
        for(e = a.d.a.ec().Kc(); e.Ob();){
            d = $61de1ee1cac498ae$var$BD(e.Pb(), 213);
            d.g = 1;
        }
        $61de1ee1cac498ae$var$uGb($61de1ee1cac498ae$var$HGb($61de1ee1cac498ae$var$IGb($61de1ee1cac498ae$var$LGb(a.f), f), false), $61de1ee1cac498ae$var$Udd(g, 1));
        $61de1ee1cac498ae$var$Qdd(g);
    }
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Axc)))) {
        g = $61de1ee1cac498ae$var$Udd(c, 1);
        $61de1ee1cac498ae$var$Odd(g, "Straight Edges Post-Processing", 1);
        $61de1ee1cac498ae$var$TJc(a);
        $61de1ee1cac498ae$var$Qdd(g);
    }
    $61de1ee1cac498ae$var$GJc(a);
    a.e = null;
    a.f = null;
    a.i = null;
    a.c = null;
    $61de1ee1cac498ae$var$Uhb(a.k);
    a.j = null;
    a.a = null;
    a.o = null;
    a.d.a.$b();
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$lMc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    for(h = new $61de1ee1cac498ae$var$olb(a.a.b); h.a < h.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 29);
        for(t = new $61de1ee1cac498ae$var$olb(f.a); t.a < t.c.c.length;){
            s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(t), 10);
            b.g[s.p] = s;
            b.a[s.p] = s;
            b.d[s.p] = 0;
        }
    }
    i = a.a.b;
    b.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc) && (i = $61de1ee1cac498ae$var$JD(i, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(i, 152)) : $61de1ee1cac498ae$var$JD(i, 131) ? $61de1ee1cac498ae$var$BD(i, 131).a : $61de1ee1cac498ae$var$JD(i, 54) ? new $61de1ee1cac498ae$var$ov(i) : new $61de1ee1cac498ae$var$dv(i));
    for(g = i.Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 29);
        n = -1;
        m = f.a;
        if (b.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc)) {
            n = $61de1ee1cac498ae$var$Ohe;
            m = $61de1ee1cac498ae$var$JD(m, 152) ? $61de1ee1cac498ae$var$km($61de1ee1cac498ae$var$BD(m, 152)) : $61de1ee1cac498ae$var$JD(m, 131) ? $61de1ee1cac498ae$var$BD(m, 131).a : $61de1ee1cac498ae$var$JD(m, 54) ? new $61de1ee1cac498ae$var$ov(m) : new $61de1ee1cac498ae$var$dv(m);
        }
        for(v = m.Kc(); v.Ob();){
            u = $61de1ee1cac498ae$var$BD(v.Pb(), 10);
            l = null;
            b.c == $61de1ee1cac498ae$var$WLc ? l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b.f, u.p), 15) : l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.b.b, u.p), 15);
            if (l.gc() > 0) {
                d = l.gc();
                j = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.floor((d + 1) / 2)) - 1;
                e = $61de1ee1cac498ae$var$QD($61de1ee1cac498ae$var$$wnd.Math.ceil((d + 1) / 2)) - 1;
                if (b.o == $61de1ee1cac498ae$var$dMc) {
                    for(k = e; k >= j; k--)if (b.a[u.p] == u) {
                        p = $61de1ee1cac498ae$var$BD(l.Xb(k), 46);
                        o = $61de1ee1cac498ae$var$BD(p.a, 10);
                        if (!$61de1ee1cac498ae$var$Rqb(c, p.b) && n > a.b.e[o.p]) {
                            b.a[o.p] = u;
                            b.g[u.p] = b.g[o.p];
                            b.a[u.p] = b.g[u.p];
                            b.f[b.g[u.p].p] = ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Ccb(b.f[b.g[u.p].p]) & u.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) ? true : false);
                            n = a.b.e[o.p];
                        }
                    }
                } else {
                    for(k = j; k <= e; k++)if (b.a[u.p] == u) {
                        r = $61de1ee1cac498ae$var$BD(l.Xb(k), 46);
                        q = $61de1ee1cac498ae$var$BD(r.a, 10);
                        if (!$61de1ee1cac498ae$var$Rqb(c, r.b) && n < a.b.e[q.p]) {
                            b.a[q.p] = u;
                            b.g[u.p] = b.g[q.p];
                            b.a[u.p] = b.g[u.p];
                            b.f[b.g[u.p].p] = ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Ccb(b.f[b.g[u.p].p]) & u.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b) ? true : false);
                            n = a.b.e[q.p];
                        }
                    }
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$Thd() {
    $61de1ee1cac498ae$var$Thd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Hhd();
    $61de1ee1cac498ae$var$Shd = $61de1ee1cac498ae$var$Ghd.a;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.a), 0), 18);
    $61de1ee1cac498ae$var$Mhd = $61de1ee1cac498ae$var$Ghd.f;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.f), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.f), 1), 34);
    $61de1ee1cac498ae$var$Rhd = $61de1ee1cac498ae$var$Ghd.n;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.n), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.n), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.n), 2), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.n), 3), 34);
    $61de1ee1cac498ae$var$Nhd = $61de1ee1cac498ae$var$Ghd.g;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.g), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.g), 1), 34);
    $61de1ee1cac498ae$var$Jhd = $61de1ee1cac498ae$var$Ghd.c;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.c), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.c), 1), 18);
    $61de1ee1cac498ae$var$Ohd = $61de1ee1cac498ae$var$Ghd.i;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.i), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.i), 1), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.i), 2), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.i), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.i), 4), 34);
    $61de1ee1cac498ae$var$Phd = $61de1ee1cac498ae$var$Ghd.j;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.j), 0), 18);
    $61de1ee1cac498ae$var$Khd = $61de1ee1cac498ae$var$Ghd.d;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 1), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 2), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 4), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 5), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 6), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.d), 7), 34);
    $61de1ee1cac498ae$var$Ihd = $61de1ee1cac498ae$var$Ghd.b;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.b), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.b), 1), 34);
    $61de1ee1cac498ae$var$Lhd = $61de1ee1cac498ae$var$Ghd.e;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 2), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 3), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 4), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 5), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 6), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 7), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 8), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 9), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.e), 10), 34);
    $61de1ee1cac498ae$var$Qhd = $61de1ee1cac498ae$var$Ghd.k;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.k), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$Ghd.k), 1), 34);
}
function $61de1ee1cac498ae$var$wQc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    C = new $61de1ee1cac498ae$var$Psb;
    w = new $61de1ee1cac498ae$var$Psb;
    q = -1;
    for(i = new $61de1ee1cac498ae$var$olb(a); i.a < i.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 128);
        g.s = q--;
        k = 0;
        t = 0;
        for(f = new $61de1ee1cac498ae$var$olb(g.t); f.a < f.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 268);
            t += d.c;
        }
        for(e = new $61de1ee1cac498ae$var$olb(g.i); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 268);
            k += d.c;
        }
        g.n = k;
        g.u = t;
        t == 0 ? $61de1ee1cac498ae$var$Gsb(w, g, w.c.b, w.c) : k == 0 && $61de1ee1cac498ae$var$Gsb(C, g, C.c.b, C.c);
    }
    F = $61de1ee1cac498ae$var$Gx(a);
    l = a.c.length;
    p = l + 1;
    r = l - 1;
    n = new $61de1ee1cac498ae$var$Rkb;
    while(F.a.gc() != 0){
        while(w.b != 0){
            v = ($61de1ee1cac498ae$var$sCb(w.b != 0), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Nsb(w, w.a.a), 128));
            F.a.Bc(v);
            v.s = r--;
            $61de1ee1cac498ae$var$AQc(v, C, w);
        }
        while(C.b != 0){
            A = ($61de1ee1cac498ae$var$sCb(C.b != 0), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Nsb(C, C.a.a), 128));
            F.a.Bc(A);
            A.s = p++;
            $61de1ee1cac498ae$var$AQc(A, C, w);
        }
        o = $61de1ee1cac498ae$var$Rie;
        for(j = F.a.ec().Kc(); j.Ob();){
            g = $61de1ee1cac498ae$var$BD(j.Pb(), 128);
            s = g.u - g.n;
            if (s >= o) {
                if (s > o) {
                    n.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                    o = s;
                }
                n.c[n.c.length] = g;
            }
        }
        if (n.c.length != 0) {
            m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(n, $61de1ee1cac498ae$var$Bub(b, n.c.length)), 128);
            F.a.Bc(m);
            m.s = p++;
            $61de1ee1cac498ae$var$AQc(m, C, w);
            n.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        }
    }
    u = a.c.length + 1;
    for(h = new $61de1ee1cac498ae$var$olb(a); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 128);
        g.s < l && (g.s += u);
    }
    for(B = new $61de1ee1cac498ae$var$olb(a); B.a < B.c.c.length;){
        A = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(B), 128);
        c = new $61de1ee1cac498ae$var$Bib(A.t, 0);
        while(c.b < c.d.gc()){
            d = ($61de1ee1cac498ae$var$sCb(c.b < c.d.gc()), $61de1ee1cac498ae$var$BD(c.d.Xb(c.c = c.b++), 268));
            D = d.b;
            if (A.s > D.s) {
                $61de1ee1cac498ae$var$uib(c);
                $61de1ee1cac498ae$var$Lkb(D.i, d);
                if (d.c > 0) {
                    d.a = D;
                    $61de1ee1cac498ae$var$Ekb(D.t, d);
                    d.b = A;
                    $61de1ee1cac498ae$var$Ekb(A.i, d);
                }
            }
        }
    }
}
function $61de1ee1cac498ae$var$qde(a) {
    var b, c, d, e, f;
    b = a.c;
    switch(b){
        case 11:
            return a.Ml();
        case 12:
            return a.Ol();
        case 14:
            return a.Ql();
        case 15:
            return a.Tl();
        case 16:
            return a.Rl();
        case 17:
            return a.Ul();
        case 21:
            $61de1ee1cac498ae$var$nde(a);
            return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$ffe;
        case 10:
            switch(a.a){
                case 65:
                    return a.yl();
                case 90:
                    return a.Dl();
                case 122:
                    return a.Kl();
                case 98:
                    return a.El();
                case 66:
                    return a.zl();
                case 60:
                    return a.Jl();
                case 62:
                    return a.Hl();
            }
    }
    f = $61de1ee1cac498ae$var$pde(a);
    b = a.c;
    switch(b){
        case 3:
            return a.Zl(f);
        case 4:
            return a.Xl(f);
        case 5:
            return a.Yl(f);
        case 0:
            if (a.a == 123 && a.d < a.j) {
                e = a.d;
                d = 0;
                c = -1;
                if ((b = $61de1ee1cac498ae$var$bfb(a.i, e++)) >= 48 && b <= 57) {
                    d = b - 48;
                    while(e < a.j && (b = $61de1ee1cac498ae$var$bfb(a.i, e++)) >= 48 && b <= 57){
                        d = d * 10 + b - 48;
                        if (d < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$bve))));
                    }
                } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Zue))));
                c = d;
                if (b == 44) {
                    if (e >= a.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$_ue))));
                    else if ((b = $61de1ee1cac498ae$var$bfb(a.i, e++)) >= 48 && b <= 57) {
                        c = b - 48;
                        while(e < a.j && (b = $61de1ee1cac498ae$var$bfb(a.i, e++)) >= 48 && b <= 57){
                            c = c * 10 + b - 48;
                            if (c < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$bve))));
                        }
                        if (d > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$ave))));
                    } else c = -1;
                }
                if (b != 125) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$$ue))));
                if (a.sl(e)) {
                    f = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(9, f));
                    a.d = e + 1;
                } else {
                    f = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(3, f));
                    a.d = e;
                }
                f.dm(d);
                f.cm(c);
                $61de1ee1cac498ae$var$nde(a);
            }
    }
    return f;
}
function $61de1ee1cac498ae$var$$bc(a, b, c, d, e) {
    var f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    p = new $61de1ee1cac498ae$var$Skb(b.b);
    u = new $61de1ee1cac498ae$var$Skb(b.b);
    m = new $61de1ee1cac498ae$var$Skb(b.b);
    B = new $61de1ee1cac498ae$var$Skb(b.b);
    q = new $61de1ee1cac498ae$var$Skb(b.b);
    for(A = $61de1ee1cac498ae$var$Jsb(b, 0); A.b != A.d.c;){
        v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(A), 11);
        for(h = new $61de1ee1cac498ae$var$olb(v.g); h.a < h.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
            if (f.c.i == f.d.i) {
                if (v.j == f.d.j) {
                    B.c[B.c.length] = f;
                    continue;
                } else if (v.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) && f.d.j == $61de1ee1cac498ae$var$Rcd) {
                    q.c[q.c.length] = f;
                    continue;
                }
            }
        }
    }
    for(i = new $61de1ee1cac498ae$var$olb(q); i.a < i.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 17);
        $61de1ee1cac498ae$var$_bc(a, f, c, d, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
    }
    for(g = new $61de1ee1cac498ae$var$olb(B); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
        C = new $61de1ee1cac498ae$var$b0b(a);
        $61de1ee1cac498ae$var$__b(C, ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b));
        $61de1ee1cac498ae$var$yNb(C, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc), ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$$bd));
        $61de1ee1cac498ae$var$yNb(C, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), f);
        D = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$yNb(D, $61de1ee1cac498ae$var$$sc, f.d);
        $61de1ee1cac498ae$var$G0b(D, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd));
        $61de1ee1cac498ae$var$F0b(D, C);
        F = new $61de1ee1cac498ae$var$H0b;
        $61de1ee1cac498ae$var$yNb(F, $61de1ee1cac498ae$var$$sc, f.c);
        $61de1ee1cac498ae$var$G0b(F, $61de1ee1cac498ae$var$zcd);
        $61de1ee1cac498ae$var$F0b(F, C);
        $61de1ee1cac498ae$var$yNb(f.c, $61de1ee1cac498ae$var$gtc, C);
        $61de1ee1cac498ae$var$yNb(f.d, $61de1ee1cac498ae$var$gtc, C);
        $61de1ee1cac498ae$var$QZb(f, null);
        $61de1ee1cac498ae$var$RZb(f, null);
        c.c[c.c.length] = C;
        $61de1ee1cac498ae$var$yNb(C, $61de1ee1cac498ae$var$ysc, $61de1ee1cac498ae$var$meb(2));
    }
    for(w = $61de1ee1cac498ae$var$Jsb(b, 0); w.b != w.d.c;){
        v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(w), 11);
        j = v.e.c.length > 0;
        r = v.g.c.length > 0;
        j && r ? m.c[m.c.length] = v : j ? p.c[p.c.length] = v : r && (u.c[u.c.length] = v);
    }
    for(o = new $61de1ee1cac498ae$var$olb(p); o.a < o.c.c.length;){
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 11);
        $61de1ee1cac498ae$var$Ekb(e, $61de1ee1cac498ae$var$Zbc(a, n, null, c));
    }
    for(t = new $61de1ee1cac498ae$var$olb(u); t.a < t.c.c.length;){
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(t), 11);
        $61de1ee1cac498ae$var$Ekb(e, $61de1ee1cac498ae$var$Zbc(a, null, s, c));
    }
    for(l = new $61de1ee1cac498ae$var$olb(m); l.a < l.c.c.length;){
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(l), 11);
        $61de1ee1cac498ae$var$Ekb(e, $61de1ee1cac498ae$var$Zbc(a, k, k, c));
    }
}
function $61de1ee1cac498ae$var$NCb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D;
    s = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Pje, $61de1ee1cac498ae$var$Pje);
    b = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Qje, $61de1ee1cac498ae$var$Qje);
    for(B = new $61de1ee1cac498ae$var$olb(a); B.a < B.c.c.length;){
        A = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(B), 8);
        s.a = $61de1ee1cac498ae$var$$wnd.Math.min(s.a, A.a);
        s.b = $61de1ee1cac498ae$var$$wnd.Math.min(s.b, A.b);
        b.a = $61de1ee1cac498ae$var$$wnd.Math.max(b.a, A.a);
        b.b = $61de1ee1cac498ae$var$$wnd.Math.max(b.b, A.b);
    }
    m = new $61de1ee1cac498ae$var$f7c(b.a - s.a, b.b - s.b);
    j = new $61de1ee1cac498ae$var$f7c(s.a - 50, s.b - m.a - 50);
    k = new $61de1ee1cac498ae$var$f7c(s.a - 50, b.b + m.a + 50);
    l = new $61de1ee1cac498ae$var$f7c(b.a + m.b / 2 + 50, s.b + m.b / 2);
    n = new $61de1ee1cac498ae$var$eDb(j, k, l);
    w = new $61de1ee1cac498ae$var$Tqb;
    f = new $61de1ee1cac498ae$var$Rkb;
    c = new $61de1ee1cac498ae$var$Rkb;
    w.a.zc(n, w);
    for(D = new $61de1ee1cac498ae$var$olb(a); D.a < D.c.c.length;){
        C = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(D), 8);
        f.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        for(v = w.a.ec().Kc(); v.Ob();){
            t = $61de1ee1cac498ae$var$BD(v.Pb(), 308);
            d = t.d;
            $61de1ee1cac498ae$var$S6c(d, t.a);
            $61de1ee1cac498ae$var$Jy($61de1ee1cac498ae$var$S6c(t.d, C), $61de1ee1cac498ae$var$S6c(t.d, t.a)) < 0 && (f.c[f.c.length] = t);
        }
        c.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        for(u = new $61de1ee1cac498ae$var$olb(f); u.a < u.c.c.length;){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 308);
            for(q = new $61de1ee1cac498ae$var$olb(t.e); q.a < q.c.c.length;){
                o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 168);
                g = true;
                for(i = new $61de1ee1cac498ae$var$olb(f); i.a < i.c.c.length;){
                    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 308);
                    h != t && ($61de1ee1cac498ae$var$wtb(o, $61de1ee1cac498ae$var$Ikb(h.e, 0)) || $61de1ee1cac498ae$var$wtb(o, $61de1ee1cac498ae$var$Ikb(h.e, 1)) || $61de1ee1cac498ae$var$wtb(o, $61de1ee1cac498ae$var$Ikb(h.e, 2))) && (g = false);
                }
                g && (c.c[c.c.length] = o);
            }
        }
        $61de1ee1cac498ae$var$Ve(w, f);
        $61de1ee1cac498ae$var$reb(w, new $61de1ee1cac498ae$var$OCb);
        for(p = new $61de1ee1cac498ae$var$olb(c); p.a < p.c.c.length;){
            o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 168);
            $61de1ee1cac498ae$var$Qqb(w, new $61de1ee1cac498ae$var$eDb(C, o.a, o.b));
        }
    }
    r = new $61de1ee1cac498ae$var$Tqb;
    $61de1ee1cac498ae$var$reb(w, new $61de1ee1cac498ae$var$QCb(r));
    e = r.a.ec().Kc();
    while(e.Ob()){
        o = $61de1ee1cac498ae$var$BD(e.Pb(), 168);
        ($61de1ee1cac498ae$var$dDb(n, o.a) || $61de1ee1cac498ae$var$dDb(n, o.b)) && e.Qb();
    }
    $61de1ee1cac498ae$var$reb(r, new $61de1ee1cac498ae$var$SCb);
    return r;
}
function $61de1ee1cac498ae$var$_Tb(a) {
    var b, c, d, e, f;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21);
    b = $61de1ee1cac498ae$var$k3c($61de1ee1cac498ae$var$WTb);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$axc)), 334);
    e == ($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd) && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$XTb);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$$wc))) ? $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$I8b)) : $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$I8b));
    $61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$g6c(), $61de1ee1cac498ae$var$f6c)) != null && $61de1ee1cac498ae$var$d3c(b, $61de1ee1cac498ae$var$YTb);
    ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$hxc))) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$_wc)))) && $61de1ee1cac498ae$var$c3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$W7b));
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Lwc), 103).g){
        case 2:
        case 3:
        case 4:
            $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$Y7b)), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$X7b);
    }
    c.Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Frc)) && $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$V7b)), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$T7b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$U7b);
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$rxc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$kAc(), $61de1ee1cac498ae$var$iAc)) && $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$A8b));
    if (c.Hc($61de1ee1cac498ae$var$Mrc)) {
        $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$G8b));
        $61de1ee1cac498ae$var$e3c(b, $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$E8b);
        $61de1ee1cac498ae$var$e3c(b, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$F8b);
    }
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$swc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$yrc(), $61de1ee1cac498ae$var$wrc)) && $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Swc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$xad)) && $61de1ee1cac498ae$var$c3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$pUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$j8b));
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$cxc))) && $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$i8b));
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Hwc))) && $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$O8b));
    if ($61de1ee1cac498ae$var$cUb(a)) {
        $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$axc)) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$ebd) ? d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Cwc), 292) : d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Dwc), 292);
        f = d == ($61de1ee1cac498ae$var$Xrc(), $61de1ee1cac498ae$var$Vrc) ? ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$D8b) : ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$R8b);
        $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$oUb), f);
    }
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$Kyc), 377).g){
        case 1:
            $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$oUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$P8b));
            break;
        case 2:
            $61de1ee1cac498ae$var$c3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$P7b)), $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$Q7b), $61de1ee1cac498ae$var$pUb, $61de1ee1cac498ae$var$R7b);
    }
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$ywc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) && $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$Q8b));
    return b;
}
function $61de1ee1cac498ae$var$mZc(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$Kre), "ELK Rectangle Packing"), "Algorithm for packing of unconnected boxes, i.e. graphs without edges. The given order of the boxes is always preserved and the main reading direction of the boxes is left to right. The algorithm is divided into two phases. One phase approximates the width in which the rectangles can be placed. The next phase places the rectangles in rows using the previously calculated width as bounding width and bundles rectangles with a similar height in blocks. A compaction step reduces the size of the drawing. Finally, the rectangles are expanded to fill their bounding box and eliminate empty unused spaces."), new $61de1ee1cac498ae$var$pZc)));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$_le, 1.3);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Jre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$VYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$gZc);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$wme, 15);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$lqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$SYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$_Yc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$aZc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$bZc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Gme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$$Yc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Dme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$cZc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Hme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$hZc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Bre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$eZc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Cre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ZYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Fre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$dZc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Gre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$iZc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Hre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$WYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Ame, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$XYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$xqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$YYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Ere, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$UYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Dre, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$TYc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$Kre, $61de1ee1cac498ae$var$Ire, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$kZc));
}
function $61de1ee1cac498ae$var$Wmd(b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    if (d == null) return null;
    if (b.a != c.Aj()) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + c.ne() + $61de1ee1cac498ae$var$ute));
    if ($61de1ee1cac498ae$var$JD(c, 457)) {
        r = $61de1ee1cac498ae$var$_Pd($61de1ee1cac498ae$var$BD(c, 671), d);
        if (!r) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$vte + d + "' is not a valid enumerator of '" + c.ne() + "'"));
        return r;
    }
    switch($61de1ee1cac498ae$var$o1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), c).cl()){
        case 2:
            d = $61de1ee1cac498ae$var$Qge(d, false);
            break;
        case 3:
            d = $61de1ee1cac498ae$var$Qge(d, true);
            break;
    }
    e = $61de1ee1cac498ae$var$o1d($61de1ee1cac498ae$var$M6d, c).$k();
    if (e) return e.Aj().Nh().Kh(e, d);
    n = $61de1ee1cac498ae$var$o1d($61de1ee1cac498ae$var$M6d, c).al();
    if (n) {
        r = new $61de1ee1cac498ae$var$Rkb;
        for(k = $61de1ee1cac498ae$var$Zmd(d), l = 0, m = k.length; l < m; ++l){
            j = k[l];
            $61de1ee1cac498ae$var$Ekb(r, n.Aj().Nh().Kh(n, j));
        }
        return r;
    }
    q = $61de1ee1cac498ae$var$o1d($61de1ee1cac498ae$var$M6d, c).bl();
    if (!q.dc()) {
        for(p = q.Kc(); p.Ob();){
            o = $61de1ee1cac498ae$var$BD(p.Pb(), 148);
            try {
                r = o.Aj().Nh().Kh(o, d);
                if (r != null) return r;
            } catch (a) {
                a = $61de1ee1cac498ae$var$ubb(a);
                if (!$61de1ee1cac498ae$var$JD(a, 60)) throw $61de1ee1cac498ae$var$vbb(a);
            }
        }
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$vte + d + "' does not match any member types of the union datatype '" + c.ne() + "'"));
    }
    $61de1ee1cac498ae$var$BD(c, 834).Fj();
    f = $61de1ee1cac498ae$var$r6d(c.Bj());
    if (!f) return null;
    if (f == $61de1ee1cac498ae$var$yI) {
        h = 0;
        try {
            h = $61de1ee1cac498ae$var$Icb(d, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe) & $61de1ee1cac498ae$var$aje;
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if ($61de1ee1cac498ae$var$JD(a, 127)) {
                g = $61de1ee1cac498ae$var$rfb(d);
                h = g[0];
            } else throw $61de1ee1cac498ae$var$vbb(a);
        }
        return $61de1ee1cac498ae$var$bdb(h);
    }
    if (f == $61de1ee1cac498ae$var$$J) {
        for(i = 0; i < $61de1ee1cac498ae$var$Pmd.length; ++i)try {
            return $61de1ee1cac498ae$var$DQd($61de1ee1cac498ae$var$Pmd[i], d);
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if (!$61de1ee1cac498ae$var$JD(a, 32)) throw $61de1ee1cac498ae$var$vbb(a);
        }
        throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$vte + d + "' is not a date formatted string of the form yyyy-MM-dd'T'HH:mm:ss'.'SSSZ or a valid subset thereof"));
    }
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$vte + d + "' is invalid. "));
}
function $61de1ee1cac498ae$var$ngb(a, b) {
    var c, d, e, f, g, h, i, j;
    c = 0;
    g = 0;
    f = b.length;
    h = null;
    j = new $61de1ee1cac498ae$var$Vfb;
    if (g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) == 43)) {
        ++g;
        ++c;
        if (g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) == 43 || ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) == 45))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + b + '"'));
    }
    while(g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) != 46) && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) != 101) && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) != 69))++g;
    j.a += "" + $61de1ee1cac498ae$var$qfb(b == null ? $61de1ee1cac498ae$var$Xhe : ($61de1ee1cac498ae$var$uCb(b), b), c, g);
    if (g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) == 46)) {
        ++g;
        c = g;
        while(g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) != 101) && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) != 69))++g;
        a.e = g - c;
        j.a += "" + $61de1ee1cac498ae$var$qfb(b == null ? $61de1ee1cac498ae$var$Xhe : ($61de1ee1cac498ae$var$uCb(b), b), c, g);
    } else a.e = 0;
    if (g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) == 101 || ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) == 69))) {
        ++g;
        c = g;
        if (g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) == 43)) {
            ++g;
            g < f && ($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g) != 45) && ++c;
        }
        h = b.substr(c, f - c);
        a.e = a.e - $61de1ee1cac498ae$var$Icb(h, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe);
        if (a.e != $61de1ee1cac498ae$var$QD(a.e)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb("Scale out of range."));
    }
    i = j.a;
    if (i.length < 16) {
        a.f = ($61de1ee1cac498ae$var$kgb == null && ($61de1ee1cac498ae$var$kgb = new RegExp("^[+-]?\\d*$", "i")), $61de1ee1cac498ae$var$kgb.test(i) ? parseInt(i, 10) : NaN);
        if (isNaN(a.f)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Oeb($61de1ee1cac498ae$var$Oje + b + '"'));
        a.a = $61de1ee1cac498ae$var$ugb(a.f);
    } else $61de1ee1cac498ae$var$ogb(a, new $61de1ee1cac498ae$var$Ygb(i));
    a.d = j.a.length;
    for(e = 0; e < j.a.length; ++e){
        d = $61de1ee1cac498ae$var$bfb(j.a, e);
        if (d != 45 && d != 48) break;
        --a.d;
    }
    a.d == 0 && (a.d = 1);
}
function $61de1ee1cac498ae$var$xXb() {
    $61de1ee1cac498ae$var$xXb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$wXb = new $61de1ee1cac498ae$var$Hp;
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Fcd), $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ocd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ocd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Lcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Ncd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Pcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Pcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Pcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ccd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ccd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Ccd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Gcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Lcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Ncd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Lcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Qcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Ncd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Qcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Gcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Lcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Kcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$wXb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Jcd);
}
function $61de1ee1cac498ae$var$YXb(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    a.d = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Pje, $61de1ee1cac498ae$var$Pje);
    a.c = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$Qje, $61de1ee1cac498ae$var$Qje);
    for(m = b.Kc(); m.Ob();){
        k = $61de1ee1cac498ae$var$BD(m.Pb(), 37);
        for(t = new $61de1ee1cac498ae$var$olb(k.a); t.a < t.c.c.length;){
            s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(t), 10);
            a.d.a = $61de1ee1cac498ae$var$$wnd.Math.min(a.d.a, s.n.a - s.d.b);
            a.d.b = $61de1ee1cac498ae$var$$wnd.Math.min(a.d.b, s.n.b - s.d.d);
            a.c.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.c.a, s.n.a + s.o.a + s.d.c);
            a.c.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.c.b, s.n.b + s.o.b + s.d.a);
        }
    }
    h = new $61de1ee1cac498ae$var$nYb;
    for(l = b.Kc(); l.Ob();){
        k = $61de1ee1cac498ae$var$BD(l.Pb(), 37);
        d = $61de1ee1cac498ae$var$fYb(a, k);
        $61de1ee1cac498ae$var$Ekb(h.a, d);
        d.a = d.a | !$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d.c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21).dc();
    }
    a.b = ($61de1ee1cac498ae$var$LUb(), B = new $61de1ee1cac498ae$var$VUb, B.f = new $61de1ee1cac498ae$var$CUb(c), B.b = $61de1ee1cac498ae$var$BUb(B.f, h), B);
    $61de1ee1cac498ae$var$PUb((o = a.b, new $61de1ee1cac498ae$var$Zdd, o));
    a.e = new $61de1ee1cac498ae$var$d7c;
    a.a = a.b.f.e;
    for(g = new $61de1ee1cac498ae$var$olb(h.a); g.a < g.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 841);
        u = $61de1ee1cac498ae$var$QUb(a.b, e);
        $61de1ee1cac498ae$var$g_b(e.c, u.a, u.b);
        for(q = new $61de1ee1cac498ae$var$olb(e.c.a); q.a < q.c.c.length;){
            p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 10);
            if (p.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) {
                r = $61de1ee1cac498ae$var$aYb(a, p.n, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(p, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Hsc)), 61));
                $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(p.n), r);
            }
        }
    }
    for(f = new $61de1ee1cac498ae$var$olb(h.a); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 841);
        for(j = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$lYb(e)); j.a < j.c.c.length;){
            i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 17);
            A = new $61de1ee1cac498ae$var$t7c(i.a);
            $61de1ee1cac498ae$var$St(A, 0, $61de1ee1cac498ae$var$A0b(i.c));
            $61de1ee1cac498ae$var$Dsb(A, $61de1ee1cac498ae$var$A0b(i.d));
            n = null;
            for(w = $61de1ee1cac498ae$var$Jsb(A, 0); w.b != w.d.c;){
                v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(w), 8);
                if (!n) {
                    n = v;
                    continue;
                }
                if ($61de1ee1cac498ae$var$Ky(n.a, v.a)) {
                    a.e.a = $61de1ee1cac498ae$var$$wnd.Math.min(a.e.a, n.a);
                    a.a.a = $61de1ee1cac498ae$var$$wnd.Math.max(a.a.a, n.a);
                } else if ($61de1ee1cac498ae$var$Ky(n.b, v.b)) {
                    a.e.b = $61de1ee1cac498ae$var$$wnd.Math.min(a.e.b, n.b);
                    a.a.b = $61de1ee1cac498ae$var$$wnd.Math.max(a.a.b, n.b);
                }
                n = v;
            }
        }
    }
    $61de1ee1cac498ae$var$V6c(a.e);
    $61de1ee1cac498ae$var$P6c(a.a, a.e);
}
function $61de1ee1cac498ae$var$wZd(a) {
    $61de1ee1cac498ae$var$Bnd(a.b, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "ConsistentTransient"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.a, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "WellFormedSourceURI"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.o, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "InterfaceIsAbstract AtMostOneID UniqueFeatureNames UniqueOperationSignatures NoCircularSuperTypes WellFormedMapEntryClass ConsistentSuperTypes DisjointFeatureAndOperationSignatures"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.p, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "WellFormedInstanceTypeName UniqueTypeParameterNames"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.v, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "UniqueEnumeratorNames UniqueEnumeratorLiterals"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.R, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "WellFormedName"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.T, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "UniqueParameterNames UniqueTypeParameterNames NoRepeatingVoid"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.U, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "WellFormedNsURI WellFormedNsPrefix UniqueSubpackageNames UniqueClassifierNames UniqueNsURIs"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.W, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "ConsistentOpposite SingleContainer ConsistentKeys ConsistentUnique ConsistentContainer"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.bb, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "ValidDefaultValueLiteral"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.eb, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "ValidLowerBound ValidUpperBound ConsistentBounds ValidType"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.H, $61de1ee1cac498ae$var$_ve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$bwe,
        "ConsistentType ConsistentBounds ConsistentArguments"
    ]));
}
function $61de1ee1cac498ae$var$B4b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C;
    if (b.dc()) return;
    e = new $61de1ee1cac498ae$var$s7c;
    h = c ? c : $61de1ee1cac498ae$var$BD(b.Xb(0), 17);
    o = h.c;
    $61de1ee1cac498ae$var$hQc();
    m = o.i.k;
    if (!(m == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b) || m == $61de1ee1cac498ae$var$i0b || m == $61de1ee1cac498ae$var$e0b || m == $61de1ee1cac498ae$var$d0b)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The target node of the edge must be a normal node or a northSouthPort."));
    $61de1ee1cac498ae$var$Fsb(e, $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        o.i.n,
        o.n,
        o.a
    ])));
    if (($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Lcd).Hc(o.j)) {
        q = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(o, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$qtc))));
        l = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            o.i.n,
            o.n,
            o.a
        ])).a, q);
        $61de1ee1cac498ae$var$Gsb(e, l, e.c.b, e.c);
    }
    k = null;
    d = false;
    i = b.Kc();
    while(i.Ob()){
        g = $61de1ee1cac498ae$var$BD(i.Pb(), 17);
        f = g.a;
        if (f.b != 0) {
            if (d) {
                j = $61de1ee1cac498ae$var$Y6c($61de1ee1cac498ae$var$P6c(k, ($61de1ee1cac498ae$var$sCb(f.b != 0), $61de1ee1cac498ae$var$BD(f.a.a.c, 8))), 0.5);
                $61de1ee1cac498ae$var$Gsb(e, j, e.c.b, e.c);
                d = false;
            } else d = true;
            k = $61de1ee1cac498ae$var$R6c(($61de1ee1cac498ae$var$sCb(f.b != 0), $61de1ee1cac498ae$var$BD(f.c.b.c, 8)));
            $61de1ee1cac498ae$var$ye(e, f);
            $61de1ee1cac498ae$var$Osb(f);
        }
    }
    p = h.d;
    if ($61de1ee1cac498ae$var$Lcd.Hc(p.j)) {
        q = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(p, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$qtc))));
        l = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            p.i.n,
            p.n,
            p.a
        ])).a, q);
        $61de1ee1cac498ae$var$Gsb(e, l, e.c.b, e.c);
    }
    $61de1ee1cac498ae$var$Fsb(e, $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        p.i.n,
        p.n,
        p.a
    ])));
    a.d == ($61de1ee1cac498ae$var$tBc(), $61de1ee1cac498ae$var$qBc) && (r = ($61de1ee1cac498ae$var$sCb(e.b != 0), $61de1ee1cac498ae$var$BD(e.a.a.c, 8)), s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(e, 1), 8), t = new $61de1ee1cac498ae$var$e7c($61de1ee1cac498ae$var$bRc(o.j)), t.a *= 5, t.b *= 5, u = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(s.a, s.b), r), v = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$A4b(t.a, u.a), $61de1ee1cac498ae$var$A4b(t.b, u.b)), $61de1ee1cac498ae$var$P6c(v, r), w = $61de1ee1cac498ae$var$Jsb(e, 1), $61de1ee1cac498ae$var$Vsb(w, v), A = ($61de1ee1cac498ae$var$sCb(e.b != 0), $61de1ee1cac498ae$var$BD(e.c.b.c, 8)), B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ut(e, e.b - 2), 8), t = new $61de1ee1cac498ae$var$e7c($61de1ee1cac498ae$var$bRc(p.j)), t.a *= 5, t.b *= 5, u = $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$f7c(B.a, B.b), A), C = new $61de1ee1cac498ae$var$f7c($61de1ee1cac498ae$var$A4b(t.a, u.a), $61de1ee1cac498ae$var$A4b(t.b, u.b)), $61de1ee1cac498ae$var$P6c(C, A), $61de1ee1cac498ae$var$St(e, e.b - 1, C), undefined);
    n = new $61de1ee1cac498ae$var$YPc(e);
    $61de1ee1cac498ae$var$ye(h.a, $61de1ee1cac498ae$var$UPc(n));
}
function $61de1ee1cac498ae$var$Kgd(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P;
    t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82);
    v = t.Dg();
    w = t.Eg();
    u = t.Cg() / 2;
    p = t.Bg() / 2;
    if ($61de1ee1cac498ae$var$JD(t, 186)) {
        s = $61de1ee1cac498ae$var$BD(t, 118);
        v += $61de1ee1cac498ae$var$mpd(s).i;
        v += $61de1ee1cac498ae$var$mpd(s).i;
    }
    v += u;
    w += p;
    F = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b), 0), 82);
    H = F.Dg();
    I = F.Eg();
    G = F.Cg() / 2;
    A = F.Bg() / 2;
    if ($61de1ee1cac498ae$var$JD(F, 186)) {
        D = $61de1ee1cac498ae$var$BD(F, 118);
        H += $61de1ee1cac498ae$var$mpd(D).i;
        H += $61de1ee1cac498ae$var$mpd(D).i;
    }
    H += G;
    I += A;
    if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i == 0) {
        h = ($61de1ee1cac498ae$var$Fhd(), j = new $61de1ee1cac498ae$var$rmd, j);
        $61de1ee1cac498ae$var$wtd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a), h);
    } else if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i > 1) {
        o = new $61de1ee1cac498ae$var$Oyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a));
        while(o.e != o.i.gc())$61de1ee1cac498ae$var$Eyd(o);
    }
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a), 0), 202);
    q = H;
    H > v + u ? q = v + u : H < v - u && (q = v - u);
    r = I;
    I > w + p ? r = w + p : I < w - p && (r = w - p);
    q > v - u && q < v + u && r > w - p && r < w + p && (q = v + u);
    $61de1ee1cac498ae$var$omd(g, q);
    $61de1ee1cac498ae$var$pmd(g, r);
    B = v;
    v > H + G ? B = H + G : v < H - G && (B = H - G);
    C = w;
    w > I + A ? C = I + A : w < I - A && (C = I - A);
    B > H - G && B < H + G && C > I - A && C < I + A && (C = I + A);
    $61de1ee1cac498ae$var$hmd(g, B);
    $61de1ee1cac498ae$var$imd(g, C);
    $61de1ee1cac498ae$var$Uxd((!g.a && (g.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, g, 5)), g.a));
    f = $61de1ee1cac498ae$var$Bub(b, 5);
    t == F && ++f;
    L = B - q;
    O = C - r;
    J = $61de1ee1cac498ae$var$$wnd.Math.sqrt(L * L + O * O);
    l = J * 0.20000000298023224;
    M = L / (f + 1);
    P = O / (f + 1);
    K = q;
    N = r;
    for(k = 0; k < f; k++){
        K += M;
        N += P;
        m = K + $61de1ee1cac498ae$var$Cub(b, 24) * $61de1ee1cac498ae$var$lke * l - l / 2;
        m < 0 ? m = 1 : m > c && (m = c - 1);
        n = N + $61de1ee1cac498ae$var$Cub(b, 24) * $61de1ee1cac498ae$var$lke * l - l / 2;
        n < 0 ? n = 1 : n > d && (n = d - 1);
        e = ($61de1ee1cac498ae$var$Fhd(), i = new $61de1ee1cac498ae$var$xkd, i);
        $61de1ee1cac498ae$var$vkd(e, m);
        $61de1ee1cac498ae$var$wkd(e, n);
        $61de1ee1cac498ae$var$wtd((!g.a && (g.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, g, 5)), g.a), e);
    }
}
function $61de1ee1cac498ae$var$Nyc() {
    $61de1ee1cac498ae$var$Nyc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$iyc = ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$I9c);
    $61de1ee1cac498ae$var$jyc = $61de1ee1cac498ae$var$J9c;
    $61de1ee1cac498ae$var$kyc = $61de1ee1cac498ae$var$K9c;
    $61de1ee1cac498ae$var$lyc = $61de1ee1cac498ae$var$L9c;
    $61de1ee1cac498ae$var$nyc = $61de1ee1cac498ae$var$M9c;
    $61de1ee1cac498ae$var$oyc = $61de1ee1cac498ae$var$N9c;
    $61de1ee1cac498ae$var$ryc = $61de1ee1cac498ae$var$P9c;
    $61de1ee1cac498ae$var$tyc = $61de1ee1cac498ae$var$R9c;
    $61de1ee1cac498ae$var$uyc = $61de1ee1cac498ae$var$S9c;
    $61de1ee1cac498ae$var$syc = $61de1ee1cac498ae$var$Q9c;
    $61de1ee1cac498ae$var$vyc = $61de1ee1cac498ae$var$T9c;
    $61de1ee1cac498ae$var$xyc = $61de1ee1cac498ae$var$U9c;
    $61de1ee1cac498ae$var$zyc = $61de1ee1cac498ae$var$X9c;
    $61de1ee1cac498ae$var$qyc = $61de1ee1cac498ae$var$O9c;
    $61de1ee1cac498ae$var$hyc = ($61de1ee1cac498ae$var$jwc(), $61de1ee1cac498ae$var$Bvc);
    $61de1ee1cac498ae$var$myc = $61de1ee1cac498ae$var$Cvc;
    $61de1ee1cac498ae$var$pyc = $61de1ee1cac498ae$var$Dvc;
    $61de1ee1cac498ae$var$wyc = $61de1ee1cac498ae$var$Evc;
    $61de1ee1cac498ae$var$byc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$D9c, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$cyc = $61de1ee1cac498ae$var$yvc;
    $61de1ee1cac498ae$var$dyc = $61de1ee1cac498ae$var$zvc;
    $61de1ee1cac498ae$var$eyc = $61de1ee1cac498ae$var$Avc;
    $61de1ee1cac498ae$var$Kyc = $61de1ee1cac498ae$var$awc;
    $61de1ee1cac498ae$var$Cyc = $61de1ee1cac498ae$var$Hvc;
    $61de1ee1cac498ae$var$Dyc = $61de1ee1cac498ae$var$Kvc;
    $61de1ee1cac498ae$var$Gyc = $61de1ee1cac498ae$var$Svc;
    $61de1ee1cac498ae$var$Eyc = $61de1ee1cac498ae$var$Nvc;
    $61de1ee1cac498ae$var$Fyc = $61de1ee1cac498ae$var$Pvc;
    $61de1ee1cac498ae$var$Myc = $61de1ee1cac498ae$var$fwc;
    $61de1ee1cac498ae$var$Lyc = $61de1ee1cac498ae$var$cwc;
    $61de1ee1cac498ae$var$Iyc = $61de1ee1cac498ae$var$Yvc;
    $61de1ee1cac498ae$var$Hyc = $61de1ee1cac498ae$var$Wvc;
    $61de1ee1cac498ae$var$Jyc = $61de1ee1cac498ae$var$$vc;
    $61de1ee1cac498ae$var$Cxc = $61de1ee1cac498ae$var$pvc;
    $61de1ee1cac498ae$var$Dxc = $61de1ee1cac498ae$var$qvc;
    $61de1ee1cac498ae$var$Xwc = $61de1ee1cac498ae$var$Auc;
    $61de1ee1cac498ae$var$Ywc = $61de1ee1cac498ae$var$Duc;
    $61de1ee1cac498ae$var$Lxc = new $61de1ee1cac498ae$var$q0b(12);
    $61de1ee1cac498ae$var$Kxc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$f9c, $61de1ee1cac498ae$var$Lxc);
    $61de1ee1cac498ae$var$Twc = ($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$wad);
    $61de1ee1cac498ae$var$Swc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$E8c, $61de1ee1cac498ae$var$Twc);
    $61de1ee1cac498ae$var$Uxc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$s9c, 0);
    $61de1ee1cac498ae$var$fyc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$E9c, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$owc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$r8c, $61de1ee1cac498ae$var$tme);
    $61de1ee1cac498ae$var$Jxc = $61de1ee1cac498ae$var$d9c;
    $61de1ee1cac498ae$var$Vxc = $61de1ee1cac498ae$var$t9c;
    $61de1ee1cac498ae$var$$xc = $61de1ee1cac498ae$var$A9c;
    $61de1ee1cac498ae$var$Kwc = $61de1ee1cac498ae$var$y8c;
    $61de1ee1cac498ae$var$mwc = $61de1ee1cac498ae$var$p8c;
    $61de1ee1cac498ae$var$axc = $61de1ee1cac498ae$var$J8c;
    $61de1ee1cac498ae$var$gyc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$H9c, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$fxc = $61de1ee1cac498ae$var$M8c;
    $61de1ee1cac498ae$var$gxc = $61de1ee1cac498ae$var$N8c;
    $61de1ee1cac498ae$var$Fxc = $61de1ee1cac498ae$var$Y8c;
    $61de1ee1cac498ae$var$Ixc = $61de1ee1cac498ae$var$b9c;
    $61de1ee1cac498ae$var$Gxc = $61de1ee1cac498ae$var$$8c;
    $61de1ee1cac498ae$var$Nwc = ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad);
    $61de1ee1cac498ae$var$Lwc = new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$z8c, $61de1ee1cac498ae$var$Nwc);
    $61de1ee1cac498ae$var$xxc = $61de1ee1cac498ae$var$W8c;
    $61de1ee1cac498ae$var$wxc = $61de1ee1cac498ae$var$U8c;
    $61de1ee1cac498ae$var$Yxc = $61de1ee1cac498ae$var$x9c;
    $61de1ee1cac498ae$var$Xxc = $61de1ee1cac498ae$var$w9c;
    $61de1ee1cac498ae$var$Zxc = $61de1ee1cac498ae$var$z9c;
    $61de1ee1cac498ae$var$Oxc = ($61de1ee1cac498ae$var$Tbd(), $61de1ee1cac498ae$var$Sbd);
    new $61de1ee1cac498ae$var$Osd($61de1ee1cac498ae$var$l9c, $61de1ee1cac498ae$var$Oxc);
    $61de1ee1cac498ae$var$Qxc = $61de1ee1cac498ae$var$o9c;
    $61de1ee1cac498ae$var$Rxc = $61de1ee1cac498ae$var$p9c;
    $61de1ee1cac498ae$var$Sxc = $61de1ee1cac498ae$var$q9c;
    $61de1ee1cac498ae$var$Pxc = $61de1ee1cac498ae$var$n9c;
    $61de1ee1cac498ae$var$Byc = $61de1ee1cac498ae$var$Gvc;
    $61de1ee1cac498ae$var$sxc = $61de1ee1cac498ae$var$avc;
    $61de1ee1cac498ae$var$rxc = $61de1ee1cac498ae$var$$uc;
    $61de1ee1cac498ae$var$Ayc = $61de1ee1cac498ae$var$Fvc;
    $61de1ee1cac498ae$var$mxc = $61de1ee1cac498ae$var$Suc;
    $61de1ee1cac498ae$var$Jwc = $61de1ee1cac498ae$var$muc;
    $61de1ee1cac498ae$var$Iwc = $61de1ee1cac498ae$var$kuc;
    $61de1ee1cac498ae$var$Awc = $61de1ee1cac498ae$var$Xtc;
    $61de1ee1cac498ae$var$Bwc = $61de1ee1cac498ae$var$Ytc;
    $61de1ee1cac498ae$var$Dwc = $61de1ee1cac498ae$var$buc;
    $61de1ee1cac498ae$var$Cwc = $61de1ee1cac498ae$var$Ztc;
    $61de1ee1cac498ae$var$Hwc = $61de1ee1cac498ae$var$iuc;
    $61de1ee1cac498ae$var$uxc = $61de1ee1cac498ae$var$cvc;
    $61de1ee1cac498ae$var$vxc = $61de1ee1cac498ae$var$dvc;
    $61de1ee1cac498ae$var$ixc = $61de1ee1cac498ae$var$Luc;
    $61de1ee1cac498ae$var$Exc = $61de1ee1cac498ae$var$uvc;
    $61de1ee1cac498ae$var$zxc = $61de1ee1cac498ae$var$hvc;
    $61de1ee1cac498ae$var$$wc = $61de1ee1cac498ae$var$Guc;
    $61de1ee1cac498ae$var$Bxc = $61de1ee1cac498ae$var$nvc;
    $61de1ee1cac498ae$var$Vwc = $61de1ee1cac498ae$var$wuc;
    $61de1ee1cac498ae$var$Wwc = $61de1ee1cac498ae$var$yuc;
    $61de1ee1cac498ae$var$zwc = $61de1ee1cac498ae$var$w8c;
    $61de1ee1cac498ae$var$yxc = $61de1ee1cac498ae$var$evc;
    $61de1ee1cac498ae$var$swc = $61de1ee1cac498ae$var$Mtc;
    $61de1ee1cac498ae$var$rwc = $61de1ee1cac498ae$var$Ktc;
    $61de1ee1cac498ae$var$qwc = $61de1ee1cac498ae$var$Jtc;
    $61de1ee1cac498ae$var$cxc = $61de1ee1cac498ae$var$Juc;
    $61de1ee1cac498ae$var$bxc = $61de1ee1cac498ae$var$Iuc;
    $61de1ee1cac498ae$var$dxc = $61de1ee1cac498ae$var$Kuc;
    $61de1ee1cac498ae$var$Hxc = $61de1ee1cac498ae$var$_8c;
    $61de1ee1cac498ae$var$jxc = $61de1ee1cac498ae$var$Q8c;
    $61de1ee1cac498ae$var$Zwc = $61de1ee1cac498ae$var$G8c;
    $61de1ee1cac498ae$var$Qwc = $61de1ee1cac498ae$var$C8c;
    $61de1ee1cac498ae$var$Pwc = $61de1ee1cac498ae$var$B8c;
    $61de1ee1cac498ae$var$Ewc = $61de1ee1cac498ae$var$euc;
    $61de1ee1cac498ae$var$Wxc = $61de1ee1cac498ae$var$v9c;
    $61de1ee1cac498ae$var$pwc = $61de1ee1cac498ae$var$v8c;
    $61de1ee1cac498ae$var$exc = $61de1ee1cac498ae$var$L8c;
    $61de1ee1cac498ae$var$Txc = $61de1ee1cac498ae$var$r9c;
    $61de1ee1cac498ae$var$Mxc = $61de1ee1cac498ae$var$h9c;
    $61de1ee1cac498ae$var$Nxc = $61de1ee1cac498ae$var$j9c;
    $61de1ee1cac498ae$var$oxc = $61de1ee1cac498ae$var$Vuc;
    $61de1ee1cac498ae$var$pxc = $61de1ee1cac498ae$var$Xuc;
    $61de1ee1cac498ae$var$ayc = $61de1ee1cac498ae$var$C9c;
    $61de1ee1cac498ae$var$nwc = $61de1ee1cac498ae$var$Itc;
    $61de1ee1cac498ae$var$qxc = $61de1ee1cac498ae$var$Zuc;
    $61de1ee1cac498ae$var$Rwc = $61de1ee1cac498ae$var$suc;
    $61de1ee1cac498ae$var$Owc = $61de1ee1cac498ae$var$quc;
    $61de1ee1cac498ae$var$txc = $61de1ee1cac498ae$var$S8c;
    $61de1ee1cac498ae$var$kxc = $61de1ee1cac498ae$var$Puc;
    $61de1ee1cac498ae$var$Axc = $61de1ee1cac498ae$var$kvc;
    $61de1ee1cac498ae$var$yyc = $61de1ee1cac498ae$var$V9c;
    $61de1ee1cac498ae$var$Mwc = $61de1ee1cac498ae$var$ouc;
    $61de1ee1cac498ae$var$_xc = $61de1ee1cac498ae$var$wvc;
    $61de1ee1cac498ae$var$Uwc = $61de1ee1cac498ae$var$uuc;
    $61de1ee1cac498ae$var$lxc = $61de1ee1cac498ae$var$Ruc;
    $61de1ee1cac498ae$var$Fwc = $61de1ee1cac498ae$var$guc;
    $61de1ee1cac498ae$var$hxc = $61de1ee1cac498ae$var$P8c;
    $61de1ee1cac498ae$var$nxc = $61de1ee1cac498ae$var$Uuc;
    $61de1ee1cac498ae$var$Gwc = $61de1ee1cac498ae$var$huc;
    $61de1ee1cac498ae$var$ywc = $61de1ee1cac498ae$var$Vtc;
    $61de1ee1cac498ae$var$wwc = $61de1ee1cac498ae$var$Stc;
    $61de1ee1cac498ae$var$uwc = $61de1ee1cac498ae$var$Qtc;
    $61de1ee1cac498ae$var$vwc = $61de1ee1cac498ae$var$Rtc;
    $61de1ee1cac498ae$var$xwc = $61de1ee1cac498ae$var$Utc;
    $61de1ee1cac498ae$var$twc = $61de1ee1cac498ae$var$Otc;
    $61de1ee1cac498ae$var$_wc = $61de1ee1cac498ae$var$Huc;
}
function $61de1ee1cac498ae$var$shb(a, b) {
    $61de1ee1cac498ae$var$phb();
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
    B = a.e;
    o = a.d;
    e = a.a;
    if (B == 0) switch(b){
        case 0:
            return "0";
        case 1:
            return $61de1ee1cac498ae$var$$je;
        case 2:
            return "0.00";
        case 3:
            return "0.000";
        case 4:
            return "0.0000";
        case 5:
            return "0.00000";
        case 6:
            return "0.000000";
        default:
            w = new $61de1ee1cac498ae$var$Ufb;
            b < 0 ? (w.a += "0E+", w) : (w.a += "0E", w);
            w.a += -b;
            return w.a;
    }
    t = o * 10 + 1 + 7;
    u = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$TD, $61de1ee1cac498ae$var$$ie, 25, t + 1, 15, 1);
    c = t;
    if (o == 1) {
        h = e[0];
        if (h < 0) {
            H = $61de1ee1cac498ae$var$xbb(h, $61de1ee1cac498ae$var$Yje);
            do {
                p = H;
                H = $61de1ee1cac498ae$var$Abb(H, 10);
                u[--c] = 48 + $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Qbb(p, $61de1ee1cac498ae$var$Ibb(H, 10))) & $61de1ee1cac498ae$var$aje;
            }while ($61de1ee1cac498ae$var$ybb(H, 0) != 0);
        } else {
            H = h;
            do {
                p = H;
                H = H / 10 | 0;
                u[--c] = 48 + (p - H * 10) & $61de1ee1cac498ae$var$aje;
            }while (H != 0);
        }
    } else {
        D = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, o, 15, 1);
        G = o;
        $61de1ee1cac498ae$var$$fb(e, 0, D, 0, G);
        I: while(true){
            A = 0;
            for(j = G - 1; j >= 0; j--){
                F = $61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$Nbb(A, 32), $61de1ee1cac498ae$var$xbb(D[j], $61de1ee1cac498ae$var$Yje));
                r = $61de1ee1cac498ae$var$qhb(F);
                D[j] = $61de1ee1cac498ae$var$Tbb(r);
                A = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Obb(r, 32));
            }
            s = $61de1ee1cac498ae$var$Tbb(A);
            q = c;
            do u[--c] = 48 + s % 10 & $61de1ee1cac498ae$var$aje;
            while ((s = s / 10 | 0) != 0 && c != 0);
            d = 9 - q + c;
            for(i = 0; i < d && c > 0; i++)u[--c] = 48;
            l = G - 1;
            for(; D[l] == 0; l--){
                if (l == 0) break I;
            }
            G = l + 1;
        }
        while(u[c] == 48)++c;
    }
    n = B < 0;
    g = t - c - b - 1;
    if (b == 0) {
        n && (u[--c] = 45);
        return $61de1ee1cac498ae$var$zfb(u, c, t - c);
    }
    if (b > 0 && g >= -6) {
        if (g >= 0) {
            k = c + g;
            for(m = t - 1; m >= k; m--)u[m + 1] = u[m];
            u[++k] = 46;
            n && (u[--c] = 45);
            return $61de1ee1cac498ae$var$zfb(u, c, t - c + 1);
        }
        for(l = 2; l < -g + 1; l++)u[--c] = 48;
        u[--c] = 46;
        u[--c] = 48;
        n && (u[--c] = 45);
        return $61de1ee1cac498ae$var$zfb(u, c, t - c);
    }
    C = c + 1;
    f = t;
    v = new $61de1ee1cac498ae$var$Vfb;
    n && (v.a += "-", v);
    if (f - C >= 1) {
        $61de1ee1cac498ae$var$Kfb(v, u[c]);
        v.a += ".";
        v.a += $61de1ee1cac498ae$var$zfb(u, c + 1, t - c - 1);
    } else v.a += $61de1ee1cac498ae$var$zfb(u, c, t - c);
    v.a += "E";
    g > 0 && (v.a += "+", v);
    v.a += "" + g;
    return v.a;
}
function $61de1ee1cac498ae$var$z$c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    a.c = b;
    a.g = new $61de1ee1cac498ae$var$Lqb;
    c = ($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd(a.c));
    d = new $61de1ee1cac498ae$var$YGb(c);
    $61de1ee1cac498ae$var$UGb(d);
    t = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$hkd(a.c, ($61de1ee1cac498ae$var$d0c(), $61de1ee1cac498ae$var$Y_c)));
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a.c, $61de1ee1cac498ae$var$$_c), 316);
    v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a.c, $61de1ee1cac498ae$var$__c), 429);
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a.c, $61de1ee1cac498ae$var$T_c), 482);
    u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a.c, $61de1ee1cac498ae$var$Z_c), 430);
    a.j = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a.c, $61de1ee1cac498ae$var$a0c)));
    h = a.a;
    switch(i.g){
        case 0:
            h = a.a;
            break;
        case 1:
            h = a.b;
            break;
        case 2:
            h = a.i;
            break;
        case 3:
            h = a.e;
            break;
        case 4:
            h = a.f;
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Mre + (i.f != null ? i.f : "" + i.g)));
    }
    a.d = new $61de1ee1cac498ae$var$g_c(h, v, g);
    $61de1ee1cac498ae$var$yNb(a.d, ($61de1ee1cac498ae$var$XNb(), $61de1ee1cac498ae$var$VNb), $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a.c, $61de1ee1cac498ae$var$V_c)));
    a.d.c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a.c, $61de1ee1cac498ae$var$U_c)));
    if ($61de1ee1cac498ae$var$Vod(a.c).i == 0) return a.d;
    for(l = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Vod(a.c)); l.e != l.i.gc();){
        k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(l), 33);
        n = k.g / 2;
        m = k.f / 2;
        w = new $61de1ee1cac498ae$var$f7c(k.i + n, k.j + m);
        while($61de1ee1cac498ae$var$Mhb(a.g, w))$61de1ee1cac498ae$var$O6c(w, ($61de1ee1cac498ae$var$$wnd.Math.random() - 0.5) * $61de1ee1cac498ae$var$qme, ($61de1ee1cac498ae$var$$wnd.Math.random() - 0.5) * $61de1ee1cac498ae$var$qme);
        p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(k, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$S8c)), 142);
        q = new $61de1ee1cac498ae$var$aOb(w, new $61de1ee1cac498ae$var$J6c(w.a - n - a.j / 2 - p.b, w.b - m - a.j / 2 - p.d, k.g + a.j + (p.b + p.c), k.f + a.j + (p.d + p.a)));
        $61de1ee1cac498ae$var$Ekb(a.d.i, q);
        $61de1ee1cac498ae$var$Rhb(a.g, w, new $61de1ee1cac498ae$var$vgd(q, k));
    }
    switch(u.g){
        case 0:
            if (t == null) a.d.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.d.i, 0), 65);
            else for(s = new $61de1ee1cac498ae$var$olb(a.d.i); s.a < s.c.c.length;){
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(s), 65);
                o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.g, q.a), 46).b, 33).zg();
                o != null && $61de1ee1cac498ae$var$dfb(o, t) && (a.d.d = q);
            }
            break;
        case 1:
            e = new $61de1ee1cac498ae$var$f7c(a.c.g, a.c.f);
            e.a *= 0.5;
            e.b *= 0.5;
            $61de1ee1cac498ae$var$O6c(e, a.c.i, a.c.j);
            f = $61de1ee1cac498ae$var$Pje;
            for(r = new $61de1ee1cac498ae$var$olb(a.d.i); r.a < r.c.c.length;){
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(r), 65);
                j = $61de1ee1cac498ae$var$S6c(q.a, e);
                if (j < f) {
                    f = j;
                    a.d.d = q;
                }
            }
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Mre + (u.f != null ? u.f : "" + u.g)));
    }
    return a.d;
}
function $61de1ee1cac498ae$var$qfd(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a), 0), 202);
    k = new $61de1ee1cac498ae$var$s7c;
    u = new $61de1ee1cac498ae$var$Lqb;
    w = $61de1ee1cac498ae$var$tfd(v);
    $61de1ee1cac498ae$var$jrb(u.f, v, w);
    m = new $61de1ee1cac498ae$var$Lqb;
    d = new $61de1ee1cac498ae$var$Psb;
    for(o = $61de1ee1cac498ae$var$ul($61de1ee1cac498ae$var$pl($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$KI, 1), $61de1ee1cac498ae$var$Uhe, 20, 0, [
        (!b.d && (b.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, b, 8, 5)), b.d),
        (!b.e && (b.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, b, 7, 4)), b.e)
    ]))); $61de1ee1cac498ae$var$Qr(o);){
        n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(o), 79);
        if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i != 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Tse + (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, a, 6, 6)), a.a).i));
        if (n != a) {
            q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!n.a && (n.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, n, 6, 6)), n.a), 0), 202);
            $61de1ee1cac498ae$var$Gsb(d, q, d.c.b, d.c);
            p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(u.f, q)), 12);
            if (!p) {
                p = $61de1ee1cac498ae$var$tfd(q);
                $61de1ee1cac498ae$var$jrb(u.f, q, p);
            }
            l = c ? $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$g7c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(w, w.c.length - 1), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(p, p.c.length - 1), 8)) : $61de1ee1cac498ae$var$c7c(new $61de1ee1cac498ae$var$g7c(($61de1ee1cac498ae$var$tCb(0, w.c.length), $61de1ee1cac498ae$var$BD(w.c[0], 8))), ($61de1ee1cac498ae$var$tCb(0, p.c.length), $61de1ee1cac498ae$var$BD(p.c[0], 8)));
            $61de1ee1cac498ae$var$jrb(m.f, q, l);
        }
    }
    if (d.b != 0) {
        r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(w, c ? w.c.length - 1 : 0), 8);
        for(j = 1; j < w.c.length; j++){
            s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(w, c ? w.c.length - 1 - j : j), 8);
            e = $61de1ee1cac498ae$var$Jsb(d, 0);
            while(e.b != e.d.c){
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(e), 202);
                p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(u.f, q)), 12);
                if (p.c.length <= j) $61de1ee1cac498ae$var$Zsb(e);
                else {
                    t = $61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$g7c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(p, c ? p.c.length - 1 - j : j), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(m.f, q)), 8));
                    if (s.a != t.a || s.b != t.b) {
                        f = s.a - r.a;
                        h = s.b - r.b;
                        g = t.a - r.a;
                        i = t.b - r.b;
                        g * h == i * f && (f == 0 || isNaN(f) ? f : f < 0 ? -1 : 1) == (g == 0 || isNaN(g) ? g : g < 0 ? -1 : 1) && (h == 0 || isNaN(h) ? h : h < 0 ? -1 : 1) == (i == 0 || isNaN(i) ? i : i < 0 ? -1 : 1) ? ($61de1ee1cac498ae$var$$wnd.Math.abs(f) < $61de1ee1cac498ae$var$$wnd.Math.abs(g) || $61de1ee1cac498ae$var$$wnd.Math.abs(h) < $61de1ee1cac498ae$var$$wnd.Math.abs(i)) && $61de1ee1cac498ae$var$Gsb(k, s, k.c.b, k.c) : j > 1 && $61de1ee1cac498ae$var$Gsb(k, r, k.c.b, k.c);
                        $61de1ee1cac498ae$var$Zsb(e);
                    }
                }
            }
            r = s;
        }
    }
    return k;
}
function $61de1ee1cac498ae$var$$Bc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L;
    $61de1ee1cac498ae$var$Odd(c, "Greedy cycle removal", 1);
    t = b.a;
    L = t.c.length;
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, L, 15, 1);
    a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, L, 15, 1);
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, L, 15, 1);
    j = 0;
    for(r = new $61de1ee1cac498ae$var$olb(t); r.a < r.c.c.length;){
        p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(r), 10);
        p.p = j;
        for(C = new $61de1ee1cac498ae$var$olb(p.j); C.a < C.c.c.length;){
            w = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(C), 11);
            for(h = new $61de1ee1cac498ae$var$olb(w.e); h.a < h.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
                if (d.c.i == p) continue;
                G = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$cyc)), 19).a;
                a.a[j] += G > 0 ? G + 1 : 1;
            }
            for(g = new $61de1ee1cac498ae$var$olb(w.g); g.a < g.c.c.length;){
                d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 17);
                if (d.d.i == p) continue;
                G = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$cyc)), 19).a;
                a.c[j] += G > 0 ? G + 1 : 1;
            }
        }
        a.c[j] == 0 ? $61de1ee1cac498ae$var$Dsb(a.e, p) : a.a[j] == 0 && $61de1ee1cac498ae$var$Dsb(a.f, p);
        ++j;
    }
    o = -1;
    n = 1;
    l = new $61de1ee1cac498ae$var$Rkb;
    a.d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$jtc)), 230);
    while(L > 0){
        while(a.e.b != 0){
            I = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Lsb(a.e), 10);
            a.b[I.p] = o--;
            $61de1ee1cac498ae$var$_Bc(a, I);
            --L;
        }
        while(a.f.b != 0){
            J = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Lsb(a.f), 10);
            a.b[J.p] = n++;
            $61de1ee1cac498ae$var$_Bc(a, J);
            --L;
        }
        if (L > 0) {
            m = $61de1ee1cac498ae$var$Rie;
            for(s = new $61de1ee1cac498ae$var$olb(t); s.a < s.c.c.length;){
                p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(s), 10);
                if (a.b[p.p] == 0) {
                    u = a.c[p.p] - a.a[p.p];
                    if (u >= m) {
                        if (u > m) {
                            l.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
                            m = u;
                        }
                        l.c[l.c.length] = p;
                    }
                }
            }
            k = a.Zf(l);
            a.b[k.p] = n++;
            $61de1ee1cac498ae$var$_Bc(a, k);
            --L;
        }
    }
    H = t.c.length + 1;
    for(j = 0; j < t.c.length; j++)a.b[j] < 0 && (a.b[j] += H);
    for(q = new $61de1ee1cac498ae$var$olb(t); q.a < q.c.c.length;){
        p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(q), 10);
        F = $61de1ee1cac498ae$var$m_b(p.j);
        for(A = F, B = 0, D = A.length; B < D; ++B){
            w = A[B];
            v = $61de1ee1cac498ae$var$k_b(w.g);
            for(e = v, f = 0, i = e.length; f < i; ++f){
                d = e[f];
                K = d.d.i.p;
                if (a.b[p.p] > a.b[K]) {
                    $61de1ee1cac498ae$var$PZb(d, true);
                    $61de1ee1cac498ae$var$yNb(b, $61de1ee1cac498ae$var$Asc, ($61de1ee1cac498ae$var$Bcb(), true));
                }
            }
        }
    }
    a.a = null;
    a.c = null;
    a.b = null;
    $61de1ee1cac498ae$var$Osb(a.f);
    $61de1ee1cac498ae$var$Osb(a.e);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$sQb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    d = new $61de1ee1cac498ae$var$Rkb;
    h = new $61de1ee1cac498ae$var$Rkb;
    q = b / 2;
    n = a.gc();
    e = $61de1ee1cac498ae$var$BD(a.Xb(0), 8);
    r = $61de1ee1cac498ae$var$BD(a.Xb(1), 8);
    o = $61de1ee1cac498ae$var$tQb(e.a, e.b, r.a, r.b, q);
    $61de1ee1cac498ae$var$Ekb(d, ($61de1ee1cac498ae$var$tCb(0, o.c.length), $61de1ee1cac498ae$var$BD(o.c[0], 8)));
    $61de1ee1cac498ae$var$Ekb(h, ($61de1ee1cac498ae$var$tCb(1, o.c.length), $61de1ee1cac498ae$var$BD(o.c[1], 8)));
    for(j = 2; j < n; j++){
        p = e;
        e = r;
        r = $61de1ee1cac498ae$var$BD(a.Xb(j), 8);
        o = $61de1ee1cac498ae$var$tQb(e.a, e.b, p.a, p.b, q);
        $61de1ee1cac498ae$var$Ekb(d, ($61de1ee1cac498ae$var$tCb(1, o.c.length), $61de1ee1cac498ae$var$BD(o.c[1], 8)));
        $61de1ee1cac498ae$var$Ekb(h, ($61de1ee1cac498ae$var$tCb(0, o.c.length), $61de1ee1cac498ae$var$BD(o.c[0], 8)));
        o = $61de1ee1cac498ae$var$tQb(e.a, e.b, r.a, r.b, q);
        $61de1ee1cac498ae$var$Ekb(d, ($61de1ee1cac498ae$var$tCb(0, o.c.length), $61de1ee1cac498ae$var$BD(o.c[0], 8)));
        $61de1ee1cac498ae$var$Ekb(h, ($61de1ee1cac498ae$var$tCb(1, o.c.length), $61de1ee1cac498ae$var$BD(o.c[1], 8)));
    }
    o = $61de1ee1cac498ae$var$tQb(r.a, r.b, e.a, e.b, q);
    $61de1ee1cac498ae$var$Ekb(d, ($61de1ee1cac498ae$var$tCb(1, o.c.length), $61de1ee1cac498ae$var$BD(o.c[1], 8)));
    $61de1ee1cac498ae$var$Ekb(h, ($61de1ee1cac498ae$var$tCb(0, o.c.length), $61de1ee1cac498ae$var$BD(o.c[0], 8)));
    c = new $61de1ee1cac498ae$var$s7c;
    g = new $61de1ee1cac498ae$var$Rkb;
    $61de1ee1cac498ae$var$Dsb(c, ($61de1ee1cac498ae$var$tCb(0, d.c.length), $61de1ee1cac498ae$var$BD(d.c[0], 8)));
    for(k = 1; k < d.c.length - 2; k += 2){
        f = ($61de1ee1cac498ae$var$tCb(k, d.c.length), $61de1ee1cac498ae$var$BD(d.c[k], 8));
        m = $61de1ee1cac498ae$var$rQb(($61de1ee1cac498ae$var$tCb(k - 1, d.c.length), $61de1ee1cac498ae$var$BD(d.c[k - 1], 8)), f, ($61de1ee1cac498ae$var$tCb(k + 1, d.c.length), $61de1ee1cac498ae$var$BD(d.c[k + 1], 8)), ($61de1ee1cac498ae$var$tCb(k + 2, d.c.length), $61de1ee1cac498ae$var$BD(d.c[k + 2], 8)));
        !isFinite(m.a) || !isFinite(m.b) ? $61de1ee1cac498ae$var$Gsb(c, f, c.c.b, c.c) : $61de1ee1cac498ae$var$Gsb(c, m, c.c.b, c.c);
    }
    $61de1ee1cac498ae$var$Dsb(c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d, d.c.length - 1), 8));
    $61de1ee1cac498ae$var$Ekb(g, ($61de1ee1cac498ae$var$tCb(0, h.c.length), $61de1ee1cac498ae$var$BD(h.c[0], 8)));
    for(l = 1; l < h.c.length - 2; l += 2){
        f = ($61de1ee1cac498ae$var$tCb(l, h.c.length), $61de1ee1cac498ae$var$BD(h.c[l], 8));
        m = $61de1ee1cac498ae$var$rQb(($61de1ee1cac498ae$var$tCb(l - 1, h.c.length), $61de1ee1cac498ae$var$BD(h.c[l - 1], 8)), f, ($61de1ee1cac498ae$var$tCb(l + 1, h.c.length), $61de1ee1cac498ae$var$BD(h.c[l + 1], 8)), ($61de1ee1cac498ae$var$tCb(l + 2, h.c.length), $61de1ee1cac498ae$var$BD(h.c[l + 2], 8)));
        !isFinite(m.a) || !isFinite(m.b) ? g.c[g.c.length] = f : g.c[g.c.length] = m;
    }
    $61de1ee1cac498ae$var$Ekb(g, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(h, h.c.length - 1), 8));
    for(i = g.c.length - 1; i >= 0; i--)$61de1ee1cac498ae$var$Dsb(c, ($61de1ee1cac498ae$var$tCb(i, g.c.length), $61de1ee1cac498ae$var$BD(g.c[i], 8)));
    return c;
}
function $61de1ee1cac498ae$var$aFd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    g = true;
    l = null;
    d = null;
    e = null;
    b = false;
    n = $61de1ee1cac498ae$var$BEd;
    j = null;
    f = null;
    h = 0;
    i = $61de1ee1cac498ae$var$UEd(a, h, $61de1ee1cac498ae$var$zEd, $61de1ee1cac498ae$var$AEd);
    if (i < a.length && ($61de1ee1cac498ae$var$BCb(i, a.length), a.charCodeAt(i) == 58)) {
        l = a.substr(h, i - h);
        h = i + 1;
    }
    c = l != null && $61de1ee1cac498ae$var$hnb($61de1ee1cac498ae$var$GEd, l.toLowerCase());
    if (c) {
        i = a.lastIndexOf("!/");
        if (i == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("no archive separator"));
        g = true;
        d = $61de1ee1cac498ae$var$qfb(a, h, ++i);
        h = i;
    } else if (h >= 0 && $61de1ee1cac498ae$var$dfb(a.substr(h, 2), "//")) {
        h += 2;
        i = $61de1ee1cac498ae$var$UEd(a, h, $61de1ee1cac498ae$var$CEd, $61de1ee1cac498ae$var$DEd);
        d = a.substr(h, i - h);
        h = i;
    } else if (l != null && (h == a.length || ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) != 47))) {
        g = false;
        i = $61de1ee1cac498ae$var$ifb(a, $61de1ee1cac498ae$var$wfb(35), h);
        i == -1 && (i = a.length);
        d = a.substr(h, i - h);
        h = i;
    }
    if (!c && h < a.length && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) == 47)) {
        i = $61de1ee1cac498ae$var$UEd(a, h + 1, $61de1ee1cac498ae$var$CEd, $61de1ee1cac498ae$var$DEd);
        k = a.substr(h + 1, i - (h + 1));
        if (k.length > 0 && $61de1ee1cac498ae$var$bfb(k, k.length - 1) == 58) {
            e = k;
            h = i;
        }
    }
    if (h < a.length && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) == 47)) {
        ++h;
        b = true;
    }
    if (h < a.length && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) != 63) && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) != 35)) {
        m = new $61de1ee1cac498ae$var$Rkb;
        while(h < a.length && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) != 63) && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) != 35)){
            i = $61de1ee1cac498ae$var$UEd(a, h, $61de1ee1cac498ae$var$CEd, $61de1ee1cac498ae$var$DEd);
            $61de1ee1cac498ae$var$Ekb(m, a.substr(h, i - h));
            h = i;
            h < a.length && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) == 47) && ($61de1ee1cac498ae$var$bFd(a, ++h) || (m.c[m.c.length] = ""));
        }
        n = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, m.c.length, 6, 1);
        $61de1ee1cac498ae$var$Qkb(m, n);
    }
    if (h < a.length && ($61de1ee1cac498ae$var$BCb(h, a.length), a.charCodeAt(h) == 63)) {
        i = $61de1ee1cac498ae$var$gfb(a, 35, ++h);
        i == -1 && (i = a.length);
        j = a.substr(h, i - h);
        h = i;
    }
    h < a.length && (f = $61de1ee1cac498ae$var$pfb(a, ++h));
    $61de1ee1cac498ae$var$iFd(g, l, d, e, n, j);
    return new $61de1ee1cac498ae$var$NEd(g, l, d, e, b, n, j, f);
}
function $61de1ee1cac498ae$var$sJc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K;
    I = new $61de1ee1cac498ae$var$Rkb;
    for(o = new $61de1ee1cac498ae$var$olb(b.b); o.a < o.c.c.length;){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(o), 29);
        for(v = new $61de1ee1cac498ae$var$olb(m.a); v.a < v.c.c.length;){
            u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(v), 10);
            u.p = -1;
            l = $61de1ee1cac498ae$var$Rie;
            B = $61de1ee1cac498ae$var$Rie;
            for(D = new $61de1ee1cac498ae$var$olb(u.j); D.a < D.c.c.length;){
                C = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(D), 11);
                for(e = new $61de1ee1cac498ae$var$olb(C.e); e.a < e.c.c.length;){
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 17);
                    F = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$eyc)), 19).a;
                    l = $61de1ee1cac498ae$var$$wnd.Math.max(l, F);
                }
                for(d = new $61de1ee1cac498ae$var$olb(C.g); d.a < d.c.c.length;){
                    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 17);
                    F = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$eyc)), 19).a;
                    B = $61de1ee1cac498ae$var$$wnd.Math.max(B, F);
                }
            }
            $61de1ee1cac498ae$var$yNb(u, $61de1ee1cac498ae$var$hJc, $61de1ee1cac498ae$var$meb(l));
            $61de1ee1cac498ae$var$yNb(u, $61de1ee1cac498ae$var$iJc, $61de1ee1cac498ae$var$meb(B));
        }
    }
    r = 0;
    for(n = new $61de1ee1cac498ae$var$olb(b.b); n.a < n.c.c.length;){
        m = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(n), 29);
        for(v = new $61de1ee1cac498ae$var$olb(m.a); v.a < v.c.c.length;){
            u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(v), 10);
            if (u.p < 0) {
                H = new $61de1ee1cac498ae$var$zJc;
                H.b = r++;
                $61de1ee1cac498ae$var$oJc(a, u, H);
                I.c[I.c.length] = H;
            }
        }
    }
    A = $61de1ee1cac498ae$var$Pu(I.c.length);
    k = $61de1ee1cac498ae$var$Pu(I.c.length);
    for(g = 0; g < I.c.length; g++){
        $61de1ee1cac498ae$var$Ekb(A, new $61de1ee1cac498ae$var$Rkb);
        $61de1ee1cac498ae$var$Ekb(k, $61de1ee1cac498ae$var$meb(0));
    }
    $61de1ee1cac498ae$var$mJc(b, I, A, k);
    J = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(I, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sY, $61de1ee1cac498ae$var$Iqe, 257, I.c.length, 0, 1)), 840);
    w = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qkb(A, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, A.c.length, 0, 1)), 192);
    j = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, k.c.length, 15, 1);
    for(h = 0; h < j.length; h++)j[h] = ($61de1ee1cac498ae$var$tCb(h, k.c.length), $61de1ee1cac498ae$var$BD(k.c[h], 19)).a;
    s = 0;
    t = new $61de1ee1cac498ae$var$Rkb;
    for(i = 0; i < J.length; i++)j[i] == 0 && $61de1ee1cac498ae$var$Ekb(t, J[i]);
    q = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, J.length, 15, 1);
    while(t.c.length != 0){
        H = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Kkb(t, 0), 257);
        q[H.b] = s++;
        while(!w[H.b].dc()){
            K = $61de1ee1cac498ae$var$BD(w[H.b].$c(0), 257);
            --j[K.b];
            j[K.b] == 0 && (t.c[t.c.length] = K);
        }
    }
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sY, $61de1ee1cac498ae$var$Iqe, 257, J.length, 0, 1);
    for(f = 0; f < J.length; f++){
        p = J[f];
        G = q[f];
        a.a[G] = p;
        p.b = G;
        for(v = new $61de1ee1cac498ae$var$olb(p.e); v.a < v.c.c.length;){
            u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(v), 10);
            u.p = G;
        }
    }
    return a.a;
}
function $61de1ee1cac498ae$var$nde(a) {
    var b, c, d;
    if (a.d >= a.j) {
        a.a = -1;
        a.c = 1;
        return;
    }
    b = $61de1ee1cac498ae$var$bfb(a.i, a.d++);
    a.a = b;
    if (a.b == 1) {
        switch(b){
            case 92:
                d = 10;
                if (a.d >= a.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$uue))));
                a.a = $61de1ee1cac498ae$var$bfb(a.i, a.d++);
                break;
            case 45:
                if ((a.e & 512) == 512 && a.d < a.j && $61de1ee1cac498ae$var$bfb(a.i, a.d) == 91) {
                    ++a.d;
                    d = 24;
                } else d = 0;
                break;
            case 91:
                if ((a.e & 512) != 512 && a.d < a.j && $61de1ee1cac498ae$var$bfb(a.i, a.d) == 58) {
                    ++a.d;
                    d = 20;
                    break;
                }
            default:
                if ((b & 64512) == $61de1ee1cac498ae$var$Uje && a.d < a.j) {
                    c = $61de1ee1cac498ae$var$bfb(a.i, a.d);
                    if ((c & 64512) == 56320) {
                        a.a = $61de1ee1cac498ae$var$Tje + (b - $61de1ee1cac498ae$var$Uje << 10) + c - 56320;
                        ++a.d;
                    }
                }
                d = 0;
        }
        a.c = d;
        return;
    }
    switch(b){
        case 124:
            d = 2;
            break;
        case 42:
            d = 3;
            break;
        case 43:
            d = 4;
            break;
        case 63:
            d = 5;
            break;
        case 41:
            d = 7;
            break;
        case 46:
            d = 8;
            break;
        case 91:
            d = 9;
            break;
        case 94:
            d = 11;
            break;
        case 36:
            d = 12;
            break;
        case 40:
            d = 6;
            if (a.d >= a.j) break;
            if ($61de1ee1cac498ae$var$bfb(a.i, a.d) != 63) break;
            if (++a.d >= a.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$vue))));
            b = $61de1ee1cac498ae$var$bfb(a.i, a.d++);
            switch(b){
                case 58:
                    d = 13;
                    break;
                case 61:
                    d = 14;
                    break;
                case 33:
                    d = 15;
                    break;
                case 91:
                    d = 19;
                    break;
                case 62:
                    d = 18;
                    break;
                case 60:
                    if (a.d >= a.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$vue))));
                    b = $61de1ee1cac498ae$var$bfb(a.i, a.d++);
                    if (b == 61) d = 16;
                    else if (b == 33) d = 17;
                    else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$wue))));
                    break;
                case 35:
                    while(a.d < a.j){
                        b = $61de1ee1cac498ae$var$bfb(a.i, a.d++);
                        if (b == 41) break;
                    }
                    if (b != 41) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$xue))));
                    d = 21;
                    break;
                default:
                    if (b == 45 || 97 <= b && b <= 122 || 65 <= b && b <= 90) {
                        --a.d;
                        d = 22;
                        break;
                    } else if (b == 40) {
                        d = 23;
                        break;
                    }
                    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$vue))));
            }
            break;
        case 92:
            d = 10;
            if (a.d >= a.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$uue))));
            a.a = $61de1ee1cac498ae$var$bfb(a.i, a.d++);
            break;
        default:
            d = 0;
    }
    a.c = d;
}
function $61de1ee1cac498ae$var$P5b(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    A = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Vxc)), 98);
    if (!(A != ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$bcd) && A != $61de1ee1cac498ae$var$ccd)) return;
    o = a.b;
    n = o.c.length;
    k = new $61de1ee1cac498ae$var$Skb(($61de1ee1cac498ae$var$Xj(n + 2, $61de1ee1cac498ae$var$Mie), $61de1ee1cac498ae$var$Oy($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$wbb(5, n + 2), (n + 2) / 10 | 0))));
    p = new $61de1ee1cac498ae$var$Skb(($61de1ee1cac498ae$var$Xj(n + 2, $61de1ee1cac498ae$var$Mie), $61de1ee1cac498ae$var$Oy($61de1ee1cac498ae$var$wbb($61de1ee1cac498ae$var$wbb(5, n + 2), (n + 2) / 10 | 0))));
    $61de1ee1cac498ae$var$Ekb(k, new $61de1ee1cac498ae$var$Lqb);
    $61de1ee1cac498ae$var$Ekb(k, new $61de1ee1cac498ae$var$Lqb);
    $61de1ee1cac498ae$var$Ekb(p, new $61de1ee1cac498ae$var$Rkb);
    $61de1ee1cac498ae$var$Ekb(p, new $61de1ee1cac498ae$var$Rkb);
    w = new $61de1ee1cac498ae$var$Rkb;
    for(b = 0; b < n; b++){
        c = ($61de1ee1cac498ae$var$tCb(b, o.c.length), $61de1ee1cac498ae$var$BD(o.c[b], 29));
        B = ($61de1ee1cac498ae$var$tCb(b, k.c.length), $61de1ee1cac498ae$var$BD(k.c[b], 83));
        q = new $61de1ee1cac498ae$var$Lqb;
        k.c[k.c.length] = q;
        D = ($61de1ee1cac498ae$var$tCb(b, p.c.length), $61de1ee1cac498ae$var$BD(p.c[b], 15));
        s = new $61de1ee1cac498ae$var$Rkb;
        p.c[p.c.length] = s;
        for(e = new $61de1ee1cac498ae$var$olb(c.a); e.a < e.c.c.length;){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
            if ($61de1ee1cac498ae$var$L5b(d)) {
                w.c[w.c.length] = d;
                continue;
            }
            for(j = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(d).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(j);){
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(j), 17);
                F = h.c.i;
                if (!$61de1ee1cac498ae$var$L5b(F)) continue;
                C = $61de1ee1cac498ae$var$BD(B.xc($61de1ee1cac498ae$var$vNb(F, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc))), 10);
                if (!C) {
                    C = $61de1ee1cac498ae$var$K5b(a, F);
                    B.zc($61de1ee1cac498ae$var$vNb(F, $61de1ee1cac498ae$var$$sc), C);
                    D.Fc(C);
                }
                $61de1ee1cac498ae$var$QZb(h, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(C.j, 1), 11));
            }
            for(i = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(d).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(i);){
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(i), 17);
                G = h.d.i;
                if (!$61de1ee1cac498ae$var$L5b(G)) continue;
                r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(q, $61de1ee1cac498ae$var$vNb(G, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc))), 10);
                if (!r) {
                    r = $61de1ee1cac498ae$var$K5b(a, G);
                    $61de1ee1cac498ae$var$Rhb(q, $61de1ee1cac498ae$var$vNb(G, $61de1ee1cac498ae$var$$sc), r);
                    s.c[s.c.length] = r;
                }
                $61de1ee1cac498ae$var$RZb(h, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(r.j, 0), 11));
            }
        }
    }
    for(l = 0; l < p.c.length; l++){
        t = ($61de1ee1cac498ae$var$tCb(l, p.c.length), $61de1ee1cac498ae$var$BD(p.c[l], 15));
        if (t.dc()) continue;
        m = null;
        if (l == 0) {
            m = new $61de1ee1cac498ae$var$H1b(a);
            $61de1ee1cac498ae$var$wCb(0, o.c.length);
            $61de1ee1cac498ae$var$aCb(o.c, 0, m);
        } else if (l == k.c.length - 1) {
            m = new $61de1ee1cac498ae$var$H1b(a);
            o.c[o.c.length] = m;
        } else m = ($61de1ee1cac498ae$var$tCb(l - 1, o.c.length), $61de1ee1cac498ae$var$BD(o.c[l - 1], 29));
        for(g = t.Kc(); g.Ob();){
            f = $61de1ee1cac498ae$var$BD(g.Pb(), 10);
            $61de1ee1cac498ae$var$$_b(f, m);
        }
    }
    for(v = new $61de1ee1cac498ae$var$olb(w); v.a < v.c.c.length;){
        u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(v), 10);
        $61de1ee1cac498ae$var$$_b(u, null);
    }
    $61de1ee1cac498ae$var$yNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Fsc), w);
}
function $61de1ee1cac498ae$var$BCc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v;
    $61de1ee1cac498ae$var$Odd(c, "Coffman-Graham Layering", 1);
    if (b.a.c.length == 0) {
        $61de1ee1cac498ae$var$Qdd(c);
        return;
    }
    v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$kxc)), 19).a;
    i = 0;
    g = 0;
    for(m = new $61de1ee1cac498ae$var$olb(b.a); m.a < m.c.c.length;){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 10);
        l.p = i++;
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(l).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            e.p = g++;
        }
    }
    a.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, i, 16, 1);
    a.a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$sbb, $61de1ee1cac498ae$var$dle, 25, g, 16, 1);
    a.b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, i, 15, 1);
    a.e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, i, 15, 1);
    a.f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, i, 15, 1);
    $61de1ee1cac498ae$var$Nc(a.c);
    $61de1ee1cac498ae$var$CCc(a, b);
    o = new $61de1ee1cac498ae$var$gub(new $61de1ee1cac498ae$var$GCc(a));
    for(u = new $61de1ee1cac498ae$var$olb(b.a); u.a < u.c.c.length;){
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 10);
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(s).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            a.a[e.p] || ++a.b[s.p];
        }
        a.b[s.p] == 0 && $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(o, s));
    }
    h = 0;
    while(o.b.c.length != 0){
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$dub(o), 10);
        a.f[s.p] = h++;
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(s).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            if (a.a[e.p]) continue;
            q = e.d.i;
            --a.b[q.p];
            $61de1ee1cac498ae$var$Rc(a.c, q, $61de1ee1cac498ae$var$meb(a.f[s.p]));
            a.b[q.p] == 0 && $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(o, q));
        }
    }
    n = new $61de1ee1cac498ae$var$gub(new $61de1ee1cac498ae$var$KCc(a));
    for(t = new $61de1ee1cac498ae$var$olb(b.a); t.a < t.c.c.length;){
        s = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(t), 10);
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(s).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            a.a[e.p] || ++a.e[s.p];
        }
        a.e[s.p] == 0 && $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(n, s));
    }
    k = new $61de1ee1cac498ae$var$Rkb;
    d = $61de1ee1cac498ae$var$yCc(b, k);
    while(n.b.c.length != 0){
        r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$dub(n), 10);
        (d.a.c.length >= v || !$61de1ee1cac498ae$var$wCc(r, d)) && (d = $61de1ee1cac498ae$var$yCc(b, k));
        $61de1ee1cac498ae$var$$_b(r, d);
        for(f = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(r).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(f);){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(f), 17);
            if (a.a[e.p]) continue;
            p = e.c.i;
            --a.e[p.p];
            a.e[p.p] == 0 && $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(n, p));
        }
    }
    for(j = k.c.length - 1; j >= 0; --j)$61de1ee1cac498ae$var$Ekb(b.b, ($61de1ee1cac498ae$var$tCb(j, k.c.length), $61de1ee1cac498ae$var$BD(k.c[j], 29)));
    b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$gee(a) {
    var b, c, d, e, f, g, h, i, j;
    a.b = 1;
    $61de1ee1cac498ae$var$nde(a);
    b = null;
    if (a.c == 0 && a.a == 94) {
        $61de1ee1cac498ae$var$nde(a);
        b = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ufe(b, 0, $61de1ee1cac498ae$var$lxe);
        h = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    } else h = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    e = true;
    while((j = a.c) != 1){
        if (j == 0 && a.a == 93 && !e) {
            if (b) {
                $61de1ee1cac498ae$var$Zfe(b, h);
                h = b;
            }
            break;
        }
        c = a.a;
        d = false;
        if (j == 10) switch(c){
            case 100:
            case 68:
            case 119:
            case 87:
            case 115:
            case 83:
                $61de1ee1cac498ae$var$Xfe(h, $61de1ee1cac498ae$var$fee(c));
                d = true;
                break;
            case 105:
            case 73:
            case 99:
            case 67:
                c = ($61de1ee1cac498ae$var$Xfe(h, $61de1ee1cac498ae$var$fee(c)), -1);
                c < 0 && (d = true);
                break;
            case 112:
            case 80:
                i = $61de1ee1cac498ae$var$tde(a, c);
                if (!i) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Iue))));
                $61de1ee1cac498ae$var$Xfe(h, i);
                d = true;
                break;
            default:
                c = $61de1ee1cac498ae$var$eee(a);
        }
        else if (j == 24 && !e) {
            if (b) {
                $61de1ee1cac498ae$var$Zfe(b, h);
                h = b;
            }
            f = $61de1ee1cac498ae$var$gee(a);
            $61de1ee1cac498ae$var$Zfe(h, f);
            if (a.c != 0 || a.a != 93) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Mue))));
            break;
        }
        $61de1ee1cac498ae$var$nde(a);
        if (!d) {
            if (j == 0) {
                if (c == 91) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Nue))));
                if (c == 93) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Oue))));
                if (c == 45 && !e && a.a != 93) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Pue))));
            }
            if (a.c != 0 || a.a != 45 || c == 45 && e) $61de1ee1cac498ae$var$Ufe(h, c, c);
            else {
                $61de1ee1cac498ae$var$nde(a);
                if ((j = a.c) == 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Kue))));
                if (j == 0 && a.a == 93) {
                    $61de1ee1cac498ae$var$Ufe(h, c, c);
                    $61de1ee1cac498ae$var$Ufe(h, 45, 45);
                } else if (j == 0 && a.a == 93 || j == 24) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Pue))));
                else {
                    g = a.a;
                    if (j == 0) {
                        if (g == 91) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Nue))));
                        if (g == 93) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Oue))));
                        if (g == 45) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Pue))));
                    } else j == 10 && (g = $61de1ee1cac498ae$var$eee(a));
                    $61de1ee1cac498ae$var$nde(a);
                    if (c > g) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Sue))));
                    $61de1ee1cac498ae$var$Ufe(h, c, g);
                }
            }
        }
        e = false;
    }
    if (a.c == 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Kue))));
    $61de1ee1cac498ae$var$Yfe(h);
    $61de1ee1cac498ae$var$Vfe(h);
    a.b = 0;
    $61de1ee1cac498ae$var$nde(a);
    return h;
}
function $61de1ee1cac498ae$var$xZd(a) {
    $61de1ee1cac498ae$var$Bnd(a.c, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#decimal"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.d, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#integer"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.e, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#boolean"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.f, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "EBoolean",
        $61de1ee1cac498ae$var$fue,
        "EBoolean:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.i, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#byte"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.g, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#hexBinary"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.j, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "EByte",
        $61de1ee1cac498ae$var$fue,
        "EByte:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.n, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "EChar",
        $61de1ee1cac498ae$var$fue,
        "EChar:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.t, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#double"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.u, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "EDouble",
        $61de1ee1cac498ae$var$fue,
        "EDouble:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.F, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#float"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.G, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "EFloat",
        $61de1ee1cac498ae$var$fue,
        "EFloat:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.I, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#int"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.J, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "EInt",
        $61de1ee1cac498ae$var$fue,
        "EInt:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.N, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#long"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.O, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "ELong",
        $61de1ee1cac498ae$var$fue,
        "ELong:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.Z, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#short"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.$, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "EShort",
        $61de1ee1cac498ae$var$fue,
        "EShort:Object"
    ]));
    $61de1ee1cac498ae$var$Bnd(a._, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$cwe,
        "http://www.w3.org/2001/XMLSchema#string"
    ]));
}
function $61de1ee1cac498ae$var$fRc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G;
    if (a.c.length == 1) return $61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 135);
    else if (a.c.length <= 0) return new $61de1ee1cac498ae$var$SRc;
    for(i = new $61de1ee1cac498ae$var$olb(a); i.a < i.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 135);
        s = 0;
        o = $61de1ee1cac498ae$var$Ohe;
        p = $61de1ee1cac498ae$var$Ohe;
        m = $61de1ee1cac498ae$var$Rie;
        n = $61de1ee1cac498ae$var$Rie;
        for(r = $61de1ee1cac498ae$var$Jsb(g.b, 0); r.b != r.d.c;){
            q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(r), 86);
            s += $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(q, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$ETc)), 19).a;
            o = $61de1ee1cac498ae$var$$wnd.Math.min(o, q.e.a);
            p = $61de1ee1cac498ae$var$$wnd.Math.min(p, q.e.b);
            m = $61de1ee1cac498ae$var$$wnd.Math.max(m, q.e.a + q.f.a);
            n = $61de1ee1cac498ae$var$$wnd.Math.max(n, q.e.b + q.f.b);
        }
        $61de1ee1cac498ae$var$yNb(g, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$ETc), $61de1ee1cac498ae$var$meb(s));
        $61de1ee1cac498ae$var$yNb(g, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$WSc), new $61de1ee1cac498ae$var$f7c(o, p));
        $61de1ee1cac498ae$var$yNb(g, $61de1ee1cac498ae$var$VSc, new $61de1ee1cac498ae$var$f7c(m, n));
    }
    $61de1ee1cac498ae$var$mmb();
    $61de1ee1cac498ae$var$Okb(a, new $61de1ee1cac498ae$var$jRc);
    v = new $61de1ee1cac498ae$var$SRc;
    $61de1ee1cac498ae$var$tNb(v, ($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 94)));
    l = 0;
    D = 0;
    for(j = new $61de1ee1cac498ae$var$olb(a); j.a < j.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 135);
        w = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$VSc)), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$WSc), 8));
        l = $61de1ee1cac498ae$var$$wnd.Math.max(l, w.a);
        D += w.a * w.b;
    }
    l = $61de1ee1cac498ae$var$$wnd.Math.max(l, $61de1ee1cac498ae$var$$wnd.Math.sqrt(D) * $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(v, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$uTc)))));
    A = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(v, $61de1ee1cac498ae$var$HTc)));
    F = 0;
    G = 0;
    k = 0;
    b = A;
    for(h = new $61de1ee1cac498ae$var$olb(a); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 135);
        w = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$VSc)), 8)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$WSc), 8));
        if (F + w.a > l) {
            F = 0;
            G += k + A;
            k = 0;
        }
        $61de1ee1cac498ae$var$eRc(v, g, F, G);
        b = $61de1ee1cac498ae$var$$wnd.Math.max(b, F + w.a);
        k = $61de1ee1cac498ae$var$$wnd.Math.max(k, w.b);
        F += w.a + A;
    }
    u = new $61de1ee1cac498ae$var$Lqb;
    c = new $61de1ee1cac498ae$var$Lqb;
    for(C = new $61de1ee1cac498ae$var$olb(a); C.a < C.c.c.length;){
        B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(C), 135);
        d = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(B, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$y8c))));
        t = !B.q ? $61de1ee1cac498ae$var$kmb : B.q;
        for(f = t.vc().Kc(); f.Ob();){
            e = $61de1ee1cac498ae$var$BD(f.Pb(), 42);
            if ($61de1ee1cac498ae$var$Mhb(u, e.cd())) {
                if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$BD(e.cd(), 146).wg()) !== $61de1ee1cac498ae$var$PD(e.dd())) {
                    if (d && $61de1ee1cac498ae$var$Mhb(c, e.cd())) {
                        $61de1ee1cac498ae$var$Zfb();
                        $61de1ee1cac498ae$var$BD(e.cd(), 146).tg();
                    } else {
                        $61de1ee1cac498ae$var$Rhb(u, $61de1ee1cac498ae$var$BD(e.cd(), 146), e.dd());
                        $61de1ee1cac498ae$var$yNb(v, $61de1ee1cac498ae$var$BD(e.cd(), 146), e.dd());
                        d && $61de1ee1cac498ae$var$Rhb(c, $61de1ee1cac498ae$var$BD(e.cd(), 146), e.dd());
                    }
                }
            } else {
                $61de1ee1cac498ae$var$Rhb(u, $61de1ee1cac498ae$var$BD(e.cd(), 146), e.dd());
                $61de1ee1cac498ae$var$yNb(v, $61de1ee1cac498ae$var$BD(e.cd(), 146), e.dd());
            }
        }
    }
    return v;
}
function $61de1ee1cac498ae$var$MYb() {
    $61de1ee1cac498ae$var$MYb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$xXb();
    $61de1ee1cac498ae$var$LYb = new $61de1ee1cac498ae$var$Hp;
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Gcd), $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Gcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Fcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Fcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Pcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Ocd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Qcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Qcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Qcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Qcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Hcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Fcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ocd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Pcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Ccd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Fcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Pcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Pcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Ecd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Fcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Dcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ocd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Mcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Fcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ocd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Icd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Jcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Qcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Bcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Fcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Gcd);
    $61de1ee1cac498ae$var$Rc($61de1ee1cac498ae$var$LYb, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Ocd);
}
function $61de1ee1cac498ae$var$HVd(a, b) {
    switch(a.e){
        case 0:
        case 2:
        case 4:
        case 6:
        case 42:
        case 44:
        case 46:
        case 48:
        case 8:
        case 10:
        case 12:
        case 14:
        case 16:
        case 18:
        case 20:
        case 22:
        case 24:
        case 26:
        case 28:
        case 30:
        case 32:
        case 34:
        case 36:
        case 38:
            return new $61de1ee1cac498ae$var$U5d(a.b, a.a, b, a.c);
        case 1:
            return new $61de1ee1cac498ae$var$BMd(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 43:
            return new $61de1ee1cac498ae$var$N4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 3:
            return new $61de1ee1cac498ae$var$xMd(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 45:
            return new $61de1ee1cac498ae$var$K4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 41:
            return new $61de1ee1cac498ae$var$dId($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$wId(a.c), 26), a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 50:
            return new $61de1ee1cac498ae$var$c6d($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$wId(a.c), 26), a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 5:
            return new $61de1ee1cac498ae$var$Q4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 47:
            return new $61de1ee1cac498ae$var$U4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 7:
            return new $61de1ee1cac498ae$var$cUd(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 49:
            return new $61de1ee1cac498ae$var$gUd(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 9:
            return new $61de1ee1cac498ae$var$I4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 11:
            return new $61de1ee1cac498ae$var$G4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 13:
            return new $61de1ee1cac498ae$var$C4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 15:
            return new $61de1ee1cac498ae$var$k2d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 17:
            return new $61de1ee1cac498ae$var$c5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 19:
            return new $61de1ee1cac498ae$var$_4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 21:
            return new $61de1ee1cac498ae$var$X4d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 23:
            return new $61de1ee1cac498ae$var$pMd(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        case 25:
            return new $61de1ee1cac498ae$var$D5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 27:
            return new $61de1ee1cac498ae$var$y5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 29:
            return new $61de1ee1cac498ae$var$t5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 31:
            return new $61de1ee1cac498ae$var$n5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 33:
            return new $61de1ee1cac498ae$var$A5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 35:
            return new $61de1ee1cac498ae$var$v5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 37:
            return new $61de1ee1cac498ae$var$p5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 39:
            return new $61de1ee1cac498ae$var$i5d(a.a, b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c), a.d.n);
        case 40:
            return new $61de1ee1cac498ae$var$u3d(b, $61de1ee1cac498ae$var$bLd(b.Tg(), a.c));
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Unknown feature style: " + a.e));
    }
}
function $61de1ee1cac498ae$var$BMc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    $61de1ee1cac498ae$var$Odd(c, "Brandes & Koepf node placement", 1);
    a.a = b;
    a.c = $61de1ee1cac498ae$var$KMc(b);
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$zxc)), 274);
    n = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$Axc)));
    a.d = d == ($61de1ee1cac498ae$var$lrc(), $61de1ee1cac498ae$var$irc) && !n || d == $61de1ee1cac498ae$var$frc;
    $61de1ee1cac498ae$var$AMc(a, b);
    v = null;
    w = null;
    r = null;
    s = null;
    q = ($61de1ee1cac498ae$var$Xj(4, $61de1ee1cac498ae$var$Jie), new $61de1ee1cac498ae$var$Skb(4));
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$zxc), 274).g){
        case 3:
            r = new $61de1ee1cac498ae$var$ULc(b, a.c.d, ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$cMc), ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc));
            q.c[q.c.length] = r;
            break;
        case 1:
            s = new $61de1ee1cac498ae$var$ULc(b, a.c.d, ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc), ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc));
            q.c[q.c.length] = s;
            break;
        case 4:
            v = new $61de1ee1cac498ae$var$ULc(b, a.c.d, ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$cMc), ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$XLc));
            q.c[q.c.length] = v;
            break;
        case 2:
            w = new $61de1ee1cac498ae$var$ULc(b, a.c.d, ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc), ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$XLc));
            q.c[q.c.length] = w;
            break;
        default:
            r = new $61de1ee1cac498ae$var$ULc(b, a.c.d, ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$cMc), ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$WLc));
            s = new $61de1ee1cac498ae$var$ULc(b, a.c.d, $61de1ee1cac498ae$var$dMc, $61de1ee1cac498ae$var$WLc);
            v = new $61de1ee1cac498ae$var$ULc(b, a.c.d, $61de1ee1cac498ae$var$cMc, $61de1ee1cac498ae$var$XLc);
            w = new $61de1ee1cac498ae$var$ULc(b, a.c.d, $61de1ee1cac498ae$var$dMc, $61de1ee1cac498ae$var$XLc);
            q.c[q.c.length] = v;
            q.c[q.c.length] = w;
            q.c[q.c.length] = r;
            q.c[q.c.length] = s;
    }
    e = new $61de1ee1cac498ae$var$mMc(b, a.c);
    for(h = new $61de1ee1cac498ae$var$olb(q); h.a < h.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 180);
        $61de1ee1cac498ae$var$lMc(e, f, a.b);
        $61de1ee1cac498ae$var$kMc(f);
    }
    m = new $61de1ee1cac498ae$var$rMc(b, a.c);
    for(i = new $61de1ee1cac498ae$var$olb(q); i.a < i.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 180);
        $61de1ee1cac498ae$var$oMc(m, f);
    }
    if (c.n) for(j = new $61de1ee1cac498ae$var$olb(q); j.a < j.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 180);
        $61de1ee1cac498ae$var$Sdd(c, f + " size is " + $61de1ee1cac498ae$var$SLc(f));
    }
    l = null;
    if (a.d) {
        k = $61de1ee1cac498ae$var$yMc(a, q, a.c.d);
        $61de1ee1cac498ae$var$xMc(b, k, c) && (l = k);
    }
    if (!l) for(j = new $61de1ee1cac498ae$var$olb(q); j.a < j.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 180);
        $61de1ee1cac498ae$var$xMc(b, f, c) && (!l || $61de1ee1cac498ae$var$SLc(l) > $61de1ee1cac498ae$var$SLc(f)) && (l = f);
    }
    !l && (l = ($61de1ee1cac498ae$var$tCb(0, q.c.length), $61de1ee1cac498ae$var$BD(q.c[0], 180)));
    for(p = new $61de1ee1cac498ae$var$olb(b.b); p.a < p.c.c.length;){
        o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 29);
        for(u = new $61de1ee1cac498ae$var$olb(o.a); u.a < u.c.c.length;){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(u), 10);
            t.n.b = $61de1ee1cac498ae$var$Edb(l.p[t.p]) + $61de1ee1cac498ae$var$Edb(l.d[t.p]);
        }
    }
    if (c.n) {
        $61de1ee1cac498ae$var$Sdd(c, "Chosen node placement: " + l);
        $61de1ee1cac498ae$var$Sdd(c, "Blocks: " + $61de1ee1cac498ae$var$DMc(l));
        $61de1ee1cac498ae$var$Sdd(c, "Classes: " + $61de1ee1cac498ae$var$EMc(l, c));
        $61de1ee1cac498ae$var$Sdd(c, "Marked edges: " + a.b);
    }
    for(g = new $61de1ee1cac498ae$var$olb(q); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 180);
        f.g = null;
        f.b = null;
        f.a = null;
        f.d = null;
        f.j = null;
        f.i = null;
        f.p = null;
    }
    $61de1ee1cac498ae$var$IMc(a.c);
    a.b.a.$b();
    $61de1ee1cac498ae$var$Qdd(c);
}
function $61de1ee1cac498ae$var$V1b(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    g = new $61de1ee1cac498ae$var$Psb;
    v = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Lwc)), 103);
    o = 0;
    $61de1ee1cac498ae$var$ye(g, (!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, b, 10, 11)), b.a));
    while(g.b != 0){
        j = $61de1ee1cac498ae$var$BD(g.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(g.b != 0), $61de1ee1cac498ae$var$Nsb(g, g.a.a)), 33);
        ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$ywc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$lqc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$jqc)) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Awc))) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$twc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$QXb))) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(j, $61de1ee1cac498ae$var$xwc))) && $61de1ee1cac498ae$var$jkd(j, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc), $61de1ee1cac498ae$var$meb(o++));
        q = !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(j, $61de1ee1cac498ae$var$Jxc)));
        if (q) {
            l = (!j.a && (j.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, j, 10, 11)), j.a).i != 0;
            n = $61de1ee1cac498ae$var$S1b(j);
            m = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(j, $61de1ee1cac498ae$var$axc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd));
            F = !$61de1ee1cac498ae$var$ikd(j, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$o8c)) || $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$hkd(j, $61de1ee1cac498ae$var$o8c)), $61de1ee1cac498ae$var$sne);
            t = null;
            if (F && m && (l || n)) {
                t = $61de1ee1cac498ae$var$P1b(j);
                $61de1ee1cac498ae$var$yNb(t, $61de1ee1cac498ae$var$Lwc, v);
                $61de1ee1cac498ae$var$wNb(t, $61de1ee1cac498ae$var$hyc) && $61de1ee1cac498ae$var$Wyc(new $61de1ee1cac498ae$var$ezc($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(t, $61de1ee1cac498ae$var$hyc)))), t);
                if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(j, $61de1ee1cac498ae$var$Fxc), 174).gc() != 0) {
                    k = t;
                    $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, (!j.c && (j.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, j, 9, 9)), new $61de1ee1cac498ae$var$Kub(j.c, 16))), new $61de1ee1cac498ae$var$k2b(k));
                    $61de1ee1cac498ae$var$L1b(j, t);
                }
            }
            w = c;
            A = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, $61de1ee1cac498ae$var$Xod(j)), 10);
            !!A && (w = A.e);
            s = $61de1ee1cac498ae$var$$1b(a, j, w);
            if (t) {
                s.e = t;
                t.e = s;
                $61de1ee1cac498ae$var$ye(g, (!j.a && (j.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, j, 10, 11)), j.a));
            }
        }
    }
    o = 0;
    $61de1ee1cac498ae$var$Gsb(g, b, g.c.b, g.c);
    while(g.b != 0){
        f = $61de1ee1cac498ae$var$BD(g.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(g.b != 0), $61de1ee1cac498ae$var$Nsb(g, g.a.a)), 33);
        for(i = new $61de1ee1cac498ae$var$Fyd((!f.b && (f.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, f, 12, 3)), f.b)); i.e != i.i.gc();){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 79);
            $61de1ee1cac498ae$var$N1b(h);
            ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$ywc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$lqc)) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Jwc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$jqc)) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$Awc))) || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(b, $61de1ee1cac498ae$var$twc)) !== $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$QXb))) && $61de1ee1cac498ae$var$jkd(h, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc), $61de1ee1cac498ae$var$meb(o++));
            C = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!h.b && (h.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, h, 4, 7)), h.b), 0), 82));
            D = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!h.c && (h.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, h, 5, 8)), h.c), 0), 82));
            if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$Jxc))) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(C, $61de1ee1cac498ae$var$Jxc))) || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(D, $61de1ee1cac498ae$var$Jxc)))) continue;
            p = $61de1ee1cac498ae$var$Qld(h) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(C, $61de1ee1cac498ae$var$fxc))) && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$gxc)));
            u = f;
            p || $61de1ee1cac498ae$var$ntd(D, C) ? u = C : $61de1ee1cac498ae$var$ntd(C, D) && (u = D);
            w = c;
            A = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, u), 10);
            !!A && (w = A.e);
            r = $61de1ee1cac498ae$var$X1b(a, h, u, w);
            $61de1ee1cac498ae$var$yNb(r, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$xsc), $61de1ee1cac498ae$var$R1b(a, h, b, c));
        }
        m = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(f, $61de1ee1cac498ae$var$axc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd));
        if (m) for(e = new $61de1ee1cac498ae$var$Fyd((!f.a && (f.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, f, 10, 11)), f.a)); e.e != e.i.gc();){
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(e), 33);
            F = !$61de1ee1cac498ae$var$ikd(d, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$o8c)) || $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$o8c)), $61de1ee1cac498ae$var$sne);
            B = $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(d, $61de1ee1cac498ae$var$axc)) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$ebd);
            F && B && $61de1ee1cac498ae$var$Gsb(g, d, g.c.b, g.c);
        }
    }
}
function $61de1ee1cac498ae$var$vA(a, b, c, d, e, f) {
    var g, h, i, j, k, l, m, n, o, p, q, r;
    switch(b){
        case 71:
            h = d.q.getFullYear() - $61de1ee1cac498ae$var$nje >= -1900 ? 1 : 0;
            c >= 4 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                $61de1ee1cac498ae$var$pje,
                $61de1ee1cac498ae$var$qje
            ])[h]) : $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "BC",
                "AD"
            ])[h]);
            break;
        case 121:
            $61de1ee1cac498ae$var$kA(a, c, d);
            break;
        case 77:
            $61de1ee1cac498ae$var$jA(a, c, d);
            break;
        case 107:
            i = e.q.getHours();
            i == 0 ? $61de1ee1cac498ae$var$EA(a, 24, c) : $61de1ee1cac498ae$var$EA(a, i, c);
            break;
        case 83:
            $61de1ee1cac498ae$var$iA(a, c, e);
            break;
        case 69:
            k = d.q.getDay();
            c == 5 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "S",
                "M",
                "T",
                "W",
                "T",
                "F",
                "S"
            ])[k]) : c == 4 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                $61de1ee1cac498ae$var$rje,
                $61de1ee1cac498ae$var$sje,
                $61de1ee1cac498ae$var$tje,
                $61de1ee1cac498ae$var$uje,
                $61de1ee1cac498ae$var$vje,
                $61de1ee1cac498ae$var$wje,
                $61de1ee1cac498ae$var$xje
            ])[k]) : $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ])[k]);
            break;
        case 97:
            e.q.getHours() >= 12 && e.q.getHours() < 24 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "AM",
                "PM"
            ])[1]) : $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "AM",
                "PM"
            ])[0]);
            break;
        case 104:
            l = e.q.getHours() % 12;
            l == 0 ? $61de1ee1cac498ae$var$EA(a, 12, c) : $61de1ee1cac498ae$var$EA(a, l, c);
            break;
        case 75:
            m = e.q.getHours() % 12;
            $61de1ee1cac498ae$var$EA(a, m, c);
            break;
        case 72:
            n = e.q.getHours();
            $61de1ee1cac498ae$var$EA(a, n, c);
            break;
        case 99:
            o = d.q.getDay();
            c == 5 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "S",
                "M",
                "T",
                "W",
                "T",
                "F",
                "S"
            ])[o]) : c == 4 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                $61de1ee1cac498ae$var$rje,
                $61de1ee1cac498ae$var$sje,
                $61de1ee1cac498ae$var$tje,
                $61de1ee1cac498ae$var$uje,
                $61de1ee1cac498ae$var$vje,
                $61de1ee1cac498ae$var$wje,
                $61de1ee1cac498ae$var$xje
            ])[o]) : c == 3 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ])[o]) : $61de1ee1cac498ae$var$EA(a, o, 1);
            break;
        case 76:
            p = d.q.getMonth();
            c == 5 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "J",
                "F",
                "M",
                "A",
                "M",
                "J",
                "J",
                "A",
                "S",
                "O",
                "N",
                "D"
            ])[p]) : c == 4 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                $61de1ee1cac498ae$var$bje,
                $61de1ee1cac498ae$var$cje,
                $61de1ee1cac498ae$var$dje,
                $61de1ee1cac498ae$var$eje,
                $61de1ee1cac498ae$var$fje,
                $61de1ee1cac498ae$var$gje,
                $61de1ee1cac498ae$var$hje,
                $61de1ee1cac498ae$var$ije,
                $61de1ee1cac498ae$var$jje,
                $61de1ee1cac498ae$var$kje,
                $61de1ee1cac498ae$var$lje,
                $61de1ee1cac498ae$var$mje
            ])[p]) : c == 3 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                $61de1ee1cac498ae$var$fje,
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ])[p]) : $61de1ee1cac498ae$var$EA(a, p + 1, c);
            break;
        case 81:
            q = d.q.getMonth() / 3 | 0;
            c < 4 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "Q1",
                "Q2",
                "Q3",
                "Q4"
            ])[q]) : $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
                "1st quarter",
                "2nd quarter",
                "3rd quarter",
                "4th quarter"
            ])[q]);
            break;
        case 100:
            r = d.q.getDate();
            $61de1ee1cac498ae$var$EA(a, r, c);
            break;
        case 109:
            j = e.q.getMinutes();
            $61de1ee1cac498ae$var$EA(a, j, c);
            break;
        case 115:
            g = e.q.getSeconds();
            $61de1ee1cac498ae$var$EA(a, g, c);
            break;
        case 122:
            c < 4 ? $61de1ee1cac498ae$var$Qfb(a, f.c[0]) : $61de1ee1cac498ae$var$Qfb(a, f.c[1]);
            break;
        case 118:
            $61de1ee1cac498ae$var$Qfb(a, f.b);
            break;
        case 90:
            c < 3 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$OA(f)) : c == 3 ? $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$NA(f)) : $61de1ee1cac498ae$var$Qfb(a, $61de1ee1cac498ae$var$QA(f.a));
            break;
        default:
            return false;
    }
    return true;
}
function $61de1ee1cac498ae$var$X1b(a, b, c, d) {
    var e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H;
    $61de1ee1cac498ae$var$N1b(b);
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.b && (b.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 4, 7)), b.b), 0), 82);
    k = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.c && (b.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 5, 8)), b.c), 0), 82);
    h = $61de1ee1cac498ae$var$atd(i);
    j = $61de1ee1cac498ae$var$atd(k);
    g = (!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, b, 6, 6)), b.a).i == 0 ? null : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.a && (b.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, b, 6, 6)), b.a), 0), 202);
    A = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, h), 10);
    F = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, j), 10);
    B = null;
    G = null;
    if ($61de1ee1cac498ae$var$JD(i, 186)) {
        w = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, i), 299);
        if ($61de1ee1cac498ae$var$JD(w, 11)) B = $61de1ee1cac498ae$var$BD(w, 11);
        else if ($61de1ee1cac498ae$var$JD(w, 10)) {
            A = $61de1ee1cac498ae$var$BD(w, 10);
            B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(A.j, 0), 11);
        }
    }
    if ($61de1ee1cac498ae$var$JD(k, 186)) {
        D = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(a.a, k), 299);
        if ($61de1ee1cac498ae$var$JD(D, 11)) G = $61de1ee1cac498ae$var$BD(D, 11);
        else if ($61de1ee1cac498ae$var$JD(D, 10)) {
            F = $61de1ee1cac498ae$var$BD(D, 10);
            G = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(F.j, 0), 11);
        }
    }
    if (!A || !F) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$z2c("The source or the target of edge " + b + " could not be found. " + "This usually happens when an edge connects a node laid out by ELK Layered to a node in " + "another level of hierarchy laid out by either another instance of ELK Layered or another " + "layout algorithm alltogether. The former can be solved by setting the hierarchyHandling " + "option to INCLUDE_CHILDREN."));
    p = new $61de1ee1cac498ae$var$UZb;
    $61de1ee1cac498ae$var$tNb(p, b);
    $61de1ee1cac498ae$var$yNb(p, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc), b);
    $61de1ee1cac498ae$var$yNb(p, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc), null);
    n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Ksc), 21);
    A == F && n.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Nrc));
    if (!B) {
        v = ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc);
        C = null;
        if (!!g && $61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(A, $61de1ee1cac498ae$var$Vxc), 98))) {
            C = new $61de1ee1cac498ae$var$f7c(g.j, g.k);
            $61de1ee1cac498ae$var$Bfd(C, $61de1ee1cac498ae$var$Mld(b));
            $61de1ee1cac498ae$var$Cfd(C, c);
            if ($61de1ee1cac498ae$var$ntd(j, h)) {
                v = $61de1ee1cac498ae$var$HAc;
                $61de1ee1cac498ae$var$P6c(C, A.n);
            }
        }
        B = $61de1ee1cac498ae$var$$$b(A, C, v, d);
    }
    if (!G) {
        v = ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc);
        H = null;
        if (!!g && $61de1ee1cac498ae$var$fcd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(F, $61de1ee1cac498ae$var$Vxc), 98))) {
            H = new $61de1ee1cac498ae$var$f7c(g.b, g.c);
            $61de1ee1cac498ae$var$Bfd(H, $61de1ee1cac498ae$var$Mld(b));
            $61de1ee1cac498ae$var$Cfd(H, c);
        }
        G = $61de1ee1cac498ae$var$$$b(F, H, v, $61de1ee1cac498ae$var$Q_b(F));
    }
    $61de1ee1cac498ae$var$QZb(p, B);
    $61de1ee1cac498ae$var$RZb(p, G);
    (B.e.c.length > 1 || B.g.c.length > 1 || G.e.c.length > 1 || G.g.c.length > 1) && n.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Irc));
    for(m = new $61de1ee1cac498ae$var$Fyd((!b.n && (b.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, b, 1, 7)), b.n)); m.e != m.i.gc();){
        l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(m), 137);
        if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(l, $61de1ee1cac498ae$var$Jxc))) && !!l.a) {
            q = $61de1ee1cac498ae$var$Z1b(l);
            $61de1ee1cac498ae$var$Ekb(p.b, q);
            switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(q, $61de1ee1cac498ae$var$Qwc), 272).g){
                case 1:
                case 2:
                    n.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Grc));
                    break;
                case 0:
                    n.Fc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Erc));
                    $61de1ee1cac498ae$var$yNb(q, $61de1ee1cac498ae$var$Qwc, ($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$nad));
            }
        }
    }
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Iwc), 314);
    r = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(d, $61de1ee1cac498ae$var$Exc), 315);
    e = f == ($61de1ee1cac498ae$var$Rpc(), $61de1ee1cac498ae$var$Opc) || r == ($61de1ee1cac498ae$var$Vzc(), $61de1ee1cac498ae$var$Rzc);
    if (!!g && (!g.a && (g.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, g, 5)), g.a).i != 0 && e) {
        s = $61de1ee1cac498ae$var$ofd(g);
        o = new $61de1ee1cac498ae$var$s7c;
        for(u = $61de1ee1cac498ae$var$Jsb(s, 0); u.b != u.d.c;){
            t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(u), 8);
            $61de1ee1cac498ae$var$Dsb(o, new $61de1ee1cac498ae$var$g7c(t));
        }
        $61de1ee1cac498ae$var$yNb(p, $61de1ee1cac498ae$var$_sc, o);
    }
    return p;
}
function $61de1ee1cac498ae$var$yZd(a) {
    if (a.gb) return;
    a.gb = true;
    a.b = $61de1ee1cac498ae$var$Lnd(a, 0);
    $61de1ee1cac498ae$var$Knd(a.b, 18);
    $61de1ee1cac498ae$var$Qnd(a.b, 19);
    a.a = $61de1ee1cac498ae$var$Lnd(a, 1);
    $61de1ee1cac498ae$var$Knd(a.a, 1);
    $61de1ee1cac498ae$var$Qnd(a.a, 2);
    $61de1ee1cac498ae$var$Qnd(a.a, 3);
    $61de1ee1cac498ae$var$Qnd(a.a, 4);
    $61de1ee1cac498ae$var$Qnd(a.a, 5);
    a.o = $61de1ee1cac498ae$var$Lnd(a, 2);
    $61de1ee1cac498ae$var$Knd(a.o, 8);
    $61de1ee1cac498ae$var$Knd(a.o, 9);
    $61de1ee1cac498ae$var$Qnd(a.o, 10);
    $61de1ee1cac498ae$var$Qnd(a.o, 11);
    $61de1ee1cac498ae$var$Qnd(a.o, 12);
    $61de1ee1cac498ae$var$Qnd(a.o, 13);
    $61de1ee1cac498ae$var$Qnd(a.o, 14);
    $61de1ee1cac498ae$var$Qnd(a.o, 15);
    $61de1ee1cac498ae$var$Qnd(a.o, 16);
    $61de1ee1cac498ae$var$Qnd(a.o, 17);
    $61de1ee1cac498ae$var$Qnd(a.o, 18);
    $61de1ee1cac498ae$var$Qnd(a.o, 19);
    $61de1ee1cac498ae$var$Qnd(a.o, 20);
    $61de1ee1cac498ae$var$Qnd(a.o, 21);
    $61de1ee1cac498ae$var$Qnd(a.o, 22);
    $61de1ee1cac498ae$var$Qnd(a.o, 23);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    $61de1ee1cac498ae$var$Pnd(a.o);
    a.p = $61de1ee1cac498ae$var$Lnd(a, 3);
    $61de1ee1cac498ae$var$Knd(a.p, 2);
    $61de1ee1cac498ae$var$Knd(a.p, 3);
    $61de1ee1cac498ae$var$Knd(a.p, 4);
    $61de1ee1cac498ae$var$Knd(a.p, 5);
    $61de1ee1cac498ae$var$Qnd(a.p, 6);
    $61de1ee1cac498ae$var$Qnd(a.p, 7);
    $61de1ee1cac498ae$var$Pnd(a.p);
    $61de1ee1cac498ae$var$Pnd(a.p);
    a.q = $61de1ee1cac498ae$var$Lnd(a, 4);
    $61de1ee1cac498ae$var$Knd(a.q, 8);
    a.v = $61de1ee1cac498ae$var$Lnd(a, 5);
    $61de1ee1cac498ae$var$Qnd(a.v, 9);
    $61de1ee1cac498ae$var$Pnd(a.v);
    $61de1ee1cac498ae$var$Pnd(a.v);
    $61de1ee1cac498ae$var$Pnd(a.v);
    a.w = $61de1ee1cac498ae$var$Lnd(a, 6);
    $61de1ee1cac498ae$var$Knd(a.w, 2);
    $61de1ee1cac498ae$var$Knd(a.w, 3);
    $61de1ee1cac498ae$var$Knd(a.w, 4);
    $61de1ee1cac498ae$var$Qnd(a.w, 5);
    a.B = $61de1ee1cac498ae$var$Lnd(a, 7);
    $61de1ee1cac498ae$var$Qnd(a.B, 1);
    $61de1ee1cac498ae$var$Pnd(a.B);
    $61de1ee1cac498ae$var$Pnd(a.B);
    $61de1ee1cac498ae$var$Pnd(a.B);
    a.Q = $61de1ee1cac498ae$var$Lnd(a, 8);
    $61de1ee1cac498ae$var$Qnd(a.Q, 0);
    $61de1ee1cac498ae$var$Pnd(a.Q);
    a.R = $61de1ee1cac498ae$var$Lnd(a, 9);
    $61de1ee1cac498ae$var$Knd(a.R, 1);
    a.S = $61de1ee1cac498ae$var$Lnd(a, 10);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    $61de1ee1cac498ae$var$Pnd(a.S);
    a.T = $61de1ee1cac498ae$var$Lnd(a, 11);
    $61de1ee1cac498ae$var$Qnd(a.T, 10);
    $61de1ee1cac498ae$var$Qnd(a.T, 11);
    $61de1ee1cac498ae$var$Qnd(a.T, 12);
    $61de1ee1cac498ae$var$Qnd(a.T, 13);
    $61de1ee1cac498ae$var$Qnd(a.T, 14);
    $61de1ee1cac498ae$var$Pnd(a.T);
    $61de1ee1cac498ae$var$Pnd(a.T);
    a.U = $61de1ee1cac498ae$var$Lnd(a, 12);
    $61de1ee1cac498ae$var$Knd(a.U, 2);
    $61de1ee1cac498ae$var$Knd(a.U, 3);
    $61de1ee1cac498ae$var$Qnd(a.U, 4);
    $61de1ee1cac498ae$var$Qnd(a.U, 5);
    $61de1ee1cac498ae$var$Qnd(a.U, 6);
    $61de1ee1cac498ae$var$Qnd(a.U, 7);
    $61de1ee1cac498ae$var$Pnd(a.U);
    a.V = $61de1ee1cac498ae$var$Lnd(a, 13);
    $61de1ee1cac498ae$var$Qnd(a.V, 10);
    a.W = $61de1ee1cac498ae$var$Lnd(a, 14);
    $61de1ee1cac498ae$var$Knd(a.W, 18);
    $61de1ee1cac498ae$var$Knd(a.W, 19);
    $61de1ee1cac498ae$var$Knd(a.W, 20);
    $61de1ee1cac498ae$var$Qnd(a.W, 21);
    $61de1ee1cac498ae$var$Qnd(a.W, 22);
    $61de1ee1cac498ae$var$Qnd(a.W, 23);
    a.bb = $61de1ee1cac498ae$var$Lnd(a, 15);
    $61de1ee1cac498ae$var$Knd(a.bb, 10);
    $61de1ee1cac498ae$var$Knd(a.bb, 11);
    $61de1ee1cac498ae$var$Knd(a.bb, 12);
    $61de1ee1cac498ae$var$Knd(a.bb, 13);
    $61de1ee1cac498ae$var$Knd(a.bb, 14);
    $61de1ee1cac498ae$var$Knd(a.bb, 15);
    $61de1ee1cac498ae$var$Knd(a.bb, 16);
    $61de1ee1cac498ae$var$Qnd(a.bb, 17);
    $61de1ee1cac498ae$var$Pnd(a.bb);
    $61de1ee1cac498ae$var$Pnd(a.bb);
    a.eb = $61de1ee1cac498ae$var$Lnd(a, 16);
    $61de1ee1cac498ae$var$Knd(a.eb, 2);
    $61de1ee1cac498ae$var$Knd(a.eb, 3);
    $61de1ee1cac498ae$var$Knd(a.eb, 4);
    $61de1ee1cac498ae$var$Knd(a.eb, 5);
    $61de1ee1cac498ae$var$Knd(a.eb, 6);
    $61de1ee1cac498ae$var$Knd(a.eb, 7);
    $61de1ee1cac498ae$var$Qnd(a.eb, 8);
    $61de1ee1cac498ae$var$Qnd(a.eb, 9);
    a.ab = $61de1ee1cac498ae$var$Lnd(a, 17);
    $61de1ee1cac498ae$var$Knd(a.ab, 0);
    $61de1ee1cac498ae$var$Knd(a.ab, 1);
    a.H = $61de1ee1cac498ae$var$Lnd(a, 18);
    $61de1ee1cac498ae$var$Qnd(a.H, 0);
    $61de1ee1cac498ae$var$Qnd(a.H, 1);
    $61de1ee1cac498ae$var$Qnd(a.H, 2);
    $61de1ee1cac498ae$var$Qnd(a.H, 3);
    $61de1ee1cac498ae$var$Qnd(a.H, 4);
    $61de1ee1cac498ae$var$Qnd(a.H, 5);
    $61de1ee1cac498ae$var$Pnd(a.H);
    a.db = $61de1ee1cac498ae$var$Lnd(a, 19);
    $61de1ee1cac498ae$var$Qnd(a.db, 2);
    a.c = $61de1ee1cac498ae$var$Mnd(a, 20);
    a.d = $61de1ee1cac498ae$var$Mnd(a, 21);
    a.e = $61de1ee1cac498ae$var$Mnd(a, 22);
    a.f = $61de1ee1cac498ae$var$Mnd(a, 23);
    a.i = $61de1ee1cac498ae$var$Mnd(a, 24);
    a.g = $61de1ee1cac498ae$var$Mnd(a, 25);
    a.j = $61de1ee1cac498ae$var$Mnd(a, 26);
    a.k = $61de1ee1cac498ae$var$Mnd(a, 27);
    a.n = $61de1ee1cac498ae$var$Mnd(a, 28);
    a.r = $61de1ee1cac498ae$var$Mnd(a, 29);
    a.s = $61de1ee1cac498ae$var$Mnd(a, 30);
    a.t = $61de1ee1cac498ae$var$Mnd(a, 31);
    a.u = $61de1ee1cac498ae$var$Mnd(a, 32);
    a.fb = $61de1ee1cac498ae$var$Mnd(a, 33);
    a.A = $61de1ee1cac498ae$var$Mnd(a, 34);
    a.C = $61de1ee1cac498ae$var$Mnd(a, 35);
    a.D = $61de1ee1cac498ae$var$Mnd(a, 36);
    a.F = $61de1ee1cac498ae$var$Mnd(a, 37);
    a.G = $61de1ee1cac498ae$var$Mnd(a, 38);
    a.I = $61de1ee1cac498ae$var$Mnd(a, 39);
    a.J = $61de1ee1cac498ae$var$Mnd(a, 40);
    a.L = $61de1ee1cac498ae$var$Mnd(a, 41);
    a.M = $61de1ee1cac498ae$var$Mnd(a, 42);
    a.N = $61de1ee1cac498ae$var$Mnd(a, 43);
    a.O = $61de1ee1cac498ae$var$Mnd(a, 44);
    a.P = $61de1ee1cac498ae$var$Mnd(a, 45);
    a.X = $61de1ee1cac498ae$var$Mnd(a, 46);
    a.Y = $61de1ee1cac498ae$var$Mnd(a, 47);
    a.Z = $61de1ee1cac498ae$var$Mnd(a, 48);
    a.$ = $61de1ee1cac498ae$var$Mnd(a, 49);
    a._ = $61de1ee1cac498ae$var$Mnd(a, 50);
    a.cb = $61de1ee1cac498ae$var$Mnd(a, 51);
    a.K = $61de1ee1cac498ae$var$Mnd(a, 52);
}
function $61de1ee1cac498ae$var$Y9c() {
    $61de1ee1cac498ae$var$Y9c = $61de1ee1cac498ae$var$ccb;
    var a, b;
    $61de1ee1cac498ae$var$o8c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$sse);
    $61de1ee1cac498ae$var$F9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$tse);
    $61de1ee1cac498ae$var$q8c = ($61de1ee1cac498ae$var$F7c(), $61de1ee1cac498ae$var$z7c);
    $61de1ee1cac498ae$var$p8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$$pe, $61de1ee1cac498ae$var$q8c);
    new $61de1ee1cac498ae$var$Tfd;
    $61de1ee1cac498ae$var$r8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$_le, null);
    $61de1ee1cac498ae$var$s8c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$use);
    $61de1ee1cac498ae$var$x8c = ($61de1ee1cac498ae$var$i8c(), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$h8c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$r1, 1), $61de1ee1cac498ae$var$Kie, 291, 0, [
        $61de1ee1cac498ae$var$d8c
    ])));
    $61de1ee1cac498ae$var$w8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$lqe, $61de1ee1cac498ae$var$x8c);
    $61de1ee1cac498ae$var$y8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Zpe, ($61de1ee1cac498ae$var$Bcb(), false));
    $61de1ee1cac498ae$var$A8c = ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$cad);
    $61de1ee1cac498ae$var$z8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$cqe, $61de1ee1cac498ae$var$A8c);
    $61de1ee1cac498ae$var$F8c = ($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$zad);
    $61de1ee1cac498ae$var$E8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ype, $61de1ee1cac498ae$var$F8c);
    $61de1ee1cac498ae$var$I8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Jre, false);
    $61de1ee1cac498ae$var$K8c = ($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$fbd);
    $61de1ee1cac498ae$var$J8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$tpe, $61de1ee1cac498ae$var$K8c);
    $61de1ee1cac498ae$var$g9c = new $61de1ee1cac498ae$var$q0b(12);
    $61de1ee1cac498ae$var$f9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$g9c);
    $61de1ee1cac498ae$var$O8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ame, false);
    $61de1ee1cac498ae$var$P8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$xqe, false);
    $61de1ee1cac498ae$var$e9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Dme, false);
    $61de1ee1cac498ae$var$u9c = ($61de1ee1cac498ae$var$dcd(), $61de1ee1cac498ae$var$ccd);
    $61de1ee1cac498ae$var$t9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Bme, $61de1ee1cac498ae$var$u9c);
    $61de1ee1cac498ae$var$C9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$uqe);
    $61de1ee1cac498ae$var$D9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$vme);
    $61de1ee1cac498ae$var$E9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$yme);
    $61de1ee1cac498ae$var$H9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$zme);
    $61de1ee1cac498ae$var$R8c = new $61de1ee1cac498ae$var$s7c;
    $61de1ee1cac498ae$var$Q8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$mqe, $61de1ee1cac498ae$var$R8c);
    $61de1ee1cac498ae$var$v8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$pqe, false);
    $61de1ee1cac498ae$var$L8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$qqe, false);
    new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$vse);
    $61de1ee1cac498ae$var$T8c = new $61de1ee1cac498ae$var$H_b;
    $61de1ee1cac498ae$var$S8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$vqe, $61de1ee1cac498ae$var$T8c);
    $61de1ee1cac498ae$var$d9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Xpe, false);
    new $61de1ee1cac498ae$var$Tfd;
    $61de1ee1cac498ae$var$G9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$wse, 1);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$xse, true);
    $61de1ee1cac498ae$var$meb(0);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$yse, $61de1ee1cac498ae$var$meb(100));
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$zse, false);
    $61de1ee1cac498ae$var$meb(0);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ase, $61de1ee1cac498ae$var$meb(4000));
    $61de1ee1cac498ae$var$meb(0);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Bse, $61de1ee1cac498ae$var$meb(400));
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Cse, false);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Dse, false);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ese, true);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Fse, false);
    $61de1ee1cac498ae$var$u8c = ($61de1ee1cac498ae$var$Ded(), $61de1ee1cac498ae$var$Ced);
    $61de1ee1cac498ae$var$t8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$rse, $61de1ee1cac498ae$var$u8c);
    $61de1ee1cac498ae$var$I9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Lpe, 10);
    $61de1ee1cac498ae$var$J9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Mpe, 10);
    $61de1ee1cac498ae$var$K9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Zle, 20);
    $61de1ee1cac498ae$var$L9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Npe, 10);
    $61de1ee1cac498ae$var$M9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$xme, 2);
    $61de1ee1cac498ae$var$N9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ope, 10);
    $61de1ee1cac498ae$var$P9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ppe, 0);
    $61de1ee1cac498ae$var$Q9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Spe, 5);
    $61de1ee1cac498ae$var$R9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Qpe, 1);
    $61de1ee1cac498ae$var$S9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Rpe, 1);
    $61de1ee1cac498ae$var$T9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$wme, 20);
    $61de1ee1cac498ae$var$U9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Tpe, 10);
    $61de1ee1cac498ae$var$X9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Upe, 10);
    $61de1ee1cac498ae$var$O9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Vpe);
    $61de1ee1cac498ae$var$W9c = new $61de1ee1cac498ae$var$I_b;
    $61de1ee1cac498ae$var$V9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$wqe, $61de1ee1cac498ae$var$W9c);
    $61de1ee1cac498ae$var$j9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$tqe);
    $61de1ee1cac498ae$var$i9c = false;
    $61de1ee1cac498ae$var$h9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$sqe, $61de1ee1cac498ae$var$i9c);
    $61de1ee1cac498ae$var$V8c = new $61de1ee1cac498ae$var$q0b(5);
    $61de1ee1cac498ae$var$U8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$dqe, $61de1ee1cac498ae$var$V8c);
    $61de1ee1cac498ae$var$X8c = ($61de1ee1cac498ae$var$Hbd(), b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$B1), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0));
    $61de1ee1cac498ae$var$W8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Gme, $61de1ee1cac498ae$var$X8c);
    $61de1ee1cac498ae$var$m9c = ($61de1ee1cac498ae$var$Tbd(), $61de1ee1cac498ae$var$Qbd);
    $61de1ee1cac498ae$var$l9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$gqe, $61de1ee1cac498ae$var$m9c);
    $61de1ee1cac498ae$var$o9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$hqe);
    $61de1ee1cac498ae$var$p9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$iqe);
    $61de1ee1cac498ae$var$q9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$jqe);
    $61de1ee1cac498ae$var$n9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$kqe);
    $61de1ee1cac498ae$var$Z8c = (a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$I1), 9), new $61de1ee1cac498ae$var$xqb(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(a, a.length), 9), 0));
    $61de1ee1cac498ae$var$Y8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Z8c);
    $61de1ee1cac498ae$var$c9c = $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$Idd(), $61de1ee1cac498ae$var$Bdd));
    $61de1ee1cac498ae$var$b9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$c9c);
    $61de1ee1cac498ae$var$a9c = new $61de1ee1cac498ae$var$f7c(0, 0);
    $61de1ee1cac498ae$var$_8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$a9c);
    $61de1ee1cac498ae$var$$8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$bqe, false);
    $61de1ee1cac498ae$var$D8c = ($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$nad);
    $61de1ee1cac498ae$var$C8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$nqe, $61de1ee1cac498ae$var$D8c);
    $61de1ee1cac498ae$var$B8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Cme, false);
    new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Gse);
    $61de1ee1cac498ae$var$meb(1);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Hse, null);
    $61de1ee1cac498ae$var$r9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$rqe);
    $61de1ee1cac498ae$var$v9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$oqe);
    $61de1ee1cac498ae$var$B9c = ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd);
    $61de1ee1cac498ae$var$A9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ype, $61de1ee1cac498ae$var$B9c);
    $61de1ee1cac498ae$var$s9c = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Wpe);
    $61de1ee1cac498ae$var$y9c = ($61de1ee1cac498ae$var$rcd(), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$pcd));
    $61de1ee1cac498ae$var$x9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Hme, $61de1ee1cac498ae$var$y9c);
    $61de1ee1cac498ae$var$w9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$eqe, false);
    $61de1ee1cac498ae$var$z9c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$fqe, true);
    $61de1ee1cac498ae$var$M8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$_pe, false);
    $61de1ee1cac498ae$var$N8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$aqe, false);
    $61de1ee1cac498ae$var$G8c = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$$le, 1);
    $61de1ee1cac498ae$var$H8c = ($61de1ee1cac498ae$var$Mad(), $61de1ee1cac498ae$var$Kad);
    new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ise, $61de1ee1cac498ae$var$H8c);
    $61de1ee1cac498ae$var$k9c = true;
}
function $61de1ee1cac498ae$var$wtc() {
    $61de1ee1cac498ae$var$wtc = $61de1ee1cac498ae$var$ccb;
    var a, b;
    $61de1ee1cac498ae$var$$sc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Ime);
    $61de1ee1cac498ae$var$xsc = new $61de1ee1cac498ae$var$Lsd("coordinateOrigin");
    $61de1ee1cac498ae$var$itc = new $61de1ee1cac498ae$var$Lsd("processors");
    $61de1ee1cac498ae$var$wsc = new $61de1ee1cac498ae$var$Msd("compoundNode", ($61de1ee1cac498ae$var$Bcb(), false));
    $61de1ee1cac498ae$var$Nsc = new $61de1ee1cac498ae$var$Msd("insideConnections", false);
    $61de1ee1cac498ae$var$_sc = new $61de1ee1cac498ae$var$Lsd("originalBendpoints");
    $61de1ee1cac498ae$var$atc = new $61de1ee1cac498ae$var$Lsd("originalDummyNodePosition");
    $61de1ee1cac498ae$var$btc = new $61de1ee1cac498ae$var$Lsd("originalLabelEdge");
    $61de1ee1cac498ae$var$ktc = new $61de1ee1cac498ae$var$Lsd("representedLabels");
    $61de1ee1cac498ae$var$Csc = new $61de1ee1cac498ae$var$Lsd("endLabels");
    $61de1ee1cac498ae$var$Dsc = new $61de1ee1cac498ae$var$Lsd("endLabel.origin");
    $61de1ee1cac498ae$var$Ssc = new $61de1ee1cac498ae$var$Msd("labelSide", ($61de1ee1cac498ae$var$rbd(), $61de1ee1cac498ae$var$qbd));
    $61de1ee1cac498ae$var$Ysc = new $61de1ee1cac498ae$var$Msd("maxEdgeThickness", 0);
    $61de1ee1cac498ae$var$ltc = new $61de1ee1cac498ae$var$Msd("reversed", false);
    $61de1ee1cac498ae$var$jtc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Jme);
    $61de1ee1cac498ae$var$Vsc = new $61de1ee1cac498ae$var$Msd("longEdgeSource", null);
    $61de1ee1cac498ae$var$Wsc = new $61de1ee1cac498ae$var$Msd("longEdgeTarget", null);
    $61de1ee1cac498ae$var$Usc = new $61de1ee1cac498ae$var$Msd("longEdgeHasLabelDummies", false);
    $61de1ee1cac498ae$var$Tsc = new $61de1ee1cac498ae$var$Msd("longEdgeBeforeLabelDummy", false);
    $61de1ee1cac498ae$var$Bsc = new $61de1ee1cac498ae$var$Msd("edgeConstraint", ($61de1ee1cac498ae$var$Gqc(), $61de1ee1cac498ae$var$Eqc));
    $61de1ee1cac498ae$var$Psc = new $61de1ee1cac498ae$var$Lsd("inLayerLayoutUnit");
    $61de1ee1cac498ae$var$Osc = new $61de1ee1cac498ae$var$Msd("inLayerConstraint", ($61de1ee1cac498ae$var$esc(), $61de1ee1cac498ae$var$csc));
    $61de1ee1cac498ae$var$Qsc = new $61de1ee1cac498ae$var$Msd("inLayerSuccessorConstraint", new $61de1ee1cac498ae$var$Rkb);
    $61de1ee1cac498ae$var$Rsc = new $61de1ee1cac498ae$var$Msd("inLayerSuccessorConstraintBetweenNonDummies", false);
    $61de1ee1cac498ae$var$gtc = new $61de1ee1cac498ae$var$Lsd("portDummy");
    $61de1ee1cac498ae$var$ysc = new $61de1ee1cac498ae$var$Msd("crossingHint", $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$Ksc = new $61de1ee1cac498ae$var$Msd("graphProperties", (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$PW), 9), new $61de1ee1cac498ae$var$xqb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(b, b.length), 9), 0)));
    $61de1ee1cac498ae$var$Hsc = new $61de1ee1cac498ae$var$Msd("externalPortSide", ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Scd));
    $61de1ee1cac498ae$var$Isc = new $61de1ee1cac498ae$var$Msd("externalPortSize", new $61de1ee1cac498ae$var$d7c);
    $61de1ee1cac498ae$var$Fsc = new $61de1ee1cac498ae$var$Lsd("externalPortReplacedDummies");
    $61de1ee1cac498ae$var$Gsc = new $61de1ee1cac498ae$var$Lsd("externalPortReplacedDummy");
    $61de1ee1cac498ae$var$Esc = new $61de1ee1cac498ae$var$Msd("externalPortConnections", (a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gdb($61de1ee1cac498ae$var$F1), 9), new $61de1ee1cac498ae$var$xqb(a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$_Bb(a, a.length), 9), 0)));
    $61de1ee1cac498ae$var$htc = new $61de1ee1cac498ae$var$Msd($61de1ee1cac498ae$var$tle, 0);
    $61de1ee1cac498ae$var$ssc = new $61de1ee1cac498ae$var$Lsd("barycenterAssociates");
    $61de1ee1cac498ae$var$vtc = new $61de1ee1cac498ae$var$Lsd("TopSideComments");
    $61de1ee1cac498ae$var$tsc = new $61de1ee1cac498ae$var$Lsd("BottomSideComments");
    $61de1ee1cac498ae$var$vsc = new $61de1ee1cac498ae$var$Lsd("CommentConnectionPort");
    $61de1ee1cac498ae$var$Msc = new $61de1ee1cac498ae$var$Msd("inputCollect", false);
    $61de1ee1cac498ae$var$etc = new $61de1ee1cac498ae$var$Msd("outputCollect", false);
    $61de1ee1cac498ae$var$Asc = new $61de1ee1cac498ae$var$Msd("cyclic", false);
    $61de1ee1cac498ae$var$zsc = new $61de1ee1cac498ae$var$Lsd("crossHierarchyMap");
    $61de1ee1cac498ae$var$utc = new $61de1ee1cac498ae$var$Lsd("targetOffset");
    new $61de1ee1cac498ae$var$Msd("splineLabelSize", new $61de1ee1cac498ae$var$d7c);
    $61de1ee1cac498ae$var$otc = new $61de1ee1cac498ae$var$Lsd("spacings");
    $61de1ee1cac498ae$var$ftc = new $61de1ee1cac498ae$var$Msd("partitionConstraint", false);
    $61de1ee1cac498ae$var$usc = new $61de1ee1cac498ae$var$Lsd("breakingPoint.info");
    $61de1ee1cac498ae$var$stc = new $61de1ee1cac498ae$var$Lsd("splines.survivingEdge");
    $61de1ee1cac498ae$var$rtc = new $61de1ee1cac498ae$var$Lsd("splines.route.start");
    $61de1ee1cac498ae$var$ptc = new $61de1ee1cac498ae$var$Lsd("splines.edgeChain");
    $61de1ee1cac498ae$var$dtc = new $61de1ee1cac498ae$var$Lsd("originalPortConstraints");
    $61de1ee1cac498ae$var$ntc = new $61de1ee1cac498ae$var$Lsd("selfLoopHolder");
    $61de1ee1cac498ae$var$qtc = new $61de1ee1cac498ae$var$Lsd("splines.nsPortY");
    $61de1ee1cac498ae$var$Zsc = new $61de1ee1cac498ae$var$Lsd("modelOrder");
    $61de1ee1cac498ae$var$Xsc = new $61de1ee1cac498ae$var$Lsd("longEdgeTargetNode");
    $61de1ee1cac498ae$var$Jsc = new $61de1ee1cac498ae$var$Msd($61de1ee1cac498ae$var$Xne, false);
    $61de1ee1cac498ae$var$mtc = new $61de1ee1cac498ae$var$Msd($61de1ee1cac498ae$var$Xne, false);
    $61de1ee1cac498ae$var$Lsc = new $61de1ee1cac498ae$var$Lsd("layerConstraints.hiddenNodes");
    $61de1ee1cac498ae$var$ctc = new $61de1ee1cac498ae$var$Lsd("layerConstraints.opposidePort");
    $61de1ee1cac498ae$var$ttc = new $61de1ee1cac498ae$var$Lsd("targetNode.modelOrder");
}
function $61de1ee1cac498ae$var$jwc() {
    $61de1ee1cac498ae$var$jwc = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$puc = ($61de1ee1cac498ae$var$xqc(), $61de1ee1cac498ae$var$vqc);
    $61de1ee1cac498ae$var$ouc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Yne, $61de1ee1cac498ae$var$puc);
    $61de1ee1cac498ae$var$Guc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Zne, ($61de1ee1cac498ae$var$Bcb(), false));
    $61de1ee1cac498ae$var$Muc = ($61de1ee1cac498ae$var$msc(), $61de1ee1cac498ae$var$ksc);
    $61de1ee1cac498ae$var$Luc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$$ne, $61de1ee1cac498ae$var$Muc);
    $61de1ee1cac498ae$var$cvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$_ne, false);
    $61de1ee1cac498ae$var$dvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$aoe, true);
    $61de1ee1cac498ae$var$Itc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$boe, false);
    $61de1ee1cac498ae$var$xvc = ($61de1ee1cac498ae$var$BAc(), $61de1ee1cac498ae$var$zAc);
    $61de1ee1cac498ae$var$wvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$coe, $61de1ee1cac498ae$var$xvc);
    $61de1ee1cac498ae$var$meb(1);
    $61de1ee1cac498ae$var$Fvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$doe, $61de1ee1cac498ae$var$meb(7));
    $61de1ee1cac498ae$var$Gvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$eoe, false);
    $61de1ee1cac498ae$var$Huc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$foe, false);
    $61de1ee1cac498ae$var$nuc = ($61de1ee1cac498ae$var$mqc(), $61de1ee1cac498ae$var$iqc);
    $61de1ee1cac498ae$var$muc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$goe, $61de1ee1cac498ae$var$nuc);
    $61de1ee1cac498ae$var$bvc = ($61de1ee1cac498ae$var$lzc(), $61de1ee1cac498ae$var$jzc);
    $61de1ee1cac498ae$var$avc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$hoe, $61de1ee1cac498ae$var$bvc);
    $61de1ee1cac498ae$var$Tuc = ($61de1ee1cac498ae$var$Ctc(), $61de1ee1cac498ae$var$Btc);
    $61de1ee1cac498ae$var$Suc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ioe, $61de1ee1cac498ae$var$Tuc);
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$Ruc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$joe, $61de1ee1cac498ae$var$meb(-1));
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$Uuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$koe, $61de1ee1cac498ae$var$meb(-1));
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$Vuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$loe, $61de1ee1cac498ae$var$meb(4));
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$Xuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$moe, $61de1ee1cac498ae$var$meb(2));
    $61de1ee1cac498ae$var$_uc = ($61de1ee1cac498ae$var$kAc(), $61de1ee1cac498ae$var$iAc);
    $61de1ee1cac498ae$var$$uc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$noe, $61de1ee1cac498ae$var$_uc);
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$Zuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ooe, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$Puc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$poe, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Ohe));
    $61de1ee1cac498ae$var$luc = ($61de1ee1cac498ae$var$Rpc(), $61de1ee1cac498ae$var$Ppc);
    $61de1ee1cac498ae$var$kuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$qoe, $61de1ee1cac498ae$var$luc);
    $61de1ee1cac498ae$var$Xtc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$roe, false);
    $61de1ee1cac498ae$var$euc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$soe, 0.1);
    $61de1ee1cac498ae$var$iuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$toe, false);
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$guc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$uoe, $61de1ee1cac498ae$var$meb(-1));
    $61de1ee1cac498ae$var$meb(-1);
    $61de1ee1cac498ae$var$huc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$voe, $61de1ee1cac498ae$var$meb(-1));
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$Ytc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$woe, $61de1ee1cac498ae$var$meb(40));
    $61de1ee1cac498ae$var$cuc = ($61de1ee1cac498ae$var$Xrc(), $61de1ee1cac498ae$var$Wrc);
    $61de1ee1cac498ae$var$buc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$xoe, $61de1ee1cac498ae$var$cuc);
    $61de1ee1cac498ae$var$$tc = $61de1ee1cac498ae$var$Urc;
    $61de1ee1cac498ae$var$Ztc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$yoe, $61de1ee1cac498ae$var$$tc);
    $61de1ee1cac498ae$var$vvc = ($61de1ee1cac498ae$var$Vzc(), $61de1ee1cac498ae$var$Qzc);
    $61de1ee1cac498ae$var$uvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$vvc);
    $61de1ee1cac498ae$var$kvc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Aoe);
    $61de1ee1cac498ae$var$fvc = ($61de1ee1cac498ae$var$_qc(), $61de1ee1cac498ae$var$Zqc);
    $61de1ee1cac498ae$var$evc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Boe, $61de1ee1cac498ae$var$fvc);
    $61de1ee1cac498ae$var$ivc = ($61de1ee1cac498ae$var$lrc(), $61de1ee1cac498ae$var$irc);
    $61de1ee1cac498ae$var$hvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Coe, $61de1ee1cac498ae$var$ivc);
    new $61de1ee1cac498ae$var$Tfd;
    $61de1ee1cac498ae$var$nvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Doe, 0.3);
    $61de1ee1cac498ae$var$pvc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$Eoe);
    $61de1ee1cac498ae$var$rvc = ($61de1ee1cac498ae$var$Izc(), $61de1ee1cac498ae$var$Gzc);
    $61de1ee1cac498ae$var$qvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Foe, $61de1ee1cac498ae$var$rvc);
    $61de1ee1cac498ae$var$xuc = ($61de1ee1cac498ae$var$TAc(), $61de1ee1cac498ae$var$RAc);
    $61de1ee1cac498ae$var$wuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Goe, $61de1ee1cac498ae$var$xuc);
    $61de1ee1cac498ae$var$zuc = ($61de1ee1cac498ae$var$_Ac(), $61de1ee1cac498ae$var$$Ac);
    $61de1ee1cac498ae$var$yuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Hoe, $61de1ee1cac498ae$var$zuc);
    $61de1ee1cac498ae$var$Buc = ($61de1ee1cac498ae$var$tBc(), $61de1ee1cac498ae$var$sBc);
    $61de1ee1cac498ae$var$Auc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ioe, $61de1ee1cac498ae$var$Buc);
    $61de1ee1cac498ae$var$Duc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Joe, 0.2);
    $61de1ee1cac498ae$var$uuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Koe, 2);
    $61de1ee1cac498ae$var$Bvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Loe, null);
    $61de1ee1cac498ae$var$Dvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Moe, 10);
    $61de1ee1cac498ae$var$Cvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Noe, 10);
    $61de1ee1cac498ae$var$Evc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Ooe, 20);
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$yvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Poe, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$zvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Qoe, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$Avc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Roe, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$Jtc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Soe, false);
    $61de1ee1cac498ae$var$Ntc = ($61de1ee1cac498ae$var$yrc(), $61de1ee1cac498ae$var$wrc);
    $61de1ee1cac498ae$var$Mtc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Toe, $61de1ee1cac498ae$var$Ntc);
    $61de1ee1cac498ae$var$Ltc = ($61de1ee1cac498ae$var$Ipc(), $61de1ee1cac498ae$var$Hpc);
    $61de1ee1cac498ae$var$Ktc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Uoe, $61de1ee1cac498ae$var$Ltc);
    $61de1ee1cac498ae$var$Juc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Voe, false);
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$Iuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Woe, $61de1ee1cac498ae$var$meb(16));
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$Kuc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Xoe, $61de1ee1cac498ae$var$meb(5));
    $61de1ee1cac498ae$var$bwc = ($61de1ee1cac498ae$var$LBc(), $61de1ee1cac498ae$var$JBc);
    $61de1ee1cac498ae$var$awc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$bwc);
    $61de1ee1cac498ae$var$Hvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$Zoe, 10);
    $61de1ee1cac498ae$var$Kvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$$oe, 1);
    $61de1ee1cac498ae$var$Tvc = ($61de1ee1cac498ae$var$bqc(), $61de1ee1cac498ae$var$aqc);
    $61de1ee1cac498ae$var$Svc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$_oe, $61de1ee1cac498ae$var$Tvc);
    $61de1ee1cac498ae$var$Nvc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$ape);
    $61de1ee1cac498ae$var$Qvc = $61de1ee1cac498ae$var$meb(1);
    $61de1ee1cac498ae$var$meb(0);
    $61de1ee1cac498ae$var$Pvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$bpe, $61de1ee1cac498ae$var$Qvc);
    $61de1ee1cac498ae$var$gwc = ($61de1ee1cac498ae$var$CBc(), $61de1ee1cac498ae$var$zBc);
    $61de1ee1cac498ae$var$fwc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$cpe, $61de1ee1cac498ae$var$gwc);
    $61de1ee1cac498ae$var$cwc = new $61de1ee1cac498ae$var$Lsd($61de1ee1cac498ae$var$dpe);
    $61de1ee1cac498ae$var$Yvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$epe, true);
    $61de1ee1cac498ae$var$Wvc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$fpe, 2);
    $61de1ee1cac498ae$var$$vc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$gpe, true);
    $61de1ee1cac498ae$var$tuc = ($61de1ee1cac498ae$var$Sqc(), $61de1ee1cac498ae$var$Qqc);
    $61de1ee1cac498ae$var$suc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$hpe, $61de1ee1cac498ae$var$tuc);
    $61de1ee1cac498ae$var$ruc = ($61de1ee1cac498ae$var$Apc(), $61de1ee1cac498ae$var$wpc);
    $61de1ee1cac498ae$var$quc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ipe, $61de1ee1cac498ae$var$ruc);
    $61de1ee1cac498ae$var$Wtc = ($61de1ee1cac498ae$var$tAc(), $61de1ee1cac498ae$var$rAc);
    $61de1ee1cac498ae$var$Vtc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$jpe, $61de1ee1cac498ae$var$Wtc);
    $61de1ee1cac498ae$var$Utc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$kpe, false);
    $61de1ee1cac498ae$var$Ptc = ($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$QXb);
    $61de1ee1cac498ae$var$Otc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$lpe, $61de1ee1cac498ae$var$Ptc);
    $61de1ee1cac498ae$var$Ttc = ($61de1ee1cac498ae$var$xzc(), $61de1ee1cac498ae$var$uzc);
    $61de1ee1cac498ae$var$Stc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$mpe, $61de1ee1cac498ae$var$Ttc);
    $61de1ee1cac498ae$var$Qtc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$npe, 0);
    $61de1ee1cac498ae$var$Rtc = new $61de1ee1cac498ae$var$Nsd($61de1ee1cac498ae$var$ope, 0);
    $61de1ee1cac498ae$var$Ouc = $61de1ee1cac498ae$var$kqc;
    $61de1ee1cac498ae$var$Nuc = $61de1ee1cac498ae$var$Opc;
    $61de1ee1cac498ae$var$Wuc = $61de1ee1cac498ae$var$izc;
    $61de1ee1cac498ae$var$Yuc = $61de1ee1cac498ae$var$izc;
    $61de1ee1cac498ae$var$Quc = $61de1ee1cac498ae$var$fzc;
    $61de1ee1cac498ae$var$fuc = ($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd);
    $61de1ee1cac498ae$var$juc = $61de1ee1cac498ae$var$Ppc;
    $61de1ee1cac498ae$var$duc = $61de1ee1cac498ae$var$Ppc;
    $61de1ee1cac498ae$var$_tc = $61de1ee1cac498ae$var$Ppc;
    $61de1ee1cac498ae$var$auc = $61de1ee1cac498ae$var$ebd;
    $61de1ee1cac498ae$var$lvc = $61de1ee1cac498ae$var$Tzc;
    $61de1ee1cac498ae$var$mvc = $61de1ee1cac498ae$var$Qzc;
    $61de1ee1cac498ae$var$gvc = $61de1ee1cac498ae$var$Qzc;
    $61de1ee1cac498ae$var$jvc = $61de1ee1cac498ae$var$Qzc;
    $61de1ee1cac498ae$var$ovc = $61de1ee1cac498ae$var$Szc;
    $61de1ee1cac498ae$var$tvc = $61de1ee1cac498ae$var$Tzc;
    $61de1ee1cac498ae$var$svc = $61de1ee1cac498ae$var$Tzc;
    $61de1ee1cac498ae$var$Cuc = ($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$yad);
    $61de1ee1cac498ae$var$Euc = $61de1ee1cac498ae$var$yad;
    $61de1ee1cac498ae$var$Fuc = $61de1ee1cac498ae$var$sBc;
    $61de1ee1cac498ae$var$vuc = $61de1ee1cac498ae$var$xad;
    $61de1ee1cac498ae$var$Ivc = $61de1ee1cac498ae$var$KBc;
    $61de1ee1cac498ae$var$Jvc = $61de1ee1cac498ae$var$IBc;
    $61de1ee1cac498ae$var$Lvc = $61de1ee1cac498ae$var$KBc;
    $61de1ee1cac498ae$var$Mvc = $61de1ee1cac498ae$var$IBc;
    $61de1ee1cac498ae$var$Uvc = $61de1ee1cac498ae$var$KBc;
    $61de1ee1cac498ae$var$Vvc = $61de1ee1cac498ae$var$IBc;
    $61de1ee1cac498ae$var$Ovc = $61de1ee1cac498ae$var$_pc;
    $61de1ee1cac498ae$var$Rvc = $61de1ee1cac498ae$var$aqc;
    $61de1ee1cac498ae$var$hwc = $61de1ee1cac498ae$var$KBc;
    $61de1ee1cac498ae$var$iwc = $61de1ee1cac498ae$var$IBc;
    $61de1ee1cac498ae$var$dwc = $61de1ee1cac498ae$var$KBc;
    $61de1ee1cac498ae$var$ewc = $61de1ee1cac498ae$var$IBc;
    $61de1ee1cac498ae$var$Zvc = $61de1ee1cac498ae$var$IBc;
    $61de1ee1cac498ae$var$Xvc = $61de1ee1cac498ae$var$IBc;
    $61de1ee1cac498ae$var$_vc = $61de1ee1cac498ae$var$IBc;
}
function $61de1ee1cac498ae$var$S8b() {
    $61de1ee1cac498ae$var$S8b = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$Y7b = new $61de1ee1cac498ae$var$T8b("DIRECTION_PREPROCESSOR", 0);
    $61de1ee1cac498ae$var$V7b = new $61de1ee1cac498ae$var$T8b("COMMENT_PREPROCESSOR", 1);
    $61de1ee1cac498ae$var$Z7b = new $61de1ee1cac498ae$var$T8b("EDGE_AND_LAYER_CONSTRAINT_EDGE_REVERSER", 2);
    $61de1ee1cac498ae$var$n8b = new $61de1ee1cac498ae$var$T8b("INTERACTIVE_EXTERNAL_PORT_POSITIONER", 3);
    $61de1ee1cac498ae$var$G8b = new $61de1ee1cac498ae$var$T8b("PARTITION_PREPROCESSOR", 4);
    $61de1ee1cac498ae$var$r8b = new $61de1ee1cac498ae$var$T8b("LABEL_DUMMY_INSERTER", 5);
    $61de1ee1cac498ae$var$M8b = new $61de1ee1cac498ae$var$T8b("SELF_LOOP_PREPROCESSOR", 6);
    $61de1ee1cac498ae$var$w8b = new $61de1ee1cac498ae$var$T8b("LAYER_CONSTRAINT_PREPROCESSOR", 7);
    $61de1ee1cac498ae$var$E8b = new $61de1ee1cac498ae$var$T8b("PARTITION_MIDPROCESSOR", 8);
    $61de1ee1cac498ae$var$i8b = new $61de1ee1cac498ae$var$T8b("HIGH_DEGREE_NODE_LAYER_PROCESSOR", 9);
    $61de1ee1cac498ae$var$A8b = new $61de1ee1cac498ae$var$T8b("NODE_PROMOTION", 10);
    $61de1ee1cac498ae$var$v8b = new $61de1ee1cac498ae$var$T8b("LAYER_CONSTRAINT_POSTPROCESSOR", 11);
    $61de1ee1cac498ae$var$F8b = new $61de1ee1cac498ae$var$T8b("PARTITION_POSTPROCESSOR", 12);
    $61de1ee1cac498ae$var$e8b = new $61de1ee1cac498ae$var$T8b("HIERARCHICAL_PORT_CONSTRAINT_PROCESSOR", 13);
    $61de1ee1cac498ae$var$O8b = new $61de1ee1cac498ae$var$T8b("SEMI_INTERACTIVE_CROSSMIN_PROCESSOR", 14);
    $61de1ee1cac498ae$var$P7b = new $61de1ee1cac498ae$var$T8b("BREAKING_POINT_INSERTER", 15);
    $61de1ee1cac498ae$var$z8b = new $61de1ee1cac498ae$var$T8b("LONG_EDGE_SPLITTER", 16);
    $61de1ee1cac498ae$var$I8b = new $61de1ee1cac498ae$var$T8b("PORT_SIDE_PROCESSOR", 17);
    $61de1ee1cac498ae$var$o8b = new $61de1ee1cac498ae$var$T8b("INVERTED_PORT_PROCESSOR", 18);
    $61de1ee1cac498ae$var$H8b = new $61de1ee1cac498ae$var$T8b("PORT_LIST_SORTER", 19);
    $61de1ee1cac498ae$var$Q8b = new $61de1ee1cac498ae$var$T8b("SORT_BY_INPUT_ORDER_OF_MODEL", 20);
    $61de1ee1cac498ae$var$C8b = new $61de1ee1cac498ae$var$T8b("NORTH_SOUTH_PORT_PREPROCESSOR", 21);
    $61de1ee1cac498ae$var$Q7b = new $61de1ee1cac498ae$var$T8b("BREAKING_POINT_PROCESSOR", 22);
    $61de1ee1cac498ae$var$D8b = new $61de1ee1cac498ae$var$T8b($61de1ee1cac498ae$var$Bne, 23);
    $61de1ee1cac498ae$var$R8b = new $61de1ee1cac498ae$var$T8b($61de1ee1cac498ae$var$Cne, 24);
    $61de1ee1cac498ae$var$K8b = new $61de1ee1cac498ae$var$T8b("SELF_LOOP_PORT_RESTORER", 25);
    $61de1ee1cac498ae$var$P8b = new $61de1ee1cac498ae$var$T8b("SINGLE_EDGE_GRAPH_WRAPPER", 26);
    $61de1ee1cac498ae$var$p8b = new $61de1ee1cac498ae$var$T8b("IN_LAYER_CONSTRAINT_PROCESSOR", 27);
    $61de1ee1cac498ae$var$b8b = new $61de1ee1cac498ae$var$T8b("END_NODE_PORT_LABEL_MANAGEMENT_PROCESSOR", 28);
    $61de1ee1cac498ae$var$q8b = new $61de1ee1cac498ae$var$T8b("LABEL_AND_NODE_SIZE_PROCESSOR", 29);
    $61de1ee1cac498ae$var$m8b = new $61de1ee1cac498ae$var$T8b("INNERMOST_NODE_MARGIN_CALCULATOR", 30);
    $61de1ee1cac498ae$var$N8b = new $61de1ee1cac498ae$var$T8b("SELF_LOOP_ROUTER", 31);
    $61de1ee1cac498ae$var$T7b = new $61de1ee1cac498ae$var$T8b("COMMENT_NODE_MARGIN_CALCULATOR", 32);
    $61de1ee1cac498ae$var$_7b = new $61de1ee1cac498ae$var$T8b("END_LABEL_PREPROCESSOR", 33);
    $61de1ee1cac498ae$var$t8b = new $61de1ee1cac498ae$var$T8b("LABEL_DUMMY_SWITCHER", 34);
    $61de1ee1cac498ae$var$S7b = new $61de1ee1cac498ae$var$T8b("CENTER_LABEL_MANAGEMENT_PROCESSOR", 35);
    $61de1ee1cac498ae$var$u8b = new $61de1ee1cac498ae$var$T8b("LABEL_SIDE_SELECTOR", 36);
    $61de1ee1cac498ae$var$k8b = new $61de1ee1cac498ae$var$T8b("HYPEREDGE_DUMMY_MERGER", 37);
    $61de1ee1cac498ae$var$f8b = new $61de1ee1cac498ae$var$T8b("HIERARCHICAL_PORT_DUMMY_SIZE_PROCESSOR", 38);
    $61de1ee1cac498ae$var$x8b = new $61de1ee1cac498ae$var$T8b("LAYER_SIZE_AND_GRAPH_HEIGHT_CALCULATOR", 39);
    $61de1ee1cac498ae$var$h8b = new $61de1ee1cac498ae$var$T8b("HIERARCHICAL_PORT_POSITION_PROCESSOR", 40);
    $61de1ee1cac498ae$var$W7b = new $61de1ee1cac498ae$var$T8b("CONSTRAINTS_POSTPROCESSOR", 41);
    $61de1ee1cac498ae$var$U7b = new $61de1ee1cac498ae$var$T8b("COMMENT_POSTPROCESSOR", 42);
    $61de1ee1cac498ae$var$l8b = new $61de1ee1cac498ae$var$T8b("HYPERNODE_PROCESSOR", 43);
    $61de1ee1cac498ae$var$g8b = new $61de1ee1cac498ae$var$T8b("HIERARCHICAL_PORT_ORTHOGONAL_EDGE_ROUTER", 44);
    $61de1ee1cac498ae$var$y8b = new $61de1ee1cac498ae$var$T8b("LONG_EDGE_JOINER", 45);
    $61de1ee1cac498ae$var$L8b = new $61de1ee1cac498ae$var$T8b("SELF_LOOP_POSTPROCESSOR", 46);
    $61de1ee1cac498ae$var$R7b = new $61de1ee1cac498ae$var$T8b("BREAKING_POINT_REMOVER", 47);
    $61de1ee1cac498ae$var$B8b = new $61de1ee1cac498ae$var$T8b("NORTH_SOUTH_PORT_POSTPROCESSOR", 48);
    $61de1ee1cac498ae$var$j8b = new $61de1ee1cac498ae$var$T8b("HORIZONTAL_COMPACTOR", 49);
    $61de1ee1cac498ae$var$s8b = new $61de1ee1cac498ae$var$T8b("LABEL_DUMMY_REMOVER", 50);
    $61de1ee1cac498ae$var$c8b = new $61de1ee1cac498ae$var$T8b("FINAL_SPLINE_BENDPOINTS_CALCULATOR", 51);
    $61de1ee1cac498ae$var$a8b = new $61de1ee1cac498ae$var$T8b("END_LABEL_SORTER", 52);
    $61de1ee1cac498ae$var$J8b = new $61de1ee1cac498ae$var$T8b("REVERSED_EDGE_RESTORER", 53);
    $61de1ee1cac498ae$var$$7b = new $61de1ee1cac498ae$var$T8b("END_LABEL_POSTPROCESSOR", 54);
    $61de1ee1cac498ae$var$d8b = new $61de1ee1cac498ae$var$T8b("HIERARCHICAL_NODE_RESIZER", 55);
    $61de1ee1cac498ae$var$X7b = new $61de1ee1cac498ae$var$T8b("DIRECTION_POSTPROCESSOR", 56);
}
function $61de1ee1cac498ae$var$KIc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, $, ab, bb, cb, db, eb, fb, gb, hb, ib, jb, kb, lb;
    cb = 0;
    for(H = b, K = 0, N = H.length; K < N; ++K){
        F = H[K];
        for(V = new $61de1ee1cac498ae$var$olb(F.j); V.a < V.c.c.length;){
            U = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(V), 11);
            X = 0;
            for(h = new $61de1ee1cac498ae$var$olb(U.g); h.a < h.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
                F.c != g.d.i.c && ++X;
            }
            X > 0 && (a.a[U.p] = cb++);
        }
    }
    hb = 0;
    for(I = c, L = 0, O = I.length; L < O; ++L){
        F = I[L];
        P = 0;
        for(V = new $61de1ee1cac498ae$var$olb(F.j); V.a < V.c.c.length;){
            U = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(V), 11);
            if (U.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) for(h = new $61de1ee1cac498ae$var$olb(U.e); h.a < h.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
                if (F.c != g.c.i.c) {
                    ++P;
                    break;
                }
            }
            else break;
        }
        R = 0;
        Y = new $61de1ee1cac498ae$var$Bib(F.j, F.j.c.length);
        while(Y.b > 0){
            U = ($61de1ee1cac498ae$var$sCb(Y.b > 0), $61de1ee1cac498ae$var$BD(Y.a.Xb(Y.c = --Y.b), 11));
            X = 0;
            for(h = new $61de1ee1cac498ae$var$olb(U.e); h.a < h.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
                F.c != g.c.i.c && ++X;
            }
            if (X > 0) {
                if (U.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) {
                    a.a[U.p] = hb;
                    ++hb;
                } else {
                    a.a[U.p] = hb + P + R;
                    ++R;
                }
            }
        }
        hb += R;
    }
    W = new $61de1ee1cac498ae$var$Lqb;
    o = new $61de1ee1cac498ae$var$zsb;
    for(G = b, J = 0, M = G.length; J < M; ++J){
        F = G[J];
        for(fb = new $61de1ee1cac498ae$var$olb(F.j); fb.a < fb.c.c.length;){
            eb = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(fb), 11);
            for(h = new $61de1ee1cac498ae$var$olb(eb.g); h.a < h.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
                jb = g.d;
                if (F.c != jb.i.c) {
                    db = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(W.f, eb)), 467);
                    ib = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(W.f, jb)), 467);
                    if (!db && !ib) {
                        n = new $61de1ee1cac498ae$var$NIc;
                        o.a.zc(n, o);
                        $61de1ee1cac498ae$var$Ekb(n.a, g);
                        $61de1ee1cac498ae$var$Ekb(n.d, eb);
                        $61de1ee1cac498ae$var$jrb(W.f, eb, n);
                        $61de1ee1cac498ae$var$Ekb(n.d, jb);
                        $61de1ee1cac498ae$var$jrb(W.f, jb, n);
                    } else if (!db) {
                        $61de1ee1cac498ae$var$Ekb(ib.a, g);
                        $61de1ee1cac498ae$var$Ekb(ib.d, eb);
                        $61de1ee1cac498ae$var$jrb(W.f, eb, ib);
                    } else if (!ib) {
                        $61de1ee1cac498ae$var$Ekb(db.a, g);
                        $61de1ee1cac498ae$var$Ekb(db.d, jb);
                        $61de1ee1cac498ae$var$jrb(W.f, jb, db);
                    } else if (db == ib) $61de1ee1cac498ae$var$Ekb(db.a, g);
                    else {
                        $61de1ee1cac498ae$var$Ekb(db.a, g);
                        for(T = new $61de1ee1cac498ae$var$olb(ib.d); T.a < T.c.c.length;){
                            S = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(T), 11);
                            $61de1ee1cac498ae$var$jrb(W.f, S, db);
                        }
                        $61de1ee1cac498ae$var$Gkb(db.a, ib.a);
                        $61de1ee1cac498ae$var$Gkb(db.d, ib.d);
                        o.a.Bc(ib);
                    }
                }
            }
        }
    }
    p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ee(o, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$oY, {
        3: 1,
        4: 1,
        5: 1,
        1946: 1
    }, 467, o.a.gc(), 0, 1)), 1946);
    D = b[0].c;
    bb = c[0].c;
    for(k = p, l = 0, m = k.length; l < m; ++l){
        j = k[l];
        j.e = cb;
        j.f = hb;
        for(V = new $61de1ee1cac498ae$var$olb(j.d); V.a < V.c.c.length;){
            U = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(V), 11);
            Z = a.a[U.p];
            if (U.i.c == D) {
                Z < j.e && (j.e = Z);
                Z > j.b && (j.b = Z);
            } else if (U.i.c == bb) {
                Z < j.f && (j.f = Z);
                Z > j.c && (j.c = Z);
            }
        }
    }
    $61de1ee1cac498ae$var$Klb(p, 0, p.length, null);
    gb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, p.length, 15, 1);
    d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, hb + 1, 15, 1);
    for(r = 0; r < p.length; r++){
        gb[r] = p[r].f;
        d[gb[r]] = 1;
    }
    f = 0;
    for(s = 0; s < d.length; s++)d[s] == 1 ? d[s] = f : --f;
    $ = 0;
    for(t = 0; t < gb.length; t++){
        gb[t] += d[gb[t]];
        $ = $61de1ee1cac498ae$var$$wnd.Math.max($, gb[t] + 1);
    }
    i = 1;
    while(i < $)i *= 2;
    lb = 2 * i - 1;
    i -= 1;
    kb = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, lb, 15, 1);
    e = 0;
    for(B = 0; B < gb.length; B++){
        A = gb[B] + i;
        ++kb[A];
        while(A > 0){
            A % 2 > 0 && (e += kb[A + 1]);
            A = (A - 1) / 2 | 0;
            ++kb[A];
        }
    }
    C = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$nY, $61de1ee1cac498ae$var$Uhe, 362, p.length * 2, 0, 1);
    for(u = 0; u < p.length; u++){
        C[2 * u] = new $61de1ee1cac498ae$var$QIc(p[u], p[u].e, p[u].b, ($61de1ee1cac498ae$var$UIc(), $61de1ee1cac498ae$var$TIc));
        C[2 * u + 1] = new $61de1ee1cac498ae$var$QIc(p[u], p[u].b, p[u].e, $61de1ee1cac498ae$var$SIc);
    }
    $61de1ee1cac498ae$var$Klb(C, 0, C.length, null);
    Q = 0;
    for(v = 0; v < C.length; v++)switch(C[v].d.g){
        case 0:
            ++Q;
            break;
        case 1:
            --Q;
            e += Q;
    }
    ab = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$nY, $61de1ee1cac498ae$var$Uhe, 362, p.length * 2, 0, 1);
    for(w = 0; w < p.length; w++){
        ab[2 * w] = new $61de1ee1cac498ae$var$QIc(p[w], p[w].f, p[w].c, ($61de1ee1cac498ae$var$UIc(), $61de1ee1cac498ae$var$TIc));
        ab[2 * w + 1] = new $61de1ee1cac498ae$var$QIc(p[w], p[w].c, p[w].f, $61de1ee1cac498ae$var$SIc);
    }
    $61de1ee1cac498ae$var$Klb(ab, 0, ab.length, null);
    Q = 0;
    for(q = 0; q < ab.length; q++)switch(ab[q].d.g){
        case 0:
            ++Q;
            break;
        case 1:
            --Q;
            e += Q;
    }
    return e;
}
function $61de1ee1cac498ae$var$wfe() {
    $61de1ee1cac498ae$var$wfe = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$ffe = new $61de1ee1cac498ae$var$xfe(7);
    $61de1ee1cac498ae$var$hfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 94));
    ++$61de1ee1cac498ae$var$vfe;
    new $61de1ee1cac498ae$var$ige(8, 64);
    $61de1ee1cac498ae$var$ife = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 36));
    $61de1ee1cac498ae$var$ofe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 65));
    $61de1ee1cac498ae$var$pfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 122));
    $61de1ee1cac498ae$var$qfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 90));
    $61de1ee1cac498ae$var$tfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 98));
    $61de1ee1cac498ae$var$mfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 66));
    $61de1ee1cac498ae$var$rfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 60));
    $61de1ee1cac498ae$var$ufe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(8, 62));
    $61de1ee1cac498ae$var$efe = new $61de1ee1cac498ae$var$xfe(11);
    $61de1ee1cac498ae$var$cfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$cfe, 48, 57);
    $61de1ee1cac498ae$var$sfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$sfe, 48, 57);
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$sfe, 65, 90);
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$sfe, 95, 95);
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$sfe, 97, 122);
    $61de1ee1cac498ae$var$nfe = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$nfe, 9, 9);
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$nfe, 10, 10);
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$nfe, 12, 12);
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$nfe, 13, 13);
    $61de1ee1cac498ae$var$Ufe($61de1ee1cac498ae$var$nfe, 32, 32);
    $61de1ee1cac498ae$var$jfe = $61de1ee1cac498ae$var$_fe($61de1ee1cac498ae$var$cfe);
    $61de1ee1cac498ae$var$lfe = $61de1ee1cac498ae$var$_fe($61de1ee1cac498ae$var$sfe);
    $61de1ee1cac498ae$var$kfe = $61de1ee1cac498ae$var$_fe($61de1ee1cac498ae$var$nfe);
    $61de1ee1cac498ae$var$Zee = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$$ee = new $61de1ee1cac498ae$var$Lqb;
    $61de1ee1cac498ae$var$_ee = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        "Cn",
        "Lu",
        "Ll",
        "Lt",
        "Lm",
        "Lo",
        "Mn",
        "Me",
        "Mc",
        "Nd",
        "Nl",
        "No",
        "Zs",
        "Zl",
        "Zp",
        "Cc",
        "Cf",
        null,
        "Co",
        "Cs",
        "Pd",
        "Ps",
        "Pe",
        "Pc",
        "Po",
        "Sm",
        "Sc",
        "Sk",
        "So",
        "Pi",
        "Pf",
        "L",
        "M",
        "N",
        "Z",
        "C",
        "P",
        "S"
    ]);
    $61de1ee1cac498ae$var$Yee = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        "Basic Latin",
        "Latin-1 Supplement",
        "Latin Extended-A",
        "Latin Extended-B",
        "IPA Extensions",
        "Spacing Modifier Letters",
        "Combining Diacritical Marks",
        "Greek",
        "Cyrillic",
        "Armenian",
        "Hebrew",
        "Arabic",
        "Syriac",
        "Thaana",
        "Devanagari",
        "Bengali",
        "Gurmukhi",
        "Gujarati",
        "Oriya",
        "Tamil",
        "Telugu",
        "Kannada",
        "Malayalam",
        "Sinhala",
        "Thai",
        "Lao",
        "Tibetan",
        "Myanmar",
        "Georgian",
        "Hangul Jamo",
        "Ethiopic",
        "Cherokee",
        "Unified Canadian Aboriginal Syllabics",
        "Ogham",
        "Runic",
        "Khmer",
        "Mongolian",
        "Latin Extended Additional",
        "Greek Extended",
        "General Punctuation",
        "Superscripts and Subscripts",
        "Currency Symbols",
        "Combining Marks for Symbols",
        "Letterlike Symbols",
        "Number Forms",
        "Arrows",
        "Mathematical Operators",
        "Miscellaneous Technical",
        "Control Pictures",
        "Optical Character Recognition",
        "Enclosed Alphanumerics",
        "Box Drawing",
        "Block Elements",
        "Geometric Shapes",
        "Miscellaneous Symbols",
        "Dingbats",
        "Braille Patterns",
        "CJK Radicals Supplement",
        "Kangxi Radicals",
        "Ideographic Description Characters",
        "CJK Symbols and Punctuation",
        "Hiragana",
        "Katakana",
        "Bopomofo",
        "Hangul Compatibility Jamo",
        "Kanbun",
        "Bopomofo Extended",
        "Enclosed CJK Letters and Months",
        "CJK Compatibility",
        "CJK Unified Ideographs Extension A",
        "CJK Unified Ideographs",
        "Yi Syllables",
        "Yi Radicals",
        "Hangul Syllables",
        $61de1ee1cac498ae$var$uxe,
        "CJK Compatibility Ideographs",
        "Alphabetic Presentation Forms",
        "Arabic Presentation Forms-A",
        "Combining Half Marks",
        "CJK Compatibility Forms",
        "Small Form Variants",
        "Arabic Presentation Forms-B",
        "Specials",
        "Halfwidth and Fullwidth Forms",
        "Old Italic",
        "Gothic",
        "Deseret",
        "Byzantine Musical Symbols",
        "Musical Symbols",
        "Mathematical Alphanumeric Symbols",
        "CJK Unified Ideographs Extension B",
        "CJK Compatibility Ideographs Supplement",
        "Tags"
    ]);
    $61de1ee1cac498ae$var$afe = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
        66304,
        66351,
        66352,
        66383,
        66560,
        66639,
        118784,
        119039,
        119040,
        119295,
        119808,
        120831,
        131072,
        173782,
        194560,
        195103,
        917504,
        917631
    ]);
}
function $61de1ee1cac498ae$var$qJb() {
    $61de1ee1cac498ae$var$qJb = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$nJb = new $61de1ee1cac498ae$var$tJb("OUT_T_L", 0, ($61de1ee1cac498ae$var$NHb(), $61de1ee1cac498ae$var$LHb), ($61de1ee1cac498ae$var$EIb(), $61de1ee1cac498ae$var$BIb), ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$dHb), $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb(($61de1ee1cac498ae$var$Hbd(), $61de1ee1cac498ae$var$Dbd), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$zbd
        ]))
    ]));
    $61de1ee1cac498ae$var$mJb = new $61de1ee1cac498ae$var$tJb("OUT_T_C", 1, $61de1ee1cac498ae$var$KHb, $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$ybd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$ybd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$oJb = new $61de1ee1cac498ae$var$tJb("OUT_T_R", 2, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$Bbd
        ]))
    ]));
    $61de1ee1cac498ae$var$eJb = new $61de1ee1cac498ae$var$tJb("OUT_B_L", 3, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$zbd
        ]))
    ]));
    $61de1ee1cac498ae$var$dJb = new $61de1ee1cac498ae$var$tJb("OUT_B_C", 4, $61de1ee1cac498ae$var$KHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$ybd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$ybd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$fJb = new $61de1ee1cac498ae$var$tJb("OUT_B_R", 5, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$Bbd
        ]))
    ]));
    $61de1ee1cac498ae$var$iJb = new $61de1ee1cac498ae$var$tJb("OUT_L_T", 6, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$zbd,
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$hJb = new $61de1ee1cac498ae$var$tJb("OUT_L_C", 7, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$CIb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$zbd,
            $61de1ee1cac498ae$var$Fbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$zbd,
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$gJb = new $61de1ee1cac498ae$var$tJb("OUT_L_B", 8, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$zbd,
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$lJb = new $61de1ee1cac498ae$var$tJb("OUT_R_T", 9, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Bbd,
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$kJb = new $61de1ee1cac498ae$var$tJb("OUT_R_C", 10, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$CIb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Bbd,
            $61de1ee1cac498ae$var$Fbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Bbd,
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$jJb = new $61de1ee1cac498ae$var$tJb("OUT_R_B", 11, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Bbd,
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$bJb = new $61de1ee1cac498ae$var$tJb("IN_T_L", 12, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$zbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$zbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$aJb = new $61de1ee1cac498ae$var$tJb("IN_T_C", 13, $61de1ee1cac498ae$var$KHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$ybd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$ybd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$cJb = new $61de1ee1cac498ae$var$tJb("IN_T_R", 14, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$DIb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$Bbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Gbd,
            $61de1ee1cac498ae$var$Bbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$$Ib = new $61de1ee1cac498ae$var$tJb("IN_C_L", 15, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$CIb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$zbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$zbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$ZIb = new $61de1ee1cac498ae$var$tJb("IN_C_C", 16, $61de1ee1cac498ae$var$KHb, $61de1ee1cac498ae$var$CIb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$ybd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$ybd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$_Ib = new $61de1ee1cac498ae$var$tJb("IN_C_R", 17, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$CIb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$Bbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Fbd,
            $61de1ee1cac498ae$var$Bbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$XIb = new $61de1ee1cac498ae$var$tJb("IN_B_L", 18, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$zbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$zbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$WIb = new $61de1ee1cac498ae$var$tJb("IN_B_C", 19, $61de1ee1cac498ae$var$KHb, $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$ybd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$ybd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$YIb = new $61de1ee1cac498ae$var$tJb("IN_B_R", 20, $61de1ee1cac498ae$var$MHb, $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$fHb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, [
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$Bbd
        ])),
        $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$B1, 1), $61de1ee1cac498ae$var$Kie, 93, 0, [
            $61de1ee1cac498ae$var$Ebd,
            $61de1ee1cac498ae$var$Bbd,
            $61de1ee1cac498ae$var$Abd
        ]))
    ]));
    $61de1ee1cac498ae$var$pJb = new $61de1ee1cac498ae$var$tJb($61de1ee1cac498ae$var$ole, 21, null, null, null, null, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$LK, 1), $61de1ee1cac498ae$var$Uhe, 21, 0, []));
}
function $61de1ee1cac498ae$var$jGd() {
    $61de1ee1cac498ae$var$jGd = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$PFd = ($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).b;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.b), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.b), 1), 18);
    $61de1ee1cac498ae$var$OFd = $61de1ee1cac498ae$var$MFd.a;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.a), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.a), 1), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.a), 2), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.a), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.a), 4), 18);
    $61de1ee1cac498ae$var$QFd = $61de1ee1cac498ae$var$MFd.o;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 1), 34);
    $61de1ee1cac498ae$var$SFd = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 2), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 4), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 5), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 6), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 7), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 8), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 9), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 10), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 11), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 12), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 13), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 14), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.o), 15), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 0), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 1), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 2), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 3), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 4), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 5), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 6), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 7), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 8), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.o), 9), 59);
    $61de1ee1cac498ae$var$RFd = $61de1ee1cac498ae$var$MFd.p;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.p), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.p), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.p), 2), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.p), 3), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.p), 4), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.p), 5), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.p), 0), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.p), 1), 59);
    $61de1ee1cac498ae$var$TFd = $61de1ee1cac498ae$var$MFd.q;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.q), 0), 34);
    $61de1ee1cac498ae$var$UFd = $61de1ee1cac498ae$var$MFd.v;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.v), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.v), 0), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.v), 1), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.v), 2), 59);
    $61de1ee1cac498ae$var$VFd = $61de1ee1cac498ae$var$MFd.w;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.w), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.w), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.w), 2), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.w), 3), 18);
    $61de1ee1cac498ae$var$WFd = $61de1ee1cac498ae$var$MFd.B;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.B), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.B), 0), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.B), 1), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.B), 2), 59);
    $61de1ee1cac498ae$var$ZFd = $61de1ee1cac498ae$var$MFd.Q;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.Q), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.Q), 0), 59);
    $61de1ee1cac498ae$var$$Fd = $61de1ee1cac498ae$var$MFd.R;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.R), 0), 34);
    $61de1ee1cac498ae$var$_Fd = $61de1ee1cac498ae$var$MFd.S;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 0), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 1), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 2), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 3), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 4), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 5), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 6), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 7), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 8), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 9), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 10), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 11), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 12), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 13), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.S), 14), 59);
    $61de1ee1cac498ae$var$aGd = $61de1ee1cac498ae$var$MFd.T;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.T), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.T), 2), 18);
    $61de1ee1cac498ae$var$bGd = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.T), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.T), 4), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.T), 0), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.T), 1), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.T), 1), 18);
    $61de1ee1cac498ae$var$cGd = $61de1ee1cac498ae$var$MFd.U;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.U), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.U), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.U), 2), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.U), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.U), 4), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.U), 5), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.U), 0), 59);
    $61de1ee1cac498ae$var$dGd = $61de1ee1cac498ae$var$MFd.V;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.V), 0), 18);
    $61de1ee1cac498ae$var$eGd = $61de1ee1cac498ae$var$MFd.W;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.W), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.W), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.W), 2), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.W), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.W), 4), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.W), 5), 18);
    $61de1ee1cac498ae$var$gGd = $61de1ee1cac498ae$var$MFd.bb;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 2), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 3), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 4), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 5), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 6), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.bb), 7), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.bb), 0), 59);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.bb), 1), 59);
    $61de1ee1cac498ae$var$hGd = $61de1ee1cac498ae$var$MFd.eb;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 1), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 2), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 3), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 4), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 5), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 6), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.eb), 7), 18);
    $61de1ee1cac498ae$var$fGd = $61de1ee1cac498ae$var$MFd.ab;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.ab), 0), 34);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.ab), 1), 34);
    $61de1ee1cac498ae$var$XFd = $61de1ee1cac498ae$var$MFd.H;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.H), 0), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.H), 1), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.H), 2), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.H), 3), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.H), 4), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.H), 5), 18);
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd($61de1ee1cac498ae$var$MFd.H), 0), 59);
    $61de1ee1cac498ae$var$iGd = $61de1ee1cac498ae$var$MFd.db;
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd($61de1ee1cac498ae$var$MFd.db), 0), 18);
    $61de1ee1cac498ae$var$YFd = $61de1ee1cac498ae$var$MFd.M;
}
function $61de1ee1cac498ae$var$bae(a) {
    var b;
    if (a.O) return;
    a.O = true;
    $61de1ee1cac498ae$var$pnd(a, "type");
    $61de1ee1cac498ae$var$cod(a, "ecore.xml.type");
    $61de1ee1cac498ae$var$dod(a, $61de1ee1cac498ae$var$Ewe);
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$nUd(($61de1ee1cac498ae$var$yFd(), $61de1ee1cac498ae$var$xFd), $61de1ee1cac498ae$var$Ewe), 1945);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.fb), a.b);
    $61de1ee1cac498ae$var$Xnd(a.b, $61de1ee1cac498ae$var$Q9, "AnyType", false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 0), 34), a.wb.D, $61de1ee1cac498ae$var$Qve, null, 0, -1, $61de1ee1cac498ae$var$Q9, false, false, true, false, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 1), 34), a.wb.D, "any", null, 0, -1, $61de1ee1cac498ae$var$Q9, true, true, true, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 2), 34), a.wb.D, "anyAttribute", null, 0, -1, $61de1ee1cac498ae$var$Q9, false, false, true, false, false, false);
    $61de1ee1cac498ae$var$Xnd(a.bb, $61de1ee1cac498ae$var$S9, $61de1ee1cac498ae$var$Jwe, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 0), 34), a.gb, "data", null, 0, 1, $61de1ee1cac498ae$var$S9, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 1), 34), a.gb, $61de1ee1cac498ae$var$bue, null, 1, 1, $61de1ee1cac498ae$var$S9, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Xnd(a.fb, $61de1ee1cac498ae$var$T9, $61de1ee1cac498ae$var$Kwe, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.fb), 0), 34), b.gb, "rawValue", null, 0, 1, $61de1ee1cac498ae$var$T9, true, true, true, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.fb), 1), 34), b.a, $61de1ee1cac498ae$var$Bte, null, 0, 1, $61de1ee1cac498ae$var$T9, true, true, true, false, true, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.fb), 2), 18), a.wb.q, null, "instanceType", 1, 1, $61de1ee1cac498ae$var$T9, false, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$Xnd(a.qb, $61de1ee1cac498ae$var$U9, $61de1ee1cac498ae$var$Lwe, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 0), 34), a.wb.D, $61de1ee1cac498ae$var$Qve, null, 0, -1, null, false, false, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 1), 18), a.wb.ab, null, "xMLNSPrefixMap", 0, -1, null, true, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 2), 18), a.wb.ab, null, "xSISchemaLocation", 0, -1, null, true, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 3), 34), a.gb, "cDATA", null, 0, -2, null, true, true, true, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 4), 34), a.gb, "comment", null, 0, -2, null, true, true, true, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 5), 18), a.bb, null, $61de1ee1cac498ae$var$jxe, 0, -2, null, true, true, true, true, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 6), 34), a.gb, $61de1ee1cac498ae$var$Ite, null, 0, -2, null, true, true, true, false, false, true);
    $61de1ee1cac498ae$var$Znd(a.a, $61de1ee1cac498ae$var$SI, "AnySimpleType", true);
    $61de1ee1cac498ae$var$Znd(a.c, $61de1ee1cac498ae$var$ZI, "AnyURI", true);
    $61de1ee1cac498ae$var$Znd(a.d, $61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SD, 1), "Base64Binary", true);
    $61de1ee1cac498ae$var$Znd(a.e, $61de1ee1cac498ae$var$sbb, "Boolean", true);
    $61de1ee1cac498ae$var$Znd(a.f, $61de1ee1cac498ae$var$wI, "BooleanObject", true);
    $61de1ee1cac498ae$var$Znd(a.g, $61de1ee1cac498ae$var$SD, "Byte", true);
    $61de1ee1cac498ae$var$Znd(a.i, $61de1ee1cac498ae$var$xI, "ByteObject", true);
    $61de1ee1cac498ae$var$Znd(a.j, $61de1ee1cac498ae$var$ZI, "Date", true);
    $61de1ee1cac498ae$var$Znd(a.k, $61de1ee1cac498ae$var$ZI, "DateTime", true);
    $61de1ee1cac498ae$var$Znd(a.n, $61de1ee1cac498ae$var$bJ, "Decimal", true);
    $61de1ee1cac498ae$var$Znd(a.o, $61de1ee1cac498ae$var$UD, "Double", true);
    $61de1ee1cac498ae$var$Znd(a.p, $61de1ee1cac498ae$var$BI, "DoubleObject", true);
    $61de1ee1cac498ae$var$Znd(a.q, $61de1ee1cac498ae$var$ZI, "Duration", true);
    $61de1ee1cac498ae$var$Znd(a.s, $61de1ee1cac498ae$var$yK, "ENTITIES", true);
    $61de1ee1cac498ae$var$Znd(a.r, $61de1ee1cac498ae$var$yK, "ENTITIESBase", true);
    $61de1ee1cac498ae$var$Znd(a.t, $61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$Rwe, true);
    $61de1ee1cac498ae$var$Znd(a.u, $61de1ee1cac498ae$var$VD, "Float", true);
    $61de1ee1cac498ae$var$Znd(a.v, $61de1ee1cac498ae$var$FI, "FloatObject", true);
    $61de1ee1cac498ae$var$Znd(a.w, $61de1ee1cac498ae$var$ZI, "GDay", true);
    $61de1ee1cac498ae$var$Znd(a.B, $61de1ee1cac498ae$var$ZI, "GMonth", true);
    $61de1ee1cac498ae$var$Znd(a.A, $61de1ee1cac498ae$var$ZI, "GMonthDay", true);
    $61de1ee1cac498ae$var$Znd(a.C, $61de1ee1cac498ae$var$ZI, "GYear", true);
    $61de1ee1cac498ae$var$Znd(a.D, $61de1ee1cac498ae$var$ZI, "GYearMonth", true);
    $61de1ee1cac498ae$var$Znd(a.F, $61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SD, 1), "HexBinary", true);
    $61de1ee1cac498ae$var$Znd(a.G, $61de1ee1cac498ae$var$ZI, "ID", true);
    $61de1ee1cac498ae$var$Znd(a.H, $61de1ee1cac498ae$var$ZI, "IDREF", true);
    $61de1ee1cac498ae$var$Znd(a.J, $61de1ee1cac498ae$var$yK, "IDREFS", true);
    $61de1ee1cac498ae$var$Znd(a.I, $61de1ee1cac498ae$var$yK, "IDREFSBase", true);
    $61de1ee1cac498ae$var$Znd(a.K, $61de1ee1cac498ae$var$WD, "Int", true);
    $61de1ee1cac498ae$var$Znd(a.M, $61de1ee1cac498ae$var$cJ, "Integer", true);
    $61de1ee1cac498ae$var$Znd(a.L, $61de1ee1cac498ae$var$JI, "IntObject", true);
    $61de1ee1cac498ae$var$Znd(a.P, $61de1ee1cac498ae$var$ZI, "Language", true);
    $61de1ee1cac498ae$var$Znd(a.Q, $61de1ee1cac498ae$var$XD, "Long", true);
    $61de1ee1cac498ae$var$Znd(a.R, $61de1ee1cac498ae$var$MI, "LongObject", true);
    $61de1ee1cac498ae$var$Znd(a.S, $61de1ee1cac498ae$var$ZI, "Name", true);
    $61de1ee1cac498ae$var$Znd(a.T, $61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$Swe, true);
    $61de1ee1cac498ae$var$Znd(a.U, $61de1ee1cac498ae$var$cJ, "NegativeInteger", true);
    $61de1ee1cac498ae$var$Znd(a.V, $61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$axe, true);
    $61de1ee1cac498ae$var$Znd(a.X, $61de1ee1cac498ae$var$yK, "NMTOKENS", true);
    $61de1ee1cac498ae$var$Znd(a.W, $61de1ee1cac498ae$var$yK, "NMTOKENSBase", true);
    $61de1ee1cac498ae$var$Znd(a.Y, $61de1ee1cac498ae$var$cJ, "NonNegativeInteger", true);
    $61de1ee1cac498ae$var$Znd(a.Z, $61de1ee1cac498ae$var$cJ, "NonPositiveInteger", true);
    $61de1ee1cac498ae$var$Znd(a.$, $61de1ee1cac498ae$var$ZI, "NormalizedString", true);
    $61de1ee1cac498ae$var$Znd(a._, $61de1ee1cac498ae$var$ZI, "NOTATION", true);
    $61de1ee1cac498ae$var$Znd(a.ab, $61de1ee1cac498ae$var$ZI, "PositiveInteger", true);
    $61de1ee1cac498ae$var$Znd(a.cb, $61de1ee1cac498ae$var$ZI, "QName", true);
    $61de1ee1cac498ae$var$Znd(a.db, $61de1ee1cac498ae$var$rbb, "Short", true);
    $61de1ee1cac498ae$var$Znd(a.eb, $61de1ee1cac498ae$var$UI, "ShortObject", true);
    $61de1ee1cac498ae$var$Znd(a.gb, $61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$Vie, true);
    $61de1ee1cac498ae$var$Znd(a.hb, $61de1ee1cac498ae$var$ZI, "Time", true);
    $61de1ee1cac498ae$var$Znd(a.ib, $61de1ee1cac498ae$var$ZI, "Token", true);
    $61de1ee1cac498ae$var$Znd(a.jb, $61de1ee1cac498ae$var$rbb, "UnsignedByte", true);
    $61de1ee1cac498ae$var$Znd(a.kb, $61de1ee1cac498ae$var$UI, "UnsignedByteObject", true);
    $61de1ee1cac498ae$var$Znd(a.lb, $61de1ee1cac498ae$var$XD, "UnsignedInt", true);
    $61de1ee1cac498ae$var$Znd(a.mb, $61de1ee1cac498ae$var$MI, "UnsignedIntObject", true);
    $61de1ee1cac498ae$var$Znd(a.nb, $61de1ee1cac498ae$var$cJ, "UnsignedLong", true);
    $61de1ee1cac498ae$var$Znd(a.ob, $61de1ee1cac498ae$var$WD, "UnsignedShort", true);
    $61de1ee1cac498ae$var$Znd(a.pb, $61de1ee1cac498ae$var$JI, "UnsignedShortObject", true);
    $61de1ee1cac498ae$var$Rnd(a, $61de1ee1cac498ae$var$Ewe);
    $61de1ee1cac498ae$var$_9d(a);
}
function $61de1ee1cac498ae$var$Oyc(a) {
    $61de1ee1cac498ae$var$r4c(a, new $61de1ee1cac498ae$var$E3c($61de1ee1cac498ae$var$Q3c($61de1ee1cac498ae$var$L3c($61de1ee1cac498ae$var$P3c($61de1ee1cac498ae$var$M3c($61de1ee1cac498ae$var$O3c($61de1ee1cac498ae$var$N3c(new $61de1ee1cac498ae$var$R3c, $61de1ee1cac498ae$var$sne), "ELK Layered"), "Layer-based algorithm provided by the Eclipse Layout Kernel. Arranges as many edges as possible into one direction by placing nodes into subsequent layers. This implementation supports different routing styles (straight, orthogonal, splines); if orthogonal routing is selected, arbitrary port constraints are respected, thus enabling the layout of block diagrams such as actor-oriented models or circuit schematics. Furthermore, full layout of compound graphs with cross-hierarchy edges is supported when the respective option is activated on the top level."), new $61de1ee1cac498ae$var$Ryc), $61de1ee1cac498ae$var$sne), $61de1ee1cac498ae$var$qqb(($61de1ee1cac498ae$var$Csd(), $61de1ee1cac498ae$var$Bsd), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$O3, 1), $61de1ee1cac498ae$var$Kie, 237, 0, [
        $61de1ee1cac498ae$var$ysd,
        $61de1ee1cac498ae$var$zsd,
        $61de1ee1cac498ae$var$xsd,
        $61de1ee1cac498ae$var$Asd,
        $61de1ee1cac498ae$var$vsd,
        $61de1ee1cac498ae$var$usd
    ])))));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Lpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$iyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Mpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$jyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Zle, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$kyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Npe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$lyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$xme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$nyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Ope, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$oyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Ppe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ryc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Qpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$tyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Rpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$uyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Spe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$syc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$wme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$vyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Tpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$xyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Upe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$zyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Vpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$qyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Loe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$hyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Noe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$myc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Moe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$pyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Ooe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$wyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$vme, $61de1ee1cac498ae$var$meb(0));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Poe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$cyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Qoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$dyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Roe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$eyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Kyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Zoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Cyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$$oe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Dyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$_oe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Gyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$ape, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Eyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$bpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Fyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$cpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Myc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$dpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Lyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$epe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Iyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$fpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Hyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$gpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Jyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Eoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Cxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Foe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Dxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Ioe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Xwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Joe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Ywc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$ame, $61de1ee1cac498ae$var$Lxc);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$ype, $61de1ee1cac498ae$var$Twc);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Wpe, 0);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$yme, $61de1ee1cac498ae$var$meb(1));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$_le, $61de1ee1cac498ae$var$tme);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Xpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Jxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Bme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Vxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Ype, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$$xc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Zpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Kwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$$pe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$mwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$tpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$axc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$zme, ($61de1ee1cac498ae$var$Bcb(), true));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$_pe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$fxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$aqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$gxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Fme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Fxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Eme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Ixc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$bqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Gxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$cqe, $61de1ee1cac498ae$var$Nwc);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Gme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$xxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$dqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$wxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Hme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Yxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$eqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Xxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$fqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Zxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$gqe, $61de1ee1cac498ae$var$Oxc);
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$hqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Qxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$iqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Rxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$jqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Sxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$kqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Pxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$eoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Byc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$hoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$sxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$noe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$rxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$doe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Ayc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$ioe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$mxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$goe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Jwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$qoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Iwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$roe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Awc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$woe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Bwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$xoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Dwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$yoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Cwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$toe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Hwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$_ne, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$uxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$aoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$vxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$$ne, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ixc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Exc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Coe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$zxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Zne, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$$wc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Doe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Bxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Goe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Vwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Hoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Wwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$lqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$zwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Boe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$yxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Toe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$swc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Uoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$rwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Soe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$qwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Voe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$cxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Woe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$bxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Xoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$dxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Tme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Hxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$mqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$jxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$$le, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Zwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$nqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Qwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Cme, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Pwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$soe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Ewc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$oqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Wxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$pqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$pwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$qqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$exc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$rqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Txc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$sqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Mxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$tqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Nxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$loe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$oxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$moe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$pxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$uqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ayc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$boe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$nwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$ooe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$qxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$hpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Rwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$ipe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Owc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$vqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$txc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$poe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$kxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Aoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Axc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$wqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$yyc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Yne, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Mwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$coe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$_xc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$Koe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Uwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$joe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$lxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$uoe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Fwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$xqe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$hxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$koe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$nxc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$voe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$Gwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$jpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$ywc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$mpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$wwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$npe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$uwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$ope, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$vwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$kpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$xwc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$lpe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$twc));
    $61de1ee1cac498ae$var$p4c(a, $61de1ee1cac498ae$var$sne, $61de1ee1cac498ae$var$foe, $61de1ee1cac498ae$var$Ksd($61de1ee1cac498ae$var$_wc));
}
function $61de1ee1cac498ae$var$kee(a, b) {
    var c, d;
    if (!$61de1ee1cac498ae$var$cee) {
        $61de1ee1cac498ae$var$cee = new $61de1ee1cac498ae$var$Lqb;
        $61de1ee1cac498ae$var$dee = new $61de1ee1cac498ae$var$Lqb;
        d = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ree(d, "	\n\r\r  ");
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$cee, $61de1ee1cac498ae$var$pxe, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$dee, $61de1ee1cac498ae$var$pxe, $61de1ee1cac498ae$var$_fe(d));
        d = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ree(d, $61de1ee1cac498ae$var$sxe);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$cee, $61de1ee1cac498ae$var$nxe, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$dee, $61de1ee1cac498ae$var$nxe, $61de1ee1cac498ae$var$_fe(d));
        d = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ree(d, $61de1ee1cac498ae$var$sxe);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$cee, $61de1ee1cac498ae$var$nxe, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$dee, $61de1ee1cac498ae$var$nxe, $61de1ee1cac498ae$var$_fe(d));
        d = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ree(d, $61de1ee1cac498ae$var$txe);
        $61de1ee1cac498ae$var$Xfe(d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$cee, $61de1ee1cac498ae$var$nxe), 117));
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$cee, $61de1ee1cac498ae$var$oxe, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$dee, $61de1ee1cac498ae$var$oxe, $61de1ee1cac498ae$var$_fe(d));
        d = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ree(d, "-.0:AZ__az\xb7\xb7\xc0\xd6\xd8\xf6\xf8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u02D0\u02D1\u0300\u0345\u0360\u0361\u0386\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0483\u0486\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u0591\u05A1\u05A3\u05B9\u05BB\u05BD\u05BF\u05BF\u05C1\u05C2\u05C4\u05C4\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0640\u0652\u0660\u0669\u0670\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06E8\u06EA\u06ED\u06F0\u06F9\u0901\u0903\u0905\u0939\u093C\u094D\u0951\u0954\u0958\u0963\u0966\u096F\u0981\u0983\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09BC\u09BC\u09BE\u09C4\u09C7\u09C8\u09CB\u09CD\u09D7\u09D7\u09DC\u09DD\u09DF\u09E3\u09E6\u09F1\u0A02\u0A02\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3C\u0A3E\u0A42\u0A47\u0A48\u0A4B\u0A4D\u0A59\u0A5C\u0A5E\u0A5E\u0A66\u0A74\u0A81\u0A83\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABC\u0AC5\u0AC7\u0AC9\u0ACB\u0ACD\u0AE0\u0AE0\u0AE6\u0AEF\u0B01\u0B03\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3C\u0B43\u0B47\u0B48\u0B4B\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F\u0B61\u0B66\u0B6F\u0B82\u0B83\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0BBE\u0BC2\u0BC6\u0BC8\u0BCA\u0BCD\u0BD7\u0BD7\u0BE7\u0BEF\u0C01\u0C03\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C3E\u0C44\u0C46\u0C48\u0C4A\u0C4D\u0C55\u0C56\u0C60\u0C61\u0C66\u0C6F\u0C82\u0C83\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CBE\u0CC4\u0CC6\u0CC8\u0CCA\u0CCD\u0CD5\u0CD6\u0CDE\u0CDE\u0CE0\u0CE1\u0CE6\u0CEF\u0D02\u0D03\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D3E\u0D43\u0D46\u0D48\u0D4A\u0D4D\u0D57\u0D57\u0D60\u0D61\u0D66\u0D6F\u0E01\u0E2E\u0E30\u0E3A\u0E40\u0E4E\u0E50\u0E59\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB9\u0EBB\u0EBD\u0EC0\u0EC4\u0EC6\u0EC6\u0EC8\u0ECD\u0ED0\u0ED9\u0F18\u0F19\u0F20\u0F29\u0F35\u0F35\u0F37\u0F37\u0F39\u0F39\u0F3E\u0F47\u0F49\u0F69\u0F71\u0F84\u0F86\u0F8B\u0F90\u0F95\u0F97\u0F97\u0F99\u0FAD\u0FB1\u0FB7\u0FB9\u0FB9\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u20D0\u20DC\u20E1\u20E1\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3005\u3005\u3007\u3007\u3021\u302F\u3031\u3035\u3041\u3094\u3099\u309A\u309D\u309E\u30A1\u30FA\u30FC\u30FE\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3");
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$cee, $61de1ee1cac498ae$var$qxe, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$dee, $61de1ee1cac498ae$var$qxe, $61de1ee1cac498ae$var$_fe(d));
        d = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        $61de1ee1cac498ae$var$Ree(d, $61de1ee1cac498ae$var$txe);
        $61de1ee1cac498ae$var$Ufe(d, 95, 95);
        $61de1ee1cac498ae$var$Ufe(d, 58, 58);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$cee, $61de1ee1cac498ae$var$rxe, d);
        $61de1ee1cac498ae$var$Shb($61de1ee1cac498ae$var$dee, $61de1ee1cac498ae$var$rxe, $61de1ee1cac498ae$var$_fe(d));
    }
    c = b ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$cee, a), 136) : $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Phb($61de1ee1cac498ae$var$dee, a), 136);
    return c;
}
function $61de1ee1cac498ae$var$_9d(a) {
    $61de1ee1cac498ae$var$Bnd(a.a, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "anySimpleType"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.b, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "anyType",
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$Qve
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 0), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$xwe,
        $61de1ee1cac498ae$var$fue,
        ":mixed"
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 1), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$xwe,
        $61de1ee1cac498ae$var$Dwe,
        $61de1ee1cac498ae$var$Fwe,
        $61de1ee1cac498ae$var$fue,
        ":1",
        $61de1ee1cac498ae$var$Owe,
        "lax"
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 2), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$vwe,
        $61de1ee1cac498ae$var$Dwe,
        $61de1ee1cac498ae$var$Fwe,
        $61de1ee1cac498ae$var$fue,
        ":2",
        $61de1ee1cac498ae$var$Owe,
        "lax"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.c, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "anyURI",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.d, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "base64Binary",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.e, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Khe,
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.f, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "boolean:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Khe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.g, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Eve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.i, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "byte:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Eve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.j, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "date",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.k, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "dateTime",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.n, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "decimal",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.o, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Gve,
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.p, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "double:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Gve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.q, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "duration",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.s, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "ENTITIES",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Pwe,
        $61de1ee1cac498ae$var$Qwe,
        "1"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.r, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Pwe,
        $61de1ee1cac498ae$var$zwe,
        $61de1ee1cac498ae$var$Rwe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.t, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Rwe,
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Swe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.u, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Hve,
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.v, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "float:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Hve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.w, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "gDay",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.B, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "gMonth",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.A, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "gMonthDay",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.C, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "gYear",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.D, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "gYearMonth",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.F, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "hexBinary",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.G, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "ID",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Swe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.H, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "IDREF",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Swe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.J, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "IDREFS",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Twe,
        $61de1ee1cac498ae$var$Qwe,
        "1"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.I, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Twe,
        $61de1ee1cac498ae$var$zwe,
        "IDREF"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.K, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Ive
    ]));
    $61de1ee1cac498ae$var$Bnd(a.M, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Uwe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.L, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "int:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Ive
    ]));
    $61de1ee1cac498ae$var$Bnd(a.P, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "language",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Vwe,
        $61de1ee1cac498ae$var$Wwe,
        $61de1ee1cac498ae$var$Xwe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.Q, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Jve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.R, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "long:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Jve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.S, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "Name",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Vwe,
        $61de1ee1cac498ae$var$Wwe,
        $61de1ee1cac498ae$var$Ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.T, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Swe,
        $61de1ee1cac498ae$var$cwe,
        "Name",
        $61de1ee1cac498ae$var$Wwe,
        $61de1ee1cac498ae$var$Zwe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.U, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "negativeInteger",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$$we,
        $61de1ee1cac498ae$var$_we,
        "-1"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.V, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$axe,
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Vwe,
        $61de1ee1cac498ae$var$Wwe,
        "\\c+"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.X, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "NMTOKENS",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$bxe,
        $61de1ee1cac498ae$var$Qwe,
        "1"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.W, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$bxe,
        $61de1ee1cac498ae$var$zwe,
        $61de1ee1cac498ae$var$axe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.Y, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$cxe,
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Uwe,
        $61de1ee1cac498ae$var$dxe,
        "0"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.Z, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$$we,
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Uwe,
        $61de1ee1cac498ae$var$_we,
        "0"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.$, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$exe,
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Mhe,
        $61de1ee1cac498ae$var$Cwe,
        "replace"
    ]));
    $61de1ee1cac498ae$var$Bnd(a._, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "NOTATION",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.ab, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "positiveInteger",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$cxe,
        $61de1ee1cac498ae$var$dxe,
        "1"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.bb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "processingInstruction_._type",
        $61de1ee1cac498ae$var$Sve,
        "empty"
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 0), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$uwe,
        $61de1ee1cac498ae$var$fue,
        "data"
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 1), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$uwe,
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$bue
    ]));
    $61de1ee1cac498ae$var$Bnd(a.cb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "QName",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.db, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Kve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.eb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "short:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$Kve
    ]));
    $61de1ee1cac498ae$var$Bnd(a.fb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "simpleAnyType",
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$twe
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.fb), 0), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        ":3",
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$twe
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.fb), 1), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        ":4",
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$twe
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.fb), 2), 18), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        ":5",
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$twe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.gb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Mhe,
        $61de1ee1cac498ae$var$Cwe,
        "preserve"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.hb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "time",
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.ib, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Vwe,
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$exe,
        $61de1ee1cac498ae$var$Cwe,
        $61de1ee1cac498ae$var$ywe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.jb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$fxe,
        $61de1ee1cac498ae$var$_we,
        "255",
        $61de1ee1cac498ae$var$dxe,
        "0"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.kb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "unsignedByte:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$fxe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.lb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$gxe,
        $61de1ee1cac498ae$var$_we,
        "4294967295",
        $61de1ee1cac498ae$var$dxe,
        "0"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.mb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "unsignedInt:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$gxe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.nb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "unsignedLong",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$cxe,
        $61de1ee1cac498ae$var$_we,
        $61de1ee1cac498ae$var$hxe,
        $61de1ee1cac498ae$var$dxe,
        "0"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.ob, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$ixe,
        $61de1ee1cac498ae$var$_we,
        "65535",
        $61de1ee1cac498ae$var$dxe,
        "0"
    ]));
    $61de1ee1cac498ae$var$Bnd(a.pb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "unsignedShort:Object",
        $61de1ee1cac498ae$var$cwe,
        $61de1ee1cac498ae$var$ixe
    ]));
    $61de1ee1cac498ae$var$Bnd(a.qb, $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$fue,
        "",
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$Qve
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 0), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$xwe,
        $61de1ee1cac498ae$var$fue,
        ":mixed"
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 1), 18), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$uwe,
        $61de1ee1cac498ae$var$fue,
        "xmlns:prefix"
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 2), 18), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$uwe,
        $61de1ee1cac498ae$var$fue,
        "xsi:schemaLocation"
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 3), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$wwe,
        $61de1ee1cac498ae$var$fue,
        "cDATA",
        $61de1ee1cac498ae$var$Awe,
        $61de1ee1cac498ae$var$Bwe
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 4), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$wwe,
        $61de1ee1cac498ae$var$fue,
        "comment",
        $61de1ee1cac498ae$var$Awe,
        $61de1ee1cac498ae$var$Bwe
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 5), 18), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$wwe,
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$jxe,
        $61de1ee1cac498ae$var$Awe,
        $61de1ee1cac498ae$var$Bwe
    ]));
    $61de1ee1cac498ae$var$Bnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.qb), 6), 34), $61de1ee1cac498ae$var$Rve, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        $61de1ee1cac498ae$var$Sve,
        $61de1ee1cac498ae$var$wwe,
        $61de1ee1cac498ae$var$fue,
        $61de1ee1cac498ae$var$Ite,
        $61de1ee1cac498ae$var$Awe,
        $61de1ee1cac498ae$var$Bwe
    ]));
}
function $61de1ee1cac498ae$var$tvd(a) {
    return $61de1ee1cac498ae$var$dfb("_UI_EMFDiagnostic_marker", a) ? "EMF Problem" : $61de1ee1cac498ae$var$dfb("_UI_CircularContainment_diagnostic", a) ? "An object may not circularly contain itself" : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$sue, a) ? "Wrong character." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$tue, a) ? "Invalid reference number." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$uue, a) ? "A character is required after \\." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$vue, a) ? "'?' is not expected.  '(?:' or '(?=' or '(?!' or '(?<' or '(?#' or '(?>'?" : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$wue, a) ? "'(?<' or '(?<!' is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$xue, a) ? "A comment is not terminated." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$yue, a) ? "')' is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$zue, a) ? "Unexpected end of the pattern in a modifier group." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Aue, a) ? "':' is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Bue, a) ? "Unexpected end of the pattern in a conditional group." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Cue, a) ? "A back reference or an anchor or a lookahead or a look-behind is expected in a conditional pattern." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Due, a) ? "There are more than three choices in a conditional group." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Eue, a) ? "A character in U+0040-U+005f must follow \\c." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Fue, a) ? "A '{' is required before a character category." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Gue, a) ? "A property name is not closed by '}'." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Hue, a) ? "Unexpected meta character." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Iue, a) ? "Unknown property." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Jue, a) ? "A POSIX character class must be closed by ':]'." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Kue, a) ? "Unexpected end of the pattern in a character class." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Lue, a) ? "Unknown name for a POSIX character class." : $61de1ee1cac498ae$var$dfb("parser.cc.4", a) ? "'-' is invalid here." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Mue, a) ? "']' is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Nue, a) ? "'[' is invalid in a character class.  Write '\\['." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Oue, a) ? "']' is invalid in a character class.  Write '\\]'." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Pue, a) ? "'-' is an invalid character range. Write '\\-'." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Que, a) ? "'[' is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Rue, a) ? "')' or '-[' or '+[' or '&[' is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Sue, a) ? "The range end code point is less than the start code point." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Tue, a) ? "Invalid Unicode hex notation." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Uue, a) ? "Overflow in a hex notation." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Vue, a) ? "'\\x{' must be closed by '}'." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Wue, a) ? "Invalid Unicode code point." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Xue, a) ? "An anchor must not be here." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Yue, a) ? "This expression is not supported in the current option setting." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$Zue, a) ? "Invalid quantifier. A digit is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$$ue, a) ? "Invalid quantifier. Invalid quantity or a '}' is missing." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$_ue, a) ? "Invalid quantifier. A digit or '}' is expected." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$ave, a) ? "Invalid quantifier. A min quantity must be <= a max quantity." : $61de1ee1cac498ae$var$dfb($61de1ee1cac498ae$var$bve, a) ? "Invalid quantifier. A quantity value overflow." : $61de1ee1cac498ae$var$dfb("_UI_PackageRegistry_extensionpoint", a) ? "Ecore Package Registry for Generated Packages" : $61de1ee1cac498ae$var$dfb("_UI_DynamicPackageRegistry_extensionpoint", a) ? "Ecore Package Registry for Dynamic Packages" : $61de1ee1cac498ae$var$dfb("_UI_FactoryRegistry_extensionpoint", a) ? "Ecore Factory Override Registry" : $61de1ee1cac498ae$var$dfb("_UI_URIExtensionParserRegistry_extensionpoint", a) ? "URI Extension Parser Registry" : $61de1ee1cac498ae$var$dfb("_UI_URIProtocolParserRegistry_extensionpoint", a) ? "URI Protocol Parser Registry" : $61de1ee1cac498ae$var$dfb("_UI_URIContentParserRegistry_extensionpoint", a) ? "URI Content Parser Registry" : $61de1ee1cac498ae$var$dfb("_UI_ContentHandlerRegistry_extensionpoint", a) ? "Content Handler Registry" : $61de1ee1cac498ae$var$dfb("_UI_URIMappingRegistry_extensionpoint", a) ? "URI Converter Mapping Registry" : $61de1ee1cac498ae$var$dfb("_UI_PackageRegistryImplementation_extensionpoint", a) ? "Ecore Package Registry Implementation" : $61de1ee1cac498ae$var$dfb("_UI_ValidationDelegateRegistry_extensionpoint", a) ? "Validation Delegate Registry" : $61de1ee1cac498ae$var$dfb("_UI_SettingDelegateRegistry_extensionpoint", a) ? "Feature Setting Delegate Factory Registry" : $61de1ee1cac498ae$var$dfb("_UI_InvocationDelegateRegistry_extensionpoint", a) ? "Operation Invocation Delegate Factory Registry" : $61de1ee1cac498ae$var$dfb("_UI_EClassInterfaceNotAbstract_diagnostic", a) ? "A class that is an interface must also be abstract" : $61de1ee1cac498ae$var$dfb("_UI_EClassNoCircularSuperTypes_diagnostic", a) ? "A class may not be a super type of itself" : $61de1ee1cac498ae$var$dfb("_UI_EClassNotWellFormedMapEntryNoInstanceClassName_diagnostic", a) ? "A class that inherits from a map entry class must have instance class name 'java.util.Map$Entry'" : $61de1ee1cac498ae$var$dfb("_UI_EReferenceOppositeOfOppositeInconsistent_diagnostic", a) ? "The opposite of the opposite may not be a reference different from this one" : $61de1ee1cac498ae$var$dfb("_UI_EReferenceOppositeNotFeatureOfType_diagnostic", a) ? "The opposite must be a feature of the reference's type" : $61de1ee1cac498ae$var$dfb("_UI_EReferenceTransientOppositeNotTransient_diagnostic", a) ? "The opposite of a transient reference must be transient if it is proxy resolving" : $61de1ee1cac498ae$var$dfb("_UI_EReferenceOppositeBothContainment_diagnostic", a) ? "The opposite of a containment reference must not be a containment reference" : $61de1ee1cac498ae$var$dfb("_UI_EReferenceConsistentUnique_diagnostic", a) ? "A containment or bidirectional reference must be unique if its upper bound is different from 1" : $61de1ee1cac498ae$var$dfb("_UI_ETypedElementNoType_diagnostic", a) ? "The typed element must have a type" : $61de1ee1cac498ae$var$dfb("_UI_EAttributeNoDataType_diagnostic", a) ? "The generic attribute type must not refer to a class" : $61de1ee1cac498ae$var$dfb("_UI_EReferenceNoClass_diagnostic", a) ? "The generic reference type must not refer to a data type" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeNoTypeParameterAndClassifier_diagnostic", a) ? "A generic type can't refer to both a type parameter and a classifier" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeNoClass_diagnostic", a) ? "A generic super type must refer to a class" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeNoTypeParameterOrClassifier_diagnostic", a) ? "A generic type in this context must refer to a classifier or a type parameter" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeBoundsOnlyForTypeArgument_diagnostic", a) ? "A generic type may have bounds only when used as a type argument" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeNoUpperAndLowerBound_diagnostic", a) ? "A generic type must not have both a lower and an upper bound" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeNoTypeParameterOrClassifierAndBound_diagnostic", a) ? "A generic type with bounds must not also refer to a type parameter or classifier" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeNoArguments_diagnostic", a) ? "A generic type may have arguments only if it refers to a classifier" : $61de1ee1cac498ae$var$dfb("_UI_EGenericTypeOutOfScopeTypeParameter_diagnostic", a) ? "A generic type may only refer to a type parameter that is in scope" : a;
}
function $61de1ee1cac498ae$var$Aod(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (a.r) return;
    a.r = true;
    $61de1ee1cac498ae$var$pnd(a, "graph");
    $61de1ee1cac498ae$var$cod(a, "graph");
    $61de1ee1cac498ae$var$dod(a, $61de1ee1cac498ae$var$yte);
    $61de1ee1cac498ae$var$Gnd(a.o, "T");
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.a), a.p);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.f), a.a);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.n), a.f);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.g), a.n);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.c), a.n);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.i), a.c);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.j), a.c);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.d), a.f);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.e), a.a);
    $61de1ee1cac498ae$var$Xnd(a.p, $61de1ee1cac498ae$var$P3, $61de1ee1cac498ae$var$Ile, true, true, false);
    o = $61de1ee1cac498ae$var$Dnd(a.p, a.p, "setProperty");
    p = $61de1ee1cac498ae$var$Hnd(o);
    j = $61de1ee1cac498ae$var$Nnd(a.o);
    k = (c = (d = new $61de1ee1cac498ae$var$UQd, d), c);
    $61de1ee1cac498ae$var$wtd((!j.d && (j.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, j, 1)), j.d), k);
    l = $61de1ee1cac498ae$var$Ond(p);
    $61de1ee1cac498ae$var$PQd(k, l);
    $61de1ee1cac498ae$var$Fnd(o, j, $61de1ee1cac498ae$var$Ate);
    j = $61de1ee1cac498ae$var$Ond(p);
    $61de1ee1cac498ae$var$Fnd(o, j, $61de1ee1cac498ae$var$Bte);
    o = $61de1ee1cac498ae$var$Dnd(a.p, null, "getProperty");
    p = $61de1ee1cac498ae$var$Hnd(o);
    j = $61de1ee1cac498ae$var$Nnd(a.o);
    k = $61de1ee1cac498ae$var$Ond(p);
    $61de1ee1cac498ae$var$wtd((!j.d && (j.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, j, 1)), j.d), k);
    $61de1ee1cac498ae$var$Fnd(o, j, $61de1ee1cac498ae$var$Ate);
    j = $61de1ee1cac498ae$var$Ond(p);
    n = $61de1ee1cac498ae$var$xId(o, j, null);
    !!n && n.Fi();
    o = $61de1ee1cac498ae$var$Dnd(a.p, a.wb.e, "hasProperty");
    j = $61de1ee1cac498ae$var$Nnd(a.o);
    k = (e = (f = new $61de1ee1cac498ae$var$UQd, f), e);
    $61de1ee1cac498ae$var$wtd((!j.d && (j.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, j, 1)), j.d), k);
    $61de1ee1cac498ae$var$Fnd(o, j, $61de1ee1cac498ae$var$Ate);
    o = $61de1ee1cac498ae$var$Dnd(a.p, a.p, "copyProperties");
    $61de1ee1cac498ae$var$End(o, a.p, $61de1ee1cac498ae$var$Cte);
    o = $61de1ee1cac498ae$var$Dnd(a.p, null, "getAllProperties");
    j = $61de1ee1cac498ae$var$Nnd(a.wb.P);
    k = $61de1ee1cac498ae$var$Nnd(a.o);
    $61de1ee1cac498ae$var$wtd((!j.d && (j.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, j, 1)), j.d), k);
    l = (g = (h = new $61de1ee1cac498ae$var$UQd, h), g);
    $61de1ee1cac498ae$var$wtd((!k.d && (k.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, k, 1)), k.d), l);
    k = $61de1ee1cac498ae$var$Nnd(a.wb.M);
    $61de1ee1cac498ae$var$wtd((!j.d && (j.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, j, 1)), j.d), k);
    m = $61de1ee1cac498ae$var$xId(o, j, null);
    !!m && m.Fi();
    $61de1ee1cac498ae$var$Xnd(a.a, $61de1ee1cac498ae$var$x2, $61de1ee1cac498ae$var$Xse, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.a), 0), 18), a.k, null, $61de1ee1cac498ae$var$Dte, 0, -1, $61de1ee1cac498ae$var$x2, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$Xnd(a.f, $61de1ee1cac498ae$var$C2, $61de1ee1cac498ae$var$Zse, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.f), 0), 18), a.g, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.g), 0), 18), "labels", 0, -1, $61de1ee1cac498ae$var$C2, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.f), 1), 34), a.wb._, $61de1ee1cac498ae$var$Ete, null, 0, 1, $61de1ee1cac498ae$var$C2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Xnd(a.n, $61de1ee1cac498ae$var$G2, "ElkShape", true, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.n), 0), 34), a.wb.t, $61de1ee1cac498ae$var$Fte, $61de1ee1cac498ae$var$$je, 1, 1, $61de1ee1cac498ae$var$G2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.n), 1), 34), a.wb.t, $61de1ee1cac498ae$var$Gte, $61de1ee1cac498ae$var$$je, 1, 1, $61de1ee1cac498ae$var$G2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.n), 2), 34), a.wb.t, "x", $61de1ee1cac498ae$var$$je, 1, 1, $61de1ee1cac498ae$var$G2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.n), 3), 34), a.wb.t, "y", $61de1ee1cac498ae$var$$je, 1, 1, $61de1ee1cac498ae$var$G2, false, false, true, false, true, false);
    o = $61de1ee1cac498ae$var$Dnd(a.n, null, "setDimensions");
    $61de1ee1cac498ae$var$End(o, a.wb.t, $61de1ee1cac498ae$var$Gte);
    $61de1ee1cac498ae$var$End(o, a.wb.t, $61de1ee1cac498ae$var$Fte);
    o = $61de1ee1cac498ae$var$Dnd(a.n, null, "setLocation");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "x");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "y");
    $61de1ee1cac498ae$var$Xnd(a.g, $61de1ee1cac498ae$var$D2, $61de1ee1cac498ae$var$dte, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.g), 0), 18), a.f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.f), 0), 18), $61de1ee1cac498ae$var$Hte, 0, 1, $61de1ee1cac498ae$var$D2, false, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.g), 1), 34), a.wb._, $61de1ee1cac498ae$var$Ite, "", 0, 1, $61de1ee1cac498ae$var$D2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Xnd(a.c, $61de1ee1cac498ae$var$z2, $61de1ee1cac498ae$var$$se, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.c), 0), 18), a.d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 1), 18), "outgoingEdges", 0, -1, $61de1ee1cac498ae$var$z2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.c), 1), 18), a.d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 2), 18), "incomingEdges", 0, -1, $61de1ee1cac498ae$var$z2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$Xnd(a.i, $61de1ee1cac498ae$var$E2, $61de1ee1cac498ae$var$ete, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 0), 18), a.j, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.j), 0), 18), "ports", 0, -1, $61de1ee1cac498ae$var$E2, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 1), 18), a.i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 2), 18), $61de1ee1cac498ae$var$Jte, 0, -1, $61de1ee1cac498ae$var$E2, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 2), 18), a.i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 1), 18), $61de1ee1cac498ae$var$Hte, 0, 1, $61de1ee1cac498ae$var$E2, false, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 3), 18), a.d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 0), 18), "containedEdges", 0, -1, $61de1ee1cac498ae$var$E2, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 4), 34), a.wb.e, $61de1ee1cac498ae$var$Kte, null, 0, 1, $61de1ee1cac498ae$var$E2, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Xnd(a.j, $61de1ee1cac498ae$var$F2, $61de1ee1cac498ae$var$fte, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.j), 0), 18), a.i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 0), 18), $61de1ee1cac498ae$var$Hte, 0, 1, $61de1ee1cac498ae$var$F2, false, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$Xnd(a.d, $61de1ee1cac498ae$var$B2, $61de1ee1cac498ae$var$_se, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 0), 18), a.i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.i), 3), 18), "containingNode", 0, 1, $61de1ee1cac498ae$var$B2, false, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 1), 18), a.c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.c), 0), 18), $61de1ee1cac498ae$var$Lte, 0, -1, $61de1ee1cac498ae$var$B2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 2), 18), a.c, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.c), 1), 18), $61de1ee1cac498ae$var$Mte, 0, -1, $61de1ee1cac498ae$var$B2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 3), 18), a.e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 5), 18), $61de1ee1cac498ae$var$Nte, 0, -1, $61de1ee1cac498ae$var$B2, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 4), 34), a.wb.e, "hyperedge", null, 0, 1, $61de1ee1cac498ae$var$B2, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 5), 34), a.wb.e, $61de1ee1cac498ae$var$Kte, null, 0, 1, $61de1ee1cac498ae$var$B2, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 6), 34), a.wb.e, "selfloop", null, 0, 1, $61de1ee1cac498ae$var$B2, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 7), 34), a.wb.e, "connected", null, 0, 1, $61de1ee1cac498ae$var$B2, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Xnd(a.b, $61de1ee1cac498ae$var$y2, $61de1ee1cac498ae$var$Yse, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 0), 34), a.wb.t, "x", $61de1ee1cac498ae$var$$je, 1, 1, $61de1ee1cac498ae$var$y2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 1), 34), a.wb.t, "y", $61de1ee1cac498ae$var$$je, 1, 1, $61de1ee1cac498ae$var$y2, false, false, true, false, true, false);
    o = $61de1ee1cac498ae$var$Dnd(a.b, null, "set");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "x");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "y");
    $61de1ee1cac498ae$var$Xnd(a.e, $61de1ee1cac498ae$var$A2, $61de1ee1cac498ae$var$ate, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 0), 34), a.wb.t, "startX", null, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 1), 34), a.wb.t, "startY", null, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 2), 34), a.wb.t, "endX", null, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 3), 34), a.wb.t, "endY", null, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 4), 18), a.b, null, $61de1ee1cac498ae$var$Ote, 0, -1, $61de1ee1cac498ae$var$A2, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 5), 18), a.d, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.d), 3), 18), $61de1ee1cac498ae$var$Hte, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 6), 18), a.c, null, $61de1ee1cac498ae$var$Pte, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 7), 18), a.c, null, $61de1ee1cac498ae$var$Qte, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 8), 18), a.e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 9), 18), $61de1ee1cac498ae$var$Rte, 0, -1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 9), 18), a.e, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 8), 18), $61de1ee1cac498ae$var$Ste, 0, -1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.e), 10), 34), a.wb._, $61de1ee1cac498ae$var$Ete, null, 0, 1, $61de1ee1cac498ae$var$A2, false, false, true, false, true, false);
    o = $61de1ee1cac498ae$var$Dnd(a.e, null, "setStartLocation");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "x");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "y");
    o = $61de1ee1cac498ae$var$Dnd(a.e, null, "setEndLocation");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "x");
    $61de1ee1cac498ae$var$End(o, a.wb.t, "y");
    $61de1ee1cac498ae$var$Xnd(a.k, $61de1ee1cac498ae$var$CK, "ElkPropertyToValueMapEntry", false, false, false);
    j = $61de1ee1cac498ae$var$Nnd(a.o);
    k = (i = (b = new $61de1ee1cac498ae$var$UQd, b), i);
    $61de1ee1cac498ae$var$wtd((!j.d && (j.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, j, 1)), j.d), k);
    $61de1ee1cac498ae$var$Wnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.k), 0), 34), j, "key", $61de1ee1cac498ae$var$CK, false, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.k), 1), 34), a.s, $61de1ee1cac498ae$var$Bte, null, 0, 1, $61de1ee1cac498ae$var$CK, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Znd(a.o, $61de1ee1cac498ae$var$Q3, "IProperty", true);
    $61de1ee1cac498ae$var$Znd(a.s, $61de1ee1cac498ae$var$SI, "PropertyValue", true);
    $61de1ee1cac498ae$var$Rnd(a, $61de1ee1cac498ae$var$yte);
}
function $61de1ee1cac498ae$var$lde() {
    $61de1ee1cac498ae$var$lde = $61de1ee1cac498ae$var$ccb;
    $61de1ee1cac498ae$var$kde = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$wte, 25, $61de1ee1cac498ae$var$Tje, 15, 1);
    $61de1ee1cac498ae$var$kde[9] = 35;
    $61de1ee1cac498ae$var$kde[10] = 19;
    $61de1ee1cac498ae$var$kde[13] = 19;
    $61de1ee1cac498ae$var$kde[32] = 51;
    $61de1ee1cac498ae$var$kde[33] = 49;
    $61de1ee1cac498ae$var$kde[34] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 35, 38, 49);
    $61de1ee1cac498ae$var$kde[38] = 1;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 39, 45, 49);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 45, 47, -71);
    $61de1ee1cac498ae$var$kde[47] = 49;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 48, 58, -71);
    $61de1ee1cac498ae$var$kde[58] = 61;
    $61de1ee1cac498ae$var$kde[59] = 49;
    $61de1ee1cac498ae$var$kde[60] = 1;
    $61de1ee1cac498ae$var$kde[61] = 49;
    $61de1ee1cac498ae$var$kde[62] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 63, 65, 49);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 65, 91, -3);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 91, 93, 33);
    $61de1ee1cac498ae$var$kde[93] = 1;
    $61de1ee1cac498ae$var$kde[94] = 33;
    $61de1ee1cac498ae$var$kde[95] = -3;
    $61de1ee1cac498ae$var$kde[96] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 97, 123, -3);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 123, 183, 33);
    $61de1ee1cac498ae$var$kde[183] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 184, 192, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 192, 215, -19);
    $61de1ee1cac498ae$var$kde[215] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 216, 247, -19);
    $61de1ee1cac498ae$var$kde[247] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 248, 306, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 306, 308, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 308, 319, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 319, 321, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 321, 329, -19);
    $61de1ee1cac498ae$var$kde[329] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 330, 383, -19);
    $61de1ee1cac498ae$var$kde[383] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 384, 452, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 452, 461, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 461, 497, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 497, 500, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 500, 502, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 502, 506, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 506, 536, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 536, 592, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 592, 681, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 681, 699, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 699, 706, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 706, 720, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 720, 722, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 722, 768, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 768, 838, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 838, 864, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 864, 866, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 866, 902, 33);
    $61de1ee1cac498ae$var$kde[902] = -19;
    $61de1ee1cac498ae$var$kde[903] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 904, 907, -19);
    $61de1ee1cac498ae$var$kde[907] = 33;
    $61de1ee1cac498ae$var$kde[908] = -19;
    $61de1ee1cac498ae$var$kde[909] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 910, 930, -19);
    $61de1ee1cac498ae$var$kde[930] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 931, 975, -19);
    $61de1ee1cac498ae$var$kde[975] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 976, 983, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 983, 986, 33);
    $61de1ee1cac498ae$var$kde[986] = -19;
    $61de1ee1cac498ae$var$kde[987] = 33;
    $61de1ee1cac498ae$var$kde[988] = -19;
    $61de1ee1cac498ae$var$kde[989] = 33;
    $61de1ee1cac498ae$var$kde[990] = -19;
    $61de1ee1cac498ae$var$kde[991] = 33;
    $61de1ee1cac498ae$var$kde[992] = -19;
    $61de1ee1cac498ae$var$kde[993] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 994, 1012, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1012, 1025, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1025, 1037, -19);
    $61de1ee1cac498ae$var$kde[1037] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1038, 1104, -19);
    $61de1ee1cac498ae$var$kde[1104] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1105, 1117, -19);
    $61de1ee1cac498ae$var$kde[1117] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1118, 1154, -19);
    $61de1ee1cac498ae$var$kde[1154] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1155, 1159, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1159, 1168, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1168, 1221, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1221, 1223, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1223, 1225, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1225, 1227, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1227, 1229, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1229, 1232, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1232, 1260, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1260, 1262, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1262, 1270, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1270, 1272, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1272, 1274, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1274, 1329, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1329, 1367, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1367, 1369, 33);
    $61de1ee1cac498ae$var$kde[1369] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1370, 1377, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1377, 1415, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1415, 1425, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1425, 1442, -87);
    $61de1ee1cac498ae$var$kde[1442] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1443, 1466, -87);
    $61de1ee1cac498ae$var$kde[1466] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1467, 1470, -87);
    $61de1ee1cac498ae$var$kde[1470] = 33;
    $61de1ee1cac498ae$var$kde[1471] = -87;
    $61de1ee1cac498ae$var$kde[1472] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1473, 1475, -87);
    $61de1ee1cac498ae$var$kde[1475] = 33;
    $61de1ee1cac498ae$var$kde[1476] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1477, 1488, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1488, 1515, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1515, 1520, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1520, 1523, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1523, 1569, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1569, 1595, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1595, 1600, 33);
    $61de1ee1cac498ae$var$kde[1600] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1601, 1611, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1611, 1619, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1619, 1632, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1632, 1642, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1642, 1648, 33);
    $61de1ee1cac498ae$var$kde[1648] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1649, 1720, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1720, 1722, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1722, 1727, -19);
    $61de1ee1cac498ae$var$kde[1727] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1728, 1743, -19);
    $61de1ee1cac498ae$var$kde[1743] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1744, 1748, -19);
    $61de1ee1cac498ae$var$kde[1748] = 33;
    $61de1ee1cac498ae$var$kde[1749] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1750, 1765, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1765, 1767, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1767, 1769, -87);
    $61de1ee1cac498ae$var$kde[1769] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1770, 1774, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1774, 1776, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1776, 1786, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 1786, 2305, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2305, 2308, -87);
    $61de1ee1cac498ae$var$kde[2308] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2309, 2362, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2362, 2364, 33);
    $61de1ee1cac498ae$var$kde[2364] = -87;
    $61de1ee1cac498ae$var$kde[2365] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2366, 2382, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2382, 2385, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2385, 2389, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2389, 2392, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2392, 2402, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2402, 2404, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2404, 2406, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2406, 2416, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2416, 2433, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2433, 2436, -87);
    $61de1ee1cac498ae$var$kde[2436] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2437, 2445, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2445, 2447, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2447, 2449, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2449, 2451, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2451, 2473, -19);
    $61de1ee1cac498ae$var$kde[2473] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2474, 2481, -19);
    $61de1ee1cac498ae$var$kde[2481] = 33;
    $61de1ee1cac498ae$var$kde[2482] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2483, 2486, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2486, 2490, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2490, 2492, 33);
    $61de1ee1cac498ae$var$kde[2492] = -87;
    $61de1ee1cac498ae$var$kde[2493] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2494, 2501, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2501, 2503, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2503, 2505, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2505, 2507, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2507, 2510, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2510, 2519, 33);
    $61de1ee1cac498ae$var$kde[2519] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2520, 2524, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2524, 2526, -19);
    $61de1ee1cac498ae$var$kde[2526] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2527, 2530, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2530, 2532, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2532, 2534, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2534, 2544, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2544, 2546, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2546, 2562, 33);
    $61de1ee1cac498ae$var$kde[2562] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2563, 2565, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2565, 2571, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2571, 2575, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2575, 2577, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2577, 2579, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2579, 2601, -19);
    $61de1ee1cac498ae$var$kde[2601] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2602, 2609, -19);
    $61de1ee1cac498ae$var$kde[2609] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2610, 2612, -19);
    $61de1ee1cac498ae$var$kde[2612] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2613, 2615, -19);
    $61de1ee1cac498ae$var$kde[2615] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2616, 2618, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2618, 2620, 33);
    $61de1ee1cac498ae$var$kde[2620] = -87;
    $61de1ee1cac498ae$var$kde[2621] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2622, 2627, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2627, 2631, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2631, 2633, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2633, 2635, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2635, 2638, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2638, 2649, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2649, 2653, -19);
    $61de1ee1cac498ae$var$kde[2653] = 33;
    $61de1ee1cac498ae$var$kde[2654] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2655, 2662, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2662, 2674, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2674, 2677, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2677, 2689, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2689, 2692, -87);
    $61de1ee1cac498ae$var$kde[2692] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2693, 2700, -19);
    $61de1ee1cac498ae$var$kde[2700] = 33;
    $61de1ee1cac498ae$var$kde[2701] = -19;
    $61de1ee1cac498ae$var$kde[2702] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2703, 2706, -19);
    $61de1ee1cac498ae$var$kde[2706] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2707, 2729, -19);
    $61de1ee1cac498ae$var$kde[2729] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2730, 2737, -19);
    $61de1ee1cac498ae$var$kde[2737] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2738, 2740, -19);
    $61de1ee1cac498ae$var$kde[2740] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2741, 2746, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2746, 2748, 33);
    $61de1ee1cac498ae$var$kde[2748] = -87;
    $61de1ee1cac498ae$var$kde[2749] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2750, 2758, -87);
    $61de1ee1cac498ae$var$kde[2758] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2759, 2762, -87);
    $61de1ee1cac498ae$var$kde[2762] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2763, 2766, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2766, 2784, 33);
    $61de1ee1cac498ae$var$kde[2784] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2785, 2790, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2790, 2800, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2800, 2817, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2817, 2820, -87);
    $61de1ee1cac498ae$var$kde[2820] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2821, 2829, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2829, 2831, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2831, 2833, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2833, 2835, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2835, 2857, -19);
    $61de1ee1cac498ae$var$kde[2857] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2858, 2865, -19);
    $61de1ee1cac498ae$var$kde[2865] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2866, 2868, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2868, 2870, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2870, 2874, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2874, 2876, 33);
    $61de1ee1cac498ae$var$kde[2876] = -87;
    $61de1ee1cac498ae$var$kde[2877] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2878, 2884, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2884, 2887, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2887, 2889, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2889, 2891, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2891, 2894, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2894, 2902, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2902, 2904, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2904, 2908, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2908, 2910, -19);
    $61de1ee1cac498ae$var$kde[2910] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2911, 2914, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2914, 2918, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2918, 2928, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2928, 2946, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2946, 2948, -87);
    $61de1ee1cac498ae$var$kde[2948] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2949, 2955, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2955, 2958, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2958, 2961, -19);
    $61de1ee1cac498ae$var$kde[2961] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2962, 2966, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2966, 2969, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2969, 2971, -19);
    $61de1ee1cac498ae$var$kde[2971] = 33;
    $61de1ee1cac498ae$var$kde[2972] = -19;
    $61de1ee1cac498ae$var$kde[2973] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2974, 2976, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2976, 2979, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2979, 2981, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2981, 2984, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2984, 2987, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2987, 2990, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2990, 2998, -19);
    $61de1ee1cac498ae$var$kde[2998] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 2999, 3002, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3002, 3006, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3006, 3011, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3011, 3014, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3014, 3017, -87);
    $61de1ee1cac498ae$var$kde[3017] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3018, 3022, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3022, 3031, 33);
    $61de1ee1cac498ae$var$kde[3031] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3032, 3047, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3047, 3056, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3056, 3073, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3073, 3076, -87);
    $61de1ee1cac498ae$var$kde[3076] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3077, 3085, -19);
    $61de1ee1cac498ae$var$kde[3085] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3086, 3089, -19);
    $61de1ee1cac498ae$var$kde[3089] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3090, 3113, -19);
    $61de1ee1cac498ae$var$kde[3113] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3114, 3124, -19);
    $61de1ee1cac498ae$var$kde[3124] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3125, 3130, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3130, 3134, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3134, 3141, -87);
    $61de1ee1cac498ae$var$kde[3141] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3142, 3145, -87);
    $61de1ee1cac498ae$var$kde[3145] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3146, 3150, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3150, 3157, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3157, 3159, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3159, 3168, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3168, 3170, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3170, 3174, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3174, 3184, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3184, 3202, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3202, 3204, -87);
    $61de1ee1cac498ae$var$kde[3204] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3205, 3213, -19);
    $61de1ee1cac498ae$var$kde[3213] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3214, 3217, -19);
    $61de1ee1cac498ae$var$kde[3217] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3218, 3241, -19);
    $61de1ee1cac498ae$var$kde[3241] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3242, 3252, -19);
    $61de1ee1cac498ae$var$kde[3252] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3253, 3258, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3258, 3262, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3262, 3269, -87);
    $61de1ee1cac498ae$var$kde[3269] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3270, 3273, -87);
    $61de1ee1cac498ae$var$kde[3273] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3274, 3278, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3278, 3285, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3285, 3287, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3287, 3294, 33);
    $61de1ee1cac498ae$var$kde[3294] = -19;
    $61de1ee1cac498ae$var$kde[3295] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3296, 3298, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3298, 3302, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3302, 3312, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3312, 3330, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3330, 3332, -87);
    $61de1ee1cac498ae$var$kde[3332] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3333, 3341, -19);
    $61de1ee1cac498ae$var$kde[3341] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3342, 3345, -19);
    $61de1ee1cac498ae$var$kde[3345] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3346, 3369, -19);
    $61de1ee1cac498ae$var$kde[3369] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3370, 3386, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3386, 3390, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3390, 3396, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3396, 3398, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3398, 3401, -87);
    $61de1ee1cac498ae$var$kde[3401] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3402, 3406, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3406, 3415, 33);
    $61de1ee1cac498ae$var$kde[3415] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3416, 3424, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3424, 3426, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3426, 3430, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3430, 3440, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3440, 3585, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3585, 3631, -19);
    $61de1ee1cac498ae$var$kde[3631] = 33;
    $61de1ee1cac498ae$var$kde[3632] = -19;
    $61de1ee1cac498ae$var$kde[3633] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3634, 3636, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3636, 3643, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3643, 3648, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3648, 3654, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3654, 3663, -87);
    $61de1ee1cac498ae$var$kde[3663] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3664, 3674, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3674, 3713, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3713, 3715, -19);
    $61de1ee1cac498ae$var$kde[3715] = 33;
    $61de1ee1cac498ae$var$kde[3716] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3717, 3719, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3719, 3721, -19);
    $61de1ee1cac498ae$var$kde[3721] = 33;
    $61de1ee1cac498ae$var$kde[3722] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3723, 3725, 33);
    $61de1ee1cac498ae$var$kde[3725] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3726, 3732, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3732, 3736, -19);
    $61de1ee1cac498ae$var$kde[3736] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3737, 3744, -19);
    $61de1ee1cac498ae$var$kde[3744] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3745, 3748, -19);
    $61de1ee1cac498ae$var$kde[3748] = 33;
    $61de1ee1cac498ae$var$kde[3749] = -19;
    $61de1ee1cac498ae$var$kde[3750] = 33;
    $61de1ee1cac498ae$var$kde[3751] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3752, 3754, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3754, 3756, -19);
    $61de1ee1cac498ae$var$kde[3756] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3757, 3759, -19);
    $61de1ee1cac498ae$var$kde[3759] = 33;
    $61de1ee1cac498ae$var$kde[3760] = -19;
    $61de1ee1cac498ae$var$kde[3761] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3762, 3764, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3764, 3770, -87);
    $61de1ee1cac498ae$var$kde[3770] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3771, 3773, -87);
    $61de1ee1cac498ae$var$kde[3773] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3774, 3776, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3776, 3781, -19);
    $61de1ee1cac498ae$var$kde[3781] = 33;
    $61de1ee1cac498ae$var$kde[3782] = -87;
    $61de1ee1cac498ae$var$kde[3783] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3784, 3790, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3790, 3792, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3792, 3802, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3802, 3864, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3864, 3866, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3866, 3872, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3872, 3882, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3882, 3893, 33);
    $61de1ee1cac498ae$var$kde[3893] = -87;
    $61de1ee1cac498ae$var$kde[3894] = 33;
    $61de1ee1cac498ae$var$kde[3895] = -87;
    $61de1ee1cac498ae$var$kde[3896] = 33;
    $61de1ee1cac498ae$var$kde[3897] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3898, 3902, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3902, 3904, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3904, 3912, -19);
    $61de1ee1cac498ae$var$kde[3912] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3913, 3946, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3946, 3953, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3953, 3973, -87);
    $61de1ee1cac498ae$var$kde[3973] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3974, 3980, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3980, 3984, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3984, 3990, -87);
    $61de1ee1cac498ae$var$kde[3990] = 33;
    $61de1ee1cac498ae$var$kde[3991] = -87;
    $61de1ee1cac498ae$var$kde[3992] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 3993, 4014, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4014, 4017, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4017, 4024, -87);
    $61de1ee1cac498ae$var$kde[4024] = 33;
    $61de1ee1cac498ae$var$kde[4025] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4026, 4256, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4256, 4294, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4294, 4304, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4304, 4343, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4343, 4352, 33);
    $61de1ee1cac498ae$var$kde[4352] = -19;
    $61de1ee1cac498ae$var$kde[4353] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4354, 4356, -19);
    $61de1ee1cac498ae$var$kde[4356] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4357, 4360, -19);
    $61de1ee1cac498ae$var$kde[4360] = 33;
    $61de1ee1cac498ae$var$kde[4361] = -19;
    $61de1ee1cac498ae$var$kde[4362] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4363, 4365, -19);
    $61de1ee1cac498ae$var$kde[4365] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4366, 4371, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4371, 4412, 33);
    $61de1ee1cac498ae$var$kde[4412] = -19;
    $61de1ee1cac498ae$var$kde[4413] = 33;
    $61de1ee1cac498ae$var$kde[4414] = -19;
    $61de1ee1cac498ae$var$kde[4415] = 33;
    $61de1ee1cac498ae$var$kde[4416] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4417, 4428, 33);
    $61de1ee1cac498ae$var$kde[4428] = -19;
    $61de1ee1cac498ae$var$kde[4429] = 33;
    $61de1ee1cac498ae$var$kde[4430] = -19;
    $61de1ee1cac498ae$var$kde[4431] = 33;
    $61de1ee1cac498ae$var$kde[4432] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4433, 4436, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4436, 4438, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4438, 4441, 33);
    $61de1ee1cac498ae$var$kde[4441] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4442, 4447, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4447, 4450, -19);
    $61de1ee1cac498ae$var$kde[4450] = 33;
    $61de1ee1cac498ae$var$kde[4451] = -19;
    $61de1ee1cac498ae$var$kde[4452] = 33;
    $61de1ee1cac498ae$var$kde[4453] = -19;
    $61de1ee1cac498ae$var$kde[4454] = 33;
    $61de1ee1cac498ae$var$kde[4455] = -19;
    $61de1ee1cac498ae$var$kde[4456] = 33;
    $61de1ee1cac498ae$var$kde[4457] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4458, 4461, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4461, 4463, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4463, 4466, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4466, 4468, -19);
    $61de1ee1cac498ae$var$kde[4468] = 33;
    $61de1ee1cac498ae$var$kde[4469] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4470, 4510, 33);
    $61de1ee1cac498ae$var$kde[4510] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4511, 4520, 33);
    $61de1ee1cac498ae$var$kde[4520] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4521, 4523, 33);
    $61de1ee1cac498ae$var$kde[4523] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4524, 4526, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4526, 4528, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4528, 4535, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4535, 4537, -19);
    $61de1ee1cac498ae$var$kde[4537] = 33;
    $61de1ee1cac498ae$var$kde[4538] = -19;
    $61de1ee1cac498ae$var$kde[4539] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4540, 4547, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4547, 4587, 33);
    $61de1ee1cac498ae$var$kde[4587] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4588, 4592, 33);
    $61de1ee1cac498ae$var$kde[4592] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4593, 4601, 33);
    $61de1ee1cac498ae$var$kde[4601] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 4602, 7680, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7680, 7836, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7836, 7840, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7840, 7930, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7930, 7936, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7936, 7958, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7958, 7960, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7960, 7966, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7966, 7968, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 7968, 8006, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8006, 8008, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8008, 8014, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8014, 8016, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8016, 8024, -19);
    $61de1ee1cac498ae$var$kde[8024] = 33;
    $61de1ee1cac498ae$var$kde[8025] = -19;
    $61de1ee1cac498ae$var$kde[8026] = 33;
    $61de1ee1cac498ae$var$kde[8027] = -19;
    $61de1ee1cac498ae$var$kde[8028] = 33;
    $61de1ee1cac498ae$var$kde[8029] = -19;
    $61de1ee1cac498ae$var$kde[8030] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8031, 8062, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8062, 8064, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8064, 8117, -19);
    $61de1ee1cac498ae$var$kde[8117] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8118, 8125, -19);
    $61de1ee1cac498ae$var$kde[8125] = 33;
    $61de1ee1cac498ae$var$kde[8126] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8127, 8130, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8130, 8133, -19);
    $61de1ee1cac498ae$var$kde[8133] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8134, 8141, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8141, 8144, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8144, 8148, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8148, 8150, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8150, 8156, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8156, 8160, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8160, 8173, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8173, 8178, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8178, 8181, -19);
    $61de1ee1cac498ae$var$kde[8181] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8182, 8189, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8189, 8400, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8400, 8413, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8413, 8417, 33);
    $61de1ee1cac498ae$var$kde[8417] = -87;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8418, 8486, 33);
    $61de1ee1cac498ae$var$kde[8486] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8487, 8490, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8490, 8492, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8492, 8494, 33);
    $61de1ee1cac498ae$var$kde[8494] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8495, 8576, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8576, 8579, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 8579, 12293, 33);
    $61de1ee1cac498ae$var$kde[12293] = -87;
    $61de1ee1cac498ae$var$kde[12294] = 33;
    $61de1ee1cac498ae$var$kde[12295] = -19;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12296, 12321, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12321, 12330, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12330, 12336, -87);
    $61de1ee1cac498ae$var$kde[12336] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12337, 12342, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12342, 12353, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12353, 12437, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12437, 12441, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12441, 12443, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12443, 12445, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12445, 12447, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12447, 12449, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12449, 12539, -19);
    $61de1ee1cac498ae$var$kde[12539] = 33;
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12540, 12543, -87);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12543, 12549, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12549, 12589, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 12589, 19968, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 19968, 40870, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 40870, 44032, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 44032, 55204, -19);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 55204, $61de1ee1cac498ae$var$Uje, 33);
    $61de1ee1cac498ae$var$ylb($61de1ee1cac498ae$var$kde, 57344, 65534, 33);
}
function $61de1ee1cac498ae$var$zZd(a) {
    var b, c, d, e, f, g, h;
    if (a.hb) return;
    a.hb = true;
    $61de1ee1cac498ae$var$pnd(a, "ecore");
    $61de1ee1cac498ae$var$cod(a, "ecore");
    $61de1ee1cac498ae$var$dod(a, $61de1ee1cac498ae$var$_ve);
    $61de1ee1cac498ae$var$Gnd(a.fb, "E");
    $61de1ee1cac498ae$var$Gnd(a.L, "T");
    $61de1ee1cac498ae$var$Gnd(a.P, "K");
    $61de1ee1cac498ae$var$Gnd(a.P, "V");
    $61de1ee1cac498ae$var$Gnd(a.cb, "E");
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.b), a.bb);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.a), a.Q);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.o), a.p);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.p), a.R);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.q), a.p);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.v), a.q);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.w), a.R);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.B), a.Q);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.R), a.Q);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.T), a.eb);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.U), a.R);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.V), a.eb);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.W), a.bb);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.bb), a.eb);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.eb), a.R);
    $61de1ee1cac498ae$var$wtd($61de1ee1cac498ae$var$_Kd(a.db), a.R);
    $61de1ee1cac498ae$var$Xnd(a.b, $61de1ee1cac498ae$var$b5, $61de1ee1cac498ae$var$qve, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 0), 34), a.e, "iD", null, 0, 1, $61de1ee1cac498ae$var$b5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.b), 1), 18), a.q, null, "eAttributeType", 1, 1, $61de1ee1cac498ae$var$b5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$Xnd(a.a, $61de1ee1cac498ae$var$a5, $61de1ee1cac498ae$var$nve, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.a), 0), 34), a._, $61de1ee1cac498ae$var$Cte, null, 0, 1, $61de1ee1cac498ae$var$a5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.a), 1), 18), a.ab, null, "details", 0, -1, $61de1ee1cac498ae$var$a5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.a), 2), 18), a.Q, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.Q), 0), 18), "eModelElement", 0, 1, $61de1ee1cac498ae$var$a5, true, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.a), 3), 18), a.S, null, "contents", 0, -1, $61de1ee1cac498ae$var$a5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.a), 4), 18), a.S, null, "references", 0, -1, $61de1ee1cac498ae$var$a5, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$Xnd(a.o, $61de1ee1cac498ae$var$c5, "EClass", false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 0), 34), a.e, "abstract", null, 0, 1, $61de1ee1cac498ae$var$c5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 1), 34), a.e, "interface", null, 0, 1, $61de1ee1cac498ae$var$c5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 2), 18), a.o, null, "eSuperTypes", 0, -1, $61de1ee1cac498ae$var$c5, false, false, true, false, true, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 3), 18), a.T, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.T), 0), 18), "eOperations", 0, -1, $61de1ee1cac498ae$var$c5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 4), 18), a.b, null, "eAllAttributes", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 5), 18), a.W, null, "eAllReferences", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 6), 18), a.W, null, "eReferences", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 7), 18), a.b, null, "eAttributes", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 8), 18), a.W, null, "eAllContainments", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 9), 18), a.T, null, "eAllOperations", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 10), 18), a.bb, null, "eAllStructuralFeatures", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 11), 18), a.o, null, "eAllSuperTypes", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 12), 18), a.b, null, "eIDAttribute", 0, 1, $61de1ee1cac498ae$var$c5, true, true, false, false, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 13), 18), a.bb, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 7), 18), "eStructuralFeatures", 0, -1, $61de1ee1cac498ae$var$c5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 14), 18), a.H, null, "eGenericSuperTypes", 0, -1, $61de1ee1cac498ae$var$c5, false, false, true, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 15), 18), a.H, null, "eAllGenericSuperTypes", 0, -1, $61de1ee1cac498ae$var$c5, true, true, false, false, true, false, true);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 0), 59), a.e, "isSuperTypeOf");
    $61de1ee1cac498ae$var$End(h, a.o, "someClass");
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 1), 59), a.I, "getFeatureCount");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 2), 59), a.bb, $61de1ee1cac498ae$var$dwe);
    $61de1ee1cac498ae$var$End(h, a.I, "featureID");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 3), 59), a.I, $61de1ee1cac498ae$var$ewe);
    $61de1ee1cac498ae$var$End(h, a.bb, $61de1ee1cac498ae$var$fwe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 4), 59), a.bb, $61de1ee1cac498ae$var$dwe);
    $61de1ee1cac498ae$var$End(h, a._, "featureName");
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 5), 59), a.I, "getOperationCount");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 6), 59), a.T, "getEOperation");
    $61de1ee1cac498ae$var$End(h, a.I, "operationID");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 7), 59), a.I, $61de1ee1cac498ae$var$gwe);
    $61de1ee1cac498ae$var$End(h, a.T, $61de1ee1cac498ae$var$hwe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 8), 59), a.T, "getOverride");
    $61de1ee1cac498ae$var$End(h, a.T, $61de1ee1cac498ae$var$hwe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.o), 9), 59), a.H, "getFeatureType");
    $61de1ee1cac498ae$var$End(h, a.bb, $61de1ee1cac498ae$var$fwe);
    $61de1ee1cac498ae$var$Xnd(a.p, $61de1ee1cac498ae$var$d5, $61de1ee1cac498ae$var$rve, true, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.p), 0), 34), a._, "instanceClassName", null, 0, 1, $61de1ee1cac498ae$var$d5, false, true, true, true, true, false);
    b = $61de1ee1cac498ae$var$Nnd(a.L);
    c = $61de1ee1cac498ae$var$vZd();
    $61de1ee1cac498ae$var$wtd((!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d), c);
    $61de1ee1cac498ae$var$Wnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.p), 1), 34), b, "instanceClass", $61de1ee1cac498ae$var$d5, true, true, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.p), 2), 34), a.M, $61de1ee1cac498ae$var$iwe, null, 0, 1, $61de1ee1cac498ae$var$d5, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.p), 3), 34), a._, "instanceTypeName", null, 0, 1, $61de1ee1cac498ae$var$d5, false, true, true, true, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.p), 4), 18), a.U, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 3), 18), "ePackage", 0, 1, $61de1ee1cac498ae$var$d5, true, false, false, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.p), 5), 18), a.db, null, $61de1ee1cac498ae$var$jwe, 0, -1, $61de1ee1cac498ae$var$d5, false, false, true, true, true, false, false);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.p), 0), 59), a.e, $61de1ee1cac498ae$var$kwe);
    $61de1ee1cac498ae$var$End(h, a.M, $61de1ee1cac498ae$var$Jhe);
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.p), 1), 59), a.I, "getClassifierID");
    $61de1ee1cac498ae$var$Xnd(a.q, $61de1ee1cac498ae$var$f5, "EDataType", false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.q), 0), 34), a.e, "serializable", $61de1ee1cac498ae$var$kse, 0, 1, $61de1ee1cac498ae$var$f5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Xnd(a.v, $61de1ee1cac498ae$var$h5, "EEnum", false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.v), 0), 18), a.w, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.w), 3), 18), "eLiterals", 0, -1, $61de1ee1cac498ae$var$h5, false, false, true, true, false, false, false);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.v), 0), 59), a.w, $61de1ee1cac498ae$var$lwe);
    $61de1ee1cac498ae$var$End(h, a._, $61de1ee1cac498ae$var$fue);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.v), 1), 59), a.w, $61de1ee1cac498ae$var$lwe);
    $61de1ee1cac498ae$var$End(h, a.I, $61de1ee1cac498ae$var$Bte);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.v), 2), 59), a.w, "getEEnumLiteralByLiteral");
    $61de1ee1cac498ae$var$End(h, a._, "literal");
    $61de1ee1cac498ae$var$Xnd(a.w, $61de1ee1cac498ae$var$g5, $61de1ee1cac498ae$var$sve, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.w), 0), 34), a.I, $61de1ee1cac498ae$var$Bte, null, 0, 1, $61de1ee1cac498ae$var$g5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.w), 1), 34), a.A, "instance", null, 0, 1, $61de1ee1cac498ae$var$g5, true, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.w), 2), 34), a._, "literal", null, 0, 1, $61de1ee1cac498ae$var$g5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.w), 3), 18), a.v, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.v), 0), 18), "eEnum", 0, 1, $61de1ee1cac498ae$var$g5, true, false, false, false, false, false, false);
    $61de1ee1cac498ae$var$Xnd(a.B, $61de1ee1cac498ae$var$i5, "EFactory", false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.B), 0), 18), a.U, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 2), 18), "ePackage", 1, 1, $61de1ee1cac498ae$var$i5, true, false, true, false, false, false, false);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.B), 0), 59), a.S, "create");
    $61de1ee1cac498ae$var$End(h, a.o, "eClass");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.B), 1), 59), a.M, "createFromString");
    $61de1ee1cac498ae$var$End(h, a.q, "eDataType");
    $61de1ee1cac498ae$var$End(h, a._, "literalValue");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.B), 2), 59), a._, "convertToString");
    $61de1ee1cac498ae$var$End(h, a.q, "eDataType");
    $61de1ee1cac498ae$var$End(h, a.M, "instanceValue");
    $61de1ee1cac498ae$var$Xnd(a.Q, $61de1ee1cac498ae$var$k5, $61de1ee1cac498ae$var$bte, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.Q), 0), 18), a.a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.a), 2), 18), "eAnnotations", 0, -1, $61de1ee1cac498ae$var$k5, false, false, true, true, false, false, false);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.Q), 0), 59), a.a, "getEAnnotation");
    $61de1ee1cac498ae$var$End(h, a._, $61de1ee1cac498ae$var$Cte);
    $61de1ee1cac498ae$var$Xnd(a.R, $61de1ee1cac498ae$var$l5, $61de1ee1cac498ae$var$cte, true, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.R), 0), 34), a._, $61de1ee1cac498ae$var$fue, null, 0, 1, $61de1ee1cac498ae$var$l5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Xnd(a.S, $61de1ee1cac498ae$var$m5, "EObject", false, false, true);
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 0), 59), a.o, "eClass");
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 1), 59), a.e, "eIsProxy");
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 2), 59), a.X, "eResource");
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 3), 59), a.S, "eContainer");
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 4), 59), a.bb, "eContainingFeature");
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 5), 59), a.W, "eContainmentFeature");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 6), 59), null, "eContents");
    b = $61de1ee1cac498ae$var$Nnd(a.fb);
    c = $61de1ee1cac498ae$var$Nnd(a.S);
    $61de1ee1cac498ae$var$wtd((!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d), c);
    e = $61de1ee1cac498ae$var$xId(h, b, null);
    !!e && e.Fi();
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 7), 59), null, "eAllContents");
    b = $61de1ee1cac498ae$var$Nnd(a.cb);
    c = $61de1ee1cac498ae$var$Nnd(a.S);
    $61de1ee1cac498ae$var$wtd((!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d), c);
    f = $61de1ee1cac498ae$var$xId(h, b, null);
    !!f && f.Fi();
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 8), 59), null, "eCrossReferences");
    b = $61de1ee1cac498ae$var$Nnd(a.fb);
    c = $61de1ee1cac498ae$var$Nnd(a.S);
    $61de1ee1cac498ae$var$wtd((!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d), c);
    g = $61de1ee1cac498ae$var$xId(h, b, null);
    !!g && g.Fi();
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 9), 59), a.M, "eGet");
    $61de1ee1cac498ae$var$End(h, a.bb, $61de1ee1cac498ae$var$fwe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 10), 59), a.M, "eGet");
    $61de1ee1cac498ae$var$End(h, a.bb, $61de1ee1cac498ae$var$fwe);
    $61de1ee1cac498ae$var$End(h, a.e, "resolve");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 11), 59), null, "eSet");
    $61de1ee1cac498ae$var$End(h, a.bb, $61de1ee1cac498ae$var$fwe);
    $61de1ee1cac498ae$var$End(h, a.M, "newValue");
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 12), 59), a.e, "eIsSet");
    $61de1ee1cac498ae$var$End(h, a.bb, $61de1ee1cac498ae$var$fwe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 13), 59), null, "eUnset");
    $61de1ee1cac498ae$var$End(h, a.bb, $61de1ee1cac498ae$var$fwe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.S), 14), 59), a.M, "eInvoke");
    $61de1ee1cac498ae$var$End(h, a.T, $61de1ee1cac498ae$var$hwe);
    b = $61de1ee1cac498ae$var$Nnd(a.fb);
    c = $61de1ee1cac498ae$var$vZd();
    $61de1ee1cac498ae$var$wtd((!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d), c);
    $61de1ee1cac498ae$var$Fnd(h, b, "arguments");
    $61de1ee1cac498ae$var$Cnd(h, a.K);
    $61de1ee1cac498ae$var$Xnd(a.T, $61de1ee1cac498ae$var$n5, $61de1ee1cac498ae$var$uve, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.T), 0), 18), a.o, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 3), 18), $61de1ee1cac498ae$var$mwe, 0, 1, $61de1ee1cac498ae$var$n5, true, false, false, false, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.T), 1), 18), a.db, null, $61de1ee1cac498ae$var$jwe, 0, -1, $61de1ee1cac498ae$var$n5, false, false, true, true, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.T), 2), 18), a.V, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.V), 0), 18), "eParameters", 0, -1, $61de1ee1cac498ae$var$n5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.T), 3), 18), a.p, null, "eExceptions", 0, -1, $61de1ee1cac498ae$var$n5, false, false, true, false, true, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.T), 4), 18), a.H, null, "eGenericExceptions", 0, -1, $61de1ee1cac498ae$var$n5, false, false, true, true, false, true, false);
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.T), 0), 59), a.I, $61de1ee1cac498ae$var$gwe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.T), 1), 59), a.e, "isOverrideOf");
    $61de1ee1cac498ae$var$End(h, a.T, "someOperation");
    $61de1ee1cac498ae$var$Xnd(a.U, $61de1ee1cac498ae$var$o5, "EPackage", false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 0), 34), a._, "nsURI", null, 0, 1, $61de1ee1cac498ae$var$o5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 1), 34), a._, "nsPrefix", null, 0, 1, $61de1ee1cac498ae$var$o5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 2), 18), a.B, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.B), 0), 18), "eFactoryInstance", 1, 1, $61de1ee1cac498ae$var$o5, true, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 3), 18), a.p, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.p), 4), 18), "eClassifiers", 0, -1, $61de1ee1cac498ae$var$o5, false, false, true, true, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 4), 18), a.U, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 5), 18), "eSubpackages", 0, -1, $61de1ee1cac498ae$var$o5, false, false, true, true, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 5), 18), a.U, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.U), 4), 18), "eSuperPackage", 0, 1, $61de1ee1cac498ae$var$o5, true, false, false, false, true, false, false);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.U), 0), 59), a.p, "getEClassifier");
    $61de1ee1cac498ae$var$End(h, a._, $61de1ee1cac498ae$var$fue);
    $61de1ee1cac498ae$var$Xnd(a.V, $61de1ee1cac498ae$var$p5, $61de1ee1cac498ae$var$vve, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.V), 0), 18), a.T, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.T), 2), 18), "eOperation", 0, 1, $61de1ee1cac498ae$var$p5, true, false, false, false, false, false, false);
    $61de1ee1cac498ae$var$Xnd(a.W, $61de1ee1cac498ae$var$q5, $61de1ee1cac498ae$var$wve, false, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.W), 0), 34), a.e, "containment", null, 0, 1, $61de1ee1cac498ae$var$q5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.W), 1), 34), a.e, "container", null, 0, 1, $61de1ee1cac498ae$var$q5, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.W), 2), 34), a.e, "resolveProxies", $61de1ee1cac498ae$var$kse, 0, 1, $61de1ee1cac498ae$var$q5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.W), 3), 18), a.W, null, "eOpposite", 0, 1, $61de1ee1cac498ae$var$q5, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.W), 4), 18), a.o, null, "eReferenceType", 1, 1, $61de1ee1cac498ae$var$q5, true, true, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.W), 5), 18), a.b, null, "eKeys", 0, -1, $61de1ee1cac498ae$var$q5, false, false, true, false, true, false, false);
    $61de1ee1cac498ae$var$Xnd(a.bb, $61de1ee1cac498ae$var$t5, $61de1ee1cac498ae$var$pve, true, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 0), 34), a.e, "changeable", $61de1ee1cac498ae$var$kse, 0, 1, $61de1ee1cac498ae$var$t5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 1), 34), a.e, "volatile", null, 0, 1, $61de1ee1cac498ae$var$t5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 2), 34), a.e, "transient", null, 0, 1, $61de1ee1cac498ae$var$t5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 3), 34), a._, "defaultValueLiteral", null, 0, 1, $61de1ee1cac498ae$var$t5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 4), 34), a.M, $61de1ee1cac498ae$var$iwe, null, 0, 1, $61de1ee1cac498ae$var$t5, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 5), 34), a.e, "unsettable", null, 0, 1, $61de1ee1cac498ae$var$t5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 6), 34), a.e, "derived", null, 0, 1, $61de1ee1cac498ae$var$t5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.bb), 7), 18), a.o, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.o), 13), 18), $61de1ee1cac498ae$var$mwe, 0, 1, $61de1ee1cac498ae$var$t5, true, false, false, false, false, false, false);
    $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.bb), 0), 59), a.I, $61de1ee1cac498ae$var$ewe);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.bb), 1), 59), null, "getContainerClass");
    b = $61de1ee1cac498ae$var$Nnd(a.L);
    c = $61de1ee1cac498ae$var$vZd();
    $61de1ee1cac498ae$var$wtd((!b.d && (b.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, b, 1)), b.d), c);
    d = $61de1ee1cac498ae$var$xId(h, b, null);
    !!d && d.Fi();
    $61de1ee1cac498ae$var$Xnd(a.eb, $61de1ee1cac498ae$var$v5, $61de1ee1cac498ae$var$ove, true, false, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 0), 34), a.e, "ordered", $61de1ee1cac498ae$var$kse, 0, 1, $61de1ee1cac498ae$var$v5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 1), 34), a.e, "unique", $61de1ee1cac498ae$var$kse, 0, 1, $61de1ee1cac498ae$var$v5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 2), 34), a.I, "lowerBound", null, 0, 1, $61de1ee1cac498ae$var$v5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 3), 34), a.I, "upperBound", "1", 0, 1, $61de1ee1cac498ae$var$v5, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 4), 34), a.e, "many", null, 0, 1, $61de1ee1cac498ae$var$v5, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 5), 34), a.e, "required", null, 0, 1, $61de1ee1cac498ae$var$v5, true, true, false, false, true, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 6), 18), a.p, null, "eType", 0, 1, $61de1ee1cac498ae$var$v5, false, true, true, false, true, true, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.eb), 7), 18), a.H, null, "eGenericType", 0, 1, $61de1ee1cac498ae$var$v5, false, true, true, true, false, true, false);
    $61de1ee1cac498ae$var$Xnd(a.ab, $61de1ee1cac498ae$var$CK, "EStringToStringMapEntry", false, false, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.ab), 0), 34), a._, "key", null, 0, 1, $61de1ee1cac498ae$var$CK, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Vnd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.ab), 1), 34), a._, $61de1ee1cac498ae$var$Bte, null, 0, 1, $61de1ee1cac498ae$var$CK, false, false, true, false, true, false);
    $61de1ee1cac498ae$var$Xnd(a.H, $61de1ee1cac498ae$var$j5, $61de1ee1cac498ae$var$tve, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.H), 0), 18), a.H, null, "eUpperBound", 0, 1, $61de1ee1cac498ae$var$j5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.H), 1), 18), a.H, null, "eTypeArguments", 0, -1, $61de1ee1cac498ae$var$j5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.H), 2), 18), a.p, null, "eRawType", 1, 1, $61de1ee1cac498ae$var$j5, true, false, false, false, true, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.H), 3), 18), a.H, null, "eLowerBound", 0, 1, $61de1ee1cac498ae$var$j5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.H), 4), 18), a.db, null, "eTypeParameter", 0, 1, $61de1ee1cac498ae$var$j5, false, false, true, false, false, false, false);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.H), 5), 18), a.p, null, "eClassifier", 0, 1, $61de1ee1cac498ae$var$j5, false, false, true, false, true, false, false);
    h = $61de1ee1cac498ae$var$$nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$WKd(a.H), 0), 59), a.e, $61de1ee1cac498ae$var$kwe);
    $61de1ee1cac498ae$var$End(h, a.M, $61de1ee1cac498ae$var$Jhe);
    $61de1ee1cac498ae$var$Xnd(a.db, $61de1ee1cac498ae$var$u5, $61de1ee1cac498ae$var$xve, false, false, true);
    $61de1ee1cac498ae$var$_nd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$ZKd(a.db), 0), 18), a.H, null, "eBounds", 0, -1, $61de1ee1cac498ae$var$u5, false, false, true, true, false, false, false);
    $61de1ee1cac498ae$var$Znd(a.c, $61de1ee1cac498ae$var$bJ, "EBigDecimal", true);
    $61de1ee1cac498ae$var$Znd(a.d, $61de1ee1cac498ae$var$cJ, "EBigInteger", true);
    $61de1ee1cac498ae$var$Znd(a.e, $61de1ee1cac498ae$var$sbb, "EBoolean", true);
    $61de1ee1cac498ae$var$Znd(a.f, $61de1ee1cac498ae$var$wI, "EBooleanObject", true);
    $61de1ee1cac498ae$var$Znd(a.i, $61de1ee1cac498ae$var$SD, "EByte", true);
    $61de1ee1cac498ae$var$Znd(a.g, $61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SD, 1), "EByteArray", true);
    $61de1ee1cac498ae$var$Znd(a.j, $61de1ee1cac498ae$var$xI, "EByteObject", true);
    $61de1ee1cac498ae$var$Znd(a.k, $61de1ee1cac498ae$var$TD, "EChar", true);
    $61de1ee1cac498ae$var$Znd(a.n, $61de1ee1cac498ae$var$yI, "ECharacterObject", true);
    $61de1ee1cac498ae$var$Znd(a.r, $61de1ee1cac498ae$var$$J, "EDate", true);
    $61de1ee1cac498ae$var$Znd(a.s, $61de1ee1cac498ae$var$O4, "EDiagnosticChain", false);
    $61de1ee1cac498ae$var$Znd(a.t, $61de1ee1cac498ae$var$UD, "EDouble", true);
    $61de1ee1cac498ae$var$Znd(a.u, $61de1ee1cac498ae$var$BI, "EDoubleObject", true);
    $61de1ee1cac498ae$var$Znd(a.fb, $61de1ee1cac498ae$var$T4, "EEList", false);
    $61de1ee1cac498ae$var$Znd(a.A, $61de1ee1cac498ae$var$U4, "EEnumerator", false);
    $61de1ee1cac498ae$var$Znd(a.C, $61de1ee1cac498ae$var$O9, "EFeatureMap", false);
    $61de1ee1cac498ae$var$Znd(a.D, $61de1ee1cac498ae$var$E9, "EFeatureMapEntry", false);
    $61de1ee1cac498ae$var$Znd(a.F, $61de1ee1cac498ae$var$VD, "EFloat", true);
    $61de1ee1cac498ae$var$Znd(a.G, $61de1ee1cac498ae$var$FI, "EFloatObject", true);
    $61de1ee1cac498ae$var$Znd(a.I, $61de1ee1cac498ae$var$WD, "EInt", true);
    $61de1ee1cac498ae$var$Znd(a.J, $61de1ee1cac498ae$var$JI, "EIntegerObject", true);
    $61de1ee1cac498ae$var$Znd(a.L, $61de1ee1cac498ae$var$AI, "EJavaClass", true);
    $61de1ee1cac498ae$var$Znd(a.M, $61de1ee1cac498ae$var$SI, "EJavaObject", true);
    $61de1ee1cac498ae$var$Znd(a.N, $61de1ee1cac498ae$var$XD, "ELong", true);
    $61de1ee1cac498ae$var$Znd(a.O, $61de1ee1cac498ae$var$MI, "ELongObject", true);
    $61de1ee1cac498ae$var$Znd(a.P, $61de1ee1cac498ae$var$DK, "EMap", false);
    $61de1ee1cac498ae$var$Znd(a.X, $61de1ee1cac498ae$var$v8, "EResource", false);
    $61de1ee1cac498ae$var$Znd(a.Y, $61de1ee1cac498ae$var$u8, "EResourceSet", false);
    $61de1ee1cac498ae$var$Znd(a.Z, $61de1ee1cac498ae$var$rbb, "EShort", true);
    $61de1ee1cac498ae$var$Znd(a.$, $61de1ee1cac498ae$var$UI, "EShortObject", true);
    $61de1ee1cac498ae$var$Znd(a._, $61de1ee1cac498ae$var$ZI, "EString", true);
    $61de1ee1cac498ae$var$Znd(a.cb, $61de1ee1cac498ae$var$X4, "ETreeIterator", false);
    $61de1ee1cac498ae$var$Znd(a.K, $61de1ee1cac498ae$var$V4, "EInvocationTargetException", false);
    $61de1ee1cac498ae$var$Rnd(a, $61de1ee1cac498ae$var$_ve);
}
var $61de1ee1cac498ae$var$Jhe = "object", $61de1ee1cac498ae$var$Khe = "boolean", $61de1ee1cac498ae$var$Lhe = "number", $61de1ee1cac498ae$var$Mhe = "string", $61de1ee1cac498ae$var$Nhe = "function", $61de1ee1cac498ae$var$Ohe = 2147483647, $61de1ee1cac498ae$var$Phe = "java.lang", $61de1ee1cac498ae$var$Qhe = {
    3: 1
}, $61de1ee1cac498ae$var$Rhe = "com.google.common.base", $61de1ee1cac498ae$var$She = ", ", $61de1ee1cac498ae$var$The = "%s (%s) must not be negative", $61de1ee1cac498ae$var$Uhe = {
    3: 1,
    4: 1,
    5: 1
}, $61de1ee1cac498ae$var$Vhe = "negative size: ", $61de1ee1cac498ae$var$Whe = "Optional.of(", $61de1ee1cac498ae$var$Xhe = "null", $61de1ee1cac498ae$var$Yhe = {
    198: 1,
    47: 1
}, $61de1ee1cac498ae$var$Zhe = "com.google.common.collect", $61de1ee1cac498ae$var$$he = {
    198: 1,
    47: 1,
    125: 1
}, $61de1ee1cac498ae$var$_he = {
    224: 1,
    3: 1
}, $61de1ee1cac498ae$var$aie = {
    47: 1
}, $61de1ee1cac498ae$var$bie = "java.util", $61de1ee1cac498ae$var$cie = {
    83: 1
}, $61de1ee1cac498ae$var$die = {
    20: 1,
    28: 1,
    14: 1
}, $61de1ee1cac498ae$var$eie = 1965, $61de1ee1cac498ae$var$fie = {
    20: 1,
    28: 1,
    14: 1,
    21: 1
}, $61de1ee1cac498ae$var$gie = {
    83: 1,
    171: 1,
    161: 1
}, $61de1ee1cac498ae$var$hie = {
    20: 1,
    28: 1,
    14: 1,
    21: 1,
    84: 1
}, $61de1ee1cac498ae$var$iie = {
    20: 1,
    28: 1,
    14: 1,
    271: 1,
    21: 1,
    84: 1
}, $61de1ee1cac498ae$var$jie = {
    47: 1,
    125: 1
}, $61de1ee1cac498ae$var$kie = {
    345: 1,
    42: 1
}, $61de1ee1cac498ae$var$lie = "AbstractMapEntry", $61de1ee1cac498ae$var$mie = "expectedValuesPerKey", $61de1ee1cac498ae$var$nie = {
    3: 1,
    6: 1,
    4: 1,
    5: 1
}, $61de1ee1cac498ae$var$oie = 16384, $61de1ee1cac498ae$var$pie = {
    164: 1
}, $61de1ee1cac498ae$var$qie = {
    38: 1
}, $61de1ee1cac498ae$var$rie = {
    l: 4194303,
    m: 4194303,
    h: 524287
}, $61de1ee1cac498ae$var$sie = {
    196: 1
}, $61de1ee1cac498ae$var$tie = {
    245: 1,
    3: 1,
    35: 1
}, $61de1ee1cac498ae$var$uie = "range unbounded on this side", $61de1ee1cac498ae$var$vie = {
    20: 1
}, $61de1ee1cac498ae$var$wie = {
    20: 1,
    14: 1
}, $61de1ee1cac498ae$var$xie = {
    3: 1,
    20: 1,
    28: 1,
    14: 1
}, $61de1ee1cac498ae$var$yie = {
    152: 1,
    3: 1,
    20: 1,
    28: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$zie = {
    3: 1,
    4: 1,
    5: 1,
    165: 1
}, $61de1ee1cac498ae$var$Aie = {
    3: 1,
    83: 1
}, $61de1ee1cac498ae$var$Bie = {
    20: 1,
    14: 1,
    21: 1
}, $61de1ee1cac498ae$var$Cie = {
    3: 1,
    20: 1,
    28: 1,
    14: 1,
    21: 1
}, $61de1ee1cac498ae$var$Die = {
    20: 1,
    14: 1,
    21: 1,
    84: 1
}, $61de1ee1cac498ae$var$Eie = 461845907, $61de1ee1cac498ae$var$Fie = -862048943, $61de1ee1cac498ae$var$Gie = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    165: 1
}, $61de1ee1cac498ae$var$Hie = "expectedSize", $61de1ee1cac498ae$var$Iie = 1073741824, $61de1ee1cac498ae$var$Jie = "initialArraySize", $61de1ee1cac498ae$var$Kie = {
    3: 1,
    6: 1,
    4: 1,
    9: 1,
    5: 1
}, $61de1ee1cac498ae$var$Lie = {
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1
}, $61de1ee1cac498ae$var$Mie = "arraySize", $61de1ee1cac498ae$var$Nie = {
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$Oie = {
    45: 1
}, $61de1ee1cac498ae$var$Pie = {
    365: 1
}, $61de1ee1cac498ae$var$Qie = 1.0E-4, $61de1ee1cac498ae$var$Rie = -2147483648, $61de1ee1cac498ae$var$Sie = "__noinit__", $61de1ee1cac498ae$var$Tie = {
    3: 1,
    102: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$Uie = "com.google.gwt.core.client.impl", $61de1ee1cac498ae$var$Vie = "String", $61de1ee1cac498ae$var$Wie = "com.google.gwt.core.client", $61de1ee1cac498ae$var$Xie = "anonymous", $61de1ee1cac498ae$var$Yie = "fnStack", $61de1ee1cac498ae$var$Zie = "Unknown", $61de1ee1cac498ae$var$$ie = {
    195: 1,
    3: 1,
    4: 1
}, $61de1ee1cac498ae$var$_ie = 1000, $61de1ee1cac498ae$var$aje = 65535, $61de1ee1cac498ae$var$bje = "January", $61de1ee1cac498ae$var$cje = "February", $61de1ee1cac498ae$var$dje = "March", $61de1ee1cac498ae$var$eje = "April", $61de1ee1cac498ae$var$fje = "May", $61de1ee1cac498ae$var$gje = "June", $61de1ee1cac498ae$var$hje = "July", $61de1ee1cac498ae$var$ije = "August", $61de1ee1cac498ae$var$jje = "September", $61de1ee1cac498ae$var$kje = "October", $61de1ee1cac498ae$var$lje = "November", $61de1ee1cac498ae$var$mje = "December", $61de1ee1cac498ae$var$nje = 1900, $61de1ee1cac498ae$var$oje = {
    48: 1,
    3: 1,
    4: 1
}, $61de1ee1cac498ae$var$pje = "Before Christ", $61de1ee1cac498ae$var$qje = "Anno Domini", $61de1ee1cac498ae$var$rje = "Sunday", $61de1ee1cac498ae$var$sje = "Monday", $61de1ee1cac498ae$var$tje = "Tuesday", $61de1ee1cac498ae$var$uje = "Wednesday", $61de1ee1cac498ae$var$vje = "Thursday", $61de1ee1cac498ae$var$wje = "Friday", $61de1ee1cac498ae$var$xje = "Saturday", $61de1ee1cac498ae$var$yje = "com.google.gwt.i18n.shared", $61de1ee1cac498ae$var$zje = "DateTimeFormat", $61de1ee1cac498ae$var$Aje = "com.google.gwt.i18n.client", $61de1ee1cac498ae$var$Bje = "DefaultDateTimeFormatInfo", $61de1ee1cac498ae$var$Cje = {
    3: 1,
    4: 1,
    35: 1,
    199: 1
}, $61de1ee1cac498ae$var$Dje = "com.google.gwt.json.client", $61de1ee1cac498ae$var$Eje = 4194303, $61de1ee1cac498ae$var$Fje = 1048575, $61de1ee1cac498ae$var$Gje = 524288, $61de1ee1cac498ae$var$Hje = 4194304, $61de1ee1cac498ae$var$Ije = 17592186044416, $61de1ee1cac498ae$var$Jje = 1000000000, $61de1ee1cac498ae$var$Kje = -17592186044416, $61de1ee1cac498ae$var$Lje = "java.io", $61de1ee1cac498ae$var$Mje = {
    3: 1,
    102: 1,
    73: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$Nje = {
    3: 1,
    289: 1,
    78: 1
}, $61de1ee1cac498ae$var$Oje = 'For input string: "', $61de1ee1cac498ae$var$Pje = Infinity, $61de1ee1cac498ae$var$Qje = -Infinity, $61de1ee1cac498ae$var$Rje = 4096, $61de1ee1cac498ae$var$Sje = {
    3: 1,
    4: 1,
    364: 1
}, $61de1ee1cac498ae$var$Tje = 65536, $61de1ee1cac498ae$var$Uje = 55296, $61de1ee1cac498ae$var$Vje = {
    104: 1,
    3: 1,
    4: 1
}, $61de1ee1cac498ae$var$Wje = 100000, $61de1ee1cac498ae$var$Xje = 0.3010299956639812, $61de1ee1cac498ae$var$Yje = 4294967295, $61de1ee1cac498ae$var$Zje = 4294967296, $61de1ee1cac498ae$var$$je = "0.0", $61de1ee1cac498ae$var$_je = {
    42: 1
}, $61de1ee1cac498ae$var$ake = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    12: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$bke = {
    3: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$cke = {
    20: 1,
    14: 1,
    15: 1
}, $61de1ee1cac498ae$var$dke = {
    3: 1,
    62: 1
}, $61de1ee1cac498ae$var$eke = {
    182: 1
}, $61de1ee1cac498ae$var$fke = {
    3: 1,
    4: 1,
    83: 1
}, $61de1ee1cac498ae$var$gke = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    14: 1,
    53: 1,
    21: 1
}, $61de1ee1cac498ae$var$hke = "delete", $61de1ee1cac498ae$var$ike = 1.4901161193847656E-8, $61de1ee1cac498ae$var$jke = 1.1102230246251565E-16, $61de1ee1cac498ae$var$kke = 15525485, $61de1ee1cac498ae$var$lke = 5.9604644775390625E-8, $61de1ee1cac498ae$var$mke = 16777216, $61de1ee1cac498ae$var$nke = 16777215, $61de1ee1cac498ae$var$oke = ", length: ", $61de1ee1cac498ae$var$pke = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$qke = {
    3: 1,
    35: 1,
    22: 1,
    297: 1
}, $61de1ee1cac498ae$var$rke = "java.util.function", $61de1ee1cac498ae$var$ske = "java.util.logging", $61de1ee1cac498ae$var$tke = {
    3: 1,
    4: 1,
    5: 1,
    842: 1
}, $61de1ee1cac498ae$var$uke = "undefined", $61de1ee1cac498ae$var$vke = "java.util.stream", $61de1ee1cac498ae$var$wke = {
    525: 1,
    670: 1
}, $61de1ee1cac498ae$var$xke = "fromIndex: ", $61de1ee1cac498ae$var$yke = " > toIndex: ", $61de1ee1cac498ae$var$zke = ", toIndex: ", $61de1ee1cac498ae$var$Ake = "Index: ", $61de1ee1cac498ae$var$Bke = ", Size: ", $61de1ee1cac498ae$var$Cke = "org.eclipse.elk.alg.common", $61de1ee1cac498ae$var$Dke = {
    62: 1
}, $61de1ee1cac498ae$var$Eke = "org.eclipse.elk.alg.common.compaction", $61de1ee1cac498ae$var$Fke = "Scanline/EventHandler", $61de1ee1cac498ae$var$Gke = "org.eclipse.elk.alg.common.compaction.oned", $61de1ee1cac498ae$var$Hke = "CNode belongs to another CGroup.", $61de1ee1cac498ae$var$Ike = "ISpacingsHandler/1", $61de1ee1cac498ae$var$Jke = "The ", $61de1ee1cac498ae$var$Kke = " instance has been finished already.", $61de1ee1cac498ae$var$Lke = "The direction ", $61de1ee1cac498ae$var$Mke = " is not supported by the CGraph instance.", $61de1ee1cac498ae$var$Nke = "OneDimensionalCompactor", $61de1ee1cac498ae$var$Oke = "OneDimensionalCompactor/lambda$0$Type", $61de1ee1cac498ae$var$Pke = "Quadruplet", $61de1ee1cac498ae$var$Qke = "ScanlineConstraintCalculator", $61de1ee1cac498ae$var$Rke = "ScanlineConstraintCalculator/ConstraintsScanlineHandler", $61de1ee1cac498ae$var$Ske = "ScanlineConstraintCalculator/ConstraintsScanlineHandler/lambda$0$Type", $61de1ee1cac498ae$var$Tke = "ScanlineConstraintCalculator/Timestamp", $61de1ee1cac498ae$var$Uke = "ScanlineConstraintCalculator/lambda$0$Type", $61de1ee1cac498ae$var$Vke = {
    169: 1,
    45: 1
}, $61de1ee1cac498ae$var$Wke = "org.eclipse.elk.alg.common.compaction.options", $61de1ee1cac498ae$var$Xke = "org.eclipse.elk.core.data", $61de1ee1cac498ae$var$Yke = "org.eclipse.elk.polyomino.traversalStrategy", $61de1ee1cac498ae$var$Zke = "org.eclipse.elk.polyomino.lowLevelSort", $61de1ee1cac498ae$var$$ke = "org.eclipse.elk.polyomino.highLevelSort", $61de1ee1cac498ae$var$_ke = "org.eclipse.elk.polyomino.fill", $61de1ee1cac498ae$var$ale = {
    130: 1
}, $61de1ee1cac498ae$var$ble = "polyomino", $61de1ee1cac498ae$var$cle = "org.eclipse.elk.alg.common.networksimplex", $61de1ee1cac498ae$var$dle = {
    177: 1,
    3: 1,
    4: 1
}, $61de1ee1cac498ae$var$ele = "org.eclipse.elk.alg.common.nodespacing", $61de1ee1cac498ae$var$fle = "org.eclipse.elk.alg.common.nodespacing.cellsystem", $61de1ee1cac498ae$var$gle = "CENTER", $61de1ee1cac498ae$var$hle = {
    212: 1,
    326: 1
}, $61de1ee1cac498ae$var$ile = {
    3: 1,
    4: 1,
    5: 1,
    595: 1
}, $61de1ee1cac498ae$var$jle = "LEFT", $61de1ee1cac498ae$var$kle = "RIGHT", $61de1ee1cac498ae$var$lle = "Vertical alignment cannot be null", $61de1ee1cac498ae$var$mle = "BOTTOM", $61de1ee1cac498ae$var$nle = "org.eclipse.elk.alg.common.nodespacing.internal", $61de1ee1cac498ae$var$ole = "UNDEFINED", $61de1ee1cac498ae$var$ple = 0.01, $61de1ee1cac498ae$var$qle = "org.eclipse.elk.alg.common.nodespacing.internal.algorithm", $61de1ee1cac498ae$var$rle = "LabelPlacer/lambda$0$Type", $61de1ee1cac498ae$var$sle = "LabelPlacer/lambda$1$Type", $61de1ee1cac498ae$var$tle = "portRatioOrPosition", $61de1ee1cac498ae$var$ule = "org.eclipse.elk.alg.common.overlaps", $61de1ee1cac498ae$var$vle = "DOWN", $61de1ee1cac498ae$var$wle = "org.eclipse.elk.alg.common.polyomino", $61de1ee1cac498ae$var$xle = "NORTH", $61de1ee1cac498ae$var$yle = "EAST", $61de1ee1cac498ae$var$zle = "SOUTH", $61de1ee1cac498ae$var$Ale = "WEST", $61de1ee1cac498ae$var$Ble = "org.eclipse.elk.alg.common.polyomino.structures", $61de1ee1cac498ae$var$Cle = "Direction", $61de1ee1cac498ae$var$Dle = "Grid is only of size ", $61de1ee1cac498ae$var$Ele = ". Requested point (", $61de1ee1cac498ae$var$Fle = ") is out of bounds.", $61de1ee1cac498ae$var$Gle = " Given center based coordinates were (", $61de1ee1cac498ae$var$Hle = "org.eclipse.elk.graph.properties", $61de1ee1cac498ae$var$Ile = "IPropertyHolder", $61de1ee1cac498ae$var$Jle = {
    3: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$Kle = "org.eclipse.elk.alg.common.spore", $61de1ee1cac498ae$var$Lle = "org.eclipse.elk.alg.common.utils", $61de1ee1cac498ae$var$Mle = {
    209: 1
}, $61de1ee1cac498ae$var$Nle = "org.eclipse.elk.core", $61de1ee1cac498ae$var$Ole = "Connected Components Compaction", $61de1ee1cac498ae$var$Ple = "org.eclipse.elk.alg.disco", $61de1ee1cac498ae$var$Qle = "org.eclipse.elk.alg.disco.graph", $61de1ee1cac498ae$var$Rle = "org.eclipse.elk.alg.disco.options", $61de1ee1cac498ae$var$Sle = "CompactionStrategy", $61de1ee1cac498ae$var$Tle = "org.eclipse.elk.disco.componentCompaction.strategy", $61de1ee1cac498ae$var$Ule = "org.eclipse.elk.disco.componentCompaction.componentLayoutAlgorithm", $61de1ee1cac498ae$var$Vle = "org.eclipse.elk.disco.debug.discoGraph", $61de1ee1cac498ae$var$Wle = "org.eclipse.elk.disco.debug.discoPolys", $61de1ee1cac498ae$var$Xle = "componentCompaction", $61de1ee1cac498ae$var$Yle = "org.eclipse.elk.disco", $61de1ee1cac498ae$var$Zle = "org.eclipse.elk.spacing.componentComponent", $61de1ee1cac498ae$var$$le = "org.eclipse.elk.edge.thickness", $61de1ee1cac498ae$var$_le = "org.eclipse.elk.aspectRatio", $61de1ee1cac498ae$var$ame = "org.eclipse.elk.padding", $61de1ee1cac498ae$var$bme = "org.eclipse.elk.alg.disco.transform", $61de1ee1cac498ae$var$cme = 1.5707963267948966, $61de1ee1cac498ae$var$dme = 1.7976931348623157E308, $61de1ee1cac498ae$var$eme = {
    3: 1,
    4: 1,
    5: 1,
    192: 1
}, $61de1ee1cac498ae$var$fme = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    106: 1,
    120: 1
}, $61de1ee1cac498ae$var$gme = "org.eclipse.elk.alg.force", $61de1ee1cac498ae$var$hme = "ComponentsProcessor", $61de1ee1cac498ae$var$ime = "ComponentsProcessor/1", $61de1ee1cac498ae$var$jme = "org.eclipse.elk.alg.force.graph", $61de1ee1cac498ae$var$kme = "Component Layout", $61de1ee1cac498ae$var$lme = "org.eclipse.elk.alg.force.model", $61de1ee1cac498ae$var$mme = "org.eclipse.elk.force.model", $61de1ee1cac498ae$var$nme = "org.eclipse.elk.force.iterations", $61de1ee1cac498ae$var$ome = "org.eclipse.elk.force.repulsivePower", $61de1ee1cac498ae$var$pme = "org.eclipse.elk.force.temperature", $61de1ee1cac498ae$var$qme = 0.001, $61de1ee1cac498ae$var$rme = "org.eclipse.elk.force.repulsion", $61de1ee1cac498ae$var$sme = "org.eclipse.elk.alg.force.options", $61de1ee1cac498ae$var$tme = 1.600000023841858, $61de1ee1cac498ae$var$ume = "org.eclipse.elk.force", $61de1ee1cac498ae$var$vme = "org.eclipse.elk.priority", $61de1ee1cac498ae$var$wme = "org.eclipse.elk.spacing.nodeNode", $61de1ee1cac498ae$var$xme = "org.eclipse.elk.spacing.edgeLabel", $61de1ee1cac498ae$var$yme = "org.eclipse.elk.randomSeed", $61de1ee1cac498ae$var$zme = "org.eclipse.elk.separateConnectedComponents", $61de1ee1cac498ae$var$Ame = "org.eclipse.elk.interactive", $61de1ee1cac498ae$var$Bme = "org.eclipse.elk.portConstraints", $61de1ee1cac498ae$var$Cme = "org.eclipse.elk.edgeLabels.inline", $61de1ee1cac498ae$var$Dme = "org.eclipse.elk.omitNodeMicroLayout", $61de1ee1cac498ae$var$Eme = "org.eclipse.elk.nodeSize.options", $61de1ee1cac498ae$var$Fme = "org.eclipse.elk.nodeSize.constraints", $61de1ee1cac498ae$var$Gme = "org.eclipse.elk.nodeLabels.placement", $61de1ee1cac498ae$var$Hme = "org.eclipse.elk.portLabels.placement", $61de1ee1cac498ae$var$Ime = "origin", $61de1ee1cac498ae$var$Jme = "random", $61de1ee1cac498ae$var$Kme = "boundingBox.upLeft", $61de1ee1cac498ae$var$Lme = "boundingBox.lowRight", $61de1ee1cac498ae$var$Mme = "org.eclipse.elk.stress.fixed", $61de1ee1cac498ae$var$Nme = "org.eclipse.elk.stress.desiredEdgeLength", $61de1ee1cac498ae$var$Ome = "org.eclipse.elk.stress.dimension", $61de1ee1cac498ae$var$Pme = "org.eclipse.elk.stress.epsilon", $61de1ee1cac498ae$var$Qme = "org.eclipse.elk.stress.iterationLimit", $61de1ee1cac498ae$var$Rme = "org.eclipse.elk.stress", $61de1ee1cac498ae$var$Sme = "ELK Stress", $61de1ee1cac498ae$var$Tme = "org.eclipse.elk.nodeSize.minimum", $61de1ee1cac498ae$var$Ume = "org.eclipse.elk.alg.force.stress", $61de1ee1cac498ae$var$Vme = "Layered layout", $61de1ee1cac498ae$var$Wme = "org.eclipse.elk.alg.layered", $61de1ee1cac498ae$var$Xme = "org.eclipse.elk.alg.layered.compaction.components", $61de1ee1cac498ae$var$Yme = "org.eclipse.elk.alg.layered.compaction.oned", $61de1ee1cac498ae$var$Zme = "org.eclipse.elk.alg.layered.compaction.oned.algs", $61de1ee1cac498ae$var$$me = "org.eclipse.elk.alg.layered.compaction.recthull", $61de1ee1cac498ae$var$_me = "org.eclipse.elk.alg.layered.components", $61de1ee1cac498ae$var$ane = "NONE", $61de1ee1cac498ae$var$bne = {
    3: 1,
    6: 1,
    4: 1,
    9: 1,
    5: 1,
    122: 1
}, $61de1ee1cac498ae$var$cne = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    141: 1,
    106: 1,
    120: 1
}, $61de1ee1cac498ae$var$dne = "org.eclipse.elk.alg.layered.compound", $61de1ee1cac498ae$var$ene = {
    51: 1
}, $61de1ee1cac498ae$var$fne = "org.eclipse.elk.alg.layered.graph", $61de1ee1cac498ae$var$gne = " -> ", $61de1ee1cac498ae$var$hne = "Not supported by LGraph", $61de1ee1cac498ae$var$ine = "Port side is undefined", $61de1ee1cac498ae$var$jne = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    474: 1,
    141: 1,
    106: 1,
    120: 1
}, $61de1ee1cac498ae$var$kne = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    141: 1,
    193: 1,
    203: 1,
    106: 1,
    120: 1
}, $61de1ee1cac498ae$var$lne = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    141: 1,
    1943: 1,
    203: 1,
    106: 1,
    120: 1
}, $61de1ee1cac498ae$var$mne = "([{\"' 	\r\n", $61de1ee1cac498ae$var$nne = ")]}\"' 	\r\n", $61de1ee1cac498ae$var$one = "The given string contains parts that cannot be parsed as numbers.", $61de1ee1cac498ae$var$pne = "org.eclipse.elk.core.math", $61de1ee1cac498ae$var$qne = {
    3: 1,
    4: 1,
    142: 1,
    207: 1,
    414: 1
}, $61de1ee1cac498ae$var$rne = {
    3: 1,
    4: 1,
    116: 1,
    207: 1,
    414: 1
}, $61de1ee1cac498ae$var$sne = "org.eclipse.elk.layered", $61de1ee1cac498ae$var$tne = "org.eclipse.elk.alg.layered.graph.transform", $61de1ee1cac498ae$var$une = "ElkGraphImporter", $61de1ee1cac498ae$var$vne = "ElkGraphImporter/lambda$0$Type", $61de1ee1cac498ae$var$wne = "ElkGraphImporter/lambda$1$Type", $61de1ee1cac498ae$var$xne = "ElkGraphImporter/lambda$2$Type", $61de1ee1cac498ae$var$yne = "ElkGraphImporter/lambda$4$Type", $61de1ee1cac498ae$var$zne = "Node margin calculation", $61de1ee1cac498ae$var$Ane = "org.eclipse.elk.alg.layered.intermediate", $61de1ee1cac498ae$var$Bne = "ONE_SIDED_GREEDY_SWITCH", $61de1ee1cac498ae$var$Cne = "TWO_SIDED_GREEDY_SWITCH", $61de1ee1cac498ae$var$Dne = "No implementation is available for the layout processor ", $61de1ee1cac498ae$var$Ene = "IntermediateProcessorStrategy", $61de1ee1cac498ae$var$Fne = "Node '", $61de1ee1cac498ae$var$Gne = "FIRST_SEPARATE", $61de1ee1cac498ae$var$Hne = "LAST_SEPARATE", $61de1ee1cac498ae$var$Ine = "Odd port side processing", $61de1ee1cac498ae$var$Jne = "org.eclipse.elk.alg.layered.intermediate.compaction", $61de1ee1cac498ae$var$Kne = "org.eclipse.elk.alg.layered.intermediate.greedyswitch", $61de1ee1cac498ae$var$Lne = "org.eclipse.elk.alg.layered.p3order.counting", $61de1ee1cac498ae$var$Mne = {
    225: 1
}, $61de1ee1cac498ae$var$Nne = "org.eclipse.elk.alg.layered.intermediate.loops", $61de1ee1cac498ae$var$One = "org.eclipse.elk.alg.layered.intermediate.loops.ordering", $61de1ee1cac498ae$var$Pne = "org.eclipse.elk.alg.layered.intermediate.loops.routing", $61de1ee1cac498ae$var$Qne = "org.eclipse.elk.alg.layered.intermediate.preserveorder", $61de1ee1cac498ae$var$Rne = "org.eclipse.elk.alg.layered.intermediate.wrapping", $61de1ee1cac498ae$var$Sne = "org.eclipse.elk.alg.layered.options", $61de1ee1cac498ae$var$Tne = "INTERACTIVE", $61de1ee1cac498ae$var$Une = "DEPTH_FIRST", $61de1ee1cac498ae$var$Vne = "EDGE_LENGTH", $61de1ee1cac498ae$var$Wne = "SELF_LOOPS", $61de1ee1cac498ae$var$Xne = "firstTryWithInitialOrder", $61de1ee1cac498ae$var$Yne = "org.eclipse.elk.layered.directionCongruency", $61de1ee1cac498ae$var$Zne = "org.eclipse.elk.layered.feedbackEdges", $61de1ee1cac498ae$var$$ne = "org.eclipse.elk.layered.interactiveReferencePoint", $61de1ee1cac498ae$var$_ne = "org.eclipse.elk.layered.mergeEdges", $61de1ee1cac498ae$var$aoe = "org.eclipse.elk.layered.mergeHierarchyEdges", $61de1ee1cac498ae$var$boe = "org.eclipse.elk.layered.allowNonFlowPortsToSwitchSides", $61de1ee1cac498ae$var$coe = "org.eclipse.elk.layered.portSortingStrategy", $61de1ee1cac498ae$var$doe = "org.eclipse.elk.layered.thoroughness", $61de1ee1cac498ae$var$eoe = "org.eclipse.elk.layered.unnecessaryBendpoints", $61de1ee1cac498ae$var$foe = "org.eclipse.elk.layered.generatePositionAndLayerIds", $61de1ee1cac498ae$var$goe = "org.eclipse.elk.layered.cycleBreaking.strategy", $61de1ee1cac498ae$var$hoe = "org.eclipse.elk.layered.layering.strategy", $61de1ee1cac498ae$var$ioe = "org.eclipse.elk.layered.layering.layerConstraint", $61de1ee1cac498ae$var$joe = "org.eclipse.elk.layered.layering.layerChoiceConstraint", $61de1ee1cac498ae$var$koe = "org.eclipse.elk.layered.layering.layerId", $61de1ee1cac498ae$var$loe = "org.eclipse.elk.layered.layering.minWidth.upperBoundOnWidth", $61de1ee1cac498ae$var$moe = "org.eclipse.elk.layered.layering.minWidth.upperLayerEstimationScalingFactor", $61de1ee1cac498ae$var$noe = "org.eclipse.elk.layered.layering.nodePromotion.strategy", $61de1ee1cac498ae$var$ooe = "org.eclipse.elk.layered.layering.nodePromotion.maxIterations", $61de1ee1cac498ae$var$poe = "org.eclipse.elk.layered.layering.coffmanGraham.layerBound", $61de1ee1cac498ae$var$qoe = "org.eclipse.elk.layered.crossingMinimization.strategy", $61de1ee1cac498ae$var$roe = "org.eclipse.elk.layered.crossingMinimization.forceNodeModelOrder", $61de1ee1cac498ae$var$soe = "org.eclipse.elk.layered.crossingMinimization.hierarchicalSweepiness", $61de1ee1cac498ae$var$toe = "org.eclipse.elk.layered.crossingMinimization.semiInteractive", $61de1ee1cac498ae$var$uoe = "org.eclipse.elk.layered.crossingMinimization.positionChoiceConstraint", $61de1ee1cac498ae$var$voe = "org.eclipse.elk.layered.crossingMinimization.positionId", $61de1ee1cac498ae$var$woe = "org.eclipse.elk.layered.crossingMinimization.greedySwitch.activationThreshold", $61de1ee1cac498ae$var$xoe = "org.eclipse.elk.layered.crossingMinimization.greedySwitch.type", $61de1ee1cac498ae$var$yoe = "org.eclipse.elk.layered.crossingMinimization.greedySwitchHierarchical.type", $61de1ee1cac498ae$var$zoe = "org.eclipse.elk.layered.nodePlacement.strategy", $61de1ee1cac498ae$var$Aoe = "org.eclipse.elk.layered.nodePlacement.favorStraightEdges", $61de1ee1cac498ae$var$Boe = "org.eclipse.elk.layered.nodePlacement.bk.edgeStraightening", $61de1ee1cac498ae$var$Coe = "org.eclipse.elk.layered.nodePlacement.bk.fixedAlignment", $61de1ee1cac498ae$var$Doe = "org.eclipse.elk.layered.nodePlacement.linearSegments.deflectionDampening", $61de1ee1cac498ae$var$Eoe = "org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility", $61de1ee1cac498ae$var$Foe = "org.eclipse.elk.layered.nodePlacement.networkSimplex.nodeFlexibility.default", $61de1ee1cac498ae$var$Goe = "org.eclipse.elk.layered.edgeRouting.selfLoopDistribution", $61de1ee1cac498ae$var$Hoe = "org.eclipse.elk.layered.edgeRouting.selfLoopOrdering", $61de1ee1cac498ae$var$Ioe = "org.eclipse.elk.layered.edgeRouting.splines.mode", $61de1ee1cac498ae$var$Joe = "org.eclipse.elk.layered.edgeRouting.splines.sloppy.layerSpacingFactor", $61de1ee1cac498ae$var$Koe = "org.eclipse.elk.layered.edgeRouting.polyline.slopedEdgeZoneWidth", $61de1ee1cac498ae$var$Loe = "org.eclipse.elk.layered.spacing.baseValue", $61de1ee1cac498ae$var$Moe = "org.eclipse.elk.layered.spacing.edgeNodeBetweenLayers", $61de1ee1cac498ae$var$Noe = "org.eclipse.elk.layered.spacing.edgeEdgeBetweenLayers", $61de1ee1cac498ae$var$Ooe = "org.eclipse.elk.layered.spacing.nodeNodeBetweenLayers", $61de1ee1cac498ae$var$Poe = "org.eclipse.elk.layered.priority.direction", $61de1ee1cac498ae$var$Qoe = "org.eclipse.elk.layered.priority.shortness", $61de1ee1cac498ae$var$Roe = "org.eclipse.elk.layered.priority.straightness", $61de1ee1cac498ae$var$Soe = "org.eclipse.elk.layered.compaction.connectedComponents", $61de1ee1cac498ae$var$Toe = "org.eclipse.elk.layered.compaction.postCompaction.strategy", $61de1ee1cac498ae$var$Uoe = "org.eclipse.elk.layered.compaction.postCompaction.constraints", $61de1ee1cac498ae$var$Voe = "org.eclipse.elk.layered.highDegreeNodes.treatment", $61de1ee1cac498ae$var$Woe = "org.eclipse.elk.layered.highDegreeNodes.threshold", $61de1ee1cac498ae$var$Xoe = "org.eclipse.elk.layered.highDegreeNodes.treeHeight", $61de1ee1cac498ae$var$Yoe = "org.eclipse.elk.layered.wrapping.strategy", $61de1ee1cac498ae$var$Zoe = "org.eclipse.elk.layered.wrapping.additionalEdgeSpacing", $61de1ee1cac498ae$var$$oe = "org.eclipse.elk.layered.wrapping.correctionFactor", $61de1ee1cac498ae$var$_oe = "org.eclipse.elk.layered.wrapping.cutting.strategy", $61de1ee1cac498ae$var$ape = "org.eclipse.elk.layered.wrapping.cutting.cuts", $61de1ee1cac498ae$var$bpe = "org.eclipse.elk.layered.wrapping.cutting.msd.freedom", $61de1ee1cac498ae$var$cpe = "org.eclipse.elk.layered.wrapping.validify.strategy", $61de1ee1cac498ae$var$dpe = "org.eclipse.elk.layered.wrapping.validify.forbiddenIndices", $61de1ee1cac498ae$var$epe = "org.eclipse.elk.layered.wrapping.multiEdge.improveCuts", $61de1ee1cac498ae$var$fpe = "org.eclipse.elk.layered.wrapping.multiEdge.distancePenalty", $61de1ee1cac498ae$var$gpe = "org.eclipse.elk.layered.wrapping.multiEdge.improveWrappedEdges", $61de1ee1cac498ae$var$hpe = "org.eclipse.elk.layered.edgeLabels.sideSelection", $61de1ee1cac498ae$var$ipe = "org.eclipse.elk.layered.edgeLabels.centerLabelPlacementStrategy", $61de1ee1cac498ae$var$jpe = "org.eclipse.elk.layered.considerModelOrder.strategy", $61de1ee1cac498ae$var$kpe = "org.eclipse.elk.layered.considerModelOrder.noModelOrder", $61de1ee1cac498ae$var$lpe = "org.eclipse.elk.layered.considerModelOrder.components", $61de1ee1cac498ae$var$mpe = "org.eclipse.elk.layered.considerModelOrder.longEdgeStrategy", $61de1ee1cac498ae$var$npe = "org.eclipse.elk.layered.considerModelOrder.crossingCounterNodeInfluence", $61de1ee1cac498ae$var$ope = "org.eclipse.elk.layered.considerModelOrder.crossingCounterPortInfluence", $61de1ee1cac498ae$var$ppe = "layering", $61de1ee1cac498ae$var$qpe = "layering.minWidth", $61de1ee1cac498ae$var$rpe = "layering.nodePromotion", $61de1ee1cac498ae$var$spe = "crossingMinimization", $61de1ee1cac498ae$var$tpe = "org.eclipse.elk.hierarchyHandling", $61de1ee1cac498ae$var$upe = "crossingMinimization.greedySwitch", $61de1ee1cac498ae$var$vpe = "nodePlacement", $61de1ee1cac498ae$var$wpe = "nodePlacement.bk", $61de1ee1cac498ae$var$xpe = "edgeRouting", $61de1ee1cac498ae$var$ype = "org.eclipse.elk.edgeRouting", $61de1ee1cac498ae$var$zpe = "spacing", $61de1ee1cac498ae$var$Ape = "priority", $61de1ee1cac498ae$var$Bpe = "compaction", $61de1ee1cac498ae$var$Cpe = "compaction.postCompaction", $61de1ee1cac498ae$var$Dpe = "Specifies whether and how post-process compaction is applied.", $61de1ee1cac498ae$var$Epe = "highDegreeNodes", $61de1ee1cac498ae$var$Fpe = "wrapping", $61de1ee1cac498ae$var$Gpe = "wrapping.cutting", $61de1ee1cac498ae$var$Hpe = "wrapping.validify", $61de1ee1cac498ae$var$Ipe = "wrapping.multiEdge", $61de1ee1cac498ae$var$Jpe = "edgeLabels", $61de1ee1cac498ae$var$Kpe = "considerModelOrder", $61de1ee1cac498ae$var$Lpe = "org.eclipse.elk.spacing.commentComment", $61de1ee1cac498ae$var$Mpe = "org.eclipse.elk.spacing.commentNode", $61de1ee1cac498ae$var$Npe = "org.eclipse.elk.spacing.edgeEdge", $61de1ee1cac498ae$var$Ope = "org.eclipse.elk.spacing.edgeNode", $61de1ee1cac498ae$var$Ppe = "org.eclipse.elk.spacing.labelLabel", $61de1ee1cac498ae$var$Qpe = "org.eclipse.elk.spacing.labelPortHorizontal", $61de1ee1cac498ae$var$Rpe = "org.eclipse.elk.spacing.labelPortVertical", $61de1ee1cac498ae$var$Spe = "org.eclipse.elk.spacing.labelNode", $61de1ee1cac498ae$var$Tpe = "org.eclipse.elk.spacing.nodeSelfLoop", $61de1ee1cac498ae$var$Upe = "org.eclipse.elk.spacing.portPort", $61de1ee1cac498ae$var$Vpe = "org.eclipse.elk.spacing.individual", $61de1ee1cac498ae$var$Wpe = "org.eclipse.elk.port.borderOffset", $61de1ee1cac498ae$var$Xpe = "org.eclipse.elk.noLayout", $61de1ee1cac498ae$var$Ype = "org.eclipse.elk.port.side", $61de1ee1cac498ae$var$Zpe = "org.eclipse.elk.debugMode", $61de1ee1cac498ae$var$$pe = "org.eclipse.elk.alignment", $61de1ee1cac498ae$var$_pe = "org.eclipse.elk.insideSelfLoops.activate", $61de1ee1cac498ae$var$aqe = "org.eclipse.elk.insideSelfLoops.yo", $61de1ee1cac498ae$var$bqe = "org.eclipse.elk.nodeSize.fixedGraphSize", $61de1ee1cac498ae$var$cqe = "org.eclipse.elk.direction", $61de1ee1cac498ae$var$dqe = "org.eclipse.elk.nodeLabels.padding", $61de1ee1cac498ae$var$eqe = "org.eclipse.elk.portLabels.nextToPortIfPossible", $61de1ee1cac498ae$var$fqe = "org.eclipse.elk.portLabels.treatAsGroup", $61de1ee1cac498ae$var$gqe = "org.eclipse.elk.portAlignment.default", $61de1ee1cac498ae$var$hqe = "org.eclipse.elk.portAlignment.north", $61de1ee1cac498ae$var$iqe = "org.eclipse.elk.portAlignment.south", $61de1ee1cac498ae$var$jqe = "org.eclipse.elk.portAlignment.west", $61de1ee1cac498ae$var$kqe = "org.eclipse.elk.portAlignment.east", $61de1ee1cac498ae$var$lqe = "org.eclipse.elk.contentAlignment", $61de1ee1cac498ae$var$mqe = "org.eclipse.elk.junctionPoints", $61de1ee1cac498ae$var$nqe = "org.eclipse.elk.edgeLabels.placement", $61de1ee1cac498ae$var$oqe = "org.eclipse.elk.port.index", $61de1ee1cac498ae$var$pqe = "org.eclipse.elk.commentBox", $61de1ee1cac498ae$var$qqe = "org.eclipse.elk.hypernode", $61de1ee1cac498ae$var$rqe = "org.eclipse.elk.port.anchor", $61de1ee1cac498ae$var$sqe = "org.eclipse.elk.partitioning.activate", $61de1ee1cac498ae$var$tqe = "org.eclipse.elk.partitioning.partition", $61de1ee1cac498ae$var$uqe = "org.eclipse.elk.position", $61de1ee1cac498ae$var$vqe = "org.eclipse.elk.margins", $61de1ee1cac498ae$var$wqe = "org.eclipse.elk.spacing.portsSurrounding", $61de1ee1cac498ae$var$xqe = "org.eclipse.elk.interactiveLayout", $61de1ee1cac498ae$var$yqe = "org.eclipse.elk.core.util", $61de1ee1cac498ae$var$zqe = {
    3: 1,
    4: 1,
    5: 1,
    593: 1
}, $61de1ee1cac498ae$var$Aqe = "NETWORK_SIMPLEX", $61de1ee1cac498ae$var$Bqe = {
    123: 1,
    51: 1
}, $61de1ee1cac498ae$var$Cqe = "org.eclipse.elk.alg.layered.p1cycles", $61de1ee1cac498ae$var$Dqe = "org.eclipse.elk.alg.layered.p2layers", $61de1ee1cac498ae$var$Eqe = {
    402: 1,
    225: 1
}, $61de1ee1cac498ae$var$Fqe = {
    832: 1,
    3: 1,
    4: 1
}, $61de1ee1cac498ae$var$Gqe = "org.eclipse.elk.alg.layered.p3order", $61de1ee1cac498ae$var$Hqe = "org.eclipse.elk.alg.layered.p4nodes", $61de1ee1cac498ae$var$Iqe = {
    3: 1,
    4: 1,
    5: 1,
    840: 1
}, $61de1ee1cac498ae$var$Jqe = 1.0E-5, $61de1ee1cac498ae$var$Kqe = "org.eclipse.elk.alg.layered.p4nodes.bk", $61de1ee1cac498ae$var$Lqe = "org.eclipse.elk.alg.layered.p5edges", $61de1ee1cac498ae$var$Mqe = "org.eclipse.elk.alg.layered.p5edges.orthogonal", $61de1ee1cac498ae$var$Nqe = "org.eclipse.elk.alg.layered.p5edges.orthogonal.direction", $61de1ee1cac498ae$var$Oqe = 1.0E-6, $61de1ee1cac498ae$var$Pqe = "org.eclipse.elk.alg.layered.p5edges.splines", $61de1ee1cac498ae$var$Qqe = 0.09999999999999998, $61de1ee1cac498ae$var$Rqe = 1.0E-8, $61de1ee1cac498ae$var$Sqe = 4.71238898038469, $61de1ee1cac498ae$var$Tqe = 3.141592653589793, $61de1ee1cac498ae$var$Uqe = "org.eclipse.elk.alg.mrtree", $61de1ee1cac498ae$var$Vqe = "org.eclipse.elk.alg.mrtree.graph", $61de1ee1cac498ae$var$Wqe = "org.eclipse.elk.alg.mrtree.intermediate", $61de1ee1cac498ae$var$Xqe = "Set neighbors in level", $61de1ee1cac498ae$var$Yqe = "DESCENDANTS", $61de1ee1cac498ae$var$Zqe = "org.eclipse.elk.mrtree.weighting", $61de1ee1cac498ae$var$$qe = "org.eclipse.elk.mrtree.searchOrder", $61de1ee1cac498ae$var$_qe = "org.eclipse.elk.alg.mrtree.options", $61de1ee1cac498ae$var$are = "org.eclipse.elk.mrtree", $61de1ee1cac498ae$var$bre = "org.eclipse.elk.tree", $61de1ee1cac498ae$var$cre = "org.eclipse.elk.alg.radial", $61de1ee1cac498ae$var$dre = 6.283185307179586, $61de1ee1cac498ae$var$ere = 4.9E-324, $61de1ee1cac498ae$var$fre = "org.eclipse.elk.alg.radial.intermediate", $61de1ee1cac498ae$var$gre = "org.eclipse.elk.alg.radial.intermediate.compaction", $61de1ee1cac498ae$var$hre = {
    3: 1,
    4: 1,
    5: 1,
    106: 1
}, $61de1ee1cac498ae$var$ire = "org.eclipse.elk.alg.radial.intermediate.optimization", $61de1ee1cac498ae$var$jre = "No implementation is available for the layout option ", $61de1ee1cac498ae$var$kre = "org.eclipse.elk.alg.radial.options", $61de1ee1cac498ae$var$lre = "org.eclipse.elk.radial.orderId", $61de1ee1cac498ae$var$mre = "org.eclipse.elk.radial.radius", $61de1ee1cac498ae$var$nre = "org.eclipse.elk.radial.compactor", $61de1ee1cac498ae$var$ore = "org.eclipse.elk.radial.compactionStepSize", $61de1ee1cac498ae$var$pre = "org.eclipse.elk.radial.sorter", $61de1ee1cac498ae$var$qre = "org.eclipse.elk.radial.wedgeCriteria", $61de1ee1cac498ae$var$rre = "org.eclipse.elk.radial.optimizationCriteria", $61de1ee1cac498ae$var$sre = "org.eclipse.elk.radial", $61de1ee1cac498ae$var$tre = "org.eclipse.elk.alg.radial.p1position.wedge", $61de1ee1cac498ae$var$ure = "org.eclipse.elk.alg.radial.sorting", $61de1ee1cac498ae$var$vre = 5.497787143782138, $61de1ee1cac498ae$var$wre = 3.9269908169872414, $61de1ee1cac498ae$var$xre = 2.356194490192345, $61de1ee1cac498ae$var$yre = "org.eclipse.elk.alg.rectpacking", $61de1ee1cac498ae$var$zre = "org.eclipse.elk.alg.rectpacking.firstiteration", $61de1ee1cac498ae$var$Are = "org.eclipse.elk.alg.rectpacking.options", $61de1ee1cac498ae$var$Bre = "org.eclipse.elk.rectpacking.optimizationGoal", $61de1ee1cac498ae$var$Cre = "org.eclipse.elk.rectpacking.lastPlaceShift", $61de1ee1cac498ae$var$Dre = "org.eclipse.elk.rectpacking.currentPosition", $61de1ee1cac498ae$var$Ere = "org.eclipse.elk.rectpacking.desiredPosition", $61de1ee1cac498ae$var$Fre = "org.eclipse.elk.rectpacking.onlyFirstIteration", $61de1ee1cac498ae$var$Gre = "org.eclipse.elk.rectpacking.rowCompaction", $61de1ee1cac498ae$var$Hre = "org.eclipse.elk.rectpacking.expandToAspectRatio", $61de1ee1cac498ae$var$Ire = "org.eclipse.elk.rectpacking.targetWidth", $61de1ee1cac498ae$var$Jre = "org.eclipse.elk.expandNodes", $61de1ee1cac498ae$var$Kre = "org.eclipse.elk.rectpacking", $61de1ee1cac498ae$var$Lre = "org.eclipse.elk.alg.rectpacking.util", $61de1ee1cac498ae$var$Mre = "No implementation available for ", $61de1ee1cac498ae$var$Nre = "org.eclipse.elk.alg.spore", $61de1ee1cac498ae$var$Ore = "org.eclipse.elk.alg.spore.options", $61de1ee1cac498ae$var$Pre = "org.eclipse.elk.sporeCompaction", $61de1ee1cac498ae$var$Qre = "org.eclipse.elk.underlyingLayoutAlgorithm", $61de1ee1cac498ae$var$Rre = "org.eclipse.elk.processingOrder.treeConstruction", $61de1ee1cac498ae$var$Sre = "org.eclipse.elk.processingOrder.spanningTreeCostFunction", $61de1ee1cac498ae$var$Tre = "org.eclipse.elk.processingOrder.preferredRoot", $61de1ee1cac498ae$var$Ure = "org.eclipse.elk.processingOrder.rootSelection", $61de1ee1cac498ae$var$Vre = "org.eclipse.elk.structure.structureExtractionStrategy", $61de1ee1cac498ae$var$Wre = "org.eclipse.elk.compaction.compactionStrategy", $61de1ee1cac498ae$var$Xre = "org.eclipse.elk.compaction.orthogonal", $61de1ee1cac498ae$var$Yre = "org.eclipse.elk.overlapRemoval.maxIterations", $61de1ee1cac498ae$var$Zre = "org.eclipse.elk.overlapRemoval.runScanline", $61de1ee1cac498ae$var$$re = "processingOrder", $61de1ee1cac498ae$var$_re = "overlapRemoval", $61de1ee1cac498ae$var$ase = "org.eclipse.elk.sporeOverlap", $61de1ee1cac498ae$var$bse = "org.eclipse.elk.alg.spore.p1structure", $61de1ee1cac498ae$var$cse = "org.eclipse.elk.alg.spore.p2processingorder", $61de1ee1cac498ae$var$dse = "org.eclipse.elk.alg.spore.p3execution", $61de1ee1cac498ae$var$ese = "Invalid index: ", $61de1ee1cac498ae$var$fse = "org.eclipse.elk.core.alg", $61de1ee1cac498ae$var$gse = {
    331: 1
}, $61de1ee1cac498ae$var$hse = {
    288: 1
}, $61de1ee1cac498ae$var$ise = "Make sure its type is registered with the ", $61de1ee1cac498ae$var$jse = " utility class.", $61de1ee1cac498ae$var$kse = "true", $61de1ee1cac498ae$var$lse = "false", $61de1ee1cac498ae$var$mse = "Couldn't clone property '", $61de1ee1cac498ae$var$nse = 0.05, $61de1ee1cac498ae$var$ose = "org.eclipse.elk.core.options", $61de1ee1cac498ae$var$pse = 1.2999999523162842, $61de1ee1cac498ae$var$qse = "org.eclipse.elk.box", $61de1ee1cac498ae$var$rse = "org.eclipse.elk.box.packingMode", $61de1ee1cac498ae$var$sse = "org.eclipse.elk.algorithm", $61de1ee1cac498ae$var$tse = "org.eclipse.elk.resolvedAlgorithm", $61de1ee1cac498ae$var$use = "org.eclipse.elk.bendPoints", $61de1ee1cac498ae$var$vse = "org.eclipse.elk.labelManager", $61de1ee1cac498ae$var$wse = "org.eclipse.elk.scaleFactor", $61de1ee1cac498ae$var$xse = "org.eclipse.elk.animate", $61de1ee1cac498ae$var$yse = "org.eclipse.elk.animTimeFactor", $61de1ee1cac498ae$var$zse = "org.eclipse.elk.layoutAncestors", $61de1ee1cac498ae$var$Ase = "org.eclipse.elk.maxAnimTime", $61de1ee1cac498ae$var$Bse = "org.eclipse.elk.minAnimTime", $61de1ee1cac498ae$var$Cse = "org.eclipse.elk.progressBar", $61de1ee1cac498ae$var$Dse = "org.eclipse.elk.validateGraph", $61de1ee1cac498ae$var$Ese = "org.eclipse.elk.validateOptions", $61de1ee1cac498ae$var$Fse = "org.eclipse.elk.zoomToFit", $61de1ee1cac498ae$var$Gse = "org.eclipse.elk.font.name", $61de1ee1cac498ae$var$Hse = "org.eclipse.elk.font.size", $61de1ee1cac498ae$var$Ise = "org.eclipse.elk.edge.type", $61de1ee1cac498ae$var$Jse = "partitioning", $61de1ee1cac498ae$var$Kse = "nodeLabels", $61de1ee1cac498ae$var$Lse = "portAlignment", $61de1ee1cac498ae$var$Mse = "nodeSize", $61de1ee1cac498ae$var$Nse = "port", $61de1ee1cac498ae$var$Ose = "portLabels", $61de1ee1cac498ae$var$Pse = "insideSelfLoops", $61de1ee1cac498ae$var$Qse = "org.eclipse.elk.fixed", $61de1ee1cac498ae$var$Rse = "org.eclipse.elk.random", $61de1ee1cac498ae$var$Sse = "port must have a parent node to calculate the port side", $61de1ee1cac498ae$var$Tse = "The edge needs to have exactly one edge section. Found: ", $61de1ee1cac498ae$var$Use = "org.eclipse.elk.core.util.adapters", $61de1ee1cac498ae$var$Vse = "org.eclipse.emf.ecore", $61de1ee1cac498ae$var$Wse = "org.eclipse.elk.graph", $61de1ee1cac498ae$var$Xse = "EMapPropertyHolder", $61de1ee1cac498ae$var$Yse = "ElkBendPoint", $61de1ee1cac498ae$var$Zse = "ElkGraphElement", $61de1ee1cac498ae$var$$se = "ElkConnectableShape", $61de1ee1cac498ae$var$_se = "ElkEdge", $61de1ee1cac498ae$var$ate = "ElkEdgeSection", $61de1ee1cac498ae$var$bte = "EModelElement", $61de1ee1cac498ae$var$cte = "ENamedElement", $61de1ee1cac498ae$var$dte = "ElkLabel", $61de1ee1cac498ae$var$ete = "ElkNode", $61de1ee1cac498ae$var$fte = "ElkPort", $61de1ee1cac498ae$var$gte = {
    92: 1,
    90: 1
}, $61de1ee1cac498ae$var$hte = "org.eclipse.emf.common.notify.impl", $61de1ee1cac498ae$var$ite = "The feature '", $61de1ee1cac498ae$var$jte = "' is not a valid changeable feature", $61de1ee1cac498ae$var$kte = "Expecting null", $61de1ee1cac498ae$var$lte = "' is not a valid feature", $61de1ee1cac498ae$var$mte = "The feature ID", $61de1ee1cac498ae$var$nte = " is not a valid feature ID", $61de1ee1cac498ae$var$ote = 32768, $61de1ee1cac498ae$var$pte = {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    49: 1,
    97: 1
}, $61de1ee1cac498ae$var$qte = "org.eclipse.emf.ecore.impl", $61de1ee1cac498ae$var$rte = "org.eclipse.elk.graph.impl", $61de1ee1cac498ae$var$ste = "Recursive containment not allowed for ", $61de1ee1cac498ae$var$tte = "The datatype '", $61de1ee1cac498ae$var$ute = "' is not a valid classifier", $61de1ee1cac498ae$var$vte = "The value '", $61de1ee1cac498ae$var$wte = {
    190: 1,
    3: 1,
    4: 1
}, $61de1ee1cac498ae$var$xte = "The class '", $61de1ee1cac498ae$var$yte = "http://www.eclipse.org/elk/ElkGraph", $61de1ee1cac498ae$var$zte = 1024, $61de1ee1cac498ae$var$Ate = "property", $61de1ee1cac498ae$var$Bte = "value", $61de1ee1cac498ae$var$Cte = "source", $61de1ee1cac498ae$var$Dte = "properties", $61de1ee1cac498ae$var$Ete = "identifier", $61de1ee1cac498ae$var$Fte = "height", $61de1ee1cac498ae$var$Gte = "width", $61de1ee1cac498ae$var$Hte = "parent", $61de1ee1cac498ae$var$Ite = "text", $61de1ee1cac498ae$var$Jte = "children", $61de1ee1cac498ae$var$Kte = "hierarchical", $61de1ee1cac498ae$var$Lte = "sources", $61de1ee1cac498ae$var$Mte = "targets", $61de1ee1cac498ae$var$Nte = "sections", $61de1ee1cac498ae$var$Ote = "bendPoints", $61de1ee1cac498ae$var$Pte = "outgoingShape", $61de1ee1cac498ae$var$Qte = "incomingShape", $61de1ee1cac498ae$var$Rte = "outgoingSections", $61de1ee1cac498ae$var$Ste = "incomingSections", $61de1ee1cac498ae$var$Tte = "org.eclipse.emf.common.util", $61de1ee1cac498ae$var$Ute = "Severe implementation error in the Json to ElkGraph importer.", $61de1ee1cac498ae$var$Vte = "id", $61de1ee1cac498ae$var$Wte = "org.eclipse.elk.graph.json", $61de1ee1cac498ae$var$Xte = "Unhandled parameter types: ", $61de1ee1cac498ae$var$Yte = "startPoint", $61de1ee1cac498ae$var$Zte = "An edge must have at least one source and one target (edge id: '", $61de1ee1cac498ae$var$$te = "').", $61de1ee1cac498ae$var$_te = "Referenced edge section does not exist: ", $61de1ee1cac498ae$var$aue = " (edge id: '", $61de1ee1cac498ae$var$bue = "target", $61de1ee1cac498ae$var$cue = "sourcePoint", $61de1ee1cac498ae$var$due = "targetPoint", $61de1ee1cac498ae$var$eue = "group", $61de1ee1cac498ae$var$fue = "name", $61de1ee1cac498ae$var$gue = "connectableShape cannot be null", $61de1ee1cac498ae$var$hue = "edge cannot be null", $61de1ee1cac498ae$var$iue = "Passed edge is not 'simple'.", $61de1ee1cac498ae$var$jue = "org.eclipse.elk.graph.util", $61de1ee1cac498ae$var$kue = "The 'no duplicates' constraint is violated", $61de1ee1cac498ae$var$lue = "targetIndex=", $61de1ee1cac498ae$var$mue = ", size=", $61de1ee1cac498ae$var$nue = "sourceIndex=", $61de1ee1cac498ae$var$oue = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1,
    67: 1,
    63: 1,
    58: 1
}, $61de1ee1cac498ae$var$pue = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    47: 1,
    15: 1,
    54: 1,
    67: 1,
    63: 1,
    58: 1,
    588: 1
}, $61de1ee1cac498ae$var$que = "logging", $61de1ee1cac498ae$var$rue = "measureExecutionTime", $61de1ee1cac498ae$var$sue = "parser.parse.1", $61de1ee1cac498ae$var$tue = "parser.parse.2", $61de1ee1cac498ae$var$uue = "parser.next.1", $61de1ee1cac498ae$var$vue = "parser.next.2", $61de1ee1cac498ae$var$wue = "parser.next.3", $61de1ee1cac498ae$var$xue = "parser.next.4", $61de1ee1cac498ae$var$yue = "parser.factor.1", $61de1ee1cac498ae$var$zue = "parser.factor.2", $61de1ee1cac498ae$var$Aue = "parser.factor.3", $61de1ee1cac498ae$var$Bue = "parser.factor.4", $61de1ee1cac498ae$var$Cue = "parser.factor.5", $61de1ee1cac498ae$var$Due = "parser.factor.6", $61de1ee1cac498ae$var$Eue = "parser.atom.1", $61de1ee1cac498ae$var$Fue = "parser.atom.2", $61de1ee1cac498ae$var$Gue = "parser.atom.3", $61de1ee1cac498ae$var$Hue = "parser.atom.4", $61de1ee1cac498ae$var$Iue = "parser.atom.5", $61de1ee1cac498ae$var$Jue = "parser.cc.1", $61de1ee1cac498ae$var$Kue = "parser.cc.2", $61de1ee1cac498ae$var$Lue = "parser.cc.3", $61de1ee1cac498ae$var$Mue = "parser.cc.5", $61de1ee1cac498ae$var$Nue = "parser.cc.6", $61de1ee1cac498ae$var$Oue = "parser.cc.7", $61de1ee1cac498ae$var$Pue = "parser.cc.8", $61de1ee1cac498ae$var$Que = "parser.ope.1", $61de1ee1cac498ae$var$Rue = "parser.ope.2", $61de1ee1cac498ae$var$Sue = "parser.ope.3", $61de1ee1cac498ae$var$Tue = "parser.descape.1", $61de1ee1cac498ae$var$Uue = "parser.descape.2", $61de1ee1cac498ae$var$Vue = "parser.descape.3", $61de1ee1cac498ae$var$Wue = "parser.descape.4", $61de1ee1cac498ae$var$Xue = "parser.descape.5", $61de1ee1cac498ae$var$Yue = "parser.process.1", $61de1ee1cac498ae$var$Zue = "parser.quantifier.1", $61de1ee1cac498ae$var$$ue = "parser.quantifier.2", $61de1ee1cac498ae$var$_ue = "parser.quantifier.3", $61de1ee1cac498ae$var$ave = "parser.quantifier.4", $61de1ee1cac498ae$var$bve = "parser.quantifier.5", $61de1ee1cac498ae$var$cve = "org.eclipse.emf.common.notify", $61de1ee1cac498ae$var$dve = {
    415: 1,
    672: 1
}, $61de1ee1cac498ae$var$eve = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    67: 1,
    58: 1
}, $61de1ee1cac498ae$var$fve = {
    366: 1,
    143: 1
}, $61de1ee1cac498ae$var$gve = "index=", $61de1ee1cac498ae$var$hve = {
    3: 1,
    4: 1,
    5: 1,
    126: 1
}, $61de1ee1cac498ae$var$ive = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1,
    67: 1,
    58: 1
}, $61de1ee1cac498ae$var$jve = {
    3: 1,
    6: 1,
    4: 1,
    5: 1,
    192: 1
}, $61de1ee1cac498ae$var$kve = {
    3: 1,
    4: 1,
    5: 1,
    165: 1,
    367: 1
}, $61de1ee1cac498ae$var$lve = ";/?:@&=+$,", $61de1ee1cac498ae$var$mve = "invalid authority: ", $61de1ee1cac498ae$var$nve = "EAnnotation", $61de1ee1cac498ae$var$ove = "ETypedElement", $61de1ee1cac498ae$var$pve = "EStructuralFeature", $61de1ee1cac498ae$var$qve = "EAttribute", $61de1ee1cac498ae$var$rve = "EClassifier", $61de1ee1cac498ae$var$sve = "EEnumLiteral", $61de1ee1cac498ae$var$tve = "EGenericType", $61de1ee1cac498ae$var$uve = "EOperation", $61de1ee1cac498ae$var$vve = "EParameter", $61de1ee1cac498ae$var$wve = "EReference", $61de1ee1cac498ae$var$xve = "ETypeParameter", $61de1ee1cac498ae$var$yve = "org.eclipse.emf.ecore.util", $61de1ee1cac498ae$var$zve = {
    76: 1
}, $61de1ee1cac498ae$var$Ave = {
    3: 1,
    20: 1,
    14: 1,
    15: 1,
    58: 1,
    589: 1,
    76: 1,
    69: 1,
    95: 1
}, $61de1ee1cac498ae$var$Bve = "org.eclipse.emf.ecore.util.FeatureMap$Entry", $61de1ee1cac498ae$var$Cve = 8192, $61de1ee1cac498ae$var$Dve = 2048, $61de1ee1cac498ae$var$Eve = "byte", $61de1ee1cac498ae$var$Fve = "char", $61de1ee1cac498ae$var$Gve = "double", $61de1ee1cac498ae$var$Hve = "float", $61de1ee1cac498ae$var$Ive = "int", $61de1ee1cac498ae$var$Jve = "long", $61de1ee1cac498ae$var$Kve = "short", $61de1ee1cac498ae$var$Lve = "java.lang.Object", $61de1ee1cac498ae$var$Mve = {
    3: 1,
    4: 1,
    5: 1,
    247: 1
}, $61de1ee1cac498ae$var$Nve = {
    3: 1,
    4: 1,
    5: 1,
    673: 1
}, $61de1ee1cac498ae$var$Ove = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1,
    67: 1,
    63: 1,
    58: 1,
    69: 1
}, $61de1ee1cac498ae$var$Pve = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1,
    67: 1,
    63: 1,
    58: 1,
    76: 1,
    69: 1,
    95: 1
}, $61de1ee1cac498ae$var$Qve = "mixed", $61de1ee1cac498ae$var$Rve = "http:///org/eclipse/emf/ecore/util/ExtendedMetaData", $61de1ee1cac498ae$var$Sve = "kind", $61de1ee1cac498ae$var$Tve = {
    3: 1,
    4: 1,
    5: 1,
    674: 1
}, $61de1ee1cac498ae$var$Uve = {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    67: 1,
    58: 1,
    76: 1,
    69: 1,
    95: 1
}, $61de1ee1cac498ae$var$Vve = {
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    58: 1,
    69: 1
}, $61de1ee1cac498ae$var$Wve = {
    47: 1,
    125: 1,
    279: 1
}, $61de1ee1cac498ae$var$Xve = {
    72: 1,
    332: 1
}, $61de1ee1cac498ae$var$Yve = "The value of type '", $61de1ee1cac498ae$var$Zve = "' must be of type '", $61de1ee1cac498ae$var$$ve = 1316, $61de1ee1cac498ae$var$_ve = "http://www.eclipse.org/emf/2002/Ecore", $61de1ee1cac498ae$var$awe = -32768, $61de1ee1cac498ae$var$bwe = "constraints", $61de1ee1cac498ae$var$cwe = "baseType", $61de1ee1cac498ae$var$dwe = "getEStructuralFeature", $61de1ee1cac498ae$var$ewe = "getFeatureID", $61de1ee1cac498ae$var$fwe = "feature", $61de1ee1cac498ae$var$gwe = "getOperationID", $61de1ee1cac498ae$var$hwe = "operation", $61de1ee1cac498ae$var$iwe = "defaultValue", $61de1ee1cac498ae$var$jwe = "eTypeParameters", $61de1ee1cac498ae$var$kwe = "isInstance", $61de1ee1cac498ae$var$lwe = "getEEnumLiteral", $61de1ee1cac498ae$var$mwe = "eContainingClass", $61de1ee1cac498ae$var$nwe = {
    55: 1
}, $61de1ee1cac498ae$var$owe = {
    3: 1,
    4: 1,
    5: 1,
    119: 1
}, $61de1ee1cac498ae$var$pwe = "org.eclipse.emf.ecore.resource", $61de1ee1cac498ae$var$qwe = {
    92: 1,
    90: 1,
    591: 1,
    1935: 1
}, $61de1ee1cac498ae$var$rwe = "org.eclipse.emf.ecore.resource.impl", $61de1ee1cac498ae$var$swe = "unspecified", $61de1ee1cac498ae$var$twe = "simple", $61de1ee1cac498ae$var$uwe = "attribute", $61de1ee1cac498ae$var$vwe = "attributeWildcard", $61de1ee1cac498ae$var$wwe = "element", $61de1ee1cac498ae$var$xwe = "elementWildcard", $61de1ee1cac498ae$var$ywe = "collapse", $61de1ee1cac498ae$var$zwe = "itemType", $61de1ee1cac498ae$var$Awe = "namespace", $61de1ee1cac498ae$var$Bwe = "##targetNamespace", $61de1ee1cac498ae$var$Cwe = "whiteSpace", $61de1ee1cac498ae$var$Dwe = "wildcards", $61de1ee1cac498ae$var$Ewe = "http://www.eclipse.org/emf/2003/XMLType", $61de1ee1cac498ae$var$Fwe = "##any", $61de1ee1cac498ae$var$Gwe = "uninitialized", $61de1ee1cac498ae$var$Hwe = "The multiplicity constraint is violated", $61de1ee1cac498ae$var$Iwe = "org.eclipse.emf.ecore.xml.type", $61de1ee1cac498ae$var$Jwe = "ProcessingInstruction", $61de1ee1cac498ae$var$Kwe = "SimpleAnyType", $61de1ee1cac498ae$var$Lwe = "XMLTypeDocumentRoot", $61de1ee1cac498ae$var$Mwe = "org.eclipse.emf.ecore.xml.type.impl", $61de1ee1cac498ae$var$Nwe = "INF", $61de1ee1cac498ae$var$Owe = "processing", $61de1ee1cac498ae$var$Pwe = "ENTITIES_._base", $61de1ee1cac498ae$var$Qwe = "minLength", $61de1ee1cac498ae$var$Rwe = "ENTITY", $61de1ee1cac498ae$var$Swe = "NCName", $61de1ee1cac498ae$var$Twe = "IDREFS_._base", $61de1ee1cac498ae$var$Uwe = "integer", $61de1ee1cac498ae$var$Vwe = "token", $61de1ee1cac498ae$var$Wwe = "pattern", $61de1ee1cac498ae$var$Xwe = "[a-zA-Z]{1,8}(-[a-zA-Z0-9]{1,8})*", $61de1ee1cac498ae$var$Ywe = "\\i\\c*", $61de1ee1cac498ae$var$Zwe = "[\\i-[:]][\\c-[:]]*", $61de1ee1cac498ae$var$$we = "nonPositiveInteger", $61de1ee1cac498ae$var$_we = "maxInclusive", $61de1ee1cac498ae$var$axe = "NMTOKEN", $61de1ee1cac498ae$var$bxe = "NMTOKENS_._base", $61de1ee1cac498ae$var$cxe = "nonNegativeInteger", $61de1ee1cac498ae$var$dxe = "minInclusive", $61de1ee1cac498ae$var$exe = "normalizedString", $61de1ee1cac498ae$var$fxe = "unsignedByte", $61de1ee1cac498ae$var$gxe = "unsignedInt", $61de1ee1cac498ae$var$hxe = "18446744073709551615", $61de1ee1cac498ae$var$ixe = "unsignedShort", $61de1ee1cac498ae$var$jxe = "processingInstruction", $61de1ee1cac498ae$var$kxe = "org.eclipse.emf.ecore.xml.type.internal", $61de1ee1cac498ae$var$lxe = 1114111, $61de1ee1cac498ae$var$mxe = "Internal Error: shorthands: \\u", $61de1ee1cac498ae$var$nxe = "xml:isDigit", $61de1ee1cac498ae$var$oxe = "xml:isWord", $61de1ee1cac498ae$var$pxe = "xml:isSpace", $61de1ee1cac498ae$var$qxe = "xml:isNameChar", $61de1ee1cac498ae$var$rxe = "xml:isInitialNameChar", $61de1ee1cac498ae$var$sxe = "09\u0660\u0669\u06F0\u06F9\u0966\u096F\u09E6\u09EF\u0A66\u0A6F\u0AE6\u0AEF\u0B66\u0B6F\u0BE7\u0BEF\u0C66\u0C6F\u0CE6\u0CEF\u0D66\u0D6F\u0E50\u0E59\u0ED0\u0ED9\u0F20\u0F29", $61de1ee1cac498ae$var$txe = "AZaz\xc0\xd6\xd8\xf6\xf8\u0131\u0134\u013E\u0141\u0148\u014A\u017E\u0180\u01C3\u01CD\u01F0\u01F4\u01F5\u01FA\u0217\u0250\u02A8\u02BB\u02C1\u0386\u0386\u0388\u038A\u038C\u038C\u038E\u03A1\u03A3\u03CE\u03D0\u03D6\u03DA\u03DA\u03DC\u03DC\u03DE\u03DE\u03E0\u03E0\u03E2\u03F3\u0401\u040C\u040E\u044F\u0451\u045C\u045E\u0481\u0490\u04C4\u04C7\u04C8\u04CB\u04CC\u04D0\u04EB\u04EE\u04F5\u04F8\u04F9\u0531\u0556\u0559\u0559\u0561\u0586\u05D0\u05EA\u05F0\u05F2\u0621\u063A\u0641\u064A\u0671\u06B7\u06BA\u06BE\u06C0\u06CE\u06D0\u06D3\u06D5\u06D5\u06E5\u06E6\u0905\u0939\u093D\u093D\u0958\u0961\u0985\u098C\u098F\u0990\u0993\u09A8\u09AA\u09B0\u09B2\u09B2\u09B6\u09B9\u09DC\u09DD\u09DF\u09E1\u09F0\u09F1\u0A05\u0A0A\u0A0F\u0A10\u0A13\u0A28\u0A2A\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59\u0A5C\u0A5E\u0A5E\u0A72\u0A74\u0A85\u0A8B\u0A8D\u0A8D\u0A8F\u0A91\u0A93\u0AA8\u0AAA\u0AB0\u0AB2\u0AB3\u0AB5\u0AB9\u0ABD\u0ABD\u0AE0\u0AE0\u0B05\u0B0C\u0B0F\u0B10\u0B13\u0B28\u0B2A\u0B30\u0B32\u0B33\u0B36\u0B39\u0B3D\u0B3D\u0B5C\u0B5D\u0B5F\u0B61\u0B85\u0B8A\u0B8E\u0B90\u0B92\u0B95\u0B99\u0B9A\u0B9C\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8\u0BAA\u0BAE\u0BB5\u0BB7\u0BB9\u0C05\u0C0C\u0C0E\u0C10\u0C12\u0C28\u0C2A\u0C33\u0C35\u0C39\u0C60\u0C61\u0C85\u0C8C\u0C8E\u0C90\u0C92\u0CA8\u0CAA\u0CB3\u0CB5\u0CB9\u0CDE\u0CDE\u0CE0\u0CE1\u0D05\u0D0C\u0D0E\u0D10\u0D12\u0D28\u0D2A\u0D39\u0D60\u0D61\u0E01\u0E2E\u0E30\u0E30\u0E32\u0E33\u0E40\u0E45\u0E81\u0E82\u0E84\u0E84\u0E87\u0E88\u0E8A\u0E8A\u0E8D\u0E8D\u0E94\u0E97\u0E99\u0E9F\u0EA1\u0EA3\u0EA5\u0EA5\u0EA7\u0EA7\u0EAA\u0EAB\u0EAD\u0EAE\u0EB0\u0EB0\u0EB2\u0EB3\u0EBD\u0EBD\u0EC0\u0EC4\u0F40\u0F47\u0F49\u0F69\u10A0\u10C5\u10D0\u10F6\u1100\u1100\u1102\u1103\u1105\u1107\u1109\u1109\u110B\u110C\u110E\u1112\u113C\u113C\u113E\u113E\u1140\u1140\u114C\u114C\u114E\u114E\u1150\u1150\u1154\u1155\u1159\u1159\u115F\u1161\u1163\u1163\u1165\u1165\u1167\u1167\u1169\u1169\u116D\u116E\u1172\u1173\u1175\u1175\u119E\u119E\u11A8\u11A8\u11AB\u11AB\u11AE\u11AF\u11B7\u11B8\u11BA\u11BA\u11BC\u11C2\u11EB\u11EB\u11F0\u11F0\u11F9\u11F9\u1E00\u1E9B\u1EA0\u1EF9\u1F00\u1F15\u1F18\u1F1D\u1F20\u1F45\u1F48\u1F4D\u1F50\u1F57\u1F59\u1F59\u1F5B\u1F5B\u1F5D\u1F5D\u1F5F\u1F7D\u1F80\u1FB4\u1FB6\u1FBC\u1FBE\u1FBE\u1FC2\u1FC4\u1FC6\u1FCC\u1FD0\u1FD3\u1FD6\u1FDB\u1FE0\u1FEC\u1FF2\u1FF4\u1FF6\u1FFC\u2126\u2126\u212A\u212B\u212E\u212E\u2180\u2182\u3007\u3007\u3021\u3029\u3041\u3094\u30A1\u30FA\u3105\u312C\u4E00\u9FA5\uAC00\uD7A3", $61de1ee1cac498ae$var$uxe = "Private Use", $61de1ee1cac498ae$var$vxe = "ASSIGNED", $61de1ee1cac498ae$var$wxe = "\0\x7f\x80\xff\u0100\u017F\u0180\u024F\u0250\u02AF\u02B0\u02FF\u0300\u036F\u0370\u03FF\u0400\u04FF\u0530\u058F\u0590\u05FF\u0600\u06FF\u0700\u074F\u0780\u07BF\u0900\u097F\u0980\u09FF\u0A00\u0A7F\u0A80\u0AFF\u0B00\u0B7F\u0B80\u0BFF\u0C00\u0C7F\u0C80\u0CFF\u0D00\u0D7F\u0D80\u0DFF\u0E00\u0E7F\u0E80\u0EFF\u0F00\u0FFF\u1000\u109F\u10A0\u10FF\u1100\u11FF\u1200\u137F\u13A0\u13FF\u1400\u167F\u1680\u169F\u16A0\u16FF\u1780\u17FF\u1800\u18AF\u1E00\u1EFF\u1F00\u1FFF\u2000\u206F\u2070\u209F\u20A0\u20CF\u20D0\u20FF\u2100\u214F\u2150\u218F\u2190\u21FF\u2200\u22FF\u2300\u23FF\u2400\u243F\u2440\u245F\u2460\u24FF\u2500\u257F\u2580\u259F\u25A0\u25FF\u2600\u26FF\u2700\u27BF\u2800\u28FF\u2E80\u2EFF\u2F00\u2FDF\u2FF0\u2FFF\u3000\u303F\u3040\u309F\u30A0\u30FF\u3100\u312F\u3130\u318F\u3190\u319F\u31A0\u31BF\u3200\u32FF\u3300\u33FF\u3400\u4DB5\u4E00\u9FFF\uA000\uA48F\uA490\uA4CF\uAC00\uD7A3\uE000\uF8FF\uF900\uFAFF\uFB00\uFB4F\uFB50\uFDFF\uFE20\uFE2F\uFE30\uFE4F\uFE50\uFE6F\uFE70\uFEFE\uFEFF\uFEFF\uFF00\uFFEF", $61de1ee1cac498ae$var$xxe = "UNASSIGNED", $61de1ee1cac498ae$var$yxe = {
    3: 1,
    117: 1
}, $61de1ee1cac498ae$var$zxe = "org.eclipse.emf.ecore.xml.type.util", $61de1ee1cac498ae$var$Axe = {
    3: 1,
    4: 1,
    5: 1,
    368: 1
}, $61de1ee1cac498ae$var$Bxe = "org.eclipse.xtext.xbase.lib", $61de1ee1cac498ae$var$Cxe = "Cannot add elements to a Range", $61de1ee1cac498ae$var$Dxe = "Cannot set elements in a Range", $61de1ee1cac498ae$var$Exe = "Cannot remove elements from a Range", $61de1ee1cac498ae$var$Fxe = "locale", $61de1ee1cac498ae$var$Gxe = "default", $61de1ee1cac498ae$var$Hxe = "user.agent";
var $61de1ee1cac498ae$var$_, $61de1ee1cac498ae$var$_bb, $61de1ee1cac498ae$var$Wbb, $61de1ee1cac498ae$var$tbb = -1;
$61de1ee1cac498ae$var$$wnd.goog = $61de1ee1cac498ae$var$$wnd.goog || {};
$61de1ee1cac498ae$var$$wnd.goog.global = $61de1ee1cac498ae$var$$wnd.goog.global || $61de1ee1cac498ae$var$$wnd;
$61de1ee1cac498ae$var$acb();
$61de1ee1cac498ae$var$bcb(1, null, {}, $61de1ee1cac498ae$var$nb);
$61de1ee1cac498ae$var$_.Fb = function ob(a) {
    return $61de1ee1cac498ae$var$mb(this, a);
};
$61de1ee1cac498ae$var$_.Gb = function qb() {
    return this.gm;
};
$61de1ee1cac498ae$var$_.Hb = function sb() {
    return $61de1ee1cac498ae$var$FCb(this);
};
$61de1ee1cac498ae$var$_.Ib = function ub() {
    var a;
    return $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$rb(this)) + "@" + (a = $61de1ee1cac498ae$var$tb(this) >>> 0, a.toString(16));
};
$61de1ee1cac498ae$var$_.equals = function(a) {
    return this.Fb(a);
};
$61de1ee1cac498ae$var$_.hashCode = function() {
    return this.Hb();
};
$61de1ee1cac498ae$var$_.toString = function() {
    return this.Ib();
};
var $61de1ee1cac498ae$var$xD, $61de1ee1cac498ae$var$yD, $61de1ee1cac498ae$var$zD;
$61de1ee1cac498ae$var$bcb(290, 1, {
    290: 1,
    2026: 1
}, $61de1ee1cac498ae$var$jdb);
$61de1ee1cac498ae$var$_.le = function kdb(a) {
    var b;
    b = new $61de1ee1cac498ae$var$jdb;
    b.i = 4;
    a > 1 ? b.c = $61de1ee1cac498ae$var$rdb(this, a - 1) : b.c = this;
    return b;
};
$61de1ee1cac498ae$var$_.me = function qdb() {
    $61de1ee1cac498ae$var$fdb(this);
    return this.b;
};
$61de1ee1cac498ae$var$_.ne = function sdb() {
    return $61de1ee1cac498ae$var$hdb(this);
};
$61de1ee1cac498ae$var$_.oe = function udb() {
    return $61de1ee1cac498ae$var$fdb(this), this.k;
};
$61de1ee1cac498ae$var$_.pe = function wdb() {
    return (this.i & 4) != 0;
};
$61de1ee1cac498ae$var$_.qe = function xdb() {
    return (this.i & 1) != 0;
};
$61de1ee1cac498ae$var$_.Ib = function Adb() {
    return $61de1ee1cac498ae$var$idb(this);
};
$61de1ee1cac498ae$var$_.i = 0;
var $61de1ee1cac498ae$var$edb = 1;
var $61de1ee1cac498ae$var$SI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Object", 1);
var $61de1ee1cac498ae$var$AI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Class", 290);
$61de1ee1cac498ae$var$bcb(1998, 1, $61de1ee1cac498ae$var$Qhe);
var $61de1ee1cac498ae$var$$D = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rhe, "Optional", 1998);
$61de1ee1cac498ae$var$bcb(1170, 1998, $61de1ee1cac498ae$var$Qhe, $61de1ee1cac498ae$var$xb);
$61de1ee1cac498ae$var$_.Fb = function yb(a) {
    return a === this;
};
$61de1ee1cac498ae$var$_.Hb = function zb() {
    return 2040732332;
};
$61de1ee1cac498ae$var$_.Ib = function Ab() {
    return "Optional.absent()";
};
$61de1ee1cac498ae$var$_.Jb = function Bb(a) {
    $61de1ee1cac498ae$var$Qb(a);
    return $61de1ee1cac498ae$var$wb(), $61de1ee1cac498ae$var$vb;
};
var $61de1ee1cac498ae$var$vb;
var $61de1ee1cac498ae$var$YD = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rhe, "Absent", 1170);
$61de1ee1cac498ae$var$bcb(628, 1, {}, $61de1ee1cac498ae$var$Gb);
var $61de1ee1cac498ae$var$ZD = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rhe, "Joiner", 628);
var $61de1ee1cac498ae$var$_D = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Rhe, "Predicate");
$61de1ee1cac498ae$var$bcb(582, 1, {
    169: 1,
    582: 1,
    3: 1,
    45: 1
}, $61de1ee1cac498ae$var$Yb);
$61de1ee1cac498ae$var$_.Mb = function ac(a) {
    return $61de1ee1cac498ae$var$Xb(this, a);
};
$61de1ee1cac498ae$var$_.Lb = function Zb(a) {
    return $61de1ee1cac498ae$var$Xb(this, a);
};
$61de1ee1cac498ae$var$_.Fb = function $b(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 582)) {
        b = $61de1ee1cac498ae$var$BD(a, 582);
        return $61de1ee1cac498ae$var$At(this.a, b.a);
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function _b() {
    return $61de1ee1cac498ae$var$qmb(this.a) + 306654252;
};
$61de1ee1cac498ae$var$_.Ib = function bc() {
    return $61de1ee1cac498ae$var$Wb(this.a);
};
var $61de1ee1cac498ae$var$aE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rhe, "Predicates/AndPredicate", 582);
$61de1ee1cac498ae$var$bcb(408, 1998, {
    408: 1,
    3: 1
}, $61de1ee1cac498ae$var$cc);
$61de1ee1cac498ae$var$_.Fb = function dc(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 408)) {
        b = $61de1ee1cac498ae$var$BD(a, 408);
        return $61de1ee1cac498ae$var$pb(this.a, b.a);
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function ec() {
    return 1502476572 + $61de1ee1cac498ae$var$tb(this.a);
};
$61de1ee1cac498ae$var$_.Ib = function fc() {
    return $61de1ee1cac498ae$var$Whe + this.a + ")";
};
$61de1ee1cac498ae$var$_.Jb = function gc(a) {
    return new $61de1ee1cac498ae$var$cc($61de1ee1cac498ae$var$Rb(a.Kb(this.a), "the Function passed to Optional.transform() must not return null."));
};
var $61de1ee1cac498ae$var$bE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rhe, "Present", 408);
$61de1ee1cac498ae$var$bcb(198, 1, $61de1ee1cac498ae$var$Yhe);
$61de1ee1cac498ae$var$_.Nb = function kc(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Qb = function lc() {
    $61de1ee1cac498ae$var$jc();
};
var $61de1ee1cac498ae$var$MH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "UnmodifiableIterator", 198);
$61de1ee1cac498ae$var$bcb(1978, 198, $61de1ee1cac498ae$var$$he);
$61de1ee1cac498ae$var$_.Qb = function nc() {
    $61de1ee1cac498ae$var$jc();
};
$61de1ee1cac498ae$var$_.Rb = function mc(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wb = function oc(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$NH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "UnmodifiableListIterator", 1978);
$61de1ee1cac498ae$var$bcb(386, 1978, $61de1ee1cac498ae$var$$he);
$61de1ee1cac498ae$var$_.Ob = function rc() {
    return this.c < this.d;
};
$61de1ee1cac498ae$var$_.Sb = function sc() {
    return this.c > 0;
};
$61de1ee1cac498ae$var$_.Pb = function tc() {
    if (this.c >= this.d) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    return this.Xb(this.c++);
};
$61de1ee1cac498ae$var$_.Tb = function uc() {
    return this.c;
};
$61de1ee1cac498ae$var$_.Ub = function vc() {
    if (this.c <= 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    return this.Xb(--this.c);
};
$61de1ee1cac498ae$var$_.Vb = function wc() {
    return this.c - 1;
};
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$cE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractIndexedListIterator", 386);
$61de1ee1cac498ae$var$bcb(699, 198, $61de1ee1cac498ae$var$Yhe);
$61de1ee1cac498ae$var$_.Ob = function Ac() {
    return $61de1ee1cac498ae$var$xc(this);
};
$61de1ee1cac498ae$var$_.Pb = function Bc() {
    return $61de1ee1cac498ae$var$yc(this);
};
$61de1ee1cac498ae$var$_.e = 1;
var $61de1ee1cac498ae$var$dE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractIterator", 699);
$61de1ee1cac498ae$var$bcb(1986, 1, {
    224: 1
});
$61de1ee1cac498ae$var$_.Zb = function Hc() {
    var a;
    return a = this.f, !a ? this.f = this.ac() : a;
};
$61de1ee1cac498ae$var$_.Fb = function Ic(a) {
    return $61de1ee1cac498ae$var$hw(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Jc() {
    return $61de1ee1cac498ae$var$tb(this.Zb());
};
$61de1ee1cac498ae$var$_.dc = function Kc() {
    return this.gc() == 0;
};
$61de1ee1cac498ae$var$_.ec = function Lc() {
    return $61de1ee1cac498ae$var$Ec(this);
};
$61de1ee1cac498ae$var$_.Ib = function Mc() {
    return $61de1ee1cac498ae$var$fcb(this.Zb());
};
var $61de1ee1cac498ae$var$IE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMultimap", 1986);
$61de1ee1cac498ae$var$bcb(726, 1986, $61de1ee1cac498ae$var$_he);
$61de1ee1cac498ae$var$_.$b = function Xc() {
    $61de1ee1cac498ae$var$Nc(this);
};
$61de1ee1cac498ae$var$_._b = function Yc(a) {
    return $61de1ee1cac498ae$var$Oc(this, a);
};
$61de1ee1cac498ae$var$_.ac = function Zc() {
    return new $61de1ee1cac498ae$var$ne(this, this.c);
};
$61de1ee1cac498ae$var$_.ic = function $c(a) {
    return this.hc();
};
$61de1ee1cac498ae$var$_.bc = function _c() {
    return new $61de1ee1cac498ae$var$zf(this, this.c);
};
$61de1ee1cac498ae$var$_.jc = function ad() {
    return this.mc(this.hc());
};
$61de1ee1cac498ae$var$_.kc = function bd() {
    return new $61de1ee1cac498ae$var$Hd(this);
};
$61de1ee1cac498ae$var$_.lc = function cd() {
    return $61de1ee1cac498ae$var$Yj(this.c.vc().Nc(), new $61de1ee1cac498ae$var$$g, 64, this.d);
};
$61de1ee1cac498ae$var$_.cc = function dd(a) {
    return $61de1ee1cac498ae$var$Qc(this, a);
};
$61de1ee1cac498ae$var$_.fc = function gd(a) {
    return $61de1ee1cac498ae$var$Sc(this, a);
};
$61de1ee1cac498ae$var$_.gc = function hd() {
    return this.d;
};
$61de1ee1cac498ae$var$_.mc = function jd(a) {
    return $61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$lnb(a);
};
$61de1ee1cac498ae$var$_.nc = function kd() {
    return new $61de1ee1cac498ae$var$Dd(this);
};
$61de1ee1cac498ae$var$_.oc = function ld() {
    return $61de1ee1cac498ae$var$Yj(this.c.Cc().Nc(), new $61de1ee1cac498ae$var$Fd, 64, this.d);
};
$61de1ee1cac498ae$var$_.pc = function md(a, b) {
    return new $61de1ee1cac498ae$var$dg(this, a, b, null);
};
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$DE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap", 726);
$61de1ee1cac498ae$var$bcb(1631, 726, $61de1ee1cac498ae$var$_he);
$61de1ee1cac498ae$var$_.hc = function pd() {
    return new $61de1ee1cac498ae$var$Skb(this.a);
};
$61de1ee1cac498ae$var$_.jc = function qd() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
};
$61de1ee1cac498ae$var$_.cc = function sd(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(this, a), 15);
};
$61de1ee1cac498ae$var$_.fc = function ud(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Sc(this, a), 15);
};
$61de1ee1cac498ae$var$_.Zb = function od() {
    return $61de1ee1cac498ae$var$nd(this);
};
$61de1ee1cac498ae$var$_.Fb = function rd(a) {
    return $61de1ee1cac498ae$var$hw(this, a);
};
$61de1ee1cac498ae$var$_.qc = function td(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(this, a), 15);
};
$61de1ee1cac498ae$var$_.rc = function vd(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Sc(this, a), 15);
};
$61de1ee1cac498ae$var$_.mc = function wd(a) {
    return $61de1ee1cac498ae$var$vmb($61de1ee1cac498ae$var$BD(a, 15));
};
$61de1ee1cac498ae$var$_.pc = function xd(a, b) {
    return $61de1ee1cac498ae$var$Vc(this, a, $61de1ee1cac498ae$var$BD(b, 15), null);
};
var $61de1ee1cac498ae$var$eE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractListMultimap", 1631);
$61de1ee1cac498ae$var$bcb(732, 1, $61de1ee1cac498ae$var$aie);
$61de1ee1cac498ae$var$_.Nb = function zd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Ad() {
    return this.c.Ob() || this.e.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Bd() {
    var a;
    if (!this.e.Ob()) {
        a = $61de1ee1cac498ae$var$BD(this.c.Pb(), 42);
        this.b = a.cd();
        this.a = $61de1ee1cac498ae$var$BD(a.dd(), 14);
        this.e = this.a.Kc();
    }
    return this.sc(this.b, this.e.Pb());
};
$61de1ee1cac498ae$var$_.Qb = function Cd() {
    this.e.Qb();
    this.a.dc() && this.c.Qb();
    --this.d.d;
};
var $61de1ee1cac498ae$var$mE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/Itr", 732);
$61de1ee1cac498ae$var$bcb(1099, 732, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Dd);
$61de1ee1cac498ae$var$_.sc = function Ed(a, b) {
    return b;
};
var $61de1ee1cac498ae$var$fE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/1", 1099);
$61de1ee1cac498ae$var$bcb(1100, 1, {}, $61de1ee1cac498ae$var$Fd);
$61de1ee1cac498ae$var$_.Kb = function Gd(a) {
    return $61de1ee1cac498ae$var$BD(a, 14).Nc();
};
var $61de1ee1cac498ae$var$gE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/1methodref$spliterator$Type", 1100);
$61de1ee1cac498ae$var$bcb(1101, 732, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Hd);
$61de1ee1cac498ae$var$_.sc = function Id(a, b) {
    return new $61de1ee1cac498ae$var$Wo(a, b);
};
var $61de1ee1cac498ae$var$hE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/2", 1101);
var $61de1ee1cac498ae$var$DK = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$bie, "Map");
$61de1ee1cac498ae$var$bcb(1967, 1, $61de1ee1cac498ae$var$cie);
$61de1ee1cac498ae$var$_.wc = function Td(a) {
    $61de1ee1cac498ae$var$stb(this, a);
};
$61de1ee1cac498ae$var$_.yc = function $d(a, b, c) {
    return $61de1ee1cac498ae$var$ttb(this, a, b, c);
};
$61de1ee1cac498ae$var$_.$b = function Od() {
    this.vc().$b();
};
$61de1ee1cac498ae$var$_.tc = function Pd(a) {
    return $61de1ee1cac498ae$var$Jd(this, a);
};
$61de1ee1cac498ae$var$_._b = function Qd(a) {
    return !!$61de1ee1cac498ae$var$Kd(this, a, false);
};
$61de1ee1cac498ae$var$_.uc = function Rd(a) {
    var b, c, d;
    for(c = this.vc().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 42);
        d = b.dd();
        if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(d) || a != null && $61de1ee1cac498ae$var$pb(a, d)) return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Fb = function Sd(a) {
    var b, c, d;
    if (a === this) return true;
    if (!$61de1ee1cac498ae$var$JD(a, 83)) return false;
    d = $61de1ee1cac498ae$var$BD(a, 83);
    if (this.gc() != d.gc()) return false;
    for(c = d.vc().Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 42);
        if (!this.tc(b)) return false;
    }
    return true;
};
$61de1ee1cac498ae$var$_.xc = function Ud(a) {
    return $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$Kd(this, a, false));
};
$61de1ee1cac498ae$var$_.Hb = function Xd() {
    return $61de1ee1cac498ae$var$pmb(this.vc());
};
$61de1ee1cac498ae$var$_.dc = function Yd() {
    return this.gc() == 0;
};
$61de1ee1cac498ae$var$_.ec = function Zd() {
    return new $61de1ee1cac498ae$var$Pib(this);
};
$61de1ee1cac498ae$var$_.zc = function _d(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb("Put not supported on this map"));
};
$61de1ee1cac498ae$var$_.Ac = function ae(a) {
    $61de1ee1cac498ae$var$Ld(this, a);
};
$61de1ee1cac498ae$var$_.Bc = function be(a) {
    return $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$Kd(this, a, true));
};
$61de1ee1cac498ae$var$_.gc = function ce() {
    return this.vc().gc();
};
$61de1ee1cac498ae$var$_.Ib = function de() {
    return $61de1ee1cac498ae$var$Md(this);
};
$61de1ee1cac498ae$var$_.Cc = function ee() {
    return new $61de1ee1cac498ae$var$$ib(this);
};
var $61de1ee1cac498ae$var$sJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractMap", 1967);
$61de1ee1cac498ae$var$bcb(1987, 1967, $61de1ee1cac498ae$var$cie);
$61de1ee1cac498ae$var$_.bc = function ge() {
    return new $61de1ee1cac498ae$var$rf(this);
};
$61de1ee1cac498ae$var$_.vc = function he() {
    return $61de1ee1cac498ae$var$fe(this);
};
$61de1ee1cac498ae$var$_.ec = function ie() {
    var a;
    a = this.g;
    return !a ? this.g = this.bc() : a;
};
$61de1ee1cac498ae$var$_.Cc = function je() {
    var a;
    a = this.i;
    return !a ? this.i = new $61de1ee1cac498ae$var$Zv(this) : a;
};
var $61de1ee1cac498ae$var$bH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/ViewCachingAbstractMap", 1987);
$61de1ee1cac498ae$var$bcb(389, 1987, $61de1ee1cac498ae$var$cie, $61de1ee1cac498ae$var$ne);
$61de1ee1cac498ae$var$_.xc = function se(a) {
    return $61de1ee1cac498ae$var$ke(this, a);
};
$61de1ee1cac498ae$var$_.Bc = function ve(a) {
    return $61de1ee1cac498ae$var$le(this, a);
};
$61de1ee1cac498ae$var$_.$b = function oe() {
    this.d == this.e.c ? this.e.$b() : $61de1ee1cac498ae$var$ir(new $61de1ee1cac498ae$var$mf(this));
};
$61de1ee1cac498ae$var$_._b = function pe(a) {
    return $61de1ee1cac498ae$var$Gv(this.d, a);
};
$61de1ee1cac498ae$var$_.Ec = function qe() {
    return new $61de1ee1cac498ae$var$df(this);
};
$61de1ee1cac498ae$var$_.Dc = function() {
    return this.Ec();
};
$61de1ee1cac498ae$var$_.Fb = function re(a) {
    return this === a || $61de1ee1cac498ae$var$pb(this.d, a);
};
$61de1ee1cac498ae$var$_.Hb = function te() {
    return $61de1ee1cac498ae$var$tb(this.d);
};
$61de1ee1cac498ae$var$_.ec = function ue() {
    return this.e.ec();
};
$61de1ee1cac498ae$var$_.gc = function we() {
    return this.d.gc();
};
$61de1ee1cac498ae$var$_.Ib = function xe() {
    return $61de1ee1cac498ae$var$fcb(this.d);
};
var $61de1ee1cac498ae$var$lE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/AsMap", 389);
var $61de1ee1cac498ae$var$KI = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Phe, "Iterable");
$61de1ee1cac498ae$var$bcb(28, 1, $61de1ee1cac498ae$var$die);
$61de1ee1cac498ae$var$_.Jc = function Le(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Lc = function Ne() {
    return this.Oc();
};
$61de1ee1cac498ae$var$_.Nc = function Pe() {
    return new $61de1ee1cac498ae$var$Kub(this, 0);
};
$61de1ee1cac498ae$var$_.Oc = function Qe() {
    return new $61de1ee1cac498ae$var$YAb(null, this.Nc());
};
$61de1ee1cac498ae$var$_.Fc = function Ge(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb("Add not supported on this collection"));
};
$61de1ee1cac498ae$var$_.Gc = function He(a) {
    return $61de1ee1cac498ae$var$ye(this, a);
};
$61de1ee1cac498ae$var$_.$b = function Ie() {
    $61de1ee1cac498ae$var$Ae(this);
};
$61de1ee1cac498ae$var$_.Hc = function Je(a) {
    return $61de1ee1cac498ae$var$ze(this, a, false);
};
$61de1ee1cac498ae$var$_.Ic = function Ke(a) {
    return $61de1ee1cac498ae$var$Be(this, a);
};
$61de1ee1cac498ae$var$_.dc = function Me() {
    return this.gc() == 0;
};
$61de1ee1cac498ae$var$_.Mc = function Oe(a) {
    return $61de1ee1cac498ae$var$ze(this, a, true);
};
$61de1ee1cac498ae$var$_.Pc = function Re() {
    return $61de1ee1cac498ae$var$De(this);
};
$61de1ee1cac498ae$var$_.Qc = function Se(a) {
    return $61de1ee1cac498ae$var$Ee(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function Te() {
    return $61de1ee1cac498ae$var$Fe(this);
};
var $61de1ee1cac498ae$var$dJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractCollection", 28);
var $61de1ee1cac498ae$var$LK = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$bie, "Set");
$61de1ee1cac498ae$var$bcb($61de1ee1cac498ae$var$eie, 28, $61de1ee1cac498ae$var$fie);
$61de1ee1cac498ae$var$_.Nc = function Ye() {
    return new $61de1ee1cac498ae$var$Kub(this, 1);
};
$61de1ee1cac498ae$var$_.Fb = function We(a) {
    return $61de1ee1cac498ae$var$Ue(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Xe() {
    return $61de1ee1cac498ae$var$pmb(this);
};
var $61de1ee1cac498ae$var$zJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractSet", $61de1ee1cac498ae$var$eie);
$61de1ee1cac498ae$var$bcb(1970, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie);
var $61de1ee1cac498ae$var$BH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Sets/ImprovedAbstractSet", 1970);
$61de1ee1cac498ae$var$bcb(1971, 1970, $61de1ee1cac498ae$var$fie);
$61de1ee1cac498ae$var$_.$b = function $e() {
    this.Rc().$b();
};
$61de1ee1cac498ae$var$_.Hc = function _e(a) {
    return $61de1ee1cac498ae$var$Ze(this, a);
};
$61de1ee1cac498ae$var$_.dc = function af() {
    return this.Rc().dc();
};
$61de1ee1cac498ae$var$_.Mc = function bf(a) {
    var b;
    if (this.Hc(a)) {
        b = $61de1ee1cac498ae$var$BD(a, 42);
        return this.Rc().ec().Mc(b.cd());
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function cf() {
    return this.Rc().gc();
};
var $61de1ee1cac498ae$var$WG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/EntrySet", 1971);
$61de1ee1cac498ae$var$bcb(1097, 1971, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$df);
$61de1ee1cac498ae$var$_.Hc = function ef(a) {
    return $61de1ee1cac498ae$var$Ck(this.a.d.vc(), a);
};
$61de1ee1cac498ae$var$_.Kc = function ff() {
    return new $61de1ee1cac498ae$var$mf(this.a);
};
$61de1ee1cac498ae$var$_.Rc = function gf() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Mc = function hf(a) {
    var b;
    if (!$61de1ee1cac498ae$var$Ck(this.a.d.vc(), a)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 42);
    $61de1ee1cac498ae$var$Tc(this.a.e, b.cd());
    return true;
};
$61de1ee1cac498ae$var$_.Nc = function jf() {
    return $61de1ee1cac498ae$var$$j(this.a.d.vc().Nc(), new $61de1ee1cac498ae$var$kf(this.a));
};
var $61de1ee1cac498ae$var$jE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/AsMap/AsMapEntries", 1097);
$61de1ee1cac498ae$var$bcb(1098, 1, {}, $61de1ee1cac498ae$var$kf);
$61de1ee1cac498ae$var$_.Kb = function lf(a) {
    return $61de1ee1cac498ae$var$me(this.a, $61de1ee1cac498ae$var$BD(a, 42));
};
var $61de1ee1cac498ae$var$iE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/AsMap/AsMapEntries/0methodref$wrapEntry$Type", 1098);
$61de1ee1cac498ae$var$bcb(730, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$mf);
$61de1ee1cac498ae$var$_.Nb = function nf(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function pf() {
    var a;
    return a = $61de1ee1cac498ae$var$BD(this.b.Pb(), 42), this.a = $61de1ee1cac498ae$var$BD(a.dd(), 14), $61de1ee1cac498ae$var$me(this.c, a);
};
$61de1ee1cac498ae$var$_.Ob = function of() {
    return this.b.Ob();
};
$61de1ee1cac498ae$var$_.Qb = function qf() {
    $61de1ee1cac498ae$var$Vb(!!this.a);
    this.b.Qb();
    this.c.e.d -= this.a.gc();
    this.a.$b();
    this.a = null;
};
var $61de1ee1cac498ae$var$kE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/AsMap/AsMapIterator", 730);
$61de1ee1cac498ae$var$bcb(532, 1970, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$rf);
$61de1ee1cac498ae$var$_.$b = function sf() {
    this.b.$b();
};
$61de1ee1cac498ae$var$_.Hc = function tf(a) {
    return this.b._b(a);
};
$61de1ee1cac498ae$var$_.Jc = function uf(a) {
    $61de1ee1cac498ae$var$Qb(a);
    this.b.wc(new $61de1ee1cac498ae$var$Xv(a));
};
$61de1ee1cac498ae$var$_.dc = function vf() {
    return this.b.dc();
};
$61de1ee1cac498ae$var$_.Kc = function wf() {
    return new $61de1ee1cac498ae$var$Mv(this.b.vc().Kc());
};
$61de1ee1cac498ae$var$_.Mc = function xf(a) {
    if (this.b._b(a)) {
        this.b.Bc(a);
        return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function yf() {
    return this.b.gc();
};
var $61de1ee1cac498ae$var$$G = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/KeySet", 532);
$61de1ee1cac498ae$var$bcb(318, 532, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$zf);
$61de1ee1cac498ae$var$_.$b = function Af() {
    var a;
    $61de1ee1cac498ae$var$ir((a = this.b.vc().Kc(), new $61de1ee1cac498ae$var$Hf(this, a)));
};
$61de1ee1cac498ae$var$_.Ic = function Bf(a) {
    return this.b.ec().Ic(a);
};
$61de1ee1cac498ae$var$_.Fb = function Cf(a) {
    return this === a || $61de1ee1cac498ae$var$pb(this.b.ec(), a);
};
$61de1ee1cac498ae$var$_.Hb = function Df() {
    return $61de1ee1cac498ae$var$tb(this.b.ec());
};
$61de1ee1cac498ae$var$_.Kc = function Ef() {
    var a;
    return a = this.b.vc().Kc(), new $61de1ee1cac498ae$var$Hf(this, a);
};
$61de1ee1cac498ae$var$_.Mc = function Ff(a) {
    var b, c;
    c = 0;
    b = $61de1ee1cac498ae$var$BD(this.b.Bc(a), 14);
    if (b) {
        c = b.gc();
        b.$b();
        this.a.d -= c;
    }
    return c > 0;
};
$61de1ee1cac498ae$var$_.Nc = function Gf() {
    return this.b.ec().Nc();
};
var $61de1ee1cac498ae$var$oE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/KeySet", 318);
$61de1ee1cac498ae$var$bcb(731, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Hf);
$61de1ee1cac498ae$var$_.Nb = function If(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Jf() {
    return this.c.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Kf() {
    this.a = $61de1ee1cac498ae$var$BD(this.c.Pb(), 42);
    return this.a.cd();
};
$61de1ee1cac498ae$var$_.Qb = function Lf() {
    var a;
    $61de1ee1cac498ae$var$Vb(!!this.a);
    a = $61de1ee1cac498ae$var$BD(this.a.dd(), 14);
    this.c.Qb();
    this.b.a.d -= a.gc();
    a.$b();
    this.a = null;
};
var $61de1ee1cac498ae$var$nE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/KeySet/1", 731);
$61de1ee1cac498ae$var$bcb(491, 389, {
    83: 1,
    161: 1
}, $61de1ee1cac498ae$var$Mf);
$61de1ee1cac498ae$var$_.bc = function Nf() {
    return this.Sc();
};
$61de1ee1cac498ae$var$_.ec = function Pf() {
    return this.Tc();
};
$61de1ee1cac498ae$var$_.Sc = function Of() {
    return new $61de1ee1cac498ae$var$Yf(this.c, this.Uc());
};
$61de1ee1cac498ae$var$_.Tc = function Qf() {
    var a;
    return a = this.b, !a ? this.b = this.Sc() : a;
};
$61de1ee1cac498ae$var$_.Uc = function Rf() {
    return $61de1ee1cac498ae$var$BD(this.d, 161);
};
var $61de1ee1cac498ae$var$sE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/SortedAsMap", 491);
$61de1ee1cac498ae$var$bcb(542, 491, $61de1ee1cac498ae$var$gie, $61de1ee1cac498ae$var$Sf);
$61de1ee1cac498ae$var$_.bc = function Tf() {
    return new $61de1ee1cac498ae$var$$f(this.a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(this.d, 161), 171));
};
$61de1ee1cac498ae$var$_.Sc = function Uf() {
    return new $61de1ee1cac498ae$var$$f(this.a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(this.d, 161), 171));
};
$61de1ee1cac498ae$var$_.ec = function Vf() {
    var a;
    return a = this.b, $61de1ee1cac498ae$var$BD(!a ? this.b = new $61de1ee1cac498ae$var$$f(this.a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(this.d, 161), 171)) : a, 271);
};
$61de1ee1cac498ae$var$_.Tc = function Wf() {
    var a;
    return a = this.b, $61de1ee1cac498ae$var$BD(!a ? this.b = new $61de1ee1cac498ae$var$$f(this.a, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(this.d, 161), 171)) : a, 271);
};
$61de1ee1cac498ae$var$_.Uc = function Xf() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(this.d, 161), 171);
};
var $61de1ee1cac498ae$var$pE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/NavigableAsMap", 542);
$61de1ee1cac498ae$var$bcb(490, 318, $61de1ee1cac498ae$var$hie, $61de1ee1cac498ae$var$Yf);
$61de1ee1cac498ae$var$_.Nc = function Zf() {
    return this.b.ec().Nc();
};
var $61de1ee1cac498ae$var$tE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/SortedKeySet", 490);
$61de1ee1cac498ae$var$bcb(388, 490, $61de1ee1cac498ae$var$iie, $61de1ee1cac498ae$var$$f);
var $61de1ee1cac498ae$var$qE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/NavigableKeySet", 388);
$61de1ee1cac498ae$var$bcb(541, 28, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$dg);
$61de1ee1cac498ae$var$_.Fc = function eg(a) {
    var b, c;
    $61de1ee1cac498ae$var$ag(this);
    c = this.d.dc();
    b = this.d.Fc(a);
    if (b) {
        ++this.f.d;
        c && $61de1ee1cac498ae$var$_f(this);
    }
    return b;
};
$61de1ee1cac498ae$var$_.Gc = function fg(a) {
    var b, c, d;
    if (a.dc()) return false;
    d = ($61de1ee1cac498ae$var$ag(this), this.d.gc());
    b = this.d.Gc(a);
    if (b) {
        c = this.d.gc();
        this.f.d += c - d;
        d == 0 && $61de1ee1cac498ae$var$_f(this);
    }
    return b;
};
$61de1ee1cac498ae$var$_.$b = function gg() {
    var a;
    a = ($61de1ee1cac498ae$var$ag(this), this.d.gc());
    if (a == 0) return;
    this.d.$b();
    this.f.d -= a;
    $61de1ee1cac498ae$var$bg(this);
};
$61de1ee1cac498ae$var$_.Hc = function hg(a) {
    $61de1ee1cac498ae$var$ag(this);
    return this.d.Hc(a);
};
$61de1ee1cac498ae$var$_.Ic = function ig(a) {
    $61de1ee1cac498ae$var$ag(this);
    return this.d.Ic(a);
};
$61de1ee1cac498ae$var$_.Fb = function jg(a) {
    if (a === this) return true;
    $61de1ee1cac498ae$var$ag(this);
    return $61de1ee1cac498ae$var$pb(this.d, a);
};
$61de1ee1cac498ae$var$_.Hb = function kg() {
    $61de1ee1cac498ae$var$ag(this);
    return $61de1ee1cac498ae$var$tb(this.d);
};
$61de1ee1cac498ae$var$_.Kc = function lg() {
    $61de1ee1cac498ae$var$ag(this);
    return new $61de1ee1cac498ae$var$Gg(this);
};
$61de1ee1cac498ae$var$_.Mc = function mg(a) {
    var b;
    $61de1ee1cac498ae$var$ag(this);
    b = this.d.Mc(a);
    if (b) {
        --this.f.d;
        $61de1ee1cac498ae$var$bg(this);
    }
    return b;
};
$61de1ee1cac498ae$var$_.gc = function ng() {
    return $61de1ee1cac498ae$var$cg(this);
};
$61de1ee1cac498ae$var$_.Nc = function og() {
    return $61de1ee1cac498ae$var$ag(this), this.d.Nc();
};
$61de1ee1cac498ae$var$_.Ib = function pg() {
    $61de1ee1cac498ae$var$ag(this);
    return $61de1ee1cac498ae$var$fcb(this.d);
};
var $61de1ee1cac498ae$var$vE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/WrappedCollection", 541);
var $61de1ee1cac498ae$var$yK = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$bie, "List");
$61de1ee1cac498ae$var$bcb(728, 541, {
    20: 1,
    28: 1,
    14: 1,
    15: 1
}, $61de1ee1cac498ae$var$qg);
$61de1ee1cac498ae$var$_.ad = function zg(a) {
    $61de1ee1cac498ae$var$ktb(this, a);
};
$61de1ee1cac498ae$var$_.Nc = function Ag() {
    return $61de1ee1cac498ae$var$ag(this), this.d.Nc();
};
$61de1ee1cac498ae$var$_.Vc = function rg(a, b) {
    var c;
    $61de1ee1cac498ae$var$ag(this);
    c = this.d.dc();
    $61de1ee1cac498ae$var$BD(this.d, 15).Vc(a, b);
    ++this.a.d;
    c && $61de1ee1cac498ae$var$_f(this);
};
$61de1ee1cac498ae$var$_.Wc = function sg(a, b) {
    var c, d, e;
    if (b.dc()) return false;
    e = ($61de1ee1cac498ae$var$ag(this), this.d.gc());
    c = $61de1ee1cac498ae$var$BD(this.d, 15).Wc(a, b);
    if (c) {
        d = this.d.gc();
        this.a.d += d - e;
        e == 0 && $61de1ee1cac498ae$var$_f(this);
    }
    return c;
};
$61de1ee1cac498ae$var$_.Xb = function tg(a) {
    $61de1ee1cac498ae$var$ag(this);
    return $61de1ee1cac498ae$var$BD(this.d, 15).Xb(a);
};
$61de1ee1cac498ae$var$_.Xc = function ug(a) {
    $61de1ee1cac498ae$var$ag(this);
    return $61de1ee1cac498ae$var$BD(this.d, 15).Xc(a);
};
$61de1ee1cac498ae$var$_.Yc = function vg() {
    $61de1ee1cac498ae$var$ag(this);
    return new $61de1ee1cac498ae$var$Mg(this);
};
$61de1ee1cac498ae$var$_.Zc = function wg(a) {
    $61de1ee1cac498ae$var$ag(this);
    return new $61de1ee1cac498ae$var$Ng(this, a);
};
$61de1ee1cac498ae$var$_.$c = function xg(a) {
    var b;
    $61de1ee1cac498ae$var$ag(this);
    b = $61de1ee1cac498ae$var$BD(this.d, 15).$c(a);
    --this.a.d;
    $61de1ee1cac498ae$var$bg(this);
    return b;
};
$61de1ee1cac498ae$var$_._c = function yg(a, b) {
    $61de1ee1cac498ae$var$ag(this);
    return $61de1ee1cac498ae$var$BD(this.d, 15)._c(a, b);
};
$61de1ee1cac498ae$var$_.bd = function Bg(a, b) {
    $61de1ee1cac498ae$var$ag(this);
    return $61de1ee1cac498ae$var$Vc(this.a, this.e, $61de1ee1cac498ae$var$BD(this.d, 15).bd(a, b), !this.b ? this : this.b);
};
var $61de1ee1cac498ae$var$xE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/WrappedList", 728);
$61de1ee1cac498ae$var$bcb(1096, 728, {
    20: 1,
    28: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$Cg);
var $61de1ee1cac498ae$var$rE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/RandomAccessWrappedList", 1096);
$61de1ee1cac498ae$var$bcb(620, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Gg);
$61de1ee1cac498ae$var$_.Nb = function Ig(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Jg() {
    $61de1ee1cac498ae$var$Fg(this);
    return this.b.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Kg() {
    $61de1ee1cac498ae$var$Fg(this);
    return this.b.Pb();
};
$61de1ee1cac498ae$var$_.Qb = function Lg() {
    $61de1ee1cac498ae$var$Eg(this);
};
var $61de1ee1cac498ae$var$uE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/WrappedCollection/WrappedIterator", 620);
$61de1ee1cac498ae$var$bcb(729, 620, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$Mg, $61de1ee1cac498ae$var$Ng);
$61de1ee1cac498ae$var$_.Qb = function Tg() {
    $61de1ee1cac498ae$var$Eg(this);
};
$61de1ee1cac498ae$var$_.Rb = function Og(a) {
    var b;
    b = $61de1ee1cac498ae$var$cg(this.a) == 0;
    ($61de1ee1cac498ae$var$Fg(this), $61de1ee1cac498ae$var$BD(this.b, 125)).Rb(a);
    ++this.a.a.d;
    b && $61de1ee1cac498ae$var$_f(this.a);
};
$61de1ee1cac498ae$var$_.Sb = function Pg() {
    return ($61de1ee1cac498ae$var$Fg(this), $61de1ee1cac498ae$var$BD(this.b, 125)).Sb();
};
$61de1ee1cac498ae$var$_.Tb = function Qg() {
    return ($61de1ee1cac498ae$var$Fg(this), $61de1ee1cac498ae$var$BD(this.b, 125)).Tb();
};
$61de1ee1cac498ae$var$_.Ub = function Rg() {
    return ($61de1ee1cac498ae$var$Fg(this), $61de1ee1cac498ae$var$BD(this.b, 125)).Ub();
};
$61de1ee1cac498ae$var$_.Vb = function Sg() {
    return ($61de1ee1cac498ae$var$Fg(this), $61de1ee1cac498ae$var$BD(this.b, 125)).Vb();
};
$61de1ee1cac498ae$var$_.Wb = function Ug(a) {
    ($61de1ee1cac498ae$var$Fg(this), $61de1ee1cac498ae$var$BD(this.b, 125)).Wb(a);
};
var $61de1ee1cac498ae$var$wE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/WrappedList/WrappedListIterator", 729);
$61de1ee1cac498ae$var$bcb(727, 541, $61de1ee1cac498ae$var$hie, $61de1ee1cac498ae$var$Vg);
$61de1ee1cac498ae$var$_.Nc = function Wg() {
    return $61de1ee1cac498ae$var$ag(this), this.d.Nc();
};
var $61de1ee1cac498ae$var$AE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/WrappedSortedSet", 727);
$61de1ee1cac498ae$var$bcb(1095, 727, $61de1ee1cac498ae$var$iie, $61de1ee1cac498ae$var$Xg);
var $61de1ee1cac498ae$var$yE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/WrappedNavigableSet", 1095);
$61de1ee1cac498ae$var$bcb(1094, 541, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$Yg);
$61de1ee1cac498ae$var$_.Nc = function Zg() {
    return $61de1ee1cac498ae$var$ag(this), this.d.Nc();
};
var $61de1ee1cac498ae$var$zE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/WrappedSet", 1094);
$61de1ee1cac498ae$var$bcb(1103, 1, {}, $61de1ee1cac498ae$var$$g);
$61de1ee1cac498ae$var$_.Kb = function _g(a) {
    return $61de1ee1cac498ae$var$fd($61de1ee1cac498ae$var$BD(a, 42));
};
var $61de1ee1cac498ae$var$BE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/lambda$1$Type", 1103);
$61de1ee1cac498ae$var$bcb(1102, 1, {}, $61de1ee1cac498ae$var$ah);
$61de1ee1cac498ae$var$_.Kb = function bh(a) {
    return new $61de1ee1cac498ae$var$Wo(this.a, a);
};
var $61de1ee1cac498ae$var$CE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMapBasedMultimap/lambda$2$Type", 1102);
var $61de1ee1cac498ae$var$CK = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$bie, "Map/Entry");
$61de1ee1cac498ae$var$bcb(345, 1, $61de1ee1cac498ae$var$kie);
$61de1ee1cac498ae$var$_.Fb = function dh(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 42)) {
        b = $61de1ee1cac498ae$var$BD(a, 42);
        return $61de1ee1cac498ae$var$Hb(this.cd(), b.cd()) && $61de1ee1cac498ae$var$Hb(this.dd(), b.dd());
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function eh() {
    var a, b;
    a = this.cd();
    b = this.dd();
    return (a == null ? 0 : $61de1ee1cac498ae$var$tb(a)) ^ (b == null ? 0 : $61de1ee1cac498ae$var$tb(b));
};
$61de1ee1cac498ae$var$_.ed = function fh(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Ib = function gh() {
    return this.cd() + "=" + this.dd();
};
var $61de1ee1cac498ae$var$EE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, $61de1ee1cac498ae$var$lie, 345);
$61de1ee1cac498ae$var$bcb(1988, 28, $61de1ee1cac498ae$var$die);
$61de1ee1cac498ae$var$_.$b = function hh() {
    this.fd().$b();
};
$61de1ee1cac498ae$var$_.Hc = function ih(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 42)) {
        b = $61de1ee1cac498ae$var$BD(a, 42);
        return $61de1ee1cac498ae$var$Cc(this.fd(), b.cd(), b.dd());
    }
    return false;
};
$61de1ee1cac498ae$var$_.Mc = function jh(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 42)) {
        b = $61de1ee1cac498ae$var$BD(a, 42);
        return $61de1ee1cac498ae$var$Gc(this.fd(), b.cd(), b.dd());
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function kh() {
    return this.fd().d;
};
var $61de1ee1cac498ae$var$fH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/Entries", 1988);
$61de1ee1cac498ae$var$bcb(733, 1988, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$lh);
$61de1ee1cac498ae$var$_.Kc = function mh() {
    return this.a.kc();
};
$61de1ee1cac498ae$var$_.fd = function nh() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Nc = function oh() {
    return this.a.lc();
};
var $61de1ee1cac498ae$var$FE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMultimap/Entries", 733);
$61de1ee1cac498ae$var$bcb(734, 733, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$ph);
$61de1ee1cac498ae$var$_.Nc = function sh() {
    return this.a.lc();
};
$61de1ee1cac498ae$var$_.Fb = function qh(a) {
    return $61de1ee1cac498ae$var$Ax(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function rh() {
    return $61de1ee1cac498ae$var$Bx(this);
};
var $61de1ee1cac498ae$var$GE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMultimap/EntrySet", 734);
$61de1ee1cac498ae$var$bcb(735, 28, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$th);
$61de1ee1cac498ae$var$_.$b = function uh() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_.Hc = function vh(a) {
    return $61de1ee1cac498ae$var$Dc(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function wh() {
    return this.a.nc();
};
$61de1ee1cac498ae$var$_.gc = function xh() {
    return this.a.d;
};
$61de1ee1cac498ae$var$_.Nc = function yh() {
    return this.a.oc();
};
var $61de1ee1cac498ae$var$HE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMultimap/Values", 735);
$61de1ee1cac498ae$var$bcb(1989, 28, {
    835: 1,
    20: 1,
    28: 1,
    14: 1
});
$61de1ee1cac498ae$var$_.Jc = function Gh(a) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$Ah(this).Jc(new $61de1ee1cac498ae$var$Xw(a));
};
$61de1ee1cac498ae$var$_.Nc = function Kh() {
    var a;
    return a = $61de1ee1cac498ae$var$Ah(this).Nc(), $61de1ee1cac498ae$var$Yj(a, new $61de1ee1cac498ae$var$cx, 64 | a.qd() & 1296, this.a.d);
};
$61de1ee1cac498ae$var$_.Fc = function Ch(a) {
    $61de1ee1cac498ae$var$zh();
    return true;
};
$61de1ee1cac498ae$var$_.Gc = function Dh(a) {
    return $61de1ee1cac498ae$var$Qb(this), $61de1ee1cac498ae$var$Qb(a), $61de1ee1cac498ae$var$JD(a, 543) ? $61de1ee1cac498ae$var$Zw($61de1ee1cac498ae$var$BD(a, 835)) : !a.dc() && $61de1ee1cac498ae$var$fr(this, a.Kc());
};
$61de1ee1cac498ae$var$_.Hc = function Eh(a) {
    var b;
    return b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$nd(this.a), a), 14), (!b ? 0 : b.gc()) > 0;
};
$61de1ee1cac498ae$var$_.Fb = function Fh(a) {
    return $61de1ee1cac498ae$var$$w(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Hh() {
    return $61de1ee1cac498ae$var$tb($61de1ee1cac498ae$var$Ah(this));
};
$61de1ee1cac498ae$var$_.dc = function Ih() {
    return $61de1ee1cac498ae$var$Ah(this).dc();
};
$61de1ee1cac498ae$var$_.Mc = function Jh(a) {
    return $61de1ee1cac498ae$var$Bw(this, a, 1) > 0;
};
$61de1ee1cac498ae$var$_.Ib = function Lh() {
    return $61de1ee1cac498ae$var$fcb($61de1ee1cac498ae$var$Ah(this));
};
var $61de1ee1cac498ae$var$KE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMultiset", 1989);
$61de1ee1cac498ae$var$bcb(1991, 1970, $61de1ee1cac498ae$var$fie);
$61de1ee1cac498ae$var$_.$b = function Mh() {
    $61de1ee1cac498ae$var$Nc(this.a.a);
};
$61de1ee1cac498ae$var$_.Hc = function Nh(a) {
    var b, c;
    if ($61de1ee1cac498ae$var$JD(a, 492)) {
        c = $61de1ee1cac498ae$var$BD(a, 416);
        if ($61de1ee1cac498ae$var$BD(c.a.dd(), 14).gc() <= 0) return false;
        b = $61de1ee1cac498ae$var$Aw(this.a, c.a.cd());
        return b == $61de1ee1cac498ae$var$BD(c.a.dd(), 14).gc();
    }
    return false;
};
$61de1ee1cac498ae$var$_.Mc = function Oh(a) {
    var b, c, d, e;
    if ($61de1ee1cac498ae$var$JD(a, 492)) {
        c = $61de1ee1cac498ae$var$BD(a, 416);
        b = c.a.cd();
        d = $61de1ee1cac498ae$var$BD(c.a.dd(), 14).gc();
        if (d != 0) {
            e = this.a;
            return $61de1ee1cac498ae$var$ax(e, b, d);
        }
    }
    return false;
};
var $61de1ee1cac498ae$var$pH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multisets/EntrySet", 1991);
$61de1ee1cac498ae$var$bcb(1109, 1991, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$Ph);
$61de1ee1cac498ae$var$_.Kc = function Qh() {
    return new $61de1ee1cac498ae$var$Lw($61de1ee1cac498ae$var$fe($61de1ee1cac498ae$var$nd(this.a.a)).Kc());
};
$61de1ee1cac498ae$var$_.gc = function Rh() {
    return $61de1ee1cac498ae$var$nd(this.a.a).gc();
};
var $61de1ee1cac498ae$var$JE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractMultiset/EntrySet", 1109);
$61de1ee1cac498ae$var$bcb(619, 726, $61de1ee1cac498ae$var$_he);
$61de1ee1cac498ae$var$_.hc = function Uh() {
    return this.gd();
};
$61de1ee1cac498ae$var$_.jc = function Vh() {
    return this.hd();
};
$61de1ee1cac498ae$var$_.cc = function Yh(a) {
    return this.jd(a);
};
$61de1ee1cac498ae$var$_.fc = function $h(a) {
    return this.kd(a);
};
$61de1ee1cac498ae$var$_.Zb = function Th() {
    var a;
    return a = this.f, !a ? this.f = this.ac() : a;
};
$61de1ee1cac498ae$var$_.hd = function Wh() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$lmb;
};
$61de1ee1cac498ae$var$_.Fb = function Xh(a) {
    return $61de1ee1cac498ae$var$hw(this, a);
};
$61de1ee1cac498ae$var$_.jd = function Zh(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(this, a), 21);
};
$61de1ee1cac498ae$var$_.kd = function _h(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Sc(this, a), 21);
};
$61de1ee1cac498ae$var$_.mc = function ai(a) {
    return $61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$zob($61de1ee1cac498ae$var$BD(a, 21));
};
$61de1ee1cac498ae$var$_.pc = function bi(a, b) {
    return new $61de1ee1cac498ae$var$Yg(this, a, $61de1ee1cac498ae$var$BD(b, 21));
};
var $61de1ee1cac498ae$var$LE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractSetMultimap", 619);
$61de1ee1cac498ae$var$bcb(1657, 619, $61de1ee1cac498ae$var$_he);
$61de1ee1cac498ae$var$_.hc = function ei() {
    return new $61de1ee1cac498ae$var$Hxb(this.b);
};
$61de1ee1cac498ae$var$_.gd = function fi() {
    return new $61de1ee1cac498ae$var$Hxb(this.b);
};
$61de1ee1cac498ae$var$_.jc = function gi() {
    return $61de1ee1cac498ae$var$Ix(new $61de1ee1cac498ae$var$Hxb(this.b));
};
$61de1ee1cac498ae$var$_.hd = function hi() {
    return $61de1ee1cac498ae$var$Ix(new $61de1ee1cac498ae$var$Hxb(this.b));
};
$61de1ee1cac498ae$var$_.cc = function ii(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(this, a), 21), 84);
};
$61de1ee1cac498ae$var$_.jd = function ji(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(this, a), 21), 84);
};
$61de1ee1cac498ae$var$_.fc = function ki(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Sc(this, a), 21), 84);
};
$61de1ee1cac498ae$var$_.kd = function li(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Sc(this, a), 21), 84);
};
$61de1ee1cac498ae$var$_.mc = function mi(a) {
    return $61de1ee1cac498ae$var$JD(a, 271) ? $61de1ee1cac498ae$var$Ix($61de1ee1cac498ae$var$BD(a, 271)) : ($61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$Zob($61de1ee1cac498ae$var$BD(a, 84)));
};
$61de1ee1cac498ae$var$_.Zb = function di() {
    var a;
    return a = this.f, !a ? this.f = $61de1ee1cac498ae$var$JD(this.c, 171) ? new $61de1ee1cac498ae$var$Sf(this, $61de1ee1cac498ae$var$BD(this.c, 171)) : $61de1ee1cac498ae$var$JD(this.c, 161) ? new $61de1ee1cac498ae$var$Mf(this, $61de1ee1cac498ae$var$BD(this.c, 161)) : new $61de1ee1cac498ae$var$ne(this, this.c) : a;
};
$61de1ee1cac498ae$var$_.pc = function ni(a, b) {
    return $61de1ee1cac498ae$var$JD(b, 271) ? new $61de1ee1cac498ae$var$Xg(this, a, $61de1ee1cac498ae$var$BD(b, 271)) : new $61de1ee1cac498ae$var$Vg(this, a, $61de1ee1cac498ae$var$BD(b, 84));
};
var $61de1ee1cac498ae$var$NE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractSortedSetMultimap", 1657);
$61de1ee1cac498ae$var$bcb(1658, 1657, $61de1ee1cac498ae$var$_he);
$61de1ee1cac498ae$var$_.Zb = function pi() {
    var a;
    return a = this.f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(!a ? this.f = $61de1ee1cac498ae$var$JD(this.c, 171) ? new $61de1ee1cac498ae$var$Sf(this, $61de1ee1cac498ae$var$BD(this.c, 171)) : $61de1ee1cac498ae$var$JD(this.c, 161) ? new $61de1ee1cac498ae$var$Mf(this, $61de1ee1cac498ae$var$BD(this.c, 161)) : new $61de1ee1cac498ae$var$ne(this, this.c) : a, 161), 171);
};
$61de1ee1cac498ae$var$_.ec = function ri() {
    var a;
    return a = this.i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(!a ? this.i = $61de1ee1cac498ae$var$JD(this.c, 171) ? new $61de1ee1cac498ae$var$$f(this, $61de1ee1cac498ae$var$BD(this.c, 171)) : $61de1ee1cac498ae$var$JD(this.c, 161) ? new $61de1ee1cac498ae$var$Yf(this, $61de1ee1cac498ae$var$BD(this.c, 161)) : new $61de1ee1cac498ae$var$zf(this, this.c) : a, 84), 271);
};
$61de1ee1cac498ae$var$_.bc = function qi() {
    return $61de1ee1cac498ae$var$JD(this.c, 171) ? new $61de1ee1cac498ae$var$$f(this, $61de1ee1cac498ae$var$BD(this.c, 171)) : $61de1ee1cac498ae$var$JD(this.c, 161) ? new $61de1ee1cac498ae$var$Yf(this, $61de1ee1cac498ae$var$BD(this.c, 161)) : new $61de1ee1cac498ae$var$zf(this, this.c);
};
var $61de1ee1cac498ae$var$ME = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractSortedKeySortedSetMultimap", 1658);
$61de1ee1cac498ae$var$bcb(2010, 1, {
    1947: 1
});
$61de1ee1cac498ae$var$_.Fb = function si(a) {
    return $61de1ee1cac498ae$var$zy(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function ti() {
    var a;
    return $61de1ee1cac498ae$var$pmb((a = this.g, !a ? this.g = new $61de1ee1cac498ae$var$vi(this) : a));
};
$61de1ee1cac498ae$var$_.Ib = function ui() {
    var a;
    return $61de1ee1cac498ae$var$Md((a = this.f, !a ? this.f = new $61de1ee1cac498ae$var$Rj(this) : a));
};
var $61de1ee1cac498ae$var$QE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractTable", 2010);
$61de1ee1cac498ae$var$bcb(665, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$vi);
$61de1ee1cac498ae$var$_.$b = function wi() {
    $61de1ee1cac498ae$var$Pi();
};
$61de1ee1cac498ae$var$_.Hc = function xi(a) {
    var b, c;
    if ($61de1ee1cac498ae$var$JD(a, 468)) {
        b = $61de1ee1cac498ae$var$BD(a, 682);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$Vi(this.a), $61de1ee1cac498ae$var$Em(b.c.e, b.b)), 83);
        return !!c && $61de1ee1cac498ae$var$Ck(c.vc(), new $61de1ee1cac498ae$var$Wo($61de1ee1cac498ae$var$Em(b.c.c, b.a), $61de1ee1cac498ae$var$Mi(b.c, b.b, b.a)));
    }
    return false;
};
$61de1ee1cac498ae$var$_.Kc = function yi() {
    return $61de1ee1cac498ae$var$Ni(this.a);
};
$61de1ee1cac498ae$var$_.Mc = function zi(a) {
    var b, c;
    if ($61de1ee1cac498ae$var$JD(a, 468)) {
        b = $61de1ee1cac498ae$var$BD(a, 682);
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Hv($61de1ee1cac498ae$var$Vi(this.a), $61de1ee1cac498ae$var$Em(b.c.e, b.b)), 83);
        return !!c && $61de1ee1cac498ae$var$Dk(c.vc(), new $61de1ee1cac498ae$var$Wo($61de1ee1cac498ae$var$Em(b.c.c, b.a), $61de1ee1cac498ae$var$Mi(b.c, b.b, b.a)));
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function Ai() {
    return $61de1ee1cac498ae$var$Xi(this.a);
};
$61de1ee1cac498ae$var$_.Nc = function Bi() {
    return $61de1ee1cac498ae$var$Oi(this.a);
};
var $61de1ee1cac498ae$var$OE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractTable/CellSet", 665);
$61de1ee1cac498ae$var$bcb(1928, 28, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$Ci);
$61de1ee1cac498ae$var$_.$b = function Di() {
    $61de1ee1cac498ae$var$Pi();
};
$61de1ee1cac498ae$var$_.Hc = function Ei(a) {
    return $61de1ee1cac498ae$var$Qi(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function Fi() {
    return $61de1ee1cac498ae$var$Zi(this.a);
};
$61de1ee1cac498ae$var$_.gc = function Gi() {
    return $61de1ee1cac498ae$var$Xi(this.a);
};
$61de1ee1cac498ae$var$_.Nc = function Hi() {
    return $61de1ee1cac498ae$var$$i(this.a);
};
var $61de1ee1cac498ae$var$PE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "AbstractTable/Values", 1928);
$61de1ee1cac498ae$var$bcb(1632, 1631, $61de1ee1cac498ae$var$_he);
var $61de1ee1cac498ae$var$RE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayListMultimapGwtSerializationDependencies", 1632);
$61de1ee1cac498ae$var$bcb(513, 1632, $61de1ee1cac498ae$var$_he, $61de1ee1cac498ae$var$Ji, $61de1ee1cac498ae$var$Ki);
$61de1ee1cac498ae$var$_.hc = function Li() {
    return new $61de1ee1cac498ae$var$Skb(this.a);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$SE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayListMultimap", 513);
$61de1ee1cac498ae$var$bcb(664, 2010, {
    664: 1,
    1947: 1,
    3: 1
}, $61de1ee1cac498ae$var$_i);
var $61de1ee1cac498ae$var$cF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable", 664);
$61de1ee1cac498ae$var$bcb(1924, 386, $61de1ee1cac498ae$var$$he, $61de1ee1cac498ae$var$aj);
$61de1ee1cac498ae$var$_.Xb = function bj(a) {
    return new $61de1ee1cac498ae$var$hj(this.a, a);
};
var $61de1ee1cac498ae$var$TE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/1", 1924);
$61de1ee1cac498ae$var$bcb(1925, 1, {}, $61de1ee1cac498ae$var$cj);
$61de1ee1cac498ae$var$_.ld = function dj(a) {
    return new $61de1ee1cac498ae$var$hj(this.a, a);
};
var $61de1ee1cac498ae$var$UE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/1methodref$getCell$Type", 1925);
$61de1ee1cac498ae$var$bcb(2011, 1, {
    682: 1
});
$61de1ee1cac498ae$var$_.Fb = function ej(a) {
    var b;
    if (a === this) return true;
    if ($61de1ee1cac498ae$var$JD(a, 468)) {
        b = $61de1ee1cac498ae$var$BD(a, 682);
        return $61de1ee1cac498ae$var$Hb($61de1ee1cac498ae$var$Em(this.c.e, this.b), $61de1ee1cac498ae$var$Em(b.c.e, b.b)) && $61de1ee1cac498ae$var$Hb($61de1ee1cac498ae$var$Em(this.c.c, this.a), $61de1ee1cac498ae$var$Em(b.c.c, b.a)) && $61de1ee1cac498ae$var$Hb($61de1ee1cac498ae$var$Mi(this.c, this.b, this.a), $61de1ee1cac498ae$var$Mi(b.c, b.b, b.a));
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function fj() {
    return $61de1ee1cac498ae$var$Hlb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        $61de1ee1cac498ae$var$Em(this.c.e, this.b),
        $61de1ee1cac498ae$var$Em(this.c.c, this.a),
        $61de1ee1cac498ae$var$Mi(this.c, this.b, this.a)
    ]));
};
$61de1ee1cac498ae$var$_.Ib = function gj() {
    return "(" + $61de1ee1cac498ae$var$Em(this.c.e, this.b) + "," + $61de1ee1cac498ae$var$Em(this.c.c, this.a) + ")=" + $61de1ee1cac498ae$var$Mi(this.c, this.b, this.a);
};
var $61de1ee1cac498ae$var$JH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Tables/AbstractCell", 2011);
$61de1ee1cac498ae$var$bcb(468, 2011, {
    468: 1,
    682: 1
}, $61de1ee1cac498ae$var$hj);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$VE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/2", 468);
$61de1ee1cac498ae$var$bcb(1927, 1, {}, $61de1ee1cac498ae$var$ij);
$61de1ee1cac498ae$var$_.ld = function jj(a) {
    return $61de1ee1cac498ae$var$Ti(this.a, a);
};
var $61de1ee1cac498ae$var$WE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/2methodref$getValue$Type", 1927);
$61de1ee1cac498ae$var$bcb(1926, 386, $61de1ee1cac498ae$var$$he, $61de1ee1cac498ae$var$kj);
$61de1ee1cac498ae$var$_.Xb = function lj(a) {
    return $61de1ee1cac498ae$var$Ti(this.a, a);
};
var $61de1ee1cac498ae$var$XE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/3", 1926);
$61de1ee1cac498ae$var$bcb(1979, 1967, $61de1ee1cac498ae$var$cie);
$61de1ee1cac498ae$var$_.$b = function nj() {
    $61de1ee1cac498ae$var$ir(this.kc());
};
$61de1ee1cac498ae$var$_.vc = function oj() {
    return new $61de1ee1cac498ae$var$Sv(this);
};
$61de1ee1cac498ae$var$_.lc = function pj() {
    return new $61de1ee1cac498ae$var$Mub(this.kc(), this.gc());
};
var $61de1ee1cac498ae$var$YG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/IteratorBasedAbstractMap", 1979);
$61de1ee1cac498ae$var$bcb(828, 1979, $61de1ee1cac498ae$var$cie);
$61de1ee1cac498ae$var$_.$b = function tj() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_._b = function uj(a) {
    return $61de1ee1cac498ae$var$sn(this.c, a);
};
$61de1ee1cac498ae$var$_.kc = function vj() {
    return new $61de1ee1cac498ae$var$Jj(this, this.c.b.c.gc());
};
$61de1ee1cac498ae$var$_.lc = function wj() {
    return $61de1ee1cac498ae$var$Zj(this.c.b.c.gc(), 16, new $61de1ee1cac498ae$var$Dj(this));
};
$61de1ee1cac498ae$var$_.xc = function xj(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$tn(this.c, a), 19);
    return !b ? null : this.nd(b.a);
};
$61de1ee1cac498ae$var$_.dc = function yj() {
    return this.c.b.c.dc();
};
$61de1ee1cac498ae$var$_.ec = function zj() {
    return $61de1ee1cac498ae$var$Xm(this.c);
};
$61de1ee1cac498ae$var$_.zc = function Aj(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$tn(this.c, a), 19);
    if (!c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb(this.md() + " " + a + " not in " + $61de1ee1cac498ae$var$Xm(this.c)));
    return this.od(c.a, b);
};
$61de1ee1cac498ae$var$_.Bc = function Bj(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.gc = function Cj() {
    return this.c.b.c.gc();
};
var $61de1ee1cac498ae$var$_E = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/ArrayMap", 828);
$61de1ee1cac498ae$var$bcb(1923, 1, {}, $61de1ee1cac498ae$var$Dj);
$61de1ee1cac498ae$var$_.ld = function Ej(a) {
    return $61de1ee1cac498ae$var$qj(this.a, a);
};
var $61de1ee1cac498ae$var$YE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/ArrayMap/0methodref$getEntry$Type", 1923);
$61de1ee1cac498ae$var$bcb(1921, 345, $61de1ee1cac498ae$var$kie, $61de1ee1cac498ae$var$Fj);
$61de1ee1cac498ae$var$_.cd = function Gj() {
    return $61de1ee1cac498ae$var$rj(this.a, this.b);
};
$61de1ee1cac498ae$var$_.dd = function Hj() {
    return this.a.nd(this.b);
};
$61de1ee1cac498ae$var$_.ed = function Ij(a) {
    return this.a.od(this.b, a);
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$ZE = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/ArrayMap/1", 1921);
$61de1ee1cac498ae$var$bcb(1922, 386, $61de1ee1cac498ae$var$$he, $61de1ee1cac498ae$var$Jj);
$61de1ee1cac498ae$var$_.Xb = function Kj(a) {
    return $61de1ee1cac498ae$var$qj(this.a, a);
};
var $61de1ee1cac498ae$var$$E = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/ArrayMap/2", 1922);
$61de1ee1cac498ae$var$bcb(1920, 828, $61de1ee1cac498ae$var$cie, $61de1ee1cac498ae$var$Lj);
$61de1ee1cac498ae$var$_.md = function Mj() {
    return "Column";
};
$61de1ee1cac498ae$var$_.nd = function Nj(a) {
    return $61de1ee1cac498ae$var$Mi(this.b, this.a, a);
};
$61de1ee1cac498ae$var$_.od = function Oj(a, b) {
    return $61de1ee1cac498ae$var$Wi(this.b, this.a, a, b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$bF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/Row", 1920);
$61de1ee1cac498ae$var$bcb(829, 828, $61de1ee1cac498ae$var$cie, $61de1ee1cac498ae$var$Rj);
$61de1ee1cac498ae$var$_.nd = function Tj(a) {
    return new $61de1ee1cac498ae$var$Lj(this.a, a);
};
$61de1ee1cac498ae$var$_.zc = function Uj(a, b) {
    return $61de1ee1cac498ae$var$BD(b, 83), $61de1ee1cac498ae$var$Pj();
};
$61de1ee1cac498ae$var$_.od = function Vj(a, b) {
    return $61de1ee1cac498ae$var$BD(b, 83), $61de1ee1cac498ae$var$Qj();
};
$61de1ee1cac498ae$var$_.md = function Sj() {
    return "Row";
};
var $61de1ee1cac498ae$var$aF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ArrayTable/RowMap", 829);
$61de1ee1cac498ae$var$bcb(1120, 1, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$_j);
$61de1ee1cac498ae$var$_.qd = function ak() {
    return this.a.qd() & -262;
};
$61de1ee1cac498ae$var$_.rd = function bk() {
    return this.a.rd();
};
$61de1ee1cac498ae$var$_.Nb = function ck(a) {
    this.a.Nb(new $61de1ee1cac498ae$var$gk(a, this.b));
};
$61de1ee1cac498ae$var$_.sd = function dk(a) {
    return this.a.sd(new $61de1ee1cac498ae$var$ek(a, this.b));
};
var $61de1ee1cac498ae$var$lF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1", 1120);
$61de1ee1cac498ae$var$bcb(1121, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$ek);
$61de1ee1cac498ae$var$_.td = function fk(a) {
    this.a.td(this.b.Kb(a));
};
var $61de1ee1cac498ae$var$dF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1/lambda$0$Type", 1121);
$61de1ee1cac498ae$var$bcb(1122, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$gk);
$61de1ee1cac498ae$var$_.td = function hk(a) {
    this.a.td(this.b.Kb(a));
};
var $61de1ee1cac498ae$var$eF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1/lambda$1$Type", 1122);
$61de1ee1cac498ae$var$bcb(1123, 1, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$jk);
$61de1ee1cac498ae$var$_.qd = function kk() {
    return this.a;
};
$61de1ee1cac498ae$var$_.rd = function lk() {
    !!this.d && (this.b = $61de1ee1cac498ae$var$Deb(this.b, this.d.rd()));
    return $61de1ee1cac498ae$var$Deb(this.b, 0);
};
$61de1ee1cac498ae$var$_.Nb = function mk(a) {
    if (this.d) {
        this.d.Nb(a);
        this.d = null;
    }
    this.c.Nb(new $61de1ee1cac498ae$var$rk(this.e, a));
    this.b = 0;
};
$61de1ee1cac498ae$var$_.sd = function ok(a) {
    while(true){
        if (!!this.d && this.d.sd(a)) {
            $61de1ee1cac498ae$var$Kbb(this.b, $61de1ee1cac498ae$var$rie) && (this.b = $61de1ee1cac498ae$var$Qbb(this.b, 1));
            return true;
        } else this.d = null;
        if (!this.c.sd(new $61de1ee1cac498ae$var$pk(this, this.e))) return false;
    }
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$hF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1FlatMapSpliterator", 1123);
$61de1ee1cac498ae$var$bcb(1124, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$pk);
$61de1ee1cac498ae$var$_.td = function qk(a) {
    $61de1ee1cac498ae$var$ik(this.a, this.b, a);
};
var $61de1ee1cac498ae$var$fF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1FlatMapSpliterator/lambda$0$Type", 1124);
$61de1ee1cac498ae$var$bcb(1125, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$rk);
$61de1ee1cac498ae$var$_.td = function sk(a) {
    $61de1ee1cac498ae$var$nk(this.b, this.a, a);
};
var $61de1ee1cac498ae$var$gF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1FlatMapSpliterator/lambda$1$Type", 1125);
$61de1ee1cac498ae$var$bcb(1117, 1, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$tk);
$61de1ee1cac498ae$var$_.qd = function uk() {
    return 16464 | this.b;
};
$61de1ee1cac498ae$var$_.rd = function vk() {
    return this.a.rd();
};
$61de1ee1cac498ae$var$_.Nb = function wk(a) {
    this.a.xe(new $61de1ee1cac498ae$var$Ak(a, this.c));
};
$61de1ee1cac498ae$var$_.sd = function xk(a) {
    return this.a.ye(new $61de1ee1cac498ae$var$yk(a, this.c));
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$kF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1WithCharacteristics", 1117);
$61de1ee1cac498ae$var$bcb(1118, 1, $61de1ee1cac498ae$var$sie, $61de1ee1cac498ae$var$yk);
$61de1ee1cac498ae$var$_.ud = function zk(a) {
    this.a.td(this.b.ld(a));
};
var $61de1ee1cac498ae$var$iF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1WithCharacteristics/lambda$0$Type", 1118);
$61de1ee1cac498ae$var$bcb(1119, 1, $61de1ee1cac498ae$var$sie, $61de1ee1cac498ae$var$Ak);
$61de1ee1cac498ae$var$_.ud = function Bk(a) {
    this.a.td(this.b.ld(a));
};
var $61de1ee1cac498ae$var$jF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "CollectSpliterators/1WithCharacteristics/lambda$1$Type", 1119);
$61de1ee1cac498ae$var$bcb(245, 1, $61de1ee1cac498ae$var$tie);
$61de1ee1cac498ae$var$_.wd = function Hk(a) {
    return this.vd($61de1ee1cac498ae$var$BD(a, 245));
};
$61de1ee1cac498ae$var$_.vd = function Gk(a) {
    var b;
    if (a == ($61de1ee1cac498ae$var$_k(), $61de1ee1cac498ae$var$$k)) return 1;
    if (a == ($61de1ee1cac498ae$var$Lk(), $61de1ee1cac498ae$var$Kk)) return -1;
    b = ($61de1ee1cac498ae$var$ex(), $61de1ee1cac498ae$var$Fcb(this.a, a.a));
    if (b != 0) return b;
    return $61de1ee1cac498ae$var$JD(this, 519) == $61de1ee1cac498ae$var$JD(a, 519) ? 0 : $61de1ee1cac498ae$var$JD(this, 519) ? 1 : -1;
};
$61de1ee1cac498ae$var$_.zd = function Ik() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Fb = function Jk(a) {
    return $61de1ee1cac498ae$var$Ek(this, a);
};
var $61de1ee1cac498ae$var$qF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Cut", 245);
$61de1ee1cac498ae$var$bcb(1761, 245, $61de1ee1cac498ae$var$tie, $61de1ee1cac498ae$var$Mk);
$61de1ee1cac498ae$var$_.vd = function Nk(a) {
    return a == this ? 0 : 1;
};
$61de1ee1cac498ae$var$_.xd = function Ok(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$xcb);
};
$61de1ee1cac498ae$var$_.yd = function Pk(a) {
    a.a += "+\u221E)";
};
$61de1ee1cac498ae$var$_.zd = function Qk() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$uie));
};
$61de1ee1cac498ae$var$_.Hb = function Rk() {
    return $61de1ee1cac498ae$var$Zfb(), $61de1ee1cac498ae$var$kCb(this);
};
$61de1ee1cac498ae$var$_.Ad = function Sk(a) {
    return false;
};
$61de1ee1cac498ae$var$_.Ib = function Tk() {
    return "+\u221E";
};
var $61de1ee1cac498ae$var$Kk;
var $61de1ee1cac498ae$var$mF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Cut/AboveAll", 1761);
$61de1ee1cac498ae$var$bcb(519, 245, {
    245: 1,
    519: 1,
    3: 1,
    35: 1
}, $61de1ee1cac498ae$var$Uk);
$61de1ee1cac498ae$var$_.xd = function Vk(a) {
    $61de1ee1cac498ae$var$Pfb((a.a += "(", a), this.a);
};
$61de1ee1cac498ae$var$_.yd = function Wk(a) {
    $61de1ee1cac498ae$var$Kfb($61de1ee1cac498ae$var$Pfb(a, this.a), 93);
};
$61de1ee1cac498ae$var$_.Hb = function Xk() {
    return ~$61de1ee1cac498ae$var$tb(this.a);
};
$61de1ee1cac498ae$var$_.Ad = function Yk(a) {
    return $61de1ee1cac498ae$var$ex(), $61de1ee1cac498ae$var$Fcb(this.a, a) < 0;
};
$61de1ee1cac498ae$var$_.Ib = function Zk() {
    return "/" + this.a + "\\";
};
var $61de1ee1cac498ae$var$nF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Cut/AboveValue", 519);
$61de1ee1cac498ae$var$bcb(1760, 245, $61de1ee1cac498ae$var$tie, $61de1ee1cac498ae$var$al);
$61de1ee1cac498ae$var$_.vd = function bl(a) {
    return a == this ? 0 : -1;
};
$61de1ee1cac498ae$var$_.xd = function cl(a) {
    a.a += "(-\u221E";
};
$61de1ee1cac498ae$var$_.yd = function dl(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$xcb);
};
$61de1ee1cac498ae$var$_.zd = function el() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$uie));
};
$61de1ee1cac498ae$var$_.Hb = function fl() {
    return $61de1ee1cac498ae$var$Zfb(), $61de1ee1cac498ae$var$kCb(this);
};
$61de1ee1cac498ae$var$_.Ad = function gl(a) {
    return true;
};
$61de1ee1cac498ae$var$_.Ib = function hl() {
    return "-\u221E";
};
var $61de1ee1cac498ae$var$$k;
var $61de1ee1cac498ae$var$oF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Cut/BelowAll", 1760);
$61de1ee1cac498ae$var$bcb(1762, 245, $61de1ee1cac498ae$var$tie, $61de1ee1cac498ae$var$il);
$61de1ee1cac498ae$var$_.xd = function jl(a) {
    $61de1ee1cac498ae$var$Pfb((a.a += "[", a), this.a);
};
$61de1ee1cac498ae$var$_.yd = function kl(a) {
    $61de1ee1cac498ae$var$Kfb($61de1ee1cac498ae$var$Pfb(a, this.a), 41);
};
$61de1ee1cac498ae$var$_.Hb = function ll() {
    return $61de1ee1cac498ae$var$tb(this.a);
};
$61de1ee1cac498ae$var$_.Ad = function ml(a) {
    return $61de1ee1cac498ae$var$ex(), $61de1ee1cac498ae$var$Fcb(this.a, a) <= 0;
};
$61de1ee1cac498ae$var$_.Ib = function nl() {
    return "\\" + this.a + "/";
};
var $61de1ee1cac498ae$var$pF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Cut/BelowValue", 1762);
$61de1ee1cac498ae$var$bcb(537, 1, $61de1ee1cac498ae$var$vie);
$61de1ee1cac498ae$var$_.Jc = function ql(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function rl() {
    return $61de1ee1cac498ae$var$tr($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rb(this, "use Optional.orNull() instead of Optional.or(null)"), 20).Kc());
};
var $61de1ee1cac498ae$var$uF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "FluentIterable", 537);
$61de1ee1cac498ae$var$bcb(433, 537, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$sl);
$61de1ee1cac498ae$var$_.Kc = function tl() {
    return new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur(this.a.Kc(), new $61de1ee1cac498ae$var$Sq));
};
var $61de1ee1cac498ae$var$rF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "FluentIterable/2", 433);
$61de1ee1cac498ae$var$bcb(1046, 537, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$vl);
$61de1ee1cac498ae$var$_.Kc = function wl() {
    return $61de1ee1cac498ae$var$ul(this);
};
var $61de1ee1cac498ae$var$tF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "FluentIterable/3", 1046);
$61de1ee1cac498ae$var$bcb(708, 386, $61de1ee1cac498ae$var$$he, $61de1ee1cac498ae$var$xl);
$61de1ee1cac498ae$var$_.Xb = function yl(a) {
    return this.a[a].Kc();
};
var $61de1ee1cac498ae$var$sF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "FluentIterable/3/1", 708);
$61de1ee1cac498ae$var$bcb(1972, 1, {});
$61de1ee1cac498ae$var$_.Ib = function zl() {
    return $61de1ee1cac498ae$var$fcb(this.Bd().b);
};
var $61de1ee1cac498ae$var$BF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingObject", 1972);
$61de1ee1cac498ae$var$bcb(1973, 1972, $61de1ee1cac498ae$var$wie);
$61de1ee1cac498ae$var$_.Bd = function Fl() {
    return this.Cd();
};
$61de1ee1cac498ae$var$_.Jc = function Gl(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Lc = function Jl() {
    return this.Oc();
};
$61de1ee1cac498ae$var$_.Nc = function Ml() {
    return new $61de1ee1cac498ae$var$Kub(this, 0);
};
$61de1ee1cac498ae$var$_.Oc = function Nl() {
    return new $61de1ee1cac498ae$var$YAb(null, this.Nc());
};
$61de1ee1cac498ae$var$_.Fc = function Al(a) {
    return this.Cd(), $61de1ee1cac498ae$var$enb();
};
$61de1ee1cac498ae$var$_.Gc = function Bl(a) {
    return this.Cd(), $61de1ee1cac498ae$var$fnb();
};
$61de1ee1cac498ae$var$_.$b = function Cl() {
    this.Cd(), $61de1ee1cac498ae$var$gnb();
};
$61de1ee1cac498ae$var$_.Hc = function Dl(a) {
    return this.Cd().Hc(a);
};
$61de1ee1cac498ae$var$_.Ic = function El(a) {
    return this.Cd().Ic(a);
};
$61de1ee1cac498ae$var$_.dc = function Hl() {
    return this.Cd().b.dc();
};
$61de1ee1cac498ae$var$_.Kc = function Il() {
    return this.Cd().Kc();
};
$61de1ee1cac498ae$var$_.Mc = function Kl(a) {
    return this.Cd(), $61de1ee1cac498ae$var$jnb();
};
$61de1ee1cac498ae$var$_.gc = function Ll() {
    return this.Cd().b.gc();
};
$61de1ee1cac498ae$var$_.Pc = function Ol() {
    return this.Cd().Pc();
};
$61de1ee1cac498ae$var$_.Qc = function Pl(a) {
    return this.Cd().Qc(a);
};
var $61de1ee1cac498ae$var$vF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingCollection", 1973);
$61de1ee1cac498ae$var$bcb(1980, 28, $61de1ee1cac498ae$var$xie);
$61de1ee1cac498ae$var$_.Kc = function Xl() {
    return this.Ed();
};
$61de1ee1cac498ae$var$_.Fc = function Sl(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Gc = function Tl(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.$b = function Ul() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Hc = function Vl(a) {
    return a != null && $61de1ee1cac498ae$var$ze(this, a, false);
};
$61de1ee1cac498ae$var$_.Dd = function Wl() {
    switch(this.gc()){
        case 0:
            return $61de1ee1cac498ae$var$im(), $61de1ee1cac498ae$var$im(), $61de1ee1cac498ae$var$hm;
        case 1:
            return $61de1ee1cac498ae$var$im(), new $61de1ee1cac498ae$var$my($61de1ee1cac498ae$var$Qb(this.Ed().Pb()));
        default:
            return new $61de1ee1cac498ae$var$px(this, this.Pc());
    }
};
$61de1ee1cac498ae$var$_.Mc = function Yl(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$WF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableCollection", 1980);
$61de1ee1cac498ae$var$bcb(712, 1980, $61de1ee1cac498ae$var$xie, $61de1ee1cac498ae$var$Zl);
$61de1ee1cac498ae$var$_.Kc = function cm() {
    return $61de1ee1cac498ae$var$vr(this.a.Kc());
};
$61de1ee1cac498ae$var$_.Hc = function $l(a) {
    return a != null && this.a.Hc(a);
};
$61de1ee1cac498ae$var$_.Ic = function _l(a) {
    return this.a.Ic(a);
};
$61de1ee1cac498ae$var$_.dc = function am() {
    return this.a.dc();
};
$61de1ee1cac498ae$var$_.Ed = function bm() {
    return $61de1ee1cac498ae$var$vr(this.a.Kc());
};
$61de1ee1cac498ae$var$_.gc = function dm() {
    return this.a.gc();
};
$61de1ee1cac498ae$var$_.Pc = function em() {
    return this.a.Pc();
};
$61de1ee1cac498ae$var$_.Qc = function fm(a) {
    return this.a.Qc(a);
};
$61de1ee1cac498ae$var$_.Ib = function gm() {
    return $61de1ee1cac498ae$var$fcb(this.a);
};
var $61de1ee1cac498ae$var$wF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingImmutableCollection", 712);
$61de1ee1cac498ae$var$bcb(152, 1980, $61de1ee1cac498ae$var$yie);
$61de1ee1cac498ae$var$_.Kc = function sm() {
    return this.Ed();
};
$61de1ee1cac498ae$var$_.Yc = function tm() {
    return this.Fd(0);
};
$61de1ee1cac498ae$var$_.Zc = function vm(a) {
    return this.Fd(a);
};
$61de1ee1cac498ae$var$_.ad = function zm(a) {
    $61de1ee1cac498ae$var$ktb(this, a);
};
$61de1ee1cac498ae$var$_.Nc = function Am() {
    return new $61de1ee1cac498ae$var$Kub(this, 16);
};
$61de1ee1cac498ae$var$_.bd = function Cm(a, b) {
    return this.Gd(a, b);
};
$61de1ee1cac498ae$var$_.Vc = function lm(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wc = function mm(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Fb = function om(a) {
    return $61de1ee1cac498ae$var$Ju(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function pm() {
    return $61de1ee1cac498ae$var$Ku(this);
};
$61de1ee1cac498ae$var$_.Xc = function qm(a) {
    return a == null ? -1 : $61de1ee1cac498ae$var$Lu(this, a);
};
$61de1ee1cac498ae$var$_.Ed = function rm() {
    return this.Fd(0);
};
$61de1ee1cac498ae$var$_.Fd = function um(a) {
    return $61de1ee1cac498ae$var$jm(this, a);
};
$61de1ee1cac498ae$var$_.$c = function xm(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_._c = function ym(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Gd = function Bm(a, b) {
    var c;
    return $61de1ee1cac498ae$var$Dm((c = new $61de1ee1cac498ae$var$$u(this), new $61de1ee1cac498ae$var$Jib(c, a, b)));
};
var $61de1ee1cac498ae$var$hm;
var $61de1ee1cac498ae$var$_F = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableList", 152);
$61de1ee1cac498ae$var$bcb(2006, 152, $61de1ee1cac498ae$var$yie);
$61de1ee1cac498ae$var$_.Kc = function Nm() {
    return $61de1ee1cac498ae$var$vr(this.Hd().Kc());
};
$61de1ee1cac498ae$var$_.bd = function Qm(a, b) {
    return $61de1ee1cac498ae$var$Dm(this.Hd().bd(a, b));
};
$61de1ee1cac498ae$var$_.Hc = function Fm(a) {
    return a != null && this.Hd().Hc(a);
};
$61de1ee1cac498ae$var$_.Ic = function Gm(a) {
    return this.Hd().Ic(a);
};
$61de1ee1cac498ae$var$_.Fb = function Hm(a) {
    return $61de1ee1cac498ae$var$pb(this.Hd(), a);
};
$61de1ee1cac498ae$var$_.Xb = function Im(a) {
    return $61de1ee1cac498ae$var$Em(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Jm() {
    return $61de1ee1cac498ae$var$tb(this.Hd());
};
$61de1ee1cac498ae$var$_.Xc = function Km(a) {
    return this.Hd().Xc(a);
};
$61de1ee1cac498ae$var$_.dc = function Lm() {
    return this.Hd().dc();
};
$61de1ee1cac498ae$var$_.Ed = function Mm() {
    return $61de1ee1cac498ae$var$vr(this.Hd().Kc());
};
$61de1ee1cac498ae$var$_.gc = function Om() {
    return this.Hd().gc();
};
$61de1ee1cac498ae$var$_.Gd = function Pm(a, b) {
    return $61de1ee1cac498ae$var$Dm(this.Hd().bd(a, b));
};
$61de1ee1cac498ae$var$_.Pc = function Rm() {
    return this.Hd().Qc($61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, this.Hd().gc(), 5, 1));
};
$61de1ee1cac498ae$var$_.Qc = function Sm(a) {
    return this.Hd().Qc(a);
};
$61de1ee1cac498ae$var$_.Ib = function Tm() {
    return $61de1ee1cac498ae$var$fcb(this.Hd());
};
var $61de1ee1cac498ae$var$xF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingImmutableList", 2006);
$61de1ee1cac498ae$var$bcb(714, 1, $61de1ee1cac498ae$var$Aie);
$61de1ee1cac498ae$var$_.vc = function cn() {
    return $61de1ee1cac498ae$var$Wm(this);
};
$61de1ee1cac498ae$var$_.wc = function en(a) {
    $61de1ee1cac498ae$var$stb(this, a);
};
$61de1ee1cac498ae$var$_.ec = function jn() {
    return $61de1ee1cac498ae$var$Xm(this);
};
$61de1ee1cac498ae$var$_.yc = function kn(a, b, c) {
    return $61de1ee1cac498ae$var$ttb(this, a, b, c);
};
$61de1ee1cac498ae$var$_.Cc = function rn() {
    return this.Ld();
};
$61de1ee1cac498ae$var$_.$b = function Zm() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_._b = function $m(a) {
    return this.xc(a) != null;
};
$61de1ee1cac498ae$var$_.uc = function _m(a) {
    return this.Ld().Hc(a);
};
$61de1ee1cac498ae$var$_.Jd = function an() {
    return new $61de1ee1cac498ae$var$jq(this);
};
$61de1ee1cac498ae$var$_.Kd = function bn() {
    return new $61de1ee1cac498ae$var$sq(this);
};
$61de1ee1cac498ae$var$_.Fb = function dn(a) {
    return $61de1ee1cac498ae$var$Dv(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function gn() {
    return $61de1ee1cac498ae$var$Wm(this).Hb();
};
$61de1ee1cac498ae$var$_.dc = function hn() {
    return this.gc() == 0;
};
$61de1ee1cac498ae$var$_.zc = function nn(a, b) {
    return $61de1ee1cac498ae$var$Ym();
};
$61de1ee1cac498ae$var$_.Bc = function on(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Ib = function pn() {
    return $61de1ee1cac498ae$var$Jv(this);
};
$61de1ee1cac498ae$var$_.Ld = function qn() {
    if (this.e) return this.e;
    return this.e = this.Kd();
};
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.d = null;
$61de1ee1cac498ae$var$_.e = null;
var $61de1ee1cac498ae$var$Um;
var $61de1ee1cac498ae$var$iG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMap", 714);
$61de1ee1cac498ae$var$bcb(715, 714, $61de1ee1cac498ae$var$Aie);
$61de1ee1cac498ae$var$_._b = function vn(a) {
    return $61de1ee1cac498ae$var$sn(this, a);
};
$61de1ee1cac498ae$var$_.uc = function wn(a) {
    return $61de1ee1cac498ae$var$dob(this.b, a);
};
$61de1ee1cac498ae$var$_.Id = function xn() {
    return $61de1ee1cac498ae$var$Vn(new $61de1ee1cac498ae$var$Ln(this));
};
$61de1ee1cac498ae$var$_.Jd = function yn() {
    return $61de1ee1cac498ae$var$Vn($61de1ee1cac498ae$var$gob(this.b));
};
$61de1ee1cac498ae$var$_.Kd = function zn() {
    return $61de1ee1cac498ae$var$Ql(), new $61de1ee1cac498ae$var$Zl($61de1ee1cac498ae$var$hob(this.b));
};
$61de1ee1cac498ae$var$_.Fb = function An(a) {
    return $61de1ee1cac498ae$var$fob(this.b, a);
};
$61de1ee1cac498ae$var$_.xc = function Bn(a) {
    return $61de1ee1cac498ae$var$tn(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Cn() {
    return $61de1ee1cac498ae$var$tb(this.b.c);
};
$61de1ee1cac498ae$var$_.dc = function Dn() {
    return this.b.c.dc();
};
$61de1ee1cac498ae$var$_.gc = function En() {
    return this.b.c.gc();
};
$61de1ee1cac498ae$var$_.Ib = function Fn() {
    return $61de1ee1cac498ae$var$fcb(this.b.c);
};
var $61de1ee1cac498ae$var$zF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingImmutableMap", 715);
$61de1ee1cac498ae$var$bcb(1974, 1973, $61de1ee1cac498ae$var$Bie);
$61de1ee1cac498ae$var$_.Bd = function Gn() {
    return this.Md();
};
$61de1ee1cac498ae$var$_.Cd = function Hn() {
    return this.Md();
};
$61de1ee1cac498ae$var$_.Nc = function Kn() {
    return new $61de1ee1cac498ae$var$Kub(this, 1);
};
$61de1ee1cac498ae$var$_.Fb = function In(a) {
    return a === this || this.Md().Fb(a);
};
$61de1ee1cac498ae$var$_.Hb = function Jn() {
    return this.Md().Hb();
};
var $61de1ee1cac498ae$var$CF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingSet", 1974);
$61de1ee1cac498ae$var$bcb(1069, 1974, $61de1ee1cac498ae$var$Bie, $61de1ee1cac498ae$var$Ln);
$61de1ee1cac498ae$var$_.Bd = function Nn() {
    return $61de1ee1cac498ae$var$eob(this.a.b);
};
$61de1ee1cac498ae$var$_.Cd = function On() {
    return $61de1ee1cac498ae$var$eob(this.a.b);
};
$61de1ee1cac498ae$var$_.Hc = function Mn(b) {
    if ($61de1ee1cac498ae$var$JD(b, 42) && $61de1ee1cac498ae$var$BD(b, 42).cd() == null) return false;
    try {
        return $61de1ee1cac498ae$var$Dob($61de1ee1cac498ae$var$eob(this.a.b), b);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 205)) return false;
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.Md = function Pn() {
    return $61de1ee1cac498ae$var$eob(this.a.b);
};
$61de1ee1cac498ae$var$_.Qc = function Qn(a) {
    var b;
    b = $61de1ee1cac498ae$var$Eob($61de1ee1cac498ae$var$eob(this.a.b), a);
    $61de1ee1cac498ae$var$eob(this.a.b).b.gc() < b.length && $61de1ee1cac498ae$var$NC(b, $61de1ee1cac498ae$var$eob(this.a.b).b.gc(), null);
    return b;
};
var $61de1ee1cac498ae$var$yF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingImmutableMap/1", 1069);
$61de1ee1cac498ae$var$bcb(1981, 1980, $61de1ee1cac498ae$var$Cie);
$61de1ee1cac498ae$var$_.Kc = function Tn() {
    return this.Ed();
};
$61de1ee1cac498ae$var$_.Nc = function Un() {
    return new $61de1ee1cac498ae$var$Kub(this, 1);
};
$61de1ee1cac498ae$var$_.Fb = function Rn(a) {
    return $61de1ee1cac498ae$var$Ax(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Sn() {
    return $61de1ee1cac498ae$var$Bx(this);
};
var $61de1ee1cac498ae$var$jG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableSet", 1981);
$61de1ee1cac498ae$var$bcb(703, 1981, $61de1ee1cac498ae$var$Cie);
$61de1ee1cac498ae$var$_.Kc = function ao() {
    return $61de1ee1cac498ae$var$vr(new $61de1ee1cac498ae$var$Dnb(this.a.b.Kc()));
};
$61de1ee1cac498ae$var$_.Hc = function Xn(a) {
    return a != null && $61de1ee1cac498ae$var$hnb(this.a, a);
};
$61de1ee1cac498ae$var$_.Ic = function Yn(a) {
    return $61de1ee1cac498ae$var$inb(this.a, a);
};
$61de1ee1cac498ae$var$_.Hb = function Zn() {
    return $61de1ee1cac498ae$var$tb(this.a.b);
};
$61de1ee1cac498ae$var$_.dc = function $n() {
    return this.a.b.dc();
};
$61de1ee1cac498ae$var$_.Ed = function _n() {
    return $61de1ee1cac498ae$var$vr(new $61de1ee1cac498ae$var$Dnb(this.a.b.Kc()));
};
$61de1ee1cac498ae$var$_.gc = function bo() {
    return this.a.b.gc();
};
$61de1ee1cac498ae$var$_.Pc = function co() {
    return this.a.b.Pc();
};
$61de1ee1cac498ae$var$_.Qc = function eo(a) {
    return $61de1ee1cac498ae$var$knb(this.a, a);
};
$61de1ee1cac498ae$var$_.Ib = function fo() {
    return $61de1ee1cac498ae$var$fcb(this.a.b);
};
var $61de1ee1cac498ae$var$AF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingImmutableSet", 703);
$61de1ee1cac498ae$var$bcb(1975, 1974, $61de1ee1cac498ae$var$Die);
$61de1ee1cac498ae$var$_.Bd = function go() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Cd = function ho() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Md = function io() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Nc = function jo() {
    return new $61de1ee1cac498ae$var$Rub(this);
};
var $61de1ee1cac498ae$var$DF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ForwardingSortedSet", 1975);
$61de1ee1cac498ae$var$bcb(533, 1979, $61de1ee1cac498ae$var$Aie, $61de1ee1cac498ae$var$wo);
$61de1ee1cac498ae$var$_.Ac = function Fo(a) {
    $61de1ee1cac498ae$var$Ld(this, a);
};
$61de1ee1cac498ae$var$_.Cc = function Io() {
    var a;
    return a = this.d, new $61de1ee1cac498ae$var$up(!a ? this.d = new $61de1ee1cac498ae$var$ap(this) : a);
};
$61de1ee1cac498ae$var$_.$b = function xo() {
    $61de1ee1cac498ae$var$ko(this);
};
$61de1ee1cac498ae$var$_._b = function yo(a) {
    return !!$61de1ee1cac498ae$var$uo(this, a, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15))));
};
$61de1ee1cac498ae$var$_.uc = function zo(a) {
    return $61de1ee1cac498ae$var$lo(this, a);
};
$61de1ee1cac498ae$var$_.kc = function Ao() {
    return new $61de1ee1cac498ae$var$Qo(this, this);
};
$61de1ee1cac498ae$var$_.wc = function Bo(a) {
    $61de1ee1cac498ae$var$no(this, a);
};
$61de1ee1cac498ae$var$_.xc = function Co(a) {
    return $61de1ee1cac498ae$var$oo(this, a);
};
$61de1ee1cac498ae$var$_.ec = function Do() {
    return new $61de1ee1cac498ae$var$Bp(this);
};
$61de1ee1cac498ae$var$_.zc = function Eo(a, b) {
    return $61de1ee1cac498ae$var$ro(this, a, b);
};
$61de1ee1cac498ae$var$_.Bc = function Go(a) {
    var b;
    b = $61de1ee1cac498ae$var$uo(this, a, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15))));
    if (!b) return null;
    else {
        $61de1ee1cac498ae$var$mo(this, b);
        b.e = null;
        b.c = null;
        return b.i;
    }
};
$61de1ee1cac498ae$var$_.gc = function Ho() {
    return this.i;
};
$61de1ee1cac498ae$var$_.pd = function Jo() {
    var a;
    return a = this.d, new $61de1ee1cac498ae$var$up(!a ? this.d = new $61de1ee1cac498ae$var$ap(this) : a);
};
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
var $61de1ee1cac498ae$var$QF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap", 533);
$61de1ee1cac498ae$var$bcb(534, 1, $61de1ee1cac498ae$var$aie);
$61de1ee1cac498ae$var$_.Nb = function Mo(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function No() {
    return $61de1ee1cac498ae$var$Ko(this);
};
$61de1ee1cac498ae$var$_.Pb = function Oo() {
    var a;
    if (!$61de1ee1cac498ae$var$Ko(this)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    a = this.c;
    this.c = a.c;
    this.f = a;
    --this.d;
    return this.Nd(a);
};
$61de1ee1cac498ae$var$_.Qb = function Po() {
    if (this.e.g != this.b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
    $61de1ee1cac498ae$var$Vb(!!this.f);
    $61de1ee1cac498ae$var$mo(this.e, this.f);
    this.b = this.e.g;
    this.f = null;
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.f = null;
var $61de1ee1cac498ae$var$NF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/Itr", 534);
$61de1ee1cac498ae$var$bcb(1011, 534, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Qo);
$61de1ee1cac498ae$var$_.Nd = function Ro(a) {
    return new $61de1ee1cac498ae$var$So(this, a);
};
var $61de1ee1cac498ae$var$FF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/1", 1011);
$61de1ee1cac498ae$var$bcb(1012, 345, $61de1ee1cac498ae$var$kie, $61de1ee1cac498ae$var$So);
$61de1ee1cac498ae$var$_.cd = function To() {
    return this.a.g;
};
$61de1ee1cac498ae$var$_.dd = function Uo() {
    return this.a.i;
};
$61de1ee1cac498ae$var$_.ed = function Vo(a) {
    var b, c, d;
    c = this.a.i;
    d = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15)));
    if (d == this.a.f && ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(c) || a != null && $61de1ee1cac498ae$var$pb(a, c))) return a;
    $61de1ee1cac498ae$var$Nb(!$61de1ee1cac498ae$var$vo(this.b.a, a, d), a);
    $61de1ee1cac498ae$var$mo(this.b.a, this.a);
    b = new $61de1ee1cac498ae$var$$o(this.a.g, this.a.a, a, d);
    $61de1ee1cac498ae$var$po(this.b.a, b, this.a);
    this.a.e = null;
    this.a.c = null;
    this.b.b = this.b.a.g;
    this.b.f == this.a && (this.b.f = b);
    this.a = b;
    return c;
};
var $61de1ee1cac498ae$var$EF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/1/MapEntry", 1012);
$61de1ee1cac498ae$var$bcb(238, 345, {
    345: 1,
    238: 1,
    3: 1,
    42: 1
}, $61de1ee1cac498ae$var$Wo);
$61de1ee1cac498ae$var$_.cd = function Xo() {
    return this.g;
};
$61de1ee1cac498ae$var$_.dd = function Yo() {
    return this.i;
};
$61de1ee1cac498ae$var$_.ed = function Zo(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$XF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableEntry", 238);
$61de1ee1cac498ae$var$bcb(317, 238, {
    345: 1,
    317: 1,
    238: 1,
    3: 1,
    42: 1
}, $61de1ee1cac498ae$var$$o);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$GF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/BiEntry", 317);
$61de1ee1cac498ae$var$bcb(610, 1979, $61de1ee1cac498ae$var$Aie, $61de1ee1cac498ae$var$ap);
$61de1ee1cac498ae$var$_.Ac = function jp(a) {
    $61de1ee1cac498ae$var$Ld(this, a);
};
$61de1ee1cac498ae$var$_.Cc = function mp() {
    return new $61de1ee1cac498ae$var$Bp(this.a);
};
$61de1ee1cac498ae$var$_.$b = function bp() {
    $61de1ee1cac498ae$var$ko(this.a);
};
$61de1ee1cac498ae$var$_._b = function cp(a) {
    return $61de1ee1cac498ae$var$lo(this.a, a);
};
$61de1ee1cac498ae$var$_.kc = function dp() {
    return new $61de1ee1cac498ae$var$op(this, this.a);
};
$61de1ee1cac498ae$var$_.wc = function ep(a) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$no(this.a, new $61de1ee1cac498ae$var$zp(a));
};
$61de1ee1cac498ae$var$_.xc = function fp(a) {
    return $61de1ee1cac498ae$var$_o(this, a);
};
$61de1ee1cac498ae$var$_.ec = function gp() {
    return new $61de1ee1cac498ae$var$up(this);
};
$61de1ee1cac498ae$var$_.zc = function ip(a, b) {
    return $61de1ee1cac498ae$var$so(this.a, a, b, false);
};
$61de1ee1cac498ae$var$_.Bc = function kp(a) {
    var b;
    b = $61de1ee1cac498ae$var$vo(this.a, a, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15))));
    if (!b) return null;
    else {
        $61de1ee1cac498ae$var$mo(this.a, b);
        b.e = null;
        b.c = null;
        return b.g;
    }
};
$61de1ee1cac498ae$var$_.gc = function lp() {
    return this.a.i;
};
$61de1ee1cac498ae$var$_.pd = function np() {
    return new $61de1ee1cac498ae$var$Bp(this.a);
};
var $61de1ee1cac498ae$var$MF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/Inverse", 610);
$61de1ee1cac498ae$var$bcb(1008, 534, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$op);
$61de1ee1cac498ae$var$_.Nd = function pp(a) {
    return new $61de1ee1cac498ae$var$qp(this, a);
};
var $61de1ee1cac498ae$var$IF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/Inverse/1", 1008);
$61de1ee1cac498ae$var$bcb(1009, 345, $61de1ee1cac498ae$var$kie, $61de1ee1cac498ae$var$qp);
$61de1ee1cac498ae$var$_.cd = function rp() {
    return this.a.i;
};
$61de1ee1cac498ae$var$_.dd = function sp() {
    return this.a.g;
};
$61de1ee1cac498ae$var$_.ed = function tp(a) {
    var b, c, d;
    d = this.a.g;
    b = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15)));
    if (b == this.a.a && ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(d) || a != null && $61de1ee1cac498ae$var$pb(a, d))) return a;
    $61de1ee1cac498ae$var$Nb(!$61de1ee1cac498ae$var$uo(this.b.a.a, a, b), a);
    $61de1ee1cac498ae$var$mo(this.b.a.a, this.a);
    c = new $61de1ee1cac498ae$var$$o(a, b, this.a.i, this.a.f);
    this.a = c;
    $61de1ee1cac498ae$var$po(this.b.a.a, c, null);
    this.b.b = this.b.a.a.g;
    return d;
};
var $61de1ee1cac498ae$var$HF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/Inverse/1/InverseEntry", 1009);
$61de1ee1cac498ae$var$bcb(611, 532, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$up);
$61de1ee1cac498ae$var$_.Kc = function vp() {
    return new $61de1ee1cac498ae$var$xp(this.a.a);
};
$61de1ee1cac498ae$var$_.Mc = function wp(a) {
    var b;
    b = $61de1ee1cac498ae$var$vo(this.a.a, a, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15))));
    if (!b) return false;
    else {
        $61de1ee1cac498ae$var$mo(this.a.a, b);
        return true;
    }
};
var $61de1ee1cac498ae$var$KF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/Inverse/InverseKeySet", 611);
$61de1ee1cac498ae$var$bcb(1007, 534, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$xp);
$61de1ee1cac498ae$var$_.Nd = function yp(a) {
    return a.i;
};
var $61de1ee1cac498ae$var$JF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/Inverse/InverseKeySet/1", 1007);
$61de1ee1cac498ae$var$bcb(1010, 1, {}, $61de1ee1cac498ae$var$zp);
$61de1ee1cac498ae$var$_.Od = function Ap(a, b) {
    $61de1ee1cac498ae$var$hp(this.a, a, b);
};
var $61de1ee1cac498ae$var$LF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/Inverse/lambda$0$Type", 1010);
$61de1ee1cac498ae$var$bcb(609, 532, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$Bp);
$61de1ee1cac498ae$var$_.Kc = function Cp() {
    return new $61de1ee1cac498ae$var$Ep(this.a);
};
$61de1ee1cac498ae$var$_.Mc = function Dp(a) {
    var b;
    b = $61de1ee1cac498ae$var$uo(this.a, a, $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15))));
    if (!b) return false;
    else {
        $61de1ee1cac498ae$var$mo(this.a, b);
        b.e = null;
        b.c = null;
        return true;
    }
};
var $61de1ee1cac498ae$var$PF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/KeySet", 609);
$61de1ee1cac498ae$var$bcb(1006, 534, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Ep);
$61de1ee1cac498ae$var$_.Nd = function Fp(a) {
    return a.g;
};
var $61de1ee1cac498ae$var$OF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashBiMap/KeySet/1", 1006);
$61de1ee1cac498ae$var$bcb(1093, 619, $61de1ee1cac498ae$var$_he);
var $61de1ee1cac498ae$var$RF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashMultimapGwtSerializationDependencies", 1093);
$61de1ee1cac498ae$var$bcb(265, 1093, $61de1ee1cac498ae$var$_he, $61de1ee1cac498ae$var$Hp);
$61de1ee1cac498ae$var$_.hc = function Ip() {
    return new $61de1ee1cac498ae$var$Uqb($61de1ee1cac498ae$var$Cv(this.a));
};
$61de1ee1cac498ae$var$_.gd = function Jp() {
    return new $61de1ee1cac498ae$var$Uqb($61de1ee1cac498ae$var$Cv(this.a));
};
$61de1ee1cac498ae$var$_.a = 2;
var $61de1ee1cac498ae$var$SF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "HashMultimap", 265);
$61de1ee1cac498ae$var$bcb(1999, 152, $61de1ee1cac498ae$var$yie);
$61de1ee1cac498ae$var$_.Hc = function Mp(a) {
    return this.Pd().Hc(a);
};
$61de1ee1cac498ae$var$_.dc = function Np() {
    return this.Pd().dc();
};
$61de1ee1cac498ae$var$_.gc = function Op() {
    return this.Pd().gc();
};
var $61de1ee1cac498ae$var$TF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableAsList", 1999);
$61de1ee1cac498ae$var$bcb(1931, 715, $61de1ee1cac498ae$var$Aie);
$61de1ee1cac498ae$var$_.Ld = function Qp() {
    return $61de1ee1cac498ae$var$Ql(), new $61de1ee1cac498ae$var$oy(this.a);
};
$61de1ee1cac498ae$var$_.Cc = function Rp() {
    return $61de1ee1cac498ae$var$Ql(), new $61de1ee1cac498ae$var$oy(this.a);
};
$61de1ee1cac498ae$var$_.pd = function Sp() {
    return $61de1ee1cac498ae$var$Ql(), new $61de1ee1cac498ae$var$oy(this.a);
};
var $61de1ee1cac498ae$var$UF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableBiMap", 1931);
$61de1ee1cac498ae$var$bcb(1977, 1, {});
var $61de1ee1cac498ae$var$VF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableCollection/Builder", 1977);
$61de1ee1cac498ae$var$bcb(1022, 703, $61de1ee1cac498ae$var$Cie, $61de1ee1cac498ae$var$Tp);
var $61de1ee1cac498ae$var$YF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableEnumSet", 1022);
$61de1ee1cac498ae$var$bcb(969, 386, $61de1ee1cac498ae$var$$he, $61de1ee1cac498ae$var$Vp);
$61de1ee1cac498ae$var$_.Xb = function Wp(a) {
    return this.a.Xb(a);
};
var $61de1ee1cac498ae$var$ZF = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableList/1", 969);
$61de1ee1cac498ae$var$bcb(968, 1977, {}, $61de1ee1cac498ae$var$Xp);
var $61de1ee1cac498ae$var$$F = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableList/Builder", 968);
$61de1ee1cac498ae$var$bcb(614, 198, $61de1ee1cac498ae$var$Yhe, $61de1ee1cac498ae$var$Yp);
$61de1ee1cac498ae$var$_.Ob = function Zp() {
    return this.a.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function $p() {
    return $61de1ee1cac498ae$var$BD(this.a.Pb(), 42).cd();
};
var $61de1ee1cac498ae$var$aG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMap/1", 614);
$61de1ee1cac498ae$var$bcb(1041, 1, {}, $61de1ee1cac498ae$var$_p);
$61de1ee1cac498ae$var$_.Kb = function aq(a) {
    return $61de1ee1cac498ae$var$BD(a, 42).cd();
};
var $61de1ee1cac498ae$var$bG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMap/2methodref$getKey$Type", 1041);
$61de1ee1cac498ae$var$bcb(1040, 1, {}, $61de1ee1cac498ae$var$cq);
var $61de1ee1cac498ae$var$cG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMap/Builder", 1040);
$61de1ee1cac498ae$var$bcb(2000, 1981, $61de1ee1cac498ae$var$Cie);
$61de1ee1cac498ae$var$_.Kc = function gq() {
    var a;
    return a = $61de1ee1cac498ae$var$Wm(this.a).Ed(), new $61de1ee1cac498ae$var$Yp(a);
};
$61de1ee1cac498ae$var$_.Dd = function dq() {
    return new $61de1ee1cac498ae$var$Fq(this);
};
$61de1ee1cac498ae$var$_.Jc = function eq(a) {
    var b, c;
    $61de1ee1cac498ae$var$Qb(a);
    c = this.gc();
    for(b = 0; b < c; b++)a.td($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rl($61de1ee1cac498ae$var$Wm(this.a)).Xb(b), 42).cd());
};
$61de1ee1cac498ae$var$_.Ed = function fq() {
    var a;
    return (a = this.c, !a ? this.c = new $61de1ee1cac498ae$var$Fq(this) : a).Ed();
};
$61de1ee1cac498ae$var$_.Nc = function hq() {
    return $61de1ee1cac498ae$var$Zj(this.gc(), 1296, new $61de1ee1cac498ae$var$Dq(this));
};
var $61de1ee1cac498ae$var$mG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "IndexedImmutableSet", 2000);
$61de1ee1cac498ae$var$bcb(1180, 2000, $61de1ee1cac498ae$var$Cie, $61de1ee1cac498ae$var$jq);
$61de1ee1cac498ae$var$_.Kc = function nq() {
    var a;
    return a = $61de1ee1cac498ae$var$Wm(this.a).Ed(), new $61de1ee1cac498ae$var$Yp(a);
};
$61de1ee1cac498ae$var$_.Hc = function kq(a) {
    return this.a._b(a);
};
$61de1ee1cac498ae$var$_.Jc = function lq(a) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$stb(this.a, new $61de1ee1cac498ae$var$qq(a));
};
$61de1ee1cac498ae$var$_.Ed = function mq() {
    var a;
    return a = $61de1ee1cac498ae$var$Wm(this.a).Ed(), new $61de1ee1cac498ae$var$Yp(a);
};
$61de1ee1cac498ae$var$_.gc = function oq() {
    return this.a.gc();
};
$61de1ee1cac498ae$var$_.Nc = function pq() {
    return $61de1ee1cac498ae$var$$j($61de1ee1cac498ae$var$Wm(this.a).Nc(), new $61de1ee1cac498ae$var$_p);
};
var $61de1ee1cac498ae$var$eG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMapKeySet", 1180);
$61de1ee1cac498ae$var$bcb(1181, 1, {}, $61de1ee1cac498ae$var$qq);
$61de1ee1cac498ae$var$_.Od = function rq(a, b) {
    $61de1ee1cac498ae$var$Ql();
    this.a.td(a);
};
var $61de1ee1cac498ae$var$dG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMapKeySet/lambda$0$Type", 1181);
$61de1ee1cac498ae$var$bcb(1178, 1980, $61de1ee1cac498ae$var$xie, $61de1ee1cac498ae$var$sq);
$61de1ee1cac498ae$var$_.Kc = function vq() {
    return new $61de1ee1cac498ae$var$Aq(this);
};
$61de1ee1cac498ae$var$_.Hc = function tq(a) {
    return a != null && $61de1ee1cac498ae$var$jr(new $61de1ee1cac498ae$var$Aq(this), a);
};
$61de1ee1cac498ae$var$_.Ed = function uq() {
    return new $61de1ee1cac498ae$var$Aq(this);
};
$61de1ee1cac498ae$var$_.gc = function wq() {
    return this.a.gc();
};
$61de1ee1cac498ae$var$_.Nc = function xq() {
    return $61de1ee1cac498ae$var$$j($61de1ee1cac498ae$var$Wm(this.a).Nc(), new $61de1ee1cac498ae$var$yq);
};
var $61de1ee1cac498ae$var$hG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMapValues", 1178);
$61de1ee1cac498ae$var$bcb(1179, 1, {}, $61de1ee1cac498ae$var$yq);
$61de1ee1cac498ae$var$_.Kb = function zq(a) {
    return $61de1ee1cac498ae$var$BD(a, 42).dd();
};
var $61de1ee1cac498ae$var$fG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMapValues/0methodref$getValue$Type", 1179);
$61de1ee1cac498ae$var$bcb(626, 198, $61de1ee1cac498ae$var$Yhe, $61de1ee1cac498ae$var$Aq);
$61de1ee1cac498ae$var$_.Ob = function Bq() {
    return this.a.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Cq() {
    return $61de1ee1cac498ae$var$BD(this.a.Pb(), 42).dd();
};
var $61de1ee1cac498ae$var$gG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "ImmutableMapValues/1", 626);
$61de1ee1cac498ae$var$bcb(1182, 1, {}, $61de1ee1cac498ae$var$Dq);
$61de1ee1cac498ae$var$_.ld = function Eq(a) {
    return $61de1ee1cac498ae$var$iq(this.a, a);
};
var $61de1ee1cac498ae$var$kG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "IndexedImmutableSet/0methodref$get$Type", 1182);
$61de1ee1cac498ae$var$bcb(752, 1999, $61de1ee1cac498ae$var$yie, $61de1ee1cac498ae$var$Fq);
$61de1ee1cac498ae$var$_.Pd = function Gq() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Xb = function Hq(a) {
    return $61de1ee1cac498ae$var$iq(this.a, a);
};
$61de1ee1cac498ae$var$_.gc = function Iq() {
    return this.a.a.gc();
};
var $61de1ee1cac498ae$var$lG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "IndexedImmutableSet/1", 752);
$61de1ee1cac498ae$var$bcb(44, 1, {}, $61de1ee1cac498ae$var$Sq);
$61de1ee1cac498ae$var$_.Kb = function Tq(a) {
    return $61de1ee1cac498ae$var$BD(a, 20).Kc();
};
$61de1ee1cac498ae$var$_.Fb = function Uq(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$nG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterables/10", 44);
$61de1ee1cac498ae$var$bcb(1042, 537, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$Wq);
$61de1ee1cac498ae$var$_.Jc = function Xq(a) {
    $61de1ee1cac498ae$var$Qb(a);
    this.b.Jc(new $61de1ee1cac498ae$var$$q(this.a, a));
};
$61de1ee1cac498ae$var$_.Kc = function Yq() {
    return $61de1ee1cac498ae$var$Vq(this);
};
var $61de1ee1cac498ae$var$pG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterables/4", 1042);
$61de1ee1cac498ae$var$bcb(1043, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$$q);
$61de1ee1cac498ae$var$_.td = function _q(a) {
    $61de1ee1cac498ae$var$Zq(this.b, this.a, a);
};
var $61de1ee1cac498ae$var$oG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterables/4/lambda$0$Type", 1043);
$61de1ee1cac498ae$var$bcb(1044, 537, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$ar);
$61de1ee1cac498ae$var$_.Jc = function br(a) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$reb(this.a, new $61de1ee1cac498ae$var$dr(a, this.b));
};
$61de1ee1cac498ae$var$_.Kc = function cr() {
    return $61de1ee1cac498ae$var$ur(new $61de1ee1cac498ae$var$Fyd(this.a), this.b);
};
var $61de1ee1cac498ae$var$rG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterables/5", 1044);
$61de1ee1cac498ae$var$bcb(1045, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$dr);
$61de1ee1cac498ae$var$_.td = function er(a) {
    this.a.td($61de1ee1cac498ae$var$Gfd(a));
};
var $61de1ee1cac498ae$var$qG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterables/5/lambda$0$Type", 1045);
$61de1ee1cac498ae$var$bcb(1071, 198, $61de1ee1cac498ae$var$Yhe, $61de1ee1cac498ae$var$wr);
$61de1ee1cac498ae$var$_.Ob = function xr() {
    return this.a.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function yr() {
    return this.a.Pb();
};
var $61de1ee1cac498ae$var$sG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterators/1", 1071);
$61de1ee1cac498ae$var$bcb(1072, 699, $61de1ee1cac498ae$var$Yhe, $61de1ee1cac498ae$var$zr);
$61de1ee1cac498ae$var$_.Yb = function Ar() {
    var a;
    while(this.b.Ob()){
        a = this.b.Pb();
        if (this.a.Lb(a)) return a;
    }
    return this.e = 2, null;
};
var $61de1ee1cac498ae$var$tG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterators/5", 1072);
$61de1ee1cac498ae$var$bcb(487, 1, $61de1ee1cac498ae$var$aie);
$61de1ee1cac498ae$var$_.Nb = function Cr(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Dr() {
    return this.b.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Er() {
    return this.Qd(this.b.Pb());
};
$61de1ee1cac498ae$var$_.Qb = function Fr() {
    this.b.Qb();
};
var $61de1ee1cac498ae$var$KH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "TransformedIterator", 487);
$61de1ee1cac498ae$var$bcb(1073, 487, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Gr);
$61de1ee1cac498ae$var$_.Qd = function Hr(a) {
    return this.a.Kb(a);
};
var $61de1ee1cac498ae$var$uG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterators/6", 1073);
$61de1ee1cac498ae$var$bcb(717, 198, $61de1ee1cac498ae$var$Yhe, $61de1ee1cac498ae$var$Ir);
$61de1ee1cac498ae$var$_.Ob = function Jr() {
    return !this.a;
};
$61de1ee1cac498ae$var$_.Pb = function Kr() {
    if (this.a) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    this.a = true;
    return this.b;
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$vG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterators/9", 717);
$61de1ee1cac498ae$var$bcb(1070, 386, $61de1ee1cac498ae$var$$he, $61de1ee1cac498ae$var$Nr);
$61de1ee1cac498ae$var$_.Xb = function Or(a) {
    return this.a[this.b + a];
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$Lr;
var $61de1ee1cac498ae$var$wG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterators/ArrayItr", 1070);
$61de1ee1cac498ae$var$bcb(39, 1, {
    39: 1,
    47: 1
}, $61de1ee1cac498ae$var$Sr);
$61de1ee1cac498ae$var$_.Nb = function Tr(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Ur() {
    return $61de1ee1cac498ae$var$Qr(this);
};
$61de1ee1cac498ae$var$_.Pb = function Vr() {
    return $61de1ee1cac498ae$var$Rr(this);
};
$61de1ee1cac498ae$var$_.Qb = function Wr() {
    $61de1ee1cac498ae$var$Vb(!!this.c);
    this.c.Qb();
    this.c = null;
};
var $61de1ee1cac498ae$var$xG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Iterators/ConcatenatedIterator", 39);
$61de1ee1cac498ae$var$bcb(22, 1, {
    3: 1,
    35: 1,
    22: 1
});
$61de1ee1cac498ae$var$_.wd = function _r(a) {
    return $61de1ee1cac498ae$var$Xr(this, $61de1ee1cac498ae$var$BD(a, 22));
};
$61de1ee1cac498ae$var$_.Fb = function bs(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Hb = function cs() {
    return $61de1ee1cac498ae$var$FCb(this);
};
$61de1ee1cac498ae$var$_.Ib = function ds() {
    return $61de1ee1cac498ae$var$Zr(this);
};
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$CI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Enum", 22);
$61de1ee1cac498ae$var$bcb(538, 22, {
    538: 1,
    3: 1,
    35: 1,
    22: 1,
    47: 1
}, $61de1ee1cac498ae$var$is);
$61de1ee1cac498ae$var$_.Nb = function js(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function ks() {
    return false;
};
$61de1ee1cac498ae$var$_.Pb = function ls() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Qb = function ms() {
    $61de1ee1cac498ae$var$Vb(false);
};
var $61de1ee1cac498ae$var$gs;
var $61de1ee1cac498ae$var$yG = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Zhe, "Iterators/EmptyModifiableIterator", 538, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$os, $61de1ee1cac498ae$var$ns);
var $61de1ee1cac498ae$var$ps;
$61de1ee1cac498ae$var$bcb(1834, 619, $61de1ee1cac498ae$var$_he);
var $61de1ee1cac498ae$var$EG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedHashMultimapGwtSerializationDependencies", 1834);
$61de1ee1cac498ae$var$bcb(1835, 1834, $61de1ee1cac498ae$var$_he, $61de1ee1cac498ae$var$ss);
$61de1ee1cac498ae$var$_.hc = function us() {
    return new $61de1ee1cac498ae$var$Asb($61de1ee1cac498ae$var$Cv(this.b));
};
$61de1ee1cac498ae$var$_.$b = function ts() {
    $61de1ee1cac498ae$var$Nc(this);
    $61de1ee1cac498ae$var$As(this.a, this.a);
};
$61de1ee1cac498ae$var$_.gd = function vs() {
    return new $61de1ee1cac498ae$var$Asb($61de1ee1cac498ae$var$Cv(this.b));
};
$61de1ee1cac498ae$var$_.ic = function ws(a) {
    return new $61de1ee1cac498ae$var$Ss(this, a, this.b);
};
$61de1ee1cac498ae$var$_.kc = function xs() {
    return new $61de1ee1cac498ae$var$Hs(this);
};
$61de1ee1cac498ae$var$_.lc = function ys() {
    var a;
    return new $61de1ee1cac498ae$var$Kub((a = this.g, $61de1ee1cac498ae$var$BD(!a ? this.g = new $61de1ee1cac498ae$var$ph(this) : a, 21)), 17);
};
$61de1ee1cac498ae$var$_.ec = function zs() {
    var a;
    return a = this.i, !a ? this.i = new $61de1ee1cac498ae$var$zf(this, this.c) : a;
};
$61de1ee1cac498ae$var$_.nc = function Cs() {
    return new $61de1ee1cac498ae$var$Ov(new $61de1ee1cac498ae$var$Hs(this));
};
$61de1ee1cac498ae$var$_.oc = function Ds() {
    var a;
    return $61de1ee1cac498ae$var$$j(new $61de1ee1cac498ae$var$Kub((a = this.g, $61de1ee1cac498ae$var$BD(!a ? this.g = new $61de1ee1cac498ae$var$ph(this) : a, 21)), 17), new $61de1ee1cac498ae$var$Es);
};
$61de1ee1cac498ae$var$_.b = 2;
var $61de1ee1cac498ae$var$FG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedHashMultimap", 1835);
$61de1ee1cac498ae$var$bcb(1838, 1, {}, $61de1ee1cac498ae$var$Es);
$61de1ee1cac498ae$var$_.Kb = function Fs(a) {
    return $61de1ee1cac498ae$var$BD(a, 42).dd();
};
var $61de1ee1cac498ae$var$zG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedHashMultimap/0methodref$getValue$Type", 1838);
$61de1ee1cac498ae$var$bcb(824, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Hs);
$61de1ee1cac498ae$var$_.Nb = function Is(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function Ks() {
    return $61de1ee1cac498ae$var$Gs(this);
};
$61de1ee1cac498ae$var$_.Ob = function Js() {
    return this.a != this.b.a;
};
$61de1ee1cac498ae$var$_.Qb = function Ls() {
    $61de1ee1cac498ae$var$Vb(!!this.c);
    $61de1ee1cac498ae$var$Gc(this.b, this.c.g, this.c.i);
    this.c = null;
};
var $61de1ee1cac498ae$var$AG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedHashMultimap/1", 824);
$61de1ee1cac498ae$var$bcb(330, 238, {
    345: 1,
    238: 1,
    330: 1,
    2020: 1,
    3: 1,
    42: 1
}, $61de1ee1cac498ae$var$Ms);
$61de1ee1cac498ae$var$_.Rd = function Ns() {
    return this.f;
};
$61de1ee1cac498ae$var$_.Sd = function Os(a) {
    this.c = a;
};
$61de1ee1cac498ae$var$_.Td = function Ps(a) {
    this.f = a;
};
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$BG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedHashMultimap/ValueEntry", 330);
$61de1ee1cac498ae$var$bcb(1836, 1970, {
    2020: 1,
    20: 1,
    28: 1,
    14: 1,
    21: 1
}, $61de1ee1cac498ae$var$Ss);
$61de1ee1cac498ae$var$_.Fc = function Ts(a) {
    var b, c, d, e, f;
    f = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15)));
    b = f & this.b.length - 1;
    e = this.b[b];
    for(c = e; c; c = c.a){
        if (c.d == f && $61de1ee1cac498ae$var$Hb(c.i, a)) return false;
    }
    d = new $61de1ee1cac498ae$var$Ms(this.c, a, f, e);
    $61de1ee1cac498ae$var$Bs(this.d, d);
    d.f = this;
    this.d = d;
    $61de1ee1cac498ae$var$As(this.g.a.b, d);
    $61de1ee1cac498ae$var$As(d, this.g.a);
    this.b[b] = d;
    ++this.f;
    ++this.e;
    $61de1ee1cac498ae$var$Qs(this);
    return true;
};
$61de1ee1cac498ae$var$_.$b = function Us() {
    var a, b;
    $61de1ee1cac498ae$var$Alb(this.b, null);
    this.f = 0;
    for(a = this.a; a != this; a = a.Rd()){
        b = $61de1ee1cac498ae$var$BD(a, 330);
        $61de1ee1cac498ae$var$As(b.b, b.e);
    }
    this.a = this;
    this.d = this;
    ++this.e;
};
$61de1ee1cac498ae$var$_.Hc = function Vs(a) {
    var b, c;
    c = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb($61de1ee1cac498ae$var$Eie, $61de1ee1cac498ae$var$keb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Ibb(a == null ? 0 : $61de1ee1cac498ae$var$tb(a), $61de1ee1cac498ae$var$Fie)), 15)));
    for(b = this.b[c & this.b.length - 1]; b; b = b.a){
        if (b.d == c && $61de1ee1cac498ae$var$Hb(b.i, a)) return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Jc = function Ws(a) {
    var b;
    $61de1ee1cac498ae$var$Qb(a);
    for(b = this.a; b != this; b = b.Rd())a.td($61de1ee1cac498ae$var$BD(b, 330).i);
};
$61de1ee1cac498ae$var$_.Rd = function Xs() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Kc = function Ys() {
    return new $61de1ee1cac498ae$var$ct(this);
};
$61de1ee1cac498ae$var$_.Mc = function Zs(a) {
    return $61de1ee1cac498ae$var$Rs(this, a);
};
$61de1ee1cac498ae$var$_.Sd = function $s(a) {
    this.d = a;
};
$61de1ee1cac498ae$var$_.Td = function _s(a) {
    this.a = a;
};
$61de1ee1cac498ae$var$_.gc = function at() {
    return this.f;
};
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$DG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedHashMultimap/ValueSet", 1836);
$61de1ee1cac498ae$var$bcb(1837, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$ct);
$61de1ee1cac498ae$var$_.Nb = function dt(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function et() {
    return $61de1ee1cac498ae$var$bt(this), this.b != this.c;
};
$61de1ee1cac498ae$var$_.Pb = function ft() {
    var a, b;
    $61de1ee1cac498ae$var$bt(this);
    if (this.b == this.c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    a = $61de1ee1cac498ae$var$BD(this.b, 330);
    b = a.i;
    this.d = a;
    this.b = a.f;
    return b;
};
$61de1ee1cac498ae$var$_.Qb = function gt() {
    $61de1ee1cac498ae$var$bt(this);
    $61de1ee1cac498ae$var$Vb(!!this.d);
    $61de1ee1cac498ae$var$Rs(this.c, this.d.i);
    this.a = this.c.e;
    this.d = null;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$CG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedHashMultimap/ValueSet/1", 1837);
$61de1ee1cac498ae$var$bcb(766, 1986, $61de1ee1cac498ae$var$_he, $61de1ee1cac498ae$var$mt);
$61de1ee1cac498ae$var$_.Zb = function nt() {
    var a;
    return a = this.f, !a ? this.f = new $61de1ee1cac498ae$var$jw(this) : a;
};
$61de1ee1cac498ae$var$_.Fb = function tt(a) {
    return $61de1ee1cac498ae$var$hw(this, a);
};
$61de1ee1cac498ae$var$_.cc = function ut(a) {
    return new $61de1ee1cac498ae$var$bu(this, a);
};
$61de1ee1cac498ae$var$_.fc = function xt(a) {
    return $61de1ee1cac498ae$var$kt(this, a);
};
$61de1ee1cac498ae$var$_.$b = function pt() {
    $61de1ee1cac498ae$var$it(this);
};
$61de1ee1cac498ae$var$_._b = function qt(a) {
    return $61de1ee1cac498ae$var$jt(this, a);
};
$61de1ee1cac498ae$var$_.ac = function rt() {
    return new $61de1ee1cac498ae$var$jw(this);
};
$61de1ee1cac498ae$var$_.bc = function st() {
    return new $61de1ee1cac498ae$var$eu(this);
};
$61de1ee1cac498ae$var$_.qc = function vt(a) {
    return new $61de1ee1cac498ae$var$bu(this, a);
};
$61de1ee1cac498ae$var$_.dc = function wt() {
    return !this.a;
};
$61de1ee1cac498ae$var$_.rc = function yt(a) {
    return $61de1ee1cac498ae$var$kt(this, a);
};
$61de1ee1cac498ae$var$_.gc = function zt() {
    return this.d;
};
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$MG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedListMultimap", 766);
$61de1ee1cac498ae$var$bcb(52, 28, $61de1ee1cac498ae$var$Lie);
$61de1ee1cac498ae$var$_.ad = function Pt(a) {
    $61de1ee1cac498ae$var$ktb(this, a);
};
$61de1ee1cac498ae$var$_.Nc = function Qt() {
    return new $61de1ee1cac498ae$var$Kub(this, 16);
};
$61de1ee1cac498ae$var$_.Vc = function Ct(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb("Add not supported on this list"));
};
$61de1ee1cac498ae$var$_.Fc = function Dt(a) {
    this.Vc(this.gc(), a);
    return true;
};
$61de1ee1cac498ae$var$_.Wc = function Et(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$uCb(b);
    c = false;
    for(e = b.Kc(); e.Ob();){
        d = e.Pb();
        this.Vc(a++, d);
        c = true;
    }
    return c;
};
$61de1ee1cac498ae$var$_.$b = function Ft() {
    this.Ud(0, this.gc());
};
$61de1ee1cac498ae$var$_.Fb = function Gt(a) {
    return $61de1ee1cac498ae$var$At(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Ht() {
    return $61de1ee1cac498ae$var$qmb(this);
};
$61de1ee1cac498ae$var$_.Xc = function It(a) {
    return $61de1ee1cac498ae$var$Bt(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function Jt() {
    return new $61de1ee1cac498ae$var$vib(this);
};
$61de1ee1cac498ae$var$_.Yc = function Kt() {
    return this.Zc(0);
};
$61de1ee1cac498ae$var$_.Zc = function Lt(a) {
    return new $61de1ee1cac498ae$var$Bib(this, a);
};
$61de1ee1cac498ae$var$_.$c = function Mt(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb("Remove not supported on this list"));
};
$61de1ee1cac498ae$var$_.Ud = function Nt(a, b) {
    var c, d;
    d = this.Zc(a);
    for(c = a; c < b; ++c){
        d.Pb();
        d.Qb();
    }
};
$61de1ee1cac498ae$var$_._c = function Ot(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb("Set not supported on this list"));
};
$61de1ee1cac498ae$var$_.bd = function Rt(a, b) {
    return new $61de1ee1cac498ae$var$Jib(this, a, b);
};
$61de1ee1cac498ae$var$_.j = 0;
var $61de1ee1cac498ae$var$kJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractList", 52);
$61de1ee1cac498ae$var$bcb(1964, 52, $61de1ee1cac498ae$var$Lie);
$61de1ee1cac498ae$var$_.Vc = function Wt(a, b) {
    $61de1ee1cac498ae$var$St(this, a, b);
};
$61de1ee1cac498ae$var$_.Wc = function Xt(a, b) {
    return $61de1ee1cac498ae$var$Tt(this, a, b);
};
$61de1ee1cac498ae$var$_.Xb = function Yt(a) {
    return $61de1ee1cac498ae$var$Ut(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function Zt() {
    return this.Zc(0);
};
$61de1ee1cac498ae$var$_.$c = function $t(a) {
    return $61de1ee1cac498ae$var$Vt(this, a);
};
$61de1ee1cac498ae$var$_._c = function _t(b, c) {
    var d, e;
    d = this.Zc(b);
    try {
        e = d.Pb();
        d.Wb(c);
        return e;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 109)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb("Can't set element " + b));
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
var $61de1ee1cac498ae$var$yJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractSequentialList", 1964);
$61de1ee1cac498ae$var$bcb(636, 1964, $61de1ee1cac498ae$var$Lie, $61de1ee1cac498ae$var$bu);
$61de1ee1cac498ae$var$_.Zc = function cu(a) {
    return $61de1ee1cac498ae$var$au(this, a);
};
$61de1ee1cac498ae$var$_.gc = function du() {
    var a;
    a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(this.a.b, this.b), 283);
    return !a ? 0 : a.a;
};
var $61de1ee1cac498ae$var$HG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedListMultimap/1", 636);
$61de1ee1cac498ae$var$bcb(1297, 1970, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$eu);
$61de1ee1cac498ae$var$_.Hc = function fu(a) {
    return $61de1ee1cac498ae$var$jt(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function gu() {
    return new $61de1ee1cac498ae$var$ku(this.a);
};
$61de1ee1cac498ae$var$_.Mc = function hu(a) {
    return !$61de1ee1cac498ae$var$kt(this.a, a).a.dc();
};
$61de1ee1cac498ae$var$_.gc = function iu() {
    return $61de1ee1cac498ae$var$Vhb(this.a.b);
};
var $61de1ee1cac498ae$var$GG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedListMultimap/1KeySetImpl", 1297);
$61de1ee1cac498ae$var$bcb(1296, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$ku);
$61de1ee1cac498ae$var$_.Nb = function lu(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function mu() {
    $61de1ee1cac498ae$var$ju(this);
    return !!this.c;
};
$61de1ee1cac498ae$var$_.Pb = function nu() {
    $61de1ee1cac498ae$var$ju(this);
    $61de1ee1cac498ae$var$ot(this.c);
    this.a = this.c;
    $61de1ee1cac498ae$var$Qqb(this.d, this.a.a);
    do this.c = this.c.b;
    while (!!this.c && !$61de1ee1cac498ae$var$Qqb(this.d, this.c.a));
    return this.a.a;
};
$61de1ee1cac498ae$var$_.Qb = function ou() {
    $61de1ee1cac498ae$var$ju(this);
    $61de1ee1cac498ae$var$Vb(!!this.a);
    $61de1ee1cac498ae$var$ir(new $61de1ee1cac498ae$var$wu(this.e, this.a.a));
    this.a = null;
    this.b = this.e.c;
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$IG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedListMultimap/DistinctKeyIterator", 1296);
$61de1ee1cac498ae$var$bcb(283, 1, {
    283: 1
}, $61de1ee1cac498ae$var$pu);
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$JG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedListMultimap/KeyList", 283);
$61de1ee1cac498ae$var$bcb(1295, 345, $61de1ee1cac498ae$var$kie, $61de1ee1cac498ae$var$qu);
$61de1ee1cac498ae$var$_.cd = function ru() {
    return this.a;
};
$61de1ee1cac498ae$var$_.dd = function su() {
    return this.f;
};
$61de1ee1cac498ae$var$_.ed = function tu(a) {
    var b;
    b = this.f;
    this.f = a;
    return b;
};
var $61de1ee1cac498ae$var$KG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedListMultimap/Node", 1295);
$61de1ee1cac498ae$var$bcb(560, 1, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$wu, $61de1ee1cac498ae$var$xu);
$61de1ee1cac498ae$var$_.Nb = function zu(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Rb = function yu(a) {
    this.e = $61de1ee1cac498ae$var$ht(this.f, this.b, a, this.c);
    ++this.d;
    this.a = null;
};
$61de1ee1cac498ae$var$_.Ob = function Au() {
    return !!this.c;
};
$61de1ee1cac498ae$var$_.Sb = function Bu() {
    return !!this.e;
};
$61de1ee1cac498ae$var$_.Pb = function Cu() {
    return $61de1ee1cac498ae$var$uu(this);
};
$61de1ee1cac498ae$var$_.Tb = function Du() {
    return this.d;
};
$61de1ee1cac498ae$var$_.Ub = function Eu() {
    return $61de1ee1cac498ae$var$vu(this);
};
$61de1ee1cac498ae$var$_.Vb = function Fu() {
    return this.d - 1;
};
$61de1ee1cac498ae$var$_.Qb = function Gu() {
    $61de1ee1cac498ae$var$Vb(!!this.a);
    if (this.a != this.c) {
        this.e = this.a.e;
        --this.d;
    } else this.c = this.a.c;
    $61de1ee1cac498ae$var$lt(this.f, this.a);
    this.a = null;
};
$61de1ee1cac498ae$var$_.Wb = function Hu(a) {
    $61de1ee1cac498ae$var$Ub(!!this.a);
    this.a.f = a;
};
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$LG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "LinkedListMultimap/ValueForKeyIterator", 560);
$61de1ee1cac498ae$var$bcb(1018, 52, $61de1ee1cac498ae$var$Lie);
$61de1ee1cac498ae$var$_.Vc = function Tu(a, b) {
    this.a.Vc(a, b);
};
$61de1ee1cac498ae$var$_.Wc = function Uu(a, b) {
    return this.a.Wc(a, b);
};
$61de1ee1cac498ae$var$_.Hc = function Vu(a) {
    return this.a.Hc(a);
};
$61de1ee1cac498ae$var$_.Xb = function Wu(a) {
    return this.a.Xb(a);
};
$61de1ee1cac498ae$var$_.$c = function Xu(a) {
    return this.a.$c(a);
};
$61de1ee1cac498ae$var$_._c = function Yu(a, b) {
    return this.a._c(a, b);
};
$61de1ee1cac498ae$var$_.gc = function Zu() {
    return this.a.gc();
};
var $61de1ee1cac498ae$var$OG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Lists/AbstractListWrapper", 1018);
$61de1ee1cac498ae$var$bcb(1019, 1018, $61de1ee1cac498ae$var$Nie);
var $61de1ee1cac498ae$var$PG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Lists/RandomAccessListWrapper", 1019);
$61de1ee1cac498ae$var$bcb(1021, 1019, $61de1ee1cac498ae$var$Nie, $61de1ee1cac498ae$var$$u);
$61de1ee1cac498ae$var$_.Zc = function _u(a) {
    return this.a.Zc(a);
};
var $61de1ee1cac498ae$var$NG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Lists/1", 1021);
$61de1ee1cac498ae$var$bcb(131, 52, {
    131: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1
}, $61de1ee1cac498ae$var$dv);
$61de1ee1cac498ae$var$_.Vc = function ev(a, b) {
    this.a.Vc($61de1ee1cac498ae$var$cv(this, a), b);
};
$61de1ee1cac498ae$var$_.$b = function fv() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_.Xb = function gv(a) {
    return this.a.Xb($61de1ee1cac498ae$var$bv(this, a));
};
$61de1ee1cac498ae$var$_.Kc = function hv() {
    return $61de1ee1cac498ae$var$av(this, 0);
};
$61de1ee1cac498ae$var$_.Zc = function iv(a) {
    return $61de1ee1cac498ae$var$av(this, a);
};
$61de1ee1cac498ae$var$_.$c = function jv(a) {
    return this.a.$c($61de1ee1cac498ae$var$bv(this, a));
};
$61de1ee1cac498ae$var$_.Ud = function kv(a, b) {
    ($61de1ee1cac498ae$var$Tb(a, b, this.a.gc()), $61de1ee1cac498ae$var$Su(this.a.bd($61de1ee1cac498ae$var$cv(this, b), $61de1ee1cac498ae$var$cv(this, a)))).$b();
};
$61de1ee1cac498ae$var$_._c = function lv(a, b) {
    return this.a._c($61de1ee1cac498ae$var$bv(this, a), b);
};
$61de1ee1cac498ae$var$_.gc = function mv() {
    return this.a.gc();
};
$61de1ee1cac498ae$var$_.bd = function nv(a, b) {
    return $61de1ee1cac498ae$var$Tb(a, b, this.a.gc()), $61de1ee1cac498ae$var$Su(this.a.bd($61de1ee1cac498ae$var$cv(this, b), $61de1ee1cac498ae$var$cv(this, a)));
};
var $61de1ee1cac498ae$var$SG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Lists/ReverseList", 131);
$61de1ee1cac498ae$var$bcb(280, 131, {
    131: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$ov);
var $61de1ee1cac498ae$var$QG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Lists/RandomAccessReverseList", 280);
$61de1ee1cac498ae$var$bcb(1020, 1, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$qv);
$61de1ee1cac498ae$var$_.Nb = function sv(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Rb = function rv(a) {
    this.c.Rb(a);
    this.c.Ub();
    this.a = false;
};
$61de1ee1cac498ae$var$_.Ob = function tv() {
    return this.c.Sb();
};
$61de1ee1cac498ae$var$_.Sb = function uv() {
    return this.c.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function vv() {
    return $61de1ee1cac498ae$var$pv(this);
};
$61de1ee1cac498ae$var$_.Tb = function wv() {
    return $61de1ee1cac498ae$var$cv(this.b, this.c.Tb());
};
$61de1ee1cac498ae$var$_.Ub = function xv() {
    if (!this.c.Ob()) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    this.a = true;
    return this.c.Pb();
};
$61de1ee1cac498ae$var$_.Vb = function yv() {
    return $61de1ee1cac498ae$var$cv(this.b, this.c.Tb()) - 1;
};
$61de1ee1cac498ae$var$_.Qb = function zv() {
    $61de1ee1cac498ae$var$Vb(this.a);
    this.c.Qb();
    this.a = false;
};
$61de1ee1cac498ae$var$_.Wb = function Av(a) {
    $61de1ee1cac498ae$var$Ub(this.a);
    this.c.Wb(a);
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$RG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Lists/ReverseList/1", 1020);
$61de1ee1cac498ae$var$bcb(432, 487, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Mv);
$61de1ee1cac498ae$var$_.Qd = function Nv(a) {
    return $61de1ee1cac498ae$var$Lv(a);
};
var $61de1ee1cac498ae$var$TG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/1", 432);
$61de1ee1cac498ae$var$bcb(698, 487, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Ov);
$61de1ee1cac498ae$var$_.Qd = function Pv(a) {
    return $61de1ee1cac498ae$var$BD(a, 42).dd();
};
var $61de1ee1cac498ae$var$UG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/2", 698);
$61de1ee1cac498ae$var$bcb(962, 487, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Qv);
$61de1ee1cac498ae$var$_.Qd = function Rv(a) {
    return new $61de1ee1cac498ae$var$Wo(a, $61de1ee1cac498ae$var$ww(this.a, a));
};
var $61de1ee1cac498ae$var$VG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/3", 962);
$61de1ee1cac498ae$var$bcb(959, 1971, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$Sv);
$61de1ee1cac498ae$var$_.Jc = function Tv(a) {
    $61de1ee1cac498ae$var$mj(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function Uv() {
    return this.a.kc();
};
$61de1ee1cac498ae$var$_.Rc = function Vv() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Nc = function Wv() {
    return this.a.lc();
};
var $61de1ee1cac498ae$var$XG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/IteratorBasedAbstractMap/1", 959);
$61de1ee1cac498ae$var$bcb(960, 1, {}, $61de1ee1cac498ae$var$Xv);
$61de1ee1cac498ae$var$_.Od = function Yv(a, b) {
    this.a.td(a);
};
var $61de1ee1cac498ae$var$ZG = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/KeySet/lambda$0$Type", 960);
$61de1ee1cac498ae$var$bcb(958, 28, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$Zv);
$61de1ee1cac498ae$var$_.$b = function $v() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_.Hc = function _v(a) {
    return this.a.uc(a);
};
$61de1ee1cac498ae$var$_.Jc = function aw(a) {
    $61de1ee1cac498ae$var$Qb(a);
    this.a.wc(new $61de1ee1cac498ae$var$fw(a));
};
$61de1ee1cac498ae$var$_.dc = function bw() {
    return this.a.dc();
};
$61de1ee1cac498ae$var$_.Kc = function cw() {
    return new $61de1ee1cac498ae$var$Ov(this.a.vc().Kc());
};
$61de1ee1cac498ae$var$_.Mc = function dw(b) {
    var c, d;
    try {
        return $61de1ee1cac498ae$var$ze(this, b, true);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 41)) {
            for(d = this.a.vc().Kc(); d.Ob();){
                c = $61de1ee1cac498ae$var$BD(d.Pb(), 42);
                if ($61de1ee1cac498ae$var$Hb(b, c.dd())) {
                    this.a.Bc(c.cd());
                    return true;
                }
            }
            return false;
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.gc = function ew() {
    return this.a.gc();
};
var $61de1ee1cac498ae$var$aH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/Values", 958);
$61de1ee1cac498ae$var$bcb(961, 1, {}, $61de1ee1cac498ae$var$fw);
$61de1ee1cac498ae$var$_.Od = function gw(a, b) {
    this.a.td(b);
};
var $61de1ee1cac498ae$var$_G = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Maps/Values/lambda$0$Type", 961);
$61de1ee1cac498ae$var$bcb(736, 1987, $61de1ee1cac498ae$var$cie, $61de1ee1cac498ae$var$jw);
$61de1ee1cac498ae$var$_.xc = function nw(a) {
    return this.a._b(a) ? this.a.cc(a) : null;
};
$61de1ee1cac498ae$var$_.Bc = function qw(a) {
    return this.a._b(a) ? this.a.fc(a) : null;
};
$61de1ee1cac498ae$var$_.$b = function kw() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_._b = function lw(a) {
    return this.a._b(a);
};
$61de1ee1cac498ae$var$_.Ec = function mw() {
    return new $61de1ee1cac498ae$var$sw(this);
};
$61de1ee1cac498ae$var$_.Dc = function() {
    return this.Ec();
};
$61de1ee1cac498ae$var$_.dc = function ow() {
    return this.a.dc();
};
$61de1ee1cac498ae$var$_.ec = function pw() {
    return this.a.ec();
};
$61de1ee1cac498ae$var$_.gc = function rw() {
    return this.a.ec().gc();
};
var $61de1ee1cac498ae$var$eH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/AsMap", 736);
$61de1ee1cac498ae$var$bcb(1104, 1971, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$sw);
$61de1ee1cac498ae$var$_.Kc = function tw() {
    return $61de1ee1cac498ae$var$Bv(this.a.a.ec(), new $61de1ee1cac498ae$var$xw(this));
};
$61de1ee1cac498ae$var$_.Rc = function uw() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Mc = function vw(a) {
    var b;
    if (!$61de1ee1cac498ae$var$Ze(this, a)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 42);
    $61de1ee1cac498ae$var$iw(this.a, b.cd());
    return true;
};
var $61de1ee1cac498ae$var$dH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/AsMap/EntrySet", 1104);
$61de1ee1cac498ae$var$bcb(1108, 1, {}, $61de1ee1cac498ae$var$xw);
$61de1ee1cac498ae$var$_.Kb = function yw(a) {
    return $61de1ee1cac498ae$var$ww(this, a);
};
$61de1ee1cac498ae$var$_.Fb = function zw(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$cH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/AsMap/EntrySet/1", 1108);
$61de1ee1cac498ae$var$bcb(543, 1989, {
    543: 1,
    835: 1,
    20: 1,
    28: 1,
    14: 1
}, $61de1ee1cac498ae$var$Cw);
$61de1ee1cac498ae$var$_.$b = function Dw() {
    $61de1ee1cac498ae$var$Nc(this.a);
};
$61de1ee1cac498ae$var$_.Hc = function Ew(a) {
    return $61de1ee1cac498ae$var$Oc(this.a, a);
};
$61de1ee1cac498ae$var$_.Jc = function Fw(a) {
    $61de1ee1cac498ae$var$Qb(a);
    $61de1ee1cac498ae$var$reb($61de1ee1cac498ae$var$Pc(this.a), new $61de1ee1cac498ae$var$Rw(a));
};
$61de1ee1cac498ae$var$_.Kc = function Gw() {
    return new $61de1ee1cac498ae$var$Mv($61de1ee1cac498ae$var$Pc(this.a).a.kc());
};
$61de1ee1cac498ae$var$_.gc = function Hw() {
    return this.a.d;
};
$61de1ee1cac498ae$var$_.Nc = function Iw() {
    return $61de1ee1cac498ae$var$$j($61de1ee1cac498ae$var$Pc(this.a).Nc(), new $61de1ee1cac498ae$var$Jw);
};
var $61de1ee1cac498ae$var$kH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/Keys", 543);
$61de1ee1cac498ae$var$bcb(1106, 1, {}, $61de1ee1cac498ae$var$Jw);
$61de1ee1cac498ae$var$_.Kb = function Kw(a) {
    return $61de1ee1cac498ae$var$BD(a, 42).cd();
};
var $61de1ee1cac498ae$var$gH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/Keys/0methodref$getKey$Type", 1106);
$61de1ee1cac498ae$var$bcb(1105, 487, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Lw);
$61de1ee1cac498ae$var$_.Qd = function Mw(a) {
    return new $61de1ee1cac498ae$var$Qw($61de1ee1cac498ae$var$BD(a, 42));
};
var $61de1ee1cac498ae$var$iH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/Keys/1", 1105);
$61de1ee1cac498ae$var$bcb(1990, 1, {
    416: 1
});
$61de1ee1cac498ae$var$_.Fb = function Nw(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 492)) {
        b = $61de1ee1cac498ae$var$BD(a, 416);
        return $61de1ee1cac498ae$var$BD(this.a.dd(), 14).gc() == $61de1ee1cac498ae$var$BD(b.a.dd(), 14).gc() && $61de1ee1cac498ae$var$Hb(this.a.cd(), b.a.cd());
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function Ow() {
    var a;
    a = this.a.cd();
    return (a == null ? 0 : $61de1ee1cac498ae$var$tb(a)) ^ $61de1ee1cac498ae$var$BD(this.a.dd(), 14).gc();
};
$61de1ee1cac498ae$var$_.Ib = function Pw() {
    var a, b;
    b = $61de1ee1cac498ae$var$xfb(this.a.cd());
    a = $61de1ee1cac498ae$var$BD(this.a.dd(), 14).gc();
    return a == 1 ? b : b + " x " + a;
};
var $61de1ee1cac498ae$var$oH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multisets/AbstractEntry", 1990);
$61de1ee1cac498ae$var$bcb(492, 1990, {
    492: 1,
    416: 1
}, $61de1ee1cac498ae$var$Qw);
var $61de1ee1cac498ae$var$hH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/Keys/1/1", 492);
$61de1ee1cac498ae$var$bcb(1107, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Rw);
$61de1ee1cac498ae$var$_.td = function Sw(a) {
    this.a.td($61de1ee1cac498ae$var$BD(a, 42).cd());
};
var $61de1ee1cac498ae$var$jH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multimaps/Keys/lambda$1$Type", 1107);
$61de1ee1cac498ae$var$bcb(1110, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Vw);
$61de1ee1cac498ae$var$_.td = function Ww(a) {
    $61de1ee1cac498ae$var$Tw($61de1ee1cac498ae$var$BD(a, 416));
};
var $61de1ee1cac498ae$var$lH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multiset/lambda$0$Type", 1110);
$61de1ee1cac498ae$var$bcb(737, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Xw);
$61de1ee1cac498ae$var$_.td = function Yw(a) {
    $61de1ee1cac498ae$var$Uw(this.a, $61de1ee1cac498ae$var$BD(a, 416));
};
var $61de1ee1cac498ae$var$mH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multiset/lambda$1$Type", 737);
$61de1ee1cac498ae$var$bcb(1111, 1, {}, $61de1ee1cac498ae$var$bx);
var $61de1ee1cac498ae$var$nH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multisets/0methodref$add$Type", 1111);
$61de1ee1cac498ae$var$bcb(738, 1, {}, $61de1ee1cac498ae$var$cx);
$61de1ee1cac498ae$var$_.Kb = function dx(a) {
    return $61de1ee1cac498ae$var$_w($61de1ee1cac498ae$var$BD(a, 416));
};
var $61de1ee1cac498ae$var$qH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Multisets/lambda$3$Type", 738);
$61de1ee1cac498ae$var$bcb(2008, 1, $61de1ee1cac498ae$var$Qhe);
var $61de1ee1cac498ae$var$rH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "RangeGwtSerializationDependencies", 2008);
$61de1ee1cac498ae$var$bcb(514, 2008, {
    169: 1,
    514: 1,
    3: 1,
    45: 1
}, $61de1ee1cac498ae$var$gx);
$61de1ee1cac498ae$var$_.Lb = function hx(a) {
    return $61de1ee1cac498ae$var$fx(this, $61de1ee1cac498ae$var$BD(a, 35));
};
$61de1ee1cac498ae$var$_.Mb = function lx(a) {
    return $61de1ee1cac498ae$var$fx(this, $61de1ee1cac498ae$var$BD(a, 35));
};
$61de1ee1cac498ae$var$_.Fb = function jx(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 514)) {
        b = $61de1ee1cac498ae$var$BD(a, 514);
        return $61de1ee1cac498ae$var$Ek(this.a, b.a) && $61de1ee1cac498ae$var$Ek(this.b, b.b);
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function kx() {
    return this.a.Hb() * 31 + this.b.Hb();
};
$61de1ee1cac498ae$var$_.Ib = function mx() {
    return $61de1ee1cac498ae$var$nx(this.a, this.b);
};
var $61de1ee1cac498ae$var$sH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Range", 514);
$61de1ee1cac498ae$var$bcb(778, 1999, $61de1ee1cac498ae$var$yie, $61de1ee1cac498ae$var$px);
$61de1ee1cac498ae$var$_.Zc = function tx(a) {
    return $61de1ee1cac498ae$var$jm(this.b, a);
};
$61de1ee1cac498ae$var$_.Pd = function qx() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Xb = function rx(a) {
    return $61de1ee1cac498ae$var$Em(this.b, a);
};
$61de1ee1cac498ae$var$_.Fd = function sx(a) {
    return $61de1ee1cac498ae$var$jm(this.b, a);
};
var $61de1ee1cac498ae$var$tH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "RegularImmutableAsList", 778);
$61de1ee1cac498ae$var$bcb(646, 2006, $61de1ee1cac498ae$var$yie, $61de1ee1cac498ae$var$ux);
$61de1ee1cac498ae$var$_.Hd = function vx() {
    return this.a;
};
var $61de1ee1cac498ae$var$uH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "RegularImmutableList", 646);
$61de1ee1cac498ae$var$bcb(616, 715, $61de1ee1cac498ae$var$Aie, $61de1ee1cac498ae$var$wx);
var $61de1ee1cac498ae$var$vH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "RegularImmutableMap", 616);
$61de1ee1cac498ae$var$bcb(716, 703, $61de1ee1cac498ae$var$Cie, $61de1ee1cac498ae$var$zx);
var $61de1ee1cac498ae$var$xx;
var $61de1ee1cac498ae$var$wH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "RegularImmutableSet", 716);
$61de1ee1cac498ae$var$bcb(1976, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie);
$61de1ee1cac498ae$var$_.Kc = function Mx() {
    return new $61de1ee1cac498ae$var$Xx(this.a, this.b);
};
$61de1ee1cac498ae$var$_.Fc = function Jx(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Gc = function Kx(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.$b = function Lx() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Mc = function Nx(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$CH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Sets/SetView", 1976);
$61de1ee1cac498ae$var$bcb(963, 1976, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$Px);
$61de1ee1cac498ae$var$_.Kc = function Tx() {
    return new $61de1ee1cac498ae$var$Xx(this.a, this.b);
};
$61de1ee1cac498ae$var$_.Hc = function Qx(a) {
    return $61de1ee1cac498ae$var$tqb(this.a, a) && this.b.Hc(a);
};
$61de1ee1cac498ae$var$_.Ic = function Rx(a) {
    return $61de1ee1cac498ae$var$Be(this.a, a) && this.b.Ic(a);
};
$61de1ee1cac498ae$var$_.dc = function Sx() {
    return $61de1ee1cac498ae$var$omb(this.b, this.a);
};
$61de1ee1cac498ae$var$_.Lc = function Ux() {
    return $61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.a, 1)), new $61de1ee1cac498ae$var$_x(this.b));
};
$61de1ee1cac498ae$var$_.gc = function Vx() {
    return $61de1ee1cac498ae$var$Ox(this);
};
$61de1ee1cac498ae$var$_.Oc = function Wx() {
    return $61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.a, 1)), new $61de1ee1cac498ae$var$Zx(this.b));
};
var $61de1ee1cac498ae$var$AH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Sets/2", 963);
$61de1ee1cac498ae$var$bcb(700, 699, $61de1ee1cac498ae$var$Yhe, $61de1ee1cac498ae$var$Xx);
$61de1ee1cac498ae$var$_.Yb = function Yx() {
    var a;
    while($61de1ee1cac498ae$var$Eqb(this.a)){
        a = $61de1ee1cac498ae$var$Fqb(this.a);
        if (this.c.Hc(a)) return a;
    }
    return this.e = 2, null;
};
var $61de1ee1cac498ae$var$xH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Sets/2/1", 700);
$61de1ee1cac498ae$var$bcb(964, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Zx);
$61de1ee1cac498ae$var$_.Mb = function $x(a) {
    return this.a.Hc(a);
};
var $61de1ee1cac498ae$var$yH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Sets/2/4methodref$contains$Type", 964);
$61de1ee1cac498ae$var$bcb(965, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$_x);
$61de1ee1cac498ae$var$_.Mb = function ay(a) {
    return this.a.Hc(a);
};
var $61de1ee1cac498ae$var$zH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Sets/2/5methodref$contains$Type", 965);
$61de1ee1cac498ae$var$bcb(607, 1975, {
    607: 1,
    3: 1,
    20: 1,
    14: 1,
    271: 1,
    21: 1,
    84: 1
}, $61de1ee1cac498ae$var$by);
$61de1ee1cac498ae$var$_.Bd = function cy() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Cd = function dy() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Md = function ey() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Jc = function fy(a) {
    this.a.Jc(a);
};
$61de1ee1cac498ae$var$_.Lc = function gy() {
    return this.a.Lc();
};
$61de1ee1cac498ae$var$_.Oc = function hy() {
    return this.a.Oc();
};
var $61de1ee1cac498ae$var$DH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Sets/UnmodifiableNavigableSet", 607);
$61de1ee1cac498ae$var$bcb(1932, 1931, $61de1ee1cac498ae$var$Aie, $61de1ee1cac498ae$var$iy);
$61de1ee1cac498ae$var$_.Ld = function jy() {
    return $61de1ee1cac498ae$var$Ql(), new $61de1ee1cac498ae$var$oy(this.a);
};
$61de1ee1cac498ae$var$_.Cc = function ky() {
    return $61de1ee1cac498ae$var$Ql(), new $61de1ee1cac498ae$var$oy(this.a);
};
$61de1ee1cac498ae$var$_.pd = function ly() {
    return $61de1ee1cac498ae$var$Ql(), new $61de1ee1cac498ae$var$oy(this.a);
};
var $61de1ee1cac498ae$var$EH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "SingletonImmutableBiMap", 1932);
$61de1ee1cac498ae$var$bcb(647, 2006, $61de1ee1cac498ae$var$yie, $61de1ee1cac498ae$var$my);
$61de1ee1cac498ae$var$_.Hd = function ny() {
    return this.a;
};
var $61de1ee1cac498ae$var$FH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "SingletonImmutableList", 647);
$61de1ee1cac498ae$var$bcb(350, 1981, $61de1ee1cac498ae$var$Cie, $61de1ee1cac498ae$var$oy);
$61de1ee1cac498ae$var$_.Kc = function ry() {
    return new $61de1ee1cac498ae$var$Ir(this.a);
};
$61de1ee1cac498ae$var$_.Hc = function py(a) {
    return $61de1ee1cac498ae$var$pb(this.a, a);
};
$61de1ee1cac498ae$var$_.Ed = function qy() {
    return new $61de1ee1cac498ae$var$Ir(this.a);
};
$61de1ee1cac498ae$var$_.gc = function sy() {
    return 1;
};
var $61de1ee1cac498ae$var$GH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "SingletonImmutableSet", 350);
$61de1ee1cac498ae$var$bcb(1115, 1, {}, $61de1ee1cac498ae$var$vy);
$61de1ee1cac498ae$var$_.Kb = function wy(a) {
    return $61de1ee1cac498ae$var$BD(a, 164);
};
var $61de1ee1cac498ae$var$HH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Streams/lambda$0$Type", 1115);
$61de1ee1cac498ae$var$bcb(1116, 1, $61de1ee1cac498ae$var$Pie, $61de1ee1cac498ae$var$xy);
$61de1ee1cac498ae$var$_.Vd = function yy() {
    $61de1ee1cac498ae$var$uy(this.a);
};
var $61de1ee1cac498ae$var$IH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "Streams/lambda$1$Type", 1116);
$61de1ee1cac498ae$var$bcb(1659, 1658, $61de1ee1cac498ae$var$_he, $61de1ee1cac498ae$var$Ay);
$61de1ee1cac498ae$var$_.Zb = function By() {
    var a;
    return a = this.f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(!a ? this.f = $61de1ee1cac498ae$var$JD(this.c, 171) ? new $61de1ee1cac498ae$var$Sf(this, $61de1ee1cac498ae$var$BD(this.c, 171)) : $61de1ee1cac498ae$var$JD(this.c, 161) ? new $61de1ee1cac498ae$var$Mf(this, $61de1ee1cac498ae$var$BD(this.c, 161)) : new $61de1ee1cac498ae$var$ne(this, this.c) : a, 161), 171);
};
$61de1ee1cac498ae$var$_.hc = function Ey() {
    return new $61de1ee1cac498ae$var$Hxb(this.b);
};
$61de1ee1cac498ae$var$_.gd = function Fy() {
    return new $61de1ee1cac498ae$var$Hxb(this.b);
};
$61de1ee1cac498ae$var$_.ec = function Hy() {
    var a;
    return a = this.i, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(!a ? this.i = $61de1ee1cac498ae$var$JD(this.c, 171) ? new $61de1ee1cac498ae$var$$f(this, $61de1ee1cac498ae$var$BD(this.c, 171)) : $61de1ee1cac498ae$var$JD(this.c, 161) ? new $61de1ee1cac498ae$var$Yf(this, $61de1ee1cac498ae$var$BD(this.c, 161)) : new $61de1ee1cac498ae$var$zf(this, this.c) : a, 84), 271);
};
$61de1ee1cac498ae$var$_.ac = function Dy() {
    return $61de1ee1cac498ae$var$JD(this.c, 171) ? new $61de1ee1cac498ae$var$Sf(this, $61de1ee1cac498ae$var$BD(this.c, 171)) : $61de1ee1cac498ae$var$JD(this.c, 161) ? new $61de1ee1cac498ae$var$Mf(this, $61de1ee1cac498ae$var$BD(this.c, 161)) : new $61de1ee1cac498ae$var$ne(this, this.c);
};
$61de1ee1cac498ae$var$_.ic = function Gy(a) {
    a == null && this.a.ue(a, a);
    return new $61de1ee1cac498ae$var$Hxb(this.b);
};
var $61de1ee1cac498ae$var$LH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zhe, "TreeMultimap", 1659);
$61de1ee1cac498ae$var$bcb(78, 1, {
    3: 1,
    78: 1
});
$61de1ee1cac498ae$var$_.Wd = function $y(a) {
    return new Error(a);
};
$61de1ee1cac498ae$var$_.Xd = function az() {
    return this.e;
};
$61de1ee1cac498ae$var$_.Yd = function bz() {
    return $61de1ee1cac498ae$var$XAb($61de1ee1cac498ae$var$NAb($61de1ee1cac498ae$var$Plb((this.k == null && (this.k = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$_I, $61de1ee1cac498ae$var$nie, 78, 0, 0, 1)), this.k)), new $61de1ee1cac498ae$var$_fb), new $61de1ee1cac498ae$var$bBb);
};
$61de1ee1cac498ae$var$_.Zd = function cz() {
    return this.f;
};
$61de1ee1cac498ae$var$_.$d = function dz() {
    return this.g;
};
$61de1ee1cac498ae$var$_._d = function ez() {
    $61de1ee1cac498ae$var$Vy(this, $61de1ee1cac498ae$var$_y(this.Wd($61de1ee1cac498ae$var$Wy(this, this.g))));
    $61de1ee1cac498ae$var$Sz(this);
};
$61de1ee1cac498ae$var$_.Ib = function fz() {
    return $61de1ee1cac498ae$var$Wy(this, this.$d());
};
$61de1ee1cac498ae$var$_.e = $61de1ee1cac498ae$var$Sie;
$61de1ee1cac498ae$var$_.i = false;
$61de1ee1cac498ae$var$_.n = true;
var $61de1ee1cac498ae$var$_I = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Throwable", 78);
$61de1ee1cac498ae$var$bcb(102, 78, {
    3: 1,
    102: 1,
    78: 1
});
var $61de1ee1cac498ae$var$EI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Exception", 102);
$61de1ee1cac498ae$var$bcb(60, 102, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$gz, $61de1ee1cac498ae$var$hz);
var $61de1ee1cac498ae$var$TI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "RuntimeException", 60);
$61de1ee1cac498ae$var$bcb(598, 60, $61de1ee1cac498ae$var$Tie);
var $61de1ee1cac498ae$var$LI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "JsException", 598);
$61de1ee1cac498ae$var$bcb(863, 598, $61de1ee1cac498ae$var$Tie);
var $61de1ee1cac498ae$var$RH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uie, "JavaScriptExceptionBase", 863);
$61de1ee1cac498ae$var$bcb(477, 863, {
    477: 1,
    3: 1,
    102: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$lz);
$61de1ee1cac498ae$var$_.$d = function oz() {
    $61de1ee1cac498ae$var$kz(this);
    return this.c;
};
$61de1ee1cac498ae$var$_.ae = function pz() {
    return $61de1ee1cac498ae$var$PD(this.b) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$iz) ? null : this.b;
};
var $61de1ee1cac498ae$var$iz;
var $61de1ee1cac498ae$var$OH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wie, "JavaScriptException", 477);
var $61de1ee1cac498ae$var$PH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wie, "JavaScriptObject$", 0);
var $61de1ee1cac498ae$var$tz;
$61de1ee1cac498ae$var$bcb(1948, 1, {});
var $61de1ee1cac498ae$var$QH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wie, "Scheduler", 1948);
var $61de1ee1cac498ae$var$xz = 0, $61de1ee1cac498ae$var$yz = 0, $61de1ee1cac498ae$var$zz = -1;
$61de1ee1cac498ae$var$bcb(890, 1948, {}, $61de1ee1cac498ae$var$Nz);
var $61de1ee1cac498ae$var$Jz;
var $61de1ee1cac498ae$var$SH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uie, "SchedulerImpl", 890);
var $61de1ee1cac498ae$var$Qz;
$61de1ee1cac498ae$var$bcb(1960, 1, {});
var $61de1ee1cac498ae$var$WH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uie, "StackTraceCreator/Collector", 1960);
$61de1ee1cac498ae$var$bcb(864, 1960, {}, $61de1ee1cac498ae$var$Yz);
$61de1ee1cac498ae$var$_.be = function Zz(a) {
    var b = {}, j;
    var c = [];
    a[$61de1ee1cac498ae$var$Yie] = c;
    var d = arguments.callee.caller;
    while(d){
        var e = ($61de1ee1cac498ae$var$Rz(), d.name || (d.name = $61de1ee1cac498ae$var$Uz(d.toString())));
        c.push(e);
        var f = ":" + e;
        var g = b[f];
        if (g) {
            var h, i;
            for(h = 0, i = g.length; h < i; h++){
                if (g[h] === d) return;
            }
        }
        (g || (b[f] = [])).push(d);
        d = d.caller;
    }
};
$61de1ee1cac498ae$var$_.ce = function $z(a) {
    var b, c, d, e;
    d = ($61de1ee1cac498ae$var$Rz(), a && a[$61de1ee1cac498ae$var$Yie] ? a[$61de1ee1cac498ae$var$Yie] : []);
    c = d.length;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$VI, $61de1ee1cac498ae$var$nie, 310, c, 0, 1);
    for(b = 0; b < c; b++)e[b] = new $61de1ee1cac498ae$var$Zeb(d[b], null, -1);
    return e;
};
var $61de1ee1cac498ae$var$TH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uie, "StackTraceCreator/CollectorLegacy", 864);
$61de1ee1cac498ae$var$bcb(1961, 1960, {});
$61de1ee1cac498ae$var$_.be = function aA(a) {};
$61de1ee1cac498ae$var$_.de = function bA(a, b, c, d) {
    return new $61de1ee1cac498ae$var$Zeb(b, a + "@" + d, c < 0 ? -1 : c);
};
$61de1ee1cac498ae$var$_.ce = function cA(a) {
    var b, c, d, e, f, g;
    e = $61de1ee1cac498ae$var$Wz(a);
    f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$VI, $61de1ee1cac498ae$var$nie, 310, 0, 0, 1);
    b = 0;
    d = e.length;
    if (d == 0) return f;
    g = $61de1ee1cac498ae$var$_z(this, e[0]);
    $61de1ee1cac498ae$var$dfb(g.d, $61de1ee1cac498ae$var$Xie) || (f[b++] = g);
    for(c = 1; c < d; c++)f[b++] = $61de1ee1cac498ae$var$_z(this, e[c]);
    return f;
};
var $61de1ee1cac498ae$var$VH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uie, "StackTraceCreator/CollectorModern", 1961);
$61de1ee1cac498ae$var$bcb(865, 1961, {}, $61de1ee1cac498ae$var$dA);
$61de1ee1cac498ae$var$_.de = function eA(a, b, c, d) {
    return new $61de1ee1cac498ae$var$Zeb(b, a, -1);
};
var $61de1ee1cac498ae$var$UH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uie, "StackTraceCreator/CollectorModernNoSourceMap", 865);
$61de1ee1cac498ae$var$bcb(1050, 1, {});
var $61de1ee1cac498ae$var$cI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yje, $61de1ee1cac498ae$var$zje, 1050);
$61de1ee1cac498ae$var$bcb(615, 1050, {
    615: 1
}, $61de1ee1cac498ae$var$HA);
var $61de1ee1cac498ae$var$FA;
var $61de1ee1cac498ae$var$XH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Aje, $61de1ee1cac498ae$var$zje, 615);
$61de1ee1cac498ae$var$bcb(2001, 1, {});
var $61de1ee1cac498ae$var$dI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yje, $61de1ee1cac498ae$var$Bje, 2001);
$61de1ee1cac498ae$var$bcb(2002, 2001, {});
var $61de1ee1cac498ae$var$YH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Aje, $61de1ee1cac498ae$var$Bje, 2002);
$61de1ee1cac498ae$var$bcb(1090, 1, {}, $61de1ee1cac498ae$var$MA);
var $61de1ee1cac498ae$var$JA;
var $61de1ee1cac498ae$var$ZH = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Aje, "LocaleInfo", 1090);
$61de1ee1cac498ae$var$bcb(1918, 1, {}, $61de1ee1cac498ae$var$PA);
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$_H = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Aje, "TimeZone", 1918);
$61de1ee1cac498ae$var$bcb(1258, 2002, {}, $61de1ee1cac498ae$var$VA);
var $61de1ee1cac498ae$var$aI = $61de1ee1cac498ae$var$mdb("com.google.gwt.i18n.client.impl.cldr", "DateTimeFormatInfoImpl", 1258);
$61de1ee1cac498ae$var$bcb(434, 1, {
    434: 1
}, $61de1ee1cac498ae$var$WA);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$bI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yje, "DateTimeFormat/PatternPart", 434);
$61de1ee1cac498ae$var$bcb(199, 1, $61de1ee1cac498ae$var$Cje, $61de1ee1cac498ae$var$eB, $61de1ee1cac498ae$var$fB, $61de1ee1cac498ae$var$gB);
$61de1ee1cac498ae$var$_.wd = function hB(a) {
    return $61de1ee1cac498ae$var$XA(this, $61de1ee1cac498ae$var$BD(a, 199));
};
$61de1ee1cac498ae$var$_.Fb = function iB(a) {
    return $61de1ee1cac498ae$var$JD(a, 199) && $61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$Cbb(this.q.getTime()), $61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$BD(a, 199).q.getTime()));
};
$61de1ee1cac498ae$var$_.Hb = function jB() {
    var a;
    a = $61de1ee1cac498ae$var$Cbb(this.q.getTime());
    return $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Vbb(a, $61de1ee1cac498ae$var$Pbb(a, 32)));
};
$61de1ee1cac498ae$var$_.Ib = function lB() {
    var a, b, c;
    c = -this.q.getTimezoneOffset();
    a = (c >= 0 ? "+" : "") + (c / 60 | 0);
    b = $61de1ee1cac498ae$var$kB($61de1ee1cac498ae$var$$wnd.Math.abs(c) % 60);
    return ($61de1ee1cac498ae$var$Dpb(), $61de1ee1cac498ae$var$Bpb)[this.q.getDay()] + " " + $61de1ee1cac498ae$var$Cpb[this.q.getMonth()] + " " + $61de1ee1cac498ae$var$kB(this.q.getDate()) + " " + $61de1ee1cac498ae$var$kB(this.q.getHours()) + ":" + $61de1ee1cac498ae$var$kB(this.q.getMinutes()) + ":" + $61de1ee1cac498ae$var$kB(this.q.getSeconds()) + " GMT" + a + b + " " + this.q.getFullYear();
};
var $61de1ee1cac498ae$var$$J = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Date", 199);
$61de1ee1cac498ae$var$bcb(1915, 199, $61de1ee1cac498ae$var$Cje, $61de1ee1cac498ae$var$nB);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.g = false;
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.j = 0;
$61de1ee1cac498ae$var$_.k = 0;
$61de1ee1cac498ae$var$_.n = 0;
$61de1ee1cac498ae$var$_.o = 0;
$61de1ee1cac498ae$var$_.p = 0;
var $61de1ee1cac498ae$var$eI = $61de1ee1cac498ae$var$mdb("com.google.gwt.i18n.shared.impl", "DateRecord", 1915);
$61de1ee1cac498ae$var$bcb(1966, 1, {});
$61de1ee1cac498ae$var$_.fe = function oB() {
    return null;
};
$61de1ee1cac498ae$var$_.ge = function pB() {
    return null;
};
$61de1ee1cac498ae$var$_.he = function qB() {
    return null;
};
$61de1ee1cac498ae$var$_.ie = function rB() {
    return null;
};
$61de1ee1cac498ae$var$_.je = function sB() {
    return null;
};
var $61de1ee1cac498ae$var$nI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONValue", 1966);
$61de1ee1cac498ae$var$bcb(216, 1966, {
    216: 1
}, $61de1ee1cac498ae$var$wB, $61de1ee1cac498ae$var$xB);
$61de1ee1cac498ae$var$_.Fb = function yB(a) {
    if (!$61de1ee1cac498ae$var$JD(a, 216)) return false;
    return $61de1ee1cac498ae$var$qz(this.a, $61de1ee1cac498ae$var$BD(a, 216).a);
};
$61de1ee1cac498ae$var$_.ee = function zB() {
    return $61de1ee1cac498ae$var$DB;
};
$61de1ee1cac498ae$var$_.Hb = function AB() {
    return $61de1ee1cac498ae$var$rz(this.a);
};
$61de1ee1cac498ae$var$_.fe = function BB() {
    return this;
};
$61de1ee1cac498ae$var$_.Ib = function CB() {
    var a, b, c;
    c = new $61de1ee1cac498ae$var$Wfb("[");
    for(b = 0, a = this.a.length; b < a; b++){
        b > 0 && (c.a += ",", c);
        $61de1ee1cac498ae$var$Pfb(c, $61de1ee1cac498ae$var$tB(this, b));
    }
    c.a += "]";
    return c.a;
};
var $61de1ee1cac498ae$var$fI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONArray", 216);
$61de1ee1cac498ae$var$bcb(483, 1966, {
    483: 1
}, $61de1ee1cac498ae$var$HB);
$61de1ee1cac498ae$var$_.ee = function IB() {
    return $61de1ee1cac498ae$var$LB;
};
$61de1ee1cac498ae$var$_.ge = function JB() {
    return this;
};
$61de1ee1cac498ae$var$_.Ib = function KB() {
    return $61de1ee1cac498ae$var$Bcb(), "" + this.a;
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$EB, $61de1ee1cac498ae$var$FB;
var $61de1ee1cac498ae$var$gI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONBoolean", 483);
$61de1ee1cac498ae$var$bcb(985, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$MB);
var $61de1ee1cac498ae$var$hI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONException", 985);
$61de1ee1cac498ae$var$bcb(1023, 1966, {}, $61de1ee1cac498ae$var$PB);
$61de1ee1cac498ae$var$_.ee = function QB() {
    return $61de1ee1cac498ae$var$SB;
};
$61de1ee1cac498ae$var$_.Ib = function RB() {
    return $61de1ee1cac498ae$var$Xhe;
};
var $61de1ee1cac498ae$var$NB;
var $61de1ee1cac498ae$var$iI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONNull", 1023);
$61de1ee1cac498ae$var$bcb(258, 1966, {
    258: 1
}, $61de1ee1cac498ae$var$TB);
$61de1ee1cac498ae$var$_.Fb = function UB(a) {
    if (!$61de1ee1cac498ae$var$JD(a, 258)) return false;
    return this.a == $61de1ee1cac498ae$var$BD(a, 258).a;
};
$61de1ee1cac498ae$var$_.ee = function VB() {
    return $61de1ee1cac498ae$var$ZB;
};
$61de1ee1cac498ae$var$_.Hb = function WB() {
    return $61de1ee1cac498ae$var$Hdb(this.a);
};
$61de1ee1cac498ae$var$_.he = function XB() {
    return this;
};
$61de1ee1cac498ae$var$_.Ib = function YB() {
    return this.a + "";
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$jI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONNumber", 258);
$61de1ee1cac498ae$var$bcb(183, 1966, {
    183: 1
}, $61de1ee1cac498ae$var$eC, $61de1ee1cac498ae$var$fC);
$61de1ee1cac498ae$var$_.Fb = function gC(a) {
    if (!$61de1ee1cac498ae$var$JD(a, 183)) return false;
    return $61de1ee1cac498ae$var$qz(this.a, $61de1ee1cac498ae$var$BD(a, 183).a);
};
$61de1ee1cac498ae$var$_.ee = function hC() {
    return $61de1ee1cac498ae$var$lC;
};
$61de1ee1cac498ae$var$_.Hb = function iC() {
    return $61de1ee1cac498ae$var$rz(this.a);
};
$61de1ee1cac498ae$var$_.ie = function jC() {
    return this;
};
$61de1ee1cac498ae$var$_.Ib = function kC() {
    var a, b, c, d, e, f, g;
    g = new $61de1ee1cac498ae$var$Wfb("{");
    a = true;
    f = $61de1ee1cac498ae$var$$B(this, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, 0, 6, 1));
    for(c = f, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        a ? a = false : (g.a += $61de1ee1cac498ae$var$She, g);
        $61de1ee1cac498ae$var$Qfb(g, $61de1ee1cac498ae$var$vz(b));
        g.a += ":";
        $61de1ee1cac498ae$var$Pfb(g, $61de1ee1cac498ae$var$aC(this, b));
    }
    g.a += "}";
    return g.a;
};
var $61de1ee1cac498ae$var$lI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONObject", 183);
$61de1ee1cac498ae$var$bcb(596, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$mC);
$61de1ee1cac498ae$var$_.Hc = function nC(a) {
    return $61de1ee1cac498ae$var$ND(a) && $61de1ee1cac498ae$var$_B(this.a, $61de1ee1cac498ae$var$GD(a));
};
$61de1ee1cac498ae$var$_.Kc = function oC() {
    return new $61de1ee1cac498ae$var$vib(new $61de1ee1cac498ae$var$amb(this.b));
};
$61de1ee1cac498ae$var$_.gc = function pC() {
    return this.b.length;
};
var $61de1ee1cac498ae$var$kI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONObject/1", 596);
var $61de1ee1cac498ae$var$qC;
$61de1ee1cac498ae$var$bcb(204, 1966, {
    204: 1
}, $61de1ee1cac498ae$var$yC);
$61de1ee1cac498ae$var$_.Fb = function zC(a) {
    if (!$61de1ee1cac498ae$var$JD(a, 204)) return false;
    return $61de1ee1cac498ae$var$dfb(this.a, $61de1ee1cac498ae$var$BD(a, 204).a);
};
$61de1ee1cac498ae$var$_.ee = function AC() {
    return $61de1ee1cac498ae$var$EC;
};
$61de1ee1cac498ae$var$_.Hb = function BC() {
    return $61de1ee1cac498ae$var$LCb(this.a);
};
$61de1ee1cac498ae$var$_.je = function CC() {
    return this;
};
$61de1ee1cac498ae$var$_.Ib = function DC() {
    return $61de1ee1cac498ae$var$vz(this.a);
};
var $61de1ee1cac498ae$var$mI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dje, "JSONString", 204);
var $61de1ee1cac498ae$var$QC;
var $61de1ee1cac498ae$var$sD, $61de1ee1cac498ae$var$tD, $61de1ee1cac498ae$var$uD, $61de1ee1cac498ae$var$vD;
$61de1ee1cac498ae$var$bcb(1962, 1, {
    525: 1
});
var $61de1ee1cac498ae$var$pI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lje, "OutputStream", 1962);
$61de1ee1cac498ae$var$bcb(1963, 1962, {
    525: 1
});
var $61de1ee1cac498ae$var$oI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lje, "FilterOutputStream", 1963);
$61de1ee1cac498ae$var$bcb(866, 1963, {
    525: 1
}, $61de1ee1cac498ae$var$jcb);
var $61de1ee1cac498ae$var$qI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lje, "PrintStream", 866);
$61de1ee1cac498ae$var$bcb(418, 1, {
    475: 1
});
$61de1ee1cac498ae$var$_.Ib = function ncb() {
    return this.a;
};
var $61de1ee1cac498ae$var$rI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "AbstractStringBuilder", 418);
$61de1ee1cac498ae$var$bcb(529, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$ocb);
var $61de1ee1cac498ae$var$sI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "ArithmeticException", 529);
$61de1ee1cac498ae$var$bcb(73, 60, $61de1ee1cac498ae$var$Mje, $61de1ee1cac498ae$var$pcb, $61de1ee1cac498ae$var$qcb);
var $61de1ee1cac498ae$var$II = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "IndexOutOfBoundsException", 73);
$61de1ee1cac498ae$var$bcb(320, 73, {
    3: 1,
    320: 1,
    102: 1,
    73: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$rcb, $61de1ee1cac498ae$var$scb);
var $61de1ee1cac498ae$var$tI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "ArrayIndexOutOfBoundsException", 320);
$61de1ee1cac498ae$var$bcb(528, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$tcb, $61de1ee1cac498ae$var$ucb);
var $61de1ee1cac498ae$var$uI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "ArrayStoreException", 528);
$61de1ee1cac498ae$var$bcb(289, 78, $61de1ee1cac498ae$var$Nje, $61de1ee1cac498ae$var$vcb);
var $61de1ee1cac498ae$var$DI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Error", 289);
$61de1ee1cac498ae$var$bcb(194, 289, $61de1ee1cac498ae$var$Nje, $61de1ee1cac498ae$var$xcb, $61de1ee1cac498ae$var$ycb);
var $61de1ee1cac498ae$var$vI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "AssertionError", 194);
$61de1ee1cac498ae$var$xD = {
    3: 1,
    476: 1,
    35: 1
};
var $61de1ee1cac498ae$var$zcb, $61de1ee1cac498ae$var$Acb;
var $61de1ee1cac498ae$var$wI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Boolean", 476);
$61de1ee1cac498ae$var$bcb(236, 1, {
    3: 1,
    236: 1
});
var $61de1ee1cac498ae$var$Gcb;
var $61de1ee1cac498ae$var$RI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Number", 236);
$61de1ee1cac498ae$var$bcb(217, 236, {
    3: 1,
    217: 1,
    35: 1,
    236: 1
}, $61de1ee1cac498ae$var$Mcb);
$61de1ee1cac498ae$var$_.wd = function Ncb(a) {
    return $61de1ee1cac498ae$var$Lcb(this, $61de1ee1cac498ae$var$BD(a, 217));
};
$61de1ee1cac498ae$var$_.ke = function Ocb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Fb = function Pcb(a) {
    return $61de1ee1cac498ae$var$JD(a, 217) && $61de1ee1cac498ae$var$BD(a, 217).a == this.a;
};
$61de1ee1cac498ae$var$_.Hb = function Qcb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Ib = function Rcb() {
    return "" + this.a;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$xI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Byte", 217);
var $61de1ee1cac498ae$var$Tcb;
$61de1ee1cac498ae$var$bcb(172, 1, {
    3: 1,
    172: 1,
    35: 1
}, $61de1ee1cac498ae$var$Xcb);
$61de1ee1cac498ae$var$_.wd = function Ycb(a) {
    return $61de1ee1cac498ae$var$Wcb(this, $61de1ee1cac498ae$var$BD(a, 172));
};
$61de1ee1cac498ae$var$_.Fb = function $cb(a) {
    return $61de1ee1cac498ae$var$JD(a, 172) && $61de1ee1cac498ae$var$BD(a, 172).a == this.a;
};
$61de1ee1cac498ae$var$_.Hb = function _cb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Ib = function adb() {
    return String.fromCharCode(this.a);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$Vcb;
var $61de1ee1cac498ae$var$yI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Character", 172);
var $61de1ee1cac498ae$var$cdb;
$61de1ee1cac498ae$var$bcb(205, 60, {
    3: 1,
    205: 1,
    102: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$Bdb, $61de1ee1cac498ae$var$Cdb);
var $61de1ee1cac498ae$var$zI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "ClassCastException", 205);
$61de1ee1cac498ae$var$yD = {
    3: 1,
    35: 1,
    333: 1,
    236: 1
};
var $61de1ee1cac498ae$var$BI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Double", 333);
$61de1ee1cac498ae$var$bcb(155, 236, {
    3: 1,
    35: 1,
    155: 1,
    236: 1
}, $61de1ee1cac498ae$var$Ndb, $61de1ee1cac498ae$var$Odb);
$61de1ee1cac498ae$var$_.wd = function Pdb(a) {
    return $61de1ee1cac498ae$var$Mdb(this, $61de1ee1cac498ae$var$BD(a, 155));
};
$61de1ee1cac498ae$var$_.ke = function Qdb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Fb = function Rdb(a) {
    return $61de1ee1cac498ae$var$JD(a, 155) && $61de1ee1cac498ae$var$Fdb(this.a, $61de1ee1cac498ae$var$BD(a, 155).a);
};
$61de1ee1cac498ae$var$_.Hb = function Sdb() {
    return $61de1ee1cac498ae$var$QD(this.a);
};
$61de1ee1cac498ae$var$_.Ib = function Udb() {
    return "" + this.a;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$FI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Float", 155);
$61de1ee1cac498ae$var$bcb(32, 60, {
    3: 1,
    102: 1,
    32: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$Vdb, $61de1ee1cac498ae$var$Wdb, $61de1ee1cac498ae$var$Xdb);
var $61de1ee1cac498ae$var$GI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "IllegalArgumentException", 32);
$61de1ee1cac498ae$var$bcb(71, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$Ydb, $61de1ee1cac498ae$var$Zdb);
var $61de1ee1cac498ae$var$HI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "IllegalStateException", 71);
$61de1ee1cac498ae$var$bcb(19, 236, {
    3: 1,
    35: 1,
    19: 1,
    236: 1
}, $61de1ee1cac498ae$var$_db);
$61de1ee1cac498ae$var$_.wd = function ceb(a) {
    return $61de1ee1cac498ae$var$$db(this, $61de1ee1cac498ae$var$BD(a, 19));
};
$61de1ee1cac498ae$var$_.ke = function deb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Fb = function eeb(a) {
    return $61de1ee1cac498ae$var$JD(a, 19) && $61de1ee1cac498ae$var$BD(a, 19).a == this.a;
};
$61de1ee1cac498ae$var$_.Hb = function feb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Ib = function leb() {
    return "" + this.a;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$JI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Integer", 19);
var $61de1ee1cac498ae$var$neb;
var $61de1ee1cac498ae$var$peb;
$61de1ee1cac498ae$var$bcb(162, 236, {
    3: 1,
    35: 1,
    162: 1,
    236: 1
}, $61de1ee1cac498ae$var$teb);
$61de1ee1cac498ae$var$_.wd = function veb(a) {
    return $61de1ee1cac498ae$var$seb(this, $61de1ee1cac498ae$var$BD(a, 162));
};
$61de1ee1cac498ae$var$_.ke = function web() {
    return $61de1ee1cac498ae$var$Sbb(this.a);
};
$61de1ee1cac498ae$var$_.Fb = function xeb(a) {
    return $61de1ee1cac498ae$var$JD(a, 162) && $61de1ee1cac498ae$var$Bbb($61de1ee1cac498ae$var$BD(a, 162).a, this.a);
};
$61de1ee1cac498ae$var$_.Hb = function yeb() {
    return $61de1ee1cac498ae$var$Tbb(this.a);
};
$61de1ee1cac498ae$var$_.Ib = function zeb() {
    return "" + $61de1ee1cac498ae$var$Ubb(this.a);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$MI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Long", 162);
var $61de1ee1cac498ae$var$Beb;
$61de1ee1cac498ae$var$bcb(2039, 1, {});
$61de1ee1cac498ae$var$bcb(1831, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$Feb);
var $61de1ee1cac498ae$var$NI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "NegativeArraySizeException", 1831);
$61de1ee1cac498ae$var$bcb(173, 598, {
    3: 1,
    102: 1,
    173: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$Geb, $61de1ee1cac498ae$var$Heb);
$61de1ee1cac498ae$var$_.Wd = function Ieb(a) {
    return new TypeError(a);
};
var $61de1ee1cac498ae$var$OI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "NullPointerException", 173);
var $61de1ee1cac498ae$var$Jeb, $61de1ee1cac498ae$var$Keb, $61de1ee1cac498ae$var$Leb, $61de1ee1cac498ae$var$Meb;
$61de1ee1cac498ae$var$bcb(127, 32, {
    3: 1,
    102: 1,
    32: 1,
    127: 1,
    60: 1,
    78: 1
}, $61de1ee1cac498ae$var$Oeb);
var $61de1ee1cac498ae$var$QI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "NumberFormatException", 127);
$61de1ee1cac498ae$var$bcb(184, 236, {
    3: 1,
    35: 1,
    236: 1,
    184: 1
}, $61de1ee1cac498ae$var$Qeb);
$61de1ee1cac498ae$var$_.wd = function Reb(a) {
    return $61de1ee1cac498ae$var$Peb(this, $61de1ee1cac498ae$var$BD(a, 184));
};
$61de1ee1cac498ae$var$_.ke = function Seb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Fb = function Teb(a) {
    return $61de1ee1cac498ae$var$JD(a, 184) && $61de1ee1cac498ae$var$BD(a, 184).a == this.a;
};
$61de1ee1cac498ae$var$_.Hb = function Ueb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Ib = function Veb() {
    return "" + this.a;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$UI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Short", 184);
var $61de1ee1cac498ae$var$Xeb;
$61de1ee1cac498ae$var$bcb(310, 1, {
    3: 1,
    310: 1
}, $61de1ee1cac498ae$var$Zeb);
$61de1ee1cac498ae$var$_.Fb = function $eb(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 310)) {
        b = $61de1ee1cac498ae$var$BD(a, 310);
        return this.c == b.c && this.d == b.d && this.a == b.a && this.b == b.b;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function _eb() {
    return $61de1ee1cac498ae$var$Hlb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        $61de1ee1cac498ae$var$meb(this.c),
        this.a,
        this.d,
        this.b
    ]));
};
$61de1ee1cac498ae$var$_.Ib = function afb() {
    return this.a + "." + this.d + "(" + (this.b != null ? this.b : "Unknown Source") + (this.c >= 0 ? ":" + this.c : "") + ")";
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$VI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "StackTraceElement", 310);
$61de1ee1cac498ae$var$zD = {
    3: 1,
    475: 1,
    35: 1,
    2: 1
};
var $61de1ee1cac498ae$var$ZI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, $61de1ee1cac498ae$var$Vie, 2);
$61de1ee1cac498ae$var$bcb(107, 418, {
    475: 1
}, $61de1ee1cac498ae$var$Hfb, $61de1ee1cac498ae$var$Ifb, $61de1ee1cac498ae$var$Jfb);
var $61de1ee1cac498ae$var$WI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "StringBuffer", 107);
$61de1ee1cac498ae$var$bcb(100, 418, {
    475: 1
}, $61de1ee1cac498ae$var$Ufb, $61de1ee1cac498ae$var$Vfb, $61de1ee1cac498ae$var$Wfb);
var $61de1ee1cac498ae$var$XI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "StringBuilder", 100);
$61de1ee1cac498ae$var$bcb(687, 73, $61de1ee1cac498ae$var$Mje, $61de1ee1cac498ae$var$Xfb);
var $61de1ee1cac498ae$var$YI = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "StringIndexOutOfBoundsException", 687);
$61de1ee1cac498ae$var$bcb(2043, 1, {});
var $61de1ee1cac498ae$var$Yfb;
$61de1ee1cac498ae$var$bcb(844, 1, {}, $61de1ee1cac498ae$var$_fb);
$61de1ee1cac498ae$var$_.Kb = function agb(a) {
    return $61de1ee1cac498ae$var$BD(a, 78).e;
};
var $61de1ee1cac498ae$var$$I = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "Throwable/lambda$0$Type", 844);
$61de1ee1cac498ae$var$bcb(41, 60, {
    3: 1,
    102: 1,
    60: 1,
    78: 1,
    41: 1
}, $61de1ee1cac498ae$var$bgb, $61de1ee1cac498ae$var$cgb);
var $61de1ee1cac498ae$var$aJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Phe, "UnsupportedOperationException", 41);
$61de1ee1cac498ae$var$bcb(240, 236, {
    3: 1,
    35: 1,
    236: 1,
    240: 1
}, $61de1ee1cac498ae$var$sgb, $61de1ee1cac498ae$var$tgb);
$61de1ee1cac498ae$var$_.wd = function wgb(a) {
    return $61de1ee1cac498ae$var$mgb(this, $61de1ee1cac498ae$var$BD(a, 240));
};
$61de1ee1cac498ae$var$_.ke = function xgb() {
    return $61de1ee1cac498ae$var$Hcb($61de1ee1cac498ae$var$rgb(this));
};
$61de1ee1cac498ae$var$_.Fb = function ygb(a) {
    var b;
    if (this === a) return true;
    if ($61de1ee1cac498ae$var$JD(a, 240)) {
        b = $61de1ee1cac498ae$var$BD(a, 240);
        return this.e == b.e && $61de1ee1cac498ae$var$mgb(this, b) == 0;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function zgb() {
    var a;
    if (this.b != 0) return this.b;
    if (this.a < 54) {
        a = $61de1ee1cac498ae$var$Cbb(this.f);
        this.b = $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$xbb(a, -1));
        this.b = 33 * this.b + $61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$xbb($61de1ee1cac498ae$var$Obb(a, 32), -1));
        this.b = 17 * this.b + $61de1ee1cac498ae$var$QD(this.e);
        return this.b;
    }
    this.b = 17 * $61de1ee1cac498ae$var$Ngb(this.c) + $61de1ee1cac498ae$var$QD(this.e);
    return this.b;
};
$61de1ee1cac498ae$var$_.Ib = function Agb() {
    return $61de1ee1cac498ae$var$rgb(this);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$dgb, $61de1ee1cac498ae$var$egb, $61de1ee1cac498ae$var$fgb, $61de1ee1cac498ae$var$ggb, $61de1ee1cac498ae$var$hgb, $61de1ee1cac498ae$var$igb, $61de1ee1cac498ae$var$jgb, $61de1ee1cac498ae$var$kgb;
var $61de1ee1cac498ae$var$bJ = $61de1ee1cac498ae$var$mdb("java.math", "BigDecimal", 240);
$61de1ee1cac498ae$var$bcb(91, 236, {
    3: 1,
    35: 1,
    236: 1,
    91: 1
}, $61de1ee1cac498ae$var$Tgb, $61de1ee1cac498ae$var$Ugb, $61de1ee1cac498ae$var$Vgb, $61de1ee1cac498ae$var$Wgb, $61de1ee1cac498ae$var$Xgb, $61de1ee1cac498ae$var$Ygb);
$61de1ee1cac498ae$var$_.wd = function $gb(a) {
    return $61de1ee1cac498ae$var$Igb(this, $61de1ee1cac498ae$var$BD(a, 91));
};
$61de1ee1cac498ae$var$_.ke = function _gb() {
    return $61de1ee1cac498ae$var$Hcb($61de1ee1cac498ae$var$shb(this, 0));
};
$61de1ee1cac498ae$var$_.Fb = function ahb(a) {
    return $61de1ee1cac498ae$var$Kgb(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function chb() {
    return $61de1ee1cac498ae$var$Ngb(this);
};
$61de1ee1cac498ae$var$_.Ib = function ehb() {
    return $61de1ee1cac498ae$var$shb(this, 0);
};
$61de1ee1cac498ae$var$_.b = -2;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$Bgb, $61de1ee1cac498ae$var$Cgb, $61de1ee1cac498ae$var$Dgb, $61de1ee1cac498ae$var$Egb, $61de1ee1cac498ae$var$Fgb, $61de1ee1cac498ae$var$Ggb;
var $61de1ee1cac498ae$var$cJ = $61de1ee1cac498ae$var$mdb("java.math", "BigInteger", 91);
var $61de1ee1cac498ae$var$nhb, $61de1ee1cac498ae$var$ohb;
var $61de1ee1cac498ae$var$Bhb, $61de1ee1cac498ae$var$Chb;
$61de1ee1cac498ae$var$bcb(488, 1967, $61de1ee1cac498ae$var$cie);
$61de1ee1cac498ae$var$_.$b = function Xhb() {
    $61de1ee1cac498ae$var$Uhb(this);
};
$61de1ee1cac498ae$var$_._b = function Yhb(a) {
    return $61de1ee1cac498ae$var$Mhb(this, a);
};
$61de1ee1cac498ae$var$_.uc = function Zhb(a) {
    return $61de1ee1cac498ae$var$Nhb(this, a, this.g) || $61de1ee1cac498ae$var$Nhb(this, a, this.f);
};
$61de1ee1cac498ae$var$_.vc = function $hb() {
    return new $61de1ee1cac498ae$var$eib(this);
};
$61de1ee1cac498ae$var$_.xc = function _hb(a) {
    return $61de1ee1cac498ae$var$Ohb(this, a);
};
$61de1ee1cac498ae$var$_.zc = function aib(a, b) {
    return $61de1ee1cac498ae$var$Rhb(this, a, b);
};
$61de1ee1cac498ae$var$_.Bc = function bib(a) {
    return $61de1ee1cac498ae$var$Thb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function cib() {
    return $61de1ee1cac498ae$var$Vhb(this);
};
var $61de1ee1cac498ae$var$gJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractHashMap", 488);
$61de1ee1cac498ae$var$bcb(261, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$eib);
$61de1ee1cac498ae$var$_.$b = function fib() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_.Hc = function gib(a) {
    return $61de1ee1cac498ae$var$dib(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function hib() {
    return new $61de1ee1cac498ae$var$nib(this.a);
};
$61de1ee1cac498ae$var$_.Mc = function iib(a) {
    var b;
    if ($61de1ee1cac498ae$var$dib(this, a)) {
        b = $61de1ee1cac498ae$var$BD(a, 42).cd();
        this.a.Bc(b);
        return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function jib() {
    return this.a.gc();
};
var $61de1ee1cac498ae$var$fJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractHashMap/EntrySet", 261);
$61de1ee1cac498ae$var$bcb(262, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$nib);
$61de1ee1cac498ae$var$_.Nb = function oib(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function qib() {
    return $61de1ee1cac498ae$var$lib(this);
};
$61de1ee1cac498ae$var$_.Ob = function pib() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Qb = function rib() {
    $61de1ee1cac498ae$var$mib(this);
};
$61de1ee1cac498ae$var$_.b = false;
var $61de1ee1cac498ae$var$eJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractHashMap/EntrySetIterator", 262);
$61de1ee1cac498ae$var$bcb(417, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$vib);
$61de1ee1cac498ae$var$_.Nb = function wib(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function xib() {
    return $61de1ee1cac498ae$var$sib(this);
};
$61de1ee1cac498ae$var$_.Pb = function yib() {
    return $61de1ee1cac498ae$var$tib(this);
};
$61de1ee1cac498ae$var$_.Qb = function zib() {
    $61de1ee1cac498ae$var$uib(this);
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = -1;
var $61de1ee1cac498ae$var$hJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractList/IteratorImpl", 417);
$61de1ee1cac498ae$var$bcb(96, 417, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$Bib);
$61de1ee1cac498ae$var$_.Qb = function Hib() {
    $61de1ee1cac498ae$var$uib(this);
};
$61de1ee1cac498ae$var$_.Rb = function Cib(a) {
    $61de1ee1cac498ae$var$Aib(this, a);
};
$61de1ee1cac498ae$var$_.Sb = function Dib() {
    return this.b > 0;
};
$61de1ee1cac498ae$var$_.Tb = function Eib() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Ub = function Fib() {
    return $61de1ee1cac498ae$var$sCb(this.b > 0), this.a.Xb(this.c = --this.b);
};
$61de1ee1cac498ae$var$_.Vb = function Gib() {
    return this.b - 1;
};
$61de1ee1cac498ae$var$_.Wb = function Iib(a) {
    $61de1ee1cac498ae$var$yCb(this.c != -1);
    this.a._c(this.c, a);
};
var $61de1ee1cac498ae$var$iJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractList/ListIteratorImpl", 96);
$61de1ee1cac498ae$var$bcb(219, 52, $61de1ee1cac498ae$var$Lie, $61de1ee1cac498ae$var$Jib);
$61de1ee1cac498ae$var$_.Vc = function Kib(a, b) {
    $61de1ee1cac498ae$var$wCb(a, this.b);
    this.c.Vc(this.a + a, b);
    ++this.b;
};
$61de1ee1cac498ae$var$_.Xb = function Lib(a) {
    $61de1ee1cac498ae$var$tCb(a, this.b);
    return this.c.Xb(this.a + a);
};
$61de1ee1cac498ae$var$_.$c = function Mib(a) {
    var b;
    $61de1ee1cac498ae$var$tCb(a, this.b);
    b = this.c.$c(this.a + a);
    --this.b;
    return b;
};
$61de1ee1cac498ae$var$_._c = function Nib(a, b) {
    $61de1ee1cac498ae$var$tCb(a, this.b);
    return this.c._c(this.a + a, b);
};
$61de1ee1cac498ae$var$_.gc = function Oib() {
    return this.b;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$jJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractList/SubList", 219);
$61de1ee1cac498ae$var$bcb(384, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$Pib);
$61de1ee1cac498ae$var$_.$b = function Qib() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_.Hc = function Rib(a) {
    return this.a._b(a);
};
$61de1ee1cac498ae$var$_.Kc = function Sib() {
    var a;
    return a = this.a.vc().Kc(), new $61de1ee1cac498ae$var$Vib(a);
};
$61de1ee1cac498ae$var$_.Mc = function Tib(a) {
    if (this.a._b(a)) {
        this.a.Bc(a);
        return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function Uib() {
    return this.a.gc();
};
var $61de1ee1cac498ae$var$mJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractMap/1", 384);
$61de1ee1cac498ae$var$bcb(691, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Vib);
$61de1ee1cac498ae$var$_.Nb = function Wib(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Xib() {
    return this.a.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Yib() {
    var a;
    return a = $61de1ee1cac498ae$var$BD(this.a.Pb(), 42), a.cd();
};
$61de1ee1cac498ae$var$_.Qb = function Zib() {
    this.a.Qb();
};
var $61de1ee1cac498ae$var$lJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractMap/1/1", 691);
$61de1ee1cac498ae$var$bcb(226, 28, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$$ib);
$61de1ee1cac498ae$var$_.$b = function _ib() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_.Hc = function ajb(a) {
    return this.a.uc(a);
};
$61de1ee1cac498ae$var$_.Kc = function bjb() {
    var a;
    return a = this.a.vc().Kc(), new $61de1ee1cac498ae$var$djb(a);
};
$61de1ee1cac498ae$var$_.gc = function cjb() {
    return this.a.gc();
};
var $61de1ee1cac498ae$var$oJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractMap/2", 226);
$61de1ee1cac498ae$var$bcb(294, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$djb);
$61de1ee1cac498ae$var$_.Nb = function ejb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function fjb() {
    return this.a.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function gjb() {
    var a;
    return a = $61de1ee1cac498ae$var$BD(this.a.Pb(), 42), a.dd();
};
$61de1ee1cac498ae$var$_.Qb = function hjb() {
    this.a.Qb();
};
var $61de1ee1cac498ae$var$nJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractMap/2/1", 294);
$61de1ee1cac498ae$var$bcb(484, 1, {
    484: 1,
    42: 1
});
$61de1ee1cac498ae$var$_.Fb = function jjb(a) {
    var b;
    if (!$61de1ee1cac498ae$var$JD(a, 42)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 42);
    return $61de1ee1cac498ae$var$wtb(this.d, b.cd()) && $61de1ee1cac498ae$var$wtb(this.e, b.dd());
};
$61de1ee1cac498ae$var$_.cd = function kjb() {
    return this.d;
};
$61de1ee1cac498ae$var$_.dd = function ljb() {
    return this.e;
};
$61de1ee1cac498ae$var$_.Hb = function mjb() {
    return $61de1ee1cac498ae$var$xtb(this.d) ^ $61de1ee1cac498ae$var$xtb(this.e);
};
$61de1ee1cac498ae$var$_.ed = function njb(a) {
    return $61de1ee1cac498ae$var$ijb(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function ojb() {
    return this.d + "=" + this.e;
};
var $61de1ee1cac498ae$var$pJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractMap/AbstractEntry", 484);
$61de1ee1cac498ae$var$bcb(383, 484, {
    484: 1,
    383: 1,
    42: 1
}, $61de1ee1cac498ae$var$pjb);
var $61de1ee1cac498ae$var$qJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractMap/SimpleEntry", 383);
$61de1ee1cac498ae$var$bcb(1984, 1, $61de1ee1cac498ae$var$_je);
$61de1ee1cac498ae$var$_.Fb = function qjb(a) {
    var b;
    if (!$61de1ee1cac498ae$var$JD(a, 42)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 42);
    return $61de1ee1cac498ae$var$wtb(this.cd(), b.cd()) && $61de1ee1cac498ae$var$wtb(this.dd(), b.dd());
};
$61de1ee1cac498ae$var$_.Hb = function rjb() {
    return $61de1ee1cac498ae$var$xtb(this.cd()) ^ $61de1ee1cac498ae$var$xtb(this.dd());
};
$61de1ee1cac498ae$var$_.Ib = function sjb() {
    return this.cd() + "=" + this.dd();
};
var $61de1ee1cac498ae$var$rJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, $61de1ee1cac498ae$var$lie, 1984);
$61de1ee1cac498ae$var$bcb(1992, 1967, $61de1ee1cac498ae$var$gie);
$61de1ee1cac498ae$var$_.tc = function vjb(a) {
    return $61de1ee1cac498ae$var$tjb(this, a);
};
$61de1ee1cac498ae$var$_._b = function wjb(a) {
    return $61de1ee1cac498ae$var$ujb(this, a);
};
$61de1ee1cac498ae$var$_.vc = function xjb() {
    return new $61de1ee1cac498ae$var$Bjb(this);
};
$61de1ee1cac498ae$var$_.xc = function yjb(a) {
    var b;
    b = a;
    return $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$Awb(this, b));
};
$61de1ee1cac498ae$var$_.ec = function Ajb() {
    return new $61de1ee1cac498ae$var$Gjb(this);
};
var $61de1ee1cac498ae$var$wJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractNavigableMap", 1992);
$61de1ee1cac498ae$var$bcb(739, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$Bjb);
$61de1ee1cac498ae$var$_.Hc = function Cjb(a) {
    return $61de1ee1cac498ae$var$JD(a, 42) && $61de1ee1cac498ae$var$tjb(this.b, $61de1ee1cac498ae$var$BD(a, 42));
};
$61de1ee1cac498ae$var$_.Kc = function Djb() {
    return new $61de1ee1cac498ae$var$Ywb(this.b);
};
$61de1ee1cac498ae$var$_.Mc = function Ejb(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 42)) {
        b = $61de1ee1cac498ae$var$BD(a, 42);
        return $61de1ee1cac498ae$var$Kwb(this.b, b);
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function Fjb() {
    return this.b.c;
};
var $61de1ee1cac498ae$var$tJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractNavigableMap/EntrySet", 739);
$61de1ee1cac498ae$var$bcb(493, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$iie, $61de1ee1cac498ae$var$Gjb);
$61de1ee1cac498ae$var$_.Nc = function Mjb() {
    return new $61de1ee1cac498ae$var$Rub(this);
};
$61de1ee1cac498ae$var$_.$b = function Hjb() {
    $61de1ee1cac498ae$var$zwb(this.a);
};
$61de1ee1cac498ae$var$_.Hc = function Ijb(a) {
    return $61de1ee1cac498ae$var$ujb(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function Jjb() {
    var a;
    return a = new $61de1ee1cac498ae$var$Ywb(new $61de1ee1cac498ae$var$cxb(this.a).b), new $61de1ee1cac498ae$var$Njb(a);
};
$61de1ee1cac498ae$var$_.Mc = function Kjb(a) {
    if ($61de1ee1cac498ae$var$ujb(this.a, a)) {
        $61de1ee1cac498ae$var$Jwb(this.a, a);
        return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function Ljb() {
    return this.a.c;
};
var $61de1ee1cac498ae$var$vJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractNavigableMap/NavigableKeySet", 493);
$61de1ee1cac498ae$var$bcb(494, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Njb);
$61de1ee1cac498ae$var$_.Nb = function Ojb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Pjb() {
    return $61de1ee1cac498ae$var$sib(this.a.a);
};
$61de1ee1cac498ae$var$_.Pb = function Qjb() {
    var a;
    return a = $61de1ee1cac498ae$var$Wwb(this.a), a.cd();
};
$61de1ee1cac498ae$var$_.Qb = function Rjb() {
    $61de1ee1cac498ae$var$Xwb(this.a);
};
var $61de1ee1cac498ae$var$uJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractNavigableMap/NavigableKeySet/1", 494);
$61de1ee1cac498ae$var$bcb(2004, 28, $61de1ee1cac498ae$var$die);
$61de1ee1cac498ae$var$_.Fc = function Sjb(a) {
    return $61de1ee1cac498ae$var$zCb($61de1ee1cac498ae$var$cub(this, a)), true;
};
$61de1ee1cac498ae$var$_.Gc = function Tjb(a) {
    $61de1ee1cac498ae$var$uCb(a);
    $61de1ee1cac498ae$var$mCb(a != this, "Can't add a queue to itself");
    return $61de1ee1cac498ae$var$ye(this, a);
};
$61de1ee1cac498ae$var$_.$b = function Ujb() {
    while($61de1ee1cac498ae$var$dub(this) != null);
};
var $61de1ee1cac498ae$var$xJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "AbstractQueue", 2004);
$61de1ee1cac498ae$var$bcb(302, 28, {
    4: 1,
    20: 1,
    28: 1,
    14: 1
}, $61de1ee1cac498ae$var$jkb, $61de1ee1cac498ae$var$kkb);
$61de1ee1cac498ae$var$_.Fc = function lkb(a) {
    return $61de1ee1cac498ae$var$Xjb(this, a), true;
};
$61de1ee1cac498ae$var$_.$b = function nkb() {
    $61de1ee1cac498ae$var$Yjb(this);
};
$61de1ee1cac498ae$var$_.Hc = function okb(a) {
    return $61de1ee1cac498ae$var$Zjb(new $61de1ee1cac498ae$var$xkb(this), a);
};
$61de1ee1cac498ae$var$_.dc = function pkb() {
    return $61de1ee1cac498ae$var$akb(this);
};
$61de1ee1cac498ae$var$_.Kc = function qkb() {
    return new $61de1ee1cac498ae$var$xkb(this);
};
$61de1ee1cac498ae$var$_.Mc = function rkb(a) {
    return $61de1ee1cac498ae$var$dkb(new $61de1ee1cac498ae$var$xkb(this), a);
};
$61de1ee1cac498ae$var$_.gc = function skb() {
    return this.c - this.b & this.a.length - 1;
};
$61de1ee1cac498ae$var$_.Nc = function tkb() {
    return new $61de1ee1cac498ae$var$Kub(this, 272);
};
$61de1ee1cac498ae$var$_.Qc = function ukb(a) {
    var b;
    b = this.c - this.b & this.a.length - 1;
    a.length < b && (a = $61de1ee1cac498ae$var$eCb(new Array(b), a));
    $61de1ee1cac498ae$var$$jb(this, a, b);
    a.length > b && $61de1ee1cac498ae$var$NC(a, b, null);
    return a;
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$BJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "ArrayDeque", 302);
$61de1ee1cac498ae$var$bcb(446, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$xkb);
$61de1ee1cac498ae$var$_.Nb = function ykb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function zkb() {
    return this.a != this.b;
};
$61de1ee1cac498ae$var$_.Pb = function Akb() {
    return $61de1ee1cac498ae$var$vkb(this);
};
$61de1ee1cac498ae$var$_.Qb = function Bkb() {
    $61de1ee1cac498ae$var$wkb(this);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = -1;
var $61de1ee1cac498ae$var$AJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "ArrayDeque/IteratorImpl", 446);
$61de1ee1cac498ae$var$bcb(12, 52, $61de1ee1cac498ae$var$ake, $61de1ee1cac498ae$var$Rkb, $61de1ee1cac498ae$var$Skb, $61de1ee1cac498ae$var$Tkb);
$61de1ee1cac498ae$var$_.Vc = function Ukb(a, b) {
    $61de1ee1cac498ae$var$Dkb(this, a, b);
};
$61de1ee1cac498ae$var$_.Fc = function Vkb(a) {
    return $61de1ee1cac498ae$var$Ekb(this, a);
};
$61de1ee1cac498ae$var$_.Wc = function Wkb(a, b) {
    return $61de1ee1cac498ae$var$Fkb(this, a, b);
};
$61de1ee1cac498ae$var$_.Gc = function Xkb(a) {
    return $61de1ee1cac498ae$var$Gkb(this, a);
};
$61de1ee1cac498ae$var$_.$b = function Ykb() {
    this.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
};
$61de1ee1cac498ae$var$_.Hc = function Zkb(a) {
    return $61de1ee1cac498ae$var$Jkb(this, a, 0) != -1;
};
$61de1ee1cac498ae$var$_.Jc = function $kb(a) {
    $61de1ee1cac498ae$var$Hkb(this, a);
};
$61de1ee1cac498ae$var$_.Xb = function _kb(a) {
    return $61de1ee1cac498ae$var$Ikb(this, a);
};
$61de1ee1cac498ae$var$_.Xc = function alb(a) {
    return $61de1ee1cac498ae$var$Jkb(this, a, 0);
};
$61de1ee1cac498ae$var$_.dc = function blb() {
    return this.c.length == 0;
};
$61de1ee1cac498ae$var$_.Kc = function clb() {
    return new $61de1ee1cac498ae$var$olb(this);
};
$61de1ee1cac498ae$var$_.$c = function dlb(a) {
    return $61de1ee1cac498ae$var$Kkb(this, a);
};
$61de1ee1cac498ae$var$_.Mc = function elb(a) {
    return $61de1ee1cac498ae$var$Lkb(this, a);
};
$61de1ee1cac498ae$var$_.Ud = function flb(a, b) {
    $61de1ee1cac498ae$var$Mkb(this, a, b);
};
$61de1ee1cac498ae$var$_._c = function glb(a, b) {
    return $61de1ee1cac498ae$var$Nkb(this, a, b);
};
$61de1ee1cac498ae$var$_.gc = function hlb() {
    return this.c.length;
};
$61de1ee1cac498ae$var$_.ad = function ilb(a) {
    $61de1ee1cac498ae$var$Okb(this, a);
};
$61de1ee1cac498ae$var$_.Pc = function jlb() {
    return $61de1ee1cac498ae$var$Pkb(this);
};
$61de1ee1cac498ae$var$_.Qc = function klb(a) {
    return $61de1ee1cac498ae$var$Qkb(this, a);
};
var $61de1ee1cac498ae$var$DJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "ArrayList", 12);
$61de1ee1cac498ae$var$bcb(7, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$olb);
$61de1ee1cac498ae$var$_.Nb = function plb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function qlb() {
    return $61de1ee1cac498ae$var$llb(this);
};
$61de1ee1cac498ae$var$_.Pb = function rlb() {
    return $61de1ee1cac498ae$var$mlb(this);
};
$61de1ee1cac498ae$var$_.Qb = function slb() {
    $61de1ee1cac498ae$var$nlb(this);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = -1;
var $61de1ee1cac498ae$var$CJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "ArrayList/1", 7);
$61de1ee1cac498ae$var$bcb(2013, $61de1ee1cac498ae$var$$wnd.Function, {}, $61de1ee1cac498ae$var$Ylb);
$61de1ee1cac498ae$var$_.te = function Zlb(a, b) {
    return $61de1ee1cac498ae$var$Kdb(a, b);
};
$61de1ee1cac498ae$var$bcb(154, 52, $61de1ee1cac498ae$var$bke, $61de1ee1cac498ae$var$amb);
$61de1ee1cac498ae$var$_.Hc = function bmb(a) {
    return $61de1ee1cac498ae$var$Bt(this, a) != -1;
};
$61de1ee1cac498ae$var$_.Jc = function cmb(a) {
    var b, c, d, e;
    $61de1ee1cac498ae$var$uCb(a);
    for(c = this.a, d = 0, e = c.length; d < e; ++d){
        b = c[d];
        a.td(b);
    }
};
$61de1ee1cac498ae$var$_.Xb = function dmb(a) {
    return $61de1ee1cac498ae$var$$lb(this, a);
};
$61de1ee1cac498ae$var$_._c = function emb(a, b) {
    var c;
    c = ($61de1ee1cac498ae$var$tCb(a, this.a.length), this.a[a]);
    $61de1ee1cac498ae$var$NC(this.a, a, b);
    return c;
};
$61de1ee1cac498ae$var$_.gc = function fmb() {
    return this.a.length;
};
$61de1ee1cac498ae$var$_.ad = function gmb(a) {
    $61de1ee1cac498ae$var$Mlb(this.a, this.a.length, a);
};
$61de1ee1cac498ae$var$_.Pc = function hmb() {
    return $61de1ee1cac498ae$var$_lb(this, $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, this.a.length, 5, 1));
};
$61de1ee1cac498ae$var$_.Qc = function imb(a) {
    return $61de1ee1cac498ae$var$_lb(this, a);
};
var $61de1ee1cac498ae$var$EJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Arrays/ArrayList", 154);
var $61de1ee1cac498ae$var$jmb, $61de1ee1cac498ae$var$kmb, $61de1ee1cac498ae$var$lmb;
$61de1ee1cac498ae$var$bcb(940, 52, $61de1ee1cac498ae$var$bke, $61de1ee1cac498ae$var$xmb);
$61de1ee1cac498ae$var$_.Hc = function ymb(a) {
    return false;
};
$61de1ee1cac498ae$var$_.Xb = function zmb(a) {
    return $61de1ee1cac498ae$var$wmb(a);
};
$61de1ee1cac498ae$var$_.Kc = function Amb() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Emb(), $61de1ee1cac498ae$var$Dmb;
};
$61de1ee1cac498ae$var$_.Yc = function Bmb() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Emb(), $61de1ee1cac498ae$var$Dmb;
};
$61de1ee1cac498ae$var$_.gc = function Cmb() {
    return 0;
};
var $61de1ee1cac498ae$var$GJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/EmptyList", 940);
$61de1ee1cac498ae$var$bcb(941, 1, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$Fmb);
$61de1ee1cac498ae$var$_.Nb = function Hmb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Rb = function Gmb(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Ob = function Imb() {
    return false;
};
$61de1ee1cac498ae$var$_.Sb = function Jmb() {
    return false;
};
$61de1ee1cac498ae$var$_.Pb = function Kmb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Tb = function Lmb() {
    return 0;
};
$61de1ee1cac498ae$var$_.Ub = function Mmb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Vb = function Nmb() {
    return -1;
};
$61de1ee1cac498ae$var$_.Qb = function Omb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
};
$61de1ee1cac498ae$var$_.Wb = function Pmb(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
};
var $61de1ee1cac498ae$var$Dmb;
var $61de1ee1cac498ae$var$FJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/EmptyListIterator", 941);
$61de1ee1cac498ae$var$bcb(943, 1967, $61de1ee1cac498ae$var$Aie, $61de1ee1cac498ae$var$Qmb);
$61de1ee1cac498ae$var$_._b = function Rmb(a) {
    return false;
};
$61de1ee1cac498ae$var$_.uc = function Smb(a) {
    return false;
};
$61de1ee1cac498ae$var$_.vc = function Tmb() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$lmb;
};
$61de1ee1cac498ae$var$_.xc = function Umb(a) {
    return null;
};
$61de1ee1cac498ae$var$_.ec = function Vmb() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$lmb;
};
$61de1ee1cac498ae$var$_.gc = function Wmb() {
    return 0;
};
$61de1ee1cac498ae$var$_.Cc = function Xmb() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
};
var $61de1ee1cac498ae$var$HJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/EmptyMap", 943);
$61de1ee1cac498ae$var$bcb(942, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$Cie, $61de1ee1cac498ae$var$Ymb);
$61de1ee1cac498ae$var$_.Hc = function Zmb(a) {
    return false;
};
$61de1ee1cac498ae$var$_.Kc = function $mb() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Emb(), $61de1ee1cac498ae$var$Dmb;
};
$61de1ee1cac498ae$var$_.gc = function _mb() {
    return 0;
};
var $61de1ee1cac498ae$var$IJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/EmptySet", 942);
$61de1ee1cac498ae$var$bcb(599, 52, {
    3: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1
}, $61de1ee1cac498ae$var$anb);
$61de1ee1cac498ae$var$_.Hc = function bnb(a) {
    return $61de1ee1cac498ae$var$wtb(this.a, a);
};
$61de1ee1cac498ae$var$_.Xb = function cnb(a) {
    $61de1ee1cac498ae$var$tCb(a, 1);
    return this.a;
};
$61de1ee1cac498ae$var$_.gc = function dnb() {
    return 1;
};
var $61de1ee1cac498ae$var$JJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/SingletonList", 599);
$61de1ee1cac498ae$var$bcb(372, 1, $61de1ee1cac498ae$var$wie, $61de1ee1cac498ae$var$lnb);
$61de1ee1cac498ae$var$_.Jc = function rnb(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Lc = function unb() {
    return new $61de1ee1cac498ae$var$YAb(null, this.Nc());
};
$61de1ee1cac498ae$var$_.Nc = function xnb() {
    return new $61de1ee1cac498ae$var$Kub(this, 0);
};
$61de1ee1cac498ae$var$_.Oc = function ynb() {
    return new $61de1ee1cac498ae$var$YAb(null, this.Nc());
};
$61de1ee1cac498ae$var$_.Fc = function mnb(a) {
    return $61de1ee1cac498ae$var$enb();
};
$61de1ee1cac498ae$var$_.Gc = function nnb(a) {
    return $61de1ee1cac498ae$var$fnb();
};
$61de1ee1cac498ae$var$_.$b = function onb() {
    $61de1ee1cac498ae$var$gnb();
};
$61de1ee1cac498ae$var$_.Hc = function pnb(a) {
    return $61de1ee1cac498ae$var$hnb(this, a);
};
$61de1ee1cac498ae$var$_.Ic = function qnb(a) {
    return $61de1ee1cac498ae$var$inb(this, a);
};
$61de1ee1cac498ae$var$_.dc = function snb() {
    return this.b.dc();
};
$61de1ee1cac498ae$var$_.Kc = function tnb() {
    return new $61de1ee1cac498ae$var$Dnb(this.b.Kc());
};
$61de1ee1cac498ae$var$_.Mc = function vnb(a) {
    return $61de1ee1cac498ae$var$jnb();
};
$61de1ee1cac498ae$var$_.gc = function wnb() {
    return this.b.gc();
};
$61de1ee1cac498ae$var$_.Pc = function znb() {
    return this.b.Pc();
};
$61de1ee1cac498ae$var$_.Qc = function Anb(a) {
    return $61de1ee1cac498ae$var$knb(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function Bnb() {
    return $61de1ee1cac498ae$var$fcb(this.b);
};
var $61de1ee1cac498ae$var$LJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableCollection", 372);
$61de1ee1cac498ae$var$bcb(371, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Dnb);
$61de1ee1cac498ae$var$_.Nb = function Enb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Fnb() {
    return this.b.Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Gnb() {
    return this.b.Pb();
};
$61de1ee1cac498ae$var$_.Qb = function Hnb() {
    $61de1ee1cac498ae$var$Cnb();
};
var $61de1ee1cac498ae$var$KJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableCollectionIterator", 371);
$61de1ee1cac498ae$var$bcb(531, 372, $61de1ee1cac498ae$var$cke, $61de1ee1cac498ae$var$Inb);
$61de1ee1cac498ae$var$_.Nc = function Vnb() {
    return new $61de1ee1cac498ae$var$Kub(this, 16);
};
$61de1ee1cac498ae$var$_.Vc = function Jnb(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wc = function Knb(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Fb = function Lnb(a) {
    return $61de1ee1cac498ae$var$pb(this.a, a);
};
$61de1ee1cac498ae$var$_.Xb = function Mnb(a) {
    return this.a.Xb(a);
};
$61de1ee1cac498ae$var$_.Hb = function Nnb() {
    return $61de1ee1cac498ae$var$tb(this.a);
};
$61de1ee1cac498ae$var$_.Xc = function Onb(a) {
    return this.a.Xc(a);
};
$61de1ee1cac498ae$var$_.dc = function Pnb() {
    return this.a.dc();
};
$61de1ee1cac498ae$var$_.Yc = function Qnb() {
    return new $61de1ee1cac498ae$var$Xnb(this.a.Zc(0));
};
$61de1ee1cac498ae$var$_.Zc = function Rnb(a) {
    return new $61de1ee1cac498ae$var$Xnb(this.a.Zc(a));
};
$61de1ee1cac498ae$var$_.$c = function Snb(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_._c = function Tnb(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.ad = function Unb(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.bd = function Wnb(a, b) {
    return new $61de1ee1cac498ae$var$Inb(this.a.bd(a, b));
};
var $61de1ee1cac498ae$var$NJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableList", 531);
$61de1ee1cac498ae$var$bcb(690, 371, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$Xnb);
$61de1ee1cac498ae$var$_.Qb = function bob() {
    $61de1ee1cac498ae$var$Cnb();
};
$61de1ee1cac498ae$var$_.Rb = function Ynb(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Sb = function Znb() {
    return this.a.Sb();
};
$61de1ee1cac498ae$var$_.Tb = function $nb() {
    return this.a.Tb();
};
$61de1ee1cac498ae$var$_.Ub = function _nb() {
    return this.a.Ub();
};
$61de1ee1cac498ae$var$_.Vb = function aob() {
    return this.a.Vb();
};
$61de1ee1cac498ae$var$_.Wb = function cob(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$MJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableListIterator", 690);
$61de1ee1cac498ae$var$bcb(600, 1, $61de1ee1cac498ae$var$cie, $61de1ee1cac498ae$var$iob);
$61de1ee1cac498ae$var$_.wc = function oob(a) {
    $61de1ee1cac498ae$var$stb(this, a);
};
$61de1ee1cac498ae$var$_.yc = function tob(a, b, c) {
    return $61de1ee1cac498ae$var$ttb(this, a, b, c);
};
$61de1ee1cac498ae$var$_.$b = function job() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_._b = function kob(a) {
    return this.c._b(a);
};
$61de1ee1cac498ae$var$_.uc = function lob(a) {
    return $61de1ee1cac498ae$var$dob(this, a);
};
$61de1ee1cac498ae$var$_.vc = function mob() {
    return $61de1ee1cac498ae$var$eob(this);
};
$61de1ee1cac498ae$var$_.Fb = function nob(a) {
    return $61de1ee1cac498ae$var$fob(this, a);
};
$61de1ee1cac498ae$var$_.xc = function pob(a) {
    return this.c.xc(a);
};
$61de1ee1cac498ae$var$_.Hb = function qob() {
    return $61de1ee1cac498ae$var$tb(this.c);
};
$61de1ee1cac498ae$var$_.dc = function rob() {
    return this.c.dc();
};
$61de1ee1cac498ae$var$_.ec = function sob() {
    return $61de1ee1cac498ae$var$gob(this);
};
$61de1ee1cac498ae$var$_.zc = function uob(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Bc = function vob(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.gc = function wob() {
    return this.c.gc();
};
$61de1ee1cac498ae$var$_.Ib = function xob() {
    return $61de1ee1cac498ae$var$fcb(this.c);
};
$61de1ee1cac498ae$var$_.Cc = function yob() {
    return $61de1ee1cac498ae$var$hob(this);
};
var $61de1ee1cac498ae$var$RJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableMap", 600);
$61de1ee1cac498ae$var$bcb(382, 372, $61de1ee1cac498ae$var$Bie, $61de1ee1cac498ae$var$zob);
$61de1ee1cac498ae$var$_.Nc = function Cob() {
    return new $61de1ee1cac498ae$var$Kub(this, 1);
};
$61de1ee1cac498ae$var$_.Fb = function Aob(a) {
    return $61de1ee1cac498ae$var$pb(this.b, a);
};
$61de1ee1cac498ae$var$_.Hb = function Bob() {
    return $61de1ee1cac498ae$var$tb(this.b);
};
var $61de1ee1cac498ae$var$TJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableSet", 382);
$61de1ee1cac498ae$var$bcb(944, 382, $61de1ee1cac498ae$var$Bie, $61de1ee1cac498ae$var$Gob);
$61de1ee1cac498ae$var$_.Hc = function Hob(a) {
    return $61de1ee1cac498ae$var$Dob(this, a);
};
$61de1ee1cac498ae$var$_.Ic = function Iob(a) {
    return this.b.Ic(a);
};
$61de1ee1cac498ae$var$_.Kc = function Job() {
    var a;
    a = this.b.Kc();
    return new $61de1ee1cac498ae$var$Mob(a);
};
$61de1ee1cac498ae$var$_.Pc = function Kob() {
    var a;
    a = this.b.Pc();
    $61de1ee1cac498ae$var$Fob(a, a.length);
    return a;
};
$61de1ee1cac498ae$var$_.Qc = function Lob(a) {
    return $61de1ee1cac498ae$var$Eob(this, a);
};
var $61de1ee1cac498ae$var$QJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableMap/UnmodifiableEntrySet", 944);
$61de1ee1cac498ae$var$bcb(945, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Mob);
$61de1ee1cac498ae$var$_.Nb = function Nob(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function Pob() {
    return new $61de1ee1cac498ae$var$Rob($61de1ee1cac498ae$var$BD(this.a.Pb(), 42));
};
$61de1ee1cac498ae$var$_.Ob = function Oob() {
    return this.a.Ob();
};
$61de1ee1cac498ae$var$_.Qb = function Qob() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$OJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableMap/UnmodifiableEntrySet/1", 945);
$61de1ee1cac498ae$var$bcb(688, 1, $61de1ee1cac498ae$var$_je, $61de1ee1cac498ae$var$Rob);
$61de1ee1cac498ae$var$_.Fb = function Sob(a) {
    return this.a.Fb(a);
};
$61de1ee1cac498ae$var$_.cd = function Tob() {
    return this.a.cd();
};
$61de1ee1cac498ae$var$_.dd = function Uob() {
    return this.a.dd();
};
$61de1ee1cac498ae$var$_.Hb = function Vob() {
    return this.a.Hb();
};
$61de1ee1cac498ae$var$_.ed = function Wob(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Ib = function Xob() {
    return $61de1ee1cac498ae$var$fcb(this.a);
};
var $61de1ee1cac498ae$var$PJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableMap/UnmodifiableEntrySet/UnmodifiableEntry", 688);
$61de1ee1cac498ae$var$bcb(601, 531, {
    20: 1,
    14: 1,
    15: 1,
    54: 1
}, $61de1ee1cac498ae$var$Yob);
var $61de1ee1cac498ae$var$SJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableRandomAccessList", 601);
$61de1ee1cac498ae$var$bcb(689, 382, $61de1ee1cac498ae$var$Die, $61de1ee1cac498ae$var$Zob);
$61de1ee1cac498ae$var$_.Nc = function apb() {
    return new $61de1ee1cac498ae$var$Rub(this);
};
$61de1ee1cac498ae$var$_.Fb = function $ob(a) {
    return $61de1ee1cac498ae$var$pb(this.a, a);
};
$61de1ee1cac498ae$var$_.Hb = function _ob() {
    return $61de1ee1cac498ae$var$tb(this.a);
};
var $61de1ee1cac498ae$var$UJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Collections/UnmodifiableSortedSet", 689);
$61de1ee1cac498ae$var$bcb(847, 1, $61de1ee1cac498ae$var$dke, $61de1ee1cac498ae$var$bpb);
$61de1ee1cac498ae$var$_.ue = function cpb(a, b) {
    var c;
    return c = $61de1ee1cac498ae$var$Ucc($61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11)), c != 0 ? c : $61de1ee1cac498ae$var$Wcc($61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function dpb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function epb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$VJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Comparator/lambda$0$Type", 847);
var $61de1ee1cac498ae$var$fpb, $61de1ee1cac498ae$var$gpb, $61de1ee1cac498ae$var$hpb;
$61de1ee1cac498ae$var$bcb(751, 1, $61de1ee1cac498ae$var$dke, $61de1ee1cac498ae$var$kpb);
$61de1ee1cac498ae$var$_.ue = function lpb(a, b) {
    return $61de1ee1cac498ae$var$jpb($61de1ee1cac498ae$var$BD(a, 35), $61de1ee1cac498ae$var$BD(b, 35));
};
$61de1ee1cac498ae$var$_.Fb = function mpb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function npb() {
    return $61de1ee1cac498ae$var$ipb(), $61de1ee1cac498ae$var$hpb;
};
var $61de1ee1cac498ae$var$WJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Comparators/NaturalOrderComparator", 751);
$61de1ee1cac498ae$var$bcb(1177, 1, $61de1ee1cac498ae$var$dke, $61de1ee1cac498ae$var$ppb);
$61de1ee1cac498ae$var$_.ue = function qpb(a, b) {
    return $61de1ee1cac498ae$var$opb($61de1ee1cac498ae$var$BD(a, 35), $61de1ee1cac498ae$var$BD(b, 35));
};
$61de1ee1cac498ae$var$_.Fb = function rpb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function spb() {
    return $61de1ee1cac498ae$var$ipb(), $61de1ee1cac498ae$var$gpb;
};
var $61de1ee1cac498ae$var$XJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Comparators/ReverseNaturalOrderComparator", 1177);
$61de1ee1cac498ae$var$bcb(64, 1, $61de1ee1cac498ae$var$dke, $61de1ee1cac498ae$var$tpb);
$61de1ee1cac498ae$var$_.Fb = function vpb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ue = function upb(a, b) {
    return this.a.ue(b, a);
};
$61de1ee1cac498ae$var$_.ve = function wpb() {
    return this.a;
};
var $61de1ee1cac498ae$var$YJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Comparators/ReversedComparator", 64);
$61de1ee1cac498ae$var$bcb(166, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$Apb);
var $61de1ee1cac498ae$var$ZJ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "ConcurrentModificationException", 166);
var $61de1ee1cac498ae$var$Bpb, $61de1ee1cac498ae$var$Cpb;
$61de1ee1cac498ae$var$bcb(1904, 1, $61de1ee1cac498ae$var$eke, $61de1ee1cac498ae$var$Gpb);
$61de1ee1cac498ae$var$_.we = function Hpb(a) {
    $61de1ee1cac498ae$var$Epb(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function Ipb() {
    return "DoubleSummaryStatistics[count = " + $61de1ee1cac498ae$var$Ubb(this.a) + ", avg = " + ($61de1ee1cac498ae$var$Dbb(this.a, 0) ? $61de1ee1cac498ae$var$Fpb(this) / $61de1ee1cac498ae$var$Sbb(this.a) : 0) + ", min = " + this.c + ", max = " + this.b + ", sum = " + $61de1ee1cac498ae$var$Fpb(this) + "]";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = $61de1ee1cac498ae$var$Qje;
$61de1ee1cac498ae$var$_.c = $61de1ee1cac498ae$var$Pje;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$_J = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "DoubleSummaryStatistics", 1904);
$61de1ee1cac498ae$var$bcb(1805, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$Jpb);
var $61de1ee1cac498ae$var$aK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EmptyStackException", 1805);
$61de1ee1cac498ae$var$bcb(451, 1967, $61de1ee1cac498ae$var$cie, $61de1ee1cac498ae$var$Rpb);
$61de1ee1cac498ae$var$_.zc = function Xpb(a, b) {
    return $61de1ee1cac498ae$var$Opb(this, a, b);
};
$61de1ee1cac498ae$var$_.$b = function Spb() {
    $61de1ee1cac498ae$var$Kpb(this);
};
$61de1ee1cac498ae$var$_._b = function Tpb(a) {
    return $61de1ee1cac498ae$var$Lpb(this, a);
};
$61de1ee1cac498ae$var$_.uc = function Upb(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$Gqb(this.a); c.a < c.c.a.length;){
        b = $61de1ee1cac498ae$var$Fqb(c);
        if ($61de1ee1cac498ae$var$wtb(a, this.b[b.g])) return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.vc = function Vpb() {
    return new $61de1ee1cac498ae$var$_pb(this);
};
$61de1ee1cac498ae$var$_.xc = function Wpb(a) {
    return $61de1ee1cac498ae$var$Mpb(this, a);
};
$61de1ee1cac498ae$var$_.Bc = function Ypb(a) {
    return $61de1ee1cac498ae$var$Ppb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function Zpb() {
    return this.a.c;
};
var $61de1ee1cac498ae$var$eK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EnumMap", 451);
$61de1ee1cac498ae$var$bcb(1352, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$_pb);
$61de1ee1cac498ae$var$_.$b = function aqb() {
    $61de1ee1cac498ae$var$Kpb(this.a);
};
$61de1ee1cac498ae$var$_.Hc = function bqb(a) {
    return $61de1ee1cac498ae$var$$pb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function cqb() {
    return new $61de1ee1cac498ae$var$fqb(this.a);
};
$61de1ee1cac498ae$var$_.Mc = function dqb(a) {
    var b;
    if ($61de1ee1cac498ae$var$$pb(this, a)) {
        b = $61de1ee1cac498ae$var$BD(a, 42).cd();
        $61de1ee1cac498ae$var$Ppb(this.a, b);
        return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function eqb() {
    return this.a.a.c;
};
var $61de1ee1cac498ae$var$cK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EnumMap/EntrySet", 1352);
$61de1ee1cac498ae$var$bcb(1353, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$fqb);
$61de1ee1cac498ae$var$_.Nb = function gqb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function iqb() {
    return this.b = $61de1ee1cac498ae$var$Fqb(this.a), new $61de1ee1cac498ae$var$kqb(this.c, this.b);
};
$61de1ee1cac498ae$var$_.Ob = function hqb() {
    return $61de1ee1cac498ae$var$Eqb(this.a);
};
$61de1ee1cac498ae$var$_.Qb = function jqb() {
    $61de1ee1cac498ae$var$yCb(!!this.b);
    $61de1ee1cac498ae$var$Ppb(this.c, this.b);
    this.b = null;
};
var $61de1ee1cac498ae$var$bK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EnumMap/EntrySetIterator", 1353);
$61de1ee1cac498ae$var$bcb(1354, 1984, $61de1ee1cac498ae$var$_je, $61de1ee1cac498ae$var$kqb);
$61de1ee1cac498ae$var$_.cd = function lqb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.dd = function mqb() {
    return this.b.b[this.a.g];
};
$61de1ee1cac498ae$var$_.ed = function nqb(a) {
    return $61de1ee1cac498ae$var$Qpb(this.b, this.a.g, a);
};
var $61de1ee1cac498ae$var$dK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EnumMap/MapEntry", 1354);
$61de1ee1cac498ae$var$bcb(174, $61de1ee1cac498ae$var$eie, {
    20: 1,
    28: 1,
    14: 1,
    174: 1,
    21: 1
});
var $61de1ee1cac498ae$var$hK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EnumSet", 174);
$61de1ee1cac498ae$var$bcb(156, 174, {
    20: 1,
    28: 1,
    14: 1,
    174: 1,
    156: 1,
    21: 1
}, $61de1ee1cac498ae$var$xqb);
$61de1ee1cac498ae$var$_.Fc = function yqb(a) {
    return $61de1ee1cac498ae$var$rqb(this, $61de1ee1cac498ae$var$BD(a, 22));
};
$61de1ee1cac498ae$var$_.Hc = function zqb(a) {
    return $61de1ee1cac498ae$var$tqb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function Aqb() {
    return new $61de1ee1cac498ae$var$Gqb(this);
};
$61de1ee1cac498ae$var$_.Mc = function Bqb(a) {
    return $61de1ee1cac498ae$var$vqb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function Cqb() {
    return this.c;
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$gK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EnumSet/EnumSetImpl", 156);
$61de1ee1cac498ae$var$bcb(343, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Gqb);
$61de1ee1cac498ae$var$_.Nb = function Hqb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function Jqb() {
    return $61de1ee1cac498ae$var$Fqb(this);
};
$61de1ee1cac498ae$var$_.Ob = function Iqb() {
    return $61de1ee1cac498ae$var$Eqb(this);
};
$61de1ee1cac498ae$var$_.Qb = function Kqb() {
    $61de1ee1cac498ae$var$yCb(this.b != -1);
    $61de1ee1cac498ae$var$NC(this.c.b, this.b, null);
    --this.c.c;
    this.b = -1;
};
$61de1ee1cac498ae$var$_.a = -1;
$61de1ee1cac498ae$var$_.b = -1;
var $61de1ee1cac498ae$var$fK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "EnumSet/EnumSetImpl/IteratorImpl", 343);
$61de1ee1cac498ae$var$bcb(43, 488, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$Lqb, $61de1ee1cac498ae$var$Mqb, $61de1ee1cac498ae$var$Nqb);
$61de1ee1cac498ae$var$_.re = function Oqb(a, b) {
    return $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(b) || a != null && $61de1ee1cac498ae$var$pb(a, b);
};
$61de1ee1cac498ae$var$_.se = function Pqb(a) {
    var b;
    b = $61de1ee1cac498ae$var$tb(a);
    return b | 0;
};
var $61de1ee1cac498ae$var$iK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "HashMap", 43);
$61de1ee1cac498ae$var$bcb(53, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$gke, $61de1ee1cac498ae$var$Tqb, $61de1ee1cac498ae$var$Uqb, $61de1ee1cac498ae$var$Vqb);
$61de1ee1cac498ae$var$_.Fc = function Xqb(a) {
    return $61de1ee1cac498ae$var$Qqb(this, a);
};
$61de1ee1cac498ae$var$_.$b = function Yqb() {
    this.a.$b();
};
$61de1ee1cac498ae$var$_.Hc = function Zqb(a) {
    return $61de1ee1cac498ae$var$Rqb(this, a);
};
$61de1ee1cac498ae$var$_.dc = function $qb() {
    return this.a.gc() == 0;
};
$61de1ee1cac498ae$var$_.Kc = function _qb() {
    return this.a.ec().Kc();
};
$61de1ee1cac498ae$var$_.Mc = function arb(a) {
    return $61de1ee1cac498ae$var$Sqb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function brb() {
    return this.a.gc();
};
var $61de1ee1cac498ae$var$jK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "HashSet", 53);
$61de1ee1cac498ae$var$bcb(1781, 1, $61de1ee1cac498ae$var$sie, $61de1ee1cac498ae$var$drb);
$61de1ee1cac498ae$var$_.ud = function erb(a) {
    $61de1ee1cac498ae$var$crb(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function frb() {
    return "IntSummaryStatistics[count = " + $61de1ee1cac498ae$var$Ubb(this.a) + ", avg = " + ($61de1ee1cac498ae$var$Dbb(this.a, 0) ? $61de1ee1cac498ae$var$Sbb(this.d) / $61de1ee1cac498ae$var$Sbb(this.a) : 0) + ", min = " + this.c + ", max = " + this.b + ", sum = " + $61de1ee1cac498ae$var$Ubb(this.d) + "]";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = $61de1ee1cac498ae$var$Rie;
$61de1ee1cac498ae$var$_.c = $61de1ee1cac498ae$var$Ohe;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$kK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "IntSummaryStatistics", 1781);
$61de1ee1cac498ae$var$bcb(1049, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$lrb);
$61de1ee1cac498ae$var$_.Jc = function mrb(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function nrb() {
    return new $61de1ee1cac498ae$var$orb(this);
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$mK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "InternalHashCodeMap", 1049);
$61de1ee1cac498ae$var$bcb(711, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$orb);
$61de1ee1cac498ae$var$_.Nb = function prb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function rrb() {
    return this.d = this.a[this.c++], this.d;
};
$61de1ee1cac498ae$var$_.Ob = function qrb() {
    var a;
    if (this.c < this.a.length) return true;
    a = this.b.next();
    if (!a.done) {
        this.a = a.value[1];
        this.c = 0;
        return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Qb = function srb() {
    $61de1ee1cac498ae$var$krb(this.e, this.d.cd());
    this.c != 0 && --this.c;
};
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = null;
var $61de1ee1cac498ae$var$lK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "InternalHashCodeMap/1", 711);
var $61de1ee1cac498ae$var$vrb;
$61de1ee1cac498ae$var$bcb(1047, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$Frb);
$61de1ee1cac498ae$var$_.Jc = function Grb(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function Hrb() {
    return new $61de1ee1cac498ae$var$Irb(this);
};
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$pK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "InternalStringMap", 1047);
$61de1ee1cac498ae$var$bcb(710, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Irb);
$61de1ee1cac498ae$var$_.Nb = function Jrb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function Lrb() {
    return this.c = this.a, this.a = this.b.next(), new $61de1ee1cac498ae$var$Nrb(this.d, this.c, this.d.d);
};
$61de1ee1cac498ae$var$_.Ob = function Krb() {
    return !this.a.done;
};
$61de1ee1cac498ae$var$_.Qb = function Mrb() {
    $61de1ee1cac498ae$var$Erb(this.d, this.c.value[0]);
};
var $61de1ee1cac498ae$var$nK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "InternalStringMap/1", 710);
$61de1ee1cac498ae$var$bcb(1048, 1984, $61de1ee1cac498ae$var$_je, $61de1ee1cac498ae$var$Nrb);
$61de1ee1cac498ae$var$_.cd = function Orb() {
    return this.b.value[0];
};
$61de1ee1cac498ae$var$_.dd = function Prb() {
    if (this.a.d != this.c) return $61de1ee1cac498ae$var$Crb(this.a, this.b.value[0]);
    return this.b.value[1];
};
$61de1ee1cac498ae$var$_.ed = function Qrb(a) {
    return $61de1ee1cac498ae$var$Drb(this.a, this.b.value[0], a);
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$oK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "InternalStringMap/2", 1048);
$61de1ee1cac498ae$var$bcb(228, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$$rb, $61de1ee1cac498ae$var$_rb);
$61de1ee1cac498ae$var$_.$b = function asb() {
    $61de1ee1cac498ae$var$Urb(this);
};
$61de1ee1cac498ae$var$_._b = function bsb(a) {
    return $61de1ee1cac498ae$var$Vrb(this, a);
};
$61de1ee1cac498ae$var$_.uc = function csb(a) {
    var b;
    b = this.d.a;
    while(b != this.d){
        if ($61de1ee1cac498ae$var$wtb(b.e, a)) return true;
        b = b.a;
    }
    return false;
};
$61de1ee1cac498ae$var$_.vc = function dsb() {
    return new $61de1ee1cac498ae$var$nsb(this);
};
$61de1ee1cac498ae$var$_.xc = function esb(a) {
    return $61de1ee1cac498ae$var$Wrb(this, a);
};
$61de1ee1cac498ae$var$_.zc = function fsb(a, b) {
    return $61de1ee1cac498ae$var$Xrb(this, a, b);
};
$61de1ee1cac498ae$var$_.Bc = function gsb(a) {
    return $61de1ee1cac498ae$var$Zrb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function hsb() {
    return $61de1ee1cac498ae$var$Vhb(this.e);
};
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$tK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedHashMap", 228);
$61de1ee1cac498ae$var$bcb(387, 383, {
    484: 1,
    383: 1,
    387: 1,
    42: 1
}, $61de1ee1cac498ae$var$ksb, $61de1ee1cac498ae$var$lsb);
var $61de1ee1cac498ae$var$qK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedHashMap/ChainEntry", 387);
$61de1ee1cac498ae$var$bcb(701, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$nsb);
$61de1ee1cac498ae$var$_.$b = function osb() {
    $61de1ee1cac498ae$var$Urb(this.a);
};
$61de1ee1cac498ae$var$_.Hc = function psb(a) {
    return $61de1ee1cac498ae$var$msb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function qsb() {
    return new $61de1ee1cac498ae$var$usb(this);
};
$61de1ee1cac498ae$var$_.Mc = function rsb(a) {
    var b;
    if ($61de1ee1cac498ae$var$msb(this, a)) {
        b = $61de1ee1cac498ae$var$BD(a, 42).cd();
        $61de1ee1cac498ae$var$Zrb(this.a, b);
        return true;
    }
    return false;
};
$61de1ee1cac498ae$var$_.gc = function ssb() {
    return $61de1ee1cac498ae$var$Vhb(this.a.e);
};
var $61de1ee1cac498ae$var$sK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedHashMap/EntrySet", 701);
$61de1ee1cac498ae$var$bcb(702, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$usb);
$61de1ee1cac498ae$var$_.Nb = function vsb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function xsb() {
    return $61de1ee1cac498ae$var$tsb(this);
};
$61de1ee1cac498ae$var$_.Ob = function wsb() {
    return this.b != this.c.a.d;
};
$61de1ee1cac498ae$var$_.Qb = function ysb() {
    $61de1ee1cac498ae$var$yCb(!!this.a);
    $61de1ee1cac498ae$var$xpb(this.c.a.e, this);
    $61de1ee1cac498ae$var$jsb(this.a);
    $61de1ee1cac498ae$var$Thb(this.c.a.e, this.a.d);
    $61de1ee1cac498ae$var$ypb(this.c.a.e, this);
    this.a = null;
};
var $61de1ee1cac498ae$var$rK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedHashMap/EntrySet/EntryIterator", 702);
$61de1ee1cac498ae$var$bcb(178, 53, $61de1ee1cac498ae$var$gke, $61de1ee1cac498ae$var$zsb, $61de1ee1cac498ae$var$Asb, $61de1ee1cac498ae$var$Bsb);
var $61de1ee1cac498ae$var$uK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedHashSet", 178);
$61de1ee1cac498ae$var$bcb(68, 1964, {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    68: 1,
    15: 1
}, $61de1ee1cac498ae$var$Psb, $61de1ee1cac498ae$var$Qsb);
$61de1ee1cac498ae$var$_.Fc = function Rsb(a) {
    return $61de1ee1cac498ae$var$Dsb(this, a);
};
$61de1ee1cac498ae$var$_.$b = function Ssb() {
    $61de1ee1cac498ae$var$Osb(this);
};
$61de1ee1cac498ae$var$_.Zc = function Tsb(a) {
    return $61de1ee1cac498ae$var$Jsb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function Usb() {
    return this.b;
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$xK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedList", 68);
$61de1ee1cac498ae$var$bcb(970, 1, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$$sb);
$61de1ee1cac498ae$var$_.Nb = function atb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Rb = function _sb(a) {
    $61de1ee1cac498ae$var$Vsb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function btb() {
    return $61de1ee1cac498ae$var$Wsb(this);
};
$61de1ee1cac498ae$var$_.Sb = function ctb() {
    return this.b.b != this.d.a;
};
$61de1ee1cac498ae$var$_.Pb = function dtb() {
    return $61de1ee1cac498ae$var$Xsb(this);
};
$61de1ee1cac498ae$var$_.Tb = function etb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Ub = function ftb() {
    return $61de1ee1cac498ae$var$Ysb(this);
};
$61de1ee1cac498ae$var$_.Vb = function gtb() {
    return this.a - 1;
};
$61de1ee1cac498ae$var$_.Qb = function htb() {
    $61de1ee1cac498ae$var$Zsb(this);
};
$61de1ee1cac498ae$var$_.Wb = function itb(a) {
    $61de1ee1cac498ae$var$yCb(!!this.c);
    this.c.c = a;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = null;
var $61de1ee1cac498ae$var$vK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedList/ListIteratorImpl", 970);
$61de1ee1cac498ae$var$bcb(608, 1, {}, $61de1ee1cac498ae$var$jtb);
var $61de1ee1cac498ae$var$wK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "LinkedList/Node", 608);
$61de1ee1cac498ae$var$bcb(1959, 1, {});
var $61de1ee1cac498ae$var$ltb, $61de1ee1cac498ae$var$mtb;
var $61de1ee1cac498ae$var$BK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Locale", 1959);
$61de1ee1cac498ae$var$bcb(861, 1959, {}, $61de1ee1cac498ae$var$otb);
$61de1ee1cac498ae$var$_.Ib = function ptb() {
    return "";
};
var $61de1ee1cac498ae$var$zK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Locale/1", 861);
$61de1ee1cac498ae$var$bcb(862, 1959, {}, $61de1ee1cac498ae$var$qtb);
$61de1ee1cac498ae$var$_.Ib = function rtb() {
    return "unknown";
};
var $61de1ee1cac498ae$var$AK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Locale/4", 862);
$61de1ee1cac498ae$var$bcb(109, 60, {
    3: 1,
    102: 1,
    60: 1,
    78: 1,
    109: 1
}, $61de1ee1cac498ae$var$utb, $61de1ee1cac498ae$var$vtb);
var $61de1ee1cac498ae$var$EK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "NoSuchElementException", 109);
$61de1ee1cac498ae$var$bcb(404, 1, {
    404: 1
}, $61de1ee1cac498ae$var$Ftb);
$61de1ee1cac498ae$var$_.Fb = function Gtb(a) {
    var b;
    if (a === this) return true;
    if (!$61de1ee1cac498ae$var$JD(a, 404)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 404);
    return $61de1ee1cac498ae$var$wtb(this.a, b.a);
};
$61de1ee1cac498ae$var$_.Hb = function Htb() {
    return $61de1ee1cac498ae$var$xtb(this.a);
};
$61de1ee1cac498ae$var$_.Ib = function Jtb() {
    return this.a != null ? $61de1ee1cac498ae$var$Whe + $61de1ee1cac498ae$var$xfb(this.a) + ")" : "Optional.empty()";
};
var $61de1ee1cac498ae$var$ztb;
var $61de1ee1cac498ae$var$HK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Optional", 404);
$61de1ee1cac498ae$var$bcb(463, 1, {
    463: 1
}, $61de1ee1cac498ae$var$Otb, $61de1ee1cac498ae$var$Ptb);
$61de1ee1cac498ae$var$_.Fb = function Qtb(a) {
    var b;
    if (a === this) return true;
    if (!$61de1ee1cac498ae$var$JD(a, 463)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 463);
    return this.a == b.a && $61de1ee1cac498ae$var$Kdb(this.b, b.b) == 0;
};
$61de1ee1cac498ae$var$_.Hb = function Rtb() {
    return this.a ? $61de1ee1cac498ae$var$QD(this.b) : 0;
};
$61de1ee1cac498ae$var$_.Ib = function Stb() {
    return this.a ? "OptionalDouble.of(" + ("" + this.b) + ")" : "OptionalDouble.empty()";
};
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$Ktb;
var $61de1ee1cac498ae$var$FK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "OptionalDouble", 463);
$61de1ee1cac498ae$var$bcb(517, 1, {
    517: 1
}, $61de1ee1cac498ae$var$Wtb, $61de1ee1cac498ae$var$Xtb);
$61de1ee1cac498ae$var$_.Fb = function Ytb(a) {
    var b;
    if (a === this) return true;
    if (!$61de1ee1cac498ae$var$JD(a, 517)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 517);
    return this.a == b.a && $61de1ee1cac498ae$var$beb(this.b, b.b) == 0;
};
$61de1ee1cac498ae$var$_.Hb = function Ztb() {
    return this.a ? this.b : 0;
};
$61de1ee1cac498ae$var$_.Ib = function $tb() {
    return this.a ? "OptionalInt.of(" + ("" + this.b) + ")" : "OptionalInt.empty()";
};
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$Ttb;
var $61de1ee1cac498ae$var$GK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "OptionalInt", 517);
$61de1ee1cac498ae$var$bcb(503, 2004, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$gub);
$61de1ee1cac498ae$var$_.Gc = function hub(a) {
    return $61de1ee1cac498ae$var$_tb(this, a);
};
$61de1ee1cac498ae$var$_.$b = function iub() {
    this.b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
};
$61de1ee1cac498ae$var$_.Hc = function jub(a) {
    return (a == null ? -1 : $61de1ee1cac498ae$var$Jkb(this.b, a, 0)) != -1;
};
$61de1ee1cac498ae$var$_.Kc = function kub() {
    return new $61de1ee1cac498ae$var$qub(this);
};
$61de1ee1cac498ae$var$_.Mc = function lub(a) {
    return $61de1ee1cac498ae$var$eub(this, a);
};
$61de1ee1cac498ae$var$_.gc = function mub() {
    return this.b.c.length;
};
$61de1ee1cac498ae$var$_.Nc = function nub() {
    return new $61de1ee1cac498ae$var$Kub(this, 256);
};
$61de1ee1cac498ae$var$_.Pc = function oub() {
    return $61de1ee1cac498ae$var$Pkb(this.b);
};
$61de1ee1cac498ae$var$_.Qc = function pub(a) {
    return $61de1ee1cac498ae$var$Qkb(this.b, a);
};
var $61de1ee1cac498ae$var$JK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "PriorityQueue", 503);
$61de1ee1cac498ae$var$bcb(1277, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$qub);
$61de1ee1cac498ae$var$_.Nb = function rub(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function tub() {
    return this.a < this.c.b.c.length;
};
$61de1ee1cac498ae$var$_.Pb = function uub() {
    $61de1ee1cac498ae$var$sCb(this.a < this.c.b.c.length);
    this.b = this.a++;
    return $61de1ee1cac498ae$var$Ikb(this.c.b, this.b);
};
$61de1ee1cac498ae$var$_.Qb = function vub() {
    $61de1ee1cac498ae$var$yCb(this.b != -1);
    $61de1ee1cac498ae$var$fub(this.c, this.a = this.b);
    this.b = -1;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = -1;
var $61de1ee1cac498ae$var$IK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "PriorityQueue/1", 1277);
$61de1ee1cac498ae$var$bcb(230, 1, {
    230: 1
}, $61de1ee1cac498ae$var$Gub, $61de1ee1cac498ae$var$Hub);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$wub, $61de1ee1cac498ae$var$xub, $61de1ee1cac498ae$var$yub = 0;
var $61de1ee1cac498ae$var$KK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Random", 230);
$61de1ee1cac498ae$var$bcb(27, 1, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$Kub, $61de1ee1cac498ae$var$Lub, $61de1ee1cac498ae$var$Mub);
$61de1ee1cac498ae$var$_.qd = function Nub() {
    return this.a;
};
$61de1ee1cac498ae$var$_.rd = function Oub() {
    $61de1ee1cac498ae$var$Iub(this);
    return this.c;
};
$61de1ee1cac498ae$var$_.Nb = function Pub(a) {
    $61de1ee1cac498ae$var$Iub(this);
    this.d.Nb(a);
};
$61de1ee1cac498ae$var$_.sd = function Qub(a) {
    return $61de1ee1cac498ae$var$Jub(this, a);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$$K = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/IteratorSpliterator", 27);
$61de1ee1cac498ae$var$bcb(485, 27, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$Rub);
var $61de1ee1cac498ae$var$MK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "SortedSet/1", 485);
$61de1ee1cac498ae$var$bcb(602, 1, $61de1ee1cac498ae$var$eke, $61de1ee1cac498ae$var$Tub);
$61de1ee1cac498ae$var$_.we = function Uub(a) {
    this.a.td(a);
};
var $61de1ee1cac498ae$var$NK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterator/OfDouble/0methodref$accept$Type", 602);
$61de1ee1cac498ae$var$bcb(603, 1, $61de1ee1cac498ae$var$eke, $61de1ee1cac498ae$var$Vub);
$61de1ee1cac498ae$var$_.we = function Wub(a) {
    this.a.td(a);
};
var $61de1ee1cac498ae$var$OK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterator/OfDouble/1methodref$accept$Type", 603);
$61de1ee1cac498ae$var$bcb(604, 1, $61de1ee1cac498ae$var$sie, $61de1ee1cac498ae$var$Xub);
$61de1ee1cac498ae$var$_.ud = function Yub(a) {
    this.a.td($61de1ee1cac498ae$var$meb(a));
};
var $61de1ee1cac498ae$var$PK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterator/OfInt/2methodref$accept$Type", 604);
$61de1ee1cac498ae$var$bcb(605, 1, $61de1ee1cac498ae$var$sie, $61de1ee1cac498ae$var$Zub);
$61de1ee1cac498ae$var$_.ud = function $ub(a) {
    this.a.td($61de1ee1cac498ae$var$meb(a));
};
var $61de1ee1cac498ae$var$QK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterator/OfInt/3methodref$accept$Type", 605);
$61de1ee1cac498ae$var$bcb(617, 1, $61de1ee1cac498ae$var$pie);
$61de1ee1cac498ae$var$_.Nb = function evb(a) {
    $61de1ee1cac498ae$var$Sub(this, a);
};
$61de1ee1cac498ae$var$_.qd = function cvb() {
    return this.d;
};
$61de1ee1cac498ae$var$_.rd = function dvb() {
    return this.e;
};
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$WK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/BaseSpliterator", 617);
$61de1ee1cac498ae$var$bcb(721, 617, $61de1ee1cac498ae$var$pie);
$61de1ee1cac498ae$var$_.xe = function gvb(a) {
    $61de1ee1cac498ae$var$_ub(this, a);
};
$61de1ee1cac498ae$var$_.Nb = function hvb(a) {
    $61de1ee1cac498ae$var$JD(a, 182) ? $61de1ee1cac498ae$var$_ub(this, $61de1ee1cac498ae$var$BD(a, 182)) : $61de1ee1cac498ae$var$_ub(this, new $61de1ee1cac498ae$var$Vub(a));
};
$61de1ee1cac498ae$var$_.sd = function ivb(a) {
    return $61de1ee1cac498ae$var$JD(a, 182) ? this.ye($61de1ee1cac498ae$var$BD(a, 182)) : this.ye(new $61de1ee1cac498ae$var$Tub(a));
};
var $61de1ee1cac498ae$var$RK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/AbstractDoubleSpliterator", 721);
$61de1ee1cac498ae$var$bcb(720, 617, $61de1ee1cac498ae$var$pie);
$61de1ee1cac498ae$var$_.xe = function kvb(a) {
    $61de1ee1cac498ae$var$_ub(this, a);
};
$61de1ee1cac498ae$var$_.Nb = function lvb(a) {
    $61de1ee1cac498ae$var$JD(a, 196) ? $61de1ee1cac498ae$var$_ub(this, $61de1ee1cac498ae$var$BD(a, 196)) : $61de1ee1cac498ae$var$_ub(this, new $61de1ee1cac498ae$var$Zub(a));
};
$61de1ee1cac498ae$var$_.sd = function mvb(a) {
    return $61de1ee1cac498ae$var$JD(a, 196) ? this.ye($61de1ee1cac498ae$var$BD(a, 196)) : this.ye(new $61de1ee1cac498ae$var$Xub(a));
};
var $61de1ee1cac498ae$var$SK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/AbstractIntSpliterator", 720);
$61de1ee1cac498ae$var$bcb(540, 617, $61de1ee1cac498ae$var$pie);
var $61de1ee1cac498ae$var$TK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/AbstractSpliterator", 540);
$61de1ee1cac498ae$var$bcb(692, 1, $61de1ee1cac498ae$var$pie);
$61de1ee1cac498ae$var$_.Nb = function tvb(a) {
    $61de1ee1cac498ae$var$Sub(this, a);
};
$61de1ee1cac498ae$var$_.qd = function rvb() {
    return this.b;
};
$61de1ee1cac498ae$var$_.rd = function svb() {
    return this.d - this.c;
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$VK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/BaseArraySpliterator", 692);
$61de1ee1cac498ae$var$bcb(947, 692, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$vvb);
$61de1ee1cac498ae$var$_.ze = function wvb(a, b) {
    $61de1ee1cac498ae$var$uvb(this, $61de1ee1cac498ae$var$BD(a, 38), b);
};
$61de1ee1cac498ae$var$_.Nb = function xvb(a) {
    $61de1ee1cac498ae$var$ovb(this, a);
};
$61de1ee1cac498ae$var$_.sd = function yvb(a) {
    return $61de1ee1cac498ae$var$pvb(this, a);
};
var $61de1ee1cac498ae$var$UK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/ArraySpliterator", 947);
$61de1ee1cac498ae$var$bcb(693, 692, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$Avb);
$61de1ee1cac498ae$var$_.ze = function Cvb(a, b) {
    $61de1ee1cac498ae$var$zvb(this, $61de1ee1cac498ae$var$BD(a, 182), b);
};
$61de1ee1cac498ae$var$_.xe = function Dvb(a) {
    $61de1ee1cac498ae$var$ovb(this, a);
};
$61de1ee1cac498ae$var$_.Nb = function Evb(a) {
    $61de1ee1cac498ae$var$JD(a, 182) ? $61de1ee1cac498ae$var$ovb(this, $61de1ee1cac498ae$var$BD(a, 182)) : $61de1ee1cac498ae$var$ovb(this, new $61de1ee1cac498ae$var$Vub(a));
};
$61de1ee1cac498ae$var$_.ye = function Fvb(a) {
    return $61de1ee1cac498ae$var$pvb(this, a);
};
$61de1ee1cac498ae$var$_.sd = function Gvb(a) {
    return $61de1ee1cac498ae$var$JD(a, 182) ? $61de1ee1cac498ae$var$pvb(this, $61de1ee1cac498ae$var$BD(a, 182)) : $61de1ee1cac498ae$var$pvb(this, new $61de1ee1cac498ae$var$Tub(a));
};
var $61de1ee1cac498ae$var$XK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/DoubleArraySpliterator", 693);
$61de1ee1cac498ae$var$bcb(1968, 1, $61de1ee1cac498ae$var$pie);
$61de1ee1cac498ae$var$_.Nb = function Lvb(a) {
    $61de1ee1cac498ae$var$Sub(this, a);
};
$61de1ee1cac498ae$var$_.qd = function Jvb() {
    return 16448;
};
$61de1ee1cac498ae$var$_.rd = function Kvb() {
    return 0;
};
var $61de1ee1cac498ae$var$Hvb;
var $61de1ee1cac498ae$var$ZK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/EmptySpliterator", 1968);
$61de1ee1cac498ae$var$bcb(946, 1968, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$Ovb);
$61de1ee1cac498ae$var$_.xe = function Pvb(a) {
    $61de1ee1cac498ae$var$Mvb(a);
};
$61de1ee1cac498ae$var$_.Nb = function Qvb(a) {
    $61de1ee1cac498ae$var$JD(a, 196) ? $61de1ee1cac498ae$var$Mvb($61de1ee1cac498ae$var$BD(a, 196)) : $61de1ee1cac498ae$var$Mvb(new $61de1ee1cac498ae$var$Zub(a));
};
$61de1ee1cac498ae$var$_.ye = function Rvb(a) {
    return $61de1ee1cac498ae$var$Nvb(a);
};
$61de1ee1cac498ae$var$_.sd = function Svb(a) {
    return $61de1ee1cac498ae$var$JD(a, 196) ? $61de1ee1cac498ae$var$Nvb($61de1ee1cac498ae$var$BD(a, 196)) : $61de1ee1cac498ae$var$Nvb(new $61de1ee1cac498ae$var$Xub(a));
};
var $61de1ee1cac498ae$var$YK = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Spliterators/EmptySpliterator/OfInt", 946);
$61de1ee1cac498ae$var$bcb(580, 52, $61de1ee1cac498ae$var$pke, $61de1ee1cac498ae$var$Wvb);
$61de1ee1cac498ae$var$_.Vc = function Xvb(a, b) {
    $61de1ee1cac498ae$var$_vb(a, this.a.c.length + 1);
    $61de1ee1cac498ae$var$Dkb(this.a, a, b);
};
$61de1ee1cac498ae$var$_.Fc = function Yvb(a) {
    return $61de1ee1cac498ae$var$Ekb(this.a, a);
};
$61de1ee1cac498ae$var$_.Wc = function Zvb(a, b) {
    $61de1ee1cac498ae$var$_vb(a, this.a.c.length + 1);
    return $61de1ee1cac498ae$var$Fkb(this.a, a, b);
};
$61de1ee1cac498ae$var$_.Gc = function $vb(a) {
    return $61de1ee1cac498ae$var$Gkb(this.a, a);
};
$61de1ee1cac498ae$var$_.$b = function awb() {
    this.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
};
$61de1ee1cac498ae$var$_.Hc = function bwb(a) {
    return $61de1ee1cac498ae$var$Jkb(this.a, a, 0) != -1;
};
$61de1ee1cac498ae$var$_.Ic = function cwb(a) {
    return $61de1ee1cac498ae$var$Be(this.a, a);
};
$61de1ee1cac498ae$var$_.Jc = function dwb(a) {
    $61de1ee1cac498ae$var$Hkb(this.a, a);
};
$61de1ee1cac498ae$var$_.Xb = function ewb(a) {
    return $61de1ee1cac498ae$var$_vb(a, this.a.c.length), $61de1ee1cac498ae$var$Ikb(this.a, a);
};
$61de1ee1cac498ae$var$_.Xc = function fwb(a) {
    return $61de1ee1cac498ae$var$Jkb(this.a, a, 0);
};
$61de1ee1cac498ae$var$_.dc = function gwb() {
    return this.a.c.length == 0;
};
$61de1ee1cac498ae$var$_.Kc = function hwb() {
    return new $61de1ee1cac498ae$var$olb(this.a);
};
$61de1ee1cac498ae$var$_.$c = function iwb(a) {
    return $61de1ee1cac498ae$var$_vb(a, this.a.c.length), $61de1ee1cac498ae$var$Kkb(this.a, a);
};
$61de1ee1cac498ae$var$_.Ud = function jwb(a, b) {
    $61de1ee1cac498ae$var$Mkb(this.a, a, b);
};
$61de1ee1cac498ae$var$_._c = function kwb(a, b) {
    return $61de1ee1cac498ae$var$_vb(a, this.a.c.length), $61de1ee1cac498ae$var$Nkb(this.a, a, b);
};
$61de1ee1cac498ae$var$_.gc = function lwb() {
    return this.a.c.length;
};
$61de1ee1cac498ae$var$_.ad = function mwb(a) {
    $61de1ee1cac498ae$var$Okb(this.a, a);
};
$61de1ee1cac498ae$var$_.bd = function nwb(a, b) {
    return new $61de1ee1cac498ae$var$Jib(this.a, a, b);
};
$61de1ee1cac498ae$var$_.Pc = function owb() {
    return $61de1ee1cac498ae$var$Pkb(this.a);
};
$61de1ee1cac498ae$var$_.Qc = function pwb(a) {
    return $61de1ee1cac498ae$var$Qkb(this.a, a);
};
$61de1ee1cac498ae$var$_.Ib = function qwb() {
    return $61de1ee1cac498ae$var$Fe(this.a);
};
var $61de1ee1cac498ae$var$lL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Vector", 580);
$61de1ee1cac498ae$var$bcb(809, 580, $61de1ee1cac498ae$var$pke, $61de1ee1cac498ae$var$twb);
var $61de1ee1cac498ae$var$_K = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "Stack", 809);
$61de1ee1cac498ae$var$bcb(206, 1, {
    206: 1
}, $61de1ee1cac498ae$var$xwb);
$61de1ee1cac498ae$var$_.Ib = function ywb() {
    return $61de1ee1cac498ae$var$wwb(this);
};
var $61de1ee1cac498ae$var$aL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "StringJoiner", 206);
$61de1ee1cac498ae$var$bcb(544, 1992, {
    3: 1,
    83: 1,
    171: 1,
    161: 1
}, $61de1ee1cac498ae$var$Pwb, $61de1ee1cac498ae$var$Qwb);
$61de1ee1cac498ae$var$_.$b = function Rwb() {
    $61de1ee1cac498ae$var$zwb(this);
};
$61de1ee1cac498ae$var$_.vc = function Swb() {
    return new $61de1ee1cac498ae$var$cxb(this);
};
$61de1ee1cac498ae$var$_.zc = function Twb(a, b) {
    return $61de1ee1cac498ae$var$Iwb(this, a, b);
};
$61de1ee1cac498ae$var$_.Bc = function Uwb(a) {
    return $61de1ee1cac498ae$var$Jwb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function Vwb() {
    return this.c;
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$jL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "TreeMap", 544);
$61de1ee1cac498ae$var$bcb(390, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Ywb);
$61de1ee1cac498ae$var$_.Nb = function $wb(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function axb() {
    return $61de1ee1cac498ae$var$Wwb(this);
};
$61de1ee1cac498ae$var$_.Ob = function _wb() {
    return $61de1ee1cac498ae$var$sib(this.a);
};
$61de1ee1cac498ae$var$_.Qb = function bxb() {
    $61de1ee1cac498ae$var$Xwb(this);
};
var $61de1ee1cac498ae$var$bL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "TreeMap/EntryIterator", 390);
$61de1ee1cac498ae$var$bcb(435, 739, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$cxb);
$61de1ee1cac498ae$var$_.$b = function dxb() {
    $61de1ee1cac498ae$var$zwb(this.a);
};
var $61de1ee1cac498ae$var$cL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "TreeMap/EntrySet", 435);
$61de1ee1cac498ae$var$bcb(436, 383, {
    484: 1,
    383: 1,
    42: 1,
    436: 1
}, $61de1ee1cac498ae$var$exb);
$61de1ee1cac498ae$var$_.b = false;
var $61de1ee1cac498ae$var$dL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "TreeMap/Node", 436);
$61de1ee1cac498ae$var$bcb(621, 1, {}, $61de1ee1cac498ae$var$fxb);
$61de1ee1cac498ae$var$_.Ib = function gxb() {
    return "State: mv=" + this.c + " value=" + this.d + " done=" + this.a + " found=" + this.b;
};
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$eL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "TreeMap/State", 621);
$61de1ee1cac498ae$var$bcb(297, 22, $61de1ee1cac498ae$var$qke, $61de1ee1cac498ae$var$mxb);
$61de1ee1cac498ae$var$_.Ae = function nxb() {
    return false;
};
$61de1ee1cac498ae$var$_.Be = function oxb() {
    return false;
};
var $61de1ee1cac498ae$var$hxb, $61de1ee1cac498ae$var$ixb, $61de1ee1cac498ae$var$jxb, $61de1ee1cac498ae$var$kxb;
var $61de1ee1cac498ae$var$iL = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$bie, "TreeMap/SubMapType", 297, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$qxb, $61de1ee1cac498ae$var$pxb);
$61de1ee1cac498ae$var$bcb(1112, 297, $61de1ee1cac498ae$var$qke, $61de1ee1cac498ae$var$rxb);
$61de1ee1cac498ae$var$_.Be = function sxb() {
    return true;
};
var $61de1ee1cac498ae$var$fL = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$bie, "TreeMap/SubMapType/1", 1112, $61de1ee1cac498ae$var$iL, null, null);
$61de1ee1cac498ae$var$bcb(1113, 297, $61de1ee1cac498ae$var$qke, $61de1ee1cac498ae$var$txb);
$61de1ee1cac498ae$var$_.Ae = function uxb() {
    return true;
};
$61de1ee1cac498ae$var$_.Be = function vxb() {
    return true;
};
var $61de1ee1cac498ae$var$gL = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$bie, "TreeMap/SubMapType/2", 1113, $61de1ee1cac498ae$var$iL, null, null);
$61de1ee1cac498ae$var$bcb(1114, 297, $61de1ee1cac498ae$var$qke, $61de1ee1cac498ae$var$wxb);
$61de1ee1cac498ae$var$_.Ae = function xxb() {
    return true;
};
var $61de1ee1cac498ae$var$hL = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$bie, "TreeMap/SubMapType/3", 1114, $61de1ee1cac498ae$var$iL, null, null);
var $61de1ee1cac498ae$var$yxb;
$61de1ee1cac498ae$var$bcb(208, $61de1ee1cac498ae$var$eie, {
    3: 1,
    20: 1,
    28: 1,
    14: 1,
    271: 1,
    21: 1,
    84: 1,
    208: 1
}, $61de1ee1cac498ae$var$Gxb, $61de1ee1cac498ae$var$Hxb);
$61de1ee1cac498ae$var$_.Nc = function Oxb() {
    return new $61de1ee1cac498ae$var$Rub(this);
};
$61de1ee1cac498ae$var$_.Fc = function Ixb(a) {
    return $61de1ee1cac498ae$var$Axb(this, a);
};
$61de1ee1cac498ae$var$_.$b = function Jxb() {
    $61de1ee1cac498ae$var$zwb(this.a);
};
$61de1ee1cac498ae$var$_.Hc = function Kxb(a) {
    return $61de1ee1cac498ae$var$ujb(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function Lxb() {
    var a;
    return a = new $61de1ee1cac498ae$var$Ywb(new $61de1ee1cac498ae$var$cxb(new $61de1ee1cac498ae$var$Gjb(this.a).a).b), new $61de1ee1cac498ae$var$Njb(a);
};
$61de1ee1cac498ae$var$_.Mc = function Mxb(a) {
    return $61de1ee1cac498ae$var$Fxb(this, a);
};
$61de1ee1cac498ae$var$_.gc = function Nxb() {
    return this.a.c;
};
var $61de1ee1cac498ae$var$kL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bie, "TreeSet", 208);
$61de1ee1cac498ae$var$bcb(966, 1, {}, $61de1ee1cac498ae$var$Rxb);
$61de1ee1cac498ae$var$_.Ce = function Sxb(a, b) {
    return $61de1ee1cac498ae$var$Pxb(this.a, a, b);
};
var $61de1ee1cac498ae$var$mL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rke, "BinaryOperator/lambda$0$Type", 966);
$61de1ee1cac498ae$var$bcb(967, 1, {}, $61de1ee1cac498ae$var$Txb);
$61de1ee1cac498ae$var$_.Ce = function Uxb(a, b) {
    return $61de1ee1cac498ae$var$Qxb(this.a, a, b);
};
var $61de1ee1cac498ae$var$nL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rke, "BinaryOperator/lambda$1$Type", 967);
$61de1ee1cac498ae$var$bcb(846, 1, {}, $61de1ee1cac498ae$var$Vxb);
$61de1ee1cac498ae$var$_.Kb = function Wxb(a) {
    return a;
};
var $61de1ee1cac498ae$var$oL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rke, "Function/lambda$0$Type", 846);
$61de1ee1cac498ae$var$bcb(431, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Xxb);
$61de1ee1cac498ae$var$_.Mb = function Yxb(a) {
    return !this.a.Mb(a);
};
var $61de1ee1cac498ae$var$pL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rke, "Predicate/lambda$2$Type", 431);
$61de1ee1cac498ae$var$bcb(572, 1, {
    572: 1
});
var $61de1ee1cac498ae$var$qL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ske, "Handler", 572);
$61de1ee1cac498ae$var$bcb(2007, 1, $61de1ee1cac498ae$var$Qhe);
$61de1ee1cac498ae$var$_.ne = function _xb() {
    return "DUMMY";
};
$61de1ee1cac498ae$var$_.Ib = function ayb() {
    return this.ne();
};
var $61de1ee1cac498ae$var$Zxb;
var $61de1ee1cac498ae$var$sL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ske, "Level", 2007);
$61de1ee1cac498ae$var$bcb(1621, 2007, $61de1ee1cac498ae$var$Qhe, $61de1ee1cac498ae$var$byb);
$61de1ee1cac498ae$var$_.ne = function cyb() {
    return "INFO";
};
var $61de1ee1cac498ae$var$rL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ske, "Level/LevelInfo", 1621);
$61de1ee1cac498ae$var$bcb(1640, 1, {}, $61de1ee1cac498ae$var$gyb);
var $61de1ee1cac498ae$var$dyb;
var $61de1ee1cac498ae$var$tL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ske, "LogManager", 1640);
$61de1ee1cac498ae$var$bcb(1780, 1, $61de1ee1cac498ae$var$Qhe, $61de1ee1cac498ae$var$iyb);
$61de1ee1cac498ae$var$_.b = null;
var $61de1ee1cac498ae$var$uL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ske, "LogRecord", 1780);
$61de1ee1cac498ae$var$bcb(512, 1, {
    512: 1
}, $61de1ee1cac498ae$var$wyb);
$61de1ee1cac498ae$var$_.e = false;
var $61de1ee1cac498ae$var$jyb = false, $61de1ee1cac498ae$var$kyb = false, $61de1ee1cac498ae$var$lyb = false, $61de1ee1cac498ae$var$myb = false, $61de1ee1cac498ae$var$nyb = false;
var $61de1ee1cac498ae$var$vL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ske, "Logger", 512);
$61de1ee1cac498ae$var$bcb(819, 572, {
    572: 1
}, $61de1ee1cac498ae$var$zyb);
var $61de1ee1cac498ae$var$wL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ske, "SimpleConsoleLogHandler", 819);
$61de1ee1cac498ae$var$bcb(132, 22, {
    3: 1,
    35: 1,
    22: 1,
    132: 1
}, $61de1ee1cac498ae$var$Gyb);
var $61de1ee1cac498ae$var$Cyb, $61de1ee1cac498ae$var$Dyb, $61de1ee1cac498ae$var$Eyb;
var $61de1ee1cac498ae$var$xL = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$vke, "Collector/Characteristics", 132, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Iyb, $61de1ee1cac498ae$var$Hyb);
var $61de1ee1cac498ae$var$Jyb;
$61de1ee1cac498ae$var$bcb(744, 1, {}, $61de1ee1cac498ae$var$Lyb);
var $61de1ee1cac498ae$var$yL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "CollectorImpl", 744);
$61de1ee1cac498ae$var$bcb(1060, 1, {}, $61de1ee1cac498ae$var$Zyb);
$61de1ee1cac498ae$var$_.Ce = function $yb(a, b) {
    return $61de1ee1cac498ae$var$vwb($61de1ee1cac498ae$var$BD(a, 206), $61de1ee1cac498ae$var$BD(b, 206));
};
var $61de1ee1cac498ae$var$zL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/10methodref$merge$Type", 1060);
$61de1ee1cac498ae$var$bcb(1061, 1, {}, $61de1ee1cac498ae$var$_yb);
$61de1ee1cac498ae$var$_.Kb = function azb(a) {
    return $61de1ee1cac498ae$var$wwb($61de1ee1cac498ae$var$BD(a, 206));
};
var $61de1ee1cac498ae$var$AL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/11methodref$toString$Type", 1061);
$61de1ee1cac498ae$var$bcb(1062, 1, {}, $61de1ee1cac498ae$var$bzb);
$61de1ee1cac498ae$var$_.Kb = function czb(a) {
    return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$_Pb(a) ? true : false;
};
var $61de1ee1cac498ae$var$BL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/12methodref$test$Type", 1062);
$61de1ee1cac498ae$var$bcb(251, 1, {}, $61de1ee1cac498ae$var$dzb);
$61de1ee1cac498ae$var$_.Od = function ezb(a, b) {
    $61de1ee1cac498ae$var$BD(a, 14).Fc(b);
};
var $61de1ee1cac498ae$var$CL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/20methodref$add$Type", 251);
$61de1ee1cac498ae$var$bcb(253, 1, {}, $61de1ee1cac498ae$var$fzb);
$61de1ee1cac498ae$var$_.Ee = function gzb() {
    return new $61de1ee1cac498ae$var$Rkb;
};
var $61de1ee1cac498ae$var$DL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/21methodref$ctor$Type", 253);
$61de1ee1cac498ae$var$bcb(346, 1, {}, $61de1ee1cac498ae$var$hzb);
$61de1ee1cac498ae$var$_.Ee = function izb() {
    return new $61de1ee1cac498ae$var$Tqb;
};
var $61de1ee1cac498ae$var$EL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/23methodref$ctor$Type", 346);
$61de1ee1cac498ae$var$bcb(347, 1, {}, $61de1ee1cac498ae$var$jzb);
$61de1ee1cac498ae$var$_.Od = function kzb(a, b) {
    $61de1ee1cac498ae$var$Qqb($61de1ee1cac498ae$var$BD(a, 53), b);
};
var $61de1ee1cac498ae$var$FL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/24methodref$add$Type", 347);
$61de1ee1cac498ae$var$bcb(1055, 1, {}, $61de1ee1cac498ae$var$lzb);
$61de1ee1cac498ae$var$_.Ce = function mzb(a, b) {
    return $61de1ee1cac498ae$var$Myb($61de1ee1cac498ae$var$BD(a, 15), $61de1ee1cac498ae$var$BD(b, 14));
};
var $61de1ee1cac498ae$var$GL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/4methodref$addAll$Type", 1055);
$61de1ee1cac498ae$var$bcb(1059, 1, {}, $61de1ee1cac498ae$var$nzb);
$61de1ee1cac498ae$var$_.Od = function ozb(a, b) {
    $61de1ee1cac498ae$var$uwb($61de1ee1cac498ae$var$BD(a, 206), $61de1ee1cac498ae$var$BD(b, 475));
};
var $61de1ee1cac498ae$var$HL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/9methodref$add$Type", 1059);
$61de1ee1cac498ae$var$bcb(1058, 1, {}, $61de1ee1cac498ae$var$pzb);
$61de1ee1cac498ae$var$_.Ee = function qzb() {
    return new $61de1ee1cac498ae$var$xwb(this.a, this.b, this.c);
};
var $61de1ee1cac498ae$var$IL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$15$Type", 1058);
$61de1ee1cac498ae$var$bcb(1063, 1, {}, $61de1ee1cac498ae$var$rzb);
$61de1ee1cac498ae$var$_.Ee = function szb() {
    var a;
    return a = new $61de1ee1cac498ae$var$$rb, $61de1ee1cac498ae$var$Xrb(a, ($61de1ee1cac498ae$var$Bcb(), false), new $61de1ee1cac498ae$var$Rkb), $61de1ee1cac498ae$var$Xrb(a, true, new $61de1ee1cac498ae$var$Rkb), a;
};
var $61de1ee1cac498ae$var$JL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$22$Type", 1063);
$61de1ee1cac498ae$var$bcb(1064, 1, {}, $61de1ee1cac498ae$var$tzb);
$61de1ee1cac498ae$var$_.Ee = function uzb() {
    return $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        this.a
    ]);
};
var $61de1ee1cac498ae$var$KL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$25$Type", 1064);
$61de1ee1cac498ae$var$bcb(1065, 1, {}, $61de1ee1cac498ae$var$vzb);
$61de1ee1cac498ae$var$_.Od = function wzb(a, b) {
    $61de1ee1cac498ae$var$Oyb(this.a, $61de1ee1cac498ae$var$CD(a));
};
var $61de1ee1cac498ae$var$LL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$26$Type", 1065);
$61de1ee1cac498ae$var$bcb(1066, 1, {}, $61de1ee1cac498ae$var$xzb);
$61de1ee1cac498ae$var$_.Ce = function yzb(a, b) {
    return $61de1ee1cac498ae$var$Pyb(this.a, $61de1ee1cac498ae$var$CD(a), $61de1ee1cac498ae$var$CD(b));
};
var $61de1ee1cac498ae$var$ML = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$27$Type", 1066);
$61de1ee1cac498ae$var$bcb(1067, 1, {}, $61de1ee1cac498ae$var$zzb);
$61de1ee1cac498ae$var$_.Kb = function Azb(a) {
    return $61de1ee1cac498ae$var$CD(a)[0];
};
var $61de1ee1cac498ae$var$NL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$28$Type", 1067);
$61de1ee1cac498ae$var$bcb(713, 1, {}, $61de1ee1cac498ae$var$Czb);
$61de1ee1cac498ae$var$_.Ce = function Dzb(a, b) {
    return $61de1ee1cac498ae$var$Bzb(a, b);
};
var $61de1ee1cac498ae$var$OL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$4$Type", 713);
$61de1ee1cac498ae$var$bcb(252, 1, {}, $61de1ee1cac498ae$var$Ezb);
$61de1ee1cac498ae$var$_.Ce = function Fzb(a, b) {
    return $61de1ee1cac498ae$var$Ryb($61de1ee1cac498ae$var$BD(a, 14), $61de1ee1cac498ae$var$BD(b, 14));
};
var $61de1ee1cac498ae$var$PL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$42$Type", 252);
$61de1ee1cac498ae$var$bcb(348, 1, {}, $61de1ee1cac498ae$var$Gzb);
$61de1ee1cac498ae$var$_.Ce = function Hzb(a, b) {
    return $61de1ee1cac498ae$var$Syb($61de1ee1cac498ae$var$BD(a, 53), $61de1ee1cac498ae$var$BD(b, 53));
};
var $61de1ee1cac498ae$var$QL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$50$Type", 348);
$61de1ee1cac498ae$var$bcb(349, 1, {}, $61de1ee1cac498ae$var$Izb);
$61de1ee1cac498ae$var$_.Kb = function Jzb(a) {
    return $61de1ee1cac498ae$var$BD(a, 53);
};
var $61de1ee1cac498ae$var$RL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$51$Type", 349);
$61de1ee1cac498ae$var$bcb(1054, 1, {}, $61de1ee1cac498ae$var$Kzb);
$61de1ee1cac498ae$var$_.Od = function Lzb(a, b) {
    $61de1ee1cac498ae$var$Tyb(this.a, $61de1ee1cac498ae$var$BD(a, 83), b);
};
var $61de1ee1cac498ae$var$SL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$7$Type", 1054);
$61de1ee1cac498ae$var$bcb(1056, 1, {}, $61de1ee1cac498ae$var$Mzb);
$61de1ee1cac498ae$var$_.Ce = function Nzb(a, b) {
    return $61de1ee1cac498ae$var$Vyb($61de1ee1cac498ae$var$BD(a, 83), $61de1ee1cac498ae$var$BD(b, 83), new $61de1ee1cac498ae$var$lzb);
};
var $61de1ee1cac498ae$var$TL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$8$Type", 1056);
$61de1ee1cac498ae$var$bcb(1057, 1, {}, $61de1ee1cac498ae$var$Ozb);
$61de1ee1cac498ae$var$_.Kb = function Pzb(a) {
    return $61de1ee1cac498ae$var$Uyb(this.a, $61de1ee1cac498ae$var$BD(a, 83));
};
var $61de1ee1cac498ae$var$UL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "Collectors/lambda$9$Type", 1057);
$61de1ee1cac498ae$var$bcb(539, 1, {});
$61de1ee1cac498ae$var$_.He = function Wzb() {
    $61de1ee1cac498ae$var$Qzb(this);
};
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$zM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "TerminatableStream", 539);
$61de1ee1cac498ae$var$bcb(812, 539, $61de1ee1cac498ae$var$wke, $61de1ee1cac498ae$var$bAb);
$61de1ee1cac498ae$var$_.He = function cAb() {
    $61de1ee1cac498ae$var$Qzb(this);
};
var $61de1ee1cac498ae$var$ZL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "DoubleStreamImpl", 812);
$61de1ee1cac498ae$var$bcb(1784, 721, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$fAb);
$61de1ee1cac498ae$var$_.ye = function hAb(a) {
    return $61de1ee1cac498ae$var$eAb(this, $61de1ee1cac498ae$var$BD(a, 182));
};
$61de1ee1cac498ae$var$_.a = null;
var $61de1ee1cac498ae$var$WL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "DoubleStreamImpl/2", 1784);
$61de1ee1cac498ae$var$bcb(1785, 1, $61de1ee1cac498ae$var$eke, $61de1ee1cac498ae$var$iAb);
$61de1ee1cac498ae$var$_.we = function jAb(a) {
    $61de1ee1cac498ae$var$gAb(this.a, a);
};
var $61de1ee1cac498ae$var$VL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "DoubleStreamImpl/2/lambda$0$Type", 1785);
$61de1ee1cac498ae$var$bcb(1782, 1, $61de1ee1cac498ae$var$eke, $61de1ee1cac498ae$var$kAb);
$61de1ee1cac498ae$var$_.we = function lAb(a) {
    $61de1ee1cac498ae$var$dAb(this.a, a);
};
var $61de1ee1cac498ae$var$XL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "DoubleStreamImpl/lambda$0$Type", 1782);
$61de1ee1cac498ae$var$bcb(1783, 1, $61de1ee1cac498ae$var$eke, $61de1ee1cac498ae$var$mAb);
$61de1ee1cac498ae$var$_.we = function nAb(a) {
    $61de1ee1cac498ae$var$Epb(this.a, a);
};
var $61de1ee1cac498ae$var$YL = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "DoubleStreamImpl/lambda$2$Type", 1783);
$61de1ee1cac498ae$var$bcb(1358, 720, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$rAb);
$61de1ee1cac498ae$var$_.ye = function sAb(a) {
    return $61de1ee1cac498ae$var$qAb(this, $61de1ee1cac498ae$var$BD(a, 196));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$$L = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "IntStream/5", 1358);
$61de1ee1cac498ae$var$bcb(787, 539, $61de1ee1cac498ae$var$wke, $61de1ee1cac498ae$var$vAb);
$61de1ee1cac498ae$var$_.He = function wAb() {
    $61de1ee1cac498ae$var$Qzb(this);
};
$61de1ee1cac498ae$var$_.Ie = function xAb() {
    return $61de1ee1cac498ae$var$Tzb(this), this.a;
};
var $61de1ee1cac498ae$var$bM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "IntStreamImpl", 787);
$61de1ee1cac498ae$var$bcb(788, 539, $61de1ee1cac498ae$var$wke, $61de1ee1cac498ae$var$yAb);
$61de1ee1cac498ae$var$_.He = function zAb() {
    $61de1ee1cac498ae$var$Qzb(this);
};
$61de1ee1cac498ae$var$_.Ie = function AAb() {
    return $61de1ee1cac498ae$var$Tzb(this), $61de1ee1cac498ae$var$Ivb(), $61de1ee1cac498ae$var$Hvb;
};
var $61de1ee1cac498ae$var$_L = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "IntStreamImpl/Empty", 788);
$61de1ee1cac498ae$var$bcb(1463, 1, $61de1ee1cac498ae$var$sie, $61de1ee1cac498ae$var$BAb);
$61de1ee1cac498ae$var$_.ud = function CAb(a) {
    $61de1ee1cac498ae$var$crb(this.a, a);
};
var $61de1ee1cac498ae$var$aM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "IntStreamImpl/lambda$4$Type", 1463);
var $61de1ee1cac498ae$var$xM = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$vke, "Stream");
$61de1ee1cac498ae$var$bcb(30, 539, {
    525: 1,
    670: 1,
    833: 1
}, $61de1ee1cac498ae$var$YAb);
$61de1ee1cac498ae$var$_.He = function ZAb() {
    $61de1ee1cac498ae$var$Qzb(this);
};
var $61de1ee1cac498ae$var$DAb;
var $61de1ee1cac498ae$var$wM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl", 30);
$61de1ee1cac498ae$var$bcb(845, 1, {}, $61de1ee1cac498ae$var$bBb);
$61de1ee1cac498ae$var$_.ld = function cBb(a) {
    return $61de1ee1cac498ae$var$aBb(a);
};
var $61de1ee1cac498ae$var$cM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/0methodref$lambda$2$Type", 845);
$61de1ee1cac498ae$var$bcb(1084, 540, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$fBb);
$61de1ee1cac498ae$var$_.sd = function gBb(a) {
    while($61de1ee1cac498ae$var$dBb(this)){
        if (this.a.sd(a)) return true;
        else {
            $61de1ee1cac498ae$var$Qzb(this.b);
            this.b = null;
            this.a = null;
        }
    }
    return false;
};
var $61de1ee1cac498ae$var$eM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/1", 1084);
$61de1ee1cac498ae$var$bcb(1085, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$hBb);
$61de1ee1cac498ae$var$_.td = function iBb(a) {
    $61de1ee1cac498ae$var$eBb(this.a, $61de1ee1cac498ae$var$BD(a, 833));
};
var $61de1ee1cac498ae$var$dM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/1/lambda$0$Type", 1085);
$61de1ee1cac498ae$var$bcb(1086, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$jBb);
$61de1ee1cac498ae$var$_.Mb = function kBb(a) {
    return $61de1ee1cac498ae$var$Qqb(this.a, a);
};
var $61de1ee1cac498ae$var$fM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/1methodref$add$Type", 1086);
$61de1ee1cac498ae$var$bcb(1087, 540, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$lBb);
$61de1ee1cac498ae$var$_.sd = function mBb(a) {
    var b;
    if (!this.a) {
        b = new $61de1ee1cac498ae$var$Rkb;
        this.b.a.Nb(new $61de1ee1cac498ae$var$nBb(b));
        $61de1ee1cac498ae$var$mmb();
        $61de1ee1cac498ae$var$Okb(b, this.c);
        this.a = new $61de1ee1cac498ae$var$Kub(b, 16);
    }
    return $61de1ee1cac498ae$var$Jub(this.a, a);
};
$61de1ee1cac498ae$var$_.a = null;
var $61de1ee1cac498ae$var$hM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/5", 1087);
$61de1ee1cac498ae$var$bcb(1088, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$nBb);
$61de1ee1cac498ae$var$_.td = function oBb(a) {
    $61de1ee1cac498ae$var$Ekb(this.a, a);
};
var $61de1ee1cac498ae$var$gM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/5/2methodref$add$Type", 1088);
$61de1ee1cac498ae$var$bcb(722, 540, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$qBb);
$61de1ee1cac498ae$var$_.sd = function rBb(a) {
    this.b = false;
    while(!this.b && this.c.sd(new $61de1ee1cac498ae$var$sBb(this, a)));
    return this.b;
};
$61de1ee1cac498ae$var$_.b = false;
var $61de1ee1cac498ae$var$jM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/FilterSpliterator", 722);
$61de1ee1cac498ae$var$bcb(1079, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$sBb);
$61de1ee1cac498ae$var$_.td = function tBb(a) {
    $61de1ee1cac498ae$var$pBb(this.a, this.b, a);
};
var $61de1ee1cac498ae$var$iM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/FilterSpliterator/lambda$0$Type", 1079);
$61de1ee1cac498ae$var$bcb(1075, 721, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$wBb);
$61de1ee1cac498ae$var$_.ye = function xBb(a) {
    return $61de1ee1cac498ae$var$vBb(this, $61de1ee1cac498ae$var$BD(a, 182));
};
var $61de1ee1cac498ae$var$lM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/MapToDoubleSpliterator", 1075);
$61de1ee1cac498ae$var$bcb(1078, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$yBb);
$61de1ee1cac498ae$var$_.td = function zBb(a) {
    $61de1ee1cac498ae$var$uBb(this.a, this.b, a);
};
var $61de1ee1cac498ae$var$kM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/MapToDoubleSpliterator/lambda$0$Type", 1078);
$61de1ee1cac498ae$var$bcb(1074, 720, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$CBb);
$61de1ee1cac498ae$var$_.ye = function DBb(a) {
    return $61de1ee1cac498ae$var$BBb(this, $61de1ee1cac498ae$var$BD(a, 196));
};
var $61de1ee1cac498ae$var$nM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/MapToIntSpliterator", 1074);
$61de1ee1cac498ae$var$bcb(1077, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$EBb);
$61de1ee1cac498ae$var$_.td = function FBb(a) {
    $61de1ee1cac498ae$var$ABb(this.a, this.b, a);
};
var $61de1ee1cac498ae$var$mM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/MapToIntSpliterator/lambda$0$Type", 1077);
$61de1ee1cac498ae$var$bcb(719, 540, $61de1ee1cac498ae$var$pie, $61de1ee1cac498ae$var$IBb);
$61de1ee1cac498ae$var$_.sd = function JBb(a) {
    return $61de1ee1cac498ae$var$HBb(this, a);
};
var $61de1ee1cac498ae$var$pM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/MapToObjSpliterator", 719);
$61de1ee1cac498ae$var$bcb(1076, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$KBb);
$61de1ee1cac498ae$var$_.td = function LBb(a) {
    $61de1ee1cac498ae$var$GBb(this.a, this.b, a);
};
var $61de1ee1cac498ae$var$oM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/MapToObjSpliterator/lambda$0$Type", 1076);
$61de1ee1cac498ae$var$bcb(618, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$NBb);
$61de1ee1cac498ae$var$_.td = function OBb(a) {
    $61de1ee1cac498ae$var$MBb(this, a);
};
var $61de1ee1cac498ae$var$qM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/ValueConsumer", 618);
$61de1ee1cac498ae$var$bcb(1080, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$PBb);
$61de1ee1cac498ae$var$_.td = function QBb(a) {
    $61de1ee1cac498ae$var$EAb();
};
var $61de1ee1cac498ae$var$rM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/lambda$0$Type", 1080);
$61de1ee1cac498ae$var$bcb(1081, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$RBb);
$61de1ee1cac498ae$var$_.td = function SBb(a) {
    $61de1ee1cac498ae$var$EAb();
};
var $61de1ee1cac498ae$var$sM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/lambda$1$Type", 1081);
$61de1ee1cac498ae$var$bcb(1082, 1, {}, $61de1ee1cac498ae$var$TBb);
$61de1ee1cac498ae$var$_.Ce = function UBb(a, b) {
    return $61de1ee1cac498ae$var$$Ab(this.a, a, b);
};
var $61de1ee1cac498ae$var$uM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/lambda$4$Type", 1082);
$61de1ee1cac498ae$var$bcb(1083, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$VBb);
$61de1ee1cac498ae$var$_.td = function WBb(a) {
    $61de1ee1cac498ae$var$_Ab(this.b, this.a, a);
};
var $61de1ee1cac498ae$var$vM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "StreamImpl/lambda$5$Type", 1083);
$61de1ee1cac498ae$var$bcb(1089, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$XBb);
$61de1ee1cac498ae$var$_.td = function YBb(a) {
    $61de1ee1cac498ae$var$Xzb(this.a, $61de1ee1cac498ae$var$BD(a, 365));
};
var $61de1ee1cac498ae$var$yM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$vke, "TerminatableStream/lambda$0$Type", 1089);
$61de1ee1cac498ae$var$bcb(2041, 1, {});
$61de1ee1cac498ae$var$bcb(1914, 1, {}, $61de1ee1cac498ae$var$iCb);
var $61de1ee1cac498ae$var$AM = $61de1ee1cac498ae$var$mdb("javaemul.internal", "ConsoleLogger", 1914);
$61de1ee1cac498ae$var$bcb(2038, 1, {});
var $61de1ee1cac498ae$var$ECb = 0;
var $61de1ee1cac498ae$var$GCb, $61de1ee1cac498ae$var$HCb = 0, $61de1ee1cac498ae$var$ICb;
$61de1ee1cac498ae$var$bcb(1768, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$OCb);
$61de1ee1cac498ae$var$_.td = function PCb(a) {
    $61de1ee1cac498ae$var$BD(a, 308);
};
var $61de1ee1cac498ae$var$BM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "BowyerWatsonTriangulation/lambda$0$Type", 1768);
$61de1ee1cac498ae$var$bcb(1769, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$QCb);
$61de1ee1cac498ae$var$_.td = function RCb(a) {
    $61de1ee1cac498ae$var$ye(this.a, $61de1ee1cac498ae$var$BD(a, 308).e);
};
var $61de1ee1cac498ae$var$CM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "BowyerWatsonTriangulation/lambda$1$Type", 1769);
$61de1ee1cac498ae$var$bcb(1770, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$SCb);
$61de1ee1cac498ae$var$_.td = function TCb(a) {
    $61de1ee1cac498ae$var$BD(a, 168);
};
var $61de1ee1cac498ae$var$DM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "BowyerWatsonTriangulation/lambda$2$Type", 1770);
$61de1ee1cac498ae$var$bcb(1765, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$WCb);
$61de1ee1cac498ae$var$_.ue = function XCb(a, b) {
    return $61de1ee1cac498ae$var$VCb(this.a, $61de1ee1cac498ae$var$BD(a, 168), $61de1ee1cac498ae$var$BD(b, 168));
};
$61de1ee1cac498ae$var$_.Fb = function YCb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function ZCb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$EM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "NaiveMinST/lambda$0$Type", 1765);
$61de1ee1cac498ae$var$bcb(499, 1, {}, $61de1ee1cac498ae$var$_Cb);
var $61de1ee1cac498ae$var$FM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "NodeMicroLayout", 499);
$61de1ee1cac498ae$var$bcb(168, 1, {
    168: 1
}, $61de1ee1cac498ae$var$aDb);
$61de1ee1cac498ae$var$_.Fb = function bDb(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 168)) {
        b = $61de1ee1cac498ae$var$BD(a, 168);
        return $61de1ee1cac498ae$var$wtb(this.a, b.a) && $61de1ee1cac498ae$var$wtb(this.b, b.b) || $61de1ee1cac498ae$var$wtb(this.a, b.b) && $61de1ee1cac498ae$var$wtb(this.b, b.a);
    } else return false;
};
$61de1ee1cac498ae$var$_.Hb = function cDb() {
    return $61de1ee1cac498ae$var$xtb(this.a) + $61de1ee1cac498ae$var$xtb(this.b);
};
var $61de1ee1cac498ae$var$GM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "TEdge", 168);
$61de1ee1cac498ae$var$bcb(308, 1, {
    308: 1
}, $61de1ee1cac498ae$var$eDb);
$61de1ee1cac498ae$var$_.Fb = function fDb(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 308)) {
        b = $61de1ee1cac498ae$var$BD(a, 308);
        return $61de1ee1cac498ae$var$dDb(this, b.a) && $61de1ee1cac498ae$var$dDb(this, b.b) && $61de1ee1cac498ae$var$dDb(this, b.c);
    } else return false;
};
$61de1ee1cac498ae$var$_.Hb = function gDb() {
    return $61de1ee1cac498ae$var$xtb(this.a) + $61de1ee1cac498ae$var$xtb(this.b) + $61de1ee1cac498ae$var$xtb(this.c);
};
var $61de1ee1cac498ae$var$HM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "TTriangle", 308);
$61de1ee1cac498ae$var$bcb(221, 1, {
    221: 1
}, $61de1ee1cac498ae$var$hDb);
var $61de1ee1cac498ae$var$IM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cke, "Tree", 221);
$61de1ee1cac498ae$var$bcb(1254, 1, {}, $61de1ee1cac498ae$var$jDb);
var $61de1ee1cac498ae$var$KM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Eke, "Scanline", 1254);
var $61de1ee1cac498ae$var$JM = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Eke, $61de1ee1cac498ae$var$Fke);
$61de1ee1cac498ae$var$bcb(1692, 1, {}, $61de1ee1cac498ae$var$mDb);
var $61de1ee1cac498ae$var$LM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "CGraph", 1692);
$61de1ee1cac498ae$var$bcb(307, 1, {
    307: 1
}, $61de1ee1cac498ae$var$oDb);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.k = $61de1ee1cac498ae$var$Qje;
var $61de1ee1cac498ae$var$NM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "CGroup", 307);
$61de1ee1cac498ae$var$bcb(815, 1, {}, $61de1ee1cac498ae$var$sDb);
var $61de1ee1cac498ae$var$MM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "CGroup/CGroupBuilder", 815);
$61de1ee1cac498ae$var$bcb(57, 1, {
    57: 1
}, $61de1ee1cac498ae$var$tDb);
$61de1ee1cac498ae$var$_.Ib = function uDb() {
    var a;
    if (this.j) return $61de1ee1cac498ae$var$GD(this.j.Kb(this));
    return $61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$PM), $61de1ee1cac498ae$var$PM.o + "@" + (a = $61de1ee1cac498ae$var$FCb(this) >>> 0, a.toString(16));
};
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.i = $61de1ee1cac498ae$var$Qje;
var $61de1ee1cac498ae$var$PM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "CNode", 57);
$61de1ee1cac498ae$var$bcb(814, 1, {}, $61de1ee1cac498ae$var$zDb);
var $61de1ee1cac498ae$var$OM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "CNode/CNodeBuilder", 814);
var $61de1ee1cac498ae$var$EDb;
$61de1ee1cac498ae$var$bcb(1525, 1, {}, $61de1ee1cac498ae$var$GDb);
$61de1ee1cac498ae$var$_.Oe = function HDb(a, b) {
    return 0;
};
$61de1ee1cac498ae$var$_.Pe = function IDb(a, b) {
    return 0;
};
var $61de1ee1cac498ae$var$QM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Ike, 1525);
$61de1ee1cac498ae$var$bcb(1790, 1, {}, $61de1ee1cac498ae$var$JDb);
$61de1ee1cac498ae$var$_.Le = function KDb(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p;
    j = $61de1ee1cac498ae$var$Pje;
    for(d = new $61de1ee1cac498ae$var$olb(a.a.b); d.a < d.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 57);
        j = $61de1ee1cac498ae$var$$wnd.Math.min(j, b.a.j.d.c + b.b.a);
    }
    n = new $61de1ee1cac498ae$var$Psb;
    for(g = new $61de1ee1cac498ae$var$olb(a.a.a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 307);
        f.k = j;
        f.g == 0 && $61de1ee1cac498ae$var$Gsb(n, f, n.c.b, n.c);
    }
    while(n.b != 0){
        f = $61de1ee1cac498ae$var$BD(n.b == 0 ? null : ($61de1ee1cac498ae$var$sCb(n.b != 0), $61de1ee1cac498ae$var$Nsb(n, n.a.a)), 307);
        e = f.j.d.c;
        for(m = f.a.a.ec().Kc(); m.Ob();){
            k = $61de1ee1cac498ae$var$BD(m.Pb(), 57);
            p = f.k + k.b.a;
            !$61de1ee1cac498ae$var$UDb(a, f, a.d) || k.d.c < p ? k.i = p : k.i = k.d.c;
        }
        e -= f.j.i;
        f.b += e;
        a.d == ($61de1ee1cac498ae$var$ead(), $61de1ee1cac498ae$var$bad) || a.d == $61de1ee1cac498ae$var$_9c ? f.c += e : f.c -= e;
        for(l = f.a.a.ec().Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 57);
            for(i = k.c.Kc(); i.Ob();){
                h = $61de1ee1cac498ae$var$BD(i.Pb(), 57);
                $61de1ee1cac498ae$var$fad(a.d) ? o = a.g.Oe(k, h) : o = a.g.Pe(k, h);
                h.a.k = $61de1ee1cac498ae$var$$wnd.Math.max(h.a.k, k.i + k.d.b + o - h.b.a);
                $61de1ee1cac498ae$var$VDb(a, h, a.d) && (h.a.k = $61de1ee1cac498ae$var$$wnd.Math.max(h.a.k, h.d.c - h.b.a));
                --h.a.g;
                h.a.g == 0 && $61de1ee1cac498ae$var$Dsb(n, h.a);
            }
        }
    }
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        b.d.c = b.i;
    }
};
var $61de1ee1cac498ae$var$RM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "LongestPathCompaction", 1790);
$61de1ee1cac498ae$var$bcb(1690, 1, {}, $61de1ee1cac498ae$var$cEb);
$61de1ee1cac498ae$var$_.e = false;
var $61de1ee1cac498ae$var$LDb, $61de1ee1cac498ae$var$MDb, $61de1ee1cac498ae$var$NDb;
var $61de1ee1cac498ae$var$TM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Nke, 1690);
$61de1ee1cac498ae$var$bcb(1691, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$dEb);
$61de1ee1cac498ae$var$_.td = function eEb(a) {
    $61de1ee1cac498ae$var$WDb(this.a, $61de1ee1cac498ae$var$BD(a, 46));
};
var $61de1ee1cac498ae$var$SM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Oke, 1691);
$61de1ee1cac498ae$var$bcb(1791, 1, {}, $61de1ee1cac498ae$var$fEb);
$61de1ee1cac498ae$var$_.Me = function gEb(a) {
    var b, c, d, e, f, g, h;
    for(c = new $61de1ee1cac498ae$var$olb(a.a.b); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 57);
        b.c.$b();
    }
    for(e = new $61de1ee1cac498ae$var$olb(a.a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 57);
        for(g = new $61de1ee1cac498ae$var$olb(a.a.b); g.a < g.c.c.length;){
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 57);
            if (d == f) continue;
            if (!!d.a && d.a == f.a) continue;
            $61de1ee1cac498ae$var$fad(a.d) ? h = a.g.Pe(d, f) : h = a.g.Oe(d, f);
            (f.d.c > d.d.c || d.d.c == f.d.c && d.d.b < f.d.b) && $61de1ee1cac498ae$var$BDb(f.d.d + f.d.a + h, d.d.d) && $61de1ee1cac498ae$var$DDb(f.d.d, d.d.d + d.d.a + h) && d.c.Fc(f);
        }
    }
};
var $61de1ee1cac498ae$var$UM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "QuadraticConstraintCalculation", 1791);
$61de1ee1cac498ae$var$bcb(522, 1, {
    522: 1
}, $61de1ee1cac498ae$var$lEb);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$VM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Pke, 522);
$61de1ee1cac498ae$var$bcb(803, 1, {}, $61de1ee1cac498ae$var$oEb);
$61de1ee1cac498ae$var$_.Me = function pEb(a) {
    this.c = a;
    $61de1ee1cac498ae$var$nEb(this, new $61de1ee1cac498ae$var$GEb);
};
var $61de1ee1cac498ae$var$_M = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Qke, 803);
$61de1ee1cac498ae$var$bcb(1718, 1, {
    679: 1
}, $61de1ee1cac498ae$var$uEb);
$61de1ee1cac498ae$var$_.Ke = function vEb(a) {
    $61de1ee1cac498ae$var$rEb(this, $61de1ee1cac498ae$var$BD(a, 464));
};
var $61de1ee1cac498ae$var$XM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Rke, 1718);
$61de1ee1cac498ae$var$bcb(1719, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$xEb);
$61de1ee1cac498ae$var$_.ue = function yEb(a, b) {
    return $61de1ee1cac498ae$var$wEb($61de1ee1cac498ae$var$BD(a, 57), $61de1ee1cac498ae$var$BD(b, 57));
};
$61de1ee1cac498ae$var$_.Fb = function zEb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function AEb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$WM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Ske, 1719);
$61de1ee1cac498ae$var$bcb(464, 1, {
    464: 1
}, $61de1ee1cac498ae$var$BEb);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$YM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Tke, 464);
$61de1ee1cac498ae$var$bcb(1720, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$CEb);
$61de1ee1cac498ae$var$_.ue = function DEb(a, b) {
    return $61de1ee1cac498ae$var$qEb($61de1ee1cac498ae$var$BD(a, 464), $61de1ee1cac498ae$var$BD(b, 464));
};
$61de1ee1cac498ae$var$_.Fb = function EEb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function FEb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$ZM = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, $61de1ee1cac498ae$var$Uke, 1720);
$61de1ee1cac498ae$var$bcb(1721, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$GEb);
$61de1ee1cac498ae$var$_.Lb = function HEb(a) {
    return $61de1ee1cac498ae$var$BD(a, 57), true;
};
$61de1ee1cac498ae$var$_.Fb = function IEb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function JEb(a) {
    return $61de1ee1cac498ae$var$BD(a, 57), true;
};
var $61de1ee1cac498ae$var$$M = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gke, "ScanlineConstraintCalculator/lambda$1$Type", 1721);
$61de1ee1cac498ae$var$bcb(428, 22, {
    3: 1,
    35: 1,
    22: 1,
    428: 1
}, $61de1ee1cac498ae$var$NEb);
var $61de1ee1cac498ae$var$KEb, $61de1ee1cac498ae$var$LEb;
var $61de1ee1cac498ae$var$aN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Wke, "HighLevelSortingCriterion", 428, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$PEb, $61de1ee1cac498ae$var$OEb);
var $61de1ee1cac498ae$var$QEb;
$61de1ee1cac498ae$var$bcb(427, 22, {
    3: 1,
    35: 1,
    22: 1,
    427: 1
}, $61de1ee1cac498ae$var$VEb);
var $61de1ee1cac498ae$var$SEb, $61de1ee1cac498ae$var$TEb;
var $61de1ee1cac498ae$var$bN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Wke, "LowLevelSortingCriterion", 427, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$XEb, $61de1ee1cac498ae$var$WEb);
var $61de1ee1cac498ae$var$YEb;
var $61de1ee1cac498ae$var$C0 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Xke, "ILayoutMetaDataProvider");
$61de1ee1cac498ae$var$bcb(853, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$gFb);
$61de1ee1cac498ae$var$_.Qe = function hFb(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Yke), $61de1ee1cac498ae$var$ble), "Polyomino Traversal Strategy"), "Traversal strategy for trying different candidate positions for polyominoes."), $61de1ee1cac498ae$var$eFb), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$V5c)), $61de1ee1cac498ae$var$dN), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$L5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Zke), $61de1ee1cac498ae$var$ble), "Polyomino Secondary Sorting Criterion"), "Possible secondary sorting criteria for the processing order of polyominoes. They are used when polyominoes are equal according to the primary sorting criterion HighLevelSortingCriterion."), $61de1ee1cac498ae$var$cFb), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$bN), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$$ke), $61de1ee1cac498ae$var$ble), "Polyomino Primary Sorting Criterion"), "Possible primary sorting criteria for the processing order of polyominoes."), $61de1ee1cac498ae$var$aFb), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$aN), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$_ke), $61de1ee1cac498ae$var$ble), "Fill Polyominoes"), "Use the Profile Fill algorithm to fill polyominoes to prevent small polyominoes from being placed inside of big polyominoes with large holes. Might increase packing area."), ($61de1ee1cac498ae$var$Bcb(), true)), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
};
var $61de1ee1cac498ae$var$$Eb, $61de1ee1cac498ae$var$_Eb, $61de1ee1cac498ae$var$aFb, $61de1ee1cac498ae$var$bFb, $61de1ee1cac498ae$var$cFb, $61de1ee1cac498ae$var$dFb, $61de1ee1cac498ae$var$eFb;
var $61de1ee1cac498ae$var$cN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wke, "PolyominoOptions", 853);
$61de1ee1cac498ae$var$bcb(250, 22, {
    3: 1,
    35: 1,
    22: 1,
    250: 1
}, $61de1ee1cac498ae$var$sFb);
var $61de1ee1cac498ae$var$iFb, $61de1ee1cac498ae$var$jFb, $61de1ee1cac498ae$var$kFb, $61de1ee1cac498ae$var$lFb, $61de1ee1cac498ae$var$mFb, $61de1ee1cac498ae$var$nFb, $61de1ee1cac498ae$var$oFb, $61de1ee1cac498ae$var$pFb, $61de1ee1cac498ae$var$qFb;
var $61de1ee1cac498ae$var$dN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Wke, "TraversalStrategy", 250, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$uFb, $61de1ee1cac498ae$var$tFb);
var $61de1ee1cac498ae$var$vFb;
$61de1ee1cac498ae$var$bcb(213, 1, {
    213: 1
}, $61de1ee1cac498ae$var$yFb);
$61de1ee1cac498ae$var$_.Ib = function zFb() {
    return "NEdge[id=" + this.b + " w=" + this.g + " d=" + this.a + "]";
};
$61de1ee1cac498ae$var$_.a = 1;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.f = false;
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$fN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cle, "NEdge", 213);
$61de1ee1cac498ae$var$bcb(176, 1, {}, $61de1ee1cac498ae$var$FFb);
var $61de1ee1cac498ae$var$eN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cle, "NEdge/NEdgeBuilder", 176);
$61de1ee1cac498ae$var$bcb(653, 1, {}, $61de1ee1cac498ae$var$KFb);
var $61de1ee1cac498ae$var$gN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cle, "NGraph", 653);
$61de1ee1cac498ae$var$bcb(121, 1, {
    121: 1
}, $61de1ee1cac498ae$var$MFb);
$61de1ee1cac498ae$var$_.c = -1;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.i = -1;
$61de1ee1cac498ae$var$_.j = false;
var $61de1ee1cac498ae$var$jN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cle, "NNode", 121);
$61de1ee1cac498ae$var$bcb(795, 1, $61de1ee1cac498ae$var$cke, $61de1ee1cac498ae$var$PFb);
$61de1ee1cac498ae$var$_.Jc = function XFb(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Lc = function cGb() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.ad = function hGb(a) {
    $61de1ee1cac498ae$var$ktb(this, a);
};
$61de1ee1cac498ae$var$_.Nc = function iGb() {
    return new $61de1ee1cac498ae$var$Kub(this, 16);
};
$61de1ee1cac498ae$var$_.Oc = function jGb() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.Vc = function QFb(a, b) {
    ++this.b;
    $61de1ee1cac498ae$var$Dkb(this.a, a, b);
};
$61de1ee1cac498ae$var$_.Fc = function RFb(a) {
    return $61de1ee1cac498ae$var$NFb(this, a);
};
$61de1ee1cac498ae$var$_.Wc = function SFb(a, b) {
    ++this.b;
    return $61de1ee1cac498ae$var$Fkb(this.a, a, b);
};
$61de1ee1cac498ae$var$_.Gc = function TFb(a) {
    ++this.b;
    return $61de1ee1cac498ae$var$Gkb(this.a, a);
};
$61de1ee1cac498ae$var$_.$b = function UFb() {
    ++this.b;
    this.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
};
$61de1ee1cac498ae$var$_.Hc = function VFb(a) {
    return $61de1ee1cac498ae$var$Jkb(this.a, a, 0) != -1;
};
$61de1ee1cac498ae$var$_.Ic = function WFb(a) {
    return $61de1ee1cac498ae$var$Be(this.a, a);
};
$61de1ee1cac498ae$var$_.Xb = function YFb(a) {
    return $61de1ee1cac498ae$var$Ikb(this.a, a);
};
$61de1ee1cac498ae$var$_.Xc = function ZFb(a) {
    return $61de1ee1cac498ae$var$Jkb(this.a, a, 0);
};
$61de1ee1cac498ae$var$_.dc = function $Fb() {
    return this.a.c.length == 0;
};
$61de1ee1cac498ae$var$_.Kc = function _Fb() {
    return $61de1ee1cac498ae$var$vr(new $61de1ee1cac498ae$var$olb(this.a));
};
$61de1ee1cac498ae$var$_.Yc = function aGb() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Zc = function bGb(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.$c = function dGb(a) {
    ++this.b;
    return $61de1ee1cac498ae$var$Kkb(this.a, a);
};
$61de1ee1cac498ae$var$_.Mc = function eGb(a) {
    return $61de1ee1cac498ae$var$OFb(this, a);
};
$61de1ee1cac498ae$var$_._c = function fGb(a, b) {
    ++this.b;
    return $61de1ee1cac498ae$var$Nkb(this.a, a, b);
};
$61de1ee1cac498ae$var$_.gc = function gGb() {
    return this.a.c.length;
};
$61de1ee1cac498ae$var$_.bd = function kGb(a, b) {
    return new $61de1ee1cac498ae$var$Jib(this.a, a, b);
};
$61de1ee1cac498ae$var$_.Pc = function lGb() {
    return $61de1ee1cac498ae$var$Pkb(this.a);
};
$61de1ee1cac498ae$var$_.Qc = function mGb(a) {
    return $61de1ee1cac498ae$var$Qkb(this.a, a);
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$hN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cle, "NNode/ChangeAwareArrayList", 795);
$61de1ee1cac498ae$var$bcb(269, 1, {}, $61de1ee1cac498ae$var$pGb);
var $61de1ee1cac498ae$var$iN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cle, "NNode/NNodeBuilder", 269);
$61de1ee1cac498ae$var$bcb(1630, 1, {}, $61de1ee1cac498ae$var$KGb);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.f = $61de1ee1cac498ae$var$Ohe;
$61de1ee1cac498ae$var$_.j = 0;
var $61de1ee1cac498ae$var$kN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cle, "NetworkSimplex", 1630);
$61de1ee1cac498ae$var$bcb(1294, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$QGb);
$61de1ee1cac498ae$var$_.td = function RGb(a) {
    $61de1ee1cac498ae$var$PGb(this.a, $61de1ee1cac498ae$var$BD(a, 680), true, false);
};
var $61de1ee1cac498ae$var$lN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ele, "NodeLabelAndSizeCalculator/lambda$0$Type", 1294);
$61de1ee1cac498ae$var$bcb(558, 1, {}, $61de1ee1cac498ae$var$YGb);
$61de1ee1cac498ae$var$_.b = true;
$61de1ee1cac498ae$var$_.c = true;
$61de1ee1cac498ae$var$_.d = true;
$61de1ee1cac498ae$var$_.e = true;
var $61de1ee1cac498ae$var$mN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ele, "NodeMarginCalculator", 558);
$61de1ee1cac498ae$var$bcb(212, 1, {
    212: 1
});
$61de1ee1cac498ae$var$_.j = false;
$61de1ee1cac498ae$var$_.k = false;
var $61de1ee1cac498ae$var$oN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "Cell", 212);
$61de1ee1cac498ae$var$bcb(124, 212, {
    124: 1,
    212: 1
}, $61de1ee1cac498ae$var$aHb);
$61de1ee1cac498ae$var$_.Re = function bHb() {
    return $61de1ee1cac498ae$var$_Gb(this);
};
$61de1ee1cac498ae$var$_.Se = function cHb() {
    var a;
    a = this.n;
    return this.a.a + a.b + a.c;
};
var $61de1ee1cac498ae$var$nN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "AtomicCell", 124);
$61de1ee1cac498ae$var$bcb(232, 22, {
    3: 1,
    35: 1,
    22: 1,
    232: 1
}, $61de1ee1cac498ae$var$hHb);
var $61de1ee1cac498ae$var$dHb, $61de1ee1cac498ae$var$eHb, $61de1ee1cac498ae$var$fHb;
var $61de1ee1cac498ae$var$pN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$fle, "ContainerArea", 232, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$jHb, $61de1ee1cac498ae$var$iHb);
var $61de1ee1cac498ae$var$kHb;
$61de1ee1cac498ae$var$bcb(326, 212, $61de1ee1cac498ae$var$hle);
var $61de1ee1cac498ae$var$qN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "ContainerCell", 326);
$61de1ee1cac498ae$var$bcb(1473, 326, $61de1ee1cac498ae$var$hle, $61de1ee1cac498ae$var$FHb);
$61de1ee1cac498ae$var$_.Re = function GHb() {
    var a;
    a = 0;
    this.e ? this.b ? a = this.b.b : !!this.a[1][1] && (a = this.a[1][1].Re()) : a = $61de1ee1cac498ae$var$EHb(this, $61de1ee1cac498ae$var$AHb(this, true));
    return a > 0 ? a + this.n.d + this.n.a : 0;
};
$61de1ee1cac498ae$var$_.Se = function HHb() {
    var a, b, c, d, e;
    e = 0;
    if (this.e) this.b ? e = this.b.a : !!this.a[1][1] && (e = this.a[1][1].Se());
    else if (this.g) e = $61de1ee1cac498ae$var$EHb(this, $61de1ee1cac498ae$var$yHb(this, null, true));
    else for(b = ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ])), c = 0, d = b.length; c < d; ++c){
        a = b[c];
        e = $61de1ee1cac498ae$var$$wnd.Math.max(e, $61de1ee1cac498ae$var$EHb(this, $61de1ee1cac498ae$var$yHb(this, a, true)));
    }
    return e > 0 ? e + this.n.b + this.n.c : 0;
};
$61de1ee1cac498ae$var$_.Te = function IHb() {
    var a, b, c, d, e;
    if (this.g) {
        a = $61de1ee1cac498ae$var$yHb(this, null, false);
        for(c = ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
            $61de1ee1cac498ae$var$dHb,
            $61de1ee1cac498ae$var$eHb,
            $61de1ee1cac498ae$var$fHb
        ])), d = 0, e = c.length; d < e; ++d){
            b = c[d];
            $61de1ee1cac498ae$var$wHb(this, b, a);
        }
    } else for(c = ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$pN, 1), $61de1ee1cac498ae$var$Kie, 232, 0, [
        $61de1ee1cac498ae$var$dHb,
        $61de1ee1cac498ae$var$eHb,
        $61de1ee1cac498ae$var$fHb
    ])), d = 0, e = c.length; d < e; ++d){
        b = c[d];
        a = $61de1ee1cac498ae$var$yHb(this, b, false);
        $61de1ee1cac498ae$var$wHb(this, b, a);
    }
};
$61de1ee1cac498ae$var$_.Ue = function JHb() {
    var a, b, c, d;
    b = this.i;
    a = this.n;
    d = $61de1ee1cac498ae$var$AHb(this, false);
    $61de1ee1cac498ae$var$uHb(this, ($61de1ee1cac498ae$var$gHb(), $61de1ee1cac498ae$var$dHb), b.d + a.d, d);
    $61de1ee1cac498ae$var$uHb(this, $61de1ee1cac498ae$var$fHb, b.d + b.a - a.a - d[2], d);
    c = b.a - a.d - a.a;
    if (d[0] > 0) {
        d[0] += this.d;
        c -= d[0];
    }
    if (d[2] > 0) {
        d[2] += this.d;
        c -= d[2];
    }
    this.c.a = $61de1ee1cac498ae$var$$wnd.Math.max(0, c);
    this.c.d = b.d + a.d + (this.c.a - c) / 2;
    d[1] = $61de1ee1cac498ae$var$$wnd.Math.max(d[1], c);
    $61de1ee1cac498ae$var$uHb(this, $61de1ee1cac498ae$var$eHb, b.d + a.d + d[0] - (d[1] - c) / 2, d);
};
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = false;
$61de1ee1cac498ae$var$_.f = false;
$61de1ee1cac498ae$var$_.g = false;
var $61de1ee1cac498ae$var$rHb = 0, $61de1ee1cac498ae$var$sHb = 0;
var $61de1ee1cac498ae$var$rN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "GridContainerCell", 1473);
$61de1ee1cac498ae$var$bcb(461, 22, {
    3: 1,
    35: 1,
    22: 1,
    461: 1
}, $61de1ee1cac498ae$var$OHb);
var $61de1ee1cac498ae$var$KHb, $61de1ee1cac498ae$var$LHb, $61de1ee1cac498ae$var$MHb;
var $61de1ee1cac498ae$var$sN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$fle, "HorizontalLabelAlignment", 461, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$QHb, $61de1ee1cac498ae$var$PHb);
var $61de1ee1cac498ae$var$RHb;
$61de1ee1cac498ae$var$bcb(306, 212, {
    212: 1,
    306: 1
}, $61de1ee1cac498ae$var$aIb, $61de1ee1cac498ae$var$bIb, $61de1ee1cac498ae$var$cIb);
$61de1ee1cac498ae$var$_.Re = function dIb() {
    return $61de1ee1cac498ae$var$YHb(this);
};
$61de1ee1cac498ae$var$_.Se = function eIb() {
    return $61de1ee1cac498ae$var$ZHb(this);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$tN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "LabelCell", 306);
$61de1ee1cac498ae$var$bcb(244, 326, {
    212: 1,
    326: 1,
    244: 1
}, $61de1ee1cac498ae$var$mIb);
$61de1ee1cac498ae$var$_.Re = function nIb() {
    return $61de1ee1cac498ae$var$fIb(this);
};
$61de1ee1cac498ae$var$_.Se = function oIb() {
    return $61de1ee1cac498ae$var$gIb(this);
};
$61de1ee1cac498ae$var$_.Te = function rIb() {
    $61de1ee1cac498ae$var$hIb(this);
};
$61de1ee1cac498ae$var$_.Ue = function sIb() {
    $61de1ee1cac498ae$var$iIb(this);
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$yN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "StripContainerCell", 244);
$61de1ee1cac498ae$var$bcb(1626, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$tIb);
$61de1ee1cac498ae$var$_.Mb = function uIb(a) {
    return $61de1ee1cac498ae$var$pIb($61de1ee1cac498ae$var$BD(a, 212));
};
var $61de1ee1cac498ae$var$uN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "StripContainerCell/lambda$0$Type", 1626);
$61de1ee1cac498ae$var$bcb(1627, 1, {}, $61de1ee1cac498ae$var$vIb);
$61de1ee1cac498ae$var$_.Fe = function wIb(a) {
    return $61de1ee1cac498ae$var$BD(a, 212).Se();
};
var $61de1ee1cac498ae$var$vN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "StripContainerCell/lambda$1$Type", 1627);
$61de1ee1cac498ae$var$bcb(1628, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$xIb);
$61de1ee1cac498ae$var$_.Mb = function yIb(a) {
    return $61de1ee1cac498ae$var$qIb($61de1ee1cac498ae$var$BD(a, 212));
};
var $61de1ee1cac498ae$var$wN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "StripContainerCell/lambda$2$Type", 1628);
$61de1ee1cac498ae$var$bcb(1629, 1, {}, $61de1ee1cac498ae$var$zIb);
$61de1ee1cac498ae$var$_.Fe = function AIb(a) {
    return $61de1ee1cac498ae$var$BD(a, 212).Re();
};
var $61de1ee1cac498ae$var$xN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fle, "StripContainerCell/lambda$3$Type", 1629);
$61de1ee1cac498ae$var$bcb(462, 22, {
    3: 1,
    35: 1,
    22: 1,
    462: 1
}, $61de1ee1cac498ae$var$FIb);
var $61de1ee1cac498ae$var$BIb, $61de1ee1cac498ae$var$CIb, $61de1ee1cac498ae$var$DIb;
var $61de1ee1cac498ae$var$zN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$fle, "VerticalLabelAlignment", 462, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$HIb, $61de1ee1cac498ae$var$GIb);
var $61de1ee1cac498ae$var$IIb;
$61de1ee1cac498ae$var$bcb(789, 1, {}, $61de1ee1cac498ae$var$LIb);
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.k = 0;
$61de1ee1cac498ae$var$_.s = 0;
$61de1ee1cac498ae$var$_.t = 0;
$61de1ee1cac498ae$var$_.v = false;
$61de1ee1cac498ae$var$_.w = 0;
$61de1ee1cac498ae$var$_.D = false;
var $61de1ee1cac498ae$var$CN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$nle, "NodeContext", 789);
$61de1ee1cac498ae$var$bcb(1471, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$OIb);
$61de1ee1cac498ae$var$_.ue = function PIb(a, b) {
    return $61de1ee1cac498ae$var$NIb($61de1ee1cac498ae$var$BD(a, 61), $61de1ee1cac498ae$var$BD(b, 61));
};
$61de1ee1cac498ae$var$_.Fb = function QIb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function RIb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$AN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$nle, "NodeContext/0methodref$comparePortSides$Type", 1471);
$61de1ee1cac498ae$var$bcb(1472, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$SIb);
$61de1ee1cac498ae$var$_.ue = function TIb(a, b) {
    return $61de1ee1cac498ae$var$MIb($61de1ee1cac498ae$var$BD(a, 111), $61de1ee1cac498ae$var$BD(b, 111));
};
$61de1ee1cac498ae$var$_.Fb = function UIb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function VIb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$BN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$nle, "NodeContext/1methodref$comparePortContexts$Type", 1472);
$61de1ee1cac498ae$var$bcb(159, 22, {
    3: 1,
    35: 1,
    22: 1,
    159: 1
}, $61de1ee1cac498ae$var$tJb);
var $61de1ee1cac498ae$var$WIb, $61de1ee1cac498ae$var$XIb, $61de1ee1cac498ae$var$YIb, $61de1ee1cac498ae$var$ZIb, $61de1ee1cac498ae$var$$Ib, $61de1ee1cac498ae$var$_Ib, $61de1ee1cac498ae$var$aJb, $61de1ee1cac498ae$var$bJb, $61de1ee1cac498ae$var$cJb, $61de1ee1cac498ae$var$dJb, $61de1ee1cac498ae$var$eJb, $61de1ee1cac498ae$var$fJb, $61de1ee1cac498ae$var$gJb, $61de1ee1cac498ae$var$hJb, $61de1ee1cac498ae$var$iJb, $61de1ee1cac498ae$var$jJb, $61de1ee1cac498ae$var$kJb, $61de1ee1cac498ae$var$lJb, $61de1ee1cac498ae$var$mJb, $61de1ee1cac498ae$var$nJb, $61de1ee1cac498ae$var$oJb, $61de1ee1cac498ae$var$pJb;
var $61de1ee1cac498ae$var$DN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$nle, "NodeLabelLocation", 159, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$wJb, $61de1ee1cac498ae$var$vJb);
var $61de1ee1cac498ae$var$xJb;
$61de1ee1cac498ae$var$bcb(111, 1, {
    111: 1
}, $61de1ee1cac498ae$var$AJb);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$EN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$nle, "PortContext", 111);
$61de1ee1cac498ae$var$bcb(1476, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$TJb);
$61de1ee1cac498ae$var$_.td = function UJb(a) {
    $61de1ee1cac498ae$var$WHb($61de1ee1cac498ae$var$BD(a, 306));
};
var $61de1ee1cac498ae$var$FN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qle, $61de1ee1cac498ae$var$rle, 1476);
$61de1ee1cac498ae$var$bcb(1477, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$VJb);
$61de1ee1cac498ae$var$_.Mb = function WJb(a) {
    return !!$61de1ee1cac498ae$var$BD(a, 111).c;
};
var $61de1ee1cac498ae$var$GN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qle, $61de1ee1cac498ae$var$sle, 1477);
$61de1ee1cac498ae$var$bcb(1478, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$XJb);
$61de1ee1cac498ae$var$_.td = function YJb(a) {
    $61de1ee1cac498ae$var$WHb($61de1ee1cac498ae$var$BD(a, 111).c);
};
var $61de1ee1cac498ae$var$HN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qle, "LabelPlacer/lambda$2$Type", 1478);
var $61de1ee1cac498ae$var$ZJb;
$61de1ee1cac498ae$var$bcb(1475, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$fKb);
$61de1ee1cac498ae$var$_.td = function gKb(a) {
    $61de1ee1cac498ae$var$$Jb();
    $61de1ee1cac498ae$var$zJb($61de1ee1cac498ae$var$BD(a, 111));
};
var $61de1ee1cac498ae$var$IN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qle, "NodeLabelAndSizeUtilities/lambda$0$Type", 1475);
$61de1ee1cac498ae$var$bcb(790, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$mKb);
$61de1ee1cac498ae$var$_.td = function nKb(a) {
    $61de1ee1cac498ae$var$kKb(this.b, this.c, this.a, $61de1ee1cac498ae$var$BD(a, 181));
};
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$JN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qle, "NodeLabelCellCreator/lambda$0$Type", 790);
$61de1ee1cac498ae$var$bcb(1474, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$tKb);
$61de1ee1cac498ae$var$_.td = function uKb(a) {
    $61de1ee1cac498ae$var$sKb(this.a, $61de1ee1cac498ae$var$BD(a, 181));
};
var $61de1ee1cac498ae$var$KN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qle, "PortContextCreator/lambda$0$Type", 1474);
var $61de1ee1cac498ae$var$BKb;
$61de1ee1cac498ae$var$bcb(1829, 1, {}, $61de1ee1cac498ae$var$VKb);
var $61de1ee1cac498ae$var$MN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ule, "GreedyRectangleStripOverlapRemover", 1829);
$61de1ee1cac498ae$var$bcb(1830, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$XKb);
$61de1ee1cac498ae$var$_.ue = function YKb(a, b) {
    return $61de1ee1cac498ae$var$WKb($61de1ee1cac498ae$var$BD(a, 222), $61de1ee1cac498ae$var$BD(b, 222));
};
$61de1ee1cac498ae$var$_.Fb = function ZKb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function $Kb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$LN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ule, "GreedyRectangleStripOverlapRemover/0methodref$compareByYCoordinate$Type", 1830);
$61de1ee1cac498ae$var$bcb(1786, 1, {}, $61de1ee1cac498ae$var$fLb);
$61de1ee1cac498ae$var$_.a = 5;
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$SN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ule, "RectangleStripOverlapRemover", 1786);
$61de1ee1cac498ae$var$bcb(1787, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$jLb);
$61de1ee1cac498ae$var$_.ue = function kLb(a, b) {
    return $61de1ee1cac498ae$var$gLb($61de1ee1cac498ae$var$BD(a, 222), $61de1ee1cac498ae$var$BD(b, 222));
};
$61de1ee1cac498ae$var$_.Fb = function lLb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function mLb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$NN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ule, "RectangleStripOverlapRemover/0methodref$compareLeftRectangleBorders$Type", 1787);
$61de1ee1cac498ae$var$bcb(1789, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$nLb);
$61de1ee1cac498ae$var$_.ue = function oLb(a, b) {
    return $61de1ee1cac498ae$var$hLb($61de1ee1cac498ae$var$BD(a, 222), $61de1ee1cac498ae$var$BD(b, 222));
};
$61de1ee1cac498ae$var$_.Fb = function pLb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function qLb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$ON = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ule, "RectangleStripOverlapRemover/1methodref$compareRightRectangleBorders$Type", 1789);
$61de1ee1cac498ae$var$bcb(406, 22, {
    3: 1,
    35: 1,
    22: 1,
    406: 1
}, $61de1ee1cac498ae$var$wLb);
var $61de1ee1cac498ae$var$rLb, $61de1ee1cac498ae$var$sLb, $61de1ee1cac498ae$var$tLb, $61de1ee1cac498ae$var$uLb;
var $61de1ee1cac498ae$var$PN = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ule, "RectangleStripOverlapRemover/OverlapRemovalDirection", 406, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$yLb, $61de1ee1cac498ae$var$xLb);
var $61de1ee1cac498ae$var$zLb;
$61de1ee1cac498ae$var$bcb(222, 1, {
    222: 1
}, $61de1ee1cac498ae$var$BLb);
var $61de1ee1cac498ae$var$QN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ule, "RectangleStripOverlapRemover/RectangleNode", 222);
$61de1ee1cac498ae$var$bcb(1788, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$CLb);
$61de1ee1cac498ae$var$_.td = function DLb(a) {
    $61de1ee1cac498ae$var$aLb(this.a, $61de1ee1cac498ae$var$BD(a, 222));
};
var $61de1ee1cac498ae$var$RN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ule, "RectangleStripOverlapRemover/lambda$1$Type", 1788);
$61de1ee1cac498ae$var$bcb(1304, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$GLb);
$61de1ee1cac498ae$var$_.ue = function HLb(a, b) {
    return $61de1ee1cac498ae$var$FLb($61de1ee1cac498ae$var$BD(a, 167), $61de1ee1cac498ae$var$BD(b, 167));
};
$61de1ee1cac498ae$var$_.Fb = function ILb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function JLb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$WN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/CornerCasesGreaterThanRestComparator", 1304);
$61de1ee1cac498ae$var$bcb(1307, 1, {}, $61de1ee1cac498ae$var$KLb);
$61de1ee1cac498ae$var$_.Kb = function LLb(a) {
    return $61de1ee1cac498ae$var$BD(a, 324).a;
};
var $61de1ee1cac498ae$var$TN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/CornerCasesGreaterThanRestComparator/lambda$0$Type", 1307);
$61de1ee1cac498ae$var$bcb(1308, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$MLb);
$61de1ee1cac498ae$var$_.Mb = function NLb(a) {
    return $61de1ee1cac498ae$var$BD(a, 323).a;
};
var $61de1ee1cac498ae$var$UN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/CornerCasesGreaterThanRestComparator/lambda$1$Type", 1308);
$61de1ee1cac498ae$var$bcb(1309, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$OLb);
$61de1ee1cac498ae$var$_.Mb = function PLb(a) {
    return $61de1ee1cac498ae$var$BD(a, 323).a;
};
var $61de1ee1cac498ae$var$VN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/CornerCasesGreaterThanRestComparator/lambda$2$Type", 1309);
$61de1ee1cac498ae$var$bcb(1302, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$RLb);
$61de1ee1cac498ae$var$_.ue = function SLb(a, b) {
    return $61de1ee1cac498ae$var$QLb($61de1ee1cac498ae$var$BD(a, 167), $61de1ee1cac498ae$var$BD(b, 167));
};
$61de1ee1cac498ae$var$_.Fb = function TLb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function ULb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$YN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/MinNumOfExtensionDirectionsComparator", 1302);
$61de1ee1cac498ae$var$bcb(1305, 1, {}, $61de1ee1cac498ae$var$VLb);
$61de1ee1cac498ae$var$_.Kb = function WLb(a) {
    return $61de1ee1cac498ae$var$BD(a, 324).a;
};
var $61de1ee1cac498ae$var$XN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/MinNumOfExtensionDirectionsComparator/lambda$0$Type", 1305);
$61de1ee1cac498ae$var$bcb(767, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$YLb);
$61de1ee1cac498ae$var$_.ue = function ZLb(a, b) {
    return $61de1ee1cac498ae$var$XLb($61de1ee1cac498ae$var$BD(a, 167), $61de1ee1cac498ae$var$BD(b, 167));
};
$61de1ee1cac498ae$var$_.Fb = function $Lb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function _Lb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$ZN = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/MinNumOfExtensionsComparator", 767);
$61de1ee1cac498ae$var$bcb(1300, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$bMb);
$61de1ee1cac498ae$var$_.ue = function cMb(a, b) {
    return $61de1ee1cac498ae$var$aMb($61de1ee1cac498ae$var$BD(a, 321), $61de1ee1cac498ae$var$BD(b, 321));
};
$61de1ee1cac498ae$var$_.Fb = function dMb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function eMb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$_N = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/MinPerimeterComparator", 1300);
$61de1ee1cac498ae$var$bcb(1301, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$gMb);
$61de1ee1cac498ae$var$_.ue = function hMb(a, b) {
    return $61de1ee1cac498ae$var$fMb($61de1ee1cac498ae$var$BD(a, 321), $61de1ee1cac498ae$var$BD(b, 321));
};
$61de1ee1cac498ae$var$_.Fb = function iMb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function jMb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$$N = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/MinPerimeterComparatorWithShape", 1301);
$61de1ee1cac498ae$var$bcb(1303, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$lMb);
$61de1ee1cac498ae$var$_.ue = function mMb(a, b) {
    return $61de1ee1cac498ae$var$kMb($61de1ee1cac498ae$var$BD(a, 167), $61de1ee1cac498ae$var$BD(b, 167));
};
$61de1ee1cac498ae$var$_.Fb = function nMb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function oMb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$bO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/SingleExtensionSideGreaterThanRestComparator", 1303);
$61de1ee1cac498ae$var$bcb(1306, 1, {}, $61de1ee1cac498ae$var$pMb);
$61de1ee1cac498ae$var$_.Kb = function qMb(a) {
    return $61de1ee1cac498ae$var$BD(a, 324).a;
};
var $61de1ee1cac498ae$var$aO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "PolyominoCompactor/SingleExtensionSideGreaterThanRestComparator/lambda$0$Type", 1306);
$61de1ee1cac498ae$var$bcb(777, 1, {}, $61de1ee1cac498ae$var$tMb);
$61de1ee1cac498ae$var$_.Ce = function uMb(a, b) {
    return $61de1ee1cac498ae$var$sMb(this, $61de1ee1cac498ae$var$BD(a, 46), $61de1ee1cac498ae$var$BD(b, 167));
};
var $61de1ee1cac498ae$var$cO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "SuccessorCombination", 777);
$61de1ee1cac498ae$var$bcb(644, 1, {}, $61de1ee1cac498ae$var$wMb);
$61de1ee1cac498ae$var$_.Ce = function xMb(a, b) {
    var c;
    return $61de1ee1cac498ae$var$vMb((c = $61de1ee1cac498ae$var$BD(a, 46), $61de1ee1cac498ae$var$BD(b, 167), c));
};
var $61de1ee1cac498ae$var$dO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "SuccessorJitter", 644);
$61de1ee1cac498ae$var$bcb(643, 1, {}, $61de1ee1cac498ae$var$zMb);
$61de1ee1cac498ae$var$_.Ce = function AMb(a, b) {
    var c;
    return $61de1ee1cac498ae$var$yMb((c = $61de1ee1cac498ae$var$BD(a, 46), $61de1ee1cac498ae$var$BD(b, 167), c));
};
var $61de1ee1cac498ae$var$eO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "SuccessorLineByLine", 643);
$61de1ee1cac498ae$var$bcb(568, 1, {}, $61de1ee1cac498ae$var$CMb);
$61de1ee1cac498ae$var$_.Ce = function DMb(a, b) {
    var c;
    return $61de1ee1cac498ae$var$BMb((c = $61de1ee1cac498ae$var$BD(a, 46), $61de1ee1cac498ae$var$BD(b, 167), c));
};
var $61de1ee1cac498ae$var$fO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "SuccessorManhattan", 568);
$61de1ee1cac498ae$var$bcb(1356, 1, {}, $61de1ee1cac498ae$var$FMb);
$61de1ee1cac498ae$var$_.Ce = function GMb(a, b) {
    var c;
    return $61de1ee1cac498ae$var$EMb((c = $61de1ee1cac498ae$var$BD(a, 46), $61de1ee1cac498ae$var$BD(b, 167), c));
};
var $61de1ee1cac498ae$var$gO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "SuccessorMaxNormWindingInMathPosSense", 1356);
$61de1ee1cac498ae$var$bcb(400, 1, {}, $61de1ee1cac498ae$var$JMb);
$61de1ee1cac498ae$var$_.Ce = function KMb(a, b) {
    return $61de1ee1cac498ae$var$HMb(this, a, b);
};
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = false;
$61de1ee1cac498ae$var$_.e = false;
$61de1ee1cac498ae$var$_.f = false;
var $61de1ee1cac498ae$var$iO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "SuccessorQuadrantsGeneric", 400);
$61de1ee1cac498ae$var$bcb(1357, 1, {}, $61de1ee1cac498ae$var$LMb);
$61de1ee1cac498ae$var$_.Kb = function MMb(a) {
    return $61de1ee1cac498ae$var$BD(a, 324).a;
};
var $61de1ee1cac498ae$var$hO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$wle, "SuccessorQuadrantsGeneric/lambda$0$Type", 1357);
$61de1ee1cac498ae$var$bcb(323, 22, {
    3: 1,
    35: 1,
    22: 1,
    323: 1
}, $61de1ee1cac498ae$var$SMb);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$NMb, $61de1ee1cac498ae$var$OMb, $61de1ee1cac498ae$var$PMb, $61de1ee1cac498ae$var$QMb;
var $61de1ee1cac498ae$var$jO = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ble, $61de1ee1cac498ae$var$Cle, 323, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$UMb, $61de1ee1cac498ae$var$TMb);
var $61de1ee1cac498ae$var$VMb;
$61de1ee1cac498ae$var$bcb(1298, 1, {});
$61de1ee1cac498ae$var$_.Ib = function bNb() {
    var a, b, c, d, e, f;
    c = " ";
    a = $61de1ee1cac498ae$var$meb(0);
    for(e = 0; e < this.o; e++){
        c += "" + a.a;
        a = $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$XMb(a.a));
    }
    c += "\n";
    a = $61de1ee1cac498ae$var$meb(0);
    for(f = 0; f < this.p; f++){
        c += "" + a.a;
        a = $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$XMb(a.a));
        for(d = 0; d < this.o; d++){
            b = $61de1ee1cac498ae$var$_Mb(this, d, f);
            $61de1ee1cac498ae$var$ybb(b, 0) == 0 ? c += "_" : $61de1ee1cac498ae$var$ybb(b, 1) == 0 ? c += "X" : c += "0";
        }
        c += "\n";
    }
    return $61de1ee1cac498ae$var$qfb(c, 0, c.length - 1);
};
$61de1ee1cac498ae$var$_.o = 0;
$61de1ee1cac498ae$var$_.p = 0;
var $61de1ee1cac498ae$var$nO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ble, "TwoBitGrid", 1298);
$61de1ee1cac498ae$var$bcb(321, 1298, {
    321: 1
}, $61de1ee1cac498ae$var$pNb);
$61de1ee1cac498ae$var$_.j = 0;
$61de1ee1cac498ae$var$_.k = 0;
var $61de1ee1cac498ae$var$kO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ble, "PlanarGrid", 321);
$61de1ee1cac498ae$var$bcb(167, 321, {
    321: 1,
    167: 1
});
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
var $61de1ee1cac498ae$var$lO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ble, "Polyomino", 167);
var $61de1ee1cac498ae$var$P3 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Hle, $61de1ee1cac498ae$var$Ile);
$61de1ee1cac498ae$var$bcb(134, 1, $61de1ee1cac498ae$var$Jle, $61de1ee1cac498ae$var$zNb);
$61de1ee1cac498ae$var$_.Ye = function DNb(a, b) {
    return $61de1ee1cac498ae$var$xNb(this, a, b);
};
$61de1ee1cac498ae$var$_.Ve = function ANb() {
    return $61de1ee1cac498ae$var$uNb(this);
};
$61de1ee1cac498ae$var$_.We = function BNb(a) {
    return $61de1ee1cac498ae$var$vNb(this, a);
};
$61de1ee1cac498ae$var$_.Xe = function CNb(a) {
    return $61de1ee1cac498ae$var$wNb(this, a);
};
var $61de1ee1cac498ae$var$R3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hle, "MapPropertyHolder", 134);
$61de1ee1cac498ae$var$bcb(1299, 134, $61de1ee1cac498ae$var$Jle, $61de1ee1cac498ae$var$ENb);
var $61de1ee1cac498ae$var$mO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ble, "Polyominoes", 1299);
var $61de1ee1cac498ae$var$FNb = false, $61de1ee1cac498ae$var$GNb, $61de1ee1cac498ae$var$HNb;
$61de1ee1cac498ae$var$bcb(1766, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$PNb);
$61de1ee1cac498ae$var$_.td = function QNb(a) {
    $61de1ee1cac498ae$var$JNb($61de1ee1cac498ae$var$BD(a, 221));
};
var $61de1ee1cac498ae$var$oO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "DepthFirstCompaction/0methodref$compactTree$Type", 1766);
$61de1ee1cac498ae$var$bcb(810, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$RNb);
$61de1ee1cac498ae$var$_.td = function SNb(a) {
    $61de1ee1cac498ae$var$MNb(this.a, $61de1ee1cac498ae$var$BD(a, 221));
};
var $61de1ee1cac498ae$var$pO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "DepthFirstCompaction/lambda$1$Type", 810);
$61de1ee1cac498ae$var$bcb(1767, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$TNb);
$61de1ee1cac498ae$var$_.td = function UNb(a) {
    $61de1ee1cac498ae$var$NNb(this.a, this.b, this.c, $61de1ee1cac498ae$var$BD(a, 221));
};
var $61de1ee1cac498ae$var$qO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "DepthFirstCompaction/lambda$2$Type", 1767);
var $61de1ee1cac498ae$var$VNb, $61de1ee1cac498ae$var$WNb;
$61de1ee1cac498ae$var$bcb(65, 1, {
    65: 1
}, $61de1ee1cac498ae$var$aOb);
var $61de1ee1cac498ae$var$rO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "Node", 65);
$61de1ee1cac498ae$var$bcb(1250, 1, {}, $61de1ee1cac498ae$var$dOb);
var $61de1ee1cac498ae$var$wO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "ScanlineOverlapCheck", 1250);
$61de1ee1cac498ae$var$bcb(1251, 1, {
    679: 1
}, $61de1ee1cac498ae$var$hOb);
$61de1ee1cac498ae$var$_.Ke = function iOb(a) {
    $61de1ee1cac498ae$var$fOb(this, $61de1ee1cac498ae$var$BD(a, 440));
};
var $61de1ee1cac498ae$var$tO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "ScanlineOverlapCheck/OverlapsScanlineHandler", 1251);
$61de1ee1cac498ae$var$bcb(1252, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$kOb);
$61de1ee1cac498ae$var$_.ue = function lOb(a, b) {
    return $61de1ee1cac498ae$var$jOb($61de1ee1cac498ae$var$BD(a, 65), $61de1ee1cac498ae$var$BD(b, 65));
};
$61de1ee1cac498ae$var$_.Fb = function mOb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function nOb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$sO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "ScanlineOverlapCheck/OverlapsScanlineHandler/lambda$0$Type", 1252);
$61de1ee1cac498ae$var$bcb(440, 1, {
    440: 1
}, $61de1ee1cac498ae$var$oOb);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$uO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "ScanlineOverlapCheck/Timestamp", 440);
$61de1ee1cac498ae$var$bcb(1253, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$pOb);
$61de1ee1cac498ae$var$_.ue = function qOb(a, b) {
    return $61de1ee1cac498ae$var$eOb($61de1ee1cac498ae$var$BD(a, 440), $61de1ee1cac498ae$var$BD(b, 440));
};
$61de1ee1cac498ae$var$_.Fb = function rOb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function sOb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$vO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kle, "ScanlineOverlapCheck/lambda$0$Type", 1253);
$61de1ee1cac498ae$var$bcb(550, 1, {}, $61de1ee1cac498ae$var$tOb);
var $61de1ee1cac498ae$var$xO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lle, "SVGImage", 550);
$61de1ee1cac498ae$var$bcb(324, 1, {
    324: 1
}, $61de1ee1cac498ae$var$uOb);
$61de1ee1cac498ae$var$_.Ib = function vOb() {
    return "(" + this.a + $61de1ee1cac498ae$var$She + this.b + $61de1ee1cac498ae$var$She + this.c + ")";
};
var $61de1ee1cac498ae$var$yO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lle, "UniqueTriple", 324);
$61de1ee1cac498ae$var$bcb(209, 1, $61de1ee1cac498ae$var$Mle);
var $61de1ee1cac498ae$var$g0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "AbstractLayoutProvider", 209);
$61de1ee1cac498ae$var$bcb(1132, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$yOb);
$61de1ee1cac498ae$var$_.Ze = function zOb(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Odd(b, $61de1ee1cac498ae$var$Ole, 1);
    this.a = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$CPb(), $61de1ee1cac498ae$var$BPb))));
    if ($61de1ee1cac498ae$var$ikd(a, $61de1ee1cac498ae$var$rPb)) {
        e = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$rPb));
        c = $61de1ee1cac498ae$var$h4c($61de1ee1cac498ae$var$n4c(), e);
        if (c) {
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hgd(c.f), 209);
            d.Ze(a, $61de1ee1cac498ae$var$Udd(b, 1));
        }
    }
    f = new $61de1ee1cac498ae$var$AQb(this.a);
    this.b = $61de1ee1cac498ae$var$yQb(f, a);
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$nPb(), $61de1ee1cac498ae$var$jPb)), 481).g){
        case 0:
            $61de1ee1cac498ae$var$BOb(new $61de1ee1cac498ae$var$FOb, this.b);
            $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$uPb, $61de1ee1cac498ae$var$vNb(this.b, $61de1ee1cac498ae$var$uPb));
            break;
        default:
            $61de1ee1cac498ae$var$Zfb();
    }
    $61de1ee1cac498ae$var$qQb(f);
    $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$tPb, this.b);
    $61de1ee1cac498ae$var$Qdd(b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$zO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ple, "DisCoLayoutProvider", 1132);
$61de1ee1cac498ae$var$bcb(1244, 1, {}, $61de1ee1cac498ae$var$FOb);
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$AO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ple, "DisCoPolyominoCompactor", 1244);
$61de1ee1cac498ae$var$bcb(561, 1, {
    561: 1
}, $61de1ee1cac498ae$var$MOb);
$61de1ee1cac498ae$var$_.b = true;
var $61de1ee1cac498ae$var$BO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qle, "DCComponent", 561);
$61de1ee1cac498ae$var$bcb(394, 22, {
    3: 1,
    35: 1,
    22: 1,
    394: 1
}, $61de1ee1cac498ae$var$SOb);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$NOb, $61de1ee1cac498ae$var$OOb, $61de1ee1cac498ae$var$POb, $61de1ee1cac498ae$var$QOb;
var $61de1ee1cac498ae$var$CO = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Qle, "DCDirection", 394, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$UOb, $61de1ee1cac498ae$var$TOb);
var $61de1ee1cac498ae$var$VOb;
$61de1ee1cac498ae$var$bcb(266, 134, {
    3: 1,
    266: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$XOb);
var $61de1ee1cac498ae$var$DO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qle, "DCElement", 266);
$61de1ee1cac498ae$var$bcb(395, 1, {
    395: 1
}, $61de1ee1cac498ae$var$ZOb);
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$EO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qle, "DCExtension", 395);
$61de1ee1cac498ae$var$bcb(755, 134, $61de1ee1cac498ae$var$Jle, $61de1ee1cac498ae$var$aPb);
var $61de1ee1cac498ae$var$FO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qle, "DCGraph", 755);
$61de1ee1cac498ae$var$bcb(481, 22, {
    3: 1,
    35: 1,
    22: 1,
    481: 1
}, $61de1ee1cac498ae$var$dPb);
var $61de1ee1cac498ae$var$bPb;
var $61de1ee1cac498ae$var$GO = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Rle, $61de1ee1cac498ae$var$Sle, 481, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$fPb, $61de1ee1cac498ae$var$ePb);
var $61de1ee1cac498ae$var$gPb;
$61de1ee1cac498ae$var$bcb(854, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$oPb);
$61de1ee1cac498ae$var$_.Qe = function pPb(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Tle), $61de1ee1cac498ae$var$Xle), "Connected Components Compaction Strategy"), "Strategy for packing different connected components in order to save space and enhance readability of a graph."), $61de1ee1cac498ae$var$kPb), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$V5c)), $61de1ee1cac498ae$var$GO), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$L5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ule), $61de1ee1cac498ae$var$Xle), "Connected Components Layout Algorithm"), "A layout algorithm that is to be applied to each connected component before the components themselves are compacted. If unspecified, the positions of the components' nodes are not altered."), $61de1ee1cac498ae$var$Z5c), $61de1ee1cac498ae$var$ZI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Vle), "debug"), "DCGraph"), "Access to the DCGraph is intended for the debug view,"), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$SI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Wle), "debug"), "List of Polyominoes"), "Access to the polyominoes is intended for the debug view,"), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$SI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$DPb((new $61de1ee1cac498ae$var$EPb, a));
};
var $61de1ee1cac498ae$var$iPb, $61de1ee1cac498ae$var$jPb, $61de1ee1cac498ae$var$kPb, $61de1ee1cac498ae$var$lPb, $61de1ee1cac498ae$var$mPb;
var $61de1ee1cac498ae$var$HO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rle, "DisCoMetaDataProvider", 854);
$61de1ee1cac498ae$var$bcb(998, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$EPb);
$61de1ee1cac498ae$var$_.Qe = function FPb(a) {
    $61de1ee1cac498ae$var$DPb(a);
};
var $61de1ee1cac498ae$var$qPb, $61de1ee1cac498ae$var$rPb, $61de1ee1cac498ae$var$sPb, $61de1ee1cac498ae$var$tPb, $61de1ee1cac498ae$var$uPb, $61de1ee1cac498ae$var$vPb, $61de1ee1cac498ae$var$wPb, $61de1ee1cac498ae$var$xPb, $61de1ee1cac498ae$var$yPb, $61de1ee1cac498ae$var$zPb, $61de1ee1cac498ae$var$APb, $61de1ee1cac498ae$var$BPb;
var $61de1ee1cac498ae$var$JO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rle, "DisCoOptions", 998);
$61de1ee1cac498ae$var$bcb(999, 1, {}, $61de1ee1cac498ae$var$GPb);
$61de1ee1cac498ae$var$_.$e = function HPb() {
    var a;
    return a = new $61de1ee1cac498ae$var$yOb, a;
};
$61de1ee1cac498ae$var$_._e = function IPb(a) {};
var $61de1ee1cac498ae$var$IO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rle, "DisCoOptions/DiscoFactory", 999);
$61de1ee1cac498ae$var$bcb(562, 167, {
    321: 1,
    167: 1,
    562: 1
}, $61de1ee1cac498ae$var$MPb);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$KO = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.disco.structures", "DCPolyomino", 562);
var $61de1ee1cac498ae$var$NPb, $61de1ee1cac498ae$var$OPb, $61de1ee1cac498ae$var$PPb;
$61de1ee1cac498ae$var$bcb(1268, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$aQb);
$61de1ee1cac498ae$var$_.Mb = function bQb(a) {
    return $61de1ee1cac498ae$var$_Pb(a);
};
var $61de1ee1cac498ae$var$LO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphComponentsProcessor/lambda$0$Type", 1268);
$61de1ee1cac498ae$var$bcb(1269, 1, {}, $61de1ee1cac498ae$var$cQb);
$61de1ee1cac498ae$var$_.Kb = function dQb(a) {
    return $61de1ee1cac498ae$var$QPb(), $61de1ee1cac498ae$var$jtd($61de1ee1cac498ae$var$BD(a, 79));
};
var $61de1ee1cac498ae$var$MO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphComponentsProcessor/lambda$1$Type", 1269);
$61de1ee1cac498ae$var$bcb(1270, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$eQb);
$61de1ee1cac498ae$var$_.Mb = function fQb(a) {
    return $61de1ee1cac498ae$var$WPb($61de1ee1cac498ae$var$BD(a, 79));
};
var $61de1ee1cac498ae$var$NO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphComponentsProcessor/lambda$2$Type", 1270);
$61de1ee1cac498ae$var$bcb(1271, 1, {}, $61de1ee1cac498ae$var$gQb);
$61de1ee1cac498ae$var$_.Kb = function hQb(a) {
    return $61de1ee1cac498ae$var$QPb(), $61de1ee1cac498ae$var$ltd($61de1ee1cac498ae$var$BD(a, 79));
};
var $61de1ee1cac498ae$var$OO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphComponentsProcessor/lambda$3$Type", 1271);
$61de1ee1cac498ae$var$bcb(1272, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$iQb);
$61de1ee1cac498ae$var$_.Mb = function jQb(a) {
    return $61de1ee1cac498ae$var$XPb($61de1ee1cac498ae$var$BD(a, 79));
};
var $61de1ee1cac498ae$var$PO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphComponentsProcessor/lambda$4$Type", 1272);
$61de1ee1cac498ae$var$bcb(1273, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$kQb);
$61de1ee1cac498ae$var$_.Mb = function lQb(a) {
    return $61de1ee1cac498ae$var$YPb(this.a, $61de1ee1cac498ae$var$BD(a, 79));
};
var $61de1ee1cac498ae$var$QO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphComponentsProcessor/lambda$5$Type", 1273);
$61de1ee1cac498ae$var$bcb(1274, 1, {}, $61de1ee1cac498ae$var$mQb);
$61de1ee1cac498ae$var$_.Kb = function nQb(a) {
    return $61de1ee1cac498ae$var$ZPb(this.a, $61de1ee1cac498ae$var$BD(a, 79));
};
var $61de1ee1cac498ae$var$RO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphComponentsProcessor/lambda$6$Type", 1274);
$61de1ee1cac498ae$var$bcb(1241, 1, {}, $61de1ee1cac498ae$var$AQb);
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$UO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphTransformer", 1241);
$61de1ee1cac498ae$var$bcb(1242, 1, {}, $61de1ee1cac498ae$var$CQb);
$61de1ee1cac498ae$var$_.Od = function DQb(a, b) {
    $61de1ee1cac498ae$var$BQb(this, $61de1ee1cac498ae$var$BD(a, 160), $61de1ee1cac498ae$var$BD(b, 266));
};
var $61de1ee1cac498ae$var$TO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphTransformer/OffsetApplier", 1242);
$61de1ee1cac498ae$var$bcb(1243, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$FQb);
$61de1ee1cac498ae$var$_.td = function GQb(a) {
    $61de1ee1cac498ae$var$EQb(this, $61de1ee1cac498ae$var$BD(a, 8));
};
var $61de1ee1cac498ae$var$SO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bme, "ElkGraphTransformer/OffsetApplier/OffSetToChainApplier", 1243);
$61de1ee1cac498ae$var$bcb(753, 1, {}, $61de1ee1cac498ae$var$MQb);
var $61de1ee1cac498ae$var$WO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$gme, $61de1ee1cac498ae$var$hme, 753);
$61de1ee1cac498ae$var$bcb(1232, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$OQb);
$61de1ee1cac498ae$var$_.ue = function PQb(a, b) {
    return $61de1ee1cac498ae$var$NQb($61de1ee1cac498ae$var$BD(a, 231), $61de1ee1cac498ae$var$BD(b, 231));
};
$61de1ee1cac498ae$var$_.Fb = function QQb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function RQb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$VO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$gme, $61de1ee1cac498ae$var$ime, 1232);
$61de1ee1cac498ae$var$bcb(740, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$ZQb);
$61de1ee1cac498ae$var$_.Ze = function $Qb(a, b) {
    $61de1ee1cac498ae$var$WQb(this, a, b);
};
var $61de1ee1cac498ae$var$XO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$gme, "ForceLayoutProvider", 740);
$61de1ee1cac498ae$var$bcb(357, 134, {
    3: 1,
    357: 1,
    94: 1,
    134: 1
});
var $61de1ee1cac498ae$var$bP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jme, "FParticle", 357);
$61de1ee1cac498ae$var$bcb(559, 357, {
    3: 1,
    559: 1,
    357: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$aRb);
$61de1ee1cac498ae$var$_.Ib = function bRb() {
    var a;
    if (this.a) {
        a = $61de1ee1cac498ae$var$Jkb(this.a.a, this, 0);
        return a >= 0 ? "b" + a + "[" + $61de1ee1cac498ae$var$fRb(this.a) + "]" : "b[" + $61de1ee1cac498ae$var$fRb(this.a) + "]";
    }
    return "b_" + $61de1ee1cac498ae$var$FCb(this);
};
var $61de1ee1cac498ae$var$YO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jme, "FBendpoint", 559);
$61de1ee1cac498ae$var$bcb(282, 134, {
    3: 1,
    282: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$gRb);
$61de1ee1cac498ae$var$_.Ib = function hRb() {
    return $61de1ee1cac498ae$var$fRb(this);
};
var $61de1ee1cac498ae$var$ZO = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jme, "FEdge", 282);
$61de1ee1cac498ae$var$bcb(231, 134, {
    3: 1,
    231: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$kRb);
var $61de1ee1cac498ae$var$$O = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jme, "FGraph", 231);
$61de1ee1cac498ae$var$bcb(447, 357, {
    3: 1,
    447: 1,
    357: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$mRb);
$61de1ee1cac498ae$var$_.Ib = function nRb() {
    return this.b == null || this.b.length == 0 ? "l[" + $61de1ee1cac498ae$var$fRb(this.a) + "]" : "l_" + this.b;
};
var $61de1ee1cac498ae$var$_O = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jme, "FLabel", 447);
$61de1ee1cac498ae$var$bcb(144, 357, {
    3: 1,
    144: 1,
    357: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$pRb);
$61de1ee1cac498ae$var$_.Ib = function qRb() {
    return $61de1ee1cac498ae$var$oRb(this);
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$aP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jme, "FNode", 144);
$61de1ee1cac498ae$var$bcb(2003, 1, {});
$61de1ee1cac498ae$var$_.bf = function vRb(a) {
    $61de1ee1cac498ae$var$rRb(this, a);
};
$61de1ee1cac498ae$var$_.cf = function wRb() {
    $61de1ee1cac498ae$var$sRb(this);
};
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$cP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$lme, "AbstractForceModel", 2003);
$61de1ee1cac498ae$var$bcb(631, 2003, {
    631: 1
}, $61de1ee1cac498ae$var$xRb);
$61de1ee1cac498ae$var$_.af = function zRb(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$uRb(this.f, a, b);
    e = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(b.d), a.d);
    g = $61de1ee1cac498ae$var$$wnd.Math.sqrt(e.a * e.a + e.b * e.b);
    d = $61de1ee1cac498ae$var$$wnd.Math.max(0, g - $61de1ee1cac498ae$var$U6c(a.e) / 2 - $61de1ee1cac498ae$var$U6c(b.e) / 2);
    c = $61de1ee1cac498ae$var$jRb(this.e, a, b);
    c > 0 ? f = -$61de1ee1cac498ae$var$yRb(d, this.c) * c : f = $61de1ee1cac498ae$var$CRb(d, this.b) * $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$oSb)), 19).a;
    $61de1ee1cac498ae$var$Y6c(e, f / g);
    return e;
};
$61de1ee1cac498ae$var$_.bf = function ARb(a) {
    $61de1ee1cac498ae$var$rRb(this, a);
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$eSb)), 19).a;
    this.c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$uSb)));
    this.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$qSb)));
};
$61de1ee1cac498ae$var$_.df = function BRb(a) {
    return a < this.a;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$dP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$lme, "EadesModel", 631);
$61de1ee1cac498ae$var$bcb(632, 2003, {
    632: 1
}, $61de1ee1cac498ae$var$DRb);
$61de1ee1cac498ae$var$_.af = function FRb(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$uRb(this.f, a, b);
    e = $61de1ee1cac498ae$var$c7c($61de1ee1cac498ae$var$R6c(b.d), a.d);
    g = $61de1ee1cac498ae$var$$wnd.Math.sqrt(e.a * e.a + e.b * e.b);
    d = $61de1ee1cac498ae$var$$wnd.Math.max(0, g - $61de1ee1cac498ae$var$U6c(a.e) / 2 - $61de1ee1cac498ae$var$U6c(b.e) / 2);
    f = $61de1ee1cac498ae$var$JRb(d, this.a) * $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$oSb)), 19).a;
    c = $61de1ee1cac498ae$var$jRb(this.e, a, b);
    c > 0 && (f -= $61de1ee1cac498ae$var$ERb(d, this.a) * c);
    $61de1ee1cac498ae$var$Y6c(e, f * this.b / g);
    return e;
};
$61de1ee1cac498ae$var$_.bf = function GRb(a) {
    var b, c, d, e, f, g, h;
    $61de1ee1cac498ae$var$rRb(this, a);
    this.b = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wSb(), $61de1ee1cac498ae$var$vSb))));
    this.c = this.b / $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$eSb), 19).a;
    d = a.e.c.length;
    f = 0;
    e = 0;
    for(h = new $61de1ee1cac498ae$var$olb(a.e); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 144);
        f += g.e.a;
        e += g.e.b;
    }
    b = f * e;
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(a, $61de1ee1cac498ae$var$uSb))) * $61de1ee1cac498ae$var$ple;
    this.a = $61de1ee1cac498ae$var$$wnd.Math.sqrt(b / (2 * d)) * c;
};
$61de1ee1cac498ae$var$_.cf = function HRb() {
    $61de1ee1cac498ae$var$sRb(this);
    this.b -= this.c;
};
$61de1ee1cac498ae$var$_.df = function IRb(a) {
    return this.b > 0;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$eP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$lme, "FruchtermanReingoldModel", 632);
$61de1ee1cac498ae$var$bcb(849, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$TRb);
$61de1ee1cac498ae$var$_.Qe = function URb(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$mme), ""), "Force Model"), "Determines the model for force calculation."), $61de1ee1cac498ae$var$MRb), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$V5c)), $61de1ee1cac498ae$var$gP), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$L5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$nme), ""), "Iterations"), "The number of iterations on the force model."), $61de1ee1cac498ae$var$meb(300)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ome), ""), "Repulsive Power"), "Determines how many bend points are added to the edge; such bend points are regarded as repelling particles in the force model"), $61de1ee1cac498ae$var$meb(0)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$pme), ""), "FR Temperature"), "The temperature is used as a scaling factor for particle displacements."), $61de1ee1cac498ae$var$qme), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$pme, $61de1ee1cac498ae$var$mme, $61de1ee1cac498ae$var$RRb);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$rme), ""), "Eades Repulsion"), "Factor for repulsive forces in Eades' model."), 5), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$rme, $61de1ee1cac498ae$var$mme, $61de1ee1cac498ae$var$ORb);
    $61de1ee1cac498ae$var$xSb((new $61de1ee1cac498ae$var$ySb, a));
};
var $61de1ee1cac498ae$var$KRb, $61de1ee1cac498ae$var$LRb, $61de1ee1cac498ae$var$MRb, $61de1ee1cac498ae$var$NRb, $61de1ee1cac498ae$var$ORb, $61de1ee1cac498ae$var$PRb, $61de1ee1cac498ae$var$QRb, $61de1ee1cac498ae$var$RRb;
var $61de1ee1cac498ae$var$fP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$sme, "ForceMetaDataProvider", 849);
$61de1ee1cac498ae$var$bcb(424, 22, {
    3: 1,
    35: 1,
    22: 1,
    424: 1
}, $61de1ee1cac498ae$var$YRb);
var $61de1ee1cac498ae$var$VRb, $61de1ee1cac498ae$var$WRb;
var $61de1ee1cac498ae$var$gP = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$sme, "ForceModelStrategy", 424, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$$Rb, $61de1ee1cac498ae$var$ZRb);
var $61de1ee1cac498ae$var$_Rb;
$61de1ee1cac498ae$var$bcb(988, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$ySb);
$61de1ee1cac498ae$var$_.Qe = function zSb(a) {
    $61de1ee1cac498ae$var$xSb(a);
};
var $61de1ee1cac498ae$var$bSb, $61de1ee1cac498ae$var$cSb, $61de1ee1cac498ae$var$dSb, $61de1ee1cac498ae$var$eSb, $61de1ee1cac498ae$var$fSb, $61de1ee1cac498ae$var$gSb, $61de1ee1cac498ae$var$hSb, $61de1ee1cac498ae$var$iSb, $61de1ee1cac498ae$var$jSb, $61de1ee1cac498ae$var$kSb, $61de1ee1cac498ae$var$lSb, $61de1ee1cac498ae$var$mSb, $61de1ee1cac498ae$var$nSb, $61de1ee1cac498ae$var$oSb, $61de1ee1cac498ae$var$pSb, $61de1ee1cac498ae$var$qSb, $61de1ee1cac498ae$var$rSb, $61de1ee1cac498ae$var$sSb, $61de1ee1cac498ae$var$tSb, $61de1ee1cac498ae$var$uSb, $61de1ee1cac498ae$var$vSb;
var $61de1ee1cac498ae$var$iP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$sme, "ForceOptions", 988);
$61de1ee1cac498ae$var$bcb(989, 1, {}, $61de1ee1cac498ae$var$ASb);
$61de1ee1cac498ae$var$_.$e = function BSb() {
    var a;
    return a = new $61de1ee1cac498ae$var$ZQb, a;
};
$61de1ee1cac498ae$var$_._e = function CSb(a) {};
var $61de1ee1cac498ae$var$hP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$sme, "ForceOptions/ForceFactory", 989);
var $61de1ee1cac498ae$var$DSb, $61de1ee1cac498ae$var$ESb, $61de1ee1cac498ae$var$FSb, $61de1ee1cac498ae$var$GSb;
$61de1ee1cac498ae$var$bcb(850, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$PSb);
$61de1ee1cac498ae$var$_.Qe = function QSb(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Mme), ""), "Fixed Position"), "Prevent that the node is moved by the layout algorithm."), ($61de1ee1cac498ae$var$Bcb(), false)), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$T5c)), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$K5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Nme), ""), "Desired Edge Length"), "Either specified for parent nodes or for individual edges, where the latter takes higher precedence."), 100), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$I5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ome), ""), "Layout Dimension"), "Dimensions that are permitted to be altered during layout."), $61de1ee1cac498ae$var$KSb), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$oP), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Pme), ""), "Stress Epsilon"), "Termination criterion for the iterative process."), $61de1ee1cac498ae$var$qme), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Qme), ""), "Iteration Limit"), "Maximum number of performed iterations. Takes higher precedence than 'epsilon'."), $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Ohe)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$cTb((new $61de1ee1cac498ae$var$dTb, a));
};
var $61de1ee1cac498ae$var$ISb, $61de1ee1cac498ae$var$JSb, $61de1ee1cac498ae$var$KSb, $61de1ee1cac498ae$var$LSb, $61de1ee1cac498ae$var$MSb, $61de1ee1cac498ae$var$NSb;
var $61de1ee1cac498ae$var$jP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$sme, "StressMetaDataProvider", 850);
$61de1ee1cac498ae$var$bcb(992, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$dTb);
$61de1ee1cac498ae$var$_.Qe = function eTb(a) {
    $61de1ee1cac498ae$var$cTb(a);
};
var $61de1ee1cac498ae$var$RSb, $61de1ee1cac498ae$var$SSb, $61de1ee1cac498ae$var$TSb, $61de1ee1cac498ae$var$USb, $61de1ee1cac498ae$var$VSb, $61de1ee1cac498ae$var$WSb, $61de1ee1cac498ae$var$XSb, $61de1ee1cac498ae$var$YSb, $61de1ee1cac498ae$var$ZSb, $61de1ee1cac498ae$var$$Sb, $61de1ee1cac498ae$var$_Sb, $61de1ee1cac498ae$var$aTb;
var $61de1ee1cac498ae$var$lP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$sme, "StressOptions", 992);
$61de1ee1cac498ae$var$bcb(993, 1, {}, $61de1ee1cac498ae$var$fTb);
$61de1ee1cac498ae$var$_.$e = function gTb() {
    var a;
    return a = new $61de1ee1cac498ae$var$iTb, a;
};
$61de1ee1cac498ae$var$_._e = function hTb(a) {};
var $61de1ee1cac498ae$var$kP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$sme, "StressOptions/StressFactory", 993);
$61de1ee1cac498ae$var$bcb(1128, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$iTb);
$61de1ee1cac498ae$var$_.Ze = function jTb(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, $61de1ee1cac498ae$var$Sme, 1);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$bTb(), $61de1ee1cac498ae$var$VSb)))) ? $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$_Sb))) || $61de1ee1cac498ae$var$$Cb((c = new $61de1ee1cac498ae$var$_Cb(($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd(a))), c)) : $61de1ee1cac498ae$var$WQb(new $61de1ee1cac498ae$var$ZQb, a, $61de1ee1cac498ae$var$Udd(b, 1));
    e = $61de1ee1cac498ae$var$TQb(a);
    d = $61de1ee1cac498ae$var$LQb(this.a, e);
    for(g = d.Kc(); g.Ob();){
        f = $61de1ee1cac498ae$var$BD(g.Pb(), 231);
        if (f.e.c.length <= 1) continue;
        $61de1ee1cac498ae$var$sTb(this.b, f);
        $61de1ee1cac498ae$var$qTb(this.b);
        $61de1ee1cac498ae$var$Hkb(f.d, new $61de1ee1cac498ae$var$kTb);
    }
    e = $61de1ee1cac498ae$var$KQb(d);
    $61de1ee1cac498ae$var$SQb(e);
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$nP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ume, "StressLayoutProvider", 1128);
$61de1ee1cac498ae$var$bcb(1129, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$kTb);
$61de1ee1cac498ae$var$_.td = function lTb(a) {
    $61de1ee1cac498ae$var$lRb($61de1ee1cac498ae$var$BD(a, 447));
};
var $61de1ee1cac498ae$var$mP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ume, "StressLayoutProvider/lambda$0$Type", 1129);
$61de1ee1cac498ae$var$bcb(990, 1, {}, $61de1ee1cac498ae$var$tTb);
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$qP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ume, "StressMajorization", 990);
$61de1ee1cac498ae$var$bcb(379, 22, {
    3: 1,
    35: 1,
    22: 1,
    379: 1
}, $61de1ee1cac498ae$var$zTb);
var $61de1ee1cac498ae$var$vTb, $61de1ee1cac498ae$var$wTb, $61de1ee1cac498ae$var$xTb;
var $61de1ee1cac498ae$var$oP = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ume, "StressMajorization/Dimension", 379, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$BTb, $61de1ee1cac498ae$var$ATb);
var $61de1ee1cac498ae$var$CTb;
$61de1ee1cac498ae$var$bcb(991, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$ETb);
$61de1ee1cac498ae$var$_.ue = function FTb(a, b) {
    return $61de1ee1cac498ae$var$uTb(this.a, $61de1ee1cac498ae$var$BD(a, 144), $61de1ee1cac498ae$var$BD(b, 144));
};
$61de1ee1cac498ae$var$_.Fb = function GTb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function HTb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$pP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ume, "StressMajorization/lambda$0$Type", 991);
$61de1ee1cac498ae$var$bcb(1229, 1, {}, $61de1ee1cac498ae$var$PTb);
var $61de1ee1cac498ae$var$tP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "ElkLayered", 1229);
$61de1ee1cac498ae$var$bcb(1230, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$STb);
$61de1ee1cac498ae$var$_.td = function TTb(a) {
    $61de1ee1cac498ae$var$QTb($61de1ee1cac498ae$var$BD(a, 37));
};
var $61de1ee1cac498ae$var$rP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "ElkLayered/lambda$0$Type", 1230);
$61de1ee1cac498ae$var$bcb(1231, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$UTb);
$61de1ee1cac498ae$var$_.td = function VTb(a) {
    $61de1ee1cac498ae$var$RTb(this.a, $61de1ee1cac498ae$var$BD(a, 37));
};
var $61de1ee1cac498ae$var$sP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "ElkLayered/lambda$1$Type", 1231);
$61de1ee1cac498ae$var$bcb(1263, 1, {}, $61de1ee1cac498ae$var$bUb);
var $61de1ee1cac498ae$var$WTb, $61de1ee1cac498ae$var$XTb, $61de1ee1cac498ae$var$YTb;
var $61de1ee1cac498ae$var$xP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "GraphConfigurator", 1263);
$61de1ee1cac498ae$var$bcb(759, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$dUb);
$61de1ee1cac498ae$var$_.td = function eUb(a) {
    $61de1ee1cac498ae$var$$Tb(this.a, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$uP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "GraphConfigurator/lambda$0$Type", 759);
$61de1ee1cac498ae$var$bcb(760, 1, {}, $61de1ee1cac498ae$var$fUb);
$61de1ee1cac498ae$var$_.Kb = function gUb(a) {
    return $61de1ee1cac498ae$var$ZTb(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$vP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "GraphConfigurator/lambda$1$Type", 760);
$61de1ee1cac498ae$var$bcb(761, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$hUb);
$61de1ee1cac498ae$var$_.td = function iUb(a) {
    $61de1ee1cac498ae$var$$Tb(this.a, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$wP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "GraphConfigurator/lambda$2$Type", 761);
$61de1ee1cac498ae$var$bcb(1127, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$jUb);
$61de1ee1cac498ae$var$_.Ze = function kUb(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$U1b(new $61de1ee1cac498ae$var$a2b, a);
    $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$axc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$hbd(), $61de1ee1cac498ae$var$ebd)) ? $61de1ee1cac498ae$var$JTb(this.a, c, b) : $61de1ee1cac498ae$var$KTb(this.a, c, b);
    $61de1ee1cac498ae$var$z2b(new $61de1ee1cac498ae$var$D2b, c);
};
var $61de1ee1cac498ae$var$yP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wme, "LayeredLayoutProvider", 1127);
$61de1ee1cac498ae$var$bcb(356, 22, {
    3: 1,
    35: 1,
    22: 1,
    356: 1
}, $61de1ee1cac498ae$var$rUb);
var $61de1ee1cac498ae$var$lUb, $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$oUb, $61de1ee1cac498ae$var$pUb;
var $61de1ee1cac498ae$var$zP = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Wme, "LayeredPhases", 356, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$tUb, $61de1ee1cac498ae$var$sUb);
var $61de1ee1cac498ae$var$uUb;
$61de1ee1cac498ae$var$bcb(1651, 1, {}, $61de1ee1cac498ae$var$CUb);
$61de1ee1cac498ae$var$_.i = 0;
var $61de1ee1cac498ae$var$wUb;
var $61de1ee1cac498ae$var$CP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xme, "ComponentsToCGraphTransformer", 1651);
var $61de1ee1cac498ae$var$hVb;
$61de1ee1cac498ae$var$bcb(1652, 1, {}, $61de1ee1cac498ae$var$DUb);
$61de1ee1cac498ae$var$_.ef = function EUb(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.min(a.a != null ? $61de1ee1cac498ae$var$Edb(a.a) : a.c.i, b.a != null ? $61de1ee1cac498ae$var$Edb(b.a) : b.c.i);
};
$61de1ee1cac498ae$var$_.ff = function FUb(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.min(a.a != null ? $61de1ee1cac498ae$var$Edb(a.a) : a.c.i, b.a != null ? $61de1ee1cac498ae$var$Edb(b.a) : b.c.i);
};
var $61de1ee1cac498ae$var$AP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xme, "ComponentsToCGraphTransformer/1", 1652);
$61de1ee1cac498ae$var$bcb(81, 1, {
    81: 1
});
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.k = true;
$61de1ee1cac498ae$var$_.o = $61de1ee1cac498ae$var$Qje;
var $61de1ee1cac498ae$var$IP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Yme, "CNode", 81);
$61de1ee1cac498ae$var$bcb(460, 81, {
    460: 1,
    81: 1
}, $61de1ee1cac498ae$var$GUb, $61de1ee1cac498ae$var$HUb);
$61de1ee1cac498ae$var$_.Ib = function IUb() {
    return "";
};
var $61de1ee1cac498ae$var$BP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xme, "ComponentsToCGraphTransformer/CRectNode", 460);
$61de1ee1cac498ae$var$bcb(1623, 1, {}, $61de1ee1cac498ae$var$VUb);
var $61de1ee1cac498ae$var$JUb, $61de1ee1cac498ae$var$KUb;
var $61de1ee1cac498ae$var$FP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xme, "OneDimensionalComponentsCompaction", 1623);
$61de1ee1cac498ae$var$bcb(1624, 1, {}, $61de1ee1cac498ae$var$YUb);
$61de1ee1cac498ae$var$_.Kb = function ZUb(a) {
    return $61de1ee1cac498ae$var$WUb($61de1ee1cac498ae$var$BD(a, 46));
};
$61de1ee1cac498ae$var$_.Fb = function $Ub(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$DP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xme, "OneDimensionalComponentsCompaction/lambda$0$Type", 1624);
$61de1ee1cac498ae$var$bcb(1625, 1, {}, $61de1ee1cac498ae$var$_Ub);
$61de1ee1cac498ae$var$_.Kb = function aVb(a) {
    return $61de1ee1cac498ae$var$XUb($61de1ee1cac498ae$var$BD(a, 46));
};
$61de1ee1cac498ae$var$_.Fb = function bVb(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$EP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xme, "OneDimensionalComponentsCompaction/lambda$1$Type", 1625);
$61de1ee1cac498ae$var$bcb(1654, 1, {}, $61de1ee1cac498ae$var$dVb);
var $61de1ee1cac498ae$var$GP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Yme, "CGraph", 1654);
$61de1ee1cac498ae$var$bcb(189, 1, {
    189: 1
}, $61de1ee1cac498ae$var$gVb);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.g = true;
$61de1ee1cac498ae$var$_.i = $61de1ee1cac498ae$var$Qje;
var $61de1ee1cac498ae$var$HP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Yme, "CGroup", 189);
$61de1ee1cac498ae$var$bcb(1653, 1, {}, $61de1ee1cac498ae$var$jVb);
$61de1ee1cac498ae$var$_.ef = function kVb(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.max(a.a != null ? $61de1ee1cac498ae$var$Edb(a.a) : a.c.i, b.a != null ? $61de1ee1cac498ae$var$Edb(b.a) : b.c.i);
};
$61de1ee1cac498ae$var$_.ff = function lVb(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.max(a.a != null ? $61de1ee1cac498ae$var$Edb(a.a) : a.c.i, b.a != null ? $61de1ee1cac498ae$var$Edb(b.a) : b.c.i);
};
var $61de1ee1cac498ae$var$JP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Yme, $61de1ee1cac498ae$var$Ike, 1653);
$61de1ee1cac498ae$var$bcb(1655, 1, {}, $61de1ee1cac498ae$var$CVb);
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$mVb;
var $61de1ee1cac498ae$var$LP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Yme, $61de1ee1cac498ae$var$Nke, 1655);
$61de1ee1cac498ae$var$bcb(1656, 1, {}, $61de1ee1cac498ae$var$DVb);
$61de1ee1cac498ae$var$_.Kb = function EVb(a) {
    return $61de1ee1cac498ae$var$nVb(), $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(a, 46).a, 81).d.e != 0 ? true : false;
};
$61de1ee1cac498ae$var$_.Fb = function FVb(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$KP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Yme, $61de1ee1cac498ae$var$Oke, 1656);
$61de1ee1cac498ae$var$bcb(823, 1, {}, $61de1ee1cac498ae$var$IVb);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$MP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Yme, $61de1ee1cac498ae$var$Pke, 823);
$61de1ee1cac498ae$var$bcb(1825, 1, {}, $61de1ee1cac498ae$var$OVb);
var $61de1ee1cac498ae$var$RP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zme, $61de1ee1cac498ae$var$Qke, 1825);
var $61de1ee1cac498ae$var$bQ = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$$me, $61de1ee1cac498ae$var$Fke);
$61de1ee1cac498ae$var$bcb(1826, 1, {
    369: 1
}, $61de1ee1cac498ae$var$SVb);
$61de1ee1cac498ae$var$_.Ke = function TVb(a) {
    $61de1ee1cac498ae$var$QVb(this, $61de1ee1cac498ae$var$BD(a, 466));
};
var $61de1ee1cac498ae$var$OP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zme, $61de1ee1cac498ae$var$Rke, 1826);
$61de1ee1cac498ae$var$bcb(1827, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$VVb);
$61de1ee1cac498ae$var$_.ue = function WVb(a, b) {
    return $61de1ee1cac498ae$var$UVb($61de1ee1cac498ae$var$BD(a, 81), $61de1ee1cac498ae$var$BD(b, 81));
};
$61de1ee1cac498ae$var$_.Fb = function XVb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function YVb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$NP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zme, $61de1ee1cac498ae$var$Ske, 1827);
$61de1ee1cac498ae$var$bcb(466, 1, {
    466: 1
}, $61de1ee1cac498ae$var$ZVb);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$PP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zme, $61de1ee1cac498ae$var$Tke, 466);
$61de1ee1cac498ae$var$bcb(1828, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$$Vb);
$61de1ee1cac498ae$var$_.ue = function _Vb(a, b) {
    return $61de1ee1cac498ae$var$PVb($61de1ee1cac498ae$var$BD(a, 466), $61de1ee1cac498ae$var$BD(b, 466));
};
$61de1ee1cac498ae$var$_.Fb = function aWb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function bWb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$QP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Zme, $61de1ee1cac498ae$var$Uke, 1828);
$61de1ee1cac498ae$var$bcb(140, 1, {
    140: 1
}, $61de1ee1cac498ae$var$cWb, $61de1ee1cac498ae$var$dWb);
$61de1ee1cac498ae$var$_.Fb = function eWb(a) {
    var b;
    if (a == null) return false;
    if ($61de1ee1cac498ae$var$TP != $61de1ee1cac498ae$var$rb(a)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 140);
    return $61de1ee1cac498ae$var$wtb(this.c, b.c) && $61de1ee1cac498ae$var$wtb(this.d, b.d);
};
$61de1ee1cac498ae$var$_.Hb = function fWb() {
    return $61de1ee1cac498ae$var$Hlb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        this.c,
        this.d
    ]));
};
$61de1ee1cac498ae$var$_.Ib = function gWb() {
    return "(" + this.c + $61de1ee1cac498ae$var$She + this.d + (this.a ? "cx" : "") + this.b + ")";
};
$61de1ee1cac498ae$var$_.a = true;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$TP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "Point", 140);
$61de1ee1cac498ae$var$bcb(405, 22, {
    3: 1,
    35: 1,
    22: 1,
    405: 1
}, $61de1ee1cac498ae$var$oWb);
var $61de1ee1cac498ae$var$hWb, $61de1ee1cac498ae$var$iWb, $61de1ee1cac498ae$var$jWb, $61de1ee1cac498ae$var$kWb;
var $61de1ee1cac498ae$var$SP = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$$me, "Point/Quadrant", 405, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$sWb, $61de1ee1cac498ae$var$rWb);
var $61de1ee1cac498ae$var$tWb;
$61de1ee1cac498ae$var$bcb(1642, 1, {}, $61de1ee1cac498ae$var$CWb);
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.d = null;
$61de1ee1cac498ae$var$_.e = null;
$61de1ee1cac498ae$var$_.f = null;
var $61de1ee1cac498ae$var$vWb, $61de1ee1cac498ae$var$wWb, $61de1ee1cac498ae$var$xWb, $61de1ee1cac498ae$var$yWb, $61de1ee1cac498ae$var$zWb;
var $61de1ee1cac498ae$var$aQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull", 1642);
$61de1ee1cac498ae$var$bcb(574, 1, {
    369: 1
}, $61de1ee1cac498ae$var$NWb);
$61de1ee1cac498ae$var$_.Ke = function OWb(a) {
    $61de1ee1cac498ae$var$MWb(this, $61de1ee1cac498ae$var$BD(a, 140));
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$KWb;
var $61de1ee1cac498ae$var$VP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/MaximalElementsEventHandler", 574);
$61de1ee1cac498ae$var$bcb(1644, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$QWb);
$61de1ee1cac498ae$var$_.ue = function RWb(a, b) {
    return $61de1ee1cac498ae$var$PWb($61de1ee1cac498ae$var$ED(a), $61de1ee1cac498ae$var$ED(b));
};
$61de1ee1cac498ae$var$_.Fb = function SWb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function TWb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$UP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/MaximalElementsEventHandler/lambda$0$Type", 1644);
$61de1ee1cac498ae$var$bcb(1643, 1, {
    369: 1
}, $61de1ee1cac498ae$var$VWb);
$61de1ee1cac498ae$var$_.Ke = function WWb(a) {
    $61de1ee1cac498ae$var$UWb(this, $61de1ee1cac498ae$var$BD(a, 140));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.d = null;
$61de1ee1cac498ae$var$_.e = null;
var $61de1ee1cac498ae$var$WP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/RectangleEventHandler", 1643);
$61de1ee1cac498ae$var$bcb(1645, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$XWb);
$61de1ee1cac498ae$var$_.ue = function YWb(a, b) {
    return $61de1ee1cac498ae$var$EWb($61de1ee1cac498ae$var$BD(a, 140), $61de1ee1cac498ae$var$BD(b, 140));
};
$61de1ee1cac498ae$var$_.Fb = function ZWb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function $Wb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$XP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/lambda$0$Type", 1645);
$61de1ee1cac498ae$var$bcb(1646, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$_Wb);
$61de1ee1cac498ae$var$_.ue = function aXb(a, b) {
    return $61de1ee1cac498ae$var$FWb($61de1ee1cac498ae$var$BD(a, 140), $61de1ee1cac498ae$var$BD(b, 140));
};
$61de1ee1cac498ae$var$_.Fb = function bXb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function cXb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$YP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/lambda$1$Type", 1646);
$61de1ee1cac498ae$var$bcb(1647, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$dXb);
$61de1ee1cac498ae$var$_.ue = function eXb(a, b) {
    return $61de1ee1cac498ae$var$GWb($61de1ee1cac498ae$var$BD(a, 140), $61de1ee1cac498ae$var$BD(b, 140));
};
$61de1ee1cac498ae$var$_.Fb = function fXb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function gXb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$ZP = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/lambda$2$Type", 1647);
$61de1ee1cac498ae$var$bcb(1648, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$hXb);
$61de1ee1cac498ae$var$_.ue = function iXb(a, b) {
    return $61de1ee1cac498ae$var$HWb($61de1ee1cac498ae$var$BD(a, 140), $61de1ee1cac498ae$var$BD(b, 140));
};
$61de1ee1cac498ae$var$_.Fb = function jXb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function kXb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$$P = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/lambda$3$Type", 1648);
$61de1ee1cac498ae$var$bcb(1649, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$lXb);
$61de1ee1cac498ae$var$_.ue = function mXb(a, b) {
    return $61de1ee1cac498ae$var$IWb($61de1ee1cac498ae$var$BD(a, 140), $61de1ee1cac498ae$var$BD(b, 140));
};
$61de1ee1cac498ae$var$_.Fb = function nXb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function oXb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$_P = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "RectilinearConvexHull/lambda$4$Type", 1649);
$61de1ee1cac498ae$var$bcb(1650, 1, {}, $61de1ee1cac498ae$var$qXb);
var $61de1ee1cac498ae$var$cQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$$me, "Scanline", 1650);
$61de1ee1cac498ae$var$bcb(2005, 1, {});
var $61de1ee1cac498ae$var$dQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "AbstractGraphPlacer", 2005);
$61de1ee1cac498ae$var$bcb(325, 1, {
    325: 1
}, $61de1ee1cac498ae$var$AXb);
$61de1ee1cac498ae$var$_.mf = function BXb(a) {
    if (this.nf(a)) {
        $61de1ee1cac498ae$var$Rc(this.b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21), a);
        return true;
    } else return false;
};
$61de1ee1cac498ae$var$_.nf = function CXb(a) {
    var b, c, d, e;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Esc)), 21);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc($61de1ee1cac498ae$var$wXb, b), 21);
    for(d = e.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 21);
        if (!$61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Qc(this.b, c), 15).dc()) return false;
    }
    return true;
};
var $61de1ee1cac498ae$var$wXb;
var $61de1ee1cac498ae$var$gQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentGroup", 325);
$61de1ee1cac498ae$var$bcb(765, 2005, {}, $61de1ee1cac498ae$var$HXb);
$61de1ee1cac498ae$var$_.of = function IXb(a) {
    var b, c;
    for(c = new $61de1ee1cac498ae$var$olb(this.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 325);
        if (b.mf(a)) return;
    }
    $61de1ee1cac498ae$var$Ekb(this.a, new $61de1ee1cac498ae$var$AXb(a));
};
$61de1ee1cac498ae$var$_.lf = function JXb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o;
    this.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    if (a.dc()) {
        b.f.a = 0;
        b.f.b = 0;
        return;
    }
    g = $61de1ee1cac498ae$var$BD(a.Xb(0), 37);
    $61de1ee1cac498ae$var$tNb(b, g);
    for(e = a.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 37);
        this.of(d);
    }
    o = new $61de1ee1cac498ae$var$d7c;
    f = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$kyc))));
    for(j = new $61de1ee1cac498ae$var$olb(this.a); j.a < j.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 325);
        k = $61de1ee1cac498ae$var$DXb(h, f);
        $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$Uc(h.b), o.a, o.b);
        o.a += k.a;
        o.b += k.b;
    }
    b.f.a = o.a - f;
    b.f.b = o.b - f;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$qwc))) && $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$Swc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$wad))) {
        for(n = a.Kc(); n.Ob();){
            l = $61de1ee1cac498ae$var$BD(n.Pb(), 37);
            $61de1ee1cac498ae$var$uXb(l, l.c.a, l.c.b);
        }
        c = new $61de1ee1cac498ae$var$gYb;
        $61de1ee1cac498ae$var$YXb(c, a, f);
        for(m = a.Kc(); m.Ob();){
            l = $61de1ee1cac498ae$var$BD(m.Pb(), 37);
            $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(l.c), c.e);
        }
        $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(b.f), c.a);
    }
    for(i = new $61de1ee1cac498ae$var$olb(this.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 325);
        $61de1ee1cac498ae$var$tXb(b, $61de1ee1cac498ae$var$Uc(h.b));
    }
};
var $61de1ee1cac498ae$var$eQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentGroupGraphPlacer", 765);
$61de1ee1cac498ae$var$bcb(1293, 765, {}, $61de1ee1cac498ae$var$LXb);
$61de1ee1cac498ae$var$_.of = function MXb(a) {
    $61de1ee1cac498ae$var$KXb(this, a);
};
$61de1ee1cac498ae$var$_.lf = function NXb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t;
    this.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    if (a.dc()) {
        b.f.a = 0;
        b.f.b = 0;
        return;
    }
    g = $61de1ee1cac498ae$var$BD(a.Xb(0), 37);
    $61de1ee1cac498ae$var$tNb(b, g);
    for(e = a.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 37);
        $61de1ee1cac498ae$var$KXb(this, d);
    }
    t = new $61de1ee1cac498ae$var$d7c;
    s = new $61de1ee1cac498ae$var$d7c;
    p = new $61de1ee1cac498ae$var$d7c;
    o = new $61de1ee1cac498ae$var$d7c;
    f = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(g, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$kyc))));
    for(j = new $61de1ee1cac498ae$var$olb(this.a); j.a < j.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 325);
        if ($61de1ee1cac498ae$var$fad($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$z8c)), 103))) {
            p.a = t.a;
            for(r = new $61de1ee1cac498ae$var$Mv($61de1ee1cac498ae$var$Pc($61de1ee1cac498ae$var$Fc(h.b).a).a.kc()); r.b.Ob();){
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Lv(r.b.Pb()), 21);
                if (q.Hc(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd))) {
                    p.a = s.a;
                    break;
                }
            }
        } else if ($61de1ee1cac498ae$var$gad($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$z8c), 103))) {
            p.b = t.b;
            for(r = new $61de1ee1cac498ae$var$Mv($61de1ee1cac498ae$var$Pc($61de1ee1cac498ae$var$Fc(h.b).a).a.kc()); r.b.Ob();){
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Lv(r.b.Pb()), 21);
                if (q.Hc(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd))) {
                    p.b = s.b;
                    break;
                }
            }
        }
        k = $61de1ee1cac498ae$var$DXb($61de1ee1cac498ae$var$BD(h, 570), f);
        $61de1ee1cac498ae$var$vXb($61de1ee1cac498ae$var$Uc(h.b), p.a, p.b);
        if ($61de1ee1cac498ae$var$fad($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$z8c), 103))) {
            s.a = p.a + k.a;
            o.a = $61de1ee1cac498ae$var$$wnd.Math.max(o.a, s.a);
            for(r = new $61de1ee1cac498ae$var$Mv($61de1ee1cac498ae$var$Pc($61de1ee1cac498ae$var$Fc(h.b).a).a.kc()); r.b.Ob();){
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Lv(r.b.Pb()), 21);
                if (q.Hc(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd))) {
                    t.a = p.a + k.a;
                    break;
                }
            }
            s.b = p.b + k.b;
            p.b = s.b;
            o.b = $61de1ee1cac498ae$var$$wnd.Math.max(o.b, p.b);
        } else if ($61de1ee1cac498ae$var$gad($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$z8c), 103))) {
            s.b = p.b + k.b;
            o.b = $61de1ee1cac498ae$var$$wnd.Math.max(o.b, s.b);
            for(r = new $61de1ee1cac498ae$var$Mv($61de1ee1cac498ae$var$Pc($61de1ee1cac498ae$var$Fc(h.b).a).a.kc()); r.b.Ob();){
                q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Lv(r.b.Pb()), 21);
                if (q.Hc(($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd))) {
                    t.b = p.b + k.b;
                    break;
                }
            }
            s.a = p.a + k.a;
            p.a = s.a;
            o.a = $61de1ee1cac498ae$var$$wnd.Math.max(o.a, p.a);
        }
    }
    b.f.a = o.a - f;
    b.f.b = o.b - f;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$qwc))) && $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(g, $61de1ee1cac498ae$var$Swc)) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$wad))) {
        for(n = a.Kc(); n.Ob();){
            l = $61de1ee1cac498ae$var$BD(n.Pb(), 37);
            $61de1ee1cac498ae$var$uXb(l, l.c.a, l.c.b);
        }
        c = new $61de1ee1cac498ae$var$gYb;
        $61de1ee1cac498ae$var$YXb(c, a, f);
        for(m = a.Kc(); m.Ob();){
            l = $61de1ee1cac498ae$var$BD(m.Pb(), 37);
            $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(l.c), c.e);
        }
        $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(b.f), c.a);
    }
    for(i = new $61de1ee1cac498ae$var$olb(this.a); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 325);
        $61de1ee1cac498ae$var$tXb(b, $61de1ee1cac498ae$var$Uc(h.b));
    }
};
var $61de1ee1cac498ae$var$fQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentGroupModelOrderGraphPlacer", 1293);
$61de1ee1cac498ae$var$bcb(423, 22, {
    3: 1,
    35: 1,
    22: 1,
    423: 1
}, $61de1ee1cac498ae$var$SXb);
var $61de1ee1cac498ae$var$OXb, $61de1ee1cac498ae$var$PXb, $61de1ee1cac498ae$var$QXb;
var $61de1ee1cac498ae$var$hQ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$_me, "ComponentOrderingStrategy", 423, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$UXb, $61de1ee1cac498ae$var$TXb);
var $61de1ee1cac498ae$var$VXb;
$61de1ee1cac498ae$var$bcb(650, 1, {}, $61de1ee1cac498ae$var$gYb);
var $61de1ee1cac498ae$var$pQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor", 650);
$61de1ee1cac498ae$var$bcb(1468, 12, $61de1ee1cac498ae$var$ake, $61de1ee1cac498ae$var$jYb);
$61de1ee1cac498ae$var$_.Fc = function kYb(a) {
    return $61de1ee1cac498ae$var$hYb(this, $61de1ee1cac498ae$var$BD(a, 140));
};
var $61de1ee1cac498ae$var$iQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor/Hullpoints", 1468);
$61de1ee1cac498ae$var$bcb(1465, 1, {
    841: 1
}, $61de1ee1cac498ae$var$mYb);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$jQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor/InternalComponent", 1465);
$61de1ee1cac498ae$var$bcb(1464, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$nYb);
$61de1ee1cac498ae$var$_.Jc = function oYb(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function pYb() {
    return new $61de1ee1cac498ae$var$olb(this.a);
};
var $61de1ee1cac498ae$var$kQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor/InternalConnectedComponents", 1464);
$61de1ee1cac498ae$var$bcb(1467, 1, {
    594: 1
}, $61de1ee1cac498ae$var$qYb);
$61de1ee1cac498ae$var$_.hf = function sYb() {
    return null;
};
$61de1ee1cac498ae$var$_.jf = function tYb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.gf = function rYb() {
    return $61de1ee1cac498ae$var$cYb(this.d);
};
$61de1ee1cac498ae$var$_.kf = function uYb() {
    return this.b;
};
var $61de1ee1cac498ae$var$lQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor/InternalExternalExtension", 1467);
$61de1ee1cac498ae$var$bcb(1466, 1, {
    594: 1
}, $61de1ee1cac498ae$var$vYb);
$61de1ee1cac498ae$var$_.jf = function yYb() {
    return this.a;
};
$61de1ee1cac498ae$var$_.gf = function wYb() {
    return $61de1ee1cac498ae$var$cYb(this.d);
};
$61de1ee1cac498ae$var$_.hf = function xYb() {
    return this.c;
};
$61de1ee1cac498ae$var$_.kf = function zYb() {
    return this.b;
};
var $61de1ee1cac498ae$var$mQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor/InternalUnionExternalExtension", 1466);
$61de1ee1cac498ae$var$bcb(1470, 1, {}, $61de1ee1cac498ae$var$AYb);
var $61de1ee1cac498ae$var$nQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor/OuterSegments", 1470);
$61de1ee1cac498ae$var$bcb(1469, 1, {}, $61de1ee1cac498ae$var$BYb);
var $61de1ee1cac498ae$var$oQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsCompactor/Segments", 1469);
$61de1ee1cac498ae$var$bcb(1264, 1, {}, $61de1ee1cac498ae$var$FYb);
var $61de1ee1cac498ae$var$rQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, $61de1ee1cac498ae$var$hme, 1264);
$61de1ee1cac498ae$var$bcb(1265, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$HYb);
$61de1ee1cac498ae$var$_.ue = function IYb(a, b) {
    return $61de1ee1cac498ae$var$GYb($61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$BD(b, 37));
};
$61de1ee1cac498ae$var$_.Fb = function JYb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function KYb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$qQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ComponentsProcessor/lambda$0$Type", 1265);
$61de1ee1cac498ae$var$bcb(570, 325, {
    325: 1,
    570: 1
}, $61de1ee1cac498ae$var$PYb);
$61de1ee1cac498ae$var$_.mf = function QYb(a) {
    return $61de1ee1cac498ae$var$NYb(this, a);
};
$61de1ee1cac498ae$var$_.nf = function RYb(a) {
    return $61de1ee1cac498ae$var$OYb(this, a);
};
var $61de1ee1cac498ae$var$LYb;
var $61de1ee1cac498ae$var$sQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "ModelOrderComponentGroup", 570);
$61de1ee1cac498ae$var$bcb(1291, 2005, {}, $61de1ee1cac498ae$var$SYb);
$61de1ee1cac498ae$var$_.lf = function TYb(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w;
    if (a.gc() == 1) {
        t = $61de1ee1cac498ae$var$BD(a.Xb(0), 37);
        if (t != b) {
            b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            $61de1ee1cac498ae$var$sXb(b, t, 0, 0);
            $61de1ee1cac498ae$var$tNb(b, t);
            $61de1ee1cac498ae$var$u_b(b.d, t.d);
            b.f.a = t.f.a;
            b.f.b = t.f.b;
        }
        return;
    } else if (a.dc()) {
        b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
        b.f.a = 0;
        b.f.b = 0;
        return;
    }
    if ($61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb(b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$twc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$RXb(), $61de1ee1cac498ae$var$QXb))) {
        for(i = a.Kc(); i.Ob();){
            g = $61de1ee1cac498ae$var$BD(i.Pb(), 37);
            r = 0;
            for(p = new $61de1ee1cac498ae$var$olb(g.a); p.a < p.c.c.length;){
                o = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(p), 10);
                r += $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(o, $61de1ee1cac498ae$var$byc), 19).a;
            }
            g.p = r;
        }
        $61de1ee1cac498ae$var$mmb();
        a.ad(new $61de1ee1cac498ae$var$VYb);
    }
    f = $61de1ee1cac498ae$var$BD(a.Xb(0), 37);
    b.a.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
    $61de1ee1cac498ae$var$tNb(b, f);
    n = 0;
    u = 0;
    for(j = a.Kc(); j.Ob();){
        g = $61de1ee1cac498ae$var$BD(j.Pb(), 37);
        s = g.f;
        n = $61de1ee1cac498ae$var$$wnd.Math.max(n, s.a);
        u += s.a * s.b;
    }
    n = $61de1ee1cac498ae$var$$wnd.Math.max(n, $61de1ee1cac498ae$var$$wnd.Math.sqrt(u) * $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$owc))));
    e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$vNb(b, $61de1ee1cac498ae$var$kyc)));
    v = 0;
    w = 0;
    m = 0;
    c = e;
    for(h = a.Kc(); h.Ob();){
        g = $61de1ee1cac498ae$var$BD(h.Pb(), 37);
        s = g.f;
        if (v + s.a > n) {
            v = 0;
            w += m + e;
            m = 0;
        }
        q = g.c;
        $61de1ee1cac498ae$var$uXb(g, v + q.a, w + q.b);
        $61de1ee1cac498ae$var$X6c(q);
        c = $61de1ee1cac498ae$var$$wnd.Math.max(c, v + s.a);
        m = $61de1ee1cac498ae$var$$wnd.Math.max(m, s.b);
        v += s.a + e;
    }
    b.f.a = c;
    b.f.b = w + m;
    if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(f, $61de1ee1cac498ae$var$qwc)))) {
        d = new $61de1ee1cac498ae$var$gYb;
        $61de1ee1cac498ae$var$YXb(d, a, e);
        for(l = a.Kc(); l.Ob();){
            k = $61de1ee1cac498ae$var$BD(l.Pb(), 37);
            $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(k.c), d.e);
        }
        $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$X6c(b.f), d.a);
    }
    $61de1ee1cac498ae$var$tXb(b, a);
};
var $61de1ee1cac498ae$var$uQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "SimpleRowGraphPlacer", 1291);
$61de1ee1cac498ae$var$bcb(1292, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$VYb);
$61de1ee1cac498ae$var$_.ue = function WYb(a, b) {
    return $61de1ee1cac498ae$var$UYb($61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$BD(b, 37));
};
$61de1ee1cac498ae$var$_.Fb = function XYb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function YYb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$tQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_me, "SimpleRowGraphPlacer/1", 1292);
var $61de1ee1cac498ae$var$ZYb;
$61de1ee1cac498ae$var$bcb(1262, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$dZb);
$61de1ee1cac498ae$var$_.Lb = function eZb(a) {
    var b;
    return b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 243).b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74), !!b && b.b != 0;
};
$61de1ee1cac498ae$var$_.Fb = function fZb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function gZb(a) {
    var b;
    return b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 243).b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$jxc)), 74), !!b && b.b != 0;
};
var $61de1ee1cac498ae$var$vQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dne, "CompoundGraphPostprocessor/1", 1262);
$61de1ee1cac498ae$var$bcb(1261, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$wZb);
$61de1ee1cac498ae$var$_.pf = function xZb(a, b) {
    $61de1ee1cac498ae$var$qZb(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$xQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dne, "CompoundGraphPreprocessor", 1261);
$61de1ee1cac498ae$var$bcb(441, 1, {
    441: 1
}, $61de1ee1cac498ae$var$yZb);
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$wQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dne, "CompoundGraphPreprocessor/ExternalPort", 441);
$61de1ee1cac498ae$var$bcb(243, 1, {
    243: 1
}, $61de1ee1cac498ae$var$BZb);
$61de1ee1cac498ae$var$_.Ib = function CZb() {
    return $61de1ee1cac498ae$var$Zr(this.c) + ":" + $61de1ee1cac498ae$var$TZb(this.b);
};
var $61de1ee1cac498ae$var$zQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dne, "CrossHierarchyEdge", 243);
$61de1ee1cac498ae$var$bcb(763, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$EZb);
$61de1ee1cac498ae$var$_.ue = function FZb(a, b) {
    return $61de1ee1cac498ae$var$DZb(this, $61de1ee1cac498ae$var$BD(a, 243), $61de1ee1cac498ae$var$BD(b, 243));
};
$61de1ee1cac498ae$var$_.Fb = function GZb(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function IZb() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$yQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dne, "CrossHierarchyEdgeComparator", 763);
$61de1ee1cac498ae$var$bcb(299, 134, {
    3: 1,
    299: 1,
    94: 1,
    134: 1
});
$61de1ee1cac498ae$var$_.p = 0;
var $61de1ee1cac498ae$var$JQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphElement", 299);
$61de1ee1cac498ae$var$bcb(17, 299, {
    3: 1,
    17: 1,
    299: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$UZb);
$61de1ee1cac498ae$var$_.Ib = function VZb() {
    return $61de1ee1cac498ae$var$TZb(this);
};
var $61de1ee1cac498ae$var$AQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LEdge", 17);
$61de1ee1cac498ae$var$bcb(37, 299, {
    3: 1,
    20: 1,
    37: 1,
    299: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$XZb);
$61de1ee1cac498ae$var$_.Jc = function YZb(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function ZZb() {
    return new $61de1ee1cac498ae$var$olb(this.b);
};
$61de1ee1cac498ae$var$_.Ib = function $Zb() {
    if (this.b.c.length == 0) return "G-unlayered" + $61de1ee1cac498ae$var$Fe(this.a);
    else if (this.a.c.length == 0) return "G-layered" + $61de1ee1cac498ae$var$Fe(this.b);
    return "G[layerless" + $61de1ee1cac498ae$var$Fe(this.a) + ", layers" + $61de1ee1cac498ae$var$Fe(this.b) + "]";
};
var $61de1ee1cac498ae$var$KQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraph", 37);
var $61de1ee1cac498ae$var$_Zb;
$61de1ee1cac498ae$var$bcb(657, 1, {});
$61de1ee1cac498ae$var$_.qf = function b$b() {
    return this.e.n;
};
$61de1ee1cac498ae$var$_.We = function c$b(a) {
    return $61de1ee1cac498ae$var$vNb(this.e, a);
};
$61de1ee1cac498ae$var$_.rf = function d$b() {
    return this.e.o;
};
$61de1ee1cac498ae$var$_.sf = function e$b() {
    return this.e.p;
};
$61de1ee1cac498ae$var$_.Xe = function f$b(a) {
    return $61de1ee1cac498ae$var$wNb(this.e, a);
};
$61de1ee1cac498ae$var$_.tf = function g$b(a) {
    this.e.n.a = a.a;
    this.e.n.b = a.b;
};
$61de1ee1cac498ae$var$_.uf = function h$b(a) {
    this.e.o.a = a.a;
    this.e.o.b = a.b;
};
$61de1ee1cac498ae$var$_.vf = function i$b(a) {
    this.e.p = a;
};
var $61de1ee1cac498ae$var$BQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/AbstractLShapeAdapter", 657);
$61de1ee1cac498ae$var$bcb(577, 1, {
    839: 1
}, $61de1ee1cac498ae$var$j$b);
$61de1ee1cac498ae$var$_.wf = function k$b() {
    var a, b;
    if (!this.b) {
        this.b = $61de1ee1cac498ae$var$Pu(this.a.b.c.length);
        for(b = new $61de1ee1cac498ae$var$olb(this.a.b); b.a < b.c.c.length;){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(b), 70);
            $61de1ee1cac498ae$var$Ekb(this.b, new $61de1ee1cac498ae$var$v$b(a));
        }
    }
    return this.b;
};
$61de1ee1cac498ae$var$_.b = null;
var $61de1ee1cac498ae$var$CQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/LEdgeAdapter", 577);
$61de1ee1cac498ae$var$bcb(656, 1, {}, $61de1ee1cac498ae$var$l$b);
$61de1ee1cac498ae$var$_.xf = function m$b() {
    var a, b, c, d, e, f;
    if (!this.b) {
        this.b = new $61de1ee1cac498ae$var$Rkb;
        for(d = new $61de1ee1cac498ae$var$olb(this.a.b); d.a < d.c.c.length;){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 29);
            for(f = new $61de1ee1cac498ae$var$olb(c.a); f.a < f.c.c.length;){
                e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 10);
                if (this.c.Mb(e)) {
                    $61de1ee1cac498ae$var$Ekb(this.b, new $61de1ee1cac498ae$var$x$b(this, e, this.e));
                    if (this.d) {
                        if ($61de1ee1cac498ae$var$wNb(e, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$vtc))) for(b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$vtc), 15).Kc(); b.Ob();){
                            a = $61de1ee1cac498ae$var$BD(b.Pb(), 10);
                            $61de1ee1cac498ae$var$Ekb(this.b, new $61de1ee1cac498ae$var$x$b(this, a, false));
                        }
                        if ($61de1ee1cac498ae$var$wNb(e, $61de1ee1cac498ae$var$tsc)) for(b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(e, $61de1ee1cac498ae$var$tsc), 15).Kc(); b.Ob();){
                            a = $61de1ee1cac498ae$var$BD(b.Pb(), 10);
                            $61de1ee1cac498ae$var$Ekb(this.b, new $61de1ee1cac498ae$var$x$b(this, a, false));
                        }
                    }
                }
            }
        }
    }
    return this.b;
};
$61de1ee1cac498ae$var$_.qf = function n$b() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$hne));
};
$61de1ee1cac498ae$var$_.We = function o$b(a) {
    return $61de1ee1cac498ae$var$vNb(this.a, a);
};
$61de1ee1cac498ae$var$_.rf = function p$b() {
    return this.a.f;
};
$61de1ee1cac498ae$var$_.sf = function q$b() {
    return this.a.p;
};
$61de1ee1cac498ae$var$_.Xe = function r$b(a) {
    return $61de1ee1cac498ae$var$wNb(this.a, a);
};
$61de1ee1cac498ae$var$_.tf = function s$b(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$hne));
};
$61de1ee1cac498ae$var$_.uf = function t$b(a) {
    this.a.f.a = a.a;
    this.a.f.b = a.b;
};
$61de1ee1cac498ae$var$_.vf = function u$b(a) {
    this.a.p = a;
};
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.d = false;
$61de1ee1cac498ae$var$_.e = false;
var $61de1ee1cac498ae$var$DQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/LGraphAdapter", 656);
$61de1ee1cac498ae$var$bcb(576, 657, {
    181: 1
}, $61de1ee1cac498ae$var$v$b);
var $61de1ee1cac498ae$var$EQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/LLabelAdapter", 576);
$61de1ee1cac498ae$var$bcb(575, 657, {
    680: 1
}, $61de1ee1cac498ae$var$x$b);
$61de1ee1cac498ae$var$_.yf = function y$b() {
    return this.b;
};
$61de1ee1cac498ae$var$_.zf = function z$b() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
};
$61de1ee1cac498ae$var$_.wf = function A$b() {
    var a, b;
    if (!this.a) {
        this.a = $61de1ee1cac498ae$var$Pu($61de1ee1cac498ae$var$BD(this.e, 10).b.c.length);
        for(b = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$BD(this.e, 10).b); b.a < b.c.c.length;){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(b), 70);
            $61de1ee1cac498ae$var$Ekb(this.a, new $61de1ee1cac498ae$var$v$b(a));
        }
    }
    return this.a;
};
$61de1ee1cac498ae$var$_.Af = function B$b() {
    var a;
    a = $61de1ee1cac498ae$var$BD(this.e, 10).d;
    return new $61de1ee1cac498ae$var$J_b(a.d, a.c, a.a, a.b);
};
$61de1ee1cac498ae$var$_.Bf = function C$b() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
};
$61de1ee1cac498ae$var$_.Cf = function D$b() {
    var a, b;
    if (!this.c) {
        this.c = $61de1ee1cac498ae$var$Pu($61de1ee1cac498ae$var$BD(this.e, 10).j.c.length);
        for(b = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$BD(this.e, 10).j); b.a < b.c.c.length;){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(b), 11);
            $61de1ee1cac498ae$var$Ekb(this.c, new $61de1ee1cac498ae$var$I$b(a, this.d));
        }
    }
    return this.c;
};
$61de1ee1cac498ae$var$_.Df = function E$b() {
    return $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(this.e, 10), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$wsc))));
};
$61de1ee1cac498ae$var$_.Ef = function F$b(a) {
    $61de1ee1cac498ae$var$BD(this.e, 10).d.b = a.b;
    $61de1ee1cac498ae$var$BD(this.e, 10).d.d = a.d;
    $61de1ee1cac498ae$var$BD(this.e, 10).d.c = a.c;
    $61de1ee1cac498ae$var$BD(this.e, 10).d.a = a.a;
};
$61de1ee1cac498ae$var$_.Ff = function G$b(a) {
    $61de1ee1cac498ae$var$BD(this.e, 10).f.b = a.b;
    $61de1ee1cac498ae$var$BD(this.e, 10).f.d = a.d;
    $61de1ee1cac498ae$var$BD(this.e, 10).f.c = a.c;
    $61de1ee1cac498ae$var$BD(this.e, 10).f.a = a.a;
};
$61de1ee1cac498ae$var$_.Gf = function H$b() {
    $61de1ee1cac498ae$var$w$b(this, ($61de1ee1cac498ae$var$a$b(), $61de1ee1cac498ae$var$_Zb));
};
$61de1ee1cac498ae$var$_.a = null;
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$FQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/LNodeAdapter", 575);
$61de1ee1cac498ae$var$bcb(1722, 657, {
    838: 1
}, $61de1ee1cac498ae$var$I$b);
$61de1ee1cac498ae$var$_.zf = function J$b() {
    var a, b, c, d;
    if (this.d && $61de1ee1cac498ae$var$BD(this.e, 11).i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b)) return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
    else if (!this.a) {
        this.a = new $61de1ee1cac498ae$var$Rkb;
        for(c = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$BD(this.e, 11).e); c.a < c.c.c.length;){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 17);
            $61de1ee1cac498ae$var$Ekb(this.a, new $61de1ee1cac498ae$var$j$b(a));
        }
        if (this.d) {
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(this.e, 11), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
            if (d) for(b = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$R_b(d).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(b);){
                a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(b), 17);
                $61de1ee1cac498ae$var$Ekb(this.a, new $61de1ee1cac498ae$var$j$b(a));
            }
        }
    }
    return this.a;
};
$61de1ee1cac498ae$var$_.wf = function K$b() {
    var a, b;
    if (!this.b) {
        this.b = $61de1ee1cac498ae$var$Pu($61de1ee1cac498ae$var$BD(this.e, 11).f.c.length);
        for(b = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$BD(this.e, 11).f); b.a < b.c.c.length;){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(b), 70);
            $61de1ee1cac498ae$var$Ekb(this.b, new $61de1ee1cac498ae$var$v$b(a));
        }
    }
    return this.b;
};
$61de1ee1cac498ae$var$_.Bf = function L$b() {
    var a, b, c, d;
    if (this.d && $61de1ee1cac498ae$var$BD(this.e, 11).i.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b)) return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
    else if (!this.c) {
        this.c = new $61de1ee1cac498ae$var$Rkb;
        for(c = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$BD(this.e, 11).g); c.a < c.c.c.length;){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 17);
            $61de1ee1cac498ae$var$Ekb(this.c, new $61de1ee1cac498ae$var$j$b(a));
        }
        if (this.d) {
            d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(this.e, 11), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc)), 10);
            if (d) for(b = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b(d).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(b);){
                a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(b), 17);
                $61de1ee1cac498ae$var$Ekb(this.c, new $61de1ee1cac498ae$var$j$b(a));
            }
        }
    }
    return this.c;
};
$61de1ee1cac498ae$var$_.Hf = function M$b() {
    return $61de1ee1cac498ae$var$BD(this.e, 11).j;
};
$61de1ee1cac498ae$var$_.If = function N$b() {
    return $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(this.e, 11), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Nsc))));
};
$61de1ee1cac498ae$var$_.a = null;
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$GQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/LPortAdapter", 1722);
$61de1ee1cac498ae$var$bcb(1723, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$P$b);
$61de1ee1cac498ae$var$_.ue = function Q$b(a, b) {
    return $61de1ee1cac498ae$var$O$b($61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function R$b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function S$b() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$HQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/PortComparator", 1723);
$61de1ee1cac498ae$var$bcb(804, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$T$b);
$61de1ee1cac498ae$var$_.Mb = function U$b(a) {
    return $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$a$b(), true;
};
var $61de1ee1cac498ae$var$IQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LGraphAdapters/lambda$0$Type", 804);
$61de1ee1cac498ae$var$bcb(392, 299, {
    3: 1,
    299: 1,
    392: 1,
    94: 1,
    134: 1
});
var $61de1ee1cac498ae$var$bR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LShape", 392);
$61de1ee1cac498ae$var$bcb(70, 392, {
    3: 1,
    299: 1,
    70: 1,
    392: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$p_b, $61de1ee1cac498ae$var$q_b);
$61de1ee1cac498ae$var$_.Ib = function r_b() {
    var a;
    a = $61de1ee1cac498ae$var$o_b(this);
    return a == null ? "label" : "l_" + a;
};
var $61de1ee1cac498ae$var$LQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LLabel", 70);
$61de1ee1cac498ae$var$bcb(207, 1, {
    3: 1,
    4: 1,
    207: 1,
    414: 1
});
$61de1ee1cac498ae$var$_.Fb = function C_b(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 207)) {
        b = $61de1ee1cac498ae$var$BD(a, 207);
        return this.d == b.d && this.a == b.a && this.b == b.b && this.c == b.c;
    } else return false;
};
$61de1ee1cac498ae$var$_.Hb = function D_b() {
    var a, b;
    a = $61de1ee1cac498ae$var$Hdb(this.b) << 16;
    a |= $61de1ee1cac498ae$var$Hdb(this.a) & $61de1ee1cac498ae$var$aje;
    b = $61de1ee1cac498ae$var$Hdb(this.c) << 16;
    b |= $61de1ee1cac498ae$var$Hdb(this.d) & $61de1ee1cac498ae$var$aje;
    return a ^ b;
};
$61de1ee1cac498ae$var$_.Jf = function F_b(b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    g = 0;
    while(g < b.length && $61de1ee1cac498ae$var$E_b(($61de1ee1cac498ae$var$BCb(g, b.length), b.charCodeAt(g)), $61de1ee1cac498ae$var$mne))++g;
    c = b.length;
    while(c > 0 && $61de1ee1cac498ae$var$E_b(($61de1ee1cac498ae$var$BCb(c - 1, b.length), b.charCodeAt(c - 1)), $61de1ee1cac498ae$var$nne))--c;
    if (g < c) {
        l = $61de1ee1cac498ae$var$mfb(b.substr(g, c - g), ",|;");
        try {
            for(i = l, j = 0, k = i.length; j < k; ++j){
                h = i[j];
                f = $61de1ee1cac498ae$var$mfb(h, "=");
                if (f.length != 2) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Expecting a list of key-value pairs."));
                e = $61de1ee1cac498ae$var$ufb(f[0]);
                m = $61de1ee1cac498ae$var$Hcb($61de1ee1cac498ae$var$ufb(f[1]));
                $61de1ee1cac498ae$var$dfb(e, "top") ? this.d = m : $61de1ee1cac498ae$var$dfb(e, "left") ? this.b = m : $61de1ee1cac498ae$var$dfb(e, "bottom") ? this.a = m : $61de1ee1cac498ae$var$dfb(e, "right") && (this.c = m);
            }
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if ($61de1ee1cac498ae$var$JD(a, 127)) {
                d = a;
                throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$one + d));
            } else throw $61de1ee1cac498ae$var$vbb(a);
        }
    }
};
$61de1ee1cac498ae$var$_.Ib = function G_b() {
    return "[top=" + this.d + ",left=" + this.b + ",bottom=" + this.a + ",right=" + this.c + "]";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$n1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$pne, "Spacing", 207);
$61de1ee1cac498ae$var$bcb(142, 207, $61de1ee1cac498ae$var$qne, $61de1ee1cac498ae$var$H_b, $61de1ee1cac498ae$var$I_b, $61de1ee1cac498ae$var$J_b, $61de1ee1cac498ae$var$K_b);
var $61de1ee1cac498ae$var$i1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$pne, "ElkMargin", 142);
$61de1ee1cac498ae$var$bcb(651, 142, $61de1ee1cac498ae$var$qne, $61de1ee1cac498ae$var$L_b);
var $61de1ee1cac498ae$var$MQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LMargin", 651);
$61de1ee1cac498ae$var$bcb(10, 392, {
    3: 1,
    299: 1,
    10: 1,
    392: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$b0b);
$61de1ee1cac498ae$var$_.Ib = function c0b() {
    return $61de1ee1cac498ae$var$a0b(this);
};
$61de1ee1cac498ae$var$_.i = false;
var $61de1ee1cac498ae$var$OQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LNode", 10);
$61de1ee1cac498ae$var$bcb(267, 22, {
    3: 1,
    35: 1,
    22: 1,
    267: 1
}, $61de1ee1cac498ae$var$k0b);
var $61de1ee1cac498ae$var$d0b, $61de1ee1cac498ae$var$e0b, $61de1ee1cac498ae$var$f0b, $61de1ee1cac498ae$var$g0b, $61de1ee1cac498ae$var$h0b, $61de1ee1cac498ae$var$i0b;
var $61de1ee1cac498ae$var$NQ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$fne, "LNode/NodeType", 267, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$m0b, $61de1ee1cac498ae$var$l0b);
var $61de1ee1cac498ae$var$n0b;
$61de1ee1cac498ae$var$bcb(116, 207, $61de1ee1cac498ae$var$rne, $61de1ee1cac498ae$var$p0b, $61de1ee1cac498ae$var$q0b, $61de1ee1cac498ae$var$r0b);
var $61de1ee1cac498ae$var$j1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$pne, "ElkPadding", 116);
$61de1ee1cac498ae$var$bcb(764, 116, $61de1ee1cac498ae$var$rne, $61de1ee1cac498ae$var$s0b);
var $61de1ee1cac498ae$var$PQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPadding", 764);
$61de1ee1cac498ae$var$bcb(11, 392, {
    3: 1,
    299: 1,
    11: 1,
    392: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$H0b);
$61de1ee1cac498ae$var$_.Ib = function I0b() {
    var a, b, c;
    a = new $61de1ee1cac498ae$var$Ufb;
    $61de1ee1cac498ae$var$Qfb((a.a += "p_", a), $61de1ee1cac498ae$var$C0b(this));
    !!this.i && $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Pfb((a.a += "[", a), this.i), "]");
    if (this.e.c.length == 1 && this.g.c.length == 0 && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(this.e, 0), 17).c != this) {
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(this.e, 0), 17).c;
        $61de1ee1cac498ae$var$Qfb((a.a += " << ", a), $61de1ee1cac498ae$var$C0b(b));
        $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Pfb((a.a += "[", a), b.i), "]");
    }
    if (this.e.c.length == 0 && this.g.c.length == 1 && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(this.g, 0), 17).d != this) {
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(this.g, 0), 17).d;
        $61de1ee1cac498ae$var$Qfb((a.a += " >> ", a), $61de1ee1cac498ae$var$C0b(c));
        $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Pfb((a.a += "[", a), c.i), "]");
    }
    return a.a;
};
$61de1ee1cac498ae$var$_.c = true;
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$t0b, $61de1ee1cac498ae$var$u0b, $61de1ee1cac498ae$var$v0b, $61de1ee1cac498ae$var$w0b, $61de1ee1cac498ae$var$x0b, $61de1ee1cac498ae$var$y0b;
var $61de1ee1cac498ae$var$aR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort", 11);
$61de1ee1cac498ae$var$bcb(397, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$J0b);
$61de1ee1cac498ae$var$_.Jc = function K0b(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function L0b() {
    var a;
    a = new $61de1ee1cac498ae$var$olb(this.a.e);
    return new $61de1ee1cac498ae$var$M0b(a);
};
var $61de1ee1cac498ae$var$RQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/1", 397);
$61de1ee1cac498ae$var$bcb(1290, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$M0b);
$61de1ee1cac498ae$var$_.Nb = function N0b(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function P0b() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(this.a), 17).c;
};
$61de1ee1cac498ae$var$_.Ob = function O0b() {
    return $61de1ee1cac498ae$var$llb(this.a);
};
$61de1ee1cac498ae$var$_.Qb = function Q0b() {
    $61de1ee1cac498ae$var$nlb(this.a);
};
var $61de1ee1cac498ae$var$QQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/1/1", 1290);
$61de1ee1cac498ae$var$bcb(359, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$R0b);
$61de1ee1cac498ae$var$_.Jc = function S0b(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function T0b() {
    var a;
    return a = new $61de1ee1cac498ae$var$olb(this.a.g), new $61de1ee1cac498ae$var$U0b(a);
};
var $61de1ee1cac498ae$var$TQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/2", 359);
$61de1ee1cac498ae$var$bcb(762, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$U0b);
$61de1ee1cac498ae$var$_.Nb = function V0b(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function X0b() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(this.a), 17).d;
};
$61de1ee1cac498ae$var$_.Ob = function W0b() {
    return $61de1ee1cac498ae$var$llb(this.a);
};
$61de1ee1cac498ae$var$_.Qb = function Y0b() {
    $61de1ee1cac498ae$var$nlb(this.a);
};
var $61de1ee1cac498ae$var$SQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/2/1", 762);
$61de1ee1cac498ae$var$bcb(1283, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$Z0b);
$61de1ee1cac498ae$var$_.Jc = function $0b(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function _0b() {
    return new $61de1ee1cac498ae$var$b1b(this);
};
var $61de1ee1cac498ae$var$VQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/CombineIter", 1283);
$61de1ee1cac498ae$var$bcb(201, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$b1b);
$61de1ee1cac498ae$var$_.Nb = function c1b(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Qb = function f1b() {
    $61de1ee1cac498ae$var$Srb();
};
$61de1ee1cac498ae$var$_.Ob = function d1b() {
    return $61de1ee1cac498ae$var$a1b(this);
};
$61de1ee1cac498ae$var$_.Pb = function e1b() {
    return $61de1ee1cac498ae$var$llb(this.a) ? $61de1ee1cac498ae$var$mlb(this.a) : $61de1ee1cac498ae$var$mlb(this.b);
};
var $61de1ee1cac498ae$var$UQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/CombineIter/1", 201);
$61de1ee1cac498ae$var$bcb(1285, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$h1b);
$61de1ee1cac498ae$var$_.Lb = function i1b(a) {
    return $61de1ee1cac498ae$var$g1b(a);
};
$61de1ee1cac498ae$var$_.Fb = function j1b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function k1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).e.c.length != 0;
};
var $61de1ee1cac498ae$var$WQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/lambda$0$Type", 1285);
$61de1ee1cac498ae$var$bcb(1284, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$m1b);
$61de1ee1cac498ae$var$_.Lb = function n1b(a) {
    return $61de1ee1cac498ae$var$l1b(a);
};
$61de1ee1cac498ae$var$_.Fb = function o1b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function p1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).g.c.length != 0;
};
var $61de1ee1cac498ae$var$XQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/lambda$1$Type", 1284);
$61de1ee1cac498ae$var$bcb(1286, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$q1b);
$61de1ee1cac498ae$var$_.Lb = function r1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd);
};
$61de1ee1cac498ae$var$_.Fb = function s1b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function t1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd);
};
var $61de1ee1cac498ae$var$YQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/lambda$2$Type", 1286);
$61de1ee1cac498ae$var$bcb(1287, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$u1b);
$61de1ee1cac498ae$var$_.Lb = function v1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd);
};
$61de1ee1cac498ae$var$_.Fb = function w1b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function x1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd);
};
var $61de1ee1cac498ae$var$ZQ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/lambda$3$Type", 1287);
$61de1ee1cac498ae$var$bcb(1288, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$y1b);
$61de1ee1cac498ae$var$_.Lb = function z1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd);
};
$61de1ee1cac498ae$var$_.Fb = function A1b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function B1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd);
};
var $61de1ee1cac498ae$var$$Q = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/lambda$4$Type", 1288);
$61de1ee1cac498ae$var$bcb(1289, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$C1b);
$61de1ee1cac498ae$var$_.Lb = function D1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd);
};
$61de1ee1cac498ae$var$_.Fb = function E1b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function F1b(a) {
    return $61de1ee1cac498ae$var$z0b(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd);
};
var $61de1ee1cac498ae$var$_Q = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "LPort/lambda$5$Type", 1289);
$61de1ee1cac498ae$var$bcb(29, 299, {
    3: 1,
    20: 1,
    299: 1,
    29: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$H1b);
$61de1ee1cac498ae$var$_.Jc = function I1b(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function J1b() {
    return new $61de1ee1cac498ae$var$olb(this.a);
};
$61de1ee1cac498ae$var$_.Ib = function K1b() {
    return "L_" + $61de1ee1cac498ae$var$Jkb(this.b.b, this, 0) + $61de1ee1cac498ae$var$Fe(this.a);
};
var $61de1ee1cac498ae$var$cR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fne, "Layer", 29);
$61de1ee1cac498ae$var$bcb(1342, 1, {}, $61de1ee1cac498ae$var$a2b);
var $61de1ee1cac498ae$var$mR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, $61de1ee1cac498ae$var$une, 1342);
$61de1ee1cac498ae$var$bcb(1346, 1, {}, $61de1ee1cac498ae$var$e2b);
$61de1ee1cac498ae$var$_.Kb = function f2b(a) {
    return $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD(a, 82));
};
var $61de1ee1cac498ae$var$dR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphImporter/0methodref$connectableShapeToNode$Type", 1346);
$61de1ee1cac498ae$var$bcb(1349, 1, {}, $61de1ee1cac498ae$var$g2b);
$61de1ee1cac498ae$var$_.Kb = function h2b(a) {
    return $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD(a, 82));
};
var $61de1ee1cac498ae$var$eR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphImporter/1methodref$connectableShapeToNode$Type", 1349);
$61de1ee1cac498ae$var$bcb(1343, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$i2b);
$61de1ee1cac498ae$var$_.td = function j2b(a) {
    $61de1ee1cac498ae$var$Q1b(this.a, $61de1ee1cac498ae$var$BD(a, 118));
};
var $61de1ee1cac498ae$var$fR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, $61de1ee1cac498ae$var$vne, 1343);
$61de1ee1cac498ae$var$bcb(1344, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$k2b);
$61de1ee1cac498ae$var$_.td = function l2b(a) {
    $61de1ee1cac498ae$var$Q1b(this.a, $61de1ee1cac498ae$var$BD(a, 118));
};
var $61de1ee1cac498ae$var$gR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, $61de1ee1cac498ae$var$wne, 1344);
$61de1ee1cac498ae$var$bcb(1345, 1, {}, $61de1ee1cac498ae$var$m2b);
$61de1ee1cac498ae$var$_.Kb = function n2b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$Old($61de1ee1cac498ae$var$BD(a, 79)), 16));
};
var $61de1ee1cac498ae$var$hR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, $61de1ee1cac498ae$var$xne, 1345);
$61de1ee1cac498ae$var$bcb(1347, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$o2b);
$61de1ee1cac498ae$var$_.Mb = function p2b(a) {
    return $61de1ee1cac498ae$var$b2b(this.a, $61de1ee1cac498ae$var$BD(a, 33));
};
var $61de1ee1cac498ae$var$iR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, $61de1ee1cac498ae$var$yne, 1347);
$61de1ee1cac498ae$var$bcb(1348, 1, {}, $61de1ee1cac498ae$var$q2b);
$61de1ee1cac498ae$var$_.Kb = function r2b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$Nld($61de1ee1cac498ae$var$BD(a, 79)), 16));
};
var $61de1ee1cac498ae$var$jR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphImporter/lambda$5$Type", 1348);
$61de1ee1cac498ae$var$bcb(1350, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$s2b);
$61de1ee1cac498ae$var$_.Mb = function t2b(a) {
    return $61de1ee1cac498ae$var$c2b(this.a, $61de1ee1cac498ae$var$BD(a, 33));
};
var $61de1ee1cac498ae$var$kR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphImporter/lambda$7$Type", 1350);
$61de1ee1cac498ae$var$bcb(1351, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$u2b);
$61de1ee1cac498ae$var$_.Mb = function v2b(a) {
    return $61de1ee1cac498ae$var$d2b($61de1ee1cac498ae$var$BD(a, 79));
};
var $61de1ee1cac498ae$var$lR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphImporter/lambda$8$Type", 1351);
$61de1ee1cac498ae$var$bcb(1278, 1, {}, $61de1ee1cac498ae$var$D2b);
var $61de1ee1cac498ae$var$w2b;
var $61de1ee1cac498ae$var$rR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphLayoutTransferrer", 1278);
$61de1ee1cac498ae$var$bcb(1279, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$G2b);
$61de1ee1cac498ae$var$_.Mb = function H2b(a) {
    return $61de1ee1cac498ae$var$E2b(this.a, $61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$nR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphLayoutTransferrer/lambda$0$Type", 1279);
$61de1ee1cac498ae$var$bcb(1280, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$I2b);
$61de1ee1cac498ae$var$_.td = function J2b(a) {
    $61de1ee1cac498ae$var$x2b();
    $61de1ee1cac498ae$var$Ekb(this.a, $61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$oR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphLayoutTransferrer/lambda$1$Type", 1280);
$61de1ee1cac498ae$var$bcb(1281, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$K2b);
$61de1ee1cac498ae$var$_.Mb = function L2b(a) {
    return $61de1ee1cac498ae$var$F2b(this.a, $61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$pR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphLayoutTransferrer/lambda$2$Type", 1281);
$61de1ee1cac498ae$var$bcb(1282, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$M2b);
$61de1ee1cac498ae$var$_.td = function N2b(a) {
    $61de1ee1cac498ae$var$x2b();
    $61de1ee1cac498ae$var$Ekb(this.a, $61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$qR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tne, "ElkGraphLayoutTransferrer/lambda$3$Type", 1282);
$61de1ee1cac498ae$var$bcb(1485, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$S2b);
$61de1ee1cac498ae$var$_.pf = function T2b(a, b) {
    $61de1ee1cac498ae$var$Q2b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$uR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "CommentNodeMarginCalculator", 1485);
$61de1ee1cac498ae$var$bcb(1486, 1, {}, $61de1ee1cac498ae$var$U2b);
$61de1ee1cac498ae$var$_.Kb = function V2b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$sR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "CommentNodeMarginCalculator/lambda$0$Type", 1486);
$61de1ee1cac498ae$var$bcb(1487, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$W2b);
$61de1ee1cac498ae$var$_.td = function X2b(a) {
    $61de1ee1cac498ae$var$R2b($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$tR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "CommentNodeMarginCalculator/lambda$1$Type", 1487);
$61de1ee1cac498ae$var$bcb(1488, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$_2b);
$61de1ee1cac498ae$var$_.pf = function a3b(a, b) {
    $61de1ee1cac498ae$var$Z2b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$vR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "CommentPostprocessor", 1488);
$61de1ee1cac498ae$var$bcb(1489, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$e3b);
$61de1ee1cac498ae$var$_.pf = function f3b(a, b) {
    $61de1ee1cac498ae$var$b3b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$wR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "CommentPreprocessor", 1489);
$61de1ee1cac498ae$var$bcb(1490, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$h3b);
$61de1ee1cac498ae$var$_.pf = function i3b(a, b) {
    $61de1ee1cac498ae$var$g3b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$xR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "ConstraintsPostprocessor", 1490);
$61de1ee1cac498ae$var$bcb(1491, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$p3b);
$61de1ee1cac498ae$var$_.pf = function q3b(a, b) {
    $61de1ee1cac498ae$var$n3b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$yR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EdgeAndLayerConstraintEdgeReverser", 1491);
$61de1ee1cac498ae$var$bcb(1492, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$t3b);
$61de1ee1cac498ae$var$_.pf = function v3b(a, b) {
    $61de1ee1cac498ae$var$r3b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$CR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPostprocessor", 1492);
$61de1ee1cac498ae$var$bcb(1493, 1, {}, $61de1ee1cac498ae$var$w3b);
$61de1ee1cac498ae$var$_.Kb = function x3b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$zR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPostprocessor/lambda$0$Type", 1493);
$61de1ee1cac498ae$var$bcb(1494, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$y3b);
$61de1ee1cac498ae$var$_.Mb = function z3b(a) {
    return $61de1ee1cac498ae$var$u3b($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$AR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPostprocessor/lambda$1$Type", 1494);
$61de1ee1cac498ae$var$bcb(1495, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$A3b);
$61de1ee1cac498ae$var$_.td = function B3b(a) {
    $61de1ee1cac498ae$var$s3b($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$BR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPostprocessor/lambda$2$Type", 1495);
$61de1ee1cac498ae$var$bcb(1496, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$M3b);
$61de1ee1cac498ae$var$_.pf = function P3b(a, b) {
    $61de1ee1cac498ae$var$I3b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$JR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPreprocessor", 1496);
$61de1ee1cac498ae$var$bcb(1497, 1, {}, $61de1ee1cac498ae$var$Q3b);
$61de1ee1cac498ae$var$_.Kb = function R3b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$DR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPreprocessor/lambda$0$Type", 1497);
$61de1ee1cac498ae$var$bcb(1498, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$S3b);
$61de1ee1cac498ae$var$_.td = function T3b(a) {
    $61de1ee1cac498ae$var$E3b(this.a, this.b, this.c, $61de1ee1cac498ae$var$BD(a, 10));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$ER = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPreprocessor/lambda$1$Type", 1498);
$61de1ee1cac498ae$var$bcb(1499, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$U3b);
$61de1ee1cac498ae$var$_.Mb = function V3b(a) {
    return $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$pad));
};
var $61de1ee1cac498ae$var$FR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPreprocessor/lambda$2$Type", 1499);
$61de1ee1cac498ae$var$bcb(1500, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$W3b);
$61de1ee1cac498ae$var$_.td = function X3b(a) {
    $61de1ee1cac498ae$var$Dsb(this.a, $61de1ee1cac498ae$var$BD(a, 70));
};
var $61de1ee1cac498ae$var$GR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPreprocessor/lambda$3$Type", 1500);
$61de1ee1cac498ae$var$bcb(1501, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Y3b);
$61de1ee1cac498ae$var$_.Mb = function Z3b(a) {
    return $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$oad));
};
var $61de1ee1cac498ae$var$HR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPreprocessor/lambda$4$Type", 1501);
$61de1ee1cac498ae$var$bcb(1502, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$$3b);
$61de1ee1cac498ae$var$_.td = function _3b(a) {
    $61de1ee1cac498ae$var$Dsb(this.a, $61de1ee1cac498ae$var$BD(a, 70));
};
var $61de1ee1cac498ae$var$IR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelPreprocessor/lambda$5$Type", 1502);
$61de1ee1cac498ae$var$bcb(1551, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$i4b);
$61de1ee1cac498ae$var$_.pf = function j4b(a, b) {
    $61de1ee1cac498ae$var$f4b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$a4b;
var $61de1ee1cac498ae$var$RR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter", 1551);
$61de1ee1cac498ae$var$bcb(1552, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$l4b);
$61de1ee1cac498ae$var$_.ue = function m4b(a, b) {
    return $61de1ee1cac498ae$var$k4b($61de1ee1cac498ae$var$BD(a, 456), $61de1ee1cac498ae$var$BD(b, 456));
};
$61de1ee1cac498ae$var$_.Fb = function n4b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function o4b() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$KR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter/1", 1552);
$61de1ee1cac498ae$var$bcb(456, 1, {
    456: 1
}, $61de1ee1cac498ae$var$p4b);
var $61de1ee1cac498ae$var$LR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter/LabelGroup", 456);
$61de1ee1cac498ae$var$bcb(1553, 1, {}, $61de1ee1cac498ae$var$q4b);
$61de1ee1cac498ae$var$_.Kb = function r4b(a) {
    return $61de1ee1cac498ae$var$b4b(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$MR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter/lambda$0$Type", 1553);
$61de1ee1cac498ae$var$bcb(1554, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$s4b);
$61de1ee1cac498ae$var$_.Mb = function t4b(a) {
    return $61de1ee1cac498ae$var$b4b(), $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$NR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter/lambda$1$Type", 1554);
$61de1ee1cac498ae$var$bcb(1555, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$u4b);
$61de1ee1cac498ae$var$_.td = function v4b(a) {
    $61de1ee1cac498ae$var$g4b($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$OR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter/lambda$2$Type", 1555);
$61de1ee1cac498ae$var$bcb(1556, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$w4b);
$61de1ee1cac498ae$var$_.Mb = function x4b(a) {
    return $61de1ee1cac498ae$var$b4b(), $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$oad));
};
var $61de1ee1cac498ae$var$PR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter/lambda$3$Type", 1556);
$61de1ee1cac498ae$var$bcb(1557, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$y4b);
$61de1ee1cac498ae$var$_.Mb = function z4b(a) {
    return $61de1ee1cac498ae$var$b4b(), $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$pad));
};
var $61de1ee1cac498ae$var$QR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "EndLabelSorter/lambda$4$Type", 1557);
$61de1ee1cac498ae$var$bcb(1503, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$L4b);
$61de1ee1cac498ae$var$_.pf = function M4b(a, b) {
    $61de1ee1cac498ae$var$J4b(this, $61de1ee1cac498ae$var$BD(a, 37));
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$YR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "FinalSplineBendpointsCalculator", 1503);
$61de1ee1cac498ae$var$bcb(1504, 1, {}, $61de1ee1cac498ae$var$N4b);
$61de1ee1cac498ae$var$_.Kb = function O4b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$SR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "FinalSplineBendpointsCalculator/lambda$0$Type", 1504);
$61de1ee1cac498ae$var$bcb(1505, 1, {}, $61de1ee1cac498ae$var$P4b);
$61de1ee1cac498ae$var$_.Kb = function Q4b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b($61de1ee1cac498ae$var$BD(a, 10)).a.Kc(), new $61de1ee1cac498ae$var$Sq))));
};
var $61de1ee1cac498ae$var$TR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "FinalSplineBendpointsCalculator/lambda$1$Type", 1505);
$61de1ee1cac498ae$var$bcb(1506, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$R4b);
$61de1ee1cac498ae$var$_.Mb = function S4b(a) {
    return !$61de1ee1cac498ae$var$OZb($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$UR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "FinalSplineBendpointsCalculator/lambda$2$Type", 1506);
$61de1ee1cac498ae$var$bcb(1507, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$T4b);
$61de1ee1cac498ae$var$_.Mb = function U4b(a) {
    return $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 17), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$rtc));
};
var $61de1ee1cac498ae$var$VR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "FinalSplineBendpointsCalculator/lambda$3$Type", 1507);
$61de1ee1cac498ae$var$bcb(1508, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$V4b);
$61de1ee1cac498ae$var$_.td = function W4b(a) {
    $61de1ee1cac498ae$var$C4b(this.a, $61de1ee1cac498ae$var$BD(a, 128));
};
var $61de1ee1cac498ae$var$WR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "FinalSplineBendpointsCalculator/lambda$4$Type", 1508);
$61de1ee1cac498ae$var$bcb(1509, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$X4b);
$61de1ee1cac498ae$var$_.td = function Y4b(a) {
    $61de1ee1cac498ae$var$smb($61de1ee1cac498ae$var$BD(a, 17).a);
};
var $61de1ee1cac498ae$var$XR = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "FinalSplineBendpointsCalculator/lambda$5$Type", 1509);
$61de1ee1cac498ae$var$bcb(792, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$u5b);
$61de1ee1cac498ae$var$_.pf = function v5b(a, b) {
    $61de1ee1cac498ae$var$l5b(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$$R = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "GraphTransformer", 792);
$61de1ee1cac498ae$var$bcb(511, 22, {
    3: 1,
    35: 1,
    22: 1,
    511: 1
}, $61de1ee1cac498ae$var$z5b);
var $61de1ee1cac498ae$var$w5b, $61de1ee1cac498ae$var$x5b;
var $61de1ee1cac498ae$var$ZR = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ane, "GraphTransformer/Mode", 511, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$B5b, $61de1ee1cac498ae$var$A5b);
var $61de1ee1cac498ae$var$C5b;
$61de1ee1cac498ae$var$bcb(1510, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$I5b);
$61de1ee1cac498ae$var$_.pf = function J5b(a, b) {
    $61de1ee1cac498ae$var$F5b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$_R = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalNodeResizingProcessor", 1510);
$61de1ee1cac498ae$var$bcb(1511, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Q5b);
$61de1ee1cac498ae$var$_.pf = function R5b(a, b) {
    $61de1ee1cac498ae$var$M5b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$bS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalPortConstraintProcessor", 1511);
$61de1ee1cac498ae$var$bcb(1512, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$T5b);
$61de1ee1cac498ae$var$_.ue = function U5b(a, b) {
    return $61de1ee1cac498ae$var$S5b($61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function V5b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function W5b() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$aS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalPortConstraintProcessor/NodeComparator", 1512);
$61de1ee1cac498ae$var$bcb(1513, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Z5b);
$61de1ee1cac498ae$var$_.pf = function $5b(a, b) {
    $61de1ee1cac498ae$var$X5b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$cS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalPortDummySizeProcessor", 1513);
$61de1ee1cac498ae$var$bcb(1514, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$l6b);
$61de1ee1cac498ae$var$_.pf = function m6b(a, b) {
    $61de1ee1cac498ae$var$e6b(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$fS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalPortOrthogonalEdgeRouter", 1514);
$61de1ee1cac498ae$var$bcb(1515, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$o6b);
$61de1ee1cac498ae$var$_.ue = function p6b(a, b) {
    return $61de1ee1cac498ae$var$n6b($61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function q6b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function r6b() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$dS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalPortOrthogonalEdgeRouter/1", 1515);
$61de1ee1cac498ae$var$bcb(1516, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$t6b);
$61de1ee1cac498ae$var$_.ue = function u6b(a, b) {
    return $61de1ee1cac498ae$var$s6b($61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function v6b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function w6b() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$eS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalPortOrthogonalEdgeRouter/2", 1516);
$61de1ee1cac498ae$var$bcb(1517, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$z6b);
$61de1ee1cac498ae$var$_.pf = function A6b(a, b) {
    $61de1ee1cac498ae$var$y6b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$gS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HierarchicalPortPositionProcessor", 1517);
$61de1ee1cac498ae$var$bcb(1518, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$J6b);
$61de1ee1cac498ae$var$_.pf = function K6b(a, b) {
    $61de1ee1cac498ae$var$I6b(this, $61de1ee1cac498ae$var$BD(a, 37));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$B6b, $61de1ee1cac498ae$var$C6b;
var $61de1ee1cac498ae$var$kS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HighDegreeNodeLayeringProcessor", 1518);
$61de1ee1cac498ae$var$bcb(571, 1, {
    571: 1
}, $61de1ee1cac498ae$var$L6b);
$61de1ee1cac498ae$var$_.b = -1;
$61de1ee1cac498ae$var$_.d = -1;
var $61de1ee1cac498ae$var$hS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HighDegreeNodeLayeringProcessor/HighDegreeNodeInformation", 571);
$61de1ee1cac498ae$var$bcb(1519, 1, {}, $61de1ee1cac498ae$var$M6b);
$61de1ee1cac498ae$var$_.Kb = function N6b(a) {
    return $61de1ee1cac498ae$var$D6b(), $61de1ee1cac498ae$var$R_b($61de1ee1cac498ae$var$BD(a, 10));
};
$61de1ee1cac498ae$var$_.Fb = function O6b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$iS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HighDegreeNodeLayeringProcessor/lambda$0$Type", 1519);
$61de1ee1cac498ae$var$bcb(1520, 1, {}, $61de1ee1cac498ae$var$P6b);
$61de1ee1cac498ae$var$_.Kb = function Q6b(a) {
    return $61de1ee1cac498ae$var$D6b(), $61de1ee1cac498ae$var$U_b($61de1ee1cac498ae$var$BD(a, 10));
};
$61de1ee1cac498ae$var$_.Fb = function R6b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$jS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HighDegreeNodeLayeringProcessor/lambda$1$Type", 1520);
$61de1ee1cac498ae$var$bcb(1526, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$X6b);
$61de1ee1cac498ae$var$_.pf = function Y6b(a, b) {
    $61de1ee1cac498ae$var$W6b(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$pS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HyperedgeDummyMerger", 1526);
$61de1ee1cac498ae$var$bcb(793, 1, {}, $61de1ee1cac498ae$var$Z6b);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$lS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HyperedgeDummyMerger/MergeState", 793);
$61de1ee1cac498ae$var$bcb(1527, 1, {}, $61de1ee1cac498ae$var$$6b);
$61de1ee1cac498ae$var$_.Kb = function _6b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$mS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HyperedgeDummyMerger/lambda$0$Type", 1527);
$61de1ee1cac498ae$var$bcb(1528, 1, {}, $61de1ee1cac498ae$var$a7b);
$61de1ee1cac498ae$var$_.Kb = function b7b(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 10).j, 16));
};
var $61de1ee1cac498ae$var$nS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HyperedgeDummyMerger/lambda$1$Type", 1528);
$61de1ee1cac498ae$var$bcb(1529, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$c7b);
$61de1ee1cac498ae$var$_.td = function d7b(a) {
    $61de1ee1cac498ae$var$BD(a, 11).p = -1;
};
var $61de1ee1cac498ae$var$oS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HyperedgeDummyMerger/lambda$2$Type", 1529);
$61de1ee1cac498ae$var$bcb(1530, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$g7b);
$61de1ee1cac498ae$var$_.pf = function h7b(a, b) {
    $61de1ee1cac498ae$var$f7b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$qS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "HypernodesProcessor", 1530);
$61de1ee1cac498ae$var$bcb(1531, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$j7b);
$61de1ee1cac498ae$var$_.pf = function k7b(a, b) {
    $61de1ee1cac498ae$var$i7b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$rS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InLayerConstraintProcessor", 1531);
$61de1ee1cac498ae$var$bcb(1532, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$m7b);
$61de1ee1cac498ae$var$_.pf = function n7b(a, b) {
    $61de1ee1cac498ae$var$l7b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$sS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InnermostNodeMarginCalculator", 1532);
$61de1ee1cac498ae$var$bcb(1533, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$r7b);
$61de1ee1cac498ae$var$_.pf = function w7b(a, b) {
    $61de1ee1cac498ae$var$q7b(this, $61de1ee1cac498ae$var$BD(a, 37));
};
$61de1ee1cac498ae$var$_.a = $61de1ee1cac498ae$var$Qje;
$61de1ee1cac498ae$var$_.b = $61de1ee1cac498ae$var$Qje;
$61de1ee1cac498ae$var$_.c = $61de1ee1cac498ae$var$Pje;
$61de1ee1cac498ae$var$_.d = $61de1ee1cac498ae$var$Pje;
var $61de1ee1cac498ae$var$zS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InteractiveExternalPortPositioner", 1533);
$61de1ee1cac498ae$var$bcb(1534, 1, {}, $61de1ee1cac498ae$var$x7b);
$61de1ee1cac498ae$var$_.Kb = function y7b(a) {
    return $61de1ee1cac498ae$var$BD(a, 17).d.i;
};
$61de1ee1cac498ae$var$_.Fb = function z7b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$tS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InteractiveExternalPortPositioner/lambda$0$Type", 1534);
$61de1ee1cac498ae$var$bcb(1535, 1, {}, $61de1ee1cac498ae$var$A7b);
$61de1ee1cac498ae$var$_.Kb = function B7b(a) {
    return $61de1ee1cac498ae$var$s7b(this.a, $61de1ee1cac498ae$var$ED(a));
};
$61de1ee1cac498ae$var$_.Fb = function C7b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$uS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InteractiveExternalPortPositioner/lambda$1$Type", 1535);
$61de1ee1cac498ae$var$bcb(1536, 1, {}, $61de1ee1cac498ae$var$D7b);
$61de1ee1cac498ae$var$_.Kb = function E7b(a) {
    return $61de1ee1cac498ae$var$BD(a, 17).c.i;
};
$61de1ee1cac498ae$var$_.Fb = function F7b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$vS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InteractiveExternalPortPositioner/lambda$2$Type", 1536);
$61de1ee1cac498ae$var$bcb(1537, 1, {}, $61de1ee1cac498ae$var$G7b);
$61de1ee1cac498ae$var$_.Kb = function H7b(a) {
    return $61de1ee1cac498ae$var$t7b(this.a, $61de1ee1cac498ae$var$ED(a));
};
$61de1ee1cac498ae$var$_.Fb = function I7b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$wS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InteractiveExternalPortPositioner/lambda$3$Type", 1537);
$61de1ee1cac498ae$var$bcb(1538, 1, {}, $61de1ee1cac498ae$var$J7b);
$61de1ee1cac498ae$var$_.Kb = function K7b(a) {
    return $61de1ee1cac498ae$var$u7b(this.a, $61de1ee1cac498ae$var$ED(a));
};
$61de1ee1cac498ae$var$_.Fb = function L7b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$xS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InteractiveExternalPortPositioner/lambda$4$Type", 1538);
$61de1ee1cac498ae$var$bcb(1539, 1, {}, $61de1ee1cac498ae$var$M7b);
$61de1ee1cac498ae$var$_.Kb = function N7b(a) {
    return $61de1ee1cac498ae$var$v7b(this.a, $61de1ee1cac498ae$var$ED(a));
};
$61de1ee1cac498ae$var$_.Fb = function O7b(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$yS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InteractiveExternalPortPositioner/lambda$5$Type", 1539);
$61de1ee1cac498ae$var$bcb(77, 22, {
    3: 1,
    35: 1,
    22: 1,
    77: 1,
    234: 1
}, $61de1ee1cac498ae$var$T8b);
$61de1ee1cac498ae$var$_.Kf = function U8b() {
    switch(this.g){
        case 15:
            return new $61de1ee1cac498ae$var$eoc;
        case 22:
            return new $61de1ee1cac498ae$var$Aoc;
        case 47:
            return new $61de1ee1cac498ae$var$Joc;
        case 28:
        case 35:
            return new $61de1ee1cac498ae$var$uac;
        case 32:
            return new $61de1ee1cac498ae$var$S2b;
        case 42:
            return new $61de1ee1cac498ae$var$_2b;
        case 1:
            return new $61de1ee1cac498ae$var$e3b;
        case 41:
            return new $61de1ee1cac498ae$var$h3b;
        case 56:
            return new $61de1ee1cac498ae$var$u5b(($61de1ee1cac498ae$var$y5b(), $61de1ee1cac498ae$var$x5b));
        case 0:
            return new $61de1ee1cac498ae$var$u5b(($61de1ee1cac498ae$var$y5b(), $61de1ee1cac498ae$var$w5b));
        case 2:
            return new $61de1ee1cac498ae$var$p3b;
        case 54:
            return new $61de1ee1cac498ae$var$t3b;
        case 33:
            return new $61de1ee1cac498ae$var$M3b;
        case 51:
            return new $61de1ee1cac498ae$var$L4b;
        case 55:
            return new $61de1ee1cac498ae$var$I5b;
        case 13:
            return new $61de1ee1cac498ae$var$Q5b;
        case 38:
            return new $61de1ee1cac498ae$var$Z5b;
        case 44:
            return new $61de1ee1cac498ae$var$l6b;
        case 40:
            return new $61de1ee1cac498ae$var$z6b;
        case 9:
            return new $61de1ee1cac498ae$var$J6b;
        case 49:
            return new $61de1ee1cac498ae$var$sgc;
        case 37:
            return new $61de1ee1cac498ae$var$X6b;
        case 43:
            return new $61de1ee1cac498ae$var$g7b;
        case 27:
            return new $61de1ee1cac498ae$var$j7b;
        case 30:
            return new $61de1ee1cac498ae$var$m7b;
        case 3:
            return new $61de1ee1cac498ae$var$r7b;
        case 18:
            return new $61de1ee1cac498ae$var$b9b;
        case 29:
            return new $61de1ee1cac498ae$var$h9b;
        case 5:
            return new $61de1ee1cac498ae$var$u9b;
        case 50:
            return new $61de1ee1cac498ae$var$D9b;
        case 34:
            return new $61de1ee1cac498ae$var$$9b;
        case 36:
            return new $61de1ee1cac498ae$var$Iac;
        case 52:
            return new $61de1ee1cac498ae$var$i4b;
        case 11:
            return new $61de1ee1cac498ae$var$Sac;
        case 7:
            return new $61de1ee1cac498ae$var$abc;
        case 39:
            return new $61de1ee1cac498ae$var$obc;
        case 45:
            return new $61de1ee1cac498ae$var$rbc;
        case 16:
            return new $61de1ee1cac498ae$var$vbc;
        case 10:
            return new $61de1ee1cac498ae$var$Fbc;
        case 48:
            return new $61de1ee1cac498ae$var$Xbc;
        case 21:
            return new $61de1ee1cac498ae$var$ccc;
        case 23:
            return new $61de1ee1cac498ae$var$fGc(($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$pGc));
        case 8:
            return new $61de1ee1cac498ae$var$lcc;
        case 12:
            return new $61de1ee1cac498ae$var$tcc;
        case 4:
            return new $61de1ee1cac498ae$var$ycc;
        case 19:
            return new $61de1ee1cac498ae$var$Tcc;
        case 17:
            return new $61de1ee1cac498ae$var$pdc;
        case 53:
            return new $61de1ee1cac498ae$var$sdc;
        case 6:
            return new $61de1ee1cac498ae$var$hec;
        case 25:
            return new $61de1ee1cac498ae$var$wdc;
        case 46:
            return new $61de1ee1cac498ae$var$Ndc;
        case 31:
            return new $61de1ee1cac498ae$var$sec;
        case 14:
            return new $61de1ee1cac498ae$var$Fec;
        case 26:
            return new $61de1ee1cac498ae$var$ppc;
        case 20:
            return new $61de1ee1cac498ae$var$Uec;
        case 24:
            return new $61de1ee1cac498ae$var$fGc(($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$qGc));
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Dne + (this.f != null ? this.f : "" + this.g)));
    }
};
var $61de1ee1cac498ae$var$P7b, $61de1ee1cac498ae$var$Q7b, $61de1ee1cac498ae$var$R7b, $61de1ee1cac498ae$var$S7b, $61de1ee1cac498ae$var$T7b, $61de1ee1cac498ae$var$U7b, $61de1ee1cac498ae$var$V7b, $61de1ee1cac498ae$var$W7b, $61de1ee1cac498ae$var$X7b, $61de1ee1cac498ae$var$Y7b, $61de1ee1cac498ae$var$Z7b, $61de1ee1cac498ae$var$$7b, $61de1ee1cac498ae$var$_7b, $61de1ee1cac498ae$var$a8b, $61de1ee1cac498ae$var$b8b, $61de1ee1cac498ae$var$c8b, $61de1ee1cac498ae$var$d8b, $61de1ee1cac498ae$var$e8b, $61de1ee1cac498ae$var$f8b, $61de1ee1cac498ae$var$g8b, $61de1ee1cac498ae$var$h8b, $61de1ee1cac498ae$var$i8b, $61de1ee1cac498ae$var$j8b, $61de1ee1cac498ae$var$k8b, $61de1ee1cac498ae$var$l8b, $61de1ee1cac498ae$var$m8b, $61de1ee1cac498ae$var$n8b, $61de1ee1cac498ae$var$o8b, $61de1ee1cac498ae$var$p8b, $61de1ee1cac498ae$var$q8b, $61de1ee1cac498ae$var$r8b, $61de1ee1cac498ae$var$s8b, $61de1ee1cac498ae$var$t8b, $61de1ee1cac498ae$var$u8b, $61de1ee1cac498ae$var$v8b, $61de1ee1cac498ae$var$w8b, $61de1ee1cac498ae$var$x8b, $61de1ee1cac498ae$var$y8b, $61de1ee1cac498ae$var$z8b, $61de1ee1cac498ae$var$A8b, $61de1ee1cac498ae$var$B8b, $61de1ee1cac498ae$var$C8b, $61de1ee1cac498ae$var$D8b, $61de1ee1cac498ae$var$E8b, $61de1ee1cac498ae$var$F8b, $61de1ee1cac498ae$var$G8b, $61de1ee1cac498ae$var$H8b, $61de1ee1cac498ae$var$I8b, $61de1ee1cac498ae$var$J8b, $61de1ee1cac498ae$var$K8b, $61de1ee1cac498ae$var$L8b, $61de1ee1cac498ae$var$M8b, $61de1ee1cac498ae$var$N8b, $61de1ee1cac498ae$var$O8b, $61de1ee1cac498ae$var$P8b, $61de1ee1cac498ae$var$Q8b, $61de1ee1cac498ae$var$R8b;
var $61de1ee1cac498ae$var$AS = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ane, $61de1ee1cac498ae$var$Ene, 77, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$W8b, $61de1ee1cac498ae$var$V8b);
var $61de1ee1cac498ae$var$X8b;
$61de1ee1cac498ae$var$bcb(1540, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$b9b);
$61de1ee1cac498ae$var$_.pf = function c9b(a, b) {
    $61de1ee1cac498ae$var$_8b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$BS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "InvertedPortProcessor", 1540);
$61de1ee1cac498ae$var$bcb(1541, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$h9b);
$61de1ee1cac498ae$var$_.pf = function i9b(a, b) {
    $61de1ee1cac498ae$var$g9b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$FS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelAndNodeSizeProcessor", 1541);
$61de1ee1cac498ae$var$bcb(1542, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$j9b);
$61de1ee1cac498ae$var$_.Mb = function k9b(a) {
    return $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$CS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelAndNodeSizeProcessor/lambda$0$Type", 1542);
$61de1ee1cac498ae$var$bcb(1543, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$l9b);
$61de1ee1cac498ae$var$_.Mb = function m9b(a) {
    return $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b);
};
var $61de1ee1cac498ae$var$DS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelAndNodeSizeProcessor/lambda$1$Type", 1543);
$61de1ee1cac498ae$var$bcb(1544, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$n9b);
$61de1ee1cac498ae$var$_.td = function o9b(a) {
    $61de1ee1cac498ae$var$e9b(this.b, this.a, this.c, $61de1ee1cac498ae$var$BD(a, 10));
};
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$ES = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelAndNodeSizeProcessor/lambda$2$Type", 1544);
$61de1ee1cac498ae$var$bcb(1545, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$u9b);
$61de1ee1cac498ae$var$_.pf = function v9b(a, b) {
    $61de1ee1cac498ae$var$s9b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$p9b;
var $61de1ee1cac498ae$var$HS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummyInserter", 1545);
$61de1ee1cac498ae$var$bcb(1546, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$w9b);
$61de1ee1cac498ae$var$_.Lb = function x9b(a) {
    return $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$nad));
};
$61de1ee1cac498ae$var$_.Fb = function y9b(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function z9b(a) {
    return $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Qwc))) === $61de1ee1cac498ae$var$PD(($61de1ee1cac498ae$var$qad(), $61de1ee1cac498ae$var$nad));
};
var $61de1ee1cac498ae$var$GS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummyInserter/1", 1546);
$61de1ee1cac498ae$var$bcb(1547, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$D9b);
$61de1ee1cac498ae$var$_.pf = function E9b(a, b) {
    $61de1ee1cac498ae$var$C9b($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$JS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummyRemover", 1547);
$61de1ee1cac498ae$var$bcb(1548, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$F9b);
$61de1ee1cac498ae$var$_.Mb = function G9b(a) {
    return $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Pwc))));
};
var $61de1ee1cac498ae$var$IS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummyRemover/lambda$0$Type", 1548);
$61de1ee1cac498ae$var$bcb(1359, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$$9b);
$61de1ee1cac498ae$var$_.pf = function cac(a, b) {
    $61de1ee1cac498ae$var$W9b(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.a = null;
var $61de1ee1cac498ae$var$H9b;
var $61de1ee1cac498ae$var$QS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummySwitcher", 1359);
$61de1ee1cac498ae$var$bcb(286, 1, {
    286: 1
}, $61de1ee1cac498ae$var$gac);
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = null;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$KS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummySwitcher/LabelDummyInfo", 286);
$61de1ee1cac498ae$var$bcb(1360, 1, {}, $61de1ee1cac498ae$var$hac);
$61de1ee1cac498ae$var$_.Kb = function iac(a) {
    return $61de1ee1cac498ae$var$I9b(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$LS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummySwitcher/lambda$0$Type", 1360);
$61de1ee1cac498ae$var$bcb(1361, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$jac);
$61de1ee1cac498ae$var$_.Mb = function kac(a) {
    return $61de1ee1cac498ae$var$I9b(), $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$f0b);
};
var $61de1ee1cac498ae$var$MS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummySwitcher/lambda$1$Type", 1361);
$61de1ee1cac498ae$var$bcb(1362, 1, {}, $61de1ee1cac498ae$var$lac);
$61de1ee1cac498ae$var$_.Kb = function mac(a) {
    return $61de1ee1cac498ae$var$_9b(this.a, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$NS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummySwitcher/lambda$2$Type", 1362);
$61de1ee1cac498ae$var$bcb(1363, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$nac);
$61de1ee1cac498ae$var$_.td = function oac(a) {
    $61de1ee1cac498ae$var$aac(this.a, $61de1ee1cac498ae$var$BD(a, 286));
};
var $61de1ee1cac498ae$var$OS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummySwitcher/lambda$3$Type", 1363);
$61de1ee1cac498ae$var$bcb(1364, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$pac);
$61de1ee1cac498ae$var$_.ue = function qac(a, b) {
    return $61de1ee1cac498ae$var$bac($61de1ee1cac498ae$var$BD(a, 286), $61de1ee1cac498ae$var$BD(b, 286));
};
$61de1ee1cac498ae$var$_.Fb = function rac(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function sac() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$PS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelDummySwitcher/lambda$4$Type", 1364);
$61de1ee1cac498ae$var$bcb(791, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$uac);
$61de1ee1cac498ae$var$_.pf = function vac(a, b) {
    $61de1ee1cac498ae$var$tac($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$RS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelManagementProcessor", 791);
$61de1ee1cac498ae$var$bcb(1549, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Iac);
$61de1ee1cac498ae$var$_.pf = function Jac(a, b) {
    $61de1ee1cac498ae$var$Cac($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$TS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelSideSelector", 1549);
$61de1ee1cac498ae$var$bcb(1550, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Kac);
$61de1ee1cac498ae$var$_.Mb = function Lac(a) {
    return $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 70), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Pwc))));
};
var $61de1ee1cac498ae$var$SS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LabelSideSelector/lambda$0$Type", 1550);
$61de1ee1cac498ae$var$bcb(1558, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Sac);
$61de1ee1cac498ae$var$_.pf = function Tac(a, b) {
    $61de1ee1cac498ae$var$Oac($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$US = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LayerConstraintPostprocessor", 1558);
$61de1ee1cac498ae$var$bcb(1559, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$abc);
$61de1ee1cac498ae$var$_.pf = function bbc(a, b) {
    $61de1ee1cac498ae$var$$ac($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$Uac;
var $61de1ee1cac498ae$var$WS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LayerConstraintPreprocessor", 1559);
$61de1ee1cac498ae$var$bcb(360, 22, {
    3: 1,
    35: 1,
    22: 1,
    360: 1
}, $61de1ee1cac498ae$var$ibc);
var $61de1ee1cac498ae$var$cbc, $61de1ee1cac498ae$var$dbc, $61de1ee1cac498ae$var$ebc, $61de1ee1cac498ae$var$fbc;
var $61de1ee1cac498ae$var$VS = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ane, "LayerConstraintPreprocessor/HiddenNodeConnections", 360, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$kbc, $61de1ee1cac498ae$var$jbc);
var $61de1ee1cac498ae$var$lbc;
$61de1ee1cac498ae$var$bcb(1560, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$obc);
$61de1ee1cac498ae$var$_.pf = function pbc(a, b) {
    $61de1ee1cac498ae$var$nbc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$XS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LayerSizeAndGraphHeightCalculator", 1560);
$61de1ee1cac498ae$var$bcb(1561, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$rbc);
$61de1ee1cac498ae$var$_.pf = function tbc(a, b) {
    $61de1ee1cac498ae$var$qbc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$YS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LongEdgeJoiner", 1561);
$61de1ee1cac498ae$var$bcb(1562, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$vbc);
$61de1ee1cac498ae$var$_.pf = function xbc(a, b) {
    $61de1ee1cac498ae$var$ubc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$ZS = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "LongEdgeSplitter", 1562);
$61de1ee1cac498ae$var$bcb(1563, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Fbc);
$61de1ee1cac498ae$var$_.pf = function Ibc(a, b) {
    $61de1ee1cac498ae$var$Bbc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.j = 0;
$61de1ee1cac498ae$var$_.k = 0;
$61de1ee1cac498ae$var$_.n = 0;
var $61de1ee1cac498ae$var$bT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "NodePromotion", 1563);
$61de1ee1cac498ae$var$bcb(1564, 1, {}, $61de1ee1cac498ae$var$Jbc);
$61de1ee1cac498ae$var$_.Kb = function Kbc(a) {
    return $61de1ee1cac498ae$var$BD(a, 46), $61de1ee1cac498ae$var$Bcb(), true;
};
$61de1ee1cac498ae$var$_.Fb = function Lbc(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$$S = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "NodePromotion/lambda$0$Type", 1564);
$61de1ee1cac498ae$var$bcb(1565, 1, {}, $61de1ee1cac498ae$var$Mbc);
$61de1ee1cac498ae$var$_.Kb = function Nbc(a) {
    return $61de1ee1cac498ae$var$Gbc(this.a, $61de1ee1cac498ae$var$BD(a, 46));
};
$61de1ee1cac498ae$var$_.Fb = function Obc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$_S = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "NodePromotion/lambda$1$Type", 1565);
$61de1ee1cac498ae$var$bcb(1566, 1, {}, $61de1ee1cac498ae$var$Pbc);
$61de1ee1cac498ae$var$_.Kb = function Qbc(a) {
    return $61de1ee1cac498ae$var$Hbc(this.a, $61de1ee1cac498ae$var$BD(a, 46));
};
$61de1ee1cac498ae$var$_.Fb = function Rbc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$aT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "NodePromotion/lambda$2$Type", 1566);
$61de1ee1cac498ae$var$bcb(1567, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Xbc);
$61de1ee1cac498ae$var$_.pf = function Ybc(a, b) {
    $61de1ee1cac498ae$var$Sbc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$cT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "NorthSouthPortPostprocessor", 1567);
$61de1ee1cac498ae$var$bcb(1568, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$ccc);
$61de1ee1cac498ae$var$_.pf = function ecc(a, b) {
    $61de1ee1cac498ae$var$acc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$eT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "NorthSouthPortPreprocessor", 1568);
$61de1ee1cac498ae$var$bcb(1569, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$fcc);
$61de1ee1cac498ae$var$_.ue = function gcc(a, b) {
    return $61de1ee1cac498ae$var$dcc($61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function hcc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function icc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$dT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "NorthSouthPortPreprocessor/lambda$0$Type", 1569);
$61de1ee1cac498ae$var$bcb(1570, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$lcc);
$61de1ee1cac498ae$var$_.pf = function ncc(a, b) {
    $61de1ee1cac498ae$var$kcc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$hT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionMidprocessor", 1570);
$61de1ee1cac498ae$var$bcb(1571, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$occ);
$61de1ee1cac498ae$var$_.Mb = function pcc(a) {
    return $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 10), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Nxc));
};
var $61de1ee1cac498ae$var$fT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionMidprocessor/lambda$0$Type", 1571);
$61de1ee1cac498ae$var$bcb(1572, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$qcc);
$61de1ee1cac498ae$var$_.td = function rcc(a) {
    $61de1ee1cac498ae$var$mcc(this.a, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$gT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionMidprocessor/lambda$1$Type", 1572);
$61de1ee1cac498ae$var$bcb(1573, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$tcc);
$61de1ee1cac498ae$var$_.pf = function ucc(a, b) {
    $61de1ee1cac498ae$var$scc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$iT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionPostprocessor", 1573);
$61de1ee1cac498ae$var$bcb(1574, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$ycc);
$61de1ee1cac498ae$var$_.pf = function zcc(a, b) {
    $61de1ee1cac498ae$var$wcc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$nT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionPreprocessor", 1574);
$61de1ee1cac498ae$var$bcb(1575, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Acc);
$61de1ee1cac498ae$var$_.Mb = function Bcc(a) {
    return $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 10), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Nxc));
};
var $61de1ee1cac498ae$var$jT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionPreprocessor/lambda$0$Type", 1575);
$61de1ee1cac498ae$var$bcb(1576, 1, {}, $61de1ee1cac498ae$var$Ccc);
$61de1ee1cac498ae$var$_.Kb = function Dcc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b($61de1ee1cac498ae$var$BD(a, 10)).a.Kc(), new $61de1ee1cac498ae$var$Sq))));
};
var $61de1ee1cac498ae$var$kT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionPreprocessor/lambda$1$Type", 1576);
$61de1ee1cac498ae$var$bcb(1577, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Ecc);
$61de1ee1cac498ae$var$_.Mb = function Fcc(a) {
    return $61de1ee1cac498ae$var$vcc($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$lT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionPreprocessor/lambda$2$Type", 1577);
$61de1ee1cac498ae$var$bcb(1578, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Gcc);
$61de1ee1cac498ae$var$_.td = function Hcc(a) {
    $61de1ee1cac498ae$var$xcc($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$mT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PartitionPreprocessor/lambda$3$Type", 1578);
$61de1ee1cac498ae$var$bcb(1579, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Tcc);
$61de1ee1cac498ae$var$_.pf = function Xcc(a, b) {
    $61de1ee1cac498ae$var$Qcc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$Icc, $61de1ee1cac498ae$var$Jcc, $61de1ee1cac498ae$var$Kcc, $61de1ee1cac498ae$var$Lcc, $61de1ee1cac498ae$var$Mcc, $61de1ee1cac498ae$var$Ncc;
var $61de1ee1cac498ae$var$tT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PortListSorter", 1579);
$61de1ee1cac498ae$var$bcb(1580, 1, {}, $61de1ee1cac498ae$var$Zcc);
$61de1ee1cac498ae$var$_.Kb = function $cc(a) {
    return $61de1ee1cac498ae$var$Occ(), $61de1ee1cac498ae$var$BD(a, 11).e;
};
var $61de1ee1cac498ae$var$oT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PortListSorter/lambda$0$Type", 1580);
$61de1ee1cac498ae$var$bcb(1581, 1, {}, $61de1ee1cac498ae$var$_cc);
$61de1ee1cac498ae$var$_.Kb = function adc(a) {
    return $61de1ee1cac498ae$var$Occ(), $61de1ee1cac498ae$var$BD(a, 11).g;
};
var $61de1ee1cac498ae$var$pT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PortListSorter/lambda$1$Type", 1581);
$61de1ee1cac498ae$var$bcb(1582, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$bdc);
$61de1ee1cac498ae$var$_.ue = function cdc(a, b) {
    return $61de1ee1cac498ae$var$Ucc($61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function ddc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function edc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$qT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PortListSorter/lambda$2$Type", 1582);
$61de1ee1cac498ae$var$bcb(1583, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$fdc);
$61de1ee1cac498ae$var$_.ue = function gdc(a, b) {
    return $61de1ee1cac498ae$var$Vcc($61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function hdc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function idc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$rT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PortListSorter/lambda$3$Type", 1583);
$61de1ee1cac498ae$var$bcb(1584, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$jdc);
$61de1ee1cac498ae$var$_.ue = function kdc(a, b) {
    return $61de1ee1cac498ae$var$Wcc($61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function ldc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function mdc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$sT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PortListSorter/lambda$4$Type", 1584);
$61de1ee1cac498ae$var$bcb(1585, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$pdc);
$61de1ee1cac498ae$var$_.pf = function qdc(a, b) {
    $61de1ee1cac498ae$var$ndc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$uT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "PortSideProcessor", 1585);
$61de1ee1cac498ae$var$bcb(1586, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$sdc);
$61de1ee1cac498ae$var$_.pf = function tdc(a, b) {
    $61de1ee1cac498ae$var$rdc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$vT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "ReversedEdgeRestorer", 1586);
$61de1ee1cac498ae$var$bcb(1591, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$wdc);
$61de1ee1cac498ae$var$_.pf = function xdc(a, b) {
    $61de1ee1cac498ae$var$udc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$CT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPortRestorer", 1591);
$61de1ee1cac498ae$var$bcb(1592, 1, {}, $61de1ee1cac498ae$var$ydc);
$61de1ee1cac498ae$var$_.Kb = function zdc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$wT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPortRestorer/lambda$0$Type", 1592);
$61de1ee1cac498ae$var$bcb(1593, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Adc);
$61de1ee1cac498ae$var$_.Mb = function Bdc(a) {
    return $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$xT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPortRestorer/lambda$1$Type", 1593);
$61de1ee1cac498ae$var$bcb(1594, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Cdc);
$61de1ee1cac498ae$var$_.Mb = function Ddc(a) {
    return $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 10), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ntc));
};
var $61de1ee1cac498ae$var$yT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPortRestorer/lambda$2$Type", 1594);
$61de1ee1cac498ae$var$bcb(1595, 1, {}, $61de1ee1cac498ae$var$Edc);
$61de1ee1cac498ae$var$_.Kb = function Fdc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 10), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ntc)), 403);
};
var $61de1ee1cac498ae$var$zT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPortRestorer/lambda$3$Type", 1595);
$61de1ee1cac498ae$var$bcb(1596, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Gdc);
$61de1ee1cac498ae$var$_.td = function Hdc(a) {
    $61de1ee1cac498ae$var$vdc(this.a, $61de1ee1cac498ae$var$BD(a, 403));
};
var $61de1ee1cac498ae$var$AT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPortRestorer/lambda$4$Type", 1596);
$61de1ee1cac498ae$var$bcb(794, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Idc);
$61de1ee1cac498ae$var$_.td = function Jdc(a) {
    $61de1ee1cac498ae$var$ljc($61de1ee1cac498ae$var$BD(a, 101));
};
var $61de1ee1cac498ae$var$BT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPortRestorer/lambda$5$Type", 794);
$61de1ee1cac498ae$var$bcb(1597, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Ndc);
$61de1ee1cac498ae$var$_.pf = function Pdc(a, b) {
    $61de1ee1cac498ae$var$Kdc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$LT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor", 1597);
$61de1ee1cac498ae$var$bcb(1598, 1, {}, $61de1ee1cac498ae$var$Qdc);
$61de1ee1cac498ae$var$_.Kb = function Rdc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$DT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$0$Type", 1598);
$61de1ee1cac498ae$var$bcb(1599, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Sdc);
$61de1ee1cac498ae$var$_.Mb = function Tdc(a) {
    return $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$ET = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$1$Type", 1599);
$61de1ee1cac498ae$var$bcb(1600, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Udc);
$61de1ee1cac498ae$var$_.Mb = function Vdc(a) {
    return $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 10), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ntc));
};
var $61de1ee1cac498ae$var$FT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$2$Type", 1600);
$61de1ee1cac498ae$var$bcb(1601, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Wdc);
$61de1ee1cac498ae$var$_.td = function Xdc(a) {
    $61de1ee1cac498ae$var$Ldc($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$GT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$3$Type", 1601);
$61de1ee1cac498ae$var$bcb(1602, 1, {}, $61de1ee1cac498ae$var$Ydc);
$61de1ee1cac498ae$var$_.Kb = function Zdc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 101).f, 1));
};
var $61de1ee1cac498ae$var$HT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$4$Type", 1602);
$61de1ee1cac498ae$var$bcb(1603, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$$dc);
$61de1ee1cac498ae$var$_.td = function _dc(a) {
    $61de1ee1cac498ae$var$Mdc(this.a, $61de1ee1cac498ae$var$BD(a, 409));
};
var $61de1ee1cac498ae$var$IT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$5$Type", 1603);
$61de1ee1cac498ae$var$bcb(1604, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$aec);
$61de1ee1cac498ae$var$_.Mb = function bec(a) {
    return !!$61de1ee1cac498ae$var$BD(a, 101).i;
};
var $61de1ee1cac498ae$var$JT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$6$Type", 1604);
$61de1ee1cac498ae$var$bcb(1605, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$cec);
$61de1ee1cac498ae$var$_.td = function dec(a) {
    $61de1ee1cac498ae$var$Odc(this.a, $61de1ee1cac498ae$var$BD(a, 101));
};
var $61de1ee1cac498ae$var$KT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPostProcessor/lambda$7$Type", 1605);
$61de1ee1cac498ae$var$bcb(1587, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$hec);
$61de1ee1cac498ae$var$_.pf = function iec(a, b) {
    $61de1ee1cac498ae$var$gec($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$PT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPreProcessor", 1587);
$61de1ee1cac498ae$var$bcb(1588, 1, {}, $61de1ee1cac498ae$var$jec);
$61de1ee1cac498ae$var$_.Kb = function kec(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 101).f, 1));
};
var $61de1ee1cac498ae$var$MT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPreProcessor/lambda$0$Type", 1588);
$61de1ee1cac498ae$var$bcb(1589, 1, {}, $61de1ee1cac498ae$var$lec);
$61de1ee1cac498ae$var$_.Kb = function mec(a) {
    return $61de1ee1cac498ae$var$BD(a, 409).a;
};
var $61de1ee1cac498ae$var$NT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPreProcessor/lambda$1$Type", 1589);
$61de1ee1cac498ae$var$bcb(1590, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$nec);
$61de1ee1cac498ae$var$_.td = function oec(a) {
    $61de1ee1cac498ae$var$fec($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$OT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopPreProcessor/lambda$2$Type", 1590);
$61de1ee1cac498ae$var$bcb(1606, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$sec);
$61de1ee1cac498ae$var$_.pf = function tec(a, b) {
    $61de1ee1cac498ae$var$qec(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$VT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopRouter", 1606);
$61de1ee1cac498ae$var$bcb(1607, 1, {}, $61de1ee1cac498ae$var$uec);
$61de1ee1cac498ae$var$_.Kb = function vec(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$QT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopRouter/lambda$0$Type", 1607);
$61de1ee1cac498ae$var$bcb(1608, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$wec);
$61de1ee1cac498ae$var$_.Mb = function xec(a) {
    return $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$RT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopRouter/lambda$1$Type", 1608);
$61de1ee1cac498ae$var$bcb(1609, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$yec);
$61de1ee1cac498ae$var$_.Mb = function zec(a) {
    return $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 10), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ntc));
};
var $61de1ee1cac498ae$var$ST = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopRouter/lambda$2$Type", 1609);
$61de1ee1cac498ae$var$bcb(1610, 1, {}, $61de1ee1cac498ae$var$Aec);
$61de1ee1cac498ae$var$_.Kb = function Bec(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 10), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$ntc)), 403);
};
var $61de1ee1cac498ae$var$TT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopRouter/lambda$3$Type", 1610);
$61de1ee1cac498ae$var$bcb(1611, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Cec);
$61de1ee1cac498ae$var$_.td = function Dec(a) {
    $61de1ee1cac498ae$var$pec(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 403));
};
var $61de1ee1cac498ae$var$UT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SelfLoopRouter/lambda$4$Type", 1611);
$61de1ee1cac498ae$var$bcb(1612, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Fec);
$61de1ee1cac498ae$var$_.pf = function Iec(a, b) {
    $61de1ee1cac498ae$var$Eec($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$$T = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SemiInteractiveCrossMinProcessor", 1612);
$61de1ee1cac498ae$var$bcb(1613, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Jec);
$61de1ee1cac498ae$var$_.Mb = function Kec(a) {
    return $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$WT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SemiInteractiveCrossMinProcessor/lambda$0$Type", 1613);
$61de1ee1cac498ae$var$bcb(1614, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Lec);
$61de1ee1cac498ae$var$_.Mb = function Mec(a) {
    return $61de1ee1cac498ae$var$uNb($61de1ee1cac498ae$var$BD(a, 10))._b(($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$ayc));
};
var $61de1ee1cac498ae$var$XT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SemiInteractiveCrossMinProcessor/lambda$1$Type", 1614);
$61de1ee1cac498ae$var$bcb(1615, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Nec);
$61de1ee1cac498ae$var$_.ue = function Oec(a, b) {
    return $61de1ee1cac498ae$var$Gec($61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function Pec(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Qec() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$YT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SemiInteractiveCrossMinProcessor/lambda$2$Type", 1615);
$61de1ee1cac498ae$var$bcb(1616, 1, {}, $61de1ee1cac498ae$var$Rec);
$61de1ee1cac498ae$var$_.Ce = function Sec(a, b) {
    return $61de1ee1cac498ae$var$Hec($61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
var $61de1ee1cac498ae$var$ZT = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SemiInteractiveCrossMinProcessor/lambda$3$Type", 1616);
$61de1ee1cac498ae$var$bcb(1618, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Uec);
$61de1ee1cac498ae$var$_.pf = function Yec(a, b) {
    $61de1ee1cac498ae$var$Tec($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$bU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SortByInputModelProcessor", 1618);
$61de1ee1cac498ae$var$bcb(1619, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Zec);
$61de1ee1cac498ae$var$_.Mb = function $ec(a) {
    return $61de1ee1cac498ae$var$BD(a, 11).g.c.length != 0;
};
var $61de1ee1cac498ae$var$_T = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SortByInputModelProcessor/lambda$0$Type", 1619);
$61de1ee1cac498ae$var$bcb(1620, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$_ec);
$61de1ee1cac498ae$var$_.td = function afc(a) {
    $61de1ee1cac498ae$var$Wec(this.a, $61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$aU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ane, "SortByInputModelProcessor/lambda$1$Type", 1620);
$61de1ee1cac498ae$var$bcb(1693, 803, {}, $61de1ee1cac498ae$var$jfc);
$61de1ee1cac498ae$var$_.Me = function kfc(a) {
    var b, c, d, e;
    this.c = a;
    switch(this.a.g){
        case 2:
            b = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.c.a.b, 16)), new $61de1ee1cac498ae$var$lgc), new $61de1ee1cac498ae$var$ngc(this, b));
            $61de1ee1cac498ae$var$nEb(this, new $61de1ee1cac498ae$var$tfc);
            $61de1ee1cac498ae$var$Hkb(b, new $61de1ee1cac498ae$var$xfc);
            b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.c.a.b, 16)), new $61de1ee1cac498ae$var$zfc), new $61de1ee1cac498ae$var$Bfc(b));
            $61de1ee1cac498ae$var$nEb(this, new $61de1ee1cac498ae$var$Ffc);
            $61de1ee1cac498ae$var$Hkb(b, new $61de1ee1cac498ae$var$Jfc);
            b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            c = $61de1ee1cac498ae$var$Ntb($61de1ee1cac498ae$var$$zb($61de1ee1cac498ae$var$OAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.c.a.b, 16)), new $61de1ee1cac498ae$var$Lfc(this))), new $61de1ee1cac498ae$var$Nfc);
            $61de1ee1cac498ae$var$MAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.c.a.a, 16)), new $61de1ee1cac498ae$var$Rfc(c, b));
            $61de1ee1cac498ae$var$nEb(this, new $61de1ee1cac498ae$var$Vfc);
            $61de1ee1cac498ae$var$Hkb(b, new $61de1ee1cac498ae$var$Zfc);
            b.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            break;
        case 3:
            d = new $61de1ee1cac498ae$var$Rkb;
            $61de1ee1cac498ae$var$nEb(this, new $61de1ee1cac498ae$var$lfc);
            e = $61de1ee1cac498ae$var$Ntb($61de1ee1cac498ae$var$$zb($61de1ee1cac498ae$var$OAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.c.a.b, 16)), new $61de1ee1cac498ae$var$pfc(this))), new $61de1ee1cac498ae$var$Pfc);
            $61de1ee1cac498ae$var$MAb($61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this.c.a.b, 16)), new $61de1ee1cac498ae$var$_fc), new $61de1ee1cac498ae$var$bgc(e, d));
            $61de1ee1cac498ae$var$nEb(this, new $61de1ee1cac498ae$var$fgc);
            $61de1ee1cac498ae$var$Hkb(d, new $61de1ee1cac498ae$var$jgc);
            d.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, 0, 5, 1);
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$x2c);
    }
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$AU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation", 1693);
$61de1ee1cac498ae$var$bcb(1694, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$lfc);
$61de1ee1cac498ae$var$_.Lb = function mfc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 145);
};
$61de1ee1cac498ae$var$_.Fb = function nfc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function ofc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 145);
};
var $61de1ee1cac498ae$var$cU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$0$Type", 1694);
$61de1ee1cac498ae$var$bcb(1695, 1, {}, $61de1ee1cac498ae$var$pfc);
$61de1ee1cac498ae$var$_.Fe = function qfc(a) {
    return $61de1ee1cac498ae$var$dfc(this.a, $61de1ee1cac498ae$var$BD(a, 57));
};
var $61de1ee1cac498ae$var$dU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$1$Type", 1695);
$61de1ee1cac498ae$var$bcb(1703, 1, $61de1ee1cac498ae$var$Pie, $61de1ee1cac498ae$var$rfc);
$61de1ee1cac498ae$var$_.Vd = function sfc() {
    $61de1ee1cac498ae$var$cfc(this.a, this.b, -1);
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$eU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$10$Type", 1703);
$61de1ee1cac498ae$var$bcb(1705, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$tfc);
$61de1ee1cac498ae$var$_.Lb = function ufc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 145);
};
$61de1ee1cac498ae$var$_.Fb = function vfc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function wfc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 145);
};
var $61de1ee1cac498ae$var$fU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$11$Type", 1705);
$61de1ee1cac498ae$var$bcb(1706, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$xfc);
$61de1ee1cac498ae$var$_.td = function yfc(a) {
    $61de1ee1cac498ae$var$BD(a, 365).Vd();
};
var $61de1ee1cac498ae$var$gU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$12$Type", 1706);
$61de1ee1cac498ae$var$bcb(1707, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$zfc);
$61de1ee1cac498ae$var$_.Mb = function Afc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 10);
};
var $61de1ee1cac498ae$var$hU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$13$Type", 1707);
$61de1ee1cac498ae$var$bcb(1709, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Bfc);
$61de1ee1cac498ae$var$_.td = function Cfc(a) {
    $61de1ee1cac498ae$var$efc(this.a, $61de1ee1cac498ae$var$BD(a, 57));
};
var $61de1ee1cac498ae$var$iU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$14$Type", 1709);
$61de1ee1cac498ae$var$bcb(1708, 1, $61de1ee1cac498ae$var$Pie, $61de1ee1cac498ae$var$Dfc);
$61de1ee1cac498ae$var$_.Vd = function Efc() {
    $61de1ee1cac498ae$var$cfc(this.b, this.a, -1);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$jU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$15$Type", 1708);
$61de1ee1cac498ae$var$bcb(1710, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$Ffc);
$61de1ee1cac498ae$var$_.Lb = function Gfc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 10);
};
$61de1ee1cac498ae$var$_.Fb = function Hfc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function Ifc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 10);
};
var $61de1ee1cac498ae$var$kU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$16$Type", 1710);
$61de1ee1cac498ae$var$bcb(1711, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Jfc);
$61de1ee1cac498ae$var$_.td = function Kfc(a) {
    $61de1ee1cac498ae$var$BD(a, 365).Vd();
};
var $61de1ee1cac498ae$var$lU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$17$Type", 1711);
$61de1ee1cac498ae$var$bcb(1712, 1, {}, $61de1ee1cac498ae$var$Lfc);
$61de1ee1cac498ae$var$_.Fe = function Mfc(a) {
    return $61de1ee1cac498ae$var$ffc(this.a, $61de1ee1cac498ae$var$BD(a, 57));
};
var $61de1ee1cac498ae$var$mU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$18$Type", 1712);
$61de1ee1cac498ae$var$bcb(1713, 1, {}, $61de1ee1cac498ae$var$Nfc);
$61de1ee1cac498ae$var$_.De = function Ofc() {
    return 0;
};
var $61de1ee1cac498ae$var$nU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$19$Type", 1713);
$61de1ee1cac498ae$var$bcb(1696, 1, {}, $61de1ee1cac498ae$var$Pfc);
$61de1ee1cac498ae$var$_.De = function Qfc() {
    return 0;
};
var $61de1ee1cac498ae$var$oU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$2$Type", 1696);
$61de1ee1cac498ae$var$bcb(1715, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Rfc);
$61de1ee1cac498ae$var$_.td = function Sfc(a) {
    $61de1ee1cac498ae$var$gfc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 307));
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$pU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$20$Type", 1715);
$61de1ee1cac498ae$var$bcb(1714, 1, $61de1ee1cac498ae$var$Pie, $61de1ee1cac498ae$var$Tfc);
$61de1ee1cac498ae$var$_.Vd = function Ufc() {
    $61de1ee1cac498ae$var$bfc(this.a, this.b, -1);
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$qU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$21$Type", 1714);
$61de1ee1cac498ae$var$bcb(1716, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$Vfc);
$61de1ee1cac498ae$var$_.Lb = function Wfc(a) {
    return $61de1ee1cac498ae$var$BD(a, 57), true;
};
$61de1ee1cac498ae$var$_.Fb = function Xfc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function Yfc(a) {
    return $61de1ee1cac498ae$var$BD(a, 57), true;
};
var $61de1ee1cac498ae$var$rU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$22$Type", 1716);
$61de1ee1cac498ae$var$bcb(1717, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Zfc);
$61de1ee1cac498ae$var$_.td = function $fc(a) {
    $61de1ee1cac498ae$var$BD(a, 365).Vd();
};
var $61de1ee1cac498ae$var$sU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$23$Type", 1717);
$61de1ee1cac498ae$var$bcb(1697, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$_fc);
$61de1ee1cac498ae$var$_.Mb = function agc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 10);
};
var $61de1ee1cac498ae$var$tU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$3$Type", 1697);
$61de1ee1cac498ae$var$bcb(1699, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$bgc);
$61de1ee1cac498ae$var$_.td = function cgc(a) {
    $61de1ee1cac498ae$var$hfc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 57));
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$uU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$4$Type", 1699);
$61de1ee1cac498ae$var$bcb(1698, 1, $61de1ee1cac498ae$var$Pie, $61de1ee1cac498ae$var$dgc);
$61de1ee1cac498ae$var$_.Vd = function egc() {
    $61de1ee1cac498ae$var$cfc(this.b, this.a, -1);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$vU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$5$Type", 1698);
$61de1ee1cac498ae$var$bcb(1700, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$fgc);
$61de1ee1cac498ae$var$_.Lb = function ggc(a) {
    return $61de1ee1cac498ae$var$BD(a, 57), true;
};
$61de1ee1cac498ae$var$_.Fb = function hgc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function igc(a) {
    return $61de1ee1cac498ae$var$BD(a, 57), true;
};
var $61de1ee1cac498ae$var$wU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$6$Type", 1700);
$61de1ee1cac498ae$var$bcb(1701, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$jgc);
$61de1ee1cac498ae$var$_.td = function kgc(a) {
    $61de1ee1cac498ae$var$BD(a, 365).Vd();
};
var $61de1ee1cac498ae$var$xU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$7$Type", 1701);
$61de1ee1cac498ae$var$bcb(1702, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$lgc);
$61de1ee1cac498ae$var$_.Mb = function mgc(a) {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 145);
};
var $61de1ee1cac498ae$var$yU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$8$Type", 1702);
$61de1ee1cac498ae$var$bcb(1704, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$ngc);
$61de1ee1cac498ae$var$_.td = function ogc(a) {
    $61de1ee1cac498ae$var$ifc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 57));
};
var $61de1ee1cac498ae$var$zU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "EdgeAwareScanlineConstraintCalculation/lambda$9$Type", 1704);
$61de1ee1cac498ae$var$bcb(1521, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$sgc);
$61de1ee1cac498ae$var$_.pf = function xgc(a, b) {
    $61de1ee1cac498ae$var$rgc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$pgc;
var $61de1ee1cac498ae$var$EU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "HorizontalGraphCompactor", 1521);
$61de1ee1cac498ae$var$bcb(1522, 1, {}, $61de1ee1cac498ae$var$ygc);
$61de1ee1cac498ae$var$_.Oe = function zgc(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$vgc(a, b)) return 0;
    c = $61de1ee1cac498ae$var$tgc(a);
    d = $61de1ee1cac498ae$var$tgc(b);
    if (!!c && c.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b) || !!d && d.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b)) return 0;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(this.a.a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    return $61de1ee1cac498ae$var$fBc(e, c ? c.k : ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b), d ? d.k : ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b));
};
$61de1ee1cac498ae$var$_.Pe = function Agc(a, b) {
    var c, d, e;
    if ($61de1ee1cac498ae$var$vgc(a, b)) return 1;
    c = $61de1ee1cac498ae$var$tgc(a);
    d = $61de1ee1cac498ae$var$tgc(b);
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(this.a.a, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$otc)), 304);
    return $61de1ee1cac498ae$var$iBc(e, c ? c.k : ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b), d ? d.k : ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b));
};
var $61de1ee1cac498ae$var$BU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "HorizontalGraphCompactor/1", 1522);
$61de1ee1cac498ae$var$bcb(1523, 1, {}, $61de1ee1cac498ae$var$Bgc);
$61de1ee1cac498ae$var$_.Ne = function Cgc(a, b) {
    return $61de1ee1cac498ae$var$qgc(), a.a.i == 0;
};
var $61de1ee1cac498ae$var$CU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "HorizontalGraphCompactor/lambda$0$Type", 1523);
$61de1ee1cac498ae$var$bcb(1524, 1, {}, $61de1ee1cac498ae$var$Dgc);
$61de1ee1cac498ae$var$_.Ne = function Egc(a, b) {
    return $61de1ee1cac498ae$var$wgc(this.a, a, b);
};
var $61de1ee1cac498ae$var$DU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "HorizontalGraphCompactor/lambda$1$Type", 1524);
$61de1ee1cac498ae$var$bcb(1664, 1, {}, $61de1ee1cac498ae$var$Ygc);
var $61de1ee1cac498ae$var$Fgc, $61de1ee1cac498ae$var$Ggc;
var $61de1ee1cac498ae$var$cV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer", 1664);
$61de1ee1cac498ae$var$bcb(1672, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$ehc);
$61de1ee1cac498ae$var$_.Mb = function fhc(a) {
    return a != null;
};
var $61de1ee1cac498ae$var$FU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/0methodref$nonNull$Type", 1672);
$61de1ee1cac498ae$var$bcb(1665, 1, {}, $61de1ee1cac498ae$var$ghc);
$61de1ee1cac498ae$var$_.Kb = function hhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), $61de1ee1cac498ae$var$fcb($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(a, 57).g, 10), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$$sc)));
};
var $61de1ee1cac498ae$var$GU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$0$Type", 1665);
$61de1ee1cac498ae$var$bcb(1666, 1, {}, $61de1ee1cac498ae$var$ihc);
$61de1ee1cac498ae$var$_.Kb = function jhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), $61de1ee1cac498ae$var$gic($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(a, 57).g, 145));
};
var $61de1ee1cac498ae$var$HU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$1$Type", 1666);
$61de1ee1cac498ae$var$bcb(1675, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$khc);
$61de1ee1cac498ae$var$_.Mb = function lhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 10);
};
var $61de1ee1cac498ae$var$IU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$10$Type", 1675);
$61de1ee1cac498ae$var$bcb(1676, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$mhc);
$61de1ee1cac498ae$var$_.td = function nhc(a) {
    $61de1ee1cac498ae$var$Zgc($61de1ee1cac498ae$var$BD(a, 57));
};
var $61de1ee1cac498ae$var$JU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$11$Type", 1676);
$61de1ee1cac498ae$var$bcb(1677, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$ohc);
$61de1ee1cac498ae$var$_.Mb = function phc(a) {
    return $61de1ee1cac498ae$var$Hgc(), $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$BD(a, 57).g, 145);
};
var $61de1ee1cac498ae$var$KU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$12$Type", 1677);
$61de1ee1cac498ae$var$bcb(1681, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$qhc);
$61de1ee1cac498ae$var$_.td = function rhc(a) {
    $61de1ee1cac498ae$var$$gc($61de1ee1cac498ae$var$BD(a, 57));
};
var $61de1ee1cac498ae$var$LU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$13$Type", 1681);
$61de1ee1cac498ae$var$bcb(1678, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$shc);
$61de1ee1cac498ae$var$_.td = function thc(a) {
    $61de1ee1cac498ae$var$_gc(this.a, $61de1ee1cac498ae$var$BD(a, 8));
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$MU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$14$Type", 1678);
$61de1ee1cac498ae$var$bcb(1679, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$uhc);
$61de1ee1cac498ae$var$_.td = function vhc(a) {
    $61de1ee1cac498ae$var$ahc(this.a, $61de1ee1cac498ae$var$BD(a, 110));
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$NU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$15$Type", 1679);
$61de1ee1cac498ae$var$bcb(1680, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$whc);
$61de1ee1cac498ae$var$_.td = function xhc(a) {
    $61de1ee1cac498ae$var$bhc(this.a, $61de1ee1cac498ae$var$BD(a, 8));
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$OU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$16$Type", 1680);
$61de1ee1cac498ae$var$bcb(1682, 1, {}, $61de1ee1cac498ae$var$yhc);
$61de1ee1cac498ae$var$_.Kb = function zhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b($61de1ee1cac498ae$var$BD(a, 10)).a.Kc(), new $61de1ee1cac498ae$var$Sq))));
};
var $61de1ee1cac498ae$var$PU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$17$Type", 1682);
$61de1ee1cac498ae$var$bcb(1683, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Ahc);
$61de1ee1cac498ae$var$_.Mb = function Bhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), $61de1ee1cac498ae$var$OZb($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$QU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$18$Type", 1683);
$61de1ee1cac498ae$var$bcb(1684, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Chc);
$61de1ee1cac498ae$var$_.td = function Dhc(a) {
    $61de1ee1cac498ae$var$Qgc(this.a, $61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$RU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$19$Type", 1684);
$61de1ee1cac498ae$var$bcb(1668, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Ehc);
$61de1ee1cac498ae$var$_.td = function Fhc(a) {
    $61de1ee1cac498ae$var$Rgc(this.a, $61de1ee1cac498ae$var$BD(a, 145));
};
var $61de1ee1cac498ae$var$SU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$2$Type", 1668);
$61de1ee1cac498ae$var$bcb(1685, 1, {}, $61de1ee1cac498ae$var$Ghc);
$61de1ee1cac498ae$var$_.Kb = function Hhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$TU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$20$Type", 1685);
$61de1ee1cac498ae$var$bcb(1686, 1, {}, $61de1ee1cac498ae$var$Ihc);
$61de1ee1cac498ae$var$_.Kb = function Jhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b($61de1ee1cac498ae$var$BD(a, 10)).a.Kc(), new $61de1ee1cac498ae$var$Sq))));
};
var $61de1ee1cac498ae$var$UU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$21$Type", 1686);
$61de1ee1cac498ae$var$bcb(1687, 1, {}, $61de1ee1cac498ae$var$Khc);
$61de1ee1cac498ae$var$_.Kb = function Lhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 17), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$rtc)), 15);
};
var $61de1ee1cac498ae$var$VU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$22$Type", 1687);
$61de1ee1cac498ae$var$bcb(1688, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Mhc);
$61de1ee1cac498ae$var$_.Mb = function Nhc(a) {
    return $61de1ee1cac498ae$var$chc($61de1ee1cac498ae$var$BD(a, 15));
};
var $61de1ee1cac498ae$var$WU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$23$Type", 1688);
$61de1ee1cac498ae$var$bcb(1689, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Ohc);
$61de1ee1cac498ae$var$_.td = function Phc(a) {
    $61de1ee1cac498ae$var$Jgc(this.a, $61de1ee1cac498ae$var$BD(a, 15));
};
var $61de1ee1cac498ae$var$XU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$24$Type", 1689);
$61de1ee1cac498ae$var$bcb(1667, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Qhc);
$61de1ee1cac498ae$var$_.td = function Rhc(a) {
    $61de1ee1cac498ae$var$Sgc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 145));
};
var $61de1ee1cac498ae$var$YU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$3$Type", 1667);
$61de1ee1cac498ae$var$bcb(1669, 1, {}, $61de1ee1cac498ae$var$Shc);
$61de1ee1cac498ae$var$_.Kb = function Thc(a) {
    return $61de1ee1cac498ae$var$Hgc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$ZU = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$4$Type", 1669);
$61de1ee1cac498ae$var$bcb(1670, 1, {}, $61de1ee1cac498ae$var$Uhc);
$61de1ee1cac498ae$var$_.Kb = function Vhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b($61de1ee1cac498ae$var$BD(a, 10)).a.Kc(), new $61de1ee1cac498ae$var$Sq))));
};
var $61de1ee1cac498ae$var$$U = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$5$Type", 1670);
$61de1ee1cac498ae$var$bcb(1671, 1, {}, $61de1ee1cac498ae$var$Whc);
$61de1ee1cac498ae$var$_.Kb = function Xhc(a) {
    return $61de1ee1cac498ae$var$Hgc(), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 17), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$rtc)), 15);
};
var $61de1ee1cac498ae$var$_U = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$6$Type", 1671);
$61de1ee1cac498ae$var$bcb(1673, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Yhc);
$61de1ee1cac498ae$var$_.td = function Zhc(a) {
    $61de1ee1cac498ae$var$dhc(this.a, $61de1ee1cac498ae$var$BD(a, 15));
};
var $61de1ee1cac498ae$var$aV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$8$Type", 1673);
$61de1ee1cac498ae$var$bcb(1674, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$$hc);
$61de1ee1cac498ae$var$_.td = function _hc(a) {
    $61de1ee1cac498ae$var$Tgc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 145));
};
var $61de1ee1cac498ae$var$bV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "LGraphToCGraphTransformer/lambda$9$Type", 1674);
$61de1ee1cac498ae$var$bcb(1663, 1, {}, $61de1ee1cac498ae$var$dic);
$61de1ee1cac498ae$var$_.Le = function eic(a) {
    var b, c, d, e, f;
    this.a = a;
    this.d = new $61de1ee1cac498ae$var$KFb;
    this.c = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$jN, $61de1ee1cac498ae$var$Uhe, 121, this.a.a.a.c.length, 0, 1);
    this.b = 0;
    for(c = new $61de1ee1cac498ae$var$olb(this.a.a.a); c.a < c.c.c.length;){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(c), 307);
        b.d = this.b;
        f = $61de1ee1cac498ae$var$nGb($61de1ee1cac498ae$var$oGb(new $61de1ee1cac498ae$var$pGb, b), this.d);
        this.c[this.b] = f;
        ++this.b;
    }
    $61de1ee1cac498ae$var$cic(this);
    $61de1ee1cac498ae$var$bic(this);
    $61de1ee1cac498ae$var$aic(this);
    $61de1ee1cac498ae$var$uGb($61de1ee1cac498ae$var$LGb(this.d), new $61de1ee1cac498ae$var$Zdd);
    for(e = new $61de1ee1cac498ae$var$olb(this.a.a.b); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 57);
        d.d.c = this.c[d.a.d].e + d.b.a;
    }
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$dV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "NetworkSimplexCompaction", 1663);
$61de1ee1cac498ae$var$bcb(145, 1, {
    35: 1,
    145: 1
}, $61de1ee1cac498ae$var$hic);
$61de1ee1cac498ae$var$_.wd = function iic(a) {
    return $61de1ee1cac498ae$var$fic(this, $61de1ee1cac498ae$var$BD(a, 145));
};
$61de1ee1cac498ae$var$_.Ib = function jic() {
    return $61de1ee1cac498ae$var$gic(this);
};
var $61de1ee1cac498ae$var$eV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Jne, "VerticalSegment", 145);
$61de1ee1cac498ae$var$bcb(827, 1, {}, $61de1ee1cac498ae$var$sic);
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.i = 0;
var $61de1ee1cac498ae$var$hV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kne, "BetweenLayerEdgeTwoNodeCrossingsCounter", 827);
$61de1ee1cac498ae$var$bcb(663, 1, {
    663: 1
}, $61de1ee1cac498ae$var$zic);
$61de1ee1cac498ae$var$_.Ib = function Aic() {
    return "AdjacencyList [node=" + this.d + ", adjacencies= " + this.a + "]";
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$gV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kne, "BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList", 663);
$61de1ee1cac498ae$var$bcb(287, 1, {
    35: 1,
    287: 1
}, $61de1ee1cac498ae$var$Dic);
$61de1ee1cac498ae$var$_.wd = function Eic(a) {
    return $61de1ee1cac498ae$var$Bic(this, $61de1ee1cac498ae$var$BD(a, 287));
};
$61de1ee1cac498ae$var$_.Ib = function Fic() {
    return "Adjacency [position=" + this.c + ", cardinality=" + this.a + ", currentCardinality=" + this.b + "]";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$fV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kne, "BetweenLayerEdgeTwoNodeCrossingsCounter/AdjacencyList/Adjacency", 287);
$61de1ee1cac498ae$var$bcb(1929, 1, {}, $61de1ee1cac498ae$var$Iic);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.e = false;
var $61de1ee1cac498ae$var$iV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kne, "CrossingMatrixFiller", 1929);
var $61de1ee1cac498ae$var$qY = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Lne, "IInitializable");
$61de1ee1cac498ae$var$bcb(1804, 1, $61de1ee1cac498ae$var$Mne, $61de1ee1cac498ae$var$Oic);
$61de1ee1cac498ae$var$_.Nf = function Ric(a, b, c, d, e, f) {};
$61de1ee1cac498ae$var$_.Pf = function Tic(a, b, c) {};
$61de1ee1cac498ae$var$_.Lf = function Pic() {
    return this.c != ($61de1ee1cac498ae$var$rGc(), $61de1ee1cac498ae$var$pGc);
};
$61de1ee1cac498ae$var$_.Mf = function Qic() {
    this.e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, this.d, 15, 1);
};
$61de1ee1cac498ae$var$_.Of = function Sic(a, b) {
    b[a][0].c.p = a;
};
$61de1ee1cac498ae$var$_.Qf = function Uic(a, b, c, d) {
    ++this.d;
};
$61de1ee1cac498ae$var$_.Rf = function Vic() {
    return true;
};
$61de1ee1cac498ae$var$_.Sf = function Wic(a, b, c, d) {
    $61de1ee1cac498ae$var$Kic(this, a, b, c);
    return $61de1ee1cac498ae$var$Jic(this, b);
};
$61de1ee1cac498ae$var$_.Tf = function Xic(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$Lic(b, a.length);
    $61de1ee1cac498ae$var$Kic(this, a, c, b);
    return $61de1ee1cac498ae$var$Mic(this, c);
};
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$jV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kne, "GreedySwitchHeuristic", 1804);
$61de1ee1cac498ae$var$bcb(1930, 1, {}, $61de1ee1cac498ae$var$ejc);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$kV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kne, "NorthSouthEdgeNeighbouringNodeCrossingsCounter", 1930);
$61de1ee1cac498ae$var$bcb(1917, 1, {}, $61de1ee1cac498ae$var$jjc);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$lV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kne, "SwitchDecider", 1917);
$61de1ee1cac498ae$var$bcb(101, 1, {
    101: 1
}, $61de1ee1cac498ae$var$pjc);
$61de1ee1cac498ae$var$_.a = null;
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.i = null;
var $61de1ee1cac498ae$var$oV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nne, "SelfHyperLoop", 101);
$61de1ee1cac498ae$var$bcb(1916, 1, {}, $61de1ee1cac498ae$var$vjc);
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$nV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nne, "SelfHyperLoopLabels", 1916);
$61de1ee1cac498ae$var$bcb(411, 22, {
    3: 1,
    35: 1,
    22: 1,
    411: 1
}, $61de1ee1cac498ae$var$Bjc);
var $61de1ee1cac498ae$var$wjc, $61de1ee1cac498ae$var$xjc, $61de1ee1cac498ae$var$yjc, $61de1ee1cac498ae$var$zjc;
var $61de1ee1cac498ae$var$mV = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Nne, "SelfHyperLoopLabels/Alignment", 411, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Djc, $61de1ee1cac498ae$var$Cjc);
var $61de1ee1cac498ae$var$Ejc;
$61de1ee1cac498ae$var$bcb(409, 1, {
    409: 1
}, $61de1ee1cac498ae$var$Gjc);
var $61de1ee1cac498ae$var$pV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nne, "SelfLoopEdge", 409);
$61de1ee1cac498ae$var$bcb(403, 1, {
    403: 1
}, $61de1ee1cac498ae$var$Kjc);
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$rV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nne, "SelfLoopHolder", 403);
$61de1ee1cac498ae$var$bcb(1724, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Mjc);
$61de1ee1cac498ae$var$_.Mb = function Njc(a) {
    return $61de1ee1cac498ae$var$OZb($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$qV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nne, "SelfLoopHolder/lambda$0$Type", 1724);
$61de1ee1cac498ae$var$bcb(113, 1, {
    113: 1
}, $61de1ee1cac498ae$var$Pjc);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$tV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nne, "SelfLoopPort", 113);
$61de1ee1cac498ae$var$bcb(1792, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Qjc);
$61de1ee1cac498ae$var$_.Mb = function Rjc(a) {
    return $61de1ee1cac498ae$var$OZb($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$sV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nne, "SelfLoopPort/lambda$0$Type", 1792);
$61de1ee1cac498ae$var$bcb(363, 22, {
    3: 1,
    35: 1,
    22: 1,
    363: 1
}, $61de1ee1cac498ae$var$Yjc);
var $61de1ee1cac498ae$var$Sjc, $61de1ee1cac498ae$var$Tjc, $61de1ee1cac498ae$var$Ujc, $61de1ee1cac498ae$var$Vjc, $61de1ee1cac498ae$var$Wjc;
var $61de1ee1cac498ae$var$uV = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Nne, "SelfLoopType", 363, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$_jc, $61de1ee1cac498ae$var$$jc);
var $61de1ee1cac498ae$var$akc;
$61de1ee1cac498ae$var$bcb(1732, 1, {}, $61de1ee1cac498ae$var$xkc);
var $61de1ee1cac498ae$var$ckc, $61de1ee1cac498ae$var$dkc, $61de1ee1cac498ae$var$ekc, $61de1ee1cac498ae$var$fkc;
var $61de1ee1cac498ae$var$JV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer", 1732);
$61de1ee1cac498ae$var$bcb(361, 22, {
    3: 1,
    35: 1,
    22: 1,
    361: 1
}, $61de1ee1cac498ae$var$Gkc);
var $61de1ee1cac498ae$var$Ckc, $61de1ee1cac498ae$var$Dkc, $61de1ee1cac498ae$var$Ekc;
var $61de1ee1cac498ae$var$vV = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$One, "PortRestorer/PortSideArea", 361, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Ikc, $61de1ee1cac498ae$var$Hkc);
var $61de1ee1cac498ae$var$Jkc;
$61de1ee1cac498ae$var$bcb(1733, 1, {}, $61de1ee1cac498ae$var$Lkc);
$61de1ee1cac498ae$var$_.Kb = function Mkc(a) {
    return $61de1ee1cac498ae$var$gkc(), $61de1ee1cac498ae$var$BD(a, 15).Oc();
};
var $61de1ee1cac498ae$var$wV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$0$Type", 1733);
$61de1ee1cac498ae$var$bcb(1734, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Nkc);
$61de1ee1cac498ae$var$_.td = function Okc(a) {
    $61de1ee1cac498ae$var$gkc();
    $61de1ee1cac498ae$var$BD(a, 113).c = false;
};
var $61de1ee1cac498ae$var$xV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$1$Type", 1734);
$61de1ee1cac498ae$var$bcb(1743, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Pkc);
$61de1ee1cac498ae$var$_.Mb = function Qkc(a) {
    return $61de1ee1cac498ae$var$gkc(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd);
};
var $61de1ee1cac498ae$var$yV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$10$Type", 1743);
$61de1ee1cac498ae$var$bcb(1744, 1, {}, $61de1ee1cac498ae$var$Rkc);
$61de1ee1cac498ae$var$_.Kb = function Skc(a) {
    return $61de1ee1cac498ae$var$gkc(), $61de1ee1cac498ae$var$BD(a, 113).d;
};
var $61de1ee1cac498ae$var$zV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$11$Type", 1744);
$61de1ee1cac498ae$var$bcb(1745, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Tkc);
$61de1ee1cac498ae$var$_.td = function Ukc(a) {
    $61de1ee1cac498ae$var$ykc(this.a, $61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$AV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$12$Type", 1745);
$61de1ee1cac498ae$var$bcb(1735, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Vkc);
$61de1ee1cac498ae$var$_.td = function Wkc(a) {
    $61de1ee1cac498ae$var$zkc(this.a, $61de1ee1cac498ae$var$BD(a, 101));
};
var $61de1ee1cac498ae$var$BV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$2$Type", 1735);
$61de1ee1cac498ae$var$bcb(1736, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Xkc);
$61de1ee1cac498ae$var$_.ue = function Ykc(a, b) {
    return $61de1ee1cac498ae$var$Akc($61de1ee1cac498ae$var$BD(a, 113), $61de1ee1cac498ae$var$BD(b, 113));
};
$61de1ee1cac498ae$var$_.Fb = function Zkc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function $kc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$CV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$3$Type", 1736);
$61de1ee1cac498ae$var$bcb(1737, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$_kc);
$61de1ee1cac498ae$var$_.Mb = function alc(a) {
    return $61de1ee1cac498ae$var$gkc(), $61de1ee1cac498ae$var$BD(a, 113).c;
};
var $61de1ee1cac498ae$var$DV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$4$Type", 1737);
$61de1ee1cac498ae$var$bcb(1738, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$blc);
$61de1ee1cac498ae$var$_.Mb = function clc(a) {
    return $61de1ee1cac498ae$var$nkc($61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$EV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$5$Type", 1738);
$61de1ee1cac498ae$var$bcb(1739, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$dlc);
$61de1ee1cac498ae$var$_.Mb = function elc(a) {
    return $61de1ee1cac498ae$var$gkc(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd);
};
var $61de1ee1cac498ae$var$FV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$6$Type", 1739);
$61de1ee1cac498ae$var$bcb(1740, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$flc);
$61de1ee1cac498ae$var$_.Mb = function glc(a) {
    return $61de1ee1cac498ae$var$gkc(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd);
};
var $61de1ee1cac498ae$var$GV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$7$Type", 1740);
$61de1ee1cac498ae$var$bcb(1741, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$hlc);
$61de1ee1cac498ae$var$_.Mb = function ilc(a) {
    return $61de1ee1cac498ae$var$okc($61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$HV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$8$Type", 1741);
$61de1ee1cac498ae$var$bcb(1742, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$jlc);
$61de1ee1cac498ae$var$_.Mb = function klc(a) {
    return $61de1ee1cac498ae$var$gkc(), $61de1ee1cac498ae$var$BD(a, 11).j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd);
};
var $61de1ee1cac498ae$var$IV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortRestorer/lambda$9$Type", 1742);
$61de1ee1cac498ae$var$bcb(270, 22, {
    3: 1,
    35: 1,
    22: 1,
    270: 1
}, $61de1ee1cac498ae$var$Blc);
var $61de1ee1cac498ae$var$slc, $61de1ee1cac498ae$var$tlc, $61de1ee1cac498ae$var$ulc, $61de1ee1cac498ae$var$vlc, $61de1ee1cac498ae$var$wlc, $61de1ee1cac498ae$var$xlc, $61de1ee1cac498ae$var$ylc, $61de1ee1cac498ae$var$zlc;
var $61de1ee1cac498ae$var$KV = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$One, "PortSideAssigner/Target", 270, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Dlc, $61de1ee1cac498ae$var$Clc);
var $61de1ee1cac498ae$var$Elc;
$61de1ee1cac498ae$var$bcb(1725, 1, {}, $61de1ee1cac498ae$var$Glc);
$61de1ee1cac498ae$var$_.Kb = function Hlc(a) {
    return $61de1ee1cac498ae$var$JAb(new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 101).j, 16)), new $61de1ee1cac498ae$var$Ylc);
};
var $61de1ee1cac498ae$var$LV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$1$Type", 1725);
$61de1ee1cac498ae$var$bcb(1726, 1, {}, $61de1ee1cac498ae$var$Ilc);
$61de1ee1cac498ae$var$_.Kb = function Jlc(a) {
    return $61de1ee1cac498ae$var$BD(a, 113).d;
};
var $61de1ee1cac498ae$var$MV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$2$Type", 1726);
$61de1ee1cac498ae$var$bcb(1727, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Klc);
$61de1ee1cac498ae$var$_.td = function Llc(a) {
    $61de1ee1cac498ae$var$G0b($61de1ee1cac498ae$var$BD(a, 11), ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd));
};
var $61de1ee1cac498ae$var$NV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$3$Type", 1727);
$61de1ee1cac498ae$var$bcb(1728, 1, {}, $61de1ee1cac498ae$var$Mlc);
$61de1ee1cac498ae$var$_.Kb = function Nlc(a) {
    return $61de1ee1cac498ae$var$BD(a, 113).d;
};
var $61de1ee1cac498ae$var$OV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$4$Type", 1728);
$61de1ee1cac498ae$var$bcb(1729, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Olc);
$61de1ee1cac498ae$var$_.td = function Plc(a) {
    $61de1ee1cac498ae$var$plc(this.a, $61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$PV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$5$Type", 1729);
$61de1ee1cac498ae$var$bcb(1730, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Qlc);
$61de1ee1cac498ae$var$_.ue = function Rlc(a, b) {
    return $61de1ee1cac498ae$var$qlc($61de1ee1cac498ae$var$BD(a, 101), $61de1ee1cac498ae$var$BD(b, 101));
};
$61de1ee1cac498ae$var$_.Fb = function Slc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Tlc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$QV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$6$Type", 1730);
$61de1ee1cac498ae$var$bcb(1731, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Ulc);
$61de1ee1cac498ae$var$_.ue = function Vlc(a, b) {
    return $61de1ee1cac498ae$var$rlc($61de1ee1cac498ae$var$BD(a, 113), $61de1ee1cac498ae$var$BD(b, 113));
};
$61de1ee1cac498ae$var$_.Fb = function Wlc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Xlc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$RV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$7$Type", 1731);
$61de1ee1cac498ae$var$bcb(805, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Ylc);
$61de1ee1cac498ae$var$_.Mb = function Zlc(a) {
    return $61de1ee1cac498ae$var$BD(a, 113).c;
};
var $61de1ee1cac498ae$var$SV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$One, "PortSideAssigner/lambda$8$Type", 805);
$61de1ee1cac498ae$var$bcb(2009, 1, {});
var $61de1ee1cac498ae$var$TV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "AbstractSelfLoopRouter", 2009);
$61de1ee1cac498ae$var$bcb(1750, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$gmc);
$61de1ee1cac498ae$var$_.ue = function hmc(a, b) {
    return $61de1ee1cac498ae$var$emc($61de1ee1cac498ae$var$BD(a, 101), $61de1ee1cac498ae$var$BD(b, 101));
};
$61de1ee1cac498ae$var$_.Fb = function imc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function jmc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$UV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, $61de1ee1cac498ae$var$rle, 1750);
$61de1ee1cac498ae$var$bcb(1751, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$kmc);
$61de1ee1cac498ae$var$_.ue = function lmc(a, b) {
    return $61de1ee1cac498ae$var$fmc($61de1ee1cac498ae$var$BD(a, 101), $61de1ee1cac498ae$var$BD(b, 101));
};
$61de1ee1cac498ae$var$_.Fb = function mmc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function nmc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$VV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, $61de1ee1cac498ae$var$sle, 1751);
$61de1ee1cac498ae$var$bcb(1793, 2009, {}, $61de1ee1cac498ae$var$zmc);
$61de1ee1cac498ae$var$_.Uf = function Amc(a, b, c) {
    return c;
};
var $61de1ee1cac498ae$var$XV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "OrthogonalSelfLoopRouter", 1793);
$61de1ee1cac498ae$var$bcb(1795, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Bmc);
$61de1ee1cac498ae$var$_.td = function Cmc(a) {
    $61de1ee1cac498ae$var$ymc(this.b, this.a, $61de1ee1cac498ae$var$BD(a, 8));
};
var $61de1ee1cac498ae$var$WV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "OrthogonalSelfLoopRouter/lambda$0$Type", 1795);
$61de1ee1cac498ae$var$bcb(1794, 1793, {}, $61de1ee1cac498ae$var$Fmc);
$61de1ee1cac498ae$var$_.Uf = function Gmc(a, b, c) {
    var d, e;
    d = a.c.d;
    $61de1ee1cac498ae$var$St(c, 0, $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$R6c(d.n), d.a));
    e = a.d.d;
    $61de1ee1cac498ae$var$Dsb(c, $61de1ee1cac498ae$var$P6c($61de1ee1cac498ae$var$R6c(e.n), e.a));
    return $61de1ee1cac498ae$var$Dmc(c);
};
var $61de1ee1cac498ae$var$YV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "PolylineSelfLoopRouter", 1794);
$61de1ee1cac498ae$var$bcb(1746, 1, {}, $61de1ee1cac498ae$var$Umc);
$61de1ee1cac498ae$var$_.a = null;
var $61de1ee1cac498ae$var$Hmc;
var $61de1ee1cac498ae$var$aW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "RoutingDirector", 1746);
$61de1ee1cac498ae$var$bcb(1747, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Wmc);
$61de1ee1cac498ae$var$_.ue = function Xmc(a, b) {
    return $61de1ee1cac498ae$var$Vmc($61de1ee1cac498ae$var$BD(a, 113), $61de1ee1cac498ae$var$BD(b, 113));
};
$61de1ee1cac498ae$var$_.Fb = function Ymc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Zmc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$ZV = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "RoutingDirector/lambda$0$Type", 1747);
$61de1ee1cac498ae$var$bcb(1748, 1, {}, $61de1ee1cac498ae$var$$mc);
$61de1ee1cac498ae$var$_.Kb = function _mc(a) {
    return $61de1ee1cac498ae$var$Imc(), $61de1ee1cac498ae$var$BD(a, 101).j;
};
var $61de1ee1cac498ae$var$$V = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "RoutingDirector/lambda$1$Type", 1748);
$61de1ee1cac498ae$var$bcb(1749, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$anc);
$61de1ee1cac498ae$var$_.td = function bnc(a) {
    $61de1ee1cac498ae$var$Imc();
    $61de1ee1cac498ae$var$BD(a, 15).ad($61de1ee1cac498ae$var$Hmc);
};
var $61de1ee1cac498ae$var$_V = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "RoutingDirector/lambda$2$Type", 1749);
$61de1ee1cac498ae$var$bcb(1752, 1, {}, $61de1ee1cac498ae$var$mnc);
var $61de1ee1cac498ae$var$dW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "RoutingSlotAssigner", 1752);
$61de1ee1cac498ae$var$bcb(1753, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$pnc);
$61de1ee1cac498ae$var$_.Mb = function qnc(a) {
    return $61de1ee1cac498ae$var$nnc(this.a, $61de1ee1cac498ae$var$BD(a, 101));
};
var $61de1ee1cac498ae$var$bW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "RoutingSlotAssigner/lambda$0$Type", 1753);
$61de1ee1cac498ae$var$bcb(1754, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$rnc);
$61de1ee1cac498ae$var$_.ue = function snc(a, b) {
    return $61de1ee1cac498ae$var$onc(this.a, $61de1ee1cac498ae$var$BD(a, 101), $61de1ee1cac498ae$var$BD(b, 101));
};
$61de1ee1cac498ae$var$_.Fb = function tnc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function unc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$cW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "RoutingSlotAssigner/lambda$1$Type", 1754);
$61de1ee1cac498ae$var$bcb(1796, 1793, {}, $61de1ee1cac498ae$var$wnc);
$61de1ee1cac498ae$var$_.Uf = function xnc(a, b, c) {
    var d, e, f, g;
    d = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$c_b(a.b.g.b, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$nyc))));
    g = new $61de1ee1cac498ae$var$u7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
        (f = a.c.d, $61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$g7c(f.n), f.a))
    ]));
    $61de1ee1cac498ae$var$vnc(a, b, c, g, d);
    $61de1ee1cac498ae$var$Dsb(g, (e = a.d.d, $61de1ee1cac498ae$var$P6c(new $61de1ee1cac498ae$var$g7c(e.n), e.a)));
    return $61de1ee1cac498ae$var$UPc(new $61de1ee1cac498ae$var$YPc(g));
};
var $61de1ee1cac498ae$var$eW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pne, "SplineSelfLoopRouter", 1796);
$61de1ee1cac498ae$var$bcb(578, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Bnc, $61de1ee1cac498ae$var$Dnc);
$61de1ee1cac498ae$var$_.ue = function Enc(a, b) {
    return $61de1ee1cac498ae$var$ync(this, $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function Fnc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Gnc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$kW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qne, "ModelOrderNodeComparator", 578);
$61de1ee1cac498ae$var$bcb(1755, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Hnc);
$61de1ee1cac498ae$var$_.Mb = function Inc(a) {
    return $61de1ee1cac498ae$var$BD(a, 11).e.c.length != 0;
};
var $61de1ee1cac498ae$var$fW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qne, "ModelOrderNodeComparator/lambda$0$Type", 1755);
$61de1ee1cac498ae$var$bcb(1756, 1, {}, $61de1ee1cac498ae$var$Jnc);
$61de1ee1cac498ae$var$_.Kb = function Knc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb($61de1ee1cac498ae$var$BD(a, 11).e, 0), 17).c;
};
var $61de1ee1cac498ae$var$gW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qne, "ModelOrderNodeComparator/lambda$1$Type", 1756);
$61de1ee1cac498ae$var$bcb(1757, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Lnc);
$61de1ee1cac498ae$var$_.Mb = function Mnc(a) {
    return $61de1ee1cac498ae$var$BD(a, 11).e.c.length != 0;
};
var $61de1ee1cac498ae$var$hW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qne, "ModelOrderNodeComparator/lambda$2$Type", 1757);
$61de1ee1cac498ae$var$bcb(1758, 1, {}, $61de1ee1cac498ae$var$Nnc);
$61de1ee1cac498ae$var$_.Kb = function Onc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb($61de1ee1cac498ae$var$BD(a, 11).e, 0), 17).c;
};
var $61de1ee1cac498ae$var$iW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qne, "ModelOrderNodeComparator/lambda$3$Type", 1758);
$61de1ee1cac498ae$var$bcb(1759, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Pnc);
$61de1ee1cac498ae$var$_.Mb = function Qnc(a) {
    return $61de1ee1cac498ae$var$BD(a, 11).e.c.length != 0;
};
var $61de1ee1cac498ae$var$jW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qne, "ModelOrderNodeComparator/lambda$4$Type", 1759);
$61de1ee1cac498ae$var$bcb(806, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Tnc, $61de1ee1cac498ae$var$Unc);
$61de1ee1cac498ae$var$_.ue = function Vnc(a, b) {
    return $61de1ee1cac498ae$var$Rnc(this, a, b);
};
$61de1ee1cac498ae$var$_.Fb = function Wnc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Xnc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$lW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Qne, "ModelOrderPortComparator", 806);
$61de1ee1cac498ae$var$bcb(801, 1, {}, $61de1ee1cac498ae$var$Ync);
$61de1ee1cac498ae$var$_.Vf = function $nc(a, b) {
    var c, d, e, f;
    e = $61de1ee1cac498ae$var$Znc(b);
    c = new $61de1ee1cac498ae$var$Rkb;
    f = b.f / e;
    for(d = 1; d < e; ++d)$61de1ee1cac498ae$var$Ekb(c, $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Tbb($61de1ee1cac498ae$var$Cbb($61de1ee1cac498ae$var$$wnd.Math.round(d * f)))));
    return c;
};
$61de1ee1cac498ae$var$_.Wf = function _nc() {
    return false;
};
var $61de1ee1cac498ae$var$mW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "ARDCutIndexHeuristic", 801);
$61de1ee1cac498ae$var$bcb(1479, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$eoc);
$61de1ee1cac498ae$var$_.pf = function foc(a, b) {
    $61de1ee1cac498ae$var$doc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$pW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointInserter", 1479);
$61de1ee1cac498ae$var$bcb(305, 1, {
    305: 1
}, $61de1ee1cac498ae$var$goc);
$61de1ee1cac498ae$var$_.Ib = function joc() {
    var a;
    a = new $61de1ee1cac498ae$var$Ufb;
    a.a += "BPInfo[";
    a.a += "\n	start=";
    $61de1ee1cac498ae$var$Pfb(a, this.i);
    a.a += "\n	end=";
    $61de1ee1cac498ae$var$Pfb(a, this.a);
    a.a += "\n	nodeStartEdge=";
    $61de1ee1cac498ae$var$Pfb(a, this.e);
    a.a += "\n	startEndEdge=";
    $61de1ee1cac498ae$var$Pfb(a, this.j);
    a.a += "\n	originalEdge=";
    $61de1ee1cac498ae$var$Pfb(a, this.f);
    a.a += "\n	startInLayerDummy=";
    $61de1ee1cac498ae$var$Pfb(a, this.k);
    a.a += "\n	startInLayerEdge=";
    $61de1ee1cac498ae$var$Pfb(a, this.n);
    a.a += "\n	endInLayerDummy=";
    $61de1ee1cac498ae$var$Pfb(a, this.b);
    a.a += "\n	endInLayerEdge=";
    $61de1ee1cac498ae$var$Pfb(a, this.c);
    return a.a;
};
var $61de1ee1cac498ae$var$nW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointInserter/BPInfo", 305);
$61de1ee1cac498ae$var$bcb(652, 1, {
    652: 1
}, $61de1ee1cac498ae$var$qoc);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$oW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointInserter/Cut", 652);
$61de1ee1cac498ae$var$bcb(1480, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Aoc);
$61de1ee1cac498ae$var$_.pf = function Boc(a, b) {
    $61de1ee1cac498ae$var$yoc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$sW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointProcessor", 1480);
$61de1ee1cac498ae$var$bcb(1481, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Coc);
$61de1ee1cac498ae$var$_.Mb = function Doc(a) {
    return $61de1ee1cac498ae$var$hoc($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$qW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointProcessor/0methodref$isEnd$Type", 1481);
$61de1ee1cac498ae$var$bcb(1482, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$Eoc);
$61de1ee1cac498ae$var$_.Mb = function Foc(a) {
    return $61de1ee1cac498ae$var$ioc($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$rW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointProcessor/1methodref$isStart$Type", 1482);
$61de1ee1cac498ae$var$bcb(1483, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$Joc);
$61de1ee1cac498ae$var$_.pf = function Koc(a, b) {
    $61de1ee1cac498ae$var$Hoc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$uW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointRemover", 1483);
$61de1ee1cac498ae$var$bcb(1484, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Loc);
$61de1ee1cac498ae$var$_.td = function Moc(a) {
    $61de1ee1cac498ae$var$BD(a, 128).k = true;
};
var $61de1ee1cac498ae$var$tW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "BreakingPointRemover/lambda$0$Type", 1484);
$61de1ee1cac498ae$var$bcb(797, 1, {}, $61de1ee1cac498ae$var$Xoc);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.j = 0;
var $61de1ee1cac498ae$var$AW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "GraphStats", 797);
$61de1ee1cac498ae$var$bcb(798, 1, {}, $61de1ee1cac498ae$var$Zoc);
$61de1ee1cac498ae$var$_.Ce = function $oc(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(a)), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
};
var $61de1ee1cac498ae$var$vW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "GraphStats/0methodref$max$Type", 798);
$61de1ee1cac498ae$var$bcb(799, 1, {}, $61de1ee1cac498ae$var$_oc);
$61de1ee1cac498ae$var$_.Ce = function apc(a, b) {
    return $61de1ee1cac498ae$var$$wnd.Math.max($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(a)), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
};
var $61de1ee1cac498ae$var$wW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "GraphStats/2methodref$max$Type", 799);
$61de1ee1cac498ae$var$bcb(1660, 1, {}, $61de1ee1cac498ae$var$bpc);
$61de1ee1cac498ae$var$_.Ce = function cpc(a, b) {
    return $61de1ee1cac498ae$var$Yoc($61de1ee1cac498ae$var$ED(a), $61de1ee1cac498ae$var$ED(b));
};
var $61de1ee1cac498ae$var$xW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "GraphStats/lambda$1$Type", 1660);
$61de1ee1cac498ae$var$bcb(1661, 1, {}, $61de1ee1cac498ae$var$dpc);
$61de1ee1cac498ae$var$_.Kb = function epc(a) {
    return $61de1ee1cac498ae$var$Roc(this.a, $61de1ee1cac498ae$var$BD(a, 29));
};
var $61de1ee1cac498ae$var$yW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "GraphStats/lambda$2$Type", 1661);
$61de1ee1cac498ae$var$bcb(1662, 1, {}, $61de1ee1cac498ae$var$fpc);
$61de1ee1cac498ae$var$_.Kb = function gpc(a) {
    return $61de1ee1cac498ae$var$Qoc(this.a, $61de1ee1cac498ae$var$BD(a, 29));
};
var $61de1ee1cac498ae$var$zW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "GraphStats/lambda$6$Type", 1662);
$61de1ee1cac498ae$var$bcb(800, 1, {}, $61de1ee1cac498ae$var$hpc);
$61de1ee1cac498ae$var$_.Vf = function ipc(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Eyc)), 15);
    return c ? c : ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb);
};
$61de1ee1cac498ae$var$_.Wf = function jpc() {
    return false;
};
var $61de1ee1cac498ae$var$BW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "ICutIndexCalculator/ManualCutIndexCalculator", 800);
$61de1ee1cac498ae$var$bcb(802, 1, {}, $61de1ee1cac498ae$var$kpc);
$61de1ee1cac498ae$var$_.Vf = function lpc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u;
    u = (b.n == null && $61de1ee1cac498ae$var$Uoc(b), b.n);
    i = (b.d == null && $61de1ee1cac498ae$var$Uoc(b), b.d);
    t = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UD, $61de1ee1cac498ae$var$Vje, 25, u.length, 15, 1);
    t[0] = u[0];
    r = u[0];
    for(j = 1; j < u.length; j++){
        t[j] = t[j - 1] + u[j];
        r += u[j];
    }
    e = $61de1ee1cac498ae$var$Znc(b) - 1;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Fyc)), 19).a;
    d = $61de1ee1cac498ae$var$Qje;
    c = new $61de1ee1cac498ae$var$Rkb;
    for(m = $61de1ee1cac498ae$var$$wnd.Math.max(0, e - g); m <= $61de1ee1cac498ae$var$$wnd.Math.min(b.f - 1, e + g); m++){
        p = r / (m + 1);
        q = 0;
        k = 1;
        f = new $61de1ee1cac498ae$var$Rkb;
        s = $61de1ee1cac498ae$var$Qje;
        l = 0;
        h = 0;
        o = i[0];
        if (m == 0) {
            s = r;
            h = (b.g == null && (b.g = $61de1ee1cac498ae$var$Poc(b, new $61de1ee1cac498ae$var$_oc)), $61de1ee1cac498ae$var$Edb(b.g));
        } else {
            while(k < b.f){
                if (t[k - 1] - q >= p) {
                    $61de1ee1cac498ae$var$Ekb(f, $61de1ee1cac498ae$var$meb(k));
                    s = $61de1ee1cac498ae$var$$wnd.Math.max(s, t[k - 1] - l);
                    h += o;
                    q += t[k - 1] - q;
                    l = t[k - 1];
                    o = i[k];
                }
                o = $61de1ee1cac498ae$var$$wnd.Math.max(o, i[k]);
                ++k;
            }
            h += o;
        }
        n = $61de1ee1cac498ae$var$$wnd.Math.min(1 / s, 1 / b.b / h);
        if (n > d) {
            d = n;
            c = f;
        }
    }
    return c;
};
$61de1ee1cac498ae$var$_.Wf = function mpc() {
    return false;
};
var $61de1ee1cac498ae$var$CW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "MSDCutIndexHeuristic", 802);
$61de1ee1cac498ae$var$bcb(1617, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$ppc);
$61de1ee1cac498ae$var$_.pf = function qpc(a, b) {
    $61de1ee1cac498ae$var$opc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$DW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Rne, "SingleEdgeGraphWrapper", 1617);
$61de1ee1cac498ae$var$bcb(227, 22, {
    3: 1,
    35: 1,
    22: 1,
    227: 1
}, $61de1ee1cac498ae$var$Bpc);
var $61de1ee1cac498ae$var$upc, $61de1ee1cac498ae$var$vpc, $61de1ee1cac498ae$var$wpc, $61de1ee1cac498ae$var$xpc, $61de1ee1cac498ae$var$ypc, $61de1ee1cac498ae$var$zpc;
var $61de1ee1cac498ae$var$EW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "CenterEdgeLabelPlacementStrategy", 227, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Dpc, $61de1ee1cac498ae$var$Cpc);
var $61de1ee1cac498ae$var$Epc;
$61de1ee1cac498ae$var$bcb(422, 22, {
    3: 1,
    35: 1,
    22: 1,
    422: 1
}, $61de1ee1cac498ae$var$Jpc);
var $61de1ee1cac498ae$var$Gpc, $61de1ee1cac498ae$var$Hpc;
var $61de1ee1cac498ae$var$FW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "ConstraintCalculationStrategy", 422, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Lpc, $61de1ee1cac498ae$var$Kpc);
var $61de1ee1cac498ae$var$Mpc;
$61de1ee1cac498ae$var$bcb(314, 22, {
    3: 1,
    35: 1,
    22: 1,
    314: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$Tpc);
$61de1ee1cac498ae$var$_.Kf = function Vpc() {
    return $61de1ee1cac498ae$var$Spc(this);
};
$61de1ee1cac498ae$var$_.Xf = function Upc() {
    return $61de1ee1cac498ae$var$Spc(this);
};
var $61de1ee1cac498ae$var$Opc, $61de1ee1cac498ae$var$Ppc, $61de1ee1cac498ae$var$Qpc;
var $61de1ee1cac498ae$var$GW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "CrossingMinimizationStrategy", 314, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Xpc, $61de1ee1cac498ae$var$Wpc);
var $61de1ee1cac498ae$var$Ypc;
$61de1ee1cac498ae$var$bcb(337, 22, {
    3: 1,
    35: 1,
    22: 1,
    337: 1
}, $61de1ee1cac498ae$var$cqc);
var $61de1ee1cac498ae$var$$pc, $61de1ee1cac498ae$var$_pc, $61de1ee1cac498ae$var$aqc;
var $61de1ee1cac498ae$var$HW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "CuttingStrategy", 337, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$eqc, $61de1ee1cac498ae$var$dqc);
var $61de1ee1cac498ae$var$fqc;
$61de1ee1cac498ae$var$bcb(335, 22, {
    3: 1,
    35: 1,
    22: 1,
    335: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$oqc);
$61de1ee1cac498ae$var$_.Kf = function qqc() {
    return $61de1ee1cac498ae$var$nqc(this);
};
$61de1ee1cac498ae$var$_.Xf = function pqc() {
    return $61de1ee1cac498ae$var$nqc(this);
};
var $61de1ee1cac498ae$var$hqc, $61de1ee1cac498ae$var$iqc, $61de1ee1cac498ae$var$jqc, $61de1ee1cac498ae$var$kqc, $61de1ee1cac498ae$var$lqc;
var $61de1ee1cac498ae$var$IW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "CycleBreakingStrategy", 335, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$sqc, $61de1ee1cac498ae$var$rqc);
var $61de1ee1cac498ae$var$tqc;
$61de1ee1cac498ae$var$bcb(419, 22, {
    3: 1,
    35: 1,
    22: 1,
    419: 1
}, $61de1ee1cac498ae$var$yqc);
var $61de1ee1cac498ae$var$vqc, $61de1ee1cac498ae$var$wqc;
var $61de1ee1cac498ae$var$JW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "DirectionCongruency", 419, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Aqc, $61de1ee1cac498ae$var$zqc);
var $61de1ee1cac498ae$var$Bqc;
$61de1ee1cac498ae$var$bcb(450, 22, {
    3: 1,
    35: 1,
    22: 1,
    450: 1
}, $61de1ee1cac498ae$var$Hqc);
var $61de1ee1cac498ae$var$Dqc, $61de1ee1cac498ae$var$Eqc, $61de1ee1cac498ae$var$Fqc;
var $61de1ee1cac498ae$var$KW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "EdgeConstraint", 450, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Jqc, $61de1ee1cac498ae$var$Iqc);
var $61de1ee1cac498ae$var$Kqc;
$61de1ee1cac498ae$var$bcb(276, 22, {
    3: 1,
    35: 1,
    22: 1,
    276: 1
}, $61de1ee1cac498ae$var$Uqc);
var $61de1ee1cac498ae$var$Mqc, $61de1ee1cac498ae$var$Nqc, $61de1ee1cac498ae$var$Oqc, $61de1ee1cac498ae$var$Pqc, $61de1ee1cac498ae$var$Qqc, $61de1ee1cac498ae$var$Rqc;
var $61de1ee1cac498ae$var$LW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "EdgeLabelSideSelection", 276, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Wqc, $61de1ee1cac498ae$var$Vqc);
var $61de1ee1cac498ae$var$Xqc;
$61de1ee1cac498ae$var$bcb(479, 22, {
    3: 1,
    35: 1,
    22: 1,
    479: 1
}, $61de1ee1cac498ae$var$arc);
var $61de1ee1cac498ae$var$Zqc, $61de1ee1cac498ae$var$$qc;
var $61de1ee1cac498ae$var$MW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "EdgeStraighteningStrategy", 479, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$crc, $61de1ee1cac498ae$var$brc);
var $61de1ee1cac498ae$var$drc;
$61de1ee1cac498ae$var$bcb(274, 22, {
    3: 1,
    35: 1,
    22: 1,
    274: 1
}, $61de1ee1cac498ae$var$mrc);
var $61de1ee1cac498ae$var$frc, $61de1ee1cac498ae$var$grc, $61de1ee1cac498ae$var$hrc, $61de1ee1cac498ae$var$irc, $61de1ee1cac498ae$var$jrc, $61de1ee1cac498ae$var$krc;
var $61de1ee1cac498ae$var$NW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "FixedAlignment", 274, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$orc, $61de1ee1cac498ae$var$nrc);
var $61de1ee1cac498ae$var$prc;
$61de1ee1cac498ae$var$bcb(275, 22, {
    3: 1,
    35: 1,
    22: 1,
    275: 1
}, $61de1ee1cac498ae$var$zrc);
var $61de1ee1cac498ae$var$rrc, $61de1ee1cac498ae$var$trc, $61de1ee1cac498ae$var$urc, $61de1ee1cac498ae$var$vrc, $61de1ee1cac498ae$var$wrc, $61de1ee1cac498ae$var$xrc;
var $61de1ee1cac498ae$var$OW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "GraphCompactionStrategy", 275, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Brc, $61de1ee1cac498ae$var$Arc);
var $61de1ee1cac498ae$var$Crc;
$61de1ee1cac498ae$var$bcb(256, 22, {
    3: 1,
    35: 1,
    22: 1,
    256: 1
}, $61de1ee1cac498ae$var$Prc);
var $61de1ee1cac498ae$var$Erc, $61de1ee1cac498ae$var$Frc, $61de1ee1cac498ae$var$Grc, $61de1ee1cac498ae$var$Hrc, $61de1ee1cac498ae$var$Irc, $61de1ee1cac498ae$var$Jrc, $61de1ee1cac498ae$var$Krc, $61de1ee1cac498ae$var$Lrc, $61de1ee1cac498ae$var$Mrc, $61de1ee1cac498ae$var$Nrc;
var $61de1ee1cac498ae$var$PW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "GraphProperties", 256, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Rrc, $61de1ee1cac498ae$var$Qrc);
var $61de1ee1cac498ae$var$Src;
$61de1ee1cac498ae$var$bcb(292, 22, {
    3: 1,
    35: 1,
    22: 1,
    292: 1
}, $61de1ee1cac498ae$var$Yrc);
var $61de1ee1cac498ae$var$Urc, $61de1ee1cac498ae$var$Vrc, $61de1ee1cac498ae$var$Wrc;
var $61de1ee1cac498ae$var$QW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "GreedySwitchType", 292, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$$rc, $61de1ee1cac498ae$var$Zrc);
var $61de1ee1cac498ae$var$_rc;
$61de1ee1cac498ae$var$bcb(303, 22, {
    3: 1,
    35: 1,
    22: 1,
    303: 1
}, $61de1ee1cac498ae$var$fsc);
var $61de1ee1cac498ae$var$bsc, $61de1ee1cac498ae$var$csc, $61de1ee1cac498ae$var$dsc;
var $61de1ee1cac498ae$var$RW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "InLayerConstraint", 303, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$hsc, $61de1ee1cac498ae$var$gsc);
var $61de1ee1cac498ae$var$isc;
$61de1ee1cac498ae$var$bcb(420, 22, {
    3: 1,
    35: 1,
    22: 1,
    420: 1
}, $61de1ee1cac498ae$var$nsc);
var $61de1ee1cac498ae$var$ksc, $61de1ee1cac498ae$var$lsc;
var $61de1ee1cac498ae$var$SW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "InteractiveReferencePoint", 420, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$psc, $61de1ee1cac498ae$var$osc);
var $61de1ee1cac498ae$var$qsc;
var $61de1ee1cac498ae$var$ssc, $61de1ee1cac498ae$var$tsc, $61de1ee1cac498ae$var$usc, $61de1ee1cac498ae$var$vsc, $61de1ee1cac498ae$var$wsc, $61de1ee1cac498ae$var$xsc, $61de1ee1cac498ae$var$ysc, $61de1ee1cac498ae$var$zsc, $61de1ee1cac498ae$var$Asc, $61de1ee1cac498ae$var$Bsc, $61de1ee1cac498ae$var$Csc, $61de1ee1cac498ae$var$Dsc, $61de1ee1cac498ae$var$Esc, $61de1ee1cac498ae$var$Fsc, $61de1ee1cac498ae$var$Gsc, $61de1ee1cac498ae$var$Hsc, $61de1ee1cac498ae$var$Isc, $61de1ee1cac498ae$var$Jsc, $61de1ee1cac498ae$var$Ksc, $61de1ee1cac498ae$var$Lsc, $61de1ee1cac498ae$var$Msc, $61de1ee1cac498ae$var$Nsc, $61de1ee1cac498ae$var$Osc, $61de1ee1cac498ae$var$Psc, $61de1ee1cac498ae$var$Qsc, $61de1ee1cac498ae$var$Rsc, $61de1ee1cac498ae$var$Ssc, $61de1ee1cac498ae$var$Tsc, $61de1ee1cac498ae$var$Usc, $61de1ee1cac498ae$var$Vsc, $61de1ee1cac498ae$var$Wsc, $61de1ee1cac498ae$var$Xsc, $61de1ee1cac498ae$var$Ysc, $61de1ee1cac498ae$var$Zsc, $61de1ee1cac498ae$var$$sc, $61de1ee1cac498ae$var$_sc, $61de1ee1cac498ae$var$atc, $61de1ee1cac498ae$var$btc, $61de1ee1cac498ae$var$ctc, $61de1ee1cac498ae$var$dtc, $61de1ee1cac498ae$var$etc, $61de1ee1cac498ae$var$ftc, $61de1ee1cac498ae$var$gtc, $61de1ee1cac498ae$var$htc, $61de1ee1cac498ae$var$itc, $61de1ee1cac498ae$var$jtc, $61de1ee1cac498ae$var$ktc, $61de1ee1cac498ae$var$ltc, $61de1ee1cac498ae$var$mtc, $61de1ee1cac498ae$var$ntc, $61de1ee1cac498ae$var$otc, $61de1ee1cac498ae$var$ptc, $61de1ee1cac498ae$var$qtc, $61de1ee1cac498ae$var$rtc, $61de1ee1cac498ae$var$stc, $61de1ee1cac498ae$var$ttc, $61de1ee1cac498ae$var$utc, $61de1ee1cac498ae$var$vtc;
$61de1ee1cac498ae$var$bcb(163, 22, {
    3: 1,
    35: 1,
    22: 1,
    163: 1
}, $61de1ee1cac498ae$var$Dtc);
var $61de1ee1cac498ae$var$xtc, $61de1ee1cac498ae$var$ytc, $61de1ee1cac498ae$var$ztc, $61de1ee1cac498ae$var$Atc, $61de1ee1cac498ae$var$Btc;
var $61de1ee1cac498ae$var$TW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "LayerConstraint", 163, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Ftc, $61de1ee1cac498ae$var$Etc);
var $61de1ee1cac498ae$var$Gtc;
$61de1ee1cac498ae$var$bcb(848, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$kwc);
$61de1ee1cac498ae$var$_.Qe = function lwc(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Yne), ""), "Direction Congruency"), "Specifies how drawings of the same graph with different layout directions compare to each other: either a natural reading direction is preserved or the drawings are rotated versions of each other."), $61de1ee1cac498ae$var$puc), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$V5c)), $61de1ee1cac498ae$var$JW), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$L5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Zne), ""), "Feedback Edges"), "Whether feedback edges should be highlighted by routing around the nodes."), ($61de1ee1cac498ae$var$Bcb(), false)), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$$ne), ""), "Interactive Reference Point"), "Determines which point of a node is considered by interactive layout phases."), $61de1ee1cac498ae$var$Muc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$SW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$$ne, $61de1ee1cac498ae$var$goe, $61de1ee1cac498ae$var$Ouc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$$ne, $61de1ee1cac498ae$var$qoe, $61de1ee1cac498ae$var$Nuc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$_ne), ""), "Merge Edges"), "Edges that have no ports are merged so they touch the connected nodes at the same points. When this option is disabled, one port is created for each edge directly connected to a node. When it is enabled, all such incoming edges share an input port, and all outgoing edges share an output port."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$aoe), ""), "Merge Hierarchy-Crossing Edges"), "If hierarchical layout is active, hierarchy-crossing edges use as few hierarchical ports as possible. They are broken by the algorithm, with hierarchical ports inserted as required. Usually, one such port is created for each edge at each hierarchy crossing point. With this option set to true, we try to create as few hierarchical ports as possible in the process. In particular, all edges that form a hyperedge can share a port."), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$C5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$boe), ""), "Allow Non-Flow Ports To Switch Sides"), "Specifies whether non-flow ports may switch sides if their node's port constraints are either FIXED_SIDE or FIXED_ORDER. A non-flow port is a port on a side that is not part of the currently configured layout flow. For instance, given a left-to-right layout direction, north and south ports would be considered non-flow ports. Further note that the underlying criterium whether to switch sides or not solely relies on the minimization of edge crossings. Hence, edge length and other aesthetics criteria are not addressed."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$M5c)), $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$ZI, 1), $61de1ee1cac498ae$var$nie, 2, 6, [
        "org.eclipse.elk.layered.northOrSouthPort"
    ]))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$coe), ""), "Port Sorting Strategy"), "Only relevant for nodes with FIXED_SIDE port constraints. Determines the way a node's ports are distributed on the sides of a node if their order is not prescribed. The option is set on parent nodes."), $61de1ee1cac498ae$var$xvc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$cX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$doe), ""), "Thoroughness"), "How much effort should be spent to produce a nice layout."), $61de1ee1cac498ae$var$meb(7)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$eoe), ""), "Add Unnecessary Bendpoints"), "Adds bend points even if an edge does not change direction. If true, each long edge dummy will contribute a bend point to its edges and hierarchy-crossing edges will always get a bend point where they cross hierarchy boundaries. By default, bend points are only added where an edge changes direction."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$foe), ""), "Generate Position and Layer IDs"), "If enabled position id and layer id are generated, which are usually only used internally when setting the interactiveLayout option. This option should be specified on the root node."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$goe), "cycleBreaking"), "Cycle Breaking Strategy"), "Strategy for cycle breaking. Cycle breaking looks for cycles in the graph and determines which edges to reverse to break the cycles. Reversed edges will end up pointing to the opposite direction of regular edges (that is, reversed edges will point left if edges usually point right)."), $61de1ee1cac498ae$var$nuc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$IW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$hoe), $61de1ee1cac498ae$var$ppe), "Node Layering Strategy"), "Strategy for node layering."), $61de1ee1cac498ae$var$bvc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$YW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ioe), $61de1ee1cac498ae$var$ppe), "Layer Constraint"), "Determines a constraint on the placement of the node regarding the layering."), $61de1ee1cac498ae$var$Tuc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$TW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$joe), $61de1ee1cac498ae$var$ppe), "Layer Choice Constraint"), "Allows to set a constraint regarding the layer placement of a node. Let i be the value of teh constraint. Assumed the drawing has n layers and i < n. If set to i, it expresses that the node should be placed in i-th layer. Should i>=n be true then the node is placed in the last layer of the drawing. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), $61de1ee1cac498ae$var$meb(-1)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$koe), $61de1ee1cac498ae$var$ppe), "Layer ID"), "Layer identifier that was calculated by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set."), $61de1ee1cac498ae$var$meb(-1)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$loe), $61de1ee1cac498ae$var$qpe), "Upper Bound On Width [MinWidth Layerer]"), "Defines a loose upper bound on the width of the MinWidth layerer. If set to '-1' multiple values are tested and the best result is selected."), $61de1ee1cac498ae$var$meb(4)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$loe, $61de1ee1cac498ae$var$hoe, $61de1ee1cac498ae$var$Wuc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$moe), $61de1ee1cac498ae$var$qpe), "Upper Layer Estimation Scaling Factor [MinWidth Layerer]"), "Multiplied with Upper Bound On Width for defining an upper bound on the width of layers which haven't been determined yet, but whose maximum width had been (roughly) estimated by the MinWidth algorithm. Compensates for too high estimations. If set to '-1' multiple values are tested and the best result is selected."), $61de1ee1cac498ae$var$meb(2)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$moe, $61de1ee1cac498ae$var$hoe, $61de1ee1cac498ae$var$Yuc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$noe), $61de1ee1cac498ae$var$rpe), "Node Promotion Strategy"), "Reduces number of dummy nodes after layering phase (if possible)."), $61de1ee1cac498ae$var$_uc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$aX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ooe), $61de1ee1cac498ae$var$rpe), "Max Node Promotion Iterations"), "Limits the number of iterations for node promotion."), $61de1ee1cac498ae$var$meb(0)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$ooe, $61de1ee1cac498ae$var$noe, null);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$poe), "layering.coffmanGraham"), "Layer Bound"), "The maximum number of nodes allowed per layer."), $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Ohe)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$poe, $61de1ee1cac498ae$var$hoe, $61de1ee1cac498ae$var$Quc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$qoe), $61de1ee1cac498ae$var$spe), "Crossing Minimization Strategy"), "Strategy for crossing minimization."), $61de1ee1cac498ae$var$luc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$GW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$roe), $61de1ee1cac498ae$var$spe), "Force Node Model Order"), "The node order given by the model does not change to produce a better layout. E.g. if node A is before node B in the model this is not changed during crossing minimization. This assumes that the node model order is already respected before crossing minimization. This can be achieved by setting considerModelOrder.strategy to NODES_AND_EDGES."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$soe), $61de1ee1cac498ae$var$spe), "Hierarchical Sweepiness"), "How likely it is to use cross-hierarchy (1) vs bottom-up (-1)."), 0.1), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$soe, $61de1ee1cac498ae$var$tpe, $61de1ee1cac498ae$var$fuc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$toe), $61de1ee1cac498ae$var$spe), "Semi-Interactive Crossing Minimization"), "Preserves the order of nodes within a layer but still minimizes crossings between edges connecting long edge dummies. Derives the desired order from positions specified by the 'org.eclipse.elk.position' layout option. Requires a crossing minimization strategy that is able to process 'in-layer' constraints."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$toe, $61de1ee1cac498ae$var$qoe, $61de1ee1cac498ae$var$juc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$uoe), $61de1ee1cac498ae$var$spe), "Position Choice Constraint"), "Allows to set a constraint regarding the position placement of a node in a layer. Assumed the layer in which the node placed includes n other nodes and i < n. If set to i, it expresses that the node should be placed at the i-th position. Should i>=n be true then the node is placed at the last position in the layer. Note that this option is not part of any of ELK Layered's default configurations but is only evaluated as part of the `InteractiveLayeredGraphVisitor`, which must be applied manually or used via the `DiagramLayoutEngine."), $61de1ee1cac498ae$var$meb(-1)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$voe), $61de1ee1cac498ae$var$spe), "Position ID"), "Position within a layer that was determined by ELK Layered for a node. This is only generated if interactiveLayot or generatePositionAndLayerIds is set."), $61de1ee1cac498ae$var$meb(-1)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$woe), $61de1ee1cac498ae$var$upe), "Greedy Switch Activation Threshold"), "By default it is decided automatically if the greedy switch is activated or not. The decision is based on whether the size of the input graph (without dummy nodes) is smaller than the value of this option. A '0' enforces the activation."), $61de1ee1cac498ae$var$meb(40)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$xoe), $61de1ee1cac498ae$var$upe), "Greedy Switch Crossing Minimization"), "Greedy Switch strategy for crossing minimization. The greedy switch heuristic is executed after the regular crossing minimization as a post-processor. Note that if 'hierarchyHandling' is set to 'INCLUDE_CHILDREN', the 'greedySwitchHierarchical.type' option must be used."), $61de1ee1cac498ae$var$cuc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$QW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$xoe, $61de1ee1cac498ae$var$qoe, $61de1ee1cac498ae$var$duc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$yoe), "crossingMinimization.greedySwitchHierarchical"), "Greedy Switch Crossing Minimization (hierarchical)"), "Activates the greedy switch heuristic in case hierarchical layout is used. The differences to the non-hierarchical case (see 'greedySwitch.type') are: 1) greedy switch is inactive by default, 3) only the option value set on the node at which hierarchical layout starts is relevant, and 2) if it's activated by the user, it properly addresses hierarchy-crossing edges."), $61de1ee1cac498ae$var$$tc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$QW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$yoe, $61de1ee1cac498ae$var$qoe, $61de1ee1cac498ae$var$_tc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$yoe, $61de1ee1cac498ae$var$tpe, $61de1ee1cac498ae$var$auc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$zoe), $61de1ee1cac498ae$var$vpe), "Node Placement Strategy"), "Strategy for node placement."), $61de1ee1cac498ae$var$vvc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$_W), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Aoe), $61de1ee1cac498ae$var$vpe), "Favor Straight Edges Over Balancing"), "Favor straight edges over a balanced node placement. The default behavior is determined automatically based on the used 'edgeRouting'. For an orthogonal style it is set to true, for all other styles to false."), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Aoe, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$lvc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Aoe, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$mvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Boe), $61de1ee1cac498ae$var$wpe), "BK Edge Straightening"), "Specifies whether the Brandes Koepf node placer tries to increase the number of straight edges at the expense of diagram size. There is a subtle difference to the 'favorStraightEdges' option, which decides whether a balanced placement of the nodes is desired, or not. In bk terms this means combining the four alignments into a single balanced one, or not. This option on the other hand tries to straighten additional edges during the creation of each of the four alignments."), $61de1ee1cac498ae$var$fvc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$MW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Boe, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$gvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Coe), $61de1ee1cac498ae$var$wpe), "BK Fixed Alignment"), "Tells the BK node placer to use a certain alignment (out of its four) instead of the one producing the smallest height, or the combination of all four."), $61de1ee1cac498ae$var$ivc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$NW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Coe, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$jvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Doe), "nodePlacement.linearSegments"), "Linear Segments Deflection Dampening"), "Dampens the movement of nodes to keep the diagram from getting too large."), 0.3), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Doe, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$ovc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Eoe), "nodePlacement.networkSimplex"), "Node Flexibility"), "Aims at shorter and straighter edges. Two configurations are possible: (a) allow ports to move freely on the side they are assigned to (the order is always defined beforehand), (b) additionally allow to enlarge a node wherever it helps. If this option is not configured for a node, the 'nodeFlexibility.default' value is used, which is specified for the node's parent."), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$$W), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Eoe, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$tvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Foe), "nodePlacement.networkSimplex.nodeFlexibility"), "Node Flexibility Default"), "Default value of the 'nodeFlexibility' option for the children of a hierarchical node."), $61de1ee1cac498ae$var$rvc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$$W), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Foe, $61de1ee1cac498ae$var$zoe, $61de1ee1cac498ae$var$svc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Goe), $61de1ee1cac498ae$var$xpe), "Self-Loop Distribution"), "Alter the distribution of the loops around the node. It only takes effect for PortConstraints.FREE."), $61de1ee1cac498ae$var$xuc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$eX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Hoe), $61de1ee1cac498ae$var$xpe), "Self-Loop Ordering"), "Alter the ordering of the loops they can either be stacked or sequenced. It only takes effect for PortConstraints.FREE."), $61de1ee1cac498ae$var$zuc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$fX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ioe), "edgeRouting.splines"), "Spline Routing Mode"), "Specifies the way control points are assembled for each individual edge. CONSERVATIVE ensures that edges are properly routed around the nodes but feels rather orthogonal at times. SLOPPY uses fewer control points to obtain curvier edge routes but may result in edges overlapping nodes."), $61de1ee1cac498ae$var$Buc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$hX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Ioe, $61de1ee1cac498ae$var$ype, $61de1ee1cac498ae$var$Cuc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Joe), "edgeRouting.splines.sloppy"), "Sloppy Spline Layer Spacing Factor"), "Spacing factor for routing area between layers when using sloppy spline routing."), 0.2), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Joe, $61de1ee1cac498ae$var$ype, $61de1ee1cac498ae$var$Euc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Joe, $61de1ee1cac498ae$var$Ioe, $61de1ee1cac498ae$var$Fuc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Koe), "edgeRouting.polyline"), "Sloped Edge Zone Width"), "Width of the strip to the left and to the right of each layer where the polyline edge router is allowed to refrain from ensuring that edges are routed horizontally. This prevents awkward bend points for nodes that extent almost to the edge of their layer."), 2), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Koe, $61de1ee1cac498ae$var$ype, $61de1ee1cac498ae$var$vuc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Loe), $61de1ee1cac498ae$var$zpe), "Spacing Base Value"), "An optional base value for all other layout options of the 'spacing' group. It can be used to conveniently alter the overall 'spaciousness' of the drawing. Whenever an explicit value is set for the other layout options, this base value will have no effect. The base value is not inherited, i.e. it must be set for each hierarchical node."), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Moe), $61de1ee1cac498ae$var$zpe), "Edge Node Between Layers Spacing"), "The spacing to be preserved between nodes and edges that are routed next to the node's layer. For the spacing between nodes and edges that cross the node's layer 'spacing.edgeNode' is used."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Noe), $61de1ee1cac498ae$var$zpe), "Edge Edge Between Layer Spacing"), "Spacing to be preserved between pairs of edges that are routed between the same pair of layers. Note that 'spacing.edgeEdge' is used for the spacing between pairs of edges crossing the same layer."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ooe), $61de1ee1cac498ae$var$zpe), "Node Node Between Layers Spacing"), "The spacing to be preserved between any pair of nodes of two adjacent layers. Note that 'spacing.nodeNode' is used for the spacing between nodes within the layer itself."), 20), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Poe), $61de1ee1cac498ae$var$Ape), "Direction Priority"), "Defines how important it is to have a certain edge point into the direction of the overall layout. This option is evaluated during the cycle breaking phase."), $61de1ee1cac498ae$var$meb(0)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Qoe), $61de1ee1cac498ae$var$Ape), "Shortness Priority"), "Defines how important it is to keep an edge as short as possible. This option is evaluated during the layering phase."), $61de1ee1cac498ae$var$meb(0)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Roe), $61de1ee1cac498ae$var$Ape), "Straightness Priority"), "Defines how important it is to keep an edge straight, i.e. aligned with one of the two axes. This option is evaluated during node placement."), $61de1ee1cac498ae$var$meb(0)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Soe), $61de1ee1cac498ae$var$Bpe), $61de1ee1cac498ae$var$Ole), "Tries to further compact components (disconnected sub-graphs)."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Soe, $61de1ee1cac498ae$var$zme, true);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Toe), $61de1ee1cac498ae$var$Cpe), "Post Compaction Strategy"), $61de1ee1cac498ae$var$Dpe), $61de1ee1cac498ae$var$Ntc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$OW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Uoe), $61de1ee1cac498ae$var$Cpe), "Post Compaction Constraint Calculation"), $61de1ee1cac498ae$var$Dpe), $61de1ee1cac498ae$var$Ltc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$FW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Voe), $61de1ee1cac498ae$var$Epe), "High Degree Node Treatment"), "Makes room around high degree nodes to place leafs and trees."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Woe), $61de1ee1cac498ae$var$Epe), "High Degree Node Threshold"), "Whether a node is considered to have a high degree."), $61de1ee1cac498ae$var$meb(16)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Woe, $61de1ee1cac498ae$var$Voe, true);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Xoe), $61de1ee1cac498ae$var$Epe), "High Degree Node Maximum Tree Height"), "Maximum height of a subtree connected to a high degree node to be moved to separate layers."), $61de1ee1cac498ae$var$meb(5)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Xoe, $61de1ee1cac498ae$var$Voe, true);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Yoe), $61de1ee1cac498ae$var$Fpe), "Graph Wrapping Strategy"), "For certain graphs and certain prescribed drawing areas it may be desirable to split the laid out graph into chunks that are placed side by side. The edges that connect different chunks are 'wrapped' around from the end of one chunk to the start of the other chunk. The points between the chunks are referred to as 'cuts'."), $61de1ee1cac498ae$var$bwc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$jX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Zoe), $61de1ee1cac498ae$var$Fpe), "Additional Wrapped Edges Spacing"), "To visually separate edges that are wrapped from regularly routed edges an additional spacing value can be specified in form of this layout option. The spacing is added to the regular edgeNode spacing."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Zoe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Ivc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Zoe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Jvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$$oe), $61de1ee1cac498ae$var$Fpe), "Correction Factor for Wrapping"), "At times and for certain types of graphs the executed wrapping may produce results that are consistently biased in the same fashion: either wrapping to often or to rarely. This factor can be used to correct the bias. Internally, it is simply multiplied with the 'aspect ratio' layout option."), 1), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$$oe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Lvc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$$oe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Mvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$_oe), $61de1ee1cac498ae$var$Gpe), "Cutting Strategy"), "The strategy by which the layer indexes are determined at which the layering crumbles into chunks."), $61de1ee1cac498ae$var$Tvc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$HW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$_oe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Uvc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$_oe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Vvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ape), $61de1ee1cac498ae$var$Gpe), "Manually Specified Cuts"), "Allows the user to specify her own cuts for a certain graph."), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$yK), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$ape, $61de1ee1cac498ae$var$_oe, $61de1ee1cac498ae$var$Ovc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$bpe), "wrapping.cutting.msd"), "MSD Freedom"), "The MSD cutting strategy starts with an initial guess on the number of chunks the graph should be split into. The freedom specifies how much the strategy may deviate from this guess. E.g. if an initial number of 3 is computed, a freedom of 1 allows 2, 3, and 4 cuts."), $61de1ee1cac498ae$var$Qvc), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$bpe, $61de1ee1cac498ae$var$_oe, $61de1ee1cac498ae$var$Rvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$cpe), $61de1ee1cac498ae$var$Hpe), "Validification Strategy"), "When wrapping graphs, one can specify indices that are not allowed as split points. The validification strategy makes sure every computed split point is allowed."), $61de1ee1cac498ae$var$gwc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$iX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$cpe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$hwc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$cpe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$iwc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$dpe), $61de1ee1cac498ae$var$Hpe), "Valid Indices for Wrapping"), null), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$yK), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$dpe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$dwc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$dpe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$ewc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$epe), $61de1ee1cac498ae$var$Ipe), "Improve Cuts"), "For general graphs it is important that not too many edges wrap backwards. Thus a compromise between evenly-distributed cuts and the total number of cut edges is sought."), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$epe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Zvc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$fpe), $61de1ee1cac498ae$var$Ipe), "Distance Penalty When Improving Cuts"), null), 2), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$fpe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$Xvc);
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$fpe, $61de1ee1cac498ae$var$epe, true);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$gpe), $61de1ee1cac498ae$var$Ipe), "Improve Wrapped Edges"), "The initial wrapping is performed in a very simple way. As a consequence, edges that wrap from one chunk to another may be unnecessarily long. Activating this option tries to shorten such edges."), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$gpe, $61de1ee1cac498ae$var$Yoe, $61de1ee1cac498ae$var$_vc);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$hpe), $61de1ee1cac498ae$var$Jpe), "Edge Label Side Selection"), "Method to decide on edge label sides."), $61de1ee1cac498ae$var$tuc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$LW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ipe), $61de1ee1cac498ae$var$Jpe), "Edge Center Label Placement Strategy"), "Determines in which layer center labels of long edges should be placed."), $61de1ee1cac498ae$var$ruc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$EW), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$J5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$jpe), $61de1ee1cac498ae$var$Kpe), "Consider Model Order"), "Preserves the order of nodes and edges in the model file if this does not lead to additional edge crossings. Depending on the strategy this is not always possible since the node and edge order might be conflicting."), $61de1ee1cac498ae$var$Wtc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$bX), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$kpe), $61de1ee1cac498ae$var$Kpe), "No Model Order"), "Set on a node to not set a model order for this node even though it is a real node."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$lpe), $61de1ee1cac498ae$var$Kpe), "Consider Model Order for Components"), "If set to NONE the usual ordering strategy (by cumulative node priority and size of nodes) is used. INSIDE_PORT_SIDES orders the components with external ports only inside the groups with the same port side. FORCE_MODEL_ORDER enforces the mode order on components. This option might produce bad alignments and sub optimal drawings in terms of used area since the ordering should be respected."), $61de1ee1cac498ae$var$Ptc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$hQ), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$lpe, $61de1ee1cac498ae$var$zme, null);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$mpe), $61de1ee1cac498ae$var$Kpe), "Long Edge Ordering Strategy"), "Indicates whether long edges are sorted under, over, or equal to nodes that have no connection to a previous layer in a left-to-right or right-to-left layout. Under and over changes to right and left in a vertical layout."), $61de1ee1cac498ae$var$Ttc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$ZW), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$npe), $61de1ee1cac498ae$var$Kpe), "Crossing Counter Node Order Influence"), "Indicates with what percentage (1 for 100%) violations of the node model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal node order. Defaults to no influence (0)."), 0), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$npe, $61de1ee1cac498ae$var$jpe, null);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ope), $61de1ee1cac498ae$var$Kpe), "Crossing Counter Port Order Influence"), "Indicates with what percentage (1 for 100%) violations of the port model order are weighted against the crossings e.g. a value of 0.5 means two model order violations are as important as on edge crossing. This allows some edge crossings in favor of preserving the model order. It is advised to set this value to a very small positive value (e.g. 0.001) to have minimal crossing and a optimal port order. Defaults to no influence (0)."), 0), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$ope, $61de1ee1cac498ae$var$jpe, null);
    $61de1ee1cac498ae$var$Oyc((new $61de1ee1cac498ae$var$Pyc, a));
};
var $61de1ee1cac498ae$var$Itc, $61de1ee1cac498ae$var$Jtc, $61de1ee1cac498ae$var$Ktc, $61de1ee1cac498ae$var$Ltc, $61de1ee1cac498ae$var$Mtc, $61de1ee1cac498ae$var$Ntc, $61de1ee1cac498ae$var$Otc, $61de1ee1cac498ae$var$Ptc, $61de1ee1cac498ae$var$Qtc, $61de1ee1cac498ae$var$Rtc, $61de1ee1cac498ae$var$Stc, $61de1ee1cac498ae$var$Ttc, $61de1ee1cac498ae$var$Utc, $61de1ee1cac498ae$var$Vtc, $61de1ee1cac498ae$var$Wtc, $61de1ee1cac498ae$var$Xtc, $61de1ee1cac498ae$var$Ytc, $61de1ee1cac498ae$var$Ztc, $61de1ee1cac498ae$var$$tc, $61de1ee1cac498ae$var$_tc, $61de1ee1cac498ae$var$auc, $61de1ee1cac498ae$var$buc, $61de1ee1cac498ae$var$cuc, $61de1ee1cac498ae$var$duc, $61de1ee1cac498ae$var$euc, $61de1ee1cac498ae$var$fuc, $61de1ee1cac498ae$var$guc, $61de1ee1cac498ae$var$huc, $61de1ee1cac498ae$var$iuc, $61de1ee1cac498ae$var$juc, $61de1ee1cac498ae$var$kuc, $61de1ee1cac498ae$var$luc, $61de1ee1cac498ae$var$muc, $61de1ee1cac498ae$var$nuc, $61de1ee1cac498ae$var$ouc, $61de1ee1cac498ae$var$puc, $61de1ee1cac498ae$var$quc, $61de1ee1cac498ae$var$ruc, $61de1ee1cac498ae$var$suc, $61de1ee1cac498ae$var$tuc, $61de1ee1cac498ae$var$uuc, $61de1ee1cac498ae$var$vuc, $61de1ee1cac498ae$var$wuc, $61de1ee1cac498ae$var$xuc, $61de1ee1cac498ae$var$yuc, $61de1ee1cac498ae$var$zuc, $61de1ee1cac498ae$var$Auc, $61de1ee1cac498ae$var$Buc, $61de1ee1cac498ae$var$Cuc, $61de1ee1cac498ae$var$Duc, $61de1ee1cac498ae$var$Euc, $61de1ee1cac498ae$var$Fuc, $61de1ee1cac498ae$var$Guc, $61de1ee1cac498ae$var$Huc, $61de1ee1cac498ae$var$Iuc, $61de1ee1cac498ae$var$Juc, $61de1ee1cac498ae$var$Kuc, $61de1ee1cac498ae$var$Luc, $61de1ee1cac498ae$var$Muc, $61de1ee1cac498ae$var$Nuc, $61de1ee1cac498ae$var$Ouc, $61de1ee1cac498ae$var$Puc, $61de1ee1cac498ae$var$Quc, $61de1ee1cac498ae$var$Ruc, $61de1ee1cac498ae$var$Suc, $61de1ee1cac498ae$var$Tuc, $61de1ee1cac498ae$var$Uuc, $61de1ee1cac498ae$var$Vuc, $61de1ee1cac498ae$var$Wuc, $61de1ee1cac498ae$var$Xuc, $61de1ee1cac498ae$var$Yuc, $61de1ee1cac498ae$var$Zuc, $61de1ee1cac498ae$var$$uc, $61de1ee1cac498ae$var$_uc, $61de1ee1cac498ae$var$avc, $61de1ee1cac498ae$var$bvc, $61de1ee1cac498ae$var$cvc, $61de1ee1cac498ae$var$dvc, $61de1ee1cac498ae$var$evc, $61de1ee1cac498ae$var$fvc, $61de1ee1cac498ae$var$gvc, $61de1ee1cac498ae$var$hvc, $61de1ee1cac498ae$var$ivc, $61de1ee1cac498ae$var$jvc, $61de1ee1cac498ae$var$kvc, $61de1ee1cac498ae$var$lvc, $61de1ee1cac498ae$var$mvc, $61de1ee1cac498ae$var$nvc, $61de1ee1cac498ae$var$ovc, $61de1ee1cac498ae$var$pvc, $61de1ee1cac498ae$var$qvc, $61de1ee1cac498ae$var$rvc, $61de1ee1cac498ae$var$svc, $61de1ee1cac498ae$var$tvc, $61de1ee1cac498ae$var$uvc, $61de1ee1cac498ae$var$vvc, $61de1ee1cac498ae$var$wvc, $61de1ee1cac498ae$var$xvc, $61de1ee1cac498ae$var$yvc, $61de1ee1cac498ae$var$zvc, $61de1ee1cac498ae$var$Avc, $61de1ee1cac498ae$var$Bvc, $61de1ee1cac498ae$var$Cvc, $61de1ee1cac498ae$var$Dvc, $61de1ee1cac498ae$var$Evc, $61de1ee1cac498ae$var$Fvc, $61de1ee1cac498ae$var$Gvc, $61de1ee1cac498ae$var$Hvc, $61de1ee1cac498ae$var$Ivc, $61de1ee1cac498ae$var$Jvc, $61de1ee1cac498ae$var$Kvc, $61de1ee1cac498ae$var$Lvc, $61de1ee1cac498ae$var$Mvc, $61de1ee1cac498ae$var$Nvc, $61de1ee1cac498ae$var$Ovc, $61de1ee1cac498ae$var$Pvc, $61de1ee1cac498ae$var$Qvc, $61de1ee1cac498ae$var$Rvc, $61de1ee1cac498ae$var$Svc, $61de1ee1cac498ae$var$Tvc, $61de1ee1cac498ae$var$Uvc, $61de1ee1cac498ae$var$Vvc, $61de1ee1cac498ae$var$Wvc, $61de1ee1cac498ae$var$Xvc, $61de1ee1cac498ae$var$Yvc, $61de1ee1cac498ae$var$Zvc, $61de1ee1cac498ae$var$$vc, $61de1ee1cac498ae$var$_vc, $61de1ee1cac498ae$var$awc, $61de1ee1cac498ae$var$bwc, $61de1ee1cac498ae$var$cwc, $61de1ee1cac498ae$var$dwc, $61de1ee1cac498ae$var$ewc, $61de1ee1cac498ae$var$fwc, $61de1ee1cac498ae$var$gwc, $61de1ee1cac498ae$var$hwc, $61de1ee1cac498ae$var$iwc;
var $61de1ee1cac498ae$var$UW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Sne, "LayeredMetaDataProvider", 848);
$61de1ee1cac498ae$var$bcb(986, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$Pyc);
$61de1ee1cac498ae$var$_.Qe = function Qyc(a) {
    $61de1ee1cac498ae$var$Oyc(a);
};
var $61de1ee1cac498ae$var$mwc, $61de1ee1cac498ae$var$nwc, $61de1ee1cac498ae$var$owc, $61de1ee1cac498ae$var$pwc, $61de1ee1cac498ae$var$qwc, $61de1ee1cac498ae$var$rwc, $61de1ee1cac498ae$var$swc, $61de1ee1cac498ae$var$twc, $61de1ee1cac498ae$var$uwc, $61de1ee1cac498ae$var$vwc, $61de1ee1cac498ae$var$wwc, $61de1ee1cac498ae$var$xwc, $61de1ee1cac498ae$var$ywc, $61de1ee1cac498ae$var$zwc, $61de1ee1cac498ae$var$Awc, $61de1ee1cac498ae$var$Bwc, $61de1ee1cac498ae$var$Cwc, $61de1ee1cac498ae$var$Dwc, $61de1ee1cac498ae$var$Ewc, $61de1ee1cac498ae$var$Fwc, $61de1ee1cac498ae$var$Gwc, $61de1ee1cac498ae$var$Hwc, $61de1ee1cac498ae$var$Iwc, $61de1ee1cac498ae$var$Jwc, $61de1ee1cac498ae$var$Kwc, $61de1ee1cac498ae$var$Lwc, $61de1ee1cac498ae$var$Mwc, $61de1ee1cac498ae$var$Nwc, $61de1ee1cac498ae$var$Owc, $61de1ee1cac498ae$var$Pwc, $61de1ee1cac498ae$var$Qwc, $61de1ee1cac498ae$var$Rwc, $61de1ee1cac498ae$var$Swc, $61de1ee1cac498ae$var$Twc, $61de1ee1cac498ae$var$Uwc, $61de1ee1cac498ae$var$Vwc, $61de1ee1cac498ae$var$Wwc, $61de1ee1cac498ae$var$Xwc, $61de1ee1cac498ae$var$Ywc, $61de1ee1cac498ae$var$Zwc, $61de1ee1cac498ae$var$$wc, $61de1ee1cac498ae$var$_wc, $61de1ee1cac498ae$var$axc, $61de1ee1cac498ae$var$bxc, $61de1ee1cac498ae$var$cxc, $61de1ee1cac498ae$var$dxc, $61de1ee1cac498ae$var$exc, $61de1ee1cac498ae$var$fxc, $61de1ee1cac498ae$var$gxc, $61de1ee1cac498ae$var$hxc, $61de1ee1cac498ae$var$ixc, $61de1ee1cac498ae$var$jxc, $61de1ee1cac498ae$var$kxc, $61de1ee1cac498ae$var$lxc, $61de1ee1cac498ae$var$mxc, $61de1ee1cac498ae$var$nxc, $61de1ee1cac498ae$var$oxc, $61de1ee1cac498ae$var$pxc, $61de1ee1cac498ae$var$qxc, $61de1ee1cac498ae$var$rxc, $61de1ee1cac498ae$var$sxc, $61de1ee1cac498ae$var$txc, $61de1ee1cac498ae$var$uxc, $61de1ee1cac498ae$var$vxc, $61de1ee1cac498ae$var$wxc, $61de1ee1cac498ae$var$xxc, $61de1ee1cac498ae$var$yxc, $61de1ee1cac498ae$var$zxc, $61de1ee1cac498ae$var$Axc, $61de1ee1cac498ae$var$Bxc, $61de1ee1cac498ae$var$Cxc, $61de1ee1cac498ae$var$Dxc, $61de1ee1cac498ae$var$Exc, $61de1ee1cac498ae$var$Fxc, $61de1ee1cac498ae$var$Gxc, $61de1ee1cac498ae$var$Hxc, $61de1ee1cac498ae$var$Ixc, $61de1ee1cac498ae$var$Jxc, $61de1ee1cac498ae$var$Kxc, $61de1ee1cac498ae$var$Lxc, $61de1ee1cac498ae$var$Mxc, $61de1ee1cac498ae$var$Nxc, $61de1ee1cac498ae$var$Oxc, $61de1ee1cac498ae$var$Pxc, $61de1ee1cac498ae$var$Qxc, $61de1ee1cac498ae$var$Rxc, $61de1ee1cac498ae$var$Sxc, $61de1ee1cac498ae$var$Txc, $61de1ee1cac498ae$var$Uxc, $61de1ee1cac498ae$var$Vxc, $61de1ee1cac498ae$var$Wxc, $61de1ee1cac498ae$var$Xxc, $61de1ee1cac498ae$var$Yxc, $61de1ee1cac498ae$var$Zxc, $61de1ee1cac498ae$var$$xc, $61de1ee1cac498ae$var$_xc, $61de1ee1cac498ae$var$ayc, $61de1ee1cac498ae$var$byc, $61de1ee1cac498ae$var$cyc, $61de1ee1cac498ae$var$dyc, $61de1ee1cac498ae$var$eyc, $61de1ee1cac498ae$var$fyc, $61de1ee1cac498ae$var$gyc, $61de1ee1cac498ae$var$hyc, $61de1ee1cac498ae$var$iyc, $61de1ee1cac498ae$var$jyc, $61de1ee1cac498ae$var$kyc, $61de1ee1cac498ae$var$lyc, $61de1ee1cac498ae$var$myc, $61de1ee1cac498ae$var$nyc, $61de1ee1cac498ae$var$oyc, $61de1ee1cac498ae$var$pyc, $61de1ee1cac498ae$var$qyc, $61de1ee1cac498ae$var$ryc, $61de1ee1cac498ae$var$syc, $61de1ee1cac498ae$var$tyc, $61de1ee1cac498ae$var$uyc, $61de1ee1cac498ae$var$vyc, $61de1ee1cac498ae$var$wyc, $61de1ee1cac498ae$var$xyc, $61de1ee1cac498ae$var$yyc, $61de1ee1cac498ae$var$zyc, $61de1ee1cac498ae$var$Ayc, $61de1ee1cac498ae$var$Byc, $61de1ee1cac498ae$var$Cyc, $61de1ee1cac498ae$var$Dyc, $61de1ee1cac498ae$var$Eyc, $61de1ee1cac498ae$var$Fyc, $61de1ee1cac498ae$var$Gyc, $61de1ee1cac498ae$var$Hyc, $61de1ee1cac498ae$var$Iyc, $61de1ee1cac498ae$var$Jyc, $61de1ee1cac498ae$var$Kyc, $61de1ee1cac498ae$var$Lyc, $61de1ee1cac498ae$var$Myc;
var $61de1ee1cac498ae$var$WW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Sne, "LayeredOptions", 986);
$61de1ee1cac498ae$var$bcb(987, 1, {}, $61de1ee1cac498ae$var$Ryc);
$61de1ee1cac498ae$var$_.$e = function Syc() {
    var a;
    return a = new $61de1ee1cac498ae$var$jUb, a;
};
$61de1ee1cac498ae$var$_._e = function Tyc(a) {};
var $61de1ee1cac498ae$var$VW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Sne, "LayeredOptions/LayeredFactory", 987);
$61de1ee1cac498ae$var$bcb(1372, 1, {});
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$Uyc;
var $61de1ee1cac498ae$var$$1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder", 1372);
$61de1ee1cac498ae$var$bcb(779, 1372, {}, $61de1ee1cac498ae$var$ezc);
var $61de1ee1cac498ae$var$bzc, $61de1ee1cac498ae$var$czc;
var $61de1ee1cac498ae$var$XW = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Sne, "LayeredSpacings/LayeredSpacingsBuilder", 779);
$61de1ee1cac498ae$var$bcb(313, 22, {
    3: 1,
    35: 1,
    22: 1,
    313: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$nzc);
$61de1ee1cac498ae$var$_.Kf = function pzc() {
    return $61de1ee1cac498ae$var$mzc(this);
};
$61de1ee1cac498ae$var$_.Xf = function ozc() {
    return $61de1ee1cac498ae$var$mzc(this);
};
var $61de1ee1cac498ae$var$fzc, $61de1ee1cac498ae$var$gzc, $61de1ee1cac498ae$var$hzc, $61de1ee1cac498ae$var$izc, $61de1ee1cac498ae$var$jzc, $61de1ee1cac498ae$var$kzc;
var $61de1ee1cac498ae$var$YW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "LayeringStrategy", 313, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$rzc, $61de1ee1cac498ae$var$qzc);
var $61de1ee1cac498ae$var$szc;
$61de1ee1cac498ae$var$bcb(378, 22, {
    3: 1,
    35: 1,
    22: 1,
    378: 1
}, $61de1ee1cac498ae$var$zzc);
var $61de1ee1cac498ae$var$uzc, $61de1ee1cac498ae$var$vzc, $61de1ee1cac498ae$var$wzc;
var $61de1ee1cac498ae$var$ZW = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "LongEdgeOrderingStrategy", 378, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Bzc, $61de1ee1cac498ae$var$Azc);
var $61de1ee1cac498ae$var$Czc;
$61de1ee1cac498ae$var$bcb(197, 22, {
    3: 1,
    35: 1,
    22: 1,
    197: 1
}, $61de1ee1cac498ae$var$Kzc);
var $61de1ee1cac498ae$var$Ezc, $61de1ee1cac498ae$var$Fzc, $61de1ee1cac498ae$var$Gzc, $61de1ee1cac498ae$var$Hzc;
var $61de1ee1cac498ae$var$$W = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "NodeFlexibility", 197, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Nzc, $61de1ee1cac498ae$var$Mzc);
var $61de1ee1cac498ae$var$Ozc;
$61de1ee1cac498ae$var$bcb(315, 22, {
    3: 1,
    35: 1,
    22: 1,
    315: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$Xzc);
$61de1ee1cac498ae$var$_.Kf = function Zzc() {
    return $61de1ee1cac498ae$var$Wzc(this);
};
$61de1ee1cac498ae$var$_.Xf = function Yzc() {
    return $61de1ee1cac498ae$var$Wzc(this);
};
var $61de1ee1cac498ae$var$Qzc, $61de1ee1cac498ae$var$Rzc, $61de1ee1cac498ae$var$Szc, $61de1ee1cac498ae$var$Tzc, $61de1ee1cac498ae$var$Uzc;
var $61de1ee1cac498ae$var$_W = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "NodePlacementStrategy", 315, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$_zc, $61de1ee1cac498ae$var$$zc);
var $61de1ee1cac498ae$var$aAc;
$61de1ee1cac498ae$var$bcb(260, 22, {
    3: 1,
    35: 1,
    22: 1,
    260: 1
}, $61de1ee1cac498ae$var$lAc);
var $61de1ee1cac498ae$var$cAc, $61de1ee1cac498ae$var$dAc, $61de1ee1cac498ae$var$eAc, $61de1ee1cac498ae$var$fAc, $61de1ee1cac498ae$var$gAc, $61de1ee1cac498ae$var$hAc, $61de1ee1cac498ae$var$iAc, $61de1ee1cac498ae$var$jAc;
var $61de1ee1cac498ae$var$aX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "NodePromotionStrategy", 260, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$nAc, $61de1ee1cac498ae$var$mAc);
var $61de1ee1cac498ae$var$oAc;
$61de1ee1cac498ae$var$bcb(339, 22, {
    3: 1,
    35: 1,
    22: 1,
    339: 1
}, $61de1ee1cac498ae$var$uAc);
var $61de1ee1cac498ae$var$qAc, $61de1ee1cac498ae$var$rAc, $61de1ee1cac498ae$var$sAc;
var $61de1ee1cac498ae$var$bX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "OrderingStrategy", 339, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$wAc, $61de1ee1cac498ae$var$vAc);
var $61de1ee1cac498ae$var$xAc;
$61de1ee1cac498ae$var$bcb(421, 22, {
    3: 1,
    35: 1,
    22: 1,
    421: 1
}, $61de1ee1cac498ae$var$CAc);
var $61de1ee1cac498ae$var$zAc, $61de1ee1cac498ae$var$AAc;
var $61de1ee1cac498ae$var$cX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "PortSortingStrategy", 421, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$EAc, $61de1ee1cac498ae$var$DAc);
var $61de1ee1cac498ae$var$FAc;
$61de1ee1cac498ae$var$bcb(452, 22, {
    3: 1,
    35: 1,
    22: 1,
    452: 1
}, $61de1ee1cac498ae$var$LAc);
var $61de1ee1cac498ae$var$HAc, $61de1ee1cac498ae$var$IAc, $61de1ee1cac498ae$var$JAc;
var $61de1ee1cac498ae$var$dX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "PortType", 452, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$NAc, $61de1ee1cac498ae$var$MAc);
var $61de1ee1cac498ae$var$OAc;
$61de1ee1cac498ae$var$bcb(375, 22, {
    3: 1,
    35: 1,
    22: 1,
    375: 1
}, $61de1ee1cac498ae$var$UAc);
var $61de1ee1cac498ae$var$QAc, $61de1ee1cac498ae$var$RAc, $61de1ee1cac498ae$var$SAc;
var $61de1ee1cac498ae$var$eX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "SelfLoopDistributionStrategy", 375, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$WAc, $61de1ee1cac498ae$var$VAc);
var $61de1ee1cac498ae$var$XAc;
$61de1ee1cac498ae$var$bcb(376, 22, {
    3: 1,
    35: 1,
    22: 1,
    376: 1
}, $61de1ee1cac498ae$var$aBc);
var $61de1ee1cac498ae$var$ZAc, $61de1ee1cac498ae$var$$Ac;
var $61de1ee1cac498ae$var$fX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "SelfLoopOrderingStrategy", 376, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$cBc, $61de1ee1cac498ae$var$bBc);
var $61de1ee1cac498ae$var$dBc;
$61de1ee1cac498ae$var$bcb(304, 1, {
    304: 1
}, $61de1ee1cac498ae$var$oBc);
var $61de1ee1cac498ae$var$gX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Sne, "Spacings", 304);
$61de1ee1cac498ae$var$bcb(336, 22, {
    3: 1,
    35: 1,
    22: 1,
    336: 1
}, $61de1ee1cac498ae$var$uBc);
var $61de1ee1cac498ae$var$qBc, $61de1ee1cac498ae$var$rBc, $61de1ee1cac498ae$var$sBc;
var $61de1ee1cac498ae$var$hX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "SplineRoutingMode", 336, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$wBc, $61de1ee1cac498ae$var$vBc);
var $61de1ee1cac498ae$var$xBc;
$61de1ee1cac498ae$var$bcb(338, 22, {
    3: 1,
    35: 1,
    22: 1,
    338: 1
}, $61de1ee1cac498ae$var$DBc);
var $61de1ee1cac498ae$var$zBc, $61de1ee1cac498ae$var$ABc, $61de1ee1cac498ae$var$BBc;
var $61de1ee1cac498ae$var$iX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "ValidifyStrategy", 338, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$FBc, $61de1ee1cac498ae$var$EBc);
var $61de1ee1cac498ae$var$GBc;
$61de1ee1cac498ae$var$bcb(377, 22, {
    3: 1,
    35: 1,
    22: 1,
    377: 1
}, $61de1ee1cac498ae$var$MBc);
var $61de1ee1cac498ae$var$IBc, $61de1ee1cac498ae$var$JBc, $61de1ee1cac498ae$var$KBc;
var $61de1ee1cac498ae$var$jX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Sne, "WrappingStrategy", 377, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$OBc, $61de1ee1cac498ae$var$NBc);
var $61de1ee1cac498ae$var$PBc;
$61de1ee1cac498ae$var$bcb(1383, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$VBc);
$61de1ee1cac498ae$var$_.Yf = function WBc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$RBc;
};
$61de1ee1cac498ae$var$_.pf = function XBc(a, b) {
    $61de1ee1cac498ae$var$UBc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$RBc;
var $61de1ee1cac498ae$var$kX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cqe, "DepthFirstCycleBreaker", 1383);
$61de1ee1cac498ae$var$bcb(782, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$aCc);
$61de1ee1cac498ae$var$_.Yf = function cCc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$YBc;
};
$61de1ee1cac498ae$var$_.pf = function dCc(a, b) {
    $61de1ee1cac498ae$var$$Bc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.Zf = function bCc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a, $61de1ee1cac498ae$var$Bub(this.d, a.c.length)), 10);
};
var $61de1ee1cac498ae$var$YBc;
var $61de1ee1cac498ae$var$lX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cqe, "GreedyCycleBreaker", 782);
$61de1ee1cac498ae$var$bcb(1386, 782, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$eCc);
$61de1ee1cac498ae$var$_.Zf = function fCc(a) {
    var b, c, d, e;
    e = null;
    b = $61de1ee1cac498ae$var$Ohe;
    for(d = new $61de1ee1cac498ae$var$olb(a); d.a < d.c.c.length;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 10);
        if ($61de1ee1cac498ae$var$wNb(c, ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Zsc)) && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Zsc), 19).a < b) {
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb(c, $61de1ee1cac498ae$var$Zsc), 19).a;
            e = c;
        }
    }
    if (!e) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a, $61de1ee1cac498ae$var$Bub(this.d, a.c.length)), 10);
    return e;
};
var $61de1ee1cac498ae$var$mX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cqe, "GreedyModelOrderCycleBreaker", 1386);
$61de1ee1cac498ae$var$bcb(1384, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$kCc);
$61de1ee1cac498ae$var$_.Yf = function lCc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$gCc;
};
$61de1ee1cac498ae$var$_.pf = function mCc(a, b) {
    $61de1ee1cac498ae$var$jCc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$gCc;
var $61de1ee1cac498ae$var$nX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cqe, "InteractiveCycleBreaker", 1384);
$61de1ee1cac498ae$var$bcb(1385, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$rCc);
$61de1ee1cac498ae$var$_.Yf = function sCc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$nCc;
};
$61de1ee1cac498ae$var$_.pf = function tCc(a, b) {
    $61de1ee1cac498ae$var$qCc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$nCc;
var $61de1ee1cac498ae$var$oX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Cqe, "ModelOrderCycleBreaker", 1385);
$61de1ee1cac498ae$var$bcb(1389, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$DCc);
$61de1ee1cac498ae$var$_.Yf = function ECc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$uCc;
};
$61de1ee1cac498ae$var$_.pf = function FCc(a, b) {
    $61de1ee1cac498ae$var$BCc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$uCc;
var $61de1ee1cac498ae$var$rX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "CoffmanGrahamLayerer", 1389);
$61de1ee1cac498ae$var$bcb(1390, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$GCc);
$61de1ee1cac498ae$var$_.ue = function HCc(a, b) {
    return $61de1ee1cac498ae$var$xCc(this.a, $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function ICc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function JCc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$pX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "CoffmanGrahamLayerer/0methodref$compareNodesInTopo$Type", 1390);
$61de1ee1cac498ae$var$bcb(1391, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$KCc);
$61de1ee1cac498ae$var$_.ue = function LCc(a, b) {
    return $61de1ee1cac498ae$var$ACc(this.a, $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function MCc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function NCc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$qX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "CoffmanGrahamLayerer/lambda$1$Type", 1391);
$61de1ee1cac498ae$var$bcb(1392, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$QCc);
$61de1ee1cac498ae$var$_.Yf = function RCc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$n8b)), $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$w8b), $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$v8b);
};
$61de1ee1cac498ae$var$_.pf = function SCc(a, b) {
    $61de1ee1cac498ae$var$PCc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$tX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "InteractiveLayerer", 1392);
$61de1ee1cac498ae$var$bcb(569, 1, {
    569: 1
}, $61de1ee1cac498ae$var$TCc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$sX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "InteractiveLayerer/LayerSpan", 569);
$61de1ee1cac498ae$var$bcb(1388, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$ZCc);
$61de1ee1cac498ae$var$_.Yf = function $Cc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$UCc;
};
$61de1ee1cac498ae$var$_.pf = function _Cc(a, b) {
    $61de1ee1cac498ae$var$WCc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$UCc;
var $61de1ee1cac498ae$var$uX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "LongestPathLayerer", 1388);
$61de1ee1cac498ae$var$bcb(1395, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$iDc);
$61de1ee1cac498ae$var$_.Yf = function jDc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$Z7b)), $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$w8b), $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$v8b);
};
$61de1ee1cac498ae$var$_.pf = function kDc(a, b) {
    $61de1ee1cac498ae$var$gDc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$aDc, $61de1ee1cac498ae$var$bDc;
var $61de1ee1cac498ae$var$wX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "MinWidthLayerer", 1395);
$61de1ee1cac498ae$var$bcb(1396, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$mDc);
$61de1ee1cac498ae$var$_.ue = function nDc(a, b) {
    return $61de1ee1cac498ae$var$lDc(this, $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function oDc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function pDc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$vX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "MinWidthLayerer/MinOutgoingEdgesComparator", 1396);
$61de1ee1cac498ae$var$bcb(1387, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$xDc);
$61de1ee1cac498ae$var$_.Yf = function yDc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$qDc;
};
$61de1ee1cac498ae$var$_.pf = function zDc(a, b) {
    $61de1ee1cac498ae$var$wDc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$qDc;
var $61de1ee1cac498ae$var$xX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "NetworkSimplexLayerer", 1387);
$61de1ee1cac498ae$var$bcb(1393, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$LDc);
$61de1ee1cac498ae$var$_.Yf = function MDc(a) {
    return $61de1ee1cac498ae$var$BD(a, 37), $61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c($61de1ee1cac498ae$var$e3c(new $61de1ee1cac498ae$var$j3c, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$lUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$Z7b)), $61de1ee1cac498ae$var$mUb, $61de1ee1cac498ae$var$w8b), $61de1ee1cac498ae$var$nUb, $61de1ee1cac498ae$var$v8b);
};
$61de1ee1cac498ae$var$_.pf = function NDc(a, b) {
    $61de1ee1cac498ae$var$IDc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.s = 0;
$61de1ee1cac498ae$var$_.t = 0;
$61de1ee1cac498ae$var$_.u = 0;
var $61de1ee1cac498ae$var$zX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "StretchWidthLayerer", 1393);
$61de1ee1cac498ae$var$bcb(1394, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$PDc);
$61de1ee1cac498ae$var$_.ue = function QDc(a, b) {
    return $61de1ee1cac498ae$var$ODc($61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function RDc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function SDc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$yX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Dqe, "StretchWidthLayerer/1", 1394);
$61de1ee1cac498ae$var$bcb(402, 1, $61de1ee1cac498ae$var$Eqe);
$61de1ee1cac498ae$var$_.Nf = function fEc(a, b, c, d, e, f) {};
$61de1ee1cac498ae$var$_._f = function dEc(a, b, c) {
    return $61de1ee1cac498ae$var$YDc(this, a, b, c);
};
$61de1ee1cac498ae$var$_.Mf = function eEc() {
    this.g = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$VD, $61de1ee1cac498ae$var$Fqe, 25, this.d, 15, 1);
    this.f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$VD, $61de1ee1cac498ae$var$Fqe, 25, this.d, 15, 1);
};
$61de1ee1cac498ae$var$_.Of = function gEc(a, b) {
    this.e[a] = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, b[a].length, 15, 1);
};
$61de1ee1cac498ae$var$_.Pf = function hEc(a, b, c) {
    var d;
    d = c[a][b];
    d.p = b;
    this.e[a][b] = b;
};
$61de1ee1cac498ae$var$_.Qf = function iEc(a, b, c, d) {
    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d[a][b].j, c), 11).p = this.d++;
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$BX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "AbstractBarycenterPortDistributor", 402);
$61de1ee1cac498ae$var$bcb(1633, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$jEc);
$61de1ee1cac498ae$var$_.ue = function kEc(a, b) {
    return $61de1ee1cac498ae$var$_Dc(this.a, $61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function lEc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function mEc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$AX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "AbstractBarycenterPortDistributor/lambda$0$Type", 1633);
$61de1ee1cac498ae$var$bcb(817, 1, $61de1ee1cac498ae$var$Mne, $61de1ee1cac498ae$var$uEc);
$61de1ee1cac498ae$var$_.Nf = function xEc(a, b, c, d, e, f) {};
$61de1ee1cac498ae$var$_.Pf = function zEc(a, b, c) {};
$61de1ee1cac498ae$var$_.Qf = function AEc(a, b, c, d) {};
$61de1ee1cac498ae$var$_.Lf = function vEc() {
    return false;
};
$61de1ee1cac498ae$var$_.Mf = function wEc() {
    this.c = this.e.a;
    this.g = this.f.g;
};
$61de1ee1cac498ae$var$_.Of = function yEc(a, b) {
    b[a][0].c.p = a;
};
$61de1ee1cac498ae$var$_.Rf = function BEc() {
    return false;
};
$61de1ee1cac498ae$var$_.ag = function CEc(a, b, c, d) {
    if (c) $61de1ee1cac498ae$var$rEc(this, a);
    else {
        $61de1ee1cac498ae$var$oEc(this, a, d);
        $61de1ee1cac498ae$var$pEc(this, a, b);
    }
    if (a.c.length > 1) {
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 10))), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Awc)))) ? $61de1ee1cac498ae$var$YGc(a, this.d, $61de1ee1cac498ae$var$BD(this, 660)) : ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Okb(a, this.d));
        $61de1ee1cac498ae$var$PEc(this.e, a);
    }
};
$61de1ee1cac498ae$var$_.Sf = function DEc(a, b, c, d) {
    var e, f, g, h, i, j, k;
    if (b != $61de1ee1cac498ae$var$sEc(c, a.length)) {
        f = a[b - (c ? 1 : -1)];
        $61de1ee1cac498ae$var$UDc(this.f, f, c ? ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc) : ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc));
    }
    e = a[b][0];
    k = !d || e.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$e0b);
    j = $61de1ee1cac498ae$var$Ou(a[b]);
    this.ag(j, k, false, c);
    g = 0;
    for(i = new $61de1ee1cac498ae$var$olb(j); i.a < i.c.c.length;){
        h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 10);
        a[b][g++] = h;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Tf = function EEc(a, b) {
    var c, d, e, f, g;
    g = $61de1ee1cac498ae$var$sEc(b, a.length);
    f = $61de1ee1cac498ae$var$Ou(a[g]);
    this.ag(f, false, true, b);
    c = 0;
    for(e = new $61de1ee1cac498ae$var$olb(f); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 10);
        a[g][c++] = d;
    }
    return false;
};
var $61de1ee1cac498ae$var$EX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "BarycenterHeuristic", 817);
$61de1ee1cac498ae$var$bcb(658, 1, {
    658: 1
}, $61de1ee1cac498ae$var$FEc);
$61de1ee1cac498ae$var$_.Ib = function GEc() {
    return "BarycenterState [node=" + this.c + ", summedWeight=" + this.d + ", degree=" + this.b + ", barycenter=" + this.a + ", visited=" + this.e + "]";
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = false;
var $61de1ee1cac498ae$var$CX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "BarycenterHeuristic/BarycenterState", 658);
$61de1ee1cac498ae$var$bcb(1802, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$HEc);
$61de1ee1cac498ae$var$_.ue = function IEc(a, b) {
    return $61de1ee1cac498ae$var$qEc(this.a, $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function JEc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function KEc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$DX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "BarycenterHeuristic/lambda$0$Type", 1802);
$61de1ee1cac498ae$var$bcb(816, 1, $61de1ee1cac498ae$var$Mne, $61de1ee1cac498ae$var$SEc);
$61de1ee1cac498ae$var$_.Mf = function TEc() {};
$61de1ee1cac498ae$var$_.Nf = function UEc(a, b, c, d, e, f) {};
$61de1ee1cac498ae$var$_.Qf = function XEc(a, b, c, d) {};
$61de1ee1cac498ae$var$_.Of = function VEc(a, b) {
    this.a[a] = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$CX, {
        3: 1,
        4: 1,
        5: 1,
        2018: 1
    }, 658, b[a].length, 0, 1);
    this.b[a] = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$FX, {
        3: 1,
        4: 1,
        5: 1,
        2019: 1
    }, 233, b[a].length, 0, 1);
};
$61de1ee1cac498ae$var$_.Pf = function WEc(a, b, c) {
    $61de1ee1cac498ae$var$OEc(this, c[a][b], true);
};
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$HX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "ForsterConstraintResolver", 816);
$61de1ee1cac498ae$var$bcb(233, 1, {
    233: 1
}, $61de1ee1cac498ae$var$$Ec, $61de1ee1cac498ae$var$_Ec);
$61de1ee1cac498ae$var$_.Ib = function aFc() {
    var a, b;
    b = new $61de1ee1cac498ae$var$Ufb;
    b.a += "[";
    for(a = 0; a < this.d.length; a++){
        $61de1ee1cac498ae$var$Qfb(b, $61de1ee1cac498ae$var$a0b(this.d[a]));
        $61de1ee1cac498ae$var$REc(this.g, this.d[0]).a != null && $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb((b.a += "<", b), $61de1ee1cac498ae$var$Jdb($61de1ee1cac498ae$var$REc(this.g, this.d[0]).a)), ">");
        a < this.d.length - 1 && (b.a += $61de1ee1cac498ae$var$She, b);
    }
    return (b.a += "]", b).a;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$FX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "ForsterConstraintResolver/ConstraintGroup", 233);
$61de1ee1cac498ae$var$bcb(1797, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$bFc);
$61de1ee1cac498ae$var$_.td = function cFc(a) {
    $61de1ee1cac498ae$var$OEc(this.a, $61de1ee1cac498ae$var$BD(a, 10), false);
};
var $61de1ee1cac498ae$var$GX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "ForsterConstraintResolver/lambda$0$Type", 1797);
$61de1ee1cac498ae$var$bcb(214, 1, {
    214: 1,
    225: 1
}, $61de1ee1cac498ae$var$fFc);
$61de1ee1cac498ae$var$_.Nf = function hFc(a, b, c, d, e, f) {};
$61de1ee1cac498ae$var$_.Of = function iFc(a, b) {};
$61de1ee1cac498ae$var$_.Mf = function gFc() {
    this.r = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, this.n, 15, 1);
};
$61de1ee1cac498ae$var$_.Pf = function jFc(a, b, c) {
    var d, e;
    e = c[a][b];
    d = e.e;
    !!d && $61de1ee1cac498ae$var$Ekb(this.b, d);
};
$61de1ee1cac498ae$var$_.Qf = function kFc(a, b, c, d) {
    ++this.n;
};
$61de1ee1cac498ae$var$_.Ib = function lFc() {
    return $61de1ee1cac498ae$var$wlb(this.e, new $61de1ee1cac498ae$var$Tqb);
};
$61de1ee1cac498ae$var$_.g = false;
$61de1ee1cac498ae$var$_.i = false;
$61de1ee1cac498ae$var$_.n = 0;
$61de1ee1cac498ae$var$_.s = false;
var $61de1ee1cac498ae$var$IX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "GraphInfoHolder", 214);
$61de1ee1cac498ae$var$bcb(1832, 1, $61de1ee1cac498ae$var$Mne, $61de1ee1cac498ae$var$pFc);
$61de1ee1cac498ae$var$_.Nf = function sFc(a, b, c, d, e, f) {};
$61de1ee1cac498ae$var$_.Of = function tFc(a, b) {};
$61de1ee1cac498ae$var$_.Qf = function vFc(a, b, c, d) {};
$61de1ee1cac498ae$var$_._f = function qFc(a, b, c) {
    c && b > 0 ? ($61de1ee1cac498ae$var$RHc(this.a, a[b - 1], a[b]), undefined) : !c && b < a.length - 1 ? ($61de1ee1cac498ae$var$RHc(this.a, a[b], a[b + 1]), undefined) : $61de1ee1cac498ae$var$THc(this.a, a[b], c ? ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd) : ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd));
    return $61de1ee1cac498ae$var$mFc(this, a, b, c);
};
$61de1ee1cac498ae$var$_.Mf = function rFc() {
    this.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, this.c, 15, 1);
    this.a = new $61de1ee1cac498ae$var$dIc(this.d);
};
$61de1ee1cac498ae$var$_.Pf = function uFc(a, b, c) {
    var d;
    d = c[a][b];
    this.c += d.j.c.length;
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$JX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "GreedyPortDistributor", 1832);
$61de1ee1cac498ae$var$bcb(1401, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$CFc);
$61de1ee1cac498ae$var$_.Yf = function DFc(a) {
    return $61de1ee1cac498ae$var$zFc($61de1ee1cac498ae$var$BD(a, 37));
};
$61de1ee1cac498ae$var$_.pf = function EFc(a, b) {
    $61de1ee1cac498ae$var$BFc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$xFc;
var $61de1ee1cac498ae$var$LX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "InteractiveCrossingMinimizer", 1401);
$61de1ee1cac498ae$var$bcb(1402, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$GFc);
$61de1ee1cac498ae$var$_.ue = function HFc(a, b) {
    return $61de1ee1cac498ae$var$FFc(this, $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function IFc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function JFc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$KX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "InteractiveCrossingMinimizer/1", 1402);
$61de1ee1cac498ae$var$bcb(507, 1, {
    507: 1,
    123: 1,
    51: 1
}, $61de1ee1cac498ae$var$fGc);
$61de1ee1cac498ae$var$_.Yf = function gGc(a) {
    var b;
    return $61de1ee1cac498ae$var$BD(a, 37), b = $61de1ee1cac498ae$var$k3c($61de1ee1cac498ae$var$KFc), $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$H8b)), b;
};
$61de1ee1cac498ae$var$_.pf = function hGc(a, b) {
    $61de1ee1cac498ae$var$YFc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$KFc;
var $61de1ee1cac498ae$var$RX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepCrossingMinimizer", 507);
$61de1ee1cac498ae$var$bcb(1398, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$iGc);
$61de1ee1cac498ae$var$_.td = function jGc(a) {
    $61de1ee1cac498ae$var$MFc(this.a, $61de1ee1cac498ae$var$BD(a, 214));
};
var $61de1ee1cac498ae$var$MX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepCrossingMinimizer/0methodref$compareDifferentRandomizedLayouts$Type", 1398);
$61de1ee1cac498ae$var$bcb(1399, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$kGc);
$61de1ee1cac498ae$var$_.td = function lGc(a) {
    $61de1ee1cac498ae$var$VFc(this.a, $61de1ee1cac498ae$var$BD(a, 214));
};
var $61de1ee1cac498ae$var$NX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepCrossingMinimizer/1methodref$minimizeCrossingsNoCounter$Type", 1399);
$61de1ee1cac498ae$var$bcb(1400, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$mGc);
$61de1ee1cac498ae$var$_.td = function nGc(a) {
    $61de1ee1cac498ae$var$XFc(this.a, $61de1ee1cac498ae$var$BD(a, 214));
};
var $61de1ee1cac498ae$var$OX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepCrossingMinimizer/2methodref$minimizeCrossingsWithCounter$Type", 1400);
$61de1ee1cac498ae$var$bcb(454, 22, {
    3: 1,
    35: 1,
    22: 1,
    454: 1
}, $61de1ee1cac498ae$var$sGc);
var $61de1ee1cac498ae$var$oGc, $61de1ee1cac498ae$var$pGc, $61de1ee1cac498ae$var$qGc;
var $61de1ee1cac498ae$var$PX = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Gqe, "LayerSweepCrossingMinimizer/CrossMinType", 454, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$uGc, $61de1ee1cac498ae$var$tGc);
var $61de1ee1cac498ae$var$vGc;
$61de1ee1cac498ae$var$bcb(1397, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$xGc);
$61de1ee1cac498ae$var$_.Mb = function yGc(a) {
    return $61de1ee1cac498ae$var$LFc(), $61de1ee1cac498ae$var$BD(a, 29).a.c.length == 0;
};
var $61de1ee1cac498ae$var$QX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepCrossingMinimizer/lambda$0$Type", 1397);
$61de1ee1cac498ae$var$bcb(1799, 1, $61de1ee1cac498ae$var$Mne, $61de1ee1cac498ae$var$BGc);
$61de1ee1cac498ae$var$_.Mf = function CGc() {};
$61de1ee1cac498ae$var$_.Nf = function DGc(a, b, c, d, e, f) {};
$61de1ee1cac498ae$var$_.Qf = function GGc(a, b, c, d) {};
$61de1ee1cac498ae$var$_.Of = function EGc(a, b) {
    b[a][0].c.p = a;
    this.b[a] = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SX, {
        3: 1,
        4: 1,
        5: 1,
        1944: 1
    }, 659, b[a].length, 0, 1);
};
$61de1ee1cac498ae$var$_.Pf = function FGc(a, b, c) {
    var d;
    d = c[a][b];
    d.p = b;
    $61de1ee1cac498ae$var$NC(this.b[a], b, new $61de1ee1cac498ae$var$HGc);
};
var $61de1ee1cac498ae$var$VX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepTypeDecider", 1799);
$61de1ee1cac498ae$var$bcb(659, 1, {
    659: 1
}, $61de1ee1cac498ae$var$HGc);
$61de1ee1cac498ae$var$_.Ib = function IGc() {
    return "NodeInfo [connectedEdges=" + this.a + ", hierarchicalInfluence=" + this.b + ", randomInfluence=" + this.c + "]";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$SX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepTypeDecider/NodeInfo", 659);
$61de1ee1cac498ae$var$bcb(1800, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$JGc);
$61de1ee1cac498ae$var$_.Lb = function KGc(a) {
    return $61de1ee1cac498ae$var$a1b(new $61de1ee1cac498ae$var$b1b($61de1ee1cac498ae$var$BD(a, 11).b));
};
$61de1ee1cac498ae$var$_.Fb = function LGc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function MGc(a) {
    return $61de1ee1cac498ae$var$a1b(new $61de1ee1cac498ae$var$b1b($61de1ee1cac498ae$var$BD(a, 11).b));
};
var $61de1ee1cac498ae$var$TX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepTypeDecider/lambda$0$Type", 1800);
$61de1ee1cac498ae$var$bcb(1801, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$NGc);
$61de1ee1cac498ae$var$_.Lb = function OGc(a) {
    return $61de1ee1cac498ae$var$a1b(new $61de1ee1cac498ae$var$b1b($61de1ee1cac498ae$var$BD(a, 11).b));
};
$61de1ee1cac498ae$var$_.Fb = function PGc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function QGc(a) {
    return $61de1ee1cac498ae$var$a1b(new $61de1ee1cac498ae$var$b1b($61de1ee1cac498ae$var$BD(a, 11).b));
};
var $61de1ee1cac498ae$var$UX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerSweepTypeDecider/lambda$1$Type", 1801);
$61de1ee1cac498ae$var$bcb(1833, 402, $61de1ee1cac498ae$var$Eqe, $61de1ee1cac498ae$var$RGc);
$61de1ee1cac498ae$var$_.$f = function SGc(a, b, c) {
    var d, e, f, g, h, i, j, k, l;
    j = this.g;
    switch(c.g){
        case 1:
            d = 0;
            e = 0;
            for(i = new $61de1ee1cac498ae$var$olb(a.j); i.a < i.c.c.length;){
                g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(i), 11);
                if (g.e.c.length != 0) {
                    ++d;
                    g.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) && ++e;
                }
            }
            f = b + e;
            l = b + d;
            for(h = $61de1ee1cac498ae$var$W_b(a, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc)).Kc(); h.Ob();){
                g = $61de1ee1cac498ae$var$BD(h.Pb(), 11);
                if (g.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) {
                    j[g.p] = f;
                    --f;
                } else {
                    j[g.p] = l;
                    --l;
                }
            }
            return d;
        case 2:
            k = 0;
            for(h = $61de1ee1cac498ae$var$W_b(a, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)).Kc(); h.Ob();){
                g = $61de1ee1cac498ae$var$BD(h.Pb(), 11);
                ++k;
                j[g.p] = b + k;
            }
            return k;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Vdb);
    }
};
var $61de1ee1cac498ae$var$WX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "LayerTotalPortDistributor", 1833);
$61de1ee1cac498ae$var$bcb(660, 817, {
    660: 1,
    225: 1
}, $61de1ee1cac498ae$var$XGc);
$61de1ee1cac498ae$var$_.ag = function ZGc(a, b, c, d) {
    if (c) $61de1ee1cac498ae$var$rEc(this, a);
    else {
        $61de1ee1cac498ae$var$oEc(this, a, d);
        $61de1ee1cac498ae$var$pEc(this, a, b);
    }
    if (a.c.length > 1) {
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 10))), ($61de1ee1cac498ae$var$Nyc(), $61de1ee1cac498ae$var$Awc)))) ? $61de1ee1cac498ae$var$YGc(a, this.d, this) : ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Okb(a, this.d));
        $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$Q_b(($61de1ee1cac498ae$var$tCb(0, a.c.length), $61de1ee1cac498ae$var$BD(a.c[0], 10))), $61de1ee1cac498ae$var$Awc))) || $61de1ee1cac498ae$var$PEc(this.e, a);
    }
};
var $61de1ee1cac498ae$var$YX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "ModelOrderBarycenterHeuristic", 660);
$61de1ee1cac498ae$var$bcb(1803, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$$Gc);
$61de1ee1cac498ae$var$_.ue = function _Gc(a, b) {
    return $61de1ee1cac498ae$var$VGc(this.a, $61de1ee1cac498ae$var$BD(a, 10), $61de1ee1cac498ae$var$BD(b, 10));
};
$61de1ee1cac498ae$var$_.Fb = function aHc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function bHc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$XX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "ModelOrderBarycenterHeuristic/lambda$0$Type", 1803);
$61de1ee1cac498ae$var$bcb(1403, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$fHc);
$61de1ee1cac498ae$var$_.Yf = function gHc(a) {
    var b;
    return $61de1ee1cac498ae$var$BD(a, 37), b = $61de1ee1cac498ae$var$k3c($61de1ee1cac498ae$var$cHc), $61de1ee1cac498ae$var$e3c(b, ($61de1ee1cac498ae$var$qUb(), $61de1ee1cac498ae$var$nUb), ($61de1ee1cac498ae$var$S8b(), $61de1ee1cac498ae$var$H8b)), b;
};
$61de1ee1cac498ae$var$_.pf = function hHc(a, b) {
    $61de1ee1cac498ae$var$eHc(($61de1ee1cac498ae$var$BD(a, 37), b));
};
var $61de1ee1cac498ae$var$cHc;
var $61de1ee1cac498ae$var$ZX = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "NoCrossingMinimizer", 1403);
$61de1ee1cac498ae$var$bcb(796, 402, $61de1ee1cac498ae$var$Eqe, $61de1ee1cac498ae$var$iHc);
$61de1ee1cac498ae$var$_.$f = function jHc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n;
    l = this.g;
    switch(c.g){
        case 1:
            e = 0;
            f = 0;
            for(k = new $61de1ee1cac498ae$var$olb(a.j); k.a < k.c.c.length;){
                i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 11);
                if (i.e.c.length != 0) {
                    ++e;
                    i.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd) && ++f;
                }
            }
            d = 1 / (e + 1);
            g = b + f * d;
            n = b + 1 - d;
            for(j = $61de1ee1cac498ae$var$W_b(a, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$HAc)).Kc(); j.Ob();){
                i = $61de1ee1cac498ae$var$BD(j.Pb(), 11);
                if (i.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd)) {
                    l[i.p] = g;
                    g -= d;
                } else {
                    l[i.p] = n;
                    n -= d;
                }
            }
            break;
        case 2:
            h = 0;
            for(k = new $61de1ee1cac498ae$var$olb(a.j); k.a < k.c.c.length;){
                i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 11);
                i.g.c.length == 0 || ++h;
            }
            d = 1 / (h + 1);
            m = b + d;
            for(j = $61de1ee1cac498ae$var$W_b(a, ($61de1ee1cac498ae$var$KAc(), $61de1ee1cac498ae$var$IAc)).Kc(); j.Ob();){
                i = $61de1ee1cac498ae$var$BD(j.Pb(), 11);
                l[i.p] = m;
                m += d;
            }
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Port type is undefined"));
    }
    return 1;
};
var $61de1ee1cac498ae$var$$X = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "NodeRelativePortDistributor", 796);
$61de1ee1cac498ae$var$bcb(807, 1, {}, $61de1ee1cac498ae$var$nHc, $61de1ee1cac498ae$var$oHc);
var $61de1ee1cac498ae$var$_X = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Gqe, "SweepCopy", 807);
$61de1ee1cac498ae$var$bcb(1798, 1, $61de1ee1cac498ae$var$Mne, $61de1ee1cac498ae$var$rHc);
$61de1ee1cac498ae$var$_.Of = function uHc(a, b) {};
$61de1ee1cac498ae$var$_.Mf = function sHc() {
    var a;
    a = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, this.f, 15, 1);
    this.d = new $61de1ee1cac498ae$var$LIc(a);
    this.a = new $61de1ee1cac498ae$var$dIc(a);
};
$61de1ee1cac498ae$var$_.Nf = function tHc(a, b, c, d, e, f) {
    var g;
    g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(f[a][b].j, c), 11);
    e.c == g && e.c.i.c == e.d.i.c && ++this.e[a];
};
$61de1ee1cac498ae$var$_.Pf = function vHc(a, b, c) {
    var d;
    d = c[a][b];
    this.c[a] = this.c[a] | d.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$i0b);
};
$61de1ee1cac498ae$var$_.Qf = function wHc(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(d[a][b].j, c), 11);
    e.p = this.f++;
    e.g.c.length + e.e.c.length > 1 && (e.j == ($61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd) ? this.b[a] = true : e.j == $61de1ee1cac498ae$var$Tcd && a > 0 && (this.b[a - 1] = true));
};
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$aY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "AllCrossingsCounter", 1798);
$61de1ee1cac498ae$var$bcb(587, 1, {}, $61de1ee1cac498ae$var$BHc);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$bY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "BinaryIndexedTree", 587);
$61de1ee1cac498ae$var$bcb(524, 1, {}, $61de1ee1cac498ae$var$dIc);
var $61de1ee1cac498ae$var$DHc, $61de1ee1cac498ae$var$EHc;
var $61de1ee1cac498ae$var$lY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter", 524);
$61de1ee1cac498ae$var$bcb(1906, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$hIc);
$61de1ee1cac498ae$var$_.ue = function iIc(a, b) {
    return $61de1ee1cac498ae$var$YHc(this.a, $61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function jIc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function kIc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$cY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$0$Type", 1906);
$61de1ee1cac498ae$var$bcb(1907, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$lIc);
$61de1ee1cac498ae$var$_.ue = function mIc(a, b) {
    return $61de1ee1cac498ae$var$ZHc(this.a, $61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function nIc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function oIc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$dY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$1$Type", 1907);
$61de1ee1cac498ae$var$bcb(1908, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$pIc);
$61de1ee1cac498ae$var$_.ue = function qIc(a, b) {
    return $61de1ee1cac498ae$var$$Hc(this.a, $61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function rIc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function sIc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$eY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$2$Type", 1908);
$61de1ee1cac498ae$var$bcb(1909, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$tIc);
$61de1ee1cac498ae$var$_.ue = function uIc(a, b) {
    return $61de1ee1cac498ae$var$_Hc(this.a, $61de1ee1cac498ae$var$BD(a, 11), $61de1ee1cac498ae$var$BD(b, 11));
};
$61de1ee1cac498ae$var$_.Fb = function vIc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function wIc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$fY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$3$Type", 1909);
$61de1ee1cac498ae$var$bcb(1910, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$xIc);
$61de1ee1cac498ae$var$_.td = function yIc(a) {
    $61de1ee1cac498ae$var$eIc(this.a, $61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$gY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$4$Type", 1910);
$61de1ee1cac498ae$var$bcb(1911, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$zIc);
$61de1ee1cac498ae$var$_.Mb = function AIc(a) {
    return $61de1ee1cac498ae$var$fIc(this.a, $61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$hY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$5$Type", 1911);
$61de1ee1cac498ae$var$bcb(1912, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$CIc);
$61de1ee1cac498ae$var$_.td = function DIc(a) {
    $61de1ee1cac498ae$var$BIc(this, a);
};
var $61de1ee1cac498ae$var$iY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$6$Type", 1912);
$61de1ee1cac498ae$var$bcb(1913, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$EIc);
$61de1ee1cac498ae$var$_.td = function FIc(a) {
    var b;
    $61de1ee1cac498ae$var$FHc();
    $61de1ee1cac498ae$var$Wjb(this.b, (b = this.a, $61de1ee1cac498ae$var$BD(a, 11), b));
};
var $61de1ee1cac498ae$var$jY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$7$Type", 1913);
$61de1ee1cac498ae$var$bcb(826, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$GIc);
$61de1ee1cac498ae$var$_.Lb = function HIc(a) {
    return $61de1ee1cac498ae$var$FHc(), $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 11), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc));
};
$61de1ee1cac498ae$var$_.Fb = function IIc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function JIc(a) {
    return $61de1ee1cac498ae$var$FHc(), $61de1ee1cac498ae$var$wNb($61de1ee1cac498ae$var$BD(a, 11), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$gtc));
};
var $61de1ee1cac498ae$var$kY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "CrossingsCounter/lambda$8$Type", 826);
$61de1ee1cac498ae$var$bcb(1905, 1, {}, $61de1ee1cac498ae$var$LIc);
var $61de1ee1cac498ae$var$pY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "HyperedgeCrossingsCounter", 1905);
$61de1ee1cac498ae$var$bcb(467, 1, {
    35: 1,
    467: 1
}, $61de1ee1cac498ae$var$NIc);
$61de1ee1cac498ae$var$_.wd = function OIc(a) {
    return $61de1ee1cac498ae$var$MIc(this, $61de1ee1cac498ae$var$BD(a, 467));
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$oY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "HyperedgeCrossingsCounter/Hyperedge", 467);
$61de1ee1cac498ae$var$bcb(362, 1, {
    35: 1,
    362: 1
}, $61de1ee1cac498ae$var$QIc);
$61de1ee1cac498ae$var$_.wd = function RIc(a) {
    return $61de1ee1cac498ae$var$PIc(this, $61de1ee1cac498ae$var$BD(a, 362));
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$nY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lne, "HyperedgeCrossingsCounter/HyperedgeCorner", 362);
$61de1ee1cac498ae$var$bcb(523, 22, {
    3: 1,
    35: 1,
    22: 1,
    523: 1
}, $61de1ee1cac498ae$var$VIc);
var $61de1ee1cac498ae$var$SIc, $61de1ee1cac498ae$var$TIc;
var $61de1ee1cac498ae$var$mY = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Lne, "HyperedgeCrossingsCounter/HyperedgeCorner/Type", 523, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$XIc, $61de1ee1cac498ae$var$WIc);
var $61de1ee1cac498ae$var$YIc;
$61de1ee1cac498ae$var$bcb(1405, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$dJc);
$61de1ee1cac498ae$var$_.Yf = function eJc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 37), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc)) ? $61de1ee1cac498ae$var$_Ic : null;
};
$61de1ee1cac498ae$var$_.pf = function fJc(a, b) {
    $61de1ee1cac498ae$var$cJc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$_Ic;
var $61de1ee1cac498ae$var$rY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "InteractiveNodePlacer", 1405);
$61de1ee1cac498ae$var$bcb(1406, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$tJc);
$61de1ee1cac498ae$var$_.Yf = function uJc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 37), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc)) ? $61de1ee1cac498ae$var$gJc : null;
};
$61de1ee1cac498ae$var$_.pf = function vJc(a, b) {
    $61de1ee1cac498ae$var$rJc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$gJc, $61de1ee1cac498ae$var$hJc, $61de1ee1cac498ae$var$iJc;
var $61de1ee1cac498ae$var$tY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "LinearSegmentsNodePlacer", 1406);
$61de1ee1cac498ae$var$bcb(257, 1, {
    35: 1,
    257: 1
}, $61de1ee1cac498ae$var$zJc);
$61de1ee1cac498ae$var$_.wd = function AJc(a) {
    return $61de1ee1cac498ae$var$wJc(this, $61de1ee1cac498ae$var$BD(a, 257));
};
$61de1ee1cac498ae$var$_.Fb = function BJc(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 257)) {
        b = $61de1ee1cac498ae$var$BD(a, 257);
        return this.b == b.b;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function CJc() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Ib = function DJc() {
    return "ls" + $61de1ee1cac498ae$var$Fe(this.e);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = -1;
$61de1ee1cac498ae$var$_.d = -1;
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$sY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "LinearSegmentsNodePlacer/LinearSegment", 257);
$61de1ee1cac498ae$var$bcb(1408, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$$Jc);
$61de1ee1cac498ae$var$_.Yf = function _Jc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 37), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc)) ? $61de1ee1cac498ae$var$EJc : null;
};
$61de1ee1cac498ae$var$_.pf = function hKc(a, b) {
    $61de1ee1cac498ae$var$WJc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$EJc;
var $61de1ee1cac498ae$var$dZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer", 1408);
$61de1ee1cac498ae$var$bcb(1427, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$iKc);
$61de1ee1cac498ae$var$_.ue = function jKc(a, b) {
    return $61de1ee1cac498ae$var$beb($61de1ee1cac498ae$var$BD(a, 19).a, $61de1ee1cac498ae$var$BD(b, 19).a);
};
$61de1ee1cac498ae$var$_.Fb = function kKc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function lKc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$uY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/0methodref$compare$Type", 1427);
$61de1ee1cac498ae$var$bcb(1429, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$mKc);
$61de1ee1cac498ae$var$_.ue = function nKc(a, b) {
    return $61de1ee1cac498ae$var$beb($61de1ee1cac498ae$var$BD(a, 19).a, $61de1ee1cac498ae$var$BD(b, 19).a);
};
$61de1ee1cac498ae$var$_.Fb = function oKc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function pKc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$vY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/1methodref$compare$Type", 1429);
$61de1ee1cac498ae$var$bcb(649, 1, {
    649: 1
}, $61de1ee1cac498ae$var$qKc);
var $61de1ee1cac498ae$var$wY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/EdgeRep", 649);
$61de1ee1cac498ae$var$bcb(401, 1, {
    401: 1
}, $61de1ee1cac498ae$var$rKc);
$61de1ee1cac498ae$var$_.b = false;
var $61de1ee1cac498ae$var$xY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/NodeRep", 401);
$61de1ee1cac498ae$var$bcb(508, 12, {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    12: 1,
    14: 1,
    15: 1,
    54: 1,
    508: 1
}, $61de1ee1cac498ae$var$vKc);
var $61de1ee1cac498ae$var$CY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/Path", 508);
$61de1ee1cac498ae$var$bcb(1409, 1, {}, $61de1ee1cac498ae$var$wKc);
$61de1ee1cac498ae$var$_.Kb = function xKc(a) {
    return $61de1ee1cac498ae$var$BD(a, 17).d.i.k;
};
var $61de1ee1cac498ae$var$yY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/Path/lambda$0$Type", 1409);
$61de1ee1cac498ae$var$bcb(1410, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$yKc);
$61de1ee1cac498ae$var$_.Mb = function zKc(a) {
    return $61de1ee1cac498ae$var$BD(a, 267) == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$g0b);
};
var $61de1ee1cac498ae$var$zY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/Path/lambda$1$Type", 1410);
$61de1ee1cac498ae$var$bcb(1411, 1, {}, $61de1ee1cac498ae$var$AKc);
$61de1ee1cac498ae$var$_.Kb = function BKc(a) {
    return $61de1ee1cac498ae$var$BD(a, 17).d.i;
};
var $61de1ee1cac498ae$var$AY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/Path/lambda$2$Type", 1411);
$61de1ee1cac498ae$var$bcb(1412, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$CKc);
$61de1ee1cac498ae$var$_.Mb = function DKc(a) {
    return $61de1ee1cac498ae$var$eLc($61de1ee1cac498ae$var$Lzc($61de1ee1cac498ae$var$BD(a, 10)));
};
var $61de1ee1cac498ae$var$BY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/Path/lambda$3$Type", 1412);
$61de1ee1cac498ae$var$bcb(1413, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$EKc);
$61de1ee1cac498ae$var$_.Mb = function FKc(a) {
    return $61de1ee1cac498ae$var$dKc($61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$DY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$0$Type", 1413);
$61de1ee1cac498ae$var$bcb(1414, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$GKc);
$61de1ee1cac498ae$var$_.td = function HKc(a) {
    $61de1ee1cac498ae$var$LJc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 11));
};
var $61de1ee1cac498ae$var$EY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$1$Type", 1414);
$61de1ee1cac498ae$var$bcb(1423, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$IKc);
$61de1ee1cac498ae$var$_.td = function JKc(a) {
    $61de1ee1cac498ae$var$MJc(this.a, $61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$FY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$10$Type", 1423);
$61de1ee1cac498ae$var$bcb(1424, 1, {}, $61de1ee1cac498ae$var$KKc);
$61de1ee1cac498ae$var$_.Kb = function LKc(a) {
    return $61de1ee1cac498ae$var$FJc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$GY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$11$Type", 1424);
$61de1ee1cac498ae$var$bcb(1425, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$MKc);
$61de1ee1cac498ae$var$_.td = function NKc(a) {
    $61de1ee1cac498ae$var$NJc(this.a, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$HY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$12$Type", 1425);
$61de1ee1cac498ae$var$bcb(1426, 1, {}, $61de1ee1cac498ae$var$OKc);
$61de1ee1cac498ae$var$_.Kb = function PKc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD(a, 121).e);
};
var $61de1ee1cac498ae$var$IY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$13$Type", 1426);
$61de1ee1cac498ae$var$bcb(1428, 1, {}, $61de1ee1cac498ae$var$QKc);
$61de1ee1cac498ae$var$_.Kb = function RKc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$BD(a, 121).e);
};
var $61de1ee1cac498ae$var$JY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$15$Type", 1428);
$61de1ee1cac498ae$var$bcb(1430, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$SKc);
$61de1ee1cac498ae$var$_.Mb = function TKc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$BD(a, 401).c.k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$KY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$17$Type", 1430);
$61de1ee1cac498ae$var$bcb(1431, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$UKc);
$61de1ee1cac498ae$var$_.Mb = function VKc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$BD(a, 401).c.j.c.length > 1;
};
var $61de1ee1cac498ae$var$LY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$18$Type", 1431);
$61de1ee1cac498ae$var$bcb(1432, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$WKc);
$61de1ee1cac498ae$var$_.td = function XKc(a) {
    $61de1ee1cac498ae$var$eKc(this.c, this.b, this.d, this.a, $61de1ee1cac498ae$var$BD(a, 401));
};
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$MY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$19$Type", 1432);
$61de1ee1cac498ae$var$bcb(1415, 1, {}, $61de1ee1cac498ae$var$YKc);
$61de1ee1cac498ae$var$_.Kb = function ZKc(a) {
    return $61de1ee1cac498ae$var$FJc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$NY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$2$Type", 1415);
$61de1ee1cac498ae$var$bcb(1433, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$$Kc);
$61de1ee1cac498ae$var$_.td = function _Kc(a) {
    $61de1ee1cac498ae$var$fKc(this.a, $61de1ee1cac498ae$var$BD(a, 11));
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$OY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$20$Type", 1433);
$61de1ee1cac498ae$var$bcb(1434, 1, {}, $61de1ee1cac498ae$var$aLc);
$61de1ee1cac498ae$var$_.Kb = function bLc(a) {
    return $61de1ee1cac498ae$var$FJc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$PY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$21$Type", 1434);
$61de1ee1cac498ae$var$bcb(1435, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$cLc);
$61de1ee1cac498ae$var$_.td = function dLc(a) {
    $61de1ee1cac498ae$var$OJc(this.a, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$QY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$22$Type", 1435);
$61de1ee1cac498ae$var$bcb(1436, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$fLc);
$61de1ee1cac498ae$var$_.Mb = function gLc(a) {
    return $61de1ee1cac498ae$var$eLc(a);
};
var $61de1ee1cac498ae$var$RY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$23$Type", 1436);
$61de1ee1cac498ae$var$bcb(1437, 1, {}, $61de1ee1cac498ae$var$hLc);
$61de1ee1cac498ae$var$_.Kb = function iLc(a) {
    return $61de1ee1cac498ae$var$FJc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$SY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$24$Type", 1437);
$61de1ee1cac498ae$var$bcb(1438, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$jLc);
$61de1ee1cac498ae$var$_.Mb = function kLc(a) {
    return $61de1ee1cac498ae$var$PJc(this.a, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$TY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$25$Type", 1438);
$61de1ee1cac498ae$var$bcb(1439, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$lLc);
$61de1ee1cac498ae$var$_.td = function mLc(a) {
    $61de1ee1cac498ae$var$QJc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$UY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$26$Type", 1439);
$61de1ee1cac498ae$var$bcb(1440, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$nLc);
$61de1ee1cac498ae$var$_.Mb = function oLc(a) {
    return $61de1ee1cac498ae$var$FJc(), !$61de1ee1cac498ae$var$OZb($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$VY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$27$Type", 1440);
$61de1ee1cac498ae$var$bcb(1441, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$pLc);
$61de1ee1cac498ae$var$_.Mb = function qLc(a) {
    return $61de1ee1cac498ae$var$FJc(), !$61de1ee1cac498ae$var$OZb($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$WY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$28$Type", 1441);
$61de1ee1cac498ae$var$bcb(1442, 1, {}, $61de1ee1cac498ae$var$rLc);
$61de1ee1cac498ae$var$_.Ce = function sLc(a, b) {
    return $61de1ee1cac498ae$var$RJc(this.a, $61de1ee1cac498ae$var$BD(a, 29), $61de1ee1cac498ae$var$BD(b, 29));
};
var $61de1ee1cac498ae$var$XY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$29$Type", 1442);
$61de1ee1cac498ae$var$bcb(1416, 1, {}, $61de1ee1cac498ae$var$tLc);
$61de1ee1cac498ae$var$_.Kb = function uLc(a) {
    return $61de1ee1cac498ae$var$FJc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$U_b($61de1ee1cac498ae$var$BD(a, 10)).a.Kc(), new $61de1ee1cac498ae$var$Sq))));
};
var $61de1ee1cac498ae$var$YY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$3$Type", 1416);
$61de1ee1cac498ae$var$bcb(1417, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$vLc);
$61de1ee1cac498ae$var$_.Mb = function wLc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$cKc($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$ZY = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$4$Type", 1417);
$61de1ee1cac498ae$var$bcb(1418, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$xLc);
$61de1ee1cac498ae$var$_.td = function yLc(a) {
    $61de1ee1cac498ae$var$XJc(this.a, $61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$$Y = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$5$Type", 1418);
$61de1ee1cac498ae$var$bcb(1419, 1, {}, $61de1ee1cac498ae$var$zLc);
$61de1ee1cac498ae$var$_.Kb = function ALc(a) {
    return $61de1ee1cac498ae$var$FJc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 29).a, 16));
};
var $61de1ee1cac498ae$var$_Y = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$6$Type", 1419);
$61de1ee1cac498ae$var$bcb(1420, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$BLc);
$61de1ee1cac498ae$var$_.Mb = function CLc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$BD(a, 10).k == ($61de1ee1cac498ae$var$j0b(), $61de1ee1cac498ae$var$h0b);
};
var $61de1ee1cac498ae$var$aZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$7$Type", 1420);
$61de1ee1cac498ae$var$bcb(1421, 1, {}, $61de1ee1cac498ae$var$DLc);
$61de1ee1cac498ae$var$_.Kb = function ELc(a) {
    return $61de1ee1cac498ae$var$FJc(), new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Lub(new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$O_b($61de1ee1cac498ae$var$BD(a, 10)).a.Kc(), new $61de1ee1cac498ae$var$Sq))));
};
var $61de1ee1cac498ae$var$bZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$8$Type", 1421);
$61de1ee1cac498ae$var$bcb(1422, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$FLc);
$61de1ee1cac498ae$var$_.Mb = function GLc(a) {
    return $61de1ee1cac498ae$var$FJc(), $61de1ee1cac498ae$var$NZb($61de1ee1cac498ae$var$BD(a, 17));
};
var $61de1ee1cac498ae$var$cZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "NetworkSimplexPlacer/lambda$9$Type", 1422);
$61de1ee1cac498ae$var$bcb(1404, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$KLc);
$61de1ee1cac498ae$var$_.Yf = function LLc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 37), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc)) ? $61de1ee1cac498ae$var$HLc : null;
};
$61de1ee1cac498ae$var$_.pf = function MLc(a, b) {
    $61de1ee1cac498ae$var$JLc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$HLc;
var $61de1ee1cac498ae$var$eZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hqe, "SimpleNodePlacer", 1404);
$61de1ee1cac498ae$var$bcb(180, 1, {
    180: 1
}, $61de1ee1cac498ae$var$ULc);
$61de1ee1cac498ae$var$_.Ib = function VLc() {
    var a;
    a = "";
    this.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$XLc) ? a += $61de1ee1cac498ae$var$kle : this.c == $61de1ee1cac498ae$var$WLc && (a += $61de1ee1cac498ae$var$jle);
    this.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$cMc) ? a += $61de1ee1cac498ae$var$vle : this.o == $61de1ee1cac498ae$var$dMc ? a += "UP" : a += "BALANCED";
    return a;
};
var $61de1ee1cac498ae$var$hZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "BKAlignedLayout", 180);
$61de1ee1cac498ae$var$bcb(516, 22, {
    3: 1,
    35: 1,
    22: 1,
    516: 1
}, $61de1ee1cac498ae$var$ZLc);
var $61de1ee1cac498ae$var$WLc, $61de1ee1cac498ae$var$XLc;
var $61de1ee1cac498ae$var$fZ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Kqe, "BKAlignedLayout/HDirection", 516, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$_Lc, $61de1ee1cac498ae$var$$Lc);
var $61de1ee1cac498ae$var$aMc;
$61de1ee1cac498ae$var$bcb(515, 22, {
    3: 1,
    35: 1,
    22: 1,
    515: 1
}, $61de1ee1cac498ae$var$fMc);
var $61de1ee1cac498ae$var$cMc, $61de1ee1cac498ae$var$dMc;
var $61de1ee1cac498ae$var$gZ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Kqe, "BKAlignedLayout/VDirection", 515, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$hMc, $61de1ee1cac498ae$var$gMc);
var $61de1ee1cac498ae$var$iMc;
$61de1ee1cac498ae$var$bcb(1634, 1, {}, $61de1ee1cac498ae$var$mMc);
var $61de1ee1cac498ae$var$iZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "BKAligner", 1634);
$61de1ee1cac498ae$var$bcb(1637, 1, {}, $61de1ee1cac498ae$var$rMc);
var $61de1ee1cac498ae$var$lZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "BKCompactor", 1637);
$61de1ee1cac498ae$var$bcb(654, 1, {
    654: 1
}, $61de1ee1cac498ae$var$sMc);
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$jZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "BKCompactor/ClassEdge", 654);
$61de1ee1cac498ae$var$bcb(458, 1, {
    458: 1
}, $61de1ee1cac498ae$var$uMc);
$61de1ee1cac498ae$var$_.a = null;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$kZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "BKCompactor/ClassNode", 458);
$61de1ee1cac498ae$var$bcb(1407, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$CMc);
$61de1ee1cac498ae$var$_.Yf = function GMc(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$vNb($61de1ee1cac498ae$var$BD(a, 37), ($61de1ee1cac498ae$var$wtc(), $61de1ee1cac498ae$var$Ksc)), 21).Hc(($61de1ee1cac498ae$var$Orc(), $61de1ee1cac498ae$var$Hrc)) ? $61de1ee1cac498ae$var$vMc : null;
};
$61de1ee1cac498ae$var$_.pf = function HMc(a, b) {
    $61de1ee1cac498ae$var$BMc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$vMc;
var $61de1ee1cac498ae$var$mZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "BKNodePlacer", 1407);
$61de1ee1cac498ae$var$bcb(1635, 1, {}, $61de1ee1cac498ae$var$JMc);
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$oZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "NeighborhoodInformation", 1635);
$61de1ee1cac498ae$var$bcb(1636, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$OMc);
$61de1ee1cac498ae$var$_.ue = function PMc(a, b) {
    return $61de1ee1cac498ae$var$NMc(this, $61de1ee1cac498ae$var$BD(a, 46), $61de1ee1cac498ae$var$BD(b, 46));
};
$61de1ee1cac498ae$var$_.Fb = function QMc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function RMc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$nZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "NeighborhoodInformation/NeighborComparator", 1636);
$61de1ee1cac498ae$var$bcb(808, 1, {});
var $61de1ee1cac498ae$var$sZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "ThresholdStrategy", 808);
$61de1ee1cac498ae$var$bcb(1763, 808, {}, $61de1ee1cac498ae$var$WMc);
$61de1ee1cac498ae$var$_.bg = function XMc(a, b, c) {
    return this.a.o == ($61de1ee1cac498ae$var$eMc(), $61de1ee1cac498ae$var$dMc) ? $61de1ee1cac498ae$var$Pje : $61de1ee1cac498ae$var$Qje;
};
$61de1ee1cac498ae$var$_.cg = function YMc() {};
var $61de1ee1cac498ae$var$pZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "ThresholdStrategy/NullThresholdStrategy", 1763);
$61de1ee1cac498ae$var$bcb(579, 1, {
    579: 1
}, $61de1ee1cac498ae$var$ZMc);
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = false;
var $61de1ee1cac498ae$var$qZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "ThresholdStrategy/Postprocessable", 579);
$61de1ee1cac498ae$var$bcb(1764, 808, {}, $61de1ee1cac498ae$var$bNc);
$61de1ee1cac498ae$var$_.bg = function cNc(a, b, c) {
    var d, e, f;
    e = b == c;
    d = this.a.a[c.p] == b;
    if (!(e || d)) return a;
    f = a;
    if (this.a.c == ($61de1ee1cac498ae$var$YLc(), $61de1ee1cac498ae$var$XLc)) {
        e && (f = $61de1ee1cac498ae$var$$Mc(this, b, true));
        !isNaN(f) && !isFinite(f) && d && (f = $61de1ee1cac498ae$var$$Mc(this, c, false));
    } else {
        e && (f = $61de1ee1cac498ae$var$$Mc(this, b, true));
        !isNaN(f) && !isFinite(f) && d && (f = $61de1ee1cac498ae$var$$Mc(this, c, false));
    }
    return f;
};
$61de1ee1cac498ae$var$_.cg = function dNc() {
    var a, b, c, d, e;
    while(this.d.b != 0){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ksb(this.d), 579);
        d = $61de1ee1cac498ae$var$_Mc(this, e);
        if (!d.a) continue;
        a = d.a;
        c = $61de1ee1cac498ae$var$Ccb(this.a.f[this.a.g[e.b.p].p]);
        if (!c && !$61de1ee1cac498ae$var$OZb(a) && a.c.i.c == a.d.i.c) continue;
        b = $61de1ee1cac498ae$var$aNc(this, e);
        b || $61de1ee1cac498ae$var$swb(this.e, e);
    }
    while(this.e.a.c.length != 0)$61de1ee1cac498ae$var$aNc(this, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$rwb(this.e), 579));
};
var $61de1ee1cac498ae$var$rZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Kqe, "ThresholdStrategy/SimpleThresholdStrategy", 1764);
$61de1ee1cac498ae$var$bcb(635, 1, {
    635: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$hNc);
$61de1ee1cac498ae$var$_.Kf = function jNc() {
    return $61de1ee1cac498ae$var$gNc(this);
};
$61de1ee1cac498ae$var$_.Xf = function iNc() {
    return $61de1ee1cac498ae$var$gNc(this);
};
var $61de1ee1cac498ae$var$eNc;
var $61de1ee1cac498ae$var$tZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lqe, "EdgeRouterFactory", 635);
$61de1ee1cac498ae$var$bcb(1458, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$wNc);
$61de1ee1cac498ae$var$_.Yf = function xNc(a) {
    return $61de1ee1cac498ae$var$uNc($61de1ee1cac498ae$var$BD(a, 37));
};
$61de1ee1cac498ae$var$_.pf = function yNc(a, b) {
    $61de1ee1cac498ae$var$vNc($61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$lNc, $61de1ee1cac498ae$var$mNc, $61de1ee1cac498ae$var$nNc, $61de1ee1cac498ae$var$oNc, $61de1ee1cac498ae$var$pNc, $61de1ee1cac498ae$var$qNc, $61de1ee1cac498ae$var$rNc, $61de1ee1cac498ae$var$sNc;
var $61de1ee1cac498ae$var$uZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lqe, "OrthogonalEdgeRouter", 1458);
$61de1ee1cac498ae$var$bcb(1451, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$NNc);
$61de1ee1cac498ae$var$_.Yf = function ONc(a) {
    return $61de1ee1cac498ae$var$INc($61de1ee1cac498ae$var$BD(a, 37));
};
$61de1ee1cac498ae$var$_.pf = function PNc(a, b) {
    $61de1ee1cac498ae$var$KNc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$zNc, $61de1ee1cac498ae$var$ANc, $61de1ee1cac498ae$var$BNc, $61de1ee1cac498ae$var$CNc, $61de1ee1cac498ae$var$DNc, $61de1ee1cac498ae$var$ENc;
var $61de1ee1cac498ae$var$wZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lqe, "PolylineEdgeRouter", 1451);
$61de1ee1cac498ae$var$bcb(1452, 1, $61de1ee1cac498ae$var$Vke, $61de1ee1cac498ae$var$RNc);
$61de1ee1cac498ae$var$_.Lb = function SNc(a) {
    return $61de1ee1cac498ae$var$QNc($61de1ee1cac498ae$var$BD(a, 10));
};
$61de1ee1cac498ae$var$_.Fb = function TNc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Mb = function UNc(a) {
    return $61de1ee1cac498ae$var$QNc($61de1ee1cac498ae$var$BD(a, 10));
};
var $61de1ee1cac498ae$var$vZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lqe, "PolylineEdgeRouter/1", 1452);
$61de1ee1cac498ae$var$bcb(1809, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$ZNc);
$61de1ee1cac498ae$var$_.Mb = function $Nc(a) {
    return $61de1ee1cac498ae$var$BD(a, 129).c == ($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc);
};
var $61de1ee1cac498ae$var$xZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeCycleDetector/lambda$0$Type", 1809);
$61de1ee1cac498ae$var$bcb(1810, 1, {}, $61de1ee1cac498ae$var$_Nc);
$61de1ee1cac498ae$var$_.Ge = function aOc(a) {
    return $61de1ee1cac498ae$var$BD(a, 129).d;
};
var $61de1ee1cac498ae$var$yZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeCycleDetector/lambda$1$Type", 1810);
$61de1ee1cac498ae$var$bcb(1811, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$bOc);
$61de1ee1cac498ae$var$_.Mb = function cOc(a) {
    return $61de1ee1cac498ae$var$BD(a, 129).c == ($61de1ee1cac498ae$var$HOc(), $61de1ee1cac498ae$var$FOc);
};
var $61de1ee1cac498ae$var$zZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeCycleDetector/lambda$2$Type", 1811);
$61de1ee1cac498ae$var$bcb(1812, 1, {}, $61de1ee1cac498ae$var$dOc);
$61de1ee1cac498ae$var$_.Ge = function eOc(a) {
    return $61de1ee1cac498ae$var$BD(a, 129).d;
};
var $61de1ee1cac498ae$var$AZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeCycleDetector/lambda$3$Type", 1812);
$61de1ee1cac498ae$var$bcb(1813, 1, {}, $61de1ee1cac498ae$var$fOc);
$61de1ee1cac498ae$var$_.Ge = function gOc(a) {
    return $61de1ee1cac498ae$var$BD(a, 129).d;
};
var $61de1ee1cac498ae$var$BZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeCycleDetector/lambda$4$Type", 1813);
$61de1ee1cac498ae$var$bcb(1814, 1, {}, $61de1ee1cac498ae$var$hOc);
$61de1ee1cac498ae$var$_.Ge = function iOc(a) {
    return $61de1ee1cac498ae$var$BD(a, 129).d;
};
var $61de1ee1cac498ae$var$CZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeCycleDetector/lambda$5$Type", 1814);
$61de1ee1cac498ae$var$bcb(112, 1, {
    35: 1,
    112: 1
}, $61de1ee1cac498ae$var$uOc);
$61de1ee1cac498ae$var$_.wd = function vOc(a) {
    return $61de1ee1cac498ae$var$kOc(this, $61de1ee1cac498ae$var$BD(a, 112));
};
$61de1ee1cac498ae$var$_.Fb = function wOc(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 112)) {
        b = $61de1ee1cac498ae$var$BD(a, 112);
        return this.g == b.g;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function xOc() {
    return this.g;
};
$61de1ee1cac498ae$var$_.Ib = function zOc() {
    var a, b, c, d;
    a = new $61de1ee1cac498ae$var$Wfb("{");
    d = new $61de1ee1cac498ae$var$olb(this.n);
    while(d.a < d.c.c.length){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(d), 11);
        b = $61de1ee1cac498ae$var$P_b(c.i);
        b == null && (b = "n" + $61de1ee1cac498ae$var$S_b(c.i));
        a.a += "" + b;
        d.a < d.c.c.length && (a.a += ",", a);
    }
    a.a += "}";
    return a.a;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = NaN;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.o = 0;
$61de1ee1cac498ae$var$_.s = NaN;
var $61de1ee1cac498ae$var$NZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegment", 112);
$61de1ee1cac498ae$var$bcb(129, 1, {
    129: 1
}, $61de1ee1cac498ae$var$DOc);
$61de1ee1cac498ae$var$_.Ib = function EOc() {
    return this.a + "->" + this.b + " (" + $61de1ee1cac498ae$var$Yr(this.c) + ")";
};
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$EZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentDependency", 129);
$61de1ee1cac498ae$var$bcb(520, 22, {
    3: 1,
    35: 1,
    22: 1,
    520: 1
}, $61de1ee1cac498ae$var$IOc);
var $61de1ee1cac498ae$var$FOc, $61de1ee1cac498ae$var$GOc;
var $61de1ee1cac498ae$var$DZ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentDependency/DependencyType", 520, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$KOc, $61de1ee1cac498ae$var$JOc);
var $61de1ee1cac498ae$var$LOc;
$61de1ee1cac498ae$var$bcb(1815, 1, {}, $61de1ee1cac498ae$var$ZOc);
var $61de1ee1cac498ae$var$MZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter", 1815);
$61de1ee1cac498ae$var$bcb(1816, 1, {}, $61de1ee1cac498ae$var$aPc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$FZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter/AreaRating", 1816);
$61de1ee1cac498ae$var$bcb(329, 1, {
    329: 1
}, $61de1ee1cac498ae$var$bPc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$GZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter/FreeArea", 329);
$61de1ee1cac498ae$var$bcb(1817, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$cPc);
$61de1ee1cac498ae$var$_.ue = function dPc(a, b) {
    return $61de1ee1cac498ae$var$_Oc($61de1ee1cac498ae$var$BD(a, 112), $61de1ee1cac498ae$var$BD(b, 112));
};
$61de1ee1cac498ae$var$_.Fb = function ePc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function fPc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$HZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter/lambda$0$Type", 1817);
$61de1ee1cac498ae$var$bcb(1818, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$gPc);
$61de1ee1cac498ae$var$_.td = function hPc(a) {
    $61de1ee1cac498ae$var$TOc(this.a, this.d, this.c, this.b, $61de1ee1cac498ae$var$BD(a, 112));
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$IZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter/lambda$1$Type", 1818);
$61de1ee1cac498ae$var$bcb(1819, 1, {}, $61de1ee1cac498ae$var$iPc);
$61de1ee1cac498ae$var$_.Kb = function jPc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 112).e, 16));
};
var $61de1ee1cac498ae$var$JZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter/lambda$2$Type", 1819);
$61de1ee1cac498ae$var$bcb(1820, 1, {}, $61de1ee1cac498ae$var$kPc);
$61de1ee1cac498ae$var$_.Kb = function lPc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 112).j, 16));
};
var $61de1ee1cac498ae$var$KZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter/lambda$3$Type", 1820);
$61de1ee1cac498ae$var$bcb(1821, 1, {}, $61de1ee1cac498ae$var$mPc);
$61de1ee1cac498ae$var$_.Fe = function nPc(a) {
    return $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(a));
};
var $61de1ee1cac498ae$var$LZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "HyperEdgeSegmentSplitter/lambda$4$Type", 1821);
$61de1ee1cac498ae$var$bcb(655, 1, {}, $61de1ee1cac498ae$var$tPc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$QZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "OrthogonalRoutingGenerator", 655);
$61de1ee1cac498ae$var$bcb(1638, 1, {}, $61de1ee1cac498ae$var$xPc);
$61de1ee1cac498ae$var$_.Kb = function yPc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 112).e, 16));
};
var $61de1ee1cac498ae$var$OZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "OrthogonalRoutingGenerator/lambda$0$Type", 1638);
$61de1ee1cac498ae$var$bcb(1639, 1, {}, $61de1ee1cac498ae$var$zPc);
$61de1ee1cac498ae$var$_.Kb = function APc(a) {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub($61de1ee1cac498ae$var$BD(a, 112).j, 16));
};
var $61de1ee1cac498ae$var$PZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mqe, "OrthogonalRoutingGenerator/lambda$1$Type", 1639);
$61de1ee1cac498ae$var$bcb(661, 1, {});
var $61de1ee1cac498ae$var$RZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nqe, "BaseRoutingDirectionStrategy", 661);
$61de1ee1cac498ae$var$bcb(1807, 661, {}, $61de1ee1cac498ae$var$EPc);
$61de1ee1cac498ae$var$_.dg = function FPc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (!!a.r && !a.q) return;
    k = b + a.o * c;
    for(j = new $61de1ee1cac498ae$var$olb(a.n); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 11);
        l = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).a;
        for(h = new $61de1ee1cac498ae$var$olb(i.g); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
            if (!$61de1ee1cac498ae$var$OZb(g)) {
                o = g.d;
                p = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    o.i.n,
                    o.n,
                    o.a
                ])).a;
                if ($61de1ee1cac498ae$var$$wnd.Math.abs(l - p) > $61de1ee1cac498ae$var$qme) {
                    f = k;
                    e = a;
                    d = new $61de1ee1cac498ae$var$f7c(l, f);
                    $61de1ee1cac498ae$var$Dsb(g.a, d);
                    $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                    m = a.r;
                    if (m) {
                        n = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ut(m.e, 0)));
                        d = new $61de1ee1cac498ae$var$f7c(n, f);
                        $61de1ee1cac498ae$var$Dsb(g.a, d);
                        $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                        f = b + m.o * c;
                        e = m;
                        d = new $61de1ee1cac498ae$var$f7c(n, f);
                        $61de1ee1cac498ae$var$Dsb(g.a, d);
                        $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                    }
                    d = new $61de1ee1cac498ae$var$f7c(p, f);
                    $61de1ee1cac498ae$var$Dsb(g.a, d);
                    $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                }
            }
        }
    }
};
$61de1ee1cac498ae$var$_.eg = function GPc(a) {
    return a.i.n.a + a.n.a + a.a.a;
};
$61de1ee1cac498ae$var$_.fg = function HPc() {
    return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd;
};
$61de1ee1cac498ae$var$_.gg = function IPc() {
    return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd;
};
var $61de1ee1cac498ae$var$SZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nqe, "NorthToSouthRoutingStrategy", 1807);
$61de1ee1cac498ae$var$bcb(1808, 661, {}, $61de1ee1cac498ae$var$JPc);
$61de1ee1cac498ae$var$_.dg = function KPc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (!!a.r && !a.q) return;
    k = b - a.o * c;
    for(j = new $61de1ee1cac498ae$var$olb(a.n); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 11);
        l = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).a;
        for(h = new $61de1ee1cac498ae$var$olb(i.g); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
            if (!$61de1ee1cac498ae$var$OZb(g)) {
                o = g.d;
                p = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    o.i.n,
                    o.n,
                    o.a
                ])).a;
                if ($61de1ee1cac498ae$var$$wnd.Math.abs(l - p) > $61de1ee1cac498ae$var$qme) {
                    f = k;
                    e = a;
                    d = new $61de1ee1cac498ae$var$f7c(l, f);
                    $61de1ee1cac498ae$var$Dsb(g.a, d);
                    $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                    m = a.r;
                    if (m) {
                        n = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ut(m.e, 0)));
                        d = new $61de1ee1cac498ae$var$f7c(n, f);
                        $61de1ee1cac498ae$var$Dsb(g.a, d);
                        $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                        f = b - m.o * c;
                        e = m;
                        d = new $61de1ee1cac498ae$var$f7c(n, f);
                        $61de1ee1cac498ae$var$Dsb(g.a, d);
                        $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                    }
                    d = new $61de1ee1cac498ae$var$f7c(p, f);
                    $61de1ee1cac498ae$var$Dsb(g.a, d);
                    $61de1ee1cac498ae$var$BPc(this, g, e, d, false);
                }
            }
        }
    }
};
$61de1ee1cac498ae$var$_.eg = function LPc(a) {
    return a.i.n.a + a.n.a + a.a.a;
};
$61de1ee1cac498ae$var$_.fg = function MPc() {
    return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Acd;
};
$61de1ee1cac498ae$var$_.gg = function NPc() {
    return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Rcd;
};
var $61de1ee1cac498ae$var$TZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nqe, "SouthToNorthRoutingStrategy", 1808);
$61de1ee1cac498ae$var$bcb(1806, 661, {}, $61de1ee1cac498ae$var$OPc);
$61de1ee1cac498ae$var$_.dg = function PPc(a, b, c) {
    var d, e, f, g, h, i, j, k, l, m, n, o, p;
    if (!!a.r && !a.q) return;
    k = b + a.o * c;
    for(j = new $61de1ee1cac498ae$var$olb(a.n); j.a < j.c.c.length;){
        i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 11);
        l = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
            i.i.n,
            i.n,
            i.a
        ])).b;
        for(h = new $61de1ee1cac498ae$var$olb(i.g); h.a < h.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 17);
            if (!$61de1ee1cac498ae$var$OZb(g)) {
                o = g.d;
                p = $61de1ee1cac498ae$var$l7c($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$m1, 1), $61de1ee1cac498ae$var$nie, 8, 0, [
                    o.i.n,
                    o.n,
                    o.a
                ])).b;
                if ($61de1ee1cac498ae$var$$wnd.Math.abs(l - p) > $61de1ee1cac498ae$var$qme) {
                    f = k;
                    e = a;
                    d = new $61de1ee1cac498ae$var$f7c(f, l);
                    $61de1ee1cac498ae$var$Dsb(g.a, d);
                    $61de1ee1cac498ae$var$BPc(this, g, e, d, true);
                    m = a.r;
                    if (m) {
                        n = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$Ut(m.e, 0)));
                        d = new $61de1ee1cac498ae$var$f7c(f, n);
                        $61de1ee1cac498ae$var$Dsb(g.a, d);
                        $61de1ee1cac498ae$var$BPc(this, g, e, d, true);
                        f = b + m.o * c;
                        e = m;
                        d = new $61de1ee1cac498ae$var$f7c(f, n);
                        $61de1ee1cac498ae$var$Dsb(g.a, d);
                        $61de1ee1cac498ae$var$BPc(this, g, e, d, true);
                    }
                    d = new $61de1ee1cac498ae$var$f7c(f, p);
                    $61de1ee1cac498ae$var$Dsb(g.a, d);
                    $61de1ee1cac498ae$var$BPc(this, g, e, d, true);
                }
            }
        }
    }
};
$61de1ee1cac498ae$var$_.eg = function QPc(a) {
    return a.i.n.b + a.n.b + a.a.b;
};
$61de1ee1cac498ae$var$_.fg = function RPc() {
    return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$zcd;
};
$61de1ee1cac498ae$var$_.gg = function SPc() {
    return $61de1ee1cac498ae$var$Ucd(), $61de1ee1cac498ae$var$Tcd;
};
var $61de1ee1cac498ae$var$UZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nqe, "WestToEastRoutingStrategy", 1806);
$61de1ee1cac498ae$var$bcb(813, 1, {}, $61de1ee1cac498ae$var$YPc);
$61de1ee1cac498ae$var$_.Ib = function ZPc() {
    return $61de1ee1cac498ae$var$Fe(this.a);
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = false;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$WZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "NubSpline", 813);
$61de1ee1cac498ae$var$bcb(407, 1, {
    407: 1
}, $61de1ee1cac498ae$var$aQc, $61de1ee1cac498ae$var$bQc);
var $61de1ee1cac498ae$var$VZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "NubSpline/PolarCP", 407);
$61de1ee1cac498ae$var$bcb(1453, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$vQc);
$61de1ee1cac498ae$var$_.Yf = function xQc(a) {
    return $61de1ee1cac498ae$var$qQc($61de1ee1cac498ae$var$BD(a, 37));
};
$61de1ee1cac498ae$var$_.pf = function yQc(a, b) {
    $61de1ee1cac498ae$var$uQc(this, $61de1ee1cac498ae$var$BD(a, 37), b);
};
var $61de1ee1cac498ae$var$cQc, $61de1ee1cac498ae$var$dQc, $61de1ee1cac498ae$var$eQc, $61de1ee1cac498ae$var$fQc, $61de1ee1cac498ae$var$gQc;
var $61de1ee1cac498ae$var$b$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineEdgeRouter", 1453);
$61de1ee1cac498ae$var$bcb(268, 1, {
    268: 1
}, $61de1ee1cac498ae$var$BQc);
$61de1ee1cac498ae$var$_.Ib = function CQc() {
    return this.a + " ->(" + this.c + ") " + this.b;
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$XZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineEdgeRouter/Dependency", 268);
$61de1ee1cac498ae$var$bcb(455, 22, {
    3: 1,
    35: 1,
    22: 1,
    455: 1
}, $61de1ee1cac498ae$var$GQc);
var $61de1ee1cac498ae$var$DQc, $61de1ee1cac498ae$var$EQc;
var $61de1ee1cac498ae$var$YZ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Pqe, "SplineEdgeRouter/SideToProcess", 455, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$IQc, $61de1ee1cac498ae$var$HQc);
var $61de1ee1cac498ae$var$JQc;
$61de1ee1cac498ae$var$bcb(1454, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$LQc);
$61de1ee1cac498ae$var$_.Mb = function MQc(a) {
    return $61de1ee1cac498ae$var$hQc(), !$61de1ee1cac498ae$var$BD(a, 128).o;
};
var $61de1ee1cac498ae$var$ZZ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineEdgeRouter/lambda$0$Type", 1454);
$61de1ee1cac498ae$var$bcb(1455, 1, {}, $61de1ee1cac498ae$var$NQc);
$61de1ee1cac498ae$var$_.Ge = function OQc(a) {
    return $61de1ee1cac498ae$var$hQc(), $61de1ee1cac498ae$var$BD(a, 128).v + 1;
};
var $61de1ee1cac498ae$var$$Z = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineEdgeRouter/lambda$1$Type", 1455);
$61de1ee1cac498ae$var$bcb(1456, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$PQc);
$61de1ee1cac498ae$var$_.td = function QQc(a) {
    $61de1ee1cac498ae$var$sQc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 46));
};
var $61de1ee1cac498ae$var$_Z = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineEdgeRouter/lambda$2$Type", 1456);
$61de1ee1cac498ae$var$bcb(1457, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$RQc);
$61de1ee1cac498ae$var$_.td = function SQc(a) {
    $61de1ee1cac498ae$var$tQc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 46));
};
var $61de1ee1cac498ae$var$a$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineEdgeRouter/lambda$3$Type", 1457);
$61de1ee1cac498ae$var$bcb(128, 1, {
    35: 1,
    128: 1
}, $61de1ee1cac498ae$var$YQc, $61de1ee1cac498ae$var$ZQc);
$61de1ee1cac498ae$var$_.wd = function $Qc(a) {
    return $61de1ee1cac498ae$var$WQc(this, $61de1ee1cac498ae$var$BD(a, 128));
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.e = false;
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.j = false;
$61de1ee1cac498ae$var$_.k = false;
$61de1ee1cac498ae$var$_.n = 0;
$61de1ee1cac498ae$var$_.o = false;
$61de1ee1cac498ae$var$_.p = false;
$61de1ee1cac498ae$var$_.q = false;
$61de1ee1cac498ae$var$_.s = 0;
$61de1ee1cac498ae$var$_.u = 0;
$61de1ee1cac498ae$var$_.v = 0;
$61de1ee1cac498ae$var$_.F = 0;
var $61de1ee1cac498ae$var$d$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineSegment", 128);
$61de1ee1cac498ae$var$bcb(459, 1, {
    459: 1
}, $61de1ee1cac498ae$var$_Qc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = false;
$61de1ee1cac498ae$var$_.e = false;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$c$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Pqe, "SplineSegment/EdgeInformation", 459);
$61de1ee1cac498ae$var$bcb(1234, 1, {}, $61de1ee1cac498ae$var$hRc);
var $61de1ee1cac498ae$var$f$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uqe, $61de1ee1cac498ae$var$hme, 1234);
$61de1ee1cac498ae$var$bcb(1235, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$jRc);
$61de1ee1cac498ae$var$_.ue = function kRc(a, b) {
    return $61de1ee1cac498ae$var$iRc($61de1ee1cac498ae$var$BD(a, 135), $61de1ee1cac498ae$var$BD(b, 135));
};
$61de1ee1cac498ae$var$_.Fb = function lRc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function mRc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$e$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uqe, $61de1ee1cac498ae$var$ime, 1235);
$61de1ee1cac498ae$var$bcb(1233, 1, {}, $61de1ee1cac498ae$var$tRc);
var $61de1ee1cac498ae$var$g$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uqe, "MrTree", 1233);
$61de1ee1cac498ae$var$bcb(393, 22, {
    3: 1,
    35: 1,
    22: 1,
    393: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$ARc);
$61de1ee1cac498ae$var$_.Kf = function CRc() {
    return $61de1ee1cac498ae$var$zRc(this);
};
$61de1ee1cac498ae$var$_.Xf = function BRc() {
    return $61de1ee1cac498ae$var$zRc(this);
};
var $61de1ee1cac498ae$var$uRc, $61de1ee1cac498ae$var$vRc, $61de1ee1cac498ae$var$wRc, $61de1ee1cac498ae$var$xRc;
var $61de1ee1cac498ae$var$h$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Uqe, "TreeLayoutPhases", 393, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$ERc, $61de1ee1cac498ae$var$DRc);
var $61de1ee1cac498ae$var$FRc;
$61de1ee1cac498ae$var$bcb(1130, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$HRc);
$61de1ee1cac498ae$var$_.Ze = function IRc(a, b) {
    var c, d, e, f, g, h, i;
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$JTc(), $61de1ee1cac498ae$var$ATc)))) || $61de1ee1cac498ae$var$$Cb((c = new $61de1ee1cac498ae$var$_Cb(($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd(a))), c));
    g = (h = new $61de1ee1cac498ae$var$SRc, $61de1ee1cac498ae$var$tNb(h, a), $61de1ee1cac498ae$var$yNb(h, ($61de1ee1cac498ae$var$mTc(), $61de1ee1cac498ae$var$dTc), a), i = new $61de1ee1cac498ae$var$Lqb, $61de1ee1cac498ae$var$pRc(a, h, i), $61de1ee1cac498ae$var$oRc(a, h, i), h);
    f = $61de1ee1cac498ae$var$gRc(this.a, g);
    for(e = new $61de1ee1cac498ae$var$olb(f); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 135);
        $61de1ee1cac498ae$var$rRc(this.b, d, $61de1ee1cac498ae$var$Udd(b, 1 / f.c.length));
    }
    g = $61de1ee1cac498ae$var$fRc(f);
    $61de1ee1cac498ae$var$nRc(g);
};
var $61de1ee1cac498ae$var$i$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uqe, "TreeLayoutProvider", 1130);
$61de1ee1cac498ae$var$bcb(1847, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$KRc);
$61de1ee1cac498ae$var$_.Jc = function LRc(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function MRc() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Emb(), $61de1ee1cac498ae$var$Dmb;
};
var $61de1ee1cac498ae$var$j$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uqe, "TreeUtil/1", 1847);
$61de1ee1cac498ae$var$bcb(1848, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$NRc);
$61de1ee1cac498ae$var$_.Jc = function ORc(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function PRc() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Emb(), $61de1ee1cac498ae$var$Dmb;
};
var $61de1ee1cac498ae$var$k$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Uqe, "TreeUtil/2", 1848);
$61de1ee1cac498ae$var$bcb(502, 134, {
    3: 1,
    502: 1,
    94: 1,
    134: 1
});
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$m$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vqe, "TGraphElement", 502);
$61de1ee1cac498ae$var$bcb(188, 502, {
    3: 1,
    188: 1,
    502: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$QRc);
$61de1ee1cac498ae$var$_.Ib = function RRc() {
    return !!this.b && !!this.c ? $61de1ee1cac498ae$var$WRc(this.b) + "->" + $61de1ee1cac498ae$var$WRc(this.c) : "e_" + $61de1ee1cac498ae$var$tb(this);
};
var $61de1ee1cac498ae$var$l$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vqe, "TEdge", 188);
$61de1ee1cac498ae$var$bcb(135, 134, {
    3: 1,
    135: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$SRc);
$61de1ee1cac498ae$var$_.Ib = function TRc() {
    var a, b, c, d, e;
    e = null;
    for(d = $61de1ee1cac498ae$var$Jsb(this.b, 0); d.b != d.d.c;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(d), 86);
        e += (c.c == null || c.c.length == 0 ? "n_" + c.g : "n_" + c.c) + "\n";
    }
    for(b = $61de1ee1cac498ae$var$Jsb(this.a, 0); b.b != b.d.c;){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(b), 188);
        e += (!!a.b && !!a.c ? $61de1ee1cac498ae$var$WRc(a.b) + "->" + $61de1ee1cac498ae$var$WRc(a.c) : "e_" + $61de1ee1cac498ae$var$tb(a)) + "\n";
    }
    return e;
};
var $61de1ee1cac498ae$var$n$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vqe, "TGraph", 135);
$61de1ee1cac498ae$var$bcb(633, 502, {
    3: 1,
    502: 1,
    633: 1,
    94: 1,
    134: 1
});
var $61de1ee1cac498ae$var$r$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vqe, "TShape", 633);
$61de1ee1cac498ae$var$bcb(86, 633, {
    3: 1,
    502: 1,
    86: 1,
    633: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$XRc);
$61de1ee1cac498ae$var$_.Ib = function YRc() {
    return $61de1ee1cac498ae$var$WRc(this);
};
var $61de1ee1cac498ae$var$q$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vqe, "TNode", 86);
$61de1ee1cac498ae$var$bcb(255, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$ZRc);
$61de1ee1cac498ae$var$_.Jc = function $Rc(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function _Rc() {
    var a;
    return a = $61de1ee1cac498ae$var$Jsb(this.a.d, 0), new $61de1ee1cac498ae$var$aSc(a);
};
var $61de1ee1cac498ae$var$p$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vqe, "TNode/2", 255);
$61de1ee1cac498ae$var$bcb(358, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$aSc);
$61de1ee1cac498ae$var$_.Nb = function bSc(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function dSc() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(this.a), 188).c;
};
$61de1ee1cac498ae$var$_.Ob = function cSc() {
    return $61de1ee1cac498ae$var$Wsb(this.a);
};
$61de1ee1cac498ae$var$_.Qb = function eSc() {
    $61de1ee1cac498ae$var$Zsb(this.a);
};
var $61de1ee1cac498ae$var$o$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vqe, "TNode/2/1", 358);
$61de1ee1cac498ae$var$bcb(1840, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$hSc);
$61de1ee1cac498ae$var$_.pf = function jSc(a, b) {
    $61de1ee1cac498ae$var$gSc(this, $61de1ee1cac498ae$var$BD(a, 135), b);
};
var $61de1ee1cac498ae$var$s$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "FanProcessor", 1840);
$61de1ee1cac498ae$var$bcb(327, 22, {
    3: 1,
    35: 1,
    22: 1,
    327: 1,
    234: 1
}, $61de1ee1cac498ae$var$rSc);
$61de1ee1cac498ae$var$_.Kf = function sSc() {
    switch(this.g){
        case 0:
            return new $61de1ee1cac498ae$var$QSc;
        case 1:
            return new $61de1ee1cac498ae$var$hSc;
        case 2:
            return new $61de1ee1cac498ae$var$GSc;
        case 3:
            return new $61de1ee1cac498ae$var$zSc;
        case 4:
            return new $61de1ee1cac498ae$var$NSc;
        case 5:
            return new $61de1ee1cac498ae$var$TSc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Dne + (this.f != null ? this.f : "" + this.g)));
    }
};
var $61de1ee1cac498ae$var$kSc, $61de1ee1cac498ae$var$lSc, $61de1ee1cac498ae$var$mSc, $61de1ee1cac498ae$var$nSc, $61de1ee1cac498ae$var$oSc, $61de1ee1cac498ae$var$pSc;
var $61de1ee1cac498ae$var$t$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Wqe, $61de1ee1cac498ae$var$Ene, 327, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$uSc, $61de1ee1cac498ae$var$tSc);
var $61de1ee1cac498ae$var$vSc;
$61de1ee1cac498ae$var$bcb(1843, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$zSc);
$61de1ee1cac498ae$var$_.pf = function ASc(a, b) {
    $61de1ee1cac498ae$var$xSc(this, $61de1ee1cac498ae$var$BD(a, 135), b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$v$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "LevelHeightProcessor", 1843);
$61de1ee1cac498ae$var$bcb(1844, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$BSc);
$61de1ee1cac498ae$var$_.Jc = function CSc(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function DSc() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Emb(), $61de1ee1cac498ae$var$Dmb;
};
var $61de1ee1cac498ae$var$u$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "LevelHeightProcessor/1", 1844);
$61de1ee1cac498ae$var$bcb(1841, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$GSc);
$61de1ee1cac498ae$var$_.pf = function HSc(a, b) {
    $61de1ee1cac498ae$var$ESc(this, $61de1ee1cac498ae$var$BD(a, 135), b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$x$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "NeighborsProcessor", 1841);
$61de1ee1cac498ae$var$bcb(1842, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$ISc);
$61de1ee1cac498ae$var$_.Jc = function JSc(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function KSc() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Emb(), $61de1ee1cac498ae$var$Dmb;
};
var $61de1ee1cac498ae$var$w$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "NeighborsProcessor/1", 1842);
$61de1ee1cac498ae$var$bcb(1845, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$NSc);
$61de1ee1cac498ae$var$_.pf = function OSc(a, b) {
    $61de1ee1cac498ae$var$LSc(this, $61de1ee1cac498ae$var$BD(a, 135), b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$y$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "NodePositionProcessor", 1845);
$61de1ee1cac498ae$var$bcb(1839, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$QSc);
$61de1ee1cac498ae$var$_.pf = function RSc(a, b) {
    $61de1ee1cac498ae$var$PSc(this, $61de1ee1cac498ae$var$BD(a, 135));
};
var $61de1ee1cac498ae$var$z$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "RootProcessor", 1839);
$61de1ee1cac498ae$var$bcb(1846, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$TSc);
$61de1ee1cac498ae$var$_.pf = function USc(a, b) {
    $61de1ee1cac498ae$var$SSc($61de1ee1cac498ae$var$BD(a, 135));
};
var $61de1ee1cac498ae$var$A$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wqe, "Untreeifyer", 1846);
var $61de1ee1cac498ae$var$VSc, $61de1ee1cac498ae$var$WSc, $61de1ee1cac498ae$var$XSc, $61de1ee1cac498ae$var$YSc, $61de1ee1cac498ae$var$ZSc, $61de1ee1cac498ae$var$$Sc, $61de1ee1cac498ae$var$_Sc, $61de1ee1cac498ae$var$aTc, $61de1ee1cac498ae$var$bTc, $61de1ee1cac498ae$var$cTc, $61de1ee1cac498ae$var$dTc, $61de1ee1cac498ae$var$eTc, $61de1ee1cac498ae$var$fTc, $61de1ee1cac498ae$var$gTc, $61de1ee1cac498ae$var$hTc, $61de1ee1cac498ae$var$iTc, $61de1ee1cac498ae$var$jTc, $61de1ee1cac498ae$var$kTc, $61de1ee1cac498ae$var$lTc;
$61de1ee1cac498ae$var$bcb(851, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$sTc);
$61de1ee1cac498ae$var$_.Qe = function tTc(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Zqe), ""), "Weighting of Nodes"), "Which weighting to use when computing a node order."), $61de1ee1cac498ae$var$qTc), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$V5c)), $61de1ee1cac498ae$var$E$), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$L5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$$qe), ""), "Search Order"), "Which search order to use when computing a spanning tree."), $61de1ee1cac498ae$var$oTc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$F$), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$KTc((new $61de1ee1cac498ae$var$LTc, a));
};
var $61de1ee1cac498ae$var$nTc, $61de1ee1cac498ae$var$oTc, $61de1ee1cac498ae$var$pTc, $61de1ee1cac498ae$var$qTc;
var $61de1ee1cac498ae$var$B$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_qe, "MrTreeMetaDataProvider", 851);
$61de1ee1cac498ae$var$bcb(994, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$LTc);
$61de1ee1cac498ae$var$_.Qe = function MTc(a) {
    $61de1ee1cac498ae$var$KTc(a);
};
var $61de1ee1cac498ae$var$uTc, $61de1ee1cac498ae$var$vTc, $61de1ee1cac498ae$var$wTc, $61de1ee1cac498ae$var$xTc, $61de1ee1cac498ae$var$yTc, $61de1ee1cac498ae$var$zTc, $61de1ee1cac498ae$var$ATc, $61de1ee1cac498ae$var$BTc, $61de1ee1cac498ae$var$CTc, $61de1ee1cac498ae$var$DTc, $61de1ee1cac498ae$var$ETc, $61de1ee1cac498ae$var$FTc, $61de1ee1cac498ae$var$GTc, $61de1ee1cac498ae$var$HTc, $61de1ee1cac498ae$var$ITc;
var $61de1ee1cac498ae$var$D$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_qe, "MrTreeOptions", 994);
$61de1ee1cac498ae$var$bcb(995, 1, {}, $61de1ee1cac498ae$var$NTc);
$61de1ee1cac498ae$var$_.$e = function OTc() {
    var a;
    return a = new $61de1ee1cac498ae$var$HRc, a;
};
$61de1ee1cac498ae$var$_._e = function PTc(a) {};
var $61de1ee1cac498ae$var$C$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$_qe, "MrTreeOptions/MrtreeFactory", 995);
$61de1ee1cac498ae$var$bcb(480, 22, {
    3: 1,
    35: 1,
    22: 1,
    480: 1
}, $61de1ee1cac498ae$var$TTc);
var $61de1ee1cac498ae$var$QTc, $61de1ee1cac498ae$var$RTc;
var $61de1ee1cac498ae$var$E$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$_qe, "OrderWeighting", 480, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$VTc, $61de1ee1cac498ae$var$UTc);
var $61de1ee1cac498ae$var$WTc;
$61de1ee1cac498ae$var$bcb(425, 22, {
    3: 1,
    35: 1,
    22: 1,
    425: 1
}, $61de1ee1cac498ae$var$_Tc);
var $61de1ee1cac498ae$var$YTc, $61de1ee1cac498ae$var$ZTc;
var $61de1ee1cac498ae$var$F$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$_qe, "TreeifyingOrder", 425, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$bUc, $61de1ee1cac498ae$var$aUc);
var $61de1ee1cac498ae$var$cUc;
$61de1ee1cac498ae$var$bcb(1459, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$lUc);
$61de1ee1cac498ae$var$_.Yf = function mUc(a) {
    return $61de1ee1cac498ae$var$BD(a, 135), $61de1ee1cac498ae$var$eUc;
};
$61de1ee1cac498ae$var$_.pf = function nUc(a, b) {
    $61de1ee1cac498ae$var$kUc(this, $61de1ee1cac498ae$var$BD(a, 135), b);
};
var $61de1ee1cac498ae$var$eUc;
var $61de1ee1cac498ae$var$G$ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.mrtree.p1treeify", "DFSTreeifyer", 1459);
$61de1ee1cac498ae$var$bcb(1460, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$sUc);
$61de1ee1cac498ae$var$_.Yf = function tUc(a) {
    return $61de1ee1cac498ae$var$BD(a, 135), $61de1ee1cac498ae$var$oUc;
};
$61de1ee1cac498ae$var$_.pf = function uUc(a, b) {
    $61de1ee1cac498ae$var$rUc(this, $61de1ee1cac498ae$var$BD(a, 135), b);
};
var $61de1ee1cac498ae$var$oUc;
var $61de1ee1cac498ae$var$H$ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.mrtree.p2order", "NodeOrderer", 1460);
$61de1ee1cac498ae$var$bcb(1461, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$CUc);
$61de1ee1cac498ae$var$_.Yf = function DUc(a) {
    return $61de1ee1cac498ae$var$BD(a, 135), $61de1ee1cac498ae$var$vUc;
};
$61de1ee1cac498ae$var$_.pf = function EUc(a, b) {
    $61de1ee1cac498ae$var$AUc(this, $61de1ee1cac498ae$var$BD(a, 135), b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$vUc;
var $61de1ee1cac498ae$var$I$ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.mrtree.p3place", "NodePlacer", 1461);
$61de1ee1cac498ae$var$bcb(1462, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$IUc);
$61de1ee1cac498ae$var$_.Yf = function JUc(a) {
    return $61de1ee1cac498ae$var$BD(a, 135), $61de1ee1cac498ae$var$FUc;
};
$61de1ee1cac498ae$var$_.pf = function KUc(a, b) {
    $61de1ee1cac498ae$var$HUc($61de1ee1cac498ae$var$BD(a, 135), b);
};
var $61de1ee1cac498ae$var$FUc;
var $61de1ee1cac498ae$var$J$ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.mrtree.p4route", "EdgeRouter", 1462);
var $61de1ee1cac498ae$var$LUc;
$61de1ee1cac498ae$var$bcb(495, 22, {
    3: 1,
    35: 1,
    22: 1,
    495: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$RUc);
$61de1ee1cac498ae$var$_.Kf = function TUc() {
    return $61de1ee1cac498ae$var$QUc(this);
};
$61de1ee1cac498ae$var$_.Xf = function SUc() {
    return $61de1ee1cac498ae$var$QUc(this);
};
var $61de1ee1cac498ae$var$NUc, $61de1ee1cac498ae$var$OUc;
var $61de1ee1cac498ae$var$K$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$cre, "RadialLayoutPhases", 495, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$VUc, $61de1ee1cac498ae$var$UUc);
var $61de1ee1cac498ae$var$WUc;
$61de1ee1cac498ae$var$bcb(1131, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$ZUc);
$61de1ee1cac498ae$var$_.Ze = function $Uc(a, b) {
    var c, d, e, f, g, h;
    c = $61de1ee1cac498ae$var$YUc(this, a);
    $61de1ee1cac498ae$var$Odd(b, "Radial layout", c.c.length);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$QWc)))) || $61de1ee1cac498ae$var$$Cb((d = new $61de1ee1cac498ae$var$_Cb(($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd(a))), d));
    h = $61de1ee1cac498ae$var$aVc(a);
    $61de1ee1cac498ae$var$jkd(a, ($61de1ee1cac498ae$var$MUc(), $61de1ee1cac498ae$var$LUc), h);
    if (!h) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The given graph is not a tree!"));
    e = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$VWc)));
    e == 0 && (e = $61de1ee1cac498ae$var$_Uc(a));
    $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$VWc, e);
    for(g = new $61de1ee1cac498ae$var$olb($61de1ee1cac498ae$var$YUc(this, a)); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 51);
        f.pf(a, $61de1ee1cac498ae$var$Udd(b, 1));
    }
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$L$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cre, "RadialLayoutProvider", 1131);
$61de1ee1cac498ae$var$bcb(549, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$jVc);
$61de1ee1cac498ae$var$_.ue = function kVc(a, b) {
    return $61de1ee1cac498ae$var$iVc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 33), $61de1ee1cac498ae$var$BD(b, 33));
};
$61de1ee1cac498ae$var$_.Fb = function lVc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function mVc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$M$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cre, "RadialUtil/lambda$0$Type", 549);
$61de1ee1cac498ae$var$bcb(1375, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$oVc);
$61de1ee1cac498ae$var$_.pf = function pVc(a, b) {
    $61de1ee1cac498ae$var$nVc($61de1ee1cac498ae$var$BD(a, 33), b);
};
var $61de1ee1cac498ae$var$N$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fre, "CalculateGraphSize", 1375);
$61de1ee1cac498ae$var$bcb(442, 22, {
    3: 1,
    35: 1,
    22: 1,
    442: 1,
    234: 1
}, $61de1ee1cac498ae$var$uVc);
$61de1ee1cac498ae$var$_.Kf = function vVc() {
    switch(this.g){
        case 0:
            return new $61de1ee1cac498ae$var$bWc;
        case 1:
            return new $61de1ee1cac498ae$var$NVc;
        case 2:
            return new $61de1ee1cac498ae$var$oVc;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$Dne + (this.f != null ? this.f : "" + this.g)));
    }
};
var $61de1ee1cac498ae$var$qVc, $61de1ee1cac498ae$var$rVc, $61de1ee1cac498ae$var$sVc;
var $61de1ee1cac498ae$var$O$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$fre, $61de1ee1cac498ae$var$Ene, 442, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$xVc, $61de1ee1cac498ae$var$wVc);
var $61de1ee1cac498ae$var$yVc;
$61de1ee1cac498ae$var$bcb(645, 1, {});
$61de1ee1cac498ae$var$_.e = 1;
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$P$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$gre, "AbstractRadiusExtensionCompaction", 645);
$61de1ee1cac498ae$var$bcb(1772, 645, {}, $61de1ee1cac498ae$var$KVc);
$61de1ee1cac498ae$var$_.hg = function LVc(a) {
    var b, c, d, e, f, g, h, i, j;
    this.c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$MUc(), $61de1ee1cac498ae$var$LUc)), 33);
    $61de1ee1cac498ae$var$EVc(this, this.c);
    this.d = $61de1ee1cac498ae$var$tXc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$WWc)), 293));
    i = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$KWc), 19);
    !!i && $61de1ee1cac498ae$var$DVc(this, i.a);
    h = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$T9c)));
    $61de1ee1cac498ae$var$FVc(this, ($61de1ee1cac498ae$var$uCb(h), h));
    j = $61de1ee1cac498ae$var$gVc(this.c);
    !!this.d && this.d.lg(j);
    $61de1ee1cac498ae$var$GVc(this, j);
    g = new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E2, 1), $61de1ee1cac498ae$var$hre, 33, 0, [
        this.c
    ]));
    for(c = 0; c < 2; c++)for(b = 0; b < j.c.length; b++){
        e = new $61de1ee1cac498ae$var$amb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$E2, 1), $61de1ee1cac498ae$var$hre, 33, 0, [
            ($61de1ee1cac498ae$var$tCb(b, j.c.length), $61de1ee1cac498ae$var$BD(j.c[b], 33))
        ]));
        f = b < j.c.length - 1 ? ($61de1ee1cac498ae$var$tCb(b + 1, j.c.length), $61de1ee1cac498ae$var$BD(j.c[b + 1], 33)) : ($61de1ee1cac498ae$var$tCb(0, j.c.length), $61de1ee1cac498ae$var$BD(j.c[0], 33));
        d = b == 0 ? $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(j, j.c.length - 1), 33) : ($61de1ee1cac498ae$var$tCb(b - 1, j.c.length), $61de1ee1cac498ae$var$BD(j.c[b - 1], 33));
        $61de1ee1cac498ae$var$IVc(this, ($61de1ee1cac498ae$var$tCb(b, j.c.length), $61de1ee1cac498ae$var$BD(j.c[b], 33), g), d, f, e);
    }
};
var $61de1ee1cac498ae$var$Q$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$gre, "AnnulusWedgeCompaction", 1772);
$61de1ee1cac498ae$var$bcb(1374, 1, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$NVc);
$61de1ee1cac498ae$var$_.pf = function OVc(a, b) {
    $61de1ee1cac498ae$var$MVc($61de1ee1cac498ae$var$BD(a, 33), b);
};
var $61de1ee1cac498ae$var$R$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$gre, "GeneralCompactor", 1374);
$61de1ee1cac498ae$var$bcb(1771, 645, {}, $61de1ee1cac498ae$var$SVc);
$61de1ee1cac498ae$var$_.hg = function TVc(a) {
    var b, c, d, e;
    c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$MUc(), $61de1ee1cac498ae$var$LUc)), 33);
    this.f = c;
    this.b = $61de1ee1cac498ae$var$tXc($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$ZWc(), $61de1ee1cac498ae$var$WWc)), 293));
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$KWc), 19);
    !!e && $61de1ee1cac498ae$var$DVc(this, e.a);
    d = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$T9c)));
    $61de1ee1cac498ae$var$FVc(this, ($61de1ee1cac498ae$var$uCb(d), d));
    b = $61de1ee1cac498ae$var$gVc(c);
    !!this.b && this.b.lg(b);
    $61de1ee1cac498ae$var$QVc(this, b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$S$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$gre, "RadialCompaction", 1771);
$61de1ee1cac498ae$var$bcb(1779, 1, {}, $61de1ee1cac498ae$var$VVc);
$61de1ee1cac498ae$var$_.ig = function WVc(a) {
    var b, c, d, e, f, g;
    this.a = a;
    b = 0;
    g = $61de1ee1cac498ae$var$gVc(a);
    d = 0;
    for(f = new $61de1ee1cac498ae$var$olb(g); f.a < f.c.c.length;){
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(f), 33);
        ++d;
        for(c = d; c < g.c.length; c++)$61de1ee1cac498ae$var$UVc(this, e, ($61de1ee1cac498ae$var$tCb(c, g.c.length), $61de1ee1cac498ae$var$BD(g.c[c], 33))) && (b += 1);
    }
    return b;
};
var $61de1ee1cac498ae$var$T$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ire, "CrossingMinimizationPosition", 1779);
$61de1ee1cac498ae$var$bcb(1777, 1, {}, $61de1ee1cac498ae$var$XVc);
$61de1ee1cac498ae$var$_.ig = function YVc(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 79);
        h = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.c && (b.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 5, 8)), b.c), 0), 82));
        j = h.i + h.g / 2;
        k = h.j + h.f / 2;
        e = a.i + a.g / 2;
        f = a.j + a.f / 2;
        l = new $61de1ee1cac498ae$var$d7c;
        l.a = j - e;
        l.b = k - f;
        g = new $61de1ee1cac498ae$var$f7c(l.a, l.b);
        $61de1ee1cac498ae$var$l6c(g, a.g, a.f);
        l.a -= g.a;
        l.b -= g.b;
        e = j - l.a;
        f = k - l.b;
        i = new $61de1ee1cac498ae$var$f7c(l.a, l.b);
        $61de1ee1cac498ae$var$l6c(i, h.g, h.f);
        l.a -= i.a;
        l.b -= i.b;
        j = e + l.a;
        k = f + l.b;
        m = j - e;
        n = k - f;
        d += $61de1ee1cac498ae$var$$wnd.Math.sqrt(m * m + n * n);
    }
    return d;
};
var $61de1ee1cac498ae$var$U$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ire, "EdgeLengthOptimization", 1777);
$61de1ee1cac498ae$var$bcb(1778, 1, {}, $61de1ee1cac498ae$var$ZVc);
$61de1ee1cac498ae$var$_.ig = function $Vc(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(a).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(c);){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(c), 79);
        h = $61de1ee1cac498ae$var$atd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud((!b.c && (b.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, b, 5, 8)), b.c), 0), 82));
        i = h.i + h.g / 2;
        j = h.j + h.f / 2;
        e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(h, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$C9c)), 8);
        f = a.i + e.a + a.g / 2;
        g = a.j + e.b + a.f;
        k = i - f;
        l = j - g;
        d += $61de1ee1cac498ae$var$$wnd.Math.sqrt(k * k + l * l);
    }
    return d;
};
var $61de1ee1cac498ae$var$V$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ire, "EdgeLengthPositionOptimization", 1778);
$61de1ee1cac498ae$var$bcb(1373, 645, $61de1ee1cac498ae$var$ene, $61de1ee1cac498ae$var$bWc);
$61de1ee1cac498ae$var$_.pf = function cWc(a, b) {
    $61de1ee1cac498ae$var$aWc(this, $61de1ee1cac498ae$var$BD(a, 33), b);
};
var $61de1ee1cac498ae$var$W$ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.radial.intermediate.overlaps", "RadiusExtensionOverlapRemoval", 1373);
$61de1ee1cac498ae$var$bcb(426, 22, {
    3: 1,
    35: 1,
    22: 1,
    426: 1
}, $61de1ee1cac498ae$var$hWc);
var $61de1ee1cac498ae$var$dWc, $61de1ee1cac498ae$var$eWc;
var $61de1ee1cac498ae$var$X$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$kre, "AnnulusWedgeCriteria", 426, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$jWc, $61de1ee1cac498ae$var$iWc);
var $61de1ee1cac498ae$var$kWc;
$61de1ee1cac498ae$var$bcb(380, 22, {
    3: 1,
    35: 1,
    22: 1,
    380: 1
}, $61de1ee1cac498ae$var$rWc);
var $61de1ee1cac498ae$var$mWc, $61de1ee1cac498ae$var$nWc, $61de1ee1cac498ae$var$oWc;
var $61de1ee1cac498ae$var$Y$ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$kre, $61de1ee1cac498ae$var$Sle, 380, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$tWc, $61de1ee1cac498ae$var$sWc);
var $61de1ee1cac498ae$var$uWc;
$61de1ee1cac498ae$var$bcb(852, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$IWc);
$61de1ee1cac498ae$var$_.Qe = function JWc(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$lre), ""), "Order ID"), "The id can be used to define an order for nodes of one radius. This can be used to sort them in the layer accordingly."), $61de1ee1cac498ae$var$meb(0)), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$X5c)), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$K5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$mre), ""), "Radius"), "The radius option can be used to set the initial radius for the radial layouter."), 0), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$nre), ""), "Compaction"), "With the compacter option it can be determined how compaction on the graph is done. It can be chosen between none, the radial compaction or the compaction of wedges separately."), $61de1ee1cac498ae$var$yWc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$Y$), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ore), ""), "Compaction Step Size"), "Determine the size of steps with which the compaction is done. Step size 1 correlates to a compaction of 1 pixel per Iteration."), $61de1ee1cac498ae$var$meb(1)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$ore, $61de1ee1cac498ae$var$nre, null);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$pre), ""), "Sorter"), "Sort the nodes per radius according to the sorting algorithm. The strategies are none, by the given order id, or sorting them by polar coordinates."), $61de1ee1cac498ae$var$EWc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$b_), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$qre), ""), "Annulus Wedge Criteria"), "Determine how the wedge for the node placement is calculated. It can be chosen between wedge determination by the number of leaves or by the maximum sum of diagonals."), $61de1ee1cac498ae$var$GWc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$X$), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$rre), ""), "Translation Optimization"), "Find the optimal translation of the nodes of the first radii according to this criteria. For example edge crossings can be minimized."), $61de1ee1cac498ae$var$AWc), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$a_), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$$Wc((new $61de1ee1cac498ae$var$_Wc, a));
};
var $61de1ee1cac498ae$var$wWc, $61de1ee1cac498ae$var$xWc, $61de1ee1cac498ae$var$yWc, $61de1ee1cac498ae$var$zWc, $61de1ee1cac498ae$var$AWc, $61de1ee1cac498ae$var$BWc, $61de1ee1cac498ae$var$CWc, $61de1ee1cac498ae$var$DWc, $61de1ee1cac498ae$var$EWc, $61de1ee1cac498ae$var$FWc, $61de1ee1cac498ae$var$GWc;
var $61de1ee1cac498ae$var$Z$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kre, "RadialMetaDataProvider", 852);
$61de1ee1cac498ae$var$bcb(996, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$_Wc);
$61de1ee1cac498ae$var$_.Qe = function aXc(a) {
    $61de1ee1cac498ae$var$$Wc(a);
};
var $61de1ee1cac498ae$var$KWc, $61de1ee1cac498ae$var$LWc, $61de1ee1cac498ae$var$MWc, $61de1ee1cac498ae$var$NWc, $61de1ee1cac498ae$var$OWc, $61de1ee1cac498ae$var$PWc, $61de1ee1cac498ae$var$QWc, $61de1ee1cac498ae$var$RWc, $61de1ee1cac498ae$var$SWc, $61de1ee1cac498ae$var$TWc, $61de1ee1cac498ae$var$UWc, $61de1ee1cac498ae$var$VWc, $61de1ee1cac498ae$var$WWc, $61de1ee1cac498ae$var$XWc, $61de1ee1cac498ae$var$YWc;
var $61de1ee1cac498ae$var$_$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kre, "RadialOptions", 996);
$61de1ee1cac498ae$var$bcb(997, 1, {}, $61de1ee1cac498ae$var$bXc);
$61de1ee1cac498ae$var$_.$e = function cXc() {
    var a;
    return a = new $61de1ee1cac498ae$var$ZUc, a;
};
$61de1ee1cac498ae$var$_._e = function dXc(a) {};
var $61de1ee1cac498ae$var$$$ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kre, "RadialOptions/RadialFactory", 997);
$61de1ee1cac498ae$var$bcb(340, 22, {
    3: 1,
    35: 1,
    22: 1,
    340: 1
}, $61de1ee1cac498ae$var$kXc);
var $61de1ee1cac498ae$var$eXc, $61de1ee1cac498ae$var$fXc, $61de1ee1cac498ae$var$gXc, $61de1ee1cac498ae$var$hXc;
var $61de1ee1cac498ae$var$a_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$kre, "RadialTranslationStrategy", 340, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$mXc, $61de1ee1cac498ae$var$lXc);
var $61de1ee1cac498ae$var$nXc;
$61de1ee1cac498ae$var$bcb(293, 22, {
    3: 1,
    35: 1,
    22: 1,
    293: 1
}, $61de1ee1cac498ae$var$uXc);
var $61de1ee1cac498ae$var$pXc, $61de1ee1cac498ae$var$qXc, $61de1ee1cac498ae$var$rXc;
var $61de1ee1cac498ae$var$b_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$kre, "SortingStrategy", 293, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$wXc, $61de1ee1cac498ae$var$vXc);
var $61de1ee1cac498ae$var$xXc;
$61de1ee1cac498ae$var$bcb(1449, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$CXc);
$61de1ee1cac498ae$var$_.Yf = function DXc(a) {
    return $61de1ee1cac498ae$var$BD(a, 33), null;
};
$61de1ee1cac498ae$var$_.pf = function EXc(a, b) {
    $61de1ee1cac498ae$var$AXc(this, $61de1ee1cac498ae$var$BD(a, 33), b);
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$c_ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.radial.p1position", "EadesRadial", 1449);
$61de1ee1cac498ae$var$bcb(1775, 1, {}, $61de1ee1cac498ae$var$FXc);
$61de1ee1cac498ae$var$_.jg = function GXc(a) {
    return $61de1ee1cac498ae$var$eVc(a);
};
var $61de1ee1cac498ae$var$d_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tre, "AnnulusWedgeByLeafs", 1775);
$61de1ee1cac498ae$var$bcb(1776, 1, {}, $61de1ee1cac498ae$var$IXc);
$61de1ee1cac498ae$var$_.jg = function JXc(a) {
    return $61de1ee1cac498ae$var$HXc(this, a);
};
var $61de1ee1cac498ae$var$e_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$tre, "AnnulusWedgeByNodeSpace", 1776);
$61de1ee1cac498ae$var$bcb(1450, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$MXc);
$61de1ee1cac498ae$var$_.Yf = function NXc(a) {
    return $61de1ee1cac498ae$var$BD(a, 33), null;
};
$61de1ee1cac498ae$var$_.pf = function OXc(a, b) {
    $61de1ee1cac498ae$var$KXc(this, $61de1ee1cac498ae$var$BD(a, 33), b);
};
var $61de1ee1cac498ae$var$f_ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.radial.p2routing", "StraightLineEdgeRouter", 1450);
$61de1ee1cac498ae$var$bcb(811, 1, {}, $61de1ee1cac498ae$var$QXc);
$61de1ee1cac498ae$var$_.kg = function RXc(a) {};
$61de1ee1cac498ae$var$_.lg = function TXc(a) {
    $61de1ee1cac498ae$var$PXc(this, a);
};
var $61de1ee1cac498ae$var$h_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ure, "IDSorter", 811);
$61de1ee1cac498ae$var$bcb(1774, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$UXc);
$61de1ee1cac498ae$var$_.ue = function VXc(a, b) {
    return $61de1ee1cac498ae$var$SXc($61de1ee1cac498ae$var$BD(a, 33), $61de1ee1cac498ae$var$BD(b, 33));
};
$61de1ee1cac498ae$var$_.Fb = function WXc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function XXc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$g_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ure, "IDSorter/lambda$0$Type", 1774);
$61de1ee1cac498ae$var$bcb(1773, 1, {}, $61de1ee1cac498ae$var$$Xc);
$61de1ee1cac498ae$var$_.kg = function _Xc(a) {
    $61de1ee1cac498ae$var$YXc(this, a);
};
$61de1ee1cac498ae$var$_.lg = function aYc(a) {
    var b;
    if (!a.dc()) {
        if (!this.e) {
            b = $61de1ee1cac498ae$var$bVc($61de1ee1cac498ae$var$BD(a.Xb(0), 33));
            $61de1ee1cac498ae$var$YXc(this, b);
        }
        $61de1ee1cac498ae$var$PXc(this.e, a);
    }
};
var $61de1ee1cac498ae$var$i_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ure, "PolarCoordinateSorter", 1773);
$61de1ee1cac498ae$var$bcb(1136, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$bYc);
$61de1ee1cac498ae$var$_.Ze = function eYc(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B, C, D, F;
    $61de1ee1cac498ae$var$Odd(b, "Rectangle Packing", 1);
    b.n && b.n && !!a && $61de1ee1cac498ae$var$Tdd(b, $61de1ee1cac498ae$var$i6d(a), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    c = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$lZc(), $61de1ee1cac498ae$var$RYc))));
    p = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$eZc), 381);
    s = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$ZYc)));
    w = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$dZc)));
    l = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$VYc)));
    A = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$fZc), 116);
    v = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$jZc)));
    e = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$iZc)));
    m = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$WYc)));
    r = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$XYc)));
    F = $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$kZc)));
    C = (!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a);
    $61de1ee1cac498ae$var$r$c(C);
    if (r) {
        o = new $61de1ee1cac498ae$var$Rkb;
        for(i = new $61de1ee1cac498ae$var$Fyd(C); i.e != i.i.gc();){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 33);
            $61de1ee1cac498ae$var$ikd(g, $61de1ee1cac498ae$var$UYc) && (o.c[o.c.length] = g);
        }
        for(j = new $61de1ee1cac498ae$var$olb(o); j.a < j.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(j), 33);
            $61de1ee1cac498ae$var$Ftd(C, g);
        }
        $61de1ee1cac498ae$var$mmb();
        $61de1ee1cac498ae$var$Okb(o, new $61de1ee1cac498ae$var$fYc);
        for(k = new $61de1ee1cac498ae$var$olb(o); k.a < k.c.c.length;){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(k), 33);
            B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(g, $61de1ee1cac498ae$var$UYc), 19).a;
            B = $61de1ee1cac498ae$var$$wnd.Math.min(B, C.i);
            $61de1ee1cac498ae$var$vtd(C, B, g);
        }
        q = 0;
        for(h = new $61de1ee1cac498ae$var$Fyd(C); h.e != h.i.gc();){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(h), 33);
            $61de1ee1cac498ae$var$jkd(g, $61de1ee1cac498ae$var$TYc, $61de1ee1cac498ae$var$meb(q));
            ++q;
        }
    }
    u = $61de1ee1cac498ae$var$rfd(a);
    u.a -= A.b + A.c;
    u.b -= A.d + A.a;
    t = u.a;
    if (F < 0 || F < u.a) {
        n = new $61de1ee1cac498ae$var$nYc(c, p, s);
        f = $61de1ee1cac498ae$var$jYc(n, C, v, A);
        b.n && b.n && !!a && $61de1ee1cac498ae$var$Tdd(b, $61de1ee1cac498ae$var$i6d(a), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    } else f = new $61de1ee1cac498ae$var$d$c(c, F, 0, ($61de1ee1cac498ae$var$k$c(), $61de1ee1cac498ae$var$j$c));
    u.a += A.b + A.c;
    u.b += A.d + A.a;
    if (!w) {
        $61de1ee1cac498ae$var$r$c(C);
        D = new $61de1ee1cac498ae$var$DZc(c, l, m, e, v);
        t = $61de1ee1cac498ae$var$$wnd.Math.max(u.a, f.c);
        f = $61de1ee1cac498ae$var$CZc(D, C, t, u, b, a, A);
    }
    $61de1ee1cac498ae$var$cYc(C, A);
    $61de1ee1cac498ae$var$Afd(a, f.c + (A.b + A.c), f.b + (A.d + A.a), false, true);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$cZc))) || $61de1ee1cac498ae$var$$Cb((d = new $61de1ee1cac498ae$var$_Cb(($61de1ee1cac498ae$var$Pgd(), new $61de1ee1cac498ae$var$bhd(a))), d));
    b.n && b.n && !!a && $61de1ee1cac498ae$var$Tdd(b, $61de1ee1cac498ae$var$i6d(a), ($61de1ee1cac498ae$var$pgd(), $61de1ee1cac498ae$var$mgd));
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$k_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yre, "RectPackingLayoutProvider", 1136);
$61de1ee1cac498ae$var$bcb(1137, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$fYc);
$61de1ee1cac498ae$var$_.ue = function gYc(a, b) {
    return $61de1ee1cac498ae$var$dYc($61de1ee1cac498ae$var$BD(a, 33), $61de1ee1cac498ae$var$BD(b, 33));
};
$61de1ee1cac498ae$var$_.Fb = function hYc(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function iYc() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$j_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yre, "RectPackingLayoutProvider/lambda$0$Type", 1137);
$61de1ee1cac498ae$var$bcb(1256, 1, {}, $61de1ee1cac498ae$var$nYc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$l_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$zre, "AreaApproximation", 1256);
var $61de1ee1cac498ae$var$o_ = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$zre, "BestCandidateFilter");
$61de1ee1cac498ae$var$bcb(638, 1, {
    526: 1
}, $61de1ee1cac498ae$var$oYc);
$61de1ee1cac498ae$var$_.mg = function pYc(a, b, c) {
    var d, e, f, g, h, i;
    i = new $61de1ee1cac498ae$var$Rkb;
    f = $61de1ee1cac498ae$var$Pje;
    for(h = new $61de1ee1cac498ae$var$olb(a); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 220);
        f = $61de1ee1cac498ae$var$$wnd.Math.min(f, (g.c + (c.b + c.c)) * (g.b + (c.d + c.a)));
    }
    for(e = new $61de1ee1cac498ae$var$olb(a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 220);
        (d.c + (c.b + c.c)) * (d.b + (c.d + c.a)) == f && (i.c[i.c.length] = d);
    }
    return i;
};
var $61de1ee1cac498ae$var$m_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$zre, "AreaFilter", 638);
$61de1ee1cac498ae$var$bcb(639, 1, {
    526: 1
}, $61de1ee1cac498ae$var$qYc);
$61de1ee1cac498ae$var$_.mg = function rYc(a, b, c) {
    var d, e, f, g, h, i;
    h = new $61de1ee1cac498ae$var$Rkb;
    i = $61de1ee1cac498ae$var$Pje;
    for(g = new $61de1ee1cac498ae$var$olb(a); g.a < g.c.c.length;){
        f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(g), 220);
        i = $61de1ee1cac498ae$var$$wnd.Math.min(i, $61de1ee1cac498ae$var$$wnd.Math.abs((f.c + (c.b + c.c)) / (f.b + (c.d + c.a)) - b));
    }
    for(e = new $61de1ee1cac498ae$var$olb(a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 220);
        $61de1ee1cac498ae$var$$wnd.Math.abs((d.c + (c.b + c.c)) / (d.b + (c.d + c.a)) - b) == i && (h.c[h.c.length] = d);
    }
    return h;
};
var $61de1ee1cac498ae$var$n_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$zre, "AspectRatioFilter", 639);
$61de1ee1cac498ae$var$bcb(637, 1, {
    526: 1
}, $61de1ee1cac498ae$var$uYc);
$61de1ee1cac498ae$var$_.mg = function vYc(a, b, c) {
    var d, e, f, g, h, i;
    i = new $61de1ee1cac498ae$var$Rkb;
    f = $61de1ee1cac498ae$var$Qje;
    for(h = new $61de1ee1cac498ae$var$olb(a); h.a < h.c.c.length;){
        g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(h), 220);
        f = $61de1ee1cac498ae$var$$wnd.Math.max(f, $61de1ee1cac498ae$var$q$c(g.c + (c.b + c.c), g.b + (c.d + c.a), g.a));
    }
    for(e = new $61de1ee1cac498ae$var$olb(a); e.a < e.c.c.length;){
        d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(e), 220);
        $61de1ee1cac498ae$var$q$c(d.c + (c.b + c.c), d.b + (c.d + c.a), d.a) == f && (i.c[i.c.length] = d);
    }
    return i;
};
var $61de1ee1cac498ae$var$p_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$zre, "ScaleMeasureFilter", 637);
$61de1ee1cac498ae$var$bcb(381, 22, {
    3: 1,
    35: 1,
    22: 1,
    381: 1
}, $61de1ee1cac498ae$var$AYc);
var $61de1ee1cac498ae$var$wYc, $61de1ee1cac498ae$var$xYc, $61de1ee1cac498ae$var$yYc;
var $61de1ee1cac498ae$var$q_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Are, "OptimizationGoal", 381, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$CYc, $61de1ee1cac498ae$var$BYc);
var $61de1ee1cac498ae$var$DYc;
$61de1ee1cac498ae$var$bcb(856, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$PYc);
$61de1ee1cac498ae$var$_.Qe = function QYc(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Bre), ""), "Optimization Goal"), "Optimization goal for approximation of the bounding box given by the first iteration. Determines whether layout is sorted by the maximum scaling, aspect ratio, or area. Depending on the strategy the aspect ratio might be nearly ignored."), $61de1ee1cac498ae$var$LYc), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$V5c)), $61de1ee1cac498ae$var$q_), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$K5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Cre), ""), "Shift Last Placed."), "When placing a rectangle behind or below the last placed rectangle in the first iteration, it is sometimes possible to shift the rectangle further to the left or right, resulting in less whitespace. True (default) enables the shift and false disables it. Disabling the shift produces a greater approximated area by the first iteration and a layout, when using ONLY the first iteration (default not the case), where it is sometimes impossible to implement a size transformation of rectangles that will fill the bounding box and eliminate empty spaces."), ($61de1ee1cac498ae$var$Bcb(), true)), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Dre), ""), "Current position of a node in the order of nodes"), "The rectangles are ordered. Normally according to their definition the the model. This option specifies the current position of a node."), $61de1ee1cac498ae$var$meb(-1)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ere), ""), "Desired index of node"), "The rectangles are ordered. Normally according to their definition the the model. This option allows to specify a desired position that has preference over the original position."), $61de1ee1cac498ae$var$meb(-1)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Fre), ""), "Only Area Approximation"), "If enabled only the width approximation step is executed and the nodes are placed accordingly. The nodes are layouted according to the packingStrategy. If set to true not expansion of nodes is taking place."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Gre), ""), "Compact Rows"), "Enables compaction. Compacts blocks if they do not use the full height of the row. This option allows to have a smaller drawing. If this option is disabled all nodes are placed next to each other in rows."), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Hre), ""), "Fit Aspect Ratio"), "Expands nodes if expandNodes is true to fit the aspect ratio instead of only in their bounds. The option is only useful if the used packingStrategy is ASPECT_RATIO_DRIVEN, otherwise this may result in unreasonable ndoe expansion."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Hre, $61de1ee1cac498ae$var$Jre, null);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ire), ""), "Target Width"), "Option to place the rectangles in the given target width instead of approximating the width using the desired aspect ratio. The padding is not included in this. Meaning a drawing will have width of targetwidth + horizontal padding."), -1), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$mZc((new $61de1ee1cac498ae$var$nZc, a));
};
var $61de1ee1cac498ae$var$FYc, $61de1ee1cac498ae$var$GYc, $61de1ee1cac498ae$var$HYc, $61de1ee1cac498ae$var$IYc, $61de1ee1cac498ae$var$JYc, $61de1ee1cac498ae$var$KYc, $61de1ee1cac498ae$var$LYc, $61de1ee1cac498ae$var$MYc, $61de1ee1cac498ae$var$NYc;
var $61de1ee1cac498ae$var$r_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Are, "RectPackingMetaDataProvider", 856);
$61de1ee1cac498ae$var$bcb(1004, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$nZc);
$61de1ee1cac498ae$var$_.Qe = function oZc(a) {
    $61de1ee1cac498ae$var$mZc(a);
};
var $61de1ee1cac498ae$var$RYc, $61de1ee1cac498ae$var$SYc, $61de1ee1cac498ae$var$TYc, $61de1ee1cac498ae$var$UYc, $61de1ee1cac498ae$var$VYc, $61de1ee1cac498ae$var$WYc, $61de1ee1cac498ae$var$XYc, $61de1ee1cac498ae$var$YYc, $61de1ee1cac498ae$var$ZYc, $61de1ee1cac498ae$var$$Yc, $61de1ee1cac498ae$var$_Yc, $61de1ee1cac498ae$var$aZc, $61de1ee1cac498ae$var$bZc, $61de1ee1cac498ae$var$cZc, $61de1ee1cac498ae$var$dZc, $61de1ee1cac498ae$var$eZc, $61de1ee1cac498ae$var$fZc, $61de1ee1cac498ae$var$gZc, $61de1ee1cac498ae$var$hZc, $61de1ee1cac498ae$var$iZc, $61de1ee1cac498ae$var$jZc, $61de1ee1cac498ae$var$kZc;
var $61de1ee1cac498ae$var$t_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Are, "RectPackingOptions", 1004);
$61de1ee1cac498ae$var$bcb(1005, 1, {}, $61de1ee1cac498ae$var$pZc);
$61de1ee1cac498ae$var$_.$e = function qZc() {
    var a;
    return a = new $61de1ee1cac498ae$var$bYc, a;
};
$61de1ee1cac498ae$var$_._e = function rZc(a) {};
var $61de1ee1cac498ae$var$s_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Are, "RectPackingOptions/RectpackingFactory", 1005);
$61de1ee1cac498ae$var$bcb(1257, 1, {}, $61de1ee1cac498ae$var$DZc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = false;
$61de1ee1cac498ae$var$_.f = false;
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$u_ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.rectpacking.seconditeration", "RowFillingAndCompaction", 1257);
$61de1ee1cac498ae$var$bcb(187, 1, {
    187: 1
}, $61de1ee1cac498ae$var$PZc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.k = false;
$61de1ee1cac498ae$var$_.o = $61de1ee1cac498ae$var$Pje;
$61de1ee1cac498ae$var$_.p = $61de1ee1cac498ae$var$Pje;
$61de1ee1cac498ae$var$_.r = 0;
$61de1ee1cac498ae$var$_.s = 0;
$61de1ee1cac498ae$var$_.t = 0;
var $61de1ee1cac498ae$var$x_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lre, "Block", 187);
$61de1ee1cac498ae$var$bcb(211, 1, {
    211: 1
}, $61de1ee1cac498ae$var$VZc);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$v_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lre, "BlockRow", 211);
$61de1ee1cac498ae$var$bcb(443, 1, {
    443: 1
}, $61de1ee1cac498ae$var$b$c);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$w_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lre, "BlockStack", 443);
$61de1ee1cac498ae$var$bcb(220, 1, {
    220: 1
}, $61de1ee1cac498ae$var$d$c, $61de1ee1cac498ae$var$e$c);
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$z_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lre, "DrawingData", 220);
$61de1ee1cac498ae$var$bcb(355, 22, {
    3: 1,
    35: 1,
    22: 1,
    355: 1
}, $61de1ee1cac498ae$var$l$c);
var $61de1ee1cac498ae$var$f$c, $61de1ee1cac498ae$var$g$c, $61de1ee1cac498ae$var$h$c, $61de1ee1cac498ae$var$i$c, $61de1ee1cac498ae$var$j$c;
var $61de1ee1cac498ae$var$y_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Lre, "DrawingDataDescriptor", 355, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$n$c, $61de1ee1cac498ae$var$m$c);
var $61de1ee1cac498ae$var$o$c;
$61de1ee1cac498ae$var$bcb(200, 1, {
    200: 1
}, $61de1ee1cac498ae$var$x$c);
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$A_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Lre, "RectRow", 200);
$61de1ee1cac498ae$var$bcb(756, 1, {}, $61de1ee1cac498ae$var$F$c);
$61de1ee1cac498ae$var$_.j = 0;
var $61de1ee1cac498ae$var$G_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, $61de1ee1cac498ae$var$une, 756);
$61de1ee1cac498ae$var$bcb(1245, 1, {}, $61de1ee1cac498ae$var$G$c);
$61de1ee1cac498ae$var$_.Je = function H$c(a) {
    return $61de1ee1cac498ae$var$S6c(a.a, a.b);
};
var $61de1ee1cac498ae$var$B_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, $61de1ee1cac498ae$var$vne, 1245);
$61de1ee1cac498ae$var$bcb(1246, 1, {}, $61de1ee1cac498ae$var$I$c);
$61de1ee1cac498ae$var$_.Je = function J$c(a) {
    return $61de1ee1cac498ae$var$A$c(this.a, a);
};
var $61de1ee1cac498ae$var$C_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, $61de1ee1cac498ae$var$wne, 1246);
$61de1ee1cac498ae$var$bcb(1247, 1, {}, $61de1ee1cac498ae$var$K$c);
$61de1ee1cac498ae$var$_.Je = function L$c(a) {
    return $61de1ee1cac498ae$var$B$c(this.a, a);
};
var $61de1ee1cac498ae$var$D_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, $61de1ee1cac498ae$var$xne, 1247);
$61de1ee1cac498ae$var$bcb(1248, 1, {}, $61de1ee1cac498ae$var$M$c);
$61de1ee1cac498ae$var$_.Je = function N$c(a) {
    return $61de1ee1cac498ae$var$C$c(this.a, a);
};
var $61de1ee1cac498ae$var$E_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, "ElkGraphImporter/lambda$3$Type", 1248);
$61de1ee1cac498ae$var$bcb(1249, 1, {}, $61de1ee1cac498ae$var$O$c);
$61de1ee1cac498ae$var$_.Je = function P$c(a) {
    return $61de1ee1cac498ae$var$D$c(this.a, a);
};
var $61de1ee1cac498ae$var$F_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, $61de1ee1cac498ae$var$yne, 1249);
$61de1ee1cac498ae$var$bcb(1133, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$Q$c);
$61de1ee1cac498ae$var$_.Ze = function S$c(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n;
    if ($61de1ee1cac498ae$var$ikd(a, ($61de1ee1cac498ae$var$d0c(), $61de1ee1cac498ae$var$c0c))) {
        n = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$J0c(), $61de1ee1cac498ae$var$I0c)));
        f = $61de1ee1cac498ae$var$h4c($61de1ee1cac498ae$var$n4c(), n);
        if (f) {
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hgd(f.f), 209);
            g.Ze(a, $61de1ee1cac498ae$var$Udd(b, 1));
        }
    }
    $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$Z_c, ($61de1ee1cac498ae$var$C_c(), $61de1ee1cac498ae$var$A_c));
    $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$$_c, ($61de1ee1cac498ae$var$N_c(), $61de1ee1cac498ae$var$K_c));
    $61de1ee1cac498ae$var$jkd(a, $61de1ee1cac498ae$var$__c, ($61de1ee1cac498ae$var$a1c(), $61de1ee1cac498ae$var$_0c));
    h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$J0c(), $61de1ee1cac498ae$var$E0c)), 19).a;
    $61de1ee1cac498ae$var$Odd(b, "Overlap removal", 1);
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$D0c)));
    i = new $61de1ee1cac498ae$var$Tqb;
    j = new $61de1ee1cac498ae$var$U$c(i);
    d = new $61de1ee1cac498ae$var$F$c;
    c = $61de1ee1cac498ae$var$z$c(d, a);
    k = true;
    e = 0;
    while(e < h && k){
        if ($61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$F0c)))) {
            i.a.$b();
            $61de1ee1cac498ae$var$cOb(new $61de1ee1cac498ae$var$dOb(j), c.i);
            if (i.a.gc() == 0) break;
            c.e = i;
        }
        $61de1ee1cac498ae$var$H2c(this.b);
        $61de1ee1cac498ae$var$K2c(this.b, ($61de1ee1cac498ae$var$Y$c(), $61de1ee1cac498ae$var$V$c), ($61de1ee1cac498ae$var$R0c(), $61de1ee1cac498ae$var$Q0c));
        $61de1ee1cac498ae$var$K2c(this.b, $61de1ee1cac498ae$var$W$c, c.g);
        $61de1ee1cac498ae$var$K2c(this.b, $61de1ee1cac498ae$var$X$c, ($61de1ee1cac498ae$var$s_c(), $61de1ee1cac498ae$var$r_c));
        this.a = $61de1ee1cac498ae$var$F2c(this.b, c);
        for(m = new $61de1ee1cac498ae$var$olb(this.a); m.a < m.c.c.length;){
            l = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$mlb(m), 51);
            l.pf(c, $61de1ee1cac498ae$var$Udd(b, 1));
        }
        $61de1ee1cac498ae$var$E$c(d, c);
        k = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(c, ($61de1ee1cac498ae$var$XNb(), $61de1ee1cac498ae$var$WNb))));
        ++e;
    }
    $61de1ee1cac498ae$var$y$c(d, c);
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$I_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, "OverlapRemovalLayoutProvider", 1133);
$61de1ee1cac498ae$var$bcb(1134, 1, {}, $61de1ee1cac498ae$var$U$c);
var $61de1ee1cac498ae$var$H_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, "OverlapRemovalLayoutProvider/lambda$0$Type", 1134);
$61de1ee1cac498ae$var$bcb(437, 22, {
    3: 1,
    35: 1,
    22: 1,
    437: 1
}, $61de1ee1cac498ae$var$Z$c);
var $61de1ee1cac498ae$var$V$c, $61de1ee1cac498ae$var$W$c, $61de1ee1cac498ae$var$X$c;
var $61de1ee1cac498ae$var$J_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Nre, "SPOrEPhases", 437, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$_$c, $61de1ee1cac498ae$var$$$c);
var $61de1ee1cac498ae$var$a_c;
$61de1ee1cac498ae$var$bcb(1255, 1, {}, $61de1ee1cac498ae$var$d_c);
var $61de1ee1cac498ae$var$L_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, "ShrinkTree", 1255);
$61de1ee1cac498ae$var$bcb(1135, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$e_c);
$61de1ee1cac498ae$var$_.Ze = function f_c(a, b) {
    var c, d, e, f, g;
    if ($61de1ee1cac498ae$var$ikd(a, ($61de1ee1cac498ae$var$d0c(), $61de1ee1cac498ae$var$c0c))) {
        g = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$c0c));
        e = $61de1ee1cac498ae$var$h4c($61de1ee1cac498ae$var$n4c(), g);
        if (e) {
            f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hgd(e.f), 209);
            f.Ze(a, $61de1ee1cac498ae$var$Udd(b, 1));
        }
    }
    d = new $61de1ee1cac498ae$var$F$c;
    c = $61de1ee1cac498ae$var$z$c(d, a);
    $61de1ee1cac498ae$var$c_c(this.a, c, $61de1ee1cac498ae$var$Udd(b, 1));
    $61de1ee1cac498ae$var$y$c(d, c);
};
var $61de1ee1cac498ae$var$K_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nre, "ShrinkTreeLayoutProvider", 1135);
$61de1ee1cac498ae$var$bcb(300, 134, {
    3: 1,
    300: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$g_c);
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$M_ = $61de1ee1cac498ae$var$mdb("org.eclipse.elk.alg.spore.graph", "Graph", 300);
$61de1ee1cac498ae$var$bcb(482, 22, {
    3: 1,
    35: 1,
    22: 1,
    482: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$k_c);
$61de1ee1cac498ae$var$_.Kf = function m_c() {
    return $61de1ee1cac498ae$var$j_c(this);
};
$61de1ee1cac498ae$var$_.Xf = function l_c() {
    return $61de1ee1cac498ae$var$j_c(this);
};
var $61de1ee1cac498ae$var$h_c;
var $61de1ee1cac498ae$var$N_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ore, $61de1ee1cac498ae$var$Sle, 482, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$o_c, $61de1ee1cac498ae$var$n_c);
var $61de1ee1cac498ae$var$p_c;
$61de1ee1cac498ae$var$bcb(551, 22, {
    3: 1,
    35: 1,
    22: 1,
    551: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$t_c);
$61de1ee1cac498ae$var$_.Kf = function v_c() {
    return new $61de1ee1cac498ae$var$I1c;
};
$61de1ee1cac498ae$var$_.Xf = function u_c() {
    return new $61de1ee1cac498ae$var$I1c;
};
var $61de1ee1cac498ae$var$r_c;
var $61de1ee1cac498ae$var$O_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ore, "OverlapRemovalStrategy", 551, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$x_c, $61de1ee1cac498ae$var$w_c);
var $61de1ee1cac498ae$var$y_c;
$61de1ee1cac498ae$var$bcb(430, 22, {
    3: 1,
    35: 1,
    22: 1,
    430: 1
}, $61de1ee1cac498ae$var$D_c);
var $61de1ee1cac498ae$var$A_c, $61de1ee1cac498ae$var$B_c;
var $61de1ee1cac498ae$var$P_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ore, "RootSelection", 430, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$F_c, $61de1ee1cac498ae$var$E_c);
var $61de1ee1cac498ae$var$G_c;
$61de1ee1cac498ae$var$bcb(316, 22, {
    3: 1,
    35: 1,
    22: 1,
    316: 1
}, $61de1ee1cac498ae$var$O_c);
var $61de1ee1cac498ae$var$I_c, $61de1ee1cac498ae$var$J_c, $61de1ee1cac498ae$var$K_c, $61de1ee1cac498ae$var$L_c, $61de1ee1cac498ae$var$M_c;
var $61de1ee1cac498ae$var$Q_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ore, "SpanningTreeCostFunction", 316, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Q_c, $61de1ee1cac498ae$var$P_c);
var $61de1ee1cac498ae$var$R_c;
$61de1ee1cac498ae$var$bcb(1002, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$f0c);
$61de1ee1cac498ae$var$_.Qe = function g0c(a) {
    $61de1ee1cac498ae$var$e0c(a);
};
var $61de1ee1cac498ae$var$T_c, $61de1ee1cac498ae$var$U_c, $61de1ee1cac498ae$var$V_c, $61de1ee1cac498ae$var$W_c, $61de1ee1cac498ae$var$X_c, $61de1ee1cac498ae$var$Y_c, $61de1ee1cac498ae$var$Z_c, $61de1ee1cac498ae$var$$_c, $61de1ee1cac498ae$var$__c, $61de1ee1cac498ae$var$a0c, $61de1ee1cac498ae$var$b0c, $61de1ee1cac498ae$var$c0c;
var $61de1ee1cac498ae$var$S_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ore, "SporeCompactionOptions", 1002);
$61de1ee1cac498ae$var$bcb(1003, 1, {}, $61de1ee1cac498ae$var$h0c);
$61de1ee1cac498ae$var$_.$e = function i0c() {
    var a;
    return a = new $61de1ee1cac498ae$var$e_c, a;
};
$61de1ee1cac498ae$var$_._e = function j0c(a) {};
var $61de1ee1cac498ae$var$R_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ore, "SporeCompactionOptions/SporeCompactionFactory", 1003);
$61de1ee1cac498ae$var$bcb(855, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$B0c);
$61de1ee1cac498ae$var$_.Qe = function C0c(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Qre), ""), "Underlying Layout Algorithm"), "A layout algorithm that is applied to the graph before it is compacted. If this is null, nothing is applied before compaction."), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$Z5c)), $61de1ee1cac498ae$var$ZI), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$L5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Vre), "structure"), "Structure Extraction Strategy"), "This option defines what kind of triangulation or other partitioning of the plane is applied to the vertices."), $61de1ee1cac498ae$var$y0c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$W_), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Rre), $61de1ee1cac498ae$var$$re), "Tree Construction Strategy"), "Whether a minimum spanning tree or a maximum spanning tree should be constructed."), $61de1ee1cac498ae$var$w0c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$X_), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Sre), $61de1ee1cac498ae$var$$re), "Cost Function for Spanning Tree"), "The cost function is used in the creation of the spanning tree."), $61de1ee1cac498ae$var$u0c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$Q_), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Tre), $61de1ee1cac498ae$var$$re), "Root node for spanning tree construction"), "The identifier of the node that is preferred as the root of the spanning tree. If this is null, the first node is chosen."), null), $61de1ee1cac498ae$var$Z5c), $61de1ee1cac498ae$var$ZI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$Tre, $61de1ee1cac498ae$var$Ure, $61de1ee1cac498ae$var$q0c);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ure), $61de1ee1cac498ae$var$$re), "Root selection for spanning tree"), "This sets the method used to select a root node for the construction of a spanning tree"), $61de1ee1cac498ae$var$s0c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$P_), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Wre), $61de1ee1cac498ae$var$Bpe), "Compaction Strategy"), "This option defines how the compaction is applied."), $61de1ee1cac498ae$var$l0c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$N_), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Xre), $61de1ee1cac498ae$var$Bpe), "Orthogonal Compaction"), "Restricts the translation of nodes to orthogonal directions in the compaction phase."), ($61de1ee1cac498ae$var$Bcb(), false)), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Yre), $61de1ee1cac498ae$var$_re), "Upper limit for iterations of overlap removal"), null), $61de1ee1cac498ae$var$meb(64)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Zre), $61de1ee1cac498ae$var$_re), "Whether to run a supplementary scanline overlap check."), null), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$K0c((new $61de1ee1cac498ae$var$L0c, a));
    $61de1ee1cac498ae$var$e0c((new $61de1ee1cac498ae$var$f0c, a));
};
var $61de1ee1cac498ae$var$k0c, $61de1ee1cac498ae$var$l0c, $61de1ee1cac498ae$var$m0c, $61de1ee1cac498ae$var$n0c, $61de1ee1cac498ae$var$o0c, $61de1ee1cac498ae$var$p0c, $61de1ee1cac498ae$var$q0c, $61de1ee1cac498ae$var$r0c, $61de1ee1cac498ae$var$s0c, $61de1ee1cac498ae$var$t0c, $61de1ee1cac498ae$var$u0c, $61de1ee1cac498ae$var$v0c, $61de1ee1cac498ae$var$w0c, $61de1ee1cac498ae$var$x0c, $61de1ee1cac498ae$var$y0c, $61de1ee1cac498ae$var$z0c;
var $61de1ee1cac498ae$var$T_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ore, "SporeMetaDataProvider", 855);
$61de1ee1cac498ae$var$bcb($61de1ee1cac498ae$var$_ie, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$L0c);
$61de1ee1cac498ae$var$_.Qe = function M0c(a) {
    $61de1ee1cac498ae$var$K0c(a);
};
var $61de1ee1cac498ae$var$D0c, $61de1ee1cac498ae$var$E0c, $61de1ee1cac498ae$var$F0c, $61de1ee1cac498ae$var$G0c, $61de1ee1cac498ae$var$H0c, $61de1ee1cac498ae$var$I0c;
var $61de1ee1cac498ae$var$V_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ore, "SporeOverlapRemovalOptions", $61de1ee1cac498ae$var$_ie);
$61de1ee1cac498ae$var$bcb(1001, 1, {}, $61de1ee1cac498ae$var$N0c);
$61de1ee1cac498ae$var$_.$e = function O0c() {
    var a;
    return a = new $61de1ee1cac498ae$var$Q$c, a;
};
$61de1ee1cac498ae$var$_._e = function P0c(a) {};
var $61de1ee1cac498ae$var$U_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Ore, "SporeOverlapRemovalOptions/SporeOverlapFactory", 1001);
$61de1ee1cac498ae$var$bcb(530, 22, {
    3: 1,
    35: 1,
    22: 1,
    530: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$T0c);
$61de1ee1cac498ae$var$_.Kf = function V0c() {
    return $61de1ee1cac498ae$var$S0c(this);
};
$61de1ee1cac498ae$var$_.Xf = function U0c() {
    return $61de1ee1cac498ae$var$S0c(this);
};
var $61de1ee1cac498ae$var$Q0c;
var $61de1ee1cac498ae$var$W_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ore, "StructureExtractionStrategy", 530, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$X0c, $61de1ee1cac498ae$var$W0c);
var $61de1ee1cac498ae$var$Y0c;
$61de1ee1cac498ae$var$bcb(429, 22, {
    3: 1,
    35: 1,
    22: 1,
    429: 1,
    246: 1,
    234: 1
}, $61de1ee1cac498ae$var$c1c);
$61de1ee1cac498ae$var$_.Kf = function e1c() {
    return $61de1ee1cac498ae$var$b1c(this);
};
$61de1ee1cac498ae$var$_.Xf = function d1c() {
    return $61de1ee1cac498ae$var$b1c(this);
};
var $61de1ee1cac498ae$var$$0c, $61de1ee1cac498ae$var$_0c;
var $61de1ee1cac498ae$var$X_ = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Ore, "TreeConstructionStrategy", 429, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$g1c, $61de1ee1cac498ae$var$f1c);
var $61de1ee1cac498ae$var$h1c;
$61de1ee1cac498ae$var$bcb(1443, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$k1c);
$61de1ee1cac498ae$var$_.Yf = function l1c(a) {
    return $61de1ee1cac498ae$var$BD(a, 300), new $61de1ee1cac498ae$var$j3c;
};
$61de1ee1cac498ae$var$_.pf = function m1c(a, b) {
    $61de1ee1cac498ae$var$j1c($61de1ee1cac498ae$var$BD(a, 300), b);
};
var $61de1ee1cac498ae$var$Z_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bse, "DelaunayTriangulationPhase", 1443);
$61de1ee1cac498ae$var$bcb(1444, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$n1c);
$61de1ee1cac498ae$var$_.td = function o1c(a) {
    $61de1ee1cac498ae$var$Ekb(this.a, $61de1ee1cac498ae$var$BD(a, 65).a);
};
var $61de1ee1cac498ae$var$Y_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$bse, "DelaunayTriangulationPhase/lambda$0$Type", 1444);
$61de1ee1cac498ae$var$bcb(783, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$s1c);
$61de1ee1cac498ae$var$_.Yf = function t1c(a) {
    return $61de1ee1cac498ae$var$BD(a, 300), new $61de1ee1cac498ae$var$j3c;
};
$61de1ee1cac498ae$var$_.pf = function u1c(a, b) {
    this.ng($61de1ee1cac498ae$var$BD(a, 300), b);
};
$61de1ee1cac498ae$var$_.ng = function v1c(a, b) {
    var c, d, e;
    $61de1ee1cac498ae$var$Odd(b, "Minimum spanning tree construction", 1);
    a.d ? d = a.d.a : d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.i, 0), 65).a;
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$XNb(), $61de1ee1cac498ae$var$VNb)))) ? e = $61de1ee1cac498ae$var$UCb(a.e, d, (c = a.b, c)) : e = $61de1ee1cac498ae$var$UCb(a.e, d, a.b);
    $61de1ee1cac498ae$var$q1c(this, e, a);
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$b0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cse, "MinSTPhase", 783);
$61de1ee1cac498ae$var$bcb(1446, 783, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$w1c);
$61de1ee1cac498ae$var$_.ng = function y1c(a, b) {
    var c, d, e, f;
    $61de1ee1cac498ae$var$Odd(b, "Maximum spanning tree construction", 1);
    c = new $61de1ee1cac498ae$var$z1c(a);
    a.d ? e = a.d.c : e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ikb(a.i, 0), 65).c;
    $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$vNb(a, ($61de1ee1cac498ae$var$XNb(), $61de1ee1cac498ae$var$VNb)))) ? f = $61de1ee1cac498ae$var$UCb(a.e, e, (d = c, d)) : f = $61de1ee1cac498ae$var$UCb(a.e, e, c);
    $61de1ee1cac498ae$var$q1c(this, f, a);
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$__ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cse, "MaxSTPhase", 1446);
$61de1ee1cac498ae$var$bcb(1447, 1, {}, $61de1ee1cac498ae$var$z1c);
$61de1ee1cac498ae$var$_.Je = function A1c(a) {
    return $61de1ee1cac498ae$var$x1c(this.a, a);
};
var $61de1ee1cac498ae$var$$_ = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cse, "MaxSTPhase/lambda$0$Type", 1447);
$61de1ee1cac498ae$var$bcb(1445, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$B1c);
$61de1ee1cac498ae$var$_.td = function C1c(a) {
    $61de1ee1cac498ae$var$r1c(this.a, $61de1ee1cac498ae$var$BD(a, 65));
};
var $61de1ee1cac498ae$var$a0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$cse, "MinSTPhase/lambda$0$Type", 1445);
$61de1ee1cac498ae$var$bcb(785, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$I1c);
$61de1ee1cac498ae$var$_.Yf = function J1c(a) {
    return $61de1ee1cac498ae$var$BD(a, 300), new $61de1ee1cac498ae$var$j3c;
};
$61de1ee1cac498ae$var$_.pf = function K1c(a, b) {
    $61de1ee1cac498ae$var$H1c(this, $61de1ee1cac498ae$var$BD(a, 300), b);
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$d0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dse, "GrowTreePhase", 785);
$61de1ee1cac498ae$var$bcb(786, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$L1c);
$61de1ee1cac498ae$var$_.td = function M1c(a) {
    $61de1ee1cac498ae$var$G1c(this.a, this.b, this.c, $61de1ee1cac498ae$var$BD(a, 221));
};
var $61de1ee1cac498ae$var$c0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dse, "GrowTreePhase/lambda$0$Type", 786);
$61de1ee1cac498ae$var$bcb(1448, 1, $61de1ee1cac498ae$var$Bqe, $61de1ee1cac498ae$var$Q1c);
$61de1ee1cac498ae$var$_.Yf = function R1c(a) {
    return $61de1ee1cac498ae$var$BD(a, 300), new $61de1ee1cac498ae$var$j3c;
};
$61de1ee1cac498ae$var$_.pf = function S1c(a, b) {
    $61de1ee1cac498ae$var$P1c(this, $61de1ee1cac498ae$var$BD(a, 300), b);
};
var $61de1ee1cac498ae$var$f0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dse, "ShrinkTreeCompactionPhase", 1448);
$61de1ee1cac498ae$var$bcb(784, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$T1c);
$61de1ee1cac498ae$var$_.td = function U1c(a) {
    $61de1ee1cac498ae$var$O1c(this.a, this.b, this.c, $61de1ee1cac498ae$var$BD(a, 221));
};
var $61de1ee1cac498ae$var$e0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$dse, "ShrinkTreeCompactionPhase/lambda$0$Type", 784);
var $61de1ee1cac498ae$var$g2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$yqe, "IGraphElementVisitor");
$61de1ee1cac498ae$var$bcb(860, 1, {
    527: 1
}, $61de1ee1cac498ae$var$b2c);
$61de1ee1cac498ae$var$_.og = function e2c(a) {
    var b;
    b = $61de1ee1cac498ae$var$a2c(this, a);
    $61de1ee1cac498ae$var$tNb(b, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ohb(this.b, a), 94));
    $61de1ee1cac498ae$var$$1c(this, a, b);
};
var $61de1ee1cac498ae$var$V1c, $61de1ee1cac498ae$var$W1c, $61de1ee1cac498ae$var$X1c;
var $61de1ee1cac498ae$var$m0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "LayoutConfigurator", 860);
var $61de1ee1cac498ae$var$h0 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Nle, "LayoutConfigurator/IPropertyHolderOptionFilter");
$61de1ee1cac498ae$var$bcb(932, 1, {
    1933: 1
}, $61de1ee1cac498ae$var$f2c);
$61de1ee1cac498ae$var$_.pg = function g2c(a, b) {
    return $61de1ee1cac498ae$var$Y1c(), !a.Xe(b);
};
var $61de1ee1cac498ae$var$i0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "LayoutConfigurator/lambda$0$Type", 932);
$61de1ee1cac498ae$var$bcb(933, 1, {
    1933: 1
}, $61de1ee1cac498ae$var$i2c);
$61de1ee1cac498ae$var$_.pg = function j2c(a, b) {
    return $61de1ee1cac498ae$var$h2c(a, b);
};
var $61de1ee1cac498ae$var$j0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "LayoutConfigurator/lambda$1$Type", 933);
$61de1ee1cac498ae$var$bcb(931, 1, {
    831: 1
}, $61de1ee1cac498ae$var$k2c);
$61de1ee1cac498ae$var$_.qg = function l2c(a, b) {
    return $61de1ee1cac498ae$var$Y1c(), !a.Xe(b);
};
var $61de1ee1cac498ae$var$k0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "LayoutConfigurator/lambda$2$Type", 931);
$61de1ee1cac498ae$var$bcb(934, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$m2c);
$61de1ee1cac498ae$var$_.Mb = function n2c(a) {
    return $61de1ee1cac498ae$var$d2c(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 1933));
};
var $61de1ee1cac498ae$var$l0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "LayoutConfigurator/lambda$3$Type", 934);
$61de1ee1cac498ae$var$bcb(858, 1, {}, $61de1ee1cac498ae$var$w2c);
var $61de1ee1cac498ae$var$n0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "RecursiveGraphLayoutEngine", 858);
$61de1ee1cac498ae$var$bcb(296, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$x2c, $61de1ee1cac498ae$var$y2c);
var $61de1ee1cac498ae$var$o0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "UnsupportedConfigurationException", 296);
$61de1ee1cac498ae$var$bcb(453, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$z2c);
var $61de1ee1cac498ae$var$p0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Nle, "UnsupportedGraphException", 453);
$61de1ee1cac498ae$var$bcb(754, 1, {});
var $61de1ee1cac498ae$var$K1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "AbstractRandomListAccessor", 754);
$61de1ee1cac498ae$var$bcb(500, 754, {}, $61de1ee1cac498ae$var$L2c);
$61de1ee1cac498ae$var$_.rg = function N2c() {
    return null;
};
$61de1ee1cac498ae$var$_.d = true;
$61de1ee1cac498ae$var$_.e = true;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$v0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "AlgorithmAssembler", 500);
$61de1ee1cac498ae$var$bcb(1236, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$O2c);
$61de1ee1cac498ae$var$_.Mb = function P2c(a) {
    return !!$61de1ee1cac498ae$var$BD(a, 123);
};
var $61de1ee1cac498ae$var$q0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "AlgorithmAssembler/lambda$0$Type", 1236);
$61de1ee1cac498ae$var$bcb(1237, 1, {}, $61de1ee1cac498ae$var$Q2c);
$61de1ee1cac498ae$var$_.Kb = function R2c(a) {
    return $61de1ee1cac498ae$var$M2c(this.a, $61de1ee1cac498ae$var$BD(a, 123));
};
var $61de1ee1cac498ae$var$r0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "AlgorithmAssembler/lambda$1$Type", 1237);
$61de1ee1cac498ae$var$bcb(1238, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$S2c);
$61de1ee1cac498ae$var$_.Mb = function T2c(a) {
    return !!$61de1ee1cac498ae$var$BD(a, 80);
};
var $61de1ee1cac498ae$var$s0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "AlgorithmAssembler/lambda$2$Type", 1238);
$61de1ee1cac498ae$var$bcb(1239, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$U2c);
$61de1ee1cac498ae$var$_.td = function V2c(a) {
    $61de1ee1cac498ae$var$d3c(this.a, $61de1ee1cac498ae$var$BD(a, 80));
};
var $61de1ee1cac498ae$var$t0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "AlgorithmAssembler/lambda$3$Type", 1239);
$61de1ee1cac498ae$var$bcb(1240, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$W2c);
$61de1ee1cac498ae$var$_.td = function X2c(a) {
    $61de1ee1cac498ae$var$G2c(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 234));
};
var $61de1ee1cac498ae$var$u0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "AlgorithmAssembler/lambda$4$Type", 1240);
$61de1ee1cac498ae$var$bcb(1355, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Z2c);
$61de1ee1cac498ae$var$_.ue = function $2c(a, b) {
    return $61de1ee1cac498ae$var$Y2c($61de1ee1cac498ae$var$BD(a, 234), $61de1ee1cac498ae$var$BD(b, 234));
};
$61de1ee1cac498ae$var$_.Fb = function _2c(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function a3c() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$w0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "EnumBasedFactoryComparator", 1355);
$61de1ee1cac498ae$var$bcb(80, 754, {
    80: 1
}, $61de1ee1cac498ae$var$j3c);
$61de1ee1cac498ae$var$_.rg = function l3c() {
    return new $61de1ee1cac498ae$var$Tqb;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$x0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$fse, "LayoutProcessorConfiguration", 80);
$61de1ee1cac498ae$var$bcb(1013, 1, {
    527: 1
}, $61de1ee1cac498ae$var$q3c);
$61de1ee1cac498ae$var$_.og = function u3c(a) {
    $61de1ee1cac498ae$var$stb($61de1ee1cac498ae$var$n3c, new $61de1ee1cac498ae$var$z3c(a));
};
var $61de1ee1cac498ae$var$m3c, $61de1ee1cac498ae$var$n3c, $61de1ee1cac498ae$var$o3c;
var $61de1ee1cac498ae$var$B0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "DeprecatedLayoutOptionReplacer", 1013);
$61de1ee1cac498ae$var$bcb(1014, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$v3c);
$61de1ee1cac498ae$var$_.td = function w3c(a) {
    $61de1ee1cac498ae$var$r3c($61de1ee1cac498ae$var$BD(a, 160));
};
var $61de1ee1cac498ae$var$y0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "DeprecatedLayoutOptionReplacer/lambda$0$Type", 1014);
$61de1ee1cac498ae$var$bcb(1015, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$x3c);
$61de1ee1cac498ae$var$_.td = function y3c(a) {
    $61de1ee1cac498ae$var$s3c($61de1ee1cac498ae$var$BD(a, 160));
};
var $61de1ee1cac498ae$var$z0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "DeprecatedLayoutOptionReplacer/lambda$1$Type", 1015);
$61de1ee1cac498ae$var$bcb(1016, 1, {}, $61de1ee1cac498ae$var$z3c);
$61de1ee1cac498ae$var$_.Od = function A3c(a, b) {
    $61de1ee1cac498ae$var$t3c(this.a, $61de1ee1cac498ae$var$BD(a, 146), $61de1ee1cac498ae$var$BD(b, 38));
};
var $61de1ee1cac498ae$var$A0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "DeprecatedLayoutOptionReplacer/lambda$2$Type", 1016);
$61de1ee1cac498ae$var$bcb(149, 1, {
    686: 1,
    149: 1
}, $61de1ee1cac498ae$var$E3c);
$61de1ee1cac498ae$var$_.Fb = function F3c(a) {
    return $61de1ee1cac498ae$var$C3c(this, a);
};
$61de1ee1cac498ae$var$_.sg = function G3c() {
    return this.b;
};
$61de1ee1cac498ae$var$_.tg = function H3c() {
    return this.c;
};
$61de1ee1cac498ae$var$_.ne = function I3c() {
    return this.e;
};
$61de1ee1cac498ae$var$_.Hb = function J3c() {
    return $61de1ee1cac498ae$var$LCb(this.c);
};
$61de1ee1cac498ae$var$_.Ib = function K3c() {
    return "Layout Algorithm: " + this.c;
};
var $61de1ee1cac498ae$var$E0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutAlgorithmData", 149);
$61de1ee1cac498ae$var$bcb(263, 1, {}, $61de1ee1cac498ae$var$R3c);
var $61de1ee1cac498ae$var$D0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutAlgorithmData/Builder", 263);
$61de1ee1cac498ae$var$bcb(1017, 1, {
    527: 1
}, $61de1ee1cac498ae$var$U3c);
$61de1ee1cac498ae$var$_.og = function V3c(a) {
    $61de1ee1cac498ae$var$JD(a, 239) && !$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(a.We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$d9c)))) && $61de1ee1cac498ae$var$S3c($61de1ee1cac498ae$var$BD(a, 33));
};
var $61de1ee1cac498ae$var$F0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutAlgorithmResolver", 1017);
$61de1ee1cac498ae$var$bcb(229, 1, {
    686: 1,
    229: 1
}, $61de1ee1cac498ae$var$W3c);
$61de1ee1cac498ae$var$_.Fb = function X3c(a) {
    if ($61de1ee1cac498ae$var$JD(a, 229)) return $61de1ee1cac498ae$var$dfb(this.b, $61de1ee1cac498ae$var$BD(a, 229).b);
    return false;
};
$61de1ee1cac498ae$var$_.sg = function Y3c() {
    return this.a;
};
$61de1ee1cac498ae$var$_.tg = function Z3c() {
    return this.b;
};
$61de1ee1cac498ae$var$_.ne = function $3c() {
    return this.d;
};
$61de1ee1cac498ae$var$_.Hb = function _3c() {
    return $61de1ee1cac498ae$var$LCb(this.b);
};
$61de1ee1cac498ae$var$_.Ib = function a4c() {
    return "Layout Type: " + this.b;
};
var $61de1ee1cac498ae$var$H0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutCategoryData", 229);
$61de1ee1cac498ae$var$bcb(344, 1, {}, $61de1ee1cac498ae$var$e4c);
var $61de1ee1cac498ae$var$G0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutCategoryData/Builder", 344);
$61de1ee1cac498ae$var$bcb(867, 1, {}, $61de1ee1cac498ae$var$m4c);
var $61de1ee1cac498ae$var$f4c;
var $61de1ee1cac498ae$var$c1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService", 867);
$61de1ee1cac498ae$var$bcb(868, 1, {}, $61de1ee1cac498ae$var$v4c);
var $61de1ee1cac498ae$var$J0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/Registry", 868);
$61de1ee1cac498ae$var$bcb(478, 1, {
    478: 1
}, $61de1ee1cac498ae$var$w4c);
var $61de1ee1cac498ae$var$I0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/Registry/Triple", 478);
$61de1ee1cac498ae$var$bcb(869, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$x4c);
$61de1ee1cac498ae$var$_.ug = function y4c() {
    return new $61de1ee1cac498ae$var$d7c;
};
var $61de1ee1cac498ae$var$K0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$0$Type", 869);
$61de1ee1cac498ae$var$bcb(870, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$z4c);
$61de1ee1cac498ae$var$_.vg = function A4c(a) {
    return $61de1ee1cac498ae$var$R6c($61de1ee1cac498ae$var$BD(a, 8));
};
var $61de1ee1cac498ae$var$L0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$1$Type", 870);
$61de1ee1cac498ae$var$bcb(879, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$B4c);
$61de1ee1cac498ae$var$_.ug = function C4c() {
    return new $61de1ee1cac498ae$var$Rkb;
};
var $61de1ee1cac498ae$var$M0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$10$Type", 879);
$61de1ee1cac498ae$var$bcb(880, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$D4c);
$61de1ee1cac498ae$var$_.vg = function E4c(a) {
    return new $61de1ee1cac498ae$var$Tkb($61de1ee1cac498ae$var$BD(a, 12));
};
var $61de1ee1cac498ae$var$N0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$11$Type", 880);
$61de1ee1cac498ae$var$bcb(881, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$F4c);
$61de1ee1cac498ae$var$_.ug = function G4c() {
    return new $61de1ee1cac498ae$var$Psb;
};
var $61de1ee1cac498ae$var$O0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$12$Type", 881);
$61de1ee1cac498ae$var$bcb(882, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$H4c);
$61de1ee1cac498ae$var$_.vg = function I4c(a) {
    return $61de1ee1cac498ae$var$Ru($61de1ee1cac498ae$var$BD(a, 68));
};
var $61de1ee1cac498ae$var$P0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$13$Type", 882);
$61de1ee1cac498ae$var$bcb(883, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$J4c);
$61de1ee1cac498ae$var$_.ug = function K4c() {
    return new $61de1ee1cac498ae$var$Tqb;
};
var $61de1ee1cac498ae$var$Q0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$14$Type", 883);
$61de1ee1cac498ae$var$bcb(884, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$L4c);
$61de1ee1cac498ae$var$_.vg = function M4c(a) {
    return $61de1ee1cac498ae$var$Dx($61de1ee1cac498ae$var$BD(a, 53));
};
var $61de1ee1cac498ae$var$R0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$15$Type", 884);
$61de1ee1cac498ae$var$bcb(885, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$N4c);
$61de1ee1cac498ae$var$_.ug = function O4c() {
    return new $61de1ee1cac498ae$var$zsb;
};
var $61de1ee1cac498ae$var$S0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$16$Type", 885);
$61de1ee1cac498ae$var$bcb(886, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$P4c);
$61de1ee1cac498ae$var$_.vg = function Q4c(a) {
    return $61de1ee1cac498ae$var$Gx($61de1ee1cac498ae$var$BD(a, 53));
};
var $61de1ee1cac498ae$var$T0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$17$Type", 886);
$61de1ee1cac498ae$var$bcb(887, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$R4c);
$61de1ee1cac498ae$var$_.ug = function S4c() {
    return new $61de1ee1cac498ae$var$Gxb;
};
var $61de1ee1cac498ae$var$U0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$18$Type", 887);
$61de1ee1cac498ae$var$bcb(888, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$T4c);
$61de1ee1cac498ae$var$_.vg = function U4c(a) {
    return $61de1ee1cac498ae$var$Hx($61de1ee1cac498ae$var$BD(a, 208));
};
var $61de1ee1cac498ae$var$V0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$19$Type", 888);
$61de1ee1cac498ae$var$bcb(871, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$V4c);
$61de1ee1cac498ae$var$_.ug = function W4c() {
    return new $61de1ee1cac498ae$var$s7c;
};
var $61de1ee1cac498ae$var$W0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$2$Type", 871);
$61de1ee1cac498ae$var$bcb(872, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$X4c);
$61de1ee1cac498ae$var$_.vg = function Y4c(a) {
    return new $61de1ee1cac498ae$var$t7c($61de1ee1cac498ae$var$BD(a, 74));
};
var $61de1ee1cac498ae$var$X0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$3$Type", 872);
$61de1ee1cac498ae$var$bcb(873, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$Z4c);
$61de1ee1cac498ae$var$_.ug = function $4c() {
    return new $61de1ee1cac498ae$var$H_b;
};
var $61de1ee1cac498ae$var$Y0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$4$Type", 873);
$61de1ee1cac498ae$var$bcb(874, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$_4c);
$61de1ee1cac498ae$var$_.vg = function a5c(a) {
    return new $61de1ee1cac498ae$var$K_b($61de1ee1cac498ae$var$BD(a, 142));
};
var $61de1ee1cac498ae$var$Z0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$5$Type", 874);
$61de1ee1cac498ae$var$bcb(875, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$b5c);
$61de1ee1cac498ae$var$_.ug = function c5c() {
    return new $61de1ee1cac498ae$var$p0b;
};
var $61de1ee1cac498ae$var$$0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$6$Type", 875);
$61de1ee1cac498ae$var$bcb(876, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$d5c);
$61de1ee1cac498ae$var$_.vg = function e5c(a) {
    return new $61de1ee1cac498ae$var$r0b($61de1ee1cac498ae$var$BD(a, 116));
};
var $61de1ee1cac498ae$var$_0 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$7$Type", 876);
$61de1ee1cac498ae$var$bcb(877, 1, $61de1ee1cac498ae$var$gse, $61de1ee1cac498ae$var$f5c);
$61de1ee1cac498ae$var$_.ug = function g5c() {
    return new $61de1ee1cac498ae$var$_fd;
};
var $61de1ee1cac498ae$var$a1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$8$Type", 877);
$61de1ee1cac498ae$var$bcb(878, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$h5c);
$61de1ee1cac498ae$var$_.vg = function i5c(a) {
    return new $61de1ee1cac498ae$var$agd($61de1ee1cac498ae$var$BD(a, 373));
};
var $61de1ee1cac498ae$var$b1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutMetaDataService/lambda$9$Type", 878);
var $61de1ee1cac498ae$var$Q3 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Hle, "IProperty");
$61de1ee1cac498ae$var$bcb(23, 1, {
    35: 1,
    686: 1,
    23: 1,
    146: 1
}, $61de1ee1cac498ae$var$p5c);
$61de1ee1cac498ae$var$_.wd = function q5c(a) {
    return $61de1ee1cac498ae$var$k5c(this, $61de1ee1cac498ae$var$BD(a, 146));
};
$61de1ee1cac498ae$var$_.Fb = function r5c(a) {
    return $61de1ee1cac498ae$var$JD(a, 23) ? $61de1ee1cac498ae$var$dfb(this.f, $61de1ee1cac498ae$var$BD(a, 23).f) : $61de1ee1cac498ae$var$JD(a, 146) && $61de1ee1cac498ae$var$dfb(this.f, $61de1ee1cac498ae$var$BD(a, 146).tg());
};
$61de1ee1cac498ae$var$_.wg = function s5c() {
    var a;
    if ($61de1ee1cac498ae$var$JD(this.b, 4)) {
        a = $61de1ee1cac498ae$var$fvd(this.b);
        if (a == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb($61de1ee1cac498ae$var$mse + this.f + "'. " + "Make sure it's type is registered with the " + ($61de1ee1cac498ae$var$fdb($61de1ee1cac498ae$var$Y3), $61de1ee1cac498ae$var$Y3.k) + $61de1ee1cac498ae$var$jse));
        return a;
    } else return this.b;
};
$61de1ee1cac498ae$var$_.sg = function t5c() {
    return this.d;
};
$61de1ee1cac498ae$var$_.tg = function u5c() {
    return this.f;
};
$61de1ee1cac498ae$var$_.ne = function v5c() {
    return this.i;
};
$61de1ee1cac498ae$var$_.Hb = function w5c() {
    return $61de1ee1cac498ae$var$LCb(this.f);
};
$61de1ee1cac498ae$var$_.Ib = function x5c() {
    return "Layout Option: " + this.f;
};
var $61de1ee1cac498ae$var$g1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutOptionData", 23);
$61de1ee1cac498ae$var$bcb(24, 1, {}, $61de1ee1cac498ae$var$H5c);
var $61de1ee1cac498ae$var$d1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Xke, "LayoutOptionData/Builder", 24);
$61de1ee1cac498ae$var$bcb(175, 22, {
    3: 1,
    35: 1,
    22: 1,
    175: 1
}, $61de1ee1cac498ae$var$O5c);
var $61de1ee1cac498ae$var$I5c, $61de1ee1cac498ae$var$J5c, $61de1ee1cac498ae$var$K5c, $61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$M5c;
var $61de1ee1cac498ae$var$e1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Xke, "LayoutOptionData/Target", 175, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Q5c, $61de1ee1cac498ae$var$P5c);
var $61de1ee1cac498ae$var$R5c;
$61de1ee1cac498ae$var$bcb(277, 22, {
    3: 1,
    35: 1,
    22: 1,
    277: 1
}, $61de1ee1cac498ae$var$a6c);
var $61de1ee1cac498ae$var$T5c, $61de1ee1cac498ae$var$U5c, $61de1ee1cac498ae$var$V5c, $61de1ee1cac498ae$var$W5c, $61de1ee1cac498ae$var$X5c, $61de1ee1cac498ae$var$Y5c, $61de1ee1cac498ae$var$Z5c, $61de1ee1cac498ae$var$$5c;
var $61de1ee1cac498ae$var$f1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Xke, "LayoutOptionData/Type", 277, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$c6c, $61de1ee1cac498ae$var$b6c);
var $61de1ee1cac498ae$var$d6c;
var $61de1ee1cac498ae$var$f6c;
var $61de1ee1cac498ae$var$h6c;
$61de1ee1cac498ae$var$bcb(110, 1, {
    110: 1
}, $61de1ee1cac498ae$var$I6c, $61de1ee1cac498ae$var$J6c, $61de1ee1cac498ae$var$K6c);
$61de1ee1cac498ae$var$_.Fb = function L6c(a) {
    var b;
    if (a == null || !$61de1ee1cac498ae$var$JD(a, 110)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 110);
    return $61de1ee1cac498ae$var$wtb(this.c, b.c) && $61de1ee1cac498ae$var$wtb(this.d, b.d) && $61de1ee1cac498ae$var$wtb(this.b, b.b) && $61de1ee1cac498ae$var$wtb(this.a, b.a);
};
$61de1ee1cac498ae$var$_.Hb = function M6c() {
    return $61de1ee1cac498ae$var$Hlb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        this.c,
        this.d,
        this.b,
        this.a
    ]));
};
$61de1ee1cac498ae$var$_.Ib = function N6c() {
    return "Rect[x=" + this.c + ",y=" + this.d + ",w=" + this.b + ",h=" + this.a + "]";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$k1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$pne, "ElkRectangle", 110);
$61de1ee1cac498ae$var$bcb(8, 1, {
    3: 1,
    4: 1,
    8: 1,
    414: 1
}, $61de1ee1cac498ae$var$d7c, $61de1ee1cac498ae$var$e7c, $61de1ee1cac498ae$var$f7c, $61de1ee1cac498ae$var$g7c);
$61de1ee1cac498ae$var$_.Fb = function h7c(a) {
    return $61de1ee1cac498ae$var$T6c(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function i7c() {
    return $61de1ee1cac498ae$var$Hdb(this.a) + $61de1ee1cac498ae$var$jeb($61de1ee1cac498ae$var$Hdb(this.b));
};
$61de1ee1cac498ae$var$_.Jf = function k7c(b) {
    var c, d, e, f;
    e = 0;
    while(e < b.length && $61de1ee1cac498ae$var$j7c(($61de1ee1cac498ae$var$BCb(e, b.length), b.charCodeAt(e)), $61de1ee1cac498ae$var$mne))++e;
    c = b.length;
    while(c > 0 && $61de1ee1cac498ae$var$j7c(($61de1ee1cac498ae$var$BCb(c - 1, b.length), b.charCodeAt(c - 1)), $61de1ee1cac498ae$var$nne))--c;
    if (e >= c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The given string does not contain any numbers."));
    f = $61de1ee1cac498ae$var$mfb(b.substr(e, c - e), ",|;|\r|\n");
    if (f.length != 2) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Exactly two numbers are expected, " + f.length + " were found."));
    try {
        this.a = $61de1ee1cac498ae$var$Hcb($61de1ee1cac498ae$var$ufb(f[0]));
        this.b = $61de1ee1cac498ae$var$Hcb($61de1ee1cac498ae$var$ufb(f[1]));
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 127)) {
            d = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$one + d));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.Ib = function m7c() {
    return "(" + this.a + "," + this.b + ")";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$m1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$pne, "KVector", 8);
$61de1ee1cac498ae$var$bcb(74, 68, {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    68: 1,
    15: 1,
    74: 1,
    414: 1
}, $61de1ee1cac498ae$var$s7c, $61de1ee1cac498ae$var$t7c, $61de1ee1cac498ae$var$u7c);
$61de1ee1cac498ae$var$_.Pc = function x7c() {
    return $61de1ee1cac498ae$var$r7c(this);
};
$61de1ee1cac498ae$var$_.Jf = function v7c(b) {
    var c, d, e, f, g, h;
    e = $61de1ee1cac498ae$var$mfb(b, ",|;|\\(|\\)|\\[|\\]|\\{|\\}| |	|\n");
    $61de1ee1cac498ae$var$Osb(this);
    try {
        d = 0;
        g = 0;
        f = 0;
        h = 0;
        while(d < e.length){
            if (e[d] != null && $61de1ee1cac498ae$var$ufb(e[d]).length > 0) {
                g % 2 == 0 ? f = $61de1ee1cac498ae$var$Hcb(e[d]) : h = $61de1ee1cac498ae$var$Hcb(e[d]);
                g > 0 && g % 2 != 0 && $61de1ee1cac498ae$var$Dsb(this, new $61de1ee1cac498ae$var$f7c(f, h));
                ++g;
            }
            ++d;
        }
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 127)) {
            c = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("The given string does not match the expected format for vectors." + c));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.Ib = function y7c() {
    var a, b, c;
    a = new $61de1ee1cac498ae$var$Wfb("(");
    b = $61de1ee1cac498ae$var$Jsb(this, 0);
    while(b.b != b.d.c){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xsb(b), 8);
        $61de1ee1cac498ae$var$Qfb(a, c.a + "," + c.b);
        b.b != b.d.c && (a.a += "; ", a);
    }
    return (a.a += ")", a).a;
};
var $61de1ee1cac498ae$var$l1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$pne, "KVectorChain", 74);
$61de1ee1cac498ae$var$bcb(248, 22, {
    3: 1,
    35: 1,
    22: 1,
    248: 1
}, $61de1ee1cac498ae$var$G7c);
var $61de1ee1cac498ae$var$z7c, $61de1ee1cac498ae$var$A7c, $61de1ee1cac498ae$var$B7c, $61de1ee1cac498ae$var$C7c, $61de1ee1cac498ae$var$D7c, $61de1ee1cac498ae$var$E7c;
var $61de1ee1cac498ae$var$o1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "Alignment", 248, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$I7c, $61de1ee1cac498ae$var$H7c);
var $61de1ee1cac498ae$var$J7c;
$61de1ee1cac498ae$var$bcb(979, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$Z7c);
$61de1ee1cac498ae$var$_.Qe = function $7c(a) {
    $61de1ee1cac498ae$var$Y7c(a);
};
var $61de1ee1cac498ae$var$L7c, $61de1ee1cac498ae$var$M7c, $61de1ee1cac498ae$var$N7c, $61de1ee1cac498ae$var$O7c, $61de1ee1cac498ae$var$P7c, $61de1ee1cac498ae$var$Q7c, $61de1ee1cac498ae$var$R7c, $61de1ee1cac498ae$var$S7c, $61de1ee1cac498ae$var$T7c, $61de1ee1cac498ae$var$U7c, $61de1ee1cac498ae$var$V7c, $61de1ee1cac498ae$var$W7c;
var $61de1ee1cac498ae$var$q1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ose, "BoxLayouterOptions", 979);
$61de1ee1cac498ae$var$bcb(980, 1, {}, $61de1ee1cac498ae$var$_7c);
$61de1ee1cac498ae$var$_.$e = function a8c() {
    var a;
    return a = new $61de1ee1cac498ae$var$ged, a;
};
$61de1ee1cac498ae$var$_._e = function b8c(a) {};
var $61de1ee1cac498ae$var$p1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ose, "BoxLayouterOptions/BoxFactory", 980);
$61de1ee1cac498ae$var$bcb(291, 22, {
    3: 1,
    35: 1,
    22: 1,
    291: 1
}, $61de1ee1cac498ae$var$j8c);
var $61de1ee1cac498ae$var$c8c, $61de1ee1cac498ae$var$d8c, $61de1ee1cac498ae$var$e8c, $61de1ee1cac498ae$var$f8c, $61de1ee1cac498ae$var$g8c, $61de1ee1cac498ae$var$h8c;
var $61de1ee1cac498ae$var$r1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "ContentAlignment", 291, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$l8c, $61de1ee1cac498ae$var$k8c);
var $61de1ee1cac498ae$var$m8c;
$61de1ee1cac498ae$var$bcb(684, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$Z9c);
$61de1ee1cac498ae$var$_.Qe = function $9c(a) {
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$sse), ""), "Layout Algorithm"), "Select a specific layout algorithm."), ($61de1ee1cac498ae$var$_5c(), $61de1ee1cac498ae$var$Z5c)), $61de1ee1cac498ae$var$ZI), $61de1ee1cac498ae$var$pqb(($61de1ee1cac498ae$var$N5c(), $61de1ee1cac498ae$var$L5c)))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$tse), ""), "Resolved Layout Algorithm"), "Meta data associated with the selected algorithm."), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$E0), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$$pe), ""), "Alignment"), "Alignment of the selected node relative to other nodes; the exact meaning depends on the used algorithm."), $61de1ee1cac498ae$var$q8c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$o1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$_le), ""), "Aspect Ratio"), "The desired aspect ratio of the drawing, that is the quotient of width by height."), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$use), ""), "Bend Points"), "A fixed list of bend points for the edge. This is used by the 'Fixed Layout' algorithm to specify a pre-defined routing for an edge. The vector chain must include the source point, any bend points, and the target point, so it must have at least two points."), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$l1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$lqe), ""), "Content Alignment"), "Specifies how the content of a node are aligned. Each node can individually control the alignment of its contents. I.e. if a node should be aligned top left in its parent node, the parent node should specify that option."), $61de1ee1cac498ae$var$x8c), $61de1ee1cac498ae$var$W5c), $61de1ee1cac498ae$var$r1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Zpe), ""), "Debug Mode"), "Whether additional debug information shall be generated."), ($61de1ee1cac498ae$var$Bcb(), false)), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$cqe), ""), $61de1ee1cac498ae$var$Cle), "Overall direction of edges: horizontal (right / left) or vertical (down / up)."), $61de1ee1cac498ae$var$A8c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$t1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ype), ""), "Edge Routing"), "What kind of edge routing style should be applied for the content of a parent node. Algorithms may also set this option to single edges in order to mark them as splines. The bend point list of edges with this option set to SPLINES must be interpreted as control points for a piecewise cubic spline."), $61de1ee1cac498ae$var$F8c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$v1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Jre), ""), "Expand Nodes"), "If active, nodes are expanded to fill the area of their parent."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$tpe), ""), "Hierarchy Handling"), "Determines whether separate layout runs are triggered for different compound nodes in a hierarchical graph. Setting a node's hierarchy handling to `INCLUDE_CHILDREN` will lay out that node and all of its descendants in a single layout run, until a descendant is encountered which has its hierarchy handling set to `SEPARATE_CHILDREN`. In general, `SEPARATE_CHILDREN` will ensure that a new layout run is triggered for a node with that setting. Including multiple levels of hierarchy in a single layout run may allow cross-hierarchical edges to be laid out properly. If the root node is set to `INHERIT` (or not set at all), the default behavior is `SEPARATE_CHILDREN`."), $61de1ee1cac498ae$var$K8c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$z1), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$K5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$ame), ""), "Padding"), "The padding to be left to a parent element's border when placing child elements. This can also serve as an output option of a layout algorithm if node size calculation is setup appropriately."), $61de1ee1cac498ae$var$g9c), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$j1), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$K5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ame), ""), "Interactive"), "Whether the algorithm should be run in interactive mode for the content of a parent node. What this means exactly depends on how the specific algorithm interprets this option. Usually in the interactive mode algorithms try to modify the current layout as little as possible."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$xqe), ""), "interactive Layout"), "Whether the graph should be changeable interactively and by setting constraints"), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Dme), ""), "Omit Node Micro Layout"), "Node micro layout comprises the computation of node dimensions (if requested), the placement of ports and their labels, and the placement of node labels. The functionality is implemented independent of any specific layout algorithm and shouldn't have any negative impact on the layout algorithm's performance itself. Yet, if any unforeseen behavior occurs, this option allows to deactivate the micro layout."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Bme), ""), "Port Constraints"), "Defines constraints of the position of the ports of a node."), $61de1ee1cac498ae$var$u9c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$D1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$uqe), ""), "Position"), "The position of a node, port, or label. This is used by the 'Fixed Layout' algorithm to specify a pre-defined position."), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$m1), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$K5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$M5c,
        $61de1ee1cac498ae$var$J5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$vme), ""), "Priority"), "Defines the priority of an object; its meaning depends on the specific layout algorithm and the context where it is used."), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$K5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$I5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$yme), ""), "Randomization Seed"), "Seed used for pseudo-random number generators to control the layout algorithm. If the value is 0, the seed shall be determined pseudo-randomly (e.g. from the system time)."), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$zme), ""), "Separate Connected Components"), "Whether each connected component should be processed separately."), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$mqe), ""), "Junction Points"), "This option is not used as option, but as output of the layout algorithms. It is attached to edges and determines the points where junction symbols should be drawn in order to represent hyperedges with orthogonal routing. Whether such points are computed depends on the chosen layout algorithm and edge routing style. The points are put into the vector chain with no specific order."), $61de1ee1cac498ae$var$R8c), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$l1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$pqe), ""), "Comment Box"), "Whether the node should be regarded as a comment box instead of a regular node. In that case its placement should be similar to how labels are handled. Any edges incident to a comment box specify to which graph elements the comment is related."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$qqe), ""), "Hypernode"), "Whether the node should be handled as a hypernode."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$vse), ""), "Label Manager"), "Label managers can shorten labels upon a layout algorithm's request."), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$h1), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$J5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$vqe), ""), "Margins"), "Margins define additional space around the actual bounds of a graph element. For instance, ports or labels being placed on the outside of a node's border might introduce such a margin. The margin is used to guarantee non-overlap of other graph elements with those ports or labels."), $61de1ee1cac498ae$var$T8c), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$i1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Xpe), ""), "No Layout"), "No layout is done for the associated element. This is used to mark parts of a diagram to avoid their inclusion in the layout graph, or to mark parts of the layout graph to prevent layout engines from processing them. If you wish to exclude the contents of a compound node from automatic layout, while the node itself is still considered on its own layer, use the 'Fixed Layout' algorithm for that node."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$K5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$I5c,
        $61de1ee1cac498ae$var$M5c,
        $61de1ee1cac498ae$var$J5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$wse), ""), "Scale Factor"), "The scaling factor to be applied to the corresponding node in recursive layout. It causes the corresponding node's size to be adjusted, and its ports and labels to be sized and placed accordingly after the layout of that node has been determined (and before the node itself and its siblings are arranged). The scaling is not reverted afterwards, so the resulting layout graph contains the adjusted size and position data. This option is currently not supported if 'Layout Hierarchy' is set."), 1), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$xse), ""), "Animate"), "Whether the shift from the old layout to the new computed layout shall be animated."), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$yse), ""), "Animation Time Factor"), "Factor for computation of animation time. The higher the value, the longer the animation time. If the value is 0, the resulting time is always equal to the minimum defined by 'Minimal Animation Time'."), $61de1ee1cac498ae$var$meb(100)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$zse), ""), "Layout Ancestors"), "Whether the hierarchy levels on the path from the selected element to the root of the diagram shall be included in the layout process."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ase), ""), "Maximal Animation Time"), "The maximal time for animations, in milliseconds."), $61de1ee1cac498ae$var$meb(4000)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Bse), ""), "Minimal Animation Time"), "The minimal time for animations, in milliseconds."), $61de1ee1cac498ae$var$meb(400)), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Cse), ""), "Progress Bar"), "Whether a progress bar shall be displayed during layout computations."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Dse), ""), "Validate Graph"), "Whether the graph shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ese), ""), "Validate Options"), "Whether layout options shall be validated before any layout algorithm is applied. If this option is enabled and at least one error is found, the layout process is aborted and a message is shown to the user."), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Fse), ""), "Zoom to Fit"), "Whether the zoom level shall be set to view the whole diagram after layout."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$rse), "box"), "Box Layout Mode"), "Configures the packing mode used by the {@link BoxLayoutProvider}. If SIMPLE is not required (neither priorities are used nor the interactive mode), GROUP_DEC can improve the packing and decrease the area. GROUP_MIXED and GROUP_INC may, in very specific scenarios, work better."), $61de1ee1cac498ae$var$u8c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$O1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Lpe), $61de1ee1cac498ae$var$zpe), "Comment Comment Spacing"), "Spacing to be preserved between a comment box and other comment boxes connected to the same node. The space left between comment boxes of different nodes is controlled by the node-node spacing."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Mpe), $61de1ee1cac498ae$var$zpe), "Comment Node Spacing"), "Spacing to be preserved between a node and its connected comment boxes. The space left between a node and the comments of another node is controlled by the node-node spacing."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Zle), $61de1ee1cac498ae$var$zpe), "Components Spacing"), "Spacing to be preserved between pairs of connected components. This option is only relevant if 'separateConnectedComponents' is activated."), 20), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Npe), $61de1ee1cac498ae$var$zpe), "Edge Spacing"), "Spacing to be preserved between any two edges. Note that while this can somewhat easily be satisfied for the segments of orthogonally drawn edges, it is harder for general polylines or splines."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$xme), $61de1ee1cac498ae$var$zpe), "Edge Label Spacing"), "The minimal distance to be preserved between a label and the edge it is associated with. Note that the placement of a label is influenced by the 'edgelabels.placement' option."), 2), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ope), $61de1ee1cac498ae$var$zpe), "Edge Node Spacing"), "Spacing to be preserved between nodes and edges."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ppe), $61de1ee1cac498ae$var$zpe), "Label Spacing"), "Determines the amount of space to be left between two labels of the same graph element."), 0), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Spe), $61de1ee1cac498ae$var$zpe), "Label Node Spacing"), "Spacing to be preserved between labels and the border of node they are associated with. Note that the placement of a label is influenced by the 'nodelabels.placement' option."), 5), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Qpe), $61de1ee1cac498ae$var$zpe), "Horizontal spacing between Label and Port"), "Horizontal spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Rpe), $61de1ee1cac498ae$var$zpe), "Vertical spacing between Label and Port"), "Vertical spacing to be preserved between labels and the ports they are associated with. Note that the placement of a label is influenced by the 'portlabels.placement' option."), 1), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$wme), $61de1ee1cac498ae$var$zpe), "Node Spacing"), "The minimal distance to be preserved between each two nodes."), 20), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Tpe), $61de1ee1cac498ae$var$zpe), "Node Self Loop Spacing"), "Spacing to be preserved between a node and its self loops."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Upe), $61de1ee1cac498ae$var$zpe), "Port Spacing"), "Spacing between pairs of ports of the same node."), 10), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$K5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Vpe), $61de1ee1cac498ae$var$zpe), "Individual Spacing"), "Allows to specify individual spacing values for graph elements that shall be different from the value specified for the element's parent."), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$i2), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$K5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$I5c,
        $61de1ee1cac498ae$var$M5c,
        $61de1ee1cac498ae$var$J5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$wqe), $61de1ee1cac498ae$var$zpe), "Additional Port Space"), "Additional space around the sets of ports on each node side. For each side of a node, this option can reserve additional space before and after the ports on each side. For example, a top spacing of 20 makes sure that the first port on the western and eastern side is 20 units away from the northern border."), $61de1ee1cac498ae$var$W9c), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$i1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$tqe), $61de1ee1cac498ae$var$Jse), "Layout Partition"), "Partition to which the node belongs. This requires Layout Partitioning to be active. Nodes with lower partition IDs will appear to the left of nodes with higher partition IDs (assuming a left-to-right layout direction)."), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$L5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$K5c
    ])))));
    $61de1ee1cac498ae$var$o4c(a, $61de1ee1cac498ae$var$tqe, $61de1ee1cac498ae$var$sqe, $61de1ee1cac498ae$var$k9c);
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$sqe), $61de1ee1cac498ae$var$Jse), "Layout Partitioning"), "Whether to activate partitioned layout. This will allow to group nodes through the Layout Partition option. a pair of nodes with different partition indices is then placed such that the node with lower index is placed to the left of the other node (with left-to-right layout direction). Depending on the layout algorithm, this may only be guaranteed to work if all nodes have a layout partition configured, or at least if edges that cross partitions are not part of a partition-crossing cycle."), $61de1ee1cac498ae$var$i9c), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$dqe), $61de1ee1cac498ae$var$Kse), "Node Label Padding"), "Define padding for node labels that are placed inside of a node."), $61de1ee1cac498ae$var$V8c), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$j1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Gme), $61de1ee1cac498ae$var$Kse), "Node Label Placement"), "Hints for where node labels are to be placed; if empty, the node label's position is not modified."), $61de1ee1cac498ae$var$X8c), $61de1ee1cac498ae$var$W5c), $61de1ee1cac498ae$var$B1), $61de1ee1cac498ae$var$qqb($61de1ee1cac498ae$var$K5c, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$e1, 1), $61de1ee1cac498ae$var$Kie, 175, 0, [
        $61de1ee1cac498ae$var$J5c
    ])))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$gqe), $61de1ee1cac498ae$var$Lse), "Port Alignment"), "Defines the default port distribution for a node. May be overridden for each side individually."), $61de1ee1cac498ae$var$m9c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$C1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$hqe), $61de1ee1cac498ae$var$Lse), "Port Alignment (North)"), "Defines how ports on the northern side are placed, overriding the node's general port alignment."), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$C1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$iqe), $61de1ee1cac498ae$var$Lse), "Port Alignment (South)"), "Defines how ports on the southern side are placed, overriding the node's general port alignment."), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$C1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$jqe), $61de1ee1cac498ae$var$Lse), "Port Alignment (West)"), "Defines how ports on the western side are placed, overriding the node's general port alignment."), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$C1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$kqe), $61de1ee1cac498ae$var$Lse), "Port Alignment (East)"), "Defines how ports on the eastern side are placed, overriding the node's general port alignment."), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$C1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Fme), $61de1ee1cac498ae$var$Mse), "Node Size Constraints"), "What should be taken into account when calculating a node's size. Empty size constraints specify that a node's size is already fixed and should not be changed."), $61de1ee1cac498ae$var$Z8c), $61de1ee1cac498ae$var$W5c), $61de1ee1cac498ae$var$I1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Eme), $61de1ee1cac498ae$var$Mse), "Node Size Options"), "Options modifying the behavior of the size constraints set on a node. Each member of the set specifies something that should be taken into account when calculating node sizes. The empty set corresponds to no further modifications."), $61de1ee1cac498ae$var$c9c), $61de1ee1cac498ae$var$W5c), $61de1ee1cac498ae$var$J1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Tme), $61de1ee1cac498ae$var$Mse), "Node Size Minimum"), "The minimal size to which a node can be reduced."), $61de1ee1cac498ae$var$a9c), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$m1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$bqe), $61de1ee1cac498ae$var$Mse), "Fixed Graph Size"), "By default, the fixed layout provider will enlarge a graph until it is large enough to contain its children. If this option is set, it won't do so."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$L5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$nqe), $61de1ee1cac498ae$var$Jpe), "Edge Label Placement"), "Gives a hint on where to put edge labels."), $61de1ee1cac498ae$var$D8c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$u1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$J5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Cme), $61de1ee1cac498ae$var$Jpe), "Inline Edge Labels"), "If true, an edge label is placed directly on its edge. May only apply to center edge labels. This kind of label placement is only advisable if the label's rendering is such that it is not crossed by its edge and thus stays legible."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$J5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Gse), "font"), "Font Name"), "Font name used for a label."), $61de1ee1cac498ae$var$Z5c), $61de1ee1cac498ae$var$ZI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$J5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Hse), "font"), "Font Size"), "Font size used for a label."), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$J5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$rqe), $61de1ee1cac498ae$var$Nse), "Port Anchor Offset"), "The offset to the port position where connections shall be attached."), $61de1ee1cac498ae$var$Y5c), $61de1ee1cac498ae$var$m1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$M5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$oqe), $61de1ee1cac498ae$var$Nse), "Port Index"), "The index of a port in the fixed order around a node. The order is assumed as clockwise, starting with the leftmost port on the top side. This option must be set if 'Port Constraints' is set to FIXED_ORDER and no specific positions are given for the ports. Additionally, the option 'Port Side' must be defined in this case."), $61de1ee1cac498ae$var$X5c), $61de1ee1cac498ae$var$JI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$M5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ype), $61de1ee1cac498ae$var$Nse), "Port Side"), "The side of a node on which a port is situated. This option must be set if 'Port Constraints' is set to FIXED_SIDE or FIXED_ORDER and no specific positions are given for the ports."), $61de1ee1cac498ae$var$B9c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$F1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$M5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Wpe), $61de1ee1cac498ae$var$Nse), "Port Border Offset"), "The offset of ports on the node border. With a positive offset the port is moved outside of the node, while with a negative offset the port is moved towards the inside. An offset of 0 means that the port is placed directly on the node border, i.e. if the port side is north, the port's south border touches the nodes's north border; if the port side is east, the port's west border touches the nodes's east border; if the port side is south, the port's north border touches the node's south border; if the port side is west, the port's east border touches the node's west border."), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$M5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Hme), $61de1ee1cac498ae$var$Ose), "Port Label Placement"), "Decides on a placement method for port labels; if empty, the node label's position is not modified."), $61de1ee1cac498ae$var$y9c), $61de1ee1cac498ae$var$W5c), $61de1ee1cac498ae$var$E1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$eqe), $61de1ee1cac498ae$var$Ose), "Port Labels Next to Port"), "Use 'portLabels.placement': NEXT_TO_PORT_OF_POSSIBLE."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$fqe), $61de1ee1cac498ae$var$Ose), "Treat Port Labels as Group"), "If this option is true (default), the labels of a port will be treated as a group when it comes to centering them next to their port. If this option is false, only the first label will be centered next to the port, with the others being placed below. This only applies to labels of eastern and western ports and will have no effect if labels are not placed next to their port."), true), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$_pe), $61de1ee1cac498ae$var$Pse), "Activate Inside Self Loops"), "Whether this node allows to route self loops inside of it instead of around it. If set to true, this will make the node a compound node if it isn't already, and will require the layout algorithm to support compound nodes with hierarchical ports."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$K5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$aqe), $61de1ee1cac498ae$var$Pse), "Inside Self Loop"), "Whether a self loop should be routed inside a node instead of around that node."), false), $61de1ee1cac498ae$var$T5c), $61de1ee1cac498ae$var$wI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$$le), "edge"), "Edge Thickness"), "The thickness of an edge. This is a hint on the line width used to draw an edge, possibly requiring more space to be reserved for it."), 1), $61de1ee1cac498ae$var$U5c), $61de1ee1cac498ae$var$BI), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$t4c(a, new $61de1ee1cac498ae$var$p5c($61de1ee1cac498ae$var$F5c($61de1ee1cac498ae$var$E5c($61de1ee1cac498ae$var$G5c($61de1ee1cac498ae$var$y5c($61de1ee1cac498ae$var$z5c($61de1ee1cac498ae$var$D5c($61de1ee1cac498ae$var$A5c($61de1ee1cac498ae$var$B5c(new $61de1ee1cac498ae$var$H5c, $61de1ee1cac498ae$var$Ise), "edge"), "Edge Type"), "The type of an edge. This is usually used for UML class diagrams, where associations must be handled differently from generalizations."), $61de1ee1cac498ae$var$H8c), $61de1ee1cac498ae$var$V5c), $61de1ee1cac498ae$var$w1), $61de1ee1cac498ae$var$pqb($61de1ee1cac498ae$var$I5c))));
    $61de1ee1cac498ae$var$s4c(a, new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$b4c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, $61de1ee1cac498ae$var$sne), "Layered"), 'The layer-based method was introduced by Sugiyama, Tagawa and Toda in 1981. It emphasizes the direction of edges by pointing as many edges as possible into the same direction. The nodes are arranged in layers, which are sometimes called "hierarchies", and then reordered such that the number of edge crossings is minimized. Afterwards, concrete coordinates are computed for the nodes and edge bend points.')));
    $61de1ee1cac498ae$var$s4c(a, new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$b4c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, "org.eclipse.elk.orthogonal"), "Orthogonal"), 'Orthogonal methods that follow the "topology-shape-metrics" approach by Batini, Nardelli and Tamassia \'86. The first phase determines the topology of the drawing by applying a planarization technique, which results in a planar representation of the graph. The orthogonal shape is computed in the second phase, which aims at minimizing the number of edge bends, and is called orthogonalization. The third phase leads to concrete coordinates for nodes and edge bend points by applying a compaction method, thus defining the metrics.')));
    $61de1ee1cac498ae$var$s4c(a, new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$b4c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, $61de1ee1cac498ae$var$ume), "Force"), "Layout algorithms that follow physical analogies by simulating a system of attractive and repulsive forces. The first successful method of this kind was proposed by Eades in 1984.")));
    $61de1ee1cac498ae$var$s4c(a, new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$b4c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, "org.eclipse.elk.circle"), "Circle"), "Circular layout algorithms emphasize cycles or biconnected components of a graph by arranging them in circles. This is useful if a drawing is desired where such components are clearly grouped, or where cycles are shown as prominent OPTIONS of the graph.")));
    $61de1ee1cac498ae$var$s4c(a, new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$b4c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, $61de1ee1cac498ae$var$bre), "Tree"), "Specialized layout methods for trees, i.e. acyclic graphs. The regular structure of graphs that have no undirected cycles can be emphasized using an algorithm of this type.")));
    $61de1ee1cac498ae$var$s4c(a, new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$b4c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, "org.eclipse.elk.planar"), "Planar"), "Algorithms that require a planar or upward planar graph. Most of these algorithms are theoretically interesting, but not practically usable.")));
    $61de1ee1cac498ae$var$s4c(a, new $61de1ee1cac498ae$var$W3c($61de1ee1cac498ae$var$b4c($61de1ee1cac498ae$var$d4c($61de1ee1cac498ae$var$c4c(new $61de1ee1cac498ae$var$e4c, $61de1ee1cac498ae$var$sre), "Radial"), "Radial layout algorithms usually position the nodes of the graph on concentric circles.")));
    $61de1ee1cac498ae$var$$ad((new $61de1ee1cac498ae$var$_ad, a));
    $61de1ee1cac498ae$var$Y7c((new $61de1ee1cac498ae$var$Z7c, a));
    $61de1ee1cac498ae$var$jdd((new $61de1ee1cac498ae$var$kdd, a));
};
var $61de1ee1cac498ae$var$o8c, $61de1ee1cac498ae$var$p8c, $61de1ee1cac498ae$var$q8c, $61de1ee1cac498ae$var$r8c, $61de1ee1cac498ae$var$s8c, $61de1ee1cac498ae$var$t8c, $61de1ee1cac498ae$var$u8c, $61de1ee1cac498ae$var$v8c, $61de1ee1cac498ae$var$w8c, $61de1ee1cac498ae$var$x8c, $61de1ee1cac498ae$var$y8c, $61de1ee1cac498ae$var$z8c, $61de1ee1cac498ae$var$A8c, $61de1ee1cac498ae$var$B8c, $61de1ee1cac498ae$var$C8c, $61de1ee1cac498ae$var$D8c, $61de1ee1cac498ae$var$E8c, $61de1ee1cac498ae$var$F8c, $61de1ee1cac498ae$var$G8c, $61de1ee1cac498ae$var$H8c, $61de1ee1cac498ae$var$I8c, $61de1ee1cac498ae$var$J8c, $61de1ee1cac498ae$var$K8c, $61de1ee1cac498ae$var$L8c, $61de1ee1cac498ae$var$M8c, $61de1ee1cac498ae$var$N8c, $61de1ee1cac498ae$var$O8c, $61de1ee1cac498ae$var$P8c, $61de1ee1cac498ae$var$Q8c, $61de1ee1cac498ae$var$R8c, $61de1ee1cac498ae$var$S8c, $61de1ee1cac498ae$var$T8c, $61de1ee1cac498ae$var$U8c, $61de1ee1cac498ae$var$V8c, $61de1ee1cac498ae$var$W8c, $61de1ee1cac498ae$var$X8c, $61de1ee1cac498ae$var$Y8c, $61de1ee1cac498ae$var$Z8c, $61de1ee1cac498ae$var$$8c, $61de1ee1cac498ae$var$_8c, $61de1ee1cac498ae$var$a9c, $61de1ee1cac498ae$var$b9c, $61de1ee1cac498ae$var$c9c, $61de1ee1cac498ae$var$d9c, $61de1ee1cac498ae$var$e9c, $61de1ee1cac498ae$var$f9c, $61de1ee1cac498ae$var$g9c, $61de1ee1cac498ae$var$h9c, $61de1ee1cac498ae$var$i9c, $61de1ee1cac498ae$var$j9c, $61de1ee1cac498ae$var$k9c, $61de1ee1cac498ae$var$l9c, $61de1ee1cac498ae$var$m9c, $61de1ee1cac498ae$var$n9c, $61de1ee1cac498ae$var$o9c, $61de1ee1cac498ae$var$p9c, $61de1ee1cac498ae$var$q9c, $61de1ee1cac498ae$var$r9c, $61de1ee1cac498ae$var$s9c, $61de1ee1cac498ae$var$t9c, $61de1ee1cac498ae$var$u9c, $61de1ee1cac498ae$var$v9c, $61de1ee1cac498ae$var$w9c, $61de1ee1cac498ae$var$x9c, $61de1ee1cac498ae$var$y9c, $61de1ee1cac498ae$var$z9c, $61de1ee1cac498ae$var$A9c, $61de1ee1cac498ae$var$B9c, $61de1ee1cac498ae$var$C9c, $61de1ee1cac498ae$var$D9c, $61de1ee1cac498ae$var$E9c, $61de1ee1cac498ae$var$F9c, $61de1ee1cac498ae$var$G9c, $61de1ee1cac498ae$var$H9c, $61de1ee1cac498ae$var$I9c, $61de1ee1cac498ae$var$J9c, $61de1ee1cac498ae$var$K9c, $61de1ee1cac498ae$var$L9c, $61de1ee1cac498ae$var$M9c, $61de1ee1cac498ae$var$N9c, $61de1ee1cac498ae$var$O9c, $61de1ee1cac498ae$var$P9c, $61de1ee1cac498ae$var$Q9c, $61de1ee1cac498ae$var$R9c, $61de1ee1cac498ae$var$S9c, $61de1ee1cac498ae$var$T9c, $61de1ee1cac498ae$var$U9c, $61de1ee1cac498ae$var$V9c, $61de1ee1cac498ae$var$W9c, $61de1ee1cac498ae$var$X9c;
var $61de1ee1cac498ae$var$s1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ose, "CoreOptions", 684);
$61de1ee1cac498ae$var$bcb(103, 22, {
    3: 1,
    35: 1,
    22: 1,
    103: 1
}, $61de1ee1cac498ae$var$iad);
var $61de1ee1cac498ae$var$_9c, $61de1ee1cac498ae$var$aad, $61de1ee1cac498ae$var$bad, $61de1ee1cac498ae$var$cad, $61de1ee1cac498ae$var$dad;
var $61de1ee1cac498ae$var$t1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, $61de1ee1cac498ae$var$Cle, 103, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$kad, $61de1ee1cac498ae$var$jad);
var $61de1ee1cac498ae$var$lad;
$61de1ee1cac498ae$var$bcb(272, 22, {
    3: 1,
    35: 1,
    22: 1,
    272: 1
}, $61de1ee1cac498ae$var$rad);
var $61de1ee1cac498ae$var$nad, $61de1ee1cac498ae$var$oad, $61de1ee1cac498ae$var$pad;
var $61de1ee1cac498ae$var$u1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "EdgeLabelPlacement", 272, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$tad, $61de1ee1cac498ae$var$sad);
var $61de1ee1cac498ae$var$uad;
$61de1ee1cac498ae$var$bcb(218, 22, {
    3: 1,
    35: 1,
    22: 1,
    218: 1
}, $61de1ee1cac498ae$var$Bad);
var $61de1ee1cac498ae$var$wad, $61de1ee1cac498ae$var$xad, $61de1ee1cac498ae$var$yad, $61de1ee1cac498ae$var$zad;
var $61de1ee1cac498ae$var$v1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "EdgeRouting", 218, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Dad, $61de1ee1cac498ae$var$Cad);
var $61de1ee1cac498ae$var$Ead;
$61de1ee1cac498ae$var$bcb(312, 22, {
    3: 1,
    35: 1,
    22: 1,
    312: 1
}, $61de1ee1cac498ae$var$Nad);
var $61de1ee1cac498ae$var$Gad, $61de1ee1cac498ae$var$Had, $61de1ee1cac498ae$var$Iad, $61de1ee1cac498ae$var$Jad, $61de1ee1cac498ae$var$Kad, $61de1ee1cac498ae$var$Lad;
var $61de1ee1cac498ae$var$w1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "EdgeType", 312, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Pad, $61de1ee1cac498ae$var$Oad);
var $61de1ee1cac498ae$var$Qad;
$61de1ee1cac498ae$var$bcb(977, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$_ad);
$61de1ee1cac498ae$var$_.Qe = function abd(a) {
    $61de1ee1cac498ae$var$$ad(a);
};
var $61de1ee1cac498ae$var$Sad, $61de1ee1cac498ae$var$Tad, $61de1ee1cac498ae$var$Uad, $61de1ee1cac498ae$var$Vad, $61de1ee1cac498ae$var$Wad, $61de1ee1cac498ae$var$Xad, $61de1ee1cac498ae$var$Yad;
var $61de1ee1cac498ae$var$y1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ose, "FixedLayouterOptions", 977);
$61de1ee1cac498ae$var$bcb(978, 1, {}, $61de1ee1cac498ae$var$bbd);
$61de1ee1cac498ae$var$_.$e = function cbd() {
    var a;
    return a = new $61de1ee1cac498ae$var$Zfd, a;
};
$61de1ee1cac498ae$var$_._e = function dbd(a) {};
var $61de1ee1cac498ae$var$x1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ose, "FixedLayouterOptions/FixedFactory", 978);
$61de1ee1cac498ae$var$bcb(334, 22, {
    3: 1,
    35: 1,
    22: 1,
    334: 1
}, $61de1ee1cac498ae$var$ibd);
var $61de1ee1cac498ae$var$ebd, $61de1ee1cac498ae$var$fbd, $61de1ee1cac498ae$var$gbd;
var $61de1ee1cac498ae$var$z1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "HierarchyHandling", 334, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$kbd, $61de1ee1cac498ae$var$jbd);
var $61de1ee1cac498ae$var$lbd;
$61de1ee1cac498ae$var$bcb(285, 22, {
    3: 1,
    35: 1,
    22: 1,
    285: 1
}, $61de1ee1cac498ae$var$tbd);
var $61de1ee1cac498ae$var$nbd, $61de1ee1cac498ae$var$obd, $61de1ee1cac498ae$var$pbd, $61de1ee1cac498ae$var$qbd;
var $61de1ee1cac498ae$var$A1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "LabelSide", 285, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$vbd, $61de1ee1cac498ae$var$ubd);
var $61de1ee1cac498ae$var$wbd;
$61de1ee1cac498ae$var$bcb(93, 22, {
    3: 1,
    35: 1,
    22: 1,
    93: 1
}, $61de1ee1cac498ae$var$Ibd);
var $61de1ee1cac498ae$var$ybd, $61de1ee1cac498ae$var$zbd, $61de1ee1cac498ae$var$Abd, $61de1ee1cac498ae$var$Bbd, $61de1ee1cac498ae$var$Cbd, $61de1ee1cac498ae$var$Dbd, $61de1ee1cac498ae$var$Ebd, $61de1ee1cac498ae$var$Fbd, $61de1ee1cac498ae$var$Gbd;
var $61de1ee1cac498ae$var$B1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "NodeLabelPlacement", 93, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Lbd, $61de1ee1cac498ae$var$Kbd);
var $61de1ee1cac498ae$var$Mbd;
$61de1ee1cac498ae$var$bcb(249, 22, {
    3: 1,
    35: 1,
    22: 1,
    249: 1
}, $61de1ee1cac498ae$var$Ubd);
var $61de1ee1cac498ae$var$Obd, $61de1ee1cac498ae$var$Pbd, $61de1ee1cac498ae$var$Qbd, $61de1ee1cac498ae$var$Rbd, $61de1ee1cac498ae$var$Sbd;
var $61de1ee1cac498ae$var$C1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "PortAlignment", 249, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Wbd, $61de1ee1cac498ae$var$Vbd);
var $61de1ee1cac498ae$var$Xbd;
$61de1ee1cac498ae$var$bcb(98, 22, {
    3: 1,
    35: 1,
    22: 1,
    98: 1
}, $61de1ee1cac498ae$var$gcd);
var $61de1ee1cac498ae$var$Zbd, $61de1ee1cac498ae$var$$bd, $61de1ee1cac498ae$var$_bd, $61de1ee1cac498ae$var$acd, $61de1ee1cac498ae$var$bcd, $61de1ee1cac498ae$var$ccd;
var $61de1ee1cac498ae$var$D1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "PortConstraints", 98, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$icd, $61de1ee1cac498ae$var$hcd);
var $61de1ee1cac498ae$var$jcd;
$61de1ee1cac498ae$var$bcb(273, 22, {
    3: 1,
    35: 1,
    22: 1,
    273: 1
}, $61de1ee1cac498ae$var$scd);
var $61de1ee1cac498ae$var$lcd, $61de1ee1cac498ae$var$mcd, $61de1ee1cac498ae$var$ncd, $61de1ee1cac498ae$var$ocd, $61de1ee1cac498ae$var$pcd, $61de1ee1cac498ae$var$qcd;
var $61de1ee1cac498ae$var$E1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "PortLabelPlacement", 273, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$wcd, $61de1ee1cac498ae$var$vcd);
var $61de1ee1cac498ae$var$xcd;
$61de1ee1cac498ae$var$bcb(61, 22, {
    3: 1,
    35: 1,
    22: 1,
    61: 1
}, $61de1ee1cac498ae$var$Ycd);
var $61de1ee1cac498ae$var$zcd, $61de1ee1cac498ae$var$Acd, $61de1ee1cac498ae$var$Bcd, $61de1ee1cac498ae$var$Ccd, $61de1ee1cac498ae$var$Dcd, $61de1ee1cac498ae$var$Ecd, $61de1ee1cac498ae$var$Fcd, $61de1ee1cac498ae$var$Gcd, $61de1ee1cac498ae$var$Hcd, $61de1ee1cac498ae$var$Icd, $61de1ee1cac498ae$var$Jcd, $61de1ee1cac498ae$var$Kcd, $61de1ee1cac498ae$var$Lcd, $61de1ee1cac498ae$var$Mcd, $61de1ee1cac498ae$var$Ncd, $61de1ee1cac498ae$var$Ocd, $61de1ee1cac498ae$var$Pcd, $61de1ee1cac498ae$var$Qcd, $61de1ee1cac498ae$var$Rcd, $61de1ee1cac498ae$var$Scd, $61de1ee1cac498ae$var$Tcd;
var $61de1ee1cac498ae$var$F1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "PortSide", 61, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$_cd, $61de1ee1cac498ae$var$$cd);
var $61de1ee1cac498ae$var$bdd;
$61de1ee1cac498ae$var$bcb(981, 1, $61de1ee1cac498ae$var$ale, $61de1ee1cac498ae$var$kdd);
$61de1ee1cac498ae$var$_.Qe = function ldd(a) {
    $61de1ee1cac498ae$var$jdd(a);
};
var $61de1ee1cac498ae$var$ddd, $61de1ee1cac498ae$var$edd, $61de1ee1cac498ae$var$fdd, $61de1ee1cac498ae$var$gdd, $61de1ee1cac498ae$var$hdd;
var $61de1ee1cac498ae$var$H1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ose, "RandomLayouterOptions", 981);
$61de1ee1cac498ae$var$bcb(982, 1, {}, $61de1ee1cac498ae$var$mdd);
$61de1ee1cac498ae$var$_.$e = function ndd() {
    var a;
    return a = new $61de1ee1cac498ae$var$Mgd, a;
};
$61de1ee1cac498ae$var$_._e = function odd(a) {};
var $61de1ee1cac498ae$var$G1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$ose, "RandomLayouterOptions/RandomFactory", 982);
$61de1ee1cac498ae$var$bcb(374, 22, {
    3: 1,
    35: 1,
    22: 1,
    374: 1
}, $61de1ee1cac498ae$var$udd);
var $61de1ee1cac498ae$var$pdd, $61de1ee1cac498ae$var$qdd, $61de1ee1cac498ae$var$rdd, $61de1ee1cac498ae$var$sdd;
var $61de1ee1cac498ae$var$I1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "SizeConstraint", 374, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$wdd, $61de1ee1cac498ae$var$vdd);
var $61de1ee1cac498ae$var$xdd;
$61de1ee1cac498ae$var$bcb(259, 22, {
    3: 1,
    35: 1,
    22: 1,
    259: 1
}, $61de1ee1cac498ae$var$Jdd);
var $61de1ee1cac498ae$var$zdd, $61de1ee1cac498ae$var$Add, $61de1ee1cac498ae$var$Bdd, $61de1ee1cac498ae$var$Cdd, $61de1ee1cac498ae$var$Ddd, $61de1ee1cac498ae$var$Edd, $61de1ee1cac498ae$var$Fdd, $61de1ee1cac498ae$var$Gdd, $61de1ee1cac498ae$var$Hdd;
var $61de1ee1cac498ae$var$J1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$ose, "SizeOptions", 259, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Ldd, $61de1ee1cac498ae$var$Kdd);
var $61de1ee1cac498ae$var$Mdd;
$61de1ee1cac498ae$var$bcb(370, 1, {
    1949: 1
}, $61de1ee1cac498ae$var$Zdd);
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = -1;
$61de1ee1cac498ae$var$_.e = null;
$61de1ee1cac498ae$var$_.f = null;
$61de1ee1cac498ae$var$_.g = -1;
$61de1ee1cac498ae$var$_.j = false;
$61de1ee1cac498ae$var$_.k = false;
$61de1ee1cac498ae$var$_.n = false;
$61de1ee1cac498ae$var$_.o = 0;
$61de1ee1cac498ae$var$_.q = 0;
$61de1ee1cac498ae$var$_.r = 0;
var $61de1ee1cac498ae$var$L1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "BasicProgressMonitor", 370);
$61de1ee1cac498ae$var$bcb(972, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$ged);
$61de1ee1cac498ae$var$_.Ze = function ked(a, b) {
    var c, d, e, f, g, h, i, j, k;
    $61de1ee1cac498ae$var$Odd(b, "Box layout", 2);
    e = $61de1ee1cac498ae$var$Gdb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$X7c(), $61de1ee1cac498ae$var$W7c))));
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$T7c), 116);
    c = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$O7c)));
    d = $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$P7c)));
    switch($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$M7c), 311).g){
        case 0:
            g = (h = new $61de1ee1cac498ae$var$Tkb((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Okb(h, new $61de1ee1cac498ae$var$med(d)), h);
            i = $61de1ee1cac498ae$var$rfd(a);
            j = $61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$L7c));
            (j == null || ($61de1ee1cac498ae$var$uCb(j), j) <= 0) && (j = 1.3);
            k = $61de1ee1cac498ae$var$ded(g, e, f, i.a, i.b, c, ($61de1ee1cac498ae$var$uCb(j), j));
            $61de1ee1cac498ae$var$Afd(a, k.a, k.b, false, true);
            break;
        default:
            $61de1ee1cac498ae$var$eed(a, e, f, c);
    }
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$S1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "BoxLayoutProvider", 972);
$61de1ee1cac498ae$var$bcb(973, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$med);
$61de1ee1cac498ae$var$_.ue = function ned(a, b) {
    return $61de1ee1cac498ae$var$led(this, $61de1ee1cac498ae$var$BD(a, 33), $61de1ee1cac498ae$var$BD(b, 33));
};
$61de1ee1cac498ae$var$_.Fb = function oed(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function ped() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$M1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "BoxLayoutProvider/1", 973);
$61de1ee1cac498ae$var$bcb(157, 1, {
    157: 1
}, $61de1ee1cac498ae$var$wed, $61de1ee1cac498ae$var$xed);
$61de1ee1cac498ae$var$_.Ib = function yed() {
    return this.c ? $61de1ee1cac498ae$var$_od(this.c) : $61de1ee1cac498ae$var$Fe(this.b);
};
var $61de1ee1cac498ae$var$N1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "BoxLayoutProvider/Group", 157);
$61de1ee1cac498ae$var$bcb(311, 22, {
    3: 1,
    35: 1,
    22: 1,
    311: 1
}, $61de1ee1cac498ae$var$Eed);
var $61de1ee1cac498ae$var$zed, $61de1ee1cac498ae$var$Aed, $61de1ee1cac498ae$var$Bed, $61de1ee1cac498ae$var$Ced;
var $61de1ee1cac498ae$var$O1 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$yqe, "BoxLayoutProvider/PackingMode", 311, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Ged, $61de1ee1cac498ae$var$Fed);
var $61de1ee1cac498ae$var$Hed;
$61de1ee1cac498ae$var$bcb(974, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Jed);
$61de1ee1cac498ae$var$_.ue = function Ked(a, b) {
    return $61de1ee1cac498ae$var$hed($61de1ee1cac498ae$var$BD(a, 157), $61de1ee1cac498ae$var$BD(b, 157));
};
$61de1ee1cac498ae$var$_.Fb = function Led(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Med() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$P1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "BoxLayoutProvider/lambda$0$Type", 974);
$61de1ee1cac498ae$var$bcb(975, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Ned);
$61de1ee1cac498ae$var$_.ue = function Oed(a, b) {
    return $61de1ee1cac498ae$var$ied($61de1ee1cac498ae$var$BD(a, 157), $61de1ee1cac498ae$var$BD(b, 157));
};
$61de1ee1cac498ae$var$_.Fb = function Ped(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Qed() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$Q1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "BoxLayoutProvider/lambda$1$Type", 975);
$61de1ee1cac498ae$var$bcb(976, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Red);
$61de1ee1cac498ae$var$_.ue = function Sed(a, b) {
    return $61de1ee1cac498ae$var$jed($61de1ee1cac498ae$var$BD(a, 157), $61de1ee1cac498ae$var$BD(b, 157));
};
$61de1ee1cac498ae$var$_.Fb = function Ted(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Ued() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$R1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "BoxLayoutProvider/lambda$2$Type", 976);
$61de1ee1cac498ae$var$bcb(1365, 1, {
    831: 1
}, $61de1ee1cac498ae$var$Ved);
$61de1ee1cac498ae$var$_.qg = function Wed(a, b) {
    return $61de1ee1cac498ae$var$Vyc(), !$61de1ee1cac498ae$var$JD(b, 160) || $61de1ee1cac498ae$var$h2c(($61de1ee1cac498ae$var$Y1c(), $61de1ee1cac498ae$var$X1c, $61de1ee1cac498ae$var$BD(a, 160)), b);
};
var $61de1ee1cac498ae$var$T1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder/lambda$0$Type", 1365);
$61de1ee1cac498ae$var$bcb(1366, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Xed);
$61de1ee1cac498ae$var$_.td = function Yed(a) {
    $61de1ee1cac498ae$var$Yyc(this.a, $61de1ee1cac498ae$var$BD(a, 146));
};
var $61de1ee1cac498ae$var$U1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder/lambda$1$Type", 1366);
$61de1ee1cac498ae$var$bcb(1367, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Zed);
$61de1ee1cac498ae$var$_.td = function $ed(a) {
    $61de1ee1cac498ae$var$BD(a, 94);
    $61de1ee1cac498ae$var$Vyc();
};
var $61de1ee1cac498ae$var$V1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder/lambda$2$Type", 1367);
$61de1ee1cac498ae$var$bcb(1371, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$_ed);
$61de1ee1cac498ae$var$_.td = function afd(a) {
    $61de1ee1cac498ae$var$Zyc(this.a, $61de1ee1cac498ae$var$BD(a, 94));
};
var $61de1ee1cac498ae$var$W1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder/lambda$3$Type", 1371);
$61de1ee1cac498ae$var$bcb(1369, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$bfd);
$61de1ee1cac498ae$var$_.Mb = function cfd(a) {
    return $61de1ee1cac498ae$var$$yc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 146));
};
var $61de1ee1cac498ae$var$X1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder/lambda$4$Type", 1369);
$61de1ee1cac498ae$var$bcb(1368, 1, $61de1ee1cac498ae$var$Oie, $61de1ee1cac498ae$var$dfd);
$61de1ee1cac498ae$var$_.Mb = function efd(a) {
    return $61de1ee1cac498ae$var$azc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 831));
};
var $61de1ee1cac498ae$var$Y1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder/lambda$5$Type", 1368);
$61de1ee1cac498ae$var$bcb(1370, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$ffd);
$61de1ee1cac498ae$var$_.td = function gfd(a) {
    $61de1ee1cac498ae$var$_yc(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 146));
};
var $61de1ee1cac498ae$var$Z1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkSpacings/AbstractSpacingsBuilder/lambda$6$Type", 1370);
$61de1ee1cac498ae$var$bcb(935, 1, {}, $61de1ee1cac498ae$var$Hfd);
$61de1ee1cac498ae$var$_.Kb = function Ifd(a) {
    return $61de1ee1cac498ae$var$Gfd(a);
};
$61de1ee1cac498ae$var$_.Fb = function Jfd(a) {
    return this === a;
};
var $61de1ee1cac498ae$var$_1 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkUtil/lambda$0$Type", 935);
$61de1ee1cac498ae$var$bcb(936, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Kfd);
$61de1ee1cac498ae$var$_.td = function Lfd(a) {
    $61de1ee1cac498ae$var$ufd(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 79));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$a2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkUtil/lambda$1$Type", 936);
$61de1ee1cac498ae$var$bcb(937, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Mfd);
$61de1ee1cac498ae$var$_.td = function Nfd(a) {
    $61de1ee1cac498ae$var$vfd(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 202));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$b2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkUtil/lambda$2$Type", 937);
$61de1ee1cac498ae$var$bcb(938, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Ofd);
$61de1ee1cac498ae$var$_.td = function Pfd(a) {
    $61de1ee1cac498ae$var$wfd(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 137));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$c2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkUtil/lambda$3$Type", 938);
$61de1ee1cac498ae$var$bcb(939, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Qfd);
$61de1ee1cac498ae$var$_.td = function Rfd(a) {
    $61de1ee1cac498ae$var$xfd(this.a, $61de1ee1cac498ae$var$BD(a, 469));
};
var $61de1ee1cac498ae$var$d2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ElkUtil/lambda$4$Type", 939);
$61de1ee1cac498ae$var$bcb(342, 1, {
    35: 1,
    342: 1
}, $61de1ee1cac498ae$var$Tfd);
$61de1ee1cac498ae$var$_.wd = function Ufd(a) {
    return $61de1ee1cac498ae$var$Sfd(this, $61de1ee1cac498ae$var$BD(a, 236));
};
$61de1ee1cac498ae$var$_.Fb = function Vfd(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 342)) {
        b = $61de1ee1cac498ae$var$BD(a, 342);
        return this.a == b.a;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Hb = function Wfd() {
    return $61de1ee1cac498ae$var$QD(this.a);
};
$61de1ee1cac498ae$var$_.Ib = function Xfd() {
    return this.a + " (exclusive)";
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$e2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "ExclusiveBounds/ExclusiveLowerBound", 342);
$61de1ee1cac498ae$var$bcb(1138, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$Zfd);
$61de1ee1cac498ae$var$_.Ze = function $fd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, A, B;
    $61de1ee1cac498ae$var$Odd(b, "Fixed Layout", 1);
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$E8c)), 218);
    l = 0;
    m = 0;
    for(s = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); s.e != s.i.gc();){
        q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(s), 33);
        B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(q, ($61de1ee1cac498ae$var$Zad(), $61de1ee1cac498ae$var$Yad)), 8);
        if (B) {
            $61de1ee1cac498ae$var$bld(q, B.a, B.b);
            if ($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(q, $61de1ee1cac498ae$var$Tad), 174).Hc(($61de1ee1cac498ae$var$tdd(), $61de1ee1cac498ae$var$pdd))) {
                n = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(q, $61de1ee1cac498ae$var$Vad), 8);
                n.a > 0 && n.b > 0 && $61de1ee1cac498ae$var$Afd(q, n.a, n.b, true, true);
            }
        }
        l = $61de1ee1cac498ae$var$$wnd.Math.max(l, q.i + q.g);
        m = $61de1ee1cac498ae$var$$wnd.Math.max(m, q.j + q.f);
        for(j = new $61de1ee1cac498ae$var$Fyd((!q.n && (q.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, q, 1, 7)), q.n)); j.e != j.i.gc();){
            h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(j), 137);
            B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$Yad), 8);
            !!B && $61de1ee1cac498ae$var$bld(h, B.a, B.b);
            l = $61de1ee1cac498ae$var$$wnd.Math.max(l, q.i + h.i + h.g);
            m = $61de1ee1cac498ae$var$$wnd.Math.max(m, q.j + h.j + h.f);
        }
        for(v = new $61de1ee1cac498ae$var$Fyd((!q.c && (q.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, q, 9, 9)), q.c)); v.e != v.i.gc();){
            u = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(v), 118);
            B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(u, $61de1ee1cac498ae$var$Yad), 8);
            !!B && $61de1ee1cac498ae$var$bld(u, B.a, B.b);
            w = q.i + u.i;
            A = q.j + u.j;
            l = $61de1ee1cac498ae$var$$wnd.Math.max(l, w + u.g);
            m = $61de1ee1cac498ae$var$$wnd.Math.max(m, A + u.f);
            for(i = new $61de1ee1cac498ae$var$Fyd((!u.n && (u.n = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$D2, u, 1, 7)), u.n)); i.e != i.i.gc();){
                h = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(i), 137);
                B = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(h, $61de1ee1cac498ae$var$Yad), 8);
                !!B && $61de1ee1cac498ae$var$bld(h, B.a, B.b);
                l = $61de1ee1cac498ae$var$$wnd.Math.max(l, w + h.i + h.g);
                m = $61de1ee1cac498ae$var$$wnd.Math.max(m, A + h.j + h.f);
            }
        }
        for(e = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(q).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(e);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(e), 79);
            k = $61de1ee1cac498ae$var$Yfd(c);
            l = $61de1ee1cac498ae$var$$wnd.Math.max(l, k.a);
            m = $61de1ee1cac498ae$var$$wnd.Math.max(m, k.b);
        }
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$$sd(q).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 79);
            if ($61de1ee1cac498ae$var$Xod($61de1ee1cac498ae$var$jtd(c)) != a) {
                k = $61de1ee1cac498ae$var$Yfd(c);
                l = $61de1ee1cac498ae$var$$wnd.Math.max(l, k.a);
                m = $61de1ee1cac498ae$var$$wnd.Math.max(m, k.b);
            }
        }
    }
    if (f == ($61de1ee1cac498ae$var$Aad(), $61de1ee1cac498ae$var$wad)) for(r = new $61de1ee1cac498ae$var$Fyd((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a)); r.e != r.i.gc();){
        q = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(r), 33);
        for(d = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd(q).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(d);){
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(d), 79);
            g = $61de1ee1cac498ae$var$pfd(c);
            g.b == 0 ? $61de1ee1cac498ae$var$jkd(c, $61de1ee1cac498ae$var$Q8c, null) : $61de1ee1cac498ae$var$jkd(c, $61de1ee1cac498ae$var$Q8c, g);
        }
    }
    if (!$61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Zad(), $61de1ee1cac498ae$var$Uad))))) {
        t = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$Wad), 116);
        p = l + t.b + t.c;
        o = m + t.d + t.a;
        $61de1ee1cac498ae$var$Afd(a, p, o, true, true);
    }
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$f2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "FixedLayoutProvider", 1138);
$61de1ee1cac498ae$var$bcb(373, 134, {
    3: 1,
    414: 1,
    373: 1,
    94: 1,
    134: 1
}, $61de1ee1cac498ae$var$_fd, $61de1ee1cac498ae$var$agd);
$61de1ee1cac498ae$var$_.Jf = function dgd(b) {
    var c, d, e, f, g, h, i, j, k;
    if (!b) return;
    try {
        j = $61de1ee1cac498ae$var$mfb(b, ";,;");
        for(g = j, h = 0, i = g.length; h < i; ++h){
            f = g[h];
            d = $61de1ee1cac498ae$var$mfb(f, "\\:");
            e = $61de1ee1cac498ae$var$k4c($61de1ee1cac498ae$var$n4c(), d[0]);
            if (!e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Invalid option id: " + d[0]));
            k = $61de1ee1cac498ae$var$o5c(e, d[1]);
            if (k == null) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb("Invalid option value: " + d[1]));
            k == null ? (!this.q && (this.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Thb(this.q, e)) : (!this.q && (this.q = new $61de1ee1cac498ae$var$Lqb), $61de1ee1cac498ae$var$Rhb(this.q, e, k));
        }
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 102)) {
            c = a;
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Xdb(c));
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.Ib = function egd() {
    var a;
    a = $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$GAb($61de1ee1cac498ae$var$NAb((!this.q ? ($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb) : this.q).vc().Oc(), new $61de1ee1cac498ae$var$fgd), $61de1ee1cac498ae$var$Ayb(new $61de1ee1cac498ae$var$pzb, new $61de1ee1cac498ae$var$nzb, new $61de1ee1cac498ae$var$Zyb, new $61de1ee1cac498ae$var$_yb, $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$xL, 1), $61de1ee1cac498ae$var$Kie, 132, 0, []))));
    return a;
};
var $61de1ee1cac498ae$var$i2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "IndividualSpacings", 373);
$61de1ee1cac498ae$var$bcb(971, 1, {}, $61de1ee1cac498ae$var$fgd);
$61de1ee1cac498ae$var$_.Kb = function ggd(a) {
    return $61de1ee1cac498ae$var$cgd($61de1ee1cac498ae$var$BD(a, 42));
};
var $61de1ee1cac498ae$var$h2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "IndividualSpacings/lambda$0$Type", 971);
$61de1ee1cac498ae$var$bcb(709, 1, {}, $61de1ee1cac498ae$var$jgd);
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$j2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "InstancePool", 709);
$61de1ee1cac498ae$var$bcb(1275, 1, {}, $61de1ee1cac498ae$var$kgd);
var $61de1ee1cac498ae$var$l2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "LoggedGraph", 1275);
$61de1ee1cac498ae$var$bcb(396, 22, {
    3: 1,
    35: 1,
    22: 1,
    396: 1
}, $61de1ee1cac498ae$var$qgd);
var $61de1ee1cac498ae$var$lgd, $61de1ee1cac498ae$var$mgd, $61de1ee1cac498ae$var$ngd, $61de1ee1cac498ae$var$ogd;
var $61de1ee1cac498ae$var$k2 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$yqe, "LoggedGraph/Type", 396, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$sgd, $61de1ee1cac498ae$var$rgd);
var $61de1ee1cac498ae$var$tgd;
$61de1ee1cac498ae$var$bcb(46, 1, {
    20: 1,
    46: 1
}, $61de1ee1cac498ae$var$vgd);
$61de1ee1cac498ae$var$_.Jc = function xgd(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Fb = function wgd(a) {
    var b, c, d;
    if ($61de1ee1cac498ae$var$JD(a, 46)) {
        c = $61de1ee1cac498ae$var$BD(a, 46);
        b = this.a == null ? c.a == null : $61de1ee1cac498ae$var$pb(this.a, c.a);
        d = this.b == null ? c.b == null : $61de1ee1cac498ae$var$pb(this.b, c.b);
        return b && d;
    } else return false;
};
$61de1ee1cac498ae$var$_.Hb = function ygd() {
    var a, b, c, d, e, f;
    c = this.a == null ? 0 : $61de1ee1cac498ae$var$tb(this.a);
    a = c & $61de1ee1cac498ae$var$aje;
    b = c & -65536;
    f = this.b == null ? 0 : $61de1ee1cac498ae$var$tb(this.b);
    d = f & $61de1ee1cac498ae$var$aje;
    e = f & -65536;
    return a ^ e >> 16 & $61de1ee1cac498ae$var$aje | b ^ d << 16;
};
$61de1ee1cac498ae$var$_.Kc = function zgd() {
    return new $61de1ee1cac498ae$var$Bgd(this);
};
$61de1ee1cac498ae$var$_.Ib = function Agd() {
    return this.a == null && this.b == null ? "pair(null,null)" : this.a == null ? "pair(null," + $61de1ee1cac498ae$var$fcb(this.b) + ")" : this.b == null ? "pair(" + $61de1ee1cac498ae$var$fcb(this.a) + ",null)" : "pair(" + $61de1ee1cac498ae$var$fcb(this.a) + "," + $61de1ee1cac498ae$var$fcb(this.b) + ")";
};
var $61de1ee1cac498ae$var$n2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "Pair", 46);
$61de1ee1cac498ae$var$bcb(983, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Bgd);
$61de1ee1cac498ae$var$_.Nb = function Cgd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Dgd() {
    return !this.c && (!this.b && this.a.a != null || this.a.b != null);
};
$61de1ee1cac498ae$var$_.Pb = function Egd() {
    if (!this.c && !this.b && this.a.a != null) {
        this.b = true;
        return this.a.a;
    } else if (!this.c && this.a.b != null) {
        this.c = true;
        return this.a.b;
    }
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Qb = function Fgd() {
    this.c && this.a.b != null ? this.a.b = null : this.b && this.a.a != null && (this.a.a = null);
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
};
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$m2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "Pair/1", 983);
$61de1ee1cac498ae$var$bcb(448, 1, {
    448: 1
}, $61de1ee1cac498ae$var$Ggd);
$61de1ee1cac498ae$var$_.Fb = function Hgd(a) {
    return $61de1ee1cac498ae$var$wtb(this.a, $61de1ee1cac498ae$var$BD(a, 448).a) && $61de1ee1cac498ae$var$wtb(this.c, $61de1ee1cac498ae$var$BD(a, 448).c) && $61de1ee1cac498ae$var$wtb(this.d, $61de1ee1cac498ae$var$BD(a, 448).d) && $61de1ee1cac498ae$var$wtb(this.b, $61de1ee1cac498ae$var$BD(a, 448).b);
};
$61de1ee1cac498ae$var$_.Hb = function Igd() {
    return $61de1ee1cac498ae$var$Hlb($61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$SI, 1), $61de1ee1cac498ae$var$Uhe, 1, 5, [
        this.a,
        this.c,
        this.d,
        this.b
    ]));
};
$61de1ee1cac498ae$var$_.Ib = function Jgd() {
    return "(" + this.a + $61de1ee1cac498ae$var$She + this.c + $61de1ee1cac498ae$var$She + this.d + $61de1ee1cac498ae$var$She + this.b + ")";
};
var $61de1ee1cac498ae$var$o2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "Quadruple", 448);
$61de1ee1cac498ae$var$bcb(1126, 209, $61de1ee1cac498ae$var$Mle, $61de1ee1cac498ae$var$Mgd);
$61de1ee1cac498ae$var$_.Ze = function Ngd(a, b) {
    var c, d, e, f, g;
    $61de1ee1cac498ae$var$Odd(b, "Random Layout", 1);
    if ((!a.a && (a.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, a, 10, 11)), a.a).i == 0) {
        $61de1ee1cac498ae$var$Qdd(b);
        return;
    }
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$idd(), $61de1ee1cac498ae$var$gdd)), 19);
    !!f && f.a != 0 ? e = new $61de1ee1cac498ae$var$Hub(f.a) : e = new $61de1ee1cac498ae$var$Gub;
    c = $61de1ee1cac498ae$var$Gdb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$ddd)));
    g = $61de1ee1cac498ae$var$Gdb($61de1ee1cac498ae$var$ED($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$hdd)));
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(a, $61de1ee1cac498ae$var$edd), 116);
    $61de1ee1cac498ae$var$Lgd(a, e, c, g, d);
    $61de1ee1cac498ae$var$Qdd(b);
};
var $61de1ee1cac498ae$var$p2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yqe, "RandomLayoutProvider", 1126);
var $61de1ee1cac498ae$var$Ogd;
$61de1ee1cac498ae$var$bcb(553, 1, {});
$61de1ee1cac498ae$var$_.qf = function Sgd() {
    return new $61de1ee1cac498ae$var$f7c(this.f.i, this.f.j);
};
$61de1ee1cac498ae$var$_.We = function Tgd(a) {
    if ($61de1ee1cac498ae$var$Jsd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$s9c))) return $61de1ee1cac498ae$var$hkd(this.f, $61de1ee1cac498ae$var$Qgd);
    return $61de1ee1cac498ae$var$hkd(this.f, a);
};
$61de1ee1cac498ae$var$_.rf = function Ugd() {
    return new $61de1ee1cac498ae$var$f7c(this.f.g, this.f.f);
};
$61de1ee1cac498ae$var$_.sf = function Vgd() {
    return this.g;
};
$61de1ee1cac498ae$var$_.Xe = function Wgd(a) {
    return $61de1ee1cac498ae$var$ikd(this.f, a);
};
$61de1ee1cac498ae$var$_.tf = function Xgd(a) {
    $61de1ee1cac498ae$var$dld(this.f, a.a);
    $61de1ee1cac498ae$var$eld(this.f, a.b);
};
$61de1ee1cac498ae$var$_.uf = function Ygd(a) {
    $61de1ee1cac498ae$var$cld(this.f, a.a);
    $61de1ee1cac498ae$var$ald(this.f, a.b);
};
$61de1ee1cac498ae$var$_.vf = function Zgd(a) {
    this.g = a;
};
$61de1ee1cac498ae$var$_.g = 0;
var $61de1ee1cac498ae$var$Qgd;
var $61de1ee1cac498ae$var$q2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Use, "ElkGraphAdapters/AbstractElkGraphElementAdapter", 553);
$61de1ee1cac498ae$var$bcb(554, 1, {
    839: 1
}, $61de1ee1cac498ae$var$$gd);
$61de1ee1cac498ae$var$_.wf = function _gd() {
    var a, b;
    if (!this.b) {
        this.b = $61de1ee1cac498ae$var$Qu($61de1ee1cac498ae$var$Kkd(this.a).i);
        for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$Kkd(this.a)); b.e != b.i.gc();){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 137);
            $61de1ee1cac498ae$var$Ekb(this.b, new $61de1ee1cac498ae$var$dhd(a));
        }
    }
    return this.b;
};
$61de1ee1cac498ae$var$_.b = null;
var $61de1ee1cac498ae$var$r2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Use, "ElkGraphAdapters/ElkEdgeAdapter", 554);
$61de1ee1cac498ae$var$bcb(301, 553, {}, $61de1ee1cac498ae$var$bhd);
$61de1ee1cac498ae$var$_.xf = function chd() {
    return $61de1ee1cac498ae$var$ahd(this);
};
$61de1ee1cac498ae$var$_.a = null;
var $61de1ee1cac498ae$var$s2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Use, "ElkGraphAdapters/ElkGraphAdapter", 301);
$61de1ee1cac498ae$var$bcb(630, 553, {
    181: 1
}, $61de1ee1cac498ae$var$dhd);
var $61de1ee1cac498ae$var$t2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Use, "ElkGraphAdapters/ElkLabelAdapter", 630);
$61de1ee1cac498ae$var$bcb(629, 553, {
    680: 1
}, $61de1ee1cac498ae$var$hhd);
$61de1ee1cac498ae$var$_.wf = function khd() {
    return $61de1ee1cac498ae$var$ehd(this);
};
$61de1ee1cac498ae$var$_.Af = function lhd() {
    var a;
    return a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$hkd(this.f, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$S8c)), 142), !a && (a = new $61de1ee1cac498ae$var$H_b), a;
};
$61de1ee1cac498ae$var$_.Cf = function nhd() {
    return $61de1ee1cac498ae$var$fhd(this);
};
$61de1ee1cac498ae$var$_.Ef = function phd(a) {
    var b;
    b = new $61de1ee1cac498ae$var$K_b(a);
    $61de1ee1cac498ae$var$jkd(this.f, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$S8c), b);
};
$61de1ee1cac498ae$var$_.Ff = function qhd(a) {
    $61de1ee1cac498ae$var$jkd(this.f, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$f9c), new $61de1ee1cac498ae$var$r0b(a));
};
$61de1ee1cac498ae$var$_.yf = function ihd() {
    return this.d;
};
$61de1ee1cac498ae$var$_.zf = function jhd() {
    var a, b;
    if (!this.a) {
        this.a = new $61de1ee1cac498ae$var$Rkb;
        for(b = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$$sd($61de1ee1cac498ae$var$BD(this.f, 33)).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(b);){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(b), 79);
            $61de1ee1cac498ae$var$Ekb(this.a, new $61de1ee1cac498ae$var$$gd(a));
        }
    }
    return this.a;
};
$61de1ee1cac498ae$var$_.Bf = function mhd() {
    var a, b;
    if (!this.c) {
        this.c = new $61de1ee1cac498ae$var$Rkb;
        for(b = new $61de1ee1cac498ae$var$Sr($61de1ee1cac498ae$var$ur($61de1ee1cac498ae$var$_sd($61de1ee1cac498ae$var$BD(this.f, 33)).a.Kc(), new $61de1ee1cac498ae$var$Sq)); $61de1ee1cac498ae$var$Qr(b);){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Rr(b), 79);
            $61de1ee1cac498ae$var$Ekb(this.c, new $61de1ee1cac498ae$var$$gd(a));
        }
    }
    return this.c;
};
$61de1ee1cac498ae$var$_.Df = function ohd() {
    return $61de1ee1cac498ae$var$Vod($61de1ee1cac498ae$var$BD(this.f, 33)).i != 0 || $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$BD(this.f, 33).We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$M8c))));
};
$61de1ee1cac498ae$var$_.Gf = function rhd() {
    $61de1ee1cac498ae$var$ghd(this, ($61de1ee1cac498ae$var$Pgd(), $61de1ee1cac498ae$var$Ogd));
};
$61de1ee1cac498ae$var$_.a = null;
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.d = null;
$61de1ee1cac498ae$var$_.e = null;
var $61de1ee1cac498ae$var$u2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Use, "ElkGraphAdapters/ElkNodeAdapter", 629);
$61de1ee1cac498ae$var$bcb(1266, 553, {
    838: 1
}, $61de1ee1cac498ae$var$thd);
$61de1ee1cac498ae$var$_.wf = function vhd() {
    return $61de1ee1cac498ae$var$shd(this);
};
$61de1ee1cac498ae$var$_.zf = function uhd() {
    var a, b;
    if (!this.a) {
        this.a = $61de1ee1cac498ae$var$Pu($61de1ee1cac498ae$var$BD(this.f, 118).xg().i);
        for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$BD(this.f, 118).xg()); b.e != b.i.gc();){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 79);
            $61de1ee1cac498ae$var$Ekb(this.a, new $61de1ee1cac498ae$var$$gd(a));
        }
    }
    return this.a;
};
$61de1ee1cac498ae$var$_.Bf = function whd() {
    var a, b;
    if (!this.c) {
        this.c = $61de1ee1cac498ae$var$Pu($61de1ee1cac498ae$var$BD(this.f, 118).yg().i);
        for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$BD(this.f, 118).yg()); b.e != b.i.gc();){
            a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 79);
            $61de1ee1cac498ae$var$Ekb(this.c, new $61de1ee1cac498ae$var$$gd(a));
        }
    }
    return this.c;
};
$61de1ee1cac498ae$var$_.Hf = function xhd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(this.f, 118).We(($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$A9c)), 61);
};
$61de1ee1cac498ae$var$_.If = function yhd() {
    var a, b, c, d, e, f, g, h;
    d = $61de1ee1cac498ae$var$mpd($61de1ee1cac498ae$var$BD(this.f, 118));
    for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$BD(this.f, 118).yg()); c.e != c.i.gc();){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 79);
        for(h = new $61de1ee1cac498ae$var$Fyd((!a.c && (a.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 5, 8)), a.c)); h.e != h.i.gc();){
            g = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(h), 82);
            if ($61de1ee1cac498ae$var$ntd($61de1ee1cac498ae$var$atd(g), d)) return true;
            else if ($61de1ee1cac498ae$var$atd(g) == d && $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$hkd(a, ($61de1ee1cac498ae$var$Y9c(), $61de1ee1cac498ae$var$N8c))))) return true;
        }
    }
    for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$BD(this.f, 118).xg()); b.e != b.i.gc();){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 79);
        for(f = new $61de1ee1cac498ae$var$Fyd((!a.b && (a.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, a, 4, 7)), a.b)); f.e != f.i.gc();){
            e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(f), 82);
            if ($61de1ee1cac498ae$var$ntd($61de1ee1cac498ae$var$atd(e), d)) return true;
        }
    }
    return false;
};
$61de1ee1cac498ae$var$_.a = null;
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
var $61de1ee1cac498ae$var$v2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Use, "ElkGraphAdapters/ElkPortAdapter", 1266);
$61de1ee1cac498ae$var$bcb(1267, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Ahd);
$61de1ee1cac498ae$var$_.ue = function Bhd(a, b) {
    return $61de1ee1cac498ae$var$zhd($61de1ee1cac498ae$var$BD(a, 118), $61de1ee1cac498ae$var$BD(b, 118));
};
$61de1ee1cac498ae$var$_.Fb = function Chd(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Dhd() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$w2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Use, "ElkGraphAdapters/PortComparator", 1267);
var $61de1ee1cac498ae$var$m5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, "EObject");
var $61de1ee1cac498ae$var$x2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$Xse);
var $61de1ee1cac498ae$var$y2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$Yse);
var $61de1ee1cac498ae$var$C2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$Zse);
var $61de1ee1cac498ae$var$G2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, "ElkShape");
var $61de1ee1cac498ae$var$z2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$$se);
var $61de1ee1cac498ae$var$B2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$_se);
var $61de1ee1cac498ae$var$A2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$ate);
var $61de1ee1cac498ae$var$k5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$bte);
var $61de1ee1cac498ae$var$i5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, "EFactory");
var $61de1ee1cac498ae$var$Ehd;
var $61de1ee1cac498ae$var$l5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$cte);
var $61de1ee1cac498ae$var$o5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, "EPackage");
var $61de1ee1cac498ae$var$Ghd;
var $61de1ee1cac498ae$var$Ihd, $61de1ee1cac498ae$var$Jhd, $61de1ee1cac498ae$var$Khd, $61de1ee1cac498ae$var$Lhd, $61de1ee1cac498ae$var$Mhd, $61de1ee1cac498ae$var$Nhd, $61de1ee1cac498ae$var$Ohd, $61de1ee1cac498ae$var$Phd, $61de1ee1cac498ae$var$Qhd, $61de1ee1cac498ae$var$Rhd, $61de1ee1cac498ae$var$Shd;
var $61de1ee1cac498ae$var$D2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$dte);
var $61de1ee1cac498ae$var$E2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$ete);
var $61de1ee1cac498ae$var$F2 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Wse, $61de1ee1cac498ae$var$fte);
$61de1ee1cac498ae$var$bcb(90, 1, $61de1ee1cac498ae$var$gte);
$61de1ee1cac498ae$var$_.Jg = function Vhd() {
    this.Kg();
    return null;
};
$61de1ee1cac498ae$var$_.Kg = function Whd() {
    return null;
};
$61de1ee1cac498ae$var$_.Lg = function Xhd() {
    return this.Kg(), false;
};
$61de1ee1cac498ae$var$_.Mg = function Yhd() {
    return false;
};
$61de1ee1cac498ae$var$_.Ng = function Zhd(a) {
    $61de1ee1cac498ae$var$Uhd(this, a);
};
var $61de1ee1cac498ae$var$b4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "BasicNotifierImpl", 90);
$61de1ee1cac498ae$var$bcb(97, 90, $61de1ee1cac498ae$var$pte);
$61de1ee1cac498ae$var$_.nh = function fjd() {
    return $61de1ee1cac498ae$var$oid(this);
};
$61de1ee1cac498ae$var$_.Og = function Fid(a, b) {
    return a;
};
$61de1ee1cac498ae$var$_.Pg = function Gid() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Qg = function Hid(a) {
    var b;
    return b = $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd(this.Tg(), this.Vg()), 18)), this.eh().ih(this, b.n, b.f, a);
};
$61de1ee1cac498ae$var$_.Rg = function Iid(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Sg = function Jid(a, b, c) {
    return $61de1ee1cac498ae$var$_hd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.Tg = function Kid() {
    var a;
    if (this.Pg()) {
        a = this.Pg().ck();
        if (a) return a;
    }
    return this.zh();
};
$61de1ee1cac498ae$var$_.Ug = function Lid() {
    return $61de1ee1cac498ae$var$aid(this);
};
$61de1ee1cac498ae$var$_.Vg = function Mid() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wg = function Oid() {
    var a, b;
    b = this.ph().dk();
    !b && this.Pg().ik(b = ($61de1ee1cac498ae$var$nRd(), a = $61de1ee1cac498ae$var$pNd($61de1ee1cac498ae$var$TKd(this.Tg())), a == null ? $61de1ee1cac498ae$var$mRd : new $61de1ee1cac498ae$var$qRd(this, a)));
    return b;
};
$61de1ee1cac498ae$var$_.Xg = function Qid(a, b) {
    return a;
};
$61de1ee1cac498ae$var$_.Yg = function Rid(a) {
    var b;
    b = a.Gj();
    return !b ? $61de1ee1cac498ae$var$bLd(this.Tg(), a) : a.aj();
};
$61de1ee1cac498ae$var$_.Zg = function Sid() {
    var a;
    a = this.Pg();
    return !a ? null : a.fk();
};
$61de1ee1cac498ae$var$_.$g = function Tid() {
    return !this.Pg() ? null : this.Pg().ck();
};
$61de1ee1cac498ae$var$_._g = function Uid(a, b, c) {
    return $61de1ee1cac498ae$var$fid(this, a, b, c);
};
$61de1ee1cac498ae$var$_.ah = function Vid(a) {
    return $61de1ee1cac498ae$var$gid(this, a);
};
$61de1ee1cac498ae$var$_.bh = function Wid(a, b) {
    return $61de1ee1cac498ae$var$hid(this, a, b);
};
$61de1ee1cac498ae$var$_.dh = function Xid() {
    var a;
    a = this.Pg();
    return !!a && a.gk();
};
$61de1ee1cac498ae$var$_.eh = function Yid() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.fh = function Zid() {
    return $61de1ee1cac498ae$var$jid(this);
};
$61de1ee1cac498ae$var$_.gh = function $id(a, b, c, d) {
    return $61de1ee1cac498ae$var$kid(this, a, b, d);
};
$61de1ee1cac498ae$var$_.hh = function _id(a, b, c) {
    var d;
    return d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd(this.Tg(), b), 66), d.Nj().Qj(this, this.yh(), b - this.Ah(), a, c);
};
$61de1ee1cac498ae$var$_.ih = function ajd(a, b, c, d) {
    return $61de1ee1cac498ae$var$lid(this, a, b, d);
};
$61de1ee1cac498ae$var$_.jh = function bjd(a, b, c) {
    var d;
    return d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd(this.Tg(), b), 66), d.Nj().Rj(this, this.yh(), b - this.Ah(), a, c);
};
$61de1ee1cac498ae$var$_.kh = function cjd() {
    return !!this.Pg() && !!this.Pg().ek();
};
$61de1ee1cac498ae$var$_.lh = function djd(a) {
    return $61de1ee1cac498ae$var$mid(this, a);
};
$61de1ee1cac498ae$var$_.mh = function ejd(a) {
    return $61de1ee1cac498ae$var$nid(this, a);
};
$61de1ee1cac498ae$var$_.oh = function gjd(a) {
    return $61de1ee1cac498ae$var$rid(this, a);
};
$61de1ee1cac498ae$var$_.ph = function hjd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.qh = function ijd() {
    return !this.Pg() ? null : this.Pg().ek();
};
$61de1ee1cac498ae$var$_.rh = function jjd() {
    return $61de1ee1cac498ae$var$jid(this);
};
$61de1ee1cac498ae$var$_.sh = function kjd(a, b) {
    $61de1ee1cac498ae$var$yid(this, a, b);
};
$61de1ee1cac498ae$var$_.th = function ljd(a) {
    this.ph().hk(a);
};
$61de1ee1cac498ae$var$_.uh = function mjd(a) {
    this.ph().kk(a);
};
$61de1ee1cac498ae$var$_.vh = function njd(a) {
    this.ph().jk(a);
};
$61de1ee1cac498ae$var$_.wh = function ojd(a, b) {
    var c, d, e, f;
    f = this.Zg();
    if (!!f && !!a) {
        b = $61de1ee1cac498ae$var$Txd(f.Vk(), this, b);
        f.Zk(this);
    }
    d = this.eh();
    if (d) {
        if (($61de1ee1cac498ae$var$Nid(this, this.eh(), this.Vg()).Bb & $61de1ee1cac498ae$var$Tje) != 0) {
            e = d.fh();
            !!e && (!a ? e.Yk(this) : !f && e.Zk(this));
        } else {
            b = (c = this.Vg(), c >= 0 ? this.Qg(b) : this.eh().ih(this, -1 - c, null, b));
            b = this.Sg(null, -1, b);
        }
    }
    this.uh(a);
    return b;
};
$61de1ee1cac498ae$var$_.xh = function pjd(a) {
    var b, c, d, e, f, g, h, i;
    c = this.Tg();
    f = $61de1ee1cac498ae$var$bLd(c, a);
    b = this.Ah();
    if (f >= b) return $61de1ee1cac498ae$var$BD(a, 66).Nj().Uj(this, this.yh(), f - b);
    else if (f <= -1) {
        g = $61de1ee1cac498ae$var$e1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), c, a);
        if (g) {
            $61de1ee1cac498ae$var$Q6d();
            $61de1ee1cac498ae$var$BD(g, 66).Oj() || (g = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, g)));
            e = (d = this.Yg(g), $61de1ee1cac498ae$var$BD(d >= 0 ? this._g(d, true, true) : $61de1ee1cac498ae$var$sid(this, g, true), 153));
            i = g.Zj();
            if (i > 1 || i == -1) return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(e, 215).hl(a, false), 76);
        } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ite + a.ne() + $61de1ee1cac498ae$var$lte));
    } else if (a.$j()) return d = this.Yg(a), $61de1ee1cac498ae$var$BD(d >= 0 ? this._g(d, false, true) : $61de1ee1cac498ae$var$sid(this, a, false), 76);
    h = new $61de1ee1cac498ae$var$nGd(this, a);
    return h;
};
$61de1ee1cac498ae$var$_.yh = function qjd() {
    return $61de1ee1cac498ae$var$Aid(this);
};
$61de1ee1cac498ae$var$_.zh = function rjd() {
    return ($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).S;
};
$61de1ee1cac498ae$var$_.Ah = function sjd() {
    return $61de1ee1cac498ae$var$aLd(this.zh());
};
$61de1ee1cac498ae$var$_.Bh = function tjd(a) {
    $61de1ee1cac498ae$var$Cid(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function ujd() {
    return $61de1ee1cac498ae$var$Eid(this);
};
var $61de1ee1cac498ae$var$B5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "BasicEObjectImpl", 97);
var $61de1ee1cac498ae$var$zFd;
$61de1ee1cac498ae$var$bcb(114, 97, {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1
});
$61de1ee1cac498ae$var$_.Ch = function Djd(a) {
    var b;
    b = $61de1ee1cac498ae$var$xjd(this);
    return b[a];
};
$61de1ee1cac498ae$var$_.Dh = function Ejd(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$xjd(this);
    $61de1ee1cac498ae$var$NC(c, a, b);
};
$61de1ee1cac498ae$var$_.Eh = function Fjd(a) {
    var b;
    b = $61de1ee1cac498ae$var$xjd(this);
    $61de1ee1cac498ae$var$NC(b, a, null);
};
$61de1ee1cac498ae$var$_.Jg = function Gjd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 4), 126);
};
$61de1ee1cac498ae$var$_.Kg = function Hjd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Lg = function Ijd() {
    return (this.Db & 4) != 0;
};
$61de1ee1cac498ae$var$_.Pg = function Jjd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Fh = function Kjd(a) {
    $61de1ee1cac498ae$var$Cjd(this, 2, a);
};
$61de1ee1cac498ae$var$_.Rg = function Ljd(a, b) {
    this.Db = b << 16 | this.Db & 255;
    this.Fh(a);
};
$61de1ee1cac498ae$var$_.Tg = function Mjd() {
    return $61de1ee1cac498ae$var$wjd(this);
};
$61de1ee1cac498ae$var$_.Vg = function Njd() {
    return this.Db >> 16;
};
$61de1ee1cac498ae$var$_.Wg = function Ojd() {
    var a, b;
    return $61de1ee1cac498ae$var$nRd(), b = $61de1ee1cac498ae$var$pNd($61de1ee1cac498ae$var$TKd((a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !a ? this.zh() : a))), b == null ? $61de1ee1cac498ae$var$mRd : new $61de1ee1cac498ae$var$qRd(this, b);
};
$61de1ee1cac498ae$var$_.Mg = function Pjd() {
    return (this.Db & 1) == 0;
};
$61de1ee1cac498ae$var$_.Zg = function Qjd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 128), 1935);
};
$61de1ee1cac498ae$var$_.$g = function Rjd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26);
};
$61de1ee1cac498ae$var$_.dh = function Sjd() {
    return (this.Db & 32) != 0;
};
$61de1ee1cac498ae$var$_.eh = function Tjd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 2), 49);
};
$61de1ee1cac498ae$var$_.kh = function Ujd() {
    return (this.Db & 64) != 0;
};
$61de1ee1cac498ae$var$_.ph = function Vjd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.qh = function Wjd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 64), 281);
};
$61de1ee1cac498ae$var$_.th = function Xjd(a) {
    $61de1ee1cac498ae$var$Cjd(this, 16, a);
};
$61de1ee1cac498ae$var$_.uh = function Yjd(a) {
    $61de1ee1cac498ae$var$Cjd(this, 128, a);
};
$61de1ee1cac498ae$var$_.vh = function Zjd(a) {
    $61de1ee1cac498ae$var$Cjd(this, 64, a);
};
$61de1ee1cac498ae$var$_.yh = function $jd() {
    return $61de1ee1cac498ae$var$yjd(this);
};
$61de1ee1cac498ae$var$_.Db = 0;
var $61de1ee1cac498ae$var$s8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "MinimalEObjectImpl", 114);
$61de1ee1cac498ae$var$bcb(115, 114, {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_.Fh = function _jd(a) {
    this.Cb = a;
};
$61de1ee1cac498ae$var$_.eh = function akd() {
    return this.Cb;
};
var $61de1ee1cac498ae$var$r8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "MinimalEObjectImpl/Container", 115);
$61de1ee1cac498ae$var$bcb(1985, 115, {
    105: 1,
    413: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_._g = function kkd(a, b, c) {
    return $61de1ee1cac498ae$var$bkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.jh = function lkd(a, b, c) {
    return $61de1ee1cac498ae$var$ckd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function mkd(a) {
    return $61de1ee1cac498ae$var$dkd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function nkd(a, b) {
    $61de1ee1cac498ae$var$ekd(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function okd() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Shd;
};
$61de1ee1cac498ae$var$_.Bh = function pkd(a) {
    $61de1ee1cac498ae$var$fkd(this, a);
};
$61de1ee1cac498ae$var$_.Ve = function qkd() {
    return $61de1ee1cac498ae$var$gkd(this);
};
$61de1ee1cac498ae$var$_.We = function rkd(a) {
    return $61de1ee1cac498ae$var$hkd(this, a);
};
$61de1ee1cac498ae$var$_.Xe = function skd(a) {
    return $61de1ee1cac498ae$var$ikd(this, a);
};
$61de1ee1cac498ae$var$_.Ye = function tkd(a, b) {
    return $61de1ee1cac498ae$var$jkd(this, a, b);
};
var $61de1ee1cac498ae$var$H2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "EMapPropertyHolderImpl", 1985);
$61de1ee1cac498ae$var$bcb(567, 115, {
    105: 1,
    469: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$xkd);
$61de1ee1cac498ae$var$_._g = function ykd(a, b, c) {
    switch(a){
        case 0:
            return this.a;
        case 1:
            return this.b;
    }
    return $61de1ee1cac498ae$var$fid(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function zkd(a) {
    switch(a){
        case 0:
            return this.a != 0;
        case 1:
            return this.b != 0;
    }
    return $61de1ee1cac498ae$var$mid(this, a);
};
$61de1ee1cac498ae$var$_.sh = function Akd(a, b) {
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$vkd(this, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
            return;
        case 1:
            $61de1ee1cac498ae$var$wkd(this, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
            return;
    }
    $61de1ee1cac498ae$var$yid(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function Bkd() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Ihd;
};
$61de1ee1cac498ae$var$_.Bh = function Ckd(a) {
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$vkd(this, 0);
            return;
        case 1:
            $61de1ee1cac498ae$var$wkd(this, 0);
            return;
    }
    $61de1ee1cac498ae$var$Cid(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function Dkd() {
    var a;
    if ((this.Db & 64) != 0) return $61de1ee1cac498ae$var$Eid(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(this));
    a.a += " (x: ";
    $61de1ee1cac498ae$var$Bfb(a, this.a);
    a.a += ", y: ";
    $61de1ee1cac498ae$var$Bfb(a, this.b);
    a.a += ")";
    return a.a;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$I2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkBendPointImpl", 567);
$61de1ee1cac498ae$var$bcb(723, 1985, {
    105: 1,
    413: 1,
    160: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_._g = function Nkd(a, b, c) {
    return $61de1ee1cac498ae$var$Ekd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.hh = function Okd(a, b, c) {
    return $61de1ee1cac498ae$var$Fkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.jh = function Pkd(a, b, c) {
    return $61de1ee1cac498ae$var$Gkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function Qkd(a) {
    return $61de1ee1cac498ae$var$Hkd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function Rkd(a, b) {
    $61de1ee1cac498ae$var$Ikd(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function Skd() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Mhd;
};
$61de1ee1cac498ae$var$_.Bh = function Tkd(a) {
    $61de1ee1cac498ae$var$Jkd(this, a);
};
$61de1ee1cac498ae$var$_.zg = function Ukd() {
    return this.k;
};
$61de1ee1cac498ae$var$_.Ag = function Vkd() {
    return $61de1ee1cac498ae$var$Kkd(this);
};
$61de1ee1cac498ae$var$_.Ib = function Wkd() {
    return $61de1ee1cac498ae$var$Mkd(this);
};
$61de1ee1cac498ae$var$_.k = null;
var $61de1ee1cac498ae$var$M2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkGraphElementImpl", 723);
$61de1ee1cac498ae$var$bcb(724, 723, {
    105: 1,
    413: 1,
    160: 1,
    470: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_._g = function gld(a, b, c) {
    return $61de1ee1cac498ae$var$Xkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function hld(a) {
    return $61de1ee1cac498ae$var$Ykd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function ild(a, b) {
    $61de1ee1cac498ae$var$Zkd(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function jld() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Rhd;
};
$61de1ee1cac498ae$var$_.Bh = function kld(a) {
    $61de1ee1cac498ae$var$$kd(this, a);
};
$61de1ee1cac498ae$var$_.Bg = function lld() {
    return this.f;
};
$61de1ee1cac498ae$var$_.Cg = function mld() {
    return this.g;
};
$61de1ee1cac498ae$var$_.Dg = function nld() {
    return this.i;
};
$61de1ee1cac498ae$var$_.Eg = function old() {
    return this.j;
};
$61de1ee1cac498ae$var$_.Fg = function pld(a, b) {
    $61de1ee1cac498ae$var$_kd(this, a, b);
};
$61de1ee1cac498ae$var$_.Gg = function qld(a, b) {
    $61de1ee1cac498ae$var$bld(this, a, b);
};
$61de1ee1cac498ae$var$_.Hg = function rld(a) {
    $61de1ee1cac498ae$var$dld(this, a);
};
$61de1ee1cac498ae$var$_.Ig = function sld(a) {
    $61de1ee1cac498ae$var$eld(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function tld() {
    return $61de1ee1cac498ae$var$fld(this);
};
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.j = 0;
var $61de1ee1cac498ae$var$T2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkShapeImpl", 724);
$61de1ee1cac498ae$var$bcb(725, 724, {
    105: 1,
    413: 1,
    82: 1,
    160: 1,
    470: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_._g = function Bld(a, b, c) {
    return $61de1ee1cac498ae$var$uld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.hh = function Cld(a, b, c) {
    return $61de1ee1cac498ae$var$vld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.jh = function Dld(a, b, c) {
    return $61de1ee1cac498ae$var$wld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function Eld(a) {
    return $61de1ee1cac498ae$var$xld(this, a);
};
$61de1ee1cac498ae$var$_.sh = function Fld(a, b) {
    $61de1ee1cac498ae$var$yld(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function Gld() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Jhd;
};
$61de1ee1cac498ae$var$_.Bh = function Hld(a) {
    $61de1ee1cac498ae$var$zld(this, a);
};
$61de1ee1cac498ae$var$_.xg = function Ild() {
    return !this.d && (this.d = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, this, 8, 5)), this.d;
};
$61de1ee1cac498ae$var$_.yg = function Jld() {
    return !this.e && (this.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$B2, this, 7, 4)), this.e;
};
var $61de1ee1cac498ae$var$J2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkConnectableShapeImpl", 725);
$61de1ee1cac498ae$var$bcb(352, 723, {
    105: 1,
    413: 1,
    79: 1,
    160: 1,
    352: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$Tld);
$61de1ee1cac498ae$var$_.Qg = function Uld(a) {
    return $61de1ee1cac498ae$var$Lld(this, a);
};
$61de1ee1cac498ae$var$_._g = function Vld(a, b, c) {
    switch(a){
        case 3:
            return $61de1ee1cac498ae$var$Mld(this);
        case 4:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7)), this.b;
        case 5:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8)), this.c;
        case 6:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, this, 6, 6)), this.a;
        case 7:
            return $61de1ee1cac498ae$var$Bcb(), !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7)), this.b.i <= 1 && (!this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8)), this.c.i <= 1) ? false : true;
        case 8:
            return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Pld(this) ? true : false;
        case 9:
            return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Qld(this) ? true : false;
        case 10:
            return $61de1ee1cac498ae$var$Bcb(), !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7)), this.b.i != 0 && (!this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8)), this.c.i != 0) ? true : false;
    }
    return $61de1ee1cac498ae$var$Ekd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.hh = function Wld(a, b, c) {
    var d;
    switch(b){
        case 3:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? $61de1ee1cac498ae$var$Lld(this, c) : this.Cb.ih(this, -1 - d, null, c)));
            return $61de1ee1cac498ae$var$Kld(this, $61de1ee1cac498ae$var$BD(a, 33), c);
        case 4:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7)), $61de1ee1cac498ae$var$Sxd(this.b, a, c);
        case 5:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8)), $61de1ee1cac498ae$var$Sxd(this.c, a, c);
        case 6:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, this, 6, 6)), $61de1ee1cac498ae$var$Sxd(this.a, a, c);
    }
    return $61de1ee1cac498ae$var$Fkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.jh = function Xld(a, b, c) {
    switch(b){
        case 3:
            return $61de1ee1cac498ae$var$Kld(this, null, c);
        case 4:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7)), $61de1ee1cac498ae$var$Txd(this.b, a, c);
        case 5:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8)), $61de1ee1cac498ae$var$Txd(this.c, a, c);
        case 6:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, this, 6, 6)), $61de1ee1cac498ae$var$Txd(this.a, a, c);
    }
    return $61de1ee1cac498ae$var$Gkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function Yld(a) {
    switch(a){
        case 3:
            return !!$61de1ee1cac498ae$var$Mld(this);
        case 4:
            return !!this.b && this.b.i != 0;
        case 5:
            return !!this.c && this.c.i != 0;
        case 6:
            return !!this.a && this.a.i != 0;
        case 7:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7)), !(this.b.i <= 1 && (!this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8)), this.c.i <= 1));
        case 8:
            return $61de1ee1cac498ae$var$Pld(this);
        case 9:
            return $61de1ee1cac498ae$var$Qld(this);
        case 10:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7)), this.b.i != 0 && (!this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8)), this.c.i != 0);
    }
    return $61de1ee1cac498ae$var$Hkd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function Zld(a, b) {
    switch(a){
        case 3:
            $61de1ee1cac498ae$var$Rld(this, $61de1ee1cac498ae$var$BD(b, 33));
            return;
        case 4:
            !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7));
            $61de1ee1cac498ae$var$Uxd(this.b);
            !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7));
            $61de1ee1cac498ae$var$ytd(this.b, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 5:
            !this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8));
            $61de1ee1cac498ae$var$Uxd(this.c);
            !this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8));
            $61de1ee1cac498ae$var$ytd(this.c, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 6:
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, this, 6, 6));
            $61de1ee1cac498ae$var$Uxd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, this, 6, 6));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$Ikd(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function $ld() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Khd;
};
$61de1ee1cac498ae$var$_.Bh = function _ld(a) {
    switch(a){
        case 3:
            $61de1ee1cac498ae$var$Rld(this, null);
            return;
        case 4:
            !this.b && (this.b = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 4, 7));
            $61de1ee1cac498ae$var$Uxd(this.b);
            return;
        case 5:
            !this.c && (this.c = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$z2, this, 5, 8));
            $61de1ee1cac498ae$var$Uxd(this.c);
            return;
        case 6:
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$A2, this, 6, 6));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
    }
    $61de1ee1cac498ae$var$Jkd(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function amd() {
    return $61de1ee1cac498ae$var$Sld(this);
};
var $61de1ee1cac498ae$var$K2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkEdgeImpl", 352);
$61de1ee1cac498ae$var$bcb(439, 1985, {
    105: 1,
    413: 1,
    202: 1,
    439: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$rmd);
$61de1ee1cac498ae$var$_.Qg = function smd(a) {
    return $61de1ee1cac498ae$var$cmd(this, a);
};
$61de1ee1cac498ae$var$_._g = function tmd(a, b, c) {
    switch(a){
        case 1:
            return this.j;
        case 2:
            return this.k;
        case 3:
            return this.b;
        case 4:
            return this.c;
        case 5:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, this, 5)), this.a;
        case 6:
            return $61de1ee1cac498ae$var$fmd(this);
        case 7:
            if (b) return $61de1ee1cac498ae$var$emd(this);
            return this.i;
        case 8:
            if (b) return $61de1ee1cac498ae$var$dmd(this);
            return this.f;
        case 9:
            return !this.g && (this.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 9, 10)), this.g;
        case 10:
            return !this.e && (this.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 10, 9)), this.e;
        case 11:
            return this.d;
    }
    return $61de1ee1cac498ae$var$bkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.hh = function umd(a, b, c) {
    var d, e, f;
    switch(b){
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$cmd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$bmd(this, $61de1ee1cac498ae$var$BD(a, 79), c);
        case 9:
            return !this.g && (this.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 9, 10)), $61de1ee1cac498ae$var$Sxd(this.g, a, c);
        case 10:
            return !this.e && (this.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 10, 9)), $61de1ee1cac498ae$var$Sxd(this.e, a, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Lhd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Lhd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function vmd(a, b, c) {
    switch(b){
        case 5:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, this, 5)), $61de1ee1cac498ae$var$Txd(this.a, a, c);
        case 6:
            return $61de1ee1cac498ae$var$bmd(this, null, c);
        case 9:
            return !this.g && (this.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 9, 10)), $61de1ee1cac498ae$var$Txd(this.g, a, c);
        case 10:
            return !this.e && (this.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 10, 9)), $61de1ee1cac498ae$var$Txd(this.e, a, c);
    }
    return $61de1ee1cac498ae$var$ckd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function wmd(a) {
    switch(a){
        case 1:
            return this.j != 0;
        case 2:
            return this.k != 0;
        case 3:
            return this.b != 0;
        case 4:
            return this.c != 0;
        case 5:
            return !!this.a && this.a.i != 0;
        case 6:
            return !!$61de1ee1cac498ae$var$fmd(this);
        case 7:
            return !!this.i;
        case 8:
            return !!this.f;
        case 9:
            return !!this.g && this.g.i != 0;
        case 10:
            return !!this.e && this.e.i != 0;
        case 11:
            return this.d != null;
    }
    return $61de1ee1cac498ae$var$dkd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function xmd(a, b) {
    switch(a){
        case 1:
            $61de1ee1cac498ae$var$omd(this, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
            return;
        case 2:
            $61de1ee1cac498ae$var$pmd(this, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
            return;
        case 3:
            $61de1ee1cac498ae$var$hmd(this, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
            return;
        case 4:
            $61de1ee1cac498ae$var$imd(this, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
            return;
        case 5:
            !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, this, 5));
            $61de1ee1cac498ae$var$Uxd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, this, 5));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 6:
            $61de1ee1cac498ae$var$mmd(this, $61de1ee1cac498ae$var$BD(b, 79));
            return;
        case 7:
            $61de1ee1cac498ae$var$lmd(this, $61de1ee1cac498ae$var$BD(b, 82));
            return;
        case 8:
            $61de1ee1cac498ae$var$kmd(this, $61de1ee1cac498ae$var$BD(b, 82));
            return;
        case 9:
            !this.g && (this.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 9, 10));
            $61de1ee1cac498ae$var$Uxd(this.g);
            !this.g && (this.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 9, 10));
            $61de1ee1cac498ae$var$ytd(this.g, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 10:
            !this.e && (this.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 10, 9));
            $61de1ee1cac498ae$var$Uxd(this.e);
            !this.e && (this.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 10, 9));
            $61de1ee1cac498ae$var$ytd(this.e, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 11:
            $61de1ee1cac498ae$var$jmd(this, $61de1ee1cac498ae$var$GD(b));
            return;
    }
    $61de1ee1cac498ae$var$ekd(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function ymd() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Lhd;
};
$61de1ee1cac498ae$var$_.Bh = function zmd(a) {
    switch(a){
        case 1:
            $61de1ee1cac498ae$var$omd(this, 0);
            return;
        case 2:
            $61de1ee1cac498ae$var$pmd(this, 0);
            return;
        case 3:
            $61de1ee1cac498ae$var$hmd(this, 0);
            return;
        case 4:
            $61de1ee1cac498ae$var$imd(this, 0);
            return;
        case 5:
            !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$y2, this, 5));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
        case 6:
            $61de1ee1cac498ae$var$mmd(this, null);
            return;
        case 7:
            $61de1ee1cac498ae$var$lmd(this, null);
            return;
        case 8:
            $61de1ee1cac498ae$var$kmd(this, null);
            return;
        case 9:
            !this.g && (this.g = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 9, 10));
            $61de1ee1cac498ae$var$Uxd(this.g);
            return;
        case 10:
            !this.e && (this.e = new $61de1ee1cac498ae$var$y5d($61de1ee1cac498ae$var$A2, this, 10, 9));
            $61de1ee1cac498ae$var$Uxd(this.e);
            return;
        case 11:
            $61de1ee1cac498ae$var$jmd(this, null);
            return;
    }
    $61de1ee1cac498ae$var$fkd(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function Amd() {
    return $61de1ee1cac498ae$var$qmd(this);
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = null;
$61de1ee1cac498ae$var$_.j = 0;
$61de1ee1cac498ae$var$_.k = 0;
var $61de1ee1cac498ae$var$L2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkEdgeSectionImpl", 439);
$61de1ee1cac498ae$var$bcb(150, 115, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_._g = function Emd(a, b, c) {
    var d;
    if (a == 0) return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function Fmd(a, b, c) {
    var d, e;
    if (b == 0) return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), b), 66), e.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.jh = function Gmd(a, b, c) {
    var d, e;
    if (b == 0) return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.lh = function Hmd(a) {
    var b;
    if (a == 0) return !!this.Ab && this.Ab.i != 0;
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.oh = function Imd(a) {
    return $61de1ee1cac498ae$var$Bmd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function Jmd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? this.zh() : c), a), b);
};
$61de1ee1cac498ae$var$_.uh = function Kmd(a) {
    $61de1ee1cac498ae$var$Cjd(this, 128, a);
};
$61de1ee1cac498ae$var$_.zh = function Lmd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$ZFd;
};
$61de1ee1cac498ae$var$_.Bh = function Mmd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function Nmd() {
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.Hh = function Omd(a) {
    return $61de1ee1cac498ae$var$Dmd(this, a);
};
$61de1ee1cac498ae$var$_.Bb = 0;
var $61de1ee1cac498ae$var$f6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EModelElementImpl", 150);
$61de1ee1cac498ae$var$bcb(704, 150, {
    105: 1,
    92: 1,
    90: 1,
    471: 1,
    147: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$$md);
$61de1ee1cac498ae$var$_.Ih = function _md(a, b) {
    return $61de1ee1cac498ae$var$Vmd(this, a, b);
};
$61de1ee1cac498ae$var$_.Jh = function and(a) {
    var b, c, d, e, f;
    if (this.a != $61de1ee1cac498ae$var$bKd(a) || (a.Bb & 256) != 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$xte + a.zb + $61de1ee1cac498ae$var$ute));
    for(d = $61de1ee1cac498ae$var$_Kd(a); $61de1ee1cac498ae$var$VKd(d.a).i != 0;){
        c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$nOd(d, 0, (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$VKd(d.a), 0), 87), f = b.c, $61de1ee1cac498ae$var$JD(f, 88) ? $61de1ee1cac498ae$var$BD(f, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd))), 26);
        if ($61de1ee1cac498ae$var$dKd(c)) {
            e = $61de1ee1cac498ae$var$bKd(c).Nh().Jh(c);
            $61de1ee1cac498ae$var$BD(e, 49).th(a);
            return e;
        }
        d = $61de1ee1cac498ae$var$_Kd(c);
    }
    return (a.D != null ? a.D : a.B) == "java.util.Map$Entry" ? new $61de1ee1cac498ae$var$lHd(a) : new $61de1ee1cac498ae$var$_Gd(a);
};
$61de1ee1cac498ae$var$_.Kh = function bnd(a, b) {
    return $61de1ee1cac498ae$var$Wmd(this, a, b);
};
$61de1ee1cac498ae$var$_._g = function cnd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.a;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$WFd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function dnd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 1:
            !!this.a && (c = $61de1ee1cac498ae$var$BD(this.a, 49).ih(this, 4, $61de1ee1cac498ae$var$o5, c));
            return $61de1ee1cac498ae$var$Tmd(this, $61de1ee1cac498ae$var$BD(a, 235), c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd) : d), b), 66), e.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function end(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 1:
            return $61de1ee1cac498ae$var$Tmd(this, null, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function fnd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return !!this.a;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$WFd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function gnd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$Ymd(this, $61de1ee1cac498ae$var$BD(b, 235));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$WFd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function hnd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd;
};
$61de1ee1cac498ae$var$_.Bh = function ind(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$Ymd(this, null);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$WFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$WFd : b), a));
};
var $61de1ee1cac498ae$var$Pmd, $61de1ee1cac498ae$var$Qmd, $61de1ee1cac498ae$var$Rmd;
var $61de1ee1cac498ae$var$d6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EFactoryImpl", 704);
$61de1ee1cac498ae$var$bcb($61de1ee1cac498ae$var$zte, 704, {
    105: 1,
    2014: 1,
    92: 1,
    90: 1,
    471: 1,
    147: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$knd);
$61de1ee1cac498ae$var$_.Ih = function lnd(a, b) {
    switch(a.yj()){
        case 12:
            return $61de1ee1cac498ae$var$BD(b, 146).tg();
        case 13:
            return $61de1ee1cac498ae$var$fcb(b);
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + a.ne() + $61de1ee1cac498ae$var$ute));
    }
};
$61de1ee1cac498ae$var$_.Jh = function mnd(a) {
    var b, c, d, e, f, g, h, i;
    switch(a.G == -1 && (a.G = (b = $61de1ee1cac498ae$var$bKd(a), b ? $61de1ee1cac498ae$var$HLd(b.Mh(), a) : -1)), a.G){
        case 4:
            return f = new $61de1ee1cac498ae$var$Jod, f;
        case 6:
            return g = new $61de1ee1cac498ae$var$apd, g;
        case 7:
            return h = new $61de1ee1cac498ae$var$ppd, h;
        case 8:
            return d = new $61de1ee1cac498ae$var$Tld, d;
        case 9:
            return c = new $61de1ee1cac498ae$var$xkd, c;
        case 10:
            return e = new $61de1ee1cac498ae$var$rmd, e;
        case 11:
            return i = new $61de1ee1cac498ae$var$Bpd, i;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$xte + a.zb + $61de1ee1cac498ae$var$ute));
    }
};
$61de1ee1cac498ae$var$_.Kh = function nnd(a, b) {
    switch(a.yj()){
        case 13:
        case 12:
            return null;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + a.ne() + $61de1ee1cac498ae$var$ute));
    }
};
var $61de1ee1cac498ae$var$N2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkGraphFactoryImpl", $61de1ee1cac498ae$var$zte);
$61de1ee1cac498ae$var$bcb(438, 150, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_.Wg = function rnd() {
    var a, b;
    b = (a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), $61de1ee1cac498ae$var$pNd($61de1ee1cac498ae$var$TKd(!a ? this.zh() : a)));
    return b == null ? ($61de1ee1cac498ae$var$nRd(), $61de1ee1cac498ae$var$nRd(), $61de1ee1cac498ae$var$mRd) : new $61de1ee1cac498ae$var$GRd(this, b);
};
$61de1ee1cac498ae$var$_._g = function snd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.ne();
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), a), b, c);
};
$61de1ee1cac498ae$var$_.lh = function tnd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.sh = function und(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            this.Lh($61de1ee1cac498ae$var$GD(b));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? this.zh() : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function vnd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$$Fd;
};
$61de1ee1cac498ae$var$_.Bh = function wnd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            this.Lh(null);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.ne = function xnd() {
    return this.zb;
};
$61de1ee1cac498ae$var$_.Lh = function ynd(a) {
    $61de1ee1cac498ae$var$pnd(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function znd() {
    return $61de1ee1cac498ae$var$qnd(this);
};
$61de1ee1cac498ae$var$_.zb = null;
var $61de1ee1cac498ae$var$j6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ENamedElementImpl", 438);
$61de1ee1cac498ae$var$bcb(179, 438, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    235: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    179: 1,
    114: 1,
    115: 1,
    675: 1
}, $61de1ee1cac498ae$var$eod);
$61de1ee1cac498ae$var$_.Qg = function god(a) {
    return $61de1ee1cac498ae$var$Snd(this, a);
};
$61de1ee1cac498ae$var$_._g = function hod(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.yb;
        case 3:
            return this.xb;
        case 4:
            return this.sb;
        case 5:
            return !this.rb && (this.rb = new $61de1ee1cac498ae$var$jUd(this, $61de1ee1cac498ae$var$d5, this)), this.rb;
        case 6:
            return !this.vb && (this.vb = new $61de1ee1cac498ae$var$gUd($61de1ee1cac498ae$var$o5, this, 6, 7)), this.vb;
        case 7:
            if (b) return this.Db >> 16 == 7 ? $61de1ee1cac498ae$var$BD(this.Cb, 235) : null;
            return $61de1ee1cac498ae$var$Ind(this);
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$cGd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function iod(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 4:
            !!this.sb && (c = $61de1ee1cac498ae$var$BD(this.sb, 49).ih(this, 1, $61de1ee1cac498ae$var$i5, c));
            return $61de1ee1cac498ae$var$Jnd(this, $61de1ee1cac498ae$var$BD(a, 471), c);
        case 5:
            return !this.rb && (this.rb = new $61de1ee1cac498ae$var$jUd(this, $61de1ee1cac498ae$var$d5, this)), $61de1ee1cac498ae$var$Sxd(this.rb, a, c);
        case 6:
            return !this.vb && (this.vb = new $61de1ee1cac498ae$var$gUd($61de1ee1cac498ae$var$o5, this, 6, 7)), $61de1ee1cac498ae$var$Sxd(this.vb, a, c);
        case 7:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$Snd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 7, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function jod(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 4:
            return $61de1ee1cac498ae$var$Jnd(this, null, c);
        case 5:
            return !this.rb && (this.rb = new $61de1ee1cac498ae$var$jUd(this, $61de1ee1cac498ae$var$d5, this)), $61de1ee1cac498ae$var$Txd(this.rb, a, c);
        case 6:
            return !this.vb && (this.vb = new $61de1ee1cac498ae$var$gUd($61de1ee1cac498ae$var$o5, this, 6, 7)), $61de1ee1cac498ae$var$Txd(this.vb, a, c);
        case 7:
            return $61de1ee1cac498ae$var$_hd(this, null, 7, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function kod(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.yb != null;
        case 3:
            return this.xb != null;
        case 4:
            return !!this.sb;
        case 5:
            return !!this.rb && this.rb.i != 0;
        case 6:
            return !!this.vb && this.vb.i != 0;
        case 7:
            return !!$61de1ee1cac498ae$var$Ind(this);
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$cGd : b), a));
};
$61de1ee1cac498ae$var$_.oh = function lod(a) {
    var b;
    b = $61de1ee1cac498ae$var$Und(this, a);
    return b ? b : $61de1ee1cac498ae$var$Bmd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function mod(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$dod(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 3:
            $61de1ee1cac498ae$var$cod(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 4:
            $61de1ee1cac498ae$var$bod(this, $61de1ee1cac498ae$var$BD(b, 471));
            return;
        case 5:
            !this.rb && (this.rb = new $61de1ee1cac498ae$var$jUd(this, $61de1ee1cac498ae$var$d5, this));
            $61de1ee1cac498ae$var$Uxd(this.rb);
            !this.rb && (this.rb = new $61de1ee1cac498ae$var$jUd(this, $61de1ee1cac498ae$var$d5, this));
            $61de1ee1cac498ae$var$ytd(this.rb, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 6:
            !this.vb && (this.vb = new $61de1ee1cac498ae$var$gUd($61de1ee1cac498ae$var$o5, this, 6, 7));
            $61de1ee1cac498ae$var$Uxd(this.vb);
            !this.vb && (this.vb = new $61de1ee1cac498ae$var$gUd($61de1ee1cac498ae$var$o5, this, 6, 7));
            $61de1ee1cac498ae$var$ytd(this.vb, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$cGd : c), a), b);
};
$61de1ee1cac498ae$var$_.vh = function nod(a) {
    var b, c;
    if (!!a && !!this.rb) for(c = new $61de1ee1cac498ae$var$Fyd(this.rb); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$Dyd(c);
        $61de1ee1cac498ae$var$JD(b, 351) && ($61de1ee1cac498ae$var$BD(b, 351).w = null);
    }
    $61de1ee1cac498ae$var$Cjd(this, 64, a);
};
$61de1ee1cac498ae$var$_.zh = function ood() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd;
};
$61de1ee1cac498ae$var$_.Bh = function pod(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$dod(this, null);
            return;
        case 3:
            $61de1ee1cac498ae$var$cod(this, null);
            return;
        case 4:
            $61de1ee1cac498ae$var$bod(this, null);
            return;
        case 5:
            !this.rb && (this.rb = new $61de1ee1cac498ae$var$jUd(this, $61de1ee1cac498ae$var$d5, this));
            $61de1ee1cac498ae$var$Uxd(this.rb);
            return;
        case 6:
            !this.vb && (this.vb = new $61de1ee1cac498ae$var$gUd($61de1ee1cac498ae$var$o5, this, 6, 7));
            $61de1ee1cac498ae$var$Uxd(this.vb);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$cGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$cGd : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function qod() {
    $61de1ee1cac498ae$var$Tnd(this);
};
$61de1ee1cac498ae$var$_.Mh = function rod() {
    return !this.rb && (this.rb = new $61de1ee1cac498ae$var$jUd(this, $61de1ee1cac498ae$var$d5, this)), this.rb;
};
$61de1ee1cac498ae$var$_.Nh = function sod() {
    return this.sb;
};
$61de1ee1cac498ae$var$_.Oh = function tod() {
    return this.ub;
};
$61de1ee1cac498ae$var$_.Ph = function uod() {
    return this.xb;
};
$61de1ee1cac498ae$var$_.Qh = function vod() {
    return this.yb;
};
$61de1ee1cac498ae$var$_.Rh = function wod(a) {
    this.ub = a;
};
$61de1ee1cac498ae$var$_.Ib = function xod() {
    var a;
    if ((this.Db & 64) != 0) return $61de1ee1cac498ae$var$qnd(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$qnd(this));
    a.a += " (nsURI: ";
    $61de1ee1cac498ae$var$Efb(a, this.yb);
    a.a += ", nsPrefix: ";
    $61de1ee1cac498ae$var$Efb(a, this.xb);
    a.a += ")";
    return a.a;
};
$61de1ee1cac498ae$var$_.xb = null;
$61de1ee1cac498ae$var$_.yb = null;
var $61de1ee1cac498ae$var$And;
var $61de1ee1cac498ae$var$t6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EPackageImpl", 179);
$61de1ee1cac498ae$var$bcb(555, 179, {
    105: 1,
    2016: 1,
    555: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    235: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    179: 1,
    114: 1,
    115: 1,
    675: 1
}, $61de1ee1cac498ae$var$Bod);
$61de1ee1cac498ae$var$_.q = false;
$61de1ee1cac498ae$var$_.r = false;
var $61de1ee1cac498ae$var$yod = false;
var $61de1ee1cac498ae$var$O2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkGraphPackageImpl", 555);
$61de1ee1cac498ae$var$bcb(354, 724, {
    105: 1,
    413: 1,
    160: 1,
    137: 1,
    470: 1,
    354: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$Jod);
$61de1ee1cac498ae$var$_.Qg = function Kod(a) {
    return $61de1ee1cac498ae$var$Eod(this, a);
};
$61de1ee1cac498ae$var$_._g = function Lod(a, b, c) {
    switch(a){
        case 7:
            return $61de1ee1cac498ae$var$Fod(this);
        case 8:
            return this.a;
    }
    return $61de1ee1cac498ae$var$Xkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.hh = function Mod(a, b, c) {
    var d;
    switch(b){
        case 7:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? $61de1ee1cac498ae$var$Eod(this, c) : this.Cb.ih(this, -1 - d, null, c)));
            return $61de1ee1cac498ae$var$Dod(this, $61de1ee1cac498ae$var$BD(a, 160), c);
    }
    return $61de1ee1cac498ae$var$Fkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.jh = function Nod(a, b, c) {
    if (b == 7) return $61de1ee1cac498ae$var$Dod(this, null, c);
    return $61de1ee1cac498ae$var$Gkd(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function Ood(a) {
    switch(a){
        case 7:
            return !!$61de1ee1cac498ae$var$Fod(this);
        case 8:
            return !$61de1ee1cac498ae$var$dfb("", this.a);
    }
    return $61de1ee1cac498ae$var$Ykd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function Pod(a, b) {
    switch(a){
        case 7:
            $61de1ee1cac498ae$var$God(this, $61de1ee1cac498ae$var$BD(b, 160));
            return;
        case 8:
            $61de1ee1cac498ae$var$Hod(this, $61de1ee1cac498ae$var$GD(b));
            return;
    }
    $61de1ee1cac498ae$var$Zkd(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function Qod() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Nhd;
};
$61de1ee1cac498ae$var$_.Bh = function Rod(a) {
    switch(a){
        case 7:
            $61de1ee1cac498ae$var$God(this, null);
            return;
        case 8:
            $61de1ee1cac498ae$var$Hod(this, "");
            return;
    }
    $61de1ee1cac498ae$var$$kd(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function Sod() {
    return $61de1ee1cac498ae$var$Iod(this);
};
$61de1ee1cac498ae$var$_.a = "";
var $61de1ee1cac498ae$var$P2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkLabelImpl", 354);
$61de1ee1cac498ae$var$bcb(239, 725, {
    105: 1,
    413: 1,
    82: 1,
    160: 1,
    33: 1,
    470: 1,
    239: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$apd);
$61de1ee1cac498ae$var$_.Qg = function bpd(a) {
    return $61de1ee1cac498ae$var$Uod(this, a);
};
$61de1ee1cac498ae$var$_._g = function cpd(a, b, c) {
    switch(a){
        case 9:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, this, 9, 9)), this.c;
        case 10:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11)), this.a;
        case 11:
            return $61de1ee1cac498ae$var$Xod(this);
        case 12:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, this, 12, 3)), this.b;
        case 13:
            return $61de1ee1cac498ae$var$Bcb(), !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11)), this.a.i > 0 ? true : false;
    }
    return $61de1ee1cac498ae$var$uld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.hh = function dpd(a, b, c) {
    var d;
    switch(b){
        case 9:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, this, 9, 9)), $61de1ee1cac498ae$var$Sxd(this.c, a, c);
        case 10:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11)), $61de1ee1cac498ae$var$Sxd(this.a, a, c);
        case 11:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? $61de1ee1cac498ae$var$Uod(this, c) : this.Cb.ih(this, -1 - d, null, c)));
            return $61de1ee1cac498ae$var$Tod(this, $61de1ee1cac498ae$var$BD(a, 33), c);
        case 12:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, this, 12, 3)), $61de1ee1cac498ae$var$Sxd(this.b, a, c);
    }
    return $61de1ee1cac498ae$var$vld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.jh = function epd(a, b, c) {
    switch(b){
        case 9:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, this, 9, 9)), $61de1ee1cac498ae$var$Txd(this.c, a, c);
        case 10:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11)), $61de1ee1cac498ae$var$Txd(this.a, a, c);
        case 11:
            return $61de1ee1cac498ae$var$Tod(this, null, c);
        case 12:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, this, 12, 3)), $61de1ee1cac498ae$var$Txd(this.b, a, c);
    }
    return $61de1ee1cac498ae$var$wld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function fpd(a) {
    switch(a){
        case 9:
            return !!this.c && this.c.i != 0;
        case 10:
            return !!this.a && this.a.i != 0;
        case 11:
            return !!$61de1ee1cac498ae$var$Xod(this);
        case 12:
            return !!this.b && this.b.i != 0;
        case 13:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11)), this.a.i > 0;
    }
    return $61de1ee1cac498ae$var$xld(this, a);
};
$61de1ee1cac498ae$var$_.sh = function gpd(a, b) {
    switch(a){
        case 9:
            !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, this, 9, 9));
            $61de1ee1cac498ae$var$Uxd(this.c);
            !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, this, 9, 9));
            $61de1ee1cac498ae$var$ytd(this.c, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 10:
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11));
            $61de1ee1cac498ae$var$Uxd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 11:
            $61de1ee1cac498ae$var$$od(this, $61de1ee1cac498ae$var$BD(b, 33));
            return;
        case 12:
            !this.b && (this.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, this, 12, 3));
            $61de1ee1cac498ae$var$Uxd(this.b);
            !this.b && (this.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, this, 12, 3));
            $61de1ee1cac498ae$var$ytd(this.b, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$yld(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function hpd() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Ohd;
};
$61de1ee1cac498ae$var$_.Bh = function ipd(a) {
    switch(a){
        case 9:
            !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$F2, this, 9, 9));
            $61de1ee1cac498ae$var$Uxd(this.c);
            return;
        case 10:
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$E2, this, 10, 11));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
        case 11:
            $61de1ee1cac498ae$var$$od(this, null);
            return;
        case 12:
            !this.b && (this.b = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$B2, this, 12, 3));
            $61de1ee1cac498ae$var$Uxd(this.b);
            return;
    }
    $61de1ee1cac498ae$var$zld(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function jpd() {
    return $61de1ee1cac498ae$var$_od(this);
};
var $61de1ee1cac498ae$var$Q2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkNodeImpl", 239);
$61de1ee1cac498ae$var$bcb(186, 725, {
    105: 1,
    413: 1,
    82: 1,
    160: 1,
    118: 1,
    470: 1,
    186: 1,
    94: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$ppd);
$61de1ee1cac498ae$var$_.Qg = function qpd(a) {
    return $61de1ee1cac498ae$var$lpd(this, a);
};
$61de1ee1cac498ae$var$_._g = function rpd(a, b, c) {
    if (a == 9) return $61de1ee1cac498ae$var$mpd(this);
    return $61de1ee1cac498ae$var$uld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.hh = function spd(a, b, c) {
    var d;
    switch(b){
        case 9:
            !!this.Cb && (c = (d = this.Db >> 16, d >= 0 ? $61de1ee1cac498ae$var$lpd(this, c) : this.Cb.ih(this, -1 - d, null, c)));
            return $61de1ee1cac498ae$var$kpd(this, $61de1ee1cac498ae$var$BD(a, 33), c);
    }
    return $61de1ee1cac498ae$var$vld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.jh = function tpd(a, b, c) {
    if (b == 9) return $61de1ee1cac498ae$var$kpd(this, null, c);
    return $61de1ee1cac498ae$var$wld(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function upd(a) {
    if (a == 9) return !!$61de1ee1cac498ae$var$mpd(this);
    return $61de1ee1cac498ae$var$xld(this, a);
};
$61de1ee1cac498ae$var$_.sh = function vpd(a, b) {
    switch(a){
        case 9:
            $61de1ee1cac498ae$var$npd(this, $61de1ee1cac498ae$var$BD(b, 33));
            return;
    }
    $61de1ee1cac498ae$var$yld(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function wpd() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Phd;
};
$61de1ee1cac498ae$var$_.Bh = function xpd(a) {
    switch(a){
        case 9:
            $61de1ee1cac498ae$var$npd(this, null);
            return;
    }
    $61de1ee1cac498ae$var$zld(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function ypd() {
    return $61de1ee1cac498ae$var$opd(this);
};
var $61de1ee1cac498ae$var$R2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkPortImpl", 186);
var $61de1ee1cac498ae$var$J4 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Tte, "BasicEMap/Entry");
$61de1ee1cac498ae$var$bcb(1092, 115, {
    105: 1,
    42: 1,
    92: 1,
    90: 1,
    133: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$Bpd);
$61de1ee1cac498ae$var$_.Fb = function Hpd(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.cd = function Jpd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Hb = function Lpd() {
    return $61de1ee1cac498ae$var$FCb(this);
};
$61de1ee1cac498ae$var$_.Uh = function Npd(a) {
    $61de1ee1cac498ae$var$zpd(this, $61de1ee1cac498ae$var$BD(a, 146));
};
$61de1ee1cac498ae$var$_._g = function Cpd(a, b, c) {
    switch(a){
        case 0:
            return this.b;
        case 1:
            return this.c;
    }
    return $61de1ee1cac498ae$var$fid(this, a, b, c);
};
$61de1ee1cac498ae$var$_.lh = function Dpd(a) {
    switch(a){
        case 0:
            return !!this.b;
        case 1:
            return this.c != null;
    }
    return $61de1ee1cac498ae$var$mid(this, a);
};
$61de1ee1cac498ae$var$_.sh = function Epd(a, b) {
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$zpd(this, $61de1ee1cac498ae$var$BD(b, 146));
            return;
        case 1:
            $61de1ee1cac498ae$var$Apd(this, b);
            return;
    }
    $61de1ee1cac498ae$var$yid(this, a, b);
};
$61de1ee1cac498ae$var$_.zh = function Fpd() {
    return $61de1ee1cac498ae$var$Thd(), $61de1ee1cac498ae$var$Qhd;
};
$61de1ee1cac498ae$var$_.Bh = function Gpd(a) {
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$zpd(this, null);
            return;
        case 1:
            $61de1ee1cac498ae$var$Apd(this, null);
            return;
    }
    $61de1ee1cac498ae$var$Cid(this, a);
};
$61de1ee1cac498ae$var$_.Sh = function Ipd() {
    var a;
    if (this.a == -1) {
        a = this.b;
        this.a = !a ? 0 : $61de1ee1cac498ae$var$tb(a);
    }
    return this.a;
};
$61de1ee1cac498ae$var$_.dd = function Kpd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.Th = function Mpd(a) {
    this.a = a;
};
$61de1ee1cac498ae$var$_.ed = function Opd(a) {
    var b;
    b = this.c;
    $61de1ee1cac498ae$var$Apd(this, a);
    return b;
};
$61de1ee1cac498ae$var$_.Ib = function Ppd() {
    var a;
    if ((this.Db & 64) != 0) return $61de1ee1cac498ae$var$Eid(this);
    a = new $61de1ee1cac498ae$var$Ufb;
    $61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb($61de1ee1cac498ae$var$Qfb(a, this.b ? this.b.tg() : $61de1ee1cac498ae$var$Xhe), $61de1ee1cac498ae$var$gne), $61de1ee1cac498ae$var$xfb(this.c));
    return a.a;
};
$61de1ee1cac498ae$var$_.a = -1;
$61de1ee1cac498ae$var$_.c = null;
var $61de1ee1cac498ae$var$S2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rte, "ElkPropertyToValueMapEntryImpl", 1092);
$61de1ee1cac498ae$var$bcb(984, 1, {}, $61de1ee1cac498ae$var$bqd);
var $61de1ee1cac498ae$var$U2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonAdapter", 984);
$61de1ee1cac498ae$var$bcb(210, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$cqd);
var $61de1ee1cac498ae$var$V2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImportException", 210);
$61de1ee1cac498ae$var$bcb(857, 1, {}, $61de1ee1cac498ae$var$ird);
var $61de1ee1cac498ae$var$J3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter", 857);
$61de1ee1cac498ae$var$bcb(891, 1, {}, $61de1ee1cac498ae$var$jrd);
var $61de1ee1cac498ae$var$W2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$0$Type", 891);
$61de1ee1cac498ae$var$bcb(892, 1, {}, $61de1ee1cac498ae$var$krd);
var $61de1ee1cac498ae$var$X2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$1$Type", 892);
$61de1ee1cac498ae$var$bcb(900, 1, {}, $61de1ee1cac498ae$var$lrd);
var $61de1ee1cac498ae$var$Y2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$10$Type", 900);
$61de1ee1cac498ae$var$bcb(902, 1, {}, $61de1ee1cac498ae$var$mrd);
var $61de1ee1cac498ae$var$Z2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$11$Type", 902);
$61de1ee1cac498ae$var$bcb(903, 1, {}, $61de1ee1cac498ae$var$nrd);
var $61de1ee1cac498ae$var$$2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$12$Type", 903);
$61de1ee1cac498ae$var$bcb(909, 1, {}, $61de1ee1cac498ae$var$ord);
var $61de1ee1cac498ae$var$_2 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$13$Type", 909);
$61de1ee1cac498ae$var$bcb(908, 1, {}, $61de1ee1cac498ae$var$prd);
var $61de1ee1cac498ae$var$a3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$14$Type", 908);
$61de1ee1cac498ae$var$bcb(904, 1, {}, $61de1ee1cac498ae$var$qrd);
var $61de1ee1cac498ae$var$b3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$15$Type", 904);
$61de1ee1cac498ae$var$bcb(905, 1, {}, $61de1ee1cac498ae$var$rrd);
var $61de1ee1cac498ae$var$c3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$16$Type", 905);
$61de1ee1cac498ae$var$bcb(906, 1, {}, $61de1ee1cac498ae$var$srd);
var $61de1ee1cac498ae$var$d3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$17$Type", 906);
$61de1ee1cac498ae$var$bcb(907, 1, {}, $61de1ee1cac498ae$var$trd);
var $61de1ee1cac498ae$var$e3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$18$Type", 907);
$61de1ee1cac498ae$var$bcb(912, 1, {}, $61de1ee1cac498ae$var$urd);
var $61de1ee1cac498ae$var$f3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$19$Type", 912);
$61de1ee1cac498ae$var$bcb(893, 1, {}, $61de1ee1cac498ae$var$vrd);
var $61de1ee1cac498ae$var$g3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$2$Type", 893);
$61de1ee1cac498ae$var$bcb(910, 1, {}, $61de1ee1cac498ae$var$wrd);
var $61de1ee1cac498ae$var$h3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$20$Type", 910);
$61de1ee1cac498ae$var$bcb(911, 1, {}, $61de1ee1cac498ae$var$xrd);
var $61de1ee1cac498ae$var$i3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$21$Type", 911);
$61de1ee1cac498ae$var$bcb(915, 1, {}, $61de1ee1cac498ae$var$yrd);
var $61de1ee1cac498ae$var$j3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$22$Type", 915);
$61de1ee1cac498ae$var$bcb(913, 1, {}, $61de1ee1cac498ae$var$zrd);
var $61de1ee1cac498ae$var$k3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$23$Type", 913);
$61de1ee1cac498ae$var$bcb(914, 1, {}, $61de1ee1cac498ae$var$Ard);
var $61de1ee1cac498ae$var$l3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$24$Type", 914);
$61de1ee1cac498ae$var$bcb(917, 1, {}, $61de1ee1cac498ae$var$Brd);
var $61de1ee1cac498ae$var$m3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$25$Type", 917);
$61de1ee1cac498ae$var$bcb(916, 1, {}, $61de1ee1cac498ae$var$Crd);
var $61de1ee1cac498ae$var$n3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$26$Type", 916);
$61de1ee1cac498ae$var$bcb(918, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Drd);
$61de1ee1cac498ae$var$_.td = function Erd(a) {
    $61de1ee1cac498ae$var$Bqd(this.b, this.a, $61de1ee1cac498ae$var$GD(a));
};
var $61de1ee1cac498ae$var$o3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$27$Type", 918);
$61de1ee1cac498ae$var$bcb(919, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Frd);
$61de1ee1cac498ae$var$_.td = function Grd(a) {
    $61de1ee1cac498ae$var$Cqd(this.b, this.a, $61de1ee1cac498ae$var$GD(a));
};
var $61de1ee1cac498ae$var$p3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$28$Type", 919);
$61de1ee1cac498ae$var$bcb(920, 1, {}, $61de1ee1cac498ae$var$Hrd);
var $61de1ee1cac498ae$var$q3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$29$Type", 920);
$61de1ee1cac498ae$var$bcb(896, 1, {}, $61de1ee1cac498ae$var$Ird);
var $61de1ee1cac498ae$var$r3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$3$Type", 896);
$61de1ee1cac498ae$var$bcb(921, 1, {}, $61de1ee1cac498ae$var$Jrd);
var $61de1ee1cac498ae$var$s3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$30$Type", 921);
$61de1ee1cac498ae$var$bcb(922, 1, {}, $61de1ee1cac498ae$var$Krd);
var $61de1ee1cac498ae$var$t3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$31$Type", 922);
$61de1ee1cac498ae$var$bcb(923, 1, {}, $61de1ee1cac498ae$var$Lrd);
var $61de1ee1cac498ae$var$u3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$32$Type", 923);
$61de1ee1cac498ae$var$bcb(924, 1, {}, $61de1ee1cac498ae$var$Mrd);
var $61de1ee1cac498ae$var$v3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$33$Type", 924);
$61de1ee1cac498ae$var$bcb(925, 1, {}, $61de1ee1cac498ae$var$Nrd);
var $61de1ee1cac498ae$var$w3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$34$Type", 925);
$61de1ee1cac498ae$var$bcb(859, 1, {}, $61de1ee1cac498ae$var$Prd);
var $61de1ee1cac498ae$var$x3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$35$Type", 859);
$61de1ee1cac498ae$var$bcb(929, 1, {}, $61de1ee1cac498ae$var$Rrd);
var $61de1ee1cac498ae$var$y3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$36$Type", 929);
$61de1ee1cac498ae$var$bcb(926, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Srd);
$61de1ee1cac498ae$var$_.td = function Trd(a) {
    $61de1ee1cac498ae$var$Lqd(this.a, $61de1ee1cac498ae$var$BD(a, 469));
};
var $61de1ee1cac498ae$var$z3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$37$Type", 926);
$61de1ee1cac498ae$var$bcb(927, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Urd);
$61de1ee1cac498ae$var$_.td = function Vrd(a) {
    $61de1ee1cac498ae$var$Mqd(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 202));
};
var $61de1ee1cac498ae$var$A3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$38$Type", 927);
$61de1ee1cac498ae$var$bcb(928, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Wrd);
$61de1ee1cac498ae$var$_.td = function Xrd(a) {
    $61de1ee1cac498ae$var$Nqd(this.a, this.b, $61de1ee1cac498ae$var$BD(a, 202));
};
var $61de1ee1cac498ae$var$B3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$39$Type", 928);
$61de1ee1cac498ae$var$bcb(894, 1, {}, $61de1ee1cac498ae$var$Yrd);
var $61de1ee1cac498ae$var$C3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$4$Type", 894);
$61de1ee1cac498ae$var$bcb(930, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$Zrd);
$61de1ee1cac498ae$var$_.td = function $rd(a) {
    $61de1ee1cac498ae$var$Oqd(this.a, $61de1ee1cac498ae$var$BD(a, 8));
};
var $61de1ee1cac498ae$var$D3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$40$Type", 930);
$61de1ee1cac498ae$var$bcb(895, 1, {}, $61de1ee1cac498ae$var$_rd);
var $61de1ee1cac498ae$var$E3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$5$Type", 895);
$61de1ee1cac498ae$var$bcb(899, 1, {}, $61de1ee1cac498ae$var$asd);
var $61de1ee1cac498ae$var$F3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$6$Type", 899);
$61de1ee1cac498ae$var$bcb(897, 1, {}, $61de1ee1cac498ae$var$bsd);
var $61de1ee1cac498ae$var$G3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$7$Type", 897);
$61de1ee1cac498ae$var$bcb(898, 1, {}, $61de1ee1cac498ae$var$csd);
var $61de1ee1cac498ae$var$H3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$8$Type", 898);
$61de1ee1cac498ae$var$bcb(901, 1, {}, $61de1ee1cac498ae$var$dsd);
var $61de1ee1cac498ae$var$I3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonImporter/lambda$9$Type", 901);
$61de1ee1cac498ae$var$bcb(948, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$msd);
$61de1ee1cac498ae$var$_.td = function nsd(a) {
    $61de1ee1cac498ae$var$Qpd(this.a, new $61de1ee1cac498ae$var$yC($61de1ee1cac498ae$var$GD(a)));
};
var $61de1ee1cac498ae$var$K3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonMetaDataConverter/lambda$0$Type", 948);
$61de1ee1cac498ae$var$bcb(949, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$osd);
$61de1ee1cac498ae$var$_.td = function psd(a) {
    $61de1ee1cac498ae$var$isd(this.a, $61de1ee1cac498ae$var$BD(a, 237));
};
var $61de1ee1cac498ae$var$L3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonMetaDataConverter/lambda$1$Type", 949);
$61de1ee1cac498ae$var$bcb(950, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$qsd);
$61de1ee1cac498ae$var$_.td = function rsd(a) {
    $61de1ee1cac498ae$var$jsd(this.a, $61de1ee1cac498ae$var$BD(a, 149));
};
var $61de1ee1cac498ae$var$M3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonMetaDataConverter/lambda$2$Type", 950);
$61de1ee1cac498ae$var$bcb(951, 1, $61de1ee1cac498ae$var$qie, $61de1ee1cac498ae$var$ssd);
$61de1ee1cac498ae$var$_.td = function tsd(a) {
    $61de1ee1cac498ae$var$ksd(this.a, $61de1ee1cac498ae$var$BD(a, 175));
};
var $61de1ee1cac498ae$var$N3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Wte, "JsonMetaDataConverter/lambda$3$Type", 951);
$61de1ee1cac498ae$var$bcb(237, 22, {
    3: 1,
    35: 1,
    22: 1,
    237: 1
}, $61de1ee1cac498ae$var$Dsd);
var $61de1ee1cac498ae$var$usd, $61de1ee1cac498ae$var$vsd, $61de1ee1cac498ae$var$wsd, $61de1ee1cac498ae$var$xsd, $61de1ee1cac498ae$var$ysd, $61de1ee1cac498ae$var$zsd, $61de1ee1cac498ae$var$Asd, $61de1ee1cac498ae$var$Bsd;
var $61de1ee1cac498ae$var$O3 = $61de1ee1cac498ae$var$ndb($61de1ee1cac498ae$var$Hle, "GraphFeature", 237, $61de1ee1cac498ae$var$CI, $61de1ee1cac498ae$var$Fsd, $61de1ee1cac498ae$var$Esd);
var $61de1ee1cac498ae$var$Gsd;
$61de1ee1cac498ae$var$bcb(13, 1, {
    35: 1,
    146: 1
}, $61de1ee1cac498ae$var$Lsd, $61de1ee1cac498ae$var$Msd, $61de1ee1cac498ae$var$Nsd, $61de1ee1cac498ae$var$Osd);
$61de1ee1cac498ae$var$_.wd = function Psd(a) {
    return $61de1ee1cac498ae$var$Isd(this, $61de1ee1cac498ae$var$BD(a, 146));
};
$61de1ee1cac498ae$var$_.Fb = function Qsd(a) {
    return $61de1ee1cac498ae$var$Jsd(this, a);
};
$61de1ee1cac498ae$var$_.wg = function Rsd() {
    return $61de1ee1cac498ae$var$Ksd(this);
};
$61de1ee1cac498ae$var$_.tg = function Ssd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Hb = function Tsd() {
    return $61de1ee1cac498ae$var$LCb(this.b);
};
$61de1ee1cac498ae$var$_.Ib = function Usd() {
    return this.b;
};
var $61de1ee1cac498ae$var$T3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hle, "Property", 13);
$61de1ee1cac498ae$var$bcb(818, 1, $61de1ee1cac498ae$var$Dke, $61de1ee1cac498ae$var$Wsd);
$61de1ee1cac498ae$var$_.ue = function Xsd(a, b) {
    return $61de1ee1cac498ae$var$Vsd(this, $61de1ee1cac498ae$var$BD(a, 94), $61de1ee1cac498ae$var$BD(b, 94));
};
$61de1ee1cac498ae$var$_.Fb = function Ysd(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.ve = function Zsd() {
    return new $61de1ee1cac498ae$var$tpb(this);
};
var $61de1ee1cac498ae$var$S3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Hle, "PropertyHolderComparator", 818);
$61de1ee1cac498ae$var$bcb(695, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$qtd);
$61de1ee1cac498ae$var$_.Nb = function rtd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function ttd() {
    return $61de1ee1cac498ae$var$ptd(this);
};
$61de1ee1cac498ae$var$_.Qb = function utd() {
    $61de1ee1cac498ae$var$Srb();
};
$61de1ee1cac498ae$var$_.Ob = function std() {
    return !!this.a;
};
var $61de1ee1cac498ae$var$U3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jue, "ElkGraphUtil/AncestorIterator", 695);
var $61de1ee1cac498ae$var$T4 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Tte, "EList");
$61de1ee1cac498ae$var$bcb(67, 52, {
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    67: 1,
    58: 1
});
$61de1ee1cac498ae$var$_.Vc = function Jtd(a, b) {
    $61de1ee1cac498ae$var$vtd(this, a, b);
};
$61de1ee1cac498ae$var$_.Fc = function Ktd(a) {
    return $61de1ee1cac498ae$var$wtd(this, a);
};
$61de1ee1cac498ae$var$_.Wc = function Ltd(a, b) {
    return $61de1ee1cac498ae$var$xtd(this, a, b);
};
$61de1ee1cac498ae$var$_.Gc = function Mtd(a) {
    return $61de1ee1cac498ae$var$ytd(this, a);
};
$61de1ee1cac498ae$var$_.Zh = function Ntd() {
    return new $61de1ee1cac498ae$var$$yd(this);
};
$61de1ee1cac498ae$var$_.$h = function Otd() {
    return new $61de1ee1cac498ae$var$bzd(this);
};
$61de1ee1cac498ae$var$_._h = function Ptd(a) {
    return $61de1ee1cac498ae$var$ztd(this, a);
};
$61de1ee1cac498ae$var$_.ai = function Qtd() {
    return true;
};
$61de1ee1cac498ae$var$_.bi = function Rtd(a, b) {};
$61de1ee1cac498ae$var$_.ci = function Std() {};
$61de1ee1cac498ae$var$_.di = function Ttd(a, b) {
    $61de1ee1cac498ae$var$Atd(this, a, b);
};
$61de1ee1cac498ae$var$_.ei = function Utd(a, b, c) {};
$61de1ee1cac498ae$var$_.fi = function Vtd(a, b) {};
$61de1ee1cac498ae$var$_.gi = function Wtd(a, b, c) {};
$61de1ee1cac498ae$var$_.Fb = function Xtd(a) {
    return $61de1ee1cac498ae$var$Btd(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function Ytd() {
    return $61de1ee1cac498ae$var$Etd(this);
};
$61de1ee1cac498ae$var$_.hi = function Ztd() {
    return false;
};
$61de1ee1cac498ae$var$_.Kc = function $td() {
    return new $61de1ee1cac498ae$var$Fyd(this);
};
$61de1ee1cac498ae$var$_.Yc = function _td() {
    return new $61de1ee1cac498ae$var$Oyd(this);
};
$61de1ee1cac498ae$var$_.Zc = function aud(a) {
    var b;
    b = this.gc();
    if (a < 0 || a > b) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(a, b));
    return new $61de1ee1cac498ae$var$Pyd(this, a);
};
$61de1ee1cac498ae$var$_.ji = function bud(a, b) {
    this.ii(a, this.Xc(b));
};
$61de1ee1cac498ae$var$_.Mc = function cud(a) {
    return $61de1ee1cac498ae$var$Ftd(this, a);
};
$61de1ee1cac498ae$var$_.li = function dud(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_._c = function eud(a, b) {
    return $61de1ee1cac498ae$var$Gtd(this, a, b);
};
$61de1ee1cac498ae$var$_.Ib = function fud() {
    return $61de1ee1cac498ae$var$Htd(this);
};
$61de1ee1cac498ae$var$_.ni = function gud() {
    return true;
};
$61de1ee1cac498ae$var$_.oi = function hud(a, b) {
    return $61de1ee1cac498ae$var$Itd(this, b);
};
var $61de1ee1cac498ae$var$p4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractEList", 67);
$61de1ee1cac498ae$var$bcb(63, 67, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$yud, $61de1ee1cac498ae$var$zud, $61de1ee1cac498ae$var$Aud);
$61de1ee1cac498ae$var$_.Vh = function Bud(a, b) {
    return $61de1ee1cac498ae$var$iud(this, a, b);
};
$61de1ee1cac498ae$var$_.Wh = function Cud(a) {
    return $61de1ee1cac498ae$var$jud(this, a);
};
$61de1ee1cac498ae$var$_.Xh = function Dud(a, b) {
    $61de1ee1cac498ae$var$kud(this, a, b);
};
$61de1ee1cac498ae$var$_.Yh = function Eud(a) {
    $61de1ee1cac498ae$var$lud(this, a);
};
$61de1ee1cac498ae$var$_.pi = function Fud(a) {
    return $61de1ee1cac498ae$var$nud(this, a);
};
$61de1ee1cac498ae$var$_.$b = function Gud() {
    $61de1ee1cac498ae$var$oud(this);
};
$61de1ee1cac498ae$var$_.Hc = function Hud(a) {
    return $61de1ee1cac498ae$var$pud(this, a);
};
$61de1ee1cac498ae$var$_.Xb = function Iud(a) {
    return $61de1ee1cac498ae$var$qud(this, a);
};
$61de1ee1cac498ae$var$_.qi = function Jud(a) {
    var b, c, d;
    ++this.j;
    c = this.g == null ? 0 : this.g.length;
    if (a > c) {
        d = this.g;
        b = c + (c / 2 | 0) + 4;
        b < a && (b = a);
        this.g = this.ri(b);
        d != null && $61de1ee1cac498ae$var$$fb(d, 0, this.g, 0, this.i);
    }
};
$61de1ee1cac498ae$var$_.Xc = function Kud(a) {
    return $61de1ee1cac498ae$var$rud(this, a);
};
$61de1ee1cac498ae$var$_.dc = function Lud() {
    return this.i == 0;
};
$61de1ee1cac498ae$var$_.ii = function Mud(a, b) {
    return $61de1ee1cac498ae$var$sud(this, a, b);
};
$61de1ee1cac498ae$var$_.ri = function Nud(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, a, 5, 1);
};
$61de1ee1cac498ae$var$_.ki = function Oud(a) {
    return this.g[a];
};
$61de1ee1cac498ae$var$_.$c = function Pud(a) {
    return $61de1ee1cac498ae$var$tud(this, a);
};
$61de1ee1cac498ae$var$_.mi = function Qud(a, b) {
    return $61de1ee1cac498ae$var$uud(this, a, b);
};
$61de1ee1cac498ae$var$_.gc = function Rud() {
    return this.i;
};
$61de1ee1cac498ae$var$_.Pc = function Sud() {
    return $61de1ee1cac498ae$var$wud(this);
};
$61de1ee1cac498ae$var$_.Qc = function Tud(a) {
    return $61de1ee1cac498ae$var$xud(this, a);
};
$61de1ee1cac498ae$var$_.i = 0;
var $61de1ee1cac498ae$var$y4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEList", 63);
var $61de1ee1cac498ae$var$X4 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Tte, "TreeIterator");
$61de1ee1cac498ae$var$bcb(694, 63, $61de1ee1cac498ae$var$pue);
$61de1ee1cac498ae$var$_.Nb = function Xud(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function Yud() {
    return this.g == null && !this.c ? $61de1ee1cac498ae$var$Uud(this) : this.g == null || this.i != 0 && $61de1ee1cac498ae$var$BD(this.g[this.i - 1], 47).Ob();
};
$61de1ee1cac498ae$var$_.Pb = function Zud() {
    return $61de1ee1cac498ae$var$Vud(this);
};
$61de1ee1cac498ae$var$_.Qb = function $ud() {
    if (!this.e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("There is no valid object to remove."));
    this.e.Qb();
};
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$q4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractTreeIterator", 694);
$61de1ee1cac498ae$var$bcb(685, 694, $61de1ee1cac498ae$var$pue, $61de1ee1cac498ae$var$_ud);
$61de1ee1cac498ae$var$_.si = function avd(a) {
    var b;
    b = $61de1ee1cac498ae$var$BD(a, 56).Wg().Kc();
    $61de1ee1cac498ae$var$JD(b, 279) && $61de1ee1cac498ae$var$BD(b, 279).Nk(new $61de1ee1cac498ae$var$bvd);
    return b;
};
var $61de1ee1cac498ae$var$W3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jue, "ElkGraphUtil/PropertiesSkippingTreeIterator", 685);
$61de1ee1cac498ae$var$bcb(952, 1, {}, $61de1ee1cac498ae$var$bvd);
var $61de1ee1cac498ae$var$V3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jue, "ElkGraphUtil/PropertiesSkippingTreeIterator/1", 952);
var $61de1ee1cac498ae$var$cvd, $61de1ee1cac498ae$var$dvd;
var $61de1ee1cac498ae$var$Y3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jue, "ElkReflect", null);
$61de1ee1cac498ae$var$bcb(889, 1, $61de1ee1cac498ae$var$hse, $61de1ee1cac498ae$var$jvd);
$61de1ee1cac498ae$var$_.vg = function kvd(a) {
    return $61de1ee1cac498ae$var$evd(), $61de1ee1cac498ae$var$sqb($61de1ee1cac498ae$var$BD(a, 174));
};
var $61de1ee1cac498ae$var$X3 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$jue, "ElkReflect/lambda$0$Type", 889);
var $61de1ee1cac498ae$var$lvd;
var $61de1ee1cac498ae$var$W4 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Tte, "ResourceLocator");
$61de1ee1cac498ae$var$bcb(1051, 1, {});
var $61de1ee1cac498ae$var$N4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "DelegatingResourceLocator", 1051);
$61de1ee1cac498ae$var$bcb(1052, 1051, {});
var $61de1ee1cac498ae$var$Z3 = $61de1ee1cac498ae$var$mdb("org.eclipse.emf.common", "EMFPlugin", 1052);
var $61de1ee1cac498ae$var$$3 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$cve, "Adapter");
var $61de1ee1cac498ae$var$_3 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$cve, "Notification");
$61de1ee1cac498ae$var$bcb(1153, 1, $61de1ee1cac498ae$var$dve);
$61de1ee1cac498ae$var$_.ti = function vvd() {
    return this.d;
};
$61de1ee1cac498ae$var$_.ui = function wvd(a) {};
$61de1ee1cac498ae$var$_.vi = function xvd(a) {
    this.d = a;
};
$61de1ee1cac498ae$var$_.wi = function yvd(a) {
    this.d == a && (this.d = null);
};
$61de1ee1cac498ae$var$_.d = null;
var $61de1ee1cac498ae$var$a4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "AdapterImpl", 1153);
$61de1ee1cac498ae$var$bcb(1995, 67, $61de1ee1cac498ae$var$eve);
$61de1ee1cac498ae$var$_.Vh = function Fvd(a, b) {
    return $61de1ee1cac498ae$var$zvd(this, a, b);
};
$61de1ee1cac498ae$var$_.Wh = function Gvd(a) {
    var b, c, d;
    ++this.j;
    if (a.dc()) return false;
    else {
        b = this.Vi();
        for(d = a.Kc(); d.Ob();){
            c = d.Pb();
            this.Ii(this.oi(b, c));
            ++b;
        }
        return true;
    }
};
$61de1ee1cac498ae$var$_.Xh = function Hvd(a, b) {
    $61de1ee1cac498ae$var$Avd(this, a, b);
};
$61de1ee1cac498ae$var$_.Yh = function Ivd(a) {
    $61de1ee1cac498ae$var$Bvd(this, a);
};
$61de1ee1cac498ae$var$_.Gi = function Jvd() {
    return this.Ji();
};
$61de1ee1cac498ae$var$_.$b = function Kvd() {
    $61de1ee1cac498ae$var$Cvd(this, this.Vi(), this.Wi());
};
$61de1ee1cac498ae$var$_.Hc = function Lvd(a) {
    return this.Li(a);
};
$61de1ee1cac498ae$var$_.Ic = function Mvd(a) {
    return this.Mi(a);
};
$61de1ee1cac498ae$var$_.Hi = function Nvd(a, b) {
    this.Si().jm();
};
$61de1ee1cac498ae$var$_.Ii = function Ovd(a) {
    this.Si().jm();
};
$61de1ee1cac498ae$var$_.Ji = function Pvd() {
    return this.Si();
};
$61de1ee1cac498ae$var$_.Ki = function Qvd() {
    this.Si().jm();
};
$61de1ee1cac498ae$var$_.Li = function Rvd(a) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Mi = function Svd(a) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Ni = function Tvd(a) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Oi = function Uvd(a) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Pi = function Vvd() {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Qi = function Wvd(a) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Ri = function Xvd() {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Ti = function Yvd(a) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Ui = function Zvd(a, b) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Vi = function $vd() {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Wi = function _vd() {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Xi = function awd(a) {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Yi = function bwd() {
    return this.Si().jm();
};
$61de1ee1cac498ae$var$_.Fb = function cwd(a) {
    return this.Ni(a);
};
$61de1ee1cac498ae$var$_.Xb = function dwd(a) {
    return this.li(a, this.Oi(a));
};
$61de1ee1cac498ae$var$_.Hb = function ewd() {
    return this.Pi();
};
$61de1ee1cac498ae$var$_.Xc = function fwd(a) {
    return this.Qi(a);
};
$61de1ee1cac498ae$var$_.dc = function gwd() {
    return this.Ri();
};
$61de1ee1cac498ae$var$_.ii = function hwd(a, b) {
    return $61de1ee1cac498ae$var$Dvd(this, a, b);
};
$61de1ee1cac498ae$var$_.ki = function iwd(a) {
    return this.Oi(a);
};
$61de1ee1cac498ae$var$_.$c = function jwd(a) {
    return $61de1ee1cac498ae$var$Evd(this, a);
};
$61de1ee1cac498ae$var$_.Mc = function kwd(a) {
    var b;
    b = this.Xc(a);
    if (b >= 0) {
        this.$c(b);
        return true;
    } else return false;
};
$61de1ee1cac498ae$var$_.mi = function lwd(a, b) {
    return this.Ui(a, this.oi(a, b));
};
$61de1ee1cac498ae$var$_.gc = function mwd() {
    return this.Vi();
};
$61de1ee1cac498ae$var$_.Pc = function nwd() {
    return this.Wi();
};
$61de1ee1cac498ae$var$_.Qc = function owd(a) {
    return this.Xi(a);
};
$61de1ee1cac498ae$var$_.Ib = function pwd() {
    return this.Yi();
};
var $61de1ee1cac498ae$var$M4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "DelegatingEList", 1995);
$61de1ee1cac498ae$var$bcb(1996, 1995, $61de1ee1cac498ae$var$eve);
$61de1ee1cac498ae$var$_.Vh = function xwd(a, b) {
    return $61de1ee1cac498ae$var$qwd(this, a, b);
};
$61de1ee1cac498ae$var$_.Wh = function ywd(a) {
    return this.Vh(this.Vi(), a);
};
$61de1ee1cac498ae$var$_.Xh = function zwd(a, b) {
    $61de1ee1cac498ae$var$rwd(this, a, b);
};
$61de1ee1cac498ae$var$_.Yh = function Awd(a) {
    $61de1ee1cac498ae$var$swd(this, a);
};
$61de1ee1cac498ae$var$_.ai = function Bwd() {
    return !this.bj();
};
$61de1ee1cac498ae$var$_.$b = function Cwd() {
    $61de1ee1cac498ae$var$vwd(this);
};
$61de1ee1cac498ae$var$_.Zi = function Dwd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$Cxd(this, a, b, c, d, e);
};
$61de1ee1cac498ae$var$_.$i = function Ewd(a) {
    $61de1ee1cac498ae$var$Uhd(this.Ai(), a);
};
$61de1ee1cac498ae$var$_._i = function Fwd() {
    return null;
};
$61de1ee1cac498ae$var$_.aj = function Gwd() {
    return -1;
};
$61de1ee1cac498ae$var$_.Ai = function Hwd() {
    return null;
};
$61de1ee1cac498ae$var$_.bj = function Iwd() {
    return false;
};
$61de1ee1cac498ae$var$_.cj = function Jwd(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.dj = function Kwd(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.ej = function Lwd() {
    return false;
};
$61de1ee1cac498ae$var$_.fj = function Mwd() {
    return !this.Ri();
};
$61de1ee1cac498ae$var$_.ii = function Nwd(a, b) {
    var c, d;
    if (this.ej()) {
        d = this.fj();
        c = $61de1ee1cac498ae$var$Dvd(this, a, b);
        this.$i(this.Zi(7, $61de1ee1cac498ae$var$meb(b), c, a, d));
        return c;
    } else return $61de1ee1cac498ae$var$Dvd(this, a, b);
};
$61de1ee1cac498ae$var$_.$c = function Owd(a) {
    var b, c, d, e;
    if (this.ej()) {
        c = null;
        d = this.fj();
        b = this.Zi(4, e = $61de1ee1cac498ae$var$Evd(this, a), null, a, d);
        if (this.bj() && !!e) {
            c = this.dj(e, c);
            if (!c) this.$i(b);
            else {
                c.Ei(b);
                c.Fi();
            }
        } else if (!c) this.$i(b);
        else {
            c.Ei(b);
            c.Fi();
        }
        return e;
    } else {
        e = $61de1ee1cac498ae$var$Evd(this, a);
        if (this.bj() && !!e) {
            c = this.dj(e, null);
            !!c && c.Fi();
        }
        return e;
    }
};
$61de1ee1cac498ae$var$_.mi = function Pwd(a, b) {
    return $61de1ee1cac498ae$var$wwd(this, a, b);
};
var $61de1ee1cac498ae$var$d4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "DelegatingNotifyingListImpl", 1996);
$61de1ee1cac498ae$var$bcb(143, 1, $61de1ee1cac498ae$var$fve);
$61de1ee1cac498ae$var$_.Ei = function pxd(a) {
    return $61de1ee1cac498ae$var$Qwd(this, a);
};
$61de1ee1cac498ae$var$_.Fi = function qxd() {
    $61de1ee1cac498ae$var$Rwd(this);
};
$61de1ee1cac498ae$var$_.xi = function rxd() {
    return this.d;
};
$61de1ee1cac498ae$var$_._i = function sxd() {
    return null;
};
$61de1ee1cac498ae$var$_.gj = function txd() {
    return null;
};
$61de1ee1cac498ae$var$_.yi = function uxd(a) {
    return -1;
};
$61de1ee1cac498ae$var$_.zi = function vxd() {
    return $61de1ee1cac498ae$var$$wd(this);
};
$61de1ee1cac498ae$var$_.Ai = function wxd() {
    return null;
};
$61de1ee1cac498ae$var$_.Bi = function xxd() {
    return $61de1ee1cac498ae$var$hxd(this);
};
$61de1ee1cac498ae$var$_.Ci = function yxd() {
    return this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o;
};
$61de1ee1cac498ae$var$_.hj = function zxd() {
    return false;
};
$61de1ee1cac498ae$var$_.Di = function Axd(a) {
    var b, c, d, e, f, g, h, i, j, k, l;
    switch(this.d){
        case 1:
        case 2:
            e = a.xi();
            switch(e){
                case 1:
                case 2:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.Ai()) && this.yi(null) == a.yi(null)) {
                        this.g = a.zi();
                        a.xi() == 1 && (this.d = 1);
                        return true;
                    }
            }
        case 4:
            e = a.xi();
            switch(e){
                case 4:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.Ai()) && this.yi(null) == a.yi(null)) {
                        j = $61de1ee1cac498ae$var$jxd(this);
                        i = this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o;
                        g = a.Ci();
                        this.d = 6;
                        l = new $61de1ee1cac498ae$var$zud(2);
                        if (i <= g) {
                            $61de1ee1cac498ae$var$wtd(l, this.n);
                            $61de1ee1cac498ae$var$wtd(l, a.Bi());
                            this.g = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
                                this.o = i,
                                g + 1
                            ]);
                        } else {
                            $61de1ee1cac498ae$var$wtd(l, a.Bi());
                            $61de1ee1cac498ae$var$wtd(l, this.n);
                            this.g = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
                                this.o = g,
                                i
                            ]);
                        }
                        this.n = l;
                        j || (this.o = -2 - this.o - 1);
                        return true;
                    }
                    break;
            }
            break;
        case 6:
            e = a.xi();
            switch(e){
                case 4:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.Ai()) && this.yi(null) == a.yi(null)) {
                        j = $61de1ee1cac498ae$var$jxd(this);
                        g = a.Ci();
                        k = $61de1ee1cac498ae$var$BD(this.g, 48);
                        d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, k.length + 1, 15, 1);
                        b = 0;
                        while(b < k.length){
                            h = k[b];
                            if (h <= g) {
                                d[b++] = h;
                                ++g;
                            } else break;
                        }
                        c = $61de1ee1cac498ae$var$BD(this.n, 15);
                        c.Vc(b, a.Bi());
                        d[b] = g;
                        while(++b < d.length)d[b] = k[b - 1];
                        this.g = d;
                        j || (this.o = -2 - d[0]);
                        return true;
                    }
                    break;
            }
            break;
    }
    return false;
};
$61de1ee1cac498ae$var$_.Ib = function Bxd() {
    var a, b, c, d;
    d = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$hdb(this.gm) + "@" + (b = $61de1ee1cac498ae$var$tb(this) >>> 0, b.toString(16)));
    d.a += " (eventType: ";
    switch(this.d){
        case 1:
            d.a += "SET";
            break;
        case 2:
            d.a += "UNSET";
            break;
        case 3:
            d.a += "ADD";
            break;
        case 5:
            d.a += "ADD_MANY";
            break;
        case 4:
            d.a += "REMOVE";
            break;
        case 6:
            d.a += "REMOVE_MANY";
            break;
        case 7:
            d.a += "MOVE";
            break;
        case 8:
            d.a += "REMOVING_ADAPTER";
            break;
        case 9:
            d.a += "RESOLVE";
            break;
        default:
            $61de1ee1cac498ae$var$Cfb(d, this.d);
            break;
    }
    $61de1ee1cac498ae$var$ixd(this) && (d.a += ", touch: true", d);
    d.a += ", position: ";
    $61de1ee1cac498ae$var$Cfb(d, this.o < 0 ? this.o < -2 ? -2 - this.o - 1 : -1 : this.o);
    d.a += ", notifier: ";
    $61de1ee1cac498ae$var$Dfb(d, this.Ai());
    d.a += ", feature: ";
    $61de1ee1cac498ae$var$Dfb(d, this._i());
    d.a += ", oldValue: ";
    $61de1ee1cac498ae$var$Dfb(d, $61de1ee1cac498ae$var$hxd(this));
    d.a += ", newValue: ";
    if (this.d == 6 && $61de1ee1cac498ae$var$JD(this.g, 48)) {
        c = $61de1ee1cac498ae$var$BD(this.g, 48);
        d.a += "[";
        for(a = 0; a < c.length;){
            d.a += c[a];
            ++a < c.length && (d.a += $61de1ee1cac498ae$var$She, d);
        }
        d.a += "]";
    } else $61de1ee1cac498ae$var$Dfb(d, $61de1ee1cac498ae$var$$wd(this));
    d.a += ", isTouch: ";
    $61de1ee1cac498ae$var$Ffb(d, $61de1ee1cac498ae$var$ixd(this));
    d.a += ", wasSet: ";
    $61de1ee1cac498ae$var$Ffb(d, $61de1ee1cac498ae$var$jxd(this));
    d.a += ")";
    return d.a;
};
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.j = 0;
$61de1ee1cac498ae$var$_.k = 0;
$61de1ee1cac498ae$var$_.o = 0;
$61de1ee1cac498ae$var$_.p = 0;
var $61de1ee1cac498ae$var$f4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "NotificationImpl", 143);
$61de1ee1cac498ae$var$bcb(1167, 143, $61de1ee1cac498ae$var$fve, $61de1ee1cac498ae$var$Cxd);
$61de1ee1cac498ae$var$_._i = function Dxd() {
    return this.a._i();
};
$61de1ee1cac498ae$var$_.yi = function Exd(a) {
    return this.a.aj();
};
$61de1ee1cac498ae$var$_.Ai = function Fxd() {
    return this.a.Ai();
};
var $61de1ee1cac498ae$var$c4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "DelegatingNotifyingListImpl/1", 1167);
$61de1ee1cac498ae$var$bcb(242, 63, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$Hxd, $61de1ee1cac498ae$var$Ixd);
$61de1ee1cac498ae$var$_.Fc = function Jxd(a) {
    return $61de1ee1cac498ae$var$Gxd(this, $61de1ee1cac498ae$var$BD(a, 366));
};
$61de1ee1cac498ae$var$_.Ei = function Kxd(a) {
    return $61de1ee1cac498ae$var$Gxd(this, a);
};
$61de1ee1cac498ae$var$_.Fi = function Lxd() {
    var a, b, c;
    for(a = 0; a < this.i; ++a){
        b = $61de1ee1cac498ae$var$BD(this.g[a], 366);
        c = b.Ai();
        c != null && b.xi() != -1 && $61de1ee1cac498ae$var$BD(c, 92).Ng(b);
    }
};
$61de1ee1cac498ae$var$_.ri = function Mxd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$_3, $61de1ee1cac498ae$var$Uhe, 366, a, 0, 1);
};
var $61de1ee1cac498ae$var$e4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "NotificationChainImpl", 242);
$61de1ee1cac498ae$var$bcb(1378, 90, $61de1ee1cac498ae$var$gte);
$61de1ee1cac498ae$var$_.Kg = function Nxd() {
    return this.e;
};
$61de1ee1cac498ae$var$_.Mg = function Oxd() {
    return (this.f & 1) != 0;
};
$61de1ee1cac498ae$var$_.f = 1;
var $61de1ee1cac498ae$var$g4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "NotifierImpl", 1378);
$61de1ee1cac498ae$var$bcb(1993, 63, $61de1ee1cac498ae$var$oue);
$61de1ee1cac498ae$var$_.Vh = function $xd(a, b) {
    return $61de1ee1cac498ae$var$Pxd(this, a, b);
};
$61de1ee1cac498ae$var$_.Wh = function _xd(a) {
    return this.Vh(this.i, a);
};
$61de1ee1cac498ae$var$_.Xh = function ayd(a, b) {
    $61de1ee1cac498ae$var$Qxd(this, a, b);
};
$61de1ee1cac498ae$var$_.Yh = function byd(a) {
    $61de1ee1cac498ae$var$Rxd(this, a);
};
$61de1ee1cac498ae$var$_.ai = function cyd() {
    return !this.bj();
};
$61de1ee1cac498ae$var$_.$b = function dyd() {
    $61de1ee1cac498ae$var$Uxd(this);
};
$61de1ee1cac498ae$var$_.Zi = function eyd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$vyd(this, a, b, c, d, e);
};
$61de1ee1cac498ae$var$_.$i = function fyd(a) {
    $61de1ee1cac498ae$var$Uhd(this.Ai(), a);
};
$61de1ee1cac498ae$var$_._i = function gyd() {
    return null;
};
$61de1ee1cac498ae$var$_.aj = function hyd() {
    return -1;
};
$61de1ee1cac498ae$var$_.Ai = function iyd() {
    return null;
};
$61de1ee1cac498ae$var$_.bj = function jyd() {
    return false;
};
$61de1ee1cac498ae$var$_.ij = function kyd() {
    return false;
};
$61de1ee1cac498ae$var$_.cj = function lyd(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.dj = function myd(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.ej = function nyd() {
    return false;
};
$61de1ee1cac498ae$var$_.fj = function oyd() {
    return this.i != 0;
};
$61de1ee1cac498ae$var$_.ii = function pyd(a, b) {
    return $61de1ee1cac498ae$var$Wxd(this, a, b);
};
$61de1ee1cac498ae$var$_.$c = function qyd(a) {
    return $61de1ee1cac498ae$var$Xxd(this, a);
};
$61de1ee1cac498ae$var$_.mi = function ryd(a, b) {
    return $61de1ee1cac498ae$var$Zxd(this, a, b);
};
$61de1ee1cac498ae$var$_.jj = function syd(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.kj = function tyd(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.lj = function uyd(a, b, c) {
    return c;
};
var $61de1ee1cac498ae$var$i4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "NotifyingListImpl", 1993);
$61de1ee1cac498ae$var$bcb(1166, 143, $61de1ee1cac498ae$var$fve, $61de1ee1cac498ae$var$vyd);
$61de1ee1cac498ae$var$_._i = function wyd() {
    return this.a._i();
};
$61de1ee1cac498ae$var$_.yi = function xyd(a) {
    return this.a.aj();
};
$61de1ee1cac498ae$var$_.Ai = function yyd() {
    return this.a.Ai();
};
var $61de1ee1cac498ae$var$h4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$hte, "NotifyingListImpl/1", 1166);
$61de1ee1cac498ae$var$bcb(953, 63, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$zyd);
$61de1ee1cac498ae$var$_.Hc = function Ayd(a) {
    if (this.i > 10) {
        if (!this.b || this.c.j != this.a) {
            this.b = new $61de1ee1cac498ae$var$Vqb(this);
            this.a = this.j;
        }
        return $61de1ee1cac498ae$var$Rqb(this.b, a);
    } else return $61de1ee1cac498ae$var$pud(this, a);
};
$61de1ee1cac498ae$var$_.ni = function Byd() {
    return true;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$j4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractEList/1", 953);
$61de1ee1cac498ae$var$bcb(295, 73, $61de1ee1cac498ae$var$Mje, $61de1ee1cac498ae$var$Cyd);
var $61de1ee1cac498ae$var$k4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractEList/BasicIndexOutOfBoundsException", 295);
$61de1ee1cac498ae$var$bcb(40, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Fyd);
$61de1ee1cac498ae$var$_.Nb = function Iyd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.mj = function Gyd() {
    if (this.i.j != this.f) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
};
$61de1ee1cac498ae$var$_.nj = function Hyd() {
    return $61de1ee1cac498ae$var$Dyd(this);
};
$61de1ee1cac498ae$var$_.Ob = function Jyd() {
    return this.e != this.i.gc();
};
$61de1ee1cac498ae$var$_.Pb = function Kyd() {
    return this.nj();
};
$61de1ee1cac498ae$var$_.Qb = function Lyd() {
    $61de1ee1cac498ae$var$Eyd(this);
};
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
$61de1ee1cac498ae$var$_.g = -1;
var $61de1ee1cac498ae$var$l4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractEList/EIterator", 40);
$61de1ee1cac498ae$var$bcb(278, 40, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$Oyd, $61de1ee1cac498ae$var$Pyd);
$61de1ee1cac498ae$var$_.Qb = function Xyd() {
    $61de1ee1cac498ae$var$Eyd(this);
};
$61de1ee1cac498ae$var$_.Rb = function Qyd(a) {
    $61de1ee1cac498ae$var$Myd(this, a);
};
$61de1ee1cac498ae$var$_.oj = function Ryd() {
    var b;
    try {
        b = this.d.Xb(--this.e);
        this.mj();
        this.g = this.e;
        return b;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            this.mj();
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.pj = function Syd(a) {
    $61de1ee1cac498ae$var$Nyd(this, a);
};
$61de1ee1cac498ae$var$_.Sb = function Tyd() {
    return this.e != 0;
};
$61de1ee1cac498ae$var$_.Tb = function Uyd() {
    return this.e;
};
$61de1ee1cac498ae$var$_.Ub = function Vyd() {
    return this.oj();
};
$61de1ee1cac498ae$var$_.Vb = function Wyd() {
    return this.e - 1;
};
$61de1ee1cac498ae$var$_.Wb = function Yyd(a) {
    this.pj(a);
};
var $61de1ee1cac498ae$var$m4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractEList/EListIterator", 278);
$61de1ee1cac498ae$var$bcb(341, 40, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$$yd);
$61de1ee1cac498ae$var$_.nj = function _yd() {
    return $61de1ee1cac498ae$var$Zyd(this);
};
$61de1ee1cac498ae$var$_.Qb = function azd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$n4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractEList/NonResolvingEIterator", 341);
$61de1ee1cac498ae$var$bcb(385, 278, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$bzd, $61de1ee1cac498ae$var$czd);
$61de1ee1cac498ae$var$_.Rb = function dzd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.nj = function ezd() {
    var b;
    try {
        b = this.c.ki(this.e);
        this.mj();
        this.g = this.e++;
        return b;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            this.mj();
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.oj = function fzd() {
    var b;
    try {
        b = this.c.ki(--this.e);
        this.mj();
        this.g = this.e;
        return b;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) {
            this.mj();
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
        } else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.Qb = function gzd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wb = function hzd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$o4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "AbstractEList/NonResolvingEListIterator", 385);
$61de1ee1cac498ae$var$bcb(1982, 67, $61de1ee1cac498ae$var$ive);
$61de1ee1cac498ae$var$_.Vh = function pzd(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m;
    e = b.gc();
    if (e != 0) {
        j = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
        k = j == null ? 0 : j.length;
        m = k + e;
        d = $61de1ee1cac498ae$var$nzd(this, m);
        l = k - a;
        l > 0 && $61de1ee1cac498ae$var$$fb(j, a, d, a + e, l);
        i = b.Kc();
        for(g = 0; g < e; ++g){
            h = i.Pb();
            c = a + g;
            $61de1ee1cac498ae$var$lzd(d, c, $61de1ee1cac498ae$var$Itd(this, h));
        }
        $61de1ee1cac498ae$var$b0d(this, d);
        for(f = 0; f < e; ++f){
            h = d[a];
            this.bi(a, h);
            ++a;
        }
        return true;
    } else {
        ++this.j;
        return false;
    }
};
$61de1ee1cac498ae$var$_.Wh = function qzd(a) {
    var b, c, d, e, f, g, h, i, j;
    d = a.gc();
    if (d != 0) {
        i = (c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126), c == null ? 0 : c.length);
        j = i + d;
        b = $61de1ee1cac498ae$var$nzd(this, j);
        h = a.Kc();
        for(f = i; f < j; ++f){
            g = h.Pb();
            $61de1ee1cac498ae$var$lzd(b, f, $61de1ee1cac498ae$var$Itd(this, g));
        }
        $61de1ee1cac498ae$var$b0d(this, b);
        for(e = i; e < j; ++e){
            g = b[e];
            this.bi(e, g);
        }
        return true;
    } else {
        ++this.j;
        return false;
    }
};
$61de1ee1cac498ae$var$_.Xh = function rzd(a, b) {
    var c, d, e, f;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
    e = d == null ? 0 : d.length;
    c = $61de1ee1cac498ae$var$nzd(this, e + 1);
    f = $61de1ee1cac498ae$var$Itd(this, b);
    a != e && $61de1ee1cac498ae$var$$fb(d, a, c, a + 1, e - a);
    $61de1ee1cac498ae$var$NC(c, a, f);
    $61de1ee1cac498ae$var$b0d(this, c);
    this.bi(a, b);
};
$61de1ee1cac498ae$var$_.Yh = function szd(a) {
    var b, c, d;
    d = (c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126), c == null ? 0 : c.length);
    b = $61de1ee1cac498ae$var$nzd(this, d + 1);
    $61de1ee1cac498ae$var$lzd(b, d, $61de1ee1cac498ae$var$Itd(this, a));
    $61de1ee1cac498ae$var$b0d(this, b);
    this.bi(d, a);
};
$61de1ee1cac498ae$var$_.Zh = function tzd() {
    return new $61de1ee1cac498ae$var$Uzd(this);
};
$61de1ee1cac498ae$var$_.$h = function uzd() {
    return new $61de1ee1cac498ae$var$Xzd(this);
};
$61de1ee1cac498ae$var$_._h = function vzd(a) {
    var b, c;
    c = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126), b == null ? 0 : b.length);
    if (a < 0 || a > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(a, c));
    return new $61de1ee1cac498ae$var$Yzd(this, a);
};
$61de1ee1cac498ae$var$_.$b = function wzd() {
    var a, b;
    ++this.j;
    a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
    b = a == null ? 0 : a.length;
    $61de1ee1cac498ae$var$b0d(this, null);
    $61de1ee1cac498ae$var$Atd(this, b, a);
};
$61de1ee1cac498ae$var$_.Hc = function xzd(a) {
    var b, c, d, e, f;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
    if (b != null) {
        if (a != null) for(d = b, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if ($61de1ee1cac498ae$var$pb(a, c)) return true;
        }
        else for(d = b, e = 0, f = d.length; e < f; ++e){
            c = d[e];
            if ($61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD(a)) return true;
        }
    }
    return false;
};
$61de1ee1cac498ae$var$_.Xb = function yzd(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
    c = b == null ? 0 : b.length;
    if (a >= c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(a, c));
    return b[a];
};
$61de1ee1cac498ae$var$_.Xc = function zzd(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
    if (b != null) {
        if (a != null) for(c = 0, d = b.length; c < d; ++c){
            if ($61de1ee1cac498ae$var$pb(a, b[c])) return c;
        }
        else for(c = 0, d = b.length; c < d; ++c){
            if ($61de1ee1cac498ae$var$PD(b[c]) === $61de1ee1cac498ae$var$PD(a)) return c;
        }
    }
    return -1;
};
$61de1ee1cac498ae$var$_.dc = function Azd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126) == null;
};
$61de1ee1cac498ae$var$_.Kc = function Bzd() {
    return new $61de1ee1cac498ae$var$Lzd(this);
};
$61de1ee1cac498ae$var$_.Yc = function Czd() {
    return new $61de1ee1cac498ae$var$Pzd(this);
};
$61de1ee1cac498ae$var$_.Zc = function Dzd(a) {
    var b, c;
    c = (b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126), b == null ? 0 : b.length);
    if (a < 0 || a > c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cyd(a, c));
    return new $61de1ee1cac498ae$var$Qzd(this, a);
};
$61de1ee1cac498ae$var$_.ii = function Ezd(a, b) {
    var c, d, e;
    c = $61de1ee1cac498ae$var$mzd(this);
    e = c == null ? 0 : c.length;
    if (a >= e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$lue + a + $61de1ee1cac498ae$var$mue + e));
    if (b >= e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$nue + b + $61de1ee1cac498ae$var$mue + e));
    d = c[b];
    if (a != b) {
        a < b ? $61de1ee1cac498ae$var$$fb(c, a, c, a + 1, b - a) : $61de1ee1cac498ae$var$$fb(c, b + 1, c, b, a - b);
        $61de1ee1cac498ae$var$NC(c, a, d);
        $61de1ee1cac498ae$var$b0d(this, c);
    }
    return d;
};
$61de1ee1cac498ae$var$_.ki = function Fzd(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126)[a];
};
$61de1ee1cac498ae$var$_.$c = function Gzd(a) {
    return $61de1ee1cac498ae$var$ozd(this, a);
};
$61de1ee1cac498ae$var$_.mi = function Hzd(a, b) {
    var c, d;
    c = $61de1ee1cac498ae$var$mzd(this);
    d = c[a];
    $61de1ee1cac498ae$var$lzd(c, a, $61de1ee1cac498ae$var$Itd(this, b));
    $61de1ee1cac498ae$var$b0d(this, c);
    return d;
};
$61de1ee1cac498ae$var$_.gc = function Izd() {
    var a;
    return a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126), a == null ? 0 : a.length;
};
$61de1ee1cac498ae$var$_.Pc = function Jzd() {
    var a, b, c;
    a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
    c = a == null ? 0 : a.length;
    b = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$$3, $61de1ee1cac498ae$var$hve, 415, c, 0, 1);
    c > 0 && $61de1ee1cac498ae$var$$fb(a, 0, b, 0, c);
    return b;
};
$61de1ee1cac498ae$var$_.Qc = function Kzd(a) {
    var b, c, d;
    b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.a, 4), 126);
    d = b == null ? 0 : b.length;
    if (d > 0) {
        if (a.length < d) {
            c = $61de1ee1cac498ae$var$izd($61de1ee1cac498ae$var$rb(a).c, d);
            a = c;
        }
        $61de1ee1cac498ae$var$$fb(b, 0, a, 0, d);
    }
    a.length > d && $61de1ee1cac498ae$var$NC(a, d, null);
    return a;
};
var $61de1ee1cac498ae$var$jzd;
var $61de1ee1cac498ae$var$v4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ArrayDelegatingEList", 1982);
$61de1ee1cac498ae$var$bcb(1038, 40, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Lzd);
$61de1ee1cac498ae$var$_.mj = function Mzd() {
    if (this.b.j != this.f || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126)) !== $61de1ee1cac498ae$var$PD(this.a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
};
$61de1ee1cac498ae$var$_.Qb = function Nzd() {
    $61de1ee1cac498ae$var$Eyd(this);
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126);
};
var $61de1ee1cac498ae$var$r4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ArrayDelegatingEList/EIterator", 1038);
$61de1ee1cac498ae$var$bcb(706, 278, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$Pzd, $61de1ee1cac498ae$var$Qzd);
$61de1ee1cac498ae$var$_.mj = function Rzd() {
    if (this.b.j != this.f || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126)) !== $61de1ee1cac498ae$var$PD(this.a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
};
$61de1ee1cac498ae$var$_.pj = function Szd(a) {
    $61de1ee1cac498ae$var$Nyd(this, a);
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126);
};
$61de1ee1cac498ae$var$_.Qb = function Tzd() {
    $61de1ee1cac498ae$var$Eyd(this);
    this.a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126);
};
var $61de1ee1cac498ae$var$s4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ArrayDelegatingEList/EListIterator", 706);
$61de1ee1cac498ae$var$bcb(1039, 341, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$Uzd);
$61de1ee1cac498ae$var$_.mj = function Vzd() {
    if (this.b.j != this.f || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126)) !== $61de1ee1cac498ae$var$PD(this.a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
};
var $61de1ee1cac498ae$var$t4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ArrayDelegatingEList/NonResolvingEIterator", 1039);
$61de1ee1cac498ae$var$bcb(707, 385, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$Xzd, $61de1ee1cac498ae$var$Yzd);
$61de1ee1cac498ae$var$_.mj = function Zzd() {
    if (this.b.j != this.f || $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this.b.a, 4), 126)) !== $61de1ee1cac498ae$var$PD(this.a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
};
var $61de1ee1cac498ae$var$u4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ArrayDelegatingEList/NonResolvingEListIterator", 707);
$61de1ee1cac498ae$var$bcb(606, 295, $61de1ee1cac498ae$var$Mje, $61de1ee1cac498ae$var$$zd);
var $61de1ee1cac498ae$var$w4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEList/BasicIndexOutOfBoundsException", 606);
$61de1ee1cac498ae$var$bcb(696, 63, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$_zd);
$61de1ee1cac498ae$var$_.Vc = function aAd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Fc = function bAd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wc = function cAd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Gc = function dAd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.$b = function eAd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.qi = function fAd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Kc = function gAd() {
    return this.Zh();
};
$61de1ee1cac498ae$var$_.Yc = function hAd() {
    return this.$h();
};
$61de1ee1cac498ae$var$_.Zc = function iAd(a) {
    return this._h(a);
};
$61de1ee1cac498ae$var$_.ii = function jAd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.ji = function kAd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.$c = function lAd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Mc = function mAd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_._c = function nAd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$x4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEList/UnmodifiableEList", 696);
$61de1ee1cac498ae$var$bcb(705, 1, {
    3: 1,
    20: 1,
    14: 1,
    15: 1,
    58: 1,
    589: 1
});
$61de1ee1cac498ae$var$_.Vc = function OAd(a, b) {
    $61de1ee1cac498ae$var$oAd(this, a, $61de1ee1cac498ae$var$BD(b, 42));
};
$61de1ee1cac498ae$var$_.Fc = function PAd(a) {
    return $61de1ee1cac498ae$var$pAd(this, $61de1ee1cac498ae$var$BD(a, 42));
};
$61de1ee1cac498ae$var$_.Jc = function XAd(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Xb = function YAd(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(this.c, a), 133);
};
$61de1ee1cac498ae$var$_.ii = function fBd(a, b) {
    return $61de1ee1cac498ae$var$BD(this.c.ii(a, b), 42);
};
$61de1ee1cac498ae$var$_.ji = function gBd(a, b) {
    $61de1ee1cac498ae$var$GAd(this, a, $61de1ee1cac498ae$var$BD(b, 42));
};
$61de1ee1cac498ae$var$_.Lc = function jBd() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.$c = function kBd(a) {
    return $61de1ee1cac498ae$var$BD(this.c.$c(a), 42);
};
$61de1ee1cac498ae$var$_._c = function mBd(a, b) {
    return $61de1ee1cac498ae$var$MAd(this, a, $61de1ee1cac498ae$var$BD(b, 42));
};
$61de1ee1cac498ae$var$_.ad = function oBd(a) {
    $61de1ee1cac498ae$var$ktb(this, a);
};
$61de1ee1cac498ae$var$_.Nc = function pBd() {
    return new $61de1ee1cac498ae$var$Kub(this, 16);
};
$61de1ee1cac498ae$var$_.Oc = function qBd() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.Wc = function QAd(a, b) {
    return this.c.Wc(a, b);
};
$61de1ee1cac498ae$var$_.Gc = function RAd(a) {
    return this.c.Gc(a);
};
$61de1ee1cac498ae$var$_.$b = function SAd() {
    this.c.$b();
};
$61de1ee1cac498ae$var$_.Hc = function TAd(a) {
    return this.c.Hc(a);
};
$61de1ee1cac498ae$var$_.Ic = function UAd(a) {
    return $61de1ee1cac498ae$var$Be(this.c, a);
};
$61de1ee1cac498ae$var$_.qj = function VAd() {
    var a, b, c;
    if (this.d == null) {
        this.d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$y4, $61de1ee1cac498ae$var$jve, 63, 2 * this.f + 1, 0, 1);
        c = this.e;
        this.f = 0;
        for(b = this.c.Kc(); b.e != b.i.gc();){
            a = $61de1ee1cac498ae$var$BD(b.nj(), 133);
            $61de1ee1cac498ae$var$uAd(this, a);
        }
        this.e = c;
    }
};
$61de1ee1cac498ae$var$_.Fb = function WAd(a) {
    return $61de1ee1cac498ae$var$zAd(this, a);
};
$61de1ee1cac498ae$var$_.Hb = function ZAd() {
    return $61de1ee1cac498ae$var$Etd(this.c);
};
$61de1ee1cac498ae$var$_.Xc = function $Ad(a) {
    return this.c.Xc(a);
};
$61de1ee1cac498ae$var$_.rj = function _Ad() {
    this.c = new $61de1ee1cac498ae$var$yBd(this);
};
$61de1ee1cac498ae$var$_.dc = function aBd() {
    return this.f == 0;
};
$61de1ee1cac498ae$var$_.Kc = function bBd() {
    return this.c.Kc();
};
$61de1ee1cac498ae$var$_.Yc = function cBd() {
    return this.c.Yc();
};
$61de1ee1cac498ae$var$_.Zc = function dBd(a) {
    return this.c.Zc(a);
};
$61de1ee1cac498ae$var$_.sj = function eBd() {
    return $61de1ee1cac498ae$var$FAd(this);
};
$61de1ee1cac498ae$var$_.tj = function hBd(a, b, c) {
    return new $61de1ee1cac498ae$var$zCd(a, b, c);
};
$61de1ee1cac498ae$var$_.uj = function iBd() {
    return new $61de1ee1cac498ae$var$EBd;
};
$61de1ee1cac498ae$var$_.Mc = function lBd(a) {
    return $61de1ee1cac498ae$var$JAd(this, a);
};
$61de1ee1cac498ae$var$_.gc = function nBd() {
    return this.f;
};
$61de1ee1cac498ae$var$_.bd = function rBd(a, b) {
    return new $61de1ee1cac498ae$var$Jib(this.c, a, b);
};
$61de1ee1cac498ae$var$_.Pc = function sBd() {
    return this.c.Pc();
};
$61de1ee1cac498ae$var$_.Qc = function tBd(a) {
    return this.c.Qc(a);
};
$61de1ee1cac498ae$var$_.Ib = function uBd() {
    return $61de1ee1cac498ae$var$Htd(this.c);
};
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$L4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap", 705);
$61de1ee1cac498ae$var$bcb(1033, 63, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$yBd);
$61de1ee1cac498ae$var$_.bi = function zBd(a, b) {
    $61de1ee1cac498ae$var$vBd(this, $61de1ee1cac498ae$var$BD(b, 133));
};
$61de1ee1cac498ae$var$_.ei = function BBd(a, b, c) {
    var d;
    ++(d = this, $61de1ee1cac498ae$var$BD(b, 133), d).a.e;
};
$61de1ee1cac498ae$var$_.fi = function CBd(a, b) {
    $61de1ee1cac498ae$var$wBd(this, $61de1ee1cac498ae$var$BD(b, 133));
};
$61de1ee1cac498ae$var$_.gi = function DBd(a, b, c) {
    $61de1ee1cac498ae$var$xBd(this, $61de1ee1cac498ae$var$BD(b, 133), $61de1ee1cac498ae$var$BD(c, 133));
};
$61de1ee1cac498ae$var$_.di = function ABd(a, b) {
    $61de1ee1cac498ae$var$tAd(this.a);
};
var $61de1ee1cac498ae$var$z4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/1", 1033);
$61de1ee1cac498ae$var$bcb(1034, 63, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$EBd);
$61de1ee1cac498ae$var$_.ri = function FBd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$I4, $61de1ee1cac498ae$var$kve, 612, a, 0, 1);
};
var $61de1ee1cac498ae$var$A4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/2", 1034);
$61de1ee1cac498ae$var$bcb(1035, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$GBd);
$61de1ee1cac498ae$var$_.$b = function HBd() {
    this.a.c.$b();
};
$61de1ee1cac498ae$var$_.Hc = function IBd(a) {
    return $61de1ee1cac498ae$var$qAd(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function JBd() {
    return this.a.f == 0 ? ($61de1ee1cac498ae$var$LCd(), $61de1ee1cac498ae$var$KCd.a) : new $61de1ee1cac498ae$var$dCd(this.a);
};
$61de1ee1cac498ae$var$_.Mc = function KBd(a) {
    var b;
    b = this.a.f;
    $61de1ee1cac498ae$var$LAd(this.a, a);
    return this.a.f != b;
};
$61de1ee1cac498ae$var$_.gc = function LBd() {
    return this.a.f;
};
var $61de1ee1cac498ae$var$B4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/3", 1035);
$61de1ee1cac498ae$var$bcb(1036, 28, $61de1ee1cac498ae$var$die, $61de1ee1cac498ae$var$MBd);
$61de1ee1cac498ae$var$_.$b = function NBd() {
    this.a.c.$b();
};
$61de1ee1cac498ae$var$_.Hc = function OBd(a) {
    return $61de1ee1cac498ae$var$rAd(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function PBd() {
    return this.a.f == 0 ? ($61de1ee1cac498ae$var$LCd(), $61de1ee1cac498ae$var$KCd.a) : new $61de1ee1cac498ae$var$fCd(this.a);
};
$61de1ee1cac498ae$var$_.gc = function QBd() {
    return this.a.f;
};
var $61de1ee1cac498ae$var$C4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/4", 1036);
$61de1ee1cac498ae$var$bcb(1037, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$SBd);
$61de1ee1cac498ae$var$_.$b = function TBd() {
    this.a.c.$b();
};
$61de1ee1cac498ae$var$_.Hc = function UBd(a) {
    var b, c, d, e, f, g, h, i, j;
    if (this.a.f > 0 && $61de1ee1cac498ae$var$JD(a, 42)) {
        this.a.qj();
        i = $61de1ee1cac498ae$var$BD(a, 42);
        h = i.cd();
        e = h == null ? 0 : $61de1ee1cac498ae$var$tb(h);
        f = $61de1ee1cac498ae$var$DAd(this.a, e);
        b = this.a.d[f];
        if (b) {
            c = $61de1ee1cac498ae$var$BD(b.g, 367);
            j = b.i;
            for(g = 0; g < j; ++g){
                d = c[g];
                if (d.Sh() == e && d.Fb(i)) return true;
            }
        }
    }
    return false;
};
$61de1ee1cac498ae$var$_.Kc = function VBd() {
    return this.a.f == 0 ? ($61de1ee1cac498ae$var$LCd(), $61de1ee1cac498ae$var$KCd.a) : new $61de1ee1cac498ae$var$ZBd(this.a);
};
$61de1ee1cac498ae$var$_.Mc = function WBd(a) {
    return $61de1ee1cac498ae$var$RBd(this, a);
};
$61de1ee1cac498ae$var$_.gc = function XBd() {
    return this.a.f;
};
var $61de1ee1cac498ae$var$D4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/5", 1037);
$61de1ee1cac498ae$var$bcb(613, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$ZBd);
$61de1ee1cac498ae$var$_.Nb = function $Bd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function _Bd() {
    return this.b != -1;
};
$61de1ee1cac498ae$var$_.Pb = function aCd() {
    var a;
    if (this.f.e != this.c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
    if (this.b == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
    this.d = this.a;
    this.e = this.b;
    $61de1ee1cac498ae$var$YBd(this);
    a = $61de1ee1cac498ae$var$BD(this.f.d[this.d].g[this.e], 133);
    return this.vj(a);
};
$61de1ee1cac498ae$var$_.Qb = function bCd() {
    if (this.f.e != this.c) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
    if (this.e == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    this.f.c.Mc($61de1ee1cac498ae$var$qud(this.f.d[this.d], this.e));
    this.c = this.f.e;
    this.e = -1;
    this.a == this.d && this.b != -1 && --this.b;
};
$61de1ee1cac498ae$var$_.vj = function cCd(a) {
    return a;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = -1;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$E4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/BasicEMapIterator", 613);
$61de1ee1cac498ae$var$bcb(1031, 613, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$dCd);
$61de1ee1cac498ae$var$_.vj = function eCd(a) {
    return a.cd();
};
var $61de1ee1cac498ae$var$F4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/BasicEMapKeyIterator", 1031);
$61de1ee1cac498ae$var$bcb(1032, 613, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$fCd);
$61de1ee1cac498ae$var$_.vj = function gCd(a) {
    return a.dd();
};
var $61de1ee1cac498ae$var$G4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/BasicEMapValueIterator", 1032);
$61de1ee1cac498ae$var$bcb(1030, 1, $61de1ee1cac498ae$var$cie, $61de1ee1cac498ae$var$iCd);
$61de1ee1cac498ae$var$_.wc = function oCd(a) {
    $61de1ee1cac498ae$var$stb(this, a);
};
$61de1ee1cac498ae$var$_.yc = function tCd(a, b, c) {
    return $61de1ee1cac498ae$var$ttb(this, a, b, c);
};
$61de1ee1cac498ae$var$_.$b = function jCd() {
    this.a.c.$b();
};
$61de1ee1cac498ae$var$_._b = function kCd(a) {
    return $61de1ee1cac498ae$var$hCd(this, a);
};
$61de1ee1cac498ae$var$_.uc = function lCd(a) {
    return $61de1ee1cac498ae$var$rAd(this.a, a);
};
$61de1ee1cac498ae$var$_.vc = function mCd() {
    return $61de1ee1cac498ae$var$yAd(this.a);
};
$61de1ee1cac498ae$var$_.Fb = function nCd(a) {
    return $61de1ee1cac498ae$var$zAd(this.a, a);
};
$61de1ee1cac498ae$var$_.xc = function pCd(a) {
    return $61de1ee1cac498ae$var$AAd(this.a, a);
};
$61de1ee1cac498ae$var$_.Hb = function qCd() {
    return $61de1ee1cac498ae$var$Etd(this.a.c);
};
$61de1ee1cac498ae$var$_.dc = function rCd() {
    return this.a.f == 0;
};
$61de1ee1cac498ae$var$_.ec = function sCd() {
    return $61de1ee1cac498ae$var$EAd(this.a);
};
$61de1ee1cac498ae$var$_.zc = function uCd(a, b) {
    return $61de1ee1cac498ae$var$HAd(this.a, a, b);
};
$61de1ee1cac498ae$var$_.Bc = function vCd(a) {
    return $61de1ee1cac498ae$var$LAd(this.a, a);
};
$61de1ee1cac498ae$var$_.gc = function wCd() {
    return this.a.f;
};
$61de1ee1cac498ae$var$_.Ib = function xCd() {
    return $61de1ee1cac498ae$var$Htd(this.a.c);
};
$61de1ee1cac498ae$var$_.Cc = function yCd() {
    return $61de1ee1cac498ae$var$NAd(this.a);
};
var $61de1ee1cac498ae$var$H4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/DelegatingMap", 1030);
$61de1ee1cac498ae$var$bcb(612, 1, {
    42: 1,
    133: 1,
    612: 1
}, $61de1ee1cac498ae$var$zCd);
$61de1ee1cac498ae$var$_.Fb = function ACd(a) {
    var b;
    if ($61de1ee1cac498ae$var$JD(a, 42)) {
        b = $61de1ee1cac498ae$var$BD(a, 42);
        return (this.b != null ? $61de1ee1cac498ae$var$pb(this.b, b.cd()) : $61de1ee1cac498ae$var$PD(this.b) === $61de1ee1cac498ae$var$PD(b.cd())) && (this.c != null ? $61de1ee1cac498ae$var$pb(this.c, b.dd()) : $61de1ee1cac498ae$var$PD(this.c) === $61de1ee1cac498ae$var$PD(b.dd()));
    } else return false;
};
$61de1ee1cac498ae$var$_.Sh = function BCd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.cd = function CCd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.dd = function DCd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.Hb = function ECd() {
    return this.a ^ (this.c == null ? 0 : $61de1ee1cac498ae$var$tb(this.c));
};
$61de1ee1cac498ae$var$_.Th = function FCd(a) {
    this.a = a;
};
$61de1ee1cac498ae$var$_.Uh = function GCd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$gz);
};
$61de1ee1cac498ae$var$_.ed = function HCd(a) {
    var b;
    b = this.c;
    this.c = a;
    return b;
};
$61de1ee1cac498ae$var$_.Ib = function ICd() {
    return this.b + "->" + this.c;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$I4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/EntryImpl", 612);
$61de1ee1cac498ae$var$bcb(536, 1, {}, $61de1ee1cac498ae$var$JCd);
var $61de1ee1cac498ae$var$K4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "BasicEMap/View", 536);
var $61de1ee1cac498ae$var$KCd;
$61de1ee1cac498ae$var$bcb(768, 1, {});
$61de1ee1cac498ae$var$_.Fb = function ZCd(a) {
    return $61de1ee1cac498ae$var$At(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb), a);
};
$61de1ee1cac498ae$var$_.Hb = function $Cd() {
    return $61de1ee1cac498ae$var$qmb(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb));
};
$61de1ee1cac498ae$var$_.Ib = function _Cd() {
    return $61de1ee1cac498ae$var$Fe(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb));
};
var $61de1ee1cac498ae$var$Q4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ECollections/BasicEmptyUnmodifiableEList", 768);
$61de1ee1cac498ae$var$bcb(1312, 1, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$aDd);
$61de1ee1cac498ae$var$_.Nb = function cDd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Rb = function bDd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Ob = function dDd() {
    return false;
};
$61de1ee1cac498ae$var$_.Sb = function eDd() {
    return false;
};
$61de1ee1cac498ae$var$_.Pb = function fDd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Tb = function gDd() {
    return 0;
};
$61de1ee1cac498ae$var$_.Ub = function hDd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Vb = function iDd() {
    return -1;
};
$61de1ee1cac498ae$var$_.Qb = function jDd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wb = function kDd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$P4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ECollections/BasicEmptyUnmodifiableEList/1", 1312);
$61de1ee1cac498ae$var$bcb(1310, 768, {
    20: 1,
    14: 1,
    15: 1,
    58: 1
}, $61de1ee1cac498ae$var$lDd);
$61de1ee1cac498ae$var$_.Vc = function mDd(a, b) {
    $61de1ee1cac498ae$var$OCd();
};
$61de1ee1cac498ae$var$_.Fc = function nDd(a) {
    return $61de1ee1cac498ae$var$PCd();
};
$61de1ee1cac498ae$var$_.Wc = function oDd(a, b) {
    return $61de1ee1cac498ae$var$QCd();
};
$61de1ee1cac498ae$var$_.Gc = function pDd(a) {
    return $61de1ee1cac498ae$var$RCd();
};
$61de1ee1cac498ae$var$_.$b = function qDd() {
    $61de1ee1cac498ae$var$SCd();
};
$61de1ee1cac498ae$var$_.Hc = function rDd(a) {
    return false;
};
$61de1ee1cac498ae$var$_.Ic = function sDd(a) {
    return false;
};
$61de1ee1cac498ae$var$_.Jc = function tDd(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Xb = function uDd(a) {
    return $61de1ee1cac498ae$var$wmb(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb, a)), null;
};
$61de1ee1cac498ae$var$_.Xc = function vDd(a) {
    return -1;
};
$61de1ee1cac498ae$var$_.dc = function wDd() {
    return true;
};
$61de1ee1cac498ae$var$_.Kc = function xDd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Yc = function yDd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Zc = function zDd(a) {
    return this.a;
};
$61de1ee1cac498ae$var$_.ii = function ADd(a, b) {
    return $61de1ee1cac498ae$var$TCd();
};
$61de1ee1cac498ae$var$_.ji = function BDd(a, b) {
    $61de1ee1cac498ae$var$UCd();
};
$61de1ee1cac498ae$var$_.Lc = function CDd() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.$c = function DDd(a) {
    return $61de1ee1cac498ae$var$VCd();
};
$61de1ee1cac498ae$var$_.Mc = function EDd(a) {
    return $61de1ee1cac498ae$var$WCd();
};
$61de1ee1cac498ae$var$_._c = function FDd(a, b) {
    return $61de1ee1cac498ae$var$XCd();
};
$61de1ee1cac498ae$var$_.gc = function GDd() {
    return 0;
};
$61de1ee1cac498ae$var$_.ad = function HDd(a) {
    $61de1ee1cac498ae$var$ktb(this, a);
};
$61de1ee1cac498ae$var$_.Nc = function IDd() {
    return new $61de1ee1cac498ae$var$Kub(this, 16);
};
$61de1ee1cac498ae$var$_.Oc = function JDd() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.bd = function KDd(a, b) {
    return $61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$Jib($61de1ee1cac498ae$var$jmb, a, b);
};
$61de1ee1cac498ae$var$_.Pc = function LDd() {
    return $61de1ee1cac498ae$var$De(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb));
};
$61de1ee1cac498ae$var$_.Qc = function MDd(a) {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Ee($61de1ee1cac498ae$var$jmb, a);
};
var $61de1ee1cac498ae$var$R4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ECollections/EmptyUnmodifiableEList", 1310);
$61de1ee1cac498ae$var$bcb(1311, 768, {
    20: 1,
    14: 1,
    15: 1,
    58: 1,
    589: 1
}, $61de1ee1cac498ae$var$NDd);
$61de1ee1cac498ae$var$_.Vc = function ODd(a, b) {
    $61de1ee1cac498ae$var$OCd();
};
$61de1ee1cac498ae$var$_.Fc = function PDd(a) {
    return $61de1ee1cac498ae$var$PCd();
};
$61de1ee1cac498ae$var$_.Wc = function QDd(a, b) {
    return $61de1ee1cac498ae$var$QCd();
};
$61de1ee1cac498ae$var$_.Gc = function RDd(a) {
    return $61de1ee1cac498ae$var$RCd();
};
$61de1ee1cac498ae$var$_.$b = function SDd() {
    $61de1ee1cac498ae$var$SCd();
};
$61de1ee1cac498ae$var$_.Hc = function TDd(a) {
    return false;
};
$61de1ee1cac498ae$var$_.Ic = function UDd(a) {
    return false;
};
$61de1ee1cac498ae$var$_.Jc = function VDd(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Xb = function WDd(a) {
    return $61de1ee1cac498ae$var$wmb(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb, a)), null;
};
$61de1ee1cac498ae$var$_.Xc = function XDd(a) {
    return -1;
};
$61de1ee1cac498ae$var$_.dc = function YDd() {
    return true;
};
$61de1ee1cac498ae$var$_.Kc = function ZDd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Yc = function $Dd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Zc = function _Dd(a) {
    return this.a;
};
$61de1ee1cac498ae$var$_.ii = function bEd(a, b) {
    return $61de1ee1cac498ae$var$TCd();
};
$61de1ee1cac498ae$var$_.ji = function cEd(a, b) {
    $61de1ee1cac498ae$var$UCd();
};
$61de1ee1cac498ae$var$_.Lc = function dEd() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.$c = function eEd(a) {
    return $61de1ee1cac498ae$var$VCd();
};
$61de1ee1cac498ae$var$_.Mc = function fEd(a) {
    return $61de1ee1cac498ae$var$WCd();
};
$61de1ee1cac498ae$var$_._c = function gEd(a, b) {
    return $61de1ee1cac498ae$var$XCd();
};
$61de1ee1cac498ae$var$_.gc = function hEd() {
    return 0;
};
$61de1ee1cac498ae$var$_.ad = function iEd(a) {
    $61de1ee1cac498ae$var$ktb(this, a);
};
$61de1ee1cac498ae$var$_.Nc = function jEd() {
    return new $61de1ee1cac498ae$var$Kub(this, 16);
};
$61de1ee1cac498ae$var$_.Oc = function kEd() {
    return new $61de1ee1cac498ae$var$YAb(null, new $61de1ee1cac498ae$var$Kub(this, 16));
};
$61de1ee1cac498ae$var$_.bd = function lEd(a, b) {
    return $61de1ee1cac498ae$var$mmb(), new $61de1ee1cac498ae$var$Jib($61de1ee1cac498ae$var$jmb, a, b);
};
$61de1ee1cac498ae$var$_.Pc = function mEd() {
    return $61de1ee1cac498ae$var$De(($61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb));
};
$61de1ee1cac498ae$var$_.Qc = function nEd(a) {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$Ee($61de1ee1cac498ae$var$jmb, a);
};
$61de1ee1cac498ae$var$_.sj = function aEd() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$kmb;
};
var $61de1ee1cac498ae$var$S4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "ECollections/EmptyUnmodifiableEMap", 1311);
var $61de1ee1cac498ae$var$U4 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Tte, "Enumerator");
var $61de1ee1cac498ae$var$oEd;
$61de1ee1cac498ae$var$bcb(281, 1, {
    281: 1
}, $61de1ee1cac498ae$var$NEd);
$61de1ee1cac498ae$var$_.Fb = function REd(a) {
    var b;
    if (this === a) return true;
    if (!$61de1ee1cac498ae$var$JD(a, 281)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 281);
    return this.f == b.f && $61de1ee1cac498ae$var$TEd(this.i, b.i) && $61de1ee1cac498ae$var$SEd(this.a, (this.f & 256) != 0 ? (b.f & 256) != 0 ? b.a : null : (b.f & 256) != 0 ? null : b.a) && $61de1ee1cac498ae$var$SEd(this.d, b.d) && $61de1ee1cac498ae$var$SEd(this.g, b.g) && $61de1ee1cac498ae$var$SEd(this.e, b.e) && $61de1ee1cac498ae$var$KEd(this, b);
};
$61de1ee1cac498ae$var$_.Hb = function WEd() {
    return this.f;
};
$61de1ee1cac498ae$var$_.Ib = function cFd() {
    return $61de1ee1cac498ae$var$LEd(this);
};
$61de1ee1cac498ae$var$_.f = 0;
var $61de1ee1cac498ae$var$sEd = 0, $61de1ee1cac498ae$var$tEd = 0, $61de1ee1cac498ae$var$uEd = 0, $61de1ee1cac498ae$var$vEd = 0, $61de1ee1cac498ae$var$wEd = 0, $61de1ee1cac498ae$var$xEd = 0, $61de1ee1cac498ae$var$yEd = 0, $61de1ee1cac498ae$var$zEd = 0, $61de1ee1cac498ae$var$AEd = 0, $61de1ee1cac498ae$var$BEd, $61de1ee1cac498ae$var$CEd = 0, $61de1ee1cac498ae$var$DEd = 0, $61de1ee1cac498ae$var$EEd = 0, $61de1ee1cac498ae$var$FEd = 0, $61de1ee1cac498ae$var$GEd, $61de1ee1cac498ae$var$HEd;
var $61de1ee1cac498ae$var$Z4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "URI", 281);
$61de1ee1cac498ae$var$bcb(1091, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$mFd);
$61de1ee1cac498ae$var$_.zc = function nFd(a, b) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Shb(this, $61de1ee1cac498ae$var$GD(a), $61de1ee1cac498ae$var$BD(b, 281)), 281);
};
var $61de1ee1cac498ae$var$Y4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "URI/URICache", 1091);
$61de1ee1cac498ae$var$bcb(497, 63, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$oFd, $61de1ee1cac498ae$var$pFd);
$61de1ee1cac498ae$var$_.hi = function qFd() {
    return true;
};
var $61de1ee1cac498ae$var$$4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "UniqueEList", 497);
$61de1ee1cac498ae$var$bcb(581, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$rFd);
var $61de1ee1cac498ae$var$_4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "WrappedException", 581);
var $61de1ee1cac498ae$var$a5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$nve);
var $61de1ee1cac498ae$var$v5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$ove);
var $61de1ee1cac498ae$var$t5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$pve);
var $61de1ee1cac498ae$var$b5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$qve);
var $61de1ee1cac498ae$var$d5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$rve);
var $61de1ee1cac498ae$var$c5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, "EClass");
var $61de1ee1cac498ae$var$f5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, "EDataType");
var $61de1ee1cac498ae$var$sFd;
$61de1ee1cac498ae$var$bcb(1183, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$vFd);
$61de1ee1cac498ae$var$_.xc = function wFd(a) {
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$Phb(this, a) : $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(this.f, a));
};
var $61de1ee1cac498ae$var$e5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vse, "EDataType/Internal/ConversionDelegate/Factory/Registry/Impl", 1183);
var $61de1ee1cac498ae$var$h5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, "EEnum");
var $61de1ee1cac498ae$var$g5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$sve);
var $61de1ee1cac498ae$var$j5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$tve);
var $61de1ee1cac498ae$var$n5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$uve);
var $61de1ee1cac498ae$var$xFd;
var $61de1ee1cac498ae$var$p5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$vve);
var $61de1ee1cac498ae$var$q5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$wve);
$61de1ee1cac498ae$var$bcb(1029, 1, {}, $61de1ee1cac498ae$var$BFd);
$61de1ee1cac498ae$var$_.Ib = function CFd() {
    return "NIL";
};
var $61de1ee1cac498ae$var$r5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vse, "EStructuralFeature/Internal/DynamicValueHolder/1", 1029);
var $61de1ee1cac498ae$var$DFd;
$61de1ee1cac498ae$var$bcb(1028, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$GFd);
$61de1ee1cac498ae$var$_.xc = function HFd(a) {
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$Phb(this, a) : $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(this.f, a));
};
var $61de1ee1cac498ae$var$s5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Vse, "EStructuralFeature/Internal/SettingDelegate/Factory/Registry/Impl", 1028);
var $61de1ee1cac498ae$var$u5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, $61de1ee1cac498ae$var$xve);
var $61de1ee1cac498ae$var$w5 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Vse, "EValidator/PatternMatcher");
var $61de1ee1cac498ae$var$IFd;
var $61de1ee1cac498ae$var$KFd;
var $61de1ee1cac498ae$var$MFd;
var $61de1ee1cac498ae$var$OFd, $61de1ee1cac498ae$var$PFd, $61de1ee1cac498ae$var$QFd, $61de1ee1cac498ae$var$RFd, $61de1ee1cac498ae$var$SFd, $61de1ee1cac498ae$var$TFd, $61de1ee1cac498ae$var$UFd, $61de1ee1cac498ae$var$VFd, $61de1ee1cac498ae$var$WFd, $61de1ee1cac498ae$var$XFd, $61de1ee1cac498ae$var$YFd, $61de1ee1cac498ae$var$ZFd, $61de1ee1cac498ae$var$$Fd, $61de1ee1cac498ae$var$_Fd, $61de1ee1cac498ae$var$aGd, $61de1ee1cac498ae$var$bGd, $61de1ee1cac498ae$var$cGd, $61de1ee1cac498ae$var$dGd, $61de1ee1cac498ae$var$eGd, $61de1ee1cac498ae$var$fGd, $61de1ee1cac498ae$var$gGd, $61de1ee1cac498ae$var$hGd, $61de1ee1cac498ae$var$iGd;
var $61de1ee1cac498ae$var$E9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$yve, "FeatureMap/Entry");
$61de1ee1cac498ae$var$bcb(535, 1, {
    72: 1
}, $61de1ee1cac498ae$var$kGd);
$61de1ee1cac498ae$var$_.ak = function lGd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.dd = function mGd() {
    return this.b;
};
var $61de1ee1cac498ae$var$x5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "BasicEObjectImpl/1", 535);
$61de1ee1cac498ae$var$bcb(1027, 1, $61de1ee1cac498ae$var$zve, $61de1ee1cac498ae$var$nGd);
$61de1ee1cac498ae$var$_.Wj = function oGd(a) {
    return $61de1ee1cac498ae$var$hid(this.a, this.b, a);
};
$61de1ee1cac498ae$var$_.fj = function pGd() {
    return $61de1ee1cac498ae$var$nid(this.a, this.b);
};
$61de1ee1cac498ae$var$_.Wb = function qGd(a) {
    $61de1ee1cac498ae$var$zid(this.a, this.b, a);
};
$61de1ee1cac498ae$var$_.Xj = function rGd() {
    $61de1ee1cac498ae$var$Did(this.a, this.b);
};
var $61de1ee1cac498ae$var$y5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "BasicEObjectImpl/4", 1027);
$61de1ee1cac498ae$var$bcb(1983, 1, {
    108: 1
});
$61de1ee1cac498ae$var$_.bk = function uGd(a) {
    this.e = a == 0 ? $61de1ee1cac498ae$var$sGd : $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, a, 5, 1);
};
$61de1ee1cac498ae$var$_.Ch = function vGd(a) {
    return this.e[a];
};
$61de1ee1cac498ae$var$_.Dh = function wGd(a, b) {
    this.e[a] = b;
};
$61de1ee1cac498ae$var$_.Eh = function xGd(a) {
    this.e[a] = null;
};
$61de1ee1cac498ae$var$_.ck = function yGd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.dk = function zGd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.ek = function AGd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.fk = function BGd() {
    return this.d;
};
$61de1ee1cac498ae$var$_.gk = function CGd() {
    return this.e != null;
};
$61de1ee1cac498ae$var$_.hk = function DGd(a) {
    this.c = a;
};
$61de1ee1cac498ae$var$_.ik = function EGd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.jk = function FGd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.kk = function GGd(a) {
    this.d = a;
};
var $61de1ee1cac498ae$var$sGd;
var $61de1ee1cac498ae$var$z5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "BasicEObjectImpl/EPropertiesHolderBaseImpl", 1983);
$61de1ee1cac498ae$var$bcb(185, 1983, {
    108: 1
}, $61de1ee1cac498ae$var$HGd);
$61de1ee1cac498ae$var$_.dk = function IGd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.ek = function JGd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.ik = function KGd(a) {
    this.a = a;
};
$61de1ee1cac498ae$var$_.jk = function LGd(a) {
    this.b = a;
};
var $61de1ee1cac498ae$var$A5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "BasicEObjectImpl/EPropertiesHolderImpl", 185);
$61de1ee1cac498ae$var$bcb(506, 97, $61de1ee1cac498ae$var$pte, $61de1ee1cac498ae$var$MGd);
$61de1ee1cac498ae$var$_.Kg = function NGd() {
    return this.f;
};
$61de1ee1cac498ae$var$_.Pg = function OGd() {
    return this.k;
};
$61de1ee1cac498ae$var$_.Rg = function PGd(a, b) {
    this.g = a;
    this.i = b;
};
$61de1ee1cac498ae$var$_.Tg = function QGd() {
    return (this.j & 2) == 0 ? this.zh() : this.ph().ck();
};
$61de1ee1cac498ae$var$_.Vg = function RGd() {
    return this.i;
};
$61de1ee1cac498ae$var$_.Mg = function SGd() {
    return (this.j & 1) != 0;
};
$61de1ee1cac498ae$var$_.eh = function TGd() {
    return this.g;
};
$61de1ee1cac498ae$var$_.kh = function UGd() {
    return (this.j & 4) != 0;
};
$61de1ee1cac498ae$var$_.ph = function VGd() {
    return !this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k;
};
$61de1ee1cac498ae$var$_.th = function WGd(a) {
    this.ph().hk(a);
    a ? this.j |= 2 : this.j &= -3;
};
$61de1ee1cac498ae$var$_.vh = function XGd(a) {
    this.ph().jk(a);
    a ? this.j |= 4 : this.j &= -5;
};
$61de1ee1cac498ae$var$_.zh = function YGd() {
    return ($61de1ee1cac498ae$var$NFd(), $61de1ee1cac498ae$var$MFd).S;
};
$61de1ee1cac498ae$var$_.i = 0;
$61de1ee1cac498ae$var$_.j = 1;
var $61de1ee1cac498ae$var$l6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EObjectImpl", 506);
$61de1ee1cac498ae$var$bcb(780, 506, {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1
}, $61de1ee1cac498ae$var$_Gd);
$61de1ee1cac498ae$var$_.Ch = function aHd(a) {
    return this.e[a];
};
$61de1ee1cac498ae$var$_.Dh = function bHd(a, b) {
    this.e[a] = b;
};
$61de1ee1cac498ae$var$_.Eh = function cHd(a) {
    this.e[a] = null;
};
$61de1ee1cac498ae$var$_.Tg = function dHd() {
    return this.d;
};
$61de1ee1cac498ae$var$_.Yg = function eHd(a) {
    return $61de1ee1cac498ae$var$bLd(this.d, a);
};
$61de1ee1cac498ae$var$_.$g = function fHd() {
    return this.d;
};
$61de1ee1cac498ae$var$_.dh = function gHd() {
    return this.e != null;
};
$61de1ee1cac498ae$var$_.ph = function hHd() {
    !this.k && (this.k = new $61de1ee1cac498ae$var$vHd);
    return this.k;
};
$61de1ee1cac498ae$var$_.th = function iHd(a) {
    this.d = a;
};
$61de1ee1cac498ae$var$_.yh = function jHd() {
    var a;
    if (this.e == null) {
        a = $61de1ee1cac498ae$var$aLd(this.d);
        this.e = a == 0 ? $61de1ee1cac498ae$var$ZGd : $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, a, 5, 1);
    }
    return this;
};
$61de1ee1cac498ae$var$_.Ah = function kHd() {
    return 0;
};
var $61de1ee1cac498ae$var$ZGd;
var $61de1ee1cac498ae$var$E5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "DynamicEObjectImpl", 780);
$61de1ee1cac498ae$var$bcb(1376, 780, {
    105: 1,
    42: 1,
    92: 1,
    90: 1,
    133: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1
}, $61de1ee1cac498ae$var$lHd);
$61de1ee1cac498ae$var$_.Fb = function nHd(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.Hb = function rHd() {
    return $61de1ee1cac498ae$var$FCb(this);
};
$61de1ee1cac498ae$var$_.th = function mHd(a) {
    this.d = a;
    this.b = $61de1ee1cac498ae$var$YKd(a, "key");
    this.c = $61de1ee1cac498ae$var$YKd(a, $61de1ee1cac498ae$var$Bte);
};
$61de1ee1cac498ae$var$_.Sh = function oHd() {
    var a;
    if (this.a == -1) {
        a = $61de1ee1cac498ae$var$iid(this, this.b);
        this.a = a == null ? 0 : $61de1ee1cac498ae$var$tb(a);
    }
    return this.a;
};
$61de1ee1cac498ae$var$_.cd = function pHd() {
    return $61de1ee1cac498ae$var$iid(this, this.b);
};
$61de1ee1cac498ae$var$_.dd = function qHd() {
    return $61de1ee1cac498ae$var$iid(this, this.c);
};
$61de1ee1cac498ae$var$_.Th = function sHd(a) {
    this.a = a;
};
$61de1ee1cac498ae$var$_.Uh = function tHd(a) {
    $61de1ee1cac498ae$var$zid(this, this.b, a);
};
$61de1ee1cac498ae$var$_.ed = function uHd(a) {
    var b;
    b = $61de1ee1cac498ae$var$iid(this, this.c);
    $61de1ee1cac498ae$var$zid(this, this.c, a);
    return b;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$C5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "DynamicEObjectImpl/BasicEMapEntry", 1376);
$61de1ee1cac498ae$var$bcb(1377, 1, {
    108: 1
}, $61de1ee1cac498ae$var$vHd);
$61de1ee1cac498ae$var$_.bk = function wHd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Ch = function xHd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Dh = function yHd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Eh = function zHd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.ck = function AHd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.dk = function BHd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.ek = function CHd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.fk = function DHd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.gk = function EHd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.hk = function FHd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.ik = function GHd(a) {
    this.a = a;
};
$61de1ee1cac498ae$var$_.jk = function HHd(a) {
    this.b = a;
};
$61de1ee1cac498ae$var$_.kk = function IHd(a) {
    this.c = a;
};
var $61de1ee1cac498ae$var$D5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "DynamicEObjectImpl/DynamicEPropertiesHolderImpl", 1377);
$61de1ee1cac498ae$var$bcb(510, 150, {
    105: 1,
    92: 1,
    90: 1,
    590: 1,
    147: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    510: 1,
    150: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$RHd);
$61de1ee1cac498ae$var$_.Qg = function SHd(a) {
    return $61de1ee1cac498ae$var$KHd(this, a);
};
$61de1ee1cac498ae$var$_._g = function THd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.d;
        case 2:
            return c ? (!this.b && (this.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this)), this.b) : (!this.b && (this.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this)), $61de1ee1cac498ae$var$FAd(this.b));
        case 3:
            return $61de1ee1cac498ae$var$MHd(this);
        case 4:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$m5, this, 4)), this.a;
        case 5:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$m5, this, 5)), this.c;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$OFd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function UHd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 3:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$KHd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$JHd(this, $61de1ee1cac498ae$var$BD(a, 147), c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function VHd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 2:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this)), $61de1ee1cac498ae$var$bId(this.b, a, c);
        case 3:
            return $61de1ee1cac498ae$var$JHd(this, null, c);
        case 4:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$m5, this, 4)), $61de1ee1cac498ae$var$Txd(this.a, a, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function WHd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.d != null;
        case 2:
            return !!this.b && this.b.f != 0;
        case 3:
            return !!$61de1ee1cac498ae$var$MHd(this);
        case 4:
            return !!this.a && this.a.i != 0;
        case 5:
            return !!this.c && this.c.i != 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$OFd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function XHd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$OHd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            !this.b && (this.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this));
            $61de1ee1cac498ae$var$cId(this.b, b);
            return;
        case 3:
            $61de1ee1cac498ae$var$NHd(this, $61de1ee1cac498ae$var$BD(b, 147));
            return;
        case 4:
            !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$m5, this, 4));
            $61de1ee1cac498ae$var$Uxd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$m5, this, 4));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 5:
            !this.c && (this.c = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$m5, this, 5));
            $61de1ee1cac498ae$var$Uxd(this.c);
            !this.c && (this.c = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$m5, this, 5));
            $61de1ee1cac498ae$var$ytd(this.c, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$OFd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function YHd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd;
};
$61de1ee1cac498ae$var$_.Bh = function ZHd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$PHd(this, null);
            return;
        case 2:
            !this.b && (this.b = new $61de1ee1cac498ae$var$sId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this));
            this.b.c.$b();
            return;
        case 3:
            $61de1ee1cac498ae$var$NHd(this, null);
            return;
        case 4:
            !this.a && (this.a = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$m5, this, 4));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
        case 5:
            !this.c && (this.c = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$m5, this, 5));
            $61de1ee1cac498ae$var$Uxd(this.c);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$OFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$OFd : b), a));
};
$61de1ee1cac498ae$var$_.Ib = function $Hd() {
    return $61de1ee1cac498ae$var$QHd(this);
};
$61de1ee1cac498ae$var$_.d = null;
var $61de1ee1cac498ae$var$G5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EAnnotationImpl", 510);
$61de1ee1cac498ae$var$bcb(151, 705, $61de1ee1cac498ae$var$Ave, $61de1ee1cac498ae$var$dId);
$61de1ee1cac498ae$var$_.Xh = function eId(a, b) {
    $61de1ee1cac498ae$var$_Hd(this, a, $61de1ee1cac498ae$var$BD(b, 42));
};
$61de1ee1cac498ae$var$_.lk = function fId(a, b) {
    return $61de1ee1cac498ae$var$aId(this, $61de1ee1cac498ae$var$BD(a, 42), b);
};
$61de1ee1cac498ae$var$_.pi = function gId(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD(this.c, 69).pi(a), 133);
};
$61de1ee1cac498ae$var$_.Zh = function hId() {
    return $61de1ee1cac498ae$var$BD(this.c, 69).Zh();
};
$61de1ee1cac498ae$var$_.$h = function iId() {
    return $61de1ee1cac498ae$var$BD(this.c, 69).$h();
};
$61de1ee1cac498ae$var$_._h = function jId(a) {
    return $61de1ee1cac498ae$var$BD(this.c, 69)._h(a);
};
$61de1ee1cac498ae$var$_.mk = function kId(a, b) {
    return $61de1ee1cac498ae$var$bId(this, a, b);
};
$61de1ee1cac498ae$var$_.Wj = function lId(a) {
    return $61de1ee1cac498ae$var$BD(this.c, 76).Wj(a);
};
$61de1ee1cac498ae$var$_.rj = function mId() {};
$61de1ee1cac498ae$var$_.fj = function nId() {
    return $61de1ee1cac498ae$var$BD(this.c, 76).fj();
};
$61de1ee1cac498ae$var$_.tj = function oId(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$bKd(this.b).Nh().Jh(this.b), 133);
    d.Th(a);
    d.Uh(b);
    d.ed(c);
    return d;
};
$61de1ee1cac498ae$var$_.uj = function pId() {
    return new $61de1ee1cac498ae$var$W5d(this);
};
$61de1ee1cac498ae$var$_.Wb = function qId(a) {
    $61de1ee1cac498ae$var$cId(this, a);
};
$61de1ee1cac498ae$var$_.Xj = function rId() {
    $61de1ee1cac498ae$var$BD(this.c, 76).Xj();
};
var $61de1ee1cac498ae$var$y9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEMap", 151);
$61de1ee1cac498ae$var$bcb(158, 151, $61de1ee1cac498ae$var$Ave, $61de1ee1cac498ae$var$sId);
$61de1ee1cac498ae$var$_.qj = function tId() {
    var a, b, c, d, e, f;
    if (this.d == null) {
        f = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$y4, $61de1ee1cac498ae$var$jve, 63, 2 * this.f + 1, 0, 1);
        for(c = this.c.Kc(); c.e != c.i.gc();){
            b = $61de1ee1cac498ae$var$BD(c.nj(), 133);
            d = b.Sh();
            e = (d & $61de1ee1cac498ae$var$Ohe) % f.length;
            a = f[e];
            !a && (a = f[e] = new $61de1ee1cac498ae$var$W5d(this));
            a.Fc(b);
        }
        this.d = f;
    }
};
var $61de1ee1cac498ae$var$F5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EAnnotationImpl/1", 158);
$61de1ee1cac498ae$var$bcb(284, 438, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    472: 1,
    49: 1,
    97: 1,
    150: 1,
    284: 1,
    114: 1,
    115: 1
});
$61de1ee1cac498ae$var$_._g = function GId(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return $61de1ee1cac498ae$var$meb(this.s);
        case 5:
            return $61de1ee1cac498ae$var$meb(this.t);
        case 6:
            return $61de1ee1cac498ae$var$Bcb(), this.$j() ? true : false;
        case 7:
            return $61de1ee1cac498ae$var$Bcb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return $61de1ee1cac498ae$var$wId(this);
            return this.r;
        case 9:
            return this.q;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), a), b, c);
};
$61de1ee1cac498ae$var$_.jh = function HId(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 9:
            return $61de1ee1cac498ae$var$vId(this, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.lh = function IId(a) {
    var b, c;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return this.$j();
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0);
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.sh = function JId(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            this.Lh($61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 5:
            this.ok($61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, $61de1ee1cac498ae$var$BD(b, 138));
            return;
        case 9:
            d = $61de1ee1cac498ae$var$xId(this, $61de1ee1cac498ae$var$BD(b, 87), null);
            !!d && d.Fi();
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? this.zh() : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function KId() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$hGd;
};
$61de1ee1cac498ae$var$_.Bh = function LId(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            this.Lh(null);
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, true);
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, true);
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, 0);
            return;
        case 5:
            this.ok(1);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, null);
            return;
        case 9:
            c = $61de1ee1cac498ae$var$xId(this, null, null);
            !!c && c.Fi();
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function MId() {
    $61de1ee1cac498ae$var$wId(this);
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.Yj = function NId() {
    return $61de1ee1cac498ae$var$wId(this);
};
$61de1ee1cac498ae$var$_.Zj = function OId() {
    return this.t;
};
$61de1ee1cac498ae$var$_.$j = function PId() {
    var a;
    return a = this.t, a > 1 || a == -1;
};
$61de1ee1cac498ae$var$_.hi = function QId() {
    return (this.Bb & 512) != 0;
};
$61de1ee1cac498ae$var$_.nk = function RId(a, b) {
    return $61de1ee1cac498ae$var$zId(this, a, b);
};
$61de1ee1cac498ae$var$_.ok = function SId(a) {
    $61de1ee1cac498ae$var$DId(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function TId() {
    return $61de1ee1cac498ae$var$EId(this);
};
$61de1ee1cac498ae$var$_.s = 0;
$61de1ee1cac498ae$var$_.t = 1;
var $61de1ee1cac498ae$var$v7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ETypedElementImpl", 284);
$61de1ee1cac498ae$var$bcb(449, 284, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    170: 1,
    66: 1,
    108: 1,
    472: 1,
    49: 1,
    97: 1,
    150: 1,
    449: 1,
    284: 1,
    114: 1,
    115: 1,
    677: 1
});
$61de1ee1cac498ae$var$_.Qg = function iJd(a) {
    return $61de1ee1cac498ae$var$UId(this, a);
};
$61de1ee1cac498ae$var$_._g = function jJd(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return $61de1ee1cac498ae$var$meb(this.s);
        case 5:
            return $61de1ee1cac498ae$var$meb(this.t);
        case 6:
            return $61de1ee1cac498ae$var$Bcb(), this.$j() ? true : false;
        case 7:
            return $61de1ee1cac498ae$var$Bcb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return $61de1ee1cac498ae$var$wId(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$zte) != 0 ? true : false;
        case 11:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Dve) != 0 ? true : false;
        case 12:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Rje) != 0 ? true : false;
        case 13:
            return this.j;
        case 14:
            return $61de1ee1cac498ae$var$VId(this);
        case 15:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? true : false;
        case 16:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$oie) != 0 ? true : false;
        case 17:
            return $61de1ee1cac498ae$var$WId(this);
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function kJd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 17:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$UId(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 17, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.jh = function lJd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 9:
            return $61de1ee1cac498ae$var$vId(this, c);
        case 17:
            return $61de1ee1cac498ae$var$_hd(this, null, 17, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.lh = function mJd(a) {
    var b, c;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return this.$j();
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0);
        case 10:
            return (this.Bb & $61de1ee1cac498ae$var$zte) == 0;
        case 11:
            return (this.Bb & $61de1ee1cac498ae$var$Dve) != 0;
        case 12:
            return (this.Bb & $61de1ee1cac498ae$var$Rje) != 0;
        case 13:
            return this.j != null;
        case 14:
            return $61de1ee1cac498ae$var$VId(this) != null;
        case 15:
            return (this.Bb & $61de1ee1cac498ae$var$Cve) != 0;
        case 16:
            return (this.Bb & $61de1ee1cac498ae$var$oie) != 0;
        case 17:
            return !!$61de1ee1cac498ae$var$WId(this);
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.sh = function nJd(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$cJd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 5:
            this.ok($61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, $61de1ee1cac498ae$var$BD(b, 138));
            return;
        case 9:
            d = $61de1ee1cac498ae$var$xId(this, $61de1ee1cac498ae$var$BD(b, 87), null);
            !!d && d.Fi();
            return;
        case 10:
            $61de1ee1cac498ae$var$ZId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 11:
            $61de1ee1cac498ae$var$fJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 12:
            $61de1ee1cac498ae$var$dJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 13:
            $61de1ee1cac498ae$var$$Id(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 15:
            $61de1ee1cac498ae$var$eJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 16:
            $61de1ee1cac498ae$var$aJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? this.zh() : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function oJd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$gGd;
};
$61de1ee1cac498ae$var$_.Bh = function pJd(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$JD(this.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(this.Cb, 88)), 4);
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, true);
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, true);
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, 0);
            return;
        case 5:
            this.ok(1);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, null);
            return;
        case 9:
            c = $61de1ee1cac498ae$var$xId(this, null, null);
            !!c && c.Fi();
            return;
        case 10:
            $61de1ee1cac498ae$var$ZId(this, true);
            return;
        case 11:
            $61de1ee1cac498ae$var$fJd(this, false);
            return;
        case 12:
            $61de1ee1cac498ae$var$dJd(this, false);
            return;
        case 13:
            this.i = null;
            $61de1ee1cac498ae$var$_Id(this, null);
            return;
        case 15:
            $61de1ee1cac498ae$var$eJd(this, false);
            return;
        case 16:
            $61de1ee1cac498ae$var$aJd(this, false);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function qJd() {
    $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), this));
    $61de1ee1cac498ae$var$wId(this);
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.Gj = function rJd() {
    return this.f;
};
$61de1ee1cac498ae$var$_.zj = function sJd() {
    return $61de1ee1cac498ae$var$VId(this);
};
$61de1ee1cac498ae$var$_.Hj = function tJd() {
    return $61de1ee1cac498ae$var$WId(this);
};
$61de1ee1cac498ae$var$_.Lj = function uJd() {
    return null;
};
$61de1ee1cac498ae$var$_.pk = function vJd() {
    return this.k;
};
$61de1ee1cac498ae$var$_.aj = function wJd() {
    return this.n;
};
$61de1ee1cac498ae$var$_.Mj = function xJd() {
    return $61de1ee1cac498ae$var$XId(this);
};
$61de1ee1cac498ae$var$_.Nj = function yJd() {
    var a, b, c, d, e, f, g, h, i;
    if (!this.p) {
        c = $61de1ee1cac498ae$var$WId(this);
        (c.i == null && $61de1ee1cac498ae$var$TKd(c), c.i).length;
        d = this.Lj();
        !!d && $61de1ee1cac498ae$var$aLd($61de1ee1cac498ae$var$WId(d));
        e = $61de1ee1cac498ae$var$wId(this);
        g = e.Bj();
        a = !g ? null : (g.i & 1) != 0 ? g == $61de1ee1cac498ae$var$sbb ? $61de1ee1cac498ae$var$wI : g == $61de1ee1cac498ae$var$WD ? $61de1ee1cac498ae$var$JI : g == $61de1ee1cac498ae$var$VD ? $61de1ee1cac498ae$var$FI : g == $61de1ee1cac498ae$var$UD ? $61de1ee1cac498ae$var$BI : g == $61de1ee1cac498ae$var$XD ? $61de1ee1cac498ae$var$MI : g == $61de1ee1cac498ae$var$rbb ? $61de1ee1cac498ae$var$UI : g == $61de1ee1cac498ae$var$SD ? $61de1ee1cac498ae$var$xI : $61de1ee1cac498ae$var$yI : g;
        b = $61de1ee1cac498ae$var$VId(this);
        h = e.zj();
        $61de1ee1cac498ae$var$n6d(this);
        (this.Bb & $61de1ee1cac498ae$var$oie) != 0 && (!!(f = $61de1ee1cac498ae$var$t1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), c)) && f != this || !!(f = $61de1ee1cac498ae$var$_1d($61de1ee1cac498ae$var$q1d($61de1ee1cac498ae$var$M6d, this)))) ? this.p = new $61de1ee1cac498ae$var$zVd(this, f) : this.$j() ? this.rk() ? !d ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.sk() ? this.p = new $61de1ee1cac498ae$var$KVd(42, this) : this.p = new $61de1ee1cac498ae$var$KVd(0, this) : a == $61de1ee1cac498ae$var$CK ? this.p = new $61de1ee1cac498ae$var$IVd(50, $61de1ee1cac498ae$var$J4, this) : this.sk() ? this.p = new $61de1ee1cac498ae$var$IVd(43, a, this) : this.p = new $61de1ee1cac498ae$var$IVd(1, a, this) : !a ? this.sk() ? this.p = new $61de1ee1cac498ae$var$KVd(44, this) : this.p = new $61de1ee1cac498ae$var$KVd(2, this) : a == $61de1ee1cac498ae$var$CK ? this.p = new $61de1ee1cac498ae$var$IVd(41, $61de1ee1cac498ae$var$J4, this) : this.sk() ? this.p = new $61de1ee1cac498ae$var$IVd(45, a, this) : this.p = new $61de1ee1cac498ae$var$IVd(3, a, this) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.sk() ? this.p = new $61de1ee1cac498ae$var$LVd(46, this, d) : this.p = new $61de1ee1cac498ae$var$LVd(4, this, d) : this.sk() ? this.p = new $61de1ee1cac498ae$var$JVd(47, a, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(5, a, this, d) : !a ? this.sk() ? this.p = new $61de1ee1cac498ae$var$LVd(48, this, d) : this.p = new $61de1ee1cac498ae$var$LVd(6, this, d) : this.sk() ? this.p = new $61de1ee1cac498ae$var$JVd(49, a, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(7, a, this, d) : $61de1ee1cac498ae$var$JD(e, 148) ? a == $61de1ee1cac498ae$var$E9 ? this.p = new $61de1ee1cac498ae$var$KVd(40, this) : (this.Bb & 512) != 0 ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$KVd(8, this) : this.p = new $61de1ee1cac498ae$var$IVd(9, a, this) : !a ? this.p = new $61de1ee1cac498ae$var$KVd(10, this) : this.p = new $61de1ee1cac498ae$var$IVd(11, a, this) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$KVd(12, this) : this.p = new $61de1ee1cac498ae$var$IVd(13, a, this) : !a ? this.p = new $61de1ee1cac498ae$var$KVd(14, this) : this.p = new $61de1ee1cac498ae$var$IVd(15, a, this) : !d ? this.sk() ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$KVd(16, this) : this.p = new $61de1ee1cac498ae$var$IVd(17, a, this) : !a ? this.p = new $61de1ee1cac498ae$var$KVd(18, this) : this.p = new $61de1ee1cac498ae$var$IVd(19, a, this) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$KVd(20, this) : this.p = new $61de1ee1cac498ae$var$IVd(21, a, this) : !a ? this.p = new $61de1ee1cac498ae$var$KVd(22, this) : this.p = new $61de1ee1cac498ae$var$IVd(23, a, this) : (i = d.t, i > 1 || i == -1 ? this.sk() ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$LVd(24, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(25, a, this, d) : !a ? this.p = new $61de1ee1cac498ae$var$LVd(26, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(27, a, this, d) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$LVd(28, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(29, a, this, d) : !a ? this.p = new $61de1ee1cac498ae$var$LVd(30, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(31, a, this, d) : this.sk() ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$LVd(32, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(33, a, this, d) : !a ? this.p = new $61de1ee1cac498ae$var$LVd(34, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(35, a, this, d) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$LVd(36, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(37, a, this, d) : !a ? this.p = new $61de1ee1cac498ae$var$LVd(38, this, d) : this.p = new $61de1ee1cac498ae$var$JVd(39, a, this, d)) : this.qk() ? this.sk() ? this.p = new $61de1ee1cac498ae$var$kWd($61de1ee1cac498ae$var$BD(e, 26), this, d) : this.p = new $61de1ee1cac498ae$var$cWd($61de1ee1cac498ae$var$BD(e, 26), this, d) : $61de1ee1cac498ae$var$JD(e, 148) ? a == $61de1ee1cac498ae$var$E9 ? this.p = new $61de1ee1cac498ae$var$KVd(40, this) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? !a ? this.p = new $61de1ee1cac498ae$var$jXd($61de1ee1cac498ae$var$BD(e, 148), b, h, this) : this.p = new $61de1ee1cac498ae$var$lXd(b, h, this, ($61de1ee1cac498ae$var$CWd(), g == $61de1ee1cac498ae$var$WD ? $61de1ee1cac498ae$var$yWd : g == $61de1ee1cac498ae$var$sbb ? $61de1ee1cac498ae$var$tWd : g == $61de1ee1cac498ae$var$XD ? $61de1ee1cac498ae$var$zWd : g == $61de1ee1cac498ae$var$VD ? $61de1ee1cac498ae$var$xWd : g == $61de1ee1cac498ae$var$UD ? $61de1ee1cac498ae$var$wWd : g == $61de1ee1cac498ae$var$rbb ? $61de1ee1cac498ae$var$BWd : g == $61de1ee1cac498ae$var$SD ? $61de1ee1cac498ae$var$uWd : g == $61de1ee1cac498ae$var$TD ? $61de1ee1cac498ae$var$vWd : $61de1ee1cac498ae$var$AWd)) : !a ? this.p = new $61de1ee1cac498ae$var$cXd($61de1ee1cac498ae$var$BD(e, 148), b, h, this) : this.p = new $61de1ee1cac498ae$var$eXd(b, h, this, ($61de1ee1cac498ae$var$CWd(), g == $61de1ee1cac498ae$var$WD ? $61de1ee1cac498ae$var$yWd : g == $61de1ee1cac498ae$var$sbb ? $61de1ee1cac498ae$var$tWd : g == $61de1ee1cac498ae$var$XD ? $61de1ee1cac498ae$var$zWd : g == $61de1ee1cac498ae$var$VD ? $61de1ee1cac498ae$var$xWd : g == $61de1ee1cac498ae$var$UD ? $61de1ee1cac498ae$var$wWd : g == $61de1ee1cac498ae$var$rbb ? $61de1ee1cac498ae$var$BWd : g == $61de1ee1cac498ae$var$SD ? $61de1ee1cac498ae$var$uWd : g == $61de1ee1cac498ae$var$TD ? $61de1ee1cac498ae$var$vWd : $61de1ee1cac498ae$var$AWd)) : this.rk() ? !d ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? this.sk() ? this.p = new $61de1ee1cac498ae$var$FXd($61de1ee1cac498ae$var$BD(e, 26), this) : this.p = new $61de1ee1cac498ae$var$DXd($61de1ee1cac498ae$var$BD(e, 26), this) : this.sk() ? this.p = new $61de1ee1cac498ae$var$BXd($61de1ee1cac498ae$var$BD(e, 26), this) : this.p = new $61de1ee1cac498ae$var$zXd($61de1ee1cac498ae$var$BD(e, 26), this) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? this.sk() ? this.p = new $61de1ee1cac498ae$var$NXd($61de1ee1cac498ae$var$BD(e, 26), this, d) : this.p = new $61de1ee1cac498ae$var$LXd($61de1ee1cac498ae$var$BD(e, 26), this, d) : this.sk() ? this.p = new $61de1ee1cac498ae$var$JXd($61de1ee1cac498ae$var$BD(e, 26), this, d) : this.p = new $61de1ee1cac498ae$var$HXd($61de1ee1cac498ae$var$BD(e, 26), this, d) : this.sk() ? !d ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? this.p = new $61de1ee1cac498ae$var$RXd($61de1ee1cac498ae$var$BD(e, 26), this) : this.p = new $61de1ee1cac498ae$var$PXd($61de1ee1cac498ae$var$BD(e, 26), this) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? this.p = new $61de1ee1cac498ae$var$VXd($61de1ee1cac498ae$var$BD(e, 26), this, d) : this.p = new $61de1ee1cac498ae$var$TXd($61de1ee1cac498ae$var$BD(e, 26), this, d) : !d ? (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? this.p = new $61de1ee1cac498ae$var$XXd($61de1ee1cac498ae$var$BD(e, 26), this) : this.p = new $61de1ee1cac498ae$var$nXd($61de1ee1cac498ae$var$BD(e, 26), this) : (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? this.p = new $61de1ee1cac498ae$var$_Xd($61de1ee1cac498ae$var$BD(e, 26), this, d) : this.p = new $61de1ee1cac498ae$var$ZXd($61de1ee1cac498ae$var$BD(e, 26), this, d);
    }
    return this.p;
};
$61de1ee1cac498ae$var$_.Ij = function zJd() {
    return (this.Bb & $61de1ee1cac498ae$var$zte) != 0;
};
$61de1ee1cac498ae$var$_.qk = function AJd() {
    return false;
};
$61de1ee1cac498ae$var$_.rk = function BJd() {
    return false;
};
$61de1ee1cac498ae$var$_.Jj = function CJd() {
    return (this.Bb & $61de1ee1cac498ae$var$oie) != 0;
};
$61de1ee1cac498ae$var$_.Oj = function DJd() {
    return $61de1ee1cac498ae$var$YId(this);
};
$61de1ee1cac498ae$var$_.sk = function EJd() {
    return false;
};
$61de1ee1cac498ae$var$_.Kj = function FJd() {
    return (this.Bb & $61de1ee1cac498ae$var$Cve) != 0;
};
$61de1ee1cac498ae$var$_.tk = function GJd(a) {
    this.k = a;
};
$61de1ee1cac498ae$var$_.Lh = function HJd(a) {
    $61de1ee1cac498ae$var$cJd(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function IJd() {
    return $61de1ee1cac498ae$var$gJd(this);
};
$61de1ee1cac498ae$var$_.e = false;
$61de1ee1cac498ae$var$_.n = 0;
var $61de1ee1cac498ae$var$n7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl", 449);
$61de1ee1cac498ae$var$bcb(322, 449, {
    105: 1,
    92: 1,
    90: 1,
    34: 1,
    147: 1,
    191: 1,
    56: 1,
    170: 1,
    66: 1,
    108: 1,
    472: 1,
    49: 1,
    97: 1,
    322: 1,
    150: 1,
    449: 1,
    284: 1,
    114: 1,
    115: 1,
    677: 1
}, $61de1ee1cac498ae$var$OJd);
$61de1ee1cac498ae$var$_._g = function PJd(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return $61de1ee1cac498ae$var$meb(this.s);
        case 5:
            return $61de1ee1cac498ae$var$meb(this.t);
        case 6:
            return $61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$LJd(this) ? true : false;
        case 7:
            return $61de1ee1cac498ae$var$Bcb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return $61de1ee1cac498ae$var$wId(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$zte) != 0 ? true : false;
        case 11:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Dve) != 0 ? true : false;
        case 12:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Rje) != 0 ? true : false;
        case 13:
            return this.j;
        case 14:
            return $61de1ee1cac498ae$var$VId(this);
        case 15:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? true : false;
        case 16:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$oie) != 0 ? true : false;
        case 17:
            return $61de1ee1cac498ae$var$WId(this);
        case 18:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$ote) != 0 ? true : false;
        case 19:
            if (b) return $61de1ee1cac498ae$var$KJd(this);
            return $61de1ee1cac498ae$var$JJd(this);
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$PFd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$PFd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.lh = function QJd(a) {
    var b, c;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return $61de1ee1cac498ae$var$LJd(this);
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0);
        case 10:
            return (this.Bb & $61de1ee1cac498ae$var$zte) == 0;
        case 11:
            return (this.Bb & $61de1ee1cac498ae$var$Dve) != 0;
        case 12:
            return (this.Bb & $61de1ee1cac498ae$var$Rje) != 0;
        case 13:
            return this.j != null;
        case 14:
            return $61de1ee1cac498ae$var$VId(this) != null;
        case 15:
            return (this.Bb & $61de1ee1cac498ae$var$Cve) != 0;
        case 16:
            return (this.Bb & $61de1ee1cac498ae$var$oie) != 0;
        case 17:
            return !!$61de1ee1cac498ae$var$WId(this);
        case 18:
            return (this.Bb & $61de1ee1cac498ae$var$ote) != 0;
        case 19:
            return !!$61de1ee1cac498ae$var$JJd(this);
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$PFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$PFd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function RJd(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$cJd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 5:
            $61de1ee1cac498ae$var$NJd(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, $61de1ee1cac498ae$var$BD(b, 138));
            return;
        case 9:
            d = $61de1ee1cac498ae$var$xId(this, $61de1ee1cac498ae$var$BD(b, 87), null);
            !!d && d.Fi();
            return;
        case 10:
            $61de1ee1cac498ae$var$ZId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 11:
            $61de1ee1cac498ae$var$fJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 12:
            $61de1ee1cac498ae$var$dJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 13:
            $61de1ee1cac498ae$var$$Id(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 15:
            $61de1ee1cac498ae$var$eJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 16:
            $61de1ee1cac498ae$var$aJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 18:
            $61de1ee1cac498ae$var$MJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$PFd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$PFd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function SJd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$PFd;
};
$61de1ee1cac498ae$var$_.Bh = function TJd(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$JD(this.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(this.Cb, 88)), 4);
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, true);
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, true);
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, 0);
            return;
        case 5:
            this.b = 0;
            $61de1ee1cac498ae$var$DId(this, 1);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, null);
            return;
        case 9:
            c = $61de1ee1cac498ae$var$xId(this, null, null);
            !!c && c.Fi();
            return;
        case 10:
            $61de1ee1cac498ae$var$ZId(this, true);
            return;
        case 11:
            $61de1ee1cac498ae$var$fJd(this, false);
            return;
        case 12:
            $61de1ee1cac498ae$var$dJd(this, false);
            return;
        case 13:
            this.i = null;
            $61de1ee1cac498ae$var$_Id(this, null);
            return;
        case 15:
            $61de1ee1cac498ae$var$eJd(this, false);
            return;
        case 16:
            $61de1ee1cac498ae$var$aJd(this, false);
            return;
        case 18:
            $61de1ee1cac498ae$var$MJd(this, false);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$PFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$PFd : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function UJd() {
    $61de1ee1cac498ae$var$KJd(this);
    $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), this));
    $61de1ee1cac498ae$var$wId(this);
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.$j = function VJd() {
    return $61de1ee1cac498ae$var$LJd(this);
};
$61de1ee1cac498ae$var$_.nk = function WJd(a, b) {
    this.b = 0;
    this.a = null;
    return $61de1ee1cac498ae$var$zId(this, a, b);
};
$61de1ee1cac498ae$var$_.ok = function XJd(a) {
    $61de1ee1cac498ae$var$NJd(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function YJd() {
    var a;
    if ((this.Db & 64) != 0) return $61de1ee1cac498ae$var$gJd(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$gJd(this));
    a.a += " (iD: ";
    $61de1ee1cac498ae$var$Ffb(a, (this.Bb & $61de1ee1cac498ae$var$ote) != 0);
    a.a += ")";
    return a.a;
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$H5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EAttributeImpl", 322);
$61de1ee1cac498ae$var$bcb(351, 438, {
    105: 1,
    92: 1,
    90: 1,
    138: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    351: 1,
    150: 1,
    114: 1,
    115: 1,
    676: 1
});
$61de1ee1cac498ae$var$_.uk = function nKd(a) {
    return a.Tg() == this;
};
$61de1ee1cac498ae$var$_.Qg = function oKd(a) {
    return $61de1ee1cac498ae$var$aKd(this, a);
};
$61de1ee1cac498ae$var$_.Rg = function pKd(a, b) {
    this.w = null;
    this.Db = b << 16 | this.Db & 255;
    this.Cb = a;
};
$61de1ee1cac498ae$var$_._g = function qKd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return $61de1ee1cac498ae$var$dKd(this);
        case 4:
            return this.zj();
        case 5:
            return this.F;
        case 6:
            if (b) return $61de1ee1cac498ae$var$bKd(this);
            return $61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7)), this.A;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function rKd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$aKd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 6, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.jh = function sKd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 6:
            return $61de1ee1cac498ae$var$_hd(this, null, 6, c);
        case 7:
            return !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7)), $61de1ee1cac498ae$var$Txd(this.A, a, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.lh = function tKd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!$61de1ee1cac498ae$var$dKd(this);
        case 4:
            return this.zj() != null;
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!$61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !!this.A && this.A.i != 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.sh = function uKd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$lKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$iKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$ytd(this.A, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? this.zh() : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function vKd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$RFd;
};
$61de1ee1cac498ae$var$_.Bh = function wKd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$JD(this.Cb, 179) && ($61de1ee1cac498ae$var$BD(this.Cb, 179).tb = null);
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$$Jd(this, null);
            $61de1ee1cac498ae$var$_Jd(this, this.D);
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, null);
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.yj = function xKd() {
    var a;
    return this.G == -1 && (this.G = (a = $61de1ee1cac498ae$var$bKd(this), a ? $61de1ee1cac498ae$var$HLd(a.Mh(), this) : -1)), this.G;
};
$61de1ee1cac498ae$var$_.zj = function yKd() {
    return null;
};
$61de1ee1cac498ae$var$_.Aj = function zKd() {
    return $61de1ee1cac498ae$var$bKd(this);
};
$61de1ee1cac498ae$var$_.vk = function AKd() {
    return this.v;
};
$61de1ee1cac498ae$var$_.Bj = function BKd() {
    return $61de1ee1cac498ae$var$dKd(this);
};
$61de1ee1cac498ae$var$_.Cj = function CKd() {
    return this.D != null ? this.D : this.B;
};
$61de1ee1cac498ae$var$_.Dj = function DKd() {
    return this.F;
};
$61de1ee1cac498ae$var$_.wj = function EKd(a) {
    return $61de1ee1cac498ae$var$fKd(this, a);
};
$61de1ee1cac498ae$var$_.wk = function FKd(a) {
    this.v = a;
};
$61de1ee1cac498ae$var$_.xk = function GKd(a) {
    $61de1ee1cac498ae$var$gKd(this, a);
};
$61de1ee1cac498ae$var$_.yk = function HKd(a) {
    this.C = a;
};
$61de1ee1cac498ae$var$_.Lh = function IKd(a) {
    $61de1ee1cac498ae$var$lKd(this, a);
};
$61de1ee1cac498ae$var$_.Ib = function JKd() {
    return $61de1ee1cac498ae$var$mKd(this);
};
$61de1ee1cac498ae$var$_.C = null;
$61de1ee1cac498ae$var$_.D = null;
$61de1ee1cac498ae$var$_.G = -1;
var $61de1ee1cac498ae$var$Z5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassifierImpl", 351);
$61de1ee1cac498ae$var$bcb(88, 351, {
    105: 1,
    92: 1,
    90: 1,
    26: 1,
    138: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    88: 1,
    351: 1,
    150: 1,
    473: 1,
    114: 1,
    115: 1,
    676: 1
}, $61de1ee1cac498ae$var$hLd);
$61de1ee1cac498ae$var$_.uk = function iLd(a) {
    return $61de1ee1cac498ae$var$dLd(this, a.Tg());
};
$61de1ee1cac498ae$var$_._g = function jLd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return $61de1ee1cac498ae$var$dKd(this);
        case 4:
            return null;
        case 5:
            return this.F;
        case 6:
            if (b) return $61de1ee1cac498ae$var$bKd(this);
            return $61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7)), this.A;
        case 8:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 9:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 512) != 0 ? true : false;
        case 10:
            return $61de1ee1cac498ae$var$_Kd(this);
        case 11:
            return !this.q && (this.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, this, 11, 10)), this.q;
        case 12:
            return $61de1ee1cac498ae$var$OKd(this);
        case 13:
            return $61de1ee1cac498ae$var$SKd(this);
        case 14:
            return $61de1ee1cac498ae$var$SKd(this), this.r;
        case 15:
            return $61de1ee1cac498ae$var$OKd(this), this.k;
        case 16:
            return $61de1ee1cac498ae$var$PKd(this);
        case 17:
            return $61de1ee1cac498ae$var$RKd(this);
        case 18:
            return $61de1ee1cac498ae$var$TKd(this);
        case 19:
            return $61de1ee1cac498ae$var$UKd(this);
        case 20:
            return $61de1ee1cac498ae$var$OKd(this), this.o;
        case 21:
            return !this.s && (this.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, this, 21, 17)), this.s;
        case 22:
            return $61de1ee1cac498ae$var$VKd(this);
        case 23:
            return $61de1ee1cac498ae$var$QKd(this);
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$QFd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function kLd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$aKd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 6, c);
        case 11:
            return !this.q && (this.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, this, 11, 10)), $61de1ee1cac498ae$var$Sxd(this.q, a, c);
        case 21:
            return !this.s && (this.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, this, 21, 17)), $61de1ee1cac498ae$var$Sxd(this.s, a, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function lLd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 6:
            return $61de1ee1cac498ae$var$_hd(this, null, 6, c);
        case 7:
            return !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7)), $61de1ee1cac498ae$var$Txd(this.A, a, c);
        case 11:
            return !this.q && (this.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, this, 11, 10)), $61de1ee1cac498ae$var$Txd(this.q, a, c);
        case 21:
            return !this.s && (this.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, this, 21, 17)), $61de1ee1cac498ae$var$Txd(this.s, a, c);
        case 22:
            return $61de1ee1cac498ae$var$Txd($61de1ee1cac498ae$var$VKd(this), a, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function mLd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!$61de1ee1cac498ae$var$dKd(this);
        case 4:
            return false;
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!$61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !!this.A && this.A.i != 0;
        case 8:
            return (this.Bb & 256) != 0;
        case 9:
            return (this.Bb & 512) != 0;
        case 10:
            return !!this.u && $61de1ee1cac498ae$var$VKd(this.u.a).i != 0 && !(!!this.n && $61de1ee1cac498ae$var$FMd(this.n));
        case 11:
            return !!this.q && this.q.i != 0;
        case 12:
            return $61de1ee1cac498ae$var$OKd(this).i != 0;
        case 13:
            return $61de1ee1cac498ae$var$SKd(this).i != 0;
        case 14:
            return $61de1ee1cac498ae$var$SKd(this), this.r.i != 0;
        case 15:
            return $61de1ee1cac498ae$var$OKd(this), this.k.i != 0;
        case 16:
            return $61de1ee1cac498ae$var$PKd(this).i != 0;
        case 17:
            return $61de1ee1cac498ae$var$RKd(this).i != 0;
        case 18:
            return $61de1ee1cac498ae$var$TKd(this).i != 0;
        case 19:
            return $61de1ee1cac498ae$var$UKd(this).i != 0;
        case 20:
            return $61de1ee1cac498ae$var$OKd(this), !!this.o;
        case 21:
            return !!this.s && this.s.i != 0;
        case 22:
            return !!this.n && $61de1ee1cac498ae$var$FMd(this.n);
        case 23:
            return $61de1ee1cac498ae$var$QKd(this).i != 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$QFd : b), a));
};
$61de1ee1cac498ae$var$_.oh = function nLd(a) {
    var b;
    b = this.i == null || !!this.q && this.q.i != 0 ? null : $61de1ee1cac498ae$var$YKd(this, a);
    return b ? b : $61de1ee1cac498ae$var$Bmd(this, a);
};
$61de1ee1cac498ae$var$_.sh = function oLd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$lKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$iKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$ytd(this.A, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 8:
            $61de1ee1cac498ae$var$eLd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 9:
            $61de1ee1cac498ae$var$fLd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 10:
            $61de1ee1cac498ae$var$vwd($61de1ee1cac498ae$var$_Kd(this));
            $61de1ee1cac498ae$var$ytd($61de1ee1cac498ae$var$_Kd(this), $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 11:
            !this.q && (this.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, this, 11, 10));
            $61de1ee1cac498ae$var$Uxd(this.q);
            !this.q && (this.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, this, 11, 10));
            $61de1ee1cac498ae$var$ytd(this.q, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 21:
            !this.s && (this.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, this, 21, 17));
            $61de1ee1cac498ae$var$Uxd(this.s);
            !this.s && (this.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, this, 21, 17));
            $61de1ee1cac498ae$var$ytd(this.s, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 22:
            $61de1ee1cac498ae$var$Uxd($61de1ee1cac498ae$var$VKd(this));
            $61de1ee1cac498ae$var$ytd($61de1ee1cac498ae$var$VKd(this), $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$QFd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function pLd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd;
};
$61de1ee1cac498ae$var$_.Bh = function qLd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$JD(this.Cb, 179) && ($61de1ee1cac498ae$var$BD(this.Cb, 179).tb = null);
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$$Jd(this, null);
            $61de1ee1cac498ae$var$_Jd(this, this.D);
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, null);
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            return;
        case 8:
            $61de1ee1cac498ae$var$eLd(this, false);
            return;
        case 9:
            $61de1ee1cac498ae$var$fLd(this, false);
            return;
        case 10:
            !!this.u && $61de1ee1cac498ae$var$vwd(this.u);
            return;
        case 11:
            !this.q && (this.q = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$n5, this, 11, 10));
            $61de1ee1cac498ae$var$Uxd(this.q);
            return;
        case 21:
            !this.s && (this.s = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$t5, this, 21, 17));
            $61de1ee1cac498ae$var$Uxd(this.s);
            return;
        case 22:
            !!this.n && $61de1ee1cac498ae$var$Uxd(this.n);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$QFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$QFd : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function rLd() {
    var a, b;
    $61de1ee1cac498ae$var$OKd(this);
    $61de1ee1cac498ae$var$SKd(this);
    $61de1ee1cac498ae$var$PKd(this);
    $61de1ee1cac498ae$var$RKd(this);
    $61de1ee1cac498ae$var$TKd(this);
    $61de1ee1cac498ae$var$UKd(this);
    $61de1ee1cac498ae$var$QKd(this);
    $61de1ee1cac498ae$var$oud($61de1ee1cac498ae$var$SMd($61de1ee1cac498ae$var$$Kd(this)));
    if (this.s) for(a = 0, b = this.s.i; a < b; ++a)$61de1ee1cac498ae$var$Cmd($61de1ee1cac498ae$var$qud(this.s, a));
    if (this.q) for(a = 0, b = this.q.i; a < b; ++a)$61de1ee1cac498ae$var$Cmd($61de1ee1cac498ae$var$qud(this.q, a));
    $61de1ee1cac498ae$var$o1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), this).ne();
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.Ib = function sLd() {
    return $61de1ee1cac498ae$var$gLd(this);
};
$61de1ee1cac498ae$var$_.k = null;
$61de1ee1cac498ae$var$_.r = null;
var $61de1ee1cac498ae$var$KKd, $61de1ee1cac498ae$var$LKd, $61de1ee1cac498ae$var$MKd;
var $61de1ee1cac498ae$var$Y5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl", 88);
$61de1ee1cac498ae$var$bcb(1994, 1993, $61de1ee1cac498ae$var$Ove);
$61de1ee1cac498ae$var$_.Vh = function tLd(a, b) {
    return $61de1ee1cac498ae$var$Pxd(this, a, b);
};
$61de1ee1cac498ae$var$_.Wh = function uLd(a) {
    return $61de1ee1cac498ae$var$Pxd(this, this.i, a);
};
$61de1ee1cac498ae$var$_.Xh = function vLd(a, b) {
    $61de1ee1cac498ae$var$Qxd(this, a, b);
};
$61de1ee1cac498ae$var$_.Yh = function wLd(a) {
    $61de1ee1cac498ae$var$Rxd(this, a);
};
$61de1ee1cac498ae$var$_.lk = function xLd(a, b) {
    return $61de1ee1cac498ae$var$Sxd(this, a, b);
};
$61de1ee1cac498ae$var$_.pi = function yLd(a) {
    return $61de1ee1cac498ae$var$nud(this, a);
};
$61de1ee1cac498ae$var$_.mk = function CLd(a, b) {
    return $61de1ee1cac498ae$var$Txd(this, a, b);
};
$61de1ee1cac498ae$var$_.mi = function DLd(a, b) {
    return $61de1ee1cac498ae$var$Zxd(this, a, b);
};
$61de1ee1cac498ae$var$_.Zh = function zLd() {
    return new $61de1ee1cac498ae$var$$yd(this);
};
$61de1ee1cac498ae$var$_.$h = function ALd() {
    return new $61de1ee1cac498ae$var$bzd(this);
};
$61de1ee1cac498ae$var$_._h = function BLd(a) {
    return $61de1ee1cac498ae$var$ztd(this, a);
};
var $61de1ee1cac498ae$var$P9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "NotifyingInternalEListImpl", 1994);
$61de1ee1cac498ae$var$bcb(622, 1994, $61de1ee1cac498ae$var$Pve);
$61de1ee1cac498ae$var$_.Hc = function NLd(a) {
    return $61de1ee1cac498ae$var$ELd(this, a);
};
$61de1ee1cac498ae$var$_.Zi = function OLd(a, b, c, d, e) {
    return $61de1ee1cac498ae$var$FLd(this, a, b, c, d, e);
};
$61de1ee1cac498ae$var$_.$i = function PLd(a) {
    $61de1ee1cac498ae$var$GLd(this, a);
};
$61de1ee1cac498ae$var$_.Wj = function QLd(a) {
    return this;
};
$61de1ee1cac498ae$var$_.ak = function RLd() {
    return $61de1ee1cac498ae$var$XKd(this.e.Tg(), this.aj());
};
$61de1ee1cac498ae$var$_._i = function SLd() {
    return this.ak();
};
$61de1ee1cac498ae$var$_.aj = function TLd() {
    return $61de1ee1cac498ae$var$bLd(this.e.Tg(), this.ak());
};
$61de1ee1cac498ae$var$_.zk = function ULd() {
    return $61de1ee1cac498ae$var$BD(this.ak().Yj(), 26).Bj();
};
$61de1ee1cac498ae$var$_.Ak = function VLd() {
    return $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD(this.ak(), 18)).n;
};
$61de1ee1cac498ae$var$_.Ai = function WLd() {
    return this.e;
};
$61de1ee1cac498ae$var$_.Bk = function XLd() {
    return true;
};
$61de1ee1cac498ae$var$_.Ck = function YLd() {
    return false;
};
$61de1ee1cac498ae$var$_.Dk = function ZLd() {
    return false;
};
$61de1ee1cac498ae$var$_.Ek = function $Ld() {
    return false;
};
$61de1ee1cac498ae$var$_.Xc = function _Ld(a) {
    return $61de1ee1cac498ae$var$HLd(this, a);
};
$61de1ee1cac498ae$var$_.cj = function aMd(a, b) {
    var c;
    return c = $61de1ee1cac498ae$var$BD(a, 49), this.Dk() ? this.Bk() ? c.gh(this.e, this.Ak(), this.zk(), b) : c.gh(this.e, $61de1ee1cac498ae$var$bLd(c.Tg(), $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD(this.ak(), 18))), null, b) : c.gh(this.e, -1 - this.aj(), null, b);
};
$61de1ee1cac498ae$var$_.dj = function bMd(a, b) {
    var c;
    return c = $61de1ee1cac498ae$var$BD(a, 49), this.Dk() ? this.Bk() ? c.ih(this.e, this.Ak(), this.zk(), b) : c.ih(this.e, $61de1ee1cac498ae$var$bLd(c.Tg(), $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD(this.ak(), 18))), null, b) : c.ih(this.e, -1 - this.aj(), null, b);
};
$61de1ee1cac498ae$var$_.rk = function cMd() {
    return false;
};
$61de1ee1cac498ae$var$_.Fk = function dMd() {
    return true;
};
$61de1ee1cac498ae$var$_.wj = function eMd(a) {
    return $61de1ee1cac498ae$var$qEd(this.d, a);
};
$61de1ee1cac498ae$var$_.ej = function fMd() {
    return $61de1ee1cac498ae$var$oid(this.e);
};
$61de1ee1cac498ae$var$_.fj = function gMd() {
    return this.i != 0;
};
$61de1ee1cac498ae$var$_.ri = function hMd(a) {
    return $61de1ee1cac498ae$var$izd(this.d, a);
};
$61de1ee1cac498ae$var$_.li = function iMd(a, b) {
    return this.Fk() && this.Ek() ? $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56)) : b;
};
$61de1ee1cac498ae$var$_.Gk = function jMd(a) {
    return a.kh() ? $61de1ee1cac498ae$var$xid(this.e, $61de1ee1cac498ae$var$BD(a, 49)) : a;
};
$61de1ee1cac498ae$var$_.Wb = function kMd(a) {
    $61de1ee1cac498ae$var$JLd(this, a);
};
$61de1ee1cac498ae$var$_.Pc = function lMd() {
    return $61de1ee1cac498ae$var$KLd(this);
};
$61de1ee1cac498ae$var$_.Qc = function mMd(a) {
    var b;
    if (this.Ek()) for(b = this.i - 1; b >= 0; --b)$61de1ee1cac498ae$var$qud(this, b);
    return $61de1ee1cac498ae$var$xud(this, a);
};
$61de1ee1cac498ae$var$_.Xj = function nMd() {
    $61de1ee1cac498ae$var$Uxd(this);
};
$61de1ee1cac498ae$var$_.oi = function oMd(a, b) {
    return $61de1ee1cac498ae$var$LLd(this, a, b);
};
var $61de1ee1cac498ae$var$t9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEList", 622);
$61de1ee1cac498ae$var$bcb(496, 622, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$pMd);
$61de1ee1cac498ae$var$_.ai = function qMd() {
    return false;
};
$61de1ee1cac498ae$var$_.aj = function rMd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.bj = function sMd() {
    return false;
};
$61de1ee1cac498ae$var$_.Fk = function tMd() {
    return true;
};
$61de1ee1cac498ae$var$_.hi = function uMd() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function vMd(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.ni = function wMd() {
    return false;
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$d9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectEList", 496);
$61de1ee1cac498ae$var$bcb(85, 496, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$xMd);
$61de1ee1cac498ae$var$_.bj = function yMd() {
    return true;
};
$61de1ee1cac498ae$var$_.Dk = function zMd() {
    return false;
};
$61de1ee1cac498ae$var$_.rk = function AMd() {
    return true;
};
var $61de1ee1cac498ae$var$Z8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentEList", 85);
$61de1ee1cac498ae$var$bcb(545, 85, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$BMd);
$61de1ee1cac498ae$var$_.ci = function CMd() {
    this.b = true;
};
$61de1ee1cac498ae$var$_.fj = function DMd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Xj = function EMd() {
    var a;
    $61de1ee1cac498ae$var$Uxd(this);
    if ($61de1ee1cac498ae$var$oid(this.e)) {
        a = this.b;
        this.b = false;
        $61de1ee1cac498ae$var$Uhd(this.e, new $61de1ee1cac498ae$var$qSd(this.e, 2, this.c, a, false));
    } else this.b = false;
};
$61de1ee1cac498ae$var$_.b = false;
var $61de1ee1cac498ae$var$Y8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentEList/Unsettable", 545);
$61de1ee1cac498ae$var$bcb(1140, 545, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$JMd);
$61de1ee1cac498ae$var$_.ii = function NMd(a, b) {
    var c, d;
    return c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wxd(this, a, b), 87), $61de1ee1cac498ae$var$oid(this.e) && $61de1ee1cac498ae$var$GLd(this, new $61de1ee1cac498ae$var$ESd(this.a, 7, ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$SFd), $61de1ee1cac498ae$var$meb(b), (d = c.c, $61de1ee1cac498ae$var$JD(d, 88) ? $61de1ee1cac498ae$var$BD(d, 26) : $61de1ee1cac498ae$var$_Fd), a)), c;
};
$61de1ee1cac498ae$var$_.jj = function OMd(a, b) {
    return $61de1ee1cac498ae$var$GMd(this, $61de1ee1cac498ae$var$BD(a, 87), b);
};
$61de1ee1cac498ae$var$_.kj = function PMd(a, b) {
    return $61de1ee1cac498ae$var$HMd(this, $61de1ee1cac498ae$var$BD(a, 87), b);
};
$61de1ee1cac498ae$var$_.lj = function QMd(a, b, c) {
    return $61de1ee1cac498ae$var$IMd(this, $61de1ee1cac498ae$var$BD(a, 87), $61de1ee1cac498ae$var$BD(b, 87), c);
};
$61de1ee1cac498ae$var$_.Zi = function KMd(a, b, c, d, e) {
    switch(a){
        case 3:
            return $61de1ee1cac498ae$var$FLd(this, a, b, c, d, this.i > 1);
        case 5:
            return $61de1ee1cac498ae$var$FLd(this, a, b, c, d, this.i - $61de1ee1cac498ae$var$BD(c, 15).gc() > 0);
        default:
            return new $61de1ee1cac498ae$var$pSd(this.e, a, this.c, b, c, d, true);
    }
};
$61de1ee1cac498ae$var$_.ij = function LMd() {
    return true;
};
$61de1ee1cac498ae$var$_.fj = function MMd() {
    return $61de1ee1cac498ae$var$FMd(this);
};
$61de1ee1cac498ae$var$_.Xj = function RMd() {
    $61de1ee1cac498ae$var$Uxd(this);
};
var $61de1ee1cac498ae$var$N5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/1", 1140);
$61de1ee1cac498ae$var$bcb(1154, 1153, $61de1ee1cac498ae$var$dve);
$61de1ee1cac498ae$var$_.ui = function VMd(a) {
    var b, c, d, e, f, g, h;
    c = a.xi();
    if (c != 8) {
        d = $61de1ee1cac498ae$var$UMd(a);
        if (d == 0) switch(c){
            case 1:
            case 9:
                h = a.Bi();
                if (h != null) {
                    b = $61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(h, 473));
                    !b.c && (b.c = new $61de1ee1cac498ae$var$xYd);
                    $61de1ee1cac498ae$var$Ftd(b.c, a.Ai());
                }
                g = a.zi();
                if (g != null) {
                    e = $61de1ee1cac498ae$var$BD(g, 473);
                    if ((e.Bb & 1) == 0) {
                        b = $61de1ee1cac498ae$var$$Kd(e);
                        !b.c && (b.c = new $61de1ee1cac498ae$var$xYd);
                        $61de1ee1cac498ae$var$wtd(b.c, $61de1ee1cac498ae$var$BD(a.Ai(), 26));
                    }
                }
                break;
            case 3:
                g = a.zi();
                if (g != null) {
                    e = $61de1ee1cac498ae$var$BD(g, 473);
                    if ((e.Bb & 1) == 0) {
                        b = $61de1ee1cac498ae$var$$Kd(e);
                        !b.c && (b.c = new $61de1ee1cac498ae$var$xYd);
                        $61de1ee1cac498ae$var$wtd(b.c, $61de1ee1cac498ae$var$BD(a.Ai(), 26));
                    }
                }
                break;
            case 5:
                g = a.zi();
                if (g != null) for(f = $61de1ee1cac498ae$var$BD(g, 14).Kc(); f.Ob();){
                    e = $61de1ee1cac498ae$var$BD(f.Pb(), 473);
                    if ((e.Bb & 1) == 0) {
                        b = $61de1ee1cac498ae$var$$Kd(e);
                        !b.c && (b.c = new $61de1ee1cac498ae$var$xYd);
                        $61de1ee1cac498ae$var$wtd(b.c, $61de1ee1cac498ae$var$BD(a.Ai(), 26));
                    }
                }
                break;
            case 4:
                h = a.Bi();
                if (h != null) {
                    e = $61de1ee1cac498ae$var$BD(h, 473);
                    if ((e.Bb & 1) == 0) {
                        b = $61de1ee1cac498ae$var$$Kd(e);
                        !b.c && (b.c = new $61de1ee1cac498ae$var$xYd);
                        $61de1ee1cac498ae$var$Ftd(b.c, a.Ai());
                    }
                }
                break;
            case 6:
                h = a.Bi();
                if (h != null) for(f = $61de1ee1cac498ae$var$BD(h, 14).Kc(); f.Ob();){
                    e = $61de1ee1cac498ae$var$BD(f.Pb(), 473);
                    if ((e.Bb & 1) == 0) {
                        b = $61de1ee1cac498ae$var$$Kd(e);
                        !b.c && (b.c = new $61de1ee1cac498ae$var$xYd);
                        $61de1ee1cac498ae$var$Ftd(b.c, a.Ai());
                    }
                }
                break;
        }
        this.Hk(d);
    }
};
$61de1ee1cac498ae$var$_.Hk = function WMd(a) {
    $61de1ee1cac498ae$var$TMd(this, a);
};
$61de1ee1cac498ae$var$_.b = 63;
var $61de1ee1cac498ae$var$p7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ESuperAdapter", 1154);
$61de1ee1cac498ae$var$bcb(1155, 1154, $61de1ee1cac498ae$var$dve, $61de1ee1cac498ae$var$YMd);
$61de1ee1cac498ae$var$_.Hk = function ZMd(a) {
    $61de1ee1cac498ae$var$XMd(this, a);
};
var $61de1ee1cac498ae$var$I5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/10", 1155);
$61de1ee1cac498ae$var$bcb(1144, 696, $61de1ee1cac498ae$var$Pve);
$61de1ee1cac498ae$var$_.Vh = function $Md(a, b) {
    return $61de1ee1cac498ae$var$iud(this, a, b);
};
$61de1ee1cac498ae$var$_.Wh = function _Md(a) {
    return $61de1ee1cac498ae$var$jud(this, a);
};
$61de1ee1cac498ae$var$_.Xh = function aNd(a, b) {
    $61de1ee1cac498ae$var$kud(this, a, b);
};
$61de1ee1cac498ae$var$_.Yh = function bNd(a) {
    $61de1ee1cac498ae$var$lud(this, a);
};
$61de1ee1cac498ae$var$_.pi = function dNd(a) {
    return $61de1ee1cac498ae$var$nud(this, a);
};
$61de1ee1cac498ae$var$_.mi = function lNd(a, b) {
    return $61de1ee1cac498ae$var$uud(this, a, b);
};
$61de1ee1cac498ae$var$_.lk = function cNd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Zh = function eNd() {
    return new $61de1ee1cac498ae$var$$yd(this);
};
$61de1ee1cac498ae$var$_.$h = function fNd() {
    return new $61de1ee1cac498ae$var$bzd(this);
};
$61de1ee1cac498ae$var$_._h = function gNd(a) {
    return $61de1ee1cac498ae$var$ztd(this, a);
};
$61de1ee1cac498ae$var$_.mk = function hNd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Wj = function iNd(a) {
    return this;
};
$61de1ee1cac498ae$var$_.fj = function jNd() {
    return this.i != 0;
};
$61de1ee1cac498ae$var$_.Wb = function kNd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Xj = function mNd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
var $61de1ee1cac498ae$var$s9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEList/UnmodifiableEList", 1144);
$61de1ee1cac498ae$var$bcb(319, 1144, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$nNd);
$61de1ee1cac498ae$var$_.ni = function oNd() {
    return false;
};
var $61de1ee1cac498ae$var$r9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEList/UnmodifiableEList/FastCompare", 319);
$61de1ee1cac498ae$var$bcb(1147, 319, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$rNd);
$61de1ee1cac498ae$var$_.Xc = function sNd(a) {
    var b, c, d;
    if ($61de1ee1cac498ae$var$JD(a, 170)) {
        b = $61de1ee1cac498ae$var$BD(a, 170);
        c = b.aj();
        if (c != -1) for(d = this.i; c < d; ++c){
            if ($61de1ee1cac498ae$var$PD(this.g[c]) === $61de1ee1cac498ae$var$PD(a)) return c;
        }
    }
    return -1;
};
var $61de1ee1cac498ae$var$J5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/1EAllStructuralFeaturesList", 1147);
$61de1ee1cac498ae$var$bcb(1141, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$wNd);
$61de1ee1cac498ae$var$_.ri = function xNd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$j5, $61de1ee1cac498ae$var$Tve, 87, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function yNd() {
    return false;
};
var $61de1ee1cac498ae$var$K5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/1EGenericSuperTypeEList", 1141);
$61de1ee1cac498ae$var$bcb(623, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$zNd);
$61de1ee1cac498ae$var$_.ri = function ANd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$t5, $61de1ee1cac498ae$var$Mve, 170, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function BNd() {
    return false;
};
var $61de1ee1cac498ae$var$L5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/1EStructuralFeatureUniqueEList", 623);
$61de1ee1cac498ae$var$bcb(741, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$CNd);
$61de1ee1cac498ae$var$_.ri = function DNd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$q5, $61de1ee1cac498ae$var$Mve, 18, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function ENd() {
    return false;
};
var $61de1ee1cac498ae$var$M5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/1ReferenceList", 741);
$61de1ee1cac498ae$var$bcb(1142, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$GNd);
$61de1ee1cac498ae$var$_.bi = function HNd(a, b) {
    $61de1ee1cac498ae$var$FNd(this, $61de1ee1cac498ae$var$BD(b, 34));
};
$61de1ee1cac498ae$var$_.ri = function INd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$b5, $61de1ee1cac498ae$var$Mve, 34, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function JNd() {
    return false;
};
var $61de1ee1cac498ae$var$O5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/2", 1142);
$61de1ee1cac498ae$var$bcb(1143, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$KNd);
$61de1ee1cac498ae$var$_.ri = function LNd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$b5, $61de1ee1cac498ae$var$Mve, 34, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function MNd() {
    return false;
};
var $61de1ee1cac498ae$var$P5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/3", 1143);
$61de1ee1cac498ae$var$bcb(1145, 319, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$PNd);
$61de1ee1cac498ae$var$_.Fc = function QNd(a) {
    return $61de1ee1cac498ae$var$NNd(this, $61de1ee1cac498ae$var$BD(a, 34));
};
$61de1ee1cac498ae$var$_.Yh = function RNd(a) {
    $61de1ee1cac498ae$var$ONd(this, $61de1ee1cac498ae$var$BD(a, 34));
};
var $61de1ee1cac498ae$var$Q5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/4", 1145);
$61de1ee1cac498ae$var$bcb(1146, 319, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$UNd);
$61de1ee1cac498ae$var$_.Fc = function VNd(a) {
    return $61de1ee1cac498ae$var$SNd(this, $61de1ee1cac498ae$var$BD(a, 18));
};
$61de1ee1cac498ae$var$_.Yh = function WNd(a) {
    $61de1ee1cac498ae$var$TNd(this, $61de1ee1cac498ae$var$BD(a, 18));
};
var $61de1ee1cac498ae$var$R5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/5", 1146);
$61de1ee1cac498ae$var$bcb(1148, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$XNd);
$61de1ee1cac498ae$var$_.ri = function YNd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$n5, $61de1ee1cac498ae$var$Nve, 59, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function ZNd() {
    return false;
};
var $61de1ee1cac498ae$var$S5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/6", 1148);
$61de1ee1cac498ae$var$bcb(1149, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$$Nd);
$61de1ee1cac498ae$var$_.ri = function _Nd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$q5, $61de1ee1cac498ae$var$Mve, 18, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function aOd() {
    return false;
};
var $61de1ee1cac498ae$var$T5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/7", 1149);
$61de1ee1cac498ae$var$bcb(1997, 1996, {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    67: 1,
    58: 1,
    69: 1
});
$61de1ee1cac498ae$var$_.Vh = function bOd(a, b) {
    return $61de1ee1cac498ae$var$qwd(this, a, b);
};
$61de1ee1cac498ae$var$_.Wh = function cOd(a) {
    return $61de1ee1cac498ae$var$qwd(this, this.Vi(), a);
};
$61de1ee1cac498ae$var$_.Xh = function dOd(a, b) {
    $61de1ee1cac498ae$var$rwd(this, a, b);
};
$61de1ee1cac498ae$var$_.Yh = function eOd(a) {
    $61de1ee1cac498ae$var$swd(this, a);
};
$61de1ee1cac498ae$var$_.lk = function fOd(a, b) {
    return $61de1ee1cac498ae$var$twd(this, a, b);
};
$61de1ee1cac498ae$var$_.mk = function lOd(a, b) {
    return $61de1ee1cac498ae$var$uwd(this, a, b);
};
$61de1ee1cac498ae$var$_.mi = function mOd(a, b) {
    return $61de1ee1cac498ae$var$wwd(this, a, b);
};
$61de1ee1cac498ae$var$_.pi = function gOd(a) {
    return this.Oi(a);
};
$61de1ee1cac498ae$var$_.Zh = function hOd() {
    return new $61de1ee1cac498ae$var$$yd(this);
};
$61de1ee1cac498ae$var$_.Gi = function iOd() {
    return this.Ji();
};
$61de1ee1cac498ae$var$_.$h = function jOd() {
    return new $61de1ee1cac498ae$var$bzd(this);
};
$61de1ee1cac498ae$var$_._h = function kOd(a) {
    return $61de1ee1cac498ae$var$ztd(this, a);
};
var $61de1ee1cac498ae$var$L8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "DelegatingNotifyingInternalEListImpl", 1997);
$61de1ee1cac498ae$var$bcb(742, 1997, $61de1ee1cac498ae$var$Uve);
$61de1ee1cac498ae$var$_.ai = function rOd() {
    var a;
    a = $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).Yj();
    return $61de1ee1cac498ae$var$JD(a, 148) && !$61de1ee1cac498ae$var$JD(a, 457) && (a.Bj().i & 1) == 0;
};
$61de1ee1cac498ae$var$_.Hc = function sOd(a) {
    var b, c, d, e, f, g, h, i;
    if (this.Fk()) {
        i = this.Vi();
        if (i > 4) {
            if (this.wj(a)) {
                if (this.rk()) {
                    d = $61de1ee1cac498ae$var$BD(a, 49);
                    c = d.Ug();
                    h = c == this.b && (this.Dk() ? d.Og(d.Vg(), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).Yj(), 26).Bj()) == $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()), 18)).n : -1 - d.Vg() == this.aj());
                    if (this.Ek() && !h && !c && !!d.Zg()) for(e = 0; e < i; ++e){
                        b = $61de1ee1cac498ae$var$oOd(this, this.Oi(e));
                        if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(a)) return true;
                    }
                    return h;
                } else if (this.Dk() && !this.Ck()) {
                    f = $61de1ee1cac498ae$var$BD(a, 56).ah($61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()), 18)));
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.b)) return true;
                    else if (f == null || !$61de1ee1cac498ae$var$BD(f, 56).kh()) return false;
                }
            } else return false;
        }
        g = this.Li(a);
        if (this.Ek() && !g) for(e = 0; e < i; ++e){
            d = $61de1ee1cac498ae$var$oOd(this, this.Oi(e));
            if ($61de1ee1cac498ae$var$PD(d) === $61de1ee1cac498ae$var$PD(a)) return true;
        }
        return g;
    } else return this.Li(a);
};
$61de1ee1cac498ae$var$_.Zi = function tOd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$pSd(this.b, a, this.aj(), b, c, d, e);
};
$61de1ee1cac498ae$var$_.$i = function uOd(a) {
    $61de1ee1cac498ae$var$Uhd(this.b, a);
};
$61de1ee1cac498ae$var$_.Wj = function vOd(a) {
    return this;
};
$61de1ee1cac498ae$var$_._i = function wOd() {
    return $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj());
};
$61de1ee1cac498ae$var$_.aj = function xOd() {
    return $61de1ee1cac498ae$var$bLd($61de1ee1cac498ae$var$wjd(this.b), $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()));
};
$61de1ee1cac498ae$var$_.Ai = function yOd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Bk = function zOd() {
    return !!$61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).Yj().Bj();
};
$61de1ee1cac498ae$var$_.bj = function AOd() {
    var a, b;
    b = $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj());
    if ($61de1ee1cac498ae$var$JD(b, 99)) {
        a = $61de1ee1cac498ae$var$BD(b, 18);
        return (a.Bb & $61de1ee1cac498ae$var$ote) != 0 || !!$61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD(b, 18));
    } else return false;
};
$61de1ee1cac498ae$var$_.Ck = function BOd() {
    var a, b, c, d;
    b = $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj());
    if ($61de1ee1cac498ae$var$JD(b, 99)) {
        a = $61de1ee1cac498ae$var$BD(b, 18);
        c = $61de1ee1cac498ae$var$zUd(a);
        return !!c && (d = c.t, d > 1 || d == -1);
    } else return false;
};
$61de1ee1cac498ae$var$_.Dk = function COd() {
    var a, b, c;
    b = $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj());
    if ($61de1ee1cac498ae$var$JD(b, 99)) {
        a = $61de1ee1cac498ae$var$BD(b, 18);
        c = $61de1ee1cac498ae$var$zUd(a);
        return !!c;
    } else return false;
};
$61de1ee1cac498ae$var$_.Ek = function DOd() {
    var a, b;
    b = $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj());
    if ($61de1ee1cac498ae$var$JD(b, 99)) {
        a = $61de1ee1cac498ae$var$BD(b, 18);
        return (a.Bb & $61de1ee1cac498ae$var$Tje) != 0;
    } else return false;
};
$61de1ee1cac498ae$var$_.Xc = function EOd(a) {
    var b, c, d, e;
    d = this.Qi(a);
    if (d >= 0) return d;
    if (this.Fk()) for(c = 0, e = this.Vi(); c < e; ++c){
        b = $61de1ee1cac498ae$var$oOd(this, this.Oi(c));
        if ($61de1ee1cac498ae$var$PD(b) === $61de1ee1cac498ae$var$PD(a)) return c;
    }
    return -1;
};
$61de1ee1cac498ae$var$_.cj = function FOd(a, b) {
    var c;
    return c = $61de1ee1cac498ae$var$BD(a, 49), this.Dk() ? this.Bk() ? c.gh(this.b, $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()), 18)).n, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).Yj(), 26).Bj(), b) : c.gh(this.b, $61de1ee1cac498ae$var$bLd(c.Tg(), $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()), 18))), null, b) : c.gh(this.b, -1 - this.aj(), null, b);
};
$61de1ee1cac498ae$var$_.dj = function GOd(a, b) {
    var c;
    return c = $61de1ee1cac498ae$var$BD(a, 49), this.Dk() ? this.Bk() ? c.ih(this.b, $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()), 18)).n, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).Yj(), 26).Bj(), b) : c.ih(this.b, $61de1ee1cac498ae$var$bLd(c.Tg(), $61de1ee1cac498ae$var$zUd($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()), 18))), null, b) : c.ih(this.b, -1 - this.aj(), null, b);
};
$61de1ee1cac498ae$var$_.rk = function HOd() {
    var a, b;
    b = $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj());
    if ($61de1ee1cac498ae$var$JD(b, 99)) {
        a = $61de1ee1cac498ae$var$BD(b, 18);
        return (a.Bb & $61de1ee1cac498ae$var$ote) != 0;
    } else return false;
};
$61de1ee1cac498ae$var$_.Fk = function IOd() {
    return $61de1ee1cac498ae$var$JD($61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).Yj(), 88);
};
$61de1ee1cac498ae$var$_.wj = function JOd(a) {
    return $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).Yj().wj(a);
};
$61de1ee1cac498ae$var$_.ej = function KOd() {
    return $61de1ee1cac498ae$var$oid(this.b);
};
$61de1ee1cac498ae$var$_.fj = function LOd() {
    return !this.Ri();
};
$61de1ee1cac498ae$var$_.hi = function MOd() {
    return $61de1ee1cac498ae$var$XKd($61de1ee1cac498ae$var$wjd(this.b), this.aj()).hi();
};
$61de1ee1cac498ae$var$_.li = function NOd(a, b) {
    return $61de1ee1cac498ae$var$nOd(this, a, b);
};
$61de1ee1cac498ae$var$_.Wb = function OOd(a) {
    $61de1ee1cac498ae$var$vwd(this);
    $61de1ee1cac498ae$var$ytd(this, $61de1ee1cac498ae$var$BD(a, 15));
};
$61de1ee1cac498ae$var$_.Pc = function POd() {
    var a;
    if (this.Ek()) for(a = this.Vi() - 1; a >= 0; --a)$61de1ee1cac498ae$var$nOd(this, a, this.Oi(a));
    return this.Wi();
};
$61de1ee1cac498ae$var$_.Qc = function QOd(a) {
    var b;
    if (this.Ek()) for(b = this.Vi() - 1; b >= 0; --b)$61de1ee1cac498ae$var$nOd(this, b, this.Oi(b));
    return this.Xi(a);
};
$61de1ee1cac498ae$var$_.Xj = function ROd() {
    $61de1ee1cac498ae$var$vwd(this);
};
$61de1ee1cac498ae$var$_.oi = function SOd(a, b) {
    return $61de1ee1cac498ae$var$pOd(this, a, b);
};
var $61de1ee1cac498ae$var$K8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "DelegatingEcoreEList", 742);
$61de1ee1cac498ae$var$bcb(1150, 742, $61de1ee1cac498ae$var$Uve, $61de1ee1cac498ae$var$YOd);
$61de1ee1cac498ae$var$_.Hi = function _Od(a, b) {
    $61de1ee1cac498ae$var$TOd(this, a, $61de1ee1cac498ae$var$BD(b, 26));
};
$61de1ee1cac498ae$var$_.Ii = function aPd(a) {
    $61de1ee1cac498ae$var$UOd(this, $61de1ee1cac498ae$var$BD(a, 26));
};
$61de1ee1cac498ae$var$_.Oi = function gPd(a) {
    var b, c;
    return b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$VKd(this.a), a), 87), c = b.c, $61de1ee1cac498ae$var$JD(c, 88) ? $61de1ee1cac498ae$var$BD(c, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd);
};
$61de1ee1cac498ae$var$_.Ti = function lPd(a) {
    var b, c;
    return b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xxd($61de1ee1cac498ae$var$VKd(this.a), a), 87), c = b.c, $61de1ee1cac498ae$var$JD(c, 88) ? $61de1ee1cac498ae$var$BD(c, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd);
};
$61de1ee1cac498ae$var$_.Ui = function mPd(a, b) {
    return $61de1ee1cac498ae$var$WOd(this, a, $61de1ee1cac498ae$var$BD(b, 26));
};
$61de1ee1cac498ae$var$_.ai = function ZOd() {
    return false;
};
$61de1ee1cac498ae$var$_.Zi = function $Od(a, b, c, d, e) {
    return null;
};
$61de1ee1cac498ae$var$_.Ji = function bPd() {
    return new $61de1ee1cac498ae$var$EPd(this);
};
$61de1ee1cac498ae$var$_.Ki = function cPd() {
    $61de1ee1cac498ae$var$Uxd($61de1ee1cac498ae$var$VKd(this.a));
};
$61de1ee1cac498ae$var$_.Li = function dPd(a) {
    return $61de1ee1cac498ae$var$VOd(this, a);
};
$61de1ee1cac498ae$var$_.Mi = function ePd(a) {
    var b, c;
    for(c = a.Kc(); c.Ob();){
        b = c.Pb();
        if (!$61de1ee1cac498ae$var$VOd(this, b)) return false;
    }
    return true;
};
$61de1ee1cac498ae$var$_.Ni = function fPd(a) {
    var b, c, d;
    if ($61de1ee1cac498ae$var$JD(a, 15)) {
        d = $61de1ee1cac498ae$var$BD(a, 15);
        if (d.gc() == $61de1ee1cac498ae$var$VKd(this.a).i) {
            for(b = d.Kc(), c = new $61de1ee1cac498ae$var$Fyd(this); b.Ob();){
                if ($61de1ee1cac498ae$var$PD(b.Pb()) !== $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$Dyd(c))) return false;
            }
            return true;
        }
    }
    return false;
};
$61de1ee1cac498ae$var$_.Pi = function hPd() {
    var a, b, c, d, e;
    c = 1;
    for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$VKd(this.a)); b.e != b.i.gc();){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 87);
        d = (e = a.c, $61de1ee1cac498ae$var$JD(e, 88) ? $61de1ee1cac498ae$var$BD(e, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
        c = 31 * c + (!d ? 0 : $61de1ee1cac498ae$var$FCb(d));
    }
    return c;
};
$61de1ee1cac498ae$var$_.Qi = function iPd(a) {
    var b, c, d, e;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$VKd(this.a)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 87);
        if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD((e = b.c, $61de1ee1cac498ae$var$JD(e, 88) ? $61de1ee1cac498ae$var$BD(e, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd)))) return d;
        ++d;
    }
    return -1;
};
$61de1ee1cac498ae$var$_.Ri = function jPd() {
    return $61de1ee1cac498ae$var$VKd(this.a).i == 0;
};
$61de1ee1cac498ae$var$_.Si = function kPd() {
    return null;
};
$61de1ee1cac498ae$var$_.Vi = function nPd() {
    return $61de1ee1cac498ae$var$VKd(this.a).i;
};
$61de1ee1cac498ae$var$_.Wi = function oPd() {
    var a, b, c, d, e, f;
    f = $61de1ee1cac498ae$var$VKd(this.a).i;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, f, 5, 1);
    c = 0;
    for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$VKd(this.a)); b.e != b.i.gc();){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 87);
        e[c++] = (d = a.c, $61de1ee1cac498ae$var$JD(d, 88) ? $61de1ee1cac498ae$var$BD(d, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
    }
    return e;
};
$61de1ee1cac498ae$var$_.Xi = function pPd(a) {
    var b, c, d, e, f, g, h;
    h = $61de1ee1cac498ae$var$VKd(this.a).i;
    if (a.length < h) {
        e = $61de1ee1cac498ae$var$izd($61de1ee1cac498ae$var$rb(a).c, h);
        a = e;
    }
    a.length > h && $61de1ee1cac498ae$var$NC(a, h, null);
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$VKd(this.a)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 87);
        f = (g = b.c, $61de1ee1cac498ae$var$JD(g, 88) ? $61de1ee1cac498ae$var$BD(g, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd));
        $61de1ee1cac498ae$var$NC(a, d++, f);
    }
    return a;
};
$61de1ee1cac498ae$var$_.Yi = function qPd() {
    var a, b, c, d, e;
    e = new $61de1ee1cac498ae$var$Hfb;
    e.a += "[";
    a = $61de1ee1cac498ae$var$VKd(this.a);
    for(b = 0, d = $61de1ee1cac498ae$var$VKd(this.a).i; b < d;){
        $61de1ee1cac498ae$var$Efb(e, $61de1ee1cac498ae$var$xfb((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(a, b), 87).c, $61de1ee1cac498ae$var$JD(c, 88) ? $61de1ee1cac498ae$var$BD(c, 26) : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$_Fd))));
        ++b < d && (e.a += $61de1ee1cac498ae$var$She, e);
    }
    e.a += "]";
    return e.a;
};
$61de1ee1cac498ae$var$_.$i = function rPd(a) {};
$61de1ee1cac498ae$var$_.aj = function sPd() {
    return 10;
};
$61de1ee1cac498ae$var$_.Bk = function tPd() {
    return true;
};
$61de1ee1cac498ae$var$_.bj = function uPd() {
    return false;
};
$61de1ee1cac498ae$var$_.Ck = function vPd() {
    return false;
};
$61de1ee1cac498ae$var$_.Dk = function wPd() {
    return false;
};
$61de1ee1cac498ae$var$_.Ek = function xPd() {
    return true;
};
$61de1ee1cac498ae$var$_.rk = function yPd() {
    return false;
};
$61de1ee1cac498ae$var$_.Fk = function zPd() {
    return true;
};
$61de1ee1cac498ae$var$_.wj = function APd(a) {
    return $61de1ee1cac498ae$var$JD(a, 88);
};
$61de1ee1cac498ae$var$_.fj = function BPd() {
    return $61de1ee1cac498ae$var$cLd(this.a);
};
$61de1ee1cac498ae$var$_.hi = function CPd() {
    return true;
};
$61de1ee1cac498ae$var$_.ni = function DPd() {
    return true;
};
var $61de1ee1cac498ae$var$V5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/8", 1150);
$61de1ee1cac498ae$var$bcb(1151, 1964, $61de1ee1cac498ae$var$Lie, $61de1ee1cac498ae$var$EPd);
$61de1ee1cac498ae$var$_.Zc = function FPd(a) {
    return $61de1ee1cac498ae$var$ztd(this.a, a);
};
$61de1ee1cac498ae$var$_.gc = function GPd() {
    return $61de1ee1cac498ae$var$VKd(this.a.a).i;
};
var $61de1ee1cac498ae$var$U5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/8/1", 1151);
$61de1ee1cac498ae$var$bcb(1152, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$HPd);
$61de1ee1cac498ae$var$_.ri = function IPd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$d5, $61de1ee1cac498ae$var$Uhe, 138, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function JPd() {
    return false;
};
var $61de1ee1cac498ae$var$W5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/9", 1152);
$61de1ee1cac498ae$var$bcb(1139, 53, $61de1ee1cac498ae$var$gke, $61de1ee1cac498ae$var$KPd);
var $61de1ee1cac498ae$var$X5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EClassImpl/MyHashSet", 1139);
$61de1ee1cac498ae$var$bcb(566, 351, {
    105: 1,
    92: 1,
    90: 1,
    138: 1,
    148: 1,
    834: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    351: 1,
    150: 1,
    114: 1,
    115: 1,
    676: 1
}, $61de1ee1cac498ae$var$MPd);
$61de1ee1cac498ae$var$_._g = function NPd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return $61de1ee1cac498ae$var$dKd(this);
        case 4:
            return this.zj();
        case 5:
            return this.F;
        case 6:
            if (b) return $61de1ee1cac498ae$var$bKd(this);
            return $61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7)), this.A;
        case 8:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? this.zh() : d), a), b, c);
};
$61de1ee1cac498ae$var$_.lh = function OPd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!$61de1ee1cac498ae$var$dKd(this);
        case 4:
            return this.zj() != null;
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!$61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !!this.A && this.A.i != 0;
        case 8:
            return (this.Bb & 256) == 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.sh = function PPd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$lKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$iKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$ytd(this.A, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 8:
            $61de1ee1cac498ae$var$LPd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? this.zh() : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function QPd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$TFd;
};
$61de1ee1cac498ae$var$_.Bh = function RPd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$JD(this.Cb, 179) && ($61de1ee1cac498ae$var$BD(this.Cb, 179).tb = null);
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$$Jd(this, null);
            $61de1ee1cac498ae$var$_Jd(this, this.D);
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, null);
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            return;
        case 8:
            $61de1ee1cac498ae$var$LPd(this, true);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? this.zh() : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function SPd() {
    $61de1ee1cac498ae$var$o1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), this).ne();
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.Fj = function TPd() {
    var a, b, c;
    if (!this.c) {
        a = $61de1ee1cac498ae$var$l6d($61de1ee1cac498ae$var$bKd(this));
        if (!a.dc()) for(c = a.Kc(); c.Ob();){
            b = $61de1ee1cac498ae$var$GD(c.Pb());
            !!$61de1ee1cac498ae$var$Dmd(this, b) && $61de1ee1cac498ae$var$k6d(this);
        }
    }
    return this.b;
};
$61de1ee1cac498ae$var$_.zj = function UPd() {
    var b;
    if (!this.e) {
        b = null;
        try {
            b = $61de1ee1cac498ae$var$dKd(this);
        } catch (a) {
            a = $61de1ee1cac498ae$var$ubb(a);
            if (!$61de1ee1cac498ae$var$JD(a, 102)) throw $61de1ee1cac498ae$var$vbb(a);
        }
        this.d = null;
        !!b && (b.i & 1) != 0 && (b == $61de1ee1cac498ae$var$sbb ? this.d = ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb) : b == $61de1ee1cac498ae$var$WD ? this.d = $61de1ee1cac498ae$var$meb(0) : b == $61de1ee1cac498ae$var$VD ? this.d = new $61de1ee1cac498ae$var$Ndb(0) : b == $61de1ee1cac498ae$var$UD ? this.d = 0 : b == $61de1ee1cac498ae$var$XD ? this.d = $61de1ee1cac498ae$var$Aeb(0) : b == $61de1ee1cac498ae$var$rbb ? this.d = $61de1ee1cac498ae$var$Web(0) : b == $61de1ee1cac498ae$var$SD ? this.d = $61de1ee1cac498ae$var$Scb(0) : this.d = $61de1ee1cac498ae$var$bdb(0));
        this.e = true;
    }
    return this.d;
};
$61de1ee1cac498ae$var$_.Ej = function VPd() {
    return (this.Bb & 256) != 0;
};
$61de1ee1cac498ae$var$_.Ik = function WPd(a) {
    a && (this.D = "org.eclipse.emf.common.util.AbstractEnumerator");
};
$61de1ee1cac498ae$var$_.xk = function XPd(a) {
    $61de1ee1cac498ae$var$gKd(this, a);
    this.Ik(a);
};
$61de1ee1cac498ae$var$_.yk = function YPd(a) {
    this.C = a;
    this.e = false;
};
$61de1ee1cac498ae$var$_.Ib = function ZPd() {
    var a;
    if ((this.Db & 64) != 0) return $61de1ee1cac498ae$var$mKd(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$mKd(this));
    a.a += " (serializable: ";
    $61de1ee1cac498ae$var$Ffb(a, (this.Bb & 256) != 0);
    a.a += ")";
    return a.a;
};
$61de1ee1cac498ae$var$_.c = false;
$61de1ee1cac498ae$var$_.d = null;
$61de1ee1cac498ae$var$_.e = false;
var $61de1ee1cac498ae$var$$5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EDataTypeImpl", 566);
$61de1ee1cac498ae$var$bcb(457, 566, {
    105: 1,
    92: 1,
    90: 1,
    138: 1,
    148: 1,
    834: 1,
    671: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    351: 1,
    457: 1,
    150: 1,
    114: 1,
    115: 1,
    676: 1
}, $61de1ee1cac498ae$var$aQd);
$61de1ee1cac498ae$var$_._g = function bQd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return this.D != null ? this.D : this.B;
        case 3:
            return $61de1ee1cac498ae$var$dKd(this);
        case 4:
            return $61de1ee1cac498ae$var$$Pd(this);
        case 5:
            return this.F;
        case 6:
            if (b) return $61de1ee1cac498ae$var$bKd(this);
            return $61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7)), this.A;
        case 8:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 9:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, this, 9, 5)), this.a;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$UFd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function cQd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 6:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$aKd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 6, c);
        case 9:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, this, 9, 5)), $61de1ee1cac498ae$var$Sxd(this.a, a, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function dQd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 6:
            return $61de1ee1cac498ae$var$_hd(this, null, 6, c);
        case 7:
            return !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7)), $61de1ee1cac498ae$var$Txd(this.A, a, c);
        case 9:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, this, 9, 5)), $61de1ee1cac498ae$var$Txd(this.a, a, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function eQd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.D != null && this.D == this.F;
        case 3:
            return !!$61de1ee1cac498ae$var$dKd(this);
        case 4:
            return !!$61de1ee1cac498ae$var$$Pd(this);
        case 5:
            return this.F != null && this.F != this.D && this.F != this.B;
        case 6:
            return !!$61de1ee1cac498ae$var$ZJd(this);
        case 7:
            return !!this.A && this.A.i != 0;
        case 8:
            return (this.Bb & 256) == 0;
        case 9:
            return !!this.a && this.a.i != 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$UFd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function fQd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$lKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$iKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$ytd(this.A, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 8:
            $61de1ee1cac498ae$var$LPd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 9:
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, this, 9, 5));
            $61de1ee1cac498ae$var$Uxd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, this, 9, 5));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$UFd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function gQd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd;
};
$61de1ee1cac498ae$var$_.Bh = function hQd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$JD(this.Cb, 179) && ($61de1ee1cac498ae$var$BD(this.Cb, 179).tb = null);
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$$Jd(this, null);
            $61de1ee1cac498ae$var$_Jd(this, this.D);
            return;
        case 5:
            $61de1ee1cac498ae$var$kKd(this, null);
            return;
        case 7:
            !this.A && (this.A = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 7));
            $61de1ee1cac498ae$var$Uxd(this.A);
            return;
        case 8:
            $61de1ee1cac498ae$var$LPd(this, true);
            return;
        case 9:
            !this.a && (this.a = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$g5, this, 9, 5));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$UFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$UFd : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function iQd() {
    var a, b;
    if (this.a) for(a = 0, b = this.a.i; a < b; ++a)$61de1ee1cac498ae$var$Cmd($61de1ee1cac498ae$var$qud(this.a, a));
    $61de1ee1cac498ae$var$o1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), this).ne();
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.zj = function jQd() {
    return $61de1ee1cac498ae$var$$Pd(this);
};
$61de1ee1cac498ae$var$_.wj = function kQd(a) {
    if (a != null) return true;
    return false;
};
$61de1ee1cac498ae$var$_.Ik = function lQd(a) {};
var $61de1ee1cac498ae$var$_5 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EEnumImpl", 457);
$61de1ee1cac498ae$var$bcb(573, 438, {
    105: 1,
    92: 1,
    90: 1,
    1940: 1,
    678: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    573: 1,
    150: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$rQd);
$61de1ee1cac498ae$var$_.ne = function AQd() {
    return this.zb;
};
$61de1ee1cac498ae$var$_.Qg = function sQd(a) {
    return $61de1ee1cac498ae$var$mQd(this, a);
};
$61de1ee1cac498ae$var$_._g = function tQd(a, b, c) {
    var d, e;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return $61de1ee1cac498ae$var$meb(this.d);
        case 3:
            return this.b ? this.b : this.a;
        case 4:
            return e = this.c, e == null ? this.zb : e;
        case 5:
            return this.Db >> 16 == 5 ? $61de1ee1cac498ae$var$BD(this.Cb, 671) : null;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$VFd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function uQd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 5:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$mQd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 5, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function vQd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 5:
            return $61de1ee1cac498ae$var$_hd(this, null, 5, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function wQd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return this.d != 0;
        case 3:
            return !!this.b;
        case 4:
            return this.c != null;
        case 5:
            return !!(this.Db >> 16 == 5 ? $61de1ee1cac498ae$var$BD(this.Cb, 671) : null);
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$VFd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function xQd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$qQd(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 3:
            $61de1ee1cac498ae$var$oQd(this, $61de1ee1cac498ae$var$BD(b, 1940));
            return;
        case 4:
            $61de1ee1cac498ae$var$pQd(this, $61de1ee1cac498ae$var$GD(b));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$VFd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function yQd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd;
};
$61de1ee1cac498ae$var$_.Bh = function zQd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$qQd(this, 0);
            return;
        case 3:
            $61de1ee1cac498ae$var$oQd(this, null);
            return;
        case 4:
            $61de1ee1cac498ae$var$pQd(this, null);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$VFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$VFd : b), a));
};
$61de1ee1cac498ae$var$_.Ib = function BQd() {
    var a;
    return a = this.c, a == null ? this.zb : a;
};
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
$61de1ee1cac498ae$var$_.d = 0;
var $61de1ee1cac498ae$var$a6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EEnumLiteralImpl", 573);
var $61de1ee1cac498ae$var$c6 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$qte, "EFactoryImpl/InternalEDateTimeFormat");
$61de1ee1cac498ae$var$bcb(489, 1, {
    2015: 1
}, $61de1ee1cac498ae$var$EQd);
var $61de1ee1cac498ae$var$b6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EFactoryImpl/1ClientInternalEDateTimeFormat", 489);
$61de1ee1cac498ae$var$bcb(241, 115, {
    105: 1,
    92: 1,
    90: 1,
    87: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    241: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$UQd);
$61de1ee1cac498ae$var$_.Sg = function VQd(a, b, c) {
    var d;
    c = $61de1ee1cac498ae$var$_hd(this, a, b, c);
    if (!!this.e && $61de1ee1cac498ae$var$JD(a, 170)) {
        d = $61de1ee1cac498ae$var$MQd(this, this.e);
        d != this.c && (c = $61de1ee1cac498ae$var$QQd(this, d, c));
    }
    return c;
};
$61de1ee1cac498ae$var$_._g = function WQd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return this.f;
        case 1:
            return !this.d && (this.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, this, 1)), this.d;
        case 2:
            if (b) return $61de1ee1cac498ae$var$KQd(this);
            return this.c;
        case 3:
            return this.b;
        case 4:
            return this.e;
        case 5:
            if (b) return $61de1ee1cac498ae$var$JQd(this);
            return this.a;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$XFd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$XFd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.jh = function XQd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return $61de1ee1cac498ae$var$IQd(this, null, c);
        case 1:
            return !this.d && (this.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, this, 1)), $61de1ee1cac498ae$var$Txd(this.d, a, c);
        case 3:
            return $61de1ee1cac498ae$var$GQd(this, null, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$XFd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$XFd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function YQd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.f;
        case 1:
            return !!this.d && this.d.i != 0;
        case 2:
            return !!this.c;
        case 3:
            return !!this.b;
        case 4:
            return !!this.e;
        case 5:
            return !!this.a;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$XFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$XFd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function ZQd(a, b) {
    var c;
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$SQd(this, $61de1ee1cac498ae$var$BD(b, 87));
            return;
        case 1:
            !this.d && (this.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, this, 1));
            $61de1ee1cac498ae$var$Uxd(this.d);
            !this.d && (this.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, this, 1));
            $61de1ee1cac498ae$var$ytd(this.d, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 3:
            $61de1ee1cac498ae$var$PQd(this, $61de1ee1cac498ae$var$BD(b, 87));
            return;
        case 4:
            $61de1ee1cac498ae$var$RQd(this, $61de1ee1cac498ae$var$BD(b, 836));
            return;
        case 5:
            $61de1ee1cac498ae$var$NQd(this, $61de1ee1cac498ae$var$BD(b, 138));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$XFd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$XFd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function $Qd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$XFd;
};
$61de1ee1cac498ae$var$_.Bh = function _Qd(a) {
    var b;
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$SQd(this, null);
            return;
        case 1:
            !this.d && (this.d = new $61de1ee1cac498ae$var$xMd($61de1ee1cac498ae$var$j5, this, 1));
            $61de1ee1cac498ae$var$Uxd(this.d);
            return;
        case 3:
            $61de1ee1cac498ae$var$PQd(this, null);
            return;
        case 4:
            $61de1ee1cac498ae$var$RQd(this, null);
            return;
        case 5:
            $61de1ee1cac498ae$var$NQd(this, null);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$XFd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$XFd : b), a));
};
$61de1ee1cac498ae$var$_.Ib = function aRd() {
    var a;
    a = new $61de1ee1cac498ae$var$Wfb($61de1ee1cac498ae$var$Eid(this));
    a.a += " (expression: ";
    $61de1ee1cac498ae$var$TQd(this, a);
    a.a += ")";
    return a.a;
};
var $61de1ee1cac498ae$var$FQd;
var $61de1ee1cac498ae$var$e6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EGenericTypeImpl", 241);
$61de1ee1cac498ae$var$bcb(1969, 1964, $61de1ee1cac498ae$var$Vve);
$61de1ee1cac498ae$var$_.Xh = function cRd(a, b) {
    $61de1ee1cac498ae$var$bRd(this, a, b);
};
$61de1ee1cac498ae$var$_.lk = function dRd(a, b) {
    $61de1ee1cac498ae$var$bRd(this, this.gc(), a);
    return b;
};
$61de1ee1cac498ae$var$_.pi = function eRd(a) {
    return $61de1ee1cac498ae$var$Ut(this.Gi(), a);
};
$61de1ee1cac498ae$var$_.Zh = function fRd() {
    return this.$h();
};
$61de1ee1cac498ae$var$_.Gi = function gRd() {
    return new $61de1ee1cac498ae$var$O0d(this);
};
$61de1ee1cac498ae$var$_.$h = function hRd() {
    return this._h(0);
};
$61de1ee1cac498ae$var$_._h = function iRd(a) {
    return this.Gi().Zc(a);
};
$61de1ee1cac498ae$var$_.mk = function jRd(a, b) {
    $61de1ee1cac498ae$var$ze(this, a, true);
    return b;
};
$61de1ee1cac498ae$var$_.ii = function kRd(a, b) {
    var c, d;
    d = $61de1ee1cac498ae$var$Vt(this, b);
    c = this.Zc(a);
    c.Rb(d);
    return d;
};
$61de1ee1cac498ae$var$_.ji = function lRd(a, b) {
    var c;
    $61de1ee1cac498ae$var$ze(this, b, true);
    c = this.Zc(a);
    c.Rb(b);
};
var $61de1ee1cac498ae$var$B8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "AbstractSequentialInternalEList", 1969);
$61de1ee1cac498ae$var$bcb(486, 1969, $61de1ee1cac498ae$var$Vve, $61de1ee1cac498ae$var$qRd);
$61de1ee1cac498ae$var$_.pi = function rRd(a) {
    return $61de1ee1cac498ae$var$Ut(this.Gi(), a);
};
$61de1ee1cac498ae$var$_.Zh = function sRd() {
    if (this.b == null) return $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$KRd;
    return this.Jk();
};
$61de1ee1cac498ae$var$_.Gi = function tRd() {
    return new $61de1ee1cac498ae$var$w4d(this.a, this.b);
};
$61de1ee1cac498ae$var$_.$h = function uRd() {
    if (this.b == null) return $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$KRd;
    return this.Jk();
};
$61de1ee1cac498ae$var$_._h = function vRd(a) {
    var b, c;
    if (this.b == null) {
        if (a < 0 || a > 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$gve + a + ", size=0"));
        return $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$KRd;
    }
    c = this.Jk();
    for(b = 0; b < a; ++b)$61de1ee1cac498ae$var$MRd(c);
    return c;
};
$61de1ee1cac498ae$var$_.dc = function wRd() {
    var a, b, c, d, e, f;
    if (this.b != null) for(c = 0; c < this.b.length; ++c){
        a = this.b[c];
        if (!this.Mk() || this.a.mh(a)) {
            f = this.a.bh(a, false);
            $61de1ee1cac498ae$var$Q6d();
            if ($61de1ee1cac498ae$var$BD(a, 66).Oj()) {
                b = $61de1ee1cac498ae$var$BD(f, 153);
                for(d = 0, e = b.gc(); d < e; ++d){
                    if ($61de1ee1cac498ae$var$oRd(b.il(d)) && b.jl(d) != null) return false;
                }
            } else if (a.$j()) {
                if (!$61de1ee1cac498ae$var$BD(f, 14).dc()) return false;
            } else if (f != null) return false;
        }
    }
    return true;
};
$61de1ee1cac498ae$var$_.Kc = function xRd() {
    return $61de1ee1cac498ae$var$pRd(this);
};
$61de1ee1cac498ae$var$_.Zc = function yRd(a) {
    var b, c;
    if (this.b == null) {
        if (a != 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$qcb($61de1ee1cac498ae$var$gve + a + ", size=0"));
        return $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$LRd(), $61de1ee1cac498ae$var$KRd;
    }
    c = this.Lk() ? this.Kk() : this.Jk();
    for(b = 0; b < a; ++b)$61de1ee1cac498ae$var$MRd(c);
    return c;
};
$61de1ee1cac498ae$var$_.ii = function zRd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.ji = function ARd(a, b) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Jk = function BRd() {
    return new $61de1ee1cac498ae$var$RRd(this.a, this.b);
};
$61de1ee1cac498ae$var$_.Kk = function CRd() {
    return new $61de1ee1cac498ae$var$dSd(this.a, this.b);
};
$61de1ee1cac498ae$var$_.Lk = function DRd() {
    return true;
};
$61de1ee1cac498ae$var$_.gc = function ERd() {
    var a, b, c, d, e, f, g;
    e = 0;
    if (this.b != null) for(c = 0; c < this.b.length; ++c){
        a = this.b[c];
        if (!this.Mk() || this.a.mh(a)) {
            g = this.a.bh(a, false);
            $61de1ee1cac498ae$var$Q6d();
            if ($61de1ee1cac498ae$var$BD(a, 66).Oj()) {
                b = $61de1ee1cac498ae$var$BD(g, 153);
                for(d = 0, f = b.gc(); d < f; ++d)$61de1ee1cac498ae$var$oRd(b.il(d)) && b.jl(d) != null && ++e;
            } else a.$j() ? e += $61de1ee1cac498ae$var$BD(g, 14).gc() : g != null && ++e;
        }
    }
    return e;
};
$61de1ee1cac498ae$var$_.Mk = function FRd() {
    return true;
};
var $61de1ee1cac498ae$var$mRd;
var $61de1ee1cac498ae$var$R8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EContentsEList", 486);
$61de1ee1cac498ae$var$bcb(1156, 486, $61de1ee1cac498ae$var$Vve, $61de1ee1cac498ae$var$GRd);
$61de1ee1cac498ae$var$_.Jk = function HRd() {
    return new $61de1ee1cac498ae$var$hSd(this.a, this.b);
};
$61de1ee1cac498ae$var$_.Kk = function IRd() {
    return new $61de1ee1cac498ae$var$fSd(this.a, this.b);
};
$61de1ee1cac498ae$var$_.Mk = function JRd() {
    return false;
};
var $61de1ee1cac498ae$var$i6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ENamedElementImpl/1", 1156);
$61de1ee1cac498ae$var$bcb(279, 1, $61de1ee1cac498ae$var$Wve, $61de1ee1cac498ae$var$RRd);
$61de1ee1cac498ae$var$_.Nb = function URd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Rb = function SRd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Nk = function TRd(a) {
    if (this.g != 0 || !!this.e) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Zdb("Iterator already in use or already filtered"));
    this.e = a;
};
$61de1ee1cac498ae$var$_.Ob = function VRd() {
    var a, b, c, d, e, f;
    switch(this.g){
        case 3:
        case 2:
            return true;
        case 1:
            return false;
        case -3:
            !this.p ? ++this.n : this.p.Pb();
        default:
            if (!this.k || (!this.p ? !$61de1ee1cac498ae$var$NRd(this) : !$61de1ee1cac498ae$var$ORd(this, this.p))) {
                while(this.d < this.c.length){
                    b = this.c[this.d++];
                    if ((!this.e || b.Gj() != $61de1ee1cac498ae$var$x2 || b.aj() != 0) && (!this.Mk() || this.b.mh(b))) {
                        f = this.b.bh(b, this.Lk());
                        this.f = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj());
                        if (this.f || b.$j()) {
                            if (this.Lk()) {
                                d = $61de1ee1cac498ae$var$BD(f, 15);
                                this.k = d;
                            } else {
                                d = $61de1ee1cac498ae$var$BD(f, 69);
                                this.k = this.j = d;
                            }
                            if ($61de1ee1cac498ae$var$JD(this.k, 54)) {
                                this.p = null;
                                this.o = this.k.gc();
                                this.n = 0;
                            } else this.p = !this.j ? this.k.Yc() : this.j.$h();
                            if (!this.p ? $61de1ee1cac498ae$var$NRd(this) : $61de1ee1cac498ae$var$ORd(this, this.p)) {
                                e = !this.p ? !this.j ? this.k.Xb(this.n++) : this.j.pi(this.n++) : this.p.Pb();
                                if (this.f) {
                                    a = $61de1ee1cac498ae$var$BD(e, 72);
                                    a.ak();
                                    c = a.dd();
                                    this.i = c;
                                } else {
                                    c = e;
                                    this.i = c;
                                }
                                this.g = 3;
                                return true;
                            }
                        } else if (f != null) {
                            this.k = null;
                            this.p = null;
                            c = f;
                            this.i = c;
                            this.g = 2;
                            return true;
                        }
                    }
                }
                this.k = null;
                this.p = null;
                this.f = false;
                this.g = 1;
                return false;
            } else {
                e = !this.p ? !this.j ? this.k.Xb(this.n++) : this.j.pi(this.n++) : this.p.Pb();
                if (this.f) {
                    a = $61de1ee1cac498ae$var$BD(e, 72);
                    a.ak();
                    c = a.dd();
                    this.i = c;
                } else {
                    c = e;
                    this.i = c;
                }
                this.g = 3;
                return true;
            }
    }
};
$61de1ee1cac498ae$var$_.Sb = function WRd() {
    var a, b, c, d, e, f;
    switch(this.g){
        case -3:
        case -2:
            return true;
        case -1:
            return false;
        case 3:
            !this.p ? --this.n : this.p.Ub();
        default:
            if (!this.k || (!this.p ? !$61de1ee1cac498ae$var$PRd(this) : !$61de1ee1cac498ae$var$QRd(this, this.p))) {
                while(this.d > 0){
                    b = this.c[--this.d];
                    if ((!this.e || b.Gj() != $61de1ee1cac498ae$var$x2 || b.aj() != 0) && (!this.Mk() || this.b.mh(b))) {
                        f = this.b.bh(b, this.Lk());
                        this.f = ($61de1ee1cac498ae$var$Q6d(), $61de1ee1cac498ae$var$BD(b, 66).Oj());
                        if (this.f || b.$j()) {
                            if (this.Lk()) {
                                d = $61de1ee1cac498ae$var$BD(f, 15);
                                this.k = d;
                            } else {
                                d = $61de1ee1cac498ae$var$BD(f, 69);
                                this.k = this.j = d;
                            }
                            if ($61de1ee1cac498ae$var$JD(this.k, 54)) {
                                this.o = this.k.gc();
                                this.n = this.o;
                            } else this.p = !this.j ? this.k.Zc(this.k.gc()) : this.j._h(this.k.gc());
                            if (!this.p ? $61de1ee1cac498ae$var$PRd(this) : $61de1ee1cac498ae$var$QRd(this, this.p)) {
                                e = !this.p ? !this.j ? this.k.Xb(--this.n) : this.j.pi(--this.n) : this.p.Ub();
                                if (this.f) {
                                    a = $61de1ee1cac498ae$var$BD(e, 72);
                                    a.ak();
                                    c = a.dd();
                                    this.i = c;
                                } else {
                                    c = e;
                                    this.i = c;
                                }
                                this.g = -3;
                                return true;
                            }
                        } else if (f != null) {
                            this.k = null;
                            this.p = null;
                            c = f;
                            this.i = c;
                            this.g = -2;
                            return true;
                        }
                    }
                }
                this.k = null;
                this.p = null;
                this.g = -1;
                return false;
            } else {
                e = !this.p ? !this.j ? this.k.Xb(--this.n) : this.j.pi(--this.n) : this.p.Ub();
                if (this.f) {
                    a = $61de1ee1cac498ae$var$BD(e, 72);
                    a.ak();
                    c = a.dd();
                    this.i = c;
                } else {
                    c = e;
                    this.i = c;
                }
                this.g = -3;
                return true;
            }
    }
};
$61de1ee1cac498ae$var$_.Pb = function XRd() {
    return $61de1ee1cac498ae$var$MRd(this);
};
$61de1ee1cac498ae$var$_.Tb = function YRd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Ub = function ZRd() {
    var a;
    if (this.g < -1 || this.Sb()) {
        --this.a;
        this.g = 0;
        a = this.i;
        this.Sb();
        return a;
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Vb = function $Rd() {
    return this.a - 1;
};
$61de1ee1cac498ae$var$_.Qb = function _Rd() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Lk = function aSd() {
    return false;
};
$61de1ee1cac498ae$var$_.Wb = function bSd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Mk = function cSd() {
    return true;
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.f = false;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.n = 0;
$61de1ee1cac498ae$var$_.o = 0;
var $61de1ee1cac498ae$var$KRd;
var $61de1ee1cac498ae$var$P8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EContentsEList/FeatureIteratorImpl", 279);
$61de1ee1cac498ae$var$bcb(697, 279, $61de1ee1cac498ae$var$Wve, $61de1ee1cac498ae$var$dSd);
$61de1ee1cac498ae$var$_.Lk = function eSd() {
    return true;
};
var $61de1ee1cac498ae$var$Q8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EContentsEList/ResolvingFeatureIteratorImpl", 697);
$61de1ee1cac498ae$var$bcb(1157, 697, $61de1ee1cac498ae$var$Wve, $61de1ee1cac498ae$var$fSd);
$61de1ee1cac498ae$var$_.Mk = function gSd() {
    return false;
};
var $61de1ee1cac498ae$var$g6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ENamedElementImpl/1/1", 1157);
$61de1ee1cac498ae$var$bcb(1158, 279, $61de1ee1cac498ae$var$Wve, $61de1ee1cac498ae$var$hSd);
$61de1ee1cac498ae$var$_.Mk = function iSd() {
    return false;
};
var $61de1ee1cac498ae$var$h6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ENamedElementImpl/1/2", 1158);
$61de1ee1cac498ae$var$bcb(36, 143, $61de1ee1cac498ae$var$fve, $61de1ee1cac498ae$var$lSd, $61de1ee1cac498ae$var$mSd, $61de1ee1cac498ae$var$nSd, $61de1ee1cac498ae$var$oSd, $61de1ee1cac498ae$var$pSd, $61de1ee1cac498ae$var$qSd, $61de1ee1cac498ae$var$rSd, $61de1ee1cac498ae$var$sSd, $61de1ee1cac498ae$var$tSd, $61de1ee1cac498ae$var$uSd, $61de1ee1cac498ae$var$vSd, $61de1ee1cac498ae$var$wSd, $61de1ee1cac498ae$var$xSd, $61de1ee1cac498ae$var$ySd, $61de1ee1cac498ae$var$zSd, $61de1ee1cac498ae$var$ASd, $61de1ee1cac498ae$var$BSd, $61de1ee1cac498ae$var$CSd, $61de1ee1cac498ae$var$DSd, $61de1ee1cac498ae$var$ESd, $61de1ee1cac498ae$var$FSd, $61de1ee1cac498ae$var$GSd, $61de1ee1cac498ae$var$HSd, $61de1ee1cac498ae$var$ISd, $61de1ee1cac498ae$var$JSd);
$61de1ee1cac498ae$var$_._i = function KSd() {
    return $61de1ee1cac498ae$var$kSd(this);
};
$61de1ee1cac498ae$var$_.gj = function LSd() {
    var a;
    a = $61de1ee1cac498ae$var$kSd(this);
    if (a) return a.zj();
    return null;
};
$61de1ee1cac498ae$var$_.yi = function MSd(a) {
    this.b == -1 && !!this.a && (this.b = this.c.Xg(this.a.aj(), this.a.Gj()));
    return this.c.Og(this.b, a);
};
$61de1ee1cac498ae$var$_.Ai = function NSd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.hj = function OSd() {
    var a;
    a = $61de1ee1cac498ae$var$kSd(this);
    if (a) return a.Kj();
    return false;
};
$61de1ee1cac498ae$var$_.b = -1;
var $61de1ee1cac498ae$var$k6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ENotificationImpl", 36);
$61de1ee1cac498ae$var$bcb(399, 284, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    59: 1,
    108: 1,
    472: 1,
    49: 1,
    97: 1,
    150: 1,
    399: 1,
    284: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$SSd);
$61de1ee1cac498ae$var$_.Qg = function TSd(a) {
    return $61de1ee1cac498ae$var$PSd(this, a);
};
$61de1ee1cac498ae$var$_._g = function USd(a, b, c) {
    var d, e, f;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return $61de1ee1cac498ae$var$meb(this.s);
        case 5:
            return $61de1ee1cac498ae$var$meb(this.t);
        case 6:
            return $61de1ee1cac498ae$var$Bcb(), f = this.t, f > 1 || f == -1 ? true : false;
        case 7:
            return $61de1ee1cac498ae$var$Bcb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return $61de1ee1cac498ae$var$wId(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return this.Db >> 16 == 10 ? $61de1ee1cac498ae$var$BD(this.Cb, 26) : null;
        case 11:
            return !this.d && (this.d = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 11)), this.d;
        case 12:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, this, 12, 10)), this.c;
        case 13:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$fTd(this, this)), this.a;
        case 14:
            return $61de1ee1cac498ae$var$QSd(this);
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$aGd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function VSd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 10:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$PSd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 10, c);
        case 12:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, this, 12, 10)), $61de1ee1cac498ae$var$Sxd(this.c, a, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function WSd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 9:
            return $61de1ee1cac498ae$var$vId(this, c);
        case 10:
            return $61de1ee1cac498ae$var$_hd(this, null, 10, c);
        case 11:
            return !this.d && (this.d = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 11)), $61de1ee1cac498ae$var$Txd(this.d, a, c);
        case 12:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, this, 12, 10)), $61de1ee1cac498ae$var$Txd(this.c, a, c);
        case 14:
            return $61de1ee1cac498ae$var$Txd($61de1ee1cac498ae$var$QSd(this), a, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function XSd(a) {
    var b, c, d;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return d = this.t, d > 1 || d == -1;
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0);
        case 10:
            return !!(this.Db >> 16 == 10 ? $61de1ee1cac498ae$var$BD(this.Cb, 26) : null);
        case 11:
            return !!this.d && this.d.i != 0;
        case 12:
            return !!this.c && this.c.i != 0;
        case 13:
            return !!this.a && $61de1ee1cac498ae$var$QSd(this.a.a).i != 0 && !(!!this.b && $61de1ee1cac498ae$var$QTd(this.b));
        case 14:
            return !!this.b && $61de1ee1cac498ae$var$QTd(this.b);
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$aGd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function YSd(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 5:
            $61de1ee1cac498ae$var$DId(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, $61de1ee1cac498ae$var$BD(b, 138));
            return;
        case 9:
            d = $61de1ee1cac498ae$var$xId(this, $61de1ee1cac498ae$var$BD(b, 87), null);
            !!d && d.Fi();
            return;
        case 11:
            !this.d && (this.d = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 11));
            $61de1ee1cac498ae$var$Uxd(this.d);
            !this.d && (this.d = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 11));
            $61de1ee1cac498ae$var$ytd(this.d, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 12:
            !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, this, 12, 10));
            $61de1ee1cac498ae$var$Uxd(this.c);
            !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, this, 12, 10));
            $61de1ee1cac498ae$var$ytd(this.c, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 13:
            !this.a && (this.a = new $61de1ee1cac498ae$var$fTd(this, this));
            $61de1ee1cac498ae$var$vwd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$fTd(this, this));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 14:
            $61de1ee1cac498ae$var$Uxd($61de1ee1cac498ae$var$QSd(this));
            $61de1ee1cac498ae$var$ytd($61de1ee1cac498ae$var$QSd(this), $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$aGd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function ZSd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd;
};
$61de1ee1cac498ae$var$_.Bh = function $Sd(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, true);
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, true);
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, 0);
            return;
        case 5:
            $61de1ee1cac498ae$var$DId(this, 1);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, null);
            return;
        case 9:
            c = $61de1ee1cac498ae$var$xId(this, null, null);
            !!c && c.Fi();
            return;
        case 11:
            !this.d && (this.d = new $61de1ee1cac498ae$var$K4d($61de1ee1cac498ae$var$u5, this, 11));
            $61de1ee1cac498ae$var$Uxd(this.d);
            return;
        case 12:
            !this.c && (this.c = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$p5, this, 12, 10));
            $61de1ee1cac498ae$var$Uxd(this.c);
            return;
        case 13:
            !!this.a && $61de1ee1cac498ae$var$vwd(this.a);
            return;
        case 14:
            !!this.b && $61de1ee1cac498ae$var$Uxd(this.b);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$aGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$aGd : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function _Sd() {
    var a, b;
    if (this.c) for(a = 0, b = this.c.i; a < b; ++a)$61de1ee1cac498ae$var$Cmd($61de1ee1cac498ae$var$qud(this.c, a));
    $61de1ee1cac498ae$var$wId(this);
    this.Bb |= 1;
};
var $61de1ee1cac498ae$var$p6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EOperationImpl", 399);
$61de1ee1cac498ae$var$bcb(505, 742, $61de1ee1cac498ae$var$Uve, $61de1ee1cac498ae$var$fTd);
$61de1ee1cac498ae$var$_.Hi = function iTd(a, b) {
    $61de1ee1cac498ae$var$aTd(this, a, $61de1ee1cac498ae$var$BD(b, 138));
};
$61de1ee1cac498ae$var$_.Ii = function jTd(a) {
    $61de1ee1cac498ae$var$bTd(this, $61de1ee1cac498ae$var$BD(a, 138));
};
$61de1ee1cac498ae$var$_.Oi = function pTd(a) {
    var b, c;
    return b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud($61de1ee1cac498ae$var$QSd(this.a), a), 87), c = b.c, c ? c : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd);
};
$61de1ee1cac498ae$var$_.Ti = function uTd(a) {
    var b, c;
    return b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Xxd($61de1ee1cac498ae$var$QSd(this.a), a), 87), c = b.c, c ? c : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd);
};
$61de1ee1cac498ae$var$_.Ui = function vTd(a, b) {
    return $61de1ee1cac498ae$var$dTd(this, a, $61de1ee1cac498ae$var$BD(b, 138));
};
$61de1ee1cac498ae$var$_.ai = function gTd() {
    return false;
};
$61de1ee1cac498ae$var$_.Zi = function hTd(a, b, c, d, e) {
    return null;
};
$61de1ee1cac498ae$var$_.Ji = function kTd() {
    return new $61de1ee1cac498ae$var$NTd(this);
};
$61de1ee1cac498ae$var$_.Ki = function lTd() {
    $61de1ee1cac498ae$var$Uxd($61de1ee1cac498ae$var$QSd(this.a));
};
$61de1ee1cac498ae$var$_.Li = function mTd(a) {
    return $61de1ee1cac498ae$var$cTd(this, a);
};
$61de1ee1cac498ae$var$_.Mi = function nTd(a) {
    var b, c;
    for(c = a.Kc(); c.Ob();){
        b = c.Pb();
        if (!$61de1ee1cac498ae$var$cTd(this, b)) return false;
    }
    return true;
};
$61de1ee1cac498ae$var$_.Ni = function oTd(a) {
    var b, c, d;
    if ($61de1ee1cac498ae$var$JD(a, 15)) {
        d = $61de1ee1cac498ae$var$BD(a, 15);
        if (d.gc() == $61de1ee1cac498ae$var$QSd(this.a).i) {
            for(b = d.Kc(), c = new $61de1ee1cac498ae$var$Fyd(this); b.Ob();){
                if ($61de1ee1cac498ae$var$PD(b.Pb()) !== $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$Dyd(c))) return false;
            }
            return true;
        }
    }
    return false;
};
$61de1ee1cac498ae$var$_.Pi = function qTd() {
    var a, b, c, d, e;
    c = 1;
    for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$QSd(this.a)); b.e != b.i.gc();){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 87);
        d = (e = a.c, e ? e : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd));
        c = 31 * c + (!d ? 0 : $61de1ee1cac498ae$var$tb(d));
    }
    return c;
};
$61de1ee1cac498ae$var$_.Qi = function rTd(a) {
    var b, c, d, e;
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$QSd(this.a)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 87);
        if ($61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD((e = b.c, e ? e : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd)))) return d;
        ++d;
    }
    return -1;
};
$61de1ee1cac498ae$var$_.Ri = function sTd() {
    return $61de1ee1cac498ae$var$QSd(this.a).i == 0;
};
$61de1ee1cac498ae$var$_.Si = function tTd() {
    return null;
};
$61de1ee1cac498ae$var$_.Vi = function wTd() {
    return $61de1ee1cac498ae$var$QSd(this.a).i;
};
$61de1ee1cac498ae$var$_.Wi = function xTd() {
    var a, b, c, d, e, f;
    f = $61de1ee1cac498ae$var$QSd(this.a).i;
    e = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SI, $61de1ee1cac498ae$var$Uhe, 1, f, 5, 1);
    c = 0;
    for(b = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$QSd(this.a)); b.e != b.i.gc();){
        a = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(b), 87);
        e[c++] = (d = a.c, d ? d : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd));
    }
    return e;
};
$61de1ee1cac498ae$var$_.Xi = function yTd(a) {
    var b, c, d, e, f, g, h;
    h = $61de1ee1cac498ae$var$QSd(this.a).i;
    if (a.length < h) {
        e = $61de1ee1cac498ae$var$izd($61de1ee1cac498ae$var$rb(a).c, h);
        a = e;
    }
    a.length > h && $61de1ee1cac498ae$var$NC(a, h, null);
    d = 0;
    for(c = new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$QSd(this.a)); c.e != c.i.gc();){
        b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Dyd(c), 87);
        f = (g = b.c, g ? g : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd));
        $61de1ee1cac498ae$var$NC(a, d++, f);
    }
    return a;
};
$61de1ee1cac498ae$var$_.Yi = function zTd() {
    var a, b, c, d, e;
    e = new $61de1ee1cac498ae$var$Hfb;
    e.a += "[";
    a = $61de1ee1cac498ae$var$QSd(this.a);
    for(b = 0, d = $61de1ee1cac498ae$var$QSd(this.a).i; b < d;){
        $61de1ee1cac498ae$var$Efb(e, $61de1ee1cac498ae$var$xfb((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(a, b), 87).c, c ? c : ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$YFd))));
        ++b < d && (e.a += $61de1ee1cac498ae$var$She, e);
    }
    e.a += "]";
    return e.a;
};
$61de1ee1cac498ae$var$_.$i = function ATd(a) {};
$61de1ee1cac498ae$var$_.aj = function BTd() {
    return 13;
};
$61de1ee1cac498ae$var$_.Bk = function CTd() {
    return true;
};
$61de1ee1cac498ae$var$_.bj = function DTd() {
    return false;
};
$61de1ee1cac498ae$var$_.Ck = function ETd() {
    return false;
};
$61de1ee1cac498ae$var$_.Dk = function FTd() {
    return false;
};
$61de1ee1cac498ae$var$_.Ek = function GTd() {
    return true;
};
$61de1ee1cac498ae$var$_.rk = function HTd() {
    return false;
};
$61de1ee1cac498ae$var$_.Fk = function ITd() {
    return true;
};
$61de1ee1cac498ae$var$_.wj = function JTd(a) {
    return $61de1ee1cac498ae$var$JD(a, 138);
};
$61de1ee1cac498ae$var$_.fj = function KTd() {
    return $61de1ee1cac498ae$var$RSd(this.a);
};
$61de1ee1cac498ae$var$_.hi = function LTd() {
    return true;
};
$61de1ee1cac498ae$var$_.ni = function MTd() {
    return true;
};
var $61de1ee1cac498ae$var$n6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EOperationImpl/1", 505);
$61de1ee1cac498ae$var$bcb(1340, 1964, $61de1ee1cac498ae$var$Lie, $61de1ee1cac498ae$var$NTd);
$61de1ee1cac498ae$var$_.Zc = function OTd(a) {
    return $61de1ee1cac498ae$var$ztd(this.a, a);
};
$61de1ee1cac498ae$var$_.gc = function PTd() {
    return $61de1ee1cac498ae$var$QSd(this.a.a).i;
};
var $61de1ee1cac498ae$var$m6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EOperationImpl/1/1", 1340);
$61de1ee1cac498ae$var$bcb(1341, 545, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$UTd);
$61de1ee1cac498ae$var$_.ii = function YTd(a, b) {
    var c, d;
    return c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Wxd(this, a, b), 87), $61de1ee1cac498ae$var$oid(this.e) && $61de1ee1cac498ae$var$GLd(this, new $61de1ee1cac498ae$var$ESd(this.a, 7, ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$bGd), $61de1ee1cac498ae$var$meb(b), (d = c.c, d ? d : $61de1ee1cac498ae$var$YFd), a)), c;
};
$61de1ee1cac498ae$var$_.jj = function ZTd(a, b) {
    return $61de1ee1cac498ae$var$RTd(this, $61de1ee1cac498ae$var$BD(a, 87), b);
};
$61de1ee1cac498ae$var$_.kj = function $Td(a, b) {
    return $61de1ee1cac498ae$var$STd(this, $61de1ee1cac498ae$var$BD(a, 87), b);
};
$61de1ee1cac498ae$var$_.lj = function _Td(a, b, c) {
    return $61de1ee1cac498ae$var$TTd(this, $61de1ee1cac498ae$var$BD(a, 87), $61de1ee1cac498ae$var$BD(b, 87), c);
};
$61de1ee1cac498ae$var$_.Zi = function VTd(a, b, c, d, e) {
    switch(a){
        case 3:
            return $61de1ee1cac498ae$var$FLd(this, a, b, c, d, this.i > 1);
        case 5:
            return $61de1ee1cac498ae$var$FLd(this, a, b, c, d, this.i - $61de1ee1cac498ae$var$BD(c, 15).gc() > 0);
        default:
            return new $61de1ee1cac498ae$var$pSd(this.e, a, this.c, b, c, d, true);
    }
};
$61de1ee1cac498ae$var$_.ij = function WTd() {
    return true;
};
$61de1ee1cac498ae$var$_.fj = function XTd() {
    return $61de1ee1cac498ae$var$QTd(this);
};
$61de1ee1cac498ae$var$_.Xj = function aUd() {
    $61de1ee1cac498ae$var$Uxd(this);
};
var $61de1ee1cac498ae$var$o6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EOperationImpl/2", 1341);
$61de1ee1cac498ae$var$bcb(498, 1, {
    1938: 1,
    498: 1
}, $61de1ee1cac498ae$var$bUd);
var $61de1ee1cac498ae$var$q6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EPackageImpl/1", 498);
$61de1ee1cac498ae$var$bcb(16, 85, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$cUd);
$61de1ee1cac498ae$var$_.zk = function dUd() {
    return this.d;
};
$61de1ee1cac498ae$var$_.Ak = function eUd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Dk = function fUd() {
    return true;
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$b9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentWithInverseEList", 16);
$61de1ee1cac498ae$var$bcb(353, 16, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$gUd);
$61de1ee1cac498ae$var$_.Ek = function hUd() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function iUd(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$$8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentWithInverseEList/Resolving", 353);
$61de1ee1cac498ae$var$bcb(298, 353, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$jUd);
$61de1ee1cac498ae$var$_.ci = function kUd() {
    this.a.tb = null;
};
var $61de1ee1cac498ae$var$r6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EPackageImpl/2", 298);
$61de1ee1cac498ae$var$bcb(1228, 1, {}, $61de1ee1cac498ae$var$lUd);
var $61de1ee1cac498ae$var$s6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EPackageImpl/3", 1228);
$61de1ee1cac498ae$var$bcb(718, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$oUd);
$61de1ee1cac498ae$var$_._b = function pUd(a) {
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$Qhb(this, a) : !!$61de1ee1cac498ae$var$irb(this.f, a);
};
var $61de1ee1cac498ae$var$u6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EPackageRegistryImpl", 718);
$61de1ee1cac498ae$var$bcb(509, 284, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    2017: 1,
    108: 1,
    472: 1,
    49: 1,
    97: 1,
    150: 1,
    509: 1,
    284: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$rUd);
$61de1ee1cac498ae$var$_.Qg = function sUd(a) {
    return $61de1ee1cac498ae$var$qUd(this, a);
};
$61de1ee1cac498ae$var$_._g = function tUd(a, b, c) {
    var d, e, f;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return $61de1ee1cac498ae$var$meb(this.s);
        case 5:
            return $61de1ee1cac498ae$var$meb(this.t);
        case 6:
            return $61de1ee1cac498ae$var$Bcb(), f = this.t, f > 1 || f == -1 ? true : false;
        case 7:
            return $61de1ee1cac498ae$var$Bcb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return $61de1ee1cac498ae$var$wId(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return this.Db >> 16 == 10 ? $61de1ee1cac498ae$var$BD(this.Cb, 59) : null;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$dGd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.hh = function uUd(a, b, c) {
    var d, e, f;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Sxd(this.Ab, a, c);
        case 10:
            !!this.Cb && (c = (e = this.Db >> 16, e >= 0 ? $61de1ee1cac498ae$var$qUd(this, c) : this.Cb.ih(this, -1 - e, null, c)));
            return $61de1ee1cac498ae$var$_hd(this, a, 10, c);
    }
    return f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd) : d), b), 66), f.Nj().Qj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd)), a, c);
};
$61de1ee1cac498ae$var$_.jh = function vUd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 9:
            return $61de1ee1cac498ae$var$vId(this, c);
        case 10:
            return $61de1ee1cac498ae$var$_hd(this, null, 10, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function wUd(a) {
    var b, c, d;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return d = this.t, d > 1 || d == -1;
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0);
        case 10:
            return !!(this.Db >> 16 == 10 ? $61de1ee1cac498ae$var$BD(this.Cb, 59) : null);
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$dGd : b), a));
};
$61de1ee1cac498ae$var$_.zh = function xUd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$dGd;
};
var $61de1ee1cac498ae$var$v6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EParameterImpl", 509);
$61de1ee1cac498ae$var$bcb(99, 449, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    18: 1,
    170: 1,
    66: 1,
    108: 1,
    472: 1,
    49: 1,
    97: 1,
    150: 1,
    99: 1,
    449: 1,
    284: 1,
    114: 1,
    115: 1,
    677: 1
}, $61de1ee1cac498ae$var$FUd);
$61de1ee1cac498ae$var$_._g = function GUd(a, b, c) {
    var d, e, f, g;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 256) != 0 ? true : false;
        case 3:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & 512) != 0 ? true : false;
        case 4:
            return $61de1ee1cac498ae$var$meb(this.s);
        case 5:
            return $61de1ee1cac498ae$var$meb(this.t);
        case 6:
            return $61de1ee1cac498ae$var$Bcb(), g = this.t, g > 1 || g == -1 ? true : false;
        case 7:
            return $61de1ee1cac498ae$var$Bcb(), e = this.s, e >= 1 ? true : false;
        case 8:
            if (b) return $61de1ee1cac498ae$var$wId(this);
            return this.r;
        case 9:
            return this.q;
        case 10:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$zte) != 0 ? true : false;
        case 11:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Dve) != 0 ? true : false;
        case 12:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Rje) != 0 ? true : false;
        case 13:
            return this.j;
        case 14:
            return $61de1ee1cac498ae$var$VId(this);
        case 15:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Cve) != 0 ? true : false;
        case 16:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$oie) != 0 ? true : false;
        case 17:
            return $61de1ee1cac498ae$var$WId(this);
        case 18:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$ote) != 0 ? true : false;
        case 19:
            return $61de1ee1cac498ae$var$Bcb(), f = $61de1ee1cac498ae$var$zUd(this), !!f && (f.Bb & $61de1ee1cac498ae$var$ote) != 0 ? true : false;
        case 20:
            return $61de1ee1cac498ae$var$Bcb(), (this.Bb & $61de1ee1cac498ae$var$Tje) != 0 ? true : false;
        case 21:
            if (b) return $61de1ee1cac498ae$var$zUd(this);
            return this.b;
        case 22:
            if (b) return $61de1ee1cac498ae$var$AUd(this);
            return $61de1ee1cac498ae$var$yUd(this);
        case 23:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$b5, this, 23)), this.a;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$eGd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$eGd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.lh = function HUd(a) {
    var b, c, d, e;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return (this.Bb & 256) == 0;
        case 3:
            return (this.Bb & 512) == 0;
        case 4:
            return this.s != 0;
        case 5:
            return this.t != 1;
        case 6:
            return e = this.t, e > 1 || e == -1;
        case 7:
            return c = this.s, c >= 1;
        case 8:
            return !!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0;
        case 9:
            return !!this.q && !(!!this.r && !this.q.e && $61de1ee1cac498ae$var$LQd(this.q).i == 0);
        case 10:
            return (this.Bb & $61de1ee1cac498ae$var$zte) == 0;
        case 11:
            return (this.Bb & $61de1ee1cac498ae$var$Dve) != 0;
        case 12:
            return (this.Bb & $61de1ee1cac498ae$var$Rje) != 0;
        case 13:
            return this.j != null;
        case 14:
            return $61de1ee1cac498ae$var$VId(this) != null;
        case 15:
            return (this.Bb & $61de1ee1cac498ae$var$Cve) != 0;
        case 16:
            return (this.Bb & $61de1ee1cac498ae$var$oie) != 0;
        case 17:
            return !!$61de1ee1cac498ae$var$WId(this);
        case 18:
            return (this.Bb & $61de1ee1cac498ae$var$ote) != 0;
        case 19:
            return d = $61de1ee1cac498ae$var$zUd(this), !!d && (d.Bb & $61de1ee1cac498ae$var$ote) != 0;
        case 20:
            return (this.Bb & $61de1ee1cac498ae$var$Tje) == 0;
        case 21:
            return !!this.b;
        case 22:
            return !!$61de1ee1cac498ae$var$yUd(this);
        case 23:
            return !!this.a && this.a.i != 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$eGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$eGd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function IUd(a, b) {
    var c, d;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$cJd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 5:
            $61de1ee1cac498ae$var$DId(this, $61de1ee1cac498ae$var$BD(b, 19).a);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, $61de1ee1cac498ae$var$BD(b, 138));
            return;
        case 9:
            d = $61de1ee1cac498ae$var$xId(this, $61de1ee1cac498ae$var$BD(b, 87), null);
            !!d && d.Fi();
            return;
        case 10:
            $61de1ee1cac498ae$var$ZId(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 11:
            $61de1ee1cac498ae$var$fJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 12:
            $61de1ee1cac498ae$var$dJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 13:
            $61de1ee1cac498ae$var$$Id(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 15:
            $61de1ee1cac498ae$var$eJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 16:
            $61de1ee1cac498ae$var$aJd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 18:
            $61de1ee1cac498ae$var$BUd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 20:
            $61de1ee1cac498ae$var$EUd(this, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(b)));
            return;
        case 21:
            $61de1ee1cac498ae$var$DUd(this, $61de1ee1cac498ae$var$BD(b, 18));
            return;
        case 23:
            !this.a && (this.a = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$b5, this, 23));
            $61de1ee1cac498ae$var$Uxd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$b5, this, 23));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$eGd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$eGd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function JUd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$eGd;
};
$61de1ee1cac498ae$var$_.Bh = function KUd(a) {
    var b, c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$JD(this.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(this.Cb, 88)), 4);
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            $61de1ee1cac498ae$var$BId(this, true);
            return;
        case 3:
            $61de1ee1cac498ae$var$CId(this, true);
            return;
        case 4:
            $61de1ee1cac498ae$var$AId(this, 0);
            return;
        case 5:
            $61de1ee1cac498ae$var$DId(this, 1);
            return;
        case 8:
            $61de1ee1cac498ae$var$yId(this, null);
            return;
        case 9:
            c = $61de1ee1cac498ae$var$xId(this, null, null);
            !!c && c.Fi();
            return;
        case 10:
            $61de1ee1cac498ae$var$ZId(this, true);
            return;
        case 11:
            $61de1ee1cac498ae$var$fJd(this, false);
            return;
        case 12:
            $61de1ee1cac498ae$var$dJd(this, false);
            return;
        case 13:
            this.i = null;
            $61de1ee1cac498ae$var$_Id(this, null);
            return;
        case 15:
            $61de1ee1cac498ae$var$eJd(this, false);
            return;
        case 16:
            $61de1ee1cac498ae$var$aJd(this, false);
            return;
        case 18:
            $61de1ee1cac498ae$var$CUd(this, false);
            $61de1ee1cac498ae$var$JD(this.Cb, 88) && $61de1ee1cac498ae$var$XMd($61de1ee1cac498ae$var$$Kd($61de1ee1cac498ae$var$BD(this.Cb, 88)), 2);
            return;
        case 20:
            $61de1ee1cac498ae$var$EUd(this, true);
            return;
        case 21:
            $61de1ee1cac498ae$var$DUd(this, null);
            return;
        case 23:
            !this.a && (this.a = new $61de1ee1cac498ae$var$_4d($61de1ee1cac498ae$var$b5, this, 23));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$eGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$eGd : b), a));
};
$61de1ee1cac498ae$var$_.Gh = function LUd() {
    $61de1ee1cac498ae$var$AUd(this);
    $61de1ee1cac498ae$var$a2d($61de1ee1cac498ae$var$q1d(($61de1ee1cac498ae$var$O6d(), $61de1ee1cac498ae$var$M6d), this));
    $61de1ee1cac498ae$var$wId(this);
    this.Bb |= 1;
};
$61de1ee1cac498ae$var$_.Lj = function MUd() {
    return $61de1ee1cac498ae$var$zUd(this);
};
$61de1ee1cac498ae$var$_.qk = function NUd() {
    var a;
    return a = $61de1ee1cac498ae$var$zUd(this), !!a && (a.Bb & $61de1ee1cac498ae$var$ote) != 0;
};
$61de1ee1cac498ae$var$_.rk = function OUd() {
    return (this.Bb & $61de1ee1cac498ae$var$ote) != 0;
};
$61de1ee1cac498ae$var$_.sk = function PUd() {
    return (this.Bb & $61de1ee1cac498ae$var$Tje) != 0;
};
$61de1ee1cac498ae$var$_.nk = function QUd(a, b) {
    this.c = null;
    return $61de1ee1cac498ae$var$zId(this, a, b);
};
$61de1ee1cac498ae$var$_.Ib = function RUd() {
    var a;
    if ((this.Db & 64) != 0) return $61de1ee1cac498ae$var$gJd(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$gJd(this));
    a.a += " (containment: ";
    $61de1ee1cac498ae$var$Ffb(a, (this.Bb & $61de1ee1cac498ae$var$ote) != 0);
    a.a += ", resolveProxies: ";
    $61de1ee1cac498ae$var$Ffb(a, (this.Bb & $61de1ee1cac498ae$var$Tje) != 0);
    a.a += ")";
    return a.a;
};
var $61de1ee1cac498ae$var$w6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EReferenceImpl", 99);
$61de1ee1cac498ae$var$bcb(548, 115, {
    105: 1,
    42: 1,
    92: 1,
    90: 1,
    133: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    548: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$XUd);
$61de1ee1cac498ae$var$_.Fb = function bVd(a) {
    return this === a;
};
$61de1ee1cac498ae$var$_.cd = function dVd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.dd = function eVd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.Hb = function fVd() {
    return $61de1ee1cac498ae$var$FCb(this);
};
$61de1ee1cac498ae$var$_.Uh = function hVd(a) {
    $61de1ee1cac498ae$var$SUd(this, $61de1ee1cac498ae$var$GD(a));
};
$61de1ee1cac498ae$var$_.ed = function iVd(a) {
    return $61de1ee1cac498ae$var$WUd(this, $61de1ee1cac498ae$var$GD(a));
};
$61de1ee1cac498ae$var$_._g = function YUd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return this.b;
        case 1:
            return this.c;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$fGd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.lh = function ZUd(a) {
    var b;
    switch(a){
        case 0:
            return this.b != null;
        case 1:
            return this.c != null;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$fGd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function $Ud(a, b) {
    var c;
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$TUd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 1:
            $61de1ee1cac498ae$var$VUd(this, $61de1ee1cac498ae$var$GD(b));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$fGd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function _Ud() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd;
};
$61de1ee1cac498ae$var$_.Bh = function aVd(a) {
    var b;
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$UUd(this, null);
            return;
        case 1:
            $61de1ee1cac498ae$var$VUd(this, null);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$fGd : b), a));
};
$61de1ee1cac498ae$var$_.Sh = function cVd() {
    var a;
    if (this.a == -1) {
        a = this.b;
        this.a = a == null ? 0 : $61de1ee1cac498ae$var$LCb(a);
    }
    return this.a;
};
$61de1ee1cac498ae$var$_.Th = function gVd(a) {
    this.a = a;
};
$61de1ee1cac498ae$var$_.Ib = function jVd() {
    var a;
    if ((this.Db & 64) != 0) return $61de1ee1cac498ae$var$Eid(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(this));
    a.a += " (key: ";
    $61de1ee1cac498ae$var$Efb(a, this.b);
    a.a += ", value: ";
    $61de1ee1cac498ae$var$Efb(a, this.c);
    a.a += ")";
    return a.a;
};
$61de1ee1cac498ae$var$_.a = -1;
$61de1ee1cac498ae$var$_.b = null;
$61de1ee1cac498ae$var$_.c = null;
var $61de1ee1cac498ae$var$x6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStringToStringMapEntryImpl", 548);
var $61de1ee1cac498ae$var$D9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$yve, "FeatureMap/Entry/Internal");
$61de1ee1cac498ae$var$bcb(565, 1, $61de1ee1cac498ae$var$Xve);
$61de1ee1cac498ae$var$_.Ok = function mVd(a) {
    return this.Pk($61de1ee1cac498ae$var$BD(a, 49));
};
$61de1ee1cac498ae$var$_.Pk = function nVd(a) {
    return this.Ok(a);
};
$61de1ee1cac498ae$var$_.Fb = function oVd(a) {
    var b, c;
    if (this === a) return true;
    else if ($61de1ee1cac498ae$var$JD(a, 72)) {
        b = $61de1ee1cac498ae$var$BD(a, 72);
        if (b.ak() == this.c) {
            c = this.dd();
            return c == null ? b.dd() == null : $61de1ee1cac498ae$var$pb(c, b.dd());
        } else return false;
    } else return false;
};
$61de1ee1cac498ae$var$_.ak = function pVd() {
    return this.c;
};
$61de1ee1cac498ae$var$_.Hb = function qVd() {
    var a;
    a = this.dd();
    return $61de1ee1cac498ae$var$tb(this.c) ^ (a == null ? 0 : $61de1ee1cac498ae$var$tb(a));
};
$61de1ee1cac498ae$var$_.Ib = function rVd() {
    var a, b;
    a = this.c;
    b = $61de1ee1cac498ae$var$bKd(a.Hj()).Ph();
    a.ne();
    return (b != null && b.length != 0 ? b + ":" + a.ne() : a.ne()) + "=" + this.dd();
};
var $61de1ee1cac498ae$var$y6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/BasicFeatureMapEntry", 565);
$61de1ee1cac498ae$var$bcb(776, 565, $61de1ee1cac498ae$var$Xve, $61de1ee1cac498ae$var$uVd);
$61de1ee1cac498ae$var$_.Pk = function vVd(a) {
    return new $61de1ee1cac498ae$var$uVd(this.c, a);
};
$61de1ee1cac498ae$var$_.dd = function wVd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Qk = function xVd(a, b, c) {
    return $61de1ee1cac498ae$var$sVd(this, a, this.a, b, c);
};
$61de1ee1cac498ae$var$_.Rk = function yVd(a, b, c) {
    return $61de1ee1cac498ae$var$tVd(this, a, this.a, b, c);
};
var $61de1ee1cac498ae$var$z6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/ContainmentUpdatingFeatureMapEntry", 776);
$61de1ee1cac498ae$var$bcb(1314, 1, {}, $61de1ee1cac498ae$var$zVd);
$61de1ee1cac498ae$var$_.Pj = function AVd(a, b, c, d, e) {
    var f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gid(a, this.b), 215);
    return f.nl(this.a).Wj(d);
};
$61de1ee1cac498ae$var$_.Qj = function BVd(a, b, c, d, e) {
    var f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gid(a, this.b), 215);
    return f.el(this.a, d, e);
};
$61de1ee1cac498ae$var$_.Rj = function CVd(a, b, c, d, e) {
    var f;
    f = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gid(a, this.b), 215);
    return f.fl(this.a, d, e);
};
$61de1ee1cac498ae$var$_.Sj = function DVd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gid(a, this.b), 215);
    return d.nl(this.a).fj();
};
$61de1ee1cac498ae$var$_.Tj = function EVd(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gid(a, this.b), 215);
    e.nl(this.a).Wb(d);
};
$61de1ee1cac498ae$var$_.Uj = function FVd(a, b, c) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gid(a, this.b), 215).nl(this.a);
};
$61de1ee1cac498ae$var$_.Vj = function GVd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$gid(a, this.b), 215);
    d.nl(this.a).Xj();
};
var $61de1ee1cac498ae$var$A6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateFeatureMapDelegator", 1314);
$61de1ee1cac498ae$var$bcb(89, 1, {}, $61de1ee1cac498ae$var$IVd, $61de1ee1cac498ae$var$JVd, $61de1ee1cac498ae$var$KVd, $61de1ee1cac498ae$var$LVd);
$61de1ee1cac498ae$var$_.Pj = function MVd(a, b, c, d, e) {
    var f;
    f = b.Ch(c);
    f == null && b.Dh(c, f = $61de1ee1cac498ae$var$HVd(this, a));
    if (!e) switch(this.e){
        case 50:
        case 41:
            return $61de1ee1cac498ae$var$BD(f, 589).sj();
        case 40:
            return $61de1ee1cac498ae$var$BD(f, 215).kl();
    }
    return f;
};
$61de1ee1cac498ae$var$_.Qj = function NVd(a, b, c, d, e) {
    var f, g;
    g = b.Ch(c);
    g == null && b.Dh(c, g = $61de1ee1cac498ae$var$HVd(this, a));
    f = $61de1ee1cac498ae$var$BD(g, 69).lk(d, e);
    return f;
};
$61de1ee1cac498ae$var$_.Rj = function OVd(a, b, c, d, e) {
    var f;
    f = b.Ch(c);
    f != null && (e = $61de1ee1cac498ae$var$BD(f, 69).mk(d, e));
    return e;
};
$61de1ee1cac498ae$var$_.Sj = function PVd(a, b, c) {
    var d;
    d = b.Ch(c);
    return d != null && $61de1ee1cac498ae$var$BD(d, 76).fj();
};
$61de1ee1cac498ae$var$_.Tj = function QVd(a, b, c, d) {
    var e;
    e = $61de1ee1cac498ae$var$BD(b.Ch(c), 76);
    !e && b.Dh(c, e = $61de1ee1cac498ae$var$HVd(this, a));
    e.Wb(d);
};
$61de1ee1cac498ae$var$_.Uj = function RVd(a, b, c) {
    var d, e;
    e = b.Ch(c);
    e == null && b.Dh(c, e = $61de1ee1cac498ae$var$HVd(this, a));
    if ($61de1ee1cac498ae$var$JD(e, 76)) return $61de1ee1cac498ae$var$BD(e, 76);
    else {
        d = $61de1ee1cac498ae$var$BD(b.Ch(c), 15);
        return new $61de1ee1cac498ae$var$iYd(d);
    }
};
$61de1ee1cac498ae$var$_.Vj = function SVd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$BD(b.Ch(c), 76);
    !d && b.Dh(c, d = $61de1ee1cac498ae$var$HVd(this, a));
    d.Xj();
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$B6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateMany", 89);
$61de1ee1cac498ae$var$bcb(504, 1, {});
$61de1ee1cac498ae$var$_.Qj = function WVd(a, b, c, d, e) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Rj = function XVd(a, b, c, d, e) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$bgb);
};
$61de1ee1cac498ae$var$_.Uj = function YVd(a, b, c) {
    return new $61de1ee1cac498ae$var$ZVd(this, a, b, c);
};
var $61de1ee1cac498ae$var$TVd;
var $61de1ee1cac498ae$var$i7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingle", 504);
$61de1ee1cac498ae$var$bcb(1331, 1, $61de1ee1cac498ae$var$zve, $61de1ee1cac498ae$var$ZVd);
$61de1ee1cac498ae$var$_.Wj = function $Vd(a) {
    return this.a.Pj(this.c, this.d, this.b, a, true);
};
$61de1ee1cac498ae$var$_.fj = function _Vd() {
    return this.a.Sj(this.c, this.d, this.b);
};
$61de1ee1cac498ae$var$_.Wb = function aWd(a) {
    this.a.Tj(this.c, this.d, this.b, a);
};
$61de1ee1cac498ae$var$_.Xj = function bWd() {
    this.a.Vj(this.c, this.d, this.b);
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$C6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingle/1", 1331);
$61de1ee1cac498ae$var$bcb(769, 504, {}, $61de1ee1cac498ae$var$cWd);
$61de1ee1cac498ae$var$_.Pj = function dWd(a, b, c, d, e) {
    return $61de1ee1cac498ae$var$Nid(a, a.eh(), a.Vg()) == this.b ? this.sk() && d ? $61de1ee1cac498ae$var$aid(a) : a.eh() : null;
};
$61de1ee1cac498ae$var$_.Qj = function eWd(a, b, c, d, e) {
    var f, g;
    !!a.eh() && (e = (f = a.Vg(), f >= 0 ? a.Qg(e) : a.eh().ih(a, -1 - f, null, e)));
    g = $61de1ee1cac498ae$var$bLd(a.Tg(), this.e);
    return a.Sg(d, g, e);
};
$61de1ee1cac498ae$var$_.Rj = function fWd(a, b, c, d, e) {
    var f;
    f = $61de1ee1cac498ae$var$bLd(a.Tg(), this.e);
    return a.Sg(null, f, e);
};
$61de1ee1cac498ae$var$_.Sj = function gWd(a, b, c) {
    var d;
    d = $61de1ee1cac498ae$var$bLd(a.Tg(), this.e);
    return !!a.eh() && a.Vg() == d;
};
$61de1ee1cac498ae$var$_.Tj = function hWd(a, b, c, d) {
    var e, f, g, h, i;
    if (d != null && !$61de1ee1cac498ae$var$fKd(this.a, d)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cdb($61de1ee1cac498ae$var$Yve + ($61de1ee1cac498ae$var$JD(d, 56) ? $61de1ee1cac498ae$var$gLd($61de1ee1cac498ae$var$BD(d, 56).Tg()) : $61de1ee1cac498ae$var$idb($61de1ee1cac498ae$var$rb(d))) + $61de1ee1cac498ae$var$Zve + this.a + "'"));
    e = a.eh();
    g = $61de1ee1cac498ae$var$bLd(a.Tg(), this.e);
    if ($61de1ee1cac498ae$var$PD(d) !== $61de1ee1cac498ae$var$PD(e) || a.Vg() != g && d != null) {
        if ($61de1ee1cac498ae$var$p6d(a, $61de1ee1cac498ae$var$BD(d, 56))) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$ste + a.Ib()));
        i = null;
        !!e && (i = (f = a.Vg(), f >= 0 ? a.Qg(i) : a.eh().ih(a, -1 - f, null, i)));
        h = $61de1ee1cac498ae$var$BD(d, 49);
        !!h && (i = h.gh(a, $61de1ee1cac498ae$var$bLd(h.Tg(), this.b), null, i));
        i = a.Sg(h, g, i);
        !!i && i.Fi();
    } else a.Lg() && a.Mg() && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$nSd(a, 1, g, d, d));
};
$61de1ee1cac498ae$var$_.Vj = function iWd(a, b, c) {
    var d, e, f, g;
    d = a.eh();
    if (d) {
        g = (e = a.Vg(), e >= 0 ? a.Qg(null) : a.eh().ih(a, -1 - e, null, null));
        f = $61de1ee1cac498ae$var$bLd(a.Tg(), this.e);
        g = a.Sg(null, f, g);
        !!g && g.Fi();
    } else a.Lg() && a.Mg() && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$DSd(a, 1, this.e, null, null));
};
$61de1ee1cac498ae$var$_.sk = function jWd() {
    return false;
};
var $61de1ee1cac498ae$var$E6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleContainer", 769);
$61de1ee1cac498ae$var$bcb(1315, 769, {}, $61de1ee1cac498ae$var$kWd);
$61de1ee1cac498ae$var$_.sk = function lWd() {
    return true;
};
var $61de1ee1cac498ae$var$D6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleContainerResolving", 1315);
$61de1ee1cac498ae$var$bcb(563, 504, {});
$61de1ee1cac498ae$var$_.Pj = function oWd(a, b, c, d, e) {
    var f;
    return f = b.Ch(c), f == null ? this.b : $61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) ? null : f;
};
$61de1ee1cac498ae$var$_.Sj = function pWd(a, b, c) {
    var d;
    d = b.Ch(c);
    return d != null && ($61de1ee1cac498ae$var$PD(d) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) || !$61de1ee1cac498ae$var$pb(d, this.b));
};
$61de1ee1cac498ae$var$_.Tj = function qWd(a, b, c, d) {
    var e, f;
    if (a.Lg() && a.Mg()) {
        e = (f = b.Ch(c), f == null ? this.b : $61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) ? null : f);
        if (d == null) {
            if (this.c != null) {
                b.Dh(c, null);
                d = this.b;
            } else this.b != null ? b.Dh(c, $61de1ee1cac498ae$var$TVd) : b.Dh(c, null);
        } else {
            this.Sk(d);
            b.Dh(c, d);
        }
        $61de1ee1cac498ae$var$Uhd(a, this.d.Tk(a, 1, this.e, e, d));
    } else if (d == null) this.c != null ? b.Dh(c, null) : this.b != null ? b.Dh(c, $61de1ee1cac498ae$var$TVd) : b.Dh(c, null);
    else {
        this.Sk(d);
        b.Dh(c, d);
    }
};
$61de1ee1cac498ae$var$_.Vj = function rWd(a, b, c) {
    var d, e;
    if (a.Lg() && a.Mg()) {
        d = (e = b.Ch(c), e == null ? this.b : $61de1ee1cac498ae$var$PD(e) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) ? null : e);
        b.Eh(c);
        $61de1ee1cac498ae$var$Uhd(a, this.d.Tk(a, 1, this.e, d, this.b));
    } else b.Eh(c);
};
$61de1ee1cac498ae$var$_.Sk = function sWd(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Bdb);
};
var $61de1ee1cac498ae$var$T6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData", 563);
$61de1ee1cac498ae$var$bcb($61de1ee1cac498ae$var$$ve, 1, {}, $61de1ee1cac498ae$var$DWd);
$61de1ee1cac498ae$var$_.Tk = function EWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$DSd(a, b, c, d, e);
};
$61de1ee1cac498ae$var$_.Uk = function FWd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$FSd(a, b, c, d, e, f);
};
var $61de1ee1cac498ae$var$tWd, $61de1ee1cac498ae$var$uWd, $61de1ee1cac498ae$var$vWd, $61de1ee1cac498ae$var$wWd, $61de1ee1cac498ae$var$xWd, $61de1ee1cac498ae$var$yWd, $61de1ee1cac498ae$var$zWd, $61de1ee1cac498ae$var$AWd, $61de1ee1cac498ae$var$BWd;
var $61de1ee1cac498ae$var$N6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator", $61de1ee1cac498ae$var$$ve);
$61de1ee1cac498ae$var$bcb(1332, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$GWd);
$61de1ee1cac498ae$var$_.Tk = function HWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$ISd(a, b, c, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(d)), $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(e)));
};
$61de1ee1cac498ae$var$_.Uk = function IWd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$JSd(a, b, c, $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(d)), $61de1ee1cac498ae$var$Ccb($61de1ee1cac498ae$var$DD(e)), f);
};
var $61de1ee1cac498ae$var$F6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/1", 1332);
$61de1ee1cac498ae$var$bcb(1333, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$JWd);
$61de1ee1cac498ae$var$_.Tk = function KWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$rSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 217).a, $61de1ee1cac498ae$var$BD(e, 217).a);
};
$61de1ee1cac498ae$var$_.Uk = function LWd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$sSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 217).a, $61de1ee1cac498ae$var$BD(e, 217).a, f);
};
var $61de1ee1cac498ae$var$G6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/2", 1333);
$61de1ee1cac498ae$var$bcb(1334, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$MWd);
$61de1ee1cac498ae$var$_.Tk = function NWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$tSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 172).a, $61de1ee1cac498ae$var$BD(e, 172).a);
};
$61de1ee1cac498ae$var$_.Uk = function OWd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$uSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 172).a, $61de1ee1cac498ae$var$BD(e, 172).a, f);
};
var $61de1ee1cac498ae$var$H6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/3", 1334);
$61de1ee1cac498ae$var$bcb(1335, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$PWd);
$61de1ee1cac498ae$var$_.Tk = function QWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$vSd(a, b, c, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d)), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(e)));
};
$61de1ee1cac498ae$var$_.Uk = function RWd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$wSd(a, b, c, $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(d)), $61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(e)), f);
};
var $61de1ee1cac498ae$var$I6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/4", 1335);
$61de1ee1cac498ae$var$bcb(1336, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$SWd);
$61de1ee1cac498ae$var$_.Tk = function TWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$xSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 155).a, $61de1ee1cac498ae$var$BD(e, 155).a);
};
$61de1ee1cac498ae$var$_.Uk = function UWd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$ySd(a, b, c, $61de1ee1cac498ae$var$BD(d, 155).a, $61de1ee1cac498ae$var$BD(e, 155).a, f);
};
var $61de1ee1cac498ae$var$J6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/5", 1336);
$61de1ee1cac498ae$var$bcb(1337, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$VWd);
$61de1ee1cac498ae$var$_.Tk = function WWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$zSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 19).a, $61de1ee1cac498ae$var$BD(e, 19).a);
};
$61de1ee1cac498ae$var$_.Uk = function XWd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$ASd(a, b, c, $61de1ee1cac498ae$var$BD(d, 19).a, $61de1ee1cac498ae$var$BD(e, 19).a, f);
};
var $61de1ee1cac498ae$var$K6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/6", 1337);
$61de1ee1cac498ae$var$bcb(1338, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$YWd);
$61de1ee1cac498ae$var$_.Tk = function ZWd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$BSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 162).a, $61de1ee1cac498ae$var$BD(e, 162).a);
};
$61de1ee1cac498ae$var$_.Uk = function $Wd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$CSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 162).a, $61de1ee1cac498ae$var$BD(e, 162).a, f);
};
var $61de1ee1cac498ae$var$L6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/7", 1338);
$61de1ee1cac498ae$var$bcb(1339, $61de1ee1cac498ae$var$$ve, {}, $61de1ee1cac498ae$var$_Wd);
$61de1ee1cac498ae$var$_.Tk = function aXd(a, b, c, d, e) {
    return new $61de1ee1cac498ae$var$GSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 184).a, $61de1ee1cac498ae$var$BD(e, 184).a);
};
$61de1ee1cac498ae$var$_.Uk = function bXd(a, b, c, d, e, f) {
    return new $61de1ee1cac498ae$var$HSd(a, b, c, $61de1ee1cac498ae$var$BD(d, 184).a, $61de1ee1cac498ae$var$BD(e, 184).a, f);
};
var $61de1ee1cac498ae$var$M6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleData/NotificationCreator/8", 1339);
$61de1ee1cac498ae$var$bcb(1317, 563, {}, $61de1ee1cac498ae$var$cXd);
$61de1ee1cac498ae$var$_.Sk = function dXd(a) {
    if (!this.a.wj(a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cdb($61de1ee1cac498ae$var$Yve + $61de1ee1cac498ae$var$rb(a) + $61de1ee1cac498ae$var$Zve + this.a + "'"));
};
var $61de1ee1cac498ae$var$O6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleDataDynamic", 1317);
$61de1ee1cac498ae$var$bcb(1318, 563, {}, $61de1ee1cac498ae$var$eXd);
$61de1ee1cac498ae$var$_.Sk = function fXd(a) {};
var $61de1ee1cac498ae$var$P6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleDataStatic", 1318);
$61de1ee1cac498ae$var$bcb(770, 563, {});
$61de1ee1cac498ae$var$_.Sj = function gXd(a, b, c) {
    var d;
    d = b.Ch(c);
    return d != null;
};
$61de1ee1cac498ae$var$_.Tj = function hXd(a, b, c, d) {
    var e, f;
    if (a.Lg() && a.Mg()) {
        e = true;
        f = b.Ch(c);
        if (f == null) {
            e = false;
            f = this.b;
        } else $61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) && (f = null);
        if (d == null) {
            if (this.c != null) {
                b.Dh(c, null);
                d = this.b;
            } else b.Dh(c, $61de1ee1cac498ae$var$TVd);
        } else {
            this.Sk(d);
            b.Dh(c, d);
        }
        $61de1ee1cac498ae$var$Uhd(a, this.d.Uk(a, 1, this.e, f, d, !e));
    } else if (d == null) this.c != null ? b.Dh(c, null) : b.Dh(c, $61de1ee1cac498ae$var$TVd);
    else {
        this.Sk(d);
        b.Dh(c, d);
    }
};
$61de1ee1cac498ae$var$_.Vj = function iXd(a, b, c) {
    var d, e;
    if (a.Lg() && a.Mg()) {
        d = true;
        e = b.Ch(c);
        if (e == null) {
            d = false;
            e = this.b;
        } else $61de1ee1cac498ae$var$PD(e) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) && (e = null);
        b.Eh(c);
        $61de1ee1cac498ae$var$Uhd(a, this.d.Uk(a, 2, this.e, e, this.b, d));
    } else b.Eh(c);
};
var $61de1ee1cac498ae$var$S6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettable", 770);
$61de1ee1cac498ae$var$bcb(1319, 770, {}, $61de1ee1cac498ae$var$jXd);
$61de1ee1cac498ae$var$_.Sk = function kXd(a) {
    if (!this.a.wj(a)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cdb($61de1ee1cac498ae$var$Yve + $61de1ee1cac498ae$var$rb(a) + $61de1ee1cac498ae$var$Zve + this.a + "'"));
};
var $61de1ee1cac498ae$var$Q6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableDynamic", 1319);
$61de1ee1cac498ae$var$bcb(1320, 770, {}, $61de1ee1cac498ae$var$lXd);
$61de1ee1cac498ae$var$_.Sk = function mXd(a) {};
var $61de1ee1cac498ae$var$R6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleDataUnsettableStatic", 1320);
$61de1ee1cac498ae$var$bcb(398, 504, {}, $61de1ee1cac498ae$var$nXd);
$61de1ee1cac498ae$var$_.Pj = function pXd(a, b, c, d, e) {
    var f, g, h, i, j;
    j = b.Ch(c);
    if (this.Kj() && $61de1ee1cac498ae$var$PD(j) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd)) return null;
    else if (this.sk() && d && j != null) {
        h = $61de1ee1cac498ae$var$BD(j, 49);
        if (h.kh()) {
            i = $61de1ee1cac498ae$var$xid(a, h);
            if (h != i) {
                if (!$61de1ee1cac498ae$var$fKd(this.a, i)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cdb($61de1ee1cac498ae$var$Yve + $61de1ee1cac498ae$var$rb(i) + $61de1ee1cac498ae$var$Zve + this.a + "'"));
                b.Dh(c, j = i);
                if (this.rk()) {
                    f = $61de1ee1cac498ae$var$BD(i, 49);
                    g = h.ih(a, !this.b ? -1 - $61de1ee1cac498ae$var$bLd(a.Tg(), this.e) : $61de1ee1cac498ae$var$bLd(h.Tg(), this.b), null, null);
                    !f.eh() && (g = f.gh(a, !this.b ? -1 - $61de1ee1cac498ae$var$bLd(a.Tg(), this.e) : $61de1ee1cac498ae$var$bLd(f.Tg(), this.b), null, g));
                    !!g && g.Fi();
                }
                a.Lg() && a.Mg() && $61de1ee1cac498ae$var$Uhd(a, new $61de1ee1cac498ae$var$DSd(a, 9, this.e, h, i));
            }
        }
        return j;
    } else return j;
};
$61de1ee1cac498ae$var$_.Qj = function qXd(a, b, c, d, e) {
    var f, g;
    g = b.Ch(c);
    $61de1ee1cac498ae$var$PD(g) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) && (g = null);
    b.Dh(c, d);
    if (this.bj()) {
        if ($61de1ee1cac498ae$var$PD(g) !== $61de1ee1cac498ae$var$PD(d) && g != null) {
            f = $61de1ee1cac498ae$var$BD(g, 49);
            e = f.ih(a, $61de1ee1cac498ae$var$bLd(f.Tg(), this.b), null, e);
        }
    } else this.rk() && g != null && (e = $61de1ee1cac498ae$var$BD(g, 49).ih(a, -1 - $61de1ee1cac498ae$var$bLd(a.Tg(), this.e), null, e));
    if (a.Lg() && a.Mg()) {
        !e && (e = new $61de1ee1cac498ae$var$Ixd(4));
        e.Ei(new $61de1ee1cac498ae$var$DSd(a, 1, this.e, g, d));
    }
    return e;
};
$61de1ee1cac498ae$var$_.Rj = function rXd(a, b, c, d, e) {
    var f;
    f = b.Ch(c);
    $61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) && (f = null);
    b.Eh(c);
    if (a.Lg() && a.Mg()) {
        !e && (e = new $61de1ee1cac498ae$var$Ixd(4));
        this.Kj() ? e.Ei(new $61de1ee1cac498ae$var$DSd(a, 2, this.e, f, null)) : e.Ei(new $61de1ee1cac498ae$var$DSd(a, 1, this.e, f, null));
    }
    return e;
};
$61de1ee1cac498ae$var$_.Sj = function sXd(a, b, c) {
    var d;
    d = b.Ch(c);
    return d != null;
};
$61de1ee1cac498ae$var$_.Tj = function tXd(a, b, c, d) {
    var e, f, g, h, i;
    if (d != null && !$61de1ee1cac498ae$var$fKd(this.a, d)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Cdb($61de1ee1cac498ae$var$Yve + ($61de1ee1cac498ae$var$JD(d, 56) ? $61de1ee1cac498ae$var$gLd($61de1ee1cac498ae$var$BD(d, 56).Tg()) : $61de1ee1cac498ae$var$idb($61de1ee1cac498ae$var$rb(d))) + $61de1ee1cac498ae$var$Zve + this.a + "'"));
    i = b.Ch(c);
    h = i != null;
    this.Kj() && $61de1ee1cac498ae$var$PD(i) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) && (i = null);
    g = null;
    if (this.bj()) {
        if ($61de1ee1cac498ae$var$PD(i) !== $61de1ee1cac498ae$var$PD(d)) {
            if (i != null) {
                e = $61de1ee1cac498ae$var$BD(i, 49);
                g = e.ih(a, $61de1ee1cac498ae$var$bLd(e.Tg(), this.b), null, g);
            }
            if (d != null) {
                e = $61de1ee1cac498ae$var$BD(d, 49);
                g = e.gh(a, $61de1ee1cac498ae$var$bLd(e.Tg(), this.b), null, g);
            }
        }
    } else if (this.rk()) {
        if ($61de1ee1cac498ae$var$PD(i) !== $61de1ee1cac498ae$var$PD(d)) {
            i != null && (g = $61de1ee1cac498ae$var$BD(i, 49).ih(a, -1 - $61de1ee1cac498ae$var$bLd(a.Tg(), this.e), null, g));
            d != null && (g = $61de1ee1cac498ae$var$BD(d, 49).gh(a, -1 - $61de1ee1cac498ae$var$bLd(a.Tg(), this.e), null, g));
        }
    }
    d == null && this.Kj() ? b.Dh(c, $61de1ee1cac498ae$var$TVd) : b.Dh(c, d);
    if (a.Lg() && a.Mg()) {
        f = new $61de1ee1cac498ae$var$FSd(a, 1, this.e, i, d, this.Kj() && !h);
        if (!g) $61de1ee1cac498ae$var$Uhd(a, f);
        else {
            g.Ei(f);
            g.Fi();
        }
    } else !!g && g.Fi();
};
$61de1ee1cac498ae$var$_.Vj = function uXd(a, b, c) {
    var d, e, f, g, h;
    h = b.Ch(c);
    g = h != null;
    this.Kj() && $61de1ee1cac498ae$var$PD(h) === $61de1ee1cac498ae$var$PD($61de1ee1cac498ae$var$TVd) && (h = null);
    f = null;
    if (h != null) {
        if (this.bj()) {
            d = $61de1ee1cac498ae$var$BD(h, 49);
            f = d.ih(a, $61de1ee1cac498ae$var$bLd(d.Tg(), this.b), null, f);
        } else this.rk() && (f = $61de1ee1cac498ae$var$BD(h, 49).ih(a, -1 - $61de1ee1cac498ae$var$bLd(a.Tg(), this.e), null, f));
    }
    b.Eh(c);
    if (a.Lg() && a.Mg()) {
        e = new $61de1ee1cac498ae$var$FSd(a, this.Kj() ? 2 : 1, this.e, h, null, g);
        if (!f) $61de1ee1cac498ae$var$Uhd(a, e);
        else {
            f.Ei(e);
            f.Fi();
        }
    } else !!f && f.Fi();
};
$61de1ee1cac498ae$var$_.bj = function vXd() {
    return false;
};
$61de1ee1cac498ae$var$_.rk = function wXd() {
    return false;
};
$61de1ee1cac498ae$var$_.sk = function xXd() {
    return false;
};
$61de1ee1cac498ae$var$_.Kj = function yXd() {
    return false;
};
var $61de1ee1cac498ae$var$h7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObject", 398);
$61de1ee1cac498ae$var$bcb(564, 398, {}, $61de1ee1cac498ae$var$zXd);
$61de1ee1cac498ae$var$_.rk = function AXd() {
    return true;
};
var $61de1ee1cac498ae$var$_6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainment", 564);
$61de1ee1cac498ae$var$bcb(1323, 564, {}, $61de1ee1cac498ae$var$BXd);
$61de1ee1cac498ae$var$_.sk = function CXd() {
    return true;
};
var $61de1ee1cac498ae$var$U6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentResolving", 1323);
$61de1ee1cac498ae$var$bcb(772, 564, {}, $61de1ee1cac498ae$var$DXd);
$61de1ee1cac498ae$var$_.Kj = function EXd() {
    return true;
};
var $61de1ee1cac498ae$var$W6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettable", 772);
$61de1ee1cac498ae$var$bcb(1325, 772, {}, $61de1ee1cac498ae$var$FXd);
$61de1ee1cac498ae$var$_.sk = function GXd() {
    return true;
};
var $61de1ee1cac498ae$var$V6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentUnsettableResolving", 1325);
$61de1ee1cac498ae$var$bcb(640, 564, {}, $61de1ee1cac498ae$var$HXd);
$61de1ee1cac498ae$var$_.bj = function IXd() {
    return true;
};
var $61de1ee1cac498ae$var$$6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverse", 640);
$61de1ee1cac498ae$var$bcb(1324, 640, {}, $61de1ee1cac498ae$var$JXd);
$61de1ee1cac498ae$var$_.sk = function KXd() {
    return true;
};
var $61de1ee1cac498ae$var$X6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseResolving", 1324);
$61de1ee1cac498ae$var$bcb(773, 640, {}, $61de1ee1cac498ae$var$LXd);
$61de1ee1cac498ae$var$_.Kj = function MXd() {
    return true;
};
var $61de1ee1cac498ae$var$Z6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettable", 773);
$61de1ee1cac498ae$var$bcb(1326, 773, {}, $61de1ee1cac498ae$var$NXd);
$61de1ee1cac498ae$var$_.sk = function OXd() {
    return true;
};
var $61de1ee1cac498ae$var$Y6 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectContainmentWithInverseUnsettableResolving", 1326);
$61de1ee1cac498ae$var$bcb(641, 398, {}, $61de1ee1cac498ae$var$PXd);
$61de1ee1cac498ae$var$_.sk = function QXd() {
    return true;
};
var $61de1ee1cac498ae$var$d7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolving", 641);
$61de1ee1cac498ae$var$bcb(1327, 641, {}, $61de1ee1cac498ae$var$RXd);
$61de1ee1cac498ae$var$_.Kj = function SXd() {
    return true;
};
var $61de1ee1cac498ae$var$a7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingUnsettable", 1327);
$61de1ee1cac498ae$var$bcb(774, 641, {}, $61de1ee1cac498ae$var$TXd);
$61de1ee1cac498ae$var$_.bj = function UXd() {
    return true;
};
var $61de1ee1cac498ae$var$c7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverse", 774);
$61de1ee1cac498ae$var$bcb(1328, 774, {}, $61de1ee1cac498ae$var$VXd);
$61de1ee1cac498ae$var$_.Kj = function WXd() {
    return true;
};
var $61de1ee1cac498ae$var$b7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectResolvingWithInverseUnsettable", 1328);
$61de1ee1cac498ae$var$bcb(1321, 398, {}, $61de1ee1cac498ae$var$XXd);
$61de1ee1cac498ae$var$_.Kj = function YXd() {
    return true;
};
var $61de1ee1cac498ae$var$e7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectUnsettable", 1321);
$61de1ee1cac498ae$var$bcb(771, 398, {}, $61de1ee1cac498ae$var$ZXd);
$61de1ee1cac498ae$var$_.bj = function $Xd() {
    return true;
};
var $61de1ee1cac498ae$var$g7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverse", 771);
$61de1ee1cac498ae$var$bcb(1322, 771, {}, $61de1ee1cac498ae$var$_Xd);
$61de1ee1cac498ae$var$_.Kj = function aYd() {
    return true;
};
var $61de1ee1cac498ae$var$f7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InternalSettingDelegateSingleEObjectWithInverseUnsettable", 1322);
$61de1ee1cac498ae$var$bcb(775, 565, $61de1ee1cac498ae$var$Xve, $61de1ee1cac498ae$var$dYd);
$61de1ee1cac498ae$var$_.Pk = function eYd(a) {
    return new $61de1ee1cac498ae$var$dYd(this.a, this.c, a);
};
$61de1ee1cac498ae$var$_.dd = function fYd() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Qk = function gYd(a, b, c) {
    return $61de1ee1cac498ae$var$bYd(this, a, this.b, c);
};
$61de1ee1cac498ae$var$_.Rk = function hYd(a, b, c) {
    return $61de1ee1cac498ae$var$cYd(this, a, this.b, c);
};
var $61de1ee1cac498ae$var$j7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/InverseUpdatingFeatureMapEntry", 775);
$61de1ee1cac498ae$var$bcb(1329, 1, $61de1ee1cac498ae$var$zve, $61de1ee1cac498ae$var$iYd);
$61de1ee1cac498ae$var$_.Wj = function jYd(a) {
    return this.a;
};
$61de1ee1cac498ae$var$_.fj = function kYd() {
    return $61de1ee1cac498ae$var$JD(this.a, 95) ? $61de1ee1cac498ae$var$BD(this.a, 95).fj() : !this.a.dc();
};
$61de1ee1cac498ae$var$_.Wb = function lYd(a) {
    this.a.$b();
    this.a.Gc($61de1ee1cac498ae$var$BD(a, 15));
};
$61de1ee1cac498ae$var$_.Xj = function mYd() {
    $61de1ee1cac498ae$var$JD(this.a, 95) ? $61de1ee1cac498ae$var$BD(this.a, 95).Xj() : this.a.$b();
};
var $61de1ee1cac498ae$var$k7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/SettingMany", 1329);
$61de1ee1cac498ae$var$bcb(1330, 565, $61de1ee1cac498ae$var$Xve, $61de1ee1cac498ae$var$nYd);
$61de1ee1cac498ae$var$_.Ok = function oYd(a) {
    return new $61de1ee1cac498ae$var$sYd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$P8d), this.b.Ih(this.a, a));
};
$61de1ee1cac498ae$var$_.dd = function pYd() {
    return null;
};
$61de1ee1cac498ae$var$_.Qk = function qYd(a, b, c) {
    return c;
};
$61de1ee1cac498ae$var$_.Rk = function rYd(a, b, c) {
    return c;
};
var $61de1ee1cac498ae$var$l7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/SimpleContentFeatureMapEntry", 1330);
$61de1ee1cac498ae$var$bcb(642, 565, $61de1ee1cac498ae$var$Xve, $61de1ee1cac498ae$var$sYd);
$61de1ee1cac498ae$var$_.Ok = function tYd(a) {
    return new $61de1ee1cac498ae$var$sYd(this.c, a);
};
$61de1ee1cac498ae$var$_.dd = function uYd() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Qk = function vYd(a, b, c) {
    return c;
};
$61de1ee1cac498ae$var$_.Rk = function wYd(a, b, c) {
    return c;
};
var $61de1ee1cac498ae$var$m7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EStructuralFeatureImpl/SimpleFeatureMapEntry", 642);
$61de1ee1cac498ae$var$bcb(391, 497, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$xYd);
$61de1ee1cac498ae$var$_.ri = function yYd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$c5, $61de1ee1cac498ae$var$Uhe, 26, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function zYd() {
    return false;
};
var $61de1ee1cac498ae$var$o7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ESuperAdapter/1", 391);
$61de1ee1cac498ae$var$bcb(444, 438, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    108: 1,
    836: 1,
    49: 1,
    97: 1,
    150: 1,
    444: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$BYd);
$61de1ee1cac498ae$var$_._g = function CYd(a, b, c) {
    var d;
    switch(a){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), this.Ab;
        case 1:
            return this.zb;
        case 2:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$KYd(this, $61de1ee1cac498ae$var$j5, this)), this.a;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$iGd)), $61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? $61de1ee1cac498ae$var$iGd : d), a), b, c);
};
$61de1ee1cac498ae$var$_.jh = function DYd(a, b, c) {
    var d, e;
    switch(b){
        case 0:
            return !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3)), $61de1ee1cac498ae$var$Txd(this.Ab, a, c);
        case 2:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$KYd(this, $61de1ee1cac498ae$var$j5, this)), $61de1ee1cac498ae$var$Txd(this.a, a, c);
    }
    return e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !d ? ($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$iGd) : d), b), 66), e.Nj().Rj(this, $61de1ee1cac498ae$var$yjd(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$iGd)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function EYd(a) {
    var b;
    switch(a){
        case 0:
            return !!this.Ab && this.Ab.i != 0;
        case 1:
            return this.zb != null;
        case 2:
            return !!this.a && this.a.i != 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$iGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$iGd : b), a));
};
$61de1ee1cac498ae$var$_.sh = function FYd(a, b) {
    var c;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$ytd(this.Ab, $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 2:
            !this.a && (this.a = new $61de1ee1cac498ae$var$KYd(this, $61de1ee1cac498ae$var$j5, this));
            $61de1ee1cac498ae$var$Uxd(this.a);
            !this.a && (this.a = new $61de1ee1cac498ae$var$KYd(this, $61de1ee1cac498ae$var$j5, this));
            $61de1ee1cac498ae$var$ytd(this.a, $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$iGd)), $61de1ee1cac498ae$var$XKd((c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !c ? $61de1ee1cac498ae$var$iGd : c), a), b);
};
$61de1ee1cac498ae$var$_.zh = function GYd() {
    return $61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$iGd;
};
$61de1ee1cac498ae$var$_.Bh = function HYd(a) {
    var b;
    switch(a){
        case 0:
            !this.Ab && (this.Ab = new $61de1ee1cac498ae$var$cUd($61de1ee1cac498ae$var$a5, this, 0, 3));
            $61de1ee1cac498ae$var$Uxd(this.Ab);
            return;
        case 1:
            $61de1ee1cac498ae$var$pnd(this, null);
            return;
        case 2:
            !this.a && (this.a = new $61de1ee1cac498ae$var$KYd(this, $61de1ee1cac498ae$var$j5, this));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$iGd)), $61de1ee1cac498ae$var$XKd((b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Ajd(this, 16), 26), !b ? $61de1ee1cac498ae$var$iGd : b), a));
};
var $61de1ee1cac498ae$var$u7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ETypeParameterImpl", 444);
$61de1ee1cac498ae$var$bcb(445, 85, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$KYd);
$61de1ee1cac498ae$var$_.cj = function LYd(a, b) {
    return $61de1ee1cac498ae$var$IYd(this, $61de1ee1cac498ae$var$BD(a, 87), b);
};
$61de1ee1cac498ae$var$_.dj = function MYd(a, b) {
    return $61de1ee1cac498ae$var$JYd(this, $61de1ee1cac498ae$var$BD(a, 87), b);
};
var $61de1ee1cac498ae$var$q7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ETypeParameterImpl/1", 445);
$61de1ee1cac498ae$var$bcb(634, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$NYd);
$61de1ee1cac498ae$var$_.ec = function OYd() {
    return new $61de1ee1cac498ae$var$RYd(this);
};
var $61de1ee1cac498ae$var$t7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ETypeParameterImpl/2", 634);
$61de1ee1cac498ae$var$bcb(556, $61de1ee1cac498ae$var$eie, $61de1ee1cac498ae$var$fie, $61de1ee1cac498ae$var$RYd);
$61de1ee1cac498ae$var$_.Fc = function SYd(a) {
    return $61de1ee1cac498ae$var$PYd(this, $61de1ee1cac498ae$var$BD(a, 87));
};
$61de1ee1cac498ae$var$_.Gc = function TYd(a) {
    var b, c, d;
    d = false;
    for(c = a.Kc(); c.Ob();){
        b = $61de1ee1cac498ae$var$BD(c.Pb(), 87);
        $61de1ee1cac498ae$var$Rhb(this.a, b, "") == null && (d = true);
    }
    return d;
};
$61de1ee1cac498ae$var$_.$b = function UYd() {
    $61de1ee1cac498ae$var$Uhb(this.a);
};
$61de1ee1cac498ae$var$_.Hc = function VYd(a) {
    return $61de1ee1cac498ae$var$Mhb(this.a, a);
};
$61de1ee1cac498ae$var$_.Kc = function WYd() {
    var a;
    return a = new $61de1ee1cac498ae$var$nib(new $61de1ee1cac498ae$var$eib(this.a).a), new $61de1ee1cac498ae$var$ZYd(a);
};
$61de1ee1cac498ae$var$_.Mc = function XYd(a) {
    return $61de1ee1cac498ae$var$QYd(this, a);
};
$61de1ee1cac498ae$var$_.gc = function YYd() {
    return $61de1ee1cac498ae$var$Vhb(this.a);
};
var $61de1ee1cac498ae$var$s7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ETypeParameterImpl/2/1", 556);
$61de1ee1cac498ae$var$bcb(557, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$ZYd);
$61de1ee1cac498ae$var$_.Nb = function $Yd(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function aZd() {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$lib(this.a).cd(), 87);
};
$61de1ee1cac498ae$var$_.Ob = function _Yd() {
    return this.a.b;
};
$61de1ee1cac498ae$var$_.Qb = function bZd() {
    $61de1ee1cac498ae$var$mib(this.a);
};
var $61de1ee1cac498ae$var$r7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "ETypeParameterImpl/2/1/1", 557);
$61de1ee1cac498ae$var$bcb(1276, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$cZd);
$61de1ee1cac498ae$var$_._b = function dZd(a) {
    return $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$Qhb(this, a) : !!$61de1ee1cac498ae$var$irb(this.f, a);
};
$61de1ee1cac498ae$var$_.xc = function eZd(a) {
    var b, c;
    b = $61de1ee1cac498ae$var$ND(a) ? $61de1ee1cac498ae$var$Phb(this, a) : $61de1ee1cac498ae$var$Wd($61de1ee1cac498ae$var$irb(this.f, a));
    if ($61de1ee1cac498ae$var$JD(b, 837)) {
        c = $61de1ee1cac498ae$var$BD(b, 837);
        b = c._j();
        $61de1ee1cac498ae$var$Rhb(this, $61de1ee1cac498ae$var$BD(a, 235), b);
        return b;
    } else return b != null ? b : a == null ? ($61de1ee1cac498ae$var$g5d(), $61de1ee1cac498ae$var$f5d) : null;
};
var $61de1ee1cac498ae$var$w7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EValidatorRegistryImpl", 1276);
$61de1ee1cac498ae$var$bcb(1313, 704, {
    105: 1,
    92: 1,
    90: 1,
    471: 1,
    147: 1,
    56: 1,
    108: 1,
    1941: 1,
    49: 1,
    97: 1,
    150: 1,
    114: 1,
    115: 1
}, $61de1ee1cac498ae$var$mZd);
$61de1ee1cac498ae$var$_.Ih = function nZd(a, b) {
    switch(a.yj()){
        case 21:
        case 22:
        case 23:
        case 24:
        case 26:
        case 31:
        case 32:
        case 37:
        case 38:
        case 39:
        case 40:
        case 43:
        case 44:
        case 48:
        case 49:
        case 20:
            return b == null ? null : $61de1ee1cac498ae$var$fcb(b);
        case 25:
            return $61de1ee1cac498ae$var$gZd(b);
        case 27:
            return $61de1ee1cac498ae$var$hZd(b);
        case 28:
            return $61de1ee1cac498ae$var$iZd(b);
        case 29:
            return b == null ? null : $61de1ee1cac498ae$var$CQd($61de1ee1cac498ae$var$Pmd[0], $61de1ee1cac498ae$var$BD(b, 199));
        case 41:
            return b == null ? "" : $61de1ee1cac498ae$var$hdb($61de1ee1cac498ae$var$BD(b, 290));
        case 42:
            return $61de1ee1cac498ae$var$fcb(b);
        case 50:
            return $61de1ee1cac498ae$var$GD(b);
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + a.ne() + $61de1ee1cac498ae$var$ute));
    }
};
$61de1ee1cac498ae$var$_.Jh = function oZd(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m, n, o, p, q;
    switch(a.G == -1 && (a.G = (m = $61de1ee1cac498ae$var$bKd(a), m ? $61de1ee1cac498ae$var$HLd(m.Mh(), a) : -1)), a.G){
        case 0:
            return c = new $61de1ee1cac498ae$var$OJd, c;
        case 1:
            return b = new $61de1ee1cac498ae$var$RHd, b;
        case 2:
            return d = new $61de1ee1cac498ae$var$hLd, d;
        case 4:
            return e = new $61de1ee1cac498ae$var$MPd, e;
        case 5:
            return f = new $61de1ee1cac498ae$var$aQd, f;
        case 6:
            return g = new $61de1ee1cac498ae$var$rQd, g;
        case 7:
            return h = new $61de1ee1cac498ae$var$$md, h;
        case 10:
            return j = new $61de1ee1cac498ae$var$MGd, j;
        case 11:
            return k = new $61de1ee1cac498ae$var$SSd, k;
        case 12:
            return l = new $61de1ee1cac498ae$var$eod, l;
        case 13:
            return n = new $61de1ee1cac498ae$var$rUd, n;
        case 14:
            return o = new $61de1ee1cac498ae$var$FUd, o;
        case 17:
            return p = new $61de1ee1cac498ae$var$XUd, p;
        case 18:
            return i = new $61de1ee1cac498ae$var$UQd, i;
        case 19:
            return q = new $61de1ee1cac498ae$var$BYd, q;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$xte + a.zb + $61de1ee1cac498ae$var$ute));
    }
};
$61de1ee1cac498ae$var$_.Kh = function pZd(a, b) {
    switch(a.yj()){
        case 20:
            return b == null ? null : new $61de1ee1cac498ae$var$tgb(b);
        case 21:
            return b == null ? null : new $61de1ee1cac498ae$var$Ygb(b);
        case 23:
        case 22:
            return b == null ? null : $61de1ee1cac498ae$var$fZd(b);
        case 26:
        case 24:
            return b == null ? null : $61de1ee1cac498ae$var$Scb($61de1ee1cac498ae$var$Icb(b, -128, 127) << 24 >> 24);
        case 25:
            return $61de1ee1cac498ae$var$Xmd(b);
        case 27:
            return $61de1ee1cac498ae$var$jZd(b);
        case 28:
            return $61de1ee1cac498ae$var$kZd(b);
        case 29:
            return $61de1ee1cac498ae$var$lZd(b);
        case 32:
        case 31:
            return b == null ? null : $61de1ee1cac498ae$var$Hcb(b);
        case 38:
        case 37:
            return b == null ? null : new $61de1ee1cac498ae$var$Odb(b);
        case 40:
        case 39:
            return b == null ? null : $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Icb(b, $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe));
        case 41:
            return null;
        case 42:
            return b == null ? null : null;
        case 44:
        case 43:
            return b == null ? null : $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$Jcb(b));
        case 49:
        case 48:
            return b == null ? null : $61de1ee1cac498ae$var$Web($61de1ee1cac498ae$var$Icb(b, $61de1ee1cac498ae$var$awe, 32767) << 16 >> 16);
        case 50:
            return b;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + a.ne() + $61de1ee1cac498ae$var$ute));
    }
};
var $61de1ee1cac498ae$var$x7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcoreFactoryImpl", 1313);
$61de1ee1cac498ae$var$bcb(547, 179, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    235: 1,
    108: 1,
    1939: 1,
    49: 1,
    97: 1,
    150: 1,
    179: 1,
    547: 1,
    114: 1,
    115: 1,
    675: 1
}, $61de1ee1cac498ae$var$AZd);
$61de1ee1cac498ae$var$_.gb = false;
$61de1ee1cac498ae$var$_.hb = false;
var $61de1ee1cac498ae$var$rZd, $61de1ee1cac498ae$var$sZd = false;
var $61de1ee1cac498ae$var$o8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl", 547);
$61de1ee1cac498ae$var$bcb(1184, 1, {
    837: 1
}, $61de1ee1cac498ae$var$EZd);
$61de1ee1cac498ae$var$_._j = function FZd() {
    return $61de1ee1cac498ae$var$I6d(), $61de1ee1cac498ae$var$H6d;
};
var $61de1ee1cac498ae$var$I7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/1", 1184);
$61de1ee1cac498ae$var$bcb(1193, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$GZd);
$61de1ee1cac498ae$var$_.wj = function HZd(a) {
    return $61de1ee1cac498ae$var$JD(a, 147);
};
$61de1ee1cac498ae$var$_.xj = function IZd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$k5, $61de1ee1cac498ae$var$Uhe, 147, a, 0, 1);
};
var $61de1ee1cac498ae$var$y7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/10", 1193);
$61de1ee1cac498ae$var$bcb(1194, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$JZd);
$61de1ee1cac498ae$var$_.wj = function KZd(a) {
    return $61de1ee1cac498ae$var$JD(a, 191);
};
$61de1ee1cac498ae$var$_.xj = function LZd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$l5, $61de1ee1cac498ae$var$Uhe, 191, a, 0, 1);
};
var $61de1ee1cac498ae$var$z7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/11", 1194);
$61de1ee1cac498ae$var$bcb(1195, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$MZd);
$61de1ee1cac498ae$var$_.wj = function NZd(a) {
    return $61de1ee1cac498ae$var$JD(a, 56);
};
$61de1ee1cac498ae$var$_.xj = function OZd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$m5, $61de1ee1cac498ae$var$Uhe, 56, a, 0, 1);
};
var $61de1ee1cac498ae$var$A7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/12", 1195);
$61de1ee1cac498ae$var$bcb(1196, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$PZd);
$61de1ee1cac498ae$var$_.wj = function QZd(a) {
    return $61de1ee1cac498ae$var$JD(a, 399);
};
$61de1ee1cac498ae$var$_.xj = function RZd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$n5, $61de1ee1cac498ae$var$Nve, 59, a, 0, 1);
};
var $61de1ee1cac498ae$var$B7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/13", 1196);
$61de1ee1cac498ae$var$bcb(1197, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$SZd);
$61de1ee1cac498ae$var$_.wj = function TZd(a) {
    return $61de1ee1cac498ae$var$JD(a, 235);
};
$61de1ee1cac498ae$var$_.xj = function UZd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$o5, $61de1ee1cac498ae$var$Uhe, 235, a, 0, 1);
};
var $61de1ee1cac498ae$var$C7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/14", 1197);
$61de1ee1cac498ae$var$bcb(1198, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$VZd);
$61de1ee1cac498ae$var$_.wj = function WZd(a) {
    return $61de1ee1cac498ae$var$JD(a, 509);
};
$61de1ee1cac498ae$var$_.xj = function XZd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$p5, $61de1ee1cac498ae$var$Uhe, 2017, a, 0, 1);
};
var $61de1ee1cac498ae$var$D7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/15", 1198);
$61de1ee1cac498ae$var$bcb(1199, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$YZd);
$61de1ee1cac498ae$var$_.wj = function ZZd(a) {
    return $61de1ee1cac498ae$var$JD(a, 99);
};
$61de1ee1cac498ae$var$_.xj = function $Zd(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$q5, $61de1ee1cac498ae$var$Mve, 18, a, 0, 1);
};
var $61de1ee1cac498ae$var$E7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/16", 1199);
$61de1ee1cac498ae$var$bcb(1200, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$_Zd);
$61de1ee1cac498ae$var$_.wj = function a$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 170);
};
$61de1ee1cac498ae$var$_.xj = function b$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$t5, $61de1ee1cac498ae$var$Mve, 170, a, 0, 1);
};
var $61de1ee1cac498ae$var$F7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/17", 1200);
$61de1ee1cac498ae$var$bcb(1201, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$c$d);
$61de1ee1cac498ae$var$_.wj = function d$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 472);
};
$61de1ee1cac498ae$var$_.xj = function e$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$v5, $61de1ee1cac498ae$var$Uhe, 472, a, 0, 1);
};
var $61de1ee1cac498ae$var$G7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/18", 1201);
$61de1ee1cac498ae$var$bcb(1202, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$f$d);
$61de1ee1cac498ae$var$_.wj = function g$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 548);
};
$61de1ee1cac498ae$var$_.xj = function h$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$x6, $61de1ee1cac498ae$var$kve, 548, a, 0, 1);
};
var $61de1ee1cac498ae$var$H7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/19", 1202);
$61de1ee1cac498ae$var$bcb(1185, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$i$d);
$61de1ee1cac498ae$var$_.wj = function j$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 322);
};
$61de1ee1cac498ae$var$_.xj = function k$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$b5, $61de1ee1cac498ae$var$Mve, 34, a, 0, 1);
};
var $61de1ee1cac498ae$var$T7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/2", 1185);
$61de1ee1cac498ae$var$bcb(1203, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$l$d);
$61de1ee1cac498ae$var$_.wj = function m$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 241);
};
$61de1ee1cac498ae$var$_.xj = function n$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$j5, $61de1ee1cac498ae$var$Tve, 87, a, 0, 1);
};
var $61de1ee1cac498ae$var$J7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/20", 1203);
$61de1ee1cac498ae$var$bcb(1204, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$o$d);
$61de1ee1cac498ae$var$_.wj = function p$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 444);
};
$61de1ee1cac498ae$var$_.xj = function q$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$u5, $61de1ee1cac498ae$var$Uhe, 836, a, 0, 1);
};
var $61de1ee1cac498ae$var$K7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/21", 1204);
$61de1ee1cac498ae$var$bcb(1205, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$r$d);
$61de1ee1cac498ae$var$_.wj = function s$d(a) {
    return $61de1ee1cac498ae$var$KD(a);
};
$61de1ee1cac498ae$var$_.xj = function t$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$wI, $61de1ee1cac498ae$var$nie, 476, a, 8, 1);
};
var $61de1ee1cac498ae$var$L7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/22", 1205);
$61de1ee1cac498ae$var$bcb(1206, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$u$d);
$61de1ee1cac498ae$var$_.wj = function v$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 190);
};
$61de1ee1cac498ae$var$_.xj = function w$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$nie, 190, a, 0, 2);
};
var $61de1ee1cac498ae$var$M7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/23", 1206);
$61de1ee1cac498ae$var$bcb(1207, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$x$d);
$61de1ee1cac498ae$var$_.wj = function y$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 217);
};
$61de1ee1cac498ae$var$_.xj = function z$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$xI, $61de1ee1cac498ae$var$nie, 217, a, 0, 1);
};
var $61de1ee1cac498ae$var$N7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/24", 1207);
$61de1ee1cac498ae$var$bcb(1208, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$A$d);
$61de1ee1cac498ae$var$_.wj = function B$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 172);
};
$61de1ee1cac498ae$var$_.xj = function C$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yI, $61de1ee1cac498ae$var$nie, 172, a, 0, 1);
};
var $61de1ee1cac498ae$var$O7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/25", 1208);
$61de1ee1cac498ae$var$bcb(1209, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$D$d);
$61de1ee1cac498ae$var$_.wj = function E$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 199);
};
$61de1ee1cac498ae$var$_.xj = function F$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$$J, $61de1ee1cac498ae$var$nie, 199, a, 0, 1);
};
var $61de1ee1cac498ae$var$P7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/26", 1209);
$61de1ee1cac498ae$var$bcb(1210, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$G$d);
$61de1ee1cac498ae$var$_.wj = function H$d(a) {
    return false;
};
$61de1ee1cac498ae$var$_.xj = function I$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$O4, $61de1ee1cac498ae$var$Uhe, 2110, a, 0, 1);
};
var $61de1ee1cac498ae$var$Q7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/27", 1210);
$61de1ee1cac498ae$var$bcb(1211, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$J$d);
$61de1ee1cac498ae$var$_.wj = function K$d(a) {
    return $61de1ee1cac498ae$var$LD(a);
};
$61de1ee1cac498ae$var$_.xj = function L$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BI, $61de1ee1cac498ae$var$nie, 333, a, 7, 1);
};
var $61de1ee1cac498ae$var$R7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/28", 1211);
$61de1ee1cac498ae$var$bcb(1212, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$M$d);
$61de1ee1cac498ae$var$_.wj = function N$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 58);
};
$61de1ee1cac498ae$var$_.xj = function O$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$T4, $61de1ee1cac498ae$var$eme, 58, a, 0, 1);
};
var $61de1ee1cac498ae$var$S7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/29", 1212);
$61de1ee1cac498ae$var$bcb(1186, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$P$d);
$61de1ee1cac498ae$var$_.wj = function Q$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 510);
};
$61de1ee1cac498ae$var$_.xj = function R$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$a5, {
        3: 1,
        4: 1,
        5: 1,
        1934: 1
    }, 590, a, 0, 1);
};
var $61de1ee1cac498ae$var$c8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/3", 1186);
$61de1ee1cac498ae$var$bcb(1213, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$S$d);
$61de1ee1cac498ae$var$_.wj = function T$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 573);
};
$61de1ee1cac498ae$var$_.xj = function U$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$U4, $61de1ee1cac498ae$var$Uhe, 1940, a, 0, 1);
};
var $61de1ee1cac498ae$var$U7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/30", 1213);
$61de1ee1cac498ae$var$bcb(1214, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$V$d);
$61de1ee1cac498ae$var$_.wj = function W$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 153);
};
$61de1ee1cac498ae$var$_.xj = function X$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$O9, $61de1ee1cac498ae$var$eme, 153, a, 0, 1);
};
var $61de1ee1cac498ae$var$V7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/31", 1214);
$61de1ee1cac498ae$var$bcb(1215, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Y$d);
$61de1ee1cac498ae$var$_.wj = function Z$d(a) {
    return $61de1ee1cac498ae$var$JD(a, 72);
};
$61de1ee1cac498ae$var$_.xj = function $$d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$E9, $61de1ee1cac498ae$var$owe, 72, a, 0, 1);
};
var $61de1ee1cac498ae$var$W7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/32", 1215);
$61de1ee1cac498ae$var$bcb(1216, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$_$d);
$61de1ee1cac498ae$var$_.wj = function a_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 155);
};
$61de1ee1cac498ae$var$_.xj = function b_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$FI, $61de1ee1cac498ae$var$nie, 155, a, 0, 1);
};
var $61de1ee1cac498ae$var$X7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/33", 1216);
$61de1ee1cac498ae$var$bcb(1217, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$c_d);
$61de1ee1cac498ae$var$_.wj = function d_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 19);
};
$61de1ee1cac498ae$var$_.xj = function e_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$JI, $61de1ee1cac498ae$var$nie, 19, a, 0, 1);
};
var $61de1ee1cac498ae$var$Y7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/34", 1217);
$61de1ee1cac498ae$var$bcb(1218, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$f_d);
$61de1ee1cac498ae$var$_.wj = function g_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 290);
};
$61de1ee1cac498ae$var$_.xj = function h_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$AI, $61de1ee1cac498ae$var$Uhe, 290, a, 0, 1);
};
var $61de1ee1cac498ae$var$Z7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/35", 1218);
$61de1ee1cac498ae$var$bcb(1219, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$i_d);
$61de1ee1cac498ae$var$_.wj = function j_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 162);
};
$61de1ee1cac498ae$var$_.xj = function k_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$MI, $61de1ee1cac498ae$var$nie, 162, a, 0, 1);
};
var $61de1ee1cac498ae$var$$7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/36", 1219);
$61de1ee1cac498ae$var$bcb(1220, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$l_d);
$61de1ee1cac498ae$var$_.wj = function m_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 83);
};
$61de1ee1cac498ae$var$_.xj = function n_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$DK, $61de1ee1cac498ae$var$Uhe, 83, a, 0, 1);
};
var $61de1ee1cac498ae$var$_7 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/37", 1220);
$61de1ee1cac498ae$var$bcb(1221, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$o_d);
$61de1ee1cac498ae$var$_.wj = function p_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 591);
};
$61de1ee1cac498ae$var$_.xj = function q_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$v8, $61de1ee1cac498ae$var$Uhe, 591, a, 0, 1);
};
var $61de1ee1cac498ae$var$a8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/38", 1221);
$61de1ee1cac498ae$var$bcb(1222, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$r_d);
$61de1ee1cac498ae$var$_.wj = function s_d(a) {
    return false;
};
$61de1ee1cac498ae$var$_.xj = function t_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$u8, $61de1ee1cac498ae$var$Uhe, 2111, a, 0, 1);
};
var $61de1ee1cac498ae$var$b8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/39", 1222);
$61de1ee1cac498ae$var$bcb(1187, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$u_d);
$61de1ee1cac498ae$var$_.wj = function v_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 88);
};
$61de1ee1cac498ae$var$_.xj = function w_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$c5, $61de1ee1cac498ae$var$Uhe, 26, a, 0, 1);
};
var $61de1ee1cac498ae$var$i8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/4", 1187);
$61de1ee1cac498ae$var$bcb(1223, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$x_d);
$61de1ee1cac498ae$var$_.wj = function y_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 184);
};
$61de1ee1cac498ae$var$_.xj = function z_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UI, $61de1ee1cac498ae$var$nie, 184, a, 0, 1);
};
var $61de1ee1cac498ae$var$d8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/40", 1223);
$61de1ee1cac498ae$var$bcb(1224, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$A_d);
$61de1ee1cac498ae$var$_.wj = function B_d(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function C_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$e8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/41", 1224);
$61de1ee1cac498ae$var$bcb(1225, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$D_d);
$61de1ee1cac498ae$var$_.wj = function E_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 588);
};
$61de1ee1cac498ae$var$_.xj = function F_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$X4, $61de1ee1cac498ae$var$Uhe, 588, a, 0, 1);
};
var $61de1ee1cac498ae$var$f8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/42", 1225);
$61de1ee1cac498ae$var$bcb(1226, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$G_d);
$61de1ee1cac498ae$var$_.wj = function H_d(a) {
    return false;
};
$61de1ee1cac498ae$var$_.xj = function I_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$V4, $61de1ee1cac498ae$var$nie, 2112, a, 0, 1);
};
var $61de1ee1cac498ae$var$g8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/43", 1226);
$61de1ee1cac498ae$var$bcb(1227, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$J_d);
$61de1ee1cac498ae$var$_.wj = function K_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 42);
};
$61de1ee1cac498ae$var$_.xj = function L_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$CK, $61de1ee1cac498ae$var$zie, 42, a, 0, 1);
};
var $61de1ee1cac498ae$var$h8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/44", 1227);
$61de1ee1cac498ae$var$bcb(1188, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$M_d);
$61de1ee1cac498ae$var$_.wj = function N_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 138);
};
$61de1ee1cac498ae$var$_.xj = function O_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$d5, $61de1ee1cac498ae$var$Uhe, 138, a, 0, 1);
};
var $61de1ee1cac498ae$var$j8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/5", 1188);
$61de1ee1cac498ae$var$bcb(1189, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$P_d);
$61de1ee1cac498ae$var$_.wj = function Q_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 148);
};
$61de1ee1cac498ae$var$_.xj = function R_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$f5, $61de1ee1cac498ae$var$Uhe, 148, a, 0, 1);
};
var $61de1ee1cac498ae$var$k8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/6", 1189);
$61de1ee1cac498ae$var$bcb(1190, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$S_d);
$61de1ee1cac498ae$var$_.wj = function T_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 457);
};
$61de1ee1cac498ae$var$_.xj = function U_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$h5, $61de1ee1cac498ae$var$Uhe, 671, a, 0, 1);
};
var $61de1ee1cac498ae$var$l8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/7", 1190);
$61de1ee1cac498ae$var$bcb(1191, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$V_d);
$61de1ee1cac498ae$var$_.wj = function W_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 573);
};
$61de1ee1cac498ae$var$_.xj = function X_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$g5, $61de1ee1cac498ae$var$Uhe, 678, a, 0, 1);
};
var $61de1ee1cac498ae$var$m8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/8", 1191);
$61de1ee1cac498ae$var$bcb(1192, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Y_d);
$61de1ee1cac498ae$var$_.wj = function Z_d(a) {
    return $61de1ee1cac498ae$var$JD(a, 471);
};
$61de1ee1cac498ae$var$_.xj = function $_d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$i5, $61de1ee1cac498ae$var$Uhe, 471, a, 0, 1);
};
var $61de1ee1cac498ae$var$n8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "EcorePackageImpl/9", 1192);
$61de1ee1cac498ae$var$bcb(1025, 1982, $61de1ee1cac498ae$var$ive, $61de1ee1cac498ae$var$c0d);
$61de1ee1cac498ae$var$_.bi = function d0d(a, b) {
    $61de1ee1cac498ae$var$__d(this, $61de1ee1cac498ae$var$BD(b, 415));
};
$61de1ee1cac498ae$var$_.fi = function e0d(a, b) {
    $61de1ee1cac498ae$var$a0d(this, a, $61de1ee1cac498ae$var$BD(b, 415));
};
var $61de1ee1cac498ae$var$q8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "MinimalEObjectImpl/1ArrayDelegatingAdapterList", 1025);
$61de1ee1cac498ae$var$bcb(1026, 143, $61de1ee1cac498ae$var$fve, $61de1ee1cac498ae$var$f0d);
$61de1ee1cac498ae$var$_.Ai = function g0d() {
    return this.a.a;
};
var $61de1ee1cac498ae$var$p8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$qte, "MinimalEObjectImpl/1ArrayDelegatingAdapterList/1", 1026);
$61de1ee1cac498ae$var$bcb(1053, 1052, {}, $61de1ee1cac498ae$var$i0d);
var $61de1ee1cac498ae$var$t8 = $61de1ee1cac498ae$var$mdb("org.eclipse.emf.ecore.plugin", "EcorePlugin", 1053);
var $61de1ee1cac498ae$var$v8 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$pwe, "Resource");
$61de1ee1cac498ae$var$bcb(781, 1378, $61de1ee1cac498ae$var$qwe);
$61de1ee1cac498ae$var$_.Yk = function m0d(a) {};
$61de1ee1cac498ae$var$_.Zk = function n0d(a) {};
$61de1ee1cac498ae$var$_.Vk = function o0d() {
    return !this.a && (this.a = new $61de1ee1cac498ae$var$z0d(this)), this.a;
};
$61de1ee1cac498ae$var$_.Wk = function p0d(a) {
    var b, c, d, e, f;
    d = a.length;
    if (d > 0) {
        $61de1ee1cac498ae$var$BCb(0, a.length);
        if (a.charCodeAt(0) == 47) {
            f = new $61de1ee1cac498ae$var$Skb(4);
            e = 1;
            for(b = 1; b < d; ++b){
                $61de1ee1cac498ae$var$BCb(b, a.length);
                if (a.charCodeAt(b) == 47) {
                    $61de1ee1cac498ae$var$Ekb(f, e == b ? "" : a.substr(e, b - e));
                    e = b + 1;
                }
            }
            $61de1ee1cac498ae$var$Ekb(f, a.substr(e));
            return $61de1ee1cac498ae$var$j0d(this, f);
        } else {
            $61de1ee1cac498ae$var$BCb(d - 1, a.length);
            if (a.charCodeAt(d - 1) == 63) {
                c = $61de1ee1cac498ae$var$lfb(a, $61de1ee1cac498ae$var$wfb(63), d - 2);
                c > 0 && (a = a.substr(0, c));
            }
        }
    }
    return $61de1ee1cac498ae$var$k0d(this, a);
};
$61de1ee1cac498ae$var$_.Xk = function q0d() {
    return this.c;
};
$61de1ee1cac498ae$var$_.Ib = function r0d() {
    var a;
    return $61de1ee1cac498ae$var$hdb(this.gm) + "@" + (a = $61de1ee1cac498ae$var$tb(this) >>> 0, a.toString(16)) + " uri='" + this.d + "'";
};
$61de1ee1cac498ae$var$_.b = false;
var $61de1ee1cac498ae$var$z8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rwe, "ResourceImpl", 781);
$61de1ee1cac498ae$var$bcb(1379, 781, $61de1ee1cac498ae$var$qwe, $61de1ee1cac498ae$var$s0d);
var $61de1ee1cac498ae$var$w8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rwe, "BinaryResourceImpl", 1379);
$61de1ee1cac498ae$var$bcb(1169, 694, $61de1ee1cac498ae$var$pue);
$61de1ee1cac498ae$var$_.si = function v0d(a) {
    return $61de1ee1cac498ae$var$JD(a, 56) ? $61de1ee1cac498ae$var$t0d(this, $61de1ee1cac498ae$var$BD(a, 56)) : $61de1ee1cac498ae$var$JD(a, 591) ? new $61de1ee1cac498ae$var$Fyd($61de1ee1cac498ae$var$BD(a, 591).Vk()) : $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(this.f) ? $61de1ee1cac498ae$var$BD(a, 14).Kc() : ($61de1ee1cac498ae$var$LCd(), $61de1ee1cac498ae$var$KCd.a);
};
$61de1ee1cac498ae$var$_.Ob = function w0d() {
    return $61de1ee1cac498ae$var$u0d(this);
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$z9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreUtil/ContentTreeIterator", 1169);
$61de1ee1cac498ae$var$bcb(1380, 1169, $61de1ee1cac498ae$var$pue, $61de1ee1cac498ae$var$x0d);
$61de1ee1cac498ae$var$_.si = function y0d(a) {
    return $61de1ee1cac498ae$var$PD(a) === $61de1ee1cac498ae$var$PD(this.f) ? $61de1ee1cac498ae$var$BD(a, 15).Kc() : new $61de1ee1cac498ae$var$C6d($61de1ee1cac498ae$var$BD(a, 56));
};
var $61de1ee1cac498ae$var$x8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rwe, "ResourceImpl/5", 1380);
$61de1ee1cac498ae$var$bcb(648, 1994, $61de1ee1cac498ae$var$Ove, $61de1ee1cac498ae$var$z0d);
$61de1ee1cac498ae$var$_.Hc = function A0d(a) {
    return this.i <= 4 ? $61de1ee1cac498ae$var$pud(this, a) : $61de1ee1cac498ae$var$JD(a, 49) && $61de1ee1cac498ae$var$BD(a, 49).Zg() == this.a;
};
$61de1ee1cac498ae$var$_.bi = function B0d(a, b) {
    a == this.i - 1 && (this.a.b || (this.a.b = true));
};
$61de1ee1cac498ae$var$_.di = function C0d(a, b) {
    a == 0 ? this.a.b || (this.a.b = true) : $61de1ee1cac498ae$var$Atd(this, a, b);
};
$61de1ee1cac498ae$var$_.fi = function D0d(a, b) {};
$61de1ee1cac498ae$var$_.gi = function E0d(a, b, c) {};
$61de1ee1cac498ae$var$_.aj = function F0d() {
    return 2;
};
$61de1ee1cac498ae$var$_.Ai = function G0d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.bj = function H0d() {
    return true;
};
$61de1ee1cac498ae$var$_.cj = function I0d(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD(a, 49);
    b = c.wh(this.a, b);
    return b;
};
$61de1ee1cac498ae$var$_.dj = function J0d(a, b) {
    var c;
    c = $61de1ee1cac498ae$var$BD(a, 49);
    return c.wh(null, b);
};
$61de1ee1cac498ae$var$_.ej = function K0d() {
    return false;
};
$61de1ee1cac498ae$var$_.hi = function L0d() {
    return true;
};
$61de1ee1cac498ae$var$_.ri = function M0d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$m5, $61de1ee1cac498ae$var$Uhe, 56, a, 0, 1);
};
$61de1ee1cac498ae$var$_.ni = function N0d() {
    return false;
};
var $61de1ee1cac498ae$var$y8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$rwe, "ResourceImpl/ContentsEList", 648);
$61de1ee1cac498ae$var$bcb(957, 1964, $61de1ee1cac498ae$var$Lie, $61de1ee1cac498ae$var$O0d);
$61de1ee1cac498ae$var$_.Zc = function P0d(a) {
    return this.a._h(a);
};
$61de1ee1cac498ae$var$_.gc = function Q0d() {
    return this.a.gc();
};
var $61de1ee1cac498ae$var$A8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "AbstractSequentialInternalEList/1", 957);
var $61de1ee1cac498ae$var$K6d, $61de1ee1cac498ae$var$L6d, $61de1ee1cac498ae$var$M6d, $61de1ee1cac498ae$var$N6d;
$61de1ee1cac498ae$var$bcb(624, 1, {}, $61de1ee1cac498ae$var$y1d);
var $61de1ee1cac498ae$var$R0d, $61de1ee1cac498ae$var$S0d;
var $61de1ee1cac498ae$var$G8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicExtendedMetaData", 624);
$61de1ee1cac498ae$var$bcb(1160, 1, {}, $61de1ee1cac498ae$var$C1d);
$61de1ee1cac498ae$var$_.$k = function D1d() {
    return null;
};
$61de1ee1cac498ae$var$_._k = function E1d() {
    this.a == -2 && $61de1ee1cac498ae$var$A1d(this, $61de1ee1cac498ae$var$W0d(this.d, this.b));
    return this.a;
};
$61de1ee1cac498ae$var$_.al = function F1d() {
    return null;
};
$61de1ee1cac498ae$var$_.bl = function G1d() {
    return $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$mmb(), $61de1ee1cac498ae$var$jmb;
};
$61de1ee1cac498ae$var$_.ne = function H1d() {
    this.c == $61de1ee1cac498ae$var$Gwe && $61de1ee1cac498ae$var$B1d(this, $61de1ee1cac498ae$var$_0d(this.d, this.b));
    return this.c;
};
$61de1ee1cac498ae$var$_.cl = function I1d() {
    return 0;
};
$61de1ee1cac498ae$var$_.a = -2;
$61de1ee1cac498ae$var$_.c = $61de1ee1cac498ae$var$Gwe;
var $61de1ee1cac498ae$var$C8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicExtendedMetaData/EClassExtendedMetaDataImpl", 1160);
$61de1ee1cac498ae$var$bcb(1161, 1, {}, $61de1ee1cac498ae$var$O1d);
$61de1ee1cac498ae$var$_.$k = function P1d() {
    this.a == ($61de1ee1cac498ae$var$T0d(), $61de1ee1cac498ae$var$R0d) && $61de1ee1cac498ae$var$J1d(this, $61de1ee1cac498ae$var$V0d(this.f, this.b));
    return this.a;
};
$61de1ee1cac498ae$var$_._k = function Q1d() {
    return 0;
};
$61de1ee1cac498ae$var$_.al = function R1d() {
    this.c == ($61de1ee1cac498ae$var$T0d(), $61de1ee1cac498ae$var$R0d) && $61de1ee1cac498ae$var$K1d(this, $61de1ee1cac498ae$var$Z0d(this.f, this.b));
    return this.c;
};
$61de1ee1cac498ae$var$_.bl = function S1d() {
    !this.d && $61de1ee1cac498ae$var$L1d(this, $61de1ee1cac498ae$var$$0d(this.f, this.b));
    return this.d;
};
$61de1ee1cac498ae$var$_.ne = function T1d() {
    this.e == $61de1ee1cac498ae$var$Gwe && $61de1ee1cac498ae$var$M1d(this, $61de1ee1cac498ae$var$_0d(this.f, this.b));
    return this.e;
};
$61de1ee1cac498ae$var$_.cl = function U1d() {
    this.g == -2 && $61de1ee1cac498ae$var$N1d(this, $61de1ee1cac498ae$var$c1d(this.f, this.b));
    return this.g;
};
$61de1ee1cac498ae$var$_.e = $61de1ee1cac498ae$var$Gwe;
$61de1ee1cac498ae$var$_.g = -2;
var $61de1ee1cac498ae$var$D8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicExtendedMetaData/EDataTypeExtendedMetaDataImpl", 1161);
$61de1ee1cac498ae$var$bcb(1159, 1, {}, $61de1ee1cac498ae$var$Y1d);
$61de1ee1cac498ae$var$_.b = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$E8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicExtendedMetaData/EPackageExtendedMetaDataImpl", 1159);
$61de1ee1cac498ae$var$bcb(1162, 1, {}, $61de1ee1cac498ae$var$j2d);
$61de1ee1cac498ae$var$_.c = -2;
$61de1ee1cac498ae$var$_.e = $61de1ee1cac498ae$var$Gwe;
$61de1ee1cac498ae$var$_.f = $61de1ee1cac498ae$var$Gwe;
var $61de1ee1cac498ae$var$F8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicExtendedMetaData/EStructuralFeatureExtendedMetaDataImpl", 1162);
$61de1ee1cac498ae$var$bcb(585, 622, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$k2d);
$61de1ee1cac498ae$var$_.aj = function l2d() {
    return this.c;
};
$61de1ee1cac498ae$var$_.Fk = function m2d() {
    return false;
};
$61de1ee1cac498ae$var$_.li = function n2d(a, b) {
    return b;
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$T8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EDataTypeEList", 585);
var $61de1ee1cac498ae$var$O9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$yve, "FeatureMap");
$61de1ee1cac498ae$var$bcb(75, 585, {
    3: 1,
    4: 1,
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    54: 1,
    67: 1,
    63: 1,
    58: 1,
    76: 1,
    153: 1,
    215: 1,
    1937: 1,
    69: 1,
    95: 1
}, $61de1ee1cac498ae$var$u3d);
$61de1ee1cac498ae$var$_.Vc = function v3d(a, b) {
    $61de1ee1cac498ae$var$o2d(this, a, $61de1ee1cac498ae$var$BD(b, 72));
};
$61de1ee1cac498ae$var$_.Fc = function w3d(a) {
    return $61de1ee1cac498ae$var$r2d(this, $61de1ee1cac498ae$var$BD(a, 72));
};
$61de1ee1cac498ae$var$_.Yh = function B3d(a) {
    $61de1ee1cac498ae$var$w2d(this, $61de1ee1cac498ae$var$BD(a, 72));
};
$61de1ee1cac498ae$var$_.cj = function M3d(a, b) {
    return $61de1ee1cac498ae$var$O2d(this, $61de1ee1cac498ae$var$BD(a, 72), b);
};
$61de1ee1cac498ae$var$_.dj = function N3d(a, b) {
    return $61de1ee1cac498ae$var$Q2d(this, $61de1ee1cac498ae$var$BD(a, 72), b);
};
$61de1ee1cac498ae$var$_.ii = function P3d(a, b) {
    return $61de1ee1cac498ae$var$W2d(this, a, b);
};
$61de1ee1cac498ae$var$_.li = function R3d(a, b) {
    return $61de1ee1cac498ae$var$_2d(this, a, $61de1ee1cac498ae$var$BD(b, 72));
};
$61de1ee1cac498ae$var$_._c = function T3d(a, b) {
    return $61de1ee1cac498ae$var$c3d(this, a, $61de1ee1cac498ae$var$BD(b, 72));
};
$61de1ee1cac498ae$var$_.jj = function X3d(a, b) {
    return $61de1ee1cac498ae$var$i3d(this, $61de1ee1cac498ae$var$BD(a, 72), b);
};
$61de1ee1cac498ae$var$_.kj = function Y3d(a, b) {
    return $61de1ee1cac498ae$var$k3d(this, $61de1ee1cac498ae$var$BD(a, 72), b);
};
$61de1ee1cac498ae$var$_.lj = function Z3d(a, b, c) {
    return $61de1ee1cac498ae$var$l3d(this, $61de1ee1cac498ae$var$BD(a, 72), $61de1ee1cac498ae$var$BD(b, 72), c);
};
$61de1ee1cac498ae$var$_.oi = function _3d(a, b) {
    return $61de1ee1cac498ae$var$t3d(this, a, $61de1ee1cac498ae$var$BD(b, 72));
};
$61de1ee1cac498ae$var$_.dl = function x3d(a, b) {
    return $61de1ee1cac498ae$var$q2d(this, a, b);
};
$61de1ee1cac498ae$var$_.Wc = function y3d(a, b) {
    var c, d, e, f, g, h, i, j, k;
    j = new $61de1ee1cac498ae$var$zud(b.gc());
    for(e = b.Kc(); e.Ob();){
        d = $61de1ee1cac498ae$var$BD(e.Pb(), 72);
        f = d.ak();
        if ($61de1ee1cac498ae$var$T6d(this.e, f)) (!f.hi() || !$61de1ee1cac498ae$var$E2d(this, f, d.dd()) && !$61de1ee1cac498ae$var$pud(j, d)) && $61de1ee1cac498ae$var$wtd(j, d);
        else {
            k = $61de1ee1cac498ae$var$S6d(this.e.Tg(), f);
            c = $61de1ee1cac498ae$var$BD(this.g, 119);
            g = true;
            for(h = 0; h < this.i; ++h){
                i = c[h];
                if (k.rl(i.ak())) {
                    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(this, h, d), 72);
                    g = false;
                    break;
                }
            }
            g && $61de1ee1cac498ae$var$wtd(j, d);
        }
    }
    return $61de1ee1cac498ae$var$xtd(this, a, j);
};
$61de1ee1cac498ae$var$_.Gc = function z3d(a) {
    var b, c, d, e, f, g, h, i, j;
    i = new $61de1ee1cac498ae$var$zud(a.gc());
    for(d = a.Kc(); d.Ob();){
        c = $61de1ee1cac498ae$var$BD(d.Pb(), 72);
        e = c.ak();
        if ($61de1ee1cac498ae$var$T6d(this.e, e)) (!e.hi() || !$61de1ee1cac498ae$var$E2d(this, e, c.dd()) && !$61de1ee1cac498ae$var$pud(i, c)) && $61de1ee1cac498ae$var$wtd(i, c);
        else {
            j = $61de1ee1cac498ae$var$S6d(this.e.Tg(), e);
            b = $61de1ee1cac498ae$var$BD(this.g, 119);
            f = true;
            for(g = 0; g < this.i; ++g){
                h = b[g];
                if (j.rl(h.ak())) {
                    $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Gtd(this, g, c), 72);
                    f = false;
                    break;
                }
            }
            f && $61de1ee1cac498ae$var$wtd(i, c);
        }
    }
    return $61de1ee1cac498ae$var$ytd(this, i);
};
$61de1ee1cac498ae$var$_.Wh = function A3d(a) {
    this.j = -1;
    return $61de1ee1cac498ae$var$Pxd(this, this.i, a);
};
$61de1ee1cac498ae$var$_.el = function C3d(a, b, c) {
    return $61de1ee1cac498ae$var$x2d(this, a, b, c);
};
$61de1ee1cac498ae$var$_.mk = function D3d(a, b) {
    return $61de1ee1cac498ae$var$B2d(this, a, b);
};
$61de1ee1cac498ae$var$_.fl = function E3d(a, b, c) {
    return $61de1ee1cac498ae$var$C2d(this, a, b, c);
};
$61de1ee1cac498ae$var$_.gl = function F3d() {
    return this;
};
$61de1ee1cac498ae$var$_.hl = function G3d(a, b) {
    return $61de1ee1cac498ae$var$K2d(this, a, b);
};
$61de1ee1cac498ae$var$_.il = function H3d(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(this, a), 72).ak();
};
$61de1ee1cac498ae$var$_.jl = function I3d(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$qud(this, a), 72).dd();
};
$61de1ee1cac498ae$var$_.kl = function J3d() {
    return this.b;
};
$61de1ee1cac498ae$var$_.bj = function K3d() {
    return true;
};
$61de1ee1cac498ae$var$_.ij = function L3d() {
    return true;
};
$61de1ee1cac498ae$var$_.ll = function O3d(a) {
    return !$61de1ee1cac498ae$var$R2d(this, a);
};
$61de1ee1cac498ae$var$_.ri = function Q3d(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$D9, $61de1ee1cac498ae$var$owe, 332, a, 0, 1);
};
$61de1ee1cac498ae$var$_.Gk = function S3d(a) {
    return $61de1ee1cac498ae$var$a3d(this, a);
};
$61de1ee1cac498ae$var$_.Wb = function U3d(a) {
    $61de1ee1cac498ae$var$d3d(this, a);
};
$61de1ee1cac498ae$var$_.ml = function V3d(a, b) {
    $61de1ee1cac498ae$var$f3d(this, a, b);
};
$61de1ee1cac498ae$var$_.nl = function W3d(a) {
    return $61de1ee1cac498ae$var$g3d(this, a);
};
$61de1ee1cac498ae$var$_.ol = function $3d(a) {
    $61de1ee1cac498ae$var$s3d(this, a);
};
var $61de1ee1cac498ae$var$J8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicFeatureMap", 75);
$61de1ee1cac498ae$var$bcb(1851, 1, $61de1ee1cac498ae$var$jie);
$61de1ee1cac498ae$var$_.Nb = function f4d(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Rb = function e4d(b) {
    if (this.g == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    $61de1ee1cac498ae$var$a4d(this);
    try {
        $61de1ee1cac498ae$var$p2d(this.e, this.b, this.a, b);
        this.d = this.e.j;
        $61de1ee1cac498ae$var$d4d(this);
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.Ob = function g4d() {
    return $61de1ee1cac498ae$var$b4d(this);
};
$61de1ee1cac498ae$var$_.Sb = function h4d() {
    return $61de1ee1cac498ae$var$c4d(this);
};
$61de1ee1cac498ae$var$_.Pb = function i4d() {
    return $61de1ee1cac498ae$var$d4d(this);
};
$61de1ee1cac498ae$var$_.Tb = function j4d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Ub = function k4d() {
    var a;
    if ($61de1ee1cac498ae$var$c4d(this)) {
        $61de1ee1cac498ae$var$a4d(this);
        this.g = --this.a;
        if (this.Lk()) {
            a = $61de1ee1cac498ae$var$b3d(this.e, this.b, this.c, this.a, this.j);
            this.j = a;
        }
        this.i = 0;
        return this.j;
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$utb);
};
$61de1ee1cac498ae$var$_.Vb = function l4d() {
    return this.a - 1;
};
$61de1ee1cac498ae$var$_.Qb = function m4d() {
    if (this.g == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    $61de1ee1cac498ae$var$a4d(this);
    try {
        $61de1ee1cac498ae$var$Z2d(this.e, this.b, this.g);
        this.d = this.e.j;
        if (this.g < this.a) {
            --this.a;
            --this.c;
        }
        --this.g;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.Lk = function n4d() {
    return false;
};
$61de1ee1cac498ae$var$_.Wb = function o4d(b) {
    if (this.g == -1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Ydb);
    $61de1ee1cac498ae$var$a4d(this);
    try {
        $61de1ee1cac498ae$var$e3d(this.e, this.b, this.g, b);
        this.d = this.e.j;
    } catch (a) {
        a = $61de1ee1cac498ae$var$ubb(a);
        if ($61de1ee1cac498ae$var$JD(a, 73)) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Apb);
        else throw $61de1ee1cac498ae$var$vbb(a);
    }
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.f = false;
$61de1ee1cac498ae$var$_.g = 0;
$61de1ee1cac498ae$var$_.i = 0;
var $61de1ee1cac498ae$var$G9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/BasicFeatureEIterator", 1851);
$61de1ee1cac498ae$var$bcb(410, 1851, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$p4d);
$61de1ee1cac498ae$var$_.pl = function q4d() {
    var a, b, c;
    c = this.e.i;
    a = $61de1ee1cac498ae$var$BD(this.e.g, 119);
    while(this.c < c){
        b = a[this.c];
        if (this.k.rl(b.ak())) {
            this.j = this.f ? b : b.dd();
            this.i = 2;
            return true;
        }
        ++this.c;
    }
    this.i = 1;
    this.g = -1;
    return false;
};
$61de1ee1cac498ae$var$_.ql = function r4d() {
    var a, b;
    a = $61de1ee1cac498ae$var$BD(this.e.g, 119);
    while(--this.c >= 0){
        b = a[this.c];
        if (this.k.rl(b.ak())) {
            this.j = this.f ? b : b.dd();
            this.i = -2;
            return true;
        }
    }
    this.i = -1;
    this.g = -1;
    return false;
};
var $61de1ee1cac498ae$var$H8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicFeatureMap/FeatureEIterator", 410);
$61de1ee1cac498ae$var$bcb(662, 410, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$s4d);
$61de1ee1cac498ae$var$_.Lk = function t4d() {
    return true;
};
var $61de1ee1cac498ae$var$I8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "BasicFeatureMap/ResolvingFeatureEIterator", 662);
$61de1ee1cac498ae$var$bcb(955, 486, $61de1ee1cac498ae$var$Vve, $61de1ee1cac498ae$var$u4d);
$61de1ee1cac498ae$var$_.Gi = function v4d() {
    return this;
};
var $61de1ee1cac498ae$var$M8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EContentsEList/1", 955);
$61de1ee1cac498ae$var$bcb(956, 486, $61de1ee1cac498ae$var$Vve, $61de1ee1cac498ae$var$w4d);
$61de1ee1cac498ae$var$_.Lk = function x4d() {
    return false;
};
var $61de1ee1cac498ae$var$N8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EContentsEList/2", 956);
$61de1ee1cac498ae$var$bcb(954, 279, $61de1ee1cac498ae$var$Wve, $61de1ee1cac498ae$var$y4d);
$61de1ee1cac498ae$var$_.Nk = function z4d(a) {};
$61de1ee1cac498ae$var$_.Ob = function A4d() {
    return false;
};
$61de1ee1cac498ae$var$_.Sb = function B4d() {
    return false;
};
var $61de1ee1cac498ae$var$O8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EContentsEList/FeatureIteratorImpl/1", 954);
$61de1ee1cac498ae$var$bcb(825, 585, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$C4d);
$61de1ee1cac498ae$var$_.ci = function D4d() {
    this.a = true;
};
$61de1ee1cac498ae$var$_.fj = function E4d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Xj = function F4d() {
    var a;
    $61de1ee1cac498ae$var$Uxd(this);
    if ($61de1ee1cac498ae$var$oid(this.e)) {
        a = this.a;
        this.a = false;
        $61de1ee1cac498ae$var$Uhd(this.e, new $61de1ee1cac498ae$var$qSd(this.e, 2, this.c, a, false));
    } else this.a = false;
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$S8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EDataTypeEList/Unsettable", 825);
$61de1ee1cac498ae$var$bcb(1849, 585, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$G4d);
$61de1ee1cac498ae$var$_.hi = function H4d() {
    return true;
};
var $61de1ee1cac498ae$var$V8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EDataTypeUniqueEList", 1849);
$61de1ee1cac498ae$var$bcb(1850, 825, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$I4d);
$61de1ee1cac498ae$var$_.hi = function J4d() {
    return true;
};
var $61de1ee1cac498ae$var$U8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EDataTypeUniqueEList/Unsettable", 1850);
$61de1ee1cac498ae$var$bcb(139, 85, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$K4d);
$61de1ee1cac498ae$var$_.Ek = function L4d() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function M4d(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$W8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentEList/Resolving", 139);
$61de1ee1cac498ae$var$bcb(1163, 545, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$N4d);
$61de1ee1cac498ae$var$_.Ek = function O4d() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function P4d(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$X8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentEList/Unsettable/Resolving", 1163);
$61de1ee1cac498ae$var$bcb(748, 16, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$Q4d);
$61de1ee1cac498ae$var$_.ci = function R4d() {
    this.a = true;
};
$61de1ee1cac498ae$var$_.fj = function S4d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Xj = function T4d() {
    var a;
    $61de1ee1cac498ae$var$Uxd(this);
    if ($61de1ee1cac498ae$var$oid(this.e)) {
        a = this.a;
        this.a = false;
        $61de1ee1cac498ae$var$Uhd(this.e, new $61de1ee1cac498ae$var$qSd(this.e, 2, this.c, a, false));
    } else this.a = false;
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$a9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentWithInverseEList/Unsettable", 748);
$61de1ee1cac498ae$var$bcb(1173, 748, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$U4d);
$61de1ee1cac498ae$var$_.Ek = function V4d() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function W4d(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$_8 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectContainmentWithInverseEList/Unsettable/Resolving", 1173);
$61de1ee1cac498ae$var$bcb(743, 496, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$X4d);
$61de1ee1cac498ae$var$_.ci = function Y4d() {
    this.a = true;
};
$61de1ee1cac498ae$var$_.fj = function Z4d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Xj = function $4d() {
    var a;
    $61de1ee1cac498ae$var$Uxd(this);
    if ($61de1ee1cac498ae$var$oid(this.e)) {
        a = this.a;
        this.a = false;
        $61de1ee1cac498ae$var$Uhd(this.e, new $61de1ee1cac498ae$var$qSd(this.e, 2, this.c, a, false));
    } else this.a = false;
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$c9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectEList/Unsettable", 743);
$61de1ee1cac498ae$var$bcb(328, 496, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$_4d);
$61de1ee1cac498ae$var$_.Ek = function a5d() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function b5d(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$f9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectResolvingEList", 328);
$61de1ee1cac498ae$var$bcb(1641, 743, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$c5d);
$61de1ee1cac498ae$var$_.Ek = function d5d() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function e5d(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$e9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectResolvingEList/Unsettable", 1641);
$61de1ee1cac498ae$var$bcb(1381, 1, {}, $61de1ee1cac498ae$var$h5d);
var $61de1ee1cac498ae$var$f5d;
var $61de1ee1cac498ae$var$g9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectValidator", 1381);
$61de1ee1cac498ae$var$bcb(546, 496, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$i5d);
$61de1ee1cac498ae$var$_.zk = function j5d() {
    return this.d;
};
$61de1ee1cac498ae$var$_.Ak = function k5d() {
    return this.b;
};
$61de1ee1cac498ae$var$_.bj = function l5d() {
    return true;
};
$61de1ee1cac498ae$var$_.Dk = function m5d() {
    return true;
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$k9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseEList", 546);
$61de1ee1cac498ae$var$bcb(1176, 546, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$n5d);
$61de1ee1cac498ae$var$_.Ck = function o5d() {
    return true;
};
var $61de1ee1cac498ae$var$h9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseEList/ManyInverse", 1176);
$61de1ee1cac498ae$var$bcb(625, 546, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$p5d);
$61de1ee1cac498ae$var$_.ci = function q5d() {
    this.a = true;
};
$61de1ee1cac498ae$var$_.fj = function r5d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Xj = function s5d() {
    var a;
    $61de1ee1cac498ae$var$Uxd(this);
    if ($61de1ee1cac498ae$var$oid(this.e)) {
        a = this.a;
        this.a = false;
        $61de1ee1cac498ae$var$Uhd(this.e, new $61de1ee1cac498ae$var$qSd(this.e, 2, this.c, a, false));
    } else this.a = false;
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$j9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseEList/Unsettable", 625);
$61de1ee1cac498ae$var$bcb(1175, 625, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$t5d);
$61de1ee1cac498ae$var$_.Ck = function u5d() {
    return true;
};
var $61de1ee1cac498ae$var$i9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseEList/Unsettable/ManyInverse", 1175);
$61de1ee1cac498ae$var$bcb(749, 546, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$v5d);
$61de1ee1cac498ae$var$_.Ek = function w5d() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function x5d(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$o9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseResolvingEList", 749);
$61de1ee1cac498ae$var$bcb(31, 749, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$y5d);
$61de1ee1cac498ae$var$_.Ck = function z5d() {
    return true;
};
var $61de1ee1cac498ae$var$l9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseResolvingEList/ManyInverse", 31);
$61de1ee1cac498ae$var$bcb(750, 625, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$A5d);
$61de1ee1cac498ae$var$_.Ek = function B5d() {
    return true;
};
$61de1ee1cac498ae$var$_.li = function C5d(a, b) {
    return $61de1ee1cac498ae$var$ILd(this, a, $61de1ee1cac498ae$var$BD(b, 56));
};
var $61de1ee1cac498ae$var$n9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseResolvingEList/Unsettable", 750);
$61de1ee1cac498ae$var$bcb(1174, 750, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$D5d);
$61de1ee1cac498ae$var$_.Ck = function E5d() {
    return true;
};
var $61de1ee1cac498ae$var$m9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EObjectWithInverseResolvingEList/Unsettable/ManyInverse", 1174);
$61de1ee1cac498ae$var$bcb(1164, 622, $61de1ee1cac498ae$var$Pve);
$61de1ee1cac498ae$var$_.ai = function F5d() {
    return (this.b & 1792) == 0;
};
$61de1ee1cac498ae$var$_.ci = function G5d() {
    this.b |= 1;
};
$61de1ee1cac498ae$var$_.Bk = function H5d() {
    return (this.b & 4) != 0;
};
$61de1ee1cac498ae$var$_.bj = function I5d() {
    return (this.b & 40) != 0;
};
$61de1ee1cac498ae$var$_.Ck = function J5d() {
    return (this.b & 16) != 0;
};
$61de1ee1cac498ae$var$_.Dk = function K5d() {
    return (this.b & 8) != 0;
};
$61de1ee1cac498ae$var$_.Ek = function L5d() {
    return (this.b & $61de1ee1cac498ae$var$Dve) != 0;
};
$61de1ee1cac498ae$var$_.rk = function M5d() {
    return (this.b & 32) != 0;
};
$61de1ee1cac498ae$var$_.Fk = function N5d() {
    return (this.b & $61de1ee1cac498ae$var$zte) != 0;
};
$61de1ee1cac498ae$var$_.wj = function O5d(a) {
    return !this.d ? this.ak().Yj().wj(a) : $61de1ee1cac498ae$var$qEd(this.d, a);
};
$61de1ee1cac498ae$var$_.fj = function P5d() {
    return (this.b & 2) != 0 ? (this.b & 1) != 0 : this.i != 0;
};
$61de1ee1cac498ae$var$_.hi = function Q5d() {
    return (this.b & 128) != 0;
};
$61de1ee1cac498ae$var$_.Xj = function S5d() {
    var a;
    $61de1ee1cac498ae$var$Uxd(this);
    if ((this.b & 2) != 0) {
        if ($61de1ee1cac498ae$var$oid(this.e)) {
            a = (this.b & 1) != 0;
            this.b &= -2;
            $61de1ee1cac498ae$var$GLd(this, new $61de1ee1cac498ae$var$qSd(this.e, 2, $61de1ee1cac498ae$var$bLd(this.e.Tg(), this.ak()), a, false));
        } else this.b &= -2;
    }
};
$61de1ee1cac498ae$var$_.ni = function T5d() {
    return (this.b & 1536) == 0;
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$q9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEList/Generic", 1164);
$61de1ee1cac498ae$var$bcb(1165, 1164, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$U5d);
$61de1ee1cac498ae$var$_.ak = function V5d() {
    return this.a;
};
var $61de1ee1cac498ae$var$p9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEList/Dynamic", 1165);
$61de1ee1cac498ae$var$bcb(747, 63, $61de1ee1cac498ae$var$oue, $61de1ee1cac498ae$var$W5d);
$61de1ee1cac498ae$var$_.ri = function X5d(a) {
    return $61de1ee1cac498ae$var$izd(this.a.a, a);
};
var $61de1ee1cac498ae$var$u9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEMap/1", 747);
$61de1ee1cac498ae$var$bcb(746, 85, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$Y5d);
$61de1ee1cac498ae$var$_.bi = function Z5d(a, b) {
    $61de1ee1cac498ae$var$uAd(this.b, $61de1ee1cac498ae$var$BD(b, 133));
};
$61de1ee1cac498ae$var$_.di = function $5d(a, b) {
    $61de1ee1cac498ae$var$tAd(this.b);
};
$61de1ee1cac498ae$var$_.ei = function _5d(a, b, c) {
    var d;
    ++(d = this.b, $61de1ee1cac498ae$var$BD(b, 133), d).e;
};
$61de1ee1cac498ae$var$_.fi = function a6d(a, b) {
    $61de1ee1cac498ae$var$vAd(this.b, $61de1ee1cac498ae$var$BD(b, 133));
};
$61de1ee1cac498ae$var$_.gi = function b6d(a, b, c) {
    $61de1ee1cac498ae$var$vAd(this.b, $61de1ee1cac498ae$var$BD(c, 133));
    $61de1ee1cac498ae$var$PD(c) === $61de1ee1cac498ae$var$PD(b) && $61de1ee1cac498ae$var$BD(c, 133).Th($61de1ee1cac498ae$var$CAd($61de1ee1cac498ae$var$BD(b, 133).cd()));
    $61de1ee1cac498ae$var$uAd(this.b, $61de1ee1cac498ae$var$BD(b, 133));
};
var $61de1ee1cac498ae$var$v9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEMap/DelegateEObjectContainmentEList", 746);
$61de1ee1cac498ae$var$bcb(1171, 151, $61de1ee1cac498ae$var$Ave, $61de1ee1cac498ae$var$c6d);
var $61de1ee1cac498ae$var$x9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEMap/Unsettable", 1171);
$61de1ee1cac498ae$var$bcb(1172, 746, $61de1ee1cac498ae$var$Pve, $61de1ee1cac498ae$var$d6d);
$61de1ee1cac498ae$var$_.ci = function e6d() {
    this.a = true;
};
$61de1ee1cac498ae$var$_.fj = function f6d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.Xj = function g6d() {
    var a;
    $61de1ee1cac498ae$var$Uxd(this);
    if ($61de1ee1cac498ae$var$oid(this.e)) {
        a = this.a;
        this.a = false;
        $61de1ee1cac498ae$var$Uhd(this.e, new $61de1ee1cac498ae$var$qSd(this.e, 2, this.c, a, false));
    } else this.a = false;
};
$61de1ee1cac498ae$var$_.a = false;
var $61de1ee1cac498ae$var$w9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreEMap/Unsettable/UnsettableDelegateEObjectContainmentEList", 1172);
$61de1ee1cac498ae$var$bcb(1168, 228, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$A6d);
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.b = false;
var $61de1ee1cac498ae$var$A9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreUtil/Copier", 1168);
$61de1ee1cac498ae$var$bcb(745, 1, $61de1ee1cac498ae$var$aie, $61de1ee1cac498ae$var$C6d);
$61de1ee1cac498ae$var$_.Nb = function D6d(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Ob = function E6d() {
    return $61de1ee1cac498ae$var$B6d(this);
};
$61de1ee1cac498ae$var$_.Pb = function F6d() {
    var a;
    $61de1ee1cac498ae$var$B6d(this);
    a = this.b;
    this.b = null;
    return a;
};
$61de1ee1cac498ae$var$_.Qb = function G6d() {
    this.a.Qb();
};
var $61de1ee1cac498ae$var$B9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreUtil/ProperContentIterator", 745);
$61de1ee1cac498ae$var$bcb(1382, 1381, {}, $61de1ee1cac498ae$var$J6d);
var $61de1ee1cac498ae$var$H6d;
var $61de1ee1cac498ae$var$C9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "EcoreValidator", 1382);
var $61de1ee1cac498ae$var$P6d;
var $61de1ee1cac498ae$var$N9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/Validator");
$61de1ee1cac498ae$var$bcb(1260, 1, {
    1942: 1
}, $61de1ee1cac498ae$var$U6d);
$61de1ee1cac498ae$var$_.rl = function V6d(a) {
    return true;
};
var $61de1ee1cac498ae$var$F9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/1", 1260);
$61de1ee1cac498ae$var$bcb(757, 1, {
    1942: 1
}, $61de1ee1cac498ae$var$Z6d);
$61de1ee1cac498ae$var$_.rl = function $6d(a) {
    var b;
    if (this.c == a) return true;
    b = $61de1ee1cac498ae$var$DD($61de1ee1cac498ae$var$Ohb(this.a, a));
    if (b == null) {
        if ($61de1ee1cac498ae$var$Y6d(this, a)) {
            $61de1ee1cac498ae$var$_6d(this.a, a, ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Acb));
            return true;
        } else {
            $61de1ee1cac498ae$var$_6d(this.a, a, ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$zcb));
            return false;
        }
    } else return b == ($61de1ee1cac498ae$var$Bcb(), $61de1ee1cac498ae$var$Acb);
};
$61de1ee1cac498ae$var$_.e = false;
var $61de1ee1cac498ae$var$W6d;
var $61de1ee1cac498ae$var$I9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/BasicValidator", 757);
$61de1ee1cac498ae$var$bcb(758, 43, $61de1ee1cac498ae$var$fke, $61de1ee1cac498ae$var$a7d);
var $61de1ee1cac498ae$var$H9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/BasicValidator/Cache", 758);
$61de1ee1cac498ae$var$bcb(501, 52, {
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    58: 1,
    76: 1,
    69: 1,
    95: 1
}, $61de1ee1cac498ae$var$f7d);
$61de1ee1cac498ae$var$_.Vc = function g7d(a, b) {
    $61de1ee1cac498ae$var$p2d(this.c, this.b, a, b);
};
$61de1ee1cac498ae$var$_.Fc = function h7d(a) {
    return $61de1ee1cac498ae$var$q2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.Wc = function i7d(a, b) {
    return $61de1ee1cac498ae$var$s2d(this.c, this.b, a, b);
};
$61de1ee1cac498ae$var$_.Gc = function j7d(a) {
    return $61de1ee1cac498ae$var$b7d(this, a);
};
$61de1ee1cac498ae$var$_.Xh = function k7d(a, b) {
    $61de1ee1cac498ae$var$u2d(this.c, this.b, a, b);
};
$61de1ee1cac498ae$var$_.lk = function l7d(a, b) {
    return $61de1ee1cac498ae$var$x2d(this.c, this.b, a, b);
};
$61de1ee1cac498ae$var$_.pi = function m7d(a) {
    return $61de1ee1cac498ae$var$J2d(this.c, this.b, a, false);
};
$61de1ee1cac498ae$var$_.Zh = function n7d() {
    return $61de1ee1cac498ae$var$y2d(this.c, this.b);
};
$61de1ee1cac498ae$var$_.$h = function o7d() {
    return $61de1ee1cac498ae$var$z2d(this.c, this.b);
};
$61de1ee1cac498ae$var$_._h = function p7d(a) {
    return $61de1ee1cac498ae$var$A2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.mk = function q7d(a, b) {
    return $61de1ee1cac498ae$var$c7d(this, a, b);
};
$61de1ee1cac498ae$var$_.$b = function r7d() {
    $61de1ee1cac498ae$var$d7d(this);
};
$61de1ee1cac498ae$var$_.Hc = function s7d(a) {
    return $61de1ee1cac498ae$var$E2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.Ic = function t7d(a) {
    return $61de1ee1cac498ae$var$G2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.Xb = function u7d(a) {
    return $61de1ee1cac498ae$var$J2d(this.c, this.b, a, true);
};
$61de1ee1cac498ae$var$_.Wj = function v7d(a) {
    return this;
};
$61de1ee1cac498ae$var$_.Xc = function w7d(a) {
    return $61de1ee1cac498ae$var$L2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.dc = function x7d() {
    return $61de1ee1cac498ae$var$e7d(this);
};
$61de1ee1cac498ae$var$_.fj = function y7d() {
    return !$61de1ee1cac498ae$var$R2d(this.c, this.b);
};
$61de1ee1cac498ae$var$_.Kc = function z7d() {
    return $61de1ee1cac498ae$var$S2d(this.c, this.b);
};
$61de1ee1cac498ae$var$_.Yc = function A7d() {
    return $61de1ee1cac498ae$var$U2d(this.c, this.b);
};
$61de1ee1cac498ae$var$_.Zc = function B7d(a) {
    return $61de1ee1cac498ae$var$V2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.ii = function C7d(a, b) {
    return $61de1ee1cac498ae$var$X2d(this.c, this.b, a, b);
};
$61de1ee1cac498ae$var$_.ji = function D7d(a, b) {
    $61de1ee1cac498ae$var$Y2d(this.c, this.b, a, b);
};
$61de1ee1cac498ae$var$_.$c = function E7d(a) {
    return $61de1ee1cac498ae$var$Z2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.Mc = function F7d(a) {
    return $61de1ee1cac498ae$var$$2d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_._c = function G7d(a, b) {
    return $61de1ee1cac498ae$var$e3d(this.c, this.b, a, b);
};
$61de1ee1cac498ae$var$_.Wb = function H7d(a) {
    $61de1ee1cac498ae$var$D2d(this.c, this.b);
    $61de1ee1cac498ae$var$b7d(this, $61de1ee1cac498ae$var$BD(a, 15));
};
$61de1ee1cac498ae$var$_.gc = function I7d() {
    return $61de1ee1cac498ae$var$n3d(this.c, this.b);
};
$61de1ee1cac498ae$var$_.Pc = function J7d() {
    return $61de1ee1cac498ae$var$o3d(this.c, this.b);
};
$61de1ee1cac498ae$var$_.Qc = function K7d(a) {
    return $61de1ee1cac498ae$var$q3d(this.c, this.b, a);
};
$61de1ee1cac498ae$var$_.Ib = function L7d() {
    var a, b;
    b = new $61de1ee1cac498ae$var$Hfb;
    b.a += "[";
    for(a = $61de1ee1cac498ae$var$y2d(this.c, this.b); $61de1ee1cac498ae$var$b4d(a);){
        $61de1ee1cac498ae$var$Efb(b, $61de1ee1cac498ae$var$xfb($61de1ee1cac498ae$var$d4d(a)));
        $61de1ee1cac498ae$var$b4d(a) && (b.a += $61de1ee1cac498ae$var$She, b);
    }
    b.a += "]";
    return b.a;
};
$61de1ee1cac498ae$var$_.Xj = function M7d() {
    $61de1ee1cac498ae$var$D2d(this.c, this.b);
};
var $61de1ee1cac498ae$var$J9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/FeatureEList", 501);
$61de1ee1cac498ae$var$bcb(627, 36, $61de1ee1cac498ae$var$fve, $61de1ee1cac498ae$var$O7d);
$61de1ee1cac498ae$var$_.yi = function P7d(a) {
    return $61de1ee1cac498ae$var$N7d(this, a);
};
$61de1ee1cac498ae$var$_.Di = function Q7d(a) {
    var b, c, d, e, f, g, h;
    switch(this.d){
        case 1:
        case 2:
            f = a.Ai();
            if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.c) && $61de1ee1cac498ae$var$N7d(this, null) == a.yi(null)) {
                this.g = a.zi();
                a.xi() == 1 && (this.d = 1);
                return true;
            }
            break;
        case 3:
            e = a.xi();
            switch(e){
                case 3:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.c) && $61de1ee1cac498ae$var$N7d(this, null) == a.yi(null)) {
                        this.d = 5;
                        b = new $61de1ee1cac498ae$var$zud(2);
                        $61de1ee1cac498ae$var$wtd(b, this.g);
                        $61de1ee1cac498ae$var$wtd(b, a.zi());
                        this.g = b;
                        return true;
                    }
                    break;
            }
            break;
        case 5:
            e = a.xi();
            switch(e){
                case 3:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.c) && $61de1ee1cac498ae$var$N7d(this, null) == a.yi(null)) {
                        c = $61de1ee1cac498ae$var$BD(this.g, 14);
                        c.Fc(a.zi());
                        return true;
                    }
                    break;
            }
            break;
        case 4:
            e = a.xi();
            switch(e){
                case 3:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.c) && $61de1ee1cac498ae$var$N7d(this, null) == a.yi(null)) {
                        this.d = 1;
                        this.g = a.zi();
                        return true;
                    }
                    break;
                case 4:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.c) && $61de1ee1cac498ae$var$N7d(this, null) == a.yi(null)) {
                        this.d = 6;
                        h = new $61de1ee1cac498ae$var$zud(2);
                        $61de1ee1cac498ae$var$wtd(h, this.n);
                        $61de1ee1cac498ae$var$wtd(h, a.Bi());
                        this.n = h;
                        g = $61de1ee1cac498ae$var$OC($61de1ee1cac498ae$var$GC($61de1ee1cac498ae$var$WD, 1), $61de1ee1cac498ae$var$oje, 25, 15, [
                            this.o,
                            a.Ci()
                        ]);
                        this.g = g;
                        return true;
                    }
                    break;
            }
            break;
        case 6:
            e = a.xi();
            switch(e){
                case 4:
                    f = a.Ai();
                    if ($61de1ee1cac498ae$var$PD(f) === $61de1ee1cac498ae$var$PD(this.c) && $61de1ee1cac498ae$var$N7d(this, null) == a.yi(null)) {
                        c = $61de1ee1cac498ae$var$BD(this.n, 14);
                        c.Fc(a.Bi());
                        g = $61de1ee1cac498ae$var$BD(this.g, 48);
                        d = $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$WD, $61de1ee1cac498ae$var$oje, 25, g.length + 1, 15, 1);
                        $61de1ee1cac498ae$var$$fb(g, 0, d, 0, g.length);
                        d[g.length] = a.Ci();
                        this.g = d;
                        return true;
                    }
                    break;
            }
            break;
    }
    return false;
};
var $61de1ee1cac498ae$var$K9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/FeatureENotificationImpl", 627);
$61de1ee1cac498ae$var$bcb(552, 501, {
    20: 1,
    28: 1,
    52: 1,
    14: 1,
    15: 1,
    58: 1,
    76: 1,
    153: 1,
    215: 1,
    1937: 1,
    69: 1,
    95: 1
}, $61de1ee1cac498ae$var$R7d);
$61de1ee1cac498ae$var$_.dl = function S7d(a, b) {
    return $61de1ee1cac498ae$var$q2d(this.c, a, b);
};
$61de1ee1cac498ae$var$_.el = function T7d(a, b, c) {
    return $61de1ee1cac498ae$var$x2d(this.c, a, b, c);
};
$61de1ee1cac498ae$var$_.fl = function U7d(a, b, c) {
    return $61de1ee1cac498ae$var$C2d(this.c, a, b, c);
};
$61de1ee1cac498ae$var$_.gl = function V7d() {
    return this;
};
$61de1ee1cac498ae$var$_.hl = function W7d(a, b) {
    return $61de1ee1cac498ae$var$K2d(this.c, a, b);
};
$61de1ee1cac498ae$var$_.il = function X7d(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$J2d(this.c, this.b, a, false), 72).ak();
};
$61de1ee1cac498ae$var$_.jl = function Y7d(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$J2d(this.c, this.b, a, false), 72).dd();
};
$61de1ee1cac498ae$var$_.kl = function Z7d() {
    return this.a;
};
$61de1ee1cac498ae$var$_.ll = function $7d(a) {
    return !$61de1ee1cac498ae$var$R2d(this.c, a);
};
$61de1ee1cac498ae$var$_.ml = function _7d(a, b) {
    $61de1ee1cac498ae$var$f3d(this.c, a, b);
};
$61de1ee1cac498ae$var$_.nl = function a8d(a) {
    return $61de1ee1cac498ae$var$g3d(this.c, a);
};
$61de1ee1cac498ae$var$_.ol = function b8d(a) {
    $61de1ee1cac498ae$var$s3d(this.c, a);
};
var $61de1ee1cac498ae$var$L9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/FeatureFeatureMap", 552);
$61de1ee1cac498ae$var$bcb(1259, 1, $61de1ee1cac498ae$var$zve, $61de1ee1cac498ae$var$c8d);
$61de1ee1cac498ae$var$_.Wj = function d8d(a) {
    return $61de1ee1cac498ae$var$J2d(this.b, this.a, -1, a);
};
$61de1ee1cac498ae$var$_.fj = function e8d() {
    return !$61de1ee1cac498ae$var$R2d(this.b, this.a);
};
$61de1ee1cac498ae$var$_.Wb = function f8d(a) {
    $61de1ee1cac498ae$var$f3d(this.b, this.a, a);
};
$61de1ee1cac498ae$var$_.Xj = function g8d() {
    $61de1ee1cac498ae$var$D2d(this.b, this.a);
};
var $61de1ee1cac498ae$var$M9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$yve, "FeatureMapUtil/FeatureValue", 1259);
var $61de1ee1cac498ae$var$h8d, $61de1ee1cac498ae$var$i8d, $61de1ee1cac498ae$var$j8d, $61de1ee1cac498ae$var$k8d, $61de1ee1cac498ae$var$l8d;
var $61de1ee1cac498ae$var$Q9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Iwe, "AnyType");
$61de1ee1cac498ae$var$bcb(666, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$n8d);
var $61de1ee1cac498ae$var$R9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Iwe, "InvalidDatatypeValueException", 666);
var $61de1ee1cac498ae$var$S9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Iwe, $61de1ee1cac498ae$var$Jwe);
var $61de1ee1cac498ae$var$T9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Iwe, $61de1ee1cac498ae$var$Kwe);
var $61de1ee1cac498ae$var$U9 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Iwe, $61de1ee1cac498ae$var$Lwe);
var $61de1ee1cac498ae$var$o8d;
var $61de1ee1cac498ae$var$q8d;
var $61de1ee1cac498ae$var$s8d, $61de1ee1cac498ae$var$t8d, $61de1ee1cac498ae$var$u8d, $61de1ee1cac498ae$var$v8d, $61de1ee1cac498ae$var$w8d, $61de1ee1cac498ae$var$x8d, $61de1ee1cac498ae$var$y8d, $61de1ee1cac498ae$var$z8d, $61de1ee1cac498ae$var$A8d, $61de1ee1cac498ae$var$B8d, $61de1ee1cac498ae$var$C8d, $61de1ee1cac498ae$var$D8d, $61de1ee1cac498ae$var$E8d, $61de1ee1cac498ae$var$F8d, $61de1ee1cac498ae$var$G8d, $61de1ee1cac498ae$var$H8d, $61de1ee1cac498ae$var$I8d, $61de1ee1cac498ae$var$J8d, $61de1ee1cac498ae$var$K8d, $61de1ee1cac498ae$var$L8d, $61de1ee1cac498ae$var$M8d, $61de1ee1cac498ae$var$N8d, $61de1ee1cac498ae$var$O8d, $61de1ee1cac498ae$var$P8d;
$61de1ee1cac498ae$var$bcb(830, 506, {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    49: 1,
    97: 1,
    843: 1
}, $61de1ee1cac498ae$var$R8d);
$61de1ee1cac498ae$var$_._g = function S8d(a, b, c) {
    switch(a){
        case 0:
            if (c) return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), this.c;
            return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), this.c.b;
        case 1:
            if (c) return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153);
            return (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153), 215)).kl();
        case 2:
            if (c) return !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2)), this.b;
            return !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2)), this.b.b;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? this.zh() : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b, c);
};
$61de1ee1cac498ae$var$_.jh = function T8d(a, b, c) {
    var d;
    switch(b){
        case 0:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$B2d(this.c, a, c);
        case 1:
            return (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153), 69)).mk(a, c);
        case 2:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2)), $61de1ee1cac498ae$var$B2d(this.b, a, c);
    }
    return d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? this.zh() : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), b), 66), d.Nj().Rj(this, $61de1ee1cac498ae$var$Aid(this), b - $61de1ee1cac498ae$var$aLd(this.zh()), a, c);
};
$61de1ee1cac498ae$var$_.lh = function U8d(a) {
    switch(a){
        case 0:
            return !!this.c && this.c.i != 0;
        case 1:
            return !(!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153)).dc();
        case 2:
            return !!this.b && this.b.i != 0;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? this.zh() : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
$61de1ee1cac498ae$var$_.sh = function V8d(a, b) {
    switch(a){
        case 0:
            !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d3d(this.c, b);
            return;
        case 1:
            (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153), 215)).Wb(b);
            return;
        case 2:
            !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2));
            $61de1ee1cac498ae$var$d3d(this.b, b);
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? this.zh() : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b);
};
$61de1ee1cac498ae$var$_.zh = function W8d() {
    return $61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$s8d;
};
$61de1ee1cac498ae$var$_.Bh = function X8d(a) {
    switch(a){
        case 0:
            !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$Uxd(this.c);
            return;
        case 1:
            (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153)).$b();
            return;
        case 2:
            !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2));
            $61de1ee1cac498ae$var$Uxd(this.b);
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(this.zh()), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? this.zh() : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
$61de1ee1cac498ae$var$_.Ib = function Y8d() {
    var a;
    if ((this.j & 4) != 0) return $61de1ee1cac498ae$var$Eid(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(this));
    a.a += " (mixed: ";
    $61de1ee1cac498ae$var$Dfb(a, this.c);
    a.a += ", anyAttribute: ";
    $61de1ee1cac498ae$var$Dfb(a, this.b);
    a.a += ")";
    return a.a;
};
var $61de1ee1cac498ae$var$V9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "AnyTypeImpl", 830);
$61de1ee1cac498ae$var$bcb(667, 506, {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    49: 1,
    97: 1,
    2021: 1,
    667: 1
}, $61de1ee1cac498ae$var$_8d);
$61de1ee1cac498ae$var$_._g = function a9d(a, b, c) {
    switch(a){
        case 0:
            return this.a;
        case 1:
            return this.b;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$F8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$F8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b, c);
};
$61de1ee1cac498ae$var$_.lh = function b9d(a) {
    switch(a){
        case 0:
            return this.a != null;
        case 1:
            return this.b != null;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$F8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$F8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
$61de1ee1cac498ae$var$_.sh = function c9d(a, b) {
    switch(a){
        case 0:
            $61de1ee1cac498ae$var$Z8d(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 1:
            $61de1ee1cac498ae$var$$8d(this, $61de1ee1cac498ae$var$GD(b));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$F8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$F8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b);
};
$61de1ee1cac498ae$var$_.zh = function d9d() {
    return $61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$F8d;
};
$61de1ee1cac498ae$var$_.Bh = function e9d(a) {
    switch(a){
        case 0:
            this.a = null;
            return;
        case 1:
            this.b = null;
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$F8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$F8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
$61de1ee1cac498ae$var$_.Ib = function f9d() {
    var a;
    if ((this.j & 4) != 0) return $61de1ee1cac498ae$var$Eid(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(this));
    a.a += " (data: ";
    $61de1ee1cac498ae$var$Efb(a, this.a);
    a.a += ", target: ";
    $61de1ee1cac498ae$var$Efb(a, this.b);
    a.a += ")";
    return a.a;
};
$61de1ee1cac498ae$var$_.a = null;
$61de1ee1cac498ae$var$_.b = null;
var $61de1ee1cac498ae$var$W9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "ProcessingInstructionImpl", 667);
$61de1ee1cac498ae$var$bcb(668, 830, {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    49: 1,
    97: 1,
    843: 1,
    2022: 1,
    668: 1
}, $61de1ee1cac498ae$var$i9d);
$61de1ee1cac498ae$var$_._g = function j9d(a, b, c) {
    switch(a){
        case 0:
            if (c) return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), this.c;
            return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), this.c.b;
        case 1:
            if (c) return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153);
            return (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153), 215)).kl();
        case 2:
            if (c) return !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2)), this.b;
            return !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2)), this.b.b;
        case 3:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$K2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$I8d), true));
        case 4:
            return $61de1ee1cac498ae$var$j6d(this.a, (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$K2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$I8d), true))));
        case 5:
            return this.a;
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$H8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$H8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b, c);
};
$61de1ee1cac498ae$var$_.lh = function k9d(a) {
    switch(a){
        case 0:
            return !!this.c && this.c.i != 0;
        case 1:
            return !(!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153)).dc();
        case 2:
            return !!this.b && this.b.i != 0;
        case 3:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$K2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$I8d), true)) != null;
        case 4:
            return $61de1ee1cac498ae$var$j6d(this.a, (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$K2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$I8d), true)))) != null;
        case 5:
            return !!this.a;
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$H8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$H8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
$61de1ee1cac498ae$var$_.sh = function l9d(a, b) {
    switch(a){
        case 0:
            !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d3d(this.c, b);
            return;
        case 1:
            (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153), 215)).Wb(b);
            return;
        case 2:
            !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2));
            $61de1ee1cac498ae$var$d3d(this.b, b);
            return;
        case 3:
            $61de1ee1cac498ae$var$h9d(this, $61de1ee1cac498ae$var$GD(b));
            return;
        case 4:
            $61de1ee1cac498ae$var$h9d(this, $61de1ee1cac498ae$var$h6d(this.a, b));
            return;
        case 5:
            $61de1ee1cac498ae$var$g9d(this, $61de1ee1cac498ae$var$BD(b, 148));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$H8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$H8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b);
};
$61de1ee1cac498ae$var$_.zh = function m9d() {
    return $61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$H8d;
};
$61de1ee1cac498ae$var$_.Bh = function n9d(a) {
    switch(a){
        case 0:
            !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$Uxd(this.c);
            return;
        case 1:
            (!this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$T2d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$t8d)), 153)).$b();
            return;
        case 2:
            !this.b && (this.b = new $61de1ee1cac498ae$var$u3d(this, 2));
            $61de1ee1cac498ae$var$Uxd(this.b);
            return;
        case 3:
            !this.c && (this.c = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$f3d(this.c, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$I8d), null);
            return;
        case 4:
            $61de1ee1cac498ae$var$h9d(this, $61de1ee1cac498ae$var$h6d(this.a, null));
            return;
        case 5:
            this.a = null;
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$H8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$H8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
var $61de1ee1cac498ae$var$X9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "SimpleAnyTypeImpl", 668);
$61de1ee1cac498ae$var$bcb(669, 506, {
    105: 1,
    92: 1,
    90: 1,
    56: 1,
    49: 1,
    97: 1,
    2023: 1,
    669: 1
}, $61de1ee1cac498ae$var$o9d);
$61de1ee1cac498ae$var$_._g = function p9d(a, b, c) {
    switch(a){
        case 0:
            if (c) return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), this.a;
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), this.a.b;
        case 1:
            return c ? (!this.b && (this.b = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 1)), this.b) : (!this.b && (this.b = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 1)), $61de1ee1cac498ae$var$FAd(this.b));
        case 2:
            return c ? (!this.c && (this.c = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 2)), this.c) : (!this.c && (this.c = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 2)), $61de1ee1cac498ae$var$FAd(this.c));
        case 3:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$L8d));
        case 4:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$M8d));
        case 5:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$O8d));
        case 6:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$P8d));
    }
    return $61de1ee1cac498ae$var$bid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$K8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$K8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b, c);
};
$61de1ee1cac498ae$var$_.jh = function q9d(a, b, c) {
    var d;
    switch(b){
        case 0:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$B2d(this.a, a, c);
        case 1:
            return !this.b && (this.b = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 1)), $61de1ee1cac498ae$var$bId(this.b, a, c);
        case 2:
            return !this.c && (this.c = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 2)), $61de1ee1cac498ae$var$bId(this.c, a, c);
        case 5:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), $61de1ee1cac498ae$var$c7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$O8d)), a, c);
    }
    return d = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$K8d) : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), b), 66), d.Nj().Rj(this, $61de1ee1cac498ae$var$Aid(this), b - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$K8d)), a, c);
};
$61de1ee1cac498ae$var$_.lh = function r9d(a) {
    switch(a){
        case 0:
            return !!this.a && this.a.i != 0;
        case 1:
            return !!this.b && this.b.f != 0;
        case 2:
            return !!this.c && this.c.f != 0;
        case 3:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), !$61de1ee1cac498ae$var$e7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$L8d)));
        case 4:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), !$61de1ee1cac498ae$var$e7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$M8d)));
        case 5:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), !$61de1ee1cac498ae$var$e7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$O8d)));
        case 6:
            return !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0)), !$61de1ee1cac498ae$var$e7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$P8d)));
    }
    return $61de1ee1cac498ae$var$cid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$K8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$K8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
$61de1ee1cac498ae$var$_.sh = function s9d(a, b) {
    switch(a){
        case 0:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d3d(this.a, b);
            return;
        case 1:
            !this.b && (this.b = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 1));
            $61de1ee1cac498ae$var$cId(this.b, b);
            return;
        case 2:
            !this.c && (this.c = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 2));
            $61de1ee1cac498ae$var$cId(this.c, b);
            return;
        case 3:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$L8d)));
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$b7d($61de1ee1cac498ae$var$T2d(this.a, $61de1ee1cac498ae$var$L8d), $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 4:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$M8d)));
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$b7d($61de1ee1cac498ae$var$T2d(this.a, $61de1ee1cac498ae$var$M8d), $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 5:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$O8d)));
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$b7d($61de1ee1cac498ae$var$T2d(this.a, $61de1ee1cac498ae$var$O8d), $61de1ee1cac498ae$var$BD(b, 14));
            return;
        case 6:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$P8d)));
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$b7d($61de1ee1cac498ae$var$T2d(this.a, $61de1ee1cac498ae$var$P8d), $61de1ee1cac498ae$var$BD(b, 14));
            return;
    }
    $61de1ee1cac498ae$var$did(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$K8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$K8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a), b);
};
$61de1ee1cac498ae$var$_.zh = function t9d() {
    return $61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$K8d;
};
$61de1ee1cac498ae$var$_.Bh = function u9d(a) {
    switch(a){
        case 0:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$Uxd(this.a);
            return;
        case 1:
            !this.b && (this.b = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 1));
            this.b.c.$b();
            return;
        case 2:
            !this.c && (this.c = new $61de1ee1cac498ae$var$dId(($61de1ee1cac498ae$var$jGd(), $61de1ee1cac498ae$var$fGd), $61de1ee1cac498ae$var$x6, this, 2));
            this.c.c.$b();
            return;
        case 3:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$L8d)));
            return;
        case 4:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$M8d)));
            return;
        case 5:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$O8d)));
            return;
        case 6:
            !this.a && (this.a = new $61de1ee1cac498ae$var$u3d(this, 0));
            $61de1ee1cac498ae$var$d7d($61de1ee1cac498ae$var$T2d(this.a, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$P8d)));
            return;
    }
    $61de1ee1cac498ae$var$eid(this, a - $61de1ee1cac498ae$var$aLd(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$K8d)), $61de1ee1cac498ae$var$XKd((this.j & 2) == 0 ? $61de1ee1cac498ae$var$K8d : (!this.k && (this.k = new $61de1ee1cac498ae$var$HGd), this.k).ck(), a));
};
$61de1ee1cac498ae$var$_.Ib = function v9d() {
    var a;
    if ((this.j & 4) != 0) return $61de1ee1cac498ae$var$Eid(this);
    a = new $61de1ee1cac498ae$var$Jfb($61de1ee1cac498ae$var$Eid(this));
    a.a += " (mixed: ";
    $61de1ee1cac498ae$var$Dfb(a, this.a);
    a.a += ")";
    return a.a;
};
var $61de1ee1cac498ae$var$Y9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypeDocumentRootImpl", 669);
$61de1ee1cac498ae$var$bcb(1919, 704, {
    105: 1,
    92: 1,
    90: 1,
    471: 1,
    147: 1,
    56: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    114: 1,
    115: 1,
    2024: 1
}, $61de1ee1cac498ae$var$U9d);
$61de1ee1cac498ae$var$_.Ih = function V9d(a, b) {
    switch(a.yj()){
        case 7:
        case 8:
        case 9:
        case 10:
        case 16:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 32:
        case 33:
        case 34:
        case 36:
        case 37:
        case 44:
        case 45:
        case 50:
        case 51:
        case 53:
        case 55:
        case 56:
        case 57:
        case 58:
        case 60:
        case 61:
        case 4:
            return b == null ? null : $61de1ee1cac498ae$var$fcb(b);
        case 19:
        case 28:
        case 29:
        case 35:
        case 38:
        case 39:
        case 41:
        case 46:
        case 52:
        case 54:
        case 5:
            return $61de1ee1cac498ae$var$GD(b);
        case 6:
            return $61de1ee1cac498ae$var$C9d($61de1ee1cac498ae$var$BD(b, 190));
        case 12:
        case 47:
        case 49:
        case 11:
            return $61de1ee1cac498ae$var$Vmd(this, a, b);
        case 13:
            return b == null ? null : $61de1ee1cac498ae$var$qgb($61de1ee1cac498ae$var$BD(b, 240));
        case 15:
        case 14:
            return b == null ? null : $61de1ee1cac498ae$var$D9d($61de1ee1cac498ae$var$Edb($61de1ee1cac498ae$var$ED(b)));
        case 17:
            return $61de1ee1cac498ae$var$E9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 18:
            return $61de1ee1cac498ae$var$E9d(b);
        case 21:
        case 20:
            return b == null ? null : $61de1ee1cac498ae$var$F9d($61de1ee1cac498ae$var$BD(b, 155).a);
        case 27:
            return $61de1ee1cac498ae$var$G9d($61de1ee1cac498ae$var$BD(b, 190));
        case 30:
            return $61de1ee1cac498ae$var$H9d(($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$BD(b, 15)));
        case 31:
            return $61de1ee1cac498ae$var$H9d($61de1ee1cac498ae$var$BD(b, 15));
        case 40:
            return $61de1ee1cac498ae$var$K9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 42:
            return $61de1ee1cac498ae$var$I9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 43:
            return $61de1ee1cac498ae$var$I9d(b);
        case 59:
        case 48:
            return $61de1ee1cac498ae$var$J9d(($61de1ee1cac498ae$var$Q8d(), b));
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + a.ne() + $61de1ee1cac498ae$var$ute));
    }
};
$61de1ee1cac498ae$var$_.Jh = function W9d(a) {
    var b, c, d, e, f;
    switch(a.G == -1 && (a.G = (c = $61de1ee1cac498ae$var$bKd(a), c ? $61de1ee1cac498ae$var$HLd(c.Mh(), a) : -1)), a.G){
        case 0:
            return b = new $61de1ee1cac498ae$var$R8d, b;
        case 1:
            return d = new $61de1ee1cac498ae$var$_8d, d;
        case 2:
            return e = new $61de1ee1cac498ae$var$i9d, e;
        case 3:
            return f = new $61de1ee1cac498ae$var$o9d, f;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$xte + a.zb + $61de1ee1cac498ae$var$ute));
    }
};
$61de1ee1cac498ae$var$_.Kh = function X9d(a, b) {
    var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r;
    switch(a.yj()){
        case 5:
        case 52:
        case 4:
            return b;
        case 6:
            return $61de1ee1cac498ae$var$L9d(b);
        case 8:
        case 7:
            return b == null ? null : $61de1ee1cac498ae$var$B9d(b);
        case 9:
            return b == null ? null : $61de1ee1cac498ae$var$Scb($61de1ee1cac498ae$var$Icb((d = $61de1ee1cac498ae$var$Qge(b, true), d.length > 0 && ($61de1ee1cac498ae$var$BCb(0, d.length), d.charCodeAt(0) == 43) ? d.substr(1) : d), -128, 127) << 24 >> 24);
        case 10:
            return b == null ? null : $61de1ee1cac498ae$var$Scb($61de1ee1cac498ae$var$Icb((e = $61de1ee1cac498ae$var$Qge(b, true), e.length > 0 && ($61de1ee1cac498ae$var$BCb(0, e.length), e.charCodeAt(0) == 43) ? e.substr(1) : e), -128, 127) << 24 >> 24);
        case 11:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$w8d), b));
        case 12:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$x8d), b));
        case 13:
            return b == null ? null : new $61de1ee1cac498ae$var$tgb($61de1ee1cac498ae$var$Qge(b, true));
        case 15:
        case 14:
            return $61de1ee1cac498ae$var$M9d(b);
        case 16:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$y8d), b));
        case 17:
            return $61de1ee1cac498ae$var$N9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 18:
            return $61de1ee1cac498ae$var$N9d(b);
        case 28:
        case 29:
        case 35:
        case 38:
        case 39:
        case 41:
        case 54:
        case 19:
            return $61de1ee1cac498ae$var$Qge(b, true);
        case 21:
        case 20:
            return $61de1ee1cac498ae$var$O9d(b);
        case 22:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$z8d), b));
        case 23:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$A8d), b));
        case 24:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$B8d), b));
        case 25:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$C8d), b));
        case 26:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$D8d), b));
        case 27:
            return $61de1ee1cac498ae$var$P9d(b);
        case 30:
            return $61de1ee1cac498ae$var$Q9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 31:
            return $61de1ee1cac498ae$var$Q9d(b);
        case 32:
            return b == null ? null : $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Icb((k = $61de1ee1cac498ae$var$Qge(b, true), k.length > 0 && ($61de1ee1cac498ae$var$BCb(0, k.length), k.charCodeAt(0) == 43) ? k.substr(1) : k), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe));
        case 33:
            return b == null ? null : new $61de1ee1cac498ae$var$Ygb((l = $61de1ee1cac498ae$var$Qge(b, true), l.length > 0 && ($61de1ee1cac498ae$var$BCb(0, l.length), l.charCodeAt(0) == 43) ? l.substr(1) : l));
        case 34:
            return b == null ? null : $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Icb((m = $61de1ee1cac498ae$var$Qge(b, true), m.length > 0 && ($61de1ee1cac498ae$var$BCb(0, m.length), m.charCodeAt(0) == 43) ? m.substr(1) : m), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe));
        case 36:
            return b == null ? null : $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$Jcb((n = $61de1ee1cac498ae$var$Qge(b, true), n.length > 0 && ($61de1ee1cac498ae$var$BCb(0, n.length), n.charCodeAt(0) == 43) ? n.substr(1) : n)));
        case 37:
            return b == null ? null : $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$Jcb((o = $61de1ee1cac498ae$var$Qge(b, true), o.length > 0 && ($61de1ee1cac498ae$var$BCb(0, o.length), o.charCodeAt(0) == 43) ? o.substr(1) : o)));
        case 40:
            return $61de1ee1cac498ae$var$T9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 42:
            return $61de1ee1cac498ae$var$R9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 43:
            return $61de1ee1cac498ae$var$R9d(b);
        case 44:
            return b == null ? null : new $61de1ee1cac498ae$var$Ygb((p = $61de1ee1cac498ae$var$Qge(b, true), p.length > 0 && ($61de1ee1cac498ae$var$BCb(0, p.length), p.charCodeAt(0) == 43) ? p.substr(1) : p));
        case 45:
            return b == null ? null : new $61de1ee1cac498ae$var$Ygb((q = $61de1ee1cac498ae$var$Qge(b, true), q.length > 0 && ($61de1ee1cac498ae$var$BCb(0, q.length), q.charCodeAt(0) == 43) ? q.substr(1) : q));
        case 46:
            return $61de1ee1cac498ae$var$Qge(b, false);
        case 47:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$E8d), b));
        case 59:
        case 48:
            return $61de1ee1cac498ae$var$S9d(($61de1ee1cac498ae$var$Q8d(), b));
        case 49:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$G8d), b));
        case 50:
            return b == null ? null : $61de1ee1cac498ae$var$Web($61de1ee1cac498ae$var$Icb((r = $61de1ee1cac498ae$var$Qge(b, true), r.length > 0 && ($61de1ee1cac498ae$var$BCb(0, r.length), r.charCodeAt(0) == 43) ? r.substr(1) : r), $61de1ee1cac498ae$var$awe, 32767) << 16 >> 16);
        case 51:
            return b == null ? null : $61de1ee1cac498ae$var$Web($61de1ee1cac498ae$var$Icb((f = $61de1ee1cac498ae$var$Qge(b, true), f.length > 0 && ($61de1ee1cac498ae$var$BCb(0, f.length), f.charCodeAt(0) == 43) ? f.substr(1) : f), $61de1ee1cac498ae$var$awe, 32767) << 16 >> 16);
        case 53:
            return $61de1ee1cac498ae$var$GD($61de1ee1cac498ae$var$Wmd(this, ($61de1ee1cac498ae$var$Q8d(), $61de1ee1cac498ae$var$J8d), b));
        case 55:
            return b == null ? null : $61de1ee1cac498ae$var$Web($61de1ee1cac498ae$var$Icb((g = $61de1ee1cac498ae$var$Qge(b, true), g.length > 0 && ($61de1ee1cac498ae$var$BCb(0, g.length), g.charCodeAt(0) == 43) ? g.substr(1) : g), $61de1ee1cac498ae$var$awe, 32767) << 16 >> 16);
        case 56:
            return b == null ? null : $61de1ee1cac498ae$var$Web($61de1ee1cac498ae$var$Icb((h = $61de1ee1cac498ae$var$Qge(b, true), h.length > 0 && ($61de1ee1cac498ae$var$BCb(0, h.length), h.charCodeAt(0) == 43) ? h.substr(1) : h), $61de1ee1cac498ae$var$awe, 32767) << 16 >> 16);
        case 57:
            return b == null ? null : $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$Jcb((i = $61de1ee1cac498ae$var$Qge(b, true), i.length > 0 && ($61de1ee1cac498ae$var$BCb(0, i.length), i.charCodeAt(0) == 43) ? i.substr(1) : i)));
        case 58:
            return b == null ? null : $61de1ee1cac498ae$var$Aeb($61de1ee1cac498ae$var$Jcb((j = $61de1ee1cac498ae$var$Qge(b, true), j.length > 0 && ($61de1ee1cac498ae$var$BCb(0, j.length), j.charCodeAt(0) == 43) ? j.substr(1) : j)));
        case 60:
            return b == null ? null : $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Icb((c = $61de1ee1cac498ae$var$Qge(b, true), c.length > 0 && ($61de1ee1cac498ae$var$BCb(0, c.length), c.charCodeAt(0) == 43) ? c.substr(1) : c), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe));
        case 61:
            return b == null ? null : $61de1ee1cac498ae$var$meb($61de1ee1cac498ae$var$Icb($61de1ee1cac498ae$var$Qge(b, true), $61de1ee1cac498ae$var$Rie, $61de1ee1cac498ae$var$Ohe));
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$Wdb($61de1ee1cac498ae$var$tte + a.ne() + $61de1ee1cac498ae$var$ute));
    }
};
var $61de1ee1cac498ae$var$w9d, $61de1ee1cac498ae$var$x9d, $61de1ee1cac498ae$var$y9d, $61de1ee1cac498ae$var$z9d;
var $61de1ee1cac498ae$var$Z9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypeFactoryImpl", 1919);
$61de1ee1cac498ae$var$bcb(586, 179, {
    105: 1,
    92: 1,
    90: 1,
    147: 1,
    191: 1,
    56: 1,
    235: 1,
    108: 1,
    49: 1,
    97: 1,
    150: 1,
    179: 1,
    114: 1,
    115: 1,
    675: 1,
    1945: 1,
    586: 1
}, $61de1ee1cac498ae$var$cae);
$61de1ee1cac498ae$var$_.N = false;
$61de1ee1cac498ae$var$_.O = false;
var $61de1ee1cac498ae$var$Z9d = false;
var $61de1ee1cac498ae$var$Yab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl", 586);
$61de1ee1cac498ae$var$bcb(1852, 1, {
    837: 1
}, $61de1ee1cac498ae$var$fae);
$61de1ee1cac498ae$var$_._j = function gae() {
    return $61de1ee1cac498ae$var$Uge(), $61de1ee1cac498ae$var$Tge;
};
var $61de1ee1cac498ae$var$iab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/1", 1852);
$61de1ee1cac498ae$var$bcb(1861, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$hae);
$61de1ee1cac498ae$var$_.wj = function iae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function jae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$$9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/10", 1861);
$61de1ee1cac498ae$var$bcb(1862, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$kae);
$61de1ee1cac498ae$var$_.wj = function lae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function mae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$_9 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/11", 1862);
$61de1ee1cac498ae$var$bcb(1863, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$nae);
$61de1ee1cac498ae$var$_.wj = function oae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function pae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$aab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/12", 1863);
$61de1ee1cac498ae$var$bcb(1864, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$qae);
$61de1ee1cac498ae$var$_.wj = function rae(a) {
    return $61de1ee1cac498ae$var$LD(a);
};
$61de1ee1cac498ae$var$_.xj = function sae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$BI, $61de1ee1cac498ae$var$nie, 333, a, 7, 1);
};
var $61de1ee1cac498ae$var$bab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/13", 1864);
$61de1ee1cac498ae$var$bcb(1865, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$tae);
$61de1ee1cac498ae$var$_.wj = function uae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function vae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$cab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/14", 1865);
$61de1ee1cac498ae$var$bcb(1866, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$wae);
$61de1ee1cac498ae$var$_.wj = function xae(a) {
    return $61de1ee1cac498ae$var$JD(a, 15);
};
$61de1ee1cac498ae$var$_.xj = function yae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, a, 0, 1);
};
var $61de1ee1cac498ae$var$dab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/15", 1866);
$61de1ee1cac498ae$var$bcb(1867, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$zae);
$61de1ee1cac498ae$var$_.wj = function Aae(a) {
    return $61de1ee1cac498ae$var$JD(a, 15);
};
$61de1ee1cac498ae$var$_.xj = function Bae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, a, 0, 1);
};
var $61de1ee1cac498ae$var$eab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/16", 1867);
$61de1ee1cac498ae$var$bcb(1868, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Cae);
$61de1ee1cac498ae$var$_.wj = function Dae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Eae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$fab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/17", 1868);
$61de1ee1cac498ae$var$bcb(1869, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Fae);
$61de1ee1cac498ae$var$_.wj = function Gae(a) {
    return $61de1ee1cac498ae$var$JD(a, 155);
};
$61de1ee1cac498ae$var$_.xj = function Hae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$FI, $61de1ee1cac498ae$var$nie, 155, a, 0, 1);
};
var $61de1ee1cac498ae$var$gab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/18", 1869);
$61de1ee1cac498ae$var$bcb(1870, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Iae);
$61de1ee1cac498ae$var$_.wj = function Jae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Kae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$hab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/19", 1870);
$61de1ee1cac498ae$var$bcb(1853, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Lae);
$61de1ee1cac498ae$var$_.wj = function Mae(a) {
    return $61de1ee1cac498ae$var$JD(a, 843);
};
$61de1ee1cac498ae$var$_.xj = function Nae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$Q9, $61de1ee1cac498ae$var$Uhe, 843, a, 0, 1);
};
var $61de1ee1cac498ae$var$tab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/2", 1853);
$61de1ee1cac498ae$var$bcb(1871, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Oae);
$61de1ee1cac498ae$var$_.wj = function Pae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Qae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$jab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/20", 1871);
$61de1ee1cac498ae$var$bcb(1872, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Rae);
$61de1ee1cac498ae$var$_.wj = function Sae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Tae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$kab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/21", 1872);
$61de1ee1cac498ae$var$bcb(1873, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Uae);
$61de1ee1cac498ae$var$_.wj = function Vae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Wae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$lab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/22", 1873);
$61de1ee1cac498ae$var$bcb(1874, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Xae);
$61de1ee1cac498ae$var$_.wj = function Yae(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Zae(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$mab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/23", 1874);
$61de1ee1cac498ae$var$bcb(1875, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$$ae);
$61de1ee1cac498ae$var$_.wj = function _ae(a) {
    return $61de1ee1cac498ae$var$JD(a, 190);
};
$61de1ee1cac498ae$var$_.xj = function abe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$nie, 190, a, 0, 2);
};
var $61de1ee1cac498ae$var$nab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/24", 1875);
$61de1ee1cac498ae$var$bcb(1876, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$bbe);
$61de1ee1cac498ae$var$_.wj = function cbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function dbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$oab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/25", 1876);
$61de1ee1cac498ae$var$bcb(1877, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$ebe);
$61de1ee1cac498ae$var$_.wj = function fbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function gbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$pab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/26", 1877);
$61de1ee1cac498ae$var$bcb(1878, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$hbe);
$61de1ee1cac498ae$var$_.wj = function ibe(a) {
    return $61de1ee1cac498ae$var$JD(a, 15);
};
$61de1ee1cac498ae$var$_.xj = function jbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, a, 0, 1);
};
var $61de1ee1cac498ae$var$qab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/27", 1878);
$61de1ee1cac498ae$var$bcb(1879, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$kbe);
$61de1ee1cac498ae$var$_.wj = function lbe(a) {
    return $61de1ee1cac498ae$var$JD(a, 15);
};
$61de1ee1cac498ae$var$_.xj = function mbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, a, 0, 1);
};
var $61de1ee1cac498ae$var$rab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/28", 1879);
$61de1ee1cac498ae$var$bcb(1880, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$nbe);
$61de1ee1cac498ae$var$_.wj = function obe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function pbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$sab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/29", 1880);
$61de1ee1cac498ae$var$bcb(1854, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$qbe);
$61de1ee1cac498ae$var$_.wj = function rbe(a) {
    return $61de1ee1cac498ae$var$JD(a, 667);
};
$61de1ee1cac498ae$var$_.xj = function sbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$S9, $61de1ee1cac498ae$var$Uhe, 2021, a, 0, 1);
};
var $61de1ee1cac498ae$var$Eab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/3", 1854);
$61de1ee1cac498ae$var$bcb(1881, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$tbe);
$61de1ee1cac498ae$var$_.wj = function ube(a) {
    return $61de1ee1cac498ae$var$JD(a, 19);
};
$61de1ee1cac498ae$var$_.xj = function vbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$JI, $61de1ee1cac498ae$var$nie, 19, a, 0, 1);
};
var $61de1ee1cac498ae$var$uab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/30", 1881);
$61de1ee1cac498ae$var$bcb(1882, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$wbe);
$61de1ee1cac498ae$var$_.wj = function xbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function ybe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$vab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/31", 1882);
$61de1ee1cac498ae$var$bcb(1883, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$zbe);
$61de1ee1cac498ae$var$_.wj = function Abe(a) {
    return $61de1ee1cac498ae$var$JD(a, 162);
};
$61de1ee1cac498ae$var$_.xj = function Bbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$MI, $61de1ee1cac498ae$var$nie, 162, a, 0, 1);
};
var $61de1ee1cac498ae$var$wab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/32", 1883);
$61de1ee1cac498ae$var$bcb(1884, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Cbe);
$61de1ee1cac498ae$var$_.wj = function Dbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Ebe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$xab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/33", 1884);
$61de1ee1cac498ae$var$bcb(1885, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Fbe);
$61de1ee1cac498ae$var$_.wj = function Gbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Hbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$yab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/34", 1885);
$61de1ee1cac498ae$var$bcb(1886, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Ibe);
$61de1ee1cac498ae$var$_.wj = function Jbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Kbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$zab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/35", 1886);
$61de1ee1cac498ae$var$bcb(1887, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Lbe);
$61de1ee1cac498ae$var$_.wj = function Mbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Nbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Aab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/36", 1887);
$61de1ee1cac498ae$var$bcb(1888, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Obe);
$61de1ee1cac498ae$var$_.wj = function Pbe(a) {
    return $61de1ee1cac498ae$var$JD(a, 15);
};
$61de1ee1cac498ae$var$_.xj = function Qbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, a, 0, 1);
};
var $61de1ee1cac498ae$var$Bab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/37", 1888);
$61de1ee1cac498ae$var$bcb(1889, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Rbe);
$61de1ee1cac498ae$var$_.wj = function Sbe(a) {
    return $61de1ee1cac498ae$var$JD(a, 15);
};
$61de1ee1cac498ae$var$_.xj = function Tbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$yK, $61de1ee1cac498ae$var$eme, 15, a, 0, 1);
};
var $61de1ee1cac498ae$var$Cab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/38", 1889);
$61de1ee1cac498ae$var$bcb(1890, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Ube);
$61de1ee1cac498ae$var$_.wj = function Vbe(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Wbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Dab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/39", 1890);
$61de1ee1cac498ae$var$bcb(1855, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Xbe);
$61de1ee1cac498ae$var$_.wj = function Ybe(a) {
    return $61de1ee1cac498ae$var$JD(a, 668);
};
$61de1ee1cac498ae$var$_.xj = function Zbe(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$T9, $61de1ee1cac498ae$var$Uhe, 2022, a, 0, 1);
};
var $61de1ee1cac498ae$var$Pab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/4", 1855);
$61de1ee1cac498ae$var$bcb(1891, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$$be);
$61de1ee1cac498ae$var$_.wj = function _be(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function ace(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Fab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/40", 1891);
$61de1ee1cac498ae$var$bcb(1892, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$bce);
$61de1ee1cac498ae$var$_.wj = function cce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function dce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Gab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/41", 1892);
$61de1ee1cac498ae$var$bcb(1893, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$ece);
$61de1ee1cac498ae$var$_.wj = function fce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function gce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Hab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/42", 1893);
$61de1ee1cac498ae$var$bcb(1894, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$hce);
$61de1ee1cac498ae$var$_.wj = function ice(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function jce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Iab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/43", 1894);
$61de1ee1cac498ae$var$bcb(1895, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$kce);
$61de1ee1cac498ae$var$_.wj = function lce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function mce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Jab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/44", 1895);
$61de1ee1cac498ae$var$bcb(1896, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$nce);
$61de1ee1cac498ae$var$_.wj = function oce(a) {
    return $61de1ee1cac498ae$var$JD(a, 184);
};
$61de1ee1cac498ae$var$_.xj = function pce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UI, $61de1ee1cac498ae$var$nie, 184, a, 0, 1);
};
var $61de1ee1cac498ae$var$Kab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/45", 1896);
$61de1ee1cac498ae$var$bcb(1897, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$qce);
$61de1ee1cac498ae$var$_.wj = function rce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function sce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Lab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/46", 1897);
$61de1ee1cac498ae$var$bcb(1898, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$tce);
$61de1ee1cac498ae$var$_.wj = function uce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function vce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Mab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/47", 1898);
$61de1ee1cac498ae$var$bcb(1899, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$wce);
$61de1ee1cac498ae$var$_.wj = function xce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function yce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Nab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/48", 1899);
$61de1ee1cac498ae$var$bcb($61de1ee1cac498ae$var$nje, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$zce);
$61de1ee1cac498ae$var$_.wj = function Ace(a) {
    return $61de1ee1cac498ae$var$JD(a, 184);
};
$61de1ee1cac498ae$var$_.xj = function Bce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$UI, $61de1ee1cac498ae$var$nie, 184, a, 0, 1);
};
var $61de1ee1cac498ae$var$Oab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/49", $61de1ee1cac498ae$var$nje);
$61de1ee1cac498ae$var$bcb(1856, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Cce);
$61de1ee1cac498ae$var$_.wj = function Dce(a) {
    return $61de1ee1cac498ae$var$JD(a, 669);
};
$61de1ee1cac498ae$var$_.xj = function Ece(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$U9, $61de1ee1cac498ae$var$Uhe, 2023, a, 0, 1);
};
var $61de1ee1cac498ae$var$Tab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/5", 1856);
$61de1ee1cac498ae$var$bcb(1901, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Fce);
$61de1ee1cac498ae$var$_.wj = function Gce(a) {
    return $61de1ee1cac498ae$var$JD(a, 162);
};
$61de1ee1cac498ae$var$_.xj = function Hce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$MI, $61de1ee1cac498ae$var$nie, 162, a, 0, 1);
};
var $61de1ee1cac498ae$var$Qab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/50", 1901);
$61de1ee1cac498ae$var$bcb(1902, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Ice);
$61de1ee1cac498ae$var$_.wj = function Jce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Kce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Rab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/51", 1902);
$61de1ee1cac498ae$var$bcb(1903, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Lce);
$61de1ee1cac498ae$var$_.wj = function Mce(a) {
    return $61de1ee1cac498ae$var$JD(a, 19);
};
$61de1ee1cac498ae$var$_.xj = function Nce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$JI, $61de1ee1cac498ae$var$nie, 19, a, 0, 1);
};
var $61de1ee1cac498ae$var$Sab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/52", 1903);
$61de1ee1cac498ae$var$bcb(1857, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Oce);
$61de1ee1cac498ae$var$_.wj = function Pce(a) {
    return $61de1ee1cac498ae$var$ND(a);
};
$61de1ee1cac498ae$var$_.xj = function Qce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$ZI, $61de1ee1cac498ae$var$nie, 2, a, 6, 1);
};
var $61de1ee1cac498ae$var$Uab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/6", 1857);
$61de1ee1cac498ae$var$bcb(1858, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Rce);
$61de1ee1cac498ae$var$_.wj = function Sce(a) {
    return $61de1ee1cac498ae$var$JD(a, 190);
};
$61de1ee1cac498ae$var$_.xj = function Tce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$SD, $61de1ee1cac498ae$var$nie, 190, a, 0, 2);
};
var $61de1ee1cac498ae$var$Vab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/7", 1858);
$61de1ee1cac498ae$var$bcb(1859, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Uce);
$61de1ee1cac498ae$var$_.wj = function Vce(a) {
    return $61de1ee1cac498ae$var$KD(a);
};
$61de1ee1cac498ae$var$_.xj = function Wce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$wI, $61de1ee1cac498ae$var$nie, 476, a, 8, 1);
};
var $61de1ee1cac498ae$var$Wab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/8", 1859);
$61de1ee1cac498ae$var$bcb(1860, 1, $61de1ee1cac498ae$var$nwe, $61de1ee1cac498ae$var$Xce);
$61de1ee1cac498ae$var$_.wj = function Yce(a) {
    return $61de1ee1cac498ae$var$JD(a, 217);
};
$61de1ee1cac498ae$var$_.xj = function Zce(a) {
    return $61de1ee1cac498ae$var$KC($61de1ee1cac498ae$var$xI, $61de1ee1cac498ae$var$nie, 217, a, 0, 1);
};
var $61de1ee1cac498ae$var$Xab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Mwe, "XMLTypePackageImpl/9", 1860);
var $61de1ee1cac498ae$var$$ce, $61de1ee1cac498ae$var$_ce;
var $61de1ee1cac498ae$var$fde, $61de1ee1cac498ae$var$gde;
var $61de1ee1cac498ae$var$kde;
$61de1ee1cac498ae$var$bcb(50, 60, $61de1ee1cac498ae$var$Tie, $61de1ee1cac498ae$var$mde);
var $61de1ee1cac498ae$var$Zab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/ParseException", 50);
$61de1ee1cac498ae$var$bcb(820, 1, {}, $61de1ee1cac498ae$var$ude);
$61de1ee1cac498ae$var$_.sl = function vde(a) {
    return a < this.j && $61de1ee1cac498ae$var$bfb(this.i, a) == 63;
};
$61de1ee1cac498ae$var$_.tl = function wde() {
    var a, b, c, d, e;
    if (this.c != 10) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$uue))));
    a = this.a;
    switch(a){
        case 101:
            a = 27;
            break;
        case 102:
            a = 12;
            break;
        case 110:
            a = 10;
            break;
        case 114:
            a = 13;
            break;
        case 116:
            a = 9;
            break;
        case 120:
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            if (this.a == 123) {
                e = 0;
                c = 0;
                do {
                    $61de1ee1cac498ae$var$nde(this);
                    if (this.c != 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
                    if ((e = $61de1ee1cac498ae$var$yde(this.a)) < 0) break;
                    if (c > c * 16) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Uue))));
                    c = c * 16 + e;
                }while (true);
                if (this.a != 125) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Vue))));
                if (c > $61de1ee1cac498ae$var$lxe) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Wue))));
                a = c;
            } else {
                e = 0;
                if (this.c != 0 || (e = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
                c = e;
                $61de1ee1cac498ae$var$nde(this);
                if (this.c != 0 || (e = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
                c = c * 16 + e;
                a = c;
            }
            break;
        case 117:
            d = 0;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            a = b;
            break;
        case 118:
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 0 || (d = $61de1ee1cac498ae$var$yde(this.a)) < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Tue))));
            b = b * 16 + d;
            if (b > $61de1ee1cac498ae$var$lxe) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), "parser.descappe.4"))));
            a = b;
            break;
        case 65:
        case 90:
        case 122:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Xue))));
    }
    return a;
};
$61de1ee1cac498ae$var$_.ul = function xde(a) {
    var b, c;
    switch(a){
        case 100:
            c = (this.e & 32) == 32 ? $61de1ee1cac498ae$var$Kfe("Nd", true) : ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$cfe);
            break;
        case 68:
            c = (this.e & 32) == 32 ? $61de1ee1cac498ae$var$Kfe("Nd", false) : ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$jfe);
            break;
        case 119:
            c = (this.e & 32) == 32 ? $61de1ee1cac498ae$var$Kfe("IsWord", true) : ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$sfe);
            break;
        case 87:
            c = (this.e & 32) == 32 ? $61de1ee1cac498ae$var$Kfe("IsWord", false) : ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$lfe);
            break;
        case 115:
            c = (this.e & 32) == 32 ? $61de1ee1cac498ae$var$Kfe("IsSpace", true) : ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$nfe);
            break;
        case 83:
            c = (this.e & 32) == 32 ? $61de1ee1cac498ae$var$Kfe("IsSpace", false) : ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$kfe);
            break;
        default:
            throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz((b = a, $61de1ee1cac498ae$var$mxe + b.toString(16))));
    }
    return c;
};
$61de1ee1cac498ae$var$_.vl = function zde(a) {
    var b, c, d, e, f, g, h, i, j, k, l, m;
    this.b = 1;
    $61de1ee1cac498ae$var$nde(this);
    b = null;
    if (this.c == 0 && this.a == 94) {
        $61de1ee1cac498ae$var$nde(this);
        if (a) k = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(5));
        else {
            b = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
            $61de1ee1cac498ae$var$Ufe(b, 0, $61de1ee1cac498ae$var$lxe);
            k = (++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
        }
    } else k = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$$fe(4));
    e = true;
    while((m = this.c) != 1){
        if (m == 0 && this.a == 93 && !e) break;
        e = false;
        c = this.a;
        d = false;
        if (m == 10) switch(c){
            case 100:
            case 68:
            case 119:
            case 87:
            case 115:
            case 83:
                $61de1ee1cac498ae$var$Xfe(k, this.ul(c));
                d = true;
                break;
            case 105:
            case 73:
            case 99:
            case 67:
                c = this.Ll(k, c);
                c < 0 && (d = true);
                break;
            case 112:
            case 80:
                l = $61de1ee1cac498ae$var$tde(this, c);
                if (!l) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Iue))));
                $61de1ee1cac498ae$var$Xfe(k, l);
                d = true;
                break;
            default:
                c = this.tl();
        }
        else if (m == 20) {
            g = $61de1ee1cac498ae$var$gfb(this.i, 58, this.d);
            if (g < 0) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Jue))));
            h = true;
            if ($61de1ee1cac498ae$var$bfb(this.i, this.d) == 94) {
                ++this.d;
                h = false;
            }
            f = $61de1ee1cac498ae$var$qfb(this.i, this.d, g);
            i = $61de1ee1cac498ae$var$Lfe(f, h, (this.e & 512) == 512);
            if (!i) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Lue))));
            $61de1ee1cac498ae$var$Xfe(k, i);
            d = true;
            if (g + 1 >= this.j || $61de1ee1cac498ae$var$bfb(this.i, g + 1) != 93) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Jue))));
            this.d = g + 2;
        }
        $61de1ee1cac498ae$var$nde(this);
        if (!d) {
            if (this.c != 0 || this.a != 45) $61de1ee1cac498ae$var$Ufe(k, c, c);
            else {
                $61de1ee1cac498ae$var$nde(this);
                if ((m = this.c) == 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Kue))));
                if (m == 0 && this.a == 93) {
                    $61de1ee1cac498ae$var$Ufe(k, c, c);
                    $61de1ee1cac498ae$var$Ufe(k, 45, 45);
                } else {
                    j = this.a;
                    m == 10 && (j = this.tl());
                    $61de1ee1cac498ae$var$nde(this);
                    $61de1ee1cac498ae$var$Ufe(k, c, j);
                }
            }
        }
        (this.e & $61de1ee1cac498ae$var$zte) == $61de1ee1cac498ae$var$zte && this.c == 0 && this.a == 44 && $61de1ee1cac498ae$var$nde(this);
    }
    if (this.c == 1) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Kue))));
    if (b) {
        $61de1ee1cac498ae$var$Zfe(b, k);
        k = b;
    }
    $61de1ee1cac498ae$var$Yfe(k);
    $61de1ee1cac498ae$var$Vfe(k);
    this.b = 0;
    $61de1ee1cac498ae$var$nde(this);
    return k;
};
$61de1ee1cac498ae$var$_.wl = function Ade() {
    var a, b, c, d;
    c = this.vl(false);
    while((d = this.c) != 7){
        a = this.a;
        if (d == 0 && (a == 45 || a == 38) || d == 4) {
            $61de1ee1cac498ae$var$nde(this);
            if (this.c != 9) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Que))));
            b = this.vl(false);
            if (d == 4) $61de1ee1cac498ae$var$Xfe(c, b);
            else if (a == 45) $61de1ee1cac498ae$var$Zfe(c, b);
            else if (a == 38) $61de1ee1cac498ae$var$Wfe(c, b);
            else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("ASSERT"));
        } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Rue))));
    }
    $61de1ee1cac498ae$var$nde(this);
    return c;
};
$61de1ee1cac498ae$var$_.xl = function Bde() {
    var a, b;
    a = this.a - 48;
    b = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Hge(12, null, a));
    !this.g && (this.g = new $61de1ee1cac498ae$var$Wvb);
    $61de1ee1cac498ae$var$Tvb(this.g, new $61de1ee1cac498ae$var$cge(a));
    $61de1ee1cac498ae$var$nde(this);
    return b;
};
$61de1ee1cac498ae$var$_.yl = function Cde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$ofe;
};
$61de1ee1cac498ae$var$_.zl = function Dde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$mfe;
};
$61de1ee1cac498ae$var$_.Al = function Ede() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Bl = function Fde() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Cl = function Gde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$Ife();
};
$61de1ee1cac498ae$var$_.Dl = function Hde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$qfe;
};
$61de1ee1cac498ae$var$_.El = function Ide() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$tfe;
};
$61de1ee1cac498ae$var$_.Fl = function Jde() {
    var a;
    if (this.d >= this.j || ((a = $61de1ee1cac498ae$var$bfb(this.i, this.d++)) & 65504) != 64) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Eue))));
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(0, a - 64);
};
$61de1ee1cac498ae$var$_.Gl = function Kde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$Jfe();
};
$61de1ee1cac498ae$var$_.Hl = function Lde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$ufe;
};
$61de1ee1cac498ae$var$_.Il = function Mde() {
    var a;
    a = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(0, 105));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Jl = function Nde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$rfe;
};
$61de1ee1cac498ae$var$_.Kl = function Ode() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$pfe;
};
$61de1ee1cac498ae$var$_.Ll = function Pde(a, b) {
    return this.tl();
};
$61de1ee1cac498ae$var$_.Ml = function Qde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$hfe;
};
$61de1ee1cac498ae$var$_.Nl = function Rde() {
    var a, b, c, d, e;
    if (this.d + 1 >= this.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Bue))));
    d = -1;
    b = null;
    a = $61de1ee1cac498ae$var$bfb(this.i, this.d);
    if (49 <= a && a <= 57) {
        d = a - 48;
        !this.g && (this.g = new $61de1ee1cac498ae$var$Wvb);
        $61de1ee1cac498ae$var$Tvb(this.g, new $61de1ee1cac498ae$var$cge(d));
        ++this.d;
        if ($61de1ee1cac498ae$var$bfb(this.i, this.d) != 41) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
        ++this.d;
    } else {
        a == 63 && --this.d;
        $61de1ee1cac498ae$var$nde(this);
        b = $61de1ee1cac498ae$var$qde(this);
        switch(b.e){
            case 20:
            case 21:
            case 22:
            case 23:
                break;
            case 8:
                if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
                break;
            default:
                throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Cue))));
        }
    }
    $61de1ee1cac498ae$var$nde(this);
    e = $61de1ee1cac498ae$var$rde(this);
    c = null;
    if (e.e == 2) {
        if (e.em() != 2) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Due))));
        c = e.am(1);
        e = e.am(0);
    }
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$vge(d, b, e, c);
};
$61de1ee1cac498ae$var$_.Ol = function Sde() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$ife;
};
$61de1ee1cac498ae$var$_.Pl = function Tde() {
    var a;
    $61de1ee1cac498ae$var$nde(this);
    a = $61de1ee1cac498ae$var$Cfe(24, $61de1ee1cac498ae$var$rde(this));
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Ql = function Ude() {
    var a;
    $61de1ee1cac498ae$var$nde(this);
    a = $61de1ee1cac498ae$var$Cfe(20, $61de1ee1cac498ae$var$rde(this));
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Rl = function Vde() {
    var a;
    $61de1ee1cac498ae$var$nde(this);
    a = $61de1ee1cac498ae$var$Cfe(22, $61de1ee1cac498ae$var$rde(this));
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Sl = function Wde() {
    var a, b, c, d, e;
    a = 0;
    c = 0;
    b = -1;
    while(this.d < this.j){
        b = $61de1ee1cac498ae$var$bfb(this.i, this.d);
        e = $61de1ee1cac498ae$var$Uee(b);
        if (e == 0) break;
        a |= e;
        ++this.d;
    }
    if (this.d >= this.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$zue))));
    if (b == 45) {
        ++this.d;
        while(this.d < this.j){
            b = $61de1ee1cac498ae$var$bfb(this.i, this.d);
            e = $61de1ee1cac498ae$var$Uee(b);
            if (e == 0) break;
            c |= e;
            ++this.d;
        }
        if (this.d >= this.j) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$zue))));
    }
    if (b == 58) {
        ++this.d;
        $61de1ee1cac498ae$var$nde(this);
        d = $61de1ee1cac498ae$var$Dfe($61de1ee1cac498ae$var$rde(this), a, c);
        if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
        $61de1ee1cac498ae$var$nde(this);
    } else if (b == 41) {
        ++this.d;
        $61de1ee1cac498ae$var$nde(this);
        d = $61de1ee1cac498ae$var$Dfe($61de1ee1cac498ae$var$rde(this), a, c);
    } else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Aue))));
    return d;
};
$61de1ee1cac498ae$var$_.Tl = function Xde() {
    var a;
    $61de1ee1cac498ae$var$nde(this);
    a = $61de1ee1cac498ae$var$Cfe(21, $61de1ee1cac498ae$var$rde(this));
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Ul = function Yde() {
    var a;
    $61de1ee1cac498ae$var$nde(this);
    a = $61de1ee1cac498ae$var$Cfe(23, $61de1ee1cac498ae$var$rde(this));
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Vl = function Zde() {
    var a, b;
    $61de1ee1cac498ae$var$nde(this);
    a = this.f++;
    b = $61de1ee1cac498ae$var$Efe($61de1ee1cac498ae$var$rde(this), a);
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return b;
};
$61de1ee1cac498ae$var$_.Wl = function $de() {
    var a;
    $61de1ee1cac498ae$var$nde(this);
    a = $61de1ee1cac498ae$var$Efe($61de1ee1cac498ae$var$rde(this), 0);
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Xl = function _de(a) {
    $61de1ee1cac498ae$var$nde(this);
    if (this.c == 5) {
        $61de1ee1cac498ae$var$nde(this);
        return $61de1ee1cac498ae$var$Bfe(a, ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(9, a)));
    } else return $61de1ee1cac498ae$var$Bfe(a, ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(3, a)));
};
$61de1ee1cac498ae$var$_.Yl = function aee(a) {
    var b;
    $61de1ee1cac498ae$var$nde(this);
    b = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Lge(2));
    if (this.c == 5) {
        $61de1ee1cac498ae$var$nde(this);
        $61de1ee1cac498ae$var$Kge(b, $61de1ee1cac498ae$var$ffe);
        $61de1ee1cac498ae$var$Kge(b, a);
    } else {
        $61de1ee1cac498ae$var$Kge(b, a);
        $61de1ee1cac498ae$var$Kge(b, $61de1ee1cac498ae$var$ffe);
    }
    return b;
};
$61de1ee1cac498ae$var$_.Zl = function bee(a) {
    $61de1ee1cac498ae$var$nde(this);
    if (this.c == 5) {
        $61de1ee1cac498ae$var$nde(this);
        return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(9, a);
    } else return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(3, a);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
$61de1ee1cac498ae$var$_.d = 0;
$61de1ee1cac498ae$var$_.e = 0;
$61de1ee1cac498ae$var$_.f = 1;
$61de1ee1cac498ae$var$_.g = null;
$61de1ee1cac498ae$var$_.j = 0;
var $61de1ee1cac498ae$var$bbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/RegexParser", 820);
$61de1ee1cac498ae$var$bcb(1824, 820, {}, $61de1ee1cac498ae$var$hee);
$61de1ee1cac498ae$var$_.sl = function iee(a) {
    return false;
};
$61de1ee1cac498ae$var$_.tl = function jee() {
    return $61de1ee1cac498ae$var$eee(this);
};
$61de1ee1cac498ae$var$_.ul = function lee(a) {
    return $61de1ee1cac498ae$var$fee(a);
};
$61de1ee1cac498ae$var$_.vl = function mee(a) {
    return $61de1ee1cac498ae$var$gee(this);
};
$61de1ee1cac498ae$var$_.wl = function nee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.xl = function oee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.yl = function pee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.zl = function qee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Al = function ree() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$fee(67);
};
$61de1ee1cac498ae$var$_.Bl = function see() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$fee(73);
};
$61de1ee1cac498ae$var$_.Cl = function tee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Dl = function uee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.El = function vee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Fl = function wee() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$fee(99);
};
$61de1ee1cac498ae$var$_.Gl = function xee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Hl = function yee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Il = function zee() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$fee(105);
};
$61de1ee1cac498ae$var$_.Jl = function Aee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Kl = function Bee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Ll = function Cee(a, b) {
    return $61de1ee1cac498ae$var$Xfe(a, $61de1ee1cac498ae$var$fee(b)), -1;
};
$61de1ee1cac498ae$var$_.Ml = function Dee() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(0, 94);
};
$61de1ee1cac498ae$var$_.Nl = function Eee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Ol = function Fee() {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$ige(0, 36);
};
$61de1ee1cac498ae$var$_.Pl = function Gee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Ql = function Hee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Rl = function Iee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Sl = function Jee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Tl = function Kee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Ul = function Lee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Vl = function Mee() {
    var a;
    $61de1ee1cac498ae$var$nde(this);
    a = $61de1ee1cac498ae$var$Efe($61de1ee1cac498ae$var$rde(this), 0);
    if (this.c != 7) throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$yue))));
    $61de1ee1cac498ae$var$nde(this);
    return a;
};
$61de1ee1cac498ae$var$_.Wl = function Nee() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$mde($61de1ee1cac498ae$var$tvd(($61de1ee1cac498ae$var$h0d(), $61de1ee1cac498ae$var$Yue))));
};
$61de1ee1cac498ae$var$_.Xl = function Oee(a) {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$Bfe(a, ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(3, a)));
};
$61de1ee1cac498ae$var$_.Yl = function Pee(a) {
    var b;
    $61de1ee1cac498ae$var$nde(this);
    b = ($61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$Lge(2));
    $61de1ee1cac498ae$var$Kge(b, a);
    $61de1ee1cac498ae$var$Kge(b, $61de1ee1cac498ae$var$ffe);
    return b;
};
$61de1ee1cac498ae$var$_.Zl = function Qee(a) {
    $61de1ee1cac498ae$var$nde(this);
    return $61de1ee1cac498ae$var$wfe(), $61de1ee1cac498ae$var$wfe(), ++$61de1ee1cac498ae$var$vfe, new $61de1ee1cac498ae$var$lge(3, a);
};
var $61de1ee1cac498ae$var$cee = null, $61de1ee1cac498ae$var$dee = null;
var $61de1ee1cac498ae$var$$ab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/ParserForXMLSchema", 1824);
$61de1ee1cac498ae$var$bcb(117, 1, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$xfe);
$61de1ee1cac498ae$var$_.$l = function yfe(a) {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Not supported."));
};
$61de1ee1cac498ae$var$_._l = function Gfe() {
    return -1;
};
$61de1ee1cac498ae$var$_.am = function Hfe(a) {
    return null;
};
$61de1ee1cac498ae$var$_.bm = function Mfe() {
    return null;
};
$61de1ee1cac498ae$var$_.cm = function Pfe(a) {};
$61de1ee1cac498ae$var$_.dm = function Qfe(a) {};
$61de1ee1cac498ae$var$_.em = function Rfe() {
    return 0;
};
$61de1ee1cac498ae$var$_.Ib = function Sfe() {
    return this.fm(0);
};
$61de1ee1cac498ae$var$_.fm = function Tfe(a) {
    return this.e == 11 ? "." : "";
};
$61de1ee1cac498ae$var$_.e = 0;
var $61de1ee1cac498ae$var$Yee, $61de1ee1cac498ae$var$Zee, $61de1ee1cac498ae$var$$ee, $61de1ee1cac498ae$var$_ee, $61de1ee1cac498ae$var$afe, $61de1ee1cac498ae$var$bfe = null, $61de1ee1cac498ae$var$cfe, $61de1ee1cac498ae$var$dfe = null, $61de1ee1cac498ae$var$efe, $61de1ee1cac498ae$var$ffe, $61de1ee1cac498ae$var$gfe = null, $61de1ee1cac498ae$var$hfe, $61de1ee1cac498ae$var$ife, $61de1ee1cac498ae$var$jfe, $61de1ee1cac498ae$var$kfe, $61de1ee1cac498ae$var$lfe, $61de1ee1cac498ae$var$mfe, $61de1ee1cac498ae$var$nfe, $61de1ee1cac498ae$var$ofe, $61de1ee1cac498ae$var$pfe, $61de1ee1cac498ae$var$qfe, $61de1ee1cac498ae$var$rfe, $61de1ee1cac498ae$var$sfe, $61de1ee1cac498ae$var$tfe, $61de1ee1cac498ae$var$ufe, $61de1ee1cac498ae$var$vfe = 0;
var $61de1ee1cac498ae$var$lbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token", 117);
$61de1ee1cac498ae$var$bcb(136, 117, {
    3: 1,
    136: 1,
    117: 1
}, $61de1ee1cac498ae$var$$fe);
$61de1ee1cac498ae$var$_.fm = function bge(a) {
    var b, c, d;
    if (this.e == 4) {
        if (this == $61de1ee1cac498ae$var$efe) c = ".";
        else if (this == $61de1ee1cac498ae$var$cfe) c = "\\d";
        else if (this == $61de1ee1cac498ae$var$sfe) c = "\\w";
        else if (this == $61de1ee1cac498ae$var$nfe) c = "\\s";
        else {
            d = new $61de1ee1cac498ae$var$Hfb;
            d.a += "[";
            for(b = 0; b < this.b.length; b += 2){
                (a & $61de1ee1cac498ae$var$zte) != 0 && b > 0 && (d.a += ",", d);
                if (this.b[b] === this.b[b + 1]) $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$age(this.b[b]));
                else {
                    $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$age(this.b[b]));
                    d.a += "-";
                    $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$age(this.b[b + 1]));
                }
            }
            d.a += "]";
            c = d.a;
        }
    } else {
        if (this == $61de1ee1cac498ae$var$jfe) c = "\\D";
        else if (this == $61de1ee1cac498ae$var$lfe) c = "\\W";
        else if (this == $61de1ee1cac498ae$var$kfe) c = "\\S";
        else {
            d = new $61de1ee1cac498ae$var$Hfb;
            d.a += "[^";
            for(b = 0; b < this.b.length; b += 2){
                (a & $61de1ee1cac498ae$var$zte) != 0 && b > 0 && (d.a += ",", d);
                if (this.b[b] === this.b[b + 1]) $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$age(this.b[b]));
                else {
                    $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$age(this.b[b]));
                    d.a += "-";
                    $61de1ee1cac498ae$var$Efb(d, $61de1ee1cac498ae$var$age(this.b[b + 1]));
                }
            }
            d.a += "]";
            c = d.a;
        }
    }
    return c;
};
$61de1ee1cac498ae$var$_.a = false;
$61de1ee1cac498ae$var$_.c = false;
var $61de1ee1cac498ae$var$_ab = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/RangeToken", 136);
$61de1ee1cac498ae$var$bcb(584, 1, {
    584: 1
}, $61de1ee1cac498ae$var$cge);
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$abb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/RegexParser/ReferencePosition", 584);
$61de1ee1cac498ae$var$bcb(583, 1, {
    3: 1,
    583: 1
}, $61de1ee1cac498ae$var$ege);
$61de1ee1cac498ae$var$_.Fb = function fge(a) {
    var b;
    if (a == null) return false;
    if (!$61de1ee1cac498ae$var$JD(a, 583)) return false;
    b = $61de1ee1cac498ae$var$BD(a, 583);
    return $61de1ee1cac498ae$var$dfb(this.b, b.b) && this.a == b.a;
};
$61de1ee1cac498ae$var$_.Hb = function gge() {
    return $61de1ee1cac498ae$var$LCb(this.b + "/" + $61de1ee1cac498ae$var$See(this.a));
};
$61de1ee1cac498ae$var$_.Ib = function hge() {
    return this.c.fm(this.a);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$cbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/RegularExpression", 583);
$61de1ee1cac498ae$var$bcb(223, 117, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$ige);
$61de1ee1cac498ae$var$_._l = function jge() {
    return this.a;
};
$61de1ee1cac498ae$var$_.fm = function kge(a) {
    var b, c, d;
    switch(this.e){
        case 0:
            switch(this.a){
                case 124:
                case 42:
                case 43:
                case 63:
                case 40:
                case 41:
                case 46:
                case 91:
                case 123:
                case 92:
                    d = "\\" + $61de1ee1cac498ae$var$HD(this.a & $61de1ee1cac498ae$var$aje);
                    break;
                case 12:
                    d = "\\f";
                    break;
                case 10:
                    d = "\\n";
                    break;
                case 13:
                    d = "\\r";
                    break;
                case 9:
                    d = "\\t";
                    break;
                case 27:
                    d = "\\e";
                    break;
                default:
                    if (this.a >= $61de1ee1cac498ae$var$Tje) {
                        c = (b = this.a >>> 0, "0" + b.toString(16));
                        d = "\\v" + $61de1ee1cac498ae$var$qfb(c, c.length - 6, c.length);
                    } else d = "" + $61de1ee1cac498ae$var$HD(this.a & $61de1ee1cac498ae$var$aje);
            }
            break;
        case 8:
            this == $61de1ee1cac498ae$var$hfe || this == $61de1ee1cac498ae$var$ife ? d = "" + $61de1ee1cac498ae$var$HD(this.a & $61de1ee1cac498ae$var$aje) : d = "\\" + $61de1ee1cac498ae$var$HD(this.a & $61de1ee1cac498ae$var$aje);
            break;
        default:
            d = null;
    }
    return d;
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$dbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/CharToken", 223);
$61de1ee1cac498ae$var$bcb(309, 117, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$lge);
$61de1ee1cac498ae$var$_.am = function mge(a) {
    return this.a;
};
$61de1ee1cac498ae$var$_.cm = function nge(a) {
    this.b = a;
};
$61de1ee1cac498ae$var$_.dm = function oge(a) {
    this.c = a;
};
$61de1ee1cac498ae$var$_.em = function pge() {
    return 1;
};
$61de1ee1cac498ae$var$_.fm = function qge(a) {
    var b;
    if (this.e == 3) {
        if (this.c < 0 && this.b < 0) b = this.a.fm(a) + "*";
        else if (this.c == this.b) b = this.a.fm(a) + "{" + this.c + "}";
        else if (this.c >= 0 && this.b >= 0) b = this.a.fm(a) + "{" + this.c + "," + this.b + "}";
        else if (this.c >= 0 && this.b < 0) b = this.a.fm(a) + "{" + this.c + ",}";
        else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Token#toString(): CLOSURE " + this.c + $61de1ee1cac498ae$var$She + this.b));
    } else {
        if (this.c < 0 && this.b < 0) b = this.a.fm(a) + "*?";
        else if (this.c == this.b) b = this.a.fm(a) + "{" + this.c + "}?";
        else if (this.c >= 0 && this.b >= 0) b = this.a.fm(a) + "{" + this.c + "," + this.b + "}?";
        else if (this.c >= 0 && this.b < 0) b = this.a.fm(a) + "{" + this.c + ",}?";
        else throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Token#toString(): NONGREEDYCLOSURE " + this.c + $61de1ee1cac498ae$var$She + this.b));
    }
    return b;
};
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$ebb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/ClosureToken", 309);
$61de1ee1cac498ae$var$bcb(821, 117, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$rge);
$61de1ee1cac498ae$var$_.am = function sge(a) {
    return a == 0 ? this.a : this.b;
};
$61de1ee1cac498ae$var$_.em = function tge() {
    return 2;
};
$61de1ee1cac498ae$var$_.fm = function uge(a) {
    var b;
    this.b.e == 3 && this.b.am(0) == this.a ? b = this.a.fm(a) + "+" : this.b.e == 9 && this.b.am(0) == this.a ? b = this.a.fm(a) + "+?" : b = this.a.fm(a) + ("" + this.b.fm(a));
    return b;
};
var $61de1ee1cac498ae$var$fbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/ConcatToken", 821);
$61de1ee1cac498ae$var$bcb(1822, 117, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$vge);
$61de1ee1cac498ae$var$_.am = function wge(a) {
    if (a == 0) return this.d;
    if (a == 1) return this.b;
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$hz("Internal Error: " + a));
};
$61de1ee1cac498ae$var$_.em = function xge() {
    return !this.b ? 1 : 2;
};
$61de1ee1cac498ae$var$_.fm = function yge(a) {
    var b;
    this.c > 0 ? b = "(?(" + this.c + ")" : this.a.e == 8 ? b = "(?(" + this.a + ")" : b = "(?" + this.a;
    !this.b ? b += this.d + ")" : b += this.d + "|" + this.b + ")";
    return b;
};
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$gbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/ConditionToken", 1822);
$61de1ee1cac498ae$var$bcb(1823, 117, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$zge);
$61de1ee1cac498ae$var$_.am = function Age(a) {
    return this.b;
};
$61de1ee1cac498ae$var$_.em = function Bge() {
    return 1;
};
$61de1ee1cac498ae$var$_.fm = function Cge(a) {
    return "(?" + (this.a == 0 ? "" : $61de1ee1cac498ae$var$See(this.a)) + (this.c == 0 ? "" : $61de1ee1cac498ae$var$See(this.c)) + ":" + this.b.fm(a) + ")";
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$hbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/ModifierToken", 1823);
$61de1ee1cac498ae$var$bcb(822, 117, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$Dge);
$61de1ee1cac498ae$var$_.am = function Ege(a) {
    return this.a;
};
$61de1ee1cac498ae$var$_.em = function Fge() {
    return 1;
};
$61de1ee1cac498ae$var$_.fm = function Gge(a) {
    var b;
    b = null;
    switch(this.e){
        case 6:
            this.b == 0 ? b = "(?:" + this.a.fm(a) + ")" : b = "(" + this.a.fm(a) + ")";
            break;
        case 20:
            b = "(?=" + this.a.fm(a) + ")";
            break;
        case 21:
            b = "(?!" + this.a.fm(a) + ")";
            break;
        case 22:
            b = "(?<=" + this.a.fm(a) + ")";
            break;
        case 23:
            b = "(?<!" + this.a.fm(a) + ")";
            break;
        case 24:
            b = "(?>" + this.a.fm(a) + ")";
    }
    return b;
};
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$ibb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/ParenToken", 822);
$61de1ee1cac498ae$var$bcb(521, 117, {
    3: 1,
    117: 1,
    521: 1
}, $61de1ee1cac498ae$var$Hge);
$61de1ee1cac498ae$var$_.bm = function Ige() {
    return this.b;
};
$61de1ee1cac498ae$var$_.fm = function Jge(a) {
    return this.e == 12 ? "\\" + this.a : $61de1ee1cac498ae$var$Wee(this.b);
};
$61de1ee1cac498ae$var$_.a = 0;
var $61de1ee1cac498ae$var$jbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/StringToken", 521);
$61de1ee1cac498ae$var$bcb(465, 117, $61de1ee1cac498ae$var$yxe, $61de1ee1cac498ae$var$Lge);
$61de1ee1cac498ae$var$_.$l = function Mge(a) {
    $61de1ee1cac498ae$var$Kge(this, a);
};
$61de1ee1cac498ae$var$_.am = function Nge(a) {
    return $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, a), 117);
};
$61de1ee1cac498ae$var$_.em = function Oge() {
    return !this.a ? 0 : this.a.a.c.length;
};
$61de1ee1cac498ae$var$_.fm = function Pge(a) {
    var b, c, d, e, f;
    if (this.e == 1) {
        if (this.a.a.c.length == 2) {
            b = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, 0), 117);
            c = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, 1), 117);
            c.e == 3 && c.am(0) == b ? e = b.fm(a) + "+" : c.e == 9 && c.am(0) == b ? e = b.fm(a) + "+?" : e = b.fm(a) + ("" + c.fm(a));
        } else {
            f = new $61de1ee1cac498ae$var$Hfb;
            for(d = 0; d < this.a.a.c.length; d++)$61de1ee1cac498ae$var$Efb(f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, d), 117).fm(a));
            e = f.a;
        }
        return e;
    }
    if (this.a.a.c.length == 2 && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, 1), 117).e == 7) e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, 0), 117).fm(a) + "?";
    else if (this.a.a.c.length == 2 && $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, 0), 117).e == 7) e = $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, 1), 117).fm(a) + "??";
    else {
        f = new $61de1ee1cac498ae$var$Hfb;
        $61de1ee1cac498ae$var$Efb(f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, 0), 117).fm(a));
        for(d = 1; d < this.a.a.c.length; d++){
            f.a += "|";
            $61de1ee1cac498ae$var$Efb(f, $61de1ee1cac498ae$var$BD($61de1ee1cac498ae$var$Uvb(this.a, d), 117).fm(a));
        }
        e = f.a;
    }
    return e;
};
var $61de1ee1cac498ae$var$kbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$kxe, "RegEx/Token/UnionToken", 465);
$61de1ee1cac498ae$var$bcb(518, 1, {
    592: 1
}, $61de1ee1cac498ae$var$Rge);
$61de1ee1cac498ae$var$_.Ib = function Sge() {
    return this.a.b;
};
var $61de1ee1cac498ae$var$mbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$zxe, "XMLTypeUtil/PatternMatcherImpl", 518);
$61de1ee1cac498ae$var$bcb(1622, 1381, {}, $61de1ee1cac498ae$var$Vge);
var $61de1ee1cac498ae$var$Tge;
var $61de1ee1cac498ae$var$nbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$zxe, "XMLTypeValidator", 1622);
$61de1ee1cac498ae$var$bcb(264, 1, $61de1ee1cac498ae$var$vie, $61de1ee1cac498ae$var$Yge);
$61de1ee1cac498ae$var$_.Jc = function Zge(a) {
    $61de1ee1cac498ae$var$reb(this, a);
};
$61de1ee1cac498ae$var$_.Kc = function $ge() {
    return (this.b - this.a) * this.c < 0 ? $61de1ee1cac498ae$var$Wge : new $61de1ee1cac498ae$var$she(this);
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
$61de1ee1cac498ae$var$_.c = 0;
var $61de1ee1cac498ae$var$Wge;
var $61de1ee1cac498ae$var$qbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Bxe, "ExclusiveRange", 264);
$61de1ee1cac498ae$var$bcb(1068, 1, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$dhe);
$61de1ee1cac498ae$var$_.Rb = function ehe(a) {
    $61de1ee1cac498ae$var$BD(a, 19);
    $61de1ee1cac498ae$var$_ge();
};
$61de1ee1cac498ae$var$_.Nb = function fhe(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function ihe() {
    return $61de1ee1cac498ae$var$ahe();
};
$61de1ee1cac498ae$var$_.Ub = function khe() {
    return $61de1ee1cac498ae$var$bhe();
};
$61de1ee1cac498ae$var$_.Wb = function nhe(a) {
    $61de1ee1cac498ae$var$BD(a, 19);
    $61de1ee1cac498ae$var$che();
};
$61de1ee1cac498ae$var$_.Ob = function ghe() {
    return false;
};
$61de1ee1cac498ae$var$_.Sb = function hhe() {
    return false;
};
$61de1ee1cac498ae$var$_.Tb = function jhe() {
    return -1;
};
$61de1ee1cac498ae$var$_.Vb = function lhe() {
    return -1;
};
$61de1ee1cac498ae$var$_.Qb = function mhe() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$Exe));
};
var $61de1ee1cac498ae$var$obb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Bxe, "ExclusiveRange/1", 1068);
$61de1ee1cac498ae$var$bcb(254, 1, $61de1ee1cac498ae$var$jie, $61de1ee1cac498ae$var$she);
$61de1ee1cac498ae$var$_.Rb = function the(a) {
    $61de1ee1cac498ae$var$BD(a, 19);
    $61de1ee1cac498ae$var$ohe();
};
$61de1ee1cac498ae$var$_.Nb = function uhe(a) {
    $61de1ee1cac498ae$var$Rrb(this, a);
};
$61de1ee1cac498ae$var$_.Pb = function xhe() {
    return $61de1ee1cac498ae$var$phe(this);
};
$61de1ee1cac498ae$var$_.Ub = function zhe() {
    return $61de1ee1cac498ae$var$qhe(this);
};
$61de1ee1cac498ae$var$_.Wb = function Che(a) {
    $61de1ee1cac498ae$var$BD(a, 19);
    $61de1ee1cac498ae$var$rhe();
};
$61de1ee1cac498ae$var$_.Ob = function vhe() {
    return this.c.c < 0 ? this.a >= this.c.b : this.a <= this.c.b;
};
$61de1ee1cac498ae$var$_.Sb = function whe() {
    return this.b > 0;
};
$61de1ee1cac498ae$var$_.Tb = function yhe() {
    return this.b;
};
$61de1ee1cac498ae$var$_.Vb = function Ahe() {
    return this.b - 1;
};
$61de1ee1cac498ae$var$_.Qb = function Bhe() {
    throw $61de1ee1cac498ae$var$vbb(new $61de1ee1cac498ae$var$cgb($61de1ee1cac498ae$var$Exe));
};
$61de1ee1cac498ae$var$_.a = 0;
$61de1ee1cac498ae$var$_.b = 0;
var $61de1ee1cac498ae$var$pbb = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Bxe, "ExclusiveRange/RangeIterator", 254);
var $61de1ee1cac498ae$var$TD = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Fve, "C");
var $61de1ee1cac498ae$var$WD = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Ive, "I");
var $61de1ee1cac498ae$var$sbb = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Khe, "Z");
var $61de1ee1cac498ae$var$XD = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Jve, "J");
var $61de1ee1cac498ae$var$SD = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Eve, "B");
var $61de1ee1cac498ae$var$UD = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Gve, "D");
var $61de1ee1cac498ae$var$VD = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Hve, "F");
var $61de1ee1cac498ae$var$rbb = $61de1ee1cac498ae$var$pdb($61de1ee1cac498ae$var$Kve, "S");
var $61de1ee1cac498ae$var$h1 = $61de1ee1cac498ae$var$odb("org.eclipse.elk.core.labels", "ILabelManager");
var $61de1ee1cac498ae$var$O4 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$Tte, "DiagnosticChain");
var $61de1ee1cac498ae$var$u8 = $61de1ee1cac498ae$var$odb($61de1ee1cac498ae$var$pwe, "ResourceSet");
var $61de1ee1cac498ae$var$V4 = $61de1ee1cac498ae$var$mdb($61de1ee1cac498ae$var$Tte, "InvocationTargetException", null);
var $61de1ee1cac498ae$var$Ihe = ($61de1ee1cac498ae$var$Az(), $61de1ee1cac498ae$var$Dz);
var $61de1ee1cac498ae$var$gwtOnLoad = $61de1ee1cac498ae$var$gwtOnLoad = $61de1ee1cac498ae$var$Zbb;
$61de1ee1cac498ae$var$Xbb($61de1ee1cac498ae$var$hcb);
$61de1ee1cac498ae$var$$bb("permProps", [
    [
        [
            $61de1ee1cac498ae$var$Fxe,
            $61de1ee1cac498ae$var$Gxe
        ],
        [
            $61de1ee1cac498ae$var$Hxe,
            "gecko1_8"
        ]
    ],
    [
        [
            $61de1ee1cac498ae$var$Fxe,
            $61de1ee1cac498ae$var$Gxe
        ],
        [
            $61de1ee1cac498ae$var$Hxe,
            "ie10"
        ]
    ],
    [
        [
            $61de1ee1cac498ae$var$Fxe,
            $61de1ee1cac498ae$var$Gxe
        ],
        [
            $61de1ee1cac498ae$var$Hxe,
            "ie8"
        ]
    ],
    [
        [
            $61de1ee1cac498ae$var$Fxe,
            $61de1ee1cac498ae$var$Gxe
        ],
        [
            $61de1ee1cac498ae$var$Hxe,
            "ie9"
        ]
    ],
    [
        [
            $61de1ee1cac498ae$var$Fxe,
            $61de1ee1cac498ae$var$Gxe
        ],
        [
            $61de1ee1cac498ae$var$Hxe,
            "safari"
        ]
    ]
]);
// --------------    RUN GWT INITIALIZATION CODE    -------------- 
$61de1ee1cac498ae$var$gwtOnLoad(null, "elk", null);

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6b3372b60d35b33f$export$998bcd577473dd93, (v) => $6b3372b60d35b33f$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6b3372b60d35b33f$export$3d6c20d97e46b957, (v) => $6b3372b60d35b33f$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$998bcd577473dd93;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$3d6c20d97e46b957;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = Symbol.for("react.element"), $6b3372b60d35b33f$var$c = Symbol.for("react.portal"), $6b3372b60d35b33f$var$d = Symbol.for("react.fragment"), $6b3372b60d35b33f$var$e = Symbol.for("react.strict_mode"), $6b3372b60d35b33f$var$f = Symbol.for("react.profiler"), $6b3372b60d35b33f$var$g = Symbol.for("react.provider"), $6b3372b60d35b33f$var$h = Symbol.for("react.context"), $6b3372b60d35b33f$var$k = Symbol.for("react.server_context"), $6b3372b60d35b33f$var$l = Symbol.for("react.forward_ref"), $6b3372b60d35b33f$var$m = Symbol.for("react.suspense"), $6b3372b60d35b33f$var$n = Symbol.for("react.suspense_list"), $6b3372b60d35b33f$var$p = Symbol.for("react.memo"), $6b3372b60d35b33f$var$q = Symbol.for("react.lazy"), $6b3372b60d35b33f$var$t = Symbol.for("react.offscreen"), $6b3372b60d35b33f$var$u;
$6b3372b60d35b33f$var$u = Symbol.for("react.module.reference");
function $6b3372b60d35b33f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$l:
                            case $6b3372b60d35b33f$var$q:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return r;
        }
    }
}
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$b;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$q;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$998bcd577473dd93 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$q;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$m;
};
$6b3372b60d35b33f$export$3d6c20d97e46b957 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$n || a === $6b3372b60d35b33f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$q || a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$l || a.$$typeof === $6b3372b60d35b33f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$v;

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;





var $acw62 = parcelRequire("acw62");
/**
 * React Router DOM v6.24.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

/**
 * React Router v6.24.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @remix-run/router v1.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$var$decodePath(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $1d34d5c4a288b213$var$ResultType.redirect,
                        response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        let matches = discoverResult.partialMatches;
        let route = matches[matches.length - 1].route;
        let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "route-discovery",
            routeId: route.id,
            pathname: pathname,
            message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
        });
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path === "*") {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            try {
                await $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, dataRoutes || inFlightDataRoutes, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes (routeId, children) {
            return $1d34d5c4a288b213$var$patchRoutes(routeId, children, dataRoutes || inFlightDataRoutes, manifest, mapRouteProperties);
        },
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isHandlerResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(unstable_dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($1d34d5c4a288b213$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $1d34d5c4a288b213$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute route.children() method to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $1d34d5c4a288b213$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $1d34d5c4a288b213$var$patchRoutes(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $1d34d5c4a288b213$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $1d34d5c4a288b213$var$patchRoutes(routeId, children, routes, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $1d34d5c4a288b213$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routes.length || "0")
        ], manifest);
        routes.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $1d34d5c4a288b213$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                });
            };
            return $1d34d5c4a288b213$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$1d34d5c4a288b213$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) return {
        type: $1d34d5c4a288b213$var$ResultType.error,
        error: result,
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : status
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `children()` function for ' + ("route `" + routeId + "` threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $1d34d5c4a288b213$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectHandlerResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $acw62 = parcelRequire("acw62");

/*!
* rete v2.0.2
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ var $b8259e79f5c77a6f$exports = {};
function $b8259e79f5c77a6f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$b8259e79f5c77a6f$exports = $b8259e79f5c77a6f$var$_asyncToGenerator, $b8259e79f5c77a6f$exports.__esModule = true, $b8259e79f5c77a6f$exports["default"] = $b8259e79f5c77a6f$exports;


var $b45a6abf916bff88$exports = {};
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$b45a6abf916bff88$exports = $b45a6abf916bff88$var$_classCallCheck, $b45a6abf916bff88$exports.__esModule = true, $b45a6abf916bff88$exports["default"] = $b45a6abf916bff88$exports;


var $fe9438347a673ba6$exports = {};
var $010f4e0e13c82e16$exports = {};

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;
var $b77c8068776c2a21$exports = {};

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$b77c8068776c2a21$exports = $b77c8068776c2a21$var$toPrimitive, $b77c8068776c2a21$exports.__esModule = true, $b77c8068776c2a21$exports["default"] = $b77c8068776c2a21$exports;


function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $b77c8068776c2a21$exports(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
$010f4e0e13c82e16$exports = $010f4e0e13c82e16$var$toPropertyKey, $010f4e0e13c82e16$exports.__esModule = true, $010f4e0e13c82e16$exports["default"] = $010f4e0e13c82e16$exports;


function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $010f4e0e13c82e16$exports(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$fe9438347a673ba6$exports = $fe9438347a673ba6$var$_createClass, $fe9438347a673ba6$exports.__esModule = true, $fe9438347a673ba6$exports["default"] = $fe9438347a673ba6$exports;


var $4c93951af9bb8a88$exports = {};
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$4c93951af9bb8a88$exports = $4c93951af9bb8a88$var$_assertThisInitialized, $4c93951af9bb8a88$exports.__esModule = true, $4c93951af9bb8a88$exports["default"] = $4c93951af9bb8a88$exports;


var $b050fc8434f4a0e1$exports = {};
var $7b4ac2338b8e8f97$exports = {};
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return $7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
$7b4ac2338b8e8f97$exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, $7b4ac2338b8e8f97$exports.__esModule = true, $7b4ac2338b8e8f97$exports["default"] = $7b4ac2338b8e8f97$exports;


function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7b4ac2338b8e8f97$exports(t, e);
}
$b050fc8434f4a0e1$exports = $b050fc8434f4a0e1$var$_inherits, $b050fc8434f4a0e1$exports.__esModule = true, $b050fc8434f4a0e1$exports["default"] = $b050fc8434f4a0e1$exports;


var $ac4cd79166dac6e4$exports = {};

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4c93951af9bb8a88$exports(t);
}
$ac4cd79166dac6e4$exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, $ac4cd79166dac6e4$exports.__esModule = true, $ac4cd79166dac6e4$exports["default"] = $ac4cd79166dac6e4$exports;


var $93d4339c80153a6a$exports = {};
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return $93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
$93d4339c80153a6a$exports = $93d4339c80153a6a$var$_getPrototypeOf, $93d4339c80153a6a$exports.__esModule = true, $93d4339c80153a6a$exports["default"] = $93d4339c80153a6a$exports;


var $bb7ca61ce45563c4$exports = {};

function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $010f4e0e13c82e16$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$bb7ca61ce45563c4$exports = $bb7ca61ce45563c4$var$_defineProperty, $bb7ca61ce45563c4$exports.__esModule = true, $bb7ca61ce45563c4$exports["default"] = $bb7ca61ce45563c4$exports;


var $c6598bdb60f83fe0$exports = {};
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
$c6598bdb60f83fe0$exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}


function $bad63f27bc7a37b5$var$_createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $bad63f27bc7a37b5$var$_unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bad63f27bc7a37b5$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bad63f27bc7a37b5$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bad63f27bc7a37b5$var$_arrayLikeToArray$1(o, minLen);
}
function $bad63f27bc7a37b5$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * A middleware type that can modify the data
 * @typeParam T - The data type
 * @param data - The data to be modified
 * @returns The modified data or undefined
 * @example (data) => data + 1
 * @example (data) => undefined // will stop the execution
 * @internal
 */ /**
 * Validate the Scope signals and replace the parameter type with an error message if they are not assignable
 * @internal
 */ /**
 * Provides 'debug' method to check the detailed assignment error message
 * @example .debug($ => $)
 * @internal
 */ function $bad63f27bc7a37b5$var$useHelper() {
    return {
        debug: function debug(f) {}
    };
}
/**
 * A signal is a middleware chain that can be used to modify the data
 * @typeParam T - The data type
 * @internal
 */ var $bad63f27bc7a37b5$export$8210dfe1863c478 = /*#__PURE__*/ function() {
    function Signal() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Signal);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "pipes", []);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Signal, [
        {
            key: "addPipe",
            value: function addPipe(pipe) {
                this.pipes.push(pipe);
            }
        },
        {
            key: "emit",
            value: function() {
                var _emit = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(context) {
                    var current, _iterator, _step, pipe;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                current = context;
                                _iterator = $bad63f27bc7a37b5$var$_createForOfIteratorHelper$1(this.pipes);
                                _context.prev = 2;
                                _iterator.s();
                            case 4:
                                if ((_step = _iterator.n()).done) {
                                    _context.next = 13;
                                    break;
                                }
                                pipe = _step.value;
                                _context.next = 8;
                                return pipe(current);
                            case 8:
                                current = _context.sent;
                                if (!(typeof current === "undefined")) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 11:
                                _context.next = 4;
                                break;
                            case 13:
                                _context.next = 18;
                                break;
                            case 15:
                                _context.prev = 15;
                                _context.t0 = _context["catch"](2);
                                _iterator.e(_context.t0);
                            case 18:
                                _context.prev = 18;
                                _iterator.f();
                                return _context.finish(18);
                            case 21:
                                return _context.abrupt("return", current);
                            case 22:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            15,
                            18,
                            21
                        ]
                    ]);
                }));
                function emit(_x) {
                    return _emit.apply(this, arguments);
                }
                return emit;
            }()
        }
    ]);
    return Signal;
}();
/**
 * Base class for all plugins and the core. Provides a signals mechanism to modify the data
 */ var $bad63f27bc7a37b5$export$775b6bb06e53a214 = /*#__PURE__*/ function() {
    // Parents['length'] extends 0 ? undefined : Scope<Parents[0], Tail<Parents>>
    function Scope(name) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "signal", new $bad63f27bc7a37b5$export$8210dfe1863c478());
        this.name = name;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Scope, [
        {
            key: "addPipe",
            value: function addPipe(middleware) {
                this.signal.addPipe(middleware);
            }
        },
        {
            key: "use",
            value: function use(scope) {
                if (!(scope instanceof Scope)) throw new Error("cannot use non-Scope instance");
                scope.setParent(this);
                this.addPipe(function(context) {
                    return scope.signal.emit(context);
                });
                return $bad63f27bc7a37b5$var$useHelper();
            }
        },
        {
            key: "setParent",
            value: function setParent(scope) {
                this.parent = scope;
            }
        },
        {
            key: "emit",
            value: function emit(context) {
                return this.signal.emit(context);
            }
        },
        {
            key: "hasParent",
            value: function hasParent() {
                return Boolean(this.parent);
            }
        },
        {
            key: "parentScope",
            value: function parentScope(type) {
                if (!this.parent) throw new Error("cannot find parent");
                if (type && this.parent instanceof type) return this.parent;
                if (type) throw new Error("actual parent is not instance of type");
                return this.parent;
            }
        }
    ]);
    return Scope;
}();
function $bad63f27bc7a37b5$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $bad63f27bc7a37b5$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $bad63f27bc7a37b5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bad63f27bc7a37b5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bad63f27bc7a37b5$var$_arrayLikeToArray(o, minLen);
}
function $bad63f27bc7a37b5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bad63f27bc7a37b5$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $bad63f27bc7a37b5$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $bad63f27bc7a37b5$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Signal types produced by NodeEditor instance
 * @typeParam Scheme - The scheme type
 * @priority 10
 * @group Primary
 */ /**
 * The NodeEditor class is the entry class. It is used to create and manage nodes and connections.
 * @typeParam Scheme - The scheme type
 * @priority 7
 * @group Primary
 */ var $bad63f27bc7a37b5$export$970c2db48345af40 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(NodeEditor, _Scope);
    var _super = $bad63f27bc7a37b5$var$_createSuper$1(NodeEditor);
    function NodeEditor() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, NodeEditor);
        _this = _super.call(this, "NodeEditor");
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "nodes", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "connections", []);
        return _this;
    }
    /**
   * Get a node by id
   * @param id - The node id
   * @returns The node or undefined
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(NodeEditor, [
        {
            key: "getNode",
            value: function getNode(id) {
                return this.nodes.find(function(node) {
                    return node.id === id;
                });
            }
        },
        {
            key: "getNodes",
            value: function getNodes() {
                return this.nodes.slice();
            }
        },
        {
            key: "getConnections",
            value: function getConnections() {
                return this.connections.slice();
            }
        },
        {
            key: "getConnection",
            value: function getConnection(id) {
                return this.connections.find(function(connection) {
                    return connection.id === id;
                });
            }
        },
        {
            key: "addNode",
            value: function() {
                var _addNode = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(data) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!this.getNode(data.id)) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new Error("node has already been added");
                            case 2:
                                _context.next = 4;
                                return this.emit({
                                    type: "nodecreate",
                                    data: data
                                });
                            case 4:
                                if (_context.sent) {
                                    _context.next = 6;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 6:
                                this.nodes.push(data);
                                _context.next = 9;
                                return this.emit({
                                    type: "nodecreated",
                                    data: data
                                });
                            case 9:
                                return _context.abrupt("return", true);
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function addNode(_x) {
                    return _addNode.apply(this, arguments);
                }
                return addNode;
            }()
        },
        {
            key: "addConnection",
            value: function() {
                var _addConnection = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(data) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!this.getConnection(data.id)) {
                                    _context2.next = 2;
                                    break;
                                }
                                throw new Error("connection has already been added");
                            case 2:
                                _context2.next = 4;
                                return this.emit({
                                    type: "connectioncreate",
                                    data: data
                                });
                            case 4:
                                if (_context2.sent) {
                                    _context2.next = 6;
                                    break;
                                }
                                return _context2.abrupt("return", false);
                            case 6:
                                this.connections.push(data);
                                _context2.next = 9;
                                return this.emit({
                                    type: "connectioncreated",
                                    data: data
                                });
                            case 9:
                                return _context2.abrupt("return", true);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function addConnection(_x2) {
                    return _addConnection.apply(this, arguments);
                }
                return addConnection;
            }()
        },
        {
            key: "removeNode",
            value: function() {
                var _removeNode = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(id) {
                    var index, node;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                index = this.nodes.findIndex(function(n) {
                                    return n.id === id;
                                });
                                node = this.nodes[index];
                                if (!(index < 0)) {
                                    _context3.next = 4;
                                    break;
                                }
                                throw new Error("cannot find node");
                            case 4:
                                _context3.next = 6;
                                return this.emit({
                                    type: "noderemove",
                                    data: node
                                });
                            case 6:
                                if (_context3.sent) {
                                    _context3.next = 8;
                                    break;
                                }
                                return _context3.abrupt("return", false);
                            case 8:
                                this.nodes.splice(index, 1);
                                _context3.next = 11;
                                return this.emit({
                                    type: "noderemoved",
                                    data: node
                                });
                            case 11:
                                return _context3.abrupt("return", true);
                            case 12:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function removeNode(_x3) {
                    return _removeNode.apply(this, arguments);
                }
                return removeNode;
            }()
        },
        {
            key: "removeConnection",
            value: function() {
                var _removeConnection = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee4(id) {
                    var index, connection;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                index = this.connections.findIndex(function(n) {
                                    return n.id === id;
                                });
                                connection = this.connections[index];
                                if (!(index < 0)) {
                                    _context4.next = 4;
                                    break;
                                }
                                throw new Error("cannot find connection");
                            case 4:
                                _context4.next = 6;
                                return this.emit({
                                    type: "connectionremove",
                                    data: connection
                                });
                            case 6:
                                if (_context4.sent) {
                                    _context4.next = 8;
                                    break;
                                }
                                return _context4.abrupt("return", false);
                            case 8:
                                this.connections.splice(index, 1);
                                _context4.next = 11;
                                return this.emit({
                                    type: "connectionremoved",
                                    data: connection
                                });
                            case 11:
                                return _context4.abrupt("return", true);
                            case 12:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function removeConnection(_x4) {
                    return _removeConnection.apply(this, arguments);
                }
                return removeConnection;
            }()
        },
        {
            key: "clear",
            value: function() {
                var _clear = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee5() {
                    var _iterator, _step, connection, _iterator2, _step2, node;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.next = 2;
                                return this.emit({
                                    type: "clear"
                                });
                            case 2:
                                if (_context5.sent) {
                                    _context5.next = 6;
                                    break;
                                }
                                _context5.next = 5;
                                return this.emit({
                                    type: "clearcancelled"
                                });
                            case 5:
                                return _context5.abrupt("return", false);
                            case 6:
                                _iterator = $bad63f27bc7a37b5$var$_createForOfIteratorHelper(this.connections.slice());
                                _context5.prev = 7;
                                _iterator.s();
                            case 9:
                                if ((_step = _iterator.n()).done) {
                                    _context5.next = 15;
                                    break;
                                }
                                connection = _step.value;
                                _context5.next = 13;
                                return this.removeConnection(connection.id);
                            case 13:
                                _context5.next = 9;
                                break;
                            case 15:
                                _context5.next = 20;
                                break;
                            case 17:
                                _context5.prev = 17;
                                _context5.t0 = _context5["catch"](7);
                                _iterator.e(_context5.t0);
                            case 20:
                                _context5.prev = 20;
                                _iterator.f();
                                return _context5.finish(20);
                            case 23:
                                _iterator2 = $bad63f27bc7a37b5$var$_createForOfIteratorHelper(this.nodes.slice());
                                _context5.prev = 24;
                                _iterator2.s();
                            case 26:
                                if ((_step2 = _iterator2.n()).done) {
                                    _context5.next = 32;
                                    break;
                                }
                                node = _step2.value;
                                _context5.next = 30;
                                return this.removeNode(node.id);
                            case 30:
                                _context5.next = 26;
                                break;
                            case 32:
                                _context5.next = 37;
                                break;
                            case 34:
                                _context5.prev = 34;
                                _context5.t1 = _context5["catch"](24);
                                _iterator2.e(_context5.t1);
                            case 37:
                                _context5.prev = 37;
                                _iterator2.f();
                                return _context5.finish(37);
                            case 40:
                                _context5.next = 42;
                                return this.emit({
                                    type: "cleared"
                                });
                            case 42:
                                return _context5.abrupt("return", true);
                            case 43:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this, [
                        [
                            7,
                            17,
                            20,
                            23
                        ],
                        [
                            24,
                            34,
                            37,
                            40
                        ]
                    ]);
                }));
                function clear() {
                    return _clear.apply(this, arguments);
                }
                return clear;
            }()
        }
    ]);
    return NodeEditor;
}($bad63f27bc7a37b5$export$775b6bb06e53a214);
/* global globalThis*/ var $bad63f27bc7a37b5$var$crypto = globalThis.crypto;
/**
 * @returns A unique id
 */ function $bad63f27bc7a37b5$export$6d2b3473b0986646() {
    if ("randomBytes" in $bad63f27bc7a37b5$var$crypto) return $bad63f27bc7a37b5$var$crypto.randomBytes(8).toString("hex");
    var bytes = $bad63f27bc7a37b5$var$crypto.getRandomValues(new Uint8Array(8));
    var array = Array.from(bytes);
    var hexPairs = array.map(function(b) {
        return b.toString(16).padStart(2, "0");
    });
    return hexPairs.join("");
}
function $bad63f27bc7a37b5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bad63f27bc7a37b5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $bad63f27bc7a37b5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * The socket class
 * @priority 7
 */ var $bad63f27bc7a37b5$var$Socket = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(/**
 * @constructor
 * @param name Name of the socket
 */ function Socket(name) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Socket);
    this.name = name;
});
/**
 * General port class
 */ var $bad63f27bc7a37b5$var$Port = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(/**
 * Port id, unique string generated by `getUID` function
 */ /**
 * Port index, used for sorting ports. Default is `0`
 */ /**
 * @constructor
 * @param socket Socket instance
 * @param label Label of the port
 * @param multipleConnections Whether the output port can have multiple connections
 */ function Port(socket, label, multipleConnections) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Port);
    this.socket = socket;
    this.label = label;
    this.multipleConnections = multipleConnections;
    this.id = $bad63f27bc7a37b5$export$6d2b3473b0986646();
});
/**
 * The input port class
 * @priority 6
 */ var $bad63f27bc7a37b5$var$Input = /*#__PURE__*/ function(_Port) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Input, _Port);
    var _super = $bad63f27bc7a37b5$var$_createSuper(Input);
    /**
   * @constructor
   * @param socket Socket instance
   * @param label Label of the input port
   * @param multipleConnections Whether the output port can have multiple connections. Default is `false`
   */ function Input(socket, label, multipleConnections) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Input);
        _this = _super.call(this, socket, label, multipleConnections);
        /**
     * Control instance
     */ (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "control", null);
        /**
     * Whether the control is visible. Can be managed dynamically by extensions. Default is `true`
     */ (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "showControl", true);
        _this.socket = socket;
        _this.label = label;
        _this.multipleConnections = multipleConnections;
        return _this;
    }
    /**
   * Add control to the input port
   * @param control Control instance
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Input, [
        {
            key: "addControl",
            value: function addControl(control) {
                if (this.control) throw new Error("control already added for this input");
                this.control = control;
            }
        },
        {
            key: "removeControl",
            value: function removeControl() {
                this.control = null;
            }
        }
    ]);
    return Input;
}($bad63f27bc7a37b5$var$Port);
/**
 * The output port class
 * @priority 5
 */ var $bad63f27bc7a37b5$var$Output = /*#__PURE__*/ function(_Port2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Output, _Port2);
    var _super2 = $bad63f27bc7a37b5$var$_createSuper(Output);
    /**
   * @constructor
   * @param socket Socket instance
   * @param label Label of the output port
   * @param multipleConnections Whether the output port can have multiple connections. Default is `true`
   */ function Output(socket, label, multipleConnections) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Output);
        return _super2.call(this, socket, label, multipleConnections !== false);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Output);
}($bad63f27bc7a37b5$var$Port);
/**
 * General control class
 * @priority 5
 */ var $bad63f27bc7a37b5$var$Control = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(/**
 * Control id, unique string generated by `getUID` function
 */ /**
 * Control index, used for sorting controls. Default is `0`
 */ function Control() {
    (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Control);
    this.id = $bad63f27bc7a37b5$export$6d2b3473b0986646();
});
/**
 * Input control options
 */ /**
 * The input control class
 * @example new InputControl('text', { readonly: true, initial: 'hello' })
 */ var $bad63f27bc7a37b5$var$InputControl = /*#__PURE__*/ function(_Control) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(InputControl, _Control);
    var _super3 = $bad63f27bc7a37b5$var$_createSuper(InputControl);
    /**
   * @constructor
   * @param type Type of the control: `text` or `number`
   * @param options Control options
   */ function InputControl(type, options) {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, InputControl);
        _this2 = _super3.call(this);
        _this2.type = type;
        _this2.options = options;
        _this2.id = $bad63f27bc7a37b5$export$6d2b3473b0986646();
        _this2.readonly = options === null || options === void 0 ? void 0 : options.readonly;
        if (typeof (options === null || options === void 0 ? void 0 : options.initial) !== "undefined") _this2.value = options.initial;
        return _this2;
    }
    /**
   * Set control value
   * @param value Value to set
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(InputControl, [
        {
            key: "setValue",
            value: function setValue(value) {
                var _this$options;
                this.value = value;
                if ((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.change) this.options.change(value);
            }
        }
    ]);
    return InputControl;
}($bad63f27bc7a37b5$var$Control);
/**
 * The node class
 * @priority 10
 * @example new Node('math')
 */ var $bad63f27bc7a37b5$var$Node = /*#__PURE__*/ function() {
    /**
   * Whether the node is selected. Default is `false`
   */ function Node(label) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Node);
        /**
     * Node id, unique string generated by `getUID` function
     */ /**
     * Node inputs
     */ (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "inputs", {});
        /**
     * Node outputs
     */ (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "outputs", {});
        /**
     * Node controls
     */ (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "controls", {});
        this.label = label;
        this.id = $bad63f27bc7a37b5$export$6d2b3473b0986646();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Node, [
        {
            key: "hasInput",
            value: function hasInput(key) {
                return Object.prototype.hasOwnProperty.call(this.inputs, key);
            }
        },
        {
            key: "addInput",
            value: function addInput(key, input) {
                if (this.hasInput(key)) throw new Error("input with key '".concat(String(key), "' already added"));
                Object.defineProperty(this.inputs, key, {
                    value: input,
                    enumerable: true,
                    configurable: true
                });
            }
        },
        {
            key: "removeInput",
            value: function removeInput(key) {
                delete this.inputs[key];
            }
        },
        {
            key: "hasOutput",
            value: function hasOutput(key) {
                return Object.prototype.hasOwnProperty.call(this.outputs, key);
            }
        },
        {
            key: "addOutput",
            value: function addOutput(key, output) {
                if (this.hasOutput(key)) throw new Error("output with key '".concat(String(key), "' already added"));
                Object.defineProperty(this.outputs, key, {
                    value: output,
                    enumerable: true,
                    configurable: true
                });
            }
        },
        {
            key: "removeOutput",
            value: function removeOutput(key) {
                delete this.outputs[key];
            }
        },
        {
            key: "hasControl",
            value: function hasControl(key) {
                return Object.prototype.hasOwnProperty.call(this.controls, key);
            }
        },
        {
            key: "addControl",
            value: function addControl(key, control) {
                if (this.hasControl(key)) throw new Error("control with key '".concat(String(key), "' already added"));
                Object.defineProperty(this.controls, key, {
                    value: control,
                    enumerable: true,
                    configurable: true
                });
            }
        },
        {
            key: "removeControl",
            value: function removeControl(key) {
                delete this.controls[key];
            }
        }
    ]);
    return Node;
}();
/**
 * The connection class
 * @priority 9
 */ var $bad63f27bc7a37b5$var$Connection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(/**
 * Connection id, unique string generated by `getUID` function
 */ /**
 * Source node id
 */ /**
 * Target node id
 */ /**
 * @constructor
 * @param source Source node instance
 * @param sourceOutput Source node output key
 * @param target Target node instance
 * @param targetInput Target node input key
 */ function Connection(source, sourceOutput, target, targetInput) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Connection);
    this.sourceOutput = sourceOutput;
    this.targetInput = targetInput;
    if (!source.outputs[sourceOutput]) throw new Error("source node doesn't have output with a key ".concat(String(sourceOutput)));
    if (!target.inputs[targetInput]) throw new Error("target node doesn't have input with a key ".concat(String(targetInput)));
    this.id = $bad63f27bc7a37b5$export$6d2b3473b0986646();
    this.source = source.id;
    this.target = target.id;
});
var $bad63f27bc7a37b5$export$c53446ac9c5804d8 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Socket: $bad63f27bc7a37b5$var$Socket,
    Port: $bad63f27bc7a37b5$var$Port,
    Input: $bad63f27bc7a37b5$var$Input,
    Output: $bad63f27bc7a37b5$var$Output,
    Control: $bad63f27bc7a37b5$var$Control,
    InputControl: $bad63f27bc7a37b5$var$InputControl,
    Node: $bad63f27bc7a37b5$var$Node,
    Connection: $bad63f27bc7a37b5$var$Connection
});


/*!
* rete-area-plugin v2.1.2
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 

var $41YNz = parcelRequire("41YNz");







var $b95e04f2d4c66124$exports = {};
var $41f5c206613f56c9$exports = {};
var $1e0ecff44bad0ea1$exports = {};
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$1e0ecff44bad0ea1$exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, $1e0ecff44bad0ea1$exports.__esModule = true, $1e0ecff44bad0ea1$exports["default"] = $1e0ecff44bad0ea1$exports;


function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $1e0ecff44bad0ea1$exports(r);
}
$41f5c206613f56c9$exports = $41f5c206613f56c9$var$_arrayWithoutHoles, $41f5c206613f56c9$exports.__esModule = true, $41f5c206613f56c9$exports["default"] = $41f5c206613f56c9$exports;


var $cce79e023a3a67e7$exports = {};
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$cce79e023a3a67e7$exports = $cce79e023a3a67e7$var$_iterableToArray, $cce79e023a3a67e7$exports.__esModule = true, $cce79e023a3a67e7$exports["default"] = $cce79e023a3a67e7$exports;


var $51f08ebed50a2438$exports = {};

function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1e0ecff44bad0ea1$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1e0ecff44bad0ea1$exports(r, a) : void 0;
    }
}
$51f08ebed50a2438$exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, $51f08ebed50a2438$exports.__esModule = true, $51f08ebed50a2438$exports["default"] = $51f08ebed50a2438$exports;


var $67c90abe6042aecd$exports = {};
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$67c90abe6042aecd$exports = $67c90abe6042aecd$var$_nonIterableSpread, $67c90abe6042aecd$exports.__esModule = true, $67c90abe6042aecd$exports["default"] = $67c90abe6042aecd$exports;


function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $41f5c206613f56c9$exports(r) || $cce79e023a3a67e7$exports(r) || $51f08ebed50a2438$exports(r) || $67c90abe6042aecd$exports();
}
$b95e04f2d4c66124$exports = $b95e04f2d4c66124$var$_toConsumableArray, $b95e04f2d4c66124$exports.__esModule = true, $b95e04f2d4c66124$exports["default"] = $b95e04f2d4c66124$exports;



function $8edd8caaa4dabbef$var$___$insertStyle(css) {
    if (!css) return;
    if (typeof window === "undefined") return;
    var style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
var $8edd8caaa4dabbef$var$Content = /*#__PURE__*/ function() {
    function Content(reordered) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Content);
        this.reordered = reordered;
        this.holder = document.createElement("div");
        this.holder.style.transformOrigin = "0 0";
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Content, [
        {
            key: "getPointerFrom",
            value: function getPointerFrom(event) {
                var _this$holder$getBound = this.holder.getBoundingClientRect(), left = _this$holder$getBound.left, top = _this$holder$getBound.top;
                var x = event.clientX - left;
                var y = event.clientY - top;
                return {
                    x: x,
                    y: y
                };
            }
        },
        {
            key: "add",
            value: function add(element) {
                this.holder.appendChild(element);
            }
        },
        {
            key: "reorder",
            value: function() {
                var _reorder = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(target, next) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.holder.contains(target)) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new Error("content doesn't have 'target' for reordering");
                            case 2:
                                if (!(next !== null && !this.holder.contains(next))) {
                                    _context.next = 4;
                                    break;
                                }
                                throw new Error("content doesn't have 'next' for reordering");
                            case 4:
                                this.holder.insertBefore(target, next);
                                _context.next = 7;
                                return this.reordered(target);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function reorder(_x, _x2) {
                    return _reorder.apply(this, arguments);
                }
                return reorder;
            }()
        },
        {
            key: "remove",
            value: function remove(element) {
                if (this.holder.contains(element)) this.holder.removeChild(element);
            }
        }
    ]);
}();
/**
 * listen to pointerdown, window's pointermove and pointerup events,
 * where last two not active before pointerdown triggered for performance reasons
 */ function $8edd8caaa4dabbef$export$2930d38f4e14d4f6(element, handlers) {
    var move = function move(event) {
        handlers.move(event);
    };
    var _up = function up(event) {
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", _up);
        window.removeEventListener("pointercancel", _up);
        handlers.up(event);
    };
    var down = function down(event) {
        window.addEventListener("pointermove", move);
        window.addEventListener("pointerup", _up);
        window.addEventListener("pointercancel", _up);
        handlers.down(event);
    };
    element.addEventListener("pointerdown", down);
    return {
        destroy: function destroy() {
            element.removeEventListener("pointerdown", down);
            window.removeEventListener("pointermove", move);
            window.removeEventListener("pointerup", _up);
            window.removeEventListener("pointercancel", _up);
        }
    };
}
/**
 * Bounding box
 */ var $8edd8caaa4dabbef$var$min = function min(arr) {
    return arr.length === 0 ? 0 : Math.min.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(arr));
};
var $8edd8caaa4dabbef$var$max = function max(arr) {
    return arr.length === 0 ? 0 : Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(arr));
};
function $8edd8caaa4dabbef$var$getBoundingBox$1(rects) {
    var left = $8edd8caaa4dabbef$var$min(rects.map(function(rect) {
        return rect.position.x;
    }));
    var top = $8edd8caaa4dabbef$var$min(rects.map(function(rect) {
        return rect.position.y;
    }));
    var right = $8edd8caaa4dabbef$var$max(rects.map(function(rect) {
        return rect.position.x + rect.width;
    }));
    var bottom = $8edd8caaa4dabbef$var$max(rects.map(function(rect) {
        return rect.position.y + rect.height;
    }));
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom,
        width: Math.abs(left - right),
        height: Math.abs(top - bottom),
        center: {
            x: (left + right) / 2,
            y: (top + bottom) / 2
        }
    };
}
function $8edd8caaa4dabbef$var$ownKeys$4(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8edd8caaa4dabbef$var$_objectSpread$4(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8edd8caaa4dabbef$var$ownKeys$4(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8edd8caaa4dabbef$var$ownKeys$4(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Drag handler, used to handle dragging of the area and nodes. Can be extended to add custom behavior.
 */ var $8edd8caaa4dabbef$export$b48985bba8f530f5 = /*#__PURE__*/ function() {
    function Drag(guards) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Drag);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "down", function(e) {
            if (!_this.guards.down(e)) return;
            e.stopPropagation();
            _this.pointerStart = {
                x: e.pageX,
                y: e.pageY
            };
            _this.startPosition = $8edd8caaa4dabbef$var$_objectSpread$4({}, _this.config.getCurrentPosition());
            _this.events.start(e);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "move", function(e) {
            if (!_this.pointerStart || !_this.startPosition) return;
            if (!_this.guards.move(e)) return;
            e.preventDefault();
            var delta = {
                x: e.pageX - _this.pointerStart.x,
                y: e.pageY - _this.pointerStart.y
            };
            var zoom = _this.config.getZoom();
            var x = _this.startPosition.x + delta.x / zoom;
            var y = _this.startPosition.y + delta.y / zoom;
            _this.events.translate(x, y, e);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "up", function(e) {
            if (!_this.pointerStart) return;
            delete _this.pointerStart;
            _this.events.drag(e);
        });
        this.guards = guards || {
            down: function down(e) {
                return !(e.pointerType === "mouse" && e.button !== 0);
            },
            move: function move() {
                return true;
            }
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Drag, [
        {
            key: "initialize",
            value: function initialize(element, config, events) {
                this.config = config;
                this.events = events;
                element.style.touchAction = "none";
                this.pointerListener = $8edd8caaa4dabbef$export$2930d38f4e14d4f6(element, {
                    down: this.down,
                    move: this.move,
                    up: this.up
                });
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.pointerListener.destroy();
            }
        }
    ]);
}();
/**
 * Zoom source
 */ /**
 * Zoom class, used to handle zooming of the area. Can be extended to add custom behavior.
 * @internal
 */ var $8edd8caaa4dabbef$export$65cfd44a2050f99 = /*#__PURE__*/ function() {
    function Zoom(intensity) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Zoom);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "previous", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "pointers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "wheel", function(e) {
            e.preventDefault();
            var _this$element$getBoun = _this.element.getBoundingClientRect(), left = _this$element$getBoun.left, top = _this$element$getBoun.top;
            var isNegative = e.deltaY < 0;
            var delta = isNegative ? _this.intensity : -_this.intensity;
            var ox = (left - e.clientX) * delta;
            var oy = (top - e.clientY) * delta;
            _this.onzoom(delta, ox, oy, "wheel");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "down", function(e) {
            _this.pointers.push(e);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "move", function(e) {
            _this.pointers = _this.pointers.map(function(p) {
                return p.pointerId === e.pointerId ? e : p;
            });
            if (!_this.isTranslating()) return;
            var _this$element$getBoun2 = _this.element.getBoundingClientRect(), left = _this$element$getBoun2.left, top = _this$element$getBoun2.top;
            var _this$getTouches = _this.getTouches(), cx = _this$getTouches.cx, cy = _this$getTouches.cy, distance = _this$getTouches.distance;
            if (_this.previous !== null && _this.previous.distance > 0) {
                var _delta = distance / _this.previous.distance - 1;
                var _ox = (left - cx) * _delta;
                var _oy = (top - cy) * _delta;
                _this.onzoom(_delta, _ox - (_this.previous.cx - cx), _oy - (_this.previous.cy - cy), "touch");
            }
            _this.previous = {
                cx: cx,
                cy: cy,
                distance: distance
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "contextmenu", function() {
            _this.pointers = [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "up", function(e) {
            _this.previous = null;
            _this.pointers = _this.pointers.filter(function(p) {
                return p.pointerId !== e.pointerId;
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "dblclick", function(e) {
            e.preventDefault();
            var _this$element$getBoun3 = _this.element.getBoundingClientRect(), left = _this$element$getBoun3.left, top = _this$element$getBoun3.top;
            var delta = 4 * _this.intensity;
            var ox = (left - e.clientX) * delta;
            var oy = (top - e.clientY) * delta;
            _this.onzoom(delta, ox, oy, "dblclick");
        });
        this.intensity = intensity;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Zoom, [
        {
            key: "initialize",
            value: function initialize(container, element, onzoom) {
                this.container = container;
                this.element = element;
                this.onzoom = onzoom;
                this.container.addEventListener("wheel", this.wheel);
                this.container.addEventListener("pointerdown", this.down);
                this.container.addEventListener("dblclick", this.dblclick);
                window.addEventListener("pointermove", this.move);
                window.addEventListener("pointerup", this.up);
                window.addEventListener("pointercancel", this.up);
                window.addEventListener("contextmenu", this.contextmenu);
            }
        },
        {
            key: "getTouches",
            value: function getTouches() {
                var e = {
                    touches: this.pointers
                };
                var _ref = [
                    e.touches[0].clientX,
                    e.touches[0].clientY
                ], x1 = _ref[0], y1 = _ref[1];
                var _ref2 = [
                    e.touches[1].clientX,
                    e.touches[1].clientY
                ], x2 = _ref2[0], y2 = _ref2[1];
                var distance = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
                return {
                    cx: (x1 + x2) / 2,
                    cy: (y1 + y2) / 2,
                    distance: distance
                };
            }
        },
        {
            key: "isTranslating",
            value: function isTranslating() {
                // is translating while zoom (works on multitouch)
                return this.pointers.length >= 2;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.container.removeEventListener("wheel", this.wheel);
                this.container.removeEventListener("pointerdown", this.down);
                this.container.removeEventListener("dblclick", this.dblclick);
                window.removeEventListener("pointermove", this.move);
                window.removeEventListener("pointerup", this.up);
                window.removeEventListener("pointercancel", this.up);
                window.removeEventListener("contextmenu", this.contextmenu);
            }
        }
    ]);
}();
var $8edd8caaa4dabbef$export$ea1a111407f37557 = /*#__PURE__*/ function() {
    function Area(container, events, guards) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Area);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "transform", {
            k: 1,
            x: 0,
            y: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "pointer", {
            x: 0,
            y: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "zoomHandler", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "dragHandler", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "pointerdown", function(event) {
            _this.setPointerFrom(event);
            _this.events.pointerDown(_this.pointer, event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "pointermove", function(event) {
            _this.setPointerFrom(event);
            _this.events.pointerMove(_this.pointer, event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "pointerup", function(event) {
            _this.setPointerFrom(event);
            _this.events.pointerUp(_this.pointer, event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "resize", function(event) {
            _this.events.resize(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "onTranslate", function(x, y) {
            var _this$zoomHandler;
            if ((_this$zoomHandler = _this.zoomHandler) !== null && _this$zoomHandler !== void 0 && _this$zoomHandler.isTranslating()) return; // lock translation while zoom on multitouch
            _this.translate(x, y);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "onZoom", function(delta, ox, oy, source) {
            _this.zoom(_this.transform.k * (1 + delta), ox, oy, source);
            _this.update();
        });
        this.container = container;
        this.events = events;
        this.guards = guards;
        this.content = new $8edd8caaa4dabbef$var$Content(function(element) {
            return _this.events.reordered(element);
        });
        this.content.holder.style.transformOrigin = "0 0";
        this.setZoomHandler(new $8edd8caaa4dabbef$export$65cfd44a2050f99(0.1));
        this.setDragHandler(new $8edd8caaa4dabbef$export$b48985bba8f530f5());
        this.container.addEventListener("pointerdown", this.pointerdown);
        this.container.addEventListener("pointermove", this.pointermove);
        window.addEventListener("pointerup", this.pointerup);
        window.addEventListener("resize", this.resize);
        container.appendChild(this.content.holder);
        this.update();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Area, [
        {
            key: "update",
            value: function update() {
                var _this$transform = this.transform, x = _this$transform.x, y = _this$transform.y, k = _this$transform.k;
                this.content.holder.style.transform = "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(k, ")");
            }
        },
        {
            key: "setDragHandler",
            value: function setDragHandler(drag) {
                var _this2 = this;
                if (this.dragHandler) this.dragHandler.destroy();
                this.dragHandler = drag;
                if (this.dragHandler) this.dragHandler.initialize(this.container, {
                    getCurrentPosition: function getCurrentPosition() {
                        return _this2.transform;
                    },
                    getZoom: function getZoom() {
                        return 1;
                    }
                }, {
                    start: function start() {
                        return null;
                    },
                    translate: this.onTranslate,
                    drag: function drag() {
                        return null;
                    }
                });
            }
        },
        {
            key: "setZoomHandler",
            value: function setZoomHandler(zoom) {
                if (this.zoomHandler) this.zoomHandler.destroy();
                this.zoomHandler = zoom;
                if (this.zoomHandler) this.zoomHandler.initialize(this.container, this.content.holder, this.onZoom);
            }
        },
        {
            key: "setPointerFrom",
            value: function setPointerFrom(event) {
                var _this$content$getPoin = this.content.getPointerFrom(event), x = _this$content$getPoin.x, y = _this$content$getPoin.y;
                var k = this.transform.k;
                this.pointer = {
                    x: x / k,
                    y: y / k
                };
            }
        },
        {
            key: "translate",
            value: /**
     * Change position of the area
     * @param x desired x coordinate
     * @param y desired y coordinate
     * @returns true if the translation was successful, false otherwise
     * @emits translate
     * @emits translated
     */ function() {
                var _translate = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(x, y) {
                    var position, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                position = {
                                    x: x,
                                    y: y
                                };
                                _context.next = 3;
                                return this.guards.translate({
                                    previous: this.transform,
                                    position: position
                                });
                            case 3:
                                result = _context.sent;
                                if (result) {
                                    _context.next = 6;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 6:
                                this.transform.x = result.data.position.x;
                                this.transform.y = result.data.position.y;
                                this.update();
                                _context.next = 11;
                                return this.events.translated(result.data);
                            case 11:
                                return _context.abrupt("return", true);
                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function translate(_x, _x2) {
                    return _translate.apply(this, arguments);
                }
                return translate;
            }()
        },
        {
            key: "zoom",
            value: function() {
                var _zoom2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(_zoom) {
                    var ox, oy, source, k, result, d, _args2 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                ox = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;
                                oy = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 0;
                                source = _args2.length > 3 ? _args2[3] : undefined;
                                k = this.transform.k;
                                _context2.next = 6;
                                return this.guards.zoom({
                                    previous: this.transform,
                                    zoom: _zoom,
                                    source: source
                                });
                            case 6:
                                result = _context2.sent;
                                if (result) {
                                    _context2.next = 9;
                                    break;
                                }
                                return _context2.abrupt("return", true);
                            case 9:
                                d = (k - result.data.zoom) / (k - _zoom || 1);
                                this.transform.k = result.data.zoom || 1;
                                this.transform.x += ox * d;
                                this.transform.y += oy * d;
                                this.update();
                                _context2.next = 16;
                                return this.events.zoomed(result.data);
                            case 16:
                                return _context2.abrupt("return", false);
                            case 17:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function zoom(_x3) {
                    return _zoom2.apply(this, arguments);
                }
                return zoom;
            }()
        },
        {
            key: "destroy",
            value: function destroy() {
                this.container.removeEventListener("pointerdown", this.pointerdown);
                this.container.removeEventListener("pointermove", this.pointermove);
                window.removeEventListener("pointerup", this.pointerup);
                window.removeEventListener("resize", this.resize);
                if (this.dragHandler) this.dragHandler.destroy();
                if (this.zoomHandler) this.zoomHandler.destroy();
                this.content.holder.innerHTML = "";
            }
        }
    ]);
}();
function $8edd8caaa4dabbef$var$_callSuper$1(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $8edd8caaa4dabbef$var$_isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $8edd8caaa4dabbef$var$_isNativeReflectConstruct$1() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8edd8caaa4dabbef$var$_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * A union of all possible signals that can be emitted by any area plugin
 * @priority 10
 */ /**
 * Base abstract class for area plugins that provides a common interface
 * @abstract
 */ var $8edd8caaa4dabbef$export$893ad666b26a6f6e = /*#__PURE__*/ function(_Scope) {
    function BaseAreaPlugin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, BaseAreaPlugin);
        return $8edd8caaa4dabbef$var$_callSuper$1(this, BaseAreaPlugin, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(BaseAreaPlugin, _Scope);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(BaseAreaPlugin);
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));
var $8edd8caaa4dabbef$var$ConnectionView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(function ConnectionView(events) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ConnectionView);
    this.element = document.createElement("div");
    this.element.style.position = "absolute";
    this.element.style.left = "0";
    this.element.style.top = "0";
    this.element.addEventListener("contextmenu", function(event) {
        return events.contextmenu(event);
    });
});
var $8edd8caaa4dabbef$var$ElementsHolder = /*#__PURE__*/ function() {
    function ElementsHolder() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ElementsHolder);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "views", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "viewsElements", new Map());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ElementsHolder, [
        {
            key: "set",
            value: function set(context) {
                var element = context.element, type = context.type, payload = context.payload;
                if (payload !== null && payload !== void 0 && payload.id) {
                    this.views.set(element, context);
                    this.viewsElements.set("".concat(type, "_").concat(payload.id), element);
                }
            }
        },
        {
            key: "get",
            value: function get(type, id) {
                var element = this.viewsElements.get("".concat(type, "_").concat(id));
                return element && this.views.get(element);
            }
        },
        {
            key: "delete",
            value: function _delete(element) {
                var _view$payload;
                var view = this.views.get(element);
                if (view && (_view$payload = view.payload) !== null && _view$payload !== void 0 && _view$payload.id) {
                    this.views["delete"](element);
                    this.viewsElements["delete"]("".concat(view.type, "_").concat(view.payload.id));
                }
            }
        }
    ]);
}();
function $8edd8caaa4dabbef$var$ownKeys$3(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8edd8caaa4dabbef$var$_objectSpread$3(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8edd8caaa4dabbef$var$ownKeys$3(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8edd8caaa4dabbef$var$ownKeys$3(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8edd8caaa4dabbef$export$77c6811359a01a6f = /*#__PURE__*/ function() {
    function NodeView(getZoom, events, guards) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, NodeView);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "translate", /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(x, y) {
                var previous, translation;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            previous = $8edd8caaa4dabbef$var$_objectSpread$3({}, _this.position);
                            _context.next = 3;
                            return _this.guards.translate({
                                previous: previous,
                                position: {
                                    x: x,
                                    y: y
                                }
                            });
                        case 3:
                            translation = _context.sent;
                            if (translation) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", false);
                        case 6:
                            _this.position = $8edd8caaa4dabbef$var$_objectSpread$3({}, translation.data.position);
                            _this.element.style.transform = "translate(".concat(_this.position.x, "px, ").concat(_this.position.y, "px)");
                            _context.next = 10;
                            return _this.events.translated({
                                position: _this.position,
                                previous: previous
                            });
                        case 10:
                            return _context.abrupt("return", true);
                        case 11:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "resize", /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(width, height) {
                var size, el;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            size = {
                                width: width,
                                height: height
                            };
                            _context2.next = 3;
                            return _this.guards.resize({
                                size: size
                            });
                        case 3:
                            if (_context2.sent) {
                                _context2.next = 5;
                                break;
                            }
                            return _context2.abrupt("return", false);
                        case 5:
                            el = _this.element.querySelector("*:not(span):not([fragment])");
                            if (!(!el || !(el instanceof HTMLElement))) {
                                _context2.next = 8;
                                break;
                            }
                            return _context2.abrupt("return", false);
                        case 8:
                            el.style.width = "".concat(width, "px");
                            el.style.height = "".concat(height, "px");
                            _context2.next = 12;
                            return _this.events.resized({
                                size: size
                            });
                        case 12:
                            return _context2.abrupt("return", true);
                        case 13:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function(_x3, _x4) {
                return _ref2.apply(this, arguments);
            };
        }());
        this.getZoom = getZoom;
        this.events = events;
        this.guards = guards;
        this.element = document.createElement("div");
        this.element.style.position = "absolute";
        this.position = {
            x: 0,
            y: 0
        };
        this.translate(0, 0);
        this.element.addEventListener("contextmenu", function(event) {
            return _this.events.contextmenu(event);
        });
        this.dragHandler = new $8edd8caaa4dabbef$export$b48985bba8f530f5();
        this.dragHandler.initialize(this.element, {
            getCurrentPosition: function getCurrentPosition() {
                return _this.position;
            },
            getZoom: function getZoom() {
                return _this.getZoom();
            }
        }, {
            start: this.events.picked,
            translate: this.translate,
            drag: this.events.dragged
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(NodeView, [
        {
            key: "destroy",
            value: function destroy() {
                this.dragHandler.destroy();
            }
        }
    ]);
}();
function $8edd8caaa4dabbef$var$getNodesRect(nodes, views) {
    return nodes.map(function(node) {
        return {
            view: views.get(node.id),
            node: node
        };
    }).filter(function(item) {
        return item.view;
    }).map(function(_ref) {
        var view = _ref.view, node = _ref.node;
        var width = node.width, height = node.height;
        if (typeof width !== "undefined" && typeof height !== "undefined") return {
            position: view.position,
            width: width,
            height: height
        };
        return {
            position: view.position,
            width: view.element.clientWidth,
            height: view.element.clientHeight
        };
    });
}
/**
 * Get the bounding box of the given nodes
 * @param plugin The area plugin
 * @param nodes The nodes to get the bounding box of
 * @returns The bounding box
 */ function $8edd8caaa4dabbef$var$getBoundingBox(plugin, nodes) {
    var editor = plugin.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
    var list = nodes.map(function(node) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(node) === "object" ? node : editor.getNode(node);
    });
    var rects = $8edd8caaa4dabbef$var$getNodesRect(list, plugin.nodeViews);
    return $8edd8caaa4dabbef$var$getBoundingBox$1(rects);
}
/**
 * Simple nodes order extension
 * @param base The base area plugin
 * @listens nodepicked
 * @listens connectioncreated
 */ function $8edd8caaa4dabbef$var$simpleNodesOrder(base) {
    var area = base;
    area.addPipe(function(context) {
        if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
        if (context.type === "nodepicked") {
            var view = area.nodeViews.get(context.data.id);
            var content = area.area.content;
            if (view) content.reorder(view.element, null);
        }
        if (context.type === "connectioncreated") {
            var _view = area.connectionViews.get(context.data.id);
            var _content = area.area.content;
            if (_view) _content.reorder(_view.element, _content.holder.firstChild);
        }
        return context;
    });
}
function $8edd8caaa4dabbef$var$ownKeys$2(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8edd8caaa4dabbef$var$_objectSpread$2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8edd8caaa4dabbef$var$ownKeys$2(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8edd8caaa4dabbef$var$ownKeys$2(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Restrictor extension parameters
 */ /**
 * Restrictor extension. Restricts the area zoom and position
 * @param plugin The area plugin
 * @param params The restrictor parameters
 * @listens zoom
 * @listens zoomed
 * @listens translated
 */ function $8edd8caaa4dabbef$var$restrictor(plugin, params) {
    var scaling = params !== null && params !== void 0 && params.scaling ? params.scaling === true ? {
        min: 0.1,
        max: 1
    } : params.scaling : false;
    var translation = params !== null && params !== void 0 && params.translation ? params.translation === true ? {
        left: 0,
        top: 0,
        right: 1000,
        bottom: 1000
    } : params.translation : false;
    function restrictZoom(zoom) {
        if (!scaling) throw new Error("scaling param isnt defined");
        var _ref = typeof scaling === "function" ? scaling() : scaling, min = _ref.min, max = _ref.max;
        if (zoom < min) return min;
        else if (zoom > max) return max;
        return zoom;
    }
    // eslint-disable-next-line max-statements
    function restrictPosition(position) {
        if (!translation) throw new Error("translation param isnt defined");
        var nextPosition = $8edd8caaa4dabbef$var$_objectSpread$2({}, position);
        var _ref2 = typeof translation === "function" ? translation() : translation, left = _ref2.left, top = _ref2.top, right = _ref2.right, bottom = _ref2.bottom;
        if (nextPosition.x < left) nextPosition.x = left;
        if (nextPosition.x > right) nextPosition.x = right;
        if (nextPosition.y < top) nextPosition.y = top;
        if (nextPosition.y > bottom) nextPosition.y = bottom;
        return nextPosition;
    }
    plugin.addPipe(function(context) {
        if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
        if (scaling && context.type === "zoom") return $8edd8caaa4dabbef$var$_objectSpread$2($8edd8caaa4dabbef$var$_objectSpread$2({}, context), {}, {
            data: $8edd8caaa4dabbef$var$_objectSpread$2($8edd8caaa4dabbef$var$_objectSpread$2({}, context.data), {}, {
                zoom: restrictZoom(context.data.zoom)
            })
        });
        if (translation && context.type === "zoomed") {
            var position = restrictPosition(plugin.area.transform);
            plugin.area.translate(position.x, position.y);
        }
        if (translation && context.type === "translate") return $8edd8caaa4dabbef$var$_objectSpread$2($8edd8caaa4dabbef$var$_objectSpread$2({}, context), {}, {
            data: $8edd8caaa4dabbef$var$_objectSpread$2($8edd8caaa4dabbef$var$_objectSpread$2({}, context.data), {}, {
                position: restrictPosition(context.data.position)
            })
        });
        return context;
    });
}
/**
 * Selector's accumulate function, activated when the ctrl key is pressed
 */ function $8edd8caaa4dabbef$var$accumulateOnCtrl() {
    var pressed = false;
    function keydown(e) {
        if (e.key === "Control" || e.key === "Meta") pressed = true;
    }
    function keyup(e) {
        if (e.key === "Control" || e.key === "Meta") pressed = false;
    }
    document.addEventListener("keydown", keydown);
    document.addEventListener("keyup", keyup);
    return {
        active: function active() {
            return pressed;
        },
        destroy: function destroy() {
            document.removeEventListener("keydown", keydown);
            document.removeEventListener("keyup", keyup);
        }
    };
}
/**
 * Selector class. Used to collect selected entities (nodes, connections, etc.) and synchronize them (select, unselect, translate, etc.).
 * Can be extended to add custom functionality.
 */ var $8edd8caaa4dabbef$var$Selector = /*#__PURE__*/ function() {
    function Selector() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Selector);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "entities", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "pickId", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Selector, [
        {
            key: "isSelected",
            value: function isSelected(entity) {
                return this.entities.has("".concat(entity.label, "_").concat(entity.id));
            }
        },
        {
            key: "add",
            value: function add(entity, accumulate) {
                if (!accumulate) this.unselectAll();
                this.entities.set("".concat(entity.label, "_").concat(entity.id), entity);
            }
        },
        {
            key: "remove",
            value: function remove(entity) {
                var id = "".concat(entity.label, "_").concat(entity.id);
                var item = this.entities.get(id);
                if (item) {
                    this.entities["delete"](id);
                    item.unselect();
                }
            }
        },
        {
            key: "unselectAll",
            value: function unselectAll() {
                var _this = this;
                (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(Array.from(this.entities.values())).forEach(function(item) {
                    return _this.remove(item);
                });
            }
        },
        {
            key: "translate",
            value: function translate(dx, dy) {
                var _this2 = this;
                this.entities.forEach(function(item) {
                    return !_this2.isPicked(item) && item.translate(dx, dy);
                });
            }
        },
        {
            key: "pick",
            value: function pick(entity) {
                this.pickId = "".concat(entity.label, "_").concat(entity.id);
            }
        },
        {
            key: "release",
            value: function release() {
                this.pickId = null;
            }
        },
        {
            key: "isPicked",
            value: function isPicked(entity) {
                return this.pickId === "".concat(entity.label, "_").concat(entity.id);
            }
        }
    ]);
}();
/**
 * Selector factory, uses default Selector class
 * @returns Selector instance
 */ function $8edd8caaa4dabbef$var$selector() {
    return new $8edd8caaa4dabbef$var$Selector();
}
/**
 * Accumulating interface, used to determine whether to accumulate entities on selection
 */ /**
 * Selectable nodes extension. Adds the ability to select nodes in the area.
 * @param base BaseAreaPlugin instance
 * @param core Selectable instance
 * @param options.accumulating Accumulating interface
 * @listens nodepicked
 * @listens nodetranslated
 * @listens pointerdown
 * @listens pointermove
 * @listens pointerup
 */ function $8edd8caaa4dabbef$var$selectableNodes(base, core, options) {
    var editor = null;
    var area = base;
    var getEditor = function getEditor() {
        return editor || (editor = area.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40)));
    };
    var twitch = 0;
    function selectNode(node) {
        if (!node.selected) {
            node.selected = true;
            area.update("node", node.id);
        }
    }
    function unselectNode(node) {
        if (node.selected) {
            node.selected = false;
            area.update("node", node.id);
        }
    }
    /**
   * Select node programmatically
   * @param nodeId Node id
   * @param accumulate Whether to accumulate nodes on selection
   */ function add(nodeId, accumulate) {
        var node = getEditor().getNode(nodeId);
        if (!node) return;
        core.add({
            label: "node",
            id: node.id,
            translate: function translate(dx, dy) {
                var view = area.nodeViews.get(node.id);
                var current = view === null || view === void 0 ? void 0 : view.position;
                if (current) view.translate(current.x + dx, current.y + dy);
            },
            unselect: function unselect() {
                unselectNode(node);
            }
        }, accumulate);
        selectNode(node);
    }
    /**
   * Unselect node programmatically
   * @param nodeId Node id
   */ function remove(nodeId) {
        core.remove({
            id: nodeId,
            label: "node"
        });
    }
    // eslint-disable-next-line max-statements, complexity
    area.addPipe(function(context) {
        if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
        if (context.type === "nodepicked") {
            var pickedId = context.data.id;
            var accumulate = options.accumulating.active();
            core.pick({
                id: pickedId,
                label: "node"
            });
            twitch = null;
            add(pickedId, accumulate);
        } else if (context.type === "nodetranslated") {
            var _context$data = context.data, id = _context$data.id, position = _context$data.position, previous = _context$data.previous;
            var _dx = position.x - previous.x;
            var _dy = position.y - previous.y;
            if (core.isPicked({
                id: id,
                label: "node"
            })) core.translate(_dx, _dy);
        } else if (context.type === "pointerdown") twitch = 0;
        else if (context.type === "pointermove") {
            if (twitch !== null) twitch++;
        } else if (context.type === "pointerup") {
            if (twitch !== null && twitch < 4) core.unselectAll();
            twitch = null;
        }
        return context;
    });
    return {
        select: add,
        unselect: remove
    };
}
/**
 * Show input control extension. It will show the input's control when there is no connection and hide it when there is a connection.
 * @param area The base area plugin
 * @param visible The visible function
 * @listens connectioncreated
 * @listens connectionremoved
 */ function $8edd8caaa4dabbef$var$showInputControl(area, visible) {
    var editor = null;
    var getEditor = function getEditor() {
        return editor || (editor = area.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40)));
    };
    function updateInputControlVisibility(target, targetInput) {
        var node = getEditor().getNode(target);
        if (!node) return;
        var input = node.inputs[targetInput];
        if (!input) throw new Error("cannot find input");
        var previous = input.showControl;
        var connections = getEditor().getConnections();
        var hasAnyConnection = Boolean(connections.find(function(connection) {
            return connection.target === target && connection.targetInput === targetInput;
        }));
        input.showControl = visible ? visible({
            hasAnyConnection: hasAnyConnection,
            input: input
        }) : !hasAnyConnection;
        if (input.showControl !== previous) area.update("node", node.id);
    }
    area.addPipe(function(context) {
        if (context.type === "connectioncreated" || context.type === "connectionremoved") updateInputControlVisibility(context.data.target, context.data.targetInput);
        return context;
    });
}
function $8edd8caaa4dabbef$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8edd8caaa4dabbef$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8edd8caaa4dabbef$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8edd8caaa4dabbef$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Snap grid extension parameters
 */ /**
 * Snap grid extension
 * @param base The base area plugin
 * @param params The snap parameters
 * @listens nodetranslate
 * @listens nodedragged
 */ function $8edd8caaa4dabbef$var$snapGrid(base, params) {
    var area = base;
    var size = typeof (params === null || params === void 0 ? void 0 : params.size) === "undefined" ? 16 : params.size;
    var dynamic = typeof (params === null || params === void 0 ? void 0 : params.dynamic) === "undefined" ? true : params.dynamic;
    function snap(value) {
        return Math.round(value / size) * size;
    }
    area.addPipe(function(context) {
        if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
        if (dynamic && context.type === "nodetranslate") {
            var position = context.data.position;
            var x = snap(position.x);
            var y = snap(position.y);
            return $8edd8caaa4dabbef$var$_objectSpread$1($8edd8caaa4dabbef$var$_objectSpread$1({}, context), {}, {
                data: $8edd8caaa4dabbef$var$_objectSpread$1($8edd8caaa4dabbef$var$_objectSpread$1({}, context.data), {}, {
                    position: {
                        x: x,
                        y: y
                    }
                })
            });
        }
        if (!dynamic && context.type === "nodedragged") {
            var view = area.nodeViews.get(context.data.id);
            if (view) {
                var _view$position = view.position, _x = _view$position.x, _y = _view$position.y;
                view.translate(snap(_x), snap(_y));
            }
        }
        return context;
    });
}
/**
 * Zoom extension parameters
 */ /**
 * Zooms the area to fit the given nodes
 * @param plugin The area plugin
 * @param nodes The nodes to fit
 * @param params The zoom parameters
 */ // eslint-disable-next-line max-statements, max-len
function $8edd8caaa4dabbef$var$zoomAt(_x, _x2, _x3) {
    return $8edd8caaa4dabbef$var$_zoomAt.apply(this, arguments);
}
function $8edd8caaa4dabbef$var$_zoomAt() {
    $8edd8caaa4dabbef$var$_zoomAt = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(plugin, nodes, params) {
        var _ref, _ref$scale, scale, editor, list, rects, boundingBox, _ref2, w, h, kw, kh, k;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref = params || {}, _ref$scale = _ref.scale, scale = _ref$scale === void 0 ? 0.9 : _ref$scale;
                    editor = plugin.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
                    list = nodes.map(function(node) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(node) === "object" ? node : editor.getNode(node);
                    });
                    rects = $8edd8caaa4dabbef$var$getNodesRect(list, plugin.nodeViews);
                    boundingBox = $8edd8caaa4dabbef$var$getBoundingBox$1(rects);
                    _ref2 = [
                        plugin.container.clientWidth,
                        plugin.container.clientHeight
                    ], w = _ref2[0], h = _ref2[1];
                    kw = w / boundingBox.width, kh = h / boundingBox.height;
                    k = Math.min(kh * scale, kw * scale, 1);
                    plugin.area.transform.x = w / 2 - boundingBox.center.x * k;
                    plugin.area.transform.y = h / 2 - boundingBox.center.y * k;
                    _context.next = 12;
                    return plugin.area.zoom(k, 0, 0);
                case 12:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $8edd8caaa4dabbef$var$_zoomAt.apply(this, arguments);
}
/**
 * Area extensions
 * @priority 7
 * @module Extensions
 */ var $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getBoundingBox: $8edd8caaa4dabbef$var$getBoundingBox,
    simpleNodesOrder: $8edd8caaa4dabbef$var$simpleNodesOrder,
    restrictor: $8edd8caaa4dabbef$var$restrictor,
    accumulateOnCtrl: $8edd8caaa4dabbef$var$accumulateOnCtrl,
    selectableNodes: $8edd8caaa4dabbef$var$selectableNodes,
    Selector: $8edd8caaa4dabbef$var$Selector,
    selector: $8edd8caaa4dabbef$var$selector,
    showInputControl: $8edd8caaa4dabbef$var$showInputControl,
    snapGrid: $8edd8caaa4dabbef$var$snapGrid,
    zoomAt: $8edd8caaa4dabbef$var$zoomAt
});
function $8edd8caaa4dabbef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8edd8caaa4dabbef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8edd8caaa4dabbef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8edd8caaa4dabbef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8edd8caaa4dabbef$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(t, $8edd8caaa4dabbef$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(t).constructor) : o.apply(t, e));
}
function $8edd8caaa4dabbef$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8edd8caaa4dabbef$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
/**
 * A union of all possible signals that can be emitted by the area
 * @priority 9
 */ /**
 * A plugin that provides a 2D area for nodes and connections
 * @priority 8
 * @emits render
 * @emits rendered
 * @emits unmount
 * @listens nodecreated
 * @listens noderemoved
 * @listens connectioncreated
 * @listens connectionremoved
 */ var $8edd8caaa4dabbef$export$ca4e44bc52e1e414 = /*#__PURE__*/ function(_BaseAreaPlugin) {
    function AreaPlugin(container) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, AreaPlugin);
        _this = $8edd8caaa4dabbef$var$_callSuper(this, AreaPlugin, [
            "area"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "nodeViews", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "connectionViews", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "elements", new $8edd8caaa4dabbef$var$ElementsHolder());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(_this, "onContextMenu", function(event) {
            _this.emit({
                type: "contextmenu",
                data: {
                    event: event,
                    context: "root"
                }
            });
        });
        _this.container = container;
        container.style.overflow = "hidden";
        container.addEventListener("contextmenu", _this.onContextMenu);
        // eslint-disable-next-line max-statements
        _this.addPipe(function(context) {
            if (!context || !((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) === "object" && "type" in context)) return context;
            if (context.type === "nodecreated") _this.addNodeView(context.data);
            if (context.type === "noderemoved") _this.removeNodeView(context.data.id);
            if (context.type === "connectioncreated") _this.addConnectionView(context.data);
            if (context.type === "connectionremoved") _this.removeConnectionView(context.data.id);
            if (context.type === "render") _this.elements.set(context.data);
            if (context.type === "unmount") _this.elements["delete"](context.data.element);
            return context;
        });
        _this.area = new $8edd8caaa4dabbef$export$ea1a111407f37557(container, {
            zoomed: function zoomed(params) {
                return _this.emit({
                    type: "zoomed",
                    data: params
                });
            },
            pointerDown: function pointerDown(position, event) {
                return void _this.emit({
                    type: "pointerdown",
                    data: {
                        position: position,
                        event: event
                    }
                });
            },
            pointerMove: function pointerMove(position, event) {
                return void _this.emit({
                    type: "pointermove",
                    data: {
                        position: position,
                        event: event
                    }
                });
            },
            pointerUp: function pointerUp(position, event) {
                return void _this.emit({
                    type: "pointerup",
                    data: {
                        position: position,
                        event: event
                    }
                });
            },
            resize: function resize(event) {
                return void _this.emit({
                    type: "resized",
                    data: {
                        event: event
                    }
                });
            },
            translated: function translated(params) {
                return _this.emit({
                    type: "translated",
                    data: params
                });
            },
            reordered: function reordered(element) {
                return _this.emit({
                    type: "reordered",
                    data: {
                        element: element
                    }
                });
            }
        }, {
            translate: function translate(params) {
                return _this.emit({
                    type: "translate",
                    data: params
                });
            },
            zoom: function zoom(params) {
                return _this.emit({
                    type: "zoom",
                    data: params
                });
            }
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(AreaPlugin, _BaseAreaPlugin);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(AreaPlugin, [
        {
            key: "addNodeView",
            value: function addNodeView(node) {
                var _this2 = this;
                var id = node.id;
                var view = new $8edd8caaa4dabbef$export$77c6811359a01a6f(function() {
                    return _this2.area.transform.k;
                }, {
                    picked: function picked() {
                        return void _this2.emit({
                            type: "nodepicked",
                            data: {
                                id: id
                            }
                        });
                    },
                    translated: function translated(data) {
                        return _this2.emit({
                            type: "nodetranslated",
                            data: $8edd8caaa4dabbef$var$_objectSpread({
                                id: id
                            }, data)
                        });
                    },
                    dragged: function dragged() {
                        return void _this2.emit({
                            type: "nodedragged",
                            data: node
                        });
                    },
                    contextmenu: function contextmenu(event) {
                        return void _this2.emit({
                            type: "contextmenu",
                            data: {
                                event: event,
                                context: node
                            }
                        });
                    },
                    resized: function resized(_ref) {
                        var size = _ref.size;
                        return _this2.emit({
                            type: "noderesized",
                            data: {
                                id: node.id,
                                size: size
                            }
                        });
                    }
                }, {
                    translate: function translate(data) {
                        return _this2.emit({
                            type: "nodetranslate",
                            data: $8edd8caaa4dabbef$var$_objectSpread({
                                id: id
                            }, data)
                        });
                    },
                    resize: function resize(_ref2) {
                        var size = _ref2.size;
                        return _this2.emit({
                            type: "noderesize",
                            data: {
                                id: node.id,
                                size: size
                            }
                        });
                    }
                });
                this.nodeViews.set(id, view);
                this.area.content.add(view.element);
                this.emit({
                    type: "render",
                    data: {
                        element: view.element,
                        type: "node",
                        payload: node
                    }
                });
                return view;
            }
        },
        {
            key: "removeNodeView",
            value: function removeNodeView(id) {
                var view = this.nodeViews.get(id);
                if (view) {
                    this.emit({
                        type: "unmount",
                        data: {
                            element: view.element
                        }
                    });
                    this.nodeViews["delete"](id);
                    this.area.content.remove(view.element);
                }
            }
        },
        {
            key: "addConnectionView",
            value: function addConnectionView(connection) {
                var _this3 = this;
                var view = new $8edd8caaa4dabbef$var$ConnectionView({
                    contextmenu: function contextmenu(event) {
                        return void _this3.emit({
                            type: "contextmenu",
                            data: {
                                event: event,
                                context: connection
                            }
                        });
                    }
                });
                this.connectionViews.set(connection.id, view);
                this.area.content.add(view.element);
                this.emit({
                    type: "render",
                    data: {
                        element: view.element,
                        type: "connection",
                        payload: connection
                    }
                });
                return view;
            }
        },
        {
            key: "removeConnectionView",
            value: function removeConnectionView(id) {
                var view = this.connectionViews.get(id);
                if (view) {
                    this.emit({
                        type: "unmount",
                        data: {
                            element: view.element
                        }
                    });
                    this.connectionViews["delete"](id);
                    this.area.content.remove(view.element);
                }
            }
        },
        {
            key: "update",
            value: function() {
                var _update = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(type, id) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                data = this.elements.get(type, id);
                                if (!data) {
                                    _context.next = 4;
                                    break;
                                }
                                _context.next = 4;
                                return this.emit({
                                    type: "render",
                                    data: data
                                });
                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function update(_x, _x2) {
                    return _update.apply(this, arguments);
                }
                return update;
            }()
        },
        {
            key: "resize",
            value: function() {
                var _resize = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(id, width, height) {
                    var view;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                view = this.nodeViews.get(id);
                                if (!view) {
                                    _context2.next = 5;
                                    break;
                                }
                                _context2.next = 4;
                                return view.resize(width, height);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function resize(_x3, _x4, _x5) {
                    return _resize.apply(this, arguments);
                }
                return resize;
            }()
        },
        {
            key: "translate",
            value: function() {
                var _translate = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(id, _ref3) {
                    var x, y, view;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                x = _ref3.x, y = _ref3.y;
                                view = this.nodeViews.get(id);
                                if (!view) {
                                    _context3.next = 6;
                                    break;
                                }
                                _context3.next = 5;
                                return view.translate(x, y);
                            case 5:
                                return _context3.abrupt("return", _context3.sent);
                            case 6:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function translate(_x6, _x7) {
                    return _translate.apply(this, arguments);
                }
                return translate;
            }()
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this4 = this;
                this.container.removeEventListener("contextmenu", this.onContextMenu);
                Array.from(this.connectionViews.keys()).forEach(function(id) {
                    return _this4.removeConnectionView(id);
                });
                Array.from(this.nodeViews.keys()).forEach(function(id) {
                    return _this4.removeNodeView(id);
                });
                this.area.destroy();
            }
        }
    ]);
}($8edd8caaa4dabbef$export$893ad666b26a6f6e);


/*!
* rete-connection-plugin v2.0.1
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 
var $41YNz = parcelRequire("41YNz");




var $9c4212772a6002f0$exports = {};
var $b297e5ebd9b2c4c7$exports = {};

function $b297e5ebd9b2c4c7$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $93d4339c80153a6a$exports(t)););
    return t;
}
$b297e5ebd9b2c4c7$exports = $b297e5ebd9b2c4c7$var$_superPropBase, $b297e5ebd9b2c4c7$exports.__esModule = true, $b297e5ebd9b2c4c7$exports["default"] = $b297e5ebd9b2c4c7$exports;


function $9c4212772a6002f0$var$_get() {
    return $9c4212772a6002f0$exports = $9c4212772a6002f0$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $b297e5ebd9b2c4c7$exports(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $9c4212772a6002f0$exports.__esModule = true, $9c4212772a6002f0$exports["default"] = $9c4212772a6002f0$exports, $9c4212772a6002f0$var$_get.apply(null, arguments);
}
$9c4212772a6002f0$exports = $9c4212772a6002f0$var$_get, $9c4212772a6002f0$exports.__esModule = true, $9c4212772a6002f0$exports["default"] = $9c4212772a6002f0$exports;









var $008fdf6f13d86ab1$exports = {};
var $bf2dbd940d8d1ee7$exports = {};
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$bf2dbd940d8d1ee7$exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, $bf2dbd940d8d1ee7$exports.__esModule = true, $bf2dbd940d8d1ee7$exports["default"] = $bf2dbd940d8d1ee7$exports;


var $efa3fde0b6100532$exports = {};
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$efa3fde0b6100532$exports = $efa3fde0b6100532$var$_iterableToArrayLimit, $efa3fde0b6100532$exports.__esModule = true, $efa3fde0b6100532$exports["default"] = $efa3fde0b6100532$exports;



var $9fdae42208ebda05$exports = {};
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9fdae42208ebda05$exports = $9fdae42208ebda05$var$_nonIterableRest, $9fdae42208ebda05$exports.__esModule = true, $9fdae42208ebda05$exports["default"] = $9fdae42208ebda05$exports;


function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $bf2dbd940d8d1ee7$exports(r) || $efa3fde0b6100532$exports(r, e) || $51f08ebed50a2438$exports(r, e) || $9fdae42208ebda05$exports();
}
$008fdf6f13d86ab1$exports = $008fdf6f13d86ab1$var$_slicedToArray, $008fdf6f13d86ab1$exports.__esModule = true, $008fdf6f13d86ab1$exports["default"] = $008fdf6f13d86ab1$exports;


function $c8972d6a08cac3bd$var$___$insertStyle(css) {
    if (!css) return;
    if (typeof window === "undefined") return;
    var style = document.createElement("style");
    style.setAttribute("type", "text/css");
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
function $c8972d6a08cac3bd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c8972d6a08cac3bd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c8972d6a08cac3bd$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c8972d6a08cac3bd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Create pseudoconnection. Used to trigger rendering of connection that is being created by user.
 * Has additional `isPseudo` property in payload.
 * @param extra Extra payload to add to connection
 */ function $c8972d6a08cac3bd$export$46d92f6d15d50e16(extra) {
    var element = null;
    var id = null;
    function unmount(areaPlugin) {
        if (id) areaPlugin.removeConnectionView(id);
        element = null;
        id = null;
    }
    function mount(areaPlugin) {
        unmount(areaPlugin);
        id = "pseudo_".concat((0, $bad63f27bc7a37b5$export$6d2b3473b0986646)());
    }
    return {
        isMounted: function isMounted() {
            return Boolean(id);
        },
        mount: mount,
        // eslint-disable-next-line complexity
        render: function render(areaPlugin, _ref, data) {
            var x = _ref.x, y = _ref.y;
            var isOutput = data.side === "output";
            var pointer = {
                x: x + (isOutput ? -3 : 3),
                y: y
            }; // fix hover of underlying elements
            if (!id) throw new Error("pseudo connection id wasn't generated");
            var payload = isOutput ? $c8972d6a08cac3bd$var$_objectSpread({
                id: id,
                source: data.nodeId,
                sourceOutput: data.key,
                target: "",
                targetInput: ""
            }, extra || {}) : $c8972d6a08cac3bd$var$_objectSpread({
                id: id,
                target: data.nodeId,
                targetInput: data.key,
                source: "",
                sourceOutput: ""
            }, extra || {});
            if (!element) {
                var view = areaPlugin.addConnectionView(payload);
                element = view.element;
            }
            if (!element) return;
            areaPlugin.emit({
                type: "render",
                data: $c8972d6a08cac3bd$var$_objectSpread({
                    element: element,
                    type: "connection",
                    payload: payload
                }, isOutput ? {
                    end: pointer
                } : {
                    start: pointer
                })
            });
        },
        unmount: unmount
    };
}
function $c8972d6a08cac3bd$var$_createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c8972d6a08cac3bd$var$_unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c8972d6a08cac3bd$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c8972d6a08cac3bd$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c8972d6a08cac3bd$var$_arrayLikeToArray$1(o, minLen);
}
function $c8972d6a08cac3bd$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * @param elements list of Element returned by document.elementsFromPoint
 */ function $c8972d6a08cac3bd$var$findSocket(socketsCache, elements) {
    var _iterator = $c8972d6a08cac3bd$var$_createForOfIteratorHelper$1(elements), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var element = _step.value;
            var found = socketsCache.get(element);
            if (found) return found;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
var $c8972d6a08cac3bd$export$4d9fb5586e103031 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(function Flow() {
    (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Flow);
});
var $c8972d6a08cac3bd$export$7254cc27399e90bd = /*#__PURE__*/ function() {
    function State() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, State);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(State, [
        {
            key: "setContext",
            value: function setContext(context) {
                this.context = context;
            }
        }
    ]);
    return State;
}();
function $c8972d6a08cac3bd$export$c5390a2c5b73d573(initial, socket) {
    var forward = initial.side === "output" && socket.side === "input";
    var backward = initial.side === "input" && socket.side === "output";
    var _ref = forward ? [
        initial,
        socket
    ] : backward ? [
        socket,
        initial
    ] : [], _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref, 2), source = _ref2[0], target = _ref2[1];
    if (source && target) return [
        source,
        target
    ];
}
function $c8972d6a08cac3bd$export$434273ee6ae8c1fb(initial, socket) {
    return Boolean($c8972d6a08cac3bd$export$c5390a2c5b73d573(initial, socket));
}
function $c8972d6a08cac3bd$export$36581735b33961ca(initial, socket, context) {
    var _ref3 = $c8972d6a08cac3bd$export$c5390a2c5b73d573(initial, socket) || [
        null,
        null
    ], _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref3, 2), source = _ref4[0], target = _ref4[1];
    if (source && target) {
        context.editor.addConnection({
            id: (0, $bad63f27bc7a37b5$export$6d2b3473b0986646)(),
            source: source.nodeId,
            sourceOutput: source.key,
            target: target.nodeId,
            targetInput: target.key
        });
        return true;
    }
}
function $c8972d6a08cac3bd$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $c8972d6a08cac3bd$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $c8972d6a08cac3bd$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Bidirect flow params
 */ var $c8972d6a08cac3bd$var$Picked$1 = /*#__PURE__*/ function(_State) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Picked, _State);
    var _super = $c8972d6a08cac3bd$var$_createSuper$2(Picked);
    function Picked(initial, params) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Picked);
        _this = _super.call(this);
        _this.initial = initial;
        _this.params = params;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Picked, [
        {
            key: "pick",
            value: function() {
                var _pick = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(_ref, context) {
                    var socket;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                socket = _ref.socket;
                                if (this.params.makeConnection(this.initial, socket, context)) this.drop(context, socket, true);
                                else if (!this.params.pickByClick) this.drop(context, socket);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function pick(_x, _x2) {
                    return _pick.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "drop",
            value: function drop(context) {
                var socket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var created = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (this.initial) context.scope.emit({
                    type: "connectiondrop",
                    data: {
                        initial: this.initial,
                        socket: socket,
                        created: created
                    }
                });
                this.context.switchTo(new $c8972d6a08cac3bd$var$Idle$1(this.params));
            }
        }
    ]);
    return Picked;
}($c8972d6a08cac3bd$export$7254cc27399e90bd);
var $c8972d6a08cac3bd$var$Idle$1 = /*#__PURE__*/ function(_State2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Idle, _State2);
    var _super2 = $c8972d6a08cac3bd$var$_createSuper$2(Idle);
    function Idle(params) {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Idle);
        _this2 = _super2.call(this);
        _this2.params = params;
        return _this2;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Idle, [
        {
            key: "pick",
            value: function() {
                var _pick2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(_ref2, context) {
                    var socket, event;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                socket = _ref2.socket, event = _ref2.event;
                                if (!(event === "down")) {
                                    _context2.next = 9;
                                    break;
                                }
                                _context2.next = 4;
                                return context.scope.emit({
                                    type: "connectionpick",
                                    data: {
                                        socket: socket
                                    }
                                });
                            case 4:
                                if (!_context2.sent) {
                                    _context2.next = 8;
                                    break;
                                }
                                this.context.switchTo(new $c8972d6a08cac3bd$var$Picked$1(socket, this.params));
                                _context2.next = 9;
                                break;
                            case 8:
                                this.drop(context);
                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function pick(_x3, _x4) {
                    return _pick2.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "drop",
            value: function drop(context) {
                var socket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var created = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (this.initial) context.scope.emit({
                    type: "connectiondrop",
                    data: {
                        initial: this.initial,
                        socket: socket,
                        created: created
                    }
                });
                delete this.initial;
            }
        }
    ]);
    return Idle;
}($c8972d6a08cac3bd$export$7254cc27399e90bd);
/**
 * Bidirect flow. User can pick a socket and connect it by releasing mouse button.
 * More simple than classic flow, but less functional (can't remove connection by clicking on input socket).
 */ var $c8972d6a08cac3bd$export$5e8354fb0beae35b = /*#__PURE__*/ function() {
    function BidirectFlow(params) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, BidirectFlow);
        var pickByClick = Boolean(params === null || params === void 0 ? void 0 : params.pickByClick);
        var makeConnection$1 = (params === null || params === void 0 ? void 0 : params.makeConnection) || $c8972d6a08cac3bd$export$36581735b33961ca;
        this.switchTo(new $c8972d6a08cac3bd$var$Idle$1({
            pickByClick: pickByClick,
            makeConnection: makeConnection$1
        }));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(BidirectFlow, [
        {
            key: "pick",
            value: function() {
                var _pick3 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(params, context) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return this.currentState.pick(params, context);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function pick(_x5, _x6) {
                    return _pick3.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "getPickedSocket",
            value: function getPickedSocket() {
                return this.currentState.initial;
            }
        },
        {
            key: "drop",
            value: function drop(context) {
                this.currentState.drop(context);
            }
        },
        {
            key: "switchTo",
            value: function switchTo(state) {
                state.setContext(this);
                this.currentState = state;
            }
        }
    ]);
    return BidirectFlow;
}();
function $c8972d6a08cac3bd$var$findPort(socket, editor) {
    var node = editor.getNode(socket.nodeId);
    if (!node) throw new Error("cannot find node");
    var list = socket.side === "input" ? node.inputs : node.outputs;
    return list[socket.key];
}
function $c8972d6a08cac3bd$var$findConnections(socket, editor) {
    var nodeId = socket.nodeId, side = socket.side, key = socket.key;
    return editor.getConnections().filter(function(connection) {
        if (side === "input") return connection.target === nodeId && connection.targetInput === key;
        if (side === "output") return connection.source === nodeId && connection.sourceOutput === key;
    });
}
/**
 * Remove existing connections if Port doesnt allow multiple connections
 */ function $c8972d6a08cac3bd$var$syncConnections(sockets, editor) {
    var connections = sockets.map(function(socket) {
        var port = $c8972d6a08cac3bd$var$findPort(socket, editor);
        var multiple = port === null || port === void 0 ? void 0 : port.multipleConnections;
        if (multiple) return [];
        return $c8972d6a08cac3bd$var$findConnections(socket, editor);
    }).flat();
    return {
        commit: function commit() {
            var uniqueIds = Array.from(new Set(connections.map(function(_ref) {
                var id = _ref.id;
                return id;
            })));
            uniqueIds.forEach(function(id) {
                return editor.removeConnection(id);
            });
        }
    };
}
function $c8972d6a08cac3bd$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $c8972d6a08cac3bd$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $c8972d6a08cac3bd$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Classic flow params
 */ var $c8972d6a08cac3bd$var$Picked = /*#__PURE__*/ function(_State) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Picked, _State);
    var _super = $c8972d6a08cac3bd$var$_createSuper$1(Picked);
    function Picked(initial, params) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Picked);
        _this = _super.call(this);
        _this.initial = initial;
        _this.params = params;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Picked, [
        {
            key: "pick",
            value: function() {
                var _pick = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(_ref, context) {
                    var socket, created;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                socket = _ref.socket;
                                if (this.params.canMakeConnection(this.initial, socket)) {
                                    $c8972d6a08cac3bd$var$syncConnections([
                                        this.initial,
                                        socket
                                    ], context.editor).commit();
                                    created = this.params.makeConnection(this.initial, socket, context);
                                    this.drop(context, created ? socket : null, created);
                                }
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function pick(_x, _x2) {
                    return _pick.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "drop",
            value: function drop(context) {
                var socket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var created = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (this.initial) context.scope.emit({
                    type: "connectiondrop",
                    data: {
                        initial: this.initial,
                        socket: socket,
                        created: created
                    }
                });
                this.context.switchTo(new $c8972d6a08cac3bd$var$Idle(this.params));
            }
        }
    ]);
    return Picked;
}($c8972d6a08cac3bd$export$7254cc27399e90bd);
var $c8972d6a08cac3bd$var$PickedExisting = /*#__PURE__*/ function(_State2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(PickedExisting, _State2);
    var _super2 = $c8972d6a08cac3bd$var$_createSuper$1(PickedExisting);
    function PickedExisting(connection, params, context) {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, PickedExisting);
        _this2 = _super2.call(this);
        _this2.connection = connection;
        _this2.params = params;
        var outputSocket = Array.from(context.socketsCache.values()).find(function(data) {
            return data.nodeId === _this2.connection.source && data.side === "output" && data.key === _this2.connection.sourceOutput;
        });
        if (!outputSocket) throw new Error("cannot find output socket");
        _this2.outputSocket = outputSocket;
        return _this2;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(PickedExisting, [
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(context) {
                    var _this3 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                context.scope.emit({
                                    type: "connectionpick",
                                    data: {
                                        socket: this.outputSocket
                                    }
                                }).then(function(response) {
                                    if (response) {
                                        context.editor.removeConnection(_this3.connection.id);
                                        _this3.initial = _this3.outputSocket;
                                    } else _this3.drop(context);
                                });
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function init(_x3) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "pick",
            value: function() {
                var _pick2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(_ref2, context) {
                    var socket, event, created, _created;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                socket = _ref2.socket, event = _ref2.event;
                                if (this.initial && !(socket.side === "input" && this.connection.target === socket.nodeId && this.connection.targetInput === socket.key)) {
                                    if (this.params.canMakeConnection(this.initial, socket)) {
                                        $c8972d6a08cac3bd$var$syncConnections([
                                            this.initial,
                                            socket
                                        ], context.editor).commit();
                                        created = this.params.makeConnection(this.initial, socket, context);
                                        this.drop(context, created ? socket : null, created);
                                    }
                                } else if (event === "down") {
                                    if (this.initial) {
                                        $c8972d6a08cac3bd$var$syncConnections([
                                            this.initial,
                                            socket
                                        ], context.editor).commit();
                                        _created = this.params.makeConnection(this.initial, socket, context);
                                        this.drop(context, _created ? socket : null, _created);
                                    }
                                }
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function pick(_x4, _x5) {
                    return _pick2.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "drop",
            value: function drop(context) {
                var socket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var created = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (this.initial) context.scope.emit({
                    type: "connectiondrop",
                    data: {
                        initial: this.initial,
                        socket: socket,
                        created: created
                    }
                });
                this.context.switchTo(new $c8972d6a08cac3bd$var$Idle(this.params));
            }
        }
    ]);
    return PickedExisting;
}($c8972d6a08cac3bd$export$7254cc27399e90bd);
var $c8972d6a08cac3bd$var$Idle = /*#__PURE__*/ function(_State3) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Idle, _State3);
    var _super3 = $c8972d6a08cac3bd$var$_createSuper$1(Idle);
    function Idle(params) {
        var _this4;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Idle);
        _this4 = _super3.call(this);
        _this4.params = params;
        return _this4;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Idle, [
        {
            key: "pick",
            value: function() {
                var _pick3 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee4(_ref3, context) {
                    var socket, event, _connection, state;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                socket = _ref3.socket, event = _ref3.event;
                                if (!(event !== "down")) {
                                    _context4.next = 3;
                                    break;
                                }
                                return _context4.abrupt("return");
                            case 3:
                                if (!(socket.side === "input")) {
                                    _context4.next = 11;
                                    break;
                                }
                                _connection = context.editor.getConnections().find(function(item) {
                                    return item.target === socket.nodeId && item.targetInput === socket.key;
                                });
                                if (!_connection) {
                                    _context4.next = 11;
                                    break;
                                }
                                state = new $c8972d6a08cac3bd$var$PickedExisting(_connection, this.params, context);
                                _context4.next = 9;
                                return state.init(context);
                            case 9:
                                this.context.switchTo(state);
                                return _context4.abrupt("return");
                            case 11:
                                _context4.next = 13;
                                return context.scope.emit({
                                    type: "connectionpick",
                                    data: {
                                        socket: socket
                                    }
                                });
                            case 13:
                                if (!_context4.sent) {
                                    _context4.next = 17;
                                    break;
                                }
                                this.context.switchTo(new $c8972d6a08cac3bd$var$Picked(socket, this.params));
                                _context4.next = 18;
                                break;
                            case 17:
                                this.drop(context);
                            case 18:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function pick(_x6, _x7) {
                    return _pick3.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "drop",
            value: function drop(context) {
                var socket = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var created = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if (this.initial) context.scope.emit({
                    type: "connectiondrop",
                    data: {
                        initial: this.initial,
                        socket: socket,
                        created: created
                    }
                });
                delete this.initial;
            }
        }
    ]);
    return Idle;
}($c8972d6a08cac3bd$export$7254cc27399e90bd);
/**
 * Classic flow. User can pick/click a socket and connect it by releasing/clicking on another socket.
 * If connection already exists and user clicks on input socket, connection will be removed.
 */ var $c8972d6a08cac3bd$export$3f0914a175ca090d = /*#__PURE__*/ function() {
    function ClassicFlow(params) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ClassicFlow);
        var canMakeConnection$1 = (params === null || params === void 0 ? void 0 : params.canMakeConnection) || $c8972d6a08cac3bd$export$434273ee6ae8c1fb;
        var makeConnection$1 = (params === null || params === void 0 ? void 0 : params.makeConnection) || $c8972d6a08cac3bd$export$36581735b33961ca;
        this.switchTo(new $c8972d6a08cac3bd$var$Idle({
            canMakeConnection: canMakeConnection$1,
            makeConnection: makeConnection$1
        }));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ClassicFlow, [
        {
            key: "pick",
            value: function() {
                var _pick4 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee5(params, context) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.next = 2;
                                return this.currentState.pick(params, context);
                            case 2:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function pick(_x8, _x9) {
                    return _pick4.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "getPickedSocket",
            value: function getPickedSocket() {
                return this.currentState.initial;
            }
        },
        {
            key: "switchTo",
            value: function switchTo(state) {
                state.setContext(this);
                this.currentState = state;
            }
        },
        {
            key: "drop",
            value: function drop(context) {
                this.currentState.drop(context);
            }
        }
    ]);
    return ClassicFlow;
}();
/**
 * Classic preset. Uses `ClassicFlow` for managing connections by user
 */ function $c8972d6a08cac3bd$var$setup() {
    return function() {
        return new $c8972d6a08cac3bd$export$3f0914a175ca090d();
    };
}
var $c8972d6a08cac3bd$var$classic = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setup: $c8972d6a08cac3bd$var$setup
});
/**
 * Built-in presets
 * @module
 */ var $c8972d6a08cac3bd$export$7a05727743f7512 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    classic: $c8972d6a08cac3bd$var$classic
});
function $c8972d6a08cac3bd$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c8972d6a08cac3bd$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c8972d6a08cac3bd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c8972d6a08cac3bd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c8972d6a08cac3bd$var$_arrayLikeToArray(o, minLen);
}
function $c8972d6a08cac3bd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c8972d6a08cac3bd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c8972d6a08cac3bd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $c8972d6a08cac3bd$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Connection plugin. Responsible for user interaction with connections (creation, deletion)
 * @priority 9
 * @emits connectionpick
 * @emits connectiondrop
 * @listens pointermove
 * @listens pointerup
 * @listens render
 * @listens unmount
 */ var $c8972d6a08cac3bd$export$bd9a5b2e2ab1f9b0 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(ConnectionPlugin, _Scope);
    var _super = $c8972d6a08cac3bd$var$_createSuper(ConnectionPlugin);
    function ConnectionPlugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ConnectionPlugin);
        _this = _super.call(this, "connection");
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "presets", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "currentFlow", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "preudoconnection", $c8972d6a08cac3bd$export$46d92f6d15d50e16({
            isPseudo: true
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "socketsCache", new Map());
        return _this;
    }
    /**
   * Add preset to the plugin
   * @param preset Preset to add
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ConnectionPlugin, [
        {
            key: "addPreset",
            value: function addPreset(preset) {
                this.presets.push(preset);
            }
        },
        {
            key: "findPreset",
            value: function findPreset(data) {
                var _iterator = $c8972d6a08cac3bd$var$_createForOfIteratorHelper(this.presets), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var preset = _step.value;
                        var flow = preset(data);
                        if (flow) return flow;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return null;
            }
        },
        {
            key: "update",
            value: function update() {
                if (!this.currentFlow) return;
                var socket = this.currentFlow.getPickedSocket();
                if (socket) this.preudoconnection.render(this.areaPlugin, this.areaPlugin.area.pointer, socket);
            }
        },
        {
            key: "drop",
            value: function drop() {
                var flowContext = {
                    editor: this.editor,
                    scope: this,
                    socketsCache: this.socketsCache
                };
                if (this.currentFlow) {
                    this.currentFlow.drop(flowContext);
                    this.preudoconnection.unmount(this.areaPlugin);
                    this.currentFlow = null;
                }
            }
        },
        {
            key: "pick",
            value: function() {
                var _pick = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(event, type) {
                    var flowContext, pointedElements, pickedSocket;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                flowContext = {
                                    editor: this.editor,
                                    scope: this,
                                    socketsCache: this.socketsCache
                                };
                                pointedElements = document.elementsFromPoint(event.clientX, event.clientY);
                                pickedSocket = $c8972d6a08cac3bd$var$findSocket(this.socketsCache, pointedElements);
                                if (!pickedSocket) {
                                    _context.next = 13;
                                    break;
                                }
                                event.preventDefault();
                                event.stopPropagation();
                                this.currentFlow = this.currentFlow || this.findPreset(pickedSocket);
                                if (!this.currentFlow) {
                                    _context.next = 11;
                                    break;
                                }
                                _context.next = 10;
                                return this.currentFlow.pick({
                                    socket: pickedSocket,
                                    event: type
                                }, flowContext);
                            case 10:
                                this.preudoconnection.mount(this.areaPlugin);
                            case 11:
                                _context.next = 14;
                                break;
                            case 13:
                                if (this.currentFlow) this.currentFlow.drop(flowContext);
                            case 14:
                                if (this.currentFlow && !this.currentFlow.getPickedSocket()) {
                                    this.preudoconnection.unmount(this.areaPlugin);
                                    this.currentFlow = null;
                                }
                                this.update();
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function pick(_x, _x2) {
                    return _pick.apply(this, arguments);
                }
                return pick;
            }()
        },
        {
            key: "setParent",
            value: function setParent(scope) {
                var _this2 = this;
                (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(ConnectionPlugin.prototype), "setParent", this).call(this, scope);
                this.areaPlugin = this.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
                this.editor = this.areaPlugin.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
                var pointerdownSocket = function pointerdownSocket(e) {
                    _this2.pick(e, "down");
                };
                // eslint-disable-next-line max-statements
                this.addPipe(function(context) {
                    if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
                    if (context.type === "pointermove") _this2.update();
                    else if (context.type === "pointerup") _this2.pick(context.data.event, "up");
                    else if (context.type === "render") {
                        if (context.data.type === "socket") {
                            var element = context.data.element;
                            element.addEventListener("pointerdown", pointerdownSocket);
                            _this2.socketsCache.set(element, context.data);
                        }
                    } else if (context.type === "unmount") {
                        var _element = context.data.element;
                        _element.removeEventListener("pointerdown", pointerdownSocket);
                        _this2.socketsCache["delete"](_element);
                    }
                    return context;
                });
            }
        }
    ]);
    return ConnectionPlugin;
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));


/*!
* rete-react-plugin v2.0.4
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 
var $41YNz = parcelRequire("41YNz");









var $acw62 = parcelRequire("acw62");





/*!
* rete-render-utils v2.0.0
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 










/**
 * Get classic SVG path for a connection between two points.
 * @param points Array of two points
 * @param curvature Curvature of the connection
 */ function $45e8e8fab5a3dbf5$export$ac147288282af99d(points, curvature) {
    var _points = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(points, 2), _points$ = _points[0], x1 = _points$.x, y1 = _points$.y, _points$2 = _points[1], x2 = _points$2.x, y2 = _points$2.y;
    var vertical = Math.abs(y1 - y2);
    var hx1 = x1 + Math.max(vertical / 2, Math.abs(x2 - x1)) * curvature;
    var hx2 = x2 - Math.max(vertical / 2, Math.abs(x2 - x1)) * curvature;
    return "M ".concat(x1, " ").concat(y1, " C ").concat(hx1, " ").concat(y1, " ").concat(hx2, " ").concat(y2, " ").concat(x2, " ").concat(y2);
}
/**
 * Get loop SVG path for a connection between two points.
 * @param points Array of two points
 * @param curvature Curvature of the loop
 * @param size Size of the loop
 */ function $45e8e8fab5a3dbf5$export$71c5890ba659a82e(points, curvature, size) {
    var _points2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(points, 2), _points2$ = _points2[0], x1 = _points2$.x, y1 = _points2$.y, _points2$2 = _points2[1], x2 = _points2$2.x, y2 = _points2$2.y;
    var k = y2 > y1 ? 1 : -1;
    var scale = size + Math.abs(x1 - x2) / (size / 2);
    var middleX = (x1 + x2) / 2;
    var middleY = y1 - k * scale;
    var vertical = (y2 - y1) * curvature;
    return "\n        M ".concat(x1, " ").concat(y1, "\n        C ").concat(x1 + scale, " ").concat(y1, "\n        ").concat(x1 + scale, " ").concat(middleY - vertical, "\n        ").concat(middleX, " ").concat(middleY, "\n        C ").concat(x2 - scale, " ").concat(middleY + vertical, "\n        ").concat(x2 - scale, " ").concat(y2, "\n        ").concat(x2, " ").concat(y2, "\n    ");
}
/* eslint-disable max-statements */ /**
* Calculates the center coordinates of a child element relative to a parent element.
* @async
* @param child The child element whose center coordinates need to be calculated.
* @param parent The parent element relative to which the child element's center is calculated.
* @returns Position of the child element's center
* @throws Error if the child element has a null offsetParent.
*/ function $45e8e8fab5a3dbf5$export$e0d4696b3026c537(_x, _x2) {
    return $45e8e8fab5a3dbf5$var$_getElementCenter.apply(this, arguments);
}
function $45e8e8fab5a3dbf5$var$_getElementCenter() {
    $45e8e8fab5a3dbf5$var$_getElementCenter = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(child, parent) {
        var x, y, currentElement, width, height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (child.offsetParent) {
                        _context.next = 5;
                        break;
                    }
                    _context.next = 3;
                    return new Promise(function(res) {
                        return setTimeout(res, 0);
                    });
                case 3:
                    _context.next = 0;
                    break;
                case 5:
                    x = child.offsetLeft;
                    y = child.offsetTop;
                    currentElement = child.offsetParent;
                    if (currentElement) {
                        _context.next = 10;
                        break;
                    }
                    throw new Error("child has null offsetParent");
                case 10:
                    while(currentElement !== null && currentElement !== parent){
                        x += currentElement.offsetLeft + currentElement.clientLeft;
                        y += currentElement.offsetTop + currentElement.clientTop;
                        currentElement = currentElement.offsetParent;
                    }
                    width = child.offsetWidth;
                    height = child.offsetHeight;
                    return _context.abrupt("return", {
                        x: x + width / 2,
                        y: y + height / 2
                    });
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $45e8e8fab5a3dbf5$var$_getElementCenter.apply(this, arguments);
}
var $45e8e8fab5a3dbf5$var$EventEmitter = /*#__PURE__*/ function() {
    function EventEmitter() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, EventEmitter);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "listeners", new Set());
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(EventEmitter, [
        {
            key: "emit",
            value: function emit(data) {
                this.listeners.forEach(function(listener) {
                    return listener(data);
                });
            }
        },
        {
            key: "listen",
            value: function listen(handler) {
                var _this = this;
                this.listeners.add(handler);
                return function() {
                    _this.listeners["delete"](handler);
                };
            }
        }
    ]);
    return EventEmitter;
}();
var $45e8e8fab5a3dbf5$var$SocketsPositionsStorage = /*#__PURE__*/ function() {
    function SocketsPositionsStorage() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, SocketsPositionsStorage);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "elements", new Map());
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(SocketsPositionsStorage, [
        {
            key: "getPosition",
            value: function getPosition(data) {
                var _found$pop;
                var list = Array.from(this.elements.values()).flat();
                var found = list.filter(function(item) {
                    return item.side === data.side && item.nodeId === data.nodeId && item.key === data.key;
                });
                // eslint-disable-next-line no-console
                if (found.length > 1) console.warn([
                    "Found more than one element for socket with same key and side.",
                    "Probably it was not unmounted correctly"
                ].join(" "), data);
                return ((_found$pop = found.pop()) === null || _found$pop === void 0 ? void 0 : _found$pop.position) || null;
            }
        },
        {
            key: "add",
            value: function add(data) {
                var existing = this.elements.get(data.element);
                this.elements.set(data.element, existing ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(existing.filter(function(n) {
                    return !(n.nodeId === data.nodeId && n.key === data.key && n.side === data.side);
                })), [
                    data
                ]) : [
                    data
                ]);
            }
        },
        {
            key: "remove",
            value: function remove(element) {
                this.elements["delete"](element);
            }
        },
        {
            key: "snapshot",
            value: function snapshot() {
                return Array.from(this.elements.values()).flat();
            }
        }
    ]);
    return SocketsPositionsStorage;
}();
/**
 * Abstract class for socket position calculation. It can be extended to implement custom socket position calculation.
 * @abstract
 * @listens render
 * @listens rendered
 * @listens unmount
 * @listens nodetranslated
 * @listens noderesized
 */ var $45e8e8fab5a3dbf5$export$ad4bbe84d3e8ed90 = /*#__PURE__*/ function() {
    function BaseSocketPosition() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, BaseSocketPosition);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "sockets", new $45e8e8fab5a3dbf5$var$SocketsPositionsStorage());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "emitter", new $45e8e8fab5a3dbf5$var$EventEmitter());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "area", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(BaseSocketPosition, [
        {
            key: "attach",
            value: /**
     * Attach the watcher to the area's child scope.
     * @param scope Scope of the watcher that should be a child of `BaseAreaPlugin`
     */ function attach(scope) {
                var _this = this;
                if (this.area) return;
                if (!scope.hasParent()) return;
                this.area = scope.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
                // eslint-disable-next-line max-statements, complexity
                this.area.addPipe(/*#__PURE__*/ function() {
                    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(context) {
                        var _context$data, _nodeId, _key, _side, _element, position, _nodeId2, _context$data$payload, source, target, _nodeId3;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    if (!(context.type === "rendered" && context.data.type === "socket")) {
                                        _context2.next = 8;
                                        break;
                                    }
                                    _context$data = context.data, _nodeId = _context$data.nodeId, _key = _context$data.key, _side = _context$data.side, _element = _context$data.element;
                                    _context2.next = 4;
                                    return _this.calculatePosition(_nodeId, _side, _key, _element);
                                case 4:
                                    position = _context2.sent;
                                    if (position) {
                                        _this.sockets.add({
                                            nodeId: _nodeId,
                                            key: _key,
                                            side: _side,
                                            element: _element,
                                            position: position
                                        });
                                        _this.emitter.emit({
                                            nodeId: _nodeId,
                                            key: _key,
                                            side: _side
                                        });
                                    }
                                    _context2.next = 24;
                                    break;
                                case 8:
                                    if (!(context.type === "unmount")) {
                                        _context2.next = 12;
                                        break;
                                    }
                                    _this.sockets.remove(context.data.element);
                                    _context2.next = 24;
                                    break;
                                case 12:
                                    if (!(context.type === "nodetranslated")) {
                                        _context2.next = 16;
                                        break;
                                    }
                                    _this.emitter.emit({
                                        nodeId: context.data.id
                                    });
                                    _context2.next = 24;
                                    break;
                                case 16:
                                    if (!(context.type === "noderesized")) {
                                        _context2.next = 23;
                                        break;
                                    }
                                    _nodeId2 = context.data.id;
                                    _context2.next = 20;
                                    return Promise.all(_this.sockets.snapshot().filter(function(item) {
                                        return item.nodeId === context.data.id && item.side === "output";
                                    }).map(/*#__PURE__*/ function() {
                                        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(item) {
                                            var side, key, element, position;
                                            return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                                                while(true)switch(_context.prev = _context.next){
                                                    case 0:
                                                        side = item.side, key = item.key, element = item.element;
                                                        _context.next = 3;
                                                        return _this.calculatePosition(_nodeId2, side, key, element);
                                                    case 3:
                                                        position = _context.sent;
                                                        if (position) item.position = position;
                                                    case 5:
                                                    case "end":
                                                        return _context.stop();
                                                }
                                            }, _callee);
                                        }));
                                        return function(_x2) {
                                            return _ref2.apply(this, arguments);
                                        };
                                    }()));
                                case 20:
                                    _this.emitter.emit({
                                        nodeId: _nodeId2
                                    });
                                    _context2.next = 24;
                                    break;
                                case 23:
                                    if (context.type === "render" && context.data.type === "connection") {
                                        _context$data$payload = context.data.payload, source = _context$data$payload.source, target = _context$data$payload.target;
                                        _nodeId3 = source || target;
                                        _this.emitter.emit({
                                            nodeId: _nodeId3
                                        });
                                    }
                                case 24:
                                    return _context2.abrupt("return", context);
                                case 25:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _callee2);
                    }));
                    return function(_x) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "listen",
            value: function listen(nodeId, side, key, change) {
                var _this2 = this;
                var unlisten = this.emitter.listen(function(data) {
                    if (data.nodeId !== nodeId) return;
                    if ((!data.key || data.side === side) && (!data.side || data.key === key)) {
                        var _this2$area;
                        var position = _this2.sockets.getPosition({
                            side: side,
                            nodeId: nodeId,
                            key: key
                        });
                        if (!position) return;
                        var x = position.x, y = position.y;
                        var nodeView = (_this2$area = _this2.area) === null || _this2$area === void 0 ? void 0 : _this2$area.nodeViews.get(nodeId);
                        if (nodeView) change({
                            x: x + nodeView.position.x,
                            y: y + nodeView.position.y
                        });
                    }
                });
                this.sockets.snapshot().forEach(function(data) {
                    if (data.nodeId === nodeId) _this2.emitter.emit(data);
                });
                return unlisten;
            }
        }
    ]);
    return BaseSocketPosition;
}();
function $45e8e8fab5a3dbf5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $45e8e8fab5a3dbf5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $45e8e8fab5a3dbf5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Props for `DOMSocketPosition` class.
 */ /**
 * Class for socket position calculation based on DOM elements. It uses `getElementCenter` function to calculate the position.
 */ var $45e8e8fab5a3dbf5$export$fec384cd93013ca1 = /*#__PURE__*/ function(_BaseSocketPosition) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(DOMSocketPosition, _BaseSocketPosition);
    var _super = $45e8e8fab5a3dbf5$var$_createSuper(DOMSocketPosition);
    function DOMSocketPosition(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, DOMSocketPosition);
        _this = _super.call(this);
        _this.props = props;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(DOMSocketPosition, [
        {
            key: "calculatePosition",
            value: function() {
                var _calculatePosition = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(nodeId, side, key, element) {
                    var _this$area, _this$props, _this$props2;
                    var view, position;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                view = (_this$area = this.area) === null || _this$area === void 0 ? void 0 : _this$area.nodeViews.get(nodeId);
                                if (view !== null && view !== void 0 && view.element) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return", null);
                            case 3:
                                _context.next = 5;
                                return $45e8e8fab5a3dbf5$export$e0d4696b3026c537(element, view.element);
                            case 5:
                                position = _context.sent;
                                if (!((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.offset)) {
                                    _context.next = 8;
                                    break;
                                }
                                return _context.abrupt("return", (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.offset(position, nodeId, side, key));
                            case 8:
                                return _context.abrupt("return", {
                                    x: position.x + 12 * (side === "input" ? -1 : 1),
                                    y: position.y
                                });
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function calculatePosition(_x, _x2, _x3, _x4) {
                    return _calculatePosition.apply(this, arguments);
                }
                return calculatePosition;
            }()
        }
    ]);
    return DOMSocketPosition;
}($45e8e8fab5a3dbf5$export$ad4bbe84d3e8ed90);
/**
 * Wrapper function for `DOMSocketPosition` class.
 * @param props Props for `DOMSocketPosition` class
 */ function $45e8e8fab5a3dbf5$export$fdd6f17af8944845(props) {
    return new $45e8e8fab5a3dbf5$export$fec384cd93013ca1(props);
}


var $c4870074adc2be76$exports = {};
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$c4870074adc2be76$exports = $c4870074adc2be76$var$_taggedTemplateLiteral, $c4870074adc2be76$exports.__esModule = true, $c4870074adc2be76$exports["default"] = $c4870074adc2be76$exports;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $d2a81c6b9c235e40$var$extendStatics = function(d, b) {
    $d2a81c6b9c235e40$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d2a81c6b9c235e40$var$extendStatics(d, b);
};
function $d2a81c6b9c235e40$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d2a81c6b9c235e40$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d2a81c6b9c235e40$export$18ce0697a983be9b = function() {
    $d2a81c6b9c235e40$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d2a81c6b9c235e40$export$18ce0697a983be9b.apply(this, arguments);
};
function $d2a81c6b9c235e40$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d2a81c6b9c235e40$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d2a81c6b9c235e40$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d2a81c6b9c235e40$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d2a81c6b9c235e40$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d2a81c6b9c235e40$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $d2a81c6b9c235e40$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d2a81c6b9c235e40$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d2a81c6b9c235e40$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d2a81c6b9c235e40$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d2a81c6b9c235e40$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d2a81c6b9c235e40$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d2a81c6b9c235e40$export$45d3717a4c69092e(o, m, p);
}
function $d2a81c6b9c235e40$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d2a81c6b9c235e40$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d2a81c6b9c235e40$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d2a81c6b9c235e40$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d2a81c6b9c235e40$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d2a81c6b9c235e40$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d2a81c6b9c235e40$export$10c90e4f7922046c(v) {
    return this instanceof $d2a81c6b9c235e40$export$10c90e4f7922046c ? (this.v = v, this) : new $d2a81c6b9c235e40$export$10c90e4f7922046c(v);
}
function $d2a81c6b9c235e40$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d2a81c6b9c235e40$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d2a81c6b9c235e40$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d2a81c6b9c235e40$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d2a81c6b9c235e40$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d2a81c6b9c235e40$export$19a8beecd37a4c45 === "function" ? $d2a81c6b9c235e40$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d2a81c6b9c235e40$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d2a81c6b9c235e40$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $d2a81c6b9c235e40$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d2a81c6b9c235e40$export$45d3717a4c69092e(result, mod, k);
    }
    $d2a81c6b9c235e40$var$__setModuleDefault(result, mod);
    return result;
}
function $d2a81c6b9c235e40$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d2a81c6b9c235e40$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d2a81c6b9c235e40$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d2a81c6b9c235e40$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d2a81c6b9c235e40$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d2a81c6b9c235e40$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d2a81c6b9c235e40$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d2a81c6b9c235e40$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $d2a81c6b9c235e40$export$2e2bcd8739ae039 = {
    __extends: $d2a81c6b9c235e40$export$a8ba968b8961cb8a,
    __assign: $d2a81c6b9c235e40$export$18ce0697a983be9b,
    __rest: $d2a81c6b9c235e40$export$3c9a16f847548506,
    __decorate: $d2a81c6b9c235e40$export$29e00dfd3077644b,
    __param: $d2a81c6b9c235e40$export$d5ad3fd78186038f,
    __metadata: $d2a81c6b9c235e40$export$f1db080c865becb9,
    __awaiter: $d2a81c6b9c235e40$export$1050f835b63b671e,
    __generator: $d2a81c6b9c235e40$export$67ebef60e6f28a6,
    __createBinding: $d2a81c6b9c235e40$export$45d3717a4c69092e,
    __exportStar: $d2a81c6b9c235e40$export$f33643c0debef087,
    __values: $d2a81c6b9c235e40$export$19a8beecd37a4c45,
    __read: $d2a81c6b9c235e40$export$8d051b38c9118094,
    __spread: $d2a81c6b9c235e40$export$afc72e2116322959,
    __spreadArrays: $d2a81c6b9c235e40$export$6388937ca91ccae8,
    __spreadArray: $d2a81c6b9c235e40$export$1216008129fb82ed,
    __await: $d2a81c6b9c235e40$export$10c90e4f7922046c,
    __asyncGenerator: $d2a81c6b9c235e40$export$e427f37a30a4de9b,
    __asyncDelegator: $d2a81c6b9c235e40$export$bbd80228419bb833,
    __asyncValues: $d2a81c6b9c235e40$export$e3b29a3d6162315f,
    __makeTemplateObject: $d2a81c6b9c235e40$export$4fb47efe1390b86f,
    __importStar: $d2a81c6b9c235e40$export$c21735bcef00d192,
    __importDefault: $d2a81c6b9c235e40$export$da59b14a69baef04,
    __classPrivateFieldGet: $d2a81c6b9c235e40$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d2a81c6b9c235e40$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d2a81c6b9c235e40$export$81fdc39f203e4e04,
    __addDisposableResource: $d2a81c6b9c235e40$export$88ac25d8e944e405,
    __disposeResources: $d2a81c6b9c235e40$export$8f076105dc360e92
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $d2b63732fb4ff365$exports = {};
//
$d2b63732fb4ff365$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(z += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $298fb931ed4fbf8b$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(z) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(k = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $298fb931ed4fbf8b$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, p + 1, p = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n, c) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span", 0) ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch", 0) ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(n, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $b905865641868929$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $f8dbcd8598db1f0b$var$f = ("undefined" != typeof $cfae44f0dfdf62c0$exports && void 0 !== $cfae44f0dfdf62c0$exports.env && undefined, "data-styled"), $f8dbcd8598db1f0b$var$m = "active", $f8dbcd8598db1f0b$var$y = "data-styled-version", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.1.11", $f8dbcd8598db1f0b$var$g = "/*!sc*/\n", $f8dbcd8598db1f0b$var$S = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, "undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, false)), $f8dbcd8598db1f0b$var$b = {}, $f8dbcd8598db1f0b$var$E = /invalid hook call/i, $f8dbcd8598db1f0b$var$N = new Set, $f8dbcd8598db1f0b$var$P = function(t, n) {
    var o, s, i, a, e;
}, $f8dbcd8598db1f0b$var$_ = Object.freeze([]), $f8dbcd8598db1f0b$var$C = Object.freeze({});
function $f8dbcd8598db1f0b$var$I(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $f8dbcd8598db1f0b$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$D = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$R(e) {
    return e.replace($f8dbcd8598db1f0b$var$O, "-").replace($f8dbcd8598db1f0b$var$D, "");
}
var $f8dbcd8598db1f0b$var$T = /(a)(d)/gi, $f8dbcd8598db1f0b$var$k = 52, $f8dbcd8598db1f0b$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $f8dbcd8598db1f0b$var$k; t = t / $f8dbcd8598db1f0b$var$k | 0)n = $f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n;
    return ($f8dbcd8598db1f0b$var$j(t % $f8dbcd8598db1f0b$var$k) + n).replace($f8dbcd8598db1f0b$var$T, "$1-$2");
}
var $f8dbcd8598db1f0b$var$V, $f8dbcd8598db1f0b$var$F = 5381, $f8dbcd8598db1f0b$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$$ = function(e) {
    return $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$F, e);
};
function $f8dbcd8598db1f0b$var$z(e) {
    return $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$$(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$L(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$G = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$Y = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$W = $f8dbcd8598db1f0b$var$G ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$J = (($f8dbcd8598db1f0b$var$V = {})[$f8dbcd8598db1f0b$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$V[$f8dbcd8598db1f0b$var$Y] = $f8dbcd8598db1f0b$var$U, $f8dbcd8598db1f0b$var$V);
function $f8dbcd8598db1f0b$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$Y ? $f8dbcd8598db1f0b$var$U : "$$typeof" in e ? $f8dbcd8598db1f0b$var$J[e.$$typeof] : $f8dbcd8598db1f0b$var$q;
}
var $f8dbcd8598db1f0b$var$Z = Object.defineProperty, $f8dbcd8598db1f0b$var$K = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$Q = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$ee = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$te = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$ne = Object.prototype;
function $f8dbcd8598db1f0b$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$ne) {
            var o = $f8dbcd8598db1f0b$var$te(t);
            o && o !== $f8dbcd8598db1f0b$var$ne && $f8dbcd8598db1f0b$var$oe(e, o, n);
        }
        var r = $f8dbcd8598db1f0b$var$K(t);
        $f8dbcd8598db1f0b$var$Q && (r = r.concat($f8dbcd8598db1f0b$var$Q(t)));
        for(var s = $f8dbcd8598db1f0b$var$X(e), i = $f8dbcd8598db1f0b$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $f8dbcd8598db1f0b$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $f8dbcd8598db1f0b$var$ee(t, c);
                try {
                    $f8dbcd8598db1f0b$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$re(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $f8dbcd8598db1f0b$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    else if ($f8dbcd8598db1f0b$var$ce(t)) for(var o in t)e[o] = $f8dbcd8598db1f0b$var$le(e[o], t[o]);
    return e;
}
function $f8dbcd8598db1f0b$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $f8dbcd8598db1f0b$var$pe = {};
function $f8dbcd8598db1f0b$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $f8dbcd8598db1f0b$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($f8dbcd8598db1f0b$var$g);
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$me = 1073741824, $f8dbcd8598db1f0b$var$ye = new Map, $f8dbcd8598db1f0b$var$ve = new Map, $f8dbcd8598db1f0b$var$ge = 1, $f8dbcd8598db1f0b$var$Se = function(e) {
    if ($f8dbcd8598db1f0b$var$ye.has(e)) return $f8dbcd8598db1f0b$var$ye.get(e);
    for(; $f8dbcd8598db1f0b$var$ve.has($f8dbcd8598db1f0b$var$ge);)$f8dbcd8598db1f0b$var$ge++;
    var t = $f8dbcd8598db1f0b$var$ge++;
    return $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e), t;
}, $f8dbcd8598db1f0b$var$we = function(e, t) {
    $f8dbcd8598db1f0b$var$ge = t + 1, $f8dbcd8598db1f0b$var$ye.set(e, t), $f8dbcd8598db1f0b$var$ve.set(t, e);
}, $f8dbcd8598db1f0b$var$be = "style[".concat($f8dbcd8598db1f0b$var$f, "][").concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"]'), $f8dbcd8598db1f0b$var$Ee = new RegExp("^".concat($f8dbcd8598db1f0b$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $f8dbcd8598db1f0b$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f8dbcd8598db1f0b$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($f8dbcd8598db1f0b$var$we(u, l), $f8dbcd8598db1f0b$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $f8dbcd8598db1f0b$var$_e() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$Ce = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($f8dbcd8598db1f0b$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($f8dbcd8598db1f0b$var$f, $f8dbcd8598db1f0b$var$m), o.setAttribute($f8dbcd8598db1f0b$var$y, $f8dbcd8598db1f0b$export$83d89fbfd8236492);
    var i = $f8dbcd8598db1f0b$var$_e();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $f8dbcd8598db1f0b$var$Ie = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ce(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $f8dbcd8598db1f0b$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ae = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$Ce(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Oe = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$De = $f8dbcd8598db1f0b$var$S, $f8dbcd8598db1f0b$var$Re = {
    isServer: !$f8dbcd8598db1f0b$var$S,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$w
}, $f8dbcd8598db1f0b$var$Te = function() {
    function e(e, n, o) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$Re), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$S && $f8dbcd8598db1f0b$var$De && ($f8dbcd8598db1f0b$var$De = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$be), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute($f8dbcd8598db1f0b$var$f) !== $f8dbcd8598db1f0b$var$m && ($f8dbcd8598db1f0b$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $f8dbcd8598db1f0b$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $f8dbcd8598db1f0b$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($f8dbcd8598db1f0b$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($f8dbcd8598db1f0b$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$Se(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$Oe(n) : t ? new $f8dbcd8598db1f0b$var$Ie(n) : new $f8dbcd8598db1f0b$var$Ae(n);
        }(this.options), new $f8dbcd8598db1f0b$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $f8dbcd8598db1f0b$var$ke = /&/g, $f8dbcd8598db1f0b$var$je = /^\s*\/\/.*$/gm;
function $f8dbcd8598db1f0b$var$xe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$xe(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$Ve(e) {
    var t, n, o, r = void 0 === e ? $f8dbcd8598db1f0b$var$C : e, s = r.options, i = void 0 === s ? $f8dbcd8598db1f0b$var$C : s, a = r.plugins, c = void 0 === a ? $f8dbcd8598db1f0b$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $298fb931ed4fbf8b$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$ke, n).replace(o, l));
    }), i.prefix && u.push($298fb931ed4fbf8b$export$e08c7d021b829b7a), u.push($298fb931ed4fbf8b$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($f8dbcd8598db1f0b$var$je, ""), l = $298fb931ed4fbf8b$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $f8dbcd8598db1f0b$var$xe(l, i.namespace));
        var p = [];
        return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(l, $298fb931ed4fbf8b$export$5a7767152ae0305f(u.concat($298fb931ed4fbf8b$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$he(15), $f8dbcd8598db1f0b$var$M(e, t.name);
    }, $f8dbcd8598db1f0b$var$F).toString() : "", p;
}
var $f8dbcd8598db1f0b$var$Fe = new $f8dbcd8598db1f0b$var$Te, $f8dbcd8598db1f0b$var$Me = $f8dbcd8598db1f0b$var$Ve(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$Fe,
    stylis: $f8dbcd8598db1f0b$var$Me
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$Be = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$Le() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $f8dbcd8598db1f0b$var$Le().styleSheet, l = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$Ve({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($d2b63732fb4ff365$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $acw62.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$Be.Provider, {
        value: u
    }, e.children));
}
var $f8dbcd8598db1f0b$var$Ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$Me);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $f8dbcd8598db1f0b$var$ue(this, function() {
            throw $f8dbcd8598db1f0b$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$Me), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$We = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$qe(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$We(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$He = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$Ue = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$f8dbcd8598db1f0b$var$He(i) && (Array.isArray(i) && i.isCss || $f8dbcd8598db1f0b$var$re(i) ? r.push("".concat($f8dbcd8598db1f0b$var$qe(s), ":"), i, ";") : $f8dbcd8598db1f0b$var$ce(i) ? r.push.apply(r, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)((0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $f8dbcd8598db1f0b$var$Ue(i), !1), [
            "}"
        ], !1)) : r.push("".concat($f8dbcd8598db1f0b$var$qe(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $b905865641868929$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $f8dbcd8598db1f0b$var$Je(e, t, n, o) {
    if ($f8dbcd8598db1f0b$var$He(e)) return [];
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($f8dbcd8598db1f0b$var$re(e)) {
        if (!$f8dbcd8598db1f0b$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $f8dbcd8598db1f0b$var$Je(r, t, n, o);
    }
    var s;
    return e instanceof $f8dbcd8598db1f0b$var$Ye ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $f8dbcd8598db1f0b$var$ce(e) ? $f8dbcd8598db1f0b$var$Ue(e) : Array.isArray(e) ? Array.prototype.concat.apply($f8dbcd8598db1f0b$var$_, e.map(function(e) {
        return $f8dbcd8598db1f0b$var$Je(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $f8dbcd8598db1f0b$var$Xe(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$re(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$Ze = $f8dbcd8598db1f0b$var$$($f8dbcd8598db1f0b$export$83d89fbfd8236492), $f8dbcd8598db1f0b$var$Ke = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$Xe(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$Ze, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Te.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $f8dbcd8598db1f0b$var$ie(o, this.staticRulesId);
            else {
                var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Je(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$x($f8dbcd8598db1f0b$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $f8dbcd8598db1f0b$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Je(u, e, t, n));
                    a = $f8dbcd8598db1f0b$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $f8dbcd8598db1f0b$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $f8dbcd8598db1f0b$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    var e = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$he(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, $acw62.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$he(14);
            if ($f8dbcd8598db1f0b$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$he(8);
            return n ? (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$ot = {}, $f8dbcd8598db1f0b$var$rt = new Set;
function $f8dbcd8598db1f0b$var$st(e, r, s) {
    var i = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), a = e, c = !$f8dbcd8598db1f0b$var$L(e), p = r.attrs, d = void 0 === p ? $f8dbcd8598db1f0b$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$R(e);
        $f8dbcd8598db1f0b$var$ot[n] = ($f8dbcd8598db1f0b$var$ot[n] || 0) + 1;
        var o = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$z($f8dbcd8598db1f0b$export$83d89fbfd8236492 + n + $f8dbcd8598db1f0b$var$ot[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $f8dbcd8598db1f0b$var$L(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($f8dbcd8598db1f0b$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $f8dbcd8598db1f0b$var$Ke(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), m = $f8dbcd8598db1f0b$var$Le(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $f8dbcd8598db1f0b$var$I(r, f, c) || $f8dbcd8598db1f0b$var$C, g = function(e, n, o) {
                for(var r, s = (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $f8dbcd8598db1f0b$var$ie(s[c], a[c]) : "style" === c ? (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $f8dbcd8598db1f0b$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $f8dbcd8598db1f0b$var$Le(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $f8dbcd8598db1f0b$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$f8dbcd8598db1f0b$var$L(S) && !$f8dbcd8598db1f0b$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $acw62.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $f8dbcd8598db1f0b$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$f8dbcd8598db1f0b$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $f8dbcd8598db1f0b$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $f8dbcd8598db1f0b$var$it(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$at = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($f8dbcd8598db1f0b$var$re(t) || $f8dbcd8598db1f0b$var$ce(t)) return $f8dbcd8598db1f0b$var$at($f8dbcd8598db1f0b$var$Je($f8dbcd8598db1f0b$var$it($f8dbcd8598db1f0b$var$_, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $f8dbcd8598db1f0b$var$Je(r) : $f8dbcd8598db1f0b$var$at($f8dbcd8598db1f0b$var$Je($f8dbcd8598db1f0b$var$it(r, n)));
}
function $f8dbcd8598db1f0b$var$lt(n, o, r) {
    if (void 0 === r && (r = $f8dbcd8598db1f0b$var$C), !o) throw $f8dbcd8598db1f0b$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$lt(n, o, (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$lt(n, o, (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $f8dbcd8598db1f0b$var$ut = function(e) {
    return $f8dbcd8598db1f0b$var$lt($f8dbcd8598db1f0b$var$st, e);
}, $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$ut;
$f8dbcd8598db1f0b$var$A.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$ut(e);
});
var $f8dbcd8598db1f0b$var$dt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$Xe(e), $f8dbcd8598db1f0b$var$Te.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$Je(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $f8dbcd8598db1f0b$var$Te.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$z(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$dt(i, a);
    var l = function(e) {
        var t = $f8dbcd8598db1f0b$var$Le(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$b, o, s);
        else {
            var i = (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)((0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $d2a81c6b9c235e40$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$z(r);
    return new $f8dbcd8598db1f0b$var$Ye(s, r);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $f8dbcd8598db1f0b$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($f8dbcd8598db1f0b$var$B(e), ")"), $f8dbcd8598db1f0b$var$oe(n, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $f8dbcd8598db1f0b$var$_e(), o = $f8dbcd8598db1f0b$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$f, '="true"'),
                "".concat($f8dbcd8598db1f0b$var$y, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$he(2);
            var r = ((n = {})[$f8dbcd8598db1f0b$var$f] = "", n[$f8dbcd8598db1f0b$var$y] = $f8dbcd8598db1f0b$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $f8dbcd8598db1f0b$var$_e();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $d2a81c6b9c235e40$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Te({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$he(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Te,
    mainSheet: $f8dbcd8598db1f0b$var$Fe
};
var $f8dbcd8598db1f0b$var$gt = "__sc-".concat($f8dbcd8598db1f0b$var$f, "__");


var $27ab08c24269de64$exports = {};
function $27ab08c24269de64$var$_extends() {
    return $27ab08c24269de64$exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
$27ab08c24269de64$exports = $27ab08c24269de64$var$_extends, $27ab08c24269de64$exports.__esModule = true, $27ab08c24269de64$exports["default"] = $27ab08c24269de64$exports;


var $c5fdcdd8d5286ae7$exports = {};
var $8bc9a7bbcf9a2a3b$exports = {};
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
$8bc9a7bbcf9a2a3b$exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, $8bc9a7bbcf9a2a3b$exports.__esModule = true, $8bc9a7bbcf9a2a3b$exports["default"] = $8bc9a7bbcf9a2a3b$exports;


function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8bc9a7bbcf9a2a3b$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$c5fdcdd8d5286ae7$exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, $c5fdcdd8d5286ae7$exports.__esModule = true, $c5fdcdd8d5286ae7$exports["default"] = $c5fdcdd8d5286ae7$exports;



function $c24bb3319861fe36$var$getRenderer(props) {
    var createRoot = props === null || props === void 0 ? void 0 : props.createRoot;
    var wrappers = new WeakMap();
    function getWrapper(container) {
        var wrapper = wrappers.get(container);
        if (wrapper) return wrapper;
        var span = document.createElement("span");
        container.appendChild(span);
        return wrappers.set(container, span).get(container);
    }
    function removeWrapper(container) {
        var wrapper = wrappers.get(container);
        if (wrapper) wrapper.remove();
        wrappers["delete"](container);
    }
    if (createRoot) {
        var roots = new WeakMap();
        return {
            mount: function(element, container) {
                var wrapper = getWrapper(container);
                if (!roots.has(wrapper)) roots.set(wrapper, createRoot(wrapper));
                var root = roots.get(wrapper);
                return root.render(element);
            },
            unmount: function unmount(container) {
                var wrapper = getWrapper(container);
                var root = roots.get(wrapper);
                if (root) {
                    root.unmount();
                    roots["delete"](wrapper);
                    removeWrapper(container);
                }
            }
        };
    }
    return {
        mount: function(element, container) {
            return $11492dca620dcaa5$exports.render(element, getWrapper(container));
        },
        unmount: function unmount(container) {
            $11492dca620dcaa5$exports.unmountComponentAtNode(getWrapper(container));
            removeWrapper(container);
        }
    };
}
function $c24bb3319861fe36$var$Root(_ref) {
    var children = _ref.children, rendered = _ref.rendered;
    (0, $acw62.useEffect)(function() {
        rendered();
    });
    return children;
}
function $c24bb3319861fe36$var$syncFlush() {
    var ready = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(function() {
        ready.current = true;
    }, []);
    return {
        apply: function apply(f) {
            if (ready.current) queueMicrotask(function() {
                return (0, $11492dca620dcaa5$exports.flushSync)(f);
            });
            else f();
        }
    };
}
function $c24bb3319861fe36$export$8b188b710970769c(create) {
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState, 2), container = _useState2[0], setContainer = _useState2[1];
    var editorRef = (0, $acw62.useRef)();
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState3, 2), editor = _useState4[0], setEditor = _useState4[1];
    var ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (container) {
            if (editorRef.current) {
                editorRef.current.destroy();
                container.innerHTML = "";
            }
            create(container).then(function(value) {
                editorRef.current = value;
                setEditor(value);
            });
        }
    }, [
        container,
        create
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            if (editorRef.current) editorRef.current.destroy();
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        if (ref.current) setContainer(ref.current);
    }, [
        ref.current
    ]);
    return [
        ref,
        editor
    ];
}
var $c24bb3319861fe36$var$ConnectionContext = /*#__PURE__*/ (0, $acw62.createContext)({
    start: null,
    end: null,
    path: null
});
function $c24bb3319861fe36$var$ConnectionWrapper(props) {
    var children = props.children;
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState, 2), computedStart = _useState2[0], setStart = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState3, 2), computedEnd = _useState4[0], setEnd = _useState4[1];
    var _useState5 = (0, $acw62.useState)(null), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useState5, 2), path = _useState6[0], setPath = _useState6[1];
    var start = "x" in props.start ? props.start : computedStart;
    var end = "x" in props.end ? props.end : computedEnd;
    var flush = $c24bb3319861fe36$var$syncFlush();
    (0, $acw62.useEffect)(function() {
        var unwatch1 = typeof props.start === "function" && props.start(function(s) {
            return flush.apply(function() {
                return setStart(s);
            });
        });
        var unwatch2 = typeof props.end === "function" && props.end(function(s) {
            return flush.apply(function() {
                return setEnd(s);
            });
        });
        return function() {
            unwatch1 && unwatch1();
            unwatch2 && unwatch2();
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        if (start && end) props.path(start, end).then(function(p) {
            return flush.apply(function() {
                return setPath(p);
            });
        });
    }, [
        start,
        end
    ]);
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$ConnectionContext.Provider, {
        value: {
            start: start,
            end: end,
            path: path
        }
    }, children);
}
function $c24bb3319861fe36$var$useConnection() {
    return (0, $acw62.useContext)($c24bb3319861fe36$var$ConnectionContext);
}
var $c24bb3319861fe36$var$_templateObject$b, $c24bb3319861fe36$var$_templateObject2$3;
var $c24bb3319861fe36$var$Svg = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).svg($c24bb3319861fe36$var$_templateObject$b || ($c24bb3319861fe36$var$_templateObject$b = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    overflow: visible !important;\n    position: absolute;\n    pointer-events: none;\n    width: 9999px;\n    height: 9999px;\n"
])));
var $c24bb3319861fe36$var$Path = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).path($c24bb3319861fe36$var$_templateObject2$3 || ($c24bb3319861fe36$var$_templateObject2$3 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    fill: none;\n    stroke-width: 5px;\n    stroke: steelblue;\n    pointer-events: auto;\n    ",
    "\n"
])), function(props) {
    return props.styles && props.styles(props);
});
function $c24bb3319861fe36$var$Connection(props) {
    var _useConnection = $c24bb3319861fe36$var$useConnection(), path = _useConnection.path;
    if (!path) return null;
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Svg, {
        "data-testid": "connection"
    }, /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Path, {
        styles: props.styles,
        d: path
    }));
}
function $c24bb3319861fe36$var$_createForOfIteratorHelper$1(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c24bb3319861fe36$var$_unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c24bb3319861fe36$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c24bb3319861fe36$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c24bb3319861fe36$var$_arrayLikeToArray$1(o, minLen);
}
function $c24bb3319861fe36$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c24bb3319861fe36$var$copyEvent(e) {
    var newEvent = new e.constructor(e.type);
    var current = newEvent;
    while(current = Object.getPrototypeOf(current)){
        var keys = Object.getOwnPropertyNames(current);
        var _iterator = $c24bb3319861fe36$var$_createForOfIteratorHelper$1(keys), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var k = _step.value;
                var item = newEvent[k];
                if (typeof item === "function") continue;
                Object.defineProperty(newEvent, k, {
                    value: e[k]
                });
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return newEvent;
}
var $c24bb3319861fe36$var$rootPrefix = "__reactContainer$";
function $c24bb3319861fe36$var$findReactRoot(element) {
    var current = element;
    while(current){
        if (current._reactRootContainer || Object.keys(current).some(function(key) {
            return key.startsWith($c24bb3319861fe36$var$rootPrefix);
        })) return current;
        current = current.parentElement;
    }
}
function $c24bb3319861fe36$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c24bb3319861fe36$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c24bb3319861fe36$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c24bb3319861fe36$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c24bb3319861fe36$var$useDrag(translate, getPointer) {
    return {
        start: function start(e) {
            var previous = $c24bb3319861fe36$var$_objectSpread$1({}, getPointer(e));
            function move(moveEvent) {
                var current = $c24bb3319861fe36$var$_objectSpread$1({}, getPointer(moveEvent));
                var dx = current.x - previous.x;
                var dy = current.y - previous.y;
                previous = current;
                translate(dx, dy);
            }
            function up() {
                window.removeEventListener("pointermove", move);
                window.removeEventListener("pointerup", up);
                window.removeEventListener("pointercancel", up);
            }
            window.addEventListener("pointermove", move);
            window.addEventListener("pointerup", up);
            window.addEventListener("pointercancel", up);
        }
    };
}
function $c24bb3319861fe36$var$useNoDrag(ref, disabled) {
    $acw62.useEffect(function() {
        var handleClick = function handleClick(e) {
            if (disabled) return;
            var root = $c24bb3319861fe36$var$findReactRoot(e.target);
            var target = $acw62.version.startsWith("16") ? document : root;
            if (target) {
                e.stopPropagation();
                target.dispatchEvent($c24bb3319861fe36$var$copyEvent(e));
            }
        };
        var el = ref.current;
        el === null || el === void 0 || el.addEventListener("pointerdown", handleClick);
        return function() {
            el === null || el === void 0 || el.removeEventListener("pointerdown", handleClick);
        };
    }, [
        ref,
        disabled
    ]);
}
function $c24bb3319861fe36$var$NoDrag(props) {
    var ref = $acw62.useRef(null);
    $c24bb3319861fe36$var$useNoDrag(ref, props.disabled);
    return /*#__PURE__*/ $acw62.createElement("span", {
        ref: ref
    }, props.children);
}
var $c24bb3319861fe36$export$b48985bba8f530f5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    useDrag: $c24bb3319861fe36$var$useDrag,
    useNoDrag: $c24bb3319861fe36$var$useNoDrag,
    NoDrag: $c24bb3319861fe36$var$NoDrag
});
var $c24bb3319861fe36$var$_templateObject$a;
var $c24bb3319861fe36$var$Input = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).input($c24bb3319861fe36$var$_templateObject$a || ($c24bb3319861fe36$var$_templateObject$a = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n  width: 100%;\n  border-radius: 30px;\n  background-color: white;\n  padding: 2px 6px;\n  border: 1px solid #999;\n  font-size: 110%;\n  box-sizing: border-box;\n  ",
    "\n"
])), function(props) {
    return props.styles && props.styles(props);
});
function $c24bb3319861fe36$var$Control(props) {
    var _React$useState = $acw62.useState(props.data.value), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    var ref = $acw62.useRef(null);
    $c24bb3319861fe36$var$useNoDrag(ref);
    $acw62.useEffect(function() {
        setValue(props.data.value);
    }, [
        props.data.value
    ]);
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Input, {
        value: value,
        type: props.data.type,
        ref: ref,
        readOnly: props.data.readonly,
        onChange: function onChange(e) {
            var val = props.data.type === "number" ? +e.target.value : e.target.value;
            setValue(val);
            props.data.setValue(val);
        },
        styles: props.styles
    });
}
var $c24bb3319861fe36$var$$nodecolor = "rgba(110,136,255,0.8)";
var $c24bb3319861fe36$var$$nodecolorselected = "#ffd92c";
var $c24bb3319861fe36$var$$socketsize = 24;
var $c24bb3319861fe36$var$$socketmargin = 6;
var $c24bb3319861fe36$var$$socketcolor = "#96b38a";
var $c24bb3319861fe36$var$$nodewidth = 180;
var $c24bb3319861fe36$var$vars = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    $nodecolor: $c24bb3319861fe36$var$$nodecolor,
    $nodecolorselected: $c24bb3319861fe36$var$$nodecolorselected,
    $socketsize: $c24bb3319861fe36$var$$socketsize,
    $socketmargin: $c24bb3319861fe36$var$$socketmargin,
    $socketcolor: $c24bb3319861fe36$var$$socketcolor,
    $nodewidth: $c24bb3319861fe36$var$$nodewidth
});
var $c24bb3319861fe36$var$_excluded$2 = [
    "init",
    "unmount"
];
/**
 * Component for rendering various elements embedded in the React.js component tree.
 */ function $c24bb3319861fe36$export$5a3d00809b0b5d51(_ref) {
    var init = _ref.init, unmount = _ref.unmount, props = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $c24bb3319861fe36$var$_excluded$2);
    var ref = $acw62.useRef(null);
    $acw62.useEffect(function() {
        var element = ref.current;
        return function() {
            if (element) unmount(element);
        };
    }, []);
    $acw62.useEffect(function() {
        if (ref.current) init(ref.current);
    });
    return /*#__PURE__*/ $acw62.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, props, {
        ref: ref
    }));
}
var $c24bb3319861fe36$var$_excluded$1 = [
    "name",
    "emit",
    "payload"
];
function $c24bb3319861fe36$var$RefControl(_ref) {
    var name = _ref.name, emit = _ref.emit, payload = _ref.payload, props = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $c24bb3319861fe36$var$_excluded$1);
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$export$5a3d00809b0b5d51, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, props, {
        className: name,
        init: function init(ref) {
            return emit({
                type: "render",
                data: {
                    type: "control",
                    element: ref,
                    payload: payload
                }
            });
        },
        unmount: function unmount(ref) {
            return emit({
                type: "unmount",
                data: {
                    element: ref
                }
            });
        }
    }));
}
var $c24bb3319861fe36$var$_excluded = [
    "name",
    "emit",
    "nodeId",
    "side",
    "socketKey",
    "payload"
];
function $c24bb3319861fe36$var$RefSocket(_ref) {
    var name = _ref.name, emit = _ref.emit, nodeId = _ref.nodeId, side = _ref.side, socketKey = _ref.socketKey, payload = _ref.payload, props = (0, (/*@__PURE__*/$parcel$interopDefault($c5fdcdd8d5286ae7$exports)))(_ref, $c24bb3319861fe36$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$export$5a3d00809b0b5d51, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, props, {
        className: name,
        init: function init(ref) {
            return emit({
                type: "render",
                data: {
                    type: "socket",
                    side: side,
                    key: socketKey,
                    nodeId: nodeId,
                    element: ref,
                    payload: payload
                }
            });
        },
        unmount: function unmount(ref) {
            return emit({
                type: "unmount",
                data: {
                    element: ref
                }
            });
        }
    }));
}
var $c24bb3319861fe36$var$_templateObject$9, $c24bb3319861fe36$var$_templateObject2$2;
var $c24bb3319861fe36$var$NodeStyles = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject$9 || ($c24bb3319861fe36$var$_templateObject$9 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    background: ",
    ";\n    border: 2px solid #4e58bf;\n    border-radius: 10px;\n    cursor: pointer;\n    box-sizing: border-box;\n    width: ",
    ";\n    height: ",
    ";\n    padding-bottom: 6px;\n    position: relative;\n    user-select: none;\n    line-height: initial;\n    font-family: Arial;\n\n    &:hover {\n        background: lighten(",
    ",4%);\n    }\n    ",
    "\n    .title {\n        color: white;\n        font-family: sans-serif;\n        font-size: 18px;\n        padding: 8px;\n    }\n    .output {\n        text-align: right;\n    }\n    .input {\n        text-align: left;\n    }\n    .output-socket {\n        text-align: right;\n        margin-right: -",
    "px;\n        display: inline-block;\n    }\n    .input-socket {\n        text-align: left;\n        margin-left: -",
    "px;\n        display: inline-block;\n    }\n    .input-title,.output-title {\n        vertical-align: middle;\n        color: white;\n        display: inline-block;\n        font-family: sans-serif;\n        font-size: 14px;\n        margin: ",
    "px;\n        line-height: ",
    "px;\n    }\n    .input-control {\n        z-index: 1;\n        width: calc(100% - ",
    "px);\n        vertical-align: middle;\n        display: inline-block;\n    }\n    .control {\n        display: block;\n        padding: ",
    "px ",
    "px;\n    }\n    ",
    "\n"
])), $c24bb3319861fe36$var$$nodecolor, function(props) {
    return Number.isFinite(props.width) ? "".concat(props.width, "px") : "".concat($c24bb3319861fe36$var$$nodewidth, "px");
}, function(props) {
    return Number.isFinite(props.height) ? "".concat(props.height, "px") : "auto";
}, $c24bb3319861fe36$var$$nodecolor, function(props) {
    return props.selected && (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)($c24bb3319861fe36$var$_templateObject2$2 || ($c24bb3319861fe36$var$_templateObject2$2 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
        "\n        background: ",
        ";\n        border-color: #e3c000;\n    "
    ])), $c24bb3319861fe36$var$$nodecolorselected);
}, $c24bb3319861fe36$var$$socketsize / 2 + $c24bb3319861fe36$var$$socketmargin, $c24bb3319861fe36$var$$socketsize / 2 + $c24bb3319861fe36$var$$socketmargin, $c24bb3319861fe36$var$$socketmargin, $c24bb3319861fe36$var$$socketsize, $c24bb3319861fe36$var$$socketsize + 2 * $c24bb3319861fe36$var$$socketmargin, $c24bb3319861fe36$var$$socketmargin, $c24bb3319861fe36$var$$socketsize / 2 + $c24bb3319861fe36$var$$socketmargin, function(props) {
    return props.styles && props.styles(props);
});
function $c24bb3319861fe36$var$sortByIndex(entries) {
    entries.sort(function(a, b) {
        var _a$, _b$;
        var ai = ((_a$ = a[1]) === null || _a$ === void 0 ? void 0 : _a$.index) || 0;
        var bi = ((_b$ = b[1]) === null || _b$ === void 0 ? void 0 : _b$.index) || 0;
        return ai - bi;
    });
}
// eslint-disable-next-line max-statements
function $c24bb3319861fe36$var$Node(props) {
    var inputs = Object.entries(props.data.inputs);
    var outputs = Object.entries(props.data.outputs);
    var controls = Object.entries(props.data.controls);
    var selected = props.data.selected || false;
    var _props$data = props.data, id = _props$data.id, label = _props$data.label, width = _props$data.width, height = _props$data.height;
    $c24bb3319861fe36$var$sortByIndex(inputs);
    $c24bb3319861fe36$var$sortByIndex(outputs);
    $c24bb3319861fe36$var$sortByIndex(controls);
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$NodeStyles, {
        selected: selected,
        width: width,
        height: height,
        styles: props.styles,
        "data-testid": "node"
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "title",
        "data-testid": "title"
    }, label), outputs.map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref, 2), key = _ref2[0], output = _ref2[1];
        return output && /*#__PURE__*/ $acw62.createElement("div", {
            className: "output",
            key: key,
            "data-testid": "output-".concat(key)
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: "output-title",
            "data-testid": "output-title"
        }, output === null || output === void 0 ? void 0 : output.label), /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$RefSocket, {
            name: "output-socket",
            side: "output",
            socketKey: key,
            nodeId: id,
            emit: props.emit,
            payload: output.socket,
            "data-testid": "output-socket"
        }));
    }), controls.map(function(_ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref3, 2), key = _ref4[0], control = _ref4[1];
        return control ? /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$RefControl, {
            key: key,
            name: "control",
            emit: props.emit,
            payload: control,
            "data-testid": "control-".concat(key)
        }) : null;
    }), inputs.map(function(_ref5) {
        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref5, 2), key = _ref6[0], input = _ref6[1];
        return input && /*#__PURE__*/ $acw62.createElement("div", {
            className: "input",
            key: key,
            "data-testid": "input-".concat(key)
        }, /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$RefSocket, {
            name: "input-socket",
            side: "input",
            socketKey: key,
            nodeId: id,
            emit: props.emit,
            payload: input.socket,
            "data-testid": "input-socket"
        }), input && (!input.control || !input.showControl) && /*#__PURE__*/ $acw62.createElement("div", {
            className: "input-title",
            "data-testid": "input-title"
        }, input === null || input === void 0 ? void 0 : input.label), (input === null || input === void 0 ? void 0 : input.control) && (input === null || input === void 0 ? void 0 : input.showControl) && /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$RefControl, {
            key: key,
            name: "input-control",
            emit: props.emit,
            payload: input.control,
            "data-testid": "input-control"
        }));
    }));
}
var $c24bb3319861fe36$var$_templateObject$8, $c24bb3319861fe36$var$_templateObject2$1;
var $c24bb3319861fe36$var$Styles$4 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject$8 || ($c24bb3319861fe36$var$_templateObject$8 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    display: inline-block;\n    cursor: pointer;\n    border: 1px solid white;\n    border-radius: ",
    "px;\n    width: ",
    "px;\n    height: ",
    "px;\n    vertical-align: middle;\n    background: ",
    ";\n    z-index: 2;\n    box-sizing: border-box;\n    &:hover {\n      border-width: 4px;\n    }\n    &.multiple {\n      border-color: yellow;\n    }\n"
])), $c24bb3319861fe36$var$$socketsize / 2.0, $c24bb3319861fe36$var$$socketsize, $c24bb3319861fe36$var$$socketsize, $c24bb3319861fe36$var$$socketcolor);
var $c24bb3319861fe36$var$Hoverable = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject2$1 || ($c24bb3319861fe36$var$_templateObject2$1 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    border-radius: ",
    "px;\n    padding: ",
    "px;\n    &:hover ",
    " {\n      border-width: 4px;\n    }\n"
])), ($c24bb3319861fe36$var$$socketsize + $c24bb3319861fe36$var$$socketmargin * 2) / 2.0, $c24bb3319861fe36$var$$socketmargin, $c24bb3319861fe36$var$Styles$4);
function $c24bb3319861fe36$var$Socket(props) {
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Hoverable, null, /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Styles$4, {
        title: props.data.name
    }));
}
/**
 * Classic preset for rendering nodes, connections, controls and sockets.
 */ function $c24bb3319861fe36$var$setup$3(props) {
    var positionWatcher = typeof (props === null || props === void 0 ? void 0 : props.socketPositionWatcher) === "undefined" ? (0, $45e8e8fab5a3dbf5$export$fdd6f17af8944845)() : props === null || props === void 0 ? void 0 : props.socketPositionWatcher;
    var _ref = (props === null || props === void 0 ? void 0 : props.customize) || {}, node = _ref.node, connection = _ref.connection, socket = _ref.socket, control = _ref.control;
    return {
        attach: function attach(plugin) {
            positionWatcher.attach(plugin);
        },
        // eslint-disable-next-line max-statements, complexity
        render: function render(context, plugin) {
            if (context.data.type === "node") {
                var parent = plugin.parentScope();
                var Component = node ? node(context.data) : $c24bb3319861fe36$var$Node;
                return Component && /*#__PURE__*/ $acw62.createElement(Component, {
                    data: context.data.payload,
                    emit: function emit(data) {
                        return parent.emit(data);
                    }
                });
            } else if (context.data.type === "connection") {
                var _Component = connection ? connection(context.data) : $c24bb3319861fe36$var$Connection;
                var payload = context.data.payload;
                var sourceOutput = payload.sourceOutput, targetInput = payload.targetInput, source = payload.source, target = payload.target;
                return _Component && /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$ConnectionWrapper, {
                    start: context.data.start || function(change) {
                        return positionWatcher.listen(source, "output", sourceOutput, change);
                    },
                    end: context.data.end || function(change) {
                        return positionWatcher.listen(target, "input", targetInput, change);
                    },
                    path: /*#__PURE__*/ function() {
                        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(start, end) {
                            var response, _response$data, path, points, curvature;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return plugin.emit({
                                            type: "connectionpath",
                                            data: {
                                                payload: payload,
                                                points: [
                                                    start,
                                                    end
                                                ]
                                            }
                                        });
                                    case 2:
                                        response = _context.sent;
                                        if (response) {
                                            _context.next = 5;
                                            break;
                                        }
                                        return _context.abrupt("return", "");
                                    case 5:
                                        _response$data = response.data, path = _response$data.path, points = _response$data.points;
                                        curvature = 0.3;
                                        if (!(!path && points.length !== 2)) {
                                            _context.next = 9;
                                            break;
                                        }
                                        throw new Error("cannot render connection with a custom number of points");
                                    case 9:
                                        if (path) {
                                            _context.next = 11;
                                            break;
                                        }
                                        return _context.abrupt("return", payload.isLoop ? (0, $45e8e8fab5a3dbf5$export$71c5890ba659a82e)(points, curvature, 120) : (0, $45e8e8fab5a3dbf5$export$ac147288282af99d)(points, curvature));
                                    case 11:
                                        return _context.abrupt("return", path);
                                    case 12:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x, _x2) {
                            return _ref2.apply(this, arguments);
                        };
                    }()
                }, /*#__PURE__*/ $acw62.createElement(_Component, {
                    data: context.data.payload
                }));
            } else if (context.data.type === "socket") {
                var _Component2 = socket ? socket(context.data) : $c24bb3319861fe36$var$Socket;
                return _Component2 && context.data.payload && /*#__PURE__*/ $acw62.createElement(_Component2, {
                    data: context.data.payload
                });
            } else if (context.data.type === "control") {
                var _Component3 = control && context.data.payload ? control(context.data) : context.data.payload instanceof (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).InputControl ? $c24bb3319861fe36$var$Control : null;
                return _Component3 && /*#__PURE__*/ $acw62.createElement(_Component3, {
                    data: context.data.payload
                });
            }
        }
    };
}
var $c24bb3319861fe36$var$index$4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    vars: $c24bb3319861fe36$var$vars,
    setup: $c24bb3319861fe36$var$setup$3,
    Connection: $c24bb3319861fe36$var$Connection,
    useConnection: $c24bb3319861fe36$var$useConnection,
    Control: $c24bb3319861fe36$var$Control,
    InputControl: $c24bb3319861fe36$var$Control,
    Node: $c24bb3319861fe36$var$Node,
    NodeStyles: $c24bb3319861fe36$var$NodeStyles,
    RefControl: $c24bb3319861fe36$var$RefControl,
    RefSocket: $c24bb3319861fe36$var$RefSocket,
    Socket: $c24bb3319861fe36$var$Socket
});
function $c24bb3319861fe36$var$useDebounce(cb, timeout) {
    var ref = (0, $acw62.useRef)();
    function cancel() {
        ref.current && clearTimeout(ref.current);
    }
    var func = function func() {
        cancel();
        ref.current = setTimeout(function() {
            cb();
        }, timeout);
    };
    (0, $acw62.useEffect)(function() {
        return cancel;
    }, []);
    return [
        func,
        cancel
    ];
}
var $c24bb3319861fe36$var$$contextColor = "rgba(110,136,255,0.8)";
var $c24bb3319861fe36$var$$contextColorLight = "rgba(130, 153, 255, 0.8)";
var $c24bb3319861fe36$var$$contextColorDark = "rgba(69, 103, 255, 0.8)";
var $c24bb3319861fe36$var$$contextMenuRound = "5px";
var $c24bb3319861fe36$var$$width = 120;
var $c24bb3319861fe36$var$_templateObject$7;
var $c24bb3319861fe36$var$CommonStyle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject$7 || ($c24bb3319861fe36$var$_templateObject$7 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n  color: #fff;\n  padding: 4px;\n  border-bottom: 1px solid ",
    ";\n  background-color: ",
    ";\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  &:first-child {\n    border-top-left-radius: ",
    ";\n    border-top-right-radius: ",
    ";\n  }\n  &:last-child {\n    border-bottom-left-radius: ",
    ";\n    border-bottom-right-radius: ",
    ";\n  }\n  &:hover {\n    background-color: ",
    ";\n  }\n"
])), $c24bb3319861fe36$var$$contextColorDark, $c24bb3319861fe36$var$$contextColor, $c24bb3319861fe36$var$$contextMenuRound, $c24bb3319861fe36$var$$contextMenuRound, $c24bb3319861fe36$var$$contextMenuRound, $c24bb3319861fe36$var$$contextMenuRound, $c24bb3319861fe36$var$$contextColorLight);
var $c24bb3319861fe36$var$_templateObject$6, $c24bb3319861fe36$var$_templateObject2, $c24bb3319861fe36$var$_templateObject3;
var $c24bb3319861fe36$var$ItemStyle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($c24bb3319861fe36$var$CommonStyle)($c24bb3319861fe36$var$_templateObject$6 || ($c24bb3319861fe36$var$_templateObject$6 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    ",
    "\n"
])), function(props) {
    return props.hasSubitems && (0, $f8dbcd8598db1f0b$export$dbf350e5966cf602)($c24bb3319861fe36$var$_templateObject2 || ($c24bb3319861fe36$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
        "&:after {\n    content: '\u25BA';\n    position: absolute;\n    opacity: 0.6;\n    right: 5px;\n    top: 5px;\n    }"
    ])));
});
var $c24bb3319861fe36$var$SubitemStyles = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject3 || ($c24bb3319861fe36$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    position: absolute;\n    top: 0;\n    left: 100%;\n    width: ",
    "px;\n"
])), $c24bb3319861fe36$var$$width);
function $c24bb3319861fe36$var$ItemElement(props) {
    var _props$components, _props$components$ite, _props$components2, _props$components2$su;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_React$useState, 2), visibleSubitems = _React$useState2[0], setVisibleSubitems = _React$useState2[1];
    var setInvisibile = $acw62.useCallback(function() {
        return setVisibleSubitems(false);
    }, [
        setVisibleSubitems
    ]);
    var _useDebounce = $c24bb3319861fe36$var$useDebounce(setInvisibile, props.delay), _useDebounce2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useDebounce, 2), hide = _useDebounce2[0], cancelHide = _useDebounce2[1];
    var Component = ((_props$components = props.components) === null || _props$components === void 0 ? void 0 : (_props$components$ite = _props$components.item) === null || _props$components$ite === void 0 ? void 0 : _props$components$ite.call(_props$components, props.data)) || $c24bb3319861fe36$var$ItemStyle;
    var Subitems = ((_props$components2 = props.components) === null || _props$components2 === void 0 ? void 0 : (_props$components2$su = _props$components2.subitems) === null || _props$components2$su === void 0 ? void 0 : _props$components2$su.call(_props$components2, props.data)) || $c24bb3319861fe36$var$SubitemStyles;
    return /*#__PURE__*/ $acw62.createElement(Component, {
        onClick: function onClick(e) {
            e.stopPropagation();
            props.data.handler();
            props.hide();
        },
        hasSubitems: Boolean(props.data.subitems),
        onPointerDown: function onPointerDown(e) {
            return e.stopPropagation();
        },
        onPointerOver: function onPointerOver() {
            cancelHide();
            setVisibleSubitems(true);
        },
        onPointerLeave: function onPointerLeave() {
            return hide && hide();
        },
        "data-testid": "context-menu-item"
    }, props.children, props.data.subitems && visibleSubitems && /*#__PURE__*/ $acw62.createElement(Subitems, null, props.data.subitems.map(function(item) {
        return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$ItemElement, {
            key: item.key,
            data: item,
            delay: props.delay,
            hide: props.hide,
            components: props.components
        }, item.label);
    })));
}
var $c24bb3319861fe36$var$_templateObject$5;
var $c24bb3319861fe36$var$SearchInput = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).input($c24bb3319861fe36$var$_templateObject$5 || ($c24bb3319861fe36$var$_templateObject$5 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n  color: white;\n  padding: 1px 8px;\n  border: 1px solid white;\n  border-radius: 10px;\n  font-size: 16px;\n  font-family: serif;\n  width: 100%;\n  box-sizing: border-box;\n  background: transparent;\n"
])));
function $c24bb3319861fe36$var$Search(props) {
    var Component = props.component || $c24bb3319861fe36$var$SearchInput;
    return /*#__PURE__*/ $acw62.createElement(Component, {
        value: props.value,
        onInput: function onInput(e) {
            return props.onChange(e.target.value);
        },
        onPointerDown: function onPointerDown(e) {
            return e.stopPropagation();
        },
        "data-testid": "context-menu-search-input"
    });
}
var $c24bb3319861fe36$var$_templateObject$4;
var $c24bb3319861fe36$var$Styles$3 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject$4 || ($c24bb3319861fe36$var$_templateObject$4 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n  padding: 10px;\n  width: ",
    "px;\n  margin-top: -20px;\n  margin-left: -",
    "px;\n"
])), $c24bb3319861fe36$var$$width, $c24bb3319861fe36$var$$width / 2);
function $c24bb3319861fe36$var$Menu(props) {
    var _props$components, _props$components$mai, _props$components2, _props$components2$co, _props$components3, _props$components3$se;
    var _useDebounce = $c24bb3319861fe36$var$useDebounce(props.onHide, props.delay), _useDebounce2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useDebounce, 2), hide = _useDebounce2[0], cancelHide = _useDebounce2[1];
    var _React$useState = $acw62.useState(""), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_React$useState, 2), filter = _React$useState2[0], setFilter = _React$useState2[1];
    var filterRegexp = new RegExp(filter, "i");
    var filteredList = props.items.filter(function(item) {
        return item.label.match(filterRegexp);
    });
    var Component = ((_props$components = props.components) === null || _props$components === void 0 ? void 0 : (_props$components$mai = _props$components.main) === null || _props$components$mai === void 0 ? void 0 : _props$components$mai.call(_props$components)) || $c24bb3319861fe36$var$Styles$3;
    var Common = ((_props$components2 = props.components) === null || _props$components2 === void 0 ? void 0 : (_props$components2$co = _props$components2.common) === null || _props$components2$co === void 0 ? void 0 : _props$components2$co.call(_props$components2)) || $c24bb3319861fe36$var$CommonStyle;
    return /*#__PURE__*/ $acw62.createElement(Component, {
        onMouseOver: function onMouseOver() {
            return cancelHide();
        },
        onMouseLeave: function onMouseLeave() {
            return hide && hide();
        },
        onWheel: function onWheel(e) {
            return e.stopPropagation();
        },
        "data-testid": "context-menu"
    }, props.searchBar && /*#__PURE__*/ $acw62.createElement(Common, null, /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Search, {
        value: filter,
        onChange: setFilter,
        component: (_props$components3 = props.components) === null || _props$components3 === void 0 ? void 0 : (_props$components3$se = _props$components3.search) === null || _props$components3$se === void 0 ? void 0 : _props$components3$se.call(_props$components3)
    })), filteredList.map(function(item) {
        return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$ItemElement, {
            key: item.key,
            data: item,
            delay: props.delay,
            hide: props.onHide,
            components: props.components
        }, item.label);
    }));
}
/**
 * Preset for rendering context menu.
 */ function $c24bb3319861fe36$var$setup$2(props) {
    var delay = typeof (props === null || props === void 0 ? void 0 : props.delay) === "undefined" ? 1000 : props.delay;
    return {
        render: function render(context) {
            if (context.data.type === "contextmenu") return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Menu, {
                items: context.data.items,
                delay: delay,
                searchBar: context.data.searchBar,
                onHide: context.data.onHide,
                components: props === null || props === void 0 ? void 0 : props.customize
            });
        }
    };
}
var $c24bb3319861fe36$var$index$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setup: $c24bb3319861fe36$var$setup$2,
    Item: $c24bb3319861fe36$var$ItemStyle,
    Subitems: $c24bb3319861fe36$var$SubitemStyles,
    Menu: $c24bb3319861fe36$var$Styles$3,
    Search: $c24bb3319861fe36$var$SearchInput,
    Common: $c24bb3319861fe36$var$CommonStyle
});
function $c24bb3319861fe36$var$useElementSize() {
    const [ref, setRef] = (0, $acw62.useState)(null);
    const [size, setSize] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    const handleSize = (0, $acw62.useCallback)(()=>{
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    $c24bb3319861fe36$var$useEventListener("resize", handleSize);
    $c24bb3319861fe36$var$useIsomorphicLayoutEffect(()=>{
        handleSize();
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    return [
        setRef,
        size
    ];
}
function $c24bb3319861fe36$var$useEventListener(eventName, handler, element, options) {
    const savedHandler = (0, $acw62.useRef)(handler);
    $c24bb3319861fe36$var$useIsomorphicLayoutEffect(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
const $c24bb3319861fe36$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $c24bb3319861fe36$var$px(value) {
    return "".concat(value, "px");
}
var $c24bb3319861fe36$var$_templateObject$3;
var $c24bb3319861fe36$var$Styles$2 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject$3 || ($c24bb3319861fe36$var$_templateObject$3 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    position: absolute;\n    background: rgba(110, 136, 255, 0.8);\n    border: 1px solid rgb(192 206 212 / 60%);\n"
])));
function $c24bb3319861fe36$var$MiniNode(props) {
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Styles$2, {
        style: {
            left: $c24bb3319861fe36$var$px(props.left),
            top: $c24bb3319861fe36$var$px(props.top),
            width: $c24bb3319861fe36$var$px(props.width),
            height: $c24bb3319861fe36$var$px(props.height)
        },
        "data-testid": "minimap-node"
    });
}
var $c24bb3319861fe36$var$_templateObject$2;
var $c24bb3319861fe36$var$MiniViewportStyles = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject$2 || ($c24bb3319861fe36$var$_templateObject$2 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n  position: absolute;\n  background: rgba(255, 251, 128, 0.32);\n  border: 1px solid #ffe52b;\n"
])));
function $c24bb3319861fe36$var$MiniViewport(props) {
    var scale = function scale(v) {
        return v * props.containerWidth;
    };
    var invert = function invert(v) {
        return v / props.containerWidth;
    };
    var drag = $c24bb3319861fe36$var$useDrag(function(dx, dy) {
        return props.translate(invert(-dx), invert(-dy));
    }, function(e) {
        return {
            x: e.pageX,
            y: e.pageY
        };
    });
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$MiniViewportStyles, {
        onPointerDown: drag.start,
        style: {
            left: $c24bb3319861fe36$var$px(scale(props.left)),
            top: $c24bb3319861fe36$var$px(scale(props.top)),
            width: $c24bb3319861fe36$var$px(scale(props.width)),
            height: $c24bb3319861fe36$var$px(scale(props.height))
        },
        "data-testid": "minimap-viewport"
    });
}
var $c24bb3319861fe36$var$_templateObject$1;
var $c24bb3319861fe36$var$Styles$1 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject$1 || ($c24bb3319861fe36$var$_templateObject$1 = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n    position: absolute;\n    right: 24px;\n    bottom: 24px;\n    background: rgba(229, 234, 239, 0.65);\n    padding: 20px;\n    overflow: hidden;\n    border: 1px solid #b1b7ff;\n    border-radius: 8px;\n    box-sizing: border-box;\n"
])));
function $c24bb3319861fe36$var$Minimap(props) {
    var container = (0, $acw62.useRef)();
    var _useElementSize = $c24bb3319861fe36$var$useElementSize(), _useElementSize2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_useElementSize, 2), containerRef = _useElementSize2[0], containerWidth = _useElementSize2[1].width;
    var scale = function scale(v) {
        return v * containerWidth;
    };
    var ref = (0, $acw62.useCallback)(function(node) {
        container.current = node;
        containerRef(node);
    }, [
        containerRef
    ]);
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Styles$1, {
        size: props.size,
        style: {
            width: $c24bb3319861fe36$var$px(props.size * props.ratio),
            height: $c24bb3319861fe36$var$px(props.size)
        },
        onPointerDown: function onPointerDown(e) {
            e.stopPropagation();
            e.preventDefault();
        },
        onDoubleClick: function onDoubleClick(e) {
            e.stopPropagation();
            e.preventDefault();
            if (!container.current) return;
            var box = container.current.getBoundingClientRect();
            var x = (e.clientX - box.left) / (props.size * props.ratio);
            var y = (e.clientY - box.top) / (props.size * props.ratio);
            props.point(x, y);
        },
        ref: ref,
        "data-testid": "minimap"
    }, containerWidth && props.nodes.map(function(node, i) {
        return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$MiniNode, {
            key: i,
            left: scale(node.left),
            top: scale(node.top),
            width: scale(node.width),
            height: scale(node.height)
        });
    }), /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$MiniViewport, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, props.viewport, {
        start: props.start,
        containerWidth: containerWidth,
        translate: props.translate
    })));
}
/**
 * Preset for rendering minimap.
 */ function $c24bb3319861fe36$var$setup$1(props) {
    return {
        render: function render(context) {
            if (context.data.type === "minimap") return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Minimap, {
                nodes: context.data.nodes,
                size: (props === null || props === void 0 ? void 0 : props.size) || 200,
                ratio: context.data.ratio,
                viewport: context.data.viewport,
                start: context.data.start,
                translate: context.data.translate,
                point: context.data.point
            });
        }
    };
}
var $c24bb3319861fe36$var$index$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setup: $c24bb3319861fe36$var$setup$1
});
var $c24bb3319861fe36$var$_templateObject;
var $c24bb3319861fe36$var$pinSize = 20;
var $c24bb3319861fe36$var$Styles = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div($c24bb3319861fe36$var$_templateObject || ($c24bb3319861fe36$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($c4870074adc2be76$exports)))([
    "\n  width: ",
    "px;\n  height: ",
    "px;\n  box-sizing: border-box;\n  background: ",
    ";\n  border: 2px solid white;\n  border-radius: ",
    "px;\n"
])), $c24bb3319861fe36$var$pinSize, $c24bb3319861fe36$var$pinSize, function(props) {
    return props.selected ? "#ffd92c" : "steelblue";
}, $c24bb3319861fe36$var$pinSize);
function $c24bb3319861fe36$var$Pin(props) {
    var drag = $c24bb3319861fe36$var$useDrag(function(dx, dy) {
        return props.translate(dx, dy);
    }, props.pointer);
    var _props$position = props.position, x = _props$position.x, y = _props$position.y;
    return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Styles, {
        onPointerDown: function onPointerDown(e) {
            e.stopPropagation();
            e.preventDefault();
            drag.start(e);
            props.pointerdown();
        },
        onContextMenu: function onContextMenu(e) {
            e.stopPropagation();
            e.preventDefault();
            props.contextMenu();
        },
        selected: props.selected,
        style: {
            position: "absolute",
            top: "".concat(y - $c24bb3319861fe36$var$pinSize / 2, "px"),
            left: "".concat(x - $c24bb3319861fe36$var$pinSize / 2, "px")
        },
        "data-testid": "pin"
    });
}
/**
 * Preset for rendering pins.
 */ function $c24bb3319861fe36$var$setup(props) {
    function renderPins(data, pointer) {
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, data.pins.map(function(pin) {
            return /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Pin, (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({}, pin, {
                key: pin.id,
                contextMenu: function contextMenu() {
                    return (props === null || props === void 0 ? void 0 : props.contextMenu) && props.contextMenu(pin.id);
                },
                translate: function translate(dx, dy) {
                    return (props === null || props === void 0 ? void 0 : props.translate) && props.translate(pin.id, dx, dy);
                },
                pointerdown: function pointerdown() {
                    return (props === null || props === void 0 ? void 0 : props.pointerdown) && props.pointerdown(pin.id);
                },
                pointer: pointer
            }));
        }));
    }
    return {
        render: function render(context, plugin) {
            var data = context.data;
            var area = plugin.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
            if (data.type === "reroute-pins") return renderPins(data.data, function() {
                return area.area.pointer;
            });
        }
    };
}
var $c24bb3319861fe36$var$index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setup: $c24bb3319861fe36$var$setup
});
/**
 * Built-in presets, responsible for rendering different parts of the editor.
 * @module
 */ var $c24bb3319861fe36$export$7a05727743f7512 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    classic: $c24bb3319861fe36$var$index$4,
    contextMenu: $c24bb3319861fe36$var$index$3,
    minimap: $c24bb3319861fe36$var$index$2,
    reroute: $c24bb3319861fe36$var$index$1
});
function $c24bb3319861fe36$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c24bb3319861fe36$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c24bb3319861fe36$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c24bb3319861fe36$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c24bb3319861fe36$var$_arrayLikeToArray(o, minLen);
}
function $c24bb3319861fe36$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c24bb3319861fe36$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c24bb3319861fe36$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c24bb3319861fe36$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c24bb3319861fe36$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c24bb3319861fe36$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c24bb3319861fe36$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $c24bb3319861fe36$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Signals that can be emitted by the plugin
 * @priority 9
 */ /**
 * Plugin props
 */ /**
 * React plugin. Renders nodes, connections and other elements using React.
 * @priority 10
 * @emits connectionpath
 * @listens render
 * @listens unmount
 */ var $c24bb3319861fe36$export$eedcd19618da8709 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(ReactPlugin, _Scope);
    var _super = $c24bb3319861fe36$var$_createSuper(ReactPlugin);
    function ReactPlugin(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ReactPlugin);
        _this = _super.call(this, "react-render");
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "presets", []);
        _this.renderer = $c24bb3319861fe36$var$getRenderer({
            createRoot: props === null || props === void 0 ? void 0 : props.createRoot
        });
        _this.addPipe(function(context) {
            if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
            if (context.type === "unmount") _this.unmount(context.data.element);
            else if (context.type === "render") {
                if ("filled" in context.data && context.data.filled) return context;
                if (_this.mount(context.data.element, context)) return $c24bb3319861fe36$var$_objectSpread($c24bb3319861fe36$var$_objectSpread({}, context), {}, {
                    data: $c24bb3319861fe36$var$_objectSpread($c24bb3319861fe36$var$_objectSpread({}, context.data), {}, {
                        filled: true
                    })
                });
            }
            return context;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ReactPlugin, [
        {
            key: "setParent",
            value: function setParent(scope) {
                var _this2 = this;
                (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(ReactPlugin.prototype), "setParent", this).call(this, scope);
                this.presets.forEach(function(preset) {
                    if (preset.attach) preset.attach(_this2);
                });
            }
        },
        {
            key: "mount",
            value: function mount(element, context) {
                var parent = this.parentScope();
                var _iterator = $c24bb3319861fe36$var$_createForOfIteratorHelper(this.presets), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var preset = _step.value;
                        var result = preset.render(context, this);
                        if (!result) continue;
                        var reactElement = /*#__PURE__*/ $acw62.createElement($c24bb3319861fe36$var$Root, {
                            rendered: function rendered() {
                                return parent.emit({
                                    type: "rendered",
                                    data: context.data
                                });
                            }
                        }, result);
                        this.renderer.mount(reactElement, element);
                        return true;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "unmount",
            value: function unmount(element) {
                this.renderer.unmount(element);
            }
        },
        {
            key: "addPreset",
            value: function addPreset(preset) {
                var local = preset;
                if (local.attach) local.attach(this);
                this.presets.push(local);
            }
        }
    ]);
    return ReactPlugin;
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));


/*!
* rete-engine v2.0.0
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 











var $d6007c48accfcb1b$exports = {};


var $668a4079c2bb95d6$exports = {};
function $668a4079c2bb95d6$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
$668a4079c2bb95d6$exports = $668a4079c2bb95d6$var$_isNativeFunction, $668a4079c2bb95d6$exports.__esModule = true, $668a4079c2bb95d6$exports["default"] = $668a4079c2bb95d6$exports;


var $d46eee8acbe6979e$exports = {};
var $426f299ee58329c3$exports = {};
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports)();
}
$426f299ee58329c3$exports = $426f299ee58329c3$var$_isNativeReflectConstruct, $426f299ee58329c3$exports.__esModule = true, $426f299ee58329c3$exports["default"] = $426f299ee58329c3$exports;



function $d46eee8acbe6979e$var$_construct(t, e, r) {
    if ($426f299ee58329c3$exports()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $7b4ac2338b8e8f97$exports(p, r.prototype), p;
}
$d46eee8acbe6979e$exports = $d46eee8acbe6979e$var$_construct, $d46eee8acbe6979e$exports.__esModule = true, $d46eee8acbe6979e$exports["default"] = $d46eee8acbe6979e$exports;


function $d6007c48accfcb1b$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $d6007c48accfcb1b$exports = $d6007c48accfcb1b$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$668a4079c2bb95d6$exports(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $d46eee8acbe6979e$exports(t, arguments, $93d4339c80153a6a$exports(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $7b4ac2338b8e8f97$exports(Wrapper, t);
    }, $d6007c48accfcb1b$exports.__esModule = true, $d6007c48accfcb1b$exports["default"] = $d6007c48accfcb1b$exports, $d6007c48accfcb1b$var$_wrapNativeSuper(t);
}
$d6007c48accfcb1b$exports = $d6007c48accfcb1b$var$_wrapNativeSuper, $d6007c48accfcb1b$exports.__esModule = true, $d6007c48accfcb1b$exports["default"] = $d6007c48accfcb1b$exports;


/**
 * ControlFlowNodeSetup is a set of functions that define how to execute a node.
 */ /**
 * ControlFlow is a class that allows to execute nodes in a graph using Control flow approach.
 * @priority 7
 */ var $75215ef86aee3bc3$export$64ae1e3c20c2b2ed = /*#__PURE__*/ function() {
    /**
   * @param editor NodeEditor instance
   */ function ControlFlow(editor) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ControlFlow);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "setups", new Map());
        this.editor = editor;
    }
    /**
   * Adds the node to the control flow.
   * @param node Node instance
   * @param setup Set of functions that define how to execute the node
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ControlFlow, [
        {
            key: "add",
            value: function add(node, setup) {
                var affected = this.setups.get(node.id);
                if (affected) throw new Error("already processed");
                this.setups.set(node.id, setup);
            }
        },
        {
            key: "remove",
            value: function remove(nodeId) {
                this.setups["delete"](nodeId);
            }
        },
        {
            key: "execute",
            value: function execute(nodeId, input) {
                var _this = this;
                var setup = this.setups.get(nodeId);
                if (!setup) throw new Error("node is not initialized");
                var inputKeys = setup.inputs();
                if (input && !inputKeys.includes(input)) throw new Error("inputs don't have a key");
                setup.execute(input, function(output) {
                    var outputKeys = setup.outputs();
                    if (!outputKeys.includes(output)) throw new Error("outputs don't have a key");
                    var cons = _this.editor.getConnections().filter(function(c) {
                        return c.source === nodeId && c.sourceOutput === output;
                    });
                    cons.forEach(function(con) {
                        _this.execute(con.target, con.targetInput);
                    });
                });
            }
        }
    ]);
    return ControlFlow;
}();
function $75215ef86aee3bc3$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $75215ef86aee3bc3$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $75215ef86aee3bc3$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * ControlFlowEngine is a plugin that integrates ControlFlow with NodeEditor making it easy to use
 * @priority 9
 * @listens nodecreated
 * @listens noderemoved
 */ var $75215ef86aee3bc3$export$4e0a6d49fc7d28d2 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(ControlFlowEngine, _Scope);
    var _super = $75215ef86aee3bc3$var$_createSuper$2(ControlFlowEngine);
    /**
   * @param configure Allows to specify which inputs and outputs are part of the control flow
   */ function ControlFlowEngine(configure) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ControlFlowEngine);
        _this = _super.call(this, "control-flow-engine");
        _this.configure = configure;
        _this.addPipe(function(context) {
            if (context.type === "nodecreated") _this.add(context.data);
            if (context.type === "noderemoved") _this.remove(context.data);
            return context;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ControlFlowEngine, [
        {
            key: "setParent",
            value: function setParent(scope) {
                (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(ControlFlowEngine.prototype), "setParent", this).call(this, scope);
                this.editor = this.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
                this.controlflow = new $75215ef86aee3bc3$export$64ae1e3c20c2b2ed(this.editor);
            }
        },
        {
            key: "add",
            value: function add(node) {
                var options = this.configure ? this.configure(node) : {
                    inputs: function inputs() {
                        return Object.keys(node.inputs);
                    },
                    outputs: function outputs() {
                        return Object.keys(node.outputs);
                    }
                };
                this.controlflow.add(node, {
                    inputs: options.inputs,
                    outputs: options.outputs,
                    execute: function execute(input, forward) {
                        node.execute(String(input), forward);
                    }
                });
            }
        },
        {
            key: "remove",
            value: function remove(node) {
                this.controlflow.remove(node.id);
            }
        },
        {
            key: "execute",
            value: function execute(nodeId, input) {
                this.controlflow.execute(nodeId, input);
            }
        }
    ]);
    return ControlFlowEngine;
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));
function $75215ef86aee3bc3$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $75215ef86aee3bc3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $75215ef86aee3bc3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $75215ef86aee3bc3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $75215ef86aee3bc3$var$_arrayLikeToArray(o, minLen);
}
function $75215ef86aee3bc3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * DataflowNodeSetup is a set of functions that define how to process a node.
 */ /**
 * Dataflow is a class that allows to process nodes in a graph using Dataflow approach.
 * @priority 8
 */ var $75215ef86aee3bc3$export$65ce5b7ac5124288 = /*#__PURE__*/ function() {
    /**
   * @param editor NodeEditor instance
   */ function Dataflow(editor) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Dataflow);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "setups", new Map());
        this.editor = editor;
    }
    /**
   * Adds the node to the dataflow.
   * @param node Node instance
   * @param setup Set of functions that define how to process the node
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Dataflow, [
        {
            key: "add",
            value: function add(node, setup) {
                var affected = this.setups.get(node.id);
                if (affected) throw new Error("already processed");
                this.setups.set(node.id, setup);
            }
        },
        {
            key: "remove",
            value: function remove(nodeId) {
                this.setups["delete"](nodeId);
            }
        },
        {
            key: "fetchInputs",
            value: function() {
                var _fetchInputs = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(nodeId) {
                    var _this = this;
                    var result, inputKeys, cons, inputs, consWithSourceData, _iterator, _step, _step$value, c, sourceData, previous;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                result = this.setups.get(nodeId);
                                if (result) {
                                    _context2.next = 3;
                                    break;
                                }
                                throw new Error("node is not initialized");
                            case 3:
                                inputKeys = result.inputs();
                                cons = this.editor.getConnections().filter(function(c) {
                                    return c.target === nodeId && inputKeys.includes(c.targetInput);
                                });
                                inputs = {};
                                _context2.next = 8;
                                return Promise.all(cons.map(/*#__PURE__*/ function() {
                                    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(c) {
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                                            while(true)switch(_context.prev = _context.next){
                                                case 0:
                                                    _context.t0 = c;
                                                    _context.next = 3;
                                                    return _this.fetch(c.source);
                                                case 3:
                                                    _context.t1 = _context.sent;
                                                    return _context.abrupt("return", {
                                                        c: _context.t0,
                                                        sourceData: _context.t1
                                                    });
                                                case 5:
                                                case "end":
                                                    return _context.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(_x2) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()));
                            case 8:
                                consWithSourceData = _context2.sent;
                                _iterator = $75215ef86aee3bc3$var$_createForOfIteratorHelper(consWithSourceData);
                                try {
                                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                                        _step$value = _step.value, c = _step$value.c, sourceData = _step$value.sourceData;
                                        previous = inputs[c.targetInput] ? inputs[c.targetInput] : [];
                                        inputs[c.targetInput] = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(previous), [
                                            sourceData[c.sourceOutput]
                                        ]);
                                    }
                                } catch (err) {
                                    _iterator.e(err);
                                } finally{
                                    _iterator.f();
                                }
                                return _context2.abrupt("return", inputs);
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function fetchInputs(_x) {
                    return _fetchInputs.apply(this, arguments);
                }
                return fetchInputs;
            }()
        },
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(nodeId) {
                    var _this2 = this;
                    var result, outputKeys, data, returningKeys;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                result = this.setups.get(nodeId);
                                if (result) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new Error("node is not initialized");
                            case 3:
                                outputKeys = result.outputs();
                                _context3.next = 6;
                                return result.data(function() {
                                    return _this2.fetchInputs(nodeId);
                                });
                            case 6:
                                data = _context3.sent;
                                returningKeys = Object.keys(data);
                                if (outputKeys.every(function(key) {
                                    return returningKeys.includes(key);
                                })) {
                                    _context3.next = 10;
                                    break;
                                }
                                throw new Error('dataflow node "'.concat(nodeId, '" doesn\'t return all of required properties. Expected "').concat(outputKeys.join('", "'), '". Got "').concat(returningKeys.join('", "'), '"'));
                            case 10:
                                return _context3.abrupt("return", data);
                            case 11:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function fetch(_x3) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
    return Dataflow;
}();
var $75215ef86aee3bc3$var$Cache = /*#__PURE__*/ function() {
    function Cache(onDelete) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Cache);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "cache", new Map());
        this.onDelete = onDelete;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Cache, [
        {
            key: "get",
            value: function get(key) {
                return this.cache.get(key);
            }
        },
        {
            key: "add",
            value: function add(key, data) {
                if (this.cache.has(key)) throw new Error("cache already exists");
                this.cache.set(key, data);
            }
        },
        {
            key: "patch",
            value: function patch(key, data) {
                this.cache.set(key, data);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var item = this.cache.get(key);
                this.cache["delete"](key);
                this.onDelete && this.onDelete(item);
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                Array.from(this.cache.keys()).forEach(function(item) {
                    _this["delete"](item);
                });
            }
        }
    ]);
    return Cache;
}();
function $75215ef86aee3bc3$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $75215ef86aee3bc3$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $75215ef86aee3bc3$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Cancelled exception. Thrown when `reset` is called while fetching data.
 */ var $75215ef86aee3bc3$export$98c5edc703974274 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(Cancelled, _Error);
    var _super = $75215ef86aee3bc3$var$_createSuper$1(Cancelled);
    function Cancelled() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Cancelled);
        return _super.call(this, "cancelled");
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Cancelled);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($d6007c48accfcb1b$exports)))(Error));
function $75215ef86aee3bc3$export$2d8eebfce44a36ff() {
    var cancelled = false;
    function commit(value) {
        if (cancelled) throw new $75215ef86aee3bc3$export$98c5edc703974274();
        return value;
    }
    // eslint-disable-next-line init-declarations
    var reject;
    var promise = new Promise(function(res, rej) {
        reject = rej;
        res();
    });
    for(var _len = arguments.length, sequence = new Array(_len), _key = 0; _key < _len; _key++)sequence[_key] = arguments[_key];
    var n = sequence.reduce(function(p, item) {
        var t = p.then(item).then(commit);
        return t;
    }, promise);
    n.cancel = function() {
        if (!cancelled) reject(new $75215ef86aee3bc3$export$98c5edc703974274());
        cancelled = true;
    };
    return n;
}
function $75215ef86aee3bc3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $75215ef86aee3bc3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $75215ef86aee3bc3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * DataflowEngine is a plugin that integrates Dataflow with NodeEditor making it easy to use.
 * Additionally, it provides a cache for the data of each node in order to avoid recurring calculations.
 * @priority 10
 * @listens nodecreated
 * @listens noderemoved
 */ var $75215ef86aee3bc3$export$aff6fc27706caf24 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(DataflowEngine, _Scope);
    var _super = $75215ef86aee3bc3$var$_createSuper(DataflowEngine);
    function DataflowEngine(configure) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, DataflowEngine);
        _this = _super.call(this, "dataflow-engine");
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "cache", new $75215ef86aee3bc3$var$Cache(function(data) {
            return (data === null || data === void 0 ? void 0 : data.cancel) && data.cancel();
        }));
        _this.configure = configure;
        _this.addPipe(function(context) {
            if (context.type === "nodecreated") _this.add(context.data);
            if (context.type === "noderemoved") _this.remove(context.data);
            return context;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(DataflowEngine, [
        {
            key: "setParent",
            value: function setParent(scope) {
                (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(DataflowEngine.prototype), "setParent", this).call(this, scope);
                this.editor = this.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
                this.dataflow = new $75215ef86aee3bc3$export$65ce5b7ac5124288(this.editor);
            }
        },
        {
            key: "getDataflow",
            value: function getDataflow() {
                if (!this.dataflow) throw new Error("DataflowEngine isn't attached to NodeEditor");
                return this.dataflow;
            }
        },
        {
            key: "add",
            value: function add(node) {
                var _this2 = this;
                var options = this.configure ? this.configure(node) : {
                    inputs: function inputs() {
                        return Object.keys(node.inputs);
                    },
                    outputs: function outputs() {
                        return Object.keys(node.outputs);
                    }
                };
                this.getDataflow().add(node, {
                    inputs: options.inputs,
                    outputs: options.outputs,
                    data: function() {
                        var _data = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(fetchInputs) {
                            var cache, cancellable;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        cache = _this2.cache.get(node.id);
                                        if (!cache) {
                                            _context.next = 3;
                                            break;
                                        }
                                        return _context.abrupt("return", cache);
                                    case 3:
                                        cancellable = $75215ef86aee3bc3$export$2d8eebfce44a36ff(function() {
                                            return fetchInputs();
                                        }, function(inputs) {
                                            return node.data(inputs);
                                        });
                                        _this2.cache.add(node.id, cancellable);
                                        return _context.abrupt("return", cancellable);
                                    case 6:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        function data(_x) {
                            return _data.apply(this, arguments);
                        }
                        return data;
                    }()
                });
            }
        },
        {
            key: "remove",
            value: function remove(node) {
                this.getDataflow().remove(node.id);
            }
        },
        {
            key: "reset",
            value: function reset(nodeId) {
                var _this3 = this;
                if (nodeId) {
                    var setup = this.getDataflow().setups.get(nodeId);
                    if (!setup) throw "setup";
                    var outputKeys = setup.outputs();
                    this.cache["delete"](nodeId);
                    this.editor.getConnections().filter(function(c) {
                        return c.source === nodeId && outputKeys.includes(c.sourceOutput);
                    }).forEach(function(c) {
                        return _this3.reset(c.target);
                    });
                } else this.cache.clear();
            }
        },
        {
            key: "fetchInputs",
            value: function() {
                var _fetchInputs = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(nodeId) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.getDataflow().fetchInputs(nodeId));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function fetchInputs(_x2) {
                    return _fetchInputs.apply(this, arguments);
                }
                return fetchInputs;
            }()
        },
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(nodeId) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.getDataflow().fetch(nodeId));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function fetch(_x3) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
    return DataflowEngine;
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));


/*!
* rete-context-menu-plugin v2.0.2
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 
var $41YNz = parcelRequire("41YNz");













function $6e1ed5df05ca2a7f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6e1ed5df05ca2a7f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6e1ed5df05ca2a7f$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6e1ed5df05ca2a7f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6e1ed5df05ca2a7f$var$createItem(_ref, key, context) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref, 2), label = _ref2[0], factory = _ref2[1];
    var item = {
        label: label,
        key: String(key)
    };
    if (typeof factory === "function") return $6e1ed5df05ca2a7f$var$_objectSpread($6e1ed5df05ca2a7f$var$_objectSpread({}, item), {}, {
        handler: function handler() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee() {
                var node;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            _context.next = 2;
                            return factory();
                        case 2:
                            node = _context.sent;
                            _context.next = 5;
                            return context.editor.addNode(node);
                        case 5:
                            context.area.translate(node.id, context.area.area.pointer);
                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }))();
        }
    });
    return $6e1ed5df05ca2a7f$var$_objectSpread($6e1ed5df05ca2a7f$var$_objectSpread({}, item), {}, {
        handler: function handler() {},
        subitems: factory.map(function(data, i) {
            return $6e1ed5df05ca2a7f$var$createItem(data, i, context);
        })
    });
}
function $6e1ed5df05ca2a7f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $6e1ed5df05ca2a7f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $6e1ed5df05ca2a7f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6e1ed5df05ca2a7f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6e1ed5df05ca2a7f$var$_arrayLikeToArray(o, minLen);
}
function $6e1ed5df05ca2a7f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Classic context menu preset.
 * Configures nodes/actions items for root and Delete/Clone items for nodes
 * @param nodes List of items
 * @example Presets.classic.setup([
  ["Math", [
    ["Number", () => new NumberNode()],
  ]]
])
 */ function $6e1ed5df05ca2a7f$var$setup(nodes) {
    return function(context, plugin) {
        var area = plugin.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
        var editor = area.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
        if (context === "root") return {
            searchBar: true,
            list: nodes.map(function(item, i) {
                return $6e1ed5df05ca2a7f$var$createItem(item, i, {
                    editor: editor,
                    area: area
                });
            })
        };
        var deleteItem = {
            label: "Delete",
            key: "delete",
            handler: function handler() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee() {
                    var connectionId, nodeId, connections, _iterator, _step, connection;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!("source" in context && "target" in context)) {
                                    _context.next = 6;
                                    break;
                                }
                                // connection
                                connectionId = context.id;
                                _context.next = 4;
                                return editor.removeConnection(connectionId);
                            case 4:
                                _context.next = 27;
                                break;
                            case 6:
                                // node
                                nodeId = context.id;
                                connections = editor.getConnections().filter(function(c) {
                                    return c.source === nodeId || c.target === nodeId;
                                });
                                _iterator = $6e1ed5df05ca2a7f$var$_createForOfIteratorHelper(connections);
                                _context.prev = 9;
                                _iterator.s();
                            case 11:
                                if ((_step = _iterator.n()).done) {
                                    _context.next = 17;
                                    break;
                                }
                                connection = _step.value;
                                _context.next = 15;
                                return editor.removeConnection(connection.id);
                            case 15:
                                _context.next = 11;
                                break;
                            case 17:
                                _context.next = 22;
                                break;
                            case 19:
                                _context.prev = 19;
                                _context.t0 = _context["catch"](9);
                                _iterator.e(_context.t0);
                            case 22:
                                _context.prev = 22;
                                _iterator.f();
                                return _context.finish(22);
                            case 25:
                                _context.next = 27;
                                return editor.removeNode(nodeId);
                            case 27:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            9,
                            19,
                            22,
                            25
                        ]
                    ]);
                }))();
            }
        };
        var clone = context.clone;
        var cloneItem = clone && {
            label: "Clone",
            key: "clone",
            handler: function handler() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2() {
                    var node;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                node = clone();
                                _context2.next = 3;
                                return editor.addNode(node);
                            case 3:
                                area.translate(node.id, area.area.pointer);
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }))();
            }
        };
        return {
            searchBar: false,
            list: [
                deleteItem
            ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(cloneItem ? [
                cloneItem
            ] : []))
        };
    };
}
var $6e1ed5df05ca2a7f$var$index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setup: $6e1ed5df05ca2a7f$var$setup
});
/**
 * Presets that create items for root and node specific context menu.
 * @module
*/ var $6e1ed5df05ca2a7f$export$7a05727743f7512 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    classic: $6e1ed5df05ca2a7f$var$index$1
});
function $6e1ed5df05ca2a7f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6e1ed5df05ca2a7f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $6e1ed5df05ca2a7f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Context menu plugin props
 * @priority 8
 */ /**
 * Signal types produced by ContextMenuPlugin instance
 * @priority 10
 */ /**
 * Plugin for context menu.
 * Responsible for initialing rendering of context menu with predefined items.
 * @priority 9
 * @emits render
 * @emits unmount
 * @listens unmount
 * @listens contextmenu
 * @listens pointerdown
 */ var $6e1ed5df05ca2a7f$export$24cca5f57f539b23 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(ContextMenuPlugin, _Scope);
    var _super = $6e1ed5df05ca2a7f$var$_createSuper(ContextMenuPlugin);
    /**
   * @param props Properties
   */ function ContextMenuPlugin(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, ContextMenuPlugin);
        _this = _super.call(this, "context-menu");
        _this.props = props;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(ContextMenuPlugin, [
        {
            key: "setParent",
            value: function setParent(scope) {
                var _this2 = this;
                (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(ContextMenuPlugin.prototype), "setParent", this).call(this, scope);
                var area = this.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
                var container = area.container;
                if (!container || !(container instanceof HTMLElement)) throw new Error("container expected");
                var element = document.createElement("div");
                element.style.display = "none";
                element.style.position = "fixed";
                // eslint-disable-next-line max-statements
                this.addPipe(function(context) {
                    var parent = _this2.parentScope();
                    if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
                    if (context.type === "unmount") {
                        if (context.data.element === element) element.style.display = "none";
                    } else if (context.type === "contextmenu") {
                        context.data.event.preventDefault();
                        context.data.event.stopPropagation();
                        var _this2$props$items = _this2.props.items(context.data.context, _this2), searchBar = _this2$props$items.searchBar, list = _this2$props$items.list;
                        container.appendChild(element);
                        element.style.left = "".concat(context.data.event.clientX, "px");
                        element.style.top = "".concat(context.data.event.clientY, "px");
                        element.style.display = "";
                        parent.emit({
                            type: "render",
                            data: {
                                type: "contextmenu",
                                element: element,
                                searchBar: searchBar,
                                onHide: function onHide() {
                                    parent.emit({
                                        type: "unmount",
                                        data: {
                                            element: element
                                        }
                                    });
                                },
                                items: list
                            }
                        });
                    } else if (context.type === "pointerdown") {
                        if (!context.data.event.composedPath().includes(element)) parent.emit({
                            type: "unmount",
                            data: {
                                element: element
                            }
                        });
                    }
                    return context;
                });
            }
        }
    ]);
    return ContextMenuPlugin;
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));


/*!
* rete-history-plugin v2.0.0
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 













var $41YNz = parcelRequire("41YNz");
var $affa0368cf6b1581$var$History = /*#__PURE__*/ function() {
    function History(_ref) {
        var limit = _ref.limit;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, History);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "produced", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "reserved", []);
        if (limit && typeof limit === "number") this.limit = limit;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(History, [
        {
            key: "add",
            value: function add(action) {
                if (this.active) return;
                this.produced.push({
                    time: Date.now(),
                    action: action
                });
                if (this.limit && this.produced.length > this.limit) this.produced.shift();
                this.reserved = [];
            }
        },
        {
            key: "getRecent",
            value: function getRecent(ms) {
                var now = Date.now();
                var treshold = now - ms;
                var list = [];
                for(var i = this.produced.length - 1; i >= 0; i--){
                    var action = this.produced[i];
                    if (action.time <= treshold) break;
                    if (action.separated) break;
                    list.push(action);
                }
                return list;
            }
        },
        {
            key: "move",
            value: function() {
                var _move = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(from, to, type) {
                    var record;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                record = from.pop();
                                if (record) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 3:
                                this.active = true;
                                _context.next = 6;
                                return record.action[type]();
                            case 6:
                                to.push(record);
                                this.active = false;
                                return _context.abrupt("return", record);
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function move(_x, _x2, _x3) {
                    return _move.apply(this, arguments);
                }
                return move;
            }()
        },
        {
            key: "undo",
            value: function() {
                var _undo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.move(this.produced, this.reserved, "undo");
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function undo() {
                    return _undo.apply(this, arguments);
                }
                return undo;
            }()
        },
        {
            key: "clear",
            value: function clear() {
                this.active = false;
                this.produced = [];
                this.reserved = [];
            }
        },
        {
            key: "redo",
            value: function() {
                var _redo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return this.move(this.reserved, this.produced, "redo");
                            case 2:
                                return _context3.abrupt("return", _context3.sent);
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function redo() {
                    return _redo.apply(this, arguments);
                }
                return redo;
            }()
        }
    ]);
    return History;
}();
/**
 * Adds keyboard shortcuts for history undo/redo
 * @param plugin History plugin instance
 */ function $affa0368cf6b1581$var$keyboard(plugin) {
    document.addEventListener("keydown", function(e) {
        if (!e.ctrlKey && !e.metaKey) return;
        /* eslint-disable indent */ switch(e.code){
            case "KeyZ":
                plugin.undo();
                break;
            case "KeyY":
                plugin.redo();
                break;
        }
    });
}
/**
 * History plugin extensions
 * @module
 */ var $affa0368cf6b1581$export$cd56b8fc3849761f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    keyboard: $affa0368cf6b1581$var$keyboard
});
var $affa0368cf6b1581$var$AddConnectionAction = /*#__PURE__*/ function() {
    function AddConnectionAction(editor, connection) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, AddConnectionAction);
        this.editor = editor;
        this.connection = connection;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(AddConnectionAction, [
        {
            key: "undo",
            value: function() {
                var _undo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.editor.removeConnection(this.connection.id);
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function undo() {
                    return _undo.apply(this, arguments);
                }
                return undo;
            }()
        },
        {
            key: "redo",
            value: function() {
                var _redo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.editor.addConnection(this.connection);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function redo() {
                    return _redo.apply(this, arguments);
                }
                return redo;
            }()
        }
    ]);
    return AddConnectionAction;
}();
var $affa0368cf6b1581$var$RemoveConnectionAction = /*#__PURE__*/ function() {
    function RemoveConnectionAction(editor, connection) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, RemoveConnectionAction);
        this.editor = editor;
        this.connection = connection;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(RemoveConnectionAction, [
        {
            key: "undo",
            value: function() {
                var _undo2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return this.editor.addConnection(this.connection);
                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function undo() {
                    return _undo2.apply(this, arguments);
                }
                return undo;
            }()
        },
        {
            key: "redo",
            value: function() {
                var _redo2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee4() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return this.editor.removeConnection(this.connection.id);
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function redo() {
                    return _redo2.apply(this, arguments);
                }
                return redo;
            }()
        }
    ]);
    return RemoveConnectionAction;
}();
function $affa0368cf6b1581$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $affa0368cf6b1581$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $affa0368cf6b1581$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $affa0368cf6b1581$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $affa0368cf6b1581$var$AddNodeAction = /*#__PURE__*/ function() {
    function AddNodeAction(editor, area, nodeId) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, AddNodeAction);
        this.editor = editor;
        this.area = area;
        this.nodeId = nodeId;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(AddNodeAction, [
        {
            key: "undo",
            value: function() {
                var _undo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee() {
                    var _this$area$nodeViews$;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                this.node = this.editor.getNode(this.nodeId);
                                this.position = (_this$area$nodeViews$ = this.area.nodeViews.get(this.nodeId)) === null || _this$area$nodeViews$ === void 0 ? void 0 : _this$area$nodeViews$.position;
                                _context.next = 4;
                                return this.editor.removeNode(this.nodeId);
                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function undo() {
                    return _undo.apply(this, arguments);
                }
                return undo;
            }()
        },
        {
            key: "redo",
            value: function() {
                var _redo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (!this.node) {
                                    _context2.next = 3;
                                    break;
                                }
                                _context2.next = 3;
                                return this.editor.addNode(this.node);
                            case 3:
                                if (!(this.node && this.position)) {
                                    _context2.next = 6;
                                    break;
                                }
                                _context2.next = 6;
                                return this.area.translate(this.node.id, this.position);
                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function redo() {
                    return _redo.apply(this, arguments);
                }
                return redo;
            }()
        }
    ]);
    return AddNodeAction;
}();
var $affa0368cf6b1581$var$RemoveNodeAction = /*#__PURE__*/ function() {
    function RemoveNodeAction(editor, area, node, position) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, RemoveNodeAction);
        this.editor = editor;
        this.area = area;
        this.node = node;
        this.position = position;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(RemoveNodeAction, [
        {
            key: "undo",
            value: function() {
                var _undo2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return this.editor.addNode(this.node);
                            case 2:
                                _context3.next = 4;
                                return this.area.translate(this.node.id, this.position);
                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function undo() {
                    return _undo2.apply(this, arguments);
                }
                return undo;
            }()
        },
        {
            key: "redo",
            value: function() {
                var _redo2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee4() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return this.editor.removeNode(this.node.id);
                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function redo() {
                    return _redo2.apply(this, arguments);
                }
                return redo;
            }()
        }
    ]);
    return RemoveNodeAction;
}();
var $affa0368cf6b1581$var$DragNodeAction = /*#__PURE__*/ function() {
    function DragNodeAction(area, nodeId, prev) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, DragNodeAction);
        this.area = area;
        this.nodeId = nodeId;
        var view = area.nodeViews.get(nodeId);
        if (!view) return;
        this.prev = $affa0368cf6b1581$var$_objectSpread({}, prev);
        this["new"] = $affa0368cf6b1581$var$_objectSpread({}, view.position);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(DragNodeAction, [
        {
            key: "translate",
            value: function() {
                var _translate = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee5(position) {
                    var view;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                view = this.area.nodeViews.get(this.nodeId);
                                if (view) {
                                    _context5.next = 3;
                                    break;
                                }
                                return _context5.abrupt("return");
                            case 3:
                                _context5.next = 5;
                                return view.translate(position.x, position.y);
                            case 5:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function translate(_x) {
                    return _translate.apply(this, arguments);
                }
                return translate;
            }()
        },
        {
            key: "undo",
            value: function() {
                var _undo3 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                _context6.next = 2;
                                return this.translate(this.prev);
                            case 2:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function undo() {
                    return _undo3.apply(this, arguments);
                }
                return undo;
            }()
        },
        {
            key: "redo",
            value: function() {
                var _redo3 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.translate(this["new"]);
                            case 2:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function redo() {
                    return _redo3.apply(this, arguments);
                }
                return redo;
            }()
        }
    ]);
    return DragNodeAction;
}();
function $affa0368cf6b1581$var$trackNodes(history, props) {
    var nodes = new Map();
    var positions = new Map();
    var area = history.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
    var editor = area.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
    var timing = props.timing;
    // eslint-disable-next-line max-statements
    editor.addPipe(function(context) {
        if (context.type === "nodecreated") {
            var id = context.data.id;
            history.add(new $affa0368cf6b1581$var$AddNodeAction(editor, area, id));
            nodes.set(id, editor.getNode(context.data.id));
        }
        if (context.type === "noderemoved") {
            var _id = context.data.id;
            var node = nodes.get(_id);
            var position = positions.get(_id);
            if (!node) throw new Error("node");
            if (!position) throw new Error("position" + _id);
            history.add(new $affa0368cf6b1581$var$RemoveNodeAction(editor, area, node, position));
            positions["delete"](_id);
            nodes["delete"](_id);
        }
        return context;
    });
    area.addPipe(function(context) {
        if (!("type" in context)) return context;
        if (context.type === "nodetranslated") {
            var _context$data = context.data, id = _context$data.id, position = _context$data.position;
            positions.set(id, position);
        }
        return context;
    });
    var picked = [];
    // eslint-disable-next-line max-statements
    area.addPipe(function(context) {
        if (!context || (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(context) !== "object" || !("type" in context)) return context;
        if (context.type === "nodepicked") picked.push(context.data.id);
        if (context.type === "nodedragged") {
            var index = picked.indexOf(context.data.id);
            if (index >= 0) picked.splice(index, 1);
        }
        if (context.type === "nodetranslated") {
            var _context$data2 = context.data, id = _context$data2.id, position = _context$data2.position, previous = _context$data2.previous;
            var recent = history.getRecent(timing).filter(function(n) {
                return n.action instanceof $affa0368cf6b1581$var$DragNodeAction;
            }).filter(function(n) {
                return n.action.nodeId === id;
            });
            if (recent.length > 1) throw new Error("> 1");
            if (recent[0]) {
                recent[0].action["new"] = position;
                recent[0].time = Date.now();
            } else history.add(new $affa0368cf6b1581$var$DragNodeAction(area, id, previous));
        }
        return context;
    });
}
function $affa0368cf6b1581$var$trackConnections(history) {
    var connections = new Map();
    var editor = history.parentScope().parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
    editor.addPipe(function(context) {
        if (context.type === "connectioncreated") {
            var connection = editor.getConnection(context.data.id);
            history.add(new $affa0368cf6b1581$var$AddConnectionAction(editor, connection));
            connections.set(context.data.id, connection);
        }
        if (context.type === "connectionremoved") {
            var _connection = connections.get(context.data.id);
            if (_connection) history.add(new $affa0368cf6b1581$var$RemoveConnectionAction(editor, _connection));
        }
        return context;
    });
}
/**
 * Classic preset for the history plugin. Tracks node adding/removing/translating, connection adding/removing.
 */ function $affa0368cf6b1581$var$setup(props) {
    return {
        connect: function connect(history) {
            var _props$timing;
            var timing = (_props$timing = props === null || props === void 0 ? void 0 : props.timing) !== null && _props$timing !== void 0 ? _props$timing : history.timing * 2;
            $affa0368cf6b1581$var$trackNodes(history, {
                timing: timing
            });
            $affa0368cf6b1581$var$trackConnections(history);
        }
    };
}
var $affa0368cf6b1581$var$index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setup: $affa0368cf6b1581$var$setup
});
/**
 * Presets for the history plugin
 * @module
 */ var $affa0368cf6b1581$export$7a05727743f7512 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    classic: $affa0368cf6b1581$var$index$1
});
function $affa0368cf6b1581$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $affa0368cf6b1581$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $affa0368cf6b1581$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * History plugin. Allows to undo/redo actions such as adding/removing nodes, connections, etc.
 */ var $affa0368cf6b1581$export$71f666dd3362399 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(HistoryPlugin, _Scope);
    var _super = $affa0368cf6b1581$var$_createSuper(HistoryPlugin);
    /**
   * @constructor
   * @param props History plugin properties
   * @param props.timing Time in ms between actions to be considered as one action
   */ function HistoryPlugin(props) {
        var _props$timing;
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, HistoryPlugin);
        _this = _super.call(this, "history");
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "history", new $affa0368cf6b1581$var$History({}));
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "presets", []);
        _this.timing = (_props$timing = props === null || props === void 0 ? void 0 : props.timing) !== null && _props$timing !== void 0 ? _props$timing : 200;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(HistoryPlugin, [
        {
            key: "setParent",
            value: function setParent(scope) {
                var _this2 = this;
                (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(HistoryPlugin.prototype), "setParent", this).call(this, scope);
                this.area = this.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
                this.editor = this.area.parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
                this.presets.forEach(function(preset) {
                    return preset.connect(_this2);
                });
                this.editor.addPipe(function(context) {
                    if (context.type === "cleared") _this2.history.clear();
                    return context;
                });
            }
        },
        {
            key: "addPreset",
            value: function addPreset(preset) {
                this.presets.push(preset);
                if (this.area && this.editor) preset.connect(this);
            }
        },
        {
            key: "add",
            value: function add(action) {
                this.history.add(action);
            }
        },
        {
            key: "getHistorySnapshot",
            value: function getHistorySnapshot() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(this.history.produced);
            }
        },
        {
            key: "getRecent",
            value: function getRecent(ms) {
                return this.history.getRecent(ms);
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.history.clear();
            }
        },
        {
            key: "separate",
            value: function separate() {
                var latest = this.history.produced[this.history.produced.length - 1];
                if (latest) latest.separated = true;
            }
        },
        {
            key: "undo",
            value: function() {
                var _undo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee() {
                    var record, latest;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.history.undo();
                            case 2:
                                record = _context.sent;
                                if (!record) {
                                    _context.next = 8;
                                    break;
                                }
                                latest = this.history.produced[this.history.produced.length - 1];
                                if (!(latest && !latest.separated && latest.time + this.timing > record.time)) {
                                    _context.next = 8;
                                    break;
                                }
                                _context.next = 8;
                                return this.undo();
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function undo() {
                    return _undo.apply(this, arguments);
                }
                return undo;
            }()
        },
        {
            key: "redo",
            value: function() {
                var _redo = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2() {
                    var record, latest;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.history.redo();
                            case 2:
                                record = _context2.sent;
                                if (!record) {
                                    _context2.next = 8;
                                    break;
                                }
                                latest = this.history.reserved[this.history.reserved.length - 1];
                                if (!(latest && !record.separated && record.time + this.timing > latest.time)) {
                                    _context2.next = 8;
                                    break;
                                }
                                _context2.next = 8;
                                return this.redo();
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function redo() {
                    return _redo.apply(this, arguments);
                }
                return redo;
            }()
        }
    ]);
    return HistoryPlugin;
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));


/*!
* rete-auto-arrange-plugin v2.0.0
* (c) 2024 Vitaliy Stoliarov
* Released under the MIT license.
* */ 










var $580dcbcb2cc739f7$exports = {};
"use strict";
function $580dcbcb2cc739f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $580dcbcb2cc739f7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $580dcbcb2cc739f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $18f2920ea9eca088$exports = {};
(function(f) {
    var g;
    $18f2920ea9eca088$exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function r(e, n, t) {
            function o(i, f) {
                if (!n[i]) {
                    if (!e[i]) {
                        var c = undefined;
                        if (!f && c) return c(i, !0);
                        if (u) return u(i, !0);
                        var a = new Error("Cannot find module '" + i + "'");
                        throw a.code = "MODULE_NOT_FOUND", a;
                    }
                    var p = n[i] = {
                        exports: {}
                    };
                    e[i][0].call(p.exports, function(r) {
                        var n = e[i][1][r];
                        return o(n || r);
                    }, p, p.exports, r, e, n, t);
                }
                return n[i].exports;
            }
            for(var u = undefined, i = 0; i < t.length; i++)o(t[i]);
            return o;
        }
        return r;
    })()({
        1: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _createClass = function() {
                    function defineProperties(target, props) {
                        for(var i = 0; i < props.length; i++){
                            var descriptor = props[i];
                            descriptor.enumerable = descriptor.enumerable || false;
                            descriptor.configurable = true;
                            if ("value" in descriptor) descriptor.writable = true;
                            Object.defineProperty(target, descriptor.key, descriptor);
                        }
                    }
                    return function(Constructor, protoProps, staticProps) {
                        if (protoProps) defineProperties(Constructor.prototype, protoProps);
                        if (staticProps) defineProperties(Constructor, staticProps);
                        return Constructor;
                    };
                }();
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                /*******************************************************************************
 * Copyright (c) 2017 Kiel University and others.
 * 
 * This program and the accompanying materials are made 
 * available under the terms of the Eclipse Public License 2.0 
 * which is available at https://www.eclipse.org/legal/epl-2.0/ 
 * 
 * SPDX-License-Identifier: EPL-2.0
 *******************************************************************************/ var ELK = function() {
                    function ELK() {
                        var _this = this;
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$defaultLayoutOpt = _ref.defaultLayoutOptions, defaultLayoutOptions = _ref$defaultLayoutOpt === undefined ? {} : _ref$defaultLayoutOpt, _ref$algorithms = _ref.algorithms, algorithms = _ref$algorithms === undefined ? [
                            "layered",
                            "stress",
                            "mrtree",
                            "radial",
                            "force",
                            "disco",
                            "sporeOverlap",
                            "sporeCompaction",
                            "rectpacking"
                        ] : _ref$algorithms, workerFactory = _ref.workerFactory, workerUrl = _ref.workerUrl;
                        _classCallCheck(this, ELK);
                        this.defaultLayoutOptions = defaultLayoutOptions;
                        this.initialized = false;
                        // check valid worker construction possible
                        if (typeof workerUrl === "undefined" && typeof workerFactory === "undefined") throw new Error("Cannot construct an ELK without both 'workerUrl' and 'workerFactory'.");
                        var factory = workerFactory;
                        if (typeof workerUrl !== "undefined" && typeof workerFactory === "undefined") // use default Web Worker
                        factory = function factory(url) {
                            return new Worker(url);
                        };
                        // create the worker
                        var worker = factory(workerUrl);
                        if (typeof worker.postMessage !== "function") throw new TypeError("Created worker does not provide the required 'postMessage' function.");
                        // wrap the worker to return promises
                        this.worker = new PromisedWorker(worker);
                        // initially register algorithms
                        this.worker.postMessage({
                            cmd: "register",
                            algorithms: algorithms
                        }).then(function(r) {
                            return _this.initialized = true;
                        }).catch(console.err);
                    }
                    _createClass(ELK, [
                        {
                            key: "layout",
                            value: function layout(graph) {
                                var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$layoutOptions = _ref2.layoutOptions, layoutOptions = _ref2$layoutOptions === undefined ? this.defaultLayoutOptions : _ref2$layoutOptions, _ref2$logging = _ref2.logging, logging = _ref2$logging === undefined ? false : _ref2$logging, _ref2$measureExecutio = _ref2.measureExecutionTime, measureExecutionTime = _ref2$measureExecutio === undefined ? false : _ref2$measureExecutio;
                                if (!graph) return Promise.reject(new Error("Missing mandatory parameter 'graph'."));
                                return this.worker.postMessage({
                                    cmd: "layout",
                                    graph: graph,
                                    layoutOptions: layoutOptions,
                                    options: {
                                        logging: logging,
                                        measureExecutionTime: measureExecutionTime
                                    }
                                });
                            }
                        },
                        {
                            key: "knownLayoutAlgorithms",
                            value: function knownLayoutAlgorithms() {
                                return this.worker.postMessage({
                                    cmd: "algorithms"
                                });
                            }
                        },
                        {
                            key: "knownLayoutOptions",
                            value: function knownLayoutOptions() {
                                return this.worker.postMessage({
                                    cmd: "options"
                                });
                            }
                        },
                        {
                            key: "knownLayoutCategories",
                            value: function knownLayoutCategories() {
                                return this.worker.postMessage({
                                    cmd: "categories"
                                });
                            }
                        },
                        {
                            key: "terminateWorker",
                            value: function terminateWorker() {
                                this.worker.terminate();
                            }
                        }
                    ]);
                    return ELK;
                }();
                exports.default = ELK;
                var PromisedWorker = function() {
                    function PromisedWorker(worker) {
                        var _this2 = this;
                        _classCallCheck(this, PromisedWorker);
                        if (worker === undefined) throw new Error("Missing mandatory parameter 'worker'.");
                        this.resolvers = {};
                        this.worker = worker;
                        this.worker.onmessage = function(answer) {
                            // why is this necessary?
                            setTimeout(function() {
                                _this2.receive(_this2, answer);
                            }, 0);
                        };
                    }
                    _createClass(PromisedWorker, [
                        {
                            key: "postMessage",
                            value: function postMessage(msg) {
                                var id = this.id || 0;
                                this.id = id + 1;
                                msg.id = id;
                                var self = this;
                                return new Promise(function(resolve, reject) {
                                    // prepare the resolver
                                    self.resolvers[id] = function(err, res) {
                                        if (err) {
                                            self.convertGwtStyleError(err);
                                            reject(err);
                                        } else resolve(res);
                                    };
                                    // post the message
                                    self.worker.postMessage(msg);
                                });
                            }
                        },
                        {
                            key: "receive",
                            value: function receive(self, answer) {
                                var json = answer.data;
                                var resolver = self.resolvers[json.id];
                                if (resolver) {
                                    delete self.resolvers[json.id];
                                    if (json.error) resolver(json.error);
                                    else resolver(null, json.data);
                                }
                            }
                        },
                        {
                            key: "terminate",
                            value: function terminate() {
                                if (this.worker.terminate) this.worker.terminate();
                            }
                        },
                        {
                            key: "convertGwtStyleError",
                            value: function convertGwtStyleError(err) {
                                if (!err) return;
                                // Somewhat flatten the way GWT stores nested exception(s)
                                var javaException = err["__java$exception"];
                                if (javaException) {
                                    // Note that the property name of the nested exception is different
                                    // in the non-minified ('cause') and the minified (not deterministic) version.
                                    // Hence, the version below only works for the non-minified version.
                                    // However, as the minified stack trace is not of much use anyway, one
                                    // should switch the used version for debugging in such a case.
                                    if (javaException.cause && javaException.cause.backingJsObject) {
                                        err.cause = javaException.cause.backingJsObject;
                                        this.convertGwtStyleError(err.cause);
                                    }
                                    delete err["__java$exception"];
                                }
                            }
                        }
                    ]);
                    return PromisedWorker;
                }();
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                "use strict";
                /*******************************************************************************
 * Copyright (c) 2021 Kiel University and others.
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 * 
 * SPDX-License-Identifier: EPL-2.0
 *******************************************************************************/ var ELK = require1("./elk-api.js").default;
                Object.defineProperty(module1.exports, "__esModule", {
                    value: true
                });
                module1.exports = ELK;
                ELK.default = ELK;
            },
            {
                "./elk-api.js": 1
            }
        ]
    }, {}, [
        2
    ])(2);
});


var $580dcbcb2cc739f7$require$ELK = $18f2920ea9eca088$exports.default;


var $580dcbcb2cc739f7$var$ELKNode = function(_ELK) {
    $580dcbcb2cc739f7$var$_inherits(ELKNode, _ELK);
    function ELKNode() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $580dcbcb2cc739f7$var$_classCallCheck(this, ELKNode);
        var optionsClone = Object.assign({}, options);
        var workerThreadsExist = false;
        try {
            undefined("web-worker");
            workerThreadsExist = true;
        } catch (e) {}
        // user requested a worker
        if (options.workerUrl) {
            if (workerThreadsExist) {
                var Worker = (parcelRequire("c1apC"));
                optionsClone.workerFactory = function(url) {
                    return new Worker(url);
                };
            } else console.warn("Web worker requested but 'web-worker' package not installed. \nConsider installing the package or pass your own 'workerFactory' to ELK's constructor.\n... Falling back to non-web worker version.");
        }
        // unless no other workerFactory is registered, use the fake worker
        if (!optionsClone.workerFactory) {
            var _require = (parcelRequire("8oWJe")), _Worker = _require.Worker;
            optionsClone.workerFactory = function(url) {
                return new _Worker(url);
            };
        }
        return $580dcbcb2cc739f7$var$_possibleConstructorReturn(this, (ELKNode.__proto__ || Object.getPrototypeOf(ELKNode)).call(this, optionsClone));
    }
    return ELKNode;
}($580dcbcb2cc739f7$require$ELK);
Object.defineProperty($580dcbcb2cc739f7$exports, "__esModule", {
    value: true
});
$580dcbcb2cc739f7$exports = $580dcbcb2cc739f7$var$ELKNode;
$580dcbcb2cc739f7$var$ELKNode.default = $580dcbcb2cc739f7$var$ELKNode;





var $41YNz = parcelRequire("41YNz");

var $d40e44a710563a99$var$Applier = /*#__PURE__*/ function() {
    function Applier() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, Applier);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(Applier, [
        {
            key: "setEditor",
            value: function setEditor(editor) {
                this.editor = editor;
            }
        },
        {
            key: "setArea",
            value: function setArea(area) {
                this.area = area;
            }
        }
    ]);
    return Applier;
}();
function $d40e44a710563a99$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $d40e44a710563a99$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $d40e44a710563a99$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Standard applier. Applies the layout to the nodes and their children immediately
 */ var $d40e44a710563a99$var$StandardApplier = /*#__PURE__*/ function(_Applier) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(StandardApplier, _Applier);
    var _super = $d40e44a710563a99$var$_createSuper$2(StandardApplier);
    function StandardApplier() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, StandardApplier);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(StandardApplier, [
        {
            key: "getValidShapes",
            value: function getValidShapes(shapes) {
                return shapes.filter(function(shape) {
                    var x = shape.x, y = shape.y, width = shape.width, height = shape.height;
                    return ![
                        (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(x),
                        (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(y),
                        (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(width),
                        (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(height)
                    ].includes("undefined");
                });
            }
        },
        {
            key: "resizeNode",
            value: function() {
                var _resizeNode = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(id, width, height) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.area.resize(id, width, height);
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function resizeNode(_x, _x2, _x3) {
                    return _resizeNode.apply(this, arguments);
                }
                return resizeNode;
            }()
        },
        {
            key: "translateNode",
            value: function() {
                var _translateNode = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(id, x, y) {
                    var view;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                view = this.area.nodeViews.get(id);
                                if (!view) {
                                    _context2.next = 4;
                                    break;
                                }
                                _context2.next = 4;
                                return view.translate(x, y);
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function translateNode(_x4, _x5, _x6) {
                    return _translateNode.apply(this, arguments);
                }
                return translateNode;
            }()
        },
        {
            key: "apply",
            value: function() {
                var _apply = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee4(nodes) {
                    var _this = this;
                    var offset, correctNodes, _args4 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                offset = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {
                                    x: 0,
                                    y: 0
                                };
                                correctNodes = this.getValidShapes(nodes);
                                _context4.next = 4;
                                return Promise.all(correctNodes.map(/*#__PURE__*/ function() {
                                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(_ref) {
                                        var id, x, y, width, height, children;
                                        return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                                            while(true)switch(_context3.prev = _context3.next){
                                                case 0:
                                                    id = _ref.id, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height, children = _ref.children;
                                                    _context3.next = 3;
                                                    return Promise.all([
                                                        _this.resizeNode(id, width, height),
                                                        _this.translateNode(id, offset.x + x, offset.y + y)
                                                    ]);
                                                case 3:
                                                    if (!children) {
                                                        _context3.next = 6;
                                                        break;
                                                    }
                                                    _context3.next = 6;
                                                    return _this.apply(children, {
                                                        x: offset.x + x,
                                                        y: offset.y + y
                                                    });
                                                case 6:
                                                case "end":
                                                    return _context3.stop();
                                            }
                                        }, _callee3);
                                    }));
                                    return function(_x8) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }()));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function apply(_x7) {
                    return _apply.apply(this, arguments);
                }
                return apply;
            }()
        }
    ]);
    return StandardApplier;
}($d40e44a710563a99$var$Applier);
var $d40e44a710563a99$var$AnimationSystem = /*#__PURE__*/ function() {
    function AnimationSystem() {
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, AnimationSystem);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(this, "activeAnimations", new Map());
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(AnimationSystem, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                var entries = Array.from(this.activeAnimations.entries());
                entries.forEach(function(_ref) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref, 2), key = _ref2[0], _ref2$ = _ref2[1], startTime = _ref2$.startTime, duration = _ref2$.duration, cb = _ref2$.cb, done = _ref2$.done;
                    var t = (Date.now() - startTime) / duration;
                    if (t >= 1) t = 1;
                    if (t < 0 || t >= 1) {
                        _this.activeAnimations["delete"](key);
                        if (t >= 1) {
                            cb(1);
                            done(true);
                        }
                        return;
                    }
                    cb(t);
                });
                this.frameId = requestAnimationFrame(function() {
                    return _this.start();
                });
            }
        },
        {
            key: "add",
            value: function() {
                var _add = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(duration, id, tick) {
                    var _this2 = this;
                    var startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                startTime = Date.now();
                                return _context.abrupt("return", new Promise(function(done) {
                                    _this2.activeAnimations.set(id, {
                                        startTime: startTime,
                                        duration: duration,
                                        cb: tick,
                                        done: done
                                    });
                                }));
                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function add(_x, _x2, _x3) {
                    return _add.apply(this, arguments);
                }
                return add;
            }()
        },
        {
            key: "cancel",
            value: function cancel(key) {
                var _this$activeAnimation;
                (_this$activeAnimation = this.activeAnimations.get(key)) === null || _this$activeAnimation === void 0 || _this$activeAnimation.done(false);
                this.activeAnimations["delete"](key);
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (typeof this.frameId !== "undefined") cancelAnimationFrame(this.frameId);
            }
        }
    ]);
    return AnimationSystem;
}();
function $d40e44a710563a99$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d40e44a710563a99$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d40e44a710563a99$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d40e44a710563a99$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d40e44a710563a99$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $d40e44a710563a99$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $d40e44a710563a99$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Transition applier props
 */ /**
 * Transition applier. Applies the layout to the nodes and their children with transition
 */ var $d40e44a710563a99$var$TransitionApplier = /*#__PURE__*/ function(_StandardApplier) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(TransitionApplier, _StandardApplier);
    var _super = $d40e44a710563a99$var$_createSuper$1(TransitionApplier);
    /**
   * @param props Transition applier props
   */ function TransitionApplier(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, TransitionApplier);
        _this = _super.call(this);
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "animation", new $d40e44a710563a99$var$AnimationSystem());
        _this.props = props;
        _this.duration = typeof (props === null || props === void 0 ? void 0 : props.duration) !== "undefined" ? props.duration : 2000;
        _this.timingFunction = typeof (props === null || props === void 0 ? void 0 : props.timingFunction) !== "undefined" ? props.timingFunction : function(t) {
            return t;
        };
        _this.animation.start();
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(TransitionApplier, [
        {
            key: "applyTiming",
            value: function applyTiming(from, to, t) {
                var k = this.timingFunction(t);
                return from * (1 - k) + to * k;
            }
        },
        {
            key: "resizeNode",
            value: function() {
                var _resizeNode = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(id, width, height) {
                    var _this2 = this;
                    var node, previous;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                node = this.editor.getNode(id);
                                if (node) {
                                    _context.next = 3;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 3:
                                previous = {
                                    width: node.width,
                                    height: node.height
                                };
                                _context.next = 6;
                                return this.animation.add(this.duration, "".concat(id, "_resize"), function(t) {
                                    var _this2$props;
                                    var currentWidth = _this2.applyTiming(previous.width, width, t);
                                    var currentHeight = _this2.applyTiming(previous.height, height, t);
                                    ((_this2$props = _this2.props) === null || _this2$props === void 0 ? void 0 : _this2$props.onTick) && _this2.props.onTick(t);
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(TransitionApplier.prototype), "resizeNode", _this2).call(_this2, id, currentWidth, currentHeight);
                                });
                            case 6:
                                return _context.abrupt("return", _context.sent);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function resizeNode(_x, _x2, _x3) {
                    return _resizeNode.apply(this, arguments);
                }
                return resizeNode;
            }()
        },
        {
            key: "translateNode",
            value: function() {
                var _translateNode = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(id, x, y) {
                    var _this3 = this;
                    var view, previous;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                view = this.area.nodeViews.get(id);
                                if (view) {
                                    _context2.next = 3;
                                    break;
                                }
                                return _context2.abrupt("return", false);
                            case 3:
                                previous = $d40e44a710563a99$var$_objectSpread$1({}, view.position);
                                _context2.next = 6;
                                return this.animation.add(this.duration, "".concat(id, "_translate"), function(t) {
                                    var _this3$props;
                                    var currentX = _this3.applyTiming(previous.x, x, t);
                                    var currentY = _this3.applyTiming(previous.y, y, t);
                                    ((_this3$props = _this3.props) === null || _this3$props === void 0 ? void 0 : _this3$props.onTick) && _this3.props.onTick(t);
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($9c4212772a6002f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(TransitionApplier.prototype), "translateNode", _this3).call(_this3, id, currentX, currentY);
                                });
                            case 6:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function translateNode(_x4, _x5, _x6) {
                    return _translateNode.apply(this, arguments);
                }
                return translateNode;
            }()
        },
        {
            key: "cancel",
            value: function cancel(id) {
                this.animation.cancel("".concat(id, "_resize"));
                this.animation.cancel("".concat(id, "_translate"));
            }
        },
        {
            key: "apply",
            value: function() {
                var _apply = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee3(nodes) {
                    var _this4 = this;
                    var offset, correctNodes, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                offset = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {
                                    x: 0,
                                    y: 0
                                };
                                correctNodes = this.getValidShapes(nodes);
                                _context3.next = 4;
                                return Promise.all(correctNodes.map(function(_ref) {
                                    var _this4$props;
                                    var id = _ref.id, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height, children = _ref.children;
                                    var hasChilden = children && children.length;
                                    var needsLayout = (_this4$props = _this4.props) !== null && _this4$props !== void 0 && _this4$props.needsLayout ? _this4.props.needsLayout(id) : true;
                                    var forceSelf = !hasChilden || needsLayout;
                                    return Promise.all([
                                        hasChilden && _this4.apply(children, {
                                            x: offset.x + x,
                                            y: offset.y + y
                                        }),
                                        forceSelf && _this4.resizeNode(id, width, height),
                                        forceSelf && _this4.translateNode(id, offset.x + x, offset.y + y)
                                    ]);
                                }));
                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function apply(_x7) {
                    return _apply.apply(this, arguments);
                }
                return apply;
            }()
        },
        {
            key: "destroy",
            value: function destroy() {
                this.animation.stop();
            }
        }
    ]);
    return TransitionApplier;
}($d40e44a710563a99$var$StandardApplier);
var $d40e44a710563a99$export$255481f24182975c = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Applier: $d40e44a710563a99$var$Applier,
    StandardApplier: $d40e44a710563a99$var$StandardApplier,
    TransitionApplier: $d40e44a710563a99$var$TransitionApplier
});
/**
 * Classic preset. Input ports are positioned on the left bottom side of the node, output ports are positioned on the right top side of the node.
 * @priority 7
 */ var $d40e44a710563a99$var$setup = function setup(props) {
    return function() {
        return {
            port: function port(data) {
                var _spacing$top$bottom = {
                    spacing: props && typeof props.spacing !== "undefined" ? props.spacing : 35,
                    top: props && typeof props.top !== "undefined" ? props.top : 35,
                    bottom: props && typeof props.bottom !== "undefined" ? props.bottom : 15
                }, spacing = _spacing$top$bottom.spacing, top = _spacing$top$bottom.top, bottom = _spacing$top$bottom.bottom;
                if (data.side === "output") return {
                    x: 0,
                    y: top + data.index * spacing,
                    width: 15,
                    height: 15,
                    side: "EAST"
                };
                return {
                    x: 0,
                    y: data.height - bottom - data.ports * spacing + data.index * spacing,
                    width: 15,
                    height: 15,
                    side: "WEST"
                };
            }
        };
    };
};
var $d40e44a710563a99$var$index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    setup: $d40e44a710563a99$var$setup
});
/**
 * Built-in presets. Responsible for node port positioning.
 * @module
 */ var $d40e44a710563a99$export$7a05727743f7512 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    classic: $d40e44a710563a99$var$index$1
});
function $d40e44a710563a99$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d40e44a710563a99$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d40e44a710563a99$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d40e44a710563a99$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d40e44a710563a99$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $d40e44a710563a99$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d40e44a710563a99$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d40e44a710563a99$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d40e44a710563a99$var$_arrayLikeToArray(o, minLen);
}
function $d40e44a710563a99$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d40e44a710563a99$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d40e44a710563a99$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($93d4339c80153a6a$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($ac4cd79166dac6e4$exports)))(this, result);
    };
}
function $d40e44a710563a99$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Auto arrange plugin. Layouts the graph using `elk.js`
 * @priority 10
 */ var $d40e44a710563a99$export$5740d7119e58a254 = /*#__PURE__*/ function(_Scope) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b050fc8434f4a0e1$exports)))(AutoArrangePlugin, _Scope);
    var _super = $d40e44a710563a99$var$_createSuper(AutoArrangePlugin);
    function AutoArrangePlugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($b45a6abf916bff88$exports)))(this, AutoArrangePlugin);
        _this = _super.call(this, "auto-arrange");
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "elk", new (0, (/*@__PURE__*/$parcel$interopDefault($580dcbcb2cc739f7$exports)))());
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "demonstration", "https://rtsys.informatik.uni-kiel.de/elklive/json.html");
        (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4c93951af9bb8a88$exports)))(_this), "presets", []);
        return _this;
    }
    /**
   * Adds a preset to the plugin, which will be used to layout the node ports and customize the layout options
   * @param preset Preset to add
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fe9438347a673ba6$exports)))(AutoArrangePlugin, [
        {
            key: "addPreset",
            value: function addPreset(preset) {
                this.presets.push(preset);
            }
        },
        {
            key: "findPreset",
            value: function findPreset(nodeId) {
                var _iterator = $d40e44a710563a99$var$_createForOfIteratorHelper(this.presets), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var presetFactory = _step.value;
                        var result = presetFactory(nodeId);
                        if (result) return result;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                throw new Error("cannot find preset for node with id = " + nodeId);
            }
        },
        {
            key: "getArea",
            value: function getArea() {
                return this.parentScope((0, $8edd8caaa4dabbef$export$893ad666b26a6f6e));
            }
        },
        {
            key: "getEditor",
            value: function getEditor() {
                return this.getArea().parentScope((0, $bad63f27bc7a37b5$export$970c2db48345af40));
            }
        },
        {
            key: "nodeToLayoutChild",
            value: function nodeToLayoutChild(node, context) {
                var _this2 = this, _preset$options;
                var id = node.id, width = node.width, height = node.height;
                var inputs = node.inputs ? Object.entries(node.inputs).map(function(_ref) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref, 2), key = _ref2[0], input = _ref2[1];
                    return {
                        key: key,
                        input: input
                    };
                }) : [];
                var outputs = node.outputs ? Object.entries(node.outputs).map(function(_ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($008fdf6f13d86ab1$exports)))(_ref3, 2), key = _ref4[0], output = _ref4[1];
                    return {
                        key: key,
                        output: output
                    };
                }) : [];
                var preset = this.findPreset(id);
                return $d40e44a710563a99$var$_objectSpread($d40e44a710563a99$var$_objectSpread({
                    id: id,
                    width: width,
                    height: height,
                    labels: [
                        {
                            text: "label" in node ? node.label : ""
                        }
                    ]
                }, this.graphToElk(context, id)), {}, {
                    ports: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(inputs.sort(function(a, b) {
                        var _a$input, _b$input;
                        return (((_a$input = a.input) === null || _a$input === void 0 ? void 0 : _a$input.index) || 0) - (((_b$input = b.input) === null || _b$input === void 0 ? void 0 : _b$input.index) || 0);
                    }).map(function(_ref5, index) {
                        var key = _ref5.key;
                        var _preset$port = preset.port({
                            nodeId: id,
                            key: key,
                            side: "input",
                            width: width,
                            height: height,
                            index: index,
                            ports: inputs.length
                        }), side = _preset$port.side, portWidth = _preset$port.width, portHeight = _preset$port.height, x = _preset$port.x, y = _preset$port.y;
                        return {
                            id: _this2.getPortId(id, key, "input"),
                            width: portWidth,
                            height: portHeight,
                            x: x,
                            y: y,
                            properties: {
                                side: side
                            }
                        };
                    })), (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(outputs.sort(function(a, b) {
                        var _a$output, _b$output;
                        return (((_a$output = a.output) === null || _a$output === void 0 ? void 0 : _a$output.index) || 0) - (((_b$output = b.output) === null || _b$output === void 0 ? void 0 : _b$output.index) || 0);
                    }).map(function(_ref6, index) {
                        var key = _ref6.key;
                        var _preset$port2 = preset.port({
                            nodeId: id,
                            side: "output",
                            key: key,
                            index: index,
                            width: width,
                            height: height,
                            ports: outputs.length
                        }), side = _preset$port2.side, portWidth = _preset$port2.width, portHeight = _preset$port2.height, x = _preset$port2.x, y = _preset$port2.y;
                        return {
                            id: _this2.getPortId(id, key, "output"),
                            width: portWidth,
                            height: portHeight,
                            x: x,
                            y: y,
                            properties: {
                                side: side
                            }
                        };
                    }))),
                    layoutOptions: $d40e44a710563a99$var$_objectSpread($d40e44a710563a99$var$_objectSpread({}, ((_preset$options = preset.options) === null || _preset$options === void 0 ? void 0 : _preset$options.call(preset, id)) || {}), {}, {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        portConstraints: "FIXED_POS"
                    })
                });
            }
        },
        {
            key: "connectionToLayoutEdge",
            value: function connectionToLayoutEdge(connection) {
                var source = connection.sourceOutput ? this.getPortId(connection.source, connection.sourceOutput, "output") : connection.source;
                var target = connection.targetInput ? this.getPortId(connection.target, connection.targetInput, "input") : connection.target;
                return {
                    id: connection.id,
                    sources: [
                        source
                    ],
                    targets: [
                        target
                    ]
                };
            }
        },
        {
            key: "graphToElk",
            value: function graphToElk(context, parent) {
                var _this3 = this;
                var nodes = context.nodes.filter(function(n) {
                    return n.parent === parent;
                });
                return {
                    children: nodes.map(function(n) {
                        return _this3.nodeToLayoutChild(n, context);
                    }),
                    edges: context.connections.filter(function() {
                        return !parent;
                    }).map(function(c) {
                        return _this3.connectionToLayoutEdge(c);
                    })
                };
            }
        },
        {
            key: "getPortId",
            value: function getPortId(id, key, side) {
                return [
                    id,
                    key,
                    side
                ].join("_");
            }
        },
        {
            key: "layout",
            value: function() {
                var _layout = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(props) {
                    var nodes, connections, graph, applier, source, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                nodes = (props === null || props === void 0 ? void 0 : props.nodes) || this.getEditor().getNodes();
                                connections = (props === null || props === void 0 ? void 0 : props.connections) || this.getEditor().getConnections();
                                graph = $d40e44a710563a99$var$_objectSpread({
                                    id: "root",
                                    layoutOptions: $d40e44a710563a99$var$_objectSpread({
                                        /* eslint-disable @typescript-eslint/naming-convention */ "elk.algorithm": "layered",
                                        "elk.hierarchyHandling": "INCLUDE_CHILDREN",
                                        "elk.edgeRouting": "POLYLINE"
                                    }, (props === null || props === void 0 ? void 0 : props.options) || {})
                                }, this.graphToElk({
                                    nodes: nodes,
                                    connections: connections
                                }));
                                applier = (props === null || props === void 0 ? void 0 : props.applier) || new $d40e44a710563a99$var$StandardApplier();
                                source = JSON.stringify(graph, null, "	");
                                applier.setEditor(this.getEditor());
                                applier.setArea(this.getArea());
                                _context.prev = 7;
                                _context.next = 10;
                                return this.elk.layout(graph);
                            case 10:
                                result = _context.sent;
                                if (!result.children) {
                                    _context.next = 14;
                                    break;
                                }
                                _context.next = 14;
                                return applier.apply(result.children);
                            case 14:
                                return _context.abrupt("return", {
                                    demonstration: this.demonstration,
                                    source: source,
                                    result: result
                                });
                            case 17:
                                _context.prev = 17;
                                _context.t0 = _context["catch"](7);
                                // eslint-disable-next-line no-console
                                console.warn("[rete-auto-arrange-plugin]", {
                                    source: source,
                                    demonstration: this.demonstration
                                });
                                throw _context.t0;
                            case 21:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            7,
                            17
                        ]
                    ]);
                }));
                function layout(_x) {
                    return _layout.apply(this, arguments);
                }
                return layout;
            }()
        }
    ]);
    return AutoArrangePlugin;
}((0, $bad63f27bc7a37b5$export$775b6bb06e53a214));


/*!
* rete-structures v2.0.0
* (c) 2024 Vitaliy Stoliarov
* Released under the CC-BY-NC-SA-4.0 license.
* */ 

function $ecd61fdb45ead356$var$getContextData(context) {
    return "nodes" in context ? context : {
        nodes: context.getNodes(),
        connections: context.getConnections()
    };
}
function $ecd61fdb45ead356$var$getNode(list, id) {
    var node = list.find(function(n) {
        return n.id === id;
    });
    if (!node) throw new Error("node");
    return node;
}
function $ecd61fdb45ead356$var$getConnection(list, id) {
    var node = list.find(function(n) {
        return n.id === id;
    });
    if (!node) throw new Error("connection");
    return node;
}
function $ecd61fdb45ead356$var$uniqueConnections(connections) {
    var ids = new Set();
    connections.forEach(function(c) {
        return ids.add(c.id);
    });
    return Array.from(ids).map(function(id) {
        return $ecd61fdb45ead356$var$getConnection(connections, id);
    });
}
function $ecd61fdb45ead356$var$getConnectionsFor(nodes, connections) {
    var ids = Array.from(nodes).map(function(n) {
        return n.id;
    });
    return connections.filter(function(c) {
        return ids.includes(c.source) && ids.includes(c.target);
    });
}
function $ecd61fdb45ead356$var$getMapping(data) {
    var getNodes = function getNodes() {
        return data.nodes;
    };
    var getConnections = function getConnections() {
        return data.connections;
    };
    var filter = function filter(predicateNode, predicateConnection) {
        var nodes = data.nodes.filter(function(node) {
            return predicateNode(node);
        });
        var connections = predicateConnection ? data.connections.filter(function(c) {
            return predicateConnection(c);
        }) : data.connections;
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, connections)
        });
    };
    return {
        nodes: getNodes,
        connections: getConnections,
        filter: filter
    };
}
function $ecd61fdb45ead356$var$getSets(data) {
    var union = function union(collection) {
        var collectionData = $ecd61fdb45ead356$var$getContextData(collection);
        var nodesSet = new Set();
        data.nodes.forEach(function(n) {
            return nodesSet.add(n.id);
        });
        collectionData.nodes.forEach(function(n) {
            return nodesSet.add(n.id);
        });
        var nodes = Array.from(nodesSet.values()).map(function(id) {
            return $ecd61fdb45ead356$var$getNode([].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(data.nodes), (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(collectionData.nodes)), id);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, $ecd61fdb45ead356$var$uniqueConnections([].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(data.connections), (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(collectionData.connections))))
        });
    };
    var difference = function difference(collection) {
        var collectionData = $ecd61fdb45ead356$var$getContextData(collection);
        var nodesSet = new Set();
        data.nodes.forEach(function(n) {
            return nodesSet.add(n.id);
        });
        collectionData.nodes.forEach(function(n) {
            return nodesSet["delete"](n.id);
        });
        var nodes = Array.from(nodesSet.values()).map(function(id) {
            return $ecd61fdb45ead356$var$getNode(data.nodes, id);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, $ecd61fdb45ead356$var$uniqueConnections([].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(data.connections), (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(collectionData.connections))))
        });
    };
    var intersection = function intersection(collection) {
        var collectionData = $ecd61fdb45ead356$var$getContextData(collection);
        var sourceIds = data.nodes.map(function(n) {
            return n.id;
        });
        var targetIds = collectionData.nodes.map(function(n) {
            return n.id;
        });
        var nodesSet = new Set();
        sourceIds.forEach(function(id) {
            if (targetIds.includes(id)) nodesSet.add(id);
        });
        var nodes = Array.from(nodesSet.values()).map(function(id) {
            return $ecd61fdb45ead356$var$getNode(data.nodes, id);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, $ecd61fdb45ead356$var$uniqueConnections([].concat((0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(data.connections), (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(collectionData.connections))))
        });
    };
    return {
        union: union,
        difference: difference,
        intersection: intersection
    };
}
function $ecd61fdb45ead356$var$getSubgraph(data) {
    var _children = function _children(nodes) {
        var ids = nodes.map(function(n) {
            return n.id;
        });
        return data.nodes.filter(function(n) {
            return "parent" in n && n.parent && ids.includes(n.parent);
        });
    };
    var getChildren = function getChildren() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Boolean;
        var nodes = _children(data.nodes.filter(selector));
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    var getParents = function getParents() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Boolean;
        var nodes = data.nodes.filter(selector);
        var ids = nodes.map(function(n) {
            return n.parent;
        });
        var parents = data.nodes.filter(function(n) {
            return ids.includes(n.id);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: parents,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(parents, data.connections)
        });
    };
    var _descendants = function _descendants(nodes, ids) {
        var children = nodes.filter(function(n) {
            return "parent" in n && n.parent && ids.includes(n.parent);
        });
        var result = (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(children);
        if (children.length) result.push.apply(result, (0, (/*@__PURE__*/$parcel$interopDefault($b95e04f2d4c66124$exports)))(_descendants(nodes, children.map(function(c) {
            return c.id;
        }))));
        return result;
    };
    var descendants = function descendants() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Boolean;
        var nodes = _descendants(data.nodes, data.nodes.filter(selector).map(function(n) {
            return n.id;
        }));
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    var _parents = function _parents(ids) {
        var local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : data;
        var parentIds = new Set();
        var targetParentIds = new Set(ids.map(function(id) {
            return $ecd61fdb45ead356$var$getNode(local.nodes, id).parent;
        }));
        data.nodes.forEach(function(parent) {
            if (targetParentIds.has(parent.id)) parentIds.add(parent.id);
        });
        if (parentIds.size) {
            var found = _parents(Array.from(parentIds), local);
            found.forEach(function(id) {
                return parentIds.add(id);
            });
        }
        return Array.from(parentIds);
    };
    var getAncestors = function getAncestors() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Boolean;
        var ids = _parents(data.nodes.filter(selector).map(function(n) {
            return n.id;
        }), data);
        var nodes = ids.map(function(id) {
            return $ecd61fdb45ead356$var$getNode(data.nodes, id);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    var orphans = function orphans() {
        var nodes = data.nodes.filter(function(n) {
            return !n.parent;
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    var siblings = function siblings() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Boolean;
        var nodes = data.nodes.filter(selector);
        var parents = nodes.map(function(n) {
            return n.parent;
        });
        var sibs = data.nodes.filter(function(n) {
            return parents.includes(n.parent);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: sibs,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(sibs, data.connections)
        });
    };
    return {
        children: getChildren,
        parents: getParents,
        descendants: descendants,
        ancestors: getAncestors,
        orphans: orphans,
        siblings: siblings
    };
}
function $ecd61fdb45ead356$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $ecd61fdb45ead356$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $ecd61fdb45ead356$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ecd61fdb45ead356$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ecd61fdb45ead356$var$_arrayLikeToArray(o, minLen);
}
function $ecd61fdb45ead356$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ecd61fdb45ead356$var$getTraverse(data) {
    var leaves = function leaves() {
        var sources = data.connections.map(function(c) {
            return c.source;
        });
        var nodes = data.nodes.filter(function(n) {
            return !(sources.length && sources.includes(n.id));
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    var roots = function roots() {
        var targets = data.connections.map(function(c) {
            return c.target;
        });
        var nodes = data.nodes.filter(function(n) {
            return !(targets.length && targets.includes(n.id));
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    var incomers = function incomers(id) {
        var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Boolean;
        var nodes = data.connections.filter(function(c) {
            var match = c.target === id;
            if (selector === Boolean) return match;
            var node = data.nodes.find(function(n) {
                return n.id === c.source;
            });
            if (!node) throw new Error("node");
            return match && selector(node, c);
        }).map(function(c) {
            var node = data.nodes.find(function(n) {
                return n.id === c.source;
            });
            if (!node) throw new Error("node");
            return node;
        });
        var uniqueNodes = Array.from(new Set(nodes));
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: uniqueNodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(uniqueNodes, data.connections)
        });
    };
    var outgoers = function outgoers(id) {
        var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Boolean;
        var nodes = data.connections.filter(function(c) {
            var match = c.source === id;
            if (selector === Boolean) return match;
            var node = data.nodes.find(function(n) {
                return n.id === c.target;
            });
            if (!node) throw new Error("node");
            return match && selector(node, c);
        }).map(function(c) {
            var node = data.nodes.find(function(n) {
                return n.id === c.target;
            });
            if (!node) throw new Error("node");
            return node;
        });
        var uniqueNodes = Array.from(new Set(nodes));
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: uniqueNodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(uniqueNodes, data.connections)
        });
    };
    var collectSuccessors = function collectSuccessors(id, set, selector) {
        var _iterator = $ecd61fdb45ead356$var$_createForOfIteratorHelper(outgoers(id, selector).nodes()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (!set.has(item.id)) {
                    set.add(item.id);
                    collectSuccessors(item.id, set, selector);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    var successors = function successors(id) {
        var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Boolean;
        var nodesSet = new Set();
        collectSuccessors(id, nodesSet, selector);
        var nodes = Array.from(nodesSet.values()).map(function(nodeId) {
            return $ecd61fdb45ead356$var$getNode(data.nodes, nodeId);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    var collectPredecessors = function collectPredecessors(id, set, selector) {
        var _iterator2 = $ecd61fdb45ead356$var$_createForOfIteratorHelper(incomers(id, selector).nodes()), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var item = _step2.value;
                if (!set.has(item.id)) {
                    set.add(item.id);
                    collectPredecessors(item.id, set, selector);
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
    var predecessors = function predecessors(id) {
        var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Boolean;
        var nodesSet = new Set();
        collectPredecessors(id, nodesSet, selector);
        var nodes = Array.from(nodesSet.values()).map(function(nodeId) {
            return $ecd61fdb45ead356$var$getNode(data.nodes, nodeId);
        });
        return $ecd61fdb45ead356$export$ed855c71509be8a0({
            nodes: nodes,
            connections: $ecd61fdb45ead356$var$getConnectionsFor(nodes, data.connections)
        });
    };
    return {
        roots: roots,
        leaves: leaves,
        incomers: incomers,
        outgoers: outgoers,
        successors: successors,
        predecessors: predecessors
    };
}
function $ecd61fdb45ead356$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ecd61fdb45ead356$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ecd61fdb45ead356$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bb7ca61ce45563c4$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ecd61fdb45ead356$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ecd61fdb45ead356$export$ed855c71509be8a0(context) {
    var data = $ecd61fdb45ead356$var$getContextData(context);
    var mapping = $ecd61fdb45ead356$var$getMapping(data);
    var subgraph = $ecd61fdb45ead356$var$getSubgraph(data);
    var traverse = $ecd61fdb45ead356$var$getTraverse(data);
    var sets = $ecd61fdb45ead356$var$getSets(data);
    return $ecd61fdb45ead356$var$_objectSpread($ecd61fdb45ead356$var$_objectSpread($ecd61fdb45ead356$var$_objectSpread($ecd61fdb45ead356$var$_objectSpread({
        mapping: mapping,
        subgraph: subgraph,
        traverse: traverse,
        sets: sets
    }, mapping), subgraph), traverse), sets);
}




var $acw62 = parcelRequire("acw62");
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r);
}


function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $95003165623aa54c$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $b5aec8b8da7ac2f2$export$2e2bcd8739ae039)();
}



var $acw62 = parcelRequire("acw62");
var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $be673cd5391dca21$var$extendsObject = function() {
    const result = Object.assign({}, arguments.length <= 0 ? undefined : arguments[0]);
    for(let i = 1; i < arguments.length; i++){
        const obj = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (obj) Object.keys(obj).forEach((key)=>{
            const val = obj[key];
            if (val !== undefined) result[key] = val;
        });
    }
    return result;
};
var $be673cd5391dca21$export$2e2bcd8739ae039 = $be673cd5391dca21$var$extendsObject;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}





function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $c0f5cb12993018cc$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $c0f5cb12993018cc$export$2e2bcd8739ae039 = $c0f5cb12993018cc$var$murmur2;



function $c6daeb3adc2b0e60$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


function $97b4b0194c593c05$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


var $3a22468320d7d808$var$APPEND_ORDER = "data-rc-order";
var $3a22468320d7d808$var$APPEND_PRIORITY = "data-rc-priority";
var $3a22468320d7d808$var$MARK_KEY = "rc-util-key";
var $3a22468320d7d808$var$containerCache = new Map();
function $3a22468320d7d808$var$getMark() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, mark = _ref.mark;
    if (mark) return mark.startsWith("data-") ? mark : "data-".concat(mark);
    return $3a22468320d7d808$var$MARK_KEY;
}
function $3a22468320d7d808$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    var head = document.querySelector("head");
    return head || document.body;
}
function $3a22468320d7d808$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
/**
 * Find style which inject by rc-util
 */ function $3a22468320d7d808$var$findStyles(container) {
    return Array.from(($3a22468320d7d808$var$containerCache.get(container) || container).children).filter(function(node) {
        return node.tagName === "STYLE";
    });
}
function $3a22468320d7d808$export$1ab5838465dbd10a(css) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) return null;
    var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
    var mergedOrder = $3a22468320d7d808$var$getOrder(prepend);
    var isPrependQueue = mergedOrder === "prependQueue";
    var styleNode = document.createElement("style");
    styleNode.setAttribute($3a22468320d7d808$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($3a22468320d7d808$var$APPEND_PRIORITY, "".concat(priority));
    if (csp !== null && csp !== void 0 && csp.nonce) styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
    styleNode.innerHTML = css;
    var container = $3a22468320d7d808$var$getContainer(option);
    var firstChild = container.firstChild;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            var existStyle = (option.styles || $3a22468320d7d808$var$findStyles(container)).filter(function(node) {
                // Ignore style which not injected by rc-util with prepend
                if (![
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($3a22468320d7d808$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                var nodePriority = Number(node.getAttribute($3a22468320d7d808$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $3a22468320d7d808$var$findExistNode(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var container = $3a22468320d7d808$var$getContainer(option);
    return (option.styles || $3a22468320d7d808$var$findStyles(container)).find(function(node) {
        return node.getAttribute($3a22468320d7d808$var$getMark(option)) === key;
    });
}
function $3a22468320d7d808$export$2232e336aecaa80a(key) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var container = $3a22468320d7d808$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $3a22468320d7d808$var$syncRealContainer(container, option) {
    var cachedRealContainer = $3a22468320d7d808$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        var placeholderStyle = $3a22468320d7d808$export$1ab5838465dbd10a("", option);
        var parentNode = placeholderStyle.parentNode;
        $3a22468320d7d808$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $3a22468320d7d808$export$f80df667f2f5a272() {
    $3a22468320d7d808$var$containerCache.clear();
}
function $3a22468320d7d808$export$4d99a2890bb989f0(css, key) {
    var originOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var container = $3a22468320d7d808$var$getContainer(originOption);
    var styles = $3a22468320d7d808$var$findStyles(container);
    var option = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originOption), {}, {
        styles: styles
    });
    // Sync real parent
    $3a22468320d7d808$var$syncRealContainer(container, option);
    var existNode = $3a22468320d7d808$var$findExistNode(key, option);
    if (existNode) {
        var _option$csp, _option$csp2;
        if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
            var _option$csp3;
            existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
        }
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    var newNode = $3a22468320d7d808$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($3a22468320d7d808$var$getMark(option), key);
    return newNode;
}



var $acw62 = parcelRequire("acw62");

function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $acw62 = parcelRequire("acw62");
function $2e4d16a6147a082d$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $acw62.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



/* eslint-disable no-console */ var $05a5f2c645683a81$var$warned = {};
var $05a5f2c645683a81$var$preWarningFns = [];
var $05a5f2c645683a81$export$61616f168f0e5a05 = function preMessage(fn) {
    $05a5f2c645683a81$var$preWarningFns.push(fn);
};
function $05a5f2c645683a81$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $05a5f2c645683a81$export$60eef1277fe463e4() {
    $05a5f2c645683a81$var$warned = {};
}
function $05a5f2c645683a81$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$05a5f2c645683a81$var$warned[message]) {
        method(false, message);
        $05a5f2c645683a81$var$warned[message] = true;
    }
}
function $05a5f2c645683a81$export$82934adf09101657(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$491112666e282270, valid, message);
}
function $05a5f2c645683a81$export$89ff31684837bbbf(valid, message) {
    $05a5f2c645683a81$export$848feb93d8f32b9b($05a5f2c645683a81$export$a92e4c44d367d0af, valid, message);
}
$05a5f2c645683a81$export$82934adf09101657.preMessage = $05a5f2c645683a81$export$61616f168f0e5a05;
$05a5f2c645683a81$export$82934adf09101657.resetWarned = $05a5f2c645683a81$export$60eef1277fe463e4;
$05a5f2c645683a81$export$82934adf09101657.noteOnce = $05a5f2c645683a81$export$89ff31684837bbbf;
var $05a5f2c645683a81$export$2e2bcd8739ae039 = $05a5f2c645683a81$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $357adc8667cde522$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(a) === "object" && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(b) === "object") {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $357adc8667cde522$export$2e2bcd8739ae039 = $357adc8667cde522$var$isEqual;



var $acw62 = parcelRequire("acw62");
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



// [times, realValue]
var $7399254758448c39$var$SPLIT = "%";
function $7399254758448c39$export$1d14e1d8187b9aad(keys) {
    return keys.join($7399254758448c39$var$SPLIT);
}
var $7399254758448c39$var$Entity = /*#__PURE__*/ function() {
    function Entity(instanceId) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Entity);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "instanceId", void 0);
        /** @private Internal cache map. Do not access this directly */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cache", new Map());
        this.instanceId = instanceId;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Entity, [
        {
            key: "get",
            value: function get(keys) {
                return this.opGet($7399254758448c39$export$1d14e1d8187b9aad(keys));
            }
        },
        {
            key: "opGet",
            value: function opGet(keyPathStr) {
                return this.cache.get(keyPathStr) || null;
            }
        },
        {
            key: "update",
            value: function update(keys, valueFn) {
                return this.opUpdate($7399254758448c39$export$1d14e1d8187b9aad(keys), valueFn);
            }
        },
        {
            key: "opUpdate",
            value: function opUpdate(keyPathStr, valueFn) {
                var prevValue = this.cache.get(keyPathStr);
                var nextValue = valueFn(prevValue);
                if (nextValue === null) this.cache.delete(keyPathStr);
                else this.cache.set(keyPathStr, nextValue);
            }
        }
    ]);
    return Entity;
}();
var $7399254758448c39$export$2e2bcd8739ae039 = $7399254758448c39$var$Entity;


var $182b356f02bf1b9b$var$_excluded = [
    "children"
];
var $182b356f02bf1b9b$export$5d99297dcd5476ac = "data-token-hash";
var $182b356f02bf1b9b$export$89ce1123b3c0bd9e = "data-css-hash";
var $182b356f02bf1b9b$export$36f8a6c9fa24262a = "data-cache-path";
var $182b356f02bf1b9b$export$4c16a0c02134a7dc = "__cssinjs_instance__";
function $182b356f02bf1b9b$export$cf6fa0bbcc94b912() {
    var cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== "undefined" && document.head && document.body) {
        var styles = document.body.querySelectorAll("style[".concat($182b356f02bf1b9b$export$89ce1123b3c0bd9e, "]")) || [];
        var firstChild = document.head.firstChild;
        Array.from(styles).forEach(function(style) {
            style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] = style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] || cssinjsInstanceId;
            // Not force move if no head
            if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        var styleHash = {};
        Array.from(document.querySelectorAll("style[".concat($182b356f02bf1b9b$export$89ce1123b3c0bd9e, "]"))).forEach(function(style) {
            var hash = style.getAttribute($182b356f02bf1b9b$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$182b356f02bf1b9b$export$4c16a0c02134a7dc] === cssinjsInstanceId) {
                    var _style$parentNode;
                    (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
                }
            } else styleHash[hash] = true;
        });
    }
    return new (0, $7399254758448c39$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
var $182b356f02bf1b9b$var$StyleContext = /*#__PURE__*/ $acw62.createContext({
    hashPriority: "low",
    cache: $182b356f02bf1b9b$export$cf6fa0bbcc94b912(),
    defaultCache: true
});
var $182b356f02bf1b9b$export$6aedb87c7b665270 = function StyleProvider(props) {
    var children = props.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $182b356f02bf1b9b$var$_excluded);
    var parentContext = $acw62.useContext($182b356f02bf1b9b$var$StyleContext);
    var context = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        var mergedContext = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, parentContext);
        Object.keys(restProps).forEach(function(key) {
            var value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        var cache = restProps.cache;
        mergedContext.cache = mergedContext.cache || $182b356f02bf1b9b$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], function(prev, next) {
        return !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev[1], next[1], true);
    });
    return /*#__PURE__*/ $acw62.createElement($182b356f02bf1b9b$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $182b356f02bf1b9b$export$2e2bcd8739ae039 = $182b356f02bf1b9b$var$StyleContext;












function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, e);
}


function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}


function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(t);
}


function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $b2099f49db83e2df$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $6a259df8fa92dc4a$export$2e2bcd8739ae039)(this, e);
    };
}





var $1a755235d4cd9d8d$var$AbstractCalculator = /*#__PURE__*/ (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $1a755235d4cd9d8d$export$2e2bcd8739ae039 = $1a755235d4cd9d8d$var$AbstractCalculator;


var $96067c2c1122b921$var$CALC_UNIT = "CALC_UNIT";
var $96067c2c1122b921$var$regexp = new RegExp($96067c2c1122b921$var$CALC_UNIT, "g");
function $96067c2c1122b921$var$unit(value) {
    if (typeof value === "number") return "".concat(value).concat($96067c2c1122b921$var$CALC_UNIT);
    return value;
}
var $96067c2c1122b921$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", "");
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === "number") _this.result = $96067c2c1122b921$var$unit(num);
        else if (numType === "string") _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " + ").concat($96067c2c1122b921$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " - ").concat($96067c2c1122b921$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === "boolean") mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($96067c2c1122b921$var$regexp, mergedUnit ? "px" : "");
                if (typeof this.lowPriority !== "undefined") return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $1a755235d4cd9d8d$export$2e2bcd8739ae039));









var $189b9ffa4e9f1d1f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === "number") _this.result = num;
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === "number") this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === "number") this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === "number") this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === "number") this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $1a755235d4cd9d8d$export$2e2bcd8739ae039));


var $f7688ec948540519$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === "css" ? (0, $96067c2c1122b921$export$2e2bcd8739ae039) : (0, $189b9ffa4e9f1d1f$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $f7688ec948540519$export$2e2bcd8739ae039 = $f7688ec948540519$var$genCalc;






function $06e75d38ebf58c74$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(var i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
var $06e75d38ebf58c74$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeCache() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ThemeCache);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cache", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "keys", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "cacheCallTimes", void 0);
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ThemeCache, [
        {
            key: "size",
            value: function size() {
                return this.keys.length;
            }
        },
        {
            key: "internalGet",
            value: function internalGet(derivativeOption) {
                var _cache2, _cache3;
                var updateCallTimes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var cache = {
                    map: this.cache
                };
                derivativeOption.forEach(function(derivative) {
                    if (!cache) cache = undefined;
                    else {
                        var _cache;
                        cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative);
                    }
                });
                if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
                return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
            }
        },
        {
            key: "get",
            value: function get(derivativeOption) {
                var _this$internalGet;
                return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
            }
        },
        {
            key: "has",
            value: function has(derivativeOption) {
                return !!this.internalGet(derivativeOption);
            }
        },
        {
            key: "set",
            value: function set(derivativeOption, value) {
                var _this = this;
                // New cache
                if (!this.has(derivativeOption)) {
                    if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                        var _this$keys$reduce = this.keys.reduce(function(result, key) {
                            var _result = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(result, 2), callTimes = _result[1];
                            if (_this.internalGet(key)[1] < callTimes) return [
                                key,
                                _this.internalGet(key)[1]
                            ];
                            return result;
                        }, [
                            this.keys[0],
                            this.cacheCallTimes
                        ]), _this$keys$reduce2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
                        this.delete(targetKey);
                    }
                    this.keys.push(derivativeOption);
                }
                var cache = this.cache;
                derivativeOption.forEach(function(derivative, index) {
                    if (index === derivativeOption.length - 1) cache.set(derivative, {
                        value: [
                            value,
                            _this.cacheCallTimes++
                        ]
                    });
                    else {
                        var cacheValue = cache.get(derivative);
                        if (!cacheValue) cache.set(derivative, {
                            map: new Map()
                        });
                        else if (!cacheValue.map) cacheValue.map = new Map();
                        cache = cache.get(derivative).map;
                    }
                });
            }
        },
        {
            key: "deleteByPath",
            value: function deleteByPath(currentCache, derivatives) {
                var cache = currentCache.get(derivatives[0]);
                if (derivatives.length === 1) {
                    var _cache$value;
                    if (!cache.map) currentCache.delete(derivatives[0]);
                    else currentCache.set(derivatives[0], {
                        map: cache.map
                    });
                    return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
                }
                var result = this.deleteByPath(cache.map, derivatives.slice(1));
                if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
                return result;
            }
        },
        {
            key: "delete",
            value: function _delete(derivativeOption) {
                // If cache exists
                if (this.has(derivativeOption)) {
                    this.keys = this.keys.filter(function(item) {
                        return !$06e75d38ebf58c74$export$dd65e95e99ed0739(item, derivativeOption);
                    });
                    return this.deleteByPath(this.cache, derivativeOption);
                }
                return undefined;
            }
        }
    ]);
    return ThemeCache;
}();
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($06e75d38ebf58c74$export$2e2bcd8739ae039, "MAX_CACHE_SIZE", 20);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($06e75d38ebf58c74$export$2e2bcd8739ae039, "MAX_CACHE_OFFSET", 5);






var $3dd697ea901030c8$var$uuid = 0;
/**
 * Theme with algorithms to derive tokens from design tokens.
 * Use `createTheme` first which will help to manage the theme instance cache.
 */ var $3dd697ea901030c8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Theme(derivatives) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Theme);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "derivatives", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "id", void 0);
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $3dd697ea901030c8$var$uuid;
        if (derivatives.length === 0) (0, $05a5f2c645683a81$export$491112666e282270)(derivatives.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function.");
        $3dd697ea901030c8$var$uuid += 1;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Theme, [
        {
            key: "getDerivativeToken",
            value: function getDerivativeToken(token) {
                return this.derivatives.reduce(function(result, derivative) {
                    return derivative(token, result);
                }, undefined);
            }
        }
    ]);
    return Theme;
}();


var $db48c74b3367fd88$var$cacheThemes = new (0, $06e75d38ebf58c74$export$2e2bcd8739ae039)();
function $db48c74b3367fd88$export$2e2bcd8739ae039(derivatives) {
    var derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$db48c74b3367fd88$var$cacheThemes.has(derivativeArr)) $db48c74b3367fd88$var$cacheThemes.set(derivativeArr, new (0, $3dd697ea901030c8$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $db48c74b3367fd88$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
var $f97444ff16d95e90$var$resultCache = new WeakMap();
var $f97444ff16d95e90$var$RESULT_VALUE = {};
function $f97444ff16d95e90$export$6aabcc1951563d93(callback, deps) {
    var current = $f97444ff16d95e90$var$resultCache;
    for(var i = 0; i < deps.length; i += 1){
        var dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($f97444ff16d95e90$var$RESULT_VALUE)) current.set($f97444ff16d95e90$var$RESULT_VALUE, callback());
    return current.get($f97444ff16d95e90$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
var $f97444ff16d95e90$var$flattenTokenCache = new WeakMap();
function $f97444ff16d95e90$export$597374558a261efc(token) {
    var hashed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var str = $f97444ff16d95e90$var$flattenTokenCache.get(token) || "";
    if (!str) {
        Object.keys(token).forEach(function(key) {
            var value = token[key];
            str += key;
            if (value instanceof (0, $3dd697ea901030c8$export$2e2bcd8739ae039)) str += value.id;
            else if (value && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object") str += $f97444ff16d95e90$export$597374558a261efc(value, hashed);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        if (hashed) str = (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(str);
        // Put in cache
        $f97444ff16d95e90$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $f97444ff16d95e90$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("".concat(salt, "_").concat($f97444ff16d95e90$export$597374558a261efc(token, true)));
}
var $f97444ff16d95e90$var$randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, "");
// Magic `content` for detect selector support
var $f97444ff16d95e90$var$checkContent = "_bAmBoO_";
function $f97444ff16d95e90$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
        var _getComputedStyle$con, _ele$parentNode;
        (0, $3a22468320d7d808$export$4d99a2890bb989f0)(styleStr, $f97444ff16d95e90$var$randomSelectorKey);
        var _ele = document.createElement("div");
        _ele.style.position = "fixed";
        _ele.style.left = "0";
        _ele.style.top = "0";
        handleElement === null || handleElement === void 0 || handleElement(_ele);
        document.body.appendChild(_ele);
        var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes($f97444ff16d95e90$var$checkContent);
        (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
        (0, $3a22468320d7d808$export$2232e336aecaa80a)($f97444ff16d95e90$var$randomSelectorKey);
        return support;
    }
    return false;
}
var $f97444ff16d95e90$var$canLayer = undefined;
function $f97444ff16d95e90$export$ac8d3fd9840e20dd() {
    if ($f97444ff16d95e90$var$canLayer === undefined) $f97444ff16d95e90$var$canLayer = $f97444ff16d95e90$var$supportSelector("@layer ".concat($f97444ff16d95e90$var$randomSelectorKey, " { .").concat($f97444ff16d95e90$var$randomSelectorKey, ' { content: "').concat($f97444ff16d95e90$var$checkContent, '"!important; } }'), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canLayer;
}
var $f97444ff16d95e90$var$canWhere = undefined;
function $f97444ff16d95e90$export$f51d3b8ac4ac9ed1() {
    if ($f97444ff16d95e90$var$canWhere === undefined) $f97444ff16d95e90$var$canWhere = $f97444ff16d95e90$var$supportSelector(":where(.".concat($f97444ff16d95e90$var$randomSelectorKey, ') { content: "').concat($f97444ff16d95e90$var$checkContent, '"!important; }'), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    });
    return $f97444ff16d95e90$var$canWhere;
}
var $f97444ff16d95e90$var$canLogic = undefined;
function $f97444ff16d95e90$export$64a912f57d5de48e() {
    if ($f97444ff16d95e90$var$canLogic === undefined) $f97444ff16d95e90$var$canLogic = $f97444ff16d95e90$var$supportSelector(".".concat($f97444ff16d95e90$var$randomSelectorKey, " { inset-block: 93px !important; }"), function(ele) {
        ele.className = $f97444ff16d95e90$var$randomSelectorKey;
    }, function(ele) {
        return getComputedStyle(ele).bottom === "93px";
    });
    return $f97444ff16d95e90$var$canLogic;
}
var $f97444ff16d95e90$export$9542afab8c2a5f48 = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)();
function $f97444ff16d95e90$export$523c0b569236b342(num) {
    if (typeof num === "number") return "".concat(num, "px");
    return num;
}
function $f97444ff16d95e90$export$71c98ec84f0481d3(style, tokenKey, styleId) {
    var customizeAttrs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var plain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (plain) return style;
    var attrs = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, customizeAttrs), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $182b356f02bf1b9b$export$5d99297dcd5476ac), tokenKey), (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e), styleId));
    var attrStr = Object.keys(attrs).map(function(attr) {
        var val = attrs[attr];
        return val ? "".concat(attr, '="').concat(val, '"') : null;
    }).filter(function(v) {
        return v;
    }).join(" ");
    return "<style ".concat(attrStr, ">").concat(style, "</style>");
}



var $5a4d26b111585357$export$309b3b095f0c7662 = function token2CSSVar(token) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return "--".concat(prefix ? "".concat(prefix, "-") : "").concat(token).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
};
var $5a4d26b111585357$export$a27ef1ee9bbc757e = function serializeCSSVar(cssVars, hashId, options) {
    if (!Object.keys(cssVars).length) return "";
    return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : "", "{").concat(Object.entries(cssVars).map(function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
        return "".concat(key, ":").concat(value, ";");
    }).join(""), "}");
};
var $5a4d26b111585357$export$67858afe85bce49f = function transformToken(token, themeKey, config) {
    var cssVars = {};
    var result = {};
    Object.entries(token).forEach(function(_ref3) {
        var _config$preserve, _config$ignore;
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], value = _ref4[1];
        if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) result[key] = value;
        else if ((typeof value === "string" || typeof value === "number") && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
            var _config$unitless;
            var cssVar = $5a4d26b111585357$export$309b3b095f0c7662(key, config === null || config === void 0 ? void 0 : config.prefix);
            cssVars[cssVar] = typeof value === "number" && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
            result[key] = "var(".concat(cssVar, ")");
        }
    });
    return [
        result,
        $5a4d26b111585357$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config === null || config === void 0 ? void 0 : config.scope
        })
    ];
};





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $493347a9fd5d8394$var$useInternalLayoutEffect = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() ? $acw62.useLayoutEffect : $acw62.useEffect;
var $493347a9fd5d8394$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $acw62.useRef(true);
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $493347a9fd5d8394$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $493347a9fd5d8394$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $493347a9fd5d8394$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $493347a9fd5d8394$export$2e2bcd8739ae039 = $493347a9fd5d8394$var$useLayoutEffect;



var $acw62 = parcelRequire("acw62");
// We need fully clone React function here
// to avoid webpack warning React 17 do not export `useId`
var $dbf330e0793a2d94$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
var $dbf330e0793a2d94$var$useInsertionEffect = $dbf330e0793a2d94$var$fullClone.useInsertionEffect;
/**
 * Polyfill `useInsertionEffect` for React < 18
 * @param renderEffect will be executed in `useMemo`, and do not have callback
 * @param effect will be executed in `useLayoutEffect`
 * @param deps
 */ var $dbf330e0793a2d94$var$useInsertionEffectPolyfill = function useInsertionEffectPolyfill(renderEffect, effect, deps) {
    $acw62.useMemo(renderEffect, deps);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        return effect(true);
    }, deps);
};
/**
 * Compatible `useInsertionEffect`
 * will use `useInsertionEffect` if React version >= 18,
 * otherwise use `useInsertionEffectPolyfill`.
 */ var $dbf330e0793a2d94$var$useCompatibleInsertionEffect = $dbf330e0793a2d94$var$useInsertionEffect ? function(renderEffect, effect, deps) {
    return $dbf330e0793a2d94$var$useInsertionEffect(function() {
        renderEffect();
        return effect();
    }, deps);
} : $dbf330e0793a2d94$var$useInsertionEffectPolyfill;
var $dbf330e0793a2d94$export$2e2bcd8739ae039 = $dbf330e0793a2d94$var$useCompatibleInsertionEffect;





var $acw62 = parcelRequire("acw62");
var $7ee590fd65ab0539$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
var $7ee590fd65ab0539$var$useInsertionEffect = $7ee590fd65ab0539$var$fullClone.useInsertionEffect;
// DO NOT register functions in useEffect cleanup function, or functions that registered will never be called.
var $7ee590fd65ab0539$var$useCleanupRegister = function useCleanupRegister(deps) {
    var effectCleanups = [];
    var cleanupFlag = false;
    function register(fn) {
        if (cleanupFlag) return;
        effectCleanups.push(fn);
    }
    $acw62.useEffect(function() {
        // Compatible with strict mode
        cleanupFlag = false;
        return function() {
            cleanupFlag = true;
            if (effectCleanups.length) effectCleanups.forEach(function(fn) {
                return fn();
            });
        };
    }, deps);
    return register;
};
var $7ee590fd65ab0539$var$useRun = function useRun() {
    return function(fn) {
        fn();
    };
};
// Only enable register in React 18
var $7ee590fd65ab0539$var$useEffectCleanupRegister = typeof $7ee590fd65ab0539$var$useInsertionEffect !== "undefined" ? $7ee590fd65ab0539$var$useCleanupRegister : $7ee590fd65ab0539$var$useRun;
var $7ee590fd65ab0539$export$2e2bcd8739ae039 = $7ee590fd65ab0539$var$useEffectCleanupRegister;


function $89824b6453bf0586$var$useProdHMR() {
    return false;
}
var $89824b6453bf0586$var$webpackHMR = false;
function $89824b6453bf0586$var$useDevHMR() {
    return $89824b6453bf0586$var$webpackHMR;
}
var $89824b6453bf0586$export$2e2bcd8739ae039 = $89824b6453bf0586$var$useProdHMR;
var $89824b6453bf0586$var$win, $89824b6453bf0586$var$originWebpackHotUpdate;


function $5cf8f09379a7b7de$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    var _React$useContext = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), globalCache = _React$useContext.cache;
    var fullPath = [
        prefix
    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyPath));
    var fullPathStr = (0, $7399254758448c39$export$1d14e1d8187b9aad)(fullPath);
    var register = (0, $7ee590fd65ab0539$export$2e2bcd8739ae039)([
        fullPathStr
    ]);
    var HMRUpdate = (0, $89824b6453bf0586$export$2e2bcd8739ae039)();
    var buildCache = function buildCache(updater) {
        globalCache.opUpdate(fullPathStr, function(prevCache) {
            var _ref = prevCache || [
                undefined,
                undefined
            ], _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
            // HMR should always ignore cache since developer may change it
            var tmpCache = cache;
            var mergedCache = tmpCache || cacheFn();
            var data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $acw62.useMemo(function() {
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    var cacheEntity = globalCache.opGet(fullPathStr);
    var cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $dbf330e0793a2d94$export$2e2bcd8739ae039)(function() {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
    }, function(polyfill) {
        // It's bad to call build again in effect.
        // But we have to do this since StrictMode will call effect twice
        // which will clear cache on the first time.
        buildCache(function(_ref3) {
            var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), times = _ref4[0], cache = _ref4[1];
            if (polyfill && times === 0) onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
            return [
                times + 1,
                cache
            ];
        });
        return function() {
            globalCache.opUpdate(fullPathStr, function(prevCache) {
                var _ref5 = prevCache || [], _ref6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
                var nextCount = times - 1;
                if (nextCount === 0) {
                    // Always remove styles in useEffect callback
                    register(function() {
                        // With polyfill, registered callback will always be called synchronously
                        // But without polyfill, it will be called in effect clean up,
                        // And by that time this cache is cleaned up.
                        if (polyfill || !globalCache.opGet(fullPathStr)) onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
                    });
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


var $fb047830d7776fb2$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
var $fb047830d7776fb2$var$hashPrefix = "css";
var $fb047830d7776fb2$var$tokenKeys = new Map();
function $fb047830d7776fb2$var$recordCleanToken(tokenKey) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $fb047830d7776fb2$var$removeStyleTags(key, instanceId) {
    if (typeof document !== "undefined") {
        var styles = document.querySelectorAll("style[".concat((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), '="').concat(key, '"]'));
        styles.forEach(function(style) {
            if (style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] === instanceId) {
                var _style$parentNode;
                (_style$parentNode = style.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style);
            }
        });
    }
}
var $fb047830d7776fb2$var$TOKEN_THRESHOLD = 0;
// Remove will check current keys first
function $fb047830d7776fb2$var$cleanTokenStyle(tokenKey, instanceId) {
    $fb047830d7776fb2$var$tokenKeys.set(tokenKey, ($fb047830d7776fb2$var$tokenKeys.get(tokenKey) || 0) - 1);
    var tokenKeyList = Array.from($fb047830d7776fb2$var$tokenKeys.keys());
    var cleanableKeyList = tokenKeyList.filter(function(key) {
        var count = $fb047830d7776fb2$var$tokenKeys.get(key) || 0;
        return count <= 0;
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeyList.length - cleanableKeyList.length > $fb047830d7776fb2$var$TOKEN_THRESHOLD) cleanableKeyList.forEach(function(key) {
        $fb047830d7776fb2$var$removeStyleTags(key, instanceId);
        $fb047830d7776fb2$var$tokenKeys.delete(key);
    });
}
var $fb047830d7776fb2$export$18602cb46ae80b62 = function getComputedToken(originToken, overrideToken, theme, format) {
    var derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    var mergedDerivativeToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, derivativeToken), overrideToken);
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
var $fb047830d7776fb2$export$270fba097347f4fa = "token";
function $fb047830d7776fb2$export$2e2bcd8739ae039(theme, tokens) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _useContext = (0, $acw62.useContext)((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var _option$salt = option.salt, salt = _option$salt === void 0 ? "" : _option$salt, _option$override = option.override, override = _option$override === void 0 ? $fb047830d7776fb2$var$EMPTY_OVERRIDE : _option$override, formatToken = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
    // Basic - We do basic cache here
    var mergedToken = (0, $f97444ff16d95e90$export$6aabcc1951563d93)(function() {
        return Object.assign.apply(Object, [
            {}
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(tokens)));
    }, tokens);
    var tokenStr = (0, $f97444ff16d95e90$export$597374558a261efc)(mergedToken);
    var overrideTokenStr = (0, $f97444ff16d95e90$export$597374558a261efc)(override);
    var cssVarStr = cssVar ? (0, $f97444ff16d95e90$export$597374558a261efc)(cssVar) : "";
    var cachedToken = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($fb047830d7776fb2$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], function() {
        var _cssVar$key;
        var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $fb047830d7776fb2$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        // Replace token value with css variables
        var actualToken = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedDerivativeToken);
        var cssVarsStr = "";
        if (!!cssVar) {
            var _transformToken = (0, $5a4d26b111585357$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
                prefix: cssVar.prefix,
                ignore: cssVar.ignore,
                unitless: cssVar.unitless,
                preserve: cssVar.preserve
            });
            var _transformToken2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_transformToken, 2);
            mergedDerivativeToken = _transformToken2[0];
            cssVarsStr = _transformToken2[1];
        }
        // Optimize for `useStyleRegister` performance
        var tokenKey = (0, $f97444ff16d95e90$export$6c82d0ebe8f2ea2c)(mergedDerivativeToken, salt);
        mergedDerivativeToken._tokenKey = tokenKey;
        actualToken._tokenKey = (0, $f97444ff16d95e90$export$6c82d0ebe8f2ea2c)(actualToken, salt);
        var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
        mergedDerivativeToken._themeKey = themeKey;
        $fb047830d7776fb2$var$recordCleanToken(themeKey);
        var hashId = "".concat($fb047830d7776fb2$var$hashPrefix, "-").concat((0, $c0f5cb12993018cc$export$2e2bcd8739ae039)(tokenKey));
        mergedDerivativeToken._hashId = hashId; // Not used
        return [
            mergedDerivativeToken,
            hashId,
            actualToken,
            cssVarsStr,
            (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ""
        ];
    }, function(cache) {
        // Remove token will remove all related style
        $fb047830d7776fb2$var$cleanTokenStyle(cache[0]._themeKey, instanceId);
    }, function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 4), token = _ref2[0], cssVarsStr = _ref2[3];
        if (cssVar && cssVarsStr) {
            var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(cssVarsStr, (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("css-variables-".concat(token._themeKey)), {
                mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
                prepend: "queue",
                attachTo: container,
                priority: -999
            });
            style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), token._themeKey);
        }
    });
    return cachedToken;
}
var $fb047830d7776fb2$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
    var _ref3 = options || {}, plain = _ref3.plain;
    if (!styleStr) return null;
    var styleId = realToken._tokenKey;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    var styleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};






var $acw62 = parcelRequire("acw62");




function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}










var $acw62 = parcelRequire("acw62");
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;




function $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03(message, info) {
    var path = info.path, parentSelectors = info.parentSelectors;
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "[Ant Design CSS-in-JS] ".concat(path ? "Error in ".concat(path, ": ") : "").concat(message).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(" | ")) : ""));
}


var $e6dfef8f0af50f8c$var$linter = function linter(key, value, info) {
    if (key === "content") {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        var contentValues = [
            "normal",
            "none",
            "initial",
            "inherit",
            "unset"
        ];
        if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
};
var $e6dfef8f0af50f8c$export$2e2bcd8739ae039 = $e6dfef8f0af50f8c$var$linter;



var $ce6167d258bd4ce8$var$linter = function linter(key, value, info) {
    if (key === "animation") {
        if (info.hashId && value !== "none") (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
};
var $ce6167d258bd4ce8$export$2e2bcd8739ae039 = $ce6167d258bd4ce8$var$linter;



function $0f2f0342ec57fd4c$var$isConcatSelector(selector) {
    var _selector$match;
    var notContent = ((_selector$match = selector.match(/:not\(([^)]*)\)/)) === null || _selector$match === void 0 ? void 0 : _selector$match[1]) || "";
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    var splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter(function(str) {
        return str;
    });
    return splitCells.length > 1;
}
function $0f2f0342ec57fd4c$var$parsePath(info) {
    return info.parentSelectors.reduce(function(prev, cur) {
        if (!prev) return cur;
        return cur.includes("&") ? cur.replace(/&/g, prev) : "".concat(prev, " ").concat(cur);
    }, "");
}
var $0f2f0342ec57fd4c$var$linter = function linter(key, value, info) {
    var parentSelectorPath = $0f2f0342ec57fd4c$var$parsePath(info);
    var notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($0f2f0342ec57fd4c$var$isConcatSelector)) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("Concat ':not' selector not support in legacy browsers.", info);
};
var $0f2f0342ec57fd4c$export$2e2bcd8739ae039 = $0f2f0342ec57fd4c$var$linter;



var $dfba7bff08539c12$var$linter = function linter(key, value, info) {
    switch(key){
        case "marginLeft":
        case "marginRight":
        case "paddingLeft":
        case "paddingRight":
        case "left":
        case "right":
        case "borderLeft":
        case "borderLeftWidth":
        case "borderLeftStyle":
        case "borderLeftColor":
        case "borderRight":
        case "borderRightWidth":
        case "borderRightStyle":
        case "borderRightColor":
        case "borderTopLeftRadius":
        case "borderTopRightRadius":
        case "borderBottomLeftRadius":
        case "borderBottomRightRadius":
            (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using non-logical property '".concat(key, "' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case "margin":
        case "padding":
        case "borderWidth":
        case "borderStyle":
            // case 'borderColor':
            if (typeof value === "string") {
                var valueArr = value.split(" ").map(function(item) {
                    return item.trim();
                });
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using '".concat(key, "' property with different left ").concat(key, " and right ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        case "clear":
        case "textAlign":
            if (value === "left" || value === "right") (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            return;
        case "borderRadius":
            if (typeof value === "string") {
                var radiusGroups = value.split("/").map(function(item) {
                    return item.trim();
                });
                var invalid = radiusGroups.reduce(function(result, group) {
                    if (result) return result;
                    var radiusArr = group.split(" ").map(function(item) {
                        return item.trim();
                    });
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("You seem to be using non-logical value '".concat(value, "' of ").concat(key, ", which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties."), info);
            }
            return;
        default:
    }
};
var $dfba7bff08539c12$export$2e2bcd8739ae039 = $dfba7bff08539c12$var$linter;



var $c9b112fad2a88d07$var$linter = function linter(key, value, info) {
    if (typeof value === "string" && /NaN/g.test(value) || Number.isNaN(value)) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("Unexpected 'NaN' in property '".concat(key, ": ").concat(value, "'."), info);
};
var $c9b112fad2a88d07$export$2e2bcd8739ae039 = $c9b112fad2a88d07$var$linter;



var $71a97720875b4c78$var$linter = function linter(key, value, info) {
    if (info.parentSelectors.some(function(selector) {
        var selectors = selector.split(",");
        return selectors.some(function(item) {
            return item.split("&").length > 2;
        });
    })) (0, $9ec21e6fbb3413b1$export$e7b7955c4f1f8c03)("Should not use more than one `&` in a selector.", info);
};
var $71a97720875b4c78$export$2e2bcd8739ae039 = $71a97720875b4c78$var$linter;









var $535d769197131042$export$1c054aa01963e47e = "data-ant-cssinjs-cache-path";
var $535d769197131042$export$e0a2f8ff7fc63361 = "_FILE_STYLE__";
function $535d769197131042$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map(function(path) {
        var hash = cachePathMap[path];
        return "".concat(path, ":").concat(hash);
    }).join(";");
}
var $535d769197131042$var$cachePathMap;
var $535d769197131042$var$fromCSSFile = true;
function $535d769197131042$export$aad8462122ac592b(mockCache) {
    var fromFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $535d769197131042$var$cachePathMap = mockCache;
    $535d769197131042$var$fromCSSFile = fromFile;
}
function $535d769197131042$export$18298bb220d85216() {
    if (!$535d769197131042$var$cachePathMap) {
        $535d769197131042$var$cachePathMap = {};
        if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
            var div = document.createElement("div");
            div.className = $535d769197131042$export$1c054aa01963e47e;
            div.style.position = "fixed";
            div.style.visibility = "hidden";
            div.style.top = "-9999px";
            document.body.appendChild(div);
            var content = getComputedStyle(div).content || "";
            content = content.replace(/^"/, "").replace(/"$/, "");
            // Fill data
            content.split(";").forEach(function(item) {
                var _item$split = item.split(":"), _item$split2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_item$split, 2), path = _item$split2[0], hash = _item$split2[1];
                $535d769197131042$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            var inlineMapStyle = document.querySelector("style[".concat($535d769197131042$export$1c054aa01963e47e, "]"));
            if (inlineMapStyle) {
                var _inlineMapStyle$paren;
                $535d769197131042$var$fromCSSFile = false;
                (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $535d769197131042$export$5aa0d776d676ab98(path) {
    $535d769197131042$export$18298bb220d85216();
    return !!$535d769197131042$var$cachePathMap[path];
}
function $535d769197131042$export$d3851dfd3659b2ce(path) {
    var hash = $535d769197131042$var$cachePathMap[path];
    var styleStr = null;
    if (hash && (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
        if ($535d769197131042$var$fromCSSFile) styleStr = $535d769197131042$export$e0a2f8ff7fc63361;
        else {
            var _style = document.querySelector("style[".concat((0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e), '="').concat($535d769197131042$var$cachePathMap[path], '"]'));
            if (_style) styleStr = _style.innerHTML;
            else // Clean up since not exist anymore
            delete $535d769197131042$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



var $7927865cee518bb3$var$SKIP_CHECK = "_skip_check_";
var $7927865cee518bb3$var$MULTI_VALUE = "_multi_value_";
function $7927865cee518bb3$export$8756898546458274(styleStr) {
    var serialized = (0, $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb)((0, $298fb931ed4fbf8b$export$ef7acd7185315e22)(styleStr), (0, $298fb931ed4fbf8b$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ";");
}
function $7927865cee518bb3$var$isCompoundCSSProperty(value) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && value && ($7927865cee518bb3$var$SKIP_CHECK in value || $7927865cee518bb3$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    var hashClassName = ".".concat(hashId);
    var hashSelector = hashPriority === "low" ? ":where(".concat(hashClassName, ")") : hashClassName;
    // 注入 hashId
    var keys = key.split(",").map(function(k) {
        var _firstPath$match;
        var fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        var firstPath = fullPath[0] || "";
        var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || "";
        firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
        return [
            firstPath
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(fullPath.slice(1))).join(" ");
    });
    return keys.join(",");
}
var $7927865cee518bb3$export$e13dc740254f53d7 = function parseStyle(interpolation) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        root: true,
        parentSelectors: []
    }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
    var hashId = config.hashId, layer = config.layer, path = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
    var styleStr = "";
    var effectStyle = {};
    function parseKeyframes(keyframes) {
        var animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            var _parseStyle = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            }), _parseStyle2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle, 1), _parsedStr = _parseStyle2[0];
            effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
        }
    }
    function flattenList(list) {
        var fullList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        list.forEach(function(item) {
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach(function(originStyle) {
        // Only root level can use raw string
        var style = typeof originStyle === "string" && !root ? {} : originStyle;
        if (typeof style === "string") styleStr += "".concat(style, "\n");
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            var mergedStyle = transformers.reduce(function(prev, trans) {
                var _trans$visit;
                return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev)) || prev;
            }, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach(function(key) {
                var value = mergedStyle[key];
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && value && (key !== "animationName" || !value._keyframe) && !$7927865cee518bb3$var$isCompoundCSSProperty(value)) {
                    var subInjectHash = false;
                    // 当成嵌套对象来处理
                    var mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    var nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith("@")) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else // 注入 hashId
                        mergedKey = $7927865cee518bb3$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === "&" || mergedKey === "")) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = "";
                        nextRoot = true;
                    }
                    var _parseStyle3 = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parentSelectors), [
                            mergedKey
                        ])
                    }), _parseStyle4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
                    effectStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, effectStyle), childEffectStyle);
                    styleStr += "".concat(mergedKey).concat(_parsedStr2);
                } else {
                    var _value;
                    function appendStyle(cssKey, cssValue) {
                        // 如果是样式则直接插入
                        var styleName = cssKey.replace(/[A-Z]/g, function(match) {
                            return "-".concat(match.toLowerCase());
                        });
                        // Auto suffix with px
                        var formatValue = cssValue;
                        if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === "number" && formatValue !== 0) formatValue = "".concat(formatValue, "px");
                        // handle animationName & Keyframe value
                        if (cssKey === "animationName" && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += "".concat(styleName, ":").concat(formatValue, ";");
                    }
                    var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && value !== null && value !== void 0 && value[$7927865cee518bb3$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach(function(item) {
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = "{".concat(styleStr, "}");
    else if (layer) {
        styleStr = "@layer ".concat(layer.name, " {").concat(styleStr, "}");
        if (layer.dependencies) effectStyle["@layer ".concat(layer.name)] = layer.dependencies.map(function(deps) {
            return "@layer ".concat(deps, ", ").concat(layer.name, ";");
        }).join("\n");
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $7927865cee518bb3$export$412618713057f6ca(path, styleStr) {
    return (0, $c0f5cb12993018cc$export$2e2bcd8739ae039)("".concat(path.join("%")).concat(styleStr));
}
function $7927865cee518bb3$var$Empty() {
    return null;
}
var $7927865cee518bb3$export$1e6d9f0d06c7ec14 = "style";
function $7927865cee518bb3$export$2e2bcd8739ae039(info, styleFn) {
    var token = info.token, path = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
    var _React$useContext = $acw62.useContext((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache, enableLayer = _React$useContext.layer;
    var tokenKey = token._tokenKey;
    var fullPath = [
        tokenKey
    ];
    if (enableLayer) fullPath.push("layer");
    fullPath.push.apply(fullPath, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(path));
    // Check if need insert style
    var isMergedClientSide = (0, $f97444ff16d95e90$export$9542afab8c2a5f48);
    var _useGlobalCache = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($7927865cee518bb3$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    function() {
        var cachePath = fullPath.join("|");
        // Get style from SSR inline style directly
        if ((0, $535d769197131042$export$5aa0d776d676ab98)(cachePath)) {
            var _getStyleAndHash = (0, $535d769197131042$export$d3851dfd3659b2ce)(cachePath), _getStyleAndHash2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                tokenKey,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        var styleObj = styleFn();
        var _parseStyle5 = $7927865cee518bb3$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join("-"),
            transformers: transformers,
            linters: linters
        }), _parseStyle6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
        var styleStr = $7927865cee518bb3$export$8756898546458274(parsedStyle);
        var styleId = $7927865cee518bb3$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            tokenKey,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    function(_ref2, fromHMR) {
        var _ref3 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref2, 3), styleId = _ref3[2];
        if ((fromHMR || autoClear) && (0, $f97444ff16d95e90$export$9542afab8c2a5f48)) (0, $3a22468320d7d808$export$2232e336aecaa80a)(styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e)
        });
    }, // Effect: Inject style here
    function(_ref4) {
        var _ref5 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
        if (isMergedClientSide && styleStr !== (0, $535d769197131042$export$e0a2f8ff7fc63361)) {
            var mergedCSSConfig = {
                mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : "queue",
                attachTo: container,
                priority: order
            };
            var nonceStr = typeof nonce === "function" ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            var effectLayerKeys = [];
            var effectRestKeys = [];
            Object.keys(effectStyle).forEach(function(key) {
                if (key.startsWith("@layer")) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach(function(effectKey) {
                (0, $3a22468320d7d808$export$4d99a2890bb989f0)($7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]), "_layer-".concat(effectKey), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedCSSConfig), {}, {
                    prepend: true
                }));
            });
            // ==================== Inject Style ====================
            // Inject style
            var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = cache.instanceId;
            // Used for `useCacheToken` to remove on batch when token removed
            style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), tokenKey);
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach(function(effectKey) {
                (0, $3a22468320d7d808$export$4d99a2890bb989f0)($7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
            });
        }
    }), _useGlobalCache2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
    return function(node) {
        var styleNode;
        if (!ssrInline || isMergedClientSide || !defaultCache) styleNode = /*#__PURE__*/ $acw62.createElement($7927865cee518bb3$var$Empty, null);
        else styleNode = /*#__PURE__*/ $acw62.createElement("style", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $182b356f02bf1b9b$export$5d99297dcd5476ac), cachedTokenKey), (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e), cachedStyleId), {
            dangerouslySetInnerHTML: {
                __html: cachedStyleStr
            }
        }));
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, styleNode, node);
    };
}
var $7927865cee518bb3$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
    var _ref7 = options || {}, plain = _ref7.plain;
    // Skip client only style
    if (clientOnly) return null;
    var keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    // ====================== Style ======================
    keyStyleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, tokenKey, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach(function(effectKey) {
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            var effectStyleStr = $7927865cee518bb3$export$8756898546458274(effectStyle[effectKey]);
            var effectStyleHTML = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
            if (effectKey.startsWith("@layer")) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


var $4766d7657208f51d$export$d96c342855c5e1fc = "cssVar";
var $4766d7657208f51d$var$useCSSVarRegister = function useCSSVarRegister(config, fn) {
    var key = config.key, prefix = config.prefix, unitless = config.unitless, ignore = config.ignore, token = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? "" : _config$scope;
    var _useContext = (0, $acw62.useContext)((0, $182b356f02bf1b9b$export$2e2bcd8739ae039)), instanceId = _useContext.cache.instanceId, container = _useContext.container;
    var tokenKey = token._tokenKey;
    var stylePath = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(config.path), [
        key,
        scope,
        tokenKey
    ]);
    var cache = (0, $5cf8f09379a7b7de$export$2e2bcd8739ae039)($4766d7657208f51d$export$d96c342855c5e1fc, stylePath, function() {
        var originToken = fn();
        var _transformToken = (0, $5a4d26b111585357$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope
        }), _transformToken2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
        var styleId = (0, $7927865cee518bb3$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, function(_ref) {
        var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 3), styleId = _ref2[2];
        if (0, $f97444ff16d95e90$export$9542afab8c2a5f48) (0, $3a22468320d7d808$export$2232e336aecaa80a)(styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e)
        });
    }, function(_ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
        if (!cssVarsStr) return;
        var style = (0, $3a22468320d7d808$export$4d99a2890bb989f0)(cssVarsStr, styleId, {
            mark: (0, $182b356f02bf1b9b$export$89ce1123b3c0bd9e),
            prepend: "queue",
            attachTo: container,
            priority: -999
        });
        style[0, $182b356f02bf1b9b$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $182b356f02bf1b9b$export$5d99297dcd5476ac), key);
    });
    return cache;
};
var $4766d7657208f51d$export$f9380c9a627682d3 = function extract(cache, effectStyles, options) {
    var _cache = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
    var _ref5 = options || {}, plain = _ref5.plain;
    if (!styleStr) return null;
    var order = -999;
    // ====================== Style ======================
    // Used for rc-util
    var sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": "".concat(order)
    };
    var styleText = (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $4766d7657208f51d$export$2e2bcd8739ae039 = $4766d7657208f51d$var$useCSSVarRegister;





var $0c1aa9cd61c22229$var$ExtractStyleFns = (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $7927865cee518bb3$export$1e6d9f0d06c7ec14), (0, $7927865cee518bb3$export$f9380c9a627682d3)), (0, $fb047830d7776fb2$export$270fba097347f4fa), (0, $fb047830d7776fb2$export$f9380c9a627682d3)), (0, $4766d7657208f51d$export$d96c342855c5e1fc), (0, $4766d7657208f51d$export$f9380c9a627682d3));
function $0c1aa9cd61c22229$var$isNotNull(value) {
    return value !== null;
}
function $0c1aa9cd61c22229$export$2e2bcd8739ae039(cache, options) {
    var _ref = typeof options === "boolean" ? {
        plain: options
    } : options || {}, _ref$plain = _ref.plain, plain = _ref$plain === void 0 ? false : _ref$plain, _ref$types = _ref.types, types = _ref$types === void 0 ? [
        "style",
        "token",
        "cssVar"
    ] : _ref$types;
    var matchPrefixRegexp = new RegExp("^(".concat((typeof types === "string" ? [
        types
    ] : types).join("|"), ")%"));
    // prefix with `style` is used for `useStyleRegister` to cache style context
    var styleKeys = Array.from(cache.cache.keys()).filter(function(key) {
        return matchPrefixRegexp.test(key);
    });
    // Common effect styles like animation
    var effectStyles = {};
    // Mapping of cachePath to style hash
    var cachePathMap = {};
    var styleText = "";
    styleKeys.map(function(key) {
        var cachePath = key.replace(matchPrefixRegexp, "").replace(/%/g, "|");
        var _key$split = key.split("%"), _key$split2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_key$split, 1), prefix = _key$split2[0];
        var extractFn = $0c1aa9cd61c22229$var$ExtractStyleFns[prefix];
        var extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        var _extractedStyle = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(extractedStyle, 3), order = _extractedStyle[0], styleId = _extractedStyle[1], styleStr = _extractedStyle[2];
        if (key.startsWith("style")) cachePathMap[cachePath] = styleId;
        return [
            order,
            styleStr
        ];
    }).filter($0c1aa9cd61c22229$var$isNotNull).sort(function(_ref2, _ref3) {
        var _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref2, 1), o1 = _ref4[0];
        var _ref5 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 1), o2 = _ref5[0];
        return o1 - o2;
    }).forEach(function(_ref6) {
        var _ref7 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref6, 2), style = _ref7[1];
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $f97444ff16d95e90$export$71c98ec84f0481d3)(".".concat((0, $535d769197131042$export$1c054aa01963e47e), '{content:"').concat((0, $535d769197131042$export$dfdc1655ccc5b9cb)(cachePathMap), '";}'), undefined, undefined, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $535d769197131042$export$1c054aa01963e47e), (0, $535d769197131042$export$1c054aa01963e47e)), plain);
    return styleText;
}








var $cb64545ddf8f118e$var$Keyframe = /*#__PURE__*/ function() {
    function Keyframe(name, style) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Keyframe);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "name", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "style", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_keyframe", true);
        this.name = name;
        this.style = style;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Keyframe, [
        {
            key: "getName",
            value: function getName() {
                var hashId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
                return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
            }
        }
    ]);
    return Keyframe;
}();
var $cb64545ddf8f118e$export$2e2bcd8739ae039 = $cb64545ddf8f118e$var$Keyframe;






function $c8e2e5c3988aca39$var$splitValues(value) {
    if (typeof value === "number") return [
        [
            value
        ],
        false
    ];
    var rawStyle = String(value).trim();
    var importantCells = rawStyle.match(/(.*)(!important)/);
    var splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    var temp = [];
    var brackets = 0;
    return [
        splitStyle.reduce(function(list, item) {
            if (item.includes("(") || item.includes(")")) {
                var left = item.split("(").length - 1;
                var right = item.split(")").length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(" "));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $c8e2e5c3988aca39$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
var $c8e2e5c3988aca39$var$keyMap = {
    // Inset
    inset: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    insetBlock: [
        "top",
        "bottom"
    ],
    insetBlockStart: [
        "top"
    ],
    insetBlockEnd: [
        "bottom"
    ],
    insetInline: [
        "left",
        "right"
    ],
    insetInlineStart: [
        "left"
    ],
    insetInlineEnd: [
        "right"
    ],
    // Margin
    marginBlock: [
        "marginTop",
        "marginBottom"
    ],
    marginBlockStart: [
        "marginTop"
    ],
    marginBlockEnd: [
        "marginBottom"
    ],
    marginInline: [
        "marginLeft",
        "marginRight"
    ],
    marginInlineStart: [
        "marginLeft"
    ],
    marginInlineEnd: [
        "marginRight"
    ],
    // Padding
    paddingBlock: [
        "paddingTop",
        "paddingBottom"
    ],
    paddingBlockStart: [
        "paddingTop"
    ],
    paddingBlockEnd: [
        "paddingBottom"
    ],
    paddingInline: [
        "paddingLeft",
        "paddingRight"
    ],
    paddingInlineStart: [
        "paddingLeft"
    ],
    paddingInlineEnd: [
        "paddingRight"
    ],
    // Border
    borderBlock: $c8e2e5c3988aca39$var$noSplit([
        "borderTop",
        "borderBottom"
    ]),
    borderBlockStart: $c8e2e5c3988aca39$var$noSplit([
        "borderTop"
    ]),
    borderBlockEnd: $c8e2e5c3988aca39$var$noSplit([
        "borderBottom"
    ]),
    borderInline: $c8e2e5c3988aca39$var$noSplit([
        "borderLeft",
        "borderRight"
    ]),
    borderInlineStart: $c8e2e5c3988aca39$var$noSplit([
        "borderLeft"
    ]),
    borderInlineEnd: $c8e2e5c3988aca39$var$noSplit([
        "borderRight"
    ]),
    // Border width
    borderBlockWidth: [
        "borderTopWidth",
        "borderBottomWidth"
    ],
    borderBlockStartWidth: [
        "borderTopWidth"
    ],
    borderBlockEndWidth: [
        "borderBottomWidth"
    ],
    borderInlineWidth: [
        "borderLeftWidth",
        "borderRightWidth"
    ],
    borderInlineStartWidth: [
        "borderLeftWidth"
    ],
    borderInlineEndWidth: [
        "borderRightWidth"
    ],
    // Border style
    borderBlockStyle: [
        "borderTopStyle",
        "borderBottomStyle"
    ],
    borderBlockStartStyle: [
        "borderTopStyle"
    ],
    borderBlockEndStyle: [
        "borderBottomStyle"
    ],
    borderInlineStyle: [
        "borderLeftStyle",
        "borderRightStyle"
    ],
    borderInlineStartStyle: [
        "borderLeftStyle"
    ],
    borderInlineEndStyle: [
        "borderRightStyle"
    ],
    // Border color
    borderBlockColor: [
        "borderTopColor",
        "borderBottomColor"
    ],
    borderBlockStartColor: [
        "borderTopColor"
    ],
    borderBlockEndColor: [
        "borderBottomColor"
    ],
    borderInlineColor: [
        "borderLeftColor",
        "borderRightColor"
    ],
    borderInlineStartColor: [
        "borderLeftColor"
    ],
    borderInlineEndColor: [
        "borderRightColor"
    ],
    // Border radius
    borderStartStartRadius: [
        "borderTopLeftRadius"
    ],
    borderStartEndRadius: [
        "borderTopRightRadius"
    ],
    borderEndStartRadius: [
        "borderBottomLeftRadius"
    ],
    borderEndEndRadius: [
        "borderBottomRightRadius"
    ]
};
function $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, important) {
    var parsedValue = value;
    if (important) parsedValue = "".concat(parsedValue, " !important");
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ var $c8e2e5c3988aca39$var$transform = {
    visit: function visit(cssObj) {
        var clone = {};
        Object.keys(cssObj).forEach(function(key) {
            var value = cssObj[key];
            var matchValue = $c8e2e5c3988aca39$var$keyMap[key];
            if (matchValue && (typeof value === "number" || typeof value === "string")) {
                var _splitValues = $c8e2e5c3988aca39$var$splitValues(value), _splitValues2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_splitValues, 2), _values = _splitValues2[0], _important = _splitValues2[1];
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach(function(matchKey) {
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(value, _important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck(_values[0], _important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach(function(matchKey, index) {
                    var _values$index;
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck((_values$index = _values[index]) !== null && _values$index !== void 0 ? _values$index : _values[0], _important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach(function(matchKey, index) {
                    var _ref, _values$index2;
                    clone[matchKey] = $c8e2e5c3988aca39$var$wrapImportantAndSkipCheck((_ref = (_values$index2 = _values[index]) !== null && _values$index2 !== void 0 ? _values$index2 : _values[index - 2]) !== null && _ref !== void 0 ? _ref : _values[0], _important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $c8e2e5c3988aca39$export$2e2bcd8739ae039 = $c8e2e5c3988aca39$var$transform;





var $3d71e62b1d8dd17b$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $3d71e62b1d8dd17b$var$toFixed(number, precision) {
    var multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
var $3d71e62b1d8dd17b$var$transform = function transform() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$rootValue = options.rootValue, rootValue = _options$rootValue === void 0 ? 16 : _options$rootValue, _options$precision = options.precision, precision = _options$precision === void 0 ? 5 : _options$precision, _options$mediaQuery = options.mediaQuery, mediaQuery = _options$mediaQuery === void 0 ? false : _options$mediaQuery;
    var pxReplace = function pxReplace(m, $1) {
        if (!$1) return m;
        var pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        var fixedVal = $3d71e62b1d8dd17b$var$toFixed(pixels / rootValue, precision);
        return "".concat(fixedVal, "rem");
    };
    var visit = function visit(cssObj) {
        var clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, cssObj);
        Object.entries(cssObj).forEach(function(_ref) {
            var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
            if (typeof value === "string" && value.includes("px")) {
                var newValue = value.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $d9263a4c6739b952$export$2e2bcd8739ae039)[key] && typeof value === "number" && value !== 0) clone[key] = "".concat(value, "px").replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
            // Media queries
            var mergedKey = key.trim();
            if (mergedKey.startsWith("@") && mergedKey.includes("px") && mediaQuery) {
                var newKey = key.replace($3d71e62b1d8dd17b$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $3d71e62b1d8dd17b$export$2e2bcd8739ae039 = $3d71e62b1d8dd17b$var$transform;




var $26595656c8972ad7$export$73abaea5066f503b = {
    supportModernCSS: function supportModernCSS() {
        return (0, $f97444ff16d95e90$export$f51d3b8ac4ac9ed1)() && (0, $f97444ff16d95e90$export$64a912f57d5de48e)();
    }
};


var $aadef4b21b7a3672$export$2e2bcd8739ae039 = "5.19.1";


"use client";
var $d8781535a68aa2aa$export$2e2bcd8739ae039 = (0, $aadef4b21b7a3672$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

/**
 * Take input from [0, n] and return it as [0, 1]
 * @hidden
 */ function $89c3f0c2cde0477f$export$b0e60b43d1d059f0(n, max) {
    if ($89c3f0c2cde0477f$export$7bf7d6849640691b(n)) n = "100%";
    var isPercent = $89c3f0c2cde0477f$export$d86432a85610ea90(n);
    n = max === 360 ? n : Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (isPercent) n = parseInt(String(n * max), 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    if (max === 360) // If n is a hue given in degrees,
    // wrap around out-of-range values into [0, 360] range
    // then convert into [0, 1].
    n = (n < 0 ? n % max + max : n % max) / parseFloat(String(max));
    else // If n not a hue given in degrees
    // Convert into [0, 1] range if it isn't already.
    n = n % max / parseFloat(String(max));
    return n;
}
function $89c3f0c2cde0477f$export$5c5ee632c52bc4a2(val) {
    return Math.min(1, Math.max(0, val));
}
function $89c3f0c2cde0477f$export$7bf7d6849640691b(n) {
    return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
}
function $89c3f0c2cde0477f$export$d86432a85610ea90(n) {
    return typeof n === "string" && n.indexOf("%") !== -1;
}
function $89c3f0c2cde0477f$export$3ae665204365318d(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
function $89c3f0c2cde0477f$export$8ba0754c08bd5ca8(n) {
    if (n <= 1) return "".concat(Number(n) * 100, "%");
    return n;
}
function $89c3f0c2cde0477f$export$9decc9dc70e2c76f(c) {
    return c.length === 1 ? "0" + c : String(c);
}


function $5dbaaddf372549d4$export$1a0d7f039f803cb(r, g, b) {
    return {
        r: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255) * 255,
        g: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255) * 255,
        b: (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255) * 255
    };
}
function $5dbaaddf372549d4$export$c85ca4f4753af384(r, g, b) {
    r = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var s = 0;
    var l = (max + min) / 2;
    if (max === min) {
        s = 0;
        h = 0; // achromatic
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
function $5dbaaddf372549d4$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * (6 * t);
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5dbaaddf372549d4$export$29fb7152bd3f781a(h, s, l) {
    var r;
    var g;
    var b;
    h = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(h, 360);
    s = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(s, 100);
    l = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(l, 100);
    if (s === 0) {
        // achromatic
        g = l;
        b = l;
        r = l;
    } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = $5dbaaddf372549d4$var$hue2rgb(p, q, h + 1 / 3);
        g = $5dbaaddf372549d4$var$hue2rgb(p, q, h);
        b = $5dbaaddf372549d4$var$hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$f76e85ca00a47f5c(r, g, b) {
    r = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(r, 255);
    g = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(g, 255);
    b = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(b, 255);
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var v = max;
    var d = max - min;
    var s = max === 0 ? 0 : d / max;
    if (max === min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
            default:
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
function $5dbaaddf372549d4$export$210753cfeec758a5(h, s, v) {
    h = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(h, 360) * 6;
    s = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(s, 100);
    v = (0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(v, 100);
    var i = Math.floor(h);
    var f = h - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    var mod = i % 6;
    var r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod];
    var g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod];
    var b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
function $5dbaaddf372549d4$export$34d09c4a771c46ef(r, g, b, allow3Char) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
function $5dbaaddf372549d4$export$ffee5509a14af63d(r, g, b, a, allow4Char) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)($5dbaaddf372549d4$export$51dcdea396f3aff6(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
function $5dbaaddf372549d4$export$ce6645f7d73030f4(r, g, b, a) {
    var hex = [
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)($5dbaaddf372549d4$export$51dcdea396f3aff6(a)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(r).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(g).toString(16)),
        (0, $89c3f0c2cde0477f$export$9decc9dc70e2c76f)(Math.round(b).toString(16))
    ];
    return hex.join("");
}
function $5dbaaddf372549d4$export$51dcdea396f3aff6(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
function $5dbaaddf372549d4$export$616da979ad1c2414(h) {
    return $5dbaaddf372549d4$export$262b3ba788b4d07c(h) / 255;
}
function $5dbaaddf372549d4$export$262b3ba788b4d07c(val) {
    return parseInt(val, 16);
}
function $5dbaaddf372549d4$export$4076ec82b665900d(color) {
    return {
        r: color >> 16,
        g: (color & 0xff00) >> 8,
        b: color & 0xff
    };
}

/* eslint-disable @typescript-eslint/no-redundant-type-constituents */ 
// https://github.com/bahamas10/css-color-names/blob/master/css-color-names.json
/**
 * @hidden
 */ var $7c1331a6b98e7de3$export$e4b2ac9215619f8d = {
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aqua: "#00ffff",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    black: "#000000",
    blanchedalmond: "#ffebcd",
    blue: "#0000ff",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    fuchsia: "#ff00ff",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    goldenrod: "#daa520",
    gold: "#ffd700",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavenderblush: "#fff0f5",
    lavender: "#e6e6fa",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    maroon: "#800000",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    navy: "#000080",
    oldlace: "#fdf5e6",
    olive: "#808000",
    olivedrab: "#6b8e23",
    orange: "#ffa500",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#ff0000",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    silver: "#c0c0c0",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    teal: "#008080",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    white: "#ffffff",
    whitesmoke: "#f5f5f5",
    yellow: "#ffff00",
    yellowgreen: "#9acd32"
};



function $4146cacf0fc753c3$export$87de337d8199f22c(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color === "string") color = $4146cacf0fc753c3$export$56237d872eed15a0(color);
    if (typeof color === "object") {
        if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.r) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.g) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.b)) {
            rgb = (0, $5dbaaddf372549d4$export$1a0d7f039f803cb)(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.v)) {
            s = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.s);
            v = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.v);
            rgb = (0, $5dbaaddf372549d4$export$210753cfeec758a5)(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($4146cacf0fc753c3$export$80d4d71a83d4526d(color.h) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.s) && $4146cacf0fc753c3$export$80d4d71a83d4526d(color.l)) {
            s = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.s);
            l = (0, $89c3f0c2cde0477f$export$8ba0754c08bd5ca8)(color.l);
            rgb = (0, $5dbaaddf372549d4$export$29fb7152bd3f781a)(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (Object.prototype.hasOwnProperty.call(color, "a")) a = color.a;
    }
    a = (0, $89c3f0c2cde0477f$export$3ae665204365318d)(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// <http://www.w3.org/TR/css3-values/#integers>
var $4146cacf0fc753c3$var$CSS_INTEGER = "[-\\+]?\\d+%?";
// <http://www.w3.org/TR/css3-values/#number-value>
var $4146cacf0fc753c3$var$CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
// Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
var $4146cacf0fc753c3$var$CSS_UNIT = "(?:".concat($4146cacf0fc753c3$var$CSS_NUMBER, ")|(?:").concat($4146cacf0fc753c3$var$CSS_INTEGER, ")");
// Actual matching.
// Parentheses and commas are optional, but not required.
// Whitespace can take the place of commas or opening paren
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")[,|\\s]+(").concat($4146cacf0fc753c3$var$CSS_UNIT, ")\\s*\\)?");
var $4146cacf0fc753c3$var$matchers = {
    CSS_UNIT: new RegExp($4146cacf0fc753c3$var$CSS_UNIT),
    rgb: new RegExp("rgb" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + $4146cacf0fc753c3$var$PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function $4146cacf0fc753c3$export$56237d872eed15a0(color) {
    color = color.trim().toLowerCase();
    if (color.length === 0) return false;
    var named = false;
    if ((0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)[color]) {
        color = (0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)[color];
        named = true;
    } else if (color === "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match = $4146cacf0fc753c3$var$matchers.rgb.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.rgba.exec(color);
    if (match) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsl.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsla.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hsv.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    match = $4146cacf0fc753c3$var$matchers.hsva.exec(color);
    if (match) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    match = $4146cacf0fc753c3$var$matchers.hex8.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3]),
        a: (0, $5dbaaddf372549d4$export$616da979ad1c2414)(match[4]),
        format: named ? "name" : "hex8"
    };
    match = $4146cacf0fc753c3$var$matchers.hex6.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3]),
        format: named ? "name" : "hex"
    };
    match = $4146cacf0fc753c3$var$matchers.hex4.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3] + match[3]),
        a: (0, $5dbaaddf372549d4$export$616da979ad1c2414)(match[4] + match[4]),
        format: named ? "name" : "hex8"
    };
    match = $4146cacf0fc753c3$var$matchers.hex3.exec(color);
    if (match) return {
        r: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[1] + match[1]),
        g: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[2] + match[2]),
        b: (0, $5dbaaddf372549d4$export$262b3ba788b4d07c)(match[3] + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $4146cacf0fc753c3$export$80d4d71a83d4526d(color) {
    return Boolean($4146cacf0fc753c3$var$matchers.CSS_UNIT.exec(String(color)));
}


var $d1dea01cb419bab7$var$hueStep = 2; // 色相阶梯
var $d1dea01cb419bab7$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
var $d1dea01cb419bab7$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
var $d1dea01cb419bab7$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
var $d1dea01cb419bab7$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
var $d1dea01cb419bab7$var$lightColorCount = 5; // 浅色数量，主色上
var $d1dea01cb419bab7$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
var $d1dea01cb419bab7$var$darkColorMap = [
    {
        index: 7,
        opacity: 0.15
    },
    {
        index: 6,
        opacity: 0.25
    },
    {
        index: 5,
        opacity: 0.3
    },
    {
        index: 5,
        opacity: 0.45
    },
    {
        index: 5,
        opacity: 0.65
    },
    {
        index: 5,
        opacity: 0.85
    },
    {
        index: 4,
        opacity: 0.9
    },
    {
        index: 3,
        opacity: 0.95
    },
    {
        index: 2,
        opacity: 0.97
    },
    {
        index: 1,
        opacity: 0.98
    }
];
// Wrapper function ported from TinyColor.prototype.toHsv
// Keep it here because of `hsv.h * 360`
function $d1dea01cb419bab7$var$toHsv(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var hsv = (0, $5dbaaddf372549d4$export$f76e85ca00a47f5c)(r, g, b);
    return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v
    };
}
// Wrapper function ported from TinyColor.prototype.toHexString
// Keep it here because of the prefix `#`
function $d1dea01cb419bab7$var$toHex(_ref2) {
    var r = _ref2.r, g = _ref2.g, b = _ref2.b;
    return "#".concat((0, $5dbaaddf372549d4$export$34d09c4a771c46ef)(r, g, b, false));
}
// Wrapper function ported from TinyColor.prototype.mix, not treeshakable.
// Amount in range [0, 1]
// Assume color1 & color2 has no alpha, since the following src code did so.
function $d1dea01cb419bab7$var$mix(rgb1, rgb2, amount) {
    var p = amount / 100;
    var rgb = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b
    };
    return rgb;
}
function $d1dea01cb419bab7$var$getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $d1dea01cb419bab7$var$hueStep * i : Math.round(hsv.h) - $d1dea01cb419bab7$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $d1dea01cb419bab7$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    var saturation;
    if (light) saturation = hsv.s - $d1dea01cb419bab7$var$saturationStep * i;
    else if (i === $d1dea01cb419bab7$var$darkColorCount) saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep;
    else saturation = hsv.s + $d1dea01cb419bab7$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $d1dea01cb419bab7$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Number(saturation.toFixed(2));
}
function $d1dea01cb419bab7$var$getValue(hsv, i, light) {
    var value;
    if (light) value = hsv.v + $d1dea01cb419bab7$var$brightnessStep1 * i;
    else value = hsv.v - $d1dea01cb419bab7$var$brightnessStep2 * i;
    if (value > 1) value = 1;
    return Number(value.toFixed(2));
}
function $d1dea01cb419bab7$export$2e2bcd8739ae039(color) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var patterns = [];
    var pColor = (0, $4146cacf0fc753c3$export$87de337d8199f22c)(color);
    for(var i = $d1dea01cb419bab7$var$lightColorCount; i > 0; i -= 1){
        var hsv = $d1dea01cb419bab7$var$toHsv(pColor);
        var colorString = $d1dea01cb419bab7$var$toHex((0, $4146cacf0fc753c3$export$87de337d8199f22c)({
            h: $d1dea01cb419bab7$var$getHue(hsv, i, true),
            s: $d1dea01cb419bab7$var$getSaturation(hsv, i, true),
            v: $d1dea01cb419bab7$var$getValue(hsv, i, true)
        }));
        patterns.push(colorString);
    }
    patterns.push($d1dea01cb419bab7$var$toHex(pColor));
    for(var _i = 1; _i <= $d1dea01cb419bab7$var$darkColorCount; _i += 1){
        var _hsv = $d1dea01cb419bab7$var$toHsv(pColor);
        var _colorString = $d1dea01cb419bab7$var$toHex((0, $4146cacf0fc753c3$export$87de337d8199f22c)({
            h: $d1dea01cb419bab7$var$getHue(_hsv, _i),
            s: $d1dea01cb419bab7$var$getSaturation(_hsv, _i),
            v: $d1dea01cb419bab7$var$getValue(_hsv, _i)
        }));
        patterns.push(_colorString);
    }
    // dark theme patterns
    if (opts.theme === "dark") return $d1dea01cb419bab7$var$darkColorMap.map(function(_ref3) {
        var index = _ref3.index, opacity = _ref3.opacity;
        var darkColorString = $d1dea01cb419bab7$var$toHex($d1dea01cb419bab7$var$mix((0, $4146cacf0fc753c3$export$87de337d8199f22c)(opts.backgroundColor || "#141414"), (0, $4146cacf0fc753c3$export$87de337d8199f22c)(patterns[index]), opacity * 100));
        return darkColorString;
    });
    return patterns;
}


// Generated by script. Do NOT modify!
var $0b4842326956570d$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
var $0b4842326956570d$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$0b4842326956570d$export$a90204d1394caf30.primary = $0b4842326956570d$export$a90204d1394caf30[5];
var $0b4842326956570d$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$0b4842326956570d$export$e63a1643b2f79b16.primary = $0b4842326956570d$export$e63a1643b2f79b16[5];
var $0b4842326956570d$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$0b4842326956570d$export$ad766f34ace1cafd.primary = $0b4842326956570d$export$ad766f34ace1cafd[5];
var $0b4842326956570d$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$0b4842326956570d$export$c24201f7fe3571d8.primary = $0b4842326956570d$export$c24201f7fe3571d8[5];
var $0b4842326956570d$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$0b4842326956570d$export$594c5a8758200c32.primary = $0b4842326956570d$export$594c5a8758200c32[5];
var $0b4842326956570d$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$0b4842326956570d$export$221d31baf2636aad.primary = $0b4842326956570d$export$221d31baf2636aad[5];
var $0b4842326956570d$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$0b4842326956570d$export$955a2ebd2fb142ae.primary = $0b4842326956570d$export$955a2ebd2fb142ae[5];
var $0b4842326956570d$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$0b4842326956570d$export$7474046f446842ee.primary = $0b4842326956570d$export$7474046f446842ee[5];
var $0b4842326956570d$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$0b4842326956570d$export$2aa0182783e7e9de.primary = $0b4842326956570d$export$2aa0182783e7e9de[5];
var $0b4842326956570d$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$0b4842326956570d$export$4138d3aeddcbf415.primary = $0b4842326956570d$export$4138d3aeddcbf415[5];
var $0b4842326956570d$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$0b4842326956570d$export$e13cce2a2d16a9d4.primary = $0b4842326956570d$export$e13cce2a2d16a9d4[5];
var $0b4842326956570d$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$0b4842326956570d$export$2a9ca2e383622e18.primary = $0b4842326956570d$export$2a9ca2e383622e18[5];
var $0b4842326956570d$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$0b4842326956570d$export$e4c89085febbc618.primary = $0b4842326956570d$export$e4c89085febbc618[5];
var $0b4842326956570d$export$3e2c219d3ab79d01 = $0b4842326956570d$export$e4c89085febbc618;
var $0b4842326956570d$export$36ad6df0f83f284d = {
    red: $0b4842326956570d$export$a90204d1394caf30,
    volcano: $0b4842326956570d$export$e63a1643b2f79b16,
    orange: $0b4842326956570d$export$ad766f34ace1cafd,
    gold: $0b4842326956570d$export$c24201f7fe3571d8,
    yellow: $0b4842326956570d$export$594c5a8758200c32,
    lime: $0b4842326956570d$export$221d31baf2636aad,
    green: $0b4842326956570d$export$955a2ebd2fb142ae,
    cyan: $0b4842326956570d$export$7474046f446842ee,
    blue: $0b4842326956570d$export$2aa0182783e7e9de,
    geekblue: $0b4842326956570d$export$4138d3aeddcbf415,
    purple: $0b4842326956570d$export$e13cce2a2d16a9d4,
    magenta: $0b4842326956570d$export$2a9ca2e383622e18,
    grey: $0b4842326956570d$export$e4c89085febbc618
};
var $0b4842326956570d$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$0b4842326956570d$export$e984d34fc144caa1.primary = $0b4842326956570d$export$e984d34fc144caa1[5];
var $0b4842326956570d$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$0b4842326956570d$export$360e10f78e17a865.primary = $0b4842326956570d$export$360e10f78e17a865[5];
var $0b4842326956570d$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$0b4842326956570d$export$d5a12c698b31fa45.primary = $0b4842326956570d$export$d5a12c698b31fa45[5];
var $0b4842326956570d$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$0b4842326956570d$export$2330427fb6a6af6f.primary = $0b4842326956570d$export$2330427fb6a6af6f[5];
var $0b4842326956570d$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$0b4842326956570d$export$67d203119f0ecec.primary = $0b4842326956570d$export$67d203119f0ecec[5];
var $0b4842326956570d$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$0b4842326956570d$export$51ed2a10d86576ed.primary = $0b4842326956570d$export$51ed2a10d86576ed[5];
var $0b4842326956570d$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$0b4842326956570d$export$76a3d804058f9b5f.primary = $0b4842326956570d$export$76a3d804058f9b5f[5];
var $0b4842326956570d$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$0b4842326956570d$export$dee6c7c6683c0d88.primary = $0b4842326956570d$export$dee6c7c6683c0d88[5];
var $0b4842326956570d$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$0b4842326956570d$export$10e0fd027e632624.primary = $0b4842326956570d$export$10e0fd027e632624[5];
var $0b4842326956570d$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$0b4842326956570d$export$abdd57ab473bba66.primary = $0b4842326956570d$export$abdd57ab473bba66[5];
var $0b4842326956570d$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$0b4842326956570d$export$7a65e68792738764.primary = $0b4842326956570d$export$7a65e68792738764[5];
var $0b4842326956570d$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$0b4842326956570d$export$d260a9321db4ab86.primary = $0b4842326956570d$export$d260a9321db4ab86[5];
var $0b4842326956570d$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$0b4842326956570d$export$515283ba400ffa6c.primary = $0b4842326956570d$export$515283ba400ffa6c[5];
var $0b4842326956570d$export$24617255e4daf647 = {
    red: $0b4842326956570d$export$e984d34fc144caa1,
    volcano: $0b4842326956570d$export$360e10f78e17a865,
    orange: $0b4842326956570d$export$d5a12c698b31fa45,
    gold: $0b4842326956570d$export$2330427fb6a6af6f,
    yellow: $0b4842326956570d$export$67d203119f0ecec,
    lime: $0b4842326956570d$export$51ed2a10d86576ed,
    green: $0b4842326956570d$export$76a3d804058f9b5f,
    cyan: $0b4842326956570d$export$dee6c7c6683c0d88,
    blue: $0b4842326956570d$export$10e0fd027e632624,
    geekblue: $0b4842326956570d$export$abdd57ab473bba66,
    purple: $0b4842326956570d$export$7a65e68792738764,
    magenta: $0b4842326956570d$export$d260a9321db4ab86,
    grey: $0b4842326956570d$export$515283ba400ffa6c
};






const $b1208bbc03407e2e$export$37e27b43af4d16eb = {
    blue: "#1677FF",
    purple: "#722ED1",
    cyan: "#13C2C2",
    green: "#52C41A",
    magenta: "#EB2F96",
    /**
   * @deprecated Use magenta instead
   */ pink: "#EB2F96",
    red: "#F5222D",
    orange: "#FA8C16",
    yellow: "#FADB14",
    volcano: "#FA541C",
    geekblue: "#2F54EB",
    gold: "#FAAD14",
    lime: "#A0D911"
};
const $b1208bbc03407e2e$var$seedToken = Object.assign(Object.assign({}, $b1208bbc03407e2e$export$37e27b43af4d16eb), {
    // Color
    colorPrimary: "#1677ff",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1677ff",
    colorLink: "",
    colorTextBase: "",
    colorBgBase: "",
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: "solid",
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
    motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
    motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
    motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
    motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
    motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
    motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
});
var $b1208bbc03407e2e$export$2e2bcd8739ae039 = $b1208bbc03407e2e$var$seedToken;






var $6d2f60b2591128fc$export$d850312fc213f33e = /** @class */ function() {
    function TinyColor(color, opts) {
        if (color === void 0) color = "";
        if (opts === void 0) opts = {};
        var _a;
        // If input is already a tinycolor, return itself
        if (color instanceof TinyColor) // eslint-disable-next-line no-constructor-return
        return color;
        if (typeof color === "number") color = (0, $5dbaaddf372549d4$export$4076ec82b665900d)(color);
        this.originalInput = color;
        var rgb = (0, $4146cacf0fc753c3$export$87de337d8199f22c)(color);
        this.originalInput = color;
        this.r = rgb.r;
        this.g = rgb.g;
        this.b = rgb.b;
        this.a = rgb.a;
        this.roundA = Math.round(100 * this.a) / 100;
        this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
        this.gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this.r < 1) this.r = Math.round(this.r);
        if (this.g < 1) this.g = Math.round(this.g);
        if (this.b < 1) this.b = Math.round(this.b);
        this.isValid = rgb.ok;
    }
    TinyColor.prototype.isDark = function() {
        return this.getBrightness() < 128;
    };
    TinyColor.prototype.isLight = function() {
        return !this.isDark();
    };
    /**
     * Returns the perceived brightness of the color, from 0-255.
     */ TinyColor.prototype.getBrightness = function() {
        // http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    };
    /**
     * Returns the perceived luminance of a color, from 0-1.
     */ TinyColor.prototype.getLuminance = function() {
        // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var R;
        var G;
        var B;
        var RsRGB = rgb.r / 255;
        var GsRGB = rgb.g / 255;
        var BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else // eslint-disable-next-line prefer-exponentiation-operator
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    /**
     * Returns the alpha value of a color, from 0-1.
     */ TinyColor.prototype.getAlpha = function() {
        return this.a;
    };
    /**
     * Sets the alpha value on the current color.
     *
     * @param alpha - The new alpha value. The accepted range is 0-1.
     */ TinyColor.prototype.setAlpha = function(alpha) {
        this.a = (0, $89c3f0c2cde0477f$export$3ae665204365318d)(alpha);
        this.roundA = Math.round(100 * this.a) / 100;
        return this;
    };
    /**
     * Returns whether the color is monochrome.
     */ TinyColor.prototype.isMonochrome = function() {
        var s = this.toHsl().s;
        return s === 0;
    };
    /**
     * Returns the object as a HSVA object.
     */ TinyColor.prototype.toHsv = function() {
        var hsv = (0, $5dbaaddf372549d4$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this.a
        };
    };
    /**
     * Returns the hsva values interpolated into a string with the following format:
     * "hsva(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHsvString = function() {
        var hsv = (0, $5dbaaddf372549d4$export$f76e85ca00a47f5c)(this.r, this.g, this.b);
        var h = Math.round(hsv.h * 360);
        var s = Math.round(hsv.s * 100);
        var v = Math.round(hsv.v * 100);
        return this.a === 1 ? "hsv(".concat(h, ", ").concat(s, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a HSLA object.
     */ TinyColor.prototype.toHsl = function() {
        var hsl = (0, $5dbaaddf372549d4$export$c85ca4f4753af384)(this.r, this.g, this.b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this.a
        };
    };
    /**
     * Returns the hsla values interpolated into a string with the following format:
     * "hsla(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toHslString = function() {
        var hsl = (0, $5dbaaddf372549d4$export$c85ca4f4753af384)(this.r, this.g, this.b);
        var h = Math.round(hsl.h * 360);
        var s = Math.round(hsl.s * 100);
        var l = Math.round(hsl.l * 100);
        return this.a === 1 ? "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    /**
     * Returns the hex value of the color.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHex = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return (0, $5dbaaddf372549d4$export$34d09c4a771c46ef)(this.r, this.g, this.b, allow3Char);
    };
    /**
     * Returns the hex value of the color -with a # prefixed.
     * @param allow3Char will shorten hex value to 3 char if possible
     */ TinyColor.prototype.toHexString = function(allow3Char) {
        if (allow3Char === void 0) allow3Char = false;
        return "#" + this.toHex(allow3Char);
    };
    /**
     * Returns the hex 8 value of the color.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8 = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return (0, $5dbaaddf372549d4$export$ffee5509a14af63d)(this.r, this.g, this.b, this.a, allow4Char);
    };
    /**
     * Returns the hex 8 value of the color -with a # prefixed.
     * @param allow4Char will shorten hex value to 4 char if possible
     */ TinyColor.prototype.toHex8String = function(allow4Char) {
        if (allow4Char === void 0) allow4Char = false;
        return "#" + this.toHex8(allow4Char);
    };
    /**
     * Returns the shorter hex value of the color depends on its alpha -with a # prefixed.
     * @param allowShortChar will shorten hex value to 3 or 4 char if possible
     */ TinyColor.prototype.toHexShortString = function(allowShortChar) {
        if (allowShortChar === void 0) allowShortChar = false;
        return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toRgb = function() {
        return {
            r: Math.round(this.r),
            g: Math.round(this.g),
            b: Math.round(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA values interpolated into a string with the following format:
     * "RGBA(xxx, xxx, xxx, xx)".
     */ TinyColor.prototype.toRgbString = function() {
        var r = Math.round(this.r);
        var g = Math.round(this.g);
        var b = Math.round(this.b);
        return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    /**
     * Returns the object as a RGBA object.
     */ TinyColor.prototype.toPercentageRgb = function() {
        var fmt = function(x) {
            return "".concat(Math.round((0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(x, 255) * 100), "%");
        };
        return {
            r: fmt(this.r),
            g: fmt(this.g),
            b: fmt(this.b),
            a: this.a
        };
    };
    /**
     * Returns the RGBA relative values interpolated into a string
     */ TinyColor.prototype.toPercentageRgbString = function() {
        var rnd = function(x) {
            return Math.round((0, $89c3f0c2cde0477f$export$b0e60b43d1d059f0)(x, 255) * 100);
        };
        return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    /**
     * The 'real' name of the color -if there is one.
     */ TinyColor.prototype.toName = function() {
        if (this.a === 0) return "transparent";
        if (this.a < 1) return false;
        var hex = "#" + (0, $5dbaaddf372549d4$export$34d09c4a771c46ef)(this.r, this.g, this.b, false);
        for(var _i = 0, _a = Object.entries((0, $7c1331a6b98e7de3$export$e4b2ac9215619f8d)); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (hex === value) return key;
        }
        return false;
    };
    TinyColor.prototype.toString = function(format) {
        var formatSet = Boolean(format);
        format = format !== null && format !== void 0 ? format : this.format;
        var formattedString = false;
        var hasAlpha = this.a < 1 && this.a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this.a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    };
    TinyColor.prototype.toNumber = function() {
        return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor.prototype.clone = function() {
        return new TinyColor(this.toString());
    };
    /**
     * Lighten the color a given amount. Providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.lighten = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l += amount / 100;
        hsl.l = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Brighten the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.brighten = function(amount) {
        if (amount === void 0) amount = 10;
        var rgb = this.toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return new TinyColor(rgb);
    };
    /**
     * Darken the color a given amount, from 0 to 100.
     * Providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.darken = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.l -= amount / 100;
        hsl.l = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.l);
        return new TinyColor(hsl);
    };
    /**
     * Mix the color with pure white, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return white.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.tint = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("white", amount);
    };
    /**
     * Mix the color with pure black, from 0 to 100.
     * Providing 0 will do nothing, providing 100 will always return black.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.shade = function(amount) {
        if (amount === void 0) amount = 10;
        return this.mix("black", amount);
    };
    /**
     * Desaturate the color a given amount, from 0 to 100.
     * Providing 100 will is the same as calling greyscale
     * @param amount - valid between 1-100
     */ TinyColor.prototype.desaturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s -= amount / 100;
        hsl.s = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Saturate the color a given amount, from 0 to 100.
     * @param amount - valid between 1-100
     */ TinyColor.prototype.saturate = function(amount) {
        if (amount === void 0) amount = 10;
        var hsl = this.toHsl();
        hsl.s += amount / 100;
        hsl.s = (0, $89c3f0c2cde0477f$export$5c5ee632c52bc4a2)(hsl.s);
        return new TinyColor(hsl);
    };
    /**
     * Completely desaturates a color into greyscale.
     * Same as calling `desaturate(100)`
     */ TinyColor.prototype.greyscale = function() {
        return this.desaturate(100);
    };
    /**
     * Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
     * Values outside of this range will be wrapped into this range.
     */ TinyColor.prototype.spin = function(amount) {
        var hsl = this.toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return new TinyColor(hsl);
    };
    /**
     * Mix the current color a given amount with another color, from 0 to 100.
     * 0 means no mixing (return current color).
     */ TinyColor.prototype.mix = function(color, amount) {
        if (amount === void 0) amount = 50;
        var rgb1 = this.toRgb();
        var rgb2 = new TinyColor(color).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return new TinyColor(rgba);
    };
    TinyColor.prototype.analogous = function(results, slices) {
        if (results === void 0) results = 6;
        if (slices === void 0) slices = 30;
        var hsl = this.toHsl();
        var part = 360 / slices;
        var ret = [
            this
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(new TinyColor(hsl));
        }
        return ret;
    };
    /**
     * taken from https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js
     */ TinyColor.prototype.complement = function() {
        var hsl = this.toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return new TinyColor(hsl);
    };
    TinyColor.prototype.monochromatic = function(results) {
        if (results === void 0) results = 6;
        var hsv = this.toHsv();
        var h = hsv.h;
        var s = hsv.s;
        var v = hsv.v;
        var res = [];
        var modification = 1 / results;
        while(results--){
            res.push(new TinyColor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return res;
    };
    TinyColor.prototype.splitcomplement = function() {
        var hsl = this.toHsl();
        var h = hsl.h;
        return [
            this,
            new TinyColor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            new TinyColor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    };
    /**
     * Compute how the color would appear on a background
     */ TinyColor.prototype.onBackground = function(background) {
        var fg = this.toRgb();
        var bg = new TinyColor(background).toRgb();
        var alpha = fg.a + bg.a * (1 - fg.a);
        return new TinyColor({
            r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
            g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
            b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
            a: alpha
        });
    };
    /**
     * Alias for `polyad(3)`
     */ TinyColor.prototype.triad = function() {
        return this.polyad(3);
    };
    /**
     * Alias for `polyad(4)`
     */ TinyColor.prototype.tetrad = function() {
        return this.polyad(4);
    };
    /**
     * Get polyad colors, like (for 1, 2, 3, 4, 5, 6, 7, 8, etc...)
     * monad, dyad, triad, tetrad, pentad, hexad, heptad, octad, etc...
     */ TinyColor.prototype.polyad = function(n) {
        var hsl = this.toHsl();
        var h = hsl.h;
        var result = [
            this
        ];
        var increment = 360 / n;
        for(var i = 1; i < n; i++)result.push(new TinyColor({
            h: (h + i * increment) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    };
    /**
     * compare color vs current color
     */ TinyColor.prototype.equals = function(color) {
        return this.toRgbString() === new TinyColor(color).toRgbString();
    };
    return TinyColor;
}();
function $6d2f60b2591128fc$export$6325b328a5266d34(color, opts) {
    if (color === void 0) color = "";
    if (opts === void 0) opts = {};
    return new $6d2f60b2591128fc$export$d850312fc213f33e(color, opts);
}


function $f9a7789ccb5ebec2$export$2e2bcd8739ae039(seed, _ref) {
    let { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes } = _ref;
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    return Object.assign(Object.assign({}, neutralColors), {
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)("#000").setAlpha(0.45).toRgbString(),
        colorWhite: "#fff"
    });
}


const $74d509d83ea2ceca$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $74d509d83ea2ceca$export$2e2bcd8739ae039 = $74d509d83ea2ceca$var$genRadius;


function $17649d51225b21b7$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return Object.assign({
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1
    }, (0, $74d509d83ea2ceca$export$2e2bcd8739ae039)(borderRadius));
}


const $7163539f10d66a74$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $7163539f10d66a74$export$2e2bcd8739ae039 = $7163539f10d66a74$var$genControlHeight;


function $239826517175299d$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $239826517175299d$export$2e2bcd8739ae039(base) {
    const fontSizes = new Array(10).fill(null).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.pow(Math.E, i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $239826517175299d$export$56204a27a2958a55(size)
        }));
}


const $10537aa233bce652$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $239826517175299d$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $10537aa233bce652$export$2e2bcd8739ae039 = $10537aa233bce652$var$genFontMapToken;


function $c9ee1fc436061bcb$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(baseColor).setAlpha(alpha).toRgbString();
const $4c3fbe9a4ea0d6be$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $8cc6ca3a04c40fcf$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || "#fff";
    const colorTextBase = textBaseColor || "#000";
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgLayout: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $4c3fbe9a4ea0d6be$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: "transparent",
        colorBorder: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $4c3fbe9a4ea0d6be$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $11cb018871a499d7$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $0b4842326956570d$export$3968a3afc810b5f5).pink = (0, $0b4842326956570d$export$3968a3afc810b5f5).magenta;
    (0, $0b4842326956570d$export$36ad6df0f83f284d).pink = (0, $0b4842326956570d$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $b1208bbc03407e2e$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $0b4842326956570d$export$3968a3afc810b5f5)[colorKey] ? (0, $0b4842326956570d$export$36ad6df0f83f284d)[colorKey] : (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(token[colorKey]);
        return new Array(10).fill(1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        // biome-ignore lint/style/noParameterAssign: it is a reduce
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token), colorPalettes), (0, $f9a7789ccb5ebec2$export$2e2bcd8739ae039)(token, {
        generateColorPalettes: $8cc6ca3a04c40fcf$export$da275153033f4ec1,
        generateNeutralColorPalettes: $8cc6ca3a04c40fcf$export$3e0cb0c1d9c1b691
    })), (0, $10537aa233bce652$export$2e2bcd8739ae039)(token.fontSize)), (0, $c9ee1fc436061bcb$export$2e2bcd8739ae039)(token)), (0, $7163539f10d66a74$export$2e2bcd8739ae039)(token)), (0, $17649d51225b21b7$export$2e2bcd8739ae039)(token));
}



const $d6a0cd0c670c9aed$export$164de7ab8df77ef0 = (0, $db48c74b3367fd88$export$2e2bcd8739ae039)((0, $11cb018871a499d7$export$2e2bcd8739ae039));
const $d6a0cd0c670c9aed$export$f84bd70098573c5c = {
    token: (0, $b1208bbc03407e2e$export$2e2bcd8739ae039),
    override: {
        override: (0, $b1208bbc03407e2e$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $d6a0cd0c670c9aed$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($d6a0cd0c670c9aed$export$f84bd70098573c5c);






function $49cdc08d8072d4ba$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $49cdc08d8072d4ba$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($49cdc08d8072d4ba$var$isStableColor(r) && $49cdc08d8072d4ba$var$isStableColor(g) && $49cdc08d8072d4ba$var$isStableColor(b)) return new (0, $6d2f60b2591128fc$export$d850312fc213f33e)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $6d2f60b2591128fc$export$d850312fc213f33e)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $49cdc08d8072d4ba$export$2e2bcd8739ae039 = $49cdc08d8072d4ba$var$getAlphaColor;


var $e6266db79468900d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e6266db79468900d$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override } = derivativeToken, restToken = $e6266db79468900d$var$__rest(derivativeToken, [
        "override"
    ]);
    const overrideTokens = Object.assign({}, override);
    Object.keys((0, $b1208bbc03407e2e$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = "0s";
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 4,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $49cdc08d8072d4ba$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: "none",
        linkHoverDecoration: "none",
        linkFocusDecoration: "none",
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
        boxShadowCard: `
      0 1px 2px -2px ${new (0, $6d2f60b2591128fc$export$d850312fc213f33e)("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new (0, $6d2f60b2591128fc$export$d850312fc213f33e)("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new (0, $6d2f60b2591128fc$export$d850312fc213f33e)("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
        boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
    }), overrideTokens);
    return aliasToken;
}


var $d014fefdb4420ef5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d014fefdb4420ef5$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true
};
const $d014fefdb4420ef5$export$738b109e247a462c = {
    size: true,
    sizeSM: true,
    sizeLG: true,
    sizeMD: true,
    sizeXS: true,
    sizeXXS: true,
    sizeMS: true,
    sizeXL: true,
    sizeXXL: true,
    sizeUnit: true,
    sizeStep: true,
    motionBase: true,
    motionUnit: true
};
const $d014fefdb4420ef5$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const $d014fefdb4420ef5$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override } = overrideToken, components = $d014fefdb4420ef5$var$__rest(overrideToken, [
        "override"
    ]);
    // Merge with override
    let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
        override: override
    });
    // Format if needed
    mergedDerivativeToken = (0, $e6266db79468900d$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach((_ref)=>{
        let [key, value] = _ref;
        const { theme: componentTheme } = value, componentTokens = $d014fefdb4420ef5$var$__rest(value, [
            "theme"
        ]);
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $d014fefdb4420ef5$export$18602cb46ae80b62(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $d014fefdb4420ef5$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: cssVar } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $d6a0cd0c670c9aed$export$69b0ebb9efcddb30));
    const salt = `${(0, $d8781535a68aa2aa$export$2e2bcd8739ae039)}-${hashed || ""}`;
    const mergedTheme = theme || (0, $d6a0cd0c670c9aed$export$164de7ab8df77ef0);
    const [token, hashId, realToken] = (0, $fb047830d7776fb2$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $b1208bbc03407e2e$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $d014fefdb4420ef5$export$18602cb46ae80b62,
        formatToken: // formatToken will not be consumed after 1.15.0 with getComputedToken.
        // But token will break if @ant-design/cssinjs is under 1.15.0 without it
        $e6266db79468900d$export$2e2bcd8739ae039,
        cssVar: cssVar && {
            prefix: cssVar.prefix,
            key: cssVar.key,
            unitless: $d014fefdb4420ef5$export$c6b9faa6b723d31a,
            ignore: $d014fefdb4420ef5$export$738b109e247a462c,
            preserve: $d014fefdb4420ef5$var$preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : "",
        token,
        cssVar
    ];
}


const $36689cb123f552b0$export$74c1bf8296b1541f = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $36689cb123f552b0$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $36689cb123f552b0$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($36689cb123f552b0$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
function $36689cb123f552b0$export$2e2bcd8739ae039() {
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const responsiveMap = $36689cb123f552b0$var$getResponsiveMap($36689cb123f552b0$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>func(screens));
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            unregister () {
                Object.keys(responsiveMap).forEach((screen)=>{
                    const matchMediaQuery = responsiveMap[screen];
                    const handler = this.matchHandlers[matchMediaQuery];
                    handler === null || handler === void 0 || handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
                });
                subscribers.clear();
            },
            register () {
                Object.keys(responsiveMap).forEach((screen)=>{
                    const matchMediaQuery = responsiveMap[screen];
                    const listener = (_ref)=>{
                        let { matches: matches } = _ref;
                        this.dispatch(Object.assign(Object.assign({}, screens), {
                            [screen]: matches
                        }));
                    };
                    const mql = window.matchMedia(matchMediaQuery);
                    mql.addListener(listener);
                    this.matchHandlers[matchMediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            responsiveMap: responsiveMap
        };
    }, [
        token
    ]);
}
const $36689cb123f552b0$export$862220c15691d248 = (screens, screenSizes)=>{
    if (screenSizes && typeof screenSizes === "object") for(let i = 0; i < $36689cb123f552b0$export$74c1bf8296b1541f.length; i++){
        const breakpoint = $36689cb123f552b0$export$74c1bf8296b1541f[i];
        if (screens[breakpoint] && screenSizes[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $6bacc63174d40f3c$var$IconContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $6bacc63174d40f3c$export$2e2bcd8739ae039 = $6bacc63174d40f3c$var$IconContext;










function $7d110e739ae14cc6$export$2e2bcd8739ae039(r) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $a0df324e6f81ee90$export$2e2bcd8739ae039)(r) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


function $17fcde5782384c29$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}


function $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === "number") clone = [];
    else if (Array.isArray(entity)) clone = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(entity);
    else clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $4bc24eaedd2a47a4$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $4bc24eaedd2a47a4$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $17fcde5782384c29$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $4bc24eaedd2a47a4$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $4bc24eaedd2a47a4$var$isObject(obj) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $4bc24eaedd2a47a4$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $4bc24eaedd2a47a4$var$keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function $4bc24eaedd2a47a4$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $4bc24eaedd2a47a4$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $4bc24eaedd2a47a4$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(originValue) !== "object") // Init container if not exist
                    clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, $4bc24eaedd2a47a4$var$createEmpty(value));
                    $4bc24eaedd2a47a4$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $4bc24eaedd2a47a4$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}



var $acw62 = parcelRequire("acw62");

function $5bd796dbed593bbb$export$8793edee2d425525() {}
let $5bd796dbed593bbb$var$deprecatedWarnList = null;
function $5bd796dbed593bbb$export$60eef1277fe463e4() {
    $5bd796dbed593bbb$var$deprecatedWarnList = null;
    (0, $05a5f2c645683a81$export$60eef1277fe463e4)();
}
// eslint-disable-next-line import/no-mutable-exports
let $5bd796dbed593bbb$var$warning = $5bd796dbed593bbb$export$8793edee2d425525;
var $5bd796dbed593bbb$var$valid, $5bd796dbed593bbb$var$component, $5bd796dbed593bbb$var$message;
const $5bd796dbed593bbb$export$11b88c75b33aa1fd = /*#__PURE__*/ $acw62.createContext({});
const $5bd796dbed593bbb$export$cf977aa92c751e61 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $5bd796dbed593bbb$export$8793edee2d425525;
    return noopWarning;
};
var $5bd796dbed593bbb$export$2e2bcd8739ae039 = $5bd796dbed593bbb$var$warning;



var $acw62 = parcelRequire("acw62");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-field-form`
$efabd6732f69a6da$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");

/* eslint-disable no-template-curly-in-string */ var $864f21d08855a737$var$locale = {
    // Options
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
};
var $864f21d08855a737$export$2e2bcd8739ae039 = $864f21d08855a737$var$locale;


var $0309ef2dc8eb0939$var$locale = {
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    yearFormat: "YYYY",
    dateFormat: "M/D/YYYY",
    dayFormat: "D",
    dateTimeFormat: "M/D/YYYY HH:mm:ss",
    monthBeforeYear: true,
    previousMonth: "Previous month (PageUp)",
    nextMonth: "Next month (PageDown)",
    previousYear: "Last year (Control + left)",
    nextYear: "Next year (Control + right)",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
};
var $0309ef2dc8eb0939$export$2e2bcd8739ae039 = $0309ef2dc8eb0939$var$locale;


const $594a5cf7899ad7e1$var$locale = {
    placeholder: "Select time",
    rangePlaceholder: [
        "Start time",
        "End time"
    ]
};
var $594a5cf7899ad7e1$export$2e2bcd8739ae039 = $594a5cf7899ad7e1$var$locale;


// Merge into a locale object
const $74a89c57a3cfafd2$var$locale = {
    lang: Object.assign({
        placeholder: "Select date",
        yearPlaceholder: "Select year",
        quarterPlaceholder: "Select quarter",
        monthPlaceholder: "Select month",
        weekPlaceholder: "Select week",
        rangePlaceholder: [
            "Start date",
            "End date"
        ],
        rangeYearPlaceholder: [
            "Start year",
            "End year"
        ],
        rangeQuarterPlaceholder: [
            "Start quarter",
            "End quarter"
        ],
        rangeMonthPlaceholder: [
            "Start month",
            "End month"
        ],
        rangeWeekPlaceholder: [
            "Start week",
            "End week"
        ]
    }, (0, $0309ef2dc8eb0939$export$2e2bcd8739ae039)),
    timePickerLocale: Object.assign({}, (0, $594a5cf7899ad7e1$export$2e2bcd8739ae039))
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$74a89c57a3cfafd2$export$2e2bcd8739ae039 = $74a89c57a3cfafd2$var$locale;


var $32ded69f6ae6c615$export$2e2bcd8739ae039 = (0, $74a89c57a3cfafd2$export$2e2bcd8739ae039);




const $c7d8dfeaf08e9faa$var$typeTemplate = "${label} is not a valid ${type}";
const $c7d8dfeaf08e9faa$var$localeValues = {
    locale: "en",
    Pagination: $864f21d08855a737$export$2e2bcd8739ae039,
    DatePicker: $74a89c57a3cfafd2$export$2e2bcd8739ae039,
    TimePicker: $594a5cf7899ad7e1$export$2e2bcd8739ae039,
    Calendar: $32ded69f6ae6c615$export$2e2bcd8739ae039,
    global: {
        placeholder: "Please select"
    },
    Table: {
        filterTitle: "Filter menu",
        filterConfirm: "OK",
        filterReset: "Reset",
        filterEmptyText: "No filters",
        filterCheckall: "Select all items",
        filterSearchPlaceholder: "Search in filters",
        emptyText: "No data",
        selectAll: "Select current page",
        selectInvert: "Invert current page",
        selectNone: "Clear all data",
        selectionAll: "Select all data",
        sortTitle: "Sort",
        expand: "Expand row",
        collapse: "Collapse row",
        triggerDesc: "Click to sort descending",
        triggerAsc: "Click to sort ascending",
        cancelSort: "Click to cancel sorting"
    },
    Tour: {
        Next: "Next",
        Previous: "Previous",
        Finish: "Finish"
    },
    Modal: {
        okText: "OK",
        cancelText: "Cancel",
        justOkText: "OK"
    },
    Popconfirm: {
        okText: "OK",
        cancelText: "Cancel"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "Search here",
        itemUnit: "item",
        itemsUnit: "items",
        remove: "Remove",
        selectCurrent: "Select current page",
        removeCurrent: "Remove current page",
        selectAll: "Select all data",
        deselectAll: "Deselect all data",
        removeAll: "Remove all data",
        selectInvert: "Invert current page"
    },
    Upload: {
        uploading: "Uploading...",
        removeFile: "Remove file",
        uploadError: "Upload error",
        previewFile: "Preview file",
        downloadFile: "Download file"
    },
    Empty: {
        description: "No data"
    },
    Icon: {
        icon: "icon"
    },
    Text: {
        edit: "Edit",
        copy: "Copy",
        copied: "Copied",
        expand: "Expand",
        collapse: "Collapse"
    },
    Form: {
        optional: "(optional)",
        defaultValidateMessages: {
            default: "Field validation error for ${label}",
            required: "Please enter ${label}",
            enum: "${label} must be one of [${enum}]",
            whitespace: "${label} cannot be a blank character",
            date: {
                format: "${label} date format is invalid",
                parse: "${label} cannot be converted to a date",
                invalid: "${label} is an invalid date"
            },
            types: {
                string: $c7d8dfeaf08e9faa$var$typeTemplate,
                method: $c7d8dfeaf08e9faa$var$typeTemplate,
                array: $c7d8dfeaf08e9faa$var$typeTemplate,
                object: $c7d8dfeaf08e9faa$var$typeTemplate,
                number: $c7d8dfeaf08e9faa$var$typeTemplate,
                date: $c7d8dfeaf08e9faa$var$typeTemplate,
                boolean: $c7d8dfeaf08e9faa$var$typeTemplate,
                integer: $c7d8dfeaf08e9faa$var$typeTemplate,
                float: $c7d8dfeaf08e9faa$var$typeTemplate,
                regexp: $c7d8dfeaf08e9faa$var$typeTemplate,
                email: $c7d8dfeaf08e9faa$var$typeTemplate,
                url: $c7d8dfeaf08e9faa$var$typeTemplate,
                hex: $c7d8dfeaf08e9faa$var$typeTemplate
            },
            string: {
                len: "${label} must be ${len} characters",
                min: "${label} must be at least ${min} characters",
                max: "${label} must be up to ${max} characters",
                range: "${label} must be between ${min}-${max} characters"
            },
            number: {
                len: "${label} must be equal to ${len}",
                min: "${label} must be minimum ${min}",
                max: "${label} must be maximum ${max}",
                range: "${label} must be between ${min}-${max}"
            },
            array: {
                len: "Must be ${len} ${label}",
                min: "At least ${min} ${label}",
                max: "At most ${max} ${label}",
                range: "The amount of ${label} must be between ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} does not match the pattern ${pattern}"
            }
        }
    },
    Image: {
        preview: "Preview"
    },
    QRCode: {
        expired: "QR code expired",
        refresh: "Refresh",
        scanned: "Scanned"
    },
    ColorPicker: {
        presetEmpty: "Empty"
    }
};
var $c7d8dfeaf08e9faa$export$2e2bcd8739ae039 = $c7d8dfeaf08e9faa$var$localeValues;


let $466e4bebfd7443ca$var$runtimeLocale = Object.assign({}, (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
let $466e4bebfd7443ca$var$localeList = [];
const $466e4bebfd7443ca$var$generateLocale = ()=>$466e4bebfd7443ca$var$localeList.reduce((merged, locale)=>Object.assign(Object.assign({}, merged), locale), (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
function $466e4bebfd7443ca$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = Object.assign({}, newLocale);
        $466e4bebfd7443ca$var$localeList.push(cloneLocale);
        $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        return ()=>{
            $466e4bebfd7443ca$var$localeList = $466e4bebfd7443ca$var$localeList.filter((locale)=>locale !== cloneLocale);
            $466e4bebfd7443ca$var$runtimeLocale = $466e4bebfd7443ca$var$generateLocale();
        };
    }
    $466e4bebfd7443ca$var$runtimeLocale = Object.assign({}, (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
}
function $466e4bebfd7443ca$export$1b6004afda18cd51() {
    return $466e4bebfd7443ca$var$runtimeLocale;
}



var $acw62 = parcelRequire("acw62");
const $6dd9227cba6de9ce$var$LocaleContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $6dd9227cba6de9ce$export$2e2bcd8739ae039 = $6dd9227cba6de9ce$var$LocaleContext;



var $acw62 = parcelRequire("acw62");


const $0020add6ec984361$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $acw62.useContext((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039));
    const getLocale = $acw62.useMemo(()=>{
        var _a;
        const locale = defaultLocale || (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
        return Object.assign(Object.assign({}, typeof locale === "function" ? locale() : locale), localeFromContext || {});
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $acw62.useMemo(()=>{
        const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
        // Had use LocaleProvide but didn't set locale
        if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) return (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $0020add6ec984361$export$2e2bcd8739ae039 = $0020add6ec984361$var$useLocale;


"use client";
const $766ff256ac32087c$export$b2f162cd5c15ea3e = "internalMark";
const $766ff256ac32087c$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $acw62.useEffect(()=>{
        const clearLocale = (0, $466e4bebfd7443ca$export$9485ecb9d81a550c)(locale === null || locale === void 0 ? void 0 : locale.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $acw62.useMemo(()=>Object.assign(Object.assign({}, locale), {
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $766ff256ac32087c$export$2e2bcd8739ae039 = $766ff256ac32087c$var$LocaleProvider;







var $acw62 = parcelRequire("acw62");
const $a18b2f6f56546238$export$eaca8ee5ed21b4e9 = "anticon";
const $a18b2f6f56546238$export$fa216ce2679a073b = [
    "outlined",
    "borderless",
    "filled"
];
const $a18b2f6f56546238$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `ant-${suffixCls}` : "ant";
};
const $a18b2f6f56546238$export$a92f85ab3e9ad68b = /*#__PURE__*/ $acw62.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $a18b2f6f56546238$var$defaultGetPrefixCls,
    iconPrefixCls: $a18b2f6f56546238$export$eaca8ee5ed21b4e9
});
const { Consumer: $a18b2f6f56546238$export$cd5442f2b8da7663 } = $a18b2f6f56546238$export$a92f85ab3e9ad68b;


/* eslint-disable import/prefer-default-export, prefer-destructuring */ 




const $e1ca56936d2d2b32$var$dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme) {
    const variables = {};
    const formatColor = (color, updater)=>{
        let clone = color.clone();
        clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
        return clone.toRgbString();
    };
    const fillColor = (colorVal, type)=>{
        const baseColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorVal);
        const colorPalettes = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(baseColor.toRgbString());
        variables[`${type}-color`] = formatColor(baseColor);
        variables[`${type}-color-disabled`] = colorPalettes[1];
        variables[`${type}-color-hover`] = colorPalettes[4];
        variables[`${type}-color-active`] = colorPalettes[6];
        variables[`${type}-color-outline`] = baseColor.clone().setAlpha(0.2).toRgbString();
        variables[`${type}-color-deprecated-bg`] = colorPalettes[0];
        variables[`${type}-color-deprecated-border`] = colorPalettes[2];
    };
    // ================ Primary Color ================
    if (theme.primaryColor) {
        fillColor(theme.primaryColor, "primary");
        const primaryColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(theme.primaryColor);
        const primaryColors = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(primaryColor.toRgbString());
        // Legacy - We should use semantic naming standard
        primaryColors.forEach((color, index)=>{
            variables[`primary-${index + 1}`] = color;
        });
        // Deprecated
        variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, (c)=>c.lighten(35));
        variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, (c)=>c.lighten(20));
        variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, (c)=>c.tint(20));
        variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, (c)=>c.tint(50));
        variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, (c)=>c.setAlpha(c.getAlpha() * 0.12));
        const primaryActiveColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(primaryColors[0]);
        variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, (c)=>c.setAlpha(c.getAlpha() * 0.3));
        variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, (c)=>c.darken(2));
    }
    // ================ Success Color ================
    if (theme.successColor) fillColor(theme.successColor, "success");
    // ================ Warning Color ================
    if (theme.warningColor) fillColor(theme.warningColor, "warning");
    // ================= Error Color =================
    if (theme.errorColor) fillColor(theme.errorColor, "error");
    // ================= Info Color ==================
    if (theme.infoColor) fillColor(theme.infoColor, "info");
    // Convert to css variables
    const cssList = Object.keys(variables).map((key)=>`--${globalPrefixCls}-${key}: ${variables[key]};`);
    return `
  :root {
    ${cssList.join("\n")}
  }
  `.trim();
}
function $e1ca56936d2d2b32$export$f9c59eed5de5ff80(globalPrefixCls, theme) {
    const style = $e1ca56936d2d2b32$export$3d2f074408bd1b82(globalPrefixCls, theme);
    if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) (0, $3a22468320d7d808$export$4d99a2890bb989f0)(style, `${$e1ca56936d2d2b32$var$dynamicStyleMark}-dynamic-theme`);
}



var $acw62 = parcelRequire("acw62");
"use client";
const $6ba6819805fb0a44$var$DisabledContext = /*#__PURE__*/ $acw62.createContext(false);
const $6ba6819805fb0a44$export$6adb5f3b918b11bb = (_ref)=>{
    let { children: children, disabled: disabled } = _ref;
    const originDisabled = $acw62.useContext($6ba6819805fb0a44$var$DisabledContext);
    return /*#__PURE__*/ $acw62.createElement($6ba6819805fb0a44$var$DisabledContext.Provider, {
        value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
    }, children);
};
var $6ba6819805fb0a44$export$2e2bcd8739ae039 = $6ba6819805fb0a44$var$DisabledContext;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
const $3e100f55cf8f3689$var$SizeContext = /*#__PURE__*/ $acw62.createContext(undefined);
const $3e100f55cf8f3689$export$dbc92d89fabc8ebe = (_ref)=>{
    let { children: children, size: size } = _ref;
    const originSize = $acw62.useContext($3e100f55cf8f3689$var$SizeContext);
    return /*#__PURE__*/ $acw62.createElement($3e100f55cf8f3689$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $3e100f55cf8f3689$export$2e2bcd8739ae039 = $3e100f55cf8f3689$var$SizeContext;


function $1e1ca3bea54a77f7$var$useConfig() {
    const componentDisabled = (0, $acw62.useContext)((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const componentSize = (0, $acw62.useContext)((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $1e1ca3bea54a77f7$export$2e2bcd8739ae039 = $1e1ca3bea54a77f7$var$useConfig;







var $acw62 = parcelRequire("acw62");
const $52df818a8259ef26$var$fullClone = Object.assign({}, $acw62);
const { useId: $52df818a8259ef26$var$useId } = $52df818a8259ef26$var$fullClone;
const $52df818a8259ef26$var$useEmptyId = ()=>"";
const $52df818a8259ef26$var$useThemeKey = typeof $52df818a8259ef26$var$useId === "undefined" ? $52df818a8259ef26$var$useEmptyId : $52df818a8259ef26$var$useId;
var $52df818a8259ef26$export$2e2bcd8739ae039 = $52df818a8259ef26$var$useThemeKey;


function $a1000671d52972e2$export$2e2bcd8739ae039(theme, parentTheme, config) {
    var _a, _b;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("ConfigProvider");
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? Object.assign(Object.assign({}, (0, $d6a0cd0c670c9aed$export$f84bd70098573c5c)), {
        hashed: (_a = parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.hashed) !== null && _a !== void 0 ? _a : (0, $d6a0cd0c670c9aed$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme === null || parentTheme === void 0 ? void 0 : parentTheme.cssVar
    }) : parentTheme;
    const themeKey = (0, $52df818a8259ef26$export$2e2bcd8739ae039)();
    return (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(()=>{
        var _a, _b;
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = Object.assign({}, parentThemeConfig.components);
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, "")}`;
        const mergedCssVar = ((_a = themeConfig.cssVar) !== null && _a !== void 0 ? _a : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
            prefix: config === null || config === void 0 ? void 0 : config.prefixCls
        }, typeof parentThemeConfig.cssVar === "object" ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === "object" ? themeConfig.cssVar : {}), {
            key: typeof themeConfig.cssVar === "object" && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
        });
        // Base token
        return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
            token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
            components: mergedComponents,
            cssVar: mergedCssVar
        });
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

function $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $808ab7b8a87ab771$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(node) === "object" && $808ab7b8a87ab771$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($808ab7b8a87ab771$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $808ab7b8a87ab771$export$2e2bcd8739ae039(node) {
    var domNode = $808ab7b8a87ab771$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))), node);
    }
    return null;
}




var $acw62 = parcelRequire("acw62");
var $3251146683c5d714$exports = {};
"use strict";

$3251146683c5d714$exports = (parcelRequire("9cCWX"));



var $5e297877593af644$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(ref) === "object" && ref && "current" in ref) ref.current = node;
};
var $5e297877593af644$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $5e297877593af644$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $5e297877593af644$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        return $5e297877593af644$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $5e297877593af644$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    var type = (0, $3251146683c5d714$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $3251146683c5d714$exports.ForwardRef)) return false;
    return true;
};
function $5e297877593af644$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(node) && !(0, $3251146683c5d714$exports.isFragment)(node);
}
var $5e297877593af644$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $5e297877593af644$var$isReactElement(node) && $5e297877593af644$export$c1cec34af06bcf7(node);
};
var $5e297877593af644$export$7465e5c0bf44f19a = Number((0, $acw62.version).split(".")[0]) >= 19 ? // >= React 19
function(node) {
    if ($5e297877593af644$var$isReactElement(node)) return node.props.ref;
    return null;
} : // < React 19
function(node) {
    if ($5e297877593af644$var$isReactElement(node)) return node.ref;
    return null;
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $7b776f21b7918d7b$var$_excluded = [
    "children"
];
var $7b776f21b7918d7b$export$841858b892ce1f4c = /*#__PURE__*/ $acw62.createContext({});
function $7b776f21b7918d7b$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $7b776f21b7918d7b$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($7b776f21b7918d7b$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $acw62 = parcelRequire("acw62");
var $e37a565edd3e4d81$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);
var $e37a565edd3e4d81$export$2e2bcd8739ae039 = $e37a565edd3e4d81$var$DomWrapper;






var $acw62 = parcelRequire("acw62");
function $01e43e72865dc583$export$2e2bcd8739ae039(callback) {
    var fnRef = $acw62.useRef();
    fnRef.current = callback;
    var memoFn = $acw62.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}







var $acw62 = parcelRequire("acw62");
function $25e137fc56329ad1$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $acw62.useRef(false);
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $acw62.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $dbf5d1f4f4ecbb6a$var$hasValue(value) {
    return value !== undefined;
}
function $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(function() {
        if ($dbf5d1f4f4ecbb6a$var$hasValue(value)) return value;
        else if ($dbf5d1f4f4ecbb6a$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        if (!$dbf5d1f4f4ecbb6a$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}











var $acw62 = parcelRequire("acw62");

function $fe03a404cc9d1454$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $acw62.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $acw62.useRef(defaultValue);
    var getValue = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === "function" ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $acw62 = parcelRequire("acw62");
var $0e817525d7f1f474$export$de71442bbf2143da = "none";
var $0e817525d7f1f474$export$4fc3521687bcacd2 = "appear";
var $0e817525d7f1f474$export$5d6af549241fe2e8 = "enter";
var $0e817525d7f1f474$export$59b1c493d29f68e4 = "leave";
var $0e817525d7f1f474$export$40b34dd77d5522bf = "none";
var $0e817525d7f1f474$export$1b792916a5fac4fc = "prepare";
var $0e817525d7f1f474$export$9563153dd25a3ce8 = "start";
var $0e817525d7f1f474$export$e205886172277ec6 = "active";
var $0e817525d7f1f474$export$3a846c3d2fac10b8 = "end";
var $0e817525d7f1f474$export$98351fa4e6b4f204 = "prepared";



var $acw62 = parcelRequire("acw62");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $c24d790a085c6d93$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $c24d790a085c6d93$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $c24d790a085c6d93$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $c24d790a085c6d93$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $c24d790a085c6d93$var$vendorPrefixes = $c24d790a085c6d93$export$6e8b350b1a8958a0((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)(), typeof window !== "undefined" ? window : {});
var $c24d790a085c6d93$var$style = {};
if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) {
    var $c24d790a085c6d93$var$_document$createEleme = document.createElement("div");
    $c24d790a085c6d93$var$style = $c24d790a085c6d93$var$_document$createEleme.style;
}
var $c24d790a085c6d93$var$prefixedEventNames = {};
function $c24d790a085c6d93$export$a032e4f39350c1d8(eventName) {
    if ($c24d790a085c6d93$var$prefixedEventNames[eventName]) return $c24d790a085c6d93$var$prefixedEventNames[eventName];
    var prefixMap = $c24d790a085c6d93$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $c24d790a085c6d93$var$style) {
                $c24d790a085c6d93$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $c24d790a085c6d93$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
var $c24d790a085c6d93$var$internalAnimationEndName = $c24d790a085c6d93$export$a032e4f39350c1d8("animationend");
var $c24d790a085c6d93$var$internalTransitionEndName = $c24d790a085c6d93$export$a032e4f39350c1d8("transitionend");
var $c24d790a085c6d93$export$d28133ed3ad06c8b = !!($c24d790a085c6d93$var$internalAnimationEndName && $c24d790a085c6d93$var$internalTransitionEndName);
var $c24d790a085c6d93$export$760cc9769c51b738 = $c24d790a085c6d93$var$internalAnimationEndName || "animationend";
var $c24d790a085c6d93$export$44baea64b8602e3c = $c24d790a085c6d93$var$internalTransitionEndName || "transitionend";
function $c24d790a085c6d93$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(transitionName) === "object") {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $7ccb217d091ef41f$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $acw62.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $c24d790a085c6d93$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $c24d790a085c6d93$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $c24d790a085c6d93$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $c24d790a085c6d93$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $acw62.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $acw62 = parcelRequire("acw62");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $fb24c0ebe270f6f6$export$2e2bcd8739ae039 = $fb24c0ebe270f6f6$var$useIsomorphicLayoutEffect;





var $acw62 = parcelRequire("acw62");


var $a1ced7b983ea61a4$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $a1ced7b983ea61a4$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $a1ced7b983ea61a4$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $a1ced7b983ea61a4$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $a1ced7b983ea61a4$var$rafUUID = 0;
var $a1ced7b983ea61a4$var$rafIds = new Map();
function $a1ced7b983ea61a4$var$cleanup(id) {
    $a1ced7b983ea61a4$var$rafIds.delete(id);
}
var $a1ced7b983ea61a4$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $a1ced7b983ea61a4$var$rafUUID += 1;
    var id = $a1ced7b983ea61a4$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $a1ced7b983ea61a4$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $a1ced7b983ea61a4$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $a1ced7b983ea61a4$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$a1ced7b983ea61a4$var$wrapperRaf.cancel = function(id) {
    var realId = $a1ced7b983ea61a4$var$rafIds.get(id);
    $a1ced7b983ea61a4$var$cleanup(id);
    return $a1ced7b983ea61a4$var$caf(realId);
};
var $a1ced7b983ea61a4$export$2e2bcd8739ae039 = $a1ced7b983ea61a4$var$wrapperRaf;



var $acw62 = parcelRequire("acw62");
var $dd21c0d0173075f3$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $acw62.useRef(null);
    function cancelNextFrame() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $1e0427d97d69e92c$var$FULL_STEP_QUEUE = [
    (0, $0e817525d7f1f474$export$1b792916a5fac4fc),
    (0, $0e817525d7f1f474$export$9563153dd25a3ce8),
    (0, $0e817525d7f1f474$export$e205886172277ec6),
    (0, $0e817525d7f1f474$export$3a846c3d2fac10b8)
];
var $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE = [
    (0, $0e817525d7f1f474$export$1b792916a5fac4fc),
    (0, $0e817525d7f1f474$export$98351fa4e6b4f204)
];
var $1e0427d97d69e92c$export$c2029bf6cfdbc28a = false;
var $1e0427d97d69e92c$export$dbee1e282e8c4830 = true;
function $1e0427d97d69e92c$export$39e04e72f972b885(step) {
    return step === (0, $0e817525d7f1f474$export$e205886172277ec6) || step === (0, $0e817525d7f1f474$export$3a846c3d2fac10b8);
}
var $1e0427d97d69e92c$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)((0, $0e817525d7f1f474$export$40b34dd77d5522bf)), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $dd21c0d0173075f3$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $0e817525d7f1f474$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $1e0427d97d69e92c$var$SIMPLE_STEP_QUEUE : $1e0427d97d69e92c$var$FULL_STEP_QUEUE;
    (0, $fb24c0ebe270f6f6$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $0e817525d7f1f474$export$40b34dd77d5522bf) && step !== (0, $0e817525d7f1f474$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $1e0427d97d69e92c$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $acw62.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $1df598d21d8025e6$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $fe03a404cc9d1454$export$2e2bcd8739ae039)((0, $0e817525d7f1f474$export$de71442bbf2143da)), _useSyncState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $acw62.useRef)(false);
    var deadlineRef = (0, $acw62.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $acw62.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $0e817525d7f1f474$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $0e817525d7f1f474$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $0e817525d7f1f474$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $0e817525d7f1f474$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $7ccb217d091ef41f$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $0e817525d7f1f474$export$4fc3521687bcacd2:
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onAppearPrepare), (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onAppearStart), (0, $0e817525d7f1f474$export$e205886172277ec6), onAppearActive);
            case 0, $0e817525d7f1f474$export$5d6af549241fe2e8:
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onEnterPrepare), (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onEnterStart), (0, $0e817525d7f1f474$export$e205886172277ec6), onEnterActive);
            case 0, $0e817525d7f1f474$export$59b1c493d29f68e4:
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $0e817525d7f1f474$export$1b792916a5fac4fc), onLeavePrepare), (0, $0e817525d7f1f474$export$9563153dd25a3ce8), onLeaveStart), (0, $0e817525d7f1f474$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $acw62.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $1e0427d97d69e92c$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $0e817525d7f1f474$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $1e0427d97d69e92c$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $0e817525d7f1f474$export$e205886172277ec6) && currentStatus !== (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $0e817525d7f1f474$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $1e0427d97d69e92c$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $1e0427d97d69e92c$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    // Update with new status
    (0, $fb24c0ebe270f6f6$export$2e2bcd8739ae039)(function() {
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $0e817525d7f1f474$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $0e817525d7f1f474$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $0e817525d7f1f474$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $acw62.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $0e817525d7f1f474$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $0e817525d7f1f474$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $0e817525d7f1f474$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $0e817525d7f1f474$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $acw62.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $acw62.useRef(false);
    (0, $acw62.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $0e817525d7f1f474$export$1b792916a5fac4fc] && step === (0, $0e817525d7f1f474$export$9563153dd25a3ce8)) mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        transition: "none"
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $084772fb8d80df29$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(config) === "object") transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $acw62.useContext((0, $7b776f21b7918d7b$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $acw62.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $acw62.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $1df598d21d8025e6$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $acw62.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $acw62.useCallback(function(node) {
            nodeRef.current = node;
            (0, $5e297877593af644$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $0e817525d7f1f474$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: "none"
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $0e817525d7f1f474$export$1b792916a5fac4fc)) statusSuffix = "prepare";
            else if ((0, $1e0427d97d69e92c$export$39e04e72f972b885)(statusStep)) statusSuffix = "active";
            else if (statusStep === (0, $0e817525d7f1f474$export$9563153dd25a3ce8)) statusSuffix = "start";
            var motionCls = (0, $c24d790a085c6d93$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $c24d790a085c6d93$export$27c72201b1d09951)(motionName, status), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === "string")),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $acw62.isValidElement(motionChildren) && (0, $5e297877593af644$export$c1cec34af06bcf7)(motionChildren)) {
            var _ref = motionChildren, originNodeRef = _ref.ref;
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $acw62.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $acw62.createElement((0, $e37a565edd3e4d81$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $084772fb8d80df29$export$2e2bcd8739ae039 = $084772fb8d80df29$export$e265d52a86a9f199((0, $c24d790a085c6d93$export$d28133ed3ad06c8b));












var $acw62 = parcelRequire("acw62");



var $16994a73d43ee3a4$export$3904baa009bc026e = "add";
var $16994a73d43ee3a4$export$851162f0adad2cbc = "keep";
var $16994a73d43ee3a4$export$c8b3fb08b68cfc85 = "remove";
var $16994a73d43ee3a4$export$2ac1bd1808d2e43a = "removed";
function $16994a73d43ee3a4$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(key) === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $16994a73d43ee3a4$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($16994a73d43ee3a4$export$c47fd798e598c85c);
}
function $16994a73d43ee3a4$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $16994a73d43ee3a4$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $16994a73d43ee3a4$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $16994a73d43ee3a4$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $16994a73d43ee3a4$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $16994a73d43ee3a4$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $16994a73d43ee3a4$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $16994a73d43ee3a4$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $ab0f5c5a9767e13d$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $ab0f5c5a9767e13d$var$_excluded2 = [
    "status"
];
var $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $084772fb8d80df29$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                var keyEntities = _this.state.keyEntities;
                var nextKeyEntities = keyEntities.map(function(entity) {
                    if (entity.key !== removeKey) return entity;
                    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, entity), {}, {
                        status: (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a)
                    });
                });
                _this.setState({
                    keyEntities: nextKeyEntities
                });
                return nextKeyEntities.filter(function(_ref) {
                    var status = _ref.status;
                    return status !== (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a);
                }).length;
            });
            return _this;
        }
        (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props, $ab0f5c5a9767e13d$var$_excluded);
                    var Component = component || $acw62.Fragment;
                    var motionProps = {};
                    $ab0f5c5a9767e13d$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $acw62.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $ab0f5c5a9767e13d$var$_excluded2);
                        var visible = status === (0, $16994a73d43ee3a4$export$3904baa009bc026e) || status === (0, $16994a73d43ee3a4$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $acw62.createElement(CSSMotion, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) {
                                    var restKeysCount = _this2.removeKey(eventProps.key);
                                    if (restKeysCount === 0 && onAllRemoved) onAllRemoved();
                                }
                            }
                        }), function(props, ref) {
                            return children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $16994a73d43ee3a4$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $16994a73d43ee3a4$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $16994a73d43ee3a4$export$2ac1bd1808d2e43a) && entity.status === (0, $16994a73d43ee3a4$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($acw62.Component);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: "div"
    });
    return CSSMotionList;
}
var $ab0f5c5a9767e13d$export$2e2bcd8739ae039 = $ab0f5c5a9767e13d$export$fcfc62c1d33d5e2e((0, $c24d790a085c6d93$export$d28133ed3ad06c8b));



var $609e894acbce1933$export$2e2bcd8739ae039 = (0, $084772fb8d80df29$export$2e2bcd8739ae039);



"use client";
function $57278e23ed3ca8fa$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $acw62.useRef(false);
    needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion === false;
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $acw62.createElement((0, $7b776f21b7918d7b$export$2e2bcd8739ae039), {
        motion: motion
    }, children);
    return children;
}



var $acw62 = parcelRequire("acw62");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $a098b6503d6d9fdd$var$PropWarning = /*#__PURE__*/ $acw62.memo((_ref)=>{
    let { dropdownMatchSelectWidth: dropdownMatchSelectWidth } = _ref;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("ConfigProvider");
    warning.deprecated(dropdownMatchSelectWidth === undefined, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
    return null;
});
var $a098b6503d6d9fdd$export$2e2bcd8739ae039 = ()=>null;





// eslint-disable-next-line import/prefer-default-export
const $d48037fcbf78d816$export$9a16e7694a707ab4 = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: "none",
        outline: "none",
        cursor: "pointer",
        transition: `color ${token.motionDurationSlow}`,
        "&:focus, &:hover": {
            color: token.colorLinkHover
        },
        "&:active": {
            color: token.colorLinkActive
        }
    });


"use client";
const $4733a3b3eb18f80d$export$b2b65df0d0824629 = {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};
const $4733a3b3eb18f80d$export$23997c3e44cc1c59 = function(token) {
    let needInheritFontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: "none",
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? "inherit" : token.fontFamily
    };
};
const $4733a3b3eb18f80d$export$171ccda7bc085e59 = ()=>({
        display: "inline-flex",
        alignItems: "center",
        color: "inherit",
        fontStyle: "normal",
        lineHeight: 0,
        textAlign: "center",
        textTransform: "none",
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: "-0.125em",
        textRendering: "optimizeLegibility",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "> *": {
            lineHeight: 1
        },
        svg: {
            display: "inline-block"
        }
    });
const $4733a3b3eb18f80d$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        "&::before": {
            display: "table",
            content: '""'
        },
        "&::after": {
            // https://github.com/ant-design/ant-design/issues/21864
            display: "table",
            clear: "both",
            content: '""'
        }
    });
const $4733a3b3eb18f80d$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: "transparent",
            // remove the gray background on active links in IE 10.
            outline: "none",
            cursor: "pointer",
            transition: `color ${token.motionDurationSlow}`,
            "-webkit-text-decoration-skip": "objects",
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            "&:hover": {
                color: token.colorLinkHover
            },
            "&:active": {
                color: token.colorLinkActive
            },
            "&:active, &:hover": {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            "&:focus": {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            "&[disabled]": {
                color: token.colorTextDisabled,
                cursor: "not-allowed"
            }
        }
    });
const $4733a3b3eb18f80d$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: "border-box",
        "&::before, &::after": {
            boxSizing: "border-box"
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: Object.assign(Object.assign(Object.assign({}, resetFontStyle), resetStyle), {
            [prefixSelector]: resetStyle
        })
    };
};
const $4733a3b3eb18f80d$export$6539948f0a737e39 = (token)=>({
        outline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: 1,
        transition: "outline-offset 0s, outline 0s"
    });
const $4733a3b3eb18f80d$export$a44db842bcb28231 = (token)=>({
        "&:focus-visible": Object.assign({}, $4733a3b3eb18f80d$export$6539948f0a737e39(token))
    });



const $af55bb63f7325a53$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $7927865cee518bb3$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: "",
        path: [
            "ant-design-icons",
            iconPrefixCls
        ],
        nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
        layer: {
            name: "antd"
        }
    }, ()=>[
            {
                [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()), {
                    [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                        display: "block"
                    }
                })
            }
        ]);
};
var $af55bb63f7325a53$export$2e2bcd8739ae039 = $af55bb63f7325a53$var$useResetIconStyle;


"use client";
var $7ed5e10e08c170f8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $7ed5e10e08c170f8$var$existThemeConfig = false;
const $7ed5e10e08c170f8$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $7ed5e10e08c170f8$export$e7f14a745e5c386a = [
    "getTargetContainer",
    "getPopupContainer",
    "rootPrefixCls",
    "getPrefixCls",
    "renderEmpty",
    "csp",
    "autoInsertSpaceInButton",
    "locale"
];
// These props is used by `useContext` directly in sub component
const $7ed5e10e08c170f8$var$PASSED_PROPS = [
    "getTargetContainer",
    "getPopupContainer",
    "renderEmpty",
    "input",
    "pagination",
    "form",
    "select",
    "button"
];
const $7ed5e10e08c170f8$export$e4ec87ea71f29b41 = "ant";
let $7ed5e10e08c170f8$var$globalPrefixCls;
let $7ed5e10e08c170f8$var$globalIconPrefixCls;
let $7ed5e10e08c170f8$var$globalTheme;
let $7ed5e10e08c170f8$var$globalHolderRender;
function $7ed5e10e08c170f8$var$getGlobalPrefixCls() {
    return $7ed5e10e08c170f8$var$globalPrefixCls || $7ed5e10e08c170f8$export$e4ec87ea71f29b41;
}
function $7ed5e10e08c170f8$var$getGlobalIconPrefixCls() {
    return $7ed5e10e08c170f8$var$globalIconPrefixCls || (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9);
}
function $7ed5e10e08c170f8$var$isLegacyTheme(theme) {
    return Object.keys(theme).some((key)=>key.endsWith("Color"));
}
const $7ed5e10e08c170f8$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $7ed5e10e08c170f8$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $7ed5e10e08c170f8$var$globalIconPrefixCls = iconPrefixCls;
    if ("holderRender" in props) $7ed5e10e08c170f8$var$globalHolderRender = holderRender;
    if (theme) {
        if ($7ed5e10e08c170f8$var$isLegacyTheme(theme)) (0, $e1ca56936d2d2b32$export$f9c59eed5de5ff80)($7ed5e10e08c170f8$var$getGlobalPrefixCls(), theme);
        else $7ed5e10e08c170f8$var$globalTheme = theme;
    }
};
const $7ed5e10e08c170f8$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$7ed5e10e08c170f8$var$getGlobalPrefixCls()}-${suffixCls}` : $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $7ed5e10e08c170f8$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($7ed5e10e08c170f8$var$globalPrefixCls) return $7ed5e10e08c170f8$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $7ed5e10e08c170f8$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$7ed5e10e08c170f8$var$globalTheme,
        holderRender: $7ed5e10e08c170f8$var$globalHolderRender
    });
const $7ed5e10e08c170f8$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, anchor: anchor, form: form, locale: locale, componentSize: componentSize, direction: direction, space: space, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, menu: menu, pagination: pagination, input: input, textArea: textArea, empty: empty, badge: badge, radio: radio, rate: rate, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect } = props;
    // =================================== Context ===================================
    const getPrefixCls = $acw62.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $a18b2f6f56546238$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    (0, $af55bb63f7325a53$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    const mergedTheme = (0, $a1000671d52972e2$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls("")
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        anchor: anchor,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        textArea: textArea,
        layout: layout,
        list: list,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        radio: radio,
        rate: rate,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect
    };
    const config = Object.assign({}, parentContext);
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $7ed5e10e08c170f8$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== "undefined") // merge deprecated api
    config.button = Object.assign({
        autoInsertSpace: autoInsertSpaceInButton
    }, config.button);
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const memoIconContextValue = $acw62.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp
        }), [
        iconPrefixCls,
        csp
    ]);
    let childNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $a098b6503d6d9fdd$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $acw62.useMemo(()=>{
        var _a, _b, _c, _d;
        return (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(((_a = (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
    }, [
        memoedConfig,
        form === null || form === void 0 ? void 0 : form.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $acw62.createElement((0, $efabd6732f69a6da$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $acw62.createElement((0, $766ff256ac32087c$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $766ff256ac32087c$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $acw62.createElement((0, $6bacc63174d40f3c$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $acw62.createElement((0, $57278e23ed3ca8fa$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $acw62.useMemo(()=>{
        const _a = mergedTheme || {}, { algorithm: algorithm, token: token, components: components, cssVar: cssVar } = _a, rest = $7ed5e10e08c170f8$var$__rest(_a, [
            "algorithm",
            "token",
            "components",
            "cssVar"
        ]);
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $db48c74b3367fd88$export$2e2bcd8739ae039)(algorithm) : (0, $d6a0cd0c670c9aed$export$164de7ab8df77ef0);
        const parsedComponents = {};
        Object.entries(components || {}).forEach((_ref)=>{
            let [componentName, componentToken] = _ref;
            const parsedToken = Object.assign({}, componentToken);
            if ("algorithm" in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === "function") parsedToken.theme = (0, $db48c74b3367fd88$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = Object.assign(Object.assign({}, (0, $b1208bbc03407e2e$export$2e2bcd8739ae039)), token);
        return Object.assign(Object.assign({}, rest), {
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: Object.assign({
                override: mergedToken
            }, parsedComponents),
            cssVar: cssVar
        });
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $acw62.createElement((0, $d6a0cd0c670c9aed$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $acw62.createElement((0, $5bd796dbed593bbb$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $acw62.createElement((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $7ed5e10e08c170f8$var$ConfigProvider = (props)=>{
    const context = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const antLocale = $acw62.useContext((0, $6dd9227cba6de9ce$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $acw62.createElement($7ed5e10e08c170f8$var$ProviderChildren, Object.assign({
        parentContext: context,
        legacyLocale: antLocale
    }, props));
};
$7ed5e10e08c170f8$var$ConfigProvider.ConfigContext = (0, $a18b2f6f56546238$export$a92f85ab3e9ad68b);
$7ed5e10e08c170f8$var$ConfigProvider.SizeContext = (0, $3e100f55cf8f3689$export$2e2bcd8739ae039);
$7ed5e10e08c170f8$var$ConfigProvider.config = $7ed5e10e08c170f8$var$setGlobalConfig;
$7ed5e10e08c170f8$var$ConfigProvider.useConfig = (0, $1e1ca3bea54a77f7$export$2e2bcd8739ae039);
Object.defineProperty($7ed5e10e08c170f8$var$ConfigProvider, "SizeContext", {
    get: ()=>{
        return 0, $3e100f55cf8f3689$export$2e2bcd8739ae039;
    }
});
var $7ed5e10e08c170f8$export$2e2bcd8739ae039 = $7ed5e10e08c170f8$var$ConfigProvider;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


"use client";
const $148bd952cb1a5a76$var$Empty = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const bgColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(token.colorBgBase);
    // Dark Theme need more dark of this
    const themeStyle = bgColor.toHsl().l < 0.5 ? {
        opacity: 0.65
    } : {};
    return /*#__PURE__*/ $acw62.createElement("svg", {
        style: themeStyle,
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("title", null, "empty image"), /*#__PURE__*/ $acw62.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(24 31.67)"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fillOpacity: ".8",
        fill: "#F5F5F7",
        cx: "67.797",
        cy: "106.89",
        rx: "67.797",
        ry: "12.668"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
        fill: "#AEB8C2"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
        fill: "url(#linearGradient-1)",
        transform: "translate(13.56)"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
        fill: "#F5F5F7"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
        fill: "#DCE0E6"
    })), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
        fill: "#DCE0E6"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(149.65 15.383)",
        fill: "#FFF"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        cx: "20.654",
        cy: "3.167",
        rx: "2.849",
        ry: "2.815"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
    }))));
};
var $148bd952cb1a5a76$export$2e2bcd8739ae039 = $148bd952cb1a5a76$var$Empty;



var $acw62 = parcelRequire("acw62");


"use client";
const $ae7f97f0fd68830c$var$Simple = ()=>{
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $acw62.useMemo)(()=>({
            borderColor: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorFill).onBackground(colorBgContainer).toHexShortString(),
            shadowColor: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorFillTertiary).onBackground(colorBgContainer).toHexShortString(),
            contentColor: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorFillQuaternary).onBackground(colorBgContainer).toHexShortString()
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $acw62.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $acw62.createElement("title", null, "Simple Empty"), /*#__PURE__*/ $acw62.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $acw62.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $acw62.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $acw62.createElement("path", {
        d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
        fill: contentColor
    }))));
};
var $ae7f97f0fd68830c$export$2e2bcd8739ae039 = $ae7f97f0fd68830c$var$Simple;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
const $ec738b50e54e861e$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ let $ec738b50e54e861e$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        this.map = new Map();
        // Use WeakMap to avoid memory leak
        this.objectIDMap = new WeakMap();
        this.nextID = 0;
        this.lastAccessBeat = new Map();
        // We will clean up the cache when reach the limit
        this.accessBeat = 0;
    }
    return (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                const compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                const compositeKey = this.getCompositeKey(keys);
                const cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                const ids = keys.map((key)=>{
                    if (key && typeof key === "object") return `obj_${this.getObjectID(key)}`;
                    return `${typeof key}_${key}`;
                });
                return ids.join("|");
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                const id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                if (this.accessBeat > 10000) {
                    const now = Date.now();
                    this.lastAccessBeat.forEach((beat, key)=>{
                        if (now - beat > $ec738b50e54e861e$var$BEAT_LIMIT) {
                            this.map.delete(key);
                            this.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
}();
const $ec738b50e54e861e$var$uniqueMap = new $ec738b50e54e861e$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $ec738b50e54e861e$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const cachedValue = $ec738b50e54e861e$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        const newValue = memoFn();
        $ec738b50e54e861e$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $ec738b50e54e861e$export$2e2bcd8739ae039 = $ec738b50e54e861e$var$useUniqueMemo;






function $6e559d99029dd9fb$export$2e2bcd8739ae039(type) {
    if (type === "js") return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return `max(${args.map((value)=>(0, $f97444ff16d95e90$export$523c0b569236b342)(value)).join(",")})`;
        },
        min: function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return `min(${args.map((value)=>(0, $f97444ff16d95e90$export$523c0b569236b342)(value)).join(",")})`;
        }
    };
}


const $2049919111d93bd2$var$enableStatistic = typeof CSSINJS_STATISTIC !== "undefined";
let $2049919111d93bd2$var$recording = true;
function $2049919111d93bd2$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$2049919111d93bd2$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $2049919111d93bd2$var$recording = false;
    const ret = {};
    objs.forEach((obj)=>{
        const keys = Object.keys(obj);
        keys.forEach((key)=>{
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: ()=>obj[key]
            });
        });
    });
    $2049919111d93bd2$var$recording = true;
    return ret;
}
const $2049919111d93bd2$export$754a5e2d36c5fa7a = {};
const $2049919111d93bd2$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $2049919111d93bd2$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ const $2049919111d93bd2$var$statisticToken = (token)=>{
    let tokenKeys;
    let proxy = token;
    let flush = $2049919111d93bd2$var$noop;
    if ($2049919111d93bd2$var$enableStatistic && typeof Proxy !== "undefined") {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get (obj, prop) {
                if ($2049919111d93bd2$var$recording) tokenKeys.add(prop);
                return obj[prop];
            }
        });
        flush = (componentName, componentToken)=>{
            var _a;
            $2049919111d93bd2$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: Object.assign(Object.assign({}, (_a = $2049919111d93bd2$export$754a5e2d36c5fa7a[componentName]) === null || _a === void 0 ? void 0 : _a.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $2049919111d93bd2$export$2e2bcd8739ae039 = $2049919111d93bd2$var$statisticToken;



"use client";
const $099b764a368ed79c$var$getDefaultComponentToken = (component, token, getDefaultToken)=>{
    var _a;
    if (typeof getDefaultToken === "function") return getDefaultToken((0, $2049919111d93bd2$export$4950aa0f605343fb)(token, (_a = token[component]) !== null && _a !== void 0 ? _a : {}));
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
};
const $099b764a368ed79c$var$getComponentToken = (component, token, defaultToken, options)=>{
    const customToken = Object.assign({}, token[component]);
    if (options === null || options === void 0 ? void 0 : options.deprecatedTokens) {
        const { deprecatedTokens: deprecatedTokens } = options;
        deprecatedTokens.forEach((_ref)=>{
            let [oldTokenKey, newTokenKey] = _ref;
            var _a;
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if ((customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey]) || (customToken === null || customToken === void 0 ? void 0 : customToken[newTokenKey])) (_a = customToken[newTokenKey]) !== null && _a !== void 0 ? _a : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
        });
    }
    const mergedToken = Object.assign(Object.assign({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach((key)=>{
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
};
const $099b764a368ed79c$var$getCompVarPrefix = (component, prefix)=>`${[
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")
    ].filter(Boolean).join("-")}`;
function $099b764a368ed79c$export$2e2bcd8739ae039(componentName, styleFn, getDefaultToken) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const cells = Array.isArray(componentName) ? componentName : [
        componentName,
        componentName
    ];
    const [component] = cells;
    const concatComponent = cells.join("-");
    // Return new style hook
    return function(prefixCls) {
        let rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
        const [theme, realToken, hashId, token, cssVar] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls, csp: csp } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        const type = cssVar ? "css" : "js";
        // Use unique memo to share the result across all instances
        const calc = (0, $ec738b50e54e861e$export$2e2bcd8739ae039)(()=>{
            const unitlessCssVar = new Set();
            if (cssVar) Object.keys(options.unitless || {}).forEach((key)=>{
                // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                unitlessCssVar.add((0, $5a4d26b111585357$export$309b3b095f0c7662)(key, cssVar.prefix));
                unitlessCssVar.add((0, $5a4d26b111585357$export$309b3b095f0c7662)(key, $099b764a368ed79c$var$getCompVarPrefix(component, cssVar.prefix)));
            });
            return (0, $f7688ec948540519$export$2e2bcd8739ae039)(type, unitlessCssVar);
        }, [
            type,
            component,
            cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
        ]);
        const { max: max, min: min } = (0, $6e559d99029dd9fb$export$2e2bcd8739ae039)(type);
        // Shared config
        const sharedConfig = {
            theme: theme,
            token: token,
            hashId: hashId,
            nonce: ()=>csp === null || csp === void 0 ? void 0 : csp.nonce,
            clientOnly: options.clientOnly,
            layer: {
                name: "antd"
            },
            // antd is always at top of styles
            order: options.order || -999
        };
        // Generate style for all a tags in antd component.
        (0, $7927865cee518bb3$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, sharedConfig), {
            clientOnly: false,
            path: [
                "Shared",
                rootPrefixCls
            ]
        }), ()=>[
                {
                    // Link
                    "&": (0, $4733a3b3eb18f80d$export$905d771977096614)(token)
                }
            ]);
        // Generate style for icons
        (0, $af55bb63f7325a53$export$2e2bcd8739ae039)(iconPrefixCls, csp);
        const wrapSSR = (0, $7927865cee518bb3$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, sharedConfig), {
            path: [
                concatComponent,
                prefixCls,
                iconPrefixCls
            ]
        }), ()=>{
            if (options.injectStyle === false) return [];
            const { token: proxyToken, flush: flush } = (0, $2049919111d93bd2$export$2e2bcd8739ae039)(token);
            const defaultComponentToken = $099b764a368ed79c$var$getDefaultComponentToken(component, realToken, getDefaultToken);
            const componentCls = `.${prefixCls}`;
            const componentToken = $099b764a368ed79c$var$getComponentToken(component, realToken, defaultComponentToken, {
                deprecatedTokens: options.deprecatedTokens
            });
            if (cssVar) Object.keys(defaultComponentToken).forEach((key)=>{
                defaultComponentToken[key] = `var(${(0, $5a4d26b111585357$export$309b3b095f0c7662)(key, $099b764a368ed79c$var$getCompVarPrefix(component, cssVar.prefix))})`;
            });
            const mergedToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(proxyToken, {
                componentCls: componentCls,
                prefixCls: prefixCls,
                iconCls: `.${iconPrefixCls}`,
                antCls: `.${rootPrefixCls}`,
                calc: calc,
                max: // @ts-ignore
                max,
                min: // @ts-ignore
                min
            }, cssVar ? defaultComponentToken : componentToken);
            const styleInterpolation = styleFn(mergedToken, {
                hashId: hashId,
                prefixCls: prefixCls,
                rootPrefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls
            });
            flush(component, componentToken);
            return [
                options.resetStyle === false ? null : (0, $4733a3b3eb18f80d$export$689382c111559cd9)(mergedToken, prefixCls, rootCls, options.resetFont),
                styleInterpolation
            ];
        });
        return [
            wrapSSR,
            hashId
        ];
    };
}
const $099b764a368ed79c$export$1537386bc155ea56 = (componentName, styleFn, getDefaultToken, options)=>{
    const useStyle = $099b764a368ed79c$export$2e2bcd8739ae039(componentName, styleFn, getDefaultToken, Object.assign({
        resetStyle: false,
        // Sub Style should default after root one
        order: -998
    }, options));
    const StyledComponent = (_ref2)=>{
        let { prefixCls: prefixCls, rootCls: rootCls = prefixCls } = _ref2;
        useStyle(prefixCls, rootCls);
        return null;
    };
    return StyledComponent;
};
const $099b764a368ed79c$var$genCSSVarRegister = (component, getDefaultToken, options)=>{
    const { unitless: compUnitless, injectStyle: injectStyle = true, prefixToken: prefixToken } = options;
    const CSSVarRegister = (_ref3)=>{
        let { rootCls: rootCls, cssVar: cssVar } = _ref3;
        const [, realToken] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
        (0, $4766d7657208f51d$export$2e2bcd8739ae039)({
            path: [
                component
            ],
            prefix: cssVar.prefix,
            key: cssVar === null || cssVar === void 0 ? void 0 : cssVar.key,
            unitless: compUnitless,
            ignore: $d014fefdb4420ef5$export$738b109e247a462c,
            token: realToken,
            scope: rootCls
        }, ()=>{
            const defaultToken = $099b764a368ed79c$var$getDefaultComponentToken(component, realToken, getDefaultToken);
            const componentToken = $099b764a368ed79c$var$getComponentToken(component, realToken, defaultToken, {
                deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
            });
            Object.keys(defaultToken).forEach((key)=>{
                componentToken[prefixToken(key)] = componentToken[key];
                delete componentToken[key];
            });
            return componentToken;
        });
        return null;
    };
    const useCSSVar = (rootCls)=>{
        const [, , , , cssVar] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
        return [
            (node)=>injectStyle && cssVar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CSSVarRegister, {
                    rootCls: rootCls,
                    cssVar: cssVar,
                    component: component
                }), node) : node,
            cssVar === null || cssVar === void 0 ? void 0 : cssVar.key
        ];
    };
    return useCSSVar;
};
const $099b764a368ed79c$export$51ec95de45185b42 = (component, styleFn, getDefaultToken, options)=>{
    const componentName = Array.isArray(component) ? component[0] : component;
    function prefixToken(key) {
        return `${componentName}${key.slice(0, 1).toUpperCase()}${key.slice(1)}`;
    }
    // Fill unitless
    const originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
    const compUnitless = Object.assign(Object.assign({}, (0, $d014fefdb4420ef5$export$c6b9faa6b723d31a)), {
        [prefixToken("zIndexPopup")]: true
    });
    Object.keys(originUnitless).forEach((key)=>{
        compUnitless[prefixToken(key)] = originUnitless[key];
    });
    // Options
    const mergedOptions = Object.assign(Object.assign({}, options), {
        unitless: compUnitless,
        prefixToken: prefixToken
    });
    // Hooks
    const useStyle = $099b764a368ed79c$export$2e2bcd8739ae039(component, styleFn, getDefaultToken, mergedOptions);
    const useCSSVar = $099b764a368ed79c$var$genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
    return function(prefixCls) {
        let rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
        const [, hashId] = useStyle(prefixCls, rootCls);
        const [wrapCSSVar, cssVarCls] = useCSSVar(rootCls);
        return [
            wrapCSSVar,
            hashId,
            cssVarCls
        ];
    };
};


// ============================== Shared ==============================
const $ee15fc052b6837a1$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: "center",
            // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: "100%"
                },
                svg: {
                    maxWidth: "100%",
                    height: "100%",
                    margin: "auto"
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            "&-normal": {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            "&-small": {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$ee15fc052b6837a1$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Empty", (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return [
        $ee15fc052b6837a1$var$genSharedEmptyStyle(emptyToken)
    ];
});


"use client";
var $ec66348328372da5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $ec66348328372da5$var$defaultEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $148bd952cb1a5a76$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$simpleEmptyImg = /*#__PURE__*/ $acw62.createElement((0, $ae7f97f0fd68830c$export$2e2bcd8739ae039), null);
const $ec66348328372da5$var$Empty = (_a)=>{
    var { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image = $ec66348328372da5$var$defaultEmptyImg, description: description, children: children, imageStyle: imageStyle, style: style } = _a, restProps = $ec66348328372da5$var$__rest(_a, [
        "className",
        "rootClassName",
        "prefixCls",
        "image",
        "description",
        "children",
        "imageStyle",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, empty: empty } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("empty", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ee15fc052b6837a1$export$2e2bcd8739ae039)(prefixCls);
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Empty");
    const des = typeof description !== "undefined" ? description : locale === null || locale === void 0 ? void 0 : locale.description;
    const alt = typeof des === "string" ? des : "empty";
    let imageNode = null;
    if (typeof image === "string") imageNode = /*#__PURE__*/ $acw62.createElement("img", {
        alt: alt,
        src: image
    });
    else imageNode = image;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, prefixCls, empty === null || empty === void 0 ? void 0 : empty.className, {
            [`${prefixCls}-normal`]: image === $ec66348328372da5$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, className, rootClassName),
        style: Object.assign(Object.assign({}, empty === null || empty === void 0 ? void 0 : empty.style), style)
    }, restProps), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-image`,
        style: imageStyle
    }, imageNode), des && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-description`
    }, des), children && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-footer`
    }, children)));
};
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_DEFAULT = $ec66348328372da5$var$defaultEmptyImg;
$ec66348328372da5$var$Empty.PRESENTED_IMAGE_SIMPLE = $ec66348328372da5$var$simpleEmptyImg;
var $ec66348328372da5$export$2e2bcd8739ae039 = $ec66348328372da5$var$Empty;


"use client";
const $3feb83783705e448$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls("empty");
    switch(componentName){
        case "Table":
        case "List":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case "Select":
        case "TreeSelect":
        case "Cascader":
        case "Transfer":
        case "Mentions":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /* istanbul ignore next */ default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), null);
    }
};
var $3feb83783705e448$export$2e2bcd8739ae039 = $3feb83783705e448$var$DefaultRenderEmpty;



var $acw62 = parcelRequire("acw62");

const $086416f743106ac8$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $3e100f55cf8f3689$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === "string") return customSize !== null && customSize !== void 0 ? customSize : size;
        if (customSize instanceof Function) return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $086416f743106ac8$export$2e2bcd8739ae039 = $086416f743106ac8$var$useSize;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $0664da0d06972591$var$RowContext = /*#__PURE__*/ (0, $acw62.createContext)({});
var $0664da0d06972591$export$2e2bcd8739ae039 = $0664da0d06972591$var$RowContext;




// ============================== Row-Shared ==============================
const $ce0ae756d67d6466$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: "flex",
            flexFlow: "row wrap",
            minWidth: 0,
            "&::before, &::after": {
                display: "flex"
            },
            "&-no-wrap": {
                flexWrap: "nowrap"
            },
            // The origin of the X-axis
            "&-start": {
                justifyContent: "flex-start"
            },
            // The center of the X-axis
            "&-center": {
                justifyContent: "center"
            },
            // The opposite of the X-axis
            "&-end": {
                justifyContent: "flex-end"
            },
            "&-space-between": {
                justifyContent: "space-between"
            },
            "&-space-around": {
                justifyContent: "space-around"
            },
            "&-space-evenly": {
                justifyContent: "space-evenly"
            },
            // Align at the top
            "&-top": {
                alignItems: "flex-start"
            },
            // Align at the center
            "&-middle": {
                alignItems: "center"
            },
            "&-bottom": {
                alignItems: "flex-end"
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $ce0ae756d67d6466$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: "relative",
            maxWidth: "100%",
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $ce0ae756d67d6466$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls: prefixCls, componentCls: componentCls, gridColumns: gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: "none"
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: "auto"
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: "auto"
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: "auto"
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: "auto"
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ["--ant-display"]: "block",
                // Fallback to display if variable not support
                display: "block"
            },
            {
                display: "var(--ant-display)",
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const $ce0ae756d67d6466$var$genGridStyle = (token, sizeCls)=>$ce0ae756d67d6466$var$genLoopGridColumnsStyle(token, sizeCls);
const $ce0ae756d67d6466$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(screenSize)})`]: Object.assign({}, $ce0ae756d67d6466$var$genGridStyle(token, sizeCls))
    });
const $ce0ae756d67d6466$export$519f4f378a4f8e85 = ()=>({});
const $ce0ae756d67d6466$export$5504d86ab3175593 = ()=>({});
const $ce0ae756d67d6466$export$b0d9c6b8be4e14cd = (0, $099b764a368ed79c$export$51ec95de45185b42)("Grid", $ce0ae756d67d6466$var$genGridRowStyle, $ce0ae756d67d6466$export$519f4f378a4f8e85);
const $ce0ae756d67d6466$export$4d3e83959861592f = (0, $099b764a368ed79c$export$51ec95de45185b42)("Grid", (token)=>{
    const gridToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = {
        "-sm": gridToken.screenSMMin,
        "-md": gridToken.screenMDMin,
        "-lg": gridToken.screenLGMin,
        "-xl": gridToken.screenXLMin,
        "-xxl": gridToken.screenXXLMin
    };
    return [
        $ce0ae756d67d6466$var$genGridColStyle(gridToken),
        $ce0ae756d67d6466$var$genGridStyle(gridToken, ""),
        $ce0ae756d67d6466$var$genGridStyle(gridToken, "-xs"),
        Object.keys(gridMediaSizesMap).map((key)=>$ce0ae756d67d6466$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], key)).reduce((pre, cur)=>Object.assign(Object.assign({}, pre), cur), {})
    ];
}, $ce0ae756d67d6466$export$5504d86ab3175593);


"use client";
var $50bd634b7bc091a8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $50bd634b7bc091a8$var$RowAligns = [
    "top",
    "middle",
    "bottom",
    "stretch"
];
const $50bd634b7bc091a8$var$RowJustify = [
    "start",
    "end",
    "center",
    "space-around",
    "space-between",
    "space-evenly"
];
function $50bd634b7bc091a8$var$useMergedPropByScreen(oriProp, screen) {
    const [prop, setProp] = $acw62.useState(typeof oriProp === "string" ? oriProp : "");
    const calcMergedAlignOrJustify = ()=>{
        if (typeof oriProp === "string") setProp(oriProp);
        if (typeof oriProp !== "object") return;
        for(let i = 0; i < (0, $36689cb123f552b0$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $36689cb123f552b0$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen[breakpoint]) continue;
            const curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $acw62.useEffect(()=>{
        calcMergedAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
}
const $50bd634b7bc091a8$var$Row = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap } = props, others = $50bd634b7bc091a8$var$__rest(props, [
        "prefixCls",
        "justify",
        "align",
        "className",
        "style",
        "children",
        "gutter",
        "wrap"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [screens, setScreens] = $acw62.useState({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true
    });
    // to save screens info when responsiveObserve callback had been call
    const [curScreens, setCurScreens] = $acw62.useState({
        xs: false,
        sm: false,
        md: false,
        lg: false,
        xl: false,
        xxl: false
    });
    // ================================== calc responsive data ==================================
    const mergedAlign = $50bd634b7bc091a8$var$useMergedPropByScreen(align, curScreens);
    const mergedJustify = $50bd634b7bc091a8$var$useMergedPropByScreen(justify, curScreens);
    const gutterRef = $acw62.useRef(gutter);
    const responsiveObserver = (0, $36689cb123f552b0$export$2e2bcd8739ae039)();
    // ================================== Effect ==================================
    $acw62.useEffect(()=>{
        const token = responsiveObserver.subscribe((screen)=>{
            setCurScreens(screen);
            const currentGutter = gutterRef.current || 0;
            if (!Array.isArray(currentGutter) && typeof currentGutter === "object" || Array.isArray(currentGutter) && (typeof currentGutter[0] === "object" || typeof currentGutter[1] === "object")) setScreens(screen);
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    // ================================== Render ==================================
    const getGutter = ()=>{
        const results = [
            undefined,
            undefined
        ];
        const normalizedGutter = Array.isArray(gutter) ? gutter : [
            gutter,
            undefined
        ];
        normalizedGutter.forEach((g, index)=>{
            if (typeof g === "object") for(let i = 0; i < (0, $36689cb123f552b0$export$74c1bf8296b1541f).length; i++){
                const breakpoint = (0, $36689cb123f552b0$export$74c1bf8296b1541f)[i];
                if (screens[breakpoint] && g[breakpoint] !== undefined) {
                    results[index] = g[breakpoint];
                    break;
                }
            }
            else results[index] = g;
        });
        return results;
    };
    const prefixCls = getPrefixCls("row", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ce0ae756d67d6466$export$b0d9c6b8be4e14cd)(prefixCls);
    const gutters = getGutter();
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    const horizontalGutter = gutters[0] != null && gutters[0] > 0 ? gutters[0] / -2 : undefined;
    if (horizontalGutter) {
        rowStyle.marginLeft = horizontalGutter;
        rowStyle.marginRight = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $acw62.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $0664da0d06972591$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        className: classes,
        style: Object.assign(Object.assign({}, rowStyle), style),
        ref: ref
    }), children)));
});
var $50bd634b7bc091a8$export$2e2bcd8739ae039 = $50bd634b7bc091a8$var$Row;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $dcbb6d0bd42650d6$export$2e2bcd8739ae039() {
    const [, forceUpdate] = $acw62.useReducer((x)=>x + 1, 0);
    return forceUpdate;
}



"use client";
function $b8c04e47cb65d6a9$var$useBreakpoint() {
    let refreshOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const screensRef = (0, $acw62.useRef)({});
    const forceUpdate = (0, $dcbb6d0bd42650d6$export$2e2bcd8739ae039)();
    const responsiveObserver = (0, $36689cb123f552b0$export$2e2bcd8739ae039)();
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, []);
    return screensRef.current;
}
var $b8c04e47cb65d6a9$export$2e2bcd8739ae039 = $b8c04e47cb65d6a9$var$useBreakpoint;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $50e767e4968fb94a$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
var $50e767e4968fb94a$export$2e2bcd8739ae039 = $50e767e4968fb94a$var$DoubleLeftOutlined;







var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");




function $b9f59244e9def868$var$getRoot(ele) {
    var _ele$getRootNode;
    return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function $b9f59244e9def868$export$cca82218ea4431a(ele) {
    return $b9f59244e9def868$var$getRoot(ele) instanceof ShadowRoot;
}
function $b9f59244e9def868$export$70e8259662bb498b(ele) {
    return $b9f59244e9def868$export$cca82218ea4431a(ele) ? $b9f59244e9def868$var$getRoot(ele) : null;
}




var $acw62 = parcelRequire("acw62");

function $1beccdf56290315b$var$camelCase(input) {
    return input.replace(/-(.)/g, function(match, g) {
        return g.toUpperCase();
    });
}
function $1beccdf56290315b$export$491112666e282270(valid, message) {
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(valid, "[@ant-design/icons] ".concat(message));
}
function $1beccdf56290315b$export$ab652842c37578f4(target) {
    return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(target.icon) === "object" || typeof target.icon === "function");
}
function $1beccdf56290315b$export$9f5073e7201cc21c() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(attrs).reduce(function(acc, key) {
        var val = attrs[key];
        switch(key){
            case "class":
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$1beccdf56290315b$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $1beccdf56290315b$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(node.tag, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        key: key
    }, $1beccdf56290315b$export$9f5073e7201cc21c(node.attrs)), rootProps), (node.children || []).map(function(child, index) {
        return $1beccdf56290315b$export$80d376111cc09ad7(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
}
function $1beccdf56290315b$export$b71c93f469694483(primaryColor) {
    // choose the second color
    return (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(primaryColor)[0];
}
function $1beccdf56290315b$export$b5b464c3d8433a9b(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
var $1beccdf56290315b$export$960a899a9cccb2d5 = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
};
var $1beccdf56290315b$export$2c99b98b77550cb4 = "\n.anticon {\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var $1beccdf56290315b$export$938b1f86b61613d0 = function useInsertStyles(eleRef) {
    var _useContext = (0, $acw62.useContext)((0, $6bacc63174d40f3c$export$2e2bcd8739ae039)), csp = _useContext.csp, prefixCls = _useContext.prefixCls;
    var mergedStyleStr = $1beccdf56290315b$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    (0, $acw62.useEffect)(function() {
        var ele = eleRef.current;
        var shadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(ele);
        (0, $3a22468320d7d808$export$4d99a2890bb989f0)(mergedStyleStr, "@ant-design-icons", {
            prepend: true,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


var $c52e7cd4d4f30fad$var$_excluded = [
    "icon",
    "className",
    "onClick",
    "style",
    "primaryColor",
    "secondaryColor"
];
var $c52e7cd4d4f30fad$var$twoToneColorPalette = {
    primaryColor: "#333",
    secondaryColor: "#E6E6E6",
    calculated: false
};
function $c52e7cd4d4f30fad$var$setTwoToneColors(_ref) {
    var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.primaryColor = primaryColor;
    $c52e7cd4d4f30fad$var$twoToneColorPalette.secondaryColor = secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor);
    $c52e7cd4d4f30fad$var$twoToneColorPalette.calculated = !!secondaryColor;
}
function $c52e7cd4d4f30fad$var$getTwoToneColors() {
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $c52e7cd4d4f30fad$var$twoToneColorPalette);
}
var $c52e7cd4d4f30fad$var$IconBase = function IconBase(props) {
    var icon = props.icon, className = props.className, onClick = props.onClick, style = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $c52e7cd4d4f30fad$var$_excluded);
    var svgRef = $acw62.useRef();
    var colors = $c52e7cd4d4f30fad$var$twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor || (0, $1beccdf56290315b$export$b71c93f469694483)(primaryColor)
    };
    (0, $1beccdf56290315b$export$938b1f86b61613d0)(svgRef);
    (0, $1beccdf56290315b$export$491112666e282270)((0, $1beccdf56290315b$export$ab652842c37578f4)(icon), "icon should be icon definiton, but got ".concat(icon));
    if (!(0, $1beccdf56290315b$export$ab652842c37578f4)(icon)) return null;
    var target = icon;
    if (target && typeof target.icon === "function") target = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, target), {}, {
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
    return (0, $1beccdf56290315b$export$80d376111cc09ad7)(target.icon, "svg-".concat(target.name), (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        className: className,
        onClick: onClick,
        style: style,
        "data-icon": target.name,
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true"
    }, restProps), {}, {
        ref: svgRef
    }));
};
$c52e7cd4d4f30fad$var$IconBase.displayName = "IconReact";
$c52e7cd4d4f30fad$var$IconBase.getTwoToneColors = $c52e7cd4d4f30fad$var$getTwoToneColors;
$c52e7cd4d4f30fad$var$IconBase.setTwoToneColors = $c52e7cd4d4f30fad$var$setTwoToneColors;
var $c52e7cd4d4f30fad$export$2e2bcd8739ae039 = $c52e7cd4d4f30fad$var$IconBase;





function $27dd37ce58e7c6e8$export$8a145f34580ff02b(twoToneColor) {
    var _normalizeTwoToneColo = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).setTwoToneColors({
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    });
}
function $27dd37ce58e7c6e8$export$abc7c554784cb4a7() {
    var colors = (0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}



"use client";
var $7714637e9c1f1f3f$var$_excluded = [
    "className",
    "icon",
    "spin",
    "rotate",
    "tabIndex",
    "onClick",
    "twoToneColor"
];
// Initial setting
// should move it to antd main repo?
(0, $27dd37ce58e7c6e8$export$8a145f34580ff02b)((0, $0b4842326956570d$export$2aa0182783e7e9de).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
var $7714637e9c1f1f3f$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $7714637e9c1f1f3f$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $6bacc63174d40f3c$export$2e2bcd8739ae039)), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rootClassName, prefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), className);
    var iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    var svgStyle = rotate ? {
        msTransform: "rotate(".concat(rotate, "deg)"),
        transform: "rotate(".concat(rotate, "deg)")
    } : undefined;
    var _normalizeTwoToneColo = (0, $1beccdf56290315b$export$b5b464c3d8433a9b)(twoToneColor), _normalizeTwoToneColo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
    return /*#__PURE__*/ $acw62.createElement("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $acw62.createElement((0, $c52e7cd4d4f30fad$export$2e2bcd8739ae039), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
$7714637e9c1f1f3f$var$Icon.displayName = "AntdIcon";
$7714637e9c1f1f3f$var$Icon.getTwoToneColor = (0, $27dd37ce58e7c6e8$export$abc7c554784cb4a7);
$7714637e9c1f1f3f$var$Icon.setTwoToneColor = (0, $27dd37ce58e7c6e8$export$8a145f34580ff02b);
var $7714637e9c1f1f3f$export$2e2bcd8739ae039 = $7714637e9c1f1f3f$var$Icon;


var $fbba0865720ca5de$var$DoubleLeftOutlined = function DoubleLeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $50e767e4968fb94a$export$2e2bcd8739ae039)
    }));
};
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ var $fbba0865720ca5de$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($fbba0865720ca5de$var$DoubleLeftOutlined);
var $fbba0865720ca5de$export$2e2bcd8739ae039 = $fbba0865720ca5de$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $6ce95b223b6e0f50$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
var $6ce95b223b6e0f50$export$2e2bcd8739ae039 = $6ce95b223b6e0f50$var$DoubleRightOutlined;



var $a7afd88ad369b46e$var$DoubleRightOutlined = function DoubleRightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $6ce95b223b6e0f50$export$2e2bcd8739ae039)
    }));
};
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ var $a7afd88ad369b46e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($a7afd88ad369b46e$var$DoubleRightOutlined);
var $a7afd88ad369b46e$export$2e2bcd8739ae039 = $a7afd88ad369b46e$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $766a51baf3f136aa$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
var $766a51baf3f136aa$export$2e2bcd8739ae039 = $766a51baf3f136aa$var$LeftOutlined;



var $1e62197f718e4845$var$LeftOutlined = function LeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $766a51baf3f136aa$export$2e2bcd8739ae039)
    }));
};
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ var $1e62197f718e4845$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1e62197f718e4845$var$LeftOutlined);
var $1e62197f718e4845$export$2e2bcd8739ae039 = $1e62197f718e4845$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $73624b371df38195$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
var $73624b371df38195$export$2e2bcd8739ae039 = $73624b371df38195$var$RightOutlined;



var $ae197ef38b34eab8$var$RightOutlined = function RightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $73624b371df38195$export$2e2bcd8739ae039)
    }));
};
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ var $ae197ef38b34eab8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ae197ef38b34eab8$var$RightOutlined);
var $ae197ef38b34eab8$export$2e2bcd8739ae039 = $ae197ef38b34eab8$var$RefIcon;










/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $d8d9cb1a28007639$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $d8d9cb1a28007639$var$KeyCode.F1 && keyCode <= $d8d9cb1a28007639$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.ALT:
            case $d8d9cb1a28007639$var$KeyCode.CAPS_LOCK:
            case $d8d9cb1a28007639$var$KeyCode.CONTEXT_MENU:
            case $d8d9cb1a28007639$var$KeyCode.CTRL:
            case $d8d9cb1a28007639$var$KeyCode.DOWN:
            case $d8d9cb1a28007639$var$KeyCode.END:
            case $d8d9cb1a28007639$var$KeyCode.ESC:
            case $d8d9cb1a28007639$var$KeyCode.HOME:
            case $d8d9cb1a28007639$var$KeyCode.INSERT:
            case $d8d9cb1a28007639$var$KeyCode.LEFT:
            case $d8d9cb1a28007639$var$KeyCode.MAC_FF_META:
            case $d8d9cb1a28007639$var$KeyCode.META:
            case $d8d9cb1a28007639$var$KeyCode.NUMLOCK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_CENTER:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_DOWN:
            case $d8d9cb1a28007639$var$KeyCode.PAGE_UP:
            case $d8d9cb1a28007639$var$KeyCode.PAUSE:
            case $d8d9cb1a28007639$var$KeyCode.PRINT_SCREEN:
            case $d8d9cb1a28007639$var$KeyCode.RIGHT:
            case $d8d9cb1a28007639$var$KeyCode.SHIFT:
            case $d8d9cb1a28007639$var$KeyCode.UP:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY:
            case $d8d9cb1a28007639$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NINE) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.NUM_ZERO && keyCode <= $d8d9cb1a28007639$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $d8d9cb1a28007639$var$KeyCode.A && keyCode <= $d8d9cb1a28007639$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $d8d9cb1a28007639$var$KeyCode.SPACE:
            case $d8d9cb1a28007639$var$KeyCode.QUESTION_MARK:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PLUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_MINUS:
            case $d8d9cb1a28007639$var$KeyCode.NUM_PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.NUM_DIVISION:
            case $d8d9cb1a28007639$var$KeyCode.SEMICOLON:
            case $d8d9cb1a28007639$var$KeyCode.DASH:
            case $d8d9cb1a28007639$var$KeyCode.EQUALS:
            case $d8d9cb1a28007639$var$KeyCode.COMMA:
            case $d8d9cb1a28007639$var$KeyCode.PERIOD:
            case $d8d9cb1a28007639$var$KeyCode.SLASH:
            case $d8d9cb1a28007639$var$KeyCode.APOSTROPHE:
            case $d8d9cb1a28007639$var$KeyCode.SINGLE_QUOTE:
            case $d8d9cb1a28007639$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $d8d9cb1a28007639$var$KeyCode.BACKSLASH:
            case $d8d9cb1a28007639$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $d8d9cb1a28007639$export$2e2bcd8739ae039 = $d8d9cb1a28007639$var$KeyCode;



var $281efe5882c936de$var$attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var $281efe5882c936de$var$eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var $281efe5882c936de$var$propList = "".concat($281efe5882c936de$var$attributes, " ").concat($281efe5882c936de$var$eventsName).split(/[\s\n]+/);
/* eslint-enable max-len */ var $281efe5882c936de$var$ariaPrefix = "aria-";
var $281efe5882c936de$var$dataPrefix = "data-";
function $281efe5882c936de$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $281efe5882c936de$export$2e2bcd8739ae039(props) {
    var ariaOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ariaOnly);
    var attrs = {};
    Object.keys(props).forEach(function(key) {
        if (// Aria
        mergedConfig.aria && (key === "role" || $281efe5882c936de$var$match(key, $281efe5882c936de$var$ariaPrefix)) || // Data
        mergedConfig.data && $281efe5882c936de$var$match(key, $281efe5882c936de$var$dataPrefix) || // Attr
        mergedConfig.attr && $281efe5882c936de$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}




var $acw62 = parcelRequire("acw62");
var $afcaa77fb9a0c881$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $afcaa77fb9a0c881$export$2e2bcd8739ae039 = $afcaa77fb9a0c881$var$locale;





var $acw62 = parcelRequire("acw62");
var $ff8fc702e2ff2e68$var$defaultPageSizeOptions = [
    "10",
    "20",
    "50",
    "100"
];
var $ff8fc702e2ff2e68$var$Options = function Options(props) {
    var _props$pageSizeOption = props.pageSizeOptions, pageSizeOptions = _props$pageSizeOption === void 0 ? $ff8fc702e2ff2e68$var$defaultPageSizeOptions : _props$pageSizeOption, locale = props.locale, changeSize = props.changeSize, pageSize = props.pageSize, goButton = props.goButton, quickGo = props.quickGo, rootPrefixCls = props.rootPrefixCls, Select = props.selectComponentClass, selectPrefixCls = props.selectPrefixCls, disabled = props.disabled, buildOptionText = props.buildOptionText;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(""), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), goInputText = _React$useState2[0], setGoInputText = _React$useState2[1];
    var getValidValue = function getValidValue() {
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    };
    var mergeBuildOptionText = typeof buildOptionText === "function" ? buildOptionText : function(value) {
        return "".concat(value, " ").concat(locale.items_per_page);
    };
    var changeSizeHandle = function changeSizeHandle(value) {
        changeSize === null || changeSize === void 0 || changeSize(Number(value));
    };
    var handleChange = function handleChange(e) {
        setGoInputText(e.target.value);
    };
    var handleBlur = function handleBlur(e) {
        if (goButton || goInputText === "") return;
        setGoInputText("");
        if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) return;
        quickGo === null || quickGo === void 0 || quickGo(getValidValue());
    };
    var go = function go(e) {
        if (goInputText === "") return;
        if (e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER || e.type === "click") {
            setGoInputText("");
            quickGo === null || quickGo === void 0 || quickGo(getValidValue());
        }
    };
    var getPageSizeOptions = function getPageSizeOptions() {
        if (pageSizeOptions.some(function(option) {
            return option.toString() === pageSize.toString();
        })) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize.toString()
        ]).sort(function(a, b) {
            var numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            var numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    var prefixCls = "".concat(rootPrefixCls, "-options");
    // ============== render ==============
    if (!changeSize && !quickGo) return null;
    var changeSelect = null;
    var goInput = null;
    var gotoButton = null;
    if (changeSize && Select) {
        var options = getPageSizeOptions().map(function(opt, i) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Select.Option, {
                key: i,
                value: opt.toString()
            }, mergeBuildOptionText(opt));
        });
        changeSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Select, {
            disabled: disabled,
            prefixCls: selectPrefixCls,
            showSearch: false,
            className: "".concat(prefixCls, "-size-changer"),
            optionLabelProp: "children",
            popupMatchSelectWidth: false,
            value: (pageSize || pageSizeOptions[0]).toString(),
            onChange: changeSizeHandle,
            getPopupContainer: function getPopupContainer(triggerNode) {
                return triggerNode.parentNode;
            },
            "aria-label": locale.page_size,
            defaultOpen: false
        }, options);
    }
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === "boolean" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: "".concat(prefixCls, "-quick-jumper-button")
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "".concat(prefixCls, "-quick-jumper")
        }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
var $ff8fc702e2ff2e68$export$2e2bcd8739ae039 = $ff8fc702e2ff2e68$var$Options;





var $acw62 = parcelRequire("acw62");
var $5c6b88f5a3018b73$var$Pager = function Pager(props) {
    var _classNames;
    var rootPrefixCls = props.rootPrefixCls, page = props.page, active = props.active, className = props.className, showTitle = props.showTitle, onClick = props.onClick, onKeyPress = props.onKeyPress, itemRender = props.itemRender;
    var prefixCls = "".concat(rootPrefixCls, "-item");
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, "".concat(prefixCls, "-").concat(page), (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-active"), active), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), !page), _classNames), className);
    var handleClick = function handleClick() {
        onClick(page);
    };
    var handleKeyPress = function handleKeyPress(e) {
        onKeyPress(e, onClick, page);
    };
    var pager = itemRender(page, "page", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
var $5c6b88f5a3018b73$export$2e2bcd8739ae039 = $5c6b88f5a3018b73$var$Pager;


var $1f6ffa8a107637fc$var$defaultItemRender = function defaultItemRender(page, type, element) {
    return element;
};
function $1f6ffa8a107637fc$var$noop() {}
function $1f6ffa8a107637fc$var$isInteger(v) {
    var value = Number(v);
    return typeof value === "number" && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $1f6ffa8a107637fc$var$calculatePage(p, pageSize, total) {
    var _pageSize = typeof p === "undefined" ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
var $1f6ffa8a107637fc$var$Pagination = function Pagination(props) {
    var _classNames5;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-pagination" : _props$prefixCls, _props$selectPrefixCl = props.selectPrefixCls, selectPrefixCls = _props$selectPrefixCl === void 0 ? "rc-select" : _props$selectPrefixCl, className = props.className, selectComponentClass = props.selectComponentClass, currentProp = props.current, _props$defaultCurrent = props.defaultCurrent, defaultCurrent = _props$defaultCurrent === void 0 ? 1 : _props$defaultCurrent, _props$total = props.total, total = _props$total === void 0 ? 0 : _props$total, pageSizeProp = props.pageSize, _props$defaultPageSiz = props.defaultPageSize, defaultPageSize = _props$defaultPageSiz === void 0 ? 10 : _props$defaultPageSiz, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? $1f6ffa8a107637fc$var$noop : _props$onChange, hideOnSinglePage = props.hideOnSinglePage, align = props.align, _props$showPrevNextJu = props.showPrevNextJumpers, showPrevNextJumpers = _props$showPrevNextJu === void 0 ? true : _props$showPrevNextJu, showQuickJumper = props.showQuickJumper, showLessItems = props.showLessItems, _props$showTitle = props.showTitle, showTitle = _props$showTitle === void 0 ? true : _props$showTitle, _props$onShowSizeChan = props.onShowSizeChange, onShowSizeChange = _props$onShowSizeChan === void 0 ? $1f6ffa8a107637fc$var$noop : _props$onShowSizeChan, _props$locale = props.locale, locale = _props$locale === void 0 ? (0, $afcaa77fb9a0c881$export$2e2bcd8739ae039) : _props$locale, style = props.style, _props$totalBoundaryS = props.totalBoundaryShowSizeChanger, totalBoundaryShowSizeChanger = _props$totalBoundaryS === void 0 ? 50 : _props$totalBoundaryS, disabled = props.disabled, simple = props.simple, showTotal = props.showTotal, showSizeChangerProp = props.showSizeChanger, pageSizeOptions = props.pageSizeOptions, _props$itemRender = props.itemRender, itemRender = _props$itemRender === void 0 ? $1f6ffa8a107637fc$var$defaultItemRender : _props$itemRender, jumpPrevIcon = props.jumpPrevIcon, jumpNextIcon = props.jumpNextIcon, prevIcon = props.prevIcon, nextIcon = props.nextIcon;
    var paginationRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(10, {
        value: pageSizeProp,
        defaultValue: defaultPageSize
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), pageSize = _useMergedState2[0], setPageSize = _useMergedState2[1];
    var _useMergedState3 = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(1, {
        value: currentProp,
        defaultValue: defaultCurrent,
        postState: function postState(c) {
            return Math.max(1, Math.min(c, $1f6ffa8a107637fc$var$calculatePage(undefined, pageSize, total)));
        }
    }), _useMergedState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState3, 2), current = _useMergedState4[0], setCurrent = _useMergedState4[1];
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(current), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), internalInputVal = _React$useState2[0], setInternalInputVal = _React$useState2[1];
    (0, $acw62.useEffect)(function() {
        setInternalInputVal(current);
    }, [
        current
    ]);
    var hasOnChange = onChange !== $1f6ffa8a107637fc$var$noop;
    var hasCurrent = "current" in props;
    var jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    var jumpNextPage = Math.min($1f6ffa8a107637fc$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        var iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            "aria-label": label,
            className: "".concat(prefixCls, "-item-link")
        });
        if (typeof icon === "function") iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(icon, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props));
        return iconNode;
    }
    function getValidValue(e) {
        var inputValue = e.target.value;
        var allPages = $1f6ffa8a107637fc$var$calculatePage(undefined, pageSize, total);
        var value;
        if (inputValue === "") value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $1f6ffa8a107637fc$var$isInteger(page) && page !== current && $1f6ffa8a107637fc$var$isInteger(total) && total > 0;
    }
    var shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP || event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        var value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        var newCurrent = $1f6ffa8a107637fc$var$calculatePage(size, pageSize, total);
        var nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange === null || onShowSizeChange === void 0 || onShowSizeChange(current, size);
        setCurrent(nextCurrent);
        onChange === null || onChange === void 0 || onChange(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            var currentPage = $1f6ffa8a107637fc$var$calculatePage(undefined, pageSize, total);
            var newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange === null || onChange === void 0 || onChange(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    var hasPrev = current > 1;
    var hasNext = current < $1f6ffa8a107637fc$var$calculatePage(undefined, pageSize, total);
    var showSizeChanger = showSizeChangerProp !== null && showSizeChangerProp !== void 0 ? showSizeChangerProp : total > totalBoundaryShowSizeChanger;
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback) {
        if (event.key === "Enter" || event.charCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) {
            for(var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restParams[_key - 2] = arguments[_key];
            callback.apply(void 0, restParams);
        }
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        var prevButton = itemRender(prevPage, "prev", getItemIcon(prevIcon, "prev page"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(prevButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        var nextButton = itemRender(nextPage, "next", getItemIcon(nextIcon, "next page"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(nextButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === "click" || event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    var jumpPrev = null;
    var dataOrAriaAttributeProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    var totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "".concat(prefixCls, "-total-text")
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    var jumpNext = null;
    var allPages = $1f6ffa8a107637fc$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    var pagerList = [];
    var pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1
    };
    var prevPage = current - 1 > 0 ? current - 1 : 0;
    var nextPage = current + 1 < allPages ? current + 1 : allPages;
    var goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    var isReadOnly = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(simple) === "object" ? simple.readOnly : !simple;
    var gotoButton = goButton;
    var simplePager = null;
    if (simple) {
        // ====== Simple quick jump ======
        if (goButton) {
            if (typeof goButton === "boolean") gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, locale.jump_to_confirm);
            else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, goButton);
            gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                title: showTitle ? "".concat(locale.jump_to).concat(current, "/").concat(allPages) : null,
                className: "".concat(prefixCls, "-simple-pager")
            }, gotoButton);
        }
        simplePager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            title: showTitle ? "".concat(current, "/").concat(allPages) : null,
            className: "".concat(prefixCls, "-simple-pager")
        }, isReadOnly ? internalInputVal : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "text",
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "".concat(prefixCls, "-slash")
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    var pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c6b88f5a3018b73$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: "".concat(prefixCls, "-item-disabled")
        })));
        for(var i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c6b88f5a3018b73$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        var prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        var nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        var jumpPrevContent = itemRender(jumpPrevPage, "jump-prev", getItemIcon(jumpPrevIcon, "prev page"));
        var jumpNextContent = itemRender(jumpNextPage, "jump-next", getItemIcon(jumpNextIcon, "next page"));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-jump-prev"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-jump-next"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
            }, jumpNextContent) : null;
        }
        var left = Math.max(1, current - pageBufferSize);
        var right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        for(var _i = left; _i <= right; _i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c6b88f5a3018b73$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pagerProps, {
            key: _i,
            page: _i,
            active: current === _i
        })));
        if (current - 1 >= pageBufferSize * 2 && current !== 3) {
            pagerList[0] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(pagerList[0], {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-item-after-jump-prev"), pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
            var lastOne = pagerList[pagerList.length - 1];
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(lastOne, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-item-before-jump-next"), lastOne.props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c6b88f5a3018b73$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5c6b88f5a3018b73$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    var prev = renderPrev(prevPage);
    if (prev) {
        var prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-prev"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
            "aria-disabled": prevDisabled
        }, prev);
    }
    var next = renderNext(nextPage);
    if (next) {
        var nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-next"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
            "aria-disabled": nextDisabled
        }, next);
    }
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (_classNames5 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames5, "".concat(prefixCls, "-start"), align === "start"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames5, "".concat(prefixCls, "-center"), align === "center"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames5, "".concat(prefixCls, "-end"), align === "end"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames5, "".concat(prefixCls, "-simple"), simple), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames5, "".concat(prefixCls, "-disabled"), disabled), _classNames5));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ff8fc702e2ff2e68$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectComponentClass: selectComponentClass,
        selectPrefixCls: selectPrefixCls,
        changeSize: showSizeChanger ? changePageSize : null,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton
    }));
};
var $1f6ffa8a107637fc$export$2e2bcd8739ae039 = $1f6ffa8a107637fc$var$Pagination;











var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");









var $066d1680709fcf3c$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === "undefined" || typeof window === "undefined") return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $707d52f2ac65b829$var$TransBtn = function TransBtn(props) {
    var className = props.className, customizeIcon = props.customizeIcon, customizeIconProps = props.customizeIconProps, children = props.children, _onMouseDown = props.onMouseDown, onClick = props.onClick;
    var icon = typeof customizeIcon === "function" ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: className,
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
        },
        style: {
            userSelect: "none",
            WebkitUserSelect: "none"
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className.split(/\s+/).map(function(cls) {
            return "".concat(cls, "-icon");
        }))
    }, children));
};
var $707d52f2ac65b829$export$2e2bcd8739ae039 = $707d52f2ac65b829$var$TransBtn;



var $acw62 = parcelRequire("acw62");
var $2025e240a41c9299$export$9ea6397a890aa3e5 = function useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
    var disabled = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var mergedSearchValue = arguments.length > 6 ? arguments[6] : undefined;
    var mode = arguments.length > 7 ? arguments[7] : undefined;
    var mergedClearIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(allowClear) === "object") return allowClear.clearIcon;
        if (clearIcon) return clearIcon;
    }, [
        allowClear,
        clearIcon
    ]);
    var mergedAllowClear = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === "combobox" && mergedSearchValue === "")) return true;
        return false;
    }, [
        allowClear,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
    return {
        allowClear: mergedAllowClear,
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
            className: "".concat(prefixCls, "-clear"),
            onMouseDown: onClearMouseDown,
            customizeIcon: mergedClearIcon
        }, "\xd7")
    };
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $acw62 = parcelRequire("acw62");
var $de346c10040f695b$export$8234047c0aea33cf = /*#__PURE__*/ $acw62.createContext(null);
function $de346c10040f695b$export$2e2bcd8739ae039() {
    return $acw62.useContext($de346c10040f695b$export$8234047c0aea33cf);
}




var $acw62 = parcelRequire("acw62");
function $6ca183ed87ff681f$export$2e2bcd8739ae039() {
    var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
    var delayRef = $acw62.useRef(null);
    var cancelLatest = function cancelLatest() {
        window.clearTimeout(delayRef.current);
    };
    $acw62.useEffect(function() {
        return cancelLatest;
    }, []);
    var delaySetBool = function delaySetBool(value, callback) {
        cancelLatest();
        delayRef.current = window.setTimeout(function() {
            setBool(value);
            if (callback) callback();
        }, timeout);
    };
    return [
        bool,
        delaySetBool,
        cancelLatest
    ];
}



var $acw62 = parcelRequire("acw62");
function $d2c203a0ff231923$export$2e2bcd8739ae039() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
    var lockRef = $acw62.useRef(null);
    var timeoutRef = $acw62.useRef(null);
    // Clean up
    $acw62.useEffect(function() {
        return function() {
            window.clearTimeout(timeoutRef.current);
        };
    }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(function() {
            lockRef.current = null;
        }, duration);
    }
    return [
        function() {
            return lockRef.current;
        },
        doLock
    ];
}



var $acw62 = parcelRequire("acw62");
function $aebeaa3bc993c458$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    var propsRef = $acw62.useRef(null);
    propsRef.current = {
        open: open,
        triggerOpen: triggerOpen,
        customizedTrigger: customizedTrigger
    };
    $acw62.useEffect(function() {
        function onGlobalMouseDown(event) {
            var _propsRef$current;
            // If trigger is customized, Trigger will take control of popupVisible
            if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) return;
            var target = event.target;
            if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
            if (propsRef.current.open && elements().filter(function(element) {
                return element;
            }).every(function(element) {
                return !element.contains(target) && element !== target;
            })) // Should trigger close
            propsRef.current.triggerOpen(false);
        }
        window.addEventListener("mousedown", onGlobalMouseDown);
        return function() {
            return window.removeEventListener("mousedown", onGlobalMouseDown);
        };
    }, []);
}






var $acw62 = parcelRequire("acw62");


function $4ae276a1f02fe75e$export$48ac81d4a07c29c(currentKeyCode) {
    return ![
        // System function button
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).SHIFT,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).BACKSPACE,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).TAB,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).WIN_KEY,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ALT,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).META,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).CTRL,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).SEMICOLON,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).EQUALS,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).CONTEXT_MENU,
        // F1-F12
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F1,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F2,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F3,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F4,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F5,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F6,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F7,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F8,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F9,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F10,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F11,
        (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode);
}





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $e85c9ef0f09d251f$export$2e2bcd8739ae039(children) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, function(child) {
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child));
        else if ((0, $3251146683c5d714$exports.isFragment)(child) && child.props) ret = ret.concat($e85c9ef0f09d251f$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}








var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $3b6981416c8ff0a7$export$db36075d98ba73d3 = /*#__PURE__*/ $acw62.createContext(null);
function $3b6981416c8ff0a7$export$fb8073518f34e6ec(_ref) {
    var children = _ref.children, onBatchResize = _ref.onBatchResize;
    var resizeIdRef = $acw62.useRef(0);
    var resizeInfosRef = $acw62.useRef([]);
    var onCollectionResize = $acw62.useContext($3b6981416c8ff0a7$export$db36075d98ba73d3);
    var onResize = $acw62.useCallback(function(size, element, data) {
        resizeIdRef.current += 1;
        var currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(function() {
            if (currentId === resizeIdRef.current) {
                onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $acw62.createElement($3b6981416c8ff0a7$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}


/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $87c2a74187854fda$var$MapShim = function() {
    if (typeof Map !== "undefined") return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $87c2a74187854fda$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
// Returns global object of a current environment.
var $87c2a74187854fda$var$global$1 = function() {
    if (typeof $parcel$global !== "undefined" && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== "undefined" && self.Math === Math) return self;
    if (typeof window !== "undefined" && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function("return this")();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $87c2a74187854fda$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === "function") // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($87c2a74187854fda$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $87c2a74187854fda$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $87c2a74187854fda$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $87c2a74187854fda$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $87c2a74187854fda$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $87c2a74187854fda$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $87c2a74187854fda$var$transitionKeys = [
    "top",
    "right",
    "bottom",
    "left",
    "width",
    "height",
    "size",
    "weight"
];
// Check if MutationObserver is available.
var $87c2a74187854fda$var$mutationObserverSupported = typeof MutationObserver !== "undefined";
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $87c2a74187854fda$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $87c2a74187854fda$var$throttle(this.refresh.bind(this), $87c2a74187854fda$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$87c2a74187854fda$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener("transitionend", this.onTransitionEnd_);
        window.addEventListener("resize", this.refresh);
        if ($87c2a74187854fda$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener("DOMSubtreeModified", this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$87c2a74187854fda$var$isBrowser || !this.connected_) return;
        document.removeEventListener("transitionend", this.onTransitionEnd_);
        window.removeEventListener("resize", this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener("DOMSubtreeModified", this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $87c2a74187854fda$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $87c2a74187854fda$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $87c2a74187854fda$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $87c2a74187854fda$var$global$1;
};
// Placeholder of an empty content rectangle.
var $87c2a74187854fda$var$emptyRect = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $87c2a74187854fda$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $87c2a74187854fda$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles["border-" + position + "-width"];
        return size + $87c2a74187854fda$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $87c2a74187854fda$var$getPaddings(styles) {
    var positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles["padding-" + position];
        paddings[position] = $87c2a74187854fda$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $87c2a74187854fda$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $87c2a74187854fda$var$emptyRect;
    var styles = $87c2a74187854fda$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $87c2a74187854fda$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $87c2a74187854fda$var$toFloat(styles.width), height = $87c2a74187854fda$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === "border-box") {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $87c2a74187854fda$var$getBordersSize(styles, "left", "right") + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $87c2a74187854fda$var$getBordersSize(styles, "top", "bottom") + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$87c2a74187854fda$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $87c2a74187854fda$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $87c2a74187854fda$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== "undefined") return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $87c2a74187854fda$var$getWindowOf(target).SVGElement && typeof target.getBBox === "function";
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $87c2a74187854fda$var$isDocumentElement(target) {
    return target === $87c2a74187854fda$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$getContentRect(target) {
    if (!$87c2a74187854fda$var$isBrowser) return $87c2a74187854fda$var$emptyRect;
    if ($87c2a74187854fda$var$isSVGGraphicsElement(target)) return $87c2a74187854fda$var$getSVGContentRect(target);
    return $87c2a74187854fda$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $87c2a74187854fda$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $87c2a74187854fda$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $87c2a74187854fda$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $87c2a74187854fda$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $87c2a74187854fda$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $87c2a74187854fda$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $87c2a74187854fda$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $87c2a74187854fda$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $87c2a74187854fda$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $87c2a74187854fda$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $87c2a74187854fda$var$MapShim();
        if (typeof callback !== "function") throw new TypeError("The callback provided as parameter 1 is not a function.");
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $87c2a74187854fda$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === "undefined" || !(Element instanceof Object)) return;
        if (!(target instanceof $87c2a74187854fda$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $87c2a74187854fda$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $87c2a74187854fda$var$observers = typeof WeakMap !== "undefined" ? new WeakMap() : new $87c2a74187854fda$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $87c2a74187854fda$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError("Cannot call a class as a function.");
        if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
        var controller = $87c2a74187854fda$var$ResizeObserverController.getInstance();
        var observer = new $87c2a74187854fda$var$ResizeObserverSPI(callback, controller, this);
        $87c2a74187854fda$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    "observe",
    "unobserve",
    "disconnect"
].forEach(function(method) {
    $87c2a74187854fda$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $87c2a74187854fda$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $87c2a74187854fda$var$index = function() {
    // Export existing implementation if available.
    if (typeof $87c2a74187854fda$var$global$1.ResizeObserver !== "undefined") return $87c2a74187854fda$var$global$1.ResizeObserver;
    return $87c2a74187854fda$var$ResizeObserver;
}();
var $87c2a74187854fda$export$2e2bcd8739ae039 = $87c2a74187854fda$var$index;


// =============================== Const ===============================
var $ed69d4f7f0510fbd$var$elementListeners = new Map();
function $ed69d4f7f0510fbd$var$onResize(entities) {
    entities.forEach(function(entity) {
        var _elementListeners$get;
        var target = entity.target;
        (_elementListeners$get = $ed69d4f7f0510fbd$var$elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
            return listener(target);
        });
    });
}
// Note: ResizeObserver polyfill not support option to measure border-box resize
var $ed69d4f7f0510fbd$var$resizeObserver = new (0, $87c2a74187854fda$export$2e2bcd8739ae039)($ed69d4f7f0510fbd$var$onResize);
var $ed69d4f7f0510fbd$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
var $ed69d4f7f0510fbd$export$524f0fd3b47831a = null; // eslint-disable-line
function $ed69d4f7f0510fbd$export$d1203567a167490e(element, callback) {
    if (!$ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.set(element, new Set());
        $ed69d4f7f0510fbd$var$resizeObserver.observe(element);
    }
    $ed69d4f7f0510fbd$var$elementListeners.get(element).add(callback);
}
function $ed69d4f7f0510fbd$export$23a2283368c55ea2(element, callback) {
    if ($ed69d4f7f0510fbd$var$elementListeners.has(element)) {
        $ed69d4f7f0510fbd$var$elementListeners.get(element).delete(callback);
        if (!$ed69d4f7f0510fbd$var$elementListeners.get(element).size) {
            $ed69d4f7f0510fbd$var$resizeObserver.unobserve(element);
            $ed69d4f7f0510fbd$var$elementListeners.delete(element);
        }
    }
}







var $acw62 = parcelRequire("acw62");
/**
 * Fallback to findDOMNode if origin ref do not provide any dom element
 */ var $1b24e2207f75c1d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($acw62.Component);


function $2f1485708e9ce0e2$var$SingleObserver(props, ref) {
    var children = props.children, disabled = props.disabled;
    var elementRef = $acw62.useRef(null);
    var wrapperRef = $acw62.useRef(null);
    var onCollectionResize = $acw62.useContext((0, $3b6981416c8ff0a7$export$db36075d98ba73d3));
    // =========================== Children ===========================
    var isRenderProps = typeof children === "function";
    var mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    var sizeRef = $acw62.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    var canRef = !isRenderProps && /*#__PURE__*/ $acw62.isValidElement(mergedChildren) && (0, $5e297877593af644$export$c1cec34af06bcf7)(mergedChildren);
    var originRef = canRef ? mergedChildren.ref : null;
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(originRef, elementRef);
    var getDom = function getDom() {
        var _elementRef$current;
        return (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(elementRef.current) || // Support `nativeElement` format
        (elementRef.current && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(elementRef.current) === "object" ? (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(wrapperRef.current);
    };
    $acw62.useImperativeHandle(ref, function() {
        return getDom();
    });
    // =========================== Observe ============================
    var propsRef = $acw62.useRef(props);
    propsRef.current = props;
    // Handler
    var onInternalResize = $acw62.useCallback(function(target) {
        var _propsRef$current = propsRef.current, onResize = _propsRef$current.onResize, data = _propsRef$current.data;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            var size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            var sizeInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, size), {}, {
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            });
            // Let collection know what happened
            onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(function() {
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    $acw62.useEffect(function() {
        var currentElement = getDom();
        if (currentElement && !disabled) (0, $ed69d4f7f0510fbd$export$d1203567a167490e)(currentElement, onInternalResize);
        return function() {
            return (0, $ed69d4f7f0510fbd$export$23a2283368c55ea2)(currentElement, onInternalResize);
        };
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $1b24e2207f75c1d9$export$2e2bcd8739ae039), {
        ref: wrapperRef
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren);
}
var $2f1485708e9ce0e2$var$RefSingleObserver = /*#__PURE__*/ $acw62.forwardRef($2f1485708e9ce0e2$var$SingleObserver);
var $2f1485708e9ce0e2$export$2e2bcd8739ae039 = $2f1485708e9ce0e2$var$RefSingleObserver;




var $8aeee349dead8f85$var$INTERNAL_PREFIX_KEY = "rc-observer-key";
function $8aeee349dead8f85$var$ResizeObserver(props, ref) {
    var children = props.children;
    var childNodes = typeof children === "function" ? [
        children
    ] : (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
    return childNodes.map(function(child, index) {
        var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat($8aeee349dead8f85$var$INTERNAL_PREFIX_KEY, "-").concat(index);
        return /*#__PURE__*/ $acw62.createElement((0, $2f1485708e9ce0e2$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
var $8aeee349dead8f85$var$RefResizeObserver = /*#__PURE__*/ $acw62.forwardRef($8aeee349dead8f85$var$ResizeObserver);
$8aeee349dead8f85$var$RefResizeObserver.Collection = (0, $3b6981416c8ff0a7$export$fb8073518f34e6ec);
var $8aeee349dead8f85$export$2e2bcd8739ae039 = $8aeee349dead8f85$var$RefResizeObserver;







var $acw62 = parcelRequire("acw62");


var $04f5dea65135d084$var$_excluded = [
    "prefixCls",
    "invalidate",
    "item",
    "renderItem",
    "responsive",
    "responsiveDisabled",
    "registerSize",
    "itemKey",
    "className",
    "style",
    "children",
    "display",
    "order",
    "component"
];
// Use shared variable to save bundle size
var $04f5dea65135d084$var$UNDEFINED = undefined;
function $04f5dea65135d084$var$InternalItem(props, ref) {
    var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey = props.itemKey, className = props.className, style = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $04f5dea65135d084$var$_excluded);
    var mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $acw62.useEffect(function() {
        return function() {
            internalRegisterSize(null);
        };
    }, []);
    // ================================ Render ================================
    var childNode = renderItem && item !== $04f5dea65135d084$var$UNDEFINED ? renderItem(item) : children;
    var overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $04f5dea65135d084$var$UNDEFINED,
        overflowY: mergedHidden ? "hidden" : $04f5dea65135d084$var$UNDEFINED,
        order: responsive ? order : $04f5dea65135d084$var$UNDEFINED,
        pointerEvents: mergedHidden ? "none" : $04f5dea65135d084$var$UNDEFINED,
        position: mergedHidden ? "absolute" : $04f5dea65135d084$var$UNDEFINED
    };
    var overflowProps = {};
    if (mergedHidden) overflowProps["aria-hidden"] = true;
    var itemNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(!invalidate && prefixCls, className),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, overflowStyle), style)
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref) {
            var offsetWidth = _ref.offsetWidth;
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
var $04f5dea65135d084$var$Item = /*#__PURE__*/ $acw62.forwardRef($04f5dea65135d084$var$InternalItem);
$04f5dea65135d084$var$Item.displayName = "Item";
var $04f5dea65135d084$export$2e2bcd8739ae039 = $04f5dea65135d084$var$Item;





var $acw62 = parcelRequire("acw62");


function $c36b6a4565c7d957$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === "undefined") (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(callback);
    else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function() {
            return callback();
        };
        channel.port2.postMessage(undefined);
    }
}


function $ec426fd785b0196a$export$eedf51fe9d751c7a() {
    // Updater Trigger
    var updateFuncRef = $acw62.useRef(null);
    // Notify update
    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $c36b6a4565c7d957$export$2e2bcd8739ae039)(function() {
                (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(function() {
                    updateFuncRef.current.forEach(function(fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $ec426fd785b0196a$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    var _React$useState = $acw62.useState(defaultValue), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
    // Set State
    var setEffectVal = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextValue) {
        notifyEffectUpdate(function() {
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $4364d04fa4ed57d4$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $182a1149db3c9d79$var$_excluded = [
    "component"
], $182a1149db3c9d79$var$_excluded2 = [
    "className"
], $182a1149db3c9d79$var$_excluded3 = [
    "className"
];
var $182a1149db3c9d79$var$InternalRawItem = function InternalRawItem(props, ref) {
    var context = $acw62.useContext((0, $4364d04fa4ed57d4$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        var _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $182a1149db3c9d79$var$_excluded);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, _restProps, {
            ref: ref
        }));
    }
    var contextClassName = context.className, restContext = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(context, $182a1149db3c9d79$var$_excluded2);
    var className = props.className, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $182a1149db3c9d79$var$_excluded3);
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $acw62.createElement((0, $4364d04fa4ed57d4$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(contextClassName, className)
    }, restContext, restProps)));
};
var $182a1149db3c9d79$var$RawItem = /*#__PURE__*/ $acw62.forwardRef($182a1149db3c9d79$var$InternalRawItem);
$182a1149db3c9d79$var$RawItem.displayName = "RawItem";
var $182a1149db3c9d79$export$2e2bcd8739ae039 = $182a1149db3c9d79$var$RawItem;



var $28a64b28232d3cd3$var$_excluded = [
    "prefixCls",
    "data",
    "renderItem",
    "renderRawItem",
    "itemKey",
    "itemWidth",
    "ssr",
    "style",
    "className",
    "maxCount",
    "renderRest",
    "renderRawRest",
    "suffix",
    "component",
    "itemComponent",
    "onVisibleChange"
];
var $28a64b28232d3cd3$var$RESPONSIVE = "responsive";
var $28a64b28232d3cd3$var$INVALIDATE = "invalidate";
function $28a64b28232d3cd3$var$defaultRenderRest(omittedItems) {
    return "+ ".concat(omittedItems.length, " ...");
}
function $28a64b28232d3cd3$var$Overflow(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $28a64b28232d3cd3$var$_excluded);
    var fullySSR = ssr === "full";
    var notifyEffectUpdate = (0, $ec426fd785b0196a$export$eedf51fe9d751c7a)();
    var _useEffectState = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, null), _useEffectState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
    var mergedContainerWidth = containerWidth || 0;
    var _useEffectState3 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map()), _useEffectState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
    var _useEffectState5 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
    var _useEffectState7 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
    var _useEffectState9 = (0, $ec426fd785b0196a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0), _useEffectState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
    var mergedDisplayCount = $acw62.useMemo(function() {
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
    var itemPrefixCls = "".concat(prefixCls, "-item");
    // Always use the max width to avoid blink
    var mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    var isResponsive = maxCount === $28a64b28232d3cd3$var$RESPONSIVE;
    var shouldResponsive = data.length && isResponsive;
    var invalidate = maxCount === $28a64b28232d3cd3$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ var showRest = shouldResponsive || typeof maxCount === "number" && data.length > maxCount;
    var mergedData = (0, $acw62.useMemo)(function() {
        var items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === "number") items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    var omittedItems = (0, $acw62.useMemo)(function() {
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    var getKey = (0, $acw62.useCallback)(function(item, index) {
        var _ref;
        if (typeof itemKey === "function") return itemKey(item);
        return (_ref = itemKey && (item === null || item === void 0 ? void 0 : item[itemKey])) !== null && _ref !== void 0 ? _ref : index;
    }, [
        itemKey
    ]);
    var mergedRenderItem = (0, $acw62.useCallback)(renderItem || function(item) {
        return item;
    }, [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths(function(origin) {
            var clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (mergedContainerWidth && typeof mergedRestWidth === "number" && mergedData) {
            var totalWidth = suffixWidth;
            var len = mergedData.length;
            var lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(var i = 0; i < len; i += 1){
                var currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    var displayRest = restReady && !!omittedItems.length;
    var suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: "absolute",
        left: suffixFixedStart,
        top: 0
    };
    var itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    var internalRenderItemNode = renderRawItem ? function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $4364d04fa4ed57d4$export$79f16dd643143c25).Provider, {
            key: key,
            value: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, itemSharedProps), {}, {
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            })
        }, renderRawItem(item, index));
    } : function(item, index) {
        var key = getKey(item, index);
        return /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    var restNode;
    var restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
    };
    if (!renderRawRest) {
        var mergedRenderRest = renderRest || $28a64b28232d3cd3$var$defaultRenderRest;
        restNode = /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
    } else if (renderRawRest) restNode = /*#__PURE__*/ $acw62.createElement((0, $4364d04fa4ed57d4$export$79f16dd643143c25).Provider, {
        value: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
    var overflowNode = /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $acw62.createElement((0, $04f5dea65135d084$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: "".concat(itemPrefixCls, "-suffix"),
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    if (isResponsive) overflowNode = /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode);
    return overflowNode;
}
var $28a64b28232d3cd3$var$ForwardOverflow = /*#__PURE__*/ $acw62.forwardRef($28a64b28232d3cd3$var$Overflow);
$28a64b28232d3cd3$var$ForwardOverflow.displayName = "Overflow";
$28a64b28232d3cd3$var$ForwardOverflow.Item = (0, $182a1149db3c9d79$export$2e2bcd8739ae039);
$28a64b28232d3cd3$var$ForwardOverflow.RESPONSIVE = $28a64b28232d3cd3$var$RESPONSIVE;
$28a64b28232d3cd3$var$ForwardOverflow.INVALIDATE = $28a64b28232d3cd3$var$INVALIDATE;
var // Convert to generic type
$28a64b28232d3cd3$export$2e2bcd8739ae039 = $28a64b28232d3cd3$var$ForwardOverflow;


var $4863ed3a14942ec4$export$2e2bcd8739ae039 = (0, $28a64b28232d3cd3$export$2e2bcd8739ae039);





var $acw62 = parcelRequire("acw62");



var $2a075c3c6c029a86$var$Input = function Input(props, ref) {
    var _inputNode2;
    var prefixCls = props.prefixCls, id = props.id, inputElement = props.inputElement, disabled = props.disabled, tabIndex = props.tabIndex, autoFocus = props.autoFocus, autoComplete = props.autoComplete, editable = props.editable, activeDescendantId = props.activeDescendantId, value = props.value, maxLength = props.maxLength, _onKeyDown = props.onKeyDown, _onMouseDown = props.onMouseDown, _onChange = props.onChange, onPaste = props.onPaste, _onCompositionStart = props.onCompositionStart, _onCompositionEnd = props.onCompositionEnd, open = props.open, attrs = props.attrs;
    var inputNode = inputElement || /*#__PURE__*/ $acw62.createElement("input", null);
    var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
    var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, style = originProps.style;
    (0, $05a5f2c645683a81$export$491112666e282270)(!("maxLength" in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
    inputNode = /*#__PURE__*/ $acw62.cloneElement(inputNode, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        type: "search"
    }, originProps), {}, {
        // Override over origin props
        id: id,
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(ref, originRef),
        disabled: disabled,
        tabIndex: tabIndex,
        autoComplete: autoComplete || "off",
        autoFocus: autoFocus,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 || (_inputNode2 = _inputNode2.props) === null || _inputNode2 === void 0 ? void 0 : _inputNode2.className),
        role: "combobox",
        "aria-expanded": open || false,
        "aria-haspopup": "listbox",
        "aria-owns": "".concat(id, "_list"),
        "aria-autocomplete": "list",
        "aria-controls": "".concat(id, "_list"),
        "aria-activedescendant": open ? activeDescendantId : undefined
    }, attrs), {}, {
        value: editable ? value : "",
        maxLength: maxLength,
        readOnly: !editable,
        unselectable: !editable ? "on" : null,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), {}, {
            opacity: editable ? null : 0
        }),
        onKeyDown: function onKeyDown(event) {
            _onKeyDown(event);
            if (onOriginKeyDown) onOriginKeyDown(event);
        },
        onMouseDown: function onMouseDown(event) {
            _onMouseDown(event);
            if (onOriginMouseDown) onOriginMouseDown(event);
        },
        onChange: function onChange(event) {
            _onChange(event);
            if (onOriginChange) onOriginChange(event);
        },
        onCompositionStart: function onCompositionStart(event) {
            _onCompositionStart(event);
            if (onOriginCompositionStart) onOriginCompositionStart(event);
        },
        onCompositionEnd: function onCompositionEnd(event) {
            _onCompositionEnd(event);
            if (onOriginCompositionEnd) onOriginCompositionEnd(event);
        },
        onPaste: onPaste
    }));
    return inputNode;
};
var $2a075c3c6c029a86$var$RefInput = /*#__PURE__*/ $acw62.forwardRef($2a075c3c6c029a86$var$Input);
var $2a075c3c6c029a86$export$2e2bcd8739ae039 = $2a075c3c6c029a86$var$RefInput;


/* eslint-disable react-hooks/rules-of-hooks */ 
var $acw62 = parcelRequire("acw62");

function $953a8baf84e85e44$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
var $953a8baf84e85e44$export$7383f122bf48ec30 = typeof window !== "undefined" && window.document && window.document.documentElement;
var $953a8baf84e85e44$export$df7146797a248522 = $953a8baf84e85e44$export$7383f122bf48ec30;
function $953a8baf84e85e44$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $953a8baf84e85e44$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $953a8baf84e85e44$var$isTitleType(title) {
    return [
        "string",
        "number"
    ].includes((0, $b8f57191916382d3$export$2e2bcd8739ae039)(title));
}
function $953a8baf84e85e44$export$70d1bf7729efff40(item) {
    var title = undefined;
    if (item) {
        if ($953a8baf84e85e44$var$isTitleType(item.title)) title = item.title.toString();
        else if ($953a8baf84e85e44$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $614cdd3d723d82e4$export$2e2bcd8739ae039(effect, deps) {
    // Never happen in test env
    if (0, $953a8baf84e85e44$export$df7146797a248522) /* istanbul ignore next */ $acw62.useLayoutEffect(effect, deps);
    else $acw62.useEffect(effect, deps);
} /* eslint-enable */ 



function $d5637f77b1efb84d$var$itemKey(value) {
    var _value$key;
    return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var $d5637f77b1efb84d$var$onPreventMouseDown = function onPreventMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
};
var $d5637f77b1efb84d$var$SelectSelector = function SelectSelector(props) {
    var id = props.id, prefixCls = props.prefixCls, values = props.values, open = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
        return "+ ".concat(omittedValues.length, " ...");
    } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
    var measureRef = $acw62.useRef(null);
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
    var selectionPrefixCls = "".concat(prefixCls, "-selection");
    // ===================== Search ======================
    var inputValue = open || mode === "multiple" && autoClearSearchValue === false || mode === "tags" ? searchValue : "";
    var inputEditable = mode === "tags" || mode === "multiple" && autoClearSearchValue === false || showSearch && (open || focused);
    // We measure width and set to the input immediately
    (0, $614cdd3d723d82e4$export$2e2bcd8739ae039)(function() {
        setInputWidth(measureRef.current.scrollWidth);
    }, [
        inputValue
    ]);
    // ===================== Render ======================
    // >>> Render Selector Node. Includes Item & Rest
    var defaultRenderSelector = function defaultRenderSelector(item, content, itemDisabled, closable, onClose) {
        return /*#__PURE__*/ $acw62.createElement("span", {
            title: (0, $953a8baf84e85e44$export$70d1bf7729efff40)(item),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(selectionPrefixCls, "-item"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
        }, /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(selectionPrefixCls, "-item-content")
        }, content), closable && /*#__PURE__*/ $acw62.createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
            className: "".concat(selectionPrefixCls, "-item-remove"),
            onMouseDown: $d5637f77b1efb84d$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xd7"));
    };
    var customizeRenderSelector = function customizeRenderSelector(value, content, itemDisabled, closable, onClose, isMaxTag) {
        var onMouseDown = function onMouseDown(e) {
            $d5637f77b1efb84d$var$onPreventMouseDown(e);
            onToggleOpen(!open);
        };
        return /*#__PURE__*/ $acw62.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    var renderItem = function renderItem(valueItem) {
        var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
        var closable = !disabled && !itemDisabled;
        var displayLabel = label;
        if (typeof maxTagTextLength === "number") {
            if (typeof label === "string" || typeof label === "number") {
                var strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
            }
        }
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    var renderRest = function renderRest(omittedValues) {
        var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === "function" ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // >>> Input Node
    var inputNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(selectionPrefixCls, "-search"),
        style: {
            width: inputWidth
        },
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur() {
            setFocused(false);
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $2a075c3c6c029a86$export$2e2bcd8739ae039), {
        ref: inputRef,
        open: open,
        prefixCls: prefixCls,
        id: id,
        inputElement: null,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: onInputChange,
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, true)
    }), /*#__PURE__*/ $acw62.createElement("span", {
        ref: measureRef,
        className: "".concat(selectionPrefixCls, "-search-mirror"),
        "aria-hidden": true
    }, inputValue, "\xa0"));
    // >>> Selections
    var selectionNode = /*#__PURE__*/ $acw62.createElement((0, $4863ed3a14942ec4$export$2e2bcd8739ae039), {
        prefixCls: "".concat(selectionPrefixCls, "-overflow"),
        data: values,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: inputNode,
        itemKey: $d5637f77b1efb84d$var$itemKey,
        maxCount: maxTagCount
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, selectionNode, !values.length && !inputValue && /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(selectionPrefixCls, "-placeholder")
    }, placeholder));
};
var $d5637f77b1efb84d$export$2e2bcd8739ae039 = $d5637f77b1efb84d$var$SelectSelector;




var $acw62 = parcelRequire("acw62");



var $a02e5d1ded01272e$var$SingleSelector = function SingleSelector(props) {
    var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, title = props.title;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
    var combobox = mode === "combobox";
    var inputEditable = combobox || showSearch;
    var item = values[0];
    var inputValue = searchValue || "";
    if (combobox && activeValue && !inputChanged) inputValue = activeValue;
    $acw62.useEffect(function() {
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // Not show text when closed expect combobox mode
    var hasTextInput = mode !== "combobox" && !open && !showSearch ? false : !!inputValue;
    // Get title of selection item
    var selectionTitle = title === undefined ? (0, $953a8baf84e85e44$export$70d1bf7729efff40)(item) : title;
    var placeholderNode = $acw62.useMemo(function() {
        if (item) return null;
        return /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-selection-placeholder"),
            style: hasTextInput ? {
                visibility: "hidden"
            } : undefined
        }, placeholder);
    }, [
        item,
        hasTextInput,
        placeholder,
        prefixCls
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-search")
    }, /*#__PURE__*/ $acw62.createElement((0, $2a075c3c6c029a86$export$2e2bcd8739ae039), {
        ref: inputRef,
        prefixCls: prefixCls,
        id: id,
        open: open,
        inputElement: inputElement,
        disabled: disabled,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        editable: inputEditable,
        activeDescendantId: activeDescendantId,
        value: inputValue,
        onKeyDown: onInputKeyDown,
        onMouseDown: onInputMouseDown,
        onChange: function onChange(e) {
            setInputChanged(true);
            onInputChange(e);
        },
        onPaste: onInputPaste,
        onCompositionStart: onInputCompositionStart,
        onCompositionEnd: onInputCompositionEnd,
        tabIndex: tabIndex,
        attrs: (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, true),
        maxLength: combobox ? maxLength : undefined
    })), !combobox && item ? /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-selection-item"),
        title: selectionTitle,
        style: hasTextInput ? {
            visibility: "hidden"
        } : undefined
    }, item.label) : null, placeholderNode);
};
var $a02e5d1ded01272e$export$2e2bcd8739ae039 = $a02e5d1ded01272e$var$SingleSelector;


var $56b625f0dbf4c4f8$var$Selector = function Selector(props, ref) {
    var inputRef = (0, $acw62.useRef)(null);
    var compositionStatusRef = (0, $acw62.useRef)(false);
    var prefixCls = props.prefixCls, open = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, disabled = props.disabled, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
    // ======================= Ref =======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus(options) {
                inputRef.current.focus(options);
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ====================== Input ======================
    var _useLock = (0, $d2c203a0ff231923$export$2e2bcd8739ae039)(0), _useLock2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown(event) {
        var which = event.which;
        if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP || which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN) event.preventDefault();
        if (onInputKeyDown) onInputKeyDown(event);
        if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER && mode === "tags" && !compositionStatusRef.current && !open) // When menu isn't open, OptionList won't trigger a value change
        // So when enter is pressed, the tag's input value should be emitted here to let selector know
        onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
        if ((0, $4ae276a1f02fe75e$export$48ac81d4a07c29c)(which)) onToggleOpen(true);
    };
    /**
   * We can not use `findDOMNode` sine it will get warning,
   * have to use timer to check if is input element.
   */ var onInternalInputMouseDown = function onInternalInputMouseDown() {
        setInputMouseDown(true);
    };
    // When paste come, ignore next onChange
    var pastedTextRef = (0, $acw62.useRef)(null);
    var triggerOnSearch = function triggerOnSearch(value) {
        if (onSearch(value, true, compositionStatusRef.current) !== false) onToggleOpen(true);
    };
    var onInputCompositionStart = function onInputCompositionStart() {
        compositionStatusRef.current = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd(e) {
        compositionStatusRef.current = false;
        // Trigger search again to support `tokenSeparators` with typewriting
        if (mode !== "combobox") triggerOnSearch(e.target.value);
    };
    var onInputChange = function onInputChange(event) {
        var value = event.target.value;
        // Pasted text should replace back to origin content
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
            value = value.replace(replacedText, pastedTextRef.current);
        }
        pastedTextRef.current = null;
        triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste(e) {
        var clipboardData = e.clipboardData;
        var value = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData("text");
        pastedTextRef.current = value || "";
    };
    var onClick = function onClick(_ref) {
        var target = _ref.target;
        if (target !== inputRef.current) {
            // Should focus input if click the selector
            var isIE = document.body.style.msTouchAction !== undefined;
            if (isIE) setTimeout(function() {
                inputRef.current.focus();
            });
            else inputRef.current.focus();
        }
    };
    var onMouseDown = function onMouseDown(event) {
        var inputMouseDown = getInputMouseDown();
        // when mode is combobox and it is disabled, don't prevent default behavior
        // https://github.com/ant-design/ant-design/issues/37320
        // https://github.com/ant-design/ant-design/issues/48281
        if (event.target !== inputRef.current && !inputMouseDown && !(mode === "combobox" && disabled)) event.preventDefault();
        if (mode !== "combobox" && (!showSearch || !inputMouseDown) || !open) {
            if (open && autoClearSearchValue !== false) onSearch("", true, false);
            onToggleOpen();
        }
    };
    // ================= Inner Selector ==================
    var sharedProps = {
        inputRef: inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange: onInputChange,
        onInputPaste: onInputPaste,
        onInputCompositionStart: onInputCompositionStart,
        onInputCompositionEnd: onInputCompositionEnd
    };
    var selectNode = mode === "multiple" || mode === "tags" ? /*#__PURE__*/ $acw62.createElement((0, $d5637f77b1efb84d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, sharedProps)) : /*#__PURE__*/ $acw62.createElement((0, $a02e5d1ded01272e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, sharedProps));
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: domRef,
        className: "".concat(prefixCls, "-selector"),
        onClick: onClick,
        onMouseDown: onMouseDown
    }, selectNode);
};
var $56b625f0dbf4c4f8$var$ForwardSelector = /*#__PURE__*/ $acw62.forwardRef($56b625f0dbf4c4f8$var$Selector);
var $56b625f0dbf4c4f8$export$2e2bcd8739ae039 = $56b625f0dbf4c4f8$var$ForwardSelector;











var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
var $b422cebf586837cd$var$OrderContext = /*#__PURE__*/ $acw62.createContext(null);
var $b422cebf586837cd$export$2e2bcd8739ae039 = $b422cebf586837cd$var$OrderContext;





var $acw62 = parcelRequire("acw62");



var $172bd5bc03f91d44$var$EMPTY_LIST = [];
function $172bd5bc03f91d44$export$2e2bcd8739ae039(render, debug) {
    var _React$useState = $acw62.useState(function() {
        if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)()) return null;
        var defaultEle = document.createElement("div");
        return defaultEle;
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), ele = _React$useState2[0];
    // ========================== Order ==========================
    var appendedRef = $acw62.useRef(false);
    var queueCreate = $acw62.useContext((0, $b422cebf586837cd$export$2e2bcd8739ae039));
    var _React$useState3 = $acw62.useState($172bd5bc03f91d44$var$EMPTY_LIST), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
    var mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : function(appendFn) {
        setQueue(function(origin) {
            var newQueue = [
                appendFn
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(origin));
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        var _ele$parentElement;
        (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || _ele$parentElement.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (queue.length) {
            queue.forEach(function(appendFn) {
                return appendFn();
            });
            setQueue($172bd5bc03f91d44$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}




var $acw62 = parcelRequire("acw62");


/* eslint-disable no-param-reassign */ 
var $217fa5593a6718d2$var$cached;
function $217fa5593a6718d2$var$measureScrollbarSize(ele) {
    var randomId = "rc-scrollbar-measure-".concat(Math.random().toString(36).substring(7));
    var measureEle = document.createElement("div");
    measureEle.id = randomId;
    // Create Style
    var measureStyle = measureEle.style;
    measureStyle.position = "absolute";
    measureStyle.left = "0";
    measureStyle.top = "0";
    measureStyle.width = "100px";
    measureStyle.height = "100px";
    measureStyle.overflow = "scroll";
    // Clone Style if needed
    var fallbackWidth;
    var fallbackHeight;
    if (ele) {
        var targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        var webkitScrollbarStyle = getComputedStyle(ele, "::-webkit-scrollbar");
        var width = parseInt(webkitScrollbarStyle.width, 10);
        var height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            var widthStyle = width ? "width: ".concat(webkitScrollbarStyle.width, ";") : "";
            var heightStyle = height ? "height: ".concat(webkitScrollbarStyle.height, ";") : "";
            (0, $3a22468320d7d808$export$4d99a2890bb989f0)("\n#".concat(randomId, "::-webkit-scrollbar {\n").concat(widthStyle, "\n").concat(heightStyle, "\n}"), randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    var scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    var scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $3a22468320d7d808$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $217fa5593a6718d2$export$2e2bcd8739ae039(fresh) {
    if (typeof document === "undefined") return 0;
    if (fresh || $217fa5593a6718d2$var$cached === undefined) $217fa5593a6718d2$var$cached = $217fa5593a6718d2$var$measureScrollbarSize();
    return $217fa5593a6718d2$var$cached.width;
}
function $217fa5593a6718d2$export$4f3ef2310365b56a(target) {
    if (typeof document === "undefined" || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $217fa5593a6718d2$var$measureScrollbarSize(target);
}


/**
 * Test usage export. Do not use in your production
 */ function $c9634f2c2418b2d0$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


var $66bc1eccb2a603c3$var$UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var $66bc1eccb2a603c3$var$uuid = 0;
function $66bc1eccb2a603c3$export$2e2bcd8739ae039(lock) {
    var mergedLock = !!lock;
    var _React$useState = $acw62.useState(function() {
        $66bc1eccb2a603c3$var$uuid += 1;
        return "".concat($66bc1eccb2a603c3$var$UNIQUE_ID, "_").concat($66bc1eccb2a603c3$var$uuid);
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), id = _React$useState2[0];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (mergedLock) {
            var scrollbarSize = (0, $217fa5593a6718d2$export$4f3ef2310365b56a)(document.body).width;
            var isOverflow = (0, $c9634f2c2418b2d0$export$31b5c8f1131a3a52)();
            (0, $3a22468320d7d808$export$4d99a2890bb989f0)("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : "", "\n}"), id);
        } else (0, $3a22468320d7d808$export$2232e336aecaa80a)(id);
        return function() {
            (0, $3a22468320d7d808$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}


var $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = false;
function $2ccc34741b4bb73f$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === "boolean") $2ccc34741b4bb73f$export$18c8ad048e32c7d5 = nextInline;
    return $2ccc34741b4bb73f$export$18c8ad048e32c7d5;
}


var $ae492a4c7ad9d4f3$var$getPortalContainer = function getPortalContainer(getContainer) {
    if (getContainer === false) return false;
    if (!(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === "string") return document.querySelector(getContainer);
    if (typeof getContainer === "function") return getContainer();
    return getContainer;
};
var $ae492a4c7ad9d4f3$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var open = props.open, autoLock = props.autoLock, getContainer = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
    var _React$useState = $acw62.useState(open), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
    var mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $acw62.useEffect(function() {
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    var _React$useState3 = $acw62.useState(function() {
        return $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
    }), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
    $acw62.useEffect(function() {
        var customizeContainer = $ae492a4c7ad9d4f3$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
    });
    var _useDom = (0, $172bd5bc03f91d44$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug), _useDom2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
    var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
    // ========================= Locker ==========================
    (0, $66bc1eccb2a603c3$export$2e2bcd8739ae039)(autoLock && open && (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // =========================== Ref ===========================
    var childRef = null;
    if (children && (0, $5e297877593af644$export$c1cec34af06bcf7)(children) && ref) {
        var _ref = children;
        childRef = _ref.ref;
    }
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    var renderInline = mergedContainer === false || (0, $2ccc34741b4bb73f$export$121d9fd0ca615463)();
    var reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $acw62.createElement((0, $b422cebf586837cd$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(reffedChildren, mergedContainer));
});
var $ae492a4c7ad9d4f3$export$2e2bcd8739ae039 = $ae492a4c7ad9d4f3$var$Portal;



var $5b46218595a40828$export$2e2bcd8739ae039 = (0, $ae492a4c7ad9d4f3$export$2e2bcd8739ae039);










var $acw62 = parcelRequire("acw62");
function $d23d006593dfab9c$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    var fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $acw62);
    return fullClone.useId;
}
var $d23d006593dfab9c$var$uuid = 0;
function $d23d006593dfab9c$export$2f0435a662835942() {}
var $d23d006593dfab9c$var$useOriginId = $d23d006593dfab9c$var$getUseId();
var $d23d006593dfab9c$export$2e2bcd8739ae039 = $d23d006593dfab9c$var$useOriginId ? // Use React `useId`
function useId(id) {
    var reactId = $d23d006593dfab9c$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState("ssr-id"), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        var nextId = $d23d006593dfab9c$var$uuid;
        $d23d006593dfab9c$var$uuid += 1;
        setInnerId("rc_unique_".concat(nextId));
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};





var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $c2c51b639b0318a5$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
    var _ref = arrow || {}, className = _ref.className, content = _ref.content;
    var _arrowPos$x = arrowPos.x, x = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
    var arrowRef = $acw62.useRef();
    // Skip if no align
    if (!align || !align.points) return null;
    var alignStyle = {
        position: "absolute"
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        var popupPoints = align.points[0];
        var targetPoints = align.points[1];
        var popupTB = popupPoints[0];
        var popupLR = popupPoints[1];
        var targetTB = targetPoints[0];
        var targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            "t",
            "b"
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === "t") alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            "l",
            "r"
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === "l") alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: arrowRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-arrow"), className),
        style: alignStyle
    }, content);
}






var $acw62 = parcelRequire("acw62");
function $c69e7bbf660984b6$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, open = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
    if (!mask) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}



var $acw62 = parcelRequire("acw62");
var $20a13834bc71bb31$var$PopupContent = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, next) {
    return next.cache;
});
var $20a13834bc71bb31$export$2e2bcd8739ae039 = $20a13834bc71bb31$var$PopupContent;


var $d8446137fd226eb8$var$Popup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
    var childNode = typeof popup === "function" ? popup() : popup;
    // We can not remove holder only when motion finished.
    var isNodeVisible = open || keepDom;
    // ======================= Container ========================
    var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
    var _React$useState = $acw62.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
    // Delay to show since `getPopupContainer` need target element
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Offset
    var AUTO = "auto";
    var offsetStyle = {
        left: "-1000vw",
        top: "-1000vh",
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (ready || !open) {
        var _experimental;
        var points = align.points;
        var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
        var alignRight = dynamicInset && points[0][1] === "r";
        var alignBottom = dynamicInset && points[0][0] === "b";
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    // >>>>> Misc
    var miscStyle = {};
    if (stretch) {
        if (stretch.includes("height") && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes("minHeight") && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes("width") && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes("minWidth") && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = "none";
    return /*#__PURE__*/ $acw62.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && function() {
            return getPopupContainer(target);
        },
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ $acw62.createElement((0, $c69e7bbf660984b6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mask,
        motion: maskMotion
    }), /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onAlign,
        disabled: !open
    }, function(resizeObserverRef) {
        return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: "".concat(prefixCls, "-hidden")
        }, motion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: function onVisibleChanged(nextVisible) {
                var _motion$onVisibleChan;
                motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
                _onVisibleChanged(nextVisible);
            }
        }), function(_ref, motionRef) {
            var motionClassName = _ref.className, motionStyle = _ref.style;
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, motionClassName, className);
            return /*#__PURE__*/ $acw62.createElement("div", {
                ref: (0, $5e297877593af644$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    "--arrow-x": "".concat(arrowPos.x || 0, "px"),
                    "--arrow-y": "".concat(arrowPos.y || 0, "px")
                }, offsetStyle), miscStyle), motionStyle), {}, {
                    boxSizing: "border-box",
                    zIndex: zIndex
                }, style),
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick
            }, arrow && /*#__PURE__*/ $acw62.createElement((0, $c2c51b639b0318a5$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $acw62.createElement((0, $20a13834bc71bb31$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, childNode));
        });
    }));
});
var $d8446137fd226eb8$export$2e2bcd8739ae039 = $d8446137fd226eb8$var$Popup;




var $acw62 = parcelRequire("acw62");
var $afb5ff905a8de769$var$TriggerWrapper = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
    var canUseRef = (0, $5e297877593af644$export$c1cec34af06bcf7)(children);
    // When use `getTriggerDOMNode`, we should do additional work to get the real dom
    var setRef = $acw62.useCallback(function(node) {
        (0, $5e297877593af644$export$f17fd18fa51dcb5b)(ref, getTriggerDOMNode ? getTriggerDOMNode(node) : node);
    }, [
        getTriggerDOMNode
    ]);
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(setRef, children.ref);
    return canUseRef ? /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    }) : children;
});
var $afb5ff905a8de769$export$2e2bcd8739ae039 = $afb5ff905a8de769$var$TriggerWrapper;



var $acw62 = parcelRequire("acw62");
var $f9b439e1e53d6d59$var$TriggerContext = /*#__PURE__*/ $acw62.createContext(null);
var $f9b439e1e53d6d59$export$2e2bcd8739ae039 = $f9b439e1e53d6d59$var$TriggerContext;



var $acw62 = parcelRequire("acw62");
function $65f8789299df97eb$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $65f8789299df97eb$export$2e2bcd8739ae039(mobile, action, showAction, hideAction) {
    return $acw62.useMemo(function() {
        var mergedShowAction = $65f8789299df97eb$var$toArray(showAction !== null && showAction !== void 0 ? showAction : action);
        var mergedHideAction = $65f8789299df97eb$var$toArray(hideAction !== null && hideAction !== void 0 ? hideAction : action);
        var showActionSet = new Set(mergedShowAction);
        var hideActionSet = new Set(mergedHideAction);
        if (mobile) {
            if (showActionSet.has("hover")) {
                showActionSet.delete("hover");
                showActionSet.add("click");
            }
            if (hideActionSet.has("hover")) {
                hideActionSet.delete("hover");
                hideActionSet.add("click");
            }
        }
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        mobile,
        action,
        showAction,
        hideAction
    ]);
}





var $555b4eee2695f264$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $acw62 = parcelRequire("acw62");

function $140ec2a5382714e1$var$isPointsEq() {
    var a1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var a2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var isAlignPoint = arguments.length > 2 ? arguments[2] : undefined;
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $140ec2a5382714e1$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var _builtinPlacements$pl;
        var placement = placements[i];
        if ($140ec2a5382714e1$var$isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return "";
}
function $140ec2a5382714e1$export$7b8936ddc277a29a(prefixCls, motion, animation, transitionName) {
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}
function $140ec2a5382714e1$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $140ec2a5382714e1$export$ba21ed9400ca485b(ele) {
    var scrollerList = [];
    var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
    var scrollStyle = [
        "hidden",
        "scroll",
        "clip",
        "auto"
    ];
    while(current){
        var _getWin$getComputedSt = $140ec2a5382714e1$export$9c0584a7cc24d9e(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
        if ([
            overflowX,
            overflowY,
            overflow
        ].some(function(o) {
            return scrollStyle.includes(o);
        })) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $140ec2a5382714e1$export$34dfc8f73bbb64ae(num) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Number.isNaN(num) ? defaultValue : num;
}
function $140ec2a5382714e1$var$getPxValue(val) {
    return $140ec2a5382714e1$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $140ec2a5382714e1$export$94be9d7985092f2d(initArea, scrollerList) {
    var visibleArea = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, initArea);
    (scrollerList || []).forEach(function(ele) {
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        var _getWin$getComputedSt2 = $140ec2a5382714e1$export$9c0584a7cc24d9e(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
        var eleRect = ele.getBoundingClientRect();
        var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
        var borderTopNum = $140ec2a5382714e1$var$getPxValue(borderTopWidth);
        var borderBottomNum = $140ec2a5382714e1$var$getPxValue(borderBottomWidth);
        var borderLeftNum = $140ec2a5382714e1$var$getPxValue(borderLeftWidth);
        var borderRightNum = $140ec2a5382714e1$var$getPxValue(borderRightWidth);
        var scaleX = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        var scaleY = $140ec2a5382714e1$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        var scaledBorderTopWidth = borderTopNum * scaleY;
        var scaledBorderBottomWidth = borderBottomNum * scaleY;
        var scaledBorderLeftWidth = borderLeftNum * scaleX;
        var scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        var clipMarginWidth = 0;
        var clipMarginHeight = 0;
        if (overflow === "clip") {
            var clipNum = $140ec2a5382714e1$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $a3ab468f9842aab3$var$getUnitOffset(size) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var offsetStr = "".concat(offset);
    var cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $a3ab468f9842aab3$var$getNumberOffset(rect, offset) {
    var _ref = offset || [], _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
    return [
        $a3ab468f9842aab3$var$getUnitOffset(rect.width, offsetX),
        $a3ab468f9842aab3$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $a3ab468f9842aab3$var$splitPoints() {
    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return [
        points[0],
        points[1]
    ];
}
function $a3ab468f9842aab3$var$getAlignPoint(rect, points) {
    var topBottom = points[0];
    var leftRight = points[1];
    var x;
    var y;
    // Top & Bottom
    if (topBottom === "t") y = rect.y;
    else if (topBottom === "b") y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === "l") x = rect.x;
    else if (leftRight === "r") x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $a3ab468f9842aab3$var$reversePoints(points, index) {
    var reverseMap = {
        t: "b",
        b: "t",
        l: "r",
        r: "l"
    };
    return points.map(function(point, i) {
        if (i === index) return reverseMap[point] || "c";
        return point;
    }).join("");
}
function $a3ab468f9842aab3$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
    var _React$useState = $acw62.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
    var alignCountRef = $acw62.useRef(0);
    var scrollerList = $acw62.useMemo(function() {
        if (!popupEle) return [];
        return (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    var prevFlipRef = $acw62.useRef({});
    var resetFlipCache = function resetFlipCache() {
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    var onAlign = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
        if (popupEle && target && open) {
            var _popupElement$parentE, _popupElement$parentE2;
            var popupElement = popupEle;
            var doc = popupElement.ownerDocument;
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
            var originLeft = popupElement.style.left;
            var originTop = popupElement.style.top;
            var originRight = popupElement.style.right;
            var originBottom = popupElement.style.bottom;
            var originOverflow = popupElement.style.overflow;
            // Placement
            var placementInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, builtinPlacements[placement]), popupAlign);
            // placeholder element
            var placeholderElement = doc.createElement("div");
            (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
            placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
            placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
            placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
            // Reset first
            popupElement.style.left = "0";
            popupElement.style.top = "0";
            popupElement.style.right = "auto";
            popupElement.style.bottom = "auto";
            popupElement.style.overflow = "hidden";
            // Calculate align style, we should consider `transform` case
            var targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                var rect = target.getBoundingClientRect();
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            var popupRect = popupElement.getBoundingClientRect();
            var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
            var popupHeight = popupRect.height;
            var popupWidth = popupRect.width;
            var targetHeight = targetRect.height;
            var targetWidth = targetRect.width;
            // Get bounding of visible area
            var visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            var scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            var htmlRegion = placementInfo.htmlRegion;
            var VISIBLE = "visible";
            var VISIBLE_FIRST = "visibleFirst";
            if (htmlRegion !== "scroll" && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            var scrollRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            var visibleRegionArea = (0, $140ec2a5382714e1$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = "auto";
            popupElement.style.top = "auto";
            popupElement.style.right = "0";
            popupElement.style.bottom = "0";
            var popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
            // Calculate scale
            var _scaleX = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            var _scaleY = (0, $140ec2a5382714e1$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (_scaleX === 0 || _scaleY === 0 || (0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(target) && !(0, $555b4eee2695f264$export$2e2bcd8739ae039)(target)) return;
            // Offset
            var offset = placementInfo.offset, targetOffset = placementInfo.targetOffset;
            var _getNumberOffset = $a3ab468f9842aab3$var$getNumberOffset(popupRect, offset), _getNumberOffset2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
            var _getNumberOffset3 = $a3ab468f9842aab3$var$getNumberOffset(targetRect, targetOffset), _getNumberOffset4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            var _ref3 = placementInfo.points || [], _ref4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
            var targetPoints = $a3ab468f9842aab3$var$splitPoints(targetPoint);
            var popupPoints = $a3ab468f9842aab3$var$splitPoints(popupPoint);
            var targetAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(targetRect, targetPoints);
            var popupAlignPoint = $a3ab468f9842aab3$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            var nextAlignInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, placementInfo);
            // Next Offset
            var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY) {
                var area = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : visibleArea;
                var l = popupRect.x + offsetX;
                var t = popupRect.y + offsetY;
                var r = l + popupWidth;
                var b = t + popupHeight;
                var visibleL = Math.max(l, area.left);
                var visibleT = Math.max(t, area.top);
                var visibleR = Math.min(r, area.right);
                var visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            var originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            var originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            var targetAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                "t",
                "l"
            ]);
            var popupAlignPointTL = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                "t",
                "l"
            ]);
            var targetAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(targetRect, [
                "b",
                "r"
            ]);
            var popupAlignPointBR = $a3ab468f9842aab3$var$getAlignPoint(popupRect, [
                "b",
                "r"
            ]);
            var overflow = placementInfo.overflow || {};
            var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
            var supportAdjust = function supportAdjust(val) {
                if (typeof val === "boolean") return val;
                return val >= 0;
            };
            // Prepare position
            var nextPopupY;
            var nextPopupBottom;
            var nextPopupX;
            var nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            var needAdjustY = supportAdjust(adjustY);
            var sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === "t" && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                var tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                var newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                var newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === "b" && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                var _tmpNextOffsetY = nextOffsetY;
                if (sameTB) _tmpNextOffsetY += popupHeight - targetHeight;
                else _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                var _newVisibleArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY);
                var _newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = _tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 0),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            var needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            var sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === "l" && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                var tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                var _newVisibleArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea2 = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea2 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === "r" && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                var _tmpNextOffsetX = nextOffsetX;
                if (sameLR) _tmpNextOffsetX += popupWidth - targetWidth;
                else _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                var _newVisibleArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY);
                var _newVisibleRecommendArea3 = getIntersectionVisibleArea(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                _newVisibleRecommendArea3 >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = _tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextAlignInfo.points = [
                        $a3ab468f9842aab3$var$reversePoints(popupPoints, 1),
                        $a3ab468f9842aab3$var$reversePoints(targetPoints, 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            // ============================ Shift ============================
            syncNextPopupPosition();
            var numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === "number") {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            var numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === "number") {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            var popupLeft = popupRect.x + nextOffsetX;
            var popupRight = popupLeft + popupWidth;
            var popupTop = popupRect.y + nextOffsetY;
            var popupBottom = popupTop + popupHeight;
            var targetLeft = targetRect.x;
            var targetRight = targetLeft + targetWidth;
            var targetTop = targetRect.y;
            var targetBottom = targetTop + targetHeight;
            var maxLeft = Math.max(popupLeft, targetLeft);
            var minRight = Math.min(popupRight, targetRight);
            var xCenter = (maxLeft + minRight) / 2;
            var nextArrowX = xCenter - popupLeft;
            var maxTop = Math.max(popupTop, targetTop);
            var minBottom = Math.min(popupBottom, targetBottom);
            var yCenter = (maxTop + minBottom) / 2;
            var nextArrowY = yCenter - popupTop;
            onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (_scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (_scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            var nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / _scaleX,
                offsetY: nextOffsetY / _scaleY,
                offsetR: offsetX4Right / _scaleX,
                offsetB: offsetY4Bottom / _scaleY,
                arrowX: nextArrowX / _scaleX,
                arrowY: nextArrowY / _scaleY,
                scaleX: _scaleX,
                scaleY: _scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    var triggerAlign = function triggerAlign() {
        alignCountRef.current += 1;
        var id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(function() {
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    var resetReady = function resetReady() {
        setOffsetInfo(function(ori) {
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ori), {}, {
                ready: false
            });
        });
    };
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}





function $02923bfaa4b78dec$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (open && target && popup) {
            var targetElement = target;
            var popupElement = popup;
            var targetScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(targetElement);
            var popupScrollList = (0, $140ec2a5382714e1$export$ba21ed9400ca485b)(popupElement);
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupElement);
            var mergedList = new Set([
                win
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(targetScrollList), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(popupScrollList)));
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach(function(scroller) {
                scroller.addEventListener("scroll", notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener("resize", notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return function() {
                mergedList.forEach(function(scroller) {
                    scroller.removeEventListener("scroll", notifyScroll);
                    win.removeEventListener("resize", notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}





var $acw62 = parcelRequire("acw62");

function $81078b27d1014ac5$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    var openRef = $acw62.useRef(open);
    openRef.current = open;
    // Click to hide is special action since click popup element should not hide
    $acw62.useEffect(function() {
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            var onTriggerClose = function onTriggerClose(_ref) {
                var target = _ref.target;
                if (openRef.current && !inPopupOrChild(target)) triggerOpen(false);
            };
            var win = (0, $140ec2a5382714e1$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener("mousedown", onTriggerClose, true);
            win.addEventListener("contextmenu", onTriggerClose, true);
            // shadow root
            var targetShadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener("mousedown", onTriggerClose, true);
                targetShadowRoot.addEventListener("contextmenu", onTriggerClose, true);
            }
            var _targetEle$getRootNod, _popupEle$getRootNode, targetRoot, popupRoot;
            return function() {
                win.removeEventListener("mousedown", onTriggerClose, true);
                win.removeEventListener("contextmenu", onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener("mousedown", onTriggerClose, true);
                    targetShadowRoot.removeEventListener("contextmenu", onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
}



var $a99c76d30a1f506f$var$_excluded = [
    "prefixCls",
    "children",
    "action",
    "showAction",
    "hideAction",
    "popupVisible",
    "defaultPopupVisible",
    "onPopupVisibleChange",
    "afterPopupVisibleChange",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "focusDelay",
    "blurDelay",
    "mask",
    "maskClosable",
    "getPopupContainer",
    "forceRender",
    "autoDestroy",
    "destroyPopupOnHide",
    "popup",
    "popupClassName",
    "popupStyle",
    "popupPlacement",
    "builtinPlacements",
    "popupAlign",
    "zIndex",
    "stretch",
    "getPopupClassNameFromAlign",
    "fresh",
    "alignPoint",
    "onPopupClick",
    "onPopupAlign",
    "arrow",
    "popupMotion",
    "maskMotion",
    "popupTransitionName",
    "popupAnimation",
    "maskTransitionName",
    "maskAnimation",
    "className",
    "getTriggerDOMNode"
];
function $a99c76d30a1f506f$export$55e99723d7f71b47() {
    var PortalComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $5b46218595a40828$export$2e2bcd8739ae039);
    var Trigger = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
        var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-trigger-popup" : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? "hover" : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $a99c76d30a1f506f$var$_excluded);
        var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
        // =========================== Mobile ===========================
        var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            setMobile((0, $066d1680709fcf3c$export$2e2bcd8739ae039)());
        }, []);
        // ========================== Context ===========================
        var subPopupElements = $acw62.useRef({});
        var parentContext = $acw62.useContext((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039));
        var context = $acw62.useMemo(function() {
            return {
                registerSubPopup: function registerSubPopup(id, subPopupEle) {
                    subPopupElements.current[id] = subPopupEle;
                    parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // =========================== Popup ============================
        var id = (0, $d23d006593dfab9c$export$2e2bcd8739ae039)();
        var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
        // Used for forwardRef popup. Not use internal
        var externalPopupRef = $acw62.useRef(null);
        var setPopupRef = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(node) {
            externalPopupRef.current = node;
            if ((0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
        // Used for forwardRef target. Not use internal
        var externalForwardRef = $acw62.useRef(null);
        var setTargetRef = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(node) {
            if ((0, $808ab7b8a87ab771$export$41e30d8dd0ba7a50)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        // ========================== Children ==========================
        var child = $acw62.Children.only(children);
        var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
        var cloneProps = {};
        var inPopupOrChild = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(ele) {
            var _getShadowRoot, _getShadowRoot2;
            var childDOM = targetEle;
            return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = (0, $b9f59244e9def868$export$70e8259662bb498b)(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = (0, $b9f59244e9def868$export$70e8259662bb498b)(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
                return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
            });
        });
        // =========================== Motion ===========================
        var mergePopupMotion = (0, $140ec2a5382714e1$export$7b8936ddc277a29a)(prefixCls, popupMotion, popupAnimation, popupTransitionName);
        var mergeMaskMotion = (0, $140ec2a5382714e1$export$7b8936ddc277a29a)(prefixCls, maskMotion, maskAnimation, maskTransitionName);
        // ============================ Open ============================
        var _React$useState7 = $acw62.useState(defaultPopupVisible || false), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
        // Render still use props as first priority
        var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
        // We use effect sync here in case `popupVisible` back to `undefined`
        var setMergedOpen = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextOpen) {
            if (popupVisible === undefined) setInternalOpen(nextOpen);
        });
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            setInternalOpen(popupVisible || false);
        }, [
            popupVisible
        ]);
        var openRef = $acw62.useRef(mergedOpen);
        openRef.current = mergedOpen;
        var lastTriggerRef = $acw62.useRef([]);
        lastTriggerRef.current = [];
        var internalTriggerOpen = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(nextOpen) {
            var _lastTriggerRef$curre;
            setMergedOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
            }
        });
        // Trigger for delay
        var delayRef = $acw62.useRef();
        var clearDelay = function clearDelay() {
            clearTimeout(delayRef.current);
        };
        var triggerOpen = function triggerOpen(nextOpen) {
            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            clearDelay();
            if (delay === 0) internalTriggerOpen(nextOpen);
            else delayRef.current = setTimeout(function() {
                internalTriggerOpen(nextOpen);
            }, delay * 1000);
        };
        $acw62.useEffect(function() {
            return clearDelay;
        }, []);
        // ========================== Motion ============================
        var _React$useState9 = $acw62.useState(false), _React$useState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function(firstMount) {
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        var _React$useState11 = $acw62.useState(null), _React$useState12 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
        // =========================== Align ============================
        var _React$useState13 = $acw62.useState([
            0,
            0
        ]), _React$useState14 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
        var setMousePosByEvent = function setMousePosByEvent(event) {
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        var _useAlign = (0, $a3ab468f9842aab3$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
        var _useAction = (0, $65f8789299df97eb$export$2e2bcd8739ae039)(mobile, action, showAction, hideAction), _useAction2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
        var clickToShow = showActions.has("click");
        var clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
        var triggerAlign = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
            if (!inMotion) onAlign();
        });
        var onScroll = function onScroll() {
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $02923bfaa4b78dec$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        var alignedClassName = $acw62.useMemo(function() {
            var baseClassName = (0, $140ec2a5382714e1$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $acw62.useImperativeHandle(ref, function() {
            return {
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            };
        });
        // ========================== Stretch ===========================
        var _React$useState15 = $acw62.useState(0), _React$useState16 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
        var _React$useState17 = $acw62.useState(0), _React$useState18 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
        var syncTargetSize = function syncTargetSize() {
            if (stretch && targetEle) {
                var rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        var onTargetResize = function onTargetResize() {
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        var onVisibleChanged = function onVisibleChanged(visible) {
            setInMotion(false);
            onAlign();
            afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
        };
        // We will trigger align when motion is in prepare
        var onPrepare = function onPrepare() {
            return new Promise(function(resolve) {
                syncTargetSize();
                setMotionPrepareResolve(function() {
                    return resolve;
                });
            });
        };
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     */ function wrapperAction(eventName, nextOpen, delay, preEvent) {
            cloneProps[eventName] = function(event) {
                var _originChildProps$eve;
                preEvent === null || preEvent === void 0 || preEvent(event);
                triggerOpen(nextOpen, delay);
                // Pass to origin
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [
                    originChildProps,
                    event
                ].concat(args));
            };
        }
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = function(event) {
            var _originChildProps$onC;
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [
                originChildProps,
                event
            ].concat(args));
        };
        // Click to hide is special action since click popup element should not hide
        (0, $81078b27d1014ac5$export$2e2bcd8739ae039)(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        var hoverToShow = showActions.has("hover");
        var hoverToHide = hideActions.has("hover");
        var onPopupMouseEnter;
        var onPopupMouseLeave;
        if (hoverToShow) {
            // Compatible with old browser which not support pointer event
            wrapperAction("onMouseEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            wrapperAction("onPointerEnter", true, mouseEnterDelay, function(event) {
                setMousePosByEvent(event);
            });
            onPopupMouseEnter = function onPopupMouseEnter(event) {
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle !== null && popupEle !== void 0 && popupEle.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = function(event) {
                var _originChildProps$onM;
                // setMousePosByEvent(event);
                (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
            };
        }
        if (hoverToHide) {
            wrapperAction("onMouseLeave", false, mouseLeaveDelay);
            wrapperAction("onPointerLeave", false, mouseLeaveDelay);
            onPopupMouseLeave = function onPopupMouseLeave() {
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has("focus")) wrapperAction("onFocus", true, focusDelay);
        if (hideActions.has("focus")) wrapperAction("onBlur", false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has("contextMenu")) cloneProps.onContextMenu = function(event) {
            var _originChildProps$onC2;
            if (openRef.current && hideActions.has("contextMenu")) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [
                originChildProps,
                event
            ].concat(args));
        };
        // ========================= ClassName ==========================
        if (className) cloneProps.className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(originChildProps.className, className);
        // =========================== Render ===========================
        var mergedChildrenProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originChildProps), cloneProps);
        // Pass props into cloneProps for nest usage
        var passedProps = {};
        var passedEventList = [
            "onContextMenu",
            "onClick",
            "onMouseDown",
            "onTouchStart",
            "onMouseEnter",
            "onMouseLeave",
            "onFocus",
            "onBlur"
        ];
        passedEventList.forEach(function(eventName) {
            if (restProps[eventName]) passedProps[eventName] = function() {
                var _mergedChildrenProps$;
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [
                    mergedChildrenProps
                ].concat(args));
                restProps[eventName].apply(restProps, args);
            };
        });
        // Child Node
        var triggerNode = /*#__PURE__*/ $acw62.cloneElement(child, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedChildrenProps), passedProps));
        var arrowPos = {
            x: arrowX,
            y: arrowY
        };
        var innerArrow = arrow ? (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, arrow !== true ? arrow : {}) : null;
        // Render
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, /*#__PURE__*/ $acw62.createElement((0, $afb5ff905a8de769$export$2e2bcd8739ae039), {
            getTriggerDOMNode: getTriggerDOMNode
        }, triggerNode)), /*#__PURE__*/ $acw62.createElement((0, $f9b439e1e53d6d59$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $acw62.createElement((0, $d8446137fd226eb8$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(popupClassName, alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            mask: mask,
            motion: mergePopupMotion,
            maskMotion: mergeMaskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY
        })));
    });
    return Trigger;
}
var $a99c76d30a1f506f$export$2e2bcd8739ae039 = $a99c76d30a1f506f$export$55e99723d7f71b47((0, $5b46218595a40828$export$2e2bcd8739ae039));




var $acw62 = parcelRequire("acw62");
var $1800478cf911b314$var$_excluded = [
    "prefixCls",
    "disabled",
    "visible",
    "children",
    "popupElement",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "direction",
    "placement",
    "builtinPlacements",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "getPopupContainer",
    "empty",
    "getTriggerDOMNode",
    "onPopupVisibleChange",
    "onPopupMouseEnter"
];
var $1800478cf911b314$var$getBuiltInPlacements = function getBuiltInPlacements(dropdownMatchSelectWidth) {
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        bottomRight: {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topLeft: {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topRight: {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        }
    };
};
var $1800478cf911b314$var$SelectTrigger = function SelectTrigger(props, ref) {
    var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, placement = props.placement, builtinPlacements = props.builtinPlacements, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $1800478cf911b314$var$_excluded);
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var popupNode = popupElement;
    if (dropdownRender) popupNode = dropdownRender(popupElement);
    var mergedBuiltinPlacements = $acw62.useMemo(function() {
        return builtinPlacements || $1800478cf911b314$var$getBuiltInPlacements(dropdownMatchSelectWidth);
    }, [
        builtinPlacements,
        dropdownMatchSelectWidth
    ]);
    // ===================== Motion ======================
    var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
    // =================== Popup Width ===================
    var isNumberPopupWidth = typeof dropdownMatchSelectWidth === "number";
    var stretch = $acw62.useMemo(function() {
        if (isNumberPopupWidth) return null;
        return dropdownMatchSelectWidth === false ? "minWidth" : "width";
    }, [
        dropdownMatchSelectWidth,
        isNumberPopupWidth
    ]);
    var popupStyle = dropdownStyle;
    if (isNumberPopupWidth) popupStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, popupStyle), {}, {
        width: dropdownMatchSelectWidth
    });
    // ======================= Ref =======================
    var triggerPopupRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            getPopupElement: function getPopupElement() {
                var _triggerPopupRef$curr;
                return (_triggerPopupRef$curr = triggerPopupRef.current) === null || _triggerPopupRef$curr === void 0 ? void 0 : _triggerPopupRef$curr.popupElement;
            }
        };
    });
    return /*#__PURE__*/ $acw62.createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        showAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        hideAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        popupPlacement: placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: dropdownPrefixCls,
        popupTransitionName: mergedTransitionName,
        popup: /*#__PURE__*/ $acw62.createElement("div", {
            onMouseEnter: onPopupMouseEnter
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: dropdownAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dropdownClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        popupStyle: popupStyle,
        getTriggerDOMNode: getTriggerDOMNode,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
var $1800478cf911b314$var$RefSelectTrigger = /*#__PURE__*/ $acw62.forwardRef($1800478cf911b314$var$SelectTrigger);
var $1800478cf911b314$export$2e2bcd8739ae039 = $1800478cf911b314$var$RefSelectTrigger;







function $67e3f69030e63308$var$getKey(data, index) {
    var key = data.key;
    var value;
    if ("value" in data) value = data.value;
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return "rc-index-key-".concat(index);
}
function $67e3f69030e63308$export$be48fd776273e509(value) {
    return typeof value !== "undefined" && !Number.isNaN(value);
}
function $67e3f69030e63308$export$6c519d302dced239(fieldNames, childrenAsData) {
    var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options, groupLabel = _ref.groupLabel;
    var mergedLabel = label || (childrenAsData ? "children" : "label");
    return {
        label: mergedLabel,
        value: value || "value",
        options: options || "options",
        groupLabel: groupLabel || mergedLabel
    };
}
function $67e3f69030e63308$export$7baa7c13b358b002(options) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
    var flattenList = [];
    var _fillFieldNames = $67e3f69030e63308$export$6c519d302dced239(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options, groupLabel = _fillFieldNames.groupLabel;
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach(function(data) {
            if (isGroupOption || !(fieldOptions in data)) {
                var value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $67e3f69030e63308$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                var grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $67e3f69030e63308$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $67e3f69030e63308$export$d0b21b213c8c013c(option) {
    var newOption = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, option);
    if (!("props" in newOption)) Object.defineProperty(newOption, "props", {
        get: function get() {
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
            return newOption;
        }
    });
    return newOption;
}
var $67e3f69030e63308$export$a09ca2a89e052b14 = function getSeparatedContent(text, tokens, end) {
    if (!tokens || !tokens.length) return null;
    var match = false;
    var separate = function separate(str, _ref3) {
        var _ref4 = (0, $7d110e739ae14cc6$export$2e2bcd8739ae039)(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
        if (!token) return [
            str
        ];
        var list = str.split(token);
        match = match || list.length > 1;
        return list.reduce(function(prevList, unitStr) {
            return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prevList), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(separate(unitStr, restTokens)));
        }, []).filter(Boolean);
    };
    var list = separate(text, tokens);
    if (match) return typeof end !== "undefined" ? list.slice(0, end) : list;
    else return null;
};



var $acw62 = parcelRequire("acw62");
// Use any here since we do not get the type during compilation
var $44daf1c3d5d48cca$var$SelectContext = /*#__PURE__*/ $acw62.createContext(null);
var $44daf1c3d5d48cca$export$2e2bcd8739ae039 = $44daf1c3d5d48cca$var$SelectContext;




var $acw62 = parcelRequire("acw62");
function $a103a3837f410b61$export$2e2bcd8739ae039(props) {
    var visible = props.visible, values = props.values;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    var MAX_COUNT = 50;
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            opacity: 0
        }
    }, "".concat(values.slice(0, MAX_COUNT).map(function(_ref) {
        var label = _ref.label, value = _ref.value;
        return [
            "number",
            "string"
        ].includes((0, $b8f57191916382d3$export$2e2bcd8739ae039)(label)) ? label : value;
    }).join(", ")), values.length > MAX_COUNT ? ", ..." : null);
}


var $685f3ef01f9743a0$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "showSearch",
    "tagRender",
    "direction",
    "omitDomProps",
    "displayValues",
    "onDisplayValuesChange",
    "emptyOptions",
    "notFoundContent",
    "onClear",
    "mode",
    "disabled",
    "loading",
    "getInputElement",
    "getRawInputElement",
    "open",
    "defaultOpen",
    "onDropdownVisibleChange",
    "activeValue",
    "onActiveValueChange",
    "activeDescendantId",
    "searchValue",
    "autoClearSearchValue",
    "onSearch",
    "onSearchSplit",
    "tokenSeparators",
    "allowClear",
    "suffixIcon",
    "clearIcon",
    "OptionList",
    "animation",
    "transitionName",
    "dropdownStyle",
    "dropdownClassName",
    "dropdownMatchSelectWidth",
    "dropdownRender",
    "dropdownAlign",
    "placement",
    "builtinPlacements",
    "getPopupContainer",
    "showAction",
    "onFocus",
    "onBlur",
    "onKeyUp",
    "onKeyDown",
    "onMouseDown"
];
var $685f3ef01f9743a0$var$DEFAULT_OMIT_PROPS = [
    "value",
    "onChange",
    "removeIcon",
    "placeholder",
    "autoFocus",
    "maxTagCount",
    "maxTagTextLength",
    "maxTagPlaceholder",
    "choiceTransitionName",
    "onInputKeyDown",
    "onPopupScroll",
    "tabIndex"
];
var $685f3ef01f9743a0$export$7f654ad2a77ad2ac = function isMultiple(mode) {
    return mode === "tags" || mode === "multiple";
};
var $685f3ef01f9743a0$var$BaseSelect = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _customizeRawInputEle;
    var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? "Not Found" : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, OptionList = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, builtinPlacements = props.builtinPlacements, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $685f3ef01f9743a0$var$_excluded);
    // ============================== MISC ==============================
    var multiple = $685f3ef01f9743a0$export$7f654ad2a77ad2ac(mode);
    var mergedShowSearch = (showSearch !== undefined ? showSearch : multiple) || mode === "combobox";
    var domProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps);
    $685f3ef01f9743a0$var$DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
    });
    omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
        delete domProps[propName];
    });
    // ============================= Mobile =============================
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    $acw62.useEffect(function() {
        // Only update on the client side
        setMobile((0, $066d1680709fcf3c$export$2e2bcd8739ae039)());
    }, []);
    // ============================== Refs ==============================
    var containerRef = $acw62.useRef(null);
    var selectorDomRef = $acw62.useRef(null);
    var triggerRef = $acw62.useRef(null);
    var selectorRef = $acw62.useRef(null);
    var listRef = $acw62.useRef(null);
    var blurRef = $acw62.useRef(false);
    /** Used for component focused management */ var _useDelayReset = (0, $6ca183ed87ff681f$export$2e2bcd8739ae039)(), _useDelayReset2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    // =========================== Imperative ===========================
    $acw62.useImperativeHandle(ref, function() {
        var _selectorRef$current, _selectorRef$current2;
        return {
            focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
            blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
            scrollTo: function scrollTo(arg) {
                var _listRef$current;
                return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
            },
            nativeElement: containerRef.current || selectorDomRef.current
        };
    });
    // ========================== Search Value ==========================
    var mergedSearchValue = $acw62.useMemo(function() {
        var _displayValues$;
        if (mode !== "combobox") return searchValue;
        var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
        return typeof val === "string" || typeof val === "number" ? String(val) : "";
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    var customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
    // Used for customize replacement for `rc-cascader`
    var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
    var customizeRawInputRef = (0, $5e297877593af644$export$1d1c999670a1285d)(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
    // ============================== Open ==============================
    // SSR not support Portal which means we need delay `open` for the first time render
    var _React$useState3 = $acw62.useState(false), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), rendered = _React$useState4[0], setRendered = _React$useState4[1];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        setRendered(true);
    }, []);
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        defaultValue: defaultOpen,
        value: open
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
    var mergedOpen = rendered ? innerOpen : false;
    // Not trigger `open` in `combobox` when `notFoundContent` is empty
    var emptyListContent = !notFoundContent && emptyOptions;
    if (disabled || emptyListContent && mergedOpen && mode === "combobox") mergedOpen = false;
    var triggerOpen = emptyListContent ? false : mergedOpen;
    var onToggleOpen = $acw62.useCallback(function(newOpen) {
        var nextOpen = newOpen !== undefined ? newOpen : !mergedOpen;
        if (!disabled) {
            setInnerOpen(nextOpen);
            if (mergedOpen !== nextOpen) onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
        }
    }, [
        disabled,
        mergedOpen,
        setInnerOpen,
        onDropdownVisibleChange
    ]);
    // ============================= Search =============================
    var tokenWithEnter = $acw62.useMemo(function() {
        return (tokenSeparators || []).some(function(tokenSeparator) {
            return [
                "\n",
                "\r\n"
            ].includes(tokenSeparator);
        });
    }, [
        tokenSeparators
    ]);
    var _ref = $acw62.useContext((0, $44daf1c3d5d48cca$export$2e2bcd8739ae039)) || {}, maxCount = _ref.maxCount, rawValues = _ref.rawValues;
    var onInternalSearch = function onInternalSearch(searchText, fromTyping, isCompositing) {
        if (multiple && (0, $67e3f69030e63308$export$be48fd776273e509)(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount) return;
        var ret = true;
        var newSearchText = searchText;
        onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
        var separatedList = (0, $67e3f69030e63308$export$a09ca2a89e052b14)(searchText, tokenSeparators, (0, $67e3f69030e63308$export$be48fd776273e509)(maxCount) ? maxCount - rawValues.size : undefined);
        // Check if match the `tokenSeparators`
        var patchLabels = isCompositing ? null : separatedList;
        // Ignore combobox since it's not split-able
        if (mode !== "combobox" && patchLabels) {
            newSearchText = "";
            onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
            // Should close when paste finish
            onToggleOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? "typing" : "effect"
        });
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    var onInternalSearchSubmit = function onInternalSearchSubmit(searchText) {
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: "submit"
        });
    };
    // Close will clean up single mode search text
    $acw62.useEffect(function() {
        if (!mergedOpen && !multiple && mode !== "combobox") onInternalSearch("", false, false);
    }, [
        mergedOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $acw62.useEffect(function() {
        if (innerOpen && disabled) setInnerOpen(false);
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled && !blurRef.current) setMockFocused(false);
    }, [
        disabled
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ var _useLock = (0, $d2c203a0ff231923$export$2e2bcd8739ae039)(), _useLock2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    // KeyDown
    var onInternalKeyDown = function onInternalKeyDown(event) {
        var clearLock = getClearLock();
        var which = event.which;
        if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) {
            // Do not submit form when type in the input
            if (mode !== "combobox") event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) onToggleOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).BACKSPACE && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            var cloneDisplayValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(displayValues);
            var removedDisplayValue = null;
            for(var i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                var current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: "remove",
                values: [
                    removedDisplayValue
                ]
            });
        }
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (mergedOpen) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.onKeyDown.apply(_listRef$current2, [
                event
            ].concat(rest));
        }
        onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    };
    // KeyUp
    var onInternalKeyUp = function onInternalKeyUp(event) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)rest[_key2 - 1] = arguments[_key2];
        if (mergedOpen) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.onKeyUp.apply(_listRef$current3, [
                event
            ].concat(rest));
        }
        onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [
            event
        ].concat(rest));
    };
    // ============================ Selector ============================
    var onSelectorRemove = function onSelectorRemove(val) {
        var newValues = displayValues.filter(function(i) {
            return i !== val;
        });
        onDisplayValuesChange(newValues, {
            type: "remove",
            values: [
                val
            ]
        });
    };
    // ========================== Focus / Blur ==========================
    /** Record real focus status */ var focusRef = $acw62.useRef(false);
    var onContainerFocus = function onContainerFocus() {
        setMockFocused(true);
        if (!disabled) {
            if (onFocus && !focusRef.current) onFocus.apply(void 0, arguments);
            // `showAction` should handle `focus` if set
            if (showAction.includes("focus")) onToggleOpen(true);
        }
        focusRef.current = true;
    };
    var onContainerBlur = function onContainerBlur() {
        blurRef.current = true;
        setMockFocused(false, function() {
            focusRef.current = false;
            blurRef.current = false;
            onToggleOpen(false);
        });
        if (disabled) return;
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === "tags") onSearch(mergedSearchValue, {
                source: "submit"
            });
            else if (mode === "multiple") // `multiple` mode only clean the search value but not trigger event
            onSearch("", {
                source: "blur"
            });
        }
        if (onBlur) onBlur.apply(void 0, arguments);
    };
    // Give focus back of Select
    var activeTimeoutIds = [];
    $acw62.useEffect(function() {
        return function() {
            activeTimeoutIds.forEach(function(timeoutId) {
                return clearTimeout(timeoutId);
            });
            activeTimeoutIds.splice(0, activeTimeoutIds.length);
        };
    }, []);
    var onInternalMouseDown = function onInternalMouseDown(event) {
        var _triggerRef$current;
        var target = event.target;
        var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement && popupElement.contains(target)) {
            var timeoutId = setTimeout(function() {
                var index = activeTimeoutIds.indexOf(timeoutId);
                if (index !== -1) activeTimeoutIds.splice(index, 1);
                cancelSetMockFocused();
                if (!mobile && !popupElement.contains(document.activeElement)) {
                    var _selectorRef$current3;
                    (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
                }
            });
            activeTimeoutIds.push(timeoutId);
        }
        for(var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)restArgs[_key3 - 1] = arguments[_key3];
        onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [
            event
        ].concat(restArgs));
    };
    // ============================ Dropdown ============================
    var _React$useState5 = $acw62.useState({}), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), forceUpdate = _React$useState6[1];
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    var onTriggerVisibleChange;
    if (customizeRawInputElement) onTriggerVisibleChange = function onTriggerVisibleChange(newOpen) {
        onToggleOpen(newOpen);
    };
    // Close when click on non-select element
    (0, $aebeaa3bc993c458$export$2e2bcd8739ae039)(function() {
        var _triggerRef$current2;
        return [
            containerRef.current,
            (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()
        ];
    }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
    // ============================ Context =============================
    var baseSelectContext = $acw62.useMemo(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: triggerOpen,
            id: id,
            showSearch: mergedShowSearch,
            multiple: multiple,
            toggleOpen: onToggleOpen
        });
    }, [
        props,
        notFoundContent,
        triggerOpen,
        mergedOpen,
        id,
        mergedShowSearch,
        multiple,
        onToggleOpen
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Arrow ==============================
    var showSuffixIcon = !!suffixIcon || loading;
    var arrowNode;
    if (showSuffixIcon) arrowNode = /*#__PURE__*/ $acw62.createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-arrow"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-arrow-loading"), loading)),
        customizeIcon: suffixIcon,
        customizeIconProps: {
            loading: loading,
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: mockFocused,
            showSearch: mergedShowSearch
        }
    });
    // ============================= Clear ==============================
    var onClearMouseDown = function onClearMouseDown() {
        var _selectorRef$current4;
        onClear === null || onClear === void 0 || onClear();
        (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
        onDisplayValuesChange([], {
            type: "clear",
            values: displayValues
        });
        onInternalSearch("", false, false);
    };
    var _useAllowClear = (0, $2025e240a41c9299$export$9ea6397a890aa3e5)(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode), mergedAllowClear = _useAllowClear.allowClear, clearNode = _useAllowClear.clearIcon;
    // =========================== OptionList ===========================
    var optionList = /*#__PURE__*/ $acw62.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-focused"), mockFocused), "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-single"), !multiple), "".concat(prefixCls, "-allow-clear"), allowClear), "".concat(prefixCls, "-show-arrow"), showSuffixIcon), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-loading"), loading), "".concat(prefixCls, "-open"), mergedOpen), "".concat(prefixCls, "-customize-input"), customizeInputElement), "".concat(prefixCls, "-show-search"), mergedShowSearch));
    // >>> Selector
    var selectorNode = /*#__PURE__*/ $acw62.createElement((0, $1800478cf911b314$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: triggerOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        dropdownStyle: dropdownStyle,
        dropdownClassName: dropdownClassName,
        direction: direction,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        dropdownRender: dropdownRender,
        dropdownAlign: dropdownAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        getTriggerDOMNode: function getTriggerDOMNode(node) {
            return(// TODO: This is workaround and should be removed in `rc-select`
            // And use new standard `nativeElement` for ref.
            // But we should update `rc-resize-observer` first.
            selectorDomRef.current || node);
        },
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter
    }, customizeRawInputElement ? /*#__PURE__*/ $acw62.cloneElement(customizeRawInputElement, {
        ref: customizeRawInputRef
    }) : /*#__PURE__*/ $acw62.createElement((0, $56b625f0dbf4c4f8$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        domRef: selectorDomRef,
        prefixCls: prefixCls,
        inputElement: customizeInputElement,
        ref: selectorRef,
        id: id,
        showSearch: mergedShowSearch,
        autoClearSearchValue: autoClearSearchValue,
        mode: mode,
        activeDescendantId: activeDescendantId,
        tagRender: tagRender,
        values: displayValues,
        open: mergedOpen,
        onToggleOpen: onToggleOpen,
        activeValue: activeValue,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter
    })));
    // >>> Render
    var renderNode;
    // Render raw
    if (customizeRawInputElement) renderNode = selectorNode;
    else renderNode = /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: mergedClassName
    }, domProps, {
        ref: containerRef,
        onMouseDown: onInternalMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onFocus: onContainerFocus,
        onBlur: onContainerBlur
    }), /*#__PURE__*/ $acw62.createElement((0, $a103a3837f410b61$export$2e2bcd8739ae039), {
        visible: mockFocused && !mergedOpen,
        values: displayValues
    }), selectorNode, arrowNode, mergedAllowClear && clearNode);
    return /*#__PURE__*/ $acw62.createElement((0, $de346c10040f695b$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, renderNode);
});
var $685f3ef01f9743a0$export$2e2bcd8739ae039 = $685f3ef01f9743a0$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $cb22e94bdb4eaaa5$var$OptGroup = function OptGroup() {
    return null;
};
$cb22e94bdb4eaaa5$var$OptGroup.isSelectOptGroup = true;
var $cb22e94bdb4eaaa5$export$2e2bcd8739ae039 = $cb22e94bdb4eaaa5$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ var $2f79e5076b69401d$var$Option = function Option() {
    return null;
};
$2f79e5076b69401d$var$Option.isSelectOption = true;
var $2f79e5076b69401d$export$2e2bcd8739ae039 = $2f79e5076b69401d$var$Option;










function $1061fbcb6f08086c$export$2e2bcd8739ae039(obj, fields) {
    var clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}














var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


/**
 * Fill component to provided the scroll content real height.
 */ var $a7c020883d75d0d6$var$Filler = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
    var outerStyle = {};
    var innerStyle = {
        display: "flex",
        flexDirection: "column"
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: "relative",
            overflow: "hidden"
        };
        innerStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, innerStyle), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({
            transform: "translateY(".concat(offsetY, "px)")
        }, rtl ? "marginRight" : "marginLeft", -offsetX), "position", "absolute"), "left", 0), "right", 0), "top", 0));
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: function onResize(_ref2) {
            var offsetHeight = _ref2.offsetHeight;
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        style: innerStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
        ref: ref
    }, innerProps), children, extra)));
});
$a7c020883d75d0d6$var$Filler.displayName = "Filler";
var $a7c020883d75d0d6$export$2e2bcd8739ae039 = $a7c020883d75d0d6$var$Filler;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $cb3ead46d99b2bdd$export$6d08773d2e66f8f2(_ref) {
    var children = _ref.children, setRef = _ref.setRef;
    var refFunc = $acw62.useCallback(function(node) {
        setRef(node);
    }, []);
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: refFunc
    });
}


function $c2cc76a198e74e0d$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, _ref) {
    var getKey = _ref.getKey;
    return list.slice(startIndex, endIndex + 1).map(function(item, index) {
        var eleIndex = startIndex + index;
        var node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        var key = getKey(item);
        return /*#__PURE__*/ $acw62.createElement((0, $cb3ead46d99b2bdd$export$6d08773d2e66f8f2), {
            key: key,
            setRef: function setRef(ele) {
                return setNodeRef(item, ele);
            }
        }, node);
    });
}




var $acw62 = parcelRequire("acw62");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $07ea81b6f4a7cb44$export$38f9023d45dd4a23(min, max, start, index) {
    var beforeCount = start - min;
    var afterCount = max - start;
    var balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        var stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $07ea81b6f4a7cb44$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    var originLen = originList.length;
    var targetLen = targetList.length;
    var shortList;
    var longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    var notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    var diffIndex = null;
    var multiple = Math.abs(originLen - targetLen) !== 1;
    for(var i = 0; i < longList.length; i += 1){
        var shortKey = getItemKey(shortList[i]);
        var longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $792c44421728f1ca$export$2e2bcd8739ae039(data, getKey, onDiff) {
    var _React$useState = $acw62.useState(data), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
    $acw62.useEffect(function() {
        var diff = (0, $07ea81b6f4a7cb44$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if ((diff === null || diff === void 0 ? void 0 : diff.index) !== undefined) {
            onDiff === null || onDiff === void 0 || onDiff(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}




var $acw62 = parcelRequire("acw62");

var $63d773591ee5124d$var$isFF = (typeof navigator === "undefined" ? "undefined" : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var $63d773591ee5124d$export$2e2bcd8739ae039 = $63d773591ee5124d$var$isFF;



var $acw62 = parcelRequire("acw62");
var $3f9e2a044ed7754f$export$2e2bcd8739ae039 = function(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight) {
    // Do lock for a wheel when scrolling
    var lockRef = (0, $acw62.useRef)(false);
    var lockTimeoutRef = (0, $acw62.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(function() {
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    var scrollPingRef = (0, $acw62.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return function(isHorizontal, delta) {
        var smoothOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $bc091312f55e72d3$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    var offsetRef = (0, $acw62.useRef)(0);
    var nextFrameRef = (0, $acw62.useRef)(null);
    // Firefox patch
    var wheelValueRef = (0, $acw62.useRef)(null);
    var isMouseScrollRef = (0, $acw62.useRef)(false);
    // Scroll status sync
    var originScroll = (0, $3f9e2a044ed7754f$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(event, deltaY) {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Proxy of scroll events
        if (!(0, $63d773591ee5124d$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            var patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $63d773591ee5124d$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    var wheelDirectionRef = (0, $acw62.useRef)(null);
    var wheelDirectionCleanRef = (0, $acw62.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            wheelDirectionRef.current = null;
        }, 2);
        var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
        var mergedDeltaX = deltaX;
        var mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === "sx" || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = "sx";
        }
        var absX = Math.abs(mergedDeltaX);
        var absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? "x" : "y";
        if (wheelDirectionRef.current === "y") onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}




var $acw62 = parcelRequire("acw62");
function $352c687fd82e878a$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    var _React$useMemo = $acw62.useMemo(function() {
        return [
            new Map(),
            []
        ];
    }, [
        mergedData,
        heights.id,
        itemHeight
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
    var getSize = function getSize(startKey) {
        var endKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startKey;
        // Get from cache first
        var startIndex = key2Index.get(startKey);
        var endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            var dataLen = mergedData.length;
            for(var i = bottomList.length; i < dataLen; i += 1){
                var _heights$get;
                var item = mergedData[i];
                var key = getKey(item);
                key2Index.set(key, i);
                var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}




var $acw62 = parcelRequire("acw62");





// Firefox has low performance of map.
var $443f2a75671c17cb$var$CacheMap = /*#__PURE__*/ function() {
    function CacheMap() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, CacheMap);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "maps", void 0);
        // Used for cache key
        // `useMemo` no need to update if `id` not change
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "id", 0);
        this.maps = Object.create(null);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(CacheMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.maps[key] = value;
                this.id += 1;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.maps[key];
            }
        }
    ]);
    return CacheMap;
}();
var $443f2a75671c17cb$export$2e2bcd8739ae039 = $443f2a75671c17cb$var$CacheMap;


function $291e20ad7019c1c9$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    var _React$useState = $acw62.useState(0), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
    var instanceRef = (0, $acw62.useRef)(new Map());
    var heightsRef = (0, $acw62.useRef)(new (0, $443f2a75671c17cb$export$2e2bcd8739ae039)());
    var collectRafRef = (0, $acw62.useRef)();
    function cancelRaf() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(collectRafRef.current);
    }
    function collectHeight() {
        var sync = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        cancelRaf();
        var doCollect = function doCollect() {
            instanceRef.current.forEach(function(element, key) {
                if (element && element.offsetParent) {
                    var htmlElement = (0, $808ab7b8a87ab771$export$2e2bcd8739ae039)(element);
                    var offsetHeight = htmlElement.offsetHeight;
                    if (heightsRef.current.get(key) !== offsetHeight) heightsRef.current.set(key, htmlElement.offsetHeight);
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            setUpdatedMark(function(c) {
                return c + 1;
            });
        };
        if (sync) doCollect();
        else collectRafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(doCollect);
    }
    function setInstanceRef(item, instance) {
        var key = getKey(item);
        var origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd === null || onItemAdd === void 0 || onItemAdd(item);
            else onItemRemove === null || onItemRemove === void 0 || onItemRemove(item);
        }
    }
    (0, $acw62.useEffect)(function() {
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}




var $acw62 = parcelRequire("acw62");
var $565f15d1b93ca0eb$var$SMOOTH_PTG = 14 / 15;
function $565f15d1b93ca0eb$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    var touchedRef = (0, $acw62.useRef)(false);
    var touchXRef = (0, $acw62.useRef)(0);
    var touchYRef = (0, $acw62.useRef)(0);
    var elementRef = (0, $acw62.useRef)(null);
    // Smooth scroll
    var intervalRef = (0, $acw62.useRef)(null);
    /* eslint-disable prefer-const */ var cleanUpEvents;
    var onTouchMove = function onTouchMove(e) {
        if (touchedRef.current) {
            var currentX = Math.ceil(e.touches[0].pageX);
            var currentY = Math.ceil(e.touches[0].pageY);
            var offsetX = touchXRef.current - currentX;
            var offsetY = touchYRef.current - currentY;
            var _isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (_isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            if (callback(_isHorizontal, _isHorizontal ? offsetX : offsetY)) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(function() {
                if (_isHorizontal) offsetX *= $565f15d1b93ca0eb$var$SMOOTH_PTG;
                else offsetY *= $565f15d1b93ca0eb$var$SMOOTH_PTG;
                var offset = Math.floor(_isHorizontal ? offsetX : offsetY);
                if (!callback(_isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    var onTouchEnd = function onTouchEnd() {
        touchedRef.current = false;
        cleanUpEvents();
    };
    var onTouchStart = function onTouchStart(e) {
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener("touchmove", onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener("touchend", onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = function cleanUpEvents() {
        if (elementRef.current) {
            elementRef.current.removeEventListener("touchmove", onTouchMove);
            elementRef.current.removeEventListener("touchend", onTouchEnd);
        }
    };
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (inVirtual) listRef.current.addEventListener("touchstart", onTouchStart, {
            passive: true
        });
        return function() {
            var _listRef$current;
            (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.removeEventListener("touchstart", onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}







var $acw62 = parcelRequire("acw62");



var $e77930eb0c8ae9f1$var$MAX_TIMES = 10;
function $e77930eb0c8ae9f1$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, collectHeight, syncScrollTop, triggerFlash) {
    var scrollRef = $acw62.useRef();
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
    // ========================== Sync Scroll ==========================
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (syncState && syncState.times < $e77930eb0c8ae9f1$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState(function(ori) {
                    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, ori);
                });
                return;
            }
            collectHeight();
            var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index = syncState.index, offset = syncState.offset;
            var height = containerRef.current.clientHeight;
            var needCollectHeight = false;
            var newTargetAlign = targetAlign;
            var targetTop = null;
            // Go to next frame if height not exist
            if (height) {
                var mergedAlign = targetAlign || originAlign;
                // Get top & bottom
                var stackTop = 0;
                var itemTop = 0;
                var itemBottom = 0;
                var maxLen = Math.min(data.length - 1, index);
                for(var i = 0; i <= maxLen; i += 1){
                    var key = getKey(data[i]);
                    itemTop = stackTop;
                    var cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                var leftHeight = mergedAlign === "top" ? offset : height - offset;
                for(var _i = maxLen; _i >= 0; _i -= 1){
                    var _key = getKey(data[_i]);
                    var _cacheHeight = heights.get(_key);
                    if (_cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= _cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case "top":
                        targetTop = itemTop - offset;
                        break;
                    case "bottom":
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        var scrollTop = containerRef.current.scrollTop;
                        var scrollBottom = scrollTop + height;
                        if (itemTop < scrollTop) newTargetAlign = "top";
                        else if (itemBottom > scrollBottom) newTargetAlign = "bottom";
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, syncState), {}, {
                times: syncState.times + 1,
                targetAlign: newTargetAlign,
                lastTop: targetTop
            }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return function(arg) {
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === "number") syncScrollTop(arg);
        else if (arg && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(arg) === "object") {
            var index;
            var align = arg.align;
            if ("index" in arg) index = arg.index;
            else index = data.findIndex(function(item) {
                return getKey(item) === arg.key;
            });
            var _arg$offset = arg.offset, offset = _arg$offset === void 0 ? 0 : _arg$offset;
            setSyncState({
                times: 0,
                index: index,
                offset: offset,
                originAlign: align
            });
        }
    };
}








var $acw62 = parcelRequire("acw62");
function $2ebd4898b033397e$var$getPageXY(e, horizontal) {
    var obj = "touches" in e ? e.touches[0] : e;
    return obj[horizontal ? "pageX" : "pageY"];
}
var $2ebd4898b033397e$var$ScrollBar = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style = props.style, propsThumbStyle = props.thumbStyle;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
    var _React$useState3 = $acw62.useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
    var _React$useState5 = $acw62.useState(null), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
    var isLTR = !rtl;
    // ========================= Refs =========================
    var scrollbarRef = $acw62.useRef();
    var thumbRef = $acw62.useRef();
    // ======================= Visible ========================
    var _React$useState7 = $acw62.useState(false), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
    var visibleTimeoutRef = $acw62.useRef();
    var delayHidden = function delayHidden() {
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(function() {
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    var enableScrollRange = scrollRange - containerSize || 0;
    var enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    var top = $acw62.useMemo(function() {
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        var ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    var onContainerMouseDown = function onContainerMouseDown(e) {
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Thumb =========================
    var stateRef = $acw62.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    var onThumbMouseDown = function onThumbMouseDown(e) {
        setDragging(true);
        setPageXY($2ebd4898b033397e$var$getPageXY(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    };
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $acw62.useEffect(function() {
        var onScrollbarTouchStart = function onScrollbarTouchStart(e) {
            e.preventDefault();
        };
        var scrollbarEle = scrollbarRef.current;
        var thumbEle = thumbRef.current;
        scrollbarEle.addEventListener("touchstart", onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener("touchstart", onThumbMouseDown, {
            passive: false
        });
        return function() {
            scrollbarEle.removeEventListener("touchstart", onScrollbarTouchStart);
            thumbEle.removeEventListener("touchstart", onThumbMouseDown);
        };
    }, []);
    // Pass to effect
    var enableScrollRangeRef = $acw62.useRef();
    enableScrollRangeRef.current = enableScrollRange;
    var enableOffsetRangeRef = $acw62.useRef();
    enableOffsetRangeRef.current = enableOffsetRange;
    $acw62.useEffect(function() {
        if (dragging) {
            var moveRafId;
            var onMouseMove = function onMouseMove(e) {
                var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
                (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(moveRafId);
                var rect = scrollbarRef.current.getBoundingClientRect();
                var scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    var offset = ($2ebd4898b033397e$var$getPageXY(e, horizontal) - statePageY) * scale;
                    var newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    var tmpEnableScrollRange = enableScrollRangeRef.current;
                    var tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
                    var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
                    newScrollTop = Math.max(newScrollTop, 0);
                    newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
                    moveRafId = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            var onMouseUp = function onMouseUp() {
                setDragging(false);
                onStopMove();
            };
            window.addEventListener("mousemove", onMouseMove, {
                passive: true
            });
            window.addEventListener("touchmove", onMouseMove, {
                passive: true
            });
            window.addEventListener("mouseup", onMouseUp, {
                passive: true
            });
            window.addEventListener("touchend", onMouseUp, {
                passive: true
            });
            return function() {
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("touchmove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);
                window.removeEventListener("touchend", onMouseUp);
                (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $acw62.useEffect(function() {
        delayHidden();
        return function() {
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $acw62.useImperativeHandle(ref, function() {
        return {
            delayHidden: delayHidden
        };
    });
    // ======================== Render ========================
    var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
    var containerStyle = {
        position: "absolute",
        visibility: visible ? null : "hidden"
    };
    var thumbStyle = {
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: 99,
        cursor: "pointer",
        userSelect: "none"
    };
    if (horizontal) {
        // Container
        containerStyle.height = 8;
        containerStyle.left = 0;
        containerStyle.right = 0;
        containerStyle.bottom = 0;
        // Thumb
        thumbStyle.height = "100%";
        thumbStyle.width = spinSize;
        if (isLTR) thumbStyle.left = top;
        else thumbStyle.right = top;
    } else {
        // Container
        containerStyle.width = 8;
        containerStyle.top = 0;
        containerStyle.bottom = 0;
        if (isLTR) containerStyle.right = 0;
        else containerStyle.left = 0;
        // Thumb
        thumbStyle.width = "100%";
        thumbStyle.height = spinSize;
        thumbStyle.top = top;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollbarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(scrollbarPrefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), "".concat(scrollbarPrefixCls, "-visible"), visible)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, containerStyle), style),
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: thumbRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(scrollbarPrefixCls, "-thumb"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, thumbStyle), propsThumbStyle),
        onMouseDown: onThumbMouseDown
    }));
});
var $2ebd4898b033397e$export$2e2bcd8739ae039 = $2ebd4898b033397e$var$ScrollBar;


var $b4a482bc5e551190$var$MIN_SIZE = 20;
function $b4a482bc5e551190$export$f2ca68955ab35ace() {
    var containerSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var scrollRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $b4a482bc5e551190$var$MIN_SIZE);
    return Math.floor(baseSize);
}


var $919681ceac17068c$var$_excluded = [
    "prefixCls",
    "className",
    "height",
    "itemHeight",
    "fullHeight",
    "style",
    "data",
    "children",
    "itemKey",
    "virtual",
    "direction",
    "scrollWidth",
    "component",
    "onScroll",
    "onVirtualScroll",
    "onVisibleChange",
    "innerProps",
    "extraRender",
    "styles"
];
var $919681ceac17068c$var$EMPTY_DATA = [];
var $919681ceac17068c$var$ScrollStyle = {
    overflowY: "auto",
    overflowAnchor: "none"
};
function $919681ceac17068c$export$cc3be4e46e8486ed(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-virtual-list" : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style = props.style, data = props.data, children = props.children, itemKey = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $919681ceac17068c$var$_excluded);
    // =============================== Item Key ===============================
    var getKey = $acw62.useCallback(function(item) {
        if (typeof itemKey === "function") return itemKey(item);
        return item === null || item === void 0 ? void 0 : item[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    var _useHeights = (0, $291e20ad7019c1c9$export$2e2bcd8739ae039)(getKey, null, null), _useHeights2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
    // ================================= MISC =================================
    var useVirtual = !!(virtual !== false && height && itemHeight);
    var containerHeight = $acw62.useMemo(function() {
        return Object.values(heights.maps).reduce(function(total, curr) {
            return total + curr;
        }, 0);
    }, [
        heights.id,
        heights.maps
    ]);
    var inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    var isRTL = direction === "rtl";
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), isRTL), className);
    var mergedData = data || $919681ceac17068c$var$EMPTY_DATA;
    var componentRef = (0, $acw62.useRef)();
    var fillerInnerRef = (0, $acw62.useRef)();
    var containerRef = (0, $acw62.useRef)();
    // =============================== Item Key ===============================
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
    var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
    var _useState5 = (0, $acw62.useState)(false), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
    var onScrollbarStartMove = function onScrollbarStartMove() {
        setScrollMoving(true);
    };
    var onScrollbarStopMove = function onScrollbarStopMove() {
        setScrollMoving(false);
    };
    var sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop(function(origin) {
            var value;
            if (typeof newTop === "function") value = newTop(origin);
            else value = newTop;
            var alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    var rangeRef = (0, $acw62.useRef)({
        start: 0,
        end: mergedData.length
    });
    var diffItemRef = (0, $acw62.useRef)();
    var _useDiffItem = (0, $792c44421728f1ca$export$2e2bcd8739ae039)(mergedData, getKey), _useDiffItem2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDiffItem, 1), diffItem = _useDiffItem2[0];
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    var _React$useMemo = $acw62.useMemo(function() {
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) {
            var _fillerInnerRef$curre;
            return {
                scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
                start: 0,
                end: mergedData.length - 1,
                offset: undefined
            };
        }
        var itemTop = 0;
        var startIndex;
        var startOffset;
        var endIndex;
        var dataLen = mergedData.length;
        for(var i = 0; i < dataLen; i += 1){
            var _item = mergedData[i];
            var key = getKey(_item);
            var cacheHeight = heights.get(key);
            var currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // ================================= Size =================================
    var _React$useState = $acw62.useState({
        width: 0,
        height: height
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
    var onHolderResize = function onHolderResize(sizeInfo) {
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    var verticalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarRef = (0, $acw62.useRef)();
    var horizontalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $b4a482bc5e551190$export$f2ca68955ab35ace)(size.width, scrollWidth);
    }, [
        size.width,
        scrollWidth
    ]);
    var verticalScrollBarSpinSize = $acw62.useMemo(function() {
        return (0, $b4a482bc5e551190$export$f2ca68955ab35ace)(size.height, scrollHeight);
    }, [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    var maxScrollHeight = scrollHeight - height;
    var maxScrollHeightRef = (0, $acw62.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        var newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    var isScrollAtTop = offsetTop <= 0;
    var isScrollAtBottom = offsetTop >= maxScrollHeight;
    var isScrollAtLeft = offsetLeft <= 0;
    var isScrollAtRight = offsetLeft >= scrollWidth;
    var originScroll = (0, $3f9e2a044ed7754f$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    var getVirtualScrollInfo = function getVirtualScrollInfo() {
        return {
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        };
    };
    var lastVirtualScrollInfoRef = (0, $acw62.useRef)(getVirtualScrollInfo());
    var triggerScroll = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(params) {
        if (onVirtualScroll) {
            var nextInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, getVirtualScrollInfo()), params);
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        var newOffset = newScrollOffset;
        if (horizontal) {
            (0, $11492dca620dcaa5$exports.flushSync)(function() {
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        var newScrollTop = e.currentTarget.scrollTop;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll === null || onScroll === void 0 || onScroll(e);
        triggerScroll();
    }
    var keepInHorizontalRange = function keepInHorizontalRange(nextOffsetLeft) {
        var tmpOffsetLeft = nextOffsetLeft;
        var max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    var onWheelDelta = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(offsetXY, fromHorizontal) {
        if (fromHorizontal) {
            // Horizontal scroll no need sync virtual position
            (0, $11492dca620dcaa5$exports.flushSync)(function() {
                setOffsetLeft(function(left) {
                    var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop(function(top) {
            var newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    var _useFrameWheel = (0, $bc091312f55e72d3$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta), _useFrameWheel2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    // Mobile touch move
    (0, $565f15d1b93ca0eb$export$2e2bcd8739ae039)(useVirtual, componentRef, function(isHorizontal, delta, smoothOffset) {
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        onRawWheel({
            preventDefault: function preventDefault() {},
            deltaX: isHorizontal ? delta : 0,
            deltaY: isHorizontal ? 0 : delta
        });
        return true;
    });
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        // Firefox only
        function onMozMousePixelScroll(e) {
            if (useVirtual) e.preventDefault();
        }
        var componentEle = componentRef.current;
        componentEle.addEventListener("wheel", onRawWheel, {
            passive: false
        });
        componentEle.addEventListener("DOMMouseScroll", onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener("MozMousePixelScroll", onMozMousePixelScroll, {
            passive: false
        });
        return function() {
            componentEle.removeEventListener("wheel", onRawWheel);
            componentEle.removeEventListener("DOMMouseScroll", onFireFoxScroll);
            componentEle.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        };
    }, [
        useVirtual
    ]);
    // Sync scroll left
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (scrollWidth) {
            var newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    var delayHideScrollBar = function delayHideScrollBar() {
        var _verticalScrollBarRef, _horizontalScrollBarR;
        (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 || _verticalScrollBarRef.delayHidden();
        (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 || _horizontalScrollBarR.delayHidden();
    };
    var _scrollTo = (0, $e77930eb0c8ae9f1$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, function() {
        return collectHeight(true);
    }, syncScrollTop, delayHideScrollBar);
    $acw62.useImperativeHandle(ref, function() {
        return {
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: function scrollTo(config) {
                function isPosScroll(arg) {
                    return arg && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(arg) === "object" && ("left" in arg || "top" in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    _scrollTo(config.top);
                } else _scrollTo(config);
            }
        };
    });
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (onVisibleChange) {
            var renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    var getSize = (0, $352c687fd82e878a$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    var listChildren = (0, $c2cc76a198e74e0d$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    var componentStyle = null;
    if (height) {
        componentStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, fullHeight ? "height" : "maxHeight", height), $919681ceac17068c$var$ScrollStyle);
        if (useVirtual) {
            componentStyle.overflowY = "hidden";
            if (scrollWidth) componentStyle.overflowX = "hidden";
            if (scrollMoving) componentStyle.pointerEvents = "none";
        }
    }
    var containerProps = {};
    if (isRTL) containerProps.dir = "rtl";
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: containerRef,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), {}, {
            position: "relative"
        }),
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $acw62.createElement(Component, {
        className: "".concat(prefixCls, "-holder"),
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $acw62.createElement((0, $a7c020883d75d0d6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $acw62.createElement((0, $2ebd4898b033397e$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $acw62.createElement((0, $2ebd4898b033397e$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
        thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb
    }));
}
var $919681ceac17068c$var$List = /*#__PURE__*/ $acw62.forwardRef($919681ceac17068c$export$cc3be4e46e8486ed);
$919681ceac17068c$var$List.displayName = "List";
var $919681ceac17068c$export$2e2bcd8739ae039 = $919681ceac17068c$var$List;


var $2f16cd4e45d13ddf$export$2e2bcd8739ae039 = (0, $919681ceac17068c$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");



/* istanbul ignore file */ function $b345c0bc7d688d6a$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



var $4a507f608f30c004$var$_excluded = [
    "disabled",
    "title",
    "children",
    "style",
    "className"
];
// export interface OptionListProps<OptionsType extends object[]> {
function $4a507f608f30c004$var$isTitleType(content) {
    return typeof content === "string" || typeof content === "number";
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ var $4a507f608f30c004$var$OptionList = function OptionList(_, ref) {
    var _useBaseProps = (0, $de346c10040f695b$export$2e2bcd8739ae039)(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
    var _React$useContext = $acw62.useContext((0, $44daf1c3d5d48cca$export$2e2bcd8739ae039)), maxCount = _React$useContext.maxCount, flattenOptions = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, direction = _React$useContext.direction, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, optionRender = _React$useContext.optionRender;
    var itemPrefixCls = "".concat(prefixCls, "-item");
    var memoFlattenOptions = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        return flattenOptions;
    }, [
        open,
        flattenOptions
    ], function(prev, next) {
        return next[0] && prev[1] !== next[1];
    });
    // =========================== List ===========================
    var listRef = $acw62.useRef(null);
    var overMaxCount = $acw62.useMemo(function() {
        return multiple && (0, $67e3f69030e63308$export$be48fd776273e509)(maxCount) && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount;
    }, [
        multiple,
        maxCount,
        rawValues === null || rawValues === void 0 ? void 0 : rawValues.size
    ]);
    var onListMouseDown = function onListMouseDown(event) {
        event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView(args) {
        var _listRef$current;
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(typeof args === "number" ? {
            index: args
        } : args);
    };
    // ========================== Active ==========================
    var getEnabledActiveIndex = function getEnabledActiveIndex(index) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        var len = memoFlattenOptions.length;
        for(var i = 0; i < len; i += 1){
            var current = (index + i * offset + len) % len;
            var _ref = memoFlattenOptions[current] || {}, group = _ref.group, data = _ref.data;
            if (!group && !(data !== null && data !== void 0 && data.disabled) && !overMaxCount) return current;
        }
        return -1;
    };
    var _React$useState = $acw62.useState(function() {
        return getEnabledActiveIndex(0);
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var setActive = function setActive(index) {
        var fromKeyboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setActiveIndex(index);
        var info = {
            source: fromKeyboard ? "keyboard" : "mouse"
        };
        // Trigger active event
        var flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $acw62.useEffect)(function() {
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/34975
    var isSelected = $acw62.useCallback(function(value) {
        return rawValues.has(value) && mode !== "combobox";
    }, [
        mode,
        (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rawValues).toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $acw62.useEffect)(function() {
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ var timeoutId = setTimeout(function() {
            if (!multiple && open && rawValues.size === 1) {
                var value = Array.from(rawValues)[0];
                var index = memoFlattenOptions.findIndex(function(_ref2) {
                    var data = _ref2.data;
                    return data.value === value;
                });
                if (index !== -1) {
                    setActive(index);
                    scrollIntoView(index);
                }
            }
        });
        // Force trigger scrollbar visible when open
        if (open) {
            var _listRef$current2;
            (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo(undefined);
        }
        return function() {
            return clearTimeout(timeoutId);
        };
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    var onSelectValue = function onSelectValue(value) {
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            onKeyDown: function onKeyDown(event) {
                var which = event.which, ctrlKey = event.ctrlKey;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).N:
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).P:
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP:
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN:
                        var offset = 0;
                        if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP) offset = -1;
                        else if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN) offset = 1;
                        else if ((0, $b345c0bc7d688d6a$export$3bbcfec016973a77)() && ctrlKey) {
                            if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).N) offset = 1;
                            else if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).P) offset = -1;
                        }
                        if (offset !== 0) {
                            var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                            scrollIntoView(nextActiveIndex);
                            setActive(nextActiveIndex, true);
                        }
                        break;
                    // >>> Select
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER:
                        var _item$data;
                        // value
                        var item = memoFlattenOptions[activeIndex];
                        if (item && !(item !== null && item !== void 0 && (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled) && !overMaxCount) onSelectValue(item.value);
                        else onSelectValue(undefined);
                        if (open) event.preventDefault();
                        break;
                    // >>> Close
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: function onKeyUp() {},
            scrollTo: function scrollTo(index) {
                scrollIntoView(index);
            }
        };
    });
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $acw62.createElement("div", {
        role: "listbox",
        id: "".concat(id, "_list"),
        className: "".concat(itemPrefixCls, "-empty"),
        onMouseDown: onListMouseDown
    }, notFoundContent);
    var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
        return fieldNames[key];
    });
    var getLabel = function getLabel(item) {
        return item.label;
    };
    function getItemAriaProps(item, index) {
        var group = item.group;
        return {
            role: group ? "presentation" : "option",
            id: "".concat(id, "_list_").concat(index)
        };
    }
    var renderItem = function renderItem(index) {
        var item = memoFlattenOptions[index];
        if (!item) return null;
        var itemData = item.data || {};
        var value = itemData.value;
        var group = item.group;
        var attrs = (0, $281efe5882c936de$export$2e2bcd8739ae039)(itemData, true);
        var mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isSelected(value)
        }), value) : null;
    };
    var a11yProps = {
        role: "listbox",
        id: "".concat(id, "_list")
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, virtual && /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: "hidden"
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $acw62.createElement((0, $2f16cd4e45d13ddf$export$2e2bcd8739ae039), {
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps
    }, function(item, itemIndex) {
        var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
        var key = data.key;
        // Group
        if (group) {
            var _data$title;
            var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : $4a507f608f30c004$var$isTitleType(label) ? label.toString() : undefined;
            return /*#__PURE__*/ $acw62.createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemPrefixCls, "".concat(itemPrefixCls, "-group"), data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        var disabled = data.disabled, title = data.title, children = data.children, style = data.style, className = data.className, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(data, $4a507f608f30c004$var$_excluded);
        var passedProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        var selected = isSelected(value);
        var mergedDisabled = disabled || !selected && overMaxCount;
        var optionPrefixCls = "".concat(itemPrefixCls, "-option");
        var optionClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemPrefixCls, optionPrefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(optionPrefixCls, "-grouped"), groupOption), "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !mergedDisabled), "".concat(optionPrefixCls, "-disabled"), mergedDisabled), "".concat(optionPrefixCls, "-selected"), selected));
        var mergedLabel = getLabel(item);
        var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        var optionTitle = $4a507f608f30c004$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $281efe5882c936de$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": selected,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: function onMouseMove() {
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: function onClick() {
                if (!mergedDisabled) onSelectValue(value);
            },
            style: style
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(optionPrefixCls, "-content")
        }, typeof optionRender === "function" ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $acw62.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $acw62.createElement((0, $707d52f2ac65b829$export$2e2bcd8739ae039), {
            className: "".concat(itemPrefixCls, "-option-state"),
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
var $4a507f608f30c004$var$RefOptionList = /*#__PURE__*/ $acw62.forwardRef($4a507f608f30c004$var$OptionList);
var $4a507f608f30c004$export$2e2bcd8739ae039 = $4a507f608f30c004$var$RefOptionList;





var $acw62 = parcelRequire("acw62");
var /**
 * Cache `value` related LabeledValue & options.
 */ $91018b9a345d68e7$export$2e2bcd8739ae039 = function(labeledValues, valueOptions) {
    var cacheRef = $acw62.useRef({
        values: new Map(),
        options: new Map()
    });
    var filledLabeledValues = $acw62.useMemo(function() {
        var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
        // Fill label by cache
        var patchedValues = labeledValues.map(function(item) {
            if (item.label === undefined) {
                var _prevValueCache$get;
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, item), {}, {
                    label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
                });
            }
            return item;
        });
        // Refresh cache
        var valueCache = new Map();
        var optionCache = new Map();
        patchedValues.forEach(function(item) {
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    var getOption = $acw62.useCallback(function(val) {
        return valueOptions.get(val) || cacheRef.current.options.get(val);
    }, [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};





var $acw62 = parcelRequire("acw62");


function $47ef072d0f92ab84$var$includes(test, search) {
    return (0, $953a8baf84e85e44$export$45b10814cc054894)(test).join("").toUpperCase().includes(search);
}
var $47ef072d0f92ab84$export$2e2bcd8739ae039 = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
    return $acw62.useMemo(function() {
        if (!searchValue || filterOption === false) return options;
        var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
        var filteredOptions = [];
        var customizeFilter = typeof filterOption === "function";
        var upperSearch = searchValue.toUpperCase();
        var filterFunc = customizeFilter ? filterOption : function(_, option) {
            // Use provided `optionFilterProp`
            if (optionFilterProp) return $47ef072d0f92ab84$var$includes(option[optionFilterProp], upperSearch);
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $47ef072d0f92ab84$var$includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
            return $47ef072d0f92ab84$var$includes(option[fieldValue], upperSearch);
        };
        var wrapOption = customizeFilter ? function(opt) {
            return (0, $67e3f69030e63308$export$d0b21b213c8c013c)(opt);
        } : function(opt) {
            return opt;
        };
        options.forEach(function(item) {
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                var matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    var subOptions = item[fieldOptions].filter(function(subItem) {
                        return filterFunc(searchValue, wrapOption(subItem));
                    });
                    if (subOptions.length) filteredOptions.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, item), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, fieldOptions, subOptions)));
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};




var $acw62 = parcelRequire("acw62");

var $8656bcd9ded5e8cf$var$uuid = 0;
var $8656bcd9ded5e8cf$export$df7146797a248522 = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)();
function $8656bcd9ded5e8cf$export$36ec425867d538d7() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($8656bcd9ded5e8cf$export$df7146797a248522) {
        retId = $8656bcd9ded5e8cf$var$uuid;
        $8656bcd9ded5e8cf$var$uuid += 1;
    } else retId = "TEST_OR_SSR";
    return retId;
}
function $8656bcd9ded5e8cf$export$2e2bcd8739ae039(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        setInnerId("rc_select_".concat($8656bcd9ded5e8cf$export$36ec425867d538d7()));
    }, []);
    return id || innerId;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $e44edf3963c3279c$var$_excluded = [
    "children",
    "value"
], $e44edf3963c3279c$var$_excluded2 = [
    "children"
];
function $e44edf3963c3279c$var$convertNodeToOption(node) {
    var _ref = node, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref$props, $e44edf3963c3279c$var$_excluded);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        key: key,
        value: value !== undefined ? value : key,
        children: children
    }, restProps);
}
function $e44edf3963c3279c$export$3beca35db74c3985(nodes) {
    var optionOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(nodes).map(function(node, index) {
        if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return null;
        var _ref2 = node, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2$props, $e44edf3963c3279c$var$_excluded2);
        if (optionOnly || !isSelectOptGroup) return $e44edf3963c3279c$var$convertNodeToOption(node);
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            key: "__RC_SELECT_GRP__".concat(key === null ? index : key, "__"),
            label: key
        }, restProps), {}, {
            options: $e44edf3963c3279c$export$3beca35db74c3985(children)
        });
    }).filter(function(data) {
        return data;
    });
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ var $05553a78451953de$var$useOptions = function useOptions(options, children, fieldNames, optionFilterProp, optionLabelProp) {
    return $acw62.useMemo(function() {
        var mergedOptions = options;
        var childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $e44edf3963c3279c$export$3beca35db74c3985)(children);
        var valueOptions = new Map();
        var labelOptions = new Map();
        var setLabelOptions = function setLabelOptions(labelOptionsMap, option, key) {
            if (key && typeof key === "string") labelOptionsMap.set(option[key], option);
        };
        var dig = function dig(optionList) {
            var isChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            // for loop to speed up collection speed
            for(var i = 0; i < optionList.length; i += 1){
                var option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    setLabelOptions(labelOptions, option, optionFilterProp);
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $05553a78451953de$export$2e2bcd8739ae039 = $05553a78451953de$var$useOptions;



var $acw62 = parcelRequire("acw62");
function $fb4ced1ec5128b6c$export$2e2bcd8739ae039(callback) {
    var funcRef = $acw62.useRef();
    funcRef.current = callback;
    var cacheFn = $acw62.useCallback(function() {
        return funcRef.current.apply(funcRef, arguments);
    }, []);
    return cacheFn;
}








var $acw62 = parcelRequire("acw62");



function $0dd83a53fec15284$var$warningProps(props) {
    var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
    var multiple = (0, $685f3ef01f9743a0$export$7f654ad2a77ad2ac)(mode);
    var mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === "combobox";
    var mergedOptions = options || (0, $e44edf3963c3279c$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(mode !== "tags" || mergedOptions.every(function(opt) {
        return !opt.disabled;
    }), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
    // `combobox` & `tags` should option be `string` type
    if (mode === "tags" || mode === "combobox") {
        var hasNumberValue = mergedOptions.some(function(item) {
            if (item.options) return item.options.some(function(opt) {
                return typeof ("value" in opt ? opt.value : opt.key) === "number";
            });
            return typeof ("value" in item ? item.value : item.key) === "number";
        });
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
    }
    // `combobox` should not use `optionLabelProp`
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
    // Only `combobox` support `backfill`
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
    // Only `combobox` support `getInputElement`
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $05a5f2c645683a81$export$89ff31684837bbbf)(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`onSearch` should work with `showSearch` instead of use alone.");
    (0, $05a5f2c645683a81$export$89ff31684837bbbf)(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
    if (value !== undefined && value !== null) {
        var values = (0, $953a8baf84e85e44$export$45b10814cc054894)(value);
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!labelInValue || values.every(function(val) {
            return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(val) === "object" && ("key" in val || "value" in val);
        }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
    }
    // Syntactic sugar should use correct children type
    if (children) {
        var invalidateChildType = null;
        (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children).some(function(node) {
            if (!/*#__PURE__*/ $acw62.isValidElement(node) || !node.type) return false;
            var _ref = node, type = _ref.type;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                var allChildrenValid = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(node.props.children).every(function(subNode) {
                    if (!/*#__PURE__*/ $acw62.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(inputValue === undefined, "`inputValue` is deprecated, please use `searchValue` instead.");
    }
}
function $0dd83a53fec15284$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        var recursiveOptions = function recursiveOptions(optionsList) {
            var inGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            for(var i = 0; i < optionsList.length; i++){
                var option = optionsList[i];
                if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`value` in Select options should not be `null`.");
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $0dd83a53fec15284$export$2e2bcd8739ae039 = $0dd83a53fec15284$var$warningProps;


var $89a6c2622fd5143d$var$_excluded = [
    "id",
    "mode",
    "prefixCls",
    "backfill",
    "fieldNames",
    "inputValue",
    "searchValue",
    "onSearch",
    "autoClearSearchValue",
    "onSelect",
    "onDeselect",
    "dropdownMatchSelectWidth",
    "filterOption",
    "filterSort",
    "optionFilterProp",
    "optionLabelProp",
    "options",
    "optionRender",
    "children",
    "defaultActiveFirstOption",
    "menuItemSelectedIcon",
    "virtual",
    "direction",
    "listHeight",
    "listItemHeight",
    "labelRender",
    "value",
    "defaultValue",
    "labelInValue",
    "onChange",
    "maxCount"
];
var $89a6c2622fd5143d$var$OMIT_DOM_PROPS = [
    "inputValue"
];
function $89a6c2622fd5143d$var$isRawValue(value) {
    return !value || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) !== "object";
}
var $89a6c2622fd5143d$var$Select = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-select" : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, optionRender = props.optionRender, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, direction = props.direction, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, labelRender = props.labelRender, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, maxCount = props.maxCount, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $89a6c2622fd5143d$var$_excluded);
    var mergedId = (0, $8656bcd9ded5e8cf$export$2e2bcd8739ae039)(id);
    var multiple = (0, $685f3ef01f9743a0$export$7f654ad2a77ad2ac)(mode);
    var childrenAsData = !!(!options && children);
    var mergedFilterOption = $acw62.useMemo(function() {
        if (filterOption === undefined && mode === "combobox") return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    var mergedFieldNames = $acw62.useMemo(function() {
        return (0, $67e3f69030e63308$export$6c519d302dced239)(fieldNames, childrenAsData);
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)("", {
        value: searchValue !== undefined ? searchValue : inputValue,
        postState: function postState(search) {
            return search || "";
        }
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    // =========================== Option ===========================
    var parsedOptions = (0, $05553a78451953de$export$2e2bcd8739ae039)(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    // ========================= Wrap Value =========================
    var convert2LabelValues = $acw62.useCallback(function(draftValues) {
        // Convert to array
        var valueList = (0, $953a8baf84e85e44$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map(function(val) {
            var rawValue;
            var rawLabel;
            var rawKey;
            var rawDisabled;
            var rawTitle;
            // Fill label & value
            if ($89a6c2622fd5143d$var$isRawValue(val)) rawValue = val;
            else {
                var _val$value;
                rawKey = val.key;
                rawLabel = val.label;
                rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
            }
            var option = valueOptions.get(rawValue);
            if (option) {
                var _option$key;
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
                if (rawKey === undefined) rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
                rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
                rawTitle = option === null || option === void 0 ? void 0 : option.title;
                var optionLabel;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawKey,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    var _useMergedState3 = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    // Merged value with LabelValueType
    var rawLabeledValues = $acw62.useMemo(function() {
        var _values$;
        var newInternalValue = multiple && internalValue === null ? [] : internalValue;
        var values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === "combobox" && (0, $953a8baf84e85e44$export$9d186c3672bb89c6)((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    var _useCache = (0, $91018b9a345d68e7$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions), _useCache2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = $acw62.useMemo(function() {
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            var firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map(function(item) {
            var _ref;
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, item), {}, {
                label: (_ref = typeof labelRender === "function" ? labelRender(item) : item.label) !== null && _ref !== void 0 ? _ref : item.value
            });
        });
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ var rawValues = $acw62.useMemo(function() {
        return new Set(mergedValues.map(function(val) {
            return val.value;
        }));
    }, [
        mergedValues
    ]);
    $acw62.useEffect(function() {
        if (mode === "combobox") {
            var _mergedValues$;
            var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
            setSearchValue((0, $953a8baf84e85e44$export$96bdbc84526f3739)(strValue) ? String(strValue) : "");
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    var createTagOption = (0, $fb4ced1ec5128b6c$export$2e2bcd8739ae039)(function(val, label) {
        var mergedLabel = label !== null && label !== void 0 ? label : val;
        return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, mergedFieldNames.value, val), mergedFieldNames.label, mergedLabel);
    });
    // Fill tag as option if mode is `tags`
    var filledTagOptions = $acw62.useMemo(function() {
        if (mode !== "tags") return mergedOptions;
        // >>> Tag mode
        var cloneOptions = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedOptions);
        // Check if value exist in options (include new patch item)
        var existOptions = function existOptions(val) {
            return valueOptions.has(val);
        };
        // Fill current value as option
        (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedValues).sort(function(a, b) {
            return a.value < b.value ? -1 : 1;
        }).forEach(function(item) {
            var val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    var filteredOptions = (0, $47ef072d0f92ab84$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
    // Fill options with search value if needed
    var filledSearchOptions = $acw62.useMemo(function() {
        if (mode !== "tags" || !mergedSearchValue || filteredOptions.some(function(item) {
            return item[optionFilterProp || "value"] === mergedSearchValue;
        })) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some(function(item) {
            return item[mergedFieldNames.value] === mergedSearchValue;
        })) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue)
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(filteredOptions));
    }, [
        createTagOption,
        optionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames
    ]);
    var orderedFilteredOptions = $acw62.useMemo(function() {
        if (!filterSort) return filledSearchOptions;
        return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(filledSearchOptions).sort(function(a, b) {
            return filterSort(a, b, {
                searchValue: mergedSearchValue
            });
        });
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    var displayOptions = $acw62.useMemo(function() {
        return (0, $67e3f69030e63308$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        });
    }, [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    var triggerChange = function triggerChange(values) {
        var labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index) {
            var _mergedValues$index;
            return ((_mergedValues$index = mergedValues[index]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
        }))) {
            var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
                return v.value;
            });
            var returnOptions = labeledValues.map(function(v) {
                return (0, $67e3f69030e63308$export$d0b21b213c8c013c)(getMixedOption(v.value));
            });
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState(0), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
    var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== "combobox";
    var onActiveValue = $acw62.useCallback(function(active, index) {
        var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? "keyboard" : _ref3$source;
        setAccessibilityIndex(index);
        if (backfill && mode === "combobox" && active !== null && source === "keyboard") setActiveValue(String(active));
    }, [
        backfill,
        mode
    ]);
    // ========================= OptionList =========================
    var triggerSelect = function triggerSelect(val, selected, type) {
        var getSelectEnt = function getSelectEnt() {
            var _option$key2;
            var option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
                    value: val,
                    key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
                } : val,
                (0, $67e3f69030e63308$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
            onSelect(wrappedValue, _option);
        } else if (!selected && onDeselect && type !== "clear") {
            var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
            onDeselect(_wrappedValue, _option2);
        }
    };
    // Used for OptionList selection
    var onInternalSelect = (0, $fb4ced1ec5128b6c$export$2e2bcd8739ae039)(function(val, info) {
        var cloneValues;
        // Single mode always trigger select only with option list
        var mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedValues), [
            val
        ]) : [
            val
        ];
        else cloneValues = mergedValues.filter(function(v) {
            return v.value !== val;
        });
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === "combobox") // setSearchValue(String(val));
        setActiveValue("");
        else if (!(0, $685f3ef01f9743a0$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue("");
            setActiveValue("");
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    var onDisplayValuesChange = function onDisplayValuesChange(nextValues, info) {
        triggerChange(nextValues);
        var type = info.type, values = info.values;
        if (type === "remove" || type === "clear") values.forEach(function(item) {
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    var onInternalSearch = function onInternalSearch(searchText, info) {
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === "submit") {
            var formatted = (searchText || "").trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                var newRawValues = Array.from(new Set([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rawValues), [
                    formatted
                ])));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue("");
            }
            return;
        }
        if (info.source !== "blur") {
            if (mode === "combobox") triggerChange(searchText);
            onSearch === null || onSearch === void 0 || onSearch(searchText);
        }
    };
    var onInternalSearchSplit = function onInternalSearchSplit(words) {
        var patchValues = words;
        if (mode !== "tags") patchValues = words.map(function(word) {
            var opt = labelOptions.get(word);
            return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
            return val !== undefined;
        });
        var newRawValues = Array.from(new Set([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rawValues), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(patchValues))));
        triggerChange(newRawValues);
        newRawValues.forEach(function(newRawValue) {
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    var selectContext = $acw62.useMemo(function() {
        var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, parsedOptions), {}, {
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender
        });
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        dropdownMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $acw62.createElement((0, $44daf1c3d5d48cca$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $acw62.createElement((0, $685f3ef01f9743a0$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $89a6c2622fd5143d$var$OMIT_DOM_PROPS,
        mode: mode,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        direction: direction,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        dropdownMatchSelectWidth: dropdownMatchSelectWidth,
        OptionList: (0, $4a507f608f30c004$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
    })));
});
var $89a6c2622fd5143d$var$TypedSelect = $89a6c2622fd5143d$var$Select;
$89a6c2622fd5143d$var$TypedSelect.Option = (0, $2f79e5076b69401d$export$2e2bcd8739ae039);
$89a6c2622fd5143d$var$TypedSelect.OptGroup = (0, $cb22e94bdb4eaaa5$export$2e2bcd8739ae039);
var $89a6c2622fd5143d$export$2e2bcd8739ae039 = $89a6c2622fd5143d$var$TypedSelect;






var $65dbbed9df0fecca$export$2e2bcd8739ae039 = (0, $89a6c2622fd5143d$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
const $2adf0f811816efa6$var$zIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
var $2adf0f811816efa6$export$2e2bcd8739ae039 = $2adf0f811816efa6$var$zIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET = 100;
const $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $8552b358f1d5b0a4$export$33ada7d8845f7e5 = $8552b358f1d5b0a4$var$CONTAINER_OFFSET * $8552b358f1d5b0a4$var$CONTAINER_OFFSET_MAX_COUNT;
const $8552b358f1d5b0a4$export$1658852af8bb2a55 = {
    Modal: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Drawer: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popover: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Popconfirm: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tooltip: $8552b358f1d5b0a4$var$CONTAINER_OFFSET,
    Tour: $8552b358f1d5b0a4$var$CONTAINER_OFFSET
};
const $8552b358f1d5b0a4$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
function $8552b358f1d5b0a4$var$isContainerType(type) {
    return type in $8552b358f1d5b0a4$export$1658852af8bb2a55;
}
function $8552b358f1d5b0a4$export$3e7906d4075187a4(componentType, customZIndex) {
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $2adf0f811816efa6$export$2e2bcd8739ae039));
    const isContainer = $8552b358f1d5b0a4$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $8552b358f1d5b0a4$export$1658852af8bb2a55[componentType];
        else zIndex += $8552b358f1d5b0a4$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
}


// ================== Collapse Motion ==================
const $2efb522a5615f01e$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $2efb522a5615f01e$var$getRealHeight = (node)=>{
    const { scrollHeight: scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const $2efb522a5615f01e$var$getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const $2efb522a5615f01e$var$skipOpacityTransition = (_, event)=>(event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
const $2efb522a5615f01e$var$initCollapseMotion = function() {
    let rootCls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ant";
    return {
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onEnterStart: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearActive: $2efb522a5615f01e$var$getRealHeight,
        onEnterActive: $2efb522a5615f01e$var$getRealHeight,
        onLeaveStart: $2efb522a5615f01e$var$getCurrentHeight,
        onLeaveActive: $2efb522a5615f01e$var$getCollapsedHeight,
        onAppearEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onEnterEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        onLeaveEnd: $2efb522a5615f01e$var$skipOpacityTransition,
        motionDeadline: 500
    };
};
const $2efb522a5615f01e$var$SelectPlacements = [
    "bottomLeft",
    "bottomRight",
    "topLeft",
    "topRight"
];
const $2efb522a5615f01e$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $2efb522a5615f01e$export$2e2bcd8739ae039 = $2efb522a5615f01e$var$initCollapseMotion;



var $acw62 = parcelRequire("acw62");


"use client";
function $91653a8941ab7768$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $acw62.createElement(Component, Object.assign({}, props)));
}
/* istanbul ignore next */ const $91653a8941ab7768$var$genPurePanel = (Component, defaultPrefixCls, getDropdownCls, postProps)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $acw62.useRef(null);
        const [popupHeight, setPopupHeight] = $acw62.useState(0);
        const [popupWidth, setPopupWidth] = $acw62.useState(0);
        const [open, setOpen] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
            value: props.open
        });
        const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || "select", customizePrefixCls);
        $acw62.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== "undefined") {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    var _a;
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, []);
        let mergedProps = Object.assign(Object.assign({}, props), {
            style: Object.assign(Object.assign({}, style), {
                margin: 0
            }),
            open: open,
            visible: open,
            getPopupContainer: ()=>holderRef.current
        });
        if (postProps) mergedProps = postProps(mergedProps);
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: "relative",
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $acw62.createElement(Component, Object.assign({}, mergedProps)));
    };
    return $91653a8941ab7768$export$29e2a8c3cdb34b03(PurePanel);
};
var $91653a8941ab7768$export$2e2bcd8739ae039 = $91653a8941ab7768$var$genPurePanel;



const $67f89d06f52454a6$var$InputStatuses = [
    "warning",
    "error",
    ""
];
function $67f89d06f52454a6$export$b08e7b47149942a2(prefixCls, status, hasFeedback) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-status-success`]: status === "success",
        [`${prefixCls}-status-warning`]: status === "warning",
        [`${prefixCls}-status-error`]: status === "error",
        [`${prefixCls}-status-validating`]: status === "validating",
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
}
const $67f89d06f52454a6$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;







/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $9be8217fdbca7dca$var$useCSSVarCls = (prefixCls)=>{
    const [, , , , cssVar] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    return cssVar ? `${prefixCls}-css-var` : "";
};
var $9be8217fdbca7dca$export$2e2bcd8739ae039 = $9be8217fdbca7dca$var$useCSSVarCls;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



function $90d00d496f52c75c$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    $90d00d496f52c75c$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError((0, $b8f57191916382d3$export$2e2bcd8739ae039)(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}


function $4051039ece381ef4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4051039ece381ef4$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}














var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $186c9d6ed579317b$export$24829b7c0e49e9f7 = "RC_FORM_INTERNAL_HOOKS";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $186c9d6ed579317b$var$warningFunc = function warningFunc() {
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var $186c9d6ed579317b$var$Context = /*#__PURE__*/ $acw62.createContext({
    getFieldValue: $186c9d6ed579317b$var$warningFunc,
    getFieldsValue: $186c9d6ed579317b$var$warningFunc,
    getFieldError: $186c9d6ed579317b$var$warningFunc,
    getFieldWarning: $186c9d6ed579317b$var$warningFunc,
    getFieldsError: $186c9d6ed579317b$var$warningFunc,
    isFieldsTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldTouched: $186c9d6ed579317b$var$warningFunc,
    isFieldValidating: $186c9d6ed579317b$var$warningFunc,
    isFieldsValidating: $186c9d6ed579317b$var$warningFunc,
    resetFields: $186c9d6ed579317b$var$warningFunc,
    setFields: $186c9d6ed579317b$var$warningFunc,
    setFieldValue: $186c9d6ed579317b$var$warningFunc,
    setFieldsValue: $186c9d6ed579317b$var$warningFunc,
    validateFields: $186c9d6ed579317b$var$warningFunc,
    submit: $186c9d6ed579317b$var$warningFunc,
    getInternalHooks: function getInternalHooks() {
        $186c9d6ed579317b$var$warningFunc();
        return {
            dispatch: $186c9d6ed579317b$var$warningFunc,
            initEntityValue: $186c9d6ed579317b$var$warningFunc,
            registerField: $186c9d6ed579317b$var$warningFunc,
            useSubscribe: $186c9d6ed579317b$var$warningFunc,
            setInitialValues: $186c9d6ed579317b$var$warningFunc,
            destroyForm: $186c9d6ed579317b$var$warningFunc,
            setCallbacks: $186c9d6ed579317b$var$warningFunc,
            registerWatch: $186c9d6ed579317b$var$warningFunc,
            getFields: $186c9d6ed579317b$var$warningFunc,
            setValidateMessages: $186c9d6ed579317b$var$warningFunc,
            setPreserve: $186c9d6ed579317b$var$warningFunc,
            getInitialValue: $186c9d6ed579317b$var$warningFunc
        };
    }
});
var $186c9d6ed579317b$export$2e2bcd8739ae039 = $186c9d6ed579317b$var$Context;



var $acw62 = parcelRequire("acw62");
var $f81400e90cbb2e33$var$ListContext = /*#__PURE__*/ $acw62.createContext(null);
var $f81400e90cbb2e33$export$2e2bcd8739ae039 = $f81400e90cbb2e33$var$ListContext;


function $c9624fc8667843e4$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $c9624fc8667843e4$export$717b316e73068e8d(form) {
    return form && !!form._init;
}













function $561ee5dfc4dc516a$export$f77fd0c3b25d8534() {
    return {
        default: "Validation error on field %s",
        required: "%s is required",
        enum: "%s must be one of %s",
        whitespace: "%s cannot be empty",
        date: {
            format: "%s date %s is invalid for format %s",
            parse: "%s date could not be parsed, %s is invalid ",
            invalid: "%s date %s is invalid"
        },
        types: {
            string: "%s is not a %s",
            method: "%s is not a %s (function)",
            array: "%s is not an %s",
            object: "%s is not an %s",
            number: "%s is not a %s",
            date: "%s is not a %s",
            boolean: "%s is not a %s",
            integer: "%s is not an %s",
            float: "%s is not a %s",
            regexp: "%s is not a valid %s",
            email: "%s is not a valid %s",
            url: "%s is not a valid %s",
            hex: "%s is not a valid %s"
        },
        string: {
            len: "%s must be exactly %s characters",
            min: "%s must be at least %s characters",
            max: "%s cannot be longer than %s characters",
            range: "%s must be between %s and %s characters"
        },
        number: {
            len: "%s must equal %s",
            min: "%s cannot be less than %s",
            max: "%s cannot be greater than %s",
            range: "%s must be between %s and %s"
        },
        array: {
            len: "%s must be exactly %s in length",
            min: "%s cannot be less than %s in length",
            max: "%s cannot be greater than %s in length",
            range: "%s must be between %s and %s in length"
        },
        pattern: {
            mismatch: "%s value %s does not match pattern %s"
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var $561ee5dfc4dc516a$export$defe85febe8b728c = $561ee5dfc4dc516a$export$f77fd0c3b25d8534();











function $7fc69e80a314c4c3$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}




function $a01f1d6c8bd49d36$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $b2099f49db83e2df$export$2e2bcd8739ae039)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(p, r.prototype), p;
}


function $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $b6acf1c5cac9dbb2$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $7fc69e80a314c4c3$export$2e2bcd8739ae039)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $a01f1d6c8bd49d36$export$2e2bcd8739ae039)(t, arguments, (0, $e4c5ebe502337db0$export$2e2bcd8739ae039)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(Wrapper, t);
    }, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039(t);
}





/* eslint no-console:0 */ var $5666056929fa6d0a$var$formatRegExp = /%[sdj%]/g;
var $5666056929fa6d0a$export$491112666e282270 = function warning() {};
// don't print warning message when in production env or node runtime
typeof $cfae44f0dfdf62c0$exports !== "undefined" && $cfae44f0dfdf62c0$exports.env;
function $5666056929fa6d0a$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $5666056929fa6d0a$export$d9468344d3651243(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === "function") // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === "string") {
        var str = template.replace($5666056929fa6d0a$var$formatRegExp, function(x) {
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $5666056929fa6d0a$var$isNativeStringType(type) {
    return type === "string" || type === "url" || type === "hex" || type === "email" || type === "date" || type === "pattern";
}
function $5666056929fa6d0a$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === "array" && Array.isArray(value) && !value.length) return true;
    if ($5666056929fa6d0a$var$isNativeStringType(type) && typeof value === "string" && !value) return true;
    return false;
}
function $5666056929fa6d0a$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $5666056929fa6d0a$var$asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function $5666056929fa6d0a$var$asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $5666056929fa6d0a$var$flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(objArr[k] || []));
    });
    return ret;
}
var $5666056929fa6d0a$export$188f48b73534b6f0 = /*#__PURE__*/ function(_Error) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(AsyncValidationError, _Error);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AsyncValidationError);
        _this = _super.call(this, "Async Validation Error");
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "errors", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AsyncValidationError);
}(/*#__PURE__*/ (0, $b6acf1c5cac9dbb2$export$2e2bcd8739ae039)(Error));
function $5666056929fa6d0a$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new $5666056929fa6d0a$export$188f48b73534b6f0(errors, $5666056929fa6d0a$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            var flattenArr = $5666056929fa6d0a$var$flattenObjArr(objArr);
            $5666056929fa6d0a$var$asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $5666056929fa6d0a$export$188f48b73534b6f0(results, $5666056929fa6d0a$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $5666056929fa6d0a$var$asyncSerialArray(arr, func, next);
            else $5666056929fa6d0a$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function $5666056929fa6d0a$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $5666056929fa6d0a$var$getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $5666056929fa6d0a$export$34d5fe50d2616cee(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = $5666056929fa6d0a$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($5666056929fa6d0a$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === "function" ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $5666056929fa6d0a$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target[s]) === "object") target[s] = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}



var $488acc05b055d7b8$var$ENUM = "enum";
var $488acc05b055d7b8$var$enumerable = function enumerable(rule, value, source, errors, options) {
    rule[$488acc05b055d7b8$var$ENUM] = Array.isArray(rule[$488acc05b055d7b8$var$ENUM]) ? rule[$488acc05b055d7b8$var$ENUM] : [];
    if (rule[$488acc05b055d7b8$var$ENUM].indexOf(value) === -1) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[$488acc05b055d7b8$var$ENUM], rule.fullField, rule[$488acc05b055d7b8$var$ENUM].join(", ")));
};
var $488acc05b055d7b8$export$2e2bcd8739ae039 = $488acc05b055d7b8$var$enumerable;



var $a35cdee3e4b23caa$var$pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === "string") {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $a35cdee3e4b23caa$export$2e2bcd8739ae039 = $a35cdee3e4b23caa$var$pattern;



var $0c32d438c85e52c5$var$range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === "number";
    var min = typeof rule.min === "number";
    var max = typeof rule.max === "number";
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === "number";
    var str = typeof value === "string";
    var arr = Array.isArray(value);
    if (num) key = "number";
    else if (str) key = "string";
    else if (arr) key = "array";
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, "_").length;
    if (len) {
        if (val !== rule.len) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $0c32d438c85e52c5$export$2e2bcd8739ae039 = $0c32d438c85e52c5$var$range;



var $367d23b7d6b626de$var$required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $367d23b7d6b626de$export$2e2bcd8739ae039 = $367d23b7d6b626de$var$required;





// https://github.com/kevva/url-regex/blob/master/index.js
var $717e29c17bb36fc4$var$urlReg;
var $717e29c17bb36fc4$export$2e2bcd8739ae039 = function() {
    if ($717e29c17bb36fc4$var$urlReg) return $717e29c17bb36fc4$var$urlReg;
    var word = "[a-fA-F\\d:]";
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : "";
    };
    var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
    var v6seg = "[a-fA-F\\d]{1,4}";
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join("|"), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), "g");
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), "g");
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), "g");
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = "(?:\\S+(?::\\S*)?@)?";
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = "(?::\\d{2,5})?";
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    $717e29c17bb36fc4$var$urlReg = new RegExp("(?:^".concat(regex, "$)"), "i");
    return $717e29c17bb36fc4$var$urlReg;
};


/* eslint max-len:0 */ var $a5d3e25a95ca0fb0$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var $a5d3e25a95ca0fb0$var$types = {
    integer: function integer(value) {
        return $a5d3e25a95ca0fb0$var$types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return $a5d3e25a95ca0fb0$var$types.number(value) && !$a5d3e25a95ca0fb0$var$types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === "number";
    },
    object: function object(value) {
        return (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) === "object" && !$a5d3e25a95ca0fb0$var$types.array(value);
    },
    method: function method(value) {
        return typeof value === "function";
    },
    email: function email(value) {
        return typeof value === "string" && value.length <= 320 && !!value.match($a5d3e25a95ca0fb0$var$pattern.email);
    },
    url: function url(value) {
        return typeof value === "string" && value.length <= 2048 && !!value.match((0, $717e29c17bb36fc4$export$2e2bcd8739ae039)());
    },
    hex: function hex(value) {
        return typeof value === "string" && !!value.match($a5d3e25a95ca0fb0$var$pattern.hex);
    }
};
var $a5d3e25a95ca0fb0$var$type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, $367d23b7d6b626de$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        "integer",
        "float",
        "array",
        "regexp",
        "object",
        "method",
        "email",
        "number",
        "date",
        "url",
        "hex"
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$a5d3e25a95ca0fb0$var$types[ruleType](value)) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value) !== rule.type) errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $a5d3e25a95ca0fb0$export$2e2bcd8739ae039 = $a5d3e25a95ca0fb0$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var $14b0862e76234af4$var$whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === "") errors.push((0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $14b0862e76234af4$export$2e2bcd8739ae039 = $14b0862e76234af4$var$whitespace;


var $0347bc150d6f2e32$export$2e2bcd8739ae039 = {
    required: (0, $367d23b7d6b626de$export$2e2bcd8739ae039),
    whitespace: (0, $14b0862e76234af4$export$2e2bcd8739ae039),
    type: (0, $a5d3e25a95ca0fb0$export$2e2bcd8739ae039),
    range: (0, $0c32d438c85e52c5$export$2e2bcd8739ae039),
    enum: (0, $488acc05b055d7b8$export$2e2bcd8739ae039),
    pattern: (0, $a35cdee3e4b23caa$export$2e2bcd8739ae039)
};



var $857fca5fb1675ca6$var$any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $857fca5fb1675ca6$export$2e2bcd8739ae039 = $857fca5fb1675ca6$var$any;



var $e1df68b6ecc210d4$var$array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, "array");
        if (value !== undefined && value !== null) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $e1df68b6ecc210d4$export$2e2bcd8739ae039 = $e1df68b6ecc210d4$var$array;




var $02baf34e66bc03aa$var$boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $02baf34e66bc03aa$export$2e2bcd8739ae039 = $02baf34e66bc03aa$var$boolean;




var $1138e96dc48b4fc5$var$date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, "date") && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, "date")) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $1138e96dc48b4fc5$export$2e2bcd8739ae039 = $1138e96dc48b4fc5$var$date;




var $a22ed5dbeaeb8c02$var$ENUM = "enum";
var $a22ed5dbeaeb8c02$var$enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039)[$a22ed5dbeaeb8c02$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $a22ed5dbeaeb8c02$export$2e2bcd8739ae039 = $a22ed5dbeaeb8c02$var$enumerable;




var $4b57481f55e2d7bb$var$floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $4b57481f55e2d7bb$export$2e2bcd8739ae039 = $4b57481f55e2d7bb$var$floatFn;




var $64c62bbb3fde492f$var$integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $64c62bbb3fde492f$export$2e2bcd8739ae039 = $64c62bbb3fde492f$var$integer;




var $eb8f17d9362978d2$var$method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $eb8f17d9362978d2$export$2e2bcd8739ae039 = $eb8f17d9362978d2$var$method;




var $c0807ef45346ad43$var$number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === "") // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $c0807ef45346ad43$export$2e2bcd8739ae039 = $c0807ef45346ad43$var$number;




var $04bb6b410c7a206f$var$object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $04bb6b410c7a206f$export$2e2bcd8739ae039 = $04bb6b410c7a206f$var$object;




var $51bdf3a9527552af$var$pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, "string") && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, "string")) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $51bdf3a9527552af$export$2e2bcd8739ae039 = $51bdf3a9527552af$var$pattern;




var $81e7b9249a6aadc4$var$regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value)) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $81e7b9249a6aadc4$export$2e2bcd8739ae039 = $81e7b9249a6aadc4$var$regexp;




var $9f32c5d072c41c33$var$required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? "array" : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value);
    (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $9f32c5d072c41c33$export$2e2bcd8739ae039 = $9f32c5d072c41c33$var$required;




var $b12128c8b08da777$var$string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, "string") && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, "string");
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, "string")) {
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $b12128c8b08da777$export$2e2bcd8739ae039 = $b12128c8b08da777$var$string;




var $a937786d6e0818eb$var$type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $5666056929fa6d0a$export$141eca273a04dc3e)(value, ruleType)) (0, $0347bc150d6f2e32$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $a937786d6e0818eb$export$2e2bcd8739ae039 = $a937786d6e0818eb$var$type;


var $562afa29da428a80$export$2e2bcd8739ae039 = {
    string: (0, $b12128c8b08da777$export$2e2bcd8739ae039),
    method: (0, $eb8f17d9362978d2$export$2e2bcd8739ae039),
    number: (0, $c0807ef45346ad43$export$2e2bcd8739ae039),
    boolean: (0, $02baf34e66bc03aa$export$2e2bcd8739ae039),
    regexp: (0, $81e7b9249a6aadc4$export$2e2bcd8739ae039),
    integer: (0, $64c62bbb3fde492f$export$2e2bcd8739ae039),
    float: (0, $4b57481f55e2d7bb$export$2e2bcd8739ae039),
    array: (0, $e1df68b6ecc210d4$export$2e2bcd8739ae039),
    object: (0, $04bb6b410c7a206f$export$2e2bcd8739ae039),
    enum: (0, $a22ed5dbeaeb8c02$export$2e2bcd8739ae039),
    pattern: (0, $51bdf3a9527552af$export$2e2bcd8739ae039),
    date: (0, $1138e96dc48b4fc5$export$2e2bcd8739ae039),
    url: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    hex: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    email: (0, $a937786d6e0818eb$export$2e2bcd8739ae039),
    required: (0, $9f32c5d072c41c33$export$2e2bcd8739ae039),
    any: (0, $857fca5fb1675ca6$export$2e2bcd8739ae039)
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var $4b94184ce2afa17e$var$Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Schema);
        // ======================== Instance ========================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "rules", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "_messages", (0, $561ee5dfc4dc516a$export$defe85febe8b728c));
        this.define(descriptor);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error("Cannot configure a schema with no rules");
                if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(rules) !== "object" || Array.isArray(rules)) throw new Error("Rules must be an object");
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages) {
                if (_messages) this._messages = (0, $5666056929fa6d0a$export$6969335ea1e4e77c)((0, $561ee5dfc4dc516a$export$f77fd0c3b25d8534)(), _messages);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, $5666056929fa6d0a$export$e85887f5ceeacced)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, $561ee5dfc4dc516a$export$defe85febe8b728c)) messages = (0, $561ee5dfc4dc516a$export$f77fd0c3b25d8534)();
                    (0, $5666056929fa6d0a$export$6969335ea1e4e77c)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === "function") {
                            if (source === source_) source = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? "array" : (0, $b8f57191916382d3$export$2e2bcd8739ae039)(value));
                        }
                        if (typeof rule === "function") rule = {
                            validator: rule
                        };
                        else rule = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, $5666056929fa6d0a$export$707ee4c4c95d39e3)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === "object" || rule.type === "array") && ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(rule.fields) === "object" || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(rule.defaultField) === "object");
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning("async-validator:", errorList);
                        if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, $5666056929fa6d0a$export$34d5fe50d2616cee)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $5666056929fa6d0a$export$34d5fe50d2616cee)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, $5666056929fa6d0a$export$d9468344d3651243)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = "pattern";
                if (typeof rule.validator !== "function" && rule.type && !(0, $562afa29da428a80$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $5666056929fa6d0a$export$d9468344d3651243)("Unknown rule type %s", rule.type));
                return rule.type || "string";
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === "function") return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf("message");
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === "required") return (0, $562afa29da428a80$export$2e2bcd8739ae039).required;
                return (0, $562afa29da428a80$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "register", function register(type, validator) {
    if (typeof validator !== "function") throw new Error("Cannot register a validator by type, validator is not a function");
    (0, $562afa29da428a80$export$2e2bcd8739ae039)[type] = validator;
});
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "warning", (0, $5666056929fa6d0a$export$491112666e282270));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "messages", (0, $561ee5dfc4dc516a$export$defe85febe8b728c));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($4b94184ce2afa17e$var$Schema, "validators", (0, $562afa29da428a80$export$2e2bcd8739ae039));
var $4b94184ce2afa17e$export$2e2bcd8739ae039 = $4b94184ce2afa17e$var$Schema;



var $acw62 = parcelRequire("acw62");

var $ebfc45d3b86f29a2$var$typeTemplate = "'${name}' is not a valid ${type}";
var $ebfc45d3b86f29a2$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $ebfc45d3b86f29a2$var$typeTemplate,
        method: $ebfc45d3b86f29a2$var$typeTemplate,
        array: $ebfc45d3b86f29a2$var$typeTemplate,
        object: $ebfc45d3b86f29a2$var$typeTemplate,
        number: $ebfc45d3b86f29a2$var$typeTemplate,
        date: $ebfc45d3b86f29a2$var$typeTemplate,
        boolean: $ebfc45d3b86f29a2$var$typeTemplate,
        integer: $ebfc45d3b86f29a2$var$typeTemplate,
        float: $ebfc45d3b86f29a2$var$typeTemplate,
        regexp: $ebfc45d3b86f29a2$var$typeTemplate,
        email: $ebfc45d3b86f29a2$var$typeTemplate,
        url: $ebfc45d3b86f29a2$var$typeTemplate,
        hex: $ebfc45d3b86f29a2$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};



// Remove incorrect original ts define
var $66537bc44202668a$var$AsyncValidator = (0, $4b94184ce2afa17e$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $66537bc44202668a$var$replaceMessage(template, kv) {
    return template.replace(/\$\{\w+\}/g, function(str) {
        var key = str.slice(2, -1);
        return kv[key];
    });
}
var $66537bc44202668a$var$CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function $66537bc44202668a$var$validateRule(_x, _x2, _x3, _x4, _x5) {
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ function $66537bc44202668a$var$_validateRule() {
    $66537bc44202668a$var$_validateRule = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee2(name, value, rule, options, messageVariables) {
        var cloneRule, originValidator, subRuleField, validator, messages, result, subResults, kv, fillVariableResult;
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    cloneRule = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rule); // Bug of `async-validator`
                    // https://github.com/react-component/field-form/issues/316
                    // https://github.com/react-component/field-form/issues/313
                    delete cloneRule.ruleIndex;
                    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
                    $66537bc44202668a$var$AsyncValidator.warning = function() {
                        return void 0;
                    };
                    if (cloneRule.validator) {
                        originValidator = cloneRule.validator;
                        cloneRule.validator = function() {
                            try {
                                return originValidator.apply(void 0, arguments);
                            } catch (error) {
                                console.error(error);
                                return Promise.reject($66537bc44202668a$var$CODE_LOGIC_ERROR);
                            }
                        };
                    }
                    // We should special handle array validate
                    subRuleField = null;
                    if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
                        subRuleField = cloneRule.defaultField;
                        delete cloneRule.defaultField;
                    }
                    validator = new $66537bc44202668a$var$AsyncValidator((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, name, [
                        cloneRule
                    ]));
                    messages = (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)((0, $ebfc45d3b86f29a2$export$c86b939816b8fbf8), options.validateMessages);
                    validator.messages(messages);
                    result = [];
                    _context2.prev = 10;
                    _context2.next = 13;
                    return Promise.resolve(validator.validate((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, name, value), (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, options)));
                case 13:
                    _context2.next = 18;
                    break;
                case 15:
                    _context2.prev = 15;
                    _context2.t0 = _context2["catch"](10);
                    if (_context2.t0.errors) result = _context2.t0.errors.map(function(_ref4, index) {
                        var message = _ref4.message;
                        var mergedMessage = message === $66537bc44202668a$var$CODE_LOGIC_ERROR ? messages.default : message;
                        return /*#__PURE__*/ $acw62.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
                        $acw62.cloneElement(mergedMessage, {
                            key: "error_".concat(index)
                        }) : mergedMessage;
                    });
                case 18:
                    if (!(!result.length && subRuleField)) {
                        _context2.next = 23;
                        break;
                    }
                    _context2.next = 21;
                    return Promise.all(value.map(function(subValue, i) {
                        return $66537bc44202668a$var$validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
                    }));
                case 21:
                    subResults = _context2.sent;
                    return _context2.abrupt("return", subResults.reduce(function(prev, errors) {
                        return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                    }, []));
                case 23:
                    // Replace message with variables
                    kv = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rule), {}, {
                        name: name,
                        enum: (rule.enum || []).join(", ")
                    }, messageVariables);
                    fillVariableResult = result.map(function(error) {
                        if (typeof error === "string") return $66537bc44202668a$var$replaceMessage(error, kv);
                        return error;
                    });
                    return _context2.abrupt("return", fillVariableResult);
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                10,
                15
            ]
        ]);
    }));
    return $66537bc44202668a$var$_validateRule.apply(this, arguments);
}
function $66537bc44202668a$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    var name = namePath.join(".");
    // Fill rule with context
    var filledRules = rules.map(function(currentRule, ruleIndex) {
        var originValidatorFunc = currentRule.validator;
        var cloneRule = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, currentRule), {}, {
            ruleIndex: ruleIndex
        });
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = function(rule, val, callback) {
            var hasPromise = false;
            // Wrap callback only accept when promise not provided
            var wrappedCallback = function wrappedCallback() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(function() {
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
                    if (!hasPromise) callback.apply(void 0, args);
                });
            };
            // Get promise
            var promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(hasPromise, "`callback` is deprecated. Please return a promise instead.");
            if (hasPromise) promise.then(function() {
                callback();
            }).catch(function(err) {
                callback(err || " ");
            });
        };
        return cloneRule;
    }).sort(function(_ref, _ref2) {
        var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
        var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    var summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(/*#__PURE__*/ function() {
        var _ref3 = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee(resolve, reject) {
            var i, rule, errors;
            return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < filledRules.length)) {
                            _context.next = 12;
                            break;
                        }
                        rule = filledRules[i];
                        _context.next = 5;
                        return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables);
                    case 5:
                        errors = _context.sent;
                        if (!errors.length) {
                            _context.next = 9;
                            break;
                        }
                        reject([
                            {
                                errors: errors,
                                rule: rule
                            }
                        ]);
                        return _context.abrupt("return");
                    case 9:
                        i += 1;
                        _context.next = 1;
                        break;
                    case 12:
                        /* eslint-enable */ resolve([]);
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x6, _x7) {
            return _ref3.apply(this, arguments);
        };
    }());
    else {
        // >>>>> Validate by parallel
        var rulePromises = filledRules.map(function(rule) {
            return $66537bc44202668a$var$validateRule(name, value, rule, options, messageVariables).then(function(errors) {
                return {
                    errors: errors,
                    rule: rule
                };
            });
        });
        summaryPromise = (validateFirst ? $66537bc44202668a$var$finishOnFirstFailed(rulePromises) : $66537bc44202668a$var$finishOnAllFailed(rulePromises)).then(function(errors) {
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch(function(e) {
        return e;
    });
    return summaryPromise;
}
function $66537bc44202668a$var$finishOnAllFailed(_x8) {
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnAllFailed() {
    $66537bc44202668a$var$_finishOnAllFailed = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee3(rulePromises) {
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
                        var _ref5;
                        var errors = (_ref5 = []).concat.apply(_ref5, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errorsList));
                        return errors;
                    }));
                case 1:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $66537bc44202668a$var$_finishOnAllFailed.apply(this, arguments);
}
function $66537bc44202668a$var$finishOnFirstFailed(_x9) {
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}
function $66537bc44202668a$var$_finishOnFirstFailed() {
    $66537bc44202668a$var$_finishOnFirstFailed = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee4(rulePromises) {
        var count;
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    count = 0;
                    return _context4.abrupt("return", new Promise(function(resolve) {
                        rulePromises.forEach(function(promise) {
                            promise.then(function(ruleError) {
                                if (ruleError.errors.length) resolve([
                                    ruleError
                                ]);
                                count += 1;
                                if (count === rulePromises.length) resolve([]);
                            });
                        });
                    }));
                case 2:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $66537bc44202668a$var$_finishOnFirstFailed.apply(this, arguments);
}







function $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9(path) {
    return (0, $c9624fc8667843e4$export$45b10814cc054894)(path);
}
function $f0c87cef6ee60bcb$export$f5be6dfb30403c59(store, namePathList) {
    var newStore = {};
    namePathList.forEach(function(namePath) {
        var value = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $f0c87cef6ee60bcb$export$646d5504364ae55b(namePathList, namePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return namePathList && namePathList.some(function(path) {
        return $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, path, partialMatch);
    });
}
function $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a(namePath, subNamePath) {
    var partialMatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every(function(nameUnit, i) {
        return namePath[i] === nameUnit;
    });
}
function $f0c87cef6ee60bcb$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(source) !== "object" || (0, $b8f57191916382d3$export$2e2bcd8739ae039)(target) !== "object") return false;
    var sourceKeys = Object.keys(source);
    var targetKeys = Object.keys(target);
    var keys = new Set([].concat(sourceKeys, targetKeys));
    return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keys).every(function(key) {
        var sourceValue = source[key];
        var targetValue = target[key];
        if (typeof sourceValue === "function" && typeof targetValue === "function") return true;
        return sourceValue === targetValue;
    });
}
function $f0c87cef6ee60bcb$export$6eeac3c5b406fb30(valuePropName) {
    var event = arguments.length <= 1 ? undefined : arguments[1];
    if (event && event.target && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(event.target) === "object" && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $f0c87cef6ee60bcb$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    var length = array.length;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    var item = array[moveIndex];
    var diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(0, toIndex)), [
        item
    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(toIndex, moveIndex)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, length)));
    if (diff < 0) // move right
    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(0, moveIndex)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(moveIndex + 1, toIndex + 1)), [
        item
    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(array.slice(toIndex + 1, length)));
    return array;
}


var $3299c229146a7fb5$var$_excluded = [
    "name"
];
var $3299c229146a7fb5$var$EMPTY_ERRORS = [];
function $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === "function") return shouldUpdate(prev, next, "source" in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
var $3299c229146a7fb5$var$Field = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Field, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Field);
    // ============================== Subscriptions ==============================
    function Field(props) {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Field);
        _this = _super.call(this, props);
        // Register on init
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            resetCount: 0
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "cancelRegisterFunc", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "mounted", false);
        /**
     * Follow state should not management in State since it will async update by React.
     * This makes first render of form can not get correct state value.
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "touched", false);
        /**
     * Mark when touched & validated. Currently only used for `dependencies`.
     * Note that we do not think field with `initialValue` is dirty
     * but this will be by `isFieldDirty` func.
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "dirty", false);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "validatePromise", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "prevValidating", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "errors", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "warnings", $3299c229146a7fb5$var$EMPTY_ERRORS);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "cancelRegister", function() {
            var _this$props = _this.props, preserve = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
            if (_this.cancelRegisterFunc) _this.cancelRegisterFunc(isListField, preserve, (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name));
            _this.cancelRegisterFunc = null;
        });
        // ================================== Utils ==================================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getNamePath", function() {
            var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
            var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
            return name !== undefined ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prefixName), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(name)) : [];
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getRules", function() {
            var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
            return rules.map(function(rule) {
                if (typeof rule === "function") return rule(fieldContext);
                return rule;
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "refresh", function() {
            if (!_this.mounted) return;
            /**
       * Clean up current node.
       */ _this.setState(function(_ref) {
                var resetCount = _ref.resetCount;
                return {
                    resetCount: resetCount + 1
                };
            });
        });
        // Event should only trigger when meta changed
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "metaCache", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "triggerMetaEvent", function(destroy) {
            var onMetaChange = _this.props.onMetaChange;
            if (onMetaChange) {
                var _meta = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.getMeta()), {}, {
                    destroy: destroy
                });
                if (!(0, $357adc8667cde522$export$2e2bcd8739ae039)(_this.metaCache, _meta)) onMetaChange(_meta);
                _this.metaCache = _meta;
            } else _this.metaCache = null;
        });
        // ========================= Field Entity Interfaces =========================
        // Trigger by store update. Check if need update the component
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onStoreChange", function(prevStore, namePathList, info) {
            var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
            var store = info.store;
            var namePath = _this.getNamePath();
            var prevValue = _this.getValue(prevStore);
            var curValue = _this.getValue(store);
            var namePathMatch = namePathList && (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, namePath);
            // `setFieldsValue` is a quick access to update related status
            if (info.type === "valueUpdate" && info.source === "external" && !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prevValue, curValue)) {
                _this.touched = true;
                _this.dirty = true;
                _this.validatePromise = null;
                _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                _this.triggerMetaEvent();
            }
            switch(info.type){
                case "reset":
                    if (!namePathList || namePathMatch) {
                        // Clean up state
                        _this.touched = false;
                        _this.dirty = false;
                        _this.validatePromise = undefined;
                        _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.triggerMetaEvent();
                        onReset === null || onReset === void 0 || onReset();
                        _this.refresh();
                        return;
                    }
                    break;
                /**
         * In case field with `preserve = false` nest deps like:
         * - A = 1 => show B
         * - B = 1 => show C
         * - Reset A, need clean B, C
         */ case "remove":
                    if (shouldUpdate) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "setField":
                    var data = info.data;
                    if (namePathMatch) {
                        if ("touched" in data) _this.touched = data.touched;
                        if ("validating" in data && !("originRCField" in data)) _this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ("errors" in data) _this.errors = data.errors || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        if ("warnings" in data) _this.warnings = data.warnings || $3299c229146a7fb5$var$EMPTY_ERRORS;
                        _this.dirty = true;
                        _this.triggerMetaEvent();
                        _this.reRender();
                        return;
                    } else if ("value" in data && (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        _this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
                case "dependenciesUpdate":
                    /**
             * Trigger when marked `dependencies` updated. Related fields will all update
             */ var dependencyList = dependencies.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some(function(dependency) {
                        return (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(info.relatedFields, dependency);
                    })) {
                        _this.reRender();
                        return;
                    }
                    break;
                default:
                    // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                    //      For example <List name="list"><Field name={['list', 0]}></List>
                    //      If `namePathList` is [['list']] (List value update), Field should be updated
                    //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                    // 2.
                    //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                    //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                    //       is not provided
                    //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                    //       else to check if value changed
                    if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $3299c229146a7fb5$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        _this.reRender();
                        return;
                    }
                    break;
            }
            if (shouldUpdate === true) _this.reRender();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "validateRules", function(options) {
            // We should fixed namePath & value to avoid developer change then by form function
            var namePath = _this.getNamePath();
            var currentValue = _this.getValue();
            var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
            // Force change to async to avoid rule OOD under renderProps field
            var rootPromise = Promise.resolve().then(/*#__PURE__*/ (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee() {
                var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
                return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (_this.mounted) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 2:
                            _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce; // Start validate
                            filteredRules = _this.getRules();
                            if (triggerName) filteredRules = filteredRules.filter(function(rule) {
                                return rule;
                            }).filter(function(rule) {
                                var validateTrigger = rule.validateTrigger;
                                if (!validateTrigger) return true;
                                var triggerList = (0, $c9624fc8667843e4$export$45b10814cc054894)(validateTrigger);
                                return triggerList.includes(triggerName);
                            });
                            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
                            if (!(validateDebounce && triggerName)) {
                                _context.next = 10;
                                break;
                            }
                            _context.next = 8;
                            return new Promise(function(resolve) {
                                setTimeout(resolve, validateDebounce);
                            });
                        case 8:
                            if (!(_this.validatePromise !== rootPromise)) {
                                _context.next = 10;
                                break;
                            }
                            return _context.abrupt("return", []);
                        case 10:
                            promise = (0, $66537bc44202668a$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                            promise.catch(function(e) {
                                return e;
                            }).then(function() {
                                var ruleErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $3299c229146a7fb5$var$EMPTY_ERRORS;
                                if (_this.validatePromise === rootPromise) {
                                    var _ruleErrors$forEach;
                                    _this.validatePromise = null;
                                    // Get errors & warnings
                                    var nextErrors = [];
                                    var nextWarnings = [];
                                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                                        var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? $3299c229146a7fb5$var$EMPTY_ERRORS : _ref4$errors;
                                        if (warningOnly) nextWarnings.push.apply(nextWarnings, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                                        else nextErrors.push.apply(nextErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                                    });
                                    _this.errors = nextErrors;
                                    _this.warnings = nextWarnings;
                                    _this.triggerMetaEvent();
                                    _this.reRender();
                                }
                            });
                            return _context.abrupt("return", promise);
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            })));
            if (validateOnly) return rootPromise;
            _this.validatePromise = rootPromise;
            _this.dirty = true;
            _this.errors = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.warnings = $3299c229146a7fb5$var$EMPTY_ERRORS;
            _this.triggerMetaEvent();
            // Force trigger re-render since we need sync renderProps with new meta
            _this.reRender();
            return rootPromise;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isFieldValidating", function() {
            return !!_this.validatePromise;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isFieldTouched", function() {
            return _this.touched;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isFieldDirty", function() {
            // Touched or validate or has initialValue
            if (_this.dirty || _this.props.initialValue !== undefined) return true;
            // Form set initialValue
            var fieldContext = _this.props.fieldContext;
            var _fieldContext$getInte = fieldContext.getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), getInitialValue = _fieldContext$getInte.getInitialValue;
            if (getInitialValue(_this.getNamePath()) !== undefined) return true;
            return false;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getErrors", function() {
            return _this.errors;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getWarnings", function() {
            return _this.warnings;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isListField", function() {
            return _this.props.isListField;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isList", function() {
            return _this.props.isList;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isPreserve", function() {
            return _this.props.preserve;
        });
        // ============================= Child Component =============================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getMeta", function() {
            // Make error & validating in cache to save perf
            _this.prevValidating = _this.isFieldValidating();
            var meta = {
                touched: _this.isFieldTouched(),
                validating: _this.prevValidating,
                errors: _this.errors,
                warnings: _this.warnings,
                name: _this.getNamePath(),
                validated: _this.validatePromise === null
            };
            return meta;
        });
        // Only return validate child node. If invalidate, will do nothing about field.
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getOnlyChild", function(children) {
            // Support render props
            if (typeof children === "function") {
                var _meta2 = _this.getMeta();
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
                    isFunction: true
                });
            }
            // Filed element only
            var childList = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
            if (childList.length !== 1 || !/*#__PURE__*/ $acw62.isValidElement(childList[0])) return {
                child: childList,
                isFunction: false
            };
            return {
                child: childList[0],
                isFunction: false
            };
        });
        // ============================== Field Control ==============================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getValue", function(store) {
            var getFieldsValue = _this.props.fieldContext.getFieldsValue;
            var namePath = _this.getNamePath();
            return (0, $17fcde5782384c29$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getControlled", function() {
            var childProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _this$props6 = _this.props, name = _this$props6.name, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
            var mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
            var namePath = _this.getNamePath();
            var getInternalHooks = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
            var _getInternalHooks = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), dispatch = _getInternalHooks.dispatch;
            var value = _this.getValue();
            var mergedGetValueProps = getValueProps || function(val) {
                return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, valuePropName, val);
            };
            var originTriggerFunc = childProps[trigger];
            var valueProps = name !== undefined ? mergedGetValueProps(value) : {};
            var control = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, childProps), valueProps);
            // Add trigger
            control[trigger] = function() {
                // Mark as touched
                _this.touched = true;
                _this.dirty = true;
                _this.triggerMetaEvent();
                var newValue;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (getValueFromEvent) newValue = getValueFromEvent.apply(void 0, args);
                else newValue = (0, $f0c87cef6ee60bcb$export$6eeac3c5b406fb30).apply(void 0, [
                    valuePropName
                ].concat(args));
                if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
                dispatch({
                    type: "updateValue",
                    namePath: namePath,
                    value: newValue
                });
                if (originTriggerFunc) originTriggerFunc.apply(void 0, args);
            };
            // Add validateTrigger
            var validateTriggerList = (0, $c9624fc8667843e4$export$45b10814cc054894)(mergedValidateTrigger || []);
            validateTriggerList.forEach(function(triggerName) {
                // Wrap additional function of component, so that we can get latest value from store
                var originTrigger = control[triggerName];
                control[triggerName] = function() {
                    if (originTrigger) originTrigger.apply(void 0, arguments);
                    // Always use latest rules
                    var rules = _this.props.rules;
                    if (rules && rules.length) // We dispatch validate to root,
                    // since it will update related data with other field with same name
                    dispatch({
                        type: "validateField",
                        namePath: namePath,
                        triggerName: triggerName
                    });
                };
            });
            return control;
        });
        if (props.fieldContext) {
            var getInternalHooks = props.fieldContext.getInternalHooks;
            var _getInternalHooks2 = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), initEntityValue = _getInternalHooks2.initEntityValue;
            initEntityValue((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        }
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Field, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
                this.mounted = true;
                // Register on init
                if (fieldContext) {
                    var getInternalHooks = fieldContext.getInternalHooks;
                    var _getInternalHooks3 = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), registerField = _getInternalHooks3.registerField;
                    this.cancelRegisterFunc = registerField(this);
                }
                // One more render for component in case fields not ready
                if (shouldUpdate === true) this.reRender();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cancelRegister();
                this.triggerMetaEvent(true);
                this.mounted = false;
            }
        },
        {
            key: "reRender",
            value: function reRender() {
                if (!this.mounted) return;
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var resetCount = this.state.resetCount;
                var children = this.props.children;
                var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
                // Not need to `cloneElement` since user can handle this in render function self
                var returnChildNode;
                if (isFunction) returnChildNode = child;
                else if (/*#__PURE__*/ $acw62.isValidElement(child)) returnChildNode = /*#__PURE__*/ $acw62.cloneElement(child, this.getControlled(child.props));
                else {
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!child, "`children` of Field is not validate ReactElement.");
                    returnChildNode = child;
                }
                return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
                    key: resetCount
                }, returnChildNode);
            }
        }
    ]);
    return Field;
}($acw62.Component);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($3299c229146a7fb5$var$Field, "contextType", (0, $186c9d6ed579317b$export$2e2bcd8739ae039));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($3299c229146a7fb5$var$Field, "defaultProps", {
    trigger: "onChange",
    valuePropName: "value"
});
function $3299c229146a7fb5$var$WrapperField(_ref6) {
    var name = _ref6.name, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref6, $3299c229146a7fb5$var$_excluded);
    var fieldContext = $acw62.useContext((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    var listContext = $acw62.useContext((0, $f81400e90cbb2e33$export$2e2bcd8739ae039));
    var namePath = name !== undefined ? (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name) : undefined;
    var key = "keep";
    if (!restProps.isListField) key = "_".concat((namePath || []).join("_"));
    return /*#__PURE__*/ $acw62.createElement($3299c229146a7fb5$var$Field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        key: key,
        name: namePath,
        isListField: !!listContext
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $3299c229146a7fb5$export$2e2bcd8739ae039 = $3299c229146a7fb5$var$WrapperField;





var $acw62 = parcelRequire("acw62");





function $1ad2b0235e0eb0b7$var$List(_ref) {
    var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
    var context = $acw62.useContext((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    var wrapperListContext = $acw62.useContext((0, $f81400e90cbb2e33$export$2e2bcd8739ae039));
    var keyRef = $acw62.useRef({
        keys: [],
        id: 0
    });
    var keyManager = keyRef.current;
    var prefixName = $acw62.useMemo(function() {
        var parentPrefixName = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parentPrefixName), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name)));
    }, [
        context.prefixName,
        name
    ]);
    var fieldContext = $acw62.useMemo(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, context), {}, {
            prefixName: prefixName
        });
    }, [
        context,
        prefixName
    ]);
    // List context
    var listContext = $acw62.useMemo(function() {
        return {
            getKey: function getKey(namePath) {
                var len = prefixName.length;
                var pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        };
    }, [
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== "function") {
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Form.List only accepts function as children.");
        return null;
    }
    var shouldUpdate = function shouldUpdate(prevValue, nextValue, _ref2) {
        var source = _ref2.source;
        if (source === "internal") return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $acw62.createElement((0, $f81400e90cbb2e33$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $acw62.createElement((0, $186c9d6ed579317b$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $acw62.createElement((0, $3299c229146a7fb5$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
    }, function(_ref3, meta) {
        var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
        var getFieldValue = context.getFieldValue;
        var getNewValue = function getNewValue() {
            var values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ var operations = {
            add: function add(defaultValue, index) {
                // Mapping keys
                var newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyManager.keys.slice(0, index)), [
                        keyManager.id
                    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyManager.keys.slice(index)));
                    onChange([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(newValue.slice(0, index)), [
                        defaultValue
                    ], (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(newValue.slice(index))));
                } else {
                    keyManager.keys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyManager.keys), [
                        keyManager.id
                    ]);
                    onChange([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(newValue), [
                        defaultValue
                    ]));
                }
                keyManager.id += 1;
            },
            remove: function remove(index) {
                var newValue = getNewValue();
                var indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
                    return !indexSet.has(keysIndex);
                });
                // Trigger store change
                onChange(newValue.filter(function(_, valueIndex) {
                    return !indexSet.has(valueIndex);
                }));
            },
            move: function move(from, to) {
                if (from === to) return;
                var newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $f0c87cef6ee60bcb$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $f0c87cef6ee60bcb$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        var listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map(function(__, index) {
            var key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $1ad2b0235e0eb0b7$export$2e2bcd8739ae039 = $1ad2b0235e0eb0b7$var$List;













var $acw62 = parcelRequire("acw62");

function $1db9f053670497ce$export$6152adfdcc6be2b5(promiseList) {
    var hasError = false;
    var count = promiseList.length;
    var results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise(function(resolve, reject) {
        promiseList.forEach(function(promise, index) {
            promise.catch(function(e) {
                hasError = true;
                return e;
            }).then(function(result) {
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}









var $bae1107165a0db1c$var$SPLIT = "__@field_split__";
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $bae1107165a0db1c$var$normalize(namePath) {
    return namePath.map(function(cell) {
        return "".concat((0, $b8f57191916382d3$export$2e2bcd8739ae039)(cell), ":").concat(cell);
    })// Magic split
    .join($bae1107165a0db1c$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ var $bae1107165a0db1c$var$NameMap = /*#__PURE__*/ function() {
    function NameMap() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NameMap);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "kvs", new Map());
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NameMap, [
        {
            key: "set",
            value: function set(key, value) {
                this.kvs.set($bae1107165a0db1c$var$normalize(key), value);
            }
        },
        {
            key: "get",
            value: function get(key) {
                return this.kvs.get($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "update",
            value: function update(key, updater) {
                var origin = this.get(key);
                var next = updater(origin);
                if (!next) this.delete(key);
                else this.set(key, next);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.kvs.delete($bae1107165a0db1c$var$normalize(key));
            }
        },
        {
            key: "map",
            value: function map(callback) {
                return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(this.kvs.entries()).map(function(_ref) {
                    var _ref2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref, 2), key = _ref2[0], value = _ref2[1];
                    var cells = key.split($bae1107165a0db1c$var$SPLIT);
                    return callback({
                        key: cells.map(function(cell) {
                            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_cell$match, 3), type = _cell$match2[1], unit = _cell$match2[2];
                            return type === "number" ? Number(unit) : unit;
                        }),
                        value: value
                    });
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var json = {};
                this.map(function(_ref3) {
                    var key = _ref3.key, value = _ref3.value;
                    json[key.join(".")] = value;
                    return null;
                });
                return json;
            }
        }
    ]);
    return NameMap;
}();
var $bae1107165a0db1c$export$2e2bcd8739ae039 = $bae1107165a0db1c$var$NameMap;



var $a1708dc7c20669c0$var$_excluded = [
    "name"
];
var $a1708dc7c20669c0$export$75ff1ab1187e691 = /*#__PURE__*/ (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(function FormStore(forceRootUpdate) {
    var _this = this;
    (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, FormStore);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "formHooked", false);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "forceRootUpdate", void 0);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "subscribable", true);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "store", {});
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "fieldEntities", []);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "initialValues", {});
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "callbacks", {});
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "validateMessages", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "preserve", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "lastValidatePromise", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getForm", function() {
        return {
            getFieldValue: _this.getFieldValue,
            getFieldsValue: _this.getFieldsValue,
            getFieldError: _this.getFieldError,
            getFieldWarning: _this.getFieldWarning,
            getFieldsError: _this.getFieldsError,
            isFieldsTouched: _this.isFieldsTouched,
            isFieldTouched: _this.isFieldTouched,
            isFieldValidating: _this.isFieldValidating,
            isFieldsValidating: _this.isFieldsValidating,
            resetFields: _this.resetFields,
            setFields: _this.setFields,
            setFieldValue: _this.setFieldValue,
            setFieldsValue: _this.setFieldsValue,
            validateFields: _this.validateFields,
            submit: _this.submit,
            _init: true,
            getInternalHooks: _this.getInternalHooks
        };
    });
    // ======================== Internal Hooks ========================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getInternalHooks", function(key) {
        if (key === (0, $186c9d6ed579317b$export$24829b7c0e49e9f7)) {
            _this.formHooked = true;
            return {
                dispatch: _this.dispatch,
                initEntityValue: _this.initEntityValue,
                registerField: _this.registerField,
                useSubscribe: _this.useSubscribe,
                setInitialValues: _this.setInitialValues,
                destroyForm: _this.destroyForm,
                setCallbacks: _this.setCallbacks,
                setValidateMessages: _this.setValidateMessages,
                getFields: _this.getFields,
                setPreserve: _this.setPreserve,
                getInitialValue: _this.getInitialValue,
                registerWatch: _this.registerWatch
            };
        }
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`getInternalHooks` is internal usage. Should not call directly.");
        return null;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "useSubscribe", function(subscribable) {
        _this.subscribable = subscribable;
    });
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "prevWithoutPreserves", null);
    /**
   * First time `setInitialValues` should update store with initial value
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setInitialValues", function(initialValues, init) {
        _this.initialValues = initialValues || {};
        if (init) {
            var _this$prevWithoutPres;
            var nextStore = (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(initialValues, _this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
                var namePath = _ref.key;
                nextStore = (0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(nextStore, namePath, (0, $17fcde5782384c29$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            _this.prevWithoutPreserves = null;
            _this.updateStore(nextStore);
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "destroyForm", function(clearOnDestroy) {
        if (clearOnDestroy) // destroy form reset store
        _this.updateStore({});
        else {
            // Fill preserve fields
            var prevWithoutPreserves = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
            _this.getFieldEntities(true).forEach(function(entity) {
                if (!_this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            _this.prevWithoutPreserves = prevWithoutPreserves;
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getInitialValue", function(namePath) {
        var initValue = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(_this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(initValue) : initValue;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setCallbacks", function(callbacks) {
        _this.callbacks = callbacks;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setValidateMessages", function(validateMessages) {
        _this.validateMessages = validateMessages;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setPreserve", function(preserve) {
        _this.preserve = preserve;
    });
    // ============================= Watch ============================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "watchList", []);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "registerWatch", function(callback) {
        _this.watchList.push(callback);
        return function() {
            _this.watchList = _this.watchList.filter(function(fn) {
                return fn !== callback;
            });
        };
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "notifyWatch", function() {
        var namePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        // No need to cost perf when nothing need to watch
        if (_this.watchList.length) {
            var values = _this.getFieldsValue();
            var allValues = _this.getFieldsValue(true);
            _this.watchList.forEach(function(callback) {
                callback(values, allValues, namePath);
            });
        }
    });
    // ========================== Dev Warning =========================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "timeoutId", null);
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "warningUnhooked", function() {});
    // ============================ Store =============================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "updateStore", function(nextStore) {
        _this.store = nextStore;
    });
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldEntities", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (!pure) return _this.fieldEntities;
        return _this.fieldEntities.filter(function(field) {
            return field.getNamePath().length;
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldsMap", function() {
        var pure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var cache = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        _this.getFieldEntities(pure).forEach(function(field) {
            var namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldEntitiesForNamePathList", function(nameList) {
        if (!nameList) return _this.getFieldEntities(true);
        var cache = _this.getFieldsMap(true);
        return nameList.map(function(name) {
            var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name)
            };
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldsValue", function(nameList, filterFunc) {
        _this.warningUnhooked();
        // Fill args
        var mergedNameList;
        var mergedFilterFunc;
        var mergedStrict;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(nameList) === "object") {
            mergedStrict = nameList.strict;
            mergedFilterFunc = nameList.filter;
        }
        if (mergedNameList === true && !mergedFilterFunc) return _this.store;
        var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        var filteredNameList = [];
        fieldEntities.forEach(function(entity) {
            var _isListField, _ref3;
            var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (mergedStrict) {
                var _isList, _ref2;
                if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) return;
            } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) return;
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                var meta = "getMeta" in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        return (0, $f0c87cef6ee60bcb$export$f5be6dfb30403c59)(_this.store, filteredNameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)));
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldValue", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        return (0, $17fcde5782384c29$export$2e2bcd8739ae039)(_this.store, namePath);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldsError", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map(function(entity, index) {
            if (entity && !("INVALIDATE_NAME_PATH" in entity)) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldError", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFieldWarning", function(name) {
        _this.warningUnhooked();
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        var fieldError = _this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldsTouched", function() {
        _this.warningUnhooked();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var arg0 = args[0], arg1 = args[1];
        var namePathList;
        var isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        var fieldEntities = _this.getFieldEntities(true);
        var isFieldTouched = function isFieldTouched(field) {
            return field.isFieldTouched();
        };
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every(function(entity) {
            return isFieldTouched(entity) || entity.isList();
        }) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        var map = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        namePathList.forEach(function(shortNamePath) {
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach(function(field) {
            var fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach(function(shortNamePath) {
                if (shortNamePath.every(function(nameUnit, i) {
                    return fieldNamePath[i] === nameUnit;
                })) map.update(shortNamePath, function(list) {
                    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(list), [
                        field
                    ]);
                });
            });
        });
        // Check if NameMap value is touched
        var isNamePathListTouched = function isNamePathListTouched(entities) {
            return entities.some(isFieldTouched);
        };
        var namePathListEntities = map.map(function(_ref4) {
            var value = _ref4.value;
            return value;
        });
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldTouched", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsTouched([
            name
        ]);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldsValidating", function(nameList) {
        _this.warningUnhooked();
        var fieldEntities = _this.getFieldEntities();
        if (!nameList) return fieldEntities.some(function(testField) {
            return testField.isFieldValidating();
        });
        var namePathList = nameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
        return fieldEntities.some(function(testField) {
            var fieldNamePath = testField.getNamePath();
            return (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isFieldValidating", function(name) {
        _this.warningUnhooked();
        return _this.isFieldsValidating([
            name
        ]);
    });
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "resetWithFieldInitialValue", function() {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create cache
        var cache = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        var fieldEntities = _this.getFieldEntities(true);
        fieldEntities.forEach(function(field) {
            var initialValue = field.props.initialValue;
            var namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                var records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        var resetWithFields = function resetWithFields(entities) {
            entities.forEach(function(field) {
                var initialValue = field.props.initialValue;
                if (initialValue !== undefined) {
                    var namePath = field.getNamePath();
                    var formInitialValue = _this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
                    else {
                        var records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
                        else if (records) {
                            var originValue = _this.getFieldValue(namePath);
                            var isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(records)[0].value));
                        }
                    }
                }
            });
        };
        var requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach(function(namePath) {
                var records = cache.get(namePath);
                if (records) {
                    var _requiredFieldEntitie;
                    (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(records).map(function(r) {
                        return r.entity;
                    })));
                }
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "resetFields", function(nameList) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (!nameList) {
            _this.updateStore((0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(_this.initialValues));
            _this.resetWithFieldInitialValue();
            _this.notifyObservers(prevStore, null, {
                type: "reset"
            });
            _this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        var namePathList = nameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9));
        namePathList.forEach(function(namePath) {
            var initialValue = _this.getInitialValue(namePath);
            _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        });
        _this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        _this.notifyObservers(prevStore, namePathList, {
            type: "reset"
        });
        _this.notifyWatch(namePathList);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setFields", function(fields) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        var namePathList = [];
        fields.forEach(function(fieldData) {
            var name = fieldData.name, data = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(fieldData, $a1708dc7c20669c0$var$_excluded);
            var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ("value" in data) _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, data.value));
            _this.notifyObservers(prevStore, [
                namePath
            ], {
                type: "setField",
                data: fieldData
            });
        });
        _this.notifyWatch(namePathList);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getFields", function() {
        var entities = _this.getFieldEntities(true);
        var fields = entities.map(function(field) {
            var namePath = field.getNamePath();
            var meta = field.getMeta();
            var fieldData = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, meta), {}, {
                name: namePath,
                value: _this.getFieldValue(namePath)
            });
            Object.defineProperty(fieldData, "originRCField", {
                value: true
            });
            return fieldData;
        });
        return fields;
    });
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "initEntityValue", function(entity) {
        var initialValue = entity.props.initialValue;
        if (initialValue !== undefined) {
            var namePath = entity.getNamePath();
            var prevValue = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(_this.store, namePath);
            if (prevValue === undefined) _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, initialValue));
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "isMergedPreserve", function(fieldPreserve) {
        var mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : _this.preserve;
        return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "registerField", function(entity) {
        _this.fieldEntities.push(entity);
        var namePath = entity.getNamePath();
        _this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            var prevStore = _this.store;
            _this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            _this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: "valueUpdate",
                source: "internal"
            });
        }
        // un-register field callback
        return function(isListField, preserve) {
            var subNamePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            _this.fieldEntities = _this.fieldEntities.filter(function(item) {
                return item !== entity;
            });
            // Clean up store value if not preserve
            if (!_this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                var defaultValue = isListField ? undefined : _this.getInitialValue(namePath);
                if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
                    return(// Only reset when no namePath exist
                    !(0, $f0c87cef6ee60bcb$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath));
                })) {
                    var _prevStore = _this.store;
                    _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    _this.notifyObservers(_prevStore, [
                        namePath
                    ], {
                        type: "remove"
                    });
                    // Dependencies update
                    _this.triggerDependenciesUpdate(_prevStore, namePath);
                }
            }
            _this.notifyWatch([
                namePath
            ]);
        };
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "dispatch", function(action) {
        switch(action.type){
            case "updateValue":
                var namePath = action.namePath, value = action.value;
                _this.updateValue(namePath, value);
                break;
            case "validateField":
                var _namePath = action.namePath, triggerName = action.triggerName;
                _this.validateFields([
                    _namePath
                ], {
                    triggerName: triggerName
                });
                break;
            default:
        }
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "notifyObservers", function(prevStore, namePathList, info) {
        if (_this.subscribable) {
            var mergedInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, info), {}, {
                store: _this.getFieldsValue(true)
            });
            _this.getFieldEntities().forEach(function(_ref5) {
                var onStoreChange = _ref5.onStoreChange;
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else _this.forceRootUpdate();
    });
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
        var childrenFields = _this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) _this.validateFields(childrenFields);
        _this.notifyObservers(prevStore, childrenFields, {
            type: "dependenciesUpdate",
            relatedFields: [
                namePath
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(childrenFields))
        });
        return childrenFields;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "updateValue", function(name, value) {
        var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(name);
        var prevStore = _this.store;
        _this.updateStore((0, $4bc24eaedd2a47a4$export$2e2bcd8739ae039)(_this.store, namePath, value));
        _this.notifyObservers(prevStore, [
            namePath
        ], {
            type: "valueUpdate",
            source: "internal"
        });
        _this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        var onValuesChange = _this.callbacks.onValuesChange;
        if (onValuesChange) {
            var changedValues = (0, $f0c87cef6ee60bcb$export$f5be6dfb30403c59)(_this.store, [
                namePath
            ]);
            onValuesChange(changedValues, _this.getFieldsValue());
        }
        _this.triggerOnFieldsChange([
            namePath
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(childrenFields)));
    });
    // Let all child Field get update.
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setFieldsValue", function(store) {
        _this.warningUnhooked();
        var prevStore = _this.store;
        if (store) {
            var nextStore = (0, $4bc24eaedd2a47a4$export$4950aa0f605343fb)(_this.store, store);
            _this.updateStore(nextStore);
        }
        _this.notifyObservers(prevStore, null, {
            type: "valueUpdate",
            source: "external"
        });
        _this.notifyWatch();
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "setFieldValue", function(name, value) {
        _this.setFields([
            {
                name: name,
                value: value
            }
        ]);
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "getDependencyChildrenFields", function(rootNamePath) {
        var children = new Set();
        var childrenFields = [];
        var dependencies2fields = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ _this.getFieldEntities().forEach(function(field) {
            var dependencies = field.props.dependencies;
            (dependencies || []).forEach(function(dependency) {
                var dependencyNamePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, function() {
                    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Set();
                    fields.add(field);
                    return fields;
                });
            });
        });
        var fillChildren = function fillChildren(namePath) {
            var fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach(function(field) {
                if (!children.has(field)) {
                    children.add(field);
                    var fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    });
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
        var onFieldsChange = _this.callbacks.onFieldsChange;
        if (onFieldsChange) {
            var fields = _this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                var cache = new (0, $bae1107165a0db1c$export$2e2bcd8739ae039)();
                filedErrors.forEach(function(_ref6) {
                    var name = _ref6.name, errors = _ref6.errors;
                    cache.set(name, errors);
                });
                fields.forEach(function(field) {
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            var changedFields = fields.filter(function(_ref7) {
                var fieldName = _ref7.name;
                return (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, fieldName);
            });
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    });
    // =========================== Validate ===========================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "validateFields", function(arg1, arg2) {
        _this.warningUnhooked();
        var nameList;
        var options;
        if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        var provideNameList = !!nameList;
        var namePathList = provideNameList ? nameList.map((0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)) : [];
        // Collect result in promise list
        var promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        var TMP_SPLIT = String(Date.now());
        var validateNamePathList = new Set();
        var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
        _this.getFieldEntities(true).forEach(function(field) {
            // Add field if not provide `nameList`
            if (!provideNameList) namePathList.push(field.getNamePath());
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            var fieldNamePath = field.getNamePath();
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $f0c87cef6ee60bcb$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                var promise = field.validateRules((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                    validateMessages: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $ebfc45d3b86f29a2$export$c86b939816b8fbf8)), _this.validateMessages)
                }, options));
                // Wrap promise with field
                promiseList.push(promise.then(function() {
                    return {
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    };
                }).catch(function(ruleErrors) {
                    var _ruleErrors$forEach;
                    var mergedErrors = [];
                    var mergedWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
                        var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
                        if (warningOnly) mergedWarnings.push.apply(mergedWarnings, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                        else mergedErrors.push.apply(mergedErrors, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(errors));
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        var summaryPromise = (0, $1db9f053670497ce$export$6152adfdcc6be2b5)(promiseList);
        _this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch(function(results) {
            return results;
        }).then(function(results) {
            var resultNamePathList = results.map(function(_ref10) {
                var name = _ref10.name;
                return name;
            });
            _this.notifyObservers(_this.store, resultNamePathList, {
                type: "validateFinish"
            });
            _this.triggerOnFieldsChange(resultNamePathList, results);
        });
        var returnPromise = summaryPromise.then(function() {
            if (_this.lastValidatePromise === summaryPromise) return Promise.resolve(_this.getFieldsValue(namePathList));
            return Promise.reject([]);
        }).catch(function(results) {
            var errorList = results.filter(function(result) {
                return result && result.errors.length;
            });
            return Promise.reject({
                values: _this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: _this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch(function(e) {
            return e;
        });
        // `validating` changed. Trigger `onFieldsChange`
        var triggerNamePathList = namePathList.filter(function(namePath) {
            return validateNamePathList.has(namePath.join(TMP_SPLIT));
        });
        _this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    });
    // ============================ Submit ============================
    (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "submit", function() {
        _this.warningUnhooked();
        _this.validateFields().then(function(values) {
            var onFinish = _this.callbacks.onFinish;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch(function(e) {
            var onFinishFailed = _this.callbacks.onFinishFailed;
            if (onFinishFailed) onFinishFailed(e);
        });
    });
    this.forceRootUpdate = forceRootUpdate;
});
function $a1708dc7c20669c0$var$useForm(form) {
    var formRef = $acw62.useRef();
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), forceUpdate = _React$useState2[1];
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            var forceReRender = function forceReRender() {
                forceUpdate({});
            };
            var formStore = new $a1708dc7c20669c0$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $a1708dc7c20669c0$export$2e2bcd8739ae039 = $a1708dc7c20669c0$var$useForm;







var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
var $0c69ed761f95e1b0$var$FormContext = /*#__PURE__*/ $acw62.createContext({
    triggerFormChange: function triggerFormChange() {},
    triggerFormFinish: function triggerFormFinish() {},
    registerForm: function registerForm() {},
    unregisterForm: function unregisterForm() {}
});
var $0c69ed761f95e1b0$export$8ce1ff4f94d08846 = function FormProvider(_ref) {
    var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
    var formContext = $acw62.useContext($0c69ed761f95e1b0$var$FormContext);
    var formsRef = $acw62.useRef({});
    return /*#__PURE__*/ $acw62.createElement($0c69ed761f95e1b0$var$FormContext.Provider, {
        value: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formContext), {}, {
            validateMessages: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages),
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: function triggerFormChange(name, changedFields) {
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: function triggerFormFinish(name, values) {
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: function registerForm(name, form) {
                if (name) formsRef.current = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formsRef.current), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, name, form));
                formContext.registerForm(name, form);
            },
            unregisterForm: function unregisterForm(name) {
                var newForms = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formsRef.current);
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        })
    }, children);
};
var $0c69ed761f95e1b0$export$2e2bcd8739ae039 = $0c69ed761f95e1b0$var$FormContext;




var $7860f41d917f18d2$var$_excluded = [
    "name",
    "initialValues",
    "fields",
    "form",
    "preserve",
    "children",
    "component",
    "validateMessages",
    "validateTrigger",
    "onValuesChange",
    "onFieldsChange",
    "onFinish",
    "onFinishFailed",
    "clearOnDestroy"
];
var $7860f41d917f18d2$var$Form = function Form(_ref, ref) {
    var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, clearOnDestroy = _ref.clearOnDestroy, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $7860f41d917f18d2$var$_excluded);
    var nativeElementRef = $acw62.useRef(null);
    var formContext = $acw62.useContext((0, $0c69ed761f95e1b0$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    var _useForm = (0, $a1708dc7c20669c0$export$2e2bcd8739ae039)(form), _useForm2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useForm, 1), formInstance = _useForm2[0];
    var _getInternalHooks = formInstance.getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
    // Pass ref with form instance
    $acw62.useImperativeHandle(ref, function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formInstance), {}, {
            nativeElement: nativeElementRef.current
        });
    });
    // Register form into Context
    $acw62.useEffect(function() {
        formContext.registerForm(name, formInstance);
        return function() {
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formContext.validateMessages), validateMessages));
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: function onFieldsChange(changedFields) {
            formContext.triggerFormChange(name, changedFields);
            if (_onFieldsChange) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
                _onFieldsChange.apply(void 0, [
                    changedFields
                ].concat(rest));
            }
        },
        onFinish: function onFinish(values) {
            formContext.triggerFormFinish(name, values);
            if (_onFinish) _onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    var mountRef = $acw62.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    $acw62.useEffect(function() {
        return function() {
            return destroyForm(clearOnDestroy);
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    var childrenNode;
    var childrenRenderProps = typeof children === "function";
    if (childrenRenderProps) {
        var _values = formInstance.getFieldsValue(true);
        childrenNode = children(_values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    var prevFieldsRef = $acw62.useRef();
    $acw62.useEffect(function() {
        if (!(0, $f0c87cef6ee60bcb$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    var formContextValue = $acw62.useMemo(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, formInstance), {}, {
            validateTrigger: validateTrigger
        });
    }, [
        formInstance,
        validateTrigger
    ]);
    var wrapperNode = /*#__PURE__*/ $acw62.createElement((0, $f81400e90cbb2e33$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $186c9d6ed579317b$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        ref: nativeElementRef,
        onSubmit: function onSubmit(event) {
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: function onReset(event) {
            var _restProps$onReset;
            event.preventDefault();
            formInstance.resetFields();
            (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
        }
    }), wrapperNode);
};
var $7860f41d917f18d2$export$2e2bcd8739ae039 = $7860f41d917f18d2$var$Form;








var $acw62 = parcelRequire("acw62");



function $c40fe08ecbe59c71$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch (err) {
        return Math.random();
    }
}
var $c40fe08ecbe59c71$var$useWatchWarning = function() {};
// ------- selector type -------
// ------- selector type end -------
function $c40fe08ecbe59c71$var$useWatch() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
    var options = (0, $c9624fc8667843e4$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    var form = options.form;
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueStr = (0, $acw62.useMemo)(function() {
        return $c40fe08ecbe59c71$export$fac44ee5b035f737(value);
    }, [
        value
    ]);
    var valueStrRef = (0, $acw62.useRef)(valueStr);
    valueStrRef.current = valueStr;
    var fieldContext = (0, $acw62.useContext)((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    var formInstance = form || fieldContext;
    var isValidForm = formInstance && formInstance._init;
    var namePath = (0, $f0c87cef6ee60bcb$export$f877b3cb4cb4ccf9)(dependencies);
    var namePathRef = (0, $acw62.useRef)(namePath);
    namePathRef.current = namePath;
    $c40fe08ecbe59c71$var$useWatchWarning(namePath);
    (0, $acw62.useEffect)(function() {
        // Skip if not exist form instance
        if (!isValidForm) return;
        var getFieldsValue = formInstance.getFieldsValue, getInternalHooks = formInstance.getInternalHooks;
        var _getInternalHooks = getInternalHooks((0, $186c9d6ed579317b$export$24829b7c0e49e9f7)), registerWatch = _getInternalHooks.registerWatch;
        var getWatchValue = function getWatchValue(values, allValues) {
            var watchValue = options.preserve ? allValues : values;
            return typeof dependencies === "function" ? dependencies(watchValue) : (0, $17fcde5782384c29$export$2e2bcd8739ae039)(watchValue, namePathRef.current);
        };
        var cancelRegister = registerWatch(function(values, allValues) {
            var newValue = getWatchValue(values, allValues);
            var nextValueStr = $c40fe08ecbe59c71$export$fac44ee5b035f737(newValue);
            // Compare stringify in case it's nest object
            if (valueStrRef.current !== nextValueStr) {
                valueStrRef.current = nextValueStr;
                setValue(newValue);
            }
        });
        // TODO: We can improve this perf in future
        var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
        // React 18 has the bug that will queue update twice even the value is not changed
        // ref: https://github.com/facebook/react/issues/27213
        if (value !== initialValue) setValue(initialValue);
        return cancelRegister;
    }, // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isValidForm
    ]);
    return value;
}
var $c40fe08ecbe59c71$export$2e2bcd8739ae039 = $c40fe08ecbe59c71$var$useWatch;


var $5f1614ae44e69c1b$var$InternalForm = /*#__PURE__*/ $acw62.forwardRef((0, $7860f41d917f18d2$export$2e2bcd8739ae039));
var $5f1614ae44e69c1b$var$RefForm = $5f1614ae44e69c1b$var$InternalForm;
$5f1614ae44e69c1b$var$RefForm.FormProvider = (0, $0c69ed761f95e1b0$export$8ce1ff4f94d08846);
$5f1614ae44e69c1b$var$RefForm.Field = (0, $3299c229146a7fb5$export$2e2bcd8739ae039);
$5f1614ae44e69c1b$var$RefForm.List = (0, $1ad2b0235e0eb0b7$export$2e2bcd8739ae039);
$5f1614ae44e69c1b$var$RefForm.useForm = (0, $a1708dc7c20669c0$export$2e2bcd8739ae039);
$5f1614ae44e69c1b$var$RefForm.useWatch = (0, $c40fe08ecbe59c71$export$2e2bcd8739ae039);
var $5f1614ae44e69c1b$export$2e2bcd8739ae039 = $5f1614ae44e69c1b$var$RefForm;



"use client";
const $ad5d550b51ac8abd$export$c24727297075ec6a = /*#__PURE__*/ $acw62.createContext({
    labelAlign: "right",
    vertical: false,
    itemRef: ()=>{}
});
const $ad5d550b51ac8abd$export$d718247e9f9b0b9e = /*#__PURE__*/ $acw62.createContext(null);
const $ad5d550b51ac8abd$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "prefixCls"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $0c69ed761f95e1b0$export$8ce1ff4f94d08846), Object.assign({}, providerProps));
};
const $ad5d550b51ac8abd$export$fb6582d3042cc879 = /*#__PURE__*/ $acw62.createContext({
    prefixCls: ""
});
const $ad5d550b51ac8abd$export$bbb5553c6c7a14ed = /*#__PURE__*/ $acw62.createContext({});
const $ad5d550b51ac8abd$export$80e4c53cb85dcab1 = (_ref)=>{
    let { children: children, status: status, override: override } = _ref;
    const formItemInputContext = (0, $acw62.useContext)($ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = (0, $acw62.useMemo)(()=>{
        const newContext = Object.assign({}, formItemInputContext);
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $acw62.createElement($ad5d550b51ac8abd$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $ad5d550b51ac8abd$export$6f0555dad42725fb = /*#__PURE__*/ (0, $acw62.createContext)(undefined);



var $acw62 = parcelRequire("acw62");


/**
 * Compatible for legacy `bordered` prop.
 */ const $ce4103032ab2fd5e$var$useVariant = function(component, variant) {
    let legacyBordered = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
    var _a, _b;
    const { variant: configVariant, [component]: componentConfig } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const ctxVariant = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$6f0555dad42725fb));
    const configComponentVariant = componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.variant;
    let mergedVariant;
    if (typeof variant !== "undefined") mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = "borderless";
    else // form variant > component global variant > global variant
    mergedVariant = (_b = (_a = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : configComponentVariant) !== null && _a !== void 0 ? _a : configVariant) !== null && _b !== void 0 ? _b : "outlined";
    const enableVariantCls = (0, $a18b2f6f56546238$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
var $ce4103032ab2fd5e$export$2e2bcd8739ae039 = $ce4103032ab2fd5e$var$useVariant;



var $acw62 = parcelRequire("acw62");





const $987474def15ea51b$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-block": {
                display: "flex",
                width: "100%"
            },
            "&-vertical": {
                flexDirection: "column"
            }
        }
    };
};
var // ============================== Export ==============================
$987474def15ea51b$export$2e2bcd8739ae039 = $987474def15ea51b$var$genSpaceCompactStyle;


const $8c6cd68a6974f2d0$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: "inline-flex",
            "&-rtl": {
                direction: "rtl"
            },
            "&-vertical": {
                flexDirection: "column"
            },
            "&-align": {
                flexDirection: "column",
                "&-center": {
                    alignItems: "center"
                },
                "&-start": {
                    alignItems: "flex-start"
                },
                "&-end": {
                    alignItems: "flex-end"
                },
                "&-baseline": {
                    alignItems: "baseline"
                }
            },
            [`${componentCls}-item:empty`]: {
                display: "none"
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: "block"
            }
        }
    };
};
const $8c6cd68a6974f2d0$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-gap-row-small": {
                rowGap: token.spaceGapSmallSize
            },
            "&-gap-row-middle": {
                rowGap: token.spaceGapMiddleSize
            },
            "&-gap-row-large": {
                rowGap: token.spaceGapLargeSize
            },
            "&-gap-col-small": {
                columnGap: token.spaceGapSmallSize
            },
            "&-gap-col-middle": {
                columnGap: token.spaceGapMiddleSize
            },
            "&-gap-col-large": {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $8c6cd68a6974f2d0$export$9ca1be8807fe0675 = ()=>({});
var $8c6cd68a6974f2d0$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Space", (token)=>{
    const spaceToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $8c6cd68a6974f2d0$var$genSpaceStyle(spaceToken),
        $8c6cd68a6974f2d0$var$genSpaceGapStyle(spaceToken),
        (0, $987474def15ea51b$export$2e2bcd8739ae039)(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
var $26050ef76e24a749$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $26050ef76e24a749$export$8d1c486ac0db0a7d = /*#__PURE__*/ $acw62.createContext(null);
const $26050ef76e24a749$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $acw62.useMemo(()=>{
        if (!compactItemContext) return "";
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === "vertical" ? "-vertical-" : "-";
        return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === "rtl"
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
        compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $26050ef76e24a749$export$5f56e610a4afb685 = (_ref)=>{
    let { children: children } = _ref;
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $26050ef76e24a749$var$CompactItem = (_a)=>{
    var { children: children } = _a, otherProps = $26050ef76e24a749$var$__rest(_a, [
        "children"
    ]);
    return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$export$8d1c486ac0db0a7d.Provider, {
        value: otherProps
    }, children);
};
const $26050ef76e24a749$var$Compact = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children } = props, restProps = $26050ef76e24a749$var$__rest(props, [
        "size",
        "direction",
        "block",
        "prefixCls",
        "className",
        "rootClassName",
        "children"
    ]);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>size !== null && size !== void 0 ? size : ctx);
    const prefixCls = getPrefixCls("space-compact", customizePrefixCls);
    const [wrapCSSVar, hashId] = (0, $8c6cd68a6974f2d0$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === "rtl",
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: direction === "vertical"
    }, className, rootClassName);
    const compactItemContext = $acw62.useContext($26050ef76e24a749$export$8d1c486ac0db0a7d);
    const childNodes = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
    const nodes = $acw62.useMemo(()=>childNodes.map((child, i)=>{
            const key = (child === null || child === void 0 ? void 0 : child.key) || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $acw62.createElement($26050ef76e24a749$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: direction,
                isFirstItem: i === 0 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isFirstItem)),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || (compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.isLastItem))
            }, child);
        }), [
        size,
        childNodes,
        compactItemContext
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: clx
    }, restProps), nodes));
};
var $26050ef76e24a749$export$2e2bcd8739ae039 = $26050ef76e24a749$var$Compact;



const $5b1ac51a636fb330$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === "scroll" ? "scroll" : "visible";
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ]
        }),
        bottomRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ]
        }),
        topLeft: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ]
        }),
        topRight: Object.assign(Object.assign({}, sharedConfig), {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ]
        })
    };
};
function $5b1ac51a636fb330$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $5b1ac51a636fb330$var$getBuiltInPlacements(popupOverflow);
}
var $5b1ac51a636fb330$export$2e2bcd8739ae039 = $5b1ac51a636fb330$var$mergedBuiltinPlacements;



// handle border collapse
function $0eabbafc4673511e$var$compactItemBorder(token, parentCls, options) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? "> *" : "";
    const hoverEffects = [
        "hover",
        focus ? "focus" : null,
        "active"
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(",");
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        "&-item": Object.assign(Object.assign({
            [hoverEffects]: {
                zIndex: 2
            }
        }, focusElCls ? {
            [`&${focusElCls}`]: {
                zIndex: 2
            }
        } : {}), {
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        })
    };
}
// handle border-radius
function $0eabbafc4673511e$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : "";
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $0eabbafc4673511e$export$b1208b23589b4b73(token) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        focus: true
    };
    const { componentCls: componentCls } = token;
    const compactCls = `${componentCls}-compact`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $0eabbafc4673511e$var$compactItemBorder(token, compactCls, options)), $0eabbafc4673511e$var$compactItemBorderRadius(componentCls, compactCls, options))
    };
}





const $c05a1428f4a08fb2$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: "both"
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const $c05a1428f4a08fb2$var$initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: "both"
    });
const $c05a1428f4a08fb2$export$83e1da9e09ec9112 = function(motionCls, inKeyframes, outKeyframes, duration) {
    let sameLevel = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const sameLevelPrefix = sameLevel ? "&" : "";
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, $c05a1428f4a08fb2$var$initMotionCommon(duration)), {
            animationPlayState: "paused"
        }),
        [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, $c05a1428f4a08fb2$var$initMotionCommonLeave(duration)), {
            animationPlayState: "paused"
        }),
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: "running"
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: "running",
            pointerEvents: "none"
        }
    };
};


const $f8b44896cb986807$export$e801b802b037de6a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideUpIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$f40f41df328ebc38 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideUpOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd9f089fa5e819fe = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideDownIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$f7243fdb9c27c3b7 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideDownOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    }
});
const $f8b44896cb986807$export$2ad3a07c3513a54 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideLeftIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$486fbda27512d5a9 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideLeftOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
const $f8b44896cb986807$export$dd03ad46dbbcd7e0 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideRightIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    }
});
const $f8b44896cb986807$export$db8e3c9b93664f34 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSlideRightOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    }
});
const $f8b44896cb986807$var$slideMotion = {
    "slide-up": {
        inKeyframes: $f8b44896cb986807$export$e801b802b037de6a,
        outKeyframes: $f8b44896cb986807$export$f40f41df328ebc38
    },
    "slide-down": {
        inKeyframes: $f8b44896cb986807$export$dd9f089fa5e819fe,
        outKeyframes: $f8b44896cb986807$export$f7243fdb9c27c3b7
    },
    "slide-left": {
        inKeyframes: $f8b44896cb986807$export$2ad3a07c3513a54,
        outKeyframes: $f8b44896cb986807$export$486fbda27512d5a9
    },
    "slide-right": {
        inKeyframes: $f8b44896cb986807$export$dd03ad46dbbcd7e0,
        outKeyframes: $f8b44896cb986807$export$db8e3c9b93664f34
    }
};
const $f8b44896cb986807$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $f8b44896cb986807$var$slideMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: "scale(0)",
                transformOrigin: "0% 0%",
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                "&-prepare": {
                    transform: "scale(1)"
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};



const $103c380d878d9852$export$c81b62e088da1305 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveDownIn", {
    "0%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$6c1eca72ac4f6672 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveDownOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$export$8dd54688d033571 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveLeftIn", {
    "0%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$be161c4e647bea9b = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveLeftOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$export$a984c43131c7d145 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveRightIn", {
    "0%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$e141ac6798b476df = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveRightOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$export$ab676201eaaca05 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveUpIn", {
    "0%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $103c380d878d9852$export$ec1b91b8ec2f6331 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antMoveUpOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $103c380d878d9852$var$moveMotion = {
    "move-up": {
        inKeyframes: $103c380d878d9852$export$ab676201eaaca05,
        outKeyframes: $103c380d878d9852$export$ec1b91b8ec2f6331
    },
    "move-down": {
        inKeyframes: $103c380d878d9852$export$c81b62e088da1305,
        outKeyframes: $103c380d878d9852$export$6c1eca72ac4f6672
    },
    "move-left": {
        inKeyframes: $103c380d878d9852$export$8dd54688d033571,
        outKeyframes: $103c380d878d9852$export$be161c4e647bea9b
    },
    "move-right": {
        inKeyframes: $103c380d878d9852$export$a984c43131c7d145,
        outKeyframes: $103c380d878d9852$export$e141ac6798b476df
    }
};
const $103c380d878d9852$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $103c380d878d9852$var$moveMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};


const $879d950d114a8bdf$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: "relative",
        display: "block",
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: "normal",
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: "border-box"
    };
};
const $879d950d114a8bdf$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    return [
        {
            [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: "absolute",
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: "border-box",
                padding: token.paddingXXS,
                overflow: "hidden",
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: "initial",
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: "none",
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $f8b44896cb986807$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $f8b44896cb986807$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $f8b44896cb986807$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $f8b44896cb986807$export$f7243fdb9c27c3b7)
                },
                "&-hidden": {
                    display: "none"
                },
                [`${selectItemCls}`]: Object.assign(Object.assign({}, $879d950d114a8bdf$var$genItemStyle(token)), {
                    cursor: "pointer",
                    transition: `background ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    "&-group": {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: "default"
                    },
                    // =========== Option ===========
                    "&-option": {
                        display: "flex",
                        "&-content": Object.assign({
                            flex: "auto"
                        }, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)),
                        "&-state": {
                            flex: "none",
                            display: "flex",
                            alignItems: "center"
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            },
                            [`&:has(+ ${selectItemCls}-option-selected:not(${selectItemCls}-option-disabled))`]: {
                                borderEndStartRadius: 0,
                                borderEndEndRadius: 0,
                                [`& + ${selectItemCls}-option-selected:not(${selectItemCls}-option-disabled)`]: {
                                    borderStartStartRadius: 0,
                                    borderStartEndRadius: 0
                                }
                            }
                        },
                        "&-disabled": {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: "not-allowed"
                        },
                        "&-grouped": {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    "&-empty": Object.assign(Object.assign({}, $879d950d114a8bdf$var$genItemStyle(token)), {
                        color: token.colorTextDisabled
                    })
                }),
                // =========================== RTL ===========================
                "&-rtl": {
                    direction: "rtl"
                }
            })
        },
        // Follow code may reuse in other components
        (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, "slide-up"),
        (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, "slide-down"),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, "move-up"),
        (0, $103c380d878d9852$export$913b1b7e3288c319)(token, "move-down")
    ];
};
var $879d950d114a8bdf$export$2e2bcd8739ae039 = $879d950d114a8bdf$var$genSingleStyle;





const $4da12f0c4f4b3a28$export$aaa3604bfe071829 = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, paddingXXS: paddingXXS, lineWidth: lineWidth, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const basePadding = token.max(token.calc(paddingXXS).sub(lineWidth).equal(), 0);
    const containerPadding = token.max(token.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
    return {
        basePadding: basePadding,
        containerPadding: containerPadding,
        itemHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(multipleSelectItemHeight),
        itemLineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(multipleSelectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal())
    };
};
const $4da12f0c4f4b3a28$var$getSelectItemStyle = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, selectHeight: selectHeight, lineWidth: lineWidth } = token;
    const selectItemDist = token.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
    return selectItemDist;
};
const $4da12f0c4f4b3a28$export$b4ab9d1500d7d856 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, borderRadiusSM: borderRadiusSM, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, multipleItemColorDisabled: multipleItemColorDisabled, multipleItemBorderColorDisabled: multipleItemBorderColorDisabled, colorIcon: colorIcon, colorIconHover: colorIconHover, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    return {
        /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */ // =========================== Overflow ===========================
        [selectOverflowPrefixCls]: {
            position: "relative",
            display: "flex",
            flex: "auto",
            flexWrap: "wrap",
            maxWidth: "100%",
            "&-item": {
                flex: "none",
                alignSelf: "center",
                maxWidth: "100%",
                display: "inline-flex"
            },
            // ======================== Selections ==========================
            [`${componentCls}-selection-item`]: {
                display: "flex",
                alignSelf: "center",
                flex: "none",
                boxSizing: "border-box",
                maxWidth: "100%",
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                borderRadius: borderRadiusSM,
                cursor: "default",
                transition: `font-size ${motionDurationSlow}, line-height ${motionDurationSlow}, height ${motionDurationSlow}`,
                marginInlineEnd: token.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                paddingInlineStart: paddingXS,
                paddingInlineEnd: token.calc(paddingXS).div(2).equal(),
                [`${componentCls}-disabled&`]: {
                    color: multipleItemColorDisabled,
                    borderColor: multipleItemBorderColorDisabled,
                    cursor: "not-allowed"
                },
                // It's ok not to do this, but 24px makes bottom narrow in view should adjust
                "&-content": {
                    display: "inline-block",
                    marginInlineEnd: token.calc(paddingXS).div(2).equal(),
                    overflow: "hidden",
                    whiteSpace: "pre",
                    // fix whitespace wrapping. custom tags display all whitespace within.
                    textOverflow: "ellipsis"
                },
                "&-remove": Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()), {
                    display: "inline-flex",
                    alignItems: "center",
                    color: colorIcon,
                    fontWeight: "bold",
                    fontSize: 10,
                    lineHeight: "inherit",
                    cursor: "pointer",
                    [`> ${iconCls}`]: {
                        verticalAlign: "-0.2em"
                    },
                    "&:hover": {
                        color: colorIconHover
                    }
                })
            }
        }
    };
};
const $4da12f0c4f4b3a28$var$genSelectionStyle = (token, suffix)=>{
    const { componentCls: componentCls, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    const selectItemHeight = token.multipleSelectItemHeight;
    const selectItemDist = $4da12f0c4f4b3a28$var$getSelectItemStyle(token);
    const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
    const multipleSelectorUnit = $4da12f0c4f4b3a28$export$aaa3604bfe071829(token);
    return {
        [`${componentCls}-multiple${suffixCls}`]: Object.assign(Object.assign({}, $4da12f0c4f4b3a28$export$b4ab9d1500d7d856(token)), {
            // ========================= Selector =========================
            [`${componentCls}-selector`]: {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                height: "100%",
                // Multiple is little different that horizontal is follow the vertical
                paddingInline: multipleSelectorUnit.basePadding,
                paddingBlock: multipleSelectorUnit.containerPadding,
                borderRadius: token.borderRadius,
                [`${componentCls}-disabled&`]: {
                    background: token.multipleSelectorBgDisabled,
                    cursor: "not-allowed"
                },
                "&:after": {
                    display: "inline-block",
                    width: 0,
                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(INTERNAL_FIXED_ITEM_MARGIN)} 0`,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectItemHeight),
                    visibility: "hidden",
                    content: '"\\a0"'
                }
            },
            // ======================== Selections ========================
            [`${componentCls}-selection-item`]: {
                height: multipleSelectorUnit.itemHeight,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(multipleSelectorUnit.itemLineHeight)
            },
            // ========================== Input ==========================
            [`${selectOverflowPrefixCls}-item + ${selectOverflowPrefixCls}-item`]: {
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 0
                }
            },
            // https://github.com/ant-design/ant-design/issues/44754
            [`${selectOverflowPrefixCls}-item-suffix`]: {
                height: "100%"
            },
            [`${componentCls}-selection-search`]: {
                display: "inline-flex",
                position: "relative",
                maxWidth: "100%",
                marginInlineStart: token.calc(token.inputPaddingHorizontalBase).sub(selectItemDist).equal(),
                [`
          &-input,
          &-mirror
        `]: {
                    height: selectItemHeight,
                    fontFamily: token.fontFamily,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectItemHeight),
                    transition: `all ${token.motionDurationSlow}`
                },
                "&-input": {
                    width: "100%",
                    minWidth: 4.1 // fix search cursor missing
                },
                "&-mirror": {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: 0,
                    insetInlineEnd: "auto",
                    zIndex: 999,
                    whiteSpace: "pre",
                    // fix whitespace wrapping caused width calculation bug
                    visibility: "hidden"
                }
            },
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: {
                position: "absolute",
                top: "50%",
                insetInlineStart: token.inputPaddingHorizontalBase,
                insetInlineEnd: token.inputPaddingHorizontalBase,
                transform: "translateY(-50%)",
                transition: `all ${token.motionDurationSlow}`
            }
        })
    };
};
function $4da12f0c4f4b3a28$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls } = token;
    const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
    const rawStyle = {
        [`${componentCls}-multiple${suffixCls}`]: {
            fontSize: token.fontSize,
            // ========================= Selector =========================
            [`${componentCls}-selector`]: {
                [`${componentCls}-show-search&`]: {
                    cursor: "text"
                }
            },
            [`
        &${componentCls}-show-arrow ${componentCls}-selector,
        &${componentCls}-allow-clear ${componentCls}-selector
      `]: {
                paddingInlineEnd: token.calc(token.fontSizeIcon).add(token.controlPaddingHorizontal).equal()
            }
        }
    };
    return [
        $4da12f0c4f4b3a28$var$genSelectionStyle(token, suffix),
        rawStyle
    ];
}
const $4da12f0c4f4b3a28$var$genMultipleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const smallToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.multipleItemHeightSM,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS
    });
    const largeToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius
    });
    return [
        $4da12f0c4f4b3a28$var$genSizeStyle(token),
        // ======================== Small ========================
        $4da12f0c4f4b3a28$var$genSizeStyle(smallToken, "sm"),
        // Padding
        {
            [`${componentCls}-multiple${componentCls}-sm`]: {
                [`${componentCls}-selection-placeholder`]: {
                    insetInline: token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal()
                },
                // https://github.com/ant-design/ant-design/issues/29559
                [`${componentCls}-selection-search`]: {
                    marginInlineStart: 2 // Magic Number
                }
            }
        },
        // ======================== Large ========================
        $4da12f0c4f4b3a28$var$genSizeStyle(largeToken, "lg")
    ];
};
var $4da12f0c4f4b3a28$export$2e2bcd8739ae039 = $4da12f0c4f4b3a28$var$genMultipleStyle;





function $143140f2aef1b4ae$var$genSizeStyle(token, suffix) {
    const { componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, borderRadius: borderRadius } = token;
    const selectHeightWithoutBorder = token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal();
    const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
    return {
        [`${componentCls}-single${suffixCls}`]: {
            fontSize: token.fontSize,
            height: token.controlHeight,
            // ========================= Selector =========================
            [`${componentCls}-selector`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token, true)), {
                display: "flex",
                borderRadius: borderRadius,
                [`${componentCls}-selection-search`]: {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: inputPaddingHorizontalBase,
                    insetInlineEnd: inputPaddingHorizontalBase,
                    bottom: 0,
                    "&-input": {
                        width: "100%",
                        WebkitAppearance: "textfield"
                    }
                },
                [`
          ${componentCls}-selection-item,
          ${componentCls}-selection-placeholder
        `]: {
                    padding: 0,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectHeightWithoutBorder),
                    transition: `all ${token.motionDurationSlow}, visibility 0s`,
                    alignSelf: "center"
                },
                [`${componentCls}-selection-placeholder`]: {
                    transition: "none",
                    pointerEvents: "none"
                },
                // For common baseline align
                [[
                    "&:after",
                    /* For '' value baseline align */ `${componentCls}-selection-item:empty:after`,
                    /* For undefined value baseline align */ `${componentCls}-selection-placeholder:empty:after`
                ].join(",")]: {
                    display: "inline-block",
                    width: 0,
                    visibility: "hidden",
                    content: '"\\a0"'
                }
            }),
            [`
        &${componentCls}-show-arrow ${componentCls}-selection-item,
        &${componentCls}-show-arrow ${componentCls}-selection-placeholder
      `]: {
                paddingInlineEnd: token.showArrowPaddingInlineEnd
            },
            // Opacity selection if open
            [`&${componentCls}-open ${componentCls}-selection-item`]: {
                color: token.colorTextPlaceholder
            },
            // ========================== Input ==========================
            // We only change the style of non-customize input which is only support by `combobox` mode.
            // Not customize
            [`&:not(${componentCls}-customize-input)`]: {
                [`${componentCls}-selector`]: {
                    width: "100%",
                    height: "100%",
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputPaddingHorizontalBase)}`,
                    [`${componentCls}-selection-search-input`]: {
                        height: selectHeightWithoutBorder
                    },
                    "&:after": {
                        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(selectHeightWithoutBorder)
                    }
                }
            },
            [`&${componentCls}-customize-input`]: {
                [`${componentCls}-selector`]: {
                    "&:after": {
                        display: "none"
                    },
                    [`${componentCls}-selection-search`]: {
                        position: "static",
                        width: "100%"
                    },
                    [`${componentCls}-selection-placeholder`]: {
                        position: "absolute",
                        insetInlineStart: 0,
                        insetInlineEnd: 0,
                        padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputPaddingHorizontalBase)}`,
                        "&:after": {
                            display: "none"
                        }
                    }
                }
            }
        }
    };
}
function $143140f2aef1b4ae$export$2e2bcd8739ae039(token) {
    const { componentCls: componentCls } = token;
    const inputPaddingHorizontalSM = token.calc(token.controlPaddingHorizontalSM).sub(token.lineWidth).equal();
    return [
        $143140f2aef1b4ae$var$genSizeStyle(token),
        // ======================== Small ========================
        // Shared
        $143140f2aef1b4ae$var$genSizeStyle((0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
            controlHeight: token.controlHeightSM,
            borderRadius: token.borderRadiusSM
        }), "sm"),
        // padding
        {
            [`${componentCls}-single${componentCls}-sm`]: {
                [`&:not(${componentCls}-customize-input)`]: {
                    [`${componentCls}-selection-search`]: {
                        insetInlineStart: inputPaddingHorizontalSM,
                        insetInlineEnd: inputPaddingHorizontalSM
                    },
                    [`${componentCls}-selector`]: {
                        padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputPaddingHorizontalSM)}`
                    },
                    // With arrow should provides `padding-right` to show the arrow
                    [`&${componentCls}-show-arrow ${componentCls}-selection-search`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalSM).add(token.calc(token.fontSize).mul(1.5)).equal()
                    },
                    [`
            &${componentCls}-show-arrow ${componentCls}-selection-item,
            &${componentCls}-show-arrow ${componentCls}-selection-placeholder
          `]: {
                        paddingInlineEnd: token.calc(token.fontSize).mul(1.5).equal()
                    }
                }
            }
        },
        // ======================== Large ========================
        // Shared
        $143140f2aef1b4ae$var$genSizeStyle((0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
            controlHeight: token.singleItemHeightLG,
            fontSize: token.fontSizeLG,
            borderRadius: token.borderRadiusLG
        }), "lg")
    ];
}


const $59698eaa3035fee4$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    return {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: "transparent",
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: "transparent",
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25)
    };
};



// =====================================================
// ==                  Outlined                       ==
// =====================================================
const $21a514116ba998e4$var$genBaseOutlinedStyle = (token, options)=>{
    const { componentCls: componentCls, antCls: antCls, controlOutlineWidth: controlOutlineWidth } = token;
    return {
        [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${options.borderColor}`,
            background: token.selectorBg
        },
        [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`&:hover ${componentCls}-selector`]: {
                borderColor: options.hoverBorderHover
            },
            [`${componentCls}-focused& ${componentCls}-selector`]: {
                borderColor: options.activeBorderColor,
                boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlOutlineWidth)} ${options.activeShadowColor}`,
                outline: 0
            }
        }
    };
};
const $21a514116ba998e4$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, $21a514116ba998e4$var$genBaseOutlinedStyle(token, options))
    });
const $21a514116ba998e4$var$genOutlinedStyle = (token)=>({
        "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, $21a514116ba998e4$var$genBaseOutlinedStyle(token, {
            borderColor: token.colorBorder,
            hoverBorderHover: token.colorPrimaryHover,
            activeBorderColor: token.colorPrimary,
            activeShadowColor: token.controlOutline
        })), $21a514116ba998e4$var$genOutlinedStatusStyle(token, {
            status: "error",
            borderColor: token.colorError,
            hoverBorderHover: token.colorErrorHover,
            activeBorderColor: token.colorError,
            activeShadowColor: token.colorErrorOutline
        })), $21a514116ba998e4$var$genOutlinedStatusStyle(token, {
            status: "warning",
            borderColor: token.colorWarning,
            hoverBorderHover: token.colorWarningHover,
            activeBorderColor: token.colorWarning,
            activeShadowColor: token.colorWarningOutline
        })), {
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.multipleItemBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
            }
        })
    });
// =====================================================
// ==                   Filled                        ==
// =====================================================
const $21a514116ba998e4$var$genBaseFilledStyle = (token, options)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
            background: options.bg,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            color: options.color
        },
        [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`&:hover ${componentCls}-selector`]: {
                background: options.hoverBg
            },
            [`${componentCls}-focused& ${componentCls}-selector`]: {
                background: token.selectorBg,
                borderColor: options.activeBorderColor,
                outline: 0
            }
        }
    };
};
const $21a514116ba998e4$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}`]: Object.assign({}, $21a514116ba998e4$var$genBaseFilledStyle(token, options))
    });
const $21a514116ba998e4$var$genFilledStyle = (token)=>({
        "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, $21a514116ba998e4$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.colorPrimary,
            color: token.colorText
        })), $21a514116ba998e4$var$genFilledStatusStyle(token, {
            status: "error",
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            color: token.colorError
        })), $21a514116ba998e4$var$genFilledStatusStyle(token, {
            status: "warning",
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            color: token.colorWarning
        })), {
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    borderColor: token.colorBorder,
                    background: token.colorBgContainerDisabled,
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.colorBgContainer,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
            }
        })
    });
// =====================================================
// ==                 Borderless                      ==
// =====================================================
const $21a514116ba998e4$var$genBorderlessStyle = (token)=>({
        "&-borderless": {
            [`${token.componentCls}-selector`]: {
                background: "transparent",
                borderColor: "transparent"
            },
            [`&${token.componentCls}-disabled`]: {
                [`&:not(${token.componentCls}-customize-input) ${token.componentCls}-selector`]: {
                    color: token.colorTextDisabled
                }
            },
            [`&${token.componentCls}-multiple ${token.componentCls}-selection-item`]: {
                background: token.multipleItemBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
            },
            // Status
            [`&${token.componentCls}-status-error`]: {
                [`${token.componentCls}-selection-item`]: {
                    color: token.colorError
                }
            },
            [`&${token.componentCls}-status-warning`]: {
                [`${token.componentCls}-selection-item`]: {
                    color: token.colorWarning
                }
            }
        }
    });
const $21a514116ba998e4$var$genVariantsStyle = (token)=>({
        [token.componentCls]: Object.assign(Object.assign(Object.assign({}, $21a514116ba998e4$var$genOutlinedStyle(token)), $21a514116ba998e4$var$genFilledStyle(token)), $21a514116ba998e4$var$genBorderlessStyle(token))
    });
var $21a514116ba998e4$export$2e2bcd8739ae039 = $21a514116ba998e4$var$genVariantsStyle;


// ============================= Selector =============================
const $62a9ef7c3b113a0f$var$genSelectorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        position: "relative",
        transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
        input: {
            cursor: "pointer"
        },
        [`${componentCls}-show-search&`]: {
            cursor: "text",
            input: {
                cursor: "auto",
                color: "inherit",
                height: "100%"
            }
        },
        [`${componentCls}-disabled&`]: {
            cursor: "not-allowed",
            input: {
                cursor: "not-allowed"
            }
        }
    };
};
// ============================== Styles ==============================
// /* Reset search input style */
const $62a9ef7c3b113a0f$var$getSearchInputWithoutBorderStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-selection-search-input`]: {
            margin: 0,
            padding: 0,
            background: "transparent",
            border: "none",
            outline: "none",
            appearance: "none",
            fontFamily: "inherit",
            "&::-webkit-search-cancel-button": {
                display: "none",
                "-webkit-appearance": "none"
            }
        }
    };
};
// =============================== Base ===============================
const $62a9ef7c3b113a0f$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, inputPaddingHorizontalBase: inputPaddingHorizontalBase, iconCls: iconCls } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "relative",
            display: "inline-block",
            cursor: "pointer",
            [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: Object.assign(Object.assign({}, $62a9ef7c3b113a0f$var$genSelectorStyle(token)), $62a9ef7c3b113a0f$var$getSearchInputWithoutBorderStyle(token)),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: Object.assign(Object.assign({
                flex: 1,
                fontWeight: "normal",
                position: "relative",
                userSelect: "none"
            }, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: "inline"
                }
            }),
            // ======================= Placeholder =======================
            [`${componentCls}-selection-placeholder`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                flex: 1,
                color: token.colorTextPlaceholder,
                pointerEvents: "none"
            }),
            // ========================== Arrow ==========================
            [`${componentCls}-arrow`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()), {
                position: "absolute",
                top: "50%",
                insetInlineStart: "auto",
                insetInlineEnd: inputPaddingHorizontalBase,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                lineHeight: 1,
                textAlign: "center",
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                transition: `opacity ${token.motionDurationSlow} ease`,
                [iconCls]: {
                    verticalAlign: "top",
                    transition: `transform ${token.motionDurationSlow}`,
                    "> svg": {
                        verticalAlign: "top"
                    },
                    [`&:not(${componentCls}-suffix)`]: {
                        pointerEvents: "auto"
                    }
                },
                [`${componentCls}-disabled &`]: {
                    cursor: "not-allowed"
                },
                "> *:not(:last-child)": {
                    marginInlineEnd: 8 // FIXME: magic
                }
            }),
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: "absolute",
                top: "50%",
                insetInlineStart: "auto",
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: "inline-block",
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontStyle: "normal",
                lineHeight: 1,
                textAlign: "center",
                textTransform: "none",
                cursor: "pointer",
                opacity: 0,
                transition: `color ${token.motionDurationMid} ease, opacity ${token.motionDurationSlow} ease`,
                textRendering: "auto",
                "&:before": {
                    display: "block"
                },
                "&:hover": {
                    color: token.colorTextTertiary
                }
            },
            "&:hover": {
                [`${componentCls}-clear`]: {
                    opacity: 1
                },
                // Should use the following selector, but since `:has` has poor compatibility,
                // we use `:not(:last-child)` instead, which may cause some problems in some cases.
                // [`${componentCls}-arrow:has(+ ${componentCls}-clear)`]: {
                [`${componentCls}-arrow:not(:last-child)`]: {
                    opacity: 0
                }
            }
        }),
        // ========================= Feedback ==========================
        [`${componentCls}-has-feedback`]: {
            [`${componentCls}-clear`]: {
                insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
            }
        }
    };
};
// ============================== Styles ==============================
const $62a9ef7c3b113a0f$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: "100%"
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $62a9ef7c3b113a0f$var$genBaseStyle(token),
        // Single
        (0, $143140f2aef1b4ae$export$2e2bcd8739ae039)(token),
        // Multiple
        (0, $4da12f0c4f4b3a28$export$2e2bcd8739ae039)(token),
        // Dropdown
        (0, $879d950d114a8bdf$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: "rtl"
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(token, {
            borderElCls: `${componentCls}-selector`,
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$62a9ef7c3b113a0f$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Select", (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const selectToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $62a9ef7c3b113a0f$var$genSelectStyle(selectToken),
        (0, $21a514116ba998e4$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $59698eaa3035fee4$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $94b215ba0d5fdf99$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
var $94b215ba0d5fdf99$export$2e2bcd8739ae039 = $94b215ba0d5fdf99$var$CheckOutlined;



var $731042e70a6ddd3b$var$CheckOutlined = function CheckOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $94b215ba0d5fdf99$export$2e2bcd8739ae039)
    }));
};
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ var $731042e70a6ddd3b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($731042e70a6ddd3b$var$CheckOutlined);
var $731042e70a6ddd3b$export$2e2bcd8739ae039 = $731042e70a6ddd3b$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0c349e8b6d22460f$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
var $0c349e8b6d22460f$export$2e2bcd8739ae039 = $0c349e8b6d22460f$var$CloseCircleFilled;



var $81ff9dc68eb84eda$var$CloseCircleFilled = function CloseCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0c349e8b6d22460f$export$2e2bcd8739ae039)
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ var $81ff9dc68eb84eda$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($81ff9dc68eb84eda$var$CloseCircleFilled);
var $81ff9dc68eb84eda$export$2e2bcd8739ae039 = $81ff9dc68eb84eda$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $91321edc6c28da63$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
var $91321edc6c28da63$export$2e2bcd8739ae039 = $91321edc6c28da63$var$CloseOutlined;



var $06f117eb9481f34c$var$CloseOutlined = function CloseOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $91321edc6c28da63$export$2e2bcd8739ae039)
    }));
};
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ var $06f117eb9481f34c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($06f117eb9481f34c$var$CloseOutlined);
var $06f117eb9481f34c$export$2e2bcd8739ae039 = $06f117eb9481f34c$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4785c2fd6b878d9a$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
var $4785c2fd6b878d9a$export$2e2bcd8739ae039 = $4785c2fd6b878d9a$var$DownOutlined;



var $9387210f6c0d2379$var$DownOutlined = function DownOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4785c2fd6b878d9a$export$2e2bcd8739ae039)
    }));
};
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ var $9387210f6c0d2379$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9387210f6c0d2379$var$DownOutlined);
var $9387210f6c0d2379$export$2e2bcd8739ae039 = $9387210f6c0d2379$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $2b0f3084756e08d0$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
var $2b0f3084756e08d0$export$2e2bcd8739ae039 = $2b0f3084756e08d0$var$LoadingOutlined;



var $d8d56e1090f62915$var$LoadingOutlined = function LoadingOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $2b0f3084756e08d0$export$2e2bcd8739ae039)
    }));
};
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ var $d8d56e1090f62915$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d8d56e1090f62915$var$LoadingOutlined);
var $d8d56e1090f62915$export$2e2bcd8739ae039 = $d8d56e1090f62915$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $86af1367b2b71ab8$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
var $86af1367b2b71ab8$export$2e2bcd8739ae039 = $86af1367b2b71ab8$var$SearchOutlined;



var $f7392a88184334dd$var$SearchOutlined = function SearchOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $86af1367b2b71ab8$export$2e2bcd8739ae039)
    }));
};
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ var $f7392a88184334dd$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f7392a88184334dd$var$SearchOutlined);
var $f7392a88184334dd$export$2e2bcd8739ae039 = $f7392a88184334dd$var$RefIcon;



"use client";
function $f15feb4dca87ef73$export$2e2bcd8739ae039(_ref) {
    let { suffixIcon: suffixIcon, clearIcon: clearIcon, menuItemSelectedIcon: menuItemSelectedIcon, removeIcon: removeIcon, loading: loading, multiple: multiple, hasFeedback: hasFeedback, prefixCls: prefixCls, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName } = _ref;
    // Clear Icon
    const mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        spin: true
    }));
    else {
        const iconCls = `${prefixCls}-suffix`;
        mergedSuffixIcon = (_ref2)=>{
            let { open: open, showSearch: showSearch } = _ref2;
            if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), {
                className: iconCls
            }));
            return getSuffixIconNode(/*#__PURE__*/ $acw62.createElement((0, $9387210f6c0d2379$export$2e2bcd8739ae039), {
                className: iconCls
            }));
        };
    }
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null);
    return {
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $ce5709ba38c89ca7$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
var $1b56c179e5783cdb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
const $1b56c179e5783cdb$var$InternalSelect = (props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount } = props, rest = $1b56c179e5783cdb$var$__rest(props, [
        "prefixCls",
        "bordered",
        "className",
        "rootClassName",
        "getPopupContainer",
        "popupClassName",
        "dropdownClassName",
        "listHeight",
        "placement",
        "listItemHeight",
        "size",
        "disabled",
        "notFoundContent",
        "status",
        "builtinPlacements",
        "dropdownMatchSelectWidth",
        "popupMatchSelectWidth",
        "direction",
        "style",
        "allowClear",
        "variant",
        "dropdownStyle",
        "transitionName",
        "tagRender",
        "maxCount"
    ]);
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow, select: select } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : token === null || token === void 0 ? void 0 : token.controlHeight;
    const prefixCls = getPrefixCls("select", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)("select", customizeVariant, bordered);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $62a9ef7c3b113a0f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $acw62.useMemo(()=>{
        const { mode: m } = props;
        if (m === "combobox") return undefined;
        if (m === $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return "combobox";
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === "multiple" || mode === "tags";
    const showSuffixIcon = (0, $ce5709ba38c89ca7$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = (_a = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : contextPopupMatchSelectWidth;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === "combobox") mergedNotFound = null;
    else mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Select")) || /*#__PURE__*/ $acw62.createElement((0, $3feb83783705e448$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: clearIcon } = (0, $f15feb4dca87ef73$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, rest), {
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: "Select"
    }));
    const mergedAllowClear = allowClear === true ? {
        clearIcon: clearIcon
    } : allowClear;
    const selectProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(rest, [
        "suffixIcon",
        "itemIcon"
    ]);
    const mergedPopupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(popupClassName || dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === "rtl"
    }, rootClassName, cssVarCls, rootCls, hashId);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-lg`]: mergedSize === "large",
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, select === null || select === void 0 ? void 0 : select.className, className, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $acw62.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === "rtl" ? "bottomRight" : "bottomLeft";
    }, [
        placement,
        direction
    ]);
    // ====================== zIndex =========================
    const [zIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("SelectLike", dropdownStyle === null || dropdownStyle === void 0 ? void 0 : dropdownStyle.zIndex);
    // ====================== Render =======================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $65dbbed9df0fecca$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        virtual: virtual,
        showSearch: select === null || select === void 0 ? void 0 : select.showSearch
    }, selectProps, {
        style: Object.assign(Object.assign({}, select === null || select === void 0 ? void 0 : select.style), style),
        dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "slide-up", transitionName),
        builtinPlacements: (0, $5b1ac51a636fb330$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        dropdownClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        dropdownStyle: Object.assign(Object.assign({}, dropdownStyle), {
            zIndex: zIndex
        }),
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined
    })));
};
const $1b56c179e5783cdb$var$Select = /*#__PURE__*/ $acw62.forwardRef($1b56c179e5783cdb$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $1b56c179e5783cdb$var$PurePanel = (0, $91653a8941ab7768$export$2e2bcd8739ae039)($1b56c179e5783cdb$var$Select);
$1b56c179e5783cdb$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $1b56c179e5783cdb$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$1b56c179e5783cdb$var$Select.Option = (0, $2f79e5076b69401d$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select.OptGroup = (0, $cb22e94bdb4eaaa5$export$2e2bcd8739ae039);
$1b56c179e5783cdb$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $1b56c179e5783cdb$var$PurePanel;
var $1b56c179e5783cdb$export$2e2bcd8739ae039 = $1b56c179e5783cdb$var$Select;


"use client";
const $4a2c5bf3f536e529$export$40e3292f13ea8c60 = (props)=>/*#__PURE__*/ $acw62.createElement((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), Object.assign({}, props, {
        showSearch: true,
        size: "small"
    }));
const $4a2c5bf3f536e529$export$c1344b3dabe19d01 = (props)=>/*#__PURE__*/ $acw62.createElement((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), Object.assign({}, props, {
        showSearch: true,
        size: "middle"
    }));
$4a2c5bf3f536e529$export$40e3292f13ea8c60.Option = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option;
$4a2c5bf3f536e529$export$c1344b3dabe19d01.Option = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option;








function $500d0ae39d0ead62$export$a157d95850191a12(token) {
    return (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $500d0ae39d0ead62$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer } = token;
    return {
        paddingBlock: Math.max(Math.round((controlHeight - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockSM: Math.max(Math.round((controlHeightSM - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
        paddingBlockLG: Math.ceil((controlHeightLG - fontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth,
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: fontSize,
        inputFontSizeLG: fontSizeLG,
        inputFontSizeSM: fontSize
    };
};




const $26df503c9b7ea2eb$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $26df503c9b7ea2eb$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: "none",
        cursor: "not-allowed",
        opacity: 1,
        "input[disabled], textarea[disabled]": {
            cursor: "not-allowed"
        },
        "&:hover:not([disabled])": Object.assign({}, $26df503c9b7ea2eb$export$bf820fba296f2fd8((0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
            hoverBorderColor: token.colorBorder,
            hoverBg: token.colorBgContainerDisabled
        })))
    });
const $26df503c9b7ea2eb$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        "&:hover": {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        "&:focus, &:focus-within": {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $26df503c9b7ea2eb$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $26df503c9b7ea2eb$export$8c569e4cc3fd115f(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }),
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $26df503c9b7ea2eb$export$53795bafd774ce02 = (token, extraStyles)=>({
        "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $26df503c9b7ea2eb$export$8c569e4cc3fd115f(token, {
            borderColor: token.colorBorder,
            hoverBorderColor: token.hoverBorderColor,
            activeBorderColor: token.activeBorderColor,
            activeShadow: token.activeShadow
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $26df503c9b7ea2eb$export$12789f962d420a93(token))
        }), $26df503c9b7ea2eb$var$genOutlinedStatusStyle(token, {
            status: "error",
            borderColor: token.colorError,
            hoverBorderColor: token.colorErrorBorderHover,
            activeBorderColor: token.colorError,
            activeShadow: token.errorActiveShadow,
            affixColor: token.colorError
        })), $26df503c9b7ea2eb$var$genOutlinedStatusStyle(token, {
            status: "warning",
            borderColor: token.colorWarning,
            hoverBorderColor: token.colorWarningBorderHover,
            activeBorderColor: token.colorWarning,
            activeShadow: token.warningActiveShadow,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $26df503c9b7ea2eb$export$8f88f32c046ff727 = (token)=>({
        "&-outlined": Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                "&-addon": {
                    background: token.addonBg,
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                "&-addon:first-child": {
                    borderInlineEnd: 0
                },
                "&-addon:last-child": {
                    borderInlineStart: 0
                }
            }
        }, $26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle(token, {
            status: "error",
            addonBorderColor: token.colorError,
            addonColor: token.colorErrorText
        })), $26df503c9b7ea2eb$var$genOutlinedGroupStatusStyle(token, {
            status: "warning",
            addonBorderColor: token.colorWarning,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: Object.assign({}, $26df503c9b7ea2eb$export$12789f962d420a93(token))
            }
        })
    });
const $26df503c9b7ea2eb$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        "&-borderless": Object.assign({
            background: "transparent",
            border: "none",
            "&:focus, &:focus-within": {
                outline: "none"
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                "&, & input, & textarea": {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                "&, & input, & textarea": {
                    color: token.colorWarning
                }
            }
        }, extraStyles)
    };
};
/* ============== Filled ============== */ const $26df503c9b7ea2eb$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: "transparent",
        "input&, & input, textarea&, & textarea": {
            color: options === null || options === void 0 ? void 0 : options.inputColor
        },
        "&:hover": {
            background: options.hoverBg
        },
        "&:focus, &:focus-within": {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $26df503c9b7ea2eb$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: Object.assign(Object.assign({}, $26df503c9b7ea2eb$var$genBaseFilledStyle(token, options)), {
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        })
    });
const $26df503c9b7ea2eb$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $26df503c9b7ea2eb$var$genBaseFilledStyle(token, {
            bg: token.colorFillTertiary,
            hoverBg: token.colorFillSecondary,
            activeBorderColor: token.activeBorderColor
        })), {
            [`&${token.componentCls}-disabled, &[disabled]`]: Object.assign({}, $26df503c9b7ea2eb$export$12789f962d420a93(token))
        }), $26df503c9b7ea2eb$var$genFilledStatusStyle(token, {
            status: "error",
            bg: token.colorErrorBg,
            hoverBg: token.colorErrorBgHover,
            activeBorderColor: token.colorError,
            inputColor: token.colorErrorText,
            affixColor: token.colorError
        })), $26df503c9b7ea2eb$var$genFilledStatusStyle(token, {
            status: "warning",
            bg: token.colorWarningBg,
            hoverBg: token.colorWarningBgHover,
            activeBorderColor: token.colorWarning,
            inputColor: token.colorWarningText,
            affixColor: token.colorWarning
        })), extraStyles)
    });
const $26df503c9b7ea2eb$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $26df503c9b7ea2eb$export$542c0fce51b1d515 = (token)=>({
        "&-filled": Object.assign(Object.assign(Object.assign({
            [`${token.componentCls}-group`]: {
                "&-addon": {
                    background: token.colorFillTertiary
                },
                [`${token.componentCls}-filled:not(:focus):not(:focus-within)`]: {
                    "&:not(:first-child)": {
                        borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    },
                    "&:not(:last-child)": {
                        borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    }
                }
            }
        }, $26df503c9b7ea2eb$var$genFilledGroupStatusStyle(token, {
            status: "error",
            addonBg: token.colorErrorBg,
            addonColor: token.colorErrorText
        })), $26df503c9b7ea2eb$var$genFilledGroupStatusStyle(token, {
            status: "warning",
            addonBg: token.colorWarningBg,
            addonColor: token.colorWarningText
        })), {
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    "&-addon": {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    "&-addon:first-child": {
                        borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    "&-addon:last-child": {
                        borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        })
    });


const $232788b5c0fca573$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        "&::-moz-placeholder": {
            opacity: 1
        },
        "&::placeholder": {
            color: color,
            userSelect: "none" // https://github.com/ant-design/ant-design/pull/32639
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        }
    });
const $232788b5c0fca573$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $232788b5c0fca573$var$genInputLargeStyle = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlockLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $232788b5c0fca573$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingBlockSM)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $232788b5c0fca573$export$8c9a381315f3ebcd = (token)=>Object.assign(Object.assign({
        position: "relative",
        display: "inline-block",
        width: "100%",
        minWidth: 0,
        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`
    }, $232788b5c0fca573$export$92095d0f4c77bd56(token.colorTextPlaceholder)), {
        // Reset height for `textarea`s
        "textarea&": {
            maxWidth: "100%",
            // prevent textarea resize from coming out of its container
            height: "auto",
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: "bottom",
            transition: `all ${token.motionDurationSlow}, height 0s`,
            resize: "vertical"
        },
        // Size
        "&-lg": Object.assign({}, $232788b5c0fca573$var$genInputLargeStyle(token)),
        "&-sm": Object.assign({}, $232788b5c0fca573$export$bb047f62c5a56f90(token)),
        // RTL
        "&-rtl, &-textarea-rtl": {
            direction: "rtl"
        }
    });
const $232788b5c0fca573$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: "relative",
        display: "table",
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            "&:last-child": {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, $232788b5c0fca573$var$genInputLargeStyle(token)),
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, $232788b5c0fca573$export$bb047f62c5a56f90(token)),
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: "table-cell",
            "&:not(:first-child):not(:last-child)": {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            "&-addon, &-wrap": {
                display: "table-cell",
                width: 1,
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                "&:not(:first-child):not(:last-child)": {
                    borderRadius: 0
                }
            },
            "&-wrap > *": {
                display: "block !important"
            },
            "&-addon": {
                position: "relative",
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: "normal",
                fontSize: token.inputFontSize,
                textAlign: "center",
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        [`${antCls}-select-selector`]: {
                            backgroundColor: "inherit",
                            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                            boxShadow: "none"
                        }
                    },
                    "&-open, &-focused": {
                        [`${antCls}-select-selector`]: {
                            color: token.colorPrimary
                        }
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: "transparent",
                    [`${antCls}-cascader-input`]: {
                        textAlign: "start",
                        border: 0,
                        boxShadow: "none"
                    }
                }
            }
        },
        [`${componentCls}`]: {
            width: "100%",
            marginBottom: 0,
            textAlign: "inherit",
            "&:focus": {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            "&:hover": {
                zIndex: 1,
                borderInlineEndWidth: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select ${antCls}-select-selector`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            "&:not(:last-child)": {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0,
                [`${componentCls}-search &`]: {
                    borderStartStartRadius: token.borderRadius,
                    borderEndStartRadius: token.borderRadius
                }
            },
            [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
            display: "block"
        }, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                "&:not(:first-child):not(:last-child)": {
                    borderInlineEndWidth: token.lineWidth,
                    "&:hover, &:focus": {
                        zIndex: 1
                    }
                }
            },
            "& > *": {
                display: "inline-flex",
                float: "none",
                verticalAlign: "top",
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: "inline-flex"
            },
            "& > *:not(:last-child)": {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [`${componentCls}`]: {
                float: "none"
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                "&:hover, &:focus": {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: "top"
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                    borderRadius: 0
                }
            },
            [`${componentCls}-group-wrapper:not(:last-child)`]: {
                [`&${componentCls}-search > ${componentCls}-group`]: {
                    [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
                        borderRadius: 0
                    },
                    [`& > ${componentCls}`]: {
                        borderStartStartRadius: token.borderRadius,
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0,
                        borderEndStartRadius: token.borderRadius
                    }
                }
            }
        })
    };
};
const $232788b5c0fca573$var$genInputStyle = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), $232788b5c0fca573$export$8c9a381315f3ebcd(token)), (0, $26df503c9b7ea2eb$export$53795bafd774ce02)(token)), (0, $26df503c9b7ea2eb$export$b8365cd7e6671d79)(token)), (0, $26df503c9b7ea2eb$export$b6de5da7f39edfcb)(token)), {
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                "-webkit-appearance": "none"
            }
        })
    };
};
const $232788b5c0fca573$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: "pointer",
            transition: `color ${token.motionDurationSlow}`,
            "&:hover": {
                color: token.colorTextTertiary
            },
            "&:active": {
                color: token.colorText
            },
            "&-hidden": {
                visibility: "hidden"
            },
            "&-has-suffix": {
                margin: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.inputAffixPadding)}`
            }
        }
    };
};
const $232788b5c0fca573$var$genAffixStyle = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover, iconCls: iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    return {
        [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, $232788b5c0fca573$export$8c9a381315f3ebcd(token)), {
            display: "inline-flex",
            [`&:not(${componentCls}-disabled):hover`]: {
                zIndex: 1,
                [`${componentCls}-search-with-button &`]: {
                    zIndex: 0
                }
            },
            "&-focused, &:focus": {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: "inherit",
                border: "none",
                borderRadius: 0,
                outline: "none",
                background: "transparent",
                color: "inherit",
                "&::-ms-reveal": {
                    display: "none"
                },
                "&:focus": {
                    boxShadow: "none !important"
                }
            },
            "&::before": {
                display: "inline-block",
                width: 0,
                visibility: "hidden",
                content: '"\\a0"'
            },
            [`${componentCls}`]: {
                "&-prefix, &-suffix": {
                    display: "flex",
                    flex: "none",
                    alignItems: "center",
                    "> *:not(:last-child)": {
                        marginInlineEnd: token.paddingXS
                    }
                },
                "&-show-count-suffix": {
                    color: colorTextDescription
                },
                "&-show-count-has-suffix": {
                    marginInlineEnd: token.paddingXXS
                },
                "&-prefix": {
                    marginInlineEnd: inputAffixPadding
                },
                "&-suffix": {
                    marginInlineStart: inputAffixPadding
                }
            }
        }), $232788b5c0fca573$var$genAllowClearStyle(token)), {
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: "pointer",
                transition: `all ${motionDurationSlow}`,
                "&:hover": {
                    color: colorIconHover
                }
            }
        })
    };
};
const $232788b5c0fca573$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), $232788b5c0fca573$export$ffe8b2a9bd2e5cfe(token)), {
            "&-rtl": {
                direction: "rtl"
            },
            "&-wrapper": Object.assign(Object.assign(Object.assign({
                display: "inline-block",
                width: "100%",
                textAlign: "start",
                verticalAlign: "top",
                "&-rtl": {
                    direction: "rtl"
                },
                // Size
                "&-lg": {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                "&-sm": {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                }
            }, (0, $26df503c9b7ea2eb$export$8f88f32c046ff727)(token)), (0, $26df503c9b7ea2eb$export$542c0fce51b1d515)(token)), {
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                }
            })
        })
    };
};
const $232788b5c0fca573$var$genSearchInputStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const searchPrefixCls = `${componentCls}-search`;
    return {
        [searchPrefixCls]: {
            [`${componentCls}`]: {
                "&:hover, &:focus": {
                    borderColor: token.colorPrimaryHover,
                    [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        borderInlineStartColor: token.colorPrimaryHover
                    }
                }
            },
            [`${componentCls}-affix-wrapper`]: {
                borderRadius: 0
            },
            // fix slight height diff in Firefox:
            // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
            [`${componentCls}-lg`]: {
                lineHeight: token.calc(token.lineHeightLG).sub(0.0002).equal()
            },
            [`> ${componentCls}-group`]: {
                [`> ${componentCls}-group-addon:last-child`]: {
                    insetInlineStart: -1,
                    padding: 0,
                    border: 0,
                    [`${searchPrefixCls}-button`]: {
                        // Fix https://github.com/ant-design/ant-design/issues/47150
                        marginInlineEnd: -1,
                        paddingTop: 0,
                        paddingBottom: 0,
                        borderStartStartRadius: 0,
                        borderStartEndRadius: token.borderRadius,
                        borderEndEndRadius: token.borderRadius,
                        borderEndStartRadius: 0,
                        boxShadow: "none"
                    },
                    [`${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
                        color: token.colorTextDescription,
                        "&:hover": {
                            color: token.colorPrimaryHover
                        },
                        "&:active": {
                            color: token.colorPrimaryActive
                        },
                        [`&${antCls}-btn-loading::before`]: {
                            insetInlineStart: 0,
                            insetInlineEnd: 0,
                            insetBlockStart: 0,
                            insetBlockEnd: 0
                        }
                    }
                }
            },
            [`${searchPrefixCls}-button`]: {
                height: token.controlHeight,
                "&:hover, &:focus": {
                    zIndex: 1
                }
            },
            [`&-large ${searchPrefixCls}-button`]: {
                height: token.controlHeightLG
            },
            [`&-small ${searchPrefixCls}-button`]: {
                height: token.controlHeightSM
            },
            "&-rtl": {
                direction: "rtl"
            },
            // ===================== Compact Item Customized Styles =====================
            [`&${componentCls}-compact-item`]: {
                [`&:not(${componentCls}-compact-last-item)`]: {
                    [`${componentCls}-group-addon`]: {
                        [`${componentCls}-search-button`]: {
                            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                            borderRadius: 0
                        }
                    }
                },
                [`&:not(${componentCls}-compact-first-item)`]: {
                    [`${componentCls},${componentCls}-affix-wrapper`]: {
                        borderRadius: 0
                    }
                },
                [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
                    "&:hover, &:focus, &:active": {
                        zIndex: 2
                    }
                },
                [`> ${componentCls}-affix-wrapper-focused`]: {
                    zIndex: 2
                }
            }
        }
    };
};
const $232788b5c0fca573$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        [textareaPrefixCls]: {
            position: "relative",
            "&-show-count": {
                // https://github.com/ant-design/ant-design/issues/33049
                [`> ${componentCls}`]: {
                    height: "100%"
                },
                [`${componentCls}-data-count`]: {
                    position: "absolute",
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: "nowrap",
                    pointerEvents: "none"
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: "inherit",
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    "&:focus": {
                        boxShadow: "none !important"
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    "> *:not(:last-child)": {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: "absolute",
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: "inline-flex",
                        alignItems: "center",
                        margin: "auto",
                        pointerEvents: "none"
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $232788b5c0fca573$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
var // ============================== Export ==============================
$232788b5c0fca573$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Input", (token)=>{
    const inputToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $232788b5c0fca573$var$genInputStyle(inputToken),
        $232788b5c0fca573$var$genTextAreaStyle(inputToken),
        $232788b5c0fca573$var$genAffixStyle(inputToken),
        $232788b5c0fca573$var$genGroupStyle(inputToken),
        $232788b5c0fca573$var$genSearchInputStyle(inputToken),
        $232788b5c0fca573$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(inputToken)
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781), {
    resetFont: false
});





const $98f050512cca42a2$var$genPaginationDisabledStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-disabled`]: {
            "&, &:hover": {
                cursor: "not-allowed",
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: "not-allowed"
                }
            },
            "&:focus-visible": {
                cursor: "not-allowed",
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: "not-allowed"
                }
            }
        },
        [`&${componentCls}-disabled`]: {
            cursor: "not-allowed",
            [`${componentCls}-item`]: {
                cursor: "not-allowed",
                "&:hover, &:active": {
                    backgroundColor: "transparent"
                },
                a: {
                    color: token.colorTextDisabled,
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "not-allowed"
                },
                "&-active": {
                    borderColor: token.colorBorder,
                    backgroundColor: token.itemActiveBgDisabled,
                    "&:hover, &:active": {
                        backgroundColor: token.itemActiveBgDisabled
                    },
                    a: {
                        color: token.itemActiveColorDisabled
                    }
                }
            },
            [`${componentCls}-item-link`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                "&:hover, &:active": {
                    backgroundColor: "transparent"
                },
                [`${componentCls}-simple&`]: {
                    backgroundColor: "transparent",
                    "&:hover, &:active": {
                        backgroundColor: "transparent"
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                color: token.colorTextDisabled
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 0
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 1
                }
            }
        },
        [`&${componentCls}-simple`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&${componentCls}-disabled ${componentCls}-item-link`]: {
                    "&:hover, &:active": {
                        backgroundColor: "transparent"
                    }
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationMiniStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-mini ${componentCls}-total-text, &${componentCls}-mini ${componentCls}-simple-pager`]: {
            height: token.itemSizeSM,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-item`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.itemSizeSM).sub(2).equal())
        },
        [`&${componentCls}-mini:not(${componentCls}-disabled) ${componentCls}-item:not(${componentCls}-item-active)`]: {
            backgroundColor: "transparent",
            borderColor: "transparent",
            "&:hover": {
                backgroundColor: token.colorBgTextHover
            },
            "&:active": {
                backgroundColor: token.colorBgTextActive
            }
        },
        [`&${componentCls}-mini ${componentCls}-prev, &${componentCls}-mini ${componentCls}-next`]: {
            minWidth: token.itemSizeSM,
            height: token.itemSizeSM,
            margin: 0,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini:not(${componentCls}-disabled)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:hover ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&:active ${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgTextActive
                },
                [`&${componentCls}-disabled:hover ${componentCls}-item-link`]: {
                    backgroundColor: "transparent"
                }
            }
        },
        [`
    &${componentCls}-mini ${componentCls}-prev ${componentCls}-item-link,
    &${componentCls}-mini ${componentCls}-next ${componentCls}-item-link
    `]: {
            backgroundColor: "transparent",
            borderColor: "transparent",
            "&::after": {
                height: token.itemSizeSM,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM)
            }
        },
        [`&${componentCls}-mini ${componentCls}-jump-prev, &${componentCls}-mini ${componentCls}-jump-next`]: {
            height: token.itemSizeSM,
            marginInlineEnd: 0,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM)
        },
        [`&${componentCls}-mini ${componentCls}-options`]: {
            marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
            "&-size-changer": {
                top: token.miniOptionsSizeChangerTop
            },
            "&-quick-jumper": {
                height: token.itemSizeSM,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM),
                input: Object.assign(Object.assign({}, (0, $232788b5c0fca573$export$bb047f62c5a56f90)(token)), {
                    width: token.paginationMiniQuickJumperInputWidth,
                    height: token.controlHeightSM
                })
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationSimpleStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`
    &${componentCls}-simple ${componentCls}-prev,
    &${componentCls}-simple ${componentCls}-next
    `]: {
            height: token.itemSizeSM,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM),
            verticalAlign: "top",
            [`${componentCls}-item-link`]: {
                height: token.itemSizeSM,
                backgroundColor: "transparent",
                border: 0,
                "&:hover": {
                    backgroundColor: token.colorBgTextHover
                },
                "&:active": {
                    backgroundColor: token.colorBgTextActive
                },
                "&::after": {
                    height: token.itemSizeSM,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSizeSM)
                }
            }
        },
        [`&${componentCls}-simple ${componentCls}-simple-pager`]: {
            display: "inline-block",
            height: token.itemSizeSM,
            marginInlineEnd: token.marginXS,
            input: {
                boxSizing: "border-box",
                height: "100%",
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                textAlign: "center",
                backgroundColor: token.itemInputBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                borderRadius: token.borderRadius,
                outline: "none",
                transition: `border-color ${token.motionDurationMid}`,
                color: "inherit",
                "&:hover": {
                    borderColor: token.colorPrimary
                },
                "&:focus": {
                    borderColor: token.colorPrimaryHover,
                    boxShadow: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.inputOutlineOffset)} 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
                },
                "&[disabled]": {
                    color: token.colorTextDisabled,
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    cursor: "not-allowed"
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationJumpStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
            outline: 0,
            [`${componentCls}-item-container`]: {
                position: "relative",
                [`${componentCls}-item-link-icon`]: {
                    color: token.colorPrimary,
                    fontSize: token.fontSizeSM,
                    opacity: 0,
                    transition: `all ${token.motionDurationMid}`,
                    "&-svg": {
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        margin: "auto"
                    }
                },
                [`${componentCls}-item-ellipsis`]: {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    display: "block",
                    margin: "auto",
                    color: token.colorTextDisabled,
                    fontFamily: "Arial, Helvetica, sans-serif",
                    letterSpacing: token.paginationEllipsisLetterSpacing,
                    textAlign: "center",
                    textIndent: token.paginationEllipsisTextIndent,
                    opacity: 1,
                    transition: `all ${token.motionDurationMid}`
                }
            },
            "&:hover": {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 1
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 0
                }
            }
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            marginInlineEnd: token.marginXS
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            display: "inline-block",
            minWidth: token.itemSize,
            height: token.itemSize,
            color: token.colorText,
            fontFamily: token.fontFamily,
            lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.itemSize)}`,
            textAlign: "center",
            verticalAlign: "middle",
            listStyle: "none",
            borderRadius: token.borderRadius,
            cursor: "pointer",
            transition: `all ${token.motionDurationMid}`
        },
        [`${componentCls}-prev, ${componentCls}-next`]: {
            fontFamily: "Arial, Helvetica, sans-serif",
            outline: 0,
            button: {
                color: token.colorText,
                cursor: "pointer",
                userSelect: "none"
            },
            [`${componentCls}-item-link`]: {
                display: "block",
                width: "100%",
                height: "100%",
                padding: 0,
                fontSize: token.fontSizeSM,
                textAlign: "center",
                backgroundColor: "transparent",
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                borderRadius: token.borderRadius,
                outline: "none",
                transition: `all ${token.motionDurationMid}`
            },
            [`&:hover ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextHover
            },
            [`&:active ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextActive
            },
            [`&${componentCls}-disabled:hover`]: {
                [`${componentCls}-item-link`]: {
                    backgroundColor: "transparent"
                }
            }
        },
        [`${componentCls}-slash`]: {
            marginInlineEnd: token.paginationSlashMarginInlineEnd,
            marginInlineStart: token.paginationSlashMarginInlineStart
        },
        [`${componentCls}-options`]: {
            display: "inline-block",
            marginInlineStart: token.margin,
            verticalAlign: "middle",
            "&-size-changer": {
                display: "inline-block",
                width: "auto",
                // https://github.com/ant-design/ant-design/issues/49258
                [`${antCls}-select-arrow:not(:last-child)`]: {
                    opacity: 1
                }
            },
            "&-quick-jumper": {
                display: "inline-block",
                height: token.controlHeight,
                marginInlineStart: token.marginXS,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlHeight),
                verticalAlign: "top",
                input: Object.assign(Object.assign(Object.assign({}, (0, $232788b5c0fca573$export$8c9a381315f3ebcd)(token)), (0, $26df503c9b7ea2eb$export$8c569e4cc3fd115f)(token, {
                    borderColor: token.colorBorder,
                    hoverBorderColor: token.colorPrimaryHover,
                    activeBorderColor: token.colorPrimary,
                    activeShadow: token.activeShadow
                })), {
                    "&[disabled]": Object.assign({}, (0, $26df503c9b7ea2eb$export$12789f962d420a93)(token)),
                    width: token.calc(token.controlHeightLG).mul(1.25).equal(),
                    height: token.controlHeight,
                    boxSizing: "border-box",
                    margin: 0,
                    marginInlineStart: token.marginXS,
                    marginInlineEnd: token.marginXS
                })
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationItemStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-item`]: {
            display: "inline-block",
            minWidth: token.itemSize,
            height: token.itemSize,
            marginInlineEnd: token.marginXS,
            fontFamily: token.fontFamily,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
            textAlign: "center",
            verticalAlign: "middle",
            listStyle: "none",
            backgroundColor: "transparent",
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            borderRadius: token.borderRadius,
            outline: 0,
            cursor: "pointer",
            userSelect: "none",
            a: {
                display: "block",
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                color: token.colorText,
                "&:hover": {
                    textDecoration: "none"
                }
            },
            [`&:not(${componentCls}-item-active)`]: {
                "&:hover": {
                    transition: `all ${token.motionDurationMid}`,
                    backgroundColor: token.colorBgTextHover
                },
                "&:active": {
                    backgroundColor: token.colorBgTextActive
                }
            },
            "&-active": {
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.itemActiveBg,
                borderColor: token.colorPrimary,
                a: {
                    color: token.colorPrimary
                },
                "&:hover": {
                    borderColor: token.colorPrimaryHover
                },
                "&:hover a": {
                    color: token.colorPrimaryHover
                }
            }
        }
    };
};
const $98f050512cca42a2$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            display: "flex",
            "&-start": {
                justifyContent: "start"
            },
            "&-center": {
                justifyContent: "center"
            },
            "&-end": {
                justifyContent: "end"
            },
            "ul, ol": {
                margin: 0,
                padding: 0,
                listStyle: "none"
            },
            "&::after": {
                display: "block",
                clear: "both",
                height: 0,
                overflow: "hidden",
                visibility: "hidden",
                content: '""'
            },
            [`${componentCls}-total-text`]: {
                display: "inline-block",
                height: token.itemSize,
                marginInlineEnd: token.marginXS,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.itemSize).sub(2).equal()),
                verticalAlign: "middle"
            }
        }), $98f050512cca42a2$var$genPaginationItemStyle(token)), $98f050512cca42a2$var$genPaginationJumpStyle(token)), $98f050512cca42a2$var$genPaginationSimpleStyle(token)), $98f050512cca42a2$var$genPaginationMiniStyle(token)), $98f050512cca42a2$var$genPaginationDisabledStyle(token)), {
            // media query style
            [`@media only screen and (max-width: ${token.screenLG}px)`]: {
                [`${componentCls}-item`]: {
                    "&-after-jump-prev, &-before-jump-next": {
                        display: "none"
                    }
                }
            },
            [`@media only screen and (max-width: ${token.screenSM}px)`]: {
                [`${componentCls}-options`]: {
                    display: "none"
                }
            }
        }),
        // rtl style
        [`&${token.componentCls}-rtl`]: {
            direction: "rtl"
        }
    };
};
const $98f050512cca42a2$var$genPaginationFocusStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled)`]: {
            [`${componentCls}-item`]: Object.assign({}, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)),
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                "&:focus-visible": Object.assign({
                    [`${componentCls}-item-link-icon`]: {
                        opacity: 1
                    },
                    [`${componentCls}-item-ellipsis`]: {
                        opacity: 0
                    }
                }, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token))
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:focus-visible ${componentCls}-item-link`]: Object.assign({}, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token))
            }
        }
    };
};
const $98f050512cca42a2$export$9ca1be8807fe0675 = (token)=>Object.assign({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemActiveBg: token.colorBgContainer,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0
    }, (0, $500d0ae39d0ead62$export$bd8b682992bc9781)(token));
const $98f050512cca42a2$export$362fb92a8f81bbf9 = (token)=>(0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        inputOutlineOffset: 0,
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginSM,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: "0.13em" // magic for ui experience
    }, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
var // ============================== Export ==============================
$98f050512cca42a2$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Pagination", (token)=>{
    const paginationToken = $98f050512cca42a2$export$362fb92a8f81bbf9(token);
    return [
        $98f050512cca42a2$var$genPaginationStyle(paginationToken),
        $98f050512cca42a2$var$genPaginationFocusStyle(paginationToken)
    ];
}, $98f050512cca42a2$export$9ca1be8807fe0675);





const $56652cfef6436cfa$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
            "&, &:hover": {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            "&:focus-visible": {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            [`${componentCls}-item, ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    a: {
                        color: token.colorTextDisabled
                    }
                },
                [`&${componentCls}-item-active`]: {
                    backgroundColor: token.itemActiveBgDisabled
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                "&:hover button": {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    color: token.colorTextDisabled
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder
                }
            }
        },
        [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                "&:hover button": {
                    borderColor: token.colorPrimaryHover,
                    backgroundColor: token.itemBg
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.itemLinkBg,
                    borderColor: token.colorBorder
                },
                [`&:hover ${componentCls}-item-link`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    color: token.colorPrimary
                },
                [`&${componentCls}-disabled`]: {
                    [`${componentCls}-item-link`]: {
                        borderColor: token.colorBorder,
                        color: token.colorTextDisabled
                    }
                }
            },
            [`${componentCls}-item`]: {
                backgroundColor: token.itemBg,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    a: {
                        color: token.colorPrimary
                    }
                },
                "&-active": {
                    borderColor: token.colorPrimary
                }
            }
        }
    };
};
var $56652cfef6436cfa$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$1537386bc155ea56)([
    "Pagination",
    "bordered"
], (token)=>{
    const paginationToken = (0, $98f050512cca42a2$export$362fb92a8f81bbf9)(token);
    return [
        $56652cfef6436cfa$var$genBorderedStyle(paginationToken)
    ];
}, (0, $98f050512cca42a2$export$9ca1be8807fe0675));


"use client";
var $41bb1cf6e4b63275$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $41bb1cf6e4b63275$var$Pagination = (props)=>{
    const { align: align, prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, locale: customLocale, selectComponentClass: selectComponentClass, responsive: responsive, showSizeChanger: showSizeChanger } = props, restProps = $41bb1cf6e4b63275$var$__rest(props, [
        "align",
        "prefixCls",
        "selectPrefixCls",
        "className",
        "rootClassName",
        "style",
        "size",
        "locale",
        "selectComponentClass",
        "responsive",
        "showSizeChanger"
    ]);
    const { xs: xs } = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(responsive);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { getPrefixCls: getPrefixCls, direction: direction, pagination: pagination = {} } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("pagination", customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $98f050512cca42a2$export$2e2bcd8739ae039)(prefixCls);
    const mergedShowSizeChanger = showSizeChanger !== null && showSizeChanger !== void 0 ? showSizeChanger : pagination.showSizeChanger;
    const iconsProps = $acw62.useMemo(()=>{
        const ellipsis = /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-item-ellipsis`
        }, "\u2022\u2022\u2022");
        const prevIcon = /*#__PURE__*/ $acw62.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === "rtl" ? /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null));
        const nextIcon = /*#__PURE__*/ $acw62.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === "rtl" ? /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null));
        const jumpPrevIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $acw62.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === "rtl" ? /*#__PURE__*/ $acw62.createElement((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $acw62.createElement((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        const jumpNextIcon = /*#__PURE__*/ // biome-ignore lint/a11y/useValidAnchor: it is hard to refactor
        $acw62.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === "rtl" ? /*#__PURE__*/ $acw62.createElement((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $acw62.createElement((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    const [contextLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Pagination", (0, $864f21d08855a737$export$2e2bcd8739ae039));
    const locale = Object.assign(Object.assign({}, contextLocale), customLocale);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const isSmall = mergedSize === "small" || !!(xs && !mergedSize && responsive);
    const selectPrefixCls = getPrefixCls("select", customizeSelectPrefixCls);
    const extendedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-${align}`]: !!align,
        [`${prefixCls}-mini`]: isSmall,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-bordered`]: token.wireframe
    }, pagination === null || pagination === void 0 ? void 0 : pagination.className, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, pagination === null || pagination === void 0 ? void 0 : pagination.style), style);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, token.wireframe && /*#__PURE__*/ $acw62.createElement((0, $56652cfef6436cfa$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $acw62.createElement((0, $1f6ffa8a107637fc$export$2e2bcd8739ae039), Object.assign({}, iconsProps, restProps, {
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        selectComponentClass: selectComponentClass || (isSmall ? (0, $4a2c5bf3f536e529$export$40e3292f13ea8c60) : (0, $4a2c5bf3f536e529$export$c1344b3dabe19d01)),
        locale: locale,
        showSizeChanger: mergedShowSizeChanger
    }))));
};
var $41bb1cf6e4b63275$export$2e2bcd8739ae039 = $41bb1cf6e4b63275$var$Pagination;


"use client";
var $457c0f7bc166788c$export$2e2bcd8739ae039 = (0, $41bb1cf6e4b63275$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $5d4cd9f8bc92bd41$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $30796c32f374b477$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
}
const $30796c32f374b477$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
};
function $30796c32f374b477$export$e530037191fcd5d7(element, props) {
    return $30796c32f374b477$export$2dfe578f95754f6a(element, element, props);
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


"use client";
function $242a363dabc3566f$export$2e2bcd8739ae039(_ref) {
    let { percent: percent, prefixCls: prefixCls } = _ref;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $acw62.useState(false);
    // ==================== Visible =====================
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent !== 0
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    const viewSize = 100;
    const borderWidth = viewSize / 5;
    const radius = viewSize / 2 - borderWidth / 2;
    const circumference = radius * 2 * Math.PI;
    const renderCircle = (circleClassName, style)=>/*#__PURE__*/ $acw62.createElement("circle", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(circleClassName, `${dotClassName}-circle`),
            r: radius,
            cx: "50",
            cy: "50",
            strokeWidth: borderWidth,
            style: style
        });
    // ===================== Render =====================
    if (!render) return null;
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        viewBox: `0 0 ${viewSize} ${viewSize}`,
        // biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: progressbar could be readonly
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, renderCircle(`${dotClassName}-circle-bg`), renderCircle("", {
        strokeDasharray: `${circumference * safePtg / 100} ${circumference * (100 - safePtg) / 100}`,
        strokeDashoffset: `${circumference / 4}`
    })));
}


"use client";
function $827038dbb6bd8311$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0 } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(holderClassName, percent > 0 && hideClassName)
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $acw62.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $acw62.createElement((0, $242a363dabc3566f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    }));
}


"use client";
function $f531c664e0f3d7ea$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $acw62.isValidElement(indicator)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(indicator, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(indicator.props.className, dotClassName),
        percent: percent
    });
    return /*#__PURE__*/ $acw62.createElement((0, $827038dbb6bd8311$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    });
}





const $f4e8aa06f042a155$var$antSpinMove = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antSpinMove", {
    to: {
        opacity: 1
    }
});
const $f4e8aa06f042a155$var$antRotate = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antRotate", {
    to: {
        transform: "rotate(405deg)"
    }
});
const $f4e8aa06f042a155$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [`${componentCls}`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "absolute",
            display: "none",
            color: token.colorPrimary,
            fontSize: 0,
            textAlign: "center",
            verticalAlign: "middle",
            opacity: 0,
            transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
            "&-spinning": {
                position: "relative",
                display: "inline-block",
                opacity: 1
            },
            [`${componentCls}-text`]: {
                fontSize: token.fontSize,
                paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
            },
            "&-fullscreen": {
                position: "fixed",
                width: "100vw",
                height: "100vh",
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                inset: 0,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
                opacity: 0,
                visibility: "hidden",
                transition: `all ${token.motionDurationMid}`,
                "&-show": {
                    opacity: 1,
                    visibility: "visible"
                },
                [componentCls]: {
                    [`${componentCls}-dot-holder`]: {
                        color: token.colorWhite
                    },
                    [`${componentCls}-text`]: {
                        color: token.colorTextLightSolid
                    }
                }
            },
            "&-nested-loading": {
                position: "relative",
                [`> div > ${componentCls}`]: {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: 0,
                    zIndex: 4,
                    display: "block",
                    width: "100%",
                    height: "100%",
                    maxHeight: token.contentHeight,
                    [`${componentCls}-dot`]: {
                        position: "absolute",
                        top: "50%",
                        insetInlineStart: "50%",
                        margin: calc(token.dotSize).mul(-1).div(2).equal()
                    },
                    [`${componentCls}-text`]: {
                        position: "absolute",
                        top: "50%",
                        width: "100%",
                        textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
                    },
                    [`&${componentCls}-show-text ${componentCls}-dot`]: {
                        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
                    },
                    "&-sm": {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
                        }
                    },
                    "&-lg": {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
                        }
                    }
                },
                [`${componentCls}-container`]: {
                    position: "relative",
                    transition: `opacity ${token.motionDurationSlow}`,
                    "&::after": {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        zIndex: 10,
                        width: "100%",
                        height: "100%",
                        background: token.colorBgContainer,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '""',
                        pointerEvents: "none"
                    }
                },
                [`${componentCls}-blur`]: {
                    clear: "both",
                    opacity: 0.5,
                    userSelect: "none",
                    pointerEvents: "none",
                    "&::after": {
                        opacity: 0.4,
                        pointerEvents: "auto"
                    }
                }
            },
            // tip
            // ------------------------------
            "&-tip": {
                color: token.spinDotDefault
            },
            // holder
            // ------------------------------
            [`${componentCls}-dot-progress`]: {
                position: "absolute",
                top: 0,
                insetInlineStart: 0
            },
            [`${componentCls}-dot-holder`]: {
                width: "1em",
                height: "1em",
                fontSize: token.dotSize,
                display: "inline-block",
                transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
                transformOrigin: "50% 50%",
                lineHeight: 1,
                color: token.colorPrimary,
                "&-hidden": {
                    transform: "scale(0.3)",
                    opacity: 0
                }
            },
            // progress
            // ------------------------------
            [`${componentCls}-dot-progress`]: {
                position: "absolute",
                top: 0,
                insetInlineStart: 0
            },
            // dots
            // ------------------------------
            [`${componentCls}-dot`]: {
                position: "relative",
                display: "inline-block",
                fontSize: token.dotSize,
                width: "1em",
                height: "1em",
                "&-item": {
                    position: "absolute",
                    display: "block",
                    width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    background: "currentColor",
                    borderRadius: "100%",
                    transform: "scale(0.75)",
                    transformOrigin: "50% 50%",
                    opacity: 0.3,
                    animationName: $f4e8aa06f042a155$var$antSpinMove,
                    animationDuration: "1s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear",
                    animationDirection: "alternate",
                    "&:nth-child(1)": {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: "0s"
                    },
                    "&:nth-child(2)": {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: "0.4s"
                    },
                    "&:nth-child(3)": {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: "0.8s"
                    },
                    "&:nth-child(4)": {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: "1.2s"
                    }
                },
                "&-spin": {
                    transform: "rotate(45deg)",
                    animationName: $f4e8aa06f042a155$var$antRotate,
                    animationDuration: "1.2s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear"
                },
                "&-circle": {
                    strokeLinecap: "round",
                    transition: [
                        "stroke-dashoffset",
                        "stroke-dasharray",
                        "stroke",
                        "stroke-width",
                        "opacity"
                    ].map((item)=>`${item} ${token.motionDurationSlow} ease`).join(","),
                    fillOpacity: 0,
                    stroke: "currentcolor"
                },
                "&-circle-bg": {
                    stroke: token.colorFillSecondary
                }
            },
            // small
            [`&-sm ${componentCls}-dot`]: {
                fontSize: token.dotSizeSM
            },
            [`&-sm ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
                    height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
                }
            },
            // large
            [`&-lg ${componentCls}-dot`]: {
                fontSize: token.dotSizeLG
            },
            [`&-lg ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
                    height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
                }
            },
            [`&${componentCls}-show-text ${componentCls}-text`]: {
                display: "block"
            }
        })
    };
};
const $f4e8aa06f042a155$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$f4e8aa06f042a155$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Spin", (token)=>{
    const spinToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $f4e8aa06f042a155$var$genSpinStyle(spinToken)
    ];
}, $f4e8aa06f042a155$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");
const $4374779c501b3dd4$var$AUTO_INTERVAL = 200;
const $4374779c501b3dd4$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $4374779c501b3dd4$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $acw62.useState(0);
    const mockIntervalRef = $acw62.useRef();
    const isAuto = percent === "auto";
    $acw62.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $4374779c501b3dd4$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $4374779c501b3dd4$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $4374779c501b3dd4$var$AUTO_INTERVAL);
        }
        return ()=>{
            clearInterval(mockIntervalRef.current);
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}


"use client";
var $26f1cf19d4dd7058$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $26f1cf19d4dd7058$var$SpinSizes = [
    "small",
    "default",
    "large"
];
// Render indicator
let $26f1cf19d4dd7058$var$defaultIndicator;
function $26f1cf19d4dd7058$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !isNaN(Number(delay));
}
const $26f1cf19d4dd7058$var$Spin = (props)=>{
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size = "default", tip: tip, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent } = props, restProps = $26f1cf19d4dd7058$var$__rest(props, [
        "prefixCls",
        "spinning",
        "delay",
        "className",
        "rootClassName",
        "size",
        "tip",
        "wrapperClassName",
        "style",
        "children",
        "fullscreen",
        "indicator",
        "percent"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("spin", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f4e8aa06f042a155$export$2e2bcd8739ae039)(prefixCls);
    const [spinning, setSpinning] = $acw62.useState(()=>customSpinning && !$26f1cf19d4dd7058$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $4374779c501b3dd4$export$2e2bcd8739ae039)(spinning, percent);
    $acw62.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $5d4cd9f8bc92bd41$export$61fc7d43ac8f84b0)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                var _a;
                (_a = showSpinning === null || showSpinning === void 0 ? void 0 : showSpinning.cancel) === null || _a === void 0 || _a.call(showSpinning);
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    const isNestedPattern = $acw62.useMemo(()=>typeof children !== "undefined" && !fullscreen, [
        children,
        fullscreen
    ]);
    const { direction: direction, spin: spin } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const spinClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, spin === null || spin === void 0 ? void 0 : spin.className, {
        [`${prefixCls}-sm`]: size === "small",
        [`${prefixCls}-lg`]: size === "large",
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, !fullscreen && rootClassName, hashId, cssVarCls);
    const containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-container`, {
        [`${prefixCls}-blur`]: spinning
    });
    const mergedStyle = Object.assign(Object.assign({}, spin === null || spin === void 0 ? void 0 : spin.style), style);
    const spinElement = /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, restProps, {
        style: mergedStyle,
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }), /*#__PURE__*/ $acw62.createElement((0, $f531c664e0f3d7ea$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        indicator: indicator !== null && indicator !== void 0 ? indicator : $26f1cf19d4dd7058$var$defaultIndicator,
        percent: mergedPercent
    }), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-text`
    }, tip) : null);
    if (isNestedPattern) return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({}, restProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-nested-loading`, wrapperClassName, hashId, cssVarCls)
    }), spinning && /*#__PURE__*/ $acw62.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ $acw62.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children)));
    if (fullscreen) return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-fullscreen`, {
            [`${prefixCls}-fullscreen-show`]: spinning
        }, rootClassName, hashId, cssVarCls)
    }, spinElement));
    return wrapCSSVar(spinElement);
};
$26f1cf19d4dd7058$var$Spin.setDefaultIndicator = (indicator)=>{
    $26f1cf19d4dd7058$var$defaultIndicator = indicator;
};
var $26f1cf19d4dd7058$export$2e2bcd8739ae039 = $26f1cf19d4dd7058$var$Spin;



var $acw62 = parcelRequire("acw62");
const $32f1d9fa6840f499$export$52411773e0d6f15d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const $32f1d9fa6840f499$export$a3183b990150745c = $32f1d9fa6840f499$export$52411773e0d6f15d.Consumer;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");




"use client";
var $d153d21e77ee9427$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $d153d21e77ee9427$var$parseFlex(flex) {
    if (typeof flex === "number") return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $d153d21e77ee9427$var$sizes = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
const $d153d21e77ee9427$var$Col = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { gutter: gutter, wrap: wrap } = $acw62.useContext((0, $0664da0d06972591$export$2e2bcd8739ae039));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style } = props, others = $d153d21e77ee9427$var$__rest(props, [
        "prefixCls",
        "span",
        "order",
        "offset",
        "push",
        "pull",
        "className",
        "children",
        "flex",
        "style"
    ]);
    const prefixCls = getPrefixCls("col", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ce0ae756d67d6466$export$4d3e83959861592f)(prefixCls);
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    $d153d21e77ee9427$var$sizes.forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === "number") sizeProps.span = propSize;
        else if (typeof propSize === "object") sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), {
            [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined,
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === "rtl"
        });
        // Responsive flex layout
        if (sizeProps.flex) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[`--${prefixCls}-${size}-flex`] = $d153d21e77ee9427$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter && gutter[0] > 0) {
        const horizontalGutter = gutter[0] / 2;
        mergedStyle.paddingLeft = horizontalGutter;
        mergedStyle.paddingRight = horizontalGutter;
    }
    if (flex) {
        mergedStyle.flex = $d153d21e77ee9427$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        style: Object.assign(Object.assign(Object.assign({}, mergedStyle), style), sizeStyle),
        className: classes,
        ref: ref
    }), children));
});
var $d153d21e77ee9427$export$2e2bcd8739ae039 = $d153d21e77ee9427$var$Col;



"use client";
var $4e345c9ad83e7fdb$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4e345c9ad83e7fdb$export$b08a9033b36413fb = (_a)=>{
    var { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description } = _a, others = $4e345c9ad83e7fdb$var$__rest(_a, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("list", customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-item-meta`, className);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-item-meta-content`
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h4", {
        className: `${prefixCls}-item-meta-title`
    }, title), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-item-meta-description`
    }, description));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, others, {
        className: classString
    }), avatar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-item-meta-avatar`
    }, avatar), (title || description) && content);
};
const $4e345c9ad83e7fdb$var$InternalItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, children: children, actions: actions, extra: extra, styles: styles, className: className, classNames: customizeClassNames, colStyle: colStyle } = props, others = $4e345c9ad83e7fdb$var$__rest(props, [
        "prefixCls",
        "children",
        "actions",
        "extra",
        "styles",
        "className",
        "classNames",
        "colStyle"
    ]);
    const { grid: grid, itemLayout: itemLayout } = (0, $acw62.useContext)((0, $32f1d9fa6840f499$export$52411773e0d6f15d));
    const { getPrefixCls: getPrefixCls, list: list } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const moduleClass = (moduleName)=>{
        var _a, _b;
        return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.classNames) === null || _b === void 0 ? void 0 : _b[moduleName], customizeClassNames === null || customizeClassNames === void 0 ? void 0 : customizeClassNames[moduleName]);
    };
    const moduleStyle = (moduleName)=>{
        var _a, _b;
        return Object.assign(Object.assign({}, (_b = (_a = list === null || list === void 0 ? void 0 : list.item) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b[moduleName]), styles === null || styles === void 0 ? void 0 : styles[moduleName]);
    };
    const isItemContainsTextNodeAndNotSingular = ()=>{
        let result = false;
        (0, $acw62.Children).forEach(children, (element)=>{
            if (typeof element === "string") result = true;
        });
        return result && (0, $acw62.Children).count(children) > 1;
    };
    const isFlexMode = ()=>{
        if (itemLayout === "vertical") return !!extra;
        return !isItemContainsTextNodeAndNotSingular();
    };
    const prefixCls = getPrefixCls("list", customizePrefixCls);
    const actionsContent = (actions === null || actions === void 0 ? void 0 : actions.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-item-action`, moduleClass("actions")),
        key: "actions",
        style: moduleStyle("actions")
    }, actions.map((action, i)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${prefixCls}-item-action-${i}`
        }, action, i !== actions.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("em", {
            className: `${prefixCls}-item-action-split`
        }))));
    const Element = grid ? "div" : "li";
    const itemChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, Object.assign({}, others, !grid ? {
        ref: ref
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-item`, {
            [`${prefixCls}-item-no-flex`]: !isFlexMode()
        }, className)
    }), itemLayout === "vertical" && extra ? [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: `${prefixCls}-item-main`,
            key: "content"
        }, children, actionsContent),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-item-extra`, moduleClass("extra")),
            key: "extra",
            style: moduleStyle("extra")
        }, extra)
    ] : [
        children,
        actionsContent,
        (0, $30796c32f374b477$export$e530037191fcd5d7)(extra, {
            key: "extra"
        })
    ]);
    return grid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d153d21e77ee9427$export$2e2bcd8739ae039), {
        ref: ref,
        flex: 1,
        style: colStyle
    }, itemChildren) : itemChildren;
});
const $4e345c9ad83e7fdb$var$Item = $4e345c9ad83e7fdb$var$InternalItem;
$4e345c9ad83e7fdb$var$Item.Meta = $4e345c9ad83e7fdb$export$b08a9033b36413fb;
var $4e345c9ad83e7fdb$export$2e2bcd8739ae039 = $4e345c9ad83e7fdb$var$Item;





const $eac466f0a49a68f5$var$genBorderedStyle = (token)=>{
    const { listBorderedCls: listBorderedCls, componentCls: componentCls, paddingLG: paddingLG, margin: margin, itemPaddingSM: itemPaddingSM, itemPaddingLG: itemPaddingLG, marginLG: marginLG, borderRadiusLG: borderRadiusLG } = token;
    return {
        [`${listBorderedCls}`]: {
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: borderRadiusLG,
            [`${componentCls}-header,${componentCls}-footer,${componentCls}-item`]: {
                paddingInline: paddingLG
            },
            [`${componentCls}-pagination`]: {
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(margin)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(marginLG)}`
            }
        },
        [`${listBorderedCls}${componentCls}-sm`]: {
            [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
                padding: itemPaddingSM
            }
        },
        [`${listBorderedCls}${componentCls}-lg`]: {
            [`${componentCls}-item,${componentCls}-header,${componentCls}-footer`]: {
                padding: itemPaddingLG
            }
        }
    };
};
const $eac466f0a49a68f5$var$genResponsiveStyle = (token)=>{
    const { componentCls: componentCls, screenSM: screenSM, screenMD: screenMD, marginLG: marginLG, marginSM: marginSM, margin: margin } = token;
    return {
        [`@media screen and (max-width:${screenMD}px)`]: {
            [`${componentCls}`]: {
                [`${componentCls}-item`]: {
                    [`${componentCls}-item-action`]: {
                        marginInlineStart: marginLG
                    }
                }
            },
            [`${componentCls}-vertical`]: {
                [`${componentCls}-item`]: {
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: marginLG
                    }
                }
            }
        },
        [`@media screen and (max-width: ${screenSM}px)`]: {
            [`${componentCls}`]: {
                [`${componentCls}-item`]: {
                    flexWrap: "wrap",
                    [`${componentCls}-action`]: {
                        marginInlineStart: marginSM
                    }
                }
            },
            [`${componentCls}-vertical`]: {
                [`${componentCls}-item`]: {
                    flexWrap: "wrap-reverse",
                    [`${componentCls}-item-main`]: {
                        minWidth: token.contentWidth
                    },
                    [`${componentCls}-item-extra`]: {
                        margin: `auto auto ${(0, $f97444ff16d95e90$export$523c0b569236b342)(margin)}`
                    }
                }
            }
        }
    };
};
// =============================== Base ===============================
const $eac466f0a49a68f5$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlHeight: controlHeight, minHeight: minHeight, paddingSM: paddingSM, marginLG: marginLG, padding: padding, itemPadding: itemPadding, colorPrimary: colorPrimary, itemPaddingSM: itemPaddingSM, itemPaddingLG: itemPaddingLG, paddingXS: paddingXS, margin: margin, colorText: colorText, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, headerBg: headerBg, footerBg: footerBg, emptyTextPadding: emptyTextPadding, metaMarginBottom: metaMarginBottom, avatarMarginRight: avatarMarginRight, titleMarginBottom: titleMarginBottom, descriptionFontSize: descriptionFontSize } = token;
    return {
        [`${componentCls}`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "relative",
            "*": {
                outline: "none"
            },
            [`${componentCls}-header`]: {
                background: headerBg
            },
            [`${componentCls}-footer`]: {
                background: footerBg
            },
            [`${componentCls}-header, ${componentCls}-footer`]: {
                paddingBlock: paddingSM
            },
            [`${componentCls}-pagination`]: {
                marginBlockStart: marginLG,
                // https://github.com/ant-design/ant-design/issues/20037
                [`${antCls}-pagination-options`]: {
                    textAlign: "start"
                }
            },
            [`${componentCls}-spin`]: {
                minHeight: minHeight,
                textAlign: "center"
            },
            [`${componentCls}-items`]: {
                margin: 0,
                padding: 0,
                listStyle: "none"
            },
            [`${componentCls}-item`]: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: itemPadding,
                color: colorText,
                [`${componentCls}-item-meta`]: {
                    display: "flex",
                    flex: 1,
                    alignItems: "flex-start",
                    maxWidth: "100%",
                    [`${componentCls}-item-meta-avatar`]: {
                        marginInlineEnd: avatarMarginRight
                    },
                    [`${componentCls}-item-meta-content`]: {
                        flex: "1 0",
                        width: 0,
                        color: colorText
                    },
                    [`${componentCls}-item-meta-title`]: {
                        margin: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXXS)} 0`,
                        color: colorText,
                        fontSize: token.fontSize,
                        lineHeight: token.lineHeight,
                        "> a": {
                            color: colorText,
                            transition: `all ${motionDurationSlow}`,
                            "&:hover": {
                                color: colorPrimary
                            }
                        }
                    },
                    [`${componentCls}-item-meta-description`]: {
                        color: colorTextDescription,
                        fontSize: descriptionFontSize,
                        lineHeight: token.lineHeight
                    }
                },
                [`${componentCls}-item-action`]: {
                    flex: "0 0 auto",
                    marginInlineStart: token.marginXXL,
                    padding: 0,
                    fontSize: 0,
                    listStyle: "none",
                    "& > li": {
                        position: "relative",
                        display: "inline-block",
                        padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)}`,
                        color: colorTextDescription,
                        fontSize: token.fontSize,
                        lineHeight: token.lineHeight,
                        textAlign: "center",
                        "&:first-child": {
                            paddingInlineStart: 0
                        }
                    },
                    [`${componentCls}-item-action-split`]: {
                        position: "absolute",
                        insetBlockStart: "50%",
                        insetInlineEnd: 0,
                        width: lineWidth,
                        height: token.calc(token.fontHeight).sub(token.calc(token.marginXXS).mul(2)).equal(),
                        transform: "translateY(-50%)",
                        backgroundColor: token.colorSplit
                    }
                }
            },
            [`${componentCls}-empty`]: {
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)} 0`,
                color: colorTextDescription,
                fontSize: token.fontSizeSM,
                textAlign: "center"
            },
            [`${componentCls}-empty-text`]: {
                padding: emptyTextPadding,
                color: token.colorTextDisabled,
                fontSize: token.fontSize,
                textAlign: "center"
            },
            // ============================ without flex ============================
            [`${componentCls}-item-no-flex`]: {
                display: "block"
            }
        }),
        [`${componentCls}-grid ${antCls}-col > ${componentCls}-item`]: {
            display: "block",
            maxWidth: "100%",
            marginBlockEnd: margin,
            paddingBlock: 0,
            borderBlockEnd: "none"
        },
        [`${componentCls}-vertical ${componentCls}-item`]: {
            alignItems: "initial",
            [`${componentCls}-item-main`]: {
                display: "block",
                flex: 1
            },
            [`${componentCls}-item-extra`]: {
                marginInlineStart: marginLG
            },
            [`${componentCls}-item-meta`]: {
                marginBlockEnd: metaMarginBottom,
                [`${componentCls}-item-meta-title`]: {
                    marginBlockStart: 0,
                    marginBlockEnd: titleMarginBottom,
                    color: colorText,
                    fontSize: token.fontSizeLG,
                    lineHeight: token.lineHeightLG
                }
            },
            [`${componentCls}-item-action`]: {
                marginBlockStart: padding,
                marginInlineStart: "auto",
                "> li": {
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)}`,
                    "&:first-child": {
                        paddingInlineStart: 0
                    }
                }
            }
        },
        [`${componentCls}-split ${componentCls}-item`]: {
            borderBlockEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
            "&:last-child": {
                borderBlockEnd: "none"
            }
        },
        [`${componentCls}-split ${componentCls}-header`]: {
            borderBlockEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-split${componentCls}-empty ${componentCls}-footer`]: {
            borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-loading ${componentCls}-spin-nested-loading`]: {
            minHeight: controlHeight
        },
        [`${componentCls}-split${componentCls}-something-after-last-item ${antCls}-spin-container > ${componentCls}-items > ${componentCls}-item:last-child`]: {
            borderBlockEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
        },
        [`${componentCls}-lg ${componentCls}-item`]: {
            padding: itemPaddingLG
        },
        [`${componentCls}-sm ${componentCls}-item`]: {
            padding: itemPaddingSM
        },
        // Horizontal
        [`${componentCls}:not(${componentCls}-vertical)`]: {
            [`${componentCls}-item-no-flex`]: {
                [`${componentCls}-item-action`]: {
                    float: "right"
                }
            }
        }
    };
};
const $eac466f0a49a68f5$export$9ca1be8807fe0675 = (token)=>({
        contentWidth: 220,
        itemPadding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingContentVertical)} 0`,
        itemPaddingSM: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingContentVerticalSM)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingContentHorizontal)}`,
        itemPaddingLG: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingContentVerticalLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerBg: "transparent",
        footerBg: "transparent",
        emptyTextPadding: token.padding,
        metaMarginBottom: token.padding,
        avatarMarginRight: token.padding,
        titleMarginBottom: token.paddingSM,
        descriptionFontSize: token.fontSize
    });
var // ============================== Export ==============================
$eac466f0a49a68f5$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("List", (token)=>{
    const listToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        listBorderedCls: `${token.componentCls}-bordered`,
        minHeight: token.controlHeightLG
    });
    return [
        $eac466f0a49a68f5$var$genBaseStyle(listToken),
        $eac466f0a49a68f5$var$genBorderedStyle(listToken),
        $eac466f0a49a68f5$var$genResponsiveStyle(listToken)
    ];
}, $eac466f0a49a68f5$export$9ca1be8807fe0675);


"use client";
var $c8a82c84763151b1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c8a82c84763151b1$var$List(_a) {
    var { pagination: pagination = false, prefixCls: customizePrefixCls, bordered: bordered = false, split: split = true, className: className, rootClassName: rootClassName, style: style, children: children, itemLayout: itemLayout, loadMore: loadMore, grid: grid, dataSource: dataSource = [], size: customizeSize, header: header, footer: footer, loading: loading = false, rowKey: rowKey, renderItem: renderItem, locale: locale } = _a, rest = $c8a82c84763151b1$var$__rest(_a, [
        "pagination",
        "prefixCls",
        "bordered",
        "split",
        "className",
        "rootClassName",
        "style",
        "children",
        "itemLayout",
        "loadMore",
        "grid",
        "dataSource",
        "size",
        "header",
        "footer",
        "loading",
        "rowKey",
        "renderItem",
        "locale"
    ]);
    const paginationObj = pagination && typeof pagination === "object" ? pagination : {};
    const [paginationCurrent, setPaginationCurrent] = $acw62.useState(paginationObj.defaultCurrent || 1);
    const [paginationSize, setPaginationSize] = $acw62.useState(paginationObj.defaultPageSize || 10);
    const { getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: direction, list: list } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const defaultPaginationProps = {
        current: 1,
        total: 0
    };
    const triggerPaginationEvent = (eventName)=>(page, pageSize)=>{
            var _a;
            setPaginationCurrent(page);
            setPaginationSize(pageSize);
            if (pagination) (_a = pagination === null || pagination === void 0 ? void 0 : pagination[eventName]) === null || _a === void 0 || _a.call(pagination, page, pageSize);
        };
    const onPaginationChange = triggerPaginationEvent("onChange");
    const onPaginationShowSizeChange = triggerPaginationEvent("onShowSizeChange");
    const renderInnerItem = (item, index)=>{
        if (!renderItem) return null;
        let key;
        if (typeof rowKey === "function") key = rowKey(item);
        else if (rowKey) key = item[rowKey];
        else key = item.key;
        if (!key) key = `list-item-${index}`;
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, {
            key: key
        }, renderItem(item, index));
    };
    const isSomethingAfterLastItem = ()=>!!(loadMore || pagination || footer);
    const prefixCls = getPrefixCls("list", customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $eac466f0a49a68f5$export$2e2bcd8739ae039)(prefixCls);
    let loadingProp = loading;
    if (typeof loadingProp === "boolean") loadingProp = {
        spinning: loadingProp
    };
    const isLoading = !!(loadingProp === null || loadingProp === void 0 ? void 0 : loadingProp.spinning);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    // large => lg
    // small => sm
    let sizeCls = "";
    switch(mergedSize){
        case "large":
            sizeCls = "lg";
            break;
        case "small":
            sizeCls = "sm";
            break;
        default:
            break;
    }
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-vertical`]: itemLayout === "vertical",
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-split`]: split,
        [`${prefixCls}-bordered`]: bordered,
        [`${prefixCls}-loading`]: isLoading,
        [`${prefixCls}-grid`]: !!grid,
        [`${prefixCls}-something-after-last-item`]: isSomethingAfterLastItem(),
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, list === null || list === void 0 ? void 0 : list.className, className, rootClassName, hashId, cssVarCls);
    const paginationProps = (0, $be673cd5391dca21$export$2e2bcd8739ae039)(defaultPaginationProps, {
        total: dataSource.length,
        current: paginationCurrent,
        pageSize: paginationSize
    }, pagination || {});
    const largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
    if (paginationProps.current > largestPage) paginationProps.current = largestPage;
    const paginationContent = pagination && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-pagination`)
    }, /*#__PURE__*/ $acw62.createElement((0, $457c0f7bc166788c$export$2e2bcd8739ae039), Object.assign({}, paginationProps, {
        onChange: onPaginationChange,
        onShowSizeChange: onPaginationShowSizeChange
    })));
    let splitDataSource = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(dataSource);
    if (pagination) {
        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) splitDataSource = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
    }
    const needResponsive = Object.keys(grid || {}).some((key)=>[
            "xs",
            "sm",
            "md",
            "lg",
            "xl",
            "xxl"
        ].includes(key));
    const screens = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(needResponsive);
    const currentBreakpoint = $acw62.useMemo(()=>{
        for(let i = 0; i < (0, $36689cb123f552b0$export$74c1bf8296b1541f).length; i += 1){
            const breakpoint = (0, $36689cb123f552b0$export$74c1bf8296b1541f)[i];
            if (screens[breakpoint]) return breakpoint;
        }
        return undefined;
    }, [
        screens
    ]);
    const colStyle = $acw62.useMemo(()=>{
        if (!grid) return undefined;
        const columnCount = currentBreakpoint && grid[currentBreakpoint] ? grid[currentBreakpoint] : grid.column;
        if (columnCount) return {
            width: `${100 / columnCount}%`,
            maxWidth: `${100 / columnCount}%`
        };
    }, [
        JSON.stringify(grid),
        currentBreakpoint
    ]);
    let childrenContent = isLoading && /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            minHeight: 53
        }
    });
    if (splitDataSource.length > 0) {
        const items = splitDataSource.map((item, index)=>renderInnerItem(item, index));
        childrenContent = grid ? /*#__PURE__*/ $acw62.createElement((0, $50bd634b7bc091a8$export$2e2bcd8739ae039), {
            gutter: grid.gutter
        }, $acw62.Children.map(items, (child)=>/*#__PURE__*/ $acw62.createElement("div", {
                key: child === null || child === void 0 ? void 0 : child.key,
                style: colStyle
            }, child))) : /*#__PURE__*/ $acw62.createElement("ul", {
            className: `${prefixCls}-items`
        }, items);
    } else if (!children && !isLoading) childrenContent = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-empty-text`
    }, (locale === null || locale === void 0 ? void 0 : locale.emptyText) || (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("List")) || /*#__PURE__*/ $acw62.createElement((0, $3feb83783705e448$export$2e2bcd8739ae039), {
        componentName: "List"
    }));
    const paginationPosition = paginationProps.position || "bottom";
    const contextValue = $acw62.useMemo(()=>({
            grid: grid,
            itemLayout: itemLayout
        }), [
        JSON.stringify(grid),
        itemLayout
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $32f1d9fa6840f499$export$52411773e0d6f15d).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement("div", Object.assign({
        style: Object.assign(Object.assign({}, list === null || list === void 0 ? void 0 : list.style), style),
        className: classString
    }, rest), (paginationPosition === "top" || paginationPosition === "both") && paginationContent, header && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-header`
    }, header), /*#__PURE__*/ $acw62.createElement((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), Object.assign({}, loadingProp), childrenContent, children), footer && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-footer`
    }, footer), loadMore || (paginationPosition === "bottom" || paginationPosition === "both") && paginationContent)));
}
$c8a82c84763151b1$var$List.Item = (0, $4e345c9ad83e7fdb$export$2e2bcd8739ae039);
var $c8a82c84763151b1$export$2e2bcd8739ae039 = $c8a82c84763151b1$var$List;





const $64636abf1746fc18$var$getDesignToken = (config)=>{
    const theme = (config === null || config === void 0 ? void 0 : config.algorithm) ? (0, $db48c74b3367fd88$export$2e2bcd8739ae039)(config.algorithm) : (0, $db48c74b3367fd88$export$2e2bcd8739ae039)((0, $11cb018871a499d7$export$2e2bcd8739ae039));
    const mergedToken = Object.assign(Object.assign({}, (0, $b1208bbc03407e2e$export$2e2bcd8739ae039)), config === null || config === void 0 ? void 0 : config.token);
    return (0, $fb047830d7776fb2$export$18602cb46ae80b62)(mergedToken, {
        override: config === null || config === void 0 ? void 0 : config.token
    }, theme, (0, $e6266db79468900d$export$2e2bcd8739ae039));
};
var $64636abf1746fc18$export$2e2bcd8739ae039 = $64636abf1746fc18$var$getDesignToken;






function $55c634384c51114e$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    const compactSizeStep = sizeStep - 2;
    return {
        sizeXXL: sizeUnit * (compactSizeStep + 10),
        sizeXL: sizeUnit * (compactSizeStep + 6),
        sizeLG: sizeUnit * (compactSizeStep + 2),
        sizeMD: sizeUnit * (compactSizeStep + 2),
        sizeMS: sizeUnit * (compactSizeStep + 1),
        size: sizeUnit * compactSizeStep,
        sizeSM: sizeUnit * compactSizeStep,
        sizeXS: sizeUnit * (compactSizeStep - 1),
        sizeXXS: sizeUnit * (compactSizeStep - 1)
    };
}


const $7480e91aa2c69f50$var$derivative = (token, mapToken)=>{
    const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : (0, $11cb018871a499d7$export$2e2bcd8739ae039)(token);
    const fontSize = mergedMapToken.fontSizeSM; // Smaller size font-size as base
    const controlHeight = mergedMapToken.controlHeight - 4;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, mergedMapToken), (0, $55c634384c51114e$export$2e2bcd8739ae039)(mapToken !== null && mapToken !== void 0 ? mapToken : token)), (0, $10537aa233bce652$export$2e2bcd8739ae039)(fontSize)), {
        controlHeight: // controlHeight
        controlHeight
    }), (0, $7163539f10d66a74$export$2e2bcd8739ae039)(Object.assign(Object.assign({}, mergedMapToken), {
        controlHeight: controlHeight
    })));
};
var $7480e91aa2c69f50$export$2e2bcd8739ae039 = $7480e91aa2c69f50$var$derivative;








const $d59c2d385264216d$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(baseColor).setAlpha(alpha).toRgbString();
const $d59c2d385264216d$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(baseColor);
    return instance.lighten(brightness).toHexString();
};


const $bb5c99fa51be6547$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(baseColor, {
        theme: "dark"
    });
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[6],
        6: colors[5],
        7: colors[4],
        8: colors[6],
        9: colors[5],
        10: colors[4]
    };
};
const $bb5c99fa51be6547$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || "#000";
    const colorTextBase = textBaseColor || "#fff";
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorText: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorTextSecondary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.18),
        colorFillSecondary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.12),
        colorFillTertiary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.08),
        colorFillQuaternary: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBgElevated: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 12),
        colorBgContainer: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 8),
        colorBgLayout: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 26),
        colorBgBlur: (0, $d59c2d385264216d$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorBorder: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 26),
        colorBorderSecondary: (0, $d59c2d385264216d$export$7003a8a990e79359)(colorBgBase, 19)
    };
};


const $179e3c86520dcfc1$var$derivative = (token, mapToken)=>{
    const colorPalettes = Object.keys((0, $b1208bbc03407e2e$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = (0, $d1dea01cb419bab7$export$2e2bcd8739ae039)(token[colorKey], {
            theme: "dark"
        });
        return new Array(10).fill(1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        // biome-ignore lint/style/noParameterAssign: it is a reduce
        prev = Object.assign(Object.assign({}, prev), cur);
        return prev;
    }, {});
    const mergedMapToken = mapToken !== null && mapToken !== void 0 ? mapToken : (0, $11cb018871a499d7$export$2e2bcd8739ae039)(token);
    return Object.assign(Object.assign(Object.assign({}, mergedMapToken), colorPalettes), (0, $f9a7789ccb5ebec2$export$2e2bcd8739ae039)(token, {
        generateColorPalettes: $bb5c99fa51be6547$export$da275153033f4ec1,
        generateNeutralColorPalettes: $bb5c99fa51be6547$export$3e0cb0c1d9c1b691
    }));
};
var $179e3c86520dcfc1$export$2e2bcd8739ae039 = $179e3c86520dcfc1$var$derivative;



"use client";
// ZombieJ: We export as object to user but array in internal.
// This is used to minimize the bundle size for antd package but safe to refactor as object also.
// Please do not export internal `useToken` directly to avoid something export unexpected.
/** Get current context Design Token. Will be different if you are using nest theme config. */ function $a978954eaf874e83$var$useToken() {
    const [theme, token, hashId] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    return {
        theme: theme,
        token: token,
        hashId: hashId
    };
}
var $a978954eaf874e83$export$2e2bcd8739ae039 = {
    defaultConfig: /** @private Test Usage. Do not use in production. */ $d6a0cd0c670c9aed$export$f84bd70098573c5c,
    /** Default seedToken */ defaultSeed: (0, $d6a0cd0c670c9aed$export$f84bd70098573c5c).token,
    useToken: $a978954eaf874e83$var$useToken,
    defaultAlgorithm: $11cb018871a499d7$export$2e2bcd8739ae039,
    darkAlgorithm: $179e3c86520dcfc1$export$2e2bcd8739ae039,
    compactAlgorithm: $7480e91aa2c69f50$export$2e2bcd8739ae039,
    getDesignToken: $64636abf1746fc18$export$2e2bcd8739ae039
};


var $acw62 = parcelRequire("acw62");






// ============================== Shared ==============================
const $798d9db240249fbb$var$genSharedDividerStyle = (token)=>{
    const { componentCls: componentCls, sizePaddingEdgeHorizontal: sizePaddingEdgeHorizontal, colorSplit: colorSplit, lineWidth: lineWidth, textPaddingInline: textPaddingInline, orientationMargin: orientationMargin, verticalMarginInline: verticalMarginInline } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            borderBlockStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`,
            // vertical
            "&-vertical": {
                position: "relative",
                top: "-0.06em",
                display: "inline-block",
                height: "0.9em",
                marginInline: verticalMarginInline,
                marginBlock: 0,
                verticalAlign: "middle",
                borderTop: 0,
                borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`
            },
            "&-horizontal": {
                display: "flex",
                clear: "both",
                width: "100%",
                minWidth: "100%",
                // Fix https://github.com/ant-design/ant-design/issues/10914
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.dividerHorizontalGutterMargin)} 0`
            },
            [`&-horizontal${componentCls}-with-text`]: {
                display: "flex",
                alignItems: "center",
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.dividerHorizontalWithTextGutterMargin)} 0`,
                color: token.colorTextHeading,
                fontWeight: 500,
                fontSize: token.fontSizeLG,
                whiteSpace: "nowrap",
                textAlign: "center",
                borderBlockStart: `0 ${colorSplit}`,
                "&::before, &::after": {
                    position: "relative",
                    width: "50%",
                    borderBlockStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} solid transparent`,
                    // Chrome not accept `inherit` in `border-top`
                    borderBlockStartColor: "inherit",
                    borderBlockEnd: 0,
                    transform: "translateY(50%)",
                    content: "''"
                }
            },
            [`&-horizontal${componentCls}-with-text-left`]: {
                "&::before": {
                    width: `calc(${orientationMargin} * 100%)`
                },
                "&::after": {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                }
            },
            [`&-horizontal${componentCls}-with-text-right`]: {
                "&::before": {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                },
                "&::after": {
                    width: `calc(${orientationMargin} * 100%)`
                }
            },
            [`${componentCls}-inner-text`]: {
                display: "inline-block",
                paddingBlock: 0,
                paddingInline: textPaddingInline
            },
            "&-dashed": {
                background: "none",
                borderColor: colorSplit,
                borderStyle: "dashed",
                borderWidth: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0`
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
                "&::before, &::after": {
                    borderStyle: "dashed none none"
                }
            },
            [`&-vertical${componentCls}-dashed`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            [`&-plain${componentCls}-with-text`]: {
                color: token.colorText,
                fontWeight: "normal",
                fontSize: token.fontSize
            },
            [`&-horizontal${componentCls}-with-text-left${componentCls}-no-default-orientation-margin-left`]: {
                "&::before": {
                    width: 0
                },
                "&::after": {
                    width: "100%"
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineStart: sizePaddingEdgeHorizontal
                }
            },
            [`&-horizontal${componentCls}-with-text-right${componentCls}-no-default-orientation-margin-right`]: {
                "&::before": {
                    width: "100%"
                },
                "&::after": {
                    width: 0
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineEnd: sizePaddingEdgeHorizontal
                }
            }
        })
    };
};
const $798d9db240249fbb$export$9ca1be8807fe0675 = (token)=>({
        textPaddingInline: "1em",
        orientationMargin: 0.05,
        verticalMarginInline: token.marginXS
    });
var // ============================== Export ==============================
$798d9db240249fbb$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Divider", (token)=>{
    const dividerToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        dividerHorizontalWithTextGutterMargin: token.margin,
        dividerHorizontalGutterMargin: token.marginLG,
        sizePaddingEdgeHorizontal: 0
    });
    return [
        $798d9db240249fbb$var$genSharedDividerStyle(dividerToken)
    ];
}, $798d9db240249fbb$export$9ca1be8807fe0675, {
    unitless: {
        orientationMargin: true
    }
});


"use client";
var $4728a501f42302e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4728a501f42302e5$var$Divider = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, divider: divider } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = "horizontal", orientation: orientation = "center", orientationMargin: orientationMargin, className: className, rootClassName: rootClassName, children: children, dashed: dashed, plain: plain, style: style } = props, restProps = $4728a501f42302e5$var$__rest(props, [
        "prefixCls",
        "type",
        "orientation",
        "orientationMargin",
        "className",
        "rootClassName",
        "children",
        "dashed",
        "plain",
        "style"
    ]);
    const prefixCls = getPrefixCls("divider", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $798d9db240249fbb$export$2e2bcd8739ae039)(prefixCls);
    const hasChildren = !!children;
    const hasCustomMarginLeft = orientation === "left" && orientationMargin != null;
    const hasCustomMarginRight = orientation === "right" && orientationMargin != null;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, divider === null || divider === void 0 ? void 0 : divider.className, hashId, cssVarCls, `${prefixCls}-${type}`, {
        [`${prefixCls}-with-text`]: hasChildren,
        [`${prefixCls}-with-text-${orientation}`]: hasChildren,
        [`${prefixCls}-dashed`]: !!dashed,
        [`${prefixCls}-plain`]: !!plain,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-no-default-orientation-margin-left`]: hasCustomMarginLeft,
        [`${prefixCls}-no-default-orientation-margin-right`]: hasCustomMarginRight
    }, className, rootClassName);
    const memoizedOrientationMargin = $acw62.useMemo(()=>{
        if (typeof orientationMargin === "number") return orientationMargin;
        if (/^\d+$/.test(orientationMargin)) return Number(orientationMargin);
        return orientationMargin;
    }, [
        orientationMargin
    ]);
    const innerStyle = Object.assign(Object.assign({}, hasCustomMarginLeft && {
        marginLeft: memoizedOrientationMargin
    }), hasCustomMarginRight && {
        marginRight: memoizedOrientationMargin
    });
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: classString,
        style: Object.assign(Object.assign({}, divider === null || divider === void 0 ? void 0 : divider.style), style)
    }, restProps, {
        // biome-ignore lint/a11y/useAriaPropsForRole: divider do not need aria-value
        role: "separator"
    }), children && type !== "vertical" && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-inner-text`,
        style: innerStyle
    }, children)));
};
var $4728a501f42302e5$export$2e2bcd8739ae039 = $4728a501f42302e5$var$Divider;






var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5eed7fae95c0ae06$var$MinusCircleTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "minus-circle",
    "theme": "twotone"
};
var $5eed7fae95c0ae06$export$2e2bcd8739ae039 = $5eed7fae95c0ae06$var$MinusCircleTwoTone;



var $94da3c83a8e5181f$var$MinusCircleTwoTone = function MinusCircleTwoTone(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5eed7fae95c0ae06$export$2e2bcd8739ae039)
    }));
};
/**![minus-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIGZpbGw9IiMxNjc3ZmYiIC8+PHBhdGggZD0iTTUxMiAxNDBjLTIwNS40IDAtMzcyIDE2Ni42LTM3MiAzNzJzMTY2LjYgMzcyIDM3MiAzNzIgMzcyLTE2Ni42IDM3Mi0zNzItMTY2LjYtMzcyLTM3Mi0zNzJ6bTE5MiAzOTZjMCA0LjQtMy42IDgtOCA4SDMyOGMtNC40IDAtOC0zLjYtOC04di00OGMwLTQuNCAzLjYtOCA4LThoMzY4YzQuNCAwIDggMy42IDggOHY0OHoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTY5NiA0ODBIMzI4Yy00LjQgMC04IDMuNi04IDh2NDhjMCA0LjQgMy42IDggOCA4aDM2OGM0LjQgMCA4LTMuNiA4LTh2LTQ4YzAtNC40LTMuNi04LTgtOHoiIGZpbGw9IiMxNjc3ZmYiIC8+PC9zdmc+) */ var $94da3c83a8e5181f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($94da3c83a8e5181f$var$MinusCircleTwoTone);
var $94da3c83a8e5181f$export$2e2bcd8739ae039 = $94da3c83a8e5181f$var$RefIcon;



"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = ((product)=>{
    return $565e85ead8bde60a$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    const threshold = 1000 / freq;
    let timer = null;
    return function throttled() {
        const force = this === true;
        const now = Date.now();
        if (force || now - timestamp > threshold) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timestamp = now;
            return fn.apply(null, arguments);
        }
        if (!timer) timer = setTimeout(()=>{
            timer = null;
            timestamp = Date.now();
            return fn.apply(null, arguments);
        }, threshold - (now - timestamp));
    };
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;


var $1a6c80b567b74091$export$2e2bcd8739ae039 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    }, freq);
};






"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType } = _config;
        let onCanceled;
        function done() {
            if (_config.cancelToken) _config.cancelToken.unsubscribe(onCanceled);
            if (_config.signal) _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, _config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (typeof _config.onDownloadProgress === "function") request.addEventListener("progress", (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(_config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof _config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(_config.onUploadProgress));
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $c9465135abb26626$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    return new ReadableStream({
        type: "bytes",
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                controller.close();
                onFinish();
                return;
            }
            let len = value.byteLength;
            onProgress && onProgress(bytes += len);
            controller.enqueue(new Uint8Array(value));
        },
        cancel (reason) {
            onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$fetchProgressDecorator = (total, fn)=>{
    const lengthComputable = total != null;
    return (loaded)=>setTimeout(()=>fn({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }));
};
const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && (()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && !!(()=>{
    try {
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
    } catch (err) {
    // return undefined
    }
})();
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, $e52be20a9fc15e96$var$fetchProgressDecorator(requestContentLength, (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(onUploadProgress)), null, $e52be20a9fc15e96$var$encodeText);
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "cors" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            withCredentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onDownloadProgress && $e52be20a9fc15e96$var$fetchProgressDecorator(responseContentLength, (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(onDownloadProgress, true)), isStreamResponse && onFinish, $e52be20a9fc15e96$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.7.2";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


const $9d936a2aecb96285$export$b27b0287c31e45de = "https://ai-api.da-tu.ca";
const $9d936a2aecb96285$export$f8a5930a19e52ae8 = "6LfA9DcqAAAAANn6q9IekaO0lyoLcikMU2ewVIJs";


const $cfadb87391ca5e26$export$b71d81bfaeb967a6 = (elements)=>{
    for (const e of elements)e.addEventListener("wheel", (e)=>{
        e.stopPropagation();
    }, {
        passive: true
    });
};
const $cfadb87391ca5e26$export$354e2109eb2648e0 = (inputs)=>{
    const previousNodes = [];
    inputs.forEach((input)=>{
        previousNodes.push(...input.previousNodes);
    });
    return previousNodes;
};
const $cfadb87391ca5e26$export$a57e9bef4b3b52d0 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
function $cfadb87391ca5e26$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $cfadb87391ca5e26$export$dd1bc94b04021eeb(arr) {
    return arr.length === 0;
}
const $cfadb87391ca5e26$export$dd6e5daab826fa5c = (fn, ms)=>{
    let timer = null;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(()=>{
            fn(...args);
        }, ms);
    };
};
const $cfadb87391ca5e26$export$8ad1e9569ec24d43 = (previousNodes)=>{
    const packageImporter = previousNodes.find((node)=>{
        return node.label === "Import Libraries";
    });
    const importStatement = packageImporter?.ImportManager.combineImportStatements() || "";
    return importStatement;
};
const $cfadb87391ca5e26$export$803b5a85accbf219 = (connection)=>{
    const source = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNodes().find((node)=>node.id === connection.source);
    const target = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNodes().find((node)=>node.id === connection.target);
    return {
        source: source,
        target: target
    };
};
const $cfadb87391ca5e26$export$7215840b05bfeace = (path1, path2, importStatement)=>{
    const minLength = Math.min(path1.length, path2.length);
    let i = 1;
    while(i < minLength && path1[i] === path2[i])i++;
    const commonAncestorPath = [
        importStatement,
        ...path1.slice(1, i)
    ];
    const path1Relative = path1.slice(i);
    const path2Relative = path2.slice(i);
    return [
        ...commonAncestorPath,
        ...path1Relative,
        ...path2Relative
    ];
};
const $cfadb87391ca5e26$export$f3642bf4730985a1 = (path1, path2)=>{
    const minLength = Math.min(path1.length, path2.length);
    let i = 0;
    while(i < minLength && path1[i].label === path2[i].label)i++;
    const commonAncestorPath = path1.slice(0, i);
    const path1Relative = path1.slice(i);
    const path2Relative = path2.slice(i);
    return [
        ...commonAncestorPath,
        ...path1Relative,
        ...path2Relative
    ];
};
const $cfadb87391ca5e26$export$ec5a5831a0a9fa3d = (previousNodes)=>{
    const model = previousNodes.find((node)=>"model" in node);
    const modelType = model?.model || null;
    return modelType;
};
const $cfadb87391ca5e26$export$155ec85c4e3b5e85 = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).create({
    baseURL: (0, $9d936a2aecb96285$export$b27b0287c31e45de),
    timeout: 10000,
    withCredentials: true
});
const $cfadb87391ca5e26$var$keyTranslations = {
    "currentURL": "Current URL",
    "url_download": "Allow URL Download",
    "uploadedDataset": "Uploaded Dataset File",
    "currentImports": "Current Imports",
    "selectedOption": "Selected Option",
    "currentCode": "Current Code",
    "currentConsole": "Current Console Output",
    "dataframeColumns": "Dataframe Columns",
    "selectedFeatures": "Selected Features",
    "targetVariable": "Target Variable",
    "testSize": "Test Size",
    "l1_ratio": "L1 Ratio",
    "max_iterations": "Maximum Iterations",
    "penalty_type": "Penalty Type",
    "solver_type": "Solver Type",
    "regularization_strength": "Regularization Strength",
    "fit_intercept": "Fit Intercept",
    "force_positive_coefficients": "Force Positive Coefficients",
    "copy_X": "Copy X",
    "plotType": "Plot Type",
    "categoricalColumn": "Categorical Column",
    "numericalColumns": "Numerical Columns",
    "bins": "Bins"
};
const $cfadb87391ca5e26$export$e568b92dd6d03d22 = (data)=>{
    return Object.keys(data).reduce((newData, key)=>{
        const translatedKey = $cfadb87391ca5e26$var$keyTranslations[key] || key; // Use translation or default to the original key
        newData[translatedKey] = data[key];
        return newData;
    }, {});
};
const $cfadb87391ca5e26$export$fa817a1d9dbb705a = (nodeType, relevantData)=>{
    switch(nodeType){
        case "DatasetImporter":
            const { value: value, useUploadedDataset: useUploadedDataset, uploadedDataset: uploadedDataset } = relevantData.data;
            return {
                currentURL: value,
                url_download: !useUploadedDataset,
                uploadedDataset: {
                    content: uploadedDataset.content,
                    fileName: uploadedDataset.fileName
                }
            };
        case "PackageImporter":
            const { selectedItems: selectedItems } = relevantData.data;
            return {
                currentImports: selectedItems
            };
        case "DataframeLoader":
            return "";
        case "DataframeInspector":
            const { option: option } = relevantData.data;
            return {
                selectedOption: option
            };
        case "CodeViewer":
            {
                const { controls: controls } = relevantData.data;
                return {
                    currentCode: controls.display.currentCode
                };
            }
        case "ConsoleViewer":
            {
                const { controls: controls } = relevantData.data;
                return {
                    currentConsole: controls.display.currentConsole
                };
            }
        case "TestTrainSplit":
            const { dataframeColumns: dataframeColumns, selectedFeatures: selectedFeatures, targetVariable: targetVariable, testSize: testSize } = relevantData.data;
            return {
                dataframeColumns: dataframeColumns,
                selectedFeatures: selectedFeatures,
                targetVariable: targetVariable,
                testSize: testSize
            };
        case "TrainModel":
            return "";
        case "LogisticRegressionModel":
            const { l1_ratio: l1_ratio, max_iter: max_iter, penalty: penalty, solver: solver, C: C } = relevantData.data;
            return {
                l1_ratio: l1_ratio,
                max_iterations: max_iter,
                penalty_type: penalty,
                solver_type: solver,
                regularization_strength: C
            };
        case "LinearRegressionModel":
            const { fitIntercept: fitIntercept, positive: positive, copyX: copyX } = relevantData.data;
            return {
                fit_intercept: fitIntercept,
                force_positive_coefficients: positive,
                copy_X: copyX
            };
        case "TrainModel":
            return "";
        case "ScoreModelBasic":
            return "";
        case "Visualizer":
            const { plotType: plotType, categoricalColumn: categoricalColumn, numericalColumns: numericalColumns, bins: bins } = relevantData.data;
            switch(plotType){
                case "scatter":
                    return {
                        plotType: plotType,
                        categoricalColumn: categoricalColumn,
                        numericalColumns: numericalColumns
                    };
                case "histogram":
                    return {
                        plotType: plotType,
                        numericalColumns: numericalColumns,
                        bins: bins
                    };
                case "heatmap":
                    return {
                        plotType: plotType
                    };
                case "bar_chart":
                    return {
                        plotType: plotType,
                        categoricalColumn: categoricalColumn,
                        numericalColumns: numericalColumns
                    };
                default:
                    return {
                        plotType: "No plot selected"
                    };
            }
        default:
            return null;
    }
};
const $cfadb87391ca5e26$export$bfb1dec8091047c0 = (type, relevantData)=>{
    switch(type){
        // GlOBAL EVENTS
        case "copy_detected":
            return {
                ...relevantData
            };
        case "paste_detected":
            return {
                ...relevantData
            };
        // EDITOR EVENTS
        case "noderemoved":
        case "nodecreated":
            {
                const nodeType = relevantData.data.getType();
                const controlData = $cfadb87391ca5e26$export$fa817a1d9dbb705a(nodeType, relevantData);
                return {
                    blockType: nodeType,
                    blockData: controlData,
                    source: relevantData.source
                };
            }
        case "nodetranslated":
            const node = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNode(relevantData.data.id);
            const nodeType = node?.getType();
            const controlData = $cfadb87391ca5e26$export$fa817a1d9dbb705a(nodeType, {
                data: node
            });
            return {
                blockType: nodeType,
                blockData: controlData
            };
        case "connectioncreated":
        case "connectionremoved":
            const source = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNode(relevantData.data.source);
            const sourceControlData = $cfadb87391ca5e26$export$fa817a1d9dbb705a(source.getType(), {
                data: source
            });
            const target = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNode(relevantData.data.target);
            const targetControlData = $cfadb87391ca5e26$export$fa817a1d9dbb705a(target.getType(), {
                data: target
            });
            return {
                source: {
                    blockType: source.getType(),
                    blockData: sourceControlData
                },
                target: {
                    blockType: target.getType(),
                    blockData: targetControlData
                }
            };
        // EDITOR CONTROLS
        case "manual_save":
        case "zoom_to_fit":
        case "auto_layout":
        case "run_program":
        case "open_image_gallery":
        case "close_image_gallery":
        case "delete_image":
            return {
                ...relevantData
            };
        // PROBLEM
        case "start_problem":
        case "submit_problem":
        case "start_new_submission":
        case "view_latest_submission":
        case "view_past_submission":
            return {
                ...relevantData
            };
        // NOTES
        case "save_note":
        case "update_note":
        case "delete_note":
            return {
                ...relevantData
            };
        // AI CHATBOT
        case "open_chatbot":
        case "close_chatbot":
        case "chatbot_request":
        case "create_new_conversation":
        case "open_problem_description":
        case "close_problem_description":
            return {
                ...relevantData
            };
        // MODULE VIEWER
        case "open_module_viewer":
        case "close_module_viewer":
        case "start_reading_module":
        case "stop_reading_module":
        case "mark_module_as_complete":
            return {
                ...relevantData
            };
        // PACKAGE IMPORTER
        case "import_library":
        case "remove_library_import":
            return {
                ...relevantData,
                blockType: "PackageImporter"
            };
        // DATASET IMPORTER
        case "upload_local_dataset":
        case "remove_local_dataset":
        case "toggle_url_download_switch":
        case "enter_url_download":
        case "preview_dataset":
        case "load_recent_dataset":
        case "delete_recent_dataset":
            return {
                ...relevantData,
                blockType: "DatasetImporter"
            };
        // TEST TRAIN SPLIT
        case "select_feature":
        case "deselect_feature":
        case "set_target_variable":
        case "set_test_size_ratio":
            return {
                ...relevantData,
                blockType: "TestTrainSplit"
            };
        // DATAFRAME INSPECTOR
        case "set_dataframe_inspection_option":
            return {
                ...relevantData,
                blockType: "DataframeInspector"
            };
        // LOGISTIC REGRESSION MODEL
        case "set_regularization_strength":
        case "set_max_iterations":
        case "set_solver_type":
        case "set_penalty_type":
        case "set_l1_ratio":
            return {
                ...relevantData,
                blockType: "LogisticRegressionModel"
            };
        // LINEAR REGRESSION MODEL
        case "set_fit_intercept":
        case "set_force_positive_coefficients":
        case "set_copy_x":
            return {
                ...relevantData,
                blockType: "LinearRegressionModel"
            };
        // VISUALIZER
        case "set_plot_type":
        case "set_categorical_column":
        case "set_numerical_column":
        case "set_bins":
        case "click_view_plots":
            return {
                ...relevantData,
                blockType: "Visualizer"
            };
        // VISUALIZER MODAL
        case "save_plot_image":
            return {
                ...relevantData,
                blockType: "VisualizerModal"
            };
        default:
            return null;
    }
};
const $cfadb87391ca5e26$export$5e4dc5c899332621 = (action, eventData)=>{
    switch(action){
        // GlOBAL EVENTS
        case "copy_detected":
            return `Copied content from ${eventData.origin}`;
        case "paste_detected":
            return `Pasted copied content into ${eventData.destination}`;
        // EDITOR EVENTS
        case "noderemoved":
            return `Deleted node ${eventData.blockType}`;
        case "nodecreated":
            return `Created node ${eventData.blockType} by ${eventData.source}`;
        case "nodetranslated":
            return `Repositioned node ${eventData.blockType}`;
        case "connectioncreated":
            return `New connection from ${eventData.source.blockType} to ${eventData.target.blockType}`;
        case "connectionremoved":
            return `Removed connection from ${eventData.source.blockType} to ${eventData.target.blockType}`;
        // PROBLEM
        case "start_problem":
            return `Started first attempt for problem ${eventData.problem_number}`;
        case "submit_problem":
            return `Submitted problem ${eventData.problem_number}, attempt #${eventData.submission_number}`;
        case "start_new_submission":
            return `Starting submission number ${eventData.submission_number} for problem ${eventData.problem_number}`;
        case "view_latest_submission":
            return `Viewed latest submission (${eventData.submission_number}) for problem ${eventData.problem_number}`;
        case "view_past_submission":
            return `Viewed past submission (${eventData.submission_number}) for problem ${eventData.problem_number}`;
        // NOTES
        case "save_note":
            return `Saved new note with ID ${eventData.note_id}${eventData.title ? ` and title '${eventData.title}'` : ""}`;
        case "update_note":
            return `Updated note with ID ${eventData.note_id}`;
        case "delete_note":
            return `Deleted note with ID ${eventData.note_id}`;
        // AI CHATBOT
        case "open_chatbot":
            return `Opened the AI chatbot`;
        case "close_chatbot":
            return `Closed the AI chatbot`;
        case "chatbot_request":
            return `Chatbot request: ${eventData.request}`;
        case "create_new_conversation":
            return `Created a conversation with the 'New Chat' button`;
        // PROBLEM DESCRIPTION
        case "open_problem_description":
            return `Opened the problem description drawer`;
        case "close_problem_description":
            return `Closed the problem description drawer`;
        // MODULE VIEWER
        case "open_module_viewer":
            return `Opened the module viewer`;
        case "close_module_viewer":
            return `Closed the module viewer`;
        case "start_reading_module":
            return `Started reading module ${eventData.module_number}: ${eventData.title}`;
        case "stop_reading_module":
            return `Stopped reading module ${eventData.module_number}: ${eventData.title}`;
        case "mark_module_as_complete":
            return `Marked module ${eventData.module_number}: ${eventData.title} as complete`;
        // EDITOR CONTROLS
        case "manual_save":
            return `Clicked the editor save button`;
        case "zoom_to_fit":
            return `Clicked the zoom-to-fit button`;
        case "auto_layout":
            return "Clicked the auto-layout button";
        case "noderesized":
            return "Currently side effect from auto_layout";
        case "run_program":
            return "Clicked the main run program button";
        case "open_image_gallery":
            return "Opened the image gallery modal";
        case "close_image_gallery":
            return "Closed the image gallery modal";
        case "delete_image":
            return `Deleted image ID ${eventData.deleted_image_id}`;
        // PACKAGE IMPORTER
        case "import_library":
            return `Imported library '${eventData.libraryName}'`;
        case "remove_library_import":
            return `Removed library '${eventData.libraryName}'`;
        // DATASET IMPORTER
        case "upload_local_dataset":
            return `Uploaded ${eventData.fileName}`;
        case "remove_local_dataset":
            return `Removed ${eventData.fileName}`;
        case "toggle_url_download_switch":
            return `Toggled URL download switch to ${eventData.url_download}`;
        case "enter_url_download":
            return `Entered URL ${eventData.currentURL}`;
        case "preview_dataset":
            return `Previewed dataset`;
        case "load_recent_dataset":
            return `Selected "${eventData.fileName}" from recent datasets list`;
        case "delete_recent_dataset":
            return `Deleted dataset ${eventData.fileName} from recent datasets list`;
        // TEST TRAIN SPLIT
        case "select_feature":
            return `Selected feature '${eventData.featureName}'`;
        case "deselect_feature":
            return `Deselected feature '${eventData.featureName}'`;
        case "set_target_variable":
            return `Set target variable to '${eventData.targetVariable}'`;
        case "set_test_size_ratio":
            return `Set test size ratio to '${eventData.testSize}'`;
        // DATAFRAME INSPECTOR
        case "set_dataframe_inspection_option":
            return `Set dataframe inspection option to '${eventData.inspection_option}'`;
        // LOGISTIC REGRESSION MODEL
        case "set_l1_ratio":
            return `Set L1 ratio to '${eventData.l1_ratio}'`;
        case "set_max_iterations":
            return `Set max iterations to '${eventData.max_iterations}'`;
        case "set_regularization_strength":
            return `Set regularization strength to '${eventData.regularization_strength}'`;
        case "set_solver_type":
            return `Set solver type to '${eventData.solver_type}'`;
        case "set_penalty_type":
            return `Set penalty type to '${eventData.penalty_type}'`;
        // LINEAR REGRESSION MODEL
        case "set_fit_intercept":
            return `Set fit intercept to '${eventData.fit_intercept}'`;
        case "set_force_positive_coefficients":
            return `Set force positive coefficients to '${eventData.force_positive_coefficients}'`;
        case "set_copy_x":
            return `Set copy x to '${eventData.copy_X}'`;
        // VISUALIZER
        case "set_plot_type":
            return `Set plot type to '${eventData.plotType}'`;
        case "set_categorical_column":
            return `Set categorical column to '${eventData.categorical_column}' for plot type '${eventData.plotType}'`;
        case "set_numerical_column":
            return `Add numerical column '${eventData.new_column}' for plot type '${eventData.plotType}'`;
        case "set_bins":
            return `Set bins to '${eventData.bins}' for plot type '${eventData.plotType}'`;
        case "click_view_plots":
            return `Viewed plots (if any) for plot type '${eventData.plotType}'`;
        // VISUALIZER MODAL
        case "save_plot_image":
            return `Saved plot image titled '${eventData.imageTitle}'`;
        default:
            return null;
    }
};
const $cfadb87391ca5e26$export$7e41d6135b9d82b9 = async (log)=>{
    try {
        const res = await $cfadb87391ca5e26$export$155ec85c4e3b5e85.post("/api/logs/user-action", log, {
            withCredentials: true
        });
    } catch (error) {
        console.error(error);
    }
};
const $cfadb87391ca5e26$export$227fec498bd204c4 = (origin, relevantData)=>{
    const selection = window.getSelection();
    if (selection) {
        const selectedText = selection.toString();
        if (selectedText) (0, $14e68cbe3c2b3085$export$83fc28f458189523)("copy_detected", {
            content: selectedText,
            origin: origin,
            ...relevantData
        }, true);
    }
};
const $cfadb87391ca5e26$export$e7e57daa27256709 = (destination, e)=>{
    const pasted_content = e.clipboardData.getData("text");
    if (pasted_content) (0, $14e68cbe3c2b3085$export$83fc28f458189523)("paste_detected", {
        destination: destination,
        pasted_content: pasted_content
    }, true);
};



const $fc4821d378713000$var$ExtendedList = ({ onPointerDown: onPointerDown, ...rest })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        onPointerDown: onPointerDown,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c8a82c84763151b1$export$2e2bcd8739ae039), {
            ...rest
        })
    });
};
const $fc4821d378713000$var$DROPDOWN_TEXT_DEFAULT = "Add Library";
function $fc4821d378713000$var$CustomDropdownList(props) {
    const [selected, setSelected] = (0, $acw62.useState)($fc4821d378713000$var$DROPDOWN_TEXT_DEFAULT);
    const [currentItems, setCurrentItems] = (0, $acw62.useState)(props.data.selectedItems);
    const context = props.data.context;
    const handleChange = (value)=>{
        setSelected($fc4821d378713000$var$DROPDOWN_TEXT_DEFAULT);
        props.data.onOptionSelect(value, setCurrentItems);
        context.markTaskAsCompleted("importLibraries");
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)(`import_library`, {
            libraryName: value
        });
    };
    const handleRemove = (value)=>{
        // If we're removing the only imported library, must revoke task completion
        if (currentItems.length === 1) context.removeTaskFromCompleted("importLibraries");
        props.data.removeImport(value, setCurrentItems);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)(`remove_library_import`, {
            libraryName: value
        });
    };
    (0, $acw62.useEffect)(()=>{
        const listContainers = document.querySelectorAll(".listContainer");
        (0, $cfadb87391ca5e26$export$b71d81bfaeb967a6)(listContainers);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "moduleSelectorContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            theme: {
                algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c24bb3319861fe36$export$b48985bba8f530f5).NoDrag, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                        className: "selectDropDown",
                        onChange: handleChange,
                        value: selected,
                        dropdownStyle: {
                            width: "fit-content"
                        },
                        options: props.data.options.map((option, index)=>{
                            let disabled = props.data.alreadySelected(option);
                            return {
                                value: option,
                                disabled: disabled,
                                title: disabled ? `${option} already imported` : `Import ${option}`
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fc4821d378713000$var$ExtendedList, {
                        className: "listContainer",
                        size: "small",
                        bordered: true,
                        dataSource: [
                            ...currentItems
                        ],
                        onPointerDown: (e)=>{
                            e.stopPropagation();
                        },
                        renderItem: (item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c8a82c84763151b1$export$2e2bcd8739ae039).Item, {
                                className: "listItem",
                                onPointerDown: (e)=>{
                                    e.stopPropagation();
                                },
                                style: {
                                    display: "flex",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    item,
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $94da3c83a8e5181f$export$2e2bcd8739ae039), {
                                        className: "removeLibraryIcon",
                                        twoToneColor: "red",
                                        tabIndex: 0,
                                        role: "button",
                                        title: "Remove import",
                                        "aria-label": `Remove import`,
                                        onClick: ()=>handleRemove(item)
                                    })
                                ]
                            })
                    })
                ]
            })
        })
    });
}
var $fc4821d378713000$export$2e2bcd8739ae039 = $fc4821d378713000$var$CustomDropdownList;



class $880a521727a0b65e$export$28c39c52cb1444cb extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    options;
    onOptionSelect;
    selectedItems;
    alreadySelected;
    removeImport;
    task_id;
    context;
    constructor(options, onOptionSelect, selectedItems, alreadySelected, removeImport, task_id, context){
        super();
        this.options = options;
        this.onOptionSelect = onOptionSelect;
        this.selectedItems = selectedItems;
        this.alreadySelected = alreadySelected;
        this.removeImport = removeImport;
        this.task_id = task_id;
        this.context = context;
    }
    setSelectedItems(items) {
        this.selectedItems = items;
    }
    setupControls(controlData) {
        this.selectedItems = controlData.selectedItems;
    }
}




const $ac9dba44400f7ac7$var$baseImportConversion = {
    Pandas: "import pandas as pd",
    Numpy: "import numpy as np",
    "Sci-Py": "import scipy as sp",
    "Scikit-Learn": "import sklearn as sk",
    Matplotlib: "import matplotlib.pyplot as plt",
    Seaborn: "import seaborn as sns"
};
class $ac9dba44400f7ac7$export$63942b8d29098e92 {
    currentImports = [];
    constructor(){}
    addBaseImport(libraryName) {
        let importStatementArray = [];
        if (libraryName in $ac9dba44400f7ac7$var$baseImportConversion) importStatementArray.push($ac9dba44400f7ac7$var$baseImportConversion[libraryName]);
        else importStatementArray.push(`import ${libraryName}`);
        this.currentImports.push({
            libraryName: libraryName,
            importStatementArray: importStatementArray
        });
    }
    removeBaseImport(libraryName) {
        const index = this.currentImports.findIndex((i)=>i.libraryName === libraryName);
        if (index !== -1) this.currentImports.splice(index, 1);
    }
    addSpecificImport(libraryName, importStatement) {
        const index = this.currentImports.findIndex((i)=>i.libraryName === libraryName);
        if (index !== -1) {
            const targetImport = this.currentImports[index];
            for (const specificImport of targetImport.importStatementArray){
                if (specificImport === importStatement) return;
            }
            targetImport.importStatementArray.push(importStatement);
            if (targetImport.importStatementArray.length === 2 && targetImport.importStatementArray[0] === $ac9dba44400f7ac7$var$baseImportConversion[libraryName]) this.removeSpecificImport(libraryName, $ac9dba44400f7ac7$var$baseImportConversion[libraryName]);
        }
    }
    removeSpecificImport(libraryName, importStatement) {
        const index = this.currentImports.findIndex((i)=>i.libraryName === libraryName);
        if (index !== -1) {
            if (this.currentImports[index].importStatementArray.length === 1) {
                this.removeBaseImport(libraryName);
                return;
            }
            const filteredImportStatements = this.currentImports[index].importStatementArray.filter((i)=>i !== importStatement);
            this.currentImports[index].importStatementArray = [
                ...filteredImportStatements
            ];
        }
    }
    removeAllSpecificImports() {
        for(let i = 0; i < this.currentImports.length; i++){
            const libraryName = this.currentImports[i].libraryName;
            this.currentImports[i].importStatementArray = [
                $ac9dba44400f7ac7$var$baseImportConversion[libraryName]
            ];
        }
    }
    combineImportStatements() {
        let codeArray = [];
        const baseImports = this.currentImports.map((i)=>i.importStatementArray);
        for (const importStatement of baseImports)codeArray = [
            ...codeArray,
            ...importStatement
        ];
        return codeArray.join("\n") + "\n";
    }
}


class $2fb57d68275642e6$export$ffa639bf02197be7 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    height = 380;
    width = 180;
    selectedItems = [];
    ImportManager = new (0, $ac9dba44400f7ac7$export$63942b8d29098e92)();
    task_id = "createLibraryImporter";
    change;
    update;
    constructor(socket, change, update, context){
        super("Import Libraries");
        this.addInput("input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Input"));
        this.addOutput("output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Imported libraries"));
        const optionsForDropdown = [
            "Pandas",
            "Numpy",
            "Sci-Py",
            "Scikit-Learn",
            "Matplotlib",
            "Seaborn"
        ];
        const dropdownListControl = new (0, $880a521727a0b65e$export$28c39c52cb1444cb)(optionsForDropdown, this.handleSelect.bind(this), this.selectedItems, this.alreadySelected.bind(this), this.handleRemove.bind(this), this.task_id, context);
        this.addControl("dropdown", dropdownListControl);
        this.change = change;
        this.update = update;
    }
    getType() {
        return "PackageImporter";
    }
    getDisplayName() {
        return "Package Importer";
    }
    #numSelectedItems() {
        return this.selectedItems.length;
    }
    #refresh() {
        this.update("node", this);
        this.change();
    }
    alreadySelected(option) {
        return this.selectedItems.includes(option);
    }
    handleSelect(option, updateState) {
        if (!this.selectedItems.includes(option)) {
            this.selectedItems.push(option);
            this.controls.dropdown.setSelectedItems([
                ...this.selectedItems
            ]);
            this.ImportManager.addBaseImport(option);
            updateState([
                ...this.selectedItems
            ]);
            this.#refresh();
        }
    }
    handleRemove(option, updateState) {
        const remainingItems = this.selectedItems.filter((item)=>item !== option);
        this.selectedItems = [
            ...remainingItems
        ];
        this.controls.dropdown.setSelectedItems([
            ...this.selectedItems
        ]);
        this.ImportManager.removeBaseImport(option);
        updateState([
            ...remainingItems
        ]);
        this.#refresh();
    }
    #refreshImportManager() {
        this.ImportManager.currentImports = [];
        for (const item of this.selectedItems)this.ImportManager.addBaseImport(item);
    }
    data(inputs) {
        this.#refreshImportManager();
        const inputConnection = inputs.input?.[0];
        let code = [];
        const currentCode = this.#numSelectedItems() === 0 ? [
            "# Import Libraries"
        ] : [
            this.ImportManager.combineImportStatements()
        ];
        if (inputConnection) code = [
            ...inputConnection.code
        ];
        code.push(...currentCode);
        // const previousNodes: PreviousNodeData[] = getPreviousNodes(Object.values(inputs));
        const previousNodes = inputs.input?.[0].previousNodes || [];
        const currentNode = {
            ...this,
            connectedPort: this.outputs.output
        };
        const output = {
            code: code,
            previousNodes: [
                ...previousNodes,
                currentNode
            ]
        };
        return {
            output: output
        };
    }
}



class $e43c57db4a9e93f6$export$76f5e7e1abc7c58d extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    currentCode;
    constructor(currentCode){
        super();
        this.currentCode = currentCode;
    }
    setValue(code) {
        this.currentCode = code;
    }
}



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
The data structure for documents. @nonabstract
*/ class $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    /**
    Get the line description around the given position.
    */ lineAt(pos) {
        if (pos < 0 || pos > this.length) throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
        return this.lineInner(pos, false, 1, 0);
    }
    /**
    Get the description for the given (1-based) line number.
    */ line(n) {
        if (n < 1 || n > this.lines) throw new RangeError(`Invalid line number ${n} in ${this.lines}-line document`);
        return this.lineInner(n, true, 1, 0);
    }
    /**
    Replace a range of the text with the given content.
    */ replace(from, to, text) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let parts = [];
        this.decompose(0, from, parts, 2 /* Open.To */ );
        if (text.length) text.decompose(0, text.length, parts, 3 /* Open.To */ );
        this.decompose(to, this.length, parts, 1 /* Open.From */ );
        return $6295c6875f57e3ee$var$TextNode.from(parts, this.length - (to - from) + text.length);
    }
    /**
    Append another document to this one.
    */ append(other) {
        return this.replace(this.length, this.length, other);
    }
    /**
    Retrieve the text between the given points.
    */ slice(from, to = this.length) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let parts = [];
        this.decompose(from, to, parts, 0);
        return $6295c6875f57e3ee$var$TextNode.from(parts, to - from);
    }
    /**
    Test whether this text is equal to another instance.
    */ eq(other) {
        if (other == this) return true;
        if (other.length != this.length || other.lines != this.lines) return false;
        let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
        let a = new $6295c6875f57e3ee$var$RawTextCursor(this), b = new $6295c6875f57e3ee$var$RawTextCursor(other);
        for(let skip = start, pos = start;;){
            a.next(skip);
            b.next(skip);
            skip = 0;
            if (a.lineBreak != b.lineBreak || a.done != b.done || a.value != b.value) return false;
            pos += a.value.length;
            if (a.done || pos >= end) return true;
        }
    }
    /**
    Iterate over the text. When `dir` is `-1`, iteration happens
    from end to start. This will return lines and the breaks between
    them as separate strings.
    */ iter(dir = 1) {
        return new $6295c6875f57e3ee$var$RawTextCursor(this, dir);
    }
    /**
    Iterate over a range of the text. When `from` > `to`, the
    iterator will run in reverse.
    */ iterRange(from, to = this.length) {
        return new $6295c6875f57e3ee$var$PartialTextCursor(this, from, to);
    }
    /**
    Return a cursor that iterates over the given range of lines,
    _without_ returning the line breaks between, and yielding empty
    strings for empty lines.
    
    When `from` and `to` are given, they should be 1-based line numbers.
    */ iterLines(from, to) {
        let inner;
        if (from == null) inner = this.iter();
        else {
            if (to == null) to = this.lines + 1;
            let start = this.line(from).from;
            inner = this.iterRange(start, Math.max(start, to == this.lines + 1 ? this.length : to <= 1 ? 0 : this.line(to - 1).to));
        }
        return new $6295c6875f57e3ee$var$LineCursor(inner);
    }
    /**
    Return the document as a string, using newline characters to
    separate lines.
    */ toString() {
        return this.sliceString(0);
    }
    /**
    Convert the document to an array of lines (which can be
    deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
    */ toJSON() {
        let lines = [];
        this.flatten(lines);
        return lines;
    }
    /**
    @internal
    */ constructor(){}
    /**
    Create a `Text` instance for the given array of lines.
    */ static of(text) {
        if (text.length == 0) throw new RangeError("A document must have at least one line");
        if (text.length == 1 && !text[0]) return $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty;
        return text.length <= 32 /* Tree.Branch */  ? new $6295c6875f57e3ee$var$TextLeaf(text) : $6295c6875f57e3ee$var$TextNode.from($6295c6875f57e3ee$var$TextLeaf.split(text, []));
    }
}
// Leaves store an array of line strings. There are always line breaks
// between these strings. Leaves are limited in size and have to be
// contained in TextNode instances for bigger documents.
class $6295c6875f57e3ee$var$TextLeaf extends $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    constructor(text, length = $6295c6875f57e3ee$var$textLength(text)){
        super();
        this.text = text;
        this.length = length;
    }
    get lines() {
        return this.text.length;
    }
    get children() {
        return null;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let string = this.text[i], end = offset + string.length;
            if ((isLine ? line : end) >= target) return new $6295c6875f57e3ee$export$17d680238e50603e(offset, end, line, string);
            offset = end + 1;
            line++;
        }
    }
    decompose(from, to, target, open) {
        let text = from <= 0 && to >= this.length ? this : new $6295c6875f57e3ee$var$TextLeaf($6295c6875f57e3ee$var$sliceText(this.text, from, to), Math.min(to, this.length) - Math.max(0, from));
        if (open & 1 /* Open.From */ ) {
            let prev = target.pop();
            let joined = $6295c6875f57e3ee$var$appendText(text.text, prev.text.slice(), 0, text.length);
            if (joined.length <= 32 /* Tree.Branch */ ) target.push(new $6295c6875f57e3ee$var$TextLeaf(joined, prev.length + text.length));
            else {
                let mid = joined.length >> 1;
                target.push(new $6295c6875f57e3ee$var$TextLeaf(joined.slice(0, mid)), new $6295c6875f57e3ee$var$TextLeaf(joined.slice(mid)));
            }
        } else target.push(text);
    }
    replace(from, to, text) {
        if (!(text instanceof $6295c6875f57e3ee$var$TextLeaf)) return super.replace(from, to, text);
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let lines = $6295c6875f57e3ee$var$appendText(this.text, $6295c6875f57e3ee$var$appendText(text.text, $6295c6875f57e3ee$var$sliceText(this.text, 0, from)), to);
        let newLen = this.length + text.length - (to - from);
        if (lines.length <= 32 /* Tree.Branch */ ) return new $6295c6875f57e3ee$var$TextLeaf(lines, newLen);
        return $6295c6875f57e3ee$var$TextNode.from($6295c6875f57e3ee$var$TextLeaf.split(lines, []), newLen);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let result = "";
        for(let pos = 0, i = 0; pos <= to && i < this.text.length; i++){
            let line = this.text[i], end = pos + line.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += line.slice(Math.max(0, from - pos), to - pos);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let line of this.text)target.push(line);
    }
    scanIdentical() {
        return 0;
    }
    static split(text, target) {
        let part = [], len = -1;
        for (let line of text){
            part.push(line);
            len += line.length + 1;
            if (part.length == 32 /* Tree.Branch */ ) {
                target.push(new $6295c6875f57e3ee$var$TextLeaf(part, len));
                part = [];
                len = -1;
            }
        }
        if (len > -1) target.push(new $6295c6875f57e3ee$var$TextLeaf(part, len));
        return target;
    }
}
// Nodes provide the tree structure of the `Text` type. They store a
// number of other nodes or leaves, taking care to balance themselves
// on changes. There are implied line breaks _between_ the children of
// a node (but not before the first or after the last child).
class $6295c6875f57e3ee$var$TextNode extends $6295c6875f57e3ee$export$5f1af8db9871e1d6 {
    constructor(children, length){
        super();
        this.children = children;
        this.length = length;
        this.lines = 0;
        for (let child of children)this.lines += child.lines;
    }
    lineInner(target, isLine, line, offset) {
        for(let i = 0;; i++){
            let child = this.children[i], end = offset + child.length, endLine = line + child.lines - 1;
            if ((isLine ? endLine : end) >= target) return child.lineInner(target, isLine, line, offset);
            offset = end + 1;
            line = endLine + 1;
        }
    }
    decompose(from, to, target, open) {
        for(let i = 0, pos = 0; pos <= to && i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (from <= end && to >= pos) {
                let childOpen = open & ((pos <= from ? 1 /* Open.From */  : 0) | (end >= to ? 2 /* Open.To */  : 0));
                if (pos >= from && end <= to && !childOpen) target.push(child);
                else child.decompose(from - pos, to - pos, target, childOpen);
            }
            pos = end + 1;
        }
    }
    replace(from, to, text) {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        if (text.lines < this.lines) for(let i = 0, pos = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            // Fast path: if the change only affects one child and the
            // child's size remains in the acceptable range, only update
            // that child
            if (from >= pos && to <= end) {
                let updated = child.replace(from - pos, to - pos, text);
                let totalLines = this.lines - child.lines + updated.lines;
                if (updated.lines < totalLines >> 4 && updated.lines > totalLines >> 6) {
                    let copy = this.children.slice();
                    copy[i] = updated;
                    return new $6295c6875f57e3ee$var$TextNode(copy, this.length - (to - from) + text.length);
                }
                return super.replace(pos, end, updated);
            }
            pos = end + 1;
        }
        return super.replace(from, to, text);
    }
    sliceString(from, to = this.length, lineSep = "\n") {
        [from, to] = $6295c6875f57e3ee$var$clip(this, from, to);
        let result = "";
        for(let i = 0, pos = 0; i < this.children.length && pos <= to; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos > from && i) result += lineSep;
            if (from < end && to > pos) result += child.sliceString(from - pos, to - pos, lineSep);
            pos = end + 1;
        }
        return result;
    }
    flatten(target) {
        for (let child of this.children)child.flatten(target);
    }
    scanIdentical(other, dir) {
        if (!(other instanceof $6295c6875f57e3ee$var$TextNode)) return 0;
        let length = 0;
        let [iA, iB, eA, eB] = dir > 0 ? [
            0,
            0,
            this.children.length,
            other.children.length
        ] : [
            this.children.length - 1,
            other.children.length - 1,
            -1,
            -1
        ];
        for(;; iA += dir, iB += dir){
            if (iA == eA || iB == eB) return length;
            let chA = this.children[iA], chB = other.children[iB];
            if (chA != chB) return length + chA.scanIdentical(chB, dir);
            length += chA.length + 1;
        }
    }
    static from(children, length = children.reduce((l, ch)=>l + ch.length + 1, -1)) {
        let lines = 0;
        for (let ch of children)lines += ch.lines;
        if (lines < 32 /* Tree.Branch */ ) {
            let flat = [];
            for (let ch of children)ch.flatten(flat);
            return new $6295c6875f57e3ee$var$TextLeaf(flat, length);
        }
        let chunk = Math.max(32 /* Tree.Branch */ , lines >> 5 /* Tree.BranchShift */ ), maxChunk = chunk << 1, minChunk = chunk >> 1;
        let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
        function add(child) {
            let last;
            if (child.lines > maxChunk && child instanceof $6295c6875f57e3ee$var$TextNode) for (let node of child.children)add(node);
            else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
                flush();
                chunked.push(child);
            } else if (child instanceof $6295c6875f57e3ee$var$TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof $6295c6875f57e3ee$var$TextLeaf && child.lines + last.lines <= 32 /* Tree.Branch */ ) {
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk[currentChunk.length - 1] = new $6295c6875f57e3ee$var$TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
            } else {
                if (currentLines + child.lines > chunk) flush();
                currentLines += child.lines;
                currentLen += child.length + 1;
                currentChunk.push(child);
            }
        }
        function flush() {
            if (currentLines == 0) return;
            chunked.push(currentChunk.length == 1 ? currentChunk[0] : $6295c6875f57e3ee$var$TextNode.from(currentChunk, currentLen));
            currentLen = -1;
            currentLines = currentChunk.length = 0;
        }
        for (let child of children)add(child);
        flush();
        return chunked.length == 1 ? chunked[0] : new $6295c6875f57e3ee$var$TextNode(chunked, length);
    }
}
$6295c6875f57e3ee$export$5f1af8db9871e1d6.empty = /*@__PURE__*/ new $6295c6875f57e3ee$var$TextLeaf([
    ""
], 0);
function $6295c6875f57e3ee$var$textLength(text) {
    let length = -1;
    for (let line of text)length += line.length + 1;
    return length;
}
function $6295c6875f57e3ee$var$appendText(text, target, from = 0, to = 1e9) {
    for(let pos = 0, i = 0, first = true; i < text.length && pos <= to; i++){
        let line = text[i], end = pos + line.length;
        if (end >= from) {
            if (end > to) line = line.slice(0, to - pos);
            if (pos < from) line = line.slice(from - pos);
            if (first) {
                target[target.length - 1] += line;
                first = false;
            } else target.push(line);
        }
        pos = end + 1;
    }
    return target;
}
function $6295c6875f57e3ee$var$sliceText(text, from, to) {
    return $6295c6875f57e3ee$var$appendText(text, [
        ""
    ], from, to);
}
class $6295c6875f57e3ee$var$RawTextCursor {
    constructor(text, dir = 1){
        this.dir = dir;
        this.done = false;
        this.lineBreak = false;
        this.value = "";
        this.nodes = [
            text
        ];
        this.offsets = [
            dir > 0 ? 1 : (text instanceof $6295c6875f57e3ee$var$TextLeaf ? text.text.length : text.children.length) << 1
        ];
    }
    nextInner(skip, dir) {
        this.done = this.lineBreak = false;
        for(;;){
            let last = this.nodes.length - 1;
            let top = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
            let size = top instanceof $6295c6875f57e3ee$var$TextLeaf ? top.text.length : top.children.length;
            if (offset == (dir > 0 ? size : 0)) {
                if (last == 0) {
                    this.done = true;
                    this.value = "";
                    return this;
                }
                if (dir > 0) this.offsets[last - 1]++;
                this.nodes.pop();
                this.offsets.pop();
            } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
                this.offsets[last] += dir;
                if (skip == 0) {
                    this.lineBreak = true;
                    this.value = "\n";
                    return this;
                }
                skip--;
            } else if (top instanceof $6295c6875f57e3ee$var$TextLeaf) {
                // Move to the next string
                let next = top.text[offset + (dir < 0 ? -1 : 0)];
                this.offsets[last] += dir;
                if (next.length > Math.max(0, skip)) {
                    this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
                    return this;
                }
                skip -= next.length;
            } else {
                let next = top.children[offset + (dir < 0 ? -1 : 0)];
                if (skip > next.length) {
                    skip -= next.length;
                    this.offsets[last] += dir;
                } else {
                    if (dir < 0) this.offsets[last]--;
                    this.nodes.push(next);
                    this.offsets.push(dir > 0 ? 1 : (next instanceof $6295c6875f57e3ee$var$TextLeaf ? next.text.length : next.children.length) << 1);
                }
            }
        }
    }
    next(skip = 0) {
        if (skip < 0) {
            this.nextInner(-skip, -this.dir);
            skip = this.value.length;
        }
        return this.nextInner(skip, this.dir);
    }
}
class $6295c6875f57e3ee$var$PartialTextCursor {
    constructor(text, start, end){
        this.value = "";
        this.done = false;
        this.cursor = new $6295c6875f57e3ee$var$RawTextCursor(text, start > end ? -1 : 1);
        this.pos = start > end ? text.length : 0;
        this.from = Math.min(start, end);
        this.to = Math.max(start, end);
    }
    nextInner(skip, dir) {
        if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
            this.value = "";
            this.done = true;
            return this;
        }
        skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
        let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
        if (skip > limit) skip = limit;
        limit -= skip;
        let { value: value } = this.cursor.next(skip);
        this.pos += (value.length + skip) * dir;
        this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
        this.done = !this.value;
        return this;
    }
    next(skip = 0) {
        if (skip < 0) skip = Math.max(skip, this.from - this.pos);
        else if (skip > 0) skip = Math.min(skip, this.to - this.pos);
        return this.nextInner(skip, this.cursor.dir);
    }
    get lineBreak() {
        return this.cursor.lineBreak && this.value != "";
    }
}
class $6295c6875f57e3ee$var$LineCursor {
    constructor(inner){
        this.inner = inner;
        this.afterBreak = true;
        this.value = "";
        this.done = false;
    }
    next(skip = 0) {
        let { done: done, lineBreak: lineBreak, value: value } = this.inner.next(skip);
        if (done && this.afterBreak) {
            this.value = "";
            this.afterBreak = false;
        } else if (done) {
            this.done = true;
            this.value = "";
        } else if (lineBreak) {
            if (this.afterBreak) this.value = "";
            else {
                this.afterBreak = true;
                this.next();
            }
        } else {
            this.value = value;
            this.afterBreak = false;
        }
        return this;
    }
    get lineBreak() {
        return false;
    }
}
if (typeof Symbol != "undefined") {
    $6295c6875f57e3ee$export$5f1af8db9871e1d6.prototype[Symbol.iterator] = function() {
        return this.iter();
    };
    $6295c6875f57e3ee$var$RawTextCursor.prototype[Symbol.iterator] = $6295c6875f57e3ee$var$PartialTextCursor.prototype[Symbol.iterator] = $6295c6875f57e3ee$var$LineCursor.prototype[Symbol.iterator] = function() {
        return this;
    };
}
/**
This type describes a line in the document. It is created
on-demand when lines are [queried](https://codemirror.net/6/docs/ref/#state.Text.lineAt).
*/ class $6295c6875f57e3ee$export$17d680238e50603e {
    /**
    @internal
    */ constructor(/**
    The position of the start of the line.
    */ from, /**
    The position at the end of the line (_before_ the line break,
    or at the end of document for the last line).
    */ to, /**
    This line's line number (1-based).
    */ number, /**
    The line's content.
    */ text){
        this.from = from;
        this.to = to;
        this.number = number;
        this.text = text;
    }
    /**
    The length of the line (not including any line break after it).
    */ get length() {
        return this.to - this.from;
    }
}
function $6295c6875f57e3ee$var$clip(text, from, to) {
    from = Math.max(0, Math.min(text.length, from));
    return [
        from,
        Math.max(from, Math.min(text.length, to))
    ];
}
// Compressed representation of the Grapheme_Cluster_Break=Extend
// information from
// http://www.unicode.org/Public/13.0.0/ucd/auxiliary/GraphemeBreakProperty.txt.
// Each pair of elements represents a range, as an offet from the
// previous range and a length. Numbers are in base-36, with the empty
// string being a shorthand for 1.
let $6295c6875f57e3ee$var$extend = /*@__PURE__*/ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s)=>s ? parseInt(s, 36) : 1);
// Convert offsets into absolute values
for(let i = 1; i < $6295c6875f57e3ee$var$extend.length; i++)$6295c6875f57e3ee$var$extend[i] += $6295c6875f57e3ee$var$extend[i - 1];
function $6295c6875f57e3ee$var$isExtendingChar(code) {
    for(let i = 1; i < $6295c6875f57e3ee$var$extend.length; i += 2)if ($6295c6875f57e3ee$var$extend[i] > code) return $6295c6875f57e3ee$var$extend[i - 1] <= code;
    return false;
}
function $6295c6875f57e3ee$var$isRegionalIndicator(code) {
    return code >= 0x1F1E6 && code <= 0x1F1FF;
}
const $6295c6875f57e3ee$var$ZWJ = 0x200d;
/**
Returns a next grapheme cluster break _after_ (not equal to)
`pos`, if `forward` is true, or before otherwise. Returns `pos`
itself if no further cluster break is available in the string.
Moves across surrogate pairs, extending characters (when
`includeExtending` is true), characters joined with zero-width
joiners, and flag emoji.
*/ function $6295c6875f57e3ee$export$a0fa439fd515e1ed(str, pos, forward = true, includeExtending = true) {
    return (forward ? $6295c6875f57e3ee$var$nextClusterBreak : $6295c6875f57e3ee$var$prevClusterBreak)(str, pos, includeExtending);
}
function $6295c6875f57e3ee$var$nextClusterBreak(str, pos, includeExtending) {
    if (pos == str.length) return pos;
    // If pos is in the middle of a surrogate pair, move to its start
    if (pos && $6295c6875f57e3ee$var$surrogateLow(str.charCodeAt(pos)) && $6295c6875f57e3ee$var$surrogateHigh(str.charCodeAt(pos - 1))) pos--;
    let prev = $6295c6875f57e3ee$export$42977f40461e1360(str, pos);
    pos += $6295c6875f57e3ee$export$a870abf234f6353c(prev);
    while(pos < str.length){
        let next = $6295c6875f57e3ee$export$42977f40461e1360(str, pos);
        if (prev == $6295c6875f57e3ee$var$ZWJ || next == $6295c6875f57e3ee$var$ZWJ || includeExtending && $6295c6875f57e3ee$var$isExtendingChar(next)) {
            pos += $6295c6875f57e3ee$export$a870abf234f6353c(next);
            prev = next;
        } else if ($6295c6875f57e3ee$var$isRegionalIndicator(next)) {
            let countBefore = 0, i = pos - 2;
            while(i >= 0 && $6295c6875f57e3ee$var$isRegionalIndicator($6295c6875f57e3ee$export$42977f40461e1360(str, i))){
                countBefore++;
                i -= 2;
            }
            if (countBefore % 2 == 0) break;
            else pos += 2;
        } else break;
    }
    return pos;
}
function $6295c6875f57e3ee$var$prevClusterBreak(str, pos, includeExtending) {
    while(pos > 0){
        let found = $6295c6875f57e3ee$var$nextClusterBreak(str, pos - 2, includeExtending);
        if (found < pos) return found;
        pos--;
    }
    return 0;
}
function $6295c6875f57e3ee$var$surrogateLow(ch) {
    return ch >= 0xDC00 && ch < 0xE000;
}
function $6295c6875f57e3ee$var$surrogateHigh(ch) {
    return ch >= 0xD800 && ch < 0xDC00;
}
/**
Find the code point at the given position in a string (like the
[`codePointAt`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt)
string method).
*/ function $6295c6875f57e3ee$export$42977f40461e1360(str, pos) {
    let code0 = str.charCodeAt(pos);
    if (!$6295c6875f57e3ee$var$surrogateHigh(code0) || pos + 1 == str.length) return code0;
    let code1 = str.charCodeAt(pos + 1);
    if (!$6295c6875f57e3ee$var$surrogateLow(code1)) return code0;
    return (code0 - 0xd800 << 10) + (code1 - 0xdc00) + 0x10000;
}
/**
Given a Unicode codepoint, return the JavaScript string that
respresents it (like
[`String.fromCodePoint`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint)).
*/ function $6295c6875f57e3ee$export$73bfc63873071f74(code) {
    if (code <= 0xffff) return String.fromCharCode(code);
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xd800, (code & 1023) + 0xdc00);
}
/**
The amount of positions a character takes up a JavaScript string.
*/ function $6295c6875f57e3ee$export$a870abf234f6353c(code) {
    return code < 0x10000 ? 1 : 2;
}
const $6295c6875f57e3ee$var$DefaultSplit = /\r\n?|\n/;
/**
Distinguishes different ways in which positions can be mapped.
*/ var $6295c6875f57e3ee$export$39cf3280165f92aa = /*@__PURE__*/ function(MapMode) {
    /**
    Map a position to a valid new position, even when its context
    was deleted.
    */ MapMode[MapMode["Simple"] = 0] = "Simple";
    /**
    Return null if deletion happens across the position.
    */ MapMode[MapMode["TrackDel"] = 1] = "TrackDel";
    /**
    Return null if the character _before_ the position is deleted.
    */ MapMode[MapMode["TrackBefore"] = 2] = "TrackBefore";
    /**
    Return null if the character _after_ the position is deleted.
    */ MapMode[MapMode["TrackAfter"] = 3] = "TrackAfter";
    return MapMode;
}($6295c6875f57e3ee$export$39cf3280165f92aa || ($6295c6875f57e3ee$export$39cf3280165f92aa = {}));
/**
A change description is a variant of [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet)
that doesn't store the inserted text. As such, it can't be
applied, but is cheaper to store and manipulate.
*/ class $6295c6875f57e3ee$export$34b6a936f2bb06a2 {
    // Sections are encoded as pairs of integers. The first is the
    // length in the current document, and the second is -1 for
    // unaffected sections, and the length of the replacement content
    // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
    // 0), and a replacement two positive numbers.
    /**
    @internal
    */ constructor(/**
    @internal
    */ sections){
        this.sections = sections;
    }
    /**
    The length of the document before the change.
    */ get length() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2)result += this.sections[i];
        return result;
    }
    /**
    The length of the document after the change.
    */ get newLength() {
        let result = 0;
        for(let i = 0; i < this.sections.length; i += 2){
            let ins = this.sections[i + 1];
            result += ins < 0 ? this.sections[i] : ins;
        }
        return result;
    }
    /**
    False when there are actual changes in this set.
    */ get empty() {
        return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
    }
    /**
    Iterate over the unchanged parts left by these changes. `posA`
    provides the position of the range in the old document, `posB`
    the new position in the changed document.
    */ iterGaps(f) {
        for(let i = 0, posA = 0, posB = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) {
                f(posA, posB, len);
                posB += len;
            } else posB += ins;
            posA += len;
        }
    }
    /**
    Iterate over the ranges changed by these changes. (See
    [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
    variant that also provides you with the inserted text.)
    `fromA`/`toA` provides the extent of the change in the starting
    document, `fromB`/`toB` the extent of the replacement in the
    changed document.
    
    When `individual` is true, adjacent changes (which are kept
    separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
    reported separately.
    */ iterChangedRanges(f, individual = false) {
        $6295c6875f57e3ee$var$iterChanges(this, f, individual);
    }
    /**
    Get a description of the inverted form of these changes.
    */ get invertedDesc() {
        let sections = [];
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            if (ins < 0) sections.push(len, ins);
            else sections.push(ins, len);
        }
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(sections);
    }
    /**
    Compute the combined effect of applying another set of changes
    after this one. The length of the document after this set should
    match the length before `other`.
    */ composeDesc(other) {
        return this.empty ? other : other.empty ? this : $6295c6875f57e3ee$var$composeSets(this, other);
    }
    /**
    Map this description, which should start with the same document
    as `other`, over another set of changes, so that it can be
    applied after it. When `before` is true, map as if the changes
    in `other` happened before the ones in `this`.
    */ mapDesc(other, before = false) {
        return other.empty ? this : $6295c6875f57e3ee$var$mapSet(this, other, before);
    }
    mapPos(pos, assoc = -1, mode = $6295c6875f57e3ee$export$39cf3280165f92aa.Simple) {
        let posA = 0, posB = 0;
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++], endA = posA + len;
            if (ins < 0) {
                if (endA > pos) return posB + (pos - posA);
                posB += len;
            } else {
                if (mode != $6295c6875f57e3ee$export$39cf3280165f92aa.Simple && endA >= pos && (mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackDel && posA < pos && endA > pos || mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackBefore && posA < pos || mode == $6295c6875f57e3ee$export$39cf3280165f92aa.TrackAfter && endA > pos)) return null;
                if (endA > pos || endA == pos && assoc < 0 && !len) return pos == posA || assoc < 0 ? posB : posB + ins;
                posB += ins;
            }
            posA = endA;
        }
        if (pos > posA) throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
        return posB;
    }
    /**
    Check whether these changes touch a given range. When one of the
    changes entirely covers the range, the string `"cover"` is
    returned.
    */ touchesRange(from, to = from) {
        for(let i = 0, pos = 0; i < this.sections.length && pos <= to;){
            let len = this.sections[i++], ins = this.sections[i++], end = pos + len;
            if (ins >= 0 && pos <= to && end >= from) return pos < from && end > to ? "cover" : true;
            pos = end;
        }
        return false;
    }
    /**
    @internal
    */ toString() {
        let result = "";
        for(let i = 0; i < this.sections.length;){
            let len = this.sections[i++], ins = this.sections[i++];
            result += (result ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
        }
        return result;
    }
    /**
    Serialize this change desc to a JSON-representable value.
    */ toJSON() {
        return this.sections;
    }
    /**
    Create a change desc from its JSON representation (as produced
    by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json) || json.length % 2 || json.some((a)=>typeof a != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(json);
    }
    /**
    @internal
    */ static create(sections) {
        return new $6295c6875f57e3ee$export$34b6a936f2bb06a2(sections);
    }
}
/**
A change set represents a group of modifications to a document. It
stores the document length, and can only be applied to documents
with exactly that length.
*/ class $6295c6875f57e3ee$export$29d7fbdcb1f8b71c extends $6295c6875f57e3ee$export$34b6a936f2bb06a2 {
    constructor(sections, /**
    @internal
    */ inserted){
        super(sections);
        this.inserted = inserted;
    }
    /**
    Apply the changes to a document, returning the modified
    document.
    */ apply(doc) {
        if (this.length != doc.length) throw new RangeError("Applying change set to a document with the wrong length");
        $6295c6875f57e3ee$var$iterChanges(this, (fromA, toA, fromB, _toB, text)=>doc = doc.replace(fromB, fromB + (toA - fromA), text), false);
        return doc;
    }
    mapDesc(other, before = false) {
        return $6295c6875f57e3ee$var$mapSet(this, other, before, true);
    }
    /**
    Given the document as it existed _before_ the changes, return a
    change set that represents the inverse of this set, which could
    be used to go from the document created by the changes back to
    the document as it existed before the changes.
    */ invert(doc) {
        let sections = this.sections.slice(), inserted = [];
        for(let i = 0, pos = 0; i < sections.length; i += 2){
            let len = sections[i], ins = sections[i + 1];
            if (ins >= 0) {
                sections[i] = ins;
                sections[i + 1] = len;
                let index = i >> 1;
                while(inserted.length < index)inserted.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
                inserted.push(len ? doc.slice(pos, pos + len) : $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
            }
            pos += len;
        }
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    Combine two subsequent change sets into a single set. `other`
    must start in the document produced by `this`. If `this` goes
    `docA` → `docB` and `other` represents `docB` → `docC`, the
    returned value will represent the change `docA` → `docC`.
    */ compose(other) {
        return this.empty ? other : other.empty ? this : $6295c6875f57e3ee$var$composeSets(this, other, true);
    }
    /**
    Given another change set starting in the same document, maps this
    change set over the other, producing a new change set that can be
    applied to the document produced by applying `other`. When
    `before` is `true`, order changes as if `this` comes before
    `other`, otherwise (the default) treat `other` as coming first.
    
    Given two changes `A` and `B`, `A.compose(B.map(A))` and
    `B.compose(A.map(B, true))` will produce the same document. This
    provides a basic form of [operational
    transformation](https://en.wikipedia.org/wiki/Operational_transformation),
    and can be used for collaborative editing.
    */ map(other, before = false) {
        return other.empty ? this : $6295c6875f57e3ee$var$mapSet(this, other, before, true);
    }
    /**
    Iterate over the changed ranges in the document, calling `f` for
    each, with the range in the original document (`fromA`-`toA`)
    and the range that replaces it in the new document
    (`fromB`-`toB`).
    
    When `individual` is true, adjacent changes are reported
    separately.
    */ iterChanges(f, individual = false) {
        $6295c6875f57e3ee$var$iterChanges(this, f, individual);
    }
    /**
    Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
    set.
    */ get desc() {
        return $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(this.sections);
    }
    /**
    @internal
    */ filter(ranges) {
        let resultSections = [], resultInserted = [], filteredSections = [];
        let iter = new $6295c6875f57e3ee$var$SectionIter(this);
        done: for(let i = 0, pos = 0;;){
            let next = i == ranges.length ? 1e9 : ranges[i++];
            while(pos < next || pos == next && iter.len == 0){
                if (iter.done) break done;
                let len = Math.min(iter.len, next - pos);
                $6295c6875f57e3ee$var$addSection(filteredSections, len, -1);
                let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
                $6295c6875f57e3ee$var$addSection(resultSections, len, ins);
                if (ins > 0) $6295c6875f57e3ee$var$addInsert(resultInserted, resultSections, iter.text);
                iter.forward(len);
                pos += len;
            }
            let end = ranges[i++];
            while(pos < end){
                if (iter.done) break done;
                let len = Math.min(iter.len, end - pos);
                $6295c6875f57e3ee$var$addSection(resultSections, len, -1);
                $6295c6875f57e3ee$var$addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
                iter.forward(len);
                pos += len;
            }
        }
        return {
            changes: new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(resultSections, resultInserted),
            filtered: $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(filteredSections)
        };
    }
    /**
    Serialize this change set to a JSON-representable value.
    */ toJSON() {
        let parts = [];
        for(let i = 0; i < this.sections.length; i += 2){
            let len = this.sections[i], ins = this.sections[i + 1];
            if (ins < 0) parts.push(len);
            else if (ins == 0) parts.push([
                len
            ]);
            else parts.push([
                len
            ].concat(this.inserted[i >> 1].toJSON()));
        }
        return parts;
    }
    /**
    Create a change set for the given changes, for a document of the
    given length, using `lineSep` as line separator.
    */ static of(changes, length, lineSep) {
        let sections = [], inserted = [], pos = 0;
        let total = null;
        function flush(force = false) {
            if (!force && !sections.length) return;
            if (pos < length) $6295c6875f57e3ee$var$addSection(sections, length - pos, -1);
            let set = new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
            total = total ? total.compose(set.map(total)) : set;
            sections = [];
            inserted = [];
            pos = 0;
        }
        function process(spec) {
            if (Array.isArray(spec)) for (let sub of spec)process(sub);
            else if (spec instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c) {
                if (spec.length != length) throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
                flush();
                total = total ? total.compose(spec.map(total)) : spec;
            } else {
                let { from: from, to: to = from, insert: insert } = spec;
                if (from > to || from < 0 || to > length) throw new RangeError(`Invalid change range ${from} to ${to} (in doc of length ${length})`);
                let insText = !insert ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : typeof insert == "string" ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(insert.split(lineSep || $6295c6875f57e3ee$var$DefaultSplit)) : insert;
                let insLen = insText.length;
                if (from == to && insLen == 0) return;
                if (from < pos) flush();
                if (from > pos) $6295c6875f57e3ee$var$addSection(sections, from - pos, -1);
                $6295c6875f57e3ee$var$addSection(sections, to - from, insLen);
                $6295c6875f57e3ee$var$addInsert(inserted, sections, insText);
                pos = to;
            }
        }
        process(changes);
        flush(!total);
        return total;
    }
    /**
    Create an empty changeset of the given length.
    */ static empty(length) {
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(length ? [
            length,
            -1
        ] : [], []);
    }
    /**
    Create a changeset from its JSON representation (as produced by
    [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
    */ static fromJSON(json) {
        if (!Array.isArray(json)) throw new RangeError("Invalid JSON representation of ChangeSet");
        let sections = [], inserted = [];
        for(let i = 0; i < json.length; i++){
            let part = json[i];
            if (typeof part == "number") sections.push(part, -1);
            else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e, i)=>i && typeof e != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
            else if (part.length == 1) sections.push(part[0], 0);
            else {
                while(inserted.length < i)inserted.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
                inserted[i] = $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(part.slice(1));
                sections.push(part[0], inserted[i].length);
            }
        }
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
    /**
    @internal
    */ static createSet(sections, inserted) {
        return new $6295c6875f57e3ee$export$29d7fbdcb1f8b71c(sections, inserted);
    }
}
function $6295c6875f57e3ee$var$addSection(sections, len, ins, forceJoin = false) {
    if (len == 0 && ins <= 0) return;
    let last = sections.length - 2;
    if (last >= 0 && ins <= 0 && ins == sections[last + 1]) sections[last] += len;
    else if (len == 0 && sections[last] == 0) sections[last + 1] += ins;
    else if (forceJoin) {
        sections[last] += len;
        sections[last + 1] += ins;
    } else sections.push(len, ins);
}
function $6295c6875f57e3ee$var$addInsert(values, sections, value) {
    if (value.length == 0) return;
    let index = sections.length - 2 >> 1;
    if (index < values.length) values[values.length - 1] = values[values.length - 1].append(value);
    else {
        while(values.length < index)values.push($6295c6875f57e3ee$export$5f1af8db9871e1d6.empty);
        values.push(value);
    }
}
function $6295c6875f57e3ee$var$iterChanges(desc, f, individual) {
    let inserted = desc.inserted;
    for(let posA = 0, posB = 0, i = 0; i < desc.sections.length;){
        let len = desc.sections[i++], ins = desc.sections[i++];
        if (ins < 0) {
            posA += len;
            posB += len;
        } else {
            let endA = posA, endB = posB, text = $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty;
            for(;;){
                endA += len;
                endB += ins;
                if (ins && inserted) text = text.append(inserted[i - 2 >> 1]);
                if (individual || i == desc.sections.length || desc.sections[i + 1] < 0) break;
                len = desc.sections[i++];
                ins = desc.sections[i++];
            }
            f(posA, endA, posB, endB, text);
            posA = endA;
            posB = endB;
        }
    }
}
function $6295c6875f57e3ee$var$mapSet(setA, setB, before, mkSet = false) {
    // Produce a copy of setA that applies to the document after setB
    // has been applied (assuming both start at the same document).
    let sections = [], insert = mkSet ? [] : null;
    let a = new $6295c6875f57e3ee$var$SectionIter(setA), b = new $6295c6875f57e3ee$var$SectionIter(setB);
    // Iterate over both sets in parallel. inserted tracks, for changes
    // in A that have to be processed piece-by-piece, whether their
    // content has been inserted already, and refers to the section
    // index.
    for(let inserted = -1;;){
        if (a.ins == -1 && b.ins == -1) {
            // Move across ranges skipped by both sets.
            let len = Math.min(a.len, b.len);
            $6295c6875f57e3ee$var$addSection(sections, len, -1);
            a.forward(len);
            b.forward(len);
        } else if (b.ins >= 0 && (a.ins < 0 || inserted == a.i || a.off == 0 && (b.len < a.len || b.len == a.len && !before))) {
            // If there's a change in B that comes before the next change in
            // A (ordered by start pos, then len, then before flag), skip
            // that (and process any changes in A it covers).
            let len = b.len;
            $6295c6875f57e3ee$var$addSection(sections, b.ins, -1);
            while(len){
                let piece = Math.min(a.len, len);
                if (a.ins >= 0 && inserted < a.i && a.len <= piece) {
                    $6295c6875f57e3ee$var$addSection(sections, 0, a.ins);
                    if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, a.text);
                    inserted = a.i;
                }
                a.forward(piece);
                len -= piece;
            }
            b.next();
        } else if (a.ins >= 0) {
            // Process the part of a change in A up to the start of the next
            // non-deletion change in B (if overlapping).
            let len = 0, left = a.len;
            while(left){
                if (b.ins == -1) {
                    let piece = Math.min(left, b.len);
                    len += piece;
                    left -= piece;
                    b.forward(piece);
                } else if (b.ins == 0 && b.len < left) {
                    left -= b.len;
                    b.next();
                } else break;
            }
            $6295c6875f57e3ee$var$addSection(sections, len, inserted < a.i ? a.ins : 0);
            if (insert && inserted < a.i) $6295c6875f57e3ee$var$addInsert(insert, sections, a.text);
            inserted = a.i;
            a.forward(a.len - left);
        } else if (a.done && b.done) return insert ? $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(sections);
        else throw new Error("Mismatched change set lengths");
    }
}
function $6295c6875f57e3ee$var$composeSets(setA, setB, mkSet = false) {
    let sections = [];
    let insert = mkSet ? [] : null;
    let a = new $6295c6875f57e3ee$var$SectionIter(setA), b = new $6295c6875f57e3ee$var$SectionIter(setB);
    for(let open = false;;){
        if (a.done && b.done) return insert ? $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.createSet(sections, insert) : $6295c6875f57e3ee$export$34b6a936f2bb06a2.create(sections);
        else if (a.ins == 0) {
            $6295c6875f57e3ee$var$addSection(sections, a.len, 0, open);
            a.next();
        } else if (b.len == 0 && !b.done) {
            $6295c6875f57e3ee$var$addSection(sections, 0, b.ins, open);
            if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            b.next();
        } else if (a.done || b.done) throw new Error("Mismatched change set lengths");
        else {
            let len = Math.min(a.len2, b.len), sectionLen = sections.length;
            if (a.ins == -1) {
                let insB = b.ins == -1 ? -1 : b.off ? 0 : b.ins;
                $6295c6875f57e3ee$var$addSection(sections, len, insB, open);
                if (insert && insB) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            } else if (b.ins == -1) {
                $6295c6875f57e3ee$var$addSection(sections, a.off ? 0 : a.len, len, open);
                if (insert) $6295c6875f57e3ee$var$addInsert(insert, sections, a.textBit(len));
            } else {
                $6295c6875f57e3ee$var$addSection(sections, a.off ? 0 : a.len, b.off ? 0 : b.ins, open);
                if (insert && !b.off) $6295c6875f57e3ee$var$addInsert(insert, sections, b.text);
            }
            open = (a.ins > len || b.ins >= 0 && b.len > len) && (open || sections.length > sectionLen);
            a.forward2(len);
            b.forward(len);
        }
    }
}
class $6295c6875f57e3ee$var$SectionIter {
    constructor(set){
        this.set = set;
        this.i = 0;
        this.next();
    }
    next() {
        let { sections: sections } = this.set;
        if (this.i < sections.length) {
            this.len = sections[this.i++];
            this.ins = sections[this.i++];
        } else {
            this.len = 0;
            this.ins = -2;
        }
        this.off = 0;
    }
    get done() {
        return this.ins == -2;
    }
    get len2() {
        return this.ins < 0 ? this.len : this.ins;
    }
    get text() {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : inserted[index];
    }
    textBit(len) {
        let { inserted: inserted } = this.set, index = this.i - 2 >> 1;
        return index >= inserted.length && !len ? $6295c6875f57e3ee$export$5f1af8db9871e1d6.empty : inserted[index].slice(this.off, len == null ? undefined : this.off + len);
    }
    forward(len) {
        if (len == this.len) this.next();
        else {
            this.len -= len;
            this.off += len;
        }
    }
    forward2(len) {
        if (this.ins == -1) this.forward(len);
        else if (len == this.ins) this.next();
        else {
            this.ins -= len;
            this.off += len;
        }
    }
}
/**
A single selection range. When
[`allowMultipleSelections`](https://codemirror.net/6/docs/ref/#state.EditorState^allowMultipleSelections)
is enabled, a [selection](https://codemirror.net/6/docs/ref/#state.EditorSelection) may hold
multiple ranges. By default, selections hold exactly one range.
*/ class $6295c6875f57e3ee$export$7bd1839c3c5d5bd4 {
    constructor(/**
    The lower boundary of the range.
    */ from, /**
    The upper boundary of the range.
    */ to, flags){
        this.from = from;
        this.to = to;
        this.flags = flags;
    }
    /**
    The anchor of the range—the side that doesn't move when you
    extend it.
    */ get anchor() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.to : this.from;
    }
    /**
    The head of the range, which is moved when the range is
    [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
    */ get head() {
        return this.flags & 32 /* RangeFlag.Inverted */  ? this.from : this.to;
    }
    /**
    True when `anchor` and `head` are at the same position.
    */ get empty() {
        return this.from == this.to;
    }
    /**
    If this is a cursor that is explicitly associated with the
    character on one of its sides, this returns the side. -1 means
    the character before its position, 1 the character after, and 0
    means no association.
    */ get assoc() {
        return this.flags & 8 /* RangeFlag.AssocBefore */  ? -1 : this.flags & 16 /* RangeFlag.AssocAfter */  ? 1 : 0;
    }
    /**
    The bidirectional text level associated with this cursor, if
    any.
    */ get bidiLevel() {
        let level = this.flags & 7 /* RangeFlag.BidiLevelMask */ ;
        return level == 7 ? null : level;
    }
    /**
    The goal column (stored vertical offset) associated with a
    cursor. This is used to preserve the vertical position when
    [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
    lines of different length.
    */ get goalColumn() {
        let value = this.flags >> 6 /* RangeFlag.GoalColumnOffset */ ;
        return value == 16777215 /* RangeFlag.NoGoalColumn */  ? undefined : value;
    }
    /**
    Map this range through a change, producing a valid range in the
    updated document.
    */ map(change, assoc = -1) {
        let from, to;
        if (this.empty) from = to = change.mapPos(this.from, assoc);
        else {
            from = change.mapPos(this.from, 1);
            to = change.mapPos(this.to, -1);
        }
        return from == this.from && to == this.to ? this : new $6295c6875f57e3ee$export$7bd1839c3c5d5bd4(from, to, this.flags);
    }
    /**
    Extend this range to cover at least `from` to `to`.
    */ extend(from, to = from) {
        if (from <= this.anchor && to >= this.anchor) return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(from, to);
        let head = Math.abs(from - this.anchor) > Math.abs(to - this.anchor) ? from : to;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(this.anchor, head);
    }
    /**
    Compare this range to another range.
    */ eq(other, includeAssoc = false) {
        return this.anchor == other.anchor && this.head == other.head && (!includeAssoc || !this.empty || this.assoc == other.assoc);
    }
    /**
    Return a JSON-serializable object representing the range.
    */ toJSON() {
        return {
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    Convert a JSON representation of a range to a `SelectionRange`
    instance.
    */ static fromJSON(json) {
        if (!json || typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.range(json.anchor, json.head);
    }
    /**
    @internal
    */ static create(from, to, flags) {
        return new $6295c6875f57e3ee$export$7bd1839c3c5d5bd4(from, to, flags);
    }
}
/**
An editor selection holds one or more selection ranges.
*/ class $6295c6875f57e3ee$export$3bb1bd44aee62999 {
    constructor(/**
    The ranges in the selection, sorted by position. Ranges cannot
    overlap (but they may touch, if they aren't empty).
    */ ranges, /**
    The index of the _main_ range in the selection (which is
    usually the range that was added last).
    */ mainIndex){
        this.ranges = ranges;
        this.mainIndex = mainIndex;
    }
    /**
    Map a selection through a change. Used to adjust the selection
    position for changes.
    */ map(change, assoc = -1) {
        if (change.empty) return this;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create(this.ranges.map((r)=>r.map(change, assoc)), this.mainIndex);
    }
    /**
    Compare this selection to another selection. By default, ranges
    are compared only by position. When `includeAssoc` is true,
    cursor ranges must also have the same
    [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
    */ eq(other, includeAssoc = false) {
        if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex) return false;
        for(let i = 0; i < this.ranges.length; i++)if (!this.ranges[i].eq(other.ranges[i], includeAssoc)) return false;
        return true;
    }
    /**
    Get the primary selection range. Usually, you should make sure
    your code applies to _all_ ranges, by using methods like
    [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
    */ get main() {
        return this.ranges[this.mainIndex];
    }
    /**
    Make sure the selection only has one range. Returns a selection
    holding only the main range from this selection.
    */ asSingle() {
        return this.ranges.length == 1 ? this : new $6295c6875f57e3ee$export$3bb1bd44aee62999([
            this.main
        ], 0);
    }
    /**
    Extend this selection with an extra range.
    */ addRange(range, main = true) {
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create([
            range
        ].concat(this.ranges), main ? 0 : this.mainIndex + 1);
    }
    /**
    Replace a given range with another range, and then normalize the
    selection to merge and sort ranges if necessary.
    */ replaceRange(range, which = this.mainIndex) {
        let ranges = this.ranges.slice();
        ranges[which] = range;
        return $6295c6875f57e3ee$export$3bb1bd44aee62999.create(ranges, this.mainIndex);
    }
    /**
    Convert this selection to an object that can be serialized to
    JSON.
    */ toJSON() {
        return {
            ranges: this.ranges.map((r)=>r.toJSON()),
            main: this.mainIndex
        };
    }
    /**
    Create a selection from a JSON representation.
    */ static fromJSON(json) {
        if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(json.ranges.map((r)=>$6295c6875f57e3ee$export$7bd1839c3c5d5bd4.fromJSON(r)), json.main);
    }
    /**
    Create a selection holding a single range.
    */ static single(anchor, head = anchor) {
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999([
            $6295c6875f57e3ee$export$3bb1bd44aee62999.range(anchor, head)
        ], 0);
    }
    /**
    Sort and merge the given set of ranges, creating a valid
    selection.
    */ static create(ranges, mainIndex = 0) {
        if (ranges.length == 0) throw new RangeError("A selection needs at least one range");
        for(let pos = 0, i = 0; i < ranges.length; i++){
            let range = ranges[i];
            if (range.empty ? range.from <= pos : range.from < pos) return $6295c6875f57e3ee$export$3bb1bd44aee62999.normalized(ranges.slice(), mainIndex);
            pos = range.to;
        }
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(ranges, mainIndex);
    }
    /**
    Create a cursor selection range at the given position. You can
    safely ignore the optional arguments in most situations.
    */ static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
        return $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 /* RangeFlag.AssocBefore */  : 16 /* RangeFlag.AssocAfter */ ) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */ );
    }
    /**
    Create a selection range.
    */ static range(anchor, head, goalColumn, bidiLevel) {
        let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 16777215 /* RangeFlag.NoGoalColumn */ ) << 6 /* RangeFlag.GoalColumnOffset */  | (bidiLevel == null ? 7 : Math.min(6, bidiLevel));
        return head < anchor ? $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(head, anchor, 48 /* RangeFlag.AssocAfter */  | flags) : $6295c6875f57e3ee$export$7bd1839c3c5d5bd4.create(anchor, head, (head > anchor ? 8 /* RangeFlag.AssocBefore */  : 0) | flags);
    }
    /**
    @internal
    */ static normalized(ranges, mainIndex = 0) {
        let main = ranges[mainIndex];
        ranges.sort((a, b)=>a.from - b.from);
        mainIndex = ranges.indexOf(main);
        for(let i = 1; i < ranges.length; i++){
            let range = ranges[i], prev = ranges[i - 1];
            if (range.empty ? range.from <= prev.to : range.from < prev.to) {
                let from = prev.from, to = Math.max(range.to, prev.to);
                if (i <= mainIndex) mainIndex--;
                ranges.splice(--i, 2, range.anchor > range.head ? $6295c6875f57e3ee$export$3bb1bd44aee62999.range(to, from) : $6295c6875f57e3ee$export$3bb1bd44aee62999.range(from, to));
            }
        }
        return new $6295c6875f57e3ee$export$3bb1bd44aee62999(ranges, mainIndex);
    }
}
function $6295c6875f57e3ee$var$checkSelection(selection, docLength) {
    for (let range of selection.ranges)if (range.to > docLength) throw new RangeError("Selection points outside of document");
}
let $6295c6875f57e3ee$var$nextID = 0;
/**
A facet is a labeled value that is associated with an editor
state. It takes inputs from any number of extensions, and combines
those into a single output value.

Examples of uses of facets are the [tab
size](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize), [editor
attributes](https://codemirror.net/6/docs/ref/#view.EditorView^editorAttributes), and [update
listeners](https://codemirror.net/6/docs/ref/#view.EditorView^updateListener).

Note that `Facet` instances can be used anywhere where
[`FacetReader`](https://codemirror.net/6/docs/ref/#state.FacetReader) is expected.
*/ class $6295c6875f57e3ee$export$ef7d5e9b79fa1504 {
    constructor(/**
    @internal
    */ combine, /**
    @internal
    */ compareInput, /**
    @internal
    */ compare, isStatic, enables){
        this.combine = combine;
        this.compareInput = compareInput;
        this.compare = compare;
        this.isStatic = isStatic;
        /**
        @internal
        */ this.id = $6295c6875f57e3ee$var$nextID++;
        this.default = combine([]);
        this.extensions = typeof enables == "function" ? enables(this) : enables;
    }
    /**
    Returns a facet reader for this facet, which can be used to
    [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
    */ get reader() {
        return this;
    }
    /**
    Define a new facet.
    */ static define(config = {}) {
        return new $6295c6875f57e3ee$export$ef7d5e9b79fa1504(config.combine || ((a)=>a), config.compareInput || ((a, b)=>a === b), config.compare || (!config.combine ? $6295c6875f57e3ee$var$sameArray : (a, b)=>a === b), !!config.static, config.enables);
    }
    /**
    Returns an extension that adds the given value to this facet.
    */ of(value) {
        return new $6295c6875f57e3ee$var$FacetProvider([], this, 0 /* Provider.Static */ , value);
    }
    /**
    Create an extension that computes a value for the facet from a
    state. You must take care to declare the parts of the state that
    this value depends on, since your function is only called again
    for a new state when one of those parts changed.
    
    In cases where your value depends only on a single field, you'll
    want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
    */ compute(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6295c6875f57e3ee$var$FacetProvider(deps, this, 1 /* Provider.Single */ , get);
    }
    /**
    Create an extension that computes zero or more values for this
    facet from a state.
    */ computeN(deps, get) {
        if (this.isStatic) throw new Error("Can't compute a static facet");
        return new $6295c6875f57e3ee$var$FacetProvider(deps, this, 2 /* Provider.Multi */ , get);
    }
    from(field, get) {
        if (!get) get = (x)=>x;
        return this.compute([
            field
        ], (state)=>get(state.field(field)));
    }
}
function $6295c6875f57e3ee$var$sameArray(a, b) {
    return a == b || a.length == b.length && a.every((e, i)=>e === b[i]);
}
class $6295c6875f57e3ee$var$FacetProvider {
    constructor(dependencies, facet, type, value){
        this.dependencies = dependencies;
        this.facet = facet;
        this.type = type;
        this.value = value;
        this.id = $6295c6875f57e3ee$var$nextID++;
    }
    dynamicSlot(addresses) {
        var _a;
        let getter = this.value;
        let compare = this.facet.compareInput;
        let id = this.id, idx = addresses[id] >> 1, multi = this.type == 2 /* Provider.Multi */ ;
        let depDoc = false, depSel = false, depAddrs = [];
        for (let dep of this.dependencies){
            if (dep == "doc") depDoc = true;
            else if (dep == "selection") depSel = true;
            else if ((((_a = addresses[dep.id]) !== null && _a !== void 0 ? _a : 1) & 1) == 0) depAddrs.push(addresses[dep.id]);
        }
        return {
            create (state) {
                state.values[idx] = getter(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update (state, tr) {
                if (depDoc && tr.docChanged || depSel && (tr.docChanged || tr.selection) || $6295c6875f57e3ee$var$ensureAll(state, depAddrs)) {
                    let newVal = getter(state);
                    if (multi ? !$6295c6875f57e3ee$var$compareArray(newVal, state.values[idx], compare) : !compare(newVal, state.values[idx])) {
                        state.values[idx] = newVal;
                        return 1 /* SlotStatus.Changed */ ;
                    }
                }
                return 0;
            },
            reconfigure: (state, oldState)=>{
                let newVal, oldAddr = oldState.config.address[id];
                if (oldAddr != null) {
                    let oldVal = $6295c6875f57e3ee$var$getAddr(oldState, oldAddr);
                    if (this.dependencies.every((dep)=>{
                        return dep instanceof $6295c6875f57e3ee$export$ef7d5e9b79fa1504 ? oldState.facet(dep) === state.facet(dep) : dep instanceof $6295c6875f57e3ee$export$34381b1ce2130245 ? oldState.field(dep, false) == state.field(dep, false) : true;
                    }) || (multi ? $6295c6875f57e3ee$var$compareArray(newVal = getter(state), oldVal, compare) : compare(newVal = getter(state), oldVal))) {
                        state.values[idx] = oldVal;
                        return 0;
                    }
                } else newVal = getter(state);
                state.values[idx] = newVal;
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
}
function $6295c6875f57e3ee$var$compareArray(a, b, compare) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!compare(a[i], b[i])) return false;
    return true;
}
function $6295c6875f57e3ee$var$ensureAll(state, addrs) {
    let changed = false;
    for (let addr of addrs)if ($6295c6875f57e3ee$var$ensureAddr(state, addr) & 1 /* SlotStatus.Changed */ ) changed = true;
    return changed;
}
function $6295c6875f57e3ee$var$dynamicFacetSlot(addresses, facet, providers) {
    let providerAddrs = providers.map((p)=>addresses[p.id]);
    let providerTypes = providers.map((p)=>p.type);
    let dynamic = providerAddrs.filter((p)=>!(p & 1));
    let idx = addresses[facet.id] >> 1;
    function get(state) {
        let values = [];
        for(let i = 0; i < providerAddrs.length; i++){
            let value = $6295c6875f57e3ee$var$getAddr(state, providerAddrs[i]);
            if (providerTypes[i] == 2 /* Provider.Multi */ ) for (let val of value)values.push(val);
            else values.push(value);
        }
        return facet.combine(values);
    }
    return {
        create (state) {
            for (let addr of providerAddrs)$6295c6875f57e3ee$var$ensureAddr(state, addr);
            state.values[idx] = get(state);
            return 1 /* SlotStatus.Changed */ ;
        },
        update (state, tr) {
            if (!$6295c6875f57e3ee$var$ensureAll(state, dynamic)) return 0;
            let value = get(state);
            if (facet.compare(value, state.values[idx])) return 0;
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        },
        reconfigure (state, oldState) {
            let depChanged = $6295c6875f57e3ee$var$ensureAll(state, providerAddrs);
            let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
            if (oldProviders && !depChanged && $6295c6875f57e3ee$var$sameArray(providers, oldProviders)) {
                state.values[idx] = oldValue;
                return 0;
            }
            let value = get(state);
            if (facet.compare(value, oldValue)) {
                state.values[idx] = oldValue;
                return 0;
            }
            state.values[idx] = value;
            return 1 /* SlotStatus.Changed */ ;
        }
    };
}
const $6295c6875f57e3ee$var$initField = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    static: true
});
/**
Fields can store additional information in an editor state, and
keep it in sync with the rest of the state.
*/ class $6295c6875f57e3ee$export$34381b1ce2130245 {
    constructor(/**
    @internal
    */ id, createF, updateF, compareF, /**
    @internal
    */ spec){
        this.id = id;
        this.createF = createF;
        this.updateF = updateF;
        this.compareF = compareF;
        this.spec = spec;
        /**
        @internal
        */ this.provides = undefined;
    }
    /**
    Define a state field.
    */ static define(config) {
        let field = new $6295c6875f57e3ee$export$34381b1ce2130245($6295c6875f57e3ee$var$nextID++, config.create, config.update, config.compare || ((a, b)=>a === b), config);
        if (config.provide) field.provides = config.provide(field);
        return field;
    }
    create(state) {
        let init = state.facet($6295c6875f57e3ee$var$initField).find((i)=>i.field == this);
        return ((init === null || init === void 0 ? void 0 : init.create) || this.createF)(state);
    }
    /**
    @internal
    */ slot(addresses) {
        let idx = addresses[this.id] >> 1;
        return {
            create: (state)=>{
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            },
            update: (state, tr)=>{
                let oldVal = state.values[idx];
                let value = this.updateF(oldVal, tr);
                if (this.compareF(oldVal, value)) return 0;
                state.values[idx] = value;
                return 1 /* SlotStatus.Changed */ ;
            },
            reconfigure: (state, oldState)=>{
                if (oldState.config.address[this.id] != null) {
                    state.values[idx] = oldState.field(this);
                    return 0;
                }
                state.values[idx] = this.create(state);
                return 1 /* SlotStatus.Changed */ ;
            }
        };
    }
    /**
    Returns an extension that enables this field and overrides the
    way it is initialized. Can be useful when you need to provide a
    non-default starting value for the field.
    */ init(create) {
        return [
            this,
            $6295c6875f57e3ee$var$initField.of({
                field: this,
                create: create
            })
        ];
    }
    /**
    State field instances can be used as
    [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
    given state.
    */ get extension() {
        return this;
    }
}
const $6295c6875f57e3ee$var$Prec_ = {
    lowest: 4,
    low: 3,
    default: 2,
    high: 1,
    highest: 0
};
function $6295c6875f57e3ee$var$prec(value) {
    return (ext)=>new $6295c6875f57e3ee$var$PrecExtension(ext, value);
}
/**
By default extensions are registered in the order they are found
in the flattened form of nested array that was provided.
Individual extension values can be assigned a precedence to
override this. Extensions that do not have a precedence set get
the precedence of the nearest parent with a precedence, or
[`default`](https://codemirror.net/6/docs/ref/#state.Prec.default) if there is no such parent. The
final ordering of extensions is determined by first sorting by
precedence and then by order within each precedence.
*/ const $6295c6875f57e3ee$export$b92464a736444411 = {
    /**
    The highest precedence level, for extensions that should end up
    near the start of the precedence ordering.
    */ highest: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.highest),
    /**
    A higher-than-default precedence, for extensions that should
    come before those with default precedence.
    */ high: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.high),
    /**
    The default precedence, which is also used for extensions
    without an explicit precedence.
    */ default: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.default),
    /**
    A lower-than-default precedence.
    */ low: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.low),
    /**
    The lowest precedence level. Meant for things that should end up
    near the end of the extension order.
    */ lowest: /*@__PURE__*/ $6295c6875f57e3ee$var$prec($6295c6875f57e3ee$var$Prec_.lowest)
};
class $6295c6875f57e3ee$var$PrecExtension {
    constructor(inner, prec){
        this.inner = inner;
        this.prec = prec;
    }
}
/**
Extension compartments can be used to make a configuration
dynamic. By [wrapping](https://codemirror.net/6/docs/ref/#state.Compartment.of) part of your
configuration in a compartment, you can later
[replace](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure) that part through a
transaction.
*/ class $6295c6875f57e3ee$export$d51c0172eb2c2431 {
    /**
    Create an instance of this compartment to add to your [state
    configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
    */ of(ext) {
        return new $6295c6875f57e3ee$var$CompartmentInstance(this, ext);
    }
    /**
    Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
    reconfigures this compartment.
    */ reconfigure(content) {
        return $6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure.of({
            compartment: this,
            extension: content
        });
    }
    /**
    Get the current content of the compartment in the state, or
    `undefined` if it isn't present.
    */ get(state) {
        return state.config.compartments.get(this);
    }
}
class $6295c6875f57e3ee$var$CompartmentInstance {
    constructor(compartment, inner){
        this.compartment = compartment;
        this.inner = inner;
    }
}
class $6295c6875f57e3ee$var$Configuration {
    constructor(base, compartments, dynamicSlots, address, staticValues, facets){
        this.base = base;
        this.compartments = compartments;
        this.dynamicSlots = dynamicSlots;
        this.address = address;
        this.staticValues = staticValues;
        this.facets = facets;
        this.statusTemplate = [];
        while(this.statusTemplate.length < dynamicSlots.length)this.statusTemplate.push(0 /* SlotStatus.Unresolved */ );
    }
    staticFacet(facet) {
        let addr = this.address[facet.id];
        return addr == null ? facet.default : this.staticValues[addr >> 1];
    }
    static resolve(base, compartments, oldState) {
        let fields = [];
        let facets = Object.create(null);
        let newCompartments = new Map();
        for (let ext of $6295c6875f57e3ee$var$flatten(base, compartments, newCompartments))if (ext instanceof $6295c6875f57e3ee$export$34381b1ce2130245) fields.push(ext);
        else (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
        let address = Object.create(null);
        let staticValues = [];
        let dynamicSlots = [];
        for (let field of fields){
            address[field.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a)=>field.slot(a));
        }
        let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
        for(let id in facets){
            let providers = facets[id], facet = providers[0].facet;
            let oldProviders = oldFacets && oldFacets[id] || [];
            if (providers.every((p)=>p.type == 0 /* Provider.Static */ )) {
                address[facet.id] = staticValues.length << 1 | 1;
                if ($6295c6875f57e3ee$var$sameArray(oldProviders, providers)) staticValues.push(oldState.facet(facet));
                else {
                    let value = facet.combine(providers.map((p)=>p.value));
                    staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
                }
            } else {
                for (let p of providers)if (p.type == 0 /* Provider.Static */ ) {
                    address[p.id] = staticValues.length << 1 | 1;
                    staticValues.push(p.value);
                } else {
                    address[p.id] = dynamicSlots.length << 1;
                    dynamicSlots.push((a)=>p.dynamicSlot(a));
                }
                address[facet.id] = dynamicSlots.length << 1;
                dynamicSlots.push((a)=>$6295c6875f57e3ee$var$dynamicFacetSlot(a, facet, providers));
            }
        }
        let dynamic = dynamicSlots.map((f)=>f(address));
        return new $6295c6875f57e3ee$var$Configuration(base, newCompartments, dynamic, address, staticValues, facets);
    }
}
function $6295c6875f57e3ee$var$flatten(extension, compartments, newCompartments) {
    let result = [
        [],
        [],
        [],
        [],
        []
    ];
    let seen = new Map();
    function inner(ext, prec) {
        let known = seen.get(ext);
        if (known != null) {
            if (known <= prec) return;
            let found = result[known].indexOf(ext);
            if (found > -1) result[known].splice(found, 1);
            if (ext instanceof $6295c6875f57e3ee$var$CompartmentInstance) newCompartments.delete(ext.compartment);
        }
        seen.set(ext, prec);
        if (Array.isArray(ext)) for (let e of ext)inner(e, prec);
        else if (ext instanceof $6295c6875f57e3ee$var$CompartmentInstance) {
            if (newCompartments.has(ext.compartment)) throw new RangeError(`Duplicate use of compartment in extensions`);
            let content = compartments.get(ext.compartment) || ext.inner;
            newCompartments.set(ext.compartment, content);
            inner(content, prec);
        } else if (ext instanceof $6295c6875f57e3ee$var$PrecExtension) inner(ext.inner, ext.prec);
        else if (ext instanceof $6295c6875f57e3ee$export$34381b1ce2130245) {
            result[prec].push(ext);
            if (ext.provides) inner(ext.provides, prec);
        } else if (ext instanceof $6295c6875f57e3ee$var$FacetProvider) {
            result[prec].push(ext);
            if (ext.facet.extensions) inner(ext.facet.extensions, $6295c6875f57e3ee$var$Prec_.default);
        } else {
            let content = ext.extension;
            if (!content) throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
            inner(content, prec);
        }
    }
    inner(extension, $6295c6875f57e3ee$var$Prec_.default);
    return result.reduce((a, b)=>a.concat(b));
}
function $6295c6875f57e3ee$var$ensureAddr(state, addr) {
    if (addr & 1) return 2 /* SlotStatus.Computed */ ;
    let idx = addr >> 1;
    let status = state.status[idx];
    if (status == 4 /* SlotStatus.Computing */ ) throw new Error("Cyclic dependency between fields and/or facets");
    if (status & 2 /* SlotStatus.Computed */ ) return status;
    state.status[idx] = 4 /* SlotStatus.Computing */ ;
    let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
    return state.status[idx] = 2 /* SlotStatus.Computed */  | changed;
}
function $6295c6875f57e3ee$var$getAddr(state, addr) {
    return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const $6295c6875f57e3ee$var$languageData = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$allowMultipleSelections = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.some((v)=>v),
    static: true
});
const $6295c6875f57e3ee$var$lineSeparator = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : undefined,
    static: true
});
const $6295c6875f57e3ee$var$changeFilter = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$transactionFilter = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$transactionExtender = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define();
const $6295c6875f57e3ee$var$readOnly = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : false
});
/**
Annotations are tagged values that are used to add metadata to
transactions in an extensible way. They should be used to model
things that effect the entire transaction (such as its [time
stamp](https://codemirror.net/6/docs/ref/#state.Transaction^time) or information about its
[origin](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent)). For effects that happen
_alongside_ the other changes made by the transaction, [state
effects](https://codemirror.net/6/docs/ref/#state.StateEffect) are more appropriate.
*/ class $6295c6875f57e3ee$export$9279461326b8700a {
    /**
    @internal
    */ constructor(/**
    The annotation type.
    */ type, /**
    The value of this annotation.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Define a new type of annotation.
    */ static define() {
        return new $6295c6875f57e3ee$export$f50c3066a53a6f2c();
    }
}
/**
Marker that identifies a type of [annotation](https://codemirror.net/6/docs/ref/#state.Annotation).
*/ class $6295c6875f57e3ee$export$f50c3066a53a6f2c {
    /**
    Create an instance of this annotation.
    */ of(value) {
        return new $6295c6875f57e3ee$export$9279461326b8700a(this, value);
    }
}
/**
Representation of a type of state effect. Defined with
[`StateEffect.define`](https://codemirror.net/6/docs/ref/#state.StateEffect^define).
*/ class $6295c6875f57e3ee$export$e41ff6bd17cc4417 {
    /**
    @internal
    */ constructor(// The `any` types in these function types are there to work
    // around TypeScript issue #37631, where the type guard on
    // `StateEffect.is` mysteriously stops working when these properly
    // have type `Value`.
    /**
    @internal
    */ map){
        this.map = map;
    }
    /**
    Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
    type.
    */ of(value) {
        return new $6295c6875f57e3ee$export$95000d4efaa4321f(this, value);
    }
}
/**
State effects can be used to represent additional effects
associated with a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction.effects). They
are often useful to model changes to custom [state
fields](https://codemirror.net/6/docs/ref/#state.StateField), when those changes aren't implicit in
document or selection changes.
*/ class $6295c6875f57e3ee$export$95000d4efaa4321f {
    /**
    @internal
    */ constructor(/**
    @internal
    */ type, /**
    The value of this effect.
    */ value){
        this.type = type;
        this.value = value;
    }
    /**
    Map this effect through a position mapping. Will return
    `undefined` when that ends up deleting the effect.
    */ map(mapping) {
        let mapped = this.type.map(this.value, mapping);
        return mapped === undefined ? undefined : mapped == this.value ? this : new $6295c6875f57e3ee$export$95000d4efaa4321f(this.type, mapped);
    }
    /**
    Tells you whether this effect object is of a given
    [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
    */ is(type) {
        return this.type == type;
    }
    /**
    Define a new effect type. The type parameter indicates the type
    of values that his effect holds. It should be a type that
    doesn't include `undefined`, since that is used in
    [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
    removed.
    */ static define(spec = {}) {
        return new $6295c6875f57e3ee$export$e41ff6bd17cc4417(spec.map || ((v)=>v));
    }
    /**
    Map an array of effects through a change set.
    */ static mapEffects(effects, mapping) {
        if (!effects.length) return effects;
        let result = [];
        for (let effect of effects){
            let mapped = effect.map(mapping);
            if (mapped) result.push(mapped);
        }
        return result;
    }
}
/**
This effect can be used to reconfigure the root extensions of
the editor. Doing this will discard any extensions
[appended](https://codemirror.net/6/docs/ref/#state.StateEffect^appendConfig), but does not reset
the content of [reconfigured](https://codemirror.net/6/docs/ref/#state.Compartment.reconfigure)
compartments.
*/ $6295c6875f57e3ee$export$95000d4efaa4321f.reconfigure = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Append extensions to the top-level configuration of the editor.
*/ $6295c6875f57e3ee$export$95000d4efaa4321f.appendConfig = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Changes to the editor state are grouped into transactions.
Typically, a user action creates a single transaction, which may
contain any number of document changes, may change the selection,
or have other effects. Create a transaction by calling
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update), or immediately
dispatch one by calling
[`EditorView.dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch).
*/ class $6295c6875f57e3ee$export$febc5573c75cefb0 {
    constructor(/**
    The state from which the transaction starts.
    */ startState, /**
    The document changes made by this transaction.
    */ changes, /**
    The selection set by this transaction, or undefined if it
    doesn't explicitly set a selection.
    */ selection, /**
    The effects added to the transaction.
    */ effects, /**
    @internal
    */ annotations, /**
    Whether the selection should be scrolled into view after this
    transaction is dispatched.
    */ scrollIntoView){
        this.startState = startState;
        this.changes = changes;
        this.selection = selection;
        this.effects = effects;
        this.annotations = annotations;
        this.scrollIntoView = scrollIntoView;
        /**
        @internal
        */ this._doc = null;
        /**
        @internal
        */ this._state = null;
        if (selection) $6295c6875f57e3ee$var$checkSelection(selection, changes.newLength);
        if (!annotations.some((a)=>a.type == $6295c6875f57e3ee$export$febc5573c75cefb0.time)) this.annotations = annotations.concat($6295c6875f57e3ee$export$febc5573c75cefb0.time.of(Date.now()));
    }
    /**
    @internal
    */ static create(startState, changes, selection, effects, annotations, scrollIntoView) {
        return new $6295c6875f57e3ee$export$febc5573c75cefb0(startState, changes, selection, effects, annotations, scrollIntoView);
    }
    /**
    The new document produced by the transaction. Contrary to
    [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
    force the entire new state to be computed right away, so it is
    recommended that [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
    when they need to look at the new document.
    */ get newDoc() {
        return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    /**
    The new selection produced by the transaction. If
    [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
    this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
    current selection through the changes made by the transaction.
    */ get newSelection() {
        return this.selection || this.startState.selection.map(this.changes);
    }
    /**
    The new state created by the transaction. Computed on demand
    (but retained for subsequent access), so it is recommended not to
    access it in [transaction
    filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
    */ get state() {
        if (!this._state) this.startState.applyTransaction(this);
        return this._state;
    }
    /**
    Get the value of the given annotation type, if any.
    */ annotation(type) {
        for (let ann of this.annotations)if (ann.type == type) return ann.value;
        return undefined;
    }
    /**
    Indicates whether the transaction changed the document.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Indicates whether this transaction reconfigures the state
    (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
    with a top-level configuration
    [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
    */ get reconfigured() {
        return this.startState.config != this.state.config;
    }
    /**
    Returns true if the transaction has a [user
    event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
    or more specific than `event`. For example, if the transaction
    has `"select.pointer"` as user event, `"select"` and
    `"select.pointer"` will match it.
    */ isUserEvent(event) {
        let e = this.annotation($6295c6875f57e3ee$export$febc5573c75cefb0.userEvent);
        return !!(e && (e == event || e.length > event.length && e.slice(0, event.length) == event && e[event.length] == "."));
    }
}
/**
Annotation used to store transaction timestamps. Automatically
added to every transaction, holding `Date.now()`.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.time = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation used to associate a transaction with a user interface
event. Holds a string identifying the event, using a
dot-separated format to support attaching more specific
information. The events used by the core libraries are:

 - `"input"` when content is entered
   - `"input.type"` for typed input
     - `"input.type.compose"` for composition
   - `"input.paste"` for pasted input
   - `"input.drop"` when adding content with drag-and-drop
   - `"input.complete"` when autocompleting
 - `"delete"` when the user deletes content
   - `"delete.selection"` when deleting the selection
   - `"delete.forward"` when deleting forward from the selection
   - `"delete.backward"` when deleting backward from the selection
   - `"delete.cut"` when cutting to the clipboard
 - `"move"` when content is moved
   - `"move.drop"` when content is moved within the editor through drag-and-drop
 - `"select"` when explicitly changing the selection
   - `"select.pointer"` when selecting with a mouse or other pointing device
 - `"undo"` and `"redo"` for history actions

Use [`isUserEvent`](https://codemirror.net/6/docs/ref/#state.Transaction.isUserEvent) to check
whether the annotation matches a given event.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.userEvent = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation indicating whether a transaction should be added to
the undo history or not.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.addToHistory = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
/**
Annotation indicating (when present and true) that a transaction
represents a change made by some other actor, not the user. This
is used, for example, to tag other people's changes in
collaborative editing.
*/ $6295c6875f57e3ee$export$febc5573c75cefb0.remote = /*@__PURE__*/ $6295c6875f57e3ee$export$9279461326b8700a.define();
function $6295c6875f57e3ee$var$joinRanges(a, b) {
    let result = [];
    for(let iA = 0, iB = 0;;){
        let from, to;
        if (iA < a.length && (iB == b.length || b[iB] >= a[iA])) {
            from = a[iA++];
            to = a[iA++];
        } else if (iB < b.length) {
            from = b[iB++];
            to = b[iB++];
        } else return result;
        if (!result.length || result[result.length - 1] < from) result.push(from, to);
        else if (result[result.length - 1] < to) result[result.length - 1] = to;
    }
}
function $6295c6875f57e3ee$var$mergeTransaction(a, b, sequential) {
    var _a;
    let mapForA, mapForB, changes;
    if (sequential) {
        mapForA = b.changes;
        mapForB = $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.empty(b.changes.length);
        changes = a.changes.compose(b.changes);
    } else {
        mapForA = b.changes.map(a.changes);
        mapForB = a.changes.mapDesc(b.changes, true);
        changes = a.changes.compose(mapForA);
    }
    return {
        changes: changes,
        selection: b.selection ? b.selection.map(mapForB) : (_a = a.selection) === null || _a === void 0 ? void 0 : _a.map(mapForA),
        effects: $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(a.effects, mapForA).concat($6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(b.effects, mapForB)),
        annotations: a.annotations.length ? a.annotations.concat(b.annotations) : b.annotations,
        scrollIntoView: a.scrollIntoView || b.scrollIntoView
    };
}
function $6295c6875f57e3ee$var$resolveTransactionInner(state, spec, docSize) {
    let sel = spec.selection, annotations = $6295c6875f57e3ee$var$asArray(spec.annotations);
    if (spec.userEvent) annotations = annotations.concat($6295c6875f57e3ee$export$febc5573c75cefb0.userEvent.of(spec.userEvent));
    return {
        changes: spec.changes instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c ? spec.changes : $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.of(spec.changes || [], docSize, state.facet($6295c6875f57e3ee$var$lineSeparator)),
        selection: sel && (sel instanceof $6295c6875f57e3ee$export$3bb1bd44aee62999 ? sel : $6295c6875f57e3ee$export$3bb1bd44aee62999.single(sel.anchor, sel.head)),
        effects: $6295c6875f57e3ee$var$asArray(spec.effects),
        annotations: annotations,
        scrollIntoView: !!spec.scrollIntoView
    };
}
function $6295c6875f57e3ee$var$resolveTransaction(state, specs, filter) {
    let s = $6295c6875f57e3ee$var$resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
    if (specs.length && specs[0].filter === false) filter = false;
    for(let i = 1; i < specs.length; i++){
        if (specs[i].filter === false) filter = false;
        let seq = !!specs[i].sequential;
        s = $6295c6875f57e3ee$var$mergeTransaction(s, $6295c6875f57e3ee$var$resolveTransactionInner(state, specs[i], seq ? s.changes.newLength : state.doc.length), seq);
    }
    let tr = $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, s.changes, s.selection, s.effects, s.annotations, s.scrollIntoView);
    return $6295c6875f57e3ee$var$extendTransaction(filter ? $6295c6875f57e3ee$var$filterTransaction(tr) : tr);
}
// Finish a transaction by applying filters if necessary.
function $6295c6875f57e3ee$var$filterTransaction(tr) {
    let state = tr.startState;
    // Change filters
    let result = true;
    for (let filter of state.facet($6295c6875f57e3ee$var$changeFilter)){
        let value = filter(tr);
        if (value === false) {
            result = false;
            break;
        }
        if (Array.isArray(value)) result = result === true ? value : $6295c6875f57e3ee$var$joinRanges(result, value);
    }
    if (result !== true) {
        let changes, back;
        if (result === false) {
            back = tr.changes.invertedDesc;
            changes = $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.empty(state.doc.length);
        } else {
            let filtered = tr.changes.filter(result);
            changes = filtered.changes;
            back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
        }
        tr = $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, changes, tr.selection && tr.selection.map(back), $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(tr.effects, back), tr.annotations, tr.scrollIntoView);
    }
    // Transaction filters
    let filters = state.facet($6295c6875f57e3ee$var$transactionFilter);
    for(let i = filters.length - 1; i >= 0; i--){
        let filtered = filters[i](tr);
        if (filtered instanceof $6295c6875f57e3ee$export$febc5573c75cefb0) tr = filtered;
        else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof $6295c6875f57e3ee$export$febc5573c75cefb0) tr = filtered[0];
        else tr = $6295c6875f57e3ee$var$resolveTransaction(state, $6295c6875f57e3ee$var$asArray(filtered), false);
    }
    return tr;
}
function $6295c6875f57e3ee$var$extendTransaction(tr) {
    let state = tr.startState, extenders = state.facet($6295c6875f57e3ee$var$transactionExtender), spec = tr;
    for(let i = extenders.length - 1; i >= 0; i--){
        let extension = extenders[i](tr);
        if (extension && Object.keys(extension).length) spec = $6295c6875f57e3ee$var$mergeTransaction(spec, $6295c6875f57e3ee$var$resolveTransactionInner(state, extension, tr.changes.newLength), true);
    }
    return spec == tr ? tr : $6295c6875f57e3ee$export$febc5573c75cefb0.create(state, tr.changes, tr.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const $6295c6875f57e3ee$var$none = [];
function $6295c6875f57e3ee$var$asArray(value) {
    return value == null ? $6295c6875f57e3ee$var$none : Array.isArray(value) ? value : [
        value
    ];
}
/**
The categories produced by a [character
categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer). These are used
do things like selecting by word.
*/ var $6295c6875f57e3ee$export$239a3d59567c1401 = /*@__PURE__*/ function(CharCategory) {
    /**
    Word characters.
    */ CharCategory[CharCategory["Word"] = 0] = "Word";
    /**
    Whitespace.
    */ CharCategory[CharCategory["Space"] = 1] = "Space";
    /**
    Anything else.
    */ CharCategory[CharCategory["Other"] = 2] = "Other";
    return CharCategory;
}($6295c6875f57e3ee$export$239a3d59567c1401 || ($6295c6875f57e3ee$export$239a3d59567c1401 = {}));
const $6295c6875f57e3ee$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let $6295c6875f57e3ee$var$wordChar;
try {
    $6295c6875f57e3ee$var$wordChar = /*@__PURE__*/ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_) {}
function $6295c6875f57e3ee$var$hasWordChar(str) {
    if ($6295c6875f57e3ee$var$wordChar) return $6295c6875f57e3ee$var$wordChar.test(str);
    for(let i = 0; i < str.length; i++){
        let ch = str[i];
        if (/\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || $6295c6875f57e3ee$var$nonASCIISingleCaseWordChar.test(ch))) return true;
    }
    return false;
}
function $6295c6875f57e3ee$var$makeCategorizer(wordChars) {
    return (char)=>{
        if (!/\S/.test(char)) return $6295c6875f57e3ee$export$239a3d59567c1401.Space;
        if ($6295c6875f57e3ee$var$hasWordChar(char)) return $6295c6875f57e3ee$export$239a3d59567c1401.Word;
        for(let i = 0; i < wordChars.length; i++)if (char.indexOf(wordChars[i]) > -1) return $6295c6875f57e3ee$export$239a3d59567c1401.Word;
        return $6295c6875f57e3ee$export$239a3d59567c1401.Other;
    };
}
/**
The editor state class is a persistent (immutable) data structure.
To update a state, you [create](https://codemirror.net/6/docs/ref/#state.EditorState.update) a
[transaction](https://codemirror.net/6/docs/ref/#state.Transaction), which produces a _new_ state
instance, without modifying the original object.

As such, _never_ mutate properties of a state directly. That'll
just break things.
*/ class $6295c6875f57e3ee$export$afa855cbfaff27f2 {
    constructor(/**
    @internal
    */ config, /**
    The current document.
    */ doc, /**
    The current selection.
    */ selection, /**
    @internal
    */ values, computeSlot, tr){
        this.config = config;
        this.doc = doc;
        this.selection = selection;
        this.values = values;
        this.status = config.statusTemplate.slice();
        this.computeSlot = computeSlot;
        // Fill in the computed state immediately, so that further queries
        // for it made during the update return this state
        if (tr) tr._state = this;
        for(let i = 0; i < this.config.dynamicSlots.length; i++)$6295c6875f57e3ee$var$ensureAddr(this, i << 1);
        this.computeSlot = null;
    }
    field(field, require = true) {
        let addr = this.config.address[field.id];
        if (addr == null) {
            if (require) throw new RangeError("Field is not present in this state");
            return undefined;
        }
        $6295c6875f57e3ee$var$ensureAddr(this, addr);
        return $6295c6875f57e3ee$var$getAddr(this, addr);
    }
    /**
    Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
    state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
    can be passed. Unless
    [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
    [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
    are assumed to start in the _current_ document (not the document
    produced by previous specs), and its
    [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
    [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
    to the document created by its _own_ changes. The resulting
    transaction contains the combined effect of all the different
    specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
    specs take precedence over earlier ones.
    */ update(...specs) {
        return $6295c6875f57e3ee$var$resolveTransaction(this, specs, true);
    }
    /**
    @internal
    */ applyTransaction(tr) {
        let conf = this.config, { base: base, compartments: compartments } = conf;
        for (let effect of tr.effects){
            if (effect.is($6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure)) {
                if (conf) {
                    compartments = new Map;
                    conf.compartments.forEach((val, key)=>compartments.set(key, val));
                    conf = null;
                }
                compartments.set(effect.value.compartment, effect.value.extension);
            } else if (effect.is($6295c6875f57e3ee$export$95000d4efaa4321f.reconfigure)) {
                conf = null;
                base = effect.value;
            } else if (effect.is($6295c6875f57e3ee$export$95000d4efaa4321f.appendConfig)) {
                conf = null;
                base = $6295c6875f57e3ee$var$asArray(base).concat(effect.value);
            }
        }
        let startValues;
        if (!conf) {
            conf = $6295c6875f57e3ee$var$Configuration.resolve(base, compartments, this);
            let intermediateState = new $6295c6875f57e3ee$export$afa855cbfaff27f2(conf, this.doc, this.selection, conf.dynamicSlots.map(()=>null), (state, slot)=>slot.reconfigure(state, this), null);
            startValues = intermediateState.values;
        } else startValues = tr.startState.values.slice();
        let selection = tr.startState.facet($6295c6875f57e3ee$var$allowMultipleSelections) ? tr.newSelection : tr.newSelection.asSingle();
        new $6295c6875f57e3ee$export$afa855cbfaff27f2(conf, tr.newDoc, selection, startValues, (state, slot)=>slot.update(state, tr), tr);
    }
    /**
    Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
    replaces every selection range with the given content.
    */ replaceSelection(text) {
        if (typeof text == "string") text = this.toText(text);
        return this.changeByRange((range)=>({
                changes: {
                    from: range.from,
                    to: range.to,
                    insert: text
                },
                range: $6295c6875f57e3ee$export$3bb1bd44aee62999.cursor(range.from + text.length)
            }));
    }
    /**
    Create a set of changes and a new selection by running the given
    function for each range in the active selection. The function
    can return an optional set of changes (in the coordinate space
    of the start document), plus an updated range (in the coordinate
    space of the document produced by the call's own changes). This
    method will merge all the changes and ranges into a single
    changeset and selection, and return it as a [transaction
    spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
    [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
    */ changeByRange(f) {
        let sel = this.selection;
        let result1 = f(sel.ranges[0]);
        let changes = this.changes(result1.changes), ranges = [
            result1.range
        ];
        let effects = $6295c6875f57e3ee$var$asArray(result1.effects);
        for(let i = 1; i < sel.ranges.length; i++){
            let result = f(sel.ranges[i]);
            let newChanges = this.changes(result.changes), newMapped = newChanges.map(changes);
            for(let j = 0; j < i; j++)ranges[j] = ranges[j].map(newMapped);
            let mapBy = changes.mapDesc(newChanges, true);
            ranges.push(result.range.map(mapBy));
            changes = changes.compose(newMapped);
            effects = $6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects(effects, newMapped).concat($6295c6875f57e3ee$export$95000d4efaa4321f.mapEffects($6295c6875f57e3ee$var$asArray(result.effects), mapBy));
        }
        return {
            changes: changes,
            selection: $6295c6875f57e3ee$export$3bb1bd44aee62999.create(ranges, sel.mainIndex),
            effects: effects
        };
    }
    /**
    Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
    description, taking the state's document length and line
    separator into account.
    */ changes(spec = []) {
        if (spec instanceof $6295c6875f57e3ee$export$29d7fbdcb1f8b71c) return spec;
        return $6295c6875f57e3ee$export$29d7fbdcb1f8b71c.of(spec, this.doc.length, this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator));
    }
    /**
    Using the state's [line
    separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
    [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
    */ toText(string) {
        return $6295c6875f57e3ee$export$5f1af8db9871e1d6.of(string.split(this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || $6295c6875f57e3ee$var$DefaultSplit));
    }
    /**
    Return the given range of the document as a string.
    */ sliceDoc(from = 0, to = this.doc.length) {
        return this.doc.sliceString(from, to, this.lineBreak);
    }
    /**
    Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
    */ facet(facet) {
        let addr = this.config.address[facet.id];
        if (addr == null) return facet.default;
        $6295c6875f57e3ee$var$ensureAddr(this, addr);
        return $6295c6875f57e3ee$var$getAddr(this, addr);
    }
    /**
    Convert this state to a JSON-serializable object. When custom
    fields should be serialized, you can pass them in as an object
    mapping property names (in the resulting object, which should
    not use `doc` or `selection`) to fields.
    */ toJSON(fields) {
        let result = {
            doc: this.sliceDoc(),
            selection: this.selection.toJSON()
        };
        if (fields) for(let prop in fields){
            let value = fields[prop];
            if (value instanceof $6295c6875f57e3ee$export$34381b1ce2130245 && this.config.address[value.id] != null) result[prop] = value.spec.toJSON(this.field(fields[prop]), this);
        }
        return result;
    }
    /**
    Deserialize a state from its JSON representation. When custom
    fields should be deserialized, pass the same object you passed
    to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
    third argument.
    */ static fromJSON(json, config = {}, fields) {
        if (!json || typeof json.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
        let fieldInit = [];
        if (fields) {
            for(let prop in fields)if (Object.prototype.hasOwnProperty.call(json, prop)) {
                let field = fields[prop], value = json[prop];
                fieldInit.push(field.init((state)=>field.spec.fromJSON(value, state)));
            }
        }
        return $6295c6875f57e3ee$export$afa855cbfaff27f2.create({
            doc: json.doc,
            selection: $6295c6875f57e3ee$export$3bb1bd44aee62999.fromJSON(json.selection),
            extensions: config.extensions ? fieldInit.concat([
                config.extensions
            ]) : fieldInit
        });
    }
    /**
    Create a new state. You'll usually only need this when
    initializing an editor—updated states are created by applying
    transactions.
    */ static create(config = {}) {
        let configuration = $6295c6875f57e3ee$var$Configuration.resolve(config.extensions || [], new Map);
        let doc = config.doc instanceof $6295c6875f57e3ee$export$5f1af8db9871e1d6 ? config.doc : $6295c6875f57e3ee$export$5f1af8db9871e1d6.of((config.doc || "").split(configuration.staticFacet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || $6295c6875f57e3ee$var$DefaultSplit));
        let selection = !config.selection ? $6295c6875f57e3ee$export$3bb1bd44aee62999.single(0) : config.selection instanceof $6295c6875f57e3ee$export$3bb1bd44aee62999 ? config.selection : $6295c6875f57e3ee$export$3bb1bd44aee62999.single(config.selection.anchor, config.selection.head);
        $6295c6875f57e3ee$var$checkSelection(selection, doc.length);
        if (!configuration.staticFacet($6295c6875f57e3ee$var$allowMultipleSelections)) selection = selection.asSingle();
        return new $6295c6875f57e3ee$export$afa855cbfaff27f2(configuration, doc, selection, configuration.dynamicSlots.map(()=>null), (state, slot)=>slot.create(state), null);
    }
    /**
    The size (in columns) of a tab in the document, determined by
    the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
    */ get tabSize() {
        return this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.tabSize);
    }
    /**
    Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
    string for this state.
    */ get lineBreak() {
        return this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator) || "\n";
    }
    /**
    Returns true when the editor is
    [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
    */ get readOnly() {
        return this.facet($6295c6875f57e3ee$var$readOnly);
    }
    /**
    Look up a translation for the given phrase (via the
    [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
    original string if no translation is found.
    
    If additional arguments are passed, they will be inserted in
    place of markers like `$1` (for the first value) and `$2`, etc.
    A single `$` is equivalent to `$1`, and `$$` will produce a
    literal dollar sign.
    */ phrase(phrase, ...insert) {
        for (let map of this.facet($6295c6875f57e3ee$export$afa855cbfaff27f2.phrases))if (Object.prototype.hasOwnProperty.call(map, phrase)) {
            phrase = map[phrase];
            break;
        }
        if (insert.length) phrase = phrase.replace(/\$(\$|\d*)/g, (m, i)=>{
            if (i == "$") return "$";
            let n = +(i || 1);
            return !n || n > insert.length ? m : insert[n - 1];
        });
        return phrase;
    }
    /**
    Find the values for a given language data field, provided by the
    the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
    
    Examples of language data fields are...
    
    - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
      comment syntax.
    - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
      for providing language-specific completion sources.
    - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
      characters that should be considered part of words in this
      language.
    - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
      bracket closing behavior.
    */ languageDataAt(name, pos, side = -1) {
        let values = [];
        for (let provider of this.facet($6295c6875f57e3ee$var$languageData)){
            for (let result of provider(this, pos, side))if (Object.prototype.hasOwnProperty.call(result, name)) values.push(result[name]);
        }
        return values;
    }
    /**
    Return a function that can categorize strings (expected to
    represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
    into one of:
    
     - Word (contains an alphanumeric character or a character
       explicitly listed in the local language's `"wordChars"`
       language data, which should be a string)
     - Space (contains only whitespace)
     - Other (anything else)
    */ charCategorizer(at) {
        return $6295c6875f57e3ee$var$makeCategorizer(this.languageDataAt("wordChars", at).join(""));
    }
    /**
    Find the word at the given position, meaning the range
    containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
    around it. If no word characters are adjacent to the position,
    this returns null.
    */ wordAt(pos) {
        let { text: text, from: from, length: length } = this.doc.lineAt(pos);
        let cat = this.charCategorizer(pos);
        let start = pos - from, end = pos - from;
        while(start > 0){
            let prev = $6295c6875f57e3ee$export$a0fa439fd515e1ed(text, start, false);
            if (cat(text.slice(prev, start)) != $6295c6875f57e3ee$export$239a3d59567c1401.Word) break;
            start = prev;
        }
        while(end < length){
            let next = $6295c6875f57e3ee$export$a0fa439fd515e1ed(text, end);
            if (cat(text.slice(end, next)) != $6295c6875f57e3ee$export$239a3d59567c1401.Word) break;
            end = next;
        }
        return start == end ? null : $6295c6875f57e3ee$export$3bb1bd44aee62999.range(start + from, end + from);
    }
}
/**
A facet that, when enabled, causes the editor to allow multiple
ranges to be selected. Be careful though, because by default the
editor relies on the native DOM selection, which cannot handle
multiple selections. An extension like
[`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) can be used to make
secondary selections visible to the user.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.allowMultipleSelections = $6295c6875f57e3ee$var$allowMultipleSelections;
/**
Configures the tab size to use in this state. The first
(highest-precedence) value of the facet is used. If no value is
given, this defaults to 4.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.tabSize = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    combine: (values)=>values.length ? values[0] : 4
});
/**
The line separator to use. By default, any of `"\n"`, `"\r\n"`
and `"\r"` is treated as a separator when splitting lines, and
lines are joined with `"\n"`.

When you configure a value here, only that precise separator
will be used, allowing you to round-trip documents through the
editor without normalizing line separators.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.lineSeparator = $6295c6875f57e3ee$var$lineSeparator;
/**
This facet controls the value of the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) getter, which is
consulted by commands and extensions that implement editing
functionality to determine whether they should apply. It
defaults to false, but when its highest-precedence value is
`true`, such functionality disables itself.

Not to be confused with
[`EditorView.editable`](https://codemirror.net/6/docs/ref/#view.EditorView^editable), which
controls whether the editor's DOM is set to be editable (and
thus focusable).
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.readOnly = $6295c6875f57e3ee$var$readOnly;
/**
Registers translation phrases. The
[`phrase`](https://codemirror.net/6/docs/ref/#state.EditorState.phrase) method will look through
all objects registered with this facet to find translations for
its argument.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.phrases = /*@__PURE__*/ $6295c6875f57e3ee$export$ef7d5e9b79fa1504.define({
    compare (a, b) {
        let kA = Object.keys(a), kB = Object.keys(b);
        return kA.length == kB.length && kA.every((k)=>a[k] == b[k]);
    }
});
/**
A facet used to register [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) providers.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.languageData = $6295c6875f57e3ee$var$languageData;
/**
Facet used to register change filters, which are called for each
transaction (unless explicitly
[disabled](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter)), and can suppress
part of the transaction's changes.

Such a function can return `true` to indicate that it doesn't
want to do anything, `false` to completely stop the changes in
the transaction, or a set of ranges in which changes should be
suppressed. Such ranges are represented as an array of numbers,
with each pair of two numbers indicating the start and end of a
range. So for example `[10, 20, 100, 110]` suppresses changes
between 10 and 20, and between 100 and 110.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.changeFilter = $6295c6875f57e3ee$var$changeFilter;
/**
Facet used to register a hook that gets a chance to update or
replace transaction specs before they are applied. This will
only be applied for transactions that don't have
[`filter`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter) set to `false`. You
can either return a single transaction spec (possibly the input
transaction), or an array of specs (which will be combined in
the same way as the arguments to
[`EditorState.update`](https://codemirror.net/6/docs/ref/#state.EditorState.update)).

When possible, it is recommended to avoid accessing
[`Transaction.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state) in a filter,
since it will force creation of a state that will then be
discarded again, if the transaction is actually filtered.

(This functionality should be used with care. Indiscriminately
modifying transaction is likely to break something or degrade
the user experience.)
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.transactionFilter = $6295c6875f57e3ee$var$transactionFilter;
/**
This is a more limited form of
[`transactionFilter`](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter),
which can only add
[annotations](https://codemirror.net/6/docs/ref/#state.TransactionSpec.annotations) and
[effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects). _But_, this type
of filter runs even if the transaction has disabled regular
[filtering](https://codemirror.net/6/docs/ref/#state.TransactionSpec.filter), making it suitable
for effects that don't need to touch the changes or selection,
but do want to process every transaction.

Extenders run _after_ filters, when both are present.
*/ $6295c6875f57e3ee$export$afa855cbfaff27f2.transactionExtender = $6295c6875f57e3ee$var$transactionExtender;
$6295c6875f57e3ee$export$d51c0172eb2c2431.reconfigure = /*@__PURE__*/ $6295c6875f57e3ee$export$95000d4efaa4321f.define();
/**
Utility function for combining behaviors to fill in a config
object from an array of provided configs. `defaults` should hold
default values for all optional fields in `Config`.

The function will, by default, error
when a field gets two values that aren't `===`-equal, but you can
provide combine functions per field to do something else.
*/ function $6295c6875f57e3ee$export$4e19c0b693794a7e(configs, defaults, combine = {}) {
    let result = {};
    for (let config of configs)for (let key of Object.keys(config)){
        let value = config[key], current = result[key];
        if (current === undefined) result[key] = value;
        else if (current === value || value === undefined) ; // No conflict
        else if (Object.hasOwnProperty.call(combine, key)) result[key] = combine[key](current, value);
        else throw new Error("Config merge conflict for field " + key);
    }
    for(let key in defaults)if (result[key] === undefined) result[key] = defaults[key];
    return result;
}
/**
Each range is associated with a value, which must inherit from
this class.
*/ class $6295c6875f57e3ee$export$d60f08ed93a48611 {
    /**
    Compare this value with another value. Used when comparing
    rangesets. The default implementation compares by identity.
    Unless you are only creating a fixed number of unique instances
    of your value type, it is a good idea to implement this
    properly.
    */ eq(other) {
        return this == other;
    }
    /**
    Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
    */ range(from, to = from) {
        return $6295c6875f57e3ee$export$9a58ef0d7ad3278c.create(from, to, this);
    }
}
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.startSide = $6295c6875f57e3ee$export$d60f08ed93a48611.prototype.endSide = 0;
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.point = false;
$6295c6875f57e3ee$export$d60f08ed93a48611.prototype.mapMode = $6295c6875f57e3ee$export$39cf3280165f92aa.TrackDel;
/**
A range associates a value with a range of positions.
*/ class $6295c6875f57e3ee$export$9a58ef0d7ad3278c {
    constructor(/**
    The range's start position.
    */ from, /**
    Its end position.
    */ to, /**
    The value associated with this range.
    */ value){
        this.from = from;
        this.to = to;
        this.value = value;
    }
    /**
    @internal
    */ static create(from, to, value) {
        return new $6295c6875f57e3ee$export$9a58ef0d7ad3278c(from, to, value);
    }
}
function $6295c6875f57e3ee$var$cmpRange(a, b) {
    return a.from - b.from || a.value.startSide - b.value.startSide;
}
class $6295c6875f57e3ee$var$Chunk {
    constructor(from, to, value, // Chunks are marked with the largest point that occurs
    // in them (or -1 for no points), so that scans that are
    // only interested in points (such as the
    // heightmap-related logic) can skip range-only chunks.
    maxPoint){
        this.from = from;
        this.to = to;
        this.value = value;
        this.maxPoint = maxPoint;
    }
    get length() {
        return this.to[this.to.length - 1];
    }
    // Find the index of the given position and side. Use the ranges'
    // `from` pos when `end == false`, `to` when `end == true`.
    findIndex(pos, side, end, startAt = 0) {
        let arr = end ? this.to : this.from;
        for(let lo = startAt, hi = arr.length;;){
            if (lo == hi) return lo;
            let mid = lo + hi >> 1;
            let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
            if (mid == lo) return diff >= 0 ? lo : hi;
            if (diff >= 0) hi = mid;
            else lo = mid + 1;
        }
    }
    between(offset, from, to, f) {
        for(let i = this.findIndex(from, -1000000000 /* C.Far */ , true), e = this.findIndex(to, 1000000000 /* C.Far */ , false, i); i < e; i++)if (f(this.from[i] + offset, this.to[i] + offset, this.value[i]) === false) return false;
    }
    map(offset, changes) {
        let value = [], from = [], to = [], newPos = -1, maxPoint = -1;
        for(let i = 0; i < this.value.length; i++){
            let val = this.value[i], curFrom = this.from[i] + offset, curTo = this.to[i] + offset, newFrom, newTo;
            if (curFrom == curTo) {
                let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
                if (mapped == null) continue;
                newFrom = newTo = mapped;
                if (val.startSide != val.endSide) {
                    newTo = changes.mapPos(curFrom, val.endSide);
                    if (newTo < newFrom) continue;
                }
            } else {
                newFrom = changes.mapPos(curFrom, val.startSide);
                newTo = changes.mapPos(curTo, val.endSide);
                if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0) continue;
            }
            if ((newTo - newFrom || val.endSide - val.startSide) < 0) continue;
            if (newPos < 0) newPos = newFrom;
            if (val.point) maxPoint = Math.max(maxPoint, newTo - newFrom);
            value.push(val);
            from.push(newFrom - newPos);
            to.push(newTo - newPos);
        }
        return {
            mapped: value.length ? new $6295c6875f57e3ee$var$Chunk(from, to, value, maxPoint) : null,
            pos: newPos
        };
    }
}
/**
A range set stores a collection of [ranges](https://codemirror.net/6/docs/ref/#state.Range) in a
way that makes them efficient to [map](https://codemirror.net/6/docs/ref/#state.RangeSet.map) and
[update](https://codemirror.net/6/docs/ref/#state.RangeSet.update). This is an immutable data
structure.
*/ class $6295c6875f57e3ee$export$34cb5241245008dd {
    constructor(/**
    @internal
    */ chunkPos, /**
    @internal
    */ chunk, /**
    @internal
    */ nextLayer, /**
    @internal
    */ maxPoint){
        this.chunkPos = chunkPos;
        this.chunk = chunk;
        this.nextLayer = nextLayer;
        this.maxPoint = maxPoint;
    }
    /**
    @internal
    */ static create(chunkPos, chunk, nextLayer, maxPoint) {
        return new $6295c6875f57e3ee$export$34cb5241245008dd(chunkPos, chunk, nextLayer, maxPoint);
    }
    /**
    @internal
    */ get length() {
        let last = this.chunk.length - 1;
        return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
    }
    /**
    The number of ranges in the set.
    */ get size() {
        if (this.isEmpty) return 0;
        let size = this.nextLayer.size;
        for (let chunk of this.chunk)size += chunk.value.length;
        return size;
    }
    /**
    @internal
    */ chunkEnd(index) {
        return this.chunkPos[index] + this.chunk[index].length;
    }
    /**
    Update the range set, optionally adding new ranges or filtering
    out existing ones.
    
    (Note: The type parameter is just there as a kludge to work
    around TypeScript variance issues that prevented `RangeSet<X>`
    from being a subtype of `RangeSet<Y>` when `X` is a subtype of
    `Y`.)
    */ update(updateSpec) {
        let { add: add = [], sort: sort = false, filterFrom: filterFrom = 0, filterTo: filterTo = this.length } = updateSpec;
        let filter = updateSpec.filter;
        if (add.length == 0 && !filter) return this;
        if (sort) add = add.slice().sort($6295c6875f57e3ee$var$cmpRange);
        if (this.isEmpty) return add.length ? $6295c6875f57e3ee$export$34cb5241245008dd.of(add) : this;
        let cur = new $6295c6875f57e3ee$var$LayerCursor(this, null, -1).goto(0), i = 0, spill = [];
        let builder = new $6295c6875f57e3ee$export$89e09ce03c7e8594();
        while(cur.value || i < add.length){
            if (i < add.length && (cur.from - add[i].from || cur.startSide - add[i].value.startSide) >= 0) {
                let range = add[i++];
                if (!builder.addInner(range.from, range.to, range.value)) spill.push(range);
            } else if (cur.rangeIndex == 1 && cur.chunkIndex < this.chunk.length && (i == add.length || this.chunkEnd(cur.chunkIndex) < add[i].from) && (!filter || filterFrom > this.chunkEnd(cur.chunkIndex) || filterTo < this.chunkPos[cur.chunkIndex]) && builder.addChunk(this.chunkPos[cur.chunkIndex], this.chunk[cur.chunkIndex])) cur.nextChunk();
            else {
                if (!filter || filterFrom > cur.to || filterTo < cur.from || filter(cur.from, cur.to, cur.value)) {
                    if (!builder.addInner(cur.from, cur.to, cur.value)) spill.push($6295c6875f57e3ee$export$9a58ef0d7ad3278c.create(cur.from, cur.to, cur.value));
                }
                cur.next();
            }
        }
        return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? $6295c6875f57e3ee$export$34cb5241245008dd.empty : this.nextLayer.update({
            add: spill,
            filter: filter,
            filterFrom: filterFrom,
            filterTo: filterTo
        }));
    }
    /**
    Map this range set through a set of changes, return the new set.
    */ map(changes) {
        if (changes.empty || this.isEmpty) return this;
        let chunks = [], chunkPos = [], maxPoint = -1;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            let touch = changes.touchesRange(start, start + chunk.length);
            if (touch === false) {
                maxPoint = Math.max(maxPoint, chunk.maxPoint);
                chunks.push(chunk);
                chunkPos.push(changes.mapPos(start));
            } else if (touch === true) {
                let { mapped: mapped, pos: pos } = chunk.map(start, changes);
                if (mapped) {
                    maxPoint = Math.max(maxPoint, mapped.maxPoint);
                    chunks.push(mapped);
                    chunkPos.push(pos);
                }
            }
        }
        let next = this.nextLayer.map(changes);
        return chunks.length == 0 ? next : new $6295c6875f57e3ee$export$34cb5241245008dd(chunkPos, chunks, next || $6295c6875f57e3ee$export$34cb5241245008dd.empty, maxPoint);
    }
    /**
    Iterate over the ranges that touch the region `from` to `to`,
    calling `f` for each. There is no guarantee that the ranges will
    be reported in any specific order. When the callback returns
    `false`, iteration stops.
    */ between(from, to, f) {
        if (this.isEmpty) return;
        for(let i = 0; i < this.chunk.length; i++){
            let start = this.chunkPos[i], chunk = this.chunk[i];
            if (to >= start && from <= start + chunk.length && chunk.between(start, from - start, to - start, f) === false) return;
        }
        this.nextLayer.between(from, to, f);
    }
    /**
    Iterate over the ranges in this set, in order, including all
    ranges that end at or after `from`.
    */ iter(from = 0) {
        return $6295c6875f57e3ee$var$HeapCursor.from([
            this
        ]).goto(from);
    }
    /**
    @internal
    */ get isEmpty() {
        return this.nextLayer == this;
    }
    /**
    Iterate over the ranges in a collection of sets, in order,
    starting from `from`.
    */ static iter(sets, from = 0) {
        return $6295c6875f57e3ee$var$HeapCursor.from(sets).goto(from);
    }
    /**
    Iterate over two groups of sets, calling methods on `comparator`
    to notify it of possible differences.
    */ static compare(oldSets, newSets, /**
    This indicates how the underlying data changed between these
    ranges, and is needed to synchronize the iteration.
    */ textDiff, comparator, /**
    Can be used to ignore all non-point ranges, and points below
    the given size. When -1, all ranges are compared.
    */ minPointSize = -1) {
        let a = oldSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let b = newSets.filter((set)=>set.maxPoint > 0 || !set.isEmpty && set.maxPoint >= minPointSize);
        let sharedChunks = $6295c6875f57e3ee$var$findSharedChunks(a, b, textDiff);
        let sideA = new $6295c6875f57e3ee$var$SpanCursor(a, sharedChunks, minPointSize);
        let sideB = new $6295c6875f57e3ee$var$SpanCursor(b, sharedChunks, minPointSize);
        textDiff.iterGaps((fromA, fromB, length)=>$6295c6875f57e3ee$var$compare(sideA, fromA, sideB, fromB, length, comparator));
        if (textDiff.empty && textDiff.length == 0) $6295c6875f57e3ee$var$compare(sideA, 0, sideB, 0, 0, comparator);
    }
    /**
    Compare the contents of two groups of range sets, returning true
    if they are equivalent in the given range.
    */ static eq(oldSets, newSets, from = 0, to) {
        if (to == null) to = 999999999;
        let a = oldSets.filter((set)=>!set.isEmpty && newSets.indexOf(set) < 0);
        let b = newSets.filter((set)=>!set.isEmpty && oldSets.indexOf(set) < 0);
        if (a.length != b.length) return false;
        if (!a.length) return true;
        let sharedChunks = $6295c6875f57e3ee$var$findSharedChunks(a, b);
        let sideA = new $6295c6875f57e3ee$var$SpanCursor(a, sharedChunks, 0).goto(from), sideB = new $6295c6875f57e3ee$var$SpanCursor(b, sharedChunks, 0).goto(from);
        for(;;){
            if (sideA.to != sideB.to || !$6295c6875f57e3ee$var$sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point))) return false;
            if (sideA.to > to) return true;
            sideA.next();
            sideB.next();
        }
    }
    /**
    Iterate over a group of range sets at the same time, notifying
    the iterator about the ranges covering every given piece of
    content. Returns the open count (see
    [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
    of the iteration.
    */ static spans(sets, from, to, iterator, /**
    When given and greater than -1, only points of at least this
    size are taken into account.
    */ minPointSize = -1) {
        let cursor = new $6295c6875f57e3ee$var$SpanCursor(sets, null, minPointSize).goto(from), pos = from;
        let openRanges = cursor.openStart;
        for(;;){
            let curTo = Math.min(cursor.to, to);
            if (cursor.point) {
                let active = cursor.activeForPoint(cursor.to);
                let openCount = cursor.pointFrom < from ? active.length + 1 : cursor.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
                iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
                openRanges = Math.min(cursor.openEnd(curTo), active.length);
            } else if (curTo > pos) {
                iterator.span(pos, curTo, cursor.active, openRanges);
                openRanges = cursor.openEnd(curTo);
            }
            if (cursor.to > to) return openRanges + (cursor.point && cursor.to > to ? 1 : 0);
            pos = cursor.to;
            cursor.next();
        }
    }
    /**
    Create a range set for the given range or array of ranges. By
    default, this expects the ranges to be _sorted_ (by start
    position and, if two start at the same position,
    `value.startSide`). You can pass `true` as second argument to
    cause the method to sort them.
    */ static of(ranges, sort = false) {
        let build = new $6295c6875f57e3ee$export$89e09ce03c7e8594();
        for (let range of ranges instanceof $6295c6875f57e3ee$export$9a58ef0d7ad3278c ? [
            ranges
        ] : sort ? $6295c6875f57e3ee$var$lazySort(ranges) : ranges)build.add(range.from, range.to, range.value);
        return build.finish();
    }
    /**
    Join an array of range sets into a single set.
    */ static join(sets) {
        if (!sets.length) return $6295c6875f57e3ee$export$34cb5241245008dd.empty;
        let result = sets[sets.length - 1];
        for(let i = sets.length - 2; i >= 0; i--)for(let layer = sets[i]; layer != $6295c6875f57e3ee$export$34cb5241245008dd.empty; layer = layer.nextLayer)result = new $6295c6875f57e3ee$export$34cb5241245008dd(layer.chunkPos, layer.chunk, result, Math.max(layer.maxPoint, result.maxPoint));
        return result;
    }
}
/**
The empty set of ranges.
*/ $6295c6875f57e3ee$export$34cb5241245008dd.empty = /*@__PURE__*/ new $6295c6875f57e3ee$export$34cb5241245008dd([], [], null, -1);
function $6295c6875f57e3ee$var$lazySort(ranges) {
    if (ranges.length > 1) for(let prev = ranges[0], i = 1; i < ranges.length; i++){
        let cur = ranges[i];
        if ($6295c6875f57e3ee$var$cmpRange(prev, cur) > 0) return ranges.slice().sort($6295c6875f57e3ee$var$cmpRange);
        prev = cur;
    }
    return ranges;
}
$6295c6875f57e3ee$export$34cb5241245008dd.empty.nextLayer = $6295c6875f57e3ee$export$34cb5241245008dd.empty;
/**
A range set builder is a data structure that helps build up a
[range set](https://codemirror.net/6/docs/ref/#state.RangeSet) directly, without first allocating
an array of [`Range`](https://codemirror.net/6/docs/ref/#state.Range) objects.
*/ class $6295c6875f57e3ee$export$89e09ce03c7e8594 {
    finishChunk(newArrays) {
        this.chunks.push(new $6295c6875f57e3ee$var$Chunk(this.from, this.to, this.value, this.maxPoint));
        this.chunkPos.push(this.chunkStart);
        this.chunkStart = -1;
        this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
        this.maxPoint = -1;
        if (newArrays) {
            this.from = [];
            this.to = [];
            this.value = [];
        }
    }
    /**
    Create an empty builder.
    */ constructor(){
        this.chunks = [];
        this.chunkPos = [];
        this.chunkStart = -1;
        this.last = null;
        this.lastFrom = -1000000000 /* C.Far */ ;
        this.lastTo = -1000000000 /* C.Far */ ;
        this.from = [];
        this.to = [];
        this.value = [];
        this.maxPoint = -1;
        this.setMaxPoint = -1;
        this.nextLayer = null;
    }
    /**
    Add a range. Ranges should be added in sorted (by `from` and
    `value.startSide`) order.
    */ add(from, to, value) {
        if (!this.addInner(from, to, value)) (this.nextLayer || (this.nextLayer = new $6295c6875f57e3ee$export$89e09ce03c7e8594)).add(from, to, value);
    }
    /**
    @internal
    */ addInner(from, to, value) {
        let diff = from - this.lastTo || value.startSide - this.last.endSide;
        if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0) throw new Error("Ranges must be added sorted by `from` position and `startSide`");
        if (diff < 0) return false;
        if (this.from.length == 250 /* C.ChunkSize */ ) this.finishChunk(true);
        if (this.chunkStart < 0) this.chunkStart = from;
        this.from.push(from - this.chunkStart);
        this.to.push(to - this.chunkStart);
        this.last = value;
        this.lastFrom = from;
        this.lastTo = to;
        this.value.push(value);
        if (value.point) this.maxPoint = Math.max(this.maxPoint, to - from);
        return true;
    }
    /**
    @internal
    */ addChunk(from, chunk) {
        if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0) return false;
        if (this.from.length) this.finishChunk(true);
        this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
        this.chunks.push(chunk);
        this.chunkPos.push(from);
        let last = chunk.value.length - 1;
        this.last = chunk.value[last];
        this.lastFrom = chunk.from[last] + from;
        this.lastTo = chunk.to[last] + from;
        return true;
    }
    /**
    Finish the range set. Returns the new set. The builder can't be
    used anymore after this has been called.
    */ finish() {
        return this.finishInner($6295c6875f57e3ee$export$34cb5241245008dd.empty);
    }
    /**
    @internal
    */ finishInner(next) {
        if (this.from.length) this.finishChunk(false);
        if (this.chunks.length == 0) return next;
        let result = $6295c6875f57e3ee$export$34cb5241245008dd.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
        this.from = null; // Make sure further `add` calls produce errors
        return result;
    }
}
function $6295c6875f57e3ee$var$findSharedChunks(a, b, textDiff) {
    let inA = new Map();
    for (let set of a)for(let i = 0; i < set.chunk.length; i++)if (set.chunk[i].maxPoint <= 0) inA.set(set.chunk[i], set.chunkPos[i]);
    let shared = new Set();
    for (let set of b)for(let i = 0; i < set.chunk.length; i++){
        let known = inA.get(set.chunk[i]);
        if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set.chunkPos[i] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set.chunk[i].length))) shared.add(set.chunk[i]);
    }
    return shared;
}
class $6295c6875f57e3ee$var$LayerCursor {
    constructor(layer, skip, minPoint, rank = 0){
        this.layer = layer;
        this.skip = skip;
        this.minPoint = minPoint;
        this.rank = rank;
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    get endSide() {
        return this.value ? this.value.endSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.chunkIndex = this.rangeIndex = 0;
        this.gotoInner(pos, side, false);
        return this;
    }
    gotoInner(pos, side, forward) {
        while(this.chunkIndex < this.layer.chunk.length){
            let next = this.layer.chunk[this.chunkIndex];
            if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint)) break;
            this.chunkIndex++;
            forward = false;
        }
        if (this.chunkIndex < this.layer.chunk.length) {
            let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
            if (!forward || this.rangeIndex < rangeIndex) this.setRangeIndex(rangeIndex);
        }
        this.next();
    }
    forward(pos, side) {
        if ((this.to - pos || this.endSide - side) < 0) this.gotoInner(pos, side, true);
    }
    next() {
        for(;;)if (this.chunkIndex == this.layer.chunk.length) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            break;
        } else {
            let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
            let from = chunkPos + chunk.from[this.rangeIndex];
            this.from = from;
            this.to = chunkPos + chunk.to[this.rangeIndex];
            this.value = chunk.value[this.rangeIndex];
            this.setRangeIndex(this.rangeIndex + 1);
            if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint) break;
        }
    }
    setRangeIndex(index) {
        if (index == this.layer.chunk[this.chunkIndex].value.length) {
            this.chunkIndex++;
            if (this.skip) while(this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))this.chunkIndex++;
            this.rangeIndex = 0;
        } else this.rangeIndex = index;
    }
    nextChunk() {
        this.chunkIndex++;
        this.rangeIndex = 0;
        this.next();
    }
    compare(other) {
        return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
    }
}
class $6295c6875f57e3ee$var$HeapCursor {
    constructor(heap){
        this.heap = heap;
    }
    static from(sets, skip = null, minPoint = -1) {
        let heap = [];
        for(let i = 0; i < sets.length; i++){
            for(let cur = sets[i]; !cur.isEmpty; cur = cur.nextLayer)if (cur.maxPoint >= minPoint) heap.push(new $6295c6875f57e3ee$var$LayerCursor(cur, skip, minPoint, i));
        }
        return heap.length == 1 ? heap[0] : new $6295c6875f57e3ee$var$HeapCursor(heap);
    }
    get startSide() {
        return this.value ? this.value.startSide : 0;
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        for (let cur of this.heap)cur.goto(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6295c6875f57e3ee$var$heapBubble(this.heap, i);
        this.next();
        return this;
    }
    forward(pos, side) {
        for (let cur of this.heap)cur.forward(pos, side);
        for(let i = this.heap.length >> 1; i >= 0; i--)$6295c6875f57e3ee$var$heapBubble(this.heap, i);
        if ((this.to - pos || this.value.endSide - side) < 0) this.next();
    }
    next() {
        if (this.heap.length == 0) {
            this.from = this.to = 1000000000 /* C.Far */ ;
            this.value = null;
            this.rank = -1;
        } else {
            let top = this.heap[0];
            this.from = top.from;
            this.to = top.to;
            this.value = top.value;
            this.rank = top.rank;
            if (top.value) top.next();
            $6295c6875f57e3ee$var$heapBubble(this.heap, 0);
        }
    }
}
function $6295c6875f57e3ee$var$heapBubble(heap, index) {
    for(let cur = heap[index];;){
        let childIndex = (index << 1) + 1;
        if (childIndex >= heap.length) break;
        let child = heap[childIndex];
        if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
            child = heap[childIndex + 1];
            childIndex++;
        }
        if (cur.compare(child) < 0) break;
        heap[childIndex] = cur;
        heap[index] = child;
        index = childIndex;
    }
}
class $6295c6875f57e3ee$var$SpanCursor {
    constructor(sets, skip, minPoint){
        this.minPoint = minPoint;
        this.active = [];
        this.activeTo = [];
        this.activeRank = [];
        this.minActive = -1;
        // A currently active point range, if any
        this.point = null;
        this.pointFrom = 0;
        this.pointRank = 0;
        this.to = -1000000000 /* C.Far */ ;
        this.endSide = 0;
        // The amount of open active ranges at the start of the iterator.
        // Not including points.
        this.openStart = -1;
        this.cursor = $6295c6875f57e3ee$var$HeapCursor.from(sets, skip, minPoint);
    }
    goto(pos, side = -1000000000 /* C.Far */ ) {
        this.cursor.goto(pos, side);
        this.active.length = this.activeTo.length = this.activeRank.length = 0;
        this.minActive = -1;
        this.to = pos;
        this.endSide = side;
        this.openStart = -1;
        this.next();
        return this;
    }
    forward(pos, side) {
        while(this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)this.removeActive(this.minActive);
        this.cursor.forward(pos, side);
    }
    removeActive(index) {
        $6295c6875f57e3ee$var$remove(this.active, index);
        $6295c6875f57e3ee$var$remove(this.activeTo, index);
        $6295c6875f57e3ee$var$remove(this.activeRank, index);
        this.minActive = $6295c6875f57e3ee$var$findMinIndex(this.active, this.activeTo);
    }
    addActive(trackOpen) {
        let i = 0, { value: value, to: to, rank: rank } = this.cursor;
        // Organize active marks by rank first, then by size
        while(i < this.activeRank.length && (rank - this.activeRank[i] || to - this.activeTo[i]) > 0)i++;
        $6295c6875f57e3ee$var$insert(this.active, i, value);
        $6295c6875f57e3ee$var$insert(this.activeTo, i, to);
        $6295c6875f57e3ee$var$insert(this.activeRank, i, rank);
        if (trackOpen) $6295c6875f57e3ee$var$insert(trackOpen, i, this.cursor.from);
        this.minActive = $6295c6875f57e3ee$var$findMinIndex(this.active, this.activeTo);
    }
    // After calling this, if `this.point` != null, the next range is a
    // point. Otherwise, it's a regular range, covered by `this.active`.
    next() {
        let from = this.to, wasPoint = this.point;
        this.point = null;
        let trackOpen = this.openStart < 0 ? [] : null;
        for(;;){
            let a = this.minActive;
            if (a > -1 && (this.activeTo[a] - this.cursor.from || this.active[a].endSide - this.cursor.startSide) < 0) {
                if (this.activeTo[a] > from) {
                    this.to = this.activeTo[a];
                    this.endSide = this.active[a].endSide;
                    break;
                }
                this.removeActive(a);
                if (trackOpen) $6295c6875f57e3ee$var$remove(trackOpen, a);
            } else if (!this.cursor.value) {
                this.to = this.endSide = 1000000000 /* C.Far */ ;
                break;
            } else if (this.cursor.from > from) {
                this.to = this.cursor.from;
                this.endSide = this.cursor.startSide;
                break;
            } else {
                let nextVal = this.cursor.value;
                if (!nextVal.point) {
                    this.addActive(trackOpen);
                    this.cursor.next();
                } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) // Ignore any non-empty points that end precisely at the end of the prev point
                this.cursor.next();
                else {
                    this.point = nextVal;
                    this.pointFrom = this.cursor.from;
                    this.pointRank = this.cursor.rank;
                    this.to = this.cursor.to;
                    this.endSide = nextVal.endSide;
                    this.cursor.next();
                    this.forward(this.to, this.endSide);
                    break;
                }
            }
        }
        if (trackOpen) {
            this.openStart = 0;
            for(let i = trackOpen.length - 1; i >= 0 && trackOpen[i] < from; i--)this.openStart++;
        }
    }
    activeForPoint(to) {
        if (!this.active.length) return this.active;
        let active = [];
        for(let i = this.active.length - 1; i >= 0; i--){
            if (this.activeRank[i] < this.pointRank) break;
            if (this.activeTo[i] > to || this.activeTo[i] == to && this.active[i].endSide >= this.point.endSide) active.push(this.active[i]);
        }
        return active.reverse();
    }
    openEnd(to) {
        let open = 0;
        for(let i = this.activeTo.length - 1; i >= 0 && this.activeTo[i] > to; i--)open++;
        return open;
    }
}
function $6295c6875f57e3ee$var$compare(a, startA, b, startB, length, comparator) {
    a.goto(startA);
    b.goto(startB);
    let endB = startB + length;
    let pos = startB, dPos = startB - startA;
    for(;;){
        let diff = a.to + dPos - b.to || a.endSide - b.endSide;
        let end = diff < 0 ? a.to + dPos : b.to, clipEnd = Math.min(end, endB);
        if (a.point || b.point) {
            if (!(a.point && b.point && (a.point == b.point || a.point.eq(b.point)) && $6295c6875f57e3ee$var$sameValues(a.activeForPoint(a.to), b.activeForPoint(b.to)))) comparator.comparePoint(pos, clipEnd, a.point, b.point);
        } else if (clipEnd > pos && !$6295c6875f57e3ee$var$sameValues(a.active, b.active)) comparator.compareRange(pos, clipEnd, a.active, b.active);
        if (end > endB) break;
        pos = end;
        if (diff <= 0) a.next();
        if (diff >= 0) b.next();
    }
}
function $6295c6875f57e3ee$var$sameValues(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i] != b[i] && !a[i].eq(b[i])) return false;
    return true;
}
function $6295c6875f57e3ee$var$remove(array, index) {
    for(let i = index, e = array.length - 1; i < e; i++)array[i] = array[i + 1];
    array.pop();
}
function $6295c6875f57e3ee$var$insert(array, index, value) {
    for(let i = array.length - 1; i >= index; i--)array[i + 1] = array[i];
    array[index] = value;
}
function $6295c6875f57e3ee$var$findMinIndex(value, array) {
    let found = -1, foundPos = 1000000000 /* C.Far */ ;
    for(let i = 0; i < array.length; i++)if ((array[i] - foundPos || value[i].endSide - value[found].endSide) < 0) {
        found = i;
        foundPos = array[i];
    }
    return found;
}
/**
Count the column position at the given offset into the string,
taking extending characters and tab size into account.
*/ function $6295c6875f57e3ee$export$20b4ab289374d0ac(string, tabSize, to = string.length) {
    let n = 0;
    for(let i = 0; i < to;)if (string.charCodeAt(i) == 9) {
        n += tabSize - n % tabSize;
        i++;
    } else {
        n++;
        i = $6295c6875f57e3ee$export$a0fa439fd515e1ed(string, i);
    }
    return n;
}
/**
Find the offset that corresponds to the given column position in a
string, taking extending characters and tab size into account. By
default, the string length is returned when it is too short to
reach the column. Pass `strict` true to make it return -1 in that
situation.
*/ function $6295c6875f57e3ee$export$718b3d71c384ca05(string, col, tabSize, strict) {
    for(let i = 0, n = 0;;){
        if (n >= col) return i;
        if (i == string.length) break;
        n += string.charCodeAt(i) == 9 ? tabSize - n % tabSize : 1;
        i = $6295c6875f57e3ee$export$a0fa439fd515e1ed(string, i);
    }
    return strict === true ? -1 : string.length;
}



const $afd7c6da9f842a17$var$C = "\u037C";
const $afd7c6da9f842a17$var$COUNT = typeof Symbol == "undefined" ? "__" + $afd7c6da9f842a17$var$C : Symbol.for($afd7c6da9f842a17$var$C);
const $afd7c6da9f842a17$var$SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const $afd7c6da9f842a17$var$top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class $afd7c6da9f842a17$export$b920c662d2efee20 {
    // :: (Object<Style>, ?{finish: ?(string) → string})
    // Create a style module from the given spec.
    //
    // When `finish` is given, it is called on regular (non-`@`)
    // selectors (after `&` expansion) to compute the final selector.
    constructor(spec, options){
        this.rules = [];
        let { finish: finish } = options || {};
        function splitSelector(selector) {
            return /^@/.test(selector) ? [
                selector
            ] : selector.split(/,\s*/);
        }
        function render(selectors, spec, target, isKeyframes) {
            let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
            if (isAt && spec == null) return target.push(selectors[0] + ";");
            for(let prop in spec){
                let value = spec[prop];
                if (/&/.test(prop)) render(prop.split(/,\s*/).map((part)=>selectors.map((sel)=>part.replace(/&/, sel))).reduce((a, b)=>a.concat(b)), value, target);
                else if (value && typeof value == "object") {
                    if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
                    render(splitSelector(prop), value, local, keyframes);
                } else if (value != null) local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l)=>"-" + l.toLowerCase()) + ": " + value + ";");
            }
            if (local.length || keyframes) target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
        }
        for(let prop in spec)render(splitSelector(prop), spec[prop], this.rules);
    }
    // :: () → string
    // Returns a string containing the module's CSS rules.
    getRules() {
        return this.rules.join("\n");
    }
    // :: () → string
    // Generate a new unique CSS class name.
    static newName() {
        let id = $afd7c6da9f842a17$var$top[$afd7c6da9f842a17$var$COUNT] || 1;
        $afd7c6da9f842a17$var$top[$afd7c6da9f842a17$var$COUNT] = id + 1;
        return $afd7c6da9f842a17$var$C + id.toString(36);
    }
    // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
    //
    // Mount the given set of modules in the given DOM root, which ensures
    // that the CSS rules defined by the module are available in that
    // context.
    //
    // Rules are only added to the document once per root.
    //
    // Rule order will follow the order of the modules, so that rules from
    // modules later in the array take precedence of those from earlier
    // modules. If you call this function multiple times for the same root
    // in a way that changes the order of already mounted modules, the old
    // order will be changed.
    //
    // If a Content Security Policy nonce is provided, it is added to
    // the `<style>` tag generated by the library.
    static mount(root, modules, options) {
        let set = root[$afd7c6da9f842a17$var$SET], nonce = options && options.nonce;
        if (!set) set = new $afd7c6da9f842a17$var$StyleSet(root, nonce);
        else if (nonce) set.setNonce(nonce);
        set.mount(Array.isArray(modules) ? modules : [
            modules
        ], root);
    }
}
let $afd7c6da9f842a17$var$adoptedSet = new Map //<Document, StyleSet>
;
class $afd7c6da9f842a17$var$StyleSet {
    constructor(root, nonce){
        let doc = root.ownerDocument || root, win = doc.defaultView;
        if (!root.head && root.adoptedStyleSheets && win.CSSStyleSheet) {
            let adopted = $afd7c6da9f842a17$var$adoptedSet.get(doc);
            if (adopted) return root[$afd7c6da9f842a17$var$SET] = adopted;
            this.sheet = new win.CSSStyleSheet;
            $afd7c6da9f842a17$var$adoptedSet.set(doc, this);
        } else {
            this.styleTag = doc.createElement("style");
            if (nonce) this.styleTag.setAttribute("nonce", nonce);
        }
        this.modules = [];
        root[$afd7c6da9f842a17$var$SET] = this;
    }
    mount(modules, root) {
        let sheet = this.sheet;
        let pos = 0 /* Current rule offset */ , j = 0 /* Index into this.modules */ ;
        for(let i = 0; i < modules.length; i++){
            let mod = modules[i], index = this.modules.indexOf(mod);
            if (index < j && index > -1) {
                this.modules.splice(index, 1);
                j--;
                index = -1;
            }
            if (index == -1) {
                this.modules.splice(j++, 0, mod);
                if (sheet) for(let k = 0; k < mod.rules.length; k++)sheet.insertRule(mod.rules[k], pos++);
            } else {
                while(j < index)pos += this.modules[j++].rules.length;
                pos += mod.rules.length;
                j++;
            }
        }
        if (sheet) {
            if (root.adoptedStyleSheets.indexOf(this.sheet) < 0) root.adoptedStyleSheets = [
                this.sheet,
                ...root.adoptedStyleSheets
            ];
        } else {
            let text = "";
            for(let i = 0; i < this.modules.length; i++)text += this.modules[i].getRules() + "\n";
            this.styleTag.textContent = text;
            let target = root.head || root;
            if (this.styleTag.parentNode != target) target.insertBefore(this.styleTag, target.firstChild);
        }
    }
    setNonce(nonce) {
        if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce) this.styleTag.setAttribute("nonce", nonce);
    }
} // Style::Object<union<Style,string>>
 //
 // A style is an object that, in the simple case, maps CSS property
 // names to strings holding their values, as in `{color: "red",
 // fontWeight: "bold"}`. The property names can be given in
 // camel-case—the library will insert a dash before capital letters
 // when converting them to CSS.
 //
 // If you include an underscore in a property name, it and everything
 // after it will be removed from the output, which can be useful when
 // providing a property multiple times, for browser compatibility
 // reasons.
 //
 // A property in a style object can also be a sub-selector, which
 // extends the current context to add a pseudo-selector or a child
 // selector. Such a property should contain a `&` character, which
 // will be replaced by the current selector. For example `{"&:before":
 // {content: '"hi"'}}`. Sub-selectors and regular properties can
 // freely be mixed in a given object. Any property containing a `&` is
 // assumed to be a sub-selector.
 //
 // Finally, a property can specify an @-block to be wrapped around the
 // styles defined inside the object that's the property's value. For
 // example to create a media query you can do `{"@media screen and
 // (min-width: 400px)": {...}}`.


var $68b9e7c405929963$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $68b9e7c405929963$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var $68b9e7c405929963$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $68b9e7c405929963$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $68b9e7c405929963$var$i = 0; $68b9e7c405929963$var$i < 10; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[48 + $68b9e7c405929963$var$i] = $68b9e7c405929963$export$e2253033e6e1df16[96 + $68b9e7c405929963$var$i] = String($68b9e7c405929963$var$i);
// The function keys
for(var $68b9e7c405929963$var$i = 1; $68b9e7c405929963$var$i <= 24; $68b9e7c405929963$var$i++)$68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i + 111] = "F" + $68b9e7c405929963$var$i;
// And the alphabetic keys
for(var $68b9e7c405929963$var$i = 65; $68b9e7c405929963$var$i <= 90; $68b9e7c405929963$var$i++){
    $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i + 32);
    $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$i] = String.fromCharCode($68b9e7c405929963$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $68b9e7c405929963$var$code in $68b9e7c405929963$export$e2253033e6e1df16)if (!$68b9e7c405929963$export$fba63a578e423eb.hasOwnProperty($68b9e7c405929963$var$code)) $68b9e7c405929963$export$fba63a578e423eb[$68b9e7c405929963$var$code] = $68b9e7c405929963$export$e2253033e6e1df16[$68b9e7c405929963$var$code];
function $68b9e7c405929963$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $68b9e7c405929963$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $68b9e7c405929963$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $68b9e7c405929963$export$fba63a578e423eb : $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}


function $7beee9608540d2c3$var$getSelection(root) {
    let target;
    // Browsers differ on whether shadow roots have a getSelection
    // method. If it exists, use that, otherwise, call it on the
    // document.
    if (root.nodeType == 11) target = root.getSelection ? root : root.ownerDocument;
    else target = root;
    return target.getSelection();
}
function $7beee9608540d2c3$var$contains(dom, node) {
    return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function $7beee9608540d2c3$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $7beee9608540d2c3$var$hasSelection(dom, selection) {
    if (!selection.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return $7beee9608540d2c3$var$contains(dom, selection.anchorNode);
    } catch (_) {
        return false;
    }
}
function $7beee9608540d2c3$var$clientRectsFor(dom) {
    if (dom.nodeType == 3) return $7beee9608540d2c3$var$textRange(dom, 0, dom.nodeValue.length).getClientRects();
    else if (dom.nodeType == 1) return dom.getClientRects();
    else return [];
}
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
function $7beee9608540d2c3$var$isEquivalentPosition(node, off, targetNode, targetOff) {
    return targetNode ? $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, -1) || $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, 1) : false;
}
function $7beee9608540d2c3$var$domIndex(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
}
function $7beee9608540d2c3$var$isBlockElement(node) {
    return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function $7beee9608540d2c3$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $7beee9608540d2c3$var$maxOffset(node))) {
            if (node.nodeName == "DIV") return false;
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1) return false;
            off = $7beee9608540d2c3$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.nodeType == 1 && node.contentEditable == "false") return false;
            off = dir < 0 ? $7beee9608540d2c3$var$maxOffset(node) : 0;
        } else return false;
    }
}
function $7beee9608540d2c3$var$maxOffset(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $7beee9608540d2c3$var$flattenRect(rect, left) {
    let x = left ? rect.left : rect.right;
    return {
        left: x,
        right: x,
        top: rect.top,
        bottom: rect.bottom
    };
}
function $7beee9608540d2c3$var$windowRect(win) {
    let vp = win.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: win.innerWidth,
        top: 0,
        bottom: win.innerHeight
    };
}
function $7beee9608540d2c3$var$getScale(elt, rect) {
    let scaleX = rect.width / elt.offsetWidth;
    let scaleY = rect.height / elt.offsetHeight;
    if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1) scaleX = 1;
    if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1) scaleY = 1;
    return {
        scaleX: scaleX,
        scaleY: scaleY
    };
}
function $7beee9608540d2c3$var$scrollRectIntoView(dom, rect, side, x, y, xMargin, yMargin, ltr) {
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    for(let cur = dom, stop = false; cur && !stop;){
        if (cur.nodeType == 1) {
            let bounding, top = cur == doc.body;
            let scaleX = 1, scaleY = 1;
            if (top) bounding = $7beee9608540d2c3$var$windowRect(win);
            else {
                if (/^(fixed|sticky)$/.test(getComputedStyle(cur).position)) stop = true;
                if (cur.scrollHeight <= cur.clientHeight && cur.scrollWidth <= cur.clientWidth) {
                    cur = cur.assignedSlot || cur.parentNode;
                    continue;
                }
                let rect = cur.getBoundingClientRect();
                ({ scaleX: scaleX, scaleY: scaleY } = $7beee9608540d2c3$var$getScale(cur, rect));
                // Make sure scrollbar width isn't included in the rectangle
                bounding = {
                    left: rect.left,
                    right: rect.left + cur.clientWidth * scaleX,
                    top: rect.top,
                    bottom: rect.top + cur.clientHeight * scaleY
                };
            }
            let moveX = 0, moveY = 0;
            if (y == "nearest") {
                if (rect.top < bounding.top) {
                    moveY = -(bounding.top - rect.top + yMargin);
                    if (side > 0 && rect.bottom > bounding.bottom + moveY) moveY = rect.bottom - bounding.bottom + moveY + yMargin;
                } else if (rect.bottom > bounding.bottom) {
                    moveY = rect.bottom - bounding.bottom + yMargin;
                    if (side < 0 && rect.top - moveY < bounding.top) moveY = -(bounding.top + moveY - rect.top + yMargin);
                }
            } else {
                let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
                let targetTop = y == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y == "start" || y == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
                moveY = targetTop - bounding.top;
            }
            if (x == "nearest") {
                if (rect.left < bounding.left) {
                    moveX = -(bounding.left - rect.left + xMargin);
                    if (side > 0 && rect.right > bounding.right + moveX) moveX = rect.right - bounding.right + moveX + xMargin;
                } else if (rect.right > bounding.right) {
                    moveX = rect.right - bounding.right + xMargin;
                    if (side < 0 && rect.left < bounding.left + moveX) moveX = -(bounding.left + moveX - rect.left + xMargin);
                }
            } else {
                let targetLeft = x == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
                moveX = targetLeft - bounding.left;
            }
            if (moveX || moveY) {
                if (top) win.scrollBy(moveX, moveY);
                else {
                    let movedX = 0, movedY = 0;
                    if (moveY) {
                        let start = cur.scrollTop;
                        cur.scrollTop += moveY / scaleY;
                        movedY = (cur.scrollTop - start) * scaleY;
                    }
                    if (moveX) {
                        let start = cur.scrollLeft;
                        cur.scrollLeft += moveX / scaleX;
                        movedX = (cur.scrollLeft - start) * scaleX;
                    }
                    rect = {
                        left: rect.left - movedX,
                        top: rect.top - movedY,
                        right: rect.right - movedX,
                        bottom: rect.bottom - movedY
                    };
                    if (movedX && Math.abs(movedX - moveX) < 1) x = "nearest";
                    if (movedY && Math.abs(movedY - moveY) < 1) y = "nearest";
                }
            }
            if (top) break;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
}
function $7beee9608540d2c3$var$scrollableParent(dom) {
    let doc = dom.ownerDocument;
    for(let cur = dom.parentNode; cur;){
        if (cur == doc.body) break;
        else if (cur.nodeType == 1) {
            if (cur.scrollHeight > cur.clientHeight || cur.scrollWidth > cur.clientWidth) return cur;
            cur = cur.assignedSlot || cur.parentNode;
        } else if (cur.nodeType == 11) cur = cur.host;
        else break;
    }
    return null;
}
class $7beee9608540d2c3$var$DOMSelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    eq(domSel) {
        return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
    }
    setRange(range) {
        let { anchorNode: anchorNode, focusNode: focusNode } = range;
        // Clip offsets to node size to avoid crashes when Safari reports bogus offsets (#1152)
        this.set(anchorNode, Math.min(range.anchorOffset, anchorNode ? $7beee9608540d2c3$var$maxOffset(anchorNode) : 0), focusNode, Math.min(range.focusOffset, focusNode ? $7beee9608540d2c3$var$maxOffset(focusNode) : 0));
    }
    set(anchorNode, anchorOffset, focusNode, focusOffset) {
        this.anchorNode = anchorNode;
        this.anchorOffset = anchorOffset;
        this.focusNode = focusNode;
        this.focusOffset = focusOffset;
    }
}
let $7beee9608540d2c3$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $7beee9608540d2c3$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($7beee9608540d2c3$var$preventScrollSupported) return dom.focus($7beee9608540d2c3$var$preventScrollSupported);
    let stack = [];
    for(let cur = dom; cur; cur = cur.parentNode){
        stack.push(cur, cur.scrollTop, cur.scrollLeft);
        if (cur == cur.ownerDocument) break;
    }
    dom.focus($7beee9608540d2c3$var$preventScrollSupported == null ? {
        get preventScroll () {
            $7beee9608540d2c3$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$7beee9608540d2c3$var$preventScrollSupported) {
        $7beee9608540d2c3$var$preventScrollSupported = false;
        for(let i = 0; i < stack.length;){
            let elt = stack[i++], top = stack[i++], left = stack[i++];
            if (elt.scrollTop != top) elt.scrollTop = top;
            if (elt.scrollLeft != left) elt.scrollLeft = left;
        }
    }
}
let $7beee9608540d2c3$var$scratchRange;
function $7beee9608540d2c3$var$textRange(node, from, to = from) {
    let range = $7beee9608540d2c3$var$scratchRange || ($7beee9608540d2c3$var$scratchRange = document.createRange());
    range.setEnd(node, to);
    range.setStart(node, from);
    return range;
}
function $7beee9608540d2c3$var$dispatchKey(elt, name, code, mods) {
    let options = {
        key: name,
        code: name,
        keyCode: code,
        which: code,
        cancelable: true
    };
    if (mods) ({ altKey: options.altKey, ctrlKey: options.ctrlKey, shiftKey: options.shiftKey, metaKey: options.metaKey } = mods);
    let down = new KeyboardEvent("keydown", options);
    down.synthetic = true;
    elt.dispatchEvent(down);
    let up = new KeyboardEvent("keyup", options);
    up.synthetic = true;
    elt.dispatchEvent(up);
    return down.defaultPrevented || up.defaultPrevented;
}
function $7beee9608540d2c3$var$getRoot(node) {
    while(node){
        if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host)) return node;
        node = node.assignedSlot || node.parentNode;
    }
    return null;
}
function $7beee9608540d2c3$var$clearAttributes(node) {
    while(node.attributes.length)node.removeAttributeNode(node.attributes[0]);
}
function $7beee9608540d2c3$var$atElementStart(doc, selection) {
    let node = selection.focusNode, offset = selection.focusOffset;
    if (!node || selection.anchorNode != node || selection.anchorOffset != offset) return false;
    // Safari can report bogus offsets (#1152)
    offset = Math.min(offset, $7beee9608540d2c3$var$maxOffset(node));
    for(;;){
        if (offset) {
            if (node.nodeType != 1) return false;
            let prev = node.childNodes[offset - 1];
            if (prev.contentEditable == "false") offset--;
            else {
                node = prev;
                offset = $7beee9608540d2c3$var$maxOffset(node);
            }
        } else if (node == doc) return true;
        else {
            offset = $7beee9608540d2c3$var$domIndex(node);
            node = node.parentNode;
        }
    }
}
function $7beee9608540d2c3$var$isScrolledToBottom(elt) {
    return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function $7beee9608540d2c3$var$textNodeBefore(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset > 0) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $7beee9608540d2c3$var$maxOffset(node);
        } else if (node.parentNode && !$7beee9608540d2c3$var$isBlockElement(node)) {
            offset = $7beee9608540d2c3$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $7beee9608540d2c3$var$textNodeAfter(startNode, startOffset) {
    for(let node = startNode, offset = startOffset;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return {
            node: node,
            offset: offset
        };
        else if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$7beee9608540d2c3$var$isBlockElement(node)) {
            offset = $7beee9608540d2c3$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
class $7beee9608540d2c3$var$DOMPos {
    constructor(node, offset, precise = true){
        this.node = node;
        this.offset = offset;
        this.precise = precise;
    }
    static before(dom, precise) {
        return new $7beee9608540d2c3$var$DOMPos(dom.parentNode, $7beee9608540d2c3$var$domIndex(dom), precise);
    }
    static after(dom, precise) {
        return new $7beee9608540d2c3$var$DOMPos(dom.parentNode, $7beee9608540d2c3$var$domIndex(dom) + 1, precise);
    }
}
const $7beee9608540d2c3$var$noChildren = [];
class $7beee9608540d2c3$var$ContentView {
    constructor(){
        this.parent = null;
        this.dom = null;
        this.flags = 2 /* ViewFlag.NodeDirty */ ;
    }
    get overrideDOMText() {
        return null;
    }
    get posAtStart() {
        return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
        return this.posAtStart + this.length;
    }
    posBefore(view) {
        let pos = this.posAtStart;
        for (let child of this.children){
            if (child == view) return pos;
            pos += child.length + child.breakAfter;
        }
        throw new RangeError("Invalid child in posBefore");
    }
    posAfter(view) {
        return this.posBefore(view) + view.length;
    }
    sync(view, track) {
        if (this.flags & 2 /* ViewFlag.NodeDirty */ ) {
            let parent = this.dom;
            let prev = null, next;
            for (let child of this.children){
                if (child.flags & 7 /* ViewFlag.Dirty */ ) {
                    if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
                        let contentView = $7beee9608540d2c3$var$ContentView.get(next);
                        if (!contentView || !contentView.parent && contentView.canReuseDOM(child)) child.reuseDOM(next);
                    }
                    child.sync(view, track);
                    child.flags &= -8 /* ViewFlag.Dirty */ ;
                }
                next = prev ? prev.nextSibling : parent.firstChild;
                if (track && !track.written && track.node == parent && next != child.dom) track.written = true;
                if (child.dom.parentNode == parent) while(next && next != child.dom)next = $7beee9608540d2c3$var$rm$1(next);
                else parent.insertBefore(child.dom, next);
                prev = child.dom;
            }
            next = prev ? prev.nextSibling : parent.firstChild;
            if (next && track && track.node == parent) track.written = true;
            while(next)next = $7beee9608540d2c3$var$rm$1(next);
        } else if (this.flags & 1 /* ViewFlag.ChildDirty */ ) {
            for (let child of this.children)if (child.flags & 7 /* ViewFlag.Dirty */ ) {
                child.sync(view, track);
                child.flags &= -8 /* ViewFlag.Dirty */ ;
            }
        }
    }
    reuseDOM(_dom) {}
    localPosFromDOM(node, offset) {
        let after;
        if (node == this.dom) after = this.dom.childNodes[offset];
        else {
            let bias = $7beee9608540d2c3$var$maxOffset(node) == 0 ? 0 : offset == 0 ? -1 : 1;
            for(;;){
                let parent = node.parentNode;
                if (parent == this.dom) break;
                if (bias == 0 && parent.firstChild != parent.lastChild) {
                    if (node == parent.firstChild) bias = -1;
                    else bias = 1;
                }
                node = parent;
            }
            if (bias < 0) after = node;
            else after = node.nextSibling;
        }
        if (after == this.dom.firstChild) return 0;
        while(after && !$7beee9608540d2c3$var$ContentView.get(after))after = after.nextSibling;
        if (!after) return this.length;
        for(let i = 0, pos = 0;; i++){
            let child = this.children[i];
            if (child.dom == after) return pos;
            pos += child.length + child.breakAfter;
        }
    }
    domBoundsAround(from, to, offset = 0) {
        let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
        for(let i = 0, pos = offset, prevEnd = offset; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (pos < from && end > to) return child.domBoundsAround(from, to, pos);
            if (end >= from && fromI == -1) {
                fromI = i;
                fromStart = pos;
            }
            if (pos > to && child.dom.parentNode == this.dom) {
                toI = i;
                toEnd = prevEnd;
                break;
            }
            prevEnd = end;
            pos = end + child.breakAfter;
        }
        return {
            from: fromStart,
            to: toEnd < 0 ? offset + this.length : toEnd,
            startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
            endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
        };
    }
    markDirty(andParent = false) {
        this.flags |= 2 /* ViewFlag.NodeDirty */ ;
        this.markParentsDirty(andParent);
    }
    markParentsDirty(childList) {
        for(let parent = this.parent; parent; parent = parent.parent){
            if (childList) parent.flags |= 2 /* ViewFlag.NodeDirty */ ;
            if (parent.flags & 1 /* ViewFlag.ChildDirty */ ) return;
            parent.flags |= 1 /* ViewFlag.ChildDirty */ ;
            childList = false;
        }
    }
    setParent(parent) {
        if (this.parent != parent) {
            this.parent = parent;
            if (this.flags & 7 /* ViewFlag.Dirty */ ) this.markParentsDirty(true);
        }
    }
    setDOM(dom) {
        if (this.dom == dom) return;
        if (this.dom) this.dom.cmView = null;
        this.dom = dom;
        dom.cmView = this;
    }
    get rootView() {
        for(let v = this;;){
            let parent = v.parent;
            if (!parent) return v;
            v = parent;
        }
    }
    replaceChildren(from, to, children = $7beee9608540d2c3$var$noChildren) {
        this.markDirty();
        for(let i = from; i < to; i++){
            let child = this.children[i];
            if (child.parent == this && children.indexOf(child) < 0) child.destroy();
        }
        this.children.splice(from, to - from, ...children);
        for(let i = 0; i < children.length; i++)children[i].setParent(this);
    }
    ignoreMutation(_rec) {
        return false;
    }
    ignoreEvent(_event) {
        return false;
    }
    childCursor(pos = this.length) {
        return new $7beee9608540d2c3$var$ChildCursor(this.children, pos, this.children.length);
    }
    childPos(pos, bias = 1) {
        return this.childCursor().findPos(pos, bias);
    }
    toString() {
        let name = this.constructor.name.replace("View", "");
        return name + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(node) {
        return node.cmView;
    }
    get isEditable() {
        return true;
    }
    get isWidget() {
        return false;
    }
    get isHidden() {
        return false;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        return false;
    }
    become(other) {
        return false;
    }
    canReuseDOM(other) {
        return other.constructor == this.constructor && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    // When this is a zero-length view with a side, this should return a
    // number <= 0 to indicate it is before its position, or a
    // number > 0 when after its position.
    getSide() {
        return 0;
    }
    destroy() {
        for (let child of this.children)if (child.parent == this) child.destroy();
        this.parent = null;
    }
}
$7beee9608540d2c3$var$ContentView.prototype.breakAfter = 0;
// Remove a DOM node and return its next sibling.
function $7beee9608540d2c3$var$rm$1(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
class $7beee9608540d2c3$var$ChildCursor {
    constructor(children, pos, i){
        this.children = children;
        this.pos = pos;
        this.i = i;
        this.off = 0;
    }
    findPos(pos, bias = 1) {
        for(;;){
            if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
                this.off = pos - this.pos;
                return this;
            }
            let next = this.children[--this.i];
            this.pos -= next.length + next.breakAfter;
        }
    }
}
function $7beee9608540d2c3$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, breakAtStart, openStart, openEnd) {
    let { children: children } = parent;
    let before = children.length ? children[fromI] : null;
    let last = insert.length ? insert[insert.length - 1] : null;
    let breakAtEnd = last ? last.breakAfter : breakAtStart;
    // Change within a single child
    if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert.length < 2 && before.merge(fromOff, toOff, insert.length ? last : null, fromOff == 0, openStart, openEnd)) return;
    if (toI < children.length) {
        let after = children[toI];
        // Make sure the end of the child after the update is preserved in `after`
        if (after && (toOff < after.length || after.breakAfter && (last === null || last === void 0 ? void 0 : last.breakAfter))) {
            // If we're splitting a child, separate part of it to avoid that
            // being mangled when updating the child before the update.
            if (fromI == toI) {
                after = after.split(toOff);
                toOff = 0;
            }
            // If the element after the replacement should be merged with
            // the last replacing element, update `content`
            if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) insert[insert.length - 1] = after;
            else {
                // Remove the start of the after element, if necessary, and
                // add it to `content`.
                if (toOff || after.children.length && !after.children[0].length) after.merge(0, toOff, null, false, 0, openEnd);
                insert.push(after);
            }
        } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
            // The element at `toI` is entirely covered by this range.
            // Preserve its line break, if any.
            if (last) last.breakAfter = 1;
            else breakAtStart = 1;
        }
        // Since we've handled the next element from the current elements
        // now, make sure `toI` points after that.
        toI++;
    }
    if (before) {
        before.breakAfter = breakAtStart;
        if (fromOff > 0) {
            if (!breakAtStart && insert.length && before.merge(fromOff, before.length, insert[0], false, openStart, 0)) before.breakAfter = insert.shift().breakAfter;
            else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) before.merge(fromOff, before.length, null, false, openStart, 0);
            fromI++;
        }
    }
    // Try to merge widgets on the boundaries of the replacement
    while(fromI < toI && insert.length){
        if (children[toI - 1].become(insert[insert.length - 1])) {
            toI--;
            insert.pop();
            openEnd = insert.length ? 0 : openStart;
        } else if (children[fromI].become(insert[0])) {
            fromI++;
            insert.shift();
            openStart = insert.length ? 0 : openEnd;
        } else break;
    }
    if (!insert.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd)) fromI--;
    if (fromI < toI || insert.length) parent.replaceChildren(fromI, toI, insert);
}
function $7beee9608540d2c3$var$mergeChildrenInto(parent, from, to, insert, openStart, openEnd) {
    let cur = parent.childCursor();
    let { i: toI, off: toOff } = cur.findPos(to, 1);
    let { i: fromI, off: fromOff } = cur.findPos(from, -1);
    let dLen = from - to;
    for (let view of insert)dLen += view.length;
    parent.length += dLen;
    $7beee9608540d2c3$var$replaceRange(parent, fromI, fromOff, toI, toOff, insert, 0, openStart, openEnd);
}
let $7beee9608540d2c3$var$nav = typeof navigator != "undefined" ? navigator : {
    userAgent: "",
    vendor: "",
    platform: ""
};
let $7beee9608540d2c3$var$doc = typeof document != "undefined" ? document : {
    documentElement: {
        style: {}
    }
};
const $7beee9608540d2c3$var$ie_edge = /*@__PURE__*/ /Edge\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie_upto10 = /*@__PURE__*/ /MSIE \d/.test($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie_11up = /*@__PURE__*/ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$ie = !!($7beee9608540d2c3$var$ie_upto10 || $7beee9608540d2c3$var$ie_11up || $7beee9608540d2c3$var$ie_edge);
const $7beee9608540d2c3$var$gecko = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /gecko\/(\d+)/i.test($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$chrome = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /Chrome\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent);
const $7beee9608540d2c3$var$webkit = "webkitFontSmoothing" in $7beee9608540d2c3$var$doc.documentElement.style;
const $7beee9608540d2c3$var$safari = !$7beee9608540d2c3$var$ie && /*@__PURE__*/ /Apple Computer/.test($7beee9608540d2c3$var$nav.vendor);
const $7beee9608540d2c3$var$ios = $7beee9608540d2c3$var$safari && /*@__PURE__*/ (/Mobile\/\w+/.test($7beee9608540d2c3$var$nav.userAgent) || $7beee9608540d2c3$var$nav.maxTouchPoints > 2);
var $7beee9608540d2c3$var$browser = {
    mac: $7beee9608540d2c3$var$ios || /*@__PURE__*/ /Mac/.test($7beee9608540d2c3$var$nav.platform),
    windows: /*@__PURE__*/ /Win/.test($7beee9608540d2c3$var$nav.platform),
    linux: /*@__PURE__*/ /Linux|X11/.test($7beee9608540d2c3$var$nav.platform),
    ie: $7beee9608540d2c3$var$ie,
    ie_version: $7beee9608540d2c3$var$ie_upto10 ? $7beee9608540d2c3$var$doc.documentMode || 6 : $7beee9608540d2c3$var$ie_11up ? +$7beee9608540d2c3$var$ie_11up[1] : $7beee9608540d2c3$var$ie_edge ? +$7beee9608540d2c3$var$ie_edge[1] : 0,
    gecko: $7beee9608540d2c3$var$gecko,
    gecko_version: $7beee9608540d2c3$var$gecko ? +/*@__PURE__*/ (/Firefox\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    chrome: !!$7beee9608540d2c3$var$chrome,
    chrome_version: $7beee9608540d2c3$var$chrome ? +$7beee9608540d2c3$var$chrome[1] : 0,
    ios: $7beee9608540d2c3$var$ios,
    android: /*@__PURE__*/ /Android\b/.test($7beee9608540d2c3$var$nav.userAgent),
    webkit: $7beee9608540d2c3$var$webkit,
    safari: $7beee9608540d2c3$var$safari,
    webkit_version: $7beee9608540d2c3$var$webkit ? +/*@__PURE__*/ (/\bAppleWebKit\/(\d+)/.exec($7beee9608540d2c3$var$nav.userAgent) || [
        0,
        0
    ])[1] : 0,
    tabSize: $7beee9608540d2c3$var$doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const $7beee9608540d2c3$var$MaxJoinLen = 256;
class $7beee9608540d2c3$var$TextView extends $7beee9608540d2c3$var$ContentView {
    constructor(text){
        super();
        this.text = text;
    }
    get length() {
        return this.text.length;
    }
    createDOM(textDOM) {
        this.setDOM(textDOM || document.createTextNode(this.text));
    }
    sync(view, track) {
        if (!this.dom) this.createDOM();
        if (this.dom.nodeValue != this.text) {
            if (track && track.node == this.dom) track.written = true;
            this.dom.nodeValue = this.text;
        }
    }
    reuseDOM(dom) {
        if (dom.nodeType == 3) this.createDOM(dom);
    }
    merge(from, to, source) {
        if (this.flags & 8 /* ViewFlag.Composition */  || source && (!(source instanceof $7beee9608540d2c3$var$TextView) || this.length - (to - from) + source.length > $7beee9608540d2c3$var$MaxJoinLen || source.flags & 8 /* ViewFlag.Composition */ )) return false;
        this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = new $7beee9608540d2c3$var$TextView(this.text.slice(from));
        this.text = this.text.slice(0, from);
        this.markDirty();
        result.flags |= this.flags & 8 /* ViewFlag.Composition */ ;
        return result;
    }
    localPosFromDOM(node, offset) {
        return node == this.dom ? offset : offset ? this.text.length : 0;
    }
    domAtPos(pos) {
        return new $7beee9608540d2c3$var$DOMPos(this.dom, pos);
    }
    domBoundsAround(_from, _to, offset) {
        return {
            from: offset,
            to: offset + this.length,
            startDOM: this.dom,
            endDOM: this.dom.nextSibling
        };
    }
    coordsAt(pos, side) {
        return $7beee9608540d2c3$var$textCoords(this.dom, pos, side);
    }
}
class $7beee9608540d2c3$var$MarkView extends $7beee9608540d2c3$var$ContentView {
    constructor(mark, children = [], length = 0){
        super();
        this.mark = mark;
        this.children = children;
        this.length = length;
        for (let ch of children)ch.setParent(this);
    }
    setAttrs(dom) {
        $7beee9608540d2c3$var$clearAttributes(dom);
        if (this.mark.class) dom.className = this.mark.class;
        if (this.mark.attrs) for(let name in this.mark.attrs)dom.setAttribute(name, this.mark.attrs[name]);
        return dom;
    }
    canReuseDOM(other) {
        return super.canReuseDOM(other) && !((this.flags | other.flags) & 8 /* ViewFlag.Composition */ );
    }
    reuseDOM(node) {
        if (node.nodeName == this.mark.tagName.toUpperCase()) {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        if (!this.dom) this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
        else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) this.setAttrs(this.dom);
        super.sync(view, track);
    }
    merge(from, to, source, _hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $7beee9608540d2c3$var$MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        $7beee9608540d2c3$var$mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart - 1, openEnd - 1);
        this.markDirty();
        return true;
    }
    split(from) {
        let result = [], off = 0, detachFrom = -1, i = 0;
        for (let elt of this.children){
            let end = off + elt.length;
            if (end > from) result.push(off < from ? elt.split(from - off) : elt);
            if (detachFrom < 0 && off >= from) detachFrom = i;
            off = end;
            i++;
        }
        let length = this.length - from;
        this.length = from;
        if (detachFrom > -1) {
            this.children.length = detachFrom;
            this.markDirty();
        }
        return new $7beee9608540d2c3$var$MarkView(this.mark, result, length);
    }
    domAtPos(pos) {
        return $7beee9608540d2c3$var$inlineDOMAtPos(this, pos);
    }
    coordsAt(pos, side) {
        return $7beee9608540d2c3$var$coordsInChildren(this, pos, side);
    }
}
function $7beee9608540d2c3$var$textCoords(text, pos, side) {
    let length = text.nodeValue.length;
    if (pos > length) pos = length;
    let from = pos, to = pos, flatten = 0;
    if (pos == 0 && side < 0 || pos == length && side >= 0) {
        if (!($7beee9608540d2c3$var$browser.chrome || $7beee9608540d2c3$var$browser.gecko)) {
            if (pos) {
                from--;
                flatten = 1;
            } else if (to < length) {
                to++;
                flatten = -1;
            }
        }
    } else {
        if (side < 0) from--;
        else if (to < length) to++;
    }
    let rects = $7beee9608540d2c3$var$textRange(text, from, to).getClientRects();
    if (!rects.length) return null;
    let rect = rects[(flatten ? flatten < 0 : side >= 0) ? 0 : rects.length - 1];
    if ($7beee9608540d2c3$var$browser.safari && !flatten && rect.width == 0) rect = Array.prototype.find.call(rects, (r)=>r.width) || rect;
    return flatten ? $7beee9608540d2c3$var$flattenRect(rect, flatten < 0) : rect || null;
}
// Also used for collapsed ranges that don't have a placeholder widget!
class $7beee9608540d2c3$var$WidgetView extends $7beee9608540d2c3$var$ContentView {
    static create(widget, length, side) {
        return new $7beee9608540d2c3$var$WidgetView(widget, length, side);
    }
    constructor(widget, length, side){
        super();
        this.widget = widget;
        this.length = length;
        this.side = side;
        this.prevWidget = null;
    }
    split(from) {
        let result = $7beee9608540d2c3$var$WidgetView.create(this.widget, this.length - from, this.side);
        this.length -= from;
        return result;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    getSide() {
        return this.side;
    }
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source && (!(source instanceof $7beee9608540d2c3$var$WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    become(other) {
        if (other instanceof $7beee9608540d2c3$var$WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
            if (!this.widget.compare(other.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get overrideDOMText() {
        if (this.length == 0) return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        let top = this;
        while(top.parent)top = top.parent;
        let { view: view } = top, text = view && view.state.doc, start = this.posAtStart;
        return text ? text.slice(start, start + this.length) : (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
    }
    domAtPos(pos) {
        return (this.length ? pos == 0 : this.side > 0) ? $7beee9608540d2c3$var$DOMPos.before(this.dom) : $7beee9608540d2c3$var$DOMPos.after(this.dom, pos == this.length);
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos, side) {
        let custom = this.widget.coordsAt(this.dom, pos, side);
        if (custom) return custom;
        let rects = this.dom.getClientRects(), rect = null;
        if (!rects.length) return null;
        let fromBack = this.side ? this.side < 0 : pos > 0;
        for(let i = fromBack ? rects.length - 1 : 0;; i += fromBack ? -1 : 1){
            rect = rects[i];
            if (pos > 0 ? i == 0 : i == rects.length - 1 || rect.top < rect.bottom) break;
        }
        return $7beee9608540d2c3$var$flattenRect(rect, !fromBack);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    get isHidden() {
        return this.widget.isHidden;
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
}
// These are drawn around uneditable widgets to avoid a number of
// browser bugs that show up when the cursor is directly next to
// uneditable inline content.
class $7beee9608540d2c3$var$WidgetBufferView extends $7beee9608540d2c3$var$ContentView {
    constructor(side){
        super();
        this.side = side;
    }
    get length() {
        return 0;
    }
    merge() {
        return false;
    }
    become(other) {
        return other instanceof $7beee9608540d2c3$var$WidgetBufferView && other.side == this.side;
    }
    split() {
        return new $7beee9608540d2c3$var$WidgetBufferView(this.side);
    }
    sync() {
        if (!this.dom) {
            let dom = document.createElement("img");
            dom.className = "cm-widgetBuffer";
            dom.setAttribute("aria-hidden", "true");
            this.setDOM(dom);
        }
    }
    getSide() {
        return this.side;
    }
    domAtPos(pos) {
        return this.side > 0 ? $7beee9608540d2c3$var$DOMPos.before(this.dom) : $7beee9608540d2c3$var$DOMPos.after(this.dom);
    }
    localPosFromDOM() {
        return 0;
    }
    domBoundsAround() {
        return null;
    }
    coordsAt(pos) {
        return this.dom.getBoundingClientRect();
    }
    get overrideDOMText() {
        return (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
    }
    get isHidden() {
        return true;
    }
}
$7beee9608540d2c3$var$TextView.prototype.children = $7beee9608540d2c3$var$WidgetView.prototype.children = $7beee9608540d2c3$var$WidgetBufferView.prototype.children = $7beee9608540d2c3$var$noChildren;
function $7beee9608540d2c3$var$inlineDOMAtPos(parent, pos) {
    let dom = parent.dom, { children: children } = parent, i = 0;
    for(let off = 0; i < children.length; i++){
        let child = children[i], end = off + child.length;
        if (end == off && child.getSide() <= 0) continue;
        if (pos > off && pos < end && child.dom.parentNode == dom) return child.domAtPos(pos - off);
        if (pos <= off) break;
        off = end;
    }
    for(let j = i; j > 0; j--){
        let prev = children[j - 1];
        if (prev.dom.parentNode == dom) return prev.domAtPos(prev.length);
    }
    for(let j = i; j < children.length; j++){
        let next = children[j];
        if (next.dom.parentNode == dom) return next.domAtPos(0);
    }
    return new $7beee9608540d2c3$var$DOMPos(dom, 0);
}
// Assumes `view`, if a mark view, has precisely 1 child.
function $7beee9608540d2c3$var$joinInlineInto(parent, view, open) {
    let last, { children: children } = parent;
    if (open > 0 && view instanceof $7beee9608540d2c3$var$MarkView && children.length && (last = children[children.length - 1]) instanceof $7beee9608540d2c3$var$MarkView && last.mark.eq(view.mark)) $7beee9608540d2c3$var$joinInlineInto(last, view.children[0], open - 1);
    else {
        children.push(view);
        view.setParent(parent);
    }
    parent.length += view.length;
}
function $7beee9608540d2c3$var$coordsInChildren(view, pos, side) {
    let before = null, beforePos = -1, after = null, afterPos = -1;
    function scan(view, pos) {
        for(let i = 0, off = 0; i < view.children.length && off <= pos; i++){
            let child = view.children[i], end = off + child.length;
            if (end >= pos) {
                if (child.children.length) scan(child, pos - off);
                else if ((!after || after.isHidden && side > 0) && (end > pos || off == end && child.getSide() > 0)) {
                    after = child;
                    afterPos = pos - off;
                } else if (off < pos || off == end && child.getSide() < 0 && !child.isHidden) {
                    before = child;
                    beforePos = pos - off;
                }
            }
            off = end;
        }
    }
    scan(view, pos);
    let target = (side < 0 ? before : after) || before || after;
    if (target) return target.coordsAt(Math.max(0, target == before ? beforePos : afterPos), side);
    return $7beee9608540d2c3$var$fallbackRect(view);
}
function $7beee9608540d2c3$var$fallbackRect(view) {
    let last = view.dom.lastChild;
    if (!last) return view.dom.getBoundingClientRect();
    let rects = $7beee9608540d2c3$var$clientRectsFor(last);
    return rects[rects.length - 1] || null;
}
function $7beee9608540d2c3$var$combineAttrs(source, target) {
    for(let name in source){
        if (name == "class" && target.class) target.class += " " + source.class;
        else if (name == "style" && target.style) target.style += ";" + source.style;
        else target[name] = source[name];
    }
    return target;
}
const $7beee9608540d2c3$var$noAttrs = /*@__PURE__*/ Object.create(null);
function $7beee9608540d2c3$var$attrsEq(a, b, ignore) {
    if (a == b) return true;
    if (!a) a = $7beee9608540d2c3$var$noAttrs;
    if (!b) b = $7beee9608540d2c3$var$noAttrs;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0)) return false;
    for (let key of keysA){
        if (key != ignore && (keysB.indexOf(key) == -1 || a[key] !== b[key])) return false;
    }
    return true;
}
function $7beee9608540d2c3$var$updateAttrs(dom, prev, attrs) {
    let changed = false;
    if (prev) {
        for(let name in prev)if (!(attrs && name in attrs)) {
            changed = true;
            if (name == "style") dom.style.cssText = "";
            else dom.removeAttribute(name);
        }
    }
    if (attrs) {
        for(let name in attrs)if (!(prev && prev[name] == attrs[name])) {
            changed = true;
            if (name == "style") dom.style.cssText = attrs[name];
            else dom.setAttribute(name, attrs[name]);
        }
    }
    return changed;
}
function $7beee9608540d2c3$var$getAttrs(dom) {
    let attrs = Object.create(null);
    for(let i = 0; i < dom.attributes.length; i++){
        let attr = dom.attributes[i];
        attrs[attr.name] = attr.value;
    }
    return attrs;
}
class $7beee9608540d2c3$var$LineView extends $7beee9608540d2c3$var$ContentView {
    constructor(){
        super(...arguments);
        this.children = [];
        this.length = 0;
        this.prevAttrs = undefined;
        this.attrs = null;
        this.breakAfter = 0;
    }
    // Consumes source
    merge(from, to, source, hasStart, openStart, openEnd) {
        if (source) {
            if (!(source instanceof $7beee9608540d2c3$var$LineView)) return false;
            if (!this.dom) source.transferDOM(this); // Reuse source.dom when appropriate
        }
        if (hasStart) this.setDeco(source ? source.attrs : null);
        $7beee9608540d2c3$var$mergeChildrenInto(this, from, to, source ? source.children.slice() : [], openStart, openEnd);
        return true;
    }
    split(at) {
        let end = new $7beee9608540d2c3$var$LineView;
        end.breakAfter = this.breakAfter;
        if (this.length == 0) return end;
        let { i: i, off: off } = this.childPos(at);
        if (off) {
            end.append(this.children[i].split(off), 0);
            this.children[i].merge(off, this.children[i].length, null, false, 0, 0);
            i++;
        }
        for(let j = i; j < this.children.length; j++)end.append(this.children[j], 0);
        while(i > 0 && this.children[i - 1].length == 0)this.children[--i].destroy();
        this.children.length = i;
        this.markDirty();
        this.length = at;
        return end;
    }
    transferDOM(other) {
        if (!this.dom) return;
        this.markDirty();
        other.setDOM(this.dom);
        other.prevAttrs = this.prevAttrs === undefined ? this.attrs : this.prevAttrs;
        this.prevAttrs = undefined;
        this.dom = null;
    }
    setDeco(attrs) {
        if (!$7beee9608540d2c3$var$attrsEq(this.attrs, attrs)) {
            if (this.dom) {
                this.prevAttrs = this.attrs;
                this.markDirty();
            }
            this.attrs = attrs;
        }
    }
    append(child, openStart) {
        $7beee9608540d2c3$var$joinInlineInto(this, child, openStart);
    }
    // Only called when building a line view in ContentBuilder
    addLineDeco(deco) {
        let attrs = deco.spec.attributes, cls = deco.spec.class;
        if (attrs) this.attrs = $7beee9608540d2c3$var$combineAttrs(attrs, this.attrs || {});
        if (cls) this.attrs = $7beee9608540d2c3$var$combineAttrs({
            class: cls
        }, this.attrs || {});
    }
    domAtPos(pos) {
        return $7beee9608540d2c3$var$inlineDOMAtPos(this, pos);
    }
    reuseDOM(node) {
        if (node.nodeName == "DIV") {
            this.setDOM(node);
            this.flags |= 6 /* ViewFlag.NodeDirty */ ;
        }
    }
    sync(view, track) {
        var _a;
        if (!this.dom) {
            this.setDOM(document.createElement("div"));
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        } else if (this.flags & 4 /* ViewFlag.AttrsDirty */ ) {
            $7beee9608540d2c3$var$clearAttributes(this.dom);
            this.dom.className = "cm-line";
            this.prevAttrs = this.attrs ? null : undefined;
        }
        if (this.prevAttrs !== undefined) {
            $7beee9608540d2c3$var$updateAttrs(this.dom, this.prevAttrs, this.attrs);
            this.dom.classList.add("cm-line");
            this.prevAttrs = undefined;
        }
        super.sync(view, track);
        let last = this.dom.lastChild;
        while(last && $7beee9608540d2c3$var$ContentView.get(last) instanceof $7beee9608540d2c3$var$MarkView)last = last.lastChild;
        if (!last || !this.length || last.nodeName != "BR" && ((_a = $7beee9608540d2c3$var$ContentView.get(last)) === null || _a === void 0 ? void 0 : _a.isEditable) == false && (!$7beee9608540d2c3$var$browser.ios || !this.children.some((ch)=>ch instanceof $7beee9608540d2c3$var$TextView))) {
            let hack = document.createElement("BR");
            hack.cmIgnore = true;
            this.dom.appendChild(hack);
        }
    }
    measureTextSize() {
        if (this.children.length == 0 || this.length > 20) return null;
        let totalWidth = 0, textHeight;
        for (let child of this.children){
            if (!(child instanceof $7beee9608540d2c3$var$TextView) || /[^ -~]/.test(child.text)) return null;
            let rects = $7beee9608540d2c3$var$clientRectsFor(child.dom);
            if (rects.length != 1) return null;
            totalWidth += rects[0].width;
            textHeight = rects[0].height;
        }
        return !totalWidth ? null : {
            lineHeight: this.dom.getBoundingClientRect().height,
            charWidth: totalWidth / this.length,
            textHeight: textHeight
        };
    }
    coordsAt(pos, side) {
        let rect = $7beee9608540d2c3$var$coordsInChildren(this, pos, side);
        // Correct rectangle height for empty lines when the returned
        // height is larger than the text height.
        if (!this.children.length && rect && this.parent) {
            let { heightOracle: heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
            if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
                let dist = (height - heightOracle.textHeight) / 2;
                return {
                    top: rect.top + dist,
                    bottom: rect.bottom - dist,
                    left: rect.left,
                    right: rect.left
                };
            }
        }
        return rect;
    }
    become(other) {
        return other instanceof $7beee9608540d2c3$var$LineView && this.children.length == 0 && other.children.length == 0 && $7beee9608540d2c3$var$attrsEq(this.attrs, other.attrs) && this.breakAfter == other.breakAfter;
    }
    covers() {
        return true;
    }
    static find(docView, pos) {
        for(let i = 0, off = 0; i < docView.children.length; i++){
            let block = docView.children[i], end = off + block.length;
            if (end >= pos) {
                if (block instanceof $7beee9608540d2c3$var$LineView) return block;
                if (end > pos) break;
            }
            off = end + block.breakAfter;
        }
        return null;
    }
}
class $7beee9608540d2c3$var$BlockWidgetView extends $7beee9608540d2c3$var$ContentView {
    constructor(widget, length, deco){
        super();
        this.widget = widget;
        this.length = length;
        this.deco = deco;
        this.breakAfter = 0;
        this.prevWidget = null;
    }
    merge(from, to, source, _takeDeco, openStart, openEnd) {
        if (source && (!(source instanceof $7beee9608540d2c3$var$BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to < this.length && openEnd <= 0)) return false;
        this.length = from + (source ? source.length : 0) + (this.length - to);
        return true;
    }
    domAtPos(pos) {
        return pos == 0 ? $7beee9608540d2c3$var$DOMPos.before(this.dom) : $7beee9608540d2c3$var$DOMPos.after(this.dom, pos == this.length);
    }
    split(at) {
        let len = this.length - at;
        this.length = at;
        let end = new $7beee9608540d2c3$var$BlockWidgetView(this.widget, len, this.deco);
        end.breakAfter = this.breakAfter;
        return end;
    }
    get children() {
        return $7beee9608540d2c3$var$noChildren;
    }
    sync(view) {
        if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
            if (this.dom && this.prevWidget) this.prevWidget.destroy(this.dom);
            this.prevWidget = null;
            this.setDOM(this.widget.toDOM(view));
            if (!this.widget.editable) this.dom.contentEditable = "false";
        }
    }
    get overrideDOMText() {
        return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
    }
    domBoundsAround() {
        return null;
    }
    become(other) {
        if (other instanceof $7beee9608540d2c3$var$BlockWidgetView && other.widget.constructor == this.widget.constructor) {
            if (!other.widget.compare(this.widget)) this.markDirty(true);
            if (this.dom && !this.prevWidget) this.prevWidget = this.widget;
            this.widget = other.widget;
            this.length = other.length;
            this.deco = other.deco;
            this.breakAfter = other.breakAfter;
            return true;
        }
        return false;
    }
    ignoreMutation() {
        return true;
    }
    ignoreEvent(event) {
        return this.widget.ignoreEvent(event);
    }
    get isEditable() {
        return false;
    }
    get isWidget() {
        return true;
    }
    coordsAt(pos, side) {
        return this.widget.coordsAt(this.dom, pos, side);
    }
    destroy() {
        super.destroy();
        if (this.dom) this.widget.destroy(this.dom);
    }
    covers(side) {
        let { startSide: startSide, endSide: endSide } = this.deco;
        return startSide == endSide ? false : side < 0 ? startSide < 0 : endSide > 0;
    }
}
/**
Widgets added to the content are described by subclasses of this
class. Using a description object like that makes it possible to
delay creating of the DOM structure for a widget until it is
needed, and to avoid redrawing widgets even if the decorations
that define them are recreated.
*/ class $7beee9608540d2c3$export$95cdd842edb044c5 {
    /**
    Compare this instance to another instance of the same type.
    (TypeScript can't express this, but only instances of the same
    specific class will be passed to this method.) This is used to
    avoid redrawing widgets when they are replaced by a new
    decoration of the same type. The default implementation just
    returns `false`, which will cause new instances of the widget to
    always be redrawn.
    */ eq(widget) {
        return false;
    }
    /**
    Update a DOM element created by a widget of the same type (but
    different, non-`eq` content) to reflect this widget. May return
    true to indicate that it could update, false to indicate it
    couldn't (in which case the widget will be redrawn). The default
    implementation just returns false.
    */ updateDOM(dom, view) {
        return false;
    }
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    The estimated height this widget will have, to be used when
    estimating the height of content that hasn't been drawn. May
    return -1 to indicate you don't know. The default implementation
    returns -1.
    */ get estimatedHeight() {
        return -1;
    }
    /**
    For inline widgets that are displayed inline (as opposed to
    `inline-block`) and introduce line breaks (through `<br>` tags
    or textual newlines), this must indicate the amount of line
    breaks they introduce. Defaults to 0.
    */ get lineBreaks() {
        return 0;
    }
    /**
    Can be used to configure which kinds of events inside the widget
    should be ignored by the editor. The default is to ignore all
    events.
    */ ignoreEvent(event) {
        return true;
    }
    /**
    Override the way screen coordinates for positions at/in the
    widget are found. `pos` will be the offset into the widget, and
    `side` the side of the position that is being queried—less than
    zero for before, greater than zero for after, and zero for
    directly at that position.
    */ coordsAt(dom, pos, side) {
        return null;
    }
    /**
    @internal
    */ get isHidden() {
        return false;
    }
    /**
    @internal
    */ get editable() {
        return false;
    }
    /**
    This is called when the an instance of the widget is removed
    from the editor view.
    */ destroy(dom) {}
}
/**
The different types of blocks that can occur in an editor view.
*/ var $7beee9608540d2c3$export$48808c686fe495c4 = /*@__PURE__*/ function(BlockType) {
    /**
    A line of text.
    */ BlockType[BlockType["Text"] = 0] = "Text";
    /**
    A block widget associated with the position after it.
    */ BlockType[BlockType["WidgetBefore"] = 1] = "WidgetBefore";
    /**
    A block widget associated with the position before it.
    */ BlockType[BlockType["WidgetAfter"] = 2] = "WidgetAfter";
    /**
    A block widget [replacing](https://codemirror.net/6/docs/ref/#view.Decoration^replace) a range of content.
    */ BlockType[BlockType["WidgetRange"] = 3] = "WidgetRange";
    return BlockType;
}($7beee9608540d2c3$export$48808c686fe495c4 || ($7beee9608540d2c3$export$48808c686fe495c4 = {}));
/**
A decoration provides information on how to draw or style a piece
of content. You'll usually use it wrapped in a
[`Range`](https://codemirror.net/6/docs/ref/#state.Range), which adds a start and end position.
@nonabstract
*/ class $7beee9608540d2c3$export$10e30b733df217ea extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    constructor(/**
    @internal
    */ startSide, /**
    @internal
    */ endSide, /**
    @internal
    */ widget, /**
    The config object used to create this decoration. You can
    include additional properties in there to store metadata about
    your decoration.
    */ spec){
        super();
        this.startSide = startSide;
        this.endSide = endSide;
        this.widget = widget;
        this.spec = spec;
    }
    /**
    @internal
    */ get heightRelevant() {
        return false;
    }
    /**
    Create a mark decoration, which influences the styling of the
    content in its range. Nested mark decorations will cause nested
    DOM elements to be created. Nesting order is determined by
    precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
    the higher-precedence decorations creating the inner DOM nodes.
    Such elements are split on line boundaries and on the boundaries
    of lower-precedence decorations.
    */ static mark(spec) {
        return new $7beee9608540d2c3$var$MarkDecoration(spec);
    }
    /**
    Create a widget decoration, which displays a DOM element at the
    given position.
    */ static widget(spec) {
        let side = Math.max(-10000, Math.min(10000, spec.side || 0)), block = !!spec.block;
        side += block && !spec.inlineOrder ? side > 0 ? 300000000 /* Side.BlockAfter */  : -400000000 /* Side.BlockBefore */  : side > 0 ? 100000000 /* Side.InlineAfter */  : -100000000 /* Side.InlineBefore */ ;
        return new $7beee9608540d2c3$var$PointDecoration(spec, side, side, block, spec.widget || null, false);
    }
    /**
    Create a replace decoration which replaces the given range with
    a widget, or simply hides it.
    */ static replace(spec) {
        let block = !!spec.block, startSide, endSide;
        if (spec.isBlockGap) {
            startSide = -500000000 /* Side.GapStart */ ;
            endSide = 400000000 /* Side.GapEnd */ ;
        } else {
            let { start: start, end: end } = $7beee9608540d2c3$var$getInclusive(spec, block);
            startSide = (start ? block ? -300000000 /* Side.BlockIncStart */  : -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ ) - 1;
            endSide = (end ? block ? 200000000 /* Side.BlockIncEnd */  : 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ ) + 1;
        }
        return new $7beee9608540d2c3$var$PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
    }
    /**
    Create a line decoration, which can add DOM attributes to the
    line starting at the given position.
    */ static line(spec) {
        return new $7beee9608540d2c3$var$LineDecoration(spec);
    }
    /**
    Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
    decorated range or ranges. If the ranges aren't already sorted,
    pass `true` for `sort` to make the library sort them for you.
    */ static set(of, sort = false) {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(of, sort);
    }
    /**
    @internal
    */ hasHeight() {
        return this.widget ? this.widget.estimatedHeight > -1 : false;
    }
}
/**
The empty set of decorations.
*/ $7beee9608540d2c3$export$10e30b733df217ea.none = (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
class $7beee9608540d2c3$var$MarkDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec){
        let { start: start, end: end } = $7beee9608540d2c3$var$getInclusive(spec);
        super(start ? -1 /* Side.InlineIncStart */  : 500000000 /* Side.NonIncStart */ , end ? 1 /* Side.InlineIncEnd */  : -600000000 /* Side.NonIncEnd */ , null, spec);
        this.tagName = spec.tagName || "span";
        this.class = spec.class || "";
        this.attrs = spec.attributes || null;
    }
    eq(other) {
        var _a, _b;
        return this == other || other instanceof $7beee9608540d2c3$var$MarkDecoration && this.tagName == other.tagName && (this.class || ((_a = this.attrs) === null || _a === void 0 ? void 0 : _a.class)) == (other.class || ((_b = other.attrs) === null || _b === void 0 ? void 0 : _b.class)) && $7beee9608540d2c3$var$attrsEq(this.attrs, other.attrs, "class");
    }
    range(from, to = from) {
        if (from >= to) throw new RangeError("Mark decorations may not be empty");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$MarkDecoration.prototype.point = false;
class $7beee9608540d2c3$var$LineDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec){
        super(-200000000 /* Side.Line */ , -200000000 /* Side.Line */ , null, spec);
    }
    eq(other) {
        return other instanceof $7beee9608540d2c3$var$LineDecoration && this.spec.class == other.spec.class && $7beee9608540d2c3$var$attrsEq(this.spec.attributes, other.spec.attributes);
    }
    range(from, to = from) {
        if (to != from) throw new RangeError("Line decoration ranges must be zero-length");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$LineDecoration.prototype.mapMode = (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore;
$7beee9608540d2c3$var$LineDecoration.prototype.point = true;
class $7beee9608540d2c3$var$PointDecoration extends $7beee9608540d2c3$export$10e30b733df217ea {
    constructor(spec, startSide, endSide, block, widget, isReplace){
        super(startSide, endSide, widget, spec);
        this.block = block;
        this.isReplace = isReplace;
        this.mapMode = !block ? (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel : startSide <= 0 ? (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore : (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackAfter;
    }
    // Only relevant when this.block == true
    get type() {
        return this.startSide != this.endSide ? $7beee9608540d2c3$export$48808c686fe495c4.WidgetRange : this.startSide <= 0 ? $7beee9608540d2c3$export$48808c686fe495c4.WidgetBefore : $7beee9608540d2c3$export$48808c686fe495c4.WidgetAfter;
    }
    get heightRelevant() {
        return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
    }
    eq(other) {
        return other instanceof $7beee9608540d2c3$var$PointDecoration && $7beee9608540d2c3$var$widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
    }
    range(from, to = from) {
        if (this.isReplace && (from > to || from == to && this.startSide > 0 && this.endSide <= 0)) throw new RangeError("Invalid range for replacement decoration");
        if (!this.isReplace && to != from) throw new RangeError("Widget decorations can only have zero-length ranges");
        return super.range(from, to);
    }
}
$7beee9608540d2c3$var$PointDecoration.prototype.point = true;
function $7beee9608540d2c3$var$getInclusive(spec, block = false) {
    let { inclusiveStart: start, inclusiveEnd: end } = spec;
    if (start == null) start = spec.inclusive;
    if (end == null) end = spec.inclusive;
    return {
        start: start !== null && start !== void 0 ? start : block,
        end: end !== null && end !== void 0 ? end : block
    };
}
function $7beee9608540d2c3$var$widgetsEq(a, b) {
    return a == b || !!(a && b && a.compare(b));
}
function $7beee9608540d2c3$var$addRange(from, to, ranges, margin = 0) {
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last] + margin >= from) ranges[last] = Math.max(ranges[last], to);
    else ranges.push(from, to);
}
class $7beee9608540d2c3$var$ContentBuilder {
    constructor(doc, pos, end, disallowBlockEffectsFor){
        this.doc = doc;
        this.pos = pos;
        this.end = end;
        this.disallowBlockEffectsFor = disallowBlockEffectsFor;
        this.content = [];
        this.curLine = null;
        this.breakAtStart = 0;
        this.pendingBuffer = 0 /* Buf.No */ ;
        this.bufferMarks = [];
        // Set to false directly after a widget that covers the position after it
        this.atCursorPos = true;
        this.openStart = -1;
        this.openEnd = -1;
        this.text = "";
        this.textOff = 0;
        this.cursor = doc.iter();
        this.skip = pos;
    }
    posCovered() {
        if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
        let last = this.content[this.content.length - 1];
        return !(last.breakAfter || last instanceof $7beee9608540d2c3$var$BlockWidgetView && last.deco.endSide < 0);
    }
    getLine() {
        if (!this.curLine) {
            this.content.push(this.curLine = new $7beee9608540d2c3$var$LineView);
            this.atCursorPos = true;
        }
        return this.curLine;
    }
    flushBuffer(active = this.bufferMarks) {
        if (this.pendingBuffer) {
            this.curLine.append($7beee9608540d2c3$var$wrapMarks(new $7beee9608540d2c3$var$WidgetBufferView(-1), active), active.length);
            this.pendingBuffer = 0 /* Buf.No */ ;
        }
    }
    addBlockWidget(view) {
        this.flushBuffer();
        this.curLine = null;
        this.content.push(view);
    }
    finish(openEnd) {
        if (this.pendingBuffer && openEnd <= this.bufferMarks.length) this.flushBuffer();
        else this.pendingBuffer = 0 /* Buf.No */ ;
        if (!this.posCovered() && !(openEnd && this.content.length && this.content[this.content.length - 1] instanceof $7beee9608540d2c3$var$BlockWidgetView)) this.getLine();
    }
    buildText(length, active, openStart) {
        while(length > 0){
            if (this.textOff == this.text.length) {
                let { value: value, lineBreak: lineBreak, done: done } = this.cursor.next(this.skip);
                this.skip = 0;
                if (done) throw new Error("Ran out of text content when drawing inline views");
                if (lineBreak) {
                    if (!this.posCovered()) this.getLine();
                    if (this.content.length) this.content[this.content.length - 1].breakAfter = 1;
                    else this.breakAtStart = 1;
                    this.flushBuffer();
                    this.curLine = null;
                    this.atCursorPos = true;
                    length--;
                    continue;
                } else {
                    this.text = value;
                    this.textOff = 0;
                }
            }
            let take = Math.min(this.text.length - this.textOff, length, 512 /* T.Chunk */ );
            this.flushBuffer(active.slice(active.length - openStart));
            this.getLine().append($7beee9608540d2c3$var$wrapMarks(new $7beee9608540d2c3$var$TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
            this.atCursorPos = true;
            this.textOff += take;
            length -= take;
            openStart = 0;
        }
    }
    span(from, to, active, openStart) {
        this.buildText(to - from, active, openStart);
        this.pos = to;
        if (this.openStart < 0) this.openStart = openStart;
    }
    point(from, to, deco, active, openStart, index) {
        if (this.disallowBlockEffectsFor[index] && deco instanceof $7beee9608540d2c3$var$PointDecoration) {
            if (deco.block) throw new RangeError("Block decorations may not be specified via plugins");
            if (to > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
        }
        let len = to - from;
        if (deco instanceof $7beee9608540d2c3$var$PointDecoration) {
            if (deco.block) {
                if (deco.startSide > 0 && !this.posCovered()) this.getLine();
                this.addBlockWidget(new $7beee9608540d2c3$var$BlockWidgetView(deco.widget || $7beee9608540d2c3$var$NullWidget.block, len, deco));
            } else {
                let view = $7beee9608540d2c3$var$WidgetView.create(deco.widget || $7beee9608540d2c3$var$NullWidget.inline, len, len ? 0 : deco.startSide);
                let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to || deco.startSide > 0);
                let cursorAfter = !view.isEditable && (from < to || openStart > active.length || deco.startSide <= 0);
                let line = this.getLine();
                if (this.pendingBuffer == 2 /* Buf.IfCursor */  && !cursorBefore && !view.isEditable) this.pendingBuffer = 0 /* Buf.No */ ;
                this.flushBuffer(active);
                if (cursorBefore) {
                    line.append($7beee9608540d2c3$var$wrapMarks(new $7beee9608540d2c3$var$WidgetBufferView(1), active), openStart);
                    openStart = active.length + Math.max(0, openStart - active.length);
                }
                line.append($7beee9608540d2c3$var$wrapMarks(view, active), openStart);
                this.atCursorPos = cursorAfter;
                this.pendingBuffer = !cursorAfter ? 0 /* Buf.No */  : from < to || openStart > active.length ? 1 /* Buf.Yes */  : 2 /* Buf.IfCursor */ ;
                if (this.pendingBuffer) this.bufferMarks = active.slice();
            }
        } else if (this.doc.lineAt(this.pos).from == this.pos) this.getLine().addLineDeco(deco);
        if (len) {
            // Advance the iterator past the replaced content
            if (this.textOff + len <= this.text.length) this.textOff += len;
            else {
                this.skip += len - (this.text.length - this.textOff);
                this.text = "";
                this.textOff = 0;
            }
            this.pos = to;
        }
        if (this.openStart < 0) this.openStart = openStart;
    }
    static build(text, from, to, decorations, dynamicDecorationMap) {
        let builder = new $7beee9608540d2c3$var$ContentBuilder(text, from, to, dynamicDecorationMap);
        builder.openEnd = (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(decorations, from, to, builder);
        if (builder.openStart < 0) builder.openStart = builder.openEnd;
        builder.finish(builder.openEnd);
        return builder;
    }
}
function $7beee9608540d2c3$var$wrapMarks(view, active) {
    for (let mark of active)view = new $7beee9608540d2c3$var$MarkView(mark, [
        view
    ], view.length);
    return view;
}
class $7beee9608540d2c3$var$NullWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(tag){
        super();
        this.tag = tag;
    }
    eq(other) {
        return other.tag == this.tag;
    }
    toDOM() {
        return document.createElement(this.tag);
    }
    updateDOM(elt) {
        return elt.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
        return true;
    }
}
$7beee9608540d2c3$var$NullWidget.inline = /*@__PURE__*/ new $7beee9608540d2c3$var$NullWidget("span");
$7beee9608540d2c3$var$NullWidget.block = /*@__PURE__*/ new $7beee9608540d2c3$var$NullWidget("div");
/**
Used to indicate [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
*/ var $7beee9608540d2c3$export$cacd6541cfeeb6c1 = /*@__PURE__*/ function(Direction) {
    // (These are chosen to match the base levels, in bidi algorithm
    // terms, of spans in that direction.)
    /**
    Left-to-right.
    */ Direction[Direction["LTR"] = 0] = "LTR";
    /**
    Right-to-left.
    */ Direction[Direction["RTL"] = 1] = "RTL";
    return Direction;
}($7beee9608540d2c3$export$cacd6541cfeeb6c1 || ($7beee9608540d2c3$export$cacd6541cfeeb6c1 = {}));
const $7beee9608540d2c3$var$LTR = $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR, $7beee9608540d2c3$var$RTL = $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL;
// Decode a string with each type encoded as log2(type)
function $7beee9608540d2c3$var$dec(str) {
    let result = [];
    for(let i = 0; i < str.length; i++)result.push(1 << +str[i]);
    return result;
}
// Character types for codepoints 0 to 0xf8
const $7beee9608540d2c3$var$LowTypes = /*@__PURE__*/ $7beee9608540d2c3$var$dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
// Character types for codepoints 0x600 to 0x6f9
const $7beee9608540d2c3$var$ArabicTypes = /*@__PURE__*/ $7beee9608540d2c3$var$dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const $7beee9608540d2c3$var$Brackets = /*@__PURE__*/ Object.create(null), $7beee9608540d2c3$var$BracketStack = [];
// There's a lot more in
// https://www.unicode.org/Public/UCD/latest/ucd/BidiBrackets.txt,
// which are left out to keep code size down.
for (let p of [
    "()",
    "[]",
    "{}"
]){
    let l = /*@__PURE__*/ p.charCodeAt(0), r = /*@__PURE__*/ p.charCodeAt(1);
    $7beee9608540d2c3$var$Brackets[l] = r;
    $7beee9608540d2c3$var$Brackets[r] = -l;
}
function $7beee9608540d2c3$var$charType(ch) {
    return ch <= 0xf7 ? $7beee9608540d2c3$var$LowTypes[ch] : 0x590 <= ch && ch <= 0x5f4 ? 2 /* T.R */  : 0x600 <= ch && ch <= 0x6f9 ? $7beee9608540d2c3$var$ArabicTypes[ch - 0x600] : 0x6ee <= ch && ch <= 0x8ac ? 4 /* T.AL */  : 0x2000 <= ch && ch <= 0x200c ? 256 /* T.NI */  : 0xfb50 <= ch && ch <= 0xfdff ? 4 /* T.AL */  : 1 /* T.L */ ;
}
const $7beee9608540d2c3$var$BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
/**
Represents a contiguous range of text that has a single direction
(as in left-to-right or right-to-left).
*/ class $7beee9608540d2c3$export$e1ed96b746bb516a {
    /**
    The direction of this span.
    */ get dir() {
        return this.level % 2 ? $7beee9608540d2c3$var$RTL : $7beee9608540d2c3$var$LTR;
    }
    /**
    @internal
    */ constructor(/**
    The start of the span (relative to the start of the line).
    */ from, /**
    The end of the span.
    */ to, /**
    The ["bidi
    level"](https://unicode.org/reports/tr9/#Basic_Display_Algorithm)
    of the span (in this context, 0 means
    left-to-right, 1 means right-to-left, 2 means left-to-right
    number inside right-to-left text).
    */ level){
        this.from = from;
        this.to = to;
        this.level = level;
    }
    /**
    @internal
    */ side(end, dir) {
        return this.dir == dir == end ? this.to : this.from;
    }
    /**
    @internal
    */ forward(forward, dir) {
        return forward == (this.dir == dir);
    }
    /**
    @internal
    */ static find(order, index, level, assoc) {
        let maybe = -1;
        for(let i = 0; i < order.length; i++){
            let span = order[i];
            if (span.from <= index && span.to >= index) {
                if (span.level == level) return i;
                // When multiple spans match, if assoc != 0, take the one that
                // covers that side, otherwise take the one with the minimum
                // level.
                if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index : span.to > index : order[maybe].level > span.level)) maybe = i;
            }
        }
        if (maybe < 0) throw new RangeError("Index out of range");
        return maybe;
    }
}
function $7beee9608540d2c3$var$isolatesEq(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++){
        let iA = a[i], iB = b[i];
        if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !$7beee9608540d2c3$var$isolatesEq(iA.inner, iB.inner)) return false;
    }
    return true;
}
// Reused array of character types
const $7beee9608540d2c3$var$types = [];
// Fill in the character types (in `types`) from `from` to `to` and
// apply W normalization rules.
function $7beee9608540d2c3$var$computeCharTypes(line, rFrom, rTo, isolates, outerType) {
    for(let iI = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        let prevType = iI ? 256 /* T.NI */  : outerType;
        // W1. Examine each non-spacing mark (NSM) in the level run, and
        // change the type of the NSM to the type of the previous
        // character. If the NSM is at the start of the level run, it will
        // get the type of sor.
        // W2. Search backwards from each instance of a European number
        // until the first strong type (R, L, AL, or sor) is found. If an
        // AL is found, change the type of the European number to Arabic
        // number.
        // W3. Change all ALs to R.
        // (Left after this: L, R, EN, AN, ET, CS, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $7beee9608540d2c3$var$charType(line.charCodeAt(i));
            if (type == 512 /* T.NSM */ ) type = prev;
            else if (type == 8 /* T.EN */  && prevStrong == 4 /* T.AL */ ) type = 16 /* T.AN */ ;
            $7beee9608540d2c3$var$types[i] = type == 4 /* T.AL */  ? 2 /* T.R */  : type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
            prev = type;
        }
        // W5. A sequence of European terminators adjacent to European
        // numbers changes to all European numbers.
        // W6. Otherwise, separators and terminators change to Other
        // Neutral.
        // W7. Search backwards from each instance of a European number
        // until the first strong type (R, L, or sor) is found. If an L is
        // found, then change the type of the European number to L.
        // (Left after this: L, R, EN+AN, NI)
        for(let i = from, prev = prevType, prevStrong = prevType; i < to; i++){
            let type = $7beee9608540d2c3$var$types[i];
            if (type == 128 /* T.CS */ ) {
                if (i < to - 1 && prev == $7beee9608540d2c3$var$types[i + 1] && prev & 24 /* T.Num */ ) type = $7beee9608540d2c3$var$types[i] = prev;
                else $7beee9608540d2c3$var$types[i] = 256 /* T.NI */ ;
            } else if (type == 64 /* T.ET */ ) {
                let end = i + 1;
                while(end < to && $7beee9608540d2c3$var$types[end] == 64 /* T.ET */ )end++;
                let replace = i && prev == 8 /* T.EN */  || end < rTo && $7beee9608540d2c3$var$types[end] == 8 /* T.EN */  ? prevStrong == 1 /* T.L */  ? 1 /* T.L */  : 8 /* T.EN */  : 256 /* T.NI */ ;
                for(let j = i; j < end; j++)$7beee9608540d2c3$var$types[j] = replace;
                i = end - 1;
            } else if (type == 8 /* T.EN */  && prevStrong == 1 /* T.L */ ) $7beee9608540d2c3$var$types[i] = 1 /* T.L */ ;
            prev = type;
            if (type & 7 /* T.Strong */ ) prevStrong = type;
        }
    }
}
// Process brackets throughout a run sequence.
function $7beee9608540d2c3$var$processBracketPairs(line, rFrom, rTo, isolates, outerType) {
    let oppositeType = outerType == 1 /* T.L */  ? 2 /* T.R */  : 1 /* T.L */ ;
    for(let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N0. Process bracket pairs in an isolating run sequence
        // sequentially in the logical order of the text positions of the
        // opening paired brackets using the logic given below. Within this
        // scope, bidirectional types EN and AN are treated as R.
        for(let i = from, ch, br, type; i < to; i++){
            // Keeps [startIndex, type, strongSeen] triples for each open
            // bracket on BracketStack.
            if (br = $7beee9608540d2c3$var$Brackets[ch = line.charCodeAt(i)]) {
                if (br < 0) {
                    for(let sJ = sI - 3; sJ >= 0; sJ -= 3)if ($7beee9608540d2c3$var$BracketStack[sJ + 1] == -br) {
                        let flags = $7beee9608540d2c3$var$BracketStack[sJ + 2];
                        let type = flags & 2 /* Bracketed.EmbedInside */  ? outerType : !(flags & 4 /* Bracketed.OppositeInside */ ) ? 0 : flags & 1 /* Bracketed.OppositeBefore */  ? oppositeType : outerType;
                        if (type) $7beee9608540d2c3$var$types[i] = $7beee9608540d2c3$var$types[$7beee9608540d2c3$var$BracketStack[sJ]] = type;
                        sI = sJ;
                        break;
                    }
                } else if ($7beee9608540d2c3$var$BracketStack.length == 189 /* Bracketed.MaxDepth */ ) break;
                else {
                    $7beee9608540d2c3$var$BracketStack[sI++] = i;
                    $7beee9608540d2c3$var$BracketStack[sI++] = ch;
                    $7beee9608540d2c3$var$BracketStack[sI++] = context;
                }
            } else if ((type = $7beee9608540d2c3$var$types[i]) == 2 /* T.R */  || type == 1 /* T.L */ ) {
                let embed = type == outerType;
                context = embed ? 0 : 1 /* Bracketed.OppositeBefore */ ;
                for(let sJ = sI - 3; sJ >= 0; sJ -= 3){
                    let cur = $7beee9608540d2c3$var$BracketStack[sJ + 2];
                    if (cur & 2 /* Bracketed.EmbedInside */ ) break;
                    if (embed) $7beee9608540d2c3$var$BracketStack[sJ + 2] |= 2 /* Bracketed.EmbedInside */ ;
                    else {
                        if (cur & 4 /* Bracketed.OppositeInside */ ) break;
                        $7beee9608540d2c3$var$BracketStack[sJ + 2] |= 4 /* Bracketed.OppositeInside */ ;
                    }
                }
            }
        }
    }
}
function $7beee9608540d2c3$var$processNeutrals(rFrom, rTo, isolates, outerType) {
    for(let iI = 0, prev = outerType; iI <= isolates.length; iI++){
        let from = iI ? isolates[iI - 1].to : rFrom, to = iI < isolates.length ? isolates[iI].from : rTo;
        // N1. A sequence of neutrals takes the direction of the
        // surrounding strong text if the text on both sides has the same
        // direction. European and Arabic numbers act as if they were R in
        // terms of their influence on neutrals. Start-of-level-run (sor)
        // and end-of-level-run (eor) are used at level run boundaries.
        // N2. Any remaining neutrals take the embedding direction.
        // (Left after this: L, R, EN+AN)
        for(let i = from; i < to;){
            let type = $7beee9608540d2c3$var$types[i];
            if (type == 256 /* T.NI */ ) {
                let end = i + 1;
                for(;;){
                    if (end == to) {
                        if (iI == isolates.length) break;
                        end = isolates[iI++].to;
                        to = iI < isolates.length ? isolates[iI].from : rTo;
                    } else if ($7beee9608540d2c3$var$types[end] == 256 /* T.NI */ ) end++;
                    else break;
                }
                let beforeL = prev == 1 /* T.L */ ;
                let afterL = (end < rTo ? $7beee9608540d2c3$var$types[end] : outerType) == 1 /* T.L */ ;
                let replace = beforeL == afterL ? beforeL ? 1 /* T.L */  : 2 /* T.R */  : outerType;
                for(let j = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j > i;){
                    if (j == fromJ) {
                        j = isolates[--jI].from;
                        fromJ = jI ? isolates[jI - 1].to : rFrom;
                    }
                    $7beee9608540d2c3$var$types[--j] = replace;
                }
                i = end;
            } else {
                prev = type;
                i++;
            }
        }
    }
}
// Find the contiguous ranges of character types in a given range, and
// emit spans for them. Flip the order of the spans as appropriate
// based on the level, and call through to compute the spans for
// isolates at the proper point.
function $7beee9608540d2c3$var$emitSpans(line, from, to, level, baseLevel, isolates, order) {
    let ourType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    if (level % 2 == baseLevel % 2) for(let iCh = from, iI = 0; iCh < to;){
        // Scan a section of characters in direction ourType, unless
        // there's another type of char right after iCh, in which case
        // we scan a section of other characters (which, if ourType ==
        // T.L, may contain both T.R and T.AN chars).
        let sameDir = true, isNum = false;
        if (iI == isolates.length || iCh < isolates[iI].from) {
            let next = $7beee9608540d2c3$var$types[iCh];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        // Holds an array of isolates to pass to a recursive call if we
        // must recurse (to distinguish T.AN inside an RTL section in
        // LTR text), null if we can emit directly
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI < isolates.length && iScan == isolates[iI].from) {
                if (isNum) break run;
                let iso = isolates[iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.to, jI = iI + 1;;){
                    if (upto == to) break run;
                    if (jI < isolates.length && isolates[jI].from == upto) upto = isolates[jI++].to;
                    else if ($7beee9608540d2c3$var$types[upto] == ourType) break run;
                    else break;
                }
                iI++;
                if (recurse) recurse.push(iso);
                else {
                    if (iso.from > iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iCh, iso.from, localLevel));
                    let dirSwap = iso.direction == $7beee9608540d2c3$var$LTR != !(localLevel % 2);
                    $7beee9608540d2c3$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.to;
                }
                iScan = iso.to;
            } else if (iScan == to || (sameDir ? $7beee9608540d2c3$var$types[iScan] != ourType : $7beee9608540d2c3$var$types[iScan] == ourType)) break;
            else iScan++;
        }
        if (recurse) $7beee9608540d2c3$var$emitSpans(line, iCh, iScan, level + 1, baseLevel, recurse, order);
        else if (iCh < iScan) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iCh, iScan, localLevel));
        iCh = iScan;
    }
    else // Iterate in reverse to flip the span order. Same code again, but
    // going from the back of the section to the front
    for(let iCh = to, iI = isolates.length; iCh > from;){
        let sameDir = true, isNum = false;
        if (!iI || iCh > isolates[iI - 1].to) {
            let next = $7beee9608540d2c3$var$types[iCh - 1];
            if (next != ourType) {
                sameDir = false;
                isNum = next == 16 /* T.AN */ ;
            }
        }
        let recurse = !sameDir && ourType == 1 /* T.L */  ? [] : null;
        let localLevel = sameDir ? level : level + 1;
        let iScan = iCh;
        run: for(;;){
            if (iI && iScan == isolates[iI - 1].to) {
                if (isNum) break run;
                let iso = isolates[--iI];
                // Scan ahead to verify that there is another char in this dir after the isolate(s)
                if (!sameDir) for(let upto = iso.from, jI = iI;;){
                    if (upto == from) break run;
                    if (jI && isolates[jI - 1].to == upto) upto = isolates[--jI].from;
                    else if ($7beee9608540d2c3$var$types[upto - 1] == ourType) break run;
                    else break;
                }
                if (recurse) recurse.push(iso);
                else {
                    if (iso.to < iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iso.to, iCh, localLevel));
                    let dirSwap = iso.direction == $7beee9608540d2c3$var$LTR != !(localLevel % 2);
                    $7beee9608540d2c3$var$computeSectionOrder(line, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order);
                    iCh = iso.from;
                }
                iScan = iso.from;
            } else if (iScan == from || (sameDir ? $7beee9608540d2c3$var$types[iScan - 1] != ourType : $7beee9608540d2c3$var$types[iScan - 1] == ourType)) break;
            else iScan--;
        }
        if (recurse) $7beee9608540d2c3$var$emitSpans(line, iScan, iCh, level + 1, baseLevel, recurse, order);
        else if (iScan < iCh) order.push(new $7beee9608540d2c3$export$e1ed96b746bb516a(iScan, iCh, localLevel));
        iCh = iScan;
    }
}
function $7beee9608540d2c3$var$computeSectionOrder(line, level, baseLevel, isolates, from, to, order) {
    let outerType = level % 2 ? 2 /* T.R */  : 1 /* T.L */ ;
    $7beee9608540d2c3$var$computeCharTypes(line, from, to, isolates, outerType);
    $7beee9608540d2c3$var$processBracketPairs(line, from, to, isolates, outerType);
    $7beee9608540d2c3$var$processNeutrals(from, to, isolates, outerType);
    $7beee9608540d2c3$var$emitSpans(line, from, to, level, baseLevel, isolates, order);
}
function $7beee9608540d2c3$var$computeOrder(line, direction, isolates) {
    if (!line) return [
        new $7beee9608540d2c3$export$e1ed96b746bb516a(0, 0, direction == $7beee9608540d2c3$var$RTL ? 1 : 0)
    ];
    if (direction == $7beee9608540d2c3$var$LTR && !isolates.length && !$7beee9608540d2c3$var$BidiRE.test(line)) return $7beee9608540d2c3$var$trivialOrder(line.length);
    if (isolates.length) while(line.length > $7beee9608540d2c3$var$types.length)$7beee9608540d2c3$var$types[$7beee9608540d2c3$var$types.length] = 256 /* T.NI */ ; // Make sure types array has no gaps
    let order = [], level = direction == $7beee9608540d2c3$var$LTR ? 0 : 1;
    $7beee9608540d2c3$var$computeSectionOrder(line, level, level, isolates, 0, line.length, order);
    return order;
}
function $7beee9608540d2c3$var$trivialOrder(length) {
    return [
        new $7beee9608540d2c3$export$e1ed96b746bb516a(0, length, 0)
    ];
}
let $7beee9608540d2c3$var$movedOver = "";
// This implementation moves strictly visually, without concern for a
// traversal visiting every logical position in the string. It will
// still do so for simple input, but situations like multiple isolates
// with the same level next to each other, or text going against the
// main dir at the end of the line, will make some positions
// unreachable with this motion. Each visible cursor position will
// correspond to the lower-level bidi span that touches it.
//
// The alternative would be to solve an order globally for a given
// line, making sure that it includes every position, but that would
// require associating non-canonical (higher bidi span level)
// positions with a given visual position, which is likely to confuse
// people. (And would generally be a lot more complicated.)
function $7beee9608540d2c3$var$moveVisually(line, order, dir, start, forward) {
    var _a;
    let startIndex = start.head - line.from;
    let spanI = $7beee9608540d2c3$export$e1ed96b746bb516a.find(order, startIndex, (_a = start.bidiLevel) !== null && _a !== void 0 ? _a : -1, start.assoc);
    let span = order[spanI], spanEnd = span.side(forward, dir);
    // End of span
    if (startIndex == spanEnd) {
        let nextI = spanI += forward ? 1 : -1;
        if (nextI < 0 || nextI >= order.length) return null;
        span = order[spanI = nextI];
        startIndex = span.side(!forward, dir);
        spanEnd = span.side(forward, dir);
    }
    let nextIndex = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, startIndex, span.forward(forward, dir));
    if (nextIndex < span.from || nextIndex > span.to) nextIndex = spanEnd;
    $7beee9608540d2c3$var$movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
    let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
    if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(nextSpan.side(!forward, dir) + line.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(nextIndex + line.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function $7beee9608540d2c3$var$autoDirection(text, from, to) {
    for(let i = from; i < to; i++){
        let type = $7beee9608540d2c3$var$charType(text.charCodeAt(i));
        if (type == 1 /* T.L */ ) return $7beee9608540d2c3$var$LTR;
        if (type == 2 /* T.R */  || type == 4 /* T.AL */ ) return $7beee9608540d2c3$var$RTL;
    }
    return $7beee9608540d2c3$var$LTR;
}
const $7beee9608540d2c3$var$clickAddsSelectionRange = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$dragMovesSelection$1 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$mouseSelectionStyle = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$exceptionSink = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$updateListener = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$inputHandler = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$focusChangeEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$perLineTextDirection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $7beee9608540d2c3$var$nativeSelectionHidden = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
const $7beee9608540d2c3$var$scrollHandler = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
class $7beee9608540d2c3$var$ScrollTarget {
    constructor(range, y = "nearest", x = "nearest", yMargin = 5, xMargin = 5, // This data structure is abused to also store precise scroll
    // snapshots, instead of a `scrollIntoView` request. When this
    // flag is `true`, `range` points at a position in the reference
    // line, `yMargin` holds the difference between the top of that
    // line and the top of the editor, and `xMargin` holds the
    // editor's `scrollLeft`.
    isSnapshot = false){
        this.range = range;
        this.y = y;
        this.x = x;
        this.yMargin = yMargin;
        this.xMargin = xMargin;
        this.isSnapshot = isSnapshot;
    }
    map(changes) {
        return changes.empty ? this : new $7beee9608540d2c3$var$ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
    clip(state) {
        return this.range.to <= state.doc.length ? this : new $7beee9608540d2c3$var$ScrollTarget((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
    }
}
const $7beee9608540d2c3$var$scrollIntoView = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: (t, ch)=>t.map(ch)
});
const $7beee9608540d2c3$var$setEditContextFormatting = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
/**
Log or report an unhandled exception in client code. Should
probably only be used by extension code that allows client code to
provide functions, and calls those functions in a context where an
exception can't be propagated to calling code in a reasonable way
(for example when in an event handler).

Either calls a handler registered with
[`EditorView.exceptionSink`](https://codemirror.net/6/docs/ref/#view.EditorView^exceptionSink),
`window.onerror`, if defined, or `console.error` (in which case
it'll pass `context`, when given, as first argument).
*/ function $7beee9608540d2c3$export$f86b2a1a2ce291b3(state, exception, context) {
    let handler = state.facet($7beee9608540d2c3$var$exceptionSink);
    if (handler.length) handler[0](exception);
    else if (window.onerror) window.onerror(String(exception), context, undefined, undefined, exception);
    else if (context) console.error(context + ":", exception);
    else console.error(exception);
}
const $7beee9608540d2c3$var$editable = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : true
});
let $7beee9608540d2c3$var$nextPluginID = 0;
const $7beee9608540d2c3$var$viewPlugin = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
View plugins associate stateful values with a view. They can
influence the way the content is drawn, and are notified of things
that happen in the view.
*/ class $7beee9608540d2c3$export$44d5eccfd62adda7 {
    constructor(/**
    @internal
    */ id, /**
    @internal
    */ create, /**
    @internal
    */ domEventHandlers, /**
    @internal
    */ domEventObservers, buildExtensions){
        this.id = id;
        this.create = create;
        this.domEventHandlers = domEventHandlers;
        this.domEventObservers = domEventObservers;
        this.extension = buildExtensions(this);
    }
    /**
    Define a plugin from a constructor function that creates the
    plugin's value, given an editor view.
    */ static define(create, spec) {
        const { eventHandlers: eventHandlers, eventObservers: eventObservers, provide: provide, decorations: deco } = spec || {};
        return new $7beee9608540d2c3$export$44d5eccfd62adda7($7beee9608540d2c3$var$nextPluginID++, create, eventHandlers, eventObservers, (plugin)=>{
            let ext = [
                $7beee9608540d2c3$var$viewPlugin.of(plugin)
            ];
            if (deco) ext.push($7beee9608540d2c3$var$decorations.of((view)=>{
                let pluginInst = view.plugin(plugin);
                return pluginInst ? deco(pluginInst) : $7beee9608540d2c3$export$10e30b733df217ea.none;
            }));
            if (provide) ext.push(provide(plugin));
            return ext;
        });
    }
    /**
    Create a plugin for a class whose constructor takes a single
    editor view as argument.
    */ static fromClass(cls, spec) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define((view)=>new cls(view), spec);
    }
}
class $7beee9608540d2c3$var$PluginInstance {
    constructor(spec){
        this.spec = spec;
        // When starting an update, all plugins have this field set to the
        // update object, indicating they need to be updated. When finished
        // updating, it is set to `false`. Retrieving a plugin that needs to
        // be updated with `view.plugin` forces an eager update.
        this.mustUpdate = null;
        // This is null when the plugin is initially created, but
        // initialized on the first update.
        this.value = null;
    }
    update(view) {
        if (!this.value) {
            if (this.spec) try {
                this.value = this.spec.create(view);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
                this.deactivate();
            }
        } else if (this.mustUpdate) {
            let update = this.mustUpdate;
            this.mustUpdate = null;
            if (this.value.update) try {
                this.value.update(update);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(update.state, e, "CodeMirror plugin crashed");
                if (this.value.destroy) try {
                    this.value.destroy();
                } catch (_) {}
                this.deactivate();
            }
        }
        return this;
    }
    destroy(view) {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.destroy) try {
            this.value.destroy();
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "CodeMirror plugin crashed");
        }
    }
    deactivate() {
        this.spec = this.value = null;
    }
}
const $7beee9608540d2c3$var$editorAttributes = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$contentAttributes = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
// Provide decorations
const $7beee9608540d2c3$var$decorations = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$outerDecorations = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$atomicRanges = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$bidiIsolatedRanges = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
function $7beee9608540d2c3$var$getIsolatedRanges(view, line) {
    let isolates = view.state.facet($7beee9608540d2c3$var$bidiIsolatedRanges);
    if (!isolates.length) return isolates;
    let sets = isolates.map((i)=>i instanceof Function ? i(view) : i);
    let result = [];
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(sets, line.from, line.to, {
        point () {},
        span (fromDoc, toDoc, active, open) {
            let from = fromDoc - line.from, to = toDoc - line.from;
            let level = result;
            for(let i = active.length - 1; i >= 0; i--, open--){
                let direction = active[i].spec.bidiIsolate, update;
                if (direction == null) direction = $7beee9608540d2c3$var$autoDirection(line.text, from, to);
                if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
                    update.to = to;
                    level = update.inner;
                } else {
                    let add = {
                        from: from,
                        to: to,
                        direction: direction,
                        inner: []
                    };
                    level.push(add);
                    level = add.inner;
                }
            }
        }
    });
    return result;
}
const $7beee9608540d2c3$var$scrollMargins = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
function $7beee9608540d2c3$var$getScrollMargins(view) {
    let left = 0, right = 0, top = 0, bottom = 0;
    for (let source of view.state.facet($7beee9608540d2c3$var$scrollMargins)){
        let m = source(view);
        if (m) {
            if (m.left != null) left = Math.max(left, m.left);
            if (m.right != null) right = Math.max(right, m.right);
            if (m.top != null) top = Math.max(top, m.top);
            if (m.bottom != null) bottom = Math.max(bottom, m.bottom);
        }
    }
    return {
        left: left,
        right: right,
        top: top,
        bottom: bottom
    };
}
const $7beee9608540d2c3$var$styleModule = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
class $7beee9608540d2c3$var$ChangedRange {
    constructor(fromA, toA, fromB, toB){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
    }
    join(other) {
        return new $7beee9608540d2c3$var$ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
    }
    addToSet(set) {
        let i = set.length, me = this;
        for(; i > 0; i--){
            let range = set[i - 1];
            if (range.fromA > me.toA) continue;
            if (range.toA < me.fromA) break;
            me = me.join(range);
            set.splice(i - 1, 1);
        }
        set.splice(i, 0, me);
        return set;
    }
    static extendWithRanges(diff, ranges) {
        if (ranges.length == 0) return diff;
        let result = [];
        for(let dI = 0, rI = 0, posA = 0, posB = 0;; dI++){
            let next = dI == diff.length ? null : diff[dI], off = posA - posB;
            let end = next ? next.fromB : 1e9;
            while(rI < ranges.length && ranges[rI] < end){
                let from = ranges[rI], to = ranges[rI + 1];
                let fromB = Math.max(posB, from), toB = Math.min(end, to);
                if (fromB <= toB) new $7beee9608540d2c3$var$ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result);
                if (to > end) break;
                else rI += 2;
            }
            if (!next) return result;
            new $7beee9608540d2c3$var$ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result);
            posA = next.toA;
            posB = next.toB;
        }
    }
}
/**
View [plugins](https://codemirror.net/6/docs/ref/#view.ViewPlugin) are given instances of this
class, which describe what happened, whenever the view is updated.
*/ class $7beee9608540d2c3$export$b5b084f95c87edf7 {
    constructor(/**
    The editor view that the update is associated with.
    */ view, /**
    The new editor state.
    */ state, /**
    The transactions involved in the update. May be empty.
    */ transactions){
        this.view = view;
        this.state = state;
        this.transactions = transactions;
        /**
        @internal
        */ this.flags = 0;
        this.startState = view.state;
        this.changes = (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).empty(this.startState.doc.length);
        for (let tr of transactions)this.changes = this.changes.compose(tr.changes);
        let changedRanges = [];
        this.changes.iterChangedRanges((fromA, toA, fromB, toB)=>changedRanges.push(new $7beee9608540d2c3$var$ChangedRange(fromA, toA, fromB, toB)));
        this.changedRanges = changedRanges;
    }
    /**
    @internal
    */ static create(view, state, transactions) {
        return new $7beee9608540d2c3$export$b5b084f95c87edf7(view, state, transactions);
    }
    /**
    Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
    [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
    update.
    */ get viewportChanged() {
        return (this.flags & 4 /* UpdateFlag.Viewport */ ) > 0;
    }
    /**
    Indicates whether the height of a block element in the editor
    changed in this update.
    */ get heightChanged() {
        return (this.flags & 2 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    Returns true when the document was modified or the size of the
    editor, or elements within the editor, changed.
    */ get geometryChanged() {
        return this.docChanged || (this.flags & 10 /* UpdateFlag.Height */ ) > 0;
    }
    /**
    True when this update indicates a focus change.
    */ get focusChanged() {
        return (this.flags & 1 /* UpdateFlag.Focus */ ) > 0;
    }
    /**
    Whether the document changed in this update.
    */ get docChanged() {
        return !this.changes.empty;
    }
    /**
    Whether the selection was explicitly set in this update.
    */ get selectionSet() {
        return this.transactions.some((tr)=>tr.selection);
    }
    /**
    @internal
    */ get empty() {
        return this.flags == 0 && this.transactions.length == 0;
    }
}
class $7beee9608540d2c3$var$DocView extends $7beee9608540d2c3$var$ContentView {
    get length() {
        return this.view.state.doc.length;
    }
    constructor(view){
        super();
        this.view = view;
        this.decorations = [];
        this.dynamicDecorationMap = [
            false
        ];
        this.domChanged = null;
        this.hasComposition = null;
        this.markedForComposition = new Set;
        this.editContextFormatting = $7beee9608540d2c3$export$10e30b733df217ea.none;
        this.lastCompositionAfterCursor = false;
        // Track a minimum width for the editor. When measuring sizes in
        // measureVisibleLineHeights, this is updated to point at the width
        // of a given element and its extent in the document. When a change
        // happens in that range, these are reset. That way, once we've seen
        // a line/element of a given length, we keep the editor wide enough
        // to fit at least that element, until it is changed, at which point
        // we forget it again.
        this.minWidth = 0;
        this.minWidthFrom = 0;
        this.minWidthTo = 0;
        // Track whether the DOM selection was set in a lossy way, so that
        // we don't mess it up when reading it back it
        this.impreciseAnchor = null;
        this.impreciseHead = null;
        this.forceSelection = false;
        // Used by the resize observer to ignore resizes that we caused
        // ourselves
        this.lastUpdate = Date.now();
        this.setDOM(view.contentDOM);
        this.children = [
            new $7beee9608540d2c3$var$LineView
        ];
        this.children[0].setParent(this);
        this.updateDeco();
        this.updateInner([
            new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, view.state.doc.length)
        ], 0, null);
    }
    // Update the document view to a given state.
    update(update) {
        var _a;
        let changedRanges = update.changedRanges;
        if (this.minWidth > 0 && changedRanges.length) {
            if (!changedRanges.every(({ fromA: fromA, toA: toA })=>toA < this.minWidthFrom || fromA > this.minWidthTo)) this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
            else {
                this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
                this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
            }
        }
        this.updateEditContextFormatting(update);
        let readCompositionAt = -1;
        if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
            if ((_a = this.domChanged) === null || _a === void 0 ? void 0 : _a.newSel) readCompositionAt = this.domChanged.newSel.head;
            else if (!$7beee9608540d2c3$var$touchesComposition(update.changes, this.hasComposition) && !update.selectionSet) readCompositionAt = update.state.selection.main.head;
        }
        let composition = readCompositionAt > -1 ? $7beee9608540d2c3$var$findCompositionRange(this.view, update.changes, readCompositionAt) : null;
        this.domChanged = null;
        if (this.hasComposition) {
            this.markedForComposition.clear();
            let { from: from, to: to } = this.hasComposition;
            changedRanges = new $7beee9608540d2c3$var$ChangedRange(from, to, update.changes.mapPos(from, -1), update.changes.mapPos(to, 1)).addToSet(changedRanges.slice());
        }
        this.hasComposition = composition ? {
            from: composition.range.fromB,
            to: composition.range.toB
        } : null;
        // When the DOM nodes around the selection are moved to another
        // parent, Chrome sometimes reports a different selection through
        // getSelection than the one that it actually shows to the user.
        // This forces a selection update when lines are joined to work
        // around that. Issue #54
        if (($7beee9608540d2c3$var$browser.ie || $7beee9608540d2c3$var$browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines) this.forceSelection = true;
        let prevDeco = this.decorations, deco = this.updateDeco();
        let decoDiff = $7beee9608540d2c3$var$findChangedDeco(prevDeco, deco, update.changes);
        changedRanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(changedRanges, decoDiff);
        if (!(this.flags & 7 /* ViewFlag.Dirty */ ) && changedRanges.length == 0) return false;
        else {
            this.updateInner(changedRanges, update.startState.doc.length, composition);
            if (update.transactions.length) this.lastUpdate = Date.now();
            return true;
        }
    }
    // Used by update and the constructor do perform the actual DOM
    // update
    updateInner(changes, oldLength, composition) {
        this.view.viewState.mustMeasureContent = true;
        this.updateChildren(changes, oldLength, composition);
        let { observer: observer } = this.view;
        observer.ignore(()=>{
            // Lock the height during redrawing, since Chrome sometimes
            // messes with the scroll position during DOM mutation (though
            // no relayout is triggered and I cannot imagine how it can
            // recompute the scroll position without a layout)
            this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
            this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
            // Chrome will sometimes, when DOM mutations occur directly
            // around the selection, get confused and report a different
            // selection from the one it displays (issue #218). This tries
            // to detect that situation.
            let track = $7beee9608540d2c3$var$browser.chrome || $7beee9608540d2c3$var$browser.ios ? {
                node: observer.selectionRange.focusNode,
                written: false
            } : undefined;
            this.sync(this.view, track);
            this.flags &= -8 /* ViewFlag.Dirty */ ;
            if (track && (track.written || observer.selectionRange.focusNode != track.node)) this.forceSelection = true;
            this.dom.style.height = "";
        });
        this.markedForComposition.forEach((cView)=>cView.flags &= -9 /* ViewFlag.Composition */ );
        let gaps = [];
        if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
            for (let child of this.children)if (child instanceof $7beee9608540d2c3$var$BlockWidgetView && child.widget instanceof $7beee9608540d2c3$var$BlockGapWidget) gaps.push(child.dom);
        }
        observer.updateGaps(gaps);
    }
    updateChildren(changes, oldLength, composition) {
        let ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
        let cursor = this.childCursor(oldLength);
        for(let i = ranges.length - 1;; i--){
            let next = i >= 0 ? ranges[i] : null;
            if (!next) break;
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = next, content, breakAtStart, openStart, openEnd;
            if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
                let before = $7beee9608540d2c3$var$ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
                let after = $7beee9608540d2c3$var$ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
                breakAtStart = before.breakAtStart;
                openStart = before.openStart;
                openEnd = after.openEnd;
                let compLine = this.compositionView(composition);
                if (after.breakAtStart) compLine.breakAfter = 1;
                else if (after.content.length && compLine.merge(compLine.length, compLine.length, after.content[0], false, after.openStart, 0)) {
                    compLine.breakAfter = after.content[0].breakAfter;
                    after.content.shift();
                }
                if (before.content.length && compLine.merge(0, 0, before.content[before.content.length - 1], true, 0, before.openEnd)) before.content.pop();
                content = before.content.concat(compLine).concat(after.content);
            } else ({ content: content, breakAtStart: breakAtStart, openStart: openStart, openEnd: openEnd } = $7beee9608540d2c3$var$ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap));
            let { i: toI, off: toOff } = cursor.findPos(toA, 1);
            let { i: fromI, off: fromOff } = cursor.findPos(fromA, -1);
            $7beee9608540d2c3$var$replaceRange(this, fromI, fromOff, toI, toOff, content, breakAtStart, openStart, openEnd);
        }
        if (composition) this.fixCompositionDOM(composition);
    }
    updateEditContextFormatting(update) {
        this.editContextFormatting = this.editContextFormatting.map(update.changes);
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($7beee9608540d2c3$var$setEditContextFormatting)) this.editContextFormatting = effect.value;
    }
    compositionView(composition) {
        let cur = new $7beee9608540d2c3$var$TextView(composition.text.nodeValue);
        cur.flags |= 8 /* ViewFlag.Composition */ ;
        for (let { deco: deco } of composition.marks)cur = new $7beee9608540d2c3$var$MarkView(deco, [
            cur
        ], cur.length);
        let line = new $7beee9608540d2c3$var$LineView;
        line.append(cur, 0);
        return line;
    }
    fixCompositionDOM(composition) {
        let fix = (dom, cView)=>{
            cView.flags |= 8 /* ViewFlag.Composition */  | (cView.children.some((c)=>c.flags & 7 /* ViewFlag.Dirty */ ) ? 1 /* ViewFlag.ChildDirty */  : 0);
            this.markedForComposition.add(cView);
            let prev = $7beee9608540d2c3$var$ContentView.get(dom);
            if (prev && prev != cView) prev.dom = null;
            cView.setDOM(dom);
        };
        let pos = this.childPos(composition.range.fromB, 1);
        let cView = this.children[pos.i];
        fix(composition.line, cView);
        for(let i = composition.marks.length - 1; i >= -1; i--){
            pos = cView.childPos(pos.off, 1);
            cView = cView.children[pos.i];
            fix(i >= 0 ? composition.marks[i].node : composition.text, cView);
        }
    }
    // Sync the DOM selection to this.state.selection
    updateSelection(mustRead = false, fromPointer = false) {
        if (mustRead || !this.view.observer.selectionRange.focusNode) this.view.observer.readSelectionRange();
        let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
        let selectionNotFocus = !focused && $7beee9608540d2c3$var$hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
        if (!(focused || fromPointer || selectionNotFocus)) return;
        let force = this.forceSelection;
        this.forceSelection = false;
        let main = this.view.state.selection.main;
        let anchor = this.moveToLine(this.domAtPos(main.anchor));
        let head = main.empty ? anchor : this.moveToLine(this.domAtPos(main.head));
        // Always reset on Firefox when next to an uneditable node to
        // avoid invisible cursor bugs (#111)
        if ($7beee9608540d2c3$var$browser.gecko && main.empty && !this.hasComposition && $7beee9608540d2c3$var$betweenUneditable(anchor)) {
            let dummy = document.createTextNode("");
            this.view.observer.ignore(()=>anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
            anchor = head = new $7beee9608540d2c3$var$DOMPos(dummy, 0);
            force = true;
        }
        let domSel = this.view.observer.selectionRange;
        // If the selection is already here, or in an equivalent position, don't touch it
        if (force || !domSel.focusNode || (!$7beee9608540d2c3$var$isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !$7beee9608540d2c3$var$isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main)) {
            this.view.observer.ignore(()=>{
                // Chrome Android will hide the virtual keyboard when tapping
                // inside an uneditable node, and not bring it back when we
                // move the cursor to its proper position. This tries to
                // restore the keyboard by cycling focus.
                if ($7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome && this.dom.contains(domSel.focusNode) && $7beee9608540d2c3$var$inUneditable(domSel.focusNode, this.dom)) {
                    this.dom.blur();
                    this.dom.focus({
                        preventScroll: true
                    });
                }
                let rawSel = $7beee9608540d2c3$var$getSelection(this.view.root);
                if (!rawSel) ;
                else if (main.empty) {
                    // Work around https://bugzilla.mozilla.org/show_bug.cgi?id=1612076
                    if ($7beee9608540d2c3$var$browser.gecko) {
                        let nextTo = $7beee9608540d2c3$var$nextToUneditable(anchor.node, anchor.offset);
                        if (nextTo && nextTo != 3 /* NextTo.After */ ) {
                            let text = (nextTo == 1 /* NextTo.Before */  ? $7beee9608540d2c3$var$textNodeBefore : $7beee9608540d2c3$var$textNodeAfter)(anchor.node, anchor.offset);
                            if (text) anchor = new $7beee9608540d2c3$var$DOMPos(text.node, text.offset);
                        }
                    }
                    rawSel.collapse(anchor.node, anchor.offset);
                    if (main.bidiLevel != null && rawSel.caretBidiLevel !== undefined) rawSel.caretBidiLevel = main.bidiLevel;
                } else if (rawSel.extend) {
                    // Selection.extend can be used to create an 'inverted' selection
                    // (one where the focus is before the anchor), but not all
                    // browsers support it yet.
                    rawSel.collapse(anchor.node, anchor.offset);
                    // Safari will ignore the call above when the editor is
                    // hidden, and then raise an error on the call to extend
                    // (#940).
                    try {
                        rawSel.extend(head.node, head.offset);
                    } catch (_) {}
                } else {
                    // Primitive (IE) way
                    let range = document.createRange();
                    if (main.anchor > main.head) [anchor, head] = [
                        head,
                        anchor
                    ];
                    range.setEnd(head.node, head.offset);
                    range.setStart(anchor.node, anchor.offset);
                    rawSel.removeAllRanges();
                    rawSel.addRange(range);
                }
                if (selectionNotFocus && this.view.root.activeElement == this.dom) {
                    this.dom.blur();
                    if (activeElt) activeElt.focus();
                }
            });
            this.view.observer.setSelectionRange(anchor, head);
        }
        this.impreciseAnchor = anchor.precise ? null : new $7beee9608540d2c3$var$DOMPos(domSel.anchorNode, domSel.anchorOffset);
        this.impreciseHead = head.precise ? null : new $7beee9608540d2c3$var$DOMPos(domSel.focusNode, domSel.focusOffset);
    }
    // If a zero-length widget is inserted next to the cursor during
    // composition, avoid moving it across it and disrupting the
    // composition.
    suppressWidgetCursorChange(sel, cursor) {
        return this.hasComposition && cursor.empty && $7beee9608540d2c3$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor.head;
    }
    enforceCursorAssoc() {
        if (this.hasComposition) return;
        let { view: view } = this, cursor = view.state.selection.main;
        let sel = $7beee9608540d2c3$var$getSelection(view.root);
        let { anchorNode: anchorNode, anchorOffset: anchorOffset } = view.observer.selectionRange;
        if (!sel || !cursor.empty || !cursor.assoc || !sel.modify) return;
        let line = $7beee9608540d2c3$var$LineView.find(this, cursor.head);
        if (!line) return;
        let lineStart = line.posAtStart;
        if (cursor.head == lineStart || cursor.head == lineStart + line.length) return;
        let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
        if (!before || !after || before.bottom > after.top) return;
        let dom = this.domAtPos(cursor.head + cursor.assoc);
        sel.collapse(dom.node, dom.offset);
        sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
        // This can go wrong in corner cases like single-character lines,
        // so check and reset if necessary.
        view.observer.readSelectionRange();
        let newRange = view.observer.selectionRange;
        if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from) sel.collapse(anchorNode, anchorOffset);
    }
    // If a position is in/near a block widget, move it to a nearby text
    // line, since we don't want the cursor inside a block widget.
    moveToLine(pos) {
        // Block widgets will return positions before/after them, which
        // are thus directly in the document DOM element.
        let dom = this.dom, newPos;
        if (pos.node != dom) return pos;
        for(let i = pos.offset; !newPos && i < dom.childNodes.length; i++){
            let view = $7beee9608540d2c3$var$ContentView.get(dom.childNodes[i]);
            if (view instanceof $7beee9608540d2c3$var$LineView) newPos = view.domAtPos(0);
        }
        for(let i = pos.offset - 1; !newPos && i >= 0; i--){
            let view = $7beee9608540d2c3$var$ContentView.get(dom.childNodes[i]);
            if (view instanceof $7beee9608540d2c3$var$LineView) newPos = view.domAtPos(view.length);
        }
        return newPos ? new $7beee9608540d2c3$var$DOMPos(newPos.node, newPos.offset, true) : pos;
    }
    nearest(dom) {
        for(let cur = dom; cur;){
            let domView = $7beee9608540d2c3$var$ContentView.get(cur);
            if (domView && domView.rootView == this) return domView;
            cur = cur.parentNode;
        }
        return null;
    }
    posFromDOM(node, offset) {
        let view = this.nearest(node);
        if (!view) throw new RangeError("Trying to find position for a DOM position outside of the document");
        return view.localPosFromDOM(node, offset) + view.posAtStart;
    }
    domAtPos(pos) {
        let { i: i, off: off } = this.childCursor().findPos(pos, -1);
        for(; i < this.children.length - 1;){
            let child = this.children[i];
            if (off < child.length || child instanceof $7beee9608540d2c3$var$LineView) break;
            i++;
            off = 0;
        }
        return this.children[i].domAtPos(off);
    }
    coordsAt(pos, side) {
        let best = null, bestPos = 0;
        for(let off = this.length, i = this.children.length - 1; i >= 0; i--){
            let child = this.children[i], end = off - child.breakAfter, start = end - child.length;
            if (end < pos) break;
            if (start <= pos && (start < pos || child.covers(-1)) && (end > pos || child.covers(1)) && (!best || child instanceof $7beee9608540d2c3$var$LineView && !(best instanceof $7beee9608540d2c3$var$LineView && side >= 0))) {
                best = child;
                bestPos = start;
            } else if (best && start == pos && end == pos && child instanceof $7beee9608540d2c3$var$BlockWidgetView && Math.abs(side) < 2) {
                if (child.deco.startSide < 0) break;
                else if (i) best = null;
            }
            off = start;
        }
        return best ? best.coordsAt(pos - bestPos, side) : null;
    }
    coordsForChar(pos) {
        let { i: i, off: off } = this.childPos(pos, 1), child = this.children[i];
        if (!(child instanceof $7beee9608540d2c3$var$LineView)) return null;
        while(child.children.length){
            let { i: i, off: childOff } = child.childPos(off, 1);
            for(;; i++){
                if (i == child.children.length) return null;
                if ((child = child.children[i]).length) break;
            }
            off = childOff;
        }
        if (!(child instanceof $7beee9608540d2c3$var$TextView)) return null;
        let end = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(child.text, off);
        if (end == off) return null;
        let rects = $7beee9608540d2c3$var$textRange(child.dom, off, end).getClientRects();
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (i == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right) return rect;
        }
        return null;
    }
    measureVisibleLineHeights(viewport) {
        let result = [], { from: from, to: to } = viewport;
        let contentWidth = this.view.contentDOM.clientWidth;
        let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
        let widest = -1, ltr = this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        for(let pos = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = pos + child.length;
            if (end > to) break;
            if (pos >= from) {
                let childRect = child.dom.getBoundingClientRect();
                result.push(childRect.height);
                if (isWider) {
                    let last = child.dom.lastChild;
                    let rects = last ? $7beee9608540d2c3$var$clientRectsFor(last) : [];
                    if (rects.length) {
                        let rect = rects[rects.length - 1];
                        let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
                        if (width > widest) {
                            widest = width;
                            this.minWidth = contentWidth;
                            this.minWidthFrom = pos;
                            this.minWidthTo = end;
                        }
                    }
                }
            }
            pos = end + child.breakAfter;
        }
        return result;
    }
    textDirectionAt(pos) {
        let { i: i } = this.childPos(pos, 1);
        return getComputedStyle(this.children[i].dom).direction == "rtl" ? $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
    }
    measureTextSize() {
        for (let child of this.children)if (child instanceof $7beee9608540d2c3$var$LineView) {
            let measure = child.measureTextSize();
            if (measure) return measure;
        }
        // If no workable line exists, force a layout of a measurable element
        let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
        dummy.className = "cm-line";
        dummy.style.width = "99999px";
        dummy.style.position = "absolute";
        dummy.textContent = "abc def ghi jkl mno pqr stu";
        this.view.observer.ignore(()=>{
            this.dom.appendChild(dummy);
            let rect = $7beee9608540d2c3$var$clientRectsFor(dummy.firstChild)[0];
            lineHeight = dummy.getBoundingClientRect().height;
            charWidth = rect ? rect.width / 27 : 7;
            textHeight = rect ? rect.height : lineHeight;
            dummy.remove();
        });
        return {
            lineHeight: lineHeight,
            charWidth: charWidth,
            textHeight: textHeight
        };
    }
    childCursor(pos = this.length) {
        // Move back to start of last element when possible, so that
        // `ChildCursor.findPos` doesn't have to deal with the edge case
        // of being after the last element.
        let i = this.children.length;
        if (i) pos -= this.children[--i].length;
        return new $7beee9608540d2c3$var$ChildCursor(this.children, pos, i);
    }
    computeBlockGapDeco() {
        let deco = [], vs = this.view.viewState;
        for(let pos = 0, i = 0;; i++){
            let next = i == vs.viewports.length ? null : vs.viewports[i];
            let end = next ? next.from - 1 : this.length;
            if (end > pos) {
                let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
                deco.push($7beee9608540d2c3$export$10e30b733df217ea.replace({
                    widget: new $7beee9608540d2c3$var$BlockGapWidget(height),
                    block: true,
                    inclusive: true,
                    isBlockGap: true
                }).range(pos, end));
            }
            if (!next) break;
            pos = next.to + 1;
        }
        return $7beee9608540d2c3$export$10e30b733df217ea.set(deco);
    }
    updateDeco() {
        let i = 1;
        let allDeco = this.view.state.facet($7beee9608540d2c3$var$decorations).map((d)=>{
            let dynamic = this.dynamicDecorationMap[i++] = typeof d == "function";
            return dynamic ? d(this.view) : d;
        });
        let dynamicOuter = false, outerDeco = this.view.state.facet($7beee9608540d2c3$var$outerDecorations).map((d, i)=>{
            let dynamic = typeof d == "function";
            if (dynamic) dynamicOuter = true;
            return dynamic ? d(this.view) : d;
        });
        if (outerDeco.length) {
            this.dynamicDecorationMap[i++] = dynamicOuter;
            allDeco.push((0, $6295c6875f57e3ee$export$34cb5241245008dd).join(outerDeco));
        }
        this.decorations = [
            this.editContextFormatting,
            ...allDeco,
            this.computeBlockGapDeco(),
            this.view.viewState.lineGapDeco
        ];
        while(i < this.decorations.length)this.dynamicDecorationMap[i++] = false;
        return this.decorations;
    }
    scrollIntoView(target) {
        if (target.isSnapshot) {
            let ref = this.view.viewState.lineBlockAt(target.range.head);
            this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
            this.view.scrollDOM.scrollLeft = target.xMargin;
            return;
        }
        for (let handler of this.view.state.facet($7beee9608540d2c3$var$scrollHandler))try {
            if (handler(this.view, target.range, target)) return true;
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.view.state, e, "scroll handler");
        }
        let { range: range } = target;
        let rect = this.coordsAt(range.head, range.empty ? range.assoc : range.head > range.anchor ? -1 : 1), other;
        if (!rect) return;
        if (!range.empty && (other = this.coordsAt(range.anchor, range.anchor > range.head ? -1 : 1))) rect = {
            left: Math.min(rect.left, other.left),
            top: Math.min(rect.top, other.top),
            right: Math.max(rect.right, other.right),
            bottom: Math.max(rect.bottom, other.bottom)
        };
        let margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        let targetRect = {
            left: rect.left - margins.left,
            top: rect.top - margins.top,
            right: rect.right + margins.right,
            bottom: rect.bottom + margins.bottom
        };
        let { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = this.view.scrollDOM;
        $7beee9608540d2c3$var$scrollRectIntoView(this.view.scrollDOM, targetRect, range.head < range.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR);
    }
}
function $7beee9608540d2c3$var$betweenUneditable(pos) {
    return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
class $7beee9608540d2c3$var$BlockGapWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(height){
        super();
        this.height = height;
    }
    toDOM() {
        let elt = document.createElement("div");
        elt.className = "cm-gap";
        this.updateDOM(elt);
        return elt;
    }
    eq(other) {
        return other.height == this.height;
    }
    updateDOM(elt) {
        elt.style.height = this.height + "px";
        return true;
    }
    get editable() {
        return true;
    }
    get estimatedHeight() {
        return this.height;
    }
    ignoreEvent() {
        return false;
    }
}
function $7beee9608540d2c3$var$findCompositionNode(view, headPos) {
    let sel = view.observer.selectionRange;
    if (!sel.focusNode) return null;
    let textBefore = $7beee9608540d2c3$var$textNodeBefore(sel.focusNode, sel.focusOffset);
    let textAfter = $7beee9608540d2c3$var$textNodeAfter(sel.focusNode, sel.focusOffset);
    let textNode = textBefore || textAfter;
    if (textAfter && textBefore && textAfter.node != textBefore.node) {
        let descAfter = $7beee9608540d2c3$var$ContentView.get(textAfter.node);
        if (!descAfter || descAfter instanceof $7beee9608540d2c3$var$TextView && descAfter.text != textAfter.node.nodeValue) textNode = textAfter;
        else if (view.docView.lastCompositionAfterCursor) {
            let descBefore = $7beee9608540d2c3$var$ContentView.get(textBefore.node);
            if (!(!descBefore || descBefore instanceof $7beee9608540d2c3$var$TextView && descBefore.text != textBefore.node.nodeValue)) textNode = textAfter;
        }
    }
    view.docView.lastCompositionAfterCursor = textNode != textBefore;
    if (!textNode) return null;
    let from = headPos - textNode.offset;
    return {
        from: from,
        to: from + textNode.node.nodeValue.length,
        node: textNode.node
    };
}
function $7beee9608540d2c3$var$findCompositionRange(view, changes, headPos) {
    let found = $7beee9608540d2c3$var$findCompositionNode(view, headPos);
    if (!found) return null;
    let { node: textNode, from: from, to: to } = found, text = textNode.nodeValue;
    // Don't try to preserve multi-line compositions
    if (/[\n\r]/.test(text)) return null;
    if (view.state.doc.sliceString(found.from, found.to) != text) return null;
    let inv = changes.invertedDesc;
    let range = new $7beee9608540d2c3$var$ChangedRange(inv.mapPos(from), inv.mapPos(to), from, to);
    let marks = [];
    for(let parent = textNode.parentNode;; parent = parent.parentNode){
        let parentView = $7beee9608540d2c3$var$ContentView.get(parent);
        if (parentView instanceof $7beee9608540d2c3$var$MarkView) marks.push({
            node: parent,
            deco: parentView.mark
        });
        else if (parentView instanceof $7beee9608540d2c3$var$LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM) return {
            range: range,
            text: textNode,
            marks: marks,
            line: parent
        };
        else if (parent != view.contentDOM) marks.push({
            node: parent,
            deco: new $7beee9608540d2c3$var$MarkDecoration({
                inclusive: true,
                attributes: $7beee9608540d2c3$var$getAttrs(parent),
                tagName: parent.tagName.toLowerCase()
            })
        });
        else return null;
    }
}
function $7beee9608540d2c3$var$nextToUneditable(node, offset) {
    if (node.nodeType != 1) return 0;
    return (offset && node.childNodes[offset - 1].contentEditable == "false" ? 1 /* NextTo.Before */  : 0) | (offset < node.childNodes.length && node.childNodes[offset].contentEditable == "false" ? 2 /* NextTo.After */  : 0);
}
let $7beee9608540d2c3$var$DecorationComparator$1 = class DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
    comparePoint(from, to) {
        $7beee9608540d2c3$var$addRange(from, to, this.changes);
    }
};
function $7beee9608540d2c3$var$findChangedDeco(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$DecorationComparator$1;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp);
    return comp.changes;
}
function $7beee9608540d2c3$var$inUneditable(node, inside) {
    for(let cur = node; cur && cur != inside; cur = cur.assignedSlot || cur.parentNode){
        if (cur.nodeType == 1 && cur.contentEditable == "false") return true;
    }
    return false;
}
function $7beee9608540d2c3$var$touchesComposition(changes, composition) {
    let touched = false;
    if (composition) changes.iterChangedRanges((from, to)=>{
        if (from < composition.to && to > composition.from) touched = true;
    });
    return touched;
}
function $7beee9608540d2c3$var$groupAt(state, pos, bias = 1) {
    let categorize = state.charCategorizer(pos);
    let line = state.doc.lineAt(pos), linePos = pos - line.from;
    if (line.length == 0) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos);
    if (linePos == 0) bias = 1;
    else if (linePos == line.length) bias = -1;
    let from = linePos, to = linePos;
    if (bias < 0) from = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, linePos, false);
    else to = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, linePos);
    let cat = categorize(line.text.slice(from, to));
    while(from > 0){
        let prev = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, from, false);
        if (categorize(line.text.slice(prev, from)) != cat) break;
        from = prev;
    }
    while(to < line.length){
        let next = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, to);
        if (categorize(line.text.slice(to, next)) != cat) break;
        to = next;
    }
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from + line.from, to + line.from);
}
// Search the DOM for the {node, offset} position closest to the given
// coordinates. Very inefficient and crude, but can usually be avoided
// by calling caret(Position|Range)FromPoint instead.
function $7beee9608540d2c3$var$getdx(x, rect) {
    return rect.left > x ? rect.left - x : Math.max(0, x - rect.right);
}
function $7beee9608540d2c3$var$getdy(y, rect) {
    return rect.top > y ? rect.top - y : Math.max(0, y - rect.bottom);
}
function $7beee9608540d2c3$var$yOverlap(a, b) {
    return a.top < b.bottom - 1 && a.bottom > b.top + 1;
}
function $7beee9608540d2c3$var$upTop(rect, top) {
    return top < rect.top ? {
        top: top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom
    } : rect;
}
function $7beee9608540d2c3$var$upBot(rect, bottom) {
    return bottom > rect.bottom ? {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: bottom
    } : rect;
}
function $7beee9608540d2c3$var$domPosAtCoords(parent, x, y) {
    let closest, closestRect, closestX, closestY, closestOverlap = false;
    let above, below, aboveRect, belowRect;
    for(let child = parent.firstChild; child; child = child.nextSibling){
        let rects = $7beee9608540d2c3$var$clientRectsFor(child);
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (closestRect && $7beee9608540d2c3$var$yOverlap(closestRect, rect)) rect = $7beee9608540d2c3$var$upTop($7beee9608540d2c3$var$upBot(rect, closestRect.bottom), closestRect.top);
            let dx = $7beee9608540d2c3$var$getdx(x, rect), dy = $7beee9608540d2c3$var$getdy(y, rect);
            if (dx == 0 && dy == 0) return child.nodeType == 3 ? $7beee9608540d2c3$var$domPosInText(child, x, y) : $7beee9608540d2c3$var$domPosAtCoords(child, x, y);
            if (!closest || closestY > dy || closestY == dy && closestX > dx) {
                closest = child;
                closestRect = rect;
                closestX = dx;
                closestY = dy;
                let side = dy ? y < rect.top ? -1 : 1 : dx ? x < rect.left ? -1 : 1 : 0;
                closestOverlap = !side || (side > 0 ? i < rects.length - 1 : i > 0);
            }
            if (dx == 0) {
                if (y > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
                    above = child;
                    aboveRect = rect;
                } else if (y < rect.top && (!belowRect || belowRect.top > rect.top)) {
                    below = child;
                    belowRect = rect;
                }
            } else if (aboveRect && $7beee9608540d2c3$var$yOverlap(aboveRect, rect)) aboveRect = $7beee9608540d2c3$var$upBot(aboveRect, rect.bottom);
            else if (belowRect && $7beee9608540d2c3$var$yOverlap(belowRect, rect)) belowRect = $7beee9608540d2c3$var$upTop(belowRect, rect.top);
        }
    }
    if (aboveRect && aboveRect.bottom >= y) {
        closest = above;
        closestRect = aboveRect;
    } else if (belowRect && belowRect.top <= y) {
        closest = below;
        closestRect = belowRect;
    }
    if (!closest) return {
        node: parent,
        offset: 0
    };
    let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x));
    if (closest.nodeType == 3) return $7beee9608540d2c3$var$domPosInText(closest, clipX, y);
    if (closestOverlap && closest.contentEditable != "false") return $7beee9608540d2c3$var$domPosAtCoords(closest, clipX, y);
    let offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
    return {
        node: parent,
        offset: offset
    };
}
function $7beee9608540d2c3$var$domPosInText(node, x, y) {
    let len = node.nodeValue.length;
    let closestOffset = -1, closestDY = 1e9, generalSide = 0;
    for(let i = 0; i < len; i++){
        let rects = $7beee9608540d2c3$var$textRange(node, i, i + 1).getClientRects();
        for(let j = 0; j < rects.length; j++){
            let rect = rects[j];
            if (rect.top == rect.bottom) continue;
            if (!generalSide) generalSide = x - rect.left;
            let dy = (rect.top > y ? rect.top - y : y - rect.bottom) - 1;
            if (rect.left - 1 <= x && rect.right + 1 >= x && dy < closestDY) {
                let right = x >= (rect.left + rect.right) / 2, after = right;
                if ($7beee9608540d2c3$var$browser.chrome || $7beee9608540d2c3$var$browser.gecko) {
                    // Check for RTL on browsers that support getting client
                    // rects for empty ranges.
                    let rectBefore = $7beee9608540d2c3$var$textRange(node, i).getBoundingClientRect();
                    if (rectBefore.left == rect.right) after = !right;
                }
                if (dy <= 0) return {
                    node: node,
                    offset: i + (after ? 1 : 0)
                };
                closestOffset = i + (after ? 1 : 0);
                closestDY = dy;
            }
        }
    }
    return {
        node: node,
        offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0
    };
}
function $7beee9608540d2c3$var$posAtCoords(view, coords, precise, bias = -1) {
    var _a, _b;
    let content = view.contentDOM.getBoundingClientRect(), docTop = content.top + view.viewState.paddingTop;
    let block, { docHeight: docHeight } = view.viewState;
    let { x: x, y: y } = coords, yOffset = y - docTop;
    if (yOffset < 0) return 0;
    if (yOffset > docHeight) return view.state.doc.length;
    // Scan for a text block near the queried y position
    for(let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false;;){
        block = view.elementAtHeight(yOffset);
        if (block.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) break;
        for(;;){
            // Move the y position out of this block
            yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
            if (yOffset >= 0 && yOffset <= docHeight) break;
            // If the document consists entirely of replaced widgets, we
            // won't find a text block, so return 0
            if (bounced) return precise ? null : 0;
            bounced = true;
            bias = -bias;
        }
    }
    y = docTop + yOffset;
    let lineStart = block.from;
    // If this is outside of the rendered viewport, we can't determine a position
    if (lineStart < view.viewport.from) return view.viewport.from == 0 ? 0 : precise ? null : $7beee9608540d2c3$var$posAtCoordsImprecise(view, content, block, x, y);
    if (lineStart > view.viewport.to) return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : $7beee9608540d2c3$var$posAtCoordsImprecise(view, content, block, x, y);
    // Prefer ShadowRootOrDocument.elementFromPoint if present, fall back to document if not
    let doc = view.dom.ownerDocument;
    let root = view.root.elementFromPoint ? view.root : doc;
    let element = root.elementFromPoint(x, y);
    if (element && !view.contentDOM.contains(element)) element = null;
    // If the element is unexpected, clip x at the sides of the content area and try again
    if (!element) {
        x = Math.max(content.left + 1, Math.min(content.right - 1, x));
        element = root.elementFromPoint(x, y);
        if (element && !view.contentDOM.contains(element)) element = null;
    }
    // There's visible editor content under the point, so we can try
    // using caret(Position|Range)FromPoint as a shortcut
    let node, offset = -1;
    if (element && ((_a = view.docView.nearest(element)) === null || _a === void 0 ? void 0 : _a.isEditable) != false) {
        if (doc.caretPositionFromPoint) {
            let pos = doc.caretPositionFromPoint(x, y);
            if (pos) ({ offsetNode: node, offset: offset } = pos);
        } else if (doc.caretRangeFromPoint) {
            let range = doc.caretRangeFromPoint(x, y);
            if (range) {
                ({ startContainer: node, startOffset: offset } = range);
                if (!view.contentDOM.contains(node) || $7beee9608540d2c3$var$browser.safari && $7beee9608540d2c3$var$isSuspiciousSafariCaretResult(node, offset, x) || $7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$isSuspiciousChromeCaretResult(node, offset, x)) node = undefined;
            }
        }
    }
    // No luck, do our own (potentially expensive) search
    if (!node || !view.docView.dom.contains(node)) {
        let line = $7beee9608540d2c3$var$LineView.find(view.docView, lineStart);
        if (!line) return yOffset > block.top + block.height / 2 ? block.to : block.from;
        ({ node: node, offset: offset } = $7beee9608540d2c3$var$domPosAtCoords(line.dom, x, y));
    }
    let nearest = view.docView.nearest(node);
    if (!nearest) return null;
    if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
        let rect = nearest.dom.getBoundingClientRect();
        return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
    } else return nearest.localPosFromDOM(node, offset) + nearest.posAtStart;
}
function $7beee9608540d2c3$var$posAtCoordsImprecise(view, contentRect, block, x, y) {
    let into = Math.round((x - contentRect.left) * view.defaultCharacterWidth);
    if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
        let textHeight = view.viewState.heightOracle.textHeight;
        let line = Math.floor((y - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
        into += line * view.viewState.heightOracle.lineLength;
    }
    let content = view.state.sliceDoc(block.from, block.to);
    return block.from + (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(content, into, view.state.tabSize);
}
// In case of a high line height, Safari's caretRangeFromPoint treats
// the space between lines as belonging to the last character of the
// line before. This is used to detect such a result so that it can be
// ignored (issue #401).
function $7beee9608540d2c3$var$isSuspiciousSafariCaretResult(node, offset, x) {
    let len;
    if (node.nodeType != 3 || offset != (len = node.nodeValue.length)) return false;
    for(let next = node.nextSibling; next; next = next.nextSibling)if (next.nodeType != 1 || next.nodeName != "BR") return false;
    return $7beee9608540d2c3$var$textRange(node, len - 1, len).getBoundingClientRect().left > x;
}
// Chrome will move positions between lines to the start of the next line
function $7beee9608540d2c3$var$isSuspiciousChromeCaretResult(node, offset, x) {
    if (offset != 0) return false;
    for(let cur = node;;){
        let parent = cur.parentNode;
        if (!parent || parent.nodeType != 1 || parent.firstChild != cur) return false;
        if (parent.classList.contains("cm-line")) break;
        cur = parent;
    }
    let rect = node.nodeType == 1 ? node.getBoundingClientRect() : $7beee9608540d2c3$var$textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
    return x - rect.left > 5;
}
function $7beee9608540d2c3$var$blockAt(view, pos) {
    let line = view.lineBlockAt(pos);
    if (Array.isArray(line.type)) for (let l of line.type){
        if (l.to > pos || l.to == pos && (l.to == line.to || l.type == $7beee9608540d2c3$export$48808c686fe495c4.Text)) return l;
    }
    return line;
}
function $7beee9608540d2c3$var$moveToLineBoundary(view, start, forward, includeWrap) {
    let line = $7beee9608540d2c3$var$blockAt(view, start.head);
    let coords = !includeWrap || line.type != $7beee9608540d2c3$export$48808c686fe495c4.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
    if (coords) {
        let editorRect = view.dom.getBoundingClientRect();
        let direction = view.textDirectionAt(line.from);
        let pos = view.posAtCoords({
            x: forward == (direction == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR) ? editorRect.right - 1 : editorRect.left + 1,
            y: (coords.top + coords.bottom) / 2
        });
        if (pos != null) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, forward ? -1 : 1);
    }
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function $7beee9608540d2c3$var$moveByChar(view, start, forward, by) {
    let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
    let direction = view.textDirectionAt(line.from);
    for(let cur = start, check = null;;){
        let next = $7beee9608540d2c3$var$moveVisually(line, spans, direction, cur, forward), char = $7beee9608540d2c3$var$movedOver;
        if (!next) {
            if (line.number == (forward ? view.state.doc.lines : 1)) return cur;
            char = "\n";
            line = view.state.doc.line(line.number + (forward ? 1 : -1));
            spans = view.bidiSpans(line);
            next = view.visualLineSide(line, !forward);
        }
        if (!check) {
            if (!by) return next;
            check = by(char);
        } else if (!check(char)) return cur;
        cur = next;
    }
}
function $7beee9608540d2c3$var$byGroup(view, pos, start) {
    let categorize = view.state.charCategorizer(pos);
    let cat = categorize(start);
    return (next)=>{
        let nextCat = categorize(next);
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) cat = nextCat;
        return cat == nextCat;
    };
}
function $7beee9608540d2c3$var$moveVertically(view, start, forward, distance) {
    let startPos = start.head, dir = forward ? 1 : -1;
    if (startPos == (forward ? view.state.doc.length : 0)) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(startPos, start.assoc);
    let goal = start.goalColumn, startY;
    let rect = view.contentDOM.getBoundingClientRect();
    let startCoords = view.coordsAtPos(startPos, start.assoc || -1), docTop = view.documentTop;
    if (startCoords) {
        if (goal == null) goal = startCoords.left - rect.left;
        startY = dir < 0 ? startCoords.top : startCoords.bottom;
    } else {
        let line = view.viewState.lineBlockAt(startPos);
        if (goal == null) goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
        startY = (dir < 0 ? line.top : line.bottom) + docTop;
    }
    let resolvedGoal = rect.left + goal;
    let dist = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
    for(let extra = 0;; extra += 10){
        let curY = startY + (dist + extra) * dir;
        let pos = $7beee9608540d2c3$var$posAtCoords(view, {
            x: resolvedGoal,
            y: curY
        }, false, dir);
        if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) {
            let charRect = view.docView.coordsForChar(pos);
            let assoc = !charRect || curY < charRect.top ? -1 : 1;
            return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, assoc, undefined, goal);
        }
    }
}
function $7beee9608540d2c3$var$skipAtomicRanges(atoms, pos, bias) {
    for(;;){
        let moved = 0;
        for (let set of atoms)set.between(pos - 1, pos + 1, (from, to, value)=>{
            if (pos > from && pos < to) {
                let side = moved || bias || (pos - from < to - pos ? -1 : 1);
                pos = side < 0 ? from : to;
                moved = side;
            }
        });
        if (!moved) return pos;
    }
}
function $7beee9608540d2c3$var$skipAtoms(view, oldPos, pos) {
    let newPos = $7beee9608540d2c3$var$skipAtomicRanges(view.state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
    return newPos == pos.from ? pos : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(newPos, newPos < pos.from ? 1 : -1);
}
// This will also be where dragging info and such goes
class $7beee9608540d2c3$var$InputState {
    setSelectionOrigin(origin) {
        this.lastSelectionOrigin = origin;
        this.lastSelectionTime = Date.now();
    }
    constructor(view){
        this.view = view;
        this.lastKeyCode = 0;
        this.lastKeyTime = 0;
        this.lastTouchTime = 0;
        this.lastFocusTime = 0;
        this.lastScrollTop = 0;
        this.lastScrollLeft = 0;
        // On iOS, some keys need to have their default behavior happen
        // (after which we retroactively handle them and reset the DOM) to
        // avoid messing up the virtual keyboard state.
        this.pendingIOSKey = undefined;
        /**
        When enabled (>-1), tab presses are not given to key handlers,
        leaving the browser's default behavior. If >0, the mode expires
        at that timestamp, and any other keypress clears it.
        Esc enables temporary tab focus mode for two seconds when not
        otherwise handled.
        */ this.tabFocusMode = -1;
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastContextMenu = 0;
        this.scrollHandlers = [];
        this.handlers = Object.create(null);
        // -1 means not in a composition. Otherwise, this counts the number
        // of changes made during the composition. The count is used to
        // avoid treating the start state of the composition, before any
        // changes have been made, as part of the composition.
        this.composing = -1;
        // Tracks whether the next change should be marked as starting the
        // composition (null means no composition, true means next is the
        // first, false means first has already been marked for this
        // composition)
        this.compositionFirstChange = null;
        // End time of the previous composition
        this.compositionEndedAt = 0;
        // Used in a kludge to detect when an Enter keypress should be
        // considered part of the composition on Safari, which fires events
        // in the wrong order
        this.compositionPendingKey = false;
        // Used to categorize changes as part of a composition, even when
        // the mutation events fire shortly after the compositionend event
        this.compositionPendingChange = false;
        this.mouseSelection = null;
        // When a drag from the editor is active, this points at the range
        // being dragged.
        this.draggedContent = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.notifiedFocused = view.hasFocus;
        // On Safari adding an input event handler somehow prevents an
        // issue where the composition vanishes when you press enter.
        if ($7beee9608540d2c3$var$browser.safari) view.contentDOM.addEventListener("input", ()=>null);
        if ($7beee9608540d2c3$var$browser.gecko) $7beee9608540d2c3$var$firefoxCopyCutHack(view.contentDOM.ownerDocument);
    }
    handleEvent(event) {
        if (!$7beee9608540d2c3$var$eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event)) return;
        if (event.type == "keydown" && this.keydown(event)) return;
        this.runHandlers(event.type, event);
    }
    runHandlers(type, event) {
        let handlers = this.handlers[type];
        if (handlers) {
            for (let observer of handlers.observers)observer(this.view, event);
            for (let handler of handlers.handlers){
                if (event.defaultPrevented) break;
                if (handler(this.view, event)) {
                    event.preventDefault();
                    break;
                }
            }
        }
    }
    ensureHandlers(plugins) {
        let handlers = $7beee9608540d2c3$var$computeHandlers(plugins), prev = this.handlers, dom = this.view.contentDOM;
        for(let type in handlers)if (type != "scroll") {
            let passive = !handlers[type].handlers.length;
            let exists = prev[type];
            if (exists && passive != !exists.handlers.length) {
                dom.removeEventListener(type, this.handleEvent);
                exists = null;
            }
            if (!exists) dom.addEventListener(type, this.handleEvent, {
                passive: passive
            });
        }
        for(let type in prev)if (type != "scroll" && !handlers[type]) dom.removeEventListener(type, this.handleEvent);
        this.handlers = handlers;
    }
    keydown(event) {
        // Must always run, even if a custom handler handled the event
        this.lastKeyCode = event.keyCode;
        this.lastKeyTime = Date.now();
        if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode)) return true;
        if (this.tabFocusMode > 0 && event.keyCode != 27 && $7beee9608540d2c3$var$modifierCodes.indexOf(event.keyCode) < 0) this.tabFocusMode = -1;
        // Chrome for Android usually doesn't fire proper key events, but
        // occasionally does, usually surrounded by a bunch of complicated
        // composition changes. When an enter or backspace key event is
        // seen, hold off on handling DOM events for a bit, and then
        // dispatch it.
        if ($7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
            this.view.observer.delayAndroidKey(event.key, event.keyCode);
            return true;
        }
        // Preventing the default behavior of Enter on iOS makes the
        // virtual keyboard get stuck in the wrong (lowercase)
        // state. So we let it go through, and then, in
        // applyDOMChange, notify key handlers of it and reset to
        // the state they produce.
        let pending;
        if ($7beee9608540d2c3$var$browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = $7beee9608540d2c3$var$PendingKeys.find((key)=>key.keyCode == event.keyCode)) && !event.ctrlKey || $7beee9608540d2c3$var$EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
            this.pendingIOSKey = pending || event;
            setTimeout(()=>this.flushIOSKey(), 250);
            return true;
        }
        if (event.keyCode != 229) this.view.observer.forceFlush();
        return false;
    }
    flushIOSKey(change) {
        let key = this.pendingIOSKey;
        if (!key) return false;
        // This looks like an autocorrection before Enter
        if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString())) return false;
        this.pendingIOSKey = undefined;
        return $7beee9608540d2c3$var$dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : undefined);
    }
    ignoreDuringComposition(event) {
        if (!/^key/.test(event.type)) return false;
        if (this.composing > 0) return true;
        // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
        // On some input method editors (IMEs), the Enter key is used to
        // confirm character selection. On Safari, when Enter is pressed,
        // compositionend and keydown events are sometimes emitted in the
        // wrong order. The key event should still be ignored, even when
        // it happens after the compositionend event.
        if ($7beee9608540d2c3$var$browser.safari && !$7beee9608540d2c3$var$browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
            this.compositionPendingKey = false;
            return true;
        }
        return false;
    }
    startMouseSelection(mouseSelection) {
        if (this.mouseSelection) this.mouseSelection.destroy();
        this.mouseSelection = mouseSelection;
    }
    update(update) {
        this.view.observer.update(update);
        if (this.mouseSelection) this.mouseSelection.update(update);
        if (this.draggedContent && update.docChanged) this.draggedContent = this.draggedContent.map(update.changes);
        if (update.transactions.length) this.lastKeyCode = this.lastSelectionTime = 0;
    }
    destroy() {
        if (this.mouseSelection) this.mouseSelection.destroy();
    }
}
function $7beee9608540d2c3$var$bindHandler(plugin, handler) {
    return (view, event)=>{
        try {
            return handler.call(plugin, event, view);
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e);
        }
    };
}
function $7beee9608540d2c3$var$computeHandlers(plugins) {
    let result = Object.create(null);
    function record(type) {
        return result[type] || (result[type] = {
            observers: [],
            handlers: []
        });
    }
    for (let plugin of plugins){
        let spec = plugin.spec;
        if (spec && spec.domEventHandlers) for(let type in spec.domEventHandlers){
            let f = spec.domEventHandlers[type];
            if (f) record(type).handlers.push($7beee9608540d2c3$var$bindHandler(plugin.value, f));
        }
        if (spec && spec.domEventObservers) for(let type in spec.domEventObservers){
            let f = spec.domEventObservers[type];
            if (f) record(type).observers.push($7beee9608540d2c3$var$bindHandler(plugin.value, f));
        }
    }
    for(let type in $7beee9608540d2c3$var$handlers)record(type).handlers.push($7beee9608540d2c3$var$handlers[type]);
    for(let type in $7beee9608540d2c3$var$observers)record(type).observers.push($7beee9608540d2c3$var$observers[type]);
    return result;
}
const $7beee9608540d2c3$var$PendingKeys = [
    {
        key: "Backspace",
        keyCode: 8,
        inputType: "deleteContentBackward"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertParagraph"
    },
    {
        key: "Enter",
        keyCode: 13,
        inputType: "insertLineBreak"
    },
    {
        key: "Delete",
        keyCode: 46,
        inputType: "deleteContentForward"
    }
];
const $7beee9608540d2c3$var$EmacsyPendingKeys = "dthko";
// Key codes for modifier keys
const $7beee9608540d2c3$var$modifierCodes = [
    16,
    17,
    18,
    20,
    91,
    92,
    224,
    225
];
const $7beee9608540d2c3$var$dragScrollMargin = 6;
function $7beee9608540d2c3$var$dragScrollSpeed(dist) {
    return Math.max(0, dist) * 0.7 + 8;
}
function $7beee9608540d2c3$var$dist(a, b) {
    return Math.max(Math.abs(a.clientX - b.clientX), Math.abs(a.clientY - b.clientY));
}
class $7beee9608540d2c3$var$MouseSelection {
    constructor(view, startEvent, style, mustSelect){
        this.view = view;
        this.startEvent = startEvent;
        this.style = style;
        this.mustSelect = mustSelect;
        this.scrollSpeed = {
            x: 0,
            y: 0
        };
        this.scrolling = -1;
        this.lastEvent = startEvent;
        this.scrollParent = $7beee9608540d2c3$var$scrollableParent(view.contentDOM);
        this.atoms = view.state.facet($7beee9608540d2c3$var$atomicRanges).map((f)=>f(view));
        let doc = view.contentDOM.ownerDocument;
        doc.addEventListener("mousemove", this.move = this.move.bind(this));
        doc.addEventListener("mouseup", this.up = this.up.bind(this));
        this.extend = startEvent.shiftKey;
        this.multiple = view.state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).allowMultipleSelections) && $7beee9608540d2c3$var$addsSelectionRange(view, startEvent);
        this.dragging = $7beee9608540d2c3$var$isInPrimarySelection(view, startEvent) && $7beee9608540d2c3$var$getClickType(startEvent) == 1 ? null : false;
    }
    start(event) {
        // When clicking outside of the selection, immediately apply the
        // effect of starting the selection
        if (this.dragging === false) this.select(event);
    }
    move(event) {
        var _a;
        if (event.buttons == 0) return this.destroy();
        if (this.dragging || this.dragging == null && $7beee9608540d2c3$var$dist(this.startEvent, event) < 10) return;
        this.select(this.lastEvent = event);
        let sx = 0, sy = 0;
        let rect = ((_a = this.scrollParent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || {
            left: 0,
            top: 0,
            right: this.view.win.innerWidth,
            bottom: this.view.win.innerHeight
        };
        let margins = $7beee9608540d2c3$var$getScrollMargins(this.view);
        if (event.clientX - margins.left <= rect.left + $7beee9608540d2c3$var$dragScrollMargin) sx = -$7beee9608540d2c3$var$dragScrollSpeed(rect.left - event.clientX);
        else if (event.clientX + margins.right >= rect.right - $7beee9608540d2c3$var$dragScrollMargin) sx = $7beee9608540d2c3$var$dragScrollSpeed(event.clientX - rect.right);
        if (event.clientY - margins.top <= rect.top + $7beee9608540d2c3$var$dragScrollMargin) sy = -$7beee9608540d2c3$var$dragScrollSpeed(rect.top - event.clientY);
        else if (event.clientY + margins.bottom >= rect.bottom - $7beee9608540d2c3$var$dragScrollMargin) sy = $7beee9608540d2c3$var$dragScrollSpeed(event.clientY - rect.bottom);
        this.setScrollSpeed(sx, sy);
    }
    up(event) {
        if (this.dragging == null) this.select(this.lastEvent);
        if (!this.dragging) event.preventDefault();
        this.destroy();
    }
    destroy() {
        this.setScrollSpeed(0, 0);
        let doc = this.view.contentDOM.ownerDocument;
        doc.removeEventListener("mousemove", this.move);
        doc.removeEventListener("mouseup", this.up);
        this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
    }
    setScrollSpeed(sx, sy) {
        this.scrollSpeed = {
            x: sx,
            y: sy
        };
        if (sx || sy) {
            if (this.scrolling < 0) this.scrolling = setInterval(()=>this.scroll(), 50);
        } else if (this.scrolling > -1) {
            clearInterval(this.scrolling);
            this.scrolling = -1;
        }
    }
    scroll() {
        if (this.scrollParent) {
            this.scrollParent.scrollLeft += this.scrollSpeed.x;
            this.scrollParent.scrollTop += this.scrollSpeed.y;
        } else this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y);
        if (this.dragging === false) this.select(this.lastEvent);
    }
    skipAtoms(sel) {
        let ranges = null;
        for(let i = 0; i < sel.ranges.length; i++){
            let range = sel.ranges[i], updated = null;
            if (range.empty) {
                let pos = $7beee9608540d2c3$var$skipAtomicRanges(this.atoms, range.from, 0);
                if (pos != range.from) updated = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, -1);
            } else {
                let from = $7beee9608540d2c3$var$skipAtomicRanges(this.atoms, range.from, -1);
                let to = $7beee9608540d2c3$var$skipAtomicRanges(this.atoms, range.to, 1);
                if (from != range.from || to != range.to) updated = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.from == range.anchor ? from : to, range.from == range.head ? from : to);
            }
            if (updated) {
                if (!ranges) ranges = sel.ranges.slice();
                ranges[i] = updated;
            }
        }
        return ranges ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, sel.mainIndex) : sel;
    }
    select(event) {
        let { view: view } = this, selection = this.skipAtoms(this.style.get(event, this.extend, this.multiple));
        if (this.mustSelect || !selection.eq(view.state.selection, this.dragging === false)) this.view.dispatch({
            selection: selection,
            userEvent: "select.pointer"
        });
        this.mustSelect = false;
    }
    update(update) {
        if (update.transactions.some((tr)=>tr.isUserEvent("input.type"))) this.destroy();
        else if (this.style.update(update)) setTimeout(()=>this.select(this.lastEvent), 20);
    }
}
function $7beee9608540d2c3$var$addsSelectionRange(view, event) {
    let facet = view.state.facet($7beee9608540d2c3$var$clickAddsSelectionRange);
    return facet.length ? facet[0](event) : $7beee9608540d2c3$var$browser.mac ? event.metaKey : event.ctrlKey;
}
function $7beee9608540d2c3$var$dragMovesSelection(view, event) {
    let facet = view.state.facet($7beee9608540d2c3$var$dragMovesSelection$1);
    return facet.length ? facet[0](event) : $7beee9608540d2c3$var$browser.mac ? !event.altKey : !event.ctrlKey;
}
function $7beee9608540d2c3$var$isInPrimarySelection(view, event) {
    let { main: main } = view.state.selection;
    if (main.empty) return false;
    // On boundary clicks, check whether the coordinates are inside the
    // selection's client rectangles
    let sel = $7beee9608540d2c3$var$getSelection(view.root);
    if (!sel || sel.rangeCount == 0) return true;
    let rects = sel.getRangeAt(0).getClientRects();
    for(let i = 0; i < rects.length; i++){
        let rect = rects[i];
        if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY) return true;
    }
    return false;
}
function $7beee9608540d2c3$var$eventBelongsToEditor(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target, cView; node != view.contentDOM; node = node.parentNode)if (!node || node.nodeType == 11 || (cView = $7beee9608540d2c3$var$ContentView.get(node)) && cView.ignoreEvent(event)) return false;
    return true;
}
const $7beee9608540d2c3$var$handlers = /*@__PURE__*/ Object.create(null);
const $7beee9608540d2c3$var$observers = /*@__PURE__*/ Object.create(null);
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $7beee9608540d2c3$var$brokenClipboardAPI = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version < 15 || $7beee9608540d2c3$var$browser.ios && $7beee9608540d2c3$var$browser.webkit_version < 604;
function $7beee9608540d2c3$var$capturePaste(view) {
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    setTimeout(()=>{
        view.focus();
        target.remove();
        $7beee9608540d2c3$var$doPaste(view, target.value);
    }, 50);
}
function $7beee9608540d2c3$var$doPaste(view, input) {
    let { state: state } = view, changes, i = 1, text = state.toText(input);
    let byLine = text.lines == state.selection.ranges.length;
    let linewise = $7beee9608540d2c3$var$lastLinewiseCopy != null && state.selection.ranges.every((r)=>r.empty) && $7beee9608540d2c3$var$lastLinewiseCopy == text.toString();
    if (linewise) {
        let lastLine = -1;
        changes = state.changeByRange((range)=>{
            let line = state.doc.lineAt(range.from);
            if (line.from == lastLine) return {
                range: range
            };
            lastLine = line.from;
            let insert = state.toText((byLine ? text.line(i++).text : input) + state.lineBreak);
            return {
                changes: {
                    from: line.from,
                    insert: insert
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + insert.length)
            };
        });
    } else if (byLine) changes = state.changeByRange((range)=>{
        let line = text.line(i++);
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: line.text
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + line.length)
        };
    });
    else changes = state.replaceSelection(text);
    view.dispatch(changes, {
        userEvent: "input.paste",
        scrollIntoView: true
    });
}
$7beee9608540d2c3$var$observers.scroll = (view)=>{
    view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
    view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
$7beee9608540d2c3$var$handlers.keydown = (view, event)=>{
    view.inputState.setSelectionOrigin("select");
    if (event.keyCode == 27 && view.inputState.tabFocusMode != 0) view.inputState.tabFocusMode = Date.now() + 2000;
    return false;
};
$7beee9608540d2c3$var$observers.touchstart = (view, e)=>{
    view.inputState.lastTouchTime = Date.now();
    view.inputState.setSelectionOrigin("select.pointer");
};
$7beee9608540d2c3$var$observers.touchmove = (view)=>{
    view.inputState.setSelectionOrigin("select.pointer");
};
$7beee9608540d2c3$var$handlers.mousedown = (view, event)=>{
    view.observer.flush();
    if (view.inputState.lastTouchTime > Date.now() - 2000) return false; // Ignore touch interaction
    let style = null;
    for (let makeStyle of view.state.facet($7beee9608540d2c3$var$mouseSelectionStyle)){
        style = makeStyle(view, event);
        if (style) break;
    }
    if (!style && event.button == 0) style = $7beee9608540d2c3$var$basicMouseSelection(view, event);
    if (style) {
        let mustFocus = !view.hasFocus;
        view.inputState.startMouseSelection(new $7beee9608540d2c3$var$MouseSelection(view, event, style, mustFocus));
        if (mustFocus) view.observer.ignore(()=>{
            $7beee9608540d2c3$var$focusPreventScroll(view.contentDOM);
            let active = view.root.activeElement;
            if (active && !active.contains(view.contentDOM)) active.blur();
        });
        let mouseSel = view.inputState.mouseSelection;
        if (mouseSel) {
            mouseSel.start(event);
            return mouseSel.dragging === false;
        }
    }
    return false;
};
function $7beee9608540d2c3$var$rangeForClick(view, pos, bias, type) {
    if (type == 1) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos, bias);
    else if (type == 2) return $7beee9608540d2c3$var$groupAt(view.state, pos, bias);
    else {
        let visual = $7beee9608540d2c3$var$LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
        let from = visual ? visual.posAtStart : line.from, to = visual ? visual.posAtEnd : line.to;
        if (to < view.state.doc.length && to == line.to) to++;
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to);
    }
}
let $7beee9608540d2c3$var$insideY = (y, rect)=>y >= rect.top && y <= rect.bottom;
let $7beee9608540d2c3$var$inside = (x, y, rect)=>$7beee9608540d2c3$var$insideY(y, rect) && x >= rect.left && x <= rect.right;
// Try to determine, for the given coordinates, associated with the
// given position, whether they are related to the element before or
// the element after the position.
function $7beee9608540d2c3$var$findPositionSide(view, pos, x, y) {
    let line = $7beee9608540d2c3$var$LineView.find(view.docView, pos);
    if (!line) return 1;
    let off = pos - line.posAtStart;
    // Line boundaries point into the line
    if (off == 0) return 1;
    if (off == line.length) return -1;
    // Positions on top of an element point at that element
    let before = line.coordsAt(off, -1);
    if (before && $7beee9608540d2c3$var$inside(x, y, before)) return -1;
    let after = line.coordsAt(off, 1);
    if (after && $7beee9608540d2c3$var$inside(x, y, after)) return 1;
    // This is probably a line wrap point. Pick before if the point is
    // beside it.
    return before && $7beee9608540d2c3$var$insideY(y, before) ? -1 : 1;
}
function $7beee9608540d2c3$var$queryPos(view, event) {
    let pos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    return {
        pos: pos,
        bias: $7beee9608540d2c3$var$findPositionSide(view, pos, event.clientX, event.clientY)
    };
}
const $7beee9608540d2c3$var$BadMouseDetail = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11;
let $7beee9608540d2c3$var$lastMouseDown = null, $7beee9608540d2c3$var$lastMouseDownCount = 0, $7beee9608540d2c3$var$lastMouseDownTime = 0;
function $7beee9608540d2c3$var$getClickType(event) {
    if (!$7beee9608540d2c3$var$BadMouseDetail) return event.detail;
    let last = $7beee9608540d2c3$var$lastMouseDown, lastTime = $7beee9608540d2c3$var$lastMouseDownTime;
    $7beee9608540d2c3$var$lastMouseDown = event;
    $7beee9608540d2c3$var$lastMouseDownTime = Date.now();
    return $7beee9608540d2c3$var$lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? ($7beee9608540d2c3$var$lastMouseDownCount + 1) % 3 : 1;
}
function $7beee9608540d2c3$var$basicMouseSelection(view, event) {
    let start = $7beee9608540d2c3$var$queryPos(view, event), type = $7beee9608540d2c3$var$getClickType(event);
    let startSel = view.state.selection;
    return {
        update (update) {
            if (update.docChanged) {
                start.pos = update.changes.mapPos(start.pos);
                startSel = startSel.map(update.changes);
            }
        },
        get (event, extend, multiple) {
            let cur = $7beee9608540d2c3$var$queryPos(view, event), removed;
            let range = $7beee9608540d2c3$var$rangeForClick(view, cur.pos, cur.bias, type);
            if (start.pos != cur.pos && !extend) {
                let startRange = $7beee9608540d2c3$var$rangeForClick(view, start.pos, start.bias, type);
                let from = Math.min(startRange.from, range.from), to = Math.max(startRange.to, range.to);
                range = from < range.from ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(to, from);
            }
            if (extend) return startSel.replaceRange(startSel.main.extend(range.from, range.to));
            else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = $7beee9608540d2c3$var$removeRangeAround(startSel, cur.pos))) return removed;
            else if (multiple) return startSel.addRange(range);
            else return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
                range
            ]);
        }
    };
}
function $7beee9608540d2c3$var$removeRangeAround(sel, pos) {
    for(let i = 0; i < sel.ranges.length; i++){
        let { from: from, to: to } = sel.ranges[i];
        if (from <= pos && to >= pos) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(sel.ranges.slice(0, i).concat(sel.ranges.slice(i + 1)), sel.mainIndex == i ? 0 : sel.mainIndex - (sel.mainIndex > i ? 1 : 0));
    }
    return null;
}
$7beee9608540d2c3$var$handlers.dragstart = (view, event)=>{
    let { selection: { main: range } } = view.state;
    if (event.target.draggable) {
        let cView = view.docView.nearest(event.target);
        if (cView && cView.isWidget) {
            let from = cView.posAtStart, to = from + cView.length;
            if (from >= range.to || to <= range.from) range = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, to);
        }
    }
    let { inputState: inputState } = view;
    if (inputState.mouseSelection) inputState.mouseSelection.dragging = true;
    inputState.draggedContent = range;
    if (event.dataTransfer) {
        event.dataTransfer.setData("Text", view.state.sliceDoc(range.from, range.to));
        event.dataTransfer.effectAllowed = "copyMove";
    }
    return false;
};
$7beee9608540d2c3$var$handlers.dragend = (view)=>{
    view.inputState.draggedContent = null;
    return false;
};
function $7beee9608540d2c3$var$dropText(view, event, text, direct) {
    if (!text) return;
    let dropPos = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let { draggedContent: draggedContent } = view.inputState;
    let del = direct && draggedContent && $7beee9608540d2c3$var$dragMovesSelection(view, event) ? {
        from: draggedContent.from,
        to: draggedContent.to
    } : null;
    let ins = {
        from: dropPos,
        insert: text
    };
    let changes = view.state.changes(del ? [
        del,
        ins
    ] : ins);
    view.focus();
    view.dispatch({
        changes: changes,
        selection: {
            anchor: changes.mapPos(dropPos, -1),
            head: changes.mapPos(dropPos, 1)
        },
        userEvent: del ? "move.drop" : "input.drop"
    });
    view.inputState.draggedContent = null;
}
$7beee9608540d2c3$var$handlers.drop = (view, event)=>{
    if (!event.dataTransfer) return false;
    if (view.state.readOnly) return true;
    let files = event.dataTransfer.files;
    if (files && files.length) {
        let text = Array(files.length), read = 0;
        let finishFile = ()=>{
            if (++read == files.length) $7beee9608540d2c3$var$dropText(view, event, text.filter((s)=>s != null).join(view.state.lineBreak), false);
        };
        for(let i = 0; i < files.length; i++){
            let reader = new FileReader;
            reader.onerror = finishFile;
            reader.onload = ()=>{
                if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result)) text[i] = reader.result;
                finishFile();
            };
            reader.readAsText(files[i]);
        }
        return true;
    } else {
        let text = event.dataTransfer.getData("Text");
        if (text) {
            $7beee9608540d2c3$var$dropText(view, event, text, true);
            return true;
        }
    }
    return false;
};
$7beee9608540d2c3$var$handlers.paste = (view, event)=>{
    if (view.state.readOnly) return true;
    view.observer.flush();
    let data = $7beee9608540d2c3$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        $7beee9608540d2c3$var$doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
        return true;
    } else {
        $7beee9608540d2c3$var$capturePaste(view);
        return false;
    }
};
function $7beee9608540d2c3$var$captureCopy(view, text) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    let parent = view.dom.parentNode;
    if (!parent) return;
    let target = parent.appendChild(document.createElement("textarea"));
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.value = text;
    target.focus();
    target.selectionEnd = text.length;
    target.selectionStart = 0;
    setTimeout(()=>{
        target.remove();
        view.focus();
    }, 50);
}
function $7beee9608540d2c3$var$copiedRange(state) {
    let content = [], ranges = [], linewise = false;
    for (let range of state.selection.ranges)if (!range.empty) {
        content.push(state.sliceDoc(range.from, range.to));
        ranges.push(range);
    }
    if (!content.length) {
        // Nothing selected, do a line-wise copy
        let upto = -1;
        for (let { from: from } of state.selection.ranges){
            let line = state.doc.lineAt(from);
            if (line.number > upto) {
                content.push(line.text);
                ranges.push({
                    from: line.from,
                    to: Math.min(state.doc.length, line.to + 1)
                });
            }
            upto = line.number;
        }
        linewise = true;
    }
    return {
        text: content.join(state.lineBreak),
        ranges: ranges,
        linewise: linewise
    };
}
let $7beee9608540d2c3$var$lastLinewiseCopy = null;
$7beee9608540d2c3$var$handlers.copy = $7beee9608540d2c3$var$handlers.cut = (view, event)=>{
    let { text: text, ranges: ranges, linewise: linewise } = $7beee9608540d2c3$var$copiedRange(view.state);
    if (!text && !linewise) return false;
    $7beee9608540d2c3$var$lastLinewiseCopy = linewise ? text : null;
    if (event.type == "cut" && !view.state.readOnly) view.dispatch({
        changes: ranges,
        scrollIntoView: true,
        userEvent: "delete.cut"
    });
    let data = $7beee9608540d2c3$var$brokenClipboardAPI ? null : event.clipboardData;
    if (data) {
        data.clearData();
        data.setData("text/plain", text);
        return true;
    } else {
        $7beee9608540d2c3$var$captureCopy(view, text);
        return false;
    }
};
const $7beee9608540d2c3$var$isFocusChange = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
function $7beee9608540d2c3$var$focusChangeTransaction(state, focus) {
    let effects = [];
    for (let getEffect of state.facet($7beee9608540d2c3$var$focusChangeEffect)){
        let effect = getEffect(state, focus);
        if (effect) effects.push(effect);
    }
    return effects ? state.update({
        effects: effects,
        annotations: $7beee9608540d2c3$var$isFocusChange.of(true)
    }) : null;
}
function $7beee9608540d2c3$var$updateForFocusChange(view) {
    setTimeout(()=>{
        let focus = view.hasFocus;
        if (focus != view.inputState.notifiedFocused) {
            let tr = $7beee9608540d2c3$var$focusChangeTransaction(view.state, focus);
            if (tr) view.dispatch(tr);
            else view.update([]);
        }
    }, 10);
}
$7beee9608540d2c3$var$observers.focus = (view)=>{
    view.inputState.lastFocusTime = Date.now();
    // When focusing reset the scroll position, move it back to where it was
    if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
        view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
        view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
    }
    $7beee9608540d2c3$var$updateForFocusChange(view);
};
$7beee9608540d2c3$var$observers.blur = (view)=>{
    view.observer.clearSelectionRange();
    $7beee9608540d2c3$var$updateForFocusChange(view);
};
$7beee9608540d2c3$var$observers.compositionstart = $7beee9608540d2c3$var$observers.compositionupdate = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    if (view.inputState.compositionFirstChange == null) view.inputState.compositionFirstChange = true;
    if (view.inputState.composing < 0) // FIXME possibly set a timeout to clear it again on Android
    view.inputState.composing = 0;
};
$7beee9608540d2c3$var$observers.compositionend = (view)=>{
    if (view.observer.editContext) return; // Composition handled by edit context
    view.inputState.composing = -1;
    view.inputState.compositionEndedAt = Date.now();
    view.inputState.compositionPendingKey = true;
    view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
    view.inputState.compositionFirstChange = null;
    if ($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.android) // Delay flushing for a bit on Android because it'll often fire a
    // bunch of contradictory changes in a row at end of compositon
    view.observer.flushSoon();
    else if (view.inputState.compositionPendingChange) // If we found pending records, schedule a flush.
    Promise.resolve().then(()=>view.observer.flush());
    else // Otherwise, make sure that, if no changes come in soon, the
    // composition view is cleared.
    setTimeout(()=>{
        if (view.inputState.composing < 0 && view.docView.hasComposition) view.update([]);
    }, 50);
};
$7beee9608540d2c3$var$observers.contextmenu = (view)=>{
    view.inputState.lastContextMenu = Date.now();
};
$7beee9608540d2c3$var$handlers.beforeinput = (view, event)=>{
    var _a;
    // Because Chrome Android doesn't fire useful key events, use
    // beforeinput to detect backspace (and possibly enter and delete,
    // but those usually don't even seem to fire beforeinput events at
    // the moment) and fake a key event for it.
    //
    // (preventDefault on beforeinput, though supported in the spec,
    // seems to do nothing at all on Chrome).
    let pending;
    if ($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.android && (pending = $7beee9608540d2c3$var$PendingKeys.find((key)=>key.inputType == event.inputType))) {
        view.observer.delayAndroidKey(pending.key, pending.keyCode);
        if (pending.key == "Backspace" || pending.key == "Delete") {
            let startViewHeight = ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0;
            setTimeout(()=>{
                var _a;
                // Backspacing near uneditable nodes on Chrome Android sometimes
                // closes the virtual keyboard. This tries to crudely detect
                // that and refocus to get it back.
                if ((((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || 0) > startViewHeight + 10 && view.hasFocus) {
                    view.contentDOM.blur();
                    view.focus();
                }
            }, 100);
        }
    }
    if ($7beee9608540d2c3$var$browser.ios && event.inputType == "deleteContentForward") // For some reason, DOM changes (and beforeinput) happen _before_
    // the key event for ctrl-d on iOS when using an external
    // keyboard.
    view.observer.flushSoon();
    // Safari will occasionally forget to fire compositionend at the end of a dead-key composition
    if ($7beee9608540d2c3$var$browser.safari && event.inputType == "insertText" && view.inputState.composing >= 0) setTimeout(()=>$7beee9608540d2c3$var$observers.compositionend(view, event), 20);
    return false;
};
const $7beee9608540d2c3$var$appliedFirefoxHack = /*@__PURE__*/ new Set;
// In Firefox, when cut/copy handlers are added to the document, that
// somehow avoids a bug where those events aren't fired when the
// selection is empty. See https://github.com/codemirror/dev/issues/1082
// and https://bugzilla.mozilla.org/show_bug.cgi?id=995961
function $7beee9608540d2c3$var$firefoxCopyCutHack(doc) {
    if (!$7beee9608540d2c3$var$appliedFirefoxHack.has(doc)) {
        $7beee9608540d2c3$var$appliedFirefoxHack.add(doc);
        doc.addEventListener("copy", ()=>{});
        doc.addEventListener("cut", ()=>{});
    }
}
const $7beee9608540d2c3$var$wrappingWhiteSpace = [
    "pre-wrap",
    "normal",
    "pre-line",
    "break-spaces"
];
class $7beee9608540d2c3$var$HeightOracle {
    constructor(lineWrapping){
        this.lineWrapping = lineWrapping;
        this.doc = (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty;
        this.heightSamples = {};
        this.lineHeight = 14; // The height of an entire line (line-height)
        this.charWidth = 7;
        this.textHeight = 14; // The height of the actual font (font-size)
        this.lineLength = 30;
        // Used to track, during updateHeight, if any actual heights changed
        this.heightChanged = false;
    }
    heightForGap(from, to) {
        let lines = this.doc.lineAt(to).number - this.doc.lineAt(from).number + 1;
        if (this.lineWrapping) lines += Math.max(0, Math.ceil((to - from - lines * this.lineLength * 0.5) / this.lineLength));
        return this.lineHeight * lines;
    }
    heightForLine(length) {
        if (!this.lineWrapping) return this.lineHeight;
        let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / (this.lineLength - 5)));
        return lines * this.lineHeight;
    }
    setDoc(doc) {
        this.doc = doc;
        return this;
    }
    mustRefreshForWrapping(whiteSpace) {
        return $7beee9608540d2c3$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
    }
    mustRefreshForHeights(lineHeights) {
        let newHeight = false;
        for(let i = 0; i < lineHeights.length; i++){
            let h = lineHeights[i];
            if (h < 0) i++;
            else if (!this.heightSamples[Math.floor(h * 10)]) {
                newHeight = true;
                this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return newHeight;
    }
    refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
        let lineWrapping = $7beee9608540d2c3$var$wrappingWhiteSpace.indexOf(whiteSpace) > -1;
        let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
        this.lineWrapping = lineWrapping;
        this.lineHeight = lineHeight;
        this.charWidth = charWidth;
        this.textHeight = textHeight;
        this.lineLength = lineLength;
        if (changed) {
            this.heightSamples = {};
            for(let i = 0; i < knownHeights.length; i++){
                let h = knownHeights[i];
                if (h < 0) i++;
                else this.heightSamples[Math.floor(h * 10)] = true;
            }
        }
        return changed;
    }
}
// This object is used by `updateHeight` to make DOM measurements
// arrive at the right nides. The `heights` array is a sequence of
// block heights, starting from position `from`.
class $7beee9608540d2c3$var$MeasuredHeights {
    constructor(from, heights){
        this.from = from;
        this.heights = heights;
        this.index = 0;
    }
    get more() {
        return this.index < this.heights.length;
    }
}
/**
Record used to represent information about a block-level element
in the editor view.
*/ class $7beee9608540d2c3$export$ddfdc4ccfe9512bd {
    /**
    @internal
    */ constructor(/**
    The start of the element in the document.
    */ from, /**
    The length of the element.
    */ length, /**
    The top position of the element (relative to the top of the
    document).
    */ top, /**
    Its height.
    */ height, /**
    @internal Weird packed field that holds an array of children
    for composite blocks, a decoration for block widgets, and a
    number indicating the amount of widget-create line breaks for
    text blocks.
    */ _content){
        this.from = from;
        this.length = length;
        this.top = top;
        this.height = height;
        this._content = _content;
    }
    /**
    The type of element this is. When querying lines, this may be
    an array of all the blocks that make up the line.
    */ get type() {
        return typeof this._content == "number" ? $7beee9608540d2c3$export$48808c686fe495c4.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    /**
    The end of the element as a document position.
    */ get to() {
        return this.from + this.length;
    }
    /**
    The bottom position of the element.
    */ get bottom() {
        return this.top + this.height;
    }
    /**
    If this is a widget block, this will return the widget
    associated with it.
    */ get widget() {
        return this._content instanceof $7beee9608540d2c3$var$PointDecoration ? this._content.widget : null;
    }
    /**
    If this is a textblock, this holds the number of line breaks
    that appear in widgets inside the block.
    */ get widgetLineBreaks() {
        return typeof this._content == "number" ? this._content : 0;
    }
    /**
    @internal
    */ join(other) {
        let content = (Array.isArray(this._content) ? this._content : [
            this
        ]).concat(Array.isArray(other._content) ? other._content : [
            other
        ]);
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(this.from, this.length + other.length, this.top, this.height + other.height, content);
    }
}
var $7beee9608540d2c3$var$QueryType = /*@__PURE__*/ function(QueryType) {
    QueryType[QueryType["ByPos"] = 0] = "ByPos";
    QueryType[QueryType["ByHeight"] = 1] = "ByHeight";
    QueryType[QueryType["ByPosNoHeight"] = 2] = "ByPosNoHeight";
    return QueryType;
}($7beee9608540d2c3$var$QueryType || ($7beee9608540d2c3$var$QueryType = {}));
const $7beee9608540d2c3$var$Epsilon = 1e-3;
class $7beee9608540d2c3$var$HeightMap {
    constructor(length, height, flags = 2 /* Flag.Outdated */ ){
        this.length = length;
        this.height = height;
        this.flags = flags;
    }
    get outdated() {
        return (this.flags & 2 /* Flag.Outdated */ ) > 0;
    }
    set outdated(value) {
        this.flags = (value ? 2 /* Flag.Outdated */  : 0) | this.flags & -3 /* Flag.Outdated */ ;
    }
    setHeight(oracle, height) {
        if (this.height != height) {
            if (Math.abs(this.height - height) > $7beee9608540d2c3$var$Epsilon) oracle.heightChanged = true;
            this.height = height;
        }
    }
    // Base case is to replace a leaf node, which simply builds a tree
    // from the new nodes and returns that (HeightMapBranch and
    // HeightMapGap override this to actually use from/to)
    replace(_from, _to, nodes) {
        return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    // Again, these are base cases, and are overridden for branch and gap nodes.
    decomposeLeft(_to, result) {
        result.push(this);
    }
    decomposeRight(_from, result) {
        result.push(this);
    }
    applyChanges(decorations, oldDoc, oracle, changes) {
        let me = this, doc = oracle.doc;
        for(let i = changes.length - 1; i >= 0; i--){
            let { fromA: fromA, toA: toA, fromB: fromB, toB: toB } = changes[i];
            let start = me.lineAt(fromA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
            let end = start.to >= toA ? start : me.lineAt(toA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            toB += end.to - toA;
            toA = end.to;
            while(i > 0 && start.from <= changes[i - 1].toA){
                fromA = changes[i - 1].fromA;
                fromB = changes[i - 1].fromB;
                i--;
                if (fromA < start.from) start = me.lineAt(fromA, $7beee9608540d2c3$var$QueryType.ByPosNoHeight, oracle, 0, 0);
            }
            fromB += start.from - fromA;
            fromA = start.from;
            let nodes = $7beee9608540d2c3$var$NodeBuilder.build(oracle.setDoc(doc), decorations, fromB, toB);
            me = me.replace(fromA, toA, nodes);
        }
        return me.updateHeight(oracle, 0);
    }
    static empty() {
        return new $7beee9608540d2c3$var$HeightMapText(0, 0);
    }
    // nodes uses null values to indicate the position of line breaks.
    // There are never line breaks at the start or end of the array, or
    // two line breaks next to each other, and the array isn't allowed
    // to be empty (same restrictions as return value from the builder).
    static of(nodes) {
        if (nodes.length == 1) return nodes[0];
        let i = 0, j = nodes.length, before = 0, after = 0;
        for(;;){
            if (i == j) {
                if (before > after * 2) {
                    let split = nodes[i - 1];
                    if (split.break) nodes.splice(--i, 1, split.left, null, split.right);
                    else nodes.splice(--i, 1, split.left, split.right);
                    j += 1 + split.break;
                    before -= split.size;
                } else if (after > before * 2) {
                    let split = nodes[j];
                    if (split.break) nodes.splice(j, 1, split.left, null, split.right);
                    else nodes.splice(j, 1, split.left, split.right);
                    j += 2 + split.break;
                    after -= split.size;
                } else break;
            } else if (before < after) {
                let next = nodes[i++];
                if (next) before += next.size;
            } else {
                let next = nodes[--j];
                if (next) after += next.size;
            }
        }
        let brk = 0;
        if (nodes[i - 1] == null) {
            brk = 1;
            i--;
        } else if (nodes[i] == null) {
            brk = 1;
            j++;
        }
        return new $7beee9608540d2c3$var$HeightMapBranch($7beee9608540d2c3$var$HeightMap.of(nodes.slice(0, i)), brk, $7beee9608540d2c3$var$HeightMap.of(nodes.slice(j)));
    }
}
$7beee9608540d2c3$var$HeightMap.prototype.size = 1;
class $7beee9608540d2c3$var$HeightMapBlock extends $7beee9608540d2c3$var$HeightMap {
    constructor(length, height, deco){
        super(length, height);
        this.deco = deco;
    }
    blockAt(_height, _oracle, top, offset) {
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.deco || 0);
    }
    lineAt(_value, _type, oracle, top, offset) {
        return this.blockAt(0, oracle, top, offset);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        if (from <= offset + this.length && to >= offset) f(this.blockAt(0, oracle, top, offset));
    }
    updateHeight(oracle, offset = 0, _force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        this.outdated = false;
        return this;
    }
    toString() {
        return `block(${this.length})`;
    }
}
class $7beee9608540d2c3$var$HeightMapText extends $7beee9608540d2c3$var$HeightMapBlock {
    constructor(length, height){
        super(length, height, null);
        this.collapsed = 0; // Amount of collapsed content in the line
        this.widgetHeight = 0; // Maximum inline widget height
        this.breaks = 0; // Number of widget-introduced line breaks on the line
    }
    blockAt(_height, _oracle, top, offset) {
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(offset, this.length, top, this.height, this.breaks);
    }
    replace(_from, _to, nodes) {
        let node = nodes[0];
        if (nodes.length == 1 && (node instanceof $7beee9608540d2c3$var$HeightMapText || node instanceof $7beee9608540d2c3$var$HeightMapGap && node.flags & 4 /* Flag.SingleLine */ ) && Math.abs(this.length - node.length) < 10) {
            if (node instanceof $7beee9608540d2c3$var$HeightMapGap) node = new $7beee9608540d2c3$var$HeightMapText(node.length, this.height);
            else node.height = this.height;
            if (!this.outdated) node.outdated = false;
            return node;
        } else return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        if (measured && measured.from <= offset && measured.more) this.setHeight(oracle, measured.heights[measured.index++]);
        else if (force || this.outdated) this.setHeight(oracle, Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
        this.outdated = false;
        return this;
    }
    toString() {
        return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
}
class $7beee9608540d2c3$var$HeightMapGap extends $7beee9608540d2c3$var$HeightMap {
    constructor(length){
        super(length, 0);
    }
    heightMetrics(oracle, offset) {
        let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
        let lines = lastLine - firstLine + 1;
        let perLine, perChar = 0;
        if (oracle.lineWrapping) {
            let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
            perLine = totalPerLine / lines;
            if (this.length > lines + 1) perChar = (this.height - totalPerLine) / (this.length - lines - 1);
        } else perLine = this.height / lines;
        return {
            firstLine: firstLine,
            lastLine: lastLine,
            perLine: perLine,
            perChar: perChar
        };
    }
    blockAt(height, oracle, top, offset) {
        let { firstLine: firstLine, lastLine: lastLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        if (oracle.lineWrapping) {
            let guess = offset + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top) / this.height)) * this.length));
            let line = oracle.doc.lineAt(guess), lineHeight = perLine + line.length * perChar;
            let lineTop = Math.max(top, height - lineHeight / 2);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0);
        } else {
            let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top) / perLine)));
            let { from: from, length: length } = oracle.doc.line(firstLine + line);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(from, length, top + perLine * line, perLine, 0);
        }
    }
    lineAt(value, type, oracle, top, offset) {
        if (type == $7beee9608540d2c3$var$QueryType.ByHeight) return this.blockAt(value, oracle, top, offset);
        if (type == $7beee9608540d2c3$var$QueryType.ByPosNoHeight) {
            let { from: from, to: to } = oracle.doc.lineAt(value);
            return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(from, to - from, 0, 0, 0);
        }
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        let line = oracle.doc.lineAt(value), lineHeight = perLine + line.length * perChar;
        let linesAbove = line.number - firstLine;
        let lineTop = top + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
        return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, Math.max(top, Math.min(lineTop, top + this.height - lineHeight)), lineHeight, 0);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        from = Math.max(from, offset);
        to = Math.min(to, offset + this.length);
        let { firstLine: firstLine, perLine: perLine, perChar: perChar } = this.heightMetrics(oracle, offset);
        for(let pos = from, lineTop = top; pos <= to;){
            let line = oracle.doc.lineAt(pos);
            if (pos == from) {
                let linesAbove = line.number - firstLine;
                lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
            }
            let lineHeight = perLine + perChar * line.length;
            f(new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(line.from, line.length, lineTop, lineHeight, 0));
            lineTop += lineHeight;
            pos = line.to + 1;
        }
    }
    replace(from, to, nodes) {
        let after = this.length - to;
        if (after > 0) {
            let last = nodes[nodes.length - 1];
            if (last instanceof $7beee9608540d2c3$var$HeightMapGap) nodes[nodes.length - 1] = new $7beee9608540d2c3$var$HeightMapGap(last.length + after);
            else nodes.push(null, new $7beee9608540d2c3$var$HeightMapGap(after - 1));
        }
        if (from > 0) {
            let first = nodes[0];
            if (first instanceof $7beee9608540d2c3$var$HeightMapGap) nodes[0] = new $7beee9608540d2c3$var$HeightMapGap(from + first.length);
            else nodes.unshift(new $7beee9608540d2c3$var$HeightMapGap(from - 1), null);
        }
        return $7beee9608540d2c3$var$HeightMap.of(nodes);
    }
    decomposeLeft(to, result) {
        result.push(new $7beee9608540d2c3$var$HeightMapGap(to - 1), null);
    }
    decomposeRight(from, result) {
        result.push(null, new $7beee9608540d2c3$var$HeightMapGap(this.length - from - 1));
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let end = offset + this.length;
        if (measured && measured.from <= offset + this.length && measured.more) {
            // Fill in part of this gap with measured lines. We know there
            // can't be widgets or collapsed ranges in those lines, because
            // they would already have been added to the heightmap (gaps
            // only contain plain text).
            let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
            if (measured.from > offset) nodes.push(new $7beee9608540d2c3$var$HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
            while(pos <= end && measured.more){
                let len = oracle.doc.lineAt(pos).length;
                if (nodes.length) nodes.push(null);
                let height = measured.heights[measured.index++];
                if (singleHeight == -1) singleHeight = height;
                else if (Math.abs(height - singleHeight) >= $7beee9608540d2c3$var$Epsilon) singleHeight = -2;
                let line = new $7beee9608540d2c3$var$HeightMapText(len, height);
                line.outdated = false;
                nodes.push(line);
                pos += len + 1;
            }
            if (pos <= end) nodes.push(null, new $7beee9608540d2c3$var$HeightMapGap(end - pos).updateHeight(oracle, pos));
            let result = $7beee9608540d2c3$var$HeightMap.of(nodes);
            if (singleHeight < 0 || Math.abs(result.height - this.height) >= $7beee9608540d2c3$var$Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= $7beee9608540d2c3$var$Epsilon) oracle.heightChanged = true;
            return result;
        } else if (force || this.outdated) {
            this.setHeight(oracle, oracle.heightForGap(offset, offset + this.length));
            this.outdated = false;
        }
        return this;
    }
    toString() {
        return `gap(${this.length})`;
    }
}
class $7beee9608540d2c3$var$HeightMapBranch extends $7beee9608540d2c3$var$HeightMap {
    constructor(left, brk, right){
        super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 /* Flag.Outdated */  : 0));
        this.left = left;
        this.right = right;
        this.size = left.size + right.size;
    }
    get break() {
        return this.flags & 1 /* Flag.Break */ ;
    }
    blockAt(height, oracle, top, offset) {
        let mid = top + this.left.height;
        return height < mid ? this.left.blockAt(height, oracle, top, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
    }
    lineAt(value, type, oracle, top, offset) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        let left = type == $7beee9608540d2c3$var$QueryType.ByHeight ? value < rightTop : value < rightOffset;
        let base = left ? this.left.lineAt(value, type, oracle, top, offset) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
        if (this.break || (left ? base.to < rightOffset : base.from > rightOffset)) return base;
        let subQuery = type == $7beee9608540d2c3$var$QueryType.ByPosNoHeight ? $7beee9608540d2c3$var$QueryType.ByPosNoHeight : $7beee9608540d2c3$var$QueryType.ByPos;
        if (left) return base.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
        else return this.left.lineAt(rightOffset, subQuery, oracle, top, offset).join(base);
    }
    forEachLine(from, to, oracle, top, offset, f) {
        let rightTop = top + this.left.height, rightOffset = offset + this.left.length + this.break;
        if (this.break) {
            if (from < rightOffset) this.left.forEachLine(from, to, oracle, top, offset, f);
            if (to >= rightOffset) this.right.forEachLine(from, to, oracle, rightTop, rightOffset, f);
        } else {
            let mid = this.lineAt(rightOffset, $7beee9608540d2c3$var$QueryType.ByPos, oracle, top, offset);
            if (from < mid.from) this.left.forEachLine(from, mid.from - 1, oracle, top, offset, f);
            if (mid.to >= from && mid.from <= to) f(mid);
            if (to > mid.to) this.right.forEachLine(mid.to + 1, to, oracle, rightTop, rightOffset, f);
        }
    }
    replace(from, to, nodes) {
        let rightStart = this.left.length + this.break;
        if (to < rightStart) return this.balanced(this.left.replace(from, to, nodes), this.right);
        if (from > this.left.length) return this.balanced(this.left, this.right.replace(from - rightStart, to - rightStart, nodes));
        let result = [];
        if (from > 0) this.decomposeLeft(from, result);
        let left = result.length;
        for (let node of nodes)result.push(node);
        if (from > 0) $7beee9608540d2c3$var$mergeGaps(result, left - 1);
        if (to < this.length) {
            let right = result.length;
            this.decomposeRight(to, result);
            $7beee9608540d2c3$var$mergeGaps(result, right);
        }
        return $7beee9608540d2c3$var$HeightMap.of(result);
    }
    decomposeLeft(to, result) {
        let left = this.left.length;
        if (to <= left) return this.left.decomposeLeft(to, result);
        result.push(this.left);
        if (this.break) {
            left++;
            if (to >= left) result.push(null);
        }
        if (to > left) this.right.decomposeLeft(to - left, result);
    }
    decomposeRight(from, result) {
        let left = this.left.length, right = left + this.break;
        if (from >= right) return this.right.decomposeRight(from - right, result);
        if (from < left) this.left.decomposeRight(from, result);
        if (this.break && from < right) result.push(null);
        result.push(this.right);
    }
    balanced(left, right) {
        if (left.size > 2 * right.size || right.size > 2 * left.size) return $7beee9608540d2c3$var$HeightMap.of(this.break ? [
            left,
            null,
            right
        ] : [
            left,
            right
        ]);
        this.left = left;
        this.right = right;
        this.height = left.height + right.height;
        this.outdated = left.outdated || right.outdated;
        this.size = left.size + right.size;
        this.length = left.length + this.break + right.length;
        return this;
    }
    updateHeight(oracle, offset = 0, force = false, measured) {
        let { left: left, right: right } = this, rightStart = offset + left.length + this.break, rebalance = null;
        if (measured && measured.from <= offset + left.length && measured.more) rebalance = left = left.updateHeight(oracle, offset, force, measured);
        else left.updateHeight(oracle, offset, force);
        if (measured && measured.from <= rightStart + right.length && measured.more) rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
        else right.updateHeight(oracle, rightStart, force);
        if (rebalance) return this.balanced(left, right);
        this.height = this.left.height + this.right.height;
        this.outdated = false;
        return this;
    }
    toString() {
        return this.left + (this.break ? " " : "-") + this.right;
    }
}
function $7beee9608540d2c3$var$mergeGaps(nodes, around) {
    let before, after;
    if (nodes[around] == null && (before = nodes[around - 1]) instanceof $7beee9608540d2c3$var$HeightMapGap && (after = nodes[around + 1]) instanceof $7beee9608540d2c3$var$HeightMapGap) nodes.splice(around - 1, 3, new $7beee9608540d2c3$var$HeightMapGap(before.length + 1 + after.length));
}
const $7beee9608540d2c3$var$relevantWidgetHeight = 5;
class $7beee9608540d2c3$var$NodeBuilder {
    constructor(pos, oracle){
        this.pos = pos;
        this.oracle = oracle;
        this.nodes = [];
        this.lineStart = -1;
        this.lineEnd = -1;
        this.covering = null;
        this.writtenTo = pos;
    }
    get isCovered() {
        return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(_from, to) {
        if (this.lineStart > -1) {
            let end = Math.min(to, this.lineEnd), last = this.nodes[this.nodes.length - 1];
            if (last instanceof $7beee9608540d2c3$var$HeightMapText) last.length += end - this.pos;
            else if (end > this.pos || !this.isCovered) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(end - this.pos, -1));
            this.writtenTo = end;
            if (to > end) {
                this.nodes.push(null);
                this.writtenTo++;
                this.lineStart = -1;
            }
        }
        this.pos = to;
    }
    point(from, to, deco) {
        if (from < to || deco.heightRelevant) {
            let height = deco.widget ? deco.widget.estimatedHeight : 0;
            let breaks = deco.widget ? deco.widget.lineBreaks : 0;
            if (height < 0) height = this.oracle.lineHeight;
            let len = to - from;
            if (deco.block) this.addBlock(new $7beee9608540d2c3$var$HeightMapBlock(len, height, deco));
            else if (len || breaks || height >= $7beee9608540d2c3$var$relevantWidgetHeight) this.addLineDeco(height, breaks, len);
        } else if (to > from) this.span(from, to);
        if (this.lineEnd > -1 && this.lineEnd < this.pos) this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
    }
    enterLine() {
        if (this.lineStart > -1) return;
        let { from: from, to: to } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = from;
        this.lineEnd = to;
        if (this.writtenTo < from) {
            if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null) this.nodes.push(this.blankContent(this.writtenTo, from - 1));
            this.nodes.push(null);
        }
        if (this.pos > from) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(this.pos - from, -1));
        this.writtenTo = this.pos;
    }
    blankContent(from, to) {
        let gap = new $7beee9608540d2c3$var$HeightMapGap(to - from);
        if (this.oracle.doc.lineAt(from).to == to) gap.flags |= 4 /* Flag.SingleLine */ ;
        return gap;
    }
    ensureLine() {
        this.enterLine();
        let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
        if (last instanceof $7beee9608540d2c3$var$HeightMapText) return last;
        let line = new $7beee9608540d2c3$var$HeightMapText(0, -1);
        this.nodes.push(line);
        return line;
    }
    addBlock(block) {
        this.enterLine();
        let deco = block.deco;
        if (deco && deco.startSide > 0 && !this.isCovered) this.ensureLine();
        this.nodes.push(block);
        this.writtenTo = this.pos = this.pos + block.length;
        if (deco && deco.endSide > 0) this.covering = block;
    }
    addLineDeco(height, breaks, length) {
        let line = this.ensureLine();
        line.length += length;
        line.collapsed += length;
        line.widgetHeight = Math.max(line.widgetHeight, height);
        line.breaks += breaks;
        this.writtenTo = this.pos = this.pos + length;
    }
    finish(from) {
        let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
        if (this.lineStart > -1 && !(last instanceof $7beee9608540d2c3$var$HeightMapText) && !this.isCovered) this.nodes.push(new $7beee9608540d2c3$var$HeightMapText(0, -1));
        else if (this.writtenTo < this.pos || last == null) this.nodes.push(this.blankContent(this.writtenTo, this.pos));
        let pos = from;
        for (let node of this.nodes){
            if (node instanceof $7beee9608540d2c3$var$HeightMapText) node.updateHeight(this.oracle, pos);
            pos += node ? node.length : 1;
        }
        return this.nodes;
    }
    // Always called with a region that on both sides either stretches
    // to a line break or the end of the document.
    // The returned array uses null to indicate line breaks, but never
    // starts or ends in a line break, or has multiple line breaks next
    // to each other.
    static build(oracle, decorations, from, to) {
        let builder = new $7beee9608540d2c3$var$NodeBuilder(from, oracle);
        (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(decorations, from, to, builder, 0);
        return builder.finish(from);
    }
}
function $7beee9608540d2c3$var$heightRelevantDecoChanges(a, b, diff) {
    let comp = new $7beee9608540d2c3$var$DecorationComparator;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).compare(a, b, diff, comp, 0);
    return comp.changes;
}
class $7beee9608540d2c3$var$DecorationComparator {
    constructor(){
        this.changes = [];
    }
    compareRange() {}
    comparePoint(from, to, a, b) {
        if (from < to || a && a.heightRelevant || b && b.heightRelevant) $7beee9608540d2c3$var$addRange(from, to, this.changes, 5);
    }
}
function $7beee9608540d2c3$var$visiblePixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    let doc = dom.ownerDocument, win = doc.defaultView || window;
    let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
    let top = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
    for(let parent = dom.parentNode; parent && parent != doc.body;){
        if (parent.nodeType == 1) {
            let elt = parent;
            let style = window.getComputedStyle(elt);
            if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
                let parentRect = elt.getBoundingClientRect();
                left = Math.max(left, parentRect.left);
                right = Math.min(right, parentRect.right);
                top = Math.max(top, parentRect.top);
                bottom = parent == dom.parentNode ? parentRect.bottom : Math.min(bottom, parentRect.bottom);
            }
            parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
        } else if (parent.nodeType == 11) parent = parent.host;
        else break;
    }
    return {
        left: left - rect.left,
        right: Math.max(left, right) - rect.left,
        top: top - (rect.top + paddingTop),
        bottom: Math.max(top, bottom) - (rect.top + paddingTop)
    };
}
function $7beee9608540d2c3$var$fullPixelRange(dom, paddingTop) {
    let rect = dom.getBoundingClientRect();
    return {
        left: 0,
        right: rect.right - rect.left,
        top: paddingTop,
        bottom: rect.bottom - (rect.top + paddingTop)
    };
}
// Line gaps are placeholder widgets used to hide pieces of overlong
// lines within the viewport, as a kludge to keep the editor
// responsive when a ridiculously long line is loaded into it.
class $7beee9608540d2c3$var$LineGap {
    constructor(from, to, size){
        this.from = from;
        this.to = to;
        this.size = size;
    }
    static same(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++){
            let gA = a[i], gB = b[i];
            if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size) return false;
        }
        return true;
    }
    draw(viewState, wrapping) {
        return $7beee9608540d2c3$export$10e30b733df217ea.replace({
            widget: new $7beee9608540d2c3$var$LineGapWidget(this.size * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
        }).range(this.from, this.to);
    }
}
class $7beee9608540d2c3$var$LineGapWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(size, vertical){
        super();
        this.size = size;
        this.vertical = vertical;
    }
    eq(other) {
        return other.size == this.size && other.vertical == this.vertical;
    }
    toDOM() {
        let elt = document.createElement("div");
        if (this.vertical) elt.style.height = this.size + "px";
        else {
            elt.style.width = this.size + "px";
            elt.style.height = "2px";
            elt.style.display = "inline-block";
        }
        return elt;
    }
    get estimatedHeight() {
        return this.vertical ? this.size : -1;
    }
}
class $7beee9608540d2c3$var$ViewState {
    constructor(state){
        this.state = state;
        // These are contentDOM-local coordinates
        this.pixelViewport = {
            left: 0,
            right: window.innerWidth,
            top: 0,
            bottom: 0
        };
        this.inView = true;
        this.paddingTop = 0; // Padding above the document, scaled
        this.paddingBottom = 0; // Padding below the document, scaled
        this.contentDOMWidth = 0; // contentDOM.getBoundingClientRect().width
        this.contentDOMHeight = 0; // contentDOM.getBoundingClientRect().height
        this.editorHeight = 0; // scrollDOM.clientHeight, unscaled
        this.editorWidth = 0; // scrollDOM.clientWidth, unscaled
        this.scrollTop = 0; // Last seen scrollDOM.scrollTop, scaled
        this.scrolledToBottom = false;
        // The CSS-transformation scale of the editor (transformed size /
        // concrete size)
        this.scaleX = 1;
        this.scaleY = 1;
        // The vertical position (document-relative) to which to anchor the
        // scroll position. -1 means anchor to the end of the document.
        this.scrollAnchorPos = 0;
        // The height at the anchor position. Set by the DOM update phase.
        // -1 means no height available.
        this.scrollAnchorHeight = -1;
        // See VP.MaxDOMHeight
        this.scaler = $7beee9608540d2c3$var$IdScaler;
        this.scrollTarget = null;
        // Briefly set to true when printing, to disable viewport limiting
        this.printing = false;
        // Flag set when editor content was redrawn, so that the next
        // measure stage knows it must read DOM layout
        this.mustMeasureContent = true;
        this.defaultTextDirection = $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        this.visibleRanges = [];
        // Cursor 'assoc' is only significant when the cursor is on a line
        // wrap point, where it must stick to the character that it is
        // associated with. Since browsers don't provide a reasonable
        // interface to set or query this, when a selection is set that
        // might cause this to be significant, this flag is set. The next
        // measure phase will check whether the cursor is on a line-wrapping
        // boundary and, if so, reset it to make sure it is positioned in
        // the right place.
        this.mustEnforceCursorAssoc = false;
        let guessWrapping = state.facet($7beee9608540d2c3$var$contentAttributes).some((v)=>typeof v != "function" && v.class == "cm-lineWrapping");
        this.heightOracle = new $7beee9608540d2c3$var$HeightOracle(guessWrapping);
        this.stateDeco = state.facet($7beee9608540d2c3$var$decorations).filter((d)=>typeof d != "function");
        this.heightMap = $7beee9608540d2c3$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty, this.heightOracle.setDoc(state.doc), [
            new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, state.doc.length)
        ]);
        for(let i = 0; i < 2; i++){
            this.viewport = this.getViewport(0, null);
            if (!this.updateForViewport()) break;
        }
        this.updateViewportLines();
        this.lineGaps = this.ensureLineGaps([]);
        this.lineGapDeco = $7beee9608540d2c3$export$10e30b733df217ea.set(this.lineGaps.map((gap)=>gap.draw(this, false)));
        this.computeVisibleRanges();
    }
    updateForViewport() {
        let viewports = [
            this.viewport
        ], { main: main } = this.state.selection;
        for(let i = 0; i <= 1; i++){
            let pos = i ? main.head : main.anchor;
            if (!viewports.some(({ from: from, to: to })=>pos >= from && pos <= to)) {
                let { from: from, to: to } = this.lineBlockAt(pos);
                viewports.push(new $7beee9608540d2c3$var$Viewport(from, to));
            }
        }
        this.viewports = viewports.sort((a, b)=>a.from - b.from);
        return this.updateScaler();
    }
    updateScaler() {
        let scaler = this.scaler;
        this.scaler = this.heightMap.height <= 7000000 /* VP.MaxDOMHeight */  ? $7beee9608540d2c3$var$IdScaler : new $7beee9608540d2c3$var$BigScaler(this.heightOracle, this.heightMap, this.viewports);
        return scaler.eq(this.scaler) ? 0 : 2 /* UpdateFlag.Height */ ;
    }
    updateViewportLines() {
        this.viewportLines = [];
        this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block)=>{
            this.viewportLines.push($7beee9608540d2c3$var$scaleBlock(block, this.scaler));
        });
    }
    update(update, scrollTarget = null) {
        this.state = update.state;
        let prevDeco = this.stateDeco;
        this.stateDeco = this.state.facet($7beee9608540d2c3$var$decorations).filter((d)=>typeof d != "function");
        let contentChanges = update.changedRanges;
        let heightChanges = $7beee9608540d2c3$var$ChangedRange.extendWithRanges(contentChanges, $7beee9608540d2c3$var$heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).empty(this.state.doc.length)));
        let prevHeight = this.heightMap.height;
        let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
        this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
        if (this.heightMap.height != prevHeight) update.flags |= 2 /* UpdateFlag.Height */ ;
        if (scrollAnchor) {
            this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
            this.scrollAnchorHeight = scrollAnchor.top;
        } else {
            this.scrollAnchorPos = -1;
            this.scrollAnchorHeight = this.heightMap.height;
        }
        let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
        if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport)) viewport = this.getViewport(0, scrollTarget);
        let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
        this.viewport = viewport;
        update.flags |= this.updateForViewport();
        if (viewportChange || !update.changes.empty || update.flags & 2 /* UpdateFlag.Height */ ) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
        update.flags |= this.computeVisibleRanges();
        if (scrollTarget) this.scrollTarget = scrollTarget;
        if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet($7beee9608540d2c3$var$nativeSelectionHidden)) this.mustEnforceCursorAssoc = true;
    }
    measure(view) {
        let dom = view.contentDOM, style = window.getComputedStyle(dom);
        let oracle = this.heightOracle;
        let whiteSpace = style.whiteSpace;
        this.defaultTextDirection = style.direction == "rtl" ? $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
        let domRect = dom.getBoundingClientRect();
        let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
        this.contentDOMHeight = domRect.height;
        this.mustMeasureContent = false;
        let result = 0, bias = 0;
        if (domRect.width && domRect.height) {
            let { scaleX: scaleX, scaleY: scaleY } = $7beee9608540d2c3$var$getScale(dom, domRect);
            if (scaleX > .005 && Math.abs(this.scaleX - scaleX) > .005 || scaleY > .005 && Math.abs(this.scaleY - scaleY) > .005) {
                this.scaleX = scaleX;
                this.scaleY = scaleY;
                result |= 8 /* UpdateFlag.Geometry */ ;
                refresh = measureContent = true;
            }
        }
        // Vertical padding
        let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
        let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
        if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
            this.paddingTop = paddingTop;
            this.paddingBottom = paddingBottom;
            result |= 10 /* UpdateFlag.Height */ ;
        }
        if (this.editorWidth != view.scrollDOM.clientWidth) {
            if (oracle.lineWrapping) measureContent = true;
            this.editorWidth = view.scrollDOM.clientWidth;
            result |= 8 /* UpdateFlag.Geometry */ ;
        }
        let scrollTop = view.scrollDOM.scrollTop * this.scaleY;
        if (this.scrollTop != scrollTop) {
            this.scrollAnchorHeight = -1;
            this.scrollTop = scrollTop;
        }
        this.scrolledToBottom = $7beee9608540d2c3$var$isScrolledToBottom(view.scrollDOM);
        // Pixel viewport
        let pixelViewport = (this.printing ? $7beee9608540d2c3$var$fullPixelRange : $7beee9608540d2c3$var$visiblePixelRange)(dom, this.paddingTop);
        let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
        this.pixelViewport = pixelViewport;
        let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
        if (inView != this.inView) {
            this.inView = inView;
            if (inView) measureContent = true;
        }
        if (!this.inView && !this.scrollTarget) return 0;
        let contentWidth = domRect.width;
        if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
            this.contentDOMWidth = domRect.width;
            this.editorHeight = view.scrollDOM.clientHeight;
            result |= 8 /* UpdateFlag.Geometry */ ;
        }
        if (measureContent) {
            let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
            if (oracle.mustRefreshForHeights(lineHeights)) refresh = true;
            if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
                let { lineHeight: lineHeight, charWidth: charWidth, textHeight: textHeight } = view.docView.measureTextSize();
                refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, contentWidth / charWidth, lineHeights);
                if (refresh) {
                    view.docView.minWidth = 0;
                    result |= 8 /* UpdateFlag.Geometry */ ;
                }
            }
            if (dTop > 0 && dBottom > 0) bias = Math.max(dTop, dBottom);
            else if (dTop < 0 && dBottom < 0) bias = Math.min(dTop, dBottom);
            oracle.heightChanged = false;
            for (let vp of this.viewports){
                let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
                this.heightMap = (refresh ? $7beee9608540d2c3$var$HeightMap.empty().applyChanges(this.stateDeco, (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).empty, this.heightOracle, [
                    new $7beee9608540d2c3$var$ChangedRange(0, 0, 0, view.state.doc.length)
                ]) : this.heightMap).updateHeight(oracle, 0, refresh, new $7beee9608540d2c3$var$MeasuredHeights(vp.from, heights));
            }
            if (oracle.heightChanged) result |= 2 /* UpdateFlag.Height */ ;
        }
        let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
        if (viewportChange) {
            if (result & 2 /* UpdateFlag.Height */ ) result |= this.updateScaler();
            this.viewport = this.getViewport(bias, this.scrollTarget);
            result |= this.updateForViewport();
        }
        if (result & 2 /* UpdateFlag.Height */  || viewportChange) this.updateViewportLines();
        if (this.lineGaps.length || this.viewport.to - this.viewport.from > 4000) this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
        result |= this.computeVisibleRanges();
        if (this.mustEnforceCursorAssoc) {
            this.mustEnforceCursorAssoc = false;
            // This is done in the read stage, because moving the selection
            // to a line end is going to trigger a layout anyway, so it
            // can't be a pure write. It should be rare that it does any
            // writing.
            view.docView.enforceCursorAssoc();
        }
        return result;
    }
    get visibleTop() {
        return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
        return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(bias, scrollTarget) {
        // This will divide VP.Margin between the top and the
        // bottom, depending on the bias (the change in viewport position
        // since the last update). It'll hold a number between 0 and 1
        let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1000 /* VP.Margin */  / 2));
        let map = this.heightMap, oracle = this.heightOracle;
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        let viewport = new $7beee9608540d2c3$var$Viewport(map.lineAt(visibleTop - marginTop * 1000 /* VP.Margin */ , $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(visibleBottom + (1 - marginTop) * 1000 /* VP.Margin */ , $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).to);
        // If scrollTarget is given, make sure the viewport includes that position
        if (scrollTarget) {
            let { head: head } = scrollTarget.range;
            if (head < viewport.from || head > viewport.to) {
                let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
                let block = map.lineAt(head, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0), topPos;
                if (scrollTarget.y == "center") topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
                else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from) topPos = block.top;
                else topPos = block.bottom - viewHeight;
                viewport = new $7beee9608540d2c3$var$Viewport(map.lineAt(topPos - 500, $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).from, map.lineAt(topPos + viewHeight + 500, $7beee9608540d2c3$var$QueryType.ByHeight, oracle, 0, 0).to);
            }
        }
        return viewport;
    }
    mapViewport(viewport, changes) {
        let from = changes.mapPos(viewport.from, -1), to = changes.mapPos(viewport.to, 1);
        return new $7beee9608540d2c3$var$Viewport(this.heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0).to);
    }
    // Checks if a given viewport covers the visible part of the
    // document and not too much beyond that.
    viewportIsAppropriate({ from: from, to: to }, bias = 0) {
        if (!this.inView) return true;
        let { top: top } = this.heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { bottom: bottom } = this.heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0);
        let { visibleTop: visibleTop, visibleBottom: visibleBottom } = this;
        return (from == 0 || top <= visibleTop - Math.max(10 /* VP.MinCoverMargin */ , Math.min(-bias, 250 /* VP.MaxCoverMargin */ ))) && (to == this.state.doc.length || bottom >= visibleBottom + Math.max(10 /* VP.MinCoverMargin */ , Math.min(bias, 250 /* VP.MaxCoverMargin */ ))) && top > visibleTop - 2000 /* VP.Margin */  && bottom < visibleBottom + 2000 /* VP.Margin */ ;
    }
    mapLineGaps(gaps, changes) {
        if (!gaps.length || changes.empty) return gaps;
        let mapped = [];
        for (let gap of gaps)if (!changes.touchesRange(gap.from, gap.to)) mapped.push(new $7beee9608540d2c3$var$LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size));
        return mapped;
    }
    // Computes positions in the viewport where the start or end of a
    // line should be hidden, trying to reuse existing line gaps when
    // appropriate to avoid unneccesary redraws.
    // Uses crude character-counting for the positioning and sizing,
    // since actual DOM coordinates aren't always available and
    // predictable. Relies on generous margins (see LG.Margin) to hide
    // the artifacts this might produce from the user.
    ensureLineGaps(current, mayMeasure) {
        let wrapping = this.heightOracle.lineWrapping;
        let margin = wrapping ? 10000 /* LG.MarginWrap */  : 2000 /* LG.Margin */ , halfMargin = margin >> 1, doubleMargin = margin << 1;
        // The non-wrapping logic won't work at all in predominantly right-to-left text.
        if (this.defaultTextDirection != $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR && !wrapping) return [];
        let gaps = [];
        let addGap = (from, to, line, structure)=>{
            if (to - from < halfMargin) return;
            let sel = this.state.selection.main, avoid = [
                sel.from
            ];
            if (!sel.empty) avoid.push(sel.to);
            for (let pos of avoid)if (pos > from && pos < to) {
                addGap(from, pos - 10 /* LG.SelectionMargin */ , line, structure);
                addGap(pos + 10 /* LG.SelectionMargin */ , to, line, structure);
                return;
            }
            let gap = $7beee9608540d2c3$var$find(current, (gap)=>gap.from >= line.from && gap.to <= line.to && Math.abs(gap.from - from) < halfMargin && Math.abs(gap.to - to) < halfMargin && !avoid.some((pos)=>gap.from < pos && gap.to > pos));
            if (!gap) {
                // When scrolling down, snap gap ends to line starts to avoid shifts in wrapping
                if (to < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r)=>r.from <= to && r.to >= to)) {
                    let lineStart = mayMeasure.moveToLineBoundary((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(to), false, true).head;
                    if (lineStart > from) to = lineStart;
                }
                gap = new $7beee9608540d2c3$var$LineGap(from, to, this.gapSize(line, from, to, structure));
            }
            gaps.push(gap);
        };
        let checkLine = (line)=>{
            if (line.length < doubleMargin || line.type != $7beee9608540d2c3$export$48808c686fe495c4.Text) return;
            let structure = $7beee9608540d2c3$var$lineStructure(line.from, line.to, this.stateDeco);
            if (structure.total < doubleMargin) return;
            let target = this.scrollTarget ? this.scrollTarget.range.head : null;
            let viewFrom, viewTo;
            if (wrapping) {
                let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
                let top, bot;
                if (target != null) {
                    let targetFrac = $7beee9608540d2c3$var$findFraction(structure, target);
                    let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
                    top = targetFrac - spaceFrac;
                    bot = targetFrac + spaceFrac;
                } else {
                    top = (this.visibleTop - line.top - marginHeight) / line.height;
                    bot = (this.visibleBottom - line.top + marginHeight) / line.height;
                }
                viewFrom = $7beee9608540d2c3$var$findPosition(structure, top);
                viewTo = $7beee9608540d2c3$var$findPosition(structure, bot);
            } else {
                let totalWidth = structure.total * this.heightOracle.charWidth;
                let marginWidth = margin * this.heightOracle.charWidth;
                let left, right;
                if (target != null) {
                    let targetFrac = $7beee9608540d2c3$var$findFraction(structure, target);
                    let spaceFrac = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + marginWidth) / totalWidth;
                    left = targetFrac - spaceFrac;
                    right = targetFrac + spaceFrac;
                } else {
                    left = (this.pixelViewport.left - marginWidth) / totalWidth;
                    right = (this.pixelViewport.right + marginWidth) / totalWidth;
                }
                viewFrom = $7beee9608540d2c3$var$findPosition(structure, left);
                viewTo = $7beee9608540d2c3$var$findPosition(structure, right);
            }
            if (viewFrom > line.from) addGap(line.from, viewFrom, line, structure);
            if (viewTo < line.to) addGap(viewTo, line.to, line, structure);
        };
        for (let line of this.viewportLines)if (Array.isArray(line.type)) line.type.forEach(checkLine);
        else checkLine(line);
        return gaps;
    }
    gapSize(line, from, to, structure) {
        let fraction = $7beee9608540d2c3$var$findFraction(structure, to) - $7beee9608540d2c3$var$findFraction(structure, from);
        if (this.heightOracle.lineWrapping) return line.height * fraction;
        else return structure.total * this.heightOracle.charWidth * fraction;
    }
    updateLineGaps(gaps) {
        if (!$7beee9608540d2c3$var$LineGap.same(gaps, this.lineGaps)) {
            this.lineGaps = gaps;
            this.lineGapDeco = $7beee9608540d2c3$export$10e30b733df217ea.set(gaps.map((gap)=>gap.draw(this, this.heightOracle.lineWrapping)));
        }
    }
    computeVisibleRanges() {
        let deco = this.stateDeco;
        if (this.lineGaps.length) deco = deco.concat(this.lineGapDeco);
        let ranges = [];
        (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(deco, this.viewport.from, this.viewport.to, {
            span (from, to) {
                ranges.push({
                    from: from,
                    to: to
                });
            },
            point () {}
        }, 20);
        let changed = ranges.length != this.visibleRanges.length || this.visibleRanges.some((r, i)=>r.from != ranges[i].from || r.to != ranges[i].to);
        this.visibleRanges = ranges;
        return changed ? 4 /* UpdateFlag.Viewport */  : 0;
    }
    lineBlockAt(pos) {
        return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b)=>b.from <= pos && b.to >= pos) || $7beee9608540d2c3$var$scaleBlock(this.heightMap.lineAt(pos, $7beee9608540d2c3$var$QueryType.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(height) {
        return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l)=>l.top <= height && l.bottom >= height) || $7beee9608540d2c3$var$scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), $7beee9608540d2c3$var$QueryType.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    scrollAnchorAt(scrollTop) {
        let block = this.lineBlockAtHeight(scrollTop + 8);
        return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
    }
    elementAtHeight(height) {
        return $7beee9608540d2c3$var$scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
    }
    get docHeight() {
        return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
        return this.docHeight + this.paddingTop + this.paddingBottom;
    }
}
class $7beee9608540d2c3$var$Viewport {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
function $7beee9608540d2c3$var$lineStructure(from, to, stateDeco) {
    let ranges = [], pos = from, total = 0;
    (0, $6295c6875f57e3ee$export$34cb5241245008dd).spans(stateDeco, from, to, {
        span () {},
        point (from, to) {
            if (from > pos) {
                ranges.push({
                    from: pos,
                    to: from
                });
                total += from - pos;
            }
            pos = to;
        }
    }, 20); // We're only interested in collapsed ranges of a significant size
    if (pos < to) {
        ranges.push({
            from: pos,
            to: to
        });
        total += to - pos;
    }
    return {
        total: total,
        ranges: ranges
    };
}
function $7beee9608540d2c3$var$findPosition({ total: total, ranges: ranges }, ratio) {
    if (ratio <= 0) return ranges[0].from;
    if (ratio >= 1) return ranges[ranges.length - 1].to;
    let dist = Math.floor(total * ratio);
    for(let i = 0;; i++){
        let { from: from, to: to } = ranges[i], size = to - from;
        if (dist <= size) return from + dist;
        dist -= size;
    }
}
function $7beee9608540d2c3$var$findFraction(structure, pos) {
    let counted = 0;
    for (let { from: from, to: to } of structure.ranges){
        if (pos <= to) {
            counted += pos - from;
            break;
        }
        counted += to - from;
    }
    return counted / structure.total;
}
function $7beee9608540d2c3$var$find(array, f) {
    for (let val of array)if (f(val)) return val;
    return undefined;
}
// Don't scale when the document height is within the range of what
// the DOM can handle.
const $7beee9608540d2c3$var$IdScaler = {
    toDOM (n) {
        return n;
    },
    fromDOM (n) {
        return n;
    },
    scale: 1,
    eq (other) {
        return other == this;
    }
};
// When the height is too big (> VP.MaxDOMHeight), scale down the
// regions outside the viewports so that the total height is
// VP.MaxDOMHeight.
class $7beee9608540d2c3$var$BigScaler {
    constructor(oracle, heightMap, viewports){
        let vpHeight = 0, base = 0, domBase = 0;
        this.viewports = viewports.map(({ from: from, to: to })=>{
            let top = heightMap.lineAt(from, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0).top;
            let bottom = heightMap.lineAt(to, $7beee9608540d2c3$var$QueryType.ByPos, oracle, 0, 0).bottom;
            vpHeight += bottom - top;
            return {
                from: from,
                to: to,
                top: top,
                bottom: bottom,
                domTop: 0,
                domBottom: 0
            };
        });
        this.scale = (7000000 /* VP.MaxDOMHeight */  - vpHeight) / (heightMap.height - vpHeight);
        for (let obj of this.viewports){
            obj.domTop = domBase + (obj.top - base) * this.scale;
            domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
            base = obj.bottom;
        }
    }
    toDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.top) return domBase + (n - base) * this.scale;
            if (n <= vp.bottom) return vp.domTop + (n - vp.top);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    fromDOM(n) {
        for(let i = 0, base = 0, domBase = 0;; i++){
            let vp = i < this.viewports.length ? this.viewports[i] : null;
            if (!vp || n < vp.domTop) return base + (n - domBase) / this.scale;
            if (n <= vp.domBottom) return vp.top + (n - vp.domTop);
            base = vp.bottom;
            domBase = vp.domBottom;
        }
    }
    eq(other) {
        if (!(other instanceof $7beee9608540d2c3$var$BigScaler)) return false;
        return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i)=>vp.from == other.viewports[i].from && vp.to == other.viewports[i].to);
    }
}
function $7beee9608540d2c3$var$scaleBlock(block, scaler) {
    if (scaler.scale == 1) return block;
    let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
    return new $7beee9608540d2c3$export$ddfdc4ccfe9512bd(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b)=>$7beee9608540d2c3$var$scaleBlock(b, scaler)) : block._content);
}
const $7beee9608540d2c3$var$theme = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (strs)=>strs.join(" ")
});
const $7beee9608540d2c3$var$darkTheme = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.indexOf(true) > -1
});
const $7beee9608540d2c3$var$baseThemeID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName(), $7beee9608540d2c3$var$baseLightID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName(), $7beee9608540d2c3$var$baseDarkID = /*@__PURE__*/ (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
const $7beee9608540d2c3$var$lightDarkIDs = {
    "&light": "." + $7beee9608540d2c3$var$baseLightID,
    "&dark": "." + $7beee9608540d2c3$var$baseDarkID
};
function $7beee9608540d2c3$var$buildTheme(main, spec, scopes) {
    return new (0, $afd7c6da9f842a17$export$b920c662d2efee20)(spec, {
        finish (sel) {
            return /&/.test(sel) ? sel.replace(/&\w*/, (m)=>{
                if (m == "&") return main;
                if (!scopes || !scopes[m]) throw new RangeError(`Unsupported selector: ${m}`);
                return scopes[m];
            }) : main + " " + sel;
        }
    });
}
const $7beee9608540d2c3$var$baseTheme$1 = /*@__PURE__*/ $7beee9608540d2c3$var$buildTheme("." + $7beee9608540d2c3$var$baseThemeID, {
    "&": {
        position: "relative !important",
        boxSizing: "border-box",
        "&.cm-focused": {
            // Provide a simple default outline to make sure a focused
            // editor is visually distinct. Can't leave the default behavior
            // because that will apply to the content element, which is
            // inside the scrollable container and doesn't include the
            // gutters. We also can't use an 'auto' outline, since those
            // are, for some reason, drawn behind the element content, which
            // will cause things like the active line background to cover
            // the outline (#297).
            outline: "1px dotted #212121"
        },
        display: "flex !important",
        flexDirection: "column"
    },
    ".cm-scroller": {
        display: "flex !important",
        alignItems: "flex-start !important",
        fontFamily: "monospace",
        lineHeight: 1.4,
        height: "100%",
        overflowX: "auto",
        position: "relative",
        zIndex: 0
    },
    ".cm-content": {
        margin: 0,
        flexGrow: 2,
        flexShrink: 0,
        display: "block",
        whiteSpace: "pre",
        wordWrap: "normal",
        boxSizing: "border-box",
        minHeight: "100%",
        padding: "4px 0",
        outline: "none",
        "&[contenteditable=true]": {
            WebkitUserModify: "read-write-plaintext-only"
        }
    },
    ".cm-lineWrapping": {
        whiteSpace_fallback: "pre-wrap",
        whiteSpace: "break-spaces",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        flexShrink: 1
    },
    "&light .cm-content": {
        caretColor: "black"
    },
    "&dark .cm-content": {
        caretColor: "white"
    },
    ".cm-line": {
        display: "block",
        padding: "0 2px 0 6px"
    },
    ".cm-layer": {
        position: "absolute",
        left: 0,
        top: 0,
        contain: "size style",
        "& > *": {
            position: "absolute"
        }
    },
    "&light .cm-selectionBackground": {
        background: "#d9d9d9"
    },
    "&dark .cm-selectionBackground": {
        background: "#222"
    },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#d7d4f0"
    },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
        background: "#233"
    },
    ".cm-cursorLayer": {
        pointerEvents: "none"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
        animation: "steps(1) cm-blink 1.2s infinite"
    },
    // Two animations defined so that we can switch between them to
    // restart the animation without forcing another style
    // recomputation.
    "@keyframes cm-blink": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    "@keyframes cm-blink2": {
        "0%": {},
        "50%": {
            opacity: 0
        },
        "100%": {}
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeft: "1.2px solid black",
        marginLeft: "-0.6px",
        pointerEvents: "none"
    },
    ".cm-cursor": {
        display: "none"
    },
    "&dark .cm-cursor": {
        borderLeftColor: "#444"
    },
    ".cm-dropCursor": {
        position: "absolute"
    },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
        display: "block"
    },
    ".cm-iso": {
        unicodeBidi: "isolate"
    },
    ".cm-announced": {
        position: "fixed",
        top: "-10000px"
    },
    "@media print": {
        ".cm-announced": {
            display: "none"
        }
    },
    "&light .cm-activeLine": {
        backgroundColor: "#cceeff44"
    },
    "&dark .cm-activeLine": {
        backgroundColor: "#99eeff33"
    },
    "&light .cm-specialChar": {
        color: "red"
    },
    "&dark .cm-specialChar": {
        color: "#f78"
    },
    ".cm-gutters": {
        flexShrink: 0,
        display: "flex",
        height: "100%",
        boxSizing: "border-box",
        insetInlineStart: 0,
        zIndex: 200
    },
    "&light .cm-gutters": {
        backgroundColor: "#f5f5f5",
        color: "#6c6c6c",
        borderRight: "1px solid #ddd"
    },
    "&dark .cm-gutters": {
        backgroundColor: "#333338",
        color: "#ccc"
    },
    ".cm-gutter": {
        display: "flex !important",
        flexDirection: "column",
        flexShrink: 0,
        boxSizing: "border-box",
        minHeight: "100%",
        overflow: "hidden"
    },
    ".cm-gutterElement": {
        boxSizing: "border-box"
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 3px 0 5px",
        minWidth: "20px",
        textAlign: "right",
        whiteSpace: "nowrap"
    },
    "&light .cm-activeLineGutter": {
        backgroundColor: "#e2f2ff"
    },
    "&dark .cm-activeLineGutter": {
        backgroundColor: "#222227"
    },
    ".cm-panels": {
        boxSizing: "border-box",
        position: "sticky",
        left: 0,
        right: 0
    },
    "&light .cm-panels": {
        backgroundColor: "#f5f5f5",
        color: "black"
    },
    "&light .cm-panels-top": {
        borderBottom: "1px solid #ddd"
    },
    "&light .cm-panels-bottom": {
        borderTop: "1px solid #ddd"
    },
    "&dark .cm-panels": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tab": {
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom"
    },
    ".cm-widgetBuffer": {
        verticalAlign: "text-top",
        height: "1em",
        width: 0,
        display: "inline"
    },
    ".cm-placeholder": {
        color: "#888",
        display: "inline-block",
        verticalAlign: "top"
    },
    ".cm-highlightSpace:before": {
        content: "attr(data-display)",
        position: "absolute",
        pointerEvents: "none",
        color: "#888"
    },
    ".cm-highlightTab": {
        backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
        backgroundSize: "auto 100%",
        backgroundPosition: "right 90%",
        backgroundRepeat: "no-repeat"
    },
    ".cm-trailingSpace": {
        backgroundColor: "#ff332255"
    },
    ".cm-button": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        padding: ".2em 1em",
        borderRadius: "1px"
    },
    "&light .cm-button": {
        backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
        }
    },
    "&dark .cm-button": {
        backgroundImage: "linear-gradient(#393939, #111)",
        border: "1px solid #888",
        "&:active": {
            backgroundImage: "linear-gradient(#111, #333)"
        }
    },
    ".cm-textfield": {
        verticalAlign: "middle",
        color: "inherit",
        fontSize: "70%",
        border: "1px solid silver",
        padding: ".2em .5em"
    },
    "&light .cm-textfield": {
        backgroundColor: "white"
    },
    "&dark .cm-textfield": {
        border: "1px solid #555",
        backgroundColor: "inherit"
    }
}, $7beee9608540d2c3$var$lightDarkIDs);
const $7beee9608540d2c3$var$LineBreakPlaceholder = "\uFFFF";
class $7beee9608540d2c3$var$DOMReader {
    constructor(points, state){
        this.points = points;
        this.text = "";
        this.lineSeparator = state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).lineSeparator);
    }
    append(text) {
        this.text += text;
    }
    lineBreak() {
        this.text += $7beee9608540d2c3$var$LineBreakPlaceholder;
    }
    readRange(start, end) {
        if (!start) return this;
        let parent = start.parentNode;
        for(let cur = start;;){
            this.findPointBefore(parent, cur);
            let oldLen = this.text.length;
            this.readNode(cur);
            let next = cur.nextSibling;
            if (next == end) break;
            let view = $7beee9608540d2c3$var$ContentView.get(cur), nextView = $7beee9608540d2c3$var$ContentView.get(next);
            if (view && nextView ? view.breakAfter : (view ? view.breakAfter : $7beee9608540d2c3$var$isBlockElement(cur)) || $7beee9608540d2c3$var$isBlockElement(next) && (cur.nodeName != "BR" || cur.cmIgnore) && this.text.length > oldLen) this.lineBreak();
            cur = next;
        }
        this.findPointBefore(parent, end);
        return this;
    }
    readTextNode(node) {
        let text = node.nodeValue;
        for (let point of this.points)if (point.node == node) point.pos = this.text.length + Math.min(point.offset, text.length);
        for(let off = 0, re = this.lineSeparator ? null : /\r\n?|\n/g;;){
            let nextBreak = -1, breakSize = 1, m;
            if (this.lineSeparator) {
                nextBreak = text.indexOf(this.lineSeparator, off);
                breakSize = this.lineSeparator.length;
            } else if (m = re.exec(text)) {
                nextBreak = m.index;
                breakSize = m[0].length;
            }
            this.append(text.slice(off, nextBreak < 0 ? text.length : nextBreak));
            if (nextBreak < 0) break;
            this.lineBreak();
            if (breakSize > 1) {
                for (let point of this.points)if (point.node == node && point.pos > this.text.length) point.pos -= breakSize - 1;
            }
            off = nextBreak + breakSize;
        }
    }
    readNode(node) {
        if (node.cmIgnore) return;
        let view = $7beee9608540d2c3$var$ContentView.get(node);
        let fromView = view && view.overrideDOMText;
        if (fromView != null) {
            this.findPointInside(node, fromView.length);
            for(let i = fromView.iter(); !i.next().done;)if (i.lineBreak) this.lineBreak();
            else this.append(i.value);
        } else if (node.nodeType == 3) this.readTextNode(node);
        else if (node.nodeName == "BR") {
            if (node.nextSibling) this.lineBreak();
        } else if (node.nodeType == 1) this.readRange(node.firstChild, null);
    }
    findPointBefore(node, next) {
        for (let point of this.points)if (point.node == node && node.childNodes[point.offset] == next) point.pos = this.text.length;
    }
    findPointInside(node, length) {
        for (let point of this.points)if (node.nodeType == 3 ? point.node == node : node.contains(point.node)) point.pos = this.text.length + ($7beee9608540d2c3$var$isAtEnd(node, point.node, point.offset) ? length : 0);
    }
}
function $7beee9608540d2c3$var$isAtEnd(parent, node, offset) {
    for(;;){
        if (!node || offset < $7beee9608540d2c3$var$maxOffset(node)) return false;
        if (node == parent) return true;
        offset = $7beee9608540d2c3$var$domIndex(node) + 1;
        node = node.parentNode;
    }
}
class $7beee9608540d2c3$var$DOMPoint {
    constructor(node, offset){
        this.node = node;
        this.offset = offset;
        this.pos = -1;
    }
}
class $7beee9608540d2c3$var$DOMChange {
    constructor(view, start, end, typeOver){
        this.typeOver = typeOver;
        this.bounds = null;
        this.text = "";
        this.domChanged = start > -1;
        let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
        if (view.state.readOnly && start > -1) // Ignore changes when the editor is read-only
        this.newSel = null;
        else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
            let selPoints = iHead || iAnchor ? [] : $7beee9608540d2c3$var$selectionPoints(view);
            let reader = new $7beee9608540d2c3$var$DOMReader(selPoints, view.state);
            reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
            this.text = reader.text;
            this.newSel = $7beee9608540d2c3$var$selectionFromPoints(selPoints, this.bounds.from);
        } else {
            let domSel = view.observer.selectionRange;
            let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !$7beee9608540d2c3$var$contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
            let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !$7beee9608540d2c3$var$contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
            // iOS will refuse to select the block gaps when doing
            // select-all.
            // Chrome will put the selection *inside* them, confusing
            // posFromDOM
            let vp = view.viewport;
            if (($7beee9608540d2c3$var$browser.ios || $7beee9608540d2c3$var$browser.chrome) && view.state.selection.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
                let from = Math.min(head, anchor), to = Math.max(head, anchor);
                let offFrom = vp.from - from, offTo = vp.to - to;
                if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to == view.state.doc.length)) {
                    head = 0;
                    anchor = view.state.doc.length;
                }
            }
            this.newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(anchor, head);
        }
    }
}
function $7beee9608540d2c3$var$applyDOMChange(view, domChange) {
    let change;
    let { newSel: newSel } = domChange, sel = view.state.selection.main;
    let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
    if (domChange.bounds) {
        let { from: from, to: to } = domChange.bounds;
        let preferredPos = sel.from, preferredSide = null;
        // Prefer anchoring to end when Backspace is pressed (or, on
        // Android, when something was deleted)
        if (lastKey === 8 || $7beee9608540d2c3$var$browser.android && domChange.text.length < to - from) {
            preferredPos = sel.to;
            preferredSide = "end";
        }
        let diff = $7beee9608540d2c3$var$findDiff(view.state.doc.sliceString(from, to, $7beee9608540d2c3$var$LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
        if (diff) {
            // Chrome inserts two newlines when pressing shift-enter at the
            // end of a line. DomChange drops one of those.
            if ($7beee9608540d2c3$var$browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == $7beee9608540d2c3$var$LineBreakPlaceholder + $7beee9608540d2c3$var$LineBreakPlaceholder) diff.toB--;
            change = {
                from: from + diff.from,
                to: from + diff.toA,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(domChange.text.slice(diff.from, diff.toB).split($7beee9608540d2c3$var$LineBreakPlaceholder))
            };
        }
    } else if (newSel && (!view.hasFocus && view.state.facet($7beee9608540d2c3$var$editable) || newSel.main.eq(sel))) newSel = null;
    if (!change && !newSel) return false;
    if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) // Heuristic to notice typing over a selected character
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, sel.to)
    };
    else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) // If the change is inside the selection and covers most of it,
    // assume it is a selection replace (with identical characters at
    // the start/end not included in the diff)
    change = {
        from: sel.from,
        to: sel.to,
        insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
    else if (($7beee9608540d2c3$var$browser.mac || $7beee9608540d2c3$var$browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
        // Detect insert-period-on-double-space Mac and Android behavior,
        // and transform it into a regular space insert.
        if (newSel && change.insert.length == 2) newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    } else if ($7beee9608540d2c3$var$browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
        // In Chrome, if you insert a space at the start of a wrapped
        // line, it will actually insert a newline and a space, causing a
        // bogus new line to be created in CodeMirror (#968)
        if (newSel) newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(newSel.main.anchor - 1, newSel.main.head - 1);
        change = {
            from: sel.from,
            to: sel.to,
            insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                " "
            ])
        };
    }
    if (change) return $7beee9608540d2c3$var$applyDOMChangeInner(view, change, newSel, lastKey);
    else if (newSel && !newSel.main.eq(sel)) {
        let scrollIntoView = false, userEvent = "select";
        if (view.inputState.lastSelectionTime > Date.now() - 50) {
            if (view.inputState.lastSelectionOrigin == "select") scrollIntoView = true;
            userEvent = view.inputState.lastSelectionOrigin;
        }
        view.dispatch({
            selection: newSel,
            scrollIntoView: scrollIntoView,
            userEvent: userEvent
        });
        return true;
    } else return false;
}
function $7beee9608540d2c3$var$applyDOMChangeInner(view, change, newSel, lastKey = -1) {
    if ($7beee9608540d2c3$var$browser.ios && view.inputState.flushIOSKey(change)) return true;
    let sel = view.state.selection.main;
    // Android browsers don't fire reasonable key events for enter,
    // backspace, or delete. So this detects changes that look like
    // they're caused by those keys, and reinterprets them as key
    // events. (Some of these keys are also handled by beforeinput
    // events and the pendingAndroidKey mechanism, but that's not
    // reliable in all situations.)
    if ($7beee9608540d2c3$var$browser.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
    // after a completion when you press enter
    (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && $7beee9608540d2c3$var$dispatchKey(view.contentDOM, "Delete", 46))) return true;
    let text = change.insert.toString();
    if (view.inputState.composing >= 0) view.inputState.composing++;
    let defaultTr;
    let defaultInsert = ()=>defaultTr || (defaultTr = $7beee9608540d2c3$var$applyDefaultInsert(view, change, newSel));
    if (!view.state.facet($7beee9608540d2c3$var$inputHandler).some((h)=>h(view, change.from, change.to, text, defaultInsert))) view.dispatch(defaultInsert());
    return true;
}
function $7beee9608540d2c3$var$applyDefaultInsert(view, change, newSel) {
    let tr, startState = view.state, sel = startState.selection.main;
    if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
        let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
        let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
        tr = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, undefined, view.state.lineBreak) + after));
    } else {
        let changes = startState.changes(change);
        let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : undefined;
        // Try to apply a composition change to all cursors
        if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
            let replaced = view.state.sliceDoc(change.from, change.to);
            let compositionRange, composition = newSel && $7beee9608540d2c3$var$findCompositionNode(view, newSel.main.head);
            if (composition) {
                let dLen = change.insert.length - (change.to - change.from);
                compositionRange = {
                    from: composition.from,
                    to: composition.to - dLen
                };
            } else compositionRange = view.state.doc.lineAt(sel.head);
            let offset = sel.to - change.to, size = sel.to - sel.from;
            tr = startState.changeByRange((range)=>{
                if (range.from == sel.from && range.to == sel.to) return {
                    changes: changes,
                    range: mainSel || range.map(changes)
                };
                let to = range.to - offset, from = to - replaced.length;
                if (range.to - range.from != size || view.state.sliceDoc(from, to) != replaced || // Unfortunately, there's no way to make multiple
                // changes in the same node work without aborting
                // composition, so cursors in the composition range are
                // ignored.
                range.to >= compositionRange.from && range.from <= compositionRange.to) return {
                    range: range
                };
                let rangeChanges = startState.changes({
                    from: from,
                    to: to,
                    insert: change.insert
                }), selOff = range.to - sel.to;
                return {
                    changes: rangeChanges,
                    range: !mainSel ? range.map(rangeChanges) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
                };
            });
        } else tr = {
            changes: changes,
            selection: mainSel && startState.selection.replaceRange(mainSel)
        };
    }
    let userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
        view.inputState.compositionPendingChange = false;
        userEvent += ".compose";
        if (view.inputState.compositionFirstChange) {
            userEvent += ".start";
            view.inputState.compositionFirstChange = false;
        }
    }
    return startState.update(tr, {
        userEvent: userEvent,
        scrollIntoView: true
    });
}
function $7beee9608540d2c3$var$findDiff(a, b, preferredPos, preferredSide) {
    let minLen = Math.min(a.length, b.length);
    let from = 0;
    while(from < minLen && a.charCodeAt(from) == b.charCodeAt(from))from++;
    if (from == minLen && a.length == b.length) return null;
    let toA = a.length, toB = b.length;
    while(toA > 0 && toB > 0 && a.charCodeAt(toA - 1) == b.charCodeAt(toB - 1)){
        toA--;
        toB--;
    }
    if (preferredSide == "end") {
        let adjust = Math.max(0, from - Math.min(toA, toB));
        preferredPos -= toA + adjust - from;
    }
    if (toA < from && a.length < b.length) {
        let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
        from -= move;
        toB = from + (toB - toA);
        toA = from;
    } else if (toB < from) {
        let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
        from -= move;
        toA = from + (toA - toB);
        toB = from;
    }
    return {
        from: from,
        toA: toA,
        toB: toB
    };
}
function $7beee9608540d2c3$var$selectionPoints(view) {
    let result = [];
    if (view.root.activeElement != view.contentDOM) return result;
    let { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = view.observer.selectionRange;
    if (anchorNode) {
        result.push(new $7beee9608540d2c3$var$DOMPoint(anchorNode, anchorOffset));
        if (focusNode != anchorNode || focusOffset != anchorOffset) result.push(new $7beee9608540d2c3$var$DOMPoint(focusNode, focusOffset));
    }
    return result;
}
function $7beee9608540d2c3$var$selectionFromPoints(points, base) {
    if (points.length == 0) return null;
    let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
    return anchor > -1 && head > -1 ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(anchor + base, head + base) : null;
}
const $7beee9608540d2c3$var$observeOptions = {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    characterDataOldValue: true
};
// IE11 has very broken mutation observers, so we also listen to
// DOMCharacterDataModified there
const $7beee9608540d2c3$var$useCharData = $7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11;
class $7beee9608540d2c3$var$DOMObserver {
    constructor(view){
        this.view = view;
        this.active = false;
        this.editContext = null;
        // The known selection. Kept in our own object, as opposed to just
        // directly accessing the selection because:
        //  - Safari doesn't report the right selection in shadow DOM
        //  - Reading from the selection forces a DOM layout
        //  - This way, we can ignore selectionchange events if we have
        //    already seen the 'new' selection
        this.selectionRange = new $7beee9608540d2c3$var$DOMSelectionState;
        // Set when a selection change is detected, cleared on flush
        this.selectionChanged = false;
        this.delayedFlush = -1;
        this.resizeTimeout = -1;
        this.queue = [];
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
        this.lastChange = 0;
        this.scrollTargets = [];
        this.intersection = null;
        this.resizeScroll = null;
        this.intersecting = false;
        this.gapIntersection = null;
        this.gaps = [];
        this.printQuery = null;
        // Timeout for scheduling check of the parents that need scroll handlers
        this.parentCheck = -1;
        this.dom = view.contentDOM;
        this.observer = new MutationObserver((mutations)=>{
            for (let mut of mutations)this.queue.push(mut);
            // IE11 will sometimes (on typing over a selection or
            // backspacing out a single character text node) call the
            // observer callback before actually updating the DOM.
            //
            // Unrelatedly, iOS Safari will, when ending a composition,
            // sometimes first clear it, deliver the mutations, and then
            // reinsert the finished text. CodeMirror's handling of the
            // deletion will prevent the reinsertion from happening,
            // breaking composition.
            if (($7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11 || $7beee9608540d2c3$var$browser.ios && view.composing) && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if (window.EditContext && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
        !($7beee9608540d2c3$var$browser.chrome && $7beee9608540d2c3$var$browser.chrome_version < 126)) {
            this.editContext = new $7beee9608540d2c3$var$EditContextManager(view);
            if (view.state.facet($7beee9608540d2c3$var$editable)) view.contentDOM.editContext = this.editContext.editContext;
        }
        if ($7beee9608540d2c3$var$useCharData) this.onCharData = (event)=>{
            this.queue.push({
                target: event.target,
                type: "characterData",
                oldValue: event.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.onScroll = this.onScroll.bind(this);
        if (window.matchMedia) this.printQuery = window.matchMedia("print");
        if (typeof ResizeObserver == "function") {
            this.resizeScroll = new ResizeObserver(()=>{
                var _a;
                if (((_a = this.view.docView) === null || _a === void 0 ? void 0 : _a.lastUpdate) < Date.now() - 75) this.onResize();
            });
            this.resizeScroll.observe(view.scrollDOM);
        }
        this.addWindowListeners(this.win = view.win);
        this.start();
        if (typeof IntersectionObserver == "function") {
            this.intersection = new IntersectionObserver((entries)=>{
                if (this.parentCheck < 0) this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1000);
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
                    this.intersecting = !this.intersecting;
                    if (this.intersecting != this.view.inView) this.onScrollChanged(document.createEvent("Event"));
                }
            }, {
                threshold: [
                    0,
                    .001
                ]
            });
            this.intersection.observe(this.dom);
            this.gapIntersection = new IntersectionObserver((entries)=>{
                if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0) this.onScrollChanged(document.createEvent("Event"));
            }, {});
        }
        this.listenForScroll();
        this.readSelectionRange();
    }
    onScrollChanged(e) {
        this.view.inputState.runHandlers("scroll", e);
        if (this.intersecting) this.view.measure();
    }
    onScroll(e) {
        if (this.intersecting) this.flush(false);
        if (this.editContext) this.view.requestMeasure(this.editContext.measureReq);
        this.onScrollChanged(e);
    }
    onResize() {
        if (this.resizeTimeout < 0) this.resizeTimeout = setTimeout(()=>{
            this.resizeTimeout = -1;
            this.view.requestMeasure();
        }, 50);
    }
    onPrint(event) {
        if (event.type == "change" && !event.matches) return;
        this.view.viewState.printing = true;
        this.view.measure();
        setTimeout(()=>{
            this.view.viewState.printing = false;
            this.view.requestMeasure();
        }, 500);
    }
    updateGaps(gaps) {
        if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g, i)=>g != gaps[i]))) {
            this.gapIntersection.disconnect();
            for (let gap of gaps)this.gapIntersection.observe(gap);
            this.gaps = gaps;
        }
    }
    onSelectionChange(event) {
        let wasChanged = this.selectionChanged;
        if (!this.readSelectionRange() || this.delayedAndroidKey) return;
        let { view: view } = this, sel = this.selectionRange;
        if (view.state.facet($7beee9608540d2c3$var$editable) ? view.root.activeElement != this.dom : !$7beee9608540d2c3$var$hasSelection(view.dom, sel)) return;
        let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
        if (context && context.ignoreEvent(event)) {
            if (!wasChanged) this.selectionChanged = false;
            return;
        }
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        // Chrome Android has a similar issue when backspacing out a
        // selection (#645).
        if (($7beee9608540d2c3$var$browser.ie && $7beee9608540d2c3$var$browser.ie_version <= 11 || $7beee9608540d2c3$var$browser.android && $7beee9608540d2c3$var$browser.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
        sel.focusNode && $7beee9608540d2c3$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) this.flushSoon();
        else this.flush(false);
    }
    readSelectionRange() {
        let { view: view } = this;
        // The Selection object is broken in shadow roots in Safari. See
        // https://github.com/codemirror/dev/issues/414
        let selection = $7beee9608540d2c3$var$getSelection(view.root);
        if (!selection) return false;
        let range = $7beee9608540d2c3$var$browser.safari && view.root.nodeType == 11 && $7beee9608540d2c3$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $7beee9608540d2c3$var$safariSelectionRangeHack(this.view, selection) || selection;
        if (!range || this.selectionRange.eq(range)) return false;
        let local = $7beee9608540d2c3$var$hasSelection(this.dom, range);
        // Detect the situation where the browser has, on focus, moved the
        // selection to the start of the content element. Reset it to the
        // position from the editor state.
        if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && $7beee9608540d2c3$var$atElementStart(this.dom, range)) {
            this.view.inputState.lastFocusTime = 0;
            view.docView.updateSelection();
            return false;
        }
        this.selectionRange.setRange(range);
        if (local) this.selectionChanged = true;
        return true;
    }
    setSelectionRange(anchor, head) {
        this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
        this.selectionChanged = false;
    }
    clearSelectionRange() {
        this.selectionRange.set(null, 0, null, 0);
    }
    listenForScroll() {
        this.parentCheck = -1;
        let i = 0, changed = null;
        for(let dom = this.dom; dom;){
            if (dom.nodeType == 1) {
                if (!changed && i < this.scrollTargets.length && this.scrollTargets[i] == dom) i++;
                else if (!changed) changed = this.scrollTargets.slice(0, i);
                if (changed) changed.push(dom);
                dom = dom.assignedSlot || dom.parentNode;
            } else if (dom.nodeType == 11) dom = dom.host;
            else break;
        }
        if (i < this.scrollTargets.length && !changed) changed = this.scrollTargets.slice(0, i);
        if (changed) {
            for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
            for (let dom of this.scrollTargets = changed)dom.addEventListener("scroll", this.onScroll);
        }
    }
    ignore(f) {
        if (!this.active) return f();
        try {
            this.stop();
            return f();
        } finally{
            this.start();
            this.clear();
        }
    }
    start() {
        if (this.active) return;
        this.observer.observe(this.dom, $7beee9608540d2c3$var$observeOptions);
        if ($7beee9608540d2c3$var$useCharData) this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.active = true;
    }
    stop() {
        if (!this.active) return;
        this.active = false;
        this.observer.disconnect();
        if ($7beee9608540d2c3$var$useCharData) this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
    }
    // Throw away any pending changes
    clear() {
        this.processRecords();
        this.queue.length = 0;
        this.selectionChanged = false;
    }
    // Chrome Android, especially in combination with GBoard, not only
    // doesn't reliably fire regular key events, but also often
    // surrounds the effect of enter or backspace with a bunch of
    // composition events that, when interrupted, cause text duplication
    // or other kinds of corruption. This hack makes the editor back off
    // from handling DOM changes for a moment when such a key is
    // detected (via beforeinput or keydown), and then tries to flush
    // them or, if that has no effect, dispatches the given key.
    delayAndroidKey(key, keyCode) {
        var _a;
        if (!this.delayedAndroidKey) {
            let flush = ()=>{
                let key = this.delayedAndroidKey;
                if (key) {
                    this.clearDelayedAndroidKey();
                    this.view.inputState.lastKeyCode = key.keyCode;
                    this.view.inputState.lastKeyTime = Date.now();
                    let flushed = this.flush();
                    if (!flushed && key.force) $7beee9608540d2c3$var$dispatchKey(this.dom, key.key, key.keyCode);
                }
            };
            this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
        }
        // Since backspace beforeinput is sometimes signalled spuriously,
        // Enter always takes precedence.
        if (!this.delayedAndroidKey || key == "Enter") this.delayedAndroidKey = {
            key: key,
            keyCode: keyCode,
            // Only run the key handler when no changes are detected if
            // this isn't coming right after another change, in which case
            // it is probably part of a weird chain of updates, and should
            // be ignored if it returns the DOM to its previous state.
            force: this.lastChange < Date.now() - 50 || !!((_a = this.delayedAndroidKey) === null || _a === void 0 ? void 0 : _a.force)
        };
    }
    clearDelayedAndroidKey() {
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
        this.delayedAndroidKey = null;
        this.flushingAndroidKey = -1;
    }
    flushSoon() {
        if (this.delayedFlush < 0) this.delayedFlush = this.view.win.requestAnimationFrame(()=>{
            this.delayedFlush = -1;
            this.flush();
        });
    }
    forceFlush() {
        if (this.delayedFlush >= 0) {
            this.view.win.cancelAnimationFrame(this.delayedFlush);
            this.delayedFlush = -1;
        }
        this.flush();
    }
    pendingRecords() {
        for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    processRecords() {
        let records = this.pendingRecords();
        if (records.length) this.queue = [];
        let from = -1, to = -1, typeOver = false;
        for (let record of records){
            let range = this.readMutation(record);
            if (!range) continue;
            if (range.typeOver) typeOver = true;
            if (from == -1) ({ from: from, to: to } = range);
            else {
                from = Math.min(range.from, from);
                to = Math.max(range.to, to);
            }
        }
        return {
            from: from,
            to: to,
            typeOver: typeOver
        };
    }
    readChange() {
        let { from: from, to: to, typeOver: typeOver } = this.processRecords();
        let newSel = this.selectionChanged && $7beee9608540d2c3$var$hasSelection(this.dom, this.selectionRange);
        if (from < 0 && !newSel) return null;
        if (from > -1) this.lastChange = Date.now();
        this.view.inputState.lastFocusTime = 0;
        this.selectionChanged = false;
        let change = new $7beee9608540d2c3$var$DOMChange(this.view, from, to, typeOver);
        this.view.docView.domChanged = {
            newSel: change.newSel ? change.newSel.main : null
        };
        return change;
    }
    // Apply pending changes, if any
    flush(readSelection = true) {
        // Completely hold off flushing when pending keys are set—the code
        // managing those will make sure processRecords is called and the
        // view is resynchronized after
        if (this.delayedFlush >= 0 || this.delayedAndroidKey) return false;
        if (readSelection) this.readSelectionRange();
        let domChange = this.readChange();
        if (!domChange) {
            this.view.requestMeasure();
            return false;
        }
        let startState = this.view.state;
        let handled = $7beee9608540d2c3$var$applyDOMChange(this.view, domChange);
        // The view wasn't updated but DOM/selection changes were seen. Reset the view.
        if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !domChange.newSel.main.eq(this.view.state.selection.main))) this.view.update([]);
        return handled;
    }
    readMutation(rec) {
        let cView = this.view.docView.nearest(rec.target);
        if (!cView || cView.ignoreMutation(rec)) return null;
        cView.markDirty(rec.type == "attributes");
        if (rec.type == "attributes") cView.flags |= 4 /* ViewFlag.AttrsDirty */ ;
        if (rec.type == "childList") {
            let childBefore = $7beee9608540d2c3$var$findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
            let childAfter = $7beee9608540d2c3$var$findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
            return {
                from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
                to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
                typeOver: false
            };
        } else if (rec.type == "characterData") return {
            from: cView.posAtStart,
            to: cView.posAtEnd,
            typeOver: rec.target.nodeValue == rec.oldValue
        };
        else return null;
    }
    setWindow(win) {
        if (win != this.win) {
            this.removeWindowListeners(this.win);
            this.win = win;
            this.addWindowListeners(this.win);
        }
    }
    addWindowListeners(win) {
        win.addEventListener("resize", this.onResize);
        if (this.printQuery) this.printQuery.addEventListener("change", this.onPrint);
        else win.addEventListener("beforeprint", this.onPrint);
        win.addEventListener("scroll", this.onScroll);
        win.document.addEventListener("selectionchange", this.onSelectionChange);
    }
    removeWindowListeners(win) {
        win.removeEventListener("scroll", this.onScroll);
        win.removeEventListener("resize", this.onResize);
        if (this.printQuery) this.printQuery.removeEventListener("change", this.onPrint);
        else win.removeEventListener("beforeprint", this.onPrint);
        win.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    update(update) {
        if (this.editContext) {
            this.editContext.update(update);
            if (update.startState.facet($7beee9608540d2c3$var$editable) != update.state.facet($7beee9608540d2c3$var$editable)) update.view.contentDOM.editContext = update.state.facet($7beee9608540d2c3$var$editable) ? this.editContext.editContext : null;
        }
    }
    destroy() {
        var _a, _b, _c;
        this.stop();
        (_a = this.intersection) === null || _a === void 0 || _a.disconnect();
        (_b = this.gapIntersection) === null || _b === void 0 || _b.disconnect();
        (_c = this.resizeScroll) === null || _c === void 0 || _c.disconnect();
        for (let dom of this.scrollTargets)dom.removeEventListener("scroll", this.onScroll);
        this.removeWindowListeners(this.win);
        clearTimeout(this.parentCheck);
        clearTimeout(this.resizeTimeout);
        this.win.cancelAnimationFrame(this.delayedFlush);
        this.win.cancelAnimationFrame(this.flushingAndroidKey);
    }
}
function $7beee9608540d2c3$var$findChild(cView, dom, dir) {
    while(dom){
        let curView = $7beee9608540d2c3$var$ContentView.get(dom);
        if (curView && curView.parent == cView) return curView;
        let parent = dom.parentNode;
        dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
    }
    return null;
}
function $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($7beee9608540d2c3$var$isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug (#414)
function $7beee9608540d2c3$var$safariSelectionRangeHack(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, range);
    }
    let found = null;
    // Because Safari (at least in 2018-2021) doesn't provide regular
    // access to the selection inside a shadowroot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    view.contentDOM.addEventListener("beforeinput", read, true);
    view.dom.ownerDocument.execCommand("indent");
    view.contentDOM.removeEventListener("beforeinput", read, true);
    return found ? $7beee9608540d2c3$var$buildSelectionRangeFromRange(view, found) : null;
}
class $7beee9608540d2c3$var$EditContextManager {
    constructor(view){
        // The document window for which the text in the context is
        // maintained. For large documents, this may be smaller than the
        // editor document. This window always includes the selection head.
        this.from = 0;
        this.to = 0;
        // When applying a transaction, this is used to compare the change
        // made to the context content to the change in the transaction in
        // order to make the minimal changes to the context (since touching
        // that sometimes breaks series of multiple edits made for a single
        // user action on some Android keyboards)
        this.pendingContextChange = null;
        this.resetRange(view.state);
        let context = this.editContext = new window.EditContext({
            text: view.state.doc.sliceString(this.from, this.to),
            selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
            selectionEnd: this.toContextPos(view.state.selection.main.head)
        });
        context.addEventListener("textupdate", (e)=>{
            let { anchor: anchor } = view.state.selection.main;
            let change = {
                from: this.toEditorPos(e.updateRangeStart),
                to: this.toEditorPos(e.updateRangeEnd),
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(e.text.split("\n"))
            };
            // If the window doesn't include the anchor, assume changes
            // adjacent to a side go up to the anchor.
            if (change.from == this.from && anchor < this.from) change.from = anchor;
            else if (change.to == this.to && anchor > this.to) change.to = anchor;
            // Edit context sometimes fire empty changes
            if (change.from == change.to && !change.insert.length) return;
            this.pendingContextChange = change;
            $7beee9608540d2c3$var$applyDOMChangeInner(view, change, (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(this.toEditorPos(e.selectionStart), this.toEditorPos(e.selectionEnd)));
            // If the transaction didn't flush our change, revert it so
            // that the context is in sync with the editor state again.
            if (this.pendingContextChange) this.revertPending(view.state);
        });
        context.addEventListener("characterboundsupdate", (e)=>{
            let rects = [], prev = null;
            for(let i = this.toEditorPos(e.rangeStart), end = this.toEditorPos(e.rangeEnd); i < end; i++){
                let rect = view.coordsForChar(i);
                prev = rect && new DOMRect(rect.left, rect.right, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect;
                rects.push(prev);
            }
            context.updateCharacterBounds(e.rangeStart, rects);
        });
        context.addEventListener("textformatupdate", (e)=>{
            let deco = [];
            for (let format of e.getTextFormats()){
                let lineStyle = format.underlineStyle, thickness = format.underlineThickness;
                if (lineStyle != "None" && thickness != "None") {
                    let style = `text-decoration: underline ${lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${thickness == "Thin" ? 1 : 2}px`;
                    deco.push($7beee9608540d2c3$export$10e30b733df217ea.mark({
                        attributes: {
                            style: style
                        }
                    }).range(this.toEditorPos(format.rangeStart), this.toEditorPos(format.rangeEnd)));
                }
            }
            view.dispatch({
                effects: $7beee9608540d2c3$var$setEditContextFormatting.of($7beee9608540d2c3$export$10e30b733df217ea.set(deco))
            });
        });
        context.addEventListener("compositionstart", ()=>{
            if (view.inputState.composing < 0) {
                view.inputState.composing = 0;
                view.inputState.compositionFirstChange = true;
            }
        });
        context.addEventListener("compositionend", ()=>{
            view.inputState.composing = -1;
            view.inputState.compositionFirstChange = null;
        });
        this.measureReq = {
            read: (view)=>{
                this.editContext.updateControlBounds(view.contentDOM.getBoundingClientRect());
                let sel = $7beee9608540d2c3$var$getSelection(view.root);
                if (sel && sel.rangeCount) this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
            }
        };
    }
    applyEdits(update) {
        let off = 0, abort = false, pending = this.pendingContextChange;
        update.changes.iterChanges((fromA, toA, _fromB, _toB, insert)=>{
            if (abort) return;
            let dLen = insert.length - (toA - fromA);
            if (pending && toA >= pending.to) {
                if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert)) {
                    pending = this.pendingContextChange = null; // Match
                    off += dLen;
                    return;
                } else {
                    pending = null;
                    this.revertPending(update.state);
                }
            }
            fromA += off;
            toA += off;
            if (toA <= this.from) {
                this.from += dLen;
                this.to += dLen;
            } else if (fromA < this.to) {
                if (fromA < this.from || toA > this.to || this.to - this.from + insert.length > 30000 /* CxVp.MaxSize */ ) {
                    abort = true;
                    return;
                }
                this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert.toString());
                this.to += dLen;
            }
            off += dLen;
        });
        if (pending && !abort) this.revertPending(update.state);
        return !abort;
    }
    update(update) {
        if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
            this.pendingContextChange = null;
            this.resetRange(update.state);
            this.editContext.updateText(0, this.editContext.text.length, update.state.doc.sliceString(this.from, this.to));
            this.setSelection(update.state);
        } else if (update.docChanged || update.selectionSet) this.setSelection(update.state);
        if (update.geometryChanged || update.docChanged || update.selectionSet) update.view.requestMeasure(this.measureReq);
    }
    resetRange(state) {
        let { head: head } = state.selection.main;
        this.from = Math.max(0, head - 10000 /* CxVp.Margin */ );
        this.to = Math.min(state.doc.length, head + 10000 /* CxVp.Margin */ );
    }
    revertPending(state) {
        let pending = this.pendingContextChange;
        this.pendingContextChange = null;
        this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.to + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
    }
    setSelection(state) {
        let { main: main } = state.selection;
        let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main.anchor)));
        let end = this.toContextPos(main.head);
        if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end) this.editContext.updateSelection(start, end);
    }
    rangeIsValid(state) {
        let { head: head } = state.selection.main;
        return !(this.from > 0 && head - this.from < 500 /* CxVp.MinMargin */  || this.to < state.doc.length && this.to - head < 500 /* CxVp.MinMargin */  || this.to - this.from > 30000);
    }
    toEditorPos(contextPos) {
        return contextPos + this.from;
    }
    toContextPos(editorPos) {
        return editorPos - this.from;
    }
}
// The editor's update state machine looks something like this:
//
//     Idle → Updating ⇆ Idle (unchecked) → Measuring → Idle
//                                         ↑      ↓
//                                         Updating (measure)
//
// The difference between 'Idle' and 'Idle (unchecked)' lies in
// whether a layout check has been scheduled. A regular update through
// the `update` method updates the DOM in a write-only fashion, and
// relies on a check (scheduled with `requestAnimationFrame`) to make
// sure everything is where it should be and the viewport covers the
// visible code. That check continues to measure and then optionally
// update until it reaches a coherent state.
/**
An editor view represents the editor's user interface. It holds
the editable DOM surface, and possibly other elements such as the
line number gutter. It handles events and dispatches state
transactions for editing actions.
*/ class $7beee9608540d2c3$export$eece2fccabbb77c5 {
    /**
    The current editor state.
    */ get state() {
        return this.viewState.state;
    }
    /**
    To be able to display large documents without consuming too much
    memory or overloading the browser, CodeMirror only draws the
    code that is visible (plus a margin around it) to the DOM. This
    property tells you the extent of the current drawn viewport, in
    document positions.
    */ get viewport() {
        return this.viewState.viewport;
    }
    /**
    When there are, for example, large collapsed ranges in the
    viewport, its size can be a lot bigger than the actual visible
    content. Thus, if you are doing something like styling the
    content in the viewport, it is preferable to only do so for
    these ranges, which are the subset of the viewport that is
    actually drawn.
    */ get visibleRanges() {
        return this.viewState.visibleRanges;
    }
    /**
    Returns false when the editor is entirely scrolled out of view
    or otherwise hidden.
    */ get inView() {
        return this.viewState.inView;
    }
    /**
    Indicates whether the user is currently composing text via
    [IME](https://en.wikipedia.org/wiki/Input_method), and at least
    one change has been made in the current composition.
    */ get composing() {
        return this.inputState.composing > 0;
    }
    /**
    Indicates whether the user is currently in composing state. Note
    that on some platforms, like Android, this will be the case a
    lot, since just putting the cursor on a word starts a
    composition there.
    */ get compositionStarted() {
        return this.inputState.composing >= 0;
    }
    /**
    The document or shadow root that the view lives in.
    */ get root() {
        return this._root;
    }
    /**
    @internal
    */ get win() {
        return this.dom.ownerDocument.defaultView || window;
    }
    /**
    Construct a new view. You'll want to either provide a `parent`
    option, or put `view.dom` into your document after creating a
    view, so that the user can see the editor.
    */ constructor(config = {}){
        this.plugins = [];
        this.pluginMap = new Map;
        this.editorAttrs = {};
        this.contentAttrs = {};
        this.bidiCache = [];
        this.destroyed = false;
        /**
        @internal
        */ this.updateState = 2 /* UpdateState.Updating */ ;
        /**
        @internal
        */ this.measureScheduled = -1;
        /**
        @internal
        */ this.measureRequests = [];
        this.contentDOM = document.createElement("div");
        this.scrollDOM = document.createElement("div");
        this.scrollDOM.tabIndex = -1;
        this.scrollDOM.className = "cm-scroller";
        this.scrollDOM.appendChild(this.contentDOM);
        this.announceDOM = document.createElement("div");
        this.announceDOM.className = "cm-announced";
        this.announceDOM.setAttribute("aria-live", "polite");
        this.dom = document.createElement("div");
        this.dom.appendChild(this.announceDOM);
        this.dom.appendChild(this.scrollDOM);
        if (config.parent) config.parent.appendChild(this.dom);
        let { dispatch: dispatch } = config;
        this.dispatchTransactions = config.dispatchTransactions || dispatch && ((trs)=>trs.forEach((tr)=>dispatch(tr, this))) || ((trs)=>this.update(trs));
        this.dispatch = this.dispatch.bind(this);
        this._root = config.root || $7beee9608540d2c3$var$getRoot(config.parent) || document;
        this.viewState = new $7beee9608540d2c3$var$ViewState(config.state || (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create(config));
        if (config.scrollTo && config.scrollTo.is($7beee9608540d2c3$var$scrollIntoView)) this.viewState.scrollTarget = config.scrollTo.value.clip(this.viewState.state);
        this.plugins = this.state.facet($7beee9608540d2c3$var$viewPlugin).map((spec)=>new $7beee9608540d2c3$var$PluginInstance(spec));
        for (let plugin of this.plugins)plugin.update(this);
        this.observer = new $7beee9608540d2c3$var$DOMObserver(this);
        this.inputState = new $7beee9608540d2c3$var$InputState(this);
        this.inputState.ensureHandlers(this.plugins);
        this.docView = new $7beee9608540d2c3$var$DocView(this);
        this.mountStyles();
        this.updateAttrs();
        this.updateState = 0 /* UpdateState.Idle */ ;
        this.requestMeasure();
    }
    dispatch(...input) {
        let trs = input.length == 1 && input[0] instanceof (0, $6295c6875f57e3ee$export$febc5573c75cefb0) ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [
            this.state.update(...input)
        ];
        this.dispatchTransactions(trs, this);
    }
    /**
    Update the view for the given array of transactions. This will
    update the visible document and selection to match the state
    produced by the transactions, and notify view plugins of the
    change. You should usually call
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
    as a primitive.
    */ update(transactions) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
        let redrawn = false, attrsChanged = false, update;
        let state = this.state;
        for (let tr of transactions){
            if (tr.startState != state) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
            state = tr.state;
        }
        if (this.destroyed) {
            this.viewState.state = state;
            return;
        }
        let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
        if (transactions.some((tr)=>tr.annotation($7beee9608540d2c3$var$isFocusChange))) {
            this.inputState.notifiedFocused = focus;
            // If a focus-change transaction is being dispatched, set this update flag.
            focusFlag = 1 /* UpdateFlag.Focus */ ;
        } else if (focus != this.inputState.notifiedFocused) {
            this.inputState.notifiedFocused = focus;
            // Schedule a separate focus transaction if necessary, otherwise
            // add a flag to this update
            dispatchFocus = $7beee9608540d2c3$var$focusChangeTransaction(state, focus);
            if (!dispatchFocus) focusFlag = 1 /* UpdateFlag.Focus */ ;
        }
        // If there was a pending DOM change, eagerly read it and try to
        // apply it after the given transactions.
        let pendingKey = this.observer.delayedAndroidKey, domChange = null;
        if (pendingKey) {
            this.observer.clearDelayedAndroidKey();
            domChange = this.observer.readChange();
            // Only try to apply DOM changes if the transactions didn't
            // change the doc or selection.
            if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection)) domChange = null;
        } else this.observer.clear();
        // When the phrases change, redraw the editor
        if (state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).phrases) != this.state.facet((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).phrases)) return this.setState(state);
        update = $7beee9608540d2c3$export$b5b084f95c87edf7.create(this, state, transactions);
        update.flags |= focusFlag;
        let scrollTarget = this.viewState.scrollTarget;
        try {
            this.updateState = 2 /* UpdateState.Updating */ ;
            for (let tr of transactions){
                if (scrollTarget) scrollTarget = scrollTarget.map(tr.changes);
                if (tr.scrollIntoView) {
                    let { main: main } = tr.state.selection;
                    scrollTarget = new $7beee9608540d2c3$var$ScrollTarget(main.empty ? main : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(main.head, main.head > main.anchor ? -1 : 1));
                }
                for (let e of tr.effects)if (e.is($7beee9608540d2c3$var$scrollIntoView)) scrollTarget = e.value.clip(this.state);
            }
            this.viewState.update(update, scrollTarget);
            this.bidiCache = $7beee9608540d2c3$var$CachedOrder.update(this.bidiCache, update.changes);
            if (!update.empty) {
                this.updatePlugins(update);
                this.inputState.update(update);
            }
            redrawn = this.docView.update(update);
            if (this.state.facet($7beee9608540d2c3$var$styleModule) != this.styleModules) this.mountStyles();
            attrsChanged = this.updateAttrs();
            this.showAnnouncements(transactions);
            this.docView.updateSelection(redrawn, transactions.some((tr)=>tr.isUserEvent("select.pointer")));
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (update.startState.facet($7beee9608540d2c3$var$theme) != update.state.facet($7beee9608540d2c3$var$theme)) this.viewState.mustMeasureContent = true;
        if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) this.requestMeasure();
        if (redrawn) this.docViewUpdate();
        if (!update.empty) for (let listener of this.state.facet($7beee9608540d2c3$var$updateListener))try {
            listener(update);
        } catch (e) {
            $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e, "update listener");
        }
        if (dispatchFocus || domChange) Promise.resolve().then(()=>{
            if (dispatchFocus && this.state == dispatchFocus.startState) this.dispatch(dispatchFocus);
            if (domChange) {
                if (!$7beee9608540d2c3$var$applyDOMChange(this, domChange) && pendingKey.force) $7beee9608540d2c3$var$dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
            }
        });
    }
    /**
    Reset the view to the given state. (This will cause the entire
    document to be redrawn and all view plugins to be reinitialized,
    so you should probably only use it when the new state isn't
    derived from the old state. Otherwise, use
    [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
    */ setState(newState) {
        if (this.updateState != 0 /* UpdateState.Idle */ ) throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
        if (this.destroyed) {
            this.viewState.state = newState;
            return;
        }
        this.updateState = 2 /* UpdateState.Updating */ ;
        let hadFocus = this.hasFocus;
        try {
            for (let plugin of this.plugins)plugin.destroy(this);
            this.viewState = new $7beee9608540d2c3$var$ViewState(newState);
            this.plugins = newState.facet($7beee9608540d2c3$var$viewPlugin).map((spec)=>new $7beee9608540d2c3$var$PluginInstance(spec));
            this.pluginMap.clear();
            for (let plugin of this.plugins)plugin.update(this);
            this.docView.destroy();
            this.docView = new $7beee9608540d2c3$var$DocView(this);
            this.inputState.ensureHandlers(this.plugins);
            this.mountStyles();
            this.updateAttrs();
            this.bidiCache = [];
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
        }
        if (hadFocus) this.focus();
        this.requestMeasure();
    }
    updatePlugins(update) {
        let prevSpecs = update.startState.facet($7beee9608540d2c3$var$viewPlugin), specs = update.state.facet($7beee9608540d2c3$var$viewPlugin);
        if (prevSpecs != specs) {
            let newPlugins = [];
            for (let spec of specs){
                let found = prevSpecs.indexOf(spec);
                if (found < 0) newPlugins.push(new $7beee9608540d2c3$var$PluginInstance(spec));
                else {
                    let plugin = this.plugins[found];
                    plugin.mustUpdate = update;
                    newPlugins.push(plugin);
                }
            }
            for (let plugin of this.plugins)if (plugin.mustUpdate != update) plugin.destroy(this);
            this.plugins = newPlugins;
            this.pluginMap.clear();
        } else for (let p of this.plugins)p.mustUpdate = update;
        for(let i = 0; i < this.plugins.length; i++)this.plugins[i].update(this);
        if (prevSpecs != specs) this.inputState.ensureHandlers(this.plugins);
    }
    docViewUpdate() {
        for (let plugin of this.plugins){
            let val = plugin.value;
            if (val && val.docViewUpdate) try {
                val.docViewUpdate(this);
            } catch (e) {
                $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e, "doc view update listener");
            }
        }
    }
    /**
    @internal
    */ measure(flush = true) {
        if (this.destroyed) return;
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        if (this.observer.delayedAndroidKey) {
            this.measureScheduled = -1;
            this.requestMeasure();
            return;
        }
        this.measureScheduled = 0; // Prevent requestMeasure calls from scheduling another animation frame
        if (flush) this.observer.forceFlush();
        let updated = null;
        let sDOM = this.scrollDOM, scrollTop = sDOM.scrollTop * this.scaleY;
        let { scrollAnchorPos: scrollAnchorPos, scrollAnchorHeight: scrollAnchorHeight } = this.viewState;
        if (Math.abs(scrollTop - this.viewState.scrollTop) > 1) scrollAnchorHeight = -1;
        this.viewState.scrollAnchorHeight = -1;
        try {
            for(let i = 0;; i++){
                if (scrollAnchorHeight < 0) {
                    if ($7beee9608540d2c3$var$isScrolledToBottom(sDOM)) {
                        scrollAnchorPos = -1;
                        scrollAnchorHeight = this.viewState.heightMap.height;
                    } else {
                        let block = this.viewState.scrollAnchorAt(scrollTop);
                        scrollAnchorPos = block.from;
                        scrollAnchorHeight = block.top;
                    }
                }
                this.updateState = 1 /* UpdateState.Measuring */ ;
                let changed = this.viewState.measure(this);
                if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
                if (i > 5) {
                    console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
                    break;
                }
                let measuring = [];
                // Only run measure requests in this cycle when the viewport didn't change
                if (!(changed & 4 /* UpdateFlag.Viewport */ )) [this.measureRequests, measuring] = [
                    measuring,
                    this.measureRequests
                ];
                let measured = measuring.map((m)=>{
                    try {
                        return m.read(this);
                    } catch (e) {
                        $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e);
                        return $7beee9608540d2c3$var$BadMeasure;
                    }
                });
                let update = $7beee9608540d2c3$export$b5b084f95c87edf7.create(this, this.state, []), redrawn = false;
                update.flags |= changed;
                if (!updated) updated = update;
                else updated.flags |= changed;
                this.updateState = 2 /* UpdateState.Updating */ ;
                if (!update.empty) {
                    this.updatePlugins(update);
                    this.inputState.update(update);
                    this.updateAttrs();
                    redrawn = this.docView.update(update);
                    if (redrawn) this.docViewUpdate();
                }
                for(let i = 0; i < measuring.length; i++)if (measured[i] != $7beee9608540d2c3$var$BadMeasure) try {
                    let m = measuring[i];
                    if (m.write) m.write(measured[i], this);
                } catch (e) {
                    $7beee9608540d2c3$export$f86b2a1a2ce291b3(this.state, e);
                }
                if (redrawn) this.docView.updateSelection(true);
                if (!update.viewportChanged && this.measureRequests.length == 0) {
                    if (this.viewState.editorHeight) {
                        if (this.viewState.scrollTarget) {
                            this.docView.scrollIntoView(this.viewState.scrollTarget);
                            this.viewState.scrollTarget = null;
                            scrollAnchorHeight = -1;
                            continue;
                        } else {
                            let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
                            let diff = newAnchorHeight - scrollAnchorHeight;
                            if (diff > 1 || diff < -1) {
                                scrollTop = scrollTop + diff;
                                sDOM.scrollTop = scrollTop / this.scaleY;
                                scrollAnchorHeight = -1;
                                continue;
                            }
                        }
                    }
                    break;
                }
            }
        } finally{
            this.updateState = 0 /* UpdateState.Idle */ ;
            this.measureScheduled = -1;
        }
        if (updated && !updated.empty) for (let listener of this.state.facet($7beee9608540d2c3$var$updateListener))listener(updated);
    }
    /**
    Get the CSS classes for the currently active editor themes.
    */ get themeClasses() {
        return $7beee9608540d2c3$var$baseThemeID + " " + (this.state.facet($7beee9608540d2c3$var$darkTheme) ? $7beee9608540d2c3$var$baseDarkID : $7beee9608540d2c3$var$baseLightID) + " " + this.state.facet($7beee9608540d2c3$var$theme);
    }
    updateAttrs() {
        let editorAttrs = $7beee9608540d2c3$var$attrsFromFacet(this, $7beee9608540d2c3$var$editorAttributes, {
            class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
        });
        let contentAttrs = {
            spellcheck: "false",
            autocorrect: "off",
            autocapitalize: "off",
            translate: "no",
            contenteditable: !this.state.facet($7beee9608540d2c3$var$editable) ? "false" : "true",
            class: "cm-content",
            style: `${$7beee9608540d2c3$var$browser.tabSize}: ${this.state.tabSize}`,
            role: "textbox",
            "aria-multiline": "true"
        };
        if (this.state.readOnly) contentAttrs["aria-readonly"] = "true";
        $7beee9608540d2c3$var$attrsFromFacet(this, $7beee9608540d2c3$var$contentAttributes, contentAttrs);
        let changed = this.observer.ignore(()=>{
            let changedContent = $7beee9608540d2c3$var$updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
            let changedEditor = $7beee9608540d2c3$var$updateAttrs(this.dom, this.editorAttrs, editorAttrs);
            return changedContent || changedEditor;
        });
        this.editorAttrs = editorAttrs;
        this.contentAttrs = contentAttrs;
        return changed;
    }
    showAnnouncements(trs) {
        let first = true;
        for (let tr of trs)for (let effect of tr.effects)if (effect.is($7beee9608540d2c3$export$eece2fccabbb77c5.announce)) {
            if (first) this.announceDOM.textContent = "";
            first = false;
            let div = this.announceDOM.appendChild(document.createElement("div"));
            div.textContent = effect.value;
        }
    }
    mountStyles() {
        this.styleModules = this.state.facet($7beee9608540d2c3$var$styleModule);
        let nonce = this.state.facet($7beee9608540d2c3$export$eece2fccabbb77c5.cspNonce);
        (0, $afd7c6da9f842a17$export$b920c662d2efee20).mount(this.root, this.styleModules.concat($7beee9608540d2c3$var$baseTheme$1).reverse(), nonce ? {
            nonce: nonce
        } : undefined);
    }
    readMeasured() {
        if (this.updateState == 2 /* UpdateState.Updating */ ) throw new Error("Reading the editor layout isn't allowed during an update");
        if (this.updateState == 0 /* UpdateState.Idle */  && this.measureScheduled > -1) this.measure(false);
    }
    /**
    Schedule a layout measurement, optionally providing callbacks to
    do custom DOM measuring followed by a DOM write phase. Using
    this is preferable reading DOM layout directly from, for
    example, an event handler, because it'll make sure measuring and
    drawing done by other components is synchronized, avoiding
    unnecessary DOM layout computations.
    */ requestMeasure(request) {
        if (this.measureScheduled < 0) this.measureScheduled = this.win.requestAnimationFrame(()=>this.measure());
        if (request) {
            if (this.measureRequests.indexOf(request) > -1) return;
            if (request.key != null) {
                for(let i = 0; i < this.measureRequests.length; i++)if (this.measureRequests[i].key === request.key) {
                    this.measureRequests[i] = request;
                    return;
                }
            }
            this.measureRequests.push(request);
        }
    }
    /**
    Get the value of a specific plugin, if present. Note that
    plugins that crash can be dropped from a view, so even when you
    know you registered a given plugin, it is recommended to check
    the return value of this method.
    */ plugin(plugin) {
        let known = this.pluginMap.get(plugin);
        if (known === undefined || known && known.spec != plugin) this.pluginMap.set(plugin, known = this.plugins.find((p)=>p.spec == plugin) || null);
        return known && known.update(this).value;
    }
    /**
    The top position of the document, in screen coordinates. This
    may be negative when the editor is scrolled down. Points
    directly to the top of the first line, not above the padding.
    */ get documentTop() {
        return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    /**
    Reports the padding above and below the document.
    */ get documentPadding() {
        return {
            top: this.viewState.paddingTop,
            bottom: this.viewState.paddingBottom
        };
    }
    /**
    If the editor is transformed with CSS, this provides the scale
    along the X axis. Otherwise, it will just be 1. Note that
    transforms other than translation and scaling are not supported.
    */ get scaleX() {
        return this.viewState.scaleX;
    }
    /**
    Provide the CSS transformed scale along the Y axis.
    */ get scaleY() {
        return this.viewState.scaleY;
    }
    /**
    Find the text line or block widget at the given vertical
    position (which is interpreted as relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
    */ elementAtHeight(height) {
        this.readMeasured();
        return this.viewState.elementAtHeight(height);
    }
    /**
    Find the line block (see
    [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
    height, again interpreted relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
    */ lineBlockAtHeight(height) {
        this.readMeasured();
        return this.viewState.lineBlockAtHeight(height);
    }
    /**
    Get the extent and vertical position of all [line
    blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
    are relative to the [top of the
    document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
    */ get viewportLineBlocks() {
        return this.viewState.viewportLines;
    }
    /**
    Find the line block around the given document position. A line
    block is a range delimited on both sides by either a
    non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
    start/end of the document. It will usually just hold a line of
    text, but may be broken into multiple textblocks by block
    widgets.
    */ lineBlockAt(pos) {
        return this.viewState.lineBlockAt(pos);
    }
    /**
    The editor's total content height.
    */ get contentHeight() {
        return this.viewState.contentHeight;
    }
    /**
    Move a cursor position by [grapheme
    cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
    the motion is away from the line start, or towards it. In
    bidirectional text, the line is traversed in visual order, using
    the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
    When the start position was the last one on the line, the
    returned position will be across the line break. If there is no
    further line, the original position is returned.
    
    By default, this method moves over a single cluster. The
    optional `by` argument can be used to move across more. It will
    be called with the first cluster as argument, and should return
    a predicate that determines, for each subsequent cluster,
    whether it should also be moved over.
    */ moveByChar(start, forward, by) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveByChar(this, start, forward, by));
    }
    /**
    Move a cursor position across the next group of either
    [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
    non-whitespace characters.
    */ moveByGroup(start, forward) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveByChar(this, start, forward, (initial)=>$7beee9608540d2c3$var$byGroup(this, start.head, initial)));
    }
    /**
    Get the cursor position visually at the start or end of a line.
    Note that this may differ from the _logical_ position at its
    start or end (which is simply at `line.from`/`line.to`) if text
    at the start or end goes against the line's base text direction.
    */ visualLineSide(line, end) {
        let order = this.bidiSpans(line), dir = this.textDirectionAt(line.from);
        let span = order[end ? order.length - 1 : 0];
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(span.side(end, dir) + line.from, span.forward(!end, dir) ? 1 : -1);
    }
    /**
    Move to the next line boundary in the given direction. If
    `includeWrap` is true, line wrapping is on, and there is a
    further wrap point on the current line, the wrap point will be
    returned. Otherwise this function will return the start or end
    of the line.
    */ moveToLineBoundary(start, forward, includeWrap = true) {
        return $7beee9608540d2c3$var$moveToLineBoundary(this, start, forward, includeWrap);
    }
    /**
    Move a cursor position vertically. When `distance` isn't given,
    it defaults to moving to the next line (including wrapped
    lines). Otherwise, `distance` should provide a positive distance
    in pixels.
    
    When `start` has a
    [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
    motion will use that as a target horizontal position. Otherwise,
    the cursor's own horizontal position is used. The returned
    cursor will have its goal column set to whichever column was
    used.
    */ moveVertically(start, forward, distance) {
        return $7beee9608540d2c3$var$skipAtoms(this, start, $7beee9608540d2c3$var$moveVertically(this, start, forward, distance));
    }
    /**
    Find the DOM parent node and offset (child offset if `node` is
    an element, character offset when it is a text node) at the
    given document position.
    
    Note that for positions that aren't currently in
    `visibleRanges`, the resulting DOM position isn't necessarily
    meaningful (it may just point before or after a placeholder
    element).
    */ domAtPos(pos) {
        return this.docView.domAtPos(pos);
    }
    /**
    Find the document position at the given DOM node. Can be useful
    for associating positions with DOM events. Will raise an error
    when `node` isn't part of the editor content.
    */ posAtDOM(node, offset = 0) {
        return this.docView.posFromDOM(node, offset);
    }
    posAtCoords(coords, precise = true) {
        this.readMeasured();
        return $7beee9608540d2c3$var$posAtCoords(this, coords, precise);
    }
    /**
    Get the screen coordinates at the given document position.
    `side` determines whether the coordinates are based on the
    element before (-1) or after (1) the position (if no element is
    available on the given side, the method will transparently use
    another strategy to get reasonable coordinates).
    */ coordsAtPos(pos, side = 1) {
        this.readMeasured();
        let rect = this.docView.coordsAt(pos, side);
        if (!rect || rect.left == rect.right) return rect;
        let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
        let span = order[$7beee9608540d2c3$export$e1ed96b746bb516a.find(order, pos - line.from, -1, side)];
        return $7beee9608540d2c3$var$flattenRect(rect, span.dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR == side > 0);
    }
    /**
    Return the rectangle around a given character. If `pos` does not
    point in front of a character that is in the viewport and
    rendered (i.e. not replaced, not a line break), this will return
    null. For space characters that are a line wrap point, this will
    return the position before the line break.
    */ coordsForChar(pos) {
        this.readMeasured();
        return this.docView.coordsForChar(pos);
    }
    /**
    The default width of a character in the editor. May not
    accurately reflect the width of all characters (given variable
    width fonts or styling of invididual ranges).
    */ get defaultCharacterWidth() {
        return this.viewState.heightOracle.charWidth;
    }
    /**
    The default height of a line in the editor. May not be accurate
    for all lines.
    */ get defaultLineHeight() {
        return this.viewState.heightOracle.lineHeight;
    }
    /**
    The text direction
    ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
    CSS property) of the editor's content element.
    */ get textDirection() {
        return this.viewState.defaultTextDirection;
    }
    /**
    Find the text direction of the block at the given position, as
    assigned by CSS. If
    [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
    isn't enabled, or the given position is outside of the viewport,
    this will always return the same as
    [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
    this may trigger a DOM layout.
    */ textDirectionAt(pos) {
        let perLine = this.state.facet($7beee9608540d2c3$var$perLineTextDirection);
        if (!perLine || pos < this.viewport.from || pos > this.viewport.to) return this.textDirection;
        this.readMeasured();
        return this.docView.textDirectionAt(pos);
    }
    /**
    Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
    (as determined by the
    [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
    CSS property of its content element).
    */ get lineWrapping() {
        return this.viewState.heightOracle.lineWrapping;
    }
    /**
    Returns the bidirectional text structure of the given line
    (which should be in the current document) as an array of span
    objects. The order of these spans matches the [text
    direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
    left-to-right, the leftmost spans come first, otherwise the
    rightmost spans come first.
    */ bidiSpans(line) {
        if (line.length > $7beee9608540d2c3$var$MaxBidiLine) return $7beee9608540d2c3$var$trivialOrder(line.length);
        let dir = this.textDirectionAt(line.from), isolates;
        for (let entry of this.bidiCache){
            if (entry.from == line.from && entry.dir == dir && (entry.fresh || $7beee9608540d2c3$var$isolatesEq(entry.isolates, isolates = $7beee9608540d2c3$var$getIsolatedRanges(this, line)))) return entry.order;
        }
        if (!isolates) isolates = $7beee9608540d2c3$var$getIsolatedRanges(this, line);
        let order = $7beee9608540d2c3$var$computeOrder(line.text, dir, isolates);
        this.bidiCache.push(new $7beee9608540d2c3$var$CachedOrder(line.from, line.to, dir, isolates, true, order));
        return order;
    }
    /**
    Check whether the editor has focus.
    */ get hasFocus() {
        var _a;
        // Safari return false for hasFocus when the context menu is open
        // or closing, which leads us to ignore selection changes from the
        // context menu because it looks like the editor isn't focused.
        // This kludges around that.
        return (this.dom.ownerDocument.hasFocus() || $7beee9608540d2c3$var$browser.safari && ((_a = this.inputState) === null || _a === void 0 ? void 0 : _a.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    /**
    Put focus on the editor.
    */ focus() {
        this.observer.ignore(()=>{
            $7beee9608540d2c3$var$focusPreventScroll(this.contentDOM);
            this.docView.updateSelection();
        });
    }
    /**
    Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
    necessary when moving the editor's existing DOM to a new window or shadow root.
    */ setRoot(root) {
        if (this._root != root) {
            this._root = root;
            this.observer.setWindow((root.nodeType == 9 ? root : root.ownerDocument).defaultView || window);
            this.mountStyles();
        }
    }
    /**
    Clean up this editor view, removing its element from the
    document, unregistering event handlers, and notifying
    plugins. The view instance can no longer be used after
    calling this.
    */ destroy() {
        if (this.root.activeElement == this.contentDOM) this.contentDOM.blur();
        for (let plugin of this.plugins)plugin.destroy(this);
        this.plugins = [];
        this.inputState.destroy();
        this.docView.destroy();
        this.dom.remove();
        this.observer.destroy();
        if (this.measureScheduled > -1) this.win.cancelAnimationFrame(this.measureScheduled);
        this.destroyed = true;
    }
    /**
    Returns an effect that can be
    [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
    cause it to scroll the given position or range into view.
    */ static scrollIntoView(pos, options = {}) {
        return $7beee9608540d2c3$var$scrollIntoView.of(new $7beee9608540d2c3$var$ScrollTarget(typeof pos == "number" ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
    }
    /**
    Return an effect that resets the editor to its current (at the
    time this method was called) scroll position. Note that this
    only affects the editor's own scrollable element, not parents.
    See also
    [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
    
    The effect should be used with a document identical to the one
    it was created for. Failing to do so is not an error, but may
    not scroll to the expected position. You can
    [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
    */ scrollSnapshot() {
        let { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.scrollDOM;
        let ref = this.viewState.scrollAnchorAt(scrollTop);
        return $7beee9608540d2c3$var$scrollIntoView.of(new $7beee9608540d2c3$var$ScrollTarget((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
    }
    /**
    Enable or disable tab-focus mode, which disables key bindings
    for Tab and Shift-Tab, letting the browser's default
    focus-changing behavior go through instead. This is useful to
    prevent trapping keyboard users in your editor.
    
    Without argument, this toggles the mode. With a boolean, it
    enables (true) or disables it (false). Given a number, it
    temporarily enables the mode until that number of milliseconds
    have passed or another non-Tab key is pressed.
    */ setTabFocusMode(to) {
        if (to == null) this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
        else if (typeof to == "boolean") this.inputState.tabFocusMode = to ? 0 : -1;
        else if (this.inputState.tabFocusMode != 0) this.inputState.tabFocusMode = Date.now() + to;
    }
    /**
    Returns an extension that can be used to add DOM event handlers.
    The value should be an object mapping event names to handler
    functions. For any given event, such functions are ordered by
    extension precedence, and the first handler to return true will
    be assumed to have handled that event, and no other handlers or
    built-in behavior will be activated for it. These are registered
    on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
    for `scroll` handlers, which will be called any time the
    editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
    its parent nodes is scrolled.
    */ static domEventHandlers(handlers) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define(()=>({}), {
            eventHandlers: handlers
        });
    }
    /**
    Create an extension that registers DOM event observers. Contrary
    to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
    observers can't be prevented from running by a higher-precedence
    handler returning true. They also don't prevent other handlers
    and observers from running when they return true, and should not
    call `preventDefault`.
    */ static domEventObservers(observers) {
        return $7beee9608540d2c3$export$44d5eccfd62adda7.define(()=>({}), {
            eventObservers: observers
        });
    }
    /**
    Create a theme extension. The first argument can be a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)
    style spec providing the styles for the theme. These will be
    prefixed with a generated class for the style.
    
    Because the selectors will be prefixed with a scope class, rule
    that directly match the editor's [wrapper
    element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
    added—need to be explicitly differentiated by adding an `&` to
    the selector for that element—for example
    `&.cm-focused`.
    
    When `dark` is set to true, the theme will be marked as dark,
    which will cause the `&dark` rules from [base
    themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
    `&light` when a light theme is active).
    */ static theme(spec, options) {
        let prefix = (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
        let result = [
            $7beee9608540d2c3$var$theme.of(prefix),
            $7beee9608540d2c3$var$styleModule.of($7beee9608540d2c3$var$buildTheme(`.${prefix}`, spec))
        ];
        if (options && options.dark) result.push($7beee9608540d2c3$var$darkTheme.of(true));
        return result;
    }
    /**
    Create an extension that adds styles to the base theme. Like
    with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
    place of the editor wrapper element when directly targeting
    that. You can also use `&dark` or `&light` instead to only
    target editors with a dark or light theme.
    */ static baseTheme(spec) {
        return (0, $6295c6875f57e3ee$export$b92464a736444411).lowest($7beee9608540d2c3$var$styleModule.of($7beee9608540d2c3$var$buildTheme("." + $7beee9608540d2c3$var$baseThemeID, spec, $7beee9608540d2c3$var$lightDarkIDs)));
    }
    /**
    Retrieve an editor view instance from the view's DOM
    representation.
    */ static findFromDOM(dom) {
        var _a;
        let content = dom.querySelector(".cm-content");
        let cView = content && $7beee9608540d2c3$var$ContentView.get(content) || $7beee9608540d2c3$var$ContentView.get(dom);
        return ((_a = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a === void 0 ? void 0 : _a.view) || null;
    }
}
/**
Facet to add a [style
module](https://github.com/marijnh/style-mod#documentation) to
an editor view. The view will ensure that the module is
mounted in its [document
root](https://codemirror.net/6/docs/ref/#view.EditorView.constructor^config.root).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.styleModule = $7beee9608540d2c3$var$styleModule;
/**
An input handler can override the way changes to the editable
DOM content are handled. Handlers are passed the document
positions between which the change was found, and the new
content. When one returns true, no further input handlers are
called and the default behavior is prevented.

The `insert` argument can be used to get the default transaction
that would be applied for this input. This can be useful when
dispatching the custom behavior as a separate transaction.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.inputHandler = $7beee9608540d2c3$var$inputHandler;
/**
Scroll handlers can override how things are scrolled into view.
If they return `true`, no further handling happens for the
scrolling. If they return false, the default scroll behavior is
applied. Scroll handlers should never initiate editor updates.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.scrollHandler = $7beee9608540d2c3$var$scrollHandler;
/**
This facet can be used to provide functions that create effects
to be dispatched when the editor's focus state changes.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.focusChangeEffect = $7beee9608540d2c3$var$focusChangeEffect;
/**
By default, the editor assumes all its content has the same
[text direction](https://codemirror.net/6/docs/ref/#view.Direction). Configure this with a `true`
value to make it read the text direction of every (rendered)
line separately.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.perLineTextDirection = $7beee9608540d2c3$var$perLineTextDirection;
/**
Allows you to provide a function that should be called when the
library catches an exception from an extension (mostly from view
plugins, but may be used by other extensions to route exceptions
from user-code-provided callbacks). This is mostly useful for
debugging and logging. See [`logException`](https://codemirror.net/6/docs/ref/#view.logException).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.exceptionSink = $7beee9608540d2c3$var$exceptionSink;
/**
A facet that can be used to register a function to be called
every time the view updates.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.updateListener = $7beee9608540d2c3$var$updateListener;
/**
Facet that controls whether the editor content DOM is editable.
When its highest-precedence value is `false`, the element will
not have its `contenteditable` attribute set. (Note that this
doesn't affect API calls that change the editor content, even
when those are bound to keys or buttons. See the
[`readOnly`](https://codemirror.net/6/docs/ref/#state.EditorState.readOnly) facet for that.)
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.editable = $7beee9608540d2c3$var$editable;
/**
Allows you to influence the way mouse selection happens. The
functions in this facet will be called for a `mousedown` event
on the editor, and can return an object that overrides the way a
selection is computed from that mouse click or drag.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.mouseSelectionStyle = $7beee9608540d2c3$var$mouseSelectionStyle;
/**
Facet used to configure whether a given selection drag event
should move or copy the selection. The given predicate will be
called with the `mousedown` event, and can return `true` when
the drag should move the content.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.dragMovesSelection = $7beee9608540d2c3$var$dragMovesSelection$1;
/**
Facet used to configure whether a given selecting click adds a
new range to the existing selection or replaces it entirely. The
default behavior is to check `event.metaKey` on macOS, and
`event.ctrlKey` elsewhere.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.clickAddsSelectionRange = $7beee9608540d2c3$var$clickAddsSelectionRange;
/**
A facet that determines which [decorations](https://codemirror.net/6/docs/ref/#view.Decoration)
are shown in the view. Decorations can be provided in two
ways—directly, or via a function that takes an editor view.

Only decoration sets provided directly are allowed to influence
the editor's vertical layout structure. The ones provided as
functions are called _after_ the new viewport has been computed,
and thus **must not** introduce block widgets or replacing
decorations that cover line breaks.

If you want decorated ranges to behave like atomic units for
cursor motion and deletion purposes, also provide the range set
containing the decorations to
[`EditorView.atomicRanges`](https://codemirror.net/6/docs/ref/#view.EditorView^atomicRanges).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.decorations = $7beee9608540d2c3$var$decorations;
/**
Facet that works much like
[`decorations`](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), but puts its
inputs at the very bottom of the precedence stack, meaning mark
decorations provided here will only be split by other, partially
overlapping \`outerDecorations\` ranges, and wrap around all
regular decorations. Use this for mark elements that should, as
much as possible, remain in one piece.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.outerDecorations = $7beee9608540d2c3$var$outerDecorations;
/**
Used to provide ranges that should be treated as atoms as far as
cursor motion is concerned. This causes methods like
[`moveByChar`](https://codemirror.net/6/docs/ref/#view.EditorView.moveByChar) and
[`moveVertically`](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) (and the
commands built on top of them) to skip across such regions when
a selection endpoint would enter them. This does _not_ prevent
direct programmatic [selection
updates](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) from moving into such
regions.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.atomicRanges = $7beee9608540d2c3$var$atomicRanges;
/**
When range decorations add a `unicode-bidi: isolate` style, they
should also include a
[`bidiIsolate`](https://codemirror.net/6/docs/ref/#view.MarkDecorationSpec.bidiIsolate) property
in their decoration spec, and be exposed through this facet, so
that the editor can compute the proper text order. (Other values
for `unicode-bidi`, except of course `normal`, are not
supported.)
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.bidiIsolatedRanges = $7beee9608540d2c3$var$bidiIsolatedRanges;
/**
Facet that allows extensions to provide additional scroll
margins (space around the sides of the scrolling element that
should be considered invisible). This can be useful when the
plugin introduces elements that cover part of that element (for
example a horizontally fixed gutter).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins = $7beee9608540d2c3$var$scrollMargins;
/**
This facet records whether a dark theme is active. The extension
returned by [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme) automatically
includes an instance of this when the `dark` option is set to
true.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.darkTheme = $7beee9608540d2c3$var$darkTheme;
/**
Provides a Content Security Policy nonce to use when creating
the style sheets for the editor. Holds the empty string when no
nonce has been provided.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.cspNonce = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.length ? values[0] : ""
});
/**
Facet that provides additional DOM attributes for the editor's
editable DOM element.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes = $7beee9608540d2c3$var$contentAttributes;
/**
Facet that provides DOM attributes for the editor's outer
element.
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.editorAttributes = $7beee9608540d2c3$var$editorAttributes;
/**
An extension that enables line wrapping in the editor (by
setting CSS `white-space` to `pre-wrap` in the content).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.lineWrapping = /*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of({
    "class": "cm-lineWrapping"
});
/**
State effect used to include screen reader announcements in a
transaction. These will be added to the DOM in a visually hidden
element with `aria-live="polite"` set, and should be used to
describe effects that are visually obvious but may not be
noticed by screen reader users (such as moving to the next
search match).
*/ $7beee9608540d2c3$export$eece2fccabbb77c5.announce = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
// Maximum line length for which we compute accurate bidi info
const $7beee9608540d2c3$var$MaxBidiLine = 4096;
const $7beee9608540d2c3$var$BadMeasure = {};
class $7beee9608540d2c3$var$CachedOrder {
    constructor(from, to, dir, isolates, fresh, order){
        this.from = from;
        this.to = to;
        this.dir = dir;
        this.isolates = isolates;
        this.fresh = fresh;
        this.order = order;
    }
    static update(cache, changes) {
        if (changes.empty && !cache.some((c)=>c.fresh)) return cache;
        let result = [], lastDir = cache.length ? cache[cache.length - 1].dir : $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
        for(let i = Math.max(0, cache.length - 10); i < cache.length; i++){
            let entry = cache[i];
            if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to)) result.push(new $7beee9608540d2c3$var$CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
        }
        return result;
    }
}
function $7beee9608540d2c3$var$attrsFromFacet(view, facet, base) {
    for(let sources = view.state.facet(facet), i = sources.length - 1; i >= 0; i--){
        let source = sources[i], value = typeof source == "function" ? source(view) : source;
        if (value) $7beee9608540d2c3$var$combineAttrs(value, base);
    }
    return base;
}
const $7beee9608540d2c3$var$currentPlatform = $7beee9608540d2c3$var$browser.mac ? "mac" : $7beee9608540d2c3$var$browser.windows ? "win" : $7beee9608540d2c3$var$browser.linux ? "linux" : "key";
function $7beee9608540d2c3$var$normalizeKeyName(name, platform) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; ++i){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if (platform == "mac") meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $7beee9608540d2c3$var$modifiers(name, event, shift) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift !== false && event.shiftKey) name = "Shift-" + name;
    return name;
}
const $7beee9608540d2c3$var$handleKeyEvents = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).default(/*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.domEventHandlers({
    keydown (event, view) {
        return $7beee9608540d2c3$var$runHandlers($7beee9608540d2c3$var$getKeymap(view.state), event, view, "editor");
    }
}));
/**
Facet used for registering keymaps.

You can add multiple keymaps to an editor. Their priorities
determine their precedence (the ones specified early or with high
priority get checked first). When a handler has returned `true`
for a given key, no further handlers are called.
*/ const $7beee9608540d2c3$export$5043418e2ef368d5 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: $7beee9608540d2c3$var$handleKeyEvents
});
const $7beee9608540d2c3$var$Keymaps = /*@__PURE__*/ new WeakMap();
// This is hidden behind an indirection, rather than directly computed
// by the facet, to keep internal types out of the facet's type.
function $7beee9608540d2c3$var$getKeymap(state) {
    let bindings = state.facet($7beee9608540d2c3$export$5043418e2ef368d5);
    let map = $7beee9608540d2c3$var$Keymaps.get(bindings);
    if (!map) $7beee9608540d2c3$var$Keymaps.set(bindings, map = $7beee9608540d2c3$var$buildKeymap(bindings.reduce((a, b)=>a.concat(b), [])));
    return map;
}
/**
Run the key handlers registered for a given scope. The event
object should be a `"keydown"` event. Returns true if any of the
handlers handled it.
*/ function $7beee9608540d2c3$export$bce154f45536286e(view, event, scope) {
    return $7beee9608540d2c3$var$runHandlers($7beee9608540d2c3$var$getKeymap(view.state), event, view, scope);
}
let $7beee9608540d2c3$var$storedPrefix = null;
const $7beee9608540d2c3$var$PrefixTimeout = 4000;
function $7beee9608540d2c3$var$buildKeymap(bindings, platform = $7beee9608540d2c3$var$currentPlatform) {
    let bound = Object.create(null);
    let isPrefix = Object.create(null);
    let checkPrefix = (name, is)=>{
        let current = isPrefix[name];
        if (current == null) isPrefix[name] = is;
        else if (current != is) throw new Error("Key binding " + name + " is used both as a regular binding and as a multi-stroke prefix");
    };
    let add = (scope, key, command, preventDefault, stopPropagation)=>{
        var _a, _b;
        let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
        let parts = key.split(/ (?!$)/).map((k)=>$7beee9608540d2c3$var$normalizeKeyName(k, platform));
        for(let i = 1; i < parts.length; i++){
            let prefix = parts.slice(0, i).join(" ");
            checkPrefix(prefix, true);
            if (!scopeObj[prefix]) scopeObj[prefix] = {
                preventDefault: true,
                stopPropagation: false,
                run: [
                    (view)=>{
                        let ourObj = $7beee9608540d2c3$var$storedPrefix = {
                            view: view,
                            prefix: prefix,
                            scope: scope
                        };
                        setTimeout(()=>{
                            if ($7beee9608540d2c3$var$storedPrefix == ourObj) $7beee9608540d2c3$var$storedPrefix = null;
                        }, $7beee9608540d2c3$var$PrefixTimeout);
                        return true;
                    }
                ]
            };
        }
        let full = parts.join(" ");
        checkPrefix(full, false);
        let binding = scopeObj[full] || (scopeObj[full] = {
            preventDefault: false,
            stopPropagation: false,
            run: ((_b = (_a = scopeObj._any) === null || _a === void 0 ? void 0 : _a.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
        });
        if (command) binding.run.push(command);
        if (preventDefault) binding.preventDefault = true;
        if (stopPropagation) binding.stopPropagation = true;
    };
    for (let b of bindings){
        let scopes = b.scope ? b.scope.split(" ") : [
            "editor"
        ];
        if (b.any) for (let scope of scopes){
            let scopeObj = bound[scope] || (bound[scope] = Object.create(null));
            if (!scopeObj._any) scopeObj._any = {
                preventDefault: false,
                stopPropagation: false,
                run: []
            };
            let { any: any } = b;
            for(let key in scopeObj)scopeObj[key].run.push((view)=>any(view, $7beee9608540d2c3$var$currentKeyEvent));
        }
        let name = b[platform] || b.key;
        if (!name) continue;
        for (let scope of scopes){
            add(scope, name, b.run, b.preventDefault, b.stopPropagation);
            if (b.shift) add(scope, "Shift-" + name, b.shift, b.preventDefault, b.stopPropagation);
        }
    }
    return bound;
}
let $7beee9608540d2c3$var$currentKeyEvent = null;
function $7beee9608540d2c3$var$runHandlers(map, event, view, scope) {
    $7beee9608540d2c3$var$currentKeyEvent = event;
    let name = (0, $68b9e7c405929963$export$fb33aafd75404f4c)(event);
    let charCode = (0, $6295c6875f57e3ee$export$42977f40461e1360)(name, 0), isChar = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(charCode) == name.length && name != " ";
    let prefix = "", handled = false, prevented = false, stopPropagation = false;
    if ($7beee9608540d2c3$var$storedPrefix && $7beee9608540d2c3$var$storedPrefix.view == view && $7beee9608540d2c3$var$storedPrefix.scope == scope) {
        prefix = $7beee9608540d2c3$var$storedPrefix.prefix + " ";
        if ($7beee9608540d2c3$var$modifierCodes.indexOf(event.keyCode) < 0) {
            prevented = true;
            $7beee9608540d2c3$var$storedPrefix = null;
        }
    }
    let ran = new Set;
    let runFor = (binding)=>{
        if (binding) {
            for (let cmd of binding.run)if (!ran.has(cmd)) {
                ran.add(cmd);
                if (cmd(view)) {
                    if (binding.stopPropagation) stopPropagation = true;
                    return true;
                }
            }
            if (binding.preventDefault) {
                if (binding.stopPropagation) stopPropagation = true;
                prevented = true;
            }
        }
        return false;
    };
    let scopeObj = map[scope], baseName, shiftName;
    if (scopeObj) {
        if (runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(name, event, !isChar)])) handled = true;
        else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
        !($7beee9608540d2c3$var$browser.windows && event.ctrlKey && event.altKey) && (baseName = (0, $68b9e7c405929963$export$e2253033e6e1df16)[event.keyCode]) && baseName != name) {
            if (runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(baseName, event, true)])) handled = true;
            else if (event.shiftKey && (shiftName = (0, $68b9e7c405929963$export$fba63a578e423eb)[event.keyCode]) != name && shiftName != baseName && runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(shiftName, event, false)])) handled = true;
        } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + $7beee9608540d2c3$var$modifiers(name, event, true)])) handled = true;
        if (!handled && runFor(scopeObj._any)) handled = true;
    }
    if (prevented) handled = true;
    if (handled && stopPropagation) event.stopPropagation();
    $7beee9608540d2c3$var$currentKeyEvent = null;
    return handled;
}
/**
Implementation of [`LayerMarker`](https://codemirror.net/6/docs/ref/#view.LayerMarker) that creates
a rectangle at a given set of coordinates.
*/ class $7beee9608540d2c3$export$9ddce7bd14f42a78 {
    /**
    Create a marker with the given class and dimensions. If `width`
    is null, the DOM element will get no width style.
    */ constructor(className, /**
    The left position of the marker (in pixels, document-relative).
    */ left, /**
    The top position of the marker.
    */ top, /**
    The width of the marker, or null if it shouldn't get a width assigned.
    */ width, /**
    The height of the marker.
    */ height){
        this.className = className;
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    draw() {
        let elt = document.createElement("div");
        elt.className = this.className;
        this.adjust(elt);
        return elt;
    }
    update(elt, prev) {
        if (prev.className != this.className) return false;
        this.adjust(elt);
        return true;
    }
    adjust(elt) {
        elt.style.left = this.left + "px";
        elt.style.top = this.top + "px";
        if (this.width != null) elt.style.width = this.width + "px";
        elt.style.height = this.height + "px";
    }
    eq(p) {
        return this.left == p.left && this.top == p.top && this.width == p.width && this.height == p.height && this.className == p.className;
    }
    /**
    Create a set of rectangles for the given selection range,
    assigning them theclass`className`. Will create a single
    rectangle for empty ranges, and a set of selection-style
    rectangles covering the range's content (in a bidi-aware
    way) for non-empty ones.
    */ static forRange(view, className, range) {
        if (range.empty) {
            let pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (!pos) return [];
            let base = $7beee9608540d2c3$var$getBase(view);
            return [
                new $7beee9608540d2c3$export$9ddce7bd14f42a78(className, pos.left - base.left, pos.top - base.top, null, pos.bottom - pos.top)
            ];
        } else return $7beee9608540d2c3$var$rectanglesForRange(view, className, range);
    }
}
function $7beee9608540d2c3$var$getBase(view) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let left = view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
    return {
        left: left - view.scrollDOM.scrollLeft * view.scaleX,
        top: rect.top - view.scrollDOM.scrollTop * view.scaleY
    };
}
function $7beee9608540d2c3$var$wrappedLine(view, pos, side, inside) {
    let coords = view.coordsAtPos(pos, side * 2);
    if (!coords) return inside;
    let editorRect = view.dom.getBoundingClientRect();
    let y = (coords.top + coords.bottom) / 2;
    let left = view.posAtCoords({
        x: editorRect.left + 1,
        y: y
    });
    let right = view.posAtCoords({
        x: editorRect.right - 1,
        y: y
    });
    if (left == null || right == null) return inside;
    return {
        from: Math.max(inside.from, Math.min(left, right)),
        to: Math.min(inside.to, Math.max(left, right))
    };
}
function $7beee9608540d2c3$var$rectanglesForRange(view, className, range) {
    if (range.to <= view.viewport.from || range.from >= view.viewport.to) return [];
    let from = Math.max(range.from, view.viewport.from), to = Math.min(range.to, view.viewport.to);
    let ltr = view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
    let content = view.contentDOM, contentRect = content.getBoundingClientRect(), base = $7beee9608540d2c3$var$getBase(view);
    let lineElt = content.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
    let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
    let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
    let startBlock = $7beee9608540d2c3$var$blockAt(view, from), endBlock = $7beee9608540d2c3$var$blockAt(view, to);
    let visualStart = startBlock.type == $7beee9608540d2c3$export$48808c686fe495c4.Text ? startBlock : null;
    let visualEnd = endBlock.type == $7beee9608540d2c3$export$48808c686fe495c4.Text ? endBlock : null;
    if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks)) visualStart = $7beee9608540d2c3$var$wrappedLine(view, from, 1, visualStart);
    if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks)) visualEnd = $7beee9608540d2c3$var$wrappedLine(view, to, -1, visualEnd);
    if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) return pieces(drawForLine(range.from, range.to, visualStart));
    else {
        let top = visualStart ? drawForLine(range.from, null, visualStart) : drawForWidget(startBlock, false);
        let bottom = visualEnd ? drawForLine(null, range.to, visualEnd) : drawForWidget(endBlock, true);
        let between = [];
        if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top.bottom + view.defaultLineHeight / 2 < bottom.top) between.push(piece(leftSide, top.bottom, rightSide, bottom.top));
        else if (top.bottom < bottom.top && view.elementAtHeight((top.bottom + bottom.top) / 2).type == $7beee9608540d2c3$export$48808c686fe495c4.Text) top.bottom = bottom.top = (top.bottom + bottom.top) / 2;
        return pieces(top).concat(between).concat(pieces(bottom));
    }
    function piece(left, top, right, bottom) {
        return new $7beee9608540d2c3$export$9ddce7bd14f42a78(className, left - base.left, top - base.top - 0.01 /* C.Epsilon */ , right - left, bottom - top + 0.01 /* C.Epsilon */ );
    }
    function pieces({ top: top, bottom: bottom, horizontal: horizontal }) {
        let pieces = [];
        for(let i = 0; i < horizontal.length; i += 2)pieces.push(piece(horizontal[i], top, horizontal[i + 1], bottom));
        return pieces;
    }
    // Gets passed from/to in line-local positions
    function drawForLine(from, to, line) {
        let top = 1e9, bottom = -1000000000, horizontal = [];
        function addSpan(from, fromOpen, to, toOpen, dir) {
            // Passing 2/-2 is a kludge to force the view to return
            // coordinates on the proper side of block widgets, since
            // normalizing the side there, though appropriate for most
            // coordsAtPos queries, would break selection drawing.
            let fromCoords = view.coordsAtPos(from, from == line.to ? -2 : 2);
            let toCoords = view.coordsAtPos(to, to == line.from ? 2 : -2);
            if (!fromCoords || !toCoords) return;
            top = Math.min(fromCoords.top, toCoords.top, top);
            bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
            if (dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR) horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
            else horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
        }
        let start = from !== null && from !== void 0 ? from : line.from, end = to !== null && to !== void 0 ? to : line.to;
        // Split the range by visible range and document line
        for (let r of view.visibleRanges)if (r.to > start && r.from < end) for(let pos = Math.max(r.from, start), endPos = Math.min(r.to, end);;){
            let docLine = view.state.doc.lineAt(pos);
            for (let span of view.bidiSpans(docLine)){
                let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
                if (spanFrom >= endPos) break;
                if (spanTo > pos) addSpan(Math.max(spanFrom, pos), from == null && spanFrom <= start, Math.min(spanTo, endPos), to == null && spanTo >= end, span.dir);
            }
            pos = docLine.to + 1;
            if (pos >= endPos) break;
        }
        if (horizontal.length == 0) addSpan(start, from == null, end, to == null, view.textDirection);
        return {
            top: top,
            bottom: bottom,
            horizontal: horizontal
        };
    }
    function drawForWidget(block, top) {
        let y = contentRect.top + (top ? block.top : block.bottom);
        return {
            top: y,
            bottom: y,
            horizontal: []
        };
    }
}
function $7beee9608540d2c3$var$sameMarker(a, b) {
    return a.constructor == b.constructor && a.eq(b);
}
class $7beee9608540d2c3$var$LayerView {
    constructor(view, layer){
        this.view = view;
        this.layer = layer;
        this.drawn = [];
        this.scaleX = 1;
        this.scaleY = 1;
        this.measureReq = {
            read: this.measure.bind(this),
            write: this.draw.bind(this)
        };
        this.dom = view.scrollDOM.appendChild(document.createElement("div"));
        this.dom.classList.add("cm-layer");
        if (layer.above) this.dom.classList.add("cm-layer-above");
        if (layer.class) this.dom.classList.add(layer.class);
        this.scale();
        this.dom.setAttribute("aria-hidden", "true");
        this.setOrder(view.state);
        view.requestMeasure(this.measureReq);
        if (layer.mount) layer.mount(this.dom, view);
    }
    update(update) {
        if (update.startState.facet($7beee9608540d2c3$var$layerOrder) != update.state.facet($7beee9608540d2c3$var$layerOrder)) this.setOrder(update.state);
        if (this.layer.update(update, this.dom) || update.geometryChanged) {
            this.scale();
            update.view.requestMeasure(this.measureReq);
        }
    }
    docViewUpdate(view) {
        if (this.layer.updateOnDocViewUpdate !== false) view.requestMeasure(this.measureReq);
    }
    setOrder(state) {
        let pos = 0, order = state.facet($7beee9608540d2c3$var$layerOrder);
        while(pos < order.length && order[pos] != this.layer)pos++;
        this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
    }
    measure() {
        return this.layer.markers(this.view);
    }
    scale() {
        let { scaleX: scaleX, scaleY: scaleY } = this.view;
        if (scaleX != this.scaleX || scaleY != this.scaleY) {
            this.scaleX = scaleX;
            this.scaleY = scaleY;
            this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
        }
    }
    draw(markers) {
        if (markers.length != this.drawn.length || markers.some((p, i)=>!$7beee9608540d2c3$var$sameMarker(p, this.drawn[i]))) {
            let old = this.dom.firstChild, oldI = 0;
            for (let marker of markers)if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
                old = old.nextSibling;
                oldI++;
            } else this.dom.insertBefore(marker.draw(), old);
            while(old){
                let next = old.nextSibling;
                old.remove();
                old = next;
            }
            this.drawn = markers;
        }
    }
    destroy() {
        if (this.layer.destroy) this.layer.destroy(this.dom, this.view);
        this.dom.remove();
    }
}
const $7beee9608540d2c3$var$layerOrder = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Define a layer.
*/ function $7beee9608540d2c3$export$50a222d9023da98b(config) {
    return [
        $7beee9608540d2c3$export$44d5eccfd62adda7.define((v)=>new $7beee9608540d2c3$var$LayerView(v, config)),
        $7beee9608540d2c3$var$layerOrder.of(config)
    ];
}
const $7beee9608540d2c3$var$CanHidePrimary = !$7beee9608540d2c3$var$browser.ios; // FIXME test IE
const $7beee9608540d2c3$var$selectionConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            cursorBlinkRate: 1200,
            drawRangeCursor: true
        }, {
            cursorBlinkRate: (a, b)=>Math.min(a, b),
            drawRangeCursor: (a, b)=>a || b
        });
    }
});
/**
Returns an extension that hides the browser's native selection and
cursor, replacing the selection with a background behind the text
(with the `cm-selectionBackground` class), and the
cursors with elements overlaid over the code (using
`cm-cursor-primary` and `cm-cursor-secondary`).

This allows the editor to display secondary selection ranges, and
tends to produce a type of selection more in line with that users
expect in a text editor (the native selection styling will often
leave gaps between lines and won't fill the horizontal space after
a line when the selection continues past it).

It does have a performance cost, in that it requires an extra DOM
layout cycle for many updates (the selection is drawn based on DOM
layout information that's only available after laying out the
content).
*/ function $7beee9608540d2c3$export$17a3d0ab3687347d(config = {}) {
    return [
        $7beee9608540d2c3$var$selectionConfig.of(config),
        $7beee9608540d2c3$var$cursorLayer,
        $7beee9608540d2c3$var$selectionLayer,
        $7beee9608540d2c3$var$hideNativeSelection,
        $7beee9608540d2c3$var$nativeSelectionHidden.of(true)
    ];
}
/**
Retrieve the [`drawSelection`](https://codemirror.net/6/docs/ref/#view.drawSelection) configuration
for this state. (Note that this will return a set of defaults even
if `drawSelection` isn't enabled.)
*/ function $7beee9608540d2c3$export$74e411a7b5f41f23(state) {
    return state.facet($7beee9608540d2c3$var$selectionConfig);
}
function $7beee9608540d2c3$var$configChanged(update) {
    return update.startState.facet($7beee9608540d2c3$var$selectionConfig) != update.state.facet($7beee9608540d2c3$var$selectionConfig);
}
const $7beee9608540d2c3$var$cursorLayer = /*@__PURE__*/ $7beee9608540d2c3$export$50a222d9023da98b({
    above: true,
    markers (view) {
        let { state: state } = view, conf = state.facet($7beee9608540d2c3$var$selectionConfig);
        let cursors = [];
        for (let r of state.selection.ranges){
            let prim = r == state.selection.main;
            if (r.empty ? !prim || $7beee9608540d2c3$var$CanHidePrimary : conf.drawRangeCursor) {
                let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
                let cursor = r.empty ? r : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(r.head, r.head > r.anchor ? -1 : 1);
                for (let piece of $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, className, cursor))cursors.push(piece);
            }
        }
        return cursors;
    },
    update (update, dom) {
        if (update.transactions.some((tr)=>tr.selection)) dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
        let confChange = $7beee9608540d2c3$var$configChanged(update);
        if (confChange) $7beee9608540d2c3$var$setBlinkRate(update.state, dom);
        return update.docChanged || update.selectionSet || confChange;
    },
    mount (dom, view) {
        $7beee9608540d2c3$var$setBlinkRate(view.state, dom);
    },
    class: "cm-cursorLayer"
});
function $7beee9608540d2c3$var$setBlinkRate(state, dom) {
    dom.style.animationDuration = state.facet($7beee9608540d2c3$var$selectionConfig).cursorBlinkRate + "ms";
}
const $7beee9608540d2c3$var$selectionLayer = /*@__PURE__*/ $7beee9608540d2c3$export$50a222d9023da98b({
    above: false,
    markers (view) {
        return view.state.selection.ranges.map((r)=>r.empty ? [] : $7beee9608540d2c3$export$9ddce7bd14f42a78.forRange(view, "cm-selectionBackground", r)).reduce((a, b)=>a.concat(b));
    },
    update (update, dom) {
        return update.docChanged || update.selectionSet || update.viewportChanged || $7beee9608540d2c3$var$configChanged(update);
    },
    class: "cm-selectionLayer"
});
const $7beee9608540d2c3$var$themeSpec = {
    ".cm-line": {
        "& ::selection, &::selection": {
            backgroundColor: "transparent !important"
        }
    },
    ".cm-content": {
        "& :focus": {
            caretColor: "initial !important",
            "&::selection, & ::selection": {
                backgroundColor: "Highlight !important"
            }
        }
    }
};
if ($7beee9608540d2c3$var$CanHidePrimary) $7beee9608540d2c3$var$themeSpec[".cm-line"].caretColor = $7beee9608540d2c3$var$themeSpec[".cm-content"].caretColor = "transparent !important";
const $7beee9608540d2c3$var$hideNativeSelection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.theme($7beee9608540d2c3$var$themeSpec));
const $7beee9608540d2c3$var$setDropCursorPos = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (pos, mapping) {
        return pos == null ? null : mapping.mapPos(pos);
    }
});
const $7beee9608540d2c3$var$dropCursorPos = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (pos, tr) {
        if (pos != null) pos = tr.changes.mapPos(pos);
        return tr.effects.reduce((pos, e)=>e.is($7beee9608540d2c3$var$setDropCursorPos) ? e.value : pos, pos);
    }
});
const $7beee9608540d2c3$var$drawDropCursor = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.cursor = null;
        this.measureReq = {
            read: this.readPos.bind(this),
            write: this.drawCursor.bind(this)
        };
    }
    update(update) {
        var _a;
        let cursorPos = update.state.field($7beee9608540d2c3$var$dropCursorPos);
        if (cursorPos == null) {
            if (this.cursor != null) {
                (_a = this.cursor) === null || _a === void 0 || _a.remove();
                this.cursor = null;
            }
        } else {
            if (!this.cursor) {
                this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
                this.cursor.className = "cm-dropCursor";
            }
            if (update.startState.field($7beee9608540d2c3$var$dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged) this.view.requestMeasure(this.measureReq);
        }
    }
    readPos() {
        let { view: view } = this;
        let pos = view.state.field($7beee9608540d2c3$var$dropCursorPos);
        let rect = pos != null && view.coordsAtPos(pos);
        if (!rect) return null;
        let outer = view.scrollDOM.getBoundingClientRect();
        return {
            left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
            top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
            height: rect.bottom - rect.top
        };
    }
    drawCursor(pos) {
        if (this.cursor) {
            let { scaleX: scaleX, scaleY: scaleY } = this.view;
            if (pos) {
                this.cursor.style.left = pos.left / scaleX + "px";
                this.cursor.style.top = pos.top / scaleY + "px";
                this.cursor.style.height = pos.height / scaleY + "px";
            } else this.cursor.style.left = "-100000px";
        }
    }
    destroy() {
        if (this.cursor) this.cursor.remove();
    }
    setDropPos(pos) {
        if (this.view.state.field($7beee9608540d2c3$var$dropCursorPos) != pos) this.view.dispatch({
            effects: $7beee9608540d2c3$var$setDropCursorPos.of(pos)
        });
    }
}, {
    eventObservers: {
        dragover (event) {
            this.setDropPos(this.view.posAtCoords({
                x: event.clientX,
                y: event.clientY
            }));
        },
        dragleave (event) {
            if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget)) this.setDropPos(null);
        },
        dragend () {
            this.setDropPos(null);
        },
        drop () {
            this.setDropPos(null);
        }
    }
});
/**
Draws a cursor at the current drop position when something is
dragged over the editor.
*/ function $7beee9608540d2c3$export$b8e3092a3bfa2062() {
    return [
        $7beee9608540d2c3$var$dropCursorPos,
        $7beee9608540d2c3$var$drawDropCursor
    ];
}
function $7beee9608540d2c3$var$iterMatches(doc, re, from, to, f) {
    re.lastIndex = 0;
    for(let cursor = doc.iterRange(from, to), pos = from, m; !cursor.next().done; pos += cursor.value.length){
        if (!cursor.lineBreak) while(m = re.exec(cursor.value))f(pos + m.index, m);
    }
}
function $7beee9608540d2c3$var$matchRanges(view, maxLength) {
    let visible = view.visibleRanges;
    if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to) return visible;
    let result = [];
    for (let { from: from, to: to } of visible){
        from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
        to = Math.min(view.state.doc.lineAt(to).to, to + maxLength);
        if (result.length && result[result.length - 1].to >= from) result[result.length - 1].to = to;
        else result.push({
            from: from,
            to: to
        });
    }
    return result;
}
/**
Helper class used to make it easier to maintain decorations on
visible code that matches a given regular expression. To be used
in a [view plugin](https://codemirror.net/6/docs/ref/#view.ViewPlugin). Instances of this object
represent a matching configuration.
*/ class $7beee9608540d2c3$export$9b928b0ca20b25cb {
    /**
    Create a decorator.
    */ constructor(config){
        const { regexp: regexp, decoration: decoration, decorate: decorate, boundary: boundary, maxLength: maxLength = 1000 } = config;
        if (!regexp.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
        this.regexp = regexp;
        if (decorate) this.addMatch = (match, view, from, add)=>decorate(add, from, from + match[0].length, match, view);
        else if (typeof decoration == "function") this.addMatch = (match, view, from, add)=>{
            let deco = decoration(match, view, from);
            if (deco) add(from, from + match[0].length, deco);
        };
        else if (decoration) this.addMatch = (match, _view, from, add)=>add(from, from + match[0].length, decoration);
        else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
        this.boundary = boundary;
        this.maxLength = maxLength;
    }
    /**
    Compute the full set of decorations for matches in the given
    view's viewport. You'll want to call this when initializing your
    plugin.
    */ createDeco(view) {
        let build = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)(), add = build.add.bind(build);
        for (let { from: from, to: to } of $7beee9608540d2c3$var$matchRanges(view, this.maxLength))$7beee9608540d2c3$var$iterMatches(view.state.doc, this.regexp, from, to, (from, m)=>this.addMatch(m, view, from, add));
        return build.finish();
    }
    /**
    Update a set of decorations for a view update. `deco` _must_ be
    the set of decorations produced by _this_ `MatchDecorator` for
    the view state before the update.
    */ updateDeco(update, deco) {
        let changeFrom = 1e9, changeTo = -1;
        if (update.docChanged) update.changes.iterChanges((_f, _t, from, to)=>{
            if (to > update.view.viewport.from && from < update.view.viewport.to) {
                changeFrom = Math.min(from, changeFrom);
                changeTo = Math.max(to, changeTo);
            }
        });
        if (update.viewportChanged || changeTo - changeFrom > 1000) return this.createDeco(update.view);
        if (changeTo > -1) return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
        return deco;
    }
    updateRange(view, deco, updateFrom, updateTo) {
        for (let r of view.visibleRanges){
            let from = Math.max(r.from, updateFrom), to = Math.min(r.to, updateTo);
            if (to > from) {
                let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to ? view.state.doc.lineAt(to) : fromLine;
                let start = Math.max(r.from, fromLine.from), end = Math.min(r.to, toLine.to);
                if (this.boundary) {
                    for(; from > fromLine.from; from--)if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
                        start = from;
                        break;
                    }
                    for(; to < toLine.to; to++)if (this.boundary.test(toLine.text[to - toLine.from])) {
                        end = to;
                        break;
                    }
                }
                let ranges = [], m;
                let add = (from, to, deco)=>ranges.push(deco.range(from, to));
                if (fromLine == toLine) {
                    this.regexp.lastIndex = start - fromLine.from;
                    while((m = this.regexp.exec(fromLine.text)) && m.index < end - fromLine.from)this.addMatch(m, view, m.index + fromLine.from, add);
                } else $7beee9608540d2c3$var$iterMatches(view.state.doc, this.regexp, start, end, (from, m)=>this.addMatch(m, view, from, add));
                deco = deco.update({
                    filterFrom: start,
                    filterTo: end,
                    filter: (from, to)=>from < start || to > end,
                    add: ranges
                });
            }
        }
        return deco;
    }
}
const $7beee9608540d2c3$var$UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const $7beee9608540d2c3$var$Specials = /*@__PURE__*/ new RegExp("[\0-\b\n-\x1f\x7f-\x9f\xad\u061C\u200B\u200E\u200F\u2028\u2029\u202D\u202E\u2066\u2067\u2069\uFEFF\uFFF9-\uFFFC]", $7beee9608540d2c3$var$UnicodeRegexpSupport);
const $7beee9608540d2c3$var$Names = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
};
let $7beee9608540d2c3$var$_supportsTabSize = null;
function $7beee9608540d2c3$var$supportsTabSize() {
    var _a;
    if ($7beee9608540d2c3$var$_supportsTabSize == null && typeof document != "undefined" && document.body) {
        let styles = document.body.style;
        $7beee9608540d2c3$var$_supportsTabSize = ((_a = styles.tabSize) !== null && _a !== void 0 ? _a : styles.MozTabSize) != null;
    }
    return $7beee9608540d2c3$var$_supportsTabSize || false;
}
const $7beee9608540d2c3$var$specialCharConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let config = (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            render: null,
            specialChars: $7beee9608540d2c3$var$Specials,
            addSpecialChars: null
        });
        if (config.replaceTabs = !$7beee9608540d2c3$var$supportsTabSize()) config.specialChars = new RegExp("	|" + config.specialChars.source, $7beee9608540d2c3$var$UnicodeRegexpSupport);
        if (config.addSpecialChars) config.specialChars = new RegExp(config.specialChars.source + "|" + config.addSpecialChars.source, $7beee9608540d2c3$var$UnicodeRegexpSupport);
        return config;
    }
});
/**
Returns an extension that installs highlighting of special
characters.
*/ function $7beee9608540d2c3$export$76dc0899547f659c(/**
Configuration options.
*/ config = {}) {
    return [
        $7beee9608540d2c3$var$specialCharConfig.of(config),
        $7beee9608540d2c3$var$specialCharPlugin()
    ];
}
let $7beee9608540d2c3$var$_plugin = null;
function $7beee9608540d2c3$var$specialCharPlugin() {
    return $7beee9608540d2c3$var$_plugin || ($7beee9608540d2c3$var$_plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.decorations = $7beee9608540d2c3$export$10e30b733df217ea.none;
            this.decorationCache = Object.create(null);
            this.decorator = this.makeDecorator(view.state.facet($7beee9608540d2c3$var$specialCharConfig));
            this.decorations = this.decorator.createDeco(view);
        }
        makeDecorator(conf) {
            return new $7beee9608540d2c3$export$9b928b0ca20b25cb({
                regexp: conf.specialChars,
                decoration: (m, view, pos)=>{
                    let { doc: doc } = view.state;
                    let code = (0, $6295c6875f57e3ee$export$42977f40461e1360)(m[0], 0);
                    if (code == 9) {
                        let line = doc.lineAt(pos);
                        let size = view.state.tabSize, col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line.text, size, pos - line.from);
                        return $7beee9608540d2c3$export$10e30b733df217ea.replace({
                            widget: new $7beee9608540d2c3$var$TabWidget((size - col % size) * this.view.defaultCharacterWidth / this.view.scaleX)
                        });
                    }
                    return this.decorationCache[code] || (this.decorationCache[code] = $7beee9608540d2c3$export$10e30b733df217ea.replace({
                        widget: new $7beee9608540d2c3$var$SpecialCharWidget(conf, code)
                    }));
                },
                boundary: conf.replaceTabs ? undefined : /[^]/
            });
        }
        update(update) {
            let conf = update.state.facet($7beee9608540d2c3$var$specialCharConfig);
            if (update.startState.facet($7beee9608540d2c3$var$specialCharConfig) != conf) {
                this.decorator = this.makeDecorator(conf);
                this.decorations = this.decorator.createDeco(update.view);
            } else this.decorations = this.decorator.updateDeco(update, this.decorations);
        }
    }, {
        decorations: (v)=>v.decorations
    }));
}
const $7beee9608540d2c3$var$DefaultPlaceholder = "\u2022";
// Assigns placeholder characters from the Control Pictures block to
// ASCII control characters
function $7beee9608540d2c3$var$placeholder$1(code) {
    if (code >= 32) return $7beee9608540d2c3$var$DefaultPlaceholder;
    if (code == 10) return "\u2424";
    return String.fromCharCode(9216 + code);
}
class $7beee9608540d2c3$var$SpecialCharWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(options, code){
        super();
        this.options = options;
        this.code = code;
    }
    eq(other) {
        return other.code == this.code;
    }
    toDOM(view) {
        let ph = $7beee9608540d2c3$var$placeholder$1(this.code);
        let desc = view.state.phrase("Control character") + " " + ($7beee9608540d2c3$var$Names[this.code] || "0x" + this.code.toString(16));
        let custom = this.options.render && this.options.render(this.code, desc, ph);
        if (custom) return custom;
        let span = document.createElement("span");
        span.textContent = ph;
        span.title = desc;
        span.setAttribute("aria-label", desc);
        span.className = "cm-specialChar";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
class $7beee9608540d2c3$var$TabWidget extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(width){
        super();
        this.width = width;
    }
    eq(other) {
        return other.width == this.width;
    }
    toDOM() {
        let span = document.createElement("span");
        span.textContent = "	";
        span.className = "cm-tab";
        span.style.width = this.width + "px";
        return span;
    }
    ignoreEvent() {
        return false;
    }
}
const $7beee9608540d2c3$var$plugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(){
        this.height = 1000;
        this.attrs = {
            style: "padding-bottom: 1000px"
        };
    }
    update(update) {
        let { view: view } = update;
        let height = view.viewState.editorHeight - view.defaultLineHeight - view.documentPadding.top - 0.5;
        if (height >= 0 && height != this.height) {
            this.height = height;
            this.attrs = {
                style: `padding-bottom: ${height}px`
            };
        }
    }
});
/**
Returns an extension that makes sure the content has a bottom
margin equivalent to the height of the editor, minus one line
height, so that every line in the document can be scrolled to the
top of the editor.

This is only meaningful when the editor is scrollable, and should
not be enabled in editors that take the size of their content.
*/ function $7beee9608540d2c3$export$1f905ef5d6deb4f() {
    return [
        $7beee9608540d2c3$var$plugin,
        $7beee9608540d2c3$var$contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin($7beee9608540d2c3$var$plugin)) === null || _a === void 0 ? void 0 : _a.attrs) || null;
        })
    ];
}
/**
Mark lines that have a cursor on them with the `"cm-activeLine"`
DOM class.
*/ function $7beee9608540d2c3$export$1a7e096bee9035c() {
    return $7beee9608540d2c3$var$activeLineHighlighter;
}
const $7beee9608540d2c3$var$lineDeco = /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.line({
    class: "cm-activeLine"
});
const $7beee9608540d2c3$var$activeLineHighlighter = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.docChanged || update.selectionSet) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let lastLineStart = -1, deco = [];
        for (let r of view.state.selection.ranges){
            let line = view.lineBlockAt(r.head);
            if (line.from > lastLineStart) {
                deco.push($7beee9608540d2c3$var$lineDeco.range(line.from));
                lastLineStart = line.from;
            }
        }
        return $7beee9608540d2c3$export$10e30b733df217ea.set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
class $7beee9608540d2c3$var$Placeholder extends $7beee9608540d2c3$export$95cdd842edb044c5 {
    constructor(content){
        super();
        this.content = content;
    }
    toDOM() {
        let wrap = document.createElement("span");
        wrap.className = "cm-placeholder";
        wrap.style.pointerEvents = "none";
        wrap.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content);
        if (typeof this.content == "string") wrap.setAttribute("aria-label", "placeholder " + this.content);
        else wrap.setAttribute("aria-hidden", "true");
        return wrap;
    }
    coordsAt(dom) {
        let rects = dom.firstChild ? $7beee9608540d2c3$var$clientRectsFor(dom.firstChild) : [];
        if (!rects.length) return null;
        let style = window.getComputedStyle(dom.parentNode);
        let rect = $7beee9608540d2c3$var$flattenRect(rects[0], style.direction != "rtl");
        let lineHeight = parseInt(style.lineHeight);
        if (rect.bottom - rect.top > lineHeight * 1.5) return {
            left: rect.left,
            right: rect.right,
            top: rect.top,
            bottom: rect.top + lineHeight
        };
        return rect;
    }
    ignoreEvent() {
        return false;
    }
}
/**
Extension that enables a placeholder—a piece of example content
to show when the editor is empty.
*/ function $7beee9608540d2c3$export$c7187bbd1a7a9244(content) {
    return $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.placeholder = content ? $7beee9608540d2c3$export$10e30b733df217ea.set([
                $7beee9608540d2c3$export$10e30b733df217ea.widget({
                    widget: new $7beee9608540d2c3$var$Placeholder(content),
                    side: 1
                }).range(0)
            ]) : $7beee9608540d2c3$export$10e30b733df217ea.none;
        }
        get decorations() {
            return this.view.state.doc.length ? $7beee9608540d2c3$export$10e30b733df217ea.none : this.placeholder;
        }
    }, {
        decorations: (v)=>v.decorations
    });
}
// Don't compute precise column positions for line offsets above this
// (since it could get expensive). Assume offset==column for them.
const $7beee9608540d2c3$var$MaxOff = 2000;
function $7beee9608540d2c3$var$rectangleFor(state, a, b) {
    let startLine = Math.min(a.line, b.line), endLine = Math.max(a.line, b.line);
    let ranges = [];
    if (a.off > $7beee9608540d2c3$var$MaxOff || b.off > $7beee9608540d2c3$var$MaxOff || a.col < 0 || b.col < 0) {
        let startOff = Math.min(a.off, b.off), endOff = Math.max(a.off, b.off);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            if (line.length <= endOff) ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(line.from + startOff, line.to + endOff));
        }
    } else {
        let startCol = Math.min(a.col, b.col), endCol = Math.max(a.col, b.col);
        for(let i = startLine; i <= endLine; i++){
            let line = state.doc.line(i);
            let start = (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(line.text, startCol, state.tabSize, true);
            if (start < 0) ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(line.to));
            else {
                let end = (0, $6295c6875f57e3ee$export$718b3d71c384ca05)(line.text, endCol, state.tabSize);
                ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(line.from + start, line.from + end));
            }
        }
    }
    return ranges;
}
function $7beee9608540d2c3$var$absoluteColumn(view, x) {
    let ref = view.coordsAtPos(view.viewport.from);
    return ref ? Math.round(Math.abs((ref.left - x) / view.defaultCharacterWidth)) : -1;
}
function $7beee9608540d2c3$var$getPos(view, event) {
    let offset = view.posAtCoords({
        x: event.clientX,
        y: event.clientY
    }, false);
    let line = view.state.doc.lineAt(offset), off = offset - line.from;
    let col = off > $7beee9608540d2c3$var$MaxOff ? -1 : off == line.length ? $7beee9608540d2c3$var$absoluteColumn(view, event.clientX) : (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line.text, view.state.tabSize, offset - line.from);
    return {
        line: line.number,
        col: col,
        off: off
    };
}
function $7beee9608540d2c3$var$rectangleSelectionStyle(view, event) {
    let start = $7beee9608540d2c3$var$getPos(view, event), startSel = view.state.selection;
    if (!start) return null;
    return {
        update (update) {
            if (update.docChanged) {
                let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
                let newLine = update.state.doc.lineAt(newStart);
                start = {
                    line: newLine.number,
                    col: start.col,
                    off: Math.min(start.off, newLine.length)
                };
                startSel = startSel.map(update.changes);
            }
        },
        get (event, _extend, multiple) {
            let cur = $7beee9608540d2c3$var$getPos(view, event);
            if (!cur) return startSel;
            let ranges = $7beee9608540d2c3$var$rectangleFor(view.state, start, cur);
            if (!ranges.length) return startSel;
            if (multiple) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.concat(startSel.ranges));
            else return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges);
        }
    };
}
/**
Create an extension that enables rectangular selections. By
default, it will react to left mouse drag with the Alt key held
down. When such a selection occurs, the text within the rectangle
that was dragged over will be selected, as one selection
[range](https://codemirror.net/6/docs/ref/#state.SelectionRange) per line.
*/ function $7beee9608540d2c3$export$dd482925db1aabd3(options) {
    let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e)=>e.altKey && e.button == 0);
    return $7beee9608540d2c3$export$eece2fccabbb77c5.mouseSelectionStyle.of((view, event)=>filter(event) ? $7beee9608540d2c3$var$rectangleSelectionStyle(view, event) : null);
}
const $7beee9608540d2c3$var$keys = {
    Alt: [
        18,
        (e)=>!!e.altKey
    ],
    Control: [
        17,
        (e)=>!!e.ctrlKey
    ],
    Shift: [
        16,
        (e)=>!!e.shiftKey
    ],
    Meta: [
        91,
        (e)=>!!e.metaKey
    ]
};
const $7beee9608540d2c3$var$showCrosshair = {
    style: "cursor: crosshair"
};
/**
Returns an extension that turns the pointer cursor into a
crosshair when a given modifier key, defaulting to Alt, is held
down. Can serve as a visual hint that rectangular selection is
going to happen when paired with
[`rectangularSelection`](https://codemirror.net/6/docs/ref/#view.rectangularSelection).
*/ function $7beee9608540d2c3$export$9b6525222ac3b7fb(options = {}) {
    let [code, getter] = $7beee9608540d2c3$var$keys[options.key || "Alt"];
    let plugin = $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
        constructor(view){
            this.view = view;
            this.isDown = false;
        }
        set(isDown) {
            if (this.isDown != isDown) {
                this.isDown = isDown;
                this.view.update([]);
            }
        }
    }, {
        eventObservers: {
            keydown (e) {
                this.set(e.keyCode == code || getter(e));
            },
            keyup (e) {
                if (e.keyCode == code || !getter(e)) this.set(false);
            },
            mousemove (e) {
                this.set(getter(e));
            }
        }
    });
    return [
        plugin,
        $7beee9608540d2c3$export$eece2fccabbb77c5.contentAttributes.of((view)=>{
            var _a;
            return ((_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.isDown) ? $7beee9608540d2c3$var$showCrosshair : null;
        })
    ];
}
const $7beee9608540d2c3$var$Outside = "-10000px";
class $7beee9608540d2c3$var$TooltipViewManager {
    constructor(view, facet, createTooltipView, removeTooltipView){
        this.facet = facet;
        this.createTooltipView = createTooltipView;
        this.removeTooltipView = removeTooltipView;
        this.input = view.state.facet(facet);
        this.tooltips = this.input.filter((t)=>t);
        let prev = null;
        this.tooltipViews = this.tooltips.map((t)=>prev = createTooltipView(t, prev));
    }
    update(update, above) {
        var _a;
        let input = update.state.facet(this.facet);
        let tooltips = input.filter((x)=>x);
        if (input === this.input) {
            for (let t of this.tooltipViews)if (t.update) t.update(update);
            return false;
        }
        let tooltipViews = [], newAbove = above ? [] : null;
        for(let i = 0; i < tooltips.length; i++){
            let tip = tooltips[i], known = -1;
            if (!tip) continue;
            for(let i = 0; i < this.tooltips.length; i++){
                let other = this.tooltips[i];
                if (other && other.create == tip.create) known = i;
            }
            if (known < 0) {
                tooltipViews[i] = this.createTooltipView(tip, i ? tooltipViews[i - 1] : null);
                if (newAbove) newAbove[i] = !!tip.above;
            } else {
                let tooltipView = tooltipViews[i] = this.tooltipViews[known];
                if (newAbove) newAbove[i] = above[known];
                if (tooltipView.update) tooltipView.update(update);
            }
        }
        for (let t of this.tooltipViews)if (tooltipViews.indexOf(t) < 0) {
            this.removeTooltipView(t);
            (_a = t.destroy) === null || _a === void 0 || _a.call(t);
        }
        if (above) {
            newAbove.forEach((val, i)=>above[i] = val);
            above.length = newAbove.length;
        }
        this.input = input;
        this.tooltips = tooltips;
        this.tooltipViews = tooltipViews;
        return true;
    }
}
/**
Creates an extension that configures tooltip behavior.
*/ function $7beee9608540d2c3$export$1fc29293196e3bc(config = {}) {
    return $7beee9608540d2c3$var$tooltipConfig.of(config);
}
function $7beee9608540d2c3$var$windowSpace(view) {
    let { win: win } = view;
    return {
        top: 0,
        left: 0,
        bottom: win.innerHeight,
        right: win.innerWidth
    };
}
const $7beee9608540d2c3$var$tooltipConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        var _a, _b, _c;
        return {
            position: $7beee9608540d2c3$var$browser.ios ? "absolute" : ((_a = values.find((conf)=>conf.position)) === null || _a === void 0 ? void 0 : _a.position) || "fixed",
            parent: ((_b = values.find((conf)=>conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
            tooltipSpace: ((_c = values.find((conf)=>conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || $7beee9608540d2c3$var$windowSpace
        };
    }
});
const $7beee9608540d2c3$var$knownHeight = /*@__PURE__*/ new WeakMap();
const $7beee9608540d2c3$var$tooltipPlugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.above = [];
        this.inView = true;
        this.madeAbsolute = false;
        this.lastTransaction = 0;
        this.measureTimeout = -1;
        let config = view.state.facet($7beee9608540d2c3$var$tooltipConfig);
        this.position = config.position;
        this.parent = config.parent;
        this.classes = view.themeClasses;
        this.createContainer();
        this.measureReq = {
            read: this.readMeasure.bind(this),
            write: this.writeMeasure.bind(this),
            key: this
        };
        this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(()=>this.measureSoon()) : null;
        this.manager = new $7beee9608540d2c3$var$TooltipViewManager(view, $7beee9608540d2c3$export$dba11b50e1aa3c12, (t, p)=>this.createTooltip(t, p), (t)=>{
            if (this.resizeObserver) this.resizeObserver.unobserve(t.dom);
            t.dom.remove();
        });
        this.above = this.manager.tooltips.map((t)=>!!t.above);
        this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries)=>{
            if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1) this.measureSoon();
        }, {
            threshold: [
                1
            ]
        }) : null;
        this.observeIntersection();
        view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
        this.maybeMeasure();
    }
    createContainer() {
        if (this.parent) {
            this.container = document.createElement("div");
            this.container.style.position = "relative";
            this.container.className = this.view.themeClasses;
            this.parent.appendChild(this.container);
        } else this.container = this.view.dom;
    }
    observeIntersection() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            for (let tooltip of this.manager.tooltipViews)this.intersectionObserver.observe(tooltip.dom);
        }
    }
    measureSoon() {
        if (this.measureTimeout < 0) this.measureTimeout = setTimeout(()=>{
            this.measureTimeout = -1;
            this.maybeMeasure();
        }, 50);
    }
    update(update) {
        if (update.transactions.length) this.lastTransaction = Date.now();
        let updated = this.manager.update(update, this.above);
        if (updated) this.observeIntersection();
        let shouldMeasure = updated || update.geometryChanged;
        let newConfig = update.state.facet($7beee9608540d2c3$var$tooltipConfig);
        if (newConfig.position != this.position && !this.madeAbsolute) {
            this.position = newConfig.position;
            for (let t of this.manager.tooltipViews)t.dom.style.position = this.position;
            shouldMeasure = true;
        }
        if (newConfig.parent != this.parent) {
            if (this.parent) this.container.remove();
            this.parent = newConfig.parent;
            this.createContainer();
            for (let t of this.manager.tooltipViews)this.container.appendChild(t.dom);
            shouldMeasure = true;
        } else if (this.parent && this.view.themeClasses != this.classes) this.classes = this.container.className = this.view.themeClasses;
        if (shouldMeasure) this.maybeMeasure();
    }
    createTooltip(tooltip, prev) {
        let tooltipView = tooltip.create(this.view);
        let before = prev ? prev.dom : null;
        tooltipView.dom.classList.add("cm-tooltip");
        if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
            let arrow = document.createElement("div");
            arrow.className = "cm-tooltip-arrow";
            tooltipView.dom.appendChild(arrow);
        }
        tooltipView.dom.style.position = this.position;
        tooltipView.dom.style.top = $7beee9608540d2c3$var$Outside;
        tooltipView.dom.style.left = "0px";
        this.container.insertBefore(tooltipView.dom, before);
        if (tooltipView.mount) tooltipView.mount(this.view);
        if (this.resizeObserver) this.resizeObserver.observe(tooltipView.dom);
        return tooltipView;
    }
    destroy() {
        var _a, _b, _c;
        this.view.win.removeEventListener("resize", this.measureSoon);
        for (let tooltipView of this.manager.tooltipViews){
            tooltipView.dom.remove();
            (_a = tooltipView.destroy) === null || _a === void 0 || _a.call(tooltipView);
        }
        if (this.parent) this.container.remove();
        (_b = this.resizeObserver) === null || _b === void 0 || _b.disconnect();
        (_c = this.intersectionObserver) === null || _c === void 0 || _c.disconnect();
        clearTimeout(this.measureTimeout);
    }
    readMeasure() {
        let editor = this.view.dom.getBoundingClientRect();
        let scaleX = 1, scaleY = 1, makeAbsolute = false;
        if (this.position == "fixed" && this.manager.tooltipViews.length) {
            let { dom: dom } = this.manager.tooltipViews[0];
            if ($7beee9608540d2c3$var$browser.gecko) // Firefox sets the element's `offsetParent` to the
            // transformed element when a transform interferes with fixed
            // positioning.
            makeAbsolute = dom.offsetParent != this.container.ownerDocument.body;
            else if (dom.style.top == $7beee9608540d2c3$var$Outside && dom.style.left == "0px") {
                // On other browsers, we have to awkwardly try and use other
                // information to detect a transform.
                let rect = dom.getBoundingClientRect();
                makeAbsolute = Math.abs(rect.top + 10000) > 1 || Math.abs(rect.left) > 1;
            }
        }
        if (makeAbsolute || this.position == "absolute") {
            if (this.parent) {
                let rect = this.parent.getBoundingClientRect();
                if (rect.width && rect.height) {
                    scaleX = rect.width / this.parent.offsetWidth;
                    scaleY = rect.height / this.parent.offsetHeight;
                }
            } else ({ scaleX: scaleX, scaleY: scaleY } = this.view.viewState);
        }
        return {
            editor: editor,
            parent: this.parent ? this.container.getBoundingClientRect() : editor,
            pos: this.manager.tooltips.map((t, i)=>{
                let tv = this.manager.tooltipViews[i];
                return tv.getCoords ? tv.getCoords(t.pos) : this.view.coordsAtPos(t.pos);
            }),
            size: this.manager.tooltipViews.map(({ dom: dom })=>dom.getBoundingClientRect()),
            space: this.view.state.facet($7beee9608540d2c3$var$tooltipConfig).tooltipSpace(this.view),
            scaleX: scaleX,
            scaleY: scaleY,
            makeAbsolute: makeAbsolute
        };
    }
    writeMeasure(measured) {
        var _a;
        if (measured.makeAbsolute) {
            this.madeAbsolute = true;
            this.position = "absolute";
            for (let t of this.manager.tooltipViews)t.dom.style.position = "absolute";
        }
        let { editor: editor, space: space, scaleX: scaleX, scaleY: scaleY } = measured;
        let others = [];
        for(let i = 0; i < this.manager.tooltips.length; i++){
            let tooltip = this.manager.tooltips[i], tView = this.manager.tooltipViews[i], { dom: dom } = tView;
            let pos = measured.pos[i], size = measured.size[i];
            // Hide tooltips that are outside of the editor.
            if (!pos || pos.bottom <= Math.max(editor.top, space.top) || pos.top >= Math.min(editor.bottom, space.bottom) || pos.right < Math.max(editor.left, space.left) - .1 || pos.left > Math.min(editor.right, space.right) + .1) {
                dom.style.top = $7beee9608540d2c3$var$Outside;
                continue;
            }
            let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
            let arrowHeight = arrow ? 7 /* Arrow.Size */  : 0;
            let width = size.right - size.left, height = (_a = $7beee9608540d2c3$var$knownHeight.get(tView)) !== null && _a !== void 0 ? _a : size.bottom - size.top;
            let offset = tView.offset || $7beee9608540d2c3$var$noOffset, ltr = this.view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR;
            let left = size.width > space.right - space.left ? ltr ? space.left : space.right - size.width : ltr ? Math.min(pos.left - (arrow ? 14 /* Arrow.Offset */  : 0) + offset.x, space.right - width) : Math.max(space.left, pos.left - width + (arrow ? 14 /* Arrow.Offset */  : 0) - offset.x);
            let above = this.above[i];
            if (!tooltip.strictSide && (above ? pos.top - (size.bottom - size.top) - offset.y < space.top : pos.bottom + (size.bottom - size.top) + offset.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top) above = this.above[i] = !above;
            let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
            if (spaceVert < height && tView.resize !== false) {
                if (spaceVert < this.view.defaultLineHeight) {
                    dom.style.top = $7beee9608540d2c3$var$Outside;
                    continue;
                }
                $7beee9608540d2c3$var$knownHeight.set(tView, height);
                dom.style.height = (height = spaceVert) / scaleY + "px";
            } else if (dom.style.height) dom.style.height = "";
            let top = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
            let right = left + width;
            if (tView.overlap !== true) {
                for (let r of others)if (r.left < right && r.right > left && r.top < top + height && r.bottom > top) top = above ? r.top - height - 2 - arrowHeight : r.bottom + arrowHeight + 2;
            }
            if (this.position == "absolute") {
                dom.style.top = (top - measured.parent.top) / scaleY + "px";
                dom.style.left = (left - measured.parent.left) / scaleX + "px";
            } else {
                dom.style.top = top / scaleY + "px";
                dom.style.left = left / scaleX + "px";
            }
            if (arrow) {
                let arrowLeft = pos.left + (ltr ? offset.x : -offset.x) - (left + 14 /* Arrow.Offset */  - 7 /* Arrow.Size */ );
                arrow.style.left = arrowLeft / scaleX + "px";
            }
            if (tView.overlap !== true) others.push({
                left: left,
                top: top,
                right: right,
                bottom: top + height
            });
            dom.classList.toggle("cm-tooltip-above", above);
            dom.classList.toggle("cm-tooltip-below", !above);
            if (tView.positioned) tView.positioned(measured.space);
        }
    }
    maybeMeasure() {
        if (this.manager.tooltips.length) {
            if (this.view.inView) this.view.requestMeasure(this.measureReq);
            if (this.inView != this.view.inView) {
                this.inView = this.view.inView;
                if (!this.inView) for (let tv of this.manager.tooltipViews)tv.dom.style.top = $7beee9608540d2c3$var$Outside;
            }
        }
    }
}, {
    eventObservers: {
        scroll () {
            this.maybeMeasure();
        }
    }
});
const $7beee9608540d2c3$var$baseTheme = /*@__PURE__*/ $7beee9608540d2c3$export$eece2fccabbb77c5.baseTheme({
    ".cm-tooltip": {
        zIndex: 100,
        boxSizing: "border-box"
    },
    "&light .cm-tooltip": {
        border: "1px solid #bbb",
        backgroundColor: "#f5f5f5"
    },
    "&light .cm-tooltip-section:not(:first-child)": {
        borderTop: "1px solid #bbb"
    },
    "&dark .cm-tooltip": {
        backgroundColor: "#333338",
        color: "white"
    },
    ".cm-tooltip-arrow": {
        height: `${7 /* Arrow.Size */ }px`,
        width: `${14}px`,
        position: "absolute",
        zIndex: -1,
        overflow: "hidden",
        "&:before, &:after": {
            content: "''",
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: `${7 /* Arrow.Size */ }px solid transparent`,
            borderRight: `${7 /* Arrow.Size */ }px solid transparent`
        },
        ".cm-tooltip-above &": {
            bottom: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderTop: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderTop: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                bottom: "1px"
            }
        },
        ".cm-tooltip-below &": {
            top: `-${7 /* Arrow.Size */ }px`,
            "&:before": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #bbb`
            },
            "&:after": {
                borderBottom: `${7 /* Arrow.Size */ }px solid #f5f5f5`,
                top: "1px"
            }
        }
    },
    "&dark .cm-tooltip .cm-tooltip-arrow": {
        "&:before": {
            borderTopColor: "#333338",
            borderBottomColor: "#333338"
        },
        "&:after": {
            borderTopColor: "transparent",
            borderBottomColor: "transparent"
        }
    }
});
const $7beee9608540d2c3$var$noOffset = {
    x: 0,
    y: 0
};
/**
Facet to which an extension can add a value to show a tooltip.
*/ const $7beee9608540d2c3$export$dba11b50e1aa3c12 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: [
        $7beee9608540d2c3$var$tooltipPlugin,
        $7beee9608540d2c3$var$baseTheme
    ]
});
const $7beee9608540d2c3$var$showHoverTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (inputs)=>inputs.reduce((a, i)=>a.concat(i), [])
});
class $7beee9608540d2c3$var$HoverTooltipHost {
    // Needs to be static so that host tooltip instances always match
    static create(view) {
        return new $7beee9608540d2c3$var$HoverTooltipHost(view);
    }
    constructor(view){
        this.view = view;
        this.mounted = false;
        this.dom = document.createElement("div");
        this.dom.classList.add("cm-tooltip-hover");
        this.manager = new $7beee9608540d2c3$var$TooltipViewManager(view, $7beee9608540d2c3$var$showHoverTooltip, (t, p)=>this.createHostedView(t, p), (t)=>t.dom.remove());
    }
    createHostedView(tooltip, prev) {
        let hostedView = tooltip.create(this.view);
        hostedView.dom.classList.add("cm-tooltip-section");
        this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
        if (this.mounted && hostedView.mount) hostedView.mount(this.view);
        return hostedView;
    }
    mount(view) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.mount) hostedView.mount(view);
        this.mounted = true;
    }
    positioned(space) {
        for (let hostedView of this.manager.tooltipViews)if (hostedView.positioned) hostedView.positioned(space);
    }
    update(update) {
        this.manager.update(update);
    }
    destroy() {
        var _a;
        for (let t of this.manager.tooltipViews)(_a = t.destroy) === null || _a === void 0 || _a.call(t);
    }
    passProp(name) {
        let value = undefined;
        for (let view of this.manager.tooltipViews){
            let given = view[name];
            if (given !== undefined) {
                if (value === undefined) value = given;
                else if (value !== given) return undefined;
            }
        }
        return value;
    }
    get offset() {
        return this.passProp("offset");
    }
    get getCoords() {
        return this.passProp("getCoords");
    }
    get overlap() {
        return this.passProp("overlap");
    }
    get resize() {
        return this.passProp("resize");
    }
}
const $7beee9608540d2c3$var$showHoverTooltipHost = /*@__PURE__*/ $7beee9608540d2c3$export$dba11b50e1aa3c12.compute([
    $7beee9608540d2c3$var$showHoverTooltip
], (state)=>{
    let tooltips = state.facet($7beee9608540d2c3$var$showHoverTooltip);
    if (tooltips.length === 0) return null;
    return {
        pos: Math.min(...tooltips.map((t)=>t.pos)),
        end: Math.max(...tooltips.map((t)=>{
            var _a;
            return (_a = t.end) !== null && _a !== void 0 ? _a : t.pos;
        })),
        create: $7beee9608540d2c3$var$HoverTooltipHost.create,
        above: tooltips[0].above,
        arrow: tooltips.some((t)=>t.arrow)
    };
});
class $7beee9608540d2c3$var$HoverPlugin {
    constructor(view, source, field, setHover, hoverTime){
        this.view = view;
        this.source = source;
        this.field = field;
        this.setHover = setHover;
        this.hoverTime = hoverTime;
        this.hoverTimeout = -1;
        this.restartTimeout = -1;
        this.pending = null;
        this.lastMove = {
            x: 0,
            y: 0,
            target: view.dom,
            time: 0
        };
        this.checkHover = this.checkHover.bind(this);
        view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
        view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
        if (this.pending) {
            this.pending = null;
            clearTimeout(this.restartTimeout);
            this.restartTimeout = setTimeout(()=>this.startHover(), 20);
        }
    }
    get active() {
        return this.view.state.field(this.field);
    }
    checkHover() {
        this.hoverTimeout = -1;
        if (this.active.length) return;
        let hovered = Date.now() - this.lastMove.time;
        if (hovered < this.hoverTime) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
        else this.startHover();
    }
    startHover() {
        clearTimeout(this.restartTimeout);
        let { view: view, lastMove: lastMove } = this;
        let desc = view.docView.nearest(lastMove.target);
        if (!desc) return;
        let pos, side = 1;
        if (desc instanceof $7beee9608540d2c3$var$WidgetView) pos = desc.posAtStart;
        else {
            pos = view.posAtCoords(lastMove);
            if (pos == null) return;
            let posCoords = view.coordsAtPos(pos);
            if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth) return;
            let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s)=>s.from <= pos && s.to >= pos);
            let rtl = bidi && bidi.dir == $7beee9608540d2c3$export$cacd6541cfeeb6c1.RTL ? -1 : 1;
            side = lastMove.x < posCoords.left ? -rtl : rtl;
        }
        let open = this.source(view, pos, side);
        if (open === null || open === void 0 ? void 0 : open.then) {
            let pending = this.pending = {
                pos: pos
            };
            open.then((result)=>{
                if (this.pending == pending) {
                    this.pending = null;
                    if (result && !(Array.isArray(result) && !result.length)) view.dispatch({
                        effects: this.setHover.of(Array.isArray(result) ? result : [
                            result
                        ])
                    });
                }
            }, (e)=>$7beee9608540d2c3$export$f86b2a1a2ce291b3(view.state, e, "hover tooltip"));
        } else if (open && !(Array.isArray(open) && !open.length)) view.dispatch({
            effects: this.setHover.of(Array.isArray(open) ? open : [
                open
            ])
        });
    }
    get tooltip() {
        let plugin = this.view.plugin($7beee9608540d2c3$var$tooltipPlugin);
        let index = plugin ? plugin.manager.tooltips.findIndex((t)=>t.create == $7beee9608540d2c3$var$HoverTooltipHost.create) : -1;
        return index > -1 ? plugin.manager.tooltipViews[index] : null;
    }
    mousemove(event) {
        var _a, _b;
        this.lastMove = {
            x: event.clientX,
            y: event.clientY,
            target: event.target,
            time: Date.now()
        };
        if (this.hoverTimeout < 0) this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
        let { active: active, tooltip: tooltip } = this;
        if (active.length && tooltip && !$7beee9608540d2c3$var$isInTooltip(tooltip.dom, event) || this.pending) {
            let { pos: pos } = active[0] || this.pending, end = (_b = (_a = active[0]) === null || _a === void 0 ? void 0 : _a.end) !== null && _b !== void 0 ? _b : pos;
            if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !$7beee9608540d2c3$var$isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
                this.view.dispatch({
                    effects: this.setHover.of([])
                });
                this.pending = null;
            }
        }
    }
    mouseleave(event) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = -1;
        let { active: active } = this;
        if (active.length) {
            let { tooltip: tooltip } = this;
            let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
            if (!inTooltip) this.view.dispatch({
                effects: this.setHover.of([])
            });
            else this.watchTooltipLeave(tooltip.dom);
        }
    }
    watchTooltipLeave(tooltip) {
        let watch = (event)=>{
            tooltip.removeEventListener("mouseleave", watch);
            if (this.active.length && !this.view.dom.contains(event.relatedTarget)) this.view.dispatch({
                effects: this.setHover.of([])
            });
        };
        tooltip.addEventListener("mouseleave", watch);
    }
    destroy() {
        clearTimeout(this.hoverTimeout);
        this.view.dom.removeEventListener("mouseleave", this.mouseleave);
        this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
}
const $7beee9608540d2c3$var$tooltipMargin = 4;
function $7beee9608540d2c3$var$isInTooltip(tooltip, event) {
    let rect = tooltip.getBoundingClientRect();
    return event.clientX >= rect.left - $7beee9608540d2c3$var$tooltipMargin && event.clientX <= rect.right + $7beee9608540d2c3$var$tooltipMargin && event.clientY >= rect.top - $7beee9608540d2c3$var$tooltipMargin && event.clientY <= rect.bottom + $7beee9608540d2c3$var$tooltipMargin;
}
function $7beee9608540d2c3$var$isOverRange(view, from, to, x, y, margin) {
    let rect = view.scrollDOM.getBoundingClientRect();
    let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
    if (rect.left > x || rect.right < x || rect.top > y || Math.min(rect.bottom, docBottom) < y) return false;
    let pos = view.posAtCoords({
        x: x,
        y: y
    }, false);
    return pos >= from && pos <= to;
}
/**
Set up a hover tooltip, which shows up when the pointer hovers
over ranges of text. The callback is called when the mouse hovers
over the document text. It should, if there is a tooltip
associated with position `pos`, return the tooltip description
(either directly or in a promise). The `side` argument indicates
on which side of the position the pointer is—it will be -1 if the
pointer is before the position, 1 if after the position.

Note that all hover tooltips are hosted within a single tooltip
container element. This allows multiple tooltips over the same
range to be "merged" together without overlapping.
*/ function $7beee9608540d2c3$export$69f8d9e63c4aa884(source, options = {}) {
    let setHover = (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
    let hoverState = (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
        create () {
            return [];
        },
        update (value, tr) {
            if (value.length) {
                if (options.hideOnChange && (tr.docChanged || tr.selection)) value = [];
                else if (options.hideOn) value = value.filter((v)=>!options.hideOn(tr, v));
                if (tr.docChanged) {
                    let mapped = [];
                    for (let tooltip of value){
                        let newPos = tr.changes.mapPos(tooltip.pos, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
                        if (newPos != null) {
                            let copy = Object.assign(Object.create(null), tooltip);
                            copy.pos = newPos;
                            if (copy.end != null) copy.end = tr.changes.mapPos(copy.end);
                            mapped.push(copy);
                        }
                    }
                    value = mapped;
                }
            }
            for (let effect of tr.effects){
                if (effect.is(setHover)) value = effect.value;
                if (effect.is($7beee9608540d2c3$var$closeHoverTooltipEffect)) value = [];
            }
            return value;
        },
        provide: (f)=>$7beee9608540d2c3$var$showHoverTooltip.from(f)
    });
    return [
        hoverState,
        $7beee9608540d2c3$export$44d5eccfd62adda7.define((view)=>new $7beee9608540d2c3$var$HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300 /* Hover.Time */ )),
        $7beee9608540d2c3$var$showHoverTooltipHost
    ];
}
/**
Get the active tooltip view for a given tooltip, if available.
*/ function $7beee9608540d2c3$export$46455b4476d4b8e1(view, tooltip) {
    let plugin = view.plugin($7beee9608540d2c3$var$tooltipPlugin);
    if (!plugin) return null;
    let found = plugin.manager.tooltips.indexOf(tooltip);
    return found < 0 ? null : plugin.manager.tooltipViews[found];
}
/**
Returns true if any hover tooltips are currently active.
*/ function $7beee9608540d2c3$export$7864d875805bc1b0(state) {
    return state.facet($7beee9608540d2c3$var$showHoverTooltip).some((x)=>x);
}
const $7beee9608540d2c3$var$closeHoverTooltipEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
/**
Transaction effect that closes all hover tooltips.
*/ const $7beee9608540d2c3$export$f6974094db6525a = /*@__PURE__*/ $7beee9608540d2c3$var$closeHoverTooltipEffect.of(null);
/**
Tell the tooltip extension to recompute the position of the active
tooltips. This can be useful when something happens (such as a
re-positioning or CSS change affecting the editor) that could
invalidate the existing tooltip positions.
*/ function $7beee9608540d2c3$export$912859096d593b90(view) {
    let plugin = view.plugin($7beee9608540d2c3$var$tooltipPlugin);
    if (plugin) plugin.maybeMeasure();
}
const $7beee9608540d2c3$var$panelConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        let topContainer, bottomContainer;
        for (let c of configs){
            topContainer = topContainer || c.topContainer;
            bottomContainer = bottomContainer || c.bottomContainer;
        }
        return {
            topContainer: topContainer,
            bottomContainer: bottomContainer
        };
    }
});
/**
Configures the panel-managing extension.
*/ function $7beee9608540d2c3$export$8128819a2322681a(config) {
    return config ? [
        $7beee9608540d2c3$var$panelConfig.of(config)
    ] : [];
}
/**
Get the active panel created by the given constructor, if any.
This can be useful when you need access to your panels' DOM
structure.
*/ function $7beee9608540d2c3$export$7361ed18ff57179e(view, panel) {
    let plugin = view.plugin($7beee9608540d2c3$var$panelPlugin);
    let index = plugin ? plugin.specs.indexOf(panel) : -1;
    return index > -1 ? plugin.panels[index] : null;
}
const $7beee9608540d2c3$var$panelPlugin = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.input = view.state.facet($7beee9608540d2c3$export$e89c3c9af31c1e3b);
        this.specs = this.input.filter((s)=>s);
        this.panels = this.specs.map((spec)=>spec(view));
        let conf = view.state.facet($7beee9608540d2c3$var$panelConfig);
        this.top = new $7beee9608540d2c3$var$PanelGroup(view, true, conf.topContainer);
        this.bottom = new $7beee9608540d2c3$var$PanelGroup(view, false, conf.bottomContainer);
        this.top.sync(this.panels.filter((p)=>p.top));
        this.bottom.sync(this.panels.filter((p)=>!p.top));
        for (let p of this.panels){
            p.dom.classList.add("cm-panel");
            if (p.mount) p.mount();
        }
    }
    update(update) {
        let conf = update.state.facet($7beee9608540d2c3$var$panelConfig);
        if (this.top.container != conf.topContainer) {
            this.top.sync([]);
            this.top = new $7beee9608540d2c3$var$PanelGroup(update.view, true, conf.topContainer);
        }
        if (this.bottom.container != conf.bottomContainer) {
            this.bottom.sync([]);
            this.bottom = new $7beee9608540d2c3$var$PanelGroup(update.view, false, conf.bottomContainer);
        }
        this.top.syncClasses();
        this.bottom.syncClasses();
        let input = update.state.facet($7beee9608540d2c3$export$e89c3c9af31c1e3b);
        if (input != this.input) {
            let specs = input.filter((x)=>x);
            let panels = [], top = [], bottom = [], mount = [];
            for (let spec of specs){
                let known = this.specs.indexOf(spec), panel;
                if (known < 0) {
                    panel = spec(update.view);
                    mount.push(panel);
                } else {
                    panel = this.panels[known];
                    if (panel.update) panel.update(update);
                }
                panels.push(panel);
                (panel.top ? top : bottom).push(panel);
            }
            this.specs = specs;
            this.panels = panels;
            this.top.sync(top);
            this.bottom.sync(bottom);
            for (let p of mount){
                p.dom.classList.add("cm-panel");
                if (p.mount) p.mount();
            }
        } else {
            for (let p of this.panels)if (p.update) p.update(update);
        }
    }
    destroy() {
        this.top.sync([]);
        this.bottom.sync([]);
    }
}, {
    provide: (plugin)=>$7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            return value && {
                top: value.top.scrollMargin(),
                bottom: value.bottom.scrollMargin()
            };
        })
});
class $7beee9608540d2c3$var$PanelGroup {
    constructor(view, top, container){
        this.view = view;
        this.top = top;
        this.container = container;
        this.dom = undefined;
        this.classes = "";
        this.panels = [];
        this.syncClasses();
    }
    sync(panels) {
        for (let p of this.panels)if (p.destroy && panels.indexOf(p) < 0) p.destroy();
        this.panels = panels;
        this.syncDOM();
    }
    syncDOM() {
        if (this.panels.length == 0) {
            if (this.dom) {
                this.dom.remove();
                this.dom = undefined;
            }
            return;
        }
        if (!this.dom) {
            this.dom = document.createElement("div");
            this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
            this.dom.style[this.top ? "top" : "bottom"] = "0";
            let parent = this.container || this.view.dom;
            parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
        }
        let curDOM = this.dom.firstChild;
        for (let panel of this.panels)if (panel.dom.parentNode == this.dom) {
            while(curDOM != panel.dom)curDOM = $7beee9608540d2c3$var$rm(curDOM);
            curDOM = curDOM.nextSibling;
        } else this.dom.insertBefore(panel.dom, curDOM);
        while(curDOM)curDOM = $7beee9608540d2c3$var$rm(curDOM);
    }
    scrollMargin() {
        return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
        if (!this.container || this.classes == this.view.themeClasses) return;
        for (let cls of this.classes.split(" "))if (cls) this.container.classList.remove(cls);
        for (let cls of (this.classes = this.view.themeClasses).split(" "))if (cls) this.container.classList.add(cls);
    }
}
function $7beee9608540d2c3$var$rm(node) {
    let next = node.nextSibling;
    node.remove();
    return next;
}
/**
Opening a panel is done by providing a constructor function for
the panel through this facet. (The panel is closed again when its
constructor is no longer provided.) Values of `null` are ignored.
*/ const $7beee9608540d2c3$export$e89c3c9af31c1e3b = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    enables: $7beee9608540d2c3$var$panelPlugin
});
/**
A gutter marker represents a bit of information attached to a line
in a specific gutter. Your own custom markers have to extend this
class.
*/ class $7beee9608540d2c3$export$591ab4c909549043 extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
    /**
    @internal
    */ compare(other) {
        return this == other || this.constructor == other.constructor && this.eq(other);
    }
    /**
    Compare this marker to another marker of the same type.
    */ eq(other) {
        return false;
    }
    /**
    Called if the marker has a `toDOM` method and its representation
    was removed from a gutter.
    */ destroy(dom) {}
}
$7beee9608540d2c3$export$591ab4c909549043.prototype.elementClass = "";
$7beee9608540d2c3$export$591ab4c909549043.prototype.toDOM = undefined;
$7beee9608540d2c3$export$591ab4c909549043.prototype.mapMode = (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackBefore;
$7beee9608540d2c3$export$591ab4c909549043.prototype.startSide = $7beee9608540d2c3$export$591ab4c909549043.prototype.endSide = -1;
$7beee9608540d2c3$export$591ab4c909549043.prototype.point = true;
/**
Facet used to add a class to all gutter elements for a given line.
Markers given to this facet should _only_ define an
[`elementclass`](https://codemirror.net/6/docs/ref/#view.GutterMarker.elementClass), not a
[`toDOM`](https://codemirror.net/6/docs/ref/#view.GutterMarker.toDOM) (or the marker will appear
in all gutters for the line).
*/ const $7beee9608540d2c3$export$113bd64f27ac1172 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$defaults = {
    class: "",
    renderEmptyElements: false,
    elementStyle: "",
    markers: ()=>(0, $6295c6875f57e3ee$export$34cb5241245008dd).empty,
    lineMarker: ()=>null,
    widgetMarker: ()=>null,
    lineMarkerChange: null,
    initialSpacer: null,
    updateSpacer: null,
    domEventHandlers: {}
};
const $7beee9608540d2c3$var$activeGutters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Define an editor gutter. The order in which the gutters appear is
determined by their extension priority.
*/ function $7beee9608540d2c3$export$f2b922cb4a245974(config) {
    return [
        $7beee9608540d2c3$export$ec15ef01b8fbae61(),
        $7beee9608540d2c3$var$activeGutters.of(Object.assign(Object.assign({}, $7beee9608540d2c3$var$defaults), config))
    ];
}
const $7beee9608540d2c3$var$unfixGutters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
The gutter-drawing plugin is automatically enabled when you add a
gutter, but you can use this function to explicitly configure it.

Unless `fixed` is explicitly set to `false`, the gutters are
fixed, meaning they don't scroll along with the content
horizontally (except on Internet Explorer, which doesn't support
CSS [`position:
sticky`](https://developer.mozilla.org/en-US/docs/Web/CSS/position#sticky)).
*/ function $7beee9608540d2c3$export$ec15ef01b8fbae61(config) {
    let result = [
        $7beee9608540d2c3$var$gutterView
    ];
    if (config && config.fixed === false) result.push($7beee9608540d2c3$var$unfixGutters.of(true));
    return result;
}
const $7beee9608540d2c3$var$gutterView = /*@__PURE__*/ $7beee9608540d2c3$export$44d5eccfd62adda7.fromClass(class {
    constructor(view){
        this.view = view;
        this.prevViewport = view.viewport;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutters";
        this.dom.setAttribute("aria-hidden", "true");
        this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        this.gutters = view.state.facet($7beee9608540d2c3$var$activeGutters).map((conf)=>new $7beee9608540d2c3$var$SingleGutterView(view, conf));
        for (let gutter of this.gutters)this.dom.appendChild(gutter.dom);
        this.fixed = !view.state.facet($7beee9608540d2c3$var$unfixGutters);
        if (this.fixed) // FIXME IE11 fallback, which doesn't support position: sticky,
        // by using position: relative + event handlers that realign the
        // gutter (or just force fixed=false on IE11?)
        this.dom.style.position = "sticky";
        this.syncGutters(false);
        view.scrollDOM.insertBefore(this.dom, view.contentDOM);
    }
    update(update) {
        if (this.updateGutters(update)) {
            // Detach during sync when the viewport changed significantly
            // (such as during scrolling), since for large updates that is
            // faster.
            let vpA = this.prevViewport, vpB = update.view.viewport;
            let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
            this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
        }
        if (update.geometryChanged) this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
        if (this.view.state.facet($7beee9608540d2c3$var$unfixGutters) != !this.fixed) {
            this.fixed = !this.fixed;
            this.dom.style.position = this.fixed ? "sticky" : "";
        }
        this.prevViewport = update.view.viewport;
    }
    syncGutters(detach) {
        let after = this.dom.nextSibling;
        if (detach) this.dom.remove();
        let lineClasses = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(this.view.state.facet($7beee9608540d2c3$export$113bd64f27ac1172), this.view.viewport.from);
        let classSet = [];
        let contexts = this.gutters.map((gutter)=>new $7beee9608540d2c3$var$UpdateContext(gutter, this.view.viewport, -this.view.documentPadding.top));
        for (let line of this.view.viewportLineBlocks){
            if (classSet.length) classSet = [];
            if (Array.isArray(line.type)) {
                let first = true;
                for (let b of line.type){
                    if (b.type == $7beee9608540d2c3$export$48808c686fe495c4.Text && first) {
                        $7beee9608540d2c3$var$advanceCursor(lineClasses, classSet, b.from);
                        for (let cx of contexts)cx.line(this.view, b, classSet);
                        first = false;
                    } else if (b.widget) for (let cx of contexts)cx.widget(this.view, b);
                }
            } else if (line.type == $7beee9608540d2c3$export$48808c686fe495c4.Text) {
                $7beee9608540d2c3$var$advanceCursor(lineClasses, classSet, line.from);
                for (let cx of contexts)cx.line(this.view, line, classSet);
            } else if (line.widget) for (let cx of contexts)cx.widget(this.view, line);
        }
        for (let cx of contexts)cx.finish();
        if (detach) this.view.scrollDOM.insertBefore(this.dom, after);
    }
    updateGutters(update) {
        let prev = update.startState.facet($7beee9608540d2c3$var$activeGutters), cur = update.state.facet($7beee9608540d2c3$var$activeGutters);
        let change = update.docChanged || update.heightChanged || update.viewportChanged || !(0, $6295c6875f57e3ee$export$34cb5241245008dd).eq(update.startState.facet($7beee9608540d2c3$export$113bd64f27ac1172), update.state.facet($7beee9608540d2c3$export$113bd64f27ac1172), update.view.viewport.from, update.view.viewport.to);
        if (prev == cur) {
            for (let gutter of this.gutters)if (gutter.update(update)) change = true;
        } else {
            change = true;
            let gutters = [];
            for (let conf of cur){
                let known = prev.indexOf(conf);
                if (known < 0) gutters.push(new $7beee9608540d2c3$var$SingleGutterView(this.view, conf));
                else {
                    this.gutters[known].update(update);
                    gutters.push(this.gutters[known]);
                }
            }
            for (let g of this.gutters){
                g.dom.remove();
                if (gutters.indexOf(g) < 0) g.destroy();
            }
            for (let g of gutters)this.dom.appendChild(g.dom);
            this.gutters = gutters;
        }
        return change;
    }
    destroy() {
        for (let view of this.gutters)view.destroy();
        this.dom.remove();
    }
}, {
    provide: (plugin)=>$7beee9608540d2c3$export$eece2fccabbb77c5.scrollMargins.of((view)=>{
            let value = view.plugin(plugin);
            if (!value || value.gutters.length == 0 || !value.fixed) return null;
            return view.textDirection == $7beee9608540d2c3$export$cacd6541cfeeb6c1.LTR ? {
                left: value.dom.offsetWidth * view.scaleX
            } : {
                right: value.dom.offsetWidth * view.scaleX
            };
        })
});
function $7beee9608540d2c3$var$asArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $7beee9608540d2c3$var$advanceCursor(cursor, collect, pos) {
    while(cursor.value && cursor.from <= pos){
        if (cursor.from == pos) collect.push(cursor.value);
        cursor.next();
    }
}
class $7beee9608540d2c3$var$UpdateContext {
    constructor(gutter, viewport, height){
        this.gutter = gutter;
        this.height = height;
        this.i = 0;
        this.cursor = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter(gutter.markers, viewport.from);
    }
    addElement(view, block, markers) {
        let { gutter: gutter } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
        if (this.i == gutter.elements.length) {
            let newElt = new $7beee9608540d2c3$var$GutterElement(view, height, above, markers);
            gutter.elements.push(newElt);
            gutter.dom.appendChild(newElt.dom);
        } else gutter.elements[this.i].update(view, height, above, markers);
        this.height = block.bottom;
        this.i++;
    }
    line(view, line, extraMarkers) {
        let localMarkers = [];
        $7beee9608540d2c3$var$advanceCursor(this.cursor, localMarkers, line.from);
        if (extraMarkers.length) localMarkers = localMarkers.concat(extraMarkers);
        let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
        if (forLine) localMarkers.unshift(forLine);
        let gutter = this.gutter;
        if (localMarkers.length == 0 && !gutter.config.renderEmptyElements) return;
        this.addElement(view, line, localMarkers);
    }
    widget(view, block) {
        let marker = this.gutter.config.widgetMarker(view, block.widget, block);
        if (marker) this.addElement(view, block, [
            marker
        ]);
    }
    finish() {
        let gutter = this.gutter;
        while(gutter.elements.length > this.i){
            let last = gutter.elements.pop();
            gutter.dom.removeChild(last.dom);
            last.destroy();
        }
    }
}
class $7beee9608540d2c3$var$SingleGutterView {
    constructor(view, config){
        this.view = view;
        this.config = config;
        this.elements = [];
        this.spacer = null;
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
        for(let prop in config.domEventHandlers)this.dom.addEventListener(prop, (event)=>{
            let target = event.target, y;
            if (target != this.dom && this.dom.contains(target)) {
                while(target.parentNode != this.dom)target = target.parentNode;
                let rect = target.getBoundingClientRect();
                y = (rect.top + rect.bottom) / 2;
            } else y = event.clientY;
            let line = view.lineBlockAtHeight(y - view.documentTop);
            if (config.domEventHandlers[prop](view, line, event)) event.preventDefault();
        });
        this.markers = $7beee9608540d2c3$var$asArray(config.markers(view));
        if (config.initialSpacer) {
            this.spacer = new $7beee9608540d2c3$var$GutterElement(view, 0, 0, [
                config.initialSpacer(view)
            ]);
            this.dom.appendChild(this.spacer.dom);
            this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
        }
    }
    update(update) {
        let prevMarkers = this.markers;
        this.markers = $7beee9608540d2c3$var$asArray(this.config.markers(update.view));
        if (this.spacer && this.config.updateSpacer) {
            let updated = this.config.updateSpacer(this.spacer.markers[0], update);
            if (updated != this.spacer.markers[0]) this.spacer.update(update.view, 0, 0, [
                updated
            ]);
        }
        let vp = update.view.viewport;
        return !(0, $6295c6875f57e3ee$export$34cb5241245008dd).eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
    }
    destroy() {
        for (let elt of this.elements)elt.destroy();
    }
}
class $7beee9608540d2c3$var$GutterElement {
    constructor(view, height, above, markers){
        this.height = -1;
        this.above = 0;
        this.markers = [];
        this.dom = document.createElement("div");
        this.dom.className = "cm-gutterElement";
        this.update(view, height, above, markers);
    }
    update(view, height, above, markers) {
        if (this.height != height) {
            this.height = height;
            this.dom.style.height = height + "px";
        }
        if (this.above != above) this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
        if (!$7beee9608540d2c3$var$sameMarkers(this.markers, markers)) this.setMarkers(view, markers);
    }
    setMarkers(view, markers) {
        let cls = "cm-gutterElement", domPos = this.dom.firstChild;
        for(let iNew = 0, iOld = 0;;){
            let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
            if (marker) {
                let c = marker.elementClass;
                if (c) cls += " " + c;
                for(let i = iOld; i < this.markers.length; i++)if (this.markers[i].compare(marker)) {
                    skipTo = i;
                    matched = true;
                    break;
                }
            } else skipTo = this.markers.length;
            while(iOld < skipTo){
                let next = this.markers[iOld++];
                if (next.toDOM) {
                    next.destroy(domPos);
                    let after = domPos.nextSibling;
                    domPos.remove();
                    domPos = after;
                }
            }
            if (!marker) break;
            if (marker.toDOM) {
                if (matched) domPos = domPos.nextSibling;
                else this.dom.insertBefore(marker.toDOM(view), domPos);
            }
            if (matched) iOld++;
        }
        this.dom.className = cls;
        this.markers = markers;
    }
    destroy() {
        this.setMarkers(null, []); // First argument not used unless creating markers
    }
}
function $7beee9608540d2c3$var$sameMarkers(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].compare(b[i])) return false;
    return true;
}
/**
Facet used to provide markers to the line number gutter.
*/ const $7beee9608540d2c3$export$dd0c91e0a7121f5f = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $7beee9608540d2c3$var$lineNumberConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(values, {
            formatNumber: String,
            domEventHandlers: {}
        }, {
            domEventHandlers (a, b) {
                let result = Object.assign({}, a);
                for(let event in b){
                    let exists = result[event], add = b[event];
                    result[event] = exists ? (view, line, event)=>exists(view, line, event) || add(view, line, event) : add;
                }
                return result;
            }
        });
    }
});
class $7beee9608540d2c3$var$NumberMarker extends $7beee9608540d2c3$export$591ab4c909549043 {
    constructor(number){
        super();
        this.number = number;
    }
    eq(other) {
        return this.number == other.number;
    }
    toDOM() {
        return document.createTextNode(this.number);
    }
}
function $7beee9608540d2c3$var$formatNumber(view, number) {
    return view.state.facet($7beee9608540d2c3$var$lineNumberConfig).formatNumber(number, view.state);
}
const $7beee9608540d2c3$var$lineNumberGutter = /*@__PURE__*/ $7beee9608540d2c3$var$activeGutters.compute([
    $7beee9608540d2c3$var$lineNumberConfig
], (state)=>({
        class: "cm-lineNumbers",
        renderEmptyElements: false,
        markers (view) {
            return view.state.facet($7beee9608540d2c3$export$dd0c91e0a7121f5f);
        },
        lineMarker (view, line, others) {
            if (others.some((m)=>m.toDOM)) return null;
            return new $7beee9608540d2c3$var$NumberMarker($7beee9608540d2c3$var$formatNumber(view, view.state.doc.lineAt(line.from).number));
        },
        widgetMarker: ()=>null,
        lineMarkerChange: (update)=>update.startState.facet($7beee9608540d2c3$var$lineNumberConfig) != update.state.facet($7beee9608540d2c3$var$lineNumberConfig),
        initialSpacer (view) {
            return new $7beee9608540d2c3$var$NumberMarker($7beee9608540d2c3$var$formatNumber(view, $7beee9608540d2c3$var$maxLineNumber(view.state.doc.lines)));
        },
        updateSpacer (spacer, update) {
            let max = $7beee9608540d2c3$var$formatNumber(update.view, $7beee9608540d2c3$var$maxLineNumber(update.view.state.doc.lines));
            return max == spacer.number ? spacer : new $7beee9608540d2c3$var$NumberMarker(max);
        },
        domEventHandlers: state.facet($7beee9608540d2c3$var$lineNumberConfig).domEventHandlers
    }));
/**
Create a line number gutter extension.
*/ function $7beee9608540d2c3$export$1a8cf111682eaa7d(config = {}) {
    return [
        $7beee9608540d2c3$var$lineNumberConfig.of(config),
        $7beee9608540d2c3$export$ec15ef01b8fbae61(),
        $7beee9608540d2c3$var$lineNumberGutter
    ];
}
function $7beee9608540d2c3$var$maxLineNumber(lines) {
    let last = 9;
    while(last < lines)last = last * 10 + 9;
    return last;
}
const $7beee9608540d2c3$var$activeLineGutterMarker = /*@__PURE__*/ new class extends $7beee9608540d2c3$export$591ab4c909549043 {
    constructor(){
        super(...arguments);
        this.elementClass = "cm-activeLineGutter";
    }
};
const $7beee9608540d2c3$var$activeLineGutterHighlighter = /*@__PURE__*/ $7beee9608540d2c3$export$113bd64f27ac1172.compute([
    "selection"
], (state)=>{
    let marks = [], last = -1;
    for (let range of state.selection.ranges){
        let linePos = state.doc.lineAt(range.head).from;
        if (linePos > last) {
            last = linePos;
            marks.push($7beee9608540d2c3$var$activeLineGutterMarker.range(linePos));
        }
    }
    return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(marks);
});
/**
Returns an extension that adds a `cm-activeLineGutter` class to
all gutter elements on the [active
line](https://codemirror.net/6/docs/ref/#view.highlightActiveLine).
*/ function $7beee9608540d2c3$export$93b52f08bb2c759c() {
    return $7beee9608540d2c3$var$activeLineGutterHighlighter;
}
const $7beee9608540d2c3$var$WhitespaceDeco = /*@__PURE__*/ new Map();
function $7beee9608540d2c3$var$getWhitespaceDeco(space) {
    let deco = $7beee9608540d2c3$var$WhitespaceDeco.get(space);
    if (!deco) $7beee9608540d2c3$var$WhitespaceDeco.set(space, deco = $7beee9608540d2c3$export$10e30b733df217ea.mark({
        attributes: space === "	" ? {
            class: "cm-highlightTab"
        } : {
            class: "cm-highlightSpace",
            "data-display": space.replace(/ /g, "\xb7")
        }
    }));
    return deco;
}
function $7beee9608540d2c3$var$matcher(decorator) {
    return $7beee9608540d2c3$export$44d5eccfd62adda7.define((view)=>({
            decorations: decorator.createDeco(view),
            update (u) {
                this.decorations = decorator.updateDeco(u, this.decorations);
            }
        }), {
        decorations: (v)=>v.decorations
    });
}
const $7beee9608540d2c3$var$whitespaceHighlighter = /*@__PURE__*/ $7beee9608540d2c3$var$matcher(/*@__PURE__*/ new $7beee9608540d2c3$export$9b928b0ca20b25cb({
    regexp: /\t| +/g,
    decoration: (match)=>$7beee9608540d2c3$var$getWhitespaceDeco(match[0]),
    boundary: /\S/
}));
/**
Returns an extension that highlights whitespace, adding a
`cm-highlightSpace` class to stretches of spaces, and a
`cm-highlightTab` class to individual tab characters. By default,
the former are shown as faint dots, and the latter as arrows.
*/ function $7beee9608540d2c3$export$beeff585f23bdb79() {
    return $7beee9608540d2c3$var$whitespaceHighlighter;
}
const $7beee9608540d2c3$var$trailingHighlighter = /*@__PURE__*/ $7beee9608540d2c3$var$matcher(/*@__PURE__*/ new $7beee9608540d2c3$export$9b928b0ca20b25cb({
    regexp: /\s+$/g,
    decoration: /*@__PURE__*/ $7beee9608540d2c3$export$10e30b733df217ea.mark({
        class: "cm-trailingSpace"
    }),
    boundary: /\S/
}));
/**
Returns an extension that adds a `cm-trailingSpace` class to all
trailing whitespace.
*/ function $7beee9608540d2c3$export$6e66b0e142f44c26() {
    return $7beee9608540d2c3$var$trailingHighlighter;
}
/**
@internal
*/ const $7beee9608540d2c3$export$91afc2cf83e15b44 = {
    HeightMap: $7beee9608540d2c3$var$HeightMap,
    HeightOracle: $7beee9608540d2c3$var$HeightOracle,
    MeasuredHeights: $7beee9608540d2c3$var$MeasuredHeights,
    QueryType: $7beee9608540d2c3$var$QueryType,
    ChangedRange: $7beee9608540d2c3$var$ChangedRange,
    computeOrder: $7beee9608540d2c3$var$computeOrder,
    moveVisually: $7beee9608540d2c3$var$moveVisually
};




/**
The default maximum length of a `TreeBuffer` node.
*/ const $ed739beecf769914$export$de305a849879ffa = 1024;
let $ed739beecf769914$var$nextPropID = 0;
class $ed739beecf769914$var$Range {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
}
/**
Each [node type](#common.NodeType) or [individual tree](#common.Tree)
can have metadata associated with it in props. Instances of this
class represent prop names.
*/ class $ed739beecf769914$export$b8034b9bc18acd90 {
    /**
    Create a new node prop type.
    */ constructor(config = {}){
        this.id = $ed739beecf769914$var$nextPropID++;
        this.perNode = !!config.perNode;
        this.deserialize = config.deserialize || (()=>{
            throw new Error("This node type doesn't define a deserialize function");
        });
    }
    /**
    This is meant to be used with
    [`NodeSet.extend`](#common.NodeSet.extend) or
    [`LRParser.configure`](#lr.ParserConfig.props) to compute
    prop values for each node type in the set. Takes a [match
    object](#common.NodeType^match) or function that returns undefined
    if the node type doesn't get this prop, and the prop's value if
    it does.
    */ add(match) {
        if (this.perNode) throw new RangeError("Can't add per-node props to node types");
        if (typeof match != "function") match = $ed739beecf769914$export$f06e977173f1857c.match(match);
        return (type)=>{
            let result = match(type);
            return result === undefined ? null : [
                this,
                result
            ];
        };
    }
}
/**
Prop that is used to describe matching delimiters. For opening
delimiters, this holds an array of node names (written as a
space-separated string when declaring this prop in a grammar)
for the node types of closing delimiters that match it.
*/ $ed739beecf769914$export$b8034b9bc18acd90.closedBy = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
The inverse of [`closedBy`](#common.NodeProp^closedBy). This is
attached to closing delimiters, holding an array of node names
of types of matching opening delimiters.
*/ $ed739beecf769914$export$b8034b9bc18acd90.openedBy = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Used to assign node types to groups (for example, all node
types that represent an expression could be tagged with an
`"Expression"` group).
*/ $ed739beecf769914$export$b8034b9bc18acd90.group = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (str)=>str.split(" ")
});
/**
Attached to nodes to indicate these should be
[displayed](https://codemirror.net/docs/ref/#language.syntaxTree)
in a bidirectional text isolate, so that direction-neutral
characters on their sides don't incorrectly get associated with
surrounding text. You'll generally want to set this for nodes
that contain arbitrary text, like strings and comments, and for
nodes that appear _inside_ arbitrary text, like HTML tags. When
not given a value, in a grammar declaration, defaults to
`"auto"`.
*/ $ed739beecf769914$export$b8034b9bc18acd90.isolate = new $ed739beecf769914$export$b8034b9bc18acd90({
    deserialize: (value)=>{
        if (value && value != "rtl" && value != "ltr" && value != "auto") throw new RangeError("Invalid value for isolate: " + value);
        return value || "auto";
    }
});
/**
The hash of the [context](#lr.ContextTracker.constructor)
that the node was parsed in, if any. Used to limit reuse of
contextual nodes.
*/ $ed739beecf769914$export$b8034b9bc18acd90.contextHash = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
The distance beyond the end of the node that the tokenizer
looked ahead for any of the tokens inside the node. (The LR
parser only stores this when it is larger than 25, for
efficiency reasons.)
*/ $ed739beecf769914$export$b8034b9bc18acd90.lookAhead = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
This per-node prop is used to replace a given node, or part of a
node, with another tree. This is useful to include trees from
different languages in mixed-language parsers.
*/ $ed739beecf769914$export$b8034b9bc18acd90.mounted = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
/**
A mounted tree, which can be [stored](#common.NodeProp^mounted) on
a tree node to indicate that parts of its content are
represented by another tree.
*/ class $ed739beecf769914$export$358cdd8bd77577cc {
    constructor(/**
    The inner tree.
    */ tree, /**
    If this is null, this tree replaces the entire node (it will
    be included in the regular iteration instead of its host
    node). If not, only the given ranges are considered to be
    covered by this tree. This is used for trees that are mixed in
    a way that isn't strictly hierarchical. Such mounted trees are
    only entered by [`resolveInner`](#common.Tree.resolveInner)
    and [`enter`](#common.SyntaxNode.enter).
    */ overlay, /**
    The parser used to create this subtree.
    */ parser){
        this.tree = tree;
        this.overlay = overlay;
        this.parser = parser;
    }
    /**
    @internal
    */ static get(tree) {
        return tree && tree.props && tree.props[$ed739beecf769914$export$b8034b9bc18acd90.mounted.id];
    }
}
const $ed739beecf769914$var$noProps = Object.create(null);
/**
Each node in a syntax tree has a node type associated with it.
*/ class $ed739beecf769914$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name of the node type. Not necessarily unique, but if the
    grammar was written properly, different node types with the
    same name within a node set should play the same semantic
    role.
    */ name, /**
    @internal
    */ props, /**
    The id of this node in its set. Corresponds to the term ids
    used in the parser.
    */ id, /**
    @internal
    */ flags = 0){
        this.name = name;
        this.props = props;
        this.id = id;
        this.flags = flags;
    }
    /**
    Define a node type.
    */ static define(spec) {
        let props = spec.props && spec.props.length ? Object.create(null) : $ed739beecf769914$var$noProps;
        let flags = (spec.top ? 1 /* NodeFlag.Top */  : 0) | (spec.skipped ? 2 /* NodeFlag.Skipped */  : 0) | (spec.error ? 4 /* NodeFlag.Error */  : 0) | (spec.name == null ? 8 /* NodeFlag.Anonymous */  : 0);
        let type = new $ed739beecf769914$export$f06e977173f1857c(spec.name || "", props, spec.id, flags);
        if (spec.props) for (let src of spec.props){
            if (!Array.isArray(src)) src = src(type);
            if (src) {
                if (src[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
                props[src[0].id] = src[1];
            }
        }
        return type;
    }
    /**
    Retrieves a node prop for this type. Will return `undefined` if
    the prop isn't present on this node.
    */ prop(prop) {
        return this.props[prop.id];
    }
    /**
    True when this is the top node of a grammar.
    */ get isTop() {
        return (this.flags & 1 /* NodeFlag.Top */ ) > 0;
    }
    /**
    True when this node is produced by a skip rule.
    */ get isSkipped() {
        return (this.flags & 2 /* NodeFlag.Skipped */ ) > 0;
    }
    /**
    Indicates whether this is an error node.
    */ get isError() {
        return (this.flags & 4 /* NodeFlag.Error */ ) > 0;
    }
    /**
    When true, this node type doesn't correspond to a user-declared
    named node, for example because it is used to cache repetition.
    */ get isAnonymous() {
        return (this.flags & 8 /* NodeFlag.Anonymous */ ) > 0;
    }
    /**
    Returns true when this node's name or one of its
    [groups](#common.NodeProp^group) matches the given string.
    */ is(name) {
        if (typeof name == "string") {
            if (this.name == name) return true;
            let group = this.prop($ed739beecf769914$export$b8034b9bc18acd90.group);
            return group ? group.indexOf(name) > -1 : false;
        }
        return this.id == name;
    }
    /**
    Create a function from node types to arbitrary values by
    specifying an object whose property names are node or
    [group](#common.NodeProp^group) names. Often useful with
    [`NodeProp.add`](#common.NodeProp.add). You can put multiple
    names, separated by spaces, in a single property name to map
    multiple node names to a single value.
    */ static match(map) {
        let direct = Object.create(null);
        for(let prop in map)for (let name of prop.split(" "))direct[name] = map[prop];
        return (node)=>{
            for(let groups = node.prop($ed739beecf769914$export$b8034b9bc18acd90.group), i = -1; i < (groups ? groups.length : 0); i++){
                let found = direct[i < 0 ? node.name : groups[i]];
                if (found) return found;
            }
        };
    }
}
/**
An empty dummy node type to use when no actual type is available.
*/ $ed739beecf769914$export$f06e977173f1857c.none = new $ed739beecf769914$export$f06e977173f1857c("", Object.create(null), 0, 8 /* NodeFlag.Anonymous */ );
/**
A node set holds a collection of node types. It is used to
compactly represent trees by storing their type ids, rather than a
full pointer to the type object, in a numeric array. Each parser
[has](#lr.LRParser.nodeSet) a node set, and [tree
buffers](#common.TreeBuffer) can only store collections of nodes
from the same set. A set can have a maximum of 2**16 (65536) node
types in it, so that the ids fit into 16-bit typed array slots.
*/ class $ed739beecf769914$export$7fad5fb00d8de02c {
    /**
    Create a set with the given types. The `id` property of each
    type should correspond to its position within the array.
    */ constructor(/**
    The node types in this set, by id.
    */ types){
        this.types = types;
        for(let i = 0; i < types.length; i++)if (types[i].id != i) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    /**
    Create a copy of this set with some node properties added. The
    arguments to this method can be created with
    [`NodeProp.add`](#common.NodeProp.add).
    */ extend(...props) {
        let newTypes = [];
        for (let type of this.types){
            let newProps = null;
            for (let source of props){
                let add = source(type);
                if (add) {
                    if (!newProps) newProps = Object.assign({}, type.props);
                    newProps[add[0].id] = add[1];
                }
            }
            newTypes.push(newProps ? new $ed739beecf769914$export$f06e977173f1857c(type.name, newProps, type.id, type.flags) : type);
        }
        return new $ed739beecf769914$export$7fad5fb00d8de02c(newTypes);
    }
}
const $ed739beecf769914$var$CachedNode = new WeakMap(), $ed739beecf769914$var$CachedInnerNode = new WeakMap();
/**
Options that control iteration. Can be combined with the `|`
operator to enable multiple ones.
*/ var $ed739beecf769914$export$b0e28367f55837aa;
(function(IterMode) {
    /**
    When enabled, iteration will only visit [`Tree`](#common.Tree)
    objects, not nodes packed into
    [`TreeBuffer`](#common.TreeBuffer)s.
    */ IterMode[IterMode["ExcludeBuffers"] = 1] = "ExcludeBuffers";
    /**
    Enable this to make iteration include anonymous nodes (such as
    the nodes that wrap repeated grammar constructs into a balanced
    tree).
    */ IterMode[IterMode["IncludeAnonymous"] = 2] = "IncludeAnonymous";
    /**
    By default, regular [mounted](#common.NodeProp^mounted) nodes
    replace their base node in iteration. Enable this to ignore them
    instead.
    */ IterMode[IterMode["IgnoreMounts"] = 4] = "IgnoreMounts";
    /**
    This option only applies in
    [`enter`](#common.SyntaxNode.enter)-style methods. It tells the
    library to not enter mounted overlays if one covers the given
    position.
    */ IterMode[IterMode["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})($ed739beecf769914$export$b0e28367f55837aa || ($ed739beecf769914$export$b0e28367f55837aa = {}));
/**
A piece of syntax tree. There are two ways to approach these
trees: the way they are actually stored in memory, and the
convenient way.

Syntax trees are stored as a tree of `Tree` and `TreeBuffer`
objects. By packing detail information into `TreeBuffer` leaf
nodes, the representation is made a lot more memory-efficient.

However, when you want to actually work with tree nodes, this
representation is very awkward, so most client code will want to
use the [`TreeCursor`](#common.TreeCursor) or
[`SyntaxNode`](#common.SyntaxNode) interface instead, which provides
a view on some part of this data structure, and can be used to
move around to adjacent nodes.
*/ class $ed739beecf769914$export$7fbedc92909ed28e {
    /**
    Construct a new tree. See also [`Tree.build`](#common.Tree^build).
    */ constructor(/**
    The type of the top node.
    */ type, /**
    This node's child nodes.
    */ children, /**
    The positions (offsets relative to the start of this tree) of
    the children.
    */ positions, /**
    The total length of this tree
    */ length, /**
    Per-node [node props](#common.NodeProp) to associate with this node.
    */ props){
        this.type = type;
        this.children = children;
        this.positions = positions;
        this.length = length;
        /**
        @internal
        */ this.props = null;
        if (props && props.length) {
            this.props = Object.create(null);
            for (let [prop, value] of props)this.props[typeof prop == "number" ? prop : prop.id] = value;
        }
    }
    /**
    @internal
    */ toString() {
        let mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(this);
        if (mounted && !mounted.overlay) return mounted.tree.toString();
        let children = "";
        for (let ch of this.children){
            let str = ch.toString();
            if (str) {
                if (children) children += ",";
                children += str;
            }
        }
        return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
    }
    /**
    Get a [tree cursor](#common.TreeCursor) positioned at the top of
    the tree. Mode can be used to [control](#common.IterMode) which
    nodes the cursor visits.
    */ cursor(mode = 0) {
        return new $ed739beecf769914$export$3ae4554f36e54a34(this.topNode, mode);
    }
    /**
    Get a [tree cursor](#common.TreeCursor) pointing into this tree
    at the given position and side (see
    [`moveTo`](#common.TreeCursor.moveTo).
    */ cursorAt(pos, side = 0, mode = 0) {
        let scope = $ed739beecf769914$var$CachedNode.get(this) || this.topNode;
        let cursor = new $ed739beecf769914$export$3ae4554f36e54a34(scope);
        cursor.moveTo(pos, side);
        $ed739beecf769914$var$CachedNode.set(this, cursor._tree);
        return cursor;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) object for the top of the
    tree.
    */ get topNode() {
        return new $ed739beecf769914$var$TreeNode(this, 0, 0, null);
    }
    /**
    Get the [syntax node](#common.SyntaxNode) at the given position.
    If `side` is -1, this will move into nodes that end at the
    position. If 1, it'll move into nodes that start at the
    position. With 0, it'll only enter nodes that cover the position
    from both sides.
    
    Note that this will not enter
    [overlays](#common.MountedTree.overlay), and you often want
    [`resolveInner`](#common.Tree.resolveInner) instead.
    */ resolve(pos, side = 0) {
        let node = $ed739beecf769914$var$resolveNode($ed739beecf769914$var$CachedNode.get(this) || this.topNode, pos, side, false);
        $ed739beecf769914$var$CachedNode.set(this, node);
        return node;
    }
    /**
    Like [`resolve`](#common.Tree.resolve), but will enter
    [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
    pointing into the innermost overlaid tree at the given position
    (with parent links going through all parent structure, including
    the host trees).
    */ resolveInner(pos, side = 0) {
        let node = $ed739beecf769914$var$resolveNode($ed739beecf769914$var$CachedInnerNode.get(this) || this.topNode, pos, side, true);
        $ed739beecf769914$var$CachedInnerNode.set(this, node);
        return node;
    }
    /**
    In some situations, it can be useful to iterate through all
    nodes around a position, including those in overlays that don't
    directly cover the position. This method gives you an iterator
    that will produce all nodes, from small to big, around the given
    position.
    */ resolveStack(pos, side = 0) {
        return $ed739beecf769914$var$stackIterator(this, pos, side);
    }
    /**
    Iterate over the tree and its children, calling `enter` for any
    node that touches the `from`/`to` region (if given) before
    running over such a node's children, and `leave` (if given) when
    leaving the node. When `enter` returns `false`, that node will
    not have its children iterated over (or `leave` called).
    */ iterate(spec) {
        let { enter: enter, leave: leave, from: from = 0, to: to = this.length } = spec;
        let mode = spec.mode || 0, anon = (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous) > 0;
        for(let c = this.cursor(mode | $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous);;){
            let entered = false;
            if (c.from <= to && c.to >= from && (!anon && c.type.isAnonymous || enter(c) !== false)) {
                if (c.firstChild()) continue;
                entered = true;
            }
            for(;;){
                if (entered && leave && (anon || !c.type.isAnonymous)) leave(c);
                if (c.nextSibling()) break;
                if (!c.parent()) return;
                entered = true;
            }
        }
    }
    /**
    Get the value of the given [node prop](#common.NodeProp) for this
    node. Works with both per-node and per-type props.
    */ prop(prop) {
        return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : undefined;
    }
    /**
    Returns the node's [per-node props](#common.NodeProp.perNode) in a
    format that can be passed to the [`Tree`](#common.Tree)
    constructor.
    */ get propValues() {
        let result = [];
        if (this.props) for(let id in this.props)result.push([
            +id,
            this.props[id]
        ]);
        return result;
    }
    /**
    Balance the direct children of this tree, producing a copy of
    which may have children grouped into subtrees with type
    [`NodeType.none`](#common.NodeType^none).
    */ balance(config = {}) {
        return this.children.length <= 8 /* Balance.BranchFactor */  ? this : $ed739beecf769914$var$balanceRange($ed739beecf769914$export$f06e977173f1857c.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length)=>new $ed739beecf769914$export$7fbedc92909ed28e(this.type, children, positions, length, this.propValues), config.makeTree || ((children, positions, length)=>new $ed739beecf769914$export$7fbedc92909ed28e($ed739beecf769914$export$f06e977173f1857c.none, children, positions, length)));
    }
    /**
    Build a tree from a postfix-ordered buffer of node information,
    or a cursor over such a buffer.
    */ static build(data) {
        return $ed739beecf769914$var$buildTree(data);
    }
}
/**
The empty tree
*/ $ed739beecf769914$export$7fbedc92909ed28e.empty = new $ed739beecf769914$export$7fbedc92909ed28e($ed739beecf769914$export$f06e977173f1857c.none, [], [], 0);
class $ed739beecf769914$var$FlatBufferCursor {
    constructor(buffer, index){
        this.buffer = buffer;
        this.index = index;
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    get pos() {
        return this.index;
    }
    next() {
        this.index -= 4;
    }
    fork() {
        return new $ed739beecf769914$var$FlatBufferCursor(this.buffer, this.index);
    }
}
/**
Tree buffers contain (type, start, end, endIndex) quads for each
node. In such a buffer, nodes are stored in prefix order (parents
before children, with the endIndex of the parent indicating which
children belong to it).
*/ class $ed739beecf769914$export$33300581b70be371 {
    /**
    Create a tree buffer.
    */ constructor(/**
    The buffer's content.
    */ buffer, /**
    The total length of the group of nodes in the buffer.
    */ length, /**
    The node set used in this buffer.
    */ set){
        this.buffer = buffer;
        this.length = length;
        this.set = set;
    }
    /**
    @internal
    */ get type() {
        return $ed739beecf769914$export$f06e977173f1857c.none;
    }
    /**
    @internal
    */ toString() {
        let result = [];
        for(let index = 0; index < this.buffer.length;){
            result.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result.join(",");
    }
    /**
    @internal
    */ childString(index) {
        let id = this.buffer[index], endIndex = this.buffer[index + 3];
        let type = this.set.types[id], result = type.name;
        if (/\W/.test(result) && !type.isError) result = JSON.stringify(result);
        index += 4;
        if (endIndex == index) return result;
        let children = [];
        while(index < endIndex){
            children.push(this.childString(index));
            index = this.buffer[index + 3];
        }
        return result + "(" + children.join(",") + ")";
    }
    /**
    @internal
    */ findChild(startIndex, endIndex, dir, pos, side) {
        let { buffer: buffer } = this, pick = -1;
        for(let i = startIndex; i != endIndex; i = buffer[i + 3])if ($ed739beecf769914$var$checkSide(side, pos, buffer[i + 1], buffer[i + 2])) {
            pick = i;
            if (dir > 0) break;
        }
        return pick;
    }
    /**
    @internal
    */ slice(startI, endI, from) {
        let b = this.buffer;
        let copy = new Uint16Array(endI - startI), len = 0;
        for(let i = startI, j = 0; i < endI;){
            copy[j++] = b[i++];
            copy[j++] = b[i++] - from;
            let to = copy[j++] = b[i++] - from;
            copy[j++] = b[i++] - startI;
            len = Math.max(len, to);
        }
        return new $ed739beecf769914$export$33300581b70be371(copy, len, this.set);
    }
}
function $ed739beecf769914$var$checkSide(side, pos, from, to) {
    switch(side){
        case -2 /* Side.Before */ :
            return from < pos;
        case -1 /* Side.AtOrBefore */ :
            return to >= pos && from < pos;
        case 0 /* Side.Around */ :
            return from < pos && to > pos;
        case 1 /* Side.AtOrAfter */ :
            return from <= pos && to > pos;
        case 2 /* Side.After */ :
            return to > pos;
        case 4 /* Side.DontCare */ :
            return true;
    }
}
function $ed739beecf769914$var$resolveNode(node, pos, side, overlays) {
    var _a;
    // Move up to a node that actually holds the position, if possible
    while(node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)){
        let parent = !overlays && node instanceof $ed739beecf769914$var$TreeNode && node.index < 0 ? null : node.parent;
        if (!parent) return node;
        node = parent;
    }
    let mode = overlays ? 0 : $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays;
    // Must go up out of overlays when those do not overlap with pos
    if (overlays) {
        for(let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent)if (scan instanceof $ed739beecf769914$var$TreeNode && scan.index < 0 && ((_a = parent.enter(pos, side, mode)) === null || _a === void 0 ? void 0 : _a.from) != scan.from) node = parent;
    }
    for(;;){
        let inner = node.enter(pos, side, mode);
        if (!inner) return node;
        node = inner;
    }
}
class $ed739beecf769914$var$BaseNode {
    cursor(mode = 0) {
        return new $ed739beecf769914$export$3ae4554f36e54a34(this, mode);
    }
    getChild(type, before = null, after = null) {
        let r = $ed739beecf769914$var$getChildren(this, type, before, after);
        return r.length ? r[0] : null;
    }
    getChildren(type, before = null, after = null) {
        return $ed739beecf769914$var$getChildren(this, type, before, after);
    }
    resolve(pos, side = 0) {
        return $ed739beecf769914$var$resolveNode(this, pos, side, false);
    }
    resolveInner(pos, side = 0) {
        return $ed739beecf769914$var$resolveNode(this, pos, side, true);
    }
    matchContext(context) {
        return $ed739beecf769914$var$matchNodeContext(this, context);
    }
    enterUnfinishedNodesBefore(pos) {
        let scan = this.childBefore(pos), node = this;
        while(scan){
            let last = scan.lastChild;
            if (!last || last.to != scan.to) break;
            if (last.type.isError && last.from == last.to) {
                node = scan;
                scan = last.prevSibling;
            } else scan = last;
        }
        return node;
    }
    get node() {
        return this;
    }
    get next() {
        return this.parent;
    }
}
class $ed739beecf769914$var$TreeNode extends $ed739beecf769914$var$BaseNode {
    constructor(_tree, from, // Index in parent node, set to -1 if the node is not a direct child of _parent.node (overlay)
    index, _parent){
        super();
        this._tree = _tree;
        this.from = from;
        this.index = index;
        this._parent = _parent;
    }
    get type() {
        return this._tree.type;
    }
    get name() {
        return this._tree.type.name;
    }
    get to() {
        return this.from + this._tree.length;
    }
    nextChild(i, dir, pos, side, mode = 0) {
        for(let parent = this;;){
            for(let { children: children, positions: positions } = parent._tree, e = dir > 0 ? children.length : -1; i != e; i += dir){
                let next = children[i], start = positions[i] + parent.from;
                if (!$ed739beecf769914$var$checkSide(side, pos, start, start + next.length)) continue;
                if (next instanceof $ed739beecf769914$export$33300581b70be371) {
                    if (mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers) continue;
                    let index = next.findChild(0, next.buffer.length, dir, pos - start, side);
                    if (index > -1) return new $ed739beecf769914$var$BufferNode(new $ed739beecf769914$var$BufferContext(parent, next, i, start), null, index);
                } else if (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !next.type.isAnonymous || $ed739beecf769914$var$hasChild(next)) {
                    let mounted;
                    if (!(mode & $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts) && (mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(next)) && !mounted.overlay) return new $ed739beecf769914$var$TreeNode(mounted.tree, start, i, parent);
                    let inner = new $ed739beecf769914$var$TreeNode(next, start, i, parent);
                    return mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
                }
            }
            if (mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || !parent.type.isAnonymous) return null;
            if (parent.index >= 0) i = parent.index + dir;
            else i = dir < 0 ? -1 : parent._parent._tree.children.length;
            parent = parent._parent;
            if (!parent) return null;
        }
    }
    get firstChild() {
        return this.nextChild(0, 1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.nextChild(this._tree.children.length - 1, -1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.nextChild(0, 1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.nextChild(this._tree.children.length - 1, -1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        let mounted;
        if (!(mode & $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays) && (mounted = $ed739beecf769914$export$358cdd8bd77577cc.get(this._tree)) && mounted.overlay) {
            let rPos = pos - this.from;
            for (let { from: from, to: to } of mounted.overlay){
                if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to >= rPos : to > rPos)) return new $ed739beecf769914$var$TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
            }
        }
        return this.nextChild(0, 1, pos, side, mode);
    }
    nextSignificantParent() {
        let val = this;
        while(val.type.isAnonymous && val._parent)val = val._parent;
        return val;
    }
    get parent() {
        return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get prevSibling() {
        return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4 /* Side.DontCare */ ) : null;
    }
    get tree() {
        return this._tree;
    }
    toTree() {
        return this._tree;
    }
    /**
    @internal
    */ toString() {
        return this._tree.toString();
    }
}
function $ed739beecf769914$var$getChildren(node, type, before, after) {
    let cur = node.cursor(), result = [];
    if (!cur.firstChild()) return result;
    if (before != null) for(let found = false; !found;){
        found = cur.type.is(before);
        if (!cur.nextSibling()) return result;
    }
    for(;;){
        if (after != null && cur.type.is(after)) return result;
        if (cur.type.is(type)) result.push(cur.node);
        if (!cur.nextSibling()) return after == null ? result : [];
    }
}
function $ed739beecf769914$var$matchNodeContext(node, context, i = context.length - 1) {
    for(let p = node.parent; i >= 0; p = p.parent){
        if (!p) return false;
        if (!p.type.isAnonymous) {
            if (context[i] && context[i] != p.name) return false;
            i--;
        }
    }
    return true;
}
class $ed739beecf769914$var$BufferContext {
    constructor(parent, buffer, index, start){
        this.parent = parent;
        this.buffer = buffer;
        this.index = index;
        this.start = start;
    }
}
class $ed739beecf769914$var$BufferNode extends $ed739beecf769914$var$BaseNode {
    get name() {
        return this.type.name;
    }
    get from() {
        return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
        return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(context, _parent, index){
        super();
        this.context = context;
        this._parent = _parent;
        this.index = index;
        this.type = context.buffer.set.types[context.buffer.buffer[index]];
    }
    child(dir, pos, side) {
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
        return index < 0 ? null : new $ed739beecf769914$var$BufferNode(this.context, this, index);
    }
    get firstChild() {
        return this.child(1, 0, 4 /* Side.DontCare */ );
    }
    get lastChild() {
        return this.child(-1, 0, 4 /* Side.DontCare */ );
    }
    childAfter(pos) {
        return this.child(1, pos, 2 /* Side.After */ );
    }
    childBefore(pos) {
        return this.child(-1, pos, -2 /* Side.Before */ );
    }
    enter(pos, side, mode = 0) {
        if (mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers) return null;
        let { buffer: buffer } = this.context;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
        return index < 0 ? null : new $ed739beecf769914$var$BufferNode(this.context, this, index);
    }
    get parent() {
        return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(dir) {
        return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4 /* Side.DontCare */ );
    }
    get nextSibling() {
        let { buffer: buffer } = this.context;
        let after = buffer.buffer[this.index + 3];
        if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length)) return new $ed739beecf769914$var$BufferNode(this.context, this._parent, after);
        return this.externalSibling(1);
    }
    get prevSibling() {
        let { buffer: buffer } = this.context;
        let parentStart = this._parent ? this._parent.index + 4 : 0;
        if (this.index == parentStart) return this.externalSibling(-1);
        return new $ed739beecf769914$var$BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
    }
    get tree() {
        return null;
    }
    toTree() {
        let children = [], positions = [];
        let { buffer: buffer } = this.context;
        let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
        if (endI > startI) {
            let from = buffer.buffer[this.index + 1];
            children.push(buffer.slice(startI, endI, from));
            positions.push(0);
        }
        return new $ed739beecf769914$export$7fbedc92909ed28e(this.type, children, positions, this.to - this.from);
    }
    /**
    @internal
    */ toString() {
        return this.context.buffer.childString(this.index);
    }
}
function $ed739beecf769914$var$iterStack(heads) {
    if (!heads.length) return null;
    let pick = 0, picked = heads[0];
    for(let i = 1; i < heads.length; i++){
        let node = heads[i];
        if (node.from > picked.from || node.to < picked.to) {
            picked = node;
            pick = i;
        }
    }
    let next = picked instanceof $ed739beecf769914$var$TreeNode && picked.index < 0 ? null : picked.parent;
    let newHeads = heads.slice();
    if (next) newHeads[pick] = next;
    else newHeads.splice(pick, 1);
    return new $ed739beecf769914$var$StackIterator(newHeads, picked);
}
class $ed739beecf769914$var$StackIterator {
    constructor(heads, node){
        this.heads = heads;
        this.node = node;
    }
    get next() {
        return $ed739beecf769914$var$iterStack(this.heads);
    }
}
function $ed739beecf769914$var$stackIterator(tree, pos, side) {
    let inner = tree.resolveInner(pos, side), layers = null;
    for(let scan = inner instanceof $ed739beecf769914$var$TreeNode ? inner : inner.context.parent; scan; scan = scan.parent)if (scan.index < 0) {
        let parent = scan.parent;
        (layers || (layers = [
            inner
        ])).push(parent.resolve(pos, side));
        scan = parent;
    } else {
        let mount = $ed739beecf769914$export$358cdd8bd77577cc.get(scan.tree);
        // Relevant overlay branching off
        if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
            let root = new $ed739beecf769914$var$TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
            (layers || (layers = [
                inner
            ])).push($ed739beecf769914$var$resolveNode(root, pos, side, false));
        }
    }
    return layers ? $ed739beecf769914$var$iterStack(layers) : inner;
}
/**
A tree cursor object focuses on a given node in a syntax tree, and
allows you to move to adjacent nodes.
*/ class $ed739beecf769914$export$3ae4554f36e54a34 {
    /**
    Shorthand for `.type.name`.
    */ get name() {
        return this.type.name;
    }
    /**
    @internal
    */ constructor(node, /**
    @internal
    */ mode = 0){
        this.mode = mode;
        /**
        @internal
        */ this.buffer = null;
        this.stack = [];
        /**
        @internal
        */ this.index = 0;
        this.bufferNode = null;
        if (node instanceof $ed739beecf769914$var$TreeNode) this.yieldNode(node);
        else {
            this._tree = node.context.parent;
            this.buffer = node.context;
            for(let n = node._parent; n; n = n._parent)this.stack.unshift(n.index);
            this.bufferNode = node;
            this.yieldBuf(node.index);
        }
    }
    yieldNode(node) {
        if (!node) return false;
        this._tree = node;
        this.type = node.type;
        this.from = node.from;
        this.to = node.to;
        return true;
    }
    yieldBuf(index, type) {
        this.index = index;
        let { start: start, buffer: buffer } = this.buffer;
        this.type = type || buffer.set.types[buffer.buffer[index]];
        this.from = start + buffer.buffer[index + 1];
        this.to = start + buffer.buffer[index + 2];
        return true;
    }
    /**
    @internal
    */ yield(node) {
        if (!node) return false;
        if (node instanceof $ed739beecf769914$var$TreeNode) {
            this.buffer = null;
            return this.yieldNode(node);
        }
        this.buffer = node.context;
        return this.yieldBuf(node.index, node.type);
    }
    /**
    @internal
    */ toString() {
        return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    /**
    @internal
    */ enterChild(dir, pos, side) {
        if (!this.buffer) return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
        let { buffer: buffer } = this.buffer;
        let index = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
        if (index < 0) return false;
        this.stack.push(this.index);
        return this.yieldBuf(index);
    }
    /**
    Move the cursor to this node's first child. When this returns
    false, the node has no child, and the cursor has not been moved.
    */ firstChild() {
        return this.enterChild(1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to this node's last child.
    */ lastChild() {
        return this.enterChild(-1, 0, 4 /* Side.DontCare */ );
    }
    /**
    Move the cursor to the first child that ends after `pos`.
    */ childAfter(pos) {
        return this.enterChild(1, pos, 2 /* Side.After */ );
    }
    /**
    Move to the last child that starts before `pos`.
    */ childBefore(pos) {
        return this.enterChild(-1, pos, -2 /* Side.Before */ );
    }
    /**
    Move the cursor to the child around `pos`. If side is -1 the
    child may end at that position, when 1 it may start there. This
    will also enter [overlaid](#common.MountedTree.overlay)
    [mounted](#common.NodeProp^mounted) trees unless `overlays` is
    set to false.
    */ enter(pos, side, mode = this.mode) {
        if (!this.buffer) return this.yield(this._tree.enter(pos, side, mode));
        return mode & $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers ? false : this.enterChild(1, pos, side);
    }
    /**
    Move to the node's parent node, if this isn't the top node.
    */ parent() {
        if (!this.buffer) return this.yieldNode(this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous ? this._tree._parent : this._tree.parent);
        if (this.stack.length) return this.yieldBuf(this.stack.pop());
        let parent = this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
        this.buffer = null;
        return this.yieldNode(parent);
    }
    /**
    @internal
    */ sibling(dir) {
        if (!this.buffer) return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode));
        let { buffer: buffer } = this.buffer, d = this.stack.length - 1;
        if (dir < 0) {
            let parentStart = d < 0 ? 0 : this.stack[d] + 4;
            if (this.index != parentStart) return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4 /* Side.DontCare */ ));
        } else {
            let after = buffer.buffer[this.index + 3];
            if (after < (d < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d] + 3])) return this.yieldBuf(after);
        }
        return d < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4 /* Side.DontCare */ , this.mode)) : false;
    }
    /**
    Move to this node's next sibling, if any.
    */ nextSibling() {
        return this.sibling(1);
    }
    /**
    Move to this node's previous sibling, if any.
    */ prevSibling() {
        return this.sibling(-1);
    }
    atLastNode(dir) {
        let index, parent, { buffer: buffer } = this;
        if (buffer) {
            if (dir > 0) {
                if (this.index < buffer.buffer.buffer.length) return false;
            } else {
                for(let i = 0; i < this.index; i++)if (buffer.buffer.buffer[i + 3] < this.index) return false;
            }
            ({ index: index, parent: parent } = buffer);
        } else ({ index: index, _parent: parent } = this._tree);
        for(; parent; { index: index, _parent: parent } = parent){
            if (index > -1) for(let i = index + dir, e = dir < 0 ? -1 : parent._tree.children.length; i != e; i += dir){
                let child = parent._tree.children[i];
                if (this.mode & $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous || child instanceof $ed739beecf769914$export$33300581b70be371 || !child.type.isAnonymous || $ed739beecf769914$var$hasChild(child)) return false;
            }
        }
        return true;
    }
    move(dir, enter) {
        if (enter && this.enterChild(dir, 0, 4 /* Side.DontCare */ )) return true;
        for(;;){
            if (this.sibling(dir)) return true;
            if (this.atLastNode(dir) || !this.parent()) return false;
        }
    }
    /**
    Move to the next node in a
    [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
    traversal, going from a node to its first child or, if the
    current node is empty or `enter` is false, its next sibling or
    the next sibling of the first parent node that has one.
    */ next(enter = true) {
        return this.move(1, enter);
    }
    /**
    Move to the next node in a last-to-first pre-order traveral. A
    node is followed by its last child or, if it has none, its
    previous sibling or the previous sibling of the first parent
    node that has one.
    */ prev(enter = true) {
        return this.move(-1, enter);
    }
    /**
    Move the cursor to the innermost node that covers `pos`. If
    `side` is -1, it will enter nodes that end at `pos`. If it is 1,
    it will enter nodes that start at `pos`.
    */ moveTo(pos, side = 0) {
        // Move up to a node that actually holds the position, if possible
        while(this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))if (!this.parent()) break;
        // Then scan down into child nodes as far as possible
        while(this.enterChild(1, pos, side));
        return this;
    }
    /**
    Get a [syntax node](#common.SyntaxNode) at the cursor's current
    position.
    */ get node() {
        if (!this.buffer) return this._tree;
        let cache = this.bufferNode, result = null, depth = 0;
        if (cache && cache.context == this.buffer) scan: for(let index = this.index, d = this.stack.length; d >= 0;){
            for(let c = cache; c; c = c._parent)if (c.index == index) {
                if (index == this.index) return c;
                result = c;
                depth = d + 1;
                break scan;
            }
            index = this.stack[--d];
        }
        for(let i = depth; i < this.stack.length; i++)result = new $ed739beecf769914$var$BufferNode(this.buffer, result, this.stack[i]);
        return this.bufferNode = new $ed739beecf769914$var$BufferNode(this.buffer, result, this.index);
    }
    /**
    Get the [tree](#common.Tree) that represents the current node, if
    any. Will return null when the node is in a [tree
    buffer](#common.TreeBuffer).
    */ get tree() {
        return this.buffer ? null : this._tree._tree;
    }
    /**
    Iterate over the current node and all its descendants, calling
    `enter` when entering a node and `leave`, if given, when leaving
    one. When `enter` returns `false`, any children of that node are
    skipped, and `leave` isn't called for it.
    */ iterate(enter, leave) {
        for(let depth = 0;;){
            let mustLeave = false;
            if (this.type.isAnonymous || enter(this) !== false) {
                if (this.firstChild()) {
                    depth++;
                    continue;
                }
                if (!this.type.isAnonymous) mustLeave = true;
            }
            for(;;){
                if (mustLeave && leave) leave(this);
                mustLeave = this.type.isAnonymous;
                if (this.nextSibling()) break;
                if (!depth) return;
                this.parent();
                depth--;
                mustLeave = true;
            }
        }
    }
    /**
    Test whether the current node matches a given context—a sequence
    of direct parent node names. Empty strings in the context array
    are treated as wildcards.
    */ matchContext(context) {
        if (!this.buffer) return $ed739beecf769914$var$matchNodeContext(this.node, context);
        let { buffer: buffer } = this.buffer, { types: types } = buffer.set;
        for(let i = context.length - 1, d = this.stack.length - 1; i >= 0; d--){
            if (d < 0) return $ed739beecf769914$var$matchNodeContext(this.node, context, i);
            let type = types[buffer.buffer[this.stack[d]]];
            if (!type.isAnonymous) {
                if (context[i] && context[i] != type.name) return false;
                i--;
            }
        }
        return true;
    }
}
function $ed739beecf769914$var$hasChild(tree) {
    return tree.children.some((ch)=>ch instanceof $ed739beecf769914$export$33300581b70be371 || !ch.type.isAnonymous || $ed739beecf769914$var$hasChild(ch));
}
function $ed739beecf769914$var$buildTree(data) {
    var _a;
    let { buffer: buffer, nodeSet: nodeSet, maxBufferLength: maxBufferLength = $ed739beecf769914$export$de305a849879ffa, reused: reused = [], minRepeatType: minRepeatType = nodeSet.types.length } = data;
    let cursor = Array.isArray(buffer) ? new $ed739beecf769914$var$FlatBufferCursor(buffer, buffer.length) : buffer;
    let types = nodeSet.types;
    let contextHash = 0, lookAhead = 0;
    function takeNode(parentStart, minPos, children, positions, inRepeat, depth) {
        let { id: id, start: start, end: end, size: size } = cursor;
        let lookAheadAtStart = lookAhead;
        while(size < 0){
            cursor.next();
            if (size == -1 /* SpecialRecord.Reuse */ ) {
                let node = reused[id];
                children.push(node);
                positions.push(start - parentStart);
                return;
            } else if (size == -3 /* SpecialRecord.ContextChange */ ) {
                contextHash = id;
                return;
            } else if (size == -4 /* SpecialRecord.LookAhead */ ) {
                lookAhead = id;
                return;
            } else throw new RangeError(`Unrecognized record size: ${size}`);
        }
        let type = types[id], node, buffer;
        let startPos = start - parentStart;
        if (end - start <= maxBufferLength && (buffer = findBufferSize(cursor.pos - minPos, inRepeat))) {
            // Small enough for a buffer, and no reused nodes inside
            let data = new Uint16Array(buffer.size - buffer.skip);
            let endPos = cursor.pos - buffer.size, index = data.length;
            while(cursor.pos > endPos)index = copyToBuffer(buffer.start, data, index);
            node = new $ed739beecf769914$export$33300581b70be371(data, end - buffer.start, nodeSet);
            startPos = buffer.start - parentStart;
        } else {
            let endPos = cursor.pos - size;
            cursor.next();
            let localChildren = [], localPositions = [];
            let localInRepeat = id >= minRepeatType ? id : -1;
            let lastGroup = 0, lastEnd = end;
            while(cursor.pos > endPos){
                if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
                    if (cursor.end <= lastEnd - maxBufferLength) {
                        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart);
                        lastGroup = localChildren.length;
                        lastEnd = cursor.end;
                    }
                    cursor.next();
                } else if (depth > 2500 /* CutOff.Depth */ ) takeFlatNode(start, endPos, localChildren, localPositions);
                else takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
            }
            if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length) makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart);
            localChildren.reverse();
            localPositions.reverse();
            if (localInRepeat > -1 && lastGroup > 0) {
                let make = makeBalanced(type);
                node = $ed739beecf769914$var$balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
            } else node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end);
        }
        children.push(node);
        positions.push(startPos);
    }
    function takeFlatNode(parentStart, minPos, children, positions) {
        let nodes = []; // Temporary, inverted array of leaf nodes found, with absolute positions
        let nodeCount = 0, stopAt = -1;
        while(cursor.pos > minPos){
            let { id: id, start: start, end: end, size: size } = cursor;
            if (size > 4) cursor.next();
            else if (stopAt > -1 && start < stopAt) break;
            else {
                if (stopAt < 0) stopAt = end - maxBufferLength;
                nodes.push(id, start, end);
                nodeCount++;
                cursor.next();
            }
        }
        if (nodeCount) {
            let buffer = new Uint16Array(nodeCount * 4);
            let start = nodes[nodes.length - 2];
            for(let i = nodes.length - 3, j = 0; i >= 0; i -= 3){
                buffer[j++] = nodes[i];
                buffer[j++] = nodes[i + 1] - start;
                buffer[j++] = nodes[i + 2] - start;
                buffer[j++] = j;
            }
            children.push(new $ed739beecf769914$export$33300581b70be371(buffer, nodes[2] - start, nodeSet));
            positions.push(start - parentStart);
        }
    }
    function makeBalanced(type) {
        return (children, positions, length)=>{
            let lookAhead = 0, lastI = children.length - 1, last, lookAheadProp;
            if (lastI >= 0 && (last = children[lastI]) instanceof $ed739beecf769914$export$7fbedc92909ed28e) {
                if (!lastI && last.type == type && last.length == length) return last;
                if (lookAheadProp = last.prop($ed739beecf769914$export$b8034b9bc18acd90.lookAhead)) lookAhead = positions[lastI] + last.length + lookAheadProp;
            }
            return makeTree(type, children, positions, length, lookAhead);
        };
    }
    function makeRepeatLeaf(children, positions, base, i, from, to, type, lookAhead) {
        let localChildren = [], localPositions = [];
        while(children.length > i){
            localChildren.push(children.pop());
            localPositions.push(positions.pop() + base - from);
        }
        children.push(makeTree(nodeSet.types[type], localChildren, localPositions, to - from, lookAhead - to));
        positions.push(from - base);
    }
    function makeTree(type, children, positions, length, lookAhead = 0, props) {
        if (contextHash) {
            let pair = [
                $ed739beecf769914$export$b8034b9bc18acd90.contextHash,
                contextHash
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        if (lookAhead > 25) {
            let pair = [
                $ed739beecf769914$export$b8034b9bc18acd90.lookAhead,
                lookAhead
            ];
            props = props ? [
                pair
            ].concat(props) : [
                pair
            ];
        }
        return new $ed739beecf769914$export$7fbedc92909ed28e(type, children, positions, length, props);
    }
    function findBufferSize(maxSize, inRepeat) {
        // Scan through the buffer to find previous siblings that fit
        // together in a TreeBuffer, and don't contain any reused nodes
        // (which can't be stored in a buffer).
        // If `inRepeat` is > -1, ignore node boundaries of that type for
        // nesting, but make sure the end falls either at the start
        // (`maxSize`) or before such a node.
        let fork = cursor.fork();
        let size = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
        let result = {
            size: 0,
            start: 0,
            skip: 0
        };
        scan: for(let minPos = fork.pos - maxSize; fork.pos > minPos;){
            let nodeSize = fork.size;
            // Pretend nested repeat nodes of the same type don't exist
            if (fork.id == inRepeat && nodeSize >= 0) {
                // Except that we store the current state as a valid return
                // value.
                result.size = size;
                result.start = start;
                result.skip = skip;
                skip += 4;
                size += 4;
                fork.next();
                continue;
            }
            let startPos = fork.pos - nodeSize;
            if (nodeSize < 0 || startPos < minPos || fork.start < minStart) break;
            let localSkipped = fork.id >= minRepeatType ? 4 : 0;
            let nodeStart = fork.start;
            fork.next();
            while(fork.pos > startPos){
                if (fork.size < 0) {
                    if (fork.size == -3 /* SpecialRecord.ContextChange */ ) localSkipped += 4;
                    else break scan;
                } else if (fork.id >= minRepeatType) localSkipped += 4;
                fork.next();
            }
            start = nodeStart;
            size += nodeSize;
            skip += localSkipped;
        }
        if (inRepeat < 0 || size == maxSize) {
            result.size = size;
            result.start = start;
            result.skip = skip;
        }
        return result.size > 4 ? result : undefined;
    }
    function copyToBuffer(bufferStart, buffer, index) {
        let { id: id, start: start, end: end, size: size } = cursor;
        cursor.next();
        if (size >= 0 && id < minRepeatType) {
            let startIndex = index;
            if (size > 4) {
                let endPos = cursor.pos - (size - 4);
                while(cursor.pos > endPos)index = copyToBuffer(bufferStart, buffer, index);
            }
            buffer[--index] = startIndex;
            buffer[--index] = end - bufferStart;
            buffer[--index] = start - bufferStart;
            buffer[--index] = id;
        } else if (size == -3 /* SpecialRecord.ContextChange */ ) contextHash = id;
        else if (size == -4 /* SpecialRecord.LookAhead */ ) lookAhead = id;
        return index;
    }
    let children = [], positions = [];
    while(cursor.pos > 0)takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
    let length = (_a = data.length) !== null && _a !== void 0 ? _a : children.length ? positions[0] + children[0].length : 0;
    return new $ed739beecf769914$export$7fbedc92909ed28e(types[data.topID], children.reverse(), positions.reverse(), length);
}
const $ed739beecf769914$var$nodeSizeCache = new WeakMap;
function $ed739beecf769914$var$nodeSize(balanceType, node) {
    if (!balanceType.isAnonymous || node instanceof $ed739beecf769914$export$33300581b70be371 || node.type != balanceType) return 1;
    let size = $ed739beecf769914$var$nodeSizeCache.get(node);
    if (size == null) {
        size = 1;
        for (let child of node.children){
            if (child.type != balanceType || !(child instanceof $ed739beecf769914$export$7fbedc92909ed28e)) {
                size = 1;
                break;
            }
            size += $ed739beecf769914$var$nodeSize(balanceType, child);
        }
        $ed739beecf769914$var$nodeSizeCache.set(node, size);
    }
    return size;
}
function $ed739beecf769914$var$balanceRange(// The type the balanced tree's inner nodes.
balanceType, // The direct children and their positions
children, positions, // The index range in children/positions to use
from, to, // The start position of the nodes, relative to their parent.
start, // Length of the outer node
length, // Function to build the top node of the balanced tree
mkTop, // Function to build internal nodes for the balanced tree
mkTree) {
    let total = 0;
    for(let i = from; i < to; i++)total += $ed739beecf769914$var$nodeSize(balanceType, children[i]);
    let maxChild = Math.ceil(total * 1.5 / 8 /* Balance.BranchFactor */ );
    let localChildren = [], localPositions = [];
    function divide(children, positions, from, to, offset) {
        for(let i = from; i < to;){
            let groupFrom = i, groupStart = positions[i], groupSize = $ed739beecf769914$var$nodeSize(balanceType, children[i]);
            i++;
            for(; i < to; i++){
                let nextSize = $ed739beecf769914$var$nodeSize(balanceType, children[i]);
                if (groupSize + nextSize >= maxChild) break;
                groupSize += nextSize;
            }
            if (i == groupFrom + 1) {
                if (groupSize > maxChild) {
                    let only = children[groupFrom]; // Only trees can have a size > 1
                    divide(only.children, only.positions, 0, only.children.length, positions[groupFrom] + offset);
                    continue;
                }
                localChildren.push(children[groupFrom]);
            } else {
                let length = positions[i - 1] + children[i - 1].length - groupStart;
                localChildren.push($ed739beecf769914$var$balanceRange(balanceType, children, positions, groupFrom, i, groupStart, length, null, mkTree));
            }
            localPositions.push(groupStart + offset - start);
        }
    }
    divide(children, positions, from, to, 0);
    return (mkTop || mkTree)(localChildren, localPositions, length);
}
/**
Provides a way to associate values with pieces of trees. As long
as that part of the tree is reused, the associated values can be
retrieved from an updated tree.
*/ class $ed739beecf769914$export$7f13b5dc44c541ae {
    constructor(){
        this.map = new WeakMap();
    }
    setBuffer(buffer, index, value) {
        let inner = this.map.get(buffer);
        if (!inner) this.map.set(buffer, inner = new Map);
        inner.set(index, value);
    }
    getBuffer(buffer, index) {
        let inner = this.map.get(buffer);
        return inner && inner.get(index);
    }
    /**
    Set the value for this syntax node.
    */ set(node, value) {
        if (node instanceof $ed739beecf769914$var$BufferNode) this.setBuffer(node.context.buffer, node.index, value);
        else if (node instanceof $ed739beecf769914$var$TreeNode) this.map.set(node.tree, value);
    }
    /**
    Retrieve value for this syntax node, if it exists in the map.
    */ get(node) {
        return node instanceof $ed739beecf769914$var$BufferNode ? this.getBuffer(node.context.buffer, node.index) : node instanceof $ed739beecf769914$var$TreeNode ? this.map.get(node.tree) : undefined;
    }
    /**
    Set the value for the node that a cursor currently points to.
    */ cursorSet(cursor, value) {
        if (cursor.buffer) this.setBuffer(cursor.buffer.buffer, cursor.index, value);
        else this.map.set(cursor.tree, value);
    }
    /**
    Retrieve the value for the node that a cursor currently points
    to.
    */ cursorGet(cursor) {
        return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
    }
}
/**
Tree fragments are used during [incremental
parsing](#common.Parser.startParse) to track parts of old trees
that can be reused in a new parse. An array of fragments is used
to track regions of an old tree whose nodes might be reused in new
parses. Use the static
[`applyChanges`](#common.TreeFragment^applyChanges) method to
update fragments for document changes.
*/ class $ed739beecf769914$export$3ae2ede6dca97077 {
    /**
    Construct a tree fragment. You'll usually want to use
    [`addTree`](#common.TreeFragment^addTree) and
    [`applyChanges`](#common.TreeFragment^applyChanges) instead of
    calling this directly.
    */ constructor(/**
    The start of the unchanged range pointed to by this fragment.
    This refers to an offset in the _updated_ document (as opposed
    to the original tree).
    */ from, /**
    The end of the unchanged range.
    */ to, /**
    The tree that this fragment is based on.
    */ tree, /**
    The offset between the fragment's tree and the document that
    this fragment can be used against. Add this when going from
    document to tree positions, subtract it to go from tree to
    document positions.
    */ offset, openStart = false, openEnd = false){
        this.from = from;
        this.to = to;
        this.tree = tree;
        this.offset = offset;
        this.open = (openStart ? 1 /* Open.Start */  : 0) | (openEnd ? 2 /* Open.End */  : 0);
    }
    /**
    Whether the start of the fragment represents the start of a
    parse, or the end of a change. (In the second case, it may not
    be safe to reuse some nodes at the start, depending on the
    parsing algorithm.)
    */ get openStart() {
        return (this.open & 1 /* Open.Start */ ) > 0;
    }
    /**
    Whether the end of the fragment represents the end of a
    full-document parse, or the start of a change.
    */ get openEnd() {
        return (this.open & 2 /* Open.End */ ) > 0;
    }
    /**
    Create a set of fragments from a freshly parsed tree, or update
    an existing set of fragments by replacing the ones that overlap
    with a tree with content from the new tree. When `partial` is
    true, the parse is treated as incomplete, and the resulting
    fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
    true.
    */ static addTree(tree, fragments = [], partial = false) {
        let result = [
            new $ed739beecf769914$export$3ae2ede6dca97077(0, tree.length, tree, 0, false, partial)
        ];
        for (let f of fragments)if (f.to > tree.length) result.push(f);
        return result;
    }
    /**
    Apply a set of edits to an array of fragments, removing or
    splitting fragments as necessary to remove edited ranges, and
    adjusting offsets for fragments that moved.
    */ static applyChanges(fragments, changes, minGap = 128) {
        if (!changes.length) return fragments;
        let result = [];
        let fI = 1, nextF = fragments.length ? fragments[0] : null;
        for(let cI = 0, pos = 0, off = 0;; cI++){
            let nextC = cI < changes.length ? changes[cI] : null;
            let nextPos = nextC ? nextC.fromA : 1e9;
            if (nextPos - pos >= minGap) while(nextF && nextF.from < nextPos){
                let cut = nextF;
                if (pos >= cut.from || nextPos <= cut.to || off) {
                    let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
                    cut = fFrom >= fTo ? null : new $ed739beecf769914$export$3ae2ede6dca97077(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
                }
                if (cut) result.push(cut);
                if (nextF.to > nextPos) break;
                nextF = fI < fragments.length ? fragments[fI++] : null;
            }
            if (!nextC) break;
            pos = nextC.toA;
            off = nextC.toA - nextC.toB;
        }
        return result;
    }
}
/**
A superclass that parsers should extend.
*/ class $ed739beecf769914$export$7acfa6ed01010e37 {
    /**
    Start a parse, returning a [partial parse](#common.PartialParse)
    object. [`fragments`](#common.TreeFragment) can be passed in to
    make the parse incremental.
    
    By default, the entire input is parsed. You can pass `ranges`,
    which should be a sorted array of non-empty, non-overlapping
    ranges, to parse only those ranges. The tree returned in that
    case will start at `ranges[0].from`.
    */ startParse(input, fragments, ranges) {
        if (typeof input == "string") input = new $ed739beecf769914$var$StringInput(input);
        ranges = !ranges ? [
            new $ed739beecf769914$var$Range(0, input.length)
        ] : ranges.length ? ranges.map((r)=>new $ed739beecf769914$var$Range(r.from, r.to)) : [
            new $ed739beecf769914$var$Range(0, 0)
        ];
        return this.createParse(input, fragments || [], ranges);
    }
    /**
    Run a full parse, returning the resulting tree.
    */ parse(input, fragments, ranges) {
        let parse = this.startParse(input, fragments, ranges);
        for(;;){
            let done = parse.advance();
            if (done) return done;
        }
    }
}
class $ed739beecf769914$var$StringInput {
    constructor(string){
        this.string = string;
    }
    get length() {
        return this.string.length;
    }
    chunk(from) {
        return this.string.slice(from);
    }
    get lineChunks() {
        return false;
    }
    read(from, to) {
        return this.string.slice(from, to);
    }
}
/**
Create a parse wrapper that, after the inner parse completes,
scans its tree for mixed language regions with the `nest`
function, runs the resulting [inner parses](#common.NestedParse),
and then [mounts](#common.NodeProp^mounted) their results onto the
tree.
*/ function $ed739beecf769914$export$5dcc455959c76221(nest) {
    return (parse, input, fragments, ranges)=>new $ed739beecf769914$var$MixedParse(parse, nest, input, fragments, ranges);
}
class $ed739beecf769914$var$InnerParse {
    constructor(parser, parse, overlay, target, from){
        this.parser = parser;
        this.parse = parse;
        this.overlay = overlay;
        this.target = target;
        this.from = from;
    }
}
function $ed739beecf769914$var$checkRanges(ranges) {
    if (!ranges.length || ranges.some((r)=>r.from >= r.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
}
class $ed739beecf769914$var$ActiveOverlay {
    constructor(parser, predicate, mounts, index, start, target, prev){
        this.parser = parser;
        this.predicate = predicate;
        this.mounts = mounts;
        this.index = index;
        this.start = start;
        this.target = target;
        this.prev = prev;
        this.depth = 0;
        this.ranges = [];
    }
}
const $ed739beecf769914$var$stoppedInner = new $ed739beecf769914$export$b8034b9bc18acd90({
    perNode: true
});
class $ed739beecf769914$var$MixedParse {
    constructor(base, nest, input, fragments, ranges){
        this.nest = nest;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.inner = [];
        this.innerDone = 0;
        this.baseTree = null;
        this.stoppedAt = null;
        this.baseParse = base;
    }
    advance() {
        if (this.baseParse) {
            let done = this.baseParse.advance();
            if (!done) return null;
            this.baseParse = null;
            this.baseTree = done;
            this.startInner();
            if (this.stoppedAt != null) for (let inner of this.inner)inner.parse.stopAt(this.stoppedAt);
        }
        if (this.innerDone == this.inner.length) {
            let result = this.baseTree;
            if (this.stoppedAt != null) result = new $ed739beecf769914$export$7fbedc92909ed28e(result.type, result.children, result.positions, result.length, result.propValues.concat([
                [
                    $ed739beecf769914$var$stoppedInner,
                    this.stoppedAt
                ]
            ]));
            return result;
        }
        let inner = this.inner[this.innerDone], done = inner.parse.advance();
        if (done) {
            this.innerDone++;
            // This is a somewhat dodgy but super helpful hack where we
            // patch up nodes created by the inner parse (and thus
            // presumably not aliased anywhere else) to hold the information
            // about the inner parse.
            let props = Object.assign(Object.create(null), inner.target.props);
            props[$ed739beecf769914$export$b8034b9bc18acd90.mounted.id] = new $ed739beecf769914$export$358cdd8bd77577cc(done, inner.overlay, inner.parser);
            inner.target.props = props;
        }
        return null;
    }
    get parsedPos() {
        if (this.baseParse) return 0;
        let pos = this.input.length;
        for(let i = this.innerDone; i < this.inner.length; i++)if (this.inner[i].from < pos) pos = Math.min(pos, this.inner[i].parse.parsedPos);
        return pos;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
        if (this.baseParse) this.baseParse.stopAt(pos);
        else for(let i = this.innerDone; i < this.inner.length; i++)this.inner[i].parse.stopAt(pos);
    }
    startInner() {
        let fragmentCursor = new $ed739beecf769914$var$FragmentCursor(this.fragments);
        let overlay = null;
        let covered = null;
        let cursor = new $ed739beecf769914$export$3ae4554f36e54a34(new $ed739beecf769914$var$TreeNode(this.baseTree, this.ranges[0].from, 0, null), $ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous | $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts);
        scan: for(let nest, isCovered;;){
            let enter = true, range;
            if (this.stoppedAt != null && cursor.from >= this.stoppedAt) enter = false;
            else if (fragmentCursor.hasNode(cursor)) {
                if (overlay) {
                    let match = overlay.mounts.find((m)=>m.frag.from <= cursor.from && m.frag.to >= cursor.to && m.mount.overlay);
                    if (match) for (let r of match.mount.overlay){
                        let from = r.from + match.pos, to = r.to + match.pos;
                        if (from >= cursor.from && to <= cursor.to && !overlay.ranges.some((r)=>r.from < to && r.to > from)) overlay.ranges.push({
                            from: from,
                            to: to
                        });
                    }
                }
                enter = false;
            } else if (covered && (isCovered = $ed739beecf769914$var$checkCover(covered.ranges, cursor.from, cursor.to))) enter = isCovered != 2 /* Cover.Full */ ;
            else if (!cursor.type.isAnonymous && (nest = this.nest(cursor, this.input)) && (cursor.from < cursor.to || !nest.overlay)) {
                if (!cursor.tree) $ed739beecf769914$var$materialize(cursor);
                let oldMounts = fragmentCursor.findMounts(cursor.from, nest.parser);
                if (typeof nest.overlay == "function") overlay = new $ed739beecf769914$var$ActiveOverlay(nest.parser, nest.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay);
                else {
                    let ranges = $ed739beecf769914$var$punchRanges(this.ranges, nest.overlay || (cursor.from < cursor.to ? [
                        new $ed739beecf769914$var$Range(cursor.from, cursor.to)
                    ] : []));
                    if (ranges.length) $ed739beecf769914$var$checkRanges(ranges);
                    if (ranges.length || !nest.overlay) this.inner.push(new $ed739beecf769914$var$InnerParse(nest.parser, ranges.length ? nest.parser.startParse(this.input, $ed739beecf769914$var$enterFragments(oldMounts, ranges), ranges) : nest.parser.startParse(""), nest.overlay ? nest.overlay.map((r)=>new $ed739beecf769914$var$Range(r.from - cursor.from, r.to - cursor.from)) : null, cursor.tree, ranges.length ? ranges[0].from : cursor.from));
                    if (!nest.overlay) enter = false;
                    else if (ranges.length) covered = {
                        ranges: ranges,
                        depth: 0,
                        prev: covered
                    };
                }
            } else if (overlay && (range = overlay.predicate(cursor))) {
                if (range === true) range = new $ed739beecf769914$var$Range(cursor.from, cursor.to);
                if (range.from < range.to) overlay.ranges.push(range);
            }
            if (enter && cursor.firstChild()) {
                if (overlay) overlay.depth++;
                if (covered) covered.depth++;
            } else for(;;){
                if (cursor.nextSibling()) break;
                if (!cursor.parent()) break scan;
                if (overlay && !--overlay.depth) {
                    let ranges = $ed739beecf769914$var$punchRanges(this.ranges, overlay.ranges);
                    if (ranges.length) {
                        $ed739beecf769914$var$checkRanges(ranges);
                        this.inner.splice(overlay.index, 0, new $ed739beecf769914$var$InnerParse(overlay.parser, overlay.parser.startParse(this.input, $ed739beecf769914$var$enterFragments(overlay.mounts, ranges), ranges), overlay.ranges.map((r)=>new $ed739beecf769914$var$Range(r.from - overlay.start, r.to - overlay.start)), overlay.target, ranges[0].from));
                    }
                    overlay = overlay.prev;
                }
                if (covered && !--covered.depth) covered = covered.prev;
            }
        }
    }
}
function $ed739beecf769914$var$checkCover(covered, from, to) {
    for (let range of covered){
        if (range.from >= to) break;
        if (range.to > from) return range.from <= from && range.to >= to ? 2 /* Cover.Full */  : 1 /* Cover.Partial */ ;
    }
    return 0 /* Cover.None */ ;
}
// Take a piece of buffer and convert it into a stand-alone
// TreeBuffer.
function $ed739beecf769914$var$sliceBuf(buf, startI, endI, nodes, positions, off) {
    if (startI < endI) {
        let from = buf.buffer[startI + 1];
        nodes.push(buf.slice(startI, endI, from));
        positions.push(from - off);
    }
}
// This function takes a node that's in a buffer, and converts it, and
// its parent buffer nodes, into a Tree. This is again acting on the
// assumption that the trees and buffers have been constructed by the
// parse that was ran via the mix parser, and thus aren't shared with
// any other code, making violations of the immutability safe.
function $ed739beecf769914$var$materialize(cursor) {
    let { node: node } = cursor, stack = [];
    let buffer = node.context.buffer;
    // Scan up to the nearest tree
    do {
        stack.push(cursor.index);
        cursor.parent();
    }while (!cursor.tree);
    // Find the index of the buffer in that tree
    let base = cursor.tree, i = base.children.indexOf(buffer);
    let buf = base.children[i], b = buf.buffer, newStack = [
        i
    ];
    // Split a level in the buffer, putting the nodes before and after
    // the child that contains `node` into new buffers.
    function split(startI, endI, type, innerOffset, length, stackPos) {
        let targetI = stack[stackPos];
        let children = [], positions = [];
        $ed739beecf769914$var$sliceBuf(buf, startI, targetI, children, positions, innerOffset);
        let from = b[targetI + 1], to = b[targetI + 2];
        newStack.push(children.length);
        let child = stackPos ? split(targetI + 4, b[targetI + 3], buf.set.types[b[targetI]], from, to - from, stackPos - 1) : node.toTree();
        children.push(child);
        positions.push(from - innerOffset);
        $ed739beecf769914$var$sliceBuf(buf, b[targetI + 3], endI, children, positions, innerOffset);
        return new $ed739beecf769914$export$7fbedc92909ed28e(type, children, positions, length);
    }
    base.children[i] = split(0, b.length, $ed739beecf769914$export$f06e977173f1857c.none, 0, buf.length, stack.length - 1);
    // Move the cursor back to the target node
    for (let index of newStack){
        let tree = cursor.tree.children[index], pos = cursor.tree.positions[index];
        cursor.yield(new $ed739beecf769914$var$TreeNode(tree, pos + cursor.from, index, cursor._tree));
    }
}
class $ed739beecf769914$var$StructureCursor {
    constructor(root, offset){
        this.offset = offset;
        this.done = false;
        this.cursor = root.cursor($ed739beecf769914$export$b0e28367f55837aa.IncludeAnonymous | $ed739beecf769914$export$b0e28367f55837aa.IgnoreMounts);
    }
    // Move to the first node (in pre-order) that starts at or after `pos`.
    moveTo(pos) {
        let { cursor: cursor } = this, p = pos - this.offset;
        while(!this.done && cursor.from < p){
            if (cursor.to >= pos && cursor.enter(p, 1, $ed739beecf769914$export$b0e28367f55837aa.IgnoreOverlays | $ed739beecf769914$export$b0e28367f55837aa.ExcludeBuffers)) ;
            else if (!cursor.next(false)) this.done = true;
        }
    }
    hasNode(cursor) {
        this.moveTo(cursor.from);
        if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) for(let tree = this.cursor.tree;;){
            if (tree == cursor.tree) return true;
            if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof $ed739beecf769914$export$7fbedc92909ed28e) tree = tree.children[0];
            else break;
        }
        return false;
    }
}
class $ed739beecf769914$var$FragmentCursor {
    constructor(fragments){
        var _a;
        this.fragments = fragments;
        this.curTo = 0;
        this.fragI = 0;
        if (fragments.length) {
            let first = this.curFrag = fragments[0];
            this.curTo = (_a = first.tree.prop($ed739beecf769914$var$stoppedInner)) !== null && _a !== void 0 ? _a : first.to;
            this.inner = new $ed739beecf769914$var$StructureCursor(first.tree, -first.offset);
        } else this.curFrag = this.inner = null;
    }
    hasNode(node) {
        while(this.curFrag && node.from >= this.curTo)this.nextFrag();
        return this.curFrag && this.curFrag.from <= node.from && this.curTo >= node.to && this.inner.hasNode(node);
    }
    nextFrag() {
        var _a;
        this.fragI++;
        if (this.fragI == this.fragments.length) this.curFrag = this.inner = null;
        else {
            let frag = this.curFrag = this.fragments[this.fragI];
            this.curTo = (_a = frag.tree.prop($ed739beecf769914$var$stoppedInner)) !== null && _a !== void 0 ? _a : frag.to;
            this.inner = new $ed739beecf769914$var$StructureCursor(frag.tree, -frag.offset);
        }
    }
    findMounts(pos, parser) {
        var _a;
        let result = [];
        if (this.inner) {
            this.inner.cursor.moveTo(pos, 1);
            for(let pos = this.inner.cursor.node; pos; pos = pos.parent){
                let mount = (_a = pos.tree) === null || _a === void 0 ? void 0 : _a.prop($ed739beecf769914$export$b8034b9bc18acd90.mounted);
                if (mount && mount.parser == parser) for(let i = this.fragI; i < this.fragments.length; i++){
                    let frag = this.fragments[i];
                    if (frag.from >= pos.to) break;
                    if (frag.tree == this.curFrag.tree) result.push({
                        frag: frag,
                        pos: pos.from - frag.offset,
                        mount: mount
                    });
                }
            }
        }
        return result;
    }
}
function $ed739beecf769914$var$punchRanges(outer, ranges) {
    let copy = null, current = ranges;
    for(let i = 1, j = 0; i < outer.length; i++){
        let gapFrom = outer[i - 1].to, gapTo = outer[i].from;
        for(; j < current.length; j++){
            let r = current[j];
            if (r.from >= gapTo) break;
            if (r.to <= gapFrom) continue;
            if (!copy) current = copy = ranges.slice();
            if (r.from < gapFrom) {
                copy[j] = new $ed739beecf769914$var$Range(r.from, gapFrom);
                if (r.to > gapTo) copy.splice(j + 1, 0, new $ed739beecf769914$var$Range(gapTo, r.to));
            } else if (r.to > gapTo) copy[j--] = new $ed739beecf769914$var$Range(gapTo, r.to);
            else copy.splice(j--, 1);
        }
    }
    return current;
}
function $ed739beecf769914$var$findCoverChanges(a, b, from, to) {
    let iA = 0, iB = 0, inA = false, inB = false, pos = -1000000000;
    let result = [];
    for(;;){
        let nextA = iA == a.length ? 1e9 : inA ? a[iA].to : a[iA].from;
        let nextB = iB == b.length ? 1e9 : inB ? b[iB].to : b[iB].from;
        if (inA != inB) {
            let start = Math.max(pos, from), end = Math.min(nextA, nextB, to);
            if (start < end) result.push(new $ed739beecf769914$var$Range(start, end));
        }
        pos = Math.min(nextA, nextB);
        if (pos == 1e9) break;
        if (nextA == pos) {
            if (!inA) inA = true;
            else {
                inA = false;
                iA++;
            }
        }
        if (nextB == pos) {
            if (!inB) inB = true;
            else {
                inB = false;
                iB++;
            }
        }
    }
    return result;
}
// Given a number of fragments for the outer tree, and a set of ranges
// to parse, find fragments for inner trees mounted around those
// ranges, if any.
function $ed739beecf769914$var$enterFragments(mounts, ranges) {
    let result = [];
    for (let { pos: pos, mount: mount, frag: frag } of mounts){
        let startPos = pos + (mount.overlay ? mount.overlay[0].from : 0), endPos = startPos + mount.tree.length;
        let from = Math.max(frag.from, startPos), to = Math.min(frag.to, endPos);
        if (mount.overlay) {
            let overlay = mount.overlay.map((r)=>new $ed739beecf769914$var$Range(r.from + pos, r.to + pos));
            let changes = $ed739beecf769914$var$findCoverChanges(ranges, overlay, from, to);
            for(let i = 0, pos = from;; i++){
                let last = i == changes.length, end = last ? to : changes[i].from;
                if (end > pos) result.push(new $ed739beecf769914$export$3ae2ede6dca97077(pos, end, mount.tree, -startPos, frag.from >= pos || frag.openStart, frag.to <= end || frag.openEnd));
                if (last) break;
                pos = changes[i].to;
            }
        } else result.push(new $ed739beecf769914$export$3ae2ede6dca97077(from, to, mount.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
    return result;
}





let $a1ec9d683d365521$var$nextTagID = 0;
/**
Highlighting tags are markers that denote a highlighting category.
They are [associated](#highlight.styleTags) with parts of a syntax
tree by a language mode, and then mapped to an actual CSS style by
a [highlighter](#highlight.Highlighter).

Because syntax tree node types and highlight styles have to be
able to talk the same language, CodeMirror uses a mostly _closed_
[vocabulary](#highlight.tags) of syntax tags (as opposed to
traditional open string-based systems, which make it hard for
highlighting themes to cover all the tokens produced by the
various languages).

It _is_ possible to [define](#highlight.Tag^define) your own
highlighting tags for system-internal use (where you control both
the language package and the highlighter), but such tags will not
be picked up by regular highlighters (though you can derive them
from standard tags to allow highlighters to fall back to those).
*/ class $a1ec9d683d365521$export$3288d34c523a1192 {
    /**
    @internal
    */ constructor(/**
    The set of this tag and all its parent tags, starting with
    this one itself and sorted in order of decreasing specificity.
    */ set, /**
    The base unmodified tag that this one is based on, if it's
    modified @internal
    */ base, /**
    The modifiers applied to this.base @internal
    */ modified){
        this.set = set;
        this.base = base;
        this.modified = modified;
        /**
        @internal
        */ this.id = $a1ec9d683d365521$var$nextTagID++;
    }
    /**
    Define a new tag. If `parent` is given, the tag is treated as a
    sub-tag of that parent, and
    [highlighters](#highlight.tagHighlighter) that don't mention
    this tag will try to fall back to the parent tag (or grandparent
    tag, etc).
    */ static define(parent) {
        if (parent === null || parent === void 0 ? void 0 : parent.base) throw new Error("Can not derive from a modified tag");
        let tag = new $a1ec9d683d365521$export$3288d34c523a1192([], null, []);
        tag.set.push(tag);
        if (parent) for (let t of parent.set)tag.set.push(t);
        return tag;
    }
    /**
    Define a tag _modifier_, which is a function that, given a tag,
    will return a tag that is a subtag of the original. Applying the
    same modifier to a twice tag will return the same value (`m1(t1)
    == m1(t1)`) and applying multiple modifiers will, regardless or
    order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
    
    When multiple modifiers are applied to a given base tag, each
    smaller set of modifiers is registered as a parent, so that for
    example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
    `m1(m3(t1)`, and so on.
    */ static defineModifier() {
        let mod = new $a1ec9d683d365521$var$Modifier;
        return (tag)=>{
            if (tag.modified.indexOf(mod) > -1) return tag;
            return $a1ec9d683d365521$var$Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a, b)=>a.id - b.id));
        };
    }
}
let $a1ec9d683d365521$var$nextModifierID = 0;
class $a1ec9d683d365521$var$Modifier {
    constructor(){
        this.instances = [];
        this.id = $a1ec9d683d365521$var$nextModifierID++;
    }
    static get(base, mods) {
        if (!mods.length) return base;
        let exists = mods[0].instances.find((t)=>t.base == base && $a1ec9d683d365521$var$sameArray(mods, t.modified));
        if (exists) return exists;
        let set = [], tag = new $a1ec9d683d365521$export$3288d34c523a1192(set, base, mods);
        for (let m of mods)m.instances.push(tag);
        let configs = $a1ec9d683d365521$var$powerSet(mods);
        for (let parent of base.set)if (!parent.modified.length) for (let config of configs)set.push($a1ec9d683d365521$var$Modifier.get(parent, config));
        return tag;
    }
}
function $a1ec9d683d365521$var$sameArray(a, b) {
    return a.length == b.length && a.every((x, i)=>x == b[i]);
}
function $a1ec9d683d365521$var$powerSet(array) {
    let sets = [
        []
    ];
    for(let i = 0; i < array.length; i++)for(let j = 0, e = sets.length; j < e; j++)sets.push(sets[j].concat(array[i]));
    return sets.sort((a, b)=>b.length - a.length);
}
/**
This function is used to add a set of tags to a language syntax
via [`NodeSet.extend`](#common.NodeSet.extend) or
[`LRParser.configure`](#lr.LRParser.configure).

The argument object maps node selectors to [highlighting
tags](#highlight.Tag) or arrays of tags.

Node selectors may hold one or more (space-separated) node paths.
Such a path can be a [node name](#common.NodeType.name), or
multiple node names (or `*` wildcards) separated by slash
characters, as in `"Block/Declaration/VariableName"`. Such a path
matches the final node but only if its direct parent nodes are the
other nodes mentioned. A `*` in such a path matches any parent,
but only a single level—wildcards that match multiple parents
aren't supported, both for efficiency reasons and because Lezer
trees make it rather hard to reason about what they would match.)

A path can be ended with `/...` to indicate that the tag assigned
to the node should also apply to all child nodes, even if they
match their own style (by default, only the innermost style is
used).

When a path ends in `!`, as in `Attribute!`, no further matching
happens for the node's child nodes, and the entire node gets the
given style.

In this notation, node names that contain `/`, `!`, `*`, or `...`
must be quoted as JSON strings.

For example:

```javascript
parser.withProps(
  styleTags({
    // Style Number and BigNumber nodes
    "Number BigNumber": tags.number,
    // Style Escape nodes whose parent is String
    "String/Escape": tags.escape,
    // Style anything inside Attributes nodes
    "Attributes!": tags.meta,
    // Add a style to all content inside Italic nodes
    "Italic/...": tags.emphasis,
    // Style InvalidString nodes as both `string` and `invalid`
    "InvalidString": [tags.string, tags.invalid],
    // Style the node named "/" as punctuation
    '"/"': tags.punctuation
  })
)
```
*/ function $a1ec9d683d365521$export$c537e79bb7b94295(spec) {
    let byName = Object.create(null);
    for(let prop in spec){
        let tags = spec[prop];
        if (!Array.isArray(tags)) tags = [
            tags
        ];
        for (let part of prop.split(" "))if (part) {
            let pieces = [], mode = 2 /* Mode.Normal */ , rest = part;
            for(let pos = 0;;){
                if (rest == "..." && pos > 0 && pos + 3 == part.length) {
                    mode = 1 /* Mode.Inherit */ ;
                    break;
                }
                let m = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
                if (!m) throw new RangeError("Invalid path: " + part);
                pieces.push(m[0] == "*" ? "" : m[0][0] == '"' ? JSON.parse(m[0]) : m[0]);
                pos += m[0].length;
                if (pos == part.length) break;
                let next = part[pos++];
                if (pos == part.length && next == "!") {
                    mode = 0 /* Mode.Opaque */ ;
                    break;
                }
                if (next != "/") throw new RangeError("Invalid path: " + part);
                rest = part.slice(pos);
            }
            let last = pieces.length - 1, inner = pieces[last];
            if (!inner) throw new RangeError("Invalid path: " + part);
            let rule = new $a1ec9d683d365521$var$Rule(tags, mode, last > 0 ? pieces.slice(0, last) : null);
            byName[inner] = rule.sort(byName[inner]);
        }
    }
    return $a1ec9d683d365521$var$ruleNodeProp.add(byName);
}
const $a1ec9d683d365521$var$ruleNodeProp = new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
class $a1ec9d683d365521$var$Rule {
    constructor(tags, mode, context, next){
        this.tags = tags;
        this.mode = mode;
        this.context = context;
        this.next = next;
    }
    get opaque() {
        return this.mode == 0 /* Mode.Opaque */ ;
    }
    get inherit() {
        return this.mode == 1 /* Mode.Inherit */ ;
    }
    sort(other) {
        if (!other || other.depth < this.depth) {
            this.next = other;
            return this;
        }
        other.next = this.sort(other.next);
        return other;
    }
    get depth() {
        return this.context ? this.context.length : 0;
    }
}
$a1ec9d683d365521$var$Rule.empty = new $a1ec9d683d365521$var$Rule([], 2 /* Mode.Normal */ , null);
/**
Define a [highlighter](#highlight.Highlighter) from an array of
tag/class pairs. Classes associated with more specific tags will
take precedence.
*/ function $a1ec9d683d365521$export$b7f6332ce20f80fb(tags, options) {
    let map = Object.create(null);
    for (let style of tags){
        if (!Array.isArray(style.tag)) map[style.tag.id] = style.class;
        else for (let tag of style.tag)map[tag.id] = style.class;
    }
    let { scope: scope, all: all = null } = options || {};
    return {
        style: (tags)=>{
            let cls = all;
            for (let tag of tags)for (let sub of tag.set){
                let tagClass = map[sub.id];
                if (tagClass) {
                    cls = cls ? cls + " " + tagClass : tagClass;
                    break;
                }
            }
            return cls;
        },
        scope: scope
    };
}
function $a1ec9d683d365521$var$highlightTags(highlighters, tags) {
    let result = null;
    for (let highlighter of highlighters){
        let value = highlighter.style(tags);
        if (value) result = result ? result + " " + value : value;
    }
    return result;
}
/**
Highlight the given [tree](#common.Tree) with the given
[highlighter](#highlight.Highlighter). Often, the higher-level
[`highlightCode`](#highlight.highlightCode) function is easier to
use.
*/ function $a1ec9d683d365521$export$af82b3d076119fad(tree, highlighter, /**
Assign styling to a region of the text. Will be called, in order
of position, for any ranges where more than zero classes apply.
`classes` is a space separated string of CSS classes.
*/ putStyle, /**
The start of the range to highlight.
*/ from = 0, /**
The end of the range.
*/ to = tree.length) {
    let builder = new $a1ec9d683d365521$var$HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [
        highlighter
    ], putStyle);
    builder.highlightRange(tree.cursor(), from, to, "", builder.highlighters);
    builder.flush(to);
}
/**
Highlight the given tree with the given highlighter, calling
`putText` for every piece of text, either with a set of classes or
with the empty string when unstyled, and `putBreak` for every line
break.
*/ function $a1ec9d683d365521$export$e443a046766e80e8(code, tree, highlighter, putText, putBreak, from = 0, to = code.length) {
    let pos = from;
    function writeTo(p, classes) {
        if (p <= pos) return;
        for(let text = code.slice(pos, p), i = 0;;){
            let nextBreak = text.indexOf("\n", i);
            let upto = nextBreak < 0 ? text.length : nextBreak;
            if (upto > i) putText(text.slice(i, upto), classes);
            if (nextBreak < 0) break;
            putBreak();
            i = nextBreak + 1;
        }
        pos = p;
    }
    $a1ec9d683d365521$export$af82b3d076119fad(tree, highlighter, (from, to, classes)=>{
        writeTo(from, "");
        writeTo(to, classes);
    }, from, to);
    writeTo(to, "");
}
class $a1ec9d683d365521$var$HighlightBuilder {
    constructor(at, highlighters, span){
        this.at = at;
        this.highlighters = highlighters;
        this.span = span;
        this.class = "";
    }
    startSpan(at, cls) {
        if (cls != this.class) {
            this.flush(at);
            if (at > this.at) this.at = at;
            this.class = cls;
        }
    }
    flush(to) {
        if (to > this.at && this.class) this.span(this.at, to, this.class);
    }
    highlightRange(cursor, from, to, inheritedClass, highlighters) {
        let { type: type, from: start, to: end } = cursor;
        if (start >= to || end <= from) return;
        if (type.isTop) highlighters = this.highlighters.filter((h)=>!h.scope || h.scope(type));
        let cls = inheritedClass;
        let rule = $a1ec9d683d365521$export$1519d79cc79711ec(cursor) || $a1ec9d683d365521$var$Rule.empty;
        let tagCls = $a1ec9d683d365521$var$highlightTags(highlighters, rule.tags);
        if (tagCls) {
            if (cls) cls += " ";
            cls += tagCls;
            if (rule.mode == 1 /* Mode.Inherit */ ) inheritedClass += (inheritedClass ? " " : "") + tagCls;
        }
        this.startSpan(Math.max(from, start), cls);
        if (rule.opaque) return;
        let mounted = cursor.tree && cursor.tree.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).mounted);
        if (mounted && mounted.overlay) {
            let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
            let innerHighlighters = this.highlighters.filter((h)=>!h.scope || h.scope(mounted.tree.type));
            let hasChild = cursor.firstChild();
            for(let i = 0, pos = start;; i++){
                let next = i < mounted.overlay.length ? mounted.overlay[i] : null;
                let nextPos = next ? next.from + start : end;
                let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to, nextPos);
                if (rangeFrom < rangeTo && hasChild) while(cursor.from < rangeTo){
                    this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
                    this.startSpan(Math.min(rangeTo, cursor.to), cls);
                    if (cursor.to >= nextPos || !cursor.nextSibling()) break;
                }
                if (!next || nextPos > to) break;
                pos = next.to + start;
                if (pos > from) {
                    this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to, pos), "", innerHighlighters);
                    this.startSpan(Math.min(to, pos), cls);
                }
            }
            if (hasChild) cursor.parent();
        } else if (cursor.firstChild()) {
            if (mounted) inheritedClass = "";
            do {
                if (cursor.to <= from) continue;
                if (cursor.from >= to) break;
                this.highlightRange(cursor, from, to, inheritedClass, highlighters);
                this.startSpan(Math.min(to, cursor.to), cls);
            }while (cursor.nextSibling());
            cursor.parent();
        }
    }
}
/**
Match a syntax node's [highlight rules](#highlight.styleTags). If
there's a match, return its set of tags, and whether it is
opaque (uses a `!`) or applies to all child nodes (`/...`).
*/ function $a1ec9d683d365521$export$1519d79cc79711ec(node) {
    let rule = node.type.prop($a1ec9d683d365521$var$ruleNodeProp);
    while(rule && rule.context && !node.matchContext(rule.context))rule = rule.next;
    return rule || null;
}
const $a1ec9d683d365521$var$t = $a1ec9d683d365521$export$3288d34c523a1192.define;
const $a1ec9d683d365521$var$comment = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$name = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$typeName = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name), $a1ec9d683d365521$var$propertyName = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name), $a1ec9d683d365521$var$literal = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$string = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal), $a1ec9d683d365521$var$number = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal), $a1ec9d683d365521$var$content = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$heading = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content), $a1ec9d683d365521$var$keyword = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$operator = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$punctuation = $a1ec9d683d365521$var$t(), $a1ec9d683d365521$var$bracket = $a1ec9d683d365521$var$t($a1ec9d683d365521$var$punctuation), $a1ec9d683d365521$var$meta = $a1ec9d683d365521$var$t();
/**
The default set of highlighting [tags](#highlight.Tag).

This collection is heavily biased towards programming languages,
and necessarily incomplete. A full ontology of syntactic
constructs would fill a stack of books, and be impractical to
write themes for. So try to make do with this set. If all else
fails, [open an
issue](https://github.com/codemirror/codemirror.next) to propose a
new tag, or [define](#highlight.Tag^define) a local custom tag for
your use case.

Note that it is not obligatory to always attach the most specific
tag possible to an element—if your grammar can't easily
distinguish a certain type of element (such as a local variable),
it is okay to style it as its more general variant (a variable).

For tags that extend some parent tag, the documentation links to
the parent.
*/ const $a1ec9d683d365521$export$8b7a896ae75accbf = {
    comment: /**
    A comment.
    */ $a1ec9d683d365521$var$comment,
    /**
    A line [comment](#highlight.tags.comment).
    */ lineComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    /**
    A block [comment](#highlight.tags.comment).
    */ blockComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    /**
    A documentation [comment](#highlight.tags.comment).
    */ docComment: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$comment),
    name: /**
    Any kind of identifier.
    */ $a1ec9d683d365521$var$name,
    /**
    The [name](#highlight.tags.name) of a variable.
    */ variableName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A type [name](#highlight.tags.name).
    */ typeName: $a1ec9d683d365521$var$typeName,
    /**
    A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
    */ tagName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$typeName),
    /**
    A property or field [name](#highlight.tags.name).
    */ propertyName: $a1ec9d683d365521$var$propertyName,
    /**
    An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
    */ attributeName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$propertyName),
    /**
    The [name](#highlight.tags.name) of a class.
    */ className: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A label [name](#highlight.tags.name).
    */ labelName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    A namespace [name](#highlight.tags.name).
    */ namespace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    /**
    The [name](#highlight.tags.name) of a macro.
    */ macroName: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$name),
    literal: /**
    A literal value.
    */ $a1ec9d683d365521$var$literal,
    string: /**
    A string [literal](#highlight.tags.literal).
    */ $a1ec9d683d365521$var$string,
    /**
    A documentation [string](#highlight.tags.string).
    */ docString: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    /**
    A character literal (subtag of [string](#highlight.tags.string)).
    */ character: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    /**
    An attribute value (subtag of [string](#highlight.tags.string)).
    */ attributeValue: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$string),
    number: /**
    A number [literal](#highlight.tags.literal).
    */ $a1ec9d683d365521$var$number,
    /**
    An integer [number](#highlight.tags.number) literal.
    */ integer: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$number),
    /**
    A floating-point [number](#highlight.tags.number) literal.
    */ float: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$number),
    /**
    A boolean [literal](#highlight.tags.literal).
    */ bool: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    Regular expression [literal](#highlight.tags.literal).
    */ regexp: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    An escape [literal](#highlight.tags.literal), for example a
    backslash escape in a string.
    */ escape: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    A color [literal](#highlight.tags.literal).
    */ color: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    /**
    A URL [literal](#highlight.tags.literal).
    */ url: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$literal),
    keyword: /**
    A language keyword.
    */ $a1ec9d683d365521$var$keyword,
    /**
    The [keyword](#highlight.tags.keyword) for the self or this
    object.
    */ self: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    The [keyword](#highlight.tags.keyword) for null.
    */ null: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) denoting some atomic value.
    */ atom: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that represents a unit.
    */ unit: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A modifier [keyword](#highlight.tags.keyword).
    */ modifier: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that acts as an operator.
    */ operatorKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A control-flow related [keyword](#highlight.tags.keyword).
    */ controlKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) that defines something.
    */ definitionKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    /**
    A [keyword](#highlight.tags.keyword) related to defining or
    interfacing with modules.
    */ moduleKeyword: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$keyword),
    operator: /**
    An operator.
    */ $a1ec9d683d365521$var$operator,
    /**
    An [operator](#highlight.tags.operator) that dereferences something.
    */ derefOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Arithmetic-related [operator](#highlight.tags.operator).
    */ arithmeticOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Logical [operator](#highlight.tags.operator).
    */ logicOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Bit [operator](#highlight.tags.operator).
    */ bitwiseOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Comparison [operator](#highlight.tags.operator).
    */ compareOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    [Operator](#highlight.tags.operator) that updates its operand.
    */ updateOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    [Operator](#highlight.tags.operator) that defines something.
    */ definitionOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Type-related [operator](#highlight.tags.operator).
    */ typeOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    /**
    Control-flow [operator](#highlight.tags.operator).
    */ controlOperator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$operator),
    punctuation: /**
    Program or markup punctuation.
    */ $a1ec9d683d365521$var$punctuation,
    /**
    [Punctuation](#highlight.tags.punctuation) that separates
    things.
    */ separator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$punctuation),
    bracket: /**
    Bracket-style [punctuation](#highlight.tags.punctuation).
    */ $a1ec9d683d365521$var$bracket,
    /**
    Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
    tokens).
    */ angleBracket: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
    tokens).
    */ squareBracket: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Parentheses (usually `(` and `)` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ paren: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    /**
    Braces (usually `{` and `}` tokens). Subtag of
    [bracket](#highlight.tags.bracket).
    */ brace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$bracket),
    content: /**
    Content, for example plain text in XML or markup documents.
    */ $a1ec9d683d365521$var$content,
    heading: /**
    [Content](#highlight.tags.content) that represents a heading.
    */ $a1ec9d683d365521$var$heading,
    /**
    A level 1 [heading](#highlight.tags.heading).
    */ heading1: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 2 [heading](#highlight.tags.heading).
    */ heading2: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 3 [heading](#highlight.tags.heading).
    */ heading3: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 4 [heading](#highlight.tags.heading).
    */ heading4: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 5 [heading](#highlight.tags.heading).
    */ heading5: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A level 6 [heading](#highlight.tags.heading).
    */ heading6: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$heading),
    /**
    A prose separator (such as a horizontal rule).
    */ contentSeparator: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that represents a list.
    */ list: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that represents a quote.
    */ quote: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is emphasized.
    */ emphasis: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is styled strong.
    */ strong: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is part of a link.
    */ link: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that is styled as code or
    monospace.
    */ monospace: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    [Content](#highlight.tags.content) that has a strike-through
    style.
    */ strikethrough: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$content),
    /**
    Inserted text in a change-tracking format.
    */ inserted: $a1ec9d683d365521$var$t(),
    /**
    Deleted text.
    */ deleted: $a1ec9d683d365521$var$t(),
    /**
    Changed text.
    */ changed: $a1ec9d683d365521$var$t(),
    /**
    An invalid or unsyntactic element.
    */ invalid: $a1ec9d683d365521$var$t(),
    meta: /**
    Metadata or meta-instruction.
    */ $a1ec9d683d365521$var$meta,
    /**
    [Metadata](#highlight.tags.meta) that applies to the entire
    document.
    */ documentMeta: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    [Metadata](#highlight.tags.meta) that annotates or adds
    attributes to a given syntactic element.
    */ annotation: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    Processing instruction or preprocessor directive. Subtag of
    [meta](#highlight.tags.meta).
    */ processingInstruction: $a1ec9d683d365521$var$t($a1ec9d683d365521$var$meta),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that a
    given element is being defined. Expected to be used with the
    various [name](#highlight.tags.name) tags.
    */ definition: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates that
    something is constant. Mostly expected to be used with
    [variable names](#highlight.tags.variableName).
    */ constant: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) used to indicate that
    a [variable](#highlight.tags.variableName) or [property
    name](#highlight.tags.propertyName) is being called or defined
    as a function.
    */ function: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that can be applied to
    [names](#highlight.tags.name) to indicate that they belong to
    the language's standard environment.
    */ standard: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier(),
    /**
    [Modifier](#highlight.Tag^defineModifier) that indicates a given
    [names](#highlight.tags.name) is local to some scope.
    */ local: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier(),
    /**
    A generic variant [modifier](#highlight.Tag^defineModifier) that
    can be used to tag language-specific alternative variants of
    some common tag. It is recommended for themes to define special
    forms of at least the [string](#highlight.tags.string) and
    [variable name](#highlight.tags.variableName) tags, since those
    come up a lot.
    */ special: $a1ec9d683d365521$export$3288d34c523a1192.defineModifier()
};
/**
This is a highlighter that adds stable, predictable classes to
tokens, for styling with external CSS.

The following tags are mapped to their name prefixed with `"tok-"`
(for example `"tok-comment"`):

* [`link`](#highlight.tags.link)
* [`heading`](#highlight.tags.heading)
* [`emphasis`](#highlight.tags.emphasis)
* [`strong`](#highlight.tags.strong)
* [`keyword`](#highlight.tags.keyword)
* [`atom`](#highlight.tags.atom)
* [`bool`](#highlight.tags.bool)
* [`url`](#highlight.tags.url)
* [`labelName`](#highlight.tags.labelName)
* [`inserted`](#highlight.tags.inserted)
* [`deleted`](#highlight.tags.deleted)
* [`literal`](#highlight.tags.literal)
* [`string`](#highlight.tags.string)
* [`number`](#highlight.tags.number)
* [`variableName`](#highlight.tags.variableName)
* [`typeName`](#highlight.tags.typeName)
* [`namespace`](#highlight.tags.namespace)
* [`className`](#highlight.tags.className)
* [`macroName`](#highlight.tags.macroName)
* [`propertyName`](#highlight.tags.propertyName)
* [`operator`](#highlight.tags.operator)
* [`comment`](#highlight.tags.comment)
* [`meta`](#highlight.tags.meta)
* [`punctuation`](#highlight.tags.punctuation)
* [`invalid`](#highlight.tags.invalid)

In addition, these mappings are provided:

* [`regexp`](#highlight.tags.regexp),
  [`escape`](#highlight.tags.escape), and
  [`special`](#highlight.tags.special)[`(string)`](#highlight.tags.string)
  are mapped to `"tok-string2"`
* [`special`](#highlight.tags.special)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName2"`
* [`local`](#highlight.tags.local)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-local"`
* [`definition`](#highlight.tags.definition)[`(variableName)`](#highlight.tags.variableName)
  to `"tok-variableName tok-definition"`
* [`definition`](#highlight.tags.definition)[`(propertyName)`](#highlight.tags.propertyName)
  to `"tok-propertyName tok-definition"`
*/ const $a1ec9d683d365521$export$bf3ffb24fb17216c = $a1ec9d683d365521$export$b7f6332ce20f80fb([
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.link,
        class: "tok-link"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.heading,
        class: "tok-heading"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.emphasis,
        class: "tok-emphasis"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.strong,
        class: "tok-strong"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.keyword,
        class: "tok-keyword"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.atom,
        class: "tok-atom"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.bool,
        class: "tok-bool"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.url,
        class: "tok-url"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.labelName,
        class: "tok-labelName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.inserted,
        class: "tok-inserted"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.deleted,
        class: "tok-deleted"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.literal,
        class: "tok-literal"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.string,
        class: "tok-string"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.number,
        class: "tok-number"
    },
    {
        tag: [
            $a1ec9d683d365521$export$8b7a896ae75accbf.regexp,
            $a1ec9d683d365521$export$8b7a896ae75accbf.escape,
            $a1ec9d683d365521$export$8b7a896ae75accbf.special($a1ec9d683d365521$export$8b7a896ae75accbf.string)
        ],
        class: "tok-string2"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.variableName,
        class: "tok-variableName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.local($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-local"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.definition($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName tok-definition"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.special($a1ec9d683d365521$export$8b7a896ae75accbf.variableName),
        class: "tok-variableName2"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.definition($a1ec9d683d365521$export$8b7a896ae75accbf.propertyName),
        class: "tok-propertyName tok-definition"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.typeName,
        class: "tok-typeName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.namespace,
        class: "tok-namespace"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.className,
        class: "tok-className"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.macroName,
        class: "tok-macroName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.propertyName,
        class: "tok-propertyName"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.operator,
        class: "tok-operator"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.comment,
        class: "tok-comment"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.meta,
        class: "tok-meta"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.invalid,
        class: "tok-invalid"
    },
    {
        tag: $a1ec9d683d365521$export$8b7a896ae75accbf.punctuation,
        class: "tok-punctuation"
    }
]);



var $a97ccac5cf5f4f5d$var$_a;
/**
Node prop stored in a parser's top syntax node to provide the
facet that stores language-specific data for that language.
*/ const $a97ccac5cf5f4f5d$export$27a2e78097f753f7 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
Helper function to define a facet (to be added to the top syntax
node(s) for a language via
[`languageDataProp`](https://codemirror.net/6/docs/ref/#language.languageDataProp)), that will be
used to associate language data with the language. You
probably only need this when subclassing
[`Language`](https://codemirror.net/6/docs/ref/#language.Language).
*/ function $a97ccac5cf5f4f5d$export$b57f683f43553b99(baseData) {
    return (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
        combine: baseData ? (values)=>values.concat(baseData) : undefined
    });
}
/**
Syntax node prop used to register sublanguages. Should be added to
the top level node type for the language.
*/ const $a97ccac5cf5f4f5d$export$4afc6f37514bbb67 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
A language object manages parsing and per-language
[metadata](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt). Parse data is
managed as a [Lezer](https://lezer.codemirror.net) tree. The class
can be used directly, via the [`LRLanguage`](https://codemirror.net/6/docs/ref/#language.LRLanguage)
subclass for [Lezer](https://lezer.codemirror.net/) LR parsers, or
via the [`StreamLanguage`](https://codemirror.net/6/docs/ref/#language.StreamLanguage) subclass
for stream parsers.
*/ class $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    /**
    Construct a language object. If you need to invoke this
    directly, first define a data facet with
    [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
    configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
    to the language's outer syntax node.
    */ constructor(/**
    The [language data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt) facet
    used for this language.
    */ data, parser, extraExtensions = [], /**
    A language name.
    */ name = ""){
        this.data = data;
        this.name = name;
        // Kludge to define EditorState.tree as a debugging helper,
        // without the EditorState package actually knowing about
        // languages and lezer trees.
        if (!(0, $6295c6875f57e3ee$export$afa855cbfaff27f2).prototype.hasOwnProperty("tree")) Object.defineProperty((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).prototype, "tree", {
            get () {
                return $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(this);
            }
        });
        this.parser = parser;
        this.extension = [
            $a97ccac5cf5f4f5d$export$789c912f57fe164c.of(this),
            (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).languageData.of((state, pos, side)=>{
                let top = $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side), data = top.type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7);
                if (!data) return [];
                let base = state.facet(data), sub = top.type.prop($a97ccac5cf5f4f5d$export$4afc6f37514bbb67);
                if (sub) {
                    let innerNode = top.resolve(pos - top.from, side);
                    for (let sublang of sub)if (sublang.test(innerNode, state)) {
                        let data = state.facet(sublang.facet);
                        return sublang.type == "replace" ? data : data.concat(base);
                    }
                }
                return base;
            })
        ].concat(extraExtensions);
    }
    /**
    Query whether this language is active at the given position.
    */ isActiveAt(state, pos, side = -1) {
        return $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side).type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data;
    }
    /**
    Find the document regions that were parsed using this language.
    The returned regions will _include_ any nested languages rooted
    in this language, when those exist.
    */ findRegions(state) {
        let lang = state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c);
        if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data) return [
            {
                from: 0,
                to: state.doc.length
            }
        ];
        if (!lang || !lang.allowsNesting) return [];
        let result = [];
        let explore = (tree, from)=>{
            if (tree.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data) {
                result.push({
                    from: from,
                    to: from + tree.length
                });
                return;
            }
            let mount = tree.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).mounted);
            if (mount) {
                if (mount.tree.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == this.data) {
                    if (mount.overlay) for (let r of mount.overlay)result.push({
                        from: r.from + from,
                        to: r.to + from
                    });
                    else result.push({
                        from: from,
                        to: from + tree.length
                    });
                    return;
                } else if (mount.overlay) {
                    let size = result.length;
                    explore(mount.tree, mount.overlay[0].from + from);
                    if (result.length > size) return;
                }
            }
            for(let i = 0; i < tree.children.length; i++){
                let ch = tree.children[i];
                if (ch instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) explore(ch, tree.positions[i] + from);
            }
        };
        explore($a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state), 0);
        return result;
    }
    /**
    Indicates whether this language allows nested languages. The
    default implementation returns true.
    */ get allowsNesting() {
        return true;
    }
}
/**
@internal
*/ $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
function $a97ccac5cf5f4f5d$var$topNodeAt(state, pos, side) {
    let topLang = state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c), tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state).topNode;
    if (!topLang || topLang.allowsNesting) {
        for(let node = tree; node; node = node.enter(pos, side, (0, $ed739beecf769914$export$b0e28367f55837aa).ExcludeBuffers))if (node.type.isTop) tree = node;
    }
    return tree;
}
/**
A subclass of [`Language`](https://codemirror.net/6/docs/ref/#language.Language) for use with Lezer
[LR parsers](https://lezer.codemirror.net/docs/ref#lr.LRParser)
parsers.
*/ class $a97ccac5cf5f4f5d$export$b243968d9fb6db03 extends $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    constructor(data, parser, name){
        super(data, parser, [], name);
        this.parser = parser;
    }
    /**
    Define a language from a parser.
    */ static define(spec) {
        let data = $a97ccac5cf5f4f5d$export$b57f683f43553b99(spec.languageData);
        return new $a97ccac5cf5f4f5d$export$b243968d9fb6db03(data, spec.parser.configure({
            props: [
                $a97ccac5cf5f4f5d$export$27a2e78097f753f7.add((type)=>type.isTop ? data : undefined)
            ]
        }), spec.name);
    }
    /**
    Create a new instance of this language with a reconfigured
    version of its parser and optionally a new name.
    */ configure(options, name) {
        return new $a97ccac5cf5f4f5d$export$b243968d9fb6db03(this.data, this.parser.configure(options), name || this.name);
    }
    get allowsNesting() {
        return this.parser.hasWrappers();
    }
}
/**
Get the syntax tree for a state, which is the current (possibly
incomplete) parse tree of the active
[language](https://codemirror.net/6/docs/ref/#language.Language), or the empty tree if there is no
language available.
*/ function $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state) {
    let field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false);
    return field ? field.tree : (0, $ed739beecf769914$export$7fbedc92909ed28e).empty;
}
/**
Try to get a parse tree that spans at least up to `upto`. The
method will do at most `timeout` milliseconds of work to parse
up to that point if the tree isn't already available.
*/ function $a97ccac5cf5f4f5d$export$8694796f3a52e973(state, upto, timeout = 50) {
    var _a;
    let parse = (_a = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context;
    if (!parse) return null;
    let oldVieport = parse.viewport;
    parse.updateViewport({
        from: 0,
        to: upto
    });
    let result = parse.isDone(upto) || parse.work(timeout, upto) ? parse.tree : null;
    parse.updateViewport(oldVieport);
    return result;
}
/**
Queries whether there is a full syntax tree available up to the
given document position. If there isn't, the background parse
process _might_ still be working and update the tree further, but
there is no guarantee of that—the parser will [stop
working](https://codemirror.net/6/docs/ref/#language.syntaxParserRunning) when it has spent a
certain amount of time or has moved beyond the visible viewport.
Always returns false if no language has been enabled.
*/ function $a97ccac5cf5f4f5d$export$2c95b013b0941e86(state, upto = state.doc.length) {
    var _a;
    return ((_a = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state, false)) === null || _a === void 0 ? void 0 : _a.context.isDone(upto)) || false;
}
/**
Move parsing forward, and update the editor state afterwards to
reflect the new tree. Will work for at most `timeout`
milliseconds. Returns true if the parser managed get to the given
position in that time.
*/ function $a97ccac5cf5f4f5d$export$b3bcb61c35026d72(view, upto = view.viewport.to, timeout = 100) {
    let success = $a97ccac5cf5f4f5d$export$8694796f3a52e973(view.state, upto, timeout);
    if (success != $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state)) view.dispatch({});
    return !!success;
}
/**
Tells you whether the language parser is planning to do more
parsing work (in a `requestIdleCallback` pseudo-thread) or has
stopped running, either because it parsed the entire document,
because it spent too much time and was cut off, or because there
is no language parser enabled.
*/ function $a97ccac5cf5f4f5d$export$23c0ee92d6189d3f(view) {
    var _a;
    return ((_a = view.plugin($a97ccac5cf5f4f5d$var$parseWorker)) === null || _a === void 0 ? void 0 : _a.isWorking()) || false;
}
/**
Lezer-style
[`Input`](https://lezer.codemirror.net/docs/ref#common.Input)
object for a [`Text`](https://codemirror.net/6/docs/ref/#state.Text) object.
*/ class $a97ccac5cf5f4f5d$export$78c262ab5af874ad {
    /**
    Create an input object for the given document.
    */ constructor(doc){
        this.doc = doc;
        this.cursorPos = 0;
        this.string = "";
        this.cursor = doc.iter();
    }
    get length() {
        return this.doc.length;
    }
    syncTo(pos) {
        this.string = this.cursor.next(pos - this.cursorPos).value;
        this.cursorPos = pos + this.string.length;
        return this.cursorPos - this.string.length;
    }
    chunk(pos) {
        this.syncTo(pos);
        return this.string;
    }
    get lineChunks() {
        return true;
    }
    read(from, to) {
        let stringStart = this.cursorPos - this.string.length;
        if (from < stringStart || to >= this.cursorPos) return this.doc.sliceString(from, to);
        else return this.string.slice(from - stringStart, to - stringStart);
    }
}
let $a97ccac5cf5f4f5d$var$currentContext = null;
/**
A parse context provided to parsers working on the editor content.
*/ class $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa {
    constructor(parser, /**
    The current editor state.
    */ state, /**
    Tree fragments that can be reused by incremental re-parses.
    */ fragments = [], /**
    @internal
    */ tree, /**
    @internal
    */ treeLen, /**
    The current editor viewport (or some overapproximation
    thereof). Intended to be used for opportunistically avoiding
    work (in which case
    [`skipUntilInView`](https://codemirror.net/6/docs/ref/#language.ParseContext.skipUntilInView)
    should be called to make sure the parser is restarted when the
    skipped region becomes visible).
    */ viewport, /**
    @internal
    */ skipped, /**
    This is where skipping parsers can register a promise that,
    when resolved, will schedule a new parse. It is cleared when
    the parse worker picks up the promise. @internal
    */ scheduleOn){
        this.parser = parser;
        this.state = state;
        this.fragments = fragments;
        this.tree = tree;
        this.treeLen = treeLen;
        this.viewport = viewport;
        this.skipped = skipped;
        this.scheduleOn = scheduleOn;
        this.parse = null;
        /**
        @internal
        */ this.tempSkipped = [];
    }
    /**
    @internal
    */ static create(parser, state, viewport) {
        return new $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa(parser, state, [], (0, $ed739beecf769914$export$7fbedc92909ed28e).empty, 0, viewport, [], null);
    }
    startParse() {
        return this.parser.startParse(new $a97ccac5cf5f4f5d$export$78c262ab5af874ad(this.state.doc), this.fragments);
    }
    /**
    @internal
    */ work(until, upto) {
        if (upto != null && upto >= this.state.doc.length) upto = undefined;
        if (this.tree != (0, $ed739beecf769914$export$7fbedc92909ed28e).empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
            this.takeTree();
            return true;
        }
        return this.withContext(()=>{
            var _a;
            if (typeof until == "number") {
                let endTime = Date.now() + until;
                until = ()=>Date.now() > endTime;
            }
            if (!this.parse) this.parse = this.startParse();
            if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length) this.parse.stopAt(upto);
            for(;;){
                let done = this.parse.advance();
                if (done) {
                    this.fragments = this.withoutTempSkipped((0, $ed739beecf769914$export$3ae2ede6dca97077).addTree(done, this.fragments, this.parse.stoppedAt != null));
                    this.treeLen = (_a = this.parse.stoppedAt) !== null && _a !== void 0 ? _a : this.state.doc.length;
                    this.tree = done;
                    this.parse = null;
                    if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length)) this.parse = this.startParse();
                    else return true;
                }
                if (until()) return false;
            }
        });
    }
    /**
    @internal
    */ takeTree() {
        let pos, tree;
        if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
            if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos) this.parse.stopAt(pos);
            this.withContext(()=>{
                while(!(tree = this.parse.advance()));
            });
            this.treeLen = pos;
            this.tree = tree;
            this.fragments = this.withoutTempSkipped((0, $ed739beecf769914$export$3ae2ede6dca97077).addTree(this.tree, this.fragments, true));
            this.parse = null;
        }
    }
    withContext(f) {
        let prev = $a97ccac5cf5f4f5d$var$currentContext;
        $a97ccac5cf5f4f5d$var$currentContext = this;
        try {
            return f();
        } finally{
            $a97ccac5cf5f4f5d$var$currentContext = prev;
        }
    }
    withoutTempSkipped(fragments) {
        for(let r; r = this.tempSkipped.pop();)fragments = $a97ccac5cf5f4f5d$var$cutFragments(fragments, r.from, r.to);
        return fragments;
    }
    /**
    @internal
    */ changes(changes, newState) {
        let { fragments: fragments, tree: tree, treeLen: treeLen, viewport: viewport, skipped: skipped } = this;
        this.takeTree();
        if (!changes.empty) {
            let ranges = [];
            changes.iterChangedRanges((fromA, toA, fromB, toB)=>ranges.push({
                    fromA: fromA,
                    toA: toA,
                    fromB: fromB,
                    toB: toB
                }));
            fragments = (0, $ed739beecf769914$export$3ae2ede6dca97077).applyChanges(fragments, ranges);
            tree = (0, $ed739beecf769914$export$7fbedc92909ed28e).empty;
            treeLen = 0;
            viewport = {
                from: changes.mapPos(viewport.from, -1),
                to: changes.mapPos(viewport.to, 1)
            };
            if (this.skipped.length) {
                skipped = [];
                for (let r of this.skipped){
                    let from = changes.mapPos(r.from, 1), to = changes.mapPos(r.to, -1);
                    if (from < to) skipped.push({
                        from: from,
                        to: to
                    });
                }
            }
        }
        return new $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
    }
    /**
    @internal
    */ updateViewport(viewport) {
        if (this.viewport.from == viewport.from && this.viewport.to == viewport.to) return false;
        this.viewport = viewport;
        let startLen = this.skipped.length;
        for(let i = 0; i < this.skipped.length; i++){
            let { from: from, to: to } = this.skipped[i];
            if (from < viewport.to && to > viewport.from) {
                this.fragments = $a97ccac5cf5f4f5d$var$cutFragments(this.fragments, from, to);
                this.skipped.splice(i--, 1);
            }
        }
        if (this.skipped.length >= startLen) return false;
        this.reset();
        return true;
    }
    /**
    @internal
    */ reset() {
        if (this.parse) {
            this.takeTree();
            this.parse = null;
        }
    }
    /**
    Notify the parse scheduler that the given region was skipped
    because it wasn't in view, and the parse should be restarted
    when it comes into view.
    */ skipUntilInView(from, to) {
        this.skipped.push({
            from: from,
            to: to
        });
    }
    /**
    Returns a parser intended to be used as placeholder when
    asynchronously loading a nested parser. It'll skip its input and
    mark it as not-really-parsed, so that the next update will parse
    it again.
    
    When `until` is given, a reparse will be scheduled when that
    promise resolves.
    */ static getSkippingParser(until) {
        return new class extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                let from = ranges[0].from, to = ranges[ranges.length - 1].to;
                let parser = {
                    parsedPos: from,
                    advance () {
                        let cx = $a97ccac5cf5f4f5d$var$currentContext;
                        if (cx) {
                            for (let r of ranges)cx.tempSkipped.push(r);
                            if (until) cx.scheduleOn = cx.scheduleOn ? Promise.all([
                                cx.scheduleOn,
                                until
                            ]) : until;
                        }
                        this.parsedPos = to;
                        return new (0, $ed739beecf769914$export$7fbedc92909ed28e)((0, $ed739beecf769914$export$f06e977173f1857c).none, [], [], to - from);
                    },
                    stoppedAt: null,
                    stopAt () {}
                };
                return parser;
            }
        };
    }
    /**
    @internal
    */ isDone(upto) {
        upto = Math.min(upto, this.state.doc.length);
        let frags = this.fragments;
        return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
    }
    /**
    Get the context for the current parse, or `null` if no editor
    parse is in progress.
    */ static get() {
        return $a97ccac5cf5f4f5d$var$currentContext;
    }
}
function $a97ccac5cf5f4f5d$var$cutFragments(fragments, from, to) {
    return (0, $ed739beecf769914$export$3ae2ede6dca97077).applyChanges(fragments, [
        {
            fromA: from,
            toA: to,
            fromB: from,
            toB: to
        }
    ]);
}
class $a97ccac5cf5f4f5d$var$LanguageState {
    constructor(// A mutable parse state that is used to preserve work done during
    // the lifetime of a state when moving to the next state.
    context){
        this.context = context;
        this.tree = context.tree;
    }
    apply(tr) {
        if (!tr.docChanged && this.tree == this.context.tree) return this;
        let newCx = this.context.changes(tr.changes, tr.state);
        // If the previous parse wasn't done, go forward only up to its
        // end position or the end of the viewport, to avoid slowing down
        // state updates with parse work beyond the viewport.
        let upto = this.context.treeLen == tr.startState.doc.length ? undefined : Math.max(tr.changes.mapPos(this.context.treeLen), newCx.viewport.to);
        if (!newCx.work(20 /* Work.Apply */ , upto)) newCx.takeTree();
        return new $a97ccac5cf5f4f5d$var$LanguageState(newCx);
    }
    static init(state) {
        let vpTo = Math.min(3000 /* Work.InitViewport */ , state.doc.length);
        let parseState = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.create(state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c).parser, state, {
            from: 0,
            to: vpTo
        });
        if (!parseState.work(20 /* Work.Apply */ , vpTo)) parseState.takeTree();
        return new $a97ccac5cf5f4f5d$var$LanguageState(parseState);
    }
}
$a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create: $a97ccac5cf5f4f5d$var$LanguageState.init,
    update (value, tr) {
        for (let e of tr.effects)if (e.is($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState)) return e.value;
        if (tr.startState.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) != tr.state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c)) return $a97ccac5cf5f4f5d$var$LanguageState.init(tr.state);
        return value.apply(tr);
    }
});
let $a97ccac5cf5f4f5d$var$requestIdle = (callback)=>{
    let timeout = setTimeout(()=>callback(), 500 /* Work.MaxPause */ );
    return ()=>clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined") $a97ccac5cf5f4f5d$var$requestIdle = (callback)=>{
    let idle = -1, timeout = setTimeout(()=>{
        idle = requestIdleCallback(callback, {
            timeout: 400 /* Work.MinPause */ 
        });
    }, 100 /* Work.MinPause */ );
    return ()=>idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
};
const $a97ccac5cf5f4f5d$var$isInputPending = typeof navigator != "undefined" && (($a97ccac5cf5f4f5d$var$_a = navigator.scheduling) === null || $a97ccac5cf5f4f5d$var$_a === void 0 ? void 0 : $a97ccac5cf5f4f5d$var$_a.isInputPending) ? ()=>navigator.scheduling.isInputPending() : null;
const $a97ccac5cf5f4f5d$var$parseWorker = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class ParseWorker {
    constructor(view){
        this.view = view;
        this.working = null;
        this.workScheduled = 0;
        // End of the current time chunk
        this.chunkEnd = -1;
        // Milliseconds of budget left for this chunk
        this.chunkBudget = -1;
        this.work = this.work.bind(this);
        this.scheduleWork();
    }
    update(update) {
        let cx = this.view.state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state).context;
        if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen) this.scheduleWork();
        if (update.docChanged || update.selectionSet) {
            if (this.view.hasFocus) this.chunkBudget += 50 /* Work.ChangeBonus */ ;
            this.scheduleWork();
        }
        this.checkAsyncSchedule(cx);
    }
    scheduleWork() {
        if (this.working) return;
        let { state: state } = this.view, field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state);
        if (field.tree != field.context.tree || !field.context.isDone(state.doc.length)) this.working = $a97ccac5cf5f4f5d$var$requestIdle(this.work);
    }
    work(deadline) {
        this.working = null;
        let now = Date.now();
        if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
            this.chunkEnd = now + 30000 /* Work.ChunkTime */ ;
            this.chunkBudget = 3000 /* Work.ChunkBudget */ ;
        }
        if (this.chunkBudget <= 0) return; // No more budget
        let { state: state, viewport: { to: vpTo } } = this.view, field = state.field($a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state);
        if (field.tree == field.context.tree && field.context.isDone(vpTo + 100000 /* Work.MaxParseAhead */ )) return;
        let endTime = Date.now() + Math.min(this.chunkBudget, 100 /* Work.Slice */ , deadline && !$a97ccac5cf5f4f5d$var$isInputPending ? Math.max(25 /* Work.MinSlice */ , deadline.timeRemaining() - 5) : 1e9);
        let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1000;
        let done = field.context.work(()=>{
            return $a97ccac5cf5f4f5d$var$isInputPending && $a97ccac5cf5f4f5d$var$isInputPending() || Date.now() > endTime;
        }, vpTo + (viewportFirst ? 0 : 100000 /* Work.MaxParseAhead */ ));
        this.chunkBudget -= Date.now() - now;
        if (done || this.chunkBudget <= 0) {
            field.context.takeTree();
            this.view.dispatch({
                effects: $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.setState.of(new $a97ccac5cf5f4f5d$var$LanguageState(field.context))
            });
        }
        if (this.chunkBudget > 0 && !(done && !viewportFirst)) this.scheduleWork();
        this.checkAsyncSchedule(field.context);
    }
    checkAsyncSchedule(cx) {
        if (cx.scheduleOn) {
            this.workScheduled++;
            cx.scheduleOn.then(()=>this.scheduleWork()).catch((err)=>(0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, err)).then(()=>this.workScheduled--);
            cx.scheduleOn = null;
        }
    }
    destroy() {
        if (this.working) this.working();
    }
    isWorking() {
        return !!(this.working || this.workScheduled > 0);
    }
}, {
    eventHandlers: {
        focus () {
            this.scheduleWork();
        }
    }
});
/**
The facet used to associate a language with an editor state. Used
by `Language` object's `extension` property (so you don't need to
manually wrap your languages in this). Can be used to access the
current language on a state.
*/ const $a97ccac5cf5f4f5d$export$789c912f57fe164c = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (languages) {
        return languages.length ? languages[0] : null;
    },
    enables: (language)=>[
            $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a.state,
            $a97ccac5cf5f4f5d$var$parseWorker,
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).contentAttributes.compute([
                language
            ], (state)=>{
                let lang = state.facet(language);
                return lang && lang.name ? {
                    "data-language": lang.name
                } : {};
            })
        ]
});
/**
This class bundles a [language](https://codemirror.net/6/docs/ref/#language.Language) with an
optional set of supporting extensions. Language packages are
encouraged to export a function that optionally takes a
configuration object and returns a `LanguageSupport` instance, as
the main way for client code to use the package.
*/ class $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b {
    /**
    Create a language support object.
    */ constructor(/**
    The language object.
    */ language, /**
    An optional set of supporting extensions. When nesting a
    language in another language, the outer language is encouraged
    to include the supporting extensions for its inner languages
    in its own set of support extensions.
    */ support = []){
        this.language = language;
        this.support = support;
        this.extension = [
            language,
            support
        ];
    }
}
/**
Language descriptions are used to store metadata about languages
and to dynamically load them. Their main role is finding the
appropriate language for a filename or dynamically loading nested
parsers.
*/ class $a97ccac5cf5f4f5d$export$50ab82debf88f71 {
    constructor(/**
    The name of this language.
    */ name, /**
    Alternative names for the mode (lowercased, includes `this.name`).
    */ alias, /**
    File extensions associated with this language.
    */ extensions, /**
    Optional filename pattern that should be associated with this
    language.
    */ filename, loadFunc, /**
    If the language has been loaded, this will hold its value.
    */ support){
        this.name = name;
        this.alias = alias;
        this.extensions = extensions;
        this.filename = filename;
        this.loadFunc = loadFunc;
        this.support = support;
        this.loading = null;
    }
    /**
    Start loading the the language. Will return a promise that
    resolves to a [`LanguageSupport`](https://codemirror.net/6/docs/ref/#language.LanguageSupport)
    object when the language successfully loads.
    */ load() {
        return this.loading || (this.loading = this.loadFunc().then((support)=>this.support = support, (err)=>{
            this.loading = null;
            throw err;
        }));
    }
    /**
    Create a language description.
    */ static of(spec) {
        let { load: load, support: support } = spec;
        if (!load) {
            if (!support) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
            load = ()=>Promise.resolve(support);
        }
        return new $a97ccac5cf5f4f5d$export$50ab82debf88f71(spec.name, (spec.alias || []).concat(spec.name).map((s)=>s.toLowerCase()), spec.extensions || [], spec.filename, load, support);
    }
    /**
    Look for a language in the given array of descriptions that
    matches the filename. Will first match
    [`filename`](https://codemirror.net/6/docs/ref/#language.LanguageDescription.filename) patterns,
    and then [extensions](https://codemirror.net/6/docs/ref/#language.LanguageDescription.extensions),
    and return the first language that matches.
    */ static matchFilename(descs, filename) {
        for (let d of descs)if (d.filename && d.filename.test(filename)) return d;
        let ext = /\.([^.]+)$/.exec(filename);
        if (ext) {
            for (let d of descs)if (d.extensions.indexOf(ext[1]) > -1) return d;
        }
        return null;
    }
    /**
    Look for a language whose name or alias matches the the given
    name (case-insensitively). If `fuzzy` is true, and no direct
    matchs is found, this'll also search for a language whose name
    or alias occurs in the string (for names shorter than three
    characters, only when surrounded by non-word characters).
    */ static matchLanguageName(descs, name, fuzzy = true) {
        name = name.toLowerCase();
        for (let d of descs)if (d.alias.some((a)=>a == name)) return d;
        if (fuzzy) for (let d of descs)for (let a of d.alias){
            let found = name.indexOf(a);
            if (found > -1 && (a.length > 2 || !/\w/.test(name[found - 1]) && !/\w/.test(name[found + a.length]))) return d;
        }
        return null;
    }
}
/**
Facet that defines a way to provide a function that computes the
appropriate indentation depth, as a column number (see
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)), at the start of a given
line. A return value of `null` indicates no indentation can be
determined, and the line should inherit the indentation of the one
above it. A return value of `undefined` defers to the next indent
service.
*/ const $a97ccac5cf5f4f5d$export$5952625dce50d1f3 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
Facet for overriding the unit by which indentation happens. Should
be a string consisting either entirely of the same whitespace
character. When not set, this defaults to 2 spaces.
*/ const $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>{
        if (!values.length) return "  ";
        let unit = values[0];
        if (!unit || /\S/.test(unit) || Array.from(unit).some((e)=>e != unit[0])) throw new Error("Invalid indent unit: " + JSON.stringify(values[0]));
        return unit;
    }
});
/**
Return the _column width_ of an indent unit in the state.
Determined by the [`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit)
facet, and [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) when that
contains tabs.
*/ function $a97ccac5cf5f4f5d$export$ad3205d09311a797(state) {
    let unit = state.facet($a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5);
    return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
/**
Create an indentation string that covers columns 0 to `cols`.
Will use tabs for as much of the columns as possible when the
[`indentUnit`](https://codemirror.net/6/docs/ref/#language.indentUnit) facet contains
tabs.
*/ function $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, cols) {
    let result = "", ts = state.tabSize, ch = state.facet($a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5)[0];
    if (ch == "	") {
        while(cols >= ts){
            result += "	";
            cols -= ts;
        }
        ch = " ";
    }
    for(let i = 0; i < cols; i++)result += ch;
    return result;
}
/**
Get the indentation, as a column number, at the given position.
Will first consult any [indent services](https://codemirror.net/6/docs/ref/#language.indentService)
that are registered, and if none of those return an indentation,
this will check the syntax tree for the [indent node
prop](https://codemirror.net/6/docs/ref/#language.indentNodeProp) and use that if found. Returns a
number when an indentation could be determined, and null
otherwise.
*/ function $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(context, pos) {
    if (context instanceof (0, $6295c6875f57e3ee$export$afa855cbfaff27f2)) context = new $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8(context);
    for (let service of context.state.facet($a97ccac5cf5f4f5d$export$5952625dce50d1f3)){
        let result = service(context, pos);
        if (result !== undefined) return result;
    }
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(context.state);
    return tree.length >= pos ? $a97ccac5cf5f4f5d$var$syntaxIndentation(context, tree, pos) : null;
}
/**
Create a change set that auto-indents all lines touched by the
given document range.
*/ function $a97ccac5cf5f4f5d$export$2fc72a4ad8b85e40(state, from, to) {
    let updated = Object.create(null);
    let context = new $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8(state, {
        overrideIndentation: (start)=>{
            var _a;
            return (_a = updated[start]) !== null && _a !== void 0 ? _a : -1;
        }
    });
    let changes = [];
    for(let pos = from; pos <= to;){
        let line = state.doc.lineAt(pos);
        pos = line.to + 1;
        let indent = $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(context, line.from);
        if (indent == null) continue;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, indent);
        if (cur != norm) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    }
    return state.changes(changes);
}
/**
Indentation contexts are used when calling [indentation
services](https://codemirror.net/6/docs/ref/#language.indentService). They provide helper utilities
useful in indentation logic, and can selectively override the
indentation reported for some lines.
*/ class $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8 {
    /**
    Create an indent context.
    */ constructor(/**
    The editor state.
    */ state, /**
    @internal
    */ options = {}){
        this.state = state;
        this.options = options;
        this.unit = $a97ccac5cf5f4f5d$export$ad3205d09311a797(state);
    }
    /**
    Get a description of the line at the given position, taking
    [simulated line
    breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    into account. If there is such a break at `pos`, the `bias`
    argument determines whether the part of the line line before or
    after the break is used.
    */ lineAt(pos, bias = 1) {
        let line = this.state.doc.lineAt(pos);
        let { simulateBreak: simulateBreak, simulateDoubleBreak: simulateDoubleBreak } = this.options;
        if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
            if (simulateDoubleBreak && simulateBreak == pos) return {
                text: "",
                from: pos
            };
            else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos) return {
                text: line.text.slice(simulateBreak - line.from),
                from: simulateBreak
            };
            else return {
                text: line.text.slice(0, simulateBreak - line.from),
                from: line.from
            };
        }
        return line;
    }
    /**
    Get the text directly after `pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ textAfterPos(pos, bias = 1) {
        if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak) return "";
        let { text: text, from: from } = this.lineAt(pos, bias);
        return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
    }
    /**
    Find the column for the given position.
    */ column(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let result = this.countColumn(text, pos - from);
        let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
        if (override > -1) result += override - this.countColumn(text, text.search(/\S|$/));
        return result;
    }
    /**
    Find the column position (taking tabs into account) of the given
    position in the given string.
    */ countColumn(line, pos = line.length) {
        return (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(line, this.state.tabSize, pos);
    }
    /**
    Find the indentation column of the line at the given point.
    */ lineIndent(pos, bias = 1) {
        let { text: text, from: from } = this.lineAt(pos, bias);
        let override = this.options.overrideIndentation;
        if (override) {
            let overriden = override(from);
            if (overriden > -1) return overriden;
        }
        return this.countColumn(text, text.search(/\S|$/));
    }
    /**
    Returns the [simulated line
    break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
    for this context, if any.
    */ get simulatedBreak() {
        return this.options.simulateBreak || null;
    }
}
/**
A syntax tree node prop used to associate indentation strategies
with node types. Such a strategy is a function from an indentation
context to a column number (see also
[`indentString`](https://codemirror.net/6/docs/ref/#language.indentString)) or null, where null
indicates that no definitive indentation can be determined.
*/ const $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
// Compute the indentation for a given position from the syntax tree.
function $a97ccac5cf5f4f5d$var$syntaxIndentation(cx, ast, pos) {
    let stack = ast.resolveStack(pos);
    let inner = stack.node.enterUnfinishedNodesBefore(pos);
    if (inner != stack.node) {
        let add = [];
        for(let cur = inner; cur != stack.node; cur = cur.parent)add.push(cur);
        for(let i = add.length - 1; i >= 0; i--)stack = {
            node: add[i],
            next: stack
        };
    }
    return $a97ccac5cf5f4f5d$var$indentFor(stack, cx, pos);
}
function $a97ccac5cf5f4f5d$var$indentFor(stack, cx, pos) {
    for(let cur = stack; cur; cur = cur.next){
        let strategy = $a97ccac5cf5f4f5d$var$indentStrategy(cur.node);
        if (strategy) return strategy($a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3.create(cx, pos, cur));
    }
    return 0;
}
function $a97ccac5cf5f4f5d$var$ignoreClosed(cx) {
    return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function $a97ccac5cf5f4f5d$var$indentStrategy(tree) {
    let strategy = tree.type.prop($a97ccac5cf5f4f5d$export$72c7d4c52b3c6460);
    if (strategy) return strategy;
    let first = tree.firstChild, close;
    if (first && (close = first.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy))) {
        let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
        return (cx)=>$a97ccac5cf5f4f5d$var$delimitedStrategy(cx, true, 1, undefined, closed && !$a97ccac5cf5f4f5d$var$ignoreClosed(cx) ? last.from : undefined);
    }
    return tree.parent == null ? $a97ccac5cf5f4f5d$var$topIndent : null;
}
function $a97ccac5cf5f4f5d$var$topIndent() {
    return 0;
}
/**
Objects of this type provide context information and helper
methods to indentation functions registered on syntax nodes.
*/ class $a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3 extends $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8 {
    constructor(base, /**
    The position at which indentation is being computed.
    */ pos, /**
    @internal
    */ context){
        super(base.state, base.options);
        this.base = base;
        this.pos = pos;
        this.context = context;
    }
    /**
    The syntax tree node to which the indentation strategy
    applies.
    */ get node() {
        return this.context.node;
    }
    /**
    @internal
    */ static create(base, pos, context) {
        return new $a97ccac5cf5f4f5d$export$8aaeb0848a33f7c3(base, pos, context);
    }
    /**
    Get the text directly after `this.pos`, either the entire line
    or the next 100 characters, whichever is shorter.
    */ get textAfter() {
        return this.textAfterPos(this.pos);
    }
    /**
    Get the indentation at the reference line for `this.node`, which
    is the line on which it starts, unless there is a node that is
    _not_ a parent of this node covering the start of that line. If
    so, the line at the start of that node is tried, again skipping
    on if it is covered by another such node.
    */ get baseIndent() {
        return this.baseIndentFor(this.node);
    }
    /**
    Get the indentation for the reference line of the given node
    (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
    */ baseIndentFor(node) {
        let line = this.state.doc.lineAt(node.from);
        // Skip line starts that are covered by a sibling (or cousin, etc)
        for(;;){
            let atBreak = node.resolve(line.from);
            while(atBreak.parent && atBreak.parent.from == atBreak.from)atBreak = atBreak.parent;
            if ($a97ccac5cf5f4f5d$var$isParent(atBreak, node)) break;
            line = this.state.doc.lineAt(atBreak.from);
        }
        return this.lineIndent(line.from);
    }
    /**
    Continue looking for indentations in the node's parent nodes,
    and return the result of that.
    */ continue() {
        return $a97ccac5cf5f4f5d$var$indentFor(this.context.next, this.base, this.pos);
    }
}
function $a97ccac5cf5f4f5d$var$isParent(parent, of) {
    for(let cur = of; cur; cur = cur.parent)if (parent == cur) return true;
    return false;
}
// Check whether a delimited node is aligned (meaning there are
// non-skipped nodes on the same line as the opening delimiter). And
// if so, return the opening token.
function $a97ccac5cf5f4f5d$var$bracketedAligned(context) {
    let tree = context.node;
    let openToken = tree.childAfter(tree.from), last = tree.lastChild;
    if (!openToken) return null;
    let sim = context.options.simulateBreak;
    let openLine = context.state.doc.lineAt(openToken.from);
    let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
    for(let pos = openToken.to;;){
        let next = tree.childAfter(pos);
        if (!next || next == last) return null;
        if (!next.type.isSkipped) return next.from < lineEnd ? openToken : null;
        pos = next.to;
    }
}
/**
An indentation strategy for delimited (usually bracketed) nodes.
Will, by default, indent one unit more than the parent's base
indent unless the line starts with a closing token. When `align`
is true and there are non-skipped nodes on the node's opening
line, the content of the node will be aligned with the end of the
opening node, like this:

    foo(bar,
        baz)
*/ function $a97ccac5cf5f4f5d$export$60e82ea306899488({ closing: closing, align: align = true, units: units = 1 }) {
    return (context)=>$a97ccac5cf5f4f5d$var$delimitedStrategy(context, align, units, closing);
}
function $a97ccac5cf5f4f5d$var$delimitedStrategy(context, align, units, closing, closedAt) {
    let after = context.textAfter, space = after.match(/^\s*/)[0].length;
    let closed = closing && after.slice(space, space + closing.length) == closing || closedAt == context.pos + space;
    let aligned = align ? $a97ccac5cf5f4f5d$var$bracketedAligned(context) : null;
    if (aligned) return closed ? context.column(aligned.from) : context.column(aligned.to);
    return context.baseIndent + (closed ? 0 : context.unit * units);
}
/**
An indentation strategy that aligns a node's content to its base
indentation.
*/ const $a97ccac5cf5f4f5d$export$4764c629086182f2 = (context)=>context.baseIndent;
/**
Creates an indentation strategy that, by default, indents
continued lines one unit more than the node's base indentation.
You can provide `except` to prevent indentation of lines that
match a pattern (for example `/^else\b/` in `if`/`else`
constructs), and you can change the amount of units used with the
`units` option.
*/ function $a97ccac5cf5f4f5d$export$688ff433e7e7cc5c({ except: except, units: units = 1 } = {}) {
    return (context)=>{
        let matchExcept = except && except.test(context.textAfter);
        return context.baseIndent + (matchExcept ? 0 : units * context.unit);
    };
}
const $a97ccac5cf5f4f5d$var$DontIndentBeyond = 200;
/**
Enables reindentation on input. When a language defines an
`indentOnInput` field in its [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt), which must hold a regular
expression, the line at the cursor will be reindented whenever new
text is typed and the input from the start of the line up to the
cursor matches that regexp.

To avoid unneccesary reindents, it is recommended to start the
regexp with `^` (usually followed by `\s*`), and end it with `$`.
For example, `/^\s*\}$/` will reindent when a closing brace is
added at the start of a line.
*/ function $a97ccac5cf5f4f5d$export$9bcaf6e2125ee117() {
    return (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).transactionFilter.of((tr)=>{
        if (!tr.docChanged || !tr.isUserEvent("input.type") && !tr.isUserEvent("input.complete")) return tr;
        let rules = tr.startState.languageDataAt("indentOnInput", tr.startState.selection.main.head);
        if (!rules.length) return tr;
        let doc = tr.newDoc, { head: head } = tr.newSelection.main, line = doc.lineAt(head);
        if (head > line.from + $a97ccac5cf5f4f5d$var$DontIndentBeyond) return tr;
        let lineStart = doc.sliceString(line.from, head);
        if (!rules.some((r)=>r.test(lineStart))) return tr;
        let { state: state } = tr, last = -1, changes = [];
        for (let { head: head } of state.selection.ranges){
            let line = state.doc.lineAt(head);
            if (line.from == last) continue;
            last = line.from;
            let indent = $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211(state, line.from);
            if (indent == null) continue;
            let cur = /^\s*/.exec(line.text)[0];
            let norm = $a97ccac5cf5f4f5d$export$db5a40e207b40576(state, indent);
            if (cur != norm) changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
        return changes.length ? [
            tr,
            {
                changes: changes,
                sequential: true
            }
        ] : tr;
    });
}
/**
A facet that registers a code folding service. When called with
the extent of a line, such a function should return a foldable
range that starts on that line (but continues beyond it), if one
can be found.
*/ const $a97ccac5cf5f4f5d$export$40014037e3ef64a = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
/**
This node prop is used to associate folding information with
syntax node types. Given a syntax node, it should check whether
that tree is foldable and return the range that can be collapsed
when it is.
*/ const $a97ccac5cf5f4f5d$export$9b075a85eb4377d8 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
/**
[Fold](https://codemirror.net/6/docs/ref/#language.foldNodeProp) function that folds everything but
the first and the last child of a syntax node. Useful for nodes
that start and end with delimiters.
*/ function $a97ccac5cf5f4f5d$export$48672beae16a681b(node) {
    let first = node.firstChild, last = node.lastChild;
    return first && first.to < last.from ? {
        from: first.to,
        to: last.type.isError ? node.to : last.from
    } : null;
}
function $a97ccac5cf5f4f5d$var$syntaxFolding(state, start, end) {
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state);
    if (tree.length < end) return null;
    let stack = tree.resolveStack(end, 1);
    let found = null;
    for(let iter = stack; iter; iter = iter.next){
        let cur = iter.node;
        if (cur.to <= end || cur.from > end) continue;
        if (found && cur.from < start) break;
        let prop = cur.type.prop($a97ccac5cf5f4f5d$export$9b075a85eb4377d8);
        if (prop && (cur.to < tree.length - 50 || tree.length == state.doc.length || !$a97ccac5cf5f4f5d$var$isUnfinished(cur))) {
            let value = prop(cur, state);
            if (value && value.from <= end && value.from >= start && value.to > end) found = value;
        }
    }
    return found;
}
function $a97ccac5cf5f4f5d$var$isUnfinished(node) {
    let ch = node.lastChild;
    return ch && ch.to == node.to && ch.type.isError;
}
/**
Check whether the given line is foldable. First asks any fold
services registered through
[`foldService`](https://codemirror.net/6/docs/ref/#language.foldService), and if none of them return
a result, tries to query the [fold node
prop](https://codemirror.net/6/docs/ref/#language.foldNodeProp) of syntax nodes that cover the end
of the line.
*/ function $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(state, lineStart, lineEnd) {
    for (let service of state.facet($a97ccac5cf5f4f5d$export$40014037e3ef64a)){
        let result = service(state, lineStart, lineEnd);
        if (result) return result;
    }
    return $a97ccac5cf5f4f5d$var$syntaxFolding(state, lineStart, lineEnd);
}
function $a97ccac5cf5f4f5d$var$mapRange(range, mapping) {
    let from = mapping.mapPos(range.from, 1), to = mapping.mapPos(range.to, -1);
    return from >= to ? undefined : {
        from: from,
        to: to
    };
}
/**
State effect that can be attached to a transaction to fold the
given range. (You probably only need this in exceptional
circumstances—usually you'll just want to let
[`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode) and the [fold
gutter](https://codemirror.net/6/docs/ref/#language.foldGutter) create the transactions.)
*/ const $a97ccac5cf5f4f5d$export$a123efe007ad265 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: $a97ccac5cf5f4f5d$var$mapRange
});
/**
State effect that unfolds the given range (if it was folded).
*/ const $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map: $a97ccac5cf5f4f5d$var$mapRange
});
function $a97ccac5cf5f4f5d$var$selectedLines(view) {
    let lines = [];
    for (let { head: head } of view.state.selection.ranges){
        if (lines.some((l)=>l.from <= head && l.to >= head)) continue;
        lines.push(view.lineBlockAt(head));
    }
    return lines;
}
/**
The state field that stores the folded ranges (as a [decoration
set](https://codemirror.net/6/docs/ref/#view.DecorationSet)). Can be passed to
[`EditorState.toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) and
[`fromJSON`](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) to serialize the fold
state.
*/ const $a97ccac5cf5f4f5d$export$6955fe1f7c578abb = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    },
    update (folded, tr) {
        folded = folded.map(tr.changes);
        for (let e of tr.effects){
            if (e.is($a97ccac5cf5f4f5d$export$a123efe007ad265) && !$a97ccac5cf5f4f5d$var$foldExists(folded, e.value.from, e.value.to)) {
                let { preparePlaceholder: preparePlaceholder } = tr.state.facet($a97ccac5cf5f4f5d$var$foldConfig);
                let widget = !preparePlaceholder ? $a97ccac5cf5f4f5d$var$foldWidget : (0, $7beee9608540d2c3$export$10e30b733df217ea).replace({
                    widget: new $a97ccac5cf5f4f5d$var$PreparedFoldWidget(preparePlaceholder(tr.state, e.value))
                });
                folded = folded.update({
                    add: [
                        widget.range(e.value.from, e.value.to)
                    ]
                });
            } else if (e.is($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab)) folded = folded.update({
                filter: (from, to)=>e.value.from != from || e.value.to != to,
                filterFrom: e.value.from,
                filterTo: e.value.to
            });
        }
        // Clear folded ranges that cover the selection head
        if (tr.selection) {
            let onSelection = false, { head: head } = tr.selection.main;
            folded.between(head, head, (a, b)=>{
                if (a < head && b > head) onSelection = true;
            });
            if (onSelection) folded = folded.update({
                filterFrom: head,
                filterTo: head,
                filter: (a, b)=>b <= head || a >= head
            });
        }
        return folded;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f),
    toJSON (folded, state) {
        let ranges = [];
        folded.between(0, state.doc.length, (from, to)=>{
            ranges.push(from, to);
        });
        return ranges;
    },
    fromJSON (value) {
        if (!Array.isArray(value) || value.length % 2) throw new RangeError("Invalid JSON for fold state");
        let ranges = [];
        for(let i = 0; i < value.length;){
            let from = value[i++], to = value[i++];
            if (typeof from != "number" || typeof to != "number") throw new RangeError("Invalid JSON for fold state");
            ranges.push($a97ccac5cf5f4f5d$var$foldWidget.range(from, to));
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(ranges, true);
    }
});
/**
Get a [range set](https://codemirror.net/6/docs/ref/#state.RangeSet) containing the folded ranges
in the given state.
*/ function $a97ccac5cf5f4f5d$export$2b3c199812391e05(state) {
    return state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) || (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
}
function $a97ccac5cf5f4f5d$var$findFold(state, from, to) {
    var _a;
    let found = null;
    (_a = state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false)) === null || _a === void 0 || _a.between(from, to, (from, to)=>{
        if (!found || found.from > from) found = {
            from: from,
            to: to
        };
    });
    return found;
}
function $a97ccac5cf5f4f5d$var$foldExists(folded, from, to) {
    let found = false;
    folded.between(from, from, (a, b)=>{
        if (a == from && b == to) found = true;
    });
    return found;
}
function $a97ccac5cf5f4f5d$var$maybeEnable(state, other) {
    return state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) ? other : other.concat((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($a97ccac5cf5f4f5d$export$2c875b83a85d0f31()));
}
/**
Fold the lines that are selected, if possible.
*/ const $a97ccac5cf5f4f5d$export$52e96be2adbea02a = (view)=>{
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (range) {
            view.dispatch({
                effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, [
                    $a97ccac5cf5f4f5d$export$a123efe007ad265.of(range),
                    $a97ccac5cf5f4f5d$var$announceFold(view, range)
                ])
            });
            return true;
        }
    }
    return false;
};
/**
Unfold folded ranges on selected lines.
*/ const $a97ccac5cf5f4f5d$export$f4cd5e9f2c073861 = (view)=>{
    if (!view.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false)) return false;
    let effects = [];
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded), $a97ccac5cf5f4f5d$var$announceFold(view, folded, false));
    }
    if (effects.length) view.dispatch({
        effects: effects
    });
    return effects.length > 0;
};
function $a97ccac5cf5f4f5d$var$announceFold(view, range, fold = true) {
    let lineFrom = view.state.doc.lineAt(range.from).number, lineTo = view.state.doc.lineAt(range.to).number;
    return (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
/**
Fold all top-level foldable ranges. Note that, in most cases,
folding information will depend on the [syntax
tree](https://codemirror.net/6/docs/ref/#language.syntaxTree), and folding everything may not work
reliably when the document hasn't been fully parsed (either
because the editor state was only just initialized, or because the
document is so big that the parser decided not to parse it
entirely).
*/ const $a97ccac5cf5f4f5d$export$5396d9eaf1c0ba76 = (view)=>{
    let { state: state } = view, effects = [];
    for(let pos = 0; pos < state.doc.length;){
        let line = view.lineBlockAt(pos), range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(state, line.from, line.to);
        if (range) effects.push($a97ccac5cf5f4f5d$export$a123efe007ad265.of(range));
        pos = (range ? view.lineBlockAt(range.to) : line).to + 1;
    }
    if (effects.length) view.dispatch({
        effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Unfold all folded code.
*/ const $a97ccac5cf5f4f5d$export$5671b24df569b27d = (view)=>{
    let field = view.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false);
    if (!field || !field.size) return false;
    let effects = [];
    field.between(0, view.state.doc.length, (from, to)=>{
        effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of({
            from: from,
            to: to
        }));
    });
    view.dispatch({
        effects: effects
    });
    return true;
};
// Find the foldable region containing the given line, if one exists
function $a97ccac5cf5f4f5d$var$foldableContainer(view, lineBlock) {
    // Look backwards through line blocks until we find a foldable region that
    // intersects with the line
    for(let line = lineBlock;;){
        let foldableRegion = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
        if (foldableRegion && foldableRegion.to > lineBlock.from) return foldableRegion;
        if (!line.from) return null;
        line = view.lineBlockAt(line.from - 1);
    }
}
/**
Toggle folding at cursors. Unfolds if there is an existing fold
starting in that line, tries to find a foldable range around it
otherwise.
*/ const $a97ccac5cf5f4f5d$export$b23e83f59d68c8f1 = (view)=>{
    let effects = [];
    for (let line of $a97ccac5cf5f4f5d$var$selectedLines(view)){
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) effects.push($a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded), $a97ccac5cf5f4f5d$var$announceFold(view, folded, false));
        else {
            let foldRange = $a97ccac5cf5f4f5d$var$foldableContainer(view, line);
            if (foldRange) effects.push($a97ccac5cf5f4f5d$export$a123efe007ad265.of(foldRange), $a97ccac5cf5f4f5d$var$announceFold(view, foldRange));
        }
    }
    if (effects.length > 0) view.dispatch({
        effects: $a97ccac5cf5f4f5d$var$maybeEnable(view.state, effects)
    });
    return !!effects.length;
};
/**
Default fold-related key bindings.

 - Ctrl-Shift-[ (Cmd-Alt-[ on macOS): [`foldCode`](https://codemirror.net/6/docs/ref/#language.foldCode).
 - Ctrl-Shift-] (Cmd-Alt-] on macOS): [`unfoldCode`](https://codemirror.net/6/docs/ref/#language.unfoldCode).
 - Ctrl-Alt-[: [`foldAll`](https://codemirror.net/6/docs/ref/#language.foldAll).
 - Ctrl-Alt-]: [`unfoldAll`](https://codemirror.net/6/docs/ref/#language.unfoldAll).
*/ const $a97ccac5cf5f4f5d$export$39c52376a8936d67 = [
    {
        key: "Ctrl-Shift-[",
        mac: "Cmd-Alt-[",
        run: $a97ccac5cf5f4f5d$export$52e96be2adbea02a
    },
    {
        key: "Ctrl-Shift-]",
        mac: "Cmd-Alt-]",
        run: $a97ccac5cf5f4f5d$export$f4cd5e9f2c073861
    },
    {
        key: "Ctrl-Alt-[",
        run: $a97ccac5cf5f4f5d$export$5396d9eaf1c0ba76
    },
    {
        key: "Ctrl-Alt-]",
        run: $a97ccac5cf5f4f5d$export$5671b24df569b27d
    }
];
const $a97ccac5cf5f4f5d$var$defaultConfig = {
    placeholderDOM: null,
    preparePlaceholder: null,
    placeholderText: "\u2026"
};
const $a97ccac5cf5f4f5d$var$foldConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(values, $a97ccac5cf5f4f5d$var$defaultConfig);
    }
});
/**
Create an extension that configures code folding.
*/ function $a97ccac5cf5f4f5d$export$2c875b83a85d0f31(config) {
    let result = [
        $a97ccac5cf5f4f5d$export$6955fe1f7c578abb,
        $a97ccac5cf5f4f5d$var$baseTheme$1
    ];
    if (config) result.push($a97ccac5cf5f4f5d$var$foldConfig.of(config));
    return result;
}
function $a97ccac5cf5f4f5d$var$widgetToDOM(view, prepared) {
    let { state: state } = view, conf = state.facet($a97ccac5cf5f4f5d$var$foldConfig);
    let onclick = (event)=>{
        let line = view.lineBlockAt(view.posAtDOM(event.target));
        let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
        if (folded) view.dispatch({
            effects: $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded)
        });
        event.preventDefault();
    };
    if (conf.placeholderDOM) return conf.placeholderDOM(view, onclick, prepared);
    let element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
}
const $a97ccac5cf5f4f5d$var$foldWidget = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).replace({
    widget: /*@__PURE__*/ new class extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
        toDOM(view) {
            return $a97ccac5cf5f4f5d$var$widgetToDOM(view, null);
        }
    }
});
class $a97ccac5cf5f4f5d$var$PreparedFoldWidget extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
    constructor(value){
        super();
        this.value = value;
    }
    eq(other) {
        return this.value == other.value;
    }
    toDOM(view) {
        return $a97ccac5cf5f4f5d$var$widgetToDOM(view, this.value);
    }
}
const $a97ccac5cf5f4f5d$var$foldGutterDefaults = {
    openText: "\u2304",
    closedText: "\u203A",
    markerDOM: null,
    domEventHandlers: {},
    foldingChanged: ()=>false
};
class $a97ccac5cf5f4f5d$var$FoldMarker extends (0, $7beee9608540d2c3$export$591ab4c909549043) {
    constructor(config, open){
        super();
        this.config = config;
        this.open = open;
    }
    eq(other) {
        return this.config == other.config && this.open == other.open;
    }
    toDOM(view) {
        if (this.config.markerDOM) return this.config.markerDOM(this.open);
        let span = document.createElement("span");
        span.textContent = this.open ? this.config.openText : this.config.closedText;
        span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
        return span;
    }
}
/**
Create an extension that registers a fold gutter, which shows a
fold status indicator before foldable lines (which can be clicked
to fold or unfold the line).
*/ function $a97ccac5cf5f4f5d$export$c4dcf64f741b6228(config = {}) {
    let fullConfig = Object.assign(Object.assign({}, $a97ccac5cf5f4f5d$var$foldGutterDefaults), config);
    let canFold = new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, true), canUnfold = new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, false);
    let markers = (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
        constructor(view){
            this.from = view.viewport.from;
            this.markers = this.buildMarkers(view);
        }
        update(update) {
            if (update.docChanged || update.viewportChanged || update.startState.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) != update.state.facet($a97ccac5cf5f4f5d$export$789c912f57fe164c) || update.startState.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) != update.state.field($a97ccac5cf5f4f5d$export$6955fe1f7c578abb, false) || $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.startState) != $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state) || fullConfig.foldingChanged(update)) this.markers = this.buildMarkers(update.view);
        }
        buildMarkers(view) {
            let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
            for (let line of view.viewportLineBlocks){
                let mark = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to) ? canUnfold : $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to) ? canFold : null;
                if (mark) builder.add(line.from, line.from, mark);
            }
            return builder.finish();
        }
    });
    let { domEventHandlers: domEventHandlers } = fullConfig;
    return [
        markers,
        (0, $7beee9608540d2c3$export$f2b922cb4a245974)({
            class: "cm-foldGutter",
            markers (view) {
                var _a;
                return ((_a = view.plugin(markers)) === null || _a === void 0 ? void 0 : _a.markers) || (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
            },
            initialSpacer () {
                return new $a97ccac5cf5f4f5d$var$FoldMarker(fullConfig, false);
            },
            domEventHandlers: Object.assign(Object.assign({}, domEventHandlers), {
                click: (view, line, event)=>{
                    if (domEventHandlers.click && domEventHandlers.click(view, line, event)) return true;
                    let folded = $a97ccac5cf5f4f5d$var$findFold(view.state, line.from, line.to);
                    if (folded) {
                        view.dispatch({
                            effects: $a97ccac5cf5f4f5d$export$bf2507dc398fc1ab.of(folded)
                        });
                        return true;
                    }
                    let range = $a97ccac5cf5f4f5d$export$cbe8a3d55245b07d(view.state, line.from, line.to);
                    if (range) {
                        view.dispatch({
                            effects: $a97ccac5cf5f4f5d$export$a123efe007ad265.of(range)
                        });
                        return true;
                    }
                    return false;
                }
            })
        }),
        $a97ccac5cf5f4f5d$export$2c875b83a85d0f31()
    ];
}
const $a97ccac5cf5f4f5d$var$baseTheme$1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-foldPlaceholder": {
        backgroundColor: "#eee",
        border: "1px solid #ddd",
        color: "#888",
        borderRadius: ".2em",
        margin: "0 1px",
        padding: "0 1px",
        cursor: "pointer"
    },
    ".cm-foldGutter span": {
        padding: "0 1px",
        cursor: "pointer"
    }
});
/**
A highlight style associates CSS styles with higlighting
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag).
*/ class $a97ccac5cf5f4f5d$export$4819f093bdd5b4a {
    constructor(/**
    The tag styles used to create this highlight style.
    */ specs, options){
        this.specs = specs;
        let modSpec;
        function def(spec) {
            let cls = (0, $afd7c6da9f842a17$export$b920c662d2efee20).newName();
            (modSpec || (modSpec = Object.create(null)))["." + cls] = spec;
            return cls;
        }
        const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : undefined;
        const scopeOpt = options.scope;
        this.scope = scopeOpt instanceof $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a ? (type)=>type.prop($a97ccac5cf5f4f5d$export$27a2e78097f753f7) == scopeOpt.data : scopeOpt ? (type)=>type == scopeOpt : undefined;
        this.style = (0, $a1ec9d683d365521$export$b7f6332ce20f80fb)(specs.map((style)=>({
                tag: style.tag,
                class: style.class || def(Object.assign({}, style, {
                    tag: null
                }))
            })), {
            all: all
        }).style;
        this.module = modSpec ? new (0, $afd7c6da9f842a17$export$b920c662d2efee20)(modSpec) : null;
        this.themeType = options.themeType;
    }
    /**
    Create a highlighter style that associates the given styles to
    the given tags. The specs must be objects that hold a style tag
    or array of tags in their `tag` property, and either a single
    `class` property providing a static CSS class (for highlighter
    that rely on external styling), or a
    [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
    set of CSS properties (which define the styling for those tags).
    
    The CSS rules created for a highlighter will be emitted in the
    order of the spec's properties. That means that for elements that
    have multiple tags associated with them, styles defined further
    down in the list will have a higher CSS precedence than styles
    defined earlier.
    */ static define(specs, options) {
        return new $a97ccac5cf5f4f5d$export$4819f093bdd5b4a(specs, options || {});
    }
}
const $a97ccac5cf5f4f5d$var$highlighterFacet = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $a97ccac5cf5f4f5d$var$fallbackHighlighter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (values) {
        return values.length ? [
            values[0]
        ] : null;
    }
});
function $a97ccac5cf5f4f5d$var$getHighlighters(state) {
    let main = state.facet($a97ccac5cf5f4f5d$var$highlighterFacet);
    return main.length ? main : state.facet($a97ccac5cf5f4f5d$var$fallbackHighlighter);
}
/**
Wrap a highlighter in an editor extension that uses it to apply
syntax highlighting to the editor content.

When multiple (non-fallback) styles are provided, the styling
applied is the union of the classes they emit.
*/ function $a97ccac5cf5f4f5d$export$ec1b956ff3a16361(highlighter, options) {
    let ext = [
        $a97ccac5cf5f4f5d$var$treeHighlighter
    ], themeType;
    if (highlighter instanceof $a97ccac5cf5f4f5d$export$4819f093bdd5b4a) {
        if (highlighter.module) ext.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).styleModule.of(highlighter.module));
        themeType = highlighter.themeType;
    }
    if (options === null || options === void 0 ? void 0 : options.fallback) ext.push($a97ccac5cf5f4f5d$var$fallbackHighlighter.of(highlighter));
    else if (themeType) ext.push($a97ccac5cf5f4f5d$var$highlighterFacet.computeN([
        (0, $7beee9608540d2c3$export$eece2fccabbb77c5).darkTheme
    ], (state)=>{
        return state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).darkTheme) == (themeType == "dark") ? [
            highlighter
        ] : [];
    }));
    else ext.push($a97ccac5cf5f4f5d$var$highlighterFacet.of(highlighter));
    return ext;
}
/**
Returns the CSS classes (if any) that the highlighters active in
the state would assign to the given style
[tags](https://lezer.codemirror.net/docs/ref#highlight.Tag) and
(optional) language
[scope](https://codemirror.net/6/docs/ref/#language.HighlightStyle^define^options.scope).
*/ function $a97ccac5cf5f4f5d$export$8ca2b052028e8782(state, tags, scope) {
    let highlighters = $a97ccac5cf5f4f5d$var$getHighlighters(state);
    let result = null;
    if (highlighters) {
        for (let highlighter of highlighters)if (!highlighter.scope || scope && highlighter.scope(scope)) {
            let cls = highlighter.style(tags);
            if (cls) result = result ? result + " " + cls : cls;
        }
    }
    return result;
}
class $a97ccac5cf5f4f5d$var$TreeHighlighter {
    constructor(view){
        this.markCache = Object.create(null);
        this.tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.buildDeco(view, $a97ccac5cf5f4f5d$var$getHighlighters(view.state));
        this.decoratedTo = view.viewport.to;
    }
    update(update) {
        let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state), highlighters = $a97ccac5cf5f4f5d$var$getHighlighters(update.state);
        let styleChange = highlighters != $a97ccac5cf5f4f5d$var$getHighlighters(update.startState);
        let { viewport: viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
        if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
            this.decorations = this.decorations.map(update.changes);
            this.decoratedTo = decoratedToMapped;
        } else if (tree != this.tree || update.viewportChanged || styleChange) {
            this.tree = tree;
            this.decorations = this.buildDeco(update.view, highlighters);
            this.decoratedTo = viewport.to;
        }
    }
    buildDeco(view, highlighters) {
        if (!highlighters || !this.tree.length) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
        for (let { from: from, to: to } of view.visibleRanges)(0, $a1ec9d683d365521$export$af82b3d076119fad)(this.tree, highlighters, (from, to, style)=>{
            builder.add(from, to, this.markCache[style] || (this.markCache[style] = (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
                class: style
            })));
        }, from, to);
        return builder.finish();
    }
}
const $a97ccac5cf5f4f5d$var$treeHighlighter = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).high(/*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass($a97ccac5cf5f4f5d$var$TreeHighlighter, {
    decorations: (v)=>v.decorations
}));
/**
A default highlight style (works well with light themes).
*/ const $a97ccac5cf5f4f5d$export$bb02a6818dd48320 = /*@__PURE__*/ $a97ccac5cf5f4f5d$export$4819f093bdd5b4a.define([
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
        color: "#404740"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
        textDecoration: "underline"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading,
        textDecoration: "underline",
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
        color: "#708"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).url,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).contentSeparator,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName
        ],
        color: "#219"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).literal,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).inserted
        ],
        color: "#164"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).deleted
        ],
        color: "#a11"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string)
        ],
        color: "#e40"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
        color: "#00f"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).local((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
        color: "#30a"
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace
        ],
        color: "#085"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
        color: "#167"
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).macroName
        ],
        color: "#256"
    },
    {
        tag: /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
        color: "#00c"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).comment,
        color: "#940"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid,
        color: "#f00"
    }
]);
const $a97ccac5cf5f4f5d$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    "&.cm-focused .cm-matchingBracket": {
        backgroundColor: "#328c8252"
    },
    "&.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bb555544"
    }
});
const $a97ccac5cf5f4f5d$var$DefaultScanDist = 10000, $a97ccac5cf5f4f5d$var$DefaultBrackets = "()[]{}";
const $a97ccac5cf5f4f5d$var$bracketMatchingConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            afterCursor: true,
            brackets: $a97ccac5cf5f4f5d$var$DefaultBrackets,
            maxScanDistance: $a97ccac5cf5f4f5d$var$DefaultScanDist,
            renderMatch: $a97ccac5cf5f4f5d$var$defaultRenderMatch
        });
    }
});
const $a97ccac5cf5f4f5d$var$matchingMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-matchingBracket"
}), $a97ccac5cf5f4f5d$var$nonmatchingMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-nonmatchingBracket"
});
function $a97ccac5cf5f4f5d$var$defaultRenderMatch(match) {
    let decorations = [];
    let mark = match.matched ? $a97ccac5cf5f4f5d$var$matchingMark : $a97ccac5cf5f4f5d$var$nonmatchingMark;
    decorations.push(mark.range(match.start.from, match.start.to));
    if (match.end) decorations.push(mark.range(match.end.from, match.end.to));
    return decorations;
}
const $a97ccac5cf5f4f5d$var$bracketMatchingState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    },
    update (deco, tr) {
        if (!tr.docChanged && !tr.selection) return deco;
        let decorations = [];
        let config = tr.state.facet($a97ccac5cf5f4f5d$var$bracketMatchingConfig);
        for (let range of tr.state.selection.ranges){
            if (!range.empty) continue;
            let match = $a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head, -1, config) || range.head > 0 && $a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head - 1, 1, config) || config.afterCursor && ($a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head, 1, config) || range.head < tr.state.doc.length && $a97ccac5cf5f4f5d$export$3391942603e90cda(tr.state, range.head + 1, -1, config));
            if (match) decorations = decorations.concat(config.renderMatch(match, tr.state));
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(decorations, true);
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f)
});
const $a97ccac5cf5f4f5d$var$bracketMatchingUnique = [
    $a97ccac5cf5f4f5d$var$bracketMatchingState,
    $a97ccac5cf5f4f5d$var$baseTheme
];
/**
Create an extension that enables bracket matching. Whenever the
cursor is next to a bracket, that bracket and the one it matches
are highlighted. Or, when no matching bracket is found, another
highlighting style is used to indicate this.
*/ function $a97ccac5cf5f4f5d$export$cef7edfd214be605(config = {}) {
    return [
        $a97ccac5cf5f4f5d$var$bracketMatchingConfig.of(config),
        $a97ccac5cf5f4f5d$var$bracketMatchingUnique
    ];
}
/**
When larger syntax nodes, such as HTML tags, are marked as
opening/closing, it can be a bit messy to treat the whole node as
a matchable bracket. This node prop allows you to define, for such
a node, a ‘handle’—the part of the node that is highlighted, and
that the cursor must be on to activate highlighting in the first
place.
*/ const $a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011 = /*@__PURE__*/ new (0, $ed739beecf769914$export$b8034b9bc18acd90)();
function $a97ccac5cf5f4f5d$var$matchingNodes(node, dir, brackets) {
    let byProp = node.prop(dir < 0 ? (0, $ed739beecf769914$export$b8034b9bc18acd90).openedBy : (0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy);
    if (byProp) return byProp;
    if (node.name.length == 1) {
        let index = brackets.indexOf(node.name);
        if (index > -1 && index % 2 == (dir < 0 ? 1 : 0)) return [
            brackets[index + dir]
        ];
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$findHandle(node) {
    let hasHandle = node.type.prop($a97ccac5cf5f4f5d$export$ca7d74cd5b9f1011);
    return hasHandle ? hasHandle(node.node) : node;
}
/**
Find the matching bracket for the token at `pos`, scanning
direction `dir`. Only the `brackets` and `maxScanDistance`
properties are used from `config`, if given. Returns null if no
bracket was found at `pos`, or a match result otherwise.
*/ function $a97ccac5cf5f4f5d$export$3391942603e90cda(state, pos, dir, config = {}) {
    let maxScanDistance = config.maxScanDistance || $a97ccac5cf5f4f5d$var$DefaultScanDist, brackets = config.brackets || $a97ccac5cf5f4f5d$var$DefaultBrackets;
    let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(state), node = tree.resolveInner(pos, dir);
    for(let cur = node; cur; cur = cur.parent){
        let matches = $a97ccac5cf5f4f5d$var$matchingNodes(cur.type, dir, brackets);
        if (matches && cur.from < cur.to) {
            let handle = $a97ccac5cf5f4f5d$var$findHandle(cur);
            if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to)) return $a97ccac5cf5f4f5d$var$matchMarkedBrackets(state, pos, dir, cur, handle, matches, brackets);
        }
    }
    return $a97ccac5cf5f4f5d$var$matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function $a97ccac5cf5f4f5d$var$matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
    let parent = token.parent, firstToken = {
        from: handle.from,
        to: handle.to
    };
    let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
    if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to))) do if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
            let endHandle = $a97ccac5cf5f4f5d$var$findHandle(cursor);
            return {
                start: firstToken,
                end: endHandle ? {
                    from: endHandle.from,
                    to: endHandle.to
                } : undefined,
                matched: true
            };
        } else if ($a97ccac5cf5f4f5d$var$matchingNodes(cursor.type, dir, brackets)) depth++;
        else if ($a97ccac5cf5f4f5d$var$matchingNodes(cursor.type, -dir, brackets)) {
            if (depth == 0) {
                let endHandle = $a97ccac5cf5f4f5d$var$findHandle(cursor);
                return {
                    start: firstToken,
                    end: endHandle && endHandle.from < endHandle.to ? {
                        from: endHandle.from,
                        to: endHandle.to
                    } : undefined,
                    matched: false
                };
            }
            depth--;
        }
    }
    while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
    return {
        start: firstToken,
        matched: false
    };
}
function $a97ccac5cf5f4f5d$var$matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
    let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
    let bracket = brackets.indexOf(startCh);
    if (bracket < 0 || bracket % 2 == 0 != dir > 0) return null;
    let startToken = {
        from: dir < 0 ? pos - 1 : pos,
        to: dir > 0 ? pos + 1 : pos
    };
    let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
    for(let distance = 0; !iter.next().done && distance <= maxScanDistance;){
        let text = iter.value;
        if (dir < 0) distance += text.length;
        let basePos = pos + distance * dir;
        for(let pos = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos != end; pos += dir){
            let found = brackets.indexOf(text[pos]);
            if (found < 0 || tree.resolveInner(basePos + pos, 1).type != tokenType) continue;
            if (found % 2 == 0 == dir > 0) depth++;
            else if (depth == 1) return {
                start: startToken,
                end: {
                    from: basePos + pos,
                    to: basePos + pos + 1
                },
                matched: found >> 1 == bracket >> 1
            };
            else depth--;
        }
        if (dir > 0) distance += text.length;
    }
    return iter.done ? {
        start: startToken,
        matched: false
    } : null;
}
// Counts the column offset in a string, taking tabs into account.
// Used mostly to find indentation.
function $a97ccac5cf5f4f5d$var$countCol(string, end, tabSize, startIndex = 0, startValue = 0) {
    if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) end = string.length;
    }
    let n = startValue;
    for(let i = startIndex; i < end; i++)if (string.charCodeAt(i) == 9) n += tabSize - n % tabSize;
    else n++;
    return n;
}
/**
Encapsulates a single line of input. Given to stream syntax code,
which uses it to tokenize the content.
*/ class $a97ccac5cf5f4f5d$export$72a09304cc8c1940 {
    /**
    Create a stream.
    */ constructor(/**
    The line.
    */ string, tabSize, /**
    The current indent unit size.
    */ indentUnit, overrideIndent){
        this.string = string;
        this.tabSize = tabSize;
        this.indentUnit = indentUnit;
        this.overrideIndent = overrideIndent;
        /**
        The current position on the line.
        */ this.pos = 0;
        /**
        The start position of the current token.
        */ this.start = 0;
        this.lastColumnPos = 0;
        this.lastColumnValue = 0;
    }
    /**
    True if we are at the end of the line.
    */ eol() {
        return this.pos >= this.string.length;
    }
    /**
    True if we are at the start of the line.
    */ sol() {
        return this.pos == 0;
    }
    /**
    Get the next code unit after the current position, or undefined
    if we're at the end of the line.
    */ peek() {
        return this.string.charAt(this.pos) || undefined;
    }
    /**
    Read the next code unit and advance `this.pos`.
    */ next() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    /**
    Match the next character against the given string, regular
    expression, or predicate. Consume and return it if it matches.
    */ eat(match) {
        let ch = this.string.charAt(this.pos);
        let ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match instanceof RegExp ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    }
    /**
    Continue matching characters that match the given string,
    regular expression, or predicate function. Return true if any
    characters were consumed.
    */ eatWhile(match) {
        let start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    }
    /**
    Consume whitespace ahead of `this.pos`. Return true if any was
    found.
    */ eatSpace() {
        let start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this.pos;
        return this.pos > start;
    }
    /**
    Move to the end of the line.
    */ skipToEnd() {
        this.pos = this.string.length;
    }
    /**
    Move to directly before the given character, if found on the
    current line.
    */ skipTo(ch) {
        let found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    }
    /**
    Move back `n` characters.
    */ backUp(n) {
        this.pos -= n;
    }
    /**
    Get the column position at `this.pos`.
    */ column() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = $a97ccac5cf5f4f5d$var$countCol(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue;
    }
    /**
    Get the indentation column of the current line.
    */ indentation() {
        var _a;
        return (_a = this.overrideIndent) !== null && _a !== void 0 ? _a : $a97ccac5cf5f4f5d$var$countCol(this.string, null, this.tabSize);
    }
    /**
    Match the input against the given string or regular expression
    (which should start with a `^`). Return true or the regexp match
    if it matches.
    
    Unless `consume` is set to `false`, this will move `this.pos`
    past the matched text.
    
    When matching a string `caseInsensitive` can be set to true to
    make the match case-insensitive.
    */ match(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            let cased = (str)=>caseInsensitive ? str.toLowerCase() : str;
            let substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            } else return null;
        } else {
            let match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    }
    /**
    Get the current token.
    */ current() {
        return this.string.slice(this.start, this.pos);
    }
}
function $a97ccac5cf5f4f5d$var$fullParser(spec) {
    return {
        name: spec.name || "",
        token: spec.token,
        blankLine: spec.blankLine || (()=>{}),
        startState: spec.startState || (()=>true),
        copyState: spec.copyState || $a97ccac5cf5f4f5d$var$defaultCopyState,
        indent: spec.indent || (()=>null),
        languageData: spec.languageData || {},
        tokenTable: spec.tokenTable || $a97ccac5cf5f4f5d$var$noTokens
    };
}
function $a97ccac5cf5f4f5d$var$defaultCopyState(state) {
    if (typeof state != "object") return state;
    let newState = {};
    for(let prop in state){
        let val = state[prop];
        newState[prop] = val instanceof Array ? val.slice() : val;
    }
    return newState;
}
const $a97ccac5cf5f4f5d$var$IndentedFrom = /*@__PURE__*/ new WeakMap();
/**
A [language](https://codemirror.net/6/docs/ref/#language.Language) class based on a CodeMirror
5-style [streaming parser](https://codemirror.net/6/docs/ref/#language.StreamParser).
*/ class $a97ccac5cf5f4f5d$export$5ee3cc23916207d8 extends $a97ccac5cf5f4f5d$export$ce4fe1c9e6520c1a {
    constructor(parser){
        let data = $a97ccac5cf5f4f5d$export$b57f683f43553b99(parser.languageData);
        let p = $a97ccac5cf5f4f5d$var$fullParser(parser), self;
        let impl = new class extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
            createParse(input, fragments, ranges) {
                return new $a97ccac5cf5f4f5d$var$Parse(self, input, fragments, ranges);
            }
        };
        super(data, impl, [
            $a97ccac5cf5f4f5d$export$5952625dce50d1f3.of((cx, pos)=>this.getIndent(cx, pos))
        ], parser.name);
        this.topNode = $a97ccac5cf5f4f5d$var$docID(data);
        self = this;
        this.streamParser = p;
        this.stateAfter = new (0, $ed739beecf769914$export$b8034b9bc18acd90)({
            perNode: true
        });
        this.tokenTable = parser.tokenTable ? new $a97ccac5cf5f4f5d$var$TokenTable(p.tokenTable) : $a97ccac5cf5f4f5d$var$defaultTokenTable;
    }
    /**
    Define a stream language.
    */ static define(spec) {
        return new $a97ccac5cf5f4f5d$export$5ee3cc23916207d8(spec);
    }
    getIndent(cx, pos) {
        let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(cx.state), at = tree.resolve(pos);
        while(at && at.type != this.topNode)at = at.parent;
        if (!at) return null;
        let from = undefined;
        let { overrideIndentation: overrideIndentation } = cx.options;
        if (overrideIndentation) {
            from = $a97ccac5cf5f4f5d$var$IndentedFrom.get(cx.state);
            if (from != null && from < pos - 1e4) from = undefined;
        }
        let start = $a97ccac5cf5f4f5d$var$findState(this, tree, 0, at.from, from !== null && from !== void 0 ? from : pos), statePos, state;
        if (start) {
            state = start.state;
            statePos = start.pos + 1;
        } else {
            state = this.streamParser.startState(cx.unit);
            statePos = 0;
        }
        if (pos - statePos > 10000 /* C.MaxIndentScanDist */ ) return null;
        while(statePos < pos){
            let line = cx.state.doc.lineAt(statePos), end = Math.min(pos, line.to);
            if (line.length) {
                let indentation = overrideIndentation ? overrideIndentation(line.from) : -1;
                let stream = new $a97ccac5cf5f4f5d$export$72a09304cc8c1940(line.text, cx.state.tabSize, cx.unit, indentation < 0 ? undefined : indentation);
                while(stream.pos < end - line.from)$a97ccac5cf5f4f5d$var$readToken(this.streamParser.token, stream, state);
            } else this.streamParser.blankLine(state, cx.unit);
            if (end == pos) break;
            statePos = line.to + 1;
        }
        let line = cx.lineAt(pos);
        if (overrideIndentation && from == null) $a97ccac5cf5f4f5d$var$IndentedFrom.set(cx.state, line.from);
        return this.streamParser.indent(state, /^\s*(.*)/.exec(line.text)[1], cx);
    }
    get allowsNesting() {
        return false;
    }
}
function $a97ccac5cf5f4f5d$var$findState(lang, tree, off, startPos, before) {
    let state = off >= startPos && off + tree.length <= before && tree.prop(lang.stateAfter);
    if (state) return {
        state: lang.streamParser.copyState(state),
        pos: off + tree.length
    };
    for(let i = tree.children.length - 1; i >= 0; i--){
        let child = tree.children[i], pos = off + tree.positions[i];
        let found = child instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e) && pos < before && $a97ccac5cf5f4f5d$var$findState(lang, child, pos, startPos, before);
        if (found) return found;
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$cutTree(lang, tree, from, to, inside) {
    if (inside && from <= 0 && to >= tree.length) return tree;
    if (!inside && tree.type == lang.topNode) inside = true;
    for(let i = tree.children.length - 1; i >= 0; i--){
        let pos = tree.positions[i], child = tree.children[i], inner;
        if (pos < to && child instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) {
            if (!(inner = $a97ccac5cf5f4f5d$var$cutTree(lang, child, from - pos, to - pos, inside))) break;
            return !inside ? inner : new (0, $ed739beecf769914$export$7fbedc92909ed28e)(tree.type, tree.children.slice(0, i).concat(inner), tree.positions.slice(0, i + 1), pos + inner.length);
        }
    }
    return null;
}
function $a97ccac5cf5f4f5d$var$findStartInFragments(lang, fragments, startPos, editorState) {
    for (let f of fragments){
        let from = f.from + (f.openStart ? 25 : 0), to = f.to - (f.openEnd ? 25 : 0);
        let found = from <= startPos && to > startPos && $a97ccac5cf5f4f5d$var$findState(lang, f.tree, 0 - f.offset, startPos, to), tree;
        if (found && (tree = $a97ccac5cf5f4f5d$var$cutTree(lang, f.tree, startPos + f.offset, found.pos + f.offset, false))) return {
            state: found.state,
            tree: tree
        };
    }
    return {
        state: lang.streamParser.startState(editorState ? $a97ccac5cf5f4f5d$export$ad3205d09311a797(editorState) : 4),
        tree: (0, $ed739beecf769914$export$7fbedc92909ed28e).empty
    };
}
class $a97ccac5cf5f4f5d$var$Parse {
    constructor(lang, input, fragments, ranges){
        this.lang = lang;
        this.input = input;
        this.fragments = fragments;
        this.ranges = ranges;
        this.stoppedAt = null;
        this.chunks = [];
        this.chunkPos = [];
        this.chunk = [];
        this.chunkReused = undefined;
        this.rangeIndex = 0;
        this.to = ranges[ranges.length - 1].to;
        let context = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.get(), from = ranges[0].from;
        let { state: state, tree: tree } = $a97ccac5cf5f4f5d$var$findStartInFragments(lang, fragments, from, context === null || context === void 0 ? void 0 : context.state);
        this.state = state;
        this.parsedPos = this.chunkStart = from + tree.length;
        for(let i = 0; i < tree.children.length; i++){
            this.chunks.push(tree.children[i]);
            this.chunkPos.push(tree.positions[i]);
        }
        if (context && this.parsedPos < context.viewport.from - 100000 /* C.MaxDistanceBeforeViewport */ ) {
            this.state = this.lang.streamParser.startState($a97ccac5cf5f4f5d$export$ad3205d09311a797(context.state));
            context.skipUntilInView(this.parsedPos, context.viewport.from);
            this.parsedPos = context.viewport.from;
        }
        this.moveRangeIndex();
    }
    advance() {
        let context = $a97ccac5cf5f4f5d$export$3fcb7c01ff2a41fa.get();
        let parseEnd = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt);
        let end = Math.min(parseEnd, this.chunkStart + 2048 /* C.ChunkSize */ );
        if (context) end = Math.min(end, context.viewport.to);
        while(this.parsedPos < end)this.parseLine(context);
        if (this.chunkStart < this.parsedPos) this.finishChunk();
        if (this.parsedPos >= parseEnd) return this.finish();
        if (context && this.parsedPos >= context.viewport.to) {
            context.skipUntilInView(this.parsedPos, parseEnd);
            return this.finish();
        }
        return null;
    }
    stopAt(pos) {
        this.stoppedAt = pos;
    }
    lineAfter(pos) {
        let chunk = this.input.chunk(pos);
        if (!this.input.lineChunks) {
            let eol = chunk.indexOf("\n");
            if (eol > -1) chunk = chunk.slice(0, eol);
        } else if (chunk == "\n") chunk = "";
        return pos + chunk.length <= this.to ? chunk : chunk.slice(0, this.to - pos);
    }
    nextLine() {
        let from = this.parsedPos, line = this.lineAfter(from), end = from + line.length;
        for(let index = this.rangeIndex;;){
            let rangeEnd = this.ranges[index].to;
            if (rangeEnd >= end) break;
            line = line.slice(0, rangeEnd - (end - line.length));
            index++;
            if (index == this.ranges.length) break;
            let rangeStart = this.ranges[index].from;
            let after = this.lineAfter(rangeStart);
            line += after;
            end = rangeStart + after.length;
        }
        return {
            line: line,
            end: end
        };
    }
    skipGapsTo(pos, offset, side) {
        for(;;){
            let end = this.ranges[this.rangeIndex].to, offPos = pos + offset;
            if (side > 0 ? end > offPos : end >= offPos) break;
            let start = this.ranges[++this.rangeIndex].from;
            offset += start - end;
        }
        return offset;
    }
    moveRangeIndex() {
        while(this.ranges[this.rangeIndex].to < this.parsedPos)this.rangeIndex++;
    }
    emitToken(id, from, to, size, offset) {
        if (this.ranges.length > 1) {
            offset = this.skipGapsTo(from, offset, 1);
            from += offset;
            let len0 = this.chunk.length;
            offset = this.skipGapsTo(to, offset, -1);
            to += offset;
            size += this.chunk.length - len0;
        }
        this.chunk.push(id, from, to, size);
        return offset;
    }
    parseLine(context) {
        let { line: line, end: end } = this.nextLine(), offset = 0, { streamParser: streamParser } = this.lang;
        let stream = new $a97ccac5cf5f4f5d$export$72a09304cc8c1940(line, context ? context.state.tabSize : 4, context ? $a97ccac5cf5f4f5d$export$ad3205d09311a797(context.state) : 2);
        if (stream.eol()) streamParser.blankLine(this.state, stream.indentUnit);
        else while(!stream.eol()){
            let token = $a97ccac5cf5f4f5d$var$readToken(streamParser.token, stream, this.state);
            if (token) offset = this.emitToken(this.lang.tokenTable.resolve(token), this.parsedPos + stream.start, this.parsedPos + stream.pos, 4, offset);
            if (stream.start > 10000 /* C.MaxLineLength */ ) break;
        }
        this.parsedPos = end;
        this.moveRangeIndex();
        if (this.parsedPos < this.to) this.parsedPos++;
    }
    finishChunk() {
        let tree = (0, $ed739beecf769914$export$7fbedc92909ed28e).build({
            buffer: this.chunk,
            start: this.chunkStart,
            length: this.parsedPos - this.chunkStart,
            nodeSet: $a97ccac5cf5f4f5d$var$nodeSet,
            topID: 0,
            maxBufferLength: 2048 /* C.ChunkSize */ ,
            reused: this.chunkReused
        });
        tree = new (0, $ed739beecf769914$export$7fbedc92909ed28e)(tree.type, tree.children, tree.positions, tree.length, [
            [
                this.lang.stateAfter,
                this.lang.streamParser.copyState(this.state)
            ]
        ]);
        this.chunks.push(tree);
        this.chunkPos.push(this.chunkStart - this.ranges[0].from);
        this.chunk = [];
        this.chunkReused = undefined;
        this.chunkStart = this.parsedPos;
    }
    finish() {
        return new (0, $ed739beecf769914$export$7fbedc92909ed28e)(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
}
function $a97ccac5cf5f4f5d$var$readToken(token, stream, state) {
    stream.start = stream.pos;
    for(let i = 0; i < 10; i++){
        let result = token(stream, state);
        if (stream.pos > stream.start) return result;
    }
    throw new Error("Stream parser failed to advance stream.");
}
const $a97ccac5cf5f4f5d$var$noTokens = /*@__PURE__*/ Object.create(null);
const $a97ccac5cf5f4f5d$var$typeArray = [
    (0, $ed739beecf769914$export$f06e977173f1857c).none
];
const $a97ccac5cf5f4f5d$var$nodeSet = /*@__PURE__*/ new (0, $ed739beecf769914$export$7fad5fb00d8de02c)($a97ccac5cf5f4f5d$var$typeArray);
const $a97ccac5cf5f4f5d$var$warned = [];
// Cache of node types by name and tags
const $a97ccac5cf5f4f5d$var$byTag = /*@__PURE__*/ Object.create(null);
const $a97ccac5cf5f4f5d$var$defaultTable = /*@__PURE__*/ Object.create(null);
for (let [legacyName, name] of [
    [
        "variable",
        "variableName"
    ],
    [
        "variable-2",
        "variableName.special"
    ],
    [
        "string-2",
        "string.special"
    ],
    [
        "def",
        "variableName.definition"
    ],
    [
        "tag",
        "tagName"
    ],
    [
        "attribute",
        "attributeName"
    ],
    [
        "type",
        "typeName"
    ],
    [
        "builtin",
        "variableName.standard"
    ],
    [
        "qualifier",
        "modifier"
    ],
    [
        "error",
        "invalid"
    ],
    [
        "header",
        "heading"
    ],
    [
        "property",
        "propertyName"
    ]
])$a97ccac5cf5f4f5d$var$defaultTable[legacyName] = /*@__PURE__*/ $a97ccac5cf5f4f5d$var$createTokenType($a97ccac5cf5f4f5d$var$noTokens, name);
class $a97ccac5cf5f4f5d$var$TokenTable {
    constructor(extra){
        this.extra = extra;
        this.table = Object.assign(Object.create(null), $a97ccac5cf5f4f5d$var$defaultTable);
    }
    resolve(tag) {
        return !tag ? 0 : this.table[tag] || (this.table[tag] = $a97ccac5cf5f4f5d$var$createTokenType(this.extra, tag));
    }
}
const $a97ccac5cf5f4f5d$var$defaultTokenTable = /*@__PURE__*/ new $a97ccac5cf5f4f5d$var$TokenTable($a97ccac5cf5f4f5d$var$noTokens);
function $a97ccac5cf5f4f5d$var$warnForPart(part, msg) {
    if ($a97ccac5cf5f4f5d$var$warned.indexOf(part) > -1) return;
    $a97ccac5cf5f4f5d$var$warned.push(part);
    console.warn(msg);
}
function $a97ccac5cf5f4f5d$var$createTokenType(extra, tagStr) {
    let tags$1 = [];
    for (let name of tagStr.split(" ")){
        let found = [];
        for (let part of name.split(".")){
            let value = extra[part] || (0, $a1ec9d683d365521$export$8b7a896ae75accbf)[part];
            if (!value) $a97ccac5cf5f4f5d$var$warnForPart(part, `Unknown highlighting tag ${part}`);
            else if (typeof value == "function") {
                if (!found.length) $a97ccac5cf5f4f5d$var$warnForPart(part, `Modifier ${part} used at start of tag`);
                else found = found.map(value);
            } else if (found.length) $a97ccac5cf5f4f5d$var$warnForPart(part, `Tag ${part} used as modifier`);
            else found = Array.isArray(value) ? value : [
                value
            ];
        }
        for (let tag of found)tags$1.push(tag);
    }
    if (!tags$1.length) return 0;
    let name = tagStr.replace(/ /g, "_"), key = name + " " + tags$1.map((t)=>t.id);
    let known = $a97ccac5cf5f4f5d$var$byTag[key];
    if (known) return known.id;
    let type = $a97ccac5cf5f4f5d$var$byTag[key] = (0, $ed739beecf769914$export$f06e977173f1857c).define({
        id: $a97ccac5cf5f4f5d$var$typeArray.length,
        name: name,
        props: [
            (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
                [name]: tags$1
            })
        ]
    });
    $a97ccac5cf5f4f5d$var$typeArray.push(type);
    return type.id;
}
function $a97ccac5cf5f4f5d$var$docID(data) {
    let type = (0, $ed739beecf769914$export$f06e977173f1857c).define({
        id: $a97ccac5cf5f4f5d$var$typeArray.length,
        name: "Document",
        props: [
            $a97ccac5cf5f4f5d$export$27a2e78097f753f7.add(()=>data)
        ],
        top: true
    });
    $a97ccac5cf5f4f5d$var$typeArray.push(type);
    return type;
}
function $a97ccac5cf5f4f5d$var$buildForLine(line) {
    return line.length <= 4096 && /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/.test(line);
}
function $a97ccac5cf5f4f5d$var$textHasRTL(text) {
    for(let i = text.iter(); !i.next().done;)if ($a97ccac5cf5f4f5d$var$buildForLine(i.value)) return true;
    return false;
}
function $a97ccac5cf5f4f5d$var$changeAddsRTL(change) {
    let added = false;
    change.iterChanges((fA, tA, fB, tB, ins)=>{
        if (!added && $a97ccac5cf5f4f5d$var$textHasRTL(ins)) added = true;
    });
    return added;
}
const $a97ccac5cf5f4f5d$var$alwaysIsolate = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine: (values)=>values.some((x)=>x)
});
/**
Make sure nodes
[marked](https://lezer.codemirror.net/docs/ref/#common.NodeProp^isolate)
as isolating for bidirectional text are rendered in a way that
isolates them from the surrounding text.
*/ function $a97ccac5cf5f4f5d$export$9c455d2bd760f210(options = {}) {
    let extensions = [
        $a97ccac5cf5f4f5d$var$isolateMarks
    ];
    if (options.alwaysIsolate) extensions.push($a97ccac5cf5f4f5d$var$alwaysIsolate.of(true));
    return extensions;
}
const $a97ccac5cf5f4f5d$var$isolateMarks = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.always = view.state.facet($a97ccac5cf5f4f5d$var$alwaysIsolate) || view.textDirection != (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR || view.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).perLineTextDirection);
        this.hasRTL = !this.always && $a97ccac5cf5f4f5d$var$textHasRTL(view.state.doc);
        this.tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(view.state);
        this.decorations = this.always || this.hasRTL ? $a97ccac5cf5f4f5d$var$buildDeco(view, this.tree, this.always) : (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
    }
    update(update) {
        let always = update.state.facet($a97ccac5cf5f4f5d$var$alwaysIsolate) || update.view.textDirection != (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR || update.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).perLineTextDirection);
        if (!always && !this.hasRTL && $a97ccac5cf5f4f5d$var$changeAddsRTL(update.changes)) this.hasRTL = true;
        if (!always && !this.hasRTL) return;
        let tree = $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1(update.state);
        if (always != this.always || tree != this.tree || update.docChanged || update.viewportChanged) {
            this.tree = tree;
            this.always = always;
            this.decorations = $a97ccac5cf5f4f5d$var$buildDeco(update.view, tree, always);
        }
    }
}, {
    provide: (plugin)=>{
        function access(view) {
            var _a, _b;
            return (_b = (_a = view.plugin(plugin)) === null || _a === void 0 ? void 0 : _a.decorations) !== null && _b !== void 0 ? _b : (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        }
        return [
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).outerDecorations.of(access),
            (0, $6295c6875f57e3ee$export$b92464a736444411).lowest((0, $7beee9608540d2c3$export$eece2fccabbb77c5).bidiIsolatedRanges.of(access))
        ];
    }
});
function $a97ccac5cf5f4f5d$var$buildDeco(view, tree, always) {
    let deco = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
    let ranges = view.visibleRanges;
    if (!always) ranges = $a97ccac5cf5f4f5d$var$clipRTLLines(ranges, view.state.doc);
    for (let { from: from, to: to } of ranges)tree.iterate({
        enter: (node)=>{
            let iso = node.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).isolate);
            if (iso) deco.add(node.from, node.to, $a97ccac5cf5f4f5d$var$marks[iso]);
        },
        from: from,
        to: to
    });
    return deco.finish();
}
function $a97ccac5cf5f4f5d$var$clipRTLLines(ranges, doc) {
    let cur = doc.iter(), pos = 0, result = [], last = null;
    for (let { from: from, to: to } of ranges){
        if (last && last.to > from) {
            from = last.to;
            if (from >= to) continue;
        }
        if (pos + cur.value.length < from) {
            cur.next(from - (pos + cur.value.length));
            pos = from;
        }
        for(;;){
            let start = pos, end = pos + cur.value.length;
            if (!cur.lineBreak && $a97ccac5cf5f4f5d$var$buildForLine(cur.value)) {
                if (last && last.to > start - 10) last.to = Math.min(to, end);
                else result.push(last = {
                    from: start,
                    to: Math.min(to, end)
                });
            }
            if (end >= to) break;
            pos = end;
            cur.next();
        }
    }
    return result;
}
const $a97ccac5cf5f4f5d$var$marks = {
    rtl: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "rtl"
        },
        bidiIsolate: (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).RTL
    }),
    ltr: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "ltr"
        },
        bidiIsolate: (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR
    }),
    auto: /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
        class: "cm-iso",
        inclusive: true,
        attributes: {
            dir: "auto"
        },
        bidiIsolate: null
    })
};



/**
Comment or uncomment the current selection. Will use line comments
if available, otherwise falling back to block comments.
*/ const $032754016b6293d7$export$afbcdd0bff36c567 = (target)=>{
    let { state: state } = target, line = state.doc.lineAt(state.selection.main.from), config = $032754016b6293d7$var$getConfig(target.state, line.from);
    return config.line ? $032754016b6293d7$export$63a9abf96aaa3c5d(target) : config.block ? $032754016b6293d7$export$e88d9eff7cafcc34(target) : false;
};
function $032754016b6293d7$var$command(f, option) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let tr = f(option, state);
        if (!tr) return false;
        dispatch(state.update(tr));
        return true;
    };
}
/**
Comment or uncomment the current selection using line comments.
The line comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $032754016b6293d7$export$63a9abf96aaa3c5d = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using line comments.
*/ const $032754016b6293d7$export$5d080f5a78d4f5b3 = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using line comments.
*/ const $032754016b6293d7$export$5a43b8c36509b6fd = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeLineComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the current selection using block comments.
The block comment syntax is taken from the
[`commentTokens`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) [language
data](https://codemirror.net/6/docs/ref/#state.EditorState.languageDataAt).
*/ const $032754016b6293d7$export$19d6fa84ce3a55ab = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 0 /* CommentOption.Toggle */ );
/**
Comment the current selection using block comments.
*/ const $032754016b6293d7$export$f2ae215066c4835a = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 1 /* CommentOption.Comment */ );
/**
Uncomment the current selection using block comments.
*/ const $032754016b6293d7$export$fddcfb23c3a05835 = /*@__PURE__*/ $032754016b6293d7$var$command($032754016b6293d7$var$changeBlockComment, 2 /* CommentOption.Uncomment */ );
/**
Comment or uncomment the lines around the current selection using
block comments.
*/ const $032754016b6293d7$export$e88d9eff7cafcc34 = /*@__PURE__*/ $032754016b6293d7$var$command((o, s)=>$032754016b6293d7$var$changeBlockComment(o, s, $032754016b6293d7$var$selectedLineRanges(s)), 0 /* CommentOption.Toggle */ );
function $032754016b6293d7$var$getConfig(state, pos) {
    let data = state.languageDataAt("commentTokens", pos);
    return data.length ? data[0] : {};
}
const $032754016b6293d7$var$SearchMargin = 50;
/**
Determines if the given range is block-commented in the given
state.
*/ function $032754016b6293d7$var$findBlockComment(state, { open: open, close: close }, from, to) {
    let textBefore = state.sliceDoc(from - $032754016b6293d7$var$SearchMargin, from);
    let textAfter = state.sliceDoc(to, to + $032754016b6293d7$var$SearchMargin);
    let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
    let beforeOff = textBefore.length - spaceBefore;
    if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) return {
        open: {
            pos: from - spaceBefore,
            margin: spaceBefore && 1
        },
        close: {
            pos: to + spaceAfter,
            margin: spaceAfter && 1
        }
    };
    let startText, endText;
    if (to - from <= 2 * $032754016b6293d7$var$SearchMargin) startText = endText = state.sliceDoc(from, to);
    else {
        startText = state.sliceDoc(from, from + $032754016b6293d7$var$SearchMargin);
        endText = state.sliceDoc(to - $032754016b6293d7$var$SearchMargin, to);
    }
    let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
    let endOff = endText.length - endSpace - close.length;
    if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) return {
        open: {
            pos: from + startSpace + open.length,
            margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
        },
        close: {
            pos: to - endSpace - close.length,
            margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
        }
    };
    return null;
}
function $032754016b6293d7$var$selectedLineRanges(state) {
    let ranges = [];
    for (let r of state.selection.ranges){
        let fromLine = state.doc.lineAt(r.from);
        let toLine = r.to <= fromLine.to ? fromLine : state.doc.lineAt(r.to);
        let last = ranges.length - 1;
        if (last >= 0 && ranges[last].to > fromLine.from) ranges[last].to = toLine.to;
        else ranges.push({
            from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length,
            to: toLine.to
        });
    }
    return ranges;
}
// Performs toggle, comment and uncomment of block comments in
// languages that support them.
function $032754016b6293d7$var$changeBlockComment(option, state, ranges = state.selection.ranges) {
    let tokens = ranges.map((r)=>$032754016b6293d7$var$getConfig(state, r.from).block);
    if (!tokens.every((c)=>c)) return null;
    let comments = ranges.map((r, i)=>$032754016b6293d7$var$findBlockComment(state, tokens[i], r.from, r.to));
    if (option != 2 /* CommentOption.Uncomment */  && !comments.every((c)=>c)) return {
        changes: state.changes(ranges.map((range, i)=>{
            if (comments[i]) return [];
            return [
                {
                    from: range.from,
                    insert: tokens[i].open + " "
                },
                {
                    from: range.to,
                    insert: " " + tokens[i].close
                }
            ];
        }))
    };
    else if (option != 1 /* CommentOption.Comment */  && comments.some((c)=>c)) {
        let changes = [];
        for(let i = 0, comment; i < comments.length; i++)if (comment = comments[i]) {
            let token = tokens[i], { open: open, close: close } = comment;
            changes.push({
                from: open.pos - token.open.length,
                to: open.pos + open.margin
            }, {
                from: close.pos - close.margin,
                to: close.pos + token.close.length
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
// Performs toggle, comment and uncomment of line comments.
function $032754016b6293d7$var$changeLineComment(option, state, ranges = state.selection.ranges) {
    let lines = [];
    let prevLine = -1;
    for (let { from: from, to: to } of ranges){
        let startI = lines.length, minIndent = 1e9;
        let token = $032754016b6293d7$var$getConfig(state, from).line;
        if (!token) continue;
        for(let pos = from; pos <= to;){
            let line = state.doc.lineAt(pos);
            if (line.from > prevLine && (from == to || to > line.from)) {
                prevLine = line.from;
                let indent = /^\s*/.exec(line.text)[0].length;
                let empty = indent == line.length;
                let comment = line.text.slice(indent, indent + token.length) == token ? indent : -1;
                if (indent < line.text.length && indent < minIndent) minIndent = indent;
                lines.push({
                    line: line,
                    comment: comment,
                    token: token,
                    indent: indent,
                    empty: empty,
                    single: false
                });
            }
            pos = line.to + 1;
        }
        if (minIndent < 1e9) {
            for(let i = startI; i < lines.length; i++)if (lines[i].indent < lines[i].line.text.length) lines[i].indent = minIndent;
        }
        if (lines.length == startI + 1) lines[startI].single = true;
    }
    if (option != 2 /* CommentOption.Uncomment */  && lines.some((l)=>l.comment < 0 && (!l.empty || l.single))) {
        let changes = [];
        for (let { line: line, token: token, indent: indent, empty: empty, single: single } of lines)if (single || !empty) changes.push({
            from: line.from + indent,
            insert: token + " "
        });
        let changeSet = state.changes(changes);
        return {
            changes: changeSet,
            selection: state.selection.map(changeSet, 1)
        };
    } else if (option != 1 /* CommentOption.Comment */  && lines.some((l)=>l.comment >= 0)) {
        let changes = [];
        for (let { line: line, comment: comment, token: token } of lines)if (comment >= 0) {
            let from = line.from + comment, to = from + token.length;
            if (line.text[to - line.from] == " ") to++;
            changes.push({
                from: from,
                to: to
            });
        }
        return {
            changes: changes
        };
    }
    return null;
}
const $032754016b6293d7$var$fromHistory = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
Transaction annotation that will prevent that transaction from
being combined with other transactions in the undo history. Given
`"before"`, it'll prevent merging with previous transactions. With
`"after"`, subsequent transactions won't be combined with this
one. With `"full"`, the transaction is isolated on both sides.
*/ const $032754016b6293d7$export$33e0bb25992f9954 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
This facet provides a way to register functions that, given a
transaction, provide a set of effects that the history should
store when inverting the transaction. This can be used to
integrate some kinds of effects in the history, so that they can
be undone (and redone again).
*/ const $032754016b6293d7$export$edb12867fb9b2023 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define();
const $032754016b6293d7$var$historyConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            minDepth: 100,
            newGroupDelay: 500,
            joinToEvent: (_t, isAdjacent)=>isAdjacent
        }, {
            minDepth: Math.max,
            newGroupDelay: Math.min,
            joinToEvent: (a, b)=>(tr, adj)=>a(tr, adj) || b(tr, adj)
        });
    }
});
const $032754016b6293d7$var$historyField_ = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return $032754016b6293d7$var$HistoryState.empty;
    },
    update (state, tr) {
        let config = tr.state.facet($032754016b6293d7$var$historyConfig);
        let fromHist = tr.annotation($032754016b6293d7$var$fromHistory);
        if (fromHist) {
            let item = $032754016b6293d7$var$HistEvent.fromTransaction(tr, fromHist.selection), from = fromHist.side;
            let other = from == 0 /* BranchName.Done */  ? state.undone : state.done;
            if (item) other = $032754016b6293d7$var$updateBranch(other, other.length, config.minDepth, item);
            else other = $032754016b6293d7$var$addSelection(other, tr.startState.selection);
            return new $032754016b6293d7$var$HistoryState(from == 0 /* BranchName.Done */  ? fromHist.rest : other, from == 0 /* BranchName.Done */  ? other : fromHist.rest);
        }
        let isolate = tr.annotation($032754016b6293d7$export$33e0bb25992f9954);
        if (isolate == "full" || isolate == "before") state = state.isolate();
        if (tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).addToHistory) === false) return !tr.changes.empty ? state.addMapping(tr.changes.desc) : state;
        let event = $032754016b6293d7$var$HistEvent.fromTransaction(tr);
        let time = tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).time), userEvent = tr.annotation((0, $6295c6875f57e3ee$export$febc5573c75cefb0).userEvent);
        if (event) state = state.addChanges(event, time, userEvent, config, tr);
        else if (tr.selection) state = state.addSelection(tr.startState.selection, time, userEvent, config.newGroupDelay);
        if (isolate == "full" || isolate == "after") state = state.isolate();
        return state;
    },
    toJSON (value) {
        return {
            done: value.done.map((e)=>e.toJSON()),
            undone: value.undone.map((e)=>e.toJSON())
        };
    },
    fromJSON (json) {
        return new $032754016b6293d7$var$HistoryState(json.done.map($032754016b6293d7$var$HistEvent.fromJSON), json.undone.map($032754016b6293d7$var$HistEvent.fromJSON));
    }
});
/**
Create a history extension with the given configuration.
*/ function $032754016b6293d7$export$55abd4691b317664(config = {}) {
    return [
        $032754016b6293d7$var$historyField_,
        $032754016b6293d7$var$historyConfig.of(config),
        (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
            beforeinput (e, view) {
                let command = e.inputType == "historyUndo" ? $032754016b6293d7$export$21f930c44940fd98 : e.inputType == "historyRedo" ? $032754016b6293d7$export$1688e416fee0a49e : null;
                if (!command) return false;
                e.preventDefault();
                return command(view);
            }
        })
    ];
}
/**
The state field used to store the history data. Should probably
only be used when you want to
[serialize](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) or
[deserialize](https://codemirror.net/6/docs/ref/#state.EditorState^fromJSON) state objects in a way
that preserves history.
*/ const $032754016b6293d7$export$c00598b6ceeb3e9 = $032754016b6293d7$var$historyField_;
function $032754016b6293d7$var$cmd(side, selection) {
    return function({ state: state, dispatch: dispatch }) {
        if (!selection && state.readOnly) return false;
        let historyState = state.field($032754016b6293d7$var$historyField_, false);
        if (!historyState) return false;
        let tr = historyState.pop(side, state, selection);
        if (!tr) return false;
        dispatch(tr);
        return true;
    };
}
/**
Undo a single group of history events. Returns false if no group
was available.
*/ const $032754016b6293d7$export$21f930c44940fd98 = /*@__PURE__*/ $032754016b6293d7$var$cmd(0 /* BranchName.Done */ , false);
/**
Redo a group of history events. Returns false if no group was
available.
*/ const $032754016b6293d7$export$1688e416fee0a49e = /*@__PURE__*/ $032754016b6293d7$var$cmd(1 /* BranchName.Undone */ , false);
/**
Undo a change or selection change.
*/ const $032754016b6293d7$export$43103d47530fe49f = /*@__PURE__*/ $032754016b6293d7$var$cmd(0 /* BranchName.Done */ , true);
/**
Redo a change or selection change.
*/ const $032754016b6293d7$export$2d87af80f1777f20 = /*@__PURE__*/ $032754016b6293d7$var$cmd(1 /* BranchName.Undone */ , true);
function $032754016b6293d7$var$depth(side) {
    return function(state) {
        let histState = state.field($032754016b6293d7$var$historyField_, false);
        if (!histState) return 0;
        let branch = side == 0 /* BranchName.Done */  ? histState.done : histState.undone;
        return branch.length - (branch.length && !branch[0].changes ? 1 : 0);
    };
}
/**
The amount of undoable change events available in a given state.
*/ const $032754016b6293d7$export$f8a176c2b9a10bdb = /*@__PURE__*/ $032754016b6293d7$var$depth(0 /* BranchName.Done */ );
/**
The amount of redoable change events available in a given state.
*/ const $032754016b6293d7$export$3ffe6b288e7d941b = /*@__PURE__*/ $032754016b6293d7$var$depth(1 /* BranchName.Undone */ );
// History events store groups of changes or effects that need to be
// undone/redone together.
class $032754016b6293d7$var$HistEvent {
    constructor(// The changes in this event. Normal events hold at least one
    // change or effect. But it may be necessary to store selection
    // events before the first change, in which case a special type of
    // instance is created which doesn't hold any changes, with
    // changes == startSelection == undefined
    changes, // The effects associated with this event
    effects, // Accumulated mapping (from addToHistory==false) that should be
    // applied to events below this one.
    mapped, // The selection before this event
    startSelection, // Stores selection changes after this event, to be used for
    // selection undo/redo.
    selectionsAfter){
        this.changes = changes;
        this.effects = effects;
        this.mapped = mapped;
        this.startSelection = startSelection;
        this.selectionsAfter = selectionsAfter;
    }
    setSelAfter(after) {
        return new $032754016b6293d7$var$HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
    }
    toJSON() {
        var _a, _b, _c;
        return {
            changes: (_a = this.changes) === null || _a === void 0 ? void 0 : _a.toJSON(),
            mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
            startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
            selectionsAfter: this.selectionsAfter.map((s)=>s.toJSON())
        };
    }
    static fromJSON(json) {
        return new $032754016b6293d7$var$HistEvent(json.changes && (0, $6295c6875f57e3ee$export$29d7fbdcb1f8b71c).fromJSON(json.changes), [], json.mapped && (0, $6295c6875f57e3ee$export$34b6a936f2bb06a2).fromJSON(json.mapped), json.startSelection && (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).fromJSON(json.startSelection), json.selectionsAfter.map((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).fromJSON));
    }
    // This does not check `addToHistory` and such, it assumes the
    // transaction needs to be converted to an item. Returns null when
    // there are no changes or effects in the transaction.
    static fromTransaction(tr, selection) {
        let effects = $032754016b6293d7$var$none;
        for (let invert of tr.startState.facet($032754016b6293d7$export$edb12867fb9b2023)){
            let result = invert(tr);
            if (result.length) effects = effects.concat(result);
        }
        if (!effects.length && tr.changes.empty) return null;
        return new $032754016b6293d7$var$HistEvent(tr.changes.invert(tr.startState.doc), effects, undefined, selection || tr.startState.selection, $032754016b6293d7$var$none);
    }
    static selection(selections) {
        return new $032754016b6293d7$var$HistEvent(undefined, $032754016b6293d7$var$none, undefined, undefined, selections);
    }
}
function $032754016b6293d7$var$updateBranch(branch, to, maxLen, newEvent) {
    let start = to + 1 > maxLen + 20 ? to - maxLen - 1 : 0;
    let newBranch = branch.slice(start, to);
    newBranch.push(newEvent);
    return newBranch;
}
function $032754016b6293d7$var$isAdjacent(a, b) {
    let ranges = [], isAdjacent = false;
    a.iterChangedRanges((f, t)=>ranges.push(f, t));
    b.iterChangedRanges((_f, _t, f, t)=>{
        for(let i = 0; i < ranges.length;){
            let from = ranges[i++], to = ranges[i++];
            if (t >= from && f <= to) isAdjacent = true;
        }
    });
    return isAdjacent;
}
function $032754016b6293d7$var$eqSelectionShape(a, b) {
    return a.ranges.length == b.ranges.length && a.ranges.filter((r, i)=>r.empty != b.ranges[i].empty).length === 0;
}
function $032754016b6293d7$var$conc(a, b) {
    return !a.length ? b : !b.length ? a : a.concat(b);
}
const $032754016b6293d7$var$none = [];
const $032754016b6293d7$var$MaxSelectionsPerEvent = 200;
function $032754016b6293d7$var$addSelection(branch, selection) {
    if (!branch.length) return [
        $032754016b6293d7$var$HistEvent.selection([
            selection
        ])
    ];
    else {
        let lastEvent = branch[branch.length - 1];
        let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - $032754016b6293d7$var$MaxSelectionsPerEvent));
        if (sels.length && sels[sels.length - 1].eq(selection)) return branch;
        sels.push(selection);
        return $032754016b6293d7$var$updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
    }
}
// Assumes the top item has one or more selectionAfter values
function $032754016b6293d7$var$popSelection(branch) {
    let last = branch[branch.length - 1];
    let newBranch = branch.slice();
    newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
    return newBranch;
}
// Add a mapping to the top event in the given branch. If this maps
// away all the changes and effects in that item, drop it and
// propagate the mapping to the next item.
function $032754016b6293d7$var$addMappingToBranch(branch, mapping) {
    if (!branch.length) return branch;
    let length = branch.length, selections = $032754016b6293d7$var$none;
    while(length){
        let event = $032754016b6293d7$var$mapEvent(branch[length - 1], mapping, selections);
        if (event.changes && !event.changes.empty || event.effects.length) {
            let result = branch.slice(0, length);
            result[length - 1] = event;
            return result;
        } else {
            mapping = event.mapped;
            length--;
            selections = event.selectionsAfter;
        }
    }
    return selections.length ? [
        $032754016b6293d7$var$HistEvent.selection(selections)
    ] : $032754016b6293d7$var$none;
}
function $032754016b6293d7$var$mapEvent(event, mapping, extraSelections) {
    let selections = $032754016b6293d7$var$conc(event.selectionsAfter.length ? event.selectionsAfter.map((s)=>s.map(mapping)) : $032754016b6293d7$var$none, extraSelections);
    // Change-less events don't store mappings (they are always the last event in a branch)
    if (!event.changes) return $032754016b6293d7$var$HistEvent.selection(selections);
    let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
    let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
    return new $032754016b6293d7$var$HistEvent(mappedChanges, (0, $6295c6875f57e3ee$export$95000d4efaa4321f).mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const $032754016b6293d7$var$joinableUserEvent = /^(input\.type|delete)($|\.)/;
class $032754016b6293d7$var$HistoryState {
    constructor(done, undone, prevTime = 0, prevUserEvent){
        this.done = done;
        this.undone = undone;
        this.prevTime = prevTime;
        this.prevUserEvent = prevUserEvent;
    }
    isolate() {
        return this.prevTime ? new $032754016b6293d7$var$HistoryState(this.done, this.undone) : this;
    }
    addChanges(event, time, userEvent, config, tr) {
        let done = this.done, lastEvent = done[done.length - 1];
        if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || $032754016b6293d7$var$joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config.newGroupDelay && config.joinToEvent(tr, $032754016b6293d7$var$isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
        userEvent == "input.type.compose")) done = $032754016b6293d7$var$updateBranch(done, done.length - 1, config.minDepth, new $032754016b6293d7$var$HistEvent(event.changes.compose(lastEvent.changes), $032754016b6293d7$var$conc(event.effects, lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, $032754016b6293d7$var$none));
        else done = $032754016b6293d7$var$updateBranch(done, done.length, config.minDepth, event);
        return new $032754016b6293d7$var$HistoryState(done, $032754016b6293d7$var$none, time, userEvent);
    }
    addSelection(selection, time, userEvent, newGroupDelay) {
        let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : $032754016b6293d7$var$none;
        if (last.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && $032754016b6293d7$var$eqSelectionShape(last[last.length - 1], selection)) return this;
        return new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$addSelection(this.done, selection), this.undone, time, userEvent);
    }
    addMapping(mapping) {
        return new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$addMappingToBranch(this.done, mapping), $032754016b6293d7$var$addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
    }
    pop(side, state, onlySelection) {
        let branch = side == 0 /* BranchName.Done */  ? this.done : this.undone;
        if (branch.length == 0) return null;
        let event = branch[branch.length - 1], selection = event.selectionsAfter[0] || state.selection;
        if (onlySelection && event.selectionsAfter.length) return state.update({
            selection: event.selectionsAfter[event.selectionsAfter.length - 1],
            annotations: $032754016b6293d7$var$fromHistory.of({
                side: side,
                rest: $032754016b6293d7$var$popSelection(branch),
                selection: selection
            }),
            userEvent: side == 0 /* BranchName.Done */  ? "select.undo" : "select.redo",
            scrollIntoView: true
        });
        else if (!event.changes) return null;
        else {
            let rest = branch.length == 1 ? $032754016b6293d7$var$none : branch.slice(0, branch.length - 1);
            if (event.mapped) rest = $032754016b6293d7$var$addMappingToBranch(rest, event.mapped);
            return state.update({
                changes: event.changes,
                selection: event.startSelection,
                effects: event.effects,
                annotations: $032754016b6293d7$var$fromHistory.of({
                    side: side,
                    rest: rest,
                    selection: selection
                }),
                filter: false,
                userEvent: side == 0 /* BranchName.Done */  ? "undo" : "redo",
                scrollIntoView: true
            });
        }
    }
}
$032754016b6293d7$var$HistoryState.empty = /*@__PURE__*/ new $032754016b6293d7$var$HistoryState($032754016b6293d7$var$none, $032754016b6293d7$var$none);
/**
Default key bindings for the undo history.

- Mod-z: [`undo`](https://codemirror.net/6/docs/ref/#commands.undo).
- Mod-y (Mod-Shift-z on macOS) + Ctrl-Shift-z on Linux: [`redo`](https://codemirror.net/6/docs/ref/#commands.redo).
- Mod-u: [`undoSelection`](https://codemirror.net/6/docs/ref/#commands.undoSelection).
- Alt-u (Mod-Shift-u on macOS): [`redoSelection`](https://codemirror.net/6/docs/ref/#commands.redoSelection).
*/ const $032754016b6293d7$export$ab4a28cb63e8a670 = [
    {
        key: "Mod-z",
        run: $032754016b6293d7$export$21f930c44940fd98,
        preventDefault: true
    },
    {
        key: "Mod-y",
        mac: "Mod-Shift-z",
        run: $032754016b6293d7$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        linux: "Ctrl-Shift-z",
        run: $032754016b6293d7$export$1688e416fee0a49e,
        preventDefault: true
    },
    {
        key: "Mod-u",
        run: $032754016b6293d7$export$43103d47530fe49f,
        preventDefault: true
    },
    {
        key: "Alt-u",
        mac: "Mod-Shift-u",
        run: $032754016b6293d7$export$2d87af80f1777f20,
        preventDefault: true
    }
];
function $032754016b6293d7$var$updateSel(sel, by) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(sel.ranges.map(by), sel.mainIndex);
}
function $032754016b6293d7$var$setSel(state, selection) {
    return state.update({
        selection: selection,
        scrollIntoView: true,
        userEvent: "select"
    });
}
function $032754016b6293d7$var$moveSel({ state: state, dispatch: dispatch }, how) {
    let selection = $032754016b6293d7$var$updateSel(state.selection, how);
    if (selection.eq(state.selection, true)) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
}
function $032754016b6293d7$var$rangeEnd(range, forward) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(forward ? range.to : range.from);
}
function $032754016b6293d7$var$cursorByChar(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByChar(range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
function $032754016b6293d7$var$ltrAtCursor(view) {
    return view.textDirectionAt(view.state.selection.main.head) == (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).LTR;
}
/**
Move the selection one character to the left (which is backward in
left-to-right text, forward in right-to-left text).
*/ const $032754016b6293d7$export$3447f2b737925430 = (view)=>$032754016b6293d7$var$cursorByChar(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one character to the right.
*/ const $032754016b6293d7$export$e45941411d098b = (view)=>$032754016b6293d7$var$cursorByChar(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one character forward.
*/ const $032754016b6293d7$export$25b7809021291927 = (view)=>$032754016b6293d7$var$cursorByChar(view, true);
/**
Move the selection one character backward.
*/ const $032754016b6293d7$export$6ddc33d0aa7a1b65 = (view)=>$032754016b6293d7$var$cursorByChar(view, false);
function $032754016b6293d7$var$cursorByGroup(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? view.moveByGroup(range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection to the left across one group of word or
non-word (but also non-space) characters.
*/ const $032754016b6293d7$export$137fb1611fb38377 = (view)=>$032754016b6293d7$var$cursorByGroup(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one group to the right.
*/ const $032754016b6293d7$export$8fb2c619d55341b4 = (view)=>$032754016b6293d7$var$cursorByGroup(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection one group forward.
*/ const $032754016b6293d7$export$ce8d94762dbdebb8 = (view)=>$032754016b6293d7$var$cursorByGroup(view, true);
/**
Move the selection one group backward.
*/ const $032754016b6293d7$export$dd83d1d646f184d8 = (view)=>$032754016b6293d7$var$cursorByGroup(view, false);
const $032754016b6293d7$var$segmenter = typeof Intl != "undefined" && Intl.Segmenter ? /*@__PURE__*/ new Intl.Segmenter(undefined, {
    granularity: "word"
}) : null;
function $032754016b6293d7$var$moveBySubword(view, range, forward) {
    let categorize = view.state.charCategorizer(range.from);
    let cat = (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space, pos = range.from, steps = 0;
    let done = false, sawUpper = false, sawLower = false;
    let step = (next)=>{
        if (done) return false;
        pos += forward ? next.length : -next.length;
        let nextCat = categorize(next), ahead;
        if (nextCat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && next.charCodeAt(0) < 128 && /[\W_]/.test(next)) nextCat = -1; // Treat word punctuation specially
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Space) cat = nextCat;
        if (cat != nextCat) return false;
        if (cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) {
            if (next.toLowerCase() == next) {
                if (!forward && sawUpper) return false;
                sawLower = true;
            } else if (sawLower) {
                if (forward) return false;
                done = true;
            } else {
                if (sawUpper && forward && categorize(ahead = view.state.sliceDoc(pos, pos + 1)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && ahead.toLowerCase() == ahead) return false;
                sawUpper = true;
            }
        }
        steps++;
        return true;
    };
    let end = view.moveByChar(range, forward, (start)=>{
        step(start);
        return step;
    });
    if ($032754016b6293d7$var$segmenter && cat == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && end.from == range.from + steps * (forward ? 1 : -1)) {
        let from = Math.min(range.head, end.head), to = Math.max(range.head, end.head);
        let skipped = view.state.sliceDoc(from, to);
        if (skipped.length > 1 && /[\u4E00-\uffff]/.test(skipped)) {
            let segments = Array.from($032754016b6293d7$var$segmenter.segment(skipped));
            if (segments.length > 1) {
                if (forward) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + segments[1].index, -1);
                return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(end.head + segments[segments.length - 1].index, 1);
            }
        }
    }
    return end;
}
function $032754016b6293d7$var$cursorBySubword(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>range.empty ? $032754016b6293d7$var$moveBySubword(view, range, forward) : $032754016b6293d7$var$rangeEnd(range, forward));
}
/**
Move the selection one group or camel-case subword forward.
*/ const $032754016b6293d7$export$d969a5b0dca9c3e2 = (view)=>$032754016b6293d7$var$cursorBySubword(view, true);
/**
Move the selection one group or camel-case subword backward.
*/ const $032754016b6293d7$export$ade35f5607ad3d82 = (view)=>$032754016b6293d7$var$cursorBySubword(view, false);
function $032754016b6293d7$var$interestingNode(state, node, bracketProp) {
    if (node.type.prop(bracketProp)) return true;
    let len = node.to - node.from;
    return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function $032754016b6293d7$var$moveBySyntax(state, start, forward) {
    let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(start.head);
    let bracketProp = forward ? (0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy : (0, $ed739beecf769914$export$b8034b9bc18acd90).openedBy;
    // Scan forward through child nodes to see if there's an interesting
    // node ahead.
    for(let at = start.head;;){
        let next = forward ? pos.childAfter(at) : pos.childBefore(at);
        if (!next) break;
        if ($032754016b6293d7$var$interestingNode(state, next, bracketProp)) pos = next;
        else at = forward ? next.to : next.from;
    }
    let bracket = pos.type.prop(bracketProp), match, newPos;
    if (bracket && (match = forward ? (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, pos.from, 1) : (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, pos.to, -1)) && match.matched) newPos = forward ? match.end.to : match.end.from;
    else newPos = forward ? pos.to : pos.from;
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(newPos, forward ? -1 : 1);
}
/**
Move the cursor over the next syntactic element to the left.
*/ const $032754016b6293d7$export$1e53c014543c10bb = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the cursor over the next syntactic element to the right.
*/ const $032754016b6293d7$export$62c6dc33f5d01e39 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, $032754016b6293d7$var$ltrAtCursor(view)));
function $032754016b6293d7$var$cursorByLine(view, forward) {
    return $032754016b6293d7$var$moveSel(view, (range)=>{
        if (!range.empty) return $032754016b6293d7$var$rangeEnd(range, forward);
        let moved = view.moveVertically(range, forward);
        return moved.head != range.head ? moved : view.moveToLineBoundary(range, forward);
    });
}
/**
Move the selection one line up.
*/ const $032754016b6293d7$export$fe179dad0485d99d = (view)=>$032754016b6293d7$var$cursorByLine(view, false);
/**
Move the selection one line down.
*/ const $032754016b6293d7$export$75f9b75ffb1a9dc5 = (view)=>$032754016b6293d7$var$cursorByLine(view, true);
function $032754016b6293d7$var$pageInfo(view) {
    let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
    let marginTop = 0, marginBottom = 0, height;
    if (selfScroll) {
        for (let source of view.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollMargins)){
            let margins = source(view);
            if (margins === null || margins === void 0 ? void 0 : margins.top) marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
            if (margins === null || margins === void 0 ? void 0 : margins.bottom) marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
        }
        height = view.scrollDOM.clientHeight - marginTop - marginBottom;
    } else height = (view.dom.ownerDocument.defaultView || window).innerHeight;
    return {
        marginTop: marginTop,
        marginBottom: marginBottom,
        selfScroll: selfScroll,
        height: Math.max(view.defaultLineHeight, height - 5)
    };
}
function $032754016b6293d7$var$cursorByPage(view, forward) {
    let page = $032754016b6293d7$var$pageInfo(view);
    let { state: state } = view, selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        return range.empty ? view.moveVertically(range, forward, page.height) : $032754016b6293d7$var$rangeEnd(range, forward);
    });
    if (selection.eq(state.selection)) return false;
    let effect;
    if (page.selfScroll) {
        let startPos = view.coordsAtPos(state.selection.main.head);
        let scrollRect = view.scrollDOM.getBoundingClientRect();
        let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
        if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom) effect = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(selection.main.head, {
            y: "start",
            yMargin: startPos.top - scrollTop
        });
    }
    view.dispatch($032754016b6293d7$var$setSel(state, selection), {
        effects: effect
    });
    return true;
}
/**
Move the selection one page up.
*/ const $032754016b6293d7$export$546ec71a9f854193 = (view)=>$032754016b6293d7$var$cursorByPage(view, false);
/**
Move the selection one page down.
*/ const $032754016b6293d7$export$6e407c2072d437f4 = (view)=>$032754016b6293d7$var$cursorByPage(view, true);
function $032754016b6293d7$var$moveByLineBoundary(view, start, forward) {
    let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
    if (moved.head == start.head && moved.head != (forward ? line.to : line.from)) moved = view.moveToLineBoundary(start, forward, false);
    if (!forward && moved.head == line.from && line.length) {
        let space = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
        if (space && start.head != line.from + space) moved = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(line.from + space);
    }
    return moved;
}
/**
Move the selection to the next line wrap point, or to the end of
the line if there isn't one left on this line.
*/ const $032754016b6293d7$export$b59ae3b25af6ea13 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, true));
/**
Move the selection to previous line wrap point, or failing that to
the start of the line. If the line is indented, and the cursor
isn't already at the end of the indentation, this will move to the
end of the indentation instead of the start of the line.
*/ const $032754016b6293d7$export$64939ebc49b03818 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, false));
/**
Move the selection one line wrap point to the left.
*/ const $032754016b6293d7$export$515c8c77cfbd2e73 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection one line wrap point to the right.
*/ const $032754016b6293d7$export$912e453a1e062a62 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, $032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection to the start of the line.
*/ const $032754016b6293d7$export$9c7dea99650bd512 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from, 1));
/**
Move the selection to the end of the line.
*/ const $032754016b6293d7$export$2a3cdaf3ab2dcbf2 = (view)=>$032754016b6293d7$var$moveSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to, -1));
function $032754016b6293d7$var$toMatchingBracket(state, dispatch, extend) {
    let found = false, selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let matching = (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head, -1) || (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head, 1) || range.head > 0 && (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head - 1, 1) || range.head < state.doc.length && (0, $a97ccac5cf5f4f5d$export$3391942603e90cda)(state, range.head + 1, -1);
        if (!matching || !matching.end) return range;
        found = true;
        let head = matching.start.from == range.head ? matching.end.to : matching.end.from;
        return extend ? (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor, head) : (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(head);
    });
    if (!found) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
}
/**
Move the selection to the bracket matching the one it is currently
on, if any.
*/ const $032754016b6293d7$export$e5a7e1f2d38b1f6a = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$toMatchingBracket(state, dispatch, false);
/**
Extend the selection to the bracket matching the one the selection
head is currently on, if any.
*/ const $032754016b6293d7$export$a56168b85007a381 = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$toMatchingBracket(state, dispatch, true);
function $032754016b6293d7$var$extendSel(view, how) {
    let selection = $032754016b6293d7$var$updateSel(view.state.selection, (range)=>{
        let head = how(range);
        return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor, head.head, head.goalColumn, head.bidiLevel || undefined);
    });
    if (selection.eq(view.state.selection)) return false;
    view.dispatch($032754016b6293d7$var$setSel(view.state, selection));
    return true;
}
function $032754016b6293d7$var$selectByChar(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByChar(range, forward));
}
/**
Move the selection head one character to the left, while leaving
the anchor in place.
*/ const $032754016b6293d7$export$639be832433387f = (view)=>$032754016b6293d7$var$selectByChar(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one character to the right.
*/ const $032754016b6293d7$export$49e3d65796d89132 = (view)=>$032754016b6293d7$var$selectByChar(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one character forward.
*/ const $032754016b6293d7$export$6a18f0ec4e3aa4ba = (view)=>$032754016b6293d7$var$selectByChar(view, true);
/**
Move the selection head one character backward.
*/ const $032754016b6293d7$export$1132822fa6924c1d = (view)=>$032754016b6293d7$var$selectByChar(view, false);
function $032754016b6293d7$var$selectByGroup(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveByGroup(range, forward));
}
/**
Move the selection head one [group](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) to
the left.
*/ const $032754016b6293d7$export$ef839611b4c2ba40 = (view)=>$032754016b6293d7$var$selectByGroup(view, !$032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one group to the right.
*/ const $032754016b6293d7$export$5ebbb4cf65fe8a74 = (view)=>$032754016b6293d7$var$selectByGroup(view, $032754016b6293d7$var$ltrAtCursor(view));
/**
Move the selection head one group forward.
*/ const $032754016b6293d7$export$53ddb317471acf76 = (view)=>$032754016b6293d7$var$selectByGroup(view, true);
/**
Move the selection head one group backward.
*/ const $032754016b6293d7$export$65a2ce60964fa778 = (view)=>$032754016b6293d7$var$selectByGroup(view, false);
function $032754016b6293d7$var$selectBySubword(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySubword(view, range, forward));
}
/**
Move the selection head one group or camel-case subword forward.
*/ const $032754016b6293d7$export$c4f4d945a8760145 = (view)=>$032754016b6293d7$var$selectBySubword(view, true);
/**
Move the selection head one group or subword backward.
*/ const $032754016b6293d7$export$3a6caa1f1abce2e2 = (view)=>$032754016b6293d7$var$selectBySubword(view, false);
/**
Move the selection head over the next syntactic element to the left.
*/ const $032754016b6293d7$export$67b15be4414061b5 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head over the next syntactic element to the right.
*/ const $032754016b6293d7$export$74aa476df7791ce = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveBySyntax(view.state, range, $032754016b6293d7$var$ltrAtCursor(view)));
function $032754016b6293d7$var$selectByLine(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveVertically(range, forward));
}
/**
Move the selection head one line up.
*/ const $032754016b6293d7$export$92aa693a1ecd7061 = (view)=>$032754016b6293d7$var$selectByLine(view, false);
/**
Move the selection head one line down.
*/ const $032754016b6293d7$export$bf847527697a3040 = (view)=>$032754016b6293d7$var$selectByLine(view, true);
function $032754016b6293d7$var$selectByPage(view, forward) {
    return $032754016b6293d7$var$extendSel(view, (range)=>view.moveVertically(range, forward, $032754016b6293d7$var$pageInfo(view).height));
}
/**
Move the selection head one page up.
*/ const $032754016b6293d7$export$61eab34d4ff5cbaf = (view)=>$032754016b6293d7$var$selectByPage(view, false);
/**
Move the selection head one page down.
*/ const $032754016b6293d7$export$a4c186a0dadaf91c = (view)=>$032754016b6293d7$var$selectByPage(view, true);
/**
Move the selection head to the next line boundary.
*/ const $032754016b6293d7$export$df223d0097d57a86 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, true));
/**
Move the selection head to the previous line boundary.
*/ const $032754016b6293d7$export$643176ee603b8e87 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, false));
/**
Move the selection head one line boundary to the left.
*/ const $032754016b6293d7$export$769cc61da74090c5 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, !$032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head one line boundary to the right.
*/ const $032754016b6293d7$export$de427496204690a6 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>$032754016b6293d7$var$moveByLineBoundary(view, range, $032754016b6293d7$var$ltrAtCursor(view)));
/**
Move the selection head to the start of the line.
*/ const $032754016b6293d7$export$a0e1e86f753956a4 = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).from));
/**
Move the selection head to the end of the line.
*/ const $032754016b6293d7$export$bd34a38d148e23af = (view)=>$032754016b6293d7$var$extendSel(view, (range)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(view.lineBlockAt(range.head).to));
/**
Move the selection to the start of the document.
*/ const $032754016b6293d7$export$ff7ed6e6e1cb317f = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: 0
    }));
    return true;
};
/**
Move the selection to the end of the document.
*/ const $032754016b6293d7$export$b12ef1671b2836da = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.doc.length
    }));
    return true;
};
/**
Move the selection head to the start of the document.
*/ const $032754016b6293d7$export$aa525ee829cc26b = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: 0
    }));
    return true;
};
/**
Move the selection head to the end of the document.
*/ const $032754016b6293d7$export$fff0131cdd9694fe = ({ state: state, dispatch: dispatch })=>{
    dispatch($032754016b6293d7$var$setSel(state, {
        anchor: state.selection.main.anchor,
        head: state.doc.length
    }));
    return true;
};
/**
Select the entire document.
*/ const $032754016b6293d7$export$90aca4adda6ff0f5 = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update({
        selection: {
            anchor: 0,
            head: state.doc.length
        },
        userEvent: "select"
    }));
    return true;
};
/**
Expand the selection to cover entire lines.
*/ const $032754016b6293d7$export$e41c12847640c21 = ({ state: state, dispatch: dispatch })=>{
    let ranges = $032754016b6293d7$var$selectedLineBlocks(state).map(({ from: from, to: to })=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(from, Math.min(to + 1, state.doc.length)));
    dispatch(state.update({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges),
        userEvent: "select"
    }));
    return true;
};
/**
Select the next syntactic construct that is larger than the
selection. Note that this will only work insofar as the language
[provider](https://codemirror.net/6/docs/ref/#language.language) you use builds up a full
syntax tree.
*/ const $032754016b6293d7$export$f38a48fa120d50ce = ({ state: state, dispatch: dispatch })=>{
    let selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        var _a;
        let stack = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveStack(range.from, 1);
        for(let cur = stack; cur; cur = cur.next){
            let { node: node } = cur;
            if ((node.from < range.from && node.to >= range.to || node.to > range.to && node.from <= range.from) && ((_a = node.parent) === null || _a === void 0 ? void 0 : _a.parent)) return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(node.to, node.from);
        }
        return range;
    });
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
};
/**
Simplify the current selection. When multiple ranges are selected,
reduce it to its main range. Otherwise, if the selection is
non-empty, convert it to a cursor selection.
*/ const $032754016b6293d7$export$2f90cebc0d40abf = ({ state: state, dispatch: dispatch })=>{
    let cur = state.selection, selection = null;
    if (cur.ranges.length > 1) selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
        cur.main
    ]);
    else if (!cur.main.empty) selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create([
        (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(cur.main.head)
    ]);
    if (!selection) return false;
    dispatch($032754016b6293d7$var$setSel(state, selection));
    return true;
};
function $032754016b6293d7$var$deleteBy(target, by) {
    if (target.state.readOnly) return false;
    let event = "delete.selection", { state: state } = target;
    let changes = state.changeByRange((range)=>{
        let { from: from, to: to } = range;
        if (from == to) {
            let towards = by(range);
            if (towards < from) {
                event = "delete.backward";
                towards = $032754016b6293d7$var$skipAtomic(target, towards, false);
            } else if (towards > from) {
                event = "delete.forward";
                towards = $032754016b6293d7$var$skipAtomic(target, towards, true);
            }
            from = Math.min(from, towards);
            to = Math.max(to, towards);
        } else {
            from = $032754016b6293d7$var$skipAtomic(target, from, false);
            to = $032754016b6293d7$var$skipAtomic(target, to, true);
        }
        return from == to ? {
            range: range
        } : {
            changes: {
                from: from,
                to: to
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(from, from < range.head ? -1 : 1)
        };
    });
    if (changes.changes.empty) return false;
    target.dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: event,
        effects: event == "delete.selection" ? (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(state.phrase("Selection deleted")) : undefined
    }));
    return true;
}
function $032754016b6293d7$var$skipAtomic(target, pos, forward) {
    if (target instanceof (0, $7beee9608540d2c3$export$eece2fccabbb77c5)) for (let ranges of target.state.facet((0, $7beee9608540d2c3$export$eece2fccabbb77c5).atomicRanges).map((f)=>f(target)))ranges.between(pos, pos, (from, to)=>{
        if (from < pos && to > pos) pos = forward ? to : from;
    });
    return pos;
}
const $032754016b6293d7$var$deleteByChar = (target, forward, byIndentUnit)=>$032754016b6293d7$var$deleteBy(target, (range)=>{
        let pos = range.from, { state: state } = target, line = state.doc.lineAt(pos), before, targetPos;
        if (byIndentUnit && !forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
            if (before[before.length - 1] == "	") return pos - 1;
            let col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(before, state.tabSize), drop = col % (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state) || (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state);
            for(let i = 0; i < drop && before[before.length - 1 - i] == " "; i++)pos--;
            targetPos = pos;
        } else {
            targetPos = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward, forward) + line.from;
            if (targetPos == pos && line.number != (forward ? state.doc.lines : 1)) targetPos += forward ? 1 : -1;
            else if (!forward && /[\ufe00-\ufe0f]/.test(line.text.slice(targetPos - line.from, pos - line.from))) targetPos = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, targetPos - line.from, false, false) + line.from;
        }
        return targetPos;
    });
/**
Delete the selection, or, for cursor selections, the character or
indentation unit before the cursor.
*/ const $032754016b6293d7$export$1e8a14efe7ca9a33 = (view)=>$032754016b6293d7$var$deleteByChar(view, false, true);
/**
Delete the selection or the character before the cursor. Does not
implement any extended behavior like deleting whole indentation
units in one go.
*/ const $032754016b6293d7$export$3365c1d7b1abe7df = (view)=>$032754016b6293d7$var$deleteByChar(view, false, false);
/**
Delete the selection or the character after the cursor.
*/ const $032754016b6293d7$export$d41683a0f042cb80 = (view)=>$032754016b6293d7$var$deleteByChar(view, true, false);
const $032754016b6293d7$var$deleteByGroup = (target, forward)=>$032754016b6293d7$var$deleteBy(target, (range)=>{
        let pos = range.head, { state: state } = target, line = state.doc.lineAt(pos);
        let categorize = state.charCategorizer(pos);
        for(let cat = null;;){
            if (pos == (forward ? line.to : line.from)) {
                if (pos == range.head && line.number != (forward ? state.doc.lines : 1)) pos += forward ? 1 : -1;
                break;
            }
            let next = (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, forward) + line.from;
            let nextChar = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
            let nextCat = categorize(nextChar);
            if (cat != null && nextCat != cat) break;
            if (nextChar != " " || pos != range.head) cat = nextCat;
            pos = next;
        }
        return pos;
    });
/**
Delete the selection or backward until the end of the next
[group](https://codemirror.net/6/docs/ref/#view.EditorView.moveByGroup), only skipping groups of
whitespace when they consist of a single space.
*/ const $032754016b6293d7$export$3072f591ab219e94 = (target)=>$032754016b6293d7$var$deleteByGroup(target, false);
/**
Delete the selection or forward until the end of the next group.
*/ const $032754016b6293d7$export$56a4e2ef21b58242 = (target)=>$032754016b6293d7$var$deleteByGroup(target, true);
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line. If the cursor is directly at the end of the
line, delete the line break after it.
*/ const $032754016b6293d7$export$ae3820c4ce0e9c92 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineEnd = view.lineBlockAt(range.head).to;
        return range.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line. If the cursor is directly at the start of the
line, delete the line break before it.
*/ const $032754016b6293d7$export$dc80e21fb31e84a5 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.lineBlockAt(range.head).from;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the start of the line or the next line wrap before the cursor.
*/ const $032754016b6293d7$export$d1072494cede984a = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, false).head;
        return range.head > lineStart ? lineStart : Math.max(0, range.head - 1);
    });
/**
Delete the selection, or, if it is a cursor selection, delete to
the end of the line or the next line wrap after the cursor.
*/ const $032754016b6293d7$export$b87eb3a389c264a4 = (view)=>$032754016b6293d7$var$deleteBy(view, (range)=>{
        let lineStart = view.moveToLineBoundary(range, true).head;
        return range.head < lineStart ? lineStart : Math.min(view.state.doc.length, range.head + 1);
    });
/**
Delete all whitespace directly before a line end from the
document.
*/ const $032754016b6293d7$export$8acd3a9fe3872724 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = [];
    for(let pos = 0, prev = "", iter = state.doc.iter();;){
        iter.next();
        if (iter.lineBreak || iter.done) {
            let trailing = prev.search(/\s+$/);
            if (trailing > -1) changes.push({
                from: pos - (prev.length - trailing),
                to: pos
            });
            if (iter.done) break;
            prev = "";
        } else prev = iter.value;
        pos += iter.value.length;
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        userEvent: "delete"
    }));
    return true;
};
/**
Replace each selection range with a line break, leaving the cursor
on the line before the break.
*/ const $032754016b6293d7$export$a258d4581e1d5d3c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of([
                    "",
                    ""
                ])
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from)
        };
    });
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Flip the characters before and after the cursor(s).
*/ const $032754016b6293d7$export$55467a37288e4063 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let changes = state.changeByRange((range)=>{
        if (!range.empty || range.from == 0 || range.from == state.doc.length) return {
            range: range
        };
        let pos = range.from, line = state.doc.lineAt(pos);
        let from = pos == line.from ? pos - 1 : (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, false) + line.from;
        let to = pos == line.to ? pos + 1 : (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(line.text, pos - line.from, true) + line.from;
        return {
            changes: {
                from: from,
                to: to,
                insert: state.doc.slice(pos, to).append(state.doc.slice(from, pos))
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(to)
        };
    });
    if (changes.changes.empty) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "move.character"
    }));
    return true;
};
function $032754016b6293d7$var$selectedLineBlocks(state) {
    let blocks = [], upto = -1;
    for (let range of state.selection.ranges){
        let startLine = state.doc.lineAt(range.from), endLine = state.doc.lineAt(range.to);
        if (!range.empty && range.to == endLine.from) endLine = state.doc.lineAt(range.to - 1);
        if (upto >= startLine.number) {
            let prev = blocks[blocks.length - 1];
            prev.to = endLine.to;
            prev.ranges.push(range);
        } else blocks.push({
            from: startLine.from,
            to: endLine.to,
            ranges: [
                range
            ]
        });
        upto = endLine.number + 1;
    }
    return blocks;
}
function $032754016b6293d7$var$moveLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [], ranges = [];
    for (let block of $032754016b6293d7$var$selectedLineBlocks(state)){
        if (forward ? block.to == state.doc.length : block.from == 0) continue;
        let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
        let size = nextLine.length + 1;
        if (forward) {
            changes.push({
                from: block.to,
                to: nextLine.to
            }, {
                from: block.from,
                insert: nextLine.text + state.lineBreak
            });
            for (let r of block.ranges)ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(Math.min(state.doc.length, r.anchor + size), Math.min(state.doc.length, r.head + size)));
        } else {
            changes.push({
                from: nextLine.from,
                to: block.from
            }, {
                from: block.to,
                insert: state.lineBreak + nextLine.text
            });
            for (let r of block.ranges)ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.anchor - size, r.head - size));
        }
    }
    if (!changes.length) return false;
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, state.selection.mainIndex),
        userEvent: "move.line"
    }));
    return true;
}
/**
Move the selected lines up one line.
*/ const $032754016b6293d7$export$c4eebaf75cfae23e = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$moveLine(state, dispatch, false);
/**
Move the selected lines down one line.
*/ const $032754016b6293d7$export$ac19ae98a6fcd34c = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$moveLine(state, dispatch, true);
function $032754016b6293d7$var$copyLine(state, dispatch, forward) {
    if (state.readOnly) return false;
    let changes = [];
    for (let block of $032754016b6293d7$var$selectedLineBlocks(state))if (forward) changes.push({
        from: block.from,
        insert: state.doc.slice(block.from, block.to) + state.lineBreak
    });
    else changes.push({
        from: block.to,
        insert: state.lineBreak + state.doc.slice(block.from, block.to)
    });
    dispatch(state.update({
        changes: changes,
        scrollIntoView: true,
        userEvent: "input.copyline"
    }));
    return true;
}
/**
Create a copy of the selected lines. Keep the selection in the top copy.
*/ const $032754016b6293d7$export$c3798d29213e527c = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$copyLine(state, dispatch, false);
/**
Create a copy of the selected lines. Keep the selection in the bottom copy.
*/ const $032754016b6293d7$export$1ad385c375816d2f = ({ state: state, dispatch: dispatch })=>$032754016b6293d7$var$copyLine(state, dispatch, true);
/**
Delete selected lines.
*/ const $032754016b6293d7$export$aba0d4cd8923f1ae = (view)=>{
    if (view.state.readOnly) return false;
    let { state: state } = view, changes = state.changes($032754016b6293d7$var$selectedLineBlocks(state).map(({ from: from, to: to })=>{
        if (from > 0) from--;
        else if (to < state.doc.length) to++;
        return {
            from: from,
            to: to
        };
    }));
    let selection = $032754016b6293d7$var$updateSel(state.selection, (range)=>{
        let dist = undefined;
        if (view.lineWrapping) {
            let block = view.lineBlockAt(range.head), pos = view.coordsAtPos(range.head, range.assoc || 1);
            if (pos) dist = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
        }
        return view.moveVertically(range, true, dist);
    }).map(changes);
    view.dispatch({
        changes: changes,
        selection: selection,
        scrollIntoView: true,
        userEvent: "delete.line"
    });
    return true;
};
/**
Replace the selection with a newline.
*/ const $032754016b6293d7$export$e7e1d174affeae8d = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.replaceSelection(state.lineBreak), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Replace the selection with a newline and the same amount of
indentation as the line above.
*/ const $032754016b6293d7$export$8dc33eb9291e07ef = ({ state: state, dispatch: dispatch })=>{
    dispatch(state.update(state.changeByRange((range)=>{
        let indent = /^\s*/.exec(state.doc.lineAt(range.from).text)[0];
        return {
            changes: {
                from: range.from,
                to: range.to,
                insert: state.lineBreak + indent
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + indent.length + 1)
        };
    }), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $032754016b6293d7$var$isBetweenBrackets(state, pos) {
    if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1))) return {
        from: pos,
        to: pos
    };
    let context = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos);
    let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
    if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from && !/\S/.test(state.sliceDoc(before.to, after.from))) return {
        from: before.to,
        to: after.from
    };
    return null;
}
/**
Replace the selection with a newline and indent the newly created
line(s). If the current line consists only of whitespace, this
will also delete that whitespace. When the cursor is between
matching brackets, an additional newline will be inserted after
the cursor.
*/ const $032754016b6293d7$export$668310d2b1aa07d5 = /*@__PURE__*/ $032754016b6293d7$var$newlineAndIndent(false);
/**
Create a blank, indented line below the current line.
*/ const $032754016b6293d7$export$2ff1ccbcf65d0770 = /*@__PURE__*/ $032754016b6293d7$var$newlineAndIndent(true);
function $032754016b6293d7$var$newlineAndIndent(atEof) {
    return ({ state: state, dispatch: dispatch })=>{
        if (state.readOnly) return false;
        let changes = state.changeByRange((range)=>{
            let { from: from, to: to } = range, line = state.doc.lineAt(from);
            let explode = !atEof && from == to && $032754016b6293d7$var$isBetweenBrackets(state, from);
            if (atEof) from = to = (to <= line.to ? line : state.doc.lineAt(to)).to;
            let cx = new (0, $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8)(state, {
                simulateBreak: from,
                simulateDoubleBreak: !!explode
            });
            let indent = (0, $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211)(cx, from);
            if (indent == null) indent = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
            while(to < line.to && /\s/.test(line.text[to - line.from]))to++;
            if (explode) ({ from: from, to: to } = explode);
            else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from))) from = line.from;
            let insert = [
                "",
                (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, indent)
            ];
            if (explode) insert.push((0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, cx.lineIndent(line.from, -1)));
            return {
                changes: {
                    from: from,
                    to: to,
                    insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(insert)
                },
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(from + 1 + insert[1].length)
            };
        });
        dispatch(state.update(changes, {
            scrollIntoView: true,
            userEvent: "input"
        }));
        return true;
    };
}
function $032754016b6293d7$var$changeBySelectedLine(state, f) {
    let atLine = -1;
    return state.changeByRange((range)=>{
        let changes = [];
        for(let pos = range.from; pos <= range.to;){
            let line = state.doc.lineAt(pos);
            if (line.number > atLine && (range.empty || range.to > line.from)) {
                f(line, changes, range);
                atLine = line.number;
            }
            pos = line.to + 1;
        }
        let changeSet = state.changes(changes);
        return {
            changes: changes,
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(changeSet.mapPos(range.anchor, 1), changeSet.mapPos(range.head, 1))
        };
    });
}
/**
Auto-indent the selected lines. This uses the [indentation service
facet](https://codemirror.net/6/docs/ref/#language.indentService) as source for auto-indent
information.
*/ const $032754016b6293d7$export$ffcf50534fec79c3 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let updated = Object.create(null);
    let context = new (0, $a97ccac5cf5f4f5d$export$eeab79349cc2f7c8)(state, {
        overrideIndentation: (start)=>{
            let found = updated[start];
            return found == null ? -1 : found;
        }
    });
    let changes = $032754016b6293d7$var$changeBySelectedLine(state, (line, changes, range)=>{
        let indent = (0, $a97ccac5cf5f4f5d$export$a2d3c9dbce6d2211)(context, line.from);
        if (indent == null) return;
        if (!/\S/.test(line.text)) indent = 0;
        let cur = /^\s*/.exec(line.text)[0];
        let norm = (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, indent);
        if (cur != norm || range.from < line.from + cur.length) {
            updated[line.from] = indent;
            changes.push({
                from: line.from,
                to: line.from + cur.length,
                insert: norm
            });
        }
    });
    if (!changes.changes.empty) dispatch(state.update(changes, {
        userEvent: "indent"
    }));
    return true;
};
/**
Add a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation to all selected
lines.
*/ const $032754016b6293d7$export$a61bf6a946ffc826 = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($032754016b6293d7$var$changeBySelectedLine(state, (line, changes)=>{
        changes.push({
            from: line.from,
            insert: state.facet((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5))
        });
    }), {
        userEvent: "input.indent"
    }));
    return true;
};
/**
Remove a [unit](https://codemirror.net/6/docs/ref/#language.indentUnit) of indentation from all
selected lines.
*/ const $032754016b6293d7$export$e4b902122bfe67ae = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    dispatch(state.update($032754016b6293d7$var$changeBySelectedLine(state, (line, changes)=>{
        let space = /^\s*/.exec(line.text)[0];
        if (!space) return;
        let col = (0, $6295c6875f57e3ee$export$20b4ab289374d0ac)(space, state.tabSize), keep = 0;
        let insert = (0, $a97ccac5cf5f4f5d$export$db5a40e207b40576)(state, Math.max(0, col - (0, $a97ccac5cf5f4f5d$export$ad3205d09311a797)(state)));
        while(keep < space.length && keep < insert.length && space.charCodeAt(keep) == insert.charCodeAt(keep))keep++;
        changes.push({
            from: line.from + keep,
            to: line.from + space.length,
            insert: insert.slice(keep)
        });
    }), {
        userEvent: "delete.dedent"
    }));
    return true;
};
/**
Enables or disables
[tab-focus mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode). While on, this
prevents the editor's key bindings from capturing Tab or
Shift-Tab, making it possible for the user to move focus out of
the editor with the keyboard.
*/ const $032754016b6293d7$export$f118650570e71643 = (view)=>{
    view.setTabFocusMode();
    return true;
};
/**
Temporarily enables [tab-focus
mode](https://codemirror.net/6/docs/ref/#view.EditorView.setTabFocusMode) for two seconds or until
another key is pressed.
*/ const $032754016b6293d7$export$1f0650d3f23682c8 = (view)=>{
    view.setTabFocusMode(2000);
    return true;
};
/**
Insert a tab character at the cursor or, if something is selected,
use [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) to indent the entire
selection.
*/ const $032754016b6293d7$export$89b2fa0b43bd10f8 = ({ state: state, dispatch: dispatch })=>{
    if (state.selection.ranges.some((r)=>!r.empty)) return $032754016b6293d7$export$a61bf6a946ffc826({
        state: state,
        dispatch: dispatch
    });
    dispatch(state.update(state.replaceSelection("	"), {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
/**
Array of key bindings containing the Emacs-style bindings that are
available on macOS by default.

 - Ctrl-b: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - Ctrl-f: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-p: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - Ctrl-n: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Ctrl-a: [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Ctrl-e: [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - Ctrl-d: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-h: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Ctrl-k: [`deleteToLineEnd`](https://codemirror.net/6/docs/ref/#commands.deleteToLineEnd)
 - Ctrl-Alt-h: [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-o: [`splitLine`](https://codemirror.net/6/docs/ref/#commands.splitLine)
 - Ctrl-t: [`transposeChars`](https://codemirror.net/6/docs/ref/#commands.transposeChars)
 - Ctrl-v: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown)
 - Alt-v: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp)
*/ const $032754016b6293d7$export$ef7c3246c722c48f = [
    {
        key: "Ctrl-b",
        run: $032754016b6293d7$export$3447f2b737925430,
        shift: $032754016b6293d7$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Ctrl-f",
        run: $032754016b6293d7$export$e45941411d098b,
        shift: $032754016b6293d7$export$49e3d65796d89132
    },
    {
        key: "Ctrl-p",
        run: $032754016b6293d7$export$fe179dad0485d99d,
        shift: $032754016b6293d7$export$92aa693a1ecd7061
    },
    {
        key: "Ctrl-n",
        run: $032754016b6293d7$export$75f9b75ffb1a9dc5,
        shift: $032754016b6293d7$export$bf847527697a3040
    },
    {
        key: "Ctrl-a",
        run: $032754016b6293d7$export$9c7dea99650bd512,
        shift: $032754016b6293d7$export$a0e1e86f753956a4
    },
    {
        key: "Ctrl-e",
        run: $032754016b6293d7$export$2a3cdaf3ab2dcbf2,
        shift: $032754016b6293d7$export$bd34a38d148e23af
    },
    {
        key: "Ctrl-d",
        run: $032754016b6293d7$export$d41683a0f042cb80
    },
    {
        key: "Ctrl-h",
        run: $032754016b6293d7$export$1e8a14efe7ca9a33
    },
    {
        key: "Ctrl-k",
        run: $032754016b6293d7$export$ae3820c4ce0e9c92
    },
    {
        key: "Ctrl-Alt-h",
        run: $032754016b6293d7$export$3072f591ab219e94
    },
    {
        key: "Ctrl-o",
        run: $032754016b6293d7$export$a258d4581e1d5d3c
    },
    {
        key: "Ctrl-t",
        run: $032754016b6293d7$export$55467a37288e4063
    },
    {
        key: "Ctrl-v",
        run: $032754016b6293d7$export$6e407c2072d437f4
    }
];
/**
An array of key bindings closely sticking to platform-standard or
widely used bindings. (This includes the bindings from
[`emacsStyleKeymap`](https://codemirror.net/6/docs/ref/#commands.emacsStyleKeymap), with their `key`
property changed to `mac`.)

 - ArrowLeft: [`cursorCharLeft`](https://codemirror.net/6/docs/ref/#commands.cursorCharLeft) ([`selectCharLeft`](https://codemirror.net/6/docs/ref/#commands.selectCharLeft) with Shift)
 - ArrowRight: [`cursorCharRight`](https://codemirror.net/6/docs/ref/#commands.cursorCharRight) ([`selectCharRight`](https://codemirror.net/6/docs/ref/#commands.selectCharRight) with Shift)
 - Ctrl-ArrowLeft (Alt-ArrowLeft on macOS): [`cursorGroupLeft`](https://codemirror.net/6/docs/ref/#commands.cursorGroupLeft) ([`selectGroupLeft`](https://codemirror.net/6/docs/ref/#commands.selectGroupLeft) with Shift)
 - Ctrl-ArrowRight (Alt-ArrowRight on macOS): [`cursorGroupRight`](https://codemirror.net/6/docs/ref/#commands.cursorGroupRight) ([`selectGroupRight`](https://codemirror.net/6/docs/ref/#commands.selectGroupRight) with Shift)
 - Cmd-ArrowLeft (on macOS): [`cursorLineStart`](https://codemirror.net/6/docs/ref/#commands.cursorLineStart) ([`selectLineStart`](https://codemirror.net/6/docs/ref/#commands.selectLineStart) with Shift)
 - Cmd-ArrowRight (on macOS): [`cursorLineEnd`](https://codemirror.net/6/docs/ref/#commands.cursorLineEnd) ([`selectLineEnd`](https://codemirror.net/6/docs/ref/#commands.selectLineEnd) with Shift)
 - ArrowUp: [`cursorLineUp`](https://codemirror.net/6/docs/ref/#commands.cursorLineUp) ([`selectLineUp`](https://codemirror.net/6/docs/ref/#commands.selectLineUp) with Shift)
 - ArrowDown: [`cursorLineDown`](https://codemirror.net/6/docs/ref/#commands.cursorLineDown) ([`selectLineDown`](https://codemirror.net/6/docs/ref/#commands.selectLineDown) with Shift)
 - Cmd-ArrowUp (on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Cmd-ArrowDown (on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Ctrl-ArrowUp (on macOS): [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - Ctrl-ArrowDown (on macOS): [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - PageUp: [`cursorPageUp`](https://codemirror.net/6/docs/ref/#commands.cursorPageUp) ([`selectPageUp`](https://codemirror.net/6/docs/ref/#commands.selectPageUp) with Shift)
 - PageDown: [`cursorPageDown`](https://codemirror.net/6/docs/ref/#commands.cursorPageDown) ([`selectPageDown`](https://codemirror.net/6/docs/ref/#commands.selectPageDown) with Shift)
 - Home: [`cursorLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryBackward) ([`selectLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryBackward) with Shift)
 - End: [`cursorLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.cursorLineBoundaryForward) ([`selectLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.selectLineBoundaryForward) with Shift)
 - Ctrl-Home (Cmd-Home on macOS): [`cursorDocStart`](https://codemirror.net/6/docs/ref/#commands.cursorDocStart) ([`selectDocStart`](https://codemirror.net/6/docs/ref/#commands.selectDocStart) with Shift)
 - Ctrl-End (Cmd-Home on macOS): [`cursorDocEnd`](https://codemirror.net/6/docs/ref/#commands.cursorDocEnd) ([`selectDocEnd`](https://codemirror.net/6/docs/ref/#commands.selectDocEnd) with Shift)
 - Enter: [`insertNewlineAndIndent`](https://codemirror.net/6/docs/ref/#commands.insertNewlineAndIndent)
 - Ctrl-a (Cmd-a on macOS): [`selectAll`](https://codemirror.net/6/docs/ref/#commands.selectAll)
 - Backspace: [`deleteCharBackward`](https://codemirror.net/6/docs/ref/#commands.deleteCharBackward)
 - Delete: [`deleteCharForward`](https://codemirror.net/6/docs/ref/#commands.deleteCharForward)
 - Ctrl-Backspace (Alt-Backspace on macOS): [`deleteGroupBackward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupBackward)
 - Ctrl-Delete (Alt-Delete on macOS): [`deleteGroupForward`](https://codemirror.net/6/docs/ref/#commands.deleteGroupForward)
 - Cmd-Backspace (macOS): [`deleteLineBoundaryBackward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryBackward).
 - Cmd-Delete (macOS): [`deleteLineBoundaryForward`](https://codemirror.net/6/docs/ref/#commands.deleteLineBoundaryForward).
*/ const $032754016b6293d7$export$ae5dfd95be821a1c = /*@__PURE__*/ [
    {
        key: "ArrowLeft",
        run: $032754016b6293d7$export$3447f2b737925430,
        shift: $032754016b6293d7$export$639be832433387f,
        preventDefault: true
    },
    {
        key: "Mod-ArrowLeft",
        mac: "Alt-ArrowLeft",
        run: $032754016b6293d7$export$137fb1611fb38377,
        shift: $032754016b6293d7$export$ef839611b4c2ba40,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowLeft",
        run: $032754016b6293d7$export$515c8c77cfbd2e73,
        shift: $032754016b6293d7$export$769cc61da74090c5,
        preventDefault: true
    },
    {
        key: "ArrowRight",
        run: $032754016b6293d7$export$e45941411d098b,
        shift: $032754016b6293d7$export$49e3d65796d89132,
        preventDefault: true
    },
    {
        key: "Mod-ArrowRight",
        mac: "Alt-ArrowRight",
        run: $032754016b6293d7$export$8fb2c619d55341b4,
        shift: $032754016b6293d7$export$5ebbb4cf65fe8a74,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowRight",
        run: $032754016b6293d7$export$912e453a1e062a62,
        shift: $032754016b6293d7$export$de427496204690a6,
        preventDefault: true
    },
    {
        key: "ArrowUp",
        run: $032754016b6293d7$export$fe179dad0485d99d,
        shift: $032754016b6293d7$export$92aa693a1ecd7061,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowUp",
        run: $032754016b6293d7$export$ff7ed6e6e1cb317f,
        shift: $032754016b6293d7$export$aa525ee829cc26b
    },
    {
        mac: "Ctrl-ArrowUp",
        run: $032754016b6293d7$export$546ec71a9f854193,
        shift: $032754016b6293d7$export$61eab34d4ff5cbaf
    },
    {
        key: "ArrowDown",
        run: $032754016b6293d7$export$75f9b75ffb1a9dc5,
        shift: $032754016b6293d7$export$bf847527697a3040,
        preventDefault: true
    },
    {
        mac: "Cmd-ArrowDown",
        run: $032754016b6293d7$export$b12ef1671b2836da,
        shift: $032754016b6293d7$export$fff0131cdd9694fe
    },
    {
        mac: "Ctrl-ArrowDown",
        run: $032754016b6293d7$export$6e407c2072d437f4,
        shift: $032754016b6293d7$export$a4c186a0dadaf91c
    },
    {
        key: "PageUp",
        run: $032754016b6293d7$export$546ec71a9f854193,
        shift: $032754016b6293d7$export$61eab34d4ff5cbaf
    },
    {
        key: "PageDown",
        run: $032754016b6293d7$export$6e407c2072d437f4,
        shift: $032754016b6293d7$export$a4c186a0dadaf91c
    },
    {
        key: "Home",
        run: $032754016b6293d7$export$64939ebc49b03818,
        shift: $032754016b6293d7$export$643176ee603b8e87,
        preventDefault: true
    },
    {
        key: "Mod-Home",
        run: $032754016b6293d7$export$ff7ed6e6e1cb317f,
        shift: $032754016b6293d7$export$aa525ee829cc26b
    },
    {
        key: "End",
        run: $032754016b6293d7$export$b59ae3b25af6ea13,
        shift: $032754016b6293d7$export$df223d0097d57a86,
        preventDefault: true
    },
    {
        key: "Mod-End",
        run: $032754016b6293d7$export$b12ef1671b2836da,
        shift: $032754016b6293d7$export$fff0131cdd9694fe
    },
    {
        key: "Enter",
        run: $032754016b6293d7$export$668310d2b1aa07d5
    },
    {
        key: "Mod-a",
        run: $032754016b6293d7$export$90aca4adda6ff0f5
    },
    {
        key: "Backspace",
        run: $032754016b6293d7$export$1e8a14efe7ca9a33,
        shift: $032754016b6293d7$export$1e8a14efe7ca9a33
    },
    {
        key: "Delete",
        run: $032754016b6293d7$export$d41683a0f042cb80
    },
    {
        key: "Mod-Backspace",
        mac: "Alt-Backspace",
        run: $032754016b6293d7$export$3072f591ab219e94
    },
    {
        key: "Mod-Delete",
        mac: "Alt-Delete",
        run: $032754016b6293d7$export$56a4e2ef21b58242
    },
    {
        mac: "Mod-Backspace",
        run: $032754016b6293d7$export$d1072494cede984a
    },
    {
        mac: "Mod-Delete",
        run: $032754016b6293d7$export$b87eb3a389c264a4
    }
].concat(/*@__PURE__*/ $032754016b6293d7$export$ef7c3246c722c48f.map((b)=>({
        mac: b.key,
        run: b.run,
        shift: b.shift
    })));
/**
The default keymap. Includes all bindings from
[`standardKeymap`](https://codemirror.net/6/docs/ref/#commands.standardKeymap) plus the following:

- Alt-ArrowLeft (Ctrl-ArrowLeft on macOS): [`cursorSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxLeft) ([`selectSyntaxLeft`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxLeft) with Shift)
- Alt-ArrowRight (Ctrl-ArrowRight on macOS): [`cursorSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.cursorSyntaxRight) ([`selectSyntaxRight`](https://codemirror.net/6/docs/ref/#commands.selectSyntaxRight) with Shift)
- Alt-ArrowUp: [`moveLineUp`](https://codemirror.net/6/docs/ref/#commands.moveLineUp)
- Alt-ArrowDown: [`moveLineDown`](https://codemirror.net/6/docs/ref/#commands.moveLineDown)
- Shift-Alt-ArrowUp: [`copyLineUp`](https://codemirror.net/6/docs/ref/#commands.copyLineUp)
- Shift-Alt-ArrowDown: [`copyLineDown`](https://codemirror.net/6/docs/ref/#commands.copyLineDown)
- Escape: [`simplifySelection`](https://codemirror.net/6/docs/ref/#commands.simplifySelection)
- Ctrl-Enter (Cmd-Enter on macOS): [`insertBlankLine`](https://codemirror.net/6/docs/ref/#commands.insertBlankLine)
- Alt-l (Ctrl-l on macOS): [`selectLine`](https://codemirror.net/6/docs/ref/#commands.selectLine)
- Ctrl-i (Cmd-i on macOS): [`selectParentSyntax`](https://codemirror.net/6/docs/ref/#commands.selectParentSyntax)
- Ctrl-[ (Cmd-[ on macOS): [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess)
- Ctrl-] (Cmd-] on macOS): [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore)
- Ctrl-Alt-\\ (Cmd-Alt-\\ on macOS): [`indentSelection`](https://codemirror.net/6/docs/ref/#commands.indentSelection)
- Shift-Ctrl-k (Shift-Cmd-k on macOS): [`deleteLine`](https://codemirror.net/6/docs/ref/#commands.deleteLine)
- Shift-Ctrl-\\ (Shift-Cmd-\\ on macOS): [`cursorMatchingBracket`](https://codemirror.net/6/docs/ref/#commands.cursorMatchingBracket)
- Ctrl-/ (Cmd-/ on macOS): [`toggleComment`](https://codemirror.net/6/docs/ref/#commands.toggleComment).
- Shift-Alt-a: [`toggleBlockComment`](https://codemirror.net/6/docs/ref/#commands.toggleBlockComment).
- Ctrl-m (Alt-Shift-m on macOS): [`toggleTabFocusMode`](https://codemirror.net/6/docs/ref/#commands.toggleTabFocusMode).
*/ const $032754016b6293d7$export$ab2e8d0ac5d2b69e = /*@__PURE__*/ [
    {
        key: "Alt-ArrowLeft",
        mac: "Ctrl-ArrowLeft",
        run: $032754016b6293d7$export$1e53c014543c10bb,
        shift: $032754016b6293d7$export$67b15be4414061b5
    },
    {
        key: "Alt-ArrowRight",
        mac: "Ctrl-ArrowRight",
        run: $032754016b6293d7$export$62c6dc33f5d01e39,
        shift: $032754016b6293d7$export$74aa476df7791ce
    },
    {
        key: "Alt-ArrowUp",
        run: $032754016b6293d7$export$c4eebaf75cfae23e
    },
    {
        key: "Shift-Alt-ArrowUp",
        run: $032754016b6293d7$export$c3798d29213e527c
    },
    {
        key: "Alt-ArrowDown",
        run: $032754016b6293d7$export$ac19ae98a6fcd34c
    },
    {
        key: "Shift-Alt-ArrowDown",
        run: $032754016b6293d7$export$1ad385c375816d2f
    },
    {
        key: "Escape",
        run: $032754016b6293d7$export$2f90cebc0d40abf
    },
    {
        key: "Mod-Enter",
        run: $032754016b6293d7$export$2ff1ccbcf65d0770
    },
    {
        key: "Alt-l",
        mac: "Ctrl-l",
        run: $032754016b6293d7$export$e41c12847640c21
    },
    {
        key: "Mod-i",
        run: $032754016b6293d7$export$f38a48fa120d50ce,
        preventDefault: true
    },
    {
        key: "Mod-[",
        run: $032754016b6293d7$export$e4b902122bfe67ae
    },
    {
        key: "Mod-]",
        run: $032754016b6293d7$export$a61bf6a946ffc826
    },
    {
        key: "Mod-Alt-\\",
        run: $032754016b6293d7$export$ffcf50534fec79c3
    },
    {
        key: "Shift-Mod-k",
        run: $032754016b6293d7$export$aba0d4cd8923f1ae
    },
    {
        key: "Shift-Mod-\\",
        run: $032754016b6293d7$export$e5a7e1f2d38b1f6a
    },
    {
        key: "Mod-/",
        run: $032754016b6293d7$export$afbcdd0bff36c567
    },
    {
        key: "Alt-A",
        run: $032754016b6293d7$export$19d6fa84ce3a55ab
    },
    {
        key: "Ctrl-m",
        mac: "Shift-Alt-m",
        run: $032754016b6293d7$export$f118650570e71643
    }
].concat($032754016b6293d7$export$ae5dfd95be821a1c);
/**
A binding that binds Tab to [`indentMore`](https://codemirror.net/6/docs/ref/#commands.indentMore) and
Shift-Tab to [`indentLess`](https://codemirror.net/6/docs/ref/#commands.indentLess).
Please see the [Tab example](../../examples/tab/) before using
this.
*/ const $032754016b6293d7$export$893b77570f8af4da = {
    key: "Tab",
    run: $032754016b6293d7$export$a61bf6a946ffc826,
    shift: $032754016b6293d7$export$e4b902122bfe67ae
};







function $2d3e4571bc0b9f5f$export$2e2bcd8739ae039() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)$2d3e4571bc0b9f5f$var$add(elt, arguments[i]);
    return elt;
}
function $2d3e4571bc0b9f5f$var$add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)$2d3e4571bc0b9f5f$var$add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}


const $976a3faeb93466fd$var$basicNormalize = typeof String.prototype.normalize == "function" ? (x)=>x.normalize("NFKD") : (x)=>x;
/**
A search cursor provides an iterator over text matches in a
document.
*/ class $976a3faeb93466fd$export$4989b254f32490be {
    /**
    Create a text cursor. The query is the search string, `from` to
    `to` provides the region to search.
    
    When `normalize` is given, it will be called, on both the query
    string and the content it is matched against, before comparing.
    You can, for example, create a case-insensitive search by
    passing `s => s.toLowerCase()`.
    
    Text is always normalized with
    [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
    (when supported).
    */ constructor(text, query, from = 0, to = text.length, normalize, test){
        this.test = test;
        /**
        The current match (only holds a meaningful value after
        [`next`](https://codemirror.net/6/docs/ref/#search.SearchCursor.next) has been called and when
        `done` is false).
        */ this.value = {
            from: 0,
            to: 0
        };
        /**
        Whether the end of the iterated region has been reached.
        */ this.done = false;
        this.matches = [];
        this.buffer = "";
        this.bufferPos = 0;
        this.iter = text.iterRange(from, to);
        this.bufferStart = from;
        this.normalize = normalize ? (x)=>normalize($976a3faeb93466fd$var$basicNormalize(x)) : $976a3faeb93466fd$var$basicNormalize;
        this.query = this.normalize(query);
    }
    peek() {
        if (this.bufferPos == this.buffer.length) {
            this.bufferStart += this.buffer.length;
            this.iter.next();
            if (this.iter.done) return -1;
            this.bufferPos = 0;
            this.buffer = this.iter.value;
        }
        return (0, $6295c6875f57e3ee$export$42977f40461e1360)(this.buffer, this.bufferPos);
    }
    /**
    Look for the next match. Updates the iterator's
    [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
    [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
    at least once before using the cursor.
    */ next() {
        while(this.matches.length)this.matches.pop();
        return this.nextOverlapping();
    }
    /**
    The `next` method will ignore matches that partially overlap a
    previous match. This method behaves like `next`, but includes
    such matches.
    */ nextOverlapping() {
        for(;;){
            let next = this.peek();
            if (next < 0) {
                this.done = true;
                return this;
            }
            let str = (0, $6295c6875f57e3ee$export$73bfc63873071f74)(next), start = this.bufferStart + this.bufferPos;
            this.bufferPos += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
            let norm = this.normalize(str);
            for(let i = 0, pos = start;; i++){
                let code = norm.charCodeAt(i);
                let match = this.match(code, pos, this.bufferPos + this.bufferStart);
                if (i == norm.length - 1) {
                    if (match) {
                        this.value = match;
                        return this;
                    }
                    break;
                }
                if (pos == start && i < str.length && str.charCodeAt(i) == code) pos++;
            }
        }
    }
    match(code, pos, end) {
        let match = null;
        for(let i = 0; i < this.matches.length; i += 2){
            let index = this.matches[i], keep = false;
            if (this.query.charCodeAt(index) == code) {
                if (index == this.query.length - 1) match = {
                    from: this.matches[i + 1],
                    to: end
                };
                else {
                    this.matches[i]++;
                    keep = true;
                }
            }
            if (!keep) {
                this.matches.splice(i, 2);
                i -= 2;
            }
        }
        if (this.query.charCodeAt(0) == code) {
            if (this.query.length == 1) match = {
                from: pos,
                to: end
            };
            else this.matches.push(1, pos);
        }
        if (match && this.test && !this.test(match.from, match.to, this.buffer, this.bufferStart)) match = null;
        return match;
    }
}
if (typeof Symbol != "undefined") $976a3faeb93466fd$export$4989b254f32490be.prototype[Symbol.iterator] = function() {
    return this;
};
const $976a3faeb93466fd$var$empty = {
    from: -1,
    to: -1,
    match: /*@__PURE__*/ /.*/.exec("")
};
const $976a3faeb93466fd$var$baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
/**
This class is similar to [`SearchCursor`](https://codemirror.net/6/docs/ref/#search.SearchCursor)
but searches for a regular expression pattern instead of a plain
string.
*/ class $976a3faeb93466fd$export$234e2283eb9dcd35 {
    /**
    Create a cursor that will search the given range in the given
    document. `query` should be the raw pattern (as you'd pass it to
    `new RegExp`).
    */ constructor(text, query, options, from = 0, to = text.length){
        this.text = text;
        this.to = to;
        this.curLine = "";
        /**
        Set to `true` when the cursor has reached the end of the search
        range.
        */ this.done = false;
        /**
        Will contain an object with the extent of the match and the
        match object when [`next`](https://codemirror.net/6/docs/ref/#search.RegExpCursor.next)
        sucessfully finds a match.
        */ this.value = $976a3faeb93466fd$var$empty;
        if (/\\[sWDnr]|\n|\r|\[\^/.test(query)) return new $976a3faeb93466fd$var$MultilineRegExpCursor(text, query, options, from, to);
        this.re = new RegExp(query, $976a3faeb93466fd$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.iter = text.iter();
        let startLine = text.lineAt(from);
        this.curLineStart = startLine.from;
        this.matchPos = $976a3faeb93466fd$var$toCharEnd(text, from);
        this.getLine(this.curLineStart);
    }
    getLine(skip) {
        this.iter.next(skip);
        if (this.iter.lineBreak) this.curLine = "";
        else {
            this.curLine = this.iter.value;
            if (this.curLineStart + this.curLine.length > this.to) this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
            this.iter.next();
        }
    }
    nextLine() {
        this.curLineStart = this.curLineStart + this.curLine.length + 1;
        if (this.curLineStart > this.to) this.curLine = "";
        else this.getLine(0);
    }
    /**
    Move to the next match, if there is one.
    */ next() {
        for(let off = this.matchPos - this.curLineStart;;){
            this.re.lastIndex = off;
            let match = this.matchPos <= this.to && this.re.exec(this.curLine);
            if (match) {
                let from = this.curLineStart + match.index, to = from + match[0].length;
                this.matchPos = $976a3faeb93466fd$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                if (from == this.curLineStart + this.curLine.length) this.nextLine();
                if ((from < to || from > this.value.to) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    return this;
                }
                off = this.matchPos - this.curLineStart;
            } else if (this.curLineStart + this.curLine.length < this.to) {
                this.nextLine();
                off = 0;
            } else {
                this.done = true;
                return this;
            }
        }
    }
}
const $976a3faeb93466fd$var$flattened = /*@__PURE__*/ new WeakMap();
// Reusable (partially) flattened document strings
class $976a3faeb93466fd$var$FlattenedDoc {
    constructor(from, text){
        this.from = from;
        this.text = text;
    }
    get to() {
        return this.from + this.text.length;
    }
    static get(doc, from, to) {
        let cached = $976a3faeb93466fd$var$flattened.get(doc);
        if (!cached || cached.from >= to || cached.to <= from) {
            let flat = new $976a3faeb93466fd$var$FlattenedDoc(from, doc.sliceString(from, to));
            $976a3faeb93466fd$var$flattened.set(doc, flat);
            return flat;
        }
        if (cached.from == from && cached.to == to) return cached;
        let { text: text, from: cachedFrom } = cached;
        if (cachedFrom > from) {
            text = doc.sliceString(from, cachedFrom) + text;
            cachedFrom = from;
        }
        if (cached.to < to) text += doc.sliceString(cached.to, to);
        $976a3faeb93466fd$var$flattened.set(doc, new $976a3faeb93466fd$var$FlattenedDoc(cachedFrom, text));
        return new $976a3faeb93466fd$var$FlattenedDoc(from, text.slice(from - cachedFrom, to - cachedFrom));
    }
}
class $976a3faeb93466fd$var$MultilineRegExpCursor {
    constructor(text, query, options, from, to){
        this.text = text;
        this.to = to;
        this.done = false;
        this.value = $976a3faeb93466fd$var$empty;
        this.matchPos = $976a3faeb93466fd$var$toCharEnd(text, from);
        this.re = new RegExp(query, $976a3faeb93466fd$var$baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
        this.test = options === null || options === void 0 ? void 0 : options.test;
        this.flat = $976a3faeb93466fd$var$FlattenedDoc.get(text, from, this.chunkEnd(from + 5000 /* Chunk.Base */ ));
    }
    chunkEnd(pos) {
        return pos >= this.to ? this.to : this.text.lineAt(pos).to;
    }
    next() {
        for(;;){
            let off = this.re.lastIndex = this.matchPos - this.flat.from;
            let match = this.re.exec(this.flat.text);
            // Skip empty matches directly after the last match
            if (match && !match[0] && match.index == off) {
                this.re.lastIndex = off + 1;
                match = this.re.exec(this.flat.text);
            }
            if (match) {
                let from = this.flat.from + match.index, to = from + match[0].length;
                // If a match goes almost to the end of a noncomplete chunk, try
                // again, since it'll likely be able to match more
                if ((this.flat.to >= this.to || match.index + match[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to, match))) {
                    this.value = {
                        from: from,
                        to: to,
                        match: match
                    };
                    this.matchPos = $976a3faeb93466fd$var$toCharEnd(this.text, to + (from == to ? 1 : 0));
                    return this;
                }
            }
            if (this.flat.to == this.to) {
                this.done = true;
                return this;
            }
            // Grow the flattened doc
            this.flat = $976a3faeb93466fd$var$FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
        }
    }
}
if (typeof Symbol != "undefined") $976a3faeb93466fd$export$234e2283eb9dcd35.prototype[Symbol.iterator] = $976a3faeb93466fd$var$MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
};
function $976a3faeb93466fd$var$validRegExp(source) {
    try {
        new RegExp(source, $976a3faeb93466fd$var$baseFlags);
        return true;
    } catch (_a) {
        return false;
    }
}
function $976a3faeb93466fd$var$toCharEnd(text, pos) {
    if (pos >= text.length) return pos;
    let line = text.lineAt(pos), next;
    while(pos < line.to && (next = line.text.charCodeAt(pos - line.from)) >= 0xDC00 && next < 0xE000)pos++;
    return pos;
}
function $976a3faeb93466fd$var$createLineDialog(view) {
    let line = String(view.state.doc.lineAt(view.state.selection.main.head).number);
    let input = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
        class: "cm-textfield",
        name: "line",
        value: line
    });
    let dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("form", {
        class: "cm-gotoLine",
        onkeydown: (event)=>{
            if (event.keyCode == 27) {
                event.preventDefault();
                view.dispatch({
                    effects: $976a3faeb93466fd$var$dialogEffect.of(false)
                });
                view.focus();
            } else if (event.keyCode == 13) {
                event.preventDefault();
                go();
            }
        },
        onsubmit: (event)=>{
            event.preventDefault();
            go();
        }
    }, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", view.state.phrase("Go to line"), ": ", input), " ", (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
        class: "cm-button",
        type: "submit"
    }, view.state.phrase("go")));
    function go() {
        let match = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
        if (!match) return;
        let { state: state } = view, startLine = state.doc.lineAt(state.selection.main.head);
        let [, sign, ln, cl, percent] = match;
        let col = cl ? +cl.slice(1) : 0;
        let line = ln ? +ln : startLine.number;
        if (ln && percent) {
            let pc = line / 100;
            if (sign) pc = pc * (sign == "-" ? -1 : 1) + startLine.number / state.doc.lines;
            line = Math.round(state.doc.lines * pc);
        } else if (ln && sign) line = line * (sign == "-" ? -1 : 1) + startLine.number;
        let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line)));
        let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
        view.dispatch({
            effects: [
                $976a3faeb93466fd$var$dialogEffect.of(false),
                (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(selection.from, {
                    y: "center"
                })
            ],
            selection: selection
        });
        view.focus();
    }
    return {
        dom: dom
    };
}
const $976a3faeb93466fd$var$dialogEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$dialogField = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return true;
    },
    update (value, tr) {
        for (let e of tr.effects)if (e.is($976a3faeb93466fd$var$dialogEffect)) value = e.value;
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val ? $976a3faeb93466fd$var$createLineDialog : null)
});
/**
Command that shows a dialog asking the user for a line number, and
when a valid position is provided, moves the cursor to that line.

Supports line numbers, relative line offsets prefixed with `+` or
`-`, document percentages suffixed with `%`, and an optional
column position by adding `:` and a second number after the line
number.
*/ const $976a3faeb93466fd$export$5d5b784f9a618ec3 = (view)=>{
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createLineDialog);
    if (!panel) {
        let effects = [
            $976a3faeb93466fd$var$dialogEffect.of(true)
        ];
        if (view.state.field($976a3faeb93466fd$var$dialogField, false) == null) effects.push((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of([
            $976a3faeb93466fd$var$dialogField,
            $976a3faeb93466fd$var$baseTheme$1
        ]));
        view.dispatch({
            effects: effects
        });
        panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createLineDialog);
    }
    if (panel) panel.dom.querySelector("input").select();
    return true;
};
const $976a3faeb93466fd$var$baseTheme$1 = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-gotoLine": {
        padding: "2px 6px 4px",
        "& label": {
            fontSize: "80%"
        }
    }
});
const $976a3faeb93466fd$var$defaultHighlightOptions = {
    highlightWordAroundCursor: false,
    minSelectionLength: 1,
    maxMatches: 100,
    wholeWords: false
};
const $976a3faeb93466fd$var$highlightConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (options) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(options, $976a3faeb93466fd$var$defaultHighlightOptions, {
            highlightWordAroundCursor: (a, b)=>a || b,
            minSelectionLength: Math.min,
            maxMatches: Math.min
        });
    }
});
/**
This extension highlights text that matches the selection. It uses
the `"cm-selectionMatch"` class for the highlighting. When
`highlightWordAroundCursor` is enabled, the word at the cursor
itself will be highlighted with `"cm-selectionMatch-main"`.
*/ function $976a3faeb93466fd$export$f14efe56171a2e02(options) {
    let ext = [
        $976a3faeb93466fd$var$defaultTheme,
        $976a3faeb93466fd$var$matchHighlighter
    ];
    if (options) ext.push($976a3faeb93466fd$var$highlightConfig.of(options));
    return ext;
}
const $976a3faeb93466fd$var$matchDeco = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch"
});
const $976a3faeb93466fd$var$mainMatchDeco = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-selectionMatch cm-selectionMatch-main"
});
// Whether the characters directly outside the given positions are non-word characters
function $976a3faeb93466fd$var$insideWordBoundaries(check, state, from, to) {
    return (from == 0 || check(state.sliceDoc(from - 1, from)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (to == state.doc.length || check(state.sliceDoc(to, to + 1)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
}
// Whether the characters directly at the given positions are word characters
function $976a3faeb93466fd$var$insideWord(check, state, from, to) {
    return check(state.sliceDoc(from, from + 1)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word && check(state.sliceDoc(to - 1, to)) == (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word;
}
const $976a3faeb93466fd$var$matchHighlighter = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.decorations = this.getDeco(view);
    }
    update(update) {
        if (update.selectionSet || update.docChanged || update.viewportChanged) this.decorations = this.getDeco(update.view);
    }
    getDeco(view) {
        let conf = view.state.facet($976a3faeb93466fd$var$highlightConfig);
        let { state: state } = view, sel = state.selection;
        if (sel.ranges.length > 1) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let range = sel.main, query, check = null;
        if (range.empty) {
            if (!conf.highlightWordAroundCursor) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            let word = state.wordAt(range.head);
            if (!word) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            check = state.charCategorizer(range.head);
            query = state.sliceDoc(word.from, word.to);
        } else {
            let len = range.to - range.from;
            if (len < conf.minSelectionLength || len > 200) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            if (conf.wholeWords) {
                query = state.sliceDoc(range.from, range.to); // TODO: allow and include leading/trailing space?
                check = state.charCategorizer(range.head);
                if (!($976a3faeb93466fd$var$insideWordBoundaries(check, state, range.from, range.to) && $976a3faeb93466fd$var$insideWord(check, state, range.from, range.to))) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            } else {
                query = state.sliceDoc(range.from, range.to);
                if (!query) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
            }
        }
        let deco = [];
        for (let part of view.visibleRanges){
            let cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, part.from, part.to);
            while(!cursor.next().done){
                let { from: from, to: to } = cursor.value;
                if (!check || $976a3faeb93466fd$var$insideWordBoundaries(check, state, from, to)) {
                    if (range.empty && from <= range.from && to >= range.to) deco.push($976a3faeb93466fd$var$mainMatchDeco.range(from, to));
                    else if (from >= range.to || to <= range.from) deco.push($976a3faeb93466fd$var$matchDeco.range(from, to));
                    if (deco.length > conf.maxMatches) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
                }
            }
        }
        return (0, $7beee9608540d2c3$export$10e30b733df217ea).set(deco);
    }
}, {
    decorations: (v)=>v.decorations
});
const $976a3faeb93466fd$var$defaultTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-selectionMatch": {
        backgroundColor: "#99ff7780"
    },
    ".cm-searchMatch .cm-selectionMatch": {
        backgroundColor: "transparent"
    }
});
// Select the words around the cursors.
const $976a3faeb93466fd$var$selectWord = ({ state: state, dispatch: dispatch })=>{
    let { selection: selection } = state;
    let newSel = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(selection.ranges.map((range)=>state.wordAt(range.head) || (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head)), selection.mainIndex);
    if (newSel.eq(selection)) return false;
    dispatch(state.update({
        selection: newSel
    }));
    return true;
};
// Find next occurrence of query relative to last cursor. Wrap around
// the document if there are no more matches.
function $976a3faeb93466fd$var$findNextOccurrence(state, query) {
    let { main: main, ranges: ranges } = state.selection;
    let word = state.wordAt(main.head), fullWord = word && word.from == main.from && word.to == main.to;
    for(let cycled = false, cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, ranges[ranges.length - 1].to);;){
        cursor.next();
        if (cursor.done) {
            if (cycled) return null;
            cursor = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
            cycled = true;
        } else {
            if (cycled && ranges.some((r)=>r.from == cursor.value.from)) continue;
            if (fullWord) {
                let word = state.wordAt(cursor.value.from);
                if (!word || word.from != cursor.value.from || word.to != cursor.value.to) continue;
            }
            return cursor.value;
        }
    }
}
/**
Select next occurrence of the current selection. Expand selection
to the surrounding word when the selection is empty.
*/ const $976a3faeb93466fd$export$dd0e64cebe05ee17 = ({ state: state, dispatch: dispatch })=>{
    let { ranges: ranges } = state.selection;
    if (ranges.some((sel)=>sel.from === sel.to)) return $976a3faeb93466fd$var$selectWord({
        state: state,
        dispatch: dispatch
    });
    let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
    if (state.selection.ranges.some((r)=>state.sliceDoc(r.from, r.to) != searchedText)) return false;
    let range = $976a3faeb93466fd$var$findNextOccurrence(state, searchedText);
    if (!range) return false;
    dispatch(state.update({
        selection: state.selection.addRange((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.from, range.to), false),
        effects: (0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(range.to)
    }));
    return true;
};
const $976a3faeb93466fd$var$searchConfigFacet = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            top: false,
            caseSensitive: false,
            literal: false,
            regexp: false,
            wholeWord: false,
            createPanel: (view)=>new $976a3faeb93466fd$var$SearchPanel(view),
            scrollToMatch: (range)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).scrollIntoView(range)
        });
    }
});
/**
Add search state to the editor configuration, and optionally
configure the search extension.
([`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) will automatically
enable this if it isn't already on).
*/ function $976a3faeb93466fd$export$d76128d007d19019(config) {
    return config ? [
        $976a3faeb93466fd$var$searchConfigFacet.of(config),
        $976a3faeb93466fd$var$searchExtensions
    ] : $976a3faeb93466fd$var$searchExtensions;
}
/**
A search query. Part of the editor's search state.
*/ class $976a3faeb93466fd$export$4bc63ef50ec3954e {
    /**
    Create a query object.
    */ constructor(config){
        this.search = config.search;
        this.caseSensitive = !!config.caseSensitive;
        this.literal = !!config.literal;
        this.regexp = !!config.regexp;
        this.replace = config.replace || "";
        this.valid = !!this.search && (!this.regexp || $976a3faeb93466fd$var$validRegExp(this.search));
        this.unquoted = this.unquote(this.search);
        this.wholeWord = !!config.wholeWord;
    }
    /**
    @internal
    */ unquote(text) {
        return this.literal ? text : text.replace(/\\([nrt\\])/g, (_, ch)=>ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "	" : "\\");
    }
    /**
    Compare this query to another query.
    */ eq(other) {
        return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
    }
    /**
    @internal
    */ create() {
        return this.regexp ? new $976a3faeb93466fd$var$RegExpQuery(this) : new $976a3faeb93466fd$var$StringQuery(this);
    }
    /**
    Get a search cursor for this query, searching through the given
    range in the given state.
    */ getCursor(state, from = 0, to) {
        let st = state.doc ? state : (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create({
            doc: state
        });
        if (to == null) to = st.doc.length;
        return this.regexp ? $976a3faeb93466fd$var$regexpCursor(this, st, from, to) : $976a3faeb93466fd$var$stringCursor(this, st, from, to);
    }
}
class $976a3faeb93466fd$var$QueryType {
    constructor(spec){
        this.spec = spec;
    }
}
function $976a3faeb93466fd$var$stringCursor(spec, state, from, to) {
    return new $976a3faeb93466fd$export$4989b254f32490be(state.doc, spec.unquoted, from, to, spec.caseSensitive ? undefined : (x)=>x.toLowerCase(), spec.wholeWord ? $976a3faeb93466fd$var$stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : undefined);
}
function $976a3faeb93466fd$var$stringWordTest(doc, categorizer) {
    return (from, to, buf, bufPos)=>{
        if (bufPos > from || bufPos + buf.length < to) {
            bufPos = Math.max(0, from - 2);
            buf = doc.sliceString(bufPos, Math.min(doc.length, to + 2));
        }
        return (categorizer($976a3faeb93466fd$var$charBefore(buf, from - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charAfter(buf, from - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (categorizer($976a3faeb93466fd$var$charAfter(buf, to - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charBefore(buf, to - bufPos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
    };
}
class $976a3faeb93466fd$var$StringQuery extends $976a3faeb93466fd$var$QueryType {
    constructor(spec){
        super(spec);
    }
    nextMatch(state, curFrom, curTo) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
        if (cursor.done) cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, 0, curFrom).nextOverlapping();
        return cursor.done ? null : cursor.value;
    }
    // Searching in reverse is, rather than implementing an inverted search
    // cursor, done by scanning chunk after chunk forward.
    prevMatchInRange(state, from, to) {
        for(let pos = to;;){
            let start = Math.max(from, pos - 10000 /* FindPrev.ChunkSize */  - this.spec.unquoted.length);
            let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, start, pos), range = null;
            while(!cursor.nextOverlapping().done)range = cursor.value;
            if (range) return range;
            if (start == from) return null;
            pos -= 10000 /* FindPrev.ChunkSize */ ;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(_result) {
        return this.spec.unquote(this.spec.replace);
    }
    matchAll(state, limit) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $976a3faeb93466fd$var$stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to + this.spec.unquoted.length, state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
function $976a3faeb93466fd$var$regexpCursor(spec, state, from, to) {
    return new $976a3faeb93466fd$export$234e2283eb9dcd35(state.doc, spec.search, {
        ignoreCase: !spec.caseSensitive,
        test: spec.wholeWord ? $976a3faeb93466fd$var$regexpWordTest(state.charCategorizer(state.selection.main.head)) : undefined
    }, from, to);
}
function $976a3faeb93466fd$var$charBefore(str, index) {
    return str.slice((0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(str, index, false), index);
}
function $976a3faeb93466fd$var$charAfter(str, index) {
    return str.slice(index, (0, $6295c6875f57e3ee$export$a0fa439fd515e1ed)(str, index));
}
function $976a3faeb93466fd$var$regexpWordTest(categorizer) {
    return (_from, _to, match)=>!match[0].length || (categorizer($976a3faeb93466fd$var$charBefore(match.input, match.index)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charAfter(match.input, match.index)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) && (categorizer($976a3faeb93466fd$var$charAfter(match.input, match.index + match[0].length)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word || categorizer($976a3faeb93466fd$var$charBefore(match.input, match.index + match[0].length)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word);
}
class $976a3faeb93466fd$var$RegExpQuery extends $976a3faeb93466fd$var$QueryType {
    nextMatch(state, curFrom, curTo) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, curTo, state.doc.length).next();
        if (cursor.done) cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, 0, curFrom).next();
        return cursor.done ? null : cursor.value;
    }
    prevMatchInRange(state, from, to) {
        for(let size = 1;; size++){
            let start = Math.max(from, to - size * 10000 /* FindPrev.ChunkSize */ );
            let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, start, to), range = null;
            while(!cursor.next().done)range = cursor.value;
            if (range && (start == from || range.from > start + 10)) return range;
            if (start == from) return null;
        }
    }
    prevMatch(state, curFrom, curTo) {
        return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
    }
    getReplacement(result) {
        return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (m, i)=>i == "$" ? "$" : i == "&" ? result.match[0] : i != "0" && +i < result.match.length ? result.match[i] : m);
    }
    matchAll(state, limit) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
        while(!cursor.next().done){
            if (ranges.length >= limit) return null;
            ranges.push(cursor.value);
        }
        return ranges;
    }
    highlight(state, from, to, add) {
        let cursor = $976a3faeb93466fd$var$regexpCursor(this.spec, state, Math.max(0, from - 250 /* RegExp.HighlightMargin */ ), Math.min(to + 250 /* RegExp.HighlightMargin */ , state.doc.length));
        while(!cursor.next().done)add(cursor.value.from, cursor.value.to);
    }
}
/**
A state effect that updates the current search query. Note that
this only has an effect if the search state has been initialized
(by including [`search`](https://codemirror.net/6/docs/ref/#search.search) in your configuration or
by running [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel) at least
once).
*/ const $976a3faeb93466fd$export$2cd1e14773f5e71b = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$togglePanel = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $976a3faeb93466fd$var$searchState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create (state) {
        return new $976a3faeb93466fd$var$SearchState($976a3faeb93466fd$var$defaultQuery(state).create(), null);
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($976a3faeb93466fd$export$2cd1e14773f5e71b)) value = new $976a3faeb93466fd$var$SearchState(effect.value.create(), value.panel);
            else if (effect.is($976a3faeb93466fd$var$togglePanel)) value = new $976a3faeb93466fd$var$SearchState(value.query, effect.value ? $976a3faeb93466fd$var$createSearchPanel : null);
        }
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel)
});
/**
Get the current search query from an editor state.
*/ function $976a3faeb93466fd$export$1664b92369554829(state) {
    let curState = state.field($976a3faeb93466fd$var$searchState, false);
    return curState ? curState.query.spec : $976a3faeb93466fd$var$defaultQuery(state);
}
/**
Query whether the search panel is open in the given editor state.
*/ function $976a3faeb93466fd$export$453cecf1765eeb62(state) {
    var _a;
    return ((_a = state.field($976a3faeb93466fd$var$searchState, false)) === null || _a === void 0 ? void 0 : _a.panel) != null;
}
class $976a3faeb93466fd$var$SearchState {
    constructor(query, panel){
        this.query = query;
        this.panel = panel;
    }
}
const $976a3faeb93466fd$var$matchMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-searchMatch"
}), $976a3faeb93466fd$var$selectedMatchMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-searchMatch cm-searchMatch-selected"
});
const $976a3faeb93466fd$var$searchHighlighter = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.decorations = this.highlight(view.state.field($976a3faeb93466fd$var$searchState));
    }
    update(update) {
        let state = update.state.field($976a3faeb93466fd$var$searchState);
        if (state != update.startState.field($976a3faeb93466fd$var$searchState) || update.docChanged || update.selectionSet || update.viewportChanged) this.decorations = this.highlight(state);
    }
    highlight({ query: query, panel: panel }) {
        if (!panel || !query.spec.valid) return (0, $7beee9608540d2c3$export$10e30b733df217ea).none;
        let { view: view } = this;
        let builder = new (0, $6295c6875f57e3ee$export$89e09ce03c7e8594)();
        for(let i = 0, ranges = view.visibleRanges, l = ranges.length; i < l; i++){
            let { from: from, to: to } = ranges[i];
            while(i < l - 1 && to > ranges[i + 1].from - 500 /* RegExp.HighlightMargin */ )to = ranges[++i].to;
            query.highlight(view.state, from, to, (from, to)=>{
                let selected = view.state.selection.ranges.some((r)=>r.from == from && r.to == to);
                builder.add(from, to, selected ? $976a3faeb93466fd$var$selectedMatchMark : $976a3faeb93466fd$var$matchMark);
            });
        }
        return builder.finish();
    }
}, {
    decorations: (v)=>v.decorations
});
function $976a3faeb93466fd$var$searchCommand(f) {
    return (view)=>{
        let state = view.state.field($976a3faeb93466fd$var$searchState, false);
        return state && state.query.spec.valid ? f(view, state) : $976a3faeb93466fd$export$8894af164d40b422(view);
    };
}
/**
Open the search panel if it isn't already open, and move the
selection to the first match after the current main selection.
Will wrap around to the start of the document when it reaches the
end.
*/ const $976a3faeb93466fd$export$ebdf538520f8717 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { to: to } = view.state.selection.main;
    let next = query.nextMatch(view.state, to, to);
    if (!next) return false;
    let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(next.from, next.to);
    let config = view.state.facet($976a3faeb93466fd$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $976a3faeb93466fd$var$announceMatch(view, next),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $976a3faeb93466fd$var$selectSearchInput(view);
    return true;
});
/**
Move the selection to the previous instance of the search query,
before the current main selection. Will wrap past the start
of the document to start searching at the end again.
*/ const $976a3faeb93466fd$export$eef4841c27f82c55 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from } = state.selection.main;
    let prev = query.prevMatch(state, from, from);
    if (!prev) return false;
    let selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(prev.from, prev.to);
    let config = view.state.facet($976a3faeb93466fd$var$searchConfigFacet);
    view.dispatch({
        selection: selection,
        effects: [
            $976a3faeb93466fd$var$announceMatch(view, prev),
            config.scrollToMatch(selection.main, view)
        ],
        userEvent: "select.search"
    });
    $976a3faeb93466fd$var$selectSearchInput(view);
    return true;
});
/**
Select all instances of the search query.
*/ const $976a3faeb93466fd$export$5d21cfc86ff1ce1d = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let ranges = query.matchAll(view.state, 1000);
    if (!ranges || !ranges.length) return false;
    view.dispatch({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.map((r)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.from, r.to))),
        userEvent: "select.search.matches"
    });
    return true;
});
/**
Select all instances of the currently selected text.
*/ const $976a3faeb93466fd$export$6f1c98d8556667b5 = ({ state: state, dispatch: dispatch })=>{
    let sel = state.selection;
    if (sel.ranges.length > 1 || sel.main.empty) return false;
    let { from: from, to: to } = sel.main;
    let ranges = [], main = 0;
    for(let cur = new $976a3faeb93466fd$export$4989b254f32490be(state.doc, state.sliceDoc(from, to)); !cur.next().done;){
        if (ranges.length > 1000) return false;
        if (cur.value.from == from) main = ranges.length;
        ranges.push((0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(cur.value.from, cur.value.to));
    }
    dispatch(state.update({
        selection: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges, main),
        userEvent: "select.search.matches"
    }));
    return true;
};
/**
Replace the current match of the search query.
*/ const $976a3faeb93466fd$export$f9afe47535eaf3d2 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    let { state: state } = view, { from: from, to: to } = state.selection.main;
    if (state.readOnly) return false;
    let next = query.nextMatch(state, from, from);
    if (!next) return false;
    let changes = [], selection, replacement;
    let effects = [];
    if (next.from == from && next.to == to) {
        replacement = state.toText(query.getReplacement(next));
        changes.push({
            from: next.from,
            to: next.to,
            insert: replacement
        });
        next = query.nextMatch(state, next.from, next.to);
        effects.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
    }
    if (next) {
        let off = changes.length == 0 || changes[0].from >= next.to ? 0 : next.to - next.from - replacement.length;
        selection = (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).single(next.from - off, next.to - off);
        effects.push($976a3faeb93466fd$var$announceMatch(view, next));
        effects.push(state.facet($976a3faeb93466fd$var$searchConfigFacet).scrollToMatch(selection.main, view));
    }
    view.dispatch({
        changes: changes,
        selection: selection,
        effects: effects,
        userEvent: "input.replace"
    });
    return true;
});
/**
Replace all instances of the search query with the given
replacement.
*/ const $976a3faeb93466fd$export$b8b3234b4edfc4c2 = /*@__PURE__*/ $976a3faeb93466fd$var$searchCommand((view, { query: query })=>{
    if (view.state.readOnly) return false;
    let changes = query.matchAll(view.state, 1e9).map((match)=>{
        let { from: from, to: to } = match;
        return {
            from: from,
            to: to,
            insert: query.getReplacement(match)
        };
    });
    if (!changes.length) return false;
    let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
    view.dispatch({
        changes: changes,
        effects: (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(announceText),
        userEvent: "input.replace.all"
    });
    return true;
});
function $976a3faeb93466fd$var$createSearchPanel(view) {
    return view.state.facet($976a3faeb93466fd$var$searchConfigFacet).createPanel(view);
}
function $976a3faeb93466fd$var$defaultQuery(state, fallback) {
    var _a, _b, _c, _d, _e;
    let sel = state.selection.main;
    let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
    if (fallback && !selText) return fallback;
    let config = state.facet($976a3faeb93466fd$var$searchConfigFacet);
    return new $976a3faeb93466fd$export$4bc63ef50ec3954e({
        search: ((_a = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a !== void 0 ? _a : config.literal) ? selText : selText.replace(/\n/g, "\\n"),
        caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config.caseSensitive,
        literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config.literal,
        regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config.regexp,
        wholeWord: (_e = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e !== void 0 ? _e : config.wholeWord
    });
}
function $976a3faeb93466fd$var$getSearchInput(view) {
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createSearchPanel);
    return panel && panel.dom.querySelector("[main-field]");
}
function $976a3faeb93466fd$var$selectSearchInput(view) {
    let input = $976a3faeb93466fd$var$getSearchInput(view);
    if (input && input == view.root.activeElement) input.select();
}
/**
Make sure the search panel is open and focused.
*/ const $976a3faeb93466fd$export$8894af164d40b422 = (view)=>{
    let state = view.state.field($976a3faeb93466fd$var$searchState, false);
    if (state && state.panel) {
        let searchInput = $976a3faeb93466fd$var$getSearchInput(view);
        if (searchInput && searchInput != view.root.activeElement) {
            let query = $976a3faeb93466fd$var$defaultQuery(view.state, state.query.spec);
            if (query.valid) view.dispatch({
                effects: $976a3faeb93466fd$export$2cd1e14773f5e71b.of(query)
            });
            searchInput.focus();
            searchInput.select();
        }
    } else view.dispatch({
        effects: [
            $976a3faeb93466fd$var$togglePanel.of(true),
            state ? $976a3faeb93466fd$export$2cd1e14773f5e71b.of($976a3faeb93466fd$var$defaultQuery(view.state, state.query.spec)) : (0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($976a3faeb93466fd$var$searchExtensions)
        ]
    });
    return true;
};
/**
Close the search panel.
*/ const $976a3faeb93466fd$export$4c389f3929badbb8 = (view)=>{
    let state = view.state.field($976a3faeb93466fd$var$searchState, false);
    if (!state || !state.panel) return false;
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $976a3faeb93466fd$var$createSearchPanel);
    if (panel && panel.dom.contains(view.root.activeElement)) view.focus();
    view.dispatch({
        effects: $976a3faeb93466fd$var$togglePanel.of(false)
    });
    return true;
};
/**
Default search-related key bindings.

 - Mod-f: [`openSearchPanel`](https://codemirror.net/6/docs/ref/#search.openSearchPanel)
 - F3, Mod-g: [`findNext`](https://codemirror.net/6/docs/ref/#search.findNext)
 - Shift-F3, Shift-Mod-g: [`findPrevious`](https://codemirror.net/6/docs/ref/#search.findPrevious)
 - Mod-Alt-g: [`gotoLine`](https://codemirror.net/6/docs/ref/#search.gotoLine)
 - Mod-d: [`selectNextOccurrence`](https://codemirror.net/6/docs/ref/#search.selectNextOccurrence)
*/ const $976a3faeb93466fd$export$2dba96787cbe0a4a = [
    {
        key: "Mod-f",
        run: $976a3faeb93466fd$export$8894af164d40b422,
        scope: "editor search-panel"
    },
    {
        key: "F3",
        run: $976a3faeb93466fd$export$ebdf538520f8717,
        shift: $976a3faeb93466fd$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Mod-g",
        run: $976a3faeb93466fd$export$ebdf538520f8717,
        shift: $976a3faeb93466fd$export$eef4841c27f82c55,
        scope: "editor search-panel",
        preventDefault: true
    },
    {
        key: "Escape",
        run: $976a3faeb93466fd$export$4c389f3929badbb8,
        scope: "editor search-panel"
    },
    {
        key: "Mod-Shift-l",
        run: $976a3faeb93466fd$export$6f1c98d8556667b5
    },
    {
        key: "Mod-Alt-g",
        run: $976a3faeb93466fd$export$5d5b784f9a618ec3
    },
    {
        key: "Mod-d",
        run: $976a3faeb93466fd$export$dd0e64cebe05ee17,
        preventDefault: true
    }
];
class $976a3faeb93466fd$var$SearchPanel {
    constructor(view){
        this.view = view;
        let query = this.query = view.state.field($976a3faeb93466fd$var$searchState).query.spec;
        this.commit = this.commit.bind(this);
        this.searchField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            value: query.search,
            placeholder: $976a3faeb93466fd$var$phrase(view, "Find"),
            "aria-label": $976a3faeb93466fd$var$phrase(view, "Find"),
            class: "cm-textfield",
            name: "search",
            form: "",
            "main-field": "true",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.replaceField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            value: query.replace,
            placeholder: $976a3faeb93466fd$var$phrase(view, "Replace"),
            "aria-label": $976a3faeb93466fd$var$phrase(view, "Replace"),
            class: "cm-textfield",
            name: "replace",
            form: "",
            onchange: this.commit,
            onkeyup: this.commit
        });
        this.caseField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "case",
            form: "",
            checked: query.caseSensitive,
            onchange: this.commit
        });
        this.reField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "re",
            form: "",
            checked: query.regexp,
            onchange: this.commit
        });
        this.wordField = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("input", {
            type: "checkbox",
            name: "word",
            form: "",
            checked: query.wholeWord,
            onchange: this.commit
        });
        function button(name, onclick, content) {
            return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
                class: "cm-button",
                name: name,
                onclick: onclick,
                type: "button"
            }, content);
        }
        this.dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
            onkeydown: (e)=>this.keydown(e),
            class: "cm-search"
        }, [
            this.searchField,
            button("next", ()=>$976a3faeb93466fd$export$ebdf538520f8717(view), [
                $976a3faeb93466fd$var$phrase(view, "next")
            ]),
            button("prev", ()=>$976a3faeb93466fd$export$eef4841c27f82c55(view), [
                $976a3faeb93466fd$var$phrase(view, "previous")
            ]),
            button("select", ()=>$976a3faeb93466fd$export$5d21cfc86ff1ce1d(view), [
                $976a3faeb93466fd$var$phrase(view, "all")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.caseField,
                $976a3faeb93466fd$var$phrase(view, "match case")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.reField,
                $976a3faeb93466fd$var$phrase(view, "regexp")
            ]),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("label", null, [
                this.wordField,
                $976a3faeb93466fd$var$phrase(view, "by word")
            ]),
            ...view.state.readOnly ? [] : [
                (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("br"),
                this.replaceField,
                button("replace", ()=>$976a3faeb93466fd$export$f9afe47535eaf3d2(view), [
                    $976a3faeb93466fd$var$phrase(view, "replace")
                ]),
                button("replaceAll", ()=>$976a3faeb93466fd$export$b8b3234b4edfc4c2(view), [
                    $976a3faeb93466fd$var$phrase(view, "replace all")
                ])
            ],
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
                name: "close",
                onclick: ()=>$976a3faeb93466fd$export$4c389f3929badbb8(view),
                "aria-label": $976a3faeb93466fd$var$phrase(view, "close"),
                type: "button"
            }, [
                "\xd7"
            ])
        ]);
    }
    commit() {
        let query = new $976a3faeb93466fd$export$4bc63ef50ec3954e({
            search: this.searchField.value,
            caseSensitive: this.caseField.checked,
            regexp: this.reField.checked,
            wholeWord: this.wordField.checked,
            replace: this.replaceField.value
        });
        if (!query.eq(this.query)) {
            this.query = query;
            this.view.dispatch({
                effects: $976a3faeb93466fd$export$2cd1e14773f5e71b.of(query)
            });
        }
    }
    keydown(e) {
        if ((0, $7beee9608540d2c3$export$bce154f45536286e)(this.view, e, "search-panel")) e.preventDefault();
        else if (e.keyCode == 13 && e.target == this.searchField) {
            e.preventDefault();
            (e.shiftKey ? $976a3faeb93466fd$export$eef4841c27f82c55 : $976a3faeb93466fd$export$ebdf538520f8717)(this.view);
        } else if (e.keyCode == 13 && e.target == this.replaceField) {
            e.preventDefault();
            $976a3faeb93466fd$export$f9afe47535eaf3d2(this.view);
        }
    }
    update(update) {
        for (let tr of update.transactions)for (let effect of tr.effects)if (effect.is($976a3faeb93466fd$export$2cd1e14773f5e71b) && !effect.value.eq(this.query)) this.setQuery(effect.value);
    }
    setQuery(query) {
        this.query = query;
        this.searchField.value = query.search;
        this.replaceField.value = query.replace;
        this.caseField.checked = query.caseSensitive;
        this.reField.checked = query.regexp;
        this.wordField.checked = query.wholeWord;
    }
    mount() {
        this.searchField.select();
    }
    get pos() {
        return 80;
    }
    get top() {
        return this.view.state.facet($976a3faeb93466fd$var$searchConfigFacet).top;
    }
}
function $976a3faeb93466fd$var$phrase(view, phrase) {
    return view.state.phrase(phrase);
}
const $976a3faeb93466fd$var$AnnounceMargin = 30;
const $976a3faeb93466fd$var$Break = /[\s\.,:;?!]/;
function $976a3faeb93466fd$var$announceMatch(view, { from: from, to: to }) {
    let line = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to).to;
    let start = Math.max(line.from, from - $976a3faeb93466fd$var$AnnounceMargin), end = Math.min(lineEnd, to + $976a3faeb93466fd$var$AnnounceMargin);
    let text = view.state.sliceDoc(start, end);
    if (start != line.from) {
        for(let i = 0; i < $976a3faeb93466fd$var$AnnounceMargin; i++)if (!$976a3faeb93466fd$var$Break.test(text[i + 1]) && $976a3faeb93466fd$var$Break.test(text[i])) {
            text = text.slice(i);
            break;
        }
    }
    if (end != lineEnd) {
        for(let i = text.length - 1; i > text.length - $976a3faeb93466fd$var$AnnounceMargin; i--)if (!$976a3faeb93466fd$var$Break.test(text[i - 1]) && $976a3faeb93466fd$var$Break.test(text[i])) {
            text = text.slice(0, i);
            break;
        }
    }
    return (0, $7beee9608540d2c3$export$eece2fccabbb77c5).announce.of(`${view.state.phrase("current match")}. ${text} ${view.state.phrase("on line")} ${line.number}.`);
}
const $976a3faeb93466fd$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-panel.cm-search": {
        padding: "2px 6px 4px",
        position: "relative",
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "4px",
            backgroundColor: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        },
        "& input, & button, & label": {
            margin: ".2em .6em .2em 0"
        },
        "& input[type=checkbox]": {
            marginRight: ".2em"
        },
        "& label": {
            fontSize: "80%",
            whiteSpace: "pre"
        }
    },
    "&light .cm-searchMatch": {
        backgroundColor: "#ffff0054"
    },
    "&dark .cm-searchMatch": {
        backgroundColor: "#00ffff8a"
    },
    "&light .cm-searchMatch-selected": {
        backgroundColor: "#ff6a0054"
    },
    "&dark .cm-searchMatch-selected": {
        backgroundColor: "#ff00ff8a"
    }
});
const $976a3faeb93466fd$var$searchExtensions = [
    $976a3faeb93466fd$var$searchState,
    /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).low($976a3faeb93466fd$var$searchHighlighter),
    $976a3faeb93466fd$var$baseTheme
];





/**
An instance of this is passed to completion source functions.
*/ class $7570a9a1a9679713$export$7b73e80391102dce {
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        /**
        @internal
        */ this.abortListeners = [];
    }
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        let token = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        let line = this.state.doc.lineAt(this.pos);
        let start = Math.max(line.from, this.pos - 250);
        let str = line.text.slice(start - line.from, this.pos - line.from);
        let found = str.search($7570a9a1a9679713$var$ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    */ addEventListener(type, listener) {
        if (type == "abort" && this.abortListeners) this.abortListeners.push(listener);
    }
}
function $7570a9a1a9679713$var$toSet(chars) {
    let flat = Object.keys(chars).join("");
    let words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function $7570a9a1a9679713$var$prefixMatch(options) {
    let first = Object.create(null), rest = Object.create(null);
    for (let { label: label } of options){
        first[label[0]] = true;
        for(let i = 1; i < label.length; i++)rest[label[i]] = true;
    }
    let source = $7570a9a1a9679713$var$toSet(first) + $7570a9a1a9679713$var$toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function $7570a9a1a9679713$export$db0ee7d2648a0c4b(list) {
    let options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    let [validFor, match] = options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : $7570a9a1a9679713$var$prefixMatch(options);
    return (context)=>{
        let token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options: options,
            validFor: validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function $7570a9a1a9679713$export$498fe7f50ed891b8(nodes, source) {
    return (context)=>{
        for(let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return source(context);
            if (pos.type.isTop) break;
        }
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function $7570a9a1a9679713$export$1dfdaeb1e91714c0(nodes, source) {
    return (context)=>{
        for(let pos = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return null;
            if (pos.type.isTop) break;
        }
        return source(context);
    };
}
class $7570a9a1a9679713$var$Option {
    constructor(completion, source, match, score){
        this.completion = completion;
        this.source = source;
        this.match = match;
        this.score = score;
    }
}
function $7570a9a1a9679713$var$cur(state) {
    return state.selection.main.from;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function $7570a9a1a9679713$var$ensureAnchor(expr, start) {
    var _a;
    let { source: source } = expr;
    let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ const $7570a9a1a9679713$export$6c84d44c1ceeb831 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function $7570a9a1a9679713$export$496ff43229d73eba(state, text, from, to) {
    let { main: main } = state.selection, fromOff = from - main.from, toOff = to - main.from;
    return Object.assign(Object.assign({}, state.changeByRange((range)=>{
        if (range != main && from != to && state.sliceDoc(range.from + fromOff, range.from + toOff) != state.sliceDoc(from, to)) return {
            range: range
        };
        return {
            changes: {
                from: range.from + fromOff,
                to: to == main.from ? range.to : range.from + toOff,
                insert: text
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.from + fromOff + text.length)
        };
    })), {
        scrollIntoView: true,
        userEvent: "input.complete"
    });
}
const $7570a9a1a9679713$var$SourceCache = /*@__PURE__*/ new WeakMap();
function $7570a9a1a9679713$var$asSource(source) {
    if (!Array.isArray(source)) return source;
    let known = $7570a9a1a9679713$var$SourceCache.get(source);
    if (!known) $7570a9a1a9679713$var$SourceCache.set(source, known = $7570a9a1a9679713$export$db0ee7d2648a0c4b(source));
    return known;
}
const $7570a9a1a9679713$var$startCompletionEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$closeCompletionEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class $7570a9a1a9679713$var$FuzzyMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        this.score = 0;
        this.matched = [];
        for(let p = 0; p < pattern.length;){
            let char = (0, $6295c6875f57e3ee$export$42977f40461e1360)(pattern, p), size = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(char);
            this.chars.push(char);
            let part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, $6295c6875f57e3ee$export$42977f40461e1360)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
    ret(score, matched) {
        this.score = score;
        this.matched = matched;
        return this;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return a boolean indicating whether there was a match and,
    // on success, set `this.score` to the score, `this.matched` to an
    // array of `from, to` pairs indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return this.ret(-100 /* Penalty.NotFull */ , []);
        if (word.length < this.pattern.length) return null;
        let { chars: chars, folded: folded, any: any, precise: precise, byWord: byWord } = this;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            let first = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, 0), firstSize = (0, $6295c6875f57e3ee$export$a870abf234f6353c)(first);
            let score = firstSize == word.length ? 0 : -100 /* Penalty.NotFull */ ;
            if (first == chars[0]) ;
            else if (first == folded[0]) score += -200 /* Penalty.CaseFold */ ;
            else return null;
            return this.ret(score, [
                0,
                firstSize
            ]);
        }
        let direct = word.indexOf(this.pattern);
        if (direct == 0) return this.ret(word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ , [
            0,
            this.pattern.length
        ]);
        let len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(let i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                let next = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        let preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        let byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        let hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(let i = 0, e = Math.min(word.length, 200), prevType = 0 /* Tp.NonWord */ ; i < e && byWordTo < len;){
            let next = (0, $6295c6875f57e3ee$export$42977f40461e1360)(word, i);
            if (direct < 0) {
                if (preciseTo < len && next == chars[preciseTo]) precise[preciseTo++] = i;
                if (adjacentTo < len) {
                    if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i;
                        adjacentEnd = i + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            let ch, type = next < 0xff ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 /* Tp.Lower */  : next >= 65 && next <= 90 ? 1 /* Tp.Upper */  : 0 /* Tp.NonWord */  : (ch = (0, $6295c6875f57e3ee$export$73bfc63873071f74)(next)) != ch.toLowerCase() ? 1 /* Tp.Upper */  : ch != ch.toUpperCase() ? 2 /* Tp.Lower */  : 0 /* Tp.NonWord */ ;
            if (!i || type == 1 /* Tp.Upper */  && hasLower || prevType == 0 /* Tp.NonWord */  && type != 0 /* Tp.NonWord */ ) {
                if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true)) byWord[byWordTo++] = i;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i += (0, $6295c6875f57e3ee$export$a870abf234f6353c)(next);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return this.ret(-200 /* Penalty.CaseFold */  - word.length + (adjacentEnd == word.length ? 0 : -100 /* Penalty.NotFull */ ), [
            0,
            adjacentEnd
        ]);
        if (direct > -1) return this.ret(-700 /* Penalty.NotStart */  - word.length, [
            direct,
            direct + this.pattern.length
        ]);
        if (adjacentTo == len) return this.ret(-900 /* Penalty.NotStart */  - word.length, [
            adjacentStart,
            adjacentEnd
        ]);
        if (byWordTo == len) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0) + -700 /* Penalty.NotStart */  + (wordAdjacent ? 0 : -1100 /* Penalty.Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* Penalty.NotStart */  : 0) + -200 /* Penalty.CaseFold */  + -1100 /* Penalty.Gap */ , any, word);
    }
    result(score, positions, word) {
        let result = [], i = 0;
        for (let pos of positions){
            let to = pos + (this.astral ? (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(word, pos)) : 1);
            if (i && result[i - 1] == pos) result[i - 1] = to;
            else {
                result[i++] = pos;
                result[i++] = to;
            }
        }
        return this.ret(score - word.length, result);
    }
}
class $7570a9a1a9679713$var$StrictMatcher {
    constructor(pattern){
        this.pattern = pattern;
        this.matched = [];
        this.score = 0;
        this.folded = pattern.toLowerCase();
    }
    match(word) {
        if (word.length < this.pattern.length) return null;
        let start = word.slice(0, this.pattern.length);
        let match = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 /* Penalty.CaseFold */  : null;
        if (match == null) return null;
        this.matched = [
            0,
            start.length
        ];
        this.score = match + (word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ );
        return this;
    }
}
const $7570a9a1a9679713$var$completionConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            activateOnTyping: true,
            activateOnCompletion: ()=>false,
            activateOnTypingDelay: 100,
            selectOnOpen: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            tooltipClass: ()=>"",
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: [],
            positionInfo: $7570a9a1a9679713$var$defaultPositionInfo,
            filterStrict: false,
            compareCompletions: (a, b)=>a.label.localeCompare(b.label),
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            tooltipClass: (a, b)=>(c)=>$7570a9a1a9679713$var$joinClass(a(c), b(c)),
            optionClass: (a, b)=>(c)=>$7570a9a1a9679713$var$joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b),
            filterStrict: (a, b)=>a || b
        });
    }
});
function $7570a9a1a9679713$var$joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function $7570a9a1a9679713$var$defaultPositionInfo(view, list, option, info, space, tooltip) {
    let rtl = view.textDirection == (0, $7beee9608540d2c3$export$cacd6541cfeeb6c1).RTL, left = rtl, narrow = false;
    let side = "top", offset, maxWidth;
    let spaceLeft = list.left - space.left, spaceRight = space.right - list.right;
    let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
    if (left && spaceLeft < Math.min(infoWidth, spaceRight)) left = false;
    else if (!left && spaceRight < Math.min(infoWidth, spaceLeft)) left = true;
    if (infoWidth <= (left ? spaceLeft : spaceRight)) {
        offset = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list.top;
        maxWidth = Math.min(400 /* Info.Width */ , left ? spaceLeft : spaceRight);
    } else {
        narrow = true;
        maxWidth = Math.min(400 /* Info.Width */ , (rtl ? list.right : space.right - list.left) - 30 /* Info.Margin */ );
        let spaceBelow = space.bottom - list.bottom;
        if (spaceBelow >= infoHeight || spaceBelow > list.top) offset = option.bottom - list.top;
        else {
            side = "bottom";
            offset = list.bottom - option.top;
        }
    }
    let scaleY = (list.bottom - list.top) / tooltip.offsetHeight;
    let scaleX = (list.right - list.left) / tooltip.offsetWidth;
    return {
        style: `${side}: ${offset / scaleY}px; max-width: ${maxWidth / scaleX}px`,
        class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
    };
}
function $7570a9a1a9679713$var$optionContent(config) {
    let content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            let icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, _v, match) {
            let labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            let label = completion.displayLabel || completion.label, off = 0;
            for(let j = 0; j < match.length;){
                let from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                let span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            let detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function $7570a9a1a9679713$var$rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected < 0) selected = 0;
    if (selected <= total >> 1) {
        let off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    let off = Math.floor((total - selected) / max);
    return {
        from: total - (off + 1) * max,
        to: total - off * max
    };
}
class $7570a9a1a9679713$var$CompletionTooltip {
    constructor(view, stateField, applyCompletion){
        this.view = view;
        this.stateField = stateField;
        this.applyCompletion = applyCompletion;
        this.info = null;
        this.infoDestroy = null;
        this.placeInfoReq = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.placeInfo(pos),
            key: this
        };
        this.space = null;
        this.currentClass = "";
        let cState = view.state.field(stateField);
        let { options: options, selected: selected } = cState.open;
        let config = view.state.facet($7570a9a1a9679713$var$completionConfig);
        this.optionContent = $7570a9a1a9679713$var$optionContent(config);
        this.optionClass = config.optionClass;
        this.tooltipClass = config.tooltipClass;
        this.range = $7570a9a1a9679713$var$rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.updateTooltipClass(view.state);
        this.dom.addEventListener("mousedown", (e)=>{
            let { options: options } = view.state.field(stateField).open;
            for(let dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                this.applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
        });
        this.dom.addEventListener("focusout", (e)=>{
            let state = view.state.field(this.stateField, false);
            if (state && state.tooltip && view.state.facet($7570a9a1a9679713$var$completionConfig).closeOnBlur && e.relatedTarget != view.contentDOM) view.dispatch({
                effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
            });
        });
        this.showOptions(options, cState.id);
    }
    mount() {
        this.updateSel();
    }
    showOptions(options, id) {
        if (this.list) this.list.remove();
        this.list = this.dom.appendChild(this.createListBox(options, id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfoReq);
        });
    }
    update(update) {
        var _a;
        let cState = update.state.field(this.stateField);
        let prevState = update.startState.field(this.stateField);
        this.updateTooltipClass(update.state);
        if (cState != prevState) {
            let { options: options, selected: selected, disabled: disabled } = cState.open;
            if (!prevState.open || prevState.open.options != options) {
                this.range = $7570a9a1a9679713$var$rangeAroundSelected(options.length, selected, update.state.facet($7570a9a1a9679713$var$completionConfig).maxRenderedOptions);
                this.showOptions(options, cState.id);
            }
            this.updateSel();
            if (disabled != ((_a = prevState.open) === null || _a === void 0 ? void 0 : _a.disabled)) this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
        }
    }
    updateTooltipClass(state) {
        let cls = this.tooltipClass(state);
        if (cls != this.currentClass) {
            for (let c of this.currentClass.split(" "))if (c) this.dom.classList.remove(c);
            for (let c of cls.split(" "))if (c) this.dom.classList.add(c);
            this.currentClass = cls;
        }
    }
    positioned(space) {
        this.space = space;
        if (this.info) this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
        let cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = $7570a9a1a9679713$var$rangeAroundSelected(open.options.length, open.selected, this.view.state.facet($7570a9a1a9679713$var$completionConfig).maxRenderedOptions);
            this.showOptions(open.options, cState.id);
        }
        if (this.updateSelectedOption(open.selected)) {
            this.destroyInfo();
            let { completion: completion } = open.options[open.selected];
            let { info: info } = completion;
            if (!info) return;
            let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ("then" in infoResult) infoResult.then((obj)=>{
                if (obj && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(obj, completion);
            }).catch((e)=>(0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, e, "completion info"));
            else this.addInfoPane(infoResult, completion);
        }
    }
    addInfoPane(content, completion) {
        this.destroyInfo();
        let wrap = this.info = document.createElement("div");
        wrap.className = "cm-tooltip cm-completionInfo";
        if (content.nodeType != null) {
            wrap.appendChild(content);
            this.infoDestroy = null;
        } else {
            let { dom: dom, destroy: destroy } = content;
            wrap.appendChild(dom);
            this.infoDestroy = destroy || null;
        }
        this.dom.appendChild(wrap);
        this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(selected) {
        let set = null;
        for(let opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (opt.nodeName != "LI" || !opt.id) i--; // A section header
            else if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) opt.removeAttribute("aria-selected");
        }
        if (set) $7570a9a1a9679713$var$scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        let sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        let listRect = this.dom.getBoundingClientRect();
        let infoRect = this.info.getBoundingClientRect();
        let selRect = sel.getBoundingClientRect();
        let space = this.space;
        if (!space) {
            let win = this.dom.ownerDocument.defaultView || window;
            space = {
                left: 0,
                top: 0,
                right: win.innerWidth,
                bottom: win.innerHeight
            };
        }
        if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10) return null;
        return this.view.state.facet($7570a9a1a9679713$var$completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
    }
    placeInfo(pos) {
        if (this.info) {
            if (pos) {
                if (pos.style) this.info.style.cssText = pos.style;
                this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
            } else this.info.style.cssText = "top: -1e6px";
        }
    }
    createListBox(options, id, range) {
        const ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        let curSection = null;
        for(let i = range.from; i < range.to; i++){
            let { completion: completion, match: match } = options[i], { section: section } = completion;
            if (section) {
                let name = typeof section == "string" ? section : section.name;
                if (name != curSection && (i > range.from || range.from == 0)) {
                    curSection = name;
                    if (typeof section != "string" && section.header) ul.appendChild(section.header(section));
                    else {
                        let header = ul.appendChild(document.createElement("completion-section"));
                        header.textContent = name;
                    }
                }
            }
            const li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            let cls = this.optionClass(completion);
            if (cls) li.className = cls;
            for (let source of this.optionContent){
                let node = source(completion, this.view.state, this.view, match);
                if (node) li.appendChild(node);
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
    destroyInfo() {
        if (this.info) {
            if (this.infoDestroy) this.infoDestroy();
            this.info.remove();
            this.info = null;
        }
    }
    destroy() {
        this.destroyInfo();
    }
}
function $7570a9a1a9679713$var$completionTooltip(stateField, applyCompletion) {
    return (view)=>new $7570a9a1a9679713$var$CompletionTooltip(view, stateField, applyCompletion);
}
function $7570a9a1a9679713$var$scrollIntoView(container, element) {
    let parent = container.getBoundingClientRect();
    let self = element.getBoundingClientRect();
    let scaleY = parent.height / container.offsetHeight;
    if (self.top < parent.top) container.scrollTop -= (parent.top - self.top) / scaleY;
    else if (self.bottom > parent.bottom) container.scrollTop += (self.bottom - parent.bottom) / scaleY;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function $7570a9a1a9679713$var$score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function $7570a9a1a9679713$var$sortOptions(active, state) {
    let options = [];
    let sections = null;
    let addOption = (option)=>{
        options.push(option);
        let { section: section } = option.completion;
        if (section) {
            if (!sections) sections = [];
            let name = typeof section == "string" ? section : section.name;
            if (!sections.some((s)=>s.name == name)) sections.push(typeof section == "string" ? {
                name: name
            } : section);
        }
    };
    let conf = state.facet($7570a9a1a9679713$var$completionConfig);
    for (let a of active)if (a.hasResult()) {
        let getMatch = a.result.getMatch;
        if (a.result.filter === false) for (let option of a.result.options)addOption(new $7570a9a1a9679713$var$Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
        else {
            let pattern = state.sliceDoc(a.from, a.to), match;
            let matcher = conf.filterStrict ? new $7570a9a1a9679713$var$StrictMatcher(pattern) : new $7570a9a1a9679713$var$FuzzyMatcher(pattern);
            for (let option of a.result.options)if (match = matcher.match(option.label)) {
                let matched = !option.displayLabel ? match.matched : getMatch ? getMatch(option, match.matched) : [];
                addOption(new $7570a9a1a9679713$var$Option(option, a.source, matched, match.score + (option.boost || 0)));
            }
        }
    }
    if (sections) {
        let sectionOrder = Object.create(null), pos = 0;
        let cmp = (a, b)=>{
            var _a, _b;
            return ((_a = a.rank) !== null && _a !== void 0 ? _a : 1e9) - ((_b = b.rank) !== null && _b !== void 0 ? _b : 1e9) || (a.name < b.name ? -1 : 1);
        };
        for (let s of sections.sort(cmp)){
            pos -= 1e5;
            sectionOrder[s.name] = pos;
        }
        for (let option of options){
            let { section: section } = option.completion;
            if (section) option.score += sectionOrder[typeof section == "string" ? section : section.name];
        }
    }
    let result = [], prev = null;
    let compare = conf.compareCompletions;
    for (let opt of options.sort((a, b)=>b.score - a.score || compare(a.completion, b.completion))){
        let cur = opt.completion;
        if (!prev || prev.label != cur.label || prev.detail != cur.detail || prev.type != null && cur.type != null && prev.type != cur.type || prev.apply != cur.apply || prev.boost != cur.boost) result.push(opt);
        else if ($7570a9a1a9679713$var$score(opt.completion) > $7570a9a1a9679713$var$score(prev)) result[result.length - 1] = opt;
        prev = opt.completion;
    }
    return result;
}
class $7570a9a1a9679713$var$CompletionDialog {
    constructor(options, attrs, tooltip, timestamp, selected, disabled){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
        this.disabled = disabled;
    }
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new $7570a9a1a9679713$var$CompletionDialog(this.options, $7570a9a1a9679713$var$makeAttrs(id, selected), this.tooltip, this.timestamp, selected, this.disabled);
    }
    static build(active, state, id, prev, conf) {
        let options = $7570a9a1a9679713$var$sortOptions(active, state);
        if (!options.length) return prev && active.some((a)=>a.state == 1 /* State.Pending */ ) ? new $7570a9a1a9679713$var$CompletionDialog(prev.options, prev.attrs, prev.tooltip, prev.timestamp, prev.selected, true) : null;
        let selected = state.facet($7570a9a1a9679713$var$completionConfig).selectOnOpen ? 0 : -1;
        if (prev && prev.selected != selected && prev.selected != -1) {
            let selectedValue = prev.options[prev.selected].completion;
            for(let i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new $7570a9a1a9679713$var$CompletionDialog(options, $7570a9a1a9679713$var$makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: $7570a9a1a9679713$var$createTooltip,
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected, false);
    }
    map(changes) {
        return new $7570a9a1a9679713$var$CompletionDialog(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
            pos: changes.mapPos(this.tooltip.pos)
        }), this.timestamp, this.selected, this.disabled);
    }
}
class $7570a9a1a9679713$var$CompletionState {
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
    static start() {
        return new $7570a9a1a9679713$var$CompletionState($7570a9a1a9679713$var$none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        let { state: state } = tr, conf = state.facet($7570a9a1a9679713$var$completionConfig);
        let sources = conf.override || state.languageDataAt("autocomplete", $7570a9a1a9679713$var$cur(state)).map($7570a9a1a9679713$var$asSource);
        let active = sources.map((source)=>{
            let value = this.active.find((s)=>s.source == source) || new $7570a9a1a9679713$var$ActiveSource(source, this.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        let open = this.open;
        if (open && tr.docChanged) open = open.map(tr.changes);
        if (tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !$7570a9a1a9679713$var$sameResults(active, this.active)) open = $7570a9a1a9679713$var$CompletionDialog.build(active, state, this.id, open, conf);
        else if (open && open.disabled && !active.some((a)=>a.state == 1 /* State.Pending */ )) open = null;
        if (!open && active.every((a)=>a.state != 1 /* State.Pending */ ) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new $7570a9a1a9679713$var$ActiveSource(a.source, 0 /* State.Inactive */ ) : a);
        for (let effect of tr.effects)if (effect.is($7570a9a1a9679713$var$setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
        return active == this.active && open == this.open ? this : new $7570a9a1a9679713$var$CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : this.active.length ? $7570a9a1a9679713$var$baseAttrs : $7570a9a1a9679713$var$noAttrs;
    }
}
function $7570a9a1a9679713$var$sameResults(a, b) {
    if (a == b) return true;
    for(let iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult)iA++;
        while(iB < b.length && !b[iB].hasResult)iB++;
        let endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
const $7570a9a1a9679713$var$baseAttrs = {
    "aria-autocomplete": "list"
};
const $7570a9a1a9679713$var$noAttrs = {};
function $7570a9a1a9679713$var$makeAttrs(id, selected) {
    let result = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": id
    };
    if (selected > -1) result["aria-activedescendant"] = id + "-" + selected;
    return result;
}
const $7570a9a1a9679713$var$none = [];
function $7570a9a1a9679713$var$getUserEvent(tr, conf) {
    if (tr.isUserEvent("input.complete")) {
        let completion = tr.annotation($7570a9a1a9679713$export$6c84d44c1ceeb831);
        if (completion && conf.activateOnCompletion(completion)) return "input";
    }
    return tr.isUserEvent("input.type") ? "input" : tr.isUserEvent("delete.backward") ? "delete" : null;
}
class $7570a9a1a9679713$var$ActiveSource {
    constructor(source, state, explicitPos = -1){
        this.source = source;
        this.state = state;
        this.explicitPos = explicitPos;
    }
    hasResult() {
        return false;
    }
    update(tr, conf) {
        let event = $7570a9a1a9679713$var$getUserEvent(tr, conf), value = this;
        if (event) value = value.handleUserEvent(tr, event, conf);
        else if (tr.docChanged) value = value.handleChange(tr);
        else if (tr.selection && value.state != 0 /* State.Inactive */ ) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 0 /* State.Inactive */ );
        for (let effect of tr.effects){
            if (effect.is($7570a9a1a9679713$var$startCompletionEffect)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 1 /* State.Pending */ , effect.value ? $7570a9a1a9679713$var$cur(tr.state) : -1);
            else if (effect.is($7570a9a1a9679713$var$closeCompletionEffect)) value = new $7570a9a1a9679713$var$ActiveSource(value.source, 0 /* State.Inactive */ );
            else if (effect.is($7570a9a1a9679713$var$setActiveEffect)) {
                for (let active of effect.value)if (active.source == value.source) value = active;
            }
        }
        return value;
    }
    handleUserEvent(tr, type, conf) {
        return type == "delete" || !conf.activateOnTyping ? this.map(tr.changes) : new $7570a9a1a9679713$var$ActiveSource(this.source, 1 /* State.Pending */ );
    }
    handleChange(tr) {
        return tr.changes.touchesRange($7570a9a1a9679713$var$cur(tr.startState)) ? new $7570a9a1a9679713$var$ActiveSource(this.source, 0 /* State.Inactive */ ) : this.map(tr.changes);
    }
    map(changes) {
        return changes.empty || this.explicitPos < 0 ? this : new $7570a9a1a9679713$var$ActiveSource(this.source, this.state, changes.mapPos(this.explicitPos));
    }
}
class $7570a9a1a9679713$var$ActiveResult extends $7570a9a1a9679713$var$ActiveSource {
    constructor(source, explicitPos, result, from, to){
        super(source, 2 /* State.Result */ , explicitPos);
        this.result = result;
        this.from = from;
        this.to = to;
    }
    hasResult() {
        return true;
    }
    handleUserEvent(tr, type, conf) {
        var _a;
        let result = this.result;
        if (result.map && !tr.changes.empty) result = result.map(result, tr.changes);
        let from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        let pos = $7570a9a1a9679713$var$cur(tr.state);
        if ((this.explicitPos < 0 ? pos <= from : pos < this.from) || pos > to || !result || type == "delete" && $7570a9a1a9679713$var$cur(tr.startState) == this.from) return new $7570a9a1a9679713$var$ActiveSource(this.source, type == "input" && conf.activateOnTyping ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
        let explicitPos = this.explicitPos < 0 ? -1 : tr.changes.mapPos(this.explicitPos);
        if ($7570a9a1a9679713$var$checkValid(result.validFor, tr.state, from, to)) return new $7570a9a1a9679713$var$ActiveResult(this.source, explicitPos, result, from, to);
        if (result.update && (result = result.update(result, from, to, new $7570a9a1a9679713$export$7b73e80391102dce(tr.state, pos, explicitPos >= 0)))) return new $7570a9a1a9679713$var$ActiveResult(this.source, explicitPos, result, result.from, (_a = result.to) !== null && _a !== void 0 ? _a : $7570a9a1a9679713$var$cur(tr.state));
        return new $7570a9a1a9679713$var$ActiveSource(this.source, 1 /* State.Pending */ , explicitPos);
    }
    handleChange(tr) {
        return tr.changes.touchesRange(this.from, this.to) ? new $7570a9a1a9679713$var$ActiveSource(this.source, 0 /* State.Inactive */ ) : this.map(tr.changes);
    }
    map(mapping) {
        if (mapping.empty) return this;
        let result = this.result.map ? this.result.map(this.result, mapping) : this.result;
        if (!result) return new $7570a9a1a9679713$var$ActiveSource(this.source, 0 /* State.Inactive */ );
        return new $7570a9a1a9679713$var$ActiveResult(this.source, this.explicitPos < 0 ? -1 : mapping.mapPos(this.explicitPos), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
}
function $7570a9a1a9679713$var$checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    let text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : $7570a9a1a9679713$var$ensureAnchor(validFor, true).test(text);
}
const $7570a9a1a9679713$var$setActiveEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
const $7570a9a1a9679713$var$setSelectedEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$completionState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return $7570a9a1a9679713$var$CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, $7beee9608540d2c3$export$dba11b50e1aa3c12).from(f, (val)=>val.tooltip),
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
function $7570a9a1a9679713$var$applyCompletion(view, option) {
    const apply = option.completion.apply || option.completion.label;
    let result = view.state.field($7570a9a1a9679713$var$completionState).active.find((a)=>a.source == option.source);
    if (!(result instanceof $7570a9a1a9679713$var$ActiveResult)) return false;
    if (typeof apply == "string") view.dispatch(Object.assign(Object.assign({}, $7570a9a1a9679713$export$496ff43229d73eba(view.state, apply, result.from, result.to)), {
        annotations: $7570a9a1a9679713$export$6c84d44c1ceeb831.of(option.completion)
    }));
    else apply(view, option.completion, result.from, result.to);
    return true;
}
const $7570a9a1a9679713$var$createTooltip = /*@__PURE__*/ $7570a9a1a9679713$var$completionTooltip($7570a9a1a9679713$var$completionState, $7570a9a1a9679713$var$applyCompletion);
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function $7570a9a1a9679713$export$26f3a479ac65d653(forward, by = "option") {
    return (view)=>{
        let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
        if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($7570a9a1a9679713$var$completionConfig).interactionDelay) return false;
        let step = 1, tooltip;
        if (by == "page" && (tooltip = (0, $7beee9608540d2c3$export$46455b4476d4b8e1)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        let { length: length } = cState.open.options;
        let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: $7570a9a1a9679713$var$setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ const $7570a9a1a9679713$export$537623a3380ccdae = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($7570a9a1a9679713$var$completionConfig).interactionDelay) return false;
    return $7570a9a1a9679713$var$applyCompletion(view, cState.open.options[cState.open.selected]);
};
/**
Explicitly start autocompletion.
*/ const $7570a9a1a9679713$export$8a36416d28f82fd5 = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: $7570a9a1a9679713$var$startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ const $7570a9a1a9679713$export$bdc62126738c63ab = (view)=>{
    let cState = view.state.field($7570a9a1a9679713$var$completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* State.Inactive */ )) return false;
    view.dispatch({
        effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
    });
    return true;
};
class $7570a9a1a9679713$var$RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
const $7570a9a1a9679713$var$MaxUpdateCount = 50, $7570a9a1a9679713$var$MinAbortTime = 1000;
const $7570a9a1a9679713$var$completionPlugin = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.pendingStart = false;
        this.composing = 0 /* CompositionState.None */ ;
        for (let active of view.state.field($7570a9a1a9679713$var$completionState).active)if (active.state == 1 /* State.Pending */ ) this.startQuery(active);
    }
    update(update) {
        let cState = update.state.field($7570a9a1a9679713$var$completionState);
        let conf = update.state.facet($7570a9a1a9679713$var$completionConfig);
        if (!update.selectionSet && !update.docChanged && update.startState.field($7570a9a1a9679713$var$completionState) == cState) return;
        let doesReset = update.transactions.some((tr)=>{
            return (tr.selection || tr.docChanged) && !$7570a9a1a9679713$var$getUserEvent(tr, conf);
        });
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (doesReset || query.updates.length + update.transactions.length > $7570a9a1a9679713$var$MaxUpdateCount && Date.now() - query.time > $7570a9a1a9679713$var$MinAbortTime) {
                for (let handler of query.context.abortListeners)try {
                    handler();
                } catch (e) {
                    (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, e);
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        if (update.transactions.some((tr)=>tr.effects.some((e)=>e.is($7570a9a1a9679713$var$startCompletionEffect)))) this.pendingStart = true;
        let delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
        this.debounceUpdate = cState.active.some((a)=>a.state == 1 /* State.Pending */  && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), delay) : -1;
        if (this.composing != 0 /* CompositionState.None */ ) for (let tr of update.transactions){
            if ($7570a9a1a9679713$var$getUserEvent(tr, conf) == "input") this.composing = 2 /* CompositionState.Changed */ ;
            else if (this.composing == 2 /* CompositionState.Changed */  && tr.selection) this.composing = 3 /* CompositionState.ChangedAndMoved */ ;
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        this.pendingStart = false;
        let { state: state } = this.view, cState = state.field($7570a9a1a9679713$var$completionState);
        for (let active of cState.active)if (active.state == 1 /* State.Pending */  && !this.running.some((r)=>r.active.source == active.source)) this.startQuery(active);
    }
    startQuery(active) {
        let { state: state } = this.view, pos = $7570a9a1a9679713$var$cur(state);
        let context = new $7570a9a1a9679713$export$7b73e80391102dce(state, pos, active.explicitPos == pos);
        let pending = new $7570a9a1a9679713$var$RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
            });
            (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($7570a9a1a9679713$var$completionConfig).updateSyncTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        let updated = [];
        let conf = this.view.state.facet($7570a9a1a9679713$var$completionConfig);
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (query.done === undefined) continue;
            this.running.splice(i--, 1);
            if (query.done) {
                let active = new $7570a9a1a9679713$var$ActiveResult(query.active.source, query.active.explicitPos, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : $7570a9a1a9679713$var$cur(query.updates.length ? query.updates[0].startState : this.view.state));
                // Replay the transactions that happened since the start of
                // the request and see if that preserves the result
                for (let tr of query.updates)active = active.update(tr, conf);
                if (active.hasResult()) {
                    updated.push(active);
                    continue;
                }
            }
            let current = this.view.state.field($7570a9a1a9679713$var$completionState).active.find((a)=>a.source == query.active.source);
            if (current && current.state == 1 /* State.Pending */ ) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    let active = new $7570a9a1a9679713$var$ActiveSource(query.active.source, 0 /* State.Inactive */ );
                    for (let tr of query.updates)active = active.update(tr, conf);
                    if (active.state != 1 /* State.Pending */ ) updated.push(active);
                } else // Cleared by subsequent transactions. Restart.
                this.startQuery(current);
            }
        }
        if (updated.length) this.view.dispatch({
            effects: $7570a9a1a9679713$var$setActiveEffect.of(updated)
        });
    }
}, {
    eventHandlers: {
        blur (event) {
            let state = this.view.state.field($7570a9a1a9679713$var$completionState, false);
            if (state && state.tooltip && this.view.state.facet($7570a9a1a9679713$var$completionConfig).closeOnBlur) {
                let dialog = state.open && (0, $7beee9608540d2c3$export$46455b4476d4b8e1)(this.view, state.open.tooltip);
                if (!dialog || !dialog.dom.contains(event.relatedTarget)) setTimeout(()=>this.view.dispatch({
                        effects: $7570a9a1a9679713$var$closeCompletionEffect.of(null)
                    }), 10);
            }
        },
        compositionstart () {
            this.composing = 1 /* CompositionState.Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* CompositionState.ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: $7570a9a1a9679713$var$startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* CompositionState.None */ ;
        }
    }
});
const $7570a9a1a9679713$var$windows = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform);
const $7570a9a1a9679713$var$commitCharacters = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
    keydown (event, view) {
        let field = view.state.field($7570a9a1a9679713$var$completionState, false);
        if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !($7570a9a1a9679713$var$windows && event.altKey) || event.metaKey) return false;
        let option = field.open.options[field.open.selected];
        let result = field.active.find((a)=>a.source == option.source);
        let commitChars = option.completion.commitCharacters || result.result.commitCharacters;
        if (commitChars && commitChars.indexOf(event.key) > -1) $7570a9a1a9679713$var$applyCompletion(view, option);
        return false;
    }
}));
const $7570a9a1a9679713$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: 0.7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: `${400 /* Info.Width */ }px`,
        boxSizing: "border-box"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: `${30 /* Info.Margin */ }px`
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: `${30 /* Info.Margin */ }px`
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class $7570a9a1a9679713$var$FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class $7570a9a1a9679713$var$FieldRange {
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
    map(changes) {
        let from = changes.mapPos(this.from, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
        let to = changes.mapPos(this.to, 1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackDel);
        return from == null || to == null ? null : new $7570a9a1a9679713$var$FieldRange(this.field, from, to);
    }
}
class $7570a9a1a9679713$var$Snippet {
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
    instantiate(state, pos) {
        let text = [], lineStart = [
            pos
        ];
        let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        for (let line of this.lines){
            if (text.length) {
                let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                for(let i = 0; i < tabs; i++)indent += state.facet((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5));
                lineStart.push(pos + indent.length - tabs);
                line = indent + line.slice(tabs);
            }
            text.push(line);
            pos += line.length + 1;
        }
        let ranges = this.fieldPositions.map((pos)=>new $7570a9a1a9679713$var$FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text: text,
            ranges: ranges
        };
    }
    static parse(template) {
        let fields = [];
        let lines = [], positions = [], m;
        for (let line of template.split(/\r\n?|\n/)){
            while(m = /[#$]\{(?:(\d+)(?::([^}]*))?|((?:\\[{}]|[^}])*))\}/.exec(line)){
                let seq = m[1] ? +m[1] : null, rawName = m[2] || m[3] || "", found = -1;
                let name = rawName.replace(/\\[{}]/g, (m)=>m[1]);
                for(let i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                if (found < 0) {
                    let i = 0;
                    while(i < fields.length && (seq == null || fields[i].seq != null && fields[i].seq < seq))i++;
                    fields.splice(i, 0, {
                        seq: seq,
                        name: name
                    });
                    found = i;
                    for (let pos of positions)if (pos.field >= found) pos.field++;
                }
                positions.push(new $7570a9a1a9679713$var$FieldPos(found, lines.length, m.index, m.index + name.length));
                line = line.slice(0, m.index) + rawName + line.slice(m.index + m[0].length);
            }
            line = line.replace(/\\([{}])/g, (_, brace, index)=>{
                for (let pos of positions)if (pos.line == lines.length && pos.from > index) {
                    pos.from--;
                    pos.to--;
                }
                return brace;
            });
            lines.push(line);
        }
        return new $7570a9a1a9679713$var$Snippet(lines, positions);
    }
}
let $7570a9a1a9679713$var$fieldMarker = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).widget({
    widget: /*@__PURE__*/ new class extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
        toDOM() {
            let span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
let $7570a9a1a9679713$var$fieldRange = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-snippetField"
});
class $7570a9a1a9679713$var$ActiveSnippet {
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, $7beee9608540d2c3$export$10e30b733df217ea).set(ranges.map((r)=>(r.from == r.to ? $7570a9a1a9679713$var$fieldMarker : $7570a9a1a9679713$var$fieldRange).range(r.from, r.to)));
    }
    map(changes) {
        let ranges = [];
        for (let r of this.ranges){
            let mapped = r.map(changes);
            if (!mapped) return null;
            ranges.push(mapped);
        }
        return new $7570a9a1a9679713$var$ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
}
const $7570a9a1a9679713$var$setActive = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
const $7570a9a1a9679713$var$moveToField = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $7570a9a1a9679713$var$snippetState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($7570a9a1a9679713$var$setActive)) return effect.value;
            if (effect.is($7570a9a1a9679713$var$moveToField) && value) return new $7570a9a1a9679713$var$ActiveSnippet(value.ranges, effect.value);
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f, (val)=>val ? val.deco : (0, $7beee9608540d2c3$export$10e30b733df217ea).none)
});
function $7570a9a1a9679713$var$fieldSelection(ranges, field) {
    return (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).create(ranges.filter((r)=>r.field == field).map((r)=>(0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order.

To include a literal `{` or `}` in your template, put a backslash
in front of it. This will be removed and the brace will not be
interpreted as indicating a placeholder.
*/ function $7570a9a1a9679713$export$f77f1ac5bf251232(template) {
    let snippet = $7570a9a1a9679713$var$Snippet.parse(template);
    return (editor, completion, from, to)=>{
        let { text: text, ranges: ranges } = snippet.instantiate(editor.state, from);
        let spec = {
            changes: {
                from: from,
                to: to,
                insert: (0, $6295c6875f57e3ee$export$5f1af8db9871e1d6).of(text)
            },
            scrollIntoView: true,
            annotations: completion ? [
                $7570a9a1a9679713$export$6c84d44c1ceeb831.of(completion),
                (0, $6295c6875f57e3ee$export$febc5573c75cefb0).userEvent.of("input.complete")
            ] : undefined
        };
        if (ranges.length) spec.selection = $7570a9a1a9679713$var$fieldSelection(ranges, 0);
        if (ranges.some((r)=>r.field > 0)) {
            let active = new $7570a9a1a9679713$var$ActiveSnippet(ranges, 0);
            let effects = spec.effects = [
                $7570a9a1a9679713$var$setActive.of(active)
            ];
            if (editor.state.field($7570a9a1a9679713$var$snippetState, false) === undefined) effects.push((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of([
                $7570a9a1a9679713$var$snippetState,
                $7570a9a1a9679713$var$addSnippetKeymap,
                $7570a9a1a9679713$var$snippetPointerHandler,
                $7570a9a1a9679713$var$baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function $7570a9a1a9679713$var$moveField(dir) {
    return ({ state: state, dispatch: dispatch })=>{
        let active = state.field($7570a9a1a9679713$var$snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        let next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: $7570a9a1a9679713$var$fieldSelection(active.ranges, next),
            effects: $7570a9a1a9679713$var$setActive.of(last ? null : new $7570a9a1a9679713$var$ActiveSnippet(active.ranges, next)),
            scrollIntoView: true
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ const $7570a9a1a9679713$export$4d00dce2599b1df3 = ({ state: state, dispatch: dispatch })=>{
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: $7570a9a1a9679713$var$setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ const $7570a9a1a9679713$export$d8da8fdad886df2f = /*@__PURE__*/ $7570a9a1a9679713$var$moveField(1);
/**
Move to the previous snippet field, if available.
*/ const $7570a9a1a9679713$export$8d02b23b64ec425c = /*@__PURE__*/ $7570a9a1a9679713$var$moveField(-1);
/**
Check if there is an active snippet with a next field for
`nextSnippetField` to move to.
*/ function $7570a9a1a9679713$export$9c250e449e4af222(state) {
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    return !!(active && active.ranges.some((r)=>r.field == active.active + 1));
}
/**
Returns true if there is an active snippet and a previous field
for `prevSnippetField` to move to.
*/ function $7570a9a1a9679713$export$ace2e22fa9996777(state) {
    let active = state.field($7570a9a1a9679713$var$snippetState, false);
    return !!(active && active.active > 0);
}
const $7570a9a1a9679713$var$defaultSnippetKeymap = [
    {
        key: "Tab",
        run: $7570a9a1a9679713$export$d8da8fdad886df2f,
        shift: $7570a9a1a9679713$export$8d02b23b64ec425c
    },
    {
        key: "Escape",
        run: $7570a9a1a9679713$export$4d00dce2599b1df3
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ const $7570a9a1a9679713$export$1808c2f24fc99b36 = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (maps) {
        return maps.length ? maps[0] : $7570a9a1a9679713$var$defaultSnippetKeymap;
    }
});
const $7570a9a1a9679713$var$addSnippetKeymap = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$5043418e2ef368d5).compute([
    $7570a9a1a9679713$export$1808c2f24fc99b36
], (state)=>state.facet($7570a9a1a9679713$export$1808c2f24fc99b36)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function $7570a9a1a9679713$export$975ef56e648d23ad(template, completion) {
    return Object.assign(Object.assign({}, completion), {
        apply: $7570a9a1a9679713$export$f77f1ac5bf251232(template)
    });
}
const $7570a9a1a9679713$var$snippetPointerHandler = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).domEventHandlers({
    mousedown (event, view) {
        let active = view.state.field($7570a9a1a9679713$var$snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        let match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: $7570a9a1a9679713$var$fieldSelection(active.ranges, match.field),
            effects: $7570a9a1a9679713$var$setActive.of(active.ranges.some((r)=>r.field > match.field) ? new $7570a9a1a9679713$var$ActiveSnippet(active.ranges, match.field) : null),
            scrollIntoView: true
        });
        return true;
    }
});
function $7570a9a1a9679713$var$wordRE(wordChars) {
    let escaped = wordChars.replace(/[\]\-\\]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function $7570a9a1a9679713$var$mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
const $7570a9a1a9679713$var$wordCaches = /*@__PURE__*/ Object.create(null);
function $7570a9a1a9679713$var$wordCache(wordChars) {
    return $7570a9a1a9679713$var$wordCaches[wordChars] || ($7570a9a1a9679713$var$wordCaches[wordChars] = new WeakMap);
}
function $7570a9a1a9679713$var$storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(let lines = doc.iterLines(), pos = 0; !lines.next().done;){
        let { value: value } = lines, m;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* C.MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function $7570a9a1a9679713$var$collectWords(doc, cache, wordRE, to, ignoreAt) {
    let big = doc.length >= 1000 /* C.MinCacheLen */ ;
    let cached = big && cache.get(doc);
    if (cached) return cached;
    let result = [], seen = Object.create(null);
    if (doc.children) {
        let pos = 0;
        for (let ch of doc.children){
            if (ch.length >= 1000 /* C.MinCacheLen */ ) {
                for (let c of $7570a9a1a9679713$var$collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos))if (!seen[c.label]) {
                    seen[c.label] = true;
                    result.push(c);
                }
            } else $7570a9a1a9679713$var$storeWords(ch, wordRE, result, seen, ignoreAt - pos);
            pos += ch.length + 1;
        }
    } else $7570a9a1a9679713$var$storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* C.MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ const $7570a9a1a9679713$export$a018df98be431a1 = (context)=>{
    let wordChars = context.state.languageDataAt("wordChars", context.pos).join("");
    let re = $7570a9a1a9679713$var$wordRE(wordChars);
    let token = context.matchBefore($7570a9a1a9679713$var$mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    let from = token ? token.from : context.pos;
    let options = $7570a9a1a9679713$var$collectWords(context.state.doc, $7570a9a1a9679713$var$wordCache(wordChars), re, 50000 /* C.Range */ , from);
    return {
        from: from,
        options: options,
        validFor: $7570a9a1a9679713$var$mapRE(re, (s)=>"^" + s)
    };
};
const $7570a9a1a9679713$var$defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
};
const $7570a9a1a9679713$var$closeBracketEffect = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define({
    map (value, mapping) {
        let mapped = mapping.mapPos(value, -1, (0, $6295c6875f57e3ee$export$39cf3280165f92aa).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
const $7570a9a1a9679713$var$closedBracket = /*@__PURE__*/ new class extends (0, $6295c6875f57e3ee$export$d60f08ed93a48611) {
};
$7570a9a1a9679713$var$closedBracket.startSide = 1;
$7570a9a1a9679713$var$closedBracket.endSide = -1;
const $7570a9a1a9679713$var$bracketState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
    },
    update (value, tr) {
        value = value.map(tr.changes);
        if (tr.selection) {
            let line = tr.state.doc.lineAt(tr.selection.main.head);
            value = value.update({
                filter: (from)=>from >= line.from && from <= line.to
            });
        }
        for (let effect of tr.effects)if (effect.is($7570a9a1a9679713$var$closeBracketEffect)) value = value.update({
            add: [
                $7570a9a1a9679713$var$closedBracket.range(effect.value, effect.value + 1)
            ]
        });
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function $7570a9a1a9679713$export$69e4e9d3300ff824() {
    return [
        $7570a9a1a9679713$var$inputHandler,
        $7570a9a1a9679713$var$bracketState
    ];
}
const $7570a9a1a9679713$var$definedClosing = "()[]{}<>";
function $7570a9a1a9679713$var$closing(ch) {
    for(let i = 0; i < $7570a9a1a9679713$var$definedClosing.length; i += 2)if ($7570a9a1a9679713$var$definedClosing.charCodeAt(i) == ch) return $7570a9a1a9679713$var$definedClosing.charAt(i + 1);
    return (0, $6295c6875f57e3ee$export$73bfc63873071f74)(ch < 128 ? ch : ch + 1);
}
function $7570a9a1a9679713$var$config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || $7570a9a1a9679713$var$defaults;
}
const $7570a9a1a9679713$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
const $7570a9a1a9679713$var$inputHandler = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).inputHandler.of((view, from, to, insert)=>{
    if (($7570a9a1a9679713$var$android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    let sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    let tr = $7570a9a1a9679713$export$7ce1ae5219095222(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ const $7570a9a1a9679713$export$5339d701ea89967c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let conf = $7570a9a1a9679713$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7570a9a1a9679713$var$defaults.brackets;
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            let before = $7570a9a1a9679713$var$prevChar(state.doc, range.head);
            for (let token of tokens){
                if (token == before && $7570a9a1a9679713$var$nextChar(state.doc, range.head) == $7570a9a1a9679713$var$closing((0, $6295c6875f57e3ee$export$42977f40461e1360)(token, 0))) return {
                    changes: {
                        from: range.head - token.length,
                        to: range.head + token.length
                    },
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head - token.length)
                };
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete.backward"
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ const $7570a9a1a9679713$export$9477e95792b48f4a = [
    {
        key: "Backspace",
        run: $7570a9a1a9679713$export$5339d701ea89967c
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function $7570a9a1a9679713$export$7ce1ae5219095222(state, bracket) {
    let conf = $7570a9a1a9679713$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $7570a9a1a9679713$var$defaults.brackets;
    for (let tok of tokens){
        let closed = $7570a9a1a9679713$var$closing((0, $6295c6875f57e3ee$export$42977f40461e1360)(tok, 0));
        if (bracket == tok) return closed == tok ? $7570a9a1a9679713$var$handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : $7570a9a1a9679713$var$handleOpen(state, tok, closed, conf.before || $7570a9a1a9679713$var$defaults.before);
        if (bracket == closed && $7570a9a1a9679713$var$closedBracketAt(state, state.selection.main.from)) return $7570a9a1a9679713$var$handleClose(state, tok, closed);
    }
    return null;
}
function $7570a9a1a9679713$var$closedBracketAt(state, pos) {
    let found = false;
    state.field($7570a9a1a9679713$var$bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function $7570a9a1a9679713$var$nextChar(doc, pos) {
    let next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(next, 0)));
}
function $7570a9a1a9679713$var$prevChar(doc, pos) {
    let prev = doc.sliceString(pos - 2, pos);
    return (0, $6295c6875f57e3ee$export$a870abf234f6353c)((0, $6295c6875f57e3ee$export$42977f40461e1360)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function $7570a9a1a9679713$var$handleOpen(state, open, close, closeBefore) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.to + open.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor + open.length, range.head + open.length)
        };
        let next = $7570a9a1a9679713$var$nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.head + open.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7570a9a1a9679713$var$handleClose(state, _open, close) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty && $7570a9a1a9679713$var$nextChar(state.doc, range.head) == close) return {
            changes: {
                from: range.head,
                to: range.head + close.length,
                insert: close
            },
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(range.head + close.length)
        };
        return dont = {
            range: range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function $7570a9a1a9679713$var$handleSame(state, token, allowTriple, config) {
    let stringPrefixes = config.stringPrefixes || $7570a9a1a9679713$var$defaults.stringPrefixes;
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(range.to + token.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).range(range.anchor + token.length, range.head + token.length)
        };
        let pos = range.head, next = $7570a9a1a9679713$var$nextChar(state.doc, pos), start;
        if (next == token) {
            if ($7570a9a1a9679713$var$nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
            else if ($7570a9a1a9679713$var$closedBracketAt(state, pos)) {
                let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                let content = isTriple ? token + token + token : token;
                return {
                    changes: {
                        from: pos,
                        to: pos + content.length,
                        insert: content
                    },
                    range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + content.length)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = $7570a9a1a9679713$var$canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && $7570a9a1a9679713$var$nodeStart(state, start)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
            range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) {
            if ($7570a9a1a9679713$var$canStartStringAt(state, pos, stringPrefixes) > -1 && !$7570a9a1a9679713$var$probablyInString(state, pos, token, stringPrefixes)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $7570a9a1a9679713$var$closeBracketEffect.of(pos + token.length),
                range: (0, $6295c6875f57e3ee$export$3bb1bd44aee62999).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $7570a9a1a9679713$var$nodeStart(state, pos) {
    let tree = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function $7570a9a1a9679713$var$probablyInString(state, pos, quoteToken, prefixes) {
    let node = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(state).resolveInner(pos, -1);
    let maxPrefix = prefixes.reduce((m, p)=>Math.max(m, p.length), 0);
    for(let i = 0; i < 5; i++){
        let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
        let quotePos = start.indexOf(quoteToken);
        if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
            let first = node.firstChild;
            while(first && first.from == node.from && first.to - first.from > quoteToken.length + quotePos){
                if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken) return false;
                first = first.firstChild;
            }
            return true;
        }
        let parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
function $7570a9a1a9679713$var$canStartStringAt(state, pos, prefixes) {
    let charCat = state.charCategorizer(pos);
    if (charCat(state.sliceDoc(pos - 1, pos)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) return pos;
    for (let prefix of prefixes){
        let start = pos - prefix.length;
        if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != (0, $6295c6875f57e3ee$export$239a3d59567c1401).Word) return start;
    }
    return -1;
}
/**
Returns an extension that enables autocompletion.
*/ function $7570a9a1a9679713$export$f95786d390465556(config = {}) {
    return [
        $7570a9a1a9679713$var$commitCharacters,
        $7570a9a1a9679713$var$completionState,
        $7570a9a1a9679713$var$completionConfig.of(config),
        $7570a9a1a9679713$var$completionPlugin,
        $7570a9a1a9679713$var$completionKeymapExt,
        $7570a9a1a9679713$var$baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space: [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ const $7570a9a1a9679713$export$2a3d759d156afab4 = [
    {
        key: "Ctrl-Space",
        run: $7570a9a1a9679713$export$8a36416d28f82fd5
    },
    {
        key: "Escape",
        run: $7570a9a1a9679713$export$bdc62126738c63ab
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ $7570a9a1a9679713$export$26f3a479ac65d653(false, "page")
    },
    {
        key: "Enter",
        run: $7570a9a1a9679713$export$537623a3380ccdae
    }
];
const $7570a9a1a9679713$var$completionKeymapExt = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$b92464a736444411).highest(/*@__PURE__*/ (0, $7beee9608540d2c3$export$5043418e2ef368d5).computeN([
    $7570a9a1a9679713$var$completionConfig
], (state)=>state.facet($7570a9a1a9679713$var$completionConfig).defaultKeymap ? [
        $7570a9a1a9679713$export$2a3d759d156afab4
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function $7570a9a1a9679713$export$9eb35bf27959eae5(state) {
    let cState = state.field($7570a9a1a9679713$var$completionState, false);
    return cState && cState.active.some((a)=>a.state == 1 /* State.Pending */ ) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? "active" : null;
}
const $7570a9a1a9679713$var$completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function $7570a9a1a9679713$export$dc0f5d77fb0cbbf5(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open || open.disabled) return [];
    let completions = $7570a9a1a9679713$var$completionArrayCache.get(open.options);
    if (!completions) $7570a9a1a9679713$var$completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function $7570a9a1a9679713$export$8c322db2cd50d0f1(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function $7570a9a1a9679713$export$93d3d3265e08d270(state) {
    var _a;
    let open = (_a = state.field($7570a9a1a9679713$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function $7570a9a1a9679713$export$64a726c2de6175b8(index) {
    return $7570a9a1a9679713$var$setSelectedEffect.of(index);
}






class $1e126942d86629f6$var$SelectedDiagnostic {
    constructor(from, to, diagnostic){
        this.from = from;
        this.to = to;
        this.diagnostic = diagnostic;
    }
}
class $1e126942d86629f6$var$LintState {
    constructor(diagnostics, panel, selected){
        this.diagnostics = diagnostics;
        this.panel = panel;
        this.selected = selected;
    }
    static init(diagnostics, panel, state) {
        // Filter the list of diagnostics for which to create markers
        let markedDiagnostics = diagnostics;
        let diagnosticFilter = state.facet($1e126942d86629f6$var$lintConfig).markerFilter;
        if (diagnosticFilter) markedDiagnostics = diagnosticFilter(markedDiagnostics, state);
        let ranges = (0, $7beee9608540d2c3$export$10e30b733df217ea).set(markedDiagnostics.map((d)=>{
            // For zero-length ranges or ranges covering only a line break, create a widget
            return d.from == d.to || d.from == d.to - 1 && state.doc.lineAt(d.from).to == d.from ? (0, $7beee9608540d2c3$export$10e30b733df217ea).widget({
                widget: new $1e126942d86629f6$var$DiagnosticWidget(d),
                diagnostic: d
            }).range(d.from) : (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
                attributes: {
                    class: "cm-lintRange cm-lintRange-" + d.severity + (d.markClass ? " " + d.markClass : "")
                },
                diagnostic: d
            }).range(d.from, d.to);
        }), true);
        return new $1e126942d86629f6$var$LintState(ranges, panel, $1e126942d86629f6$var$findDiagnostic(ranges));
    }
}
function $1e126942d86629f6$var$findDiagnostic(diagnostics, diagnostic = null, after = 0) {
    let found = null;
    diagnostics.between(after, 1e9, (from, to, { spec: spec })=>{
        if (diagnostic && spec.diagnostic != diagnostic) return;
        found = new $1e126942d86629f6$var$SelectedDiagnostic(from, to, spec.diagnostic);
        return false;
    });
    return found;
}
function $1e126942d86629f6$var$hideTooltip(tr, tooltip) {
    let from = tooltip.pos, to = tooltip.end || from;
    let result = tr.state.facet($1e126942d86629f6$var$lintConfig).hideOn(tr, from, to);
    if (result != null) return result;
    let line = tr.startState.doc.lineAt(tooltip.pos);
    return !!(tr.effects.some((e)=>e.is($1e126942d86629f6$export$9c7976977981c7bf)) || tr.changes.touchesRange(line.from, Math.max(line.to, to)));
}
function $1e126942d86629f6$var$maybeEnableLint(state, effects) {
    return state.field($1e126942d86629f6$var$lintState, false) ? effects : effects.concat((0, $6295c6875f57e3ee$export$95000d4efaa4321f).appendConfig.of($1e126942d86629f6$var$lintExtensions));
}
/**
Returns a transaction spec which updates the current set of
diagnostics, and enables the lint extension if if wasn't already
active.
*/ function $1e126942d86629f6$export$188c3c6ceeec4bb3(state, diagnostics) {
    return {
        effects: $1e126942d86629f6$var$maybeEnableLint(state, [
            $1e126942d86629f6$export$9c7976977981c7bf.of(diagnostics)
        ])
    };
}
/**
The state effect that updates the set of active diagnostics. Can
be useful when writing an extension that needs to track these.
*/ const $1e126942d86629f6$export$9c7976977981c7bf = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$togglePanel = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$movePanelSelection = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$lintState = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return new $1e126942d86629f6$var$LintState((0, $7beee9608540d2c3$export$10e30b733df217ea).none, null, null);
    },
    update (value, tr) {
        if (tr.docChanged && value.diagnostics.size) {
            let mapped = value.diagnostics.map(tr.changes), selected = null, panel = value.panel;
            if (value.selected) {
                let selPos = tr.changes.mapPos(value.selected.from, 1);
                selected = $1e126942d86629f6$var$findDiagnostic(mapped, value.selected.diagnostic, selPos) || $1e126942d86629f6$var$findDiagnostic(mapped, null, selPos);
            }
            if (!mapped.size && panel && tr.state.facet($1e126942d86629f6$var$lintConfig).autoPanel) panel = null;
            value = new $1e126942d86629f6$var$LintState(mapped, panel, selected);
        }
        for (let effect of tr.effects){
            if (effect.is($1e126942d86629f6$export$9c7976977981c7bf)) {
                let panel = !tr.state.facet($1e126942d86629f6$var$lintConfig).autoPanel ? value.panel : effect.value.length ? $1e126942d86629f6$var$LintPanel.open : null;
                value = $1e126942d86629f6$var$LintState.init(effect.value, panel, tr.state);
            } else if (effect.is($1e126942d86629f6$var$togglePanel)) value = new $1e126942d86629f6$var$LintState(value.diagnostics, effect.value ? $1e126942d86629f6$var$LintPanel.open : null, value.selected);
            else if (effect.is($1e126942d86629f6$var$movePanelSelection)) value = new $1e126942d86629f6$var$LintState(value.diagnostics, value.panel, effect.value);
        }
        return value;
    },
    provide: (f)=>[
            (0, $7beee9608540d2c3$export$e89c3c9af31c1e3b).from(f, (val)=>val.panel),
            (0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.from(f, (s)=>s.diagnostics)
        ]
});
/**
Returns the number of active lint diagnostics in the given state.
*/ function $1e126942d86629f6$export$31ce51ade4a789ff(state) {
    let lint = state.field($1e126942d86629f6$var$lintState, false);
    return lint ? lint.diagnostics.size : 0;
}
const $1e126942d86629f6$var$activeMark = /*@__PURE__*/ (0, $7beee9608540d2c3$export$10e30b733df217ea).mark({
    class: "cm-lintRange cm-lintRange-active"
});
function $1e126942d86629f6$var$lintTooltip(view, pos, side) {
    let { diagnostics: diagnostics } = view.state.field($1e126942d86629f6$var$lintState);
    let found = [], stackStart = 2e8, stackEnd = 0;
    diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to, { spec: spec })=>{
        if (pos >= from && pos <= to && (from == to || (pos > from || side > 0) && (pos < to || side < 0))) {
            found.push(spec.diagnostic);
            stackStart = Math.min(from, stackStart);
            stackEnd = Math.max(to, stackEnd);
        }
    });
    let diagnosticFilter = view.state.facet($1e126942d86629f6$var$lintConfig).tooltipFilter;
    if (diagnosticFilter) found = diagnosticFilter(found, view.state);
    if (!found.length) return null;
    return {
        pos: stackStart,
        end: stackEnd,
        above: view.state.doc.lineAt(stackStart).to < stackEnd,
        create () {
            return {
                dom: $1e126942d86629f6$var$diagnosticsTooltip(view, found)
            };
        }
    };
}
function $1e126942d86629f6$var$diagnosticsTooltip(view, diagnostics) {
    return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("ul", {
        class: "cm-tooltip-lint"
    }, diagnostics.map((d)=>$1e126942d86629f6$var$renderDiagnostic(view, d, false)));
}
/**
Command to open and focus the lint panel.
*/ const $1e126942d86629f6$export$5c4e65c70e8c34a7 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field || !field.panel) view.dispatch({
        effects: $1e126942d86629f6$var$maybeEnableLint(view.state, [
            $1e126942d86629f6$var$togglePanel.of(true)
        ])
    });
    let panel = (0, $7beee9608540d2c3$export$7361ed18ff57179e)(view, $1e126942d86629f6$var$LintPanel.open);
    if (panel) panel.dom.querySelector(".cm-panel-lint ul").focus();
    return true;
};
/**
Command to close the lint panel, when open.
*/ const $1e126942d86629f6$export$2ee372c3e690e3c3 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field || !field.panel) return false;
    view.dispatch({
        effects: $1e126942d86629f6$var$togglePanel.of(false)
    });
    return true;
};
/**
Move the selection to the next diagnostic.
*/ const $1e126942d86629f6$export$79abb131646e1359 = (view)=>{
    let field = view.state.field($1e126942d86629f6$var$lintState, false);
    if (!field) return false;
    let sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
    if (!next.value) {
        next = field.diagnostics.iter(0);
        if (!next.value || next.from == sel.from && next.to == sel.to) return false;
    }
    view.dispatch({
        selection: {
            anchor: next.from,
            head: next.to
        },
        scrollIntoView: true
    });
    return true;
};
/**
Move the selection to the previous diagnostic.
*/ const $1e126942d86629f6$export$f71c1dd1430b5cc1 = (view)=>{
    let { state: state } = view, field = state.field($1e126942d86629f6$var$lintState, false);
    if (!field) return false;
    let sel = state.selection.main;
    let prevFrom, prevTo, lastFrom, lastTo;
    field.diagnostics.between(0, state.doc.length, (from, to)=>{
        if (to < sel.to && (prevFrom == null || prevFrom < from)) {
            prevFrom = from;
            prevTo = to;
        }
        if (lastFrom == null || from > lastFrom) {
            lastFrom = from;
            lastTo = to;
        }
    });
    if (lastFrom == null || prevFrom == null && lastFrom == sel.from) return false;
    view.dispatch({
        selection: {
            anchor: prevFrom !== null && prevFrom !== void 0 ? prevFrom : lastFrom,
            head: prevTo !== null && prevTo !== void 0 ? prevTo : lastTo
        },
        scrollIntoView: true
    });
    return true;
};
/**
A set of default key bindings for the lint functionality.

- Ctrl-Shift-m (Cmd-Shift-m on macOS): [`openLintPanel`](https://codemirror.net/6/docs/ref/#lint.openLintPanel)
- F8: [`nextDiagnostic`](https://codemirror.net/6/docs/ref/#lint.nextDiagnostic)
*/ const $1e126942d86629f6$export$a21d7a0cde3cbb60 = [
    {
        key: "Mod-Shift-m",
        run: $1e126942d86629f6$export$5c4e65c70e8c34a7,
        preventDefault: true
    },
    {
        key: "F8",
        run: $1e126942d86629f6$export$79abb131646e1359
    }
];
const $1e126942d86629f6$var$lintPlugin = /*@__PURE__*/ (0, $7beee9608540d2c3$export$44d5eccfd62adda7).fromClass(class {
    constructor(view){
        this.view = view;
        this.timeout = -1;
        this.set = true;
        let { delay: delay } = view.state.facet($1e126942d86629f6$var$lintConfig);
        this.lintTime = Date.now() + delay;
        this.run = this.run.bind(this);
        this.timeout = setTimeout(this.run, delay);
    }
    run() {
        clearTimeout(this.timeout);
        let now = Date.now();
        if (now < this.lintTime - 10) this.timeout = setTimeout(this.run, this.lintTime - now);
        else {
            this.set = false;
            let { state: state } = this.view, { sources: sources } = state.facet($1e126942d86629f6$var$lintConfig);
            if (sources.length) Promise.all(sources.map((source)=>Promise.resolve(source(this.view)))).then((annotations)=>{
                let all = annotations.reduce((a, b)=>a.concat(b));
                if (this.view.state.doc == state.doc) this.view.dispatch($1e126942d86629f6$export$188c3c6ceeec4bb3(this.view.state, all));
            }, (error)=>{
                (0, $7beee9608540d2c3$export$f86b2a1a2ce291b3)(this.view.state, error);
            });
        }
    }
    update(update) {
        let config = update.state.facet($1e126942d86629f6$var$lintConfig);
        if (update.docChanged || config != update.startState.facet($1e126942d86629f6$var$lintConfig) || config.needsRefresh && config.needsRefresh(update)) {
            this.lintTime = Date.now() + config.delay;
            if (!this.set) {
                this.set = true;
                this.timeout = setTimeout(this.run, config.delay);
            }
        }
    }
    force() {
        if (this.set) {
            this.lintTime = Date.now();
            this.run();
        }
    }
    destroy() {
        clearTimeout(this.timeout);
    }
});
const $1e126942d86629f6$var$lintConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (input) {
        return Object.assign({
            sources: input.map((i)=>i.source).filter((x)=>x != null)
        }, (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(input.map((i)=>i.config), {
            delay: 750,
            markerFilter: null,
            tooltipFilter: null,
            needsRefresh: null,
            hideOn: ()=>null
        }, {
            needsRefresh: (a, b)=>!a ? b : !b ? a : (u)=>a(u) || b(u)
        }));
    }
});
/**
Given a diagnostic source, this function returns an extension that
enables linting with that source. It will be called whenever the
editor is idle (after its content changed). If `null` is given as
source, this only configures the lint extension.
*/ function $1e126942d86629f6$export$8bb7ef7a8be4cb1c(source, config = {}) {
    return [
        $1e126942d86629f6$var$lintConfig.of({
            source: source,
            config: config
        }),
        $1e126942d86629f6$var$lintPlugin,
        $1e126942d86629f6$var$lintExtensions
    ];
}
/**
Forces any linters [configured](https://codemirror.net/6/docs/ref/#lint.linter) to run when the
editor is idle to run right away.
*/ function $1e126942d86629f6$export$e917f1893924e285(view) {
    let plugin = view.plugin($1e126942d86629f6$var$lintPlugin);
    if (plugin) plugin.force();
}
function $1e126942d86629f6$var$assignKeys(actions) {
    let assigned = [];
    if (actions) actions: for (let { name: name } of actions){
        for(let i = 0; i < name.length; i++){
            let ch = name[i];
            if (/[a-zA-Z]/.test(ch) && !assigned.some((c)=>c.toLowerCase() == ch.toLowerCase())) {
                assigned.push(ch);
                continue actions;
            }
        }
        assigned.push("");
    }
    return assigned;
}
function $1e126942d86629f6$var$renderDiagnostic(view, diagnostic, inPanel) {
    var _a;
    let keys = inPanel ? $1e126942d86629f6$var$assignKeys(diagnostic.actions) : [];
    return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("li", {
        class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity
    }, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("span", {
        class: "cm-diagnosticText"
    }, diagnostic.renderMessage ? diagnostic.renderMessage(view) : diagnostic.message), (_a = diagnostic.actions) === null || _a === void 0 ? void 0 : _a.map((action, i)=>{
        let fired = false, click = (e)=>{
            e.preventDefault();
            if (fired) return;
            fired = true;
            let found = $1e126942d86629f6$var$findDiagnostic(view.state.field($1e126942d86629f6$var$lintState).diagnostics, diagnostic);
            if (found) action.apply(view, found.from, found.to);
        };
        let { name: name } = action, keyIndex = keys[i] ? name.indexOf(keys[i]) : -1;
        let nameElt = keyIndex < 0 ? name : [
            name.slice(0, keyIndex),
            (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("u", name.slice(keyIndex, keyIndex + 1)),
            name.slice(keyIndex + 1)
        ];
        return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            type: "button",
            class: "cm-diagnosticAction",
            onclick: click,
            onmousedown: click,
            "aria-label": ` Action: ${name}${keyIndex < 0 ? "" : ` (access key "${keys[i]})"`}.`
        }, nameElt);
    }), diagnostic.source && (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
        class: "cm-diagnosticSource"
    }, diagnostic.source));
}
class $1e126942d86629f6$var$DiagnosticWidget extends (0, $7beee9608540d2c3$export$95cdd842edb044c5) {
    constructor(diagnostic){
        super();
        this.diagnostic = diagnostic;
    }
    eq(other) {
        return other.diagnostic == this.diagnostic;
    }
    toDOM() {
        return (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("span", {
            class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity
        });
    }
}
class $1e126942d86629f6$var$PanelItem {
    constructor(view, diagnostic){
        this.diagnostic = diagnostic;
        this.id = "item_" + Math.floor(Math.random() * 0xffffffff).toString(16);
        this.dom = $1e126942d86629f6$var$renderDiagnostic(view, diagnostic, true);
        this.dom.id = this.id;
        this.dom.setAttribute("role", "option");
    }
}
class $1e126942d86629f6$var$LintPanel {
    constructor(view){
        this.view = view;
        this.items = [];
        let onkeydown = (event)=>{
            if (event.keyCode == 27) {
                $1e126942d86629f6$export$2ee372c3e690e3c3(this.view);
                this.view.focus();
            } else if (event.keyCode == 38 || event.keyCode == 33) this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
            else if (event.keyCode == 40 || event.keyCode == 34) this.moveSelection((this.selectedIndex + 1) % this.items.length);
            else if (event.keyCode == 36) this.moveSelection(0);
            else if (event.keyCode == 35) this.moveSelection(this.items.length - 1);
            else if (event.keyCode == 13) this.view.focus();
            else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
                let { diagnostic: diagnostic } = this.items[this.selectedIndex], keys = $1e126942d86629f6$var$assignKeys(diagnostic.actions);
                for(let i = 0; i < keys.length; i++)if (keys[i].toUpperCase().charCodeAt(0) == event.keyCode) {
                    let found = $1e126942d86629f6$var$findDiagnostic(this.view.state.field($1e126942d86629f6$var$lintState).diagnostics, diagnostic);
                    if (found) diagnostic.actions[i].apply(view, found.from, found.to);
                }
            } else return;
            event.preventDefault();
        };
        let onclick = (event)=>{
            for(let i = 0; i < this.items.length; i++)if (this.items[i].dom.contains(event.target)) this.moveSelection(i);
        };
        this.list = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("ul", {
            tabIndex: 0,
            role: "listbox",
            "aria-label": this.view.state.phrase("Diagnostics"),
            onkeydown: onkeydown,
            onclick: onclick
        });
        this.dom = (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("div", {
            class: "cm-panel-lint"
        }, this.list, (0, $2d3e4571bc0b9f5f$export$2e2bcd8739ae039)("button", {
            type: "button",
            name: "close",
            "aria-label": this.view.state.phrase("close"),
            onclick: ()=>$1e126942d86629f6$export$2ee372c3e690e3c3(this.view)
        }, "\xd7"));
        this.update();
    }
    get selectedIndex() {
        let selected = this.view.state.field($1e126942d86629f6$var$lintState).selected;
        if (!selected) return -1;
        for(let i = 0; i < this.items.length; i++)if (this.items[i].diagnostic == selected.diagnostic) return i;
        return -1;
    }
    update() {
        let { diagnostics: diagnostics, selected: selected } = this.view.state.field($1e126942d86629f6$var$lintState);
        let i = 0, needsSync = false, newSelectedItem = null;
        diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec: spec })=>{
            let found = -1, item;
            for(let j = i; j < this.items.length; j++)if (this.items[j].diagnostic == spec.diagnostic) {
                found = j;
                break;
            }
            if (found < 0) {
                item = new $1e126942d86629f6$var$PanelItem(this.view, spec.diagnostic);
                this.items.splice(i, 0, item);
                needsSync = true;
            } else {
                item = this.items[found];
                if (found > i) {
                    this.items.splice(i, found - i);
                    needsSync = true;
                }
            }
            if (selected && item.diagnostic == selected.diagnostic) {
                if (!item.dom.hasAttribute("aria-selected")) {
                    item.dom.setAttribute("aria-selected", "true");
                    newSelectedItem = item;
                }
            } else if (item.dom.hasAttribute("aria-selected")) item.dom.removeAttribute("aria-selected");
            i++;
        });
        while(i < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)){
            needsSync = true;
            this.items.pop();
        }
        if (this.items.length == 0) {
            this.items.push(new $1e126942d86629f6$var$PanelItem(this.view, {
                from: -1,
                to: -1,
                severity: "info",
                message: this.view.state.phrase("No diagnostics")
            }));
            needsSync = true;
        }
        if (newSelectedItem) {
            this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
            this.view.requestMeasure({
                key: this,
                read: ()=>({
                        sel: newSelectedItem.dom.getBoundingClientRect(),
                        panel: this.list.getBoundingClientRect()
                    }),
                write: ({ sel: sel, panel: panel })=>{
                    let scaleY = panel.height / this.list.offsetHeight;
                    if (sel.top < panel.top) this.list.scrollTop -= (panel.top - sel.top) / scaleY;
                    else if (sel.bottom > panel.bottom) this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
                }
            });
        } else if (this.selectedIndex < 0) this.list.removeAttribute("aria-activedescendant");
        if (needsSync) this.sync();
    }
    sync() {
        let domPos = this.list.firstChild;
        function rm() {
            let prev = domPos;
            domPos = prev.nextSibling;
            prev.remove();
        }
        for (let item of this.items)if (item.dom.parentNode == this.list) {
            while(domPos != item.dom)rm();
            domPos = item.dom.nextSibling;
        } else this.list.insertBefore(item.dom, domPos);
        while(domPos)rm();
    }
    moveSelection(selectedIndex) {
        if (this.selectedIndex < 0) return;
        let field = this.view.state.field($1e126942d86629f6$var$lintState);
        let selection = $1e126942d86629f6$var$findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
        if (!selection) return;
        this.view.dispatch({
            selection: {
                anchor: selection.from,
                head: selection.to
            },
            scrollIntoView: true,
            effects: $1e126942d86629f6$var$movePanelSelection.of(selection)
        });
    }
    static open(view) {
        return new $1e126942d86629f6$var$LintPanel(view);
    }
}
function $1e126942d86629f6$var$svg(content, attrs = `viewBox="0 0 40 40"`) {
    return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content)}</svg>')`;
}
function $1e126942d86629f6$var$underline(color) {
    return $1e126942d86629f6$var$svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const $1e126942d86629f6$var$baseTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-diagnostic": {
        padding: "3px 6px 3px 8px",
        marginLeft: "-1px",
        display: "block",
        whiteSpace: "pre-wrap"
    },
    ".cm-diagnostic-error": {
        borderLeft: "5px solid #d11"
    },
    ".cm-diagnostic-warning": {
        borderLeft: "5px solid orange"
    },
    ".cm-diagnostic-info": {
        borderLeft: "5px solid #999"
    },
    ".cm-diagnostic-hint": {
        borderLeft: "5px solid #66d"
    },
    ".cm-diagnosticAction": {
        font: "inherit",
        border: "none",
        padding: "2px 4px",
        backgroundColor: "#444",
        color: "white",
        borderRadius: "3px",
        marginLeft: "8px",
        cursor: "pointer"
    },
    ".cm-diagnosticSource": {
        fontSize: "70%",
        opacity: .7
    },
    ".cm-lintRange": {
        backgroundPosition: "left bottom",
        backgroundRepeat: "repeat-x",
        paddingBottom: "0.7px"
    },
    ".cm-lintRange-error": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#d11")
    },
    ".cm-lintRange-warning": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("orange")
    },
    ".cm-lintRange-info": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#999")
    },
    ".cm-lintRange-hint": {
        backgroundImage: /*@__PURE__*/ $1e126942d86629f6$var$underline("#66d")
    },
    ".cm-lintRange-active": {
        backgroundColor: "#ffdd9980"
    },
    ".cm-tooltip-lint": {
        padding: 0,
        margin: 0
    },
    ".cm-lintPoint": {
        position: "relative",
        "&:after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "-2px",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent",
            borderBottom: "4px solid #d11"
        }
    },
    ".cm-lintPoint-warning": {
        "&:after": {
            borderBottomColor: "orange"
        }
    },
    ".cm-lintPoint-info": {
        "&:after": {
            borderBottomColor: "#999"
        }
    },
    ".cm-lintPoint-hint": {
        "&:after": {
            borderBottomColor: "#66d"
        }
    },
    ".cm-panel.cm-panel-lint": {
        position: "relative",
        "& ul": {
            maxHeight: "100px",
            overflowY: "auto",
            "& [aria-selected]": {
                backgroundColor: "#ddd",
                "& u": {
                    textDecoration: "underline"
                }
            },
            "&:focus [aria-selected]": {
                background_fallback: "#bdf",
                backgroundColor: "Highlight",
                color_fallback: "white",
                color: "HighlightText"
            },
            "& u": {
                textDecoration: "none"
            },
            padding: 0,
            margin: 0
        },
        "& [name=close]": {
            position: "absolute",
            top: "0",
            right: "2px",
            background: "inherit",
            border: "none",
            font: "inherit",
            padding: 0,
            margin: 0
        }
    }
});
function $1e126942d86629f6$var$severityWeight(sev) {
    return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
class $1e126942d86629f6$var$LintGutterMarker extends (0, $7beee9608540d2c3$export$591ab4c909549043) {
    constructor(diagnostics){
        super();
        this.diagnostics = diagnostics;
        this.severity = diagnostics.reduce((max, d)=>$1e126942d86629f6$var$severityWeight(max) < $1e126942d86629f6$var$severityWeight(d.severity) ? d.severity : max, "hint");
    }
    toDOM(view) {
        let elt = document.createElement("div");
        elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
        let diagnostics = this.diagnostics;
        let diagnosticsFilter = view.state.facet($1e126942d86629f6$var$lintGutterConfig).tooltipFilter;
        if (diagnosticsFilter) diagnostics = diagnosticsFilter(diagnostics, view.state);
        if (diagnostics.length) elt.onmouseover = ()=>$1e126942d86629f6$var$gutterMarkerMouseOver(view, elt, diagnostics);
        return elt;
    }
}
function $1e126942d86629f6$var$trackHoverOn(view, marker) {
    let mousemove = (event)=>{
        let rect = marker.getBoundingClientRect();
        if (event.clientX > rect.left - 10 /* Hover.Margin */  && event.clientX < rect.right + 10 /* Hover.Margin */  && event.clientY > rect.top - 10 /* Hover.Margin */  && event.clientY < rect.bottom + 10 /* Hover.Margin */ ) return;
        for(let target = event.target; target; target = target.parentNode){
            if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint")) return;
        }
        window.removeEventListener("mousemove", mousemove);
        if (view.state.field($1e126942d86629f6$var$lintGutterTooltip)) view.dispatch({
            effects: $1e126942d86629f6$var$setLintGutterTooltip.of(null)
        });
    };
    window.addEventListener("mousemove", mousemove);
}
function $1e126942d86629f6$var$gutterMarkerMouseOver(view, marker, diagnostics) {
    function hovered() {
        let line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
        const linePos = view.coordsAtPos(line.from);
        if (linePos) view.dispatch({
            effects: $1e126942d86629f6$var$setLintGutterTooltip.of({
                pos: line.from,
                above: false,
                create () {
                    return {
                        dom: $1e126942d86629f6$var$diagnosticsTooltip(view, diagnostics),
                        getCoords: ()=>marker.getBoundingClientRect()
                    };
                }
            })
        });
        marker.onmouseout = marker.onmousemove = null;
        $1e126942d86629f6$var$trackHoverOn(view, marker);
    }
    let { hoverTime: hoverTime } = view.state.facet($1e126942d86629f6$var$lintGutterConfig);
    let hoverTimeout = setTimeout(hovered, hoverTime);
    marker.onmouseout = ()=>{
        clearTimeout(hoverTimeout);
        marker.onmouseout = marker.onmousemove = null;
    };
    marker.onmousemove = ()=>{
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(hovered, hoverTime);
    };
}
function $1e126942d86629f6$var$markersForDiagnostics(doc, diagnostics) {
    let byLine = Object.create(null);
    for (let diagnostic of diagnostics){
        let line = doc.lineAt(diagnostic.from);
        (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
    }
    let markers = [];
    for(let line in byLine)markers.push(new $1e126942d86629f6$var$LintGutterMarker(byLine[line]).range(+line));
    return (0, $6295c6875f57e3ee$export$34cb5241245008dd).of(markers, true);
}
const $1e126942d86629f6$var$lintGutterExtension = /*@__PURE__*/ (0, $7beee9608540d2c3$export$f2b922cb4a245974)({
    class: "cm-gutter-lint",
    markers: (view)=>view.state.field($1e126942d86629f6$var$lintGutterMarkers)
});
const $1e126942d86629f6$var$lintGutterMarkers = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return (0, $6295c6875f57e3ee$export$34cb5241245008dd).empty;
    },
    update (markers, tr) {
        markers = markers.map(tr.changes);
        let diagnosticFilter = tr.state.facet($1e126942d86629f6$var$lintGutterConfig).markerFilter;
        for (let effect of tr.effects)if (effect.is($1e126942d86629f6$export$9c7976977981c7bf)) {
            let diagnostics = effect.value;
            if (diagnosticFilter) diagnostics = diagnosticFilter(diagnostics || [], tr.state);
            markers = $1e126942d86629f6$var$markersForDiagnostics(tr.state.doc, diagnostics.slice(0));
        }
        return markers;
    }
});
const $1e126942d86629f6$var$setLintGutterTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$95000d4efaa4321f).define();
const $1e126942d86629f6$var$lintGutterTooltip = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$34381b1ce2130245).define({
    create () {
        return null;
    },
    update (tooltip, tr) {
        if (tooltip && tr.docChanged) tooltip = $1e126942d86629f6$var$hideTooltip(tr, tooltip) ? null : Object.assign(Object.assign({}, tooltip), {
            pos: tr.changes.mapPos(tooltip.pos)
        });
        return tr.effects.reduce((t, e)=>e.is($1e126942d86629f6$var$setLintGutterTooltip) ? e.value : t, tooltip);
    },
    provide: (field)=>(0, $7beee9608540d2c3$export$dba11b50e1aa3c12).from(field)
});
const $1e126942d86629f6$var$lintGutterTheme = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).baseTheme({
    ".cm-gutter-lint": {
        width: "1.4em",
        "& .cm-gutterElement": {
            padding: ".2em"
        }
    },
    ".cm-lint-marker": {
        width: "1em",
        height: "1em"
    },
    ".cm-lint-marker-info": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
    },
    ".cm-lint-marker-warning": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
    },
    ".cm-lint-marker-error": {
        content: /*@__PURE__*/ $1e126942d86629f6$var$svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
    }
});
const $1e126942d86629f6$var$lintExtensions = [
    $1e126942d86629f6$var$lintState,
    /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).decorations.compute([
        $1e126942d86629f6$var$lintState
    ], (state)=>{
        let { selected: selected, panel: panel } = state.field($1e126942d86629f6$var$lintState);
        return !selected || !panel || selected.from == selected.to ? (0, $7beee9608540d2c3$export$10e30b733df217ea).none : (0, $7beee9608540d2c3$export$10e30b733df217ea).set([
            $1e126942d86629f6$var$activeMark.range(selected.from, selected.to)
        ]);
    }),
    /*@__PURE__*/ (0, $7beee9608540d2c3$export$69f8d9e63c4aa884)($1e126942d86629f6$var$lintTooltip, {
        hideOn: $1e126942d86629f6$var$hideTooltip
    }),
    $1e126942d86629f6$var$baseTheme
];
const $1e126942d86629f6$var$lintGutterConfig = /*@__PURE__*/ (0, $6295c6875f57e3ee$export$ef7d5e9b79fa1504).define({
    combine (configs) {
        return (0, $6295c6875f57e3ee$export$4e19c0b693794a7e)(configs, {
            hoverTime: 300 /* Hover.Time */ ,
            markerFilter: null,
            tooltipFilter: null
        });
    }
});
/**
Returns an extension that installs a gutter showing markers for
each line that has diagnostics, which can be hovered over to see
the diagnostics.
*/ function $1e126942d86629f6$export$3a68dabf7c007d32(config = {}) {
    return [
        $1e126942d86629f6$var$lintGutterConfig.of(config),
        $1e126942d86629f6$var$lintGutterMarkers,
        $1e126942d86629f6$var$lintGutterExtension,
        $1e126942d86629f6$var$lintGutterTheme,
        $1e126942d86629f6$var$lintGutterTooltip
    ];
}
/**
Iterate over the marked diagnostics for the given editor state,
calling `f` for each of them. Note that, if the document changed
since the diagnostics were created, the `Diagnostic` object will
hold the original outdated position, whereas the `to` and `from`
arguments hold the diagnostic's current position.
*/ function $1e126942d86629f6$export$7991d57589868fb2(state, f) {
    let lState = state.field($1e126942d86629f6$var$lintState, false);
    if (lState && lState.diagnostics.size) for(let iter = (0, $6295c6875f57e3ee$export$34cb5241245008dd).iter([
        lState.diagnostics
    ]); iter.value; iter.next())f(iter.value.spec.diagnostic, iter.from, iter.to);
}


var $4eff9f346d033132$export$f4f2465c1e83499c = function basicSetup(options) {
    if (options === void 0) options = {};
    var { crosshairCursor: initCrosshairCursor = false } = options;
    var keymaps = [];
    if (options.closeBracketsKeymap !== false) keymaps = keymaps.concat((0, $7570a9a1a9679713$export$9477e95792b48f4a));
    if (options.defaultKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab2e8d0ac5d2b69e));
    if (options.searchKeymap !== false) keymaps = keymaps.concat((0, $976a3faeb93466fd$export$2dba96787cbe0a4a));
    if (options.historyKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab4a28cb63e8a670));
    if (options.foldKeymap !== false) keymaps = keymaps.concat((0, $a97ccac5cf5f4f5d$export$39c52376a8936d67));
    if (options.completionKeymap !== false) keymaps = keymaps.concat((0, $7570a9a1a9679713$export$2a3d759d156afab4));
    if (options.lintKeymap !== false) keymaps = keymaps.concat((0, $1e126942d86629f6$export$a21d7a0cde3cbb60));
    var extensions = [];
    if (options.lineNumbers !== false) extensions.push((0, $7beee9608540d2c3$export$1a8cf111682eaa7d)());
    if (options.highlightActiveLineGutter !== false) extensions.push((0, $7beee9608540d2c3$export$93b52f08bb2c759c)());
    if (options.highlightSpecialChars !== false) extensions.push((0, $7beee9608540d2c3$export$76dc0899547f659c)());
    if (options.history !== false) extensions.push((0, $032754016b6293d7$export$55abd4691b317664)());
    if (options.foldGutter !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$c4dcf64f741b6228)());
    if (options.drawSelection !== false) extensions.push((0, $7beee9608540d2c3$export$17a3d0ab3687347d)());
    if (options.dropCursor !== false) extensions.push((0, $7beee9608540d2c3$export$b8e3092a3bfa2062)());
    if (options.allowMultipleSelections !== false) extensions.push((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).allowMultipleSelections.of(true));
    if (options.indentOnInput !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$9bcaf6e2125ee117)());
    if (options.syntaxHighlighting !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)((0, $a97ccac5cf5f4f5d$export$bb02a6818dd48320), {
        fallback: true
    }));
    if (options.bracketMatching !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$cef7edfd214be605)());
    if (options.closeBrackets !== false) extensions.push((0, $7570a9a1a9679713$export$69e4e9d3300ff824)());
    if (options.autocompletion !== false) extensions.push((0, $7570a9a1a9679713$export$f95786d390465556)());
    if (options.rectangularSelection !== false) extensions.push((0, $7beee9608540d2c3$export$dd482925db1aabd3)());
    if (initCrosshairCursor !== false) extensions.push((0, $7beee9608540d2c3$export$9b6525222ac3b7fb)());
    if (options.highlightActiveLine !== false) extensions.push((0, $7beee9608540d2c3$export$1a7e096bee9035c)());
    if (options.highlightSelectionMatches !== false) extensions.push((0, $976a3faeb93466fd$export$f14efe56171a2e02)());
    if (options.tabSize && typeof options.tabSize === "number") extensions.push((0, $a97ccac5cf5f4f5d$export$9e0d0c2ce4d3ceb5).of(" ".repeat(options.tabSize)));
    return extensions.concat([
        (0, $7beee9608540d2c3$export$5043418e2ef368d5).of(keymaps.flat())
    ]).filter(Boolean);
};
var $4eff9f346d033132$export$def279f8e103ce59 = function minimalSetup(options) {
    if (options === void 0) options = {};
    var keymaps = [];
    if (options.defaultKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab2e8d0ac5d2b69e));
    if (options.historyKeymap !== false) keymaps = keymaps.concat((0, $032754016b6293d7$export$ab4a28cb63e8a670));
    var extensions = [];
    if (options.highlightSpecialChars !== false) extensions.push((0, $7beee9608540d2c3$export$76dc0899547f659c)());
    if (options.history !== false) extensions.push((0, $032754016b6293d7$export$55abd4691b317664)());
    if (options.drawSelection !== false) extensions.push((0, $7beee9608540d2c3$export$17a3d0ab3687347d)());
    if (options.syntaxHighlighting !== false) extensions.push((0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)((0, $a97ccac5cf5f4f5d$export$bb02a6818dd48320), {
        fallback: true
    }));
    return extensions.concat([
        (0, $7beee9608540d2c3$export$5043418e2ef368d5).of(keymaps.flat())
    ]).filter(Boolean);
};






// Using https://github.com/one-dark/vscode-one-dark-theme/ as reference for the colors
const $467f030ca1673efa$var$chalky = "#e5c07b", $467f030ca1673efa$var$coral = "#e06c75", $467f030ca1673efa$var$cyan = "#56b6c2", $467f030ca1673efa$var$invalid = "#ffffff", $467f030ca1673efa$var$ivory = "#abb2bf", $467f030ca1673efa$var$stone = "#7d8799", $467f030ca1673efa$var$malibu = "#61afef", $467f030ca1673efa$var$sage = "#98c379", $467f030ca1673efa$var$whiskey = "#d19a66", $467f030ca1673efa$var$violet = "#c678dd", $467f030ca1673efa$var$darkBackground = "#21252b", $467f030ca1673efa$var$highlightBackground = "#2c313a", $467f030ca1673efa$var$background = "#282c34", $467f030ca1673efa$var$tooltipBackground = "#353a42", $467f030ca1673efa$var$selection = "#3E4451", $467f030ca1673efa$var$cursor = "#528bff";
/**
The colors used in the theme, as CSS color strings.
*/ const $467f030ca1673efa$export$35e9368ef982300f = {
    chalky: $467f030ca1673efa$var$chalky,
    coral: $467f030ca1673efa$var$coral,
    cyan: $467f030ca1673efa$var$cyan,
    invalid: $467f030ca1673efa$var$invalid,
    ivory: $467f030ca1673efa$var$ivory,
    stone: $467f030ca1673efa$var$stone,
    malibu: $467f030ca1673efa$var$malibu,
    sage: $467f030ca1673efa$var$sage,
    whiskey: $467f030ca1673efa$var$whiskey,
    violet: $467f030ca1673efa$var$violet,
    darkBackground: $467f030ca1673efa$var$darkBackground,
    highlightBackground: $467f030ca1673efa$var$highlightBackground,
    background: $467f030ca1673efa$var$background,
    tooltipBackground: $467f030ca1673efa$var$tooltipBackground,
    selection: $467f030ca1673efa$var$selection,
    cursor: $467f030ca1673efa$var$cursor
};
/**
The editor theme styles for One Dark.
*/ const $467f030ca1673efa$export$71837134942a888d = /*@__PURE__*/ (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
    "&": {
        color: $467f030ca1673efa$var$ivory,
        backgroundColor: $467f030ca1673efa$var$background
    },
    ".cm-content": {
        caretColor: $467f030ca1673efa$var$cursor
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeftColor: $467f030ca1673efa$var$cursor
    },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": {
        backgroundColor: $467f030ca1673efa$var$selection
    },
    ".cm-panels": {
        backgroundColor: $467f030ca1673efa$var$darkBackground,
        color: $467f030ca1673efa$var$ivory
    },
    ".cm-panels.cm-panels-top": {
        borderBottom: "2px solid black"
    },
    ".cm-panels.cm-panels-bottom": {
        borderTop: "2px solid black"
    },
    ".cm-searchMatch": {
        backgroundColor: "#72a1ff59",
        outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
        backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": {
        backgroundColor: "#6699ff0b"
    },
    ".cm-selectionMatch": {
        backgroundColor: "#aafe661a"
    },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
        backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
        backgroundColor: $467f030ca1673efa$var$background,
        color: $467f030ca1673efa$var$stone,
        border: "none"
    },
    ".cm-activeLineGutter": {
        backgroundColor: $467f030ca1673efa$var$highlightBackground
    },
    ".cm-foldPlaceholder": {
        backgroundColor: "transparent",
        border: "none",
        color: "#ddd"
    },
    ".cm-tooltip": {
        border: "none",
        backgroundColor: $467f030ca1673efa$var$tooltipBackground
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
        borderTopColor: "transparent",
        borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
        borderTopColor: $467f030ca1673efa$var$tooltipBackground,
        borderBottomColor: $467f030ca1673efa$var$tooltipBackground
    },
    ".cm-tooltip-autocomplete": {
        "& > ul > li[aria-selected]": {
            backgroundColor: $467f030ca1673efa$var$highlightBackground,
            color: $467f030ca1673efa$var$ivory
        }
    }
}, {
    dark: true
});
/**
The highlighting style for code in the One Dark theme.
*/ const $467f030ca1673efa$export$e74990644b6794ed = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$4819f093bdd5b4a).define([
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
        color: $467f030ca1673efa$var$violet
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).name,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).deleted,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).character,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).macroName
        ],
        color: $467f030ca1673efa$var$coral
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).labelName
        ],
        color: $467f030ca1673efa$var$malibu
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).color,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).constant((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).standard((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name)
        ],
        color: $467f030ca1673efa$var$whiskey
    },
    {
        tag: [
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).name),
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator
        ],
        color: $467f030ca1673efa$var$ivory
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).typeName,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).className,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).changed,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).annotation,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).self,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).namespace
        ],
        color: $467f030ca1673efa$var$chalky
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operator,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).url,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).regexp,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string)
        ],
        color: $467f030ca1673efa$var$cyan
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).comment
        ],
        color: $467f030ca1673efa$var$stone
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strong,
        fontWeight: "bold"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).emphasis,
        fontStyle: "italic"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).strikethrough,
        textDecoration: "line-through"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).link,
        color: $467f030ca1673efa$var$stone,
        textDecoration: "underline"
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).heading,
        fontWeight: "bold",
        color: $467f030ca1673efa$var$coral
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).atom,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
            /*@__PURE__*/ (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)
        ],
        color: $467f030ca1673efa$var$whiskey
    },
    {
        tag: [
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).processingInstruction,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
            (0, $a1ec9d683d365521$export$8b7a896ae75accbf).inserted
        ],
        color: $467f030ca1673efa$var$sage
    },
    {
        tag: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).invalid,
        color: $467f030ca1673efa$var$invalid
    }
]);
/**
Extension to enable the One Dark theme (both the editor theme and
the highlight style).
*/ const $467f030ca1673efa$export$97539a48bdf87cbf = [
    $467f030ca1673efa$export$71837134942a888d,
    /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$ec1b956ff3a16361)($467f030ca1673efa$export$e74990644b6794ed)
];




var $8a00d1f38586aebb$export$5c0bff399ffe03b = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
    "&": {
        backgroundColor: "#fff"
    }
}, {
    dark: false
});


var $e1be4b6b4d37a0a2$export$8c6170ff4f7af97d = function getDefaultExtensions(optios) {
    if (optios === void 0) optios = {};
    var { indentWithTab: defaultIndentWithTab = true, editable: editable = true, readOnly: readOnly = false, theme: theme = "light", placeholder: placeholderStr = "", basicSetup: defaultBasicSetup = true } = optios;
    var getExtensions = [];
    if (defaultIndentWithTab) getExtensions.unshift((0, $7beee9608540d2c3$export$5043418e2ef368d5).of([
        (0, $032754016b6293d7$export$893b77570f8af4da)
    ]));
    if (defaultBasicSetup) {
        if (typeof defaultBasicSetup === "boolean") getExtensions.unshift((0, $4eff9f346d033132$export$f4f2465c1e83499c)());
        else getExtensions.unshift((0, $4eff9f346d033132$export$f4f2465c1e83499c)(defaultBasicSetup));
    }
    if (placeholderStr) getExtensions.unshift((0, $7beee9608540d2c3$export$c7187bbd1a7a9244)(placeholderStr));
    switch(theme){
        case "light":
            getExtensions.push((0, $8a00d1f38586aebb$export$5c0bff399ffe03b));
            break;
        case "dark":
            getExtensions.push((0, $467f030ca1673efa$export$97539a48bdf87cbf));
            break;
        case "none":
            break;
        default:
            getExtensions.push(theme);
            break;
    }
    if (editable === false) getExtensions.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).editable.of(false));
    if (readOnly) getExtensions.push((0, $6295c6875f57e3ee$export$afa855cbfaff27f2).readOnly.of(true));
    return [
        ...getExtensions
    ];
};


var $aa886e06174c9e1a$export$115663dc807a2e95 = (view)=>{
    return {
        line: view.state.doc.lineAt(view.state.selection.main.from),
        lineCount: view.state.doc.lines,
        lineBreak: view.state.lineBreak,
        length: view.state.doc.length,
        readOnly: view.state.readOnly,
        tabSize: view.state.tabSize,
        selection: view.state.selection,
        selectionAsSingle: view.state.selection.asSingle().main,
        ranges: view.state.selection.ranges,
        selectionCode: view.state.sliceDoc(view.state.selection.main.from, view.state.selection.main.to),
        selections: view.state.selection.ranges.map((r)=>view.state.sliceDoc(r.from, r.to)),
        selectedText: view.state.selection.ranges.some((r)=>!r.empty)
    };
};


var $e7c12a755349ccc2$var$External = (0, $6295c6875f57e3ee$export$9279461326b8700a).define();
var $e7c12a755349ccc2$var$emptyExtensions = [];
function $e7c12a755349ccc2$export$6b2608dbc019b23d(props) {
    var { value: value, selection: selection, onChange: onChange, onStatistics: onStatistics, onCreateEditor: onCreateEditor, onUpdate: onUpdate, extensions: extensions = $e7c12a755349ccc2$var$emptyExtensions, autoFocus: autoFocus, theme: theme = "light", height: height = null, minHeight: minHeight = null, maxHeight: maxHeight = null, width: width = null, minWidth: minWidth = null, maxWidth: maxWidth = null, placeholder: placeholderStr = "", editable: editable = true, readOnly: readOnly = false, indentWithTab: defaultIndentWithTab = true, basicSetup: defaultBasicSetup = true, root: root, initialState: initialState } = props;
    var [container, setContainer] = (0, $acw62.useState)();
    var [view, setView] = (0, $acw62.useState)();
    var [state, setState] = (0, $acw62.useState)();
    var defaultThemeOption = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).theme({
        "&": {
            height: height,
            minHeight: minHeight,
            maxHeight: maxHeight,
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth
        },
        "& .cm-scroller": {
            height: "100% !important"
        }
    });
    var updateListener = (0, $7beee9608540d2c3$export$eece2fccabbb77c5).updateListener.of((vu)=>{
        if (vu.docChanged && typeof onChange === "function" && // Fix echoing of the remote changes:
        // If transaction is market as remote we don't have to call `onChange` handler again
        !vu.transactions.some((tr)=>tr.annotation($e7c12a755349ccc2$var$External))) {
            var doc = vu.state.doc;
            var _value = doc.toString();
            onChange(_value, vu);
        }
        onStatistics && onStatistics((0, $aa886e06174c9e1a$export$115663dc807a2e95)(vu));
    });
    var defaultExtensions = (0, $e1be4b6b4d37a0a2$export$8c6170ff4f7af97d)({
        theme: theme,
        editable: editable,
        readOnly: readOnly,
        placeholder: placeholderStr,
        indentWithTab: defaultIndentWithTab,
        basicSetup: defaultBasicSetup
    });
    var getExtensions = [
        updateListener,
        defaultThemeOption,
        ...defaultExtensions
    ];
    if (onUpdate && typeof onUpdate === "function") getExtensions.push((0, $7beee9608540d2c3$export$eece2fccabbb77c5).updateListener.of(onUpdate));
    getExtensions = getExtensions.concat(extensions);
    (0, $acw62.useEffect)(()=>{
        if (container && !state) {
            var config = {
                doc: value,
                selection: selection,
                extensions: getExtensions
            };
            var stateCurrent = initialState ? (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).fromJSON(initialState.json, config, initialState.fields) : (0, $6295c6875f57e3ee$export$afa855cbfaff27f2).create(config);
            setState(stateCurrent);
            if (!view) {
                var viewCurrent = new (0, $7beee9608540d2c3$export$eece2fccabbb77c5)({
                    state: stateCurrent,
                    parent: container,
                    root: root
                });
                setView(viewCurrent);
                onCreateEditor && onCreateEditor(viewCurrent, stateCurrent);
            }
        }
        return ()=>{
            if (view) {
                setState(undefined);
                setView(undefined);
            }
        };
    }, [
        container,
        state
    ]);
    (0, $acw62.useEffect)(()=>setContainer(props.container), [
        props.container
    ]);
    (0, $acw62.useEffect)(()=>()=>{
            if (view) {
                view.destroy();
                setView(undefined);
            }
        }, [
        view
    ]);
    (0, $acw62.useEffect)(()=>{
        if (autoFocus && view) view.focus();
    }, [
        autoFocus,
        view
    ]);
    (0, $acw62.useEffect)(()=>{
        if (view) view.dispatch({
            effects: (0, $6295c6875f57e3ee$export$95000d4efaa4321f).reconfigure.of(getExtensions)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        theme,
        extensions,
        height,
        minHeight,
        maxHeight,
        width,
        minWidth,
        maxWidth,
        placeholderStr,
        editable,
        readOnly,
        defaultIndentWithTab,
        defaultBasicSetup,
        onChange,
        onUpdate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (value === undefined) return;
        var currentValue = view ? view.state.doc.toString() : "";
        if (view && value !== currentValue) view.dispatch({
            changes: {
                from: 0,
                to: currentValue.length,
                insert: value || ""
            },
            annotations: [
                $e7c12a755349ccc2$var$External.of(true)
            ]
        });
    }, [
        value,
        view
    ]);
    return {
        state: state,
        setState: setState,
        view: view,
        setView: setView,
        container: container,
        setContainer: setContainer
    };
}








var $269cb9ebbcb83755$var$_excluded = [
    "className",
    "value",
    "selection",
    "extensions",
    "onChange",
    "onStatistics",
    "onCreateEditor",
    "onUpdate",
    "autoFocus",
    "theme",
    "height",
    "minHeight",
    "maxHeight",
    "width",
    "minWidth",
    "maxWidth",
    "basicSetup",
    "placeholder",
    "indentWithTab",
    "editable",
    "readOnly",
    "root",
    "initialState"
];
var $269cb9ebbcb83755$var$ReactCodeMirror = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { className: className, value: value = "", selection: selection, extensions: extensions = [], onChange: onChange, onStatistics: onStatistics, onCreateEditor: onCreateEditor, onUpdate: onUpdate, autoFocus: autoFocus, theme: theme = "light", height: height, minHeight: minHeight, maxHeight: maxHeight, width: width, minWidth: minWidth, maxWidth: maxWidth, basicSetup: basicSetup, placeholder: placeholder, indentWithTab: indentWithTab, editable: editable, readOnly: readOnly, root: root, initialState: initialState } = props, other = (0, (/*@__PURE__*/$parcel$interopDefault($8bc9a7bbcf9a2a3b$exports)))(props, $269cb9ebbcb83755$var$_excluded);
    var editor = (0, $acw62.useRef)(null);
    var { state: state, view: view, container: container } = (0, $e7c12a755349ccc2$export$6b2608dbc019b23d)({
        container: editor.current,
        root: root,
        value: value,
        autoFocus: autoFocus,
        theme: theme,
        height: height,
        minHeight: minHeight,
        maxHeight: maxHeight,
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth,
        basicSetup: basicSetup,
        placeholder: placeholder,
        indentWithTab: indentWithTab,
        editable: editable,
        readOnly: readOnly,
        selection: selection,
        onChange: onChange,
        onStatistics: onStatistics,
        onCreateEditor: onCreateEditor,
        onUpdate: onUpdate,
        extensions: extensions,
        initialState: initialState
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            editor: editor.current,
            state: state,
            view: view
        }), [
        editor,
        container,
        state,
        view
    ]);
    // check type of value
    if (typeof value !== "string") throw new Error("value must be typeof string but got " + typeof value);
    var defaultClassNames = typeof theme === "string" ? "cm-theme-" + theme : "cm-theme";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($27ab08c24269de64$exports)))({
        ref: editor,
        className: "" + defaultClassNames + (className ? " " + className : "")
    }, other));
});
$269cb9ebbcb83755$var$ReactCodeMirror.displayName = "CodeMirror";
var $269cb9ebbcb83755$export$2e2bcd8739ae039 = $269cb9ebbcb83755$var$ReactCodeMirror;




/**
A parse stack. These are used internally by the parser to track
parsing progress. They also provide some properties and methods
that external code such as a tokenizer can use to get information
about the parse state.
*/ class $96e8fc72168067c5$export$694e0d28c7ffc90c {
    /**
    @internal
    */ constructor(/**
    The parse that this stack is part of @internal
    */ p, /**
    Holds state, input pos, buffer index triplets for all but the
    top state @internal
    */ stack, /**
    The current parse state @internal
    */ state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /**
    @internal
    */ reducePos, /**
    The input position up to which this stack has parsed.
    */ pos, /**
    The dynamic score of the stack, including dynamic precedence
    and error-recovery penalties
    @internal
    */ score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /**
    @internal
    */ buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /**
    @internal
    */ bufferBase, /**
    @internal
    */ curContext, /**
    @internal
    */ lookAhead = 0, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /**
    @internal
    */ parent){
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
    /**
    @internal
    */ toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /**
    @internal
    */ static start(p, state, pos = 0) {
        let cx = p.parser.context;
        return new $96e8fc72168067c5$export$694e0d28c7ffc90c(p, [], state, pos, pos, 0, [], 0, cx ? new $96e8fc72168067c5$var$StackContext(cx, cx.start) : null, 0, null);
    }
    /**
    The stack's current [context](#lr.ContextTracker) value, if
    any. Its type will depend on the context tracker's type
    parameter, or it will be `null` if there is no context
    tracker.
    */ get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /**
    @internal
    */ pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /**
    @internal
    */ reduce(action) {
        var _a;
        let depth = action >> 19 /* Action.ReduceDepthShift */ , type = action & 65535 /* Action.ValueMask */ ;
        let { parser: parser } = this.p;
        if (this.reducePos < this.pos - 25 /* Lookahead.Margin */ ) this.setLookAhead(this.pos);
        let dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        let base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* Action.StayFlag */  ? 6 : 0);
        let start = base ? this.stack[base - 2] : this.p.ranges[0].from, size = this.reducePos - start;
        // This is a kludge to try and detect overly deep left-associative
        // trees, which will not increase the parse stack depth and thus
        // won't be caught by the regular stack-depth limit check.
        if (size >= 2000 /* Recover.MinBigReduction */  && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
            if (start == this.p.lastBigReductionStart) {
                this.p.bigReductionCount++;
                this.p.lastBigReductionSize = size;
            } else if (this.p.lastBigReductionSize < size) {
                this.p.bigReductionCount = 1;
                this.p.lastBigReductionStart = start;
                this.p.lastBigReductionSize = size;
            }
        }
        let bufferBase = base ? this.stack[base - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* Action.RepeatFlag */ ) {
            let pos = parser.stateFlag(this.state, 1 /* StateFlag.Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* Action.StayFlag */ ) this.state = this.stack[base];
        else {
            let baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /**
    @internal
    */ storeNode(term, start, end, size = 4, isReduce = false) {
        if (term == 0 /* Term.Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            let cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Term.Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!isReduce || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            let index = this.buffer.length;
            if (index > 0 && this.buffer[index - 4] != 0 /* Term.Err */ ) while(index > 0 && this.buffer[index - 2] > end){
                // Move this record forward
                this.buffer[index] = this.buffer[index - 4];
                this.buffer[index + 1] = this.buffer[index - 3];
                this.buffer[index + 2] = this.buffer[index - 2];
                this.buffer[index + 3] = this.buffer[index - 1];
                index -= 4;
                if (size > 4) size -= 4;
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /**
    @internal
    */ shift(action, type, start, end) {
        if (action & 131072 /* Action.GotoFlag */ ) this.pushState(action & 65535 /* Action.ValueMask */ , this.pos);
        else if ((action & 262144 /* Action.StayFlag */ ) == 0) {
            let nextState = action, { parser: parser } = this.p;
            if (end > this.pos || type <= parser.maxNode) {
                this.pos = end;
                if (!parser.stateFlag(nextState, 1 /* StateFlag.Skipped */ )) this.reducePos = end;
            }
            this.pushState(nextState, start);
            this.shiftContext(type, start);
            if (type <= parser.maxNode) this.buffer.push(type, start, end, 4);
        } else {
            this.pos = end;
            this.shiftContext(type, start);
            if (type <= this.p.parser.maxNode) this.buffer.push(type, start, end, 4);
        }
    }
    // Apply an action
    /**
    @internal
    */ apply(action, next, nextStart, nextEnd) {
        if (action & 65536 /* Action.ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextStart, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /**
    @internal
    */ useNode(value, next) {
        let index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        let start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /**
    @internal
    */ split() {
        let parent = this;
        let off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        let buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new $96e8fc72168067c5$export$694e0d28c7ffc90c(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /**
    @internal
    */ recoverByDelete(next, nextEnd) {
        let isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Term.Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Recover.Delete */ ;
    }
    /**
    Check if the given term would be able to be shifted (optionally
    after some reductions) on this stack. This can be useful for
    external tokenizers that want to make sure they only provide a
    given token when it applies.
    */ canShift(term) {
        for(let sim = new $96e8fc72168067c5$var$SimulatedStack(this);;){
            let action = this.p.parser.stateSlot(sim.state, 4 /* ParseState.DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if (action == 0) return false;
            if ((action & 65536 /* Action.ReduceFlag */ ) == 0) return true;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /**
    @internal
    */ recoverByInsert(next) {
        if (this.stack.length >= 300 /* Recover.MaxInsertStackDepth */ ) return [];
        let nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* Recover.DampenInsertStackDepth */ ) {
            let best = [];
            for(let i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* Recover.DampenInsertStackDepth */ ) for(let i = 0; best.length < 8 && i < nextStates.length; i += 2){
                let s = nextStates[i + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i], s);
            }
            nextStates = best;
        }
        let result = [];
        for(let i = 0; i < nextStates.length && result.length < 4 /* Recover.MaxNext */ ; i += 2){
            let s = nextStates[i + 1];
            if (s == this.state) continue;
            let stack = this.split();
            stack.pushState(s, this.pos);
            stack.storeNode(0 /* Term.Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i], this.pos);
            stack.reducePos = this.pos;
            stack.score -= 200 /* Recover.Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /**
    @internal
    */ forceReduce() {
        let { parser: parser } = this.p;
        let reduce = parser.stateSlot(this.state, 5 /* ParseState.ForcedReduce */ );
        if ((reduce & 65536 /* Action.ReduceFlag */ ) == 0) return false;
        if (!parser.validAction(this.state, reduce)) {
            let depth = reduce >> 19 /* Action.ReduceDepthShift */ , term = reduce & 65535 /* Action.ValueMask */ ;
            let target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) {
                let backup = this.findForcedReduction();
                if (backup == null) return false;
                reduce = backup;
            }
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            this.score -= 100 /* Recover.Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /**
    Try to scan through the automaton to find some kind of reduction
    that can be applied. Used when the regular ForcedReduce field
    isn't a valid action. @internal
    */ findForcedReduction() {
        let { parser: parser } = this.p, seen = [];
        let explore = (state, depth)=>{
            if (seen.includes(state)) return;
            seen.push(state);
            return parser.allActions(state, (action)=>{
                if (action & 393216 /* Action.GotoFlag */ ) ;
                else if (action & 65536 /* Action.ReduceFlag */ ) {
                    let rDepth = (action >> 19 /* Action.ReduceDepthShift */ ) - depth;
                    if (rDepth > 1) {
                        let term = action & 65535 /* Action.ValueMask */ , target = this.stack.length - rDepth * 3;
                        if (target >= 0 && parser.getGoto(this.stack[target], term, false) >= 0) return rDepth << 19 /* Action.ReduceDepthShift */  | 65536 /* Action.ReduceFlag */  | term;
                    }
                } else {
                    let found = explore(action, depth + 1);
                    if (found != null) return found;
                }
            });
        };
        return explore(this.state, 0);
    }
    /**
    @internal
    */ forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* StateFlag.Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /**
    Check whether this state has no further actions (assumed to be a direct descendant of the
    top state, since any other states must be able to continue
    somehow). @internal
    */ get deadEnd() {
        if (this.stack.length != 3) return false;
        let { parser: parser } = this.p;
        return parser.data[parser.stateSlot(this.state, 1 /* ParseState.Actions */ )] == 65535 /* Seq.End */  && !parser.stateSlot(this.state, 4 /* ParseState.DefaultReduce */ );
    }
    /**
    Restart the stack (put it back in its start state). Only safe
    when this.stack.length == 3 (state is directly below the top
    state). @internal
    */ restart() {
        this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /**
    @internal
    */ sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(let i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /**
    Get the parser used by this stack.
    */ get parser() {
        return this.p.parser;
    }
    /**
    Test whether a given dialect (by numeric ID, as exported from
    the terms file) is enabled.
    */ dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /**
    @internal
    */ emitContext() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    /**
    @internal
    */ emitLookAhead() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            let newCx = new $96e8fc72168067c5$var$StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /**
    @internal
    */ setLookAhead(lookAhead) {
        if (lookAhead > this.lookAhead) {
            this.emitLookAhead();
            this.lookAhead = lookAhead;
        }
    }
    /**
    @internal
    */ close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
}
class $96e8fc72168067c5$var$StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class $96e8fc72168067c5$var$SimulatedStack {
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
    reduce(action) {
        let term = action & 65535 /* Action.ValueMask */ , depth = action >> 19 /* Action.ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class $96e8fc72168067c5$var$StackBufferCursor {
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
    static create(stack, pos = stack.bufferBase + stack.buffer.length) {
        return new $96e8fc72168067c5$var$StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        let next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new $96e8fc72168067c5$var$StackBufferCursor(this.stack, this.pos, this.index);
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function $96e8fc72168067c5$var$decodeArray(input, Type = Uint16Array) {
    if (typeof input != "string") return input;
    let array = null;
    for(let pos = 0, out = 0; pos < input.length;){
        let value = 0;
        for(;;){
            let next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* Encode.BigValCode */ ) {
                value = 65535 /* Encode.BigVal */ ;
                break;
            }
            if (next >= 92 /* Encode.Gap2 */ ) next--;
            if (next >= 34 /* Encode.Gap1 */ ) next--;
            let digit = next - 32 /* Encode.Start */ ;
            if (digit >= 46 /* Encode.Base */ ) {
                digit -= 46 /* Encode.Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Encode.Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
class $96e8fc72168067c5$var$CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
const $96e8fc72168067c5$var$nullToken = new $96e8fc72168067c5$var$CachedToken;
/**
[Tokenizers](#lr.ExternalTokenizer) interact with the input
through this interface. It presents the input as a stream of
characters, tracking lookahead and hiding the complexity of
[ranges](#common.Parser.parse^ranges) from tokenizer code.
*/ class $96e8fc72168067c5$export$f22294a9362415e4 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ input, /**
    @internal
    */ ranges){
        this.input = input;
        this.ranges = ranges;
        /**
        @internal
        */ this.chunk = "";
        /**
        @internal
        */ this.chunkOff = 0;
        /**
        Backup chunk
        */ this.chunk2 = "";
        this.chunk2Pos = 0;
        /**
        The character code of the next code unit in the input, or -1
        when the stream is at the end of the input.
        */ this.next = -1;
        /**
        @internal
        */ this.token = $96e8fc72168067c5$var$nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
    /**
    @internal
    */ resolveOffset(offset, assoc) {
        let range = this.range, index = this.rangeIndex;
        let pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            let next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            let next = this.ranges[++index];
            pos += next.from - range.to;
            range = next;
        }
        return pos;
    }
    /**
    @internal
    */ clipPos(pos) {
        if (pos >= this.range.from && pos < this.range.to) return pos;
        for (let range of this.ranges)if (range.to > pos) return Math.max(pos, range.from);
        return this.end;
    }
    /**
    Look at a code unit near the stream position. `.peek(0)` equals
    `.next`, `.peek(-1)` gives you the previous character, and so
    on.
    
    Note that looking around during tokenizing creates dependencies
    on potentially far-away content, which may reduce the
    effectiveness incremental parsing—when looking forward—or even
    cause invalid reparses when looking backward more than 25 code
    units, since the library does not track lookbehind.
    */ peek(offset) {
        let idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            let resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                let i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /**
    Accept a token. By default, the end of the token is set to the
    current stream position, but you can pass an offset (relative to
    the stream position) to change that.
    */ acceptToken(token, endOffset = 0) {
        let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    /**
    Accept a token ending at a specific given position.
    */ acceptTokenTo(token, endPos) {
        this.token.value = token;
        this.token.end = endPos;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            let { chunk: chunk, chunkPos: chunkPos } = this;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            let nextChunk = this.input.chunk(this.pos);
            let end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /**
    Move the stream forward N (defaults to 1) code units. Returns
    the new value of [`next`](#lr.InputStream.next).
    */ advance(n = 1) {
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /**
    @internal
    */ reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = $96e8fc72168067c5$var$nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /**
    @internal
    */ read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        let result = "";
        for (let r of this.ranges){
            if (r.from >= to) break;
            if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
        return result;
    }
}
/**
@internal
*/ class $96e8fc72168067c5$var$TokenGroup {
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
    token(input, stack) {
        let { parser: parser } = stack.p;
        $96e8fc72168067c5$var$readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
}
$96e8fc72168067c5$var$TokenGroup.prototype.contextual = $96e8fc72168067c5$var$TokenGroup.prototype.fallback = $96e8fc72168067c5$var$TokenGroup.prototype.extend = false;
/**
@hide
*/ class $96e8fc72168067c5$export$dbe55ed82366d5e9 {
    constructor(data, precTable, elseToken){
        this.precTable = precTable;
        this.elseToken = elseToken;
        this.data = typeof data == "string" ? $96e8fc72168067c5$var$decodeArray(data) : data;
    }
    token(input, stack) {
        let start = input.pos, skipped = 0;
        for(;;){
            let atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
            $96e8fc72168067c5$var$readToken(this.data, input, stack, 0, this.data, this.precTable);
            if (input.token.value > -1) break;
            if (this.elseToken == null) return;
            if (!atEof) skipped++;
            if (nextPos == null) break;
            input.reset(nextPos, input.token);
        }
        if (skipped) {
            input.reset(start, input.token);
            input.acceptToken(this.elseToken, skipped);
        }
    }
}
$96e8fc72168067c5$export$dbe55ed82366d5e9.prototype.contextual = $96e8fc72168067c5$var$TokenGroup.prototype.fallback = $96e8fc72168067c5$var$TokenGroup.prototype.extend = false;
/**
`@external tokens` declarations in the grammar should resolve to
an instance of this class.
*/ class $96e8fc72168067c5$export$6e56a42e94c6b2cb {
    /**
    Create a tokenizer. The first argument is the function that,
    given an input stream, scans for the types of tokens it
    recognizes at the stream's position, and calls
    [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    one.
    */ constructor(/**
    @internal
    */ token, options = {}){
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.
function $96e8fc72168067c5$var$readToken(data, input, stack, group, precTable, precOffset) {
    let state = 0, groupMask = 1 << group, { dialect: dialect } = stack.p.parser;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        let accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(let i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            let term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || $96e8fc72168067c5$var$overrides(term, input.token.value, precTable, precOffset))) {
                input.acceptToken(term);
                break;
            }
        }
        let next = input.next, low = 0, high = data[state + 2];
        // Special case for EOF
        if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 /* Seq.End */ ) {
            state = data[accEnd + high * 3 - 1];
            continue scan;
        }
        // Do a binary search on the state's edges
        for(; low < high;){
            let mid = low + high >> 1;
            let index = accEnd + mid + (mid << 1);
            let from = data[index], to = data[index + 1] || 0x10000;
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
function $96e8fc72168067c5$var$findOffset(data, start, term) {
    for(let i = start, next; (next = data[i]) != 65535 /* Seq.End */ ; i++)if (next == term) return i - start;
    return -1;
}
function $96e8fc72168067c5$var$overrides(token, prev, tableData, tableOffset) {
    let iPrev = $96e8fc72168067c5$var$findOffset(tableData, tableOffset, prev);
    return iPrev < 0 || $96e8fc72168067c5$var$findOffset(tableData, tableOffset, token) < iPrev;
}
// Environment variable used to control console output
const $96e8fc72168067c5$var$verbose = typeof $cfae44f0dfdf62c0$exports != "undefined" && $cfae44f0dfdf62c0$exports.env && /\bparse\b/.test(undefined);
let $96e8fc72168067c5$var$stackIDs = null;
function $96e8fc72168067c5$var$cutAt(tree, pos, side) {
    let cursor = tree.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Lookahead.Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Lookahead.Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class $96e8fc72168067c5$var$FragmentCursor {
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
    nextFragment() {
        let fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? $96e8fc72168067c5$var$cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? $96e8fc72168067c5$var$cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            let last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            let top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            let next = top.children[index];
            let start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    let end = start + next.length;
                    if (end <= this.safeTo) {
                        let lookAhead = next.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
}
class $96e8fc72168067c5$var$TokenCache {
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new $96e8fc72168067c5$var$CachedToken);
    }
    getActions(stack) {
        let actionIndex = 0;
        let main = null;
        let { parser: parser } = stack.p, { tokenizers: tokenizers } = parser;
        let mask = parser.stateSlot(stack.state, 3 /* ParseState.TokenizerMask */ );
        let context = stack.curContext ? stack.curContext.hash : 0;
        let lookAhead = 0;
        for(let i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            let tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Lookahead.Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Term.Err */ ) {
                let startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new $96e8fc72168067c5$var$CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        let main = new $96e8fc72168067c5$var$CachedToken, { pos: pos, p: p } = stack;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Term.Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        let start = this.stream.clipPos(stack.pos);
        tokenizer.token(this.stream.reset(start, token), stack);
        if (token.value > -1) {
            let { parser: parser } = stack.p;
            for(let i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                let result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize.Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Term.Err */ ;
            token.end = this.stream.clipPos(start + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(let i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        let { state: state } = stack, { parser: parser } = stack.p, { data: data } = parser;
        for(let set = 0; set < 2; set++)for(let i = parser.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ );; i += 3){
            if (data[i] == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Seq.Other */ ) index = this.putAction($96e8fc72168067c5$var$pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction($96e8fc72168067c5$var$pair(data, i + 1), token, end, index);
        }
        return index;
    }
}
class $96e8fc72168067c5$var$Parse {
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.lastBigReductionStart = -1;
        this.lastBigReductionSize = 0;
        this.bigReductionCount = 0;
        this.stream = new $96e8fc72168067c5$export$f22294a9362415e4(input, ranges);
        this.tokens = new $96e8fc72168067c5$var$TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        let { from: from } = ranges[0];
        this.stacks = [
            $96e8fc72168067c5$export$694e0d28c7ffc90c.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new $96e8fc72168067c5$var$FragmentCursor(fragments, parser.nodeSet) : null;
    }
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        let stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        let newStacks = this.stacks = [];
        let stopped, stoppedTokens;
        // If a large amount of reductions happened with the same start
        // position, force the stack out of that production in order to
        // avoid creating a tree too deep to recurse through.
        // (This is an ugly kludge, because unfortunately there is no
        // straightforward, cheap way to check for this happening, due to
        // the history of reductions only being available in an
        // expensive-to-access format in the stack buffers.)
        if (this.bigReductionCount > 300 /* Rec.MaxLeftAssociativeReductionCount */  && stacks.length == 1) {
            let [s] = stacks;
            while(s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart);
            this.bigReductionCount = this.lastBigReductionSize = 0;
        }
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    let tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            let finished = stopped && $96e8fc72168067c5$var$findFinished(stopped);
            if (finished) {
                if ($96e8fc72168067c5$var$verbose) console.log("Finish with " + this.stackID(finished));
                return this.stackToTree(finished);
            }
            if (this.parser.strict) {
                if ($96e8fc72168067c5$var$verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Rec.Distance */ ;
        }
        if (this.recovering && stopped) {
            let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished) {
                if ($96e8fc72168067c5$var$verbose) console.log("Force-finish " + this.stackID(finished));
                return this.stackToTree(finished.forceAll());
            }
        }
        if (this.recovering) {
            let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* Rec.MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) {
            // Prune stacks that are in the same state, or that have been
            // running without splitting for a while, to avoid getting stuck
            // with multiple successful stacks running endlessly on.
            outer: for(let i = 0; i < newStacks.length - 1; i++){
                let stack = newStacks[i];
                for(let j = i + 1; j < newStacks.length; j++){
                    let other = newStacks[j];
                    if (stack.sameState(other) || stack.buffer.length > 500 /* Rec.MinBufferLengthPrune */  && other.buffer.length > 500 /* Rec.MinBufferLengthPrune */ ) {
                        if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                        else {
                            newStacks.splice(i--, 1);
                            continue outer;
                        }
                    }
                }
            }
            if (newStacks.length > 12 /* Rec.MaxStackCount */ ) newStacks.splice(12 /* Rec.MaxStackCount */ , newStacks.length - 12 /* Rec.MaxStackCount */ );
        }
        this.minStackPos = newStacks[0].pos;
        for(let i = 1; i < newStacks.length; i++)if (newStacks[i].pos < this.minStackPos) this.minStackPos = newStacks[i].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        let start = stack.pos, { parser: parser } = this;
        let base = $96e8fc72168067c5$var$verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(let cached = this.fragments.nodeAt(start); cached;){
                let match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, $ed739beecf769914$export$b8034b9bc18acd90).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                let inner = cached.children[0];
                if (inner instanceof (0, $ed739beecf769914$export$7fbedc92909ed28e) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        let defaultReduce = parser.stateSlot(stack.state, 4 /* ParseState.DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* Action.ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 8400 /* Rec.CutDepth */ ) {
            while(stack.stack.length > 6000 /* Rec.CutTo */  && stack.forceReduce());
        }
        let actions = this.tokens.getActions(stack);
        for(let i = 0; i < actions.length;){
            let action = actions[i++], term = actions[i++], end = actions[i++];
            let last = i == actions.length || !split;
            let localStack = last ? stack : stack.split();
            let main = this.tokens.mainToken;
            localStack.apply(action, term, main ? main.start : localStack.pos, end);
            if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* Action.ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* Action.ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        let pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                $96e8fc72168067c5$var$pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        let finished = null, restarted = false;
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            let base = $96e8fc72168067c5$var$verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + " (restarted)");
                let done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            let force = stack.split(), forceBase = base;
            for(let j = 0; force.forceReduce() && j < 10 /* Rec.ForceReduceLimit */ ; j++){
                if ($96e8fc72168067c5$var$verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                let done = this.advanceFully(force, newStacks);
                if (done) break;
                if ($96e8fc72168067c5$var$verbose) forceBase = this.stackID(force) + " -> ";
            }
            for (let insert of stack.recoverByInsert(token)){
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                this.advanceFully(insert, newStacks);
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Term.Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if ($96e8fc72168067c5$var$verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                $96e8fc72168067c5$var$pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, $ed739beecf769914$export$7fbedc92909ed28e).build({
            buffer: $96e8fc72168067c5$var$StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        let id = ($96e8fc72168067c5$var$stackIDs || ($96e8fc72168067c5$var$stackIDs = new WeakMap)).get(stack);
        if (!id) $96e8fc72168067c5$var$stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
}
function $96e8fc72168067c5$var$pushStackDedup(stack, newStacks) {
    for(let i = 0; i < newStacks.length; i++){
        let other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class $96e8fc72168067c5$var$Dialect {
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
}
const $96e8fc72168067c5$var$id = (x)=>x;
/**
Context trackers are used to track stateful context (such as
indentation in the Python grammar, or parent elements in the XML
grammar) needed by external tokenizers. You declare them in a
grammar file as `@context exportName from "module"`.

Context values should be immutable, and can be updated (replaced)
on shift or reduce actions.

The export used in a `@context` declaration should be of this
type.
*/ class $96e8fc72168067c5$export$88193367295cc46b {
    /**
    Define a context tracker.
    */ constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || $96e8fc72168067c5$var$id;
        this.reduce = spec.reduce || $96e8fc72168067c5$var$id;
        this.reuse = spec.reuse || $96e8fc72168067c5$var$id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/**
Holds the parse tables for a given grammar, as generated by
`lezer-generator`, and provides [methods](#common.Parser) to parse
content with.
*/ class $96e8fc72168067c5$export$60c033f4cf02b410 extends (0, $ed739beecf769914$export$7acfa6ed01010e37) {
    /**
    @internal
    */ constructor(spec){
        super();
        /**
        @internal
        */ this.wrappers = [];
        if (spec.version != 14 /* File.Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* File.Version */ })`);
        let nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(let i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        let topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        let nodeProps = [];
        for(let i = 0; i < nodeNames.length; i++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        if (spec.nodeProps) for (let propSpec of spec.nodeProps){
            let prop = propSpec[0];
            if (typeof prop == "string") prop = (0, $ed739beecf769914$export$b8034b9bc18acd90)[prop];
            for(let i = 1; i < propSpec.length;){
                let next = propSpec[i++];
                if (next >= 0) setProp(next, prop, propSpec[i++]);
                else {
                    let value = propSpec[i + -next];
                    for(let j = -next; j > 0; j--)setProp(propSpec[i++], prop, value);
                    i++;
                }
            }
        }
        this.nodeSet = new (0, $ed739beecf769914$export$7fad5fb00d8de02c)(nodeNames.map((name, i)=>(0, $ed739beecf769914$export$f06e977173f1857c).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, $ed739beecf769914$export$de305a849879ffa);
        let tokenArray = $96e8fc72168067c5$var$decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specializerSpecs = spec.specialized || [];
        this.specialized = new Uint16Array(this.specializerSpecs.length);
        for(let i = 0; i < this.specializerSpecs.length; i++)this.specialized[i] = this.specializerSpecs[i].term;
        this.specializers = this.specializerSpecs.map($96e8fc72168067c5$var$getSpecializer);
        this.states = $96e8fc72168067c5$var$decodeArray(spec.states, Uint32Array);
        this.data = $96e8fc72168067c5$var$decodeArray(spec.stateData);
        this.goto = $96e8fc72168067c5$var$decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new $96e8fc72168067c5$var$TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
    createParse(input, fragments, ranges) {
        let parse = new $96e8fc72168067c5$var$Parse(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /**
    Get a goto table entry @internal
    */ getGoto(state, term, loose = false) {
        let table = this.goto;
        if (term >= table[0]) return -1;
        for(let pos = table[term + 1];;){
            let groupTag = table[pos++], last = groupTag & 1;
            let target = table[pos++];
            if (last && loose) return target;
            for(let end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /**
    Check if this state has an action for a given terminal @internal
    */ hasAction(state, terminal) {
        let data = this.data;
        for(let set = 0; set < 2; set++)for(let i = this.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ ), next;; i += 3){
            if ((next = data[i]) == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) next = data[i = $96e8fc72168067c5$var$pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Seq.Other */ ) return $96e8fc72168067c5$var$pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Term.Err */ ) return $96e8fc72168067c5$var$pair(data, i + 1);
        }
        return 0;
    }
    /**
    @internal
    */ stateSlot(state, slot) {
        return this.states[state * 6 /* ParseState.Size */  + slot];
    }
    /**
    @internal
    */ stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* ParseState.Flags */ ) & flag) > 0;
    }
    /**
    @internal
    */ validAction(state, action) {
        return !!this.allActions(state, (a)=>a == action ? true : null);
    }
    /**
    @internal
    */ allActions(state, action) {
        let deflt = this.stateSlot(state, 4 /* ParseState.DefaultReduce */ );
        let result = deflt ? action(deflt) : undefined;
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ ); result == null; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(this.data, i + 2);
                else break;
            }
            result = action($96e8fc72168067c5$var$pair(this.data, i + 1));
        }
        return result;
    }
    /**
    Get the states that can follow this one through shift actions or
    goto jumps. @internal
    */ nextStates(state) {
        let result = [];
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ );; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $96e8fc72168067c5$var$pair(this.data, i + 2);
                else break;
            }
            if ((this.data[i + 2] & 1) == 0) {
                let value = this.data[i + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(this.data[i], value);
            }
        }
        return result;
    }
    /**
    Configure the parser. Returns a new parser instance that has the
    given settings modified. Settings not provided in `config` are
    kept from the original parser.
    */ configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        let copy = Object.assign(Object.create($96e8fc72168067c5$export$60c033f4cf02b410.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            let info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            let found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.specializers) {
            copy.specializers = this.specializers.slice();
            copy.specializerSpecs = this.specializerSpecs.map((s, i)=>{
                let found = config.specializers.find((r)=>r.from == s.external);
                if (!found) return s;
                let spec = Object.assign(Object.assign({}, s), {
                    external: found.to
                });
                copy.specializers[i] = $96e8fc72168067c5$var$getSpecializer(spec);
                return spec;
            });
        }
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /**
    Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    are registered for this parser.
    */ hasWrappers() {
        return this.wrappers.length > 0;
    }
    /**
    Returns the name associated with a given term. This will only
    work for all terms when the parser was generated with the
    `--names` option. By default, only the names of tagged terms are
    stored.
    */ getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /**
    The eof term id is always allocated directly after the node
    types. @internal
    */ get eofTerm() {
        return this.maxNode + 1;
    }
    /**
    The type of top node produced by the parser.
    */ get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /**
    @internal
    */ dynamicPrecedence(term) {
        let prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /**
    @internal
    */ parseDialect(dialect) {
        let values = Object.keys(this.dialects), flags = values.map(()=>false);
        if (dialect) for (let part of dialect.split(" ")){
            let id = values.indexOf(part);
            if (id >= 0) flags[id] = true;
        }
        let disabled = null;
        for(let i = 0; i < values.length; i++)if (!flags[i]) for(let j = this.dialects[values[i]], id; (id = this.data[j++]) != 65535 /* Seq.End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id] = 1;
        return new $96e8fc72168067c5$var$Dialect(dialect, flags, disabled);
    }
    /**
    Used by the output of the parser generator. Not available to
    user code. @hide
    */ static deserialize(spec) {
        return new $96e8fc72168067c5$export$60c033f4cf02b410(spec);
    }
}
function $96e8fc72168067c5$var$pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function $96e8fc72168067c5$var$findFinished(stacks) {
    let best = null;
    for (let stack of stacks){
        let stopped = stack.p.stoppedAt;
        if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* StateFlag.Accepting */ ) && (!best || best.score < stack.score)) best = stack;
    }
    return best;
}
function $96e8fc72168067c5$var$getSpecializer(spec) {
    if (spec.external) {
        let mask = spec.extend ? 1 /* Specialize.Extend */  : 0 /* Specialize.Specialize */ ;
        return (value, stack)=>spec.external(value, stack) << 1 | mask;
    }
    return spec.get;
}



// This file was generated by lezer-generator. You probably shouldn't edit it.
const $2bb9cf00b6309d75$var$printKeyword = 1, $2bb9cf00b6309d75$var$indent = 194, $2bb9cf00b6309d75$var$dedent = 195, $2bb9cf00b6309d75$var$newline$1 = 196, $2bb9cf00b6309d75$var$blankLineStart = 197, $2bb9cf00b6309d75$var$newlineBracketed = 198, $2bb9cf00b6309d75$var$eof = 199, $2bb9cf00b6309d75$var$stringContent = 200, $2bb9cf00b6309d75$var$Escape = 2, $2bb9cf00b6309d75$var$replacementStart = 3, $2bb9cf00b6309d75$var$stringEnd = 201, $2bb9cf00b6309d75$var$ParenL = 24, $2bb9cf00b6309d75$var$ParenthesizedExpression = 25, $2bb9cf00b6309d75$var$TupleExpression = 49, $2bb9cf00b6309d75$var$ComprehensionExpression = 50, $2bb9cf00b6309d75$var$BracketL = 55, $2bb9cf00b6309d75$var$ArrayExpression = 56, $2bb9cf00b6309d75$var$ArrayComprehensionExpression = 57, $2bb9cf00b6309d75$var$BraceL = 59, $2bb9cf00b6309d75$var$DictionaryExpression = 60, $2bb9cf00b6309d75$var$DictionaryComprehensionExpression = 61, $2bb9cf00b6309d75$var$SetExpression = 62, $2bb9cf00b6309d75$var$SetComprehensionExpression = 63, $2bb9cf00b6309d75$var$ArgList = 65, $2bb9cf00b6309d75$var$subscript = 238, $2bb9cf00b6309d75$var$String$1 = 71, $2bb9cf00b6309d75$var$stringStart = 241, $2bb9cf00b6309d75$var$stringStartD = 242, $2bb9cf00b6309d75$var$stringStartL = 243, $2bb9cf00b6309d75$var$stringStartLD = 244, $2bb9cf00b6309d75$var$stringStartR = 245, $2bb9cf00b6309d75$var$stringStartRD = 246, $2bb9cf00b6309d75$var$stringStartRL = 247, $2bb9cf00b6309d75$var$stringStartRLD = 248, $2bb9cf00b6309d75$var$FormatString = 72, $2bb9cf00b6309d75$var$stringStartF = 249, $2bb9cf00b6309d75$var$stringStartFD = 250, $2bb9cf00b6309d75$var$stringStartFL = 251, $2bb9cf00b6309d75$var$stringStartFLD = 252, $2bb9cf00b6309d75$var$stringStartFR = 253, $2bb9cf00b6309d75$var$stringStartFRD = 254, $2bb9cf00b6309d75$var$stringStartFRL = 255, $2bb9cf00b6309d75$var$stringStartFRLD = 256, $2bb9cf00b6309d75$var$FormatReplacement = 73, $2bb9cf00b6309d75$var$nestedFormatReplacement = 77, $2bb9cf00b6309d75$var$importList = 263, $2bb9cf00b6309d75$var$TypeParamList = 112, $2bb9cf00b6309d75$var$ParamList = 130, $2bb9cf00b6309d75$var$SequencePattern = 151, $2bb9cf00b6309d75$var$MappingPattern = 152, $2bb9cf00b6309d75$var$PatternArgList = 155;
const $2bb9cf00b6309d75$var$newline = 10, $2bb9cf00b6309d75$var$carriageReturn = 13, $2bb9cf00b6309d75$var$space = 32, $2bb9cf00b6309d75$var$tab = 9, $2bb9cf00b6309d75$var$hash = 35, $2bb9cf00b6309d75$var$parenOpen = 40, $2bb9cf00b6309d75$var$dot = 46, $2bb9cf00b6309d75$var$braceOpen = 123, $2bb9cf00b6309d75$var$braceClose = 125, $2bb9cf00b6309d75$var$singleQuote = 39, $2bb9cf00b6309d75$var$doubleQuote = 34, $2bb9cf00b6309d75$var$backslash = 92, $2bb9cf00b6309d75$var$letter_o = 111, $2bb9cf00b6309d75$var$letter_x = 120, $2bb9cf00b6309d75$var$letter_N = 78, $2bb9cf00b6309d75$var$letter_u = 117, $2bb9cf00b6309d75$var$letter_U = 85;
const $2bb9cf00b6309d75$var$bracketed = new Set([
    $2bb9cf00b6309d75$var$ParenthesizedExpression,
    $2bb9cf00b6309d75$var$TupleExpression,
    $2bb9cf00b6309d75$var$ComprehensionExpression,
    $2bb9cf00b6309d75$var$importList,
    $2bb9cf00b6309d75$var$ArgList,
    $2bb9cf00b6309d75$var$ParamList,
    $2bb9cf00b6309d75$var$ArrayExpression,
    $2bb9cf00b6309d75$var$ArrayComprehensionExpression,
    $2bb9cf00b6309d75$var$subscript,
    $2bb9cf00b6309d75$var$SetExpression,
    $2bb9cf00b6309d75$var$SetComprehensionExpression,
    $2bb9cf00b6309d75$var$FormatString,
    $2bb9cf00b6309d75$var$FormatReplacement,
    $2bb9cf00b6309d75$var$nestedFormatReplacement,
    $2bb9cf00b6309d75$var$DictionaryExpression,
    $2bb9cf00b6309d75$var$DictionaryComprehensionExpression,
    $2bb9cf00b6309d75$var$SequencePattern,
    $2bb9cf00b6309d75$var$MappingPattern,
    $2bb9cf00b6309d75$var$PatternArgList,
    $2bb9cf00b6309d75$var$TypeParamList
]);
function $2bb9cf00b6309d75$var$isLineBreak(ch) {
    return ch == $2bb9cf00b6309d75$var$newline || ch == $2bb9cf00b6309d75$var$carriageReturn;
}
function $2bb9cf00b6309d75$var$isHex(ch) {
    return ch >= 48 && ch <= 57 || ch >= 65 && ch <= 70 || ch >= 97 && ch <= 102;
}
const $2bb9cf00b6309d75$var$newlines = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let prev;
    if (input.next < 0) input.acceptToken($2bb9cf00b6309d75$var$eof);
    else if (stack.context.flags & $2bb9cf00b6309d75$var$cx_Bracketed) {
        if ($2bb9cf00b6309d75$var$isLineBreak(input.next)) input.acceptToken($2bb9cf00b6309d75$var$newlineBracketed, 1);
    } else if (((prev = input.peek(-1)) < 0 || $2bb9cf00b6309d75$var$isLineBreak(prev)) && stack.canShift($2bb9cf00b6309d75$var$blankLineStart)) {
        let spaces = 0;
        while(input.next == $2bb9cf00b6309d75$var$space || input.next == $2bb9cf00b6309d75$var$tab){
            input.advance();
            spaces++;
        }
        if (input.next == $2bb9cf00b6309d75$var$newline || input.next == $2bb9cf00b6309d75$var$carriageReturn || input.next == $2bb9cf00b6309d75$var$hash) input.acceptToken($2bb9cf00b6309d75$var$blankLineStart, -spaces);
    } else if ($2bb9cf00b6309d75$var$isLineBreak(input.next)) input.acceptToken($2bb9cf00b6309d75$var$newline$1, 1);
}, {
    contextual: true
});
const $2bb9cf00b6309d75$var$indentation = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let context = stack.context;
    if (context.flags) return;
    let prev = input.peek(-1);
    if (prev == $2bb9cf00b6309d75$var$newline || prev == $2bb9cf00b6309d75$var$carriageReturn) {
        let depth = 0, chars = 0;
        for(;;){
            if (input.next == $2bb9cf00b6309d75$var$space) depth++;
            else if (input.next == $2bb9cf00b6309d75$var$tab) depth += 8 - depth % 8;
            else break;
            input.advance();
            chars++;
        }
        if (depth != context.indent && input.next != $2bb9cf00b6309d75$var$newline && input.next != $2bb9cf00b6309d75$var$carriageReturn && input.next != $2bb9cf00b6309d75$var$hash) {
            if (depth < context.indent) input.acceptToken($2bb9cf00b6309d75$var$dedent, -chars);
            else input.acceptToken($2bb9cf00b6309d75$var$indent);
        }
    }
});
// Flags used in Context objects
const $2bb9cf00b6309d75$var$cx_Bracketed = 1, $2bb9cf00b6309d75$var$cx_String = 2, $2bb9cf00b6309d75$var$cx_DoubleQuote = 4, $2bb9cf00b6309d75$var$cx_Long = 8, $2bb9cf00b6309d75$var$cx_Raw = 16, $2bb9cf00b6309d75$var$cx_Format = 32;
function $2bb9cf00b6309d75$var$Context(parent, indent, flags) {
    this.parent = parent;
    this.indent = indent;
    this.flags = flags;
    this.hash = (parent ? parent.hash + parent.hash << 8 : 0) + indent + (indent << 4) + flags + (flags << 6);
}
const $2bb9cf00b6309d75$var$topIndent = new $2bb9cf00b6309d75$var$Context(null, 0, 0);
function $2bb9cf00b6309d75$var$countIndent(space) {
    let depth = 0;
    for(let i = 0; i < space.length; i++)depth += space.charCodeAt(i) == $2bb9cf00b6309d75$var$tab ? 8 - depth % 8 : 1;
    return depth;
}
const $2bb9cf00b6309d75$var$stringFlags = new Map([
    [
        $2bb9cf00b6309d75$var$stringStart,
        0
    ],
    [
        $2bb9cf00b6309d75$var$stringStartD,
        $2bb9cf00b6309d75$var$cx_DoubleQuote
    ],
    [
        $2bb9cf00b6309d75$var$stringStartL,
        $2bb9cf00b6309d75$var$cx_Long
    ],
    [
        $2bb9cf00b6309d75$var$stringStartLD,
        $2bb9cf00b6309d75$var$cx_Long | $2bb9cf00b6309d75$var$cx_DoubleQuote
    ],
    [
        $2bb9cf00b6309d75$var$stringStartR,
        $2bb9cf00b6309d75$var$cx_Raw
    ],
    [
        $2bb9cf00b6309d75$var$stringStartRD,
        $2bb9cf00b6309d75$var$cx_Raw | $2bb9cf00b6309d75$var$cx_DoubleQuote
    ],
    [
        $2bb9cf00b6309d75$var$stringStartRL,
        $2bb9cf00b6309d75$var$cx_Raw | $2bb9cf00b6309d75$var$cx_Long
    ],
    [
        $2bb9cf00b6309d75$var$stringStartRLD,
        $2bb9cf00b6309d75$var$cx_Raw | $2bb9cf00b6309d75$var$cx_Long | $2bb9cf00b6309d75$var$cx_DoubleQuote
    ],
    [
        $2bb9cf00b6309d75$var$stringStartF,
        $2bb9cf00b6309d75$var$cx_Format
    ],
    [
        $2bb9cf00b6309d75$var$stringStartFD,
        $2bb9cf00b6309d75$var$cx_Format | $2bb9cf00b6309d75$var$cx_DoubleQuote
    ],
    [
        $2bb9cf00b6309d75$var$stringStartFL,
        $2bb9cf00b6309d75$var$cx_Format | $2bb9cf00b6309d75$var$cx_Long
    ],
    [
        $2bb9cf00b6309d75$var$stringStartFLD,
        $2bb9cf00b6309d75$var$cx_Format | $2bb9cf00b6309d75$var$cx_Long | $2bb9cf00b6309d75$var$cx_DoubleQuote
    ],
    [
        $2bb9cf00b6309d75$var$stringStartFR,
        $2bb9cf00b6309d75$var$cx_Format | $2bb9cf00b6309d75$var$cx_Raw
    ],
    [
        $2bb9cf00b6309d75$var$stringStartFRD,
        $2bb9cf00b6309d75$var$cx_Format | $2bb9cf00b6309d75$var$cx_Raw | $2bb9cf00b6309d75$var$cx_DoubleQuote
    ],
    [
        $2bb9cf00b6309d75$var$stringStartFRL,
        $2bb9cf00b6309d75$var$cx_Format | $2bb9cf00b6309d75$var$cx_Raw | $2bb9cf00b6309d75$var$cx_Long
    ],
    [
        $2bb9cf00b6309d75$var$stringStartFRLD,
        $2bb9cf00b6309d75$var$cx_Format | $2bb9cf00b6309d75$var$cx_Raw | $2bb9cf00b6309d75$var$cx_Long | $2bb9cf00b6309d75$var$cx_DoubleQuote
    ]
].map(([term, flags])=>[
        term,
        flags | $2bb9cf00b6309d75$var$cx_String
    ]));
const $2bb9cf00b6309d75$var$trackIndent = new (0, $96e8fc72168067c5$export$88193367295cc46b)({
    start: $2bb9cf00b6309d75$var$topIndent,
    reduce (context, term, _, input) {
        if (context.flags & $2bb9cf00b6309d75$var$cx_Bracketed && $2bb9cf00b6309d75$var$bracketed.has(term) || (term == $2bb9cf00b6309d75$var$String$1 || term == $2bb9cf00b6309d75$var$FormatString) && context.flags & $2bb9cf00b6309d75$var$cx_String) return context.parent;
        return context;
    },
    shift (context, term, stack, input) {
        if (term == $2bb9cf00b6309d75$var$indent) return new $2bb9cf00b6309d75$var$Context(context, $2bb9cf00b6309d75$var$countIndent(input.read(input.pos, stack.pos)), 0);
        if (term == $2bb9cf00b6309d75$var$dedent) return context.parent;
        if (term == $2bb9cf00b6309d75$var$ParenL || term == $2bb9cf00b6309d75$var$BracketL || term == $2bb9cf00b6309d75$var$BraceL || term == $2bb9cf00b6309d75$var$replacementStart) return new $2bb9cf00b6309d75$var$Context(context, 0, $2bb9cf00b6309d75$var$cx_Bracketed);
        if ($2bb9cf00b6309d75$var$stringFlags.has(term)) return new $2bb9cf00b6309d75$var$Context(context, 0, $2bb9cf00b6309d75$var$stringFlags.get(term) | context.flags & $2bb9cf00b6309d75$var$cx_Bracketed);
        return context;
    },
    hash (context) {
        return context.hash;
    }
});
const $2bb9cf00b6309d75$var$legacyPrint = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input)=>{
    for(let i = 0; i < 5; i++){
        if (input.next != "print".charCodeAt(i)) return;
        input.advance();
    }
    if (/\w/.test(String.fromCharCode(input.next))) return;
    for(let off = 0;; off++){
        let next = input.peek(off);
        if (next == $2bb9cf00b6309d75$var$space || next == $2bb9cf00b6309d75$var$tab) continue;
        if (next != $2bb9cf00b6309d75$var$parenOpen && next != $2bb9cf00b6309d75$var$dot && next != $2bb9cf00b6309d75$var$newline && next != $2bb9cf00b6309d75$var$carriageReturn && next != $2bb9cf00b6309d75$var$hash) input.acceptToken($2bb9cf00b6309d75$var$printKeyword);
        return;
    }
});
const $2bb9cf00b6309d75$var$strings = new (0, $96e8fc72168067c5$export$6e56a42e94c6b2cb)((input, stack)=>{
    let { flags: flags } = stack.context;
    let quote = flags & $2bb9cf00b6309d75$var$cx_DoubleQuote ? $2bb9cf00b6309d75$var$doubleQuote : $2bb9cf00b6309d75$var$singleQuote;
    let long = (flags & $2bb9cf00b6309d75$var$cx_Long) > 0;
    let escapes = !(flags & $2bb9cf00b6309d75$var$cx_Raw);
    let format = (flags & $2bb9cf00b6309d75$var$cx_Format) > 0;
    let start = input.pos;
    for(;;){
        if (input.next < 0) break;
        else if (format && input.next == $2bb9cf00b6309d75$var$braceOpen) {
            if (input.peek(1) == $2bb9cf00b6309d75$var$braceOpen) input.advance(2);
            else {
                if (input.pos == start) {
                    input.acceptToken($2bb9cf00b6309d75$var$replacementStart, 1);
                    return;
                }
                break;
            }
        } else if (escapes && input.next == $2bb9cf00b6309d75$var$backslash) {
            if (input.pos == start) {
                input.advance();
                let escaped = input.next;
                if (escaped >= 0) {
                    input.advance();
                    $2bb9cf00b6309d75$var$skipEscape(input, escaped);
                }
                input.acceptToken($2bb9cf00b6309d75$var$Escape);
                return;
            }
            break;
        } else if (input.next == quote && (!long || input.peek(1) == quote && input.peek(2) == quote)) {
            if (input.pos == start) {
                input.acceptToken($2bb9cf00b6309d75$var$stringEnd, long ? 3 : 1);
                return;
            }
            break;
        } else if (input.next == $2bb9cf00b6309d75$var$newline) {
            if (long) input.advance();
            else if (input.pos == start) {
                input.acceptToken($2bb9cf00b6309d75$var$stringEnd);
                return;
            }
            break;
        } else input.advance();
    }
    if (input.pos > start) input.acceptToken($2bb9cf00b6309d75$var$stringContent);
});
function $2bb9cf00b6309d75$var$skipEscape(input, ch) {
    if (ch == $2bb9cf00b6309d75$var$letter_o) for(let i = 0; i < 2 && input.next >= 48 && input.next <= 55; i++)input.advance();
    else if (ch == $2bb9cf00b6309d75$var$letter_x) for(let i = 0; i < 2 && $2bb9cf00b6309d75$var$isHex(input.next); i++)input.advance();
    else if (ch == $2bb9cf00b6309d75$var$letter_u) for(let i = 0; i < 4 && $2bb9cf00b6309d75$var$isHex(input.next); i++)input.advance();
    else if (ch == $2bb9cf00b6309d75$var$letter_U) for(let i = 0; i < 8 && $2bb9cf00b6309d75$var$isHex(input.next); i++)input.advance();
    else if (ch == $2bb9cf00b6309d75$var$letter_N) {
        if (input.next == $2bb9cf00b6309d75$var$braceOpen) {
            input.advance();
            while(input.next >= 0 && input.next != $2bb9cf00b6309d75$var$braceClose && input.next != $2bb9cf00b6309d75$var$singleQuote && input.next != $2bb9cf00b6309d75$var$doubleQuote && input.next != $2bb9cf00b6309d75$var$newline)input.advance();
            if (input.next == $2bb9cf00b6309d75$var$braceClose) input.advance();
        }
    }
}
const $2bb9cf00b6309d75$var$pythonHighlighting = (0, $a1ec9d683d365521$export$c537e79bb7b94295)({
    'async "*" "**" FormatConversion FormatSpec': (0, $a1ec9d683d365521$export$8b7a896ae75accbf).modifier,
    "for while if elif else try except finally return raise break continue with pass assert await yield match case": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).controlKeyword,
    "in not and or is del": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).operatorKeyword,
    "from def class global nonlocal lambda": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionKeyword,
    import: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).moduleKeyword,
    "with as print": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).keyword,
    Boolean: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bool,
    None: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).null,
    VariableName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName,
    "CallExpression/VariableName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName),
    "FunctionDefinition/VariableName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).variableName)),
    "ClassDefinition/VariableName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definition((0, $a1ec9d683d365521$export$8b7a896ae75accbf).className),
    PropertyName: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName,
    "CallExpression/MemberExpression/PropertyName": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).function((0, $a1ec9d683d365521$export$8b7a896ae75accbf).propertyName),
    Comment: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).lineComment,
    Number: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).number,
    String: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).string,
    FormatString: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).special((0, $a1ec9d683d365521$export$8b7a896ae75accbf).string),
    Escape: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).escape,
    UpdateOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).updateOperator,
    "ArithOp!": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).arithmeticOperator,
    BitOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).bitwiseOperator,
    CompareOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).compareOperator,
    AssignOp: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).definitionOperator,
    Ellipsis: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).punctuation,
    At: (0, $a1ec9d683d365521$export$8b7a896ae75accbf).meta,
    "( )": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).paren,
    "[ ]": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).squareBracket,
    "{ }": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).brace,
    ".": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).derefOperator,
    ", ;": (0, $a1ec9d683d365521$export$8b7a896ae75accbf).separator
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $2bb9cf00b6309d75$var$spec_identifier = {
    __proto__: null,
    await: 44,
    or: 54,
    and: 56,
    in: 60,
    not: 62,
    is: 64,
    if: 70,
    else: 72,
    lambda: 76,
    yield: 94,
    from: 96,
    async: 102,
    for: 104,
    None: 162,
    True: 164,
    False: 164,
    del: 178,
    pass: 182,
    break: 186,
    continue: 190,
    return: 194,
    raise: 202,
    import: 206,
    as: 208,
    global: 212,
    nonlocal: 214,
    assert: 218,
    type: 223,
    elif: 236,
    while: 240,
    try: 246,
    except: 248,
    finally: 250,
    with: 254,
    def: 258,
    class: 268,
    match: 279,
    case: 285
};
const $2bb9cf00b6309d75$export$8f49e4af10703ce3 = (0, $96e8fc72168067c5$export$60c033f4cf02b410).deserialize({
    version: 14,
    states: "##jO`QeOOP$}OSOOO&WQtO'#HUOOQS'#Co'#CoOOQS'#Cp'#CpO'vQdO'#CnO*UQtO'#HTOOQS'#HU'#HUOOQS'#DU'#DUOOQS'#HT'#HTO*rQdO'#D_O+VQdO'#DfO+gQdO'#DjO+zOWO'#DuO,VOWO'#DvO.[QtO'#GuOOQS'#Gu'#GuO'vQdO'#GtO0ZQtO'#GtOOQS'#Eb'#EbO0rQdO'#EcOOQS'#Gs'#GsO0|QdO'#GrOOQV'#Gr'#GrO1XQdO'#FYOOQS'#G^'#G^O1^QdO'#FXOOQV'#IS'#ISOOQV'#Gq'#GqOOQV'#Fq'#FqQ`QeOOO'vQdO'#CqO1lQdO'#C}O1sQdO'#DRO2RQdO'#HYO2cQtO'#EVO'vQdO'#EWOOQS'#EY'#EYOOQS'#E['#E[OOQS'#E^'#E^O2wQdO'#E`O3_QdO'#EdO3rQdO'#EfO3zQtO'#EfO1XQdO'#EiO0rQdO'#ElO1XQdO'#EnO0rQdO'#EtO0rQdO'#EwO4VQdO'#EyO4^QdO'#FOO4iQdO'#EzO0rQdO'#FOO1XQdO'#FQO1XQdO'#FVO4nQdO'#F[P4uOdO'#GpPOOO)CBd)CBdOOQS'#Ce'#CeOOQS'#Cf'#CfOOQS'#Cg'#CgOOQS'#Ch'#ChOOQS'#Ci'#CiOOQS'#Cj'#CjOOQS'#Cl'#ClO'vQdO,59OO'vQdO,59OO'vQdO,59OO'vQdO,59OO'vQdO,59OO'vQdO,59OO5QQdO'#DoOOQS,5:Y,5:YO5eQdO'#HdOOQS,5:],5:]O5rQ!fO,5:]O5wQtO,59YO1lQdO,59bO1lQdO,59bO1lQdO,59bO8gQdO,59bO8lQdO,59bO8sQdO,59jO8zQdO'#HTO:QQdO'#HSOOQS'#HS'#HSOOQS'#D['#D[O:iQdO,59aO'vQdO,59aO:wQdO,59aOOQS,59y,59yO:|QdO,5:RO'vQdO,5:ROOQS,5:Q,5:QO;[QdO,5:QO;aQdO,5:XO'vQdO,5:XO'vQdO,5:VOOQS,5:U,5:UO;rQdO,5:UO;wQdO,5:WOOOW'#Fy'#FyO;|OWO,5:aOOQS,5:a,5:aO<XQdO'#HwOOOW'#Dw'#DwOOOW'#Fz'#FzO<iOWO,5:bOOQS,5:b,5:bOOQS'#F}'#F}O<wQtO,5:iO?iQtO,5=`O@SQ#xO,5=`O@sQtO,5=`OOQS,5:},5:}OA[QeO'#GWOBnQdO,5;^OOQV,5=^,5=^OByQtO'#IPOChQdO,5;tOOQS-E:[-E:[OOQV,5;s,5;sO4dQdO'#FQOOQV-E9o-E9oOCpQtO,59]OEwQtO,59iOFbQdO'#HVOFmQdO'#HVO1XQdO'#HVOFxQdO'#DTOGQQdO,59mOGVQdO'#HZO'vQdO'#HZO0rQdO,5=tOOQS,5=t,5=tO0rQdO'#EROOQS'#ES'#ESOGtQdO'#GPOHUQdO,58|OHUQdO,58|O*xQdO,5:oOHdQtO'#H]OOQS,5:r,5:rOOQS,5:z,5:zOHwQdO,5;OOIYQdO'#IOO1XQdO'#H}OOQS,5;Q,5;QOOQS'#GT'#GTOInQtO,5;QOI|QdO,5;QOJRQdO'#IQOOQS,5;T,5;TOJaQdO'#H|OOQS,5;W,5;WOJrQdO,5;YO4iQdO,5;`O4iQdO,5;cOJzQtO'#ITO'vQdO'#ITOKUQdO,5;eO4VQdO,5;eO0rQdO,5;jO1XQdO,5;lOKZQeO'#EuOLgQgO,5;fO!!hQdO'#IUO4iQdO,5;jO!!sQdO,5;lO!!{QdO,5;qO!#WQtO,5;vO'vQdO,5;vPOOO,5=[,5=[P!#_OSO,5=[P!#dOdO,5=[O!&XQtO1G.jO!&`QtO1G.jO!)PQtO1G.jO!)ZQtO1G.jO!+tQtO1G.jO!,XQtO1G.jO!,lQdO'#HcO!,zQtO'#GuO0rQdO'#HcO!-UQdO'#HbOOQS,5:Z,5:ZO!-^QdO,5:ZO!-cQdO'#HeO!-nQdO'#HeO!.RQdO,5>OOOQS'#Ds'#DsOOQS1G/w1G/wOOQS1G.|1G.|O!/RQtO1G.|O!/YQtO1G.|O1lQdO1G.|O!/uQdO1G/UOOQS'#DZ'#DZO0rQdO,59tOOQS1G.{1G.{O!/|QdO1G/eO!0^QdO1G/eO!0fQdO1G/fO'vQdO'#H[O!0kQdO'#H[O!0pQtO1G.{O!1QQdO,59iO!2WQdO,5=zO!2hQdO,5=zO!2pQdO1G/mO!2uQtO1G/mOOQS1G/l1G/lO!3VQdO,5=uO!3|QdO,5=uO0rQdO1G/qO!4kQdO1G/sO!4pQtO1G/sO!5QQtO1G/qOOQS1G/p1G/pOOQS1G/r1G/rOOOW-E9w-E9wOOQS1G/{1G/{O!5bQdO'#HxO0rQdO'#HxO!5sQdO,5>cOOOW-E9x-E9xOOQS1G/|1G/|OOQS-E9{-E9{O!6RQ#xO1G2zO!6rQtO1G2zO'vQdO,5<jOOQS,5<j,5<jOOQS-E9|-E9|OOQS,5<r,5<rOOQS-E:U-E:UOOQV1G0x1G0xO1XQdO'#GRO!7ZQtO,5>kOOQS1G1`1G1`O!7xQdO1G1`OOQS'#DV'#DVO0rQdO,5=qOOQS,5=q,5=qO!7}QdO'#FrO!8YQdO,59oO!8bQdO1G/XO!8lQtO,5=uOOQS1G3`1G3`OOQS,5:m,5:mO!9]QdO'#GtOOQS,5<k,5<kOOQS-E9}-E9}O!9nQdO1G.hOOQS1G0Z1G0ZO!9|QdO,5=wO!:^QdO,5=wO0rQdO1G0jO0rQdO1G0jO!:oQdO,5>jO!;QQdO,5>jO1XQdO,5>jO!;cQdO,5>iOOQS-E:R-E:RO!;hQdO1G0lO!;sQdO1G0lO!;xQdO,5>lO!<WQdO,5>lO!<fQdO,5>hO!<|QdO,5>hO!=_QdO'#EpO0rQdO1G0tO!=jQdO1G0tO!=oQgO1G0zO!AmQgO1G0}O!EhQdO,5>oO!ErQdO,5>oO!EzQtO,5>oO0rQdO1G1PO!FUQdO1G1PO4iQdO1G1UO!!sQdO1G1WOOQV,5;a,5;aO!FZQfO,5;aO!F`QgO1G1QO!JaQdO'#GZO4iQdO1G1QO4iQdO1G1QO!JqQdO,5>pO!KOQdO,5>pO1XQdO,5>pOOQV1G1U1G1UO!KWQdO'#FSO!KiQ!fO1G1WO!KqQdO1G1WOOQV1G1]1G1]O4iQdO1G1]O!KvQdO1G1]O!LOQdO'#F^OOQV1G1b1G1bO!#WQtO1G1bPOOO1G2v1G2vP!LTOSO1G2vOOQS,5=},5=}OOQS'#Dp'#DpO0rQdO,5=}O!LYQdO,5=|O!LmQdO,5=|OOQS1G/u1G/uO!LuQdO,5>PO!MVQdO,5>PO!M_QdO,5>PO!MrQdO,5>PO!NSQdO,5>POOQS1G3j1G3jOOQS7+$h7+$hO!8bQdO7+$pO# uQdO1G.|O# |QdO1G.|OOQS1G/`1G/`OOQS,5<`,5<`O'vQdO,5<`OOQS7+%P7+%PO#!TQdO7+%POOQS-E9r-E9rOOQS7+%Q7+%QO#!eQdO,5=vO'vQdO,5=vOOQS7+$g7+$gO#!jQdO7+%PO#!rQdO7+%QO#!wQdO1G3fOOQS7+%X7+%XO##XQdO1G3fO##aQdO7+%XOOQS,5<_,5<_O'vQdO,5<_O##fQdO1G3aOOQS-E9q-E9qO#$]QdO7+%]OOQS7+%_7+%_O#$kQdO1G3aO#%YQdO7+%_O#%_QdO1G3gO#%oQdO1G3gO#%wQdO7+%]O#%|QdO,5>dO#&gQdO,5>dO#&gQdO,5>dOOQS'#Dx'#DxO#&xO&jO'#DzO#'TO`O'#HyOOOW1G3}1G3}O#'YQdO1G3}O#'bQdO1G3}O#'mQ#xO7+(fO#(^QtO1G2UP#(wQdO'#GOOOQS,5<m,5<mOOQS-E:P-E:POOQS7+&z7+&zOOQS1G3]1G3]OOQS,5<^,5<^OOQS-E9p-E9pOOQS7+$s7+$sO#)UQdO,5=`O#)oQdO,5=`O#*QQtO,5<aO#*eQdO1G3cOOQS-E9s-E9sOOQS7+&U7+&UO#*uQdO7+&UO#+TQdO,5<nO#+iQdO1G4UOOQS-E:Q-E:QO#+zQdO1G4UOOQS1G4T1G4TOOQS7+&W7+&WO#,]QdO7+&WOOQS,5<p,5<pO#,hQdO1G4WOOQS-E:S-E:SOOQS,5<l,5<lO#,vQdO1G4SOOQS-E:O-E:OO1XQdO'#EqO#-^QdO'#EqO#-iQdO'#IRO#-qQdO,5;[OOQS7+&`7+&`O0rQdO7+&`O#-vQgO7+&fO!JdQdO'#GXO4iQdO7+&fO4iQdO7+&iO#1tQtO,5<tO'vQdO,5<tO#2OQdO1G4ZOOQS-E:W-E:WO#2YQdO1G4ZO4iQdO7+&kO0rQdO7+&kOOQV7+&p7+&pO!KiQ!fO7+&rO!KqQdO7+&rO`QeO1G0{OOQV-E:X-E:XO4iQdO7+&lO4iQdO7+&lOOQV,5<u,5<uO#2bQdO,5<uO!JdQdO,5<uOOQV7+&l7+&lO#2mQgO7+&lO#6hQdO,5<vO#6sQdO1G4[OOQS-E:Y-E:YO#7QQdO1G4[O#7YQdO'#IWO#7hQdO'#IWO1XQdO'#IWOOQS'#IW'#IWO#7sQdO'#IVOOQS,5;n,5;nO#7{QdO,5;nO0rQdO'#FUOOQV7+&r7+&rO4iQdO7+&rOOQV7+&w7+&wO4iQdO7+&wO#8QQfO,5;xOOQV7+&|7+&|POOO7+(b7+(bO#8VQdO1G3iOOQS,5<c,5<cO#8eQdO1G3hOOQS-E9u-E9uO#8xQdO,5<dO#9TQdO,5<dO#9hQdO1G3kOOQS-E9v-E9vO#9xQdO1G3kO#:QQdO1G3kO#:bQdO1G3kO#9xQdO1G3kOOQS<<H[<<H[O#:mQtO1G1zOOQS<<Hk<<HkP#:zQdO'#FtO8sQdO1G3bO#;XQdO1G3bO#;^QdO<<HkOOQS<<Hl<<HlO#;nQdO7+)QOOQS<<Hs<<HsO#<OQtO1G1yP#<oQdO'#FsO#<|QdO7+)RO#=^QdO7+)RO#=fQdO<<HwO#=kQdO7+({OOQS<<Hy<<HyO#>bQdO,5<bO'vQdO,5<bOOQS-E9t-E9tOOQS<<Hw<<HwOOQS,5<g,5<gO0rQdO,5<gO#>gQdO1G4OOOQS-E9y-E9yO#?QQdO1G4OO<XQdO'#H{OOOO'#D{'#D{OOOO'#F|'#F|O#?cO&jO,5:fOOOW,5>e,5>eOOOW7+)i7+)iO#?nQdO7+)iO#?vQdO1G2zO#@aQdO1G2zP'vQdO'#FuO0rQdO<<IpO1XQdO1G2YP1XQdO'#GSO#@rQdO7+)pO#ATQdO7+)pOOQS<<Ir<<IrP1XQdO'#GUP0rQdO'#GQOOQS,5;],5;]O#AfQdO,5>mO#AtQdO,5>mOOQS1G0v1G0vOOQS<<Iz<<IzOOQV-E:V-E:VO4iQdO<<JQOOQV,5<s,5<sO4iQdO,5<sOOQV<<JQ<<JQOOQV<<JT<<JTO#A|QtO1G2`P#BWQdO'#GYO#B_QdO7+)uO#BiQgO<<JVO4iQdO<<JVOOQV<<J^<<J^O4iQdO<<J^O!KiQ!fO<<J^O#FdQgO7+&gOOQV<<JW<<JWO#FnQgO<<JWOOQV1G2a1G2aO1XQdO1G2aO#JiQdO1G2aO4iQdO<<JWO1XQdO1G2bP0rQdO'#G[O#JtQdO7+)vO#KRQdO7+)vOOQS'#FT'#FTO0rQdO,5>rO#KZQdO,5>rOOQS,5>r,5>rO#KfQdO,5>qO#KwQdO,5>qOOQS1G1Y1G1YOOQS,5;p,5;pOOQV<<Jc<<JcO#LPQdO1G1dOOQS7+)T7+)TP#LUQdO'#FwO#LfQdO1G2OO#LyQdO1G2OO#MZQdO1G2OP#MfQdO'#FxO#MsQdO7+)VO#NTQdO7+)VO#NTQdO7+)VO#N]QdO7+)VO#NmQdO7+(|O8sQdO7+(|OOQSAN>VAN>VO$ WQdO<<LmOOQSAN>cAN>cO0rQdO1G1|O$ hQtO1G1|P$ rQdO'#FvOOQS1G2R1G2RP$!PQdO'#F{O$!^QdO7+)jO$!wQdO,5>gOOOO-E9z-E9zOOOW<<MT<<MTO$#VQdO7+(fOOQSAN?[AN?[OOQS7+'t7+'tO$#pQdO<<M[OOQS,5<q,5<qO$$RQdO1G4XOOQS-E:T-E:TOOQVAN?lAN?lOOQV1G2_1G2_O4iQdOAN?qO$$aQgOAN?qOOQVAN?xAN?xO4iQdOAN?xOOQV<<JR<<JRO4iQdOAN?rO4iQdO7+'{OOQV7+'{7+'{O1XQdO7+'{OOQVAN?rAN?rOOQS7+'|7+'|O$([QdO<<MbOOQS1G4^1G4^O0rQdO1G4^OOQS,5<w,5<wO$(iQdO1G4]OOQS-E:Z-E:ZOOQU'#G_'#G_O$(zQfO7+'OO$)VQdO'#F_O$*^QdO7+'jO$*nQdO7+'jOOQS7+'j7+'jO$*yQdO<<LqO$+ZQdO<<LqO$+ZQdO<<LqO$+cQdO'#H^OOQS<<Lh<<LhO$+mQdO<<LhOOQS7+'h7+'hOOQS'#D|'#D|OOOO1G4R1G4RO$,WQdO1G4RO$,`QdO1G4RP!=_QdO'#GVOOQVG25]G25]O4iQdOG25]OOQVG25dG25dOOQVG25^G25^OOQV<<Kg<<KgO4iQdO<<KgOOQS7+)x7+)xP$,kQdO'#G]OOQU-E:]-E:]OOQV<<Jj<<JjO$-_QtO'#FaOOQS'#Fc'#FcO$-oQdO'#FbO$.aQdO'#FbOOQS'#Fb'#FbO$.fQdO'#IYO$)VQdO'#FiO$)VQdO'#FiO$.}QdO'#FjO$)VQdO'#FkO$/UQdO'#IZOOQS'#IZ'#IZO$/sQdO,5;yOOQS<<KU<<KUO$/{QdO<<KUO$0]QdOANB]O$0mQdOANB]O$0uQdO'#H_OOQS'#H_'#H_O1sQdO'#DcO$1`QdO,5=xOOQSANBSANBSOOOO7+)m7+)mO$1wQdO7+)mOOQVLD*wLD*wOOQVANARANARO5rQ!fO'#GaO$2PQtO,5<SO$)VQdO'#FmOOQS,5<W,5<WOOQS'#Fd'#FdO$2qQdO,5;|O$2vQdO,5;|OOQS'#Fg'#FgO$)VQdO'#G`O$3hQdO,5<QO$4SQdO,5>tO$4dQdO,5>tO1XQdO,5<PO$4uQdO,5<TO$4zQdO,5<TO$)VQdO'#I[O$5PQdO'#I[O$5UQdO,5<UOOQS,5<V,5<VO'vQdO'#FpOOQU1G1e1G1eO4iQdO1G1eOOQSAN@pAN@pO$5ZQdOG27wO$5kQdO,59}OOQS1G3d1G3dOOOO<<MX<<MXOOQS,5<{,5<{OOQS-E:_-E:_O$5pQtO'#FaO$5wQdO'#I]O$6VQdO'#I]O$6_QdO,5<XOOQS1G1h1G1hO$6dQdO1G1hO$6iQdO,5<zOOQS-E:^-E:^O$7TQdO,5=OO$7lQdO1G4`OOQS-E:b-E:bOOQS1G1k1G1kOOQS1G1o1G1oO$7|QdO,5>vO$)VQdO,5>vOOQS1G1p1G1pO$8[QtO,5<[OOQU7+'P7+'PO$+cQdO1G/iO$)VQdO,5<YO$8cQdO,5>wO$8jQdO,5>wOOQS1G1s1G1sOOQS7+'S7+'SP$)VQdO'#GdO$8rQdO1G4bO$8|QdO1G4bO$9UQdO1G4bOOQS7+%T7+%TO$9dQdO1G1tO$9rQtO'#FaO$9yQdO,5<}OOQS,5<},5<}O$:XQdO1G4cOOQS-E:a-E:aO$)VQdO,5<|O$:`QdO,5<|O$:eQdO7+)|OOQS-E:`-E:`O$:oQdO7+)|O$)VQdO,5<ZP$)VQdO'#GcO$:wQdO1G2hO$)VQdO1G2hP$;VQdO'#GbO$;^QdO<<MhO$;hQdO1G1uO$;vQdO7+(SO8sQdO'#C}O8sQdO,59bO8sQdO,59bO8sQdO,59bO$<UQtO,5=`O8sQdO1G.|O0rQdO1G/XO0rQdO7+$pP$<iQdO'#GOO'vQdO'#GtO$<vQdO,59bO$<{QdO,59bO$=SQdO,59mO$=XQdO1G/UO1sQdO'#DRO8sQdO,59j",
    stateData: "$=r~O%cOS%^OSSOS%]PQ~OPdOVaOfoOhYOopOs!POvqO!PrO!Q{O!T!SO!U!RO!XZO!][O!h`O!r`O!s`O!t`O!{tO!}uO#PvO#RwO#TxO#XyO#ZzO#^|O#_|O#a}O#c!OO#l!QO#o!TO#s!UO#u!VO#z!WO#}hO$P!XO%oRO%pRO%tSO%uWO&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O&c^O&d^O&e^O&f^O&g^O&h^O&i^O&j^O~O%]!YO~OV!aO_!aOa!bOh!iO!X!kO!f!mO%j![O%k!]O%l!^O%m!_O%n!_O%o!`O%p!`O%q!aO%r!aO%s!aO~Ok%xXl%xXm%xXn%xXo%xXp%xXs%xXz%xX{%xX!x%xX#g%xX%[%xX%_%xX%z%xXg%xX!T%xX!U%xX%{%xX!W%xX![%xX!Q%xX#[%xXt%xX!m%xX~P%SOfoOhYO!XZO!][O!h`O!r`O!s`O!t`O%oRO%pRO%tSO%uWO&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O&c^O&d^O&e^O&f^O&g^O&h^O&i^O&j^O~Oz%wX{%wX#g%wX%[%wX%_%wX%z%wX~Ok!pOl!qOm!oOn!oOo!rOp!sOs!tO!x%wX~P)pOV!zOg!|Oo0cOv0qO!PrO~P'vOV#OOo0cOv0qO!W#PO~P'vOV#SOa#TOo0cOv0qO![#UO~P'vOQ#XO%`#XO%a#ZO~OQ#^OR#[O%`#^O%a#`O~OV%iX_%iXa%iXh%iXk%iXl%iXm%iXn%iXo%iXp%iXs%iXz%iX!X%iX!f%iX%j%iX%k%iX%l%iX%m%iX%n%iX%o%iX%p%iX%q%iX%r%iX%s%iXg%iX!T%iX!U%iX~O&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O&c^O&d^O&e^O&f^O&g^O&h^O&i^O&j^O{%iX!x%iX#g%iX%[%iX%_%iX%z%iX%{%iX!W%iX![%iX!Q%iX#[%iXt%iX!m%iX~P,eOz#dO{%hX!x%hX#g%hX%[%hX%_%hX%z%hX~Oo0cOv0qO~P'vO#g#gO%[#iO%_#iO~O%uWO~O!T#nO#u!VO#z!WO#}hO~OopO~P'vOV#sOa#tO%uWO{wP~OV#xOo0cOv0qO!Q#yO~P'vO{#{O!x$QO%z#|O#g!yX%[!yX%_!yX~OV#xOo0cOv0qO#g#SX%[#SX%_#SX~P'vOo0cOv0qO#g#WX%[#WX%_#WX~P'vOh$WO%uWO~O!f$YO!r$YO%uWO~OV$eO~P'vO!U$gO#s$hO#u$iO~O{$jO~OV$qO~P'vOS$sO%[$rO%c$tO~OV$}Oa$}Og%POo0cOv0qO~P'vOo0cOv0qO{%SO~P'vO&Y%UO~Oa!bOh!iO!X!kO!f!mOVba_bakbalbambanbaobapbasbazba{ba!xba#gba%[ba%_ba%jba%kba%lba%mba%nba%oba%pba%qba%rba%sba%zbagba!Tba!Uba%{ba!Wba![ba!Qba#[batba!mba~On%ZO~Oo%ZO~P'vOo0cO~P'vOk0eOl0fOm0dOn0dOo0mOp0nOs0rOg%wX!T%wX!U%wX%{%wX!W%wX![%wX!Q%wX#[%wX!m%wX~P)pO%{%]Og%vXz%vX!T%vX!U%vX!W%vX{%vX~Og%_Oz%`O!T%dO!U%cO~Og%_O~Oz%gO!T%dO!U%cO!W&SX~O!W%kO~Oz%lO{%nO!T%dO!U%cO![%}X~O![%rO~O![%sO~OQ#XO%`#XO%a%uO~OV%wOo0cOv0qO!PrO~P'vOQ#^OR#[O%`#^O%a%zO~OV!qa_!qaa!qah!qak!qal!qam!qan!qao!qap!qas!qaz!qa{!qa!X!qa!f!qa!x!qa#g!qa%[!qa%_!qa%j!qa%k!qa%l!qa%m!qa%n!qa%o!qa%p!qa%q!qa%r!qa%s!qa%z!qag!qa!T!qa!U!qa%{!qa!W!qa![!qa!Q!qa#[!qat!qa!m!qa~P#yOz%|O{%ha!x%ha#g%ha%[%ha%_%ha%z%ha~P%SOV&OOopOvqO{%ha!x%ha#g%ha%[%ha%_%ha%z%ha~P'vOz%|O{%ha!x%ha#g%ha%[%ha%_%ha%z%ha~OPdOVaOopOvqO!PrO!Q{O!{tO!}uO#PvO#RwO#TxO#XyO#ZzO#^|O#_|O#a}O#c!OO#g$zX%[$zX%_$zX~P'vO#g#gO%[&TO%_&TO~O!f&UOh&sX%[&sXz&sX#[&sX#g&sX%_&sX#Z&sXg&sX~Oh!iO%[&WO~Okealeameaneaoeapeaseazea{ea!xea#gea%[ea%_ea%zeagea!Tea!Uea%{ea!Wea![ea!Qea#[eatea!mea~P%SOsqazqa{qa#gqa%[qa%_qa%zqa~Ok!pOl!qOm!oOn!oOo!rOp!sO!xqa~PE`O%z&YOz%yX{%yX~O%uWOz%yX{%yX~Oz&]O{wX~O{&_O~Oz%lO#g%}X%[%}X%_%}Xg%}X{%}X![%}X!m%}X%z%}X~OV0lOo0cOv0qO!PrO~P'vO%z#|O#gUa%[Ua%_Ua~Oz&hO#g&PX%[&PX%_&PXn&PX~P%SOz&kO!Q&jO#g#Wa%[#Wa%_#Wa~Oz&lO#[&nO#g&rX%[&rX%_&rXg&rX~O!f$YO!r$YO#Z&qO%uWO~O#Z&qO~Oz&sO#g&tX%[&tX%_&tX~Oz&uO#g&pX%[&pX%_&pX{&pX~O!X&wO%z&xO~Oz&|On&wX~P%SOn'PO~OPdOVaOopOvqO!PrO!Q{O!{tO!}uO#PvO#RwO#TxO#XyO#ZzO#^|O#_|O#a}O#c!OO%['UO~P'vOt'YO#p'WO#q'XOP#naV#naf#nah#nao#nas#nav#na!P#na!Q#na!T#na!U#na!X#na!]#na!h#na!r#na!s#na!t#na!{#na!}#na#P#na#R#na#T#na#X#na#Z#na#^#na#_#na#a#na#c#na#l#na#o#na#s#na#u#na#z#na#}#na$P#na%X#na%o#na%p#na%t#na%u#na&Z#na&[#na&]#na&^#na&_#na&`#na&a#na&b#na&c#na&d#na&e#na&f#na&g#na&h#na&i#na&j#na%Z#na%_#na~Oz'ZO#[']O{&xX~Oh'_O!X&wO~Oh!iO{$jO!X&wO~O{'eO~P%SO%['hO~OS'iO%['hO~OV!aO_!aOa!bOh!iO!X!kO!f!mO%l!^O%m!_O%n!_O%o!`O%p!`O%q!aO%r!aO%s!aOkWilWimWinWioWipWisWizWi{Wi!xWi#gWi%[Wi%_Wi%jWi%zWigWi!TWi!UWi%{Wi!WWi![Wi!QWi#[WitWi!mWi~O%k!]O~P!#lO%kWi~P!#lOV!aO_!aOa!bOh!iO!X!kO!f!mO%o!`O%p!`O%q!aO%r!aO%s!aOkWilWimWinWioWipWisWizWi{Wi!xWi#gWi%[Wi%_Wi%jWi%kWi%lWi%zWigWi!TWi!UWi%{Wi!WWi![Wi!QWi#[WitWi!mWi~O%m!_O%n!_O~P!&gO%mWi%nWi~P!&gOa!bOh!iO!X!kO!f!mOkWilWimWinWioWipWisWizWi{Wi!xWi#gWi%[Wi%_Wi%jWi%kWi%lWi%mWi%nWi%oWi%pWi%zWigWi!TWi!UWi%{Wi!WWi![Wi!QWi#[WitWi!mWi~OV!aO_!aO%q!aO%r!aO%s!aO~P!)eOVWi_Wi%qWi%rWi%sWi~P!)eO!T%dO!U%cOg&VXz&VX~O%z'kO%{'kO~P,eOz'mOg&UX~Og'oO~Oz'pO{'rO!W&XX~Oo0cOv0qOz'pO{'sO!W&XX~P'vO!W'uO~Om!oOn!oOo!rOp!sOkjisjizji{ji!xji#gji%[ji%_ji%zji~Ol!qO~P!.WOlji~P!.WOk0eOl0fOm0dOn0dOo0mOp0nO~Ot'wO~P!/aOV'|Og'}Oo0cOv0qO~P'vOg'}Oz(OO~Og(QO~O!U(SO~Og(TOz(OO!T%dO!U%cO~P%SOk0eOl0fOm0dOn0dOo0mOp0nOgqa!Tqa!Uqa%{qa!Wqa![qa!Qqa#[qatqa!mqa~PE`OV'|Oo0cOv0qO!W&Sa~P'vOz(WO!W&Sa~O!W(XO~Oz(WO!T%dO!U%cO!W&Sa~P%SOV(]Oo0cOv0qO![%}a#g%}a%[%}a%_%}ag%}a{%}a!m%}a%z%}a~P'vOz(^O![%}a#g%}a%[%}a%_%}ag%}a{%}a!m%}a%z%}a~O![(aO~Oz(^O!T%dO!U%cO![%}a~P%SOz(dO!T%dO!U%cO![&Ta~P%SOz(gO{&lX![&lX!m&lX%z&lX~O{(kO![(mO!m(nO%z(jO~OV&OOopOvqO{%hi!x%hi#g%hi%[%hi%_%hi%z%hi~P'vOz(pO{%hi!x%hi#g%hi%[%hi%_%hi%z%hi~O!f&UOh&sa%[&saz&sa#[&sa#g&sa%_&sa#Z&sag&sa~O%[(uO~OV#sOa#tO%uWO~Oz&]O{wa~OopOvqO~P'vOz(^O#g%}a%[%}a%_%}ag%}a{%}a![%}a!m%}a%z%}a~P%SOz(zO#g%hX%[%hX%_%hX%z%hX~O%z#|O#gUi%[Ui%_Ui~O#g&Pa%[&Pa%_&Pan&Pa~P'vOz(}O#g&Pa%[&Pa%_&Pan&Pa~O%uWO#g&ra%[&ra%_&rag&ra~Oz)SO#g&ra%[&ra%_&rag&ra~Og)VO~OV)WOh$WO%uWO~O#Z)XO~O%uWO#g&ta%[&ta%_&ta~Oz)ZO#g&ta%[&ta%_&ta~Oo0cOv0qO#g&pa%[&pa%_&pa{&pa~P'vOz)^O#g&pa%[&pa%_&pa{&pa~OV)`Oa)`O%uWO~O%z)eO~Ot)hO#j)gOP#hiV#hif#hih#hio#his#hiv#hi!P#hi!Q#hi!T#hi!U#hi!X#hi!]#hi!h#hi!r#hi!s#hi!t#hi!{#hi!}#hi#P#hi#R#hi#T#hi#X#hi#Z#hi#^#hi#_#hi#a#hi#c#hi#l#hi#o#hi#s#hi#u#hi#z#hi#}#hi$P#hi%X#hi%o#hi%p#hi%t#hi%u#hi&Z#hi&[#hi&]#hi&^#hi&_#hi&`#hi&a#hi&b#hi&c#hi&d#hi&e#hi&f#hi&g#hi&h#hi&i#hi&j#hi%Z#hi%_#hi~Ot)iOP#kiV#kif#kih#kio#kis#kiv#ki!P#ki!Q#ki!T#ki!U#ki!X#ki!]#ki!h#ki!r#ki!s#ki!t#ki!{#ki!}#ki#P#ki#R#ki#T#ki#X#ki#Z#ki#^#ki#_#ki#a#ki#c#ki#l#ki#o#ki#s#ki#u#ki#z#ki#}#ki$P#ki%X#ki%o#ki%p#ki%t#ki%u#ki&Z#ki&[#ki&]#ki&^#ki&_#ki&`#ki&a#ki&b#ki&c#ki&d#ki&e#ki&f#ki&g#ki&h#ki&i#ki&j#ki%Z#ki%_#ki~OV)kOn&wa~P'vOz)lOn&wa~Oz)lOn&wa~P%SOn)pO~O%Y)tO~Ot)wO#p'WO#q)vOP#niV#nif#nih#nio#nis#niv#ni!P#ni!Q#ni!T#ni!U#ni!X#ni!]#ni!h#ni!r#ni!s#ni!t#ni!{#ni!}#ni#P#ni#R#ni#T#ni#X#ni#Z#ni#^#ni#_#ni#a#ni#c#ni#l#ni#o#ni#s#ni#u#ni#z#ni#}#ni$P#ni%X#ni%o#ni%p#ni%t#ni%u#ni&Z#ni&[#ni&]#ni&^#ni&_#ni&`#ni&a#ni&b#ni&c#ni&d#ni&e#ni&f#ni&g#ni&h#ni&i#ni&j#ni%Z#ni%_#ni~OV)zOo0cOv0qO{$jO~P'vOo0cOv0qO{&xa~P'vOz*OO{&xa~OV*SOa*TOg*WO%q*UO%uWO~O{$jO&{*YO~Oh'_O~Oh!iO{$jO~O%[*_O~O%[*aO~OV$}Oa$}Oo0cOv0qOg&Ua~P'vOz*dOg&Ua~Oo0cOv0qO{*gO!W&Xa~P'vOz*hO!W&Xa~Oo0cOv0qOz*hO{*kO!W&Xa~P'vOo0cOv0qOz*hO!W&Xa~P'vOz*hO{*kO!W&Xa~Om0dOn0dOo0mOp0nOgjikjisjizji!Tji!Uji%{ji!Wji{ji![ji#gji%[ji%_ji!Qji#[jitji!mji%zji~Ol0fO~P!N_Olji~P!N_OV'|Og*pOo0cOv0qO~P'vOn*rO~Og*pOz*tO~Og*uO~OV'|Oo0cOv0qO!W&Si~P'vOz*vO!W&Si~O!W*wO~OV(]Oo0cOv0qO![%}i#g%}i%[%}i%_%}ig%}i{%}i!m%}i%z%}i~P'vOz*zO!T%dO!U%cO![&Ti~Oz*}O![%}i#g%}i%[%}i%_%}ig%}i{%}i!m%}i%z%}i~O![+OO~Oa+QOo0cOv0qO![&Ti~P'vOz*zO![&Ti~O![+SO~OV+UOo0cOv0qO{&la![&la!m&la%z&la~P'vOz+VO{&la![&la!m&la%z&la~O!]+YO&n+[O![!nX~O![+^O~O{(kO![+_O~O{(kO![+_O!m+`O~OV&OOopOvqO{%hq!x%hq#g%hq%[%hq%_%hq%z%hq~P'vOz$ri{$ri!x$ri#g$ri%[$ri%_$ri%z$ri~P%SOV&OOopOvqO~P'vOV&OOo0cOv0qO#g%ha%[%ha%_%ha%z%ha~P'vOz+aO#g%ha%[%ha%_%ha%z%ha~Oz$ia#g$ia%[$ia%_$ian$ia~P%SO#g&Pi%[&Pi%_&Pin&Pi~P'vOz+dO#g#Wq%[#Wq%_#Wq~O#[+eOz$va#g$va%[$va%_$vag$va~O%uWO#g&ri%[&ri%_&rig&ri~Oz+gO#g&ri%[&ri%_&rig&ri~OV+iOh$WO%uWO~O%uWO#g&ti%[&ti%_&ti~Oo0cOv0qO#g&pi%[&pi%_&pi{&pi~P'vO{#{Oz#eX!W#eX~Oz+mO!W&uX~O!W+oO~Ot+rO#j)gOP#hqV#hqf#hqh#hqo#hqs#hqv#hq!P#hq!Q#hq!T#hq!U#hq!X#hq!]#hq!h#hq!r#hq!s#hq!t#hq!{#hq!}#hq#P#hq#R#hq#T#hq#X#hq#Z#hq#^#hq#_#hq#a#hq#c#hq#l#hq#o#hq#s#hq#u#hq#z#hq#}#hq$P#hq%X#hq%o#hq%p#hq%t#hq%u#hq&Z#hq&[#hq&]#hq&^#hq&_#hq&`#hq&a#hq&b#hq&c#hq&d#hq&e#hq&f#hq&g#hq&h#hq&i#hq&j#hq%Z#hq%_#hq~On$|az$|a~P%SOV)kOn&wi~P'vOz+yOn&wi~Oz,TO{$jO#[,TO~O#q,VOP#nqV#nqf#nqh#nqo#nqs#nqv#nq!P#nq!Q#nq!T#nq!U#nq!X#nq!]#nq!h#nq!r#nq!s#nq!t#nq!{#nq!}#nq#P#nq#R#nq#T#nq#X#nq#Z#nq#^#nq#_#nq#a#nq#c#nq#l#nq#o#nq#s#nq#u#nq#z#nq#}#nq$P#nq%X#nq%o#nq%p#nq%t#nq%u#nq&Z#nq&[#nq&]#nq&^#nq&_#nq&`#nq&a#nq&b#nq&c#nq&d#nq&e#nq&f#nq&g#nq&h#nq&i#nq&j#nq%Z#nq%_#nq~O#[,WOz%Oa{%Oa~Oo0cOv0qO{&xi~P'vOz,YO{&xi~O{#{O%z,[Og&zXz&zX~O%uWOg&zXz&zX~Oz,`Og&yX~Og,bO~O%Y,eO~O!T%dO!U%cOg&Viz&Vi~OV$}Oa$}Oo0cOv0qOg&Ui~P'vO{,hOz$la!W$la~Oo0cOv0qO{,iOz$la!W$la~P'vOo0cOv0qO{*gO!W&Xi~P'vOz,lO!W&Xi~Oo0cOv0qOz,lO!W&Xi~P'vOz,lO{,oO!W&Xi~Og$hiz$hi!W$hi~P%SOV'|Oo0cOv0qO~P'vOn,qO~OV'|Og,rOo0cOv0qO~P'vOV'|Oo0cOv0qO!W&Sq~P'vOz$gi![$gi#g$gi%[$gi%_$gig$gi{$gi!m$gi%z$gi~P%SOV(]Oo0cOv0qO~P'vOa+QOo0cOv0qO![&Tq~P'vOz,sO![&Tq~O![,tO~OV(]Oo0cOv0qO![%}q#g%}q%[%}q%_%}qg%}q{%}q!m%}q%z%}q~P'vO{,uO~OV+UOo0cOv0qO{&li![&li!m&li%z&li~P'vOz,zO{&li![&li!m&li%z&li~O!]+YO&n+[O![!na~O{(kO![,}O~OV&OOo0cOv0qO#g%hi%[%hi%_%hi%z%hi~P'vOz-OO#g%hi%[%hi%_%hi%z%hi~O%uWO#g&rq%[&rq%_&rqg&rq~Oz-RO#g&rq%[&rq%_&rqg&rq~OV)`Oa)`O%uWO!W&ua~Oz-TO!W&ua~On$|iz$|i~P%SOV)kO~P'vOV)kOn&wq~P'vOt-XOP#myV#myf#myh#myo#mys#myv#my!P#my!Q#my!T#my!U#my!X#my!]#my!h#my!r#my!s#my!t#my!{#my!}#my#P#my#R#my#T#my#X#my#Z#my#^#my#_#my#a#my#c#my#l#my#o#my#s#my#u#my#z#my#}#my$P#my%X#my%o#my%p#my%t#my%u#my&Z#my&[#my&]#my&^#my&_#my&`#my&a#my&b#my&c#my&d#my&e#my&f#my&g#my&h#my&i#my&j#my%Z#my%_#my~O%Z-]O%_-]O~P`O#q-^OP#nyV#nyf#nyh#nyo#nys#nyv#ny!P#ny!Q#ny!T#ny!U#ny!X#ny!]#ny!h#ny!r#ny!s#ny!t#ny!{#ny!}#ny#P#ny#R#ny#T#ny#X#ny#Z#ny#^#ny#_#ny#a#ny#c#ny#l#ny#o#ny#s#ny#u#ny#z#ny#}#ny$P#ny%X#ny%o#ny%p#ny%t#ny%u#ny&Z#ny&[#ny&]#ny&^#ny&_#ny&`#ny&a#ny&b#ny&c#ny&d#ny&e#ny&f#ny&g#ny&h#ny&i#ny&j#ny%Z#ny%_#ny~Oz-aO{$jO#[-aO~Oo0cOv0qO{&xq~P'vOz-dO{&xq~O%z,[Og&zaz&za~OV*SOa*TO%q*UO%uWOg&ya~Oz-hOg&ya~O$S-lO~OV$}Oa$}Oo0cOv0qO~P'vOo0cOv0qO{-mOz$li!W$li~P'vOo0cOv0qOz$li!W$li~P'vO{-mOz$li!W$li~Oo0cOv0qO{*gO~P'vOo0cOv0qO{*gO!W&Xq~P'vOz-pO!W&Xq~Oo0cOv0qOz-pO!W&Xq~P'vOs-sO!T%dO!U%cOg&Oq!W&Oq![&Oqz&Oq~P!/aOa+QOo0cOv0qO![&Ty~P'vOz$ji![$ji~P%SOa+QOo0cOv0qO~P'vOV+UOo0cOv0qO~P'vOV+UOo0cOv0qO{&lq![&lq!m&lq%z&lq~P'vO{(kO![-xO!m-yO%z-wO~OV&OOo0cOv0qO#g%hq%[%hq%_%hq%z%hq~P'vO%uWO#g&ry%[&ry%_&ryg&ry~OV)`Oa)`O%uWO!W&ui~Ot-}OP#m!RV#m!Rf#m!Rh#m!Ro#m!Rs#m!Rv#m!R!P#m!R!Q#m!R!T#m!R!U#m!R!X#m!R!]#m!R!h#m!R!r#m!R!s#m!R!t#m!R!{#m!R!}#m!R#P#m!R#R#m!R#T#m!R#X#m!R#Z#m!R#^#m!R#_#m!R#a#m!R#c#m!R#l#m!R#o#m!R#s#m!R#u#m!R#z#m!R#}#m!R$P#m!R%X#m!R%o#m!R%p#m!R%t#m!R%u#m!R&Z#m!R&[#m!R&]#m!R&^#m!R&_#m!R&`#m!R&a#m!R&b#m!R&c#m!R&d#m!R&e#m!R&f#m!R&g#m!R&h#m!R&i#m!R&j#m!R%Z#m!R%_#m!R~Oo0cOv0qO{&xy~P'vOV*SOa*TO%q*UO%uWOg&yi~O$S-lO%Z.VO%_.VO~OV.aOh._O!X.^O!].`O!h.YO!s.[O!t.[O%p.XO%uWO&Z]O&[]O&]]O&^]O&_]O&`]O&a]O&b]O~Oo0cOv0qOz$lq!W$lq~P'vO{.fOz$lq!W$lq~Oo0cOv0qO{*gO!W&Xy~P'vOz.gO!W&Xy~Oo0cOv.kO~P'vOs-sO!T%dO!U%cOg&Oy!W&Oy![&Oyz&Oy~P!/aO{(kO![.nO~O{(kO![.nO!m.oO~OV*SOa*TO%q*UO%uWO~Oh.tO!f.rOz$TX#[$TX%j$TXg$TX~Os$TX{$TX!W$TX![$TX~P$,yO%o.vO%p.vOs$UXz$UX{$UX#[$UX%j$UX!W$UXg$UX![$UX~O!h.xO~Oz.|O#[/OO%j.yOs&|X{&|X!W&|Xg&|X~Oa/RO~P$)cOh.tOs&}Xz&}X{&}X#[&}X%j&}X!W&}Xg&}X![&}X~Os/VO{$jO~Oo0cOv0qOz$ly!W$ly~P'vOo0cOv0qO{*gO!W&X!R~P'vOz/ZO!W&X!R~Og&RXs&RX!T&RX!U&RX!W&RX![&RXz&RX~P!/aOs-sO!T%dO!U%cOg&Qa!W&Qa![&Qaz&Qa~O{(kO![/^O~O!f.rOh$[as$[az$[a{$[a#[$[a%j$[a!W$[ag$[a![$[a~O!h/eO~O%o.vO%p.vOs$Uaz$Ua{$Ua#[$Ua%j$Ua!W$Uag$Ua![$Ua~O%j.yOs$Yaz$Ya{$Ya#[$Ya!W$Yag$Ya![$Ya~Os&|a{&|a!W&|ag&|a~P$)VOz/jOs&|a{&|a!W&|ag&|a~O!W/mO~Og/mO~O{/oO~O![/pO~Oo0cOv0qO{*gO!W&X!Z~P'vO{/sO~O%z/tO~P$,yOz/uO#[/OO%j.yOg'PX~Oz/uOg'PX~Og/wO~O!h/xO~O#[/OOs%Saz%Sa{%Sa%j%Sa!W%Sag%Sa![%Sa~O#[/OO%j.yOs%Waz%Wa{%Wa!W%Wag%Wa~Os&|i{&|i!W&|ig&|i~P$)VOz/zO#[/OO%j.yO!['Oa~O{$da~P%SOg'Pa~P$)VOz0SOg'Pa~Oa0UO!['Oi~P$)cOz0WO!['Oi~Oz0WO#[/OO%j.yO!['Oi~O#[/OO%j.yOg$biz$bi~O%z0ZO~P$,yO#[/OO%j.yOg%Vaz%Va~Og'Pi~P$)VO{0^O~Oa0UO!['Oq~P$)cOz0`O!['Oq~O#[/OO%j.yOz%Ui![%Ui~Oa0UO~P$)cOa0UO!['Oy~P$)cO#[/OO%j.yOg$ciz$ci~O#[/OO%j.yOz%Uq![%Uq~Oz+aO#g%ha%[%ha%_%ha%z%ha~P%SOV&OOo0cOv0qO~P'vOn0hO~Oo0hO~P'vO{0iO~Ot0jO~P!/aO&]&Z&j&h&i&g&f&d&e&c&b&`&a&_&^&[%u~",
    goto: "!=l'QPPPPPP'RP'Z*s+]+v,b,}-kP.YP'Z.y.y'ZPPP'Z2cPPPPPP2c5VPP5VP7g7p=xPP={>m>pPP'Z'ZPP?PPP'Z'ZPP'Z'Z'Z'Z'Z?T?}'ZP@QP@WD_G{HPPHSH^Hb'ZPPPHeHn'RP'R'RP'RP'RP'RP'RP'R'R'RP'RPP'RPP'RP'RPHtIQIYPIaIgPIaPIaIaPPPIaPKuPLOLYL`KuPIaLiPIaPLpLvPLzM`M}NhLzLzNnN{LzLzLzLz! a! g! j! o! r! |!!S!!`!!r!!x!#S!#Y!#v!#|!$S!$^!$d!$j!$|!%W!%^!%d!%n!%t!%z!&Q!&W!&^!&h!&n!&x!'O!'X!'_!'n!'v!(Q!(XPPPPPPPPPPP!(_!(b!(h!(q!({!)WPPPPPPPPPPPP!-z!/`!3`!6pPP!6x!7X!7b!8Z!8Q!8d!8j!8m!8p!8s!8{!9lPPPPPPPPPPPPPPPPP!9o!9s!9yP!:_!:c!:o!:x!;U!;l!;o!;r!;x!<O!<U!<XP!<a!<j!=f!=i]eOn#g$j)t,P'}`OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0r}!cQ#c#p$R$d$p%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0g!P!dQ#c#p$R$d$p$u%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0g!R!eQ#c#p$R$d$p$u$v%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0g!T!fQ#c#p$R$d$p$u$v$w%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0g!V!gQ#c#p$R$d$p$u$v$w$x%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0g!X!hQ#c#p$R$d$p$u$v$w$x$y%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0g!]!hQ!n#c#p$R$d$p$u$v$w$x$y$z%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0g'}TOTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0r&cVOYZ[dnprxy}!P!Q!U!i!k!o!p!q!s!t#[#d#g#y#{#}$Q$h$j$}%S%Z%^%`%g%l%n%w%|&Z&_&j&k&u&x'P'W'Z'l'm'p'r's'w(O(W(^(d(g(p(r(z)^)e)g)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+U+V+Y+a+d+k,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/Z/s0c0d0e0f0h0i0j0k0n0r%mXOYZ[dnrxy}!P!Q!U!i!k#[#d#g#y#{#}$Q$h$j$}%S%^%`%g%l%n%w%|&Z&_&j&k&u&x'P'W'Z'l'm'p'r's'w(O(W(^(d(g(p(r(z)^)e)g)p)t)z*O*Y*d*g*h*k*q*t*v*y*z*}+U+V+Y+a+d+k,P,X,Y,],g,h,i,k,l,o,s,u,w,y,z-O-d-f-m-p.f.g/Z0i0j0kQ#vqQ/[.kR0o0q't`OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0rh#jhz{$W$Z&l&q)S)X+f+g-RW#rq&].k0qQ$]|Q$a!OQ$n!VQ$o!WW$|!i'm*d,gS&[#s#tQ'S$iQ(s&UQ)U&nU)Y&s)Z+jW)a&w+m-T-{Q*Q']W*R'_,`-h.TQ+l)`S,_*S*TQ-Q+eQ-_,TQ-c,WQ.R-al.W-l.^._.a.z.|/R/j/o/t/y0U0Z0^Q/S.`Q/a.tQ/l/OU0P/u0S0[X0V/z0W0_0`R&Z#r!_!wYZ!P!Q!k%S%`%g'p'r's(O(W)g*g*h*k*q*t*v,h,i,k,l,o-m-p.f.g/ZR%^!vQ!{YQ%x#[Q&d#}Q&g$QR,{+YT.j-s/s![!jQ!n#c#p$R$d$p$u$v$w$x$y$z%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0gQ&X#kQ'c$oR*^'dR'l$|Q%V!mR/_.r'|_OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0rS#a_#b!P.[-l.^._.`.a.t.z.|/R/j/o/t/u/y/z0S0U0W0Z0[0^0_0`'|_OTYZ[adnoprtxy}!P!Q!R!U!X!c!d!e!f!g!h!i!k!o!p!q!s!t!z#O#S#T#[#d#g#x#y#{#}$Q$e$g$h$j$q$}%S%Z%^%`%c%g%l%n%w%|&O&Z&_&h&j&k&u&x&|'P'W'Z'l'm'p'r's'w'|(O(S(W(](^(d(g(p(r(z(})^)e)g)k)l)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+Q+U+V+Y+a+c+d+k+x+y,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/V/Z/s0c0d0e0f0h0i0j0k0l0n0rT#a_#bT#^^#_R(o%xa(l%x(n(o+`,{-y-z.oT+[(k+]R-z,{Q$PsQ+l)aR,^*RX#}s$O$P&fQ&y$aQ'a$nQ'd$oR)s'SQ)b&wV-S+m-T-{ZgOn$j)t,PXkOn)t,PQ$k!TQ&z$bQ&{$cQ'^$mQ'b$oQ)q'RQ)x'WQ){'XQ)|'YQ*Z'`S*]'c'dQ+s)gQ+u)hQ+v)iQ+z)oS+|)r*[Q,Q)vQ,R)wS,S)y)zQ,d*^Q-V+rQ-W+tQ-Y+{S-Z+},OQ-`,UQ-b,VQ-|-XQ.O-[Q.P-^Q.Q-_Q.p-}Q.q.RQ/W.dR/r/XWkOn)t,PR#mjQ'`$nS)r'S'aR,O)sQ,]*RR-f,^Q*['`Q+})rR-[,OZiOjn)t,PQ'f$pR*`'gT-j,e-ku.c-l.^._.a.t.z.|/R/j/o/t/u/y0S0U0Z0[0^t.c-l.^._.a.t.z.|/R/j/o/t/u/y0S0U0Z0[0^Q/S.`X0V/z0W0_0`!P.Z-l.^._.`.a.t.z.|/R/j/o/t/u/y/z0S0U0W0Z0[0^0_0`Q.w.YR/f.xg.z.].{/b/i/n/|0O0Q0]0a0bu.b-l.^._.a.t.z.|/R/j/o/t/u/y0S0U0Z0[0^X.u.W.b/a0PR/c.tV0R/u0S0[R/X.dQnOS#on,PR,P)tQ&^#uR(x&^S%m#R#wS(_%m(bT(b%p&`Q%a!yQ%h!}W(P%a%h(U(YQ(U%eR(Y%jQ&i$RR)O&iQ(e%qQ*{(`T+R(e*{Q'n%OR*e'nS'q%R%SY*i'q*j,m-q.hU*j'r's'tU,m*k*l*mS-q,n,oR.h-rQ#Y]R%t#YQ#_^R%y#_Q(h%vS+W(h+XR+X(iQ+](kR,|+]Q#b_R%{#bQ#ebQ%}#cW&Q#e%}({+bQ({&cR+b0gQ$OsS&e$O&fR&f$PQ&v$_R)_&vQ&V#jR(t&VQ&m$VS)T&m+hR+h)UQ$Z{R&p$ZQ&t$]R)[&tQ+n)bR-U+nQ#hfR&S#hQ)f&zR+q)fQ&}$dS)m&})nR)n'OQ'V$kR)u'VQ'[$lS*P'[,ZR,Z*QQ,a*VR-i,aWjOn)t,PR#ljQ-k,eR.U-kd.{.]/b/i/n/|0O0Q0]0a0bR/h.{U.s.W/a0PR/`.sQ/{/nS0X/{0YR0Y/|S/v/b/cR0T/vQ.}.]R/k.}R!ZPXmOn)t,PWlOn)t,PR'T$jYfOn$j)t,PR&R#g[sOn#g$j)t,PR&d#}&bQOYZ[dnprxy}!P!Q!U!i!k!o!p!q!s!t#[#d#g#y#{#}$Q$h$j$}%S%Z%^%`%g%l%n%w%|&Z&_&j&k&u&x'P'W'Z'l'm'p'r's'w(O(W(^(d(g(p(r(z)^)e)g)p)t)z*O*Y*d*g*h*k*q*r*t*v*y*z*}+U+V+Y+a+d+k,P,X,Y,],g,h,i,k,l,o,q,s,u,w,y,z-O-d-f-m-p-s.f.g/Z/s0c0d0e0f0h0i0j0k0n0rQ!nTQ#caQ#poU$Rt%c(SS$d!R$gQ$p!XQ$u!cQ$v!dQ$w!eQ$x!fQ$y!gQ$z!hQ%e!zQ%j#OQ%p#SQ%q#TQ&`#xQ'O$eQ'g$qQ(q&OU(|&h(}+cW)j&|)l+x+yQ*o'|Q*x(]Q+w)kQ,v+QQ/q/VR0g0lQ!yYQ!}ZQ$b!PQ$c!QQ%R!kQ't%S^'{%`%g(O(W*q*t*v^*f'p*h,k,l-p.g/ZQ*l'rQ*m'sQ+t)gQ,j*gQ,n*kQ-n,hQ-o,iQ-r,oQ.e-mR/Y.f[bOn#g$j)t,P!^!vYZ!P!Q!k%S%`%g'p'r's(O(W)g*g*h*k*q*t*v,h,i,k,l,o-m-p.f.g/ZQ#R[Q#fdS#wrxQ$UyW$_}$Q'P)pS$l!U$hW${!i'm*d,gS%v#[+Y`&P#d%|(p(r(z+a-O0kQ&a#yQ&b#{Q&c#}Q'j$}Q'z%^W([%l(^*y*}Q(`%nQ(i%wQ(v&ZS(y&_0iQ)P&jQ)Q&kU)]&u)^+kQ)d&xQ)y'WY)}'Z*O,X,Y-dQ*b'lS*n'w0jW+P(d*z,s,wW+T(g+V,y,zQ+p)eQ,U)zQ,c*YQ,x+UQ-P+dQ-e,]Q-v,uR.S-fhUOn#d#g$j%|&_'w(p(r)t,P%S!uYZ[drxy}!P!Q!U!i!k#[#y#{#}$Q$h$}%S%^%`%g%l%n%w&Z&j&k&u&x'P'W'Z'l'm'p'r's(O(W(^(d(g(z)^)e)g)p)z*O*Y*d*g*h*k*q*t*v*y*z*}+U+V+Y+a+d+k,X,Y,],g,h,i,k,l,o,s,u,w,y,z-O-d-f-m-p.f.g/Z0i0j0kQ#qpW%W!o!s0d0nQ%X!pQ%Y!qQ%[!tQ%f0cS'v%Z0hQ'x0eQ'y0fQ,p*rQ-u,qS.i-s/sR0p0rU#uq.k0qR(w&][cOn#g$j)t,PZ!xY#[#}$Q+YQ#W[Q#zrR$TxQ%b!yQ%i!}Q%o#RQ'j${Q(V%eQ(Z%jQ(c%pQ(f%qQ*|(`Q,f*bQ-t,pQ.m-uR/].lQ$StQ(R%cR*s(SQ.l-sR/}/sR#QZR#V[R%Q!iQ%O!iV*c'm*d,g!]!lQ!n#c#p$R$d$p$u$v$w$x$y$z%e%j%p%q&`'O'g(q(|)j*o*x+w,v/q0gR%T!kT#]^#_Q%x#[R,{+YQ(m%xS+_(n(oQ,}+`Q-x,{S.n-y-zR/^.oT+Z(k+]Q$`}Q&g$QQ)o'PR+{)pQ$XzQ)W&qR+i)XQ$XzQ&o$WQ)W&qR+i)XQ#khW$Vz$W&q)XQ$[{Q&r$ZZ)R&l)S+f+g-RR$^|R)c&wXlOn)t,PQ$f!RR'Q$gQ$m!UR'R$hR*X'_Q*V'_V-g,`-h.TQ.d-lQ/P.^R/Q._U.]-l.^._Q/U.aQ/b.tQ/g.zU/i.|/j/yQ/n/RQ/|/oQ0O/tU0Q/u0S0[Q0]0UQ0a0ZR0b0^R/T.`R/d.t",
    nodeNames: "\u26A0 print Escape { Comment Script AssignStatement * BinaryExpression BitOp BitOp BitOp BitOp ArithOp ArithOp @ ArithOp ** UnaryExpression ArithOp BitOp AwaitExpression await ) ( ParenthesizedExpression BinaryExpression or and CompareOp in not is UnaryExpression ConditionalExpression if else LambdaExpression lambda ParamList VariableName AssignOp , : NamedExpression AssignOp YieldExpression yield from TupleExpression ComprehensionExpression async for LambdaExpression ] [ ArrayExpression ArrayComprehensionExpression } { DictionaryExpression DictionaryComprehensionExpression SetExpression SetComprehensionExpression CallExpression ArgList AssignOp MemberExpression . PropertyName Number String FormatString FormatReplacement FormatSelfDoc FormatConversion FormatSpec FormatReplacement FormatSelfDoc ContinuedString Ellipsis None Boolean TypeDef AssignOp UpdateStatement UpdateOp ExpressionStatement DeleteStatement del PassStatement pass BreakStatement break ContinueStatement continue ReturnStatement return YieldStatement PrintStatement RaiseStatement raise ImportStatement import as ScopeStatement global nonlocal AssertStatement assert TypeDefinition type TypeParamList TypeParam StatementGroup ; IfStatement Body elif WhileStatement while ForStatement TryStatement try except finally WithStatement with FunctionDefinition def ParamList AssignOp TypeDef ClassDefinition class DecoratedStatement Decorator At MatchStatement match MatchBody MatchClause case CapturePattern LiteralPattern ArithOp ArithOp AsPattern OrPattern LogicOp AttributePattern SequencePattern MappingPattern StarPattern ClassPattern PatternArgList KeywordPattern KeywordPattern Guard",
    maxTerm: 277,
    context: $2bb9cf00b6309d75$var$trackIndent,
    nodeProps: [
        [
            "isolate",
            -5,
            4,
            71,
            72,
            73,
            77,
            ""
        ],
        [
            "group",
            -15,
            6,
            85,
            87,
            88,
            90,
            92,
            94,
            96,
            98,
            99,
            100,
            102,
            105,
            108,
            110,
            "Statement Statement",
            -22,
            8,
            18,
            21,
            25,
            40,
            49,
            50,
            56,
            57,
            60,
            61,
            62,
            63,
            64,
            67,
            70,
            71,
            72,
            79,
            80,
            81,
            82,
            "Expression",
            -10,
            114,
            116,
            119,
            121,
            122,
            126,
            128,
            133,
            135,
            138,
            "Statement",
            -9,
            143,
            144,
            147,
            148,
            150,
            151,
            152,
            153,
            154,
            "Pattern"
        ],
        [
            "openedBy",
            23,
            "(",
            54,
            "[",
            58,
            "{"
        ],
        [
            "closedBy",
            24,
            ")",
            55,
            "]",
            59,
            "}"
        ]
    ],
    propSources: [
        $2bb9cf00b6309d75$var$pythonHighlighting
    ],
    skippedNodes: [
        0,
        4
    ],
    repeatNodeCount: 34,
    tokenData: "!2|~R!`OX%TXY%oY[%T[]%o]p%Tpq%oqr'ars)Yst*xtu%Tuv,dvw-hwx.Uxy/tyz0[z{0r{|2S|}2p}!O3W!O!P4_!P!Q:Z!Q!R;k!R![>_![!]Do!]!^Es!^!_FZ!_!`Gk!`!aHX!a!b%T!b!cIf!c!dJU!d!eK^!e!hJU!h!i!#f!i!tJU!t!u!,|!u!wJU!w!x!.t!x!}JU!}#O!0S#O#P&o#P#Q!0j#Q#R!1Q#R#SJU#S#T%T#T#UJU#U#VK^#V#YJU#Y#Z!#f#Z#fJU#f#g!,|#g#iJU#i#j!.t#j#oJU#o#p!1n#p#q!1s#q#r!2a#r#s!2f#s$g%T$g;'SJU;'S;=`KW<%lOJU`%YT&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T`%lP;=`<%l%To%v]&n`%c_OX%TXY%oY[%T[]%o]p%Tpq%oq#O%T#O#P&o#P#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To&tX&n`OY%TYZ%oZ]%T]^%o^#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc'f[&n`O!_%T!_!`([!`#T%T#T#U(r#U#f%T#f#g(r#g#h(r#h#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc(cTmR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc(yT!mR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk)aV&n`&[ZOr%Trs)vs#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk){V&n`Or%Trs*bs#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk*iT&n`&^ZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To+PZS_&n`OY*xYZ%TZ]*x]^%T^#o*x#o#p+r#p#q*x#q#r+r#r;'S*x;'S;=`,^<%lO*x_+wTS_OY+rZ]+r^;'S+r;'S;=`,W<%lO+r_,ZP;=`<%l+ro,aP;=`<%l*xj,kV%rQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj-XT!xY&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj-oV%lQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk.]V&n`&ZZOw%Twx.rx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk.wV&n`Ow%Twx/^x#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk/eT&n`&]ZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk/{ThZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc0cTgR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk0yXVZ&n`Oz%Tz{1f{!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk1mVaR&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk2ZV%oZ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc2wTzR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To3_W%pZ&n`O!_%T!_!`-Q!`!a3w!a#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Td4OT&{S&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk4fX!fQ&n`O!O%T!O!P5R!P!Q%T!Q![6T![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk5WV&n`O!O%T!O!P5m!P#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk5tT!rZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti6[a!hX&n`O!Q%T!Q![6T![!g%T!g!h7a!h!l%T!l!m9s!m#R%T#R#S6T#S#X%T#X#Y7a#Y#^%T#^#_9s#_#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti7fZ&n`O{%T{|8X|}%T}!O8X!O!Q%T!Q![8s![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti8^V&n`O!Q%T!Q![8s![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti8z]!hX&n`O!Q%T!Q![8s![!l%T!l!m9s!m#R%T#R#S8s#S#^%T#^#_9s#_#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti9zT!hX&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk:bX%qR&n`O!P%T!P!Q:}!Q!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj;UV%sQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti;ro!hX&n`O!O%T!O!P=s!P!Q%T!Q![>_![!d%T!d!e?q!e!g%T!g!h7a!h!l%T!l!m9s!m!q%T!q!rA]!r!z%T!z!{Bq!{#R%T#R#S>_#S#U%T#U#V?q#V#X%T#X#Y7a#Y#^%T#^#_9s#_#c%T#c#dA]#d#l%T#l#mBq#m#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti=xV&n`O!Q%T!Q![6T![#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti>fc!hX&n`O!O%T!O!P=s!P!Q%T!Q![>_![!g%T!g!h7a!h!l%T!l!m9s!m#R%T#R#S>_#S#X%T#X#Y7a#Y#^%T#^#_9s#_#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti?vY&n`O!Q%T!Q!R@f!R!S@f!S#R%T#R#S@f#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Ti@mY!hX&n`O!Q%T!Q!R@f!R!S@f!S#R%T#R#S@f#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiAbX&n`O!Q%T!Q!YA}!Y#R%T#R#SA}#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiBUX!hX&n`O!Q%T!Q!YA}!Y#R%T#R#SA}#S#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiBv]&n`O!Q%T!Q![Co![!c%T!c!iCo!i#R%T#R#SCo#S#T%T#T#ZCo#Z#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TiCv]!hX&n`O!Q%T!Q![Co![!c%T!c!iCo!i#R%T#R#SCo#S#T%T#T#ZCo#Z#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%ToDvV{_&n`O!_%T!_!`E]!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TcEdT%{R&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkEzT#gZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkFbXmR&n`O!^%T!^!_F}!_!`([!`!a([!a#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TjGUV%mQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkGrV%zZ&n`O!_%T!_!`([!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkH`WmR&n`O!_%T!_!`([!`!aHx!a#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TjIPV%nQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkIoV_Q#}P&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%ToJ_]&n`&YS%uZO!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUoKZP;=`<%lJUoKge&n`&YS%uZOr%Trs)Ysw%Twx.Ux!Q%T!Q![JU![!c%T!c!tJU!t!uLx!u!}JU!}#R%T#R#SJU#S#T%T#T#fJU#f#gLx#g#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUoMRa&n`&YS%uZOr%TrsNWsw%Twx! vx!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUkN_V&n`&`ZOr%TrsNts#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%TkNyV&n`Or%Trs! `s#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk! gT&n`&bZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk! }V&n`&_ZOw%Twx!!dx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!!iV&n`Ow%Twx!#Ox#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!#VT&n`&aZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To!#oe&n`&YS%uZOr%Trs!%Qsw%Twx!&px!Q%T!Q![JU![!c%T!c!tJU!t!u!(`!u!}JU!}#R%T#R#SJU#S#T%T#T#fJU#f#g!(`#g#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUk!%XV&n`&dZOr%Trs!%ns#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!%sV&n`Or%Trs!&Ys#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!&aT&n`&fZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!&wV&n`&cZOw%Twx!'^x#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!'cV&n`Ow%Twx!'xx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!(PT&n`&eZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To!(ia&n`&YS%uZOr%Trs!)nsw%Twx!+^x!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUk!)uV&n`&hZOr%Trs!*[s#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!*aV&n`Or%Trs!*vs#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!*}T&n`&jZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!+eV&n`&gZOw%Twx!+zx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!,PV&n`Ow%Twx!,fx#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tk!,mT&n`&iZO#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%To!-Vi&n`&YS%uZOr%TrsNWsw%Twx! vx!Q%T!Q![JU![!c%T!c!dJU!d!eLx!e!hJU!h!i!(`!i!}JU!}#R%T#R#SJU#S#T%T#T#UJU#U#VLx#V#YJU#Y#Z!(`#Z#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUo!.}a&n`&YS%uZOr%Trs)Ysw%Twx.Ux!Q%T!Q![JU![!c%T!c!}JU!}#R%T#R#SJU#S#T%T#T#oJU#p#q%T#r$g%T$g;'SJU;'S;=`KW<%lOJUk!0ZT!XZ&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tc!0qT!WR&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%Tj!1XV%kQ&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T~!1sO!]~k!1zV%jR&n`O!_%T!_!`-Q!`#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T~!2fO![~i!2mT%tX&n`O#o%T#p#q%T#r;'S%T;'S;=`%i<%lO%T",
    tokenizers: [
        $2bb9cf00b6309d75$var$legacyPrint,
        $2bb9cf00b6309d75$var$indentation,
        $2bb9cf00b6309d75$var$newlines,
        $2bb9cf00b6309d75$var$strings,
        0,
        1,
        2,
        3,
        4
    ],
    topRules: {
        "Script": [
            0,
            5
        ]
    },
    specialized: [
        {
            term: 221,
            get: (value)=>$2bb9cf00b6309d75$var$spec_identifier[value] || -1
        }
    ],
    tokenPrec: 7652
});





const $3d5a662064fc0d8b$var$cache = /*@__PURE__*/ new (0, $ed739beecf769914$export$7f13b5dc44c541ae)();
const $3d5a662064fc0d8b$var$ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Body",
    "FunctionDefinition",
    "ClassDefinition",
    "LambdaExpression",
    "ForStatement",
    "MatchClause"
]);
function $3d5a662064fc0d8b$var$defID(type) {
    return (node, def, outer)=>{
        if (outer) return false;
        let id = node.node.getChild("VariableName");
        if (id) def(id, type);
        return true;
    };
}
const $3d5a662064fc0d8b$var$gatherCompletions = {
    FunctionDefinition: /*@__PURE__*/ $3d5a662064fc0d8b$var$defID("function"),
    ClassDefinition: /*@__PURE__*/ $3d5a662064fc0d8b$var$defID("class"),
    ForStatement (node, def, outer) {
        if (outer) for(let child = node.node.firstChild; child; child = child.nextSibling){
            if (child.name == "VariableName") def(child, "variable");
            else if (child.name == "in") break;
        }
    },
    ImportStatement (_node, def) {
        var _a, _b;
        let { node: node } = _node;
        let isFrom = ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.name) == "from";
        for(let ch = node.getChild("import"); ch; ch = ch.nextSibling)if (ch.name == "VariableName" && ((_b = ch.nextSibling) === null || _b === void 0 ? void 0 : _b.name) != "as") def(ch, isFrom ? "variable" : "namespace");
    },
    AssignStatement (node, def) {
        for(let child = node.node.firstChild; child; child = child.nextSibling){
            if (child.name == "VariableName") def(child, "variable");
            else if (child.name == ":" || child.name == "AssignOp") break;
        }
    },
    ParamList (node, def) {
        for(let prev = null, child = node.node.firstChild; child; child = child.nextSibling){
            if (child.name == "VariableName" && (!prev || !/\*|AssignOp/.test(prev.name))) def(child, "variable");
            prev = child;
        }
    },
    CapturePattern: /*@__PURE__*/ $3d5a662064fc0d8b$var$defID("variable"),
    AsPattern: /*@__PURE__*/ $3d5a662064fc0d8b$var$defID("variable"),
    __proto__: null
};
function $3d5a662064fc0d8b$var$getScope(doc, node) {
    let cached = $3d5a662064fc0d8b$var$cache.get(node);
    if (cached) return cached;
    let completions = [], top = true;
    function def(node, type) {
        let name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type: type
        });
    }
    node.cursor((0, $ed739beecf769914$export$b0e28367f55837aa).IncludeAnonymous).iterate((node)=>{
        if (node.name) {
            let gather = $3d5a662064fc0d8b$var$gatherCompletions[node.name];
            if (gather && gather(node, def, top) || !top && $3d5a662064fc0d8b$var$ScopeNodes.has(node.name)) return false;
            top = false;
        } else if (node.to - node.from > 8192) {
            // Allow caching for bigger internal nodes
            for (let c of $3d5a662064fc0d8b$var$getScope(doc, node.node))completions.push(c);
            return false;
        }
    });
    $3d5a662064fc0d8b$var$cache.set(node, completions);
    return completions;
}
const $3d5a662064fc0d8b$var$Identifier = /^[\w\xa1-\uffff][\w\d\xa1-\uffff]*$/;
const $3d5a662064fc0d8b$var$dontComplete = [
    "String",
    "FormatString",
    "Comment",
    "PropertyName"
];
/**
Completion source that looks up locally defined names in
Python code.
*/ function $3d5a662064fc0d8b$export$a2e0a5b87b9b861c(context) {
    let inner = (0, $a97ccac5cf5f4f5d$export$7fc98e56a4ca6be1)(context.state).resolveInner(context.pos, -1);
    if ($3d5a662064fc0d8b$var$dontComplete.indexOf(inner.name) > -1) return null;
    let isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && $3d5a662064fc0d8b$var$Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    let options = [];
    for(let pos = inner; pos; pos = pos.parent)if ($3d5a662064fc0d8b$var$ScopeNodes.has(pos.name)) options = options.concat($3d5a662064fc0d8b$var$getScope(context.state.doc, pos));
    return {
        options: options,
        from: isWord ? inner.from : context.pos,
        validFor: $3d5a662064fc0d8b$var$Identifier
    };
}
const $3d5a662064fc0d8b$var$globals = /*@__PURE__*/ [
    "__annotations__",
    "__builtins__",
    "__debug__",
    "__doc__",
    "__import__",
    "__name__",
    "__loader__",
    "__package__",
    "__spec__",
    "False",
    "None",
    "True"
].map((n)=>({
        label: n,
        type: "constant"
    })).concat(/*@__PURE__*/ [
    "ArithmeticError",
    "AssertionError",
    "AttributeError",
    "BaseException",
    "BlockingIOError",
    "BrokenPipeError",
    "BufferError",
    "BytesWarning",
    "ChildProcessError",
    "ConnectionAbortedError",
    "ConnectionError",
    "ConnectionRefusedError",
    "ConnectionResetError",
    "DeprecationWarning",
    "EOFError",
    "Ellipsis",
    "EncodingWarning",
    "EnvironmentError",
    "Exception",
    "FileExistsError",
    "FileNotFoundError",
    "FloatingPointError",
    "FutureWarning",
    "GeneratorExit",
    "IOError",
    "ImportError",
    "ImportWarning",
    "IndentationError",
    "IndexError",
    "InterruptedError",
    "IsADirectoryError",
    "KeyError",
    "KeyboardInterrupt",
    "LookupError",
    "MemoryError",
    "ModuleNotFoundError",
    "NameError",
    "NotADirectoryError",
    "NotImplemented",
    "NotImplementedError",
    "OSError",
    "OverflowError",
    "PendingDeprecationWarning",
    "PermissionError",
    "ProcessLookupError",
    "RecursionError",
    "ReferenceError",
    "ResourceWarning",
    "RuntimeError",
    "RuntimeWarning",
    "StopAsyncIteration",
    "StopIteration",
    "SyntaxError",
    "SyntaxWarning",
    "SystemError",
    "SystemExit",
    "TabError",
    "TimeoutError",
    "TypeError",
    "UnboundLocalError",
    "UnicodeDecodeError",
    "UnicodeEncodeError",
    "UnicodeError",
    "UnicodeTranslateError",
    "UnicodeWarning",
    "UserWarning",
    "ValueError",
    "Warning",
    "ZeroDivisionError"
].map((n)=>({
        label: n,
        type: "type"
    }))).concat(/*@__PURE__*/ [
    "bool",
    "bytearray",
    "bytes",
    "classmethod",
    "complex",
    "float",
    "frozenset",
    "int",
    "list",
    "map",
    "memoryview",
    "object",
    "range",
    "set",
    "staticmethod",
    "str",
    "super",
    "tuple",
    "type"
].map((n)=>({
        label: n,
        type: "class"
    }))).concat(/*@__PURE__*/ [
    "abs",
    "aiter",
    "all",
    "anext",
    "any",
    "ascii",
    "bin",
    "breakpoint",
    "callable",
    "chr",
    "compile",
    "delattr",
    "dict",
    "dir",
    "divmod",
    "enumerate",
    "eval",
    "exec",
    "exit",
    "filter",
    "format",
    "getattr",
    "globals",
    "hasattr",
    "hash",
    "help",
    "hex",
    "id",
    "input",
    "isinstance",
    "issubclass",
    "iter",
    "len",
    "license",
    "locals",
    "max",
    "min",
    "next",
    "oct",
    "open",
    "ord",
    "pow",
    "print",
    "property",
    "quit",
    "repr",
    "reversed",
    "round",
    "setattr",
    "slice",
    "sorted",
    "sum",
    "vars",
    "zip"
].map((n)=>({
        label: n,
        type: "function"
    })));
const $3d5a662064fc0d8b$var$snippets = [
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("def ${name}(${params}):\n	${}", {
        label: "def",
        detail: "function",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("for ${name} in ${collection}:\n	${}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("while ${}:\n	${}", {
        label: "while",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("try:\n	${}\nexcept ${error}:\n	${}", {
        label: "try",
        detail: "/ except block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("if ${}:\n	\n", {
        label: "if",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("if ${}:\n	${}\nelse:\n	${}", {
        label: "if",
        detail: "/ else block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("class ${name}:\n	def __init__(self, ${params}):\n			${}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("import ${module}", {
        label: "import",
        detail: "statement",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $7570a9a1a9679713$export$975ef56e648d23ad)("from ${module} import ${names}", {
        label: "from",
        detail: "import",
        type: "keyword"
    })
];
/**
Autocompletion for built-in Python globals and keywords.
*/ const $3d5a662064fc0d8b$export$e6aacc8077e6ec50 = /*@__PURE__*/ (0, $7570a9a1a9679713$export$1dfdaeb1e91714c0)($3d5a662064fc0d8b$var$dontComplete, /*@__PURE__*/ (0, $7570a9a1a9679713$export$db0ee7d2648a0c4b)(/*@__PURE__*/ $3d5a662064fc0d8b$var$globals.concat($3d5a662064fc0d8b$var$snippets)));
function $3d5a662064fc0d8b$var$innerBody(context) {
    let { node: node, pos: pos } = context;
    let lineIndent = context.lineIndent(pos, -1);
    let found = null;
    for(;;){
        let before = node.childBefore(pos);
        if (!before) break;
        else if (before.name == "Comment") pos = before.from;
        else if (before.name == "Body") {
            if (context.baseIndentFor(before) + context.unit <= lineIndent) found = before;
            node = before;
        } else if (before.type.is("Statement")) node = before;
        else break;
    }
    return found;
}
function $3d5a662064fc0d8b$var$indentBody(context, node) {
    let base = context.baseIndentFor(node);
    let line = context.lineAt(context.pos, -1), to = line.from + line.text.length;
    // Don't consider blank, deindented lines at the end of the
    // block part of the block
    if (/^\s*($|#)/.test(line.text) && context.node.to < to + 100 && !/\S/.test(context.state.sliceDoc(to, context.node.to)) && context.lineIndent(context.pos, -1) <= base) return null;
    // A normally deindenting keyword that appears at a higher
    // indentation than the block should probably be handled by the next
    // level
    if (/^\s*(else:|elif |except |finally:)/.test(context.textAfter) && context.lineIndent(context.pos, -1) > base) return null;
    return base + context.unit;
}
/**
A language provider based on the [Lezer Python
parser](https://github.com/lezer-parser/python), extended with
highlighting and indentation information.
*/ const $3d5a662064fc0d8b$export$14a84ed53f00030d = /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$b243968d9fb6db03).define({
    name: "python",
    parser: /*@__PURE__*/ (0, $2bb9cf00b6309d75$export$8f49e4af10703ce3).configure({
        props: [
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$72c7d4c52b3c6460).add({
                Body: (context)=>{
                    var _a;
                    let inner = $3d5a662064fc0d8b$var$innerBody(context);
                    return (_a = $3d5a662064fc0d8b$var$indentBody(context, inner || context.node)) !== null && _a !== void 0 ? _a : context.continue();
                },
                IfStatement: (cx)=>/^\s*(else:|elif )/.test(cx.textAfter) ? cx.baseIndent : cx.continue(),
                "ForStatement WhileStatement": (cx)=>/^\s*else:/.test(cx.textAfter) ? cx.baseIndent : cx.continue(),
                TryStatement: (cx)=>/^\s*(except |finally:|else:)/.test(cx.textAfter) ? cx.baseIndent : cx.continue(),
                "TupleExpression ComprehensionExpression ParamList ArgList ParenthesizedExpression": /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$60e82ea306899488)({
                    closing: ")"
                }),
                "DictionaryExpression DictionaryComprehensionExpression SetExpression SetComprehensionExpression": /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$60e82ea306899488)({
                    closing: "}"
                }),
                "ArrayExpression ArrayComprehensionExpression": /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$60e82ea306899488)({
                    closing: "]"
                }),
                "String FormatString": ()=>null,
                Script: (context)=>{
                    var _a;
                    let inner = $3d5a662064fc0d8b$var$innerBody(context);
                    return (_a = inner && $3d5a662064fc0d8b$var$indentBody(context, inner)) !== null && _a !== void 0 ? _a : context.continue();
                }
            }),
            /*@__PURE__*/ (0, $a97ccac5cf5f4f5d$export$9b075a85eb4377d8).add({
                "ArrayExpression DictionaryExpression SetExpression TupleExpression": (0, $a97ccac5cf5f4f5d$export$48672beae16a681b),
                Body: (node, state)=>({
                        from: node.from + 1,
                        to: node.to - (node.to == state.doc.length ? 0 : 1)
                    })
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "'''",
                '"""'
            ],
            stringPrefixes: [
                "f",
                "fr",
                "rf",
                "r",
                "u",
                "b",
                "br",
                "rb",
                "F",
                "FR",
                "RF",
                "R",
                "U",
                "B",
                "BR",
                "RB"
            ]
        },
        commentTokens: {
            line: "#"
        },
        indentOnInput: /^\s*([\}\]\)]|else:|elif |except |finally:)$/
    }
});
/**
Python language support.
*/ function $3d5a662064fc0d8b$export$3ccdad7705c71630() {
    return new (0, $a97ccac5cf5f4f5d$export$cbdefefa8a51dd3b)($3d5a662064fc0d8b$export$14a84ed53f00030d, [
        $3d5a662064fc0d8b$export$14a84ed53f00030d.data.of({
            autocomplete: $3d5a662064fc0d8b$export$a2e0a5b87b9b861c
        }),
        $3d5a662064fc0d8b$export$14a84ed53f00030d.data.of({
            autocomplete: $3d5a662064fc0d8b$export$e6aacc8077e6ec50
        })
    ]);
}


const $6c6cd973a530b75c$var$CodeDisplayElement = (props)=>{
    const { lineWrapping: lineWrapping, editable: editable } = (0, $7beee9608540d2c3$export$eece2fccabbb77c5);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $269cb9ebbcb83755$export$2e2bcd8739ae039), {
        onPointerDown: (e)=>e.stopPropagation(),
        style: {
            cursor: "text",
            whiteSpace: "pre-line",
            overflow: "auto",
            height: "300px"
        },
        value: props.data.currentCode,
        height: "300px",
        maxWidth: "100%",
        theme: "dark",
        extensions: [
            (0, $3d5a662064fc0d8b$export$3ccdad7705c71630)(),
            lineWrapping,
            editable.of(false)
        ],
        onWheel: (e)=>{
            e.stopPropagation();
        },
        onContextMenu: (e)=>{
            e.stopPropagation();
        }
    });
};
var $6c6cd973a530b75c$export$2e2bcd8739ae039 = $6c6cd973a530b75c$var$CodeDisplayElement;





class $f49a18cfb699f2ae$export$6f3ba425d7d3e976 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    update;
    width;
    height;
    currentCode;
    constructor(socket, update){
        super("Code Viewer");
        this.update = update;
        this.width = 700;
        this.height = 400;
        this.currentCode = "Connect a block";
        this.addControl("display", new (0, $e43c57db4a9e93f6$export$76f5e7e1abc7c58d)(this.currentCode));
        this.addInput("main", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Code input"));
    }
    getType() {
        return "CodeViewer";
    }
    getDisplayName() {
        return "Code Viewer";
    }
    data(inputs) {
        const previousNodes = inputs.main?.[0]?.previousNodes || [];
        const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodes);
        const mainData = inputs.main?.[0]?.code || [
            "Connect a block"
        ];
        if (inputs.main && importStatement) mainData[0] = importStatement;
        const displayValue = mainData.join("\n");
        this.controls.display.setValue(displayValue);
        const currentNodeData = {
            ...this,
            connectedPort: this.outputs.output
        };
        const output = {
            code: mainData,
            previousNodes: [
                ...previousNodes,
                currentNodeData
            ]
        };
        this.update("node", this);
        return {
            output: output
        };
    }
}



class $cf40b7ad0ce13c76$export$83e695320cf826d5 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    currentConsole;
    isLoading;
    constructor(currentConsole, isLoading){
        super();
        this.currentConsole = currentConsole;
        this.isLoading = isLoading;
    }
    setValue(console) {
        this.currentConsole = console;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
}



const $4e6b0038302d94d3$var$parseURLs = (code)=>{
    const updateCode = code.replace(/read_csv\(([^,)]+)(\,\s?)?(.*)?\)/, "read_csv(open_url($1)$2$3)");
    return updateCode;
};
const $4e6b0038302d94d3$var$injectUploadedDataset = (code, dataset)=>{
    const safeDataset = dataset.replace(/\n/g, "\\n").replace(/"/g, '\\"');
    const regex = /pd\.read_csv\((.*?)\)/;
    const updatedCode = code.replace(regex, `pd.read_csv(StringIO(\"\"\"${safeDataset}\"\"\"))`);
    return updatedCode;
};
const $4e6b0038302d94d3$var$getCodeGeneratedPlots = (code)=>{
    let plotCount = 0;
    const plotPaths = [];
    const parsedCode = code.replace(/(\w+)\.show\(\)/g, function(match, prefix) {
        plotCount += 1;
        const imagePath = `/tmp/figure${plotCount}.png`;
        plotPaths.push(imagePath);
        return `${prefix}.savefig("${imagePath}")`;
    });
    return {
        parsedCode: parsedCode,
        plotPaths: plotPaths
    };
};
const $4e6b0038302d94d3$var$displayCodeGeneratedPlots = (pyodide, plotPaths)=>{
    const plotsContainer = document.querySelector(".visualizerModal .plotsContainer");
    // Remove all children
    plotsContainer.innerHTML = "";
    const totalNumPlots = plotPaths.length;
    let currentIndex = 1;
    for (const path of plotPaths){
        const imageData = pyodide.FS.readFile(path, {
            encoding: "binary"
        });
        const blob = new Blob([
            imageData.buffer
        ], {
            type: "image/png"
        });
        // Create container for the image
        const singlePlotContainer = document.createElement("div");
        singlePlotContainer.className = "single-plot-container";
        singlePlotContainer.innerHTML = `
            <div class="plot-header">
                <h2>Plot ${currentIndex}/${totalNumPlots}</h2>
            </div>
            <img src="${URL.createObjectURL(blob)}" />
        `;
        // Add event listener to the button
        // const saveImageBtn = singlePlotContainer.querySelector("button");
        // addSaveImageEventListener(saveImageBtn, blob); // Make sure this function is defined
        // Append the new container to the images container
        plotsContainer.appendChild(singlePlotContainer);
        currentIndex++;
    }
};
const $4e6b0038302d94d3$var$processCodeGeneratedPlots = (pyodide, plotPaths)=>{
    const blobUrls = plotPaths.map((path)=>{
        const imageData = pyodide.FS.readFile(path, {
            encoding: "binary"
        });
        const blob = new Blob([
            imageData.buffer
        ], {
            type: "image/png"
        });
        return URL.createObjectURL(blob);
    });
    return blobUrls;
};
const $4e6b0038302d94d3$export$f9a73699f5f52645 = (codeSnippets)=>{
    const filteredCodeSnippets = codeSnippets.filter((snippet)=>!snippet.startsWith("#"));
    return filteredCodeSnippets.join("\n");
};
const $4e6b0038302d94d3$export$115dc2451863682d = function() {
    let instance = null;
    let isInitializing = false;
    let isRunning = false;
    let useUploadedDataset = false;
    let uploadedDataset = "";
    const queue = [];
    async function createInstance() {
        if (isInitializing || instance) return instance;
        isInitializing = true;
        instance = await window.loadPyodide({
            indexURL: "https://cdn.jsdelivr.net/pyodide/v0.24.1/full/",
            packages: [
                "numpy",
                "pandas",
                "matplotlib",
                "scipy",
                "scikit-learn"
            ]
        });
        await instance.loadPackage("micropip");
        const micropip = instance.pyimport("micropip");
        await micropip.install("seaborn");
        isInitializing = false;
        return instance;
    }
    return {
        getInstance: async function() {
            if (!instance) return await createInstance();
            return instance;
        },
        setDatasetSource: function(useUpload) {
            useUploadedDataset = useUpload;
        },
        saveUploadedDataset: function(dataset) {
            uploadedDataset = dataset;
        },
        runCode: async function(code) {
            return new Promise(async (resolve, reject)=>{
                const task = {
                    code: code,
                    resolve: resolve,
                    reject: reject
                };
                if (isRunning) queue.push(task);
                else {
                    isRunning = true;
                    await this.executeTask(task);
                }
            });
        },
        executeTask: async function(task) {
            const pyodide = await this.getInstance();
            try {
                await pyodide.loadPackagesFromImports(task.code);
                await pyodide.runPythonAsync(`
                    globals().clear()
                    import js
                    import io
                    import sys
                    from io import StringIO, BytesIO
                    import base64
                    sys.stdout = StringIO()

                    from pyodide.http import open_url
                `);
                let injectDatasetCode = "";
                if (useUploadedDataset) injectDatasetCode = $4e6b0038302d94d3$var$injectUploadedDataset(task.code, uploadedDataset);
                else injectDatasetCode = $4e6b0038302d94d3$var$parseURLs(task.code);
                const { parsedCode: parsedCode, plotPaths: plotPaths } = $4e6b0038302d94d3$var$getCodeGeneratedPlots(injectDatasetCode);
                const lastLineVariable = await pyodide.runPythonAsync(parsedCode);
                let consoleOutput = await pyodide.runPythonAsync("sys.stdout.getvalue()");
                let plots;
                if (plotPaths.length > 0) {
                    plots = $4e6b0038302d94d3$var$processCodeGeneratedPlots(pyodide, plotPaths);
                    const plotsMessage = `Plots generated: (${plotPaths.length}) - click the 'View Plots' button on the visualizer block to view the results.`;
                    consoleOutput = plotsMessage.concat(consoleOutput);
                }
                task.resolve({
                    success: true,
                    data: consoleOutput,
                    variable: lastLineVariable,
                    plots: plots
                });
            } catch (error) {
                task.resolve({
                    success: false,
                    data: `${error}`,
                    variable: null
                });
            } finally{
                if (queue.length > 0) this.executeTask(queue.shift());
                else isRunning = false;
            }
        }
    };
}();



class $810971140f72e2de$export$4bb420d367dd583f extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    update;
    width;
    height;
    currentConsole;
    isLoading;
    constructor(socket, update){
        super("Console Output");
        this.update = update;
        this.width = 700;
        this.height = 400;
        this.currentConsole = "# Connect code generating blocks to view console output";
        this.isLoading = false;
        this.#toggleLoading = (isLoading)=>{
            this.isLoading = isLoading;
            this.controls.display.setIsLoading(isLoading);
            this.update("node", this);
        };
        this.addControl("display", new (0, $cf40b7ad0ce13c76$export$83e695320cf826d5)(this.currentConsole, this.isLoading));
        this.addInput("input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Code input"));
    }
    getType() {
        return "ConsoleViewer";
    }
    getDisplayName() {
        return "Console Viewer";
    }
    #toggleLoading;
    async data(inputs) {
        const previousNodes = inputs.input?.[0]?.previousNodes || [];
        const codeInput = inputs.input?.[0].code || [];
        let totalCode = (0, $4e6b0038302d94d3$export$f9a73699f5f52645)(codeInput);
        let display = [
            this.currentConsole
        ];
        if (totalCode) {
            this.#toggleLoading(true);
            await (0, $cfadb87391ca5e26$export$a57e9bef4b3b52d0)(10);
            let consoleOutput = await (0, $4e6b0038302d94d3$export$115dc2451863682d).runCode(totalCode);
            if (consoleOutput.success) consoleOutput.data = "[Executed successfully \u2713]\n".concat(consoleOutput.data);
            this.controls.display.setValue(consoleOutput.data);
            this.#toggleLoading(false);
            display = [
                consoleOutput.data
            ];
        } else {
            this.controls.display.setValue(inputs.input ? "[No runnable code detected]" : this.currentConsole);
            this.update("node", this);
        }
        const currentNodeData = {
            ...this,
            connectedPort: this.outputs.output
        };
        const output = {
            code: codeInput,
            previousNodes: [
                ...previousNodes,
                currentNodeData
            ]
        };
        return {
            output: output
        };
    }
}




class $6c9ba8c8034ad685$export$a39bff1902b94c0b extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    value;
    useUploadedDataset;
    onChange;
    isValidCsvUrl;
    setDatasetColumns;
    uploadDataset;
    setDatasetSource;
    context;
    signalParseCsvComplete;
    adjustHeight;
    uploadedDataset;
    constructor(value, useUploadedDataset, onChange, isValidCsvUrl, setDatasetColumns, uploadDataset, setDatasetSource, context, signalParseCsvComplete, adjustHeight){
        super();
        this.value = value;
        this.useUploadedDataset = useUploadedDataset;
        this.onChange = onChange;
        this.isValidCsvUrl = isValidCsvUrl;
        this.setDatasetColumns = setDatasetColumns;
        this.uploadDataset = uploadDataset;
        this.setDatasetSource = setDatasetSource;
        this.context = context;
        this.signalParseCsvComplete = signalParseCsvComplete;
        this.adjustHeight = adjustHeight;
        this.uploadedDataset = {
            content: "",
            fileName: ""
        };
    }
    setValue(value) {
        this.value = value;
    }
    setUseUploadedDataset(useUploadedDataset) {
        this.useUploadedDataset = useUploadedDataset;
    }
    setUploadedDataset(content, fileName) {
        this.uploadedDataset = {
            content: content,
            fileName: fileName || ""
        };
    }
    setupControls(controlData) {
        this.value = controlData.value;
        this.useUploadedDataset = controlData.useUploadedDataset;
        this.uploadDataset(controlData.uploadedDataset?.content || "", controlData.uploadedDataset?.fileName || "");
    }
}




class $d8d53b6b0907a50a$export$97f07c7bed44aa64 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 400;
    height = 295;
    value = "https://raw.githubusercontent.com/datu-ca/dataset/main/classification/IRIS/data.csv";
    uploadedDataset = {
        content: "",
        fileName: ""
    };
    useUploadedDataset = true;
    datasetColumns = [];
    task_id = "createDatasetImporter";
    onParseCsvCompleteResolve;
    onParseCsvCompletePromise;
    change;
    update;
    constructor(socket, update, change, context){
        super("Import Dataset");
        this.addInput("input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Input"));
        this.addOutput("output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Dataset"));
        this.addControl("dataset_url", new (0, $6c9ba8c8034ad685$export$a39bff1902b94c0b)(this.value, this.useUploadedDataset, this.handleChange.bind(this), this.isValidCsvUrl.bind(this), this.setDatasetColumns.bind(this), this.handleUploadDataset.bind(this), this.handleSetDatasetSource.bind(this), context, this.signalParseCsvComplete.bind(this), this.adjustHeight.bind(this)));
        this.update = update;
        this.change = change;
        this.onParseCsvCompletePromise = new Promise((resolve)=>{
            this.onParseCsvCompleteResolve = resolve;
        });
    }
    getType() {
        return "DatasetImporter";
    }
    getDisplayName() {
        return "Dataset Importer";
    }
    signalParseCsvComplete() {
        this.onParseCsvCompleteResolve();
    }
    initializeParseCsvCompletionPromise() {
        this.onParseCsvCompletePromise = new Promise((resolve)=>{
            this.onParseCsvCompleteResolve = resolve;
        });
    }
    handleChange(value) {
        this.value = value;
        this.controls.dataset_url.setValue(value);
        this.change();
    }
    adjustHeight(height) {
        this.height = height;
        setTimeout(()=>{
            this.update("node", this);
        }, 100);
    }
    handleUploadDataset(dataset, fileName) {
        this.uploadedDataset.content = dataset;
        this.uploadedDataset.fileName = fileName || "";
        this.controls.dataset_url.setUploadedDataset(dataset, fileName);
        this.update("node", this);
    }
    setDatasetColumns(datasetColumns) {
        this.datasetColumns = [
            ...datasetColumns
        ];
        this.update("node", this);
        this.change();
    }
    getDatasetColumns() {
        return this.datasetColumns;
    }
    #uploadDataset(dataset) {
        (0, $4e6b0038302d94d3$export$115dc2451863682d).saveUploadedDataset(dataset);
    }
    handleSetDatasetSource(useUploadedDataset) {
        this.useUploadedDataset = useUploadedDataset;
        this.controls.dataset_url.setUseUploadedDataset(useUploadedDataset);
    // this.change();
    }
    #setDatasetSource(useUploadedDataset) {
        (0, $4e6b0038302d94d3$export$115dc2451863682d).setDatasetSource(useUploadedDataset);
    }
    isValidCsvUrl(url) {
        const urlPattern = new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i");
        if (!urlPattern.test(url)) return false;
        if (!url.toLowerCase().endsWith(".csv")) return false;
        return true;
    }
    async data(inputs) {
        let code = [];
        const inputConnection = inputs.input?.[0];
        if (inputConnection) code = [
            ...inputConnection.code
        ];
        this.#uploadDataset(this.uploadedDataset.content);
        this.#setDatasetSource(this.useUploadedDataset);
        const previousNodes = (0, $cfadb87391ca5e26$export$354e2109eb2648e0)(inputs.input ? inputs.input : []);
        const currentNode = {
            ...this,
            connectedPort: this.outputs.output
        };
        const output = {
            code: code,
            previousNodes: [
                ...previousNodes,
                currentNode
            ]
        };
        return {
            output: output
        };
    }
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






const $92631131e38a19f0$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary } = token;
    return {
        [componentCls]: {
            position: "absolute",
            background: "transparent",
            pointerEvents: "none",
            boxSizing: "border-box",
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            "&.wave-motion-appear": {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(","),
                "&-active": {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                "&.wave-quick": {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(",")
                }
            }
        }
    };
};
var $92631131e38a19f0$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$2e2bcd8739ae039)("Wave", (token)=>[
        $92631131e38a19f0$var$genWaveStyle(token)
    ]);



var $acw62 = parcelRequire("acw62");





const $ede16c18199d1556$export$23466a5792b7a5d3 = `${(0, $7ed5e10e08c170f8$export$e4ec87ea71f29b41)}-wave-target`;



var $acw62 = parcelRequire("acw62");








// Let compiler not to search module usage
var $db3659e597d7eb55$var$fullClone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $11492dca620dcaa5$exports);
var $db3659e597d7eb55$var$version = $db3659e597d7eb55$var$fullClone.version, $db3659e597d7eb55$var$reactRender = $db3659e597d7eb55$var$fullClone.render, $db3659e597d7eb55$var$unmountComponentAtNode = $db3659e597d7eb55$var$fullClone.unmountComponentAtNode;
var $db3659e597d7eb55$var$createRoot;
try {
    var $db3659e597d7eb55$var$mainVersion = Number(($db3659e597d7eb55$var$version || "").split(".")[0]);
    if ($db3659e597d7eb55$var$mainVersion >= 18) $db3659e597d7eb55$var$createRoot = $db3659e597d7eb55$var$fullClone.createRoot;
} catch (e) {
// Do nothing;
}
function $db3659e597d7eb55$var$toggleWarning(skip) {
    var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $db3659e597d7eb55$var$fullClone.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
}
var $db3659e597d7eb55$var$MARK = "__rc_react_root__";
// ========================== Render ==========================
function $db3659e597d7eb55$var$modernRender(node, container) {
    $db3659e597d7eb55$var$toggleWarning(true);
    var root = container[$db3659e597d7eb55$var$MARK] || $db3659e597d7eb55$var$createRoot(container);
    $db3659e597d7eb55$var$toggleWarning(false);
    root.render(node);
    container[$db3659e597d7eb55$var$MARK] = root;
}
function $db3659e597d7eb55$var$legacyRender(node, container) {
    $db3659e597d7eb55$var$reactRender(node, container);
}
function $db3659e597d7eb55$export$892c6608f54d7438(node, container) {}
function $db3659e597d7eb55$export$b3890eb0ae9dca99(node, container) {
    if ($db3659e597d7eb55$var$createRoot) {
        $db3659e597d7eb55$var$modernRender(node, container);
        return;
    }
    $db3659e597d7eb55$var$legacyRender(node, container);
}
// ========================= Unmount ==========================
function $db3659e597d7eb55$var$modernUnmount(_x) {
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_modernUnmount() {
    $db3659e597d7eb55$var$_modernUnmount = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee(container) {
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", Promise.resolve().then(function() {
                        var _container$MARK;
                        (_container$MARK = container[$db3659e597d7eb55$var$MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
                        delete container[$db3659e597d7eb55$var$MARK];
                    }));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $db3659e597d7eb55$var$_modernUnmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$legacyUnmount(container) {
    $db3659e597d7eb55$var$unmountComponentAtNode(container);
}
function $db3659e597d7eb55$export$fd39fe14445b207a(container) {}
function $db3659e597d7eb55$export$121e2d597d222bad(_x2) {
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}
function $db3659e597d7eb55$var$_unmount() {
    $db3659e597d7eb55$var$_unmount = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee2(container) {
        return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if (!($db3659e597d7eb55$var$createRoot !== undefined)) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", $db3659e597d7eb55$var$modernUnmount(container));
                case 2:
                    $db3659e597d7eb55$var$legacyUnmount(container);
                case 3:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $db3659e597d7eb55$var$_unmount.apply(this, arguments);
}




function $fc14acdc17dc0f28$export$1394a8dd73acd4cc(color) {
    // eslint-disable-next-line no-useless-escape
    const match = (color || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
    // biome-ignore lint/complexity/useOptionalChain: this is way is more simple
    if (match && match[1] && match[2] && match[3]) return !(match[1] === match[2] && match[2] === match[3]);
    return true;
}
function $fc14acdc17dc0f28$export$9d61ea039e87eb91(color) {
    return color && color !== "#fff" && color !== "#ffffff" && color !== "rgb(255, 255, 255)" && color !== "rgba(255, 255, 255, 1)" && $fc14acdc17dc0f28$export$1394a8dd73acd4cc(color) && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== "transparent";
}
function $fc14acdc17dc0f28$export$651d8e9c80304fc8(node) {
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = getComputedStyle(node);
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(borderTopColor)) return borderTopColor;
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(borderColor)) return borderColor;
    if ($fc14acdc17dc0f28$export$9d61ea039e87eb91(backgroundColor)) return backgroundColor;
    return null;
}


"use client";
function $1267f32cdb4173c5$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $1267f32cdb4173c5$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component } = props;
    const divRef = $acw62.useRef(null);
    const [color, setWaveColor] = $acw62.useState(null);
    const [borderRadius, setBorderRadius] = $acw62.useState([]);
    const [left, setLeft] = $acw62.useState(0);
    const [top, setTop] = $acw62.useState(0);
    const [width, setWidth] = $acw62.useState(0);
    const [height, setHeight] = $acw62.useState(0);
    const [enabled, setEnabled] = $acw62.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(" ")
    };
    if (color) waveStyle["--wave-color"] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $fc14acdc17dc0f28$export$651d8e9c80304fc8)(target));
        const isStatic = nodeStyle.position === "static";
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $1267f32cdb4173c5$var$validateNum(-parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $1267f32cdb4173c5$var$validateNum(-parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$1267f32cdb4173c5$var$validateNum(parseFloat(radius))));
    }
    $acw62.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== "undefined") {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(id);
                resizeObserver === null || resizeObserver === void 0 || resizeObserver.disconnect();
            };
        }
    }, []);
    if (!enabled) return null;
    const isSmallComponent = (component === "Checkbox" || component === "Radio") && (target === null || target === void 0 ? void 0 : target.classList.contains((0, $ede16c18199d1556$export$23466a5792b7a5d3)));
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            var _a;
            if (event.deadline || event.propertyName === "opacity") {
                const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
                (0, $db3659e597d7eb55$export$121e2d597d222bad)(holder).then(()=>{
                    holder === null || holder === void 0 || holder.remove();
                });
            }
            return false;
        }
    }, (_ref, ref)=>{
        let { className: motionClassName } = _ref;
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: (0, $5e297877593af644$export$ab452c34e8e05029)(divRef, ref),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, motionClassName, {
                "wave-quick": isSmallComponent
            }),
            style: waveStyle
        });
    });
};
const $1267f32cdb4173c5$var$showWaveEffect = (target, info)=>{
    var _a;
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === "Checkbox" && !((_a = target.querySelector("input")) === null || _a === void 0 ? void 0 : _a.checked)) return;
    // Create holder
    const holder = document.createElement("div");
    holder.style.position = "absolute";
    holder.style.left = "0px";
    holder.style.top = "0px";
    target === null || target === void 0 || target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
    (0, $db3659e597d7eb55$export$b3890eb0ae9dca99)(/*#__PURE__*/ $acw62.createElement($1267f32cdb4173c5$var$WaveEffect, Object.assign({}, info, {
        target: target
    })), holder);
};
var $1267f32cdb4173c5$export$2e2bcd8739ae039 = $1267f32cdb4173c5$var$showWaveEffect;


const $20c8c8dba0bc4c2d$var$useWave = (nodeRef, className, component)=>{
    const { wave: wave } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const showWave = (0, $01e43e72865dc583$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node) return;
        const targetNode = node.querySelector(`.${(0, $ede16c18199d1556$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $1267f32cdb4173c5$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId
        });
    });
    const rafId = $acw62.useRef();
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(rafId.current);
        rafId.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $20c8c8dba0bc4c2d$export$2e2bcd8739ae039 = $20c8c8dba0bc4c2d$var$useWave;


const $37e027257ee01609$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const containerRef = (0, $acw62.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls("wave");
    const [, hashId] = (0, $92631131e38a19f0$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $20c8c8dba0bc4c2d$export$2e2bcd8739ae039)(containerRef, (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, hashId), component);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== 1 || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $555b4eee2695f264$export$2e2bcd8739ae039)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute("disabled") || node.disabled || node.className.includes("disabled") || node.className.includes("-leave")) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener("click", onClick, true);
        return ()=>{
            node.removeEventListener("click", onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(children)) return children !== null && children !== void 0 ? children : null;
    const ref = (0, $5e297877593af644$export$c1cec34af06bcf7)(children) ? (0, $5e297877593af644$export$ab452c34e8e05029)(children.ref, containerRef) : containerRef;
    return (0, $30796c32f374b477$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $37e027257ee01609$export$2e2bcd8739ae039 = $37e027257ee01609$var$Wave;







var $acw62 = parcelRequire("acw62");




"use client";
var $981d7d04085c8929$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $981d7d04085c8929$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $acw62.createContext(undefined);
const $981d7d04085c8929$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className } = props, others = $981d7d04085c8929$var$__rest(props, [
        "prefixCls",
        "size",
        "className"
    ]);
    const prefixCls = getPrefixCls("btn-group", customizePrefixCls);
    const [, , hashId] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    let sizeCls = "";
    switch(size){
        case "large":
            sizeCls = "lg";
            break;
        case "small":
            sizeCls = "sm";
            break;
        default:
    }
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, hashId);
    return /*#__PURE__*/ $acw62.createElement($981d7d04085c8929$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        className: classes
    })));
};
var $981d7d04085c8929$export$2e2bcd8739ae039 = $981d7d04085c8929$var$ButtonGroup;



var $acw62 = parcelRequire("acw62");

"use client";
const $891d27b465b97c91$var$rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
const $891d27b465b97c91$export$c5dca2bf412dea0d = $891d27b465b97c91$var$rxTwoCNChar.test.bind($891d27b465b97c91$var$rxTwoCNChar);
function $891d27b465b97c91$export$19bc9a290855952(type) {
    if (type === "danger") return {
        danger: true
    };
    return {
        type: type
    };
}
function $891d27b465b97c91$export$844ec244b1367d54(str) {
    return typeof str === "string";
}
function $891d27b465b97c91$export$1085c0511270cee(type) {
    return type === "text" || type === "link";
}
function $891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted) {
    if (child === null || child === undefined) return;
    const SPACE = needInserted ? " " : "";
    if (typeof child !== "string" && typeof child !== "number" && $891d27b465b97c91$export$844ec244b1367d54(child.type) && $891d27b465b97c91$export$c5dca2bf412dea0d(child.props.children)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        children: child.props.children.split("").join(SPACE)
    });
    if ($891d27b465b97c91$export$844ec244b1367d54(child)) return $891d27b465b97c91$export$c5dca2bf412dea0d(child) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child.split("").join(SPACE)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child);
    if ((0, $30796c32f374b477$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, child);
    return child;
}
function $891d27b465b97c91$export$b6ee00a7e7908bc(children, needInserted) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === "string" || type === "number";
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(childList, (child)=>$891d27b465b97c91$var$splitCNCharsBySpace(child, needInserted));
}
const $891d27b465b97c91$var$ButtonTypes = [
    "default",
    "primary",
    "dashed",
    "link",
    "text"
];
const $891d27b465b97c91$var$ButtonShapes = [
    "default",
    "circle",
    "round"
];
const $891d27b465b97c91$var$ButtonHTMLTypes = [
    "submit",
    "button",
    "reset"
];



var $acw62 = parcelRequire("acw62");

"use client";
const $19bf9f13d1d4a6e4$var$IconWrapper = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $19bf9f13d1d4a6e4$export$2e2bcd8739ae039 = $19bf9f13d1d4a6e4$var$IconWrapper;



var $acw62 = parcelRequire("acw62");




"use client";
const $7597853c34b57de5$var$InnerLoadingIcon = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19bf9f13d1d4a6e4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $7597853c34b57de5$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: "scale(0)"
    });
const $7597853c34b57de5$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: "scale(1)"
    });
const $7597853c34b57de5$var$LoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7597853c34b57de5$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: visible,
        // We do not really use this motionName
        motionName: `${prefixCls}-loading-icon-motion`,
        motionLeave: visible,
        removeOnLeave: true,
        onAppearStart: $7597853c34b57de5$var$getCollapsedWidth,
        onAppearActive: $7597853c34b57de5$var$getRealWidth,
        onEnterStart: $7597853c34b57de5$var$getCollapsedWidth,
        onEnterActive: $7597853c34b57de5$var$getRealWidth,
        onLeaveStart: $7597853c34b57de5$var$getRealWidth,
        onLeaveActive: $7597853c34b57de5$var$getCollapsedWidth
    }, (_ref, ref)=>{
        let { className: motionCls, style: motionStyle } = _ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7597853c34b57de5$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: className,
            style: Object.assign(Object.assign({}, style), motionStyle),
            ref: ref,
            iconClassName: motionCls
        });
    });
};
var $7597853c34b57de5$export$2e2bcd8739ae039 = $7597853c34b57de5$var$LoadingIcon;





const $9b1a8aea1f437a60$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            "&:not(:last-child)": {
                [`&, & > ${buttonTypeCls}`]: {
                    "&:not(:disabled)": {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            "&:not(:first-child)": {
                [`&, & > ${buttonTypeCls}`]: {
                    "&:not(:disabled)": {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $9b1a8aea1f437a60$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: "relative",
                display: "inline-flex",
                // Border
                [`> span, > ${componentCls}`]: {
                    "&:not(:last-child)": {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    "&:not(:first-child)": {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: "relative",
                    zIndex: 1,
                    "&:hover, &:focus, &:active": {
                        zIndex: 2
                    },
                    "&[disabled]": {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $9b1a8aea1f437a60$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $9b1a8aea1f437a60$export$2e2bcd8739ae039 = $9b1a8aea1f437a60$var$genGroupStyle;



const $528e850af07e6ac9$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize, paddingBlock: paddingBlock } = token;
    const buttonToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: paddingBlock,
        buttonIconOnlyFontSize: onlyIconSize
    });
    return buttonToken;
};
const $528e850af07e6ac9$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c, _d, _e, _f;
    const contentFontSize = (_a = token.contentFontSize) !== null && _a !== void 0 ? _a : token.fontSize;
    const contentFontSizeSM = (_b = token.contentFontSizeSM) !== null && _b !== void 0 ? _b : token.fontSize;
    const contentFontSizeLG = (_c = token.contentFontSizeLG) !== null && _c !== void 0 ? _c : token.fontSizeLG;
    const contentLineHeight = (_d = token.contentLineHeight) !== null && _d !== void 0 ? _d : (0, $239826517175299d$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = (_e = token.contentLineHeightSM) !== null && _e !== void 0 ? _e : (0, $239826517175299d$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = (_f = token.contentLineHeightLG) !== null && _f !== void 0 ? _f : (0, $239826517175299d$export$56204a27a2958a55)(contentFontSizeLG);
    return {
        fontWeight: 400,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorder,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: "transparent",
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: token.fontSizeLG,
        onlyIconSizeSM: token.fontSizeLG - 2,
        onlyIconSizeLG: token.fontSizeLG + 2,
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: "transparent",
        textHoverBg: token.colorBgTextHover,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0)
    };
};


// ============================== Shared ==============================
const $3fa444975abc8ac9$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight } = token;
    return {
        [componentCls]: {
            outline: "none",
            position: "relative",
            display: "inline-flex",
            gap: token.marginXS,
            alignItems: "center",
            justifyContent: "center",
            fontWeight: fontWeight,
            whiteSpace: "nowrap",
            textAlign: "center",
            backgroundImage: "none",
            background: "transparent",
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            cursor: "pointer",
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: "none",
            touchAction: "manipulation",
            color: token.colorText,
            "&:disabled > *": {
                pointerEvents: "none"
            },
            "> span": {
                display: "inline-block"
            },
            [`${componentCls}-icon`]: {
                lineHeight: 1
            },
            "> a": {
                color: "currentColor"
            },
            "&:not(:disabled)": Object.assign({}, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: "0.34em"
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: "-0.34em",
                letterSpacing: "0.34em"
            },
            // iconPosition="end"
            "&-icon-end": {
                flexDirection: "row-reverse"
            }
        }
    };
};
const $3fa444975abc8ac9$var$genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle)=>({
        [`&:not(:disabled):not(${btnCls}-disabled)`]: {
            "&:hover": hoverStyle,
            "&:active": activeStyle
        }
    });
// ============================== Shape ===============================
const $3fa444975abc8ac9$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        borderRadius: "50%"
    });
const $3fa444975abc8ac9$var$genRoundButtonStyle = (token)=>({
        borderRadius: token.controlHeight,
        paddingInlineStart: token.calc(token.controlHeight).div(2).equal(),
        paddingInlineEnd: token.calc(token.controlHeight).div(2).equal()
    });
// =============================== Type ===============================
const $3fa444975abc8ac9$var$genDisabledStyle = (token)=>({
        cursor: "not-allowed",
        borderColor: token.borderColorDisabled,
        color: token.colorTextDisabled,
        background: token.colorBgContainerDisabled,
        boxShadow: "none"
    });
const $3fa444975abc8ac9$var$genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle)=>({
        [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
            color: textColor || undefined,
            background: background,
            borderColor: borderColor || undefined,
            boxShadow: "none"
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(btnCls, Object.assign({
            background: background
        }, hoverStyle), Object.assign({
            background: background
        }, activeStyle))), {
            "&:disabled": {
                cursor: "not-allowed",
                color: textColorDisabled || undefined,
                borderColor: borderColorDisabled || undefined
            }
        })
    });
const $3fa444975abc8ac9$var$genSolidDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: Object.assign({}, $3fa444975abc8ac9$var$genDisabledStyle(token))
    });
const $3fa444975abc8ac9$var$genSolidButtonStyle = (token)=>Object.assign({}, $3fa444975abc8ac9$var$genSolidDisabledButtonStyle(token));
const $3fa444975abc8ac9$var$genPureDisabledButtonStyle = (token)=>({
        [`&:disabled, &${token.componentCls}-disabled`]: {
            cursor: "not-allowed",
            color: token.colorTextDisabled
        }
    });
// Type: Default
const $3fa444975abc8ac9$var$genDefaultButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genSolidButtonStyle(token)), {
        background: token.defaultBg,
        borderColor: token.defaultBorderColor,
        color: token.defaultColor,
        boxShadow: token.defaultShadow
    }), $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.defaultHoverColor,
        borderColor: token.defaultHoverBorderColor,
        background: token.defaultHoverBg
    }, {
        color: token.defaultActiveColor,
        borderColor: token.defaultActiveBorderColor,
        background: token.defaultActiveBg
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.defaultGhostColor, token.defaultGhostBorderColor, token.colorTextDisabled, token.colorBorder)), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
            color: token.colorError,
            borderColor: token.colorError
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            color: token.colorErrorHover,
            borderColor: token.colorErrorBorderHover
        }, {
            color: token.colorErrorActive,
            borderColor: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder)), $3fa444975abc8ac9$var$genSolidDisabledButtonStyle(token))
    });
// Type: Primary
const $3fa444975abc8ac9$var$genPrimaryButtonStyle = (token)=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genSolidButtonStyle(token)), {
        color: token.primaryColor,
        background: token.colorPrimary,
        boxShadow: token.primaryShadow
    }), $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorTextLightSolid,
        background: token.colorPrimaryHover
    }, {
        color: token.colorTextLightSolid,
        background: token.colorPrimaryActive
    })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorPrimary, token.colorPrimary, token.colorTextDisabled, token.colorBorder, {
        color: token.colorPrimaryHover,
        borderColor: token.colorPrimaryHover
    }, {
        color: token.colorPrimaryActive,
        borderColor: token.colorPrimaryActive
    })), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
            background: token.colorError,
            boxShadow: token.dangerShadow,
            color: token.dangerColor
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            background: token.colorErrorHover
        }, {
            background: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorError, token.colorError, token.colorTextDisabled, token.colorBorder, {
            color: token.colorErrorHover,
            borderColor: token.colorErrorHover
        }, {
            color: token.colorErrorActive,
            borderColor: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genSolidDisabledButtonStyle(token))
    });
// Type: Dashed
const $3fa444975abc8ac9$var$genDashedButtonStyle = (token)=>Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genDefaultButtonStyle(token)), {
        borderStyle: "dashed"
    });
// Type: Link
const $3fa444975abc8ac9$var$genLinkButtonStyle = (token)=>Object.assign(Object.assign(Object.assign({
        color: token.colorLink
    }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorLinkHover,
        background: token.linkHoverBg
    }, {
        color: token.colorLinkActive
    })), $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token)), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign({
            color: token.colorError
        }, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            color: token.colorErrorHover
        }, {
            color: token.colorErrorActive
        })), $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token))
    });
// Type: Text
const $3fa444975abc8ac9$var$genTextButtonStyle = (token)=>Object.assign(Object.assign(Object.assign({}, $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
        color: token.colorText,
        background: token.textHoverBg
    }, {
        color: token.colorText,
        background: token.colorBgTextActive
    })), $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token)), {
        [`&${token.componentCls}-dangerous`]: Object.assign(Object.assign({
            color: token.colorError
        }, $3fa444975abc8ac9$var$genPureDisabledButtonStyle(token)), $3fa444975abc8ac9$var$genHoverActiveButtonStyle(token.componentCls, {
            color: token.colorErrorHover,
            background: token.colorErrorBg
        }, {
            color: token.colorErrorHover,
            background: token.colorErrorBgActive
        }))
    });
const $3fa444975abc8ac9$var$genTypeButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-default`]: $3fa444975abc8ac9$var$genDefaultButtonStyle(token),
        [`${componentCls}-primary`]: $3fa444975abc8ac9$var$genPrimaryButtonStyle(token),
        [`${componentCls}-dashed`]: $3fa444975abc8ac9$var$genDashedButtonStyle(token),
        [`${componentCls}-link`]: $3fa444975abc8ac9$var$genLinkButtonStyle(token),
        [`${componentCls}-text`]: $3fa444975abc8ac9$var$genTextButtonStyle(token),
        [`${componentCls}-ghost`]: $3fa444975abc8ac9$var$genGhostButtonStyle(token.componentCls, token.ghostBg, token.colorBgContainer, token.colorBgContainer, token.colorTextDisabled, token.colorBorder)
    };
};
// =============================== Size ===============================
const $3fa444975abc8ac9$var$genButtonStyle = function(token) {
    let prefixCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical } = token;
    const iconOnlyCls = `${componentCls}-icon-only`;
    return [
        {
            [`${prefixCls}`]: {
                fontSize: fontSize,
                lineHeight: lineHeight,
                height: controlHeight,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${iconOnlyCls}`]: {
                    width: controlHeight,
                    paddingInline: 0,
                    // make `btn-icon-only` not too narrow
                    [`&${componentCls}-compact-item`]: {
                        flex: "none"
                    },
                    [`&${componentCls}-round`]: {
                        width: "auto"
                    },
                    [iconCls]: {
                        fontSize: token.buttonIconOnlyFontSize
                    }
                },
                // Loading
                [`&${componentCls}-loading`]: {
                    opacity: token.opacityLoading,
                    cursor: "default"
                },
                [`${componentCls}-loading-icon`]: {
                    transition: `width ${token.motionDurationSlow} ${token.motionEaseInOut}, opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $3fa444975abc8ac9$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: $3fa444975abc8ac9$var$genRoundButtonStyle(token)
        }
    ];
};
const $3fa444975abc8ac9$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize,
        lineHeight: token.contentLineHeight
    });
    return $3fa444975abc8ac9$var$genButtonStyle(baseToken, token.componentCls);
};
const $3fa444975abc8ac9$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        lineHeight: token.contentLineHeightSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: token.paddingBlockSM,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $3fa444975abc8ac9$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $3fa444975abc8ac9$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        lineHeight: token.contentLineHeightLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: token.paddingBlockLG,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $3fa444975abc8ac9$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $3fa444975abc8ac9$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: "100%"
            }
        }
    };
};
var // ============================== Export ==============================
$3fa444975abc8ac9$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Button", (token)=>{
    const buttonToken = (0, $528e850af07e6ac9$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $3fa444975abc8ac9$var$genSharedButtonStyle(buttonToken),
        // Size
        $3fa444975abc8ac9$var$genSizeBaseButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeSmallButtonStyle(buttonToken),
        $3fa444975abc8ac9$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $3fa444975abc8ac9$var$genBlockButtonStyle(buttonToken),
        // Group (type, ghost, danger, loading)
        $3fa444975abc8ac9$var$genTypeButtonStyle(buttonToken),
        // Button Group
        (0, $9b1a8aea1f437a60$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $528e850af07e6ac9$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// Style as inline component


function $6ef3f73594535ba5$var$compactItemVerticalBorder(token, parentCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        "&-item": {
            "&:hover,&:focus,&:active": {
                zIndex: 2
            },
            "&[disabled]": {
                zIndex: 0
            }
        }
    };
}
function $6ef3f73594535ba5$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $6ef3f73594535ba5$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: Object.assign(Object.assign({}, $6ef3f73594535ba5$var$compactItemVerticalBorder(token, compactCls)), $6ef3f73594535ba5$var$compactItemBorderVerticalRadius(token.componentCls, compactCls))
    };
}




const $d5babcd62cf57d30$var$genButtonCompactStyle = (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    return {
        [componentCls]: {
            // Special styles for Primary Button
            [`&-compact-item${componentCls}-primary`]: {
                [`&:not([disabled]) + ${componentCls}-compact-item${componentCls}-primary:not([disabled])`]: {
                    position: "relative",
                    "&:before": {
                        position: "absolute",
                        top: calc(token.lineWidth).mul(-1).equal(),
                        insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
                        display: "inline-block",
                        width: token.lineWidth,
                        height: `calc(100% + ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} * 2)`,
                        backgroundColor: token.colorPrimaryHover,
                        content: '""'
                    }
                }
            },
            // Special styles for Primary Button
            "&-compact-vertical-item": {
                [`&${componentCls}-primary`]: {
                    [`&:not([disabled]) + ${componentCls}-compact-vertical-item${componentCls}-primary:not([disabled])`]: {
                        position: "relative",
                        "&:before": {
                            position: "absolute",
                            top: calc(token.lineWidth).mul(-1).equal(),
                            insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
                            display: "inline-block",
                            width: `calc(100% + ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} * 2)`,
                            height: token.lineWidth,
                            backgroundColor: token.colorPrimaryHover,
                            content: '""'
                        }
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$d5babcd62cf57d30$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$1537386bc155ea56)([
    "Button",
    "compact"
], (token)=>{
    const buttonToken = (0, $528e850af07e6ac9$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(buttonToken),
        (0, $6ef3f73594535ba5$export$4dc87cb8ebf78ac6)(buttonToken),
        $d5babcd62cf57d30$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $528e850af07e6ac9$export$9ca1be8807fe0675));


"use client";
var $c6609c7ee777e096$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c6609c7ee777e096$var$getLoadingConfig(loading) {
    if (typeof loading === "object" && loading) {
        let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
        delay = !Number.isNaN(delay) && typeof delay === "number" ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $c6609c7ee777e096$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    var _a, _b, _c;
    const { loading: loading = false, prefixCls: customizePrefixCls, type: type, danger: danger = false, shape: shape = "default", size: customizeSize, styles: styles, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition = "start", ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = "button", classNames: customClassNames, style: customStyle = {}, autoInsertSpace: autoInsertSpace } = props, rest = $c6609c7ee777e096$var$__rest(props, [
        "loading",
        "prefixCls",
        "type",
        "danger",
        "shape",
        "size",
        "styles",
        "disabled",
        "className",
        "rootClassName",
        "children",
        "icon",
        "iconPosition",
        "ghost",
        "block",
        "htmlType",
        "classNames",
        "style",
        "autoInsertSpace"
    ]);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || "default";
    const { getPrefixCls: getPrefixCls, direction: direction, button: button } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const mergedInsertSpace = (_a = autoInsertSpace !== null && autoInsertSpace !== void 0 ? autoInsertSpace : button === null || button === void 0 ? void 0 : button.autoInsertSpace) !== null && _a !== void 0 ? _a : true;
    const prefixCls = getPrefixCls("btn", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3fa444975abc8ac9$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $acw62.useContext)((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const groupSize = (0, $acw62.useContext)((0, $981d7d04085c8929$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $acw62.useMemo)(()=>$c6609c7ee777e096$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, $acw62.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $acw62.useState)(false);
    const internalRef = /*#__PURE__*/ (0, $acw62.createRef)();
    const buttonRef = (0, $5e297877593af644$export$ab452c34e8e05029)(ref, internalRef);
    const needInserted = (0, $acw62.Children).count(children) === 1 && !icon && !(0, $891d27b465b97c91$export$1085c0511270cee)(mergedType);
    (0, $acw62.useEffect)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay
    ]);
    (0, $acw62.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef || !buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent;
        if (needInserted && (0, $891d27b465b97c91$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    }, [
        buttonRef
    ]);
    const handleClick = (e)=>{
        const { onClick: onClick } = props;
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeClassNameMap = {
        large: "lg",
        small: "sm",
        middle: undefined
    };
    const sizeFullName = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctxSize)=>{
        var _a, _b;
        return (_b = (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : groupSize) !== null && _b !== void 0 ? _b : ctxSize;
    });
    const sizeCls = sizeFullName ? sizeClassNameMap[sizeFullName] || "" : "";
    const iconType = innerLoading ? "loading" : icon;
    const linkButtonRestProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(rest, [
        "navigate"
    ]);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== "default" && shape,
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $891d27b465b97c91$export$1085c0511270cee)(mergedType),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-icon-end`]: iconPosition === "end"
    }, compactItemClassnames, className, rootClassName, button === null || button === void 0 ? void 0 : button.className);
    const fullStyle = Object.assign(Object.assign({}, button === null || button === void 0 ? void 0 : button.style), customStyle);
    const iconClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, (_b = button === null || button === void 0 ? void 0 : button.classNames) === null || _b === void 0 ? void 0 : _b.icon);
    const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), ((_c = button === null || button === void 0 ? void 0 : button.styles) === null || _c === void 0 ? void 0 : _c.icon) || {});
    const iconNode = icon && !innerLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19bf9f13d1d4a6e4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: iconClasses,
        style: iconStyle
    }, icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7597853c34b57de5$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading
    });
    const kids = children || children === 0 ? (0, $891d27b465b97c91$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace) : null;
    if (linkButtonRestProps.href !== undefined) return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({}, linkButtonRestProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: buttonRef,
        tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, rest, {
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: buttonRef
    }), iconNode, kids, !!compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d5babcd62cf57d30$export$2e2bcd8739ae039), {
        key: "compact",
        prefixCls: prefixCls
    }));
    if (!(0, $891d27b465b97c91$export$1085c0511270cee)(mergedType)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return wrapCSSVar(buttonNode);
});
const $c6609c7ee777e096$var$Button = $c6609c7ee777e096$var$InternalCompoundedButton;
$c6609c7ee777e096$var$Button.Group = (0, $981d7d04085c8929$export$2e2bcd8739ae039);
$c6609c7ee777e096$var$Button.__ANT_BUTTON = true;
var $c6609c7ee777e096$export$2e2bcd8739ae039 = $c6609c7ee777e096$var$Button;



"use client";
var $3929aafb948ac62c$export$2e2bcd8739ae039 = (0, $c6609c7ee777e096$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");


function $cf0f554ddf4da10f$export$f5153c3888a6824e(size) {
    return [
        "small",
        "middle",
        "large"
    ].includes(size);
}
function $cf0f554ddf4da10f$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === "number" && !Number.isNaN(size);
}





const $456fd1d46e9f26d7$export$6773a72e15c6c21d = [
    "wrap",
    "nowrap",
    "wrap-reverse"
];
const $456fd1d46e9f26d7$export$fc1ed670ad7f670d = [
    "flex-start",
    "flex-end",
    "start",
    "end",
    "center",
    "space-between",
    "space-around",
    "space-evenly",
    "stretch",
    "normal",
    "left",
    "right"
];
const $456fd1d46e9f26d7$export$4a0bd4174fc92cb3 = [
    "center",
    "start",
    "end",
    "flex-start",
    "flex-end",
    "self-start",
    "self-end",
    "baseline",
    "normal",
    "stretch"
];
const $456fd1d46e9f26d7$var$genClsWrap = (prefixCls, props)=>{
    const wrap = props.wrap === true ? "wrap" : props.wrap;
    return {
        [`${prefixCls}-wrap-${wrap}`]: wrap && $456fd1d46e9f26d7$export$6773a72e15c6c21d.includes(wrap)
    };
};
const $456fd1d46e9f26d7$var$genClsAlign = (prefixCls, props)=>{
    const alignCls = {};
    $456fd1d46e9f26d7$export$4a0bd4174fc92cb3.forEach((cssKey)=>{
        alignCls[`${prefixCls}-align-${cssKey}`] = props.align === cssKey;
    });
    alignCls[`${prefixCls}-align-stretch`] = !props.align && !!props.vertical;
    return alignCls;
};
const $456fd1d46e9f26d7$var$genClsJustify = (prefixCls, props)=>{
    const justifyCls = {};
    $456fd1d46e9f26d7$export$fc1ed670ad7f670d.forEach((cssKey)=>{
        justifyCls[`${prefixCls}-justify-${cssKey}`] = props.justify === cssKey;
    });
    return justifyCls;
};
function $456fd1d46e9f26d7$var$createFlexClassNames(prefixCls, props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(Object.assign(Object.assign(Object.assign({}, $456fd1d46e9f26d7$var$genClsWrap(prefixCls, props)), $456fd1d46e9f26d7$var$genClsAlign(prefixCls, props)), $456fd1d46e9f26d7$var$genClsJustify(prefixCls, props)));
}
var $456fd1d46e9f26d7$export$2e2bcd8739ae039 = $456fd1d46e9f26d7$var$createFlexClassNames;


const $63ea37159c444462$var$genFlexStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: "flex",
            "&-vertical": {
                flexDirection: "column"
            },
            "&-rtl": {
                direction: "rtl"
            },
            "&:empty": {
                display: "none"
            }
        }
    };
};
const $63ea37159c444462$var$genFlexGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-gap-small": {
                gap: token.flexGapSM
            },
            "&-gap-middle": {
                gap: token.flexGap
            },
            "&-gap-large": {
                gap: token.flexGapLG
            }
        }
    };
};
const $63ea37159c444462$var$genFlexWrapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const wrapStyle = {};
    (0, $456fd1d46e9f26d7$export$6773a72e15c6c21d).forEach((value)=>{
        wrapStyle[`${componentCls}-wrap-${value}`] = {
            flexWrap: value
        };
    });
    return wrapStyle;
};
const $63ea37159c444462$var$genAlignItemsStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const alignStyle = {};
    (0, $456fd1d46e9f26d7$export$4a0bd4174fc92cb3).forEach((value)=>{
        alignStyle[`${componentCls}-align-${value}`] = {
            alignItems: value
        };
    });
    return alignStyle;
};
const $63ea37159c444462$var$genJustifyContentStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const justifyStyle = {};
    (0, $456fd1d46e9f26d7$export$fc1ed670ad7f670d).forEach((value)=>{
        justifyStyle[`${componentCls}-justify-${value}`] = {
            justifyContent: value
        };
    });
    return justifyStyle;
};
const $63ea37159c444462$export$9ca1be8807fe0675 = ()=>({});
var $63ea37159c444462$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Flex", (token)=>{
    const { paddingXS: paddingXS, padding: padding, paddingLG: paddingLG } = token;
    const flexToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        flexGapSM: paddingXS,
        flexGap: padding,
        flexGapLG: paddingLG
    });
    return [
        $63ea37159c444462$var$genFlexStyle(flexToken),
        $63ea37159c444462$var$genFlexGapStyle(flexToken),
        $63ea37159c444462$var$genFlexWrapStyle(flexToken),
        $63ea37159c444462$var$genAlignItemsStyle(flexToken),
        $63ea37159c444462$var$genJustifyContentStyle(flexToken)
    ];
}, $63ea37159c444462$export$9ca1be8807fe0675, {
    // Flex component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/46403
    resetStyle: false
});



"use client";
var $c7119f916fc54765$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c7119f916fc54765$var$Flex = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, rootClassName: rootClassName, className: className, style: style, flex: flex, gap: gap, children: children, vertical: vertical = false, component: Component = "div" } = props, othersProps = $c7119f916fc54765$var$__rest(props, [
        "prefixCls",
        "rootClassName",
        "className",
        "style",
        "flex",
        "gap",
        "children",
        "vertical",
        "component"
    ]);
    const { flex: ctxFlex, direction: ctxDirection, getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("flex", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $63ea37159c444462$export$2e2bcd8739ae039)(prefixCls);
    const mergedVertical = vertical !== null && vertical !== void 0 ? vertical : ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.vertical;
    const mergedCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, rootClassName, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.className, prefixCls, hashId, cssVarCls, (0, $456fd1d46e9f26d7$export$2e2bcd8739ae039)(prefixCls, props), {
        [`${prefixCls}-rtl`]: ctxDirection === "rtl",
        [`${prefixCls}-gap-${gap}`]: (0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(gap),
        [`${prefixCls}-vertical`]: mergedVertical
    });
    const mergedStyle = Object.assign(Object.assign({}, ctxFlex === null || ctxFlex === void 0 ? void 0 : ctxFlex.style), style);
    if (flex) mergedStyle.flex = flex;
    if (gap && !(0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(gap)) mergedStyle.gap = gap;
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, Object.assign({
        ref: ref,
        className: mergedCls,
        style: mergedStyle
    }, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(othersProps, [
        "justify",
        "wrap",
        "align"
    ])), children));
});
var $c7119f916fc54765$export$2e2bcd8739ae039 = $c7119f916fc54765$var$Flex;


var $acw62 = parcelRequire("acw62");





"use client";
const $ae15c91e7f32cbed$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls("input-group", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input");
    const [wrapCSSVar, hashId] = (0, $232788b5c0fca573$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-lg`]: props.size === "large",
        [`${prefixCls}-sm`]: props.size === "small",
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, hashId, className);
    const formItemContext = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $acw62.useMemo)(()=>Object.assign(Object.assign({}, formItemContext), {
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, props.children)));
};
var $ae15c91e7f32cbed$export$2e2bcd8739ae039 = $ae15c91e7f32cbed$var$Group;



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
function $fd5fdd8da073bd4e$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $fd5fdd8da073bd4e$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $fd5fdd8da073bd4e$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    var currentTarget = target.cloneNode(true);
    // click clear icon
    var newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === "number" && typeof target.selectionEnd === "number") {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = function() {
        target.setSelectionRange.apply(target, arguments);
    };
    return newEvent;
}
function $fd5fdd8da073bd4e$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    var event = e;
    if (e.type === "click") {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $fd5fdd8da073bd4e$var$cloneEvent(e, target, "");
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== "file" && targetValue !== undefined) {
        event = $fd5fdd8da073bd4e$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}
function $fd5fdd8da073bd4e$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    var _ref = option || {}, cursor = _ref.cursor;
    if (cursor) {
        var len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}


var $32a5e8fad29dc207$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var _element$props, _element$props2;
    var inputEl = props.inputElement, children = props.children, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components;
    var inputElement = children !== null && children !== void 0 ? children : inputEl;
    var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || "span";
    var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || "span";
    var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || "span";
    var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || "span";
    var containerRef = (0, $acw62.useRef)(null);
    var onInputClick = function onInputClick(e) {
        var _containerRef$current;
        if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) triggerFocus === null || triggerFocus === void 0 || triggerFocus();
    };
    var hasAffix = (0, $fd5fdd8da073bd4e$export$a19010aeeaa0c7a)(props);
    var element = /*#__PURE__*/ (0, $acw62.cloneElement)(inputElement, {
        value: value,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(inputElement.props.className, !hasAffix && (classNames === null || classNames === void 0 ? void 0 : classNames.variant)) || null
    });
    // ======================== Ref ======================== //
    var groupRef = (0, $acw62.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            nativeElement: groupRef.current || containerRef.current
        };
    });
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        var _clsx2;
        // ================== Clear Icon ================== //
        var clearIcon = null;
        if (allowClear) {
            var _clsx;
            var needClear = !disabled && !readOnly && value;
            var clearIconCls = "".concat(prefixCls, "-clear-icon");
            var iconNode = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(allowClear) === "object" && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                onClick: handleReset,
                onMouseDown: function onMouseDown(e) {
                    return e.preventDefault();
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(clearIconCls, (_clsx = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx, "".concat(clearIconCls, "-hidden"), !needClear), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx, "".concat(clearIconCls, "-has-suffix"), !!suffix), _clsx)),
                role: "button",
                tabIndex: -1
            }, iconNode);
        }
        var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
        var affixWrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(affixWrapperPrefixCls, (_clsx2 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx2, "".concat(prefixCls, "-disabled"), disabled), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-focused"), focused), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _clsx2), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, classNames === null || classNames === void 0 ? void 0 : classNames.variant);
        var suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-suffix"), classNames === null || classNames === void 0 ? void 0 : classNames.suffix),
            style: styles === null || styles === void 0 ? void 0 : styles.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AffixWrapperComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: affixWrapperCls,
            style: styles === null || styles === void 0 ? void 0 : styles.affixWrapper,
            onClick: onInputClick
        }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-prefix"), classNames === null || classNames === void 0 ? void 0 : classNames.prefix),
            style: styles === null || styles === void 0 ? void 0 : styles.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $fd5fdd8da073bd4e$export$ae6255aa850a31d1)(props)) {
        var wrapperCls = "".concat(prefixCls, "-group");
        var addonCls = "".concat(wrapperCls, "-addon");
        var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
        var mergedWrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames === null || classNames === void 0 ? void 0 : classNames.wrapper);
        var mergedGroupClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(groupWrapperCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames === null || classNames === void 0 ? void 0 : classNames.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_element$props = element.props) === null || _element$props === void 0 ? void 0 : _element$props.className, className) || null,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (_element$props2 = element.props) === null || _element$props2 === void 0 ? void 0 : _element$props2.style), style),
        hidden: hidden
    });
});
var $32a5e8fad29dc207$export$2e2bcd8739ae039 = $32a5e8fad29dc207$var$BaseInput;












var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
var $8d507ba491af0684$var$_excluded = [
    "show"
];
function $8d507ba491af0684$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    var count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $8d507ba491af0684$export$2e2bcd8739ae039(count, showCount) {
    return $acw62.useMemo(function() {
        var mergedConfig = {};
        if (showCount) mergedConfig.show = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(showCount) === "object" && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedConfig), count);
        var _ref = mergedConfig, show = _ref.show, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $8d507ba491af0684$var$_excluded);
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rest), {}, {
            show: !!show,
            showFormatter: typeof show === "function" ? show : undefined,
            strategy: rest.strategy || function(value) {
                return value.length;
            }
        });
    }, [
        count,
        showCount
    ]);
}



var $9cda19a001f87ecf$var$_excluded = [
    "autoComplete",
    "onChange",
    "onFocus",
    "onBlur",
    "onPressEnter",
    "onKeyDown",
    "prefixCls",
    "disabled",
    "htmlSize",
    "className",
    "maxLength",
    "suffix",
    "showCount",
    "count",
    "type",
    "classes",
    "classNames",
    "styles",
    "onCompositionStart",
    "onCompositionEnd"
];
var $9cda19a001f87ecf$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var autoComplete = props.autoComplete, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, onPressEnter = props.onPressEnter, onKeyDown = props.onKeyDown, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input" : _props$prefixCls, disabled = props.disabled, htmlSize = props.htmlSize, className = props.className, maxLength = props.maxLength, suffix = props.suffix, showCount = props.showCount, count = props.count, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, classes = props.classes, classNames = props.classNames, styles = props.styles, _onCompositionStart = props.onCompositionStart, onCompositionEnd = props.onCompositionEnd, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $9cda19a001f87ecf$var$_excluded);
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var compositionRef = (0, $acw62.useRef)(false);
    var inputRef = (0, $acw62.useRef)(null);
    var holderRef = (0, $acw62.useRef)(null);
    var focus = function focus(option) {
        if (inputRef.current) (0, $fd5fdd8da073bd4e$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(props.defaultValue, {
        value: props.value
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? "" : String(value);
    // =================== Select Range ===================
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), selection = _useState4[0], setSelection = _useState4[1];
    // ====================== Count =======================
    var countConfig = (0, $8d507ba491af0684$export$2e2bcd8739ae039)(count, showCount);
    var mergedMax = countConfig.max || maxLength;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, $acw62.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            focus: focus,
            blur: function blur() {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
            },
            setSelectionRange: function setSelectionRange(start, end, direction) {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.setSelectionRange(start, end, direction);
            },
            select: function select() {
                var _inputRef$current3;
                (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.select();
            },
            input: inputRef.current,
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || inputRef.current
        };
    });
    (0, $acw62.useEffect)(function() {
        setFocused(function(prev) {
            return prev && disabled ? false : prev;
        });
    }, [
        disabled
    ]);
    var triggerChange = function triggerChange(e, currentValue, info) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) {
                var _inputRef$current4, _inputRef$current5;
                setSelection([
                    ((_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 ? void 0 : _inputRef$current4.selectionStart) || 0,
                    ((_inputRef$current5 = inputRef.current) === null || _inputRef$current5 === void 0 ? void 0 : _inputRef$current5.selectionEnd) || 0
                ]);
            }
        } else if (info.source === "compositionEnd") // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    (0, $acw62.useEffect)(function() {
        if (selection) {
            var _inputRef$current6;
            (_inputRef$current6 = inputRef.current) === null || _inputRef$current6 === void 0 || _inputRef$current6.setSelectionRange.apply(_inputRef$current6, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selection));
        }
    }, [
        selection
    ]);
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value, {
            source: "change"
        });
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: "compositionEnd"
        });
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (onPressEnter && e.key === "Enter") onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    var handleReset = function handleReset(e) {
        setValue("");
        focus();
        if (inputRef.current) (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    var outOfRangeCls = isOutOfRange && "".concat(prefixCls, "-out-of-range");
    var getInputElement = function getInputElement() {
        // Fix https://fb.me/react-unknown-prop
        var otherProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
            "prefixCls",
            "onPressEnter",
            "addonBefore",
            "addonAfter",
            "prefix",
            "suffix",
            "allowClear",
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            "defaultValue",
            "showCount",
            "count",
            "classes",
            "htmlSize",
            "styles",
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled), classNames === null || classNames === void 0 ? void 0 : classNames.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: function onCompositionStart(e) {
                compositionRef.current = true;
                _onCompositionStart === null || _onCompositionStart === void 0 || _onCompositionStart(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    var getSuffix = function getSuffix() {
        // Max length value
        var hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            var dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-show-count-suffix"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-count-has-suffix"), !!suffix), classNames === null || classNames === void 0 ? void 0 : classNames.count),
                style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, styles === null || styles === void 0 ? void 0 : styles.count)
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32a5e8fad29dc207$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles
    }), getInputElement());
});
var $9cda19a001f87ecf$export$2e2bcd8739ae039 = $9cda19a001f87ecf$var$Input;


var $93b8a86f8ed15614$export$2e2bcd8739ae039 = (0, $9cda19a001f87ecf$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");


"use client";
const $894cbe2fb0245b19$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (children === undefined || children === null) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad5d550b51ac8abd$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $26050ef76e24a749$export$5f56e610a4afb685), null, result);
    return result;
};
var $894cbe2fb0245b19$export$2e2bcd8739ae039 = $894cbe2fb0245b19$var$ContextIsolator;



var $acw62 = parcelRequire("acw62");

"use client";
const $f9fe093fa4df8f6d$var$getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null)
    };
    return mergedAllowClear;
};
var $f9fe093fa4df8f6d$export$2e2bcd8739ae039 = $f9fe093fa4df8f6d$var$getAllowClear;












var $acw62 = parcelRequire("acw62");
function $e424ea760f35b51a$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $acw62.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            var _a, _b, _c, _d;
            if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) && ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.input.getAttribute("type")) === "password" && ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.input.hasAttribute("value"))) (_d = inputRef.current) === null || _d === void 0 || _d.input.removeAttribute("value");
        }));
    };
    (0, $acw62.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}



// eslint-disable-next-line import/prefer-default-export
function $23144ccd376634c7$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
var $538df197b854e6d1$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $538df197b854e6d1$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor: cursor } = option || {};
    if (cursor) {
        const len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
const $538df197b854e6d1$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classes, variant: customVariant } = props, rest = $538df197b854e6d1$var$__rest(props, [
        "prefixCls",
        "bordered",
        "status",
        "size",
        "disabled",
        "onBlur",
        "onFocus",
        "suffix",
        "allowClear",
        "addonAfter",
        "addonBefore",
        "className",
        "style",
        "styles",
        "rootClassName",
        "onChange",
        "classNames",
        "variant"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, input: input } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("input", customizePrefixCls);
    const inputRef = (0, $acw62.useRef)(null);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $232788b5c0fca573$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customSize !== null && customSize !== void 0 ? customSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $23144ccd376634c7$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, $acw62.useRef)(inputHasPrefixSuffix);
    var _a1;
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange === null || onChange === void 0 || onChange(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $f9fe093fa4df8f6d$export$2e2bcd8739ae039)(allowClear !== null && allowClear !== void 0 ? allowClear : input === null || input === void 0 ? void 0 : input.allowClear);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)("input", customVariant, bordered);
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $93b8a86f8ed15614$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: input === null || input === void 0 ? void 0 : input.autoComplete
    }, rest, {
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.style), style),
        styles: Object.assign(Object.assign({}, input === null || input === void 0 ? void 0 : input.styles), styles),
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, input === null || input === void 0 ? void 0 : input.className),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), input === null || input === void 0 ? void 0 : input.classNames), {
            input: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-sm`]: mergedSize === "small",
                [`${prefixCls}-lg`]: mergedSize === "large",
                [`${prefixCls}-rtl`]: direction === "rtl"
            }, classes === null || classes === void 0 ? void 0 : classes.input, (_a = input === null || input === void 0 ? void 0 : input.classNames) === null || _a === void 0 ? void 0 : _a.input, hashId),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl"
            }, hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-group-rtl`]: direction === "rtl"
            }, hashId),
            groupWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-group-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        })
    })));
});
var $538df197b854e6d1$export$2e2bcd8739ae039 = $538df197b854e6d1$var$Input;




var $acw62 = parcelRequire("acw62");











// =============================== OTP ================================
const $342237063413aff3$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [`${componentCls}`]: {
            display: "inline-flex",
            alignItems: "center",
            flexWrap: "nowrap",
            columnGap: paddingXS,
            "&-rtl": {
                direction: "rtl"
            },
            [`${componentCls}-input`]: {
                textAlign: "center",
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$342237063413aff3$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)([
    "Input",
    "OTP"
], (token)=>{
    const inputToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $342237063413aff3$var$genOTPStyle(inputToken)
    ];
}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781));



var $acw62 = parcelRequire("acw62");


"use client";
var $f02194bc3f3a92de$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f02194bc3f3a92de$var$OTPInput = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask } = props, restProps = $f02194bc3f3a92de$var$__rest(props, [
        "value",
        "onChange",
        "onActiveChange",
        "index",
        "mask"
    ]);
    const internalValue = value && typeof mask === "string" ? mask : value;
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================== Ref ===========================
    const inputRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(()=>{
            var _a;
            const inputEle = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (_ref)=>{
        let { key: key } = _ref;
        if (key === "ArrowLeft") onActiveChange(index - 1);
        else if (key === "ArrowRight") onActiveChange(index + 1);
        syncSelection();
    };
    const onInternalKeyUp = (e)=>{
        if (e.key === "Backspace" && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        ref: inputRef,
        value: internalValue,
        onInput: onInternalChange,
        onFocus: syncSelection,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        type: mask === true ? "password" : "text"
    }));
});
var $f02194bc3f3a92de$export$2e2bcd8739ae039 = $f02194bc3f3a92de$var$OTPInput;


"use client";
var $a41c5ef9ac79dcae$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $a41c5ef9ac79dcae$var$strToArr(str) {
    return (str || "").split("");
}
const $a41c5ef9ac79dcae$var$OTP = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, variant: variant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask } = props, restProps = $a41c5ef9ac79dcae$var$__rest(props, [
        "prefixCls",
        "length",
        "size",
        "defaultValue",
        "value",
        "onChange",
        "formatter",
        "variant",
        "disabled",
        "status",
        "autoFocus",
        "mask"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("otp", customizePrefixCls);
    const domAttrs = (0, $281efe5882c936de$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $342237063413aff3$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Size =========================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>customSize !== null && customSize !== void 0 ? customSize : ctx);
    // ======================== Status ========================
    const formContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $acw62.useMemo(()=>Object.assign(Object.assign({}, formContext), {
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $acw62.useRef(null);
    const refs = $acw62.useRef({});
    $acw62.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _a;
                (_a = refs.current[0]) === null || _a === void 0 || _a.focus();
            },
            blur: ()=>{
                var _a;
                for(let i = 0; i < length; i += 1)(_a = refs.current[i]) === null || _a === void 0 || _a.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $acw62.useState($a41c5ef9ac79dcae$var$strToArr(internalFormatter(defaultValue || "")));
    $acw62.useEffect(()=>{
        if (value !== undefined) setValueCells($a41c5ef9ac79dcae$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $01e43e72865dc583$export$2e2bcd8739ae039)((nextValueCells)=>{
        setValueCells(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(""));
    });
    const patchValue = (0, $01e43e72865dc583$export$2e2bcd8739ae039)((index, txt)=>{
        let nextCells = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = "";
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($a41c5ef9ac79dcae$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || " ").join(""));
        nextCells = $a41c5ef9ac79dcae$var$strToArr(formattedValue).map((c, i)=>{
            if (c === " " && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        var _a;
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index) (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        var _a;
        (_a = refs.current[nextIndex]) === null || _a === void 0 || _a.focus();
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({}, domAttrs, {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === "small",
            [`${prefixCls}-lg`]: mergedSize === "large",
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, cssVarCls, hashId)
    }), /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || "";
        return /*#__PURE__*/ $acw62.createElement((0, $f02194bc3f3a92de$export$2e2bcd8739ae039), Object.assign({
            ref: (inputEle)=>{
                refs.current[index] = inputEle;
            },
            key: key,
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: `${prefixCls}-input`,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus
        }, inputSharedProps));
    }))));
});
var $a41c5ef9ac79dcae$export$2e2bcd8739ae039 = $a41c5ef9ac79dcae$var$OTP;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $70c4e92fea0b3f8a$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
var $70c4e92fea0b3f8a$export$2e2bcd8739ae039 = $70c4e92fea0b3f8a$var$EyeInvisibleOutlined;



var $48f4fe50ff6ca9c8$var$EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $70c4e92fea0b3f8a$export$2e2bcd8739ae039)
    }));
};
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ var $48f4fe50ff6ca9c8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($48f4fe50ff6ca9c8$var$EyeInvisibleOutlined);
var $48f4fe50ff6ca9c8$export$2e2bcd8739ae039 = $48f4fe50ff6ca9c8$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b7bc758130af6b02$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
var $b7bc758130af6b02$export$2e2bcd8739ae039 = $b7bc758130af6b02$var$EyeOutlined;



var $d8a9efd7a074f5f5$var$EyeOutlined = function EyeOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $b7bc758130af6b02$export$2e2bcd8739ae039)
    }));
};
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ var $d8a9efd7a074f5f5$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d8a9efd7a074f5f5$var$EyeOutlined);
var $d8a9efd7a074f5f5$export$2e2bcd8739ae039 = $d8a9efd7a074f5f5$var$RefIcon;








"use client";
var $27b11b4fcd97a00b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $27b11b4fcd97a00b$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $acw62.createElement((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $48f4fe50ff6ca9c8$export$2e2bcd8739ae039), null);
const $27b11b4fcd97a00b$var$actionMap = {
    click: "onClick",
    hover: "onMouseOver"
};
const $27b11b4fcd97a00b$var$Password = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { disabled: disabled, action: action = "click", visibilityToggle: visibilityToggle = true, iconRender: iconRender = $27b11b4fcd97a00b$var$defaultIconRender } = props;
    const visibilityControlled = typeof visibilityToggle === "object" && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $acw62.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $acw62.useRef)(null);
    $acw62.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $e424ea760f35b51a$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        if (disabled) return;
        if (visible) removePasswordTimeout();
        setVisible((prevState)=>{
            var _a;
            const newState = !prevState;
            if (typeof visibilityToggle === "object") (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 || _a.call(visibilityToggle, newState);
            return newState;
        });
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $27b11b4fcd97a00b$var$actionMap[action] || "";
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: "passwordIcon",
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ $acw62.cloneElement(/*#__PURE__*/ $acw62.isValidElement(icon) ? icon : /*#__PURE__*/ $acw62.createElement("span", null, icon), iconProps);
    };
    const { className: className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size: size } = props, restProps = $27b11b4fcd97a00b$var$__rest(props, [
        "className",
        "prefixCls",
        "inputPrefixCls",
        "size"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const prefixCls = getPrefixCls("input-password", customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = Object.assign(Object.assign({}, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(restProps, [
        "suffix",
        "iconRender",
        "visibilityToggle"
    ])), {
        type: visible ? "text" : "password",
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon
    });
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(ref, inputRef)
    }, omittedProps));
});
var $27b11b4fcd97a00b$export$2e2bcd8739ae039 = $27b11b4fcd97a00b$var$Password;



var $acw62 = parcelRequire("acw62");









"use client";
var $22717f99dfeb0b1a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $22717f99dfeb0b1a$var$Search = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, suffix: suffix, enterButton: enterButton = false, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd } = props, restProps = $22717f99dfeb0b1a$var$__rest(props, [
        "prefixCls",
        "inputPrefixCls",
        "className",
        "size",
        "suffix",
        "enterButton",
        "addonAfter",
        "loading",
        "disabled",
        "onSearch",
        "onChange",
        "onCompositionStart",
        "onCompositionEnd"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const composedRef = $acw62.useRef(false);
    const prefixCls = getPrefixCls("input-search", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const { compactSize: compactSize } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    const inputRef = $acw62.useRef(null);
    const onChange = (e)=>{
        if ((e === null || e === void 0 ? void 0 : e.target) && e.type === "click" && customOnSearch) customOnSearch(e.target.value, e, {
            source: "clear"
        });
        customOnChange === null || customOnChange === void 0 || customOnChange(e);
    };
    const onMouseDown = (e)=>{
        var _a;
        if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) e.preventDefault();
    };
    const onSearch = (e)=>{
        var _a, _b;
        if (customOnSearch) customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e, {
            source: "input"
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        onSearch(e);
    };
    const searchIcon = typeof enterButton === "boolean" ? /*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), null) : null;
    const btnClassName = `${prefixCls}-button`;
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === "button") button = (0, $30796c32f374b477$export$e530037191fcd5d7)(enterButtonAsElement, Object.assign({
        onMouseDown: onMouseDown,
        onClick: (e)=>{
            var _a, _b;
            (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 || _b.call(_a, e);
            onSearch(e);
        },
        key: "enterButton"
    }, isAntdButton ? {
        className: btnClassName,
        size: size
    } : {}));
    else button = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        className: btnClassName,
        type: enterButton ? "primary" : undefined,
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $30796c32f374b477$export$e530037191fcd5d7)(addonAfter, {
            key: "addonAfter"
        })
    ];
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $538df197b854e6d1$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(inputRef, ref),
        onPressEnter: onPressEnter
    }, restProps, {
        size: size,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        prefixCls: inputPrefixCls,
        addonAfter: button,
        suffix: suffix,
        onChange: onChange,
        className: cls,
        disabled: disabled
    }));
});
var $22717f99dfeb0b1a$export$2e2bcd8739ae039 = $22717f99dfeb0b1a$var$Search;



var $acw62 = parcelRequire("acw62");













var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var $e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var $e3bb0cd99ab7a8bc$var$SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "padding-top",
    "padding-bottom",
    "font-family",
    "font-weight",
    "font-size",
    "font-variant",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-left",
    "padding-right",
    "border-width",
    "box-sizing",
    "word-break",
    "white-space"
];
var $e3bb0cd99ab7a8bc$var$computedStyleCache = {};
var $e3bb0cd99ab7a8bc$var$hiddenTextarea;
function $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(node) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
    if (useCache && $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef]) return $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef];
    var style = window.getComputedStyle(node);
    var boxSizing = style.getPropertyValue("box-sizing") || style.getPropertyValue("-moz-box-sizing") || style.getPropertyValue("-webkit-box-sizing");
    var paddingSize = parseFloat(style.getPropertyValue("padding-bottom")) + parseFloat(style.getPropertyValue("padding-top"));
    var borderSize = parseFloat(style.getPropertyValue("border-bottom-width")) + parseFloat(style.getPropertyValue("border-top-width"));
    var sizingStyle = $e3bb0cd99ab7a8bc$var$SIZING_STYLE.map(function(name) {
        return "".concat(name, ":").concat(style.getPropertyValue(name));
    }).join(";");
    var nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $e3bb0cd99ab7a8bc$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039(uiTextNode) {
    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!$e3bb0cd99ab7a8bc$var$hiddenTextarea) {
        $e3bb0cd99ab7a8bc$var$hiddenTextarea = document.createElement("textarea");
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("tab-index", "-1");
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        document.body.appendChild($e3bb0cd99ab7a8bc$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute("wrap")) $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
    else $e3bb0cd99ab7a8bc$var$hiddenTextarea.removeAttribute("wrap");
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    var _calculateNodeStyling = $e3bb0cd99ab7a8bc$export$1a56dc6a39385a18(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat($e3bb0cd99ab7a8bc$var$HIDDEN_TEXTAREA_STYLE));
    $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
    var minHeight = undefined;
    var maxHeight = undefined;
    var overflowY;
    var height = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight;
    if (boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === "content-box") // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $e3bb0cd99ab7a8bc$var$hiddenTextarea.value = " ";
        var singleRowHeight = $e3bb0cd99ab7a8bc$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? "" : "hidden";
            height = Math.min(maxHeight, height);
        }
    }
    var style = {
        height: height,
        overflowY: overflowY,
        resize: "none"
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


var $30d6639cbca42aae$var$_excluded = [
    "prefixCls",
    "onPressEnter",
    "defaultValue",
    "value",
    "autoSize",
    "onResize",
    "className",
    "style",
    "disabled",
    "onChange",
    "onInternalAutoSize"
];
var $30d6639cbca42aae$var$RESIZE_START = 0;
var $30d6639cbca42aae$var$RESIZE_MEASURING = 1;
var $30d6639cbca42aae$var$RESIZE_STABLE = 2;
var $30d6639cbca42aae$var$ResizableTextArea = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _ref = props, prefixCls = _ref.prefixCls, onPressEnter = _ref.onPressEnter, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize = _ref.onResize, className = _ref.className, style = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $30d6639cbca42aae$var$_excluded);
    // =============================== Value ================================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: value,
        postState: function postState(val) {
            return val !== null && val !== void 0 ? val : "";
        }
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
    var onInternalChange = function onInternalChange(event) {
        setMergedValue(event.target.value);
        onChange === null || onChange === void 0 || onChange(event);
    };
    // ================================ Ref =================================
    var textareaRef = $acw62.useRef();
    $acw62.useImperativeHandle(ref, function() {
        return {
            textArea: textareaRef.current
        };
    });
    // ============================== AutoSize ==============================
    var _React$useMemo = $acw62.useMemo(function() {
        if (autoSize && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(autoSize) === "object") return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
    var needAutoSize = !!autoSize;
    // =============================== Scroll ===============================
    // https://github.com/ant-design/ant-design/issues/21870
    var fixFirefoxAutoScroll = function fixFirefoxAutoScroll() {
        try {
            // FF has bug with jump of scroll to top. We force back here.
            if (document.activeElement === textareaRef.current) {
                var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
                // Fix Safari bug which not rollback when break line
                // This makes Chinese IME can't input. Do not fix this
                // const { value: tmpValue } = textareaRef.current;
                // textareaRef.current.value = '';
                // textareaRef.current.value = tmpValue;
                textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
                textareaRef.current.scrollTop = scrollTop;
            }
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    };
    // =============================== Resize ===============================
    var _React$useState = $acw62.useState($30d6639cbca42aae$var$RESIZE_STABLE), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
    var _React$useState3 = $acw62.useState(), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
    var startResize = function startResize() {
        setResizeState($30d6639cbca42aae$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_START) setResizeState($30d6639cbca42aae$var$RESIZE_MEASURING);
        else if (resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
            var textareaStyles = (0, $e3bb0cd99ab7a8bc$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState($30d6639cbca42aae$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        } else fixFirefoxAutoScroll();
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    var resizeRafRef = $acw62.useRef();
    var cleanRaf = function cleanRaf() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    var onInternalResize = function onInternalResize(size) {
        if (resizeState === $30d6639cbca42aae$var$RESIZE_STABLE) {
            onResize === null || onResize === void 0 || onResize(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                    startResize();
                });
            }
        }
    };
    $acw62.useEffect(function() {
        return cleanRaf;
    }, []);
    // =============================== Render ===============================
    var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), mergedAutoSizeStyle);
    if (resizeState === $30d6639cbca42aae$var$RESIZE_START || resizeState === $30d6639cbca42aae$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = "hidden";
        mergedStyle.overflowX = "hidden";
    }
    return /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $acw62.createElement("textarea", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled)),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $30d6639cbca42aae$export$2e2bcd8739ae039 = $30d6639cbca42aae$var$ResizableTextArea;


var $368a509879ccc1d0$var$_excluded = [
    "defaultValue",
    "value",
    "onFocus",
    "onBlur",
    "onChange",
    "allowClear",
    "maxLength",
    "onCompositionStart",
    "onCompositionEnd",
    "suffix",
    "prefixCls",
    "showCount",
    "count",
    "className",
    "style",
    "disabled",
    "hidden",
    "classNames",
    "styles",
    "onResize",
    "readOnly"
];
var $368a509879ccc1d0$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(_ref, ref) {
    var _countConfig$max;
    var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-textarea" : _ref$prefixCls, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames = _ref.classNames, styles = _ref.styles, onResize = _ref.onResize, readOnly = _ref.readOnly, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $368a509879ccc1d0$var$_excluded);
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: customValue,
        defaultValue: defaultValue
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
    var formatValue = value === undefined || value === null ? "" : String(value);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
    // =============================== Ref ================================
    var holderRef = (0, $acw62.useRef)(null);
    var resizableTextAreaRef = (0, $acw62.useRef)(null);
    var getTextArea = function getTextArea() {
        var _resizableTextAreaRef;
        return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
    };
    var focus = function focus() {
        getTextArea().focus();
    };
    (0, $acw62.useImperativeHandle)(ref, function() {
        var _holderRef$current;
        return {
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: function blur() {
                getTextArea().blur();
            },
            nativeElement: ((_holderRef$current = holderRef.current) === null || _holderRef$current === void 0 ? void 0 : _holderRef$current.nativeElement) || getTextArea()
        };
    });
    (0, $acw62.useEffect)(function() {
        setFocused(function(prev) {
            return !disabled && prev;
        });
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    var _React$useState5 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (selection) {
            var _getTextArea;
            (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(selection));
        }
    }, [
        selection
    ]);
    // ============================== Count ===============================
    var countConfig = (0, $8d507ba491af0684$export$2e2bcd8739ae039)(count, showCount);
    var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
    // Max length value
    var hasMaxLength = Number(mergedMax) > 0;
    var valueLength = countConfig.strategy(formatValue);
    var isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    var triggerChange = function triggerChange(e, currentValue) {
        var cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    var onInternalCompositionStart = function onInternalCompositionStart(e) {
        compositionRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
    };
    var onInternalCompositionEnd = function onInternalCompositionEnd(e) {
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
    };
    var onInternalChange = function onInternalChange(e) {
        triggerChange(e, e.target.value);
    };
    var handleKeyDown = function handleKeyDown(e) {
        var onPressEnter = rest.onPressEnter, onKeyDown = rest.onKeyDown;
        if (e.key === "Enter" && onPressEnter) onPressEnter(e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    };
    var handleFocus = function handleFocus(e) {
        setFocused(true);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var handleBlur = function handleBlur(e) {
        setFocused(false);
        onBlur === null || onBlur === void 0 || onBlur(e);
    };
    // ============================== Reset ===============================
    var handleReset = function handleReset(e) {
        setValue("");
        focus();
        (0, $fd5fdd8da073bd4e$export$c28984794956ddc0)(getTextArea(), e, onChange);
    };
    var suffixNode = suffix;
    var dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
        suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-data-count"), classNames === null || classNames === void 0 ? void 0 : classNames.count),
            style: styles === null || styles === void 0 ? void 0 : styles.count
        }, dataCount));
    }
    var handleResize = function handleResize(size) {
        var _getTextArea2;
        onResize === null || onResize === void 0 || onResize(size);
        if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) setTextareaResized(true);
    };
    var isPureTextArea = !rest.autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32a5e8fad29dc207$export$2e2bcd8739ae039), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, classNames), {}, {
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classNames === null || classNames === void 0 ? void 0 : classNames.affixWrapper, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-count"), showCount), "".concat(prefixCls, "-textarea-allow-clear"), allowClear))
        }),
        disabled: disabled,
        focused: focused,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), textareaResized && !isPureTextArea ? {
            height: "auto"
        } : {}),
        dataAttrs: {
            affixWrapper: {
                "data-count": typeof dataCount === "string" ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $30d6639cbca42aae$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, {
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classNames === null || classNames === void 0 ? void 0 : classNames.textarea),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
            resize: style === null || style === void 0 ? void 0 : style.resize
        }),
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $368a509879ccc1d0$export$2e2bcd8739ae039 = $368a509879ccc1d0$var$TextArea;



var $36948fc6671d6b75$export$2e2bcd8739ae039 = (0, $368a509879ccc1d0$export$2e2bcd8739ae039);













"use client";
var $fc29eec8796e8593$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fc29eec8796e8593$var$TextArea = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classes, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant } = props, rest = $fc29eec8796e8593$var$__rest(props, [
        "prefixCls",
        "bordered",
        "size",
        "disabled",
        "status",
        "allowClear",
        "classNames",
        "rootClassName",
        "className",
        "style",
        "styles",
        "variant"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, textArea: textArea } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    // ===================== Size =====================
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Ref =====================
    const innerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            resizableTextArea: (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea,
            focus: (option)=>{
                var _a, _b;
                (0, $538df197b854e6d1$export$2b92016deb0b7aad)((_b = (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
            },
            blur: ()=>{
                var _a;
                return (_a = innerRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
    });
    const prefixCls = getPrefixCls("input", customizePrefixCls);
    // ===================== Style =====================
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $232788b5c0fca573$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)("textArea", customVariant, bordered);
    const mergedAllowClear = (0, $f9fe093fa4df8f6d$export$2e2bcd8739ae039)(allowClear !== null && allowClear !== void 0 ? allowClear : textArea === null || textArea === void 0 ? void 0 : textArea.allowClear);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $36948fc6671d6b75$export$2e2bcd8739ae039), Object.assign({
        autoComplete: textArea === null || textArea === void 0 ? void 0 : textArea.autoComplete
    }, rest, {
        style: Object.assign(Object.assign({}, textArea === null || textArea === void 0 ? void 0 : textArea.style), style),
        styles: Object.assign(Object.assign({}, textArea === null || textArea === void 0 ? void 0 : textArea.styles), styles),
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(cssVarCls, rootCls, className, rootClassName, textArea === null || textArea === void 0 ? void 0 : textArea.className),
        classNames: Object.assign(Object.assign(Object.assign({}, classes), textArea === null || textArea === void 0 ? void 0 : textArea.classNames), {
            textarea: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-sm`]: mergedSize === "small",
                [`${prefixCls}-lg`]: mergedSize === "large"
            }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea, (_a = textArea === null || textArea === void 0 ? void 0 : textArea.classNames) === null || _a === void 0 ? void 0 : _a.textarea),
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-textarea-show-count`]: props.showCount || ((_b = props.count) === null || _b === void 0 ? void 0 : _b.show)
            }, hashId)
        }),
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        ref: innerRef
    })));
});
var $fc29eec8796e8593$export$2e2bcd8739ae039 = $fc29eec8796e8593$var$TextArea;


"use client";
const $ad70426818bb52aa$var$Input = (0, $538df197b854e6d1$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Group = (0, $ae15c91e7f32cbed$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Search = (0, $22717f99dfeb0b1a$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.TextArea = (0, $fc29eec8796e8593$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.Password = (0, $27b11b4fcd97a00b$export$2e2bcd8739ae039);
$ad70426818bb52aa$var$Input.OTP = (0, $a41c5ef9ac79dcae$export$2e2bcd8739ae039);
var $ad70426818bb52aa$export$2e2bcd8739ae039 = $ad70426818bb52aa$var$Input;


var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");



var $d0d93e48d7e4310b$var$_excluded = [
    "prefixCls",
    "className",
    "checked",
    "defaultChecked",
    "disabled",
    "loadingIcon",
    "checkedChildren",
    "unCheckedChildren",
    "onClick",
    "onChange",
    "onKeyDown"
];
var $d0d93e48d7e4310b$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function(_ref, ref) {
    var _classNames;
    var _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-switch" : _ref$prefixCls, className = _ref.className, checked = _ref.checked, defaultChecked = _ref.defaultChecked, disabled = _ref.disabled, loadingIcon = _ref.loadingIcon, checkedChildren = _ref.checkedChildren, unCheckedChildren = _ref.unCheckedChildren, onClick = _ref.onClick, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $d0d93e48d7e4310b$var$_excluded);
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: checked,
        defaultValue: defaultChecked
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), innerChecked = _useMergedState2[0], setInnerChecked = _useMergedState2[1];
    function triggerChange(newChecked, event) {
        var mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange === null || onChange === void 0 || onChange(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT) triggerChange(false, e);
        else if (e.which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT) triggerChange(true, e);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    }
    function onInternalClick(e) {
        var ret = triggerChange(!innerChecked, e);
        // [Legacy] trigger onClick with value
        onClick === null || onClick === void 0 || onClick(ret, e);
    }
    var switchClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-checked"), innerChecked), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    return /*#__PURE__*/ $acw62.createElement("button", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-inner-checked")
    }, checkedChildren), /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-inner-unchecked")
    }, unCheckedChildren)));
});
$d0d93e48d7e4310b$var$Switch.displayName = "Switch";
var $d0d93e48d7e4310b$export$2e2bcd8739ae039 = $d0d93e48d7e4310b$var$Switch;











const $a10c6528c54a1def$var$genSwitchSmallStyle = (token)=>{
    const { componentCls: componentCls, trackHeightSM: trackHeightSM, trackPadding: trackPadding, trackMinWidthSM: trackMinWidthSM, innerMinMarginSM: innerMinMarginSM, innerMaxMarginSM: innerMaxMarginSM, handleSizeSM: handleSizeSM, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(innerMaxMarginSM).mul(2).equal());
    return {
        [componentCls]: {
            [`&${componentCls}-small`]: {
                minWidth: trackMinWidthSM,
                height: trackHeightSM,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(trackHeightSM),
                [`${componentCls}-inner`]: {
                    paddingInlineStart: innerMaxMarginSM,
                    paddingInlineEnd: innerMinMarginSM,
                    [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                        minHeight: trackHeightSM
                    },
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                        marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                    },
                    [`${switchInnerCls}-unchecked`]: {
                        marginTop: calc(trackHeightSM).mul(-1).equal(),
                        marginInlineStart: 0,
                        marginInlineEnd: 0
                    }
                },
                [`${componentCls}-handle`]: {
                    width: handleSizeSM,
                    height: handleSizeSM
                },
                [`${componentCls}-loading-icon`]: {
                    top: calc(calc(handleSizeSM).sub(token.switchLoadingIconSize)).div(2).equal(),
                    fontSize: token.switchLoadingIconSize
                },
                [`&${componentCls}-checked`]: {
                    [`${componentCls}-inner`]: {
                        paddingInlineStart: innerMinMarginSM,
                        paddingInlineEnd: innerMaxMarginSM,
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: 0,
                            marginInlineEnd: 0
                        },
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                            marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                        }
                    },
                    [`${componentCls}-handle`]: {
                        insetInlineStart: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(handleSizeSM).add(trackPadding).equal())})`
                    }
                },
                [`&:not(${componentCls}-disabled):active`]: {
                    [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: calc(token.marginXXS).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).mul(-1).div(2).equal()
                        }
                    },
                    [`&${componentCls}-checked ${switchInnerCls}`]: {
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: calc(token.marginXXS).mul(-1).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).div(2).equal()
                        }
                    }
                }
            }
        }
    };
};
const $a10c6528c54a1def$var$genSwitchLoadingStyle = (token)=>{
    const { componentCls: componentCls, handleSize: handleSize, calc: calc } = token;
    return {
        [componentCls]: {
            [`${componentCls}-loading-icon${token.iconCls}`]: {
                position: "relative",
                top: calc(calc(handleSize).sub(token.fontSize)).div(2).equal(),
                color: token.switchLoadingIconColor,
                verticalAlign: "top"
            },
            [`&${componentCls}-checked ${componentCls}-loading-icon`]: {
                color: token.switchColor
            }
        }
    };
};
const $a10c6528c54a1def$var$genSwitchHandleStyle = (token)=>{
    const { componentCls: componentCls, trackPadding: trackPadding, handleBg: handleBg, handleShadow: handleShadow, handleSize: handleSize, calc: calc } = token;
    const switchHandleCls = `${componentCls}-handle`;
    return {
        [componentCls]: {
            [switchHandleCls]: {
                position: "absolute",
                top: trackPadding,
                insetInlineStart: trackPadding,
                width: handleSize,
                height: handleSize,
                transition: `all ${token.switchDuration} ease-in-out`,
                "&::before": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    backgroundColor: handleBg,
                    borderRadius: calc(handleSize).div(2).equal(),
                    boxShadow: handleShadow,
                    transition: `all ${token.switchDuration} ease-in-out`,
                    content: '""'
                }
            },
            [`&${componentCls}-checked ${switchHandleCls}`]: {
                insetInlineStart: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(handleSize).add(trackPadding).equal())})`
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`${switchHandleCls}::before`]: {
                    insetInlineEnd: token.switchHandleActiveInset,
                    insetInlineStart: 0
                },
                [`&${componentCls}-checked ${switchHandleCls}::before`]: {
                    insetInlineEnd: 0,
                    insetInlineStart: token.switchHandleActiveInset
                }
            }
        }
    };
};
const $a10c6528c54a1def$var$genSwitchInnerStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackPadding: trackPadding, innerMinMargin: innerMinMargin, innerMaxMargin: innerMaxMargin, handleSize: handleSize, calc: calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(innerMaxMargin).mul(2).equal());
    return {
        [componentCls]: {
            [switchInnerCls]: {
                display: "block",
                overflow: "hidden",
                borderRadius: 100,
                height: "100%",
                paddingInlineStart: innerMaxMargin,
                paddingInlineEnd: innerMinMargin,
                transition: `padding-inline-start ${token.switchDuration} ease-in-out, padding-inline-end ${token.switchDuration} ease-in-out`,
                [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                    display: "block",
                    color: token.colorTextLightSolid,
                    fontSize: token.fontSizeSM,
                    transition: `margin-inline-start ${token.switchDuration} ease-in-out, margin-inline-end ${token.switchDuration} ease-in-out`,
                    pointerEvents: "none",
                    minHeight: trackHeight
                },
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginTop: calc(trackHeight).mul(-1).equal(),
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                }
            },
            [`&${componentCls}-checked ${switchInnerCls}`]: {
                paddingInlineStart: innerMinMargin,
                paddingInlineEnd: innerMaxMargin,
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                }
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                    [`${switchInnerCls}-unchecked`]: {
                        marginInlineStart: calc(trackPadding).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
                    }
                },
                [`&${componentCls}-checked ${switchInnerCls}`]: {
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(2).equal()
                    }
                }
            }
        }
    };
};
const $a10c6528c54a1def$var$genSwitchStyle = (token)=>{
    const { componentCls: componentCls, trackHeight: trackHeight, trackMinWidth: trackMinWidth } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "relative",
            display: "inline-block",
            boxSizing: "border-box",
            minWidth: trackMinWidth,
            height: trackHeight,
            lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(trackHeight)}`,
            verticalAlign: "middle",
            background: token.colorTextQuaternary,
            border: "0",
            borderRadius: 100,
            cursor: "pointer",
            transition: `all ${token.motionDurationMid}`,
            userSelect: "none",
            [`&:hover:not(${componentCls}-disabled)`]: {
                background: token.colorTextTertiary
            }
        }), (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)), {
            [`&${componentCls}-checked`]: {
                background: token.switchColor,
                [`&:hover:not(${componentCls}-disabled)`]: {
                    background: token.colorPrimaryHover
                }
            },
            [`&${componentCls}-loading, &${componentCls}-disabled`]: {
                cursor: "not-allowed",
                opacity: token.switchDisabledOpacity,
                "*": {
                    boxShadow: "none",
                    cursor: "not-allowed"
                }
            },
            // rtl style
            [`&${componentCls}-rtl`]: {
                direction: "rtl"
            }
        })
    };
};
const $a10c6528c54a1def$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, controlHeight: controlHeight, colorWhite: colorWhite } = token;
    const height = fontSize * lineHeight;
    const heightSM = controlHeight / 2;
    const padding = 2; // Fixed value
    const handleSize = height - padding * 2;
    const handleSizeSM = heightSM - padding * 2;
    return {
        trackHeight: height,
        trackHeightSM: heightSM,
        trackMinWidth: handleSize * 2 + padding * 4,
        trackMinWidthSM: handleSizeSM * 2 + padding * 2,
        trackPadding: padding,
        // Fixed value
        handleBg: colorWhite,
        handleSize: handleSize,
        handleSizeSM: handleSizeSM,
        handleShadow: `0 2px 4px 0 ${new (0, $6d2f60b2591128fc$export$d850312fc213f33e)("#00230b").setAlpha(0.2).toRgbString()}`,
        innerMinMargin: handleSize / 2,
        innerMaxMargin: handleSize + padding + padding * 2,
        innerMinMarginSM: handleSizeSM / 2,
        innerMaxMarginSM: handleSizeSM + padding + padding * 2
    };
};
var $a10c6528c54a1def$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Switch", (token)=>{
    const switchToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        switchDuration: token.motionDurationMid,
        switchColor: token.colorPrimary,
        switchDisabledOpacity: token.opacityLoading,
        switchLoadingIconSize: token.calc(token.fontSizeIcon).mul(0.75).equal(),
        switchLoadingIconColor: `rgba(0, 0, 0, ${token.opacityLoading})`,
        switchHandleActiveInset: "-30%"
    });
    return [
        $a10c6528c54a1def$var$genSwitchStyle(switchToken),
        // inner style
        $a10c6528c54a1def$var$genSwitchInnerStyle(switchToken),
        // handle style
        $a10c6528c54a1def$var$genSwitchHandleStyle(switchToken),
        // loading style
        $a10c6528c54a1def$var$genSwitchLoadingStyle(switchToken),
        // small style
        $a10c6528c54a1def$var$genSwitchSmallStyle(switchToken)
    ];
}, $a10c6528c54a1def$export$9ca1be8807fe0675);


"use client";
var $40b6a897f33a99d9$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $40b6a897f33a99d9$var$InternalSwitch = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, size: customizeSize, disabled: customDisabled, loading: loading, className: className, rootClassName: rootClassName, style: style, checked: checkedProp, value: value, defaultChecked: defaultCheckedProp, defaultValue: defaultValue, onChange: onChange } = props, restProps = $40b6a897f33a99d9$var$__rest(props, [
        "prefixCls",
        "size",
        "disabled",
        "loading",
        "className",
        "rootClassName",
        "style",
        "checked",
        "value",
        "defaultChecked",
        "defaultValue",
        "onChange"
    ]);
    const [checked, setChecked] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: checkedProp !== null && checkedProp !== void 0 ? checkedProp : value,
        defaultValue: defaultCheckedProp !== null && defaultCheckedProp !== void 0 ? defaultCheckedProp : defaultValue
    });
    const { getPrefixCls: getPrefixCls, direction: direction, switch: SWITCH } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = (customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled) || loading;
    const prefixCls = getPrefixCls("switch", customizePrefixCls);
    const loadingIcon = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-handle`
    }, loading && /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        className: `${prefixCls}-loading-icon`
    }));
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $a10c6528c54a1def$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.className, {
        [`${prefixCls}-small`]: mergedSize === "small",
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, SWITCH === null || SWITCH === void 0 ? void 0 : SWITCH.style), style);
    const changeHandler = function() {
        setChecked(arguments.length <= 0 ? undefined : arguments[0]);
        onChange === null || onChange === void 0 || onChange.apply(void 0, arguments);
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Switch"
    }, /*#__PURE__*/ $acw62.createElement((0, $d0d93e48d7e4310b$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        checked: checked,
        onChange: changeHandler,
        prefixCls: prefixCls,
        className: classes,
        style: mergedStyle,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    }))));
});
const $40b6a897f33a99d9$var$Switch = $40b6a897f33a99d9$var$InternalSwitch;
$40b6a897f33a99d9$var$Switch.__ANT_SWITCH = true;
var $40b6a897f33a99d9$export$2e2bcd8739ae039 = $40b6a897f33a99d9$var$Switch;


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");
















var $acw62 = parcelRequire("acw62");

var $58e44f0198af143b$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = file.type || "";
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim();
            // This is something like */*,*  allow all files
            if (/^\*(\/\*)?$/.test(type)) return true;
            // like .jpg, .png
            if (validType.charAt(0) === ".") {
                var lowerFileName = fileName.toLowerCase();
                var lowerType = validType.toLowerCase();
                var affixList = [
                    lowerType
                ];
                if (lowerType === ".jpg" || lowerType === ".jpeg") affixList = [
                    ".jpg",
                    ".jpeg"
                ];
                return affixList.some(function(affix) {
                    return lowerFileName.endsWith(affix);
                });
            }
            // This is something like a image/* mime type
            if (/\/\*$/.test(validType)) return baseMimeType === validType.replace(/\/.*$/, "");
            // Full match
            if (mimeType === validType) return true;
            // Invalidate type should skip
            if (/^\w+$/.test(validType)) {
                (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Upload takes an invalidate 'accept' type '".concat(validType, "'.Skip for check."));
                return true;
            }
            return false;
        });
    }
    return true;
};


function $11fd01730c52ca6c$var$getError(option, xhr) {
    var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
    var err = new Error(msg);
    err.status = xhr.status;
    err.method = option.method;
    err.url = option.action;
    return err;
}
function $11fd01730c52ca6c$var$getBody(xhr) {
    var text = xhr.responseText || xhr.response;
    if (!text) return text;
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}
function $11fd01730c52ca6c$export$2e2bcd8739ae039(option) {
    // eslint-disable-next-line no-undef
    var xhr = new XMLHttpRequest();
    if (option.onProgress && xhr.upload) xhr.upload.onprogress = function progress(e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        option.onProgress(e);
    };
    // eslint-disable-next-line no-undef
    var formData = new FormData();
    if (option.data) Object.keys(option.data).forEach(function(key) {
        var value = option.data[key];
        // support key-value array data
        if (Array.isArray(value)) {
            value.forEach(function(item) {
                // { list: [ 11, 22 ] }
                // formData.append('list[]', 11);
                formData.append("".concat(key, "[]"), item);
            });
            return;
        }
        formData.append(key, value);
    });
    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) formData.append(option.filename, option.file, option.file.name);
    else formData.append(option.filename, option.file);
    xhr.onerror = function error(e) {
        option.onError(e);
    };
    xhr.onload = function onload() {
        // allow success when 2xx status
        // see https://github.com/react-component/upload/issues/34
        if (xhr.status < 200 || xhr.status >= 300) return option.onError($11fd01730c52ca6c$var$getError(option, xhr), $11fd01730c52ca6c$var$getBody(xhr));
        return option.onSuccess($11fd01730c52ca6c$var$getBody(xhr), xhr);
    };
    xhr.open(option.method, option.action, true);
    // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
    if (option.withCredentials && "withCredentials" in xhr) xhr.withCredentials = true;
    var headers = option.headers || {};
    // when set headers['X-Requested-With'] = null , can close default XHR header
    // see https://github.com/react-component/upload/issues/33
    if (headers["X-Requested-With"] !== null) xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    Object.keys(headers).forEach(function(h) {
        if (headers[h] !== null) xhr.setRequestHeader(h, headers[h]);
    });
    xhr.send(formData);
    return {
        abort: function abort() {
            xhr.abort();
        }
    };
}


function $503d9f78f89fe362$var$loopFiles(item, callback) {
    var dirReader = item.createReader();
    var fileList = [];
    function sequence() {
        dirReader.readEntries(function(entries) {
            var entryList = Array.prototype.slice.apply(entries);
            fileList = fileList.concat(entryList);
            // Check if all the file has been viewed
            var isFinished = !entryList.length;
            if (isFinished) callback(fileList);
            else sequence();
        });
    }
    sequence();
}
var $503d9f78f89fe362$var$traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var _traverseFileTree = function _traverseFileTree(item, path) {
        if (!item) return;
        // eslint-disable-next-line no-param-reassign
        item.path = path || "";
        if (item.isFile) item.file(function(file) {
            if (isAccepted(file)) {
                // https://github.com/ant-design/ant-design/issues/16426
                if (item.fullPath && !file.webkitRelativePath) {
                    Object.defineProperties(file, {
                        webkitRelativePath: {
                            writable: true
                        }
                    });
                    // eslint-disable-next-line no-param-reassign
                    file.webkitRelativePath = item.fullPath.replace(/^\//, "");
                    Object.defineProperties(file, {
                        webkitRelativePath: {
                            writable: false
                        }
                    });
                }
                callback([
                    file
                ]);
            }
        });
        else if (item.isDirectory) $503d9f78f89fe362$var$loopFiles(item, function(entries) {
            entries.forEach(function(entryItem) {
                _traverseFileTree(entryItem, "".concat(path).concat(item.name, "/"));
            });
        });
    };
    files.forEach(function(file) {
        _traverseFileTree(file.webkitGetAsEntry());
    });
};
var $503d9f78f89fe362$export$2e2bcd8739ae039 = $503d9f78f89fe362$var$traverseFileTree;


var $0daea9a81623c04d$var$now = +new Date();
var $0daea9a81623c04d$var$index = 0;
function $0daea9a81623c04d$export$2e2bcd8739ae039() {
    // eslint-disable-next-line no-plusplus
    return "rc-upload-".concat($0daea9a81623c04d$var$now, "-").concat(++$0daea9a81623c04d$var$index);
}


var $f6bb9b2e0d4ecc67$var$_excluded = [
    "component",
    "prefixCls",
    "className",
    "classNames",
    "disabled",
    "id",
    "style",
    "styles",
    "multiple",
    "accept",
    "capture",
    "children",
    "directory",
    "openFileDialogOnClick",
    "onMouseEnter",
    "onMouseLeave",
    "hasControlInside"
];
var $f6bb9b2e0d4ecc67$var$AjaxUploader = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(AjaxUploader, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(AjaxUploader);
    function AjaxUploader() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, AjaxUploader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            uid: (0, $0daea9a81623c04d$export$2e2bcd8739ae039)()
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "reqs", {});
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "fileInput", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "_isMounted", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onChange", function(e) {
            var _this$props = _this.props, accept = _this$props.accept, directory = _this$props.directory;
            var files = e.target.files;
            var acceptedFiles = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(files).filter(function(file) {
                return !directory || (0, $58e44f0198af143b$export$2e2bcd8739ae039)(file, accept);
            });
            _this.uploadFiles(acceptedFiles);
            _this.reset();
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
            var el = _this.fileInput;
            if (!el) return;
            var target = event.target;
            var onClick = _this.props.onClick;
            if (target && target.tagName === "BUTTON") {
                var parent = el.parentNode;
                parent.focus();
                target.blur();
            }
            el.click();
            if (onClick) onClick(event);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onKeyDown", function(e) {
            if (e.key === "Enter") _this.onClick(e);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onFileDrop", function(e) {
            var multiple = _this.props.multiple;
            e.preventDefault();
            if (e.type === "dragover") return;
            if (_this.props.directory) (0, $503d9f78f89fe362$export$2e2bcd8739ae039)(Array.prototype.slice.call(e.dataTransfer.items), _this.uploadFiles, function(_file) {
                return (0, $58e44f0198af143b$export$2e2bcd8739ae039)(_file, _this.props.accept);
            });
            else {
                var files = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(e.dataTransfer.files).filter(function(file) {
                    return (0, $58e44f0198af143b$export$2e2bcd8739ae039)(file, _this.props.accept);
                });
                if (multiple === false) files = files.slice(0, 1);
                _this.uploadFiles(files);
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "uploadFiles", function(files) {
            var originFiles = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(files);
            var postFiles = originFiles.map(function(file) {
                // eslint-disable-next-line no-param-reassign
                file.uid = (0, $0daea9a81623c04d$export$2e2bcd8739ae039)();
                return _this.processFile(file, originFiles);
            });
            // Batch upload files
            Promise.all(postFiles).then(function(fileList) {
                var onBatchStart = _this.props.onBatchStart;
                onBatchStart === null || onBatchStart === void 0 || onBatchStart(fileList.map(function(_ref) {
                    var origin = _ref.origin, parsedFile = _ref.parsedFile;
                    return {
                        file: origin,
                        parsedFile: parsedFile
                    };
                }));
                fileList.filter(function(file) {
                    return file.parsedFile !== null;
                }).forEach(function(file) {
                    _this.post(file);
                });
            });
        });
        /**
     * Process file before upload. When all the file is ready, we start upload.
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "processFile", /*#__PURE__*/ function() {
            var _ref2 = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().mark(function _callee(file, fileList) {
                var beforeUpload, transformedFile, action, mergedAction, data, mergedData, parsedData, parsedFile, mergedParsedFile;
                return (0, $90d00d496f52c75c$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            beforeUpload = _this.props.beforeUpload;
                            transformedFile = file;
                            if (!beforeUpload) {
                                _context.next = 14;
                                break;
                            }
                            _context.prev = 3;
                            _context.next = 6;
                            return beforeUpload(file, fileList);
                        case 6:
                            transformedFile = _context.sent;
                            _context.next = 12;
                            break;
                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context["catch"](3);
                            // Rejection will also trade as false
                            transformedFile = false;
                        case 12:
                            if (!(transformedFile === false)) {
                                _context.next = 14;
                                break;
                            }
                            return _context.abrupt("return", {
                                origin: file,
                                parsedFile: null,
                                action: null,
                                data: null
                            });
                        case 14:
                            // Get latest action
                            action = _this.props.action;
                            if (!(typeof action === "function")) {
                                _context.next = 21;
                                break;
                            }
                            _context.next = 18;
                            return action(file);
                        case 18:
                            mergedAction = _context.sent;
                            _context.next = 22;
                            break;
                        case 21:
                            mergedAction = action;
                        case 22:
                            // Get latest data
                            data = _this.props.data;
                            if (!(typeof data === "function")) {
                                _context.next = 29;
                                break;
                            }
                            _context.next = 26;
                            return data(file);
                        case 26:
                            mergedData = _context.sent;
                            _context.next = 30;
                            break;
                        case 29:
                            mergedData = data;
                        case 30:
                            parsedData = // string type is from legacy `transformFile`.
                            // Not sure if this will work since no related test case works with it
                            ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(transformedFile) === "object" || typeof transformedFile === "string") && transformedFile ? transformedFile : file;
                            if (parsedData instanceof File) parsedFile = parsedData;
                            else parsedFile = new File([
                                parsedData
                            ], file.name, {
                                type: file.type
                            });
                            mergedParsedFile = parsedFile;
                            mergedParsedFile.uid = file.uid;
                            return _context.abrupt("return", {
                                origin: file,
                                data: mergedData,
                                parsedFile: mergedParsedFile,
                                action: mergedAction
                            });
                        case 35:
                        case "end":
                            return _context.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        9
                    ]
                ]);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "saveFileInput", function(node) {
            _this.fileInput = node;
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(AjaxUploader, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._isMounted = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._isMounted = false;
                this.abort();
            }
        },
        {
            key: "post",
            value: function post(_ref3) {
                var _this2 = this;
                var data = _ref3.data, origin = _ref3.origin, action = _ref3.action, parsedFile = _ref3.parsedFile;
                if (!this._isMounted) return;
                var _this$props2 = this.props, onStart = _this$props2.onStart, customRequest = _this$props2.customRequest, name = _this$props2.name, headers = _this$props2.headers, withCredentials = _this$props2.withCredentials, method = _this$props2.method;
                var uid = origin.uid;
                var request = customRequest || (0, $11fd01730c52ca6c$export$2e2bcd8739ae039);
                var requestOption = {
                    action: action,
                    filename: name,
                    data: data,
                    file: parsedFile,
                    headers: headers,
                    withCredentials: withCredentials,
                    method: method || "post",
                    onProgress: function onProgress(e) {
                        var onProgress = _this2.props.onProgress;
                        onProgress === null || onProgress === void 0 || onProgress(e, parsedFile);
                    },
                    onSuccess: function onSuccess(ret, xhr) {
                        var onSuccess = _this2.props.onSuccess;
                        onSuccess === null || onSuccess === void 0 || onSuccess(ret, parsedFile, xhr);
                        delete _this2.reqs[uid];
                    },
                    onError: function onError(err, ret) {
                        var onError = _this2.props.onError;
                        onError === null || onError === void 0 || onError(err, ret, parsedFile);
                        delete _this2.reqs[uid];
                    }
                };
                onStart(origin);
                this.reqs[uid] = request(requestOption);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.setState({
                    uid: (0, $0daea9a81623c04d$export$2e2bcd8739ae039)()
                });
            }
        },
        {
            key: "abort",
            value: function abort(file) {
                var reqs = this.reqs;
                if (file) {
                    var uid = file.uid ? file.uid : file;
                    if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
                    delete reqs[uid];
                } else Object.keys(reqs).forEach(function(uid) {
                    if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
                    delete reqs[uid];
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _clsx;
                var _this$props3 = this.props, Tag = _this$props3.component, prefixCls = _this$props3.prefixCls, className = _this$props3.className, _this$props3$classNam = _this$props3.classNames, classNames = _this$props3$classNam === void 0 ? {} : _this$props3$classNam, disabled = _this$props3.disabled, id = _this$props3.id, style = _this$props3.style, _this$props3$styles = _this$props3.styles, styles = _this$props3$styles === void 0 ? {} : _this$props3$styles, multiple = _this$props3.multiple, accept = _this$props3.accept, capture = _this$props3.capture, children = _this$props3.children, directory = _this$props3.directory, openFileDialogOnClick = _this$props3.openFileDialogOnClick, onMouseEnter = _this$props3.onMouseEnter, onMouseLeave = _this$props3.onMouseLeave, hasControlInside = _this$props3.hasControlInside, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props3, $f6bb9b2e0d4ecc67$var$_excluded);
                var cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_clsx = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx, prefixCls, true), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx, "".concat(prefixCls, "-disabled"), disabled), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_clsx, className, className), _clsx));
                // because input don't have directory/webkitdirectory type declaration
                var dirProps = directory ? {
                    directory: "directory",
                    webkitdirectory: "webkitdirectory"
                } : {};
                var events = disabled ? {} : {
                    onClick: openFileDialogOnClick ? this.onClick : function() {},
                    onKeyDown: openFileDialogOnClick ? this.onKeyDown : function() {},
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onDrop: this.onFileDrop,
                    onDragOver: this.onFileDrop,
                    tabIndex: hasControlInside ? undefined : "0"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, events, {
                    className: cls,
                    role: hasControlInside ? undefined : "button",
                    style: style
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $281efe5882c936de$export$2e2bcd8739ae039)(otherProps, {
                    aria: true,
                    data: true
                }), {
                    id: id,
                    disabled: disabled,
                    type: "file",
                    ref: this.saveFileInput,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    } // https://github.com/ant-design/ant-design/issues/19948
                    ,
                    key: this.state.uid,
                    style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                        display: "none"
                    }, styles.input),
                    className: classNames.input,
                    accept: accept
                }, dirProps, {
                    multiple: multiple,
                    onChange: this.onChange
                }, capture != null ? {
                    capture: capture
                } : {})), children);
            }
        }
    ]);
    return AjaxUploader;
}((0, $acw62.Component));
var $f6bb9b2e0d4ecc67$export$2e2bcd8739ae039 = $f6bb9b2e0d4ecc67$var$AjaxUploader;


function $1067a457f6409605$var$empty() {}
var $1067a457f6409605$var$Upload = /*#__PURE__*/ function(_Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Upload, _Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Upload);
    function Upload() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Upload);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "uploader", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "saveUploader", function(node) {
            _this.uploader = node;
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Upload, [
        {
            key: "abort",
            value: function abort(file) {
                this.uploader.abort(file);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f6bb9b2e0d4ecc67$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.props, {
                    ref: this.saveUploader
                }));
            }
        }
    ]);
    return Upload;
}((0, $acw62.Component));
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($1067a457f6409605$var$Upload, "defaultProps", {
    component: "span",
    prefixCls: "rc-upload",
    data: {},
    headers: {},
    name: "file",
    multipart: false,
    onStart: $1067a457f6409605$var$empty,
    onError: $1067a457f6409605$var$empty,
    onSuccess: $1067a457f6409605$var$empty,
    multiple: false,
    beforeUpload: null,
    customRequest: null,
    withCredentials: false,
    openFileDialogOnClick: true,
    hasControlInside: false
});
var $1067a457f6409605$export$2e2bcd8739ae039 = $1067a457f6409605$var$Upload;


var $cb8cc710d8cb195d$export$2e2bcd8739ae039 = (0, $1067a457f6409605$export$2e2bcd8739ae039);









const $8eae2cab6b8e600b$var$genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: "hidden",
                "&-active": {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: "hidden",
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
var $8eae2cab6b8e600b$export$2e2bcd8739ae039 = $8eae2cab6b8e600b$var$genCollapseMotion;




const $7dae882f2d961dee$var$genDraggerStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-drag`]: {
                position: "relative",
                width: "100%",
                height: "100%",
                textAlign: "center",
                background: token.colorFillAlter,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: "pointer",
                transition: `border-color ${token.motionDurationSlow}`,
                [componentCls]: {
                    padding: token.padding
                },
                [`${componentCls}-btn`]: {
                    display: "table",
                    width: "100%",
                    height: "100%",
                    outline: "none",
                    borderRadius: token.borderRadiusLG,
                    "&:focus-visible": {
                        outline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`
                    }
                },
                [`${componentCls}-drag-container`]: {
                    display: "table-cell",
                    verticalAlign: "middle"
                },
                [`
          &:not(${componentCls}-disabled):hover,
          &-hover:not(${componentCls}-disabled)
        `]: {
                    borderColor: token.colorPrimaryHover
                },
                [`p${componentCls}-drag-icon`]: {
                    marginBottom: token.margin,
                    [iconCls]: {
                        color: token.colorPrimary,
                        fontSize: token.uploadThumbnailSize
                    }
                },
                [`p${componentCls}-text`]: {
                    margin: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXXS)}`,
                    color: token.colorTextHeading,
                    fontSize: token.fontSizeLG
                },
                [`p${componentCls}-hint`]: {
                    color: token.colorTextDescription,
                    fontSize: token.fontSize
                },
                // ===================== Disabled =====================
                [`&${componentCls}-disabled`]: {
                    [`p${componentCls}-drag-icon ${iconCls},
            p${componentCls}-text,
            p${componentCls}-hint
          `]: {
                        color: token.colorTextDisabled
                    }
                }
            }
        }
    };
};
var $7dae882f2d961dee$export$2e2bcd8739ae039 = $7dae882f2d961dee$var$genDraggerStyle;




const $276983e6abe3bf13$var$genListStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, fontSize: fontSize, lineHeight: lineHeight, calc: calc } = token;
    const itemCls = `${componentCls}-list-item`;
    const actionsCls = `${itemCls}-actions`;
    const actionCls = `${itemCls}-action`;
    const listItemHeightSM = token.fontHeightSM;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-list`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
                lineHeight: token.lineHeight,
                [itemCls]: {
                    position: "relative",
                    height: calc(token.lineHeight).mul(fontSize).equal(),
                    marginTop: token.marginXS,
                    fontSize: fontSize,
                    display: "flex",
                    alignItems: "center",
                    transition: `background-color ${token.motionDurationSlow}`,
                    "&:hover": {
                        backgroundColor: token.controlItemBgHover
                    },
                    [`${itemCls}-name`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                        padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)}`,
                        lineHeight: lineHeight,
                        flex: "auto",
                        transition: `all ${token.motionDurationSlow}`
                    }),
                    [actionsCls]: {
                        whiteSpace: "nowrap",
                        [actionCls]: {
                            opacity: 0
                        },
                        [iconCls]: {
                            color: token.actionsColor,
                            transition: `all ${token.motionDurationSlow}`
                        },
                        [`
              ${actionCls}:focus-visible,
              &.picture ${actionCls}
            `]: {
                            opacity: 1
                        },
                        [`${actionCls}${antCls}-btn`]: {
                            height: listItemHeightSM,
                            border: 0,
                            lineHeight: 1
                        }
                    },
                    [`${componentCls}-icon ${iconCls}`]: {
                        color: token.colorTextDescription,
                        fontSize: fontSize
                    },
                    [`${itemCls}-progress`]: {
                        position: "absolute",
                        bottom: token.calc(token.uploadProgressOffset).mul(-1).equal(),
                        width: "100%",
                        paddingInlineStart: calc(fontSize).add(token.paddingXS).equal(),
                        fontSize: fontSize,
                        lineHeight: 0,
                        pointerEvents: "none",
                        "> div": {
                            margin: 0
                        }
                    }
                },
                [`${itemCls}:hover ${actionCls}`]: {
                    opacity: 1
                },
                [`${itemCls}-error`]: {
                    color: token.colorError,
                    [`${itemCls}-name, ${componentCls}-icon ${iconCls}`]: {
                        color: token.colorError
                    },
                    [actionsCls]: {
                        [`${iconCls}, ${iconCls}:hover`]: {
                            color: token.colorError
                        },
                        [actionCls]: {
                            opacity: 1
                        }
                    }
                },
                [`${componentCls}-list-item-container`]: {
                    transition: `opacity ${token.motionDurationSlow}, height ${token.motionDurationSlow}`,
                    // For smooth removing animation
                    "&::before": {
                        display: "table",
                        width: 0,
                        height: 0,
                        content: '""'
                    }
                }
            })
        }
    };
};
var $276983e6abe3bf13$export$2e2bcd8739ae039 = $276983e6abe3bf13$var$genListStyle;





const $cfaac789ec22cce1$export$82e6205b15e6c637 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antFadeIn", {
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
const $cfaac789ec22cce1$export$c091916f1530334c = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antFadeOut", {
    "0%": {
        opacity: 1
    },
    "100%": {
        opacity: 0
    }
});
const $cfaac789ec22cce1$export$2909268c8354a12 = function(token) {
    let sameLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? "&" : "";
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, $cfaac789ec22cce1$export$82e6205b15e6c637, $cfaac789ec22cce1$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: "linear"
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: "linear"
            }
        }
    ];
};


// =========================== Motion ===========================
const $fd4f9b0935d49bdf$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const uploadAnimateInlineIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("uploadAnimateInlineIn", {
        from: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const uploadAnimateInlineOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("uploadAnimateInlineOut", {
        to: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const inlineCls = `${componentCls}-animate-inline`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${inlineCls}-appear, ${inlineCls}-enter, ${inlineCls}-leave`]: {
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseInOutCirc,
                    animationFillMode: "forwards"
                },
                [`${inlineCls}-appear, ${inlineCls}-enter`]: {
                    animationName: uploadAnimateInlineIn
                },
                [`${inlineCls}-leave`]: {
                    animationName: uploadAnimateInlineOut
                }
            }
        },
        {
            [`${componentCls}-wrapper`]: (0, $cfaac789ec22cce1$export$2909268c8354a12)(token)
        },
        uploadAnimateInlineIn,
        uploadAnimateInlineOut
    ];
};
var $fd4f9b0935d49bdf$export$2e2bcd8739ae039 = $fd4f9b0935d49bdf$var$genMotionStyle;





const $fc871974daa118a4$export$353fdbacdd19997a = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, uploadThumbnailSize: uploadThumbnailSize, uploadProgressOffset: uploadProgressOffset, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    return {
        [`${componentCls}-wrapper`]: {
            // ${listCls} 增加优先级
            [`
        ${listCls}${listCls}-picture,
        ${listCls}${listCls}-picture-card,
        ${listCls}${listCls}-picture-circle
      `]: {
                [itemCls]: {
                    position: "relative",
                    height: calc(uploadThumbnailSize).add(calc(token.lineWidth).mul(2)).add(calc(token.paddingXS).mul(2)).equal(),
                    padding: token.paddingXS,
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusLG,
                    "&:hover": {
                        background: "transparent"
                    },
                    [`${itemCls}-thumbnail`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                        width: uploadThumbnailSize,
                        height: uploadThumbnailSize,
                        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(uploadThumbnailSize).add(token.paddingSM).equal()),
                        textAlign: "center",
                        flex: "none",
                        [iconCls]: {
                            fontSize: token.fontSizeHeading2,
                            color: token.colorPrimary
                        },
                        img: {
                            display: "block",
                            width: "100%",
                            height: "100%",
                            overflow: "hidden"
                        }
                    }),
                    [`${itemCls}-progress`]: {
                        bottom: uploadProgressOffset,
                        width: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.paddingSM).mul(2).equal())})`,
                        marginTop: 0,
                        paddingInlineStart: calc(uploadThumbnailSize).add(token.paddingXS).equal()
                    }
                },
                [`${itemCls}-error`]: {
                    borderColor: token.colorError,
                    // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
                    [`${itemCls}-thumbnail ${iconCls}`]: {
                        [`svg path[fill='${(0, $0b4842326956570d$export$2aa0182783e7e9de)[0]}']`]: {
                            fill: token.colorErrorBg
                        },
                        [`svg path[fill='${(0, $0b4842326956570d$export$2aa0182783e7e9de).primary}']`]: {
                            fill: token.colorError
                        }
                    }
                },
                [`${itemCls}-uploading`]: {
                    borderStyle: "dashed",
                    [`${itemCls}-name`]: {
                        marginBottom: uploadProgressOffset
                    }
                }
            },
            [`${listCls}${listCls}-picture-circle ${itemCls}`]: {
                [`&, &::before, ${itemCls}-thumbnail`]: {
                    borderRadius: "50%"
                }
            }
        }
    };
};
const $fc871974daa118a4$export$31311f200c99910f = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    const uploadPictureCardSize = token.uploadPicCardSize;
    return {
        [`
      ${componentCls}-wrapper${componentCls}-picture-card-wrapper,
      ${componentCls}-wrapper${componentCls}-picture-circle-wrapper
    `]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
            display: "block",
            [`${componentCls}${componentCls}-select`]: {
                width: uploadPictureCardSize,
                height: uploadPictureCardSize,
                textAlign: "center",
                verticalAlign: "top",
                backgroundColor: token.colorFillAlter,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: "pointer",
                transition: `border-color ${token.motionDurationSlow}`,
                [`> ${componentCls}`]: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    textAlign: "center"
                },
                [`&:not(${componentCls}-disabled):hover`]: {
                    borderColor: token.colorPrimary
                }
            },
            // list
            [`${listCls}${listCls}-picture-card, ${listCls}${listCls}-picture-circle`]: {
                display: "flex",
                flexWrap: "wrap",
                "@supports not (gap: 1px)": {
                    "& > *": {
                        marginBlockEnd: token.marginXS,
                        marginInlineEnd: token.marginXS
                    }
                },
                "@supports (gap: 1px)": {
                    gap: token.marginXS
                },
                [`${listCls}-item-container`]: {
                    display: "inline-block",
                    width: uploadPictureCardSize,
                    height: uploadPictureCardSize,
                    verticalAlign: "top"
                },
                "&::after": {
                    display: "none"
                },
                "&::before": {
                    display: "none"
                },
                [itemCls]: {
                    height: "100%",
                    margin: 0,
                    "&::before": {
                        position: "absolute",
                        zIndex: 1,
                        width: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        height: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        backgroundColor: token.colorBgMask,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '" "'
                    }
                },
                [`${itemCls}:hover`]: {
                    [`&::before, ${itemCls}-actions`]: {
                        opacity: 1
                    }
                },
                [`${itemCls}-actions`]: {
                    position: "absolute",
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: "100%",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    [`
            ${iconCls}-eye,
            ${iconCls}-download,
            ${iconCls}-delete
          `]: {
                        zIndex: 10,
                        width: fontSizeLG,
                        margin: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXXS)}`,
                        fontSize: fontSizeLG,
                        cursor: "pointer",
                        transition: `all ${token.motionDurationSlow}`,
                        color: colorTextLightSolid,
                        "&:hover": {
                            color: colorTextLightSolid
                        },
                        svg: {
                            verticalAlign: "baseline"
                        }
                    }
                },
                [`${itemCls}-thumbnail, ${itemCls}-thumbnail img`]: {
                    position: "static",
                    display: "block",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                },
                [`${itemCls}-name`]: {
                    display: "none",
                    textAlign: "center"
                },
                [`${itemCls}-file + ${itemCls}-name`]: {
                    position: "absolute",
                    bottom: token.margin,
                    display: "block",
                    width: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`
                },
                [`${itemCls}-uploading`]: {
                    [`&${itemCls}`]: {
                        backgroundColor: token.colorFillAlter
                    },
                    [`&::before, ${iconCls}-eye, ${iconCls}-download, ${iconCls}-delete`]: {
                        display: "none"
                    }
                },
                [`${itemCls}-progress`]: {
                    bottom: token.marginXL,
                    width: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                    paddingInlineStart: 0
                }
            }
        }),
        [`${componentCls}-wrapper${componentCls}-picture-circle-wrapper`]: {
            [`${componentCls}${componentCls}-select`]: {
                borderRadius: "50%"
            }
        }
    };
};


// =========================== Motion ===========================
const $f3cb16d72b796da2$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        }
    };
};
var $f3cb16d72b796da2$export$2e2bcd8739ae039 = $f3cb16d72b796da2$var$genRtlStyle;


const $ac15cb84fb7f4f70$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, colorTextDisabled: colorTextDisabled } = token;
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            [componentCls]: {
                outline: 0,
                "input[type='file']": {
                    cursor: "pointer"
                }
            },
            [`${componentCls}-select`]: {
                display: "inline-block"
            },
            [`${componentCls}-disabled`]: {
                color: colorTextDisabled,
                cursor: "not-allowed"
            }
        })
    };
};
const $ac15cb84fb7f4f70$export$9ca1be8807fe0675 = (token)=>({
        actionsColor: token.colorTextDescription
    });
var // ============================== Export ==============================
$ac15cb84fb7f4f70$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Upload", (token)=>{
    const { fontSizeHeading3: fontSizeHeading3, fontHeight: fontHeight, lineWidth: lineWidth, controlHeightLG: controlHeightLG, calc: calc } = token;
    const uploadToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
        uploadProgressOffset: calc(calc(fontHeight).div(2)).add(lineWidth).equal(),
        uploadPicCardSize: calc(controlHeightLG).mul(2.55).equal()
    });
    return [
        $ac15cb84fb7f4f70$var$genBaseStyle(uploadToken),
        (0, $7dae882f2d961dee$export$2e2bcd8739ae039)(uploadToken),
        (0, $fc871974daa118a4$export$353fdbacdd19997a)(uploadToken),
        (0, $fc871974daa118a4$export$31311f200c99910f)(uploadToken),
        (0, $276983e6abe3bf13$export$2e2bcd8739ae039)(uploadToken),
        (0, $fd4f9b0935d49bdf$export$2e2bcd8739ae039)(uploadToken),
        (0, $f3cb16d72b796da2$export$2e2bcd8739ae039)(uploadToken),
        (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(uploadToken)
    ];
}, $ac15cb84fb7f4f70$export$9ca1be8807fe0675);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $626ce8c33f2e9bd1$var$FileTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M534 352V136H232v752h560V394H576a42 42 0 01-42-42z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0042 42h216v494z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "file",
    "theme": "twotone"
};
var $626ce8c33f2e9bd1$export$2e2bcd8739ae039 = $626ce8c33f2e9bd1$var$FileTwoTone;



var $3b2351e207d05ec8$var$FileTwoTone = function FileTwoTone(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $626ce8c33f2e9bd1$export$2e2bcd8739ae039)
    }));
};
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzNCAzNTJWMTM2SDIzMnY3NTJoNTYwVjM5NEg1NzZhNDIgNDIgMCAwMS00Mi00MnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTYwMiAxMzcuOEw3OTAuMiAzMjZINjAyVjEzNy44ek03OTIgODg4SDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIGZpbGw9IiMxNjc3ZmYiIC8+PC9zdmc+) */ var $3b2351e207d05ec8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($3b2351e207d05ec8$var$FileTwoTone);
var $3b2351e207d05ec8$export$2e2bcd8739ae039 = $3b2351e207d05ec8$var$RefIcon;





var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ab741407c256adcd$var$PaperClipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    },
    "name": "paper-clip",
    "theme": "outlined"
};
var $ab741407c256adcd$export$2e2bcd8739ae039 = $ab741407c256adcd$var$PaperClipOutlined;



var $3bbd06532cd0661e$var$PaperClipOutlined = function PaperClipOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $ab741407c256adcd$export$2e2bcd8739ae039)
    }));
};
/**![paper-clip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc3OS4zIDE5Ni42Yy05NC4yLTk0LjItMjQ3LjYtOTQuMi0zNDEuNyAwbC0yNjEgMjYwLjhjLTEuNyAxLjctMi42IDQtMi42IDYuNHMuOSA0LjcgMi42IDYuNGwzNi45IDM2LjlhOSA5IDAgMDAxMi43IDBsMjYxLTI2MC44YzMyLjQtMzIuNCA3NS41LTUwLjIgMTIxLjMtNTAuMnM4OC45IDE3LjggMTIxLjIgNTAuMmMzMi40IDMyLjQgNTAuMiA3NS41IDUwLjIgMTIxLjIgMCA0NS44LTE3LjggODguOC01MC4yIDEyMS4ybC0yNjYgMjY1LjktNDMuMSA0My4xYy00MC4zIDQwLjMtMTA1LjggNDAuMy0xNDYuMSAwLTE5LjUtMTkuNS0zMC4yLTQ1LjQtMzAuMi03M3MxMC43LTUzLjUgMzAuMi03M2wyNjMuOS0yNjMuOGM2LjctNi42IDE1LjUtMTAuMyAyNC45LTEwLjNoLjFjOS40IDAgMTguMSAzLjcgMjQuNyAxMC4zIDYuNyA2LjcgMTAuMyAxNS41IDEwLjMgMjQuOSAwIDkuMy0zLjcgMTguMS0xMC4zIDI0LjdMMzcyLjQgNjUzYy0xLjcgMS43LTIuNiA0LTIuNiA2LjRzLjkgNC43IDIuNiA2LjRsMzYuOSAzNi45YTkgOSAwIDAwMTIuNyAwbDIxNS42LTIxNS42YzE5LjktMTkuOSAzMC44LTQ2LjMgMzAuOC03NC40cy0xMS01NC42LTMwLjgtNzQuNGMtNDEuMS00MS4xLTEwNy45LTQxLTE0OSAwTDQ2MyAzNjQgMjI0LjggNjAyLjFBMTcyLjIyIDE3Mi4yMiAwIDAwMTc0IDcyNC44YzAgNDYuMyAxOC4xIDg5LjggNTAuOCAxMjIuNSAzMy45IDMzLjggNzguMyA1MC43IDEyMi43IDUwLjcgNDQuNCAwIDg4LjgtMTYuOSAxMjIuNi01MC43bDMwOS4yLTMwOUM4MjQuOCA0OTIuNyA4NTAgNDMyIDg1MCAzNjcuNWMuMS02NC42LTI1LjEtMTI1LjMtNzAuNy0xNzAuOXoiIC8+PC9zdmc+) */ var $3bbd06532cd0661e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($3bbd06532cd0661e$var$PaperClipOutlined);
var $3bbd06532cd0661e$export$2e2bcd8739ae039 = $3bbd06532cd0661e$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0544d5f04b37bdfc$var$PictureTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 110 176 88 88 0 010-176z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M276 368a28 28 0 1056 0 28 28 0 10-56 0z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "picture",
    "theme": "twotone"
};
var $0544d5f04b37bdfc$export$2e2bcd8739ae039 = $0544d5f04b37bdfc$var$PictureTwoTone;



var $64f220388a832627$var$PictureTwoTone = function PictureTwoTone(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0544d5f04b37bdfc$export$2e2bcd8739ae039)
    }));
};
/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNnYtMzkuOWwxMzguNS0xNjQuMyAxNTAuMSAxNzhMNjU4LjEgNDg5IDg4OCA3NjEuNlY3OTJ6bTAtMTI5LjhMNjY0LjIgMzk2LjhjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDQyNC42IDY2Ni40bC0xNDQtMTcwLjdjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDEzNiA2NTIuN1YyMzJoNzUydjQzMC4yeiIgZmlsbD0iIzE2NzdmZiIgLz48cGF0aCBkPSJNNDI0LjYgNzY1LjhsLTE1MC4xLTE3OEwxMzYgNzUyLjFWNzkyaDc1MnYtMzAuNEw2NTguMSA0ODl6IiBmaWxsPSIjZTZmNGZmIiAvPjxwYXRoIGQ9Ik0xMzYgNjUyLjdsMTMyLjQtMTU3YzMuMi0zLjggOS0zLjggMTIuMiAwbDE0NCAxNzAuN0w2NTIgMzk2LjhjMy4yLTMuOCA5LTMuOCAxMi4yIDBMODg4IDY2Mi4yVjIzMkgxMzZ2NDIwLjd6TTMwNCAyODBhODggODggMCAxMTAgMTc2IDg4IDg4IDAgMDEwLTE3NnoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTI3NiAzNjhhMjggMjggMCAxMDU2IDAgMjggMjggMCAxMC01NiAweiIgZmlsbD0iI2U2ZjRmZiIgLz48cGF0aCBkPSJNMzA0IDQ1NmE4OCA4OCAwIDEwMC0xNzYgODggODggMCAwMDAgMTc2em0wLTExNmMxNS41IDAgMjggMTIuNSAyOCAyOHMtMTIuNSAyOC0yOCAyOC0yOC0xMi41LTI4LTI4IDEyLjUtMjggMjgtMjh6IiBmaWxsPSIjMTY3N2ZmIiAvPjwvc3ZnPg==) */ var $64f220388a832627$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($64f220388a832627$var$PictureTwoTone);
var $64f220388a832627$export$2e2bcd8739ae039 = $64f220388a832627$var$RefIcon;










function $92d37f24422d5899$export$6dc848fd109e803d(file) {
    return Object.assign(Object.assign({}, file), {
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        size: file.size,
        type: file.type,
        uid: file.uid,
        percent: 0,
        originFileObj: file
    });
}
function $92d37f24422d5899$export$65c2063f64290f37(file, fileList) {
    const nextFileList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(fileList);
    const fileIndex = nextFileList.findIndex((_ref)=>{
        let { uid: uid } = _ref;
        return uid === file.uid;
    });
    if (fileIndex === -1) nextFileList.push(file);
    else nextFileList[fileIndex] = file;
    return nextFileList;
}
function $92d37f24422d5899$export$1165ac073f485fae(file, fileList) {
    const matchKey = file.uid !== undefined ? "uid" : "name";
    return fileList.filter((item)=>item[matchKey] === file[matchKey])[0];
}
function $92d37f24422d5899$export$f3bced642db28a96(file, fileList) {
    const matchKey = file.uid !== undefined ? "uid" : "name";
    const removed = fileList.filter((item)=>item[matchKey] !== file[matchKey]);
    if (removed.length === fileList.length) return null;
    return removed;
}
// ==================== Default Image Preview ====================
const $92d37f24422d5899$var$extname = function() {
    let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    const temp = url.split("/");
    const filename = temp[temp.length - 1];
    const filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [
        ""
    ])[0];
};
const $92d37f24422d5899$var$isImageFileType = (type)=>type.indexOf("image/") === 0;
const $92d37f24422d5899$export$431d13c2db3f6781 = (file)=>{
    if (file.type && !file.thumbUrl) return $92d37f24422d5899$var$isImageFileType(file.type);
    const url = file.thumbUrl || file.url || "";
    const extension = $92d37f24422d5899$var$extname(url);
    if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|heic|heif)$/i.test(extension)) return true;
    if (/^data:/.test(url)) // other file types of base64
    return false;
    if (extension) // other file types which have extension
    return false;
    return true;
};
const $92d37f24422d5899$var$MEASURE_SIZE = 200;
function $92d37f24422d5899$export$b5db251096956c0d(file) {
    return new Promise((resolve)=>{
        if (!file.type || !$92d37f24422d5899$var$isImageFileType(file.type)) {
            resolve("");
            return;
        }
        const canvas = document.createElement("canvas");
        canvas.width = $92d37f24422d5899$var$MEASURE_SIZE;
        canvas.height = $92d37f24422d5899$var$MEASURE_SIZE;
        canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${$92d37f24422d5899$var$MEASURE_SIZE}px; height: ${$92d37f24422d5899$var$MEASURE_SIZE}px; z-index: 9999; display: none;`;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.onload = ()=>{
            const { width: width, height: height } = img;
            let drawWidth = $92d37f24422d5899$var$MEASURE_SIZE;
            let drawHeight = $92d37f24422d5899$var$MEASURE_SIZE;
            let offsetX = 0;
            let offsetY = 0;
            if (width > height) {
                drawHeight = height * ($92d37f24422d5899$var$MEASURE_SIZE / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            } else {
                drawWidth = width * ($92d37f24422d5899$var$MEASURE_SIZE / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            const dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);
            window.URL.revokeObjectURL(img.src);
            resolve(dataURL);
        };
        img.crossOrigin = "anonymous";
        if (file.type.startsWith("image/svg+xml")) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result && typeof reader.result === "string") img.src = reader.result;
            };
            reader.readAsDataURL(file);
        } else if (file.type.startsWith("image/gif")) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result) resolve(reader.result);
            };
            reader.readAsDataURL(file);
        } else img.src = window.URL.createObjectURL(file);
    });
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $1f7080d7f45398b4$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
var $1f7080d7f45398b4$export$2e2bcd8739ae039 = $1f7080d7f45398b4$var$DeleteOutlined;



var $66758f779ccbee67$var$DeleteOutlined = function DeleteOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $1f7080d7f45398b4$export$2e2bcd8739ae039)
    }));
};
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ var $66758f779ccbee67$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($66758f779ccbee67$var$DeleteOutlined);
var $66758f779ccbee67$export$2e2bcd8739ae039 = $66758f779ccbee67$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $bc4d543ef1b2f293$var$DownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "download",
    "theme": "outlined"
};
var $bc4d543ef1b2f293$export$2e2bcd8739ae039 = $bc4d543ef1b2f293$var$DownloadOutlined;



var $36f671eea1f29809$var$DownloadOutlined = function DownloadOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $bc4d543ef1b2f293$export$2e2bcd8739ae039)
    }));
};
/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ var $36f671eea1f29809$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($36f671eea1f29809$var$DownloadOutlined);
var $36f671eea1f29809$export$2e2bcd8739ae039 = $36f671eea1f29809$var$RefIcon;







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8e7f784a29e9449d$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
var $8e7f784a29e9449d$export$2e2bcd8739ae039 = $8e7f784a29e9449d$var$CheckCircleFilled;



var $9149fdfb4424d1d9$var$CheckCircleFilled = function CheckCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $8e7f784a29e9449d$export$2e2bcd8739ae039)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ var $9149fdfb4424d1d9$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9149fdfb4424d1d9$var$CheckCircleFilled);
var $9149fdfb4424d1d9$export$2e2bcd8739ae039 = $9149fdfb4424d1d9$var$RefIcon;











var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $76abf5bce6617d70$export$9c21a3269931e1e6 = {
    percent: 0,
    prefixCls: "rc-progress",
    strokeColor: "#2db7f5",
    strokeLinecap: "round",
    strokeWidth: 1,
    trailColor: "#D9D9D9",
    trailWidth: 1,
    gapPosition: "bottom"
};
var $76abf5bce6617d70$export$7685006d504ecf0b = function useTransitionDuration() {
    var pathsRef = (0, $acw62.useRef)([]);
    var prevTimeStamp = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        var now = Date.now();
        var updated = false;
        pathsRef.current.forEach(function(path) {
            if (!path) return;
            updated = true;
            var pathStyle = path.style;
            pathStyle.transitionDuration = ".3s, .3s, .3s, .06s";
            if (prevTimeStamp.current && now - prevTimeStamp.current < 100) pathStyle.transitionDuration = "0s, 0s";
        });
        if (updated) prevTimeStamp.current = Date.now();
    });
    return pathsRef.current;
};


var $607f7793730da27c$var$_excluded = [
    "className",
    "percent",
    "prefixCls",
    "strokeColor",
    "strokeLinecap",
    "strokeWidth",
    "style",
    "trailColor",
    "trailWidth",
    "transition"
];
var $607f7793730da27c$var$Line = function Line(props) {
    var _defaultProps$props = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $76abf5bce6617d70$export$9c21a3269931e1e6)), props), className = _defaultProps$props.className, percent = _defaultProps$props.percent, prefixCls = _defaultProps$props.prefixCls, strokeColor = _defaultProps$props.strokeColor, strokeLinecap = _defaultProps$props.strokeLinecap, strokeWidth = _defaultProps$props.strokeWidth, style = _defaultProps$props.style, trailColor = _defaultProps$props.trailColor, trailWidth = _defaultProps$props.trailWidth, transition = _defaultProps$props.transition, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_defaultProps$props, $607f7793730da27c$var$_excluded);
    // eslint-disable-next-line no-param-reassign
    delete restProps.gapPosition;
    var percentList = Array.isArray(percent) ? percent : [
        percent
    ];
    var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [
        strokeColor
    ];
    var paths = (0, $76abf5bce6617d70$export$7685006d504ecf0b)();
    var center = strokeWidth / 2;
    var right = 100 - strokeWidth / 2;
    var pathString = "M ".concat(strokeLinecap === "round" ? center : 0, ",").concat(center, "\n         L ").concat(strokeLinecap === "round" ? right : 100, ",").concat(center);
    var viewBoxString = "0 0 100 ".concat(strokeWidth);
    var stackPtg = 0;
    return /*#__PURE__*/ $acw62.createElement("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-line"), className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
    }, restProps), /*#__PURE__*/ $acw62.createElement("path", {
        className: "".concat(prefixCls, "-line-trail"),
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: trailColor,
        strokeWidth: trailWidth || strokeWidth,
        fillOpacity: "0"
    }), percentList.map(function(ptg, index) {
        var dashPercent = 1;
        switch(strokeLinecap){
            case "round":
                dashPercent = 1 - strokeWidth / 100;
                break;
            case "square":
                dashPercent = 1 - strokeWidth / 2 / 100;
                break;
            default:
                dashPercent = 1;
                break;
        }
        var pathStyle = {
            strokeDasharray: "".concat(ptg * dashPercent, "px, 100px"),
            strokeDashoffset: "-".concat(stackPtg, "px"),
            transition: transition || "stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear"
        };
        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return /*#__PURE__*/ $acw62.createElement("path", {
            key: index,
            className: "".concat(prefixCls, "-line-path"),
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: color,
            strokeWidth: strokeWidth,
            fillOpacity: "0",
            ref: function ref(elem) {
                // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                // React will call the ref callback with the DOM element when the component mounts,
                // and call it with `null` when it unmounts.
                // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                paths[index] = elem;
            },
            style: pathStyle
        });
    }));
};
var $607f7793730da27c$export$2e2bcd8739ae039 = $607f7793730da27c$var$Line;







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $2f0314bf683ae0bb$var$uuid = 0;
var $2f0314bf683ae0bb$export$df7146797a248522 = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)();
/** Get unique id for accessibility usage */ function $2f0314bf683ae0bb$var$getUUID() {
    var retId;
    // Test never reach
    /* istanbul ignore if */ if ($2f0314bf683ae0bb$export$df7146797a248522) {
        retId = $2f0314bf683ae0bb$var$uuid;
        $2f0314bf683ae0bb$var$uuid += 1;
    } else retId = "TEST_OR_SSR";
    return retId;
}
var $2f0314bf683ae0bb$export$2e2bcd8739ae039 = function(id) {
    // Inner id for accessibility usage. Only work in client side
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    $acw62.useEffect(function() {
        setInnerId("rc_progress_".concat($2f0314bf683ae0bb$var$getUUID()));
    }, []);
    return id || innerId;
};




var $acw62 = parcelRequire("acw62");
var $af852ec14b138ea1$var$Block = function Block(_ref) {
    var bg = _ref.bg, children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            width: "100%",
            height: "100%",
            background: bg
        }
    }, children);
};
function $af852ec14b138ea1$var$getPtgColors(color, scale) {
    return Object.keys(color).map(function(key) {
        var parsedKey = parseFloat(key);
        var ptgKey = "".concat(Math.floor(parsedKey * scale), "%");
        return "".concat(color[key], " ").concat(ptgKey);
    });
}
var $af852ec14b138ea1$var$PtgCircle = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, color = props.color, gradientId = props.gradientId, radius = props.radius, circleStyleForStack = props.style, ptg = props.ptg, strokeLinecap = props.strokeLinecap, strokeWidth = props.strokeWidth, size = props.size, gapDegree = props.gapDegree;
    var isGradient = color && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(color) === "object";
    var stroke = isGradient ? "#FFF" : undefined;
    // ========================== Circle ==========================
    var halfSize = size / 2;
    var circleNode = /*#__PURE__*/ $acw62.createElement("circle", {
        className: "".concat(prefixCls, "-circle-path"),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: stroke,
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth,
        opacity: ptg === 0 ? 0 : 1,
        style: circleStyleForStack,
        ref: ref
    });
    // ========================== Render ==========================
    if (!isGradient) return circleNode;
    var maskId = "".concat(gradientId, "-conic");
    var fromDeg = gapDegree ? "".concat(180 + gapDegree / 2, "deg") : "0deg";
    var conicColors = $af852ec14b138ea1$var$getPtgColors(color, (360 - gapDegree) / 360);
    var linearColors = $af852ec14b138ea1$var$getPtgColors(color, 1);
    var conicColorBg = "conic-gradient(from ".concat(fromDeg, ", ").concat(conicColors.join(", "), ")");
    var linearColorBg = "linear-gradient(to ".concat(gapDegree ? "bottom" : "top", ", ").concat(linearColors.join(", "), ")");
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("mask", {
        id: maskId
    }, circleNode), /*#__PURE__*/ $acw62.createElement("foreignObject", {
        x: 0,
        y: 0,
        width: size,
        height: size,
        mask: "url(#".concat(maskId, ")")
    }, /*#__PURE__*/ $acw62.createElement($af852ec14b138ea1$var$Block, {
        bg: linearColorBg
    }, /*#__PURE__*/ $acw62.createElement($af852ec14b138ea1$var$Block, {
        bg: conicColorBg
    }))));
});
var $af852ec14b138ea1$export$2e2bcd8739ae039 = $af852ec14b138ea1$var$PtgCircle;


var $e5cd7fac6dcd6e96$export$b8239b3abadfb141 = 100;
var $e5cd7fac6dcd6e96$export$b0aaf64d8cc0f6db = function getCircleStyle(perimeter, perimeterWithoutGap, offset, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth) {
    var stepSpace = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 0;
    var offsetDeg = offset / 100 * 360 * ((360 - gapDegree) / 360);
    var positionDeg = gapDegree === 0 ? 0 : ({
        bottom: 0,
        top: 180,
        left: 90,
        right: -90
    })[gapPosition];
    var strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
    // Fix percent accuracy when strokeLinecap is round
    // https://github.com/ant-design/ant-design/issues/35009
    if (strokeLinecap === "round" && percent !== 100) {
        strokeDashoffset += strokeWidth / 2;
        // when percent is small enough (<= 1%), keep smallest value to avoid it's disappearance
        if (strokeDashoffset >= perimeterWithoutGap) strokeDashoffset = perimeterWithoutGap - 0.01;
    }
    var halfSize = $e5cd7fac6dcd6e96$export$b8239b3abadfb141 / 2;
    return {
        stroke: typeof strokeColor === "string" ? strokeColor : undefined,
        strokeDasharray: "".concat(perimeterWithoutGap, "px ").concat(perimeter),
        strokeDashoffset: strokeDashoffset + stepSpace,
        transform: "rotate(".concat(rotateDeg + offsetDeg + positionDeg, "deg)"),
        transformOrigin: "".concat(halfSize, "px ").concat(halfSize, "px"),
        transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
        fillOpacity: 0
    };
};


var $e074a89d31a955bb$var$_excluded = [
    "id",
    "prefixCls",
    "steps",
    "strokeWidth",
    "trailWidth",
    "gapDegree",
    "gapPosition",
    "trailColor",
    "strokeLinecap",
    "style",
    "className",
    "strokeColor",
    "percent"
];
function $e074a89d31a955bb$var$toArray(value) {
    var mergedValue = value !== null && value !== void 0 ? value : [];
    return Array.isArray(mergedValue) ? mergedValue : [
        mergedValue
    ];
}
var $e074a89d31a955bb$var$Circle = function Circle(props) {
    var _defaultProps$props = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $76abf5bce6617d70$export$9c21a3269931e1e6)), props), id = _defaultProps$props.id, prefixCls = _defaultProps$props.prefixCls, steps = _defaultProps$props.steps, strokeWidth = _defaultProps$props.strokeWidth, trailWidth = _defaultProps$props.trailWidth, _defaultProps$props$g = _defaultProps$props.gapDegree, gapDegree = _defaultProps$props$g === void 0 ? 0 : _defaultProps$props$g, gapPosition = _defaultProps$props.gapPosition, trailColor = _defaultProps$props.trailColor, strokeLinecap = _defaultProps$props.strokeLinecap, style = _defaultProps$props.style, className = _defaultProps$props.className, strokeColor = _defaultProps$props.strokeColor, percent = _defaultProps$props.percent, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_defaultProps$props, $e074a89d31a955bb$var$_excluded);
    var halfSize = (0, $e5cd7fac6dcd6e96$export$b8239b3abadfb141) / 2;
    var mergedId = (0, $2f0314bf683ae0bb$export$2e2bcd8739ae039)(id);
    var gradientId = "".concat(mergedId, "-gradient");
    var radius = halfSize - strokeWidth / 2;
    var perimeter = Math.PI * 2 * radius;
    var rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
    var perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
    var _ref = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(steps) === "object" ? steps : {
        count: steps,
        gap: 2
    }, stepCount = _ref.count, stepGap = _ref.gap;
    var percentList = $e074a89d31a955bb$var$toArray(percent);
    var strokeColorList = $e074a89d31a955bb$var$toArray(strokeColor);
    var gradient = strokeColorList.find(function(color) {
        return color && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(color) === "object";
    });
    var isConicGradient = gradient && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(gradient) === "object";
    var mergedStrokeLinecap = isConicGradient ? "butt" : strokeLinecap;
    var circleStyle = (0, $e5cd7fac6dcd6e96$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, trailColor, mergedStrokeLinecap, strokeWidth);
    var paths = (0, $76abf5bce6617d70$export$7685006d504ecf0b)();
    var getStokeList = function getStokeList() {
        var stackPtg = 0;
        return percentList.map(function(ptg, index) {
            var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
            var circleStyleForStack = (0, $e5cd7fac6dcd6e96$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, mergedStrokeLinecap, strokeWidth);
            stackPtg += ptg;
            return /*#__PURE__*/ $acw62.createElement((0, $af852ec14b138ea1$export$2e2bcd8739ae039), {
                key: index,
                color: color,
                ptg: ptg,
                radius: radius,
                prefixCls: prefixCls,
                gradientId: gradientId,
                style: circleStyleForStack,
                strokeLinecap: mergedStrokeLinecap,
                strokeWidth: strokeWidth,
                gapDegree: gapDegree,
                ref: function ref(elem) {
                    // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                    // React will call the ref callback with the DOM element when the component mounts,
                    // and call it with `null` when it unmounts.
                    // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                    paths[index] = elem;
                },
                size: (0, $e5cd7fac6dcd6e96$export$b8239b3abadfb141)
            });
        }).reverse();
    };
    var getStepStokeList = function getStepStokeList() {
        // only show the first percent when pass steps
        var current = Math.round(stepCount * (percentList[0] / 100));
        var stepPtg = 100 / stepCount;
        var stackPtg = 0;
        return new Array(stepCount).fill(null).map(function(_, index) {
            var color = index <= current - 1 ? strokeColorList[0] : trailColor;
            var stroke = color && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(color) === "object" ? "url(#".concat(gradientId, ")") : undefined;
            var circleStyleForStack = (0, $e5cd7fac6dcd6e96$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, "butt", strokeWidth, stepGap);
            stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepGap) * 100 / perimeterWithoutGap;
            return /*#__PURE__*/ $acw62.createElement("circle", {
                key: index,
                className: "".concat(prefixCls, "-circle-path"),
                r: radius,
                cx: halfSize,
                cy: halfSize,
                stroke: stroke,
                strokeWidth: strokeWidth,
                opacity: 1,
                style: circleStyleForStack,
                ref: function ref(elem) {
                    paths[index] = elem;
                }
            });
        });
    };
    return /*#__PURE__*/ $acw62.createElement("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-circle"), className),
        viewBox: "0 0 ".concat((0, $e5cd7fac6dcd6e96$export$b8239b3abadfb141), " ").concat((0, $e5cd7fac6dcd6e96$export$b8239b3abadfb141)),
        style: style,
        id: id,
        role: "presentation"
    }, restProps), !stepCount && /*#__PURE__*/ $acw62.createElement("circle", {
        className: "".concat(prefixCls, "-circle-trail"),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: trailColor,
        strokeLinecap: mergedStrokeLinecap,
        strokeWidth: trailWidth || strokeWidth,
        style: circleStyle
    }), stepCount ? getStepStokeList() : getStokeList());
};
var $e074a89d31a955bb$export$2e2bcd8739ae039 = $e074a89d31a955bb$var$Circle;


var $f8f3b94d2ebc8ea9$export$2e2bcd8739ae039 = {
    Line: (0, $607f7793730da27c$export$2e2bcd8739ae039),
    Circle: (0, $e074a89d31a955bb$export$2e2bcd8739ae039)
};



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $576260377b469890$export$2e2bcd8739ae039(props) {
    var children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === "function" ? children() : children));
}







var $acw62 = parcelRequire("acw62");
var $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
var $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
var $6c7c9d120875ff76$var$targetOffset = [
    0,
    0
];
var $6c7c9d120875ff76$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $6c7c9d120875ff76$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $6c7c9d120875ff76$var$targetOffset
    }
};
var $6c7c9d120875ff76$export$2e2bcd8739ae039 = $6c7c9d120875ff76$export$803cd8101b6c182b;



var $870014fb7370caba$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $870014fb7370caba$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $870014fb7370caba$var$_excluded);
    var triggerRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return triggerRef.current;
    });
    var extraProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps);
    if ("visible" in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $acw62.createElement((0, $576260377b469890$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $6c7c9d120875ff76$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay,
        arrow: showArrow
    }, extraProps), children);
};
var $870014fb7370caba$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.forwardRef)($870014fb7370caba$var$Tooltip);


var $d0136ab94ce7f56e$export$2e2bcd8739ae039 = (0, $870014fb7370caba$export$2e2bcd8739ae039);







function $0c0596420865f622$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $0c0596420865f622$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    return {
        pointerEvents: "none",
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: "hidden",
        "&::before": {
            position: "absolute",
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        "&::after": {
            content: '""',
            position: "absolute",
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: "auto",
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(borderRadiusXS)} 0`
            },
            transform: "translateY(50%) rotate(-135deg)",
            boxShadow: boxShadow,
            zIndex: 0,
            background: "transparent"
        }
    };
};


const $13cd8c878b3c9176$export$de6e4ffc9ec3c089 = 8;
function $13cd8c878b3c9176$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $13cd8c878b3c9176$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
function $13cd8c878b3c9176$var$isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function $13cd8c878b3c9176$export$2e2bcd8739ae039(token, colorBg, options) {
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal } = token;
    const { arrowDistance: arrowDistance = 0, arrowPlacement: arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                Object.assign(Object.assign({
                    position: "absolute",
                    zIndex: 1,
                    display: "block"
                }, (0, $0c0596420865f622$export$601fa0375eb80eec)(token, colorBg, boxShadowPopoverArrow)), {
                    "&:before": {
                        background: colorBg
                    }
                })
            ]
        }, $13cd8c878b3c9176$var$isInject(!!arrowPlacement.top, {
            [[
                `&-placement-top > ${componentCls}-arrow`,
                `&-placement-topLeft > ${componentCls}-arrow`,
                `&-placement-topRight > ${componentCls}-arrow`
            ].join(",")]: {
                bottom: arrowDistance,
                transform: "translateY(100%) rotate(180deg)"
            },
            [`&-placement-top > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateX(-50%) translateY(100%) rotate(180deg)"
            },
            [`&-placement-topLeft > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            },
            [`&-placement-topRight > ${componentCls}-arrow`]: {
                right: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.bottom, {
            [[
                `&-placement-bottom > ${componentCls}-arrow`,
                `&-placement-bottomLeft > ${componentCls}-arrow`,
                `&-placement-bottomRight > ${componentCls}-arrow`
            ].join(",")]: {
                top: arrowDistance,
                transform: `translateY(-100%)`
            },
            [`&-placement-bottom > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: `translateX(-50%) translateY(-100%)`
            },
            [`&-placement-bottomLeft > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            },
            [`&-placement-bottomRight > ${componentCls}-arrow`]: {
                right: {
                    _skip_check_: true,
                    value: arrowOffsetHorizontal
                }
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.left, {
            [[
                `&-placement-left > ${componentCls}-arrow`,
                `&-placement-leftTop > ${componentCls}-arrow`,
                `&-placement-leftBottom > ${componentCls}-arrow`
            ].join(",")]: {
                right: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: "translateX(100%) rotate(90deg)"
            },
            [`&-placement-left > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateY(-50%) translateX(100%) rotate(90deg)"
            },
            [`&-placement-leftTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        })), $13cd8c878b3c9176$var$isInject(!!arrowPlacement.right, {
            [[
                `&-placement-right > ${componentCls}-arrow`,
                `&-placement-rightTop > ${componentCls}-arrow`,
                `&-placement-rightBottom > ${componentCls}-arrow`
            ].join(",")]: {
                left: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: "translateX(-100%) rotate(-90deg)"
            },
            [`&-placement-right > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
            },
            [`&-placement-rightTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        }))
    };
}


function $aa2151c32cec40fb$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === "object" ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case "top":
        case "bottom":
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case "left":
        case "right":
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $aa2151c32cec40fb$var$PlacementAlignMap = {
    left: {
        points: [
            "cr",
            "cl"
        ]
    },
    right: {
        points: [
            "cl",
            "cr"
        ]
    },
    top: {
        points: [
            "bc",
            "tc"
        ]
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ]
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tr"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ]
    }
};
const $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            "bl",
            "tc"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "cl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tc"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "cr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "bc"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "cr"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bc"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "cl"
        ]
    }
};
const $aa2151c32cec40fb$var$DisableAutoArrowList = new Set([
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight",
    "leftTop",
    "leftBottom",
    "rightTop",
    "rightBottom"
]);
function $aa2151c32cec40fb$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    Object.keys($aa2151c32cec40fb$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $aa2151c32cec40fb$var$ArrowCenterPlacementAlignMap[key] || $aa2151c32cec40fb$var$PlacementAlignMap[key];
        const placementInfo = Object.assign(Object.assign({}, template), {
            offset: [
                0,
                0
            ],
            dynamicInset: true
        });
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($aa2151c32cec40fb$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case "top":
            case "topLeft":
            case "topRight":
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case "bottom":
            case "bottomLeft":
            case "bottomRight":
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case "left":
            case "leftTop":
            case "leftBottom":
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case "right":
            case "rightTop":
            case "rightBottom":
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        // Dynamic offset
        const arrowOffset = (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
            contentRadius: borderRadius,
            limitVerticalRadius: true
        });
        if (arrowPointAtCenter) switch(key){
            case "topLeft":
            case "bottomLeft":
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case "topRight":
            case "bottomRight":
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case "leftTop":
            case "rightTop":
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case "leftBottom":
            case "rightBottom":
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $aa2151c32cec40fb$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = "visibleFirst";
    });
    return placementMap;
}








var $acw62 = parcelRequire("acw62");







const $d2082114d5952afb$export$3b71758b3ed5255f = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomIn", {
    "0%": {
        transform: "scale(0.2)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
const $d2082114d5952afb$export$9fdb0a49c6b4b521 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.2)",
        opacity: 0
    }
});
const $d2082114d5952afb$export$be061d573c42e33a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomBigIn", {
    "0%": {
        transform: "scale(0.8)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
const $d2082114d5952afb$export$582d93d613303da3 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomBigOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.8)",
        opacity: 0
    }
});
const $d2082114d5952afb$export$45eddd18c599b827 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomUpIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    }
});
const $d2082114d5952afb$export$a85c97750adaa37a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomUpOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    }
});
const $d2082114d5952afb$export$bd2378f7814f5f1a = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomLeftIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    }
});
const $d2082114d5952afb$export$e58f88c751c4f04e = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomLeftOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    }
});
const $d2082114d5952afb$export$fee1456954aef331 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomRightIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    }
});
const $d2082114d5952afb$export$811ba6d3e2adb730 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomRightOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    }
});
const $d2082114d5952afb$export$633a68aa72dec21c = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomDownIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    }
});
const $d2082114d5952afb$export$1cf46a906e8dede4 = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomDownOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    }
});
const $d2082114d5952afb$var$zoomMotion = {
    zoom: {
        inKeyframes: $d2082114d5952afb$export$3b71758b3ed5255f,
        outKeyframes: $d2082114d5952afb$export$9fdb0a49c6b4b521
    },
    "zoom-big": {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    "zoom-big-fast": {
        inKeyframes: $d2082114d5952afb$export$be061d573c42e33a,
        outKeyframes: $d2082114d5952afb$export$582d93d613303da3
    },
    "zoom-left": {
        inKeyframes: $d2082114d5952afb$export$bd2378f7814f5f1a,
        outKeyframes: $d2082114d5952afb$export$e58f88c751c4f04e
    },
    "zoom-right": {
        inKeyframes: $d2082114d5952afb$export$fee1456954aef331,
        outKeyframes: $d2082114d5952afb$export$811ba6d3e2adb730
    },
    "zoom-up": {
        inKeyframes: $d2082114d5952afb$export$45eddd18c599b827,
        outKeyframes: $d2082114d5952afb$export$a85c97750adaa37a
    },
    "zoom-down": {
        inKeyframes: $d2082114d5952afb$export$633a68aa72dec21c,
        outKeyframes: $d2082114d5952afb$export$1cf46a906e8dede4
    }
};
const $d2082114d5952afb$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $d2082114d5952afb$var$zoomMotion[motionName];
    return [
        (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === "zoom-big-fast" ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: "scale(0)",
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                "&-prepare": {
                    transform: "none"
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};




const $8bbb48c728db3fab$export$6d4fe3a00a1811ad = [
    "blue",
    "purple",
    "cyan",
    "green",
    "magenta",
    "pink",
    "red",
    "orange",
    "yellow",
    "volcano",
    "geekblue",
    "lime",
    "gold"
];


function $69386722b4e8be32$export$2e2bcd8739ae039(token, genCss) {
    return (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return Object.assign(Object.assign({}, prev), genCss(colorKey, {
            lightColor: lightColor,
            lightBorderColor: lightBorderColor,
            darkColor: darkColor,
            textColor: textColor
        }));
    }, {});
}


const $8bcca9e8f96db88a$var$genTooltipStyle = (token)=>{
    const { componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, boxShadowSecondary: boxShadowSecondary, paddingSM: paddingSM, paddingXS: paddingXS } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: "absolute",
                zIndex: zIndexPopup,
                display: "block",
                width: "max-content",
                maxWidth: tooltipMaxWidth,
                visibility: "visible",
                transformOrigin: `var(--arrow-x, 50%) var(--arrow-y, 50%)`,
                "&-hidden": {
                    display: "none"
                },
                "--antd-arrow-background-color": tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-inner`]: {
                    minWidth: "1em",
                    minHeight: controlHeight,
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)}`,
                    color: tooltipColor,
                    textAlign: "start",
                    textDecoration: "none",
                    wordWrap: "break-word",
                    backgroundColor: tooltipBg,
                    borderRadius: tooltipBorderRadius,
                    boxShadow: boxShadowSecondary,
                    boxSizing: "border-box"
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(",")]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $13cd8c878b3c9176$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: "relative"
                }
            }), (0, $69386722b4e8be32$export$2e2bcd8739ae039)(token, (colorKey, _ref)=>{
                let { darkColor: darkColor } = _ref;
                return {
                    [`&${componentCls}-${colorKey}`]: {
                        [`${componentCls}-inner`]: {
                            backgroundColor: darkColor
                        },
                        [`${componentCls}-arrow`]: {
                            "--antd-arrow-background-color": darkColor
                        }
                    }
                };
            })), {
                // RTL
                "&-rtl": {
                    direction: "rtl"
                }
            })
        },
        // Arrow Style
        (0, $13cd8c878b3c9176$export$2e2bcd8739ae039)(token, "var(--antd-arrow-background-color)"),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: "relative",
                maxWidth: "none",
                margin: token.sizePopupArrow
            }
        }
    ];
};
const $8bcca9e8f96db88a$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 70
    }, (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
        contentRadius: token.borderRadius,
        limitVerticalRadius: true
    })), (0, $0c0596420865f622$export$87e38ee403661ccc)((0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
    })));
var $8bcca9e8f96db88a$export$2e2bcd8739ae039 = function(prefixCls) {
    let injectStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const useStyle = (0, $099b764a368ed79c$export$51ec95de45185b42)("Tooltip", (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight } = token;
        const TooltipToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $8bcca9e8f96db88a$var$genTooltipStyle(TooltipToken),
            (0, $d2082114d5952afb$export$f5d123412490d9dc)(token, "zoom-big-fast")
        ];
    }, $8bcca9e8f96db88a$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls);
};


/* eslint-disable import/prefer-default-export */ 


const $1513ceb924eda9b6$var$inverseColors = (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $1513ceb924eda9b6$export$bb684163c94c55ae = [
    "success",
    "processing",
    "error",
    "default",
    "warning"
];
function $1513ceb924eda9b6$export$ee62ebd6a58c4884(color) {
    let includeInverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (includeInverse) return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($1513ceb924eda9b6$var$inverseColors), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).includes(color);
}
function $1513ceb924eda9b6$export$88a0ba1f7d1ea40e(color) {
    return $1513ceb924eda9b6$export$bb684163c94c55ae.includes(color);
}


function $080c438853985df7$export$6e865ea70d7724f(prefixCls, color) {
    const isInternalColor = (0, $1513ceb924eda9b6$export$ee62ebd6a58c4884)(color);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        // @ts-ignore
        arrowStyle["--antd-arrow-background-color"] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
}


"use client";
/** @private Internal Component. Do not use in your production. */ const $e604628db2f2c0d3$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = "top", title: title, color: color, overlayInnerStyle: overlayInnerStyle } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8bcca9e8f96db88a$export$2e2bcd8739ae039)(prefixCls);
    // Color
    const colorInfo = (0, $080c438853985df7$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: arrowContentStyle
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $acw62.createElement((0, $576260377b469890$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls,
        overlayInnerStyle: formattedOverlayInnerStyle
    }), title)));
};
var $e604628db2f2c0d3$export$2e2bcd8739ae039 = $e604628db2f2c0d3$var$PurePanel;




"use client";
var $0ac88bf86814a6e5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0ac88bf86814a6e5$var$InternalTooltip = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, overlayClassName: overlayClassName, color: color, overlayInnerStyle: overlayInnerStyle, children: children, afterOpenChange: afterOpenChange, afterVisibleChange: afterVisibleChange, destroyTooltipOnHide: destroyTooltipOnHide, arrow: arrow = true, title: title, overlay: overlay, builtinPlacements: builtinPlacements, arrowPointAtCenter: arrowPointAtCenter = false, autoAdjustOverflow: autoAdjustOverflow = true } = props;
    const mergedShowArrow = !!arrow;
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    // ============================== Ref ===============================
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("Tooltip");
    const tooltipRef = $acw62.useRef(null);
    const forceAlign = ()=>{
        var _a;
        (_a = tooltipRef.current) === null || _a === void 0 || _a.forceAlign();
    };
    $acw62.useImperativeHandle(ref, ()=>{
        var _a;
        return {
            forceAlign: forceAlign,
            forcePopupAlign: ()=>{
                warning.deprecated(false, "forcePopupAlign", "forceAlign");
                forceAlign();
            },
            nativeElement: (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
        };
    });
    var _ref;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    });
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onOpenChange = (vis)=>{
        var _a, _b;
        setOpen(noTitle ? false : vis);
        if (!noTitle) {
            (_a = props.onOpenChange) === null || _a === void 0 || _a.call(props, vis);
            (_b = props.onVisibleChange) === null || _b === void 0 || _b.call(props, vis);
        }
    };
    const tooltipPlacements = $acw62.useMemo(()=>{
        var _a, _b;
        let mergedArrowPointAtCenter = arrowPointAtCenter;
        if (typeof arrow === "object") mergedArrowPointAtCenter = (_b = (_a = arrow.pointAtCenter) !== null && _a !== void 0 ? _a : arrow.arrowPointAtCenter) !== null && _b !== void 0 ? _b : arrowPointAtCenter;
        return builtinPlacements || (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrowPointAtCenter,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        arrowPointAtCenter,
        arrow,
        builtinPlacements,
        token
    ]);
    const memoOverlay = $acw62.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || "";
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        space: true
    }, typeof memoOverlay === "function" ? memoOverlay() : memoOverlay);
    const { getPopupContainer: getPopupContainer, placement: placement = "top", mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, overlayStyle: overlayStyle, rootClassName: rootClassName } = props, otherProps = $0ac88bf86814a6e5$var$__rest(props, [
        "getPopupContainer",
        "placement",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayStyle",
        "rootClassName"
    ]);
    const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props["data-popover-inject"];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!("open" in props) && !("visible" in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $acw62.isValidElement(children) && !(0, $30796c32f374b477$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $acw62.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8bcca9e8f96db88a$export$2e2bcd8739ae039)(prefixCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $080c438853985df7$export$6e865ea70d7724f)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
    const customOverlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, colorInfo.className, rootClassName, hashId, cssVarCls);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("Tooltip", otherProps.zIndex);
    const content = /*#__PURE__*/ $acw62.createElement((0, $d0136ab94ce7f56e$export$2e2bcd8739ae039), Object.assign({}, otherProps, {
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        overlayClassName: customOverlayClassName,
        overlayStyle: Object.assign(Object.assign({}, arrowContentStyle), overlayStyle),
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onOpenChange,
        afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        overlayInnerStyle: formattedOverlayInnerStyle,
        arrowContent: /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom-big-fast", props.transitionName),
            motionDeadline: 1000
        },
        destroyTooltipOnHide: !!destroyTooltipOnHide
    }), tempOpen ? (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content));
});
const $0ac88bf86814a6e5$var$Tooltip = $0ac88bf86814a6e5$var$InternalTooltip;
$0ac88bf86814a6e5$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $e604628db2f2c0d3$export$2e2bcd8739ae039);
var $0ac88bf86814a6e5$export$2e2bcd8739ae039 = $0ac88bf86814a6e5$var$Tooltip;



function $2cf86ffe54834eec$export$2caef35201f951a0(progress) {
    if (!progress || progress < 0) return 0;
    if (progress > 100) return 100;
    return progress;
}
function $2cf86ffe54834eec$export$4ab1c09ce4ee99b(_ref) {
    let { success: success, successPercent: successPercent } = _ref;
    let percent = successPercent;
    /** @deprecated Use `percent` instead */ if (success && "progress" in success) percent = success.progress;
    if (success && "percent" in success) percent = success.percent;
    return percent;
}
const $2cf86ffe54834eec$export$6712e0f6cd0ea03 = (_ref2)=>{
    let { percent: percent, success: success, successPercent: successPercent } = _ref2;
    const realSuccessPercent = $2cf86ffe54834eec$export$2caef35201f951a0($2cf86ffe54834eec$export$4ab1c09ce4ee99b({
        success: success,
        successPercent: successPercent
    }));
    return [
        realSuccessPercent,
        $2cf86ffe54834eec$export$2caef35201f951a0($2cf86ffe54834eec$export$2caef35201f951a0(percent) - realSuccessPercent)
    ];
};
const $2cf86ffe54834eec$export$a73db48ef11a2bc3 = (_ref3)=>{
    let { success: success = {}, strokeColor: strokeColor } = _ref3;
    const { strokeColor: successColor } = success;
    return [
        successColor || (0, $0b4842326956570d$export$3968a3afc810b5f5).green,
        strokeColor || null
    ];
};
const $2cf86ffe54834eec$export$31b21d0167753bb4 = (size, type, extra)=>{
    var _a, _b, _c, _d;
    let width = -1;
    let height = -1;
    if (type === "step") {
        const steps = extra.steps;
        const strokeWidth = extra.strokeWidth;
        if (typeof size === "string" || typeof size === "undefined") {
            width = size === "small" ? 2 : 14;
            height = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 8;
        } else if (typeof size === "number") [width, height] = [
            size,
            size
        ];
        else [width = 14, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
        width *= steps;
    } else if (type === "line") {
        const strokeWidth = extra === null || extra === void 0 ? void 0 : extra.strokeWidth;
        if (typeof size === "string" || typeof size === "undefined") height = strokeWidth || (size === "small" ? 6 : 8);
        else if (typeof size === "number") [width, height] = [
            size,
            size
        ];
        else [width = -1, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
    } else if (type === "circle" || type === "dashboard") {
        if (typeof size === "string" || typeof size === "undefined") [width, height] = size === "small" ? [
            60,
            60
        ] : [
            120,
            120
        ];
        else if (typeof size === "number") [width, height] = [
            size,
            size
        ];
        else if (Array.isArray(size)) {
            width = (_b = (_a = size[0]) !== null && _a !== void 0 ? _a : size[1]) !== null && _b !== void 0 ? _b : 120;
            height = (_d = (_c = size[0]) !== null && _c !== void 0 ? _c : size[1]) !== null && _d !== void 0 ? _d : 120;
        }
    }
    return [
        width,
        height
    ];
};


"use client";
const $91e7bbf5efc79f50$var$CIRCLE_MIN_STROKE_WIDTH = 3;
const $91e7bbf5efc79f50$var$getMinPercent = (width)=>$91e7bbf5efc79f50$var$CIRCLE_MIN_STROKE_WIDTH / width * 100;
const $91e7bbf5efc79f50$var$Circle = (props)=>{
    const { prefixCls: prefixCls, trailColor: trailColor = null, strokeLinecap: strokeLinecap = "round", gapPosition: gapPosition, gapDegree: gapDegree, width: originWidth = 120, type: type, children: children, success: success, size: size = originWidth, steps: steps } = props;
    const [width, height] = (0, $2cf86ffe54834eec$export$31b21d0167753bb4)(size, "circle");
    let { strokeWidth: strokeWidth } = props;
    if (strokeWidth === undefined) strokeWidth = Math.max($91e7bbf5efc79f50$var$getMinPercent(width), 6);
    const circleStyle = {
        width: width,
        height: height,
        fontSize: width * 0.15 + 6
    };
    const realGapDegree = $acw62.useMemo(()=>{
        // Support gapDeg = 0 when type = 'dashboard'
        if (gapDegree || gapDegree === 0) return gapDegree;
        if (type === "dashboard") return 75;
        return undefined;
    }, [
        gapDegree,
        type
    ]);
    const percentArray = (0, $2cf86ffe54834eec$export$6712e0f6cd0ea03)(props);
    const gapPos = gapPosition || type === "dashboard" && "bottom" || undefined;
    // using className to style stroke color
    const isGradient = Object.prototype.toString.call(props.strokeColor) === "[object Object]";
    const strokeColor = (0, $2cf86ffe54834eec$export$a73db48ef11a2bc3)({
        success: success,
        strokeColor: props.strokeColor
    });
    const wrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-inner`, {
        [`${prefixCls}-circle-gradient`]: isGradient
    });
    const circleContent = /*#__PURE__*/ $acw62.createElement((0, $e074a89d31a955bb$export$2e2bcd8739ae039), {
        steps: steps,
        percent: steps ? percentArray[1] : percentArray,
        strokeWidth: strokeWidth,
        trailWidth: strokeWidth,
        strokeColor: steps ? strokeColor[1] : strokeColor,
        strokeLinecap: strokeLinecap,
        trailColor: trailColor,
        prefixCls: prefixCls,
        gapDegree: realGapDegree,
        gapPosition: gapPos
    });
    const smallCircle = width <= 20;
    const node = /*#__PURE__*/ $acw62.createElement("div", {
        className: wrapperClassName,
        style: circleStyle
    }, circleContent, !smallCircle && children);
    if (smallCircle) return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
        title: children
    }, node);
    return node;
};
var $91e7bbf5efc79f50$export$2e2bcd8739ae039 = $91e7bbf5efc79f50$var$Circle;



var $acw62 = parcelRequire("acw62");






const $71f0fece0b4c83b2$export$ce7447cfda329128 = "--progress-line-stroke-color";
const $71f0fece0b4c83b2$export$cbc348af47898b5e = "--progress-percent";
const $71f0fece0b4c83b2$var$genAntProgressActive = (isRtl)=>{
    const direction = isRtl ? "100%" : "-100%";
    return new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)(`antProgress${isRtl ? "RTL" : "LTR"}Active`, {
        "0%": {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.1
        },
        "20%": {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.5
        },
        to: {
            transform: "translateX(0) scaleX(1)",
            opacity: 0
        }
    });
};
const $71f0fece0b4c83b2$var$genBaseStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            display: "inline-block",
            "&-rtl": {
                direction: "rtl"
            },
            "&-line": {
                position: "relative",
                width: "100%",
                fontSize: token.fontSize
            },
            [`${progressCls}-outer`]: {
                display: "inline-flex",
                alignItems: "center",
                width: "100%"
            },
            [`${progressCls}-inner`]: {
                position: "relative",
                display: "inline-block",
                width: "100%",
                flex: 1,
                overflow: "hidden",
                verticalAlign: "middle",
                backgroundColor: token.remainingColor,
                borderRadius: token.lineBorderRadius
            },
            [`${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.defaultColor
                }
            },
            [`${progressCls}-success-bg, ${progressCls}-bg`]: {
                position: "relative",
                background: token.defaultColor,
                borderRadius: token.lineBorderRadius,
                transition: `all ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`
            },
            [`${progressCls}-layout-bottom`]: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                [`${progressCls}-text`]: {
                    width: "max-content",
                    marginInlineStart: 0,
                    marginTop: token.marginXXS
                }
            },
            [`${progressCls}-bg`]: {
                overflow: "hidden",
                "&::after": {
                    content: '""',
                    background: {
                        _multi_value_: true,
                        value: [
                            "inherit",
                            `var(${$71f0fece0b4c83b2$export$ce7447cfda329128})`
                        ]
                    },
                    height: "100%",
                    width: `calc(1 / var(${$71f0fece0b4c83b2$export$cbc348af47898b5e}) * 100%)`,
                    display: "block"
                },
                [`&${progressCls}-bg-inner`]: {
                    minWidth: "max-content",
                    "&::after": {
                        content: "none"
                    },
                    [`${progressCls}-text-inner`]: {
                        color: token.colorWhite,
                        [`&${progressCls}-text-bright`]: {
                            color: "rgba(0, 0, 0, 0.45)"
                        }
                    }
                }
            },
            [`${progressCls}-success-bg`]: {
                position: "absolute",
                insetBlockStart: 0,
                insetInlineStart: 0,
                backgroundColor: token.colorSuccess
            },
            [`${progressCls}-text`]: {
                display: "inline-block",
                marginInlineStart: token.marginXS,
                color: token.colorText,
                lineHeight: 1,
                width: "2em",
                whiteSpace: "nowrap",
                textAlign: "start",
                verticalAlign: "middle",
                wordBreak: "normal",
                [iconPrefixCls]: {
                    fontSize: token.fontSize
                },
                [`&${progressCls}-text-outer`]: {
                    width: "max-content"
                },
                [`&${progressCls}-text-outer${progressCls}-text-start`]: {
                    width: "max-content",
                    marginInlineStart: 0,
                    marginInlineEnd: token.marginXS
                }
            },
            [`${progressCls}-text-inner`]: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                marginInlineStart: 0,
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXXS)}`,
                [`&${progressCls}-text-start`]: {
                    justifyContent: "start"
                },
                [`&${progressCls}-text-end`]: {
                    justifyContent: "end"
                }
            },
            [`&${progressCls}-status-active`]: {
                [`${progressCls}-bg::before`]: {
                    position: "absolute",
                    inset: 0,
                    backgroundColor: token.colorBgContainer,
                    borderRadius: token.lineBorderRadius,
                    opacity: 0,
                    animationName: $71f0fece0b4c83b2$var$genAntProgressActive(),
                    animationDuration: token.progressActiveMotionDuration,
                    animationTimingFunction: token.motionEaseOutQuint,
                    animationIterationCount: "infinite",
                    content: '""'
                }
            },
            [`&${progressCls}-rtl${progressCls}-status-active`]: {
                [`${progressCls}-bg::before`]: {
                    animationName: $71f0fece0b4c83b2$var$genAntProgressActive(true)
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-bg`]: {
                    backgroundColor: token.colorError
                },
                [`${progressCls}-text`]: {
                    color: token.colorError
                }
            },
            [`&${progressCls}-status-exception ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.colorError
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-bg`]: {
                    backgroundColor: token.colorSuccess
                },
                [`${progressCls}-text`]: {
                    color: token.colorSuccess
                }
            },
            [`&${progressCls}-status-success ${progressCls}-inner:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.colorSuccess
                }
            }
        })
    };
};
const $71f0fece0b4c83b2$var$genCircleStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-circle-trail`]: {
                stroke: token.remainingColor
            },
            [`&${progressCls}-circle ${progressCls}-inner`]: {
                position: "relative",
                lineHeight: 1,
                backgroundColor: "transparent"
            },
            [`&${progressCls}-circle ${progressCls}-text`]: {
                position: "absolute",
                insetBlockStart: "50%",
                insetInlineStart: 0,
                width: "100%",
                margin: 0,
                padding: 0,
                color: token.circleTextColor,
                fontSize: token.circleTextFontSize,
                lineHeight: 1,
                whiteSpace: "normal",
                textAlign: "center",
                transform: "translateY(-50%)",
                [iconPrefixCls]: {
                    fontSize: token.circleIconFontSize
                }
            },
            [`${progressCls}-circle&-status-exception`]: {
                [`${progressCls}-text`]: {
                    color: token.colorError
                }
            },
            [`${progressCls}-circle&-status-success`]: {
                [`${progressCls}-text`]: {
                    color: token.colorSuccess
                }
            }
        },
        [`${progressCls}-inline-circle`]: {
            lineHeight: 1,
            [`${progressCls}-inner`]: {
                verticalAlign: "bottom"
            }
        }
    };
};
const $71f0fece0b4c83b2$var$genStepStyle = (token)=>{
    const { componentCls: progressCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-steps`]: {
                display: "inline-block",
                "&-outer": {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                },
                "&-item": {
                    flexShrink: 0,
                    minWidth: token.progressStepMinWidth,
                    marginInlineEnd: token.progressStepMarginInlineEnd,
                    backgroundColor: token.remainingColor,
                    transition: `all ${token.motionDurationSlow}`,
                    "&-active": {
                        backgroundColor: token.defaultColor
                    }
                }
            }
        }
    };
};
const $71f0fece0b4c83b2$var$genSmallLine = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-text ${iconPrefixCls}`]: {
                fontSize: token.fontSizeSM
            }
        }
    };
};
const $71f0fece0b4c83b2$export$9ca1be8807fe0675 = (token)=>({
        circleTextColor: token.colorText,
        defaultColor: token.colorInfo,
        remainingColor: token.colorFillSecondary,
        lineBorderRadius: 100,
        // magic for capsule shape, should be a very large number
        circleTextFontSize: "1em",
        circleIconFontSize: `${token.fontSize / token.fontSizeSM}em`
    });
var $71f0fece0b4c83b2$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Progress", (token)=>{
    const progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
    const progressToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        progressStepMarginInlineEnd: progressStepMarginInlineEnd,
        progressStepMinWidth: progressStepMarginInlineEnd,
        progressActiveMotionDuration: "2.4s"
    });
    return [
        $71f0fece0b4c83b2$var$genBaseStyle(progressToken),
        $71f0fece0b4c83b2$var$genCircleStyle(progressToken),
        $71f0fece0b4c83b2$var$genStepStyle(progressToken),
        $71f0fece0b4c83b2$var$genSmallLine(progressToken)
    ];
}, $71f0fece0b4c83b2$export$9ca1be8807fe0675);



"use client";
var $0c3b2e7d253c6288$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0c3b2e7d253c6288$export$8947b167cf78cbe = (gradients)=>{
    let tempArr = [];
    Object.keys(gradients).forEach((key)=>{
        const formattedKey = parseFloat(key.replace(/%/g, ""));
        if (!isNaN(formattedKey)) tempArr.push({
            key: formattedKey,
            value: gradients[key]
        });
    });
    tempArr = tempArr.sort((a, b)=>a.key - b.key);
    return tempArr.map((_ref)=>{
        let { key: key, value: value } = _ref;
        return `${value} ${key}%`;
    }).join(", ");
};
const $0c3b2e7d253c6288$export$22b6122229807a9f = (strokeColor, directionConfig)=>{
    const { from: from = (0, $0b4842326956570d$export$3968a3afc810b5f5).blue, to: to = (0, $0b4842326956570d$export$3968a3afc810b5f5).blue, direction: direction = directionConfig === "rtl" ? "to left" : "to right" } = strokeColor, rest = $0c3b2e7d253c6288$var$__rest(strokeColor, [
        "from",
        "to",
        "direction"
    ]);
    if (Object.keys(rest).length !== 0) {
        const sortedGradients = $0c3b2e7d253c6288$export$8947b167cf78cbe(rest);
        const background = `linear-gradient(${direction}, ${sortedGradients})`;
        return {
            background: background,
            [(0, $71f0fece0b4c83b2$export$ce7447cfda329128)]: background
        };
    }
    const background = `linear-gradient(${direction}, ${from}, ${to})`;
    return {
        background: background,
        [(0, $71f0fece0b4c83b2$export$ce7447cfda329128)]: background
    };
};
const $0c3b2e7d253c6288$var$Line = (props)=>{
    const { prefixCls: prefixCls, direction: directionConfig, percent: percent, size: size, strokeWidth: strokeWidth, strokeColor: strokeColor, strokeLinecap: strokeLinecap = "round", children: children, trailColor: trailColor = null, percentPosition: percentPosition, success: success } = props;
    const { align: infoAlign, type: infoPosition } = percentPosition;
    const backgroundProps = strokeColor && typeof strokeColor !== "string" ? $0c3b2e7d253c6288$export$22b6122229807a9f(strokeColor, directionConfig) : {
        [(0, $71f0fece0b4c83b2$export$ce7447cfda329128)]: strokeColor,
        background: strokeColor
    };
    const borderRadius = strokeLinecap === "square" || strokeLinecap === "butt" ? 0 : undefined;
    const mergedSize = size !== null && size !== void 0 ? size : [
        -1,
        strokeWidth || (size === "small" ? 6 : 8)
    ];
    const [width, height] = (0, $2cf86ffe54834eec$export$31b21d0167753bb4)(mergedSize, "line", {
        strokeWidth: strokeWidth
    });
    const trailStyle = {
        backgroundColor: trailColor || undefined,
        borderRadius: borderRadius
    };
    const percentStyle = Object.assign(Object.assign({
        width: `${(0, $2cf86ffe54834eec$export$2caef35201f951a0)(percent)}%`,
        height: height,
        borderRadius: borderRadius
    }, backgroundProps), {
        [(0, $71f0fece0b4c83b2$export$cbc348af47898b5e)]: (0, $2cf86ffe54834eec$export$2caef35201f951a0)(percent) / 100
    });
    const successPercent = (0, $2cf86ffe54834eec$export$4ab1c09ce4ee99b)(props);
    const successPercentStyle = {
        width: `${(0, $2cf86ffe54834eec$export$2caef35201f951a0)(successPercent)}%`,
        height: height,
        borderRadius: borderRadius,
        backgroundColor: success === null || success === void 0 ? void 0 : success.strokeColor
    };
    const outerStyle = {
        width: width < 0 ? "100%" : width
    };
    const lineInner = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inner`,
        style: trailStyle
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-bg`, `${prefixCls}-bg-${infoPosition}`),
        style: percentStyle
    }, infoPosition === "inner" && children), successPercent !== undefined && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-success-bg`,
        style: successPercentStyle
    }));
    const isOuterStart = infoPosition === "outer" && infoAlign === "start";
    const isOuterEnd = infoPosition === "outer" && infoAlign === "end";
    return infoPosition === "outer" && infoAlign === "center" ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-layout-bottom`
    }, lineInner, children) : /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-outer`,
        style: outerStyle
    }, isOuterStart && children, lineInner, isOuterEnd && children);
};
var $0c3b2e7d253c6288$export$2e2bcd8739ae039 = $0c3b2e7d253c6288$var$Line;



var $acw62 = parcelRequire("acw62");


"use client";
const $7dfe5fefa8fd560b$var$Steps = (props)=>{
    const { size: size, steps: steps, percent: percent = 0, strokeWidth: strokeWidth = 8, strokeColor: strokeColor, trailColor: trailColor = null, prefixCls: prefixCls, children: children } = props;
    const current = Math.round(steps * (percent / 100));
    const stepWidth = size === "small" ? 2 : 14;
    const mergedSize = size !== null && size !== void 0 ? size : [
        stepWidth,
        strokeWidth
    ];
    const [width, height] = (0, $2cf86ffe54834eec$export$31b21d0167753bb4)(mergedSize, "step", {
        steps: steps,
        strokeWidth: strokeWidth
    });
    const unitWidth = width / steps;
    const styledSteps = new Array(steps);
    for(let i = 0; i < steps; i++){
        const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
        styledSteps[i] = /*#__PURE__*/ $acw62.createElement("div", {
            key: i,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-steps-item`, {
                [`${prefixCls}-steps-item-active`]: i <= current - 1
            }),
            style: {
                backgroundColor: i <= current - 1 ? color : trailColor,
                width: unitWidth,
                height: height
            }
        });
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-steps-outer`
    }, styledSteps, children);
};
var $7dfe5fefa8fd560b$export$2e2bcd8739ae039 = $7dfe5fefa8fd560b$var$Steps;




"use client";
var $37272e79c54f1843$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $37272e79c54f1843$export$e54ebc7fe4b5dc4e = [
    "line",
    "circle",
    "dashboard"
];
const $37272e79c54f1843$var$ProgressStatuses = [
    "normal",
    "exception",
    "active",
    "success"
];
const $37272e79c54f1843$var$Progress = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, steps: steps, strokeColor: strokeColor, percent: percent = 0, size: size = "default", showInfo: showInfo = true, type: type = "line", status: status, format: format, style: style, percentPosition: percentPosition = {} } = props, restProps = $37272e79c54f1843$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "steps",
        "strokeColor",
        "percent",
        "size",
        "showInfo",
        "type",
        "status",
        "format",
        "style",
        "percentPosition"
    ]);
    const { align: infoAlign = "end", type: infoPosition = "outer" } = percentPosition;
    const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
    const strokeColorNotGradient = typeof strokeColor === "string" || Array.isArray(strokeColor) ? strokeColor : undefined;
    const strokeColorIsBright = $acw62.useMemo(()=>{
        if (strokeColorNotArray) {
            const color = typeof strokeColorNotArray === "string" ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
            return new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(color).isLight();
        }
        return false;
    }, [
        strokeColor
    ]);
    const percentNumber = $acw62.useMemo(()=>{
        var _a, _b;
        const successPercent = (0, $2cf86ffe54834eec$export$4ab1c09ce4ee99b)(props);
        return parseInt(successPercent !== undefined ? (_a = successPercent !== null && successPercent !== void 0 ? successPercent : 0) === null || _a === void 0 ? void 0 : _a.toString() : (_b = percent !== null && percent !== void 0 ? percent : 0) === null || _b === void 0 ? void 0 : _b.toString(), 10);
    }, [
        percent,
        props.success,
        props.successPercent
    ]);
    const progressStatus = $acw62.useMemo(()=>{
        if (!$37272e79c54f1843$var$ProgressStatuses.includes(status) && percentNumber >= 100) return "success";
        return status || "normal";
    }, [
        status,
        percentNumber
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, progress: progressStyle } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("progress", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $71f0fece0b4c83b2$export$2e2bcd8739ae039)(prefixCls);
    const isLineType = type === "line";
    const isPureLineType = isLineType && !steps;
    const progressInfo = $acw62.useMemo(()=>{
        if (!showInfo) return null;
        const successPercent = (0, $2cf86ffe54834eec$export$4ab1c09ce4ee99b)(props);
        let text;
        const textFormatter = format || ((number)=>`${number}%`);
        const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === "inner";
        if (infoPosition === "inner" || format || progressStatus !== "exception" && progressStatus !== "success") text = textFormatter((0, $2cf86ffe54834eec$export$2caef35201f951a0)(percent), (0, $2cf86ffe54834eec$export$2caef35201f951a0)(successPercent));
        else if (progressStatus === "exception") text = isLineType ? /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null);
        else if (progressStatus === "success") text = isLineType ? /*#__PURE__*/ $acw62.createElement((0, $9149fdfb4424d1d9$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $acw62.createElement("span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-text`, {
                [`${prefixCls}-text-bright`]: isBrightInnerColor,
                [`${prefixCls}-text-${infoAlign}`]: isPureLineType,
                [`${prefixCls}-text-${infoPosition}`]: isPureLineType
            }),
            title: typeof text === "string" ? text : undefined
        }, text);
    }, [
        showInfo,
        percent,
        percentNumber,
        progressStatus,
        type,
        prefixCls,
        format
    ]);
    let progress;
    // Render progress shape
    if (type === "line") progress = steps ? /*#__PURE__*/ $acw62.createElement((0, $7dfe5fefa8fd560b$export$2e2bcd8739ae039), Object.assign({}, props, {
        strokeColor: strokeColorNotGradient,
        prefixCls: prefixCls,
        steps: typeof steps === "object" ? steps.count : steps
    }), progressInfo) : /*#__PURE__*/ $acw62.createElement((0, $0c3b2e7d253c6288$export$2e2bcd8739ae039), Object.assign({}, props, {
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        direction: direction,
        percentPosition: {
            align: infoAlign,
            type: infoPosition
        }
    }), progressInfo);
    else if (type === "circle" || type === "dashboard") progress = /*#__PURE__*/ $acw62.createElement((0, $91e7bbf5efc79f50$export$2e2bcd8739ae039), Object.assign({}, props, {
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        progressStatus: progressStatus
    }), progressInfo);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-status-${progressStatus}`, {
        [`${prefixCls}-${type === "dashboard" && "circle" || type}`]: type !== "line",
        [`${prefixCls}-inline-circle`]: type === "circle" && (0, $2cf86ffe54834eec$export$31b21d0167753bb4)(size, "circle")[0] <= 20,
        [`${prefixCls}-line`]: isPureLineType,
        [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
        [`${prefixCls}-steps`]: steps,
        [`${prefixCls}-show-info`]: showInfo,
        [`${prefixCls}-${size}`]: typeof size === "string",
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.className, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        ref: ref,
        style: Object.assign(Object.assign({}, progressStyle === null || progressStyle === void 0 ? void 0 : progressStyle.style), style),
        className: classString,
        role: "progressbar",
        "aria-valuenow": percentNumber,
        "aria-valuemin": 0,
        "aria-valuemax": 100
    }, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(restProps, [
        "trailColor",
        "strokeWidth",
        "width",
        "gapDegree",
        "gapPosition",
        "strokeLinecap",
        "success",
        "successPercent"
    ])), progress));
});
var $37272e79c54f1843$export$2e2bcd8739ae039 = $37272e79c54f1843$var$Progress;


"use client";
var $79bdee06e67dd736$export$2e2bcd8739ae039 = (0, $37272e79c54f1843$export$2e2bcd8739ae039);



"use client";
const $1987780c1c55678a$var$ListItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { prefixCls: prefixCls, className: className, style: style, locale: locale, listType: listType, file: file, items: items, progress: progressProps, iconRender: iconRender, actionIconRender: actionIconRender, itemRender: itemRender, isImgUrl: isImgUrl, showPreviewIcon: showPreviewIcon, showRemoveIcon: showRemoveIcon, showDownloadIcon: showDownloadIcon, previewIcon: customPreviewIcon, removeIcon: customRemoveIcon, downloadIcon: customDownloadIcon, onPreview: onPreview, onDownload: onDownload, onClose: onClose } = _ref;
    var _a, _b;
    // Status: which will ignore `removed` status
    const { status: status } = file;
    const [mergedStatus, setMergedStatus] = $acw62.useState(status);
    $acw62.useEffect(()=>{
        if (status !== "removed") setMergedStatus(status);
    }, [
        status
    ]);
    // Delay to show the progress bar
    const [showProgress, setShowProgress] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        const timer = setTimeout(()=>{
            setShowProgress(true);
        }, 300);
        return ()=>{
            clearTimeout(timer);
        };
    }, []);
    const iconNode = iconRender(file);
    let icon = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-icon`
    }, iconNode);
    if (listType === "picture" || listType === "picture-card" || listType === "picture-circle") {
        if (mergedStatus === "uploading" || !file.thumbUrl && !file.url) {
            const uploadingClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: mergedStatus !== "uploading"
            });
            icon = /*#__PURE__*/ $acw62.createElement("div", {
                className: uploadingClassName
            }, iconNode);
        } else {
            const thumbnail = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /*#__PURE__*/ $acw62.createElement("img", {
                src: file.thumbUrl || file.url,
                alt: file.name,
                className: `${prefixCls}-list-item-image`,
                crossOrigin: file.crossOrigin
            }) : iconNode;
            const aClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: isImgUrl && !isImgUrl(file)
            });
            icon = /*#__PURE__*/ $acw62.createElement("a", {
                className: aClassName,
                onClick: (e)=>onPreview(file, e),
                href: file.url || file.thumbUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, thumbnail);
        }
    }
    const listItemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list-item`, `${prefixCls}-list-item-${mergedStatus}`);
    const linkProps = typeof file.linkProps === "string" ? JSON.parse(file.linkProps) : file.linkProps;
    const removeIcon = showRemoveIcon ? actionIconRender((typeof customRemoveIcon === "function" ? customRemoveIcon(file) : customRemoveIcon) || /*#__PURE__*/ $acw62.createElement((0, $66758f779ccbee67$export$2e2bcd8739ae039), null), ()=>onClose(file), prefixCls, locale.removeFile, // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    true) : null;
    const downloadIcon = showDownloadIcon && mergedStatus === "done" ? actionIconRender((typeof customDownloadIcon === "function" ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/ $acw62.createElement((0, $36f671eea1f29809$export$2e2bcd8739ae039), null), ()=>onDownload(file), prefixCls, locale.downloadFile) : null;
    const downloadOrDelete = listType !== "picture-card" && listType !== "picture-circle" && /*#__PURE__*/ $acw62.createElement("span", {
        key: "download-delete",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list-item-actions`, {
            picture: listType === "picture"
        })
    }, downloadIcon, removeIcon);
    const listItemNameClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list-item-name`);
    const fileName = file.url ? [
        /*#__PURE__*/ $acw62.createElement("a", Object.assign({
            key: "view",
            target: "_blank",
            rel: "noopener noreferrer",
            className: listItemNameClass,
            title: file.name
        }, linkProps, {
            href: file.url,
            onClick: (e)=>onPreview(file, e)
        }), file.name),
        downloadOrDelete
    ] : [
        /*#__PURE__*/ $acw62.createElement("span", {
            key: "view",
            className: listItemNameClass,
            onClick: (e)=>onPreview(file, e),
            title: file.name
        }, file.name),
        downloadOrDelete
    ];
    const previewIcon = showPreviewIcon && (file.url || file.thumbUrl) ? /*#__PURE__*/ $acw62.createElement("a", {
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (e)=>onPreview(file, e),
        title: locale.previewFile
    }, typeof customPreviewIcon === "function" ? customPreviewIcon(file) : customPreviewIcon || /*#__PURE__*/ $acw62.createElement((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), null)) : null;
    const pictureCardActions = (listType === "picture-card" || listType === "picture-circle") && mergedStatus !== "uploading" && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-list-item-actions`
    }, previewIcon, mergedStatus === "done" && downloadIcon, removeIcon);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const dom = /*#__PURE__*/ $acw62.createElement("div", {
        className: listItemClassName
    }, icon, fileName, pictureCardActions, showProgress && /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        motionName: `${rootPrefixCls}-fade`,
        visible: mergedStatus === "uploading",
        motionDeadline: 2000
    }, (_ref2)=>{
        let { className: motionClassName } = _ref2;
        // show loading icon if upload progress listener is disabled
        const loadingProgress = "percent" in file ? /*#__PURE__*/ $acw62.createElement((0, $79bdee06e67dd736$export$2e2bcd8739ae039), Object.assign({}, progressProps, {
            type: "line",
            percent: file.percent,
            "aria-label": file["aria-label"],
            "aria-labelledby": file["aria-labelledby"]
        })) : null;
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list-item-progress`, motionClassName)
        }, loadingProgress);
    }));
    const message = file.response && typeof file.response === "string" ? file.response : ((_a = file.error) === null || _a === void 0 ? void 0 : _a.statusText) || ((_b = file.error) === null || _b === void 0 ? void 0 : _b.message) || locale.uploadError;
    const item = mergedStatus === "error" ? /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
        title: message,
        getPopupContainer: (node)=>node.parentNode
    }, dom) : dom;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list-item-container`, className),
        style: style,
        ref: ref
    }, itemRender ? itemRender(item, file, items, {
        download: onDownload.bind(null, file),
        preview: onPreview.bind(null, file),
        remove: onClose.bind(null, file)
    }) : item);
});
var $1987780c1c55678a$export$2e2bcd8739ae039 = $1987780c1c55678a$var$ListItem;


"use client";
const $e81d74349446ce57$var$InternalUploadList = (props, ref)=>{
    const { listType: listType = "text", previewFile: previewFile = (0, $92d37f24422d5899$export$b5db251096956c0d), onPreview: onPreview, onDownload: onDownload, onRemove: onRemove, locale: locale, iconRender: iconRender, isImageUrl: isImgUrl = (0, $92d37f24422d5899$export$431d13c2db3f6781), prefixCls: customizePrefixCls, items: items = [], showPreviewIcon: showPreviewIcon = true, showRemoveIcon: showRemoveIcon = true, showDownloadIcon: showDownloadIcon = false, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, progress: progress = {
        size: [
            -1,
            2
        ],
        showInfo: false
    }, appendAction: appendAction, appendActionVisible: appendActionVisible = true, itemRender: itemRender, disabled: disabled } = props;
    const forceUpdate = (0, $dcbb6d0bd42650d6$export$2e2bcd8739ae039)();
    const [motionAppear, setMotionAppear] = $acw62.useState(false);
    // ============================= Effect =============================
    $acw62.useEffect(()=>{
        if (listType !== "picture" && listType !== "picture-card" && listType !== "picture-circle") return;
        (items || []).forEach((file)=>{
            if (typeof document === "undefined" || typeof window === "undefined" || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) return;
            file.thumbUrl = "";
            if (previewFile) previewFile(file.originFileObj).then((previewDataUrl)=>{
                // Need append '' to avoid dead loop
                file.thumbUrl = previewDataUrl || "";
                forceUpdate();
            });
        });
    }, [
        listType,
        items,
        previewFile
    ]);
    $acw62.useEffect(()=>{
        setMotionAppear(true);
    }, []);
    // ============================= Events =============================
    const onInternalPreview = (file, e)=>{
        if (!onPreview) return;
        e === null || e === void 0 || e.preventDefault();
        return onPreview(file);
    };
    const onInternalDownload = (file)=>{
        if (typeof onDownload === "function") onDownload(file);
        else if (file.url) window.open(file.url);
    };
    const onInternalClose = (file)=>{
        onRemove === null || onRemove === void 0 || onRemove(file);
    };
    const internalIconRender = (file)=>{
        if (iconRender) return iconRender(file, listType);
        const isLoading = file.status === "uploading";
        const fileIcon = (isImgUrl === null || isImgUrl === void 0 ? void 0 : isImgUrl(file)) ? /*#__PURE__*/ $acw62.createElement((0, $64f220388a832627$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $3b2351e207d05ec8$export$2e2bcd8739ae039), null);
        let icon = isLoading ? /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $3bbd06532cd0661e$export$2e2bcd8739ae039), null);
        if (listType === "picture") icon = isLoading ? /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null) : fileIcon;
        else if (listType === "picture-card" || listType === "picture-circle") icon = isLoading ? locale.uploading : fileIcon;
        return icon;
    };
    const actionIconRender = (customIcon, callback, prefixCls, title, acceptUploadDisabled)=>{
        const btnProps = {
            type: "text",
            size: "small",
            title: title,
            onClick: (e)=>{
                var _a, _b;
                callback();
                if (/*#__PURE__*/ $acw62.isValidElement(customIcon)) (_b = (_a = customIcon.props).onClick) === null || _b === void 0 || _b.call(_a, e);
            },
            className: `${prefixCls}-list-item-action`
        };
        if (acceptUploadDisabled) btnProps.disabled = disabled;
        if (/*#__PURE__*/ $acw62.isValidElement(customIcon)) {
            const btnIcon = (0, $30796c32f374b477$export$e530037191fcd5d7)(customIcon, Object.assign(Object.assign({}, customIcon.props), {
                onClick: ()=>{}
            }));
            return /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), Object.assign({}, btnProps, {
                icon: btnIcon
            }));
        }
        return /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), Object.assign({}, btnProps), /*#__PURE__*/ $acw62.createElement("span", null, customIcon));
    };
    // ============================== Ref ===============================
    // Test needs
    $acw62.useImperativeHandle(ref, ()=>({
            handlePreview: onInternalPreview,
            handleDownload: onInternalDownload
        }));
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    // ============================= Render =============================
    const prefixCls = getPrefixCls("upload", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const listClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-list`, `${prefixCls}-list-${listType}`);
    // >>> Motion config
    const motionKeyList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(items.map((file)=>({
            key: file.uid,
            file: file
        })));
    const animationDirection = listType === "picture-card" || listType === "picture-circle" ? "animate-inline" : "animate";
    // const transitionName = list.length === 0 ? '' : `${prefixCls}-${animationDirection}`;
    let motionConfig = {
        motionDeadline: 2000,
        motionName: `${prefixCls}-${animationDirection}`,
        keys: motionKeyList,
        motionAppear: motionAppear
    };
    const listItemMotion = $acw62.useMemo(()=>{
        const motion = Object.assign({}, (0, $2efb522a5615f01e$export$2e2bcd8739ae039)(rootPrefixCls));
        delete motion.onAppearEnd;
        delete motion.onEnterEnd;
        delete motion.onLeaveEnd;
        return motion;
    }, [
        rootPrefixCls
    ]);
    if (listType !== "picture-card" && listType !== "picture-circle") motionConfig = Object.assign(Object.assign({}, listItemMotion), motionConfig);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: listClassNames
    }, /*#__PURE__*/ $acw62.createElement((0, $ab0f5c5a9767e13d$export$2e2bcd8739ae039), Object.assign({}, motionConfig, {
        component: false
    }), (_ref)=>{
        let { key: key, file: file, className: motionClassName, style: motionStyle } = _ref;
        return /*#__PURE__*/ $acw62.createElement((0, $1987780c1c55678a$export$2e2bcd8739ae039), {
            key: key,
            locale: locale,
            prefixCls: prefixCls,
            className: motionClassName,
            style: motionStyle,
            file: file,
            items: items,
            progress: progress,
            listType: listType,
            isImgUrl: isImgUrl,
            showPreviewIcon: showPreviewIcon,
            showRemoveIcon: showRemoveIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            iconRender: internalIconRender,
            actionIconRender: actionIconRender,
            itemRender: itemRender,
            onPreview: onInternalPreview,
            onDownload: onInternalDownload,
            onClose: onInternalClose
        });
    }), appendAction && /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), Object.assign({}, motionConfig, {
        visible: appendActionVisible,
        forceRender: true
    }), (_ref2)=>{
        let { className: motionClassName, style: motionStyle } = _ref2;
        return (0, $30796c32f374b477$export$e530037191fcd5d7)(appendAction, (oriProps)=>({
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(oriProps.className, motionClassName),
                style: Object.assign(Object.assign(Object.assign({}, motionStyle), {
                    // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
                    pointerEvents: motionClassName ? "none" : undefined
                }), oriProps.style)
            }));
    }));
};
const $e81d74349446ce57$var$UploadList = /*#__PURE__*/ $acw62.forwardRef($e81d74349446ce57$var$InternalUploadList);
var $e81d74349446ce57$export$2e2bcd8739ae039 = $e81d74349446ce57$var$UploadList;



"use client";
var $71d3b3e99aa569d0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $71d3b3e99aa569d0$export$8f9bb9ff126b1bf5 = `__LIST_IGNORE_${Date.now()}__`;
const $71d3b3e99aa569d0$var$InternalUpload = (props, ref)=>{
    const { fileList: fileList, defaultFileList: defaultFileList, onRemove: onRemove, showUploadList: showUploadList = true, listType: listType = "text", onPreview: onPreview, onDownload: onDownload, onChange: onChange, onDrop: onDrop, previewFile: previewFile, disabled: customDisabled, locale: propLocale, iconRender: iconRender, isImageUrl: isImageUrl, progress: progress, prefixCls: customizePrefixCls, className: className, type: type = "select", children: children, style: style, itemRender: itemRender, maxCount: maxCount, data: data = {}, multiple: multiple = false, hasControlInside: hasControlInside = true, action: action = "", accept: accept = "", supportServerRender: supportServerRender = true, rootClassName: rootClassName } = props;
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const [mergedFileList, setMergedFileList] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultFileList || [], {
        value: fileList,
        postState: (list)=>list !== null && list !== void 0 ? list : []
    });
    const [dragState, setDragState] = $acw62.useState("drop");
    const upload = $acw62.useRef(null);
    const wrapRef = $acw62.useRef(null);
    // Control mode will auto fill file uid if not provided
    $acw62.useMemo(()=>{
        const timestamp = Date.now();
        (fileList || []).forEach((file, index)=>{
            if (!file.uid && !Object.isFrozen(file)) file.uid = `__AUTO__${timestamp}_${index}__`;
        });
    }, [
        fileList
    ]);
    const onInternalChange = (file, changedFileList, event)=>{
        let cloneList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(changedFileList);
        let exceedMaxCount = false;
        // Cut to match count
        if (maxCount === 1) cloneList = cloneList.slice(-1);
        else if (maxCount) {
            exceedMaxCount = cloneList.length > maxCount;
            cloneList = cloneList.slice(0, maxCount);
        }
        // Prevent React18 auto batch since input[upload] trigger process at same time
        // which makes fileList closure problem
        (0, $11492dca620dcaa5$exports.flushSync)(()=>{
            setMergedFileList(cloneList);
        });
        const changeInfo = {
            file: file,
            fileList: cloneList
        };
        if (event) changeInfo.event = event;
        if (!exceedMaxCount || file.status === "removed" || // We should ignore event if current file is exceed `maxCount`
        cloneList.some((f)=>f.uid === file.uid)) (0, $11492dca620dcaa5$exports.flushSync)(()=>{
            onChange === null || onChange === void 0 || onChange(changeInfo);
        });
    };
    const mergedBeforeUpload = (file, fileListArgs)=>$71d3b3e99aa569d0$var$__awaiter(void 0, void 0, void 0, function*() {
            const { beforeUpload: beforeUpload, transformFile: transformFile } = props;
            let parsedFile = file;
            if (beforeUpload) {
                const result = yield beforeUpload(file, fileListArgs);
                if (result === false) return false;
                // Hack for LIST_IGNORE, we add additional info to remove from the list
                delete file[$71d3b3e99aa569d0$export$8f9bb9ff126b1bf5];
                if (result === $71d3b3e99aa569d0$export$8f9bb9ff126b1bf5) {
                    Object.defineProperty(file, $71d3b3e99aa569d0$export$8f9bb9ff126b1bf5, {
                        value: true,
                        configurable: true
                    });
                    return false;
                }
                if (typeof result === "object" && result) parsedFile = result;
            }
            if (transformFile) parsedFile = yield transformFile(parsedFile);
            return parsedFile;
        });
    const onBatchStart = (batchFileInfoList)=>{
        // Skip file which marked as `LIST_IGNORE`, these file will not add to file list
        const filteredFileInfoList = batchFileInfoList.filter((info)=>!info.file[$71d3b3e99aa569d0$export$8f9bb9ff126b1bf5]);
        // Nothing to do since no file need upload
        if (!filteredFileInfoList.length) return;
        const objectFileList = filteredFileInfoList.map((info)=>(0, $92d37f24422d5899$export$6dc848fd109e803d)(info.file));
        // Concat new files with prev files
        let newFileList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedFileList);
        objectFileList.forEach((fileObj)=>{
            // Replace file if exist
            newFileList = (0, $92d37f24422d5899$export$65c2063f64290f37)(fileObj, newFileList);
        });
        objectFileList.forEach((fileObj, index)=>{
            // Repeat trigger `onChange` event for compatible
            let triggerFileObj = fileObj;
            if (!filteredFileInfoList[index].parsedFile) {
                // `beforeUpload` return false
                const { originFileObj: originFileObj } = fileObj;
                let clone;
                try {
                    clone = new File([
                        originFileObj
                    ], originFileObj.name, {
                        type: originFileObj.type
                    });
                } catch (e) {
                    clone = new Blob([
                        originFileObj
                    ], {
                        type: originFileObj.type
                    });
                    clone.name = originFileObj.name;
                    clone.lastModifiedDate = new Date();
                    clone.lastModified = new Date().getTime();
                }
                clone.uid = fileObj.uid;
                triggerFileObj = clone;
            } else // Inject `uploading` status
            fileObj.status = "uploading";
            onInternalChange(triggerFileObj, newFileList);
        });
    };
    const onSuccess = (response, file, xhr)=>{
        try {
            if (typeof response === "string") // biome-ignore lint/style/noParameterAssign: we need to modify response
            response = JSON.parse(response);
        } catch (e) {
        /* do nothing */ }
        // removed
        if (!(0, $92d37f24422d5899$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $92d37f24422d5899$export$6dc848fd109e803d)(file);
        targetItem.status = "done";
        targetItem.percent = 100;
        targetItem.response = response;
        targetItem.xhr = xhr;
        const nextFileList = (0, $92d37f24422d5899$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const onProgress = (e, file)=>{
        // removed
        if (!(0, $92d37f24422d5899$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $92d37f24422d5899$export$6dc848fd109e803d)(file);
        targetItem.status = "uploading";
        targetItem.percent = e.percent;
        const nextFileList = (0, $92d37f24422d5899$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList, e);
    };
    const onError = (error, response, file)=>{
        // removed
        if (!(0, $92d37f24422d5899$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $92d37f24422d5899$export$6dc848fd109e803d)(file);
        targetItem.error = error;
        targetItem.response = response;
        targetItem.status = "error";
        const nextFileList = (0, $92d37f24422d5899$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const handleRemove = (file)=>{
        let currentFile;
        Promise.resolve(typeof onRemove === "function" ? onRemove(file) : onRemove).then((ret)=>{
            var _a;
            // Prevent removing file
            if (ret === false) return;
            const removedFileList = (0, $92d37f24422d5899$export$f3bced642db28a96)(file, mergedFileList);
            if (removedFileList) {
                currentFile = Object.assign(Object.assign({}, file), {
                    status: "removed"
                });
                mergedFileList === null || mergedFileList === void 0 || mergedFileList.forEach((item)=>{
                    const matchKey = currentFile.uid !== undefined ? "uid" : "name";
                    if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) item.status = "removed";
                });
                (_a = upload.current) === null || _a === void 0 || _a.abort(currentFile);
                onInternalChange(currentFile, removedFileList);
            }
        });
    };
    const onFileDrop = (e)=>{
        setDragState(e.type);
        if (e.type === "drop") onDrop === null || onDrop === void 0 || onDrop(e);
    };
    // Test needs
    $acw62.useImperativeHandle(ref, ()=>({
            onBatchStart: onBatchStart,
            onSuccess: onSuccess,
            onProgress: onProgress,
            onError: onError,
            fileList: mergedFileList,
            upload: upload.current,
            nativeElement: wrapRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, upload: ctxUpload } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("upload", customizePrefixCls);
    const rcUploadProps = Object.assign(Object.assign({
        onBatchStart: onBatchStart,
        onError: onError,
        onProgress: onProgress,
        onSuccess: onSuccess
    }, props), {
        data: data,
        multiple: multiple,
        action: action,
        accept: accept,
        supportServerRender: supportServerRender,
        prefixCls: prefixCls,
        disabled: mergedDisabled,
        beforeUpload: mergedBeforeUpload,
        onChange: undefined,
        hasControlInside: hasControlInside
    });
    delete rcUploadProps.className;
    delete rcUploadProps.style;
    // Remove id to avoid open by label when trigger is hidden
    // !children: https://github.com/ant-design/ant-design/issues/14298
    // disabled: https://github.com/ant-design/ant-design/issues/16478
    //           https://github.com/ant-design/ant-design/issues/24197
    if (!children || mergedDisabled) delete rcUploadProps.id;
    const wrapperCls = `${prefixCls}-wrapper`;
    const [wrapCSSVar, hashId, cssVarCls] = (0, $ac15cb84fb7f4f70$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    const [contextLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Upload", (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Upload);
    const { showRemoveIcon: showRemoveIcon, showPreviewIcon: showPreviewIcon, showDownloadIcon: showDownloadIcon, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon } = typeof showUploadList === "boolean" ? {} : showUploadList;
    // use showRemoveIcon if it is specified explicitly
    const realShowRemoveIcon = typeof showRemoveIcon === "undefined" ? !mergedDisabled : !!showRemoveIcon;
    const renderUploadList = (button, buttonVisible)=>{
        if (!showUploadList) return button;
        return /*#__PURE__*/ $acw62.createElement((0, $e81d74349446ce57$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            listType: listType,
            items: mergedFileList,
            previewFile: previewFile,
            onPreview: onPreview,
            onDownload: onDownload,
            onRemove: handleRemove,
            showRemoveIcon: realShowRemoveIcon,
            showPreviewIcon: showPreviewIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            iconRender: iconRender,
            locale: Object.assign(Object.assign({}, contextLocale), propLocale),
            isImageUrl: isImageUrl,
            progress: progress,
            appendAction: button,
            appendActionVisible: buttonVisible,
            itemRender: itemRender,
            disabled: mergedDisabled
        });
    };
    const mergedCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(wrapperCls, className, rootClassName, hashId, cssVarCls, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.className, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-picture-card-wrapper`]: listType === "picture-card",
        [`${prefixCls}-picture-circle-wrapper`]: listType === "picture-circle"
    });
    const mergedStyle = Object.assign(Object.assign({}, ctxUpload === null || ctxUpload === void 0 ? void 0 : ctxUpload.style), style);
    // ======================== Render ========================
    if (type === "drag") {
        const dragCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, prefixCls, `${prefixCls}-drag`, {
            [`${prefixCls}-drag-uploading`]: mergedFileList.some((file)=>file.status === "uploading"),
            [`${prefixCls}-drag-hover`]: dragState === "dragover",
            [`${prefixCls}-disabled`]: mergedDisabled,
            [`${prefixCls}-rtl`]: direction === "rtl"
        });
        return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", {
            className: mergedCls,
            ref: wrapRef
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: dragCls,
            style: mergedStyle,
            onDrop: onFileDrop,
            onDragOver: onFileDrop,
            onDragLeave: onFileDrop
        }, /*#__PURE__*/ $acw62.createElement((0, $cb8cc710d8cb195d$export$2e2bcd8739ae039), Object.assign({}, rcUploadProps, {
            ref: upload,
            className: `${prefixCls}-btn`
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-drag-container`
        }, children))), renderUploadList()));
    }
    const uploadButtonCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-select`, {
        [`${prefixCls}-disabled`]: mergedDisabled
    });
    const uploadButton = /*#__PURE__*/ $acw62.createElement("div", {
        className: uploadButtonCls,
        style: children ? undefined : {
            display: "none"
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $cb8cc710d8cb195d$export$2e2bcd8739ae039), Object.assign({}, rcUploadProps, {
        ref: upload
    })));
    if (listType === "picture-card" || listType === "picture-circle") return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", {
        className: mergedCls,
        ref: wrapRef
    }, renderUploadList(uploadButton, !!children)));
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", {
        className: mergedCls,
        ref: wrapRef
    }, uploadButton, renderUploadList()));
};
const $71d3b3e99aa569d0$var$Upload = /*#__PURE__*/ $acw62.forwardRef($71d3b3e99aa569d0$var$InternalUpload);
var $71d3b3e99aa569d0$export$2e2bcd8739ae039 = $71d3b3e99aa569d0$var$Upload;


"use client";
var $7b8cba1660efb86f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $7b8cba1660efb86f$var$Dragger = /*#__PURE__*/ $acw62.forwardRef((_a, ref)=>{
    var { style: style, height: height, hasControlInside: hasControlInside = false } = _a, restProps = $7b8cba1660efb86f$var$__rest(_a, [
        "style",
        "height",
        "hasControlInside"
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $71d3b3e99aa569d0$export$2e2bcd8739ae039), Object.assign({
        ref: ref,
        hasControlInside: hasControlInside
    }, restProps, {
        type: "drag",
        style: Object.assign(Object.assign({}, style), {
            height: height
        })
    }));
});
var $7b8cba1660efb86f$export$2e2bcd8739ae039 = $7b8cba1660efb86f$var$Dragger;



"use client";
const $e3764dd060390695$var$Upload = (0, $71d3b3e99aa569d0$export$2e2bcd8739ae039);
$e3764dd060390695$var$Upload.Dragger = (0, $7b8cba1660efb86f$export$2e2bcd8739ae039);
$e3764dd060390695$var$Upload.LIST_IGNORE = (0, $71d3b3e99aa569d0$export$8f9bb9ff126b1bf5);
var $e3764dd060390695$export$2e2bcd8739ae039 = $e3764dd060390695$var$Upload;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $9485e0abdc4882ed$var$UploadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "upload",
    "theme": "outlined"
};
var $9485e0abdc4882ed$export$2e2bcd8739ae039 = $9485e0abdc4882ed$var$UploadOutlined;



var $3a791dc244e00455$var$UploadOutlined = function UploadOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $9485e0abdc4882ed$export$2e2bcd8739ae039)
    }));
};
/**![upload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQwMCAzMTcuN2g3My45VjY1NmMwIDQuNCAzLjYgOCA4IDhoNjBjNC40IDAgOC0zLjYgOC04VjMxNy43SDYyNGM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1MTguMyAxNjNhOCA4IDAgMDAtMTIuNiAwbC0xMTIgMTQxLjdjLTQuMSA1LjMtLjQgMTMgNi4zIDEzek04NzggNjI2aC02MGMtNC40IDAtOCAzLjYtOCA4djE1NEgyMTRWNjM0YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYxOThjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjg0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjYzNGMwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */ var $3a791dc244e00455$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($3a791dc244e00455$var$UploadOutlined);
var $3a791dc244e00455$export$2e2bcd8739ae039 = $3a791dc244e00455$var$RefIcon;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ce0f95a23ea8b20d$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
var $ce0f95a23ea8b20d$export$2e2bcd8739ae039 = $ce0f95a23ea8b20d$var$ExclamationCircleFilled;



var $2444f6da62064575$var$ExclamationCircleFilled = function ExclamationCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $ce0f95a23ea8b20d$export$2e2bcd8739ae039)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $2444f6da62064575$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2444f6da62064575$var$ExclamationCircleFilled);
var $2444f6da62064575$export$2e2bcd8739ae039 = $2444f6da62064575$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $57a9c466662aed09$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
var $57a9c466662aed09$export$2e2bcd8739ae039 = $57a9c466662aed09$var$InfoCircleFilled;



var $b5d5d018bfa4ba6e$var$InfoCircleFilled = function InfoCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $57a9c466662aed09$export$2e2bcd8739ae039)
    }));
};
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ var $b5d5d018bfa4ba6e$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($b5d5d018bfa4ba6e$var$InfoCircleFilled);
var $b5d5d018bfa4ba6e$export$2e2bcd8739ae039 = $b5d5d018bfa4ba6e$var$RefIcon;










var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



"use client";
function $4c53afaea8b9c117$var$isThenable(thing) {
    return !!(thing === null || thing === void 0 ? void 0 : thing.then);
}
const $4c53afaea8b9c117$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $acw62.useRef(false);
    const buttonRef = $acw62.useRef(null);
    const [loading, setLoading] = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(false);
    const onInternalClose = function() {
        close === null || close === void 0 || close.apply(void 0, arguments);
    };
    $acw62.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, []);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!$4c53afaea8b9c117$var$isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then(function() {
            setLoading(false, true);
            onInternalClose.apply(void 0, arguments);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !$4c53afaea8b9c117$var$isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!$4c53afaea8b9c117$var$isThenable(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), Object.assign({}, (0, $891d27b465b97c91$export$19bc9a290855952)(type), {
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls
    }, buttonProps, {
        ref: buttonRef
    }), children);
};
var $4c53afaea8b9c117$export$2e2bcd8739ae039 = $4c53afaea8b9c117$var$ActionButton;



var $acw62 = parcelRequire("acw62");
const $6eed8829240c00e1$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const { Provider: $6eed8829240c00e1$export$7c9538f5f3c365e9 } = $6eed8829240c00e1$export$ab57792b9b6974a6;


"use client";
const $b41cca75d2dc2fd0$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c53afaea8b9c117$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: function() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        autoFocus: autoFocusButton === "cancel",
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $b41cca75d2dc2fd0$export$2e2bcd8739ae039 = $b41cca75d2dc2fd0$var$ConfirmCancelBtn;



var $acw62 = parcelRequire("acw62");


"use client";
const $a937a1d7917b01bb$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c53afaea8b9c117$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || "primary",
        actionFn: onOk,
        close: function() {
            close === null || close === void 0 || close.apply(void 0, arguments);
            onConfirm === null || onConfirm === void 0 || onConfirm(true);
        },
        autoFocus: autoFocusButton === "ok",
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $a937a1d7917b01bb$export$2e2bcd8739ae039 = $a937a1d7917b01bb$var$ConfirmOkBtn;




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $92d33d80ee6bc497$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $acw62.createContext({});











var $acw62 = parcelRequire("acw62");
// =============================== Motion ===============================
function $90c55518cdbfc131$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    var motionName = transitionName;
    if (!motionName && animationName) motionName = "".concat(prefixCls, "-").concat(animationName);
    return motionName;
}
// =============================== Offset ===============================
function $90c55518cdbfc131$var$getScroll(w, top) {
    var ret = w["page".concat(top ? "Y" : "X", "Offset")];
    var method = "scroll".concat(top ? "Top" : "Left");
    if (typeof ret !== "number") {
        var d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== "number") ret = d.body[method];
    }
    return ret;
}
function $90c55518cdbfc131$export$cc800923e997bb8(el) {
    var rect = el.getBoundingClientRect();
    var pos = {
        left: rect.left,
        top: rect.top
    };
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $90c55518cdbfc131$var$getScroll(w);
    pos.top += $90c55518cdbfc131$var$getScroll(w, true);
    return pos;
}






var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $112494d152ccd867$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo(function(_ref) {
    var children = _ref.children;
    return children;
}, function(_, _ref2) {
    var shouldUpdate = _ref2.shouldUpdate;
    return !shouldUpdate;
});



var $d87bfeabd0b3848d$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: "hidden",
    outline: "none"
};
var $d87bfeabd0b3848d$var$entityStyle = {
    outline: "none"
};
var $d87bfeabd0b3848d$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
    // ================================= Refs =================================
    var _React$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $92d33d80ee6bc497$export$ee4e38b469b6f5d1)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(holderRef, panelRef);
    var sentinelStartRef = (0, $acw62.useRef)();
    var sentinelEndRef = (0, $acw62.useRef)();
    var entityRef = (0, $acw62.useRef)();
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                var _entityRef$current;
                (_entityRef$current = entityRef.current) === null || _entityRef$current === void 0 || _entityRef$current.focus({
                    preventScroll: true
                });
            },
            changeActive: function changeActive(next) {
                var _document = document, activeElement = _document.activeElement;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        };
    });
    // ================================ Style =================================
    var contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    var footerNode = footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
    }, footer) : null;
    var headerNode = title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-title"),
        id: ariaId
    }, title)) : null;
    var closableObj = (0, $acw62.useMemo)(function() {
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(closable) === "object" && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "".concat(prefixCls, "-close-x")
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    var ariaProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(closableObj, true);
    var closeBtnIsDisabled = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(closable) === "object" && closable.disabled;
    var closerNode = closable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: "".concat(prefixCls, "-close"),
        disabled: closeBtnIsDisabled
    }), closableObj.closeIcon) : null;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
        style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
    }, closerNode, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), contentStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: entityRef,
        tabIndex: -1,
        style: $d87bfeabd0b3848d$var$entityStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $112494d152ccd867$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $d87bfeabd0b3848d$var$sentinelStyle,
        "aria-hidden": "true"
    }));
});
var $d87bfeabd0b3848d$export$2e2bcd8739ae039 = $d87bfeabd0b3848d$var$Panel;


var $b02b23d234e320c9$var$Content = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, title = props.title, style = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition = props.mousePosition;
    var dialogRef = (0, $acw62.useRef)();
    // ============================= Style ==============================
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
    var contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        var elementOffset = (0, $90c55518cdbfc131$export$cc800923e997bb8)(dialogRef.current);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
    }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement((0, $d87bfeabd0b3848d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            ref: ref,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), style), contentStyle),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, motionClassName)
        }));
    });
});
$b02b23d234e320c9$var$Content.displayName = "Content";
var $b02b23d234e320c9$export$2e2bcd8739ae039 = $b02b23d234e320c9$var$Content;





var $acw62 = parcelRequire("acw62");


var $e10e3c44c896dc47$var$Mask = function Mask(props) {
    var prefixCls = props.prefixCls, style = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className = props.className;
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: "".concat(prefixCls, "-mask-hidden")
    }, function(_ref, ref) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            ref: ref,
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), style),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), motionClassName, className)
        }, maskProps));
    });
};
var $e10e3c44c896dc47$export$2e2bcd8739ae039 = $e10e3c44c896dc47$var$Mask;



var $850025f1cddd8729$var$Dialog = function Dialog(props) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dialog" : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
    var lastOutSideActiveElementRef = (0, $acw62.useRef)();
    var wrapperRef = (0, $acw62.useRef)();
    var contentRef = (0, $acw62.useRef)();
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ========================== Init ==========================
    var ariaId = (0, $d23d006593dfab9c$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $97b4b0194c593c05$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) {
            var _contentRef$current;
            (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
        }
    }
    // ========================= Events =========================
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else {
            // Clean up scroll bar & focus back
            setAnimatedVisible(false);
            if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
                try {
                    lastOutSideActiveElementRef.current.focus({
                        preventScroll: true
                    });
                } catch (e) {
                // Do nothing
                }
                lastOutSideActiveElementRef.current = null;
            }
            // Trigger afterClose only when change visible from true to false
            if (animatedVisible) afterClose === null || afterClose === void 0 || afterClose();
        }
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
    }
    function onInternalClose(e) {
        onClose === null || onClose === void 0 || onClose(e);
    }
    // >>> Content
    var contentClickRef = (0, $acw62.useRef)(false);
    var contentTimeoutRef = (0, $acw62.useRef)();
    // We need record content click incase content popup out of dialog
    var onContentMouseDown = function onContentMouseDown() {
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    var onContentMouseUp = function onContentMouseUp() {
        contentTimeoutRef.current = setTimeout(function() {
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    var onWrapperClick = null;
    if (maskClosable) onWrapperClick = function onWrapperClick(e) {
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, $acw62.useEffect)(function() {
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        }
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, $acw62.useEffect)(function() {
        return function() {
            clearTimeout(contentTimeoutRef.current);
        };
    }, []);
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
        display: !animatedVisible ? "none" : null
    });
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-root"), rootClassName)
    }, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $acw62.createElement((0, $e10e3c44c896dc47$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            zIndex: zIndex
        }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
        maskProps: maskProps,
        className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
    }), /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $acw62.createElement((0, $b02b23d234e320c9$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $90c55518cdbfc131$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
};
var $850025f1cddd8729$export$2e2bcd8739ae039 = $850025f1cddd8729$var$Dialog;


// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ var $08b45dfd0eb11827$var$DialogWrap = function DialogWrap(props) {
    var visible = props.visible, getContainer = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
    var _React$useState = $acw62.useState(visible), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    var refContext = $acw62.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    $acw62.useEffect(function() {
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnClose && !animatedVisible) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $92d33d80ee6bc497$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $acw62.createElement((0, $5b46218595a40828$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ $acw62.createElement((0, $850025f1cddd8729$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        destroyOnClose: destroyOnClose,
        afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 || _afterClose();
            setAnimatedVisible(false);
        }
    }))));
};
$08b45dfd0eb11827$var$DialogWrap.displayName = "Dialog";
var $08b45dfd0eb11827$export$2e2bcd8739ae039 = $08b45dfd0eb11827$var$DialogWrap;



var $fc48b5916203bd39$export$2e2bcd8739ae039 = (0, $08b45dfd0eb11827$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");


"use client";
function $91e86e8e8e97dd3f$export$51ad9c30389f050b(context) {
    if (!context) return undefined;
    return {
        closable: context.closable,
        closeIcon: context.closeIcon
    };
}
/** Convert `closable` and `closeIcon` to config object */ function $91e86e8e8e97dd3f$var$useClosableConfig(closableCollection) {
    const { closable: closable, closeIcon: closeIcon } = closableCollection || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (// If `closable`, whatever rest be should be true
        !closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
        if (closable === undefined && closeIcon === undefined) return null;
        let closableConfig = {
            closeIcon: typeof closeIcon !== "boolean" && closeIcon !== null ? closeIcon : undefined
        };
        if (closable && typeof closable === "object") closableConfig = Object.assign(Object.assign({}, closableConfig), closable);
        return closableConfig;
    }, [
        closable,
        closeIcon
    ]);
}
/**
 * Assign object without `undefined` field. Will skip if is `false`.
 * This helps to handle both closableConfig or false
 */ function $91e86e8e8e97dd3f$var$assignWithoutUndefined() {
    const target = {};
    for(var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++)objList[_key] = arguments[_key];
    objList.forEach((obj)=>{
        if (obj) Object.keys(obj).forEach((key)=>{
            if (obj[key] !== undefined) target[key] = obj[key];
        });
    });
    return target;
}
/** Use same object to support `useMemo` optimization */ const $91e86e8e8e97dd3f$var$EmptyFallbackCloseCollection = {};
function $91e86e8e8e97dd3f$export$2e2bcd8739ae039(propCloseCollection, contextCloseCollection) {
    let fallbackCloseCollection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $91e86e8e8e97dd3f$var$EmptyFallbackCloseCollection;
    // Align the `props`, `context` `fallback` to config object first
    const propCloseConfig = $91e86e8e8e97dd3f$var$useClosableConfig(propCloseCollection);
    const contextCloseConfig = $91e86e8e8e97dd3f$var$useClosableConfig(contextCloseCollection);
    const mergedFallbackCloseCollection = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.assign({
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null)
        }, fallbackCloseCollection), [
        fallbackCloseCollection
    ]);
    // Use fallback logic to fill the config
    const mergedClosableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // ================ Props First ================
        // Skip if prop is disabled
        if (propCloseConfig === false) return false;
        if (propCloseConfig) return $91e86e8e8e97dd3f$var$assignWithoutUndefined(mergedFallbackCloseCollection, contextCloseConfig, propCloseConfig);
        // =============== Context Second ==============
        // Skip if context is disabled
        if (contextCloseConfig === false) return false;
        if (contextCloseConfig) return $91e86e8e8e97dd3f$var$assignWithoutUndefined(mergedFallbackCloseCollection, contextCloseConfig);
        // ============= Fallback Default ==============
        return !mergedFallbackCloseCollection.closable ? false : mergedFallbackCloseCollection;
    }, [
        propCloseConfig,
        contextCloseConfig,
        mergedFallbackCloseCollection
    ]);
    // Calculate the final closeIcon
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (mergedClosableConfig === false) return [
            false,
            null
        ];
        const { closeIconRender: closeIconRender } = mergedFallbackCloseCollection;
        const { closeIcon: closeIcon } = mergedClosableConfig;
        let mergedCloseIcon = closeIcon;
        if (mergedCloseIcon !== null && mergedCloseIcon !== undefined) {
            // Wrap the closeIcon if needed
            if (closeIconRender) mergedCloseIcon = closeIconRender(closeIcon);
            // Wrap the closeIcon with aria props
            const ariaProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(mergedClosableConfig, true);
            if (Object.keys(ariaProps).length) mergedCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(mergedCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(mergedCloseIcon, ariaProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({}, ariaProps), mergedCloseIcon);
        }
        return [
            true,
            mergedCloseIcon
        ];
    }, [
        mergedClosableConfig,
        mergedFallbackCloseCollection
    ]);
}






var $5ac27a8c1ec0b63e$var$isStyleNameSupport = function isStyleNameSupport(styleName) {
    if ((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() && window.document.documentElement) {
        var styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        var documentElement = window.document.documentElement;
        return styleNameList.some(function(name) {
            return name in documentElement.style;
        });
    }
    return false;
};
var $5ac27a8c1ec0b63e$var$isStyleValueSupport = function isStyleValueSupport(styleName, value) {
    if (!$5ac27a8c1ec0b63e$var$isStyleNameSupport(styleName)) return false;
    var ele = document.createElement("div");
    var origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $5ac27a8c1ec0b63e$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $5ac27a8c1ec0b63e$var$isStyleValueSupport(styleName, styleValue);
    return $5ac27a8c1ec0b63e$var$isStyleNameSupport(styleName);
}


const $ebcf30cec053af5e$export$7dbdadf5e9653129 = ()=>(0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() && window.document.documentElement;







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

"use client";
const $7c41d3edfd4df78b$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-lg`]: size === "large",
        [`${prefixCls}-sm`]: size === "small"
    });
    const shapeCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-circle`]: shape === "circle",
        [`${prefixCls}-square`]: shape === "square",
        [`${prefixCls}-round`]: shape === "round"
    });
    const sizeStyle = $acw62.useMemo(()=>typeof size === "number" ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, sizeCls, shapeCls, className),
        style: Object.assign(Object.assign({}, sizeStyle), style)
    });
};
var $7c41d3edfd4df78b$export$2e2bcd8739ae039 = $7c41d3edfd4df78b$var$Element;




const $c8ad1686c6f1e1ca$var$skeletonClsLoading = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)(`ant-skeleton-loading`, {
    "0%": {
        backgroundPosition: "100% 50%"
    },
    "100%": {
        backgroundPosition: "0 50%"
    }
});
const $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(size)
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize = (size)=>Object.assign({
        width: size
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: "400% 100%",
        animationName: $c8ad1686c6f1e1ca$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: "ease",
        animationIterationCount: "infinite"
    });
const $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize = (size, calc)=>Object.assign({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal()
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [`${skeletonAvatarCls}`]: Object.assign({
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeight)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: "50%"
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightLG)),
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightSM))
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [`${skeletonInputCls}`]: Object.assign({
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeight, calc)),
        [`${skeletonInputCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeightLG, calc)),
        [`${skeletonInputCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementInputSize(controlHeightSM, calc))
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementImageSize = (size)=>Object.assign({
        width: size
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, calc: calc } = token;
    return {
        [`${skeletonImageCls}`]: Object.assign(Object.assign({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementImageSize(calc(imageSizeBase).mul(2).equal())), {
            [`${skeletonImageCls}-path`]: {
                fill: "#bfbfbf"
            },
            [`${skeletonImageCls}-svg`]: Object.assign(Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementImageSize(imageSizeBase)), {
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            }),
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: "50%"
            }
        }),
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: "50%"
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: "50%"
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize = (size, calc)=>Object.assign({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal()
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementCommonSize(size));
const $c8ad1686c6f1e1ca$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        [`${skeletonButtonCls}`]: Object.assign({
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal()
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeight, calc))
    }, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls)), {
        [`${skeletonButtonCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeightLG, calc))
    }), $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`)), {
        [`${skeletonButtonCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementButtonSize(controlHeightSM, calc))
    }), $c8ad1686c6f1e1ca$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`));
};
// =============================== Base ===============================
const $c8ad1686c6f1e1ca$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [`${componentCls}`]: {
            display: "table",
            width: "100%",
            [`${componentCls}-header`]: {
                display: "table-cell",
                paddingInlineEnd: padding,
                verticalAlign: "top",
                // Avatar
                [`${skeletonAvatarCls}`]: Object.assign({
                    display: "inline-block",
                    verticalAlign: "top",
                    background: gradientFromColor
                }, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeight)),
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: "50%"
                },
                [`${skeletonAvatarCls}-lg`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightLG)),
                [`${skeletonAvatarCls}-sm`]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonElementAvatarSize(controlHeightSM))
            },
            [`${componentCls}-content`]: {
                display: "table-cell",
                width: "100%",
                verticalAlign: "top",
                // Title
                [`${skeletonTitleCls}`]: {
                    width: "100%",
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [`${skeletonParagraphCls}`]: {
                    padding: 0,
                    "> li": {
                        width: "100%",
                        height: paragraphLiHeight,
                        listStyle: "none",
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        "+ li": {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: "61%"
                }
            },
            [`&-round ${componentCls}-content`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-content`]: {
            // Title
            [`${skeletonTitleCls}`]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton element
        [`${componentCls}${componentCls}-element`]: Object.assign(Object.assign(Object.assign(Object.assign({
            display: "inline-block",
            width: "auto"
        }, $c8ad1686c6f1e1ca$var$genSkeletonElementButton(token)), $c8ad1686c6f1e1ca$var$genSkeletonElementAvatar(token)), $c8ad1686c6f1e1ca$var$genSkeletonElementInput(token)), $c8ad1686c6f1e1ca$var$genSkeletonElementImage(token)),
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: "100%",
            [`${skeletonButtonCls}`]: {
                width: "100%"
            },
            [`${skeletonInputCls}`]: {
                width: "100%"
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonImageCls}
      `]: Object.assign({}, $c8ad1686c6f1e1ca$var$genSkeletonColor(token))
        }
    };
};
const $c8ad1686c6f1e1ca$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $c8ad1686c6f1e1ca$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Skeleton", (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: "1.4s"
    });
    return [
        $c8ad1686c6f1e1ca$var$genBaseStyle(skeletonToken)
    ];
}, $c8ad1686c6f1e1ca$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            "color",
            "gradientFromColor"
        ],
        [
            "colorGradientEnd",
            "gradientToColor"
        ]
    ]
});


"use client";
const $febf367e4c351696$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, shape: shape = "circle", size: size = "default" } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "prefixCls",
        "className"
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-avatar`,
        shape: shape,
        size: size
    }, otherProps))));
};
var $febf367e4c351696$export$2e2bcd8739ae039 = $febf367e4c351696$var$SkeletonAvatar;



var $acw62 = parcelRequire("acw62");





"use client";
const $13df8eca828a64aa$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block = false, size: size = "default" } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "prefixCls"
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-button`,
        size: size
    }, otherProps))));
};
var $13df8eca828a64aa$export$2e2bcd8739ae039 = $13df8eca828a64aa$var$SkeletonButton;




var $acw62 = parcelRequire("acw62");



"use client";
const $2d15da232c1f201d$var$path = "M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z";
const $2d15da232c1f201d$var$SkeletonImage = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-image`, className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $acw62.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $acw62.createElement("path", {
        d: $2d15da232c1f201d$var$path,
        className: `${prefixCls}-image-path`
    })))));
};
var $2d15da232c1f201d$export$2e2bcd8739ae039 = $2d15da232c1f201d$var$SkeletonImage;



var $acw62 = parcelRequire("acw62");





"use client";
const $91e87c3cdd7d215d$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, active: active, block: block, size: size = "default" } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const otherProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "prefixCls"
    ]);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), Object.assign({
        prefixCls: `${prefixCls}-input`,
        size: size
    }, otherProps))));
};
var $91e87c3cdd7d215d$export$2e2bcd8739ae039 = $91e87c3cdd7d215d$var$SkeletonInput;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4af4b6581042791c$var$DotChartOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 10128 0 64 64 0 10-128 0zm118-224a48 48 0 1096 0 48 48 0 10-96 0zm158 228a96 96 0 10192 0 96 96 0 10-192 0zm148-314a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "dot-chart",
    "theme": "outlined"
};
var $4af4b6581042791c$export$2e2bcd8739ae039 = $4af4b6581042791c$var$DotChartOutlined;



var $ab461e380423e01a$var$DotChartOutlined = function DotChartOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4af4b6581042791c$export$2e2bcd8739ae039)
    }));
};
/**![dot-chart](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4OCA3OTJIMjAwVjE2OGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2Njg4YzAgNC40IDMuNiA4IDggOGg3NTJjNC40IDAgOC0zLjYgOC04di01NmMwLTQuNC0zLjYtOC04LTh6TTI4OCA2MDRhNjQgNjQgMCAxMDEyOCAwIDY0IDY0IDAgMTAtMTI4IDB6bTExOC0yMjRhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem0xNTggMjI4YTk2IDk2IDAgMTAxOTIgMCA5NiA5NiAwIDEwLTE5MiAwem0xNDgtMzE0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ var $ab461e380423e01a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ab461e380423e01a$var$DotChartOutlined);
var $ab461e380423e01a$export$2e2bcd8739ae039 = $ab461e380423e01a$var$RefIcon;





"use client";
const $28cf1b1f35f23ace$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, className, rootClassName, cssVarCls);
    const content = children !== null && children !== void 0 ? children : /*#__PURE__*/ $acw62.createElement((0, $ab461e380423e01a$export$2e2bcd8739ae039), null);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-image`, className),
        style: style
    }, content)));
};
var $28cf1b1f35f23ace$export$2e2bcd8739ae039 = $28cf1b1f35f23ace$var$SkeletonNode;




var $acw62 = parcelRequire("acw62");

"use client";
const $df381a499592442b$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $df381a499592442b$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows } = props;
    const rowList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(Array(rows)).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $acw62.createElement("li", {
            key: index,
            style: {
                width: $df381a499592442b$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className),
        style: style
    }, rowList);
};
var $df381a499592442b$export$2e2bcd8739ae039 = $df381a499592442b$var$Paragraph;




var $acw62 = parcelRequire("acw62");

"use client";
const $d644e5b233ba4700$var$Title = (_ref)=>{
    let { prefixCls: prefixCls, className: className, width: width, style: style } = _ref;
    return(/*#__PURE__*/ // biome-ignore lint/a11y/useHeadingContent: HOC here
    $acw62.createElement("h3", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className),
        style: Object.assign({
            width: width
        }, style)
    }));
};
var $d644e5b233ba4700$export$2e2bcd8739ae039 = $d644e5b233ba4700$var$Title;


"use client";
function $186852cf13bfcae4$var$getComponentProps(prop) {
    if (prop && typeof prop === "object") return prop;
    return {};
}
function $186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: "large",
        shape: "square"
    };
    return {
        size: "large",
        shape: "circle"
    };
}
function $186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: "38%"
    };
    if (hasAvatar && hasParagraph) return {
        width: "50%"
    };
    return {};
}
function $186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = "61%";
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
const $186852cf13bfcae4$var$Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, style: style, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, skeleton: skeleton } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c8ad1686c6f1e1ca$export$2e2bcd8739ae039)(prefixCls);
    if (loading || !("loading" in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = Object.assign(Object.assign({
                prefixCls: `${prefixCls}-avatar`
            }, $186852cf13bfcae4$var$getAvatarBasicProps(hasTitle, hasParagraph)), $186852cf13bfcae4$var$getComponentProps(avatar));
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-header`
            }, /*#__PURE__*/ $acw62.createElement((0, $7c41d3edfd4df78b$export$2e2bcd8739ae039), Object.assign({}, avatarProps)));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-title`
                }, $186852cf13bfcae4$var$getTitleBasicProps(hasAvatar, hasParagraph)), $186852cf13bfcae4$var$getComponentProps(title));
                $title = /*#__PURE__*/ $acw62.createElement((0, $d644e5b233ba4700$export$2e2bcd8739ae039), Object.assign({}, titleProps));
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = Object.assign(Object.assign({
                    prefixCls: `${prefixCls}-paragraph`
                }, $186852cf13bfcae4$var$getParagraphBasicProps(hasAvatar, hasTitle)), $186852cf13bfcae4$var$getComponentProps(paragraph));
                paragraphNode = /*#__PURE__*/ $acw62.createElement((0, $df381a499592442b$export$2e2bcd8739ae039), Object.assign({}, paragraphProps));
            }
            contentNode = /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-content`
            }, $title, paragraphNode);
        }
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-round`]: round
        }, skeleton === null || skeleton === void 0 ? void 0 : skeleton.className, className, rootClassName, hashId, cssVarCls);
        return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
            className: cls,
            style: Object.assign(Object.assign({}, skeleton === null || skeleton === void 0 ? void 0 : skeleton.style), style)
        }, avatarNode, contentNode));
    }
    return children !== null && children !== void 0 ? children : null;
};
$186852cf13bfcae4$var$Skeleton.Button = (0, $13df8eca828a64aa$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Avatar = (0, $febf367e4c351696$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Input = (0, $91e87c3cdd7d215d$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Image = (0, $2d15da232c1f201d$export$2e2bcd8739ae039);
$186852cf13bfcae4$var$Skeleton.Node = (0, $28cf1b1f35f23ace$export$2e2bcd8739ae039);
var $186852cf13bfcae4$export$2e2bcd8739ae039 = $186852cf13bfcae4$var$Skeleton;


"use client";
var $b9eb1d5949d003b0$export$2e2bcd8739ae039 = (0, $186852cf13bfcae4$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

function $9ce1b741d917b083$var$voidFunc() {}
const $9ce1b741d917b083$var$WatermarkContext = /*#__PURE__*/ $acw62.createContext({
    add: $9ce1b741d917b083$var$voidFunc,
    remove: $9ce1b741d917b083$var$voidFunc
});
function $9ce1b741d917b083$export$94ab53417567be34(panelSelector) {
    const watermark = $acw62.useContext($9ce1b741d917b083$var$WatermarkContext);
    const panelEleRef = $acw62.useRef();
    const panelRef = (0, $01e43e72865dc583$export$2e2bcd8739ae039)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            watermark.add(innerContentEle);
            panelEleRef.current = innerContentEle;
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $9ce1b741d917b083$export$2e2bcd8739ae039 = $9ce1b741d917b083$var$WatermarkContext;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


"use client";
const $671e2637f7c09c5d$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), Object.assign({
        onClick: onCancel
    }, cancelButtonProps), cancelTextLocale);
};
var $671e2637f7c09c5d$export$2e2bcd8739ae039 = $671e2637f7c09c5d$var$NormalCancelBtn;



var $acw62 = parcelRequire("acw62");



"use client";
const $dbfeff6b64918b5e$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $acw62.useContext)((0, $6eed8829240c00e1$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), Object.assign({}, (0, $891d27b465b97c91$export$19bc9a290855952)(okType), {
        loading: confirmLoading,
        onClick: onOk
    }, okButtonProps), okTextLocale);
};
var $dbfeff6b64918b5e$export$2e2bcd8739ae039 = $dbfeff6b64918b5e$var$NormalOkBtn;




"use client";
function $52ee3afc292c0929$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
}
const $52ee3afc292c0929$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = "primary", cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Modal", (0, $466e4bebfd7443ca$export$1b6004afda18cd51)());
    // ================== Locale Text ==================
    const okTextLocale = okText || (locale === null || locale === void 0 ? void 0 : locale.okText);
    const cancelTextLocale = cancelText || (locale === null || locale === void 0 ? void 0 : locale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = {
        confirmLoading: confirmLoading,
        okButtonProps: okButtonProps,
        cancelButtonProps: cancelButtonProps,
        okTextLocale: okTextLocale,
        cancelTextLocale: cancelTextLocale,
        okType: okType,
        onOk: onOk,
        onCancel: onCancel
    };
    const btnCtxValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>btnCtxValue, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(Object.values(btnCtxValue)));
    let footerNode;
    if (typeof footer === "function" || typeof footer === "undefined") {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $671e2637f7c09c5d$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbfeff6b64918b5e$export$2e2bcd8739ae039), null));
        if (typeof footer === "function") footerNode = footer(footerNode, {
            OkBtn: (0, $dbfeff6b64918b5e$export$2e2bcd8739ae039),
            CancelBtn: (0, $671e2637f7c09c5d$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6eed8829240c00e1$export$7c9538f5f3c365e9), {
            value: btnCtxValueMemo
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};






function $4273ff34fb23b4b1$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $4273ff34fb23b4b1$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: "none",
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: "none"
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
                    pointerEvents: "none"
                },
                [`${componentCls}-mask`]: Object.assign(Object.assign({}, $4273ff34fb23b4b1$var$box("fixed")), {
                    zIndex: token.zIndexPopupBase,
                    height: "100%",
                    backgroundColor: token.colorBgMask,
                    pointerEvents: "none",
                    [`${componentCls}-hidden`]: {
                        display: "none"
                    }
                }),
                [`${componentCls}-wrap`]: Object.assign(Object.assign({}, $4273ff34fb23b4b1$var$box("fixed")), {
                    zIndex: token.zIndexPopupBase,
                    overflow: "auto",
                    outline: 0,
                    WebkitOverflowScrolling: "touch"
                })
            }
        },
        {
            [`${componentCls}-root`]: (0, $cfaac789ec22cce1$export$2909268c8354a12)(token)
        }
    ];
};
const $4273ff34fb23b4b1$var$genModalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: "rtl"
                },
                [`${componentCls}-centered`]: {
                    textAlign: "center",
                    "&::before": {
                        display: "inline-block",
                        width: 0,
                        height: "100%",
                        verticalAlign: "middle",
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: "inline-block",
                        paddingBottom: 0,
                        textAlign: "start",
                        verticalAlign: "middle"
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: "calc(100vw - 16px)",
                        margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                pointerEvents: "none",
                position: "relative",
                top: 100,
                width: "auto",
                maxWidth: `calc(100vw - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal())})`,
                margin: "0 auto",
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: "break-word"
                },
                [`${componentCls}-content`]: {
                    position: "relative",
                    backgroundColor: token.contentBg,
                    backgroundClip: "padding-box",
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: "auto",
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: Object.assign({
                    position: "absolute",
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: "none",
                    background: "transparent",
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: "pointer",
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    "&-x": {
                        display: "flex",
                        fontSize: token.fontSizeLG,
                        fontStyle: "normal",
                        lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.modalCloseBtnSize)}`,
                        justifyContent: "center",
                        textTransform: "none",
                        textRendering: "auto"
                    },
                    "&:hover": {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: "none"
                    },
                    "&:active": {
                        backgroundColor: token.colorBgTextActive
                    }
                }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)),
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: "break-word",
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: "end",
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: "hidden"
                }
            })
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: "auto",
                padding: 0,
                display: "flex",
                flexDirection: "column",
                [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: "flex",
                    flexDirection: "column",
                    flex: "auto"
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: "auto"
                }
            }
        }
    ];
};
const $4273ff34fb23b4b1$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: "rtl",
                [`${componentCls}-confirm-body`]: {
                    direction: "rtl"
                }
            }
        }
    };
};
const $4273ff34fb23b4b1$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $4273ff34fb23b4b1$export$9ca1be8807fe0675 = (token)=>({
        footerBg: "transparent",
        headerBg: token.colorBgElevated,
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingMD)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : "none",
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : "none",
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding * 2)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding * 2)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM
    });
var $4273ff34fb23b4b1$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Modal", (token)=>{
    const modalToken = $4273ff34fb23b4b1$export$362fb92a8f81bbf9(token);
    return [
        $4273ff34fb23b4b1$var$genModalStyle(modalToken),
        $4273ff34fb23b4b1$var$genRTLStyle(modalToken),
        $4273ff34fb23b4b1$export$8bb6dada04673ddd(modalToken),
        (0, $d2082114d5952afb$export$f5d123412490d9dc)(modalToken, "zoom")
    ];
}, $4273ff34fb23b4b1$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});


"use client";
var $e567711acbe5f453$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $e567711acbe5f453$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $e567711acbe5f453$var$getClickPosition = (e)=>{
    $e567711acbe5f453$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $e567711acbe5f453$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $ebcf30cec053af5e$export$7dbdadf5e9653129)()) document.documentElement.addEventListener("click", $e567711acbe5f453$var$getClickPosition, true);
const $e567711acbe5f453$var$Modal = (props)=>{
    var _a;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, modal: modalContext } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const handleCancel = (e)=>{
        const { onCancel: onCancel } = props;
        onCancel === null || onCancel === void 0 || onCancel(e);
    };
    const handleOk = (e)=>{
        const { onOk: onOk } = props;
        onOk === null || onOk === void 0 || onOk(e);
    };
    var _ref;
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, focusTriggerAfterClose: focusTriggerAfterClose = true, style: style, visible: // Deprecated
    visible, width: width = 520, footer: footer, classNames: modalClassNames, styles: modalStyles, children: children, loading: loading } = props, restProps = $e567711acbe5f453$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "open",
        "wrapClassName",
        "centered",
        "getContainer",
        "focusTriggerAfterClose",
        "style",
        "visible",
        "width",
        "footer",
        "classNames",
        "styles",
        "children",
        "loading"
    ]);
    const prefixCls = getPrefixCls("modal", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $4273ff34fb23b4b1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(wrapClassName, {
        [`${prefixCls}-centered`]: !!centered,
        [`${prefixCls}-wrap-rtl`]: direction === "rtl"
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $acw62.createElement((0, $52ee3afc292c0929$export$a06f1c675e846f6f), Object.assign({}, props, {
        onOk: handleOk,
        onCancel: handleCancel
    })) : null;
    const [mergedClosable, mergedCloseIcon] = (0, $91e86e8e8e97dd3f$export$2e2bcd8739ae039)((0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(props), (0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $52ee3afc292c0929$export$97c34646962d356e)(prefixCls, icon)
    });
    // ============================ Refs ============================
    // Select `ant-modal-content` by `panelRef`
    const panelRef = (0, $9ce1b741d917b083$export$94ab53417567be34)(`.${prefixCls}-content`);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("Modal", restProps.zIndex);
    // =========================== Render ===========================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $fc48b5916203bd39$export$2e2bcd8739ae039), Object.assign({
        width: width
    }, restProps, {
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, rootClassName, cssVarCls, rootCls),
        footer: dialogFooter,
        visible: open !== null && open !== void 0 ? open : visible,
        mousePosition: (_a = restProps.mousePosition) !== null && _a !== void 0 ? _a : $e567711acbe5f453$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom", props.transitionName),
        maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "fade", props.maskTransitionName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, className, modalContext === null || modalContext === void 0 ? void 0 : modalContext.className),
        style: Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.style), style),
        classNames: Object.assign(Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.classNames), modalClassNames), {
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(wrapClassNameExtended, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper)
        }),
        styles: Object.assign(Object.assign({}, modalContext === null || modalContext === void 0 ? void 0 : modalContext.styles), modalStyles),
        panelRef: panelRef
    }), loading ? /*#__PURE__*/ $acw62.createElement((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : children))));
};
var $e567711acbe5f453$export$2e2bcd8739ae039 = $e567711acbe5f453$var$Modal;


// Style as confirm component




// ============================= Confirm ==============================
const $69c3edf195b4d1b8$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            "&-rtl": {
                direction: "rtl"
            },
            [`${token.antCls}-modal-header`]: {
                display: "none"
            },
            [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()),
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "start",
                [`> ${token.iconCls}`]: {
                    flex: "none",
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: "flex",
                flexDirection: "column",
                flex: "auto",
                rowGap: token.marginXS
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-content`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: "end",
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$69c3edf195b4d1b8$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$1537386bc155ea56)([
    "Modal",
    "confirm"
], (token)=>{
    const modalToken = (0, $4273ff34fb23b4b1$export$362fb92a8f81bbf9)(token);
    return [
        $69c3edf195b4d1b8$var$genModalConfirmStyle(modalToken)
    ];
}, (0, $4273ff34fb23b4b1$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
var $e57a817b0bed94b2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e57a817b0bed94b2$export$78cf841dc2c9f0b5(props) {
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale } = props, resetProps = $e57a817b0bed94b2$var$__rest(props, [
        "prefixCls",
        "icon",
        "okText",
        "cancelText",
        "confirmPrefixCls",
        "type",
        "okCancel",
        "footer",
        "locale"
    ]);
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case "info":
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039), null);
            break;
        case "success":
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $9149fdfb4424d1d9$export$2e2bcd8739ae039), null);
            break;
        case "error":
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ $acw62.createElement((0, $2444f6da62064575$export$2e2bcd8739ae039), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type === "confirm";
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || "ok";
    const [locale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Modal");
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
    const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
    // ================= Context Value =================
    const btnCtxValue = Object.assign({
        autoFocusButton: autoFocusButton,
        cancelTextLocale: cancelTextLocale,
        okTextLocale: okTextLocale,
        mergedOkCancel: mergedOkCancel
    }, resetProps);
    const btnCtxValueMemo = $acw62.useMemo(()=>btnCtxValue, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(Object.values(btnCtxValue)));
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $b41cca75d2dc2fd0$export$2e2bcd8739ae039), null), /*#__PURE__*/ $acw62.createElement((0, $a937a1d7917b01bb$export$2e2bcd8739ae039), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === "function" ? /*#__PURE__*/ $acw62.createElement((0, $6eed8829240c00e1$export$7c9538f5f3c365e9), {
        value: btnCtxValueMemo
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === "function" ? footer(footerOriginNode, {
        OkBtn: $a937a1d7917b01bb$export$2e2bcd8739ae039,
        CancelBtn: $b41cca75d2dc2fd0$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $acw62.createElement((0, $69c3edf195b4d1b8$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
}
const $e57a817b0bed94b2$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, afterClose: afterClose, open: open, keyboard: keyboard, centered: centered, getContainer: getContainer, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, closeIcon: closeIcon, modalRender: modalRender, focusTriggerAfterClose: focusTriggerAfterClose, onConfirm: onConfirm, styles: styles } = props;
    var _ref;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    const mask = props.mask === undefined ? true : props.mask;
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === "rtl"
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const mergedZIndex = $acw62.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $8552b358f1d5b0a4$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $acw62.createElement((0, $e567711acbe5f453$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: classString,
        wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close === null || close === void 0 || close({
                triggerCancel: true
            });
            onConfirm === null || onConfirm === void 0 || onConfirm(false);
        },
        open: open,
        title: "",
        footer: null,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls || "", "zoom", props.transitionName),
        maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls || "", "fade", props.maskTransitionName),
        mask: mask,
        maskClosable: maskClosable,
        style: style,
        styles: Object.assign({
            body: bodyStyle,
            mask: maskStyle
        }, styles),
        width: width,
        zIndex: mergedZIndex,
        afterClose: afterClose,
        keyboard: keyboard,
        centered: centered,
        getContainer: getContainer,
        closable: closable,
        closeIcon: closeIcon,
        modalRender: modalRender,
        focusTriggerAfterClose: focusTriggerAfterClose
    }, /*#__PURE__*/ $acw62.createElement($e57a817b0bed94b2$export$78cf841dc2c9f0b5, Object.assign({}, props, {
        confirmPrefixCls: confirmPrefixCls
    })));
};
const $e57a817b0bed94b2$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $acw62.createElement($e57a817b0bed94b2$var$ConfirmDialog, Object.assign({}, props)));
};
var $e57a817b0bed94b2$export$2e2bcd8739ae039 = $e57a817b0bed94b2$var$ConfirmDialogWrapper;


const $2077bf4ca69b0fef$var$destroyFns = [];
var $2077bf4ca69b0fef$export$2e2bcd8739ae039 = $2077bf4ca69b0fef$var$destroyFns;



"use client";
let $31d3fb1111bc089d$var$defaultRootPrefixCls = "";
function $31d3fb1111bc089d$var$getRootPrefixCls() {
    return $31d3fb1111bc089d$var$defaultRootPrefixCls;
}
const $31d3fb1111bc089d$var$ConfirmDialogWrapper = (props)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $466e4bebfd7443ca$export$1b6004afda18cd51)();
    const config = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const rootPrefixCls = $31d3fb1111bc089d$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e57a817b0bed94b2$export$2e2bcd8739ae039), Object.assign({}, props, {
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction !== null && direction !== void 0 ? direction : config.direction,
        locale: (_b = (_a = config.locale) === null || _a === void 0 ? void 0 : _a.Modal) !== null && _b !== void 0 ? _b : runtimeLocale,
        getContainer: mergedGetContainer
    }));
};
function $31d3fb1111bc089d$export$2e2bcd8739ae039(config) {
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const container = document.createDocumentFragment();
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    let currentConfig = Object.assign(Object.assign({}, config), {
        close: close,
        open: true
    });
    let timeoutId;
    function destroy() {
        var _a;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = config.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                config,
                ()=>{}
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(args.slice(1))));
        }
        for(let i = 0; i < (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039)[i];
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (fn === close) {
                (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $db3659e597d7eb55$export$121e2d597d222bad)(container);
    }
    function render(props) {
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $31d3fb1111bc089d$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31d3fb1111bc089d$var$ConfirmDialogWrapper, Object.assign({}, props));
            (0, $db3659e597d7eb55$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, global.holderRender ? global.holderRender(dom) : dom), container);
        });
    }
    function close() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        currentConfig = Object.assign(Object.assign({}, currentConfig), {
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === "function") config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        });
        // Legacy support
        if (currentConfig.visible) delete currentConfig.visible;
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === "function") currentConfig = configUpdate(currentConfig);
        else currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
        render(currentConfig);
    }
    render(currentConfig);
    (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $31d3fb1111bc089d$export$503fa8fed137d104(props) {
    return Object.assign(Object.assign({}, props), {
        type: "warning"
    });
}
function $31d3fb1111bc089d$export$2f728eab0dacbb2e(props) {
    return Object.assign(Object.assign({}, props), {
        type: "info"
    });
}
function $31d3fb1111bc089d$export$2b5f8d7f29c805d4(props) {
    return Object.assign(Object.assign({}, props), {
        type: "success"
    });
}
function $31d3fb1111bc089d$export$60e9e0884ce12b55(props) {
    return Object.assign(Object.assign({}, props), {
        type: "error"
    });
}
function $31d3fb1111bc089d$export$665b64399d4af99c(props) {
    return Object.assign(Object.assign({}, props), {
        type: "confirm"
    });
}
function $31d3fb1111bc089d$export$ff0b30c638ae2396(_ref) {
    let { rootPrefixCls: rootPrefixCls } = _ref;
    $31d3fb1111bc089d$var$defaultRootPrefixCls = rootPrefixCls;
}





var $acw62 = parcelRequire("acw62");








"use client";
var $5c5e8cd61d089094$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5c5e8cd61d089094$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer } = props, restProps = $5c5e8cd61d089094$var$__rest(props, [
        "prefixCls",
        "className",
        "closeIcon",
        "closable",
        "type",
        "title",
        "children",
        "footer"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls("modal");
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(rootPrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $4273ff34fb23b4b1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : false,
        title: "",
        footer: "",
        children: /*#__PURE__*/ $acw62.createElement((0, $e57a817b0bed94b2$export$78cf841dc2c9f0b5), Object.assign({}, props, {
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        }))
    };
    else additionalProps = {
        closable: closable !== null && closable !== void 0 ? closable : true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $acw62.createElement((0, $52ee3afc292c0929$export$a06f1c675e846f6f), Object.assign({}, props)),
        children: children
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $d87bfeabd0b3848d$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls)
    }, restProps, {
        closeIcon: (0, $52ee3afc292c0929$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable
    }, additionalProps)));
};
var $5c5e8cd61d089094$export$2e2bcd8739ae039 = (0, $91653a8941ab7768$export$29e2a8c3cdb34b03)($5c5e8cd61d089094$var$PurePanel);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $36203fe8ea319954$export$2e2bcd8739ae039() {
    const [elements, setElements] = $acw62.useState([]);
    const patchElement = $acw62.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
}






var $acw62 = parcelRequire("acw62");




"use client";
var $f743e93ee4f7840b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f743e93ee4f7840b$var$HookModal = (_a, ref)=>{
    var _b;
    var { afterClose: hookAfterClose, config: config } = _a, restProps = $f743e93ee4f7840b$var$__rest(_a, [
        "afterClose",
        "config"
    ]);
    const [open, setOpen] = $acw62.useState(true);
    const [innerConfig, setInnerConfig] = $acw62.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("modal");
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        var _a;
        hookAfterClose();
        (_a = innerConfig.afterClose) === null || _a === void 0 || _a.call(innerConfig);
    };
    const close = function() {
        var _a;
        setOpen(false);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const triggerCancel = args.some((param)=>param === null || param === void 0 ? void 0 : param.triggerCancel);
        if (triggerCancel) {
            var _a2;
            (_a = innerConfig.onCancel) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                innerConfig,
                ()=>{}
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(args.slice(1))));
        }
    };
    $acw62.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>Object.assign(Object.assign({}, originConfig), newConfig));
            }
        }));
    const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === "confirm";
    const [contextLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Modal", (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Modal);
    return /*#__PURE__*/ $acw62.createElement((0, $e57a817b0bed94b2$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls
    }, innerConfig, {
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
    }, restProps));
};
var $f743e93ee4f7840b$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($f743e93ee4f7840b$var$HookModal);


"use client";
let $b16aece18eefbd47$var$uuid = 0;
const $b16aece18eefbd47$var$ElementsHolder = /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $36203fe8ea319954$export$2e2bcd8739ae039)();
    $acw62.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), []);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, elements);
}));
function $b16aece18eefbd47$var$useModal() {
    const holderRef = $acw62.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $acw62.useCallback((withFunc)=>function hookConfirm(config) {
            var _a;
            $b16aece18eefbd47$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $acw62.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $acw62.createElement((0, $f743e93ee4f7840b$export$2e2bcd8739ae039), {
                key: `modal-${$b16aece18eefbd47$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc === null || closeFunc === void 0 || closeFunc();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            if (closeFunc) (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        var _a;
                        (_a = modalRef.current) === null || _a === void 0 || _a.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $acw62.useMemo(()=>({
            info: getConfirmFunc((0, $31d3fb1111bc089d$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $31d3fb1111bc089d$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $31d3fb1111bc089d$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $31d3fb1111bc089d$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $31d3fb1111bc089d$export$665b64399d4af99c))
        }), []);
    return [
        fns,
        /*#__PURE__*/ $acw62.createElement($b16aece18eefbd47$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $b16aece18eefbd47$export$2e2bcd8739ae039 = $b16aece18eefbd47$var$useModal;


"use client";
function $e47cb76d58815cb1$var$modalWarn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$503fa8fed137d104)(props));
}
const $e47cb76d58815cb1$var$Modal = (0, $e567711acbe5f453$export$2e2bcd8739ae039);
$e47cb76d58815cb1$var$Modal.useModal = (0, $b16aece18eefbd47$export$2e2bcd8739ae039);
$e47cb76d58815cb1$var$Modal.info = function infoFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$2f728eab0dacbb2e)(props));
};
$e47cb76d58815cb1$var$Modal.success = function successFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$2b5f8d7f29c805d4)(props));
};
$e47cb76d58815cb1$var$Modal.error = function errorFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$60e9e0884ce12b55)(props));
};
$e47cb76d58815cb1$var$Modal.warning = $e47cb76d58815cb1$var$modalWarn;
$e47cb76d58815cb1$var$Modal.warn = $e47cb76d58815cb1$var$modalWarn;
$e47cb76d58815cb1$var$Modal.confirm = function confirmFn(props) {
    return (0, $31d3fb1111bc089d$export$2e2bcd8739ae039)((0, $31d3fb1111bc089d$export$665b64399d4af99c)(props));
};
$e47cb76d58815cb1$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).length){
        const close = (0, $2077bf4ca69b0fef$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$e47cb76d58815cb1$var$Modal.config = (0, $31d3fb1111bc089d$export$ff0b30c638ae2396);
$e47cb76d58815cb1$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $5c5e8cd61d089094$export$2e2bcd8739ae039);
var $e47cb76d58815cb1$export$2e2bcd8739ae039 = $e47cb76d58815cb1$var$Modal;


var $acw62 = parcelRequire("acw62");
var $5f2cc95ff3bf4bb6$export$e1053575ddfcb301 = {};
var $5f2cc95ff3bf4bb6$export$91b75cf262680225 = "rc-table-internal-hook";







var $acw62 = parcelRequire("acw62");

function $2b6e94889042e439$export$fd42f52fd3ae1109(defaultValue) {
    var Context = /*#__PURE__*/ $acw62.createContext(undefined);
    var Provider = function Provider(_ref) {
        var value = _ref.value, children = _ref.children;
        var valueRef = $acw62.useRef(value);
        valueRef.current = value;
        var _React$useState = $acw62.useState(function() {
            return {
                getValue: function getValue() {
                    return valueRef.current;
                },
                listeners: new Set()
            };
        }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), context = _React$useState2[0];
        (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
            (0, $11492dca620dcaa5$exports.unstable_batchedUpdates)(function() {
                context.listeners.forEach(function(listener) {
                    listener(value);
                });
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $acw62.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider,
        defaultValue: defaultValue
    };
}
function $2b6e94889042e439$export$fae74005e78b1a27(holder, selector) {
    var eventSelector = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(typeof selector === "function" ? selector : function(ctx) {
        if (selector === undefined) return ctx;
        if (!Array.isArray(selector)) return ctx[selector];
        var obj = {};
        selector.forEach(function(key) {
            obj[key] = ctx[key];
        });
        return obj;
    });
    var context = $acw62.useContext(holder === null || holder === void 0 ? void 0 : holder.Context);
    var _ref2 = context || {}, listeners = _ref2.listeners, getValue = _ref2.getValue;
    var valueRef = $acw62.useRef();
    valueRef.current = eventSelector(context ? getValue() : holder === null || holder === void 0 ? void 0 : holder.defaultValue);
    var _React$useState3 = $acw62.useState({}), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), forceUpdate = _React$useState4[1];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (!context) return;
        function trigger(nextValue) {
            var nextSelectorValue = eventSelector(nextValue);
            if (!(0, $357adc8667cde522$export$2e2bcd8739ae039)(valueRef.current, nextSelectorValue, true)) forceUpdate({});
        }
        listeners.add(trigger);
        return function() {
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return valueRef.current;
}





var $acw62 = parcelRequire("acw62");
function $a6c6008fe53487e1$export$2e2bcd8739ae039() {
    var ImmutableContext = /*#__PURE__*/ $acw62.createContext(null);
    /**
   * Get render update mark by `makeImmutable` root.
   * Do not deps on the return value as render times
   * but only use for `useMemo` or `useCallback` deps.
   */ function useImmutableMark() {
        return $acw62.useContext(ImmutableContext);
    }
    /**
  * Wrapped Component will be marked as Immutable.
  * When Component parent trigger render,
  * it will notice children component (use with `responseImmutable`) node that parent has updated.
  * @param Component Passed Component
  * @param triggerRender Customize trigger `responseImmutable` children re-render logic. Default will always trigger re-render when this component re-render.
  */ function makeImmutable(Component, shouldTriggerRender) {
        var refAble = (0, $5e297877593af644$export$c1cec34af06bcf7)(Component);
        var ImmutableComponent = function ImmutableComponent(props, ref) {
            var refProps = refAble ? {
                ref: ref
            } : {};
            var renderTimesRef = $acw62.useRef(0);
            var prevProps = $acw62.useRef(props);
            // If parent has the context, we do not wrap it
            var mark = useImmutableMark();
            if (mark !== null) return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, refProps));
            if (// Always trigger re-render if not provide `notTriggerRender`
            !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)) renderTimesRef.current += 1;
            prevProps.current = props;
            return /*#__PURE__*/ $acw62.createElement(ImmutableContext.Provider, {
                value: renderTimesRef.current
            }, /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, refProps)));
        };
        return refAble ? /*#__PURE__*/ $acw62.forwardRef(ImmutableComponent) : ImmutableComponent;
    }
    /**
   * Wrapped Component with `React.memo`.
   * But will rerender when parent with `makeImmutable` rerender.
   */ function responseImmutable(Component, propsAreEqual) {
        var refAble = (0, $5e297877593af644$export$c1cec34af06bcf7)(Component);
        var ImmutableComponent = function ImmutableComponent(props, ref) {
            var refProps = refAble ? {
                ref: ref
            } : {};
            useImmutableMark();
            return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, refProps));
        };
        return refAble ? /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(ImmutableComponent), propsAreEqual) : /*#__PURE__*/ $acw62.memo(ImmutableComponent, propsAreEqual);
    }
    return {
        makeImmutable: makeImmutable,
        responseImmutable: responseImmutable,
        useImmutableMark: useImmutableMark
    };
}


// For legacy usage, we export it directly
var $ecc5eb53c8c5a4f3$var$_createImmutable = (0, $a6c6008fe53487e1$export$2e2bcd8739ae039)(), $ecc5eb53c8c5a4f3$export$ffd6d5bef5eaf0a4 = $ecc5eb53c8c5a4f3$var$_createImmutable.makeImmutable, $ecc5eb53c8c5a4f3$export$e9e4cb9eb9e2b4c4 = $ecc5eb53c8c5a4f3$var$_createImmutable.responseImmutable, $ecc5eb53c8c5a4f3$export$c5d829a463bd3201 = $ecc5eb53c8c5a4f3$var$_createImmutable.useImmutableMark;



var $acw62 = parcelRequire("acw62");

var $22d941e9230e52ce$var$_createImmutable = (0, $a6c6008fe53487e1$export$2e2bcd8739ae039)(), $22d941e9230e52ce$export$ffd6d5bef5eaf0a4 = $22d941e9230e52ce$var$_createImmutable.makeImmutable, $22d941e9230e52ce$export$e9e4cb9eb9e2b4c4 = $22d941e9230e52ce$var$_createImmutable.responseImmutable, $22d941e9230e52ce$export$c5d829a463bd3201 = $22d941e9230e52ce$var$_createImmutable.useImmutableMark;
var $22d941e9230e52ce$var$TableContext = (0, $2b6e94889042e439$export$fd42f52fd3ae1109)();
var $22d941e9230e52ce$export$2e2bcd8739ae039 = $22d941e9230e52ce$var$TableContext;


/* istanbul ignore file */ 
var $acw62 = parcelRequire("acw62");
function $0004b54412a6a014$var$useRenderTimes(props, debug) {
    // Render times
    var timesRef = $acw62.useRef(0);
    timesRef.current += 1;
    // Props changed
    var propsRef = $acw62.useRef(props);
    var keys = [];
    Object.keys(props || {}).map(function(key) {
        var _propsRef$current;
        if ((props === null || props === void 0 ? void 0 : props[key]) !== ((_propsRef$current = propsRef.current) === null || _propsRef$current === void 0 ? void 0 : _propsRef$current[key])) keys.push(key);
    });
    propsRef.current = props;
    // Cache keys since React rerender may cause it lost
    var keysRef = $acw62.useRef([]);
    if (keys.length) keysRef.current = keys;
    $acw62.useDebugValue(timesRef.current);
    $acw62.useDebugValue(keysRef.current.join(", "));
    if (debug) console.log("".concat(debug, ":"), timesRef.current, keysRef.current);
    return timesRef.current;
}
var $0004b54412a6a014$export$2e2bcd8739ae039 = function() {};
var $0004b54412a6a014$export$e57c788cafefed4f = /*#__PURE__*/ $acw62.memo(function() {
    var times = $0004b54412a6a014$var$useRenderTimes();
    return /*#__PURE__*/ $acw62.createElement("h1", null, "Render Times: ", times);
});




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// TODO: Remove when use `responsiveImmutable`
var $509ef1d103e7af0d$var$PerfContext = /*#__PURE__*/ $acw62.createContext({
    renderWithProps: false
});
var $509ef1d103e7af0d$export$2e2bcd8739ae039 = $509ef1d103e7af0d$var$PerfContext;


var $b1ce2e4492efd614$var$INTERNAL_KEY_PREFIX = "RC_TABLE_KEY";
function $b1ce2e4492efd614$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $b1ce2e4492efd614$export$fd2ca5407d9be470(columns) {
    var columnKeys = [];
    var keys = {};
    columns.forEach(function(column) {
        var _ref = column || {}, key = _ref.key, dataIndex = _ref.dataIndex;
        var mergedKey = key || $b1ce2e4492efd614$var$toArray(dataIndex).join("-") || $b1ce2e4492efd614$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = "".concat(mergedKey, "_next");
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $b1ce2e4492efd614$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}



function $32b0eb62770f791f$var$isRenderCell(data) {
    return data && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(data) === "object" && !Array.isArray(data) && !/*#__PURE__*/ $acw62.isValidElement(data);
}
function $32b0eb62770f791f$export$2e2bcd8739ae039(record, dataIndex, renderIndex, children, render, shouldCellUpdate) {
    // TODO: Remove this after next major version
    var perfRecord = $acw62.useContext((0, $509ef1d103e7af0d$export$2e2bcd8739ae039));
    var mark = (0, $22d941e9230e52ce$export$c5d829a463bd3201)();
    // ======================== Render ========================
    var retData = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        if ((0, $b1ce2e4492efd614$export$b76e9316566cc26e)(children)) return [
            children
        ];
        var path = dataIndex === null || dataIndex === undefined || dataIndex === "" ? [] : Array.isArray(dataIndex) ? dataIndex : [
            dataIndex
        ];
        var value = (0, $17fcde5782384c29$export$2e2bcd8739ae039)(record, path);
        // Customize render node
        var returnChildNode = value;
        var returnCellProps = undefined;
        if (render) {
            var renderData = render(value, record, renderIndex);
            if ($32b0eb62770f791f$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        // Force update deps
        mark,
        // Normal deps
        record,
        children,
        dataIndex,
        render,
        renderIndex
    ], function(prev, next) {
        if (shouldCellUpdate) {
            var _prev = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(prev, 2), prevRecord = _prev[1];
            var _next = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(next, 2), nextRecord = _next[1];
            return shouldCellUpdate(nextRecord, prevRecord);
        }
        // Legacy mode should always update
        if (perfRecord.renderWithProps) return true;
        return !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev, next, true);
    });
    return retData;
}




/** Check if cell is in hover range */ function $2a8969a9ceca54c7$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    var cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $2a8969a9ceca54c7$export$2e2bcd8739ae039(rowIndex, rowSpan) {
    return (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), function(ctx) {
        var hovering = $2a8969a9ceca54c7$var$inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
        return [
            hovering,
            ctx.onHover
        ];
    });
}



var $2e31a35df2b3b43c$var$getTitleFromCellRenderChildren = function getTitleFromCellRenderChildren(_ref) {
    var ellipsis = _ref.ellipsis, rowType = _ref.rowType, children = _ref.children;
    var title;
    var ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === "header")) {
        if (typeof children === "string" || typeof children === "number") title = children.toString();
        else if (/*#__PURE__*/ $acw62.isValidElement(children) && typeof children.props.children === "string") title = children.props.children;
    }
    return title;
};
function $2e31a35df2b3b43c$var$Cell(props) {
    var _ref2, _ref3, _legacyCellProps$colS, _ref4, _ref5, _legacyCellProps$rowS, _additionalProps$titl, _classNames;
    var Component = props.component, children = props.children, ellipsis = props.ellipsis, scope = props.scope, prefixCls = props.prefixCls, className = props.className, align = props.align, record = props.record, render = props.render, dataIndex = props.dataIndex, renderIndex = props.renderIndex, shouldCellUpdate = props.shouldCellUpdate, index = props.index, rowType = props.rowType, colSpan = props.colSpan, rowSpan = props.rowSpan, fixLeft = props.fixLeft, fixRight = props.fixRight, firstFixLeft = props.firstFixLeft, lastFixLeft = props.lastFixLeft, firstFixRight = props.firstFixRight, lastFixRight = props.lastFixRight, appendNode = props.appendNode, _props$additionalProp = props.additionalProps, additionalProps = _props$additionalProp === void 0 ? {} : _props$additionalProp, isSticky = props.isSticky;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "supportSticky",
        "allColumnsFixedLeft",
        "rowHoverable"
    ]), supportSticky = _useContext.supportSticky, allColumnsFixedLeft = _useContext.allColumnsFixedLeft, rowHoverable = _useContext.rowHoverable;
    // ====================== Value =======================
    var _useCellRender = (0, $32b0eb62770f791f$export$2e2bcd8739ae039)(record, dataIndex, renderIndex, children, render, shouldCellUpdate), _useCellRender2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useCellRender, 2), childNode = _useCellRender2[0], legacyCellProps = _useCellRender2[1];
    // ====================== Fixed =======================
    var fixedStyle = {};
    var isFixLeft = typeof fixLeft === "number" && supportSticky;
    var isFixRight = typeof fixRight === "number" && supportSticky;
    if (isFixLeft) {
        fixedStyle.position = "sticky";
        fixedStyle.left = fixLeft;
    }
    if (isFixRight) {
        fixedStyle.position = "sticky";
        fixedStyle.right = fixRight;
    }
    // ================ RowSpan & ColSpan =================
    var mergedColSpan = (_ref2 = (_ref3 = (_legacyCellProps$colS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.colSpan) !== null && _legacyCellProps$colS !== void 0 ? _legacyCellProps$colS : additionalProps.colSpan) !== null && _ref3 !== void 0 ? _ref3 : colSpan) !== null && _ref2 !== void 0 ? _ref2 : 1;
    var mergedRowSpan = (_ref4 = (_ref5 = (_legacyCellProps$rowS = legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.rowSpan) !== null && _legacyCellProps$rowS !== void 0 ? _legacyCellProps$rowS : additionalProps.rowSpan) !== null && _ref5 !== void 0 ? _ref5 : rowSpan) !== null && _ref4 !== void 0 ? _ref4 : 1;
    // ====================== Hover =======================
    var _useHoverState = (0, $2a8969a9ceca54c7$export$2e2bcd8739ae039)(index, mergedRowSpan), _useHoverState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useHoverState, 2), hovering = _useHoverState2[0], onHover = _useHoverState2[1];
    var onMouseEnter = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(event) {
        var _additionalProps$onMo;
        if (record) onHover(index, index + mergedRowSpan - 1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo = additionalProps.onMouseEnter) === null || _additionalProps$onMo === void 0 || _additionalProps$onMo.call(additionalProps, event);
    });
    var onMouseLeave = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(event) {
        var _additionalProps$onMo2;
        if (record) onHover(-1, -1);
        additionalProps === null || additionalProps === void 0 || (_additionalProps$onMo2 = additionalProps.onMouseLeave) === null || _additionalProps$onMo2 === void 0 || _additionalProps$onMo2.call(additionalProps, event);
    });
    // ====================== Render ======================
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
    // >>>>> Title
    var title = (_additionalProps$titl = additionalProps.title) !== null && _additionalProps$titl !== void 0 ? _additionalProps$titl : $2e31a35df2b3b43c$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    // >>>>> ClassName
    var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(cellPrefixCls, className, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-left"), isFixLeft && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-left-first"), firstFixLeft && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-left-last"), lastFixLeft && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-left-all"), lastFixLeft && allColumnsFixedLeft && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-right"), isFixRight && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-right-first"), firstFixRight && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-right-last"), lastFixRight && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-ellipsis"), ellipsis), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-with-append"), appendNode), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-fix-sticky"), (isFixLeft || isFixRight) && isSticky && supportSticky), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(cellPrefixCls, "-row-hover"), !legacyCellProps && hovering), _classNames), additionalProps.className, legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.className);
    // >>>>> Style
    var alignStyle = {};
    if (align) alignStyle.textAlign = align;
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, fixedStyle), additionalProps.style), alignStyle), legacyCellProps === null || legacyCellProps === void 0 ? void 0 : legacyCellProps.style);
    // >>>>> Children Node
    var mergedChildNode = childNode;
    // Not crash if final `childNode` is not validate ReactNode
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(mergedChildNode) === "object" && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $acw62.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (lastFixLeft || firstFixRight)) mergedChildNode = /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(cellPrefixCls, "-content")
    }, mergedChildNode);
    return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, legacyCellProps, additionalProps, {
        className: mergedClassName,
        style: mergedStyle,
        title: title,
        scope: scope,
        onMouseEnter: rowHoverable ? onMouseEnter : undefined,
        onMouseLeave: rowHoverable ? onMouseLeave : undefined,
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
    }), appendNode, mergedChildNode);
}
var $2e31a35df2b3b43c$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($2e31a35df2b3b43c$var$Cell);




function $533a734f6aca19a1$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets, direction) {
    var startColumn = columns[colStart] || {};
    var endColumn = columns[colEnd] || {};
    var fixLeft;
    var fixRight;
    if (startColumn.fixed === "left") fixLeft = stickyOffsets.left[direction === "rtl" ? colEnd : colStart];
    else if (endColumn.fixed === "right") fixRight = stickyOffsets.right[direction === "rtl" ? colStart : colEnd];
    var lastFixLeft = false;
    var firstFixRight = false;
    var lastFixRight = false;
    var firstFixLeft = false;
    var nextColumn = columns[colEnd + 1];
    var prevColumn = columns[colStart - 1];
    // need show shadow only when canLastFix is true
    var canLastFix = nextColumn && !nextColumn.fixed || prevColumn && !prevColumn.fixed || columns.every(function(col) {
        return col.fixed === "left";
    });
    if (direction === "rtl") {
        if (fixLeft !== undefined) {
            var prevFixLeft = prevColumn && prevColumn.fixed === "left";
            firstFixLeft = !prevFixLeft && canLastFix;
        } else if (fixRight !== undefined) {
            var nextFixRight = nextColumn && nextColumn.fixed === "right";
            lastFixRight = !nextFixRight && canLastFix;
        }
    } else if (fixLeft !== undefined) {
        var nextFixLeft = nextColumn && nextColumn.fixed === "left";
        lastFixLeft = !nextFixLeft && canLastFix;
    } else if (fixRight !== undefined) {
        var prevFixRight = prevColumn && prevColumn.fixed === "right";
        firstFixRight = !prevFixRight && canLastFix;
    }
    return {
        fixLeft: fixLeft,
        fixRight: fixRight,
        lastFixLeft: lastFixLeft,
        firstFixRight: firstFixRight,
        lastFixRight: lastFixRight,
        firstFixLeft: firstFixLeft,
        isSticky: stickyOffsets.isSticky
    };
}



var $acw62 = parcelRequire("acw62");
var $4481e6c8f03a9146$var$SummaryContext = /*#__PURE__*/ $acw62.createContext({});
var $4481e6c8f03a9146$export$2e2bcd8739ae039 = $4481e6c8f03a9146$var$SummaryContext;


function $0c60ca8e95ee6d31$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, index = _ref.index, children = _ref.children, _ref$colSpan = _ref.colSpan, colSpan = _ref$colSpan === void 0 ? 1 : _ref$colSpan, rowSpan = _ref.rowSpan, align = _ref.align;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "prefixCls",
        "direction"
    ]), prefixCls = _useContext.prefixCls, direction = _useContext.direction;
    var _React$useContext = $acw62.useContext((0, $4481e6c8f03a9146$export$2e2bcd8739ae039)), scrollColumnIndex = _React$useContext.scrollColumnIndex, stickyOffsets = _React$useContext.stickyOffsets, flattenColumns = _React$useContext.flattenColumns;
    var lastIndex = index + colSpan - 1;
    var mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    var fixedInfo = (0, $533a734f6aca19a1$export$695db918331141f3)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets, direction);
    return /*#__PURE__*/ $acw62.createElement((0, $2e31a35df2b3b43c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: function render() {
            return children;
        }
    }, fixedInfo));
}




var $acw62 = parcelRequire("acw62");
var $99049c316d79d591$var$_excluded = [
    "children"
];
function $99049c316d79d591$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $99049c316d79d591$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement("tr", props, children);
}


/**
 * Syntactic sugar. Do not support HOC.
 */ function $8e6409dc82717fb8$var$Summary(_ref) {
    var children = _ref.children;
    return children;
}
$8e6409dc82717fb8$var$Summary.Row = (0, $99049c316d79d591$export$2e2bcd8739ae039);
$8e6409dc82717fb8$var$Summary.Cell = (0, $0c60ca8e95ee6d31$export$2e2bcd8739ae039);
var $8e6409dc82717fb8$export$2e2bcd8739ae039 = $8e6409dc82717fb8$var$Summary;



function $46b6722da5e5f96e$var$Footer(props) {
    var children = props.children, stickyOffsets = props.stickyOffsets, flattenColumns = props.flattenColumns;
    var prefixCls = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), "prefixCls");
    var lastColumnIndex = flattenColumns.length - 1;
    var scrollColumn = flattenColumns[lastColumnIndex];
    var summaryContext = $acw62.useMemo(function() {
        return {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: scrollColumn !== null && scrollColumn !== void 0 && scrollColumn.scrollbar ? lastColumnIndex : null
        };
    }, [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $4481e6c8f03a9146$export$2e2bcd8739ae039).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $acw62.createElement("tfoot", {
        className: "".concat(prefixCls, "-summary")
    }, children));
}
var $46b6722da5e5f96e$export$2e2bcd8739ae039 = (0, $22d941e9230e52ce$export$e9e4cb9eb9e2b4c4)($46b6722da5e5f96e$var$Footer);
var $46b6722da5e5f96e$export$d605f3af09eef683 = (0, $8e6409dc82717fb8$export$2e2bcd8739ae039);


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $6c13968ac95170e6$var$Column(_) {
    return null;
}
var $6c13968ac95170e6$export$2e2bcd8739ae039 = $6c13968ac95170e6$var$Column;


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $220c394bb4cc7b1f$var$ColumnGroup(_) {
    return null;
}
var $220c394bb4cc7b1f$export$2e2bcd8739ae039 = $220c394bb4cc7b1f$var$ColumnGroup;
















var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// recursion (flat tree structure)
function $78671905ff86343f$var$fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    list.push({
        record: record,
        indent: indent,
        index: index
    });
    var key = getRowKey(record);
    var expanded = expandedKeys === null || expandedKeys === void 0 ? void 0 : expandedKeys.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(var i = 0; i < record[childrenColumnName].length; i += 1)$78671905ff86343f$var$fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
}
function $78671905ff86343f$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    var arr = $acw62.useMemo(function() {
        if (expandedKeys !== null && expandedKeys !== void 0 && expandedKeys.size) {
            var list = [];
            // collect flattened record
            for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i += 1){
                var record = data[i];
                // using array.push or spread operator may cause "Maximum call stack size exceeded" exception if array size is big enough.
                $78671905ff86343f$var$fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
            }
            return list;
        }
        return data === null || data === void 0 ? void 0 : data.map(function(item, index) {
            return {
                record: item,
                indent: 0,
                index: index
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}








var $acw62 = parcelRequire("acw62");









function $bcd5585dffbf99c6$export$2e2bcd8739ae039(record, rowKey, recordIndex, indent) {
    var context = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "prefixCls",
        "fixedInfoList",
        "flattenColumns",
        "expandableType",
        "expandRowByClick",
        "onTriggerExpand",
        "rowClassName",
        "expandedRowClassName",
        "indentSize",
        "expandIcon",
        "expandedRowRender",
        "expandIconColumnIndex",
        "expandedKeys",
        "childrenColumnName",
        "rowExpandable",
        "onRow"
    ]);
    var flattenColumns = context.flattenColumns, expandableType = context.expandableType, expandedKeys = context.expandedKeys, childrenColumnName = context.childrenColumnName, onTriggerExpand = context.onTriggerExpand, rowExpandable = context.rowExpandable, onRow = context.onRow, expandRowByClick = context.expandRowByClick, rowClassName = context.rowClassName;
    // ======================= Expandable =======================
    // Only when row is not expandable and `children` exist in record
    var nestExpandable = expandableType === "nest";
    var rowSupportExpand = expandableType === "row" && (!rowExpandable || rowExpandable(record));
    var mergedExpandable = rowSupportExpand || nestExpandable;
    var expanded = expandedKeys && expandedKeys.has(rowKey);
    var hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    var onInternalTriggerExpand = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(onTriggerExpand);
    // ========================= onRow ==========================
    var rowProps = onRow === null || onRow === void 0 ? void 0 : onRow(record, recordIndex);
    var onRowClick = rowProps === null || rowProps === void 0 ? void 0 : rowProps.onClick;
    var onClick = function onClick(event) {
        if (expandRowByClick && mergedExpandable) onTriggerExpand(record, event);
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        onRowClick === null || onRowClick === void 0 || onRowClick.apply(void 0, [
            event
        ].concat(args));
    };
    // ====================== RowClassName ======================
    var computeRowClassName;
    if (typeof rowClassName === "string") computeRowClassName = rowClassName;
    else if (typeof rowClassName === "function") computeRowClassName = rowClassName(record, recordIndex, indent);
    // ========================= Column =========================
    var columnsKey = (0, $b1ce2e4492efd614$export$fd2ca5407d9be470)(flattenColumns);
    return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, context), {}, {
        columnsKey: columnsKey,
        nestExpandable: nestExpandable,
        expanded: expanded,
        hasNestChildren: hasNestChildren,
        record: record,
        onTriggerExpand: onInternalTriggerExpand,
        rowSupportExpand: rowSupportExpand,
        expandable: mergedExpandable,
        rowProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rowProps), {}, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(computeRowClassName, rowProps === null || rowProps === void 0 ? void 0 : rowProps.className),
            onClick: onClick
        })
    });
}




var $acw62 = parcelRequire("acw62");



function $85c485a146925ee8$var$ExpandedRow(props) {
    var prefixCls = props.prefixCls, children = props.children, Component = props.component, cellComponent = props.cellComponent, className = props.className, expanded = props.expanded, colSpan = props.colSpan, isEmpty = props.isEmpty;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "scrollbarSize",
        "fixHeader",
        "fixColumn",
        "componentWidth",
        "horizonScroll"
    ]), scrollbarSize = _useContext.scrollbarSize, fixHeader = _useContext.fixHeader, fixColumn = _useContext.fixColumn, componentWidth = _useContext.componentWidth, horizonScroll = _useContext.horizonScroll;
    // Cache render node
    var contentNode = children;
    if (isEmpty ? horizonScroll && componentWidth : fixColumn) contentNode = /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            width: componentWidth - (fixHeader ? scrollbarSize : 0),
            position: "sticky",
            left: 0,
            overflow: "hidden"
        },
        className: "".concat(prefixCls, "-expanded-row-fixed")
    }, contentNode);
    return /*#__PURE__*/ $acw62.createElement(Component, {
        className: className,
        style: {
            display: expanded ? null : "none"
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $2e31a35df2b3b43c$export$2e2bcd8739ae039), {
        component: cellComponent,
        prefixCls: prefixCls,
        colSpan: colSpan
    }, contentNode));
}
var $85c485a146925ee8$export$2e2bcd8739ae039 = $85c485a146925ee8$var$ExpandedRow;


function $3947fe8a4b6be6fe$export$16400ac709c56616(rowInfo, column, colIndex, indent, index) {
    var record = rowInfo.record, prefixCls = rowInfo.prefixCls, columnsKey = rowInfo.columnsKey, fixedInfoList = rowInfo.fixedInfoList, expandIconColumnIndex = rowInfo.expandIconColumnIndex, nestExpandable = rowInfo.nestExpandable, indentSize = rowInfo.indentSize, expandIcon = rowInfo.expandIcon, expanded = rowInfo.expanded, hasNestChildren = rowInfo.hasNestChildren, onTriggerExpand = rowInfo.onTriggerExpand;
    var key = columnsKey[colIndex];
    var fixedInfo = fixedInfoList[colIndex];
    // ============= Used for nest expandable =============
    var appendCellNode;
    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            paddingLeft: "".concat(indentSize * indent, "px")
        },
        className: "".concat(prefixCls, "-row-indent indent-level-").concat(indent)
    }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
    }));
    var additionalCellProps;
    if (column.onCell) additionalCellProps = column.onCell(record, index);
    return {
        key: key,
        fixedInfo: fixedInfo,
        appendCellNode: appendCellNode,
        additionalCellProps: additionalCellProps || {}
    };
}
// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
function $3947fe8a4b6be6fe$var$BodyRow(props) {
    var className = props.className, style = props.style, record = props.record, index = props.index, renderIndex = props.renderIndex, rowKey = props.rowKey, _props$indent = props.indent, indent = _props$indent === void 0 ? 0 : _props$indent, RowComponent = props.rowComponent, cellComponent = props.cellComponent, scopeCellComponent = props.scopeCellComponent;
    var rowInfo = (0, $bcd5585dffbf99c6$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    var prefixCls = rowInfo.prefixCls, flattenColumns = rowInfo.flattenColumns, expandedRowClassName = rowInfo.expandedRowClassName, expandedRowRender = rowInfo.expandedRowRender, rowProps = rowInfo.rowProps, expanded = rowInfo.expanded, rowSupportExpand = rowInfo.rowSupportExpand;
    // Force render expand row if expanded before
    var expandedRef = $acw62.useRef(false);
    expandedRef.current || (expandedRef.current = expanded);
    // 若没有 expandedRowRender 参数, 将使用 baseRowNode 渲染 Children
    // 此时如果 level > 1 则说明是 expandedRow, 一样需要附加 computedExpandedRowClassName
    var computedExpandedRowClassName = expandedRowClassName && expandedRowClassName(record, index, indent);
    // ======================== Base tr row ========================
    var baseRowNode = /*#__PURE__*/ $acw62.createElement(RowComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowProps, {
        "data-row-key": rowKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, "".concat(prefixCls, "-row"), "".concat(prefixCls, "-row-level-").concat(indent), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, indent >= 1 ? computedExpandedRowClassName : ""),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
    }), flattenColumns.map(function(column, colIndex) {
        var render = column.render, dataIndex = column.dataIndex, columnClassName = column.className;
        var _getCellProps = $3947fe8a4b6be6fe$export$16400ac709c56616(rowInfo, column, colIndex, indent, index), key = _getCellProps.key, fixedInfo = _getCellProps.fixedInfo, appendCellNode = _getCellProps.appendCellNode, additionalCellProps = _getCellProps.additionalCellProps;
        return /*#__PURE__*/ $acw62.createElement((0, $2e31a35df2b3b43c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: columnClassName,
            ellipsis: column.ellipsis,
            align: column.align,
            scope: column.rowScope,
            component: column.rowScope ? scopeCellComponent : cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps
        }));
    }));
    // ======================== Expand Row =========================
    var expandRowNode;
    if (rowSupportExpand && (expandedRef.current || expanded)) {
        var expandContent = expandedRowRender(record, index, indent + 1, expanded);
        expandRowNode = /*#__PURE__*/ $acw62.createElement((0, $85c485a146925ee8$export$2e2bcd8739ae039), {
            expanded: expanded,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: flattenColumns.length,
            isEmpty: false
        }, expandContent);
    }
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, baseRowNode, expandRowNode);
}
var $3947fe8a4b6be6fe$export$2e2bcd8739ae039 = (0, $22d941e9230e52ce$export$e9e4cb9eb9e2b4c4)($3947fe8a4b6be6fe$var$BodyRow);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $11f84790e7524d63$export$2e2bcd8739ae039(_ref) {
    var columnKey = _ref.columnKey, onColumnResize = _ref.onColumnResize;
    var cellRef = $acw62.useRef();
    $acw62.useEffect(function() {
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        data: columnKey
    }, /*#__PURE__*/ $acw62.createElement("td", {
        ref: cellRef,
        style: {
            padding: 0,
            border: 0,
            height: 0
        }
    }, /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            height: 0,
            overflow: "hidden"
        }
    }, "\xa0")));
}


function $f8d88c93ca218423$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, columnsKey = _ref.columnsKey, onColumnResize = _ref.onColumnResize;
    return /*#__PURE__*/ $acw62.createElement("tr", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-measure-row"),
        style: {
            height: 0,
            fontSize: 0
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039).Collection, {
        onBatchResize: function onBatchResize(infoList) {
            infoList.forEach(function(_ref2) {
                var columnKey = _ref2.data, size = _ref2.size;
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map(function(columnKey) {
        return /*#__PURE__*/ $acw62.createElement((0, $11f84790e7524d63$export$2e2bcd8739ae039), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize
        });
    })));
}


function $c323f6b3243a8952$var$Body(props) {
    var data = props.data, measureColumnWidth = props.measureColumnWidth;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "prefixCls",
        "getComponent",
        "onColumnResize",
        "flattenColumns",
        "getRowKey",
        "expandedKeys",
        "childrenColumnName",
        "emptyNode"
    ]), prefixCls = _useContext.prefixCls, getComponent = _useContext.getComponent, onColumnResize = _useContext.onColumnResize, flattenColumns = _useContext.flattenColumns, getRowKey = _useContext.getRowKey, expandedKeys = _useContext.expandedKeys, childrenColumnName = _useContext.childrenColumnName, emptyNode = _useContext.emptyNode;
    var flattenData = (0, $78671905ff86343f$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // =================== Performance ====================
    var perfRef = $acw62.useRef({
        renderWithProps: false
    });
    // ====================== Render ======================
    var WrapperComponent = getComponent([
        "body",
        "wrapper"
    ], "tbody");
    var trComponent = getComponent([
        "body",
        "row"
    ], "tr");
    var tdComponent = getComponent([
        "body",
        "cell"
    ], "td");
    var thComponent = getComponent([
        "body",
        "cell"
    ], "th");
    var rows;
    if (data.length) rows = flattenData.map(function(item, idx) {
        var record = item.record, indent = item.indent, renderIndex = item.index;
        var key = getRowKey(record, idx);
        return /*#__PURE__*/ $acw62.createElement((0, $3947fe8a4b6be6fe$export$2e2bcd8739ae039), {
            key: key,
            rowKey: key,
            record: record,
            index: idx,
            renderIndex: renderIndex,
            rowComponent: trComponent,
            cellComponent: tdComponent,
            scopeCellComponent: thComponent,
            getRowKey: getRowKey,
            indent: indent
        });
    });
    else rows = /*#__PURE__*/ $acw62.createElement((0, $85c485a146925ee8$export$2e2bcd8739ae039), {
        expanded: true,
        className: "".concat(prefixCls, "-placeholder"),
        prefixCls: prefixCls,
        component: trComponent,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length,
        isEmpty: true
    }, emptyNode);
    var columnsKey = (0, $b1ce2e4492efd614$export$fd2ca5407d9be470)(flattenColumns);
    return /*#__PURE__*/ $acw62.createElement((0, $509ef1d103e7af0d$export$2e2bcd8739ae039).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $acw62.createElement(WrapperComponent, {
        className: "".concat(prefixCls, "-tbody")
    }, measureColumnWidth && /*#__PURE__*/ $acw62.createElement((0, $f8d88c93ca218423$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        columnsKey: columnsKey,
        onColumnResize: onColumnResize
    }), rows));
}
var $c323f6b3243a8952$export$2e2bcd8739ae039 = (0, $22d941e9230e52ce$export$e9e4cb9eb9e2b4c4)($c323f6b3243a8952$var$Body);





var $acw62 = parcelRequire("acw62");



var $7d5e637feda74b50$var$_excluded = [
    "expandable"
];
var $7d5e637feda74b50$export$f8dba99c0d5b6b87 = "RC_TABLE_INTERNAL_COL_DEFINE";
function $7d5e637feda74b50$export$e215b9806eacdfb5(props) {
    var expandable = props.expandable, legacyExpandableConfig = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $7d5e637feda74b50$var$_excluded);
    var config;
    if ("expandable" in props) config = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, legacyExpandableConfig), expandable);
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}


var $15c8e448643b1144$var$_excluded = [
    "columnType"
];
function $15c8e448643b1144$var$ColGroup(_ref) {
    var colWidths = _ref.colWidths, columns = _ref.columns, columCount = _ref.columCount;
    var cols = [];
    var len = columCount || columns.length;
    // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    var mustInsert = false;
    for(var i = len - 1; i >= 0; i -= 1){
        var width = colWidths[i];
        var column = columns && columns[i];
        var additionalProps = column && column[0, $7d5e637feda74b50$export$f8dba99c0d5b6b87];
        if (width || additionalProps || mustInsert) {
            var _ref2 = additionalProps || {}, columnType = _ref2.columnType, restAdditionalProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $15c8e448643b1144$var$_excluded);
            cols.unshift(/*#__PURE__*/ $acw62.createElement("col", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                key: i,
                style: {
                    width: width
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return /*#__PURE__*/ $acw62.createElement("colgroup", null, cols);
}
var $15c8e448643b1144$export$2e2bcd8739ae039 = $15c8e448643b1144$var$ColGroup;












var $acw62 = parcelRequire("acw62");



var $e37bd13d64da95ca$var$_excluded = [
    "className",
    "noData",
    "columns",
    "flattenColumns",
    "colWidths",
    "columCount",
    "stickyOffsets",
    "direction",
    "fixHeader",
    "stickyTopOffset",
    "stickyBottomOffset",
    "stickyClassName",
    "onScroll",
    "maxContentScroll",
    "children"
];
function $e37bd13d64da95ca$var$useColumnWidth(colWidths, columCount) {
    return (0, $acw62.useMemo)(function() {
        var cloneColumns = [];
        for(var i = 0; i < columCount; i += 1){
            var val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join("_"),
        columCount
    ]);
}
var $e37bd13d64da95ca$var$FixedHolder = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var className = props.className, noData = props.noData, columns = props.columns, flattenColumns = props.flattenColumns, colWidths = props.colWidths, columCount = props.columCount, stickyOffsets = props.stickyOffsets, direction = props.direction, fixHeader = props.fixHeader, stickyTopOffset = props.stickyTopOffset, stickyBottomOffset = props.stickyBottomOffset, stickyClassName = props.stickyClassName, onScroll = props.onScroll, maxContentScroll = props.maxContentScroll, children = props.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $e37bd13d64da95ca$var$_excluded);
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "prefixCls",
        "scrollbarSize",
        "isSticky",
        "getComponent"
    ]), prefixCls = _useContext.prefixCls, scrollbarSize = _useContext.scrollbarSize, isSticky = _useContext.isSticky, getComponent = _useContext.getComponent;
    var TableComponent = getComponent([
        "header",
        "table"
    ], "table");
    var combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
    // Pass wheel to scroll event
    var scrollRef = $acw62.useRef(null);
    var setScrollRef = $acw62.useCallback(function(element) {
        (0, $5e297877593af644$export$f17fd18fa51dcb5b)(ref, element);
        (0, $5e297877593af644$export$f17fd18fa51dcb5b)(scrollRef, element);
    }, []);
    $acw62.useEffect(function() {
        var _scrollRef$current;
        function onWheel(e) {
            var _ref = e, currentTarget = _ref.currentTarget, deltaX = _ref.deltaX;
            if (deltaX) {
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: currentTarget.scrollLeft + deltaX
                });
                e.preventDefault();
            }
        }
        (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.addEventListener("wheel", onWheel, {
            passive: false
        });
        return function() {
            var _scrollRef$current2;
            (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 || _scrollRef$current2.removeEventListener("wheel", onWheel);
        };
    }, []);
    // Check if all flattenColumns has width
    var allFlattenColumnsWithWidth = $acw62.useMemo(function() {
        return flattenColumns.every(function(column) {
            return column.width;
        });
    }, [
        flattenColumns
    ]);
    // Add scrollbar column
    var lastColumn = flattenColumns[flattenColumns.length - 1];
    var ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: function onHeaderCell() {
            return {
                className: "".concat(prefixCls, "-cell-scrollbar")
            };
        }
    };
    var columnsWithScrollbar = (0, $acw62.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(columns), [
            ScrollBarColumn
        ]) : columns;
    }, [
        combinationScrollBarSize,
        columns
    ]);
    var flattenColumnsWithScrollbar = (0, $acw62.useMemo)(function() {
        return combinationScrollBarSize ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(flattenColumns), [
            ScrollBarColumn
        ]) : flattenColumns;
    }, [
        combinationScrollBarSize,
        flattenColumns
    ]);
    // Calculate the sticky offsets
    var headerStickyOffsets = (0, $acw62.useMemo)(function() {
        var right = stickyOffsets.right, left = stickyOffsets.left;
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, stickyOffsets), {}, {
            left: direction === "rtl" ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(left.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]) : left,
            right: direction === "rtl" ? right : [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(right.map(function(width) {
                return width + combinationScrollBarSize;
            })), [
                0
            ]),
            isSticky: isSticky
        });
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    var mergedColumnWidth = $e37bd13d64da95ca$var$useColumnWidth(colWidths, columCount);
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            overflow: "hidden"
        }, isSticky ? {
            top: stickyTopOffset,
            bottom: stickyBottomOffset
        } : {}),
        ref: setScrollRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, stickyClassName, !!stickyClassName))
    }, /*#__PURE__*/ $acw62.createElement(TableComponent, {
        style: {
            tableLayout: "fixed",
            visibility: noData || mergedColumnWidth ? null : "hidden"
        }
    }, (!noData || !maxContentScroll || allFlattenColumnsWithWidth) && /*#__PURE__*/ $acw62.createElement((0, $15c8e448643b1144$export$2e2bcd8739ae039), {
        colWidths: mergedColumnWidth ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedColumnWidth), [
            combinationScrollBarSize
        ]) : [],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    }))));
});
var /** Return a table in div as fixed element which contains sticky info */ // export default responseImmutable(FixedHolder);
$e37bd13d64da95ca$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($e37bd13d64da95ca$var$FixedHolder);






var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");





var $7b56d8a164a347ab$var$HeaderRow = function HeaderRow(props) {
    var cells = props.cells, stickyOffsets = props.stickyOffsets, flattenColumns = props.flattenColumns, RowComponent = props.rowComponent, CellComponent = props.cellComponent, onHeaderRow = props.onHeaderRow, index = props.index;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "prefixCls",
        "direction"
    ]), prefixCls = _useContext.prefixCls, direction = _useContext.direction;
    var rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map(function(cell) {
        return cell.column;
    }), index);
    var columnsKey = (0, $b1ce2e4492efd614$export$fd2ca5407d9be470)(cells.map(function(cell) {
        return cell.column;
    }));
    return /*#__PURE__*/ $acw62.createElement(RowComponent, rowProps, cells.map(function(cell, cellIndex) {
        var column = cell.column;
        var fixedInfo = (0, $533a734f6aca19a1$export$695db918331141f3)(cell.colStart, cell.colEnd, flattenColumns, stickyOffsets, direction);
        var additionalProps;
        if (column && column.onHeaderCell) additionalProps = cell.column.onHeaderCell(column);
        return /*#__PURE__*/ $acw62.createElement((0, $2e31a35df2b3b43c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, cell, {
            scope: column.title ? cell.colSpan > 1 ? "colgroup" : "col" : null,
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
};
var $7b56d8a164a347ab$export$2e2bcd8739ae039 = $7b56d8a164a347ab$var$HeaderRow;


function $2b8793d7a19e207e$var$parseHeaderRows(rootColumns) {
    var rows = [];
    function fillRowCells(columns, colIndex) {
        var rowIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        var currentColIndex = colIndex;
        var colSpans = columns.filter(Boolean).map(function(column) {
            var cell = {
                key: column.key,
                className: column.className || "",
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            var colSpan = 1;
            var subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce(function(total, count) {
                    return total + count;
                }, 0);
                cell.hasSubColumns = true;
            }
            if ("colSpan" in column) colSpan = column.colSpan;
            if ("rowSpan" in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    }
    // Generate `rows` cell data
    fillRowCells(rootColumns, 0);
    // Handle `rowSpan`
    var rowCount = rows.length;
    var _loop = function _loop(rowIndex) {
        rows[rowIndex].forEach(function(cell) {
            if (!("rowSpan" in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
            cell.rowSpan = rowCount - rowIndex;
        });
    };
    for(var rowIndex = 0; rowIndex < rowCount; rowIndex += 1)_loop(rowIndex);
    return rows;
}
var $2b8793d7a19e207e$var$Header = function Header(props) {
    var stickyOffsets = props.stickyOffsets, columns = props.columns, flattenColumns = props.flattenColumns, onHeaderRow = props.onHeaderRow;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "prefixCls",
        "getComponent"
    ]), prefixCls = _useContext.prefixCls, getComponent = _useContext.getComponent;
    var rows = $acw62.useMemo(function() {
        return $2b8793d7a19e207e$var$parseHeaderRows(columns);
    }, [
        columns
    ]);
    var WrapperComponent = getComponent([
        "header",
        "wrapper"
    ], "thead");
    var trComponent = getComponent([
        "header",
        "row"
    ], "tr");
    var thComponent = getComponent([
        "header",
        "cell"
    ], "th");
    return /*#__PURE__*/ $acw62.createElement(WrapperComponent, {
        className: "".concat(prefixCls, "-thead")
    }, rows.map(function(row, rowIndex) {
        var rowNode = /*#__PURE__*/ $acw62.createElement((0, $7b56d8a164a347ab$export$2e2bcd8739ae039), {
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
};
var $2b8793d7a19e207e$export$2e2bcd8739ae039 = (0, $22d941e9230e52ce$export$e9e4cb9eb9e2b4c4)($2b8793d7a19e207e$var$Header);











var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $c037ec40b1ed4993$var$parseColWidth(totalWidth) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (typeof width === "number") return width;
    if (width.endsWith("%")) return totalWidth * parseFloat(width) / 100;
    return null;
}
function $c037ec40b1ed4993$export$2e2bcd8739ae039(flattenColumns, scrollWidth, clientWidth) {
    return $acw62.useMemo(function() {
        // Fill width if needed
        if (scrollWidth && scrollWidth > 0) {
            var totalWidth = 0;
            var missWidthCount = 0;
            // collect not given width column
            flattenColumns.forEach(function(col) {
                var colWidth = $c037ec40b1ed4993$var$parseColWidth(scrollWidth, col.width);
                if (colWidth) totalWidth += colWidth;
                else missWidthCount += 1;
            });
            // Fill width
            var maxFitWidth = Math.max(scrollWidth, clientWidth);
            var restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
            var restCount = missWidthCount;
            var avgWidth = restWidth / missWidthCount;
            var realTotal = 0;
            var filledColumns = flattenColumns.map(function(col) {
                var clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, col);
                var colWidth = $c037ec40b1ed4993$var$parseColWidth(scrollWidth, clone.width);
                if (colWidth) clone.width = colWidth;
                else {
                    var colAvgWidth = Math.floor(avgWidth);
                    clone.width = restCount === 1 ? restWidth : colAvgWidth;
                    restWidth -= colAvgWidth;
                    restCount -= 1;
                }
                realTotal += clone.width;
                return clone;
            });
            // If realTotal is less than clientWidth,
            // We need extend column width
            if (realTotal < maxFitWidth) {
                var scale = maxFitWidth / realTotal;
                restWidth = maxFitWidth;
                filledColumns.forEach(function(col, index) {
                    var colWidth = Math.floor(col.width * scale);
                    col.width = index === filledColumns.length - 1 ? restWidth : colWidth;
                    restWidth -= colWidth;
                });
            }
            return [
                filledColumns,
                Math.max(realTotal, maxFitWidth)
            ];
        }
        return [
            flattenColumns,
            scrollWidth
        ];
    }, [
        flattenColumns,
        scrollWidth,
        clientWidth
    ]);
}


var $2b88d91727f4011e$var$_excluded = [
    "children"
], $2b88d91727f4011e$var$_excluded2 = [
    "fixed"
];
function $2b88d91727f4011e$export$d87a97eba44e0f9c(children) {
    return (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children).filter(function(node) {
        return /*#__PURE__*/ $acw62.isValidElement(node);
    }).map(function(_ref) {
        var key = _ref.key, props = _ref.props;
        var nodeChildren = props.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $2b88d91727f4011e$var$_excluded);
        var column = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            key: key
        }, restProps);
        if (nodeChildren) column.children = $2b88d91727f4011e$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $2b88d91727f4011e$var$filterHiddenColumns(columns) {
    return columns.filter(function(column) {
        return column && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(column) === "object" && !column.hidden;
    }).map(function(column) {
        var subColumns = column.children;
        if (subColumns && subColumns.length > 0) return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, column), {}, {
            children: $2b88d91727f4011e$var$filterHiddenColumns(subColumns)
        });
        return column;
    });
}
function $2b88d91727f4011e$var$flatColumns(columns) {
    var parentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "key";
    return columns.filter(function(column) {
        return column && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(column) === "object";
    }).reduce(function(list, column, index) {
        var fixed = column.fixed;
        // Convert `fixed='true'` to `fixed='left'` instead
        var parsedFixed = fixed === true ? "left" : fixed;
        var mergedKey = "".concat(parentKey, "-").concat(index);
        var subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(list), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($2b88d91727f4011e$var$flatColumns(subColumns, mergedKey).map(function(subColum) {
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                fixed: parsedFixed
            }, subColum);
        })));
        return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(list), [
            (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                key: mergedKey
            }, column), {}, {
                fixed: parsedFixed
            })
        ]);
    }, []);
}
function $2b88d91727f4011e$var$revertForRtl(columns) {
    return columns.map(function(column) {
        var fixed = column.fixed, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(column, $2b88d91727f4011e$var$_excluded2);
        // Convert `fixed='left'` to `fixed='right'` instead
        var parsedFixed = fixed;
        if (fixed === "left") parsedFixed = "right";
        else if (fixed === "right") parsedFixed = "left";
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            fixed: parsedFixed
        }, restProps);
    });
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $2b88d91727f4011e$var$useColumns(_ref2, transformColumns) {
    var prefixCls = _ref2.prefixCls, columns = _ref2.columns, children = _ref2.children, expandable = _ref2.expandable, expandedKeys = _ref2.expandedKeys, columnTitle = _ref2.columnTitle, getRowKey = _ref2.getRowKey, onTriggerExpand = _ref2.onTriggerExpand, expandIcon = _ref2.expandIcon, rowExpandable = _ref2.rowExpandable, expandIconColumnIndex = _ref2.expandIconColumnIndex, direction = _ref2.direction, expandRowByClick = _ref2.expandRowByClick, columnWidth = _ref2.columnWidth, fixed = _ref2.fixed, scrollWidth = _ref2.scrollWidth, clientWidth = _ref2.clientWidth;
    var baseColumns = $acw62.useMemo(function() {
        var newColumns = columns || $2b88d91727f4011e$export$d87a97eba44e0f9c(children) || [];
        return $2b88d91727f4011e$var$filterHiddenColumns(newColumns.slice());
    }, [
        columns,
        children
    ]);
    // ========================== Expand ==========================
    var withExpandColumns = $acw62.useMemo(function() {
        if (expandable) {
            var _expandColumn;
            var cloneColumns = baseColumns.slice();
            // >>> Insert expand column if not exist
            if (!cloneColumns.includes((0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301))) {
                var expandColIndex = expandIconColumnIndex || 0;
                if (expandColIndex >= 0) cloneColumns.splice(expandColIndex, 0, (0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301));
            }
            var expandColumnIndex = cloneColumns.indexOf((0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301));
            cloneColumns = cloneColumns.filter(function(column, index) {
                return column !== (0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301) || index === expandColumnIndex;
            });
            // >>> Check if expand column need to fixed
            var prevColumn = baseColumns[expandColumnIndex];
            var fixedColumn;
            if ((fixed === "left" || fixed) && !expandIconColumnIndex) fixedColumn = "left";
            else if ((fixed === "right" || fixed) && expandIconColumnIndex === baseColumns.length) fixedColumn = "right";
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
            // >>> Create expandable column
            var expandColumn = (_expandColumn = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_expandColumn, (0, $7d5e637feda74b50$export$f8dba99c0d5b6b87), {
                className: "".concat(prefixCls, "-expand-icon-col"),
                columnType: "EXPAND_COLUMN"
            }), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_expandColumn, "title", columnTitle), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_expandColumn, "fixed", fixedColumn), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_expandColumn, "className", "".concat(prefixCls, "-row-expand-icon-cell")), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_expandColumn, "width", columnWidth), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_expandColumn, "render", function render(_, record, index) {
                var rowKey = getRowKey(record, index);
                var expanded = expandedKeys.has(rowKey);
                var recordExpandable = rowExpandable ? rowExpandable(record) : true;
                var icon = expandIcon({
                    prefixCls: prefixCls,
                    expanded: expanded,
                    expandable: recordExpandable,
                    record: record,
                    onExpand: onTriggerExpand
                });
                if (expandRowByClick) return /*#__PURE__*/ $acw62.createElement("span", {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    }
                }, icon);
                return icon;
            }), _expandColumn);
            return cloneColumns.map(function(col) {
                return col === (0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301) ? expandColumn : col;
            });
        }
        return baseColumns.filter(function(col) {
            return col !== (0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301);
        });
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction
    ]);
    // ========================= Transform ========================
    var mergedColumns = $acw62.useMemo(function() {
        var finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
        // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: function render() {
                    return null;
                }
            }
        ];
        return finalColumns;
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]);
    // ========================== Flatten =========================
    var flattenColumns = $acw62.useMemo(function() {
        if (direction === "rtl") return $2b88d91727f4011e$var$revertForRtl($2b88d91727f4011e$var$flatColumns(mergedColumns));
        return $2b88d91727f4011e$var$flatColumns(mergedColumns);
    }, [
        mergedColumns,
        direction,
        scrollWidth
    ]);
    // ========================= Gap Fixed ========================
    var hasGapFixed = $acw62.useMemo(function() {
        // Fixed: left, since old browser not support `findLastIndex`, we should use reverse loop
        var lastLeftIndex = -1;
        for(var i = flattenColumns.length - 1; i >= 0; i -= 1){
            var colFixed = flattenColumns[i].fixed;
            if (colFixed === "left" || colFixed === true) {
                lastLeftIndex = i;
                break;
            }
        }
        if (lastLeftIndex >= 0) for(var _i = 0; _i <= lastLeftIndex; _i += 1){
            var _colFixed = flattenColumns[_i].fixed;
            if (_colFixed !== "left" && _colFixed !== true) return true;
        }
        // Fixed: right
        var firstRightIndex = flattenColumns.findIndex(function(_ref3) {
            var colFixed = _ref3.fixed;
            return colFixed === "right";
        });
        if (firstRightIndex >= 0) for(var _i2 = firstRightIndex; _i2 < flattenColumns.length; _i2 += 1){
            var _colFixed2 = flattenColumns[_i2].fixed;
            if (_colFixed2 !== "right") return true;
        }
        return false;
    }, [
        flattenColumns
    ]);
    // ========================= FillWidth ========================
    var _useWidthColumns = (0, $c037ec40b1ed4993$export$2e2bcd8739ae039)(flattenColumns, scrollWidth, clientWidth), _useWidthColumns2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useWidthColumns, 2), filledColumns = _useWidthColumns2[0], realScrollWidth = _useWidthColumns2[1];
    return [
        mergedColumns,
        filledColumns,
        realScrollWidth,
        hasGapFixed
    ];
}
var $2b88d91727f4011e$export$2e2bcd8739ae039 = $2b88d91727f4011e$var$useColumns;







var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $90d83b5d8e78c871$export$ae14373a7f810e33(_ref) {
    var _classNames;
    var prefixCls = _ref.prefixCls, record = _ref.record, onExpand = _ref.onExpand, expanded = _ref.expanded, expandable = _ref.expandable;
    var expandClassName = "".concat(prefixCls, "-row-expand-icon");
    if (!expandable) return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(expandClassName, "".concat(prefixCls, "-row-spaced"))
    });
    var onClick = function onClick(event) {
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(expandClassName, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _classNames)),
        onClick: onClick
    });
}
function $90d83b5d8e78c871$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    var keys = [];
    function dig(list) {
        (list || []).forEach(function(item, index) {
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}



function $f1e77eb2991e4c1e$export$2e2bcd8739ae039(props, mergedData, getRowKey) {
    var expandableConfig = (0, $7d5e637feda74b50$export$e215b9806eacdfb5)(props);
    var expandIcon = expandableConfig.expandIcon, expandedRowKeys = expandableConfig.expandedRowKeys, defaultExpandedRowKeys = expandableConfig.defaultExpandedRowKeys, defaultExpandAllRows = expandableConfig.defaultExpandAllRows, expandedRowRender = expandableConfig.expandedRowRender, onExpand = expandableConfig.onExpand, onExpandedRowsChange = expandableConfig.onExpandedRowsChange, childrenColumnName = expandableConfig.childrenColumnName;
    var mergedExpandIcon = expandIcon || (0, $90d83b5d8e78c871$export$ae14373a7f810e33);
    var mergedChildrenColumnName = childrenColumnName || "children";
    var expandableType = $acw62.useMemo(function() {
        if (expandedRowRender) return "row";
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && props.internalHooks === (0, $5f2cc95ff3bf4bb6$export$91b75cf262680225) && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some(function(record) {
            return record && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(record) === "object" && record[mergedChildrenColumnName];
        })) return "nest";
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    var _React$useState = $acw62.useState(function() {
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $90d83b5d8e78c871$export$49bec56f6055f375)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerExpandedKeys = _React$useState2[0], setInnerExpandedKeys = _React$useState2[1];
    var mergedExpandedKeys = $acw62.useMemo(function() {
        return new Set(expandedRowKeys || innerExpandedKeys || []);
    }, [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    var onTriggerExpand = $acw62.useCallback(function(record) {
        var key = getRowKey(record, mergedData.indexOf(record));
        var newExpandedKeys;
        var hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedExpandedKeys);
        } else newExpandedKeys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedExpandedKeys), [
            key
        ]);
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]);
    return [
        expandableConfig,
        expandableType,
        mergedExpandedKeys,
        mergedExpandIcon,
        mergedChildrenColumnName,
        onTriggerExpand
    ];
}





function $b398ee1fa3da8f86$export$2e2bcd8739ae039(flattenColumns, stickyOffsets, direction) {
    var fixedInfoList = flattenColumns.map(function(_, colIndex) {
        return (0, $533a734f6aca19a1$export$695db918331141f3)(colIndex, colIndex, flattenColumns, stickyOffsets, direction);
    });
    return (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        return fixedInfoList;
    }, [
        fixedInfoList
    ], function(prev, next) {
        return !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev, next);
    });
}




var $acw62 = parcelRequire("acw62");
function $9033f76e13287b2a$export$510e4dd13e0b67dd(defaultState) {
    var stateRef = (0, $acw62.useRef)(defaultState);
    var _useState = (0, $acw62.useState)({}), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), forceUpdate = _useState2[1];
    var lastPromiseRef = (0, $acw62.useRef)(null);
    var updateBatchRef = (0, $acw62.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        var promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(function() {
            if (lastPromiseRef.current === promise) {
                var prevBatch = updateBatchRef.current;
                var prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach(function(batchUpdater) {
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $acw62.useEffect)(function() {
        return function() {
            lastPromiseRef.current = null;
        };
    }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $9033f76e13287b2a$export$d63c72d5e6d02249(defaultState) {
    var frameRef = (0, $acw62.useRef)(defaultState || null);
    var timeoutRef = (0, $acw62.useRef)();
    function cleanUp() {
        window.clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = window.setTimeout(function() {
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $acw62.useEffect)(function() {
        return cleanUp;
    }, []);
    return [
        setState,
        getState
    ];
}




var $acw62 = parcelRequire("acw62");
function $df0382f2511156f9$export$2e2bcd8739ae039() {
    var _React$useState = $acw62.useState(-1), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), startRow = _React$useState2[0], setStartRow = _React$useState2[1];
    var _React$useState3 = $acw62.useState(-1), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), endRow = _React$useState4[0], setEndRow = _React$useState4[1];
    var onHover = $acw62.useCallback(function(start, end) {
        setStartRow(start);
        setEndRow(end);
    }, []);
    return [
        startRow,
        endRow,
        onHover
    ];
}




var $acw62 = parcelRequire("acw62");

// fix ssr render
var $ca375aff0d5eb2f7$var$defaultContainer = (0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() ? window : null;
function $ca375aff0d5eb2f7$export$2e2bcd8739ae039(sticky, prefixCls) {
    var _ref = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(sticky) === "object" ? sticky : {}, _ref$offsetHeader = _ref.offsetHeader, offsetHeader = _ref$offsetHeader === void 0 ? 0 : _ref$offsetHeader, _ref$offsetSummary = _ref.offsetSummary, offsetSummary = _ref$offsetSummary === void 0 ? 0 : _ref$offsetSummary, _ref$offsetScroll = _ref.offsetScroll, offsetScroll = _ref$offsetScroll === void 0 ? 0 : _ref$offsetScroll, _ref$getContainer = _ref.getContainer, getContainer = _ref$getContainer === void 0 ? function() {
        return $ca375aff0d5eb2f7$var$defaultContainer;
    } : _ref$getContainer;
    var container = getContainer() || $ca375aff0d5eb2f7$var$defaultContainer;
    return $acw62.useMemo(function() {
        var isSticky = !!sticky;
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? "".concat(prefixCls, "-sticky-holder") : "",
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}



var $acw62 = parcelRequire("acw62");
/**
 * Get sticky column offset width
 */ function $bdd35ed3b4dc746f$var$useStickyOffsets(colWidths, flattenColumns, direction) {
    var stickyOffsets = (0, $acw62.useMemo)(function() {
        var columnCount = flattenColumns.length;
        var getOffsets = function getOffsets(startIndex, endIndex, offset) {
            var offsets = [];
            var total = 0;
            for(var i = startIndex; i !== endIndex; i += offset){
                offsets.push(total);
                if (flattenColumns[i].fixed) total += colWidths[i] || 0;
            }
            return offsets;
        };
        var startOffsets = getOffsets(0, columnCount, 1);
        var endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
        return direction === "rtl" ? {
            left: endOffsets,
            right: startOffsets
        } : {
            left: startOffsets,
            right: endOffsets
        };
    }, [
        colWidths,
        flattenColumns,
        direction
    ]);
    return stickyOffsets;
}
var $bdd35ed3b4dc746f$export$2e2bcd8739ae039 = $bdd35ed3b4dc746f$var$useStickyOffsets;



var $acw62 = parcelRequire("acw62");
function $d93d063ef9e8de8a$var$Panel(_ref) {
    var className = _ref.className, children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className
    }, children);
}
var $d93d063ef9e8de8a$export$2e2bcd8739ae039 = $d93d063ef9e8de8a$var$Panel;








function $0860008a706f6e42$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}


/* eslint-disable no-nested-ternary */ var $cbf8b6c8fd246421$var$PIXEL_PATTERN = /margin|padding|width|height|max|min|offset/;
var $cbf8b6c8fd246421$var$removePixel = {
    left: true,
    top: true
};
var $cbf8b6c8fd246421$var$floatMap = {
    cssFloat: 1,
    styleFloat: 1,
    float: 1
};
function $cbf8b6c8fd246421$var$getComputedStyle(node) {
    return node.nodeType === 1 ? node.ownerDocument.defaultView.getComputedStyle(node, null) : {};
}
function $cbf8b6c8fd246421$var$getStyleValue(node, type, value) {
    type = type.toLowerCase();
    if (value === "auto") {
        if (type === "height") return node.offsetHeight;
        if (type === "width") return node.offsetWidth;
    }
    if (!(type in $cbf8b6c8fd246421$var$removePixel)) $cbf8b6c8fd246421$var$removePixel[type] = $cbf8b6c8fd246421$var$PIXEL_PATTERN.test(type);
    return $cbf8b6c8fd246421$var$removePixel[type] ? parseFloat(value) || 0 : value;
}
function $cbf8b6c8fd246421$export$3988ae62b71be9a3(node, name) {
    var length = arguments.length;
    var style = $cbf8b6c8fd246421$var$getComputedStyle(node);
    name = $cbf8b6c8fd246421$var$floatMap[name] ? "cssFloat" in node.style ? "cssFloat" : "styleFloat" : name;
    return length === 1 ? style : $cbf8b6c8fd246421$var$getStyleValue(node, name, style[name] || node.style[name]);
}
function $cbf8b6c8fd246421$export$adaa4cf7ef1b65be(node, name, value) {
    var length = arguments.length;
    name = $cbf8b6c8fd246421$var$floatMap[name] ? "cssFloat" in node.style ? "cssFloat" : "styleFloat" : name;
    if (length === 3) {
        if (typeof value === "number" && $cbf8b6c8fd246421$var$PIXEL_PATTERN.test(name)) value = "".concat(value, "px");
        node.style[name] = value; // Number
        return value;
    }
    for(var x in name)if (name.hasOwnProperty(x)) $cbf8b6c8fd246421$export$adaa4cf7ef1b65be(node, x, name[x]);
    return $cbf8b6c8fd246421$var$getComputedStyle(node);
}
function $cbf8b6c8fd246421$export$18e9b0709c75d4c5(el) {
    if (el === document.body) return document.documentElement.clientWidth;
    return el.offsetWidth;
}
function $cbf8b6c8fd246421$export$3ef1368fc1aa92de(el) {
    if (el === document.body) return window.innerHeight || document.documentElement.clientHeight;
    return el.offsetHeight;
}
function $cbf8b6c8fd246421$export$fddbd22e9c622ca7() {
    var width = Math.max(document.documentElement.scrollWidth, document.body.scrollWidth);
    var height = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
    return {
        width: width,
        height: height
    };
}
function $cbf8b6c8fd246421$export$1feb45891927fcb4() {
    var width = document.documentElement.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
}
function $cbf8b6c8fd246421$export$ff41c598de81c14a() {
    return {
        scrollLeft: Math.max(document.documentElement.scrollLeft, document.body.scrollLeft),
        scrollTop: Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    };
}
function $cbf8b6c8fd246421$export$622cea445a1c5b7d(node) {
    var box = node.getBoundingClientRect();
    var docElem = document.documentElement;
    // < ie8 不支持 win.pageXOffset, 则使用 docElem.scrollLeft
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}




var $acw62 = parcelRequire("acw62");



var $5b943abb988e72b5$var$StickyScrollBar = function StickyScrollBar(_ref, ref) {
    var _scrollBodyRef$curren, _scrollBodyRef$curren2;
    var scrollBodyRef = _ref.scrollBodyRef, onScroll = _ref.onScroll, offsetScroll = _ref.offsetScroll, container = _ref.container;
    var prefixCls = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), "prefixCls");
    var bodyScrollWidth = ((_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 ? void 0 : _scrollBodyRef$curren.scrollWidth) || 0;
    var bodyWidth = ((_scrollBodyRef$curren2 = scrollBodyRef.current) === null || _scrollBodyRef$curren2 === void 0 ? void 0 : _scrollBodyRef$curren2.clientWidth) || 0;
    var scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    var scrollBarRef = $acw62.useRef();
    var _useLayoutState = (0, $9033f76e13287b2a$export$510e4dd13e0b67dd)({
        scrollLeft: 0,
        isHiddenScrollBar: false
    }), _useLayoutState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useLayoutState, 2), scrollState = _useLayoutState2[0], setScrollState = _useLayoutState2[1];
    var refState = $acw62.useRef({
        delta: 0,
        x: 0
    });
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), isActive = _React$useState2[0], setActive = _React$useState2[1];
    var rafRef = $acw62.useRef(null);
    $acw62.useEffect(function() {
        return function() {
            (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(rafRef.current);
        };
    }, []);
    var onMouseUp = function onMouseUp() {
        setActive(false);
    };
    var onMouseDown = function onMouseDown(event) {
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    var onMouseMove = function onMouseMove(event) {
        var _window;
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        var _ref2 = event || ((_window = window) === null || _window === void 0 ? void 0 : _window.event), buttons = _ref2.buttons;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        var left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        if (left <= 0) left = 0;
        if (left + scrollBarWidth >= bodyWidth) left = bodyWidth - scrollBarWidth;
        onScroll({
            scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
        });
        refState.current.x = event.pageX;
    };
    var checkScrollBarVisible = function checkScrollBarVisible() {
        rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            if (!scrollBodyRef.current) return;
            var tableOffsetTop = (0, $cbf8b6c8fd246421$export$622cea445a1c5b7d)(scrollBodyRef.current).top;
            var tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
            var currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $cbf8b6c8fd246421$export$622cea445a1c5b7d)(container).top + container.clientHeight;
            if (tableBottomOffset - (0, $217fa5593a6718d2$export$2e2bcd8739ae039)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState(function(state) {
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, state), {}, {
                    isHiddenScrollBar: true
                });
            });
            else setScrollState(function(state) {
                return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, state), {}, {
                    isHiddenScrollBar: false
                });
            });
        });
    };
    var setScrollLeft = function setScrollLeft(left) {
        setScrollState(function(state) {
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, state), {}, {
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            });
        });
    };
    $acw62.useImperativeHandle(ref, function() {
        return {
            setScrollLeft: setScrollLeft,
            checkScrollBarVisible: checkScrollBarVisible
        };
    });
    $acw62.useEffect(function() {
        var onMouseUpListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(document.body, "mouseup", onMouseUp, false);
        var onMouseMoveListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(document.body, "mousemove", onMouseMove, false);
        checkScrollBarVisible();
        return function() {
            onMouseUpListener.remove();
            onMouseMoveListener.remove();
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    $acw62.useEffect(function() {
        var onScrollListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(container, "scroll", checkScrollBarVisible, false);
        var onResizeListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "resize", checkScrollBarVisible, false);
        return function() {
            onScrollListener.remove();
            onResizeListener.remove();
        };
    }, [
        container
    ]);
    $acw62.useEffect(function() {
        if (!scrollState.isHiddenScrollBar) setScrollState(function(state) {
            var bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, state), {}, {
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            });
        });
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            height: (0, $217fa5593a6718d2$export$2e2bcd8739ae039)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: "".concat(prefixCls, "-sticky-scroll")
    }, /*#__PURE__*/ $acw62.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-sticky-scroll-bar"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-sticky-scroll-bar-active"), isActive)),
        style: {
            width: "".concat(scrollBarWidth, "px"),
            transform: "translate3d(".concat(scrollState.scrollLeft, "px, 0, 0)")
        }
    }));
};
var $5b943abb988e72b5$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($5b943abb988e72b5$var$StickyScrollBar);





var $fd7626e42d9e458e$export$c42ed95a478b1ec5 = "rc-table";
// Used for conditions cache
var $fd7626e42d9e458e$var$EMPTY_DATA = [];
// Used for customize scroll
var $fd7626e42d9e458e$var$EMPTY_SCROLL_TARGET = {};
function $fd7626e42d9e458e$var$defaultEmpty() {
    return "No Data";
}
function $fd7626e42d9e458e$var$Table(tableProps, ref) {
    var _classNames;
    var props = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        rowKey: "key",
        prefixCls: $fd7626e42d9e458e$export$c42ed95a478b1ec5,
        emptyText: $fd7626e42d9e458e$var$defaultEmpty
    }, tableProps);
    var prefixCls = props.prefixCls, className = props.className, rowClassName = props.rowClassName, style = props.style, data = props.data, rowKey = props.rowKey, scroll = props.scroll, tableLayout = props.tableLayout, direction = props.direction, title = props.title, footer = props.footer, summary = props.summary, caption = props.caption, id = props.id, showHeader = props.showHeader, components = props.components, emptyText = props.emptyText, onRow = props.onRow, onHeaderRow = props.onHeaderRow, onScroll = props.onScroll, internalHooks = props.internalHooks, transformColumns = props.transformColumns, internalRefs = props.internalRefs, tailor = props.tailor, getContainerWidth = props.getContainerWidth, sticky = props.sticky, _props$rowHoverable = props.rowHoverable, rowHoverable = _props$rowHoverable === void 0 ? true : _props$rowHoverable;
    var mergedData = data || $fd7626e42d9e458e$var$EMPTY_DATA;
    var hasData = !!mergedData.length;
    var useInternalHooks = internalHooks === (0, $5f2cc95ff3bf4bb6$export$91b75cf262680225);
    // ==================== Customize =====================
    var getComponent = $acw62.useCallback(function(path, defaultComponent) {
        return (0, $17fcde5782384c29$export$2e2bcd8739ae039)(components, path) || defaultComponent;
    }, [
        components
    ]);
    var getRowKey = $acw62.useMemo(function() {
        if (typeof rowKey === "function") return rowKey;
        return function(record) {
            var key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]);
    var customizeScrollBody = getComponent([
        "body"
    ]);
    // ====================== Hover =======================
    var _useHover = (0, $df0382f2511156f9$export$2e2bcd8739ae039)(), _useHover2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useHover, 3), startRow = _useHover2[0], endRow = _useHover2[1], onHover = _useHover2[2];
    // ====================== Expand ======================
    var _useExpand = (0, $f1e77eb2991e4c1e$export$2e2bcd8739ae039)(props, mergedData, getRowKey), _useExpand2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useExpand, 6), expandableConfig = _useExpand2[0], expandableType = _useExpand2[1], mergedExpandedKeys = _useExpand2[2], mergedExpandIcon = _useExpand2[3], mergedChildrenColumnName = _useExpand2[4], onTriggerExpand = _useExpand2[5];
    // ====================== Column ======================
    var scrollX = scroll === null || scroll === void 0 ? void 0 : scroll.x;
    var _React$useState = $acw62.useState(0), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), componentWidth = _React$useState2[0], setComponentWidth = _React$useState2[1];
    var _useColumns = (0, $2b88d91727f4011e$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), expandableConfig), {}, {
        expandable: !!expandableConfig.expandedRowRender,
        columnTitle: expandableConfig.columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand: onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
        direction: direction,
        scrollWidth: useInternalHooks && tailor && typeof scrollX === "number" ? scrollX : null,
        clientWidth: componentWidth
    }), useInternalHooks ? transformColumns : null), _useColumns2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useColumns, 4), columns = _useColumns2[0], flattenColumns = _useColumns2[1], flattenScrollX = _useColumns2[2], hasGapFixed = _useColumns2[3];
    var mergedScrollX = flattenScrollX !== null && flattenScrollX !== void 0 ? flattenScrollX : scrollX;
    var columnContext = $acw62.useMemo(function() {
        return {
            columns: columns,
            flattenColumns: flattenColumns
        };
    }, [
        columns,
        flattenColumns
    ]);
    // ======================= Refs =======================
    var fullTableRef = $acw62.useRef();
    var scrollHeaderRef = $acw62.useRef();
    var scrollBodyRef = $acw62.useRef();
    var scrollBodyContainerRef = $acw62.useRef();
    $acw62.useImperativeHandle(ref, function() {
        return {
            nativeElement: fullTableRef.current,
            scrollTo: function scrollTo(config) {
                var _scrollBodyRef$curren3;
                if (scrollBodyRef.current instanceof HTMLElement) {
                    // Native scroll
                    var index = config.index, top = config.top, key = config.key;
                    if (top) {
                        var _scrollBodyRef$curren;
                        (_scrollBodyRef$curren = scrollBodyRef.current) === null || _scrollBodyRef$curren === void 0 || _scrollBodyRef$curren.scrollTo({
                            top: top
                        });
                    } else {
                        var _scrollBodyRef$curren2;
                        var mergedKey = key !== null && key !== void 0 ? key : getRowKey(mergedData[index]);
                        (_scrollBodyRef$curren2 = scrollBodyRef.current.querySelector('[data-row-key="'.concat(mergedKey, '"]'))) === null || _scrollBodyRef$curren2 === void 0 || _scrollBodyRef$curren2.scrollIntoView();
                    }
                } else if ((_scrollBodyRef$curren3 = scrollBodyRef.current) !== null && _scrollBodyRef$curren3 !== void 0 && _scrollBodyRef$curren3.scrollTo) // Pass to proxy
                scrollBodyRef.current.scrollTo(config);
            }
        };
    });
    // ====================== Scroll ======================
    var scrollSummaryRef = $acw62.useRef();
    var _React$useState3 = $acw62.useState(false), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), pingedLeft = _React$useState4[0], setPingedLeft = _React$useState4[1];
    var _React$useState5 = $acw62.useState(false), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), pingedRight = _React$useState6[0], setPingedRight = _React$useState6[1];
    var _useLayoutState = (0, $9033f76e13287b2a$export$510e4dd13e0b67dd)(new Map()), _useLayoutState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useLayoutState, 2), colsWidths = _useLayoutState2[0], updateColsWidths = _useLayoutState2[1];
    // Convert map to number width
    var colsKeys = (0, $b1ce2e4492efd614$export$fd2ca5407d9be470)(flattenColumns);
    var pureColWidths = colsKeys.map(function(columnKey) {
        return colsWidths.get(columnKey);
    });
    var colWidths = $acw62.useMemo(function() {
        return pureColWidths;
    }, [
        pureColWidths.join("_")
    ]);
    var stickyOffsets = (0, $bdd35ed3b4dc746f$export$2e2bcd8739ae039)(colWidths, flattenColumns, direction);
    var fixHeader = scroll && (0, $b1ce2e4492efd614$export$b76e9316566cc26e)(scroll.y);
    var horizonScroll = scroll && (0, $b1ce2e4492efd614$export$b76e9316566cc26e)(mergedScrollX) || Boolean(expandableConfig.fixed);
    var fixColumn = horizonScroll && flattenColumns.some(function(_ref) {
        var fixed = _ref.fixed;
        return fixed;
    });
    // Sticky
    var stickyRef = $acw62.useRef();
    var _useSticky = (0, $ca375aff0d5eb2f7$export$2e2bcd8739ae039)(sticky, prefixCls), isSticky = _useSticky.isSticky, offsetHeader = _useSticky.offsetHeader, offsetSummary = _useSticky.offsetSummary, offsetScroll = _useSticky.offsetScroll, stickyClassName = _useSticky.stickyClassName, container = _useSticky.container;
    // Footer (Fix footer must fixed header)
    var summaryNode = $acw62.useMemo(function() {
        return summary === null || summary === void 0 ? void 0 : summary(mergedData);
    }, [
        summary,
        mergedData
    ]);
    var fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $acw62.isValidElement(summaryNode) && summaryNode.type === (0, $8e6409dc82717fb8$export$2e2bcd8739ae039) && summaryNode.props.fixed;
    // Scroll
    var scrollXStyle;
    var scrollYStyle;
    var scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: "scroll",
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: "auto"
        };
        // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: "hidden"
        };
        scrollTableStyle = {
            width: mergedScrollX === true ? "auto" : mergedScrollX,
            minWidth: "100%"
        };
    }
    var onColumnResize = $acw62.useCallback(function(columnKey, width) {
        if ((0, $555b4eee2695f264$export$2e2bcd8739ae039)(fullTableRef.current)) updateColsWidths(function(widths) {
            if (widths.get(columnKey) !== width) {
                var newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    var _useTimeoutLock = (0, $9033f76e13287b2a$export$d63c72d5e6d02249)(null), _useTimeoutLock2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useTimeoutLock, 2), setScrollTarget = _useTimeoutLock2[0], getScrollTarget = _useTimeoutLock2[1];
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === "function") target(scrollLeft);
        else if (target.scrollLeft !== scrollLeft) {
            target.scrollLeft = scrollLeft;
            // Delay to force scroll position if not sync
            // ref: https://github.com/ant-design/ant-design/issues/37179
            if (target.scrollLeft !== scrollLeft) setTimeout(function() {
                target.scrollLeft = scrollLeft;
            }, 0);
        }
    }
    var onInternalScroll = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(_ref2) {
        var currentTarget = _ref2.currentTarget, scrollLeft = _ref2.scrollLeft;
        var isRTL = direction === "rtl";
        var mergedScrollLeft = typeof scrollLeft === "number" ? scrollLeft : currentTarget.scrollLeft;
        var compareTarget = currentTarget || $fd7626e42d9e458e$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            var _stickyRef$current;
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, (_stickyRef$current = stickyRef.current) === null || _stickyRef$current === void 0 ? void 0 : _stickyRef$current.setScrollLeft);
        }
        var measureTarget = currentTarget || scrollHeaderRef.current;
        if (measureTarget) {
            var scrollWidth = measureTarget.scrollWidth, clientWidth = measureTarget.clientWidth;
            // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setPingedLeft(false);
                setPingedRight(false);
                return;
            }
            if (isRTL) {
                setPingedLeft(-mergedScrollLeft < scrollWidth - clientWidth);
                setPingedRight(-mergedScrollLeft > 0);
            } else {
                setPingedLeft(mergedScrollLeft > 0);
                setPingedRight(mergedScrollLeft < scrollWidth - clientWidth);
            }
        }
    });
    var onBodyScroll = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(e) {
        onInternalScroll(e);
        onScroll === null || onScroll === void 0 || onScroll(e);
    });
    var triggerOnScroll = function triggerOnScroll() {
        if (horizonScroll && scrollBodyRef.current) onInternalScroll({
            currentTarget: scrollBodyRef.current
        });
        else {
            setPingedLeft(false);
            setPingedRight(false);
        }
    };
    var onFullTableResize = function onFullTableResize(_ref3) {
        var _stickyRef$current2;
        var width = _ref3.width;
        (_stickyRef$current2 = stickyRef.current) === null || _stickyRef$current2 === void 0 || _stickyRef$current2.checkScrollBarVisible();
        var mergedWidth = fullTableRef.current ? fullTableRef.current.offsetWidth : width;
        if (useInternalHooks && getContainerWidth && fullTableRef.current) mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
        if (mergedWidth !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(mergedWidth);
        }
    };
    // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    var mounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $acw62.useEffect(function() {
        mounted.current = true;
    }, []);
    // ===================== Effects ======================
    var _React$useState7 = $acw62.useState(0), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), scrollbarSize = _React$useState8[0], setScrollbarSize = _React$useState8[1];
    var _React$useState9 = $acw62.useState(true), _React$useState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState9, 2), supportSticky = _React$useState10[0], setSupportSticky = _React$useState10[1]; // Only IE not support, we mark as support first
    $acw62.useEffect(function() {
        if (!tailor || !useInternalHooks) {
            if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $217fa5593a6718d2$export$4f3ef2310365b56a)(scrollBodyRef.current).width);
            else setScrollbarSize((0, $217fa5593a6718d2$export$4f3ef2310365b56a)(scrollBodyContainerRef.current).width);
        }
        setSupportSticky((0, $5ac27a8c1ec0b63e$export$d616d7831008e86c)("position", "sticky"));
    }, []);
    // ================== INTERNAL HOOKS ==================
    $acw62.useEffect(function() {
        if (useInternalHooks && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    });
    // ========================================================================
    // ==                               Render                               ==
    // ========================================================================
    // =================== Render: Func ===================
    var renderFixedHeaderTable = $acw62.useCallback(function(fixedHolderPassProps) {
        return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $2b8793d7a19e207e$export$2e2bcd8739ae039), fixedHolderPassProps), fixFooter === "top" && /*#__PURE__*/ $acw62.createElement((0, $46b6722da5e5f96e$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode));
    }, [
        fixFooter,
        summaryNode
    ]);
    var renderFixedFooterTable = $acw62.useCallback(function(fixedHolderPassProps) {
        return /*#__PURE__*/ $acw62.createElement((0, $46b6722da5e5f96e$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode);
    }, [
        summaryNode
    ]);
    // =================== Render: Node ===================
    var TableComponent = getComponent([
        "table"
    ], "table");
    // Table layout
    var mergedTableLayout = $acw62.useMemo(function() {
        if (tableLayout) return tableLayout;
        // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return mergedScrollX === "max-content" ? "auto" : "fixed";
        if (fixHeader || isSticky || flattenColumns.some(function(_ref4) {
            var ellipsis = _ref4.ellipsis;
            return ellipsis;
        })) return "fixed";
        return "auto";
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    var groupTableNode;
    // Header props
    var headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    };
    // Empty
    var emptyNode = $acw62.useMemo(function() {
        if (hasData) return null;
        if (typeof emptyText === "function") return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]);
    // Body
    var bodyTable = /*#__PURE__*/ $acw62.createElement((0, $c323f6b3243a8952$export$2e2bcd8739ae039), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky
    });
    var bodyColGroup = /*#__PURE__*/ $acw62.createElement((0, $15c8e448643b1144$export$2e2bcd8739ae039), {
        colWidths: flattenColumns.map(function(_ref5) {
            var width = _ref5.width;
            return width;
        }),
        columns: flattenColumns
    });
    var captionElement = caption !== null && caption !== undefined ? /*#__PURE__*/ $acw62.createElement("caption", {
        className: "".concat(prefixCls, "-caption")
    }, caption) : undefined;
    var dataProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        data: true
    });
    var ariaProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        aria: true
    });
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        var bodyContent;
        if (typeof customizeScrollBody === "function") {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onInternalScroll
            });
            headerProps.colWidths = flattenColumns.map(function(_ref6, index) {
                var width = _ref6.width;
                var colWidth = index === flattenColumns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === "number" && !Number.isNaN(colWidth)) return colWidth;
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $acw62.createElement("div", {
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, scrollXStyle), scrollYStyle),
            onScroll: onBodyScroll,
            ref: scrollBodyRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-body"))
        }, /*#__PURE__*/ $acw62.createElement(TableComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, scrollTableStyle), {}, {
                tableLayout: mergedTableLayout
            })
        }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $acw62.createElement((0, $46b6722da5e5f96e$export$2e2bcd8739ae039), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
        // Fixed holder share the props
        var fixedHolderProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && mergedScrollX === "max-content"
        }, headerProps), columnContext), {}, {
            direction: direction,
            stickyClassName: stickyClassName,
            onScroll: onInternalScroll
        });
        groupTableNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, showHeader !== false && /*#__PURE__*/ $acw62.createElement((0, $e37bd13d64da95ca$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: "".concat(prefixCls, "-header"),
            ref: scrollHeaderRef
        }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== "top" && /*#__PURE__*/ $acw62.createElement((0, $e37bd13d64da95ca$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: "".concat(prefixCls, "-summary"),
            ref: scrollSummaryRef
        }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /*#__PURE__*/ $acw62.createElement((0, $5b943abb988e72b5$export$2e2bcd8739ae039), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onInternalScroll,
            container: container
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $acw62.createElement("div", {
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, scrollXStyle), scrollYStyle),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content")),
        onScroll: onInternalScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $acw62.createElement(TableComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, scrollTableStyle), {}, {
            tableLayout: mergedTableLayout
        })
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /*#__PURE__*/ $acw62.createElement((0, $2b8793d7a19e207e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $acw62.createElement((0, $46b6722da5e5f96e$export$2e2bcd8739ae039), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    var fullTable = /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-ping-left"), pingedLeft), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-ping-right"), pingedRight), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-layout-fixed"), tableLayout === "fixed"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-fixed-header"), fixHeader), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-fixed-column"), fixColumn), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-fixed-column-gapped"), fixColumn && hasGapFixed), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-scroll-horizontal"), horizonScroll), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-has-fix-left"), flattenColumns[0] && flattenColumns[0].fixed), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-has-fix-right"), flattenColumns[flattenColumns.length - 1] && flattenColumns[flattenColumns.length - 1].fixed === "right"), _classNames)),
        style: style,
        id: id,
        ref: fullTableRef
    }, dataProps), title && /*#__PURE__*/ $acw62.createElement((0, $d93d063ef9e8de8a$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-title")
    }, title(mergedData)), /*#__PURE__*/ $acw62.createElement("div", {
        ref: scrollBodyContainerRef,
        className: "".concat(prefixCls, "-container")
    }, groupTableNode), footer && /*#__PURE__*/ $acw62.createElement((0, $d93d063ef9e8de8a$export$2e2bcd8739ae039), {
        className: "".concat(prefixCls, "-footer")
    }, footer(mergedData)));
    if (horizonScroll) fullTable = /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onFullTableResize
    }, fullTable);
    var fixedInfoList = (0, $b398ee1fa3da8f86$export$2e2bcd8739ae039)(flattenColumns, stickyOffsets, direction);
    var TableContextValue = $acw62.useMemo(function() {
        return {
            // Scroll
            scrollX: mergedScrollX,
            // Table
            prefixCls: prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: fixedInfoList,
            isSticky: isSticky,
            supportSticky: supportSticky,
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll,
            // Body
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandableConfig.expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandableConfig.expandRowByClick,
            expandedRowRender: expandableConfig.expandedRowRender,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
            indentSize: expandableConfig.indentSize,
            allColumnsFixedLeft: flattenColumns.every(function(col) {
                return col.fixed === "left";
            }),
            emptyNode: emptyNode,
            // Column
            columns: columns,
            flattenColumns: flattenColumns,
            onColumnResize: onColumnResize,
            // Row
            hoverStartRow: startRow,
            hoverEndRow: endRow,
            onHover: onHover,
            rowExpandable: expandableConfig.rowExpandable,
            onRow: onRow,
            getRowKey: getRowKey,
            expandedKeys: mergedExpandedKeys,
            childrenColumnName: mergedChildrenColumnName,
            rowHoverable: rowHoverable
        };
    }, [
        // Scroll
        mergedScrollX,
        // Table
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        fixedInfoList,
        isSticky,
        supportSticky,
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll,
        // Body
        mergedTableLayout,
        rowClassName,
        expandableConfig.expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandableConfig.expandRowByClick,
        expandableConfig.expandedRowRender,
        onTriggerExpand,
        expandableConfig.expandIconColumnIndex,
        expandableConfig.indentSize,
        emptyNode,
        // Column
        columns,
        flattenColumns,
        onColumnResize,
        // Row
        startRow,
        endRow,
        onHover,
        expandableConfig.rowExpandable,
        onRow,
        getRowKey,
        mergedExpandedKeys,
        mergedChildrenColumnName,
        rowHoverable
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $22d941e9230e52ce$export$2e2bcd8739ae039).Provider, {
        value: TableContextValue
    }, fullTable);
}
var $fd7626e42d9e458e$var$RefTable = /*#__PURE__*/ $acw62.forwardRef($fd7626e42d9e458e$var$Table);
function $fd7626e42d9e458e$export$13da147d1fdf3e3c(shouldTriggerRender) {
    return (0, $22d941e9230e52ce$export$ffd6d5bef5eaf0a4)($fd7626e42d9e458e$var$RefTable, shouldTriggerRender);
}
var $fd7626e42d9e458e$var$ImmutableTable = $fd7626e42d9e458e$export$13da147d1fdf3e3c();
$fd7626e42d9e458e$var$ImmutableTable.EXPAND_COLUMN = (0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301);
$fd7626e42d9e458e$var$ImmutableTable.INTERNAL_HOOKS = (0, $5f2cc95ff3bf4bb6$export$91b75cf262680225);
$fd7626e42d9e458e$var$ImmutableTable.Column = (0, $6c13968ac95170e6$export$2e2bcd8739ae039);
$fd7626e42d9e458e$var$ImmutableTable.ColumnGroup = (0, $220c394bb4cc7b1f$export$2e2bcd8739ae039);
$fd7626e42d9e458e$var$ImmutableTable.Summary = (0, $46b6722da5e5f96e$export$d605f3af09eef683);
var $fd7626e42d9e458e$export$2e2bcd8739ae039 = $fd7626e42d9e458e$var$ImmutableTable;








var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");



var $6cb04dbe6b3b59f6$export$fbb76fda59aa02a2 = (0, $2b6e94889042e439$export$fd42f52fd3ae1109)(null);
var $6cb04dbe6b3b59f6$export$11cae3e04ab99fae = (0, $2b6e94889042e439$export$fd42f52fd3ae1109)(null);


function $f86eef91cd110252$export$dfa11a34ceba822(colIndex, colSpan, columnsOffset) {
    var mergedColSpan = colSpan || 1;
    return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
function $f86eef91cd110252$var$VirtualCell(props) {
    var rowInfo = props.rowInfo, column = props.column, colIndex = props.colIndex, indent = props.indent, index = props.index, component = props.component, renderIndex = props.renderIndex, record = props.record, style = props.style, className = props.className, inverse = props.inverse, getHeight = props.getHeight;
    var render = column.render, dataIndex = column.dataIndex, columnClassName = column.className, colWidth = column.width;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $6cb04dbe6b3b59f6$export$11cae3e04ab99fae), [
        "columnsOffset"
    ]), columnsOffset = _useContext.columnsOffset;
    var _getCellProps = (0, $3947fe8a4b6be6fe$export$16400ac709c56616)(rowInfo, column, colIndex, indent, index), key = _getCellProps.key, fixedInfo = _getCellProps.fixedInfo, appendCellNode = _getCellProps.appendCellNode, additionalCellProps = _getCellProps.additionalCellProps;
    var cellStyle = additionalCellProps.style, _additionalCellProps$ = additionalCellProps.colSpan, colSpan = _additionalCellProps$ === void 0 ? 1 : _additionalCellProps$, _additionalCellProps$2 = additionalCellProps.rowSpan, rowSpan = _additionalCellProps$2 === void 0 ? 1 : _additionalCellProps$2;
    // ========================= ColWidth =========================
    // column width
    var startColIndex = colIndex - 1;
    var concatColWidth = $f86eef91cd110252$export$dfa11a34ceba822(startColIndex, colSpan, columnsOffset);
    // margin offset
    var marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;
    // ========================== Style ===========================
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, cellStyle), style), {}, {
        flex: "0 0 ".concat(concatColWidth, "px"),
        width: "".concat(concatColWidth, "px"),
        marginRight: marginOffset,
        pointerEvents: "auto"
    });
    // When `colSpan` or `rowSpan` is `0`, should skip render.
    var needHide = $acw62.useMemo(function() {
        if (inverse) return rowSpan <= 1;
        else return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }, [
        rowSpan,
        colSpan,
        inverse
    ]);
    // 0 rowSpan or colSpan should not render
    if (needHide) mergedStyle.visibility = "hidden";
    else if (inverse) mergedStyle.height = getHeight === null || getHeight === void 0 ? void 0 : getHeight(rowSpan);
    var mergedRender = needHide ? function() {
        return null;
    } : render;
    // ========================== Render ==========================
    var cellSpan = {};
    // Virtual should reset `colSpan` & `rowSpan`
    if (rowSpan === 0 || colSpan === 0) {
        cellSpan.rowSpan = 1;
        cellSpan.colSpan = 1;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $2e31a35df2b3b43c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(columnClassName, className),
        ellipsis: column.ellipsis,
        align: column.align,
        scope: column.rowScope,
        component: component,
        prefixCls: rowInfo.prefixCls,
        key: key,
        record: record,
        index: index,
        renderIndex: renderIndex,
        dataIndex: dataIndex,
        render: mergedRender,
        shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
        appendNode: appendCellNode,
        additionalProps: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, additionalCellProps), {}, {
            style: mergedStyle
        }, cellSpan)
    }));
}
var $f86eef91cd110252$export$2e2bcd8739ae039 = $f86eef91cd110252$var$VirtualCell;



var $2c634099127d8dfe$var$_excluded = [
    "data",
    "index",
    "className",
    "rowKey",
    "style",
    "extra",
    "getHeight"
];
var $2c634099127d8dfe$var$BodyLine = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var data = props.data, index = props.index, className = props.className, rowKey = props.rowKey, style = props.style, extra = props.extra, getHeight = props.getHeight, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $2c634099127d8dfe$var$_excluded);
    var record = data.record, indent = data.indent, renderIndex = data.index;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "prefixCls",
        "flattenColumns",
        "fixColumn",
        "componentWidth",
        "scrollX"
    ]), scrollX = _useContext.scrollX, flattenColumns = _useContext.flattenColumns, prefixCls = _useContext.prefixCls, fixColumn = _useContext.fixColumn, componentWidth = _useContext.componentWidth;
    var _useContext2 = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $6cb04dbe6b3b59f6$export$fbb76fda59aa02a2), [
        "getComponent"
    ]), getComponent = _useContext2.getComponent;
    var rowInfo = (0, $bcd5585dffbf99c6$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    var RowComponent = getComponent([
        "body",
        "row"
    ], "div");
    var cellComponent = getComponent([
        "body",
        "cell"
    ], "div");
    // ========================== Expand ==========================
    var rowSupportExpand = rowInfo.rowSupportExpand, expanded = rowInfo.expanded, rowProps = rowInfo.rowProps, expandedRowRender = rowInfo.expandedRowRender, expandedRowClassName = rowInfo.expandedRowClassName;
    var expandRowNode;
    if (rowSupportExpand && expanded) {
        var expandContent = expandedRowRender(record, index, indent + 1, expanded);
        var computedExpandedRowClassName = expandedRowClassName === null || expandedRowClassName === void 0 ? void 0 : expandedRowClassName(record, index, indent);
        var additionalProps = {};
        if (fixColumn) additionalProps = {
            style: (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "--virtual-width", "".concat(componentWidth, "px"))
        };
        var rowCellCls = "".concat(prefixCls, "-expanded-row-cell");
        expandRowNode = /*#__PURE__*/ $acw62.createElement(RowComponent, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-expanded-row"), "".concat(prefixCls, "-expanded-row-level-").concat(indent + 1), computedExpandedRowClassName)
        }, /*#__PURE__*/ $acw62.createElement((0, $2e31a35df2b3b43c$export$2e2bcd8739ae039), {
            component: cellComponent,
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rowCellCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(rowCellCls, "-fixed"), fixColumn)),
            additionalProps: additionalProps
        }, expandContent));
    }
    // ========================== Render ==========================
    var rowStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), {}, {
        width: scrollX
    });
    if (extra) {
        rowStyle.position = "absolute";
        rowStyle.pointerEvents = "none";
    }
    var rowNode = /*#__PURE__*/ $acw62.createElement(RowComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowProps, restProps, {
        "data-row-key": rowKey,
        ref: rowSupportExpand ? null : ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, "".concat(prefixCls, "-row"), rowProps === null || rowProps === void 0 ? void 0 : rowProps.className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-row-extra"), extra)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rowStyle), rowProps === null || rowProps === void 0 ? void 0 : rowProps.style)
    }), flattenColumns.map(function(column, colIndex) {
        return /*#__PURE__*/ $acw62.createElement((0, $f86eef91cd110252$export$2e2bcd8739ae039), {
            key: colIndex,
            component: cellComponent,
            rowInfo: rowInfo,
            column: column,
            colIndex: colIndex,
            indent: indent,
            index: index,
            renderIndex: renderIndex,
            record: record,
            inverse: extra,
            getHeight: getHeight
        });
    }));
    if (rowSupportExpand) return /*#__PURE__*/ $acw62.createElement("div", {
        ref: ref
    }, rowNode, expandRowNode);
    return rowNode;
});
var $2c634099127d8dfe$var$ResponseBodyLine = (0, $22d941e9230e52ce$export$e9e4cb9eb9e2b4c4)($2c634099127d8dfe$var$BodyLine);
var $2c634099127d8dfe$export$2e2bcd8739ae039 = $2c634099127d8dfe$var$ResponseBodyLine;



var $238c9ecaedf9624d$var$Grid = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var data = props.data, onScroll = props.onScroll;
    var _useContext = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $22d941e9230e52ce$export$2e2bcd8739ae039), [
        "flattenColumns",
        "onColumnResize",
        "getRowKey",
        "prefixCls",
        "expandedKeys",
        "childrenColumnName",
        "emptyNode",
        "scrollX"
    ]), flattenColumns = _useContext.flattenColumns, onColumnResize = _useContext.onColumnResize, getRowKey = _useContext.getRowKey, expandedKeys = _useContext.expandedKeys, prefixCls = _useContext.prefixCls, childrenColumnName = _useContext.childrenColumnName, emptyNode = _useContext.emptyNode, scrollX = _useContext.scrollX;
    var _useContext2 = (0, $2b6e94889042e439$export$fae74005e78b1a27)((0, $6cb04dbe6b3b59f6$export$fbb76fda59aa02a2)), sticky = _useContext2.sticky, scrollY = _useContext2.scrollY, listItemHeight = _useContext2.listItemHeight, getComponent = _useContext2.getComponent, onTablePropScroll = _useContext2.onScroll;
    // =========================== Ref ============================
    var listRef = $acw62.useRef();
    // =========================== Data ===========================
    var flattenData = (0, $78671905ff86343f$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // ========================== Column ==========================
    var columnsWidth = $acw62.useMemo(function() {
        var total = 0;
        return flattenColumns.map(function(_ref) {
            var width = _ref.width, key = _ref.key;
            total += width;
            return [
                key,
                width,
                total
            ];
        });
    }, [
        flattenColumns
    ]);
    var columnsOffset = $acw62.useMemo(function() {
        return columnsWidth.map(function(colWidth) {
            return colWidth[2];
        });
    }, [
        columnsWidth
    ]);
    $acw62.useEffect(function() {
        columnsWidth.forEach(function(_ref2) {
            var _ref3 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_ref2, 2), key = _ref3[0], width = _ref3[1];
            onColumnResize(key, width);
        });
    }, [
        columnsWidth
    ]);
    // =========================== Ref ============================
    $acw62.useImperativeHandle(ref, function() {
        var obj = {
            scrollTo: function scrollTo(config) {
                var _listRef$current;
                (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(config);
            }
        };
        Object.defineProperty(obj, "scrollLeft", {
            get: function get() {
                var _listRef$current2;
                return ((_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.getScrollInfo().x) || 0;
            },
            set: function set(value) {
                var _listRef$current3;
                (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.scrollTo({
                    left: value
                });
            }
        });
        return obj;
    });
    // ======================= Col/Row Span =======================
    var getRowSpan = function getRowSpan(column, index) {
        var _flattenData$index;
        var record = (_flattenData$index = flattenData[index]) === null || _flattenData$index === void 0 ? void 0 : _flattenData$index.record;
        var onCell = column.onCell;
        if (onCell) {
            var _cellProps$rowSpan;
            var cellProps = onCell(record, index);
            return (_cellProps$rowSpan = cellProps === null || cellProps === void 0 ? void 0 : cellProps.rowSpan) !== null && _cellProps$rowSpan !== void 0 ? _cellProps$rowSpan : 1;
        }
        return 1;
    };
    var extraRender = function extraRender(info) {
        var start = info.start, end = info.end, getSize = info.getSize, offsetY = info.offsetY;
        // Do nothing if no data
        if (end < 0) return null;
        // Find first rowSpan column
        var firstRowSpanColumns = flattenColumns.filter(// rowSpan is 0
        function(column) {
            return getRowSpan(column, start) === 0;
        });
        var startIndex = start;
        var _loop = function _loop(i) {
            firstRowSpanColumns = firstRowSpanColumns.filter(function(column) {
                return getRowSpan(column, i) === 0;
            });
            if (!firstRowSpanColumns.length) {
                startIndex = i;
                return 1; // break
            }
        };
        for(var i = start; i >= 0; i -= 1){
            if (_loop(i)) break;
        }
        // Find last rowSpan column
        var lastRowSpanColumns = flattenColumns.filter(// rowSpan is not 1
        function(column) {
            return getRowSpan(column, end) !== 1;
        });
        var endIndex = end;
        var _loop2 = function _loop2(_i) {
            lastRowSpanColumns = lastRowSpanColumns.filter(function(column) {
                return getRowSpan(column, _i) !== 1;
            });
            if (!lastRowSpanColumns.length) {
                endIndex = Math.max(_i - 1, end);
                return 1; // break
            }
        };
        for(var _i = end; _i < flattenData.length; _i += 1){
            if (_loop2(_i)) break;
        }
        // Collect the line who has rowSpan
        var spanLines = [];
        var _loop3 = function _loop3(_i2) {
            var item = flattenData[_i2];
            // This code will never reach, just incase
            if (!item) return 1; // continue
            if (flattenColumns.some(function(column) {
                return getRowSpan(column, _i2) > 1;
            })) spanLines.push(_i2);
        };
        for(var _i2 = startIndex; _i2 <= endIndex; _i2 += 1){
            if (_loop3(_i2)) continue;
        }
        // Patch extra line on the page
        var nodes = spanLines.map(function(index) {
            var item = flattenData[index];
            var rowKey = getRowKey(item.record, index);
            var getHeight = function getHeight(rowSpan) {
                var endItemIndex = index + rowSpan - 1;
                var endItemKey = getRowKey(flattenData[endItemIndex].record, endItemIndex);
                var sizeInfo = getSize(rowKey, endItemKey);
                return sizeInfo.bottom - sizeInfo.top;
            };
            var sizeInfo = getSize(rowKey);
            return /*#__PURE__*/ $acw62.createElement((0, $2c634099127d8dfe$export$2e2bcd8739ae039), {
                key: index,
                data: item,
                rowKey: rowKey,
                index: index,
                style: {
                    top: -offsetY + sizeInfo.top
                },
                extra: true,
                getHeight: getHeight
            });
        });
        return nodes;
    };
    // ========================= Context ==========================
    var gridContext = $acw62.useMemo(function() {
        return {
            columnsOffset: columnsOffset
        };
    }, [
        columnsOffset
    ]);
    // ========================== Render ==========================
    var tblPrefixCls = "".concat(prefixCls, "-tbody");
    // default 'div' in rc-virtual-list
    var wrapperComponent = getComponent([
        "body",
        "wrapper"
    ]);
    var RowComponent = getComponent([
        "body",
        "row"
    ], "div");
    var cellComponent = getComponent([
        "body",
        "cell"
    ], "div");
    var bodyContent;
    if (flattenData.length) {
        // ========================== Sticky Scroll Bar ==========================
        var horizontalScrollBarStyle = {};
        if (sticky) {
            horizontalScrollBarStyle.position = "sticky";
            horizontalScrollBarStyle.bottom = 0;
            if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(sticky) === "object" && sticky.offsetScroll) horizontalScrollBarStyle.bottom = sticky.offsetScroll;
        }
        bodyContent = /*#__PURE__*/ $acw62.createElement((0, $2f16cd4e45d13ddf$export$2e2bcd8739ae039), {
            fullHeight: false,
            ref: listRef,
            prefixCls: "".concat(tblPrefixCls, "-virtual"),
            styles: {
                horizontalScrollBar: horizontalScrollBarStyle
            },
            className: tblPrefixCls,
            height: scrollY,
            itemHeight: listItemHeight || 24,
            data: flattenData,
            itemKey: function itemKey(item) {
                return getRowKey(item.record);
            },
            component: wrapperComponent,
            scrollWidth: scrollX,
            onVirtualScroll: function onVirtualScroll(_ref4) {
                var x = _ref4.x;
                onScroll({
                    scrollLeft: x
                });
            },
            onScroll: onTablePropScroll,
            extraRender: extraRender
        }, function(item, index, itemProps) {
            var rowKey = getRowKey(item.record, index);
            return /*#__PURE__*/ $acw62.createElement((0, $2c634099127d8dfe$export$2e2bcd8739ae039), {
                data: item,
                rowKey: rowKey,
                index: index,
                style: itemProps.style
            });
        });
    } else bodyContent = /*#__PURE__*/ $acw62.createElement(RowComponent, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-placeholder"))
    }, /*#__PURE__*/ $acw62.createElement((0, $2e31a35df2b3b43c$export$2e2bcd8739ae039), {
        component: cellComponent,
        prefixCls: prefixCls
    }, emptyNode));
    return /*#__PURE__*/ $acw62.createElement((0, $6cb04dbe6b3b59f6$export$11cae3e04ab99fae).Provider, {
        value: gridContext
    }, bodyContent);
});
var $238c9ecaedf9624d$var$ResponseGrid = (0, $22d941e9230e52ce$export$e9e4cb9eb9e2b4c4)($238c9ecaedf9624d$var$Grid);
var $238c9ecaedf9624d$export$2e2bcd8739ae039 = $238c9ecaedf9624d$var$ResponseGrid;




var $256f829f2e694a08$var$renderBody = function renderBody(rawData, props) {
    var ref = props.ref, onScroll = props.onScroll;
    return /*#__PURE__*/ $acw62.createElement((0, $238c9ecaedf9624d$export$2e2bcd8739ae039), {
        ref: ref,
        data: rawData,
        onScroll: onScroll
    });
};
function $256f829f2e694a08$var$VirtualTable(props, ref) {
    var columns = props.columns, scroll = props.scroll, sticky = props.sticky, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? (0, $fd7626e42d9e458e$export$c42ed95a478b1ec5) : _props$prefixCls, className = props.className, listItemHeight = props.listItemHeight, components = props.components, onScroll = props.onScroll;
    var _ref = scroll || {}, scrollX = _ref.x, scrollY = _ref.y;
    // Fill scrollX
    if (typeof scrollX !== "number") scrollX = 1;
    // Fill scrollY
    if (typeof scrollY !== "number") scrollY = 500;
    var getComponent = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(path, defaultComponent) {
        return (0, $17fcde5782384c29$export$2e2bcd8739ae039)(components, path) || defaultComponent;
    });
    // Memo this
    var onInternalScroll = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(onScroll);
    // ========================= Context ==========================
    var context = $acw62.useMemo(function() {
        return {
            sticky: sticky,
            scrollY: scrollY,
            listItemHeight: listItemHeight,
            getComponent: getComponent,
            onScroll: onInternalScroll
        };
    }, [
        sticky,
        scrollY,
        listItemHeight,
        getComponent,
        onInternalScroll
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $acw62.createElement((0, $6cb04dbe6b3b59f6$export$fbb76fda59aa02a2).Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement((0, $fd7626e42d9e458e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, "".concat(prefixCls, "-virtual")),
        scroll: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, scroll), {}, {
            x: scrollX
        }),
        components: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, components), {}, {
            body: $256f829f2e694a08$var$renderBody
        }),
        columns: columns,
        internalHooks: (0, $5f2cc95ff3bf4bb6$export$91b75cf262680225),
        tailor: true,
        ref: ref
    })));
}
var $256f829f2e694a08$var$RefVirtualTable = /*#__PURE__*/ $acw62.forwardRef($256f829f2e694a08$var$VirtualTable);
function $256f829f2e694a08$export$4747b79b36862360(shouldTriggerRender) {
    return (0, $22d941e9230e52ce$export$ffd6d5bef5eaf0a4)($256f829f2e694a08$var$RefVirtualTable, shouldTriggerRender);
}
var $256f829f2e694a08$export$2e2bcd8739ae039 = $256f829f2e694a08$export$4747b79b36862360();


var $39bc5e7a79a06441$export$2e2bcd8739ae039 = (0, $fd7626e42d9e458e$export$2e2bcd8739ae039);


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $fad2a96b4c8bbab5$var$Column(_) {
    return null;
}
var $fad2a96b4c8bbab5$export$2e2bcd8739ae039 = $fad2a96b4c8bbab5$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ // eslint-disable-next-line no-unused-vars
function $836a2b733f2d0243$var$ColumnGroup(_) {
    return null;
}
var $836a2b733f2d0243$export$2e2bcd8739ae039 = $836a2b733f2d0243$var$ColumnGroup;




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");
/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ 
var $acw62 = parcelRequire("acw62");
var $006d2f9f7167e028$export$dfae7d399eea2568 = /*#__PURE__*/ $acw62.createContext(null);





var $acw62 = parcelRequire("acw62");
var $5da23ba28fbceb77$var$Indent = function Indent(_ref) {
    var prefixCls = _ref.prefixCls, level = _ref.level, isStart = _ref.isStart, isEnd = _ref.isEnd;
    var baseClassName = "".concat(prefixCls, "-indent-unit");
    var list = [];
    for(var i = 0; i < level; i += 1)list.push(/*#__PURE__*/ $acw62.createElement("span", {
        key: i,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(baseClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(baseClassName, "-start"), isStart[i]), "".concat(baseClassName, "-end"), isEnd[i]))
    }));
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-indent")
    }, list);
};
var $5da23ba28fbceb77$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($5da23ba28fbceb77$var$Indent);


function $2bbd948531562d93$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}










var $e0866d8dd7f10128$var$_excluded = [
    "children"
];
function $e0866d8dd7f10128$export$1690e12b840569b9(level, index) {
    return "".concat(level, "-").concat(index);
}
function $e0866d8dd7f10128$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $e0866d8dd7f10128$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $e0866d8dd7f10128$export$6c519d302dced239(fieldNames) {
    var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key = _ref.key, children = _ref.children;
    var mergedTitle = title || "title";
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || "key",
        children: children || "children"
    };
}
function $e0866d8dd7f10128$export$702780ec64d148df(treeData, fieldNames) {
    var keys = new Map();
    function dig(list) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        (list || []).forEach(function(treeNode) {
            var key = treeNode[fieldNames.key];
            var children = treeNode[fieldNames.children];
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(key !== null && key !== undefined, "Tree node must have a certain key: [".concat(path).concat(key, "]"));
            var recordKey = String(key);
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!keys.has(recordKey) || key === null || key === undefined, "Same 'key' exist in the Tree: ".concat(recordKey));
            keys.set(recordKey, true);
            dig(children, "".concat(path).concat(recordKey, " > "));
        });
    }
    dig(treeData);
}
function $e0866d8dd7f10128$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        var treeNodes = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(node);
        return treeNodes.map(function(treeNode) {
            // Filter invalidate node
            if (!$e0866d8dd7f10128$export$1c189858aa1437d7(treeNode)) {
                (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!treeNode, "Tree/TreeNode can only accept TreeNode as children.");
                return null;
            }
            var key = treeNode.key;
            var _treeNode$props = treeNode.props, children = _treeNode$props.children, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_treeNode$props, $e0866d8dd7f10128$var$_excluded);
            var dataNode = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
                key: key
            }, rest);
            var parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter(function(dataNode) {
            return dataNode;
        });
    }
    return dig(rootNodes);
}
function $e0866d8dd7f10128$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    var _fillFieldNames = $e0866d8dd7f10128$export$6c519d302dced239(fieldNames), fieldTitles = _fillFieldNames._title, fieldKey = _fillFieldNames.key, fieldChildren = _fillFieldNames.children;
    var expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    var flattenList = [];
    function dig(list) {
        var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return list.map(function(treeNode, index) {
            var pos = $e0866d8dd7f10128$export$1690e12b840569b9(parent ? parent.pos : "0", index);
            var mergedKey = $e0866d8dd7f10128$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            var mergedTitle;
            for(var i = 0; i < fieldTitles.length; i += 1){
                var fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            // We use `Object.assign` here to save perf since babel's `objectSpread` has perf issue
            var flattenNode = Object.assign((0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(treeNode, [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(fieldTitles), [
                fieldKey,
                fieldChildren
            ])), {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parent ? parent.isStart : []), [
                    index === 0
                ]),
                isEnd: [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parent ? parent.isEnd : []), [
                    index === list.length - 1
                ])
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $e0866d8dd7f10128$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    var mergedConfig = {};
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(config) === "object") mergedConfig = config;
    else mergedConfig = {
        externalGetKey: config
    };
    mergedConfig = mergedConfig || {};
    // Init config
    var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
    var _fillFieldNames2 = $e0866d8dd7f10128$export$6c519d302dced239(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
    var mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    var syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === "string") syntheticGetKey = function syntheticGetKey(node) {
            return node[externalGetKey];
        };
        else if (typeof externalGetKey === "function") syntheticGetKey = function syntheticGetKey(node) {
            return externalGetKey(node);
        };
    } else syntheticGetKey = function syntheticGetKey(node, pos) {
        return $e0866d8dd7f10128$export$a47fb462a08de82f(node[fieldKey], pos);
    };
    // Process
    function processNode(node, index, parent, pathNodes) {
        var children = node ? node[mergeChildrenPropName] : dataNodes;
        var pos = node ? $e0866d8dd7f10128$export$1690e12b840569b9(parent.pos, index) : "0";
        var connectNodes = node ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(pathNodes), [
            node
        ]) : [];
        // Process node if is not root
        if (node) {
            var key = syntheticGetKey(node, pos);
            var _data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(_data);
        }
        // Process children node
        if (children) children.forEach(function(subNode, subIndex) {
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $e0866d8dd7f10128$export$e5d831ce033a4615(dataNodes) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
    var /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey = arguments.length > 2 ? arguments[2] : undefined;
    // Init config
    var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    var posEntities = {};
    var keyEntities = {};
    var wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $e0866d8dd7f10128$export$4b2e27469b557f9d(dataNodes, function(item) {
        var node = item.node, index = item.index, pos = item.pos, key = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
        var entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        var mergedKey = $e0866d8dd7f10128$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $e0866d8dd7f10128$export$d961fd523a514db5(key, _ref3) {
    var expandedKeys = _ref3.expandedKeys, selectedKeys = _ref3.selectedKeys, loadedKeys = _ref3.loadedKeys, loadingKeys = _ref3.loadingKeys, checkedKeys = _ref3.checkedKeys, halfCheckedKeys = _ref3.halfCheckedKeys, dragOverNodeKey = _ref3.dragOverNodeKey, dropPosition = _ref3.dropPosition, keyEntities = _ref3.keyEntities;
    var entity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, key);
    var treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ""),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $e0866d8dd7f10128$export$7bd1b0fd4a8b540b(props) {
    var data = props.data, expanded = props.expanded, selected = props.selected, checked = props.checked, loaded = props.loaded, loading = props.loading, halfChecked = props.halfChecked, dragOver = props.dragOver, dragOverGapTop = props.dragOverGapTop, dragOverGapBottom = props.dragOverGapBottom, pos = props.pos, active = props.active, eventKey = props.eventKey;
    var eventData = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, data), {}, {
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    });
    if (!("props" in eventData)) Object.defineProperty(eventData, "props", {
        get: function get() {
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.");
            return props;
        }
    });
    return eventData;
}


var $414eed6175d6b51d$var$_excluded = [
    "eventKey",
    "className",
    "style",
    "dragOver",
    "dragOverGapTop",
    "dragOverGapBottom",
    "isLeaf",
    "isStart",
    "isEnd",
    "expanded",
    "selected",
    "checked",
    "halfChecked",
    "loading",
    "domRef",
    "active",
    "data",
    "onMouseMove",
    "selectable"
];
var $414eed6175d6b51d$var$ICON_OPEN = "open";
var $414eed6175d6b51d$var$ICON_CLOSE = "close";
var $414eed6175d6b51d$var$defaultTitle = "---";
var $414eed6175d6b51d$var$InternalTreeNode = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(InternalTreeNode, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(InternalTreeNode);
    function InternalTreeNode() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, InternalTreeNode);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            dragNodeHighlight: false
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "selectHandle", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "cacheIndent", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onSelectorClick", function(e) {
            // Click trigger before select/check operation
            var onNodeClick = _this.props.context.onNodeClick;
            onNodeClick(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
            if (_this.isSelectable()) _this.onSelect(e);
            else _this.onCheck(e);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onSelectorDoubleClick", function(e) {
            var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
            onNodeDoubleClick(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onSelect", function(e) {
            if (_this.isDisabled()) return;
            var onNodeSelect = _this.props.context.onNodeSelect;
            onNodeSelect(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onCheck", function(e) {
            if (_this.isDisabled()) return;
            var _this$props = _this.props, disableCheckbox = _this$props.disableCheckbox, checked = _this$props.checked;
            var onNodeCheck = _this.props.context.onNodeCheck;
            if (!_this.isCheckable() || disableCheckbox) return;
            var targetChecked = !checked;
            onNodeCheck(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props), targetChecked);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onMouseEnter", function(e) {
            var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
            onNodeMouseEnter(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onMouseLeave", function(e) {
            var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
            onNodeMouseLeave(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onContextMenu", function(e) {
            var onNodeContextMenu = _this.props.context.onNodeContextMenu;
            onNodeContextMenu(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDragStart", function(e) {
            var onNodeDragStart = _this.props.context.onNodeDragStart;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: true
            });
            onNodeDragStart(e, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
            try {
                // ie throw error
                // firefox-need-it
                e.dataTransfer.setData("text/plain", "");
            } catch (error) {
            // empty
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDragEnter", function(e) {
            var onNodeDragEnter = _this.props.context.onNodeDragEnter;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragEnter(e, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDragOver", function(e) {
            var onNodeDragOver = _this.props.context.onNodeDragOver;
            e.preventDefault();
            e.stopPropagation();
            onNodeDragOver(e, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDragLeave", function(e) {
            var onNodeDragLeave = _this.props.context.onNodeDragLeave;
            e.stopPropagation();
            onNodeDragLeave(e, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDragEnd", function(e) {
            var onNodeDragEnd = _this.props.context.onNodeDragEnd;
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDragEnd(e, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onDrop", function(e) {
            var onNodeDrop = _this.props.context.onNodeDrop;
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                dragNodeHighlight: false
            });
            onNodeDrop(e, (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this));
        });
        // Disabled item still can be switch
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onExpand", function(e) {
            var _this$props2 = _this.props, loading = _this$props2.loading, onNodeExpand = _this$props2.context.onNodeExpand;
            if (loading) return;
            onNodeExpand(e, (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
        });
        // Drag usage
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "setSelectHandle", function(node) {
            _this.selectHandle = node;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getNodeState", function() {
            var expanded = _this.props.expanded;
            if (_this.isLeaf()) return null;
            return expanded ? $414eed6175d6b51d$var$ICON_OPEN : $414eed6175d6b51d$var$ICON_CLOSE;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "hasChildren", function() {
            var eventKey = _this.props.eventKey;
            var keyEntities = _this.props.context.keyEntities;
            var _ref = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, eventKey) || {}, children = _ref.children;
            return !!(children || []).length;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isLeaf", function() {
            var _this$props3 = _this.props, isLeaf = _this$props3.isLeaf, loaded = _this$props3.loaded;
            var loadData = _this.props.context.loadData;
            var hasChildren = _this.hasChildren();
            if (isLeaf === false) return false;
            return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isDisabled", function() {
            var disabled = _this.props.disabled;
            var treeDisabled = _this.props.context.disabled;
            return !!(treeDisabled || disabled);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isCheckable", function() {
            var checkable = _this.props.checkable;
            var treeCheckable = _this.props.context.checkable;
            // Return false if tree or treeNode is not checkable
            if (!treeCheckable || checkable === false) return false;
            return treeCheckable;
        });
        // Load data to avoid default expanded tree without data
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "syncLoadData", function(props) {
            var expanded = props.expanded, loading = props.loading, loaded = props.loaded;
            var _this$props$context = _this.props.context, loadData = _this$props$context.loadData, onNodeLoad = _this$props$context.onNodeLoad;
            if (loading) return;
            // read from state to avoid loadData at same time
            if (loadData && expanded && !_this.isLeaf() && !loaded) // We needn't reload data when has children in sync logic
            // It's only needed in node expanded
            onNodeLoad((0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.props));
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "isDraggable", function() {
            var _this$props4 = _this.props, data = _this$props4.data, draggable = _this$props4.context.draggable;
            return !!(draggable && (!draggable.nodeDraggable || draggable.nodeDraggable(data)));
        });
        // ==================== Render: Drag Handler ====================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderDragHandler", function() {
            var _this$props$context2 = _this.props.context, draggable = _this$props$context2.draggable, prefixCls = _this$props$context2.prefixCls;
            return draggable !== null && draggable !== void 0 && draggable.icon ? /*#__PURE__*/ $acw62.createElement("span", {
                className: "".concat(prefixCls, "-draggable-icon")
            }, draggable.icon) : null;
        });
        // ====================== Render: Switcher ======================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderSwitcherIconDom", function(isLeaf) {
            var switcherIconFromProps = _this.props.switcherIcon;
            var switcherIconFromCtx = _this.props.context.switcherIcon;
            var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
            // if switcherIconDom is null, no render switcher span
            if (typeof switcherIcon === "function") return switcherIcon((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, _this.props), {}, {
                isLeaf: isLeaf
            }));
            return switcherIcon;
        });
        // Switcher
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderSwitcher", function() {
            var expanded = _this.props.expanded;
            var prefixCls = _this.props.context.prefixCls;
            if (_this.isLeaf()) {
                // if switcherIconDom is null, no render switcher span
                var _switcherIconDom = _this.renderSwitcherIconDom(true);
                return _switcherIconDom !== false ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
                }, _switcherIconDom) : null;
            }
            var switcherCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? $414eed6175d6b51d$var$ICON_OPEN : $414eed6175d6b51d$var$ICON_CLOSE));
            var switcherIconDom = _this.renderSwitcherIconDom(false);
            return switcherIconDom !== false ? /*#__PURE__*/ $acw62.createElement("span", {
                onClick: _this.onExpand,
                className: switcherCls
            }, switcherIconDom) : null;
        });
        // ====================== Render: Checkbox ======================
        // Checkbox
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderCheckbox", function() {
            var _this$props5 = _this.props, checked = _this$props5.checked, halfChecked = _this$props5.halfChecked, disableCheckbox = _this$props5.disableCheckbox;
            var prefixCls = _this.props.context.prefixCls;
            var disabled = _this.isDisabled();
            var checkable = _this.isCheckable();
            if (!checkable) return null;
            // [Legacy] Custom element should be separate with `checkable` in future
            var $custom = typeof checkable !== "boolean" ? checkable : null;
            return /*#__PURE__*/ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
                onClick: _this.onCheck
            }, $custom);
        });
        // ==================== Render: Title + Icon ====================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderIcon", function() {
            var loading = _this.props.loading;
            var prefixCls = _this.props.context.prefixCls;
            return /*#__PURE__*/ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || "docu"), loading && "".concat(prefixCls, "-icon_loading"))
            });
        });
        // Icon + Title
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderSelector", function() {
            var dragNodeHighlight = _this.state.dragNodeHighlight;
            var _this$props6 = _this.props, _this$props6$title = _this$props6.title, title = _this$props6$title === void 0 ? $414eed6175d6b51d$var$defaultTitle : _this$props6$title, selected = _this$props6.selected, icon = _this$props6.icon, loading = _this$props6.loading, data = _this$props6.data;
            var _this$props$context3 = _this.props.context, prefixCls = _this$props$context3.prefixCls, showIcon = _this$props$context3.showIcon, treeIcon = _this$props$context3.icon, loadData = _this$props$context3.loadData, titleRender = _this$props$context3.titleRender;
            var disabled = _this.isDisabled();
            var wrapClass = "".concat(prefixCls, "-node-content-wrapper");
            // Icon - Still show loading icon when loading without showIcon
            var $icon;
            if (showIcon) {
                var currentIcon = icon || treeIcon;
                $icon = currentIcon ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
                }, typeof currentIcon === "function" ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
            } else if (loadData && loading) $icon = _this.renderIcon();
            // Title
            var titleNode;
            if (typeof title === "function") titleNode = title(data);
            else if (titleRender) titleNode = titleRender(data);
            else titleNode = title;
            var $title = /*#__PURE__*/ $acw62.createElement("span", {
                className: "".concat(prefixCls, "-title")
            }, titleNode);
            return /*#__PURE__*/ $acw62.createElement("span", {
                ref: _this.setSelectHandle,
                title: typeof title === "string" ? title : "",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || "normal"), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected")),
                onMouseEnter: _this.onMouseEnter,
                onMouseLeave: _this.onMouseLeave,
                onContextMenu: _this.onContextMenu,
                onClick: _this.onSelectorClick,
                onDoubleClick: _this.onSelectorDoubleClick
            }, $icon, $title, _this.renderDropIndicator());
        });
        // =================== Render: Drop Indicator ===================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "renderDropIndicator", function() {
            var _this$props7 = _this.props, disabled = _this$props7.disabled, eventKey = _this$props7.eventKey;
            var _this$props$context4 = _this.props.context, draggable = _this$props$context4.draggable, dropLevelOffset = _this$props$context4.dropLevelOffset, dropPosition = _this$props$context4.dropPosition, prefixCls = _this$props$context4.prefixCls, indent = _this$props$context4.indent, dropIndicatorRender = _this$props$context4.dropIndicatorRender, dragOverNodeKey = _this$props$context4.dragOverNodeKey, direction = _this$props$context4.direction;
            var rootDraggable = !!draggable;
            // allowDrop is calculated in Tree.tsx, there is no need for calc it here
            var showIndicator = !disabled && rootDraggable && dragOverNodeKey === eventKey;
            // This is a hot fix which is already fixed in
            // https://github.com/react-component/tree/pull/743/files
            // But some case need break point so we hack on this
            // ref https://github.com/ant-design/ant-design/issues/43493
            var mergedIndent = indent !== null && indent !== void 0 ? indent : _this.cacheIndent;
            _this.cacheIndent = indent;
            return showIndicator ? dropIndicatorRender({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                indent: mergedIndent,
                prefixCls: prefixCls,
                direction: direction
            }) : null;
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(InternalTreeNode, [
        {
            key: "componentDidMount",
            value: // Isomorphic needn't load data in server side
            function componentDidMount() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.syncLoadData(this.props);
            }
        },
        {
            key: "isSelectable",
            value: function isSelectable() {
                var selectable = this.props.selectable;
                var treeSelectable = this.props.context.selectable;
                // Ignore when selectable is undefined or null
                if (typeof selectable === "boolean") return selectable;
                return treeSelectable;
            }
        },
        {
            key: "render",
            value: // =========================== Render ===========================
            function render() {
                var _classNames;
                var _this$props8 = this.props, eventKey = _this$props8.eventKey, className = _this$props8.className, style = _this$props8.style, dragOver = _this$props8.dragOver, dragOverGapTop = _this$props8.dragOverGapTop, dragOverGapBottom = _this$props8.dragOverGapBottom, isLeaf = _this$props8.isLeaf, isStart = _this$props8.isStart, isEnd = _this$props8.isEnd, expanded = _this$props8.expanded, selected = _this$props8.selected, checked = _this$props8.checked, halfChecked = _this$props8.halfChecked, loading = _this$props8.loading, domRef = _this$props8.domRef, active = _this$props8.active, data = _this$props8.data, onMouseMove = _this$props8.onMouseMove, selectable = _this$props8.selectable, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props8, $414eed6175d6b51d$var$_excluded);
                var _this$props$context5 = this.props.context, prefixCls = _this$props$context5.prefixCls, filterTreeNode = _this$props$context5.filterTreeNode, keyEntities = _this$props$context5.keyEntities, dropContainerKey = _this$props$context5.dropContainerKey, dropTargetKey = _this$props$context5.dropTargetKey, draggingNodeKey = _this$props$context5.draggingNodeKey;
                var disabled = this.isDisabled();
                var dataOrAriaAttributeProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(otherProps, {
                    aria: true,
                    data: true
                });
                var _ref2 = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, eventKey) || {}, level = _ref2.level;
                var isEndNode = isEnd[isEnd.length - 1];
                var mergedDraggable = this.isDraggable();
                var draggableWithoutDisabled = !disabled && mergedDraggable;
                var dragging = draggingNodeKey === eventKey;
                var ariaSelected = selectable !== undefined ? {
                    "aria-selected": !!selectable
                } : undefined;
                return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    ref: domRef,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, "".concat(prefixCls, "-treenode"), (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? "open" : "close"), !isLeaf), "".concat(prefixCls, "-treenode-checkbox-checked"), checked), "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), "".concat(prefixCls, "-treenode-selected"), selected), "".concat(prefixCls, "-treenode-loading"), loading), "".concat(prefixCls, "-treenode-active"), active), "".concat(prefixCls, "-treenode-leaf-last"), isEndNode), "".concat(prefixCls, "-treenode-draggable"), mergedDraggable), "dragging", dragging), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "drop-target", dropTargetKey === eventKey), "drop-container", dropContainerKey === eventKey), "drag-over", !disabled && dragOver), "drag-over-gap-top", !disabled && dragOverGapTop), "drag-over-gap-bottom", !disabled && dragOverGapBottom), "filter-node", filterTreeNode && filterTreeNode((0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(this.props))))),
                    style: style,
                    draggable: draggableWithoutDisabled,
                    "aria-grabbed": dragging,
                    onDragStart: draggableWithoutDisabled ? this.onDragStart : undefined,
                    onDragEnter: mergedDraggable ? this.onDragEnter : undefined,
                    onDragOver: mergedDraggable ? this.onDragOver : undefined,
                    onDragLeave: mergedDraggable ? this.onDragLeave : undefined,
                    onDrop: mergedDraggable ? this.onDrop : undefined,
                    onDragEnd: mergedDraggable ? this.onDragEnd : undefined,
                    onMouseMove: onMouseMove
                }, ariaSelected, dataOrAriaAttributeProps), /*#__PURE__*/ $acw62.createElement((0, $5da23ba28fbceb77$export$2e2bcd8739ae039), {
                    prefixCls: prefixCls,
                    level: level,
                    isStart: isStart,
                    isEnd: isEnd
                }), this.renderDragHandler(), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector());
            }
        }
    ]);
    return InternalTreeNode;
}($acw62.Component);
var $414eed6175d6b51d$var$ContextTreeNode = function ContextTreeNode(props) {
    return /*#__PURE__*/ $acw62.createElement((0, $006d2f9f7167e028$export$dfae7d399eea2568).Consumer, null, function(context) {
        return /*#__PURE__*/ $acw62.createElement($414eed6175d6b51d$var$InternalTreeNode, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            context: context
        }));
    });
};
$414eed6175d6b51d$var$ContextTreeNode.displayName = "TreeNode";
$414eed6175d6b51d$var$ContextTreeNode.isTreeNode = 1;
var $414eed6175d6b51d$export$2e2bcd8739ae039 = $414eed6175d6b51d$var$ContextTreeNode;




var $af974b6720932c91$var$_excluded = [
    "children"
];
function $af974b6720932c91$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    var clone = list.slice();
    var index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $af974b6720932c91$export$10663f6bbd2fd717(list, value) {
    var clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $af974b6720932c91$export$ddaee97dc8907312(pos) {
    return pos.split("-");
}
function $af974b6720932c91$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    var dragChildrenKeys = [];
    var entity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, dragNodeKey);
    function dig() {
        var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        list.forEach(function(_ref) {
            var key = _ref.key, children = _ref.children;
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $af974b6720932c91$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        var posArr = $af974b6720932c91$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $af974b6720932c91$export$b823688e4155eb8d(treeNodeEntity) {
    var posArr = $af974b6720932c91$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $af974b6720932c91$export$78a5519d0fb779c3(event, dragNode, targetNode, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    var _abstractDropNodeEnti;
    var clientX = event.clientX, clientY = event.clientY;
    var _getBoundingClientRec = event.target.getBoundingClientRect(), top = _getBoundingClientRec.top, height = _getBoundingClientRec.height;
    // optional chain for testing
    var horizontalMouseOffset = (direction === "rtl" ? -1 : 1) * (((startMousePosition === null || startMousePosition === void 0 ? void 0 : startMousePosition.x) || 0) - clientX);
    var rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // Filter the expanded keys to exclude the node that not has children currently (like async nodes).
    var filteredExpandKeys = expandKeys.filter(function(key) {
        var _keyEntities$key;
        return (_keyEntities$key = keyEntities[key]) === null || _keyEntities$key === void 0 || (_keyEntities$key = _keyEntities$key.children) === null || _keyEntities$key === void 0 ? void 0 : _keyEntities$key.length;
    });
    // find abstract drop node by horizontal offset
    var abstractDropNodeEntity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, targetNode.props.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        var nodeIndex = flattenedNodes.findIndex(function(flattenedNode) {
            return flattenedNode.key === abstractDropNodeEntity.key;
        });
        var prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        var prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, prevNodeKey);
    }
    var initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    var abstractDragOverEntity = abstractDropNodeEntity;
    var dragOverNodeKey = abstractDropNodeEntity.key;
    var dropPosition = 0;
    var dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) for(var i = 0; i < rawDropLevelOffset; i += 1){
        if ($af974b6720932c91$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    var abstractDragDataNode = dragNode.props.data;
    var abstractDropDataNode = abstractDropNodeEntity.node;
    var dropAllowed = true;
    if ($af974b6720932c91$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNode.props.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : ((_abstractDropNodeEnti = abstractDropNodeEntity.parent) === null || _abstractDropNodeEnti === void 0 ? void 0 : _abstractDropNodeEnti.key) || null,
        dropAllowed: dropAllowed
    };
}
function $af974b6720932c91$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    var multiple = props.multiple;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
var $af974b6720932c91$var$internalProcessProps = function internalProcessProps(props) {
    return props;
};
function $af974b6720932c91$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    var _ref2 = processor || {}, _ref2$processProps = _ref2.processProps, processProps = _ref2$processProps === void 0 ? $af974b6720932c91$var$internalProcessProps : _ref2$processProps;
    var list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(function(_ref3) {
        var children = _ref3.children, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref3, $af974b6720932c91$var$_excluded);
        var childrenNodes = $af974b6720932c91$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $414eed6175d6b51d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $af974b6720932c91$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    var keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(keys) === "object") keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`checkedKeys` is not an array or an object");
        return null;
    }
    return keyProps;
}
function $af974b6720932c91$export$fac4a40c345ccd80(keyList, keyEntities) {
    var expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        var entity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        var parent = entity.parent, node = entity.node;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach(function(key) {
        conductUp(key);
    });
    return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(expandedKeys);
}




function $4d7359063b3a6d19$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    var filteredKeys = new Set();
    halfCheckedKeys.forEach(function(key) {
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $4d7359063b3a6d19$export$ab01c86170b1dea0(node) {
    var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $4d7359063b3a6d19$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    var visitedKeys = new Set();
    for(var _level = maxLevel; _level >= 0; _level -= 1){
        var _entities = levelEntities.get(_level) || new Set();
        _entities.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref2) {
                var key = _ref2.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($4d7359063b3a6d19$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $4d7359063b3a6d19$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    var checkedKeys = new Set(keys);
    var halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(var level = 0; level <= maxLevel; level += 1){
        var entities = levelEntities.get(level) || new Set();
        entities.forEach(function(entity) {
            var key = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(childEntity) {
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    var visitedKeys = new Set();
    for(var _level2 = maxLevel; _level2 >= 0; _level2 -= 1){
        var _entities2 = levelEntities.get(_level2) || new Set();
        _entities2.forEach(function(entity) {
            var parent = entity.parent, node = entity.node;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            var allChecked = true;
            var partialChecked = false;
            (parent.children || []).filter(function(childEntity) {
                return !syntheticGetCheckDisabled(childEntity.node);
            }).forEach(function(_ref3) {
                var key = _ref3.key;
                var checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($4d7359063b3a6d19$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $4d7359063b3a6d19$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    var warningMissKeys = [];
    var syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $4d7359063b3a6d19$export$ab01c86170b1dea0;
    // We only handle exist keys
    var keys = new Set(keyList.filter(function(key) {
        var hasEntity = !!(0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    var levelEntities = new Map();
    var maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach(function(key) {
        var entity = keyEntities[key];
        var level = entity.level;
        var levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!warningMissKeys.length, "Tree missing follow keys: ".concat(warningMissKeys.slice(0, 100).map(function(key) {
        return "'".concat(key, "'");
    }).join(", ")));
    var result;
    if (checked === true) result = $4d7359063b3a6d19$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $4d7359063b3a6d19$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}





var $acw62 = parcelRequire("acw62");
function $220d9bc86e982cbe$export$2e2bcd8739ae039(getKey) {
    const [prevSelectedIndex, setPrevSelectedIndex] = (0, $acw62.useState)(null);
    const multipleSelect = (0, $acw62.useCallback)((currentSelectedIndex, data, selectedKeys)=>{
        const configPrevSelectedIndex = prevSelectedIndex !== null && prevSelectedIndex !== void 0 ? prevSelectedIndex : currentSelectedIndex;
        // add/delete the selected range
        const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
        const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
        const rangeKeys = data.slice(startIndex, endIndex + 1).map((item)=>getKey(item));
        const shouldSelected = rangeKeys.some((rangeKey)=>!selectedKeys.has(rangeKey));
        const changedKeys = [];
        rangeKeys.forEach((item)=>{
            if (shouldSelected) {
                if (!selectedKeys.has(item)) changedKeys.push(item);
                selectedKeys.add(item);
            } else {
                selectedKeys.delete(item);
                changedKeys.push(item);
            }
        });
        setPrevSelectedIndex(shouldSelected ? endIndex : null);
        return changedKeys;
    }, [
        prevSelectedIndex
    ]);
    const updatePrevSelectedIndex = (val)=>{
        setPrevSelectedIndex(val);
    };
    return [
        multipleSelect,
        updatePrevSelectedIndex
    ];
}




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");
var $b58897a741799cae$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "checked",
    "disabled",
    "defaultChecked",
    "type",
    "title",
    "onChange"
];
var $b58897a741799cae$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-checkbox" : _props$prefixCls, className = props.className, style = props.style, checked = props.checked, disabled = props.disabled, _props$defaultChecked = props.defaultChecked, defaultChecked = _props$defaultChecked === void 0 ? false : _props$defaultChecked, _props$type = props.type, type = _props$type === void 0 ? "checkbox" : _props$type, title = props.title, onChange = props.onChange, inputProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $b58897a741799cae$var$_excluded);
    var inputRef = (0, $acw62.useRef)(null);
    var holderRef = (0, $acw62.useRef)(null);
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultChecked, {
        value: checked
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), rawValue = _useMergedState2[0], setRawValue = _useMergedState2[1];
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            focus: function focus(options) {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
            },
            blur: function blur() {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        };
    });
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-checked"), rawValue), "".concat(prefixCls, "-disabled"), disabled));
    var handleChange = function handleChange(e) {
        if (disabled) return;
        if (!("checked" in props)) setRawValue(e.target.checked);
        onChange === null || onChange === void 0 || onChange({
            target: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
                type: type,
                checked: e.target.checked
            }),
            stopPropagation: function stopPropagation() {
                e.stopPropagation();
            },
            preventDefault: function preventDefault() {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ $acw62.createElement("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputProps, {
        className: "".concat(prefixCls, "-input"),
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(prefixCls, "-inner")
    }));
});
var $b58897a741799cae$export$2e2bcd8739ae039 = $b58897a741799cae$export$48513f6b9f8ce62d;










var $acw62 = parcelRequire("acw62");
const $73625a15de7a6c87$var$GroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $73625a15de7a6c87$export$2e2bcd8739ae039 = $73625a15de7a6c87$var$GroupContext;





const $04e90e571fcd1828$export$92a97fe1d1148438 = (token)=>{
    const { checkboxCls: checkboxCls } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                display: "inline-flex",
                flexWrap: "wrap",
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            }),
            // Wrapper
            [wrapperCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                display: "inline-flex",
                alignItems: "baseline",
                cursor: "pointer",
                // Fix checkbox & radio in flex align #30260
                "&:after": {
                    display: "inline-block",
                    width: 0,
                    overflow: "hidden",
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                },
                [`&${wrapperCls}-in-form-item`]: {
                    'input[type="checkbox"]': {
                        width: 14,
                        // FIXME: magic
                        height: 14 // FIXME: magic
                    }
                }
            }),
            // Wrapper > Checkbox
            [checkboxCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: "relative",
                whiteSpace: "nowrap",
                lineHeight: 1,
                cursor: "pointer",
                borderRadius: token.borderRadiusSM,
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: "center",
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: "absolute",
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: 0,
                    zIndex: 1,
                    cursor: "pointer",
                    opacity: 0,
                    margin: 0,
                    [`&:focus-visible + ${checkboxCls}-inner`]: Object.assign({}, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token))
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    boxSizing: "border-box",
                    display: "block",
                    width: token.checkboxSize,
                    height: token.checkboxSize,
                    direction: "ltr",
                    backgroundColor: token.colorBgContainer,
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusSM,
                    borderCollapse: "separate",
                    transition: `all ${token.motionDurationSlow}`,
                    "&:after": {
                        boxSizing: "border-box",
                        position: "absolute",
                        top: "50%",
                        insetInlineStart: "25%",
                        display: "table",
                        width: token.calc(token.checkboxSize).div(14).mul(5).equal(),
                        height: token.calc(token.checkboxSize).div(14).mul(8).equal(),
                        border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorWhite}`,
                        borderTop: 0,
                        borderInlineStart: 0,
                        transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
                        opacity: 0,
                        content: '""',
                        transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`
                    }
                },
                // Wrapper > Checkbox + Text
                "& + span": {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            })
        },
        // ===================== Hover =====================
        {
            // Wrapper & Wrapper > Checkbox
            [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    borderColor: token.colorPrimary
                }
            },
            [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled) ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: "transparent"
                },
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled):after`]: {
                    borderColor: token.colorPrimaryHover
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                [`${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimary,
                    borderColor: token.colorPrimary,
                    "&:after": {
                        opacity: 1,
                        transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
                        transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`
                    }
                }
            },
            [`
        ${wrapperCls}-checked:not(${wrapperCls}-disabled),
        ${checkboxCls}-checked:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: "transparent"
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                "&-indeterminate": {
                    // Wrapper > Checkbox > inner
                    [`${checkboxCls}-inner`]: {
                        backgroundColor: token.colorBgContainer,
                        borderColor: token.colorBorder,
                        "&:after": {
                            top: "50%",
                            insetInlineStart: "50%",
                            width: token.calc(token.fontSizeLG).div(2).equal(),
                            height: token.calc(token.fontSizeLG).div(2).equal(),
                            backgroundColor: token.colorPrimary,
                            border: 0,
                            transform: "translate(-50%, -50%) scale(1)",
                            opacity: 1,
                            content: '""'
                        }
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: "not-allowed"
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: "not-allowed",
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: "none"
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    background: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    "&:after": {
                        borderColor: token.colorTextDisabled
                    }
                },
                "&:after": {
                    display: "none"
                },
                "& + span": {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate ${checkboxCls}-inner::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function $04e90e571fcd1828$export$3d2f074408bd1b82(prefixCls, token) {
    const checkboxToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return [
        $04e90e571fcd1828$export$92a97fe1d1148438(checkboxToken)
    ];
}
var $04e90e571fcd1828$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Checkbox", (token, _ref)=>{
    let { prefixCls: prefixCls } = _ref;
    return [
        $04e90e571fcd1828$export$3d2f074408bd1b82(prefixCls, token)
    ];
});


"use client";
var $04e12b22f131287e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $04e12b22f131287e$var$InternalCheckbox = (props, ref)=>{
    var _a;
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, indeterminate: indeterminate = false, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, skipGroup: skipGroup = false, disabled: disabled } = props, restProps = $04e12b22f131287e$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "children",
        "indeterminate",
        "style",
        "onMouseEnter",
        "onMouseLeave",
        "skipGroup",
        "disabled"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, checkbox: checkbox } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const checkboxGroup = $acw62.useContext((0, $73625a15de7a6c87$export$2e2bcd8739ae039));
    const { isFormItemInput: isFormItemInput } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const contextDisabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = (_a = (checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.disabled) || disabled) !== null && _a !== void 0 ? _a : contextDisabled;
    const prevValue = $acw62.useRef(restProps.value);
    $acw62.useEffect(()=>{
        checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
    }, []);
    $acw62.useEffect(()=>{
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.cancelValue(prevValue.current);
            checkboxGroup === null || checkboxGroup === void 0 || checkboxGroup.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return ()=>checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.cancelValue(restProps.value);
    }, [
        restProps.value
    ]);
    const prefixCls = getPrefixCls("checkbox", customizePrefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $04e90e571fcd1828$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const checkboxProps = Object.assign({}, restProps);
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = function() {
            if (restProps.onChange) restProps.onChange.apply(restProps, arguments);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, checkbox === null || checkbox === void 0 ? void 0 : checkbox.className, className, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, $ede16c18199d1556$export$23466a5792b7a5d3), hashId);
    const ariaChecked = indeterminate ? "mixed" : undefined;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $acw62.createElement("label", {
        className: classString,
        style: Object.assign(Object.assign({}, checkbox === null || checkbox === void 0 ? void 0 : checkbox.style), style),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ $acw62.createElement((0, $b58897a741799cae$export$2e2bcd8739ae039), Object.assign({
        "aria-checked": ariaChecked
    }, checkboxProps, {
        prefixCls: prefixCls,
        className: checkboxClass,
        disabled: mergedDisabled,
        ref: ref
    })), children !== undefined && /*#__PURE__*/ $acw62.createElement("span", null, children))));
};
const $04e12b22f131287e$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef($04e12b22f131287e$var$InternalCheckbox);
var $04e12b22f131287e$export$2e2bcd8739ae039 = $04e12b22f131287e$var$Checkbox;




var $acw62 = parcelRequire("acw62");







"use client";
var $727f72b27c7ab10d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $727f72b27c7ab10d$var$CheckboxGroup = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { defaultValue: defaultValue, children: children, options: options = [], prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, onChange: onChange } = props, restProps = $727f72b27c7ab10d$var$__rest(props, [
        "defaultValue",
        "children",
        "options",
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "onChange"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [value, setValue] = $acw62.useState(restProps.value || defaultValue || []);
    const [registeredValues, setRegisteredValues] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        if ("value" in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    const memoOptions = $acw62.useMemo(()=>options.map((option)=>{
            if (typeof option === "string" || typeof option === "number") return {
                label: option,
                value: option
            };
            return option;
        }), [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = value.indexOf(option.value);
        const newValue = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!("value" in restProps)) setValue(newValue);
        onChange === null || onChange === void 0 || onChange(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls("checkbox", customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $04e90e571fcd1828$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const domProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(restProps, [
        "value",
        "disabled"
    ]);
    const childrenNode = options.length ? memoOptions.map((option)=>/*#__PURE__*/ $acw62.createElement((0, $04e12b22f131287e$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: "disabled" in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: `${groupPrefixCls}-item`,
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const context = {
        toggleOption: toggleOption,
        value: value,
        disabled: restProps.disabled,
        name: restProps.name,
        registerValue: // https://github.com/ant-design/ant-design/issues/16376
        registerValue,
        cancelValue: cancelValue
    };
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        className: classString,
        style: style
    }, domProps, {
        ref: ref
    }), /*#__PURE__*/ $acw62.createElement((0, $73625a15de7a6c87$export$2e2bcd8739ae039).Provider, {
        value: context
    }, childrenNode)));
});
var $727f72b27c7ab10d$export$2e2bcd8739ae039 = $727f72b27c7ab10d$var$CheckboxGroup;


"use client";
const $da237ba92f78ed9a$var$Checkbox = (0, $04e12b22f131287e$export$2e2bcd8739ae039);
$da237ba92f78ed9a$var$Checkbox.Group = (0, $727f72b27c7ab10d$export$2e2bcd8739ae039);
$da237ba92f78ed9a$var$Checkbox.__ANT_CHECKBOX = true;
var $da237ba92f78ed9a$export$2e2bcd8739ae039 = $da237ba92f78ed9a$var$Checkbox;



var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
var $fd5c50d68a830e84$var$ESC = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC, $fd5c50d68a830e84$var$TAB = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).TAB;
function $fd5c50d68a830e84$export$2e2bcd8739ae039(_ref) {
    var visible = _ref.visible, triggerRef = _ref.triggerRef, onVisibleChange = _ref.onVisibleChange, autoFocus = _ref.autoFocus, overlayRef = _ref.overlayRef;
    var focusMenuRef = $acw62.useRef(false);
    var handleCloseMenuAndReturnFocus = function handleCloseMenuAndReturnFocus() {
        if (visible) {
            var _triggerRef$current, _triggerRef$current$f;
            (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || (_triggerRef$current$f = _triggerRef$current.focus) === null || _triggerRef$current$f === void 0 || _triggerRef$current$f.call(_triggerRef$current);
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(false);
        }
    };
    var focusMenu = function focusMenu() {
        var _overlayRef$current;
        if ((_overlayRef$current = overlayRef.current) !== null && _overlayRef$current !== void 0 && _overlayRef$current.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    var handleKeyDown = function handleKeyDown(event) {
        switch(event.keyCode){
            case $fd5c50d68a830e84$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $fd5c50d68a830e84$var$TAB:
                var focusResult = false;
                if (!focusMenuRef.current) focusResult = focusMenu();
                if (focusResult) event.preventDefault();
                else handleCloseMenuAndReturnFocus();
                break;
        }
    };
    $acw62.useEffect(function() {
        if (visible) {
            window.addEventListener("keydown", handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(focusMenu, 3);
            return function() {
                window.removeEventListener("keydown", handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return function() {
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}



var $acw62 = parcelRequire("acw62");

var $e68e305c80c7967c$var$Overlay = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var overlay = props.overlay, arrow = props.arrow, prefixCls = props.prefixCls;
    var overlayNode = (0, $acw62.useMemo)(function() {
        var overlayElement;
        if (typeof overlay === "function") overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    var composedRef = (0, $5e297877593af644$export$ab452c34e8e05029)(ref, overlayNode === null || overlayNode === void 0 ? void 0 : overlayNode.ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-arrow")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(overlayNode, {
        ref: (0, $5e297877593af644$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $e68e305c80c7967c$export$2e2bcd8739ae039 = $e68e305c80c7967c$var$Overlay;


var $9a69693d1b18e39e$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $9a69693d1b18e39e$var$targetOffset = [
    0,
    0
];
var $9a69693d1b18e39e$var$placements = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $9a69693d1b18e39e$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $9a69693d1b18e39e$var$targetOffset
    }
};
var $9a69693d1b18e39e$export$2e2bcd8739ae039 = $9a69693d1b18e39e$var$placements;


var $efa0709bbe269de7$var$_excluded = [
    "arrow",
    "prefixCls",
    "transitionName",
    "animation",
    "align",
    "placement",
    "placements",
    "getPopupContainer",
    "showAction",
    "hideAction",
    "overlayClassName",
    "overlayStyle",
    "visible",
    "trigger",
    "autoFocus",
    "overlay",
    "children",
    "onVisibleChange"
];
function $efa0709bbe269de7$var$Dropdown(props, ref) {
    var _children$props;
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dropdown" : _props$prefixCls, transitionName = props.transitionName, animation = props.animation, align = props.align, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottomLeft" : _props$placement, _props$placements = props.placements, placements = _props$placements === void 0 ? (0, $9a69693d1b18e39e$export$2e2bcd8739ae039) : _props$placements, getPopupContainer = props.getPopupContainer, showAction = props.showAction, hideAction = props.hideAction, overlayClassName = props.overlayClassName, overlayStyle = props.overlayStyle, visible = props.visible, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        "hover"
    ] : _props$trigger, autoFocus = props.autoFocus, overlay = props.overlay, children = props.children, onVisibleChange = props.onVisibleChange, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $efa0709bbe269de7$var$_excluded);
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), triggerVisible = _React$useState2[0], setTriggerVisible = _React$useState2[1];
    var mergedVisible = "visible" in props ? visible : triggerVisible;
    var triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    var childRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, function() {
        return triggerRef.current;
    });
    var handleVisibleChange = function handleVisibleChange(newVisible) {
        setTriggerVisible(newVisible);
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(newVisible);
    };
    (0, $fd5c50d68a830e84$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    var onClick = function onClick(e) {
        var onOverlayClick = props.onOverlayClick;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    var getMenuElement = function getMenuElement() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e68e305c80c7967c$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    };
    var getMenuElementOrLambda = function getMenuElementOrLambda() {
        if (typeof overlay === "function") return getMenuElement;
        return getMenuElement();
    };
    var getMinOverlayWidthMatchTrigger = function getMinOverlayWidthMatchTrigger() {
        var minOverlayWidthMatchTrigger = props.minOverlayWidthMatchTrigger, alignPoint = props.alignPoint;
        if ("minOverlayWidthMatchTrigger" in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    var getOpenClassName = function getOpenClassName() {
        var openClassName = props.openClassName;
        if (openClassName !== undefined) return openClassName;
        return "".concat(prefixCls, "-open");
    };
    var childrenNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.className, mergedVisible && getOpenClassName()),
        ref: (0, $5e297877593af644$export$c1cec34af06bcf7)(children) ? (0, $5e297877593af644$export$ab452c34e8e05029)(childRef, children.ref) : undefined
    });
    var triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf("contextMenu") !== -1) triggerHideAction = [
        "click"
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? "minWidth" : "",
        popup: getMenuElementOrLambda(),
        onPopupVisibleChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
}
var $efa0709bbe269de7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($efa0709bbe269de7$var$Dropdown);


var $e2ef3d42b101c489$export$2e2bcd8739ae039 = (0, $efa0709bbe269de7$export$2e2bcd8739ae039);














var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $9c2ff7221738ac19$export$26537912ea160acd = /*#__PURE__*/ $acw62.createContext(null);
function $9c2ff7221738ac19$export$80c871fe8d6b896(uuid, eventKey) {
    if (uuid === undefined) return null;
    return "".concat(uuid, "-").concat(eventKey);
}
function $9c2ff7221738ac19$export$a276eb4e9be640f8(eventKey) {
    var id = $acw62.useContext($9c2ff7221738ac19$export$26537912ea160acd);
    return $9c2ff7221738ac19$export$80c871fe8d6b896(id, eventKey);
}





var $acw62 = parcelRequire("acw62");


var $24a4386da4a32dce$var$_excluded = [
    "children",
    "locked"
];
var $24a4386da4a32dce$export$c7e742effb1c51e2 = /*#__PURE__*/ $acw62.createContext(null);
function $24a4386da4a32dce$var$mergeProps(origin, target) {
    var clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, origin);
    Object.keys(target).forEach(function(key) {
        var value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $24a4386da4a32dce$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, locked = _ref.locked, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $24a4386da4a32dce$var$_excluded);
    var context = $acw62.useContext($24a4386da4a32dce$export$c7e742effb1c51e2);
    var inheritableContext = (0, $2e4d16a6147a082d$export$2e2bcd8739ae039)(function() {
        return $24a4386da4a32dce$var$mergeProps(context, restProps);
    }, [
        context,
        restProps
    ], function(prev, next) {
        return !locked && (prev[0] !== next[0] || !(0, $357adc8667cde522$export$2e2bcd8739ae039)(prev[1], next[1], true));
    });
    return /*#__PURE__*/ $acw62.createElement($24a4386da4a32dce$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}




var $acw62 = parcelRequire("acw62");
var $76292f3495da88ff$var$EmptyList = [];
var $76292f3495da88ff$export$d9ffb5bfd108b003 = /*#__PURE__*/ $acw62.createContext(null);
function $76292f3495da88ff$export$e295b0c537d32d7d() {
    return $acw62.useContext($76292f3495da88ff$export$d9ffb5bfd108b003);
}
var $76292f3495da88ff$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $acw62.createContext($76292f3495da88ff$var$EmptyList);
function $76292f3495da88ff$export$d3d2d0a05677870a(eventKey) {
    var parentKeyPath = $acw62.useContext($76292f3495da88ff$export$54d9e16aa4c8a7fa);
    return $acw62.useMemo(function() {
        return eventKey !== undefined ? [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(parentKeyPath), [
            eventKey
        ]) : parentKeyPath;
    }, [
        parentKeyPath,
        eventKey
    ]);
}
var $76292f3495da88ff$export$f0b9e0db98edfa53 = /*#__PURE__*/ $acw62.createContext(null);



var $acw62 = parcelRequire("acw62");
var $db67f8032758903f$var$PrivateContext = /*#__PURE__*/ $acw62.createContext({});
var $db67f8032758903f$export$2e2bcd8739ae039 = $db67f8032758903f$var$PrivateContext;





function $52ee51206a0899df$var$focusable(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if ((0, $555b4eee2695f264$export$2e2bcd8739ae039)(node)) {
        var nodeName = node.nodeName.toLowerCase();
        var isFocusableElement = // Focusable element
        [
            "input",
            "select",
            "textarea",
            "button"
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === "a" && !!node.getAttribute("href");
        // Get tabIndex
        var tabIndexAttr = node.getAttribute("tabindex");
        var tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        var tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $52ee51206a0899df$export$bbc7b5f11aba534b(node) {
    var includePositive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var res = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(node.querySelectorAll("*")).filter(function(child) {
        return $52ee51206a0899df$var$focusable(child, includePositive);
    });
    if ($52ee51206a0899df$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
var $52ee51206a0899df$var$lastFocusElement = null;
function $52ee51206a0899df$export$79fea02f7a83293d() {
    $52ee51206a0899df$var$lastFocusElement = document.activeElement;
}
function $52ee51206a0899df$export$8785654047fe7352() {
    $52ee51206a0899df$var$lastFocusElement = null;
}
function $52ee51206a0899df$export$fac0a9974415d98f() {
    if ($52ee51206a0899df$var$lastFocusElement) try {
        // 元素可能已经被移动了
        $52ee51206a0899df$var$lastFocusElement.focus();
    /* eslint-disable no-empty */ } catch (e) {
    // empty
    }
}
function $52ee51206a0899df$export$5717027f63f8addb(node, e) {
    if (e.keyCode === 9) {
        var tabNodeList = $52ee51206a0899df$export$bbc7b5f11aba534b(node);
        var lastTabNode = tabNodeList[e.shiftKey ? 0 : tabNodeList.length - 1];
        var leavingTab = lastTabNode === document.activeElement || node === document.activeElement;
        if (leavingTab) {
            var target = tabNodeList[e.shiftKey ? tabNodeList.length - 1 : 0];
            target.focus();
            e.preventDefault();
        }
    }
}





var $acw62 = parcelRequire("acw62");

// destruct to reduce minify size
var $6782197159192667$var$LEFT = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT, $6782197159192667$var$RIGHT = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT, $6782197159192667$var$UP = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP, $6782197159192667$var$DOWN = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN, $6782197159192667$var$ENTER = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER, $6782197159192667$var$ESC = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC, $6782197159192667$var$HOME = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).HOME, $6782197159192667$var$END = (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).END;
var $6782197159192667$var$ArrowKeys = [
    $6782197159192667$var$UP,
    $6782197159192667$var$DOWN,
    $6782197159192667$var$LEFT,
    $6782197159192667$var$RIGHT
];
function $6782197159192667$var$getOffset(mode, isRootLevel, isRtl, which) {
    var _inline, _horizontal, _vertical, _offsets;
    var prev = "prev";
    var next = "next";
    var children = "children";
    var parent = "parent";
    // Inline enter is special that we use unique operation
    if (mode === "inline" && which === $6782197159192667$var$ENTER) return {
        inlineTrigger: true
    };
    var inline = (_inline = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_inline, $6782197159192667$var$UP, prev), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_inline, $6782197159192667$var$DOWN, next), _inline);
    var horizontal = (_horizontal = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_horizontal, $6782197159192667$var$LEFT, isRtl ? next : prev), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_horizontal, $6782197159192667$var$RIGHT, isRtl ? prev : next), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_horizontal, $6782197159192667$var$DOWN, children), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_horizontal, $6782197159192667$var$ENTER, children), _horizontal);
    var vertical = (_vertical = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_vertical, $6782197159192667$var$UP, prev), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_vertical, $6782197159192667$var$DOWN, next), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_vertical, $6782197159192667$var$ENTER, children), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_vertical, $6782197159192667$var$ESC, parent), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_vertical, $6782197159192667$var$LEFT, isRtl ? children : parent), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_vertical, $6782197159192667$var$RIGHT, isRtl ? parent : children), _vertical);
    var offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    var type = (_offsets = offsets["".concat(mode).concat(isRootLevel ? "" : "Sub")]) === null || _offsets === void 0 ? void 0 : _offsets[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $6782197159192667$var$findContainerUL(element) {
    var current = element;
    while(current){
        if (current.getAttribute("data-menu-list")) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $6782197159192667$var$getFocusElement(activeElement, elements) {
    var current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $6782197159192667$export$433aaa1f216cf32d(container, elements) {
    var list = (0, $52ee51206a0899df$export$bbc7b5f11aba534b)(container, true);
    return list.filter(function(ele) {
        return elements.has(ele);
    });
}
function $6782197159192667$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    var sameLevelFocusableMenuElementList = $6782197159192667$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    var count = sameLevelFocusableMenuElementList.length;
    var focusIndex = sameLevelFocusableMenuElementList.findIndex(function(ele) {
        return focusMenuElement === ele;
    });
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
var $6782197159192667$export$20827b68c762d23 = function refreshElements(keys, id) {
    var elements = new Set();
    var key2element = new Map();
    var element2key = new Map();
    keys.forEach(function(key) {
        var element = document.querySelector("[data-menu-id='".concat((0, $9c2ff7221738ac19$export$80c871fe8d6b896)(id, key), "']"));
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $6782197159192667$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    var rafRef = $acw62.useRef();
    var activeRef = $acw62.useRef();
    activeRef.current = activeKey;
    var cleanRaf = function cleanRaf() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    $acw62.useEffect(function() {
        return function() {
            cleanRaf();
        };
    }, []);
    return function(e) {
        var which = e.which;
        if ([].concat($6782197159192667$var$ArrowKeys, [
            $6782197159192667$var$ENTER,
            $6782197159192667$var$ESC,
            $6782197159192667$var$HOME,
            $6782197159192667$var$END
        ]).includes(which)) {
            var keys = getKeys();
            var refreshedElements = $6782197159192667$export$20827b68c762d23(keys, id);
            var _refreshedElements = refreshedElements, elements = _refreshedElements.elements, key2element = _refreshedElements.key2element, element2key = _refreshedElements.element2key;
            // First we should find current focused MenuItem/SubMenu element
            var activeElement = key2element.get(activeKey);
            var focusMenuElement = $6782197159192667$var$getFocusElement(activeElement, elements);
            var focusMenuKey = element2key.get(focusMenuElement);
            var offsetObj = $6782197159192667$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $6782197159192667$var$HOME && which !== $6782197159192667$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($6782197159192667$var$ArrowKeys.includes(which) || [
                $6782197159192667$var$HOME,
                $6782197159192667$var$END
            ].includes(which)) e.preventDefault();
            var tryFocus = function tryFocus(menuElement) {
                if (menuElement) {
                    var focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    var link = menuElement.querySelector("a");
                    if (link !== null && link !== void 0 && link.getAttribute("href")) focusTargetElement = link;
                    var targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $6782197159192667$var$HOME,
                $6782197159192667$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                var parentQueryContainer;
                if (!focusMenuElement || mode === "inline") parentQueryContainer = containerRef.current;
                else parentQueryContainer = $6782197159192667$var$findContainerUL(focusMenuElement);
                // Get next focus element
                var targetElement;
                var focusableElements = $6782197159192667$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $6782197159192667$var$HOME) targetElement = focusableElements[0];
                else if (which === $6782197159192667$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $6782197159192667$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                    // Async should resync elements
                    refreshedElements = $6782197159192667$export$20827b68c762d23(keys, id);
                    var controlId = focusMenuElement.getAttribute("aria-controls");
                    var subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    var targetElement = $6782197159192667$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                var keyPath = getKeyPath(focusMenuKey, true);
                var parentKey = keyPath[keyPath.length - 2];
                var parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown === null || originOnKeyDown === void 0 || originOnKeyDown(e);
    };
}





var $acw62 = parcelRequire("acw62");

function $383bc652cde1c429$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


var $91daccd328800b8c$var$PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__";
var $91daccd328800b8c$var$getPathStr = function getPathStr(keyPath) {
    return keyPath.join($91daccd328800b8c$var$PATH_SPLIT);
};
var $91daccd328800b8c$var$getPathKeys = function getPathKeys(keyPathStr) {
    return keyPathStr.split($91daccd328800b8c$var$PATH_SPLIT);
};
var $91daccd328800b8c$export$20a0132c46ce5b04 = "rc-menu-more";
function $91daccd328800b8c$export$2e2bcd8739ae039() {
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), internalForceUpdate = _React$useState2[1];
    var key2pathRef = (0, $acw62.useRef)(new Map());
    var path2keyRef = (0, $acw62.useRef)(new Map());
    var _React$useState3 = $acw62.useState([]), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), overflowKeys = _React$useState4[0], setOverflowKeys = _React$useState4[1];
    var updateRef = (0, $acw62.useRef)(0);
    var destroyRef = (0, $acw62.useRef)(false);
    var forceUpdate = function forceUpdate() {
        if (!destroyRef.current) internalForceUpdate({});
    };
    var registerPath = (0, $acw62.useCallback)(function(key, keyPath) {
        // Fill map
        var connectedPath = $91daccd328800b8c$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        var id = updateRef.current;
        (0, $383bc652cde1c429$export$7693db51ef834b40)(function() {
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    var unregisterPath = (0, $acw62.useCallback)(function(key, keyPath) {
        var connectedPath = $91daccd328800b8c$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    var refreshOverflowKeys = (0, $acw62.useCallback)(function(keys) {
        setOverflowKeys(keys);
    }, []);
    var getKeyPath = (0, $acw62.useCallback)(function(eventKey, includeOverflow) {
        var fullPath = key2pathRef.current.get(eventKey) || "";
        var keys = $91daccd328800b8c$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($91daccd328800b8c$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    var isSubPathKey = (0, $acw62.useCallback)(function(pathKeys, eventKey) {
        return pathKeys.filter(function(item) {
            return item !== undefined;
        }).some(function(pathKey) {
            var pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        });
    }, [
        getKeyPath
    ]);
    var getKeys = function getKeys() {
        var keys = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(key2pathRef.current.keys());
        if (overflowKeys.length) keys.push($91daccd328800b8c$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ var getSubPathKeys = (0, $acw62.useCallback)(function(key) {
        var connectedPath = "".concat(key2pathRef.current.get(key)).concat($91daccd328800b8c$var$PATH_SPLIT);
        var pathKeys = new Set();
        (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(path2keyRef.current.keys()).forEach(function(pathKey) {
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $acw62.useEffect(function() {
        return function() {
            destroyRef.current = true;
        };
    }, []);
    return {
        // Register
        registerPath: registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        // Util
        isSubPathKey: isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $acw62 = parcelRequire("acw62");
function $f79f42a79a2878d1$export$2e2bcd8739ae039(func) {
    var funRef = $acw62.useRef(func);
    funRef.current = func;
    var callback = $acw62.useCallback(function() {
        var _funRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_funRef$current = funRef.current) === null || _funRef$current === void 0 ? void 0 : _funRef$current.call.apply(_funRef$current, [
            funRef
        ].concat(args));
    }, []);
    return func ? callback : undefined;
}




var $acw62 = parcelRequire("acw62");

var $610565fd72f5965a$var$uniquePrefix = Math.random().toFixed(5).toString().slice(2);
var $610565fd72f5965a$var$internalId = 0;
function $610565fd72f5965a$export$2e2bcd8739ae039(id) {
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(id, {
        value: id
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), uuid = _useMergedState2[0], setUUID = _useMergedState2[1];
    $acw62.useEffect(function() {
        $610565fd72f5965a$var$internalId += 1;
        var newId = "".concat($610565fd72f5965a$var$uniquePrefix, "-").concat($610565fd72f5965a$var$internalId);
        setUUID("rc-menu-uuid-".concat(newId));
    }, []);
    return uuid;
}


















var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

function $a649e094df404c52$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), activeKey = _React$useContext.activeKey, onActive = _React$useContext.onActive, onInactive = _React$useContext.onInactive;
    var ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = function(domEvent) {
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = function(domEvent) {
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $acw62 = parcelRequire("acw62");

function $551f98bff3692876$export$2e2bcd8739ae039(level) {
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), mode = _React$useContext.mode, rtl = _React$useContext.rtl, inlineIndent = _React$useContext.inlineIndent;
    if (mode !== "inline") return null;
    var len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}




var $acw62 = parcelRequire("acw62");
function $c3c54e71b725e1ff$export$2e2bcd8739ae039(_ref) {
    var icon = _ref.icon, props = _ref.props, children = _ref.children;
    var iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === "function") iconNode = /*#__PURE__*/ $acw62.createElement(icon, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props));
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}




var $124c89870f2be225$var$_excluded = [
    "item"
];
function $124c89870f2be225$export$e189bcd94b66c1db(_ref) {
    var item = _ref.item, restInfo = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $124c89870f2be225$var$_excluded);
    Object.defineProperty(restInfo, "item", {
        get: function get() {
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future.");
            return item;
        }
    });
    return restInfo;
}


var $c59b5fb169e5cf0f$var$_excluded = [
    "title",
    "attribute",
    "elementRef"
], $c59b5fb169e5cf0f$var$_excluded2 = [
    "style",
    "className",
    "eventKey",
    "warnKey",
    "disabled",
    "itemIcon",
    "children",
    "role",
    "onMouseEnter",
    "onMouseLeave",
    "onClick",
    "onKeyDown",
    "onFocus"
], $c59b5fb169e5cf0f$var$_excluded3 = [
    "active"
];
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
var $c59b5fb169e5cf0f$var$LegacyMenuItem = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(LegacyMenuItem, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(LegacyMenuItem);
    function LegacyMenuItem() {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, LegacyMenuItem);
        return _super.apply(this, arguments);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(LegacyMenuItem, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, title = _this$props.title, attribute = _this$props.attribute, elementRef = _this$props.elementRef, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_this$props, $c59b5fb169e5cf0f$var$_excluded);
                // Here the props are eventually passed to the DOM element.
                // React does not recognize non-standard attributes.
                // Therefore, remove the props that is not used here.
                // ref: https://github.com/ant-design/ant-design/issues/41395
                var passedProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(restProps, [
                    "eventKey",
                    "popupClassName",
                    "popupOffset",
                    "onTitleClick"
                ]);
                (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!attribute, "`attribute` of Menu.Item is deprecated. Please pass attribute directly.");
                return /*#__PURE__*/ $acw62.createElement((0, $4863ed3a14942ec4$export$2e2bcd8739ae039).Item, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, attribute, {
                    title: typeof title === "string" ? title : undefined
                }, passedProps, {
                    ref: elementRef
                }));
            }
        }
    ]);
    return LegacyMenuItem;
}($acw62.Component);
/**
 * Real Menu Item component
 */ var $c59b5fb169e5cf0f$var$InternalMenuItem = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var style = props.style, className = props.className, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, itemIcon = props.itemIcon, children = props.children, role = props.role, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onFocus = props.onFocus, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $c59b5fb169e5cf0f$var$_excluded2);
    var domDataId = (0, $9c2ff7221738ac19$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, onItemClick = _React$useContext.onItemClick, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, contextItemIcon = _React$useContext.itemIcon, selectedKeys = _React$useContext.selectedKeys, onActive = _React$useContext.onActive;
    var _React$useContext2 = $acw62.useContext((0, $db67f8032758903f$export$2e2bcd8739ae039)), _internalRenderMenuItem = _React$useContext2._internalRenderMenuItem;
    var itemCls = "".concat(prefixCls, "-item");
    var legacyMenuItemRef = $acw62.useRef();
    var elementRef = $acw62.useRef();
    var mergedDisabled = contextDisabled || disabled;
    var mergedEleRef = (0, $5e297877593af644$export$1d1c999670a1285d)(ref, elementRef);
    var connectedKeys = (0, $76292f3495da88ff$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    var getEventInfo = function getEventInfo(e) {
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(connectedKeys).reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    var mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    var _useActive = (0, $a649e094df404c52$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave), active = _useActive.active, activeProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_useActive, $c59b5fb169e5cf0f$var$_excluded3);
    // ============================ Select ============================
    var selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    var directionStyle = (0, $551f98bff3692876$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    var onInternalClick = function onInternalClick(e) {
        if (mergedDisabled) return;
        var info = getEventInfo(e);
        onClick === null || onClick === void 0 || onClick((0, $124c89870f2be225$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    var onInternalKeyDown = function onInternalKeyDown(e) {
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
        if (e.which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) {
            var info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick === null || onClick === void 0 || onClick((0, $124c89870f2be225$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus(e) {
        onActive(eventKey);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    // ============================ Render ============================
    var optionRoleProps = {};
    if (props.role === "option") optionRoleProps["aria-selected"] = selected;
    var renderNode = /*#__PURE__*/ $acw62.createElement($c59b5fb169e5cf0f$var$LegacyMenuItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? "none" : role || "menuitem",
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, restProps, activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, directionStyle), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemCls, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(itemCls, "-active"), active), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(itemCls, "-selected"), selected), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(itemCls, "-disabled"), mergedDisabled), _classNames), className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $acw62.createElement((0, $c3c54e71b725e1ff$export$2e2bcd8739ae039), {
        props: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            isSelected: selected
        }),
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $c59b5fb169e5cf0f$var$MenuItem(props, ref) {
    var eventKey = props.eventKey;
    // ==================== Record KeyPath ====================
    var measure = (0, $76292f3495da88ff$export$e295b0c537d32d7d)();
    var connectedKeyPath = (0, $76292f3495da88ff$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $acw62.createElement($c59b5fb169e5cf0f$var$InternalMenuItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref
    }));
}
var $c59b5fb169e5cf0f$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($c59b5fb169e5cf0f$var$MenuItem);








var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


var $ad0e9c8fde51e397$var$_excluded = [
    "className",
    "children"
];
var $ad0e9c8fde51e397$var$InternalSubMenuList = function InternalSubMenuList(_ref, ref) {
    var className = _ref.className, children = _ref.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $ad0e9c8fde51e397$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, rtl = _React$useContext.rtl;
    return /*#__PURE__*/ $acw62.createElement("ul", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, rtl && "".concat(prefixCls, "-rtl"), "".concat(prefixCls, "-sub"), "".concat(prefixCls, "-").concat(mode === "inline" ? "inline" : "vertical"), className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
var $ad0e9c8fde51e397$var$SubMenuList = /*#__PURE__*/ $acw62.forwardRef($ad0e9c8fde51e397$var$InternalSubMenuList);
$ad0e9c8fde51e397$var$SubMenuList.displayName = "SubMenuList";
var $ad0e9c8fde51e397$export$2e2bcd8739ae039 = $ad0e9c8fde51e397$var$SubMenuList;





var $acw62 = parcelRequire("acw62");
function $152cdddbd0a33c22$export$cd230e97e668be9(children, keyPath) {
    return (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children).map(function(child, index) {
        if (/*#__PURE__*/ $acw62.isValidElement(child)) {
            var _eventKey, _child$props;
            var key = child.key;
            var eventKey = (_eventKey = (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.eventKey) !== null && _eventKey !== void 0 ? _eventKey : key;
            var emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = "tmp_key-".concat([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keyPath), [
                index
            ]).join("-"));
            var cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $acw62.cloneElement(child, cloneProps);
        }
        return child;
    });
}








var $acw62 = parcelRequire("acw62");




var $cf5eb12962f7aceb$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $cf5eb12962f7aceb$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    }
};
var $cf5eb12962f7aceb$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $cf5eb12962f7aceb$var$autoAdjustOverflow
    }
};
var $cf5eb12962f7aceb$export$2e2bcd8739ae039 = $cf5eb12962f7aceb$export$803cd8101b6c182b;


function $aa6d1d843f423253$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


var $9673b769529d0dd1$var$popupPlacementMap = {
    horizontal: "bottomLeft",
    vertical: "rightTop",
    "vertical-left": "rightTop",
    "vertical-right": "leftTop"
};
function $9673b769529d0dd1$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, visible = _ref.visible, children = _ref.children, popup = _ref.popup, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupOffset = _ref.popupOffset, disabled = _ref.disabled, mode = _ref.mode, onVisibleChange = _ref.onVisibleChange;
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), getPopupContainer = _React$useContext.getPopupContainer, rtl = _React$useContext.rtl, subMenuOpenDelay = _React$useContext.subMenuOpenDelay, subMenuCloseDelay = _React$useContext.subMenuCloseDelay, builtinPlacements = _React$useContext.builtinPlacements, triggerSubMenuAction = _React$useContext.triggerSubMenuAction, forceSubMenuRender = _React$useContext.forceSubMenuRender, rootClassName = _React$useContext.rootClassName, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), innerVisible = _React$useState2[0], setInnerVisible = _React$useState2[1];
    var placement = rtl ? (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $cf5eb12962f7aceb$export$e2b3f69b0a16e1f)), builtinPlacements) : (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $cf5eb12962f7aceb$export$803cd8101b6c182b)), builtinPlacements);
    var popupPlacement = $9673b769529d0dd1$var$popupPlacementMap[mode];
    var targetMotion = (0, $aa6d1d843f423253$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    var targetMotionRef = $acw62.useRef(targetMotion);
    if (mode !== "inline") /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    var mergedMotion = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, targetMotionRef.current), {}, {
        leavedClassName: "".concat(prefixCls, "-hidden"),
        removeOnLeave: false,
        motionAppear: true
    });
    // Delay to change visible
    var visibleRef = $acw62.useRef();
    $acw62.useEffect(function() {
        visibleRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            setInnerVisible(visible);
        });
        return function() {
            (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $a99c76d30a1f506f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-popup"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-rtl"), rtl), popupClassName, rootClassName),
        stretch: mode === "horizontal" ? "minWidth" : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}










var $acw62 = parcelRequire("acw62");




function $107e5113551bc6e9$export$2e2bcd8739ae039(_ref) {
    var id = _ref.id, open = _ref.open, keyPath = _ref.keyPath, children = _ref.children;
    var fixedMode = "inline";
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, forceSubMenuRender = _React$useContext.forceSubMenuRender, motion = _React$useContext.motion, defaultMotions = _React$useContext.defaultMotions, mode = _React$useContext.mode;
    // Always use latest mode check
    var sameModeRef = $acw62.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    var _React$useState = $acw62.useState(!sameModeRef.current), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), destroy = _React$useState2[0], setDestroy = _React$useState2[1];
    var mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $acw62.useEffect(function() {
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    var mergedMotion = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $aa6d1d843f423253$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions));
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    var originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = function(newVisible) {
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged === null || originOnVisibleChanged === void 0 ? void 0 : originOnVisibleChanged(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $24a4386da4a32dce$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }), function(_ref2) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement((0, $ad0e9c8fde51e397$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





var $c14a300ca0685832$var$_excluded = [
    "style",
    "className",
    "title",
    "eventKey",
    "warnKey",
    "disabled",
    "internalPopupClose",
    "children",
    "itemIcon",
    "expandIcon",
    "popupClassName",
    "popupOffset",
    "popupStyle",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onTitleClick",
    "onTitleMouseEnter",
    "onTitleMouseLeave"
], $c14a300ca0685832$var$_excluded2 = [
    "active"
];
var $c14a300ca0685832$var$InternalSubMenu = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _classNames;
    var style = props.style, className = props.className, title = props.title, eventKey = props.eventKey, warnKey = props.warnKey, disabled = props.disabled, internalPopupClose = props.internalPopupClose, children = props.children, itemIcon = props.itemIcon, expandIcon = props.expandIcon, popupClassName = props.popupClassName, popupOffset = props.popupOffset, popupStyle = props.popupStyle, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onTitleClick = props.onTitleClick, onTitleMouseEnter = props.onTitleMouseEnter, onTitleMouseLeave = props.onTitleMouseLeave, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $c14a300ca0685832$var$_excluded);
    var domDataId = (0, $9c2ff7221738ac19$export$a276eb4e9be640f8)(eventKey);
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls, mode = _React$useContext.mode, openKeys = _React$useContext.openKeys, contextDisabled = _React$useContext.disabled, overflowDisabled = _React$useContext.overflowDisabled, activeKey = _React$useContext.activeKey, selectedKeys = _React$useContext.selectedKeys, contextItemIcon = _React$useContext.itemIcon, contextExpandIcon = _React$useContext.expandIcon, onItemClick = _React$useContext.onItemClick, onOpenChange = _React$useContext.onOpenChange, onActive = _React$useContext.onActive;
    var _React$useContext2 = $acw62.useContext((0, $db67f8032758903f$export$2e2bcd8739ae039)), _internalRenderSubMenuItem = _React$useContext2._internalRenderSubMenuItem;
    var _React$useContext3 = $acw62.useContext((0, $76292f3495da88ff$export$f0b9e0db98edfa53)), isSubPathKey = _React$useContext3.isSubPathKey;
    var connectedPath = (0, $76292f3495da88ff$export$d3d2d0a05677870a)();
    var subMenuPrefixCls = "".concat(prefixCls, "-submenu");
    var mergedDisabled = contextDisabled || disabled;
    var elementRef = $acw62.useRef();
    var popupRef = $acw62.useRef();
    // ================================ Icon ================================
    var mergedItemIcon = itemIcon !== null && itemIcon !== void 0 ? itemIcon : contextItemIcon;
    var mergedExpandIcon = expandIcon !== null && expandIcon !== void 0 ? expandIcon : contextExpandIcon;
    // ================================ Open ================================
    var originOpen = openKeys.includes(eventKey);
    var open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    var childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    var _useActive = (0, $a649e094df404c52$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave), active = _useActive.active, activeProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_useActive, $c14a300ca0685832$var$_excluded2);
    // Fallback of active check to avoid hover on menu title or disabled item
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), childrenActive = _React$useState2[0], setChildrenActive = _React$useState2[1];
    var triggerChildrenActive = function triggerChildrenActive(newActive) {
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(domEvent) {
        triggerChildrenActive(true);
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var onInternalMouseLeave = function onInternalMouseLeave(domEvent) {
        triggerChildrenActive(false);
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
            key: eventKey,
            domEvent: domEvent
        });
    };
    var mergedActive = $acw62.useMemo(function() {
        if (active) return active;
        if (mode !== "inline") return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    var directionStyle = (0, $551f98bff3692876$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    var onInternalTitleClick = function onInternalTitleClick(e) {
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick === null || onTitleClick === void 0 || onTitleClick({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === "inline") onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    var onMergedItemClick = (0, $f79f42a79a2878d1$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $124c89870f2be225$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    var onPopupVisibleChange = function onPopupVisibleChange(newVisible) {
        if (mode !== "inline") onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ var onInternalFocus = function onInternalFocus() {
        onActive(eventKey);
    };
    // =============================== Render ===============================
    var popupId = domDataId && "".concat(domDataId, "-popup");
    // >>>>> Title
    var titleNode = /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "menuitem",
        style: directionStyle,
        className: "".concat(subMenuPrefixCls, "-title"),
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === "string" ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, /*#__PURE__*/ $acw62.createElement((0, $c3c54e71b725e1ff$export$2e2bcd8739ae039), {
        icon: mode !== "horizontal" ? mergedExpandIcon : undefined,
        props: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
            isOpen: open,
            // [Legacy] Not sure why need this mark
            isSubMenu: true
        })
    }, /*#__PURE__*/ $acw62.createElement("i", {
        className: "".concat(subMenuPrefixCls, "-arrow")
    })));
    // Cache mode if it change to `inline` which do not have popup motion
    var triggerModeRef = $acw62.useRef(mode);
    if (mode !== "inline" && connectedPath.length > 1) triggerModeRef.current = "vertical";
    else triggerModeRef.current = mode;
    if (!overflowDisabled) {
        var triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $acw62.createElement((0, $9673b769529d0dd1$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== "inline",
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: /*#__PURE__*/ $acw62.createElement((0, $24a4386da4a32dce$export$2e2bcd8739ae039), {
                mode: triggerMode === "horizontal" ? "vertical" : triggerMode
            }, /*#__PURE__*/ $acw62.createElement((0, $ad0e9c8fde51e397$export$2e2bcd8739ae039), {
                id: popupId,
                ref: popupRef
            }, children)),
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    var listNode = /*#__PURE__*/ $acw62.createElement((0, $4863ed3a14942ec4$export$2e2bcd8739ae039).Item, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(subMenuPrefixCls, "".concat(subMenuPrefixCls, "-").concat(mode), className, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-open"), open), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-active"), mergedActive), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-selected"), childrenSelected), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(subMenuPrefixCls, "-disabled"), mergedDisabled), _classNames)),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $acw62.createElement((0, $107e5113551bc6e9$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $24a4386da4a32dce$export$2e2bcd8739ae039), {
        onItemClick: onMergedItemClick,
        mode: mode === "horizontal" ? "vertical" : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
var $c14a300ca0685832$var$SubMenu = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $76292f3495da88ff$export$d3d2d0a05677870a)(eventKey);
    var childList = (0, $152cdddbd0a33c22$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    var measure = (0, $76292f3495da88ff$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $acw62.useEffect(function() {
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return function() {
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    var renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $acw62.createElement($c14a300ca0685832$var$InternalSubMenu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $acw62.createElement((0, $76292f3495da88ff$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
var $c14a300ca0685832$export$2e2bcd8739ae039 = $c14a300ca0685832$var$SubMenu;







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



function $db65e601ae4bf633$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, style = _ref.style;
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var measure = (0, $76292f3495da88ff$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $acw62.createElement("li", {
        role: "separator",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-item-divider"), className),
        style: style
    });
}








var $acw62 = parcelRequire("acw62");



var $73334e01b4c90e74$var$_excluded = [
    "className",
    "title",
    "eventKey",
    "children"
];
var $73334e01b4c90e74$var$InternalMenuItemGroup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var className = props.className, title = props.title, eventKey = props.eventKey, children = props.children, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $73334e01b4c90e74$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $24a4386da4a32dce$export$c7e742effb1c51e2)), prefixCls = _React$useContext.prefixCls;
    var groupPrefixCls = "".concat(prefixCls, "-item-group");
    return /*#__PURE__*/ $acw62.createElement("li", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: function onClick(e) {
            return e.stopPropagation();
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(groupPrefixCls, className)
    }), /*#__PURE__*/ $acw62.createElement("div", {
        role: "presentation",
        className: "".concat(groupPrefixCls, "-title"),
        title: typeof title === "string" ? title : undefined
    }, title), /*#__PURE__*/ $acw62.createElement("ul", {
        role: "group",
        className: "".concat(groupPrefixCls, "-list")
    }, children));
});
var $73334e01b4c90e74$var$MenuItemGroup = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var eventKey = props.eventKey, children = props.children;
    var connectedKeyPath = (0, $76292f3495da88ff$export$d3d2d0a05677870a)(eventKey);
    var childList = (0, $152cdddbd0a33c22$export$cd230e97e668be9)(children, connectedKeyPath);
    var measure = (0, $76292f3495da88ff$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $acw62.createElement($73334e01b4c90e74$var$InternalMenuItemGroup, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "warnKey"
    ])), childList);
});
var $73334e01b4c90e74$export$2e2bcd8739ae039 = $73334e01b4c90e74$var$MenuItemGroup;




var $fa82369bcec373f6$var$_excluded = [
    "label",
    "children",
    "key",
    "type"
];
function $fa82369bcec373f6$var$convertItemsToNodes(list, components) {
    var MergedMenuItem = components.item, MergedMenuItemGroup = components.group, MergedSubMenu = components.submenu, MergedDivider = components.divider;
    return (list || []).map(function(opt, index) {
        if (opt && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(opt) === "object") {
            var _ref = opt, label = _ref.label, children = _ref.children, key = _ref.key, type = _ref.type, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $fa82369bcec373f6$var$_excluded);
            var mergedKey = key !== null && key !== void 0 ? key : "tmp-".concat(index);
            // MenuItemGroup & SubMenuItem
            if (children || type === "group") {
                if (type === "group") // Group
                return /*#__PURE__*/ $acw62.createElement(MergedMenuItemGroup, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $fa82369bcec373f6$var$convertItemsToNodes(children, components));
                // Sub Menu
                return /*#__PURE__*/ $acw62.createElement(MergedSubMenu, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $fa82369bcec373f6$var$convertItemsToNodes(children, components));
            }
            // MenuItem & Divider
            if (type === "divider") return /*#__PURE__*/ $acw62.createElement(MergedDivider, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ $acw62.createElement(MergedMenuItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                key: mergedKey
            }, restProps), label);
        }
        return null;
    }).filter(function(opt) {
        return opt;
    });
}
function $fa82369bcec373f6$export$50458dc1a9a0f894(children, items, keyPath, components) {
    var childNodes = children;
    var mergedComponents = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        divider: (0, $db65e601ae4bf633$export$2e2bcd8739ae039),
        item: (0, $c59b5fb169e5cf0f$export$2e2bcd8739ae039),
        group: (0, $73334e01b4c90e74$export$2e2bcd8739ae039),
        submenu: (0, $c14a300ca0685832$export$2e2bcd8739ae039)
    }, components);
    if (items) childNodes = $fa82369bcec373f6$var$convertItemsToNodes(items, mergedComponents);
    return (0, $152cdddbd0a33c22$export$cd230e97e668be9)(childNodes, keyPath);
}



var $c301bc30ecc557ca$var$_excluded = [
    "prefixCls",
    "rootClassName",
    "style",
    "className",
    "tabIndex",
    "items",
    "children",
    "direction",
    "id",
    "mode",
    "inlineCollapsed",
    "disabled",
    "disabledOverflow",
    "subMenuOpenDelay",
    "subMenuCloseDelay",
    "forceSubMenuRender",
    "defaultOpenKeys",
    "openKeys",
    "activeKey",
    "defaultActiveFirst",
    "selectable",
    "multiple",
    "defaultSelectedKeys",
    "selectedKeys",
    "onSelect",
    "onDeselect",
    "inlineIndent",
    "motion",
    "defaultMotions",
    "triggerSubMenuAction",
    "builtinPlacements",
    "itemIcon",
    "expandIcon",
    "overflowedIndicator",
    "overflowedIndicatorPopupClassName",
    "getPopupContainer",
    "onClick",
    "onOpenChange",
    "onKeyDown",
    "openAnimation",
    "openTransitionName",
    "_internalRenderMenuItem",
    "_internalRenderSubMenuItem",
    "_internalComponents"
];
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
var $c301bc30ecc557ca$var$EMPTY_LIST = [];
var $c301bc30ecc557ca$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _childList$, _classNames;
    var _ref = props, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-menu" : _ref$prefixCls, rootClassName = _ref.rootClassName, style = _ref.style, className = _ref.className, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex, items = _ref.items, children = _ref.children, direction = _ref.direction, id = _ref.id, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "vertical" : _ref$mode, inlineCollapsed = _ref.inlineCollapsed, disabled = _ref.disabled, disabledOverflow = _ref.disabledOverflow, _ref$subMenuOpenDelay = _ref.subMenuOpenDelay, subMenuOpenDelay = _ref$subMenuOpenDelay === void 0 ? 0.1 : _ref$subMenuOpenDelay, _ref$subMenuCloseDela = _ref.subMenuCloseDelay, subMenuCloseDelay = _ref$subMenuCloseDela === void 0 ? 0.1 : _ref$subMenuCloseDela, forceSubMenuRender = _ref.forceSubMenuRender, defaultOpenKeys = _ref.defaultOpenKeys, openKeys = _ref.openKeys, activeKey = _ref.activeKey, defaultActiveFirst = _ref.defaultActiveFirst, _ref$selectable = _ref.selectable, selectable = _ref$selectable === void 0 ? true : _ref$selectable, _ref$multiple = _ref.multiple, multiple = _ref$multiple === void 0 ? false : _ref$multiple, defaultSelectedKeys = _ref.defaultSelectedKeys, selectedKeys = _ref.selectedKeys, onSelect = _ref.onSelect, onDeselect = _ref.onDeselect, _ref$inlineIndent = _ref.inlineIndent, inlineIndent = _ref$inlineIndent === void 0 ? 24 : _ref$inlineIndent, motion = _ref.motion, defaultMotions = _ref.defaultMotions, _ref$triggerSubMenuAc = _ref.triggerSubMenuAction, triggerSubMenuAction = _ref$triggerSubMenuAc === void 0 ? "hover" : _ref$triggerSubMenuAc, builtinPlacements = _ref.builtinPlacements, itemIcon = _ref.itemIcon, expandIcon = _ref.expandIcon, _ref$overflowedIndica = _ref.overflowedIndicator, overflowedIndicator = _ref$overflowedIndica === void 0 ? "..." : _ref$overflowedIndica, overflowedIndicatorPopupClassName = _ref.overflowedIndicatorPopupClassName, getPopupContainer = _ref.getPopupContainer, onClick = _ref.onClick, onOpenChange = _ref.onOpenChange, onKeyDown = _ref.onKeyDown, openAnimation = _ref.openAnimation, openTransitionName = _ref.openTransitionName, _internalRenderMenuItem = _ref._internalRenderMenuItem, _internalRenderSubMenuItem = _ref._internalRenderSubMenuItem, _internalComponents = _ref._internalComponents, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $c301bc30ecc557ca$var$_excluded);
    var _React$useMemo = $acw62.useMemo(function() {
        return [
            (0, $fa82369bcec373f6$export$50458dc1a9a0f894)(children, items, $c301bc30ecc557ca$var$EMPTY_LIST, _internalComponents),
            (0, $fa82369bcec373f6$export$50458dc1a9a0f894)(children, items, $c301bc30ecc557ca$var$EMPTY_LIST, {})
        ];
    }, [
        children,
        items,
        _internalComponents
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), childList = _React$useMemo2[0], measureChildList = _React$useMemo2[1];
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), mounted = _React$useState2[0], setMounted = _React$useState2[1];
    var containerRef = $acw62.useRef();
    var uuid = (0, $610565fd72f5965a$export$2e2bcd8739ae039)(id);
    var isRtl = direction === "rtl";
    // ========================= Open =========================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultOpenKeys, {
        value: openKeys,
        postState: function postState(keys) {
            return keys || $c301bc30ecc557ca$var$EMPTY_LIST;
        }
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedOpenKeys = _useMergedState2[0], setMergedOpenKeys = _useMergedState2[1];
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    var triggerOpenKeys = function triggerOpenKeys(keys) {
        var forceFlush = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(keys);
        }
        if (forceFlush) (0, $11492dca620dcaa5$exports.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    var _React$useState3 = $acw62.useState(mergedOpenKeys), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), inlineCacheOpenKeys = _React$useState4[0], setInlineCacheOpenKeys = _React$useState4[1];
    var mountRef = $acw62.useRef(false);
    // ========================= Mode =========================
    var _React$useMemo3 = $acw62.useMemo(function() {
        if ((mode === "inline" || mode === "vertical") && inlineCollapsed) return [
            "vertical",
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]), _React$useMemo4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo3, 2), mergedMode = _React$useMemo4[0], mergedInlineCollapsed = _React$useMemo4[1];
    var isInlineMode = mergedMode === "inline";
    var _React$useState5 = $acw62.useState(mergedMode), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), internalMode = _React$useState6[0], setInternalMode = _React$useState6[1];
    var _React$useState7 = $acw62.useState(mergedInlineCollapsed), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), internalInlineCollapsed = _React$useState8[0], setInternalInlineCollapsed = _React$useState8[1];
    $acw62.useEffect(function() {
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($c301bc30ecc557ca$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    var _React$useState9 = $acw62.useState(0), _React$useState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState9, 2), lastVisibleIndex = _React$useState10[0], setLastVisibleIndex = _React$useState10[1];
    var allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== "horizontal" || disabledOverflow;
    // Cache
    $acw62.useEffect(function() {
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $acw62.useEffect(function() {
        mountRef.current = true;
        return function() {
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    var _useKeyRecords = (0, $91daccd328800b8c$export$2e2bcd8739ae039)(), registerPath = _useKeyRecords.registerPath, unregisterPath = _useKeyRecords.unregisterPath, refreshOverflowKeys = _useKeyRecords.refreshOverflowKeys, isSubPathKey = _useKeyRecords.isSubPathKey, getKeyPath = _useKeyRecords.getKeyPath, getKeys = _useKeyRecords.getKeys, getSubPathKeys = _useKeyRecords.getSubPathKeys;
    var registerPathContext = $acw62.useMemo(function() {
        return {
            registerPath: registerPath,
            unregisterPath: unregisterPath
        };
    }, [
        registerPath,
        unregisterPath
    ]);
    var pathUserContext = $acw62.useMemo(function() {
        return {
            isSubPathKey: isSubPathKey
        };
    }, [
        isSubPathKey
    ]);
    $acw62.useEffect(function() {
        refreshOverflowKeys(allVisible ? $c301bc30ecc557ca$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map(function(child) {
            return child.key;
        }));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    var _useMergedState3 = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(activeKey || defaultActiveFirst && ((_childList$ = childList[0]) === null || _childList$ === void 0 ? void 0 : _childList$.key), {
        value: activeKey
    }), _useMergedState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState3, 2), mergedActiveKey = _useMergedState4[0], setMergedActiveKey = _useMergedState4[1];
    var onActive = (0, $f79f42a79a2878d1$export$2e2bcd8739ae039)(function(key) {
        setMergedActiveKey(key);
    });
    var onInactive = (0, $f79f42a79a2878d1$export$2e2bcd8739ae039)(function() {
        setMergedActiveKey(undefined);
    });
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            list: containerRef.current,
            focus: function focus(options) {
                var _childList$find;
                var keys = getKeys();
                var _refreshElements = (0, $6782197159192667$export$20827b68c762d23)(keys, uuid), elements = _refreshElements.elements, key2element = _refreshElements.key2element, element2key = _refreshElements.element2key;
                var focusableElements = (0, $6782197159192667$export$433aaa1f216cf32d)(containerRef.current, elements);
                var shouldFocusKey = mergedActiveKey !== null && mergedActiveKey !== void 0 ? mergedActiveKey : focusableElements[0] ? element2key.get(focusableElements[0]) : (_childList$find = childList.find(function(node) {
                    return !node.props.disabled;
                })) === null || _childList$find === void 0 ? void 0 : _childList$find.key;
                var elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) {
                    var _elementToFocus$focus;
                    elementToFocus === null || elementToFocus === void 0 || (_elementToFocus$focus = elementToFocus.focus) === null || _elementToFocus$focus === void 0 || _elementToFocus$focus.call(elementToFocus, options);
                }
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    var _useMergedState5 = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultSelectedKeys || [], {
        value: selectedKeys,
        // Legacy convert key to array
        postState: function postState(keys) {
            if (Array.isArray(keys)) return keys;
            if (keys === null || keys === undefined) return $c301bc30ecc557ca$var$EMPTY_LIST;
            return [
                keys
            ];
        }
    }), _useMergedState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState5, 2), mergedSelectKeys = _useMergedState6[0], setMergedSelectKeys = _useMergedState6[1];
    // >>>>> Trigger select
    var triggerSelection = function triggerSelection(info) {
        if (selectable) {
            // Insert or Remove
            var targetKey = info.key;
            var exist = mergedSelectKeys.includes(targetKey);
            var newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter(function(key) {
                    return key !== targetKey;
                });
                else newSelectKeys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedSelectKeys), [
                    targetKey
                ]);
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            var selectInfo = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, info), {}, {
                selectedKeys: newSelectKeys
            });
            if (exist) onDeselect === null || onDeselect === void 0 || onDeselect(selectInfo);
            else onSelect === null || onSelect === void 0 || onSelect(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== "inline") triggerOpenKeys($c301bc30ecc557ca$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ var onInternalClick = (0, $f79f42a79a2878d1$export$2e2bcd8739ae039)(function(info) {
        onClick === null || onClick === void 0 || onClick((0, $124c89870f2be225$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    var onInternalOpenChange = (0, $f79f42a79a2878d1$export$2e2bcd8739ae039)(function(key, open) {
        var newOpenKeys = mergedOpenKeys.filter(function(k) {
            return k !== key;
        });
        if (open) newOpenKeys.push(key);
        else if (internalMode !== "inline") {
            // We need find all related popup to close
            var subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter(function(k) {
                return !subPathKeys.has(k);
            });
        }
        if (!(0, $357adc8667cde522$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    var triggerAccessibilityOpen = function triggerAccessibilityOpen(key, open) {
        var nextOpen = open !== null && open !== void 0 ? open : !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    var onInternalKeyDown = (0, $6782197159192667$export$aa6de64279d64603)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $acw62.useEffect(function() {
        setMounted(true);
    }, []);
    // ======================= Context ========================
    var privateContext = $acw62.useMemo(function() {
        return {
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        };
    }, [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    var wrappedChildList = internalMode !== "horizontal" || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map(function(child, index) {
        return(/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $acw62.createElement((0, $24a4386da4a32dce$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex
        }, child));
    });
    // >>>>> Container
    var container = /*#__PURE__*/ $acw62.createElement((0, $4863ed3a14942ec4$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: id,
        ref: containerRef,
        prefixCls: "".concat(prefixCls, "-overflow"),
        component: "ul",
        itemComponent: (0, $c59b5fb169e5cf0f$export$2e2bcd8739ae039),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, "".concat(prefixCls, "-root"), "".concat(prefixCls, "-").concat(internalMode), className, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-inline-collapsed"), internalInlineCollapsed), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-rtl"), isRtl), _classNames), rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: function renderRawItem(node) {
            return node;
        },
        renderRawRest: function renderRawRest(omitItems) {
            // We use origin list since wrapped list use context to prevent open
            var len = omitItems.length;
            var originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $acw62.createElement((0, $c14a300ca0685832$export$2e2bcd8739ae039), {
                eventKey: (0, $91daccd328800b8c$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== "horizontal" || disabledOverflow ? (0, $4863ed3a14942ec4$export$2e2bcd8739ae039).INVALIDATE : (0, $4863ed3a14942ec4$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: function onVisibleChange(newLastIndex) {
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $acw62.createElement((0, $db67f8032758903f$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $acw62.createElement((0, $9c2ff7221738ac19$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $acw62.createElement((0, $24a4386da4a32dce$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange
    }, /*#__PURE__*/ $acw62.createElement((0, $76292f3495da88ff$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            display: "none"
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $acw62.createElement((0, $76292f3495da88ff$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $c301bc30ecc557ca$export$2e2bcd8739ae039 = $c301bc30ecc557ca$var$Menu;







var $b187593cf569a182$var$ExportMenu = (0, $c301bc30ecc557ca$export$2e2bcd8739ae039);
$b187593cf569a182$var$ExportMenu.Item = (0, $c59b5fb169e5cf0f$export$2e2bcd8739ae039);
$b187593cf569a182$var$ExportMenu.SubMenu = (0, $c14a300ca0685832$export$2e2bcd8739ae039);
$b187593cf569a182$var$ExportMenu.ItemGroup = (0, $73334e01b4c90e74$export$2e2bcd8739ae039);
$b187593cf569a182$var$ExportMenu.Divider = (0, $db65e601ae4bf633$export$2e2bcd8739ae039);
var $b187593cf569a182$export$2e2bcd8739ae039 = $b187593cf569a182$var$ExportMenu;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b54d53674fa39ea0$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
var $b54d53674fa39ea0$export$2e2bcd8739ae039 = $b54d53674fa39ea0$var$BarsOutlined;



var $8b88bbac7ec7b356$var$BarsOutlined = function BarsOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $b54d53674fa39ea0$export$2e2bcd8739ae039)
    }));
};
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ var $8b88bbac7ec7b356$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($8b88bbac7ec7b356$var$BarsOutlined);
var $8b88bbac7ec7b356$export$2e2bcd8739ae039 = $8b88bbac7ec7b356$var$RefIcon;






const $b951a1015ade6f8d$var$isNumeric = (value)=>!isNaN(parseFloat(value)) && isFinite(value);
var $b951a1015ade6f8d$export$2e2bcd8739ae039 = $b951a1015ade6f8d$var$isNumeric;




var $acw62 = parcelRequire("acw62");
const $368377cf0f14dd00$export$964282a2c3979546 = /*#__PURE__*/ $acw62.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});


"use client";
var $f4e67dbf2453f541$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f4e67dbf2453f541$var$dimensionMaxMap = {
    xs: "479.98px",
    sm: "575.98px",
    md: "767.98px",
    lg: "991.98px",
    xl: "1199.98px",
    xxl: "1599.98px"
};
const $f4e67dbf2453f541$export$63554aebd2a6d54c = /*#__PURE__*/ $acw62.createContext({});
const $f4e67dbf2453f541$var$generateId = (()=>{
    let i = 0;
    return function() {
        let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $f4e67dbf2453f541$var$Sider = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = "dark", style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint } = props, otherProps = $f4e67dbf2453f541$var$__rest(props, [
        "prefixCls",
        "className",
        "trigger",
        "children",
        "defaultCollapsed",
        "theme",
        "style",
        "collapsible",
        "reverseArrow",
        "width",
        "collapsedWidth",
        "zeroWidthTriggerStyle",
        "breakpoint",
        "onCollapse",
        "onBreakpoint"
    ]);
    const { siderHook: siderHook } = (0, $acw62.useContext)((0, $368377cf0f14dd00$export$964282a2c3979546));
    const [collapsed, setCollapsed] = (0, $acw62.useState)("collapsed" in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if ("collapsed" in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!("collapsed" in props)) setCollapsed(value);
        onCollapse === null || onCollapse === void 0 || onCollapse(value, type);
    };
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $acw62.useRef)();
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint === null || onBreakpoint === void 0 || onBreakpoint(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, "responsive");
    };
    (0, $acw62.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current(mql);
        }
        let mql;
        if (typeof window !== "undefined") {
            const { matchMedia: matchMedia } = window;
            if (matchMedia && breakpoint && breakpoint in $f4e67dbf2453f541$var$dimensionMaxMap) {
                mql = matchMedia(`screen and (max-width: ${$f4e67dbf2453f541$var$dimensionMaxMap[breakpoint]})`);
                try {
                    mql.addEventListener("change", responsiveHandler);
                } catch (error) {
                    mql.addListener(responsiveHandler);
                }
                responsiveHandler(mql);
            }
        }
        return ()=>{
            try {
                mql === null || mql === void 0 || mql.removeEventListener("change", responsiveHandler);
            } catch (error) {
                mql === null || mql === void 0 || mql.removeListener(responsiveHandler);
            }
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $acw62.useEffect)(()=>{
        const uniqueId = $f4e67dbf2453f541$var$generateId("ant-sider-");
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, "clickTrigger");
    };
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const renderSider = ()=>{
        const prefixCls = getPrefixCls("layout-sider", customizePrefixCls);
        const divProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(otherProps, [
            "collapsed"
        ]);
        const rawWidth = collapsed ? collapsedWidth : width;
        // use "px" as fallback unit for width
        const siderWidth = (0, $b951a1015ade6f8d$export$2e2bcd8739ae039)(rawWidth) ? `${rawWidth}px` : String(rawWidth);
        // special trigger when collapsedWidth == 0
        const zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $acw62.createElement("span", {
            onClick: toggle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? "right" : "left"}`),
            style: zeroWidthTriggerStyle
        }, trigger || /*#__PURE__*/ $acw62.createElement((0, $8b88bbac7ec7b356$export$2e2bcd8739ae039), null)) : null;
        const iconObj = {
            expanded: reverseArrow ? /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null),
            collapsed: reverseArrow ? /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null)
        };
        const status = collapsed ? "collapsed" : "expanded";
        const defaultTrigger = iconObj[status];
        const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-trigger`,
            onClick: toggle,
            style: {
                width: siderWidth
            }
        }, trigger || defaultTrigger) : null;
        const divStyle = Object.assign(Object.assign({}, style), {
            flex: `0 0 ${siderWidth}`,
            maxWidth: siderWidth,
            minWidth: siderWidth,
            width: siderWidth
        });
        const siderCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-${theme}`, {
            [`${prefixCls}-collapsed`]: !!collapsed,
            [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
            [`${prefixCls}-below`]: !!below,
            [`${prefixCls}-zero-width`]: parseFloat(siderWidth) === 0
        }, className);
        return /*#__PURE__*/ $acw62.createElement("aside", Object.assign({
            className: siderCls
        }, divProps, {
            style: divStyle,
            ref: ref
        }), /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-children`
        }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null);
    };
    const contextValue = $acw62.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return /*#__PURE__*/ $acw62.createElement($f4e67dbf2453f541$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, renderSider());
});
var $f4e67dbf2453f541$export$2e2bcd8739ae039 = $f4e67dbf2453f541$var$Sider;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $bf122e88db242cab$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
var $bf122e88db242cab$export$2e2bcd8739ae039 = $bf122e88db242cab$var$EllipsisOutlined;



var $18b92a77e6b0d38f$var$EllipsisOutlined = function EllipsisOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $bf122e88db242cab$export$2e2bcd8739ae039)
    }));
};
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ var $18b92a77e6b0d38f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($18b92a77e6b0d38f$var$EllipsisOutlined);
var $18b92a77e6b0d38f$export$2e2bcd8739ae039 = $18b92a77e6b0d38f$var$RefIcon;












var $acw62 = parcelRequire("acw62");
"use client";
const $f1be9e89e34926b1$var$MenuContext = /*#__PURE__*/ (0, $acw62.createContext)({
    prefixCls: "",
    firstLevel: true,
    inlineCollapsed: false
});
var $f1be9e89e34926b1$export$2e2bcd8739ae039 = $f1be9e89e34926b1$var$MenuContext;



var $acw62 = parcelRequire("acw62");



"use client";
var $d26f09d6992ff5d8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d26f09d6992ff5d8$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed } = props, restProps = $d26f09d6992ff5d8$var$__rest(props, [
        "prefixCls",
        "className",
        "dashed"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("menu", customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $acw62.createElement((0, $db65e601ae4bf633$export$2e2bcd8739ae039), Object.assign({
        className: classString
    }, restProps));
};
var $d26f09d6992ff5d8$export$2e2bcd8739ae039 = $d26f09d6992ff5d8$var$MenuDivider;



var $acw62 = parcelRequire("acw62");








"use client";
const $8955a62aec0d8484$var$MenuItem = (props)=>{
    var _a;
    const { className: className, children: children, icon: icon, title: title, danger: danger } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, inlineCollapsed: isInlineCollapsed } = $acw62.useContext((0, $f1be9e89e34926b1$export$2e2bcd8739ae039));
    const renderItemChildren = (inlineCollapsed)=>{
        const wrapNode = /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-title-content`
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $acw62.isValidElement(children) && children.type === "span") {
            if (children && inlineCollapsed && firstLevel && typeof children === "string") return /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, children.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed: siderCollapsed } = $acw62.useContext((0, $f4e67dbf2453f541$export$63554aebd2a6d54c));
    let tooltipTitle = title;
    if (typeof title === "undefined") tooltipTitle = firstLevel ? children : "";
    else if (title === false) tooltipTitle = "";
    const tooltipProps = {
        title: tooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children).length;
    let returnNode = /*#__PURE__*/ $acw62.createElement((0, $c59b5fb169e5cf0f$export$2e2bcd8739ae039), Object.assign({}, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "title",
        "icon",
        "danger"
    ]), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        title: typeof title === "string" ? title : undefined
    }), (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(/*#__PURE__*/ $acw62.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : "", `${prefixCls}-item-icon`)
    }), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
        placement: direction === "rtl" ? "left" : "right",
        overlayClassName: `${prefixCls}-inline-collapsed-tooltip`
    }), returnNode);
    return returnNode;
};
var $8955a62aec0d8484$export$2e2bcd8739ae039 = $8955a62aec0d8484$var$MenuItem;



var $acw62 = parcelRequire("acw62");


"use client";
var $798e9781cc841bf2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $798e9781cc841bf2$var$OverrideContext = /*#__PURE__*/ $acw62.createContext(null);
const $798e9781cc841bf2$export$9bd434816b0530d0 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { children: children } = props, restProps = $798e9781cc841bf2$var$__rest(props, [
        "children"
    ]);
    const override = $acw62.useContext($798e9781cc841bf2$var$OverrideContext);
    const context = $acw62.useMemo(()=>Object.assign(Object.assign({}, override), restProps), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $5e297877593af644$export$b51ae67c7882a242)(children);
    const mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(ref, canRef ? children.ref : null);
    return /*#__PURE__*/ $acw62.createElement($798e9781cc841bf2$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        space: true
    }, canRef ? /*#__PURE__*/ $acw62.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $798e9781cc841bf2$export$2e2bcd8739ae039 = $798e9781cc841bf2$var$OverrideContext;








const $538c6177909b715a$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: "none",
            "&::after": {
                display: "block",
                clear: "both",
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: "relative",
                display: "inline-block",
                verticalAlign: "bottom",
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: "transparent"
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color ${motionDurationSlow}`,
                    `background ${motionDurationSlow}`
                ].join(",")
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: "none"
            }
        }
    };
};
var $538c6177909b715a$export$2e2bcd8739ae039 = $538c6177909b715a$var$getHorizontalStyle;



const $99ca4130ddbe9d7a$var$getRTLStyle = (_ref)=>{
    let { componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc } = _ref;
    return {
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: "100% 0"
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                "&::before": {
                    transform: `rotate(-45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                "&::after": {
                    transform: `rotate(45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    };
};
var $99ca4130ddbe9d7a$export$2e2bcd8739ae039 = $99ca4130ddbe9d7a$var$getRTLStyle;




const $e091dfcd5daa8c55$var$accessibilityFocus = (token)=>Object.assign({}, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token));
const $e091dfcd5daa8c55$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: Object.assign({}, $e091dfcd5daa8c55$var$accessibilityFocus(token)),
            // ======================== Item ========================
            [`${componentCls}-item-group-title`]: {
                color: groupTitleColor
            },
            [`${componentCls}-submenu-selected`]: {
                [`> ${componentCls}-submenu-title`]: {
                    color: itemSelectedColor
                }
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: Object.assign({}, $e091dfcd5daa8c55$var$accessibilityFocus(token))
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    "&:hover": {
                        backgroundColor: itemHoverBg
                    },
                    "&:active": {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    "&:hover": {
                        backgroundColor: itemHoverBg
                    },
                    "&:active": {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                "&, &:hover": {
                    color: "inherit"
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                "a, a:hover": {
                    color: "inherit"
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: Object.assign(Object.assign({}, themeSuffix === "dark" ? {
                borderBottom: 0
            } : {}), {
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    "&::after": {
                        position: "absolute",
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    "&:hover, &-active, &-open": {
                        background: horizontalItemHoverBg,
                        "&::after": {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    "&-selected": {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        "&:hover": {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        "&::after": {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            }),
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: "relative",
                    "&::after": {
                        position: "absolute",
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: "scaleY(0.0001)",
                        opacity: 0,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseOut}`,
                            `opacity ${motionDurationMid} ${motionEaseOut}`
                        ].join(","),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        "&::after": {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    "&::after": {
                        transform: "scaleY(1)",
                        opacity: 1,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseInOut}`,
                            `opacity ${motionDurationMid} ${motionEaseInOut}`
                        ].join(",")
                    }
                }
            }
        }
    };
};
var $e091dfcd5daa8c55$export$2e2bcd8739ae039 = $e091dfcd5daa8c55$var$getThemeStyle;




const $d9c44872a0498ed5$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: "relative",
            overflow: "hidden"
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight),
            paddingInline: padding,
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $d9c44872a0498ed5$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, motionDurationMid: motionDurationMid, motionEaseOut: motionEaseOut, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight),
        listStylePosition: "inside",
        listStyleType: "disc"
    };
    return [
        {
            [componentCls]: {
                "&-inline, &-vertical": Object.assign({
                    [`&${componentCls}-root`]: {
                        boxShadow: "none"
                    }
                }, $d9c44872a0498ed5$var$getVerticalInlineStyle(token))
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: Object.assign(Object.assign({}, $d9c44872a0498ed5$var$getVerticalInlineStyle(token)), {
                    boxShadow: boxShadowSecondary
                })
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: "0",
                overflow: "hidden",
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: "hidden",
                    overflowY: "auto"
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: "100%",
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: "flex",
                        alignItems: "center",
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background ${motionDurationSlow}`,
                            `padding ${motionDurationMid} ${motionEaseOut}`,
                            `padding-inline calc(50% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(fontSizeLG).div(2).equal())} - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(itemMarginInline)})`
                        ].join(","),
                        [`> ${componentCls}-title-content`]: {
                            flex: "auto",
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        "> *": {
                            flex: "none"
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: "none",
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: "center"
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(fontSizeLG).div(2).equal())} - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(itemMarginInline)})`,
                    textOverflow: "clip",
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(itemHeight),
                        "+ span": {
                            display: "inline-block",
                            opacity: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: "inline-block"
                },
                "&-tooltip": {
                    pointerEvents: "none",
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: "none"
                    },
                    "a, a:hover": {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                    paddingInline: paddingXS
                })
            }
        }
    ];
};
var $d9c44872a0498ed5$export$2e2bcd8739ae039 = $d9c44872a0498ed5$var$getVerticalStyle;


const $8b02c8fb9659c94e$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: "relative",
            display: "block",
            margin: 0,
            whiteSpace: "nowrap",
            cursor: "pointer",
            transition: [
                `border-color ${motionDurationSlow}`,
                `background ${motionDurationSlow}`,
                `padding ${motionDurationSlow} ${motionEaseInOut}`
            ].join(","),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(","),
                "+ span": {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(",")
                }
            },
            [`${componentCls}-item-icon`]: Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()),
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: "none !important",
            cursor: "not-allowed",
            "&::after": {
                borderColor: "transparent !important"
            },
            a: {
                color: "inherit !important"
            },
            [`> ${componentCls}-submenu-title`]: {
                color: "inherit !important",
                cursor: "not-allowed"
            }
        }
    };
};
const $8b02c8fb9659c94e$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            "&-expand-icon, &-arrow": {
                position: "absolute",
                top: "50%",
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: "currentcolor",
                transform: "translateY(-50%)",
                transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
            },
            "&-arrow": {
                // →
                "&::before, &::after": {
                    position: "absolute",
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: "currentcolor",
                    borderRadius: borderRadius,
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `transform ${motionDurationSlow} ${motionEaseInOut}`,
                        `top ${motionDurationSlow} ${motionEaseInOut}`,
                        `color ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(","),
                    content: '""'
                },
                "&::before": {
                    transform: `rotate(45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                "&::after": {
                    transform: `rotate(-45deg) translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $8b02c8fb9659c94e$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize } = token;
    return [
        // Misc
        {
            "": {
                [`${componentCls}`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
                    // Hidden
                    "&-hidden": {
                        display: "none"
                    }
                })
            },
            [`${componentCls}-submenu-hidden`]: {
                display: "none"
            }
        },
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                listStyle: "none",
                outline: "none",
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                "ul, ol": {
                    margin: 0,
                    padding: 0,
                    listStyle: "none"
                },
                // Overflow ellipsis
                "&-overflow": {
                    display: "flex",
                    [`${componentCls}-item`]: {
                        flex: "none"
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(",")
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationMid} ${motionEaseInOut}`
                    ].join(",")
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: "initial",
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(",")
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    // https://github.com/ant-design/ant-design/issues/41143
                    [`> ${antCls}-typography-ellipsis-single-line`]: {
                        display: "inline",
                        verticalAlign: "unset"
                    }
                },
                [`${componentCls}-item a`]: {
                    "&::before": {
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "transparent",
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: "hidden",
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    "&-dashed": {
                        borderStyle: "dashed"
                    }
                }
            }), $8b02c8fb9659c94e$var$genMenuItemStyle(token)), {
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(fontSize).mul(2).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                "&-submenu": {
                    "&-popup": {
                        position: "absolute",
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: "none",
                        transformOrigin: "0 0",
                        [`&${componentCls}-submenu`]: {
                            background: "transparent"
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        "&::before": {
                            position: "absolute",
                            inset: 0,
                            zIndex: -1,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: Object.assign(Object.assign(Object.assign({
                            borderRadius: borderRadiusLG
                        }, $8b02c8fb9659c94e$var$genMenuItemStyle(token)), $8b02c8fb9659c94e$var$genSubMenuArrowStyle(token)), {
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        })
                    },
                    [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
                        transformOrigin: "100% 0"
                    },
                    [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
                        transformOrigin: "100% 100%"
                    },
                    [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
                        transformOrigin: "0 100%"
                    },
                    [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
                        transformOrigin: "0 0"
                    },
                    [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
                        paddingInlineEnd: token.paddingXS
                    },
                    [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
                        paddingInlineStart: token.paddingXS
                    },
                    [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
                        paddingBottom: token.paddingXS
                    },
                    [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
                        paddingTop: token.paddingXS
                    }
                }
            }), $8b02c8fb9659c94e$var$genSubMenuArrowStyle(token)), {
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    "&::before": {
                        transform: `rotate(-45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                    },
                    "&::after": {
                        transform: `rotate(45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    "&::after": {
                        transform: `rotate(-45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    "&::before": {
                        transform: `rotate(45deg) translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(menuArrowOffset)})`
                    }
                }
            })
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: "inherit"
                }
            }
        }
    ];
};
const $8b02c8fb9659c94e$export$9ca1be8807fe0675 = (token)=>{
    var _a, _b, _c;
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = (_a = token.activeBarWidth) !== null && _a !== void 0 ? _a : 0;
    const activeBarBorderWidth = (_b = token.activeBarBorderWidth) !== null && _b !== void 0 ? _b : lineWidth;
    const itemMarginInline = (_c = token.itemMarginInline) !== null && _c !== void 0 ? _c : token.marginXXS;
    const colorTextDark = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorTextLightSolid).setAlpha(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: "transparent",
        horizontalItemSelectedBg: "transparent",
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: "transparent",
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorTextLightSolid).setAlpha(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: "#001529",
        darkPopupBg: "#001529",
        darkSubMenuItemBg: "#000c17",
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: "transparent",
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$8b02c8fb9659c94e$export$2e2bcd8739ae039 = function(prefixCls) {
    let rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
    let injectStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const useStyle = (0, $099b764a368ed79c$export$51ec95de45185b42)("Menu", (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: "transparent",
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $8b02c8fb9659c94e$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $538c6177909b715a$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $d9c44872a0498ed5$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $e091dfcd5daa8c55$export$2e2bcd8739ae039)(menuToken, "light"),
            (0, $e091dfcd5daa8c55$export$2e2bcd8739ae039)(menuDarkToken, "dark"),
            // RTL
            (0, $99ca4130ddbe9d7a$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(menuToken),
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(menuToken, "slide-up"),
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(menuToken, "slide-down"),
            (0, $d2082114d5952afb$export$f5d123412490d9dc)(menuToken, "zoom-big")
        ];
    }, $8b02c8fb9659c94e$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                "colorGroupTitle",
                "groupTitleColor"
            ],
            [
                "radiusItem",
                "itemBorderRadius"
            ],
            [
                "radiusSubMenuItem",
                "subMenuItemBorderRadius"
            ],
            [
                "colorItemText",
                "itemColor"
            ],
            [
                "colorItemTextHover",
                "itemHoverColor"
            ],
            [
                "colorItemTextHoverHorizontal",
                "horizontalItemHoverColor"
            ],
            [
                "colorItemTextSelected",
                "itemSelectedColor"
            ],
            [
                "colorItemTextSelectedHorizontal",
                "horizontalItemSelectedColor"
            ],
            [
                "colorItemTextDisabled",
                "itemDisabledColor"
            ],
            [
                "colorDangerItemText",
                "dangerItemColor"
            ],
            [
                "colorDangerItemTextHover",
                "dangerItemHoverColor"
            ],
            [
                "colorDangerItemTextSelected",
                "dangerItemSelectedColor"
            ],
            [
                "colorDangerItemBgActive",
                "dangerItemActiveBg"
            ],
            [
                "colorDangerItemBgSelected",
                "dangerItemSelectedBg"
            ],
            [
                "colorItemBg",
                "itemBg"
            ],
            [
                "colorItemBgHover",
                "itemHoverBg"
            ],
            [
                "colorSubItemBg",
                "subMenuItemBg"
            ],
            [
                "colorItemBgActive",
                "itemActiveBg"
            ],
            [
                "colorItemBgSelectedHorizontal",
                "horizontalItemSelectedBg"
            ],
            [
                "colorActiveBarWidth",
                "activeBarWidth"
            ],
            [
                "colorActiveBarHeight",
                "activeBarHeight"
            ],
            [
                "colorActiveBarBorderSize",
                "activeBarBorderWidth"
            ],
            [
                "colorItemBgSelected",
                "itemSelectedBg"
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};



var $acw62 = parcelRequire("acw62");






"use client";
const $14bdbe2126091cad$var$SubMenu = (props)=>{
    var _a;
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $acw62.useContext((0, $f1be9e89e34926b1$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme } = context;
    const parentPath = (0, $76292f3495da88ff$export$d3d2d0a05677870a)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === "string" ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $acw62.isValidElement(title) && title.type === "span";
        titleNode = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (0, $30796c32f374b477$export$e530037191fcd5d7)(icon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(/*#__PURE__*/ $acw62.isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : "", `${prefixCls}-item-icon`)
        }), titleIsSpan ? title : /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $acw62.useMemo(()=>Object.assign(Object.assign({}, context), {
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("Menu");
    return /*#__PURE__*/ $acw62.createElement((0, $f1be9e89e34926b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $c14a300ca0685832$export$2e2bcd8739ae039), Object.assign({}, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "icon"
    ]), {
        title: titleNode,
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, popupClassName, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: {
            zIndex: zIndex
        }
    })));
};
var $14bdbe2126091cad$export$2e2bcd8739ae039 = $14bdbe2126091cad$var$SubMenu;


"use client";
var $b245b5b99d4f95a5$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $b245b5b99d4f95a5$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $b245b5b99d4f95a5$var$MENU_COMPONENTS = {
    item: (0, $8955a62aec0d8484$export$2e2bcd8739ae039),
    submenu: (0, $14bdbe2126091cad$export$2e2bcd8739ae039),
    divider: (0, $d26f09d6992ff5d8$export$2e2bcd8739ae039)
};
const $b245b5b99d4f95a5$var$InternalMenu = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _a;
    const override = $acw62.useContext((0, $798e9781cc841bf2$export$2e2bcd8739ae039));
    const overrideObj = override || {};
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, menu: menu } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = "light", expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName } = props, restProps = $b245b5b99d4f95a5$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "theme",
        "expandIcon",
        "_internalDisableMenuItemTitleTooltip",
        "inlineCollapsed",
        "siderCollapsed",
        "rootClassName",
        "mode",
        "selectable",
        "onClick",
        "overflowedIndicatorPopupClassName"
    ]);
    const passedProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(restProps, [
        "collapsedWidth"
    ]);
    (_a = overrideObj.validator) === null || _a === void 0 || _a.call(overrideObj, {
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
        var _a;
        onClick === null || onClick === void 0 || onClick.apply(void 0, arguments);
        (_a = overrideObj.onClick) === null || _a === void 0 || _a.call(overrideObj);
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable !== null && selectable !== void 0 ? selectable : overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = $acw62.useMemo(()=>{
        if (siderCollapsed !== undefined) return siderCollapsed;
        return inlineCollapsed;
    }, [
        inlineCollapsed,
        siderCollapsed
    ]);
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $2efb522a5615f01e$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls("menu", customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8b02c8fb9659c94e$export$2e2bcd8739ae039)(prefixCls, rootCls, !override);
    const menuClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-${theme}`, menu === null || menu === void 0 ? void 0 : menu.className, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $acw62.useMemo(()=>{
        var _a, _b;
        if (typeof expandIcon === "function" || $b245b5b99d4f95a5$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if (typeof overrideObj.expandIcon === "function" || $b245b5b99d4f95a5$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if (typeof (menu === null || menu === void 0 ? void 0 : menu.expandIcon) === "function" || $b245b5b99d4f95a5$var$isEmptyIcon(menu === null || menu === void 0 ? void 0 : menu.expandIcon)) return (menu === null || menu === void 0 ? void 0 : menu.expandIcon) || null;
        const mergedIcon = (_a = expandIcon !== null && expandIcon !== void 0 ? expandIcon : overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon) !== null && _a !== void 0 ? _a : menu === null || menu === void 0 ? void 0 : menu.expandIcon;
        return (0, $30796c32f374b477$export$e530037191fcd5d7)(mergedIcon, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $acw62.isValidElement(mergedIcon) ? (_b = mergedIcon.props) === null || _b === void 0 ? void 0 : _b.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj === null || overrideObj === void 0 ? void 0 : overrideObj.expandIcon,
        menu === null || menu === void 0 ? void 0 : menu.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $acw62.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme
    ]);
    // ========================= Render ==========================
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $acw62.createElement((0, $f1be9e89e34926b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $b187593cf569a182$export$2e2bcd8739ae039), Object.assign({
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $acw62.createElement((0, $18b92a77e6b0d38f$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick
    }, passedProps, {
        inlineCollapsed: mergedInlineCollapsed,
        style: Object.assign(Object.assign({}, menu === null || menu === void 0 ? void 0 : menu.style), style),
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls),
        _internalComponents: $b245b5b99d4f95a5$var$MENU_COMPONENTS
    })))));
});
var $b245b5b99d4f95a5$export$2e2bcd8739ae039 = $b245b5b99d4f95a5$var$InternalMenu;





"use client";
const $47077f34c49bbd52$var$Menu = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    const menuRef = (0, $acw62.useRef)(null);
    const context = $acw62.useContext((0, $f4e67dbf2453f541$export$63554aebd2a6d54c));
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                var _a;
                (_a = menuRef.current) === null || _a === void 0 || _a.focus(options);
            }
        }));
    return /*#__PURE__*/ $acw62.createElement((0, $b245b5b99d4f95a5$export$2e2bcd8739ae039), Object.assign({
        ref: menuRef
    }, props, context));
});
$47077f34c49bbd52$var$Menu.Item = (0, $8955a62aec0d8484$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.SubMenu = (0, $14bdbe2126091cad$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.Divider = (0, $d26f09d6992ff5d8$export$2e2bcd8739ae039);
$47077f34c49bbd52$var$Menu.ItemGroup = (0, $73334e01b4c90e74$export$2e2bcd8739ae039);
var $47077f34c49bbd52$export$2e2bcd8739ae039 = $47077f34c49bbd52$var$Menu;










const $40b8ffab092920b4$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    "&:hover": {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $40b8ffab092920b4$export$2e2bcd8739ae039 = $40b8ffab092920b4$var$genStatusStyle;


// =============================== Base ===============================
const $df81a0a68f1a30be$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated } = token;
    return [
        {
            [componentCls]: {
                position: "absolute",
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: "block",
                // A placeholder out of dropdown visible range to avoid close when user moving
                "&::before": {
                    position: "absolute",
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: "relative",
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
                    display: "none"
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $f8b44896cb986807$export$e801b802b037de6a)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $f8b44896cb986807$export$dd9f089fa5e819fe)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $f8b44896cb986807$export$f40f41df328ebc38)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $f8b44896cb986807$export$f7243fdb9c27c3b7)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $13cd8c878b3c9176$export$2e2bcd8739ae039)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: "relative",
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: "absolute",
                zIndex: zIndexPopup,
                background: "transparent",
                boxShadow: "none",
                transformOrigin: "0 0",
                "ul, li": {
                    listStyle: "none",
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                [menuCls]: Object.assign(Object.assign({
                    padding: dropdownEdgeChildPadding,
                    listStyleType: "none",
                    backgroundColor: colorBgElevated,
                    backgroundClip: "padding-box",
                    borderRadius: token.borderRadiusLG,
                    outline: "none",
                    boxShadow: token.boxShadowSecondary
                }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)), {
                    "&:empty": {
                        padding: 0,
                        boxShadow: "none"
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: "relative",
                        display: "flex",
                        alignItems: "center"
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: "auto",
                        "> a": {
                            color: "inherit",
                            transition: `all ${motionDurationMid}`,
                            "&:hover": {
                                color: "inherit"
                            },
                            "&::after": {
                                position: "absolute",
                                inset: 0,
                                content: '""'
                            }
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: Object.assign(Object.assign({
                        clear: "both",
                        margin: 0,
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: "normal",
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: "pointer",
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        "&:hover, &-active": {
                            backgroundColor: token.controlItemBgHover
                        }
                    }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)), {
                        "&-selected": {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            "&:hover, &-active": {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        "&-disabled": {
                            color: colorTextDisabled,
                            cursor: "not-allowed",
                            "&:hover": {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: "not-allowed"
                            },
                            a: {
                                pointerEvents: "none"
                            }
                        },
                        "&-divider": {
                            height: 1,
                            // By design
                            margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXXS)} 0`,
                            overflow: "hidden",
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: "absolute",
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: "0 !important",
                                color: token.colorTextDescription,
                                fontSize: fontSizeIcon,
                                fontStyle: "normal"
                            }
                        }
                    }),
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXS)}`,
                        padding: 0,
                        listStyle: "none"
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: "relative"
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: "not-allowed"
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                })
            })
        },
        // Follow code may reuse in other components
        [
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, "slide-up"),
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, "slide-down"),
            (0, $103c380d878d9852$export$913b1b7e3288c319)(token, "move-up"),
            (0, $103c380d878d9852$export$913b1b7e3288c319)(token, "move-down"),
            (0, $d2082114d5952afb$export$f5d123412490d9dc)(token, "zoom-big")
        ]
    ];
};
const $df81a0a68f1a30be$export$9ca1be8807fe0675 = (token)=>Object.assign(Object.assign({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2
    }, (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
        contentRadius: token.borderRadiusLG,
        limitVerticalRadius: true
    })), (0, $0c0596420865f622$export$87e38ee403661ccc)(token));
var $df81a0a68f1a30be$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Dropdown", (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $df81a0a68f1a30be$var$genBaseStyle(dropdownToken),
        (0, $40b8ffab092920b4$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $df81a0a68f1a30be$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $c311d16d3fa9262a$var$Placements = [
    "topLeft",
    "topCenter",
    "topRight",
    "bottomLeft",
    "bottomCenter",
    "bottomRight",
    "top",
    "bottom"
];
const $c311d16d3fa9262a$var$Dropdown = (props)=>{
    var _a;
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, visible: // Deprecated
    visible, onVisibleChange: onVisibleChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = "", overlay: overlay, transitionName: transitionName } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, dropdown: dropdown } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    // Warning for deprecated usage
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("Dropdown");
    var _ref;
    const memoTransitionName = $acw62.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes("top")) return `${rootPrefixCls}-slide-down`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $acw62.useMemo(()=>{
        if (!placement) return direction === "rtl" ? "bottomRight" : "bottomLeft";
        if (placement.includes("Center")) return placement.slice(0, placement.indexOf("Center"));
        return placement;
    }, [
        placement,
        direction
    ]);
    var _ref2;
    const prefixCls = getPrefixCls("dropdown", customizePrefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $df81a0a68f1a30be$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const child = $acw62.Children.only(children);
    const dropdownTrigger = (0, $30796c32f374b477$export$e530037191fcd5d7)(child, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, child.props.className),
        disabled: (_a = child.props.disabled) !== null && _a !== void 0 ? _a : disabled
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!(triggerActions === null || triggerActions === void 0 ? void 0 : triggerActions.includes("contextMenu"));
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: open !== null && open !== void 0 ? open : visible
    });
    const onInnerOpenChange = (0, $01e43e72865dc583$export$2e2bcd8739ae039)((nextOpen)=>{
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(nextOpen, {
            source: "trigger"
        });
        onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(nextOpen);
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, dropdown === null || dropdown === void 0 ? void 0 : dropdown.className, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    });
    const builtinPlacements = (0, $aa2151c32cec40fb$export$2e2bcd8739ae039)({
        arrowPointAtCenter: typeof arrow === "object" && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = $acw62.useCallback(()=>{
        if ((menu === null || menu === void 0 ? void 0 : menu.selectable) && (menu === null || menu === void 0 ? void 0 : menu.multiple)) return;
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(false, {
            source: "menu"
        });
        setOpen(false);
    }, [
        menu === null || menu === void 0 ? void 0 : menu.selectable,
        menu === null || menu === void 0 ? void 0 : menu.multiple
    ]);
    const renderOverlay = ()=>{
        // rc-dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to rc-dropdown.
        let overlayNode;
        if (menu === null || menu === void 0 ? void 0 : menu.items) overlayNode = /*#__PURE__*/ $acw62.createElement((0, $47077f34c49bbd52$export$2e2bcd8739ae039), Object.assign({}, menu));
        else if (typeof overlay === "function") overlayNode = overlay();
        else overlayNode = overlay;
        if (dropdownRender) overlayNode = dropdownRender(overlayNode);
        overlayNode = $acw62.Children.only(typeof overlayNode === "string" ? /*#__PURE__*/ $acw62.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$9bd434816b0530d0), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $acw62.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: (_ref3)=>{
                let { mode: mode } = _ref3;
            }
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("Dropdown", overlayStyle === null || overlayStyle === void 0 ? void 0 : overlayStyle.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $acw62.createElement((0, $e2ef3d42b101c489$export$2e2bcd8739ae039), Object.assign({
        alignPoint: alignPoint
    }, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "rootClassName"
    ]), {
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: Object.assign(Object.assign(Object.assign({}, dropdown === null || dropdown === void 0 ? void 0 : dropdown.style), overlayStyle), {
            zIndex: zIndex
        })
    }), dropdownTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return wrapCSSVar(renderNode);
};
function $c311d16d3fa9262a$var$postPureProps(props) {
    return Object.assign(Object.assign({}, props), {
        align: {
            overflow: {
                adjustX: false,
                adjustY: false
            }
        }
    });
}
// We don't care debug panel
const $c311d16d3fa9262a$var$PurePanel = (0, $91653a8941ab7768$export$2e2bcd8739ae039)($c311d16d3fa9262a$var$Dropdown, "dropdown", (prefixCls)=>prefixCls, $c311d16d3fa9262a$var$postPureProps);
/* istanbul ignore next */ const $c311d16d3fa9262a$var$WrapPurePanel = (props)=>/*#__PURE__*/ $acw62.createElement($c311d16d3fa9262a$var$PurePanel, Object.assign({}, props), /*#__PURE__*/ $acw62.createElement("span", null));
$c311d16d3fa9262a$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $c311d16d3fa9262a$var$WrapPurePanel;
var $c311d16d3fa9262a$export$2e2bcd8739ae039 = $c311d16d3fa9262a$var$Dropdown;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
const $68baed55ab318008$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    latestIndex: 0
});
const $68baed55ab318008$export$2bbf36e6e96e17f9 = $68baed55ab318008$export$853f607fd5cc208b.Provider;



var $acw62 = parcelRequire("acw62");

"use client";
const $a9129d7ad0e59df6$var$Item = (_ref)=>{
    let { className: className, index: index, children: children, split: split, style: style } = _ref;
    const { latestIndex: latestIndex } = $acw62.useContext((0, $68baed55ab318008$export$853f607fd5cc208b));
    if (children === null || children === undefined) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && split && /*#__PURE__*/ $acw62.createElement("span", {
        className: `${className}-split`
    }, split));
};
var $a9129d7ad0e59df6$export$2e2bcd8739ae039 = $a9129d7ad0e59df6$var$Item;



"use client";
var $8f666b0c5cd58c95$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $8f666b0c5cd58c95$var$InternalSpace = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b, _c;
    const { getPrefixCls: getPrefixCls, space: space, direction: directionConfig } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { size: size = (_a = space === null || space === void 0 ? void 0 : space.size) !== null && _a !== void 0 ? _a : "small", align: align, className: className, rootClassName: rootClassName, children: children, direction: direction = "horizontal", prefixCls: customizePrefixCls, split: split, style: style, wrap: wrap = false, classNames: customClassNames, styles: styles } = props, otherProps = $8f666b0c5cd58c95$var$__rest(props, [
        "size",
        "align",
        "className",
        "rootClassName",
        "children",
        "direction",
        "prefixCls",
        "split",
        "style",
        "wrap",
        "classNames",
        "styles"
    ]);
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $cf0f554ddf4da10f$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $cf0f554ddf4da10f$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $cf0f554ddf4da10f$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    const mergedAlign = align === undefined && direction === "horizontal" ? "center" : align;
    const prefixCls = getPrefixCls("space", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $8c6cd68a6974f2d0$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, space === null || space === void 0 ? void 0 : space.className, hashId, `${prefixCls}-${direction}`, {
        [`${prefixCls}-rtl`]: directionConfig === "rtl",
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls);
    const itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-item`, (_b = customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.item) !== null && _b !== void 0 ? _b : (_c = space === null || space === void 0 ? void 0 : space.classNames) === null || _c === void 0 ? void 0 : _c.item);
    // Calculate latest one
    let latestIndex = 0;
    const nodes = childNodes.map((child, i)=>{
        var _a, _b;
        if (child !== null && child !== undefined) latestIndex = i;
        const key = (child === null || child === void 0 ? void 0 : child.key) || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $acw62.createElement((0, $a9129d7ad0e59df6$export$2e2bcd8739ae039), {
            className: itemClassName,
            key: key,
            index: i,
            split: split,
            style: (_a = styles === null || styles === void 0 ? void 0 : styles.item) !== null && _a !== void 0 ? _a : (_b = space === null || space === void 0 ? void 0 : space.styles) === null || _b === void 0 ? void 0 : _b.item
        }, child);
    });
    const spaceContext = $acw62.useMemo(()=>({
            latestIndex: latestIndex
        }), [
        latestIndex
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = "wrap";
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        ref: ref,
        className: cls,
        style: Object.assign(Object.assign(Object.assign({}, gapStyle), space === null || space === void 0 ? void 0 : space.style), style)
    }, otherProps), /*#__PURE__*/ $acw62.createElement((0, $68baed55ab318008$export$2bbf36e6e96e17f9), {
        value: spaceContext
    }, nodes)));
});
const $8f666b0c5cd58c95$var$Space = $8f666b0c5cd58c95$var$InternalSpace;
$8f666b0c5cd58c95$var$Space.Compact = (0, $26050ef76e24a749$export$2e2bcd8739ae039);
var $8f666b0c5cd58c95$export$2e2bcd8739ae039 = $8f666b0c5cd58c95$var$Space;




"use client";
var $87bdca50cc18044d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $87bdca50cc18044d$var$DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = "default", danger: danger, disabled: disabled, loading: loading, onClick: onClick, htmlType: htmlType, children: children, className: className, menu: menu, arrow: arrow, autoFocus: autoFocus, overlay: overlay, trigger: trigger, align: align, open: open, onOpenChange: onOpenChange, placement: placement, getPopupContainer: getPopupContainer, href: href, icon: icon = /*#__PURE__*/ $acw62.createElement((0, $18b92a77e6b0d38f$export$2e2bcd8739ae039), null), title: title, buttonsRender: buttonsRender = (buttons)=>buttons, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, destroyPopupOnHide: destroyPopupOnHide, dropdownRender: dropdownRender } = props, restProps = $87bdca50cc18044d$var$__rest(props, [
        "prefixCls",
        "type",
        "danger",
        "disabled",
        "loading",
        "onClick",
        "htmlType",
        "children",
        "className",
        "menu",
        "arrow",
        "autoFocus",
        "overlay",
        "trigger",
        "align",
        "open",
        "onOpenChange",
        "placement",
        "getPopupContainer",
        "href",
        "icon",
        "title",
        "buttonsRender",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "overlayClassName",
        "overlayStyle",
        "destroyPopupOnHide",
        "dropdownRender"
    ]);
    const prefixCls = getPrefixCls("dropdown", customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayClassName: overlayClassName,
        overlayStyle: overlayStyle,
        destroyPopupOnHide: destroyPopupOnHide,
        dropdownRender: dropdownRender
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(buttonPrefixCls, compactItemClassnames, className);
    if ("overlay" in props) dropdownProps.overlay = overlay;
    if ("open" in props) dropdownProps.open = open;
    if ("placement" in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === "rtl" ? "bottomLeft" : "bottomRight";
    const leftButton = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039).Compact, Object.assign({
        className: classes,
        size: compactSize,
        block: true
    }, restProps), leftButtonToRender, /*#__PURE__*/ $acw62.createElement((0, $c311d16d3fa9262a$export$2e2bcd8739ae039), Object.assign({}, dropdownProps), rightButtonToRender));
};
$87bdca50cc18044d$var$DropdownButton.__ANT_BUTTON = true;
var $87bdca50cc18044d$export$2e2bcd8739ae039 = $87bdca50cc18044d$var$DropdownButton;


"use client";
const $9df091eb5002c0d1$var$Dropdown = (0, $c311d16d3fa9262a$export$2e2bcd8739ae039);
$9df091eb5002c0d1$var$Dropdown.Button = (0, $87bdca50cc18044d$export$2e2bcd8739ae039);
var $9df091eb5002c0d1$export$2e2bcd8739ae039 = $9df091eb5002c0d1$var$Dropdown;



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
const $5d2deff95d42cf3f$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(null);
const $5d2deff95d42cf3f$export$67d4730aee04efd2 = $5d2deff95d42cf3f$var$RadioGroupContext.Provider;
var $5d2deff95d42cf3f$export$2e2bcd8739ae039 = $5d2deff95d42cf3f$var$RadioGroupContext;
const $5d2deff95d42cf3f$export$4fbd9581b41e971f = /*#__PURE__*/ $acw62.createContext(null);
const $5d2deff95d42cf3f$export$1b5d1f64a577990e = $5d2deff95d42cf3f$export$4fbd9581b41e971f.Provider;



var $acw62 = parcelRequire("acw62");














// ============================== Styles ==============================
// styles from RadioGroup only
const $3ada146bee73c6aa$var$getGroupRadioStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const groupPrefixCls = `${componentCls}-group`;
    return {
        [groupPrefixCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            display: "inline-block",
            fontSize: 0,
            // RTL
            [`&${groupPrefixCls}-rtl`]: {
                direction: "rtl"
            },
            [`${antCls}-badge ${antCls}-badge-count`]: {
                zIndex: 1
            },
            [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
                borderInlineStart: "none"
            }
        })
    };
};
// Styles from radio-wrapper
const $3ada146bee73c6aa$var$getRadioBasicStyle = (token)=>{
    const { componentCls: componentCls, wrapperMarginInlineEnd: wrapperMarginInlineEnd, colorPrimary: colorPrimary, radioSize: radioSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOutCirc: motionEaseInOutCirc, colorBgContainer: colorBgContainer, colorBorder: colorBorder, lineWidth: lineWidth, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, paddingXS: paddingXS, dotColorDisabled: dotColorDisabled, lineType: lineType, radioColor: radioColor, radioBgColor: radioBgColor, calc: calc } = token;
    const radioInnerPrefixCls = `${componentCls}-inner`;
    const dotPadding = 4;
    const radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
    const radioSizeCalc = calc(1).mul(radioSize).equal({
        unit: true
    });
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            display: "inline-flex",
            alignItems: "baseline",
            marginInlineStart: 0,
            marginInlineEnd: wrapperMarginInlineEnd,
            cursor: "pointer",
            // RTL
            [`&${componentCls}-wrapper-rtl`]: {
                direction: "rtl"
            },
            "&-disabled": {
                cursor: "not-allowed",
                color: token.colorTextDisabled
            },
            "&::after": {
                display: "inline-block",
                width: 0,
                overflow: "hidden",
                content: '"\\a0"'
            },
            // hashId 在 wrapper 上，只能铺平
            [`${componentCls}-checked::after`]: {
                position: "absolute",
                insetBlockStart: 0,
                insetInlineStart: 0,
                width: "100%",
                height: "100%",
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: "50%",
                visibility: "hidden",
                opacity: 0,
                content: '""'
            },
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: "relative",
                display: "inline-block",
                outline: "none",
                cursor: "pointer",
                alignSelf: "center",
                borderRadius: "50%"
            }),
            [`${componentCls}-wrapper:hover &,
        &:hover ${radioInnerPrefixCls}`]: {
                borderColor: colorPrimary
            },
            [`${componentCls}-input:focus-visible + ${radioInnerPrefixCls}`]: Object.assign({}, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)),
            [`${componentCls}:hover::after, ${componentCls}-wrapper:hover &::after`]: {
                visibility: "visible"
            },
            [`${componentCls}-inner`]: {
                "&::after": {
                    boxSizing: "border-box",
                    position: "absolute",
                    insetBlockStart: "50%",
                    insetInlineStart: "50%",
                    display: "block",
                    width: radioSizeCalc,
                    height: radioSizeCalc,
                    marginBlockStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    marginInlineStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    backgroundColor: radioColor,
                    borderBlockStart: 0,
                    borderInlineStart: 0,
                    borderRadius: radioSizeCalc,
                    transform: "scale(0)",
                    opacity: 0,
                    transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`,
                    content: '""'
                },
                boxSizing: "border-box",
                position: "relative",
                insetBlockStart: 0,
                insetInlineStart: 0,
                display: "block",
                width: radioSizeCalc,
                height: radioSizeCalc,
                backgroundColor: colorBgContainer,
                borderColor: colorBorder,
                borderStyle: "solid",
                borderWidth: lineWidth,
                borderRadius: "50%",
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-input`]: {
                position: "absolute",
                inset: 0,
                zIndex: 1,
                cursor: "pointer",
                opacity: 0
            },
            // 选中状态
            [`${componentCls}-checked`]: {
                [radioInnerPrefixCls]: {
                    borderColor: colorPrimary,
                    backgroundColor: radioBgColor,
                    "&::after": {
                        transform: `scale(${token.calc(token.dotSize).div(radioSize).equal()})`,
                        opacity: 1,
                        transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
                    }
                }
            },
            [`${componentCls}-disabled`]: {
                cursor: "not-allowed",
                [radioInnerPrefixCls]: {
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder,
                    cursor: "not-allowed",
                    "&::after": {
                        backgroundColor: dotColorDisabled
                    }
                },
                [`${componentCls}-input`]: {
                    cursor: "not-allowed"
                },
                [`${componentCls}-disabled + span`]: {
                    color: colorTextDisabled,
                    cursor: "not-allowed"
                },
                [`&${componentCls}-checked`]: {
                    [radioInnerPrefixCls]: {
                        "&::after": {
                            transform: `scale(${calc(radioDotDisabledSize).div(radioSize).equal()})`
                        }
                    }
                }
            },
            [`span${componentCls} + *`]: {
                paddingInlineStart: paddingXS,
                paddingInlineEnd: paddingXS
            }
        })
    };
};
// Styles from radio-button
const $3ada146bee73c6aa$var$getRadioButtonStyle = (token)=>{
    const { buttonColor: buttonColor, controlHeight: controlHeight, componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, buttonPaddingInline: buttonPaddingInline, fontSize: fontSize, buttonBg: buttonBg, fontSizeLG: fontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, paddingXS: paddingXS, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, buttonCheckedBg: buttonCheckedBg, buttonSolidCheckedColor: buttonSolidCheckedColor, colorTextDisabled: colorTextDisabled, colorBgContainerDisabled: colorBgContainerDisabled, buttonCheckedBgDisabled: buttonCheckedBgDisabled, buttonCheckedColorDisabled: buttonCheckedColorDisabled, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, buttonSolidCheckedBg: buttonSolidCheckedBg, buttonSolidCheckedHoverBg: buttonSolidCheckedHoverBg, buttonSolidCheckedActiveBg: buttonSolidCheckedActiveBg, calc: calc } = token;
    return {
        [`${componentCls}-button-wrapper`]: {
            position: "relative",
            display: "inline-block",
            height: controlHeight,
            margin: 0,
            paddingInline: buttonPaddingInline,
            paddingBlock: 0,
            color: buttonColor,
            fontSize: fontSize,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
            background: buttonBg,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
            // strange align fix for chrome but works
            // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
            borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
            borderInlineStartWidth: 0,
            borderInlineEndWidth: lineWidth,
            cursor: "pointer",
            transition: [
                `color ${motionDurationMid}`,
                `background ${motionDurationMid}`,
                `box-shadow ${motionDurationMid}`
            ].join(","),
            a: {
                color: buttonColor
            },
            [`> ${componentCls}-button`]: {
                position: "absolute",
                insetBlockStart: 0,
                insetInlineStart: 0,
                zIndex: -1,
                width: "100%",
                height: "100%"
            },
            "&:not(:first-child)": {
                "&::before": {
                    position: "absolute",
                    insetBlockStart: calc(lineWidth).mul(-1).equal(),
                    insetInlineStart: calc(lineWidth).mul(-1).equal(),
                    display: "block",
                    boxSizing: "content-box",
                    width: 1,
                    height: "100%",
                    paddingBlock: lineWidth,
                    paddingInline: 0,
                    backgroundColor: colorBorder,
                    transition: `background-color ${motionDurationSlow}`,
                    content: '""'
                }
            },
            "&:first-child": {
                borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
                borderStartStartRadius: borderRadius,
                borderEndStartRadius: borderRadius
            },
            "&:last-child": {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            "&:first-child:last-child": {
                borderRadius: borderRadius
            },
            [`${componentCls}-group-large &`]: {
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
                "&:first-child": {
                    borderStartStartRadius: borderRadiusLG,
                    borderEndStartRadius: borderRadiusLG
                },
                "&:last-child": {
                    borderStartEndRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-small &`]: {
                height: controlHeightSM,
                paddingInline: calc(paddingXS).sub(lineWidth).equal(),
                paddingBlock: 0,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
                "&:first-child": {
                    borderStartStartRadius: borderRadiusSM,
                    borderEndStartRadius: borderRadiusSM
                },
                "&:last-child": {
                    borderStartEndRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                }
            },
            "&:hover": {
                position: "relative",
                color: colorPrimary
            },
            "&:has(:focus-visible)": Object.assign({}, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)),
            [`${componentCls}-inner, input[type='checkbox'], input[type='radio']`]: {
                width: 0,
                height: 0,
                opacity: 0,
                pointerEvents: "none"
            },
            [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                zIndex: 1,
                color: colorPrimary,
                background: buttonCheckedBg,
                borderColor: colorPrimary,
                "&::before": {
                    backgroundColor: colorPrimary
                },
                "&:first-child": {
                    borderColor: colorPrimary
                },
                "&:hover": {
                    color: colorPrimaryHover,
                    borderColor: colorPrimaryHover,
                    "&::before": {
                        backgroundColor: colorPrimaryHover
                    }
                },
                "&:active": {
                    color: colorPrimaryActive,
                    borderColor: colorPrimaryActive,
                    "&::before": {
                        backgroundColor: colorPrimaryActive
                    }
                }
            },
            [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                color: buttonSolidCheckedColor,
                background: buttonSolidCheckedBg,
                borderColor: buttonSolidCheckedBg,
                "&:hover": {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedHoverBg,
                    borderColor: buttonSolidCheckedHoverBg
                },
                "&:active": {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedActiveBg,
                    borderColor: buttonSolidCheckedActiveBg
                }
            },
            "&-disabled": {
                color: colorTextDisabled,
                backgroundColor: colorBgContainerDisabled,
                borderColor: colorBorder,
                cursor: "not-allowed",
                "&:first-child, &:hover": {
                    color: colorTextDisabled,
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder
                }
            },
            [`&-disabled${componentCls}-button-wrapper-checked`]: {
                color: buttonCheckedColorDisabled,
                backgroundColor: buttonCheckedBgDisabled,
                borderColor: colorBorder,
                boxShadow: "none"
            }
        }
    };
};
const $3ada146bee73c6aa$export$9ca1be8807fe0675 = (token)=>{
    const { wireframe: wireframe, padding: padding, marginXS: marginXS, lineWidth: lineWidth, fontSizeLG: fontSizeLG, colorText: colorText, colorBgContainer: colorBgContainer, colorTextDisabled: colorTextDisabled, controlItemBgActiveDisabled: controlItemBgActiveDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, colorWhite: colorWhite } = token;
    const dotPadding = 4; // Fixed value
    const radioSize = fontSizeLG;
    const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
    return {
        radioSize: // Radio
        radioSize,
        dotSize: radioDotSize,
        dotColorDisabled: colorTextDisabled,
        // Radio buttons
        buttonSolidCheckedColor: colorTextLightSolid,
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimaryHover,
        buttonSolidCheckedActiveBg: colorPrimaryActive,
        buttonBg: colorBgContainer,
        buttonCheckedBg: colorBgContainer,
        buttonColor: colorText,
        buttonCheckedBgDisabled: controlItemBgActiveDisabled,
        buttonCheckedColorDisabled: colorTextDisabled,
        buttonPaddingInline: padding - lineWidth,
        wrapperMarginInlineEnd: marginXS,
        // internal
        radioColor: wireframe ? colorPrimary : colorWhite,
        radioBgColor: wireframe ? colorBgContainer : colorPrimary
    };
};
var $3ada146bee73c6aa$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Radio", (token)=>{
    const { controlOutline: controlOutline, controlOutlineWidth: controlOutlineWidth } = token;
    const radioFocusShadow = `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(controlOutlineWidth)} ${controlOutline}`;
    const radioButtonFocusShadow = radioFocusShadow;
    const radioToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        radioFocusShadow: radioFocusShadow,
        radioButtonFocusShadow: radioButtonFocusShadow
    });
    return [
        $3ada146bee73c6aa$var$getGroupRadioStyle(radioToken),
        $3ada146bee73c6aa$var$getRadioBasicStyle(radioToken),
        $3ada146bee73c6aa$var$getRadioButtonStyle(radioToken)
    ];
}, $3ada146bee73c6aa$export$9ca1be8807fe0675, {
    unitless: {
        radioSize: true,
        dotSize: true
    }
});


"use client";
var $9248626bdf467aa3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $9248626bdf467aa3$var$InternalRadio = (props, ref)=>{
    var _a, _b;
    const groupContext = $acw62.useContext((0, $5d2deff95d42cf3f$export$2e2bcd8739ae039));
    const radioOptionTypeContext = $acw62.useContext((0, $5d2deff95d42cf3f$export$4fbd9581b41e971f));
    const { getPrefixCls: getPrefixCls, direction: direction, radio: radio } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const innerRef = $acw62.useRef(null);
    const mergedRef = (0, $5e297877593af644$export$ab452c34e8e05029)(ref, innerRef);
    const { isFormItemInput: isFormItemInput } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const onChange = (e)=>{
        var _a, _b;
        (_a = props.onChange) === null || _a === void 0 || _a.call(props, e);
        (_b = groupContext === null || groupContext === void 0 ? void 0 : groupContext.onChange) === null || _b === void 0 || _b.call(groupContext, e);
    };
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, style: style, title: title } = props, restProps = $9248626bdf467aa3$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "children",
        "style",
        "title"
    ]);
    const radioPrefixCls = getPrefixCls("radio", customizePrefixCls);
    const isButtonType = ((groupContext === null || groupContext === void 0 ? void 0 : groupContext.optionType) || radioOptionTypeContext) === "button";
    const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(radioPrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3ada146bee73c6aa$export$2e2bcd8739ae039)(radioPrefixCls, rootCls);
    const radioProps = Object.assign({}, restProps);
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = (_a = radioProps.disabled) !== null && _a !== void 0 ? _a : groupContext.disabled;
    }
    radioProps.disabled = (_b = radioProps.disabled) !== null && _b !== void 0 ? _b : disabled;
    const wrapperClassString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: radioProps.checked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        [`${prefixCls}-wrapper-rtl`]: direction === "rtl",
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, radio === null || radio === void 0 ? void 0 : radio.className, className, rootClassName, hashId, cssVarCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $37e027257ee01609$export$2e2bcd8739ae039), {
        component: "Radio",
        disabled: radioProps.disabled
    }, /*#__PURE__*/ $acw62.createElement("label", {
        className: wrapperClassString,
        style: Object.assign(Object.assign({}, radio === null || radio === void 0 ? void 0 : radio.style), style),
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        title: title
    }, /*#__PURE__*/ $acw62.createElement((0, $b58897a741799cae$export$2e2bcd8739ae039), Object.assign({}, radioProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(radioProps.className, {
            [(0, $ede16c18199d1556$export$23466a5792b7a5d3)]: !isButtonType
        }),
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef
    })), children !== undefined ? /*#__PURE__*/ $acw62.createElement("span", null, children) : null)));
};
const $9248626bdf467aa3$var$Radio = /*#__PURE__*/ $acw62.forwardRef($9248626bdf467aa3$var$InternalRadio);
var $9248626bdf467aa3$export$2e2bcd8739ae039 = $9248626bdf467aa3$var$Radio;



"use client";
const $61a2b39e6d97013d$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [value, setValue] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(props.defaultValue, {
        value: props.value
    });
    const onRadioChange = (ev)=>{
        const lastValue = value;
        const val = ev.target.value;
        if (!("value" in props)) setValue(val);
        const { onChange: onChange } = props;
        if (onChange && val !== lastValue) onChange(ev);
    };
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, options: options, buttonStyle: buttonStyle = "outline", disabled: disabled, children: children, size: customizeSize, style: style, id: id, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = props;
    const prefixCls = getPrefixCls("radio", customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3ada146bee73c6aa$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map((option)=>{
        if (typeof option === "string" || typeof option === "number") // 此处类型自动推导为 string
        return /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), {
            key: `radio-group-value-options-${option.value}`,
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            title: option.title,
            style: option.style,
            id: option.id,
            required: option.required
        }, option.label);
    });
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
        [`${groupPrefixCls}-${mergedSize}`]: mergedSize,
        [`${groupPrefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId, cssVarCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({}, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    }), {
        className: classString,
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }), /*#__PURE__*/ $acw62.createElement((0, $5d2deff95d42cf3f$export$67d4730aee04efd2), {
        value: {
            onChange: onRadioChange,
            value: value,
            disabled: props.disabled,
            name: props.name,
            optionType: props.optionType
        }
    }, childrenToRender)));
});
var $61a2b39e6d97013d$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($61a2b39e6d97013d$var$RadioGroup);




var $acw62 = parcelRequire("acw62");



"use client";
var $26603fe9919115f7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $26603fe9919115f7$var$RadioButton = (props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls } = props, radioProps = $26603fe9919115f7$var$__rest(props, [
        "prefixCls"
    ]);
    const prefixCls = getPrefixCls("radio", customizePrefixCls);
    return /*#__PURE__*/ $acw62.createElement((0, $5d2deff95d42cf3f$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $acw62.createElement((0, $9248626bdf467aa3$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls
    }, radioProps, {
        type: "radio",
        ref: ref
    })));
};
var $26603fe9919115f7$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($26603fe9919115f7$var$RadioButton);


"use client";
const $c1fe26c11c01fc5f$var$Radio = (0, $9248626bdf467aa3$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.Button = (0, $26603fe9919115f7$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.Group = (0, $61a2b39e6d97013d$export$2e2bcd8739ae039);
$c1fe26c11c01fc5f$var$Radio.__ANT_RADIO = true;
var $c1fe26c11c01fc5f$export$2e2bcd8739ae039 = $c1fe26c11c01fc5f$var$Radio;


"use client";
const $e201eb08b7050f4b$export$ed10248435b8f218 = {};
const $e201eb08b7050f4b$export$14159cd9e2a500c8 = "SELECT_ALL";
const $e201eb08b7050f4b$export$625c4f68eaaf8cfd = "SELECT_INVERT";
const $e201eb08b7050f4b$export$c1a725540f5a63bd = "SELECT_NONE";
const $e201eb08b7050f4b$var$EMPTY_LIST = [];
const $e201eb08b7050f4b$var$flattenData = (childrenColumnName, data)=>{
    let list = [];
    (data || []).forEach((record)=>{
        list.push(record);
        if (record && typeof record === "object" && childrenColumnName in record) list = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(list), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($e201eb08b7050f4b$var$flattenData(childrenColumnName, record[childrenColumnName])));
    });
    return list;
};
const $e201eb08b7050f4b$var$useSelection = (config, rowSelection)=>{
    const { preserveSelectedRowKeys: preserveSelectedRowKeys, selectedRowKeys: selectedRowKeys, defaultSelectedRowKeys: defaultSelectedRowKeys, getCheckboxProps: getCheckboxProps, onChange: onSelectionChange, onSelect: onSelect, onSelectAll: onSelectAll, onSelectInvert: onSelectInvert, onSelectNone: onSelectNone, onSelectMultiple: onSelectMultiple, columnWidth: selectionColWidth, type: selectionType, selections: selections, fixed: fixed, renderCell: customizeRenderCell, hideSelectAll: hideSelectAll, checkStrictly: checkStrictly = true } = rowSelection || {};
    const { prefixCls: prefixCls, data: data, pageData: pageData, getRecordByKey: getRecordByKey, getRowKey: getRowKey, expandType: expandType, childrenColumnName: childrenColumnName, locale: tableLocale, getPopupContainer: getPopupContainer } = config;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("Table");
    // ========================= MultipleSelect =========================
    const [multipleSelect, updatePrevSelectedIndex] = (0, $220d9bc86e982cbe$export$2e2bcd8739ae039)((item)=>item);
    // ========================= Keys =========================
    const [mergedSelectedKeys, setMergedSelectedKeys] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(selectedRowKeys || defaultSelectedRowKeys || $e201eb08b7050f4b$var$EMPTY_LIST, {
        value: selectedRowKeys
    });
    // ======================== Caches ========================
    const preserveRecordsRef = $acw62.useRef(new Map());
    const updatePreserveRecordsCache = (0, $acw62.useCallback)((keys)=>{
        if (preserveSelectedRowKeys) {
            const newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach((key)=>{
                let record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $acw62.useEffect(()=>{
        updatePreserveRecordsCache(mergedSelectedKeys);
    }, [
        mergedSelectedKeys
    ]);
    const { keyEntities: keyEntities } = (0, $acw62.useMemo)(()=>{
        if (checkStrictly) return {
            keyEntities: null
        };
        let convertData = data;
        if (preserveSelectedRowKeys) {
            const keysSet = new Set(data.map((record, index)=>getRowKey(record, index)));
            // remove preserveRecords that duplicate data
            const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, _ref)=>{
                let [key, value] = _ref;
                return keysSet.has(key) ? total : total.concat(value);
            }, []);
            convertData = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(convertData), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(preserveRecords));
        }
        return (0, $e0866d8dd7f10128$export$e5d831ce033a4615)(convertData, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName,
        preserveSelectedRowKeys
    ]);
    // Get flatten data
    const flattedData = (0, $acw62.useMemo)(()=>$e201eb08b7050f4b$var$flattenData(childrenColumnName, pageData), [
        childrenColumnName,
        pageData
    ]);
    // Get all checkbox props
    const checkboxPropsMap = (0, $acw62.useMemo)(()=>{
        const map = new Map();
        flattedData.forEach((record, index)=>{
            const key = getRowKey(record, index);
            const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    const isCheckboxDisabled = (0, $acw62.useCallback)((r)=>{
        var _a;
        return !!((_a = checkboxPropsMap.get(getRowKey(r))) === null || _a === void 0 ? void 0 : _a.disabled);
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0, $acw62.useMemo)(()=>{
        if (checkStrictly) return [
            mergedSelectedKeys || [],
            []
        ];
        const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $4d7359063b3a6d19$export$43adf2c483e3e633)(mergedSelectedKeys, true, keyEntities, isCheckboxDisabled);
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeys,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]);
    const derivedSelectedKeySet = (0, $acw62.useMemo)(()=>{
        const keys = selectionType === "radio" ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    const derivedHalfSelectedKeySet = (0, $acw62.useMemo)(()=>selectionType === "radio" ? new Set() : new Set(derivedHalfSelectedKeys), [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Reset if rowSelection reset
    $acw62.useEffect(()=>{
        if (!rowSelection) setMergedSelectedKeys($e201eb08b7050f4b$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    const setSelectedKeys = (0, $acw62.useCallback)((keys, method)=>{
        let availableKeys;
        let records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map((key)=>preserveRecordsRef.current.get(key));
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach((key)=>{
                const record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    const triggerSingleSelection = (0, $acw62.useCallback)((key, selected, keys, event)=>{
        if (onSelect) {
            const rows = keys.map((k)=>getRecordByKey(k));
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, "single");
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    const mergedSelections = (0, $acw62.useMemo)(()=>{
        if (!selections || hideSelectAll) return null;
        const selectionList = selections === true ? [
            $e201eb08b7050f4b$export$14159cd9e2a500c8,
            $e201eb08b7050f4b$export$625c4f68eaaf8cfd,
            $e201eb08b7050f4b$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map((selection)=>{
            if (selection === $e201eb08b7050f4b$export$14159cd9e2a500c8) return {
                key: "all",
                text: tableLocale.selectionAll,
                onSelect () {
                    setSelectedKeys(data.map((record, index)=>getRowKey(record, index)).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return !(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled) || derivedSelectedKeySet.has(key);
                    }), "all");
                }
            };
            if (selection === $e201eb08b7050f4b$export$625c4f68eaaf8cfd) return {
                key: "invert",
                text: tableLocale.selectInvert,
                onSelect () {
                    const keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach((record, index)=>{
                        const key = getRowKey(record, index);
                        const checkProps = checkboxPropsMap.get(key);
                        if (!(checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled)) {
                            if (keySet.has(key)) keySet.delete(key);
                            else keySet.add(key);
                        }
                    });
                    const keys = Array.from(keySet);
                    if (onSelectInvert) {
                        warning.deprecated(false, "onSelectInvert", "onChange");
                        onSelectInvert(keys);
                    }
                    setSelectedKeys(keys, "invert");
                }
            };
            if (selection === $e201eb08b7050f4b$export$c1a725540f5a63bd) return {
                key: "none",
                text: tableLocale.selectNone,
                onSelect () {
                    onSelectNone === null || onSelectNone === void 0 || onSelectNone();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return checkProps === null || checkProps === void 0 ? void 0 : checkProps.disabled;
                    }), "none");
                }
            };
            return selection;
        }).map((selection)=>Object.assign(Object.assign({}, selection), {
                onSelect: function() {
                    var _a2;
                    var _a;
                    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
                    (_a = selection.onSelect) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        selection
                    ].concat(rest));
                    updatePrevSelectedIndex(null);
                }
            }));
    }, [
        selections,
        derivedSelectedKeySet,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    const transformColumns = (0, $acw62.useCallback)((columns)=>{
        var _a;
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter((col)=>col !== $e201eb08b7050f4b$export$ed10248435b8f218);
        // >>>>>>>>>>> Support selection
        let cloneColumns = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(columns);
        const keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        const recordKeys = flattedData.map(getRowKey).filter((key)=>!checkboxPropsMap.get(key).disabled);
        const checkedCurrentAll = recordKeys.every((key)=>keySet.has(key));
        const checkedCurrentSome = recordKeys.some((key)=>keySet.has(key));
        const onSelectAllChange = ()=>{
            const changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach((key)=>{
                keySet.delete(key);
                changeKeys.push(key);
            });
            else recordKeys.forEach((key)=>{
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            const keys = Array.from(keySet);
            onSelectAll === null || onSelectAll === void 0 || onSelectAll(!checkedCurrentAll, keys.map((k)=>getRecordByKey(k)), changeKeys.map((k)=>getRecordByKey(k)));
            setSelectedKeys(keys, "all");
            updatePrevSelectedIndex(null);
        };
        // ===================== Render =====================
        // Title Cell
        let title;
        let columnTitleCheckbox;
        if (selectionType !== "radio") {
            let customizeSelections;
            if (mergedSelections) {
                const menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map((selection, index)=>{
                        const { key: key, text: text, onSelect: onSelectionClick } = selection;
                        return {
                            key: key !== null && key !== void 0 ? key : index,
                            onClick: ()=>{
                                onSelectionClick === null || onSelectionClick === void 0 || onSelectionClick(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $acw62.createElement("div", {
                    className: `${prefixCls}-selection-extra`
                }, /*#__PURE__*/ $acw62.createElement((0, $9df091eb5002c0d1$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $acw62.createElement("span", null, /*#__PURE__*/ $acw62.createElement((0, $9387210f6c0d2379$export$2e2bcd8739ae039), null))));
            }
            const allDisabledData = flattedData.map((record, index)=>{
                const key = getRowKey(record, index);
                const checkboxProps = checkboxPropsMap.get(key) || {};
                return Object.assign({
                    checked: keySet.has(key)
                }, checkboxProps);
            }).filter((_ref2)=>{
                let { disabled: disabled } = _ref2;
                return disabled;
            });
            const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            const allDisabledAndChecked = allDisabled && allDisabledData.every((_ref3)=>{
                let { checked: checked } = _ref3;
                return checked;
            });
            const allDisabledSomeChecked = allDisabled && allDisabledData.some((_ref4)=>{
                let { checked: checked } = _ref4;
                return checked;
            });
            columnTitleCheckbox = /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: onSelectAllChange,
                disabled: flattedData.length === 0 || allDisabled,
                "aria-label": customizeSelections ? "Custom selection" : "Select all",
                skipGroup: true
            });
            title = !hideSelectAll && /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-selection`
            }, columnTitleCheckbox, customizeSelections);
        }
        // Body Cell
        let renderCell;
        if (selectionType === "radio") renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            return {
                node: /*#__PURE__*/ $acw62.createElement((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), Object.assign({}, checkboxPropsMap.get(key), {
                    checked: checked,
                    onClick: (e)=>e.stopPropagation(),
                    onChange: (event)=>{
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                    }
                })),
                checked: checked
            };
        };
        else renderCell = (_, record, index)=>{
            var _a;
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const indeterminate = derivedHalfSelectedKeySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            let mergedIndeterminate;
            if (expandType === "nest") mergedIndeterminate = indeterminate;
            else mergedIndeterminate = (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.indeterminate) !== null && _a !== void 0 ? _a : indeterminate;
            // Record checked
            return {
                node: /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), Object.assign({}, checkboxProps, {
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: (e)=>e.stopPropagation(),
                    onChange: (_ref5)=>{
                        let { nativeEvent: nativeEvent } = _ref5;
                        const { shiftKey: shiftKey } = nativeEvent;
                        const currentSelectedIndex = recordKeys.findIndex((item)=>item === key);
                        const isMultiple = derivedSelectedKeys.some((item)=>recordKeys.includes(item));
                        if (shiftKey && checkStrictly && isMultiple) {
                            const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                            const keys = Array.from(keySet);
                            onSelectMultiple === null || onSelectMultiple === void 0 || onSelectMultiple(!checked, keys.map((recordKey)=>getRecordByKey(recordKey)), changedKeys.map((recordKey)=>getRecordByKey(recordKey)));
                            setSelectedKeys(keys, "multiple");
                        } else {
                            // Single record selected
                            const originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                const checkedKeys = checked ? (0, $af974b6720932c91$export$5bfb9ff497fe2298)(originCheckedKeys, key) : (0, $af974b6720932c91$export$10663f6bbd2fd717)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                const result = (0, $4d7359063b3a6d19$export$43adf2c483e3e633)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = result;
                                let nextCheckedKeys = checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    const tempKeySet = new Set(checkedKeys);
                                    tempKeySet.delete(key);
                                    nextCheckedKeys = (0, $4d7359063b3a6d19$export$43adf2c483e3e633)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) updatePrevSelectedIndex(null);
                        else updatePrevSelectedIndex(currentSelectedIndex);
                    }
                })),
                checked: checked
            };
        };
        const renderSelectionCell = (_, record, index)=>{
            const { node: node, checked: checked } = renderCell(_, record, index);
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($e201eb08b7050f4b$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex((col)=>{
                var _a;
                return ((_a = col[0, $7d5e637feda74b50$export$f8dba99c0d5b6b87]) === null || _a === void 0 ? void 0 : _a.columnType) === "EXPAND_COLUMN";
            }) === 0) {
                const [expandColumn, ...restColumns] = cloneColumns;
                cloneColumns = [
                    expandColumn,
                    $e201eb08b7050f4b$export$ed10248435b8f218
                ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $e201eb08b7050f4b$export$ed10248435b8f218
            ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cloneColumns));
        }
        // Deduplicate selection column
        const selectionColumnIndex = cloneColumns.indexOf($e201eb08b7050f4b$export$ed10248435b8f218);
        cloneColumns = cloneColumns.filter((column, index)=>column !== $e201eb08b7050f4b$export$ed10248435b8f218 || index === selectionColumnIndex);
        // Fixed column logic
        const prevCol = cloneColumns[selectionColumnIndex - 1];
        const nextCol = cloneColumns[selectionColumnIndex + 1];
        let mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if ((nextCol === null || nextCol === void 0 ? void 0 : nextCol.fixed) !== undefined) mergedFixed = nextCol.fixed;
            else if ((prevCol === null || prevCol === void 0 ? void 0 : prevCol.fixed) !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && ((_a = prevCol[0, $7d5e637feda74b50$export$f8dba99c0d5b6b87]) === null || _a === void 0 ? void 0 : _a.columnType) === "EXPAND_COLUMN" && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        const columnCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-selection-col`, {
            [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === "checkbox"
        });
        const renderColumnTitle = ()=>{
            if (!(rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.columnTitle)) return title;
            if (typeof rowSelection.columnTitle === "function") return rowSelection.columnTitle(columnTitleCheckbox);
            return rowSelection.columnTitle;
        };
        // Replace with real selection column
        const selectionColumn = {
            fixed: mergedFixed,
            width: selectionColWidth,
            className: `${prefixCls}-selection-column`,
            title: renderColumnTitle(),
            render: renderSelectionCell,
            onCell: rowSelection.onCell,
            [(0, $7d5e637feda74b50$export$f8dba99c0d5b6b87)]: {
                className: columnCls
            }
        };
        return cloneColumns.map((col)=>col === $e201eb08b7050f4b$export$ed10248435b8f218 ? selectionColumn : col);
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
};
var $e201eb08b7050f4b$export$2e2bcd8739ae039 = $e201eb08b7050f4b$var$useSelection;



var $acw62 = parcelRequire("acw62");




// Proxy the dom ref with `{ nativeElement, otherFn }` type
// ref: https://github.com/ant-design/ant-design/discussions/45242

var $acw62 = parcelRequire("acw62");
function $f0212a5d02e19b33$var$fillProxy(element, handler) {
    element._antProxy = element._antProxy || {};
    Object.keys(handler).forEach((key)=>{
        if (!(key in element._antProxy)) {
            const ori = element[key];
            element._antProxy[key] = ori;
            element[key] = handler[key];
        }
    });
    return element;
}
function $f0212a5d02e19b33$export$2e2bcd8739ae039(ref, init) {
    return (0, $acw62.useImperativeHandle)(ref, ()=>{
        const refObj = init();
        const { nativeElement: nativeElement } = refObj;
        if (typeof Proxy !== "undefined") return new Proxy(nativeElement, {
            get (obj, prop) {
                if (refObj[prop]) return refObj[prop];
                return Reflect.get(obj, prop);
            }
        });
        // Fallback of IE
        return $f0212a5d02e19b33$var$fillProxy(nativeElement, refObj);
    });
}



/* eslint-disable */ function $a8ca81d24930dc06$export$24656b269d8df7d6(t, b, c, d) {
    const cc = c - b;
    // biome-ignore lint: it is a common easing function
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // biome-ignore lint: it is a common easing function
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}


function $bf032ca2c6c444c9$export$5a096129d439f843(obj) {
    return obj !== null && obj !== undefined && obj === obj.window;
}
const $bf032ca2c6c444c9$var$getScroll = (target)=>{
    var _a, _b;
    if (typeof window === "undefined") return 0;
    let result = 0;
    if ($bf032ca2c6c444c9$export$5a096129d439f843(target)) result = target.pageYOffset;
    else if (target instanceof Document) result = target.documentElement.scrollTop;
    else if (target instanceof HTMLElement) result = target.scrollTop;
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    /* biome-ignore lint/complexity/useLiteralKeys: target is a never type */ /* eslint-disable-next-line dot-notation */ result = target["scrollTop"];
    if (target && !$bf032ca2c6c444c9$export$5a096129d439f843(target) && typeof result !== "number") result = (_b = ((_a = target.ownerDocument) !== null && _a !== void 0 ? _a : target).documentElement) === null || _b === void 0 ? void 0 : _b.scrollTop;
    return result;
};
var $bf032ca2c6c444c9$export$2e2bcd8739ae039 = $bf032ca2c6c444c9$var$getScroll;


function $4262b79604674a3c$export$2e2bcd8739ae039(y) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { getContainer: getContainer = ()=>window, callback: callback, duration: duration = 450 } = options;
    const container = getContainer();
    const scrollTop = (0, $bf032ca2c6c444c9$export$2e2bcd8739ae039)(container);
    const startTime = Date.now();
    const frameFunc = ()=>{
        const timestamp = Date.now();
        const time = timestamp - startTime;
        const nextScrollTop = (0, $a8ca81d24930dc06$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, $bf032ca2c6c444c9$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, nextScrollTop);
        else if (container instanceof Document || container.constructor.name === "HTMLDocument") container.documentElement.scrollTop = nextScrollTop;
        else container.scrollTop = nextScrollTop;
        if (time < duration) (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(frameFunc);
        else if (typeof callback === "function") callback();
    };
    (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(frameFunc);
}













var $acw62 = parcelRequire("acw62");

"use client";
function $8f25299cf0da5780$var$renderExpandIcon(locale) {
    return function expandIcon(_ref) {
        let { prefixCls: prefixCls, onExpand: onExpand, record: record, expanded: expanded, expandable: expandable } = _ref;
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        return /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            onClick: (e)=>{
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(iconPrefix, {
                [`${iconPrefix}-spaced`]: !expandable,
                [`${iconPrefix}-expanded`]: expandable && expanded,
                [`${iconPrefix}-collapsed`]: expandable && !expanded
            }),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $8f25299cf0da5780$export$2e2bcd8739ae039 = $8f25299cf0da5780$var$renderExpandIcon;


function $2da82ee1b6da5550$export$2e2bcd8739ae039(prefixCls) {
    const getContainerWidth = (ele, width)=>{
        const container = ele.querySelector(`.${prefixCls}-container`);
        let returnWidth = width;
        if (container) {
            const style = getComputedStyle(container);
            const borderLeft = parseInt(style.borderLeftWidth, 10);
            const borderRight = parseInt(style.borderRightWidth, 10);
            returnWidth = width - borderLeft - borderRight;
        }
        return returnWidth;
    };
    return getContainerWidth;
}




var $acw62 = parcelRequire("acw62");

function $10b8a922ada6c9c1$export$480219a02f196e72(column, defaultKey) {
    if ("key" in column && column.key !== undefined && column.key !== null) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join(".") : column.dataIndex;
    return defaultKey;
}
function $10b8a922ada6c9c1$export$7e4db04adce9b4db(index, pos) {
    return pos ? `${pos}-${index}` : `${index}`;
}
function $10b8a922ada6c9c1$export$cfda450db2088de7(title, props) {
    if (typeof title === "function") return title(props);
    return title;
}
function $10b8a922ada6c9c1$export$1c24e0676a106839(title, props) {
    const res = $10b8a922ada6c9c1$export$cfda450db2088de7(title, props);
    if (Object.prototype.toString.call(res) === "[object Object]") return "";
    return res;
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5dc9c75e7259b2a6$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
var $5dc9c75e7259b2a6$export$2e2bcd8739ae039 = $5dc9c75e7259b2a6$var$FilterFilled;



var $6d4c3c11d072512d$var$FilterFilled = function FilterFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5dc9c75e7259b2a6$export$2e2bcd8739ae039)
    }));
};
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0OSA4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNjQySDM0OXYxOTZ6bTUzMS4xLTY4NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4bDIyMS4zIDM3NmgzNDguOGwyMjEuMy0zNzZjMTIuMS0yMS4zLTMuMi00OC0yNy43LTQ4eiIgLz48L3N2Zz4=) */ var $6d4c3c11d072512d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($6d4c3c11d072512d$var$FilterFilled);
var $6d4c3c11d072512d$export$2e2bcd8739ae039 = $6d4c3c11d072512d$var$RefIcon;





var $acw62 = parcelRequire("acw62");

function $1f7b7badb410ab86$export$2e2bcd8739ae039(initialValue) {
    const ref = $acw62.useRef(initialValue);
    const forceUpdate = (0, $dcbb6d0bd42650d6$export$2e2bcd8739ae039)();
    return [
        ()=>ref.current,
        (newValue)=>{
            ref.current = newValue;
            // re-render
            forceUpdate();
        }
    ];
}


























var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $3f745b9b85452e9b$export$2e2bcd8739ae039(_ref) {
    var dropPosition = _ref.dropPosition, dropLevelOffset = _ref.dropLevelOffset, indent = _ref.indent;
    var style = {
        pointerEvents: "none",
        position: "absolute",
        right: 0,
        backgroundColor: "red",
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ $acw62.createElement("div", {
        style: style
    });
}



function $23eccd30fa89cd48$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}







var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

function $b387b11e1bcca75f$export$2e2bcd8739ae039(triggerStart, triggerEnd) {
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), firstMount = _React$useState2[0], setFirstMount = _React$useState2[1];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (firstMount) {
            triggerStart();
            return function() {
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        setFirstMount(true);
        return function() {
            setFirstMount(false);
        };
    }, []);
}



var $00491823df84b2f1$var$_excluded = [
    "className",
    "style",
    "motion",
    "motionNodes",
    "motionType",
    "onMotionStart",
    "onMotionEnd",
    "active",
    "treeNodeRequiredProps"
];
var $00491823df84b2f1$var$MotionTreeNode = function MotionTreeNode(_ref, ref) {
    var className = _ref.className, style = _ref.style, motion = _ref.motion, motionNodes = _ref.motionNodes, motionType = _ref.motionType, onOriginMotionStart = _ref.onMotionStart, onOriginMotionEnd = _ref.onMotionEnd, active = _ref.active, treeNodeRequiredProps = _ref.treeNodeRequiredProps, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $00491823df84b2f1$var$_excluded);
    var _React$useState = $acw62.useState(true), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), visible = _React$useState2[0], setVisible = _React$useState2[1];
    var _React$useContext = $acw62.useContext((0, $006d2f9f7167e028$export$dfae7d399eea2568)), prefixCls = _React$useContext.prefixCls;
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    var targetVisible = motionNodes && motionType !== "hide";
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    var triggerMotionStart = function triggerMotionStart() {
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    var triggerMotionEndRef = $acw62.useRef(false);
    var triggerMotionEnd = function triggerMotionEnd() {
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $b387b11e1bcca75f$export$2e2bcd8739ae039)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    var onVisibleChanged = function onVisibleChanged(nextVisible) {
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === "show",
        onVisibleChanged: onVisibleChanged
    }), function(_ref2, motionRef) {
        var motionClassName = _ref2.className, motionStyle = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement("div", {
            ref: motionRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-treenode-motion"), motionClassName),
            style: motionStyle
        }, motionNodes.map(function(treeNode) {
            var restProps = Object.assign({}, ((0, $23eccd30fa89cd48$export$2e2bcd8739ae039)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
            delete restProps.children;
            var treeNodeProps = (0, $e0866d8dd7f10128$export$d961fd523a514db5)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $acw62.createElement((0, $414eed6175d6b51d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        }));
    });
    return /*#__PURE__*/ $acw62.createElement((0, $414eed6175d6b51d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
};
$00491823df84b2f1$var$MotionTreeNode.displayName = "MotionTreeNode";
var $00491823df84b2f1$var$RefMotionTreeNode = /*#__PURE__*/ $acw62.forwardRef($00491823df84b2f1$var$MotionTreeNode);
var $00491823df84b2f1$export$2e2bcd8739ae039 = $00491823df84b2f1$var$RefMotionTreeNode;


function $577136c4898a9394$export$d561f9b5d6be9236() {
    var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var prevLen = prev.length;
    var nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        var cache = new Map();
        shorter.forEach(function(key) {
            cache.set(key, true);
        });
        var keys = longer.filter(function(key) {
            return !cache.has(key);
        });
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $577136c4898a9394$export$d9cfb1169163442d(shorter, longer, key) {
    var shorterStartIndex = shorter.findIndex(function(data) {
        return data.key === key;
    });
    var shorterEndNode = shorter[shorterStartIndex + 1];
    var longerStartIndex = longer.findIndex(function(data) {
        return data.key === key;
    });
    if (shorterEndNode) {
        var longerEndIndex = longer.findIndex(function(data) {
            return data.key === shorterEndNode.key;
        });
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}



var $3d87a790a526c3d0$var$_excluded = [
    "prefixCls",
    "data",
    "selectable",
    "checkable",
    "expandedKeys",
    "selectedKeys",
    "checkedKeys",
    "loadedKeys",
    "loadingKeys",
    "halfCheckedKeys",
    "keyEntities",
    "disabled",
    "dragging",
    "dragOverNodeKey",
    "dropPosition",
    "motion",
    "height",
    "itemHeight",
    "virtual",
    "focusable",
    "activeItem",
    "focused",
    "tabIndex",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onActiveChange",
    "onListChangeStart",
    "onListChangeEnd"
];
var $3d87a790a526c3d0$var$HIDDEN_STYLE = {
    width: 0,
    height: 0,
    display: "flex",
    overflow: "hidden",
    opacity: 0,
    border: 0,
    padding: 0,
    margin: 0
};
var $3d87a790a526c3d0$var$noop = function noop() {};
var $3d87a790a526c3d0$export$17c02cdd52a7d889 = "RC_TREE_MOTION_".concat(Math.random());
var $3d87a790a526c3d0$var$MotionNode = {
    key: $3d87a790a526c3d0$export$17c02cdd52a7d889
};
var $3d87a790a526c3d0$export$2d18abad5109a402 = {
    key: $3d87a790a526c3d0$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: "0",
    node: $3d87a790a526c3d0$var$MotionNode,
    nodes: [
        $3d87a790a526c3d0$var$MotionNode
    ]
};
var $3d87a790a526c3d0$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $3d87a790a526c3d0$export$2d18abad5109a402.pos,
    data: $3d87a790a526c3d0$var$MotionNode,
    title: null,
    key: $3d87a790a526c3d0$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $3d87a790a526c3d0$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $3d87a790a526c3d0$var$itemKey(item) {
    var key = item.key, pos = item.pos;
    return (0, $e0866d8dd7f10128$export$a47fb462a08de82f)(key, pos);
}
function $3d87a790a526c3d0$var$getAccessibilityPath(item) {
    var path = String(item.data.key);
    var current = item;
    while(current.parent){
        current = current.parent;
        path = "".concat(current.data.key, " > ").concat(path);
    }
    return path;
}
var $3d87a790a526c3d0$var$NodeList = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, data = props.data, selectable = props.selectable, checkable = props.checkable, expandedKeys = props.expandedKeys, selectedKeys = props.selectedKeys, checkedKeys = props.checkedKeys, loadedKeys = props.loadedKeys, loadingKeys = props.loadingKeys, halfCheckedKeys = props.halfCheckedKeys, keyEntities = props.keyEntities, disabled = props.disabled, dragging = props.dragging, dragOverNodeKey = props.dragOverNodeKey, dropPosition = props.dropPosition, motion = props.motion, height = props.height, itemHeight = props.itemHeight, virtual = props.virtual, focusable = props.focusable, activeItem = props.activeItem, focused = props.focused, tabIndex = props.tabIndex, onKeyDown = props.onKeyDown, onFocus = props.onFocus, onBlur = props.onBlur, onActiveChange = props.onActiveChange, onListChangeStart = props.onListChangeStart, onListChangeEnd = props.onListChangeEnd, domProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $3d87a790a526c3d0$var$_excluded);
    // =============================== Ref ================================
    var listRef = $acw62.useRef(null);
    var indentMeasurerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, function() {
        return {
            scrollTo: function scrollTo(scroll) {
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: function getIndentWidth() {
                return indentMeasurerRef.current.offsetWidth;
            }
        };
    });
    // ============================== Motion ==============================
    var _React$useState = $acw62.useState(expandedKeys), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), prevExpandedKeys = _React$useState2[0], setPrevExpandedKeys = _React$useState2[1];
    var _React$useState3 = $acw62.useState(data), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), prevData = _React$useState4[0], setPrevData = _React$useState4[1];
    var _React$useState5 = $acw62.useState(data), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), transitionData = _React$useState6[0], setTransitionData = _React$useState6[1];
    var _React$useState7 = $acw62.useState([]), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), transitionRange = _React$useState8[0], setTransitionRange = _React$useState8[1];
    var _React$useState9 = $acw62.useState(null), _React$useState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState9, 2), motionType = _React$useState10[0], setMotionType = _React$useState10[1];
    // When motion end but data change, this will makes data back to previous one
    var dataRef = $acw62.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        var latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        setPrevExpandedKeys(expandedKeys);
        var diffExpanded = (0, $577136c4898a9394$export$d561f9b5d6be9236)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                var keyIndex = prevData.findIndex(function(_ref) {
                    var key = _ref.key;
                    return key === diffExpanded.key;
                });
                var rangeNodes = $3d87a790a526c3d0$export$435bacc8d7a01e14((0, $577136c4898a9394$export$d9cfb1169163442d)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                var newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $3d87a790a526c3d0$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType("show");
            } else {
                var _keyIndex = data.findIndex(function(_ref2) {
                    var key = _ref2.key;
                    return key === diffExpanded.key;
                });
                var _rangeNodes = $3d87a790a526c3d0$export$435bacc8d7a01e14((0, $577136c4898a9394$export$d9cfb1169163442d)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                var _newTransitionData = data.slice();
                _newTransitionData.splice(_keyIndex + 1, 0, $3d87a790a526c3d0$var$MotionFlattenData);
                setTransitionData(_newTransitionData);
                setTransitionRange(_rangeNodes);
                setMotionType("hide");
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $acw62.useEffect(function() {
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    var mergedData = motion ? transitionData : data;
    var treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, focused && activeItem && /*#__PURE__*/ $acw62.createElement("span", {
        style: $3d87a790a526c3d0$var$HIDDEN_STYLE,
        "aria-live": "assertive"
    }, $3d87a790a526c3d0$var$getAccessibilityPath(activeItem)), /*#__PURE__*/ $acw62.createElement("div", null, /*#__PURE__*/ $acw62.createElement("input", {
        style: $3d87a790a526c3d0$var$HIDDEN_STYLE,
        disabled: focusable === false || disabled,
        tabIndex: focusable !== false ? tabIndex : null,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        value: "",
        onChange: $3d87a790a526c3d0$var$noop,
        "aria-label": "for screen reader"
    })), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-treenode"),
        "aria-hidden": true,
        style: {
            position: "absolute",
            pointerEvents: "none",
            visibility: "hidden",
            height: 0,
            overflow: "hidden",
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-indent")
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: indentMeasurerRef,
        className: "".concat(prefixCls, "-indent-unit")
    }))), /*#__PURE__*/ $acw62.createElement((0, $2f16cd4e45d13ddf$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, domProps, {
        data: mergedData,
        itemKey: $3d87a790a526c3d0$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        prefixCls: "".concat(prefixCls, "-list"),
        ref: listRef,
        onVisibleChange: function onVisibleChange(originList, fullList) {
            var originSet = new Set(originList);
            var restList = fullList.filter(function(item) {
                return !originSet.has(item);
            });
            // Motion node is not render. Skip motion
            if (restList.some(function(item) {
                return $3d87a790a526c3d0$var$itemKey(item) === $3d87a790a526c3d0$export$17c02cdd52a7d889;
            })) onMotionEnd();
        }
    }), function(treeNode) {
        var pos = treeNode.pos, restProps = Object.assign({}, ((0, $23eccd30fa89cd48$export$2e2bcd8739ae039)(treeNode.data), treeNode.data)), title = treeNode.title, key = treeNode.key, isStart = treeNode.isStart, isEnd = treeNode.isEnd;
        var mergedKey = (0, $e0866d8dd7f10128$export$a47fb462a08de82f)(key, pos);
        delete restProps.key;
        delete restProps.children;
        var treeNodeProps = (0, $e0866d8dd7f10128$export$d961fd523a514db5)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $acw62.createElement((0, $00491823df84b2f1$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $3d87a790a526c3d0$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            onMouseMove: function onMouseMove() {
                onActiveChange(null);
            }
        }));
    }));
});
$3d87a790a526c3d0$var$NodeList.displayName = "NodeList";
var $3d87a790a526c3d0$export$2e2bcd8739ae039 = $3d87a790a526c3d0$var$NodeList;







var $014366ec5d4b5909$var$MAX_RETRY_TIMES = 10;
var $014366ec5d4b5909$var$Tree = /*#__PURE__*/ function(_React$Component) {
    (0, $0ed648f7bbaf3aff$export$2e2bcd8739ae039)(Tree, _React$Component);
    var _super = (0, $a76f20fb39fa9d46$export$2e2bcd8739ae039)(Tree);
    function Tree() {
        var _this;
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Tree);
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(_args));
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "destroyed", false);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "delayedDragEnterLogic", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "loadingRetryTimes", {});
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "state", {
            keyEntities: {},
            indent: null,
            selectedKeys: [],
            checkedKeys: [],
            halfCheckedKeys: [],
            loadedKeys: [],
            loadingKeys: [],
            expandedKeys: [],
            draggingNodeKey: null,
            dragChildrenKeys: [],
            // dropTargetKey is the key of abstract-drop-node
            // the abstract-drop-node is the real drop node when drag and drop
            // not the DOM drag over node
            dropTargetKey: null,
            dropPosition: null,
            // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
            dropContainerKey: null,
            // the container key of abstract-drop-node if dropPosition is -1 or 1
            dropLevelOffset: null,
            // the drop level offset of abstract-drag-over-node
            dropTargetPos: null,
            // the pos of abstract-drop-node
            dropAllowed: true,
            // if drop to abstract-drop-node is allowed
            // the abstract-drag-over-node
            // if mouse is on the bottom of top dom node or no the top of the bottom dom node
            // abstract-drag-over-node is the top node
            dragOverNodeKey: null,
            treeData: [],
            flattenNodes: [],
            focused: false,
            activeKey: null,
            listChanging: false,
            prevProps: null,
            fieldNames: (0, $e0866d8dd7f10128$export$6c519d302dced239)()
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "dragStartMousePosition", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "dragNode", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "currentMouseOverDroppableNodeKey", null);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "listRef", /*#__PURE__*/ $acw62.createRef());
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeDragStart", function(event, node) {
            var _this$state = _this.state, expandedKeys = _this$state.expandedKeys, keyEntities = _this$state.keyEntities;
            var onDragStart = _this.props.onDragStart;
            var eventKey = node.props.eventKey;
            _this.dragNode = node;
            _this.dragStartMousePosition = {
                x: event.clientX,
                y: event.clientY
            };
            var newExpandedKeys = (0, $af974b6720932c91$export$5bfb9ff497fe2298)(expandedKeys, eventKey);
            _this.setState({
                draggingNodeKey: eventKey,
                dragChildrenKeys: (0, $af974b6720932c91$export$b0610c44bcbb051c)(eventKey, keyEntities),
                indent: _this.listRef.current.getIndentWidth()
            });
            _this.setExpandedKeys(newExpandedKeys);
            window.addEventListener("dragend", _this.onWindowDragEnd);
            onDragStart === null || onDragStart === void 0 || onDragStart({
                event: event,
                node: (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(node.props)
            });
        });
        /**
     * [Legacy] Select handler is smaller than node,
     * so that this will trigger when drag enter node or select handler.
     * This is a little tricky if customize css without padding.
     * Better for use mouse move event to refresh drag state.
     * But let's just keep it to avoid event trigger logic change.
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeDragEnter", function(event, node) {
            var _this$state2 = _this.state, expandedKeys = _this$state2.expandedKeys, keyEntities = _this$state2.keyEntities, dragChildrenKeys = _this$state2.dragChildrenKeys, flattenNodes = _this$state2.flattenNodes, indent = _this$state2.indent;
            var _this$props = _this.props, onDragEnter = _this$props.onDragEnter, onExpand = _this$props.onExpand, allowDrop = _this$props.allowDrop, direction = _this$props.direction;
            var _node$props = node.props, pos = _node$props.pos, eventKey = _node$props.eventKey;
            var _assertThisInitialize = (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), dragNode = _assertThisInitialize.dragNode;
            // record the key of node which is latest entered, used in dragleave event.
            if (_this.currentMouseOverDroppableNodeKey !== eventKey) _this.currentMouseOverDroppableNodeKey = eventKey;
            if (!dragNode) {
                _this.resetDragState();
                return;
            }
            var _calcDropPosition = (0, $af974b6720932c91$export$78a5519d0fb779c3)(event, dragNode, node, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition.dropPosition, dropLevelOffset = _calcDropPosition.dropLevelOffset, dropTargetKey = _calcDropPosition.dropTargetKey, dropContainerKey = _calcDropPosition.dropContainerKey, dropTargetPos = _calcDropPosition.dropTargetPos, dropAllowed = _calcDropPosition.dropAllowed, dragOverNodeKey = _calcDropPosition.dragOverNodeKey;
            if (// don't allow drop inside its children
            dragChildrenKeys.indexOf(dropTargetKey) !== -1 || // don't allow drop when drop is not allowed caculated by calcDropPosition
            !dropAllowed) {
                _this.resetDragState();
                return;
            }
            // Side effect for delay drag
            if (!_this.delayedDragEnterLogic) _this.delayedDragEnterLogic = {};
            Object.keys(_this.delayedDragEnterLogic).forEach(function(key) {
                clearTimeout(_this.delayedDragEnterLogic[key]);
            });
            if (dragNode.props.eventKey !== node.props.eventKey) {
                // hoist expand logic here
                // since if logic is on the bottom
                // it will be blocked by abstract dragover node check
                //   => if you dragenter from top, you mouse will still be consider as in the top node
                event.persist();
                _this.delayedDragEnterLogic[pos] = window.setTimeout(function() {
                    if (_this.state.draggingNodeKey === null) return;
                    var newExpandedKeys = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(expandedKeys);
                    var entity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, node.props.eventKey);
                    if (entity && (entity.children || []).length) newExpandedKeys = (0, $af974b6720932c91$export$10663f6bbd2fd717)(expandedKeys, node.props.eventKey);
                    if (!("expandedKeys" in _this.props)) _this.setExpandedKeys(newExpandedKeys);
                    onExpand === null || onExpand === void 0 || onExpand(newExpandedKeys, {
                        node: (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(node.props),
                        expanded: true,
                        nativeEvent: event.nativeEvent
                    });
                }, 800);
            }
            // Skip if drag node is self
            if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
                _this.resetDragState();
                return;
            }
            // Update drag over node and drag state
            _this.setState({
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed
            });
            onDragEnter === null || onDragEnter === void 0 || onDragEnter({
                event: event,
                node: (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(node.props),
                expandedKeys: expandedKeys
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeDragOver", function(event, node) {
            var _this$state3 = _this.state, dragChildrenKeys = _this$state3.dragChildrenKeys, flattenNodes = _this$state3.flattenNodes, keyEntities = _this$state3.keyEntities, expandedKeys = _this$state3.expandedKeys, indent = _this$state3.indent;
            var _this$props2 = _this.props, onDragOver = _this$props2.onDragOver, allowDrop = _this$props2.allowDrop, direction = _this$props2.direction;
            var _assertThisInitialize2 = (0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), dragNode = _assertThisInitialize2.dragNode;
            if (!dragNode) return;
            var _calcDropPosition2 = (0, $af974b6720932c91$export$78a5519d0fb779c3)(event, dragNode, node, indent, _this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction), dropPosition = _calcDropPosition2.dropPosition, dropLevelOffset = _calcDropPosition2.dropLevelOffset, dropTargetKey = _calcDropPosition2.dropTargetKey, dropContainerKey = _calcDropPosition2.dropContainerKey, dropAllowed = _calcDropPosition2.dropAllowed, dropTargetPos = _calcDropPosition2.dropTargetPos, dragOverNodeKey = _calcDropPosition2.dragOverNodeKey;
            if (dragChildrenKeys.indexOf(dropTargetKey) !== -1 || !dropAllowed) // don't allow drop inside its children
            // don't allow drop when drop is not allowed calculated by calcDropPosition
            return;
            // Update drag position
            if (dragNode.props.eventKey === dropTargetKey && dropLevelOffset === 0) {
                if (!(_this.state.dropPosition === null && _this.state.dropLevelOffset === null && _this.state.dropTargetKey === null && _this.state.dropContainerKey === null && _this.state.dropTargetPos === null && _this.state.dropAllowed === false && _this.state.dragOverNodeKey === null)) _this.resetDragState();
            } else if (!(dropPosition === _this.state.dropPosition && dropLevelOffset === _this.state.dropLevelOffset && dropTargetKey === _this.state.dropTargetKey && dropContainerKey === _this.state.dropContainerKey && dropTargetPos === _this.state.dropTargetPos && dropAllowed === _this.state.dropAllowed && dragOverNodeKey === _this.state.dragOverNodeKey)) _this.setState({
                dropPosition: dropPosition,
                dropLevelOffset: dropLevelOffset,
                dropTargetKey: dropTargetKey,
                dropContainerKey: dropContainerKey,
                dropTargetPos: dropTargetPos,
                dropAllowed: dropAllowed,
                dragOverNodeKey: dragOverNodeKey
            });
            onDragOver === null || onDragOver === void 0 || onDragOver({
                event: event,
                node: (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(node.props)
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeDragLeave", function(event, node) {
            // if it is outside the droppable area
            // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
            if (_this.currentMouseOverDroppableNodeKey === node.props.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
                _this.resetDragState();
                _this.currentMouseOverDroppableNodeKey = null;
            }
            var onDragLeave = _this.props.onDragLeave;
            onDragLeave === null || onDragLeave === void 0 || onDragLeave({
                event: event,
                node: (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(node.props)
            });
        });
        // since stopPropagation() is called in treeNode
        // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onWindowDragEnd", function(event) {
            _this.onNodeDragEnd(event, null, true);
            window.removeEventListener("dragend", _this.onWindowDragEnd);
        });
        // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeDragEnd", function(event, node) {
            var onDragEnd = _this.props.onDragEnd;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                event: event,
                node: (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(node.props)
            });
            _this.dragNode = null;
            window.removeEventListener("dragend", _this.onWindowDragEnd);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeDrop", function(event, node) {
            var _this$getActiveItem;
            var outsideTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var _this$state4 = _this.state, dragChildrenKeys = _this$state4.dragChildrenKeys, dropPosition = _this$state4.dropPosition, dropTargetKey = _this$state4.dropTargetKey, dropTargetPos = _this$state4.dropTargetPos, dropAllowed = _this$state4.dropAllowed;
            if (!dropAllowed) return;
            var onDrop = _this.props.onDrop;
            _this.setState({
                dragOverNodeKey: null
            });
            _this.cleanDragState();
            if (dropTargetKey === null) return;
            var abstractDropNodeProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $e0866d8dd7f10128$export$d961fd523a514db5)(dropTargetKey, _this.getTreeNodeRequiredProps())), {}, {
                active: ((_this$getActiveItem = _this.getActiveItem()) === null || _this$getActiveItem === void 0 ? void 0 : _this$getActiveItem.key) === dropTargetKey,
                data: (0, $2bbd948531562d93$export$2e2bcd8739ae039)(_this.state.keyEntities, dropTargetKey).node
            });
            var dropToChild = dragChildrenKeys.indexOf(dropTargetKey) !== -1;
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
            var posArr = (0, $af974b6720932c91$export$ddaee97dc8907312)(dropTargetPos);
            var dropResult = {
                event: event,
                node: (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(abstractDropNodeProps),
                dragNode: _this.dragNode ? (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)(_this.dragNode.props) : null,
                dragNodesKeys: [
                    _this.dragNode.props.eventKey
                ].concat(dragChildrenKeys),
                dropToGap: dropPosition !== 0,
                dropPosition: dropPosition + Number(posArr[posArr.length - 1])
            };
            if (!outsideTree) onDrop === null || onDrop === void 0 || onDrop(dropResult);
            _this.dragNode = null;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "cleanDragState", function() {
            var draggingNodeKey = _this.state.draggingNodeKey;
            if (draggingNodeKey !== null) _this.setState({
                draggingNodeKey: null,
                dropPosition: null,
                dropContainerKey: null,
                dropTargetKey: null,
                dropLevelOffset: null,
                dropAllowed: true,
                dragOverNodeKey: null
            });
            _this.dragStartMousePosition = null;
            _this.currentMouseOverDroppableNodeKey = null;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "triggerExpandActionExpand", function(e, treeNode) {
            var _this$state5 = _this.state, expandedKeys = _this$state5.expandedKeys, flattenNodes = _this$state5.flattenNodes;
            var expanded = treeNode.expanded, key = treeNode.key, isLeaf = treeNode.isLeaf;
            if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
            var node = flattenNodes.filter(function(nodeItem) {
                return nodeItem.key === key;
            })[0];
            var eventNode = (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $e0866d8dd7f10128$export$d961fd523a514db5)(key, _this.getTreeNodeRequiredProps())), {}, {
                data: node.data
            }));
            _this.setExpandedKeys(expanded ? (0, $af974b6720932c91$export$5bfb9ff497fe2298)(expandedKeys, key) : (0, $af974b6720932c91$export$10663f6bbd2fd717)(expandedKeys, key));
            _this.onNodeExpand(e, eventNode);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeClick", function(e, treeNode) {
            var _this$props3 = _this.props, onClick = _this$props3.onClick, expandAction = _this$props3.expandAction;
            if (expandAction === "click") _this.triggerExpandActionExpand(e, treeNode);
            onClick === null || onClick === void 0 || onClick(e, treeNode);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeDoubleClick", function(e, treeNode) {
            var _this$props4 = _this.props, onDoubleClick = _this$props4.onDoubleClick, expandAction = _this$props4.expandAction;
            if (expandAction === "doubleClick") _this.triggerExpandActionExpand(e, treeNode);
            onDoubleClick === null || onDoubleClick === void 0 || onDoubleClick(e, treeNode);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeSelect", function(e, treeNode) {
            var selectedKeys = _this.state.selectedKeys;
            var _this$state6 = _this.state, keyEntities = _this$state6.keyEntities, fieldNames = _this$state6.fieldNames;
            var _this$props5 = _this.props, onSelect = _this$props5.onSelect, multiple = _this$props5.multiple;
            var selected = treeNode.selected;
            var key = treeNode[fieldNames.key];
            var targetSelected = !selected;
            // Update selected keys
            if (!targetSelected) selectedKeys = (0, $af974b6720932c91$export$5bfb9ff497fe2298)(selectedKeys, key);
            else if (!multiple) selectedKeys = [
                key
            ];
            else selectedKeys = (0, $af974b6720932c91$export$10663f6bbd2fd717)(selectedKeys, key);
            // [Legacy] Not found related usage in doc or upper libs
            var selectedNodes = selectedKeys.map(function(selectedKey) {
                var entity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, selectedKey);
                if (!entity) return null;
                return entity.node;
            }).filter(function(node) {
                return node;
            });
            _this.setUncontrolledState({
                selectedKeys: selectedKeys
            });
            onSelect === null || onSelect === void 0 || onSelect(selectedKeys, {
                event: "select",
                selected: targetSelected,
                node: treeNode,
                selectedNodes: selectedNodes,
                nativeEvent: e.nativeEvent
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeCheck", function(e, treeNode, checked) {
            var _this$state7 = _this.state, keyEntities = _this$state7.keyEntities, oriCheckedKeys = _this$state7.checkedKeys, oriHalfCheckedKeys = _this$state7.halfCheckedKeys;
            var _this$props6 = _this.props, checkStrictly = _this$props6.checkStrictly, onCheck = _this$props6.onCheck;
            var key = treeNode.key;
            // Prepare trigger arguments
            var checkedObj;
            var eventObj = {
                event: "check",
                node: treeNode,
                checked: checked,
                nativeEvent: e.nativeEvent
            };
            if (checkStrictly) {
                var checkedKeys = checked ? (0, $af974b6720932c91$export$10663f6bbd2fd717)(oriCheckedKeys, key) : (0, $af974b6720932c91$export$5bfb9ff497fe2298)(oriCheckedKeys, key);
                var halfCheckedKeys = (0, $af974b6720932c91$export$5bfb9ff497fe2298)(oriHalfCheckedKeys, key);
                checkedObj = {
                    checked: checkedKeys,
                    halfChecked: halfCheckedKeys
                };
                eventObj.checkedNodes = checkedKeys.map(function(checkedKey) {
                    return (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                }).filter(function(entity) {
                    return entity;
                }).map(function(entity) {
                    return entity.node;
                });
                _this.setUncontrolledState({
                    checkedKeys: checkedKeys
                });
            } else {
                // Always fill first
                var _conductCheck = (0, $4d7359063b3a6d19$export$43adf2c483e3e633)([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(oriCheckedKeys), [
                    key
                ]), true, keyEntities), _checkedKeys = _conductCheck.checkedKeys, _halfCheckedKeys = _conductCheck.halfCheckedKeys;
                // If remove, we do it again to correction
                if (!checked) {
                    var keySet = new Set(_checkedKeys);
                    keySet.delete(key);
                    var _conductCheck2 = (0, $4d7359063b3a6d19$export$43adf2c483e3e633)(Array.from(keySet), {
                        checked: false,
                        halfCheckedKeys: _halfCheckedKeys
                    }, keyEntities);
                    _checkedKeys = _conductCheck2.checkedKeys;
                    _halfCheckedKeys = _conductCheck2.halfCheckedKeys;
                }
                checkedObj = _checkedKeys;
                // [Legacy] This is used for `rc-tree-select`
                eventObj.checkedNodes = [];
                eventObj.checkedNodesPositions = [];
                eventObj.halfCheckedKeys = _halfCheckedKeys;
                _checkedKeys.forEach(function(checkedKey) {
                    var entity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                    if (!entity) return;
                    var node = entity.node, pos = entity.pos;
                    eventObj.checkedNodes.push(node);
                    eventObj.checkedNodesPositions.push({
                        node: node,
                        pos: pos
                    });
                });
                _this.setUncontrolledState({
                    checkedKeys: _checkedKeys
                }, false, {
                    halfCheckedKeys: _halfCheckedKeys
                });
            }
            onCheck === null || onCheck === void 0 || onCheck(checkedObj, eventObj);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeLoad", function(treeNode) {
            var _entity$children;
            var key = treeNode.key;
            var keyEntities = _this.state.keyEntities;
            // Skip if has children already
            var entity = (0, $2bbd948531562d93$export$2e2bcd8739ae039)(keyEntities, key);
            if (entity !== null && entity !== void 0 && (_entity$children = entity.children) !== null && _entity$children !== void 0 && _entity$children.length) return;
            var loadPromise = new Promise(function(resolve, reject) {
                // We need to get the latest state of loading/loaded keys
                _this.setState(function(_ref) {
                    var _ref$loadedKeys = _ref.loadedKeys, loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys, _ref$loadingKeys = _ref.loadingKeys, loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
                    var _this$props7 = _this.props, loadData = _this$props7.loadData, onLoad = _this$props7.onLoad;
                    if (!loadData || loadedKeys.indexOf(key) !== -1 || loadingKeys.indexOf(key) !== -1) return null;
                    // Process load data
                    var promise = loadData(treeNode);
                    promise.then(function() {
                        var currentLoadedKeys = _this.state.loadedKeys;
                        var newLoadedKeys = (0, $af974b6720932c91$export$10663f6bbd2fd717)(currentLoadedKeys, key);
                        // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                        // https://github.com/ant-design/ant-design/issues/12464
                        onLoad === null || onLoad === void 0 || onLoad(newLoadedKeys, {
                            event: "load",
                            node: treeNode
                        });
                        _this.setUncontrolledState({
                            loadedKeys: newLoadedKeys
                        });
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $af974b6720932c91$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                            };
                        });
                        resolve();
                    }).catch(function(e) {
                        _this.setState(function(prevState) {
                            return {
                                loadingKeys: (0, $af974b6720932c91$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                            };
                        });
                        // If exceed max retry times, we give up retry
                        _this.loadingRetryTimes[key] = (_this.loadingRetryTimes[key] || 0) + 1;
                        if (_this.loadingRetryTimes[key] >= $014366ec5d4b5909$var$MAX_RETRY_TIMES) {
                            var currentLoadedKeys = _this.state.loadedKeys;
                            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Retry for `loadData` many times but still failed. No more retry.");
                            _this.setUncontrolledState({
                                loadedKeys: (0, $af974b6720932c91$export$10663f6bbd2fd717)(currentLoadedKeys, key)
                            });
                            resolve();
                        }
                        reject(e);
                    });
                    return {
                        loadingKeys: (0, $af974b6720932c91$export$10663f6bbd2fd717)(loadingKeys, key)
                    };
                });
            });
            // Not care warning if we ignore this
            loadPromise.catch(function() {});
            return loadPromise;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeMouseEnter", function(event, node) {
            var onMouseEnter = _this.props.onMouseEnter;
            onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter({
                event: event,
                node: node
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeMouseLeave", function(event, node) {
            var onMouseLeave = _this.props.onMouseLeave;
            onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave({
                event: event,
                node: node
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeContextMenu", function(event, node) {
            var onRightClick = _this.props.onRightClick;
            if (onRightClick) {
                event.preventDefault();
                onRightClick({
                    event: event,
                    node: node
                });
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onFocus", function() {
            var onFocus = _this.props.onFocus;
            _this.setState({
                focused: true
            });
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            onFocus === null || onFocus === void 0 || onFocus.apply(void 0, args);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onBlur", function() {
            var onBlur = _this.props.onBlur;
            _this.setState({
                focused: false
            });
            _this.onActiveChange(null);
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            onBlur === null || onBlur === void 0 || onBlur.apply(void 0, args);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getTreeNodeRequiredProps", function() {
            var _this$state8 = _this.state, expandedKeys = _this$state8.expandedKeys, selectedKeys = _this$state8.selectedKeys, loadedKeys = _this$state8.loadedKeys, loadingKeys = _this$state8.loadingKeys, checkedKeys = _this$state8.checkedKeys, halfCheckedKeys = _this$state8.halfCheckedKeys, dragOverNodeKey = _this$state8.dragOverNodeKey, dropPosition = _this$state8.dropPosition, keyEntities = _this$state8.keyEntities;
            return {
                expandedKeys: expandedKeys || [],
                selectedKeys: selectedKeys || [],
                loadedKeys: loadedKeys || [],
                loadingKeys: loadingKeys || [],
                checkedKeys: checkedKeys || [],
                halfCheckedKeys: halfCheckedKeys || [],
                dragOverNodeKey: dragOverNodeKey,
                dropPosition: dropPosition,
                keyEntities: keyEntities
            };
        });
        // =========================== Expanded ===========================
        /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "setExpandedKeys", function(expandedKeys) {
            var _this$state9 = _this.state, treeData = _this$state9.treeData, fieldNames = _this$state9.fieldNames;
            var flattenNodes = (0, $e0866d8dd7f10128$export$215c1b4f1ba88b23)(treeData, expandedKeys, fieldNames);
            _this.setUncontrolledState({
                expandedKeys: expandedKeys,
                flattenNodes: flattenNodes
            }, true);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onNodeExpand", function(e, treeNode) {
            var expandedKeys = _this.state.expandedKeys;
            var _this$state10 = _this.state, listChanging = _this$state10.listChanging, fieldNames = _this$state10.fieldNames;
            var _this$props8 = _this.props, onExpand = _this$props8.onExpand, loadData = _this$props8.loadData;
            var expanded = treeNode.expanded;
            var key = treeNode[fieldNames.key];
            // Do nothing when motion is in progress
            if (listChanging) return;
            // Update selected keys
            var index = expandedKeys.indexOf(key);
            var targetExpanded = !expanded;
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(expanded && index !== -1 || !expanded && index === -1, "Expand state not sync with index check");
            if (targetExpanded) expandedKeys = (0, $af974b6720932c91$export$10663f6bbd2fd717)(expandedKeys, key);
            else expandedKeys = (0, $af974b6720932c91$export$5bfb9ff497fe2298)(expandedKeys, key);
            _this.setExpandedKeys(expandedKeys);
            onExpand === null || onExpand === void 0 || onExpand(expandedKeys, {
                node: treeNode,
                expanded: targetExpanded,
                nativeEvent: e.nativeEvent
            });
            // Async Load data
            if (targetExpanded && loadData) {
                var loadPromise = _this.onNodeLoad(treeNode);
                if (loadPromise) loadPromise.then(function() {
                    // [Legacy] Refresh logic
                    var newFlattenTreeData = (0, $e0866d8dd7f10128$export$215c1b4f1ba88b23)(_this.state.treeData, expandedKeys, fieldNames);
                    _this.setUncontrolledState({
                        flattenNodes: newFlattenTreeData
                    });
                }).catch(function() {
                    var currentExpandedKeys = _this.state.expandedKeys;
                    var expandedKeysToRestore = (0, $af974b6720932c91$export$5bfb9ff497fe2298)(currentExpandedKeys, key);
                    _this.setExpandedKeys(expandedKeysToRestore);
                });
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onListChangeStart", function() {
            _this.setUncontrolledState({
                listChanging: true
            });
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onListChangeEnd", function() {
            setTimeout(function() {
                _this.setUncontrolledState({
                    listChanging: false
                });
            });
        });
        // =========================== Keyboard ===========================
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onActiveChange", function(newActiveKey) {
            var activeKey = _this.state.activeKey;
            var _this$props9 = _this.props, onActiveChange = _this$props9.onActiveChange, _this$props9$itemScro = _this$props9.itemScrollOffset, itemScrollOffset = _this$props9$itemScro === void 0 ? 0 : _this$props9$itemScro;
            if (activeKey === newActiveKey) return;
            _this.setState({
                activeKey: newActiveKey
            });
            if (newActiveKey !== null) _this.scrollTo({
                key: newActiveKey,
                offset: itemScrollOffset
            });
            onActiveChange === null || onActiveChange === void 0 || onActiveChange(newActiveKey);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "getActiveItem", function() {
            var _this$state11 = _this.state, activeKey = _this$state11.activeKey, flattenNodes = _this$state11.flattenNodes;
            if (activeKey === null) return null;
            return flattenNodes.find(function(_ref2) {
                var key = _ref2.key;
                return key === activeKey;
            }) || null;
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "offsetActiveKey", function(offset) {
            var _this$state12 = _this.state, flattenNodes = _this$state12.flattenNodes, activeKey = _this$state12.activeKey;
            var index = flattenNodes.findIndex(function(_ref3) {
                var key = _ref3.key;
                return key === activeKey;
            });
            // Align with index
            if (index === -1 && offset < 0) index = flattenNodes.length;
            index = (index + offset + flattenNodes.length) % flattenNodes.length;
            var item = flattenNodes[index];
            if (item) {
                var _key4 = item.key;
                _this.onActiveChange(_key4);
            } else _this.onActiveChange(null);
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "onKeyDown", function(event) {
            var _this$state13 = _this.state, activeKey = _this$state13.activeKey, expandedKeys = _this$state13.expandedKeys, checkedKeys = _this$state13.checkedKeys, fieldNames = _this$state13.fieldNames;
            var _this$props10 = _this.props, onKeyDown = _this$props10.onKeyDown, checkable = _this$props10.checkable, selectable = _this$props10.selectable;
            // >>>>>>>>>> Direction
            switch(event.which){
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP:
                    _this.offsetActiveKey(-1);
                    event.preventDefault();
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN:
                    _this.offsetActiveKey(1);
                    event.preventDefault();
                    break;
            }
            // >>>>>>>>>> Expand & Selection
            var activeItem = _this.getActiveItem();
            if (activeItem && activeItem.data) {
                var treeNodeRequiredProps = _this.getTreeNodeRequiredProps();
                var expandable = activeItem.data.isLeaf === false || !!(activeItem.data[fieldNames.children] || []).length;
                var eventNode = (0, $e0866d8dd7f10128$export$7bd1b0fd4a8b540b)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $e0866d8dd7f10128$export$d961fd523a514db5)(activeKey, treeNodeRequiredProps)), {}, {
                    data: activeItem.data,
                    active: true
                }));
                switch(event.which){
                    // >>> Expand
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT:
                        // Collapse if possible
                        if (expandable && expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.parent) _this.onActiveChange(activeItem.parent.key);
                        event.preventDefault();
                        break;
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT:
                        // Expand if possible
                        if (expandable && !expandedKeys.includes(activeKey)) _this.onNodeExpand({}, eventNode);
                        else if (activeItem.children && activeItem.children.length) _this.onActiveChange(activeItem.children[0].key);
                        event.preventDefault();
                        break;
                    // Selection
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER:
                    case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).SPACE:
                        if (checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox) _this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                        else if (!checkable && selectable && !eventNode.disabled && eventNode.selectable !== false) _this.onNodeSelect({}, eventNode);
                        break;
                }
            }
            onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
        });
        /**
     * Only update the value which is not in props
     */ (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "setUncontrolledState", function(state) {
            var atomic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var forceState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            if (!_this.destroyed) {
                var needSync = false;
                var allPassed = true;
                var newState = {};
                Object.keys(state).forEach(function(name) {
                    if (name in _this.props) {
                        allPassed = false;
                        return;
                    }
                    needSync = true;
                    newState[name] = state[name];
                });
                if (needSync && (!atomic || allPassed)) _this.setState((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, newState), forceState));
            }
        });
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this), "scrollTo", function(scroll) {
            _this.listRef.current.scrollTo(scroll);
        });
        return _this;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Tree, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.destroyed = false;
                this.onUpdated();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.onUpdated();
            }
        },
        {
            key: "onUpdated",
            value: function onUpdated() {
                var _this$props11 = this.props, activeKey = _this$props11.activeKey, _this$props11$itemScr = _this$props11.itemScrollOffset, itemScrollOffset = _this$props11$itemScr === void 0 ? 0 : _this$props11$itemScr;
                if (activeKey !== undefined && activeKey !== this.state.activeKey) {
                    this.setState({
                        activeKey: activeKey
                    });
                    if (activeKey !== null) this.scrollTo({
                        key: activeKey,
                        offset: itemScrollOffset
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("dragend", this.onWindowDragEnd);
                this.destroyed = true;
            }
        },
        {
            key: "resetDragState",
            value: function resetDragState() {
                this.setState({
                    dragOverNodeKey: null,
                    dropPosition: null,
                    dropLevelOffset: null,
                    dropTargetKey: null,
                    dropContainerKey: null,
                    dropTargetPos: null,
                    dropAllowed: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state14 = this.state, focused = _this$state14.focused, flattenNodes = _this$state14.flattenNodes, keyEntities = _this$state14.keyEntities, draggingNodeKey = _this$state14.draggingNodeKey, activeKey = _this$state14.activeKey, dropLevelOffset = _this$state14.dropLevelOffset, dropContainerKey = _this$state14.dropContainerKey, dropTargetKey = _this$state14.dropTargetKey, dropPosition = _this$state14.dropPosition, dragOverNodeKey = _this$state14.dragOverNodeKey, indent = _this$state14.indent;
                var _this$props12 = this.props, prefixCls = _this$props12.prefixCls, className = _this$props12.className, style = _this$props12.style, showLine = _this$props12.showLine, focusable = _this$props12.focusable, _this$props12$tabInde = _this$props12.tabIndex, tabIndex = _this$props12$tabInde === void 0 ? 0 : _this$props12$tabInde, selectable = _this$props12.selectable, showIcon = _this$props12.showIcon, icon = _this$props12.icon, switcherIcon = _this$props12.switcherIcon, draggable = _this$props12.draggable, checkable = _this$props12.checkable, checkStrictly = _this$props12.checkStrictly, disabled = _this$props12.disabled, motion = _this$props12.motion, loadData = _this$props12.loadData, filterTreeNode = _this$props12.filterTreeNode, height = _this$props12.height, itemHeight = _this$props12.itemHeight, virtual = _this$props12.virtual, titleRender = _this$props12.titleRender, dropIndicatorRender = _this$props12.dropIndicatorRender, onContextMenu = _this$props12.onContextMenu, onScroll = _this$props12.onScroll, direction = _this$props12.direction, rootClassName = _this$props12.rootClassName, rootStyle = _this$props12.rootStyle;
                var domProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(this.props, {
                    aria: true,
                    data: true
                });
                // It's better move to hooks but we just simply keep here
                var draggableConfig;
                if (draggable) {
                    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(draggable) === "object") draggableConfig = draggable;
                    else if (typeof draggable === "function") draggableConfig = {
                        nodeDraggable: draggable
                    };
                    else draggableConfig = {};
                }
                return /*#__PURE__*/ $acw62.createElement((0, $006d2f9f7167e028$export$dfae7d399eea2568).Provider, {
                    value: {
                        prefixCls: prefixCls,
                        selectable: selectable,
                        showIcon: showIcon,
                        icon: icon,
                        switcherIcon: switcherIcon,
                        draggable: draggableConfig,
                        draggingNodeKey: draggingNodeKey,
                        checkable: checkable,
                        checkStrictly: checkStrictly,
                        disabled: disabled,
                        keyEntities: keyEntities,
                        dropLevelOffset: dropLevelOffset,
                        dropContainerKey: dropContainerKey,
                        dropTargetKey: dropTargetKey,
                        dropPosition: dropPosition,
                        dragOverNodeKey: dragOverNodeKey,
                        indent: indent,
                        direction: direction,
                        dropIndicatorRender: dropIndicatorRender,
                        loadData: loadData,
                        filterTreeNode: filterTreeNode,
                        titleRender: titleRender,
                        onNodeClick: this.onNodeClick,
                        onNodeDoubleClick: this.onNodeDoubleClick,
                        onNodeExpand: this.onNodeExpand,
                        onNodeSelect: this.onNodeSelect,
                        onNodeCheck: this.onNodeCheck,
                        onNodeLoad: this.onNodeLoad,
                        onNodeMouseEnter: this.onNodeMouseEnter,
                        onNodeMouseLeave: this.onNodeMouseLeave,
                        onNodeContextMenu: this.onNodeContextMenu,
                        onNodeDragStart: this.onNodeDragStart,
                        onNodeDragEnter: this.onNodeDragEnter,
                        onNodeDragOver: this.onNodeDragOver,
                        onNodeDragLeave: this.onNodeDragLeave,
                        onNodeDragEnd: this.onNodeDragEnd,
                        onNodeDrop: this.onNodeDrop
                    }
                }, /*#__PURE__*/ $acw62.createElement("div", {
                    role: "tree",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, rootClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-show-line"), showLine), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-active-focused"), activeKey !== null)),
                    style: rootStyle
                }, /*#__PURE__*/ $acw62.createElement((0, $3d87a790a526c3d0$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    ref: this.listRef,
                    prefixCls: prefixCls,
                    style: style,
                    data: flattenNodes,
                    disabled: disabled,
                    selectable: selectable,
                    checkable: !!checkable,
                    motion: motion,
                    dragging: draggingNodeKey !== null,
                    height: height,
                    itemHeight: itemHeight,
                    virtual: virtual,
                    focusable: focusable,
                    focused: focused,
                    tabIndex: tabIndex,
                    activeItem: this.getActiveItem(),
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onKeyDown: this.onKeyDown,
                    onActiveChange: this.onActiveChange,
                    onListChangeStart: this.onListChangeStart,
                    onListChangeEnd: this.onListChangeEnd,
                    onContextMenu: onContextMenu,
                    onScroll: onScroll
                }, this.getTreeNodeRequiredProps(), domProps))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, prevState) {
                var prevProps = prevState.prevProps;
                var newState = {
                    prevProps: props
                };
                function needSync(name) {
                    return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
                }
                // ================== Tree Node ==================
                var treeData;
                // fieldNames
                var fieldNames = prevState.fieldNames;
                if (needSync("fieldNames")) {
                    fieldNames = (0, $e0866d8dd7f10128$export$6c519d302dced239)(props.fieldNames);
                    newState.fieldNames = fieldNames;
                }
                // Check if `treeData` or `children` changed and save into the state.
                if (needSync("treeData")) treeData = props.treeData;
                else if (needSync("children")) {
                    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "`children` of Tree is deprecated. Please use `treeData` instead.");
                    treeData = (0, $e0866d8dd7f10128$export$6d8b10995563b669)(props.children);
                }
                // Save flatten nodes info and convert `treeData` into keyEntities
                if (treeData) {
                    newState.treeData = treeData;
                    var entitiesMap = (0, $e0866d8dd7f10128$export$e5d831ce033a4615)(treeData, {
                        fieldNames: fieldNames
                    });
                    newState.keyEntities = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, (0, $3d87a790a526c3d0$export$17c02cdd52a7d889), (0, $3d87a790a526c3d0$export$2d18abad5109a402)), entitiesMap.keyEntities);
                }
                var keyEntities = newState.keyEntities || prevState.keyEntities;
                // ================ expandedKeys =================
                if (needSync("expandedKeys") || prevProps && needSync("autoExpandParent")) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $af974b6720932c91$export$fac4a40c345ccd80)(props.expandedKeys, keyEntities) : props.expandedKeys;
                else if (!prevProps && props.defaultExpandAll) {
                    var cloneKeyEntities = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, keyEntities);
                    delete cloneKeyEntities[0, $3d87a790a526c3d0$export$17c02cdd52a7d889];
                    newState.expandedKeys = Object.keys(cloneKeyEntities).map(function(key) {
                        return cloneKeyEntities[key].key;
                    });
                } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $af974b6720932c91$export$fac4a40c345ccd80)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
                if (!newState.expandedKeys) delete newState.expandedKeys;
                // ================ flattenNodes =================
                if (treeData || newState.expandedKeys) {
                    var flattenNodes = (0, $e0866d8dd7f10128$export$215c1b4f1ba88b23)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
                    newState.flattenNodes = flattenNodes;
                }
                // ================ selectedKeys =================
                if (props.selectable) {
                    if (needSync("selectedKeys")) newState.selectedKeys = (0, $af974b6720932c91$export$fffc10811828fd68)(props.selectedKeys, props);
                    else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $af974b6720932c91$export$fffc10811828fd68)(props.defaultSelectedKeys, props);
                }
                // ================= checkedKeys =================
                if (props.checkable) {
                    var checkedKeyEntity;
                    if (needSync("checkedKeys")) checkedKeyEntity = (0, $af974b6720932c91$export$29d4989c23990d41)(props.checkedKeys) || {};
                    else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $af974b6720932c91$export$29d4989c23990d41)(props.defaultCheckedKeys) || {};
                    else if (treeData) // If `treeData` changed, we also need check it
                    checkedKeyEntity = (0, $af974b6720932c91$export$29d4989c23990d41)(props.checkedKeys) || {
                        checkedKeys: prevState.checkedKeys,
                        halfCheckedKeys: prevState.halfCheckedKeys
                    };
                    if (checkedKeyEntity) {
                        var _checkedKeyEntity = checkedKeyEntity, _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys, checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che, _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys, halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
                        if (!props.checkStrictly) {
                            var conductKeys = (0, $4d7359063b3a6d19$export$43adf2c483e3e633)(checkedKeys, true, keyEntities);
                            checkedKeys = conductKeys.checkedKeys;
                            halfCheckedKeys = conductKeys.halfCheckedKeys;
                        }
                        newState.checkedKeys = checkedKeys;
                        newState.halfCheckedKeys = halfCheckedKeys;
                    }
                }
                // ================= loadedKeys ==================
                if (needSync("loadedKeys")) newState.loadedKeys = props.loadedKeys;
                return newState;
            }
        }
    ]);
    return Tree;
}($acw62.Component);
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($014366ec5d4b5909$var$Tree, "defaultProps", {
    prefixCls: "rc-tree",
    showLine: false,
    showIcon: true,
    selectable: true,
    multiple: false,
    checkable: false,
    disabled: false,
    checkStrictly: false,
    draggable: false,
    defaultExpandParent: true,
    autoExpandParent: false,
    defaultExpandAll: false,
    defaultExpandedKeys: [],
    defaultCheckedKeys: [],
    defaultSelectedKeys: [],
    dropIndicatorRender: (0, $3f745b9b85452e9b$export$2e2bcd8739ae039),
    allowDrop: function allowDrop() {
        return true;
    },
    expandAction: false
});
(0, $f329557dcab6d0bb$export$2e2bcd8739ae039)($014366ec5d4b5909$var$Tree, "TreeNode", (0, $414eed6175d6b51d$export$2e2bcd8739ae039));
var $014366ec5d4b5909$export$2e2bcd8739ae039 = $014366ec5d4b5909$var$Tree;



var $626263d9d009eabc$export$2e2bcd8739ae039 = (0, $014366ec5d4b5909$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5b173e35d737c62d$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
var $5b173e35d737c62d$export$2e2bcd8739ae039 = $5b173e35d737c62d$var$FileOutlined;



var $810fbb56c7a452ed$var$FileOutlined = function FileOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5b173e35d737c62d$export$2e2bcd8739ae039)
    }));
};
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ var $810fbb56c7a452ed$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($810fbb56c7a452ed$var$FileOutlined);
var $810fbb56c7a452ed$export$2e2bcd8739ae039 = $810fbb56c7a452ed$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $682105b8f0090055$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
var $682105b8f0090055$export$2e2bcd8739ae039 = $682105b8f0090055$var$FolderOpenOutlined;



var $a9e9f1e6898cec9b$var$FolderOpenOutlined = function FolderOpenOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $682105b8f0090055$export$2e2bcd8739ae039)
    }));
};
/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */ var $a9e9f1e6898cec9b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($a9e9f1e6898cec9b$var$FolderOpenOutlined);
var $a9e9f1e6898cec9b$export$2e2bcd8739ae039 = $a9e9f1e6898cec9b$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $fc99a386109651e1$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
var $fc99a386109651e1$export$2e2bcd8739ae039 = $fc99a386109651e1$var$FolderOutlined;



var $7413288a2bacf616$var$FolderOutlined = function FolderOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $fc99a386109651e1$export$2e2bcd8739ae039)
    }));
};
/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */ var $7413288a2bacf616$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($7413288a2bacf616$var$FolderOutlined);
var $7413288a2bacf616$export$2e2bcd8739ae039 = $7413288a2bacf616$var$RefIcon;







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8c209b42de494af1$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
var $8c209b42de494af1$export$2e2bcd8739ae039 = $8c209b42de494af1$var$HolderOutlined;



var $19519bd5f49a4d45$var$HolderOutlined = function HolderOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $8c209b42de494af1$export$2e2bcd8739ae039)
    }));
};
/**![holder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwMCAyNzYuNWE1NiA1NiAwIDEwNTYtOTcgNTYgNTYgMCAwMC01NiA5N3ptMCAyODRhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCAyMjhhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDAwLTExMiAwek0zMDAgODQ0LjVhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCA3OTZhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6IiAvPjwvc3ZnPg==) */ var $19519bd5f49a4d45$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($19519bd5f49a4d45$var$HolderOutlined);
var $19519bd5f49a4d45$export$2e2bcd8739ae039 = $19519bd5f49a4d45$var$RefIcon;












// ============================ Keyframes =============================
const $1453a5f857f99b8a$var$treeNodeFX = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("ant-tree-node-fx-do-not-use", {
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
// ============================== Switch ==============================
const $1453a5f857f99b8a$var$getSwitchStyle = (prefixCls, token)=>({
        [`.${prefixCls}-switcher-icon`]: {
            display: "inline-block",
            fontSize: 10,
            verticalAlign: "baseline",
            svg: {
                transition: `transform ${token.motionDurationSlow}`
            }
        }
    });
// =============================== Drop ===============================
const $1453a5f857f99b8a$var$getDropIndicatorStyle = (prefixCls, token)=>({
        [`.${prefixCls}-drop-indicator`]: {
            position: "absolute",
            // it should displayed over the following node
            zIndex: 1,
            height: 2,
            backgroundColor: token.colorPrimary,
            borderRadius: 1,
            pointerEvents: "none",
            "&:after": {
                position: "absolute",
                top: -3,
                insetInlineStart: -6,
                width: 8,
                height: 8,
                backgroundColor: "transparent",
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorPrimary}`,
                borderRadius: "50%",
                content: '""'
            }
        }
    });
const $1453a5f857f99b8a$export$5ca74f7be820a85 = (prefixCls, token)=>{
    const { treeCls: treeCls, treeNodeCls: treeNodeCls, treeNodePadding: treeNodePadding, titleHeight: titleHeight, nodeSelectedBg: nodeSelectedBg, nodeHoverBg: nodeHoverBg } = token;
    const treeCheckBoxMarginHorizontal = token.paddingXS;
    return {
        [treeCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            background: token.colorBgContainer,
            borderRadius: token.borderRadius,
            transition: `background-color ${token.motionDurationSlow}`,
            [`&${treeCls}-rtl`]: {
                // >>> Switcher
                [`${treeCls}-switcher`]: {
                    "&_close": {
                        [`${treeCls}-switcher-icon`]: {
                            svg: {
                                transform: "rotate(90deg)"
                            }
                        }
                    }
                }
            },
            [`&-focused:not(:hover):not(${treeCls}-active-focused)`]: Object.assign({}, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token)),
            // =================== Virtual List ===================
            [`${treeCls}-list-holder-inner`]: {
                alignItems: "flex-start"
            },
            [`&${treeCls}-block-node`]: {
                [`${treeCls}-list-holder-inner`]: {
                    alignItems: "stretch",
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        flex: "auto"
                    },
                    // >>> Drag
                    [`${treeNodeCls}.dragging`]: {
                        position: "relative",
                        "&:after": {
                            position: "absolute",
                            top: 0,
                            insetInlineEnd: 0,
                            bottom: treeNodePadding,
                            insetInlineStart: 0,
                            border: `1px solid ${token.colorPrimary}`,
                            opacity: 0,
                            animationName: $1453a5f857f99b8a$var$treeNodeFX,
                            animationDuration: token.motionDurationSlow,
                            animationPlayState: "running",
                            animationFillMode: "forwards",
                            content: '""',
                            pointerEvents: "none"
                        }
                    }
                }
            },
            // ===================== TreeNode =====================
            [`${treeNodeCls}`]: {
                display: "flex",
                alignItems: "flex-start",
                padding: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(treeNodePadding)} 0`,
                outline: "none",
                "&-rtl": {
                    direction: "rtl"
                },
                // Disabled
                "&-disabled": {
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        color: token.colorTextDisabled,
                        cursor: "not-allowed",
                        "&:hover": {
                            background: "transparent"
                        }
                    }
                },
                [`&-active ${treeCls}-node-content-wrapper`]: {
                    background: token.controlItemBgHover
                },
                [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
                    color: "inherit",
                    fontWeight: 500
                },
                "&-draggable": {
                    cursor: "grab",
                    [`${treeCls}-draggable-icon`]: {
                        // https://github.com/ant-design/ant-design/issues/41915
                        flexShrink: 0,
                        width: titleHeight,
                        lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(titleHeight)}`,
                        textAlign: "center",
                        visibility: "visible",
                        opacity: 0.2,
                        transition: `opacity ${token.motionDurationSlow}`,
                        [`${treeNodeCls}:hover &`]: {
                            opacity: 0.45
                        }
                    },
                    [`&${treeNodeCls}-disabled`]: {
                        [`${treeCls}-draggable-icon`]: {
                            visibility: "hidden"
                        }
                    }
                }
            },
            // >>> Indent
            [`${treeCls}-indent`]: {
                alignSelf: "stretch",
                whiteSpace: "nowrap",
                userSelect: "none",
                "&-unit": {
                    display: "inline-block",
                    width: titleHeight
                }
            },
            // >>> Drag Handler
            [`${treeCls}-draggable-icon`]: {
                visibility: "hidden"
            },
            // >>> Switcher
            [`${treeCls}-switcher`]: Object.assign(Object.assign({}, $1453a5f857f99b8a$var$getSwitchStyle(prefixCls, token)), {
                position: "relative",
                flex: "none",
                alignSelf: "stretch",
                width: titleHeight,
                margin: 0,
                lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(titleHeight)}`,
                textAlign: "center",
                cursor: "pointer",
                userSelect: "none",
                transition: `all ${token.motionDurationSlow}`,
                borderRadius: token.borderRadius,
                "&-noop": {
                    cursor: "unset"
                },
                [`&:not(${treeCls}-switcher-noop):hover`]: {
                    backgroundColor: token.colorBgTextHover
                },
                "&_close": {
                    [`${treeCls}-switcher-icon`]: {
                        svg: {
                            transform: "rotate(-90deg)"
                        }
                    }
                },
                "&-loading-icon": {
                    color: token.colorPrimary
                },
                "&-leaf-line": {
                    position: "relative",
                    zIndex: 1,
                    display: "inline-block",
                    width: "100%",
                    height: "100%",
                    // https://github.com/ant-design/ant-design/issues/31884
                    "&:before": {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        marginInlineStart: -1,
                        borderInlineEnd: `1px solid ${token.colorBorder}`,
                        content: '""'
                    },
                    "&:after": {
                        position: "absolute",
                        width: token.calc(token.calc(titleHeight).div(2).equal()).mul(0.8).equal(),
                        height: token.calc(titleHeight).div(2).equal(),
                        borderBottom: `1px solid ${token.colorBorder}`,
                        content: '""'
                    }
                }
            }),
            // >>> Checkbox
            [`${treeCls}-checkbox`]: {
                top: "initial",
                marginInlineEnd: treeCheckBoxMarginHorizontal,
                alignSelf: "flex-start",
                marginTop: token.marginXXS
            },
            // >>> Title
            // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
            [`${treeCls}-node-content-wrapper, ${treeCls}-checkbox + span`]: {
                position: "relative",
                zIndex: "auto",
                minHeight: titleHeight,
                margin: 0,
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingXS).div(2).equal())}`,
                color: "inherit",
                lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(titleHeight)}`,
                background: "transparent",
                borderRadius: token.borderRadius,
                cursor: "pointer",
                transition: `all ${token.motionDurationMid}, border 0s, line-height 0s, box-shadow 0s`,
                "&:hover": {
                    backgroundColor: nodeHoverBg
                },
                [`&${treeCls}-node-selected`]: {
                    backgroundColor: nodeSelectedBg
                },
                // Icon
                [`${treeCls}-iconEle`]: {
                    display: "inline-block",
                    width: titleHeight,
                    height: titleHeight,
                    lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(titleHeight)}`,
                    textAlign: "center",
                    verticalAlign: "top",
                    "&:empty": {
                        display: "none"
                    }
                }
            },
            // https://github.com/ant-design/ant-design/issues/28217
            [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
                backgroundColor: "transparent"
            },
            // ==================== Draggable =====================
            [`${treeCls}-node-content-wrapper`]: Object.assign({
                lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(titleHeight)}`,
                userSelect: "none"
            }, $1453a5f857f99b8a$var$getDropIndicatorStyle(prefixCls, token)),
            [`${treeNodeCls}.drop-container`]: {
                "> [draggable]": {
                    boxShadow: `0 0 0 2px ${token.colorPrimary}`
                }
            },
            // ==================== Show Line =====================
            "&-show-line": {
                // ================ Indent lines ================
                [`${treeCls}-indent`]: {
                    "&-unit": {
                        position: "relative",
                        height: "100%",
                        "&:before": {
                            position: "absolute",
                            top: 0,
                            insetInlineEnd: token.calc(titleHeight).div(2).equal(),
                            bottom: token.calc(treeNodePadding).mul(-1).equal(),
                            borderInlineEnd: `1px solid ${token.colorBorder}`,
                            content: '""'
                        },
                        "&-end": {
                            "&:before": {
                                display: "none"
                            }
                        }
                    }
                },
                // ============== Cover Background ==============
                [`${treeCls}-switcher`]: {
                    background: "transparent",
                    "&-line-icon": {
                        // https://github.com/ant-design/ant-design/issues/32813
                        verticalAlign: "-0.15em"
                    }
                }
            },
            [`${treeNodeCls}-leaf-last`]: {
                [`${treeCls}-switcher`]: {
                    "&-leaf-line": {
                        "&:before": {
                            top: "auto !important",
                            bottom: "auto !important",
                            height: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(titleHeight).div(2).equal())} !important`
                        }
                    }
                }
            }
        })
    };
};
const $1453a5f857f99b8a$export$2f47474ee6fcebcf = (token)=>{
    const { treeCls: treeCls, treeNodeCls: treeNodeCls, treeNodePadding: treeNodePadding, directoryNodeSelectedBg: directoryNodeSelectedBg, directoryNodeSelectedColor: directoryNodeSelectedColor } = token;
    return {
        [`${treeCls}${treeCls}-directory`]: {
            // ================== TreeNode ==================
            [treeNodeCls]: {
                position: "relative",
                // Hover color
                "&:before": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: treeNodePadding,
                    insetInlineStart: 0,
                    transition: `background-color ${token.motionDurationMid}`,
                    content: '""',
                    pointerEvents: "none"
                },
                "&:hover": {
                    "&:before": {
                        background: token.controlItemBgHover
                    }
                },
                // Elements
                "> *": {
                    zIndex: 1
                },
                // >>> Switcher
                [`${treeCls}-switcher`]: {
                    transition: `color ${token.motionDurationMid}`
                },
                // >>> Title
                [`${treeCls}-node-content-wrapper`]: {
                    borderRadius: 0,
                    userSelect: "none",
                    "&:hover": {
                        background: "transparent"
                    },
                    [`&${treeCls}-node-selected`]: {
                        color: directoryNodeSelectedColor,
                        background: "transparent"
                    }
                },
                // ============= Selected =============
                "&-selected": {
                    [`
            &:hover::before,
            &::before
          `]: {
                        background: directoryNodeSelectedBg
                    },
                    // >>> Switcher
                    [`${treeCls}-switcher`]: {
                        color: directoryNodeSelectedColor
                    },
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        color: directoryNodeSelectedColor,
                        background: "transparent"
                    }
                }
            }
        }
    };
};
const $1453a5f857f99b8a$export$6543b952798356f2 = (prefixCls, token)=>{
    const treeCls = `.${prefixCls}`;
    const treeNodeCls = `${treeCls}-treenode`;
    const treeNodePadding = token.calc(token.paddingXS).div(2).equal();
    const treeToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        treeCls: treeCls,
        treeNodeCls: treeNodeCls,
        treeNodePadding: treeNodePadding
    });
    return [
        // Basic
        $1453a5f857f99b8a$export$5ca74f7be820a85(prefixCls, treeToken),
        // Directory
        $1453a5f857f99b8a$export$2f47474ee6fcebcf(treeToken)
    ];
};
const $1453a5f857f99b8a$export$bd8b682992bc9781 = (token)=>{
    const { controlHeightSM: controlHeightSM } = token;
    return {
        titleHeight: controlHeightSM,
        nodeHoverBg: token.controlItemBgHover,
        nodeSelectedBg: token.controlItemBgActive
    };
};
const $1453a5f857f99b8a$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary } = token;
    return Object.assign(Object.assign({}, $1453a5f857f99b8a$export$bd8b682992bc9781(token)), {
        directoryNodeSelectedColor: colorTextLightSolid,
        directoryNodeSelectedBg: colorPrimary
    });
};
var $1453a5f857f99b8a$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Tree", (token, _ref)=>{
    let { prefixCls: prefixCls } = _ref;
    return [
        {
            [token.componentCls]: (0, $04e90e571fcd1828$export$3d2f074408bd1b82)(`${prefixCls}-checkbox`, token)
        },
        $1453a5f857f99b8a$export$6543b952798356f2(prefixCls, token),
        (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(token)
    ];
}, $1453a5f857f99b8a$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");
"use client";
const $1dfbc26739217dee$export$cc800923e997bb8 = 4;
function $1dfbc26739217dee$export$2e2bcd8739ae039(props) {
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, prefixCls: prefixCls, indent: indent, direction: direction = "ltr" } = props;
    const startPosition = direction === "ltr" ? "left" : "right";
    const endPosition = direction === "ltr" ? "right" : "left";
    const style = {
        [startPosition]: -dropLevelOffset * indent + $1dfbc26739217dee$export$cc800923e997bb8,
        [endPosition]: 0
    };
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $1dfbc26739217dee$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: `${prefixCls}-drop-indicator`
    });
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d18b58b25958afc6$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
var $d18b58b25958afc6$export$2e2bcd8739ae039 = $d18b58b25958afc6$var$CaretDownFilled;



var $be6cf3d0998df145$var$CaretDownFilled = function CaretDownFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $d18b58b25958afc6$export$2e2bcd8739ae039)
    }));
};
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ var $be6cf3d0998df145$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($be6cf3d0998df145$var$CaretDownFilled);
var $be6cf3d0998df145$export$2e2bcd8739ae039 = $be6cf3d0998df145$var$RefIcon;






var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c39dba0bbe13c0cc$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
var $c39dba0bbe13c0cc$export$2e2bcd8739ae039 = $c39dba0bbe13c0cc$var$MinusSquareOutlined;



var $1c3abacbb20fe960$var$MinusSquareOutlined = function MinusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $c39dba0bbe13c0cc$export$2e2bcd8739ae039)
    }));
};
/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ var $1c3abacbb20fe960$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1c3abacbb20fe960$var$MinusSquareOutlined);
var $1c3abacbb20fe960$export$2e2bcd8739ae039 = $1c3abacbb20fe960$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $0bd4c0466d4aa550$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
var $0bd4c0466d4aa550$export$2e2bcd8739ae039 = $0bd4c0466d4aa550$var$PlusSquareOutlined;



var $534a8c31bb2cb9ed$var$PlusSquareOutlined = function PlusSquareOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $0bd4c0466d4aa550$export$2e2bcd8739ae039)
    }));
};
/**![plus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMTUydjE1MmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjU0NGgxNTJjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ var $534a8c31bb2cb9ed$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($534a8c31bb2cb9ed$var$PlusSquareOutlined);
var $534a8c31bb2cb9ed$export$2e2bcd8739ae039 = $534a8c31bb2cb9ed$var$RefIcon;




"use client";
const $587d94115e84e73e$var$SwitcherIconCom = (props)=>{
    const { prefixCls: prefixCls, switcherIcon: switcherIcon, treeNodeProps: treeNodeProps, showLine: showLine } = props;
    const { isLeaf: isLeaf, expanded: expanded, loading: loading } = treeNodeProps;
    if (loading) return /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-loading-icon`
    });
    let showLeafIcon;
    if (showLine && typeof showLine === "object") showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== "boolean" && !!showLeafIcon) {
            const leafIcon = typeof showLeafIcon === "function" ? showLeafIcon(treeNodeProps) : showLeafIcon;
            const leafCls = `${prefixCls}-switcher-line-custom-icon`;
            if (/*#__PURE__*/ $acw62.isValidElement(leafIcon)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(leafIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(leafIcon.props.className || "", leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $acw62.createElement((0, $810fbb56c7a452ed$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-line-icon`
        }) : /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-switcher-leaf-line`
        });
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = typeof switcherIcon === "function" ? switcherIcon(treeNodeProps) : switcherIcon;
    if (/*#__PURE__*/ $acw62.isValidElement(switcher)) return (0, $30796c32f374b477$export$e530037191fcd5d7)(switcher, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(switcher.props.className || "", switcherCls)
    });
    if (switcher !== undefined) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $acw62.createElement((0, $1c3abacbb20fe960$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/ $acw62.createElement((0, $534a8c31bb2cb9ed$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    });
    return /*#__PURE__*/ $acw62.createElement((0, $be6cf3d0998df145$export$2e2bcd8739ae039), {
        className: switcherCls
    });
};
var $587d94115e84e73e$export$2e2bcd8739ae039 = $587d94115e84e73e$var$SwitcherIconCom;


"use client";
const $71445890cbc611bb$var$Tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    var _a;
    const { getPrefixCls: getPrefixCls, direction: direction, virtual: virtual, tree: tree } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = false, showLine: showLine, switcherIcon: switcherIcon, blockNode: blockNode = false, children: children, checkable: checkable = false, selectable: selectable = true, draggable: draggable, motion: customMotion, style: style } = props;
    const prefixCls = getPrefixCls("tree", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const motion = customMotion !== null && customMotion !== void 0 ? customMotion : Object.assign(Object.assign({}, (0, $2efb522a5615f01e$export$2e2bcd8739ae039)(rootPrefixCls)), {
        motionAppear: false
    });
    const newProps = Object.assign(Object.assign({}, props), {
        checkable: checkable,
        selectable: selectable,
        showIcon: showIcon,
        motion: motion,
        blockNode: blockNode,
        showLine: Boolean(showLine),
        dropIndicatorRender: $1dfbc26739217dee$export$2e2bcd8739ae039
    });
    const [wrapCSSVar, hashId, cssVarCls] = (0, $1453a5f857f99b8a$export$2e2bcd8739ae039)(prefixCls);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const itemHeight = token.paddingXS / 2 + (((_a = token.Tree) === null || _a === void 0 ? void 0 : _a.titleHeight) || token.controlHeightSM);
    const draggableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!draggable) return false;
        let mergedDraggable = {};
        switch(typeof draggable){
            case "function":
                mergedDraggable.nodeDraggable = draggable;
                break;
            case "object":
                mergedDraggable = Object.assign({}, draggable);
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $19519bd5f49a4d45$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    const renderSwitcherIcon = (nodeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $587d94115e84e73e$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            switcherIcon: switcherIcon,
            treeNodeProps: nodeProps,
            showLine: showLine
        });
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $626263d9d009eabc$export$2e2bcd8739ae039), Object.assign({
        itemHeight: itemHeight,
        ref: ref,
        virtual: virtual
    }, newProps, {
        // newProps may contain style so declare style below it
        style: Object.assign(Object.assign({}, tree === null || tree === void 0 ? void 0 : tree.style), style),
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-icon-hide`]: !showIcon,
            [`${prefixCls}-block-node`]: blockNode,
            [`${prefixCls}-unselectable`]: !selectable,
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, tree === null || tree === void 0 ? void 0 : tree.className, className, hashId, cssVarCls),
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: `${prefixCls}-checkbox-inner`
        }) : checkable,
        selectable: selectable,
        switcherIcon: renderSwitcherIcon,
        draggable: draggableConfig
    }), children));
});
var $71445890cbc611bb$export$2e2bcd8739ae039 = $71445890cbc611bb$var$Tree;




const $b87075829d49fe5e$var$RECORD_NONE = 0;
const $b87075829d49fe5e$var$RECORD_START = 1;
const $b87075829d49fe5e$var$RECORD_END = 2;
function $b87075829d49fe5e$var$traverseNodesKey(treeData, callback, fieldNames) {
    const { key: fieldKey, children: fieldChildren } = fieldNames;
    function processNode(dataNode) {
        const key = dataNode[fieldKey];
        const children = dataNode[fieldChildren];
        if (callback(key, dataNode) !== false) $b87075829d49fe5e$var$traverseNodesKey(children || [], callback, fieldNames);
    }
    treeData.forEach(processNode);
}
function $b87075829d49fe5e$export$aad0b800290b42ab(_ref) {
    let { treeData: treeData, expandedKeys: expandedKeys, startKey: startKey, endKey: endKey, fieldNames: fieldNames } = _ref;
    const keys = [];
    let record = $b87075829d49fe5e$var$RECORD_NONE;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $b87075829d49fe5e$var$traverseNodesKey(treeData, (key)=>{
        if (record === $b87075829d49fe5e$var$RECORD_END) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $b87075829d49fe5e$var$RECORD_NONE) record = $b87075829d49fe5e$var$RECORD_START;
            else if (record === $b87075829d49fe5e$var$RECORD_START) {
                record = $b87075829d49fe5e$var$RECORD_END;
                return false;
            }
        } else if (record === $b87075829d49fe5e$var$RECORD_START) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    }, (0, $e0866d8dd7f10128$export$6c519d302dced239)(fieldNames));
    return keys;
}
function $b87075829d49fe5e$export$7d40a46ab3886826(treeData, keys, fieldNames) {
    const restKeys = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keys);
    const nodes = [];
    $b87075829d49fe5e$var$traverseNodesKey(treeData, (key, node)=>{
        const index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    }, (0, $e0866d8dd7f10128$export$6c519d302dced239)(fieldNames));
    return nodes;
}


"use client";
var $6fd2de76bf4211ba$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $6fd2de76bf4211ba$var$getIcon(props) {
    const { isLeaf: isLeaf, expanded: expanded } = props;
    if (isLeaf) return /*#__PURE__*/ $acw62.createElement((0, $810fbb56c7a452ed$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $acw62.createElement((0, $a9e9f1e6898cec9b$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $7413288a2bacf616$export$2e2bcd8739ae039), null);
}
function $6fd2de76bf4211ba$var$getTreeData(_ref) {
    let { treeData: treeData, children: children } = _ref;
    return treeData || (0, $e0866d8dd7f10128$export$6d8b10995563b669)(children);
}
const $6fd2de76bf4211ba$var$DirectoryTree = (_a, ref)=>{
    var { defaultExpandAll: defaultExpandAll, defaultExpandParent: defaultExpandParent, defaultExpandedKeys: defaultExpandedKeys } = _a, props = $6fd2de76bf4211ba$var$__rest(_a, [
        "defaultExpandAll",
        "defaultExpandParent",
        "defaultExpandedKeys"
    ]);
    // Shift click usage
    const lastSelectedKey = $acw62.useRef();
    const cachedSelectedKeys = $acw62.useRef();
    const getInitExpandedKeys = ()=>{
        const { keyEntities: keyEntities } = (0, $e0866d8dd7f10128$export$e5d831ce033a4615)($6fd2de76bf4211ba$var$getTreeData(props));
        let initExpandedKeys;
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $af974b6720932c91$export$fac4a40c345ccd80)(props.expandedKeys || defaultExpandedKeys || [], keyEntities);
        else initExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
        return initExpandedKeys;
    };
    const [selectedKeys, setSelectedKeys] = $acw62.useState(props.selectedKeys || props.defaultSelectedKeys || []);
    const [expandedKeys, setExpandedKeys] = $acw62.useState(()=>getInitExpandedKeys());
    $acw62.useEffect(()=>{
        if ("selectedKeys" in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $acw62.useEffect(()=>{
        if ("expandedKeys" in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    const onExpand = (keys, info)=>{
        var _a;
        if (!("expandedKeys" in props)) setExpandedKeys(keys);
        // Call origin function
        return (_a = props.onExpand) === null || _a === void 0 ? void 0 : _a.call(props, keys, info);
    };
    const onSelect = (keys, event)=>{
        var _a;
        const { multiple: multiple, fieldNames: fieldNames } = props;
        const { node: node, nativeEvent: nativeEvent } = event;
        const { key: key = "" } = node;
        const treeData = $6fd2de76bf4211ba$var$getTreeData(props);
        // const newState: DirectoryTreeState = {};
        // We need wrap this event since some value is not same
        const newEvent = Object.assign(Object.assign({}, event), {
            selected: true
        });
        // Windows / Mac single pick
        const ctrlPick = (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.ctrlKey) || (nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.metaKey);
        const shiftPick = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.shiftKey;
        // Generate new selected keys
        let newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cachedSelectedKeys.current || []), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $b87075829d49fe5e$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKey.current,
                fieldNames: fieldNames
            })))));
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKey.current = key;
            cachedSelectedKeys.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $b87075829d49fe5e$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        }
        (_a = props.onSelect) === null || _a === void 0 || _a.call(props, newSelectedKeys, newEvent);
        if (!("selectedKeys" in props)) setSelectedKeys(newSelectedKeys);
    };
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = true, expandAction: expandAction = "click" } = props, otherProps = $6fd2de76bf4211ba$var$__rest(props, [
        "prefixCls",
        "className",
        "showIcon",
        "expandAction"
    ]);
    const prefixCls = getPrefixCls("tree", customizePrefixCls);
    const connectClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-directory`, {
        [`${prefixCls}-directory-rtl`]: direction === "rtl"
    }, className);
    return /*#__PURE__*/ $acw62.createElement((0, $71445890cbc611bb$export$2e2bcd8739ae039), Object.assign({
        icon: $6fd2de76bf4211ba$var$getIcon,
        ref: ref,
        blockNode: true
    }, otherProps, {
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    }));
};
const $6fd2de76bf4211ba$var$ForwardDirectoryTree = /*#__PURE__*/ $acw62.forwardRef($6fd2de76bf4211ba$var$DirectoryTree);
var $6fd2de76bf4211ba$export$2e2bcd8739ae039 = $6fd2de76bf4211ba$var$ForwardDirectoryTree;



"use client";
const $214c2d233474e3a9$var$Tree = (0, $71445890cbc611bb$export$2e2bcd8739ae039);
$214c2d233474e3a9$var$Tree.DirectoryTree = (0, $6fd2de76bf4211ba$export$2e2bcd8739ae039);
$214c2d233474e3a9$var$Tree.TreeNode = (0, $414eed6175d6b51d$export$2e2bcd8739ae039);
var $214c2d233474e3a9$export$2e2bcd8739ae039 = $214c2d233474e3a9$var$Tree;



var $acw62 = parcelRequire("acw62");


"use client";
function $c1d7c8bb2fcfceb3$var$FilterSearch(_ref) {
    let { value: value, onChange: onChange, filterSearch: filterSearch, tablePrefixCls: tablePrefixCls, locale: locale } = _ref;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${tablePrefixCls}-filter-dropdown-search`
    }, /*#__PURE__*/ $acw62.createElement((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $acw62.createElement((0, $f7392a88184334dd$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: `${tablePrefixCls}-filter-dropdown-search-input`
    }));
}
var $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039 = $c1d7c8bb2fcfceb3$var$FilterSearch;



var $acw62 = parcelRequire("acw62");

"use client";
const $93969139f956c4b8$var$onKeyDown = (event)=>{
    const { keyCode: keyCode } = event;
    if (keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) event.stopPropagation();
};
const $93969139f956c4b8$var$FilterDropdownMenuWrapper = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement("div", {
        className: props.className,
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: $93969139f956c4b8$var$onKeyDown,
        ref: ref
    }, props.children));
var $93969139f956c4b8$export$2e2bcd8739ae039 = $93969139f956c4b8$var$FilterDropdownMenuWrapper;


"use client";
function $e2c4fb76408c4dec$export$50792ddeed01ab0a(filters) {
    let keys = [];
    (filters || []).forEach((_ref)=>{
        let { value: value, children: children } = _ref;
        keys.push(value);
        if (children) keys = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(keys), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($e2c4fb76408c4dec$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $e2c4fb76408c4dec$var$hasSubMenu(filters) {
    return filters.some((_ref2)=>{
        let { children: children } = _ref2;
        return children;
    });
}
function $e2c4fb76408c4dec$var$searchValueMatched(searchValue, text) {
    if (typeof text === "string" || typeof text === "number") return text === null || text === void 0 ? void 0 : text.toString().toLowerCase().includes(searchValue.trim().toLowerCase());
    return false;
}
function $e2c4fb76408c4dec$var$renderFilterItems(_ref3) {
    let { filters: filters, prefixCls: prefixCls, filteredKeys: filteredKeys, filterMultiple: filterMultiple, searchValue: searchValue, filterSearch: filterSearch } = _ref3;
    return filters.map((filter, index)=>{
        const key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: `${prefixCls}-dropdown-submenu`,
            children: $e2c4fb76408c4dec$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                filterSearch: filterSearch
            })
        };
        const Component = filterMultiple ? (0, $da237ba92f78ed9a$export$2e2bcd8739ae039) : (0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039);
        const item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $acw62.createElement("span", null, filter.text))
        };
        if (searchValue.trim()) {
            if (typeof filterSearch === "function") return filterSearch(searchValue, filter) ? item : null;
            return $e2c4fb76408c4dec$var$searchValueMatched(searchValue, filter.text) ? item : null;
        }
        return item;
    });
}
function $e2c4fb76408c4dec$var$wrapStringListType(keys) {
    return keys || [];
}
function $e2c4fb76408c4dec$var$FilterDropdown(props) {
    var _a, _b;
    const { tablePrefixCls: tablePrefixCls, prefixCls: prefixCls, column: column, dropdownPrefixCls: dropdownPrefixCls, columnKey: columnKey, filterOnClose: filterOnClose, filterMultiple: filterMultiple, filterMode: filterMode = "menu", filterSearch: filterSearch = false, filterState: filterState, triggerFilter: triggerFilter, locale: locale, children: children, getPopupContainer: getPopupContainer, rootClassName: rootClassName } = props;
    const { filterDropdownOpen: filterDropdownOpen, onFilterDropdownOpenChange: onFilterDropdownOpenChange, filterResetToDefaultFilteredValue: filterResetToDefaultFilteredValue, defaultFilteredValue: defaultFilteredValue, filterDropdownVisible: // Deprecated
    filterDropdownVisible, onFilterDropdownVisibleChange: onFilterDropdownVisibleChange } = column;
    const [visible, setVisible] = $acw62.useState(false);
    const filtered = !!(filterState && (((_a = filterState.filteredKeys) === null || _a === void 0 ? void 0 : _a.length) || filterState.forceFiltered));
    const triggerVisible = (newVisible)=>{
        setVisible(newVisible);
        onFilterDropdownOpenChange === null || onFilterDropdownOpenChange === void 0 || onFilterDropdownOpenChange(newVisible);
        onFilterDropdownVisibleChange === null || onFilterDropdownVisibleChange === void 0 || onFilterDropdownVisibleChange(newVisible);
    };
    var _ref4;
    const mergedVisible = (_b = filterDropdownOpen !== null && filterDropdownOpen !== void 0 ? filterDropdownOpen : filterDropdownVisible) !== null && _b !== void 0 ? _b : visible;
    // ===================== Select Keys =====================
    const propFilteredKeys = filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys;
    const [getFilteredKeysSync, setFilteredKeysSync] = (0, $1f7b7badb410ab86$export$2e2bcd8739ae039)($e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys));
    const onSelectKeys = (_ref5)=>{
        let { selectedKeys: selectedKeys } = _ref5;
        setFilteredKeysSync(selectedKeys);
    };
    const onCheck = (keys, _ref6)=>{
        let { node: node, checked: checked } = _ref6;
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $acw62.useEffect(()=>{
        if (!visible) return;
        onSelectKeys({
            selectedKeys: $e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys
    ]);
    // ====================== Open Keys ======================
    const [openKeys, setOpenKeys] = $acw62.useState([]);
    const onOpenChange = (keys)=>{
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    const [searchValue, setSearchValue] = $acw62.useState("");
    const onSearch = (e)=>{
        const { value: value } = e.target;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $acw62.useEffect(()=>{
        if (!visible) setSearchValue("");
    }, [
        visible
    ]);
    // ======================= Submit ========================
    const internalTriggerFilter = (keys)=>{
        const mergedKeys = (keys === null || keys === void 0 ? void 0 : keys.length) ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, $357adc8667cde522$export$2e2bcd8739ae039)(mergedKeys, filterState === null || filterState === void 0 ? void 0 : filterState.filteredKeys, true)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    const onConfirm = ()=>{
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onReset = function() {
        let { confirm: confirm, closeDropdown: closeDropdown } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            confirm: false,
            closeDropdown: false
        };
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue("");
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map((key)=>String(key)));
        else setFilteredKeysSync([]);
    };
    const doFilter = function() {
        let { closeDropdown: closeDropdown } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            closeDropdown: true
        };
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onVisibleChange = (newVisible, info)=>{
        if (info.source === "trigger") {
            if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefined)
            setFilteredKeysSync($e2c4fb76408c4dec$var$wrapStringListType(propFilteredKeys));
            triggerVisible(newVisible);
            if (!newVisible && !column.filterDropdown && filterOnClose) onConfirm();
        }
    };
    // ======================== Style ========================
    const dropdownMenuClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${dropdownPrefixCls}-menu-without-submenu`]: !$e2c4fb76408c4dec$var$hasSubMenu(column.filters || [])
    });
    const onCheckAll = (e)=>{
        if (e.target.checked) {
            const allFilterKeys = $e2c4fb76408c4dec$export$50792ddeed01ab0a(column === null || column === void 0 ? void 0 : column.filters).map((key)=>String(key));
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    const getTreeData = (_ref7)=>{
        let { filters: filters } = _ref7;
        return (filters || []).map((filter, index)=>{
            const key = String(filter.value);
            const item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    };
    const getFilterData = (node)=>{
        var _a;
        return Object.assign(Object.assign({}, node), {
            text: node.title,
            value: node.key,
            children: ((_a = node.children) === null || _a === void 0 ? void 0 : _a.map((item)=>getFilterData(item))) || []
        });
    };
    let dropdownContent;
    if (typeof column.filterDropdown === "function") dropdownContent = column.filterDropdown({
        prefixCls: `${dropdownPrefixCls}-custom`,
        setSelectedKeys: (selectedKeys)=>onSelectKeys({
                selectedKeys: selectedKeys
            }),
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: ()=>{
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        const selectedKeys = getFilteredKeysSync() || [];
        const getFilterComponent = ()=>{
            const empty = /*#__PURE__*/ $acw62.createElement((0, $ec66348328372da5$export$2e2bcd8739ae039), {
                image: (0, $ec66348328372da5$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                imageStyle: {
                    height: 24
                },
                style: {
                    margin: 0,
                    padding: "16px 0"
                }
            });
            if ((column.filters || []).length === 0) return empty;
            if (filterMode === "tree") return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $acw62.createElement("div", {
                className: `${tablePrefixCls}-filter-dropdown-tree`
            }, filterMultiple ? /*#__PURE__*/ $acw62.createElement((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === $e2c4fb76408c4dec$export$50792ddeed01ab0a(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < $e2c4fb76408c4dec$export$50792ddeed01ab0a(column.filters).length,
                className: `${tablePrefixCls}-filter-dropdown-checkall`,
                onChange: onCheckAll
            }, locale.filterCheckall) : null, /*#__PURE__*/ $acw62.createElement((0, $214c2d233474e3a9$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: `${dropdownPrefixCls}-menu`,
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: searchValue.trim() ? (node)=>{
                    if (typeof filterSearch === "function") return filterSearch(searchValue, getFilterData(node));
                    return $e2c4fb76408c4dec$var$searchValueMatched(searchValue, node.title);
                } : undefined
            })));
            const items = $e2c4fb76408c4dec$var$renderFilterItems({
                filters: column.filters || [],
                filterSearch: filterSearch,
                prefixCls: prefixCls,
                filteredKeys: getFilteredKeysSync(),
                filterMultiple: filterMultiple,
                searchValue: searchValue
            });
            const isEmpty = items.every((item)=>item === null);
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $c1d7c8bb2fcfceb3$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), isEmpty ? empty : /*#__PURE__*/ $acw62.createElement((0, $47077f34c49bbd52$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: `${dropdownPrefixCls}-menu`,
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: items
            }));
        };
        const getResetDisabled = ()=>{
            if (filterResetToDefaultFilteredValue) return (0, $357adc8667cde522$export$2e2bcd8739ae039)((defaultFilteredValue || []).map((key)=>String(key)), selectedKeys, true);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, getFilterComponent(), /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-dropdown-btns`
        }, /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: ()=>onReset()
        }, locale.filterReset), /*#__PURE__*/ $acw62.createElement((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $acw62.createElement((0, $798e9781cc841bf2$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    const menu = ()=>/*#__PURE__*/ $acw62.createElement((0, $93969139f956c4b8$export$2e2bcd8739ae039), {
            className: `${prefixCls}-dropdown`
        }, dropdownContent);
    let filterIcon;
    if (typeof column.filterIcon === "function") filterIcon = column.filterIcon(filtered);
    else if (column.filterIcon) filterIcon = column.filterIcon;
    else filterIcon = /*#__PURE__*/ $acw62.createElement((0, $6d4c3c11d072512d$export$2e2bcd8739ae039), null);
    const { direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), /*#__PURE__*/ $acw62.createElement((0, $9df091eb5002c0d1$export$2e2bcd8739ae039), {
        dropdownRender: menu,
        trigger: [
            "click"
        ],
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        getPopupContainer: getPopupContainer,
        placement: direction === "rtl" ? "bottomLeft" : "bottomRight",
        rootClassName: rootClassName
    }, /*#__PURE__*/ $acw62.createElement("span", {
        role: "button",
        tabIndex: -1,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-trigger`, {
            active: filtered
        }),
        onClick: (e)=>{
            e.stopPropagation();
        }
    }, filterIcon)));
}
var $e2c4fb76408c4dec$export$2e2bcd8739ae039 = $e2c4fb76408c4dec$var$FilterDropdown;


"use client";
function $498593f51893a533$var$collectFilterStates(columns, init, pos) {
    let filterStates = [];
    (columns || []).forEach((column, index)=>{
        var _a;
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        if (column.filters || "filterDropdown" in column || "onFilter" in column) {
            if ("filteredValue" in column) {
                // Controlled
                let filteredValues = column.filteredValue;
                if (!("filterDropdown" in column)) filteredValues = (_a = filteredValues === null || filteredValues === void 0 ? void 0 : filteredValues.map(String)) !== null && _a !== void 0 ? _a : filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ("children" in column) filterStates = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(filterStates), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($498593f51893a533$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
}
function $498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale, triggerFilter, getPopupContainer, pos, rootClassName) {
    return columns.map((column, index)=>{
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        const { filterOnClose: filterOnClose = true, filterMultiple: filterMultiple = true, filterMode: filterMode, filterSearch: filterSearch } = column;
        let newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            const columnKey = (0, $10b8a922ada6c9c1$export$480219a02f196e72)(newColumn, columnPos);
            const filterState = filterStates.find((_ref)=>{
                let { key: key } = _ref;
                return columnKey === key;
            });
            newColumn = Object.assign(Object.assign({}, newColumn), {
                title: (renderProps)=>/*#__PURE__*/ $acw62.createElement((0, $e2c4fb76408c4dec$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: `${prefixCls}-filter`,
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterOnClose: filterOnClose,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer,
                        rootClassName: rootClassName
                    }, (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, renderProps))
            });
        }
        if ("children" in newColumn) newColumn = Object.assign(Object.assign({}, newColumn), {
            children: $498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale, triggerFilter, getPopupContainer, columnPos, rootClassName)
        });
        return newColumn;
    });
}
function $498593f51893a533$var$generateFilterInfo(filterStates) {
    const currentFilters = {};
    filterStates.forEach((_ref2)=>{
        let { key: key, filteredKeys: filteredKeys, column: column } = _ref2;
        const keyAsString = key;
        const { filters: filters, filterDropdown: filterDropdown } = column;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            const keys = (0, $e2c4fb76408c4dec$export$50792ddeed01ab0a)(filters);
            currentFilters[keyAsString] = keys.filter((originKey)=>filteredKeys.includes(String(originKey)));
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
}
function $498593f51893a533$export$37643bb40f4c1c56(data, filterStates, childrenColumnName) {
    return filterStates.reduce((currentData, filterState)=>{
        const { column: { onFilter: onFilter, filters: filters }, filteredKeys: filteredKeys } = filterState;
        if (onFilter && filteredKeys && filteredKeys.length) return currentData// shallow copy
        .map((record)=>Object.assign({}, record)).filter((record)=>filteredKeys.some((key)=>{
                const keys = (0, $e2c4fb76408c4dec$export$50792ddeed01ab0a)(filters);
                const keyIndex = keys.findIndex((k)=>String(k) === String(key));
                const realKey = keyIndex !== -1 ? keys[keyIndex] : key;
                // filter children
                if (record[childrenColumnName]) record[childrenColumnName] = $498593f51893a533$export$37643bb40f4c1c56(record[childrenColumnName], filterStates, childrenColumnName);
                return onFilter(realKey, record);
            }));
        return currentData;
    }, data);
}
const $498593f51893a533$var$getMergedColumns = (rawMergedColumns)=>rawMergedColumns.flatMap((column)=>{
        if ("children" in column) return [
            column
        ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($498593f51893a533$var$getMergedColumns(column.children || [])));
        return [
            column
        ];
    });
function $498593f51893a533$var$useFilter(_ref3) {
    let { prefixCls: prefixCls, dropdownPrefixCls: dropdownPrefixCls, mergedColumns: rawMergedColumns, onFilterChange: onFilterChange, getPopupContainer: getPopupContainer, locale: tableLocale, rootClassName: rootClassName } = _ref3;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("Table");
    const mergedColumns = $acw62.useMemo(()=>$498593f51893a533$var$getMergedColumns(rawMergedColumns || []), [
        rawMergedColumns
    ]);
    const [filterStates, setFilterStates] = $acw62.useState(()=>$498593f51893a533$var$collectFilterStates(mergedColumns, true));
    const mergedFilterStates = $acw62.useMemo(()=>{
        const collectedStates = $498593f51893a533$var$collectFilterStates(mergedColumns, false);
        if (collectedStates.length === 0) return collectedStates;
        let filteredKeysIsAllNotControlled = true;
        let filteredKeysIsAllControlled = true;
        collectedStates.forEach((_ref4)=>{
            let { filteredKeys: filteredKeys } = _ref4;
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) {
            // Filter column may have been removed
            const keyList = (mergedColumns || []).map((column, index)=>(0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index)));
            return filterStates.filter((_ref5)=>{
                let { key: key } = _ref5;
                return keyList.includes(key);
            }).map((item)=>{
                const col = mergedColumns[keyList.findIndex((key)=>key === item.key)];
                return Object.assign(Object.assign({}, item), {
                    column: Object.assign(Object.assign({}, item.column), col),
                    forceFiltered: col.filtered
                });
            });
        }
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    const filters = $acw62.useMemo(()=>$498593f51893a533$var$generateFilterInfo(mergedFilterStates), [
        mergedFilterStates
    ]);
    const triggerFilter = (filterState)=>{
        const newFilterStates = mergedFilterStates.filter((_ref6)=>{
            let { key: key } = _ref6;
            return key !== filterState.key;
        });
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($498593f51893a533$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    const transformColumns = (innerColumns)=>$498593f51893a533$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, undefined, rootClassName);
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
}
var $498593f51893a533$export$2e2bcd8739ae039 = $498593f51893a533$var$useFilter;



var $acw62 = parcelRequire("acw62");
function $e2770d04bc76b8cc$export$2e2bcd8739ae039(data, childrenColumnName, getRowKey) {
    const mapCacheRef = $acw62.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            const kvMap = new Map();
            /* eslint-disable no-inner-declarations */ function dig(records) {
                records.forEach((record, index)=>{
                    const rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if (record && typeof record === "object" && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            /* eslint-enable */ dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap.get(key);
    }
    return [
        getRecordByKey
    ];
}



var $acw62 = parcelRequire("acw62");

var $b37c5a68d8297fb7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b37c5a68d8297fb7$export$5716e8bcb003888d = 10;
function $b37c5a68d8297fb7$export$27eceeed7bf0f4c2(mergedPagination, pagination) {
    const param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    const paginationObj = pagination && typeof pagination === "object" ? pagination : {};
    Object.keys(paginationObj).forEach((pageProp)=>{
        const value = mergedPagination[pageProp];
        if (typeof value !== "function") param[pageProp] = value;
    });
    return param;
}
function $b37c5a68d8297fb7$var$usePagination(total, onChange, pagination) {
    const _a = pagination && typeof pagination === "object" ? pagination : {}, { total: paginationTotal = 0 } = _a, paginationObj = $b37c5a68d8297fb7$var$__rest(_a, [
        "total"
    ]);
    const [innerPagination, setInnerPagination] = (0, $acw62.useState)(()=>({
            current: "defaultCurrent" in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: "defaultPageSize" in paginationObj ? paginationObj.defaultPageSize : $b37c5a68d8297fb7$export$5716e8bcb003888d
        }));
    // ============ Basic Pagination Config ============
    const mergedPagination = (0, $be673cd5391dca21$export$2e2bcd8739ae039)(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    const refreshPagination = (current, pageSize)=>{
        setInnerPagination({
            current: current !== null && current !== void 0 ? current : 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    const onInternalChange = (current, pageSize)=>{
        var _a;
        if (pagination) (_a = pagination.onChange) === null || _a === void 0 || _a.call(pagination, current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize));
    };
    if (pagination === false) return [
        {},
        ()=>{}
    ];
    return [
        Object.assign(Object.assign({}, mergedPagination), {
            onChange: onInternalChange
        }),
        refreshPagination
    ];
}
var $b37c5a68d8297fb7$export$2e2bcd8739ae039 = $b37c5a68d8297fb7$var$usePagination;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $749787560a770a62$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
var $749787560a770a62$export$2e2bcd8739ae039 = $749787560a770a62$var$CaretDownOutlined;



var $d6a331782cd0282d$var$CaretDownOutlined = function CaretDownOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $749787560a770a62$export$2e2bcd8739ae039)
    }));
};
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ var $d6a331782cd0282d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($d6a331782cd0282d$var$CaretDownOutlined);
var $d6a331782cd0282d$export$2e2bcd8739ae039 = $d6a331782cd0282d$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $478fce407c73001f$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
var $478fce407c73001f$export$2e2bcd8739ae039 = $478fce407c73001f$var$CaretUpOutlined;



var $ee1b76222e0d2812$var$CaretUpOutlined = function CaretUpOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $478fce407c73001f$export$2e2bcd8739ae039)
    }));
};
/**![caret-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC45IDY4OUw1MzAuNSAzMDguMmMtOS40LTEwLjktMjcuNS0xMC45LTM3IDBMMTY1LjEgNjg5Yy0xMi4yIDE0LjItMS4yIDM1IDE4LjUgMzVoNjU2LjhjMTkuNyAwIDMwLjctMjAuOCAxOC41LTM1eiIgLz48L3N2Zz4=) */ var $ee1b76222e0d2812$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ee1b76222e0d2812$var$CaretUpOutlined);
var $ee1b76222e0d2812$export$2e2bcd8739ae039 = $ee1b76222e0d2812$var$RefIcon;






"use client";
const $71f5389ed963960f$var$ASCEND = "ascend";
const $71f5389ed963960f$var$DESCEND = "descend";
function $71f5389ed963960f$var$getMultiplePriority(column) {
    if (typeof column.sorter === "object" && typeof column.sorter.multiple === "number") return column.sorter.multiple;
    return false;
}
function $71f5389ed963960f$var$getSortFunction(sorter) {
    if (typeof sorter === "function") return sorter;
    if (sorter && typeof sorter === "object" && sorter.compare) return sorter.compare;
    return false;
}
function $71f5389ed963960f$var$nextSortDirection(sortDirections, current) {
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
}
function $71f5389ed963960f$var$collectSortStates(columns, init, pos) {
    let sortStates = [];
    function pushState(column, columnPos) {
        sortStates.push({
            column: column,
            key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    }
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ("sortOrder" in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(sortStates), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)($71f5389ed963960f$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ("sortOrder" in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $10b8a922ada6c9c1$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
}
function $71f5389ed963960f$var$injectSorter(prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos) {
    return (columns || []).map((column, index)=>{
        const columnPos = (0, $10b8a922ada6c9c1$export$7e4db04adce9b4db)(index, pos);
        let newColumn = column;
        if (newColumn.sorter) {
            const sortDirections = newColumn.sortDirections || defaultSortDirections;
            const showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            const columnKey = (0, $10b8a922ada6c9c1$export$480219a02f196e72)(newColumn, columnPos);
            const sorterState = sorterStates.find((_ref)=>{
                let { key: key } = _ref;
                return key === columnKey;
            });
            const sortOrder = sorterState ? sorterState.sortOrder : null;
            const nextSortOrder = $71f5389ed963960f$var$nextSortDirection(sortDirections, sortOrder);
            let sorter;
            if (column.sortIcon) sorter = column.sortIcon({
                sortOrder: sortOrder
            });
            else {
                const upNode = sortDirections.includes($71f5389ed963960f$var$ASCEND) && /*#__PURE__*/ $acw62.createElement((0, $ee1b76222e0d2812$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-column-sorter-up`, {
                        active: sortOrder === $71f5389ed963960f$var$ASCEND
                    })
                });
                const downNode = sortDirections.includes($71f5389ed963960f$var$DESCEND) && /*#__PURE__*/ $acw62.createElement((0, $d6a331782cd0282d$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-column-sorter-down`, {
                        active: sortOrder === $71f5389ed963960f$var$DESCEND
                    })
                });
                sorter = /*#__PURE__*/ $acw62.createElement("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-column-sorter`, {
                        [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
                    })
                }, /*#__PURE__*/ $acw62.createElement("span", {
                    className: `${prefixCls}-column-sorter-inner`,
                    "aria-hidden": "true"
                }, upNode, downNode));
            }
            const { cancelSort: cancelSort, triggerAsc: triggerAsc, triggerDesc: triggerDesc } = tableLocale || {};
            let sortTip = cancelSort;
            if (nextSortOrder === $71f5389ed963960f$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $71f5389ed963960f$var$ASCEND) sortTip = triggerAsc;
            const tooltipProps = typeof showSorterTooltip === "object" ? Object.assign({
                title: sortTip
            }, showSorterTooltip) : {
                title: sortTip
            };
            newColumn = Object.assign(Object.assign({}, newColumn), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(newColumn.className, {
                    [`${prefixCls}-column-sort`]: sortOrder
                }),
                title: (renderProps)=>{
                    const columnSortersClass = `${prefixCls}-column-sorters`;
                    const renderColumnTitleWrapper = /*#__PURE__*/ $acw62.createElement("span", {
                        className: `${prefixCls}-column-title`
                    }, (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, renderProps));
                    const renderSortTitle = /*#__PURE__*/ $acw62.createElement("div", {
                        className: columnSortersClass
                    }, renderColumnTitleWrapper, sorter);
                    if (showSorterTooltip) {
                        if (typeof showSorterTooltip !== "boolean" && (showSorterTooltip === null || showSorterTooltip === void 0 ? void 0 : showSorterTooltip.target) === "sorter-icon") return /*#__PURE__*/ $acw62.createElement("div", {
                            className: `${columnSortersClass} ${prefixCls}-column-sorters-tooltip-target-sorter`
                        }, renderColumnTitleWrapper, /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({}, tooltipProps), sorter));
                        return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({}, tooltipProps), renderSortTitle);
                    }
                    return renderSortTitle;
                },
                onHeaderCell: (col)=>{
                    var _a;
                    const cell = ((_a = column.onHeaderCell) === null || _a === void 0 ? void 0 : _a.call(column, col)) || {};
                    const originOnClick = cell.onClick;
                    const originOKeyDown = cell.onKeyDown;
                    cell.onClick = (event)=>{
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column)
                        });
                        originOnClick === null || originOnClick === void 0 || originOnClick(event);
                    };
                    cell.onKeyDown = (event)=>{
                        if (event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $71f5389ed963960f$var$getMultiplePriority(column)
                            });
                            originOKeyDown === null || originOKeyDown === void 0 || originOKeyDown(event);
                        }
                    };
                    const renderTitle = (0, $10b8a922ada6c9c1$export$1c24e0676a106839)(column.title, {});
                    const displayTitle = renderTitle === null || renderTitle === void 0 ? void 0 : renderTitle.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sortOrder) cell["aria-sort"] = sortOrder === "ascend" ? "ascending" : "descending";
                    else cell["aria-label"] = displayTitle || "";
                    cell.className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(cell.className, `${prefixCls}-column-has-sorters`);
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle !== null && renderTitle !== void 0 ? renderTitle : "").toString();
                    return cell;
                }
            });
        }
        if ("children" in newColumn) newColumn = Object.assign(Object.assign({}, newColumn), {
            children: $71f5389ed963960f$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos)
        });
        return newColumn;
    });
}
const $71f5389ed963960f$var$stateToInfo = (sorterStates)=>{
    const { column: column, sortOrder: sortOrder } = sorterStates;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
};
const $71f5389ed963960f$var$generateSorterInfo = (sorterStates)=>{
    const list = sorterStates.filter((_ref2)=>{
        let { sortOrder: sortOrder } = _ref2;
        return sortOrder;
    }).map($71f5389ed963960f$var$stateToInfo);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (list.length === 0 && sorterStates.length) {
        const lastIndex = sorterStates.length - 1;
        return Object.assign(Object.assign({}, $71f5389ed963960f$var$stateToInfo(sorterStates[lastIndex])), {
            column: undefined
        });
    }
    if (list.length <= 1) return list[0] || {};
    return list;
};
function $71f5389ed963960f$export$594b2c8da4a70ee(data, sortStates, childrenColumnName) {
    const innerSorterStates = sortStates.slice().sort((a, b)=>b.multiplePriority - a.multiplePriority);
    const cloneData = data.slice();
    const runningSorters = innerSorterStates.filter((_ref3)=>{
        let { column: { sorter: sorter }, sortOrder: sortOrder } = _ref3;
        return $71f5389ed963960f$var$getSortFunction(sorter) && sortOrder;
    });
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort((record1, record2)=>{
        for(let i = 0; i < runningSorters.length; i += 1){
            const sorterState = runningSorters[i];
            const { column: { sorter: sorter }, sortOrder: sortOrder } = sorterState;
            const compareFn = $71f5389ed963960f$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                const compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $71f5389ed963960f$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map((record)=>{
        const subRecords = record[childrenColumnName];
        if (subRecords) return Object.assign(Object.assign({}, record), {
            [childrenColumnName]: $71f5389ed963960f$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)
        });
        return record;
    });
}
function $71f5389ed963960f$export$2e2bcd8739ae039(_ref4) {
    let { prefixCls: prefixCls, mergedColumns: mergedColumns, onSorterChange: onSorterChange, sortDirections: sortDirections, tableLocale: tableLocale, showSorterTooltip: showSorterTooltip } = _ref4;
    const [sortStates, setSortStates] = $acw62.useState($71f5389ed963960f$var$collectSortStates(mergedColumns, true));
    const mergedSorterStates = $acw62.useMemo(()=>{
        let validate = true;
        const collectedStates = $71f5389ed963960f$var$collectSortStates(mergedColumns, false);
        // Return if not controlled
        if (!collectedStates.length) return sortStates;
        const validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push(Object.assign(Object.assign({}, state), {
                sortOrder: null
            }));
        }
        let multipleMode = null;
        collectedStates.forEach((state)=>{
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        mergedColumns,
        sortStates
    ]);
    // Get render columns title required props
    const columnTitleSorterProps = $acw62.useMemo(()=>{
        var _a, _b;
        const sortColumns = mergedSorterStates.map((_ref5)=>{
            let { column: column, sortOrder: sortOrder } = _ref5;
            return {
                column: column,
                order: sortOrder
            };
        });
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: (_a = sortColumns[0]) === null || _a === void 0 ? void 0 : _a.column,
            sortOrder: (_b = sortColumns[0]) === null || _b === void 0 ? void 0 : _b.order
        };
    }, [
        mergedSorterStates
    ]);
    const triggerSorter = (sortState)=>{
        let newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(mergedSorterStates.filter((_ref6)=>{
            let { key: key } = _ref6;
            return key !== sortState.key;
        })), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($71f5389ed963960f$var$generateSorterInfo(newSorterStates), newSorterStates);
    };
    const transformColumns = (innerColumns)=>$71f5389ed963960f$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip);
    const getSorters = ()=>$71f5389ed963960f$var$generateSorterInfo(mergedSorterStates);
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
}



var $acw62 = parcelRequire("acw62");

function $6bcbe2fbe72fb80a$var$fillTitle(columns, columnTitleProps) {
    return columns.map((column)=>{
        const cloneColumn = Object.assign({}, column);
        cloneColumn.title = (0, $10b8a922ada6c9c1$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ("children" in cloneColumn) cloneColumn.children = $6bcbe2fbe72fb80a$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
}
function $6bcbe2fbe72fb80a$export$2e2bcd8739ae039(columnTitleProps) {
    const filledColumns = $acw62.useCallback((columns)=>$6bcbe2fbe72fb80a$var$fillTitle(columns, columnTitleProps), [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
}



"use client";
var /**
 * Same as `rc-table` but we modify trigger children update logic instead.
 */ $5ea5ba4b4caafc13$export$2e2bcd8739ae039 = (0, $fd7626e42d9e458e$export$13da147d1fdf3e3c)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});



"use client";
var /**
 * Same as `rc-table` but we modify trigger children update logic instead.
 */ $18bcd07e79dcd06c$export$2e2bcd8739ae039 = (0, $256f829f2e694a08$export$4747b79b36862360)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});







const $b9b6fedf44f4f803$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableHeaderBg: tableHeaderBg, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal)=>({
            [`&${componentCls}-${size}`]: {
                [`> ${componentCls}-container`]: {
                    [`> ${componentCls}-content, > ${componentCls}-body`]: {
                        [`
            > table > tbody > tr > th,
            > table > tbody > tr > td
          `]: {
                            [`> ${componentCls}-expanded-row-fixed`]: {
                                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())}
              ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
                            }
                        }
                    }
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}${componentCls}-bordered`]: Object.assign(Object.assign(Object.assign({
                // ============================ Title =============================
                [`> ${componentCls}-title`]: {
                    border: tableBorder,
                    borderBottom: 0
                },
                // ============================ Content ============================
                [`> ${componentCls}-container`]: {
                    borderInlineStart: tableBorder,
                    borderTop: tableBorder,
                    [`
            > ${componentCls}-content,
            > ${componentCls}-header,
            > ${componentCls}-body,
            > ${componentCls}-summary
          `]: {
                        "> table": {
                            // ============================= Cell =============================
                            [`
                > thead > tr > th,
                > thead > tr > td,
                > tbody > tr > th,
                > tbody > tr > td,
                > tfoot > tr > th,
                > tfoot > tr > td
              `]: {
                                borderInlineEnd: tableBorder
                            },
                            // ============================ Header ============================
                            "> thead": {
                                "> tr:not(:last-child) > th": {
                                    borderBottom: tableBorder
                                },
                                "> tr > th::before": {
                                    backgroundColor: "transparent !important"
                                }
                            },
                            // Fixed right should provides additional border
                            [`
                > thead > tr,
                > tbody > tr,
                > tfoot > tr
              `]: {
                                [`> ${componentCls}-cell-fix-right-first::after`]: {
                                    borderInlineEnd: tableBorder
                                }
                            },
                            // ========================== Expandable ==========================
                            [`
                > tbody > tr > th,
                > tbody > tr > td
              `]: {
                                [`> ${componentCls}-expanded-row-fixed`]: {
                                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                                    "&::after": {
                                        position: "absolute",
                                        top: 0,
                                        insetInlineEnd: lineWidth,
                                        bottom: 0,
                                        borderInlineEnd: tableBorder,
                                        content: '""'
                                    }
                                }
                            }
                        }
                    }
                },
                // ============================ Scroll ============================
                [`&${componentCls}-scroll-horizontal`]: {
                    [`> ${componentCls}-container > ${componentCls}-body`]: {
                        "> table > tbody": {
                            [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                                "> th, > td": {
                                    borderInlineEnd: 0
                                }
                            }
                        }
                    }
                }
            }, getSizeBorderStyle("middle", token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle)), getSizeBorderStyle("small", token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall)), {
                // ============================ Footer ============================
                [`> ${componentCls}-footer`]: {
                    border: tableBorder,
                    borderTop: 0
                }
            }),
            // ============================ Nested ============================
            [`${componentCls}-cell`]: {
                [`${componentCls}-container:first-child`]: {
                    // :first-child to avoid the case when bordered and title is set
                    borderTop: 0
                },
                // https://github.com/ant-design/ant-design/issues/35577
                "&-scrollbar:not([rowspan])": {
                    boxShadow: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${tableHeaderBg}`
                }
            },
            [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
                borderInlineEnd: tableBorder
            }
        }
    };
};
var $b9b6fedf44f4f803$export$2e2bcd8739ae039 = $b9b6fedf44f4f803$var$genBorderedStyle;



const $bce3bf4179f630c0$var$genEllipsisStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-cell-ellipsis`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                wordBreak: "keep-all",
                // Fixed first or last should special process
                [`
          &${componentCls}-cell-fix-left-last,
          &${componentCls}-cell-fix-right-first
        `]: {
                    overflow: "visible",
                    [`${componentCls}-cell-content`]: {
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                    }
                },
                [`${componentCls}-column-title`]: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    wordBreak: "keep-all"
                }
            })
        }
    };
};
var $bce3bf4179f630c0$export$2e2bcd8739ae039 = $bce3bf4179f630c0$var$genEllipsisStyle;


// ========================= Placeholder ==========================
const $2d5ebf15cfaf4644$var$genEmptyStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
                textAlign: "center",
                color: token.colorTextDisabled,
                [`
          &:hover > th,
          &:hover > td,
        `]: {
                    background: token.colorBgContainer
                }
            }
        }
    };
};
var $2d5ebf15cfaf4644$export$2e2bcd8739ae039 = $2d5ebf15cfaf4644$var$genEmptyStyle;




const $8888c6f6420bf18d$var$genExpandStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, paddingXS: paddingXS, lineType: lineType, tableBorderColor: tableBorderColor, tableExpandIconBg: tableExpandIconBg, tableExpandColumnWidth: tableExpandColumnWidth, borderRadius: borderRadius, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandedRowBg: tableExpandedRowBg, paddingXXS: paddingXXS, expandIconMarginTop: expandIconMarginTop, expandIconSize: expandIconSize, expandIconHalfInner: expandIconHalfInner, expandIconScale: expandIconScale, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-expand-icon-col`]: {
                width: tableExpandColumnWidth
            },
            [`${componentCls}-row-expand-icon-cell`]: {
                textAlign: "center",
                [`${componentCls}-row-expand-icon`]: {
                    display: "inline-flex",
                    float: "none",
                    verticalAlign: "sub"
                }
            },
            [`${componentCls}-row-indent`]: {
                height: 1,
                float: "left"
            },
            [`${componentCls}-row-expand-icon`]: Object.assign(Object.assign({}, (0, $d48037fcbf78d816$export$9a16e7694a707ab4)(token)), {
                position: "relative",
                float: "left",
                boxSizing: "border-box",
                width: expandIconSize,
                height: expandIconSize,
                padding: 0,
                color: "inherit",
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(expandIconSize),
                background: tableExpandIconBg,
                border: tableBorder,
                borderRadius: borderRadius,
                transform: `scale(${expandIconScale})`,
                transition: `all ${motionDurationSlow}`,
                userSelect: "none",
                "&:focus, &:hover, &:active": {
                    borderColor: "currentcolor"
                },
                "&::before, &::after": {
                    position: "absolute",
                    background: "currentcolor",
                    transition: `transform ${motionDurationSlow} ease-out`,
                    content: '""'
                },
                "&::before": {
                    top: expandIconHalfInner,
                    insetInlineEnd: expandIconLineOffset,
                    insetInlineStart: expandIconLineOffset,
                    height: lineWidth
                },
                "&::after": {
                    top: expandIconLineOffset,
                    bottom: expandIconLineOffset,
                    insetInlineStart: expandIconHalfInner,
                    width: lineWidth,
                    transform: "rotate(90deg)"
                },
                // Motion effect
                "&-collapsed::before": {
                    transform: "rotate(-180deg)"
                },
                "&-collapsed::after": {
                    transform: "rotate(0deg)"
                },
                "&-spaced": {
                    "&::before, &::after": {
                        display: "none",
                        content: "none"
                    },
                    background: "transparent",
                    border: 0,
                    visibility: "hidden"
                }
            }),
            [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
                marginTop: expandIconMarginTop,
                marginInlineEnd: paddingXS
            },
            [`tr${componentCls}-expanded-row`]: {
                "&, &:hover": {
                    "> th, > td": {
                        background: tableExpandedRowBg
                    }
                },
                // https://github.com/ant-design/ant-design/issues/25573
                [`${antCls}-descriptions-view`]: {
                    display: "flex",
                    table: {
                        flex: "auto",
                        width: "auto"
                    }
                }
            },
            // With fixed
            [`${componentCls}-expanded-row-fixed`]: {
                position: "relative",
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`
            }
        }
    };
};
var $8888c6f6420bf18d$export$2e2bcd8739ae039 = $8888c6f6420bf18d$var$genExpandStyle;




const $da23b384be167274$var$genFilterStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, tableFilterDropdownWidth: tableFilterDropdownWidth, tableFilterDropdownSearchWidth: tableFilterDropdownSearchWidth, paddingXXS: paddingXXS, paddingXS: paddingXS, colorText: colorText, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, headerIconColor: headerIconColor, fontSizeSM: fontSizeSM, tablePaddingHorizontal: tablePaddingHorizontal, borderRadius: borderRadius, motionDurationSlow: motionDurationSlow, colorTextDescription: colorTextDescription, colorPrimary: colorPrimary, tableHeaderFilterActiveBg: tableHeaderFilterActiveBg, colorTextDisabled: colorTextDisabled, tableFilterDropdownBg: tableFilterDropdownBg, tableFilterDropdownHeight: tableFilterDropdownHeight, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive, boxShadowSecondary: boxShadowSecondary, filterDropdownMenuBg: filterDropdownMenuBg, calc: calc } = token;
    const dropdownPrefixCls = `${antCls}-dropdown`;
    const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
    const treePrefixCls = `${antCls}-tree`;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${componentCls}-filter-column`]: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                [`${componentCls}-filter-trigger`]: {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    marginBlock: calc(paddingXXS).mul(-1).equal(),
                    marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXXS)}`,
                    color: headerIconColor,
                    fontSize: fontSizeSM,
                    borderRadius: borderRadius,
                    cursor: "pointer",
                    transition: `all ${motionDurationSlow}`,
                    "&:hover": {
                        color: colorTextDescription,
                        background: tableHeaderFilterActiveBg
                    },
                    "&.active": {
                        color: colorPrimary
                    }
                }
            }
        },
        {
            // Dropdown
            [`${antCls}-dropdown`]: {
                [tableFilterDropdownPrefixCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                    minWidth: tableFilterDropdownWidth,
                    backgroundColor: tableFilterDropdownBg,
                    borderRadius: borderRadius,
                    boxShadow: boxShadowSecondary,
                    overflow: "hidden",
                    // Reset menu
                    [`${dropdownPrefixCls}-menu`]: {
                        // https://github.com/ant-design/ant-design/issues/4916
                        // https://github.com/ant-design/ant-design/issues/19542
                        maxHeight: tableFilterDropdownHeight,
                        overflowX: "hidden",
                        border: 0,
                        boxShadow: "none",
                        borderRadius: "unset",
                        backgroundColor: filterDropdownMenuBg,
                        "&:empty::after": {
                            display: "block",
                            padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)} 0`,
                            color: colorTextDisabled,
                            fontSize: fontSizeSM,
                            textAlign: "center",
                            content: '"Not Found"'
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-tree`]: {
                        paddingBlock: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)} 0`,
                        paddingInline: paddingXS,
                        [treePrefixCls]: {
                            padding: 0
                        },
                        [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
                            backgroundColor: controlItemBgHover
                        },
                        [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
                            "&, &:hover": {
                                backgroundColor: controlItemBgActive
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-search`]: {
                        padding: paddingXS,
                        borderBottom: tableBorder,
                        "&-input": {
                            input: {
                                minWidth: tableFilterDropdownSearchWidth
                            },
                            [iconCls]: {
                                color: colorTextDisabled
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-checkall`]: {
                        width: "100%",
                        marginBottom: paddingXXS,
                        marginInlineStart: paddingXXS
                    },
                    // Operation
                    [`${tableFilterDropdownPrefixCls}-btns`]: {
                        display: "flex",
                        justifyContent: "space-between",
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingXS).sub(lineWidth).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXS)}`,
                        overflow: "hidden",
                        borderTop: tableBorder
                    }
                })
            }
        },
        // Dropdown Menu & SubMenu
        {
            // submenu of table filter dropdown
            [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
                // Checkbox
                [`${antCls}-checkbox-wrapper + span`]: {
                    paddingInlineStart: paddingXS,
                    color: colorText
                },
                "> ul": {
                    maxHeight: "calc(100vh - 130px)",
                    overflowX: "hidden",
                    overflowY: "auto"
                }
            }
        }
    ];
};
var $da23b384be167274$export$2e2bcd8739ae039 = $da23b384be167274$var$genFilterStyle;


const $3bb78fceca3da582$var$genFixedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, colorSplit: colorSplit, motionDurationSlow: motionDurationSlow, zIndexTableFixed: zIndexTableFixed, tableBg: tableBg, zIndexTableSticky: zIndexTableSticky, calc: calc } = token;
    const shadowColor = colorSplit;
    // Follow style is magic of shadow which should not follow token:
    return {
        [`${componentCls}-wrapper`]: {
            [`
        ${componentCls}-cell-fix-left,
        ${componentCls}-cell-fix-right
      `]: {
                position: "sticky !important",
                zIndex: zIndexTableFixed,
                background: tableBg
            },
            [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after
      `]: {
                position: "absolute",
                top: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                bottom: calc(lineWidth).mul(-1).equal(),
                width: 30,
                transform: "translateX(100%)",
                transition: `box-shadow ${motionDurationSlow}`,
                content: '""',
                pointerEvents: "none"
            },
            [`${componentCls}-cell-fix-left-all::after`]: {
                display: "none"
            },
            [`
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
                position: "absolute",
                top: 0,
                bottom: calc(lineWidth).mul(-1).equal(),
                left: {
                    _skip_check_: true,
                    value: 0
                },
                width: 30,
                transform: "translateX(-100%)",
                transition: `box-shadow ${motionDurationSlow}`,
                content: '""',
                pointerEvents: "none"
            },
            [`${componentCls}-container`]: {
                position: "relative",
                "&::before, &::after": {
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    zIndex: calc(zIndexTableSticky).add(1).equal({
                        unit: false
                    }),
                    width: 30,
                    transition: `box-shadow ${motionDurationSlow}`,
                    content: '""',
                    pointerEvents: "none"
                },
                "&::before": {
                    insetInlineStart: 0
                },
                "&::after": {
                    insetInlineEnd: 0
                }
            },
            [`${componentCls}-ping-left`]: {
                [`&:not(${componentCls}-has-fix-left) ${componentCls}-container::before`]: {
                    boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
                },
                [`
          ${componentCls}-cell-fix-left-first::after,
          ${componentCls}-cell-fix-left-last::after
        `]: {
                    boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
                },
                [`${componentCls}-cell-fix-left-last::before`]: {
                    backgroundColor: "transparent !important"
                }
            },
            [`${componentCls}-ping-right`]: {
                [`&:not(${componentCls}-has-fix-right) ${componentCls}-container::after`]: {
                    boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
                },
                [`
          ${componentCls}-cell-fix-right-first::after,
          ${componentCls}-cell-fix-right-last::after
        `]: {
                    boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
                }
            },
            // Gapped fixed Columns do not show the shadow
            [`${componentCls}-fixed-column-gapped`]: {
                [`
        ${componentCls}-cell-fix-left-first::after,
        ${componentCls}-cell-fix-left-last::after,
        ${componentCls}-cell-fix-right-first::after,
        ${componentCls}-cell-fix-right-last::after
      `]: {
                    boxShadow: "none"
                }
            }
        }
    };
};
var $3bb78fceca3da582$export$2e2bcd8739ae039 = $3bb78fceca3da582$var$genFixedStyle;



const $9a6bae14c3d282e3$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, margin: margin } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Pagination ==========================
            [`${componentCls}-pagination${antCls}-pagination`]: {
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(margin)} 0`
            },
            [`${componentCls}-pagination`]: {
                display: "flex",
                flexWrap: "wrap",
                rowGap: token.paddingXS,
                "> *": {
                    flex: "none"
                },
                "&-left": {
                    justifyContent: "flex-start"
                },
                "&-center": {
                    justifyContent: "center"
                },
                "&-right": {
                    justifyContent: "flex-end"
                }
            }
        }
    };
};
var $9a6bae14c3d282e3$export$2e2bcd8739ae039 = $9a6bae14c3d282e3$var$genPaginationStyle;



const $4773b3998487f976$var$genRadiusStyle = (token)=>{
    const { componentCls: componentCls, tableRadius: tableRadius } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [componentCls]: {
                // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
                [`${componentCls}-title, ${componentCls}-header`]: {
                    borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} 0 0`
                },
                [`${componentCls}-title + ${componentCls}-container`]: {
                    borderStartStartRadius: 0,
                    borderStartEndRadius: 0,
                    // https://github.com/ant-design/ant-design/issues/41975
                    [`${componentCls}-header, table`]: {
                        borderRadius: 0
                    },
                    "table > thead > tr:first-child": {
                        "th:first-child, th:last-child, td:first-child, td:last-child": {
                            borderRadius: 0
                        }
                    }
                },
                "&-container": {
                    borderStartStartRadius: tableRadius,
                    borderStartEndRadius: tableRadius,
                    "table > thead > tr:first-child": {
                        "> *:first-child": {
                            borderStartStartRadius: tableRadius
                        },
                        "> *:last-child": {
                            borderStartEndRadius: tableRadius
                        }
                    }
                },
                "&-footer": {
                    borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)}`
                }
            }
        }
    };
};
var $4773b3998487f976$export$2e2bcd8739ae039 = $4773b3998487f976$var$genRadiusStyle;


const $5ed237fc7d94970f$var$genStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper-rtl`]: {
            direction: "rtl",
            table: {
                direction: "rtl"
            },
            [`${componentCls}-pagination-left`]: {
                justifyContent: "flex-end"
            },
            [`${componentCls}-pagination-right`]: {
                justifyContent: "flex-start"
            },
            [`${componentCls}-row-expand-icon`]: {
                float: "right",
                "&::after": {
                    transform: "rotate(-90deg)"
                },
                "&-collapsed::before": {
                    transform: "rotate(180deg)"
                },
                "&-collapsed::after": {
                    transform: "rotate(0deg)"
                }
            },
            [`${componentCls}-container`]: {
                "&::before": {
                    insetInlineStart: "unset",
                    insetInlineEnd: 0
                },
                "&::after": {
                    insetInlineStart: 0,
                    insetInlineEnd: "unset"
                },
                [`${componentCls}-row-indent`]: {
                    float: "right"
                }
            }
        }
    };
};
var $5ed237fc7d94970f$export$2e2bcd8739ae039 = $5ed237fc7d94970f$var$genStyle;



const $ca6d152d3b6852e2$var$genSelectionStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, fontSizeIcon: fontSizeIcon, padding: padding, paddingXS: paddingXS, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor, tableSelectionColumnWidth: tableSelectionColumnWidth, tableSelectedRowBg: tableSelectedRowBg, tableSelectedRowHoverBg: tableSelectedRowHoverBg, tableRowHoverBg: tableRowHoverBg, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Selections ==========================
            [`${componentCls}-selection-col`]: {
                width: tableSelectionColumnWidth,
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
                }
            },
            [`${componentCls}-bordered ${componentCls}-selection-col`]: {
                width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
                }
            },
            [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS,
                textAlign: "center",
                [`${antCls}-radio-wrapper`]: {
                    marginInlineEnd: 0
                }
            },
            [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
                zIndex: token.zIndexTableFixed + 1
            },
            [`table tr th${componentCls}-selection-column::after`]: {
                backgroundColor: "transparent !important"
            },
            [`${componentCls}-selection`]: {
                position: "relative",
                display: "inline-flex",
                flexDirection: "column"
            },
            [`${componentCls}-selection-extra`]: {
                position: "absolute",
                top: 0,
                zIndex: 1,
                cursor: "pointer",
                transition: `all ${token.motionDurationSlow}`,
                marginInlineStart: "100%",
                paddingInlineStart: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(4).equal()),
                [iconCls]: {
                    color: headerIconColor,
                    fontSize: fontSizeIcon,
                    verticalAlign: "baseline",
                    "&:hover": {
                        color: headerIconHoverColor
                    }
                }
            },
            // ============================= Rows =============================
            [`${componentCls}-tbody`]: {
                [`${componentCls}-row`]: {
                    [`&${componentCls}-row-selected`]: {
                        [`> ${componentCls}-cell`]: {
                            background: tableSelectedRowBg,
                            "&-row-hover": {
                                background: tableSelectedRowHoverBg
                            }
                        }
                    },
                    [`> ${componentCls}-cell-row-hover`]: {
                        background: tableRowHoverBg
                    }
                }
            }
        }
    };
};
var $ca6d152d3b6852e2$export$2e2bcd8739ae039 = $ca6d152d3b6852e2$var$genSelectionStyle;



const $d7a83fe23e3255cb$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, tableExpandColumnWidth: tableExpandColumnWidth, calc: calc } = token;
    const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize)=>({
            [`${componentCls}${componentCls}-${size}`]: {
                fontSize: fontSize,
                [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingHorizontal)}`
                },
                [`${componentCls}-filter-trigger`]: {
                    marginInlineEnd: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).div(2).mul(-1).equal())
                },
                [`${componentCls}-expanded-row-fixed`]: {
                    margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                },
                [`${componentCls}-tbody`]: {
                    // ========================= Nest Table ===========================
                    [`${componentCls}-wrapper:only-child ${componentCls}`]: {
                        marginBlock: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal()),
                        marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                    }
                },
                // https://github.com/ant-design/ant-design/issues/35167
                [`${componentCls}-selection-extra`]: {
                    paddingInlineStart: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(paddingHorizontal).div(4).equal())
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({}, getSizeStyle("middle", token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle)), getSizeStyle("small", token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall))
    };
};
var $d7a83fe23e3255cb$export$2e2bcd8739ae039 = $d7a83fe23e3255cb$var$genSizeStyle;


const $6655b371bedfd634$var$genSorterStyle = (token)=>{
    const { componentCls: componentCls, marginXXS: marginXXS, fontSizeIcon: fontSizeIcon, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
                outline: "none",
                cursor: "pointer",
                transition: `all ${token.motionDurationSlow}`,
                "&:hover": {
                    background: token.tableHeaderSortHoverBg,
                    "&::before": {
                        backgroundColor: "transparent !important"
                    }
                },
                "&:focus-visible": {
                    color: token.colorPrimary
                },
                // https://github.com/ant-design/ant-design/issues/30969
                [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
                    background: token.tableFixedHeaderSortActiveBg
                }
            },
            [`${componentCls}-thead th${componentCls}-column-sort`]: {
                background: token.tableHeaderSortBg,
                "&::before": {
                    backgroundColor: "transparent !important"
                }
            },
            [`td${componentCls}-column-sort`]: {
                background: token.tableBodySortBg
            },
            [`${componentCls}-column-title`]: {
                position: "relative",
                zIndex: 1,
                flex: 1
            },
            [`${componentCls}-column-sorters`]: {
                display: "flex",
                flex: "auto",
                alignItems: "center",
                justifyContent: "space-between",
                "&::after": {
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    content: '""'
                }
            },
            [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
                "&::after": {
                    content: "none"
                }
            },
            [`${componentCls}-column-sorter`]: {
                marginInlineStart: marginXXS,
                color: headerIconColor,
                fontSize: 0,
                transition: `color ${token.motionDurationSlow}`,
                "&-inner": {
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "center"
                },
                "&-up, &-down": {
                    fontSize: fontSizeIcon,
                    "&.active": {
                        color: token.colorPrimary
                    }
                },
                [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
                    marginTop: "-0.3em"
                }
            },
            [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
                color: headerIconHoverColor
            }
        }
    };
};
var $6655b371bedfd634$export$2e2bcd8739ae039 = $6655b371bedfd634$var$genSorterStyle;



const $994f7808639e9938$var$genStickyStyle = (token)=>{
    const { componentCls: componentCls, opacityLoading: opacityLoading, tableScrollThumbBg: tableScrollThumbBg, tableScrollThumbBgHover: tableScrollThumbBgHover, tableScrollThumbSize: tableScrollThumbSize, tableScrollBg: tableScrollBg, zIndexTableSticky: zIndexTableSticky, stickyScrollBarBorderRadius: stickyScrollBarBorderRadius, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-sticky`]: {
                "&-holder": {
                    position: "sticky",
                    zIndex: zIndexTableSticky,
                    background: token.colorBgContainer
                },
                "&-scroll": {
                    position: "sticky",
                    bottom: 0,
                    height: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableScrollThumbSize)} !important`,
                    zIndex: zIndexTableSticky,
                    display: "flex",
                    alignItems: "center",
                    background: tableScrollBg,
                    borderTop: tableBorder,
                    opacity: opacityLoading,
                    "&:hover": {
                        transformOrigin: "center bottom"
                    },
                    // fake scrollbar style of sticky
                    "&-bar": {
                        height: tableScrollThumbSize,
                        backgroundColor: tableScrollThumbBg,
                        borderRadius: stickyScrollBarBorderRadius,
                        transition: `all ${token.motionDurationSlow}, transform none`,
                        position: "absolute",
                        bottom: 0,
                        "&:hover, &-active": {
                            backgroundColor: tableScrollThumbBgHover
                        }
                    }
                }
            }
        }
    };
};
var $994f7808639e9938$export$2e2bcd8739ae039 = $994f7808639e9938$var$genStickyStyle;



const $9a56b0c2c027df00$var$genSummaryStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-summary`]: {
                position: "relative",
                zIndex: token.zIndexTableFixed,
                background: token.tableBg,
                "> tr": {
                    "> th, > td": {
                        borderBottom: tableBorder
                    }
                }
            },
            [`div${componentCls}-summary`]: {
                boxShadow: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
            }
        }
    };
};
var $9a56b0c2c027df00$export$2e2bcd8739ae039 = $9a56b0c2c027df00$var$genSummaryStyle;



const $f75ead9ff31bbaa9$var$genVirtualStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const rowCellCls = `${componentCls}-expanded-row-cell`;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Row ==========================
            [`${componentCls}-tbody-virtual`]: {
                [`${componentCls}-row:not(tr)`]: {
                    display: "flex",
                    boxSizing: "border-box",
                    width: "100%"
                },
                [`${componentCls}-cell`]: {
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid}`
                },
                [`${componentCls}-expanded-row`]: {
                    [`${rowCellCls}${rowCellCls}-fixed`]: {
                        position: "sticky",
                        insetInlineStart: 0,
                        overflow: "hidden",
                        width: `calc(var(--virtual-width) - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)})`,
                        borderInlineEnd: "none"
                    }
                }
            },
            // ======================== Border =========================
            [`${componentCls}-bordered`]: {
                [`${componentCls}-tbody-virtual`]: {
                    "&:after": {
                        content: '""',
                        insetInline: 0,
                        bottom: 0,
                        borderBottom: tableBorder,
                        position: "absolute"
                    },
                    [`${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        [`&${componentCls}-cell-fix-right-first:before`]: {
                            content: '""',
                            position: "absolute",
                            insetBlock: 0,
                            insetInlineStart: calc(lineWidth).mul(-1).equal(),
                            borderInlineStart: tableBorder
                        }
                    }
                },
                // Empty placeholder
                [`&${componentCls}-virtual`]: {
                    [`${componentCls}-placeholder ${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        borderBottom: tableBorder
                    }
                }
            }
        }
    };
};
var $f75ead9ff31bbaa9$export$2e2bcd8739ae039 = $f75ead9ff31bbaa9$var$genVirtualStyle;


const $52ea1741590722c9$var$genTableStyle = (token)=>{
    const { componentCls: componentCls, fontWeightStrong: fontWeightStrong, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandColumnWidth: tableExpandColumnWidth, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableFontSize: tableFontSize, tableBg: tableBg, tableRadius: tableRadius, tableHeaderTextColor: tableHeaderTextColor, motionDurationMid: motionDurationMid, tableHeaderBg: tableHeaderBg, tableHeaderCellSplitColor: tableHeaderCellSplitColor, tableFooterTextColor: tableFooterTextColor, tableFooterBg: tableFooterBg, calc: calc } = token;
    const tableBorder = `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: Object.assign(Object.assign({
            clear: "both",
            maxWidth: "100%"
        }, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                fontSize: tableFontSize,
                background: tableBg,
                borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} 0 0`,
                // https://github.com/ant-design/ant-design/issues/47486
                scrollbarColor: `${token.tableScrollThumbBg} ${token.tableScrollBg}`
            }),
            // https://github.com/ant-design/ant-design/issues/17611
            table: {
                width: "100%",
                textAlign: "start",
                borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tableRadius)} 0 0`,
                borderCollapse: "separate",
                borderSpacing: 0
            },
            // ============================= Cell ==============================
            [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
                position: "relative",
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                overflowWrap: "break-word"
            },
            // ============================ Title =============================
            [`${componentCls}-title`]: {
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`
            },
            // ============================ Header ============================
            [`${componentCls}-thead`]: {
                [`
          > tr > th,
          > tr > td
        `]: {
                    position: "relative",
                    color: tableHeaderTextColor,
                    fontWeight: fontWeightStrong,
                    textAlign: "start",
                    background: tableHeaderBg,
                    borderBottom: tableBorder,
                    transition: `background ${motionDurationMid} ease`,
                    "&[colspan]:not([colspan='1'])": {
                        textAlign: "center"
                    },
                    [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
                        position: "absolute",
                        top: "50%",
                        insetInlineEnd: 0,
                        width: 1,
                        height: "1.6em",
                        backgroundColor: tableHeaderCellSplitColor,
                        transform: "translateY(-50%)",
                        transition: `background-color ${motionDurationMid}`,
                        content: '""'
                    }
                },
                "> tr:not(:last-child) > th[colspan]": {
                    borderBottom: 0
                }
            },
            // ============================ Body ============================
            [`${componentCls}-tbody`]: {
                "> tr": {
                    "> th, > td": {
                        transition: `background ${motionDurationMid}, border-color ${motionDurationMid}`,
                        borderBottom: tableBorder,
                        // ========================= Nest Table ===========================
                        [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
                            [componentCls]: {
                                marginBlock: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal()),
                                marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                                [`${componentCls}-tbody > tr:last-child > td`]: {
                                    borderBottom: 0,
                                    "&:first-child, &:last-child": {
                                        borderRadius: 0
                                    }
                                }
                            }
                        }
                    },
                    "> th": {
                        position: "relative",
                        color: tableHeaderTextColor,
                        fontWeight: fontWeightStrong,
                        textAlign: "start",
                        background: tableHeaderBg,
                        borderBottom: tableBorder,
                        transition: `background ${motionDurationMid} ease`
                    }
                }
            },
            // ============================ Footer ============================
            [`${componentCls}-footer`]: {
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                color: tableFooterTextColor,
                background: tableFooterBg
            }
        })
    };
};
const $52ea1741590722c9$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillAlter: colorFillAlter, colorBgContainer: colorBgContainer, colorTextHeading: colorTextHeading, colorFillSecondary: colorFillSecondary, colorFillContent: colorFillContent, controlItemBgActive: controlItemBgActive, controlItemBgActiveHover: controlItemBgActiveHover, padding: padding, paddingSM: paddingSM, paddingXS: paddingXS, colorBorderSecondary: colorBorderSecondary, borderRadiusLG: borderRadiusLG, controlHeight: controlHeight, colorTextPlaceholder: colorTextPlaceholder, fontSize: fontSize, fontSizeSM: fontSizeSM, lineHeight: lineHeight, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, opacityLoading: opacityLoading, controlInteractiveSize: controlInteractiveSize } = token;
    const colorFillSecondarySolid = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorFillSecondary).onBackground(colorBgContainer).toHexShortString();
    const colorFillContentSolid = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorFillContent).onBackground(colorBgContainer).toHexShortString();
    const colorFillAlterSolid = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorFillAlter).onBackground(colorBgContainer).toHexShortString();
    const baseColorAction = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorIcon);
    const baseColorActionHover = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(colorIconHover);
    const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
    const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
    return {
        headerBg: colorFillAlterSolid,
        headerColor: colorTextHeading,
        headerSortActiveBg: colorFillSecondarySolid,
        headerSortHoverBg: colorFillContentSolid,
        bodySortBg: colorFillAlterSolid,
        rowHoverBg: colorFillAlterSolid,
        rowSelectedBg: controlItemBgActive,
        rowSelectedHoverBg: controlItemBgActiveHover,
        rowExpandedBg: colorFillAlter,
        cellPaddingBlock: padding,
        cellPaddingInline: padding,
        cellPaddingBlockMD: paddingSM,
        cellPaddingInlineMD: paddingXS,
        cellPaddingBlockSM: paddingXS,
        cellPaddingInlineSM: paddingXS,
        borderColor: colorBorderSecondary,
        headerBorderRadius: borderRadiusLG,
        footerBg: colorFillAlterSolid,
        footerColor: colorTextHeading,
        cellFontSize: fontSize,
        cellFontSizeMD: fontSize,
        cellFontSizeSM: fontSize,
        headerSplitColor: colorBorderSecondary,
        fixedHeaderSortActiveBg: colorFillSecondarySolid,
        headerFilterHoverBg: colorFillContent,
        filterDropdownMenuBg: colorBgContainer,
        filterDropdownBg: colorBgContainer,
        expandIconBg: colorBgContainer,
        selectionColumnWidth: controlHeight,
        stickyScrollBarBg: colorTextPlaceholder,
        stickyScrollBarBorderRadius: 100,
        expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
        headerIconColor: baseColorAction.clone().setAlpha(baseColorAction.getAlpha() * opacityLoading).toRgbString(),
        headerIconHoverColor: baseColorActionHover.clone().setAlpha(baseColorActionHover.getAlpha() * opacityLoading).toRgbString(),
        expandIconHalfInner: expandIconHalfInner,
        expandIconSize: expandIconSize,
        expandIconScale: controlInteractiveSize / expandIconSize
    };
};
var // ============================== Export ==============================
$52ea1741590722c9$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Table", (token)=>{
    const { colorTextHeading: colorTextHeading, colorSplit: colorSplit, colorBgContainer: colorBgContainer, controlInteractiveSize: checkboxSize, headerBg: headerBg, headerColor: headerColor, headerSortActiveBg: headerSortActiveBg, headerSortHoverBg: headerSortHoverBg, bodySortBg: bodySortBg, rowHoverBg: rowHoverBg, rowSelectedBg: rowSelectedBg, rowSelectedHoverBg: rowSelectedHoverBg, rowExpandedBg: rowExpandedBg, cellPaddingBlock: cellPaddingBlock, cellPaddingInline: cellPaddingInline, cellPaddingBlockMD: cellPaddingBlockMD, cellPaddingInlineMD: cellPaddingInlineMD, cellPaddingBlockSM: cellPaddingBlockSM, cellPaddingInlineSM: cellPaddingInlineSM, borderColor: borderColor, footerBg: footerBg, footerColor: footerColor, headerBorderRadius: headerBorderRadius, cellFontSize: cellFontSize, cellFontSizeMD: cellFontSizeMD, cellFontSizeSM: cellFontSizeSM, headerSplitColor: headerSplitColor, fixedHeaderSortActiveBg: fixedHeaderSortActiveBg, headerFilterHoverBg: headerFilterHoverBg, filterDropdownBg: filterDropdownBg, expandIconBg: expandIconBg, selectionColumnWidth: selectionColumnWidth, stickyScrollBarBg: stickyScrollBarBg, calc: calc } = token;
    const zIndexTableFixed = 2;
    const tableToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        tableFontSize: cellFontSize,
        tableBg: colorBgContainer,
        tableRadius: headerBorderRadius,
        tablePaddingVertical: cellPaddingBlock,
        tablePaddingHorizontal: cellPaddingInline,
        tablePaddingVerticalMiddle: cellPaddingBlockMD,
        tablePaddingHorizontalMiddle: cellPaddingInlineMD,
        tablePaddingVerticalSmall: cellPaddingBlockSM,
        tablePaddingHorizontalSmall: cellPaddingInlineSM,
        tableBorderColor: borderColor,
        tableHeaderTextColor: headerColor,
        tableHeaderBg: headerBg,
        tableFooterTextColor: footerColor,
        tableFooterBg: footerBg,
        tableHeaderCellSplitColor: headerSplitColor,
        tableHeaderSortBg: headerSortActiveBg,
        tableHeaderSortHoverBg: headerSortHoverBg,
        tableBodySortBg: bodySortBg,
        tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
        tableHeaderFilterActiveBg: headerFilterHoverBg,
        tableFilterDropdownBg: filterDropdownBg,
        tableRowHoverBg: rowHoverBg,
        tableSelectedRowBg: rowSelectedBg,
        tableSelectedRowHoverBg: rowSelectedHoverBg,
        zIndexTableFixed: zIndexTableFixed,
        zIndexTableSticky: zIndexTableFixed + 1,
        tableFontSizeMiddle: cellFontSizeMD,
        tableFontSizeSmall: cellFontSizeSM,
        tableSelectionColumnWidth: selectionColumnWidth,
        tableExpandIconBg: expandIconBg,
        tableExpandColumnWidth: calc(checkboxSize).add(calc(token.padding).mul(2)).equal(),
        tableExpandedRowBg: rowExpandedBg,
        // Dropdown
        tableFilterDropdownWidth: 120,
        tableFilterDropdownHeight: 264,
        tableFilterDropdownSearchWidth: 140,
        // Virtual Scroll Bar
        tableScrollThumbSize: 8,
        // Mac scroll bar size
        tableScrollThumbBg: stickyScrollBarBg,
        tableScrollThumbBgHover: colorTextHeading,
        tableScrollBg: colorSplit
    });
    return [
        $52ea1741590722c9$var$genTableStyle(tableToken),
        (0, $9a6bae14c3d282e3$export$2e2bcd8739ae039)(tableToken),
        (0, $9a56b0c2c027df00$export$2e2bcd8739ae039)(tableToken),
        (0, $6655b371bedfd634$export$2e2bcd8739ae039)(tableToken),
        (0, $da23b384be167274$export$2e2bcd8739ae039)(tableToken),
        (0, $b9b6fedf44f4f803$export$2e2bcd8739ae039)(tableToken),
        (0, $4773b3998487f976$export$2e2bcd8739ae039)(tableToken),
        (0, $8888c6f6420bf18d$export$2e2bcd8739ae039)(tableToken),
        (0, $9a56b0c2c027df00$export$2e2bcd8739ae039)(tableToken),
        (0, $2d5ebf15cfaf4644$export$2e2bcd8739ae039)(tableToken),
        (0, $ca6d152d3b6852e2$export$2e2bcd8739ae039)(tableToken),
        (0, $3bb78fceca3da582$export$2e2bcd8739ae039)(tableToken),
        (0, $994f7808639e9938$export$2e2bcd8739ae039)(tableToken),
        (0, $bce3bf4179f630c0$export$2e2bcd8739ae039)(tableToken),
        (0, $d7a83fe23e3255cb$export$2e2bcd8739ae039)(tableToken),
        (0, $5ed237fc7d94970f$export$2e2bcd8739ae039)(tableToken),
        (0, $f75ead9ff31bbaa9$export$2e2bcd8739ae039)(tableToken)
    ];
}, $52ea1741590722c9$export$9ca1be8807fe0675, {
    unitless: {
        expandIconScale: true
    }
});


"use client";
const $bb02e87ac9998cdb$var$EMPTY_LIST = [];
const $bb02e87ac9998cdb$var$InternalTable = (props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, bordered: bordered, dropdownPrefixCls: customizeDropdownPrefixCls, dataSource: dataSource, pagination: pagination, rowSelection: rowSelection, rowKey: rowKey = "key", rowClassName: rowClassName, columns: columns, children: children, childrenColumnName: legacyChildrenColumnName, onChange: onChange, getPopupContainer: getPopupContainer, loading: loading, expandIcon: expandIcon, expandable: expandable, expandedRowRender: expandedRowRender, expandIconColumnIndex: expandIconColumnIndex, indentSize: indentSize, scroll: scroll, sortDirections: sortDirections, locale: locale, showSorterTooltip: showSorterTooltip = {
        target: "full-header"
    }, virtual: virtual } = props;
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("Table");
    const baseColumns = $acw62.useMemo(()=>columns || (0, $2b88d91727f4011e$export$d87a97eba44e0f9c)(children), [
        columns,
        children
    ]);
    const needResponsive = $acw62.useMemo(()=>baseColumns.some((col)=>col.responsive), [
        baseColumns
    ]);
    const screens = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(needResponsive);
    const mergedColumns = $acw62.useMemo(()=>{
        const matched = new Set(Object.keys(screens).filter((m)=>screens[m]));
        return baseColumns.filter((c)=>!c.responsive || c.responsive.some((r)=>matched.has(r)));
    }, [
        baseColumns,
        screens
    ]);
    const tableProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(props, [
        "className",
        "style",
        "columns"
    ]);
    const { locale: contextLocale = (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039), direction: direction, table: table, renderEmpty: renderEmpty, getPrefixCls: getPrefixCls, getPopupContainer: getContextPopupContainer } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const tableLocale = Object.assign(Object.assign({}, contextLocale.Table), locale);
    const rawData = dataSource || $bb02e87ac9998cdb$var$EMPTY_LIST;
    const prefixCls = getPrefixCls("table", customizePrefixCls);
    const dropdownPrefixCls = getPrefixCls("dropdown", customizeDropdownPrefixCls);
    const [, token] = (0, $d014fefdb4420ef5$export$2e2bcd8739ae039)();
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $52ea1741590722c9$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedExpandable = Object.assign(Object.assign({
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex
    }, expandable), {
        expandIcon: (_a = expandable === null || expandable === void 0 ? void 0 : expandable.expandIcon) !== null && _a !== void 0 ? _a : (_b = table === null || table === void 0 ? void 0 : table.expandable) === null || _b === void 0 ? void 0 : _b.expandIcon
    });
    const { childrenColumnName: childrenColumnName = "children" } = mergedExpandable;
    const expandType = $acw62.useMemo(()=>{
        if (rawData.some((item)=>item === null || item === void 0 ? void 0 : item[childrenColumnName])) return "nest";
        if (expandedRowRender || (expandable === null || expandable === void 0 ? void 0 : expandable.expandedRowRender)) return "row";
        return null;
    }, [
        rawData
    ]);
    const internalRefs = {
        body: $acw62.useRef()
    };
    // ============================ Width =============================
    const getContainerWidth = (0, $2da82ee1b6da5550$export$2e2bcd8739ae039)(prefixCls);
    // ============================= Refs =============================
    const rootRef = $acw62.useRef(null);
    const tblRef = $acw62.useRef(null);
    (0, $f0212a5d02e19b33$export$2e2bcd8739ae039)(ref, ()=>Object.assign(Object.assign({}, tblRef.current), {
            nativeElement: rootRef.current
        }));
    // ============================ RowKey ============================
    const getRowKey = $acw62.useMemo(()=>{
        if (typeof rowKey === "function") return rowKey;
        return (record)=>record === null || record === void 0 ? void 0 : record[rowKey];
    }, [
        rowKey
    ]);
    const [getRecordByKey] = (0, $e2770d04bc76b8cc$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey);
    // ============================ Events =============================
    const changeEventInfo = {};
    const triggerOnChange = function(info, action) {
        let reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var _a, _b, _c, _d;
        const changeInfo = Object.assign(Object.assign({}, changeEventInfo), info);
        if (reset) {
            (_a = changeEventInfo.resetPagination) === null || _a === void 0 || _a.call(changeEventInfo);
            // Reset event param
            if ((_b = changeInfo.pagination) === null || _b === void 0 ? void 0 : _b.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination) (_c = pagination.onChange) === null || _c === void 0 || _c.call(pagination, 1, (_d = changeInfo.pagination) === null || _d === void 0 ? void 0 : _d.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRefs.body.current) (0, $4262b79604674a3c$export$2e2bcd8739ae039)(0, {
            getContainer: ()=>internalRefs.body.current
        });
        onChange === null || onChange === void 0 || onChange(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $498593f51893a533$export$37643bb40f4c1c56)((0, $71f5389ed963960f$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    const onSorterChange = (sorter, sorterStates)=>{
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, "sort", false);
    };
    const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = (0, $71f5389ed963960f$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            "ascend",
            "descend"
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip
    });
    const sortedData = $acw62.useMemo(()=>(0, $71f5389ed963960f$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName), [
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    const onFilterChange = (filters, filterStates)=>{
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, "filter", true);
    };
    const [transformFilterColumns, filterStates, filters] = (0, $498593f51893a533$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        rootClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rootClassName, rootCls)
    });
    const mergedData = (0, $498593f51893a533$export$37643bb40f4c1c56)(sortedData, filterStates, childrenColumnName);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    const columnTitleProps = $acw62.useMemo(()=>{
        const mergedFilters = {};
        Object.keys(filters).forEach((filterKey)=>{
            if (filters[filterKey] !== null) mergedFilters[filterKey] = filters[filterKey];
        });
        return Object.assign(Object.assign({}, sorterTitleProps), {
            filters: mergedFilters
        });
    }, [
        sorterTitleProps,
        filters
    ]);
    const [transformTitleColumns] = (0, $6bcbe2fbe72fb80a$export$2e2bcd8739ae039)(columnTitleProps);
    // ========================== Pagination ==========================
    const onPaginationChange = (current, pageSize)=>{
        triggerOnChange({
            pagination: Object.assign(Object.assign({}, changeEventInfo.pagination), {
                current: current,
                pageSize: pageSize
            })
        }, "paginate");
    };
    const [mergedPagination, resetPagination] = (0, $b37c5a68d8297fb7$export$2e2bcd8739ae039)(mergedData.length, onPaginationChange, pagination);
    changeEventInfo.pagination = pagination === false ? {} : (0, $b37c5a68d8297fb7$export$27eceeed7bf0f4c2)(mergedPagination, pagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    const pageData = $acw62.useMemo(()=>{
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        const { current: current = 1, total: total, pageSize: pageSize = (0, $b37c5a68d8297fb7$export$5716e8bcb003888d) } = mergedPagination;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.current,
        mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.pageSize,
        mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total
    ]);
    // ========================== Selections ==========================
    const [transformSelectionColumns, selectedKeySet] = (0, $e201eb08b7050f4b$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer || getContextPopupContainer
    }, rowSelection);
    const internalRowClassName = (record, index, indent)=>{
        let mergedRowClassName;
        if (typeof rowClassName === "function") mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rowClassName(record, index, indent));
        else mergedRowClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rowClassName);
        return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index))
        }, mergedRowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `rc-table`, this can be removed when refactor with `rc-table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $8f25299cf0da5780$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === "nest" && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = rowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && rowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (typeof mergedExpandable.indentSize !== "number") mergedExpandable.indentSize = typeof indentSize === "number" ? indentSize : 15;
    // ============================ Render ============================
    const transformColumns = $acw62.useCallback((innerColumns)=>transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    let topPaginationNode;
    let bottomPaginationNode;
    if (pagination !== false && (mergedPagination === null || mergedPagination === void 0 ? void 0 : mergedPagination.total)) {
        let paginationSize;
        if (mergedPagination.size) paginationSize = mergedPagination.size;
        else paginationSize = mergedSize === "small" || mergedSize === "middle" ? "small" : undefined;
        const renderPagination = (position)=>/*#__PURE__*/ $acw62.createElement((0, $457c0f7bc166788c$export$2e2bcd8739ae039), Object.assign({}, mergedPagination, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-pagination ${prefixCls}-pagination-${position}`, mergedPagination.className),
                size: paginationSize
            }));
        const defaultPosition = direction === "rtl" ? "left" : "right";
        const { position: position } = mergedPagination;
        if (position !== null && Array.isArray(position)) {
            const topPos = position.find((p)=>p.includes("top"));
            const bottomPos = position.find((p)=>p.includes("bottom"));
            const isDisable = position.every((p)=>`${p}` === "none");
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination(defaultPosition);
            if (topPos) topPaginationNode = renderPagination(topPos.toLowerCase().replace("top", ""));
            if (bottomPos) bottomPaginationNode = renderPagination(bottomPos.toLowerCase().replace("bottom", ""));
        } else bottomPaginationNode = renderPagination(defaultPosition);
    }
    // >>>>>>>>> Spinning
    let spinProps;
    if (typeof loading === "boolean") spinProps = {
        spinning: loading
    };
    else if (typeof loading === "object") spinProps = Object.assign({
        spinning: true
    }, loading);
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(cssVarCls, rootCls, `${prefixCls}-wrapper`, table === null || table === void 0 ? void 0 : table.className, {
        [`${prefixCls}-wrapper-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId);
    const mergedStyle = Object.assign(Object.assign({}, table === null || table === void 0 ? void 0 : table.style), style);
    const emptyText = typeof (locale === null || locale === void 0 ? void 0 : locale.emptyText) !== "undefined" ? locale.emptyText : (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Table")) || /*#__PURE__*/ $acw62.createElement((0, $3feb83783705e448$export$2e2bcd8739ae039), {
        componentName: "Table"
    });
    // ========================== Render ==========================
    const TableComponent = virtual ? (0, $18bcd07e79dcd06c$export$2e2bcd8739ae039) : (0, $5ea5ba4b4caafc13$export$2e2bcd8739ae039);
    // >>> Virtual Table props. We set height here since it will affect height collection
    const virtualProps = {};
    const listItemHeight = $acw62.useMemo(()=>{
        const { fontSize: fontSize, lineHeight: lineHeight, padding: padding, paddingXS: paddingXS, paddingSM: paddingSM } = token;
        const fontHeight = Math.floor(fontSize * lineHeight);
        switch(mergedSize){
            case "large":
                return padding * 2 + fontHeight;
            case "small":
                return paddingXS * 2 + fontHeight;
            default:
                return paddingSM * 2 + fontHeight;
        }
    }, [
        token,
        mergedSize
    ]);
    if (virtual) virtualProps.listItemHeight = listItemHeight;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        ref: rootRef,
        className: wrapperClassNames,
        style: mergedStyle
    }, /*#__PURE__*/ $acw62.createElement((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), Object.assign({
        spinning: false
    }, spinProps), topPaginationNode, /*#__PURE__*/ $acw62.createElement(TableComponent, Object.assign({}, virtualProps, tableProps, {
        ref: tblRef,
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-middle`]: mergedSize === "middle",
            [`${prefixCls}-small`]: mergedSize === "small",
            [`${prefixCls}-bordered`]: bordered,
            [`${prefixCls}-empty`]: rawData.length === 0
        }, cssVarCls, rootCls, hashId),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: emptyText,
        // Internal
        internalHooks: (0, $5f2cc95ff3bf4bb6$export$91b75cf262680225),
        internalRefs: internalRefs,
        transformColumns: transformColumns,
        getContainerWidth: getContainerWidth
    })), bottomPaginationNode)));
};
var $bb02e87ac9998cdb$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($bb02e87ac9998cdb$var$InternalTable);


"use client";
const $57b3d2664e78424f$var$Table = (props, ref)=>{
    const renderTimesRef = $acw62.useRef(0);
    renderTimesRef.current += 1;
    return /*#__PURE__*/ $acw62.createElement((0, $bb02e87ac9998cdb$export$2e2bcd8739ae039), Object.assign({}, props, {
        ref: ref,
        _renderTimes: renderTimesRef.current
    }));
};
const $57b3d2664e78424f$var$ForwardTable = /*#__PURE__*/ $acw62.forwardRef($57b3d2664e78424f$var$Table);
$57b3d2664e78424f$var$ForwardTable.SELECTION_COLUMN = (0, $e201eb08b7050f4b$export$ed10248435b8f218);
$57b3d2664e78424f$var$ForwardTable.EXPAND_COLUMN = (0, $5f2cc95ff3bf4bb6$export$e1053575ddfcb301);
$57b3d2664e78424f$var$ForwardTable.SELECTION_ALL = (0, $e201eb08b7050f4b$export$14159cd9e2a500c8);
$57b3d2664e78424f$var$ForwardTable.SELECTION_INVERT = (0, $e201eb08b7050f4b$export$625c4f68eaaf8cfd);
$57b3d2664e78424f$var$ForwardTable.SELECTION_NONE = (0, $e201eb08b7050f4b$export$c1a725540f5a63bd);
$57b3d2664e78424f$var$ForwardTable.Column = (0, $fad2a96b4c8bbab5$export$2e2bcd8739ae039);
$57b3d2664e78424f$var$ForwardTable.ColumnGroup = (0, $836a2b733f2d0243$export$2e2bcd8739ae039);
$57b3d2664e78424f$var$ForwardTable.Summary = (0, $46b6722da5e5f96e$export$d605f3af09eef683);
var $57b3d2664e78424f$export$2e2bcd8739ae039 = $57b3d2664e78424f$var$ForwardTable;


"use client";
var $de80f58eedfd6ef7$export$2e2bcd8739ae039 = (0, $57b3d2664e78424f$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");
var $c30c6651c4c506e0$exports = {};
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : $c30c6651c4c506e0$exports = t();
}($c30c6651c4c506e0$exports, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "	",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});



const $c3ee28f116541c94$var$NO_DATASET_MESSAGE = "--- No dataset loaded ---";
const $c3ee28f116541c94$var$INVALID_URL_MESSAGE = "--- Invalid URL entered ---";
const $c3ee28f116541c94$var$LOADING_DATASET_MESSAGE = "--- Loading dataset ---";
const $c3ee28f116541c94$var$DatasetViewerComponent = ({ file: file, useUrl: useUrl, url: url, setDatasetColumns: setDatasetColumns, fileUploading: fileUploading, setFileUploading: setFileUploading, isValidCsvUrl: isValidCsvUrl })=>{
    const [moduleMessage, setModuleMessage] = (0, $acw62.useState)($c3ee28f116541c94$var$NO_DATASET_MESSAGE);
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [modalHeight, setModalHeight] = (0, $acw62.useState)(0);
    const [tableHeight, setTableHeight] = (0, $acw62.useState)(900);
    const [parsedData, setParsedData] = (0, $acw62.useState)([]);
    const [fields, setFields] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [isFileChanged, setIsFileChanged] = (0, $acw62.useState)(false);
    const [isUrlChanged, setIsUrlChanged] = (0, $acw62.useState)(false);
    const [isValidUrl, setIsValidUrl] = (0, $acw62.useState)(isValidCsvUrl(url));
    const [sourceDataTypeChanged, setSourceDataTypeChanged] = (0, $acw62.useState)(false);
    const [initialParseComplete, setInitialParseComplete] = (0, $acw62.useState)(false);
    const [firstRun, setFirstRun] = (0, $acw62.useState)(true);
    const parseCsv = (csvSource, useUrl)=>{
        return new Promise((resolve, reject)=>{
            if (!csvSource) {
                setParsedData([]);
                setFields([]);
                setDatasetColumns([]);
                setModuleMessage($c3ee28f116541c94$var$NO_DATASET_MESSAGE);
                reject("No dataset provided - safe to ignore");
                setInitialParseComplete(true);
                return;
            }
            const config = {
                header: true,
                dynamicTyping: true,
                download: true,
                complete: (results)=>{
                    const hasIndex = results.data[0].hasOwnProperty("id");
                    setParsedData(results.data.map((row, index)=>({
                            ...row,
                            key: index,
                            id: index + 1
                        })));
                    if (results.meta.fields) {
                        let tempFields = [];
                        if (!hasIndex) tempFields = [
                            "id"
                        ];
                        const colFields = [
                            ...tempFields,
                            ...results.meta.fields
                        ].map((field)=>{
                            return {
                                title: field,
                                dataIndex: field,
                                key: field,
                                width: "max-content"
                            };
                        });
                        setFields(colFields);
                        setDatasetColumns(colFields.map((field)=>field.title));
                    }
                    resolve();
                },
                error: (error)=>{
                    setParsedData([]);
                    setFields([]);
                    setDatasetColumns([]);
                    reject(error);
                }
            };
            if (useUrl) config.download = true;
            (0, (/*@__PURE__*/$parcel$interopDefault($c30c6651c4c506e0$exports))).parse(csvSource, config);
        });
    };
    const determineParseRequirement = ()=>{
        if (!initialParseComplete) return true;
        if (!useUrl) {
            if (isFileChanged || sourceDataTypeChanged) {
                setIsFileChanged(false);
                setSourceDataTypeChanged(false);
                return true;
            }
        } else if (isUrlChanged || sourceDataTypeChanged) {
            setIsUrlChanged(false);
            setSourceDataTypeChanged(false);
            return true;
        }
        return false;
    };
    const showModal = async ()=>{
        setIsModalOpen(true);
        setIsLoading(true);
        setModuleMessage($c3ee28f116541c94$var$LOADING_DATASET_MESSAGE);
        let sourceData = useUrl ? url : file;
        let isParseRequired = determineParseRequirement();
        if (isParseRequired) try {
            await parseCsv(sourceData, useUrl);
            setModuleMessage(null);
        } catch (error) {
            console.log(error);
            if (useUrl) {
                console.error("Invalid URL detected");
                setModuleMessage($c3ee28f116541c94$var$INVALID_URL_MESSAGE);
            }
        }
        else setModuleMessage(null);
        setIsLoading(false);
        const eventData = {
            datasetSource: useUrl ? "url" : "file",
            dataset: useUrl ? url : file?.name
        };
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("preview_dataset", eventData, true);
    };
    const handleOk = ()=>{
        setIsModalOpen(false);
    };
    const handleCancel = ()=>{
        setIsModalOpen(false);
    };
    const getAvailableTableHeight = ()=>{
        const modalHeaderHeight = document.querySelector(".ant-modal-header")?.offsetHeight;
        const modalFooterHeight = document.querySelector(".ant-modal-footer")?.offsetHeight;
        const modalHeight = document.querySelector(".ant-modal")?.offsetHeight;
        const modalBodyPadding = 40;
        const availableHeight = modalHeight - modalHeaderHeight - modalFooterHeight - modalBodyPadding;
        return availableHeight;
    };
    const updateTableHeight = ()=>{
        const availableTableHeight = getAvailableTableHeight();
        setTableHeight(availableTableHeight);
    };
    (0, $acw62.useEffect)(()=>{
        setIsFileChanged(true);
        if (!useUrl && file) {
            const fetchData = async ()=>{
                try {
                    await parseCsv(file, useUrl);
                } catch (error) {
                    console.log(error);
                }
                setInitialParseComplete(true);
                setFileUploading(false);
            };
            fetchData();
        }
    }, [
        file
    ]);
    (0, $acw62.useEffect)(()=>{
        const isValid = isValidCsvUrl(url);
        setIsValidUrl(isValid);
        setIsUrlChanged(true);
        if (useUrl && url && isValid) {
            const fetchData = async ()=>{
                try {
                    await parseCsv(url, useUrl);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
            setInitialParseComplete(true);
        }
    }, [
        url
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!firstRun) {
            const parseRequired = determineParseRequirement();
            if (parseRequired) {
                let sourceData = useUrl ? url : file;
                const fetchData = async ()=>{
                    try {
                        await parseCsv(sourceData, useUrl);
                    } catch (error) {
                        console.log(error);
                    }
                };
                fetchData();
                setInitialParseComplete(true);
            }
        }
    }, [
        useUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", updateTableHeight);
        return ()=>{
            window.removeEventListener("resize", updateTableHeight);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isModalOpen) setTimeout(()=>{
            updateTableHeight();
        }, 100);
    }, [
        isModalOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (firstRun) setFirstRun(false);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                type: "primary",
                onClick: showModal,
                "aria-label": "Open Dataset Previewer",
                disabled: useUrl && (!url || !isValidUrl) || !useUrl && !file,
                loading: fileUploading,
                children: "Preview Dataset"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
                title: "Dataset Previewer",
                open: isModalOpen,
                onOk: handleOk,
                onCancel: handleCancel,
                width: "70%",
                style: {
                    height: "80vh"
                },
                centered: true,
                footer: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        onClick: handleCancel,
                        children: "Close"
                    }, "back")
                ],
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $de80f58eedfd6ef7$export$2e2bcd8739ae039), {
                        columns: fields || [],
                        dataSource: parsedData,
                        loading: {
                            size: "large",
                            spinning: isLoading,
                            tip: "Loading dataset...",
                            wrapperClassName: "datasetLoadingOverlay"
                        },
                        scroll: {
                            y: tableHeight - 120,
                            scrollToFirstRowOnChange: true
                        },
                        style: {
                            height: tableHeight,
                            maxHeight: "100%"
                        },
                        pagination: {
                            showSizeChanger: true,
                            pageSizeOptions: [
                                "10",
                                "20",
                                "50",
                                "100"
                            ],
                            defaultPageSize: 50,
                            defaultCurrent: 1
                        }
                    }),
                    moduleMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "noFileSelectedMessage",
                        children: moduleMessage
                    })
                ]
            })
        ]
    });
};
var $c3ee28f116541c94$export$2e2bcd8739ae039 = $c3ee28f116541c94$var$DatasetViewerComponent;






const $9d71970f2049ac94$var$isTypeCsv = (file)=>{
    return file.type === "text/csv" || file.type === "text/plain" || file.type === "application/csv" || file.type === "application/vnd.ms-excel" || file.type === "text/x-csv";
};
const $9d71970f2049ac94$var$delayFunction = (fn, ms)=>{
    let timer = null;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(()=>{
            fn(...args);
        }, ms);
    };
};
const $9d71970f2049ac94$var$delayUrlLog = $9d71970f2049ac94$var$delayFunction((type, context)=>(0, $14e68cbe3c2b3085$export$83fc28f458189523)(type, context), 1000);
const $9d71970f2049ac94$var$COMPONENT_ACTION_ID = "importDataset";
const $9d71970f2049ac94$export$c83e0cbdd085b807 = (props)=>{
    const [text, setText] = (0, $acw62.useState)(props.data.value);
    const [switchStatus, setSwitchStatus] = (0, $acw62.useState)(!props.data.useUploadedDataset);
    const [file, setFile] = (0, $acw62.useState)(null);
    const [fileUploading, setFileUploading] = (0, $acw62.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)(false);
    const [savedFile, setSavedFile] = (0, $acw62.useState)(null);
    const [datasets, setDatasets] = (0, $acw62.useState)([]);
    const [recentDatasets, setRecentDatasets] = (0, $acw62.useState)([]);
    const containerRef = (0, $acw62.useRef)(null);
    const context = props.data.context;
    const toggleUrlImportStep = (action)=>{
        if (props.data.isValidCsvUrl(action)) context.markTaskAsCompleted($9d71970f2049ac94$var$COMPONENT_ACTION_ID);
        else context.removeTaskFromCompleted($9d71970f2049ac94$var$COMPONENT_ACTION_ID);
    };
    const handleChange = (e)=>{
        props.data.onChange(e.target.value);
        setText(e.target.value);
        toggleUrlImportStep(e.target.value);
        $9d71970f2049ac94$var$delayUrlLog("enter_url_download", {
            url_download: true,
            currentURL: e.target.value
        });
    };
    const handleFileRead = (file, skipLog = false)=>{
        setFileUploading(true);
        const reader = new FileReader();
        reader.onload = async (e)=>{
            const content = e.target?.result;
            if (typeof content === "string") {
                setFile(file);
                props.data.uploadDataset(content, file.name);
            }
        };
        reader.readAsText(file);
        if (!skipLog) (0, $14e68cbe3c2b3085$export$83fc28f458189523)("upload_local_dataset", {
            fileName: file.name,
            url_download: false
        });
    };
    const beforeUpload = async (file, fileList, skipUpload = false)=>{
        // Check if there's an existing file, update date accessed on that file
        if (savedFile && savedFile.length > 0) await UpdateDateDatasetAccessedByFile(savedFile[0]);
        if (!$9d71970f2049ac94$var$isTypeCsv(file)) {
            fileList[0].status = "error";
            return false;
        }
        if (!skipUpload) {
            setSavedFile(fileList);
            await uploadFileToServer(file);
        }
        handleFileRead(file, skipUpload);
        if (context) {
            const { markTaskAsCompleted: markTaskAsCompleted } = context;
            markTaskAsCompleted($9d71970f2049ac94$var$COMPONENT_ACTION_ID);
        }
        return false;
    };
    const onRemove = async (file)=>{
        await UpdateDateDatasetAccessedByFile(file);
        setFile(null);
        setSavedFile(null);
        setErrorMessage(false);
        props.data.setDatasetColumns([]);
        context.removeTaskFromCompleted($9d71970f2049ac94$var$COMPONENT_ACTION_ID);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("remove_local_dataset", {
            fileName: file.name,
            url_download: false
        });
        props.data.uploadDataset("", null);
        return true;
    };
    const UpdateDateDatasetAccessedByFile = async (file)=>{
        const dataset = recentDatasets.find((d)=>d.dataset_name === file.name);
        if (dataset) await updateDateDatasetAccessed(dataset);
    };
    const getElementTotalHeight = (el)=>{
        const styles = window.getComputedStyle(el);
        const margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);
        return el.offsetHeight + margin;
    };
    const sumImmediateChildrenHeights = (parentDiv)=>{
        let totalHeight = 0;
        for (let child of parentDiv.children)totalHeight += getElementTotalHeight(child);
        return totalHeight;
    };
    const getCurrentHeight = ()=>{
        if (!containerRef.current) return 295;
        const controlContainer = containerRef.current;
        const overallNodeContainer = controlContainer.closest("[data-testid='node']") || document.createElement("div");
        const totalRequiredHeight = sumImmediateChildrenHeights(overallNodeContainer);
        // Clear any hardcoded dimensions from the auto arrange plugin
        overallNodeContainer.style.height = "";
        overallNodeContainer.style.width = "";
        return totalRequiredHeight + 5;
    };
    const onSwitch = (checked)=>{
        props.data.setDatasetSource(!checked);
        setSwitchStatus(checked);
        setErrorMessage(false);
        if (checked) toggleUrlImportStep(text);
        else if (!file) context.removeTaskFromCompleted($9d71970f2049ac94$var$COMPONENT_ACTION_ID);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("toggle_url_download_switch", {
            url_download: checked,
            current_url: text,
            current_file: file?.name || "No file uploaded"
        });
    };
    const uploadFileToServer = async (file)=>{
        const formData = new FormData();
        try {
            formData.append("file", file);
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/file/upload", formData);
            setErrorMessage(false);
        } catch (error) {
            console.log(error);
            if (error.response.status === 413) {
                console.log("File too large to save");
                setErrorMessage(true);
                return true;
            }
        }
        return false;
    };
    const getUploadedDatasetPath = async (fileName)=>{
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get(`/api/file/get-path/${fileName}`);
            return res.data.dataset;
        } catch (error) {
            console.log(error);
            return null;
        }
    };
    const updateDateDatasetAccessed = async (dataset)=>{
        try {
            await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post(`/api/file/update-dataset-last-accessed-at`, {
                id: dataset.id
            });
        } catch (error) {
            console.log("Failed to update dataset accessed date");
        }
    };
    const loadDatasetIntoEditor = async (dataset, recentDataset = false)=>{
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get(`${(0, $9d936a2aecb96285$export$b27b0287c31e45de)}${dataset.dataset_path}`, {
                responseType: "blob"
            });
            const blob = res.data;
            const file = new File([
                blob
            ], dataset.dataset_name, {
                type: blob.type
            });
            const tempUploadFile = {
                uid: "-1",
                name: dataset.dataset_name,
                status: "done"
            };
            setSavedFile([
                tempUploadFile
            ]);
            await beforeUpload(file, [
                file
            ], true);
            if (recentDataset) {
                await updateDateDatasetAccessed(dataset);
                (0, $14e68cbe3c2b3085$export$83fc28f458189523)("load_recent_dataset", {
                    fileName: dataset.dataset_name,
                    url_download: false
                });
            }
        } catch (error) {
            console.log("Failed to retrieve dataset path, resorting to default behavior");
        }
    };
    const setupForPreviouslyUploadedDataset = async ()=>{
        const dataset = await getUploadedDatasetPath(props.data.uploadedDataset.fileName);
        if (dataset) await loadDatasetIntoEditor(dataset);
        else console.log("Failed to retrieve dataset path, resorting to default behavior");
    };
    const getRecentlyUploadedDatasets = async ()=>{
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/file/recently-uploaded-datasets");
            const datasets = res.data.datasets;
            if (!datasets) {
                setDatasets([]);
                setRecentDatasets([]);
                return;
            }
            setDatasets(datasets);
            const updatedDatasets = datasets.map((dataset)=>{
                const timeSinceLastAccessed = formatTimeSinceLastAccessed(dataset.last_accessed_at);
                return {
                    ...dataset,
                    last_accessed_at: timeSinceLastAccessed
                };
            });
            setRecentDatasets(updatedDatasets);
        } catch (error) {
            console.log(error);
        }
    };
    const formatTimeSinceLastAccessed = (last_accessed_at)=>{
        const now = new Date();
        const lastAccessed = new Date(last_accessed_at);
        const diffInMs = now.getTime() - lastAccessed.getTime(); // Difference in milliseconds
        const diffInSecs = Math.floor(diffInMs / 1000);
        const diffInMinutes = Math.floor(diffInMs / 60000);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInSecs < 2) return "just now";
        else if (diffInSecs < 60) // Less than a minute, show seconds
        return `${diffInSecs} second${diffInSecs === 1 ? "" : "s"} ago`;
        else if (diffInMinutes < 120) // Less than 2 hours, show minutes
        return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;
        else if (diffInHours < 24) {
            // Less than 24 hours, show hours and minutes
            const remainingMinutes = diffInMinutes % 60;
            return remainingMinutes === 0 || diffInHours > 2 ? `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago` : `${diffInHours} hour${diffInHours === 1 ? "" : "s"} and ${remainingMinutes} minute${remainingMinutes === 1 ? "" : "s"} ago`;
        } else // 24 hours or more, show days
        return `${diffInDays} day${diffInDays === 1 ? "" : "s"} ago`;
    };
    const handleDeleteRecentDataset = async (e, deleted_dataset)=>{
        e.stopPropagation();
        const { id: id, dataset_name: dataset_name } = deleted_dataset;
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post(`/api/file/delete-dataset`, {
                id: id
            });
            if (res.status === 200) {
                setDatasets(datasets.filter((dataset)=>dataset.id !== id));
                setRecentDatasets(recentDatasets.filter((dataset)=>dataset.id !== id));
                (0, $14e68cbe3c2b3085$export$83fc28f458189523)("delete_recent_dataset", {
                    dataset_id: id,
                    fileName: dataset_name,
                    url_download: false
                });
            }
        } catch (error) {
            console.log("Failed to delete dataset on backend");
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (containerRef.current) {
            const overalDatasetImporter = containerRef.current.closest("[data-testid='node']") || document.createElement("div");
            // Reset hardcoded dimensions from auto arrange plugin
            overalDatasetImporter.style.width = "";
            overalDatasetImporter.style.height = "";
        }
    }, [
        file
    ]);
    (0, $acw62.useEffect)(()=>{
        if (props.data.useUploadedDataset && props.data.uploadedDataset.fileName !== "") setupForPreviouslyUploadedDataset();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!savedFile) getRecentlyUploadedDatasets();
    }, [
        savedFile
    ]);
    (0, $acw62.useEffect)(()=>{
        if (datasets.length > 0) {
            const interval = setInterval(()=>{
                setRecentDatasets(datasets.map((dataset)=>{
                    const timeSinceLastAccessed = formatTimeSinceLastAccessed(dataset.last_accessed_at);
                    return {
                        ...dataset,
                        last_accessed_at: timeSinceLastAccessed
                    };
                }));
            }, 60000);
            return ()=>clearInterval(interval);
        }
    }, [
        datasets
    ]);
    (0, $acw62.useEffect)(()=>{
        const observer = new ResizeObserver((entries)=>{
            for (let entry of entries)if (entry.target === containerRef.current) {
                const height = getCurrentHeight();
                props.data.adjustHeight(height);
            }
        });
        if (containerRef.current) observer.observe(containerRef.current);
        // Cleanup observer on unmount
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        theme: {
            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c7119f916fc54765$export$2e2bcd8739ae039), {
            gap: "small",
            align: "center",
            vertical: true,
            ref: containerRef,
            onPointerDown: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3764dd060390695$export$2e2bcd8739ae039), {
                    accept: ".csv",
                    listType: "text",
                    maxCount: 1,
                    beforeUpload: beforeUpload,
                    onRemove: onRemove,
                    disabled: switchStatus,
                    fileList: savedFile || undefined,
                    className: "fileUploadContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        disabled: switchStatus,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3a791dc244e00455$export$2e2bcd8739ae039), {}),
                        children: "Upload dataset (csv)"
                    })
                }),
                recentDatasets.length > 0 && !savedFile && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                    defaultValue: "Recent Datasets",
                    dropdownStyle: {
                        width: "fit-content"
                    },
                    disabled: switchStatus,
                    onSelect: (path, option)=>loadDatasetIntoEditor({
                            id: option.key,
                            dataset_name: option.dataset_name,
                            dataset_path: path,
                            createdAt: option.createdAt,
                            last_accessed_at: option.last_accessed_at
                        }, true),
                    options: recentDatasets.map((dataset)=>({
                            key: dataset.id,
                            value: dataset.dataset_path,
                            dataset_name: dataset.dataset_name,
                            createdAt: dataset.createdAt,
                            last_accessed_at: dataset.last_accessed_at,
                            label: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "recentDatasetOptionOverallContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "recentDatasetOptionNameAndDateAccessed",
                                        title: `Dataset: ${dataset.dataset_name}\nUploaded: ${new Date(dataset.createdAt).toLocaleString()}\nLast accessed: ${dataset.last_accessed_at}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "recentDatasetOptionName",
                                                children: dataset.dataset_name
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "recentDatasetOptionDate",
                                                children: [
                                                    "Last accessed: ",
                                                    dataset.last_accessed_at
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        className: "recentDatasetOptionDeleteButton",
                                        type: "text",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
                                            className: "deleteRecentDatasetIcon",
                                            style: {
                                                color: "#ff0000"
                                            }
                                        }),
                                        title: `Remove from recent datasets`,
                                        onClick: (e)=>handleDeleteRecentDataset(e, dataset),
                                        "aria-label": `Delete dataset: ${dataset.dataset_name}`
                                    })
                                ]
                            })
                        }))
                }),
                errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "fileUploadErrorMessage",
                    children: "File too large to save, only available until refresh"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: "OR"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c7119f916fc54765$export$2e2bcd8739ae039), {
                    gap: "small",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            children: "URL download?"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40b6a897f33a99d9$export$2e2bcd8739ae039), {
                            checked: switchStatus,
                            onChange: onSwitch,
                            disabled: fileUploading
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                    disabled: !switchStatus,
                    placeholder: "Enter dataset url",
                    value: text,
                    onChange: handleChange,
                    "aria-label": "Enter dataset URL",
                    name: "datasetUrlInput"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c3ee28f116541c94$export$2e2bcd8739ae039), {
                    file: file,
                    useUrl: switchStatus,
                    url: text,
                    setDatasetColumns: props.data.setDatasetColumns,
                    fileUploading: fileUploading,
                    setFileUploading: setFileUploading,
                    isValidCsvUrl: props.data.isValidCsvUrl
                })
            ]
        })
    });
};





parcelRequire("acw62");

const $3c798496d2a40a1f$var$customItem = ({ hasSubitems: hasSubitems, ...props })=>{
    const { Item: Item } = (0, $c24bb3319861fe36$export$7a05727743f7512).contextMenu;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Item, {
        ...props
    });
};
var $3c798496d2a40a1f$export$2e2bcd8739ae039 = $3c798496d2a40a1f$var$customItem;




var $acw62 = parcelRequire("acw62");



const $9f0b5fc5c8b684cd$var$ConsoleViewerComponent = (props)=>{
    (0, $acw62.useEffect)(()=>{
        const consoleContainers = document.querySelectorAll(".console");
        (0, $cfadb87391ca5e26$export$b71d81bfaeb967a6)(consoleContainers);
    }, []);
    const handleMouseDown = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "consoleOutputContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), {
            wrapperClassName: "consoleLoadingOverlay",
            tip: "Processing changes...",
            spinning: props.data.isLoading,
            size: "large",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "console",
                onWheel: (e)=>{
                    e.stopPropagation;
                },
                onPointerDown: handleMouseDown,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    children: props.data.currentConsole
                })
            })
        })
    });
};
var $9f0b5fc5c8b684cd$export$2e2bcd8739ae039 = $9f0b5fc5c8b684cd$var$ConsoleViewerComponent;




class $4313fafad8131e76$export$48cab1cc19c1aec7 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    option;
    options;
    onOptionSelect;
    constructor(option, options, onOptionSelect){
        super();
        this.option = option;
        this.options = options;
        this.onOptionSelect = onOptionSelect;
    }
    setOption(option) {
        this.option = option;
    }
    setupControls(controlData) {
        this.option = controlData.option;
    }
}



class $f26d115732c81313$export$d1590ca22f5c6870 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 200;
    height = 170;
    option = "Select an option";
    options = [
        "Info",
        "Head",
        "Tail",
        "Describe",
        "Columns",
        "Shape"
    ];
    change;
    update;
    #optionToCommand = {
        Info: "print(df.info())",
        Head: "print(df.head())",
        Tail: "print(df.tail())",
        Describe: "print(df.describe())",
        Columns: "print(df.columns)",
        Shape: "print(df.shape)"
    };
    constructor(socket, update, change, context){
        super("Dataframe Inspector");
        this.addInput("input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Input (dataframe required)"));
        this.addOutput("output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Output"));
        this.addControl("selector", new (0, $4313fafad8131e76$export$48cab1cc19c1aec7)(this.option, this.options, this.handleSelect.bind(this)));
        this.change = change;
        this.update = update;
    }
    getType() {
        return "DataframeInspector";
    }
    getDisplayName() {
        return "Dataframe Inspector";
    }
    handleSelect(option) {
        this.option = option;
        this.controls.selector.setOption(option);
        this.update("node", this);
        this.change();
    }
    data(inputs) {
        const previousCodeRows = inputs.input?.[0].code || [];
        const previousNodes = inputs.input?.[0].previousNodes || [];
        const selectedOptionCode = this.#optionToCommand[this.controls.selector.option] || "# Select a dataframe inspector option";
        const newCode = [
            ...previousCodeRows,
            selectedOptionCode
        ];
        const currentNode = {
            ...this,
            connectedPort: this.outputs.output
        };
        const output = {
            code: newCode,
            previousNodes: [
                ...previousNodes,
                currentNode
            ]
        };
        return {
            output: output
        };
    }
}





parcelRequire("acw62");


const $4d1776c2c55b839d$var$DROPDOWN_TEXT_DEFAULT = "Select inspection type";
const $4d1776c2c55b839d$var$DataframeInspectorComponent = (props)=>{
    const handleSelect = (value)=>{
        props.data.onOptionSelect(value);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_dataframe_inspection_option", {
            inspection_option: value
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "dfInspectSelectorContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
            theme: {
                algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c24bb3319861fe36$export$b48985bba8f530f5).NoDrag, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                    className: "selectDropDown",
                    onChange: handleSelect,
                    value: props.data.option,
                    defaultValue: $4d1776c2c55b839d$var$DROPDOWN_TEXT_DEFAULT,
                    dropdownStyle: {
                        width: "fit-content"
                    },
                    options: props.data.options.map((option, index)=>{
                        return {
                            value: option,
                            title: `Inspect ${option}`
                        };
                    })
                })
            })
        })
    });
};
var $4d1776c2c55b839d$export$2e2bcd8739ae039 = $4d1776c2c55b839d$var$DataframeInspectorComponent;








class $183561bbe0560042$export$9b78530a1257fd4b extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    loadingStatus;
    messages;
    context;
    constructor(loadingStatus, messages = [], context){
        super();
        this.loadingStatus = loadingStatus;
        this.messages = messages;
        this.context = context;
    }
    setLoadingStatus(loadingStatus) {
        this.loadingStatus = loadingStatus;
    }
    clearMessages() {
        this.messages = [];
    }
    addMessage(message) {
        this.messages.push(message);
    }
    setupControls(controlData) {
        this.messages = controlData.messages;
    }
}


class $01f94c473c0d84e2$export$22ddc13a7241495c extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 260;
    height = 200;
    initialMessages = [
        "Connect dataset importer",
        "Connect library importer"
    ];
    task_id = "createDataframeLoader";
    change;
    update;
    constructor(socket, update, change, context){
        super("Load Dataframe");
        this.addInput("input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Input", true));
        this.addOutput("output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Export Dataframe"));
        this.addControl("status_indicator", new (0, $183561bbe0560042$export$9b78530a1257fd4b)("initial", this.initialMessages, context));
        this.update = update;
        this.change = change;
    }
    getType() {
        return "DataframeLoader";
    }
    getDisplayName() {
        return "Dataframe Loader";
    }
    #isValidCsvUrl(url) {
        const urlPattern = new RegExp("^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i");
        if (!urlPattern.test(url)) return false;
        if (!url.toLowerCase().endsWith(".csv")) return false;
        return true;
    }
    #requiredConditions(prevNodes) {
        const datasetNode = prevNodes.find((node)=>node.label.toLowerCase() === "import dataset");
        const packageImporterNode = prevNodes.find((node)=>node.label.toLowerCase() === "import libraries");
        const useUploadedDataset = datasetNode?.useUploadedDataset || null;
        const uploadedDataset = datasetNode?.uploadedDataset || null;
        const url_value = datasetNode?.value || "";
        const isDatasetNodeConnected = !!datasetNode;
        const isUploadedDatasetEmpty = uploadedDataset?.content === "";
        const isUrlEmpty = url_value === "";
        const isDatasetLoaded = isDatasetNodeConnected ? datasetNode.datasetColumns.length > 0 : false;
        const isPackageImporterNodeConnected = !!packageImporterNode;
        const isPandasImported = packageImporterNode?.selectedItems.some((item)=>item.toLowerCase() === "pandas") || false;
        return {
            useUploadedDataset: useUploadedDataset,
            uploadedDataset: uploadedDataset,
            url_value: url_value,
            isDatasetNodeConnected: isDatasetNodeConnected,
            isUploadedDatasetEmpty: isUploadedDatasetEmpty,
            isUrlEmpty: isUrlEmpty,
            isPackageImporterNodeConnected: isPackageImporterNodeConnected,
            isPandasImported: isPandasImported,
            isDatasetLoaded: isDatasetLoaded
        };
    }
    #generateCurrentCode(prevNodes) {
        const requiredConditions = this.#requiredConditions(prevNodes);
        const { useUploadedDataset: useUploadedDataset, uploadedDataset: uploadedDataset, url_value: url_value, isDatasetNodeConnected: isDatasetNodeConnected, isPackageImporterNodeConnected: isPackageImporterNodeConnected, isPandasImported: isPandasImported, isUploadedDatasetEmpty: isUploadedDatasetEmpty, isUrlEmpty: isUrlEmpty, isDatasetLoaded: isDatasetLoaded } = requiredConditions;
        let currentCode = "";
        this.controls.status_indicator.clearMessages();
        if (!isDatasetNodeConnected) {
            currentCode += "# Connect a dataset importer node\n";
            this.controls.status_indicator.addMessage("Connect dataset importer");
        } else if (useUploadedDataset) {
            if (isUploadedDatasetEmpty) {
                currentCode += "# Select a dataset for upload\n";
                this.controls.status_indicator.addMessage("Upload a dataset");
            } else currentCode += `df = pd.read_csv("${uploadedDataset?.fileName}")\n`;
        } else {
            if (isUrlEmpty) {
                currentCode += "# Enter a url to import dataset\n";
                this.controls.status_indicator.addMessage("Enter a url to import dataset");
            } else if (this.#isValidCsvUrl(url_value) && isDatasetLoaded) currentCode += `df = pd.read_csv("${url_value}")\n`;
            else {
                currentCode += "# Invalid url used for import\n";
                this.controls.status_indicator.addMessage("Invalid dataset url");
            }
        }
        if (!isPackageImporterNodeConnected) {
            currentCode = [
                "# Connect a library importer node\n",
                currentCode
            ].join("");
            this.controls.status_indicator.addMessage("Connect library importer");
        }
        if (!isPandasImported && isPackageImporterNodeConnected) {
            currentCode = [
                "# Import pandas library to create Dataframe\n",
                currentCode
            ].join("");
            this.controls.status_indicator.addMessage("Import pandas");
        }
        return currentCode;
    }
    #mergeInputCode(inputs) {
        const mergedInput = inputs.map((input)=>input.code);
        return mergedInput.flat();
    }
    data(inputs) {
        this.controls.status_indicator.setLoadingStatus("loading");
        const mergedInput = inputs.input || [];
        const previousCode = this.#mergeInputCode(mergedInput);
        let previousNodes = [];
        if (mergedInput) previousNodes = (0, $cfadb87391ca5e26$export$354e2109eb2648e0)(mergedInput);
        let currentCode = this.#generateCurrentCode(previousNodes);
        const code = [
            ...previousCode,
            currentCode
        ];
        const currentNode = {
            ...this,
            connectedPort: this.outputs.output
        };
        const output = {
            code: code,
            previousNodes: [
                ...previousNodes,
                currentNode
            ]
        };
        if (this.controls.status_indicator.messages.length === 0) this.controls.status_indicator.setLoadingStatus("success");
        else this.controls.status_indicator.setLoadingStatus("error");
        this.update("node", this);
        return {
            output: output
        };
    }
}







class $0897edf622ee7484$export$8d9ea068df147b5e extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    df_columns;
    errorMessages;
    selectedFeatures;
    targetFeature;
    testSize;
    isLoading;
    setSelectedFeatures;
    setTargetVariable;
    setTestSize;
    constructor(df_columns, errorMessages, selectedFeatures, targetFeature, testSize, isLoading, setSelectedFeatures, setTargetVariable, setTestSize){
        super();
        this.df_columns = df_columns;
        this.errorMessages = errorMessages;
        this.selectedFeatures = selectedFeatures;
        this.targetFeature = targetFeature;
        this.testSize = testSize;
        this.isLoading = isLoading;
        this.setSelectedFeatures = setSelectedFeatures;
        this.setTargetVariable = setTargetVariable;
        this.setTestSize = setTestSize;
    }
    setDataframeColumns(df_columns) {
        this.df_columns = [
            ...df_columns
        ];
    }
    setTargetFeature(targetFeature) {
        this.targetFeature = targetFeature;
    }
    setIsLoading(isLoading) {
        this.isLoading = isLoading;
    }
    _setSelectedFeatures(selectedFeatures) {
        this.selectedFeatures = [
            ...selectedFeatures
        ];
    }
    _setTestSize(testSize) {
        this.testSize = testSize;
    }
    setErrorMessages(errorMessages) {
        this.errorMessages = [
            ...errorMessages
        ];
    }
    setupControls(controlData) {
        this.setDataframeColumns(controlData.df_columns);
        this.selectedFeatures = controlData.selectedFeatures;
        this.targetFeature = controlData.targetFeature;
        this.testSize = controlData.testSize;
        this.errorMessages = controlData.errorMessages;
    }
}





class $9735c6bee69b34d2$export$86875fb9396ffef7 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 375;
    height = 365;
    dataframeColumns = [];
    selectedFeatures = [];
    targetVariable = "Choose Variable";
    testSize = 0.2;
    errorMessages = [
        "No dataframe found",
        "Sci-Kit Learn must be imported"
    ];
    update;
    change;
    debouncedUpdate;
    constructor(socket, update, change, context){
        super("Test Train Split");
        this.addInput("dataframe_input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Dataframe"));
        this.addOutput("train_output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Train Dataframe"));
        this.addOutput("test_output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Test Dataframe"));
        this.addControl("test_train_split", new (0, $0897edf622ee7484$export$8d9ea068df147b5e)(this.dataframeColumns, this.errorMessages, this.selectedFeatures, this.targetVariable, this.testSize, false, this.setSelectedFeatures.bind(this), this.setTargetVariable.bind(this), this.setTestSize.bind(this)));
        this.update = update;
        this.change = change;
        this.debouncedUpdate = (0, $cfadb87391ca5e26$export$dd6e5daab826fa5c)(this.change.bind(this), 1000);
    }
    getType() {
        return "TestTrainSplit";
    }
    getDisplayName() {
        return "Test-Train-Split";
    }
    setSelectedFeatures(selectedFeatures) {
        this.selectedFeatures = [
            ...selectedFeatures
        ];
        this.controls.test_train_split._setSelectedFeatures(selectedFeatures);
        this.update("node", this);
        this.debouncedUpdate();
    }
    setTargetVariable(targetVariable) {
        this.targetVariable = targetVariable;
        this.controls.test_train_split.setTargetFeature(targetVariable);
        this.update("node", this);
        this.debouncedUpdate();
    }
    setTestSize(testSize) {
        this.testSize = testSize;
        this.controls.test_train_split._setTestSize(testSize);
        this.update("node", this);
        this.debouncedUpdate();
    }
    #setIsLoading(loadingStatus) {
        this.controls.test_train_split.setIsLoading(loadingStatus);
        this.update("node", this);
    }
    #clearErrorMessages() {
        this.controls.test_train_split.setErrorMessages([]);
        this.update("node", this);
    }
    #getDatasetColumns(previousNodes) {
        const datasetImporterNode = previousNodes.find((node)=>{
            return node.label === "Import Dataset";
        });
        const columns = datasetImporterNode?.datasetColumns.filter((column)=>column !== "id") || [];
        return columns;
    }
    #dataframeExists(code) {
        const regex = /df\s*=\s*pd/g;
        const dataframe = code.match(regex);
        return !!dataframe;
    }
    #resetSelectedFeatures(columns) {
        this.dataframeColumns = columns.filter((column)=>column !== "id");
        this.selectedFeatures = [];
        this.targetVariable = "";
        this.testSize = 0.2;
        this.controls.test_train_split._setTestSize(this.testSize);
        this.controls.test_train_split.setDataframeColumns(this.dataframeColumns);
        this.controls.test_train_split._setSelectedFeatures([]);
        this.controls.test_train_split.setTargetFeature("");
        this.update("node", this);
    }
    #getUnselectedFeatures() {
        const unselectedFeatures = this.dataframeColumns.filter((column)=>!this.selectedFeatures.includes(column)).map((column)=>`"${column}"`);
        return unselectedFeatures;
    }
    #generateCode() {
        const unselectedFeatures = this.#getUnselectedFeatures();
        let code = `X = df.drop(columns=[
    ${!(0, $cfadb87391ca5e26$export$dd1bc94b04021eeb)(unselectedFeatures) ? this.#getUnselectedFeatures().join(", ") : "# Every column selected, nothing to drop"}
])
${!!this.targetVariable ? `y = df["${this.targetVariable}"]` : "# Select a target variable to continue"}\n`;
        if (!(0, $cfadb87391ca5e26$export$dd1bc94b04021eeb)(this.selectedFeatures) && !!this.targetVariable) code += `X_train, X_test, y_train, y_test = train_test_split(X, y, test_size=${this.testSize}, random_state=42)\n`;
        return code;
    }
    #addRequiredImport(previousNodes) {
        const libraryName = "Scikit-Learn";
        const importStatement = "from sklearn.model_selection import train_test_split";
        const packageImporterNode = previousNodes.find((node)=>{
            return node.label === "Import Libraries";
        });
        const ImportManager = packageImporterNode?.ImportManager;
        if (ImportManager) ImportManager.addSpecificImport(libraryName, importStatement);
    }
    #hasBaseImport(previousNodes) {
        const packageImporterNode = previousNodes.find((node)=>{
            return node.label === "Import Libraries";
        });
        const hasBaseImport = packageImporterNode?.ImportManager.currentImports.some((i)=>i.libraryName === "Scikit-Learn");
        return !!hasBaseImport;
    }
    async data(inputs) {
        this.#setIsLoading(true);
        const previousNodes = inputs.dataframe_input?.[0].previousNodes || [];
        this.#addRequiredImport(previousNodes);
        const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodes);
        const previousCode = inputs.dataframe_input?.[0].code || [];
        if (inputs.dataframe_input && importStatement) previousCode[0] = importStatement;
        let totalCode = (0, $4e6b0038302d94d3$export$f9a73699f5f52645)(previousCode);
        let errorComments = [];
        let currentNodeTrain = {
            ...this,
            connectedPort: this.outputs.train_output
        };
        let currentNodeTest = {
            ...this,
            connectedPort: this.outputs.test_output
        };
        const dataframeExists = this.#dataframeExists(totalCode);
        if (!dataframeExists) errorComments.push({
            code: "# Test Train Split: No dataframe found",
            msg: "No dataframe found"
        });
        const hasRequiredBaseImport = this.#hasBaseImport(previousNodes);
        if (!hasRequiredBaseImport) errorComments.push({
            code: "# scikit-learn must be imported",
            msg: "scikit-learn must be imported"
        });
        if (errorComments.length > 0) {
            this.#setIsLoading(false);
            this.#resetSelectedFeatures([]);
            const errorCode = errorComments.map((e)=>e.code).join("\n");
            this.controls.test_train_split.setErrorMessages(errorComments.map((e)=>e.msg));
            return {
                train_output: {
                    code: [
                        ...previousCode,
                        errorCode
                    ],
                    previousNodes: [
                        ...previousNodes,
                        currentNodeTrain
                    ]
                },
                test_output: {
                    code: [
                        ...previousCode,
                        errorCode
                    ],
                    previousNodes: [
                        ...previousNodes,
                        currentNodeTest
                    ]
                }
            };
        }
        this.#clearErrorMessages();
        const dataframeColumns = this.#getDatasetColumns(previousNodes);
        const areColumnsChanged = !(0, $cfadb87391ca5e26$export$234180f8206db11b)(dataframeColumns, this.controls.test_train_split.df_columns);
        if (areColumnsChanged) this.#resetSelectedFeatures(dataframeColumns);
        const currentCode = this.#generateCode();
        currentNodeTrain = {
            ...this,
            connectedPort: this.outputs.train_output
        };
        currentNodeTest = {
            ...this,
            connectedPort: this.outputs.test_output
        };
        const train_output = {
            code: [
                ...previousCode,
                currentCode
            ],
            previousNodes: [
                ...previousNodes,
                currentNodeTrain
            ]
        };
        const test_output = {
            code: [
                ...previousCode,
                currentCode
            ],
            previousNodes: [
                ...previousNodes,
                currentNodeTest
            ]
        };
        this.#setIsLoading(false);
        return {
            train_output: train_output,
            test_output: test_output
        };
    }
}




class $25d2d290184854c1$export$fb555a1f694982ed extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 240;
    height = 150;
    constructor(socket){
        super("Train Model");
        this.addInput("model_input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Untrained Model"));
        this.addInput("training_dataset_input", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Train Dataframe"));
        this.addOutput("trained_model_output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Trained Model"));
    }
    getType() {
        return "TrainModel";
    }
    getDisplayName() {
        return "Train Model";
    }
    #checkConnections(model_input, training_dataset_input) {
        // Check if model and training dataset are connected
        let allValidConnections = true;
        let codeMessageIfInvalid = "";
        let previousCodeIfError = [];
        let previousNodesIfError = [];
        if (!model_input) {
            allValidConnections = false;
            codeMessageIfInvalid += "# Connect a model to Train Model block\n";
        } else {
            previousCodeIfError = model_input.code;
            previousNodesIfError = [
                ...model_input.previousNodes
            ];
            const model = model_input.previousNodes[0];
            if (model && !("model" in model)) {
                allValidConnections = false;
                codeMessageIfInvalid += "# Connect a model to Train Model block\n";
            }
        }
        if (!training_dataset_input) {
            allValidConnections = false;
            codeMessageIfInvalid += "# Connect a training dataset to Train Model block\n";
        } else {
            previousCodeIfError = [
                ...training_dataset_input.code,
                ...previousCodeIfError
            ];
            previousNodesIfError = [
                ...training_dataset_input.previousNodes,
                ...previousNodesIfError
            ];
            const previousNodesTrainPort = training_dataset_input.previousNodes;
            const noTrainDatasetFound = previousNodesTrainPort.every((node)=>{
                return !(node.connectedPort.label === "Train Dataframe");
            });
            if (noTrainDatasetFound) {
                allValidConnections = false;
                codeMessageIfInvalid += "# Connect a training dataset to Train Model block\n";
            }
        }
        return {
            allValidConnections: allValidConnections,
            codeMessageIfInvalid: codeMessageIfInvalid,
            previousCodeIfError: previousCodeIfError,
            previousNodesIfError: previousNodesIfError
        };
    }
    #addRequiredModelImports(modelInput, trainingDatasetInput) {
        const previousModelNodes = modelInput.previousNodes;
        const previousTrainingDatasetNodes = trainingDatasetInput.previousNodes;
        const model = previousModelNodes.find((node)=>"model" in node);
        const requiredImports = model?.requiredImports || null;
        if (requiredImports) {
            const { libraryName: libraryName, importStatement: importStatement } = requiredImports;
            const packageImporterNode = previousTrainingDatasetNodes.find((node)=>{
                return node.label === "Import Libraries";
            });
            const ImportManager = packageImporterNode?.ImportManager || null;
            if (ImportManager) ImportManager.addSpecificImport(libraryName, importStatement);
        }
    }
    data(inputs) {
        let currentCode = "";
        let previousNodes = [];
        const modelInput = inputs.model_input?.[0] || null;
        const trainingDataset = inputs.training_dataset_input?.[0] || null;
        const { allValidConnections: allValidConnections, codeMessageIfInvalid: codeMessageIfInvalid, previousCodeIfError: previousCodeIfError, previousNodesIfError: previousNodesIfError } = this.#checkConnections(modelInput, trainingDataset);
        if (!allValidConnections) {
            currentCode += codeMessageIfInvalid;
            return {
                trained_model_output: {
                    code: [
                        ...previousCodeIfError,
                        currentCode
                    ],
                    previousNodes: [
                        ...previousNodesIfError,
                        {
                            ...this,
                            connectedPort: this.outputs.trained_model_output
                        }
                    ]
                }
            };
        }
        this.#addRequiredModelImports(modelInput, trainingDataset);
        previousNodes = [
            ...trainingDataset.previousNodes,
            ...modelInput.previousNodes
        ];
        const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodes);
        const previousCode = [
            ...trainingDataset.code,
            ...modelInput.code
        ];
        if (importStatement) previousCode[0] = importStatement;
        currentCode += `model.fit(X_train, y_train)\n`;
        const currentNode = {
            ...this,
            connectedPort: this.outputs.trained_model_output
        };
        const trained_model_output = {
            code: [
                ...previousCode,
                currentCode
            ],
            previousNodes: [
                ...previousNodes,
                currentNode
            ]
        };
        return {
            trained_model_output: trained_model_output
        };
    }
}



class $1ebb17db6a168a75$export$563d687b34faa3e extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    initialSolver;
    initialPenalty;
    initialC;
    initialMaxIter;
    initialL1Ratio;
    updateL1Ratio;
    updateSolver;
    updatePenalty;
    updateC;
    updateMaxIter;
    constructor(initialSolver, initialPenalty, initialC, initialMaxIter, initialL1Ratio, updateL1Ratio, updateSolver, updatePenalty, updateC, updateMaxIter){
        super();
        this.initialSolver = initialSolver;
        this.initialPenalty = initialPenalty;
        this.initialC = initialC;
        this.initialMaxIter = initialMaxIter;
        this.initialL1Ratio = initialL1Ratio;
        this.updateL1Ratio = updateL1Ratio;
        this.updateSolver = updateSolver;
        this.updatePenalty = updatePenalty;
        this.updateC = updateC;
        this.updateMaxIter = updateMaxIter;
    }
    setupControls(controlData) {
        this.initialSolver = controlData.initialSolver;
        this.initialPenalty = controlData.initialPenalty;
        this.initialC = controlData.initialC;
        this.initialMaxIter = controlData.initialMaxIter;
        this.initialL1Ratio = controlData.initialL1Ratio;
    }
}



class $0e7415dfef3d107e$export$94ed1b3e3ae1550b extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 250;
    height = 290;
    model = "logistic_regression";
    solver = "liblinear";
    penalty = "l2";
    C = 1.0;
    max_iter = 100;
    l1_ratio = 0.5;
    requiredImports = {
        libraryName: "Scikit-Learn",
        importStatement: "from sklearn.linear_model import LogisticRegression"
    };
    update;
    change;
    constructor(socket, update, change){
        super("Logistic Regression Model");
        this.addControl("settings", new (0, $1ebb17db6a168a75$export$563d687b34faa3e)(this.solver, this.penalty, this.C, this.max_iter, this.l1_ratio, this.updateL1Ratio.bind(this), this.updateSolver.bind(this), this.updatePenalty.bind(this), this.updateC.bind(this), this.updateMaxIter.bind(this)));
        this.addOutput("output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Untrained Model"));
        this.update = update;
        this.change = change;
    }
    getType() {
        return "LogisticRegressionModel";
    }
    getDisplayName() {
        return "Logistic Regression Model";
    }
    updateL1Ratio = (value)=>{
        this.l1_ratio = value;
        this.controls.settings.initialL1Ratio = value;
        this.change();
    };
    updateSolver = (value)=>{
        this.solver = value;
        this.controls.settings.initialSolver = value;
        this.change();
    };
    updatePenalty = (value)=>{
        this.penalty = value;
        this.controls.settings.initialPenalty = value;
        if (value === "elasticnet") this.height = 335;
        else this.height = 290;
        this.update("node", this);
        this.change();
    };
    updateC = (value)=>{
        this.C = value;
        this.controls.settings.initialC = value;
        this.change();
    };
    updateMaxIter = (value)=>{
        this.max_iter = value;
        this.controls.settings.initialMaxIter = value;
        this.change();
    };
    getCurrentCode() {
        const currentCode = `model = LogisticRegression(solver='${this.solver}', penalty='${this.penalty}', C=${this.C}, max_iter=${this.max_iter})\n`;
        return currentCode;
    }
    data(inputs) {
        const currentCode = this.getCurrentCode();
        const previousNodes = [
            {
                ...this,
                connectedPort: this.outputs.output
            }
        ];
        const output = {
            code: [
                currentCode
            ],
            previousNodes: previousNodes
        };
        return {
            output: output
        };
    }
}




class $f526e55cdfab877a$export$69adef2c3afcd250 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 240;
    height = 150;
    score = "";
    constructor(socket){
        super("Simple Score Model");
        this.addInput("trained_model", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Trained Model"));
        this.addInput("test_dataset", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Test Dataframe"));
        this.addOutput("simple_score", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Score"));
    }
    getType() {
        return "ScoreModelBasic";
    }
    getDisplayName() {
        return "Score Model Basic";
    }
    scoreVariableNames = {
        "linear_regression": "R_squared",
        "logistic_regression": "Accuracy",
        "decision_tree_classifier": "Accuracy",
        "random_forest_classifier": "Accuracy",
        "support_vector_classifier": "Accuracy",
        "k_nearest_neighbors": "Accuracy",
        "decision_tree_regressor": "R_squared",
        "random_forest_regressor": "R_squared",
        "support_vector_regressor": "R_squared"
    };
    #checkConnections(trained_model, test_dataset) {
        let allValidConnections = true;
        let codeMessageIfInvalid = "";
        let previousCodeIfError = [];
        let previousNodesIfError = [];
        if (!trained_model) {
            allValidConnections = false;
            codeMessageIfInvalid += "# Connect a trained model to the `Trained Model` port on the Simple Score Model block\n";
        } else {
            previousCodeIfError = [
                ...trained_model.code
            ];
            previousNodesIfError = [
                ...trained_model.previousNodes
            ];
            const hasTrainedModel = trained_model.previousNodes.find((node)=>node.connectedPort.label === "Trained Model");
            if (!hasTrainedModel) {
                allValidConnections = false;
                codeMessageIfInvalid += "# Invalid connection at `Trained Model` port on the Simple Score Model block\n";
            }
        }
        if (!test_dataset) {
            allValidConnections = false;
            codeMessageIfInvalid += "# Connect a test dataset to the `Test Dataset` port on the Simple Score Model block\n";
        } else {
            previousNodesIfError = (0, $cfadb87391ca5e26$export$f3642bf4730985a1)(previousNodesIfError, test_dataset.previousNodes);
            const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodesIfError);
            previousCodeIfError = (0, $cfadb87391ca5e26$export$7215840b05bfeace)(test_dataset.code, previousCodeIfError, importStatement);
            const previousNodesTestPort = test_dataset.previousNodes;
            const hasTestDataset = previousNodesTestPort.find((node)=>{
                return node.connectedPort.label === "Test Dataframe";
            });
            if (!hasTestDataset) {
                allValidConnections = false;
                codeMessageIfInvalid += "# Invalid connection at `Test Dataframe` port on the Simple Score Model block\n";
            }
        }
        return {
            allValidConnections: allValidConnections,
            codeMessageIfInvalid: codeMessageIfInvalid,
            previousCodeIfError: previousCodeIfError,
            previousNodesIfError: previousNodesIfError
        };
    }
    #getScoreVariableBasedOnModelType(previousNodes) {
        let scoreVariable = "unknown_score";
        const modelType = (0, $cfadb87391ca5e26$export$ec5a5831a0a9fa3d)(previousNodes);
        if (!modelType) return scoreVariable;
        scoreVariable = this.scoreVariableNames[modelType] || "Score";
        return scoreVariable;
    }
    data(inputs) {
        let currentCode = "";
        let previousNodes = [];
        const trainedModelInput = inputs.trained_model?.[0] || null;
        const testDataset = inputs.test_dataset?.[0] || null;
        const { allValidConnections: allValidConnections, codeMessageIfInvalid: codeMessageIfInvalid, previousCodeIfError: previousCodeIfError, previousNodesIfError: previousNodesIfError } = this.#checkConnections(trainedModelInput, testDataset);
        if (!allValidConnections) {
            currentCode += codeMessageIfInvalid;
            return {
                simple_score: {
                    code: [
                        ...previousCodeIfError,
                        currentCode
                    ],
                    previousNodes: [
                        ...previousNodesIfError,
                        {
                            ...this,
                            connectedPort: this.outputs.simple_score
                        }
                    ]
                }
            };
        }
        previousNodes = (0, $cfadb87391ca5e26$export$f3642bf4730985a1)(trainedModelInput.previousNodes, testDataset.previousNodes);
        const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodes);
        const previousCode = (0, $cfadb87391ca5e26$export$7215840b05bfeace)(trainedModelInput.code, testDataset.code, importStatement);
        const scoreVariable = this.#getScoreVariableBasedOnModelType(trainedModelInput.previousNodes);
        currentCode += `${scoreVariable} = model.score(X_test, y_test)\n`;
        currentCode += `print("${scoreVariable} is", ${scoreVariable})\n`;
        const currentNode = {
            ...this,
            connectedPort: this.outputs.simple_score
        };
        const simple_score = {
            code: [
                ...previousCode,
                currentCode
            ],
            previousNodes: [
                ...previousNodes,
                currentNode
            ]
        };
        return {
            simple_score: simple_score
        };
    }
}



class $b793ca7473380a0a$export$f0ec58f328f6e9c0 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    initialFitIntercept;
    initialCopyX;
    initialPositive;
    updateFitIntercept;
    updateCopyX;
    updatePositive;
    constructor(initialFitIntercept, initialCopyX, initialPositive, updateFitIntercept, updateCopyX, updatePositive){
        super();
        this.initialFitIntercept = initialFitIntercept;
        this.initialCopyX = initialCopyX;
        this.initialPositive = initialPositive;
        this.updateFitIntercept = updateFitIntercept;
        this.updateCopyX = updateCopyX;
        this.updatePositive = updatePositive;
    }
    setupControls(controlData) {
        this.initialFitIntercept = controlData.initialFitIntercept;
        this.initialCopyX = controlData.initialCopyX;
        this.initialPositive = controlData.initialPositive;
    }
}



class $c35186146850e89e$export$d3b03157a2f8aeb0 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 300;
    height = 200;
    model = "linear_regression";
    fitIntercept = true;
    copyX = true;
    positive = false;
    requiredImports = {
        libraryName: "Scikit-Learn",
        importStatement: "from sklearn.linear_model import LinearRegression"
    };
    update;
    change;
    constructor(socket, update, change){
        super("Linear Regression Model");
        this.addControl("settings", new (0, $b793ca7473380a0a$export$f0ec58f328f6e9c0)(this.fitIntercept, this.copyX, this.positive, this.updateFitIntercept.bind(this), this.updateCopyX.bind(this), this.updatePositive.bind(this)));
        this.addOutput("output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Untrained Model"));
        this.update = update;
        this.change = change;
    }
    getType() {
        return "LinearRegressionModel";
    }
    getDisplayName() {
        return "Linear Regression Model";
    }
    updateFitIntercept = (value)=>{
        this.fitIntercept = value;
        this.controls.settings.initialFitIntercept = value;
        this.change();
    };
    updateCopyX = (value)=>{
        this.copyX = value;
        this.controls.settings.initialCopyX = value;
        this.change();
    };
    updatePositive = (value)=>{
        this.positive = value;
        this.controls.settings.initialPositive = value;
        this.change();
    };
    getCurrentCode() {
        const currentCode = `model = LinearRegression(fit_intercept=${this.fitIntercept ? "True" : "False"}, copy_X=${this.copyX ? "True" : "False"}, positive=${this.positive ? "True" : "False"})\n`;
        return currentCode;
    }
    data(inputs) {
        const currentCode = this.getCurrentCode();
        const previousNodes = [
            {
                ...this,
                connectedPort: this.outputs.output
            }
        ];
        const output = {
            code: [
                currentCode
            ],
            previousNodes: previousNodes
        };
        return {
            output: output
        };
    }
}




class $34c62684cffe3541$export$41b53e6f254bcba7 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Control {
    setIsVisualizerOpen;
    setPlotType;
    setCategoricalColumn;
    setNumericalColumns;
    setBins;
    adjustHeight;
    messages;
    plotType;
    df_columns;
    generatedPlots;
    categoricalColumn;
    numericalColumns;
    bins;
    constructor(setIsVisualizerOpen, setPlotType, setCategoricalColumn, setNumericalColumns, setBins, adjustHeight, messages){
        super();
        this.setIsVisualizerOpen = setIsVisualizerOpen;
        this.setPlotType = setPlotType;
        this.setCategoricalColumn = setCategoricalColumn;
        this.setNumericalColumns = setNumericalColumns;
        this.setBins = setBins;
        this.adjustHeight = adjustHeight;
        this.messages = messages;
        this.plotType = "";
        this.df_columns = [];
        this.generatedPlots = [];
        this.categoricalColumn = "";
        this.numericalColumns = [];
        this.bins = null;
    }
    _setPlotType(type) {
        this.plotType = type;
    }
    setDfColumns(columns) {
        this.df_columns = columns;
    }
    setGeneratedPlots(plots) {
        this.generatedPlots = plots;
    }
    _setCategoricalColumn(column) {
        this.categoricalColumn = column;
    }
    _setNumericalColumns(columns) {
        this.numericalColumns = columns;
    }
    _setBins(bins) {
        this.bins = bins;
    }
    clearMessages() {
        this.messages = [];
    }
    addMessage(message) {
        this.messages.push(message);
    }
    setupControls(controlData) {
        this.plotType = controlData.plotType;
        this.df_columns = controlData.df_columns;
        this.generatedPlots = controlData.generatedPlots;
        this.categoricalColumn = controlData.categoricalColumn || "";
        this.numericalColumns = controlData.numericalColumns || [];
        this.bins = controlData.bins;
    }
}



class $3a72e5e3d0c4576d$export$5eb306383074849d extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    update;
    change;
    width;
    height;
    plotType;
    categoricalColumn;
    numericalColumns;
    selectedSpecies;
    bins;
    messages;
    constructor(socket, update, setIsVisualizerOpen, change){
        super("Generate Plot");
        this.update = update;
        this.change = change;
        this.width = 300;
        this.height = 250;
        this.plotType = "";
        this.categoricalColumn = "";
        this.numericalColumns = [];
        this.selectedSpecies = [];
        this.bins = 10;
        this.messages = [
            "No dataframe found"
        ];
        this.addControl("controls", new (0, $34c62684cffe3541$export$41b53e6f254bcba7)(()=>setIsVisualizerOpen(true), this.setPlotType.bind(this), this.setCategoricalColumn.bind(this), this.setNumericalColumns.bind(this), this.setBins.bind(this), this.adjustHeight.bind(this), this.messages));
        this.addInput("data", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Data"));
        this.addOutput("output", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Output"));
    }
    getType() {
        return "Visualizer";
    }
    getDisplayName() {
        return "Visualizer";
    }
    setPlotType(type) {
        this.plotType = type;
        this.controls.controls._setPlotType(type);
        this.categoricalColumn = "";
        this.controls.controls._setCategoricalColumn("");
        this.numericalColumns = [];
        this.controls.controls._setNumericalColumns([]);
        this.controls.controls.setBins(10);
        this.change();
    }
    setCategoricalColumn(column) {
        this.categoricalColumn = column;
        this.controls.controls._setCategoricalColumn(column);
        this.change();
    }
    setNumericalColumns(columns) {
        this.numericalColumns = columns;
        this.controls.controls._setNumericalColumns(columns);
        this.change();
    }
    setBins(bins) {
        this.bins = bins;
        this.controls.controls._setBins(bins);
        this.change();
    }
    adjustHeight(value) {
        this.height = value;
        this.update("node", this);
    }
    #setDfColumns(columns) {
        if (!(0, $cfadb87391ca5e26$export$234180f8206db11b)(columns, this.controls.controls.df_columns)) {
            this.controls.controls.setDfColumns(columns);
            this.numericalColumns = [];
            this.controls.controls._setNumericalColumns([]);
            this.categoricalColumn = "";
            this.controls.controls._setCategoricalColumn("");
            this.update("node", this);
        }
    }
    #addRequiredImport(previousNodes) {
        const libraryNames = [
            "Matplotlib",
            "Seaborn"
        ];
        const packageImporterNode = previousNodes.find((node)=>{
            return node.label === "Import Libraries";
        });
        const ImportManager = packageImporterNode?.ImportManager;
        if (ImportManager) for (const libraryName of libraryNames)ImportManager.addBaseImport(libraryName);
    }
    #getCurrentCode() {
        switch(this.plotType){
            case "heatmap":
                return `corr = df.corr()
sns.heatmap(corr, annot=True)
plt.show()`;
            case "bar_chart":
                if (this.numericalColumns.length === 0) return `df['${this.categoricalColumn || "Select categorical column"}'].value_counts().plot(kind='bar')
plt.xlabel('${this.categoricalColumn || "Select categorical column"}')
plt.ylabel('Counts')
plt.title('Frequency of Each ${this.categoricalColumn || "Select categorical column"}')
plt.xticks(rotation=45)
plt.subplots_adjust(bottom=0.25)
plt.show()`;
                else return `df.groupby('${this.categoricalColumn || "Select categorical column"}')['${this.numericalColumns[0]}'].mean().plot(kind='bar')
plt.xlabel('${this.categoricalColumn || "Select categorical column"}')
plt.ylabel('Average of ${this.numericalColumns[0]}')
plt.title('Average ${this.numericalColumns[0]} Grouped by ${this.categoricalColumn || "Select categorical column"}')
plt.xticks(rotation=45)
plt.subplots_adjust(bottom=0.25)
plt.show()`;
            case "histogram":
                return `df['${this.numericalColumns[0] || "Select column"}'].plot(kind='hist', bins=${this.bins})
plt.xlabel('${this.numericalColumns[0] || "Select column"}')
plt.ylabel('Frequency')
plt.title('Histogram of ${this.numericalColumns[0] || "Select column"} (${this.bins} bins)')
plt.show()`;
            case "scatter":
                return `sns.scatterplot(data=df, x='${this.numericalColumns[0] || "Select x column"}', y='${this.numericalColumns[1] || "Select y column"}'${this.categoricalColumn && `, hue='${this.categoricalColumn || "Select categorical column"}'`})
plt.xlabel('${this.numericalColumns[0] || "Select x column"}')
plt.ylabel('${this.numericalColumns[1] || "Select y column"}')
plt.title('Scatter Plot of "${this.numericalColumns[0] || "Select x column"}" vs "${this.numericalColumns[1] || "Select y column"}"')
plt.show()`;
            case "line":
                return `df.plot()
plt.show()`;
            default:
                return ``;
        }
    }
    #getDatasetColumns(previousNodes) {
        const datasetImporterNode = previousNodes.find((node)=>{
            return node.label === "Import Dataset";
        });
        const columns = datasetImporterNode?.datasetColumns.filter((column)=>column !== "id") || [];
        return columns;
    }
    #dataframeExists(code) {
        const regex = /df\s*=\s*pd/g;
        const dataframe = code.match(regex);
        return !!dataframe;
    }
    #checkForRequiredImports(prevNodes, previousCode) {
        const dataframeExists = this.#dataframeExists(previousCode.join("\n"));
        const packageImporterNode = prevNodes.find((node)=>node.label === "Import Libraries");
        const isMatPlotLibImported = !!packageImporterNode?.selectedItems.map((item)=>item.toLowerCase()).includes("matplotlib");
        const isSeabornImported = !!packageImporterNode?.selectedItems.map((item)=>item.toLowerCase()).includes("seaborn");
        const display = this.controls.controls;
        display.clearMessages();
        if (!dataframeExists) {
            display.addMessage("No dataframe found");
            return;
        }
        if (!isMatPlotLibImported) display.addMessage("Import Matplotlib");
        switch(this.plotType){
            case "heatmap":
            case "scatter":
                if (!isSeabornImported) display.addMessage("Import Seaborn");
                break;
            case "bar_chart":
            case "histogram":
                break;
            default:
                break;
        }
    }
    data(inputs) {
        const previousNodes = inputs.data?.[0].previousNodes || [];
        const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodes);
        const previousCode = inputs.data?.[0].code || [];
        if (inputs.data && importStatement) previousCode[0] = importStatement;
        const df_columns = this.#getDatasetColumns(previousNodes);
        this.#setDfColumns(df_columns);
        let currentCode = this.#getCurrentCode();
        if (currentCode) currentCode = "plt.clf() # Clear any previous plot data\n" + currentCode;
        this.#checkForRequiredImports(previousNodes, previousCode);
        const output = {
            code: [
                ...previousCode,
                currentCode
            ],
            previousNodes: [
                ...previousNodes,
                {
                    ...this,
                    connectedPort: this.outputs.output
                }
            ]
        };
        this.update("node", this);
        return {
            output: output
        };
    }
}




class $94f417b207779069$export$b861717cc31ea743 extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Node {
    width = 240;
    height = 150;
    constructor(socket){
        super("Predict Model");
        this.addInput("trained_model", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Trained Model"));
        this.addInput("test_dataset", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Input(socket, "Test Dataframe"));
        this.addOutput("predictions", new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Output(socket, "Predictions"));
    }
    getType() {
        return "PredictModel";
    }
    getDisplayName() {
        return "Predict Model";
    }
    #checkConnections(trained_model, test_dataset) {
        // Check if model and training dataset are connected
        let allValidConnections = true;
        let codeMessageIfInvalid = "";
        let previousCodeIfError = [];
        let previousNodesIfError = [];
        if (!trained_model) {
            allValidConnections = false;
            codeMessageIfInvalid += "# Connect a trained model to the `Trained Model` port on the Predict Model block\n";
        } else {
            previousCodeIfError = [
                ...trained_model.code
            ];
            previousNodesIfError = [
                ...trained_model.previousNodes
            ];
            const hasTrainedModel = trained_model.previousNodes.find((node)=>node.connectedPort.label === "Trained Model");
            if (!hasTrainedModel) {
                allValidConnections = false;
                codeMessageIfInvalid += "# Invalid connection at `Trained Model` port on the Predict Model block\n";
            }
        }
        if (!test_dataset) {
            allValidConnections = false;
            codeMessageIfInvalid += "# Connect a test dataset to the `Test Dataset` port on the Predict Model block\n";
        } else {
            previousNodesIfError = (0, $cfadb87391ca5e26$export$f3642bf4730985a1)(previousNodesIfError, test_dataset.previousNodes);
            const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodesIfError);
            previousCodeIfError = (0, $cfadb87391ca5e26$export$7215840b05bfeace)(test_dataset.code, previousCodeIfError, importStatement);
            const previousNodesTestPort = test_dataset.previousNodes;
            const hasTestDataset = previousNodesTestPort.find((node)=>{
                return node.connectedPort.label === "Test Dataset";
            });
            if (!hasTestDataset) {
                allValidConnections = false;
                codeMessageIfInvalid += "# Invalid connection at `Test Dataframe` port on the Predict Model block\n";
            }
        }
        return {
            allValidConnections: allValidConnections,
            codeMessageIfInvalid: codeMessageIfInvalid,
            previousCodeIfError: previousCodeIfError,
            previousNodesIfError: previousNodesIfError
        };
    }
    data(inputs) {
        let currentCode = "";
        let previousNodes = [];
        const trainedModelInput = inputs.trained_model?.[0] || null;
        const testDataset = inputs.test_dataset?.[0] || null;
        const { allValidConnections: allValidConnections, codeMessageIfInvalid: codeMessageIfInvalid, previousCodeIfError: previousCodeIfError, previousNodesIfError: previousNodesIfError } = this.#checkConnections(trainedModelInput, testDataset);
        if (!allValidConnections) {
            currentCode += codeMessageIfInvalid;
            return {
                predictions: {
                    code: [
                        ...previousCodeIfError,
                        currentCode
                    ],
                    previousNodes: [
                        ...previousNodesIfError,
                        {
                            ...this,
                            connectedPort: this.outputs.predictions
                        }
                    ]
                }
            };
        }
        previousNodes = (0, $cfadb87391ca5e26$export$f3642bf4730985a1)(trainedModelInput.previousNodes, testDataset.previousNodes);
        const importStatement = (0, $cfadb87391ca5e26$export$8ad1e9569ec24d43)(previousNodes);
        const previousCode = (0, $cfadb87391ca5e26$export$7215840b05bfeace)(trainedModelInput.code, testDataset.code, importStatement);
        currentCode += `predictions = model.predict(X_test)\n`;
        const currentNode = {
            ...this,
            connectedPort: this.outputs.predictions
        };
        const predictions = {
            code: [
                ...previousCode,
                currentCode
            ],
            previousNodes: [
                ...previousNodes,
                currentNode
            ]
        };
        return {
            predictions: predictions
        };
    }
}


const $afd930b1a77e3a58$export$62ca784e6947e746 = ()=>{
    const editorState = {
        nodes: [],
        connections: [],
        paths: []
    };
    const nodes = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNodes();
    const connections = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getConnections();
    for (const node of nodes){
        const blockType = node.getType();
        const blockDisplayName = node.getDisplayName();
        const controlData = (0, $cfadb87391ca5e26$export$fa817a1d9dbb705a)(blockType, {
            data: node
        });
        editorState.nodes.push({
            id: node.id,
            name: blockDisplayName,
            controlData: controlData
        });
    }
    for (const connection of connections){
        const source_node = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNode(connection.source);
        const target_node = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNode(connection.target);
        editorState.connections.push({
            source: {
                id: source_node.id,
                blockType: source_node.getDisplayName()
            },
            target: {
                id: target_node.id,
                blockType: target_node.getDisplayName()
            }
        });
    }
    const neverStartingNode = [
        "Linear Regression Model",
        "Logistic Regression Model"
    ];
    const starterNodes = editorState.nodes.filter((node)=>!connections.some((conn)=>conn.target === node.id) && connections.some((conn)=>conn.source === node.id) && !neverStartingNode.includes(node.name));
    if (starterNodes.length === 0) {
        console.log("No starter nodes found");
        return;
    }
    const leafNodes = editorState.nodes.filter((node)=>!connections.some((conn)=>conn.source === node.id) && connections.some((conn)=>conn.target === node.id));
    if (leafNodes.length === 0) {
        console.log("No leaf nodes found");
        return;
    }
    const pathSummaries = leafNodes.map((node, index)=>{
        return {
            pathNumber: index + 1,
            startNode: starterNodes.map((node)=>node.name).join(" + "),
            endNode: node.name
        };
    });
    editorState.paths.push(...pathSummaries);
    return editorState;
};
const $afd930b1a77e3a58$var$filterOutMethods = (obj, seen)=>{
    if (typeof obj !== "object" || obj === null) return obj;
    if (seen.has(obj)) return;
    seen.add(obj);
    const keys_to_remove = [
        "plotType"
    ];
    const newObj = Array.isArray(obj) ? [] : {};
    Object.keys(obj).forEach((key)=>{
        const value = obj[key];
        // if (keys_to_remove.includes(key)) {
        //     return;
        // }
        if (Array.isArray(value)) newObj[key] = value.slice();
        else if (value && typeof value === "object") {
            if (key === "uploadedDataset") {
                newObj[key] = {
                    content: "",
                    fileName: value.fileName
                };
                return;
            }
            newObj[key] = $afd930b1a77e3a58$var$filterOutMethods(value, seen);
        } else if (typeof value !== "function" && !(value instanceof HTMLElement)) newObj[key] = value;
    });
    return newObj;
};
function $afd930b1a77e3a58$var$getCustomNodeData(node) {
    const seen = new WeakSet();
    let filteredNode = $afd930b1a77e3a58$var$filterOutMethods(node, seen);
    if (node.getType() === "DatasetImporter") filteredNode = {
        ...filteredNode,
        height: 295
    };
    return filteredNode;
}
function $afd930b1a77e3a58$export$f69443b1e6a5be15(editor, area) {
    const data = {
        nodes: [],
        connections: []
    };
    const nodes = editor.getNodes();
    const connections = editor.getConnections();
    for (const node of nodes){
        const customData = $afd930b1a77e3a58$var$getCustomNodeData(node);
        const position = area.nodeViews.get(node.id)?.position;
        data.nodes.push({
            ...customData,
            __type: node.getType(),
            position: position,
            selected: false
        });
    }
    for (const connection of connections)data.connections.push({
        source: connection.source,
        sourceOutput: connection.sourceOutput,
        target: connection.target,
        targetInput: connection.targetInput
    });
    const serializedData = JSON.stringify(data);
    localStorage.setItem("graph", serializedData);
    return serializedData;
}
function $afd930b1a77e3a58$export$270e7ba5936d3c48(type, params) {
    const { socket: socket, updateAsset: updateAsset, process: process, context: context, setIsVisualizerOpen: setIsVisualizerOpen } = params;
    switch(type){
        case "DatasetImporter":
            return new (0, $d8d53b6b0907a50a$export$97f07c7bed44aa64)(socket, updateAsset, process, context);
        case "PackageImporter":
            return new (0, $2fb57d68275642e6$export$ffa639bf02197be7)(socket, process, updateAsset, context);
        case "DataframeLoader":
            return new (0, $01f94c473c0d84e2$export$22ddc13a7241495c)(socket, updateAsset, process, context);
        case "DataframeInspector":
            return new (0, $f26d115732c81313$export$d1590ca22f5c6870)(socket, updateAsset, process, context);
        case "CodeViewer":
            return new (0, $f49a18cfb699f2ae$export$6f3ba425d7d3e976)(socket, updateAsset);
        case "ConsoleViewer":
            return new (0, $810971140f72e2de$export$4bb420d367dd583f)(socket, updateAsset);
        case "PredictModel":
            return new (0, $94f417b207779069$export$b861717cc31ea743)(socket);
        case "TestTrainSplit":
            return new (0, $9735c6bee69b34d2$export$86875fb9396ffef7)(socket, updateAsset, process, context);
        case "TrainModel":
            return new (0, $25d2d290184854c1$export$fb555a1f694982ed)(socket);
        case "LogisticRegressionModel":
            return new (0, $0e7415dfef3d107e$export$94ed1b3e3ae1550b)(socket, updateAsset, process);
        case "LinearRegressionModel":
            return new (0, $c35186146850e89e$export$d3b03157a2f8aeb0)(socket, updateAsset, process);
        case "TrainModel":
            return new (0, $25d2d290184854c1$export$fb555a1f694982ed)(socket);
        case "ScoreModelBasic":
            return new (0, $f526e55cdfab877a$export$69adef2c3afcd250)(socket);
        case "Visualizer":
            return new (0, $3a72e5e3d0c4576d$export$5eb306383074849d)(socket, updateAsset, setIsVisualizerOpen, process);
        default:
            throw new Error(`Unknown node type: ${type}`);
    }
}
async function $afd930b1a77e3a58$export$ddad178871dadc52(editor, area, socket, updateAsset, process, context, setIsVisualizerOpen, problem_id) {
    const data = await $afd930b1a77e3a58$export$ca672b5acc4c423(problem_id);
    const parsedData = JSON.parse(data);
    const nodes = parsedData?.nodes || [];
    const connections = parsedData?.connections || [];
    for (const node of nodes){
        const { position: position, __type: __type, controls: controls, context: contextData, ImportManager: ImportManager, uploadedDataset: uploadedDataset, inputs: inputs, outputs: outputs, ...nodeData } = node;
        const newNode = $afd930b1a77e3a58$export$270e7ba5936d3c48(__type, {
            socket: socket,
            updateAsset: updateAsset,
            process: process,
            context: context,
            setIsVisualizerOpen: setIsVisualizerOpen
        });
        const controlData = Object.values(controls)[0];
        Object.assign(newNode, nodeData);
        if (Object.values(newNode.controls).length > 0) {
            const needsSetup = "setupControls" in Object.values(newNode.controls)[0];
            if (needsSetup) Object.values(newNode.controls)[0].setupControls(controlData);
        }
        await editor.addNode(newNode);
        await area.translate(newNode.id, position);
    }
    for (const connection of connections){
        const { source: source, sourceOutput: sourceOutput, target: target, targetInput: targetInput } = connection;
        const sourceNode = editor.getNode(source);
        const targetNode = editor.getNode(target);
        const newConnection = new (0, $14e68cbe3c2b3085$export$98b66c25bb38499d)(sourceNode, sourceOutput, targetNode, targetInput);
        await editor.addConnection(newConnection);
    }
}
async function $afd930b1a77e3a58$export$e8665f5904db2e8f(problem_id) {
    const graphData = $afd930b1a77e3a58$export$f69443b1e6a5be15((0, $14e68cbe3c2b3085$export$48f2fed47365221c), (0, $14e68cbe3c2b3085$export$5d8ad995f8f7b680));
    try {
        const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/editor/saveGraph", {
            graphData: graphData,
            problem_id: problem_id
        }, {
            withCredentials: true
        });
    } catch (error) {
        console.log("error", error.response.data);
    }
}
const $afd930b1a77e3a58$export$ca672b5acc4c423 = async (problem_id)=>{
    try {
        const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/editor/getGraph", {
            params: {
                problem_id: problem_id
            },
            withCredentials: true
        });
        const graphData = response.data.graphData;
        return graphData;
    } catch (error) {
        console.log("error", error.response.data);
        return "{}";
    }
};






"use client";
var $2dcdaeaf17c3bbb2$export$2e2bcd8739ae039 = (0, $50bd634b7bc091a8$export$2e2bcd8739ae039);


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c7365cae08954809$var$UpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    "name": "up",
    "theme": "outlined"
};
var $c7365cae08954809$export$2e2bcd8739ae039 = $c7365cae08954809$var$UpOutlined;



var $8ac1c243e74bf2d4$var$UpOutlined = function UpOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $c7365cae08954809$export$2e2bcd8739ae039)
    }));
};
/**![up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5MC41IDc1NS4zTDUzNy45IDI2OS4yYy0xMi44LTE3LjYtMzktMTcuNi01MS43IDBMMTMzLjUgNzU1LjNBOCA4IDAgMDAxNDAgNzY4aDc1YzUuMSAwIDkuOS0yLjUgMTIuOS02LjZMNTEyIDM2OS44bDI4NC4xIDM5MS42YzMgNC4xIDcuOCA2LjYgMTIuOSA2LjZoNzVjNi41IDAgMTAuMy03LjQgNi41LTEyLjd6IiAvPjwvc3ZnPg==) */ var $8ac1c243e74bf2d4$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($8ac1c243e74bf2d4$var$UpOutlined);
var $8ac1c243e74bf2d4$export$2e2bcd8739ae039 = $8ac1c243e74bf2d4$var$RefIcon;








/* eslint-disable max-classes-per-file */ 


function $4df45b08b12685e0$export$d5c7b2f63580e8f5() {
    return typeof BigInt === "function";
}


function $c5ec03f2f712ef62$export$dd1bc94b04021eeb(value) {
    return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function $c5ec03f2f712ef62$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith("-");
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, "$1")// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, "")// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, "");
    if (str.startsWith(".")) str = "0".concat(str);
    var trimStr = str || "0";
    var splitNumber = trimStr.split(".");
    var integerStr = splitNumber[0] || "0";
    var decimalStr = splitNumber[1] || "0";
    if (integerStr === "0" && decimalStr === "0") negative = false;
    var negativeStr = negative ? "-" : "";
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $c5ec03f2f712ef62$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes("e");
}
function $c5ec03f2f712ef62$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($c5ec03f2f712ef62$export$ee6c12ef7f6d8b32(number)) {
        var precision = Number(numStr.slice(numStr.indexOf("e-") + 2));
        var decimalMatch = numStr.match(/\.(\d+)/);
        if (decimalMatch !== null && decimalMatch !== void 0 && decimalMatch[1]) precision += decimalMatch[1].length;
        return precision;
    }
    return numStr.includes(".") && $c5ec03f2f712ef62$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf(".") - 1 : 0;
}
function $c5ec03f2f712ef62$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($c5ec03f2f712ef62$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $4df45b08b12685e0$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $4df45b08b12685e0$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        numStr = number.toFixed($c5ec03f2f712ef62$export$2e56483e4ad90ee6(numStr));
    }
    return $c5ec03f2f712ef62$export$5be79a0015c5ab12(numStr).fullStr;
}
function $c5ec03f2f712ef62$export$b3d198e17b370bec(num) {
    if (typeof num === "number") return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}


var $a98c5202b8d780e1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /** BigInt will convert `0009` to `9`. We need record the len of decimal */ function BigIntDecimal(value) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, BigIntDecimal);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "origin", "");
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "negative", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "integer", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "decimal", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "decimalLen", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "empty", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "nan", void 0);
        if ((0, $c5ec03f2f712ef62$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === "-" || Number.isNaN(value)) {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $c5ec03f2f712ef62$export$ee6c12ef7f6d8b32)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === "string" ? mergedValue : (0, $c5ec03f2f712ef62$export$fdc98affa95a4322)(mergedValue);
        if ((0, $c5ec03f2f712ef62$export$b3d198e17b370bec)(mergedValue)) {
            var trimRet = (0, $c5ec03f2f712ef62$export$5be79a0015c5ab12)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split(".");
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || "0";
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? "-" : "";
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, "0");
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, "0"));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "cal",
            value: function cal(offset, calculator, calDecimalLen) {
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
                var nextDecimalLength = calDecimalLen(maxDecimalLength);
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $c5ec03f2f712ef62$export$5be79a0015c5ab12)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, "0"));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                return this.cal(offset, function(num1, num2) {
                    return num1 + num2;
                }, function(len) {
                    return len;
                });
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = new BigIntDecimal(value);
                if (this.isInvalidate() || target.isInvalidate()) return new BigIntDecimal(NaN);
                return this.cal(target, function(num1, num2) {
                    return num1 * num2;
                }, function(len) {
                    return len * 2;
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                return (0, $c5ec03f2f712ef62$export$5be79a0015c5ab12)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();






/**
 * We can remove this when IE not support anymore
 */ var $909943b482d463d4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, NumberDecimal);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "origin", "");
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "number", void 0);
        (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(this, "empty", void 0);
        if ((0, $c5ec03f2f712ef62$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $c5ec03f2f712ef62$export$2e56483e4ad90ee6)(this.number), (0, $c5ec03f2f712ef62$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = Number(value);
                if (this.isInvalidate() || Number.isNaN(target)) return new NumberDecimal(NaN);
                var number = this.number * target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $c5ec03f2f712ef62$export$2e56483e4ad90ee6)(this.number), (0, $c5ec03f2f712ef62$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                return (0, $c5ec03f2f712ef62$export$fdc98affa95a4322)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();




function $7c447b41ca6024eb$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $4df45b08b12685e0$export$d5c7b2f63580e8f5)()) return new (0, $a98c5202b8d780e1$export$2e2bcd8739ae039)(value);
    return new (0, $909943b482d463d4$export$2e2bcd8739ae039)(value);
}
function $7c447b41ca6024eb$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === "") return "";
    var _trimNumber = (0, $c5ec03f2f712ef62$export$5be79a0015c5ab12)(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $7c447b41ca6024eb$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat("0".repeat(precision)).concat(10 - advancedNum));
            return $7c447b41ca6024eb$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, "0").slice(0, precision));
    }
    if (precisionDecimalStr === ".0") return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}



var $0bbdd0669817c7b1$export$2e2bcd8739ae039 = (0, $7c447b41ca6024eb$export$2e2bcd8739ae039);





/**
 * Proxy object if environment supported
 */ function $1ea42f56aaf074b0$export$2e2bcd8739ae039(obj, extendProps) {
    if (typeof Proxy !== "undefined" && obj) return new Proxy(obj, {
        get: function get(target, prop) {
            if (extendProps[prop]) return extendProps[prop];
            // Proxy origin property
            var originProp = target[prop];
            return typeof originProp === "function" ? originProp.bind(target) : originProp;
        }
    });
    return obj;
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $67b09a2610848fb9$export$2e2bcd8739ae039(input, focused) {
    var selectionRef = (0, $acw62.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            var start = input.selectionStart, end = input.selectionEnd, value = input.value;
            var beforeTxt = value.substring(0, start);
            var afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            var value = input.value;
            var _selectionRef$current = selectionRef.current, beforeTxt = _selectionRef$current.beforeTxt, afterTxt = _selectionRef$current.afterTxt, start = _selectionRef$current.start;
            var startPos = value.length;
            if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else {
                var beforeLastChar = beforeTxt[start - 1];
                var newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Something warning of cursor restore. Please fire issue about this: ".concat(e.message));
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


/**
 * Hook to detect if the user is on a mobile device
 * Notice that this hook will only detect the device type in effect, so it will always be false in server side
 */ var $74df8b5ac18d89f1$var$useMobile = function useMobile() {
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        setMobile((0, $066d1680709fcf3c$export$2e2bcd8739ae039)());
    }, []);
    return mobile;
};
var $74df8b5ac18d89f1$export$2e2bcd8739ae039 = $74df8b5ac18d89f1$var$useMobile;



/**
 * When click and hold on a button - the speed of auto changing the value.
 */ var $84412fb75b1f49e4$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ var $84412fb75b1f49e4$var$STEP_DELAY = 600;
function $84412fb75b1f49e4$export$2e2bcd8739ae039(_ref) {
    var prefixCls = _ref.prefixCls, upNode = _ref.upNode, downNode = _ref.downNode, upDisabled = _ref.upDisabled, downDisabled = _ref.downDisabled, onStep = _ref.onStep;
    // ======================== Step ========================
    var stepTimeoutRef = $acw62.useRef();
    var frameIds = $acw62.useRef([]);
    var onStepRef = $acw62.useRef();
    onStepRef.current = onStep;
    var onStopStep = function onStopStep() {
        clearTimeout(stepTimeoutRef.current);
    };
    // We will interval update step when hold mouse down
    var onStepMouseDown = function onStepMouseDown(e, up) {
        e.preventDefault();
        onStopStep();
        onStepRef.current(up);
        // Loop step for interval
        function loopStep() {
            onStepRef.current(up);
            stepTimeoutRef.current = setTimeout(loopStep, $84412fb75b1f49e4$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $84412fb75b1f49e4$var$STEP_DELAY);
    };
    $acw62.useEffect(function() {
        return function() {
            onStopStep();
            frameIds.current.forEach(function(id) {
                return (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(id);
            });
        };
    }, []);
    // ======================= Render =======================
    var isMobile = (0, $74df8b5ac18d89f1$export$2e2bcd8739ae039)();
    if (isMobile) return null;
    var handlerClassName = "".concat(prefixCls, "-handler");
    var upClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(handlerClassName, "".concat(handlerClassName, "-up"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(handlerClassName, "-up-disabled"), upDisabled));
    var downClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(handlerClassName, "".concat(handlerClassName, "-down"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(handlerClassName, "-down-disabled"), downDisabled));
    // fix: https://github.com/ant-design/ant-design/issues/43088
    // In Safari, When we fire onmousedown and onmouseup events in quick succession, 
    // there may be a problem that the onmouseup events are executed first, 
    // resulting in a disordered program execution.
    // So, we need to use requestAnimationFrame to ensure that the onmouseup event is executed after the onmousedown event.
    var safeOnStopStep = function safeOnStopStep() {
        return frameIds.current.push((0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(onStopStep));
    };
    var sharedHandlerProps = {
        unselectable: "on",
        role: "button",
        onMouseUp: safeOnStopStep,
        onMouseLeave: safeOnStopStep
    };
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(handlerClassName, "-wrap")
    }, /*#__PURE__*/ $acw62.createElement("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, true);
        },
        "aria-label": "Increase Value",
        "aria-disabled": upDisabled,
        className: upClassName
    }), upNode || /*#__PURE__*/ $acw62.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-up-inner")
    })), /*#__PURE__*/ $acw62.createElement("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sharedHandlerProps, {
        onMouseDown: function onMouseDown(e) {
            onStepMouseDown(e, false);
        },
        "aria-label": "Decrease Value",
        "aria-disabled": downDisabled,
        className: downClassName
    }), downNode || /*#__PURE__*/ $acw62.createElement("span", {
        unselectable: "on",
        className: "".concat(prefixCls, "-handler-down-inner")
    })));
}



function $4d1f7625d90c1d1d$export$d2883c6c6307c415(step) {
    var stepStr = typeof step === "number" ? (0, $c5ec03f2f712ef62$export$fdc98affa95a4322)(step) : (0, $c5ec03f2f712ef62$export$5be79a0015c5ab12)(step).fullStr;
    var hasPoint = stepStr.includes(".");
    if (!hasPoint) return step + "0";
    return (0, $c5ec03f2f712ef62$export$5be79a0015c5ab12)(stepStr.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr;
}




var $acw62 = parcelRequire("acw62");

var /**
 * Always trigger latest once when call multiple time
 */ $d33f9bc38de662bd$export$2e2bcd8739ae039 = function() {
    var idRef = (0, $acw62.useRef)(0);
    var cleanUp = function cleanUp() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(idRef.current);
    };
    (0, $acw62.useEffect)(function() {
        return cleanUp;
    }, []);
    return function(callback) {
        cleanUp();
        idRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            callback();
        });
    };
};


var $43533026b471f792$var$_excluded = [
    "prefixCls",
    "className",
    "style",
    "min",
    "max",
    "step",
    "defaultValue",
    "value",
    "disabled",
    "readOnly",
    "upHandler",
    "downHandler",
    "keyboard",
    "changeOnWheel",
    "controls",
    "classNames",
    "stringMode",
    "parser",
    "formatter",
    "precision",
    "decimalSeparator",
    "onChange",
    "onInput",
    "onPressEnter",
    "onStep",
    "changeOnBlur",
    "domRef"
], $43533026b471f792$var$_excluded2 = [
    "disabled",
    "style",
    "prefixCls",
    "value",
    "prefix",
    "suffix",
    "addonBefore",
    "addonAfter",
    "className",
    "classNames"
];
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ var $43533026b471f792$var$getDecimalValue = function getDecimalValue(stringMode, decimalValue) {
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
var $43533026b471f792$var$getDecimalIfValidate = function getDecimalIfValidate(value) {
    var decimal = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(value);
    return decimal.isInvalidate() ? null : decimal;
};
var $43533026b471f792$var$InternalInputNumber = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, min = props.min, max = props.max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, defaultValue = props.defaultValue, value = props.value, disabled = props.disabled, readOnly = props.readOnly, upHandler = props.upHandler, downHandler = props.downHandler, keyboard = props.keyboard, _props$changeOnWheel = props.changeOnWheel, changeOnWheel = _props$changeOnWheel === void 0 ? false : _props$changeOnWheel, _props$controls = props.controls, controls = _props$controls === void 0 ? true : _props$controls, classNames = props.classNames, stringMode = props.stringMode, parser = props.parser, formatter = props.formatter, precision = props.precision, decimalSeparator = props.decimalSeparator, onChange = props.onChange, onInput = props.onInput, onPressEnter = props.onPressEnter, onStep = props.onStep, _props$changeOnBlur = props.changeOnBlur, changeOnBlur = _props$changeOnBlur === void 0 ? true : _props$changeOnBlur, domRef = props.domRef, inputProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $43533026b471f792$var$_excluded);
    var inputClassName = "".concat(prefixCls, "-input");
    var inputRef = $acw62.useRef(null);
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), focus = _React$useState2[0], setFocus = _React$useState2[1];
    var userTypingRef = $acw62.useRef(false);
    var compositionRef = $acw62.useRef(false);
    var shiftKeyRef = $acw62.useRef(false);
    // ============================ Value =============================
    // Real value control
    var _React$useState3 = $acw62.useState(function() {
        return (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(value !== null && value !== void 0 ? value : defaultValue);
    }), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), decimalValue = _React$useState4[0], setDecimalValue = _React$useState4[1];
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ var getPrecision = $acw62.useCallback(function(numStr, userTyping) {
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $c5ec03f2f712ef62$export$2e56483e4ad90ee6)(numStr), (0, $c5ec03f2f712ef62$export$2e56483e4ad90ee6)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    var mergedParser = $acw62.useCallback(function(num) {
        var numStr = String(num);
        if (parser) return parser(numStr);
        var parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, ".");
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, "");
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    var inputValueRef = $acw62.useRef("");
    var mergedFormatter = $acw62.useCallback(function(number, userTyping) {
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        var str = typeof number === "number" ? (0, $c5ec03f2f712ef62$export$fdc98affa95a4322)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            var mergedPrecision = getPrecision(str, userTyping);
            if ((0, $c5ec03f2f712ef62$export$b3d198e17b370bec)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                var separatorStr = decimalSeparator || ".";
                str = (0, $7c447b41ca6024eb$export$a81f732198733497)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ var _React$useState5 = $acw62.useState(function() {
        var initValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value;
        if (decimalValue.isInvalidate() && [
            "string",
            "number"
        ].includes((0, $b8f57191916382d3$export$2e2bcd8739ae039)(initValue))) return Number.isNaN(initValue) ? "" : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    }), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), inputValue = _React$useState6[0], setInternalInputValue = _React$useState6[1];
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    var maxDecimal = $acw62.useMemo(function() {
        return $43533026b471f792$var$getDecimalIfValidate(max);
    }, [
        max,
        precision
    ]);
    var minDecimal = $acw62.useMemo(function() {
        return $43533026b471f792$var$getDecimalIfValidate(min);
    }, [
        min,
        precision
    ]);
    var upDisabled = $acw62.useMemo(function() {
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    var downDisabled = $acw62.useMemo(function() {
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    var _useCursor = (0, $67b09a2610848fb9$export$2e2bcd8739ae039)(inputRef.current, focus), _useCursor2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useCursor, 2), recordCursor = _useCursor2[0], restoreCursor = _useCursor2[1];
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ var getRangeValue = function getRangeValue(target) {
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ var isInRange = function isInRange(target) {
        return !getRangeValue(target);
    };
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ var triggerValueUpdate = function triggerValueUpdate(newValue, userTyping) {
        var updateValue = newValue;
        var isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            var numStr = updateValue.toString();
            var mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)((0, $7c447b41ca6024eb$export$a81f732198733497)(numStr, ".", mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)((0, $7c447b41ca6024eb$export$a81f732198733497)(numStr, ".", mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange === null || onChange === void 0 || onChange(updateValue.isEmpty() ? null : $43533026b471f792$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    var onNextPromise = (0, $d33f9bc38de662bd$export$2e2bcd8739ae039)();
    // >>> Collect input value
    var collectInputValue = function collectInputValue(inputStr) {
        recordCursor();
        // Update inputValue in case input can not parse as number
        // Refresh ref value immediately since it may used by formatter
        inputValueRef.current = inputStr;
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            var finalValue = mergedParser(inputStr);
            var finalDecimal = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want to handle something after onChange
        onInput === null || onInput === void 0 || onInput(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(function() {
            var nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, ".");
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    var onCompositionStart = function onCompositionStart() {
        compositionRef.current = true;
    };
    var onCompositionEnd = function onCompositionEnd() {
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    var onInternalInput = function onInternalInput(e) {
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    var onInternalStep = function onInternalStep(up) {
        var _inputRef$current;
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may be caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        var stepDecimal = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(shiftKeyRef.current ? (0, $4d1f7625d90c1d1d$export$d2883c6c6307c415)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        var target = (decimalValue || (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(0)).add(stepDecimal.toString());
        var updatedValue = triggerValueUpdate(target, false);
        onStep === null || onStep === void 0 || onStep($43533026b471f792$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $4d1f7625d90c1d1d$export$d2883c6c6307c415)(step) : step,
            type: up ? "up" : "down"
        });
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    };
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed.
   * This will always flush input value for update.
   * If it's invalidate, will fallback to last validate value.
   */ var flushInputValue = function flushInputValue(userTyping) {
        var parsedValue = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(mergedParser(inputValue));
        var formatValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = triggerValueUpdate(decimalValue, userTyping);
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    var onBeforeInput = function onBeforeInput() {
        userTypingRef.current = true;
    };
    var onKeyDown = function onKeyDown(event) {
        var key = event.key, shiftKey = event.shiftKey;
        userTypingRef.current = true;
        shiftKeyRef.current = shiftKey;
        if (key === "Enter") {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter === null || onPressEnter === void 0 || onPressEnter(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            "Up",
            "ArrowUp",
            "Down",
            "ArrowDown"
        ].includes(key)) {
            onInternalStep(key === "Up" || key === "ArrowUp");
            event.preventDefault();
        }
    };
    var onKeyUp = function onKeyUp() {
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    $acw62.useEffect(function() {
        if (changeOnWheel && focus) {
            var onWheel = function onWheel(event) {
                // moving mouse wheel rises wheel event with deltaY < 0
                // scroll value grows from top to bottom, as screen Y coordinate
                onInternalStep(event.deltaY < 0);
                event.preventDefault();
            };
            var input = inputRef.current;
            if (input) {
                // React onWheel is passive and we can't preventDefault() in it.
                // That's why we should subscribe with DOM listener
                // https://stackoverflow.com/questions/63663025/react-onwheel-handler-cant-preventdefault-because-its-a-passive-event-listenev
                input.addEventListener("wheel", onWheel, {
                    passive: false
                });
                return function() {
                    return input.removeEventListener("wheel", onWheel);
                };
            }
        }
    });
    // >>> Focus & Blur
    var onBlur = function onBlur() {
        if (changeOnBlur) flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // ========================== Controlled ==========================
    // Input by precision & formatter
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision,
        formatter
    ]);
    // Input by value
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        var newValue = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(value);
        setDecimalValue(newValue);
        var currentParsedValue = (0, $0bbdd0669817c7b1$export$2e2bcd8739ae039)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement("div", {
        ref: domRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-focused"), focus), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-readonly"), readOnly), "".concat(prefixCls, "-not-a-number"), decimalValue.isNaN()), "".concat(prefixCls, "-out-of-range"), !decimalValue.isInvalidate() && !isInRange(decimalValue))),
        style: style,
        onFocus: function onFocus() {
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, controls && /*#__PURE__*/ $acw62.createElement((0, $84412fb75b1f49e4$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        upNode: upHandler,
        downNode: downHandler,
        upDisabled: upDisabled,
        downDisabled: downDisabled,
        onStep: onInternalStep
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(inputClassName, "-wrap")
    }, /*#__PURE__*/ $acw62.createElement("input", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step
    }, inputProps, {
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(inputRef, ref),
        className: inputClassName,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }))));
});
var $43533026b471f792$var$InputNumber = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var disabled = props.disabled, style = props.style, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-input-number" : _props$prefixCls, value = props.value, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, classNames = props.classNames, rest = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $43533026b471f792$var$_excluded2);
    var holderRef = $acw62.useRef(null);
    var inputNumberDomRef = $acw62.useRef(null);
    var inputFocusRef = $acw62.useRef(null);
    var focus = function focus(option) {
        if (inputFocusRef.current) (0, $fd5fdd8da073bd4e$export$2b92016deb0b7aad)(inputFocusRef.current, option);
    };
    $acw62.useImperativeHandle(ref, function() {
        return (0, $1ea42f56aaf074b0$export$2e2bcd8739ae039)(inputFocusRef.current, {
            nativeElement: holderRef.current.nativeElement || inputNumberDomRef.current
        });
    });
    return /*#__PURE__*/ $acw62.createElement((0, $32a5e8fad29dc207$export$2e2bcd8739ae039), {
        className: className,
        triggerFocus: focus,
        prefixCls: prefixCls,
        value: value,
        disabled: disabled,
        style: style,
        prefix: prefix,
        suffix: suffix,
        addonAfter: addonAfter,
        addonBefore: addonBefore,
        classNames: classNames,
        components: {
            affixWrapper: "div",
            groupWrapper: "div",
            wrapper: "div",
            groupAddon: "div"
        },
        ref: holderRef
    }, /*#__PURE__*/ $acw62.createElement($43533026b471f792$var$InternalInputNumber, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        disabled: disabled,
        ref: inputFocusRef,
        domRef: inputNumberDomRef,
        className: classNames === null || classNames === void 0 ? void 0 : classNames.input
    }, rest)));
});
var $43533026b471f792$export$2e2bcd8739ae039 = $43533026b471f792$var$InputNumber;


var $ee1c088b03f012b0$export$2e2bcd8739ae039 = (0, $43533026b471f792$export$2e2bcd8739ae039);




















const $a635cc1b688760e1$export$9ca1be8807fe0675 = (token)=>{
    var _a;
    const handleVisible = (_a = token.handleVisible) !== null && _a !== void 0 ? _a : "auto";
    return Object.assign(Object.assign({}, (0, $500d0ae39d0ead62$export$bd8b682992bc9781)(token)), {
        controlWidth: 90,
        handleWidth: token.controlHeightSM - token.lineWidth * 2,
        handleFontSize: token.fontSize / 2,
        handleVisible: handleVisible,
        handleActiveBg: token.colorFillAlter,
        handleBg: token.colorBgContainer,
        filledHandleBg: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(token.colorFillSecondary).onBackground(token.colorBgContainer).toHexString(),
        handleHoverColor: token.colorPrimary,
        handleBorderColor: token.colorBorder,
        handleOpacity: handleVisible === true ? 1 : 0
    });
};


const $181c953590f6489f$export$b6107fb2af1bfc36 = (_ref, size)=>{
    let { componentCls: componentCls, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG } = _ref;
    const borderRadius = size === "lg" ? borderRadiusLG : borderRadiusSM;
    return {
        [`&-${size}`]: {
            [`${componentCls}-handler-wrap`]: {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            [`${componentCls}-handler-up`]: {
                borderStartEndRadius: borderRadius
            },
            [`${componentCls}-handler-down`]: {
                borderEndEndRadius: borderRadius
            }
        }
    };
};
const $181c953590f6489f$var$genInputNumberStyles = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, borderRadius: borderRadius, inputFontSizeSM: inputFontSizeSM, inputFontSizeLG: inputFontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, colorError: colorError, paddingInlineSM: paddingInlineSM, paddingBlockSM: paddingBlockSM, paddingBlockLG: paddingBlockLG, paddingInlineLG: paddingInlineLG, colorTextDescription: colorTextDescription, motionDurationMid: motionDurationMid, handleHoverColor: handleHoverColor, paddingInline: paddingInline, paddingBlock: paddingBlock, handleBg: handleBg, handleActiveBg: handleActiveBg, colorTextDisabled: colorTextDisabled, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, controlWidth: controlWidth, handleOpacity: handleOpacity, handleBorderColor: handleBorderColor, filledHandleBg: filledHandleBg, lineHeightLG: lineHeightLG, calc: calc } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), (0, $232788b5c0fca573$export$8c9a381315f3ebcd)(token)), {
                display: "inline-block",
                width: controlWidth,
                margin: 0,
                padding: 0,
                borderRadius: borderRadius
            }), (0, $26df503c9b7ea2eb$export$53795bafd774ce02)(token, {
                [`${componentCls}-handler-wrap`]: {
                    background: handleBg,
                    [`${componentCls}-handler-down`]: {
                        borderBlockStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${handleBorderColor}`
                    }
                }
            })), (0, $26df503c9b7ea2eb$export$b8365cd7e6671d79)(token, {
                [`${componentCls}-handler-wrap`]: {
                    background: filledHandleBg,
                    [`${componentCls}-handler-down`]: {
                        borderBlockStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${handleBorderColor}`
                    }
                },
                "&:focus-within": {
                    [`${componentCls}-handler-wrap`]: {
                        background: handleBg
                    }
                }
            })), (0, $26df503c9b7ea2eb$export$b6de5da7f39edfcb)(token)), {
                "&-rtl": {
                    direction: "rtl",
                    [`${componentCls}-input`]: {
                        direction: "rtl"
                    }
                },
                "&-lg": {
                    padding: 0,
                    fontSize: inputFontSizeLG,
                    lineHeight: lineHeightLG,
                    borderRadius: borderRadiusLG,
                    [`input${componentCls}-input`]: {
                        height: calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal(),
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlockLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingInlineLG)}`
                    }
                },
                "&-sm": {
                    padding: 0,
                    fontSize: inputFontSizeSM,
                    borderRadius: borderRadiusSM,
                    [`input${componentCls}-input`]: {
                        height: calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal(),
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlockSM)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingInlineSM)}`
                    }
                },
                // ===================== Out Of Range =====================
                "&-out-of-range": {
                    [`${componentCls}-input-wrap`]: {
                        input: {
                            color: colorError
                        }
                    }
                },
                // Style for input-group: input with label, with button or dropdown...
                "&-group": Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), (0, $232788b5c0fca573$export$ffe8b2a9bd2e5cfe)(token)), {
                    "&-wrapper": Object.assign(Object.assign(Object.assign({
                        display: "inline-block",
                        textAlign: "start",
                        verticalAlign: "top",
                        [`${componentCls}-affix-wrapper`]: {
                            width: "100%"
                        },
                        // Size
                        "&-lg": {
                            [`${componentCls}-group-addon`]: {
                                borderRadius: borderRadiusLG,
                                fontSize: token.fontSizeLG
                            }
                        },
                        "&-sm": {
                            [`${componentCls}-group-addon`]: {
                                borderRadius: borderRadiusSM
                            }
                        }
                    }, (0, $26df503c9b7ea2eb$export$8f88f32c046ff727)(token)), (0, $26df503c9b7ea2eb$export$542c0fce51b1d515)(token)), {
                        // Fix the issue of using icons in Space Compact mode
                        // https://github.com/ant-design/ant-design/issues/45764
                        [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                            [`${componentCls}, ${componentCls}-group-addon`]: {
                                borderRadius: 0
                            }
                        },
                        [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                            [`${componentCls}, ${componentCls}-group-addon`]: {
                                borderStartEndRadius: 0,
                                borderEndEndRadius: 0
                            }
                        },
                        [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                            [`${componentCls}, ${componentCls}-group-addon`]: {
                                borderStartStartRadius: 0,
                                borderEndStartRadius: 0
                            }
                        }
                    })
                }),
                [`&-disabled ${componentCls}-input`]: {
                    cursor: "not-allowed"
                },
                [componentCls]: {
                    "&-input": Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                        width: "100%",
                        padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingInline)}`,
                        textAlign: "start",
                        backgroundColor: "transparent",
                        border: 0,
                        borderRadius: borderRadius,
                        outline: 0,
                        transition: `all ${motionDurationMid} linear`,
                        appearance: "textfield",
                        fontSize: "inherit"
                    }), (0, $232788b5c0fca573$export$92095d0f4c77bd56)(token.colorTextPlaceholder)), {
                        '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
                            margin: 0,
                            webkitAppearance: "none",
                            appearance: "none"
                        }
                    })
                }
            })
        },
        // Handler
        {
            [componentCls]: Object.assign(Object.assign(Object.assign({
                [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
                    opacity: 1
                },
                [`${componentCls}-handler-wrap`]: {
                    position: "absolute",
                    insetBlockStart: 0,
                    insetInlineEnd: 0,
                    width: token.handleWidth,
                    height: "100%",
                    borderStartStartRadius: 0,
                    borderStartEndRadius: borderRadius,
                    borderEndEndRadius: borderRadius,
                    borderEndStartRadius: 0,
                    opacity: handleOpacity,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                    transition: `opacity ${motionDurationMid} linear ${motionDurationMid}`,
                    // Fix input number inside Menu makes icon too large
                    // We arise the selector priority by nest selector here
                    // https://github.com/ant-design/ant-design/issues/14367
                    [`${componentCls}-handler`]: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flex: "auto",
                        height: "40%",
                        [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
                            marginInlineEnd: 0,
                            fontSize: token.handleFontSize
                        }
                    }
                },
                [`${componentCls}-handler`]: {
                    height: "50%",
                    overflow: "hidden",
                    color: colorTextDescription,
                    fontWeight: "bold",
                    lineHeight: 0,
                    textAlign: "center",
                    cursor: "pointer",
                    borderInlineStart: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${handleBorderColor}`,
                    transition: `all ${motionDurationMid} linear`,
                    "&:active": {
                        background: handleActiveBg
                    },
                    // Hover
                    "&:hover": {
                        height: `60%`,
                        [`
              ${componentCls}-handler-up-inner,
              ${componentCls}-handler-down-inner
            `]: {
                            color: handleHoverColor
                        }
                    },
                    "&-up-inner, &-down-inner": Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$171ccda7bc085e59)()), {
                        color: colorTextDescription,
                        transition: `all ${motionDurationMid} linear`,
                        userSelect: "none"
                    })
                },
                [`${componentCls}-handler-up`]: {
                    borderStartEndRadius: borderRadius
                },
                [`${componentCls}-handler-down`]: {
                    borderEndEndRadius: borderRadius
                }
            }, $181c953590f6489f$export$b6107fb2af1bfc36(token, "lg")), $181c953590f6489f$export$b6107fb2af1bfc36(token, "sm")), {
                // Disabled
                "&-disabled, &-readonly": {
                    [`${componentCls}-handler-wrap`]: {
                        display: "none"
                    },
                    [`${componentCls}-input`]: {
                        color: "inherit"
                    }
                },
                [`
          ${componentCls}-handler-up-disabled,
          ${componentCls}-handler-down-disabled
        `]: {
                    cursor: "not-allowed"
                },
                [`
          ${componentCls}-handler-up-disabled:hover &-handler-up-inner,
          ${componentCls}-handler-down-disabled:hover &-handler-down-inner
        `]: {
                    color: colorTextDisabled
                }
            })
        }
    ];
};
const $181c953590f6489f$var$genAffixWrapperStyles = (token)=>{
    const { componentCls: componentCls, paddingBlock: paddingBlock, paddingInline: paddingInline, inputAffixPadding: inputAffixPadding, controlWidth: controlWidth, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, paddingInlineLG: paddingInlineLG, paddingInlineSM: paddingInlineSM, paddingBlockLG: paddingBlockLG, paddingBlockSM: paddingBlockSM } = token;
    return {
        [`${componentCls}-affix-wrapper`]: Object.assign(Object.assign({
            [`input${componentCls}-input`]: {
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlock)} 0`
            }
        }, (0, $232788b5c0fca573$export$8c9a381315f3ebcd)(token)), {
            // or number handler will cover form status
            position: "relative",
            display: "inline-flex",
            width: controlWidth,
            padding: 0,
            paddingInlineStart: paddingInline,
            "&-lg": {
                borderRadius: borderRadiusLG,
                paddingInlineStart: paddingInlineLG,
                [`input${componentCls}-input`]: {
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlockLG)} 0`
                }
            },
            "&-sm": {
                borderRadius: borderRadiusSM,
                paddingInlineStart: paddingInlineSM,
                [`input${componentCls}-input`]: {
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingBlockSM)} 0`
                }
            },
            [`&:not(${componentCls}-disabled):hover`]: {
                zIndex: 1
            },
            "&-focused, &:focus": {
                zIndex: 1
            },
            [`&-disabled > ${componentCls}-disabled`]: {
                background: "transparent"
            },
            [`> div${componentCls}`]: {
                width: "100%",
                border: "none",
                outline: "none",
                [`&${componentCls}-focused`]: {
                    boxShadow: "none !important"
                }
            },
            "&::before": {
                display: "inline-block",
                width: 0,
                visibility: "hidden",
                content: '"\\a0"'
            },
            [`${componentCls}-handler-wrap`]: {
                zIndex: 2
            },
            [componentCls]: {
                color: "inherit",
                "&-prefix, &-suffix": {
                    display: "flex",
                    flex: "none",
                    alignItems: "center",
                    pointerEvents: "none"
                },
                "&-prefix": {
                    marginInlineEnd: inputAffixPadding
                },
                "&-suffix": {
                    position: "absolute",
                    insetBlockStart: 0,
                    insetInlineEnd: 0,
                    zIndex: 1,
                    height: "100%",
                    marginInlineEnd: paddingInline,
                    marginInlineStart: inputAffixPadding
                }
            }
        })
    };
};
var $181c953590f6489f$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("InputNumber", (token)=>{
    const inputNumberToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, (0, $500d0ae39d0ead62$export$a157d95850191a12)(token));
    return [
        $181c953590f6489f$var$genInputNumberStyles(inputNumberToken),
        $181c953590f6489f$var$genAffixWrapperStyles(inputNumberToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $0eabbafc4673511e$export$b1208b23589b4b73)(inputNumberToken)
    ];
}, (0, $a635cc1b688760e1$export$9ca1be8807fe0675), {
    unitless: {
        handleOpacity: true
    }
});


"use client";
var $4ed9156e2babf3c6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4ed9156e2babf3c6$var$InputNumber = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const inputRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>inputRef.current);
    const { className: className, rootClassName: rootClassName, size: customizeSize, disabled: customDisabled, prefixCls: customizePrefixCls, addonBefore: addonBefore, addonAfter: addonAfter, prefix: prefix, bordered: bordered, readOnly: readOnly, status: customStatus, controls: controls, variant: customVariant } = props, others = $4ed9156e2babf3c6$var$__rest(props, [
        "className",
        "rootClassName",
        "size",
        "disabled",
        "prefixCls",
        "addonBefore",
        "addonAfter",
        "prefix",
        "bordered",
        "readOnly",
        "status",
        "controls",
        "variant"
    ]);
    const prefixCls = getPrefixCls("input-number", customizePrefixCls);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $181c953590f6489f$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $26050ef76e24a749$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    let upIcon = /*#__PURE__*/ $acw62.createElement((0, $8ac1c243e74bf2d4$export$2e2bcd8739ae039), {
        className: `${prefixCls}-handler-up-inner`
    });
    let downIcon = /*#__PURE__*/ $acw62.createElement((0, $9387210f6c0d2379$export$2e2bcd8739ae039), {
        className: `${prefixCls}-handler-down-inner`
    });
    const controlsTemp = typeof controls === "boolean" ? controls : undefined;
    if (typeof controls === "object") {
        upIcon = typeof controls.upIcon === "undefined" ? upIcon : /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-handler-up-inner`
        }, controls.upIcon);
        downIcon = typeof controls.downIcon === "undefined" ? downIcon : /*#__PURE__*/ $acw62.createElement("span", {
            className: `${prefixCls}-handler-down-inner`
        }, controls.downIcon);
    }
    const { hasFeedback: hasFeedback, status: contextStatus, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $67f89d06f52454a6$export$314e193082d7ba49)(contextStatus, customStatus);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)((ctx)=>{
        var _a;
        return (_a = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a !== void 0 ? _a : ctx;
    });
    // ===================== Disabled =====================
    const disabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
    const [variant, enableVariantCls] = (0, $ce4103032ab2fd5e$export$2e2bcd8739ae039)("inputNumber", customVariant, bordered);
    /* biome-ignore lint/complexity/noUselessFragments: avoid falsy value */ /* eslint-disable-next-line react/jsx-no-useless-fragment */ const suffixNode = hasFeedback && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, feedbackIcon);
    const inputNumberClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-lg`]: mergedSize === "large",
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, hashId);
    const wrapperClassName = `${prefixCls}-group`;
    const element = /*#__PURE__*/ $acw62.createElement((0, $ee1c088b03f012b0$export$2e2bcd8739ae039), Object.assign({
        ref: inputRef,
        disabled: mergedDisabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(cssVarCls, rootCls, className, rootClassName, compactItemClassnames),
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp,
        prefix: prefix,
        suffix: suffixNode,
        addonBefore: addonBefore && /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            input: inputNumberClass,
            variant: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback)),
            affixWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl"
            }, hashId),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${wrapperClassName}-rtl`]: direction === "rtl"
            }, hashId),
            groupWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-group-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $67f89d06f52454a6$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    }, others));
    return wrapCSSVar(element);
});
const $4ed9156e2babf3c6$var$TypedInputNumber = $4ed9156e2babf3c6$var$InputNumber;
/** @private Internal Component. Do not use in your production. */ const $4ed9156e2babf3c6$var$PureInputNumber = (props)=>/*#__PURE__*/ $acw62.createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        theme: {
            components: {
                InputNumber: {
                    handleVisible: true
                }
            }
        }
    }, /*#__PURE__*/ $acw62.createElement($4ed9156e2babf3c6$var$InputNumber, Object.assign({}, props)));
$4ed9156e2babf3c6$var$TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = $4ed9156e2babf3c6$var$PureInputNumber;
var $4ed9156e2babf3c6$export$2e2bcd8739ae039 = $4ed9156e2babf3c6$var$TypedInputNumber;


var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
function $d9ddb32dfdf86c65$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $d9ddb32dfdf86c65$export$a41628415415e6e(direction, value, min, max) {
    var offset = $d9ddb32dfdf86c65$export$622cea445a1c5b7d(value, min, max);
    var positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = "".concat(offset * 100, "%");
            positionStyle.transform = "translateX(50%)";
            break;
        case "btt":
            positionStyle.bottom = "".concat(offset * 100, "%");
            positionStyle.transform = "translateY(50%)";
            break;
        case "ttb":
            positionStyle.top = "".concat(offset * 100, "%");
            positionStyle.transform = "translateY(-50%)";
            break;
        default:
            positionStyle.left = "".concat(offset * 100, "%");
            positionStyle.transform = "translateX(-50%)";
            break;
    }
    return positionStyle;
}
function $d9ddb32dfdf86c65$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}









var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $d315e37ebd8360d8$var$SliderContext = /*#__PURE__*/ $acw62.createContext({
    min: 0,
    max: 0,
    direction: "ltr",
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true,
    styles: {},
    classNames: {}
});
var $d315e37ebd8360d8$export$2e2bcd8739ae039 = $d315e37ebd8360d8$var$SliderContext;



var $ea6359646810a9a3$var$_excluded = [
    "prefixCls",
    "value",
    "valueIndex",
    "onStartMove",
    "style",
    "render",
    "dragging",
    "onOffsetChange",
    "onChangeComplete",
    "onFocus",
    "onMouseEnter"
];
var $ea6359646810a9a3$var$Handle = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, value = props.value, valueIndex = props.valueIndex, onStartMove = props.onStartMove, style = props.style, render = props.render, dragging = props.dragging, onOffsetChange = props.onOffsetChange, onChangeComplete = props.onChangeComplete, onFocus = props.onFocus, onMouseEnter = props.onMouseEnter, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $ea6359646810a9a3$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, disabled = _React$useContext.disabled, keyboard = _React$useContext.keyboard, range = _React$useContext.range, tabIndex = _React$useContext.tabIndex, ariaLabelForHandle = _React$useContext.ariaLabelForHandle, ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle, styles = _React$useContext.styles, classNames = _React$useContext.classNames;
    var handlePrefixCls = "".concat(prefixCls, "-handle");
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled) onStartMove(e, valueIndex);
    };
    var onInternalFocus = function onInternalFocus(e) {
        onFocus === null || onFocus === void 0 || onFocus(e, valueIndex);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(e) {
        onMouseEnter(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    var onKeyDown = function onKeyDown(e) {
        if (!disabled && keyboard) {
            var offset = null;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT:
                    offset = direction === "ltr" || direction === "btt" ? -1 : 1;
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === "ltr" || direction === "btt" ? 1 : -1;
                    break;
                // Up is plus
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP:
                    offset = direction !== "ttb" ? 1 : -1;
                    break;
                // Down is minus
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== "ttb" ? -1 : 1;
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).HOME:
                    offset = "min";
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).END:
                    offset = "max";
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    var handleKeyUp = function handleKeyUp(e) {
        switch(e.which || e.keyCode){
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).HOME:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).END:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).PAGE_UP:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).PAGE_DOWN:
                onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete();
                break;
        }
    };
    // ============================ Offset ============================
    var positionStyle = (0, $d9ddb32dfdf86c65$export$a41628415415e6e)(direction, value, min, max);
    // ============================ Render ============================
    var divProps = {};
    if (valueIndex !== null) {
        var _getIndex;
        divProps = {
            tabIndex: disabled ? null : (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(tabIndex, valueIndex),
            role: "slider",
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-disabled": disabled,
            "aria-label": (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
            "aria-labelledby": (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
            "aria-valuetext": (_getIndex = (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value),
            "aria-orientation": direction === "ltr" || direction === "rtl" ? "horizontal" : "vertical",
            onMouseDown: onInternalStartMove,
            onTouchStart: onInternalStartMove,
            onFocus: onInternalFocus,
            onMouseEnter: onInternalMouseEnter,
            onKeyDown: onKeyDown,
            onKeyUp: handleKeyUp
        };
    }
    var handleNode = /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(handlePrefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), valueIndex !== null && range), "".concat(handlePrefixCls, "-dragging"), dragging), classNames.handle),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, positionStyle), style), styles.handle)
    }, divProps, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging
    });
    return handleNode;
});
var $ea6359646810a9a3$export$2e2bcd8739ae039 = $ea6359646810a9a3$var$Handle;


var $33124806a04337b6$var$_excluded = [
    "prefixCls",
    "style",
    "onStartMove",
    "onOffsetChange",
    "values",
    "handleRender",
    "activeHandleRender",
    "draggingIndex",
    "onFocus"
];
var $33124806a04337b6$var$Handles = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, onStartMove = props.onStartMove, onOffsetChange = props.onOffsetChange, values = props.values, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, draggingIndex = props.draggingIndex, onFocus = props.onFocus, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $33124806a04337b6$var$_excluded);
    var handlesRef = $acw62.useRef({});
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus(index) {
                var _handlesRef$current$i;
                (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
            }
        };
    });
    // =========================== Active ===========================
    var _React$useState = $acw62.useState(-1), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var onHandleFocus = function onHandleFocus(e, index) {
        setActiveIndex(index);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var onHandleMouseEnter = function onHandleMouseEnter(e, index) {
        setActiveIndex(index);
    };
    // =========================== Render ===========================
    // Handle Props
    var handleProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        onStartMove: onStartMove,
        onOffsetChange: onOffsetChange,
        render: handleRender,
        onFocus: onHandleFocus,
        onMouseEnter: onHandleMouseEnter
    }, restProps);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, values.map(function(value, index) {
        return /*#__PURE__*/ $acw62.createElement((0, $ea6359646810a9a3$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            ref: function ref(node) {
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: draggingIndex === index,
            style: (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index
        }, handleProps));
    }), activeHandleRender && /*#__PURE__*/ $acw62.createElement((0, $ea6359646810a9a3$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        key: "a11y"
    }, handleProps, {
        value: values[activeIndex],
        valueIndex: null,
        dragging: draggingIndex !== -1,
        render: activeHandleRender,
        style: {
            pointerEvents: "none"
        },
        tabIndex: null,
        "aria-hidden": true
    })));
});
var $33124806a04337b6$export$2e2bcd8739ae039 = $33124806a04337b6$var$Handles;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


var $63cea05a8409ada9$var$Mark = function Mark(props) {
    var prefixCls = props.prefixCls, style = props.style, children = props.children, value = props.value, _onClick = props.onClick;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd, included = _React$useContext.included;
    var textCls = "".concat(prefixCls, "-text");
    // ============================ Offset ============================
    var positionStyle = (0, $d9ddb32dfdf86c65$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(textCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: function onMouseDown(e) {
            e.stopPropagation();
        },
        onClick: function onClick() {
            _onClick(value);
        }
    }, children);
};
var $63cea05a8409ada9$export$2e2bcd8739ae039 = $63cea05a8409ada9$var$Mark;


var $6c5dd54af2d2fb84$var$Marks = function Marks(props) {
    var prefixCls = props.prefixCls, marks = props.marks, onClick = props.onClick;
    var markPrefixCls = "".concat(prefixCls, "-mark");
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: markPrefixCls
    }, marks.map(function(_ref) {
        var value = _ref.value, style = _ref.style, label = _ref.label;
        return /*#__PURE__*/ $acw62.createElement((0, $63cea05a8409ada9$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label);
    }));
};
var $6c5dd54af2d2fb84$export$2e2bcd8739ae039 = $6c5dd54af2d2fb84$var$Marks;



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $5bd80ee77bd33d65$var$Dot = function Dot(props) {
    var prefixCls = props.prefixCls, value = props.value, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, included = _React$useContext.included, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd;
    var dotClassName = "".concat(prefixCls, "-dot");
    var active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    var mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $d9ddb32dfdf86c65$export$a41628415415e6e)(direction, value, min, max)), typeof style === "function" ? style(value) : style);
    if (active) mergedStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, mergedStyle), typeof activeStyle === "function" ? activeStyle(value) : activeStyle);
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(dotClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(dotClassName, "-active"), active)),
        style: mergedStyle
    });
};
var $5bd80ee77bd33d65$export$2e2bcd8739ae039 = $5bd80ee77bd33d65$var$Dot;


var $64ef0293c8d9c7de$var$Steps = function Steps(props) {
    var prefixCls = props.prefixCls, marks = props.marks, dots = props.dots, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), min = _React$useContext.min, max = _React$useContext.max, step = _React$useContext.step;
    var stepDots = $acw62.useMemo(function() {
        var dotSet = new Set();
        // Add marks
        marks.forEach(function(mark) {
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            var current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, stepDots.map(function(dotValue) {
        return /*#__PURE__*/ $acw62.createElement((0, $5bd80ee77bd33d65$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        });
    }));
};
var $64ef0293c8d9c7de$export$2e2bcd8739ae039 = $64ef0293c8d9c7de$var$Steps;





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


var $f96b888bd5109383$var$Track = function Track(props) {
    var prefixCls = props.prefixCls, style = props.style, start = props.start, end = props.end, index = props.index, onStartMove = props.onStartMove, replaceCls = props.replaceCls;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), direction = _React$useContext.direction, min = _React$useContext.min, max = _React$useContext.max, disabled = _React$useContext.disabled, range = _React$useContext.range, classNames = _React$useContext.classNames;
    var trackPrefixCls = "".concat(prefixCls, "-track");
    var offsetStart = (0, $d9ddb32dfdf86c65$export$622cea445a1c5b7d)(start, min, max);
    var offsetEnd = (0, $d9ddb32dfdf86c65$export$622cea445a1c5b7d)(end, min, max);
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    var positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case "btt":
            positionStyle.bottom = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case "ttb":
            positionStyle.top = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        default:
            positionStyle.left = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
    }
    var className = replaceCls || (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(trackPrefixCls, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(trackPrefixCls, "-").concat(index + 1), index !== null && range), "".concat(prefixCls, "-track-draggable"), onStartMove), classNames.track);
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: className,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
};
var $f96b888bd5109383$export$2e2bcd8739ae039 = $f96b888bd5109383$var$Track;


var $b2dccf24aa11036a$var$Tracks = function Tracks(props) {
    var prefixCls = props.prefixCls, style = props.style, values = props.values, startPoint = props.startPoint, onStartMove = props.onStartMove;
    var _React$useContext = $acw62.useContext((0, $d315e37ebd8360d8$export$2e2bcd8739ae039)), included = _React$useContext.included, range = _React$useContext.range, min = _React$useContext.min, styles = _React$useContext.styles, classNames = _React$useContext.classNames;
    // =========================== List ===========================
    var trackList = $acw62.useMemo(function() {
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
            var endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        var list = [];
        for(var i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    if (!included) return null;
    // ========================== Render ==========================
    var tracksNode = classNames.tracks || styles.tracks ? /*#__PURE__*/ $acw62.createElement((0, $f96b888bd5109383$export$2e2bcd8739ae039), {
        index: null,
        prefixCls: prefixCls,
        start: trackList[0].start,
        end: trackList[trackList.length - 1].end,
        replaceCls: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classNames.tracks, "".concat(prefixCls, "-tracks")),
        style: styles.tracks
    }) : null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, tracksNode, trackList.map(function(_ref, index) {
        var start = _ref.start, end = _ref.end;
        return /*#__PURE__*/ $acw62.createElement((0, $f96b888bd5109383$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, (0, $d9ddb32dfdf86c65$export$ddfa24987dade61b)(style, index)), styles.track),
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        });
    }));
};
var $b2dccf24aa11036a$export$2e2bcd8739ae039 = $b2dccf24aa11036a$var$Tracks;







var $acw62 = parcelRequire("acw62");
function $4f3717c6c62f79f1$var$getPosition(e) {
    var obj = "touches" in e ? e.touches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $4f3717c6c62f79f1$var$useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues) {
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), draggingValue = _React$useState2[0], setDraggingValue = _React$useState2[1];
    var _React$useState3 = $acw62.useState(-1), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), draggingIndex = _React$useState4[0], setDraggingIndex = _React$useState4[1];
    var _React$useState5 = $acw62.useState(rawValues), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), cacheValues = _React$useState6[0], setCacheValues = _React$useState6[1];
    var _React$useState7 = $acw62.useState(rawValues), _React$useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState7, 2), originValues = _React$useState8[0], setOriginValues = _React$useState8[1];
    var mouseMoveEventRef = $acw62.useRef(null);
    var mouseUpEventRef = $acw62.useRef(null);
    $acw62.useLayoutEffect(function() {
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    $acw62.useEffect(function() {
        return function() {
            document.removeEventListener("mousemove", mouseMoveEventRef.current);
            document.removeEventListener("mouseup", mouseUpEventRef.current);
            document.removeEventListener("touchmove", mouseMoveEventRef.current);
            document.removeEventListener("touchend", mouseUpEventRef.current);
        };
    }, []);
    var flushValues = function flushValues(nextValues, nextValue) {
        // Perf: Only update state when value changed
        if (cacheValues.some(function(val, i) {
            return val !== nextValues[i];
        })) {
            if (nextValue !== undefined) setDraggingValue(nextValue);
            setCacheValues(nextValues);
            triggerChange(nextValues);
        }
    };
    var updateCacheValue = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function(valueIndex, offsetPercent) {
        // Basic point offset
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            var startValue = originValues[0];
            var endValue = originValues[originValues.length - 1];
            var maxStartOffset = min - startValue;
            var maxEndOffset = max - endValue;
            // Get valid offset
            var offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            var formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            var cloneCacheValues = originValues.map(function(val) {
                return val + offset;
            });
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            var offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            var cloneValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cacheValues);
            cloneValues[valueIndex] = originValues[valueIndex];
            var next = offsetValues(cloneValues, offsetDist, valueIndex, "dist");
            flushValues(next.values, next.value);
        }
    });
    var onStartMove = function onStartMove(e, valueIndex, startValues) {
        e.stopPropagation();
        // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
        var initialValues = startValues || rawValues;
        var originValue = initialValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(initialValues);
        var _getPosition = $4f3717c6c62f79f1$var$getPosition(e), startX = _getPosition.pageX, startY = _getPosition.pageY;
        // Moving
        var onMouseMove = function onMouseMove(event) {
            event.preventDefault();
            var _getPosition2 = $4f3717c6c62f79f1$var$getPosition(event), moveX = _getPosition2.pageX, moveY = _getPosition2.pageY;
            var offsetX = moveX - startX;
            var offsetY = moveY - startY;
            var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
            var offSetPercent;
            switch(direction){
                case "btt":
                    offSetPercent = -offsetY / height;
                    break;
                case "ttb":
                    offSetPercent = offsetY / height;
                    break;
                case "rtl":
                    offSetPercent = -offsetX / width;
                    break;
                default:
                    offSetPercent = offsetX / width;
            }
            updateCacheValue(valueIndex, offSetPercent);
        };
        // End
        var onMouseUp = function onMouseUp(event) {
            event.preventDefault();
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("touchend", onMouseUp);
            document.removeEventListener("touchmove", onMouseMove);
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            setDraggingIndex(-1);
            finishChange();
        };
        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("touchend", onMouseUp);
        document.addEventListener("touchmove", onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
    };
    // Only return cache value when it mapping with rawValues
    var returnValues = $acw62.useMemo(function() {
        var sourceValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rawValues).sort(function(a, b) {
            return a - b;
        });
        var targetValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cacheValues).sort(function(a, b) {
            return a - b;
        });
        return sourceValues.every(function(val, index) {
            return val === targetValues[index];
        }) ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues
    ]);
    return [
        draggingIndex,
        draggingValue,
        returnValues,
        onStartMove
    ];
}
var $4f3717c6c62f79f1$export$2e2bcd8739ae039 = $4f3717c6c62f79f1$var$useDrag;




var $acw62 = parcelRequire("acw62");
function $32bdf9f49cee13d8$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable) {
    var formatRangeValue = $acw62.useCallback(function(val) {
        return Math.max(min, Math.min(max, val));
    }, [
        min,
        max
    ]);
    var formatStepValue = $acw62.useCallback(function(val) {
        if (step !== null) {
            var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            var getDecimal = function getDecimal(num) {
                return (String(num).split(".")[1] || "").length;
            };
            var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            var fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    var formatValue = $acw62.useCallback(function(val) {
        var formatNextValue = formatRangeValue(val);
        // List align values
        var alignValues = markList.map(function(mark) {
            return mark.value;
        });
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        var closeValue = alignValues[0];
        var closeDist = max - min;
        alignValues.forEach(function(alignValue) {
            var dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    var offsetValue = function offsetValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        if (typeof offset === "number") {
            var nextValue;
            var originValue = values[valueIndex];
            // Only used for `dist` mode
            var targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            var potentialValues = [];
            markList.forEach(function(mark) {
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            var sign = offset > 0 ? 1 : -1;
            if (mode === "unit") potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter(function(val) {
                return val !== null;
            })// Remove reverse value
            .filter(function(val) {
                return offset < 0 ? val <= originValue : val >= originValue;
            });
            if (mode === "unit") // `unit` mode can not contain itself
            potentialValues = potentialValues.filter(function(val) {
                return val !== originValue;
            });
            var compareValue = mode === "unit" ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            var valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach(function(potentialValue) {
                var dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === "dist") return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                var cloneValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(values);
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === "min") return min;
        else if (offset === "max") return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        var originValue = values[valueIndex];
        var nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    var needPush = function needPush(dist) {
        return pushable === null && dist === 0 || typeof pushable === "number" && dist < pushable;
    };
    // Values
    var offsetValues = function offsetValues(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "unit";
        var nextValues = values.map(formatValue);
        var originValue = nextValues[valueIndex];
        var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            var pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === "number" || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(var i = valueIndex + 1; i < nextValues.length; i += 1){
                var changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed){
                    var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
                    nextValues[i] = _offsetChangedValue.value;
                    changed = _offsetChangedValue.changed;
                }
            }
            // Start values
            for(var _i = valueIndex; _i > 0; _i -= 1){
                var _changed = true;
                while(needPush(nextValues[_i] - nextValues[_i - 1]) && _changed){
                    var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
                    nextValues[_i - 1] = _offsetChangedValue2.value;
                    _changed = _offsetChangedValue2.changed;
                }
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1){
                var _changed2 = true;
                while(needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2){
                    var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
                    nextValues[_i2 - 1] = _offsetChangedValue3.value;
                    _changed2 = _offsetChangedValue3.changed;
                }
            }
            // Start to End
            for(var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1){
                var _changed3 = true;
                while(needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3){
                    var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
                    nextValues[_i3 + 1] = _offsetChangedValue4.value;
                    _changed3 = _offsetChangedValue4.changed;
                }
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}


/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */ var $981acad438e43c15$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-slider" : _props$prefixCls, className = props.className, style = props.style, classNames = props.classNames, styles = props.styles, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, autoFocus = props.autoFocus, onFocus = props.onFocus, onBlur = props.onBlur, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, value = props.value, defaultValue = props.defaultValue, range = props.range, count = props.count, onChange = props.onChange, onBeforeChange = props.onBeforeChange, onAfterChange = props.onAfterChange, onChangeComplete = props.onChangeComplete, _props$allowCross = props.allowCross, allowCross = _props$allowCross === void 0 ? true : _props$allowCross, _props$pushable = props.pushable, pushable = _props$pushable === void 0 ? false : _props$pushable, draggableTrack = props.draggableTrack, reverse = props.reverse, vertical = props.vertical, _props$included = props.included, included = _props$included === void 0 ? true : _props$included, startPoint = props.startPoint, trackStyle = props.trackStyle, handleStyle = props.handleStyle, railStyle = props.railStyle, dotStyle = props.dotStyle, activeDotStyle = props.activeDotStyle, marks = props.marks, dots = props.dots, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, ariaLabelForHandle = props.ariaLabelForHandle, ariaLabelledByForHandle = props.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
    var handlesRef = $acw62.useRef(null);
    var containerRef = $acw62.useRef(null);
    var direction = $acw62.useMemo(function() {
        if (vertical) return reverse ? "ttb" : "btt";
        return reverse ? "rtl" : "ltr";
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    var mergedMin = $acw62.useMemo(function() {
        return isFinite(min) ? min : 0;
    }, [
        min
    ]);
    var mergedMax = $acw62.useMemo(function() {
        return isFinite(max) ? max : 100;
    }, [
        max
    ]);
    // ============================= Step =============================
    var mergedStep = $acw62.useMemo(function() {
        return step !== null && step <= 0 ? 1 : step;
    }, [
        step
    ]);
    // ============================= Push =============================
    var mergedPush = $acw62.useMemo(function() {
        if (typeof pushable === "boolean") return pushable ? mergedStep : false;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    var markList = $acw62.useMemo(function() {
        return Object.keys(marks || {}).map(function(key) {
            var mark = marks[key];
            var markObj = {
                value: Number(key)
            };
            if (mark && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(mark) === "object" && !/*#__PURE__*/ $acw62.isValidElement(mark) && ("label" in mark || "style" in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(function(_ref) {
            var label = _ref.label;
            return label || typeof label === "number";
        }).sort(function(a, b) {
            return a.value - b.value;
        });
    }, [
        marks
    ]);
    // ============================ Format ============================
    var _useOffset = (0, $32bdf9f49cee13d8$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush), _useOffset2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useOffset, 2), formatValue = _useOffset2[0], offsetValues = _useOffset2[1];
    // ============================ Values ============================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var rawValues = $acw62.useMemo(function() {
        var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        var _valueList = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(valueList, 1), _valueList$ = _valueList[0], val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
        var returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (range) {
            returnValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(valueList);
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                var pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount){
                    var _returnValues;
                    returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
                }
            }
            returnValues.sort(function(a, b) {
                return a - b;
            });
        }
        // Align in range
        returnValues.forEach(function(val, index) {
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        range,
        mergedMin,
        count,
        formatValue
    ]);
    // =========================== onChange ===========================
    var rawValuesRef = $acw62.useRef(rawValues);
    rawValuesRef.current = rawValues;
    var getTriggerValue = function getTriggerValue(triggerValues) {
        return range ? triggerValues : triggerValues[0];
    };
    var triggerChange = function triggerChange(nextValues) {
        // Order first
        var cloneNextValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(nextValues).sort(function(a, b) {
            return a - b;
        });
        // Trigger event if needed
        if (onChange && !(0, $357adc8667cde522$export$2e2bcd8739ae039)(cloneNextValues, rawValuesRef.current, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    };
    var finishChange = function finishChange() {
        var finishValue = getTriggerValue(rawValuesRef.current);
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(finishValue);
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!onAfterChange, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.");
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(finishValue);
    };
    var _useDrag = (0, $4f3717c6c62f79f1$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues), _useDrag2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useDrag, 4), draggingIndex = _useDrag2[0], draggingValue = _useDrag2[1], cacheValues = _useDrag2[2], onStartDrag = _useDrag2[3];
    var changeToCloseValue = function changeToCloseValue(newValue, e) {
        if (!disabled) {
            var valueIndex = 0;
            var valueDist = mergedMax - mergedMin;
            rawValues.forEach(function(val, index) {
                var dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
            });
            // Create new values
            var cloneNextValues = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(rawValues);
            cloneNextValues[valueIndex] = newValue;
            // Fill value to match default 2
            if (range && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
            triggerChange(cloneNextValues);
            if (e) {
                var _document$activeEleme, _document$activeEleme2;
                (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
                handlesRef.current.focus(valueIndex);
                onStartDrag(e, valueIndex, cloneNextValues);
            }
        }
    };
    // ============================ Click =============================
    var onSliderMouseDown = function onSliderMouseDown(e) {
        e.preventDefault();
        var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height, left = _containerRef$current.left, top = _containerRef$current.top, bottom = _containerRef$current.bottom, right = _containerRef$current.right;
        var clientX = e.clientX, clientY = e.clientY;
        var percent;
        switch(direction){
            case "btt":
                percent = (bottom - clientY) / height;
                break;
            case "ttb":
                percent = (clientY - top) / height;
                break;
            case "rtl":
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        var nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue), e);
    };
    // =========================== Keyboard ===========================
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), keyboardValue = _React$useState2[0], setKeyboardValue = _React$useState2[1];
    var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
        if (!disabled) {
            var next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
            triggerChange(next.values);
            setKeyboardValue(next.value);
        }
    };
    $acw62.useEffect(function() {
        if (keyboardValue !== null) {
            var valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    var mergedDraggableTrack = $acw62.useMemo(function() {
        if (draggableTrack && mergedStep === null) return false;
        return draggableTrack;
    }, [
        draggableTrack,
        mergedStep
    ]);
    var onStartMove = function onStartMove(e, valueIndex) {
        onStartDrag(e, valueIndex);
        onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValuesRef.current));
    };
    // Auto focus for updated handle
    var dragging = draggingIndex !== -1;
    $acw62.useEffect(function() {
        if (!dragging) {
            var valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    var sortedCacheValues = $acw62.useMemo(function() {
        return (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(cacheValues).sort(function(a, b) {
            return a - b;
        });
    }, [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    var _React$useMemo = $acw62.useMemo(function() {
        if (!range) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        range,
        mergedMin
    ]), _React$useMemo2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useMemo, 2), includedStart = _React$useMemo2[0], includedEnd = _React$useMemo2[1];
    // ============================= Refs =============================
    $acw62.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                handlesRef.current.focus(0);
            },
            blur: function blur() {
                var _containerRef$current2;
                var _document = document, activeElement = _document.activeElement;
                if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(activeElement)) activeElement === null || activeElement === void 0 || activeElement.blur();
            }
        };
    });
    // ========================== Auto Focus ==========================
    $acw62.useEffect(function() {
        if (autoFocus) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    var context = $acw62.useMemo(function() {
        return {
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            keyboard: keyboard,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: range,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
            styles: styles || {},
            classNames: classNames || {}
        };
    }, [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        range,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaValueTextFormatterForHandle,
        styles,
        classNames
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $acw62.createElement((0, $d315e37ebd8360d8$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-vertical"), vertical), "".concat(prefixCls, "-horizontal"), !vertical), "".concat(prefixCls, "-with-marks"), markList.length)),
        style: style,
        onMouseDown: onSliderMouseDown
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-rail"), classNames === null || classNames === void 0 ? void 0 : classNames.rail),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, railStyle), styles === null || styles === void 0 ? void 0 : styles.rail)
    }), /*#__PURE__*/ $acw62.createElement((0, $b2dccf24aa11036a$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: sortedCacheValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : undefined
    }), /*#__PURE__*/ $acw62.createElement((0, $64ef0293c8d9c7de$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $acw62.createElement((0, $33124806a04337b6$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: finishChange
    }), /*#__PURE__*/ $acw62.createElement((0, $6c5dd54af2d2fb84$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
var $981acad438e43c15$export$2e2bcd8739ae039 = $981acad438e43c15$var$Slider;


var $8913456de870b864$export$2e2bcd8739ae039 = (0, $981acad438e43c15$export$2e2bcd8739ae039);







var $acw62 = parcelRequire("acw62");



"use client";
const $df2ee388cfcac8e5$var$SliderTooltip = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { open: open } = props;
    const innerRef = (0, $acw62.useRef)(null);
    const rafRef = (0, $acw62.useRef)(null);
    function cancelKeepAlign() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(()=>{
            var _a;
            (_a = innerRef.current) === null || _a === void 0 || _a.forceAlign();
            rafRef.current = null;
        });
    }
    $acw62.useEffect(()=>{
        if (open) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        open,
        props.title
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({
        ref: (0, $5e297877593af644$export$ab452c34e8e05029)(innerRef, ref)
    }, props));
});
var $df2ee388cfcac8e5$export$2e2bcd8739ae039 = $df2ee388cfcac8e5$var$SliderTooltip;






// =============================== Base ===============================
const $b1e18c6ab4b00b96$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlSize: controlSize, dotSize: dotSize, marginFull: marginFull, marginPart: marginPart, colorFillContentHover: colorFillContentHover, handleColorDisabled: handleColorDisabled, calc: calc, handleSize: handleSize, handleSizeHover: handleSizeHover, handleActiveColor: handleActiveColor, handleActiveOutlineColor: handleActiveOutlineColor, handleLineWidth: handleLineWidth, handleLineWidthHover: handleLineWidthHover, motionDurationMid: motionDurationMid } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "relative",
            height: controlSize,
            margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(marginPart)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(marginFull)}`,
            padding: 0,
            cursor: "pointer",
            touchAction: "none",
            "&-vertical": {
                margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(marginFull)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(marginPart)}`
            },
            [`${componentCls}-rail`]: {
                position: "absolute",
                backgroundColor: token.railBg,
                borderRadius: token.borderRadiusXS,
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track,${componentCls}-tracks`]: {
                position: "absolute",
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track`]: {
                backgroundColor: token.trackBg,
                borderRadius: token.borderRadiusXS
            },
            [`${componentCls}-track-draggable`]: {
                boxSizing: "content-box",
                backgroundClip: "content-box",
                border: "solid rgba(0,0,0,0)"
            },
            "&:hover": {
                [`${componentCls}-rail`]: {
                    backgroundColor: token.railHoverBg
                },
                [`${componentCls}-track`]: {
                    backgroundColor: token.trackHoverBg
                },
                [`${componentCls}-dot`]: {
                    borderColor: colorFillContentHover
                },
                [`${componentCls}-handle::after`]: {
                    boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(handleLineWidth)} ${token.colorPrimaryBorderHover}`
                },
                [`${componentCls}-dot-active`]: {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`${componentCls}-handle`]: {
                position: "absolute",
                width: handleSize,
                height: handleSize,
                outline: "none",
                // 扩大选区
                "&::before": {
                    content: '""',
                    position: "absolute",
                    insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
                    insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
                    width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    backgroundColor: "transparent"
                },
                "&::after": {
                    content: '""',
                    position: "absolute",
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: handleSize,
                    height: handleSize,
                    backgroundColor: token.colorBgElevated,
                    boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(handleLineWidth)} ${token.handleColor}`,
                    outline: `0px solid transparent`,
                    borderRadius: "50%",
                    cursor: "pointer",
                    transition: `
            inset-inline-start ${motionDurationMid},
            inset-block-start ${motionDurationMid},
            width ${motionDurationMid},
            height ${motionDurationMid},
            box-shadow ${motionDurationMid},
            outline ${motionDurationMid}
          `
                },
                "&:hover, &:active, &:focus": {
                    "&::before": {
                        insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
                        height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
                    },
                    "&::after": {
                        boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(handleLineWidthHover)} ${handleActiveColor}`,
                        outline: `6px solid ${handleActiveOutlineColor}`,
                        width: handleSizeHover,
                        height: handleSizeHover,
                        insetInlineStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal(),
                        insetBlockStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal()
                    }
                }
            },
            [`&-lock ${componentCls}-handle`]: {
                "&::before, &::after": {
                    transition: "none"
                }
            },
            [`${componentCls}-mark`]: {
                position: "absolute",
                fontSize: token.fontSize
            },
            [`${componentCls}-mark-text`]: {
                position: "absolute",
                display: "inline-block",
                color: token.colorTextDescription,
                textAlign: "center",
                wordBreak: "keep-all",
                cursor: "pointer",
                userSelect: "none",
                "&-active": {
                    color: token.colorText
                }
            },
            [`${componentCls}-step`]: {
                position: "absolute",
                background: "transparent",
                pointerEvents: "none"
            },
            [`${componentCls}-dot`]: {
                position: "absolute",
                width: dotSize,
                height: dotSize,
                backgroundColor: token.colorBgElevated,
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(handleLineWidth)} solid ${token.dotBorderColor}`,
                borderRadius: "50%",
                cursor: "pointer",
                transition: `border-color ${token.motionDurationSlow}`,
                pointerEvents: "auto",
                "&-active": {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`&${componentCls}-disabled`]: {
                cursor: "not-allowed",
                [`${componentCls}-rail`]: {
                    backgroundColor: `${token.railBg} !important`
                },
                [`${componentCls}-track`]: {
                    backgroundColor: `${token.trackBgDisabled} !important`
                },
                [`
          ${componentCls}-dot
        `]: {
                    backgroundColor: token.colorBgElevated,
                    borderColor: token.trackBgDisabled,
                    boxShadow: "none",
                    cursor: "not-allowed"
                },
                [`${componentCls}-handle::after`]: {
                    backgroundColor: token.colorBgElevated,
                    cursor: "not-allowed",
                    width: handleSize,
                    height: handleSize,
                    boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(handleLineWidth)} ${handleColorDisabled}`,
                    insetInlineStart: 0,
                    insetBlockStart: 0
                },
                [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
                    cursor: `not-allowed !important`
                }
            },
            [`&-tooltip ${antCls}-tooltip-inner`]: {
                minWidth: "unset"
            }
        })
    };
};
// ============================ Horizontal ============================
const $b1e18c6ab4b00b96$var$genDirectionStyle = (token, horizontal)=>{
    const { componentCls: componentCls, railSize: railSize, handleSize: handleSize, dotSize: dotSize, marginFull: marginFull, calc: calc } = token;
    const railPadding = horizontal ? "paddingBlock" : "paddingInline";
    const full = horizontal ? "width" : "height";
    const part = horizontal ? "height" : "width";
    const handlePos = horizontal ? "insetBlockStart" : "insetInlineStart";
    const markInset = horizontal ? "top" : "insetInlineStart";
    const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
    const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
    const draggableBorder = horizontal ? {
        borderWidth: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(draggableBorderSize)} 0`,
        transform: `translateY(${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(draggableBorderSize).mul(-1).equal())})`
    } : {
        borderWidth: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(draggableBorderSize)}`,
        transform: `translateX(${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(draggableBorderSize).mul(-1).equal())})`
    };
    return {
        [railPadding]: railSize,
        [part]: calc(railSize).mul(3).equal(),
        [`${componentCls}-rail`]: {
            [full]: "100%",
            [part]: railSize
        },
        [`${componentCls}-track,${componentCls}-tracks`]: {
            [part]: railSize
        },
        [`${componentCls}-track-draggable`]: Object.assign({}, draggableBorder),
        [`${componentCls}-handle`]: {
            [handlePos]: handlePosSize
        },
        [`${componentCls}-mark`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            // https://github.com/ant-design/ant-design/issues/43731
            [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
            [full]: "100%"
        },
        [`${componentCls}-step`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            [markInset]: railSize,
            [full]: "100%",
            [part]: railSize
        },
        [`${componentCls}-dot`]: {
            position: "absolute",
            [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
        }
    };
};
// ============================ Horizontal ============================
const $b1e18c6ab4b00b96$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, marginPartWithMark: marginPartWithMark } = token;
    return {
        [`${componentCls}-horizontal`]: Object.assign(Object.assign({}, $b1e18c6ab4b00b96$var$genDirectionStyle(token, true)), {
            [`&${componentCls}-with-marks`]: {
                marginBottom: marginPartWithMark
            }
        })
    };
};
// ============================= Vertical =============================
const $b1e18c6ab4b00b96$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-vertical`]: Object.assign(Object.assign({}, $b1e18c6ab4b00b96$var$genDirectionStyle(token, false)), {
            height: "100%"
        })
    };
};
const $b1e18c6ab4b00b96$export$9ca1be8807fe0675 = (token)=>{
    // Handle line width is always width-er 1px
    const increaseHandleWidth = 1;
    const controlSize = token.controlHeightLG / 4;
    const controlSizeHover = token.controlHeightSM / 2;
    const handleLineWidth = token.lineWidth + increaseHandleWidth;
    const handleLineWidthHover = token.lineWidth + increaseHandleWidth * 1.5;
    const handleActiveColor = token.colorPrimary;
    const handleActiveOutlineColor = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(handleActiveColor).setAlpha(0.2).toRgbString();
    return {
        controlSize: controlSize,
        railSize: 4,
        handleSize: controlSize,
        handleSizeHover: controlSizeHover,
        dotSize: 8,
        handleLineWidth: handleLineWidth,
        handleLineWidthHover: handleLineWidthHover,
        railBg: token.colorFillTertiary,
        railHoverBg: token.colorFillSecondary,
        trackBg: token.colorPrimaryBorder,
        trackHoverBg: token.colorPrimaryBorderHover,
        handleColor: token.colorPrimaryBorder,
        handleActiveColor: handleActiveColor,
        handleActiveOutlineColor: handleActiveOutlineColor,
        handleColorDisabled: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(token.colorTextDisabled).onBackground(token.colorBgContainer).toHexShortString(),
        dotBorderColor: token.colorBorderSecondary,
        dotActiveBorderColor: token.colorPrimaryBorder,
        trackBgDisabled: token.colorBgContainerDisabled
    };
};
var $b1e18c6ab4b00b96$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Slider", (token)=>{
    const sliderToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        marginPart: token.calc(token.controlHeight).sub(token.controlSize).div(2).equal(),
        marginFull: token.calc(token.controlSize).div(2).equal(),
        marginPartWithMark: token.calc(token.controlHeightLG).sub(token.controlSize).equal()
    });
    return [
        $b1e18c6ab4b00b96$var$genBaseStyle(sliderToken),
        $b1e18c6ab4b00b96$var$genHorizontalStyle(sliderToken),
        $b1e18c6ab4b00b96$var$genVerticalStyle(sliderToken)
    ];
}, $b1e18c6ab4b00b96$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");

function $c0be84c2d683561f$export$2e2bcd8739ae039() {
    const [state, setState] = $acw62.useState(false);
    const rafRef = $acw62.useRef();
    const cleanup = ()=>{
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    const setDelayState = (nextState)=>{
        cleanup();
        if (nextState) setState(nextState);
        else rafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(()=>{
            setState(nextState);
        });
    };
    $acw62.useEffect(()=>cleanup, []);
    return [
        state,
        setDelayState
    ];
}


"use client";
var $3e379b7d04954998$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $3e379b7d04954998$var$getTipFormatter(tipFormatter, legacyTipFormatter) {
    if (tipFormatter || tipFormatter === null) return tipFormatter;
    if (legacyTipFormatter || legacyTipFormatter === null) return legacyTipFormatter;
    return (val)=>typeof val === "number" ? val.toString() : "";
}
const $3e379b7d04954998$var$Slider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, range: range, className: className, rootClassName: rootClassName, style: style, disabled: disabled, // Deprecated Props
    tooltipPrefixCls: legacyTooltipPrefixCls, tipFormatter: legacyTipFormatter, tooltipVisible: legacyTooltipVisible, getTooltipPopupContainer: legacyGetTooltipPopupContainer, tooltipPlacement: legacyTooltipPlacement, tooltip: tooltip = {}, onChangeComplete: onChangeComplete } = props, restProps = $3e379b7d04954998$var$__rest(props, [
        "prefixCls",
        "range",
        "className",
        "rootClassName",
        "style",
        "disabled",
        "tooltipPrefixCls",
        "tipFormatter",
        "tooltipVisible",
        "getTooltipPopupContainer",
        "tooltipPlacement",
        "tooltip",
        "onChangeComplete"
    ]);
    const { vertical: vertical } = props;
    const { direction: direction, slider: slider, getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer } = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const mergedDisabled = disabled !== null && disabled !== void 0 ? disabled : contextDisabled;
    // =============================== Open ===============================
    const [hoverOpen, setHoverOpen] = (0, $c0be84c2d683561f$export$2e2bcd8739ae039)();
    const [focusOpen, setFocusOpen] = (0, $c0be84c2d683561f$export$2e2bcd8739ae039)();
    const tooltipProps = Object.assign({}, tooltip);
    const { open: tooltipOpen, placement: tooltipPlacement, getPopupContainer: getTooltipPopupContainer, prefixCls: customizeTooltipPrefixCls, formatter: tipFormatter } = tooltipProps;
    const lockOpen = tooltipOpen !== null && tooltipOpen !== void 0 ? tooltipOpen : legacyTooltipVisible;
    const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
    const mergedTipFormatter = $3e379b7d04954998$var$getTipFormatter(tipFormatter, legacyTipFormatter);
    // ============================= Change ==============================
    const [dragging, setDragging] = (0, $c0be84c2d683561f$export$2e2bcd8739ae039)();
    const onInternalChangeComplete = (nextValues)=>{
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(nextValues);
        setDragging(false);
    };
    // ============================ Placement ============================
    const getTooltipPlacement = (placement, vert)=>{
        if (placement) return placement;
        if (!vert) return "top";
        return direction === "rtl" ? "left" : "right";
    };
    // ============================== Style ===============================
    const prefixCls = getPrefixCls("slider", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $b1e18c6ab4b00b96$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, slider === null || slider === void 0 ? void 0 : slider.className, rootClassName, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-lock`]: dragging
    }, hashId, cssVarCls);
    // make reverse default on rtl direction
    if (direction === "rtl" && !restProps.vertical) restProps.reverse = !restProps.reverse;
    // ============================= Multiple =============================
    // Range config
    const [mergedRange, draggableTrack] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!range) return [
            false
        ];
        return typeof range === "object" ? [
            true,
            range.draggableTrack
        ] : [
            true,
            false
        ];
    }, [
        range
    ]);
    var _ref;
    // ============================== Handle ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const onMouseUp = ()=>{
            // Delay for 1 frame to make the click to enable hide tooltip
            // even when the handle is focused
            (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(()=>{
                setFocusOpen(false);
            }, 1);
        };
        document.addEventListener("mouseup", onMouseUp);
        return ()=>{
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, []);
    const useActiveTooltipHandle = mergedRange && !lockOpen;
    const handleRender = (node, info)=>{
        const { index: index } = info;
        const nodeProps = node.props;
        const passedProps = Object.assign(Object.assign({}, nodeProps), {
            onMouseEnter: (e)=>{
                var _a;
                setHoverOpen(true);
                (_a = nodeProps.onMouseEnter) === null || _a === void 0 || _a.call(nodeProps, e);
            },
            onMouseLeave: (e)=>{
                var _a;
                setHoverOpen(false);
                (_a = nodeProps.onMouseLeave) === null || _a === void 0 || _a.call(nodeProps, e);
            },
            onMouseDown: (e)=>{
                var _a;
                setFocusOpen(true);
                setDragging(true);
                (_a = nodeProps.onMouseDown) === null || _a === void 0 || _a.call(nodeProps, e);
            },
            onFocus: (e)=>{
                var _a, _b;
                setFocusOpen(true);
                (_a = restProps.onFocus) === null || _a === void 0 || _a.call(restProps, e);
                (_b = nodeProps.onFocus) === null || _b === void 0 || _b.call(nodeProps, e);
            },
            onBlur: (e)=>{
                var _a, _b;
                setFocusOpen(false);
                (_a = restProps.onBlur) === null || _a === void 0 || _a.call(restProps, e);
                (_b = nodeProps.onBlur) === null || _b === void 0 || _b.call(nodeProps, e);
            }
        });
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(node, passedProps);
        const open = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
        // Wrap on handle with Tooltip when is single mode or multiple with all show tooltip
        if (!useActiveTooltipHandle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df2ee388cfcac8e5$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
            prefixCls: getPrefixCls("tooltip", customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : "",
            open: open,
            placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
            key: index,
            overlayClassName: `${prefixCls}-tooltip`,
            getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer
        }), cloneNode);
        return cloneNode;
    };
    // ========================== Active Handle ===========================
    const activeHandleRender = useActiveTooltipHandle ? (handle, info)=>{
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(handle, {
            style: Object.assign(Object.assign({}, handle.props.style), {
                visibility: "hidden"
            })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $df2ee388cfcac8e5$export$2e2bcd8739ae039), Object.assign({}, tooltipProps, {
            prefixCls: getPrefixCls("tooltip", customizeTooltipPrefixCls !== null && customizeTooltipPrefixCls !== void 0 ? customizeTooltipPrefixCls : legacyTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : "",
            open: mergedTipFormatter !== null && activeOpen,
            placement: getTooltipPlacement(tooltipPlacement !== null && tooltipPlacement !== void 0 ? tooltipPlacement : legacyTooltipPlacement, vertical),
            key: "tooltip",
            overlayClassName: `${prefixCls}-tooltip`,
            getPopupContainer: getTooltipPopupContainer || legacyGetTooltipPopupContainer || getPopupContainer
        }), cloneNode);
    } : undefined;
    // ============================== Render ==============================
    const mergedStyle = Object.assign(Object.assign({}, slider === null || slider === void 0 ? void 0 : slider.style), style);
    return wrapCSSVar(/*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8913456de870b864$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        step: restProps.step,
        range: mergedRange,
        draggableTrack: draggableTrack,
        className: cls,
        style: mergedStyle,
        disabled: mergedDisabled,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: onInternalChangeComplete
    })));
});
var $3e379b7d04954998$export$2e2bcd8739ae039 = $3e379b7d04954998$var$Slider;



var $acw62 = parcelRequire("acw62");



const $fa2410c2c2e8d257$var$TestTrainSplitComponent = (props)=>{
    const [checkedList, setCheckedList] = (0, $acw62.useState)([]);
    const [targetVariable, setTargetVariable] = (0, $acw62.useState)(props.data.targetFeature);
    const [targetVariableOptions, setTargetVariableOptions] = (0, $acw62.useState)(props.data.df_columns);
    const [testSize, setTestSize] = (0, $acw62.useState)(props.data.testSize);
    const handleOnChangeFeatures = (e)=>{
        const newFeature = e.target.value;
        const isChecked = e.target.checked;
        const actionType = isChecked ? "select_feature" : "deselect_feature";
        const updatedCheckedList = isChecked ? [
            ...checkedList,
            newFeature
        ] : checkedList.filter((item)=>item !== newFeature);
        setCheckedList(updatedCheckedList);
        props.data.setSelectedFeatures(updatedCheckedList);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)(actionType, {
            featureName: newFeature,
            AllSelectedFeatures: updatedCheckedList
        });
    };
    const handleOnChangeTarget = (value)=>{
        props.data.setTargetVariable(value);
        setTargetVariable(value);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_target_variable", {
            targetVariable: value
        });
    };
    const HandleOnTestSizeChange = (newValue)=>{
        if (newValue) props.data.setTestSize(newValue);
        setTestSize(newValue);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_test_size_ratio", {
            testSize: newValue
        });
    };
    (0, $acw62.useEffect)(()=>{
        setTestSize(props.data.testSize);
    }, [
        props.data.testSize
    ]);
    (0, $acw62.useEffect)(()=>{
        setTargetVariable(props.data.targetFeature || "Choose Variable");
    }, [
        props.data.targetFeature
    ]);
    (0, $acw62.useEffect)(()=>{
        setCheckedList(props.data.selectedFeatures);
    }, [
        props.data.selectedFeatures
    ]);
    (0, $acw62.useEffect)(()=>{
        const newOptions = props.data.df_columns.filter((option)=>!checkedList.includes(option) || checkedList.length === 0);
        setTargetVariableOptions(newOptions);
    }, [
        props.data.df_columns,
        checkedList
    ]);
    (0, $acw62.useEffect)(()=>{
        const listContainers = document.querySelectorAll(".featuresCheckboxList");
        (0, $cfadb87391ca5e26$export$b71d81bfaeb967a6)(listContainers);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        theme: {
            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), {
            spinning: props.data.isLoading,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                        className: "topBottomDivider"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c7119f916fc54765$export$2e2bcd8739ae039), {
                        gap: ".5rem",
                        className: "mainControlContainer",
                        onPointerDown: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "selectFeaturesContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                        className: "testTrainSplitHeader",
                                        children: "Features"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "featuresCheckboxList",
                                        children: props.data.df_columns.map((option, index)=>{
                                            const disabled = option === targetVariable;
                                            const isChecked = checkedList.includes(option);
                                            const title = disabled ? "Target variable cannot be a feature" : isChecked ? "Remove feature" : "Add feature";
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                                                name: `select ${title} feature`,
                                                value: option,
                                                title: title,
                                                disabled: disabled,
                                                onChange: handleOnChangeFeatures,
                                                checked: disabled ? false : checkedList.includes(option),
                                                children: option
                                            }, index);
                                        })
                                    }),
                                    props.data.errorMessages.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "featuresErrorWindow",
                                        children: props.data.errorMessages.map((message, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                style: {
                                                    fontStyle: "italic"
                                                },
                                                children: [
                                                    `> `,
                                                    message
                                                ]
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                type: "vertical",
                                style: {
                                    height: "100%",
                                    marginInline: "0"
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "selectTargetContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "halfContainer targetVariableContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "testTrainSplitHeader",
                                                children: "Target Variable"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                className: "selectDropDown",
                                                onChange: handleOnChangeTarget,
                                                value: targetVariable,
                                                tabIndex: 0,
                                                listHeight: 800,
                                                dropdownStyle: {
                                                    width: "max-content",
                                                    minWidth: "175px"
                                                },
                                                options: targetVariableOptions.map((option)=>{
                                                    let disabled = option === targetVariable;
                                                    return {
                                                        value: option,
                                                        disabled: disabled,
                                                        title: disabled ? `${option} already selected` : `Set ${option} as target variable`
                                                    };
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                        style: {
                                            margin: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "halfContainer testSizeRatioContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                className: "testTrainSplitHeader",
                                                children: "Test Size Ratio"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2dcdaeaf17c3bbb2$export$2e2bcd8739ae039), {
                                                        className: "inputNumberRow",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed9156e2babf3c6$export$2e2bcd8739ae039), {
                                                            name: "testSizeRatioInput",
                                                            min: 0.05,
                                                            max: 1,
                                                            step: 0.05,
                                                            style: {
                                                                margin: "0 16px",
                                                                width: "70px"
                                                            },
                                                            value: testSize,
                                                            onChange: HandleOnTestSizeChange,
                                                            className: "testSizeInput"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2dcdaeaf17c3bbb2$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e379b7d04954998$export$2e2bcd8739ae039), {
                                                            min: 0.05,
                                                            max: 1,
                                                            step: 0.05,
                                                            onChange: HandleOnTestSizeChange,
                                                            defaultValue: testSize,
                                                            value: typeof testSize === "number" ? testSize : 0,
                                                            style: {
                                                                width: "100%"
                                                            },
                                                            tooltip: {
                                                                placement: "bottom",
                                                                autoAdjustOverflow: false,
                                                                className: "sliderTooltip"
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                        className: "topBottomDivider"
                    })
                ]
            })
        })
    });
};
var $fa2410c2c2e8d257$export$2e2bcd8739ae039 = $fa2410c2c2e8d257$var$TestTrainSplitComponent;








var $acw62 = parcelRequire("acw62");
const $d248ed2e4a3b2340$var$DataframeLoaderComponent = (props)=>{
    (0, $acw62.useEffect)(()=>{
        if (props.data.loadingStatus === "success") props.data.context.markTaskAsCompleted("loadDataframeSuccess");
    }, [
        props.data.loadingStatus
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), {
            wrapperClassName: "dataframeLoadingOverlay",
            size: "default",
            spinning: props.data.loadingStatus === "loading",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "dataframeLoadingContainer",
                children: [
                    (props.data.loadingStatus === "error" || props.data.loadingStatus === "initial") && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        children: props.data.messages.map((message, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    "> ",
                                    message
                                ]
                            }, index))
                    }),
                    props.data.loadingStatus === "success" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                        className: "successDfMessage",
                        children: [
                            ">",
                            " Dataframe created \u2713"
                        ]
                    })
                ]
            })
        })
    });
};
var $d248ed2e4a3b2340$export$2e2bcd8739ae039 = $d248ed2e4a3b2340$var$DataframeLoaderComponent;








var $acw62 = parcelRequire("acw62");



const $4dbc11826bd4bc44$var$LinearRegressionSettingsComponent = (props)=>{
    const { initialFitIntercept: initialFitIntercept, initialCopyX: initialCopyX, initialPositive: initialPositive, updateFitIntercept: updateFitIntercept, updateCopyX: updateCopyX, updatePositive: updatePositive } = props.data;
    const [fitIntercept, setFitIntercept] = (0, $acw62.useState)(initialFitIntercept);
    const [copyX, setCopyX] = (0, $acw62.useState)(initialCopyX);
    const [positive, setPositive] = (0, $acw62.useState)(initialPositive);
    const handleFitInterceptChange = (checked)=>{
        setFitIntercept(checked);
        updateFitIntercept(checked);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_fit_intercept", {
            fit_intercept: checked
        });
    };
    const handleCopyXChange = (checked)=>{
        setCopyX(checked);
        updateCopyX(checked);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_copy_x", {
            copy_X: checked
        });
    };
    const handlePositiveChange = (checked)=>{
        setPositive(checked);
        updatePositive(checked);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_force_positive_coefficients", {
            force_positive_coefficients: checked
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "linearRegressionSettingsContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c24bb3319861fe36$export$b48985bba8f530f5).NoDrag, {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                size: "middle",
                direction: "vertical",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelSwitchContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Include Intercept"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40b6a897f33a99d9$export$2e2bcd8739ae039), {
                                checked: fitIntercept,
                                onChange: handleFitInterceptChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelSwitchContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Copy Input Data"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40b6a897f33a99d9$export$2e2bcd8739ae039), {
                                checked: copyX,
                                onChange: handleCopyXChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelSwitchContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Force Positive Coefficients"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40b6a897f33a99d9$export$2e2bcd8739ae039), {
                                checked: positive,
                                onChange: handlePositiveChange
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $4dbc11826bd4bc44$export$2e2bcd8739ae039 = $4dbc11826bd4bc44$var$LinearRegressionSettingsComponent;









var $acw62 = parcelRequire("acw62");



const $d4d9c0f4e6482781$var$solverOptions = [
    {
        value: "liblinear",
        label: "liblinear"
    },
    {
        value: "newton-cg",
        label: "newton-cg"
    },
    {
        value: "lbfgs",
        label: "lbfgs"
    },
    {
        value: "sag",
        label: "sag"
    },
    {
        value: "saga",
        label: "saga"
    }
];
const $d4d9c0f4e6482781$var$penaltyOptions = [
    {
        value: "l1",
        label: "l1"
    },
    {
        value: "l2",
        label: "l2"
    },
    {
        value: "elasticnet",
        label: "elasticnet"
    },
    {
        value: "none",
        label: "none"
    }
];
const $d4d9c0f4e6482781$var$delayFunction = (fn, ms)=>{
    let timer = null;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(()=>{
            fn(...args);
        }, ms);
    };
};
const $d4d9c0f4e6482781$var$delayNumberInputLog = $d4d9c0f4e6482781$var$delayFunction((type, context)=>(0, $14e68cbe3c2b3085$export$83fc28f458189523)(type, context), 1000);
const $d4d9c0f4e6482781$var$LogisticRegressionSettingsComponent = (props)=>{
    const { initialSolver: initialSolver, initialPenalty: initialPenalty, initialC: initialC, initialMaxIter: initialMaxIter, initialL1Ratio: initialL1Ratio, updateL1Ratio: updateL1Ratio, updateSolver: updateSolver, updatePenalty: updatePenalty, updateC: updateC, updateMaxIter: updateMaxIter } = props.data;
    const [solver, setSolver] = (0, $acw62.useState)(initialSolver);
    const [penalty, setPenalty] = (0, $acw62.useState)(initialPenalty);
    const [C, setC] = (0, $acw62.useState)(initialC);
    const [maxIter, setMaxIter] = (0, $acw62.useState)(initialMaxIter);
    const [l1Ratio, setL1Ratio] = (0, $acw62.useState)(initialL1Ratio);
    const handleCChange = (value)=>{
        if (value !== null) {
            setC(value);
            updateC(value);
        }
        $d4d9c0f4e6482781$var$delayNumberInputLog("set_regularization_strength", {
            regularization_strength: value
        });
    };
    const handleMaxIterChange = (value)=>{
        if (value !== null) {
            setMaxIter(value);
            updateMaxIter(value);
        }
        $d4d9c0f4e6482781$var$delayNumberInputLog("set_max_iterations", {
            max_iterations: value
        });
    };
    const handleL1RatioChange = (value)=>{
        if (value !== null) {
            setL1Ratio(value);
            updateL1Ratio(value);
        }
        $d4d9c0f4e6482781$var$delayNumberInputLog("set_l1_ratio", {
            l1_ratio: value
        });
    };
    const handleSolverChange = (value)=>{
        setSolver(value);
        updateSolver(value);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_solver_type", {
            solver_type: value
        });
    };
    const handlePenaltyChange = (value)=>{
        setPenalty(value);
        updatePenalty(value);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_penalty_type", {
            penalty_type: value
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "logisticRegressionSettingsContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c24bb3319861fe36$export$b48985bba8f530f5).NoDrag, {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                size: "middle",
                direction: "vertical",
                align: "end",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Solver"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                defaultValue: solver,
                                onChange: handleSolverChange,
                                dropdownStyle: {
                                    width: "max-content"
                                },
                                options: $d4d9c0f4e6482781$var$solverOptions.map((option)=>({
                                        value: option.value,
                                        label: option.label,
                                        title: `Select ${option.label}`
                                    }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Penalty"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                defaultValue: penalty,
                                onChange: handlePenaltyChange,
                                dropdownStyle: {
                                    width: "max-content"
                                },
                                options: $d4d9c0f4e6482781$var$penaltyOptions.map((option)=>({
                                        value: option.value,
                                        label: option.label,
                                        title: `Select ${option.label}`
                                    }))
                            })
                        ]
                    }),
                    penalty === "elasticnet" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "L1 Ratio"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed9156e2babf3c6$export$2e2bcd8739ae039), {
                                name: "l1RatioInput",
                                min: 0,
                                max: 1,
                                step: 0.1,
                                value: l1Ratio,
                                onChange: handleL1RatioChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Reg Strength (C)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed9156e2babf3c6$export$2e2bcd8739ae039), {
                                name: "regStrengthInput",
                                min: 0.01,
                                max: 1000,
                                step: 0.01,
                                defaultValue: C,
                                onChange: handleCChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "labelContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                children: "Max Iterations"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed9156e2babf3c6$export$2e2bcd8739ae039), {
                                name: "maxIterationsInput",
                                min: 1,
                                max: 10000,
                                defaultValue: maxIter,
                                onChange: handleMaxIterChange
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $d4d9c0f4e6482781$export$2e2bcd8739ae039 = $d4d9c0f4e6482781$var$LogisticRegressionSettingsComponent;







var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
function $9ffe1c2756854ba4$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = $acw62.useState(value);
    $acw62.useEffect(()=>{
        const timeout = setTimeout(()=>{
            setCacheValue(value);
        }, value.length ? 0 : 10);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    return cacheValue;
}






const $b632032085440de2$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`,
            "&-appear, &-enter": {
                opacity: 0,
                "&-active": {
                    opacity: 1
                }
            },
            "&-leave": {
                opacity: 1,
                "&-active": {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: "hidden",
                transition: `height ${token.motionDurationSlow} ${token.motionEaseInOut},
                     opacity ${token.motionDurationSlow} ${token.motionEaseInOut},
                     transform ${token.motionDurationSlow} ${token.motionEaseInOut} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    "&-active": {
                        transform: "translateY(0)",
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $b632032085440de2$export$2e2bcd8739ae039 = $b632032085440de2$var$genFormValidateMotionStyle;


const $3f17b93d805dc813$var$resetForm = (token)=>({
        legend: {
            display: "block",
            width: "100%",
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: "inherit",
            border: 0,
            borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: "border-box"
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: "normal"
        },
        'input[type="file"]': {
            display: "block"
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: "block",
            width: "100%"
        },
        // Make multiple select elements height not fixed
        "select[multiple], select[size]": {
            height: "auto"
        },
        // Focus for file, radio, and checkbox
        [`input[type='file']:focus,
  input[type='radio']:focus,
  input[type='checkbox']:focus`]: {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: "block",
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $3f17b93d805dc813$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $3f17b93d805dc813$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [token.componentCls]: Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), $3f17b93d805dc813$var$resetForm(token)), {
            [`${componentCls}-text`]: {
                display: "inline-block",
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            "&-small": Object.assign({}, $3f17b93d805dc813$var$genFormSize(token, token.controlHeightSM)),
            "&-large": Object.assign({}, $3f17b93d805dc813$var$genFormSize(token, token.controlHeightLG))
        })
    };
};
const $3f17b93d805dc813$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, componentCls: componentCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    return {
        [formItemCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            marginBottom: itemMarginBottom,
            verticalAlign: "top",
            "&-with-help": {
                transition: "none"
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: "none"
            },
            "&-has-warning": {
                [`${formItemCls}-split`]: {
                    color: token.colorError
                }
            },
            "&-has-error": {
                [`${formItemCls}-split`]: {
                    color: token.colorWarning
                }
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textAlign: "end",
                verticalAlign: "middle",
                "&-left": {
                    textAlign: "start"
                },
                "&-wrap": {
                    overflow: "unset",
                    lineHeight: token.lineHeight,
                    whiteSpace: "unset"
                },
                "> label": {
                    position: "relative",
                    display: "inline-flex",
                    alignItems: "center",
                    maxWidth: "100%",
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: "top"
                    },
                    // Required mark
                    [`&${formItemCls}-required:not(${formItemCls}-required-mark-optional)::before`]: {
                        display: "inline-block",
                        marginInlineEnd: token.marginXXS,
                        color: labelRequiredMarkColor,
                        fontSize: token.fontSize,
                        fontFamily: "SimSun, sans-serif",
                        lineHeight: 1,
                        content: '"*"',
                        [`${componentCls}-hide-required-mark &`]: {
                            display: "none"
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: "inline-block",
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`${componentCls}-hide-required-mark &`]: {
                            display: "none"
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: "help",
                        writingMode: "horizontal-tb",
                        marginInlineStart: token.marginXXS
                    },
                    "&::after": {
                        content: '":"',
                        position: "relative",
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                ["--ant-display"]: "flex",
                flexDirection: "column",
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: "100%"
                },
                "&-input": {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    minHeight: token.controlHeight,
                    "&-content": {
                        flex: "auto",
                        maxWidth: "100%",
                        lineHeight: "100%"
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                "&-explain, &-extra": {
                    clear: "both",
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                "&-explain-connected": {
                    width: "100%"
                },
                "&-extra": {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                "&-explain": {
                    "&-error": {
                        color: token.colorError
                    },
                    "&-warning": {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: "auto",
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: "center",
                visibility: "visible",
                animationName: (0, $d2082114d5952afb$export$3b71758b3ed5255f),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: "none",
                "&-success": {
                    color: token.colorSuccess
                },
                "&-error": {
                    color: token.colorError
                },
                "&-warning": {
                    color: token.colorWarning
                },
                "&-validating": {
                    color: token.colorPrimary
                }
            }
        })
    };
};
const $3f17b93d805dc813$var$genHorizontalStyle = (token, className)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [`${className}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: "1 1 0",
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: "unset"
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: "flex",
            flexWrap: "wrap",
            [formItemCls]: {
                flex: "none",
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                "&-row": {
                    flexWrap: "nowrap"
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: "inline-block",
                    verticalAlign: "top"
                },
                [`> ${formItemCls}-label`]: {
                    flex: "none"
                },
                [`${componentCls}-text`]: {
                    display: "inline-block"
                },
                [`${formItemCls}-has-feedback`]: {
                    display: "inline-block"
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: "initial",
        textAlign: "start",
        "> label": {
            margin: 0,
            "&::after": {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: "hidden"
            }
        }
    });
const $3f17b93d805dc813$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: "wrap",
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: "0 0 100%",
                        maxWidth: "100%"
                    }
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                [`${formItemCls}-row`]: {
                    flexDirection: "column"
                },
                [`${formItemCls}-label > label`]: {
                    height: "auto"
                },
                [`${formItemCls}-control`]: {
                    width: "100%"
                },
                [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $3f17b93d805dc813$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $3f17b93d805dc813$var$genItemVerticalStyle = (token)=>{
    const { formItemCls: formItemCls, antCls: antCls } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: "column"
            },
            [`${formItemCls}-label > label`]: {
                height: "auto"
            },
            [`${formItemCls}-control`]: {
                width: "100%"
            }
        },
        [`${formItemCls}-vertical ${formItemCls}-label,
      ${antCls}-col-24${formItemCls}-label,
      ${antCls}-col-xl-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token),
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $3f17b93d805dc813$var$makeVerticalLayout(token),
            {
                [formItemCls]: {
                    [`${antCls}-col-xs-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
                }
            }
        ],
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-sm-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-md-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        },
        [`@media (max-width: ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [formItemCls]: {
                [`${antCls}-col-lg-24${formItemCls}-label`]: $3f17b93d805dc813$var$makeVerticalLayoutLabel(token)
            }
        }
    };
};
const $3f17b93d805dc813$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $3f17b93d805dc813$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $3f17b93d805dc813$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Form", (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const formToken = $3f17b93d805dc813$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $3f17b93d805dc813$var$genFormStyle(formToken),
        $3f17b93d805dc813$var$genFormItemStyle(formToken),
        (0, $b632032085440de2$export$2e2bcd8739ae039)(formToken),
        $3f17b93d805dc813$var$genHorizontalStyle(formToken, formToken.componentCls),
        $3f17b93d805dc813$var$genHorizontalStyle(formToken, formToken.formItemCls),
        $3f17b93d805dc813$var$genInlineStyle(formToken),
        $3f17b93d805dc813$var$genVerticalStyle(formToken),
        $3f17b93d805dc813$var$genItemVerticalStyle(formToken),
        (0, $8eae2cab6b8e600b$export$2e2bcd8739ae039)(formToken),
        (0, $d2082114d5952afb$export$3b71758b3ed5255f)
    ];
}, $3f17b93d805dc813$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});


"use client";
const $2cd7502dce089e1a$var$EMPTY_LIST = [];
function $2cd7502dce089e1a$var$toErrorEntity(error, prefix, errorStatus) {
    let index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return {
        key: typeof error === "string" ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $2cd7502dce089e1a$var$ErrorList = (_ref)=>{
    let { help: help, helpStatus: helpStatus, errors: errors = $2cd7502dce089e1a$var$EMPTY_LIST, warnings: warnings = $2cd7502dce089e1a$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged } = _ref;
    const { prefixCls: prefixCls } = $acw62.useContext((0, $ad5d550b51ac8abd$export$fb6582d3042cc879));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3f17b93d805dc813$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const collapseMotion = (0, $acw62.useMemo)(()=>(0, $2efb522a5615f01e$export$2e2bcd8739ae039)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(warnings);
    const fullKeyList = $acw62.useMemo(()=>{
        if (help !== undefined && help !== null) return [
            $2cd7502dce089e1a$var$toErrorEntity(help, "help", helpStatus)
        ];
        return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(debounceErrors.map((error, index)=>$2cd7502dce089e1a$var$toErrorEntity(error, "error", "error", index))), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(debounceWarnings.map((warning, index)=>$2cd7502dce089e1a$var$toErrorEntity(warning, "warning", "warning", index))));
    }, [
        help,
        helpStatus,
        debounceErrors,
        debounceWarnings
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!fullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, helpProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(baseClassName, holderClassName, cssVarCls, rootCls, rootClassName, hashId),
            style: holderStyle,
            role: "alert"
        }), /*#__PURE__*/ $acw62.createElement((0, $ab0f5c5a9767e13d$export$2e2bcd8739ae039), Object.assign({
            keys: fullKeyList
        }, (0, $2efb522a5615f01e$export$2e2bcd8739ae039)(prefixCls), {
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }), (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $acw62.createElement("div", {
                key: key,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemClassName, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: itemStyle
            }, error);
        }));
    }));
};
var $2cd7502dce089e1a$export$2e2bcd8739ae039 = $2cd7502dce089e1a$var$ErrorList;



var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


const $a135099456a3a66d$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $a135099456a3a66d$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $a135099456a3a66d$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $a135099456a3a66d$var$e(o.overflowY, n) || $a135099456a3a66d$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $a135099456a3a66d$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $a135099456a3a66d$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $a135099456a3a66d$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$a135099456a3a66d$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $a135099456a3a66d$var$t(W) && p(W);){
        if (W = $a135099456a3a66d$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $a135099456a3a66d$var$n(W) && !$a135099456a3a66d$var$n(document.documentElement) || null != W && $a135099456a3a66d$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: n, width: l, top: r, right: i, bottom: s, left: d } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r && I <= s && R >= d && C <= i) return L;
        const h = getComputedStyle(e), a = parseInt(h.borderLeftWidth, 10), g = parseInt(h.borderTopWidth, 10), p = parseInt(h.borderRightWidth, 10), W = parseInt(h.borderBottomWidth, 10);
        let T = 0, B = 0;
        const F = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - a - p : 0, V = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - g - W : 0, S = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : l / e.offsetWidth : 0, X = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : n / e.offsetHeight : 0;
        if (m === e) T = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $a135099456a3a66d$var$o(M, M + H, H, g, W, M + k, M + k + v, v) : k - H / 2, B = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $a135099456a3a66d$var$o(y, y + b, b, a, p, y + D, y + D + E, E), T = Math.max(0, T + M), B = Math.max(0, B + y);
        else {
            T = "start" === f ? k - r - g : "end" === f ? k - s + W + V : "nearest" === f ? $a135099456a3a66d$var$o(r, s, n, g, W + V, k, k + v, v) : k - (r + n / 2) + V / 2, B = "start" === u ? D - d - a : "center" === u ? D - (d + l / 2) + F / 2 : "end" === u ? D - i + p + F : $a135099456a3a66d$var$o(d, i, l, a, p + F, D, D + E, E);
            const { scrollLeft: t, scrollTop: h } = e;
            T = 0 === X ? 0 : Math.max(0, Math.min(h + T / X, e.scrollHeight - n / X + V)), B = 0 === S ? 0 : Math.max(0, Math.min(t + B / S, e.scrollWidth - l / S + F)), k += h - T, D += t - B;
        }
        L.push({
            el: e,
            top: T,
            left: B
        });
    }
    return L;
};


const $b26c6e29c94de039$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $b26c6e29c94de039$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $a135099456a3a66d$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $a135099456a3a66d$export$3b12cb22b12b954b)(e, $b26c6e29c94de039$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}


// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $43291396832d20f3$var$formItemNameBlackList = [
    "parentNode"
];
// default form item id prefix.
const $43291396832d20f3$var$defaultItemNamePrefixCls = "form_item";
function $43291396832d20f3$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $43291396832d20f3$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join("_");
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $43291396832d20f3$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$43291396832d20f3$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $43291396832d20f3$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = "validating";
    else if (errors.length) status = "error";
    else if (warnings.length) status = "warning";
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = "success";
    return status;
}


function $4c36311913591211$var$toNamePathStr(name) {
    const namePath = (0, $43291396832d20f3$export$45b10814cc054894)(name);
    return namePath.join("_");
}
function $4c36311913591211$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $808ab7b8a87ab771$export$9aa546fdc20ae5b3)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $43291396832d20f3$export$f4457e83c74ac000)((0, $43291396832d20f3$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $4c36311913591211$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $a1708dc7c20669c0$export$2e2bcd8739ae039)();
    const itemsRef = $acw62.useRef({});
    const wrapForm = $acw62.useMemo(()=>form !== null && form !== void 0 ? form : Object.assign(Object.assign({}, rcForm), {
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $4c36311913591211$var$toNamePathStr(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: function(name) {
                let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                const node = $4c36311913591211$var$getFieldDOMNode(name, wrapForm);
                if (node) (0, $b26c6e29c94de039$export$2e2bcd8739ae039)(node, Object.assign({
                    scrollMode: "if-needed",
                    block: "nearest"
                }, options));
            },
            getFieldInstance: (name)=>{
                const namePathStr = $4c36311913591211$var$toNamePathStr(name);
                return itemsRef.current[namePathStr];
            }
        }), [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}





"use client";
var $69a0bf7fe3d99aff$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $69a0bf7fe3d99aff$var$InternalForm = (props, ref)=>{
    const contextDisabled = $acw62.useContext((0, $6ba6819805fb0a44$export$2e2bcd8739ae039));
    const { getPrefixCls: getPrefixCls, direction: direction, form: contextForm } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, hideRequiredMark: hideRequiredMark, layout: layout = "horizontal", scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant } = props, restFormProps = $69a0bf7fe3d99aff$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "size",
        "disabled",
        "form",
        "colon",
        "labelAlign",
        "labelWrap",
        "labelCol",
        "wrapperCol",
        "hideRequiredMark",
        "layout",
        "scrollToFirstError",
        "requiredMark",
        "onFinishFailed",
        "name",
        "style",
        "feedbackIcons",
        "variant"
    ]);
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(size);
    const contextValidateMessages = $acw62.useContext((0, $efabd6732f69a6da$export$2e2bcd8739ae039));
    const mergedRequiredMark = (0, $acw62.useMemo)(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (hideRequiredMark) return false;
        if (contextForm && contextForm.requiredMark !== undefined) return contextForm.requiredMark;
        return true;
    }, [
        hideRequiredMark,
        requiredMark,
        contextForm
    ]);
    const mergedColon = colon !== null && colon !== void 0 ? colon : contextForm === null || contextForm === void 0 ? void 0 : contextForm.colon;
    const prefixCls = getPrefixCls("form", customizePrefixCls);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3f17b93d805dc813$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const formClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-${mergedSize}`]: mergedSize
    }, cssVarCls, rootCls, hashId, contextForm === null || contextForm === void 0 ? void 0 : contextForm.className, className, rootClassName);
    const [wrapForm] = (0, $4c36311913591211$export$2e2bcd8739ae039)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = (0, $acw62.useMemo)(()=>({
            name: name,
            labelAlign: labelAlign,
            labelCol: labelCol,
            labelWrap: labelWrap,
            wrapperCol: wrapperCol,
            vertical: layout === "vertical",
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons
        }), [
        name,
        labelAlign,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons
    ]);
    const nativeElementRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>{
        var _a;
        return Object.assign(Object.assign({}, wrapForm), {
            nativeElement: (_a = nativeElementRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement
        });
    });
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: "nearest"
            };
            if (typeof options === "object") defaultScrollToFirstError = options;
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed === null || onFinishFailed === void 0 || onFinishFailed(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextForm && contextForm.scrollToFirstError !== undefined) scrollToField(contextForm.scrollToFirstError, fieldName);
        }
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$6f0555dad42725fb).Provider, {
        value: variant
    }, /*#__PURE__*/ $acw62.createElement((0, $6ba6819805fb0a44$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $acw62.createElement((0, $3e100f55cf8f3689$export$2e2bcd8739ae039).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$8ce1ff4f94d08846), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $acw62.createElement((0, $5f1614ae44e69c1b$export$2e2bcd8739ae039), Object.assign({
        id: name
    }, restFormProps, {
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: Object.assign(Object.assign({}, contextForm === null || contextForm === void 0 ? void 0 : contextForm.style), style),
        className: formClassName
    }))))))));
};
const $69a0bf7fe3d99aff$var$Form = /*#__PURE__*/ $acw62.forwardRef($69a0bf7fe3d99aff$var$InternalForm);
var $69a0bf7fe3d99aff$export$2e2bcd8739ae039 = $69a0bf7fe3d99aff$var$Form;




var $acw62 = parcelRequire("acw62");










function $6d72a014848b02ce$export$2e2bcd8739ae039(children) {
    if (typeof children === "function") return children;
    const childList = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
    return childList.length <= 1 ? childList[0] : childList;
}



var $acw62 = parcelRequire("acw62");


const $c23052ca479f865f$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$c23052ca479f865f$var$useFormItemStatus.Context = (0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed);
var $c23052ca479f865f$export$2e2bcd8739ae039 = $c23052ca479f865f$var$useFormItemStatus;



var $acw62 = parcelRequire("acw62");

function $bc695e48262f4f73$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $acw62.useState(defaultValue);
    const frameRef = (0, $acw62.useRef)(null);
    const batchRef = (0, $acw62.useRef)([]);
    const destroyRef = (0, $acw62.useRef)(false);
    $acw62.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $acw62 = parcelRequire("acw62");


function $3c7d21c38713ea5c$export$2e2bcd8739ae039() {
    const { itemRef: itemRef } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const cacheRef = $acw62.useRef({});
    function getRef(name, children) {
        const childrenRef = children && typeof children === "object" && children.ref;
        const nameStr = name.join("_");
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $5e297877593af644$export$ab452c34e8e05029)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    }
    return getRef;
}





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




/**
 * Fallback of IE.
 * Safe to remove.
 */ // Style as inline component


// ============================= Fallback =============================
const $cf15d29d2c9ecade$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: "flex"
            }
        }
    };
};
var // ============================== Export ==============================
$cf15d29d2c9ecade$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$1537386bc155ea56)([
    "Form",
    "item-item"
], (token, _ref)=>{
    let { rootPrefixCls: rootPrefixCls } = _ref;
    const formToken = (0, $3f17b93d805dc813$export$362fb92a8f81bbf9)(token, rootPrefixCls);
    return [
        $cf15d29d2c9ecade$var$genFallbackStyle(formToken)
    ];
});


"use client";
const $1c2fb1c8dfed9a89$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $acw62.useMemo(()=>Object.assign({}, formContext), [
        formContext
    ]);
    delete subFormContext.labelCol;
    delete subFormContext.wrapperCol;
    const inputDom = /*#__PURE__*/ $acw62.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${baseClassName}-control-input-content`
    }, children));
    const formItemContext = $acw62.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            display: "flex",
            flexWrap: "nowrap"
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $acw62.createElement((0, $2cd7502dce089e1a$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })), !!marginBottom && /*#__PURE__*/ $acw62.createElement("div", {
        style: {
            width: 0,
            height: marginBottom
        }
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, extraProps, {
        className: `${baseClassName}-extra`
    }), extra) : null;
    const dom = formItemRender && formItemRender.mark === "pro_table_render" && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, inputDom, errorListDom, extraDom);
    return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $acw62.createElement((0, $d153d21e77ee9427$export$2e2bcd8739ae039), Object.assign({}, mergedWrapperCol, {
        className: className
    }), dom), /*#__PURE__*/ $acw62.createElement((0, $cf15d29d2c9ecade$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
var $1c2fb1c8dfed9a89$export$2e2bcd8739ae039 = $1c2fb1c8dfed9a89$var$FormItemInput;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $62cc23852a32c921$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
var $62cc23852a32c921$export$2e2bcd8739ae039 = $62cc23852a32c921$var$QuestionCircleOutlined;



var $f894f96f86da23c6$var$QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $62cc23852a32c921$export$2e2bcd8739ae039)
    }));
};
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ var $f894f96f86da23c6$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f894f96f86da23c6$var$QuestionCircleOutlined);
var $f894f96f86da23c6$export$2e2bcd8739ae039 = $f894f96f86da23c6$var$RefIcon;








"use client";
var $e49ae3442c8737f4$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $e49ae3442c8737f4$var$toTooltipProps(tooltip) {
    if (!tooltip) return null;
    if (typeof tooltip === "object" && !/*#__PURE__*/ $acw62.isValidElement(tooltip)) return tooltip;
    return {
        title: tooltip
    };
}
const $e49ae3442c8737f4$var$FormItemLabel = (_ref)=>{
    let { prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical } = _ref;
    var _a;
    const [formLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Form");
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    if (!label) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(labelClsBasic, mergedLabelAlign === "left" && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === "string" && label.trim() !== "") labelChildren = label.replace(/[:|：]\s*$/, "");
    // Tooltip
    const tooltipProps = $e49ae3442c8737f4$var$toTooltipProps(tooltip);
    if (tooltipProps) {
        const { icon: icon = /*#__PURE__*/ $acw62.createElement((0, $f894f96f86da23c6$export$2e2bcd8739ae039), null) } = tooltipProps, restTooltipProps = $e49ae3442c8737f4$var$__rest(tooltipProps, [
            "icon"
        ]);
        const tooltipNode = /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({}, restTooltipProps), /*#__PURE__*/ $acw62.cloneElement(icon, {
            className: `${prefixCls}-item-tooltip`,
            title: "",
            onClick: (e)=>{
                // Prevent label behavior in tooltip icon
                // https://github.com/ant-design/ant-design/issues/46154
                e.preventDefault();
            },
            tabIndex: null
        }));
        labelChildren = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === "optional";
    const isRenderMark = typeof requiredMark === "function";
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, labelChildren, /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-item-optional`,
        title: ""
    }, (formLocale === null || formLocale === void 0 ? void 0 : formLocale.optional) || ((_a = (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Form) === null || _a === void 0 ? void 0 : _a.optional)));
    const labelClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-optional`]: isOptionalMark || isRenderMark,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $acw62.createElement((0, $d153d21e77ee9427$export$2e2bcd8739ae039), Object.assign({}, mergedLabelCol, {
        className: labelColClassName
    }), /*#__PURE__*/ $acw62.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        title: typeof label === "string" ? label : ""
    }, labelChildren));
};
var $e49ae3442c8737f4$export$2e2bcd8739ae039 = $e49ae3442c8737f4$var$FormItemLabel;





var $acw62 = parcelRequire("acw62");







"use client";
const $ba46d4357a9f33ef$var$iconMap = {
    success: (0, $9149fdfb4424d1d9$export$2e2bcd8739ae039),
    warning: (0, $2444f6da62064575$export$2e2bcd8739ae039),
    error: (0, $81ff9dc68eb84eda$export$2e2bcd8739ae039),
    validating: (0, $d8d56e1090f62915$export$2e2bcd8739ae039)
};
function $ba46d4357a9f33ef$export$2e2bcd8739ae039(_ref) {
    let { children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle } = _ref;
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const mergedValidateStatus = (0, $43291396832d20f3$export$b70265791d2079d4)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon } = $acw62.useContext((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed));
    // ====================== Context =======================
    const formItemStatusContext = $acw62.useMemo(()=>{
        var _a;
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && ((_a = customIcons === null || customIcons === void 0 ? void 0 : customIcons({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })) === null || _a === void 0 ? void 0 : _a[mergedValidateStatus]);
            const IconNode = mergedValidateStatus && $ba46d4357a9f33ef$var$iconMap[mergedValidateStatus];
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $acw62.createElement("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $acw62.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || "",
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus !== null && mergedValidateStatus !== void 0 ? mergedValidateStatus : parentStatus) || "";
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback !== null && hasFeedback !== void 0 ? hasFeedback : parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
        }
        return context;
    }, [
        mergedValidateStatus,
        hasFeedback,
        noStyle,
        parentIsFormItemInput,
        parentStatus
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children);
}


"use client";
var $046eb12d049399e0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $046eb12d049399e0$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: layout } = props, restProps = $046eb12d049399e0$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "help",
        "errors",
        "warnings",
        "validateStatus",
        "meta",
        "hasFeedback",
        "hidden",
        "children",
        "fieldId",
        "required",
        "isRequired",
        "onSubItemMetaChange",
        "layout"
    ]);
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, vertical: formVertical } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const vertical = formVertical || layout === "vertical";
    // ======================== Margin ========================
    const itemRef = $acw62.useRef(null);
    const debounceErrors = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $9ffe1c2756854ba4$export$2e2bcd8739ae039)(warnings);
    const hasHelp = help !== undefined && help !== null;
    const hasError = !!(hasHelp || errors.length || warnings.length);
    const isOnScreen = !!itemRef.current && (0, $555b4eee2695f264$export$2e2bcd8739ae039)(itemRef.current);
    const [marginBottom, setMarginBottom] = $acw62.useState(null);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = function() {
        let isDebounce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $43291396832d20f3$export$b70265791d2079d4)(_errors, _warnings, meta, "", !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === "success",
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === "warning",
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === "error",
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === "validating",
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $acw62.createElement((0, $50bd634b7bc091a8$export$2e2bcd8739ae039), Object.assign({
        className: `${itemPrefixCls}-row`
    }, (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(restProps, [
        "_internalItemRender",
        "colon",
        "dependencies",
        "extra",
        "fieldKey",
        "getValueFromEvent",
        "getValueProps",
        "htmlFor",
        "id",
        // It is deprecated because `htmlFor` is its replacement.
        "initialValue",
        "isListField",
        "label",
        "labelAlign",
        "labelCol",
        "labelWrap",
        "messageVariables",
        "name",
        "normalize",
        "noStyle",
        "preserve",
        "requiredMark",
        "rules",
        "shouldUpdate",
        "trigger",
        "tooltip",
        "validateFirst",
        "validateTrigger",
        "valuePropName",
        "wrapperCol",
        "validateDebounce"
    ])), /*#__PURE__*/ $acw62.createElement((0, $e49ae3442c8737f4$export$2e2bcd8739ae039), Object.assign({
        htmlFor: fieldId
    }, props, {
        requiredMark: requiredMark,
        required: required !== null && required !== void 0 ? required : isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    })), /*#__PURE__*/ $acw62.createElement((0, $1c2fb1c8dfed9a89$export$2e2bcd8739ae039), Object.assign({}, props, meta, {
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }), /*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $acw62.createElement((0, $ba46d4357a9f33ef$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus
    }, children)))), !!marginBottom && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}



"use client";
const $8713ccd60b7fb61a$var$NAME_SPLIT = "__SPLIT__";
const $8713ccd60b7fb61a$var$ValidateStatuses = [
    "success",
    "warning",
    "error",
    "validating",
    ""
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $8713ccd60b7fb61a$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || typeof propValueA === "function" || typeof propValueB === "function";
    });
}
const $8713ccd60b7fb61a$var$MemoInput = /*#__PURE__*/ $acw62.memo((_ref)=>{
    let { children: children } = _ref;
    return children;
}, (prev, next)=>$8713ccd60b7fb61a$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $8713ccd60b7fb61a$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $8713ccd60b7fb61a$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = "onChange", validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const { name: formName } = $acw62.useContext((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    const mergedChildren = (0, $6d72a014848b02ce$export$2e2bcd8739ae039)(children);
    const isRenderProps = typeof mergedChildren === "function";
    const notifyParentMetaChange = $acw62.useContext((0, $ad5d550b51ac8abd$export$d718247e9f9b0b9e));
    const { validateTrigger: contextValidateTrigger } = $acw62.useContext((0, $186c9d6ed579317b$export$2e2bcd8739ae039));
    const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : contextValidateTrigger;
    const hasName = !(name === undefined || name === null);
    const prefixCls = getPrefixCls("form", customizePrefixCls);
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3f17b93d805dc813$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("Form.Item");
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $acw62.useContext((0, $f81400e90cbb2e33$export$2e2bcd8739ae039));
    const fieldKeyPathRef = $acw62.useRef();
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $bc695e48262f4f73$export$2e2bcd8739ae039)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $25e137fc56329ad1$export$2e2bcd8739ae039)(()=>$8713ccd60b7fb61a$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext === null || listContext === void 0 ? void 0 : listContext.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $8713ccd60b7fb61a$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = Object.assign({}, prevSubFieldErrors);
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(subMeta.name.slice(0, -1)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($8713ccd60b7fb61a$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $acw62.useMemo(()=>{
        const errorList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(meta.errors);
        const warningList = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $3c7d21c38713ea5c$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $acw62.createElement((0, $ba46d4357a9f33ef$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true
        }, baseChildren);
        return /*#__PURE__*/ $acw62.createElement((0, $046eb12d049399e0$export$2e2bcd8739ae039), Object.assign({
            key: "row"
        }, props, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout
        }), baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return wrapCSSVar(renderLayout(mergedChildren));
    let variables = {};
    if (typeof label === "string") variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = Object.assign(Object.assign({}, variables), messageVariables);
    // >>>>> With Field
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $3299c229146a7fb5$export$2e2bcd8739ae039), Object.assign({}, props, {
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }), (control, renderMeta, context)=>{
        const mergedName = (0, $43291396832d20f3$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $43291396832d20f3$export$f4457e83c74ac000)(mergedName, formName);
        const isRequired = required !== undefined ? required : !!(rules === null || rules === void 0 ? void 0 : rules.some((rule)=>{
            if (rule && typeof rule === "object" && rule.required && !rule.warningOnly) return true;
            if (typeof rule === "function") {
                const ruleEntity = rule(context);
                return (ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.required) && !(ruleEntity === null || ruleEntity === void 0 ? void 0 : ruleEntity.warningOnly);
            }
            return false;
        }));
        // ======================= Children =======================
        const mergedControl = Object.assign({}, control);
        let childNode = null;
        if (Array.isArray(mergedChildren) && hasName) childNode = mergedChildren;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if (/*#__PURE__*/ $acw62.isValidElement(mergedChildren)) {
            const childProps = Object.assign(Object.assign({}, mergedChildren.props), mergedControl);
            if (!childProps.id) childProps.id = fieldId;
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (props.extra) describedbyArr.push(`${fieldId}_extra`);
                childProps["aria-describedby"] = describedbyArr.join(" ");
            }
            if (mergedErrors.length > 0) childProps["aria-invalid"] = "true";
            if (isRequired) childProps["aria-required"] = "true";
            if ((0, $5e297877593af644$export$c1cec34af06bcf7)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $43291396832d20f3$export$45b10814cc054894)(trigger)), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $43291396832d20f3$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = function() {
                    var _a2, _c2;
                    var _a, _b, _c;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    (_a = mergedControl[eventName]) === null || _a === void 0 || (_a2 = _a).call.apply(_a2, [
                        mergedControl
                    ].concat(args));
                    (_c = (_b = mergedChildren.props)[eventName]) === null || _c === void 0 || (_c2 = _c).call.apply(_c2, [
                        _b
                    ].concat(args));
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps["aria-required"],
                childProps["aria-invalid"],
                childProps["aria-describedby"]
            ];
            childNode = /*#__PURE__*/ $acw62.createElement($8713ccd60b7fb61a$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $30796c32f374b477$export$e530037191fcd5d7)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else childNode = mergedChildren;
        return renderLayout(childNode, fieldId, isRequired);
    }));
}
const $8713ccd60b7fb61a$var$FormItem = $8713ccd60b7fb61a$var$InternalFormItem;
$8713ccd60b7fb61a$var$FormItem.useStatus = (0, $c23052ca479f865f$export$2e2bcd8739ae039);
var $8713ccd60b7fb61a$export$2e2bcd8739ae039 = $8713ccd60b7fb61a$var$FormItem;



var $acw62 = parcelRequire("acw62");




"use client";
var $3a42708cb1545f12$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3a42708cb1545f12$var$FormList = (_a)=>{
    var { prefixCls: customizePrefixCls, children: children } = _a, props = $3a42708cb1545f12$var$__rest(_a, [
        "prefixCls",
        "children"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("form", customizePrefixCls);
    const contextValue = $acw62.useMemo(()=>({
            prefixCls: prefixCls,
            status: "error"
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $1ad2b0235e0eb0b7$export$2e2bcd8739ae039), Object.assign({}, props), (fields, operation, meta)=>/*#__PURE__*/ $acw62.createElement((0, $ad5d550b51ac8abd$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map((field)=>Object.assign(Object.assign({}, field), {
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $3a42708cb1545f12$export$2e2bcd8739ae039 = $3a42708cb1545f12$var$FormList;



var $acw62 = parcelRequire("acw62");

function $a4f42b2c91c59125$export$2e2bcd8739ae039() {
    const { form: form } = (0, $acw62.useContext)((0, $ad5d550b51ac8abd$export$c24727297075ec6a));
    return form;
}


"use client";
const $38feeba41dc3d65b$var$Form = (0, $69a0bf7fe3d99aff$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.Item = (0, $8713ccd60b7fb61a$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.List = (0, $3a42708cb1545f12$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.ErrorList = (0, $2cd7502dce089e1a$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useForm = (0, $4c36311913591211$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useFormInstance = (0, $a4f42b2c91c59125$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.useWatch = (0, $c40fe08ecbe59c71$export$2e2bcd8739ae039);
$38feeba41dc3d65b$var$Form.Provider = (0, $ad5d550b51ac8abd$export$8ce1ff4f94d08846);
$38feeba41dc3d65b$var$Form.create = ()=>{};
var $38feeba41dc3d65b$export$2e2bcd8739ae039 = $38feeba41dc3d65b$var$Form;






var $acw62 = parcelRequire("acw62");
const $14baf5ad039df94f$var$ErrorDisplay = ({ messages: messages, plotType: plotType })=>{
    const [localMessages, setLocalMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(messages);
    (0, $acw62.useEffect)(()=>{
        if (plotType === "") setLocalMessages([
            "Select a plot type",
            ...messages
        ]);
        else setLocalMessages(messages);
    }, [
        plotType,
        messages
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "errorDisplayContainer",
        children: [
            localMessages.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                children: localMessages.map((message, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        children: `> ${message}`
                    }, index))
            }),
            messages.length === 0 && plotType != "" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                className: "successVisualizer",
                children: [
                    ">",
                    " Run Program to view plots"
                ]
            })
        ]
    });
};
var $14baf5ad039df94f$export$2e2bcd8739ae039 = $14baf5ad039df94f$var$ErrorDisplay;


const $7972f4626a749cb2$var$plotTypeOptions = [
    {
        value: "bar_chart",
        label: "Bar Chart"
    },
    {
        value: "heatmap",
        label: "Heatmap"
    },
    {
        value: "histogram",
        label: "Histogram"
    },
    {
        value: "scatter",
        label: "Scatter Plot"
    }
];
const $7972f4626a749cb2$var$delayFunction = (fn, ms)=>{
    let timer = null;
    return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(()=>{
            fn(...args);
        }, ms);
    };
};
const $7972f4626a749cb2$var$delaySetBins = $7972f4626a749cb2$var$delayFunction((type, context, logOnly)=>(0, $14e68cbe3c2b3085$export$83fc28f458189523)(type, context, logOnly), 1000);
const $7972f4626a749cb2$var$VisualizerComponent = (props)=>{
    const [columns, setColumns] = (0, $acw62.useState)([]);
    const [plotType, setPlotType] = (0, $acw62.useState)(props.data.plotType || "");
    const [selectedCategoricalColumn, setSelectedCategoricalColumn] = (0, $acw62.useState)(props.data.categoricalColumn || "");
    const [selectedNumericalColumns, setSelectedNumericalColumns] = (0, $acw62.useState)(props.data.numericalColumns || []);
    const [bins, setBins] = (0, $acw62.useState)(props.data.bins || null);
    const containerRef = (0, $acw62.useRef)(null);
    const { df_columns: df_columns, messages: messages } = props.data;
    const handleClickViewPlots = ()=>{
        props.data.setIsVisualizerOpen();
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("click_view_plots", {
            plotType: plotType
        }, true);
    };
    const handlePlotTypeChange = (value)=>{
        props.data.setPlotType(value);
        setPlotType(props.data.plotType);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_plot_type", {
            plotType: value
        });
    };
    const handleCategoricalColumnChange = (value)=>{
        setSelectedCategoricalColumn(value);
        props.data.setCategoricalColumn(value);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_categorical_column", {
            plotType: plotType,
            categorical_column: value
        });
    };
    const handleNumericalColumnChange = (value, index = 0)=>{
        if (!selectedNumericalColumns.includes(value) && selectedCategoricalColumn !== value) setSelectedNumericalColumns((prev)=>{
            let newNumericalColumns;
            if (plotType === "bar_chart" || plotType === "histogram") newNumericalColumns = [
                value
            ];
            else {
                newNumericalColumns = [
                    ...prev
                ];
                newNumericalColumns[index] = value;
            }
            props.data.setNumericalColumns(newNumericalColumns);
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("set_numerical_column", {
                plotType: plotType,
                new_column: value,
                numerical_columns: newNumericalColumns
            });
            return newNumericalColumns;
        });
    };
    const handleBinsChange = (value)=>{
        if (value) {
            props.data.setBins(value);
            setBins(value);
            $7972f4626a749cb2$var$delaySetBins("set_bins", {
                plotType: plotType,
                bins: value
            });
        }
    };
    const getElementTotalHeight = (el)=>{
        const styles = window.getComputedStyle(el);
        const margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);
        return el.offsetHeight + margin;
    };
    const sumImmediateChildrenHeights = (parentDiv)=>{
        let totalHeight = 0;
        for (let child of parentDiv.children)totalHeight += getElementTotalHeight(child);
        return totalHeight;
    };
    const getCurrentHeight = ()=>{
        if (!containerRef.current) return 250;
        const controlContainer = containerRef.current;
        const overallNodeContainer = controlContainer.closest("[data-testid='node']") || document.createElement("div");
        const totalRequiredHeight = sumImmediateChildrenHeights(overallNodeContainer);
        // Clear any hardcoded dimensions from the auto arrange plugin
        overallNodeContainer.style.height = "";
        overallNodeContainer.style.width = "";
        return totalRequiredHeight + 5;
    };
    const updateNodeHeightByContent = ()=>{
        const newHeight = getCurrentHeight();
        props.data.adjustHeight(newHeight);
    };
    const checkIfColumnSelected = (column)=>{
        return selectedCategoricalColumn === column || selectedNumericalColumns.includes(column);
    };
    (0, $acw62.useEffect)(()=>{
        setSelectedCategoricalColumn("");
        setSelectedNumericalColumns([]);
        setBins(props.data.bins || 10);
        setTimeout(()=>{
            updateNodeHeightByContent();
        }, 50);
    }, [
        plotType
    ]);
    (0, $acw62.useEffect)(()=>{
        setColumns(props.data.df_columns);
        setSelectedCategoricalColumn(props.data.categoricalColumn || "");
        setSelectedNumericalColumns(props.data.numericalColumns || []);
        updateNodeHeightByContent();
    }, [
        props.data.df_columns
    ]);
    (0, $acw62.useEffect)(()=>{
        updateNodeHeightByContent();
    }, [
        selectedCategoricalColumn,
        selectedNumericalColumns
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "generatePlotControlContainer",
        ref: containerRef,
        onPointerDown: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                defaultValue: props.data.plotType || "Select Plot Type",
                dropdownStyle: {
                    width: "fit-content",
                    minWidth: "175px"
                },
                onChange: handlePlotTypeChange,
                options: $7972f4626a749cb2$var$plotTypeOptions.map((option, index)=>{
                    return {
                        value: option.value,
                        title: `Create ${option.label}`,
                        label: option.label
                    };
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $14baf5ad039df94f$export$2e2bcd8739ae039), {
                messages: messages,
                plotType: plotType
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "requiredInputChoices",
                children: [
                    plotType === "bar_chart" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                label: "Select Categorical Column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    defaultValue: selectedCategoricalColumn || "Select Column",
                                    onChange: handleCategoricalColumnChange,
                                    dropdownStyle: {
                                        width: "fit-content",
                                        minWidth: "175px"
                                    },
                                    value: selectedCategoricalColumn || "Select Column",
                                    options: columns.map((column)=>{
                                        const disabled = checkIfColumnSelected(column);
                                        return {
                                            value: column,
                                            title: disabled ? "Column already selected elsewhere" : `Select ${column}`,
                                            label: column,
                                            disabled: checkIfColumnSelected(column)
                                        };
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                label: "Select Numerical Column (Optional)",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    defaultValue: selectedNumericalColumns[0] || "Select Column",
                                    value: selectedNumericalColumns[0] || "Select Column",
                                    onChange: (val)=>handleNumericalColumnChange(val),
                                    dropdownStyle: {
                                        width: "fit-content",
                                        minWidth: "175px"
                                    },
                                    options: columns.map((column)=>{
                                        const disabled = checkIfColumnSelected(column);
                                        return {
                                            value: column,
                                            title: disabled ? "Column already selected elsewhere" : `Select ${column}`,
                                            label: column,
                                            disabled: checkIfColumnSelected(column)
                                        };
                                    })
                                })
                            })
                        ]
                    }),
                    plotType === "histogram" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                label: "Select Numerical Column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    defaultValue: selectedNumericalColumns[0] || "Select Column",
                                    value: selectedNumericalColumns[0] || "Select Column",
                                    onChange: (val)=>handleNumericalColumnChange(val),
                                    dropdownStyle: {
                                        width: "fit-content",
                                        minWidth: "175px"
                                    },
                                    options: columns.map((column)=>({
                                            value: column,
                                            title: `Select ${column}`,
                                            label: column
                                        }))
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                label: "Number of Bins",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed9156e2babf3c6$export$2e2bcd8739ae039), {
                                    min: 1,
                                    max: 100,
                                    defaultValue: bins || 10,
                                    value: bins || 10,
                                    step: 1,
                                    onChange: handleBinsChange
                                })
                            })
                        ]
                    }),
                    plotType === "scatter" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                label: "Select X-Axis Column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    defaultValue: selectedNumericalColumns[0] || "Select Column",
                                    value: selectedNumericalColumns[0] || "Select Column",
                                    onChange: (val)=>handleNumericalColumnChange(val, 0),
                                    dropdownStyle: {
                                        width: "fit-content",
                                        minWidth: "175px"
                                    },
                                    options: columns.map((column)=>{
                                        const disabled = checkIfColumnSelected(column);
                                        return {
                                            value: column,
                                            title: disabled ? "Column already selected elsewhere" : `Select ${column}`,
                                            label: column,
                                            disabled: disabled
                                        };
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                label: "Select Y-Axis Column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    defaultValue: selectedNumericalColumns[1] || "Select Column",
                                    value: selectedNumericalColumns[1] || "Select Column",
                                    onChange: (val)=>handleNumericalColumnChange(val, 1),
                                    dropdownStyle: {
                                        width: "fit-content",
                                        minWidth: "175px"
                                    },
                                    options: columns.map((column)=>{
                                        const disabled = checkIfColumnSelected(column);
                                        return {
                                            value: column,
                                            title: disabled ? "Column already selected elsewhere" : `Select ${column}`,
                                            label: column,
                                            disabled: disabled
                                        };
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                label: "Select Categorical Column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                    defaultValue: selectedCategoricalColumn || "Select Column",
                                    value: selectedCategoricalColumn || "Select Column",
                                    onChange: handleCategoricalColumnChange,
                                    dropdownStyle: {
                                        width: "fit-content",
                                        minWidth: "175px"
                                    },
                                    options: columns.map((column)=>{
                                        const disabled = checkIfColumnSelected(column);
                                        return {
                                            value: column,
                                            title: disabled ? "Column already selected elsewhere" : `Select ${column}`,
                                            label: column,
                                            disabled: disabled
                                        };
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, props.data.df_columns.join(",")),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: handleClickViewPlots,
                children: "View Plots"
            })
        ]
    });
};
var $7972f4626a749cb2$export$2e2bcd8739ae039 = $7972f4626a749cb2$var$VisualizerComponent;



let $14e68cbe3c2b3085$export$83fc28f458189523;
const $14e68cbe3c2b3085$var$AUTO_SAVE_TRIGGER_DELAY = 250; // ms
let $14e68cbe3c2b3085$export$48f2fed47365221c;
let $14e68cbe3c2b3085$export$5d8ad995f8f7b680;
let $14e68cbe3c2b3085$export$3dc39d1c205f6de;
let $14e68cbe3c2b3085$export$9df0b6e8eb716c6a;
let $14e68cbe3c2b3085$export$5f1aefa39776ca10;
let $14e68cbe3c2b3085$export$eff0af430afeb33d;
let $14e68cbe3c2b3085$export$cb44fff24c460592;
let $14e68cbe3c2b3085$export$b082f73d8fa2a56f;
function $14e68cbe3c2b3085$var$makeEditorExportable(editor, area, arrange, engine, socket, updateAsset, process, selector) {
    $14e68cbe3c2b3085$export$48f2fed47365221c = editor;
    $14e68cbe3c2b3085$export$5d8ad995f8f7b680 = area;
    $14e68cbe3c2b3085$export$3dc39d1c205f6de = arrange;
    $14e68cbe3c2b3085$export$9df0b6e8eb716c6a = engine;
    $14e68cbe3c2b3085$export$eff0af430afeb33d = socket;
    $14e68cbe3c2b3085$export$cb44fff24c460592 = updateAsset;
    $14e68cbe3c2b3085$export$b082f73d8fa2a56f = process;
    $14e68cbe3c2b3085$export$5f1aefa39776ca10 = selector;
}
class $14e68cbe3c2b3085$export$98b66c25bb38499d extends (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Connection {
}
async function $14e68cbe3c2b3085$export$eb02d1ee0d3cac30(container, context, setCodePreview, setAutoSaveStatus, setResetTrigger, setIsVisualizerOpen, setPlotType, problem_id, setEditorNodes, isContextMenuSource, setCodePaths, hasProcessStartedRef) {
    const socket = new (0, $bad63f27bc7a37b5$export$c53446ac9c5804d8).Socket("socket");
    const editor = new (0, $bad63f27bc7a37b5$export$970c2db48345af40)();
    const area = new (0, $8edd8caaa4dabbef$export$ca4e44bc52e1e414)(container);
    const connection = new (0, $c8972d6a08cac3bd$export$bd9a5b2e2ab1f9b0)();
    const engine = new (0, $75215ef86aee3bc3$export$aff6fc27706caf24)();
    const render = new (0, $c24bb3319861fe36$export$eedcd19618da8709)({
        createRoot: $7e96a608cb33bf79$export$882461b6382ed46c
    });
    const history = new (0, $affa0368cf6b1581$export$71f666dd3362399)();
    const contextMenu = new (0, $6e1ed5df05ca2a7f$export$24cca5f57f539b23)({
        items: (0, $6e1ed5df05ca2a7f$export$7a05727743f7512).classic.setup([
            [
                "Display",
                [
                    [
                        "Code Viewer",
                        ()=>new (0, $f49a18cfb699f2ae$export$6f3ba425d7d3e976)(socket, updateAsset)
                    ],
                    [
                        "Console Viewer",
                        ()=>new (0, $810971140f72e2de$export$4bb420d367dd583f)(socket, updateAsset)
                    ],
                    [
                        "Visualizer",
                        ()=>new (0, $3a72e5e3d0c4576d$export$5eb306383074849d)(socket, updateAsset, setIsVisualizerOpen, process)
                    ]
                ]
            ],
            [
                "Import",
                [
                    [
                        "Dataset Importer",
                        ()=>new (0, $d8d53b6b0907a50a$export$97f07c7bed44aa64)(socket, updateAsset, process, context)
                    ],
                    [
                        "Library Importer",
                        ()=>new (0, $2fb57d68275642e6$export$ffa639bf02197be7)(socket, process, updateAsset, context)
                    ]
                ]
            ],
            [
                "Dataframe Tools",
                [
                    [
                        "Dataframe Loader",
                        ()=>new (0, $01f94c473c0d84e2$export$22ddc13a7241495c)(socket, updateAsset, process, context)
                    ],
                    [
                        "Dataframe Inspector",
                        ()=>new (0, $f26d115732c81313$export$d1590ca22f5c6870)(socket, updateAsset, process, context)
                    ],
                    [
                        "Test Train Split",
                        ()=>new (0, $9735c6bee69b34d2$export$86875fb9396ffef7)(socket, updateAsset, process, context)
                    ]
                ]
            ],
            [
                "Model",
                [
                    [
                        "Model Selection",
                        [
                            [
                                "Linear Regression",
                                ()=>new (0, $c35186146850e89e$export$d3b03157a2f8aeb0)(socket, updateAsset, process)
                            ],
                            [
                                "Logistic Regression",
                                ()=>new (0, $0e7415dfef3d107e$export$94ed1b3e3ae1550b)(socket, updateAsset, process)
                            ]
                        ]
                    ],
                    [
                        "Model Training",
                        [
                            [
                                "Train Model",
                                ()=>new (0, $25d2d290184854c1$export$fb555a1f694982ed)(socket)
                            ]
                        ]
                    ],
                    [
                        "Model Prediction",
                        [
                            [
                                "Predict Model",
                                ()=>new (0, $94f417b207779069$export$b861717cc31ea743)(socket)
                            ]
                        ]
                    ],
                    [
                        "Model Evaluation",
                        [
                            [
                                "Score Model",
                                ()=>new (0, $f526e55cdfab877a$export$69adef2c3afcd250)(socket)
                            ]
                        ]
                    ]
                ]
            ]
        ])
    });
    const graph = (0, $ecd61fdb45ead356$export$ed855c71509be8a0)(editor);
    const arrange = new (0, $d40e44a710563a99$export$5740d7119e58a254)();
    let isEditorLoaded = false;
    const { markTaskAsCompleted: markTaskAsCompleted, removeTaskFromCompleted: removeTaskFromCompleted } = context;
    history.addPreset((0, $affa0368cf6b1581$export$7a05727743f7512).classic.setup());
    const selectorExt = (0, $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b).selector();
    (0, $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b).selectableNodes(area, selectorExt, {
        accumulating: (0, $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b).accumulateOnCtrl()
    });
    async function process(connectionRemoved = false, affectedNode) {
        if (!hasProcessStartedRef.current) hasProcessStartedRef.current = true;
        engine.reset();
        const allNodes = editor.getNodes();
        const isolatedNodes = allNodes.filter((n)=>!graph.connections().some((c)=>c.source === n.id || c.target === n.id) && (!connectionRemoved || n.id !== affectedNode?.id));
        const leafNodes = graph.leaves().nodes().filter((n)=>!isolatedNodes.includes(n));
        const targetNodes = leafNodes.filter((n)=>n instanceof (0, $f49a18cfb699f2ae$export$6f3ba425d7d3e976) || n instanceof (0, $810971140f72e2de$export$4bb420d367dd583f) || n instanceof (0, $01f94c473c0d84e2$export$22ddc13a7241495c) || n instanceof (0, $9735c6bee69b34d2$export$86875fb9396ffef7));
        const consoleIndex = leafNodes.findIndex((n)=>n instanceof (0, $810971140f72e2de$export$4bb420d367dd583f));
        if (consoleIndex >= 0) {
            const [consoleNode] = leafNodes.splice(consoleIndex, 1);
            leafNodes.push(consoleNode);
        }
        let totalCodePreview = "";
        let codePaths = [];
        let pathNum = 1;
        try {
            for (const n of leafNodes){
                const data = await engine.fetch(n.id);
                if (pathNum !== 1) totalCodePreview += "\n\n";
                const codeOutput = Object.values(data)[0].code.join("\n");
                codePaths.push({
                    pathNum: pathNum,
                    code: codeOutput
                });
                totalCodePreview += `#########################\n###### Path ${pathNum} code ######\n#########################\n${codeOutput}`;
                const plotType = Object.values(data)[0].previousNodes.find((node)=>node.label === "Generate Plot")?.plotType;
                setPlotType(plotType);
                pathNum++;
            }
        } catch (error) {
            console.log("Error caught in process function:", error);
        }
        setCodePaths(codePaths);
        setCodePreview(totalCodePreview || "");
    }
    function updateAsset(type, asset) {
        area.update(type, asset.id);
    }
    render.addPreset((0, $c24bb3319861fe36$export$7a05727743f7512).classic.setup());
    render.addPreset((0, $c24bb3319861fe36$export$7a05727743f7512).classic.setup({
        customize: {
            control (data) {
                if (data.payload instanceof (0, $880a521727a0b65e$export$28c39c52cb1444cb)) return 0, $fc4821d378713000$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $e43c57db4a9e93f6$export$76f5e7e1abc7c58d)) return 0, $6c6cd973a530b75c$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $6c9ba8c8034ad685$export$a39bff1902b94c0b)) return 0, $9d71970f2049ac94$export$c83e0cbdd085b807;
                if (data.payload instanceof (0, $cf40b7ad0ce13c76$export$83e695320cf826d5)) return 0, $9f0b5fc5c8b684cd$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $4313fafad8131e76$export$48cab1cc19c1aec7)) return 0, $4d1776c2c55b839d$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $0897edf622ee7484$export$8d9ea068df147b5e)) return 0, $fa2410c2c2e8d257$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $183561bbe0560042$export$9b78530a1257fd4b)) return 0, $d248ed2e4a3b2340$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $b793ca7473380a0a$export$f0ec58f328f6e9c0)) return 0, $4dbc11826bd4bc44$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $1ebb17db6a168a75$export$563d687b34faa3e)) return 0, $d4d9c0f4e6482781$export$2e2bcd8739ae039;
                if (data.payload instanceof (0, $34c62684cffe3541$export$41b53e6f254bcba7)) return 0, $7972f4626a749cb2$export$2e2bcd8739ae039;
                return null;
            }
        }
    }));
    const { Menu: Menu, Common: Common, Search: Search, Subitems: Subitems, Item: Item } = (0, $c24bb3319861fe36$export$7a05727743f7512).contextMenu;
    const CustomMenu = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(Menu)`
        width: fit-content;
    `;
    const CustomSubItems = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)(Subitems)`
        width: max-content;
    `;
    const CustomItemType = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $3c798496d2a40a1f$export$2e2bcd8739ae039))`
        background: grey;
    `;
    render.addPreset((0, $c24bb3319861fe36$export$7a05727743f7512).contextMenu.setup({
        delay: 200,
        customize: {
            main: ()=>CustomMenu,
            item: ()=>CustomItemType,
            common: ()=>Common,
            search: ()=>Search,
            subitems: ()=>CustomSubItems
        }
    }));
    render.addPreset((0, $c24bb3319861fe36$export$7a05727743f7512).contextMenu.setup());
    connection.addPreset((0, $c8972d6a08cac3bd$export$7a05727743f7512).classic.setup());
    arrange.addPreset((0, $d40e44a710563a99$export$7a05727743f7512).classic.setup());
    editor.use(engine);
    editor.use(area);
    area.use(connection);
    area.use(contextMenu);
    area.use(render);
    area.use(history);
    area.use(arrange);
    (0, $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b).simpleNodesOrder(area);
    const LOG_EVENT_TYPES = [
        "nodecreated",
        "noderemoved",
        "connectioncreated",
        "connectionremoved"
    ];
    editor.addPipe(async (context)=>{
        const type = context.type;
        if (type === "nodecreated" && isEditorLoaded) {
            if ("task_id" in context.data) {
                const currentAction = context.data.task_id;
                await markTaskAsCompleted(currentAction);
            }
        }
        if (type === "noderemoved") {
            if ("task_id" in context.data) {
                const currentAction = context.data.task_id;
                const typeStillExists = editor.getNodes().some((n)=>n.task_id === currentAction);
                if (!typeStillExists) {
                    await removeTaskFromCompleted(currentAction);
                    if (currentAction === "createLibraryImporter") // Must also remove importLibraries task since its dependent on library importer
                    await removeTaskFromCompleted("importLibraries");
                    else if (currentAction === "createDatasetImporter") // Must also remove importDataset task since its dependent on dataset importer
                    await removeTaskFromCompleted("importDataset");
                }
            }
        }
        return context;
    });
    const debouncedProcess = (0, $cfadb87391ca5e26$export$dd6e5daab826fa5c)((removed = false, target = null)=>process(removed, target), 500);
    let ignoreNextTwoNodeTranslations = false;
    let ignoreCount = 0;
    // SETUP EDITOR EVENT LISTENERS
    const autoSaveEventTypes = [
        "nodetranslated",
        "noderesized",
        "nodecreated",
        "noderemoved",
        "connectioncreated",
        "connectionremoved"
    ];
    const autoSave = (0, $cfadb87391ca5e26$export$dd6e5daab826fa5c)((eventType = "Not specified")=>{
        setAutoSaveStatus("saved");
        (0, $afd930b1a77e3a58$export$e8665f5904db2e8f)(problem_id);
    }, (0, $4d8ac34042b67290$export$56475857fe697c62) * 1000 - $14e68cbe3c2b3085$var$AUTO_SAVE_TRIGGER_DELAY);
    $14e68cbe3c2b3085$export$83fc28f458189523 = (0, $cfadb87391ca5e26$export$dd6e5daab826fa5c)((type, context = {}, logOnly = false, saveOnly = false)=>{
        if (saveOnly) {
            autoSave();
            return;
        }
        if (!logOnly) {
            setAutoSaveStatus("pending");
            setResetTrigger((prev)=>!prev);
            autoSave(type);
        }
        const eventData = (0, $cfadb87391ca5e26$export$bfb1dec8091047c0)(type, context);
        const details = (0, $cfadb87391ca5e26$export$5e4dc5c899332621)(type, eventData) || undefined;
        (0, $cfadb87391ca5e26$export$7e41d6135b9d82b9)({
            action: type,
            eventData: eventData,
            details: details,
            problem_id: problem_id
        });
    }, $14e68cbe3c2b3085$var$AUTO_SAVE_TRIGGER_DELAY);
    area.addPipe((context)=>{
        const type = context.type;
        if (isEditorLoaded && autoSaveEventTypes.includes(type)) {
            let source = "dragging from Dock Menu";
            let contextCopy = {
                ...context,
                source: ""
            };
            if (type === "nodetranslated" && ignoreNextTwoNodeTranslations) {
                ignoreCount--;
                if (ignoreCount <= 0) ignoreNextTwoNodeTranslations = false;
                return context;
            } else if (type === "nodecreated") {
                ignoreNextTwoNodeTranslations = true;
                ignoreCount = 2;
                if (isContextMenuSource.current) {
                    isContextMenuSource.current = false;
                    source = "right-click Context Menu";
                }
                contextCopy = {
                    ...context,
                    source: source
                };
            }
            $14e68cbe3c2b3085$export$83fc28f458189523(type, contextCopy);
        }
        if (type === "render") {
            const subtype = context.data.type;
            if (subtype === "control") {
                const element = context.data.element;
                element.addEventListener("dblclick", (e)=>{
                    e.stopPropagation();
                });
            } else if (subtype === "contextmenu") isContextMenuSource.current = true;
        }
        if (isEditorLoaded && (type === "connectioncreated" || type === "connectionremoved")) {
            const target = editor.getNode(context.data.target);
            if (type === "connectionremoved") debouncedProcess(true, target);
            else debouncedProcess();
        }
        if ("data" in context) {
            if (LOG_EVENT_TYPES.includes(type)) {
                if (type === "connectionremoved" || type === "connectioncreated") {
                    const connectionData = (0, $cfadb87391ca5e26$export$803b5a85accbf219)(context.data);
                }
            }
        }
        return context;
    });
    $14e68cbe3c2b3085$var$makeEditorExportable(editor, area, arrange, engine, socket, updateAsset, process, selectorExt);
    await (0, $afd930b1a77e3a58$export$ddad178871dadc52)(editor, area, socket, updateAsset, process, context, setIsVisualizerOpen, problem_id);
    const editorNodeTypes = editor.getNodes().map((node)=>{
        return {
            blockType: node.getType(),
            id: node.id
        };
    });
    setEditorNodes(editorNodeTypes);
    setTimeout(()=>{
        (0, $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b).zoomAt(area, editor.getNodes());
        isEditorLoaded = true;
    }, 10);
    setTimeout(async ()=>{
        const isDatasetImporterPresent = editorNodeTypes.some((type)=>type.blockType === "DatasetImporter");
        if (!isDatasetImporterPresent || !hasProcessStartedRef.current) process();
    }, 500);
    return {
        destroy: ()=>area.destroy()
    };
}




var $acw62 = parcelRequire("acw62");
const $4b757d6069fb0a9d$var$ProblemContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $4b757d6069fb0a9d$export$2e2bcd8739ae039 = $4b757d6069fb0a9d$var$ProblemContext;




var $acw62 = parcelRequire("acw62");
const $64b95cf95a31e7f0$var$SaveIndicator = ({ status: status, setStatus: setStatus, max_interval_seconds: max_interval_seconds, resetTrigger: resetTrigger, saveIndicatorMessageRef: saveIndicatorMessageRef })=>{
    const [countDown, setCountDown] = (0, $acw62.useState)(0);
    const [dots, setDots] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (status) setCountDown(max_interval_seconds);
    }, [
        resetTrigger
    ]);
    (0, $acw62.useEffect)(()=>{
        if (status === "pending") {
            const timer = setInterval(()=>{
                setCountDown((prev)=>prev - 0.25);
            }, 250);
            if (countDown <= 0) clearInterval(timer);
            return ()=>clearInterval(timer);
        }
    }, [
        countDown
    ]);
    // Saved status timeout
    (0, $acw62.useEffect)(()=>{
        let timeoutId = null;
        if (status === "saved") timeoutId = setTimeout(()=>{
            setStatus("");
        }, 2000);
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        status
    ]);
    // Submitting status dots animation
    (0, $acw62.useEffect)(()=>{
        let interval = null;
        if (status === "submitting") interval = setInterval(()=>{
            setDots((prevDots)=>(prevDots + 1) % 5);
        }, 750);
        else setDots(0);
        return ()=>{
            if (interval) clearInterval(interval);
        };
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: saveIndicatorMessageRef,
        className: "saveIndicatorContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
            className: "saveIndicatorText",
            children: [
                status === "pending" && `Pending auto-save in ${countDown.toFixed(0)}...`,
                status === "saved" && "Successfully saved!",
                status === "submitting" && `Submitting${" .".repeat(dots)}`
            ]
        })
    });
};
var $64b95cf95a31e7f0$export$2e2bcd8739ae039 = $64b95cf95a31e7f0$var$SaveIndicator;





var $acw62 = parcelRequire("acw62");



const { confirm: $98cb8c383600531f$var$confirm } = (0, $e47cb76d58815cb1$export$2e2bcd8739ae039);
const $98cb8c383600531f$var$plotTypeToTitle = {
    heatmap: "Heatmap",
    bar_chart: "Bar Chart",
    histogram: "Histogram",
    scatter: "Scatter Plot"
};
const $98cb8c383600531f$export$14e9cfd4a872cc1e = async (blobUrl)=>{
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return blob;
};
const $98cb8c383600531f$export$47a328b4cabd57cc = (blob)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};
const $98cb8c383600531f$var$VisualizerModal = ({ isVisualizerOpen: isVisualizerOpen, generatedPlots: generatedPlots, setIsVisualizerOpen: setIsVisualizerOpen, setIsImageGalleryOpen: setIsImageGalleryOpen, plotType: plotType, setStoredImages: setStoredImages })=>{
    const [localPlotType, setLocalPlotType] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(plotType);
    const [title, setTitle] = (0, $acw62.useState)("");
    const [imageLoading, setImageLoading] = (0, $acw62.useState)(false);
    const [disableSaveImage, setDisableSaveImage] = (0, $acw62.useState)(true);
    const titleRef = (0, $acw62.useRef)(title);
    const titleInputRef = (0, $acw62.useRef)(null);
    const saveImageToDb = async (imageUrl)=>{
        const blob = await $98cb8c383600531f$export$14e9cfd4a872cc1e(imageUrl);
        const base64 = await $98cb8c383600531f$export$47a328b4cabd57cc(blob);
        (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/images/save-image", {
            image: base64,
            imageTitle: titleRef.current
        }, {
            withCredentials: true
        }).then((response)=>{
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("save_plot_image", {
                imageTitle: titleRef.current
            }, true);
            setDisableSaveImage(true);
            setStoredImages((prevImages)=>{
                if (prevImages) return [
                    ...prevImages,
                    {
                        id: response.data.image_id,
                        image_path: imageUrl,
                        image_title: titleRef.current,
                        is_temporary: true
                    }
                ];
                else return [
                    {
                        id: response.data.image_id,
                        image_path: imageUrl,
                        image_title: titleRef.current,
                        is_temporary: true
                    }
                ];
            });
        }).catch((error)=>{
            console.error("Error uploading image", error);
        }).finally(()=>{
            setImageLoading(false);
        });
    };
    const updateTitle = (e)=>{
        const newTitle = e.target.value;
        setTitle(newTitle);
        titleRef.current = newTitle;
    };
    const openSavePrompt = (defaultTitle, imageUrl)=>{
        setImageLoading(true);
        setTitle(defaultTitle);
        $98cb8c383600531f$var$confirm({
            title: "Add a title before saving",
            content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                        children: "Image Title"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                        ref: titleInputRef,
                        defaultValue: defaultTitle,
                        onChange: updateTitle
                    })
                ]
            }),
            onOk () {
                saveImageToDb(imageUrl);
            },
            onCancel () {
                setImageLoading(false);
            }
        });
        setTimeout(()=>{
            if (titleInputRef.current) {
                titleInputRef.current.focus();
                titleInputRef.current.select();
            }
        }, 100);
    };
    (0, $acw62.useEffect)(()=>{
        setLocalPlotType(plotType);
        if (plotType !== "") {
            const updateVisualizerNodes = async ()=>{
                const visualizerNodes = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNodes().filter((node)=>node.getType() === "Visualizer");
                for (const visualizer of visualizerNodes){
                    const data = await (0, $14e68cbe3c2b3085$export$9df0b6e8eb716c6a).fetch(visualizer.id);
                }
            };
            updateVisualizerNodes();
            setDisableSaveImage(false);
        }
    }, [
        generatedPlots
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
        centered: true,
        width: "40%",
        zIndex: 1000,
        open: isVisualizerOpen,
        className: "visualizerModal",
        onCancel: ()=>setIsVisualizerOpen(false),
        footer: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: ()=>setIsVisualizerOpen(false),
                type: "primary",
                danger: true,
                children: "Close"
            }, "close")
        ],
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: "Generated Plot(s)"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "plotsContainer",
                children: [
                    generatedPlots.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "noDataFoundMessage",
                        children: "No plot(s) generated, please run the program to generate a plot."
                    }),
                    generatedPlots.map((plot, index)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "singlePlotContainer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: $98cb8c383600531f$var$plotTypeToTitle[localPlotType]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: plot,
                                    alt: `Generated Plot ${index + 1}`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    className: "saveBtn",
                                    loading: imageLoading,
                                    disabled: disableSaveImage,
                                    onClick: ()=>openSavePrompt($98cb8c383600531f$var$plotTypeToTitle[localPlotType], plot),
                                    children: disableSaveImage ? "Image saved!" : imageLoading ? "Saving" : "Save Image"
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        type: "primary",
                        onClick: ()=>setIsImageGalleryOpen(true),
                        children: "View Saved Images"
                    })
                ]
            })
        ]
    });
};
var $98cb8c383600531f$export$2e2bcd8739ae039 = $98cb8c383600531f$var$VisualizerModal;




var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $f6b39a89eb32b427$export$3062997f0b99863 = /*#__PURE__*/ $acw62.createContext(null);


var $ad989023bcb6c68a$var$Operations = function Operations(props) {
    var visible = props.visible, maskTransitionName = props.maskTransitionName, getContainer = props.getContainer, prefixCls = props.prefixCls, rootClassName = props.rootClassName, icons = props.icons, countRender = props.countRender, showSwitch = props.showSwitch, showProgress = props.showProgress, current = props.current, transform = props.transform, count = props.count, scale = props.scale, minScale = props.minScale, maxScale = props.maxScale, closeIcon = props.closeIcon, onSwitchLeft = props.onSwitchLeft, onSwitchRight = props.onSwitchRight, onClose = props.onClose, onZoomIn = props.onZoomIn, onZoomOut = props.onZoomOut, onRotateRight = props.onRotateRight, onRotateLeft = props.onRotateLeft, onFlipX = props.onFlipX, onFlipY = props.onFlipY, onReset = props.onReset, toolbarRender = props.toolbarRender, zIndex = props.zIndex, image = props.image;
    var groupContext = (0, $acw62.useContext)((0, $f6b39a89eb32b427$export$3062997f0b99863));
    var rotateLeft = icons.rotateLeft, rotateRight = icons.rotateRight, zoomIn = icons.zoomIn, zoomOut = icons.zoomOut, close = icons.close, left = icons.left, right = icons.right, flipX = icons.flipX, flipY = icons.flipY;
    var toolClassName = "".concat(prefixCls, "-operations-operation");
    $acw62.useEffect(function() {
        var onKeyDown = function onKeyDown(e) {
            if (e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC) onClose();
        };
        if (visible) window.addEventListener("keydown", onKeyDown);
        return function() {
            window.removeEventListener("keydown", onKeyDown);
        };
    }, [
        visible
    ]);
    var tools = [
        {
            icon: flipY,
            onClick: onFlipY,
            type: "flipY"
        },
        {
            icon: flipX,
            onClick: onFlipX,
            type: "flipX"
        },
        {
            icon: rotateLeft,
            onClick: onRotateLeft,
            type: "rotateLeft"
        },
        {
            icon: rotateRight,
            onClick: onRotateRight,
            type: "rotateRight"
        },
        {
            icon: zoomOut,
            onClick: onZoomOut,
            type: "zoomOut",
            disabled: scale <= minScale
        },
        {
            icon: zoomIn,
            onClick: onZoomIn,
            type: "zoomIn",
            disabled: scale === maxScale
        }
    ];
    var toolsNode = tools.map(function(_ref) {
        var _classnames;
        var icon = _ref.icon, onClick = _ref.onClick, type = _ref.type, disabled = _ref.disabled;
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(toolClassName, (_classnames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classnames, "".concat(prefixCls, "-operations-operation-").concat(type), true), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classnames, "".concat(prefixCls, "-operations-operation-disabled"), !!disabled), _classnames)),
            onClick: onClick,
            key: type
        }, icon);
    });
    var toolbarNode = /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-operations")
    }, toolsNode);
    return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: visible,
        motionName: maskTransitionName
    }, function(_ref2) {
        var className = _ref2.className, style = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement((0, $5b46218595a40828$export$2e2bcd8739ae039), {
            open: true,
            getContainer: getContainer !== null && getContainer !== void 0 ? getContainer : document.body
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-operations-wrapper"), className, rootClassName),
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), {}, {
                zIndex: zIndex
            })
        }, closeIcon === null ? null : /*#__PURE__*/ $acw62.createElement("button", {
            className: "".concat(prefixCls, "-close"),
            onClick: onClose
        }, closeIcon || close), showSwitch && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-switch-left"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-switch-left-disabled"), current === 0)),
            onClick: onSwitchLeft
        }, left), /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-switch-right"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-switch-right-disabled"), current === count - 1)),
            onClick: onSwitchRight
        }, right)), /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-footer")
        }, showProgress && /*#__PURE__*/ $acw62.createElement("div", {
            className: "".concat(prefixCls, "-progress")
        }, countRender ? countRender(current + 1, count) : "".concat(current + 1, " / ").concat(count)), toolbarRender ? toolbarRender(toolbarNode, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            icons: {
                flipYIcon: toolsNode[0],
                flipXIcon: toolsNode[1],
                rotateLeftIcon: toolsNode[2],
                rotateRightIcon: toolsNode[3],
                zoomOutIcon: toolsNode[4],
                zoomInIcon: toolsNode[5]
            },
            actions: {
                onFlipY: onFlipY,
                onFlipX: onFlipX,
                onRotateLeft: onRotateLeft,
                onRotateRight: onRotateRight,
                onZoomOut: onZoomOut,
                onZoomIn: onZoomIn,
                onReset: onReset,
                onClose: onClose
            },
            transform: transform
        }, groupContext ? {
            current: current,
            total: count
        } : {}), {}, {
            image: image
        })) : toolbarNode)));
    });
};
var $ad989023bcb6c68a$export$2e2bcd8739ae039 = $ad989023bcb6c68a$var$Operations;









var $acw62 = parcelRequire("acw62");
var $8042920a8b955a80$var$initialTransform = {
    x: 0,
    y: 0,
    rotate: 0,
    scale: 1,
    flipX: false,
    flipY: false
};
function $8042920a8b955a80$export$2e2bcd8739ae039(imgRef, minScale, maxScale, onTransform) {
    var frame = (0, $acw62.useRef)(null);
    var queue = (0, $acw62.useRef)([]);
    var _useState = (0, $acw62.useState)($8042920a8b955a80$var$initialTransform), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), transform = _useState2[0], setTransform = _useState2[1];
    var resetTransform = function resetTransform(action) {
        setTransform($8042920a8b955a80$var$initialTransform);
        if (!(0, $357adc8667cde522$export$2e2bcd8739ae039)($8042920a8b955a80$var$initialTransform, transform)) onTransform === null || onTransform === void 0 || onTransform({
            transform: $8042920a8b955a80$var$initialTransform,
            action: action
        });
    };
    /** Direct update transform */ var updateTransform = function updateTransform(newTransform, action) {
        if (frame.current === null) {
            queue.current = [];
            frame.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
                setTransform(function(preState) {
                    var memoState = preState;
                    queue.current.forEach(function(queueState) {
                        memoState = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, memoState), queueState);
                    });
                    frame.current = null;
                    onTransform === null || onTransform === void 0 || onTransform({
                        transform: memoState,
                        action: action
                    });
                    return memoState;
                });
            });
        }
        queue.current.push((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, transform), newTransform));
    };
    /** Scale according to the position of centerX and centerY */ var dispatchZoomChange = function dispatchZoomChange(ratio, action, centerX, centerY, isTouch) {
        var _imgRef$current = imgRef.current, width = _imgRef$current.width, height = _imgRef$current.height, offsetWidth = _imgRef$current.offsetWidth, offsetHeight = _imgRef$current.offsetHeight, offsetLeft = _imgRef$current.offsetLeft, offsetTop = _imgRef$current.offsetTop;
        var newRatio = ratio;
        var newScale = transform.scale * ratio;
        if (newScale > maxScale) {
            newScale = maxScale;
            newRatio = maxScale / transform.scale;
        } else if (newScale < minScale) {
            // For mobile interactions, allow scaling down to the minimum scale.
            newScale = isTouch ? newScale : minScale;
            newRatio = newScale / transform.scale;
        }
        /** Default center point scaling */ var mergedCenterX = centerX !== null && centerX !== void 0 ? centerX : innerWidth / 2;
        var mergedCenterY = centerY !== null && centerY !== void 0 ? centerY : innerHeight / 2;
        var diffRatio = newRatio - 1;
        /** Deviation calculated from image size */ var diffImgX = diffRatio * width * 0.5;
        var diffImgY = diffRatio * height * 0.5;
        /** The difference between the click position and the edge of the document */ var diffOffsetLeft = diffRatio * (mergedCenterX - transform.x - offsetLeft);
        var diffOffsetTop = diffRatio * (mergedCenterY - transform.y - offsetTop);
        /** Final positioning */ var newX = transform.x - (diffOffsetLeft - diffImgX);
        var newY = transform.y - (diffOffsetTop - diffImgY);
        /**
     * When zooming the image
     * When the image size is smaller than the width and height of the window, the position is initialized
     */ if (ratio < 1 && newScale === 1) {
            var mergedWidth = offsetWidth * newScale;
            var mergedHeight = offsetHeight * newScale;
            var _getClientSize = (0, $cbf8b6c8fd246421$export$1feb45891927fcb4)(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
            if (mergedWidth <= clientWidth && mergedHeight <= clientHeight) {
                newX = 0;
                newY = 0;
            }
        }
        updateTransform({
            x: newX,
            y: newY,
            scale: newScale
        }, action);
    };
    return {
        transform: transform,
        resetTransform: resetTransform,
        updateTransform: updateTransform,
        dispatchZoomChange: dispatchZoomChange
    };
}







var $acw62 = parcelRequire("acw62");



function $72833f9ac99418e5$var$fixPoint(key, start, width, clientWidth) {
    var startAddWidth = start + width;
    var offsetStart = (width - clientWidth) / 2;
    if (width > clientWidth) {
        if (start > 0) return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, key, offsetStart);
        if (start < 0 && startAddWidth < clientWidth) return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, key, -offsetStart);
    } else if (start < 0 || startAddWidth > clientWidth) return (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, key, start < 0 ? offsetStart : -offsetStart);
    return {};
}
function $72833f9ac99418e5$export$2e2bcd8739ae039(width, height, left, top) {
    var _getClientSize = (0, $cbf8b6c8fd246421$export$1feb45891927fcb4)(), clientWidth = _getClientSize.width, clientHeight = _getClientSize.height;
    var fixPos = null;
    if (width <= clientWidth && height <= clientHeight) fixPos = {
        x: 0,
        y: 0
    };
    else if (width > clientWidth || height > clientHeight) fixPos = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, $72833f9ac99418e5$var$fixPoint("x", left, width, clientWidth)), $72833f9ac99418e5$var$fixPoint("y", top, height, clientHeight));
    return fixPos;
}


/** Scale the ratio base */ var $e759751996a0e6db$export$6e76060232ffaf48 = 1;
var $e759751996a0e6db$export$137a7d87d4a2aae5 = 1;


function $21fd334325859aa7$export$2e2bcd8739ae039(imgRef, movable, visible, scaleStep, transform, updateTransform, dispatchZoomChange) {
    var rotate = transform.rotate, scale = transform.scale, x = transform.x, y = transform.y;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), isMoving = _useState2[0], setMoving = _useState2[1];
    var startPositionInfo = (0, $acw62.useRef)({
        diffX: 0,
        diffY: 0,
        transformX: 0,
        transformY: 0
    });
    var onMouseDown = function onMouseDown(event) {
        // Only allow main button
        if (!movable || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        startPositionInfo.current = {
            diffX: event.pageX - x,
            diffY: event.pageY - y,
            transformX: x,
            transformY: y
        };
        setMoving(true);
    };
    var onMouseMove = function onMouseMove(event) {
        if (visible && isMoving) updateTransform({
            x: event.pageX - startPositionInfo.current.diffX,
            y: event.pageY - startPositionInfo.current.diffY
        }, "move");
    };
    var onMouseUp = function onMouseUp() {
        if (visible && isMoving) {
            setMoving(false);
            /** No need to restore the position when the picture is not moved, So as not to interfere with the click */ var _startPositionInfo$cu = startPositionInfo.current, transformX = _startPositionInfo$cu.transformX, transformY = _startPositionInfo$cu.transformY;
            var hasChangedPosition = x !== transformX && y !== transformY;
            if (!hasChangedPosition) return;
            var width = imgRef.current.offsetWidth * scale;
            var height = imgRef.current.offsetHeight * scale;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(), left = _imgRef$current$getBo.left, top = _imgRef$current$getBo.top;
            var isRotate = rotate % 180 !== 0;
            var fixState = (0, $72833f9ac99418e5$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
            if (fixState) updateTransform((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, fixState), "dragRebound");
        }
    };
    var onWheel = function onWheel(event) {
        if (!visible || event.deltaY == 0) return;
        // Scale ratio depends on the deltaY size
        var scaleRatio = Math.abs(event.deltaY / 100);
        // Limit the maximum scale ratio
        var mergedScaleRatio = Math.min(scaleRatio, (0, $e759751996a0e6db$export$137a7d87d4a2aae5));
        // Scale the ratio each time
        var ratio = (0, $e759751996a0e6db$export$6e76060232ffaf48) + mergedScaleRatio * scaleStep;
        if (event.deltaY > 0) ratio = (0, $e759751996a0e6db$export$6e76060232ffaf48) / ratio;
        dispatchZoomChange(ratio, "wheel", event.clientX, event.clientY);
    };
    (0, $acw62.useEffect)(function() {
        var onTopMouseUpListener;
        var onTopMouseMoveListener;
        var onMouseUpListener;
        var onMouseMoveListener;
        if (movable) {
            onMouseUpListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "mouseup", onMouseUp, false);
            onMouseMoveListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "mousemove", onMouseMove, false);
            try {
                // Resolve if in iframe lost event
                /* istanbul ignore next */ if (window.top !== window.self) {
                    onTopMouseUpListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window.top, "mouseup", onMouseUp, false);
                    onTopMouseMoveListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window.top, "mousemove", onMouseMove, false);
                }
            } catch (error) {
                /* istanbul ignore next */ (0, $05a5f2c645683a81$export$491112666e282270)(false, "[rc-image] ".concat(error));
            }
        }
        return function() {
            var _onMouseUpListener, _onMouseMoveListener, _onTopMouseUpListener, _onTopMouseMoveListen;
            (_onMouseUpListener = onMouseUpListener) === null || _onMouseUpListener === void 0 || _onMouseUpListener.remove();
            (_onMouseMoveListener = onMouseMoveListener) === null || _onMouseMoveListener === void 0 || _onMouseMoveListener.remove();
            /* istanbul ignore next */ (_onTopMouseUpListener = onTopMouseUpListener) === null || _onTopMouseUpListener === void 0 || _onTopMouseUpListener.remove();
            /* istanbul ignore next */ (_onTopMouseMoveListen = onTopMouseMoveListener) === null || _onTopMouseMoveListen === void 0 || _onTopMouseMoveListen.remove();
        };
    }, [
        visible,
        isMoving,
        x,
        y,
        rotate,
        movable
    ]);
    return {
        isMoving: isMoving,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        onWheel: onWheel
    };
}




var $acw62 = parcelRequire("acw62");
function $5ff374bbb553478f$export$602246410992d405(src) {
    return new Promise(function(resolve) {
        var img = document.createElement("img");
        img.onerror = function() {
            return resolve(false);
        };
        img.onload = function() {
            return resolve(true);
        };
        img.src = src;
    });
}


function $e610472e6a9db819$export$2e2bcd8739ae039(_ref) {
    var src = _ref.src, isCustomPlaceholder = _ref.isCustomPlaceholder, fallback = _ref.fallback;
    var _useState = (0, $acw62.useState)(isCustomPlaceholder ? "loading" : "normal"), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setStatus = _useState2[1];
    var isLoaded = (0, $acw62.useRef)(false);
    var isError = status === "error";
    // https://github.com/react-component/image/pull/187
    (0, $acw62.useEffect)(function() {
        var isCurrentSrc = true;
        (0, $5ff374bbb553478f$export$602246410992d405)(src).then(function(isValid) {
            // https://github.com/ant-design/ant-design/issues/44948
            // If src changes, the previous setStatus should not be triggered
            if (!isValid && isCurrentSrc) setStatus("error");
        });
        return function() {
            isCurrentSrc = false;
        };
    }, [
        src
    ]);
    (0, $acw62.useEffect)(function() {
        if (isCustomPlaceholder && !isLoaded.current) setStatus("loading");
        else if (isError) setStatus("normal");
    }, [
        src
    ]);
    var onLoad = function onLoad() {
        setStatus("normal");
    };
    var getImgRef = function getImgRef(img) {
        isLoaded.current = false;
        if (status === "loading" && img !== null && img !== void 0 && img.complete && (img.naturalWidth || img.naturalHeight)) {
            isLoaded.current = true;
            onLoad();
        }
    };
    var srcAndOnload = isError && fallback ? {
        src: fallback
    } : {
        onLoad: onLoad,
        src: src
    };
    return [
        getImgRef,
        srcAndOnload,
        status
    ];
}






var $acw62 = parcelRequire("acw62");

function $dd0a084636b5859d$var$getDistance(a, b) {
    var x = a.x - b.x;
    var y = a.y - b.y;
    return Math.hypot(x, y);
}
function $dd0a084636b5859d$var$getCenter(oldPoint1, oldPoint2, newPoint1, newPoint2) {
    // Calculate the distance each point has moved
    var distance1 = $dd0a084636b5859d$var$getDistance(oldPoint1, newPoint1);
    var distance2 = $dd0a084636b5859d$var$getDistance(oldPoint2, newPoint2);
    // If both distances are 0, return the original points
    if (distance1 === 0 && distance2 === 0) return [
        oldPoint1.x,
        oldPoint1.y
    ];
    // Calculate the ratio of the distances
    var ratio = distance1 / (distance1 + distance2);
    // Calculate the new center point based on the ratio
    var x = oldPoint1.x + ratio * (oldPoint2.x - oldPoint1.x);
    var y = oldPoint1.y + ratio * (oldPoint2.y - oldPoint1.y);
    return [
        x,
        y
    ];
}
function $dd0a084636b5859d$export$2e2bcd8739ae039(imgRef, movable, visible, minScale, transform, updateTransform, dispatchZoomChange) {
    var rotate = transform.rotate, scale = transform.scale, x = transform.x, y = transform.y;
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), isTouching = _useState2[0], setIsTouching = _useState2[1];
    var touchPointInfo = (0, $acw62.useRef)({
        point1: {
            x: 0,
            y: 0
        },
        point2: {
            x: 0,
            y: 0
        },
        eventType: "none"
    });
    var updateTouchPointInfo = function updateTouchPointInfo(values) {
        touchPointInfo.current = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, touchPointInfo.current), values);
    };
    var onTouchStart = function onTouchStart(event) {
        if (!movable) return;
        event.stopPropagation();
        setIsTouching(true);
        var _event$touches = event.touches, touches = _event$touches === void 0 ? [] : _event$touches;
        if (touches.length > 1) // touch zoom
        updateTouchPointInfo({
            point1: {
                x: touches[0].clientX,
                y: touches[0].clientY
            },
            point2: {
                x: touches[1].clientX,
                y: touches[1].clientY
            },
            eventType: "touchZoom"
        });
        else // touch move
        updateTouchPointInfo({
            point1: {
                x: touches[0].clientX - x,
                y: touches[0].clientY - y
            },
            eventType: "move"
        });
    };
    var onTouchMove = function onTouchMove(event) {
        var _event$touches2 = event.touches, touches = _event$touches2 === void 0 ? [] : _event$touches2;
        var _touchPointInfo$curre = touchPointInfo.current, point1 = _touchPointInfo$curre.point1, point2 = _touchPointInfo$curre.point2, eventType = _touchPointInfo$curre.eventType;
        if (touches.length > 1 && eventType === "touchZoom") {
            // touch zoom
            var newPoint1 = {
                x: touches[0].clientX,
                y: touches[0].clientY
            };
            var newPoint2 = {
                x: touches[1].clientX,
                y: touches[1].clientY
            };
            var _getCenter = $dd0a084636b5859d$var$getCenter(point1, point2, newPoint1, newPoint2), _getCenter2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getCenter, 2), centerX = _getCenter2[0], centerY = _getCenter2[1];
            var ratio = $dd0a084636b5859d$var$getDistance(newPoint1, newPoint2) / $dd0a084636b5859d$var$getDistance(point1, point2);
            dispatchZoomChange(ratio, "touchZoom", centerX, centerY, true);
            updateTouchPointInfo({
                point1: newPoint1,
                point2: newPoint2,
                eventType: "touchZoom"
            });
        } else if (eventType === "move") {
            // touch move
            updateTransform({
                x: touches[0].clientX - point1.x,
                y: touches[0].clientY - point1.y
            }, "move");
            updateTouchPointInfo({
                eventType: "move"
            });
        }
    };
    var onTouchEnd = function onTouchEnd() {
        if (!visible) return;
        if (isTouching) setIsTouching(false);
        updateTouchPointInfo({
            eventType: "none"
        });
        if (minScale > scale) /** When the scaling ratio is less than the minimum scaling ratio, reset the scaling ratio */ return updateTransform({
            x: 0,
            y: 0,
            scale: minScale
        }, "touchZoom");
        var width = imgRef.current.offsetWidth * scale;
        var height = imgRef.current.offsetHeight * scale;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var _imgRef$current$getBo = imgRef.current.getBoundingClientRect(), left = _imgRef$current$getBo.left, top = _imgRef$current$getBo.top;
        var isRotate = rotate % 180 !== 0;
        var fixState = (0, $72833f9ac99418e5$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
        if (fixState) updateTransform((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, fixState), "dragRebound");
    };
    (0, $acw62.useEffect)(function() {
        var onTouchMoveListener;
        if (visible && movable) onTouchMoveListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "touchmove", function(e) {
            return e.preventDefault();
        }, {
            passive: false
        });
        return function() {
            var _onTouchMoveListener;
            (_onTouchMoveListener = onTouchMoveListener) === null || _onTouchMoveListener === void 0 || _onTouchMoveListener.remove();
        };
    }, [
        visible,
        movable
    ]);
    return {
        isTouching: isTouching,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
}



var $642d0c4e097edefe$var$_excluded = [
    "fallback",
    "src",
    "imgRef"
], $642d0c4e097edefe$var$_excluded2 = [
    "prefixCls",
    "src",
    "alt",
    "imageInfo",
    "fallback",
    "movable",
    "onClose",
    "visible",
    "icons",
    "rootClassName",
    "closeIcon",
    "getContainer",
    "current",
    "count",
    "countRender",
    "scaleStep",
    "minScale",
    "maxScale",
    "transitionName",
    "maskTransitionName",
    "imageRender",
    "imgCommonProps",
    "toolbarRender",
    "onTransform",
    "onChange"
];
var $642d0c4e097edefe$var$PreviewImage = function PreviewImage(_ref) {
    var fallback = _ref.fallback, src = _ref.src, imgRef = _ref.imgRef, props = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $642d0c4e097edefe$var$_excluded);
    var _useStatus = (0, $e610472e6a9db819$export$2e2bcd8739ae039)({
        src: src,
        fallback: fallback
    }), _useStatus2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStatus, 2), getImgRef = _useStatus2[0], srcAndOnload = _useStatus2[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: function ref(_ref2) {
            imgRef.current = _ref2;
            getImgRef(_ref2);
        }
    }, props, srcAndOnload));
};
var $642d0c4e097edefe$var$Preview = function Preview(props) {
    var prefixCls = props.prefixCls, src = props.src, alt = props.alt, imageInfo = props.imageInfo, fallback = props.fallback, _props$movable = props.movable, movable = _props$movable === void 0 ? true : _props$movable, onClose = props.onClose, visible = props.visible, _props$icons = props.icons, icons = _props$icons === void 0 ? {} : _props$icons, rootClassName = props.rootClassName, closeIcon = props.closeIcon, getContainer = props.getContainer, _props$current = props.current, current = _props$current === void 0 ? 0 : _props$current, _props$count = props.count, count = _props$count === void 0 ? 1 : _props$count, countRender = props.countRender, _props$scaleStep = props.scaleStep, scaleStep = _props$scaleStep === void 0 ? 0.5 : _props$scaleStep, _props$minScale = props.minScale, minScale = _props$minScale === void 0 ? 1 : _props$minScale, _props$maxScale = props.maxScale, maxScale = _props$maxScale === void 0 ? 50 : _props$maxScale, _props$transitionName = props.transitionName, transitionName = _props$transitionName === void 0 ? "zoom" : _props$transitionName, _props$maskTransition = props.maskTransitionName, maskTransitionName = _props$maskTransition === void 0 ? "fade" : _props$maskTransition, imageRender = props.imageRender, imgCommonProps = props.imgCommonProps, toolbarRender = props.toolbarRender, onTransform = props.onTransform, onChange = props.onChange, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $642d0c4e097edefe$var$_excluded2);
    var imgRef = (0, $acw62.useRef)();
    var groupContext = (0, $acw62.useContext)((0, $f6b39a89eb32b427$export$3062997f0b99863));
    var showLeftOrRightSwitches = groupContext && count > 1;
    var showOperationsProgress = groupContext && count >= 1;
    var _useState = (0, $acw62.useState)(true), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), enableTransition = _useState2[0], setEnableTransition = _useState2[1];
    var _useImageTransform = (0, $8042920a8b955a80$export$2e2bcd8739ae039)(imgRef, minScale, maxScale, onTransform), transform = _useImageTransform.transform, resetTransform = _useImageTransform.resetTransform, updateTransform = _useImageTransform.updateTransform, dispatchZoomChange = _useImageTransform.dispatchZoomChange;
    var _useMouseEvent = (0, $21fd334325859aa7$export$2e2bcd8739ae039)(imgRef, movable, visible, scaleStep, transform, updateTransform, dispatchZoomChange), isMoving = _useMouseEvent.isMoving, onMouseDown = _useMouseEvent.onMouseDown, onWheel = _useMouseEvent.onWheel;
    var _useTouchEvent = (0, $dd0a084636b5859d$export$2e2bcd8739ae039)(imgRef, movable, visible, minScale, transform, updateTransform, dispatchZoomChange), isTouching = _useTouchEvent.isTouching, onTouchStart = _useTouchEvent.onTouchStart, onTouchMove = _useTouchEvent.onTouchMove, onTouchEnd = _useTouchEvent.onTouchEnd;
    var rotate = transform.rotate, scale = transform.scale;
    var wrapClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-moving"), isMoving));
    (0, $acw62.useEffect)(function() {
        if (!enableTransition) setEnableTransition(true);
    }, [
        enableTransition
    ]);
    var onAfterClose = function onAfterClose() {
        resetTransform("close");
    };
    var onZoomIn = function onZoomIn() {
        dispatchZoomChange((0, $e759751996a0e6db$export$6e76060232ffaf48) + scaleStep, "zoomIn");
    };
    var onZoomOut = function onZoomOut() {
        dispatchZoomChange((0, $e759751996a0e6db$export$6e76060232ffaf48) / ((0, $e759751996a0e6db$export$6e76060232ffaf48) + scaleStep), "zoomOut");
    };
    var onRotateRight = function onRotateRight() {
        updateTransform({
            rotate: rotate + 90
        }, "rotateRight");
    };
    var onRotateLeft = function onRotateLeft() {
        updateTransform({
            rotate: rotate - 90
        }, "rotateLeft");
    };
    var onFlipX = function onFlipX() {
        updateTransform({
            flipX: !transform.flipX
        }, "flipX");
    };
    var onFlipY = function onFlipY() {
        updateTransform({
            flipY: !transform.flipY
        }, "flipY");
    };
    var onReset = function onReset() {
        resetTransform("reset");
    };
    var onSwitchLeft = function onSwitchLeft(event) {
        event === null || event === void 0 || event.preventDefault();
        event === null || event === void 0 || event.stopPropagation();
        if (current > 0) {
            setEnableTransition(false);
            resetTransform("prev");
            onChange === null || onChange === void 0 || onChange(current - 1, current);
        }
    };
    var onSwitchRight = function onSwitchRight(event) {
        event === null || event === void 0 || event.preventDefault();
        event === null || event === void 0 || event.stopPropagation();
        if (current < count - 1) {
            setEnableTransition(false);
            resetTransform("next");
            onChange === null || onChange === void 0 || onChange(current + 1, current);
        }
    };
    var onKeyDown = function onKeyDown(event) {
        if (!visible || !showLeftOrRightSwitches) return;
        if (event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).LEFT) onSwitchLeft();
        else if (event.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).RIGHT) onSwitchRight();
    };
    var onDoubleClick = function onDoubleClick(event) {
        if (visible) {
            if (scale !== 1) updateTransform({
                x: 0,
                y: 0,
                scale: 1
            }, "doubleClick");
            else dispatchZoomChange((0, $e759751996a0e6db$export$6e76060232ffaf48) + scaleStep, "doubleClick", event.clientX, event.clientY);
        }
    };
    (0, $acw62.useEffect)(function() {
        var onKeyDownListener = (0, $0860008a706f6e42$export$2e2bcd8739ae039)(window, "keydown", onKeyDown, false);
        return function() {
            onKeyDownListener.remove();
        };
    }, [
        visible,
        showLeftOrRightSwitches,
        current
    ]);
    var imgNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($642d0c4e097edefe$var$PreviewImage, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, imgCommonProps, {
        width: props.width,
        height: props.height,
        imgRef: imgRef,
        className: "".concat(prefixCls, "-img"),
        alt: alt,
        style: {
            transform: "translate3d(".concat(transform.x, "px, ").concat(transform.y, "px, 0) scale3d(").concat(transform.flipX ? "-" : "").concat(scale, ", ").concat(transform.flipY ? "-" : "").concat(scale, ", 1) rotate(").concat(rotate, "deg)"),
            transitionDuration: (!enableTransition || isTouching) && "0s"
        },
        fallback: fallback,
        src: src,
        onWheel: onWheel,
        onMouseDown: onMouseDown,
        onDoubleClick: onDoubleClick,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onTouchCancel: onTouchEnd
    }));
    var image = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        url: src,
        alt: alt
    }, imageInfo);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fc48b5916203bd39$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        transitionName: transitionName,
        maskTransitionName: maskTransitionName,
        closable: false,
        keyboard: true,
        prefixCls: prefixCls,
        onClose: onClose,
        visible: visible,
        classNames: {
            wrapper: wrapClassName
        },
        rootClassName: rootClassName,
        getContainer: getContainer
    }, restProps, {
        afterClose: onAfterClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "".concat(prefixCls, "-img-wrapper")
    }, imageRender ? imageRender(imgNode, (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        transform: transform,
        image: image
    }, groupContext ? {
        current: current
    } : {})) : imgNode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ad989023bcb6c68a$export$2e2bcd8739ae039), {
        visible: visible,
        transform: transform,
        maskTransitionName: maskTransitionName,
        closeIcon: closeIcon,
        getContainer: getContainer,
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        icons: icons,
        countRender: countRender,
        showSwitch: showLeftOrRightSwitches,
        showProgress: showOperationsProgress,
        current: current,
        count: count,
        scale: scale,
        minScale: minScale,
        maxScale: maxScale,
        toolbarRender: toolbarRender,
        onSwitchLeft: onSwitchLeft,
        onSwitchRight: onSwitchRight,
        onZoomIn: onZoomIn,
        onZoomOut: onZoomOut,
        onRotateRight: onRotateRight,
        onRotateLeft: onRotateLeft,
        onFlipX: onFlipX,
        onFlipY: onFlipY,
        onClose: onClose,
        onReset: onReset,
        zIndex: restProps.zIndex !== undefined ? restProps.zIndex + 1 : undefined,
        image: image
    }));
};
var $642d0c4e097edefe$export$2e2bcd8739ae039 = $642d0c4e097edefe$var$Preview;








var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
var $0968bdba463aae69$export$2367aee66755576 = [
    "crossOrigin",
    "decoding",
    "draggable",
    "loading",
    "referrerPolicy",
    "sizes",
    "srcSet",
    "useMap",
    "alt"
];


function $36d509a6c9957d99$export$2e2bcd8739ae039(items) {
    // Context collection image data
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), images = _React$useState2[0], setImages = _React$useState2[1];
    var registerImage = $acw62.useCallback(function(id, data) {
        setImages(function(imgs) {
            return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, imgs), {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, id, data));
        });
        return function() {
            setImages(function(imgs) {
                var cloneImgs = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, imgs);
                delete cloneImgs[id];
                return cloneImgs;
            });
        };
    }, []);
    // items
    var mergedItems = $acw62.useMemo(function() {
        // use `items` first
        if (items) return items.map(function(item) {
            if (typeof item === "string") return {
                data: {
                    src: item
                }
            };
            var data = {};
            Object.keys(item).forEach(function(key) {
                if ([
                    "src"
                ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)((0, $0968bdba463aae69$export$2367aee66755576))).includes(key)) data[key] = item[key];
            });
            return {
                data: data
            };
        });
        // use registered images secondly
        return Object.keys(images).reduce(function(total, id) {
            var _images$id = images[id], canPreview = _images$id.canPreview, data = _images$id.data;
            if (canPreview) total.push({
                data: data,
                id: id
            });
            return total;
        }, []);
    }, [
        items,
        images
    ]);
    return [
        mergedItems,
        registerImage,
        !!items
    ];
}


var $24a9b4d085f66d2e$var$_excluded = [
    "visible",
    "onVisibleChange",
    "getContainer",
    "current",
    "movable",
    "minScale",
    "maxScale",
    "countRender",
    "closeIcon",
    "onChange",
    "onTransform",
    "toolbarRender",
    "imageRender"
], $24a9b4d085f66d2e$var$_excluded2 = [
    "src"
];
var $24a9b4d085f66d2e$var$Group = function Group(_ref) {
    var _mergedItems$current;
    var _ref$previewPrefixCls = _ref.previewPrefixCls, previewPrefixCls = _ref$previewPrefixCls === void 0 ? "rc-image-preview" : _ref$previewPrefixCls, children = _ref.children, _ref$icons = _ref.icons, icons = _ref$icons === void 0 ? {} : _ref$icons, items = _ref.items, preview = _ref.preview, fallback = _ref.fallback;
    var _ref2 = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(preview) === "object" ? preview : {}, previewVisible = _ref2.visible, onVisibleChange = _ref2.onVisibleChange, getContainer = _ref2.getContainer, currentIndex = _ref2.current, movable = _ref2.movable, minScale = _ref2.minScale, maxScale = _ref2.maxScale, countRender = _ref2.countRender, closeIcon = _ref2.closeIcon, onChange = _ref2.onChange, onTransform = _ref2.onTransform, toolbarRender = _ref2.toolbarRender, imageRender = _ref2.imageRender, dialogProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $24a9b4d085f66d2e$var$_excluded);
    // ========================== Items ===========================
    var _usePreviewItems = (0, $36d509a6c9957d99$export$2e2bcd8739ae039)(items), _usePreviewItems2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_usePreviewItems, 3), mergedItems = _usePreviewItems2[0], register = _usePreviewItems2[1], fromItems = _usePreviewItems2[2];
    // ========================= Preview ==========================
    // >>> Index
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(0, {
        value: currentIndex
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), current = _useMergedState2[0], setCurrent = _useMergedState2[1];
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), keepOpenIndex = _useState2[0], setKeepOpenIndex = _useState2[1];
    // >>> Image
    var _ref3 = ((_mergedItems$current = mergedItems[current]) === null || _mergedItems$current === void 0 ? void 0 : _mergedItems$current.data) || {}, src = _ref3.src, imgCommonProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref3, $24a9b4d085f66d2e$var$_excluded2);
    // >>> Visible
    var _useMergedState3 = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(!!previewVisible, {
        value: previewVisible,
        onChange: function onChange(val, prevVal) {
            onVisibleChange === null || onVisibleChange === void 0 || onVisibleChange(val, prevVal, current);
        }
    }), _useMergedState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState3, 2), isShowPreview = _useMergedState4[0], setShowPreview = _useMergedState4[1];
    // >>> Position
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), mousePosition = _useState4[0], setMousePosition = _useState4[1];
    var onPreviewFromImage = $acw62.useCallback(function(id, imageSrc, mouseX, mouseY) {
        var index = fromItems ? mergedItems.findIndex(function(item) {
            return item.data.src === imageSrc;
        }) : mergedItems.findIndex(function(item) {
            return item.id === id;
        });
        setCurrent(index < 0 ? 0 : index);
        setShowPreview(true);
        setMousePosition({
            x: mouseX,
            y: mouseY
        });
        setKeepOpenIndex(true);
    }, [
        mergedItems,
        fromItems
    ]);
    // Reset current when reopen
    $acw62.useEffect(function() {
        if (isShowPreview) {
            if (!keepOpenIndex) setCurrent(0);
        } else setKeepOpenIndex(false);
    }, [
        isShowPreview
    ]);
    // ========================== Events ==========================
    var onInternalChange = function onInternalChange(next, prev) {
        setCurrent(next);
        onChange === null || onChange === void 0 || onChange(next, prev);
    };
    var onPreviewClose = function onPreviewClose() {
        setShowPreview(false);
        setMousePosition(null);
    };
    // ========================= Context ==========================
    var previewGroupContext = $acw62.useMemo(function() {
        return {
            register: register,
            onPreview: onPreviewFromImage
        };
    }, [
        register,
        onPreviewFromImage
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $acw62.createElement((0, $f6b39a89eb32b427$export$3062997f0b99863).Provider, {
        value: previewGroupContext
    }, children, /*#__PURE__*/ $acw62.createElement((0, $642d0c4e097edefe$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": !isShowPreview,
        movable: movable,
        visible: isShowPreview,
        prefixCls: previewPrefixCls,
        closeIcon: closeIcon,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        imgCommonProps: imgCommonProps,
        src: src,
        fallback: fallback,
        icons: icons,
        minScale: minScale,
        maxScale: maxScale,
        getContainer: getContainer,
        current: current,
        count: mergedItems.length,
        countRender: countRender,
        onTransform: onTransform,
        toolbarRender: toolbarRender,
        imageRender: imageRender,
        onChange: onInternalChange
    }, dialogProps)));
};
var $24a9b4d085f66d2e$export$2e2bcd8739ae039 = $24a9b4d085f66d2e$var$Group;






var $acw62 = parcelRequire("acw62");

var $1b19903abeb5a7ec$var$uid = 0;
function $1b19903abeb5a7ec$export$2e2bcd8739ae039(canPreview, data) {
    var _React$useState = $acw62.useState(function() {
        $1b19903abeb5a7ec$var$uid += 1;
        return String($1b19903abeb5a7ec$var$uid);
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 1), id = _React$useState2[0];
    var groupContext = $acw62.useContext((0, $f6b39a89eb32b427$export$3062997f0b99863));
    var registerData = {
        data: data,
        canPreview: canPreview
    };
    // Keep order start
    // Resolve https://github.com/ant-design/ant-design/issues/28881
    // Only need unRegister when component unMount
    $acw62.useEffect(function() {
        if (groupContext) return groupContext.register(id, registerData);
    }, []);
    $acw62.useEffect(function() {
        if (groupContext) groupContext.register(id, registerData);
    }, [
        canPreview,
        data
    ]);
    return id;
}



var $bca85f3e75975fa9$var$_excluded = [
    "src",
    "alt",
    "onPreviewClose",
    "prefixCls",
    "previewPrefixCls",
    "placeholder",
    "fallback",
    "width",
    "height",
    "style",
    "preview",
    "className",
    "onClick",
    "onError",
    "wrapperClassName",
    "wrapperStyle",
    "rootClassName"
], $bca85f3e75975fa9$var$_excluded2 = [
    "src",
    "visible",
    "onVisibleChange",
    "getContainer",
    "mask",
    "maskClassName",
    "movable",
    "icons",
    "scaleStep",
    "minScale",
    "maxScale",
    "imageRender",
    "toolbarRender"
];
var $bca85f3e75975fa9$var$ImageInternal = function ImageInternal(props) {
    var imgSrc = props.src, alt = props.alt, onInitialPreviewClose = props.onPreviewClose, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-image" : _props$prefixCls, _props$previewPrefixC = props.previewPrefixCls, previewPrefixCls = _props$previewPrefixC === void 0 ? "".concat(prefixCls, "-preview") : _props$previewPrefixC, placeholder = props.placeholder, fallback = props.fallback, width = props.width, height = props.height, style = props.style, _props$preview = props.preview, preview = _props$preview === void 0 ? true : _props$preview, className = props.className, onClick = props.onClick, onError = props.onError, wrapperClassName = props.wrapperClassName, wrapperStyle = props.wrapperStyle, rootClassName = props.rootClassName, otherProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $bca85f3e75975fa9$var$_excluded);
    var isCustomPlaceholder = placeholder && placeholder !== true;
    var _ref = (0, $b8f57191916382d3$export$2e2bcd8739ae039)(preview) === "object" ? preview : {}, previewSrc = _ref.src, _ref$visible = _ref.visible, previewVisible = _ref$visible === void 0 ? undefined : _ref$visible, _ref$onVisibleChange = _ref.onVisibleChange, onPreviewVisibleChange = _ref$onVisibleChange === void 0 ? onInitialPreviewClose : _ref$onVisibleChange, _ref$getContainer = _ref.getContainer, getPreviewContainer = _ref$getContainer === void 0 ? undefined : _ref$getContainer, previewMask = _ref.mask, maskClassName = _ref.maskClassName, movable = _ref.movable, icons = _ref.icons, scaleStep = _ref.scaleStep, minScale = _ref.minScale, maxScale = _ref.maxScale, imageRender = _ref.imageRender, toolbarRender = _ref.toolbarRender, dialogProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $bca85f3e75975fa9$var$_excluded2);
    var src = previewSrc !== null && previewSrc !== void 0 ? previewSrc : imgSrc;
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(!!previewVisible, {
        value: previewVisible,
        onChange: onPreviewVisibleChange
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), isShowPreview = _useMergedState2[0], setShowPreview = _useMergedState2[1];
    var _useStatus = (0, $e610472e6a9db819$export$2e2bcd8739ae039)({
        src: imgSrc,
        isCustomPlaceholder: isCustomPlaceholder,
        fallback: fallback
    }), _useStatus2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStatus, 3), getImgRef = _useStatus2[0], srcAndOnload = _useStatus2[1], status = _useStatus2[2];
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), mousePosition = _useState2[0], setMousePosition = _useState2[1];
    var groupContext = (0, $acw62.useContext)((0, $f6b39a89eb32b427$export$3062997f0b99863));
    var canPreview = !!preview;
    var onPreviewClose = function onPreviewClose() {
        setShowPreview(false);
        setMousePosition(null);
    };
    var wrapperClass = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, wrapperClassName, rootClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-error"), status === "error"));
    // ========================= ImageProps =========================
    var imgCommonProps = (0, $acw62.useMemo)(function() {
        var obj = {};
        (0, $0968bdba463aae69$export$2367aee66755576).forEach(function(prop) {
            if (props[prop] !== undefined) obj[prop] = props[prop];
        });
        return obj;
    }, (0, $0968bdba463aae69$export$2367aee66755576).map(function(prop) {
        return props[prop];
    }));
    // ========================== Register ==========================
    var registerData = (0, $acw62.useMemo)(function() {
        return (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, imgCommonProps), {}, {
            src: src
        });
    }, [
        src,
        imgCommonProps
    ]);
    var imageId = (0, $1b19903abeb5a7ec$export$2e2bcd8739ae039)(canPreview, registerData);
    // ========================== Preview ===========================
    var onPreview = function onPreview(e) {
        var _getOffset = (0, $cbf8b6c8fd246421$export$622cea445a1c5b7d)(e.target), left = _getOffset.left, top = _getOffset.top;
        if (groupContext) groupContext.onPreview(imageId, src, left, top);
        else {
            setMousePosition({
                x: left,
                y: top
            });
            setShowPreview(true);
        }
        onClick === null || onClick === void 0 || onClick(e);
    };
    // =========================== Render ===========================
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, otherProps, {
        className: wrapperClass,
        onClick: canPreview ? onPreview : onClick,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            width: width,
            height: height
        }, wrapperStyle)
    }), /*#__PURE__*/ $acw62.createElement("img", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, imgCommonProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-img"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-img-placeholder"), placeholder === true), className),
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
            height: height
        }, style),
        ref: getImgRef
    }, srcAndOnload, {
        width: width,
        height: height,
        onError: onError
    })), status === "loading" && /*#__PURE__*/ $acw62.createElement("div", {
        "aria-hidden": "true",
        className: "".concat(prefixCls, "-placeholder")
    }, placeholder), previewMask && canPreview && /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), maskClassName),
        style: {
            display: (style === null || style === void 0 ? void 0 : style.display) === "none" ? "none" : undefined
        }
    }, previewMask)), !groupContext && canPreview && /*#__PURE__*/ $acw62.createElement((0, $642d0c4e097edefe$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": !isShowPreview,
        visible: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        src: src,
        alt: alt,
        imageInfo: {
            width: width,
            height: height
        },
        fallback: fallback,
        getContainer: getPreviewContainer,
        icons: icons,
        movable: movable,
        scaleStep: scaleStep,
        minScale: minScale,
        maxScale: maxScale,
        rootClassName: rootClassName,
        imageRender: imageRender,
        imgCommonProps: imgCommonProps,
        toolbarRender: toolbarRender
    }, dialogProps)));
};
$bca85f3e75975fa9$var$ImageInternal.PreviewGroup = (0, $24a9b4d085f66d2e$export$2e2bcd8739ae039);
var $bca85f3e75975fa9$export$2e2bcd8739ae039 = $bca85f3e75975fa9$var$ImageInternal;


var $b8e27e74b4085961$export$2e2bcd8739ae039 = (0, $bca85f3e75975fa9$export$2e2bcd8739ae039);








var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $ff15ac1227d2f2eb$var$RotateLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    },
    "name": "rotate-left",
    "theme": "outlined"
};
var $ff15ac1227d2f2eb$export$2e2bcd8739ae039 = $ff15ac1227d2f2eb$var$RotateLeftOutlined;



var $91bc6521e9f91ff1$var$RotateLeftOutlined = function RotateLeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $ff15ac1227d2f2eb$export$2e2bcd8739ae039)
    }));
};
/**![rotate-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik02NzIgNDE4SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NDE0YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDUyOGMxNy43IDAgMzItMTQuMyAzMi0zMlY0NTBjMC0xNy43LTE0LjMtMzItMzItMzJ6bS00NCA0MDJIMTg4VjQ5NGg0NDB2MzI2eiIgLz48cGF0aCBkPSJNODE5LjMgMzI4LjVjLTc4LjgtMTAwLjctMTk2LTE1My42LTMxNC42LTE1NC4ybC0uMi02NGMwLTYuNS03LjYtMTAuMS0xMi42LTYuMWwtMTI4IDEwMWMtNCAzLjEtMy45IDkuMSAwIDEyLjNMNDkyIDMxOC42YzUuMSA0IDEyLjcuNCAxMi42LTYuMXYtNjMuOWMxMi45LjEgMjUuOS45IDM4LjggMi41IDQyLjEgNS4yIDgyLjEgMTguMiAxMTkgMzguNyAzOC4xIDIxLjIgNzEuMiA0OS43IDk4LjQgODQuMyAyNy4xIDM0LjcgNDYuNyA3My43IDU4LjEgMTE1LjhhMzI1Ljk1IDMyNS45NSAwIDAxNi41IDE0MC45aDc0LjljMTQuOC0xMDMuNi0xMS4zLTIxMy04MS0zMDIuM3oiIC8+PC9zdmc+) */ var $91bc6521e9f91ff1$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($91bc6521e9f91ff1$var$RotateLeftOutlined);
var $91bc6521e9f91ff1$export$2e2bcd8739ae039 = $91bc6521e9f91ff1$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $1745df0058500b69$var$RotateRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"
                }
            }
        ]
    },
    "name": "rotate-right",
    "theme": "outlined"
};
var $1745df0058500b69$export$2e2bcd8739ae039 = $1745df0058500b69$var$RotateRightOutlined;



var $911f8997e634ac65$var$RotateRightOutlined = function RotateRightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $1745df0058500b69$export$2e2bcd8739ae039)
    }));
};
/**![rotate-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik00ODAuNSAyNTEuMmMxMy0xLjYgMjUuOS0yLjQgMzguOC0yLjV2NjMuOWMwIDYuNSA3LjUgMTAuMSAxMi42IDYuMUw2NjAgMjE3LjZjNC0zLjIgNC05LjIgMC0xMi4zbC0xMjgtMTAxYy01LjEtNC0xMi42LS40LTEyLjYgNi4xbC0uMiA2NGMtMTE4LjYuNS0yMzUuOCA1My40LTMxNC42IDE1NC4yQTM5OS43NSAzOTkuNzUgMCAwMDEyMy41IDYzMWg3NC45Yy0uOS01LjMtMS43LTEwLjctMi40LTE2LjEtNS4xLTQyLjEtMi4xLTg0LjEgOC45LTEyNC44IDExLjQtNDIuMiAzMS04MS4xIDU4LjEtMTE1LjggMjcuMi0zNC43IDYwLjMtNjMuMiA5OC40LTg0LjMgMzctMjAuNiA3Ni45LTMzLjYgMTE5LjEtMzguOHoiIC8+PHBhdGggZD0iTTg4MCA0MThIMzUyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY0MTRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNTI4YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjQ1MGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQ0IDQwMkgzOTZWNDk0aDQ0MHYzMjZ6IiAvPjwvc3ZnPg==) */ var $911f8997e634ac65$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($911f8997e634ac65$var$RotateRightOutlined);
var $911f8997e634ac65$export$2e2bcd8739ae039 = $911f8997e634ac65$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $142ab1e202af18c4$var$SwapOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "swap",
    "theme": "outlined"
};
var $142ab1e202af18c4$export$2e2bcd8739ae039 = $142ab1e202af18c4$var$SwapOutlined;



var $c70c198379b0f74c$var$SwapOutlined = function SwapOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $142ab1e202af18c4$export$2e2bcd8739ae039)
    }));
};
/**![swap](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0Ny45IDU5MkgxNTJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoNjA1LjJMNjEyLjkgODUxYy00LjEgNS4yLS40IDEzIDYuMyAxM2g3Mi41YzQuOSAwIDkuNS0yLjIgMTIuNi02LjFsMTY4LjgtMjE0LjFjMTYuNS0yMSAxLjYtNTEuOC0yNS4yLTUxLjh6TTg3MiAzNTZIMjY2LjhsMTQ0LjMtMTgzYzQuMS01LjIuNC0xMy02LjMtMTNoLTcyLjVjLTQuOSAwLTkuNSAyLjItMTIuNiA2LjFMMTUwLjkgMzgwLjJjLTE2LjUgMjEtMS42IDUxLjggMjUuMSA1MS44aDY5NmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ var $c70c198379b0f74c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($c70c198379b0f74c$var$SwapOutlined);
var $c70c198379b0f74c$export$2e2bcd8739ae039 = $c70c198379b0f74c$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $729962fdaaeabdbf$var$ZoomInOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-in",
    "theme": "outlined"
};
var $729962fdaaeabdbf$export$2e2bcd8739ae039 = $729962fdaaeabdbf$var$ZoomInOutlined;



var $be03b75194f902f8$var$ZoomInOutlined = function ZoomInOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $729962fdaaeabdbf$export$2e2bcd8739ae039)
    }));
};
/**![zoom-in](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNINTE5VjMwOWMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTM0SDMyNWMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGgxMTh2MTM0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWNTE5aDExOGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ var $be03b75194f902f8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($be03b75194f902f8$var$ZoomInOutlined);
var $be03b75194f902f8$export$2e2bcd8739ae039 = $be03b75194f902f8$var$RefIcon;




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d157258ac3afd907$var$ZoomOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-out",
    "theme": "outlined"
};
var $d157258ac3afd907$export$2e2bcd8739ae039 = $d157258ac3afd907$var$ZoomOutOutlined;



var $2e50f5d8a03dff9a$var$ZoomOutOutlined = function ZoomOutOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $d157258ac3afd907$export$2e2bcd8739ae039)
    }));
};
/**![zoom-out](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNIMzI1Yy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDMxMmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ var $2e50f5d8a03dff9a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2e50f5d8a03dff9a$var$ZoomOutOutlined);
var $2e50f5d8a03dff9a$export$2e2bcd8739ae039 = $2e50f5d8a03dff9a$var$RefIcon;














const $002238b65f4cc4e7$export$cee50e75a801b845 = (position)=>({
        position: position || "absolute",
        inset: 0
    });
const $002238b65f4cc4e7$export$b57c3249879885ff = (token)=>{
    const { iconCls: iconCls, motionDurationSlow: motionDurationSlow, paddingXXS: paddingXXS, marginXXS: marginXXS, prefixCls: prefixCls, colorTextLightSolid: colorTextLightSolid } = token;
    return {
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: colorTextLightSolid,
        background: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)("#000").setAlpha(0.5).toRgbString(),
        cursor: "pointer",
        opacity: 0,
        transition: `opacity ${motionDurationSlow}`,
        [`.${prefixCls}-mask-info`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
            padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingXXS)}`,
            [iconCls]: {
                marginInlineEnd: marginXXS,
                svg: {
                    verticalAlign: "baseline"
                }
            }
        })
    };
};
const $002238b65f4cc4e7$export$e6a4f11f32125e36 = (token)=>{
    const { previewCls: previewCls, modalMaskBg: modalMaskBg, paddingSM: paddingSM, marginXL: marginXL, margin: margin, paddingLG: paddingLG, previewOperationColorDisabled: previewOperationColorDisabled, previewOperationHoverColor: previewOperationHoverColor, motionDurationSlow: motionDurationSlow, iconCls: iconCls, colorTextLightSolid: colorTextLightSolid } = token;
    const operationBg = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(modalMaskBg).setAlpha(0.1);
    const operationBgHover = operationBg.clone().setAlpha(0.2);
    return {
        [`${previewCls}-footer`]: {
            position: "fixed",
            bottom: marginXL,
            left: {
                _skip_check_: true,
                value: 0
            },
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: token.previewOperationColor
        },
        [`${previewCls}-progress`]: {
            marginBottom: margin
        },
        [`${previewCls}-close`]: {
            position: "fixed",
            top: marginXL,
            right: {
                _skip_check_: true,
                value: marginXL
            },
            display: "flex",
            color: colorTextLightSolid,
            backgroundColor: operationBg.toRgbString(),
            borderRadius: "50%",
            padding: paddingSM,
            outline: 0,
            border: 0,
            cursor: "pointer",
            transition: `all ${motionDurationSlow}`,
            "&:hover": {
                backgroundColor: operationBgHover.toRgbString()
            },
            [`& > ${iconCls}`]: {
                fontSize: token.previewOperationSize
            }
        },
        [`${previewCls}-operations`]: {
            display: "flex",
            alignItems: "center",
            padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingLG)}`,
            backgroundColor: operationBg.toRgbString(),
            borderRadius: 100,
            "&-operation": {
                marginInlineStart: paddingSM,
                padding: paddingSM,
                cursor: "pointer",
                transition: `all ${motionDurationSlow}`,
                userSelect: "none",
                [`&:not(${previewCls}-operations-operation-disabled):hover > ${iconCls}`]: {
                    color: previewOperationHoverColor
                },
                "&-disabled": {
                    color: previewOperationColorDisabled,
                    cursor: "not-allowed"
                },
                "&:first-of-type": {
                    marginInlineStart: 0
                },
                [`& > ${iconCls}`]: {
                    fontSize: token.previewOperationSize
                }
            }
        }
    };
};
const $002238b65f4cc4e7$export$583c8fac5244ba77 = (token)=>{
    const { modalMaskBg: modalMaskBg, iconCls: iconCls, previewOperationColorDisabled: previewOperationColorDisabled, previewCls: previewCls, zIndexPopup: zIndexPopup, motionDurationSlow: motionDurationSlow } = token;
    const operationBg = new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(modalMaskBg).setAlpha(0.1);
    const operationBgHover = operationBg.clone().setAlpha(0.2);
    return {
        [`${previewCls}-switch-left, ${previewCls}-switch-right`]: {
            position: "fixed",
            insetBlockStart: "50%",
            zIndex: token.calc(zIndexPopup).add(1).equal(),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: token.imagePreviewSwitchSize,
            height: token.imagePreviewSwitchSize,
            marginTop: token.calc(token.imagePreviewSwitchSize).mul(-1).div(2).equal(),
            color: token.previewOperationColor,
            background: operationBg.toRgbString(),
            borderRadius: "50%",
            transform: `translateY(-50%)`,
            cursor: "pointer",
            transition: `all ${motionDurationSlow}`,
            userSelect: "none",
            "&:hover": {
                background: operationBgHover.toRgbString()
            },
            "&-disabled": {
                "&, &:hover": {
                    color: previewOperationColorDisabled,
                    background: "transparent",
                    cursor: "not-allowed",
                    [`> ${iconCls}`]: {
                        cursor: "not-allowed"
                    }
                }
            },
            [`> ${iconCls}`]: {
                fontSize: token.previewOperationSize
            }
        },
        [`${previewCls}-switch-left`]: {
            insetInlineStart: token.marginSM
        },
        [`${previewCls}-switch-right`]: {
            insetInlineEnd: token.marginSM
        }
    };
};
const $002238b65f4cc4e7$export$f8264fb430b07c9a = (token)=>{
    const { motionEaseOut: motionEaseOut, previewCls: previewCls, motionDurationSlow: motionDurationSlow, componentCls: componentCls } = token;
    return [
        {
            [`${componentCls}-preview-root`]: {
                [previewCls]: {
                    height: "100%",
                    textAlign: "center",
                    pointerEvents: "none"
                },
                [`${previewCls}-body`]: Object.assign(Object.assign({}, $002238b65f4cc4e7$export$cee50e75a801b845()), {
                    overflow: "hidden"
                }),
                [`${previewCls}-img`]: {
                    maxWidth: "100%",
                    maxHeight: "70%",
                    verticalAlign: "middle",
                    transform: "scale3d(1, 1, 1)",
                    cursor: "grab",
                    transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`,
                    userSelect: "none",
                    "&-wrapper": Object.assign(Object.assign({}, $002238b65f4cc4e7$export$cee50e75a801b845()), {
                        transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`,
                        // https://github.com/ant-design/ant-design/issues/39913
                        // TailwindCSS will reset img default style.
                        // Let's set back.
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        "& > *": {
                            pointerEvents: "auto"
                        },
                        "&::before": {
                            display: "inline-block",
                            width: 1,
                            height: "50%",
                            marginInlineEnd: -1,
                            content: '""'
                        }
                    })
                },
                [`${previewCls}-moving`]: {
                    [`${previewCls}-preview-img`]: {
                        cursor: "grabbing",
                        "&-wrapper": {
                            transitionDuration: "0s"
                        }
                    }
                }
            }
        },
        // Override
        {
            [`${componentCls}-preview-root`]: {
                [`${previewCls}-wrap`]: {
                    zIndex: token.zIndexPopup
                }
            }
        },
        // Preview operations & switch
        {
            [`${componentCls}-preview-operations-wrapper`]: {
                position: "fixed",
                zIndex: token.calc(token.zIndexPopup).add(1).equal()
            },
            "&": [
                $002238b65f4cc4e7$export$e6a4f11f32125e36(token),
                $002238b65f4cc4e7$export$583c8fac5244ba77(token)
            ]
        }
    ];
};
const $002238b65f4cc4e7$var$genImageStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ============================== image ==============================
        [componentCls]: {
            position: "relative",
            display: "inline-block",
            [`${componentCls}-img`]: {
                width: "100%",
                height: "auto",
                verticalAlign: "middle"
            },
            [`${componentCls}-img-placeholder`]: {
                backgroundColor: token.colorBgContainerDisabled,
                backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "30%"
            },
            [`${componentCls}-mask`]: Object.assign({}, $002238b65f4cc4e7$export$b57c3249879885ff(token)),
            [`${componentCls}-mask:hover`]: {
                opacity: 1
            },
            [`${componentCls}-placeholder`]: Object.assign({}, $002238b65f4cc4e7$export$cee50e75a801b845())
        }
    };
};
const $002238b65f4cc4e7$var$genPreviewMotion = (token)=>{
    const { previewCls: previewCls } = token;
    return {
        [`${previewCls}-root`]: (0, $d2082114d5952afb$export$f5d123412490d9dc)(token, "zoom"),
        "&": (0, $cfaac789ec22cce1$export$2909268c8354a12)(token, true)
    };
};
const $002238b65f4cc4e7$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 80,
        previewOperationColor: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(token.colorTextLightSolid).setAlpha(0.65).toRgbString(),
        previewOperationHoverColor: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(token.colorTextLightSolid).setAlpha(0.85).toRgbString(),
        previewOperationColorDisabled: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)(token.colorTextLightSolid).setAlpha(0.25).toRgbString(),
        previewOperationSize: token.fontSizeIcon * 1.5 // FIXME: fontSizeIconLG
    });
var $002238b65f4cc4e7$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Image", (token)=>{
    const previewCls = `${token.componentCls}-preview`;
    const imageToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        previewCls: previewCls,
        modalMaskBg: new (0, $6d2f60b2591128fc$export$d850312fc213f33e)("#000").setAlpha(0.45).toRgbString(),
        // FIXME: Shared Token
        imagePreviewSwitchSize: token.controlHeightLG
    });
    return [
        $002238b65f4cc4e7$var$genImageStyle(imageToken),
        $002238b65f4cc4e7$export$f8264fb430b07c9a(imageToken),
        (0, $4273ff34fb23b4b1$export$8bb6dada04673ddd)((0, $2049919111d93bd2$export$4950aa0f605343fb)(imageToken, {
            componentCls: previewCls
        })),
        $002238b65f4cc4e7$var$genPreviewMotion(imageToken)
    ];
}, $002238b65f4cc4e7$export$9ca1be8807fe0675);


"use client";
var $01d7f5b7c8f36ad2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $01d7f5b7c8f36ad2$export$df03f54e09e486fa = {
    rotateLeft: /*#__PURE__*/ $acw62.createElement((0, $91bc6521e9f91ff1$export$2e2bcd8739ae039), null),
    rotateRight: /*#__PURE__*/ $acw62.createElement((0, $911f8997e634ac65$export$2e2bcd8739ae039), null),
    zoomIn: /*#__PURE__*/ $acw62.createElement((0, $be03b75194f902f8$export$2e2bcd8739ae039), null),
    zoomOut: /*#__PURE__*/ $acw62.createElement((0, $2e50f5d8a03dff9a$export$2e2bcd8739ae039), null),
    close: /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null),
    left: /*#__PURE__*/ $acw62.createElement((0, $1e62197f718e4845$export$2e2bcd8739ae039), null),
    right: /*#__PURE__*/ $acw62.createElement((0, $ae197ef38b34eab8$export$2e2bcd8739ae039), null),
    flipX: /*#__PURE__*/ $acw62.createElement((0, $c70c198379b0f74c$export$2e2bcd8739ae039), null),
    flipY: /*#__PURE__*/ $acw62.createElement((0, $c70c198379b0f74c$export$2e2bcd8739ae039), {
        rotate: 90
    })
};
const $01d7f5b7c8f36ad2$var$InternalPreviewGroup = (_a)=>{
    var { previewPrefixCls: customizePrefixCls, preview: preview } = _a, otherProps = $01d7f5b7c8f36ad2$var$__rest(_a, [
        "previewPrefixCls",
        "preview"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("image", customizePrefixCls);
    const previewPrefixCls = `${prefixCls}-preview`;
    const rootPrefixCls = getPrefixCls();
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $002238b65f4cc4e7$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [zIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("ImagePreview", typeof preview === "object" ? preview.zIndex : undefined);
    const mergedPreview = $acw62.useMemo(()=>{
        var _a;
        if (preview === false) return preview;
        const _preview = typeof preview === "object" ? preview : {};
        const mergedRootClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, rootCls, (_a = _preview.rootClassName) !== null && _a !== void 0 ? _a : "");
        return Object.assign(Object.assign({}, _preview), {
            transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom", _preview.transitionName),
            maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "fade", _preview.maskTransitionName),
            rootClassName: mergedRootClassName,
            zIndex: zIndex
        });
    }, [
        preview
    ]);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $b8e27e74b4085961$export$2e2bcd8739ae039).PreviewGroup, Object.assign({
        preview: mergedPreview,
        previewPrefixCls: previewPrefixCls,
        icons: $01d7f5b7c8f36ad2$export$df03f54e09e486fa
    }, otherProps)));
};
var $01d7f5b7c8f36ad2$export$2e2bcd8739ae039 = $01d7f5b7c8f36ad2$var$InternalPreviewGroup;



"use client";
var $bdacfb30f3b10618$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $bdacfb30f3b10618$var$Image = (props)=>{
    var _a;
    const { prefixCls: customizePrefixCls, preview: preview, className: className, rootClassName: rootClassName, style: style } = props, otherProps = $bdacfb30f3b10618$var$__rest(props, [
        "prefixCls",
        "preview",
        "className",
        "rootClassName",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, locale: contextLocale = (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039), getPopupContainer: getContextPopupContainer, image: image } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("image", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const imageLocale = contextLocale.Image || (0, $c7d8dfeaf08e9faa$export$2e2bcd8739ae039).Image;
    // Style
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $002238b65f4cc4e7$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedRootClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(rootClassName, hashId, cssVarCls, rootCls);
    const mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, hashId, image === null || image === void 0 ? void 0 : image.className);
    const [zIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("ImagePreview", typeof preview === "object" ? preview.zIndex : undefined);
    const mergedPreview = $acw62.useMemo(()=>{
        var _a;
        if (preview === false) return preview;
        const _preview = typeof preview === "object" ? preview : {};
        const { getContainer: getContainer, closeIcon: closeIcon } = _preview, restPreviewProps = $bdacfb30f3b10618$var$__rest(_preview, [
            "getContainer",
            "closeIcon"
        ]);
        return Object.assign(Object.assign({
            mask: /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-mask-info`
            }, /*#__PURE__*/ $acw62.createElement((0, $d8a9efd7a074f5f5$export$2e2bcd8739ae039), null), imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview),
            icons: $01d7f5b7c8f36ad2$export$df03f54e09e486fa
        }, restPreviewProps), {
            getContainer: getContainer !== null && getContainer !== void 0 ? getContainer : getContextPopupContainer,
            transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom", _preview.transitionName),
            maskTransitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "fade", _preview.maskTransitionName),
            zIndex: zIndex,
            closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : (_a = image === null || image === void 0 ? void 0 : image.preview) === null || _a === void 0 ? void 0 : _a.closeIcon
        });
    }, [
        preview,
        imageLocale,
        (_a = image === null || image === void 0 ? void 0 : image.preview) === null || _a === void 0 ? void 0 : _a.closeIcon
    ]);
    const mergedStyle = Object.assign(Object.assign({}, image === null || image === void 0 ? void 0 : image.style), style);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $b8e27e74b4085961$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        preview: mergedPreview,
        rootClassName: mergedRootClassName,
        className: mergedClassName,
        style: mergedStyle
    }, otherProps)));
};
$bdacfb30f3b10618$var$Image.PreviewGroup = (0, $01d7f5b7c8f36ad2$export$2e2bcd8739ae039);
var $bdacfb30f3b10618$export$2e2bcd8739ae039 = $bdacfb30f3b10618$var$Image;


"use client";
var $0ecbbbb3ffda2d77$export$2e2bcd8739ae039 = (0, $d153d21e77ee9427$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");




const $a16dd9e8e5029b59$var$ImageGalleryModal = ({ isImageGalleryOpen: isImageGalleryOpen, setIsImageGalleryOpen: setIsImageGalleryOpen, setStoredImages: setStoredImages, storedImages: storedImages })=>{
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/images/get-images", {
                    withCredentials: true
                });
                const data = response.data;
                setStoredImages(data);
            } catch (error) {
                console.error("Error fetching images", error);
            }
        };
        fetchData();
    }, []);
    const deleteImage = async (image_id)=>{
        try {
            const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).delete(`/api/images/delete-image/`, {
                data: {
                    image_id: image_id
                },
                withCredentials: true
            });
            setStoredImages((prevImages)=>{
                if (prevImages) return prevImages.filter((image)=>image.id !== image_id);
                return prevImages;
            });
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("delete_image", {
                deleted_image_id: image_id,
                image_count: storedImages?.length || 0,
                images: storedImages
            }, true);
        } catch (error) {
            console.error("Error deleting image", error);
        }
    };
    const handleCloseImageGallery = ()=>{
        setIsImageGalleryOpen(false);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("close_image_gallery", {
            image_count: storedImages?.length || 0,
            images: storedImages
        }, true);
    };
    (0, $acw62.useEffect)(()=>{
        if (isImageGalleryOpen) (0, $14e68cbe3c2b3085$export$83fc28f458189523)("open_image_gallery", {
            image_count: storedImages?.length || 0,
            images: storedImages
        }, true);
    }, [
        isImageGalleryOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
        open: isImageGalleryOpen,
        className: "imageGalleryModal",
        centered: true,
        width: "40%",
        onCancel: handleCloseImageGallery,
        zIndex: 1001,
        footer: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                onClick: handleCloseImageGallery,
                type: "primary",
                danger: true,
                children: "Close"
            }, "close")
        ],
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "My Saved Images"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039).PreviewGroup, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2dcdaeaf17c3bbb2$export$2e2bcd8739ae039), {
                    gutter: [
                        16,
                        16
                    ],
                    children: storedImages ? storedImages.map((image, index)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0ecbbbb3ffda2d77$export$2e2bcd8739ae039), {
                            span: 6,
                            className: "imageGalleryItem",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039), {
                                    style: {
                                        zIndex: 1002
                                    },
                                    src: image.is_temporary ? image.image_path : `${0, $9d936a2aecb96285$export$b27b0287c31e45de}${image.image_path}`,
                                    alt: image.image_title,
                                    title: "Click to view full image"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    className: "deleteButton",
                                    shape: "circle",
                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66758f779ccbee67$export$2e2bcd8739ae039), {
                                        color: "red"
                                    }),
                                    onClick: ()=>deleteImage(image.id)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "gallery-caption",
                                    children: image.image_title
                                })
                            ]
                        }, index);
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "noDataFoundMessage",
                        children: "No saved images found. Next time you generate a plot make sure to click the 'Save Image' button below it."
                    })
                })
            })
        ]
    });
};
var $a16dd9e8e5029b59$export$2e2bcd8739ae039 = $a16dd9e8e5029b59$var$ImageGalleryModal;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $bacf9639868026a8$var$VerticalAlignTopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z"
                }
            }
        ]
    },
    "name": "vertical-align-top",
    "theme": "outlined"
};
var $bacf9639868026a8$export$2e2bcd8739ae039 = $bacf9639868026a8$var$VerticalAlignTopOutlined;



var $55f5c421b582c04d$var$VerticalAlignTopOutlined = function VerticalAlignTopOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $bacf9639868026a8$export$2e2bcd8739ae039)
    }));
};
/**![vertical-align-top](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OS45IDE2OEgxNjQuMWMtNC41IDAtOC4xIDMuNi04LjEgOHY2MGMwIDQuNCAzLjYgOCA4LjEgOGg2OTUuOGM0LjUgMCA4LjEtMy42IDguMS04di02MGMwLTQuNC0zLjYtOC04LjEtOHpNNTE4LjMgMzU1YTggOCAwIDAwLTEyLjYgMGwtMTEyIDE0MS43YTcuOTggNy45OCAwIDAwNi4zIDEyLjloNzMuOVY4NDhjMCA0LjQgMy42IDggOCA4aDYwYzQuNCAwIDgtMy42IDgtOFY1MDkuN0g2MjRjNi43IDAgMTAuNC03LjcgNi4zLTEyLjlMNTE4LjMgMzU1eiIgLz48L3N2Zz4=) */ var $55f5c421b582c04d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($55f5c421b582c04d$var$VerticalAlignTopOutlined);
var $55f5c421b582c04d$export$2e2bcd8739ae039 = $55f5c421b582c04d$var$RefIcon;









function $2612b4c1638153e7$var$throttleByAnimationFrame(fn) {
    let requestId;
    const later = (args)=>()=>{
            requestId = null;
            fn.apply(void 0, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(args));
        };
    const throttled = function() {
        if (requestId == null) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            requestId = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(later(args));
        }
    };
    throttled.cancel = ()=>{
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(requestId);
        requestId = null;
    };
    return throttled;
}
var $2612b4c1638153e7$export$2e2bcd8739ae039 = $2612b4c1638153e7$var$throttleByAnimationFrame;




var $acw62 = parcelRequire("acw62");
const $29887e00e9f7dd95$var$FloatButtonGroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(undefined);
const { Provider: $29887e00e9f7dd95$export$97c642573a13671 } = $29887e00e9f7dd95$var$FloatButtonGroupContext;
var $29887e00e9f7dd95$export$2e2bcd8739ae039 = $29887e00e9f7dd95$var$FloatButtonGroupContext;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");







const $5413658b578f2f42$var$antStatusProcessing = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antStatusProcessing", {
    "0%": {
        transform: "scale(0.8)",
        opacity: 0.5
    },
    "100%": {
        transform: "scale(2.4)",
        opacity: 0
    }
});
const $5413658b578f2f42$var$antZoomBadgeIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomBadgeIn", {
    "0%": {
        transform: "scale(0) translate(50%, -50%)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1) translate(50%, -50%)"
    }
});
const $5413658b578f2f42$var$antZoomBadgeOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antZoomBadgeOut", {
    "0%": {
        transform: "scale(1) translate(50%, -50%)"
    },
    "100%": {
        transform: "scale(0) translate(50%, -50%)",
        opacity: 0
    }
});
const $5413658b578f2f42$var$antNoWrapperZoomBadgeIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antNoWrapperZoomBadgeIn", {
    "0%": {
        transform: "scale(0)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)"
    }
});
const $5413658b578f2f42$var$antNoWrapperZoomBadgeOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antNoWrapperZoomBadgeOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0)",
        opacity: 0
    }
});
const $5413658b578f2f42$var$antBadgeLoadingCircle = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antBadgeLoadingCircle", {
    "0%": {
        transformOrigin: "50%"
    },
    "100%": {
        transform: "translate(50%, -50%) rotate(360deg)",
        transformOrigin: "50%"
    }
});
const $5413658b578f2f42$var$genSharedBadgeStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, antCls: antCls, badgeShadowSize: badgeShadowSize, motionDurationSlow: motionDurationSlow, textFontSize: textFontSize, textFontSizeSM: textFontSizeSM, statusSize: statusSize, dotSize: dotSize, textFontWeight: textFontWeight, indicatorHeight: indicatorHeight, indicatorHeightSM: indicatorHeightSM, marginXS: marginXS, calc: calc } = token;
    const numberPrefixCls = `${antCls}-scroll-number`;
    const colorPreset = (0, $69386722b4e8be32$export$2e2bcd8739ae039)(token, (colorKey, _ref)=>{
        let { darkColor: darkColor } = _ref;
        return {
            [`&${componentCls} ${componentCls}-color-${colorKey}`]: {
                background: darkColor,
                [`&:not(${componentCls}-count)`]: {
                    color: darkColor
                },
                "a:hover &": {
                    background: darkColor
                }
            }
        };
    });
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "relative",
            display: "inline-block",
            width: "fit-content",
            lineHeight: 1,
            [`${componentCls}-count`]: {
                display: "inline-flex",
                justifyContent: "center",
                zIndex: token.indicatorZIndex,
                minWidth: indicatorHeight,
                height: indicatorHeight,
                color: token.badgeTextColor,
                fontWeight: textFontWeight,
                fontSize: textFontSize,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(indicatorHeight),
                whiteSpace: "nowrap",
                textAlign: "center",
                background: token.badgeColor,
                borderRadius: calc(indicatorHeight).div(2).equal(),
                boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`,
                transition: `background ${token.motionDurationMid}`,
                a: {
                    color: token.badgeTextColor
                },
                "a:hover": {
                    color: token.badgeTextColor
                },
                "a:hover &": {
                    background: token.badgeColorHover
                }
            },
            [`${componentCls}-count-sm`]: {
                minWidth: indicatorHeightSM,
                height: indicatorHeightSM,
                fontSize: textFontSizeSM,
                lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(indicatorHeightSM),
                borderRadius: calc(indicatorHeightSM).div(2).equal()
            },
            [`${componentCls}-multiple-words`]: {
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)}`,
                bdi: {
                    unicodeBidi: "plaintext"
                }
            },
            [`${componentCls}-dot`]: {
                zIndex: token.indicatorZIndex,
                width: dotSize,
                minWidth: dotSize,
                height: dotSize,
                background: token.badgeColor,
                borderRadius: "100%",
                boxShadow: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`
            },
            [`${componentCls}-dot${numberPrefixCls}`]: {
                transition: `background ${motionDurationSlow}`
            },
            [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                position: "absolute",
                top: 0,
                insetInlineEnd: 0,
                transform: "translate(50%, -50%)",
                transformOrigin: "100% 0%",
                [`&${iconCls}-spin`]: {
                    animationName: $5413658b578f2f42$var$antBadgeLoadingCircle,
                    animationDuration: "1s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear"
                }
            },
            [`&${componentCls}-status`]: {
                lineHeight: "inherit",
                verticalAlign: "baseline",
                [`${componentCls}-status-dot`]: {
                    position: "relative",
                    top: -1,
                    // Magic number, but seems better experience
                    display: "inline-block",
                    width: statusSize,
                    height: statusSize,
                    verticalAlign: "middle",
                    borderRadius: "50%"
                },
                [`${componentCls}-status-success`]: {
                    backgroundColor: token.colorSuccess
                },
                [`${componentCls}-status-processing`]: {
                    overflow: "visible",
                    color: token.colorInfo,
                    backgroundColor: token.colorInfo,
                    borderColor: "currentcolor",
                    "&::after": {
                        position: "absolute",
                        top: 0,
                        insetInlineStart: 0,
                        width: "100%",
                        height: "100%",
                        borderWidth: badgeShadowSize,
                        borderStyle: "solid",
                        borderColor: "inherit",
                        borderRadius: "50%",
                        animationName: $5413658b578f2f42$var$antStatusProcessing,
                        animationDuration: token.badgeProcessingDuration,
                        animationIterationCount: "infinite",
                        animationTimingFunction: "ease-in-out",
                        content: '""'
                    }
                },
                [`${componentCls}-status-default`]: {
                    backgroundColor: token.colorTextPlaceholder
                },
                [`${componentCls}-status-error`]: {
                    backgroundColor: token.colorError
                },
                [`${componentCls}-status-warning`]: {
                    backgroundColor: token.colorWarning
                },
                [`${componentCls}-status-text`]: {
                    marginInlineStart: marginXS,
                    color: token.colorText,
                    fontSize: token.fontSize
                }
            }
        }), colorPreset), {
            [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                animationName: $5413658b578f2f42$var$antZoomBadgeIn,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: "both"
            },
            [`${componentCls}-zoom-leave`]: {
                animationName: $5413658b578f2f42$var$antZoomBadgeOut,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: "both"
            },
            [`&${componentCls}-not-a-wrapper`]: {
                [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                    animationName: $5413658b578f2f42$var$antNoWrapperZoomBadgeIn,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`${componentCls}-zoom-leave`]: {
                    animationName: $5413658b578f2f42$var$antNoWrapperZoomBadgeOut,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`&:not(${componentCls}-status)`]: {
                    verticalAlign: "middle"
                },
                [`${numberPrefixCls}-custom-component, ${componentCls}-count`]: {
                    transform: "none"
                },
                [`${numberPrefixCls}-custom-component, ${numberPrefixCls}`]: {
                    position: "relative",
                    top: "auto",
                    display: "block",
                    transformOrigin: "50% 50%"
                }
            },
            [`${numberPrefixCls}`]: {
                overflow: "hidden",
                [`${numberPrefixCls}-only`]: {
                    position: "relative",
                    display: "inline-block",
                    height: indicatorHeight,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseOutBack}`,
                    WebkitTransformStyle: "preserve-3d",
                    WebkitBackfaceVisibility: "hidden",
                    [`> p${numberPrefixCls}-only-unit`]: {
                        height: indicatorHeight,
                        margin: 0,
                        WebkitTransformStyle: "preserve-3d",
                        WebkitBackfaceVisibility: "hidden"
                    }
                },
                [`${numberPrefixCls}-symbol`]: {
                    verticalAlign: "top"
                }
            },
            // ====================== RTL =======================
            "&-rtl": {
                direction: "rtl",
                [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                    transform: "translate(-50%, -50%)"
                }
            }
        })
    };
};
const $5413658b578f2f42$export$362fb92a8f81bbf9 = (token)=>{
    const { fontHeight: fontHeight, lineWidth: lineWidth, marginXS: marginXS, colorBorderBg: colorBorderBg } = token;
    const badgeFontHeight = fontHeight;
    const badgeShadowSize = lineWidth;
    const badgeTextColor = token.colorBgContainer;
    const badgeColor = token.colorError;
    const badgeColorHover = token.colorErrorHover;
    const badgeToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        badgeFontHeight: badgeFontHeight,
        badgeShadowSize: badgeShadowSize,
        badgeTextColor: badgeTextColor,
        badgeColor: badgeColor,
        badgeColorHover: badgeColorHover,
        badgeShadowColor: colorBorderBg,
        badgeProcessingDuration: "1.2s",
        badgeRibbonOffset: marginXS,
        // Follow token just by Design. Not related with token
        badgeRibbonCornerTransform: "scaleY(0.75)",
        badgeRibbonCornerFilter: `brightness(75%)`
    });
    return badgeToken;
};
const $5413658b578f2f42$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, fontSizeSM: fontSizeSM, lineWidth: lineWidth } = token;
    return {
        indicatorZIndex: "auto",
        indicatorHeight: Math.round(fontSize * lineHeight) - 2 * lineWidth,
        indicatorHeightSM: fontSize,
        dotSize: fontSizeSM / 2,
        textFontSize: fontSizeSM,
        textFontSizeSM: fontSizeSM,
        textFontWeight: "normal",
        statusSize: fontSizeSM / 2
    };
};
var $5413658b578f2f42$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Badge", (token)=>{
    const badgeToken = $5413658b578f2f42$export$362fb92a8f81bbf9(token);
    return $5413658b578f2f42$var$genSharedBadgeStyle(badgeToken);
}, $5413658b578f2f42$export$9ca1be8807fe0675);




// ============================== Ribbon ==============================
const $08ffd290ed72d18f$var$genRibbonStyle = (token)=>{
    const { antCls: antCls, badgeFontHeight: badgeFontHeight, marginXS: marginXS, badgeRibbonOffset: badgeRibbonOffset, calc: calc } = token;
    const ribbonPrefixCls = `${antCls}-ribbon`;
    const ribbonWrapperPrefixCls = `${antCls}-ribbon-wrapper`;
    const statusRibbonPreset = (0, $69386722b4e8be32$export$2e2bcd8739ae039)(token, (colorKey, _ref)=>{
        let { darkColor: darkColor } = _ref;
        return {
            [`&${ribbonPrefixCls}-color-${colorKey}`]: {
                background: darkColor,
                color: darkColor
            }
        };
    });
    return {
        [`${ribbonWrapperPrefixCls}`]: {
            position: "relative"
        },
        [`${ribbonPrefixCls}`]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "absolute",
            top: marginXS,
            padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)}`,
            color: token.colorPrimary,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(badgeFontHeight),
            whiteSpace: "nowrap",
            backgroundColor: token.colorPrimary,
            borderRadius: token.borderRadiusSM,
            [`${ribbonPrefixCls}-text`]: {
                color: token.colorTextLightSolid
            },
            [`${ribbonPrefixCls}-corner`]: {
                position: "absolute",
                top: "100%",
                width: badgeRibbonOffset,
                height: badgeRibbonOffset,
                color: "currentcolor",
                border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(badgeRibbonOffset).div(2).equal())} solid`,
                transform: token.badgeRibbonCornerTransform,
                transformOrigin: "top",
                filter: token.badgeRibbonCornerFilter
            }
        }), statusRibbonPreset), {
            [`&${ribbonPrefixCls}-placement-end`]: {
                insetInlineEnd: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndEndRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineEnd: 0,
                    borderInlineEndColor: "transparent",
                    borderBlockEndColor: "transparent"
                }
            },
            [`&${ribbonPrefixCls}-placement-start`]: {
                insetInlineStart: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndStartRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineStart: 0,
                    borderBlockEndColor: "transparent",
                    borderInlineStartColor: "transparent"
                }
            },
            // ====================== RTL =======================
            "&-rtl": {
                direction: "rtl"
            }
        })
    };
};
var // ============================== Export ==============================
$08ffd290ed72d18f$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)([
    "Badge",
    "Ribbon"
], (token)=>{
    const badgeToken = (0, $5413658b578f2f42$export$362fb92a8f81bbf9)(token);
    return $08ffd290ed72d18f$var$genRibbonStyle(badgeToken);
}, (0, $5413658b578f2f42$export$9ca1be8807fe0675));


"use client";
const $f4b49d395773fe4d$var$Ribbon = (props)=>{
    const { className: className, prefixCls: customizePrefixCls, style: style, color: color, children: children, text: text, placement: placement = "end", rootClassName: rootClassName } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("ribbon", customizePrefixCls);
    const wrapperCls = `${prefixCls}-wrapper`;
    const [wrapCSSVar, hashId, cssVarCls] = (0, $08ffd290ed72d18f$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    const colorInPreset = (0, $1513ceb924eda9b6$export$ee62ebd6a58c4884)(color, false);
    const ribbonCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-placement-${placement}`, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-color-${color}`]: colorInPreset
    }, className);
    const colorStyle = {};
    const cornerColorStyle = {};
    if (color && !colorInPreset) {
        colorStyle.background = color;
        cornerColorStyle.color = color;
    }
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(wrapperCls, rootClassName, hashId, cssVarCls)
    }, children, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(ribbonCls, hashId),
        style: Object.assign(Object.assign({}, colorStyle), style)
    }, /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-text`
    }, text), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-corner`,
        style: cornerColorStyle
    }))));
};
var $f4b49d395773fe4d$export$2e2bcd8739ae039 = $f4b49d395773fe4d$var$Ribbon;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

"use client";
function $b5dd9c619414cb5a$var$UnitNumber(_ref) {
    let { prefixCls: prefixCls, value: value, current: current, offset: offset = 0 } = _ref;
    let style;
    if (offset) style = {
        position: "absolute",
        top: `${offset}00%`,
        left: 0
    };
    return /*#__PURE__*/ $acw62.createElement("span", {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-only-unit`, {
            current: current
        })
    }, value);
}
function $b5dd9c619414cb5a$var$getOffset(start, end, unit) {
    let index = start;
    let offset = 0;
    while((index + 10) % 10 !== end){
        index += unit;
        offset += unit;
    }
    return offset;
}
function $b5dd9c619414cb5a$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, count: originCount, value: originValue } = props;
    const value = Number(originValue);
    const count = Math.abs(originCount);
    const [prevValue, setPrevValue] = $acw62.useState(value);
    const [prevCount, setPrevCount] = $acw62.useState(count);
    // ============================= Events =============================
    const onTransitionEnd = ()=>{
        setPrevValue(value);
        setPrevCount(count);
    };
    // Fallback if transition events are not supported
    $acw62.useEffect(()=>{
        const timeout = setTimeout(()=>{
            onTransitionEnd();
        }, 1000);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        value
    ]);
    // ============================= Render =============================
    // Render unit list
    let unitNodes;
    let offsetStyle;
    if (prevValue === value || Number.isNaN(value) || Number.isNaN(prevValue)) {
        // Nothing to change
        unitNodes = [
            /*#__PURE__*/ $acw62.createElement($b5dd9c619414cb5a$var$UnitNumber, Object.assign({}, props, {
                key: value,
                current: true
            }))
        ];
        offsetStyle = {
            transition: "none"
        };
    } else {
        unitNodes = [];
        // Fill basic number units
        const end = value + 10;
        const unitNumberList = [];
        for(let index = value; index <= end; index += 1)unitNumberList.push(index);
        // Fill with number unit nodes
        const prevIndex = unitNumberList.findIndex((n)=>n % 10 === prevValue);
        unitNodes = unitNumberList.map((n, index)=>{
            const singleUnit = n % 10;
            return /*#__PURE__*/ $acw62.createElement($b5dd9c619414cb5a$var$UnitNumber, Object.assign({}, props, {
                key: n,
                value: singleUnit,
                offset: index - prevIndex,
                current: index === prevIndex
            }));
        });
        // Calculate container offset value
        const unit = prevCount < count ? 1 : -1;
        offsetStyle = {
            transform: `translateY(${-$b5dd9c619414cb5a$var$getOffset(prevValue, value, unit)}00%)`
        };
    }
    return /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-only`,
        style: offsetStyle,
        onTransitionEnd: onTransitionEnd
    }, unitNodes);
}


"use client";
var $180a5bbc2654583d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $180a5bbc2654583d$var$ScrollNumber = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, count: count, className: className, motionClassName: motionClassName, style: style, title: title, show: show, component: Component = "sup", children: children } = props, restProps = $180a5bbc2654583d$var$__rest(props, [
        "prefixCls",
        "count",
        "className",
        "motionClassName",
        "style",
        "title",
        "show",
        "component",
        "children"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("scroll-number", customizePrefixCls);
    // ============================ Render ============================
    const newProps = Object.assign(Object.assign({}, restProps), {
        "data-show": show,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, className, motionClassName),
        title: title
    });
    // Only integer need motion
    let numberNodes = count;
    if (count && Number(count) % 1 === 0) {
        const numberList = String(count).split("");
        numberNodes = /*#__PURE__*/ $acw62.createElement("bdi", null, numberList.map((num, i)=>/*#__PURE__*/ $acw62.createElement((0, $b5dd9c619414cb5a$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                count: Number(count),
                value: num,
                // eslint-disable-next-line react/no-array-index-key
                key: numberList.length - i
            })));
    }
    // allow specify the border
    // mock border-color by box-shadow for compatible with old usage:
    // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
    if (style === null || style === void 0 ? void 0 : style.borderColor) newProps.style = Object.assign(Object.assign({}, style), {
        boxShadow: `0 0 0 1px ${style.borderColor} inset`
    });
    if (children) return (0, $30796c32f374b477$export$e530037191fcd5d7)(children, (oriProps)=>({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-custom-component`, oriProps === null || oriProps === void 0 ? void 0 : oriProps.className, motionClassName)
        }));
    return /*#__PURE__*/ $acw62.createElement(Component, Object.assign({}, newProps, {
        ref: ref
    }), numberNodes);
});
var $180a5bbc2654583d$export$2e2bcd8739ae039 = $180a5bbc2654583d$var$ScrollNumber;



"use client";
var $1118404ffe351710$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $1118404ffe351710$var$InternalBadge = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b, _c, _d, _e;
    const { prefixCls: customizePrefixCls, scrollNumberPrefixCls: customizeScrollNumberPrefixCls, children: children, status: status, text: text, color: color, count: count = null, overflowCount: overflowCount = 99, dot: dot = false, size: size = "default", title: title, offset: offset, style: style, className: className, rootClassName: rootClassName, classNames: classNames, styles: styles, showZero: showZero = false } = props, restProps = $1118404ffe351710$var$__rest(props, [
        "prefixCls",
        "scrollNumberPrefixCls",
        "children",
        "status",
        "text",
        "color",
        "count",
        "overflowCount",
        "dot",
        "size",
        "title",
        "offset",
        "style",
        "className",
        "rootClassName",
        "classNames",
        "styles",
        "showZero"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, badge: badge } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("badge", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $5413658b578f2f42$export$2e2bcd8739ae039)(prefixCls);
    // ================================ Misc ================================
    const numberedDisplayCount = count > overflowCount ? `${overflowCount}+` : count;
    const isZero = numberedDisplayCount === "0" || numberedDisplayCount === 0;
    const ignoreCount = count === null || isZero && !showZero;
    const hasStatus = (status !== null && status !== undefined || color !== null && color !== undefined) && ignoreCount;
    const showAsDot = dot && !isZero;
    const mergedCount = showAsDot ? "" : numberedDisplayCount;
    const isHidden = (0, $acw62.useMemo)(()=>{
        const isEmpty = mergedCount === null || mergedCount === undefined || mergedCount === "";
        return (isEmpty || isZero && !showZero) && !showAsDot;
    }, [
        mergedCount,
        isZero,
        showZero,
        showAsDot
    ]);
    // Count should be cache in case hidden change it
    const countRef = (0, $acw62.useRef)(count);
    if (!isHidden) countRef.current = count;
    const livingCount = countRef.current;
    // We need cache count since remove motion should not change count display
    const displayCountRef = (0, $acw62.useRef)(mergedCount);
    if (!isHidden) displayCountRef.current = mergedCount;
    const displayCount = displayCountRef.current;
    // We will cache the dot status to avoid shaking on leaved motion
    const isDotRef = (0, $acw62.useRef)(showAsDot);
    if (!isHidden) isDotRef.current = showAsDot;
    // =============================== Styles ===============================
    const mergedStyle = (0, $acw62.useMemo)(()=>{
        if (!offset) return Object.assign(Object.assign({}, badge === null || badge === void 0 ? void 0 : badge.style), style);
        const offsetStyle = {
            marginTop: offset[1]
        };
        if (direction === "rtl") offsetStyle.left = parseInt(offset[0], 10);
        else offsetStyle.right = -parseInt(offset[0], 10);
        return Object.assign(Object.assign(Object.assign({}, offsetStyle), badge === null || badge === void 0 ? void 0 : badge.style), style);
    }, [
        direction,
        offset,
        style,
        badge === null || badge === void 0 ? void 0 : badge.style
    ]);
    // =============================== Render ===============================
    // >>> Title
    const titleNode = title !== null && title !== void 0 ? title : typeof livingCount === "string" || typeof livingCount === "number" ? livingCount : undefined;
    // >>> Status Text
    const statusTextNode = isHidden || !text ? null : /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-status-text`
    }, text);
    // >>> Display Component
    const displayNode = !livingCount || typeof livingCount !== "object" ? undefined : (0, $30796c32f374b477$export$e530037191fcd5d7)(livingCount, (oriProps)=>({
            style: Object.assign(Object.assign({}, mergedStyle), oriProps.style)
        }));
    // InternalColor
    const isInternalColor = (0, $1513ceb924eda9b6$export$ee62ebd6a58c4884)(color, false);
    // Shared styles
    const statusCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classNames === null || classNames === void 0 ? void 0 : classNames.indicator, (_a = badge === null || badge === void 0 ? void 0 : badge.classNames) === null || _a === void 0 ? void 0 : _a.indicator, {
        [`${prefixCls}-status-dot`]: hasStatus,
        [`${prefixCls}-status-${status}`]: !!status,
        [`${prefixCls}-color-${color}`]: isInternalColor
    });
    const statusStyle = {};
    if (color && !isInternalColor) {
        statusStyle.color = color;
        statusStyle.background = color;
    }
    const badgeClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-status`]: hasStatus,
        [`${prefixCls}-not-a-wrapper`]: !children,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, badge === null || badge === void 0 ? void 0 : badge.className, (_b = badge === null || badge === void 0 ? void 0 : badge.classNames) === null || _b === void 0 ? void 0 : _b.root, classNames === null || classNames === void 0 ? void 0 : classNames.root, hashId, cssVarCls);
    // <Badge status="success" />
    if (!children && hasStatus) {
        const statusTextColor = mergedStyle.color;
        return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", Object.assign({}, restProps, {
            className: badgeClassName,
            style: Object.assign(Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.root), (_c = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _c === void 0 ? void 0 : _c.root), mergedStyle)
        }), /*#__PURE__*/ $acw62.createElement("span", {
            className: statusCls,
            style: Object.assign(Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.indicator), (_d = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _d === void 0 ? void 0 : _d.indicator), statusStyle)
        }), text && /*#__PURE__*/ $acw62.createElement("span", {
            style: {
                color: statusTextColor
            },
            className: `${prefixCls}-status-text`
        }, text)));
    }
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("span", Object.assign({
        ref: ref
    }, restProps, {
        className: badgeClassName,
        style: Object.assign(Object.assign({}, (_e = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _e === void 0 ? void 0 : _e.root), styles === null || styles === void 0 ? void 0 : styles.root)
    }), children, /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: !isHidden,
        motionName: `${prefixCls}-zoom`,
        motionAppear: false,
        motionDeadline: 1000
    }, (_ref)=>{
        let { className: motionClassName } = _ref;
        var _a, _b;
        const scrollNumberPrefixCls = getPrefixCls("scroll-number", customizeScrollNumberPrefixCls);
        const isDot = isDotRef.current;
        const scrollNumberCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(classNames === null || classNames === void 0 ? void 0 : classNames.indicator, (_a = badge === null || badge === void 0 ? void 0 : badge.classNames) === null || _a === void 0 ? void 0 : _a.indicator, {
            [`${prefixCls}-dot`]: isDot,
            [`${prefixCls}-count`]: !isDot,
            [`${prefixCls}-count-sm`]: size === "small",
            [`${prefixCls}-multiple-words`]: !isDot && displayCount && displayCount.toString().length > 1,
            [`${prefixCls}-status-${status}`]: !!status,
            [`${prefixCls}-color-${color}`]: isInternalColor
        });
        let scrollNumberStyle = Object.assign(Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.indicator), (_b = badge === null || badge === void 0 ? void 0 : badge.styles) === null || _b === void 0 ? void 0 : _b.indicator), mergedStyle);
        if (color && !isInternalColor) {
            scrollNumberStyle = scrollNumberStyle || {};
            scrollNumberStyle.background = color;
        }
        return /*#__PURE__*/ $acw62.createElement((0, $180a5bbc2654583d$export$2e2bcd8739ae039), {
            prefixCls: scrollNumberPrefixCls,
            show: !isHidden,
            motionClassName: motionClassName,
            className: scrollNumberCls,
            count: displayCount,
            title: titleNode,
            style: scrollNumberStyle,
            key: "scrollNumber"
        }, displayNode);
    }), statusTextNode));
});
const $1118404ffe351710$var$Badge = $1118404ffe351710$var$InternalBadge;
$1118404ffe351710$var$Badge.Ribbon = (0, $f4b49d395773fe4d$export$2e2bcd8739ae039);
var $1118404ffe351710$export$2e2bcd8739ae039 = $1118404ffe351710$var$Badge;







var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $b78a5e44c8d5ff9e$var$FileTextOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    },
    "name": "file-text",
    "theme": "outlined"
};
var $b78a5e44c8d5ff9e$export$2e2bcd8739ae039 = $b78a5e44c8d5ff9e$var$FileTextOutlined;



var $1b54f846438024e8$var$FileTextOutlined = function FileTextOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $b78a5e44c8d5ff9e$export$2e2bcd8739ae039)
    }));
};
/**![file-text](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTA0IDYxOEgzMjBjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04ek0zMTIgNDkwdjQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThIMzIwYy00LjQgMC04IDMuNi04IDh6IiAvPjwvc3ZnPg==) */ var $1b54f846438024e8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($1b54f846438024e8$var$FileTextOutlined);
var $1b54f846438024e8$export$2e2bcd8739ae039 = $1b54f846438024e8$var$RefIcon;



"use client";
const $dbb6ad41621b1e34$var$FloatButtonContent = (props)=>{
    const { icon: icon, description: description, prefixCls: prefixCls, className: className } = props;
    const defaultElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-icon`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b54f846438024e8$export$2e2bcd8739ae039), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        onClick: props.onClick,
        onFocus: props.onFocus,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, `${prefixCls}-content`)
    }, icon || description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-icon`
    }, icon), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-description`
    }, description)) : defaultElement);
};
var $dbb6ad41621b1e34$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($dbb6ad41621b1e34$var$FloatButtonContent);







const $63326cfcd24aa6ea$var$getOffset = (radius)=>{
    if (radius === 0) return 0;
    // 如果要考虑通用性，这里应该用三角函数 Math.sin(45)
    // 但是这个场景比较特殊，始终是等腰直角三角形，所以直接用 Math.sqrt() 开方即可
    return radius - Math.sqrt(Math.pow(radius, 2) / 2);
};
var $63326cfcd24aa6ea$export$2e2bcd8739ae039 = $63326cfcd24aa6ea$var$getOffset;


const $d7cfe86cae631824$var$initFloatButtonGroupMotion = (token)=>{
    const { componentCls: componentCls, floatButtonSize: floatButtonSize, motionDurationSlow: motionDurationSlow, motionEaseInOutCirc: motionEaseInOutCirc } = token;
    const groupPrefixCls = `${componentCls}-group`;
    const moveDownIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antFloatButtonMoveDownIn", {
        "0%": {
            transform: `translate3d(0, ${(0, $f97444ff16d95e90$export$523c0b569236b342)(floatButtonSize)}, 0)`,
            transformOrigin: "0 0",
            opacity: 0
        },
        "100%": {
            transform: "translate3d(0, 0, 0)",
            transformOrigin: "0 0",
            opacity: 1
        }
    });
    const moveDownOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("antFloatButtonMoveDownOut", {
        "0%": {
            transform: "translate3d(0, 0, 0)",
            transformOrigin: "0 0",
            opacity: 1
        },
        "100%": {
            transform: `translate3d(0, ${(0, $f97444ff16d95e90$export$523c0b569236b342)(floatButtonSize)}, 0)`,
            transformOrigin: "0 0",
            opacity: 0
        }
    });
    return [
        {
            [`${groupPrefixCls}-wrap`]: Object.assign({}, (0, $c05a1428f4a08fb2$export$83e1da9e09ec9112)(`${groupPrefixCls}-wrap`, moveDownIn, moveDownOut, motionDurationSlow, true))
        },
        {
            [`${groupPrefixCls}-wrap`]: {
                [`
          &${groupPrefixCls}-wrap-enter,
          &${groupPrefixCls}-wrap-appear
        `]: {
                    opacity: 0,
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`&${groupPrefixCls}-wrap-leave`]: {
                    animationTimingFunction: motionEaseInOutCirc
                }
            }
        }
    ];
};
// ============================== Group ==============================
const $d7cfe86cae631824$var$floatButtonGroupStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, floatButtonSize: floatButtonSize, margin: margin, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, badgeOffset: badgeOffset, floatButtonBodyPadding: floatButtonBodyPadding, calc: calc } = token;
    const groupPrefixCls = `${componentCls}-group`;
    return {
        [groupPrefixCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            zIndex: 99,
            display: "block",
            border: "none",
            position: "fixed",
            width: floatButtonSize,
            height: "auto",
            boxShadow: "none",
            minHeight: floatButtonSize,
            insetInlineEnd: token.floatButtonInsetInlineEnd,
            insetBlockEnd: token.floatButtonInsetBlockEnd,
            borderRadius: borderRadiusLG,
            [`${groupPrefixCls}-wrap`]: {
                zIndex: -1,
                display: "block",
                position: "relative",
                marginBottom: margin
            },
            [`&${groupPrefixCls}-rtl`]: {
                direction: "rtl"
            },
            [componentCls]: {
                position: "static"
            }
        }),
        [`${groupPrefixCls}-circle`]: {
            [`${componentCls}-circle:not(:last-child)`]: {
                marginBottom: token.margin,
                [`${componentCls}-body`]: {
                    width: floatButtonSize,
                    height: floatButtonSize,
                    borderRadius: "50%"
                }
            }
        },
        [`${groupPrefixCls}-square`]: {
            [`${componentCls}-square`]: {
                borderRadius: 0,
                padding: 0,
                "&:first-child": {
                    borderStartStartRadius: borderRadiusLG,
                    borderStartEndRadius: borderRadiusLG
                },
                "&:last-child": {
                    borderEndStartRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                },
                "&:not(:last-child)": {
                    borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                },
                [`${antCls}-badge`]: {
                    [`${antCls}-badge-count`]: {
                        top: calc(calc(floatButtonBodyPadding).add(badgeOffset)).mul(-1).equal(),
                        insetInlineEnd: calc(calc(floatButtonBodyPadding).add(badgeOffset)).mul(-1).equal()
                    }
                }
            },
            [`${groupPrefixCls}-wrap`]: {
                display: "block",
                borderRadius: borderRadiusLG,
                boxShadow: token.boxShadowSecondary,
                [`${componentCls}-square`]: {
                    boxShadow: "none",
                    marginTop: 0,
                    borderRadius: 0,
                    padding: floatButtonBodyPadding,
                    "&:first-child": {
                        borderStartStartRadius: borderRadiusLG,
                        borderStartEndRadius: borderRadiusLG
                    },
                    "&:last-child": {
                        borderEndStartRadius: borderRadiusLG,
                        borderEndEndRadius: borderRadiusLG
                    },
                    "&:not(:last-child)": {
                        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    },
                    [`${componentCls}-body`]: {
                        width: token.floatButtonBodySize,
                        height: token.floatButtonBodySize
                    }
                }
            }
        },
        [`${groupPrefixCls}-circle-shadow`]: {
            boxShadow: "none"
        },
        [`${groupPrefixCls}-square-shadow`]: {
            boxShadow: token.boxShadowSecondary,
            [`${componentCls}-square`]: {
                boxShadow: "none",
                padding: floatButtonBodyPadding,
                [`${componentCls}-body`]: {
                    width: token.floatButtonBodySize,
                    height: token.floatButtonBodySize,
                    borderRadius: borderRadiusSM
                }
            }
        }
    };
};
// ============================== Shared ==============================
const $d7cfe86cae631824$var$sharedFloatButtonStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, floatButtonBodyPadding: floatButtonBodyPadding, floatButtonIconSize: floatButtonIconSize, floatButtonSize: floatButtonSize, borderRadiusLG: borderRadiusLG, badgeOffset: badgeOffset, dotOffsetInSquare: dotOffsetInSquare, dotOffsetInCircle: dotOffsetInCircle, calc: calc } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            border: "none",
            position: "fixed",
            cursor: "pointer",
            zIndex: 99,
            // Do not remove the 'display: block' here.
            // Deleting it will cause marginBottom to become ineffective.
            // Ref: https://github.com/ant-design/ant-design/issues/44700
            display: "block",
            width: floatButtonSize,
            height: floatButtonSize,
            insetInlineEnd: token.floatButtonInsetInlineEnd,
            insetBlockEnd: token.floatButtonInsetBlockEnd,
            boxShadow: token.boxShadowSecondary,
            // Pure Panel
            "&-pure": {
                position: "relative",
                inset: "auto"
            },
            "&:empty": {
                display: "none"
            },
            [`${antCls}-badge`]: {
                width: "100%",
                height: "100%",
                [`${antCls}-badge-count`]: {
                    transform: "translate(0, 0)",
                    transformOrigin: "center",
                    top: calc(badgeOffset).mul(-1).equal(),
                    insetInlineEnd: calc(badgeOffset).mul(-1).equal()
                }
            },
            [`${componentCls}-body`]: {
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transition: `all ${token.motionDurationMid}`,
                [`${componentCls}-content`]: {
                    overflow: "hidden",
                    textAlign: "center",
                    minHeight: floatButtonSize,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(calc(floatButtonBodyPadding).div(2).equal())} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(floatButtonBodyPadding)}`,
                    [`${componentCls}-icon`]: {
                        textAlign: "center",
                        margin: "auto",
                        width: floatButtonIconSize,
                        fontSize: floatButtonIconSize,
                        lineHeight: 1
                    }
                }
            }
        }),
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        },
        [`${componentCls}-circle`]: {
            height: floatButtonSize,
            borderRadius: "50%",
            [`${antCls}-badge`]: {
                [`${antCls}-badge-dot`]: {
                    top: dotOffsetInCircle,
                    insetInlineEnd: dotOffsetInCircle
                }
            },
            [`${componentCls}-body`]: {
                borderRadius: "50%"
            }
        },
        [`${componentCls}-square`]: {
            height: "auto",
            minHeight: floatButtonSize,
            borderRadius: borderRadiusLG,
            [`${antCls}-badge`]: {
                [`${antCls}-badge-dot`]: {
                    top: dotOffsetInSquare,
                    insetInlineEnd: dotOffsetInSquare
                }
            },
            [`${componentCls}-body`]: {
                height: "auto",
                borderRadius: borderRadiusLG
            }
        },
        [`${componentCls}-default`]: {
            backgroundColor: token.floatButtonBackgroundColor,
            transition: `background-color ${token.motionDurationMid}`,
            [`${componentCls}-body`]: {
                backgroundColor: token.floatButtonBackgroundColor,
                transition: `background-color ${token.motionDurationMid}`,
                "&:hover": {
                    backgroundColor: token.colorFillContent
                },
                [`${componentCls}-content`]: {
                    [`${componentCls}-icon`]: {
                        color: token.colorText
                    },
                    [`${componentCls}-description`]: {
                        display: "flex",
                        alignItems: "center",
                        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.fontSizeLG),
                        color: token.colorText,
                        fontSize: token.fontSizeSM
                    }
                }
            }
        },
        [`${componentCls}-primary`]: {
            backgroundColor: token.colorPrimary,
            [`${componentCls}-body`]: {
                backgroundColor: token.colorPrimary,
                transition: `background-color ${token.motionDurationMid}`,
                "&:hover": {
                    backgroundColor: token.colorPrimaryHover
                },
                [`${componentCls}-content`]: {
                    [`${componentCls}-icon`]: {
                        color: token.colorTextLightSolid
                    },
                    [`${componentCls}-description`]: {
                        display: "flex",
                        alignItems: "center",
                        lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.fontSizeLG),
                        color: token.colorTextLightSolid,
                        fontSize: token.fontSizeSM
                    }
                }
            }
        }
    };
};
const $d7cfe86cae631824$export$9ca1be8807fe0675 = (token)=>({
        dotOffsetInCircle: (0, $63326cfcd24aa6ea$export$2e2bcd8739ae039)(token.controlHeightLG / 2),
        dotOffsetInSquare: (0, $63326cfcd24aa6ea$export$2e2bcd8739ae039)(token.borderRadiusLG)
    });
var $d7cfe86cae631824$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("FloatButton", (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, marginXXL: marginXXL, marginLG: marginLG, fontSize: fontSize, fontSizeIcon: fontSizeIcon, controlItemBgHover: controlItemBgHover, paddingXXS: paddingXXS, calc: calc } = token;
    const floatButtonToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        floatButtonBackgroundColor: colorBgElevated,
        floatButtonColor: colorTextLightSolid,
        floatButtonHoverBackgroundColor: controlItemBgHover,
        floatButtonFontSize: fontSize,
        floatButtonIconSize: calc(fontSizeIcon).mul(1.5).equal(),
        floatButtonSize: controlHeightLG,
        floatButtonInsetBlockEnd: marginXXL,
        floatButtonInsetInlineEnd: marginLG,
        floatButtonBodySize: calc(controlHeightLG).sub(calc(paddingXXS).mul(2)).equal(),
        // 这里的 paddingXXS 是简写，完整逻辑是 (controlHeightLG - (controlHeightLG - paddingXXS * 2)) / 2,
        floatButtonBodyPadding: paddingXXS,
        badgeOffset: calc(paddingXXS).mul(1.5).equal()
    });
    return [
        $d7cfe86cae631824$var$floatButtonGroupStyle(floatButtonToken),
        $d7cfe86cae631824$var$sharedFloatButtonStyle(floatButtonToken),
        (0, $cfaac789ec22cce1$export$2909268c8354a12)(token),
        $d7cfe86cae631824$var$initFloatButtonGroupMotion(floatButtonToken)
    ];
}, $d7cfe86cae631824$export$9ca1be8807fe0675);


"use client";
var $6a82ab4792282e7d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $6a82ab4792282e7d$export$5fb6721f6c2144ac = "float-btn";
const $6a82ab4792282e7d$var$InternalFloatButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, type: type = "default", shape: shape = "circle", icon: icon, description: description, tooltip: tooltip, badge: badge = {} } = props, restProps = $6a82ab4792282e7d$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "type",
        "shape",
        "icon",
        "description",
        "tooltip",
        "badge"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const groupShape = (0, $acw62.useContext)((0, $29887e00e9f7dd95$export$2e2bcd8739ae039));
    const prefixCls = getPrefixCls($6a82ab4792282e7d$export$5fb6721f6c2144ac, customizePrefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $d7cfe86cae631824$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedShape = groupShape || shape;
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, rootCls, prefixCls, className, rootClassName, `${prefixCls}-${type}`, `${prefixCls}-${mergedShape}`, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    });
    // 虽然在 ts 中已经 omit 过了，但是为了防止多余的属性被透传进来，这里再 omit 一遍，以防万一
    const badgeProps = (0, $acw62.useMemo)(()=>(0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(badge, [
            "title",
            "children",
            "status",
            "text"
        ]), [
        badge
    ]);
    const contentProps = (0, $acw62.useMemo)(()=>({
            prefixCls: prefixCls,
            description: description,
            icon: icon,
            type: type
        }), [
        prefixCls,
        description,
        icon,
        type
    ]);
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${prefixCls}-body`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dbb6ad41621b1e34$export$2e2bcd8739ae039), Object.assign({}, contentProps)));
    if ("badge" in props) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1118404ffe351710$export$2e2bcd8739ae039), Object.assign({}, badgeProps), buttonNode);
    if ("tooltip" in props) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
        title: tooltip,
        placement: direction === "rtl" ? "right" : "left"
    }, buttonNode);
    return wrapCSSVar(props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        ref: ref
    }, restProps, {
        className: classString
    }), buttonNode) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        ref: ref
    }, restProps, {
        className: classString,
        type: "button"
    }), buttonNode));
});
const $6a82ab4792282e7d$var$FloatButton = $6a82ab4792282e7d$var$InternalFloatButton;
var $6a82ab4792282e7d$export$2e2bcd8739ae039 = $6a82ab4792282e7d$var$FloatButton;


"use client";
var $80f46a0c14542918$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $80f46a0c14542918$var$BackTop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, type: type = "default", shape: shape = "circle", visibilityHeight: visibilityHeight = 400, icon: icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $55f5c421b582c04d$export$2e2bcd8739ae039), null), target: target, onClick: onClick, duration: duration = 450 } = props, restProps = $80f46a0c14542918$var$__rest(props, [
        "prefixCls",
        "className",
        "type",
        "shape",
        "visibilityHeight",
        "icon",
        "target",
        "onClick",
        "duration"
    ]);
    const [visible, setVisible] = (0, $acw62.useState)(visibilityHeight === 0);
    const internalRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>({
            nativeElement: internalRef.current
        }));
    const getDefaultTarget = ()=>{
        var _a;
        return ((_a = internalRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || window;
    };
    const handleScroll = (0, $2612b4c1638153e7$export$2e2bcd8739ae039)((e)=>{
        const scrollTop = (0, $bf032ca2c6c444c9$export$2e2bcd8739ae039)(e.target);
        setVisible(scrollTop >= visibilityHeight);
    });
    (0, $acw62.useEffect)(()=>{
        const getTarget = target || getDefaultTarget;
        const container = getTarget();
        handleScroll({
            target: container
        });
        container === null || container === void 0 || container.addEventListener("scroll", handleScroll);
        return ()=>{
            handleScroll.cancel();
            container === null || container === void 0 || container.removeEventListener("scroll", handleScroll);
        };
    }, [
        target
    ]);
    const scrollToTop = (e)=>{
        (0, $4262b79604674a3c$export$2e2bcd8739ae039)(0, {
            getContainer: target || getDefaultTarget,
            duration: duration
        });
        onClick === null || onClick === void 0 || onClick(e);
    };
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls((0, $6a82ab4792282e7d$export$5fb6721f6c2144ac), customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const groupShape = (0, $acw62.useContext)((0, $29887e00e9f7dd95$export$2e2bcd8739ae039));
    const mergedShape = groupShape || shape;
    const contentProps = Object.assign({
        prefixCls: prefixCls,
        icon: icon,
        type: type,
        shape: mergedShape
    }, restProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: visible,
        motionName: `${rootPrefixCls}-fade`
    }, (_ref, setRef)=>{
        let { className: motionClassName } = _ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a82ab4792282e7d$export$2e2bcd8739ae039), Object.assign({
            ref: (0, $5e297877593af644$export$ab452c34e8e05029)(internalRef, setRef)
        }, contentProps, {
            onClick: scrollToTop,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, motionClassName)
        }));
    });
});
var $80f46a0c14542918$export$2e2bcd8739ae039 = $80f46a0c14542918$var$BackTop;




var $acw62 = parcelRequire("acw62");











"use client";
var $0545160dc2ec36c0$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $0545160dc2ec36c0$var$FloatButtonGroup = (props)=>{
    var _a;
    const { prefixCls: customizePrefixCls, className: className, style: style, shape: shape = "circle", type: type = "default", icon: icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b54f846438024e8$export$2e2bcd8739ae039), null), closeIcon: closeIcon, description: description, trigger: trigger, children: children, onOpenChange: onOpenChange, open: customOpen } = props, floatButtonProps = $0545160dc2ec36c0$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "shape",
        "type",
        "icon",
        "closeIcon",
        "description",
        "trigger",
        "children",
        "onOpenChange",
        "open"
    ]);
    const { direction: direction, getPrefixCls: getPrefixCls, floatButtonGroup: floatButtonGroup } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const mergedCloseIcon = (_a = closeIcon !== null && closeIcon !== void 0 ? closeIcon : floatButtonGroup === null || floatButtonGroup === void 0 ? void 0 : floatButtonGroup.closeIcon) !== null && _a !== void 0 ? _a : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null);
    const prefixCls = getPrefixCls((0, $6a82ab4792282e7d$export$5fb6721f6c2144ac), customizePrefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $d7cfe86cae631824$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const groupCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(groupPrefixCls, hashId, cssVarCls, rootCls, className, {
        [`${groupPrefixCls}-rtl`]: direction === "rtl",
        [`${groupPrefixCls}-${shape}`]: shape,
        [`${groupPrefixCls}-${shape}-shadow`]: !trigger
    });
    const wrapperCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, `${groupPrefixCls}-wrap`);
    const [open, setOpen] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: customOpen
    });
    const floatButtonGroupRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const floatButtonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const hoverAction = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const hoverTypeAction = {
            onMouseEnter () {
                setOpen(true);
                onOpenChange === null || onOpenChange === void 0 || onOpenChange(true);
            },
            onMouseLeave () {
                setOpen(false);
                onOpenChange === null || onOpenChange === void 0 || onOpenChange(false);
            }
        };
        return trigger === "hover" ? hoverTypeAction : {};
    }, [
        trigger
    ]);
    const handleOpenChange = ()=>{
        setOpen((prevState)=>{
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(!prevState);
            return !prevState;
        });
    };
    const onClick = (0, $acw62.useCallback)((e)=>{
        var _a, _b;
        if ((_a = floatButtonGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            if ((_b = floatButtonRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target)) handleOpenChange();
            return;
        }
        setOpen(false);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(false);
    }, [
        trigger
    ]);
    (0, $acw62.useEffect)(()=>{
        if (trigger === "click") {
            document.addEventListener("click", onClick);
            return ()=>{
                document.removeEventListener("click", onClick);
            };
        }
    }, [
        trigger
    ]);
    return wrapCSSVar(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $29887e00e9f7dd95$export$97c642573a13671), {
        value: shape
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: floatButtonGroupRef,
        className: groupCls,
        style: style
    }, hoverAction), trigger && [
        "click",
        "hover"
    ].includes(trigger) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), {
        visible: open,
        motionName: `${groupPrefixCls}-wrap`
    }, (_ref)=>{
        let { className: motionClassName } = _ref;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(motionClassName, wrapperCls)
        }, children);
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6a82ab4792282e7d$export$2e2bcd8739ae039), Object.assign({
        ref: floatButtonRef,
        type: type,
        icon: open ? mergedCloseIcon : icon,
        description: description,
        "aria-label": props["aria-label"]
    }, floatButtonProps))) : children)));
};
var $0545160dc2ec36c0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.memo)($0545160dc2ec36c0$var$FloatButtonGroup);



var $acw62 = parcelRequire("acw62");





"use client";
var $b0531178b85013e2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b0531178b85013e2$var$PureFloatButton = (_a)=>{
    var { backTop: backTop } = _a, props = $b0531178b85013e2$var$__rest(_a, [
        "backTop"
    ]);
    return backTop ? /*#__PURE__*/ $acw62.createElement((0, $80f46a0c14542918$export$2e2bcd8739ae039), Object.assign({}, props, {
        visibilityHeight: 0
    })) : /*#__PURE__*/ $acw62.createElement((0, $6a82ab4792282e7d$export$2e2bcd8739ae039), Object.assign({}, props));
};
/** @private Internal Component. Do not use in your production. */ const $b0531178b85013e2$var$PurePanel = (_a)=>{
    var { className: className, items: items } = _a, props = $b0531178b85013e2$var$__rest(_a, [
        "className",
        "items"
    ]);
    const { prefixCls: customizePrefixCls } = props;
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls((0, $6a82ab4792282e7d$export$5fb6721f6c2144ac), customizePrefixCls);
    const pureCls = `${prefixCls}-pure`;
    if (items) return /*#__PURE__*/ $acw62.createElement((0, $0545160dc2ec36c0$export$2e2bcd8739ae039), Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, pureCls)
    }, props), items.map((item, index)=>/*#__PURE__*/ $acw62.createElement($b0531178b85013e2$var$PureFloatButton, Object.assign({
            key: index
        }, item))));
    return /*#__PURE__*/ $acw62.createElement($b0531178b85013e2$var$PureFloatButton, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, pureCls)
    }, props));
};
var $b0531178b85013e2$export$2e2bcd8739ae039 = $b0531178b85013e2$var$PurePanel;


"use client";
(0, $6a82ab4792282e7d$export$2e2bcd8739ae039).BackTop = (0, $80f46a0c14542918$export$2e2bcd8739ae039);
(0, $6a82ab4792282e7d$export$2e2bcd8739ae039).Group = (0, $0545160dc2ec36c0$export$2e2bcd8739ae039);
(0, $6a82ab4792282e7d$export$2e2bcd8739ae039)._InternalPanelDoNotUseOrYouWillBeFired = (0, $b0531178b85013e2$export$2e2bcd8739ae039);
var $f17dad7fc2efbdff$export$2e2bcd8739ae039 = (0, $6a82ab4792282e7d$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $e68297810293da87$var$FileImageOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-image",
    "theme": "outlined"
};
var $e68297810293da87$export$2e2bcd8739ae039 = $e68297810293da87$var$FileImageOutlined;



var $e94fe1725923755c$var$FileImageOutlined = function FileImageOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $e68297810293da87$export$2e2bcd8739ae039)
    }));
};
/**![file-image](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU1My4xIDUwOS4xbC03Ny44IDk5LjItNDEuMS01Mi40YTggOCAwIDAwLTEyLjYgMGwtOTkuOCAxMjcuMmE3Ljk4IDcuOTggMCAwMDYuMyAxMi45SDY5NmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOWwtMTM2LjUtMTc0YTguMSA4LjEgMCAwMC0xMi43IDB6TTM2MCA0NDJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAwem00OTQuNi0xNTMuNEw2MzkuNCA3My40Yy02LTYtMTQuMS05LjQtMjIuNi05LjRIMTkyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY4MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMxMS4zYzAtOC41LTMuNC0xNi43LTkuNC0yMi43ek03OTAuMiAzMjZINjAyVjEzNy44TDc5MC4yIDMyNnptMS44IDU2MkgyMzJWMTM2aDMwMnYyMTZhNDIgNDIgMCAwMDQyIDQyaDIxNnY0OTR6IiAvPjwvc3ZnPg==) */ var $e94fe1725923755c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($e94fe1725923755c$var$FileImageOutlined);
var $e94fe1725923755c$export$2e2bcd8739ae039 = $e94fe1725923755c$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $d09e0a38d67021a7$var$PartitionOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3zm53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150zm364.2 75.1h150v150.1h-150V662.1z"
                }
            }
        ]
    },
    "name": "partition",
    "theme": "outlined"
};
var $d09e0a38d67021a7$export$2e2bcd8739ae039 = $d09e0a38d67021a7$var$PartitionOutlined;



var $2afc7bfb9bf837f2$var$PartitionOutlined = function PartitionOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $d09e0a38d67021a7$export$2e2bcd8739ae039)
    }));
};
/**![partition](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik02NDAuNiA0MjkuOGgyNTcuMWM3LjkgMCAxNC4zLTYuNCAxNC4zLTE0LjNWMTU4LjNjMC03LjktNi40LTE0LjMtMTQuMy0xNC4zSDY0MC42Yy03LjkgMC0xNC4zIDYuNC0xNC4zIDE0LjN2OTIuOUg0OTAuNmMtMy45IDAtNy4xIDMuMi03LjEgNy4xdjIyMS41aC04NS43di05Ni41YzAtNy45LTYuNC0xNC4zLTE0LjMtMTQuM0gxMjYuM2MtNy45IDAtMTQuMyA2LjQtMTQuMyAxNC4zdjI1Ny4yYzAgNy45IDYuNCAxNC4zIDE0LjMgMTQuM2gyNTcuMWM3LjkgMCAxNC4zLTYuNCAxNC4zLTE0LjNWNTQ0aDg1Ljd2MjIxLjVjMCAzLjkgMy4yIDcuMSA3LjEgNy4xaDEzNS43djkyLjljMCA3LjkgNi40IDE0LjMgMTQuMyAxNC4zaDI1Ny4xYzcuOSAwIDE0LjMtNi40IDE0LjMtMTQuM3YtMjU3YzAtNy45LTYuNC0xNC4zLTE0LjMtMTQuM2gtMjU3Yy03LjkgMC0xNC4zIDYuNC0xNC4zIDE0LjN2MTAwaC03OC42di0zOTNoNzguNnYxMDBjMCA3LjkgNi40IDE0LjMgMTQuMyAxNC4zem01My41LTIxNy45aDE1MFYzNjJoLTE1MFYyMTEuOXpNMzI5LjkgNTg3aC0xNTBWNDM3aDE1MHYxNTB6bTM2NC4yIDc1LjFoMTUwdjE1MC4xaC0xNTBWNjYyLjF6IiAvPjwvc3ZnPg==) */ var $2afc7bfb9bf837f2$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2afc7bfb9bf837f2$var$PartitionOutlined);
var $2afc7bfb9bf837f2$export$2e2bcd8739ae039 = $2afc7bfb9bf837f2$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5ceabd3adffb0bf8$var$ExpandAltOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 000 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0013.5-4.7L863.9 169a7.9 7.9 0 00-8.9-8.9zM416.6 562.3a8.03 8.03 0 00-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 00-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z"
                }
            }
        ]
    },
    "name": "expand-alt",
    "theme": "outlined"
};
var $5ceabd3adffb0bf8$export$2e2bcd8739ae039 = $5ceabd3adffb0bf8$var$ExpandAltOutlined;



var $f1c791ea476719e3$var$ExpandAltOutlined = function ExpandAltOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5ceabd3adffb0bf8$export$2e2bcd8739ae039)
    }));
};
/**![expand-alt](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NSAxNjAuMWwtMTg5LjIgMjMuNWMtNi42LjgtOS4zIDguOC00LjcgMTMuNWw1NC43IDU0LjctMTUzLjUgMTUzLjVhOC4wMyA4LjAzIDAgMDAwIDExLjNsNDUuMSA0NS4xYzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBsMTUzLjYtMTUzLjYgNTQuNyA1NC43YTcuOTQgNy45NCAwIDAwMTMuNS00LjdMODYzLjkgMTY5YTcuOSA3LjkgMCAwMC04LjktOC45ek00MTYuNiA1NjIuM2E4LjAzIDguMDMgMCAwMC0xMS4zIDBMMjUxLjggNzE1LjlsLTU0LjctNTQuN2E3Ljk0IDcuOTQgMCAwMC0xMy41IDQuN0wxNjAuMSA4NTVjLS42IDUuMiAzLjcgOS41IDguOSA4LjlsMTg5LjItMjMuNWM2LjYtLjggOS4zLTguOCA0LjctMTMuNWwtNTQuNy01NC43IDE1My42LTE1My42YzMuMS0zLjEgMy4xLTguMiAwLTExLjNsLTQ1LjItNDV6IiAvPjwvc3ZnPg==) */ var $f1c791ea476719e3$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($f1c791ea476719e3$var$ExpandAltOutlined);
var $f1c791ea476719e3$export$2e2bcd8739ae039 = $f1c791ea476719e3$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $a8beb526486c71a5$var$PlayCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 00398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 000-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z"
                }
            }
        ]
    },
    "name": "play-circle",
    "theme": "outlined"
};
var $a8beb526486c71a5$export$2e2bcd8739ae039 = $a8beb526486c71a5$var$PlayCircleOutlined;



var $31fa5d5f7a56cbd8$var$PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $a8beb526486c71a5$export$2e2bcd8739ae039)
    }));
};
/**![play-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTcxOS40IDQ5OS4xbC0yOTYuMS0yMTVBMTUuOSAxNS45IDAgMDAzOTggMjk3djQzMGMwIDEzLjEgMTQuOCAyMC41IDI1LjMgMTIuOWwyOTYuMS0yMTVhMTUuOSAxNS45IDAgMDAwLTI1Ljh6bS0yNTcuNiAxMzRWMzkwLjlMNjI4LjUgNTEyIDQ2MS44IDYzMy4xeiIgLz48L3N2Zz4=) */ var $31fa5d5f7a56cbd8$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($31fa5d5f7a56cbd8$var$PlayCircleOutlined);
var $31fa5d5f7a56cbd8$export$2e2bcd8739ae039 = $31fa5d5f7a56cbd8$var$RefIcon;






const $5184a13b2b4cae17$var$applier = new (0, $d40e44a710563a99$export$255481f24182975c).TransitionApplier({
    duration: 600,
    timingFunction: (t)=>t,
    async onTick () {
        (0, $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b).zoomAt((0, $14e68cbe3c2b3085$export$5d8ad995f8f7b680), (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNodes());
    }
});
const $5184a13b2b4cae17$export$717ee5e4c44f254a = (action, relevantDetails = {}, problem_id)=>{
    const blocks = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNodes().map((node)=>node.getType());
    const connections = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getConnections().map((connection)=>{
        const sourceNode = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNode(connection.source);
        const targetNode = (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNode(connection.target);
        return {
            source: sourceNode.getType(),
            target: targetNode.getType()
        };
    });
    const eventData = (0, $cfadb87391ca5e26$export$bfb1dec8091047c0)(action, {
        editorData: {
            blocks: blocks,
            connections: connections,
            ...relevantDetails
        }
    });
    const details = (0, $cfadb87391ca5e26$export$5e4dc5c899332621)(action, eventData);
    (0, $cfadb87391ca5e26$export$7e41d6135b9d82b9)({
        action: action,
        eventData: eventData,
        details: details,
        problem_id: problem_id
    });
};
const $5184a13b2b4cae17$export$95b8ceda2c9b7ad6 = async ()=>{
    await (0, $8edd8caaa4dabbef$export$dd91fcb1ff6d0f3b).zoomAt((0, $14e68cbe3c2b3085$export$5d8ad995f8f7b680), (0, $14e68cbe3c2b3085$export$48f2fed47365221c).getNodes());
};
const $5184a13b2b4cae17$var$EditorButtonPanel = ({ setRunProgram: setRunProgram, runProgram: runProgram, setIsImageGalleryOpen: setIsImageGalleryOpen, problem_id: problem_id, consoleText: consoleText, codePreview: codePreview })=>{
    const [localRunProgram, setLocalRunProgram] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleClickZoomToFit = async ()=>{
        await $5184a13b2b4cae17$export$95b8ceda2c9b7ad6();
        $5184a13b2b4cae17$export$717ee5e4c44f254a("zoom_to_fit", {}, problem_id);
    };
    const handleAutoLayout = async ()=>{
        await (0, $14e68cbe3c2b3085$export$3dc39d1c205f6de).layout({
            applier: $5184a13b2b4cae17$var$applier
        });
        (0, $afd930b1a77e3a58$export$e8665f5904db2e8f)(problem_id);
        $5184a13b2b4cae17$export$717ee5e4c44f254a("auto_layout", {}, problem_id);
    };
    const handleRunProgram = async ()=>{
        if (!localRunProgram) setLocalRunProgram(true);
    };
    const handleOpenImageGallery = ()=>{
        setIsImageGalleryOpen(true);
    };
    (0, $acw62.useEffect)(()=>{
        if (localRunProgram) setRunProgram(true);
    }, [
        localRunProgram
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!runProgram) {
            setLocalRunProgram(false);
            if (localRunProgram) $5184a13b2b4cae17$export$717ee5e4c44f254a("run_program", {
                code_preview: codePreview,
                console_output: consoleText
            }, problem_id);
        }
    }, [
        runProgram
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "editorFloatButtonGroup",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                title: "View Saved Images",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f17dad7fc2efbdff$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e94fe1725923755c$export$2e2bcd8739ae039), {}),
                    onClick: handleOpenImageGallery
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                title: "Auto-Layout",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f17dad7fc2efbdff$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2afc7bfb9bf837f2$export$2e2bcd8739ae039), {}),
                    onClick: handleAutoLayout
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                title: "Zoom to Fit",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f17dad7fc2efbdff$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1c791ea476719e3$export$2e2bcd8739ae039), {}),
                    onClick: handleClickZoomToFit
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                title: "Run Program",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f17dad7fc2efbdff$export$2e2bcd8739ae039), {
                    className: "runProgramBtn",
                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $31fa5d5f7a56cbd8$export$2e2bcd8739ae039), {}),
                    onClick: handleRunProgram
                })
            })
        ]
    });
};
var $5184a13b2b4cae17$export$2e2bcd8739ae039 = $5184a13b2b4cae17$var$EditorButtonPanel;




var $acw62 = parcelRequire("acw62");

// export this package's api





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e6b07bfba513af43$var$DrawerContext = /*#__PURE__*/ $acw62.createContext(null);
var $e6b07bfba513af43$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $acw62.createContext({});
var $e6b07bfba513af43$export$2e2bcd8739ae039 = $e6b07bfba513af43$var$DrawerContext;











var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



var $cd37d88931cf5417$var$_excluded = [
    "prefixCls",
    "className",
    "containerRef"
];
var $cd37d88931cf5417$var$DrawerPanel = function DrawerPanel(props) {
    var prefixCls = props.prefixCls, className = props.className, containerRef = props.containerRef, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $cd37d88931cf5417$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $e6b07bfba513af43$export$ee4e38b469b6f5d1)), panelRef = _React$useContext.panel;
    var mergedRef = (0, $5e297877593af644$export$1d1c999670a1285d)(panelRef, containerRef);
    // =============================== Render ===============================
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content"), className),
        role: "dialog",
        ref: mergedRef
    }, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
        aria: true
    }), {
        "aria-modal": "true"
    }, restProps));
};
var $cd37d88931cf5417$export$2e2bcd8739ae039 = $cd37d88931cf5417$var$DrawerPanel;




function $3608f954053a88c7$export$efeadb1af96d0a6d(value) {
    if (typeof value === "string" && String(Number(value)) === value) {
        (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(false, "Invalid value type of `width` or `height` which should be number type instead.");
        return Number(value);
    }
    return value;
}
function $3608f954053a88c7$export$e77176dc71180add(props) {
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)(!("wrapperClassName" in props), "'wrapperClassName' is removed. Please use 'rootClassName' instead.");
    (0, $05a5f2c645683a81$export$2e2bcd8739ae039)((0, $c6daeb3adc2b0e60$export$2e2bcd8739ae039)() || !props.open, "Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.");
}


var $494acda2d727dd35$var$sentinelStyle = {
    width: 0,
    height: 0,
    overflow: "hidden",
    outline: "none",
    position: "absolute"
};
function $494acda2d727dd35$var$DrawerPopup(props, ref) {
    var _ref, _pushConfig$distance, _pushConfig;
    var prefixCls = props.prefixCls, open = props.open, placement = props.placement, inline = props.inline, push = props.push, forceRender = props.forceRender, autoFocus = props.autoFocus, keyboard = props.keyboard, drawerClassNames = props.classNames, rootClassName = props.rootClassName, rootStyle = props.rootStyle, zIndex = props.zIndex, className = props.className, id = props.id, style = props.style, motion = props.motion, width = props.width, height = props.height, children = props.children, mask = props.mask, maskClosable = props.maskClosable, maskMotion = props.maskMotion, maskClassName = props.maskClassName, maskStyle = props.maskStyle, afterOpenChange = props.afterOpenChange, onClose = props.onClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, styles = props.styles, drawerRender = props.drawerRender;
    // ================================ Refs ================================
    var panelRef = $acw62.useRef();
    var sentinelStartRef = $acw62.useRef();
    var sentinelEndRef = $acw62.useRef();
    $acw62.useImperativeHandle(ref, function() {
        return panelRef.current;
    });
    var onPanelKeyDown = function onPanelKeyDown(event) {
        var keyCode = event.keyCode, shiftKey = event.shiftKey;
        switch(keyCode){
            // Tab active
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).TAB:
                if (keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).TAB) {
                    if (!shiftKey && document.activeElement === sentinelEndRef.current) {
                        var _sentinelStartRef$cur;
                        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
                            preventScroll: true
                        });
                    } else if (shiftKey && document.activeElement === sentinelStartRef.current) {
                        var _sentinelEndRef$curre;
                        (_sentinelEndRef$curre = sentinelEndRef.current) === null || _sentinelEndRef$curre === void 0 || _sentinelEndRef$curre.focus({
                            preventScroll: true
                        });
                    }
                }
                break;
            // Close
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC:
                if (onClose && keyboard) {
                    event.stopPropagation();
                    onClose(event);
                }
                break;
        }
    };
    // ========================== Control ===========================
    // Auto Focus
    $acw62.useEffect(function() {
        if (open && autoFocus) {
            var _panelRef$current;
            (_panelRef$current = panelRef.current) === null || _panelRef$current === void 0 || _panelRef$current.focus({
                preventScroll: true
            });
        }
    }, [
        open
    ]);
    // ============================ Push ============================
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), pushed = _React$useState2[0], setPushed = _React$useState2[1];
    var parentContext = $acw62.useContext((0, $e6b07bfba513af43$export$2e2bcd8739ae039));
    // Merge push distance
    var pushConfig;
    if (typeof push === "boolean") pushConfig = push ? {} : {
        distance: 0
    };
    else pushConfig = push || {};
    var pushDistance = (_ref = (_pushConfig$distance = (_pushConfig = pushConfig) === null || _pushConfig === void 0 ? void 0 : _pushConfig.distance) !== null && _pushConfig$distance !== void 0 ? _pushConfig$distance : parentContext === null || parentContext === void 0 ? void 0 : parentContext.pushDistance) !== null && _ref !== void 0 ? _ref : 180;
    var mergedContext = $acw62.useMemo(function() {
        return {
            pushDistance: pushDistance,
            push: function push() {
                setPushed(true);
            },
            pull: function pull() {
                setPushed(false);
            }
        };
    }, [
        pushDistance
    ]);
    // ========================= ScrollLock =========================
    // Tell parent to push
    $acw62.useEffect(function() {
        if (open) {
            var _parentContext$push;
            parentContext === null || parentContext === void 0 || (_parentContext$push = parentContext.push) === null || _parentContext$push === void 0 || _parentContext$push.call(parentContext);
        } else {
            var _parentContext$pull;
            parentContext === null || parentContext === void 0 || (_parentContext$pull = parentContext.pull) === null || _parentContext$pull === void 0 || _parentContext$pull.call(parentContext);
        }
    }, [
        open
    ]);
    // Clean up
    $acw62.useEffect(function() {
        return function() {
            var _parentContext$pull2;
            parentContext === null || parentContext === void 0 || (_parentContext$pull2 = parentContext.pull) === null || _parentContext$pull2 === void 0 || _parentContext$pull2.call(parentContext);
        };
    }, []);
    // ============================ Mask ============================
    var maskNode = mask && /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        key: "mask"
    }, maskMotion, {
        visible: open
    }), function(_ref2, maskRef) {
        var motionMaskClassName = _ref2.className, motionMaskStyle = _ref2.style;
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-mask"), motionMaskClassName, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.mask, maskClassName),
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionMaskStyle), maskStyle), styles === null || styles === void 0 ? void 0 : styles.mask),
            onClick: maskClosable && open ? onClose : undefined,
            ref: maskRef
        });
    });
    // =========================== Panel ============================
    var motionProps = typeof motion === "function" ? motion(placement) : motion;
    var wrapperStyle = {};
    if (pushed && pushDistance) switch(placement){
        case "top":
            wrapperStyle.transform = "translateY(".concat(pushDistance, "px)");
            break;
        case "bottom":
            wrapperStyle.transform = "translateY(".concat(-pushDistance, "px)");
            break;
        case "left":
            wrapperStyle.transform = "translateX(".concat(pushDistance, "px)");
            break;
        default:
            wrapperStyle.transform = "translateX(".concat(-pushDistance, "px)");
            break;
    }
    if (placement === "left" || placement === "right") wrapperStyle.width = (0, $3608f954053a88c7$export$efeadb1af96d0a6d)(width);
    else wrapperStyle.height = (0, $3608f954053a88c7$export$efeadb1af96d0a6d)(height);
    var eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    var panelNode = /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        key: "panel"
    }, motionProps, {
        visible: open,
        forceRender: forceRender,
        onVisibleChanged: function onVisibleChanged(nextVisible) {
            afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
        },
        removeOnLeave: false,
        leavedClassName: "".concat(prefixCls, "-content-wrapper-hidden")
    }), function(_ref3, motionRef) {
        var motionClassName = _ref3.className, motionStyle = _ref3.style;
        var content = /*#__PURE__*/ $acw62.createElement((0, $cd37d88931cf5417$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            id: id,
            containerRef: motionRef,
            prefixCls: prefixCls,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.content),
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style), styles === null || styles === void 0 ? void 0 : styles.content)
        }, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
            aria: true
        }), eventHandlers), children);
        return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content-wrapper"), drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.wrapper, motionClassName),
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, wrapperStyle), motionStyle), styles === null || styles === void 0 ? void 0 : styles.wrapper)
        }, (0, $281efe5882c936de$export$2e2bcd8739ae039)(props, {
            data: true
        })), drawerRender ? drawerRender(content) : content);
    });
    // =========================== Render ===========================
    var containerStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, rootStyle);
    if (zIndex) containerStyle.zIndex = zIndex;
    return /*#__PURE__*/ $acw62.createElement((0, $e6b07bfba513af43$export$2e2bcd8739ae039).Provider, {
        value: mergedContext
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, "".concat(prefixCls, "-").concat(placement), rootClassName, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-open"), open), "".concat(prefixCls, "-inline"), inline)),
        style: containerStyle,
        tabIndex: -1,
        ref: panelRef,
        onKeyDown: onPanelKeyDown
    }, maskNode, /*#__PURE__*/ $acw62.createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: $494acda2d727dd35$var$sentinelStyle,
        "aria-hidden": "true",
        "data-sentinel": "start"
    }), panelNode, /*#__PURE__*/ $acw62.createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: $494acda2d727dd35$var$sentinelStyle,
        "aria-hidden": "true",
        "data-sentinel": "end"
    })));
}
var $494acda2d727dd35$var$RefDrawerPopup = /*#__PURE__*/ $acw62.forwardRef($494acda2d727dd35$var$DrawerPopup);
var $494acda2d727dd35$export$2e2bcd8739ae039 = $494acda2d727dd35$var$RefDrawerPopup;



var $d7298074da8fe094$var$Drawer = function Drawer(props) {
    var _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-drawer" : _props$prefixCls, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$width = props.width, width = _props$width === void 0 ? 378 : _props$width, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getContainer = props.getContainer, forceRender = props.forceRender, afterOpenChange = props.afterOpenChange, destroyOnClose = props.destroyOnClose, onMouseEnter = props.onMouseEnter, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, onClick = props.onClick, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, panelRef = props.panelRef;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
    // ============================= Open =============================
    var _React$useState3 = $acw62.useState(false), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), mounted = _React$useState4[0], setMounted = _React$useState4[1];
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        setMounted(true);
    }, []);
    var mergedOpen = mounted ? open : false;
    // ============================ Focus =============================
    var popupRef = $acw62.useRef();
    var lastActiveRef = $acw62.useRef();
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(function() {
        if (mergedOpen) lastActiveRef.current = document.activeElement;
    }, [
        mergedOpen
    ]);
    // ============================= Open =============================
    var internalAfterOpenChange = function internalAfterOpenChange(nextVisible) {
        var _popupRef$current;
        setAnimatedVisible(nextVisible);
        afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(nextVisible);
        if (!nextVisible && lastActiveRef.current && !((_popupRef$current = popupRef.current) !== null && _popupRef$current !== void 0 && _popupRef$current.contains(lastActiveRef.current))) {
            var _lastActiveRef$curren;
            (_lastActiveRef$curren = lastActiveRef.current) === null || _lastActiveRef$curren === void 0 || _lastActiveRef$curren.focus({
                preventScroll: true
            });
        }
    };
    // =========================== Context ============================
    var refContext = $acw62.useMemo(function() {
        return {
            panel: panelRef
        };
    }, [
        panelRef
    ]);
    // ============================ Render ============================
    if (!forceRender && !animatedVisible && !mergedOpen && destroyOnClose) return null;
    var eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    var drawerPopupProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        open: mergedOpen,
        prefixCls: prefixCls,
        placement: placement,
        autoFocus: autoFocus,
        keyboard: keyboard,
        width: width,
        mask: mask,
        maskClosable: maskClosable,
        inline: getContainer === false,
        afterOpenChange: internalAfterOpenChange,
        ref: popupRef
    }, eventHandlers);
    return /*#__PURE__*/ $acw62.createElement((0, $e6b07bfba513af43$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $acw62.createElement((0, $5b46218595a40828$export$2e2bcd8739ae039), {
        open: mergedOpen || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: mask && (mergedOpen || animatedVisible)
    }, /*#__PURE__*/ $acw62.createElement((0, $494acda2d727dd35$export$2e2bcd8739ae039), drawerPopupProps)));
};
var $d7298074da8fe094$export$2e2bcd8739ae039 = $d7298074da8fe094$var$Drawer;


var $614f9c0d6cbb150b$export$2e2bcd8739ae039 = (0, $d7298074da8fe094$export$2e2bcd8739ae039);










var $acw62 = parcelRequire("acw62");




"use client";
const $0279d43d1c26ee11$var$DrawerPanel = (props)=>{
    var _a, _b;
    const { prefixCls: prefixCls, title: title, footer: footer, extra: extra, loading: loading, onClose: onClose, headerStyle: headerStyle, bodyStyle: bodyStyle, footerStyle: footerStyle, children: children, classNames: drawerClassNames, styles: drawerStyles } = props;
    const { drawer: drawerContext } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const customCloseIconRender = $acw62.useCallback((icon)=>/*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            onClick: onClose,
            "aria-label": "Close",
            className: `${prefixCls}-close`
        }, icon), [
        onClose
    ]);
    const [mergedClosable, mergedCloseIcon] = (0, $91e86e8e8e97dd3f$export$2e2bcd8739ae039)((0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(props), (0, $91e86e8e8e97dd3f$export$51ad9c30389f050b)(drawerContext), {
        closable: true,
        closeIconRender: customCloseIconRender
    });
    const headerNode = $acw62.useMemo(()=>{
        var _a, _b;
        if (!title && !mergedClosable) return null;
        return /*#__PURE__*/ $acw62.createElement("div", {
            style: Object.assign(Object.assign(Object.assign({}, (_a = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.styles) === null || _a === void 0 ? void 0 : _a.header), headerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.header),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-header`, {
                [`${prefixCls}-header-close-only`]: mergedClosable && !title && !extra
            }, (_b = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.classNames) === null || _b === void 0 ? void 0 : _b.header, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.header)
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-header-title`
        }, mergedCloseIcon, title && /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-title`
        }, title)), extra && /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-extra`
        }, extra));
    }, [
        mergedClosable,
        mergedCloseIcon,
        extra,
        headerStyle,
        prefixCls,
        title
    ]);
    const footerNode = $acw62.useMemo(()=>{
        var _a, _b;
        if (!footer) return null;
        const footerClassName = `${prefixCls}-footer`;
        return /*#__PURE__*/ $acw62.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(footerClassName, (_a = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.classNames) === null || _a === void 0 ? void 0 : _a.footer, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.footer),
            style: Object.assign(Object.assign(Object.assign({}, (_b = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.styles) === null || _b === void 0 ? void 0 : _b.footer), footerStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.footer)
        }, footer);
    }, [
        footer,
        footerStyle,
        prefixCls
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, headerNode, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-body`, drawerClassNames === null || drawerClassNames === void 0 ? void 0 : drawerClassNames.body, (_a = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.classNames) === null || _a === void 0 ? void 0 : _a.body),
        style: Object.assign(Object.assign(Object.assign({}, (_b = drawerContext === null || drawerContext === void 0 ? void 0 : drawerContext.styles) === null || _b === void 0 ? void 0 : _b.body), bodyStyle), drawerStyles === null || drawerStyles === void 0 ? void 0 : drawerStyles.body)
    }, loading ? /*#__PURE__*/ $acw62.createElement((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 5
        },
        className: `${prefixCls}-body-skeleton`
    }) : children), footerNode);
};
var $0279d43d1c26ee11$export$2e2bcd8739ae039 = $0279d43d1c26ee11$var$DrawerPanel;





const $663c87952542a325$var$getMoveTranslate = (direction)=>{
    const value = "100%";
    return ({
        left: `translateX(-${value})`,
        right: `translateX(${value})`,
        top: `translateY(-${value})`,
        bottom: `translateY(${value})`
    })[direction];
};
const $663c87952542a325$var$getEnterLeaveStyle = (startStyle, endStyle)=>({
        "&-enter, &-appear": Object.assign(Object.assign({}, startStyle), {
            "&-active": endStyle
        }),
        "&-leave": Object.assign(Object.assign({}, endStyle), {
            "&-active": startStyle
        })
    });
const $663c87952542a325$var$getFadeStyle = (from, duration)=>Object.assign({
        "&-enter, &-appear, &-leave": {
            "&-start": {
                transition: "none"
            },
            "&-active": {
                transition: `all ${duration}`
            }
        }
    }, $663c87952542a325$var$getEnterLeaveStyle({
        opacity: from
    }, {
        opacity: 1
    }));
const $663c87952542a325$var$getPanelMotionStyles = (direction, duration)=>[
        $663c87952542a325$var$getFadeStyle(0.7, duration),
        $663c87952542a325$var$getEnterLeaveStyle({
            transform: $663c87952542a325$var$getMoveTranslate(direction)
        }, {
            transform: "none"
        })
    ];
const $663c87952542a325$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return {
        [componentCls]: {
            // ======================== Mask ========================
            [`${componentCls}-mask-motion`]: $663c87952542a325$var$getFadeStyle(0, motionDurationSlow),
            // ======================= Panel ========================
            [`${componentCls}-panel-motion`]: [
                "left",
                "right",
                "top",
                "bottom"
            ].reduce((obj, direction)=>Object.assign(Object.assign({}, obj), {
                    [`&-${direction}`]: $663c87952542a325$var$getPanelMotionStyles(direction, motionDurationSlow)
                }), {})
        }
    };
};
var $663c87952542a325$export$2e2bcd8739ae039 = $663c87952542a325$var$genMotionStyle;


// =============================== Base ===============================
const $f93b1dac0ddeb04a$var$genDrawerStyle = (token)=>{
    const { borderRadiusSM: borderRadiusSM, componentCls: componentCls, zIndexPopup: zIndexPopup, colorBgMask: colorBgMask, colorBgElevated: colorBgElevated, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, paddingXS: paddingXS, padding: padding, paddingLG: paddingLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, lineWidth: lineWidth, lineType: lineType, colorSplit: colorSplit, marginXS: marginXS, colorIcon: colorIcon, colorIconHover: colorIconHover, colorBgTextHover: colorBgTextHover, colorBgTextActive: colorBgTextActive, colorText: colorText, fontWeightStrong: fontWeightStrong, footerPaddingBlock: footerPaddingBlock, footerPaddingInline: footerPaddingInline, calc: calc } = token;
    const wrapperCls = `${componentCls}-content-wrapper`;
    return {
        [componentCls]: {
            position: "fixed",
            inset: 0,
            zIndex: zIndexPopup,
            pointerEvents: "none",
            color: colorText,
            "&-pure": {
                position: "relative",
                background: colorBgElevated,
                display: "flex",
                flexDirection: "column",
                [`&${componentCls}-left`]: {
                    boxShadow: token.boxShadowDrawerLeft
                },
                [`&${componentCls}-right`]: {
                    boxShadow: token.boxShadowDrawerRight
                },
                [`&${componentCls}-top`]: {
                    boxShadow: token.boxShadowDrawerUp
                },
                [`&${componentCls}-bottom`]: {
                    boxShadow: token.boxShadowDrawerDown
                }
            },
            "&-inline": {
                position: "absolute"
            },
            // ====================== Mask ======================
            [`${componentCls}-mask`]: {
                position: "absolute",
                inset: 0,
                zIndex: zIndexPopup,
                background: colorBgMask,
                pointerEvents: "auto"
            },
            // ==================== Content =====================
            [wrapperCls]: {
                position: "absolute",
                zIndex: zIndexPopup,
                maxWidth: "100vw",
                transition: `all ${motionDurationSlow}`,
                "&-hidden": {
                    display: "none"
                }
            },
            // Placement
            [`&-left > ${wrapperCls}`]: {
                top: 0,
                bottom: 0,
                left: {
                    _skip_check_: true,
                    value: 0
                },
                boxShadow: token.boxShadowDrawerLeft
            },
            [`&-right > ${wrapperCls}`]: {
                top: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                bottom: 0,
                boxShadow: token.boxShadowDrawerRight
            },
            [`&-top > ${wrapperCls}`]: {
                top: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerUp
            },
            [`&-bottom > ${wrapperCls}`]: {
                bottom: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerDown
            },
            [`${componentCls}-content`]: {
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                overflow: "auto",
                background: colorBgElevated,
                pointerEvents: "auto"
            },
            // Header
            [`${componentCls}-header`]: {
                display: "flex",
                flex: 0,
                alignItems: "center",
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(padding)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(paddingLG)}`,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG,
                borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                "&-title": {
                    display: "flex",
                    flex: 1,
                    alignItems: "center",
                    minWidth: 0,
                    minHeight: 0
                }
            },
            [`${componentCls}-extra`]: {
                flex: "none"
            },
            [`${componentCls}-close`]: Object.assign({
                display: "inline-flex",
                width: calc(fontSizeLG).add(paddingXS).equal(),
                height: calc(fontSizeLG).add(paddingXS).equal(),
                borderRadius: borderRadiusSM,
                justifyContent: "center",
                alignItems: "center",
                marginInlineEnd: marginXS,
                color: colorIcon,
                fontWeight: fontWeightStrong,
                fontSize: fontSizeLG,
                fontStyle: "normal",
                lineHeight: 1,
                textAlign: "center",
                textTransform: "none",
                textDecoration: "none",
                background: "transparent",
                border: 0,
                cursor: "pointer",
                transition: `all ${motionDurationMid}`,
                textRendering: "auto",
                "&:hover": {
                    color: colorIconHover,
                    backgroundColor: colorBgTextHover,
                    textDecoration: "none"
                },
                "&:active": {
                    backgroundColor: colorBgTextActive
                }
            }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)),
            [`${componentCls}-title`]: {
                flex: 1,
                margin: 0,
                fontWeight: token.fontWeightStrong,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG
            },
            // Body
            [`${componentCls}-body`]: {
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                padding: paddingLG,
                overflow: "auto",
                [`${componentCls}-body-skeleton`]: {
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center"
                }
            },
            // Footer
            [`${componentCls}-footer`]: {
                flexShrink: 0,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(footerPaddingBlock)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(footerPaddingInline)}`,
                borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
            },
            // ====================== RTL =======================
            "&-rtl": {
                direction: "rtl"
            }
        }
    };
};
const $f93b1dac0ddeb04a$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase,
        footerPaddingBlock: token.paddingXS,
        footerPaddingInline: token.padding
    });
var // ============================== Export ==============================
$f93b1dac0ddeb04a$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Drawer", (token)=>{
    const drawerToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {});
    return [
        $f93b1dac0ddeb04a$var$genDrawerStyle(drawerToken),
        (0, $663c87952542a325$export$2e2bcd8739ae039)(drawerToken)
    ];
}, $f93b1dac0ddeb04a$export$9ca1be8807fe0675);


"use client";
var $d2824be14bd3234d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $d2824be14bd3234d$var$SizeTypes = [
    "default",
    "large"
];
const $d2824be14bd3234d$var$defaultPushState = {
    distance: 180
};
const $d2824be14bd3234d$var$Drawer = (props)=>{
    var _a;
    const { rootClassName: rootClassName, width: width, height: height, size: size = "default", mask: mask = true, push: push = $d2824be14bd3234d$var$defaultPushState, open: open, afterOpenChange: afterOpenChange, onClose: onClose, prefixCls: customizePrefixCls, getContainer: customizeGetContainer, style: style, className: className, visible: // Deprecated
    visible, afterVisibleChange: afterVisibleChange, maskStyle: maskStyle, drawerStyle: drawerStyle, contentWrapperStyle: contentWrapperStyle } = props, rest = $d2824be14bd3234d$var$__rest(props, [
        "rootClassName",
        "width",
        "height",
        "size",
        "mask",
        "push",
        "open",
        "afterOpenChange",
        "onClose",
        "prefixCls",
        "getContainer",
        "style",
        "className",
        "visible",
        "afterVisibleChange",
        "maskStyle",
        "drawerStyle",
        "contentWrapperStyle"
    ]);
    const { getPopupContainer: getPopupContainer, getPrefixCls: getPrefixCls, direction: direction, drawer: drawer } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("drawer", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f93b1dac0ddeb04a$export$2e2bcd8739ae039)(prefixCls);
    const getContainer = // 有可能为 false，所以不能直接判断
    customizeGetContainer === undefined && getPopupContainer ? ()=>getPopupContainer(document.body) : customizeGetContainer;
    const drawerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
        "no-mask": !mask,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, rootClassName, hashId, cssVarCls);
    var _ref;
    // ============================ Size ============================
    const mergedWidth = $acw62.useMemo(()=>width !== null && width !== void 0 ? width : size === "large" ? 736 : 378, [
        width,
        size
    ]);
    const mergedHeight = $acw62.useMemo(()=>height !== null && height !== void 0 ? height : size === "large" ? 736 : 378, [
        height,
        size
    ]);
    // =========================== Motion ===========================
    const maskMotion = {
        motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(prefixCls, "mask-motion"),
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        motionDeadline: 500
    };
    const panelMotion = (motionPlacement)=>({
            motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(prefixCls, `panel-motion-${motionPlacement}`),
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            motionDeadline: 500
        });
    // ============================ Refs ============================
    // Select `ant-modal-content` by `panelRef`
    const panelRef = (0, $9ce1b741d917b083$export$94ab53417567be34)();
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $8552b358f1d5b0a4$export$3e7906d4075187a4)("Drawer", rest.zIndex);
    // =========================== Render ===========================
    const { classNames: propClassNames = {}, styles: propStyles = {} } = rest;
    const { classNames: contextClassNames = {}, styles: contextStyles = {} } = drawer || {};
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $894cbe2fb0245b19$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $acw62.createElement((0, $2adf0f811816efa6$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $614f9c0d6cbb150b$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls,
        onClose: onClose,
        maskMotion: maskMotion,
        motion: panelMotion
    }, rest, {
        classNames: {
            mask: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(propClassNames.mask, contextClassNames.mask),
            content: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(propClassNames.content, contextClassNames.content),
            wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(propClassNames.wrapper, contextClassNames.wrapper)
        },
        styles: {
            mask: Object.assign(Object.assign(Object.assign({}, propStyles.mask), maskStyle), contextStyles.mask),
            content: Object.assign(Object.assign(Object.assign({}, propStyles.content), drawerStyle), contextStyles.content),
            wrapper: Object.assign(Object.assign(Object.assign({}, propStyles.wrapper), contentWrapperStyle), contextStyles.wrapper)
        },
        open: open !== null && open !== void 0 ? open : visible,
        mask: mask,
        push: push,
        width: mergedWidth,
        height: mergedHeight,
        style: Object.assign(Object.assign({}, drawer === null || drawer === void 0 ? void 0 : drawer.style), style),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(drawer === null || drawer === void 0 ? void 0 : drawer.className, className),
        rootClassName: drawerClassName,
        getContainer: getContainer,
        afterOpenChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
        panelRef: panelRef,
        zIndex: zIndex
    }), /*#__PURE__*/ $acw62.createElement((0, $0279d43d1c26ee11$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls
    }, rest, {
        onClose: onClose
    }))))));
};
/** @private Internal Component. Do not use in your production. */ const $d2824be14bd3234d$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, placement: placement = "right" } = props, restProps = $d2824be14bd3234d$var$__rest(props, [
        "prefixCls",
        "style",
        "className",
        "placement"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("drawer", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $f93b1dac0ddeb04a$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-pure`, `${prefixCls}-${placement}`, hashId, cssVarCls, className);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: cls,
        style: style
    }, /*#__PURE__*/ $acw62.createElement((0, $0279d43d1c26ee11$export$2e2bcd8739ae039), Object.assign({
        prefixCls: prefixCls
    }, restProps))));
};
$d2824be14bd3234d$var$Drawer._InternalPanelDoNotUseOrYouWillBeFired = $d2824be14bd3234d$var$PurePanel;
var $d2824be14bd3234d$export$2e2bcd8739ae039 = $d2824be14bd3234d$var$Drawer;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




parcelRequire("acw62");
const $c92d6609230c449a$var$PageLoadingMessage = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "pageLoadingBackground",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
            children: "Loading..."
        })
    });
};
var $c92d6609230c449a$export$2e2bcd8739ae039 = $c92d6609230c449a$var$PageLoadingMessage;




const $dc39e8dd1c90619b$var$ProblemDescription = ({ inDrawer: inDrawer = false, isAdmin: isAdmin })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c92d6609230c449a$export$2e2bcd8739ae039), {});
    const { problem: problem, setProblem: setProblem } = problemContext;
    const handleOpenProblem = ()=>{
        if (problem?.problem_status === "not started") setProblem((prev)=>{
            if (prev) return {
                ...prev,
                problem_status: "in-progress"
            };
            return prev;
        });
        if (problem?.problem_status === "completed") {
            navigate(`/problems/${problem?.id}/submission`);
            return;
        } else navigate(`/problems/${problem?.id}`);
    };
    (0, $acw62.useEffect)(()=>{
        if (problem?.adminOnly && !isAdmin) navigate("/problems");
    }, [
        problem
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mainContainer problemDescriptionContainer",
        onCopy: ()=>(0, $cfadb87391ca5e26$export$227fec498bd204c4)(inDrawer ? "problem description drawer" : "problem description page"),
        children: [
            !inDrawer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                theme: {
                    algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    size: "large",
                    className: "backToProblemsButton",
                    onClick: ()=>navigate("/problems"),
                    children: "< Back to Problems"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "titleContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: `Problem ${problem?.problem_number || 1} - ${problem?.title}`
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "descriptionContainer",
                dangerouslySetInnerHTML: {
                    __html: problem?.description || "Loading..."
                }
            }),
            !inDrawer && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "buttonContainer",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                    className: "startButton",
                    size: "large",
                    onClick: handleOpenProblem,
                    children: [
                        problem?.problem_status === "not started" && "Start Problem",
                        problem?.problem_status === "in-progress" && "Resume Problem",
                        problem?.problem_status === "completed" && "View Submission"
                    ]
                })
            })
        ]
    });
};
var $dc39e8dd1c90619b$export$2e2bcd8739ae039 = $dc39e8dd1c90619b$var$ProblemDescription;




const $e1cf63d932554ae4$var$STARTING_DRAWER_HEIGHT = Math.round(window.innerHeight * 0.5);
let $e1cf63d932554ae4$var$DRAWER_MIN_HEIGHT = Math.round(window.innerHeight * 0.25);
let $e1cf63d932554ae4$var$DRAWER_MAX_HEIGHT = Math.round(window.innerHeight * 0.9);
const $e1cf63d932554ae4$var$RESIZE_HANDLE_HEIGHT = 26;
const $e1cf63d932554ae4$var$ProblemDescriptionDrawer = ({ leftColumnRef: leftColumnRef, rightColumnRef: rightColumnRef, isAdmin: isAdmin })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [displayHeightAdjustBar, setDisplayHeightAdjustBar] = (0, $acw62.useState)(false);
    const [drawerHeight, setDrawerHeight] = (0, $acw62.useState)($e1cf63d932554ae4$var$STARTING_DRAWER_HEIGHT);
    const [offsetHeight, setOffsetHeight] = (0, $acw62.useState)(0);
    const [isResizing, setIsResizing] = (0, $acw62.useState)(false);
    const [leftPosition, setLeftPosition] = (0, $acw62.useState)(0);
    const [rightPosition, setRightPosition] = (0, $acw62.useState)(0);
    const isResizingRef = (0, $acw62.useRef)(isResizing);
    const updateWidths = ()=>{
        if (leftColumnRef.current) setLeftPosition(leftColumnRef.current.offsetWidth);
        if (rightColumnRef.current) {
            const rightRect = rightColumnRef.current.getBoundingClientRect();
            setRightPosition(document.body.offsetWidth - rightRect.left);
        }
    };
    const showDrawer = ()=>{
        setOpen(true);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("open_problem_description", {}, true);
    };
    const onClose = ()=>{
        const drawer = document.querySelector(".ant-drawer-body");
        drawer?.scrollTo(0, 0);
        setDisplayHeightAdjustBar(false);
        setOpen(false);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("close_problem_description", {}, true);
    };
    const startResizing = (e)=>{
        e.preventDefault();
        setIsResizing(true);
        isResizingRef.current = true;
        setOffsetHeight(e.clientY - drawerHeight);
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", stopResizing);
    };
    const stopResizing = ()=>{
        setIsResizing(false);
        isResizingRef.current = false;
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", stopResizing);
    };
    const handleMouseMove = (e)=>{
        if (isResizingRef.current) updateDrawerHeight(e.clientY - offsetHeight);
    };
    const updateDrawerHeight = (newHeight)=>{
        if (newHeight < $e1cf63d932554ae4$var$DRAWER_MIN_HEIGHT) {
            setDrawerHeight($e1cf63d932554ae4$var$DRAWER_MIN_HEIGHT);
            return;
        } else if (newHeight > $e1cf63d932554ae4$var$DRAWER_MAX_HEIGHT) {
            setDrawerHeight($e1cf63d932554ae4$var$DRAWER_MAX_HEIGHT);
            return;
        }
        setDrawerHeight(Math.round(newHeight));
    };
    (0, $acw62.useEffect)(()=>{
        const wrapper = document.querySelector(".ant-drawer-top > .ant-drawer-content-wrapper");
        const mask = document.querySelector(".ant-drawer-mask");
        if (!wrapper) return;
        if (!mask) return;
        if (isResizing) {
            wrapper.classList.add("no-transition");
            mask.classList.add("no-transition");
        } else {
            wrapper.classList.remove("no-transition");
            mask.classList.remove("no-transition");
        }
        return ()=>{
            wrapper.classList.remove("no-transition");
            mask.classList.remove("no-transition");
        };
    }, [
        isResizing
    ]);
    (0, $acw62.useEffect)(()=>{
        const updateDrawerUponResize = ()=>{
            $e1cf63d932554ae4$var$DRAWER_MIN_HEIGHT = Math.round(window.innerHeight * 0.25);
            $e1cf63d932554ae4$var$DRAWER_MAX_HEIGHT = Math.round(window.innerHeight * 0.9);
            updateDrawerHeight(drawerHeight);
        };
        window.addEventListener("resize", updateDrawerUponResize);
        return ()=>{
            window.removeEventListener("resize", updateDrawerUponResize);
        };
    }, [
        drawerHeight
    ]);
    (0, $acw62.useEffect)(()=>{
        const mask = document.querySelector(".ant-drawer-mask");
        if (mask && open && !mask.getAttribute("title")) mask.setAttribute("title", "Click out here to close problem description");
    }, [
        displayHeightAdjustBar,
        open
    ]);
    (0, $acw62.useEffect)(()=>{
        const leftObserver = new ResizeObserver(updateWidths);
        const rightObserver = new ResizeObserver(updateWidths);
        if (leftColumnRef.current) leftObserver.observe(leftColumnRef.current);
        if (rightColumnRef.current) rightObserver.observe(rightColumnRef.current);
        return ()=>{
            if (leftColumnRef.current) leftObserver.disconnect();
            if (rightColumnRef.current) rightObserver.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "drawerOuterContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d2824be14bd3234d$export$2e2bcd8739ae039), {
                placement: "top",
                open: open,
                onClose: onClose,
                height: drawerHeight,
                style: {
                    maxHeight: `${$e1cf63d932554ae4$var$DRAWER_MAX_HEIGHT}px`,
                    minHeight: `${$e1cf63d932554ae4$var$DRAWER_MIN_HEIGHT}px`
                },
                styles: {
                    wrapper: {
                        left: leftPosition,
                        right: rightPosition
                    }
                },
                classNames: {
                    mask: "",
                    content: "problemDescriptionDrawerContent",
                    body: "problemDescriptionDrawerBody"
                },
                className: "problemDescriptionDrawer",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc39e8dd1c90619b$export$2e2bcd8739ae039), {
                        inDrawer: true,
                        isAdmin: isAdmin
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "resizeBar problemDescriptionResizeBar",
                        onMouseDown: startResizing,
                        title: "Drag to resize"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                className: "viewProblemDescButton",
                onClick: showDrawer,
                children: "View Problem Description"
            })
        ]
    });
};
var $e1cf63d932554ae4$export$2e2bcd8739ae039 = $e1cf63d932554ae4$var$ProblemDescriptionDrawer;







var $5a197630e9446689$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $5a197630e9446689$exports = factory();
})($5a197630e9446689$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $36808251bfa881a8$var$ExclamationCircleTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1096 0 48 48 0 10-96 0z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "exclamation-circle",
    "theme": "twotone"
};
var $36808251bfa881a8$export$2e2bcd8739ae039 = $36808251bfa881a8$var$ExclamationCircleTwoTone;



var $e3880c1309882ac1$var$ExclamationCircleTwoTone = function ExclamationCircleTwoTone(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $36808251bfa881a8$export$2e2bcd8739ae039)
    }));
};
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIGZpbGw9IiMxNjc3ZmYiIC8+PHBhdGggZD0iTTUxMiAxNDBjLTIwNS40IDAtMzcyIDE2Ni42LTM3MiAzNzJzMTY2LjYgMzcyIDM3MiAzNzIgMzcyLTE2Ni42IDM3Mi0zNzItMTY2LjYtMzcyLTM3Mi0zNzJ6bS0zMiAxNTZjMC00LjQgMy42LTggOC04aDQ4YzQuNCAwIDggMy42IDggOHYyNzJjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjI5NnptMzIgNDQwYTQ4LjAxIDQ4LjAxIDAgMDEwLTk2IDQ4LjAxIDQ4LjAxIDAgMDEwIDk2eiIgZmlsbD0iI2U2ZjRmZiIgLz48cGF0aCBkPSJNNDg4IDU3Nmg0OGM0LjQgMCA4LTMuNiA4LThWMjk2YzAtNC40LTMuNi04LTgtOGgtNDhjLTQuNCAwLTggMy42LTggOHYyNzJjMCA0LjQgMy42IDggOCA4em0tMjQgMTEyYTQ4IDQ4IDAgMTA5NiAwIDQ4IDQ4IDAgMTAtOTYgMHoiIGZpbGw9IiMxNjc3ZmYiIC8+PC9zdmc+) */ var $e3880c1309882ac1$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($e3880c1309882ac1$var$ExclamationCircleTwoTone);
var $e3880c1309882ac1$export$2e2bcd8739ae039 = $e3880c1309882ac1$var$RefIcon;






const { confirm: $1d6cfe59b3aaeeb7$var$confirm } = (0, $e47cb76d58815cb1$export$2e2bcd8739ae039);
const $1d6cfe59b3aaeeb7$var$EditorOverlayContainer = ({ runProgram: runProgram, setRunProgram: setRunProgram, setIsImageGalleryOpen: setIsImageGalleryOpen, leftColumnRef: leftColumnRef, rightColumnRef: rightColumnRef, isAdmin: isAdmin, codePreview: codePreview, consoleText: consoleText, editorRef: editorRef, openChatbotButtonRef: openChatbotButtonRef, openModuleViewerButtonRef: openModuleViewerButtonRef, generatedPlots: generatedPlots, saveIndicatorMessageRef: saveIndicatorMessageRef, setEditorStatus: setEditorStatus })=>{
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    const [localRunProgram, setLocalRunProgram] = (0, $acw62.useState)(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = (0, $acw62.useState)(false);
    const [confidence, setConfidence] = (0, $acw62.useState)(50);
    const [editorImageURL, setEditorImageURL] = (0, $acw62.useState)("");
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c92d6609230c449a$export$2e2bcd8739ae039), {});
    const { problem: problem, setProblem: setProblem } = problemContext;
    const triggerSubmitProblem = async ()=>{
        await (0, $5184a13b2b4cae17$export$95b8ceda2c9b7ad6)();
        if (editorRef.current) editorRef.current.style.pointerEvents = "none";
        setIsSubmitting(true);
        const editorImageURL = await captureEditorSnapshot();
        setEditorImageURL(editorImageURL);
        setLocalRunProgram(true);
    };
    const submitProblem = async ()=>{
        const editor_state = (0, $afd930b1a77e3a58$export$62ca784e6947e746)();
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/problems/submit-problem", {
                problem_id: problem?.id,
                full_code: codePreview,
                console_output: consoleText,
                image_data_url: editorImageURL,
                confidence: confidence,
                editor_state: editor_state
            }, {
                withCredentials: true
            });
            if (!res.data.success) {
                console.log("Error submitting problem.");
                throw new Error("Error submitting problem.");
            }
            setProblem((prevProblem)=>{
                if (prevProblem) return {
                    ...prevProblem,
                    problem_status: "completed"
                };
                return prevProblem;
            });
            const submissionData = {
                ...res.data.problem_submission_data,
                "date_started": new Date(res.data.problem_submission_data.date_started).toLocaleString(),
                "date_submission_started": new Date(res.data.problem_submission_data.date_submission_started).toLocaleString(),
                "date_completed": new Date(res.data.problem_submission_data.date_completed).toLocaleString()
            };
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("submit_problem", submissionData, true);
            if (generatedPlots.length > 0) {
                const uploadPromises = generatedPlots.map(async (plot, index)=>{
                    const blob = await (0, $98cb8c383600531f$export$14e9cfd4a872cc1e)(plot);
                    const base64 = await (0, $98cb8c383600531f$export$47a328b4cabd57cc)(blob);
                    return await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/images/save-generated-submission-image", {
                        image: base64,
                        imageTitle: `Generated Plot ${index + 1}`,
                        problem_submission_id: submissionData.problem_submission_id
                    }, {
                        withCredentials: true
                    });
                });
                await Promise.all(uploadPromises);
            }
            if (editorRef.current) editorRef.current.style.pointerEvents = "auto";
            setEditorStatus("");
            navigate(`/problems/${problem?.id}/submission`);
        } catch (e) {
            console.error(e.response.data.message);
        }
        setIsSubmitting(false);
    };
    const confirmSubmitProblem = ()=>{
        setIsConfirmModalOpen(true);
    };
    const updateConfidence = (value)=>{
        setConfidence(value || 0);
    };
    const captureEditorSnapshot = async ()=>{
        if (editorRef.current) {
            const dpr = window.devicePixelRatio || 5;
            openChatbotButtonRef.current?.style.setProperty("z-index", "-1");
            openModuleViewerButtonRef.current?.style.setProperty("z-index", "-1");
            saveIndicatorMessageRef.current?.style.setProperty("z-index", "-1");
            (0, $14e68cbe3c2b3085$export$5f1aefa39776ca10).unselectAll();
            await new Promise((resolve)=>requestAnimationFrame(resolve));
            try {
                const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($5a197630e9446689$exports)))(document.getElementById("root"), {
                    useCORS: true,
                    scale: dpr,
                    foreignObjectRendering: true
                });
                openChatbotButtonRef.current?.style.setProperty("z-index", "auto");
                openModuleViewerButtonRef.current?.style.setProperty("z-index", "auto");
                saveIndicatorMessageRef.current?.style.setProperty("z-index", "auto");
                setEditorStatus("submitting");
                const rect = editorRef.current.getBoundingClientRect();
                const croppedCanvas = document.createElement("canvas");
                croppedCanvas.width = rect.width * dpr;
                croppedCanvas.height = rect.height * dpr;
                const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const ctx = croppedCanvas.getContext("2d");
                // Draw the cropped image onto the new canvas
                ctx?.drawImage(canvas, (rect.left + scrollLeft) * dpr, (rect.top + scrollTop) * dpr, rect.width * dpr, rect.height * dpr, 0, 0, rect.width * dpr, rect.height * dpr);
                const imageURL = croppedCanvas.toDataURL("image/png");
                return imageURL;
            } catch (e) {
                console.error("Error capturing image:", e);
                openChatbotButtonRef.current?.style.setProperty("visibility", "visible");
                openModuleViewerButtonRef.current?.style.setProperty("visibility", "visible");
            }
        }
        return "";
    };
    (0, $acw62.useEffect)(()=>{
        if (localRunProgram) setRunProgram(true);
        else if (isSubmitting && !localRunProgram) submitProblem();
    }, [
        localRunProgram
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!runProgram) setLocalRunProgram(false);
    }, [
        runProgram
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "editorOverlayContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c24bb3319861fe36$export$b48985bba8f530f5).NoDrag, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "overlayCenteringContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                            className: "editorProblemTitle",
                            children: problem ? `Problem ${problem.problem_number} - ${problem.title}` : "Loading..."
                        }),
                        problem && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cf63d932554ae4$export$2e2bcd8739ae039), {
                            leftColumnRef: leftColumnRef,
                            rightColumnRef: rightColumnRef,
                            isAdmin: isAdmin
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5184a13b2b4cae17$export$2e2bcd8739ae039), {
                            runProgram: runProgram,
                            setRunProgram: setRunProgram,
                            setIsImageGalleryOpen: setIsImageGalleryOpen,
                            problem_id: problem?.id || 0,
                            consoleText: consoleText,
                            codePreview: codePreview
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                    theme: {
                        components: {
                            Button: {
                                defaultBg: "#00c800",
                                linkHoverBg: "green",
                                defaultColor: "white",
                                borderColorDisabled: "white",
                                colorTextDisabled: "white",
                                colorBgContainerDisabled: "lightgreen"
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        loading: isSubmitting,
                        className: "submitProblemBtn",
                        onClick: confirmSubmitProblem,
                        title: problem?.problem_status === "completed" ? "Problem submitted" : "Click to submit problem",
                        disabled: isSubmitting || problem?.problem_status === "completed",
                        children: problem?.problem_status === "completed" ? "Submitted" : "Submit Problem"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
                    open: isConfirmModalOpen,
                    width: "fit-content",
                    okText: "Submit",
                    onOk: ()=>{
                        setIsConfirmModalOpen(false);
                        triggerSubmitProblem();
                    },
                    okButtonProps: {
                        title: "Confirm submission"
                    },
                    onCancel: ()=>{
                        setIsConfirmModalOpen(false);
                    },
                    cancelButtonProps: {
                        title: "Cancel submission"
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "confirmProblemModalContent",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "confirmModalWarningContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3880c1309882ac1$export$2e2bcd8739ae039), {
                                        className: "solidExclamationSymbolConfirm",
                                        twoToneColor: "#faad14"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "confirmModalContent",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: "Are you sure you want to submit?"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "You will not be able to edit this problem after submission."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2dcdaeaf17c3bbb2$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ecbbbb3ffda2d77$export$2e2bcd8739ae039), {
                                    offset: 2,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "confidenceContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "How confident are you in your solution (0 - 100)"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2dcdaeaf17c3bbb2$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ecbbbb3ffda2d77$export$2e2bcd8739ae039), {
                                                        offset: 2,
                                                        span: 16,
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e379b7d04954998$export$2e2bcd8739ae039), {
                                                            min: 0,
                                                            max: 100,
                                                            step: 5,
                                                            value: confidence,
                                                            onChange: updateConfidence
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ecbbbb3ffda2d77$export$2e2bcd8739ae039), {
                                                        offset: 1,
                                                        span: 4,
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed9156e2babf3c6$export$2e2bcd8739ae039), {
                                                            value: confidence,
                                                            onChange: updateConfidence,
                                                            step: 5,
                                                            min: 0,
                                                            max: 100
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $1d6cfe59b3aaeeb7$export$2e2bcd8739ae039 = $1d6cfe59b3aaeeb7$var$EditorOverlayContainer;




var $acw62 = parcelRequire("acw62");




var $1fddf034d74735a2$exports = {};
/// <reference lib="WebWorker"/>
var $1fddf034d74735a2$var$_self = typeof window !== "undefined" ? window // if in browser
 : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $1fddf034d74735a2$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case "Object":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case "Array":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return "none";
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, "gi"), "");
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add("language-" + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === "undefined") return null;
                if ("currentScript" in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName("script");
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = "no-" + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === "Object" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === "Array" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run("before-all-elements-highlight", env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre") _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
            }
            _.hooks.run("before-sanity-check", env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) parent.setAttribute("tabindex", "0");
            if (!env.code) {
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run("before-tokenize", env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run("after-tokenize", env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == "string") return o;
        if (Array.isArray(o)) {
            var s = "";
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + "," + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + "," + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($1fddf034d74735a2$var$_self);
if (0, $1fddf034d74735a2$exports) $1fddf034d74735a2$exports = $1fddf034d74735a2$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== "undefined") $parcel$global.Prism = $1fddf034d74735a2$var$Prism;
 // some additional documentation/types
 /**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */  /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */  /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */  /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ 


Prism.languages.python = {
    "comment": {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            "interpolation": {
                // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            "string": /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    "string": {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    "function": {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    "decorator": {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            "punctuation": /\./
        }
    },
    "keyword": /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    "builtin": /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    "boolean": /\b(?:False|None|True)\b/,
    "number": /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    "operator": /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    "punctuation": /[{}[\];(),.:]/
};
Prism.languages.python["string-interpolation"].inside["interpolation"].inside.rest = Prism.languages.python;
Prism.languages.py = Prism.languages.python;



(function() {
    if (typeof Prism === "undefined" || typeof document === "undefined") return;
    /**
	 * Plugin name which is used as a class name for <pre> which is activating the plugin
	 *
	 * @type {string}
	 */ var PLUGIN_NAME = "line-numbers";
    /**
	 * Regular expression used for determining line breaks
	 *
	 * @type {RegExp}
	 */ var NEW_LINE_EXP = /\n(?!$)/g;
    /**
	 * Global exports
	 */ var config = Prism.plugins.lineNumbers = {
        /**
		 * Get node for provided line number
		 *
		 * @param {Element} element pre element
		 * @param {number} number line number
		 * @returns {Element|undefined}
		 */ getLine: function(element, number) {
            if (element.tagName !== "PRE" || !element.classList.contains(PLUGIN_NAME)) return;
            var lineNumberRows = element.querySelector(".line-numbers-rows");
            if (!lineNumberRows) return;
            var lineNumberStart = parseInt(element.getAttribute("data-start"), 10) || 1;
            var lineNumberEnd = lineNumberStart + (lineNumberRows.children.length - 1);
            if (number < lineNumberStart) number = lineNumberStart;
            if (number > lineNumberEnd) number = lineNumberEnd;
            var lineIndex = number - lineNumberStart;
            return lineNumberRows.children[lineIndex];
        },
        /**
		 * Resizes the line numbers of the given element.
		 *
		 * This function will not add line numbers. It will only resize existing ones.
		 *
		 * @param {HTMLElement} element A `<pre>` element with line numbers.
		 * @returns {void}
		 */ resize: function(element) {
            resizeElements([
                element
            ]);
        },
        /**
		 * Whether the plugin can assume that the units font sizes and margins are not depended on the size of
		 * the current viewport.
		 *
		 * Setting this to `true` will allow the plugin to do certain optimizations for better performance.
		 *
		 * Set this to `false` if you use any of the following CSS units: `vh`, `vw`, `vmin`, `vmax`.
		 *
		 * @type {boolean}
		 */ assumeViewportIndependence: true
    };
    /**
	 * Resizes the given elements.
	 *
	 * @param {HTMLElement[]} elements
	 */ function resizeElements(elements) {
        elements = elements.filter(function(e) {
            var codeStyles = getStyles(e);
            var whiteSpace = codeStyles["white-space"];
            return whiteSpace === "pre-wrap" || whiteSpace === "pre-line";
        });
        if (elements.length == 0) return;
        var infos = elements.map(function(element) {
            var codeElement = element.querySelector("code");
            var lineNumbersWrapper = element.querySelector(".line-numbers-rows");
            if (!codeElement || !lineNumbersWrapper) return undefined;
            /** @type {HTMLElement} */ var lineNumberSizer = element.querySelector(".line-numbers-sizer");
            var codeLines = codeElement.textContent.split(NEW_LINE_EXP);
            if (!lineNumberSizer) {
                lineNumberSizer = document.createElement("span");
                lineNumberSizer.className = "line-numbers-sizer";
                codeElement.appendChild(lineNumberSizer);
            }
            lineNumberSizer.innerHTML = "0";
            lineNumberSizer.style.display = "block";
            var oneLinerHeight = lineNumberSizer.getBoundingClientRect().height;
            lineNumberSizer.innerHTML = "";
            return {
                element: element,
                lines: codeLines,
                lineHeights: [],
                oneLinerHeight: oneLinerHeight,
                sizer: lineNumberSizer
            };
        }).filter(Boolean);
        infos.forEach(function(info) {
            var lineNumberSizer = info.sizer;
            var lines = info.lines;
            var lineHeights = info.lineHeights;
            var oneLinerHeight = info.oneLinerHeight;
            lineHeights[lines.length - 1] = undefined;
            lines.forEach(function(line, index) {
                if (line && line.length > 1) {
                    var e = lineNumberSizer.appendChild(document.createElement("span"));
                    e.style.display = "block";
                    e.textContent = line;
                } else lineHeights[index] = oneLinerHeight;
            });
        });
        infos.forEach(function(info) {
            var lineNumberSizer = info.sizer;
            var lineHeights = info.lineHeights;
            var childIndex = 0;
            for(var i = 0; i < lineHeights.length; i++)if (lineHeights[i] === undefined) lineHeights[i] = lineNumberSizer.children[childIndex++].getBoundingClientRect().height;
        });
        infos.forEach(function(info) {
            var lineNumberSizer = info.sizer;
            var wrapper = info.element.querySelector(".line-numbers-rows");
            lineNumberSizer.style.display = "none";
            lineNumberSizer.innerHTML = "";
            info.lineHeights.forEach(function(height, lineNumber) {
                wrapper.children[lineNumber].style.height = height + "px";
            });
        });
    }
    /**
	 * Returns style declarations for the element
	 *
	 * @param {Element} element
	 */ function getStyles(element) {
        if (!element) return null;
        return window.getComputedStyle ? getComputedStyle(element) : element.currentStyle || null;
    }
    var lastWidth = undefined;
    window.addEventListener("resize", function() {
        if (config.assumeViewportIndependence && lastWidth === window.innerWidth) return;
        lastWidth = window.innerWidth;
        resizeElements(Array.prototype.slice.call(document.querySelectorAll("pre." + PLUGIN_NAME)));
    });
    Prism.hooks.add("complete", function(env) {
        if (!env.code) return;
        var code = /** @type {Element} */ env.element;
        var pre = /** @type {HTMLElement} */ code.parentNode;
        // works only for <code> wrapped inside <pre> (not inline)
        if (!pre || !/pre/i.test(pre.nodeName)) return;
        // Abort if line numbers already exists
        if (code.querySelector(".line-numbers-rows")) return;
        // only add line numbers if <code> or one of its ancestors has the `line-numbers` class
        if (!Prism.util.isActive(code, PLUGIN_NAME)) return;
        // Remove the class 'line-numbers' from the <code>
        code.classList.remove(PLUGIN_NAME);
        // Add the class 'line-numbers' to the <pre>
        pre.classList.add(PLUGIN_NAME);
        var match = env.code.match(NEW_LINE_EXP);
        var linesNum = match ? match.length + 1 : 1;
        var lineNumbersWrapper;
        var lines = new Array(linesNum + 1).join("<span></span>");
        lineNumbersWrapper = document.createElement("span");
        lineNumbersWrapper.setAttribute("aria-hidden", "true");
        lineNumbersWrapper.className = "line-numbers-rows";
        lineNumbersWrapper.innerHTML = lines;
        if (pre.hasAttribute("data-start")) pre.style.counterReset = "linenumber " + (parseInt(pre.getAttribute("data-start"), 10) - 1);
        env.element.appendChild(lineNumbersWrapper);
        resizeElements([
            pre
        ]);
        Prism.hooks.run("line-numbers", env);
    });
    Prism.hooks.add("line-numbers", function(env) {
        env.plugins = env.plugins || {};
        env.plugins.lineNumbers = true;
    });
})();



(function() {
    if (typeof Prism === "undefined" || typeof document === "undefined") return;
    var callbacks = [];
    var map = {};
    var noop = function() {};
    Prism.plugins.toolbar = {};
    /**
	 * @typedef ButtonOptions
	 * @property {string} text The text displayed.
	 * @property {string} [url] The URL of the link which will be created.
	 * @property {Function} [onClick] The event listener for the `click` event of the created button.
	 * @property {string} [className] The class attribute to include with element.
	 */ /**
	 * Register a button callback with the toolbar.
	 *
	 * @param {string} key
	 * @param {ButtonOptions|Function} opts
	 */ var registerButton = Prism.plugins.toolbar.registerButton = function(key, opts) {
        var callback;
        if (typeof opts === "function") callback = opts;
        else callback = function(env) {
            var element;
            if (typeof opts.onClick === "function") {
                element = document.createElement("button");
                element.type = "button";
                element.addEventListener("click", function() {
                    opts.onClick.call(this, env);
                });
            } else if (typeof opts.url === "string") {
                element = document.createElement("a");
                element.href = opts.url;
            } else element = document.createElement("span");
            if (opts.className) element.classList.add(opts.className);
            element.textContent = opts.text;
            return element;
        };
        if (key in map) {
            console.warn('There is a button with the key "' + key + '" registered already.');
            return;
        }
        callbacks.push(map[key] = callback);
    };
    /**
	 * Returns the callback order of the given element.
	 *
	 * @param {HTMLElement} element
	 * @returns {string[] | undefined}
	 */ function getOrder(element) {
        while(element){
            var order = element.getAttribute("data-toolbar-order");
            if (order != null) {
                order = order.trim();
                if (order.length) return order.split(/\s*,\s*/g);
                else return [];
            }
            element = element.parentElement;
        }
    }
    /**
	 * Post-highlight Prism hook callback.
	 *
	 * @param env
	 */ var hook = Prism.plugins.toolbar.hook = function(env) {
        // Check if inline or actual code block (credit to line-numbers plugin)
        var pre = env.element.parentNode;
        if (!pre || !/pre/i.test(pre.nodeName)) return;
        // Autoloader rehighlights, so only do this once.
        if (pre.parentNode.classList.contains("code-toolbar")) return;
        // Create wrapper for <pre> to prevent scrolling toolbar with content
        var wrapper = document.createElement("div");
        wrapper.classList.add("code-toolbar");
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);
        // Setup the toolbar
        var toolbar = document.createElement("div");
        toolbar.classList.add("toolbar");
        // order callbacks
        var elementCallbacks = callbacks;
        var order = getOrder(env.element);
        if (order) elementCallbacks = order.map(function(key) {
            return map[key] || noop;
        });
        elementCallbacks.forEach(function(callback) {
            var element = callback(env);
            if (!element) return;
            var item = document.createElement("div");
            item.classList.add("toolbar-item");
            item.appendChild(element);
            toolbar.appendChild(item);
        });
        // Add our toolbar to the currently created wrapper of <pre> tag
        wrapper.appendChild(toolbar);
    };
    registerButton("label", function(env) {
        var pre = env.element.parentNode;
        if (!pre || !/pre/i.test(pre.nodeName)) return;
        if (!pre.hasAttribute("data-label")) return;
        var element;
        var template;
        var text = pre.getAttribute("data-label");
        try {
            // Any normal text will blow up this selector.
            template = document.querySelector("template#" + text);
        } catch (e) {}
        if (template) element = template.content;
        else {
            if (pre.hasAttribute("data-url")) {
                element = document.createElement("a");
                element.href = pre.getAttribute("data-url");
            } else element = document.createElement("span");
            element.textContent = text;
        }
        return element;
    });
    /**
	 * Register the toolbar with Prism.
	 */ Prism.hooks.add("complete", hook);
})();


(function() {
    if (typeof Prism === "undefined" || typeof document === "undefined") return;
    if (!Prism.plugins.toolbar) {
        console.warn("Show Languages plugin loaded before Toolbar plugin.");
        return;
    }
    /* eslint-disable */ // The languages map is built automatically with gulp
    var Languages = /*languages_placeholder[*/ {
        "none": "Plain text",
        "plain": "Plain text",
        "plaintext": "Plain text",
        "text": "Plain text",
        "txt": "Plain text",
        "html": "HTML",
        "xml": "XML",
        "svg": "SVG",
        "mathml": "MathML",
        "ssml": "SSML",
        "rss": "RSS",
        "css": "CSS",
        "clike": "C-like",
        "js": "JavaScript",
        "abap": "ABAP",
        "abnf": "ABNF",
        "al": "AL",
        "antlr4": "ANTLR4",
        "g4": "ANTLR4",
        "apacheconf": "Apache Configuration",
        "apl": "APL",
        "aql": "AQL",
        "ino": "Arduino",
        "arff": "ARFF",
        "armasm": "ARM Assembly",
        "arm-asm": "ARM Assembly",
        "art": "Arturo",
        "asciidoc": "AsciiDoc",
        "adoc": "AsciiDoc",
        "aspnet": "ASP.NET (C#)",
        "asm6502": "6502 Assembly",
        "asmatmel": "Atmel AVR Assembly",
        "autohotkey": "AutoHotkey",
        "autoit": "AutoIt",
        "avisynth": "AviSynth",
        "avs": "AviSynth",
        "avro-idl": "Avro IDL",
        "avdl": "Avro IDL",
        "awk": "AWK",
        "gawk": "GAWK",
        "sh": "Shell",
        "basic": "BASIC",
        "bbcode": "BBcode",
        "bbj": "BBj",
        "bnf": "BNF",
        "rbnf": "RBNF",
        "bqn": "BQN",
        "bsl": "BSL (1C:Enterprise)",
        "oscript": "OneScript",
        "csharp": "C#",
        "cs": "C#",
        "dotnet": "C#",
        "cpp": "C++",
        "cfscript": "CFScript",
        "cfc": "CFScript",
        "cil": "CIL",
        "cilkc": "Cilk/C",
        "cilk-c": "Cilk/C",
        "cilkcpp": "Cilk/C++",
        "cilk-cpp": "Cilk/C++",
        "cilk": "Cilk/C++",
        "cmake": "CMake",
        "cobol": "COBOL",
        "coffee": "CoffeeScript",
        "conc": "Concurnas",
        "csp": "Content-Security-Policy",
        "css-extras": "CSS Extras",
        "csv": "CSV",
        "cue": "CUE",
        "dataweave": "DataWeave",
        "dax": "DAX",
        "django": "Django/Jinja2",
        "jinja2": "Django/Jinja2",
        "dns-zone-file": "DNS zone file",
        "dns-zone": "DNS zone file",
        "dockerfile": "Docker",
        "dot": "DOT (Graphviz)",
        "gv": "DOT (Graphviz)",
        "ebnf": "EBNF",
        "editorconfig": "EditorConfig",
        "ejs": "EJS",
        "etlua": "Embedded Lua templating",
        "erb": "ERB",
        "excel-formula": "Excel Formula",
        "xlsx": "Excel Formula",
        "xls": "Excel Formula",
        "fsharp": "F#",
        "firestore-security-rules": "Firestore security rules",
        "ftl": "FreeMarker Template Language",
        "gml": "GameMaker Language",
        "gamemakerlanguage": "GameMaker Language",
        "gap": "GAP (CAS)",
        "gcode": "G-code",
        "gdscript": "GDScript",
        "gedcom": "GEDCOM",
        "gettext": "gettext",
        "po": "gettext",
        "glsl": "GLSL",
        "gn": "GN",
        "gni": "GN",
        "linker-script": "GNU Linker Script",
        "ld": "GNU Linker Script",
        "go-module": "Go module",
        "go-mod": "Go module",
        "graphql": "GraphQL",
        "hbs": "Handlebars",
        "hs": "Haskell",
        "hcl": "HCL",
        "hlsl": "HLSL",
        "http": "HTTP",
        "hpkp": "HTTP Public-Key-Pins",
        "hsts": "HTTP Strict-Transport-Security",
        "ichigojam": "IchigoJam",
        "icu-message-format": "ICU Message Format",
        "idr": "Idris",
        "ignore": ".ignore",
        "gitignore": ".gitignore",
        "hgignore": ".hgignore",
        "npmignore": ".npmignore",
        "inform7": "Inform 7",
        "javadoc": "JavaDoc",
        "javadoclike": "JavaDoc-like",
        "javastacktrace": "Java stack trace",
        "jq": "JQ",
        "jsdoc": "JSDoc",
        "js-extras": "JS Extras",
        "json": "JSON",
        "webmanifest": "Web App Manifest",
        "json5": "JSON5",
        "jsonp": "JSONP",
        "jsstacktrace": "JS stack trace",
        "js-templates": "JS Templates",
        "keepalived": "Keepalived Configure",
        "kts": "Kotlin Script",
        "kt": "Kotlin",
        "kumir": "KuMir (\u041A\u0443\u041C\u0438\u0440)",
        "kum": "KuMir (\u041A\u0443\u041C\u0438\u0440)",
        "latex": "LaTeX",
        "tex": "TeX",
        "context": "ConTeXt",
        "lilypond": "LilyPond",
        "ly": "LilyPond",
        "emacs": "Lisp",
        "elisp": "Lisp",
        "emacs-lisp": "Lisp",
        "llvm": "LLVM IR",
        "log": "Log file",
        "lolcode": "LOLCODE",
        "magma": "Magma (CAS)",
        "md": "Markdown",
        "markup-templating": "Markup templating",
        "matlab": "MATLAB",
        "maxscript": "MAXScript",
        "mel": "MEL",
        "metafont": "METAFONT",
        "mongodb": "MongoDB",
        "moon": "MoonScript",
        "n1ql": "N1QL",
        "n4js": "N4JS",
        "n4jsd": "N4JS",
        "nand2tetris-hdl": "Nand To Tetris HDL",
        "naniscript": "Naninovel Script",
        "nani": "Naninovel Script",
        "nasm": "NASM",
        "neon": "NEON",
        "nginx": "nginx",
        "nsis": "NSIS",
        "objectivec": "Objective-C",
        "objc": "Objective-C",
        "ocaml": "OCaml",
        "opencl": "OpenCL",
        "openqasm": "OpenQasm",
        "qasm": "OpenQasm",
        "parigp": "PARI/GP",
        "objectpascal": "Object Pascal",
        "psl": "PATROL Scripting Language",
        "pcaxis": "PC-Axis",
        "px": "PC-Axis",
        "peoplecode": "PeopleCode",
        "pcode": "PeopleCode",
        "php": "PHP",
        "phpdoc": "PHPDoc",
        "php-extras": "PHP Extras",
        "plant-uml": "PlantUML",
        "plantuml": "PlantUML",
        "plsql": "PL/SQL",
        "powerquery": "PowerQuery",
        "pq": "PowerQuery",
        "mscript": "PowerQuery",
        "powershell": "PowerShell",
        "promql": "PromQL",
        "properties": ".properties",
        "protobuf": "Protocol Buffers",
        "purebasic": "PureBasic",
        "pbfasm": "PureBasic",
        "purs": "PureScript",
        "py": "Python",
        "qsharp": "Q#",
        "qs": "Q#",
        "q": "Q (kdb+ database)",
        "qml": "QML",
        "rkt": "Racket",
        "cshtml": "Razor C#",
        "razor": "Razor C#",
        "jsx": "React JSX",
        "tsx": "React TSX",
        "renpy": "Ren'py",
        "rpy": "Ren'py",
        "res": "ReScript",
        "rest": "reST (reStructuredText)",
        "robotframework": "Robot Framework",
        "robot": "Robot Framework",
        "rb": "Ruby",
        "sas": "SAS",
        "sass": "Sass (Sass)",
        "scss": "Sass (SCSS)",
        "shell-session": "Shell session",
        "sh-session": "Shell session",
        "shellsession": "Shell session",
        "sml": "SML",
        "smlnj": "SML/NJ",
        "solidity": "Solidity (Ethereum)",
        "sol": "Solidity (Ethereum)",
        "solution-file": "Solution file",
        "sln": "Solution file",
        "soy": "Soy (Closure Template)",
        "sparql": "SPARQL",
        "rq": "SPARQL",
        "splunk-spl": "Splunk SPL",
        "sqf": "SQF: Status Quo Function (Arma 3)",
        "sql": "SQL",
        "stata": "Stata Ado",
        "iecst": "Structured Text (IEC 61131-3)",
        "supercollider": "SuperCollider",
        "sclang": "SuperCollider",
        "systemd": "Systemd configuration file",
        "t4-templating": "T4 templating",
        "t4-cs": "T4 Text Templates (C#)",
        "t4": "T4 Text Templates (C#)",
        "t4-vb": "T4 Text Templates (VB)",
        "tap": "TAP",
        "tt2": "Template Toolkit 2",
        "toml": "TOML",
        "trickle": "trickle",
        "troy": "troy",
        "trig": "TriG",
        "ts": "TypeScript",
        "tsconfig": "TSConfig",
        "uscript": "UnrealScript",
        "uc": "UnrealScript",
        "uorazor": "UO Razor Script",
        "uri": "URI",
        "url": "URL",
        "vbnet": "VB.Net",
        "vhdl": "VHDL",
        "vim": "vim",
        "visual-basic": "Visual Basic",
        "vba": "VBA",
        "vb": "Visual Basic",
        "wasm": "WebAssembly",
        "web-idl": "Web IDL",
        "webidl": "Web IDL",
        "wgsl": "WGSL",
        "wiki": "Wiki markup",
        "wolfram": "Wolfram language",
        "nb": "Mathematica Notebook",
        "wl": "Wolfram language",
        "xeoracube": "XeoraCube",
        "xml-doc": "XML doc (.net)",
        "xojo": "Xojo (REALbasic)",
        "xquery": "XQuery",
        "yaml": "YAML",
        "yml": "YAML",
        "yang": "YANG"
    } /*]*/ ;
    /* eslint-enable */ Prism.plugins.toolbar.registerButton("show-language", function(env) {
        var pre = env.element.parentNode;
        if (!pre || !/pre/i.test(pre.nodeName)) return;
        /**
		 * Tries to guess the name of a language given its id.
		 *
		 * @param {string} id The language id.
		 * @returns {string}
		 */ function guessTitle(id) {
            if (!id) return id;
            return (id.substring(0, 1).toUpperCase() + id.substring(1)).replace(/s(?=cript)/, "S");
        }
        var language = pre.getAttribute("data-language") || Languages[env.language] || guessTitle(env.language);
        if (!language) return;
        var element = document.createElement("span");
        element.textContent = language;
        return element;
    });
})();





var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $8a1557d9f9123afe$var$PlusCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    },
    "name": "plus-circle",
    "theme": "filled"
};
var $8a1557d9f9123afe$export$2e2bcd8739ae039 = $8a1557d9f9123afe$var$PlusCircleFilled;



var $9e1167a67a71696c$var$PlusCircleFilled = function PlusCircleFilled(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $8a1557d9f9123afe$export$2e2bcd8739ae039)
    }));
};
/**![plus-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTIgNDcyYzAgNC40LTMuNiA4LTggOEg1NDR2MTUyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFY1NDRIMzI4Yy00LjQgMC04LTMuNi04LTh2LTQ4YzAtNC40IDMuNi04IDgtOGgxNTJWMzI4YzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MTUyaDE1MmM0LjQgMCA4IDMuNiA4IDh2NDh6IiAvPjwvc3ZnPg==) */ var $9e1167a67a71696c$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9e1167a67a71696c$var$PlusCircleFilled);
var $9e1167a67a71696c$export$2e2bcd8739ae039 = $9e1167a67a71696c$var$RefIcon;



var $d349326c2b62c55f$exports = {};
/*! @license DOMPurify 3.1.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.5/LICENSE */ (function(global, factory) {
    $d349326c2b62c55f$exports = factory();
})($d349326c2b62c55f$exports, function() {
    "use strict";
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== "undefined" && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param {Function} func - The function to be wrapped and called.
   * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param {Function} func - The constructor function to be wrapped and called.
   * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param {Object} set - The set to which elements will be added.
   * @param {Array} array - The array containing elements to be added to the set.
   * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns {Object} The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param {Array} array - The array to be cleaned.
   * @returns {Array} The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param {Object} object - The object to be cloned.
   * @returns {Object} A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === "object" && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param {Object} object - The object to look up the getter function in its prototype chain.
   * @param {String} prop - The property name for which to find the getter function.
   * @returns {Function} The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]);
    // SVG
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "wrap",
        "xmlns",
        "slot"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        ERB_EXPR: ERB_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR,
        DATA_ATTR: DATA_ATTR,
        ARIA_ATTR: ARIA_ATTR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        DOCTYPE_NAME: DOCTYPE_NAME,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT
    });
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return {TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "3.1.5";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode");
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, "ALLOWED_TAGS") ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, "ALLOWED_ATTR") ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, "ALLOWED_NAMESPACES") ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, "ADD_URI_SAFE_ATTR") ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, "ADD_DATA_URI_TAGS") ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, "FORBID_CONTENTS") ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, "FORBID_TAGS") ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, "FORBID_ATTR") ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, "USE_PROFILES") ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML("");
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === "string") emptyHTML = trustedTypesPolicy.createHTML("");
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        const HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "annotation-xml"
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                node.remove();
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ const _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param  {Node} root The root element or node to start traversing on.
     * @return {NodeIterator} The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param  {Node} object object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ const _isNode = function _isNode(object) {
            return typeof Node === "function" && object instanceof Node;
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, " ");
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param {string} tagName name of the tag of the node to sanitize
     * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== "annotation-xml" && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === "value" ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, " ");
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} cfg object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, " ");
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {String} tag Tag name of containing element.
     * @param  {String} attr Attribute name.
     * @param  {String} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});



function $7dc9608df6769390$export$1b82eb7005b29d31(dateTimeString) {
    if (!dateTimeString) return "";
    const date = new Date(dateTimeString);
    if (isNaN(date.getTime())) return "Invalid date";
    const dateOptions = {
        month: "long",
        day: "numeric",
        year: "numeric"
    };
    const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true
    };
    const userDate = date.toLocaleDateString([], dateOptions);
    const userTime = date.toLocaleTimeString([], options);
    return `${userDate} at ${userTime}`;
}
const $7dc9608df6769390$var$AIChatbot = ({ leftColumnRef: leftColumnRef, rightColumnRef: rightColumnRef, openChatbotButtonRef: openChatbotButtonRef })=>{
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    const { problem: problem } = problemContext;
    const [showChatbot, setShowChatbot] = (0, $acw62.useState)(false);
    const [conversations, setConversations] = (0, $acw62.useState)([]);
    const [currentConversation, setCurrentConversation] = (0, $acw62.useState)();
    const [messages, setMessages] = (0, $acw62.useState)([
        {
            content: "Ask me anything!",
            type: "response"
        }
    ]);
    const [inputValue, setInputValue] = (0, $acw62.useState)("");
    const [leftPosition, setLeftPosition] = (0, $acw62.useState)(0);
    const [rightPosition, setRightPosition] = (0, $acw62.useState)(0);
    const [collapsed, setCollapsed] = (0, $acw62.useState)(false);
    const [delayRender, setDelayRender] = (0, $acw62.useState)(false);
    const [tooltipOpen, setTooltipOpen] = (0, $acw62.useState)();
    const [drawerHeight, setDrawerHeight] = (0, $acw62.useState)(window.innerHeight < 700 ? 0.8 * window.innerHeight : 600);
    const [messageLoading, setMessageLoading] = (0, $acw62.useState)(false);
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const isDraggingRef = (0, $acw62.useRef)(false);
    const startY = (0, $acw62.useRef)(0);
    const startHeight = (0, $acw62.useRef)(0);
    const updateInterval = (0, $acw62.useRef)(null);
    const chatInputRef = (0, $acw62.useRef)(null);
    const updateWidths = ()=>{
        if (leftColumnRef.current) setLeftPosition(leftColumnRef.current.offsetWidth);
        if (rightColumnRef.current) {
            const rightRect = rightColumnRef.current.getBoundingClientRect();
            setRightPosition(document.body.offsetWidth - rightRect.left);
        }
    };
    const closeChatbot = ()=>{
        setShowChatbot(false);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("close_chatbot", {}, true);
    };
    const openChatbot = ()=>{
        setShowChatbot(true);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("open_chatbot", {}, true);
    };
    const stopUpdateInterval = ()=>{
        if (updateInterval.current) {
            clearInterval(updateInterval.current);
            updateInterval.current = null;
        }
    };
    const askQuestion = async (e)=>{
        e.preventDefault();
        if (!inputValue || !problem) return;
        setMessageLoading(true);
        const savedInputValue = inputValue;
        setInputValue("");
        const currentDate = new Date();
        setMessages((prevMessages)=>[
                ...prevMessages,
                {
                    content: savedInputValue,
                    type: "request",
                    createdAt: $7dc9608df6769390$export$1b82eb7005b29d31(currentDate.toISOString())
                },
                {
                    content: "",
                    type: "response",
                    tempStreamingMessage: true
                }
            ]);
        chatInputRef.current?.focus();
        try {
            const response = await fetch(`${(0, $9d936a2aecb96285$export$b27b0287c31e45de)}/api/chatbot/ask-chatbot-question`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "text/event-stream"
                },
                body: JSON.stringify({
                    message: savedInputValue,
                    conversation_id: currentConversation?.id,
                    problem_id: problem.id
                }),
                credentials: "include"
            });
            const reader = response.body?.getReader();
            const decoder = new TextDecoder();
            let chatResponse = "";
            if (!reader) throw new Error("No reader available, try again.");
            const startUpdateInterval = ()=>{
                if (updateInterval.current) return;
                updateInterval.current = setInterval(()=>{
                    setMessages((prevMessages)=>prevMessages.map((message)=>message.tempStreamingMessage ? {
                                ...message,
                                content: chatResponse
                            } : message));
                }, 200);
            };
            reader.read().then(function processText({ done: done, value: value }) {
                if (done) {
                    stopUpdateInterval();
                    return Promise.resolve();
                }
                const chunk = decoder.decode(value, {
                    stream: true
                });
                const lines = chunk.split("\n").filter((line)=>line.trim());
                const lastLine = lines[lines.length - 1].trim();
                if (lastLine.startsWith("data:")) try {
                    const messageData = JSON.parse(lastLine.slice(5));
                    if (messageData.event === "done") {
                        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("chatbot_request", {
                            request: savedInputValue,
                            response: messageData.chat_response.content
                        }, true);
                        setMessages((prevMessages)=>prevMessages.map((message)=>message.tempStreamingMessage ? {
                                    ...message,
                                    content: messageData.chat_response.content,
                                    tempStreamingMessage: false,
                                    createdAt: $7dc9608df6769390$export$1b82eb7005b29d31(messageData.chat_response.createdAt)
                                } : message));
                        if (messageData.updateTitle) {
                            if (conversations.length === 0) setConversations([
                                {
                                    ...messageData.conversation,
                                    is_active: false
                                }
                            ]);
                            else setConversations((prevConversations)=>{
                                return prevConversations.map((conversation)=>conversation.id === messageData.conversation.id ? {
                                        ...messageData.conversation,
                                        is_active: false
                                    } : conversation);
                            });
                            setCurrentConversation(messageData.conversation);
                        }
                        setMessageLoading(false);
                        stopUpdateInterval();
                    } else if (messageData.content) {
                        setMessageLoading(false);
                        chatResponse = messageData.content;
                        startUpdateInterval();
                    } else if (messageData.event === "error") throw new Error(messageData.message);
                } catch (error) {
                    console.log("Failed to parse JSON");
                }
                return reader.read().then(processText);
            });
        } catch (error) {
            console.error("Error sending message", error);
            stopUpdateInterval();
            setMessages((prevMessages)=>{
                const updatedMessages = [
                    ...prevMessages,
                    {
                        content: "Sorry, I am unable to process your request, please refresh and try again.",
                        type: "response"
                    }
                ];
                return updatedMessages.map((message)=>message.tempStreamingMessage ? {
                        ...message,
                        tempStreamingMessage: false
                    } : message);
            });
            setInputValue(savedInputValue);
            setMessageLoading(false);
        }
    };
    const loadMessages = async ()=>{
        if (!currentConversation) return;
        try {
            // fetch messages
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get(`/api/chatbot/get-messages/${currentConversation.id}`, {
                withCredentials: true
            });
            setMessages([
                {
                    content: "Ask me anything!",
                    type: "response"
                },
                ...res.data.messages.map((message)=>{
                    const cleanMessageContent = (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(message.content);
                    return {
                        content: cleanMessageContent,
                        type: message.type,
                        createdAt: $7dc9608df6769390$export$1b82eb7005b29d31(message.createdAt)
                    };
                })
            ]);
        } catch (error) {
            console.log("Error fetching messages", error);
        }
    };
    const loadConversations = async ()=>{
        try {
            // fetch conversations
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/chatbot/get-conversations", {
                withCredentials: true
            });
            const conversations = res.data.conversations;
            setConversations(conversations.map((conversation)=>({
                    ...conversation,
                    is_active: false
                })));
            if (conversations.length > 0) {
                const lastActiveConversation = res.data.conversations.reduce((prev, current)=>{
                    return new Date(prev.updatedAt) > new Date(current.updatedAt) ? prev : current;
                });
                setCurrentConversation(lastActiveConversation);
            }
        } catch (error) {
            console.log("Error fetching conversations", error);
        }
    };
    const selectConversation = (conversation)=>{
        if (conversation.id === currentConversation?.id) return;
        setCurrentConversation(conversation);
    };
    const createConversation = async ()=>{
        try {
            const tempName = `Conversation at ${new Date().toLocaleTimeString()}`;
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/chatbot/create-new-conversation", {
                name: tempName
            }, {
                withCredentials: true
            });
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("create_new_conversation", {}, true);
            setConversations((prevConversations)=>[
                    ...prevConversations,
                    res.data.conversation
                ]);
            setCurrentConversation(res.data.conversation);
        } catch (error) {
            console.log("Error creating conversation", error);
        }
    };
    const resetClosedTooltip = ()=>{
        setTooltipOpen(false);
        setTimeout(()=>{
            setTooltipOpen(undefined);
        }, 10);
    };
    const onMouseDown = (e)=>{
        setIsDragging(true);
        isDraggingRef.current = true;
        startY.current = e.clientY;
        startHeight.current = drawerHeight;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    };
    const onMouseMove = (e)=>{
        if (isDraggingRef.current) {
            const difference = e.clientY - startY.current;
            const newHeight = startHeight.current - difference;
            setDrawerHeight(Math.max(newHeight, 350));
        }
    };
    const onMouseUp = ()=>{
        setIsDragging(false);
        isDraggingRef.current = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
    };
    (0, $acw62.useEffect)(()=>{
        if (currentConversation) {
            loadMessages();
            setConversations((prevConversations)=>{
                return prevConversations?.map((conversation)=>{
                    return {
                        ...conversation,
                        is_active: conversation.id === currentConversation.id
                    };
                });
            });
        }
    }, [
        currentConversation
    ]);
    (0, $acw62.useEffect)(()=>{
        if (messages) {
            const codeElements = document.querySelectorAll("code.language-python");
            codeElements.forEach((element)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($1fddf034d74735a2$exports))).highlightElement(element);
            });
            const chatbotMessagesContainer = document.querySelector(".chatbotMessagesContainer");
            if (chatbotMessagesContainer) chatbotMessagesContainer.scrollTop = chatbotMessagesContainer.scrollHeight;
        }
    }, [
        messages,
        showChatbot
    ]);
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>{
            setDelayRender(collapsed);
        }, 200);
    }, [
        collapsed
    ]);
    (0, $acw62.useEffect)(()=>{
        const chatbotOverallContainer = document.querySelectorAll(".chatbotOverallContainer");
        if (chatbotOverallContainer) (0, $cfadb87391ca5e26$export$b71d81bfaeb967a6)(chatbotOverallContainer);
        loadConversations();
        const leftObserver = new ResizeObserver(updateWidths);
        const rightObserver = new ResizeObserver(updateWidths);
        if (leftColumnRef.current) leftObserver.observe(leftColumnRef.current);
        if (rightColumnRef.current) rightObserver.observe(rightColumnRef.current);
        return ()=>{
            if (leftColumnRef.current) leftObserver.disconnect();
            if (rightColumnRef.current) rightObserver.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "chatbotOverallContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2824be14bd3234d$export$2e2bcd8739ae039), {
                placement: "bottom",
                classNames: {
                    body: "chatbotBody"
                },
                styles: {
                    header: {
                        display: "none"
                    },
                    wrapper: {
                        left: `${leftPosition}px`,
                        right: `${rightPosition}px`,
                        transition: isDragging ? "none" : ""
                    }
                },
                height: drawerHeight,
                open: showChatbot,
                onClose: closeChatbot,
                className: isDragging ? "chatbotDrawerDragging" : "",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "chatbotContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "resizeBar",
                            title: "Drag to resize",
                            onMouseDown: onMouseDown
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "chatbotHeader",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    className: "chatbotHeaderCloseButton",
                                    onClick: closeChatbot,
                                    children: "Close Chatbot"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "chatbotHeaderTitle",
                                    children: "AI Chatbot"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "spacer"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "chatbotMainContent",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: `chatbotConversationContainer ${collapsed ? "collapsed" : ""}`,
                                    children: [
                                        !collapsed && !delayRender && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: "Conversations"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    className: "addNewConversationBtn",
                                                    title: "Create new conversation",
                                                    onClick: createConversation,
                                                    children: [
                                                        "New Chat",
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e1167a67a71696c$export$2e2bcd8739ae039), {
                                                            className: "newConversationPlusIcon"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                    className: "conversation-list",
                                                    children: [
                                                        conversations?.map((conversation, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                tabIndex: 0,
                                                                role: "button",
                                                                className: `conversation-list-item ${conversation.is_active ? "active-conversation" : ""}`,
                                                                title: conversation.name,
                                                                onClick: ()=>selectConversation(conversation),
                                                                children: conversation.name
                                                            }, conversation.id || index)),
                                                        conversations.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                            className: "no-conversations-msg",
                                                            children: "No conversations yet"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                                            placement: "top",
                                            title: collapsed ? "Expand Sidebar" : "Collapse Sidebar",
                                            open: tooltipOpen,
                                            mouseEnterDelay: 0,
                                            mouseLeaveDelay: 0.5,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                className: `collapseConversationBarBtn`,
                                                icon: collapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {}),
                                                onClick: ()=>{
                                                    resetClosedTooltip();
                                                    setCollapsed((prev)=>!prev);
                                                }
                                            })
                                        }),
                                        collapsed && delayRender && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "collapsedConversationBarPlaceholder",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: "Expand to view conversations"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "chatbotMessagesAndInputContainer",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "chatbotMessagesAndInputInternalPositioningContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                                className: "chatbotMessagesContainer",
                                                onCopy: ()=>(0, $cfadb87391ca5e26$export$227fec498bd204c4)("chatbot messages"),
                                                children: [
                                                    messages.map((message, index)=>{
                                                        return message.content && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            className: `message-list-item ${message.type === "response" ? "response-message" : "request-message"}${message.createdAt ? " addPaddingForTimestamp" : ""}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: message.content
                                                                    }
                                                                }),
                                                                message.createdAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    className: "messageTimeStamp",
                                                                    children: `${message.createdAt}`
                                                                })
                                                            ]
                                                        }, index);
                                                    }),
                                                    messageLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        className: "message-list-item response-message",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "typing-indicator",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {})
                                                            ]
                                                        })
                                                    }, "chatbotLoadingIndicator")
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
                                                className: "chatbotInputContainer",
                                                onSubmitCapture: askQuestion,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                        type: "text",
                                                        id: "chatbotInput",
                                                        autoComplete: "off",
                                                        className: "chatbotInput",
                                                        placeholder: "Type your question here...",
                                                        ref: chatInputRef,
                                                        value: inputValue,
                                                        onChange: (e)=>setInputValue(e.target.value),
                                                        onPaste: (e)=>(0, $cfadb87391ca5e26$export$e7e57daa27256709)("chatbot input", e)
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        name: "chatbotSendButton",
                                                        type: "primary",
                                                        htmlType: "submit",
                                                        className: "chatbotSendButton",
                                                        children: "Send"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                ref: openChatbotButtonRef,
                className: "openChatbotBtn",
                onClick: openChatbot,
                children: "Open AI Chatbot"
            })
        ]
    });
};
var $7dc9608df6769390$export$2e2bcd8739ae039 = $7dc9608df6769390$var$AIChatbot;






var $acw62 = parcelRequire("acw62");






function $a27b05490eb06301$export$2e2bcd8739ae039(siders, children, hasSider) {
    if (typeof hasSider === "boolean") return hasSider;
    if (siders.length) return true;
    const childNodes = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children);
    return childNodes.some((node)=>node.type === (0, $f4e67dbf2453f541$export$2e2bcd8739ae039));
}




const $94333cf053f9f105$var$genLayoutLightStyle = (token)=>{
    const { componentCls: componentCls, bodyBg: bodyBg, lightSiderBg: lightSiderBg, lightTriggerBg: lightTriggerBg, lightTriggerColor: lightTriggerColor } = token;
    return {
        [`${componentCls}-sider-light`]: {
            background: lightSiderBg,
            [`${componentCls}-sider-trigger`]: {
                color: lightTriggerColor,
                background: lightTriggerBg
            },
            [`${componentCls}-sider-zero-width-trigger`]: {
                color: lightTriggerColor,
                background: lightTriggerBg,
                border: `1px solid ${bodyBg}`,
                // Safe to modify to any other color
                borderInlineStart: 0
            }
        }
    };
};
var $94333cf053f9f105$export$2e2bcd8739ae039 = $94333cf053f9f105$var$genLayoutLightStyle;


const $cac338994a0b926f$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, triggerColor: triggerColor, footerBg: footerBg, triggerBg: triggerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, triggerHeight: triggerHeight, zeroTriggerHeight: zeroTriggerHeight, zeroTriggerWidth: zeroTriggerWidth, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, fontSize: fontSize, borderRadius: borderRadius, bodyBg: bodyBg, headerBg: headerBg, siderBg: siderBg } = token;
    return {
        [componentCls]: Object.assign(Object.assign({
            display: "flex",
            flex: "auto",
            flexDirection: "column",
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            "&, *": {
                boxSizing: "border-box"
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: "row",
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: "0 0 auto"
            },
            [`${componentCls}-sider`]: {
                position: "relative",
                // fix firefox can't set width smaller than content on flex item
                minWidth: 0,
                background: siderBg,
                transition: `all ${motionDurationMid}, background 0s`,
                "&-children": {
                    height: "100%",
                    // Hack for fixing margin collapse bug
                    // https://github.com/ant-design/ant-design/issues/7967
                    // solution from https://stackoverflow.com/a/33132624/3040605
                    marginTop: -0.1,
                    paddingTop: 0.1,
                    [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                        width: "auto"
                    }
                },
                "&-has-trigger": {
                    paddingBottom: triggerHeight
                },
                "&-right": {
                    order: 1
                },
                "&-trigger": {
                    position: "fixed",
                    bottom: 0,
                    zIndex: 1,
                    height: triggerHeight,
                    color: triggerColor,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(triggerHeight),
                    textAlign: "center",
                    background: triggerBg,
                    cursor: "pointer",
                    transition: `all ${motionDurationMid}`
                },
                "&-zero-width": {
                    "> *": {
                        overflow: "hidden"
                    },
                    "&-trigger": {
                        position: "absolute",
                        top: headerHeight,
                        insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                        zIndex: 1,
                        width: zeroTriggerWidth,
                        height: zeroTriggerHeight,
                        color: triggerColor,
                        fontSize: token.fontSizeXL,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: siderBg,
                        borderStartStartRadius: 0,
                        borderStartEndRadius: borderRadius,
                        borderEndEndRadius: borderRadius,
                        borderEndStartRadius: 0,
                        cursor: "pointer",
                        transition: `background ${motionDurationSlow} ease`,
                        "&::after": {
                            position: "absolute",
                            inset: 0,
                            background: "transparent",
                            transition: `all ${motionDurationSlow}`,
                            content: '""'
                        },
                        "&:hover::after": {
                            background: `rgba(255, 255, 255, 0.2)`
                        },
                        "&-right": {
                            insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                            borderStartStartRadius: borderRadius,
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0,
                            borderEndStartRadius: borderRadius
                        }
                    }
                }
            }
        }, (0, $94333cf053f9f105$export$2e2bcd8739ae039)(token)), {
            // RTL
            "&-rtl": {
                direction: "rtl"
            }
        }),
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: "inherit"
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: "auto",
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $cac338994a0b926f$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: "#001529",
        colorBgBody: colorBgLayout,
        colorBgTrigger: "#002140",
        bodyBg: colorBgLayout,
        headerBg: "#001529",
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: "#001529",
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: "#002140",
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
var // ============================== Export ==============================
$cac338994a0b926f$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Layout", (token)=>[
        $cac338994a0b926f$var$genLayoutStyle(token)
    ], $cac338994a0b926f$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            "colorBgBody",
            "bodyBg"
        ],
        [
            "colorBgHeader",
            "headerBg"
        ],
        [
            "colorBgTrigger",
            "triggerBg"
        ]
    ]
});


"use client";
var $ea0a526399f02a88$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ea0a526399f02a88$var$generator(_ref) {
    let { suffixCls: suffixCls, tagName: tagName, displayName: displayName } = _ref;
    return (BasicComponent)=>{
        const Adapter = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement(BasicComponent, Object.assign({
                ref: ref,
                suffixCls: suffixCls,
                tagName: tagName
            }, props)));
        return Adapter;
    };
}
const $ea0a526399f02a88$var$Basic = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, suffixCls: suffixCls, className: className, tagName: TagName } = props, others = $ea0a526399f02a88$var$__rest(props, [
        "prefixCls",
        "suffixCls",
        "className",
        "tagName"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("layout", customizePrefixCls);
    const [wrapSSR, hashId, cssVarCls] = (0, $cac338994a0b926f$export$2e2bcd8739ae039)(prefixCls);
    const prefixWithSuffixCls = suffixCls ? `${prefixCls}-${suffixCls}` : prefixCls;
    return wrapSSR(/*#__PURE__*/ $acw62.createElement(TagName, Object.assign({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(customizePrefixCls || prefixWithSuffixCls, className, hashId, cssVarCls),
        ref: ref
    }, others)));
});
const $ea0a526399f02a88$var$BasicLayout = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [siders, setSiders] = $acw62.useState([]);
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, hasSider: hasSider, tagName: Tag, style: style } = props, others = $ea0a526399f02a88$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "children",
        "hasSider",
        "tagName",
        "style"
    ]);
    const passedProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(others, [
        "suffixCls"
    ]);
    const { getPrefixCls: getPrefixCls, layout: layout } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("layout", customizePrefixCls);
    const mergedHasSider = (0, $a27b05490eb06301$export$2e2bcd8739ae039)(siders, children, hasSider);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $cac338994a0b926f$export$2e2bcd8739ae039)(prefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, {
        [`${prefixCls}-has-sider`]: mergedHasSider,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, layout === null || layout === void 0 ? void 0 : layout.className, className, rootClassName, hashId, cssVarCls);
    const contextValue = $acw62.useMemo(()=>({
            siderHook: {
                addSider: (id)=>{
                    setSiders((prev)=>[].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), [
                            id
                        ]));
                },
                removeSider: (id)=>{
                    setSiders((prev)=>prev.filter((currentId)=>currentId !== id));
                }
            }
        }), []);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $368377cf0f14dd00$export$964282a2c3979546).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement(Tag, Object.assign({
        ref: ref,
        className: classString,
        style: Object.assign(Object.assign({}, layout === null || layout === void 0 ? void 0 : layout.style), style)
    }, passedProps), children)));
});
const $ea0a526399f02a88$var$Layout = $ea0a526399f02a88$var$generator({
    tagName: "div",
    displayName: "Layout"
})($ea0a526399f02a88$var$BasicLayout);
const $ea0a526399f02a88$export$8b251419efc915eb = $ea0a526399f02a88$var$generator({
    suffixCls: "header",
    tagName: "header",
    displayName: "Header"
})($ea0a526399f02a88$var$Basic);
const $ea0a526399f02a88$export$a06f1c675e846f6f = $ea0a526399f02a88$var$generator({
    suffixCls: "footer",
    tagName: "footer",
    displayName: "Footer"
})($ea0a526399f02a88$var$Basic);
const $ea0a526399f02a88$export$7c6e2c02157bb7d2 = $ea0a526399f02a88$var$generator({
    suffixCls: "content",
    tagName: "main",
    displayName: "Content"
})($ea0a526399f02a88$var$Basic);
var $ea0a526399f02a88$export$2e2bcd8739ae039 = $ea0a526399f02a88$var$Layout;



"use client";
const $49639f13efb591ba$var$Layout = (0, $ea0a526399f02a88$export$2e2bcd8739ae039);
$49639f13efb591ba$var$Layout.Header = (0, $ea0a526399f02a88$export$8b251419efc915eb);
$49639f13efb591ba$var$Layout.Footer = (0, $ea0a526399f02a88$export$a06f1c675e846f6f);
$49639f13efb591ba$var$Layout.Content = (0, $ea0a526399f02a88$export$7c6e2c02157bb7d2);
$49639f13efb591ba$var$Layout.Sider = (0, $f4e67dbf2453f541$export$2e2bcd8739ae039);
$49639f13efb591ba$var$Layout._InternalSiderContext = (0, $f4e67dbf2453f541$export$63554aebd2a6d54c);
var $49639f13efb591ba$export$2e2bcd8739ae039 = $49639f13efb591ba$var$Layout;


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $54675b4e19f0d6af$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
var $54675b4e19f0d6af$export$2e2bcd8739ae039 = $54675b4e19f0d6af$var$PlusOutlined;



var $61e4183d607620fc$var$PlusOutlined = function PlusOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $54675b4e19f0d6af$export$2e2bcd8739ae039)
    }));
};
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ var $61e4183d607620fc$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($61e4183d607620fc$var$PlusOutlined);
var $61e4183d607620fc$export$2e2bcd8739ae039 = $61e4183d607620fc$var$RefIcon;













var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $bb2ee1e3f89d10a5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $acw62.createContext)(null);






var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $d6c5d05385b01772$var$useIndicator = function useIndicator(options) {
    var activeTabOffset = options.activeTabOffset, horizontal = options.horizontal, rtl = options.rtl, _options$indicator = options.indicator, indicator = _options$indicator === void 0 ? {} : _options$indicator;
    var size = indicator.size, _indicator$align = indicator.align, align = _indicator$align === void 0 ? "center" : _indicator$align;
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), inkStyle = _useState2[0], setInkStyle = _useState2[1];
    var inkBarRafRef = (0, $acw62.useRef)();
    var getLength = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(origin) {
        if (typeof size === "function") return size(origin);
        if (typeof size === "number") return size;
        return origin;
    }, [
        size
    ]);
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039).cancel(inkBarRafRef.current);
    }
    (0, $acw62.useEffect)(function() {
        var newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                newInkStyle.width = getLength(activeTabOffset.width);
                var key = rtl ? "right" : "left";
                if (align === "start") newInkStyle[key] = activeTabOffset[key];
                if (align === "center") {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width / 2;
                    newInkStyle.transform = rtl ? "translateX(50%)" : "translateX(-50%)";
                }
                if (align === "end") {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width;
                    newInkStyle.transform = "translateX(-100%)";
                }
            } else {
                newInkStyle.height = getLength(activeTabOffset.height);
                if (align === "start") newInkStyle.top = activeTabOffset.top;
                if (align === "center") {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                    newInkStyle.transform = "translateY(-50%)";
                }
                if (align === "end") {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
                    newInkStyle.transform = "translateY(-100%)";
                }
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $a1ced7b983ea61a4$export$2e2bcd8739ae039)(function() {
            setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        activeTabOffset,
        horizontal,
        rtl,
        align,
        getLength
    ]);
    return {
        style: inkStyle
    };
};
var $d6c5d05385b01772$export$2e2bcd8739ae039 = $d6c5d05385b01772$var$useIndicator;




var $acw62 = parcelRequire("acw62");
var $fea37cf40acfe645$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $fea37cf40acfe645$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $acw62.useMemo)(function() {
        var _tabs$;
        var map = new Map();
        var lastOffset = tabSizes.get((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key) || $fea37cf40acfe645$var$DEFAULT_SIZE;
        var rightOffset = lastOffset.left + lastOffset.width;
        for(var i = 0; i < tabs.length; i += 1){
            var key = tabs[i].key;
            var data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) {
                var _tabs;
                data = tabSizes.get((_tabs = tabs[i - 1]) === null || _tabs === void 0 ? void 0 : _tabs.key) || $fea37cf40acfe645$var$DEFAULT_SIZE;
            }
            var entity = map.get(key) || (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, data);
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        tabSizes,
        holderScrollWidth
    ]);
}




var $acw62 = parcelRequire("acw62");
function $f1c0f3be6d5fa93f$export$2e2bcd8739ae039(defaultState, onChange) {
    var stateRef = $acw62.useRef(defaultState);
    var _React$useState = $acw62.useState({}), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), forceUpdate = _React$useState2[1];
    function setState(updater) {
        var newValue = typeof updater === "function" ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}




var $acw62 = parcelRequire("acw62");
var $bd298a079d025635$var$MIN_SWIPE_DISTANCE = 0.1;
var $bd298a079d025635$var$STOP_SWIPE_DISTANCE = 0.01;
var $bd298a079d025635$var$REFRESH_INTERVAL = 20;
var $bd298a079d025635$var$SPEED_OFF_MULTIPLE = Math.pow(0.995, $bd298a079d025635$var$REFRESH_INTERVAL);
function $bd298a079d025635$export$2e2bcd8739ae039(ref, onOffset) {
    var _useState = (0, $acw62.useState)(), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), touchPosition = _useState2[0], setTouchPosition = _useState2[1];
    var _useState3 = (0, $acw62.useState)(0), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), lastTimestamp = _useState4[0], setLastTimestamp = _useState4[1];
    var _useState5 = (0, $acw62.useState)(0), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), lastTimeDiff = _useState6[0], setLastTimeDiff = _useState6[1];
    var _useState7 = (0, $acw62.useState)(), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), lastOffset = _useState8[0], setLastOffset = _useState8[1];
    var motionRef = (0, $acw62.useRef)();
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        var _e$touches$ = e.touches[0], screenX = _e$touches$.screenX, screenY = _e$touches$.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        e.preventDefault();
        var _e$touches$2 = e.touches[0], screenX = _e$touches$2.screenX, screenY = _e$touches$2.screenY;
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        var offsetX = screenX - touchPosition.x;
        var offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        var now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            var distanceX = lastOffset.x / lastTimeDiff;
            var distanceY = lastOffset.y / lastTimeDiff;
            var absX = Math.abs(distanceX);
            var absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $bd298a079d025635$var$MIN_SWIPE_DISTANCE) return;
            var currentX = distanceX;
            var currentY = distanceY;
            motionRef.current = window.setInterval(function() {
                if (Math.abs(currentX) < $bd298a079d025635$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $bd298a079d025635$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $bd298a079d025635$var$SPEED_OFF_MULTIPLE;
                currentY *= $bd298a079d025635$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $bd298a079d025635$var$REFRESH_INTERVAL, currentY * $bd298a079d025635$var$REFRESH_INTERVAL);
            }, $bd298a079d025635$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    var lastWheelDirectionRef = (0, $acw62.useRef)();
    function onWheel(e) {
        var deltaX = e.deltaX, deltaY = e.deltaY;
        // Convert both to x & y since wheel only happened on PC
        var mixed = 0;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === "x" ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = "x";
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = "y";
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    var touchEventsRef = (0, $acw62.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $acw62.useEffect(function() {
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener("touchmove", onProxyTouchMove, {
            passive: false
        });
        document.addEventListener("touchend", onProxyTouchEnd, {
            passive: true
        });
        // No need to clean up since element removed
        ref.current.addEventListener("touchstart", onProxyTouchStart, {
            passive: true
        });
        ref.current.addEventListener("wheel", onProxyWheel, {
            passive: false
        });
        return function() {
            document.removeEventListener("touchmove", onProxyTouchMove);
            document.removeEventListener("touchend", onProxyTouchEnd);
        };
    }, []);
}





var $acw62 = parcelRequire("acw62");
function $6bb369ac1283ea97$export$2e2bcd8739ae039(callback) {
    var _useState = (0, $acw62.useState)(0), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), count = _useState2[0], setCount = _useState2[1];
    var effectRef = (0, $acw62.useRef)(0);
    var callbackRef = (0, $acw62.useRef)();
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $493347a9fd5d8394$export$9283e56bae2f7b0f)(function() {
        var _callbackRef$current;
        (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 || _callbackRef$current.call(callbackRef);
    }, [
        count
    ]);
    // Trigger to update count
    return function() {
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $6bb369ac1283ea97$export$aefd2a30eb6d999e(defaultState) {
    var batchRef = (0, $acw62.useRef)([]);
    var _useState3 = (0, $acw62.useState)({}), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), forceUpdate = _useState4[1];
    var state = (0, $acw62.useRef)(typeof defaultState === "function" ? defaultState() : defaultState);
    var flushUpdate = $6bb369ac1283ea97$export$2e2bcd8739ae039(function() {
        var current = state.current;
        batchRef.current.forEach(function(callback) {
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $acw62 = parcelRequire("acw62");
var $1e3cbc4ab07e0147$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $1e3cbc4ab07e0147$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, _ref) {
    var tabs = _ref.tabs, tabPosition = _ref.tabPosition, rtl = _ref.rtl;
    var charUnit;
    var position;
    var transformSize;
    if ([
        "top",
        "bottom"
    ].includes(tabPosition)) {
        charUnit = "width";
        position = rtl ? "right" : "left";
        transformSize = Math.abs(transform);
    } else {
        charUnit = "height";
        position = "top";
        transformSize = -transform;
    }
    return (0, $acw62.useMemo)(function() {
        if (!tabs.length) return [
            0,
            0
        ];
        var len = tabs.length;
        var endIndex = len;
        for(var i = 0; i < len; i += 1){
            var offset = tabOffsets.get(tabs[i].key) || $1e3cbc4ab07e0147$var$DEFAULT_SIZE;
            if (offset[position] + offset[charUnit] > transformSize + visibleTabContentValue) {
                endIndex = i - 1;
                break;
            }
        }
        var startIndex = 0;
        for(var _i = len - 1; _i >= 0; _i -= 1){
            var _offset = tabOffsets.get(tabs[_i].key) || $1e3cbc4ab07e0147$var$DEFAULT_SIZE;
            if (_offset[position] < transformSize) {
                startIndex = _i + 1;
                break;
            }
        }
        return startIndex >= endIndex ? [
            0,
            0
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        rtl
    ]);
}


/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $099b8f1c61d35623$export$fac44ee5b035f737(obj) {
    var tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach(function(v, k) {
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
var $099b8f1c61d35623$var$RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function $099b8f1c61d35623$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $099b8f1c61d35623$var$RC_TABS_DOUBLE_QUOTE);
}
function $099b8f1c61d35623$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}



var $acw62 = parcelRequire("acw62");
var $034d4b5b2135dc44$var$AddButton = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, editable = props.editable, locale = props.locale, style = props.style;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $acw62.createElement("button", {
        ref: ref,
        type: "button",
        className: "".concat(prefixCls, "-nav-add"),
        style: style,
        "aria-label": (locale === null || locale === void 0 ? void 0 : locale.addAriaLabel) || "Add tab",
        onClick: function onClick(event) {
            editable.onEdit("add", {
                event: event
            });
        }
    }, editable.addIcon || "+");
});
var $034d4b5b2135dc44$export$2e2bcd8739ae039 = $034d4b5b2135dc44$var$AddButton;




var $acw62 = parcelRequire("acw62");
var $f179037cdfb41409$var$ExtraContent = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var position = props.position, prefixCls = props.prefixCls, extra = props.extra;
    if (!extra) return null;
    var content;
    // Parse extra
    var assertExtra = {};
    if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(extra) === "object" && !/*#__PURE__*/ $acw62.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === "right") content = assertExtra.right;
    if (position === "left") content = assertExtra.left;
    return content ? /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-extra-content"),
        ref: ref
    }, content) : null;
});
var $f179037cdfb41409$export$2e2bcd8739ae039 = $f179037cdfb41409$var$ExtraContent;










var $acw62 = parcelRequire("acw62");


var $7e96fc940147fd66$var$OperationNode = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, id = props.id, tabs = props.tabs, locale = props.locale, mobile = props.mobile, _props$more = props.more, moreProps = _props$more === void 0 ? {} : _props$more, style = props.style, className = props.className, editable = props.editable, tabBarGutter = props.tabBarGutter, rtl = props.rtl, removeAriaLabel = props.removeAriaLabel, onTabClick = props.onTabClick, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName;
    // ======================== Dropdown ========================
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), open = _useState2[0], setOpen = _useState2[1];
    var _useState3 = (0, $acw62.useState)(null), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), selectedKey = _useState4[0], setSelectedKey = _useState4[1];
    var _moreProps$icon = moreProps.icon, moreIcon = _moreProps$icon === void 0 ? "More" : _moreProps$icon;
    var popupId = "".concat(id, "-more-popup");
    var dropdownPrefix = "".concat(prefixCls, "-dropdown");
    var selectedItemId = selectedKey !== null ? "".concat(popupId, "-").concat(selectedKey) : null;
    var dropdownAriaLabel = locale === null || locale === void 0 ? void 0 : locale.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    var menu = /*#__PURE__*/ $acw62.createElement((0, $b187593cf569a182$export$2e2bcd8739ae039), {
        onClick: function onClick(_ref) {
            var key = _ref.key, domEvent = _ref.domEvent;
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: "".concat(dropdownPrefix, "-menu"),
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : "expanded dropdown"
    }, tabs.map(function(tab) {
        var closable = tab.closable, disabled = tab.disabled, closeIcon = tab.closeIcon, key = tab.key, label = tab.label;
        var removable = (0, $099b8f1c61d35623$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $acw62.createElement((0, $c59b5fb169e5cf0f$export$2e2bcd8739ae039), {
            key: key,
            id: "".concat(popupId, "-").concat(key),
            role: "option",
            "aria-controls": id && "".concat(id, "-panel-").concat(key),
            disabled: disabled
        }, /*#__PURE__*/ $acw62.createElement("span", null, label), removable && /*#__PURE__*/ $acw62.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || "remove",
            tabIndex: 0,
            className: "".concat(dropdownPrefix, "-menu-item-remove"),
            onClick: function onClick(e) {
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    function selectOffset(offset) {
        var enabledTabs = tabs.filter(function(tab) {
            return !tab.disabled;
        });
        var selectedIndex = enabledTabs.findIndex(function(tab) {
            return tab.key === selectedKey;
        }) || 0;
        var len = enabledTabs.length;
        for(var i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            var tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        var which = e.which;
        if (!open) {
            if ([
                (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN,
                (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).SPACE,
                (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).SPACE:
            case (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $acw62.useEffect)(function() {
        // We use query element here to avoid React strict warning
        var ele = document.getElementById(selectedItemId);
        if (ele && ele.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedKey
    ]);
    (0, $acw62.useEffect)(function() {
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    var moreStyle = (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, rtl ? "marginRight" : "marginLeft", tabBarGutter);
    if (!tabs.length) {
        moreStyle.visibility = "hidden";
        moreStyle.order = 1;
    }
    var overlayClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(dropdownPrefix, "-rtl"), rtl));
    var moreNode = mobile ? null : /*#__PURE__*/ $acw62.createElement((0, $e2ef3d42b101c489$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        prefixCls: dropdownPrefix,
        overlay: menu,
        visible: tabs.length ? open : false,
        onVisibleChange: setOpen,
        overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, popupClassName),
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, moreProps), /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        className: "".concat(prefixCls, "-nav-more"),
        style: moreStyle,
        tabIndex: -1,
        "aria-hidden": "true",
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: "".concat(id, "-more"),
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-nav-operations"), className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $acw62.createElement((0, $034d4b5b2135dc44$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $7e96fc940147fd66$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.memo($7e96fc940147fd66$var$OperationNode, function(_, next) {
    return(// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);
});






var $acw62 = parcelRequire("acw62");

var $05c6b22b26939e9e$var$TabNode = function TabNode(props) {
    var prefixCls = props.prefixCls, id = props.id, active = props.active, _props$tab = props.tab, key = _props$tab.key, label = _props$tab.label, disabled = _props$tab.disabled, closeIcon = _props$tab.closeIcon, icon = _props$tab.icon, closable = props.closable, renderWrapper = props.renderWrapper, removeAriaLabel = props.removeAriaLabel, editable = props.editable, onClick = props.onClick, onFocus = props.onFocus, style = props.style;
    var tabPrefix = "".concat(prefixCls, "-tab");
    var removable = (0, $099b8f1c61d35623$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    var labelNode = $acw62.useMemo(function() {
        return icon && typeof label === "string" ? /*#__PURE__*/ $acw62.createElement("span", null, label) : label;
    }, [
        label,
        icon
    ]);
    var node = /*#__PURE__*/ $acw62.createElement("div", {
        key: key,
        "data-node-key": (0, $099b8f1c61d35623$export$c55417729a96230c)(key),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(tabPrefix, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(tabPrefix, "-with-remove"), removable), "".concat(tabPrefix, "-active"), active), "".concat(tabPrefix, "-disabled"), disabled)),
        style: style,
        onClick: onInternalClick
    }, /*#__PURE__*/ $acw62.createElement("div", {
        role: "tab",
        "aria-selected": active,
        id: id && "".concat(id, "-tab-").concat(key),
        className: "".concat(tabPrefix, "-btn"),
        "aria-controls": id && "".concat(id, "-panel-").concat(key),
        "aria-disabled": disabled,
        tabIndex: disabled ? null : 0,
        onClick: function onClick(e) {
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            if ([
                (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).SPACE,
                (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER
            ].includes(e.which)) {
                e.preventDefault();
                onInternalClick(e);
            }
        },
        onFocus: onFocus
    }, icon && /*#__PURE__*/ $acw62.createElement("span", {
        className: "".concat(tabPrefix, "-icon")
    }, icon), label && labelNode), removable && /*#__PURE__*/ $acw62.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || "remove",
        tabIndex: 0,
        className: "".concat(tabPrefix, "-remove"),
        onClick: function onClick(e) {
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $05c6b22b26939e9e$export$2e2bcd8739ae039 = $05c6b22b26939e9e$var$TabNode;


var $251c9e7122a85d75$var$getTabSize = function getTabSize(tab, containerRect) {
    // tabListRef
    var offsetWidth = tab.offsetWidth, offsetHeight = tab.offsetHeight, offsetTop = tab.offsetTop, offsetLeft = tab.offsetLeft;
    var _tab$getBoundingClien = tab.getBoundingClientRect(), width = _tab$getBoundingClien.width, height = _tab$getBoundingClien.height, x = _tab$getBoundingClien.x, y = _tab$getBoundingClien.y;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        x - containerRect.x,
        y - containerRect.y
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
var $251c9e7122a85d75$var$getSize = function getSize(refObj) {
    var _ref = refObj.current || {}, _ref$offsetWidth = _ref.offsetWidth, offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth, _ref$offsetHeight = _ref.offsetHeight, offsetHeight = _ref$offsetHeight === void 0 ? 0 : _ref$offsetHeight;
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        var _refObj$current$getBo = refObj.current.getBoundingClientRect(), width = _refObj$current$getBo.width, height = _refObj$current$getBo.height;
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ var $251c9e7122a85d75$var$getUnitValue = function getUnitValue(size, tabPositionTopOrBottom) {
    return size[tabPositionTopOrBottom ? 0 : 1];
};
var $251c9e7122a85d75$var$TabNavList = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var className = props.className, style = props.style, id = props.id, animated = props.animated, activeKey = props.activeKey, rtl = props.rtl, extra = props.extra, editable = props.editable, locale = props.locale, tabPosition = props.tabPosition, tabBarGutter = props.tabBarGutter, children = props.children, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, indicator = props.indicator;
    var _React$useContext = $acw62.useContext((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var containerRef = (0, $acw62.useRef)(null);
    var extraLeftRef = (0, $acw62.useRef)(null);
    var extraRightRef = (0, $acw62.useRef)(null);
    var tabsWrapperRef = (0, $acw62.useRef)(null);
    var tabListRef = (0, $acw62.useRef)(null);
    var operationsRef = (0, $acw62.useRef)(null);
    var innerAddButtonRef = (0, $acw62.useRef)(null);
    var tabPositionTopOrBottom = tabPosition === "top" || tabPosition === "bottom";
    var _useSyncState = (0, $f1c0f3be6d5fa93f$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "left" : "right"
        });
    }), _useSyncState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useSyncState, 2), transformLeft = _useSyncState2[0], setTransformLeft = _useSyncState2[1];
    var _useSyncState3 = (0, $f1c0f3be6d5fa93f$export$2e2bcd8739ae039)(0, function(next, prev) {
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "top" : "bottom"
        });
    }), _useSyncState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useSyncState3, 2), transformTop = _useSyncState4[0], setTransformTop = _useSyncState4[1];
    var _useState = (0, $acw62.useState)([
        0,
        0
    ]), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), containerExcludeExtraSize = _useState2[0], setContainerExcludeExtraSize = _useState2[1];
    var _useState3 = (0, $acw62.useState)([
        0,
        0
    ]), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), tabContentSize = _useState4[0], setTabContentSize = _useState4[1];
    var _useState5 = (0, $acw62.useState)([
        0,
        0
    ]), _useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState5, 2), addSize = _useState6[0], setAddSize = _useState6[1];
    var _useState7 = (0, $acw62.useState)([
        0,
        0
    ]), _useState8 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState7, 2), operationSize = _useState8[0], setOperationSize = _useState8[1];
    var _useUpdateState = (0, $6bb369ac1283ea97$export$aefd2a30eb6d999e)(new Map()), _useUpdateState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useUpdateState, 2), tabSizes = _useUpdateState2[0], setTabSizes = _useUpdateState2[1];
    var tabOffsets = (0, $fea37cf40acfe645$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    var containerExcludeExtraSizeValue = $251c9e7122a85d75$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    var tabContentSizeValue = $251c9e7122a85d75$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    var addSizeValue = $251c9e7122a85d75$var$getUnitValue(addSize, tabPositionTopOrBottom);
    var operationSizeValue = $251c9e7122a85d75$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    var needScroll = containerExcludeExtraSizeValue < tabContentSizeValue + addSizeValue;
    var visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    var operationsHiddenClassName = "".concat(prefixCls, "-nav-operations-hidden");
    var transformMin = 0;
    var transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    var touchMovingRef = (0, $acw62.useRef)(null);
    var _useState9 = (0, $acw62.useState)(), _useState10 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState9, 2), lockAnimation = _useState10[0], setLockAnimation = _useState10[1];
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $bd298a079d025635$export$2e2bcd8739ae039)(tabsWrapperRef, function(offsetX, offsetY) {
        function doMove(setState, offset) {
            setState(function(value) {
                var newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $acw62.useEffect)(function() {
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(function() {
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    var _useVisibleRange = (0, $1e3cbc4ab07e0147$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, props), {}, {
        tabs: tabs
    })), _useVisibleRange2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useVisibleRange, 2), visibleStart = _useVisibleRange2[0], visibleEnd = _useVisibleRange2[1];
    // ========================= Scroll ========================
    var scrollToTab = (0, $01e43e72865dc583$export$2e2bcd8739ae039)(function() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : activeKey;
        var tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            var newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            var _newTransform = transformTop;
            if (tabOffset.top < -transformTop) _newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) _newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(_newTransform));
        }
    });
    // ========================== Tab ==========================
    var tabNodeStyle = {};
    if (tabPosition === "top" || tabPosition === "bottom") tabNodeStyle[rtl ? "marginRight" : "marginLeft"] = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    var tabNodes = tabs.map(function(tab, i) {
        var key = tab.key;
        return /*#__PURE__*/ $acw62.createElement((0, $05c6b22b26939e9e$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            style: i === 0 ? undefined : tabNodeStyle,
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            renderWrapper: children,
            removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
            onClick: function onClick(e) {
                onTabClick(key, e);
            },
            onFocus: function onFocus() {
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            }
        });
    });
    // Update buttons records
    var updateTabSizes = function updateTabSizes() {
        return setTabSizes(function() {
            var _tabListRef$current;
            var newSizes = new Map();
            var listRect = (_tabListRef$current = tabListRef.current) === null || _tabListRef$current === void 0 ? void 0 : _tabListRef$current.getBoundingClientRect();
            tabs.forEach(function(_ref2) {
                var _tabListRef$current2;
                var key = _ref2.key;
                var btnNode = (_tabListRef$current2 = tabListRef.current) === null || _tabListRef$current2 === void 0 ? void 0 : _tabListRef$current2.querySelector('[data-node-key="'.concat((0, $099b8f1c61d35623$export$c55417729a96230c)(key), '"]'));
                if (btnNode) {
                    var _getTabSize = $251c9e7122a85d75$var$getTabSize(btnNode, listRect), _getTabSize2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_getTabSize, 4), width = _getTabSize2[0], height = _getTabSize2[1], left = _getTabSize2[2], top = _getTabSize2[3];
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    };
    (0, $acw62.useEffect)(function() {
        updateTabSizes();
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_")
    ]);
    var onListHolderResize = (0, $6bb369ac1283ea97$export$2e2bcd8739ae039)(function() {
        // Update wrapper records
        var containerSize = $251c9e7122a85d75$var$getSize(containerRef);
        var extraLeftSize = $251c9e7122a85d75$var$getSize(extraLeftRef);
        var extraRightSize = $251c9e7122a85d75$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        var newAddSize = $251c9e7122a85d75$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        var newOperationSize = $251c9e7122a85d75$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        var tabContentFullSize = $251c9e7122a85d75$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    var startHiddenTabs = tabs.slice(0, visibleStart);
    var endHiddenTabs = tabs.slice(visibleEnd + 1);
    var hiddenTabs = [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(startHiddenTabs), (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(endHiddenTabs));
    // =================== Link & Operations ===================
    var activeTabOffset = tabOffsets.get(activeKey);
    var _useIndicator = (0, $d6c5d05385b01772$export$2e2bcd8739ae039)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        indicator: indicator,
        rtl: rtl
    }), indicatorStyle = _useIndicator.style;
    // ========================= Effect ========================
    (0, $acw62.useEffect)(function() {
        scrollToTab();
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $099b8f1c61d35623$export$fac44ee5b035f737)(activeTabOffset),
        (0, $099b8f1c61d35623$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $acw62.useEffect)(function() {
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    var hasDropdown = !!hiddenTabs.length;
    var wrapPrefix = "".concat(prefixCls, "-nav-wrap");
    var pingLeft;
    var pingRight;
    var pingTop;
    var pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: (0, $5e297877593af644$export$1d1c999670a1285d)(ref, containerRef),
        role: "tablist",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-nav"), className),
        style: style,
        onKeyDown: function onKeyDown() {
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $acw62.createElement((0, $f179037cdfb41409$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(wrapPrefix, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(wrapPrefix, "-ping-left"), pingLeft), "".concat(wrapPrefix, "-ping-right"), pingRight), "".concat(wrapPrefix, "-ping-top"), pingTop), "".concat(wrapPrefix, "-ping-bottom"), pingBottom)),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $acw62.createElement("div", {
        ref: tabListRef,
        className: "".concat(prefixCls, "-nav-list"),
        style: {
            transform: "translate(".concat(transformLeft, "px, ").concat(transformTop, "px)"),
            transition: lockAnimation ? "none" : undefined
        }
    }, tabNodes, /*#__PURE__*/ $acw62.createElement((0, $034d4b5b2135dc44$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, tabNodes.length === 0 ? undefined : tabNodeStyle), {}, {
            visibility: hasDropdown ? "hidden" : null
        })
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-ink-bar"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-ink-bar-animated"), animated.inkBar)),
        style: indicatorStyle
    }))))), /*#__PURE__*/ $acw62.createElement((0, $7e96fc940147fd66$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        removeAriaLabel: locale === null || locale === void 0 ? void 0 : locale.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $acw62.createElement((0, $f179037cdfb41409$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $251c9e7122a85d75$export$2e2bcd8739ae039 = $251c9e7122a85d75$var$TabNavList;





var $acw62 = parcelRequire("acw62");
var $32b6ebe184c19bb6$var$TabPane = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, className = props.className, style = props.style, id = props.id, active = props.active, tabKey = props.tabKey, children = props.children;
    return /*#__PURE__*/ $acw62.createElement("div", {
        id: id && "".concat(id, "-panel-").concat(tabKey),
        role: "tabpanel",
        tabIndex: active ? 0 : -1,
        "aria-labelledby": id && "".concat(id, "-tab-").concat(tabKey),
        "aria-hidden": !active,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, active && "".concat(prefixCls, "-active"), className),
        ref: ref
    }, children);
});
var $32b6ebe184c19bb6$export$2e2bcd8739ae039 = $32b6ebe184c19bb6$var$TabPane;


var $9e555564d15c1afa$var$_excluded = [
    "renderTabBar"
], $9e555564d15c1afa$var$_excluded2 = [
    "label",
    "key"
];
// We have to create a TabNavList components.
var $9e555564d15c1afa$var$TabNavListWrapper = function TabNavListWrapper(_ref) {
    var renderTabBar = _ref.renderTabBar, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $9e555564d15c1afa$var$_excluded);
    var _React$useContext = $acw62.useContext((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039)), tabs = _React$useContext.tabs;
    if (renderTabBar) {
        var tabNavBarProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, restProps), {}, {
            // Legacy support. We do not use this actually
            panes: tabs.map(function(_ref2) {
                var label = _ref2.label, key = _ref2.key, restTabProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref2, $9e555564d15c1afa$var$_excluded2);
                return /*#__PURE__*/ $acw62.createElement((0, $32b6ebe184c19bb6$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    tab: label,
                    key: key,
                    tabKey: key
                }, restTabProps));
            })
        });
        return renderTabBar(tabNavBarProps, (0, $251c9e7122a85d75$export$2e2bcd8739ae039));
    }
    return /*#__PURE__*/ $acw62.createElement((0, $251c9e7122a85d75$export$2e2bcd8739ae039), restProps);
};
var $9e555564d15c1afa$export$2e2bcd8739ae039 = $9e555564d15c1afa$var$TabNavListWrapper;









var $acw62 = parcelRequire("acw62");


var $8a40c3051886a790$var$_excluded = [
    "key",
    "forceRender",
    "style",
    "className",
    "destroyInactiveTabPane"
];
var $8a40c3051886a790$var$TabPanelList = function TabPanelList(props) {
    var id = props.id, activeKey = props.activeKey, animated = props.animated, tabPosition = props.tabPosition, destroyInactiveTabPane = props.destroyInactiveTabPane;
    var _React$useContext = $acw62.useContext((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039)), prefixCls = _React$useContext.prefixCls, tabs = _React$useContext.tabs;
    var tabPaneAnimated = animated.tabPane;
    var tabPanePrefixCls = "".concat(prefixCls, "-tabpane");
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content-holder"))
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-content"), "".concat(prefixCls, "-content-").concat(tabPosition), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-content-animated"), tabPaneAnimated))
    }, tabs.map(function(item) {
        var key = item.key, forceRender = item.forceRender, paneStyle = item.style, paneClassName = item.className, itemDestroyInactiveTabPane = item.destroyInactiveTabPane, restTabProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(item, $8a40c3051886a790$var$_excluded);
        var active = key === activeKey;
        return /*#__PURE__*/ $acw62.createElement((0, $609e894acbce1933$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyInactiveTabPane || itemDestroyInactiveTabPane),
            leavedClassName: "".concat(tabPanePrefixCls, "-hidden")
        }, animated.tabPaneMotion), function(_ref, ref) {
            var motionStyle = _ref.style, motionClassName = _ref.className;
            return /*#__PURE__*/ $acw62.createElement((0, $32b6ebe184c19bb6$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restTabProps, {
                prefixCls: tabPanePrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, paneStyle), motionStyle),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(paneClassName, motionClassName),
                ref: ref
            }));
        });
    })));
};
var $8a40c3051886a790$export$2e2bcd8739ae039 = $8a40c3051886a790$var$TabPanelList;





function $8ba1fa9e00219fcd$export$2e2bcd8739ae039() {
    var animated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        inkBar: true,
        tabPane: false
    };
    var mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({
        inkBar: true
    }, (0, $b8f57191916382d3$export$2e2bcd8739ae039)(animated) === "object" ? animated : {});
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}


var $31c9762e836450cf$var$_excluded = [
    "id",
    "prefixCls",
    "className",
    "items",
    "direction",
    "activeKey",
    "defaultActiveKey",
    "editable",
    "animated",
    "tabPosition",
    "tabBarGutter",
    "tabBarStyle",
    "tabBarExtraContent",
    "locale",
    "more",
    "destroyInactiveTabPane",
    "renderTabBar",
    "onChange",
    "onTabClick",
    "onTabScroll",
    "getPopupContainer",
    "popupClassName",
    "indicator"
];
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
var $31c9762e836450cf$var$uuid = 0;
var $31c9762e836450cf$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var id = props.id, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tabs" : _props$prefixCls, className = props.className, items = props.items, direction = props.direction, activeKey = props.activeKey, defaultActiveKey = props.defaultActiveKey, editable = props.editable, animated = props.animated, _props$tabPosition = props.tabPosition, tabPosition = _props$tabPosition === void 0 ? "top" : _props$tabPosition, tabBarGutter = props.tabBarGutter, tabBarStyle = props.tabBarStyle, tabBarExtraContent = props.tabBarExtraContent, locale = props.locale, more = props.more, destroyInactiveTabPane = props.destroyInactiveTabPane, renderTabBar = props.renderTabBar, onChange = props.onChange, onTabClick = props.onTabClick, onTabScroll = props.onTabScroll, getPopupContainer = props.getPopupContainer, popupClassName = props.popupClassName, indicator = props.indicator, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $31c9762e836450cf$var$_excluded);
    var tabs = $acw62.useMemo(function() {
        return (items || []).filter(function(item) {
            return item && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(item) === "object" && "key" in item;
        });
    }, [
        items
    ]);
    var rtl = direction === "rtl";
    var mergedAnimated = (0, $8ba1fa9e00219fcd$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    var _useState = (0, $acw62.useState)(false), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), mobile = _useState2[0], setMobile = _useState2[1];
    (0, $acw62.useEffect)(function() {
        // Only update on the client side
        setMobile((0, $066d1680709fcf3c$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    var _useMergedState = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(function() {
        var _tabs$;
        return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.key;
    }, {
        value: activeKey,
        defaultValue: defaultActiveKey
    }), _useMergedState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState, 2), mergedActiveKey = _useMergedState2[0], setMergedActiveKey = _useMergedState2[1];
    var _useState3 = (0, $acw62.useState)(function() {
        return tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
    }), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), activeIndex = _useState4[0], setActiveIndex = _useState4[1];
    // Reset active key if not exist anymore
    (0, $acw62.useEffect)(function() {
        var newActiveIndex = tabs.findIndex(function(tab) {
            return tab.key === mergedActiveKey;
        });
        if (newActiveIndex === -1) {
            var _tabs$newActiveIndex;
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey((_tabs$newActiveIndex = tabs[newActiveIndex]) === null || _tabs$newActiveIndex === void 0 ? void 0 : _tabs$newActiveIndex.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map(function(tab) {
            return tab.key;
        }).join("_"),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    var _useMergedState3 = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(null, {
        value: id
    }), _useMergedState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useMergedState3, 2), mergedId = _useMergedState4[0], setMergedId = _useMergedState4[1];
    // Async generate id to avoid ssr mapping failed
    (0, $acw62.useEffect)(function() {
        if (!id) {
            setMergedId("rc-tabs-".concat($31c9762e836450cf$var$uuid));
            $31c9762e836450cf$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick === null || onTabClick === void 0 || onTabClick(key, e);
        var isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange === null || onChange === void 0 || onChange(key);
    }
    // ======================== Render ========================
    var sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    var tabNavBarProps = (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, sharedProps), {}, {
        editable: editable,
        locale: locale,
        more: more,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        panes: null,
        getPopupContainer: getPopupContainer,
        popupClassName: popupClassName,
        indicator: indicator
    });
    return /*#__PURE__*/ $acw62.createElement((0, $bb2ee1e3f89d10a5$export$2e2bcd8739ae039).Provider, {
        value: {
            tabs: tabs,
            prefixCls: prefixCls
        }
    }, /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, "".concat(prefixCls, "-").concat(tabPosition), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-mobile"), mobile), "".concat(prefixCls, "-editable"), editable), "".concat(prefixCls, "-rtl"), rtl), className)
    }, restProps), /*#__PURE__*/ $acw62.createElement((0, $9e555564d15c1afa$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $acw62.createElement((0, $8a40c3051886a790$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        destroyInactiveTabPane: destroyInactiveTabPane
    }, sharedProps, {
        animated: mergedAnimated
    }))));
});
var $31c9762e836450cf$export$2e2bcd8739ae039 = $31c9762e836450cf$var$Tabs;


var $a66b746dc2ee365b$export$2e2bcd8739ae039 = (0, $31c9762e836450cf$export$2e2bcd8739ae039);







const $eb61855ec5fb79d5$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $eb61855ec5fb79d5$export$2e2bcd8739ae039(prefixCls) {
    let animated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        inkBar: true,
        tabPane: false
    };
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = Object.assign({
        inkBar: true
    }, typeof animated === "object" ? animated : {});
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = Object.assign(Object.assign({}, $eb61855ec5fb79d5$var$motion), {
        motionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(prefixCls, "switch")
    });
    return mergedAnimated;
}



var $acw62 = parcelRequire("acw62");


var $364487f9f614b61c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $364487f9f614b61c$var$filter(items) {
    return items.filter((item)=>item);
}
function $364487f9f614b61c$export$2e2bcd8739ae039(items, children) {
    if (items) return items;
    const childrenItems = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children).map((node)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(node)) {
            const { key: key, props: props } = node;
            const _a = props || {}, { tab: tab } = _a, restProps = $364487f9f614b61c$var$__rest(_a, [
                "tab"
            ]);
            const item = Object.assign(Object.assign({
                key: String(key)
            }, restProps), {
                label: tab
            });
            return item;
        }
        return null;
    });
    return $364487f9f614b61c$var$filter(childrenItems);
}






const $9d9811f30568fd64$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return [
        {
            [componentCls]: {
                [`${componentCls}-switch`]: {
                    "&-appear, &-enter": {
                        transition: "none",
                        "&-start": {
                            opacity: 0
                        },
                        "&-active": {
                            opacity: 1,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    },
                    "&-leave": {
                        position: "absolute",
                        transition: "none",
                        inset: 0,
                        "&-start": {
                            opacity: 1
                        },
                        "&-active": {
                            opacity: 0,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, "slide-up"),
            (0, $f8b44896cb986807$export$9018e60daecf7a6c)(token, "slide-down")
        ]
    ];
};
var $9d9811f30568fd64$export$2e2bcd8739ae039 = $9d9811f30568fd64$var$genMotionStyle;


const $5cc245dd2cc46dea$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardBg: cardBg, cardGutter: cardGutter, colorBorderSecondary: colorBorderSecondary, itemSelectedColor: itemSelectedColor } = token;
    return {
        [`${componentCls}-card`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: 0,
                    padding: tabsCardPadding,
                    background: cardBg,
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
                },
                [`${componentCls}-tab-active`]: {
                    color: itemSelectedColor,
                    background: token.colorBgContainer
                },
                [`${componentCls}-ink-bar`]: {
                    visibility: "hidden"
                }
            },
            // ========================== Top & Bottom ==========================
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $f97444ff16d95e90$export$523c0b569236b342)(cardGutter)
                        }
                    }
                }
            },
            [`&${componentCls}-top`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderBottomColor: token.colorBgContainer
                    }
                }
            },
            [`&${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)}`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderTopColor: token.colorBgContainer
                    }
                }
            },
            // ========================== Left & Right ==========================
            [`&${componentCls}-left, &${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginTop: (0, $f97444ff16d95e90$export$523c0b569236b342)(cardGutter)
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)}`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderRightColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderLeftColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genDropdownStyle = (token)=>{
    const { componentCls: componentCls, itemHoverColor: itemHoverColor, dropdownEdgeChildVerticalPadding: dropdownEdgeChildVerticalPadding } = token;
    return {
        [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "absolute",
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: token.zIndexPopup,
            display: "block",
            "&-hidden": {
                display: "none"
            },
            [`${componentCls}-dropdown-menu`]: {
                maxHeight: token.tabsDropdownHeight,
                margin: 0,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(dropdownEdgeChildVerticalPadding)} 0`,
                overflowX: "hidden",
                overflowY: "auto",
                textAlign: {
                    _skip_check_: true,
                    value: "left"
                },
                listStyleType: "none",
                backgroundColor: token.colorBgContainer,
                backgroundClip: "padding-box",
                borderRadius: token.borderRadiusLG,
                outline: "none",
                boxShadow: token.boxShadowSecondary,
                "&-item": Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                    display: "flex",
                    alignItems: "center",
                    minWidth: token.tabsDropdownWidth,
                    margin: 0,
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXXS)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingSM)}`,
                    color: token.colorText,
                    fontWeight: "normal",
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    cursor: "pointer",
                    transition: `all ${token.motionDurationSlow}`,
                    "> span": {
                        flex: 1,
                        whiteSpace: "nowrap"
                    },
                    "&-remove": {
                        flex: "none",
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        },
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        background: "transparent",
                        border: 0,
                        cursor: "pointer",
                        "&:hover": {
                            color: itemHoverColor
                        }
                    },
                    "&:hover": {
                        background: token.controlItemBgHover
                    },
                    "&-disabled": {
                        "&, &:hover": {
                            color: token.colorTextDisabled,
                            background: "transparent",
                            cursor: "not-allowed"
                        }
                    }
                })
            }
        })
    };
};
const $5cc245dd2cc46dea$var$genPositionStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, colorBorderSecondary: colorBorderSecondary, horizontalMargin: horizontalMargin, verticalItemPadding: verticalItemPadding, verticalItemMargin: verticalItemMargin, calc: calc } = token;
    return {
        // ========================== Top & Bottom ==========================
        [`${componentCls}-top, ${componentCls}-bottom`]: {
            flexDirection: "column",
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                margin: horizontalMargin,
                "&::before": {
                    position: "absolute",
                    right: {
                        _skip_check_: true,
                        value: 0
                    },
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    content: "''"
                },
                [`${componentCls}-ink-bar`]: {
                    height: token.lineWidthBold,
                    "&-animated": {
                        transition: `width ${token.motionDurationSlow}, left ${token.motionDurationSlow},
            right ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-wrap`]: {
                    "&::before, &::after": {
                        top: 0,
                        bottom: 0,
                        width: token.controlHeight
                    },
                    "&::before": {
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowLeft
                    },
                    "&::after": {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowRight
                    },
                    [`&${componentCls}-nav-wrap-ping-left::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-right::after`]: {
                        opacity: 1
                    }
                }
            }
        },
        [`${componentCls}-top`]: {
            [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
                "&::before": {
                    bottom: 0
                },
                [`${componentCls}-ink-bar`]: {
                    bottom: 0
                }
            }
        },
        [`${componentCls}-bottom`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                marginTop: margin,
                marginBottom: 0,
                "&::before": {
                    top: 0
                },
                [`${componentCls}-ink-bar`]: {
                    top: 0
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0
            }
        },
        // ========================== Left & Right ==========================
        [`${componentCls}-left, ${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                flexDirection: "column",
                minWidth: calc(token.controlHeight).mul(1.25).equal(),
                // >>>>>>>>>>> Tab
                [`${componentCls}-tab`]: {
                    padding: verticalItemPadding,
                    textAlign: "center"
                },
                [`${componentCls}-tab + ${componentCls}-tab`]: {
                    margin: verticalItemMargin
                },
                // >>>>>>>>>>> Nav
                [`${componentCls}-nav-wrap`]: {
                    flexDirection: "column",
                    "&::before, &::after": {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.controlHeight
                    },
                    "&::before": {
                        top: 0,
                        boxShadow: token.boxShadowTabsOverflowTop
                    },
                    "&::after": {
                        bottom: 0,
                        boxShadow: token.boxShadowTabsOverflowBottom
                    },
                    [`&${componentCls}-nav-wrap-ping-top::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
                        opacity: 1
                    }
                },
                // >>>>>>>>>>> Ink Bar
                [`${componentCls}-ink-bar`]: {
                    width: token.lineWidthBold,
                    "&-animated": {
                        transition: `height ${token.motionDurationSlow}, top ${token.motionDurationSlow}`
                    }
                },
                [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
                    flex: "1 0 auto",
                    // fix safari scroll problem
                    flexDirection: "column"
                }
            }
        },
        [`${componentCls}-left`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-ink-bar`]: {
                    right: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                marginLeft: {
                    _skip_check_: true,
                    value: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.lineWidth).mul(-1).equal())
                },
                borderLeft: {
                    _skip_check_: true,
                    value: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingLeft: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        },
        [`${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                [`${componentCls}-ink-bar`]: {
                    left: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-content-holder, > div > ${componentCls}-content-holder`]: {
                order: 0,
                marginRight: {
                    _skip_check_: true,
                    value: calc(token.lineWidth).mul(-1).equal()
                },
                borderRight: {
                    _skip_check_: true,
                    value: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-content > ${componentCls}-tabpane`]: {
                    paddingRight: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, cardPaddingLG: cardPaddingLG, horizontalItemPaddingSM: horizontalItemPaddingSM, horizontalItemPaddingLG: horizontalItemPaddingLG } = token;
    return {
        [componentCls]: {
            "&-small": {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingSM,
                        fontSize: token.titleFontSizeSM
                    }
                }
            },
            "&-large": {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingLG,
                        fontSize: token.titleFontSizeLG
                    }
                }
            }
        },
        [`${componentCls}-card`]: {
            [`&${componentCls}-small`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingSM
                    }
                },
                [`&${componentCls}-bottom`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)}`
                    }
                },
                [`&${componentCls}-top`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)} 0 0`
                    }
                },
                [`&${componentCls}-right`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)} 0`
                        }
                    }
                },
                [`&${componentCls}-left`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)} 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadius)}`
                        }
                    }
                }
            },
            [`&${componentCls}-large`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingLG
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genTabStyle = (token)=>{
    const { componentCls: componentCls, itemActiveColor: itemActiveColor, itemHoverColor: itemHoverColor, iconCls: iconCls, tabsHorizontalItemMargin: tabsHorizontalItemMargin, horizontalItemPadding: horizontalItemPadding, itemSelectedColor: itemSelectedColor, itemColor: itemColor } = token;
    const tabCls = `${componentCls}-tab`;
    return {
        [tabCls]: {
            position: "relative",
            WebkitTouchCallout: "none",
            WebkitTapHighlightColor: "transparent",
            display: "inline-flex",
            alignItems: "center",
            padding: horizontalItemPadding,
            fontSize: token.titleFontSize,
            background: "transparent",
            border: 0,
            outline: "none",
            cursor: "pointer",
            color: itemColor,
            "&-btn, &-remove": Object.assign({
                "&:focus:not(:focus-visible), &:active": {
                    color: itemActiveColor
                }
            }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token)),
            "&-btn": {
                outline: "none",
                transition: `all ${token.motionDurationSlow}`,
                [`${tabCls}-icon:not(:last-child)`]: {
                    marginInlineEnd: token.marginSM
                }
            },
            "&-remove": {
                flex: "none",
                marginRight: {
                    _skip_check_: true,
                    value: token.calc(token.marginXXS).mul(-1).equal()
                },
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginXS
                },
                color: token.colorTextDescription,
                fontSize: token.fontSizeSM,
                background: "transparent",
                border: "none",
                outline: "none",
                cursor: "pointer",
                transition: `all ${token.motionDurationSlow}`,
                "&:hover": {
                    color: token.colorTextHeading
                }
            },
            "&:hover": {
                color: itemHoverColor
            },
            [`&${tabCls}-active ${tabCls}-btn`]: {
                color: itemSelectedColor,
                textShadow: token.tabsActiveTextShadow
            },
            [`&${tabCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed"
            },
            [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
                "&:focus, &:active": {
                    color: token.colorTextDisabled
                }
            },
            [`& ${tabCls}-remove ${iconCls}`]: {
                margin: 0
            },
            [`${iconCls}:not(:last-child)`]: {
                marginRight: {
                    _skip_check_: true,
                    value: token.marginSM
                }
            }
        },
        [`${tabCls} + ${tabCls}`]: {
            margin: {
                _skip_check_: true,
                value: tabsHorizontalItemMargin
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls, tabsHorizontalItemMarginRTL: tabsHorizontalItemMarginRTL, iconCls: iconCls, cardGutter: cardGutter, calc: calc } = token;
    const rtlCls = `${componentCls}-rtl`;
    return {
        [rtlCls]: {
            direction: "rtl",
            [`${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: {
                        _skip_check_: true,
                        value: tabsHorizontalItemMarginRTL
                    },
                    [`${componentCls}-tab:last-of-type`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    },
                    [iconCls]: {
                        marginRight: {
                            _skip_check_: true,
                            value: 0
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginSM)
                        }
                    },
                    [`${componentCls}-tab-remove`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXS)
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $f97444ff16d95e90$export$523c0b569236b342)(calc(token.marginXXS).mul(-1).equal())
                        },
                        [iconCls]: {
                            margin: 0
                        }
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav`]: {
                    order: 1
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 0
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav`]: {
                    order: 0
                },
                [`> ${componentCls}-content-holder`]: {
                    order: 1
                }
            },
            // ====================== Card ======================
            [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: cardGutter
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    }
                }
            }
        },
        [`${componentCls}-dropdown-rtl`]: {
            direction: "rtl"
        },
        [`${componentCls}-menu-item`]: {
            [`${componentCls}-dropdown-rtl`]: {
                textAlign: {
                    _skip_check_: true,
                    value: "right"
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$var$genTabsStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardHeight: cardHeight, cardGutter: cardGutter, itemHoverColor: itemHoverColor, itemActiveColor: itemActiveColor, colorBorderSecondary: colorBorderSecondary } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            display: "flex",
            // ========================== Navigation ==========================
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                position: "relative",
                display: "flex",
                flex: "none",
                alignItems: "center",
                [`${componentCls}-nav-wrap`]: {
                    position: "relative",
                    display: "flex",
                    flex: "auto",
                    alignSelf: "stretch",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    transform: "translate(0)",
                    // Fix chrome render bug
                    // >>>>> Ping shadow
                    "&::before, &::after": {
                        position: "absolute",
                        zIndex: 1,
                        opacity: 0,
                        transition: `opacity ${token.motionDurationSlow}`,
                        content: "''",
                        pointerEvents: "none"
                    }
                },
                [`${componentCls}-nav-list`]: {
                    position: "relative",
                    display: "flex",
                    transition: `opacity ${token.motionDurationSlow}`
                },
                // >>>>>>>> Operations
                [`${componentCls}-nav-operations`]: {
                    display: "flex",
                    alignSelf: "stretch"
                },
                [`${componentCls}-nav-operations-hidden`]: {
                    position: "absolute",
                    visibility: "hidden",
                    pointerEvents: "none"
                },
                [`${componentCls}-nav-more`]: {
                    position: "relative",
                    padding: tabsCardPadding,
                    background: "transparent",
                    border: 0,
                    color: token.colorText,
                    "&::after": {
                        position: "absolute",
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        bottom: 0,
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.calc(token.controlHeightLG).div(8).equal(),
                        transform: "translateY(100%)",
                        content: "''"
                    }
                },
                [`${componentCls}-nav-add`]: Object.assign({
                    minWidth: cardHeight,
                    minHeight: cardHeight,
                    marginLeft: {
                        _skip_check_: true,
                        value: cardGutter
                    },
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)}`,
                    background: "transparent",
                    border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    outline: "none",
                    cursor: "pointer",
                    color: token.colorText,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                    "&:hover": {
                        color: itemHoverColor
                    },
                    "&:active, &:focus:not(:focus-visible)": {
                        color: itemActiveColor
                    }
                }, (0, $4733a3b3eb18f80d$export$a44db842bcb28231)(token))
            },
            [`${componentCls}-extra-content`]: {
                flex: "none"
            },
            // ============================ InkBar ============================
            [`${componentCls}-ink-bar`]: {
                position: "absolute",
                background: token.inkBarColor,
                pointerEvents: "none"
            }
        }), $5cc245dd2cc46dea$var$genTabStyle(token)), {
            // =========================== TabPanes ===========================
            [`${componentCls}-content`]: {
                position: "relative",
                width: "100%"
            },
            [`${componentCls}-content-holder`]: {
                flex: "auto",
                minWidth: 0,
                minHeight: 0
            },
            [`${componentCls}-tabpane`]: {
                outline: "none",
                "&-hidden": {
                    display: "none"
                }
            }
        }),
        [`${componentCls}-centered`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-nav-wrap`]: {
                    [`&:not([class*='${componentCls}-nav-wrap-ping'])`]: {
                        justifyContent: "center"
                    }
                }
            }
        }
    };
};
const $5cc245dd2cc46dea$export$9ca1be8807fe0675 = (token)=>{
    const cardHeight = token.controlHeightLG;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        cardHeight: cardHeight,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: `${(cardHeight - Math.round(token.fontSize * token.lineHeight)) / 2 - token.lineWidth}px ${token.padding}px`,
        cardPaddingSM: `${token.paddingXXS * 1.5}px ${token.padding}px`,
        cardPaddingLG: `${token.paddingXS}px ${token.padding}px ${token.paddingXXS * 1.5}px`,
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: `0 0 ${token.margin}px 0`,
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: ``,
        horizontalItemMarginRTL: ``,
        horizontalItemPadding: `${token.paddingSM}px 0`,
        horizontalItemPaddingSM: `${token.paddingXS}px 0`,
        horizontalItemPaddingLG: `${token.padding}px 0`,
        verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
        verticalItemMargin: `${token.margin}px 0 0 0`,
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$5cc245dd2cc46dea$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Tabs", (token)=>{
    const tabsToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsActiveTextShadow: "0 0 0.25px currentcolor",
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.horizontalItemGutter)}`,
        tabsHorizontalItemMarginRTL: `0 0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.horizontalItemGutter)}`
    });
    return [
        $5cc245dd2cc46dea$var$genSizeStyle(tabsToken),
        $5cc245dd2cc46dea$var$genRtlStyle(tabsToken),
        $5cc245dd2cc46dea$var$genPositionStyle(tabsToken),
        $5cc245dd2cc46dea$var$genDropdownStyle(tabsToken),
        $5cc245dd2cc46dea$var$genCardStyle(tabsToken),
        $5cc245dd2cc46dea$var$genTabsStyle(tabsToken),
        (0, $9d9811f30568fd64$export$2e2bcd8739ae039)(tabsToken)
    ];
}, $5cc245dd2cc46dea$export$9ca1be8807fe0675);


const $4c89efaaf6882e88$var$TabPane = ()=>null;
var $4c89efaaf6882e88$export$2e2bcd8739ae039 = $4c89efaaf6882e88$var$TabPane;


"use client";
var $389d763730796d58$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $389d763730796d58$var$Tabs = (props)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { type: type, className: className, rootClassName: rootClassName, size: customSize, onEdit: onEdit, hideAdd: hideAdd, centered: centered, addIcon: addIcon, removeIcon: removeIcon, moreIcon: moreIcon, more: more, popupClassName: popupClassName, children: children, items: items, animated: animated, style: style, indicatorSize: indicatorSize, indicator: indicator } = props, otherProps = $389d763730796d58$var$__rest(props, [
        "type",
        "className",
        "rootClassName",
        "size",
        "onEdit",
        "hideAdd",
        "centered",
        "addIcon",
        "removeIcon",
        "moreIcon",
        "more",
        "popupClassName",
        "children",
        "items",
        "animated",
        "style",
        "indicatorSize",
        "indicator"
    ]);
    const { prefixCls: customizePrefixCls } = otherProps;
    const { direction: direction, tabs: tabs, getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("tabs", customizePrefixCls);
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $5cc245dd2cc46dea$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let editable;
    if (type === "editable-card") editable = {
        onEdit: (editType, _ref)=>{
            let { key: key, event: event } = _ref;
            onEdit === null || onEdit === void 0 || onEdit(editType === "add" ? event : key, editType);
        },
        removeIcon: (_a = removeIcon !== null && removeIcon !== void 0 ? removeIcon : tabs === null || tabs === void 0 ? void 0 : tabs.removeIcon) !== null && _a !== void 0 ? _a : /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), null),
        addIcon: (addIcon !== null && addIcon !== void 0 ? addIcon : tabs === null || tabs === void 0 ? void 0 : tabs.addIcon) || /*#__PURE__*/ $acw62.createElement((0, $61e4183d607620fc$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    const rootPrefixCls = getPrefixCls();
    const size = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customSize);
    const mergedItems = (0, $364487f9f614b61c$export$2e2bcd8739ae039)(items, children);
    const mergedAnimated = (0, $eb61855ec5fb79d5$export$2e2bcd8739ae039)(prefixCls, animated);
    const mergedStyle = Object.assign(Object.assign({}, tabs === null || tabs === void 0 ? void 0 : tabs.style), style);
    const mergedIndicator = {
        align: (_b = indicator === null || indicator === void 0 ? void 0 : indicator.align) !== null && _b !== void 0 ? _b : (_c = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _c === void 0 ? void 0 : _c.align,
        size: (_g = (_e = (_d = indicator === null || indicator === void 0 ? void 0 : indicator.size) !== null && _d !== void 0 ? _d : indicatorSize) !== null && _e !== void 0 ? _e : (_f = tabs === null || tabs === void 0 ? void 0 : tabs.indicator) === null || _f === void 0 ? void 0 : _f.size) !== null && _g !== void 0 ? _g : tabs === null || tabs === void 0 ? void 0 : tabs.indicatorSize
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $a66b746dc2ee365b$export$2e2bcd8739ae039), Object.assign({
        direction: direction,
        getPopupContainer: getPopupContainer
    }, otherProps, {
        items: mergedItems,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-${size}`]: size,
            [`${prefixCls}-card`]: [
                "card",
                "editable-card"
            ].includes(type),
            [`${prefixCls}-editable-card`]: type === "editable-card",
            [`${prefixCls}-centered`]: centered
        }, tabs === null || tabs === void 0 ? void 0 : tabs.className, className, rootClassName, hashId, cssVarCls, rootCls),
        popupClassName: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(popupClassName, hashId, cssVarCls, rootCls),
        style: mergedStyle,
        editable: editable,
        more: Object.assign({
            icon: (_l = (_k = (_j = (_h = tabs === null || tabs === void 0 ? void 0 : tabs.more) === null || _h === void 0 ? void 0 : _h.icon) !== null && _j !== void 0 ? _j : tabs === null || tabs === void 0 ? void 0 : tabs.moreIcon) !== null && _k !== void 0 ? _k : moreIcon) !== null && _l !== void 0 ? _l : /*#__PURE__*/ $acw62.createElement((0, $18b92a77e6b0d38f$export$2e2bcd8739ae039), null),
            transitionName: `${rootPrefixCls}-slide-up`
        }, more),
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicator: mergedIndicator
    })));
};
$389d763730796d58$var$Tabs.TabPane = (0, $4c89efaaf6882e88$export$2e2bcd8739ae039);
var $389d763730796d58$export$2e2bcd8739ae039 = $389d763730796d58$var$Tabs;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



const $c676d8b8b586adda$export$15e5fca53711d340 = (propValue)=>{
    if (!propValue) return null;
    return typeof propValue === "function" ? propValue() : propValue;
};







var $acw62 = parcelRequire("acw62");









const $7c34a58b2ba4d17c$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, boxShadowSecondary: boxShadowSecondary, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding } = token;
    return [
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                position: "absolute",
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: "normal",
                whiteSpace: "normal",
                textAlign: "start",
                cursor: "auto",
                userSelect: "text",
                transformOrigin: `var(--arrow-x, 50%) var(--arrow-y, 50%)`,
                "--antd-arrow-background-color": colorBgElevated,
                width: "max-content",
                maxWidth: "100vw",
                "&-rtl": {
                    direction: "rtl"
                },
                "&-hidden": {
                    display: "none"
                },
                [`${componentCls}-content`]: {
                    position: "relative"
                },
                [`${componentCls}-inner`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: "padding-box",
                    borderRadius: borderRadiusLG,
                    boxShadow: boxShadowSecondary,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-inner-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            })
        },
        // Arrow Style
        (0, $13cd8c878b3c9176$export$2e2bcd8739ae039)(token, "var(--antd-arrow-background-color)"),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: "relative",
                maxWidth: "none",
                margin: token.sizePopupArrow,
                display: "inline-block",
                [`${componentCls}-content`]: {
                    display: "inline-block"
                }
            }
        }
    ];
};
const $7c34a58b2ba4d17c$var$genColorStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: (0, $8bbb48c728db3fab$export$6d4fe3a00a1811ad).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    "--antd-arrow-background-color": lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: "transparent"
                    }
                }
            };
        })
    };
};
const $7c34a58b2ba4d17c$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return Object.assign(Object.assign(Object.assign({
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30
    }, (0, $0c0596420865f622$export$87e38ee403661ccc)(token)), (0, $13cd8c878b3c9176$export$bddc192327bb9823)({
        contentRadius: borderRadiusLG,
        limitVerticalRadius: true
    })), {
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : "none",
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    });
};
var $7c34a58b2ba4d17c$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Popover", (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $7c34a58b2ba4d17c$var$genBaseStyle(popoverToken),
        $7c34a58b2ba4d17c$var$genColorStyle(popoverToken),
        (0, $d2082114d5952afb$export$f5d123412490d9dc)(popoverToken, "zoom-big")
    ];
}, $7c34a58b2ba4d17c$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            "width",
            "titleMinWidth"
        ],
        [
            "minWidth",
            "titleMinWidth"
        ]
    ]
});


"use client";
var $b7a2edcc9afcf494$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $b7a2edcc9afcf494$export$6953fc58cbc4170a = (prefixCls, title, content)=>{
    if (!title && !content) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, title && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-title`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(title)), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inner-content`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(content)));
};
const $b7a2edcc9afcf494$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = "top", title: title, content: content, children: children } = props;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className),
        style: style
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $acw62.createElement((0, $576260377b469890$export$2e2bcd8739ae039), Object.assign({}, props, {
        className: hashId,
        prefixCls: prefixCls
    }), children || $b7a2edcc9afcf494$export$6953fc58cbc4170a(prefixCls, title, content)));
};
const $b7a2edcc9afcf494$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className } = props, restProps = $b7a2edcc9afcf494$var$__rest(props, [
        "prefixCls",
        "className"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("popover", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $7c34a58b2ba4d17c$export$2e2bcd8739ae039)(prefixCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement($b7a2edcc9afcf494$export$c40925af82c95d5b, Object.assign({}, restProps, {
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, cssVarCls)
    })));
};
var $b7a2edcc9afcf494$export$2e2bcd8739ae039 = $b7a2edcc9afcf494$var$PurePanel;



"use client";
var $50a5b629c434844e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $50a5b629c434844e$var$Overlay = (_ref)=>{
    let { title: title, content: content, prefixCls: prefixCls } = _ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, title && /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-title`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(title)), /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-inner-content`
    }, (0, $c676d8b8b586adda$export$15e5fca53711d340)(content)));
};
const $50a5b629c434844e$var$InternalPopover = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b;
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = "top", trigger: trigger = "hover", children: children, mouseEnterDelay: mouseEnterDelay = 0.1, mouseLeaveDelay: mouseLeaveDelay = 0.1, onOpenChange: onOpenChange, overlayStyle: overlayStyle = {} } = props, otherProps = $50a5b629c434844e$var$__rest(props, [
        "prefixCls",
        "title",
        "content",
        "overlayClassName",
        "placement",
        "trigger",
        "children",
        "mouseEnterDelay",
        "mouseLeaveDelay",
        "onOpenChange",
        "overlayStyle"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("popover", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $7c34a58b2ba4d17c$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const overlayCls = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlayClassName, hashId, cssVarCls);
    const [open, setOpen] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
        defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
    });
    const settingOpen = (value, e)=>{
        setOpen(value, true);
        onOpenChange === null || onOpenChange === void 0 || onOpenChange(value, e);
    };
    const onKeyDown = (e)=>{
        if (e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC) settingOpen(false, e);
    };
    const onInternalOpenChange = (value)=>{
        settingOpen(value);
    };
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({
        placement: placement,
        trigger: trigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        overlayStyle: overlayStyle
    }, otherProps, {
        prefixCls: prefixCls,
        overlayClassName: overlayCls,
        ref: ref,
        open: open,
        onOpenChange: onInternalOpenChange,
        overlay: title || content ? /*#__PURE__*/ $acw62.createElement($50a5b629c434844e$var$Overlay, {
            prefixCls: prefixCls,
            title: title,
            content: content
        }) : null,
        transitionName: (0, $2efb522a5615f01e$export$27c72201b1d09951)(rootPrefixCls, "zoom-big", otherProps.transitionName),
        "data-popover-inject": true
    }), (0, $30796c32f374b477$export$e530037191fcd5d7)(children, {
        onKeyDown: (e)=>{
            var _a, _b;
            if (/*#__PURE__*/ $acw62.isValidElement(children)) (_b = children === null || children === void 0 ? void 0 : (_a = children.props).onKeyDown) === null || _b === void 0 || _b.call(_a, e);
            onKeyDown(e);
        }
    })));
});
const $50a5b629c434844e$var$Popover = $50a5b629c434844e$var$InternalPopover;
$50a5b629c434844e$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $b7a2edcc9afcf494$export$2e2bcd8739ae039);
var $50a5b629c434844e$export$2e2bcd8739ae039 = $50a5b629c434844e$var$Popover;



const $b7ee91d90065633a$var$nodeCategories = [
    {
        name: "Import",
        hasSubCategories: false,
        items: [
            {
                displayName: "Dataset Importer",
                blockType: "DatasetImporter",
                preview_image_name: "DatasetImporter_small",
                description: "Import and preview a dataset from a local file or via URL download. The dataset is made available for the rest of the blocks in the pipeline.",
                inputs: [],
                outputs: [
                    {
                        displayName: "Dataset",
                        description: "Sets the dataset for the rest of the blocks in the pipeline."
                    }
                ]
            },
            {
                displayName: "Library Importer",
                blockType: "PackageImporter",
                preview_image_name: "PackageImporter_small",
                description: "Import Python libraries for the block pipeline. The libraries are made available for the rest of the blocks in the pipeline.",
                inputs: [],
                outputs: [
                    {
                        displayName: "Imported Libraries",
                        description: "Injects the imported libraries into the pipeline."
                    }
                ]
            }
        ]
    },
    {
        name: "Dataframe Tools",
        hasSubCategories: false,
        items: [
            {
                displayName: "Dataframe Loader",
                blockType: "DataframeLoader",
                preview_image_name: "DataframeLoader_small",
                description: `Load a Pandas dataframe by connecting the output of a dataset and library importer to the inputs of the dataframe loader. The dataframe (df) is available for the rest of the blocks in the pipeline.
<h4 style="margin-top:0.5rem; font-weight:600; text-decoration:underline;">Prerequisites:</h4>
<ul class="blockPreRequisites">
    <li>A dataset must be loaded (connect to dataset importer block)</li>
    <li><span style="font-weight:600;">Pandas</span> must be imported</li>
</ul>`,
                inputs: [
                    {
                        displayName: "Imported Dataset",
                        description: "Connect to a dataset importer block to load the dataset."
                    },
                    {
                        displayName: "Imported Packages",
                        description: "Connect to a library importer block to load the libraries."
                    }
                ],
                outputs: [
                    {
                        displayName: "Export Dataframe",
                        description: "Dataframe is available for rest of pipeline as variable 'df'."
                    }
                ]
            },
            {
                displayName: "Dataframe Inspector",
                blockType: "DataframeInspector",
                preview_image_name: "DataframeInspector_small",
                description: `Inspect a dataframe (df) by choosing one of the following operations:
<ul>
    <li><span class="boldText">Info</span>: provides a concise summary of the dataframe</li>
    <li><span class="boldText">Head</span>: displays the first few rows</li>
    <li><span class="boldText">Tail</span>: displays the last few rows</li>
    <li><span class="boldText">Describe</span>: provides descriptive statistics</li>
    <li><span class="boldText">Columns</span>: lists all column names</li>
    <li><span class="boldText">Shape</span>: gives the number of rows and columns</li>
</ul>
The output of the chosen operation is displayed in the console output.
<h4 style="margin-top:0.5rem; font-weight:600; text-decoration:underline;">Prerequisites:</h4>
<ul class="blockPreRequisites">
    <li>Connect to a series of blocks which have loaded a dataframe.</li>
</ul>`,
                inputs: [
                    {
                        displayName: "Dataframe",
                        description: "Connect to a series of blocks which have loaded a dataframe."
                    }
                ],
                outputs: [
                    {
                        displayName: "Dataframe",
                        description: "Adds a print statement with the selected dataframe operation to the code. Viewable output found in console viewer or global console output after code has been run."
                    }
                ]
            },
            {
                displayName: "Test-Train-Split",
                blockType: "TestTrainSplit",
                preview_image_name: "TestTrainSplit_small",
                description: `Split a dataframe (df) into training and testing data.
<h4 style="margin-top:0.5rem; font-weight:600; text-decoration:underline;">Prerequisites:</h4>
<ul class="blockPreRequisites">
    <li>Connect to a series of blocks which have loaded a dataframe.</li>
    <li><span style="font-weight:600;">Scikit-learn</span> must be imported</li>
</ul>`,
                inputs: [
                    {
                        displayName: "Dataframe",
                        description: "Connect to a series of blocks which have loaded a dataframe."
                    }
                ],
                outputs: [
                    {
                        displayName: "Train Dataframe",
                        description: "Training data for the model."
                    },
                    {
                        displayName: "Test Dataframe",
                        description: "Testing data for the model."
                    }
                ]
            }
        ]
    },
    {
        name: "Model",
        hasSubCategories: true,
        subCategories: [
            {
                name: "Model Selection",
                items: [
                    {
                        displayName: "Linear Regression Model",
                        blockType: "LinearRegressionModel",
                        preview_image_name: "LinearRegressionModel_small",
                        description: "Setup an untrained linear regression model.",
                        inputs: [],
                        outputs: [
                            {
                                displayName: "Untrained Model",
                                description: "Untrained linear regression model."
                            }
                        ]
                    },
                    {
                        displayName: "Logistic Regression Model",
                        blockType: "LogisticRegressionModel",
                        preview_image_name: "LogisticRegressionModel_small",
                        description: "Setup an untrained logistic regression model.",
                        inputs: [],
                        outputs: [
                            {
                                displayName: "Untrained Model",
                                description: "Untrained logistic regression model."
                            }
                        ]
                    }
                ]
            },
            {
                name: "Model Training",
                items: [
                    {
                        displayName: "Train Model",
                        blockType: "TrainModel",
                        preview_image_name: "TrainModel_small",
                        description: "Train an untrained model with a training dataframe.",
                        inputs: [
                            {
                                displayName: "Untrained Model",
                                description: "Connect to a model block."
                            },
                            {
                                displayName: "Train Dataframe",
                                description: "Connect to the Train Dataframe output of a Test-Train-Split block."
                            }
                        ],
                        outputs: [
                            {
                                displayName: "Trained Model",
                                description: "Trained model ready for use in prediction."
                            }
                        ]
                    }
                ]
            },
            {
                name: "Model Prediction",
                items: [
                    {
                        displayName: "Predict Model",
                        blockType: "PredictModel",
                        preview_image_name: "PredictModel_small",
                        description: "Predict the test data using a trained model.",
                        inputs: [
                            {
                                displayName: "Trained Model",
                                description: "Connect to a model block."
                            },
                            {
                                displayName: "Test Dataframe",
                                description: "Connect to the Test Dataframe output of a Test-Train-Split block."
                            }
                        ],
                        outputs: [
                            {
                                displayName: "Predictions",
                                description: "Predictions made by the model based on the test data."
                            }
                        ]
                    }
                ]
            },
            {
                name: "Model Evaluation",
                items: [
                    {
                        displayName: "Score Model Basic",
                        blockType: "ScoreModelBasic",
                        preview_image_name: "ScoreModelBasic_small",
                        description: "Scores the model using a basic scoring method, score type depends on model used.",
                        inputs: [
                            {
                                displayName: "Predictions",
                                description: "Connect to the Predictions output of a Predict Model block."
                            },
                            {
                                displayName: "Test Dataframe",
                                description: "Connect to the Test Dataframe output of a Test-Train-Split block."
                            }
                        ],
                        outputs: [
                            {
                                displayName: "Score",
                                description: "Basic scoring of the model, score type depends on model used."
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        name: "Display",
        hasSubCategories: false,
        items: [
            // {
            //     displayName: "Code Viewer",
            //     blockType: "CodeViewer",
            //     preview_image_name: "CodeViewer_small",
            //     description:
            //         "Displays the code equivalent of the connected blocks. Even though the global code preview exists, this block is useful for viewing code up to a specific point in the pipeline.",
            //     inputs: [
            //         {
            //             displayName: "Code input",
            //             description:
            //                 "Connect to any series of blocks to view the equivalent Python code.",
            //         },
            //     ],
            //     outputs: [],
            // },
            // {
            //     displayName: "Console Viewer",
            //     blockType: "ConsoleViewer",
            //     preview_image_name: "ConsoleViewer_small",
            //     description:
            //         "Displays the console output as a result of running the equivalent code of the connected blocks.",
            //     inputs: [
            //         {
            //             displayName: "Code input",
            //             description: "Connect to a series of blocks which produce code output.",
            //         },
            //     ],
            //     outputs: [],
            // },
            {
                displayName: "Visualizer",
                blockType: "Visualizer",
                preview_image_name: "Visualizer_small",
                description: `Visualize a connected dataframe (df) through a series of different plot types. Generate and save plots after running the block program.
<h4 style="margin-top:0.5rem; font-weight:600; text-decoration:underline;">Prerequisites:</h4>
<ul class="blockPreRequisites">
    <li>Connect to a series of blocks which have loaded a dataframe.</li>
    <li><span style="font-weight:600;">Matplotlib</span> must be imported</li>
    <li><span style="font-weight:600;">Seaborn</span> must be imported for <span style="font-weight:600;">Heatmaps</span> and <span style="font-weight:600;">Scatter plots</span></li>

</ul>`,
                inputs: [
                    {
                        displayName: "Data",
                        description: "Connect to a series of blocks which have loaded a dataframe."
                    }
                ],
                outputs: []
            }
        ]
    }
];
const $b7ee91d90065633a$var$DockMenu = ({ collapsed: collapsed })=>{
    const [delayRender, setDelayRender] = (0, $acw62.useState)(false);
    const [forceClosePopovers, setForceClosePopovers] = (0, $acw62.useState)(undefined);
    const onDragStart = async (e)=>{
        // Force close all popovers once user starts dragging
        setForceClosePopovers(false);
        setTimeout(()=>{
            // Reset popovers back to automatic open/close on hover
            setForceClosePopovers(undefined);
        }, 10);
        const blockType = e.currentTarget.getAttribute("data-block-type") || "";
        e.dataTransfer.setData("blockType", blockType);
        const newImg = new Image();
        const previewImageName = e.currentTarget.getAttribute("data-preview-image");
        newImg.src = `${0, $9d936a2aecb96285$export$b27b0287c31e45de}/block-previews/${previewImageName}.png`;
        e.dataTransfer.setDragImage(newImg, 0, 0);
    };
    (0, $acw62.useEffect)(()=>{
        if (!collapsed) {
            const timer = setTimeout(()=>{
                setDelayRender(collapsed);
            }, 300);
            return ()=>{
                clearTimeout(timer);
            };
        } else setDelayRender(collapsed);
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `dockMenuOverallContainer ${collapsed ? "sidebarCollapsed" : ""}`,
        children: !delayRender && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    children: "Blocks"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                    className: "dockMenuElementList",
                    children: $b7ee91d90065633a$var$nodeCategories.map((category, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    children: category.name
                                }),
                                category.hasSubCategories ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "subCategoryList",
                                    children: category.subCategories?.map((subCategory, subIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            className: "subCategory",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                    children: subCategory.name
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    children: subCategory.items.map((node, itemIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                                                            theme: {
                                                                algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                                                            },
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                                                                open: forceClosePopovers,
                                                                placement: "rightTop",
                                                                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "nodePreviewTitle",
                                                                    children: node.displayName
                                                                }),
                                                                mouseEnterDelay: 0.2,
                                                                mouseLeaveDelay: 0,
                                                                overlayClassName: "blockPopoverOverlay",
                                                                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "blockPopoverContent",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                            className: "blockDescriptionContainer",
                                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                className: "blockDescriptionText",
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: node.description
                                                                                }
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                                                            className: "divider"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "inputOutputContainer",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    className: `inputsColumn ${node.inputs.length == 0 ? "emptyInputOutput" : ""}`,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                            className: "inputOutputTitle",
                                                                                            children: "Inputs"
                                                                                        }),
                                                                                        node.inputs.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                                            children: node.inputs.map((input, inputIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                            className: "boldText",
                                                                                                            children: `${input.displayName}`
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                            children: ` - ${input.description}`
                                                                                                        })
                                                                                                    ]
                                                                                                }, inputIndex))
                                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                            children: "None"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                    className: "dividerContainer",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                                                                        className: "verticalDivider",
                                                                                        type: "vertical"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                                    className: `outputsColumn ${node.outputs.length == 0 ? "emptyInputOutput" : ""}`,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                                            className: "inputOutputTitle",
                                                                                            children: "Outputs"
                                                                                        }),
                                                                                        node.outputs && node.outputs.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                                            children: node.outputs.map((output, outputIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                                className: "boldText",
                                                                                                                children: `${output.displayName}`
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                                children: ` - ${output.description}`
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                }, outputIndex))
                                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                            children: "None"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                    className: "dockMenuElement",
                                                                    "data-block-type": node.blockType,
                                                                    "data-preview-image": node.preview_image_name,
                                                                    draggable: true,
                                                                    onDragStart: onDragStart,
                                                                    children: [
                                                                        node.displayName,
                                                                        node.preview_image_name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                            className: "offscreen",
                                                                            src: `${(0, $9d936a2aecb96285$export$b27b0287c31e45de)}/block-previews/${node.preview_image_name}.png`,
                                                                            alt: `Preview image for ${node.displayName}`
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }, node.blockType))
                                                })
                                            ]
                                        }, subIndex))
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    children: category.items?.map((node, itemIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                                            theme: {
                                                algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50a5b629c434844e$export$2e2bcd8739ae039), {
                                                open: forceClosePopovers,
                                                placement: "rightTop",
                                                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "nodePreviewTitle",
                                                    children: node.displayName
                                                }),
                                                overlayClassName: "blockPopoverOverlay",
                                                mouseEnterDelay: 0.2,
                                                mouseLeaveDelay: 0,
                                                content: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "blockPopoverContent",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            className: "blockDescriptionContainer",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "blockDescriptionText",
                                                                dangerouslySetInnerHTML: {
                                                                    __html: node.description
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                                            className: "divider"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            className: "inputOutputContainer",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: `inputsColumn ${node.inputs.length == 0 ? "emptyInputOutput" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                            className: "inputOutputTitle",
                                                                            children: "Inputs"
                                                                        }),
                                                                        node.inputs.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                            children: node.inputs.map((input, inputIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            className: "boldText",
                                                                                            children: `${input.displayName}`
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                            children: ` - ${input.description}`
                                                                                        })
                                                                                    ]
                                                                                }, inputIndex))
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            children: "None"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "dividerContainer",
                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                                                        className: "verticalDivider",
                                                                        type: "vertical"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: `outputsColumn ${node.outputs.length == 0 ? "emptyInputOutput" : ""}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                            className: "inputOutputTitle",
                                                                            children: "Outputs"
                                                                        }),
                                                                        node.outputs && node.outputs.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                                            children: node.outputs.map((output, outputIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                className: "boldText",
                                                                                                children: `${output.displayName}`
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                                                children: ` - ${output.description}`
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                }, outputIndex))
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                            children: "None"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                    className: "dockMenuElement",
                                                    "data-block-type": node.blockType,
                                                    "data-preview-image": node.preview_image_name,
                                                    draggable: true,
                                                    onDragStart: onDragStart,
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                            children: node.displayName
                                                        }),
                                                        node.preview_image_name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                            className: "offscreen",
                                                            src: `${(0, $9d936a2aecb96285$export$b27b0287c31e45de)}/block-previews/${node.preview_image_name}.png`,
                                                            alt: `Preview image for ${node.displayName}`
                                                        })
                                                    ]
                                                })
                                            })
                                        }, node.blockType))
                                })
                            ]
                        }, category.name))
                })
            ]
        })
    });
};
var $b7ee91d90065633a$export$2e2bcd8739ae039 = $b7ee91d90065633a$var$DockMenu;




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $279f2d7c24920df6$var$_excluded = [
    "className",
    "prefixCls",
    "style",
    "active",
    "status",
    "iconPrefix",
    "icon",
    "wrapperStyle",
    "stepNumber",
    "disabled",
    "description",
    "title",
    "subTitle",
    "progressDot",
    "stepIcon",
    "tailContent",
    "icons",
    "stepIndex",
    "onStepClick",
    "onClick",
    "render"
];
function $279f2d7c24920df6$var$isString(str) {
    return typeof str === "string";
}
function $279f2d7c24920df6$var$Step(props) {
    var _classNames2;
    var className = props.className, prefixCls = props.prefixCls, style = props.style, active = props.active, status = props.status, iconPrefix = props.iconPrefix, icon = props.icon, wrapperStyle = props.wrapperStyle, stepNumber = props.stepNumber, disabled = props.disabled, description = props.description, title = props.title, subTitle = props.subTitle, progressDot = props.progressDot, stepIcon = props.stepIcon, tailContent = props.tailContent, icons = props.icons, stepIndex = props.stepIndex, onStepClick = props.onStepClick, onClick = props.onClick, render = props.render, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $279f2d7c24920df6$var$_excluded);
    // ========================= Click ==========================
    var clickable = !!onStepClick && !disabled;
    var accessibilityProps = {};
    if (clickable) {
        accessibilityProps.role = "button";
        accessibilityProps.tabIndex = 0;
        accessibilityProps.onClick = function(e) {
            onClick === null || onClick === void 0 || onClick(e);
            onStepClick(stepIndex);
        };
        accessibilityProps.onKeyDown = function(e) {
            var which = e.which;
            if (which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER || which === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).SPACE) onStepClick(stepIndex);
        };
    }
    // ========================= Render =========================
    var renderIconNode = function renderIconNode() {
        var _classNames;
        var iconNode;
        var iconClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-icon"), "".concat(iconPrefix, "icon"), (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(iconPrefix, "icon-").concat(icon), icon && $279f2d7c24920df6$var$isString(icon)), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(iconPrefix, "icon-check"), !icon && status === "finish" && (icons && !icons.finish || !icons)), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(iconPrefix, "icon-cross"), !icon && status === "error" && (icons && !icons.error || !icons)), _classNames));
        var iconDot = /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-icon-dot")
        });
        // `progressDot` enjoy the highest priority
        if (progressDot) {
            if (typeof progressDot === "function") iconNode = /*#__PURE__*/ $acw62.createElement("span", {
                className: "".concat(prefixCls, "-icon")
            }, progressDot(iconDot, {
                index: stepNumber - 1,
                status: status,
                title: title,
                description: description
            }));
            else iconNode = /*#__PURE__*/ $acw62.createElement("span", {
                className: "".concat(prefixCls, "-icon")
            }, iconDot);
        } else if (icon && !$279f2d7c24920df6$var$isString(icon)) iconNode = /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-icon")
        }, icon);
        else if (icons && icons.finish && status === "finish") iconNode = /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-icon")
        }, icons.finish);
        else if (icons && icons.error && status === "error") iconNode = /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-icon")
        }, icons.error);
        else if (icon || status === "finish" || status === "error") iconNode = /*#__PURE__*/ $acw62.createElement("span", {
            className: iconClassName
        });
        else iconNode = /*#__PURE__*/ $acw62.createElement("span", {
            className: "".concat(prefixCls, "-icon")
        }, stepNumber);
        if (stepIcon) iconNode = stepIcon({
            index: stepNumber - 1,
            status: status,
            title: title,
            description: description,
            node: iconNode
        });
        return iconNode;
    };
    var mergedStatus = status || "wait";
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-item"), "".concat(prefixCls, "-item-").concat(mergedStatus), className, (_classNames2 = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-item-custom"), icon), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-item-active"), active), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-item-disabled"), disabled === true), _classNames2));
    var stepItemStyle = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, style);
    var stepNode = /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restProps, {
        className: classString,
        style: stepItemStyle
    }), /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        onClick: onClick
    }, accessibilityProps, {
        className: "".concat(prefixCls, "-item-container")
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-tail")
    }, tailContent), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-icon")
    }, renderIconNode()), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-content")
    }, /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-title")
    }, title, subTitle && /*#__PURE__*/ $acw62.createElement("div", {
        title: typeof subTitle === "string" ? subTitle : undefined,
        className: "".concat(prefixCls, "-item-subtitle")
    }, subTitle)), description && /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(prefixCls, "-item-description")
    }, description))));
    if (render) stepNode = render(stepNode) || null;
    return stepNode;
}
var $279f2d7c24920df6$export$2e2bcd8739ae039 = $279f2d7c24920df6$var$Step;


var $a2ee4e4c69ac301a$var$_excluded = [
    "prefixCls",
    "style",
    "className",
    "children",
    "direction",
    "type",
    "labelPlacement",
    "iconPrefix",
    "status",
    "size",
    "current",
    "progressDot",
    "stepIcon",
    "initial",
    "icons",
    "onChange",
    "itemRender",
    "items"
];
function $a2ee4e4c69ac301a$var$Steps(props) {
    var _classNames;
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-steps" : _props$prefixCls, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style, className = props.className, children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? "horizontal" : _props$direction, _props$type = props.type, type = _props$type === void 0 ? "default" : _props$type, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? "horizontal" : _props$labelPlacement, _props$iconPrefix = props.iconPrefix, iconPrefix = _props$iconPrefix === void 0 ? "rc" : _props$iconPrefix, _props$status = props.status, status = _props$status === void 0 ? "process" : _props$status, size = props.size, _props$current = props.current, current = _props$current === void 0 ? 0 : _props$current, _props$progressDot = props.progressDot, progressDot = _props$progressDot === void 0 ? false : _props$progressDot, stepIcon = props.stepIcon, _props$initial = props.initial, initial = _props$initial === void 0 ? 0 : _props$initial, icons = props.icons, onChange = props.onChange, itemRender = props.itemRender, _props$items = props.items, items = _props$items === void 0 ? [] : _props$items, restProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(props, $a2ee4e4c69ac301a$var$_excluded);
    var isNav = type === "navigation";
    var isInline = type === "inline";
    // inline type requires fixed progressDot direction size.
    var mergedProgressDot = isInline || progressDot;
    var mergedDirection = isInline ? "horizontal" : direction;
    var mergedSize = isInline ? undefined : size;
    var adjustedLabelPlacement = mergedProgressDot ? "vertical" : labelPlacement;
    var classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, "".concat(prefixCls, "-").concat(mergedDirection), className, (_classNames = {}, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-").concat(mergedSize), mergedSize), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-label-").concat(adjustedLabelPlacement), mergedDirection === "horizontal"), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot"), !!mergedProgressDot), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-navigation"), isNav), (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-inline"), isInline), _classNames));
    var onStepClick = function onStepClick(next) {
        if (onChange && current !== next) onChange(next);
    };
    var renderStep = function renderStep(item, index) {
        var mergedItem = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, item);
        var stepNumber = initial + index;
        // fix tail color
        if (status === "error" && index === current - 1) mergedItem.className = "".concat(prefixCls, "-next-error");
        if (!mergedItem.status) {
            if (stepNumber === current) mergedItem.status = status;
            else if (stepNumber < current) mergedItem.status = "finish";
            else mergedItem.status = "wait";
        }
        if (isInline) {
            mergedItem.icon = undefined;
            mergedItem.subTitle = undefined;
        }
        if (!mergedItem.render && itemRender) mergedItem.render = function(stepItem) {
            return itemRender(mergedItem, stepItem);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $279f2d7c24920df6$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, mergedItem, {
            active: stepNumber === current,
            stepNumber: stepNumber + 1,
            stepIndex: stepNumber,
            key: stepNumber,
            prefixCls: prefixCls,
            iconPrefix: iconPrefix,
            wrapperStyle: style,
            progressDot: mergedProgressDot,
            stepIcon: stepIcon,
            icons: icons,
            onStepClick: onChange && onStepClick
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classString,
        style: style
    }, restProps), items.filter(function(item) {
        return item;
    }).map(renderStep));
}
$a2ee4e4c69ac301a$var$Steps.Step = (0, $279f2d7c24920df6$export$2e2bcd8739ae039);
var $a2ee4e4c69ac301a$export$2e2bcd8739ae039 = $a2ee4e4c69ac301a$var$Steps;



var $716a13c8dd93d151$export$2e2bcd8739ae039 = (0, $a2ee4e4c69ac301a$export$2e2bcd8739ae039);











const $a8cca314ded38f6b$var$genStepsCustomIconStyle = (token)=>{
    const { componentCls: componentCls, customIconTop: customIconTop, customIconSize: customIconSize, customIconFontSize: customIconFontSize } = token;
    return {
        [`${componentCls}-item-custom`]: {
            [`> ${componentCls}-item-container > ${componentCls}-item-icon`]: {
                height: "auto",
                background: "none",
                border: 0,
                [`> ${componentCls}-icon`]: {
                    top: customIconTop,
                    width: customIconSize,
                    height: customIconSize,
                    fontSize: customIconFontSize,
                    lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(customIconSize)}`
                }
            }
        },
        // Only adjust horizontal customize icon width
        [`&:not(${componentCls}-vertical)`]: {
            [`${componentCls}-item-custom`]: {
                [`${componentCls}-item-icon`]: {
                    width: "auto",
                    background: "none"
                }
            }
        }
    };
};
var $a8cca314ded38f6b$export$2e2bcd8739ae039 = $a8cca314ded38f6b$var$genStepsCustomIconStyle;


const $f74a4ad20a28dd8a$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const stepsItemCls = `${componentCls}-item`; // .ant-steps-item
    return {
        [`${componentCls}-horizontal`]: {
            [`${stepsItemCls}-tail`]: {
                transform: "translateY(-50%)"
            }
        }
    };
};
var $f74a4ad20a28dd8a$export$2e2bcd8739ae039 = $f74a4ad20a28dd8a$var$genHorizontalStyle;



const $0a1231b16193fd42$var$genStepsInlineStyle = (token)=>{
    const { componentCls: componentCls, inlineDotSize: inlineDotSize, inlineTitleColor: inlineTitleColor, inlineTailColor: inlineTailColor } = token;
    const containerPaddingTop = token.calc(token.paddingXS).add(token.lineWidth).equal();
    const titleStyle = {
        [`${componentCls}-item-container ${componentCls}-item-content ${componentCls}-item-title`]: {
            color: inlineTitleColor
        }
    };
    return {
        [`&${componentCls}-inline`]: {
            width: "auto",
            display: "inline-flex",
            [`${componentCls}-item`]: {
                flex: "none",
                "&-container": {
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(containerPaddingTop)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXXS)} 0`,
                    margin: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.marginXXS).div(2).equal())}`,
                    borderRadius: token.borderRadiusSM,
                    cursor: "pointer",
                    transition: `background-color ${token.motionDurationMid}`,
                    "&:hover": {
                        background: token.controlItemBgHover
                    },
                    "&[role='button']:hover": {
                        opacity: 1
                    }
                },
                "&-icon": {
                    width: inlineDotSize,
                    height: inlineDotSize,
                    marginInlineStart: `calc(50% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(inlineDotSize).div(2).equal())})`,
                    [`> ${componentCls}-icon`]: {
                        top: 0
                    },
                    [`${componentCls}-icon-dot`]: {
                        borderRadius: token.calc(token.fontSizeSM).div(4).equal(),
                        "&::after": {
                            display: "none"
                        }
                    }
                },
                "&-content": {
                    width: "auto",
                    marginTop: token.calc(token.marginXS).sub(token.lineWidth).equal()
                },
                "&-title": {
                    color: inlineTitleColor,
                    fontSize: token.fontSizeSM,
                    lineHeight: token.lineHeightSM,
                    fontWeight: "normal",
                    marginBottom: token.calc(token.marginXXS).div(2).equal()
                },
                "&-description": {
                    display: "none"
                },
                "&-tail": {
                    marginInlineStart: 0,
                    top: token.calc(inlineDotSize).div(2).add(containerPaddingTop).equal(),
                    transform: `translateY(-50%)`,
                    "&:after": {
                        width: "100%",
                        height: token.lineWidth,
                        borderRadius: 0,
                        marginInlineStart: 0,
                        background: inlineTailColor
                    }
                },
                [`&:first-child ${componentCls}-item-tail`]: {
                    width: "50%",
                    marginInlineStart: "50%"
                },
                [`&:last-child ${componentCls}-item-tail`]: {
                    display: "block",
                    width: "50%"
                },
                "&-wait": Object.assign({
                    [`${componentCls}-item-icon ${componentCls}-icon ${componentCls}-icon-dot`]: {
                        backgroundColor: token.colorBorderBg,
                        border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${inlineTailColor}`
                    }
                }, titleStyle),
                "&-finish": Object.assign({
                    [`${componentCls}-item-tail::after`]: {
                        backgroundColor: inlineTailColor
                    },
                    [`${componentCls}-item-icon ${componentCls}-icon ${componentCls}-icon-dot`]: {
                        backgroundColor: inlineTailColor,
                        border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${inlineTailColor}`
                    }
                }, titleStyle),
                "&-error": titleStyle,
                "&-active, &-process": Object.assign({
                    [`${componentCls}-item-icon`]: {
                        width: inlineDotSize,
                        height: inlineDotSize,
                        marginInlineStart: `calc(50% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(inlineDotSize).div(2).equal())})`,
                        top: 0
                    }
                }, titleStyle),
                [`&:not(${componentCls}-item-active) > ${componentCls}-item-container[role='button']:hover`]: {
                    [`${componentCls}-item-title`]: {
                        color: inlineTitleColor
                    }
                }
            }
        }
    };
};
var $0a1231b16193fd42$export$2e2bcd8739ae039 = $0a1231b16193fd42$var$genStepsInlineStyle;



const $bdbeca1dbc04ac05$var$genStepsLabelPlacementStyle = (token)=>{
    const { componentCls: componentCls, iconSize: iconSize, lineHeight: lineHeight, iconSizeSM: iconSizeSM } = token;
    return {
        [`&${componentCls}-label-vertical`]: {
            [`${componentCls}-item`]: {
                overflow: "visible",
                "&-tail": {
                    marginInlineStart: token.calc(iconSize).div(2).add(token.controlHeightLG).equal(),
                    padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingLG)}`
                },
                "&-content": {
                    display: "block",
                    width: token.calc(iconSize).div(2).add(token.controlHeightLG).mul(2).equal(),
                    marginTop: token.marginSM,
                    textAlign: "center"
                },
                "&-icon": {
                    display: "inline-block",
                    marginInlineStart: token.controlHeightLG
                },
                "&-title": {
                    paddingInlineEnd: 0,
                    paddingInlineStart: 0,
                    "&::after": {
                        display: "none"
                    }
                },
                "&-subtitle": {
                    display: "block",
                    marginBottom: token.marginXXS,
                    marginInlineStart: 0,
                    lineHeight: lineHeight
                }
            },
            [`&${componentCls}-small:not(${componentCls}-dot)`]: {
                [`${componentCls}-item`]: {
                    "&-icon": {
                        marginInlineStart: token.calc(iconSize).sub(iconSizeSM).div(2).add(token.controlHeightLG).equal()
                    }
                }
            }
        }
    };
};
var $bdbeca1dbc04ac05$export$2e2bcd8739ae039 = $bdbeca1dbc04ac05$var$genStepsLabelPlacementStyle;




const $589da721d83fb096$var$genStepsNavStyle = (token)=>{
    const { componentCls: componentCls, navContentMaxWidth: navContentMaxWidth, navArrowColor: navArrowColor, stepsNavActiveColor: stepsNavActiveColor, motionDurationSlow: motionDurationSlow } = token;
    return {
        [`&${componentCls}-navigation`]: {
            paddingTop: token.paddingSM,
            [`&${componentCls}-small`]: {
                [`${componentCls}-item`]: {
                    "&-container": {
                        marginInlineStart: token.calc(token.marginSM).mul(-1).equal()
                    }
                }
            },
            [`${componentCls}-item`]: {
                overflow: "visible",
                textAlign: "center",
                "&-container": {
                    display: "inline-block",
                    height: "100%",
                    marginInlineStart: token.calc(token.margin).mul(-1).equal(),
                    paddingBottom: token.paddingSM,
                    textAlign: "start",
                    transition: `opacity ${motionDurationSlow}`,
                    [`${componentCls}-item-content`]: {
                        maxWidth: navContentMaxWidth
                    },
                    [`${componentCls}-item-title`]: Object.assign(Object.assign({
                        maxWidth: "100%",
                        paddingInlineEnd: 0
                    }, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
                        "&::after": {
                            display: "none"
                        }
                    })
                },
                [`&:not(${componentCls}-item-active)`]: {
                    [`${componentCls}-item-container[role='button']`]: {
                        cursor: "pointer",
                        "&:hover": {
                            opacity: 0.85
                        }
                    }
                },
                "&:last-child": {
                    flex: 1,
                    "&::after": {
                        display: "none"
                    }
                },
                "&::after": {
                    position: "absolute",
                    top: `calc(50% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.paddingSM).div(2).equal())})`,
                    insetInlineStart: "100%",
                    display: "inline-block",
                    width: token.fontSizeIcon,
                    height: token.fontSizeIcon,
                    borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
                    borderBottom: "none",
                    borderInlineStart: "none",
                    borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
                    transform: "translateY(-50%) translateX(-50%) rotate(45deg)",
                    content: '""'
                },
                "&::before": {
                    position: "absolute",
                    bottom: 0,
                    insetInlineStart: "50%",
                    display: "inline-block",
                    width: 0,
                    height: token.lineWidthBold,
                    backgroundColor: stepsNavActiveColor,
                    transition: `width ${motionDurationSlow}, inset-inline-start ${motionDurationSlow}`,
                    transitionTimingFunction: "ease-out",
                    content: '""'
                }
            },
            [`${componentCls}-item${componentCls}-item-active::before`]: {
                insetInlineStart: 0,
                width: "100%"
            }
        },
        [`&${componentCls}-navigation${componentCls}-vertical`]: {
            [`> ${componentCls}-item`]: {
                marginInlineEnd: 0,
                "&::before": {
                    display: "none"
                },
                [`&${componentCls}-item-active::before`]: {
                    top: 0,
                    insetInlineEnd: 0,
                    insetInlineStart: "unset",
                    display: "block",
                    width: token.calc(token.lineWidth).mul(3).equal(),
                    height: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginLG)})`
                },
                "&::after": {
                    position: "relative",
                    insetInlineStart: "50%",
                    display: "block",
                    width: token.calc(token.controlHeight).mul(0.25).equal(),
                    height: token.calc(token.controlHeight).mul(0.25).equal(),
                    marginBottom: token.marginXS,
                    textAlign: "center",
                    transform: "translateY(-50%) translateX(-50%) rotate(135deg)"
                },
                "&:last-child": {
                    "&::after": {
                        display: "none"
                    }
                },
                [`> ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                    visibility: "hidden"
                }
            }
        },
        [`&${componentCls}-navigation${componentCls}-horizontal`]: {
            [`> ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                visibility: "hidden"
            }
        }
    };
};
var $589da721d83fb096$export$2e2bcd8739ae039 = $589da721d83fb096$var$genStepsNavStyle;



const $d8eb8627d301910e$var$genStepsProgressStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, iconSize: iconSize, iconSizeSM: iconSizeSM, processIconColor: processIconColor, marginXXS: marginXXS, lineWidthBold: lineWidthBold, lineWidth: lineWidth, paddingXXS: paddingXXS } = token;
    const progressSize = token.calc(iconSize).add(token.calc(lineWidthBold).mul(4).equal()).equal();
    const progressSizeSM = token.calc(iconSizeSM).add(token.calc(token.lineWidth).mul(4).equal()).equal();
    return {
        [`&${componentCls}-with-progress`]: {
            [`${componentCls}-item`]: {
                paddingTop: paddingXXS,
                [`&-process ${componentCls}-item-container ${componentCls}-item-icon ${componentCls}-icon`]: {
                    color: processIconColor
                }
            },
            [`&${componentCls}-vertical > ${componentCls}-item `]: {
                paddingInlineStart: paddingXXS,
                [`> ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                    top: marginXXS,
                    insetInlineStart: token.calc(iconSize).div(2).sub(lineWidth).add(paddingXXS).equal()
                }
            },
            [`&, &${componentCls}-small`]: {
                [`&${componentCls}-horizontal ${componentCls}-item:first-child`]: {
                    paddingBottom: paddingXXS,
                    paddingInlineStart: paddingXXS
                }
            },
            [`&${componentCls}-small${componentCls}-vertical > ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                insetInlineStart: token.calc(iconSizeSM).div(2).sub(lineWidth).add(paddingXXS).equal()
            },
            [`&${componentCls}-label-vertical ${componentCls}-item ${componentCls}-item-tail`]: {
                top: token.calc(iconSize).div(2).add(paddingXXS).equal()
            },
            [`${componentCls}-item-icon`]: {
                position: "relative",
                [`${antCls}-progress`]: {
                    position: "absolute",
                    insetInlineStart: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    "&-inner": {
                        width: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(progressSize)} !important`,
                        height: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(progressSize)} !important`
                    }
                }
            },
            // ============================== Small size ==============================
            [`&${componentCls}-small`]: {
                [`&${componentCls}-label-vertical ${componentCls}-item ${componentCls}-item-tail`]: {
                    top: token.calc(iconSizeSM).div(2).add(paddingXXS).equal()
                },
                [`${componentCls}-item-icon ${antCls}-progress-inner`]: {
                    width: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(progressSizeSM)} !important`,
                    height: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(progressSizeSM)} !important`
                }
            }
        }
    };
};
var $d8eb8627d301910e$export$2e2bcd8739ae039 = $d8eb8627d301910e$var$genStepsProgressStyle;



const $e8358112fda1949b$var$genStepsProgressDotStyle = (token)=>{
    const { componentCls: componentCls, descriptionMaxWidth: descriptionMaxWidth, lineHeight: lineHeight, dotCurrentSize: dotCurrentSize, dotSize: dotSize, motionDurationSlow: motionDurationSlow } = token;
    return {
        [`&${componentCls}-dot, &${componentCls}-dot${componentCls}-small`]: {
            [`${componentCls}-item`]: {
                "&-title": {
                    lineHeight: lineHeight
                },
                "&-tail": {
                    // Math.floor((token.size - token.lineWidth * 3) / 2)
                    top: token.calc(token.dotSize).sub(token.calc(token.lineWidth).mul(3).equal()).div(2).equal(),
                    width: "100%",
                    marginTop: 0,
                    marginBottom: 0,
                    marginInline: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(descriptionMaxWidth).div(2).equal())} 0`,
                    padding: 0,
                    "&::after": {
                        width: `calc(100% - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.marginSM).mul(2).equal())})`,
                        height: token.calc(token.lineWidth).mul(3).equal(),
                        marginInlineStart: token.marginSM
                    }
                },
                "&-icon": {
                    width: dotSize,
                    height: dotSize,
                    marginInlineStart: token.calc(token.descriptionMaxWidth).sub(dotSize).div(2).equal(),
                    paddingInlineEnd: 0,
                    lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(dotSize)}`,
                    background: "transparent",
                    border: 0,
                    [`${componentCls}-icon-dot`]: {
                        position: "relative",
                        float: "left",
                        width: "100%",
                        height: "100%",
                        borderRadius: 100,
                        // very large number
                        transition: `all ${motionDurationSlow}`,
                        /* expand hover area */ "&::after": {
                            position: "absolute",
                            top: token.calc(token.marginSM).mul(-1).equal(),
                            insetInlineStart: token.calc(dotSize).sub(token.calc(token.controlHeightLG).mul(1.5).equal()).div(2).equal(),
                            width: token.calc(token.controlHeightLG).mul(1.5).equal(),
                            height: token.controlHeight,
                            background: "transparent",
                            content: '""'
                        }
                    }
                },
                "&-content": {
                    width: descriptionMaxWidth
                },
                [`&-process ${componentCls}-item-icon`]: {
                    position: "relative",
                    top: token.calc(dotSize).sub(dotCurrentSize).div(2).equal(),
                    width: dotCurrentSize,
                    height: dotCurrentSize,
                    lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(dotCurrentSize)}`,
                    background: "none",
                    marginInlineStart: token.calc(token.descriptionMaxWidth).sub(dotCurrentSize).div(2).equal()
                },
                [`&-process ${componentCls}-icon`]: {
                    [`&:first-child ${componentCls}-icon-dot`]: {
                        insetInlineStart: 0
                    }
                }
            }
        },
        [`&${componentCls}-vertical${componentCls}-dot`]: {
            [`${componentCls}-item-icon`]: {
                marginTop: token.calc(token.controlHeight).sub(dotSize).div(2).equal(),
                marginInlineStart: 0,
                background: "none"
            },
            [`${componentCls}-item-process ${componentCls}-item-icon`]: {
                marginTop: token.calc(token.controlHeight).sub(dotCurrentSize).div(2).equal(),
                top: 0,
                insetInlineStart: token.calc(dotSize).sub(dotCurrentSize).div(2).equal(),
                marginInlineStart: 0
            },
            // https://github.com/ant-design/ant-design/issues/18354
            [`${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                top: token.calc(token.controlHeight).sub(dotSize).div(2).equal(),
                insetInlineStart: 0,
                margin: 0,
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(dotSize).add(token.paddingXS).equal())} 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.paddingXS)}`,
                "&::after": {
                    marginInlineStart: token.calc(dotSize).sub(token.lineWidth).div(2).equal()
                }
            },
            [`&${componentCls}-small`]: {
                [`${componentCls}-item-icon`]: {
                    marginTop: token.calc(token.controlHeightSM).sub(dotSize).div(2).equal()
                },
                [`${componentCls}-item-process ${componentCls}-item-icon`]: {
                    marginTop: token.calc(token.controlHeightSM).sub(dotCurrentSize).div(2).equal()
                },
                [`${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                    top: token.calc(token.controlHeightSM).sub(dotSize).div(2).equal()
                }
            },
            [`${componentCls}-item:first-child ${componentCls}-icon-dot`]: {
                insetInlineStart: 0
            },
            [`${componentCls}-item-content`]: {
                width: "inherit"
            }
        }
    };
};
var $e8358112fda1949b$export$2e2bcd8739ae039 = $e8358112fda1949b$var$genStepsProgressDotStyle;


const $9122c0cf6eae66a5$var$genStepsRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-rtl`]: {
            direction: "rtl",
            [`${componentCls}-item`]: {
                "&-subtitle": {
                    float: "left"
                }
            },
            // nav
            [`&${componentCls}-navigation`]: {
                [`${componentCls}-item::after`]: {
                    transform: "rotate(-45deg)"
                }
            },
            // vertical
            [`&${componentCls}-vertical`]: {
                [`> ${componentCls}-item`]: {
                    "&::after": {
                        transform: "rotate(225deg)"
                    },
                    [`${componentCls}-item-icon`]: {
                        float: "right"
                    }
                }
            },
            // progress-dot
            [`&${componentCls}-dot`]: {
                [`${componentCls}-item-icon ${componentCls}-icon-dot, &${componentCls}-small ${componentCls}-item-icon ${componentCls}-icon-dot`]: {
                    float: "right"
                }
            }
        }
    };
};
var $9122c0cf6eae66a5$export$2e2bcd8739ae039 = $9122c0cf6eae66a5$var$genStepsRTLStyle;



const $aef743a8a52c3286$var$genStepsSmallStyle = (token)=>{
    const { componentCls: componentCls, iconSizeSM: iconSizeSM, fontSizeSM: // stepsSmallIconMargin,
    fontSizeSM, fontSize: fontSize, colorTextDescription: colorTextDescription } = token;
    return {
        [`&${componentCls}-small`]: {
            [`&${componentCls}-horizontal:not(${componentCls}-label-vertical) ${componentCls}-item`]: {
                paddingInlineStart: token.paddingSM,
                "&:first-child": {
                    paddingInlineStart: 0
                }
            },
            [`${componentCls}-item-icon`]: {
                width: iconSizeSM,
                height: iconSizeSM,
                // margin: stepsSmallIconMargin,
                marginTop: 0,
                marginBottom: 0,
                marginInline: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.marginXS)}`,
                fontSize: fontSizeSM,
                lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(iconSizeSM)}`,
                textAlign: "center",
                borderRadius: iconSizeSM
            },
            [`${componentCls}-item-title`]: {
                paddingInlineEnd: token.paddingSM,
                fontSize: fontSize,
                lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(iconSizeSM)}`,
                "&::after": {
                    top: token.calc(iconSizeSM).div(2).equal()
                }
            },
            [`${componentCls}-item-description`]: {
                color: colorTextDescription,
                fontSize: fontSize
            },
            [`${componentCls}-item-tail`]: {
                top: token.calc(iconSizeSM).div(2).sub(token.paddingXXS).equal()
            },
            [`${componentCls}-item-custom ${componentCls}-item-icon`]: {
                width: "inherit",
                height: "inherit",
                lineHeight: "inherit",
                background: "none",
                border: 0,
                borderRadius: 0,
                [`> ${componentCls}-icon`]: {
                    fontSize: iconSizeSM,
                    lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(iconSizeSM)}`,
                    transform: "none"
                }
            }
        }
    };
};
var $aef743a8a52c3286$export$2e2bcd8739ae039 = $aef743a8a52c3286$var$genStepsSmallStyle;



const $b5515ab0119a1e30$var$genStepsVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconSizeSM: iconSizeSM, iconSize: iconSize } = token;
    return {
        [`&${componentCls}-vertical`]: {
            display: "flex",
            flexDirection: "column",
            [`> ${componentCls}-item`]: {
                display: "block",
                flex: "1 0 auto",
                paddingInlineStart: 0,
                overflow: "visible",
                [`${componentCls}-item-icon`]: {
                    float: "left",
                    marginInlineEnd: token.margin
                },
                [`${componentCls}-item-content`]: {
                    display: "block",
                    minHeight: token.calc(token.controlHeight).mul(1.5).equal(),
                    overflow: "hidden"
                },
                [`${componentCls}-item-title`]: {
                    lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(iconSize)}`
                },
                [`${componentCls}-item-description`]: {
                    paddingBottom: token.paddingSM
                }
            },
            [`> ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                position: "absolute",
                top: 0,
                insetInlineStart: token.calc(iconSize).div(2).sub(token.lineWidth).equal(),
                width: token.lineWidth,
                height: "100%",
                padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.marginXXS).mul(1.5).add(iconSize).equal())} 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.marginXXS).mul(1.5).equal())}`,
                "&::after": {
                    width: token.lineWidth,
                    height: "100%"
                }
            },
            [`> ${componentCls}-item:not(:last-child) > ${componentCls}-item-container > ${componentCls}-item-tail`]: {
                display: "block"
            },
            [` > ${componentCls}-item > ${componentCls}-item-container > ${componentCls}-item-content > ${componentCls}-item-title`]: {
                "&::after": {
                    display: "none"
                }
            },
            [`&${componentCls}-small ${componentCls}-item-container`]: {
                [`${componentCls}-item-tail`]: {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: token.calc(iconSizeSM).div(2).sub(token.lineWidth).equal(),
                    padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.marginXXS).mul(1.5).add(iconSizeSM).equal())} 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.marginXXS).mul(1.5).equal())}`
                },
                [`${componentCls}-item-title`]: {
                    lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(iconSizeSM)}`
                }
            }
        }
    };
};
var $b5515ab0119a1e30$export$2e2bcd8739ae039 = $b5515ab0119a1e30$var$genStepsVerticalStyle;


const $5a87c94441d5c277$var$STEP_ITEM_STATUS_WAIT = "wait";
const $5a87c94441d5c277$var$STEP_ITEM_STATUS_PROCESS = "process";
const $5a87c94441d5c277$var$STEP_ITEM_STATUS_FINISH = "finish";
const $5a87c94441d5c277$var$STEP_ITEM_STATUS_ERROR = "error";
const $5a87c94441d5c277$var$genStepsItemStatusStyle = (status, token)=>{
    const prefix = `${token.componentCls}-item`;
    const iconColorKey = `${status}IconColor`;
    const titleColorKey = `${status}TitleColor`;
    const descriptionColorKey = `${status}DescriptionColor`;
    const tailColorKey = `${status}TailColor`;
    const iconBgColorKey = `${status}IconBgColor`;
    const iconBorderColorKey = `${status}IconBorderColor`;
    const dotColorKey = `${status}DotColor`;
    return {
        [`${prefix}-${status} ${prefix}-icon`]: {
            backgroundColor: token[iconBgColorKey],
            borderColor: token[iconBorderColorKey],
            [`> ${token.componentCls}-icon`]: {
                color: token[iconColorKey],
                [`${token.componentCls}-icon-dot`]: {
                    background: token[dotColorKey]
                }
            }
        },
        [`${prefix}-${status}${prefix}-custom ${prefix}-icon`]: {
            [`> ${token.componentCls}-icon`]: {
                color: token[dotColorKey]
            }
        },
        [`${prefix}-${status} > ${prefix}-container > ${prefix}-content > ${prefix}-title`]: {
            color: token[titleColorKey],
            "&::after": {
                backgroundColor: token[tailColorKey]
            }
        },
        [`${prefix}-${status} > ${prefix}-container > ${prefix}-content > ${prefix}-description`]: {
            color: token[descriptionColorKey]
        },
        [`${prefix}-${status} > ${prefix}-container > ${prefix}-tail::after`]: {
            backgroundColor: token[tailColorKey]
        }
    };
};
const $5a87c94441d5c277$var$genStepsItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    const stepsItemCls = `${componentCls}-item`; // .ant-steps-item
    const stepItemIconCls = `${stepsItemCls}-icon`;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        [stepsItemCls]: {
            position: "relative",
            display: "inline-block",
            flex: 1,
            overflow: "hidden",
            verticalAlign: "top",
            "&:last-child": {
                flex: "none",
                [`> ${stepsItemCls}-container > ${stepsItemCls}-tail, > ${stepsItemCls}-container >  ${stepsItemCls}-content > ${stepsItemCls}-title::after`]: {
                    display: "none"
                }
            }
        },
        [`${stepsItemCls}-container`]: {
            outline: "none",
            "&:focus-visible": {
                [stepItemIconCls]: Object.assign({}, (0, $4733a3b3eb18f80d$export$6539948f0a737e39)(token))
            }
        },
        [`${stepItemIconCls}, ${stepsItemCls}-content`]: {
            display: "inline-block",
            verticalAlign: "top"
        },
        [stepItemIconCls]: {
            width: token.iconSize,
            height: token.iconSize,
            marginTop: 0,
            marginBottom: 0,
            marginInlineStart: 0,
            marginInlineEnd: token.marginXS,
            fontSize: token.iconFontSize,
            fontFamily: token.fontFamily,
            lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.iconSize)}`,
            textAlign: "center",
            borderRadius: token.iconSize,
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            transition: `background-color ${motionDurationSlow}, border-color ${motionDurationSlow}`,
            [`${componentCls}-icon`]: {
                position: "relative",
                top: token.iconTop,
                color: token.colorPrimary,
                lineHeight: 1
            }
        },
        [`${stepsItemCls}-tail`]: {
            position: "absolute",
            top: token.calc(token.iconSize).div(2).equal(),
            insetInlineStart: 0,
            width: "100%",
            "&::after": {
                display: "inline-block",
                width: "100%",
                height: token.lineWidth,
                background: token.colorSplit,
                borderRadius: token.lineWidth,
                transition: `background ${motionDurationSlow}`,
                content: '""'
            }
        },
        [`${stepsItemCls}-title`]: {
            position: "relative",
            display: "inline-block",
            paddingInlineEnd: token.padding,
            color: token.colorText,
            fontSize: token.fontSizeLG,
            lineHeight: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.titleLineHeight)}`,
            "&::after": {
                position: "absolute",
                top: token.calc(token.titleLineHeight).div(2).equal(),
                insetInlineStart: "100%",
                display: "block",
                width: 9999,
                height: token.lineWidth,
                background: token.processTailColor,
                content: '""'
            }
        },
        [`${stepsItemCls}-subtitle`]: {
            display: "inline",
            marginInlineStart: token.marginXS,
            color: token.colorTextDescription,
            fontWeight: "normal",
            fontSize: token.fontSize
        },
        [`${stepsItemCls}-description`]: {
            color: token.colorTextDescription,
            fontSize: token.fontSize
        }
    }, $5a87c94441d5c277$var$genStepsItemStatusStyle($5a87c94441d5c277$var$STEP_ITEM_STATUS_WAIT, token)), $5a87c94441d5c277$var$genStepsItemStatusStyle($5a87c94441d5c277$var$STEP_ITEM_STATUS_PROCESS, token)), {
        [`${stepsItemCls}-process > ${stepsItemCls}-container > ${stepsItemCls}-title`]: {
            fontWeight: token.fontWeightStrong
        }
    }), $5a87c94441d5c277$var$genStepsItemStatusStyle($5a87c94441d5c277$var$STEP_ITEM_STATUS_FINISH, token)), $5a87c94441d5c277$var$genStepsItemStatusStyle($5a87c94441d5c277$var$STEP_ITEM_STATUS_ERROR, token)), {
        [`${stepsItemCls}${componentCls}-next-error > ${componentCls}-item-title::after`]: {
            background: token.colorError
        },
        [`${stepsItemCls}-disabled`]: {
            cursor: "not-allowed"
        }
    });
};
// ============================= Clickable ===========================
const $5a87c94441d5c277$var$genStepsClickableStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return {
        [`& ${componentCls}-item`]: {
            [`&:not(${componentCls}-item-active)`]: {
                [`& > ${componentCls}-item-container[role='button']`]: {
                    cursor: "pointer",
                    [`${componentCls}-item`]: {
                        [`&-title, &-subtitle, &-description, &-icon ${componentCls}-icon`]: {
                            transition: `color ${motionDurationSlow}`
                        }
                    },
                    "&:hover": {
                        [`${componentCls}-item`]: {
                            "&-title, &-subtitle, &-description": {
                                color: token.colorPrimary
                            }
                        }
                    }
                },
                [`&:not(${componentCls}-item-process)`]: {
                    [`& > ${componentCls}-item-container[role='button']:hover`]: {
                        [`${componentCls}-item`]: {
                            "&-icon": {
                                borderColor: token.colorPrimary,
                                [`${componentCls}-icon`]: {
                                    color: token.colorPrimary
                                }
                            }
                        }
                    }
                }
            }
        },
        [`&${componentCls}-horizontal:not(${componentCls}-label-vertical)`]: {
            [`${componentCls}-item`]: {
                paddingInlineStart: token.padding,
                whiteSpace: "nowrap",
                "&:first-child": {
                    paddingInlineStart: 0
                },
                [`&:last-child ${componentCls}-item-title`]: {
                    paddingInlineEnd: 0
                },
                "&-tail": {
                    display: "none"
                },
                "&-description": {
                    maxWidth: token.descriptionMaxWidth,
                    whiteSpace: "normal"
                }
            }
        }
    };
};
const $5a87c94441d5c277$var$genStepsStyle = (token)=>{
    const { componentCls: componentCls } = token; // .ant-steps
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            display: "flex",
            width: "100%",
            fontSize: 0,
            textAlign: "initial"
        }), $5a87c94441d5c277$var$genStepsItemStyle(token)), $5a87c94441d5c277$var$genStepsClickableStyle(token)), (0, $a8cca314ded38f6b$export$2e2bcd8739ae039)(token)), (0, $aef743a8a52c3286$export$2e2bcd8739ae039)(token)), (0, $b5515ab0119a1e30$export$2e2bcd8739ae039)(token)), (0, $f74a4ad20a28dd8a$export$2e2bcd8739ae039)(token)), (0, $bdbeca1dbc04ac05$export$2e2bcd8739ae039)(token)), (0, $e8358112fda1949b$export$2e2bcd8739ae039)(token)), (0, $589da721d83fb096$export$2e2bcd8739ae039)(token)), (0, $9122c0cf6eae66a5$export$2e2bcd8739ae039)(token)), (0, $d8eb8627d301910e$export$2e2bcd8739ae039)(token)), (0, $0a1231b16193fd42$export$2e2bcd8739ae039)(token))
    };
};
const $5a87c94441d5c277$export$9ca1be8807fe0675 = (token)=>({
        titleLineHeight: token.controlHeight,
        customIconSize: token.controlHeight,
        customIconTop: 0,
        customIconFontSize: token.controlHeightSM,
        iconSize: token.controlHeight,
        iconTop: -0.5,
        // magic for ui experience
        iconFontSize: token.fontSize,
        iconSizeSM: token.fontSizeHeading3,
        dotSize: token.controlHeight / 4,
        dotCurrentSize: token.controlHeightLG / 4,
        navArrowColor: token.colorTextDisabled,
        navContentMaxWidth: "auto",
        descriptionMaxWidth: 140,
        waitIconColor: token.wireframe ? token.colorTextDisabled : token.colorTextLabel,
        waitIconBgColor: token.wireframe ? token.colorBgContainer : token.colorFillContent,
        waitIconBorderColor: token.wireframe ? token.colorTextDisabled : "transparent",
        finishIconBgColor: token.wireframe ? token.colorBgContainer : token.controlItemBgActive,
        finishIconBorderColor: token.wireframe ? token.colorPrimary : token.controlItemBgActive
    });
var $5a87c94441d5c277$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Steps", (token)=>{
    const { colorTextDisabled: colorTextDisabled, controlHeightLG: controlHeightLG, colorTextLightSolid: colorTextLightSolid, colorText: colorText, colorPrimary: colorPrimary, colorTextDescription: colorTextDescription, colorTextQuaternary: colorTextQuaternary, colorError: colorError, colorBorderSecondary: colorBorderSecondary, colorSplit: colorSplit } = token;
    const stepsToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        // Steps component less variable
        processIconColor: colorTextLightSolid,
        processTitleColor: colorText,
        processDescriptionColor: colorText,
        processIconBgColor: colorPrimary,
        processIconBorderColor: colorPrimary,
        processDotColor: colorPrimary,
        processTailColor: colorSplit,
        waitTitleColor: colorTextDescription,
        waitDescriptionColor: colorTextDescription,
        waitTailColor: colorSplit,
        waitDotColor: colorTextDisabled,
        finishIconColor: colorPrimary,
        finishTitleColor: colorText,
        finishDescriptionColor: colorTextDescription,
        finishTailColor: colorPrimary,
        finishDotColor: colorPrimary,
        errorIconColor: colorTextLightSolid,
        errorTitleColor: colorError,
        errorDescriptionColor: colorError,
        errorTailColor: colorSplit,
        errorIconBgColor: colorError,
        errorIconBorderColor: colorError,
        errorDotColor: colorError,
        stepsNavActiveColor: colorPrimary,
        stepsProgressSize: controlHeightLG,
        // Steps inline variable
        inlineDotSize: 6,
        inlineTitleColor: colorTextQuaternary,
        inlineTailColor: colorBorderSecondary
    });
    return [
        $5a87c94441d5c277$var$genStepsStyle(stepsToken)
    ];
}, $5a87c94441d5c277$export$9ca1be8807fe0675);



var $acw62 = parcelRequire("acw62");


function $6ce844e8a9c523e5$var$filter(items) {
    return items.filter((item)=>item);
}
function $6ce844e8a9c523e5$export$2e2bcd8739ae039(items, children) {
    if (items) return items;
    const childrenItems = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(children).map((node)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(node)) {
            const { props: props } = node;
            const item = Object.assign({}, props);
            return item;
        }
        return null;
    });
    return $6ce844e8a9c523e5$var$filter(childrenItems);
}


"use client";
var $607238fe01d03e7c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $607238fe01d03e7c$var$Steps = (props)=>{
    const { percent: percent, size: customizeSize, className: className, rootClassName: rootClassName, direction: direction, items: items, responsive: responsive = true, current: current = 0, children: children, style: style } = props, restProps = $607238fe01d03e7c$var$__rest(props, [
        "percent",
        "size",
        "className",
        "rootClassName",
        "direction",
        "items",
        "responsive",
        "current",
        "children",
        "style"
    ]);
    const { xs: xs } = (0, $b8c04e47cb65d6a9$export$2e2bcd8739ae039)(responsive);
    const { getPrefixCls: getPrefixCls, direction: rtlDirection, steps: steps } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const realDirectionValue = $acw62.useMemo(()=>responsive && xs ? "vertical" : direction, [
        xs,
        direction
    ]);
    const size = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const prefixCls = getPrefixCls("steps", props.prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $5a87c94441d5c277$export$2e2bcd8739ae039)(prefixCls);
    const isInline = props.type === "inline";
    const iconPrefix = getPrefixCls("", props.iconPrefix);
    const mergedItems = (0, $6ce844e8a9c523e5$export$2e2bcd8739ae039)(items, children);
    const mergedPercent = isInline ? undefined : percent;
    const mergedStyle = Object.assign(Object.assign({}, steps === null || steps === void 0 ? void 0 : steps.style), style);
    const stepsClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(steps === null || steps === void 0 ? void 0 : steps.className, {
        [`${prefixCls}-rtl`]: rtlDirection === "rtl",
        [`${prefixCls}-with-progress`]: mergedPercent !== undefined
    }, className, rootClassName, hashId, cssVarCls);
    const icons = {
        finish: /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {
            className: `${prefixCls}-finish-icon`
        }),
        error: /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
            className: `${prefixCls}-error-icon`
        })
    };
    const stepIconRender = (_ref)=>{
        let { node: node, status: status } = _ref;
        if (status === "process" && mergedPercent !== undefined) {
            // currently it's hard-coded, since we can't easily read the actually width of icon
            const progressWidth = size === "small" ? 32 : 40;
            // iconWithProgress
            return /*#__PURE__*/ $acw62.createElement("div", {
                className: `${prefixCls}-progress-icon`
            }, /*#__PURE__*/ $acw62.createElement((0, $79bdee06e67dd736$export$2e2bcd8739ae039), {
                type: "circle",
                percent: mergedPercent,
                size: progressWidth,
                strokeWidth: 4,
                format: ()=>null
            }), node);
        }
        return node;
    };
    const itemRender = (item, stepItem)=>item.description ? /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
            title: item.description
        }, stepItem) : stepItem;
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $716a13c8dd93d151$export$2e2bcd8739ae039), Object.assign({
        icons: icons
    }, restProps, {
        style: mergedStyle,
        current: current,
        size: size,
        items: mergedItems,
        itemRender: isInline ? itemRender : undefined,
        stepIcon: stepIconRender,
        direction: realDirectionValue,
        prefixCls: prefixCls,
        iconPrefix: iconPrefix,
        className: stepsClassName
    })));
};
$607238fe01d03e7c$var$Steps.Step = (0, $716a13c8dd93d151$export$2e2bcd8739ae039).Step;
var $607238fe01d03e7c$export$2e2bcd8739ae039 = $607238fe01d03e7c$var$Steps;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $3385aaf64f93b436$var$CheckCircleTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "check-circle",
    "theme": "twotone"
};
var $3385aaf64f93b436$export$2e2bcd8739ae039 = $3385aaf64f93b436$var$CheckCircleTwoTone;



var $6aa79cbfa41e2a73$var$CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $3385aaf64f93b436$export$2e2bcd8739ae039)
    }));
};
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIGZpbGw9IiMxNjc3ZmYiIC8+PHBhdGggZD0iTTUxMiAxNDBjLTIwNS40IDAtMzcyIDE2Ni42LTM3MiAzNzJzMTY2LjYgMzcyIDM3MiAzNzIgMzcyLTE2Ni42IDM3Mi0zNzItMTY2LjYtMzcyLTM3Mi0zNzJ6bTE5My40IDIyNS43bC0yMTAuNiAyOTJhMzEuOCAzMS44IDAgMDEtNTEuNyAwTDMxOC41IDQ4NC45Yy0zLjgtNS4zIDAtMTIuNyA2LjUtMTIuN2g0Ni45YzEwLjMgMCAxOS45IDUgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjQgMTUuNy0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi40IDEyLjd6IiBmaWxsPSIjZTZmNGZmIiAvPjxwYXRoIGQ9Ik02OTkgMzUzaC00Ni45Yy0xMC4yIDAtMTkuOSA0LjktMjUuOSAxMy4zTDQ2OSA1ODQuM2wtNzEuMi05OC44Yy02LTguMy0xNS42LTEzLjMtMjUuOS0xMy4zSDMyNWMtNi41IDAtMTAuMyA3LjQtNi41IDEyLjdsMTI0LjYgMTcyLjhhMzEuOCAzMS44IDAgMDA1MS43IDBsMjEwLjYtMjkyYzMuOS01LjMuMS0xMi43LTYuNC0xMi43eiIgZmlsbD0iIzE2NzdmZiIgLz48L3N2Zz4=) */ var $6aa79cbfa41e2a73$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($6aa79cbfa41e2a73$var$CheckCircleTwoTone);
var $6aa79cbfa41e2a73$export$2e2bcd8739ae039 = $6aa79cbfa41e2a73$var$RefIcon;


const $77dad2977f13711f$var$Roadmap = ({ setIsAuthenticated: setIsAuthenticated, collapsed: collapsed })=>{
    const [highestCompletedTask, setHighestCompletedTask] = (0, $acw62.useState)(0);
    const [delayRender, setDelayRender] = (0, $acw62.useState)(collapsed);
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) throw new Error("ProblemContext must be used within a ProblemProvider");
    const { currentTask: currentTask, tasks: tasks, problem: problem } = problemContext;
    const items = tasks?.map((task)=>{
        const { id: id, ...rest } = task;
        return {
            ...rest
        };
    });
    (0, $acw62.useEffect)(()=>{
        const handlePointerDown = (e)=>{
            e.stopPropagation();
            const currentTarget = e.currentTarget;
        };
        const subSteps = document.querySelectorAll(".subStep");
        subSteps.forEach((task)=>{
            task.addEventListener("pointerdown", handlePointerDown);
        });
        return ()=>{
            subSteps.forEach((task)=>{
                task.removeEventListener("pointerdown", handlePointerDown);
            });
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        setHighestCompletedTask(currentTask === -1 ? tasks.length : currentTask);
    }, [
        currentTask,
        tasks
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!collapsed) {
            const timer = setTimeout(()=>{
                setDelayRender(collapsed);
            }, 300);
            return ()=>{
                clearTimeout(timer);
            };
        } else setDelayRender(collapsed);
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `sidebarContainer ${collapsed ? "sidebarCollapsed" : ""}`,
        children: !delayRender && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                    className: "roadmapHeader",
                    children: [
                        "Problem ",
                        problem?.problem_number,
                        " Tasks"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "taskProgressContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                tasks.reduce((a, b)=>{
                                    if (b.task_status === "completed") return a + 1;
                                    return a;
                                }, 0),
                                "/",
                                tasks.length,
                                " ",
                                highestCompletedTask === tasks.length ? "All tasks completed" : `Tasks completed`
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("progress", {
                            value: tasks.reduce((a, b)=>{
                                if (b.task_status === "completed") return a + 1;
                                return a;
                            }, 0),
                            max: tasks.length,
                            id: "taskProgress"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $607238fe01d03e7c$export$2e2bcd8739ae039), {
                    className: "roadmapSteps",
                    current: currentTask,
                    direction: "vertical",
                    labelPlacement: "horizontal",
                    children: items.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $607238fe01d03e7c$export$2e2bcd8739ae039).Step, {
                            title: item.title,
                            description: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "stepDescriptionText",
                                children: item.description
                            }),
                            icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                                title: item.task_status === "completed" ? "Complete" : "Incomplete",
                                children: item.task_status === "completed" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa79cbfa41e2a73$export$2e2bcd8739ae039), {
                                    twoToneColor: "lightgreen"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "unfinishedTaskIcon",
                                    style: {
                                        color: `${currentTask === index ? "grey" : undefined}`
                                    }
                                })
                            })
                        }, index))
                })
            ]
        })
    });
};
var $77dad2977f13711f$export$2e2bcd8739ae039 = $77dad2977f13711f$var$Roadmap;









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $20d973f7249e2921$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
var $20d973f7249e2921$export$2e2bcd8739ae039 = $20d973f7249e2921$var$EditOutlined;



var $498b707c3c04dc0a$var$EditOutlined = function EditOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $20d973f7249e2921$export$2e2bcd8739ae039)
    }));
};
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ var $498b707c3c04dc0a$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($498b707c3c04dc0a$var$EditOutlined);
var $498b707c3c04dc0a$export$2e2bcd8739ae039 = $498b707c3c04dc0a$var$RefIcon;











var $acw62 = parcelRequire("acw62");

"use client";
var $3aff44b895d5798c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3aff44b895d5798c$var$inlineStyle = {
    border: 0,
    background: "transparent",
    padding: 0,
    lineHeight: "inherit",
    display: "inline-flex"
};
const $3aff44b895d5798c$var$TransButton = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const onKeyDown = (event)=>{
        const { keyCode: keyCode } = event;
        if (keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) event.preventDefault();
    };
    const onKeyUp = (event)=>{
        const { keyCode: keyCode } = event;
        const { onClick: onClick } = props;
        if (keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER && onClick) onClick();
    };
    const { style: style, noStyle: noStyle, disabled: disabled, tabIndex: tabIndex = 0 } = props, restProps = $3aff44b895d5798c$var$__rest(props, [
        "style",
        "noStyle",
        "disabled",
        "tabIndex"
    ]);
    let mergedStyle = {};
    if (!noStyle) mergedStyle = Object.assign({}, $3aff44b895d5798c$var$inlineStyle);
    if (disabled) mergedStyle.pointerEvents = "none";
    mergedStyle = Object.assign(Object.assign({}, mergedStyle), style);
    return /*#__PURE__*/ $acw62.createElement("div", Object.assign({
        role: "button",
        tabIndex: tabIndex,
        ref: ref
    }, restProps, {
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        style: mergedStyle
    }));
});
var $3aff44b895d5798c$export$2e2bcd8739ae039 = $3aff44b895d5798c$var$TransButton;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $579f6109eaa96326$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
var $579f6109eaa96326$export$2e2bcd8739ae039 = $579f6109eaa96326$var$EnterOutlined;



var $ac0f9536ca737b46$var$EnterOutlined = function EnterOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $579f6109eaa96326$export$2e2bcd8739ae039)
    }));
};
/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ var $ac0f9536ca737b46$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($ac0f9536ca737b46$var$EnterOutlined);
var $ac0f9536ca737b46$export$2e2bcd8739ae039 = $ac0f9536ca737b46$var$RefIcon;








/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/ 


// eslint-disable-next-line import/prefer-default-export
const $950f24b0c690e3c4$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $950f24b0c690e3c4$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $950f24b0c690e3c4$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $950f24b0c690e3c4$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        "a&, a": Object.assign(Object.assign({}, (0, $d48037fcbf78d816$export$9a16e7694a707ab4)(token)), {
            textDecoration: token.linkDecoration,
            "&:active, &:hover": {
                textDecoration: token.linkHoverDecoration
            },
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                "&:active, &:hover": {
                    color: token.colorTextDisabled
                },
                "&:active": {
                    pointerEvents: "none"
                }
            }
        })
    };
};
const $950f24b0c690e3c4$export$977383a86f45014b = (token)=>({
        code: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.2em 0.1em",
            fontSize: "85%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.1)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderRadius: 3
        },
        kbd: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.15em 0.1em",
            fontSize: "90%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.06)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $0b4842326956570d$export$c24201f7fe3571d8)[2]
        },
        "u, ins": {
            textDecoration: "underline",
            textDecorationSkipInk: "auto"
        },
        "s, del": {
            textDecoration: "line-through"
        },
        strong: {
            fontWeight: 600
        },
        // list
        "ul, ol": {
            marginInline: 0,
            marginBlock: "0 1em",
            padding: 0,
            li: {
                marginInline: "20px 0",
                marginBlock: 0,
                paddingInline: "4px 0",
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: "circle",
            ul: {
                listStyleType: "disc"
            }
        },
        ol: {
            listStyleType: "decimal"
        },
        // pre & block
        "pre, blockquote": {
            margin: "1em 0"
        },
        pre: {
            padding: "0.4em 0.6em",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            background: "rgba(150, 150, 150, 0.1)",
            border: "1px solid rgba(100, 100, 100, 0.2)",
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: "inline",
                margin: 0,
                padding: 0,
                fontSize: "inherit",
                fontFamily: "inherit",
                background: "transparent",
                border: 0
            }
        },
        blockquote: {
            paddingInline: "0.6em 0",
            paddingBlock: 0,
            borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
            opacity: 0.85
        }
    });
const $950f24b0c690e3c4$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        "&-edit-content": {
            position: "relative",
            "div&": {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                marginTop: token.calc(inputShift).mul(-1).equal(),
                marginBottom: `calc(1em - ${(0, $f97444ff16d95e90$export$523c0b569236b342)(inputShift)})`
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: "absolute",
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorTextDescription,
                // default style
                fontWeight: "normal",
                fontSize: token.fontSize,
                fontStyle: "normal",
                pointerEvents: "none"
            },
            textarea: {
                margin: "0!important",
                // Fix Editable Textarea flash in Firefox
                MozTransition: "none",
                height: "1em"
            }
        }
    };
};
const $950f24b0c690e3c4$export$34755446404037a5 = (token)=>({
        [`${token.componentCls}-copy-success`]: {
            [`
    &,
    &:hover,
    &:focus`]: {
                color: token.colorSuccess
            }
        },
        [`${token.componentCls}-copy-icon-only`]: {
            marginInlineStart: 0
        }
    });
const $950f24b0c690e3c4$export$d9556a50eba3003b = ()=>({
        [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
            display: "inline-block",
            maxWidth: "100%"
        },
        "&-ellipsis-single-line": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            // https://blog.csdn.net/iefreer/article/details/50421025
            "a&, span&": {
                verticalAlign: "bottom"
            },
            "> code": {
                paddingBlock: 0,
                maxWidth: "calc(100% - 1.2em)",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: "content-box"
            }
        },
        "&-ellipsis-multiple-line": {
            display: "-webkit-box",
            overflow: "hidden",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical"
        }
    });


const $29a5bb3c87e057f0$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
            color: token.colorText,
            wordBreak: "break-word",
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success`]: {
                color: token.colorSuccess
            },
            [`&${componentCls}-warning`]: {
                color: token.colorWarning
            },
            [`&${componentCls}-danger`]: {
                color: token.colorError,
                "a&:active, a&:focus": {
                    color: token.colorErrorActive
                },
                "a&:hover": {
                    color: token.colorErrorHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                userSelect: "none"
            },
            [`
        div&,
        p
      `]: {
                marginBottom: "1em"
            }
        }, (0, $950f24b0c690e3c4$export$83146cf7d1bec659)(token)), {
            [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
                marginTop: titleMarginTop
            },
            [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
                [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
                    marginTop: titleMarginTop
                }
            }
        }), (0, $950f24b0c690e3c4$export$977383a86f45014b)(token)), (0, $950f24b0c690e3c4$export$566f4066c7caac18)(token)), {
            // Operation
            [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: Object.assign(Object.assign({}, (0, $d48037fcbf78d816$export$9a16e7694a707ab4)(token)), {
                marginInlineStart: token.marginXXS
            })
        }), (0, $950f24b0c690e3c4$export$2667badb03518972)(token)), (0, $950f24b0c690e3c4$export$34755446404037a5)(token)), (0, $950f24b0c690e3c4$export$d9556a50eba3003b)()), {
            "&-rtl": {
                direction: "rtl"
            }
        })
    };
};
const $29a5bb3c87e057f0$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: "1.2em",
        titleMarginBottom: "0.5em"
    });
var // ============================== Export ==============================
$29a5bb3c87e057f0$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Typography", (token)=>[
        $29a5bb3c87e057f0$var$genTypographyStyle(token)
    ], $29a5bb3c87e057f0$export$9ca1be8807fe0675);


"use client";
const $8a5b8988dc6b65c3$var$Editable = (props)=>{
    const { prefixCls: prefixCls, "aria-label": ariaLabel, className: className, style: style, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $acw62.createElement((0, $ac0f9536ca737b46$export$2e2bcd8739ae039), null) } = props;
    const ref = $acw62.useRef(null);
    const inComposition = $acw62.useRef(false);
    const lastKeyCode = $acw62.useRef();
    const [current, setCurrent] = $acw62.useState(value);
    $acw62.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $acw62.useEffect(()=>{
        var _a;
        if ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = (_ref)=>{
        let { target: target } = _ref;
        setCurrent(target.value.replace(/[\n\r]/g, ""));
    };
    const onCompositionStart = ()=>{
        inComposition.current = true;
    };
    const onCompositionEnd = ()=>{
        inComposition.current = false;
    };
    const onKeyDown = (_ref2)=>{
        let { keyCode: keyCode } = _ref2;
        // We don't record keyCode when IME is using
        if (inComposition.current) return;
        lastKeyCode.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = (_ref3)=>{
        let { keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey } = _ref3;
        // Check if it's a real key
        if (lastKeyCode.current === keyCode && !inComposition.current && !ctrlKey && !altKey && !metaKey && !shiftKey) {
            if (keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) {
                confirmChange();
                onEnd === null || onEnd === void 0 || onEnd();
            } else if (keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ESC) onCancel();
        }
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const textClassName = component ? `${prefixCls}-${component}` : "";
    const [wrapCSSVar, hashId, cssVarCls] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, textClassName, hashId, cssVarCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", {
        className: textAreaClassName,
        style: style
    }, /*#__PURE__*/ $acw62.createElement((0, $fc29eec8796e8593$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize
    }), enterIcon !== null ? (0, $30796c32f374b477$export$e530037191fcd5d7)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null));
};
var $8a5b8988dc6b65c3$export$2e2bcd8739ae039 = $8a5b8988dc6b65c3$var$Editable;



var $acw62 = parcelRequire("acw62");
var $e5a78797c4262d1f$exports = {};
"use strict";
var $9e6bd5018912b3a9$exports = {};
$9e6bd5018912b3a9$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9e6bd5018912b3a9$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$e5a78797c4262d1f$exports = $e5a78797c4262d1f$var$copy;



var $03d6c4dc81f23be0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $03d6c4dc81f23be0$var$useCopyClick = (_ref)=>{
    let { copyConfig: copyConfig, children: children } = _ref;
    const [copied, setCopied] = $acw62.useState(false);
    const [copyLoading, setCopyLoading] = $acw62.useState(false);
    const copyIdRef = $acw62.useRef(null);
    const cleanCopyId = ()=>{
        if (copyIdRef.current) clearTimeout(copyIdRef.current);
    };
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    $acw62.useEffect(()=>cleanCopyId, []);
    // Keep copy action up to date
    const onClick = (0, $01e43e72865dc583$export$2e2bcd8739ae039)((e)=>$03d6c4dc81f23be0$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            e === null || e === void 0 || e.preventDefault();
            e === null || e === void 0 || e.stopPropagation();
            setCopyLoading(true);
            try {
                const text = typeof copyConfig.text === "function" ? yield copyConfig.text() : copyConfig.text;
                (0, (/*@__PURE__*/$parcel$interopDefault($e5a78797c4262d1f$exports)))(text || String(children) || "", copyOptions);
                setCopyLoading(false);
                setCopied(true);
                // Trigger tips update
                cleanCopyId();
                copyIdRef.current = setTimeout(()=>{
                    setCopied(false);
                }, 3000);
                (_a = copyConfig.onCopy) === null || _a === void 0 || _a.call(copyConfig, e);
            } catch (error) {
                setCopyLoading(false);
                throw error;
            }
        }));
    return {
        copied: copied,
        copyLoading: copyLoading,
        onClick: onClick
    };
};
var $03d6c4dc81f23be0$export$2e2bcd8739ae039 = $03d6c4dc81f23be0$var$useCopyClick;



var $acw62 = parcelRequire("acw62");
function $4f54d14ab15fca01$export$2e2bcd8739ae039(propConfig, templateConfig) {
    return $acw62.useMemo(()=>{
        const support = !!propConfig;
        return [
            support,
            Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === "object" ? propConfig : null)
        ];
    }, [
        propConfig
    ]);
}



var $acw62 = parcelRequire("acw62");
const $4564445e53d0f3b9$var$usePrevious = (value)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $4564445e53d0f3b9$export$2e2bcd8739ae039 = $4564445e53d0f3b9$var$usePrevious;



var $acw62 = parcelRequire("acw62");
/** Similar with `useEffect` but only trigger after mounted */ const $16a6c1cd6424d279$var$useUpdatedEffect = (callback, conditions)=>{
    const mountRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (mountRef.current) callback();
        else mountRef.current = true;
    }, conditions);
};
var $16a6c1cd6424d279$export$2e2bcd8739ae039 = $16a6c1cd6424d279$var$useUpdatedEffect;



var $acw62 = parcelRequire("acw62");





"use client";
var $a3673f44358dd6b6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $a3673f44358dd6b6$var$Typography = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, component: Component = "article", className: className, rootClassName: rootClassName, setContentRef: setContentRef, children: children, direction: typographyDirection, style: style } = props, restProps = $a3673f44358dd6b6$var$__rest(props, [
        "prefixCls",
        "component",
        "className",
        "rootClassName",
        "setContentRef",
        "children",
        "direction",
        "style"
    ]);
    const { getPrefixCls: getPrefixCls, direction: contextDirection, typography: typography } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
    let mergedRef = ref;
    if (setContentRef) mergedRef = (0, $5e297877593af644$export$ab452c34e8e05029)(ref, setContentRef);
    const prefixCls = getPrefixCls("typography", customizePrefixCls);
    // Style
    const [wrapCSSVar, hashId, cssVarCls] = (0, $29a5bb3c87e057f0$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, typography === null || typography === void 0 ? void 0 : typography.className, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, typography === null || typography === void 0 ? void 0 : typography.style), style);
    return wrapCSSVar(/*#__PURE__*/ // @ts-expect-error: Expression produces a union type that is too complex to represent.
    $acw62.createElement(Component, Object.assign({
        className: componentClassName,
        style: mergedStyle,
        ref: mergedRef
    }, restProps), children));
});
var // es default export should use const instead of let
$a3673f44358dd6b6$export$2e2bcd8739ae039 = $a3673f44358dd6b6$var$Typography;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4da90ab6d25f30a4$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
var $4da90ab6d25f30a4$export$2e2bcd8739ae039 = $4da90ab6d25f30a4$var$CopyOutlined;



var $cf161c40cf97635f$var$CopyOutlined = function CopyOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4da90ab6d25f30a4$export$2e2bcd8739ae039)
    }));
};
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ var $cf161c40cf97635f$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($cf161c40cf97635f$var$CopyOutlined);
var $cf161c40cf97635f$export$2e2bcd8739ae039 = $cf161c40cf97635f$var$RefIcon;






function $670def8f8d6657a1$export$effcdbd76139450(val) {
    if (val === false) return [
        false,
        false
    ];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $670def8f8d6657a1$export$3f778c4e796a1f9c(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}


"use client";
const $f52e626a12e29853$var$CopyBtn = (props)=>{
    const { prefixCls: prefixCls, copied: copied, locale: locale, iconOnly: iconOnly, tooltips: tooltips, icon: icon, loading: btnLoading, tabIndex: tabIndex, onCopy: onCopy } = props;
    const tooltipNodes = (0, $670def8f8d6657a1$export$effcdbd76139450)(tooltips);
    const iconNodes = (0, $670def8f8d6657a1$export$effcdbd76139450)(icon);
    const { copied: copiedText, copy: copyText } = locale !== null && locale !== void 0 ? locale : {};
    const copyTitle = copied ? (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(tooltipNodes[1], copiedText) : (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(tooltipNodes[0], copyText);
    const systemStr = copied ? copiedText : copyText;
    const ariaLabel = typeof copyTitle === "string" ? copyTitle : systemStr;
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
        key: "copy",
        title: copyTitle
    }, /*#__PURE__*/ $acw62.createElement((0, $3aff44b895d5798c$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-copy`, {
            [`${prefixCls}-copy-success`]: copied,
            [`${prefixCls}-copy-icon-only`]: iconOnly
        }),
        onClick: onCopy,
        "aria-label": ariaLabel,
        tabIndex: tabIndex
    }, copied ? (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(iconNodes[1], /*#__PURE__*/ $acw62.createElement((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), null), true) : (0, $670def8f8d6657a1$export$3f778c4e796a1f9c)(iconNodes[0], btnLoading ? /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $acw62.createElement((0, $cf161c40cf97635f$export$2e2bcd8739ae039), null), true)));
};
var $f52e626a12e29853$export$2e2bcd8739ae039 = $f52e626a12e29853$var$CopyBtn;




var $acw62 = parcelRequire("acw62");


"use client";
const $89c852553f755dc1$var$MeasureText = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { style: style, children: children } = _ref;
    const spanRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>({
            isExceed: ()=>{
                const span = spanRef.current;
                return span.scrollHeight > span.clientHeight;
            },
            getHeight: ()=>spanRef.current.clientHeight
        }));
    return /*#__PURE__*/ $acw62.createElement("span", {
        "aria-hidden": true,
        ref: spanRef,
        style: Object.assign({
            position: "fixed",
            display: "block",
            left: 0,
            top: 0,
            pointerEvents: "none",
            backgroundColor: "rgba(255, 0, 0, 0.65)"
        }, style)
    }, children);
});
function $89c852553f755dc1$var$cuttable(node) {
    const type = typeof node;
    return type === "string" || type === "number";
}
function $89c852553f755dc1$var$getNodesLen(nodeList) {
    let totalLen = 0;
    nodeList.forEach((node)=>{
        if ($89c852553f755dc1$var$cuttable(node)) totalLen += String(node).length;
        else totalLen += 1;
    });
    return totalLen;
}
function $89c852553f755dc1$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = $89c852553f755dc1$var$cuttable(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const $89c852553f755dc1$var$STATUS_MEASURE_NONE = 0;
const $89c852553f755dc1$var$STATUS_MEASURE_PREPARE = 1;
const $89c852553f755dc1$var$STATUS_MEASURE_START = 2;
const $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS = 3;
const $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const $89c852553f755dc1$var$lineClipStyle = {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
};
function $89c852553f755dc1$export$2e2bcd8739ae039(props) {
    const { enableMeasure: enableMeasure, width: width, text: text, children: children, rows: rows, expanded: expanded, miscDeps: miscDeps, onEllipsis: onEllipsis } = props;
    const nodeList = $acw62.useMemo(()=>(0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(text), [
        text
    ]);
    const nodeLen = $acw62.useMemo(()=>$89c852553f755dc1$var$getNodesLen(nodeList), [
        text
    ]);
    // ========================= Full Content =========================
    // Used for measure only, which means it's always render as no need ellipsis
    const fullContent = $acw62.useMemo(()=>children(nodeList, false), [
        text
    ]);
    // ========================= Cut Content ==========================
    const [ellipsisCutIndex, setEllipsisCutIndex] = $acw62.useState(null);
    const cutMidRef = $acw62.useRef(null);
    // ========================= NeedEllipsis =========================
    const measureWhiteSpaceRef = $acw62.useRef(null);
    const needEllipsisRef = $acw62.useRef(null);
    // Measure for `rows-1` height, to avoid operation exceed the line height
    const descRowsEllipsisRef = $acw62.useRef(null);
    const symbolRowEllipsisRef = $acw62.useRef(null);
    const [canEllipsis, setCanEllipsis] = $acw62.useState(false);
    const [needEllipsis, setNeedEllipsis] = $acw62.useState($89c852553f755dc1$var$STATUS_MEASURE_NONE);
    const [ellipsisHeight, setEllipsisHeight] = $acw62.useState(0);
    const [parentWhiteSpace, setParentWhiteSpace] = $acw62.useState(null);
    // Trigger start measure
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        if (enableMeasure && width && nodeLen) setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_PREPARE);
        else setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_NONE);
    }, [
        width,
        text,
        rows,
        enableMeasure,
        nodeList
    ]);
    // Measure process
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        var _a, _b, _c, _d;
        if (needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_PREPARE) {
            setNeedEllipsis($89c852553f755dc1$var$STATUS_MEASURE_START);
            // Parent ref `white-space`
            const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
            setParentWhiteSpace(nextWhiteSpace);
        } else if (needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_START) {
            const isOverflow = !!((_a = needEllipsisRef.current) === null || _a === void 0 ? void 0 : _a.isExceed());
            setNeedEllipsis(isOverflow ? $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS : $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS);
            setEllipsisCutIndex(isOverflow ? [
                0,
                nodeLen
            ] : null);
            setCanEllipsis(isOverflow);
            // Get the basic height of ellipsis rows
            const baseRowsEllipsisHeight = ((_b = needEllipsisRef.current) === null || _b === void 0 ? void 0 : _b.getHeight()) || 0;
            // Get the height of `rows - 1` + symbol height
            const descRowsEllipsisHeight = rows === 1 ? 0 : ((_c = descRowsEllipsisRef.current) === null || _c === void 0 ? void 0 : _c.getHeight()) || 0;
            const symbolRowEllipsisHeight = ((_d = symbolRowEllipsisRef.current) === null || _d === void 0 ? void 0 : _d.getHeight()) || 0;
            const rowsWithEllipsisHeight = descRowsEllipsisHeight + symbolRowEllipsisHeight;
            const maxRowsHeight = Math.max(baseRowsEllipsisHeight, rowsWithEllipsisHeight);
            setEllipsisHeight(maxRowsHeight + 1);
            onEllipsis(isOverflow);
        }
    }, [
        needEllipsis
    ]);
    // ========================= Cut Measure ==========================
    const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        var _a;
        const [minIndex, maxIndex] = ellipsisCutIndex || [
            0,
            0
        ];
        if (minIndex !== maxIndex) {
            const midHeight = ((_a = cutMidRef.current) === null || _a === void 0 ? void 0 : _a.getHeight()) || 0;
            const isOverflow = midHeight > ellipsisHeight;
            let targetMidIndex = cutMidIndex;
            if (maxIndex - minIndex === 1) targetMidIndex = isOverflow ? minIndex : maxIndex;
            if (isOverflow) setEllipsisCutIndex([
                minIndex,
                targetMidIndex
            ]);
            else setEllipsisCutIndex([
                targetMidIndex,
                maxIndex
            ]);
        }
    }, [
        ellipsisCutIndex,
        cutMidIndex
    ]);
    // ========================= Text Content =========================
    const finalContent = $acw62.useMemo(()=>{
        if (needEllipsis !== $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
            const content = children(nodeList, false);
            // Limit the max line count to avoid scrollbar blink
            // https://github.com/ant-design/ant-design/issues/42958
            if (needEllipsis !== $89c852553f755dc1$var$STATUS_MEASURE_NO_NEED_ELLIPSIS && needEllipsis !== $89c852553f755dc1$var$STATUS_MEASURE_NONE) return /*#__PURE__*/ $acw62.createElement("span", {
                style: Object.assign(Object.assign({}, $89c852553f755dc1$var$lineClipStyle), {
                    WebkitLineClamp: rows
                })
            }, content);
            return content;
        }
        return children(expanded ? nodeList : $89c852553f755dc1$var$sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
    }, [
        expanded,
        needEllipsis,
        ellipsisCutIndex,
        nodeList
    ].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(miscDeps)));
    // ============================ Render ============================
    const measureStyle = {
        width: width,
        margin: 0,
        padding: 0,
        whiteSpace: parentWhiteSpace === "nowrap" ? "normal" : "inherit"
    };
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, finalContent, needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_START && /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $89c852553f755dc1$var$lineClipStyle), {
            WebkitLineClamp: rows
        }),
        ref: needEllipsisRef
    }, fullContent), /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $89c852553f755dc1$var$lineClipStyle), {
            WebkitLineClamp: rows - 1
        }),
        ref: descRowsEllipsisRef
    }, fullContent), /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign(Object.assign({}, measureStyle), $89c852553f755dc1$var$lineClipStyle), {
            WebkitLineClamp: 1
        }),
        ref: symbolRowEllipsisRef
    }, children([], true))), needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /*#__PURE__*/ $acw62.createElement($89c852553f755dc1$var$MeasureText, {
        style: Object.assign(Object.assign({}, measureStyle), {
            top: 400
        }),
        ref: cutMidRef
    }, children($89c852553f755dc1$var$sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === $89c852553f755dc1$var$STATUS_MEASURE_PREPARE && /*#__PURE__*/ $acw62.createElement("span", {
        style: {
            whiteSpace: "inherit"
        },
        ref: measureWhiteSpaceRef
    }));
}



var $acw62 = parcelRequire("acw62");

"use client";
const $2c5f09c9102f607d$var$EllipsisTooltip = (_ref)=>{
    let { enableEllipsis: enableEllipsis, isEllipsis: isEllipsis, children: children, tooltipProps: tooltipProps } = _ref;
    if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enableEllipsis) return children;
    return /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), Object.assign({
        open: isEllipsis ? undefined : false
    }, tooltipProps), children);
};
var $2c5f09c9102f607d$export$2e2bcd8739ae039 = $2c5f09c9102f607d$var$EllipsisTooltip;


"use client";
var $c756fe581e322b8b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $c756fe581e322b8b$var$wrapperDecorations(_ref, content) {
    let { mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic } = _ref;
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $acw62.createElement(tag, {}, currentContent);
    }
    wrap("strong", strong);
    wrap("u", underline);
    wrap("del", del);
    wrap("code", code);
    wrap("mark", mark);
    wrap("kbd", keyboard);
    wrap("i", italic);
    return currentContent;
}
const $c756fe581e322b8b$var$ELLIPSIS_STR = "...";
const $c756fe581e322b8b$var$Base = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var _a, _b, _c;
    const { prefixCls: customizePrefixCls, className: className, style: style, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, component: component, title: title } = props, restProps = $c756fe581e322b8b$var$__rest(props, [
        "prefixCls",
        "className",
        "style",
        "type",
        "disabled",
        "children",
        "ellipsis",
        "editable",
        "copyable",
        "component",
        "title"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const [textLocale] = (0, $0020add6ec984361$export$2e2bcd8739ae039)("Text");
    const typographyRef = $acw62.useRef(null);
    const editIconRef = $acw62.useRef(null);
    // ============================ MISC ============================
    const prefixCls = getPrefixCls("typography", customizePrefixCls);
    const textProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(restProps, [
        "mark",
        "code",
        "delete",
        "underline",
        "strong",
        "keyboard",
        "italic"
    ]);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(false, {
        value: editConfig.editing
    });
    const { triggerType: triggerType = [
        "icon"
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        var _a;
        if (edit) (_a = editConfig.onStart) === null || _a === void 0 || _a.call(editConfig);
        setEditing(edit);
    };
    // Focus edit icon when back
    const prevEditing = (0, $4564445e53d0f3b9$export$2e2bcd8739ae039)(editing);
    (0, $16a6c1cd6424d279$export$2e2bcd8739ae039)(()=>{
        var _a;
        if (!editing && prevEditing) (_a = editIconRef.current) === null || _a === void 0 || _a.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e === null || e === void 0 || e.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        var _a;
        (_a = editConfig.onChange) === null || _a === void 0 || _a.call(editConfig, value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        var _a;
        (_a = editConfig.onCancel) === null || _a === void 0 || _a.call(editConfig);
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(copyable);
    const { copied: copied, copyLoading: copyLoading, onClick: onCopyClick } = (0, $03d6c4dc81f23be0$export$2e2bcd8739ae039)({
        copyConfig: copyConfig,
        children: children
    });
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $acw62.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $acw62.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $acw62.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $acw62.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $acw62.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $4f54d14ab15fca01$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false,
        symbol: (isExpanded)=>isExpanded ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
    });
    const [expanded, setExpanded] = (0, $dbf5d1f4f4ecbb6a$export$2e2bcd8739ae039)(ellipsisConfig.defaultExpanded || false, {
        value: ellipsisConfig.expanded
    });
    const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === "collapsible");
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $acw62.useMemo(()=>// Disable ellipsis
        mergedEnableEllipsis && // Provide suffix
        (ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy), [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $5ac27a8c1ec0b63e$export$d616d7831008e86c)("webkitLineClamp"));
            setIsTextOverflowSupport((0, $5ac27a8c1ec0b63e$export$d616d7831008e86c)("textOverflow"));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const [cssEllipsis, setCssEllipsis] = $acw62.useState(mergedEnableEllipsis);
    const canUseCssEllipsis = $acw62.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        isTextOverflowSupport,
        isLineClampSupport
    ]);
    // We use effect to change from css ellipsis to js ellipsis.
    // To make SSR still can see the ellipsis.
    (0, $493347a9fd5d8394$export$2e2bcd8739ae039)(()=>{
        setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
    }, [
        canUseCssEllipsis,
        mergedEnableEllipsis
    ]);
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e, info)=>{
        var _a;
        setExpanded(info.expanded);
        (_a = ellipsisConfig.onExpand) === null || _a === void 0 || _a.call(ellipsisConfig, e, info);
    };
    const [ellipsisWidth, setEllipsisWidth] = $acw62.useState(0);
    const onResize = (_ref2)=>{
        let { offsetWidth: offsetWidth } = _ref2;
        setEllipsisWidth(offsetWidth);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        var _a;
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) (_a = ellipsisConfig.onEllipsis) === null || _a === void 0 || _a.call(ellipsisConfig, jsEllipsis);
    };
    // >>>>> Native ellipsis
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && cssEllipsis && textEle) {
            const currentEllipsis = cssLineClamp ? textEle.offsetHeight < textEle.scrollHeight : textEle.offsetWidth < textEle.scrollWidth;
            if (isNativeEllipsis !== currentEllipsis) setIsNativeEllipsis(currentEllipsis);
        }
    }, [
        enableEllipsis,
        cssEllipsis,
        children,
        cssLineClamp,
        isNativeVisible,
        ellipsisWidth
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $acw62.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === "undefined" || !textEle || !cssEllipsis || !mergedEnableEllipsis) return;
        /* eslint-disable-next-line compat/compat */ const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        cssEllipsis,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    let tooltipProps = {};
    if (ellipsisConfig.tooltip === true) tooltipProps = {
        title: (_a = editConfig.text) !== null && _a !== void 0 ? _a : children
    };
    else if (/*#__PURE__*/ $acw62.isValidElement(ellipsisConfig.tooltip)) tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    else if (typeof ellipsisConfig.tooltip === "object") tooltipProps = Object.assign({
        title: (_b = editConfig.text) !== null && _b !== void 0 ? _b : children
    }, ellipsisConfig.tooltip);
    else tooltipProps = {
        title: ellipsisConfig.tooltip
    };
    const topAriaLabel = $acw62.useMemo(()=>{
        const isValid = (val)=>[
                "string",
                "number"
            ].includes(typeof val);
        if (!enableEllipsis || cssEllipsis) return undefined;
        if (isValid(editConfig.text)) return editConfig.text;
        if (isValid(children)) return children;
        if (isValid(title)) return title;
        if (isValid(tooltipProps.title)) return tooltipProps.title;
        return undefined;
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $acw62.createElement((0, $8a5b8988dc6b65c3$export$2e2bcd8739ae039), {
        value: (_c = editConfig.text) !== null && _c !== void 0 ? _c : typeof children === "string" ? children : "",
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        if (!expandable) return null;
        if (expanded && expandable !== "collapsible") return null;
        return /*#__PURE__*/ $acw62.createElement((0, $3aff44b895d5798c$export$2e2bcd8739ae039), {
            key: "expand",
            className: `${prefixCls}-${expanded ? "collapse" : "expand"}`,
            onClick: (e)=>onExpandClick(e, {
                    expanded: !expanded
                }),
            "aria-label": expanded ? textLocale.collapse : textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
        }, typeof symbol === "function" ? symbol(expanded) : symbol);
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip, tabIndex: tabIndex } = editConfig;
        const editTitle = (0, $e85c9ef0f09d251f$export$2e2bcd8739ae039)(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
        const ariaLabel = typeof editTitle === "string" ? editTitle : "";
        return triggerType.includes("icon") ? /*#__PURE__*/ $acw62.createElement((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? "" : editTitle
        }, /*#__PURE__*/ $acw62.createElement((0, $3aff44b895d5798c$export$2e2bcd8739ae039), {
            ref: editIconRef,
            className: `${prefixCls}-edit`,
            onClick: onEditClick,
            "aria-label": ariaLabel,
            tabIndex: tabIndex
        }, icon || /*#__PURE__*/ $acw62.createElement((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return null;
        return /*#__PURE__*/ $acw62.createElement((0, $f52e626a12e29853$export$2e2bcd8739ae039), Object.assign({
            key: "copy"
        }, copyConfig, {
            prefixCls: prefixCls,
            copied: copied,
            locale: textLocale,
            onCopy: onCopyClick,
            loading: copyLoading,
            iconOnly: children === null || children === undefined
        }));
    };
    const renderOperations = (canEllipsis)=>[
            // (renderExpanded || ellipsisConfig.collapsible) && renderExpand(),
            canEllipsis && renderExpand(),
            renderEdit(),
            renderCopy()
        ];
    const renderEllipsis = (canEllipsis)=>[
            canEllipsis && !expanded && /*#__PURE__*/ $acw62.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $c756fe581e322b8b$var$ELLIPSIS_STR),
            ellipsisConfig.suffix,
            renderOperations(canEllipsis)
        ];
    return /*#__PURE__*/ $acw62.createElement((0, $8aeee349dead8f85$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $acw62.createElement((0, $2c5f09c9102f607d$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enableEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis
        }, /*#__PURE__*/ $acw62.createElement((0, $a3673f44358dd6b6$export$2e2bcd8739ae039), Object.assign({
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
            }, className),
            prefixCls: customizePrefixCls,
            style: Object.assign(Object.assign({}, style), {
                WebkitLineClamp: cssLineClamp ? rows : undefined
            }),
            component: component,
            ref: (0, $5e297877593af644$export$ab452c34e8e05029)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes("text") ? onEditClick : undefined,
            "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
            title: title
        }, textProps), /*#__PURE__*/ $acw62.createElement((0, $89c852553f755dc1$export$2e2bcd8739ae039), {
            enableMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            onEllipsis: onJsEllipsis,
            expanded: expanded,
            miscDeps: [
                copied,
                expanded,
                copyLoading,
                enableEdit,
                enableCopy
            ]
        }, (node, canEllipsis)=>$c756fe581e322b8b$var$wrapperDecorations(props, /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? /*#__PURE__*/ $acw62.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, node) : node, renderEllipsis(canEllipsis)))))));
});
var $c756fe581e322b8b$export$2e2bcd8739ae039 = $c756fe581e322b8b$var$Base;


"use client";
var $e59afc5fcefd918d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e59afc5fcefd918d$var$Link = /*#__PURE__*/ $acw62.forwardRef((_a, ref)=>{
    var { ellipsis: ellipsis, rel: rel } = _a, restProps = $e59afc5fcefd918d$var$__rest(_a, [
        "ellipsis",
        "rel"
    ]);
    const mergedProps = Object.assign(Object.assign({}, restProps), {
        rel: rel === undefined && restProps.target === "_blank" ? "noopener noreferrer" : rel
    });
    // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    delete mergedProps.navigate;
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({}, mergedProps, {
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }));
});
var $e59afc5fcefd918d$export$2e2bcd8739ae039 = $e59afc5fcefd918d$var$Link;



var $acw62 = parcelRequire("acw62");

"use client";
const $32838ac41e3e19d1$var$Paragraph = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, props, {
        component: "div"
    })));
var $32838ac41e3e19d1$export$2e2bcd8739ae039 = $32838ac41e3e19d1$var$Paragraph;



var $acw62 = parcelRequire("acw62");



"use client";
var $3704098f38e9f562$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $3704098f38e9f562$var$Text = (_a, ref)=>{
    var { ellipsis: ellipsis } = _a, restProps = $3704098f38e9f562$var$__rest(_a, [
        "ellipsis"
    ]);
    const mergedEllipsis = $acw62.useMemo(()=>{
        if (ellipsis && typeof ellipsis === "object") return (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(ellipsis, [
            "expandable",
            "rows"
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        ellipsis: mergedEllipsis,
        component: "span"
    }));
};
var $3704098f38e9f562$export$2e2bcd8739ae039 = /*#__PURE__*/ $acw62.forwardRef($3704098f38e9f562$var$Text);



var $acw62 = parcelRequire("acw62");


"use client";
var $af44bdd0e8458ef3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $af44bdd0e8458ef3$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $af44bdd0e8458ef3$var$Title = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { level: level = 1 } = props, restProps = $af44bdd0e8458ef3$var$__rest(props, [
        "level"
    ]);
    let component;
    if ($af44bdd0e8458ef3$var$TITLE_ELE_LIST.includes(level)) component = `h${level}`;
    else component = "h1";
    return /*#__PURE__*/ $acw62.createElement((0, $c756fe581e322b8b$export$2e2bcd8739ae039), Object.assign({
        ref: ref
    }, restProps, {
        component: component
    }));
});
var $af44bdd0e8458ef3$export$2e2bcd8739ae039 = $af44bdd0e8458ef3$var$Title;



"use client";
const $69754065fe3b4b60$var$Typography = (0, $a3673f44358dd6b6$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Text = (0, $3704098f38e9f562$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Link = (0, $e59afc5fcefd918d$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Title = (0, $af44bdd0e8458ef3$export$2e2bcd8739ae039);
$69754065fe3b4b60$var$Typography.Paragraph = (0, $32838ac41e3e19d1$export$2e2bcd8739ae039);
var $69754065fe3b4b60$export$2e2bcd8739ae039 = $69754065fe3b4b60$var$Typography;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $ec30be32576c1d45$export$264c6064649f9206 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const $ec30be32576c1d45$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    message: {},
    notification: {},
    modal: {}
});
var $ec30be32576c1d45$export$2e2bcd8739ae039 = $ec30be32576c1d45$var$AppContext;




var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");

var $6be5862818f90611$var$Notify = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, className = props.className, _props$duration = props.duration, duration = _props$duration === void 0 ? 4.5 : _props$duration, showProgress = props.showProgress, _props$pauseOnHover = props.pauseOnHover, pauseOnHover = _props$pauseOnHover === void 0 ? true : _props$pauseOnHover, eventKey = props.eventKey, content = props.content, closable = props.closable, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? "x" : _props$closeIcon, divProps = props.props, onClick = props.onClick, onNoticeClose = props.onNoticeClose, times = props.times, forcedHovering = props.hovering;
    var _React$useState = $acw62.useState(false), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), hovering = _React$useState2[0], setHovering = _React$useState2[1];
    var _React$useState3 = $acw62.useState(0), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), percent = _React$useState4[0], setPercent = _React$useState4[1];
    var _React$useState5 = $acw62.useState(0), _React$useState6 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState5, 2), spentTime = _React$useState6[0], setSpentTime = _React$useState6[1];
    var mergedHovering = forcedHovering || hovering;
    var mergedShowProgress = duration > 0 && showProgress;
    // ======================== Close =========================
    var onInternalClose = function onInternalClose() {
        onNoticeClose(eventKey);
    };
    var onCloseKeyDown = function onCloseKeyDown(e) {
        if (e.key === "Enter" || e.code === "Enter" || e.keyCode === (0, $d8d9cb1a28007639$export$2e2bcd8739ae039).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    $acw62.useEffect(function() {
        if (!mergedHovering && duration > 0) {
            var start = Date.now() - spentTime;
            var timeout = setTimeout(function() {
                onInternalClose();
            }, duration * 1000 - spentTime);
            return function() {
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        mergedHovering,
        times
    ]);
    $acw62.useEffect(function() {
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            var start = performance.now();
            var animationFrame;
            var calculate = function calculate() {
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame(function(timestamp) {
                    var runtime = timestamp + spentTime - start;
                    var progress = Math.min(runtime / (duration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return function() {
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        duration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    var closableObj = $acw62.useMemo(function() {
        if ((0, $b8f57191916382d3$export$2e2bcd8739ae039)(closable) === "object" && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon
        };
        return {};
    }, [
        closable,
        closeIcon
    ]);
    var ariaProps = (0, $281efe5882c936de$export$2e2bcd8739ae039)(closableObj, true);
    // ======================== Progress ========================
    var validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    var noticePrefixCls = "".concat(prefixCls, "-notice");
    return /*#__PURE__*/ $acw62.createElement("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, divProps, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(noticePrefixCls, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(noticePrefixCls, "-closable"), closable)),
        style: style,
        onMouseEnter: function onMouseEnter(e) {
            var _divProps$onMouseEnte;
            setHovering(true);
            divProps === null || divProps === void 0 || (_divProps$onMouseEnte = divProps.onMouseEnter) === null || _divProps$onMouseEnte === void 0 || _divProps$onMouseEnte.call(divProps, e);
        },
        onMouseLeave: function onMouseLeave(e) {
            var _divProps$onMouseLeav;
            setHovering(false);
            divProps === null || divProps === void 0 || (_divProps$onMouseLeav = divProps.onMouseLeave) === null || _divProps$onMouseLeav === void 0 || _divProps$onMouseLeav.call(divProps, e);
        },
        onClick: onClick
    }), /*#__PURE__*/ $acw62.createElement("div", {
        className: "".concat(noticePrefixCls, "-content")
    }, content), closable && /*#__PURE__*/ $acw62.createElement("a", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: 0,
        className: "".concat(noticePrefixCls, "-close"),
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon), mergedShowProgress && /*#__PURE__*/ $acw62.createElement("progress", {
        className: "".concat(noticePrefixCls, "-progress"),
        max: "100",
        value: validPercent
    }, validPercent + "%"));
});
var $6be5862818f90611$export$2e2bcd8739ae039 = $6be5862818f90611$var$Notify;



var $acw62 = parcelRequire("acw62");
var $189ebb65137099c1$export$a6e93d8cb5d50678 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
var $189ebb65137099c1$var$NotificationProvider = function NotificationProvider(_ref) {
    var children = _ref.children, classNames = _ref.classNames;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($189ebb65137099c1$export$a6e93d8cb5d50678.Provider, {
        value: {
            classNames: classNames
        }
    }, children);
};
var $189ebb65137099c1$export$2e2bcd8739ae039 = $189ebb65137099c1$var$NotificationProvider;



var $f0f0b4f717b22ee3$var$DEFAULT_OFFSET = 8;
var $f0f0b4f717b22ee3$var$DEFAULT_THRESHOLD = 3;
var $f0f0b4f717b22ee3$var$DEFAULT_GAP = 16;
var $f0f0b4f717b22ee3$var$useStack = function useStack(config) {
    var result = {
        offset: $f0f0b4f717b22ee3$var$DEFAULT_OFFSET,
        threshold: $f0f0b4f717b22ee3$var$DEFAULT_THRESHOLD,
        gap: $f0f0b4f717b22ee3$var$DEFAULT_GAP
    };
    if (config && (0, $b8f57191916382d3$export$2e2bcd8739ae039)(config) === "object") {
        var _config$offset, _config$threshold, _config$gap;
        result.offset = (_config$offset = config.offset) !== null && _config$offset !== void 0 ? _config$offset : $f0f0b4f717b22ee3$var$DEFAULT_OFFSET;
        result.threshold = (_config$threshold = config.threshold) !== null && _config$threshold !== void 0 ? _config$threshold : $f0f0b4f717b22ee3$var$DEFAULT_THRESHOLD;
        result.gap = (_config$gap = config.gap) !== null && _config$gap !== void 0 ? _config$gap : $f0f0b4f717b22ee3$var$DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
var $f0f0b4f717b22ee3$export$2e2bcd8739ae039 = $f0f0b4f717b22ee3$var$useStack;


var $d47dcfb349f9c499$var$_excluded = [
    "className",
    "style",
    "classNames",
    "styles"
];
var $d47dcfb349f9c499$var$NoticeList = function NoticeList(props) {
    var configList = props.configList, placement = props.placement, prefixCls = props.prefixCls, className = props.className, style = props.style, motion = props.motion, onAllNoticeRemoved = props.onAllNoticeRemoved, onNoticeClose = props.onNoticeClose, stackConfig = props.stack;
    var _useContext = (0, $acw62.useContext)((0, $189ebb65137099c1$export$a6e93d8cb5d50678)), ctxCls = _useContext.classNames;
    var dictRef = (0, $acw62.useRef)({});
    var _useState = (0, $acw62.useState)(null), _useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState, 2), latestNotice = _useState2[0], setLatestNotice = _useState2[1];
    var _useState3 = (0, $acw62.useState)([]), _useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useState3, 2), hoverKeys = _useState4[0], setHoverKeys = _useState4[1];
    var keys = configList.map(function(config) {
        return {
            config: config,
            key: String(config.key)
        };
    });
    var _useStack = (0, $f0f0b4f717b22ee3$export$2e2bcd8739ae039)(stackConfig), _useStack2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_useStack, 2), stack = _useStack2[0], _useStack2$ = _useStack2[1], offset = _useStack2$.offset, threshold = _useStack2$.threshold, gap = _useStack2$.gap;
    var expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    var placementMotion = typeof motion === "function" ? motion(placement) : motion;
    // Clean hover key
    (0, $acw62.useEffect)(function() {
        if (stack && hoverKeys.length > 1) setHoverKeys(function(prev) {
            return prev.filter(function(key) {
                return keys.some(function(_ref) {
                    var dataKey = _ref.key;
                    return key === dataKey;
                });
            });
        });
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, $acw62.useEffect)(function() {
        var _keys;
        if (stack && dictRef.current[(_keys = keys[keys.length - 1]) === null || _keys === void 0 ? void 0 : _keys.key]) {
            var _keys2;
            setLatestNotice(dictRef.current[(_keys2 = keys[keys.length - 1]) === null || _keys2 === void 0 ? void 0 : _keys2.key]);
        }
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ab0f5c5a9767e13d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        key: placement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, "".concat(prefixCls, "-").concat(placement), ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.list, className, (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)((0, $f329557dcab6d0bb$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-stack"), !!stack), "".concat(prefixCls, "-stack-expanded"), expanded)),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: function onAllRemoved() {
            onAllNoticeRemoved(placement);
        }
    }), function(_ref2, nodeRef) {
        var config = _ref2.config, motionClassName = _ref2.className, motionStyle = _ref2.style, motionIndex = _ref2.index;
        var _ref3 = config, key = _ref3.key, times = _ref3.times;
        var strKey = String(key);
        var _ref4 = config, configClassName = _ref4.className, configStyle = _ref4.style, configClassNames = _ref4.classNames, configStyles = _ref4.styles, restConfig = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref4, $d47dcfb349f9c499$var$_excluded);
        var dataIndex = keys.findIndex(function(item) {
            return item.key === strKey;
        });
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        var stackStyle = {};
        if (stack) {
            var index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            var transformX = placement === "top" || placement === "bottom" ? "-50%" : "0";
            if (index > 0) {
                var _dictRef$current$strK, _dictRef$current$strK2, _dictRef$current$strK3;
                stackStyle.height = expanded ? (_dictRef$current$strK = dictRef.current[strKey]) === null || _dictRef$current$strK === void 0 ? void 0 : _dictRef$current$strK.offsetHeight : latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetHeight;
                // Transform
                var verticalOffset = 0;
                for(var i = 0; i < index; i++){
                    var _dictRef$current$keys;
                    verticalOffset += ((_dictRef$current$keys = dictRef.current[keys[keys.length - 1 - i].key]) === null || _dictRef$current$keys === void 0 ? void 0 : _dictRef$current$keys.offsetHeight) + gap;
                }
                var transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith("top") ? 1 : -1);
                var scaleX = !expanded && latestNotice !== null && latestNotice !== void 0 && latestNotice.offsetWidth && (_dictRef$current$strK2 = dictRef.current[strKey]) !== null && _dictRef$current$strK2 !== void 0 && _dictRef$current$strK2.offsetWidth ? ((latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetWidth) - offset * 2 * (index < 3 ? index : 3)) / ((_dictRef$current$strK3 = dictRef.current[strKey]) === null || _dictRef$current$strK3 === void 0 ? void 0 : _dictRef$current$strK3.offsetWidth) : 1;
                stackStyle.transform = "translate3d(".concat(transformX, ", ").concat(transformY, "px, 0) scaleX(").concat(scaleX, ")");
            } else stackStyle.transform = "translate3d(".concat(transformX, ", 0, 0)");
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: nodeRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("".concat(prefixCls, "-notice-wrapper"), motionClassName, configClassNames === null || configClassNames === void 0 ? void 0 : configClassNames.wrapper),
            style: (0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)((0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, motionStyle), stackStyle), configStyles === null || configStyles === void 0 ? void 0 : configStyles.wrapper),
            onMouseEnter: function onMouseEnter() {
                return setHoverKeys(function(prev) {
                    return prev.includes(strKey) ? prev : [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(prev), [
                        strKey
                    ]);
                });
            },
            onMouseLeave: function onMouseLeave() {
                return setHoverKeys(function(prev) {
                    return prev.filter(function(k) {
                        return k !== strKey;
                    });
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6be5862818f90611$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, restConfig, {
            ref: function ref(node) {
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(configClassName, ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
var $d47dcfb349f9c499$export$2e2bcd8739ae039 = $d47dcfb349f9c499$var$NoticeList;


// ant-notification ant-notification-topRight
var $08224a65c5b0e7df$var$Notifications = /*#__PURE__*/ $acw62.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-notification" : _props$prefixCls, container = props.container, motion = props.motion, maxCount = props.maxCount, className = props.className, style = props.style, onAllRemoved = props.onAllRemoved, stack = props.stack, renderNotifications = props.renderNotifications;
    var _React$useState = $acw62.useState([]), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), configList = _React$useState2[0], setConfigList = _React$useState2[1];
    // ======================== Close =========================
    var onNoticeClose = function onNoticeClose(key) {
        var _config$onClose;
        // Trigger close event
        var config = configList.find(function(item) {
            return item.key === key;
        });
        config === null || config === void 0 || (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
        setConfigList(function(list) {
            return list.filter(function(item) {
                return item.key !== key;
            });
        });
    };
    // ========================= Refs =========================
    $acw62.useImperativeHandle(ref, function() {
        return {
            open: function open(config) {
                setConfigList(function(list) {
                    var clone = (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(list);
                    // Replace if exist
                    var index = clone.findIndex(function(item) {
                        return item.key === config.key;
                    });
                    var innerConfig = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, config);
                    if (index >= 0) {
                        var _list$index;
                        innerConfig.times = (((_list$index = list[index]) === null || _list$index === void 0 ? void 0 : _list$index.times) || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: function close(key) {
                onNoticeClose(key);
            },
            destroy: function destroy() {
                setConfigList([]);
            }
        };
    });
    // ====================== Placements ======================
    var _React$useState3 = $acw62.useState({}), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), placements = _React$useState4[0], setPlacements = _React$useState4[1];
    $acw62.useEffect(function() {
        var nextPlacements = {};
        configList.forEach(function(config) {
            var _config$placement = config.placement, placement = _config$placement === void 0 ? "topRight" : _config$placement;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach(function(placement) {
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    var onAllNoticeRemoved = function onAllNoticeRemoved(placement) {
        setPlacements(function(originPlacements) {
            var clone = (0, $983350b7b3960a26$export$2e2bcd8739ae039)({}, originPlacements);
            var list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    var emptyRef = $acw62.useRef(false);
    $acw62.useEffect(function() {
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved === null || onAllRemoved === void 0 || onAllRemoved();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    var placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, $11492dca620dcaa5$exports.createPortal)(/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, placementList.map(function(placement) {
        var placementConfigList = placements[placement];
        var list = /*#__PURE__*/ $acw62.createElement((0, $d47dcfb349f9c499$export$2e2bcd8739ae039), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className === null || className === void 0 ? void 0 : className(placement),
            style: style === null || style === void 0 ? void 0 : style(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls: prefixCls,
            key: placement
        }) : list;
    })), container);
});
var $08224a65c5b0e7df$export$2e2bcd8739ae039 = $08224a65c5b0e7df$var$Notifications;


var $4fb0b9c84003ea9f$var$_excluded = [
    "getContainer",
    "motion",
    "prefixCls",
    "maxCount",
    "className",
    "style",
    "onAllRemoved",
    "stack",
    "renderNotifications"
];
var $4fb0b9c84003ea9f$var$defaultGetContainer = function defaultGetContainer() {
    return document.body;
};
var $4fb0b9c84003ea9f$var$uniqueKey = 0;
function $4fb0b9c84003ea9f$var$mergeConfig() {
    var clone = {};
    for(var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++)objList[_key] = arguments[_key];
    objList.forEach(function(obj) {
        if (obj) Object.keys(obj).forEach(function(key) {
            var val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function $4fb0b9c84003ea9f$export$2e2bcd8739ae039() {
    var rootConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _rootConfig$getContai = rootConfig.getContainer, getContainer = _rootConfig$getContai === void 0 ? $4fb0b9c84003ea9f$var$defaultGetContainer : _rootConfig$getContai, motion = rootConfig.motion, prefixCls = rootConfig.prefixCls, maxCount = rootConfig.maxCount, className = rootConfig.className, style = rootConfig.style, onAllRemoved = rootConfig.onAllRemoved, stack = rootConfig.stack, renderNotifications = rootConfig.renderNotifications, shareConfig = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(rootConfig, $4fb0b9c84003ea9f$var$_excluded);
    var _React$useState = $acw62.useState(), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), container = _React$useState2[0], setContainer = _React$useState2[1];
    var notificationsRef = $acw62.useRef();
    var contextHolder = /*#__PURE__*/ $acw62.createElement((0, $08224a65c5b0e7df$export$2e2bcd8739ae039), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    var _React$useState3 = $acw62.useState([]), _React$useState4 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState3, 2), taskQueue = _React$useState4[0], setTaskQueue = _React$useState4[1];
    // ========================= Refs =========================
    var api = $acw62.useMemo(function() {
        return {
            open: function open(config) {
                var mergedConfig = $4fb0b9c84003ea9f$var$mergeConfig(shareConfig, config);
                if (mergedConfig.key === null || mergedConfig.key === undefined) {
                    mergedConfig.key = "rc-notification-".concat($4fb0b9c84003ea9f$var$uniqueKey);
                    $4fb0b9c84003ea9f$var$uniqueKey += 1;
                }
                setTaskQueue(function(queue) {
                    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(queue), [
                        {
                            type: "open",
                            config: mergedConfig
                        }
                    ]);
                });
            },
            close: function close(key) {
                setTaskQueue(function(queue) {
                    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(queue), [
                        {
                            type: "close",
                            key: key
                        }
                    ]);
                });
            },
            destroy: function destroy() {
                setTaskQueue(function(queue) {
                    return [].concat((0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(queue), [
                        {
                            type: "destroy"
                        }
                    ]);
                });
            }
        };
    }, []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    $acw62.useEffect(function() {
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    $acw62.useEffect(function() {
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach(function(task) {
                switch(task.type){
                    case "open":
                        notificationsRef.current.open(task.config);
                        break;
                    case "close":
                        notificationsRef.current.close(task.key);
                        break;
                    case "destroy":
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue(function(oriQueue) {
                return oriQueue.filter(function(task) {
                    return !taskQueue.includes(task);
                });
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}












const $3bac234c47ba2af8$var$genMessageStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, boxShadow: boxShadow, colorText: colorText, colorSuccess: colorSuccess, colorError: colorError, colorWarning: colorWarning, colorInfo: colorInfo, fontSizeLG: fontSizeLG, motionEaseInOutCirc: motionEaseInOutCirc, motionDurationSlow: motionDurationSlow, marginXS: marginXS, paddingXS: paddingXS, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, contentPadding: // Custom token
    contentPadding, contentBg: contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("MessageMoveIn", {
        "0%": {
            padding: 0,
            transform: "translateY(-100%)",
            opacity: 0
        },
        "100%": {
            padding: paddingXS,
            transform: "translateY(0)",
            opacity: 1
        }
    });
    const messageMoveOut = new (0, $cb64545ddf8f118e$export$2e2bcd8739ae039)("MessageMoveOut", {
        "0%": {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        "100%": {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: "center",
        [`${componentCls}-custom-content`]: {
            display: "flex",
            alignItems: "center"
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: "inline-block",
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow: boxShadow,
            pointerEvents: "all"
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
                color: colorText,
                position: "fixed",
                top: marginXS,
                width: "100%",
                pointerEvents: "none",
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: "forwards"
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: "paused",
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: "running"
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: "paused",
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: "running"
                },
                "&-rtl": {
                    direction: "rtl",
                    span: {
                        direction: "rtl"
                    }
                }
            })
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: Object.assign({}, noticeStyle)
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: Object.assign(Object.assign({}, noticeStyle), {
                padding: 0,
                textAlign: "start"
            })
        }
    ];
};
const $3bac234c47ba2af8$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, $8552b358f1d5b0a4$export$33ada7d8845f7e5) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
var // ============================== Export ==============================
$3bac234c47ba2af8$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Message", (token)=>{
    // Gen-style functions here
    const combinedToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        height: 150
    });
    return [
        $3bac234c47ba2af8$var$genMessageStyle(combinedToken)
    ];
}, $3bac234c47ba2af8$export$9ca1be8807fe0675);


"use client";
var $c9808e733d97ff6c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c9808e733d97ff6c$export$ad8f8fc3bcd61b4a = {
    info: /*#__PURE__*/ $acw62.createElement((0, $b5d5d018bfa4ba6e$export$2e2bcd8739ae039), null),
    success: /*#__PURE__*/ $acw62.createElement((0, $9149fdfb4424d1d9$export$2e2bcd8739ae039), null),
    error: /*#__PURE__*/ $acw62.createElement((0, $81ff9dc68eb84eda$export$2e2bcd8739ae039), null),
    warning: /*#__PURE__*/ $acw62.createElement((0, $2444f6da62064575$export$2e2bcd8739ae039), null),
    loading: /*#__PURE__*/ $acw62.createElement((0, $d8d56e1090f62915$export$2e2bcd8739ae039), null)
};
const $c9808e733d97ff6c$export$429c001938db3a78 = (_ref)=>{
    let { prefixCls: prefixCls, type: type, icon: icon, children: children } = _ref;
    return /*#__PURE__*/ $acw62.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, icon || $c9808e733d97ff6c$export$ad8f8fc3bcd61b4a[type], /*#__PURE__*/ $acw62.createElement("span", null, children));
};
/** @private Internal Component. Do not use in your production. */ const $c9808e733d97ff6c$var$PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className: className, type: type, icon: icon, content: content } = props, restProps = $c9808e733d97ff6c$var$__rest(props, [
        "prefixCls",
        "className",
        "type",
        "icon",
        "content"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls("message");
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3bac234c47ba2af8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $6be5862818f90611$export$2e2bcd8739ae039), Object.assign({}, restProps, {
        prefixCls: prefixCls,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ $acw62.createElement($c9808e733d97ff6c$export$429c001938db3a78, {
            prefixCls: prefixCls,
            type: type,
            icon: icon
        }, content)
    })));
};
var $c9808e733d97ff6c$export$2e2bcd8739ae039 = $c9808e733d97ff6c$var$PurePanel;



var $acw62 = parcelRequire("acw62");








function $c93f159ca3fa0be1$export$7b8936ddc277a29a(prefixCls, transitionName) {
    return {
        motionName: transitionName !== null && transitionName !== void 0 ? transitionName : `${prefixCls}-move-up`
    };
}
function $c93f159ca3fa0be1$export$52ce770daa307a45(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn === null || closeFn === void 0 || closeFn();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}


"use client";
var $279f9cad32c830f7$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $279f9cad32c830f7$var$DEFAULT_OFFSET = 8;
const $279f9cad32c830f7$var$DEFAULT_DURATION = 3;
const $279f9cad32c830f7$var$Wrapper = (_ref)=>{
    let { children: children, prefixCls: prefixCls } = _ref;
    const rootCls = (0, $9be8217fdbca7dca$export$2e2bcd8739ae039)(prefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $3bac234c47ba2af8$export$2e2bcd8739ae039)(prefixCls, rootCls);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement((0, $189ebb65137099c1$export$2e2bcd8739ae039), {
        classNames: {
            list: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(hashId, cssVarCls, rootCls)
        }
    }, children));
};
const $279f9cad32c830f7$var$renderNotifications = (node, _ref2)=>{
    let { prefixCls: prefixCls, key: key } = _ref2;
    return /*#__PURE__*/ $acw62.createElement($279f9cad32c830f7$var$Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
};
const $279f9cad32c830f7$var$Holder = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { top: top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount: maxCount, duration: duration = $279f9cad32c830f7$var$DEFAULT_DURATION, rtl: rtl, transitionName: transitionName, onAllRemoved: onAllRemoved } = props;
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, message: message, direction: direction } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = staticPrefixCls || getPrefixCls("message");
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: "50%",
            transform: "translateX(-50%)",
            top: top !== null && top !== void 0 ? top : $279f9cad32c830f7$var$DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))({
            [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === "rtl"
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, $c93f159ca3fa0be1$export$7b8936ddc277a29a)(prefixCls, transitionName);
    // ============================ Close Icon =============================
    const mergedCloseIcon = /*#__PURE__*/ $acw62.createElement("span", {
        className: `${prefixCls}-close-x`
    }, /*#__PURE__*/ $acw62.createElement((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
    // ============================== Origin ===============================
    const [api, holder] = (0, $4fb0b9c84003ea9f$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: false,
        closeIcon: mergedCloseIcon,
        duration: duration,
        getContainer: ()=>(staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
        maxCount: maxCount,
        onAllRemoved: onAllRemoved,
        renderNotifications: $279f9cad32c830f7$var$renderNotifications
    });
    // ================================ Ref ================================
    $acw62.useImperativeHandle(ref, ()=>Object.assign(Object.assign({}, api), {
            prefixCls: prefixCls,
            message: message
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let $279f9cad32c830f7$var$keyIndex = 0;
function $279f9cad32c830f7$export$1689db33b6c27d9e(messageConfig) {
    const holderRef = $acw62.useRef(null);
    const warning = (0, $5bd796dbed593bbb$export$cf977aa92c751e61)("Message");
    // ================================ API ================================
    const wrapAPI = $acw62.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            var _a;
            (_a = holderRef.current) === null || _a === void 0 || _a.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls: prefixCls, message: message } = holderRef.current;
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content: content, icon: icon, type: type, key: key, className: className, style: style, onClose: onClose } = config, restConfig = $279f9cad32c830f7$var$__rest(config, [
                "content",
                "icon",
                "type",
                "key",
                "className",
                "style",
                "onClose"
            ]);
            let mergedKey = key;
            if (mergedKey === undefined || mergedKey === null) {
                $279f9cad32c830f7$var$keyIndex += 1;
                mergedKey = `antd-message-${$279f9cad32c830f7$var$keyIndex}`;
            }
            return (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
                originOpen(Object.assign(Object.assign({}, restConfig), {
                    key: mergedKey,
                    content: /*#__PURE__*/ $acw62.createElement((0, $c9808e733d97ff6c$export$429c001938db3a78), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon
                    }, content),
                    placement: "top",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(type && `${noticePrefixCls}-${type}`, className, message === null || message === void 0 ? void 0 : message.className),
                    style: Object.assign(Object.assign({}, message === null || message === void 0 ? void 0 : message.style), style),
                    onClose: ()=>{
                        onClose === null || onClose === void 0 || onClose();
                        resolve();
                    }
                }));
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            var _a;
            if (key !== undefined) close(key);
            else (_a = holderRef.current) === null || _a === void 0 || _a.destroy();
        };
        const clone = {
            open: open,
            destroy: destroy
        };
        const keys = [
            "info",
            "success",
            "warning",
            "error",
            "loading"
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if (jointContent && typeof jointContent === "object" && "content" in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === "function") mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = Object.assign(Object.assign({
                    onClose: mergedOnClose,
                    duration: mergedDuration
                }, config), {
                    type: type
                });
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ $acw62.createElement($279f9cad32c830f7$var$Holder, Object.assign({
            key: "message-holder"
        }, messageConfig, {
            ref: holderRef
        }))
    ];
}
function $279f9cad32c830f7$export$2e2bcd8739ae039(messageConfig) {
    return $279f9cad32c830f7$export$1689db33b6c27d9e(messageConfig);
}



"use client";
let $dc31f36873c2f472$var$message = null;
let $dc31f36873c2f472$var$act = (callback)=>callback();
let $dc31f36873c2f472$var$taskQueue = [];
let $dc31f36873c2f472$var$defaultGlobalConfig = {};
function $dc31f36873c2f472$var$getGlobalContext() {
    const { getContainer: getContainer, duration: duration, rtl: rtl, maxCount: maxCount, top: top } = $dc31f36873c2f472$var$defaultGlobalConfig;
    const mergedContainer = (getContainer === null || getContainer === void 0 ? void 0 : getContainer()) || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration: duration,
        rtl: rtl,
        maxCount: maxCount,
        top: top
    };
}
const $dc31f36873c2f472$var$GlobalHolder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { messageConfig: messageConfig, sync: sync } = props;
    const { getPrefixCls: getPrefixCls } = (0, $acw62.useContext)((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = $dc31f36873c2f472$var$defaultGlobalConfig.prefixCls || getPrefixCls("message");
    const appConfig = (0, $acw62.useContext)((0, $ec30be32576c1d45$export$264c6064649f9206));
    const [api, holder] = (0, $279f9cad32c830f7$export$1689db33b6c27d9e)(Object.assign(Object.assign(Object.assign({}, messageConfig), {
        prefixCls: prefixCls
    }), appConfig.message));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useImperativeHandle(ref, ()=>{
        const instance = Object.assign({}, api);
        Object.keys(instance).forEach((method)=>{
            instance[method] = function() {
                sync();
                return api[method].apply(api, arguments);
            };
        });
        return {
            instance: instance,
            sync: sync
        };
    });
    return holder;
});
const $dc31f36873c2f472$var$GlobalHolderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($dc31f36873c2f472$var$getGlobalContext);
    const sync = ()=>{
        setMessageConfig($dc31f36873c2f472$var$getGlobalContext);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(sync, []);
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dc31f36873c2f472$var$GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
function $dc31f36873c2f472$var$flushNotice() {
    if (!$dc31f36873c2f472$var$message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        $dc31f36873c2f472$var$message = newMessage;
        // Delay render to avoid sync issue
        $dc31f36873c2f472$var$act(()=>{
            (0, $db3659e597d7eb55$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($dc31f36873c2f472$var$GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance: instance, sync: sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            $dc31f36873c2f472$var$flushNotice();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!$dc31f36873c2f472$var$message.instance) return;
    // >>> Execute task
    $dc31f36873c2f472$var$taskQueue.forEach((task)=>{
        const { type: type, skipped: skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case "open":
                $dc31f36873c2f472$var$act(()=>{
                    const closeFn = $dc31f36873c2f472$var$message.instance.open(Object.assign(Object.assign({}, $dc31f36873c2f472$var$defaultGlobalConfig), task.config));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case "destroy":
                $dc31f36873c2f472$var$act(()=>{
                    $dc31f36873c2f472$var$message === null || $dc31f36873c2f472$var$message === void 0 || $dc31f36873c2f472$var$message.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                $dc31f36873c2f472$var$act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = $dc31f36873c2f472$var$message.instance)[type].apply(_message$instance, (0, $eb1ed927433e7e98$export$2e2bcd8739ae039)(task.args));
                    closeFn === null || closeFn === void 0 || closeFn.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    $dc31f36873c2f472$var$taskQueue = [];
}
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function $dc31f36873c2f472$var$setMessageGlobalConfig(config) {
    $dc31f36873c2f472$var$defaultGlobalConfig = Object.assign(Object.assign({}, $dc31f36873c2f472$var$defaultGlobalConfig), config);
    // Trigger sync for it
    $dc31f36873c2f472$var$act(()=>{
        var _a;
        (_a = $dc31f36873c2f472$var$message === null || $dc31f36873c2f472$var$message === void 0 ? void 0 : $dc31f36873c2f472$var$message.sync) === null || _a === void 0 || _a.call($dc31f36873c2f472$var$message);
    });
}
function $dc31f36873c2f472$var$open(config) {
    const result = (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: "open",
            config: config,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $dc31f36873c2f472$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $dc31f36873c2f472$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $dc31f36873c2f472$var$flushNotice();
    return result;
}
function $dc31f36873c2f472$var$typeOpen(type, args) {
    const global = (0, $7ed5e10e08c170f8$export$f9cd1e43211d8a4a)();
    const result = (0, $c93f159ca3fa0be1$export$52ce770daa307a45)((resolve)=>{
        let closeFn;
        const task = {
            type: type,
            args: args,
            resolve: resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        $dc31f36873c2f472$var$taskQueue.push(task);
        return ()=>{
            if (closeFn) $dc31f36873c2f472$var$act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    $dc31f36873c2f472$var$flushNotice();
    return result;
}
const $dc31f36873c2f472$var$destroy = (key)=>{
    $dc31f36873c2f472$var$taskQueue.push({
        type: "destroy",
        key: key
    });
    $dc31f36873c2f472$var$flushNotice();
};
const $dc31f36873c2f472$var$methods = [
    "success",
    "info",
    "warning",
    "error",
    "loading"
];
const $dc31f36873c2f472$var$baseStaticMethods = {
    open: $dc31f36873c2f472$var$open,
    destroy: $dc31f36873c2f472$var$destroy,
    config: $dc31f36873c2f472$var$setMessageGlobalConfig,
    useMessage: $279f9cad32c830f7$export$2e2bcd8739ae039,
    _InternalPanelDoNotUseOrYouWillBeFired: (0, $c9808e733d97ff6c$export$2e2bcd8739ae039)
};
const $dc31f36873c2f472$var$staticMethods = $dc31f36873c2f472$var$baseStaticMethods;
$dc31f36873c2f472$var$methods.forEach((type)=>{
    $dc31f36873c2f472$var$staticMethods[type] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $dc31f36873c2f472$var$typeOpen(type, args);
    };
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const $dc31f36873c2f472$var$noop = ()=>{};
let $dc31f36873c2f472$export$71ceb3dabb09f455 = $dc31f36873c2f472$var$noop;
var $dc31f36873c2f472$var$wrapper;
let $dc31f36873c2f472$export$43de32c50edff050 = $dc31f36873c2f472$var$noop;
var $dc31f36873c2f472$export$2e2bcd8739ae039 = $dc31f36873c2f472$var$staticMethods;




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $c2453685a99be1dd$var$DeleteTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M292.7 840h438.6l24.2-512h-487z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "delete",
    "theme": "twotone"
};
var $c2453685a99be1dd$export$2e2bcd8739ae039 = $c2453685a99be1dd$var$DeleteTwoTone;



var $3655877bbadec08b$var$DeleteTwoTone = function DeleteTwoTone(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $c2453685a99be1dd$export$2e2bcd8739ae039)
    }));
};
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5Mi43IDg0MGg0MzguNmwyNC4yLTUxMmgtNDg3eiIgZmlsbD0iI2U2ZjRmZiIgLz48cGF0aCBkPSJNODY0IDI1Nkg3MzZ2LTgwYzAtMzUuMy0yOC43LTY0LTY0LTY0SDM1MmMtMzUuMyAwLTY0IDI4LjctNjQgNjR2ODBIMTYwYy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzMmMwIDQuNCAzLjYgOCA4IDhoNjAuNGwyNC43IDUyM2MxLjYgMzQuMSAyOS44IDYxIDYzLjkgNjFoNDU0YzM0LjIgMCA2Mi4zLTI2LjggNjMuOS02MWwyNC43LTUyM0g4ODhjNC40IDAgOC0zLjYgOC04di0zMmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTUwNC03MmgzMDR2NzJIMzYwdi03MnptMzcxLjMgNjU2SDI5Mi43bC0yNC4yLTUxMmg0ODdsLTI0LjIgNTEyeiIgZmlsbD0iIzE2NzdmZiIgLz48L3N2Zz4=) */ var $3655877bbadec08b$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($3655877bbadec08b$var$DeleteTwoTone);
var $3655877bbadec08b$export$2e2bcd8739ae039 = $3655877bbadec08b$var$RefIcon;



const { Text: $e800c5af19e7cf97$var$Text, Title: $e800c5af19e7cf97$var$Title, Paragraph: $e800c5af19e7cf97$var$Paragraph } = (0, $69754065fe3b4b60$export$2e2bcd8739ae039);
const $e800c5af19e7cf97$var$EditableNote = ({ note: note, handleNoteUpdate: handleNoteUpdate, handleDeleteNote: handleDeleteNote })=>{
    const [editing, setEditing] = (0, $acw62.useState)(false);
    const [value, setValue] = (0, $acw62.useState)(note.content);
    const [titleValue, setTitleValue] = (0, $acw62.useState)(note.title);
    const [collapsed, setCollapsed] = (0, $acw62.useState)(true);
    const [showButton, setShowButton] = (0, $acw62.useState)(false);
    const paragraphRef = (0, $acw62.useRef)(null);
    const toggleCollapse = ()=>{
        setCollapsed(!collapsed);
    };
    const handleEdit = ()=>{
        setEditing(true);
        setValue(note.content);
        setTitleValue(note.title);
    };
    const handleSave = ()=>{
        setEditing(false);
        handleNoteUpdate(value, titleValue);
    };
    const handleNoteChange = (e)=>{
        setValue(e.target.value);
    };
    const handleTitleChange = (e)=>{
        setTitleValue(e.target.value);
    };
    (0, $acw62.useEffect)(()=>{
        const previousCollapsedState = collapsed;
        const measureContent = ()=>{
            if (paragraphRef.current) {
                const fullHeight = paragraphRef.current.scrollHeight; // Full content height
                const lineHeight = parseInt(getComputedStyle(paragraphRef.current).lineHeight, 10);
                const linesToShow = 3;
                const maxHeight = lineHeight * linesToShow;
                setShowButton(fullHeight > maxHeight);
                setCollapsed(previousCollapsedState);
            }
        };
        setCollapsed(false);
        setTimeout(measureContent, 0);
    }, [
        note.content
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "editableNoteContainer",
        children: editing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                    value: titleValue,
                    onChange: handleTitleChange,
                    placeholder: "Add title"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "noteContentAndIconContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).TextArea, {
                            value: value,
                            onChange: handleNoteChange,
                            autoSize: {
                                minRows: 2,
                                maxRows: 15
                            },
                            style: {
                                whiteSpace: "pre-wrap"
                            },
                            onPaste: (e)=>(0, $cfadb87391ca5e26$export$e7e57daa27256709)("existing note input", e)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "noteButtonsContainer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                                    title: "Save note",
                                    mouseEnterDelay: 0.3,
                                    mouseLeaveDelay: 0,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $731042e70a6ddd3b$export$2e2bcd8739ae039), {
                                            style: {
                                                color: "green"
                                            }
                                        }),
                                        onClick: handleSave,
                                        size: "small"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                                    title: "Cancel changes",
                                    mouseEnterDelay: 0.3,
                                    mouseLeaveDelay: 0,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06f117eb9481f34c$export$2e2bcd8739ae039), {
                                            style: {
                                                color: "red"
                                            }
                                        }),
                                        onClick: ()=>setEditing(false),
                                        size: "small"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                note.title && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "readOnlyTitleContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e800c5af19e7cf97$var$Title, {
                        level: 4,
                        children: note.title
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "noteContentAndIconContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e800c5af19e7cf97$var$Paragraph, {
                            className: `readOnlyNoteContent${showButton ? "" : " adjustForCollapseButton"}`,
                            ellipsis: collapsed ? {
                                rows: 3
                            } : false,
                            ref: paragraphRef,
                            children: note.content
                        }),
                        showButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            onClick: toggleCollapse,
                            className: "expandCollapseNoteButton",
                            children: collapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                title: "Click to expand",
                                children: [
                                    "More ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9387210f6c0d2379$export$2e2bcd8739ae039), {})
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                title: "Click to collapse",
                                children: [
                                    "Less ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ac1c243e74bf2d4$export$2e2bcd8739ae039), {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "noteButtonsContainer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                                    title: "Edit note",
                                    mouseEnterDelay: 0.3,
                                    mouseLeaveDelay: 0,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $498b707c3c04dc0a$export$2e2bcd8739ae039), {}),
                                        size: "small",
                                        onClick: handleEdit
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                                    title: "Delete note",
                                    mouseEnterDelay: 0.3,
                                    mouseLeaveDelay: 0,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3655877bbadec08b$export$2e2bcd8739ae039), {
                                            twoToneColor: "red"
                                        }),
                                        onClick: (e)=>handleDeleteNote(e, note.id)
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $e800c5af19e7cf97$export$2e2bcd8739ae039 = $e800c5af19e7cf97$var$EditableNote;





const { Text: $646665c8ec0de84c$var$Text, Paragraph: $646665c8ec0de84c$var$Paragraph } = (0, $69754065fe3b4b60$export$2e2bcd8739ae039);
const { confirm: $646665c8ec0de84c$var$confirm } = (0, $e47cb76d58815cb1$export$2e2bcd8739ae039);
const $646665c8ec0de84c$var$Notes = ({ collapsed: collapsed, setIsOverflowing: setIsOverflowing })=>{
    const [delayRender, setDelayRender] = (0, $acw62.useState)(collapsed);
    const [notes, setNotes] = (0, $acw62.useState)([]);
    const [errorMsg, setErrorMsg] = (0, $acw62.useState)("");
    const [errorStatus, setErrorStatus] = (0, $acw62.useState)(null);
    const [inputValue, setInputValue] = (0, $acw62.useState)("");
    const [titleValue, setTitleValue] = (0, $acw62.useState)("");
    const [hasScrollBar, setHasScrollBar] = (0, $acw62.useState)(false);
    const [messageApi, contextHolder] = (0, $dc31f36873c2f472$export$2e2bcd8739ae039).useMessage();
    const noteInputRef = (0, $acw62.useRef)(null);
    const notesListRef = (0, $acw62.useRef)(null);
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
    const { problem: problem } = problemContext;
    const generateTempKey = ()=>{
        let key = Math.floor(Math.random() * 10000);
        while(notes.some((note)=>note.id === key))key = Math.floor(Math.random() * 10000);
        return key;
    };
    const checkScrollbar = (0, $acw62.useCallback)(()=>{
        if (notesListRef.current) setHasScrollBar(notesListRef.current.scrollHeight > notesListRef.current.clientHeight);
    }, [
        notesListRef
    ]);
    const displayInputErrorStatus = (message)=>{
        setErrorMsg(message);
        setErrorStatus("error");
    };
    const clearInputErrorStatus = ()=>{
        setErrorMsg("");
        setErrorStatus(null);
    };
    const handleNoteUpdate = async (id, content, title)=>{
        if (content.trim() === "") {
            handleDeleteNote(id);
            return;
        }
        const trimmedInput = content.trim();
        const trimmedTitle = title?.trim();
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/notes/update-note", {
                note_id: id,
                content: trimmedInput,
                title: trimmedTitle
            });
            const noteData = res.data.note;
            const date_modified = new Date(noteData.date_modified);
            setNotes((prevNotes)=>prevNotes.map((note)=>note.id === id ? {
                        ...note,
                        content: trimmedInput,
                        title: trimmedTitle,
                        date_modified: date_modified.toLocaleString()
                    } : note));
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("update_note", {
                note_id: id,
                content: trimmedInput,
                title: trimmedTitle
            }, true);
            messageApi.success("Note updated successfully");
        } catch (e) {
            console.log(e);
            messageApi.error("Failed to update note");
        }
    };
    const saveNote = async ()=>{
        const trimmedInput = inputValue.trim();
        if (trimmedInput === "") {
            displayInputErrorStatus("Note cannot be empty");
            if (noteInputRef.current) noteInputRef.current.focus();
            return;
        }
        if (!problem) return;
        const trimmedTitle = titleValue.trim();
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/notes/save-note", {
                problem_id: problem.id,
                title: trimmedTitle,
                content: trimmedInput
            });
            const note_id = res.data.note.id;
            const date_created = new Date(res.data.note.date_created);
            const date_modified = new Date(res.data.note.date_modified);
            setNotes((prevNotes)=>[
                    {
                        id: note_id,
                        content: trimmedInput,
                        title: trimmedTitle,
                        date_created: date_created.toLocaleString(),
                        date_modified: date_modified.toLocaleString()
                    },
                    ...prevNotes
                ]);
            setInputValue("");
            setTitleValue("");
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("save_note", {
                note_id: note_id,
                content: trimmedInput,
                title: trimmedTitle
            }, true);
            messageApi.success("New note saved successfully");
        } catch (e) {
            console.log(e);
            displayInputErrorStatus("Failed to save note");
            messageApi.error("Failed to save note");
        }
    };
    const handleDeleteNote = async (id)=>{
        if (!id) return;
        const note = notes.find((note)=>note.id === id);
        try {
            await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/notes/delete-note", {
                note_id: id
            });
            setNotes((prevNotes)=>prevNotes.filter((note)=>note.id !== id));
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("delete_note", {
                note_id: id,
                content: note?.content,
                title: note?.title
            }, true);
            messageApi.success("Note deleted successfully");
        } catch (e) {
            console.log(e);
            messageApi.error("Failed to delete note");
        }
    };
    const handleConfirmDelete = (e, id)=>{
        const xPosition = e.clientX > 250 ? e.clientX - 200 : 50;
        const yPosition = e.clientY > 250 ? e.clientY - 200 : 50;
        $646665c8ec0de84c$var$confirm({
            title: "Are you sure you want to delete this note?",
            content: "This action cannot be undone.",
            okText: "Delete",
            okButtonProps: {
                danger: true
            },
            async onOk () {
                await handleDeleteNote(id);
            },
            onCancel () {
                messageApi.info("Delete canceled");
            },
            style: {
                position: "fixed",
                top: yPosition,
                left: xPosition
            }
        });
    };
    const getNotes = async ()=>{
        if (!problem) return;
        try {
            const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/notes/get-notes", {
                params: {
                    problem_id: problem.id
                }
            });
            const noteData = response.data.noteData;
            const formattedNotes = noteData.sort((a, b)=>new Date(b.date_modified).getTime() - new Date(a.date_modified).getTime()).map((note)=>{
                return {
                    ...note,
                    date_created: new Date(note.date_created).toLocaleString(),
                    date_modified: new Date(note.date_modified ? note.date_modified : "").toLocaleString()
                };
            });
            setNotes(formattedNotes);
        } catch (error) {
            console.error("Error fetching notes: ", error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        getNotes();
    }, [
        problem
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!collapsed) {
            const timer = setTimeout(()=>{
                setDelayRender(collapsed);
            }, 300);
            return ()=>{
                clearTimeout(timer);
            };
        } else setDelayRender(collapsed);
    }, [
        collapsed
    ]);
    (0, $acw62.useEffect)(()=>{
        checkScrollbar();
    }, [
        notes
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", checkScrollbar);
        return ()=>{
            window.removeEventListener("resize", checkScrollbar);
        };
    }, [
        checkScrollbar
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsOverflowing(hasScrollBar);
    }, [
        hasScrollBar
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "notesContainerOverall",
        children: [
            contextHolder,
            !delayRender && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: "Notes"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "notesInputContainer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                name: "titleInput",
                                className: "titleInput",
                                placeholder: "Add note title (optional)",
                                autoComplete: "off",
                                value: titleValue,
                                onChange: (e)=>setTitleValue(e.target.value),
                                onPaste: (e)=>(0, $cfadb87391ca5e26$export$e7e57daa27256709)("new note title input", e)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).TextArea, {
                                ref: noteInputRef,
                                name: "noteContentInput",
                                className: "noteInput",
                                placeholder: "Add a new note",
                                autoComplete: "off",
                                autoSize: {
                                    minRows: 3,
                                    maxRows: 10
                                },
                                status: errorStatus || "",
                                value: inputValue,
                                onChange: (e)=>{
                                    if (errorMsg) clearInputErrorStatus();
                                    setInputValue(e.target.value);
                                },
                                onSubmit: saveNote,
                                onPaste: (e)=>(0, $cfadb87391ca5e26$export$e7e57daa27256709)("new note input", e)
                            }),
                            errorMsg && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "noteErrorMessage",
                                children: errorMsg
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                className: "saveNoteBtn",
                                type: "primary",
                                onClick: saveNote,
                                children: "Save Note"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `notesListContainer ${hasScrollBar ? "adjustForScrollBar" : ""}`,
                        ref: notesListRef,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                            className: "notesList",
                            onCopy: ()=>(0, $cfadb87391ca5e26$export$227fec498bd204c4)("notes tab"),
                            children: notes.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                children: "No notes yet"
                            }) : notes.map((note, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "noteDateModified",
                                            children: note.date_modified
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e800c5af19e7cf97$export$2e2bcd8739ae039), {
                                            note: note,
                                            handleNoteUpdate: (value, title)=>handleNoteUpdate(note.id, value, title),
                                            handleDeleteNote: handleConfirmDelete
                                        })
                                    ]
                                }, note.id))
                        })
                    })
                ]
            })
        ]
    });
};
var $646665c8ec0de84c$export$2e2bcd8739ae039 = $646665c8ec0de84c$var$Notes;


const { Sider: $45c2a7efe9d65c70$var$Sider } = (0, $49639f13efb591ba$export$2e2bcd8739ae039);
const $45c2a7efe9d65c70$var$LeftSideBar = (props)=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { setIsAuthenticated: setIsAuthenticated, leftRef: leftRef, userSettings: userSettings } = props;
    const [collapsed, setCollapsed] = (0, $acw62.useState)(false);
    const [activeKey, setActiveKey] = (0, $acw62.useState)("1");
    const [tooltipOpen, setTooltipOpen] = (0, $acw62.useState)();
    const [isOverflowing, setIsOverflowing] = (0, $acw62.useState)(false);
    const usernameRef = (0, $acw62.useRef)(null);
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) throw new Error("ProblemContext not found");
    const { setProblem_id: setProblem_id, tasks: tasks } = problemContext;
    const tabItems = [
        ...(!userSettings || userSettings?.taskbar_enabled) && tasks.length > 0 ? [
            {
                key: "1",
                label: "Tasks",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77dad2977f13711f$export$2e2bcd8739ae039), {
                    setIsAuthenticated: setIsAuthenticated,
                    collapsed: collapsed
                })
            }
        ] : [],
        {
            key: (!userSettings || userSettings?.taskbar_enabled) && tasks.length > 0 ? "2" : "1",
            label: "Blocks",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7ee91d90065633a$export$2e2bcd8739ae039), {
                collapsed: collapsed
            })
        },
        {
            key: (!userSettings || userSettings?.taskbar_enabled) && tasks.length > 0 ? "3" : "2",
            label: "Notes",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $646665c8ec0de84c$export$2e2bcd8739ae039), {
                collapsed: collapsed,
                setIsOverflowing: setIsOverflowing
            })
        }
    ];
    const handleTabClick = (key)=>{
        if (collapsed) setCollapsed(false);
        setActiveKey(key);
    };
    const handleLogout = async ()=>{
        try {
            const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/users/logout", {}, {
                withCredentials: true
            });
            setIsAuthenticated(false);
            setProblem_id(undefined);
            navigate("/login");
        } catch (error) {
            console.log("Logout error ->", error);
        }
    };
    const resetClosedTooltip = ()=>{
        setTooltipOpen(false);
        setTimeout(()=>{
            setTooltipOpen(undefined);
        }, 10);
    };
    const handleCollapse = ()=>{
        setCollapsed((prev)=>!prev);
        resetClosedTooltip();
        setTimeout(()=>{
            (0, $5184a13b2b4cae17$export$95b8ceda2c9b7ad6)();
        }, 0);
    };
    const adjustUsernameFontSize = ()=>{
        const container = usernameRef.current;
        if (!container) return;
        let fontSize = 20; // px
        container.style.fontSize = fontSize + "px";
        container.style.textWrap = "nowrap";
        container.style.overflowWrap = "normal";
        while(container.scrollWidth > container.offsetWidth){
            fontSize--;
            container.style.fontSize = fontSize + "px";
            if (fontSize <= 10) {
                if (container.scrollWidth > container.offsetWidth) {
                    container.style.textWrap = "balance";
                    container.style.overflowWrap = "break-word";
                }
                break;
            }
        }
    };
    (0, $acw62.useEffect)(()=>{
        adjustUsernameFontSize();
    }, [
        props.username
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49639f13efb591ba$export$2e2bcd8739ae039), {
        ref: leftRef,
        style: {
            flex: "0 0 110px"
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                id: "welcomeUsernameContainer",
                className: `welcomeUsernameMsg${collapsed ? " adjustUserWelcomeMsg" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Welcome User"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        id: "usernameText",
                        ref: usernameRef,
                        className: "usernameBold",
                        title: props.username,
                        children: props.username
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($45c2a7efe9d65c70$var$Sider, {
                className: `siderContainer ${collapsed ? "siderCollapsed" : ""}`,
                collapsible: true,
                collapsed: collapsed,
                trigger: null,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                        placement: "right",
                        title: collapsed ? "Expand Sidebar" : "Collapse Sidebar",
                        open: tooltipOpen,
                        mouseEnterDelay: 0,
                        mouseLeaveDelay: 0.5,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            className: `siderCollapseBtn topSiderButton ${collapsed ? "siderCollapseBtnCollapsed" : ""}`,
                            onClick: handleCollapse,
                            icon: collapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $389d763730796d58$export$2e2bcd8739ae039), {
                        className: `siderTabs ${collapsed ? "siderTabsCollapsed" : ""}`,
                        tabPosition: "left",
                        defaultActiveKey: "1",
                        onTabClick: handleTabClick,
                        items: tabItems,
                        activeKey: collapsed ? "" : activeKey
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                        placement: "right",
                        title: collapsed ? "Expand Sidebar" : "Collapse Sidebar",
                        open: tooltipOpen,
                        mouseEnterDelay: 0,
                        mouseLeaveDelay: 0.5,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            className: `siderCollapseBtn bottomSiderButton ${collapsed ? "siderCollapseBtnCollapsed" : ""} ${isOverflowing ? "ajustForOverflow" : ""}`,
                            onClick: handleCollapse,
                            icon: collapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        className: "siderProblemsBtn",
                        onClick: ()=>navigate("/problems"),
                        children: "All Problems"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                        theme: {
                            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            className: "siderLogoutBtn",
                            onClick: handleLogout,
                            children: "Logout"
                        })
                    })
                ]
            })
        ]
    });
};
var $45c2a7efe9d65c70$export$2e2bcd8739ae039 = $45c2a7efe9d65c70$var$LeftSideBar;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $93562a58da2c2cf4$var$CodePreview = ({ codePreview: codePreview })=>{
    const { lineWrapping: lineWrapping, editable: editable } = (0, $7beee9608540d2c3$export$eece2fccabbb77c5);
    const [previousCodePreview, setPreviousCodePreview] = (0, $acw62.useState)("");
    const findFirstDifferenceIndex = (str1, str2)=>{
        for(let i = 0; i < Math.max(str1.length, str2.length); i++){
            if (str1[i] !== str2[i]) return i;
        }
        return -1;
    };
    const scrollToFirstChange = (oldText, newText)=>{
        const div = document.querySelector(".codePreviewInnerContainer .cm-scroller");
        const firstDiffIndex = findFirstDifferenceIndex(oldText, newText);
        if (div && firstDiffIndex !== -1) {
            const tempDiv = document.createElement("div");
            tempDiv.style.visibility = "hidden";
            tempDiv.style.position = "absolute";
            tempDiv.style.width = div.offsetWidth + "px";
            tempDiv.innerHTML = newText.substring(0, firstDiffIndex).replace(/\n/g, "<br>");
            document.body.appendChild(tempDiv);
            const offsetTop = tempDiv.offsetHeight;
            const cmContent = div.querySelector(".cm-content");
            if (cmContent) {
                if (offsetTop > div.offsetHeight - 110) div.scrollTop = offsetTop;
                else div.scrollTop = 0;
            }
            document.body.removeChild(tempDiv);
        } else console.log("No differences found");
    };
    (0, $acw62.useEffect)(()=>{
        if (codePreview !== previousCodePreview && previousCodePreview !== "") scrollToFirstChange(previousCodePreview, codePreview);
        setPreviousCodePreview(codePreview);
    }, [
        codePreview
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rightColumnHalfContainer topHalf",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "codePreviewOuterContainer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "codePreviewTitle",
                    children: "Code Preview"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $269cb9ebbcb83755$export$2e2bcd8739ae039), {
                    onPointerDown: (e)=>e.stopPropagation(),
                    className: "codePreviewInnerContainer",
                    height: "100%",
                    value: codePreview || "# Your code will appear here",
                    theme: "dark",
                    extensions: [
                        (0, $3d5a662064fc0d8b$export$3ccdad7705c71630)(),
                        lineWrapping,
                        editable.of(false)
                    ],
                    onCopy: ()=>(0, $cfadb87391ca5e26$export$227fec498bd204c4)("code preview window")
                })
            ]
        })
    });
};
var $93562a58da2c2cf4$export$2e2bcd8739ae039 = $93562a58da2c2cf4$var$CodePreview;




var $acw62 = parcelRequire("acw62");





const $20994290e54fb605$var$ConsoleViewer = ({ codePreview: codePreview, runProgram: runProgram, setRunProgram: setRunProgram, setGeneratedPlots: setGeneratedPlots, codePaths: codePaths, consoleText: consoleText, setConsoleText: setConsoleText })=>{
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const consoleRef = (0, $acw62.useRef)(null);
    const context = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!context) throw new Error("ProblemContext must be used within a ProblemProvider");
    const { problem: problem } = context;
    (0, $acw62.useEffect)(()=>{
        if (runProgram) {
            setIsLoading(true);
            const splitCode = codePreview.split("\n").filter((line)=>line !== "");
            const totalCode = (0, $4e6b0038302d94d3$export$f9a73699f5f52645)(splitCode);
            if (totalCode) {
                let cumulativeConsoleOutput = "";
                let allPlots = [];
                const processCodePaths = async ()=>{
                    try {
                        for (const path of codePaths){
                            const { pathNum: pathNum, code: code } = path;
                            try {
                                if (code) {
                                    const consoleOutput = await (0, $4e6b0038302d94d3$export$115dc2451863682d).runCode(code);
                                    if (consoleOutput.success) consoleOutput.data = `[Executed successfully \u{2713}]${consoleOutput.data ? "\n" + consoleOutput.data : ""}`;
                                    cumulativeConsoleOutput += `Path ${pathNum} output:\n${consoleOutput.data}\n\n`;
                                    if (consoleOutput.plots) allPlots = [
                                        ...allPlots,
                                        ...consoleOutput.plots
                                    ];
                                } else cumulativeConsoleOutput += `Path ${pathNum} output:\nError: No code to run\n\n`;
                            } catch (e) {
                                console.log(e);
                                cumulativeConsoleOutput += `Path ${pathNum} output:\nError: ${e.message}\n`;
                            }
                        }
                        setConsoleText(cumulativeConsoleOutput);
                        setGeneratedPlots(allPlots);
                    } catch (e) {
                        console.log(e);
                        setGeneratedPlots([]);
                        setConsoleText(`Error: ${e.message}`);
                    } finally{
                        setIsLoading(false);
                    }
                };
                processCodePaths();
            } else {
                setConsoleText("Error: No code to run");
                setIsLoading(false);
            }
        }
    }, [
        runProgram
    ]);
    (0, $acw62.useEffect)(()=>{
        if (runProgram && problem && !isLoading) setRunProgram(false);
    }, [
        consoleText,
        isLoading
    ]);
    (0, $acw62.useEffect)(()=>{
        if (consoleRef.current) consoleRef.current.scrollTop = consoleRef.current.scrollHeight;
    }, [
        consoleText
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "rightColumnHalfContainer bottomHalf",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "consoleViewerOuterContainer",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Console Output"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    ref: consoleRef,
                    className: "consoleOutputContainer",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), {
                        wrapperClassName: "consoleLoadingOverlay",
                        tip: "Processing changes...",
                        spinning: isLoading,
                        size: "large",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "console globalConsole",
                            onCopy: ()=>(0, $cfadb87391ca5e26$export$227fec498bd204c4)("console output window"),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                children: consoleText
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $20994290e54fb605$export$2e2bcd8739ae039 = $20994290e54fb605$var$ConsoleViewer;




const $54652e863bc41242$var$RightSideBar = (props)=>{
    const [collapsed, setCollapsed] = (0, $acw62.useState)(false);
    const { codePreview: codePreview, runProgram: runProgram, setRunProgram: setRunProgram, setGeneratedPlots: setGeneratedPlots, rightRef: rightRef, consoleText: consoleText, setConsoleText: setConsoleText } = props;
    const [tooltipOpen, setTooltipOpen] = (0, $acw62.useState)();
    const resetClosedTooltip = ()=>{
        setTooltipOpen(false);
        setTimeout(()=>{
            setTooltipOpen(undefined);
        }, 10);
    };
    const handleCollapse = ()=>{
        setCollapsed((prev)=>!prev);
        resetClosedTooltip();
        setTimeout(()=>{
            (0, $5184a13b2b4cae17$export$95b8ceda2c9b7ad6)();
        }, 0);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49639f13efb591ba$export$2e2bcd8739ae039), {
        ref: rightRef,
        className: `rightSideContainer ${collapsed ? "siderCollapsed" : ""}`,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f4e67dbf2453f541$export$2e2bcd8739ae039), {
            className: `rightSiderContainer ${collapsed ? "siderCollapsed" : ""}`,
            collapsed: collapsed,
            onCollapse: ()=>setCollapsed(!collapsed),
            collapsible: true,
            trigger: null,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                    placement: "left",
                    title: collapsed ? "Expand Sidebar" : "Collapse Sidebar",
                    open: tooltipOpen,
                    mouseEnterDelay: 0,
                    mouseLeaveDelay: 0.5,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        className: "rightSiderCollapseBtn topCollapseBtn",
                        onClick: handleCollapse,
                        icon: !collapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {})
                    })
                }),
                !collapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93562a58da2c2cf4$export$2e2bcd8739ae039), {
                            codePreview: codePreview
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20994290e54fb605$export$2e2bcd8739ae039), {
                            codePreview: codePreview,
                            runProgram: runProgram,
                            setRunProgram: setRunProgram,
                            setGeneratedPlots: setGeneratedPlots,
                            codePaths: props.codePaths,
                            consoleText: consoleText,
                            setConsoleText: setConsoleText
                        })
                    ]
                }),
                collapsed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "sideBarPlaceHolderText",
                        children: "Expand to view code preview and console output."
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ac88bf86814a6e5$export$2e2bcd8739ae039), {
                    placement: "left",
                    title: collapsed ? "Expand Sidebar" : "Collapse Sidebar",
                    open: tooltipOpen,
                    mouseEnterDelay: 0,
                    mouseLeaveDelay: 0.5,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        className: "rightSiderCollapseBtn bottomCollapseBtn",
                        onClick: handleCollapse,
                        icon: !collapsed ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7afd88ad369b46e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fbba0865720ca5de$export$2e2bcd8739ae039), {})
                    })
                })
            ]
        })
    });
};
var $54652e863bc41242$export$2e2bcd8739ae039 = $54652e863bc41242$var$RightSideBar;





var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $4f8539149c3257cf$var$ArrowLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "arrow-left",
    "theme": "outlined"
};
var $4f8539149c3257cf$export$2e2bcd8739ae039 = $4f8539149c3257cf$var$ArrowLeftOutlined;



var $9540ed9c9b119e24$var$ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $4f8539149c3257cf$export$2e2bcd8739ae039)
    }));
};
/**![arrow-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiA0NzRIMjg2LjlsMzUwLjItMzA0YzUuNi00LjkgMi4yLTE0LTUuMi0xNGgtODguNWMtMy45IDAtNy42IDEuNC0xMC41IDMuOUwxNTUgNDg3LjhhMzEuOTYgMzEuOTYgMCAwMDAgNDguM0w1MzUuMSA4NjZjMS41IDEuMyAzLjMgMiA1LjIgMmg5MS41YzcuNCAwIDEwLjgtOS4yIDUuMi0xNEwyODYuOSA1NTBIODcyYzQuNCAwIDgtMy42IDgtOHYtNjBjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ var $9540ed9c9b119e24$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($9540ed9c9b119e24$var$ArrowLeftOutlined);
var $9540ed9c9b119e24$export$2e2bcd8739ae039 = $9540ed9c9b119e24$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $beb0f4a2bf4b9d4a$var$ClockCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    },
    "name": "clock-circle",
    "theme": "outlined"
};
var $beb0f4a2bf4b9d4a$export$2e2bcd8739ae039 = $beb0f4a2bf4b9d4a$var$ClockCircleOutlined;



var $2628771293840a7d$var$ClockCircleOutlined = function ClockCircleOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $beb0f4a2bf4b9d4a$export$2e2bcd8739ae039)
    }));
};
/**![clock-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTY4Ni43IDYzOC42TDU0NC4xIDUzNS41VjI4OGMwLTQuNC0zLjYtOC04LThINDg4Yy00LjQgMC04IDMuNi04IDh2Mjc1LjRjMCAyLjYgMS4yIDUgMy4zIDYuNWwxNjUuNCAxMjAuNmMzLjYgMi42IDguNiAxLjggMTEuMi0xLjdsMjguNi0zOWMyLjYtMy43IDEuOC04LjctMS44LTExLjJ6IiAvPjwvc3ZnPg==) */ var $2628771293840a7d$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($2628771293840a7d$var$ClockCircleOutlined);
var $2628771293840a7d$export$2e2bcd8739ae039 = $2628771293840a7d$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $07df50eedb5b9fc3$var$CodeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 00308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 00-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "code",
    "theme": "outlined"
};
var $07df50eedb5b9fc3$export$2e2bcd8739ae039 = $07df50eedb5b9fc3$var$CodeOutlined;



var $09676f779c4636c5$var$CodeOutlined = function CodeOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $07df50eedb5b9fc3$export$2e2bcd8739ae039)
    }));
};
/**![code](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxNiA2NzNjMCA0LjQgMy40IDggNy41IDhoMTg1YzQuMSAwIDcuNS0zLjYgNy41LTh2LTQ4YzAtNC40LTMuNC04LTcuNS04aC0xODVjLTQuMSAwLTcuNSAzLjYtNy41IDh2NDh6bS0xOTQuOSA2LjFsMTkyLTE2MWMzLjgtMy4yIDMuOC05LjEgMC0xMi4zbC0xOTItMTYwLjlBNy45NSA3Ljk1IDAgMDAzMDggMzUxdjYyLjdjMCAyLjQgMSA0LjYgMi45IDYuMUw0MjAuNyA1MTJsLTEwOS44IDkyLjJhOC4xIDguMSAwIDAwLTIuOSA2LjFWNjczYzAgNi44IDcuOSAxMC41IDEzLjEgNi4xek04ODAgMTEySDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NzM2YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDczNmMxNy43IDAgMzItMTQuMyAzMi0zMlYxNDRjMC0xNy43LTE0LjMtMzItMzItMzJ6bS00MCA3MjhIMTg0VjE4NGg2NTZ2NjU2eiIgLz48L3N2Zz4=) */ var $09676f779c4636c5$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($09676f779c4636c5$var$CodeOutlined);
var $09676f779c4636c5$export$2e2bcd8739ae039 = $09676f779c4636c5$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $934da7f75bdad661$var$BulbOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    },
    "name": "bulb",
    "theme": "outlined"
};
var $934da7f75bdad661$export$2e2bcd8739ae039 = $934da7f75bdad661$var$BulbOutlined;



var $47cb012582fff432$var$BulbOutlined = function BulbOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $934da7f75bdad661$export$2e2bcd8739ae039)
    }));
};
/**![bulb](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzMiA4ODhIMzkyYy00LjQgMC04IDMuNi04IDh2MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoMTkyYzE3LjcgMCAzMi0xNC4zIDMyLTMydi0zMmMwLTQuNC0zLjYtOC04LTh6TTUxMiA2NGMtMTgxLjEgMC0zMjggMTQ2LjktMzI4IDMyOCAwIDEyMS40IDY2IDIyNy40IDE2NCAyODQuMVY3OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoMjY0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjY3Ni4xYzk4LTU2LjcgMTY0LTE2Mi43IDE2NC0yODQuMSAwLTE4MS4xLTE0Ni45LTMyOC0zMjgtMzI4em0xMjcuOSA1NDkuOEw2MDQgNjM0LjZWNzUySDQyMFY2MzQuNmwtMzUuOS0yMC44QzMwNS40IDU2OC4zIDI1NiA0ODQuNSAyNTYgMzkyYzAtMTQxLjQgMTE0LjYtMjU2IDI1Ni0yNTZzMjU2IDExNC42IDI1NiAyNTZjMCA5Mi41LTQ5LjQgMTc2LjMtMTI4LjEgMjIxLjh6IiAvPjwvc3ZnPg==) */ var $47cb012582fff432$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($47cb012582fff432$var$BulbOutlined);
var $47cb012582fff432$export$2e2bcd8739ae039 = $47cb012582fff432$var$RefIcon;




var $acw62 = parcelRequire("acw62");








const $758ad93e1501bbba$var$MarkdownRenderer = ({ content: content })=>{
    (0, $acw62.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($1fddf034d74735a2$exports))).highlightAll();
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "moduleTextContent",
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};
var $758ad93e1501bbba$export$2e2bcd8739ae039 = $758ad93e1501bbba$var$MarkdownRenderer;


var $faa88de4f0afd1d0$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
$faa88de4f0afd1d0$exports = $faa88de4f0afd1d0$var$debounce;




const { Option: $ad3a2baab68f7aaa$var$Option } = (0, $1b56c179e5783cdb$export$2e2bcd8739ae039);
const { Group: $ad3a2baab68f7aaa$var$RadioGroup } = (0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039);
const { Text: $ad3a2baab68f7aaa$var$Text } = (0, $69754065fe3b4b60$export$2e2bcd8739ae039);
const $ad3a2baab68f7aaa$var$capitalizeWords = (str)=>{
    return str.split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
const $ad3a2baab68f7aaa$var$moduleStatusToClass = {
    "in-progress": "moduleInProgress",
    completed: "moduleComplete"
};
const $ad3a2baab68f7aaa$var$ModuleViewer = ({ leftColumnRef: leftColumnRef, rightColumnRef: rightColumnRef, openModuleViewerButtonRef: openModuleViewerButtonRef })=>{
    const [drawerHeight, setDrawerHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(window.innerHeight < 700 ? 0.8 * window.innerHeight : 600);
    const [showModuleViewer, setShowModuleViewer] = (0, $acw62.useState)(false);
    const [leftPosition, setLeftPosition] = (0, $acw62.useState)(0);
    const [rightPosition, setRightPosition] = (0, $acw62.useState)(0);
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const [query, setQuery] = (0, $acw62.useState)("");
    const [sortBy, setSortBy] = (0, $acw62.useState)("");
    const [filterType, setFilterType] = (0, $acw62.useState)("");
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("");
    const [searchResults, setSearchResults] = (0, $acw62.useState)([]);
    const [modules, setModules] = (0, $acw62.useState)([]);
    const [selectedModule, setSelectedModule] = (0, $acw62.useState)(null);
    const [scrollPosition, setScrollPosition] = (0, $acw62.useState)(0);
    const [showScrollUpButton, setShowScrollUpButton] = (0, $acw62.useState)(false);
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) throw new Error("Problem Context not loaded properly.");
    const { problem: problem } = problemContext;
    const moduleListViewerRef = (0, $acw62.useRef)(null);
    const singleModuleViewerRef = (0, $acw62.useRef)(null);
    const startY = (0, $acw62.useRef)(0);
    const startHeight = (0, $acw62.useRef)(drawerHeight);
    const isDraggingRef = (0, $acw62.useRef)(false);
    const queryRef = (0, $acw62.useRef)(query);
    const sortByRef = (0, $acw62.useRef)(sortBy);
    const filterTypeRef = (0, $acw62.useRef)(filterType);
    const filterStatusRef = (0, $acw62.useRef)(filterStatus);
    const closeModuleViewer = ()=>{
        setShowModuleViewer(false);
        if (selectedModule) handleStopReadingModule();
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("close_module_viewer", {}, true);
        setTimeout(()=>{
            setScrollPosition(0);
            setSelectedModule(null);
            handleClickScrollToTopButton("instant");
        }, 200);
    };
    const openModuleViewer = ()=>{
        setShowModuleViewer(true);
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("open_module_viewer", {}, true);
    };
    const updateWidths = ()=>{
        if (leftColumnRef.current) setLeftPosition(leftColumnRef.current.offsetWidth);
        if (rightColumnRef.current) {
            const rightRect = rightColumnRef.current.getBoundingClientRect();
            setRightPosition(document.body.offsetWidth - rightRect.left);
        }
    };
    const onMouseDown = (e)=>{
        setIsDragging(true);
        isDraggingRef.current = true;
        startY.current = e.clientY;
        startHeight.current = drawerHeight;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
    };
    const onMouseMove = (e)=>{
        if (isDraggingRef.current) {
            const difference = e.clientY - startY.current;
            const newHeight = startHeight.current - difference;
            setDrawerHeight(Math.max(newHeight, 350));
        }
    };
    const onMouseUp = ()=>{
        setIsDragging(false);
        isDraggingRef.current = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
    };
    const handleStartReadingModule = async (module)=>{
        if (!module || !problem) return;
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("start_reading_module", {
            module_id: module.id,
            module_number: module.module_number,
            title: module.title
        }, true);
        // Scroll to top
        handleClickScrollToTopButton("instant");
        if (module.user_module.length === 0) try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/modules/start-reading-module", {
                module_id: module.id
            });
            // Update module with new user_module data if a record was created
            setModules((prevModules)=>prevModules.map((prevModule)=>prevModule.id === module.id ? {
                        ...prevModule,
                        user_module: [
                            res.data.userModule
                        ]
                    } : prevModule));
        } catch (e) {
            console.log(e);
        }
    };
    const handleStopReadingModule = async ()=>{
        if (!selectedModule || !problem) return;
        (0, $14e68cbe3c2b3085$export$83fc28f458189523)("stop_reading_module", {
            module_id: selectedModule.id,
            module_number: selectedModule.module_number,
            title: selectedModule.title
        }, true);
    };
    const handleMarkModuleAsComplete = async ()=>{
        if (!selectedModule || !problem) return;
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/modules/complete-module", {
                module_id: selectedModule.id
            });
            setModules((prevModules)=>prevModules.map((prevModule)=>prevModule.id === selectedModule.id ? {
                        ...prevModule,
                        user_module: [
                            res.data.userModule
                        ]
                    } : prevModule));
            setSelectedModule((prevModule)=>prevModule ? {
                    ...prevModule,
                    user_module: [
                        res.data.userModule
                    ]
                } : prevModule);
            (0, $14e68cbe3c2b3085$export$83fc28f458189523)("mark_module_as_complete", {
                module_id: selectedModule.id,
                module_number: selectedModule.module_number,
                title: selectedModule.title,
                date_completed: res.data.userModule.date_completed
            }, true);
        } catch (e) {
            console.log(e);
        }
    };
    const handleSelectModule = (module)=>{
        const moduleListViewer = document.querySelector(".moduleSearchAndResultsContainer");
        if (moduleListViewer) setScrollPosition(moduleListViewer.scrollTop);
        if (module) handleStartReadingModule(module);
        else handleStopReadingModule();
        setSelectedModule(module);
    };
    const sortResults = (results)=>{
        switch(sortByRef.current // assuming sortByRef is updated to track current sorting option
        ){
            case "numAsc":
                return [
                    ...results
                ].sort((a, b)=>Number(a.module_number) - Number(b.module_number));
            case "numDesc":
                return [
                    ...results
                ].sort((a, b)=>Number(b.module_number) - Number(a.module_number));
            case "alphAsc":
                return [
                    ...results
                ].sort((a, b)=>a.title.localeCompare(b.title));
            case "alphDesc":
                return [
                    ...results
                ].sort((a, b)=>b.title.localeCompare(a.title));
            case "timeShort":
                return [
                    ...results
                ].sort((a, b)=>a.duration - b.duration);
            case "timeLong":
                return [
                    ...results
                ].sort((a, b)=>b.duration - a.duration);
            default:
                return results;
        }
    };
    const applySearchFilters = ()=>{
        let results = modules.filter((module)=>{
            const moduleStatus = module.user_module[0]?.status || "not started";
            return (queryRef.current === "" || module.title.toLowerCase().includes(queryRef.current.toLowerCase()) || module.overview.toLowerCase().includes(queryRef.current.toLowerCase())) && (filterTypeRef.current === "" || module.type === filterTypeRef.current) && (filterStatusRef.current === "" || moduleStatus === filterStatusRef.current);
        });
        results = sortResults(results);
        setSearchResults(results);
    };
    const debouncedQuery = (0, $acw62.useCallback)((0, $cfadb87391ca5e26$export$dd6e5daab826fa5c)(()=>applySearchFilters(), 200), [
        modules
    ]);
    const handleSearchQuery = (query)=>{
        setQuery(query);
        queryRef.current = query;
        debouncedQuery();
    };
    const clearSearchParameters = ()=>{
        handleSearchQuery("");
        setSortBy("");
        setFilterType("");
        setFilterStatus("");
    };
    const handleClickScrollToTopButton = (behavior = "smooth")=>{
        if (!selectedModule) {
            moduleListViewerRef.current?.scrollTo({
                top: 0,
                behavior: behavior
            });
            return;
        }
        singleModuleViewerRef.current?.scrollTo({
            top: 0,
            behavior: behavior
        });
    };
    (0, $acw62.useEffect)(()=>{
        sortByRef.current = sortBy;
        filterTypeRef.current = filterType;
        filterStatusRef.current = filterStatus;
        applySearchFilters();
    }, [
        sortBy,
        filterType,
        filterStatus,
        modules
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedModule) {
            const moduleListViewer = document.querySelector(".moduleSearchAndResultsContainer");
            if (moduleListViewer) moduleListViewer.scrollTop = scrollPosition;
        }
    }, [
        selectedModule
    ]);
    // setup event listener for scroll to show/hide scroll up button
    (0, $acw62.useEffect)(()=>{
        const handleScroll = (0, (/*@__PURE__*/$parcel$interopDefault($faa88de4f0afd1d0$exports)))(()=>{
            const moduleListViewer = moduleListViewerRef.current;
            const singleModuleViewer = singleModuleViewerRef.current;
            if (moduleListViewer && moduleListViewer.scrollTop > 300) setShowScrollUpButton(true);
            else if (singleModuleViewer && singleModuleViewer.scrollTop > 300) setShowScrollUpButton(true);
            else setShowScrollUpButton(false);
        }, 200);
        if (moduleListViewerRef.current) moduleListViewerRef.current.addEventListener("scroll", handleScroll);
        if (singleModuleViewerRef.current) singleModuleViewerRef.current.addEventListener("scroll", handleScroll);
        return ()=>{
            moduleListViewerRef.current?.removeEventListener("scroll", handleScroll);
            singleModuleViewerRef.current?.removeEventListener("scroll", handleScroll);
        };
    }, [
        showModuleViewer,
        selectedModule
    ]);
    // Sizing the drawer to match editor width
    (0, $acw62.useEffect)(()=>{
        const moduleViewerOverallContainer = document.querySelectorAll(".moduleViewerOverallContainer");
        if (moduleViewerOverallContainer) (0, $cfadb87391ca5e26$export$b71d81bfaeb967a6)(moduleViewerOverallContainer);
        const leftObserver = new ResizeObserver(updateWidths);
        const rightObserver = new ResizeObserver(updateWidths);
        if (leftColumnRef.current) leftObserver.observe(leftColumnRef.current);
        if (rightColumnRef.current) rightObserver.observe(rightColumnRef.current);
        return ()=>{
            if (leftColumnRef.current) leftObserver.disconnect();
            if (rightColumnRef.current) rightObserver.disconnect();
        };
    }, []);
    // Fetch modules
    (0, $acw62.useEffect)(()=>{
        // Get modules
        const fetchModules = async ()=>{
            try {
                const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/modules/get-modules");
                const data = response.data;
                const formattedData = data.map((module)=>{
                    return {
                        ...module,
                        category: $ad3a2baab68f7aaa$var$capitalizeWords(module.category),
                        title: $ad3a2baab68f7aaa$var$capitalizeWords(module.title)
                    };
                });
                setModules(formattedData);
            } catch (e) {}
        };
        fetchModules();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "moduleViewerOverallContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                ref: openModuleViewerButtonRef,
                onClick: openModuleViewer,
                children: "View Modules"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d2824be14bd3234d$export$2e2bcd8739ae039), {
                placement: "bottom",
                classNames: {
                    body: "chatbotBody"
                },
                styles: {
                    header: {
                        display: "none"
                    },
                    wrapper: {
                        left: `${leftPosition}px`,
                        right: `${rightPosition}px`,
                        transition: isDragging ? "none" : ""
                    }
                },
                height: drawerHeight,
                open: showModuleViewer,
                onClose: closeModuleViewer,
                className: isDragging ? "chatbotDrawerDragging" : "",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "moduleViewerContent",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "resizeBar",
                                title: "Drag to resize",
                                onMouseDown: onMouseDown
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `moduleViewerHeader${selectedModule ? " singleModuleHeader" : ""}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "moduleHeaderButtonContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                className: "closeModuleViewerButton",
                                                onClick: closeModuleViewer,
                                                children: "Close Module Viewer"
                                            }),
                                            selectedModule && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                                                theme: {
                                                    algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                    onClick: ()=>handleSelectModule(null),
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9540ed9c9b119e24$export$2e2bcd8739ae039), {}),
                                                        "Back"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        className: "moduleViewerTitle",
                                        children: selectedModule ? `${selectedModule.module_number} - ${selectedModule.title}` : "All Learning Modules"
                                    }),
                                    !selectedModule && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "moduleViewerHeaderSpacer"
                                    })
                                ]
                            }),
                            selectedModule ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                ref: singleModuleViewerRef,
                                className: "individualModuleContainer",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "moduleViewerModuleContent",
                                    onCopy: ()=>(0, $cfadb87391ca5e26$export$227fec498bd204c4)("learning module", {
                                            module_title: `${selectedModule.module_number} - ${selectedModule.title}`
                                        }),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $758ad93e1501bbba$export$2e2bcd8739ae039), {
                                            content: selectedModule.content
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                            className: "markModuleCompleteButton" + `${selectedModule.user_module[0]?.is_completed ? " completeModule" : ""}`,
                                            disabled: selectedModule.user_module[0]?.is_completed,
                                            onClick: handleMarkModuleAsComplete,
                                            children: selectedModule.user_module[0]?.is_completed ? "Completed" : "Mark as complete"
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                ref: moduleListViewerRef,
                                className: "moduleSearchAndResultsContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
                                        layout: "vertical",
                                        className: "moduleViewerForm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039).Compact, {
                                                    className: "searchBarAndClearButtonContainer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {
                                                            placeholder: "Search title...",
                                                            value: query,
                                                            onChange: (e)=>handleSearchQuery(e.target.value),
                                                            name: "moduleSearch"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                            onClick: clearSearchParameters,
                                                            name: "clearModuleSearch",
                                                            children: "Clear search"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "sortByContainer",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                        htmlFor: "sortBySelect",
                                                        children: "Sort by:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                        id: "sortBySelect",
                                                        value: sortBy,
                                                        onChange: (value)=>setSortBy(value),
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Option, {
                                                                value: "",
                                                                children: "Module Number (asc)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Option, {
                                                                value: "numDesc",
                                                                children: "Module Number (desc)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Option, {
                                                                value: "alphAsc",
                                                                children: "Alphabetical (asc)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Option, {
                                                                value: "alphDesc",
                                                                children: "Alphabetical (desc)"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Option, {
                                                                value: "timeShort",
                                                                children: "Shortest"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Option, {
                                                                value: "timeLong",
                                                                children: "Longest"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    children: [
                                                        "Type",
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad3a2baab68f7aaa$var$RadioGroup, {
                                                            className: "moduleSearchRadioGroup",
                                                            name: "moduleType",
                                                            value: filterType,
                                                            onChange: (e)=>setFilterType(e.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                                                                    value: "",
                                                                    children: "All"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                                                                    value: "code",
                                                                    children: "Code"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                                                                    value: "concept",
                                                                    children: "Concept"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                    children: [
                                                        "Status",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad3a2baab68f7aaa$var$RadioGroup, {
                                                            className: "moduleSearchRadioGroup",
                                                            name: "moduleStatus",
                                                            value: filterStatus,
                                                            onChange: (e)=>setFilterStatus(e.target.value),
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                                                                    value: "",
                                                                    children: "All"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                                                                    value: "not started",
                                                                    children: "Not started"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                                                                    value: "in-progress",
                                                                    children: "In progress"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1fe26c11c01fc5f$export$2e2bcd8739ae039), {
                                                                    value: "completed",
                                                                    children: "Complete"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                                        theme: {
                                            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "moduleSearchResultsContainer",
                                            onCopy: ()=>(0, $cfadb87391ca5e26$export$227fec498bd204c4)("learning modules list"),
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c8a82c84763151b1$export$2e2bcd8739ae039), {
                                                className: "moduleListContainer",
                                                itemLayout: "vertical",
                                                size: "large",
                                                children: [
                                                    searchResults.slice(0, isDragging ? 8 : undefined).map((module)=>{
                                                        const moduleStatusClass = $ad3a2baab68f7aaa$var$moduleStatusToClass[module.user_module[0]?.status] || "";
                                                        const moduleStatusText = $ad3a2baab68f7aaa$var$capitalizeWords(module.user_module[0]?.status || "not started");
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c8a82c84763151b1$export$2e2bcd8739ae039).Item, {
                                                            className: "moduleListItem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                    className: "moduleListItemTop",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                            className: "moduleTitleAndDescription",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                                    className: "moduleListItemTitle",
                                                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Text, {
                                                                                        children: `${module.module_number} - ${module.title}`
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8f666b0c5cd58c95$export$2e2bcd8739ae039), {
                                                                                    className: "moduleDetails",
                                                                                    align: "start",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                                            className: `moduleStatusContainer ${moduleStatusClass}`,
                                                                                            title: module.user_module[0]?.is_completed ? `Completed ${(0, $7dc9608df6769390$export$1b82eb7005b29d31)(module.user_module[0]?.date_completed)}` : moduleStatusText,
                                                                                            children: moduleStatusText
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad3a2baab68f7aaa$var$Text, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2628771293840a7d$export$2e2bcd8739ae039), {}),
                                                                                                " ",
                                                                                                module.duration,
                                                                                                " ",
                                                                                                `${module.duration > 1 ? "minutes" : "minute"}`
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ad3a2baab68f7aaa$var$Text, {
                                                                                            children: [
                                                                                                module.type === "code" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $09676f779c4636c5$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $47cb012582fff432$export$2e2bcd8739ae039), {}),
                                                                                                " ",
                                                                                                module.type
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                                            onClick: ()=>handleSelectModule(module),
                                                                            "aria-label": `View ${module.title} module`,
                                                                            children: "View Module"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                    className: "moduleOverview",
                                                                    children: module.overview
                                                                })
                                                            ]
                                                        }, module.id);
                                                    }),
                                                    searchResults.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "noResultsContainer",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ad3a2baab68f7aaa$var$Text, {
                                                            children: "No results found"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    showScrollUpButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                        title: "Scroll to top",
                        className: `backToTopButton`,
                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55f5c421b582c04d$export$2e2bcd8739ae039), {}),
                        onClick: ()=>handleClickScrollToTopButton()
                    })
                ]
            })
        ]
    });
};
var $ad3a2baab68f7aaa$export$2e2bcd8739ae039 = $ad3a2baab68f7aaa$var$ModuleViewer;


const $4d8ac34042b67290$export$56475857fe697c62 = 3;
const $4d8ac34042b67290$var$MainEditor = ({ setIsAuthenticated: setIsAuthenticated, isLoading: isLoading, isAdmin: isAdmin, userSettings: userSettings, username: username })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    const [autoSaveStatus, setAutoSaveStatus] = (0, $acw62.useState)("");
    const [codePreview, setCodePreview] = (0, $acw62.useState)("");
    const [codePaths, setCodePaths] = (0, $acw62.useState)([]);
    const [runProgram, setRunProgram] = (0, $acw62.useState)(false);
    const [generatedPlots, setGeneratedPlots] = (0, $acw62.useState)([]);
    const [plotType, setPlotType] = (0, $acw62.useState)("");
    const [storedImages, setStoredImages] = (0, $acw62.useState)(null);
    const [isVisualizerOpen, setIsVisualizerOpen] = (0, $acw62.useState)(false);
    const [isImageGalleryOpen, setIsImageGalleryOpen] = (0, $acw62.useState)(false);
    const [editorNodes, setEditorNodes] = (0, $acw62.useState)([]);
    const [consoleText, setConsoleText] = (0, $acw62.useState)("Click 'Run Program' to view console output");
    const isContextMenuSource = (0, $acw62.useRef)(false);
    const leftColumnRef = (0, $acw62.useRef)(null);
    const rightColumnRef = (0, $acw62.useRef)(null);
    const openChatbotButtonRef = (0, $acw62.useRef)(null);
    const openModuleViewerButtonRef = (0, $acw62.useRef)(null);
    const saveIndicatorMessageRef = (0, $acw62.useRef)(null);
    const hasProcessStartedRef = (0, $acw62.useRef)(false);
    const [resetTrigger, setResetTrigger] = (0, $acw62.useState)(false);
    const context = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!context) throw new Error("ProblemContext must be used within a ProblemProvider");
    const { problem: problem, setProblem: setProblem } = context;
    let { problem_id: problem_id_string } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const problem_id = Number(problem_id_string);
    const initEditor = (0, $acw62.useCallback)((el)=>{
        return (0, $14e68cbe3c2b3085$export$eb02d1ee0d3cac30)(el, context, setCodePreview, setAutoSaveStatus, setResetTrigger, setIsVisualizerOpen, setPlotType, problem_id, setEditorNodes, isContextMenuSource, setCodePaths, hasProcessStartedRef);
    }, []);
    const [ref] = (0, $c24bb3319861fe36$export$8b188b710970769c)(initEditor);
    (0, $acw62.useEffect)(()=>{
        if (!isLoading && isNaN(problem_id)) navigate("/problems");
        if (problem?.problem_status === "not started") setProblem((prev)=>{
            if (prev) return {
                ...prev,
                problem_status: "in-progress"
            };
            return prev;
        });
    }, [
        problem_id,
        problem
    ]);
    (0, $acw62.useEffect)(()=>{
        if (problem?.adminOnly && !isAdmin) navigate("/problems");
    }, [
        problem
    ]);
    (0, $acw62.useEffect)(()=>{
        if (problem?.problem_status === "completed") navigate(`/problems/${problem_id}/submission`);
    }, [
        location
    ]);
    const onDragOver = (e)=>{
        e.preventDefault();
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        if (!ref.current) return;
        const blockType = e.dataTransfer.getData("blockType");
        const rect = ref.current?.getBoundingClientRect();
        const x = e.clientX - (rect?.left || 0);
        const y = e.clientY - (rect?.top || 0);
        addElementToEditor(blockType, {
            x: x,
            y: y
        });
    };
    const addElementToEditor = async (blockType, globalPosition)=>{
        if (!blockType) return;
        isContextMenuSource.current = false;
        const node = (0, $afd930b1a77e3a58$export$270e7ba5936d3c48)(blockType, {
            socket: (0, $14e68cbe3c2b3085$export$eff0af430afeb33d),
            updateAsset: (0, $14e68cbe3c2b3085$export$cb44fff24c460592),
            process: (0, $14e68cbe3c2b3085$export$b082f73d8fa2a56f),
            context: context,
            setIsVisualizerOpen: setIsVisualizerOpen
        });
        // Get the pan and zoom of editor window for relative positioning in editor coordinate frame
        const transform = (0, $14e68cbe3c2b3085$export$5d8ad995f8f7b680).area.transform;
        const dropPositionCoordinates = {
            x: (globalPosition.x - transform.x) / transform.k,
            y: (globalPosition.y - transform.y) / transform.k
        };
        await (0, $14e68cbe3c2b3085$export$48f2fed47365221c).addNode(node);
        await (0, $14e68cbe3c2b3085$export$5d8ad995f8f7b680).translate(node.id, dropPositionCoordinates);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "BlockEditorContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45c2a7efe9d65c70$export$2e2bcd8739ae039), {
                leftRef: leftColumnRef,
                setIsAuthenticated: setIsAuthenticated,
                userSettings: userSettings,
                username: username
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mainCenterColumn",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "editorTopInterface",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d6cfe59b3aaeeb7$export$2e2bcd8739ae039), {
                            setRunProgram: setRunProgram,
                            runProgram: runProgram,
                            setIsImageGalleryOpen: setIsImageGalleryOpen,
                            leftColumnRef: leftColumnRef,
                            rightColumnRef: rightColumnRef,
                            isAdmin: isAdmin,
                            codePreview: codePreview,
                            consoleText: consoleText,
                            editorRef: ref,
                            openChatbotButtonRef: openChatbotButtonRef,
                            openModuleViewerButtonRef: openModuleViewerButtonRef,
                            generatedPlots: generatedPlots,
                            saveIndicatorMessageRef: saveIndicatorMessageRef,
                            setEditorStatus: setAutoSaveStatus
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "editorContainer",
                        ref: ref,
                        onDragOver: onDragOver,
                        onDrop: handleDrop,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64b95cf95a31e7f0$export$2e2bcd8739ae039), {
                                status: autoSaveStatus,
                                setStatus: setAutoSaveStatus,
                                max_interval_seconds: $4d8ac34042b67290$export$56475857fe697c62,
                                resetTrigger: resetTrigger,
                                saveIndicatorMessageRef: saveIndicatorMessageRef
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bottomEditorButtons",
                                children: [
                                    (!userSettings || userSettings?.chatgpt_enabled) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dc9608df6769390$export$2e2bcd8739ae039), {
                                        leftColumnRef: leftColumnRef,
                                        rightColumnRef: rightColumnRef,
                                        openChatbotButtonRef: openChatbotButtonRef
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad3a2baab68f7aaa$export$2e2bcd8739ae039), {
                                        leftColumnRef: leftColumnRef,
                                        rightColumnRef: rightColumnRef,
                                        openModuleViewerButtonRef: openModuleViewerButtonRef
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54652e863bc41242$export$2e2bcd8739ae039), {
                codePreview: codePreview,
                runProgram: runProgram,
                setRunProgram: setRunProgram,
                setGeneratedPlots: setGeneratedPlots,
                rightRef: rightColumnRef,
                codePaths: codePaths,
                consoleText: consoleText,
                setConsoleText: setConsoleText
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $98cb8c383600531f$export$2e2bcd8739ae039), {
                isVisualizerOpen: isVisualizerOpen,
                generatedPlots: generatedPlots,
                setIsVisualizerOpen: setIsVisualizerOpen,
                setIsImageGalleryOpen: setIsImageGalleryOpen,
                plotType: plotType,
                setStoredImages: setStoredImages
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a16dd9e8e5029b59$export$2e2bcd8739ae039), {
                isImageGalleryOpen: isImageGalleryOpen,
                setIsImageGalleryOpen: setIsImageGalleryOpen,
                setStoredImages: setStoredImages,
                storedImages: storedImages
            })
        ]
    });
};
var $4d8ac34042b67290$export$2e2bcd8739ae039 = $4d8ac34042b67290$var$MainEditor;






var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $7b9bf6be2b37a4cd$var$s = function() {
    return $7b9bf6be2b37a4cd$var$s = Object.assign || function(e) {
        for(var t, r = 1, o = arguments.length; r < o; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }, $7b9bf6be2b37a4cd$var$s.apply(this, arguments);
};
function $7b9bf6be2b37a4cd$var$u(e, t, r, o) {
    return new (r || (r = Promise))(function(n, a) {
        function c(e) {
            try {
                s(o.next(e));
            } catch (e) {
                a(e);
            }
        }
        function i(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function s(e) {
            var t;
            e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(c, i);
        }
        s((o = o.apply(e, t || [])).next());
    });
}
function $7b9bf6be2b37a4cd$var$l(e, t) {
    var r, o, n, a, c = {
        label: 0,
        sent: function() {
            if (1 & n[0]) throw n[1];
            return n[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: i(0),
        throw: i(1),
        return: i(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function i(a) {
        return function(i) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; c;)try {
                    if (r = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                    switch(o = 0, n && (a = [
                        2 & a[0],
                        n.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            n = a;
                            break;
                        case 4:
                            return c.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            c.label++, o = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(n = c.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                c = 0;
                                continue;
                            }
                            if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                c.label = a[1];
                                break;
                            }
                            if (6 === a[0] && c.label < n[1]) {
                                c.label = n[1], n = a;
                                break;
                            }
                            if (n && c.label < n[2]) {
                                c.label = n[2], c.ops.push(a);
                                break;
                            }
                            n[2] && c.ops.pop(), c.trys.pop();
                            continue;
                    }
                    a = t.call(e, c);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    r = n = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                i
            ]);
        };
    }
}
var $7b9bf6be2b37a4cd$var$f, $7b9bf6be2b37a4cd$var$p = function(e) {
    var t;
    e ? function(e) {
        if (e) for(; e.lastChild;)e.lastChild.remove();
    }("string" == typeof e ? document.getElementById(e) : e) : (t = document.querySelector(".grecaptcha-badge")) && t.parentNode && document.body.removeChild(t.parentNode);
}, $7b9bf6be2b37a4cd$var$d = function(e, t) {
    $7b9bf6be2b37a4cd$var$p(t), window.___grecaptcha_cfg = void 0;
    var r = document.querySelector("#" + e);
    r && r.remove(), function() {
        var e = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
        e && e.remove();
    }();
}, $7b9bf6be2b37a4cd$var$y = function(e) {
    var t = e.render, r = e.onLoadCallbackName, o = e.language, n = e.onLoad, a = e.useRecaptchaNet, c = e.useEnterprise, i = e.scriptProps, s = void 0 === i ? {} : i, u = s.nonce, l = void 0 === u ? "" : u, f = s.defer, p = void 0 !== f && f, d = s.async, y = void 0 !== d && d, m = s.id, v = void 0 === m ? "" : m, b = s.appendTo, h = v || "google-recaptcha-v3";
    if (function(e) {
        return !!document.querySelector("#" + e);
    }(h)) n();
    else {
        var g = function(e) {
            return "https://www." + (e.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (e.useEnterprise ? "enterprise.js" : "api.js");
        }({
            useEnterprise: c,
            useRecaptchaNet: a
        }), S = document.createElement("script");
        S.id = h, S.src = g + "?render=" + t + ("explicit" === t ? "&onload=" + r : "") + (o ? "&hl=" + o : ""), l && (S.nonce = l), S.defer = !!p, S.async = !!y, S.onload = n, ("body" === b ? document.body : document.getElementsByTagName("head")[0]).appendChild(S);
    }
}, $7b9bf6be2b37a4cd$var$m = function(e) {
    "undefined" != typeof $cfae44f0dfdf62c0$exports && $cfae44f0dfdf62c0$exports.env, console.warn(e);
};
!function(e) {
    e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
}($7b9bf6be2b37a4cd$var$f || ($7b9bf6be2b37a4cd$var$f = {}));
var $7b9bf6be2b37a4cd$export$dd93270ab0cf623c = (0, $acw62.createContext)({
    executeRecaptcha: function() {
        throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
    }
}), $7b9bf6be2b37a4cd$export$14d6311c3d83742b = $7b9bf6be2b37a4cd$export$dd93270ab0cf623c.Consumer;
function $7b9bf6be2b37a4cd$export$3d3872bfc53fd642(t) {
    var i = t.reCaptchaKey, u = t.useEnterprise, l = void 0 !== u && u, p = t.useRecaptchaNet, b = void 0 !== p && p, h = t.scriptProps, g = t.language, S = t.container, w = t.children, $ = (0, $acw62.useState)(null), C = $[0], P = $[1], x = (0, $acw62.useRef)(i), E = JSON.stringify(h), R = JSON.stringify(null == S ? void 0 : S.parameters);
    (0, $acw62.useEffect)(function() {
        if (i) {
            var e = (null == h ? void 0 : h.id) || "google-recaptcha-v3", t = (null == h ? void 0 : h.onLoadCallbackName) || "onRecaptchaLoadCallback";
            window[t] = function() {
                var e = l ? window.grecaptcha.enterprise : window.grecaptcha, t = $7b9bf6be2b37a4cd$var$s({
                    badge: "inline",
                    size: "invisible",
                    sitekey: i
                }, (null == S ? void 0 : S.parameters) || {});
                x.current = e.render(null == S ? void 0 : S.element, t);
            };
            return $7b9bf6be2b37a4cd$var$y({
                render: (null == S ? void 0 : S.element) ? "explicit" : i,
                onLoadCallbackName: t,
                useEnterprise: l,
                useRecaptchaNet: b,
                scriptProps: h,
                language: g,
                onLoad: function() {
                    if (window && window.grecaptcha) {
                        var e = l ? window.grecaptcha.enterprise : window.grecaptcha;
                        e.ready(function() {
                            P(e);
                        });
                    } else $7b9bf6be2b37a4cd$var$m("<GoogleRecaptchaProvider /> " + $7b9bf6be2b37a4cd$var$f.SCRIPT_NOT_AVAILABLE);
                },
                onError: function() {
                    $7b9bf6be2b37a4cd$var$m("Error loading google recaptcha script");
                }
            }), function() {
                $7b9bf6be2b37a4cd$var$d(e, null == S ? void 0 : S.element);
            };
        }
        $7b9bf6be2b37a4cd$var$m("<GoogleReCaptchaProvider /> recaptcha key not provided");
    }, [
        l,
        b,
        E,
        R,
        g,
        i,
        null == S ? void 0 : S.element
    ]);
    var M = (0, $acw62.useCallback)(function(e) {
        if (!C || !C.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
        return C.execute(x.current, {
            action: e
        });
    }, [
        C,
        x
    ]), N = (0, $acw62.useMemo)(function() {
        return {
            executeRecaptcha: C ? M : void 0,
            container: null == S ? void 0 : S.element
        };
    }, [
        M,
        C,
        null == S ? void 0 : S.element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7b9bf6be2b37a4cd$export$dd93270ab0cf623c.Provider, {
        value: N
    }, w);
}
var $7b9bf6be2b37a4cd$export$7f8feffd50fb5144 = function() {
    return (0, $acw62.useContext)($7b9bf6be2b37a4cd$export$dd93270ab0cf623c);
};
function $7b9bf6be2b37a4cd$export$d5aa16f6da947fbf(t) {
    var r = this, o = t.action, a = t.onVerify, c = t.refreshReCaptcha, i = $7b9bf6be2b37a4cd$export$7f8feffd50fb5144();
    (0, $acw62.useEffect)(function() {
        var e = i.executeRecaptcha;
        if (e) $7b9bf6be2b37a4cd$var$u(r, void 0, void 0, function() {
            var t;
            return $7b9bf6be2b37a4cd$var$l(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            e(o)
                        ];
                    case 1:
                        return t = r.sent(), a ? (a(t), [
                            2
                        ]) : ($7b9bf6be2b37a4cd$var$m("Please define an onVerify function"), [
                            2
                        ]);
                }
            });
        });
    }, [
        o,
        a,
        c,
        i
    ]);
    var s = i.container;
    return "string" == typeof s ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: s
    }) : null;
}
function $7b9bf6be2b37a4cd$var$w(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ }
var $7b9bf6be2b37a4cd$var$$ = "function" == typeof Symbol && Symbol.for, $7b9bf6be2b37a4cd$var$C = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.element") : 60103, $7b9bf6be2b37a4cd$var$P = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.portal") : 60106, $7b9bf6be2b37a4cd$var$x = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.fragment") : 60107, $7b9bf6be2b37a4cd$var$E = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.strict_mode") : 60108, $7b9bf6be2b37a4cd$var$R = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.profiler") : 60114, $7b9bf6be2b37a4cd$var$M = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.provider") : 60109, $7b9bf6be2b37a4cd$var$N = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.context") : 60110, $7b9bf6be2b37a4cd$var$O = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.async_mode") : 60111, $7b9bf6be2b37a4cd$var$_ = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.concurrent_mode") : 60111, $7b9bf6be2b37a4cd$var$T = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.forward_ref") : 60112, $7b9bf6be2b37a4cd$var$j = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.suspense") : 60113, $7b9bf6be2b37a4cd$var$L = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.suspense_list") : 60120, $7b9bf6be2b37a4cd$var$k = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.memo") : 60115, $7b9bf6be2b37a4cd$var$F = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.lazy") : 60116, $7b9bf6be2b37a4cd$var$A = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.block") : 60121, $7b9bf6be2b37a4cd$var$V = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.fundamental") : 60117, $7b9bf6be2b37a4cd$var$z = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.responder") : 60118, $7b9bf6be2b37a4cd$var$G = $7b9bf6be2b37a4cd$var$$ ? Symbol.for("react.scope") : 60119;
function $7b9bf6be2b37a4cd$var$I(e) {
    if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch(t){
            case $7b9bf6be2b37a4cd$var$C:
                switch(e = e.type){
                    case $7b9bf6be2b37a4cd$var$O:
                    case $7b9bf6be2b37a4cd$var$_:
                    case $7b9bf6be2b37a4cd$var$x:
                    case $7b9bf6be2b37a4cd$var$R:
                    case $7b9bf6be2b37a4cd$var$E:
                    case $7b9bf6be2b37a4cd$var$j:
                        return e;
                    default:
                        switch(e = e && e.$$typeof){
                            case $7b9bf6be2b37a4cd$var$N:
                            case $7b9bf6be2b37a4cd$var$T:
                            case $7b9bf6be2b37a4cd$var$F:
                            case $7b9bf6be2b37a4cd$var$k:
                            case $7b9bf6be2b37a4cd$var$M:
                                return e;
                            default:
                                return t;
                        }
                }
            case $7b9bf6be2b37a4cd$var$P:
                return t;
        }
    }
}
function $7b9bf6be2b37a4cd$var$D(e) {
    return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$_;
}
var $7b9bf6be2b37a4cd$var$q = {
    AsyncMode: $7b9bf6be2b37a4cd$var$O,
    ConcurrentMode: $7b9bf6be2b37a4cd$var$_,
    ContextConsumer: $7b9bf6be2b37a4cd$var$N,
    ContextProvider: $7b9bf6be2b37a4cd$var$M,
    Element: $7b9bf6be2b37a4cd$var$C,
    ForwardRef: $7b9bf6be2b37a4cd$var$T,
    Fragment: $7b9bf6be2b37a4cd$var$x,
    Lazy: $7b9bf6be2b37a4cd$var$F,
    Memo: $7b9bf6be2b37a4cd$var$k,
    Portal: $7b9bf6be2b37a4cd$var$P,
    Profiler: $7b9bf6be2b37a4cd$var$R,
    StrictMode: $7b9bf6be2b37a4cd$var$E,
    Suspense: $7b9bf6be2b37a4cd$var$j,
    isAsyncMode: function(e) {
        return $7b9bf6be2b37a4cd$var$D(e) || $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$O;
    },
    isConcurrentMode: $7b9bf6be2b37a4cd$var$D,
    isContextConsumer: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$N;
    },
    isContextProvider: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$M;
    },
    isElement: function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === $7b9bf6be2b37a4cd$var$C;
    },
    isForwardRef: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$T;
    },
    isFragment: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$x;
    },
    isLazy: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$F;
    },
    isMemo: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$k;
    },
    isPortal: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$P;
    },
    isProfiler: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$R;
    },
    isStrictMode: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$E;
    },
    isSuspense: function(e) {
        return $7b9bf6be2b37a4cd$var$I(e) === $7b9bf6be2b37a4cd$var$j;
    },
    isValidElementType: function(e) {
        return "string" == typeof e || "function" == typeof e || e === $7b9bf6be2b37a4cd$var$x || e === $7b9bf6be2b37a4cd$var$_ || e === $7b9bf6be2b37a4cd$var$R || e === $7b9bf6be2b37a4cd$var$E || e === $7b9bf6be2b37a4cd$var$j || e === $7b9bf6be2b37a4cd$var$L || "object" == typeof e && null !== e && (e.$$typeof === $7b9bf6be2b37a4cd$var$F || e.$$typeof === $7b9bf6be2b37a4cd$var$k || e.$$typeof === $7b9bf6be2b37a4cd$var$M || e.$$typeof === $7b9bf6be2b37a4cd$var$N || e.$$typeof === $7b9bf6be2b37a4cd$var$T || e.$$typeof === $7b9bf6be2b37a4cd$var$V || e.$$typeof === $7b9bf6be2b37a4cd$var$z || e.$$typeof === $7b9bf6be2b37a4cd$var$G || e.$$typeof === $7b9bf6be2b37a4cd$var$A);
    },
    typeOf: $7b9bf6be2b37a4cd$var$I
}, $7b9bf6be2b37a4cd$var$B = $7b9bf6be2b37a4cd$var$w(function(e, t) {}), $7b9bf6be2b37a4cd$var$J = ($7b9bf6be2b37a4cd$var$B.AsyncMode, $7b9bf6be2b37a4cd$var$B.ConcurrentMode, $7b9bf6be2b37a4cd$var$B.ContextConsumer, $7b9bf6be2b37a4cd$var$B.ContextProvider, $7b9bf6be2b37a4cd$var$B.Element, $7b9bf6be2b37a4cd$var$B.ForwardRef, $7b9bf6be2b37a4cd$var$B.Fragment, $7b9bf6be2b37a4cd$var$B.Lazy, $7b9bf6be2b37a4cd$var$B.Memo, $7b9bf6be2b37a4cd$var$B.Portal, $7b9bf6be2b37a4cd$var$B.Profiler, $7b9bf6be2b37a4cd$var$B.StrictMode, $7b9bf6be2b37a4cd$var$B.Suspense, $7b9bf6be2b37a4cd$var$B.isAsyncMode, $7b9bf6be2b37a4cd$var$B.isConcurrentMode, $7b9bf6be2b37a4cd$var$B.isContextConsumer, $7b9bf6be2b37a4cd$var$B.isContextProvider, $7b9bf6be2b37a4cd$var$B.isElement, $7b9bf6be2b37a4cd$var$B.isForwardRef, $7b9bf6be2b37a4cd$var$B.isFragment, $7b9bf6be2b37a4cd$var$B.isLazy, $7b9bf6be2b37a4cd$var$B.isMemo, $7b9bf6be2b37a4cd$var$B.isPortal, $7b9bf6be2b37a4cd$var$B.isProfiler, $7b9bf6be2b37a4cd$var$B.isStrictMode, $7b9bf6be2b37a4cd$var$B.isSuspense, $7b9bf6be2b37a4cd$var$B.isValidElementType, $7b9bf6be2b37a4cd$var$B.typeOf, $7b9bf6be2b37a4cd$var$w(function(e) {
    e.exports = $7b9bf6be2b37a4cd$var$q;
})), $7b9bf6be2b37a4cd$var$K = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $7b9bf6be2b37a4cd$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $7b9bf6be2b37a4cd$var$H = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $7b9bf6be2b37a4cd$var$Q = {};
function $7b9bf6be2b37a4cd$var$W(e) {
    return $7b9bf6be2b37a4cd$var$J.isMemo(e) ? $7b9bf6be2b37a4cd$var$H : $7b9bf6be2b37a4cd$var$Q[e.$$typeof] || $7b9bf6be2b37a4cd$var$K;
}
$7b9bf6be2b37a4cd$var$Q[$7b9bf6be2b37a4cd$var$J.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $7b9bf6be2b37a4cd$var$Q[$7b9bf6be2b37a4cd$var$J.Memo] = $7b9bf6be2b37a4cd$var$H;
var $7b9bf6be2b37a4cd$var$X = Object.defineProperty, $7b9bf6be2b37a4cd$var$Y = Object.getOwnPropertyNames, $7b9bf6be2b37a4cd$var$Z = Object.getOwnPropertySymbols, $7b9bf6be2b37a4cd$var$ee = Object.getOwnPropertyDescriptor, $7b9bf6be2b37a4cd$var$te = Object.getPrototypeOf, $7b9bf6be2b37a4cd$var$re = Object.prototype;
var $7b9bf6be2b37a4cd$var$oe = function e(t, r, o) {
    if ("string" != typeof r) {
        if ($7b9bf6be2b37a4cd$var$re) {
            var n = $7b9bf6be2b37a4cd$var$te(r);
            n && n !== $7b9bf6be2b37a4cd$var$re && e(t, n, o);
        }
        var a = $7b9bf6be2b37a4cd$var$Y(r);
        $7b9bf6be2b37a4cd$var$Z && (a = a.concat($7b9bf6be2b37a4cd$var$Z(r)));
        for(var c = $7b9bf6be2b37a4cd$var$W(t), i = $7b9bf6be2b37a4cd$var$W(r), s = 0; s < a.length; ++s){
            var u = a[s];
            if (!($7b9bf6be2b37a4cd$var$U[u] || o && o[u] || i && i[u] || c && c[u])) {
                var l = $7b9bf6be2b37a4cd$var$ee(r, u);
                try {
                    $7b9bf6be2b37a4cd$var$X(t, u, l);
                } catch (e) {}
            }
        }
    }
    return t;
}, $7b9bf6be2b37a4cd$export$b641f6dbb7005cb7 = function(t) {
    var r = function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7b9bf6be2b37a4cd$export$14d6311c3d83742b, null, function(o) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(t, $7b9bf6be2b37a4cd$var$s({}, r, {
                googleReCaptchaProps: o
            }));
        });
    };
    return r.displayName = "withGoogleReCaptcha(" + (t.displayName || t.name || "Component") + ")", $7b9bf6be2b37a4cd$var$oe(r, t), r;
};



const $21eec0eb2da7c252$var$onFinishFailed = (errorInfo)=>{
    console.log("Failed:", errorInfo);
};
const $21eec0eb2da7c252$var$passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).*$/;
// Custom validator function
const $21eec0eb2da7c252$var$validatePassword = (_, value)=>{
    if (!value) return Promise.reject(new Error("Password is required"));
    if (!$21eec0eb2da7c252$var$passwordRegex.test(value)) return Promise.reject(new Error("Password must include at least one uppercase letter, one number, and one symbol"));
    return Promise.resolve();
};
const $21eec0eb2da7c252$var$Register = ({ isAuthenticated: isAuthenticated, setIsAuthenticated: setIsAuthenticated, isLoading: isLoading })=>{
    const [statusMessage, setStatusMessage] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)(undefined);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { executeRecaptcha: executeRecaptcha } = (0, $7b9bf6be2b37a4cd$export$7f8feffd50fb5144)();
    const registerNewUser = async (formData)=>{
        if (!executeRecaptcha) return;
        try {
            const token = await executeRecaptcha("register");
            const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/users/register", {
                ...formData,
                token: token
            }, {
                withCredentials: true
            });
            const data = response.data;
            setStatusMessage(data.messages.join("\n"));
            setStatus("success");
            return true;
        } catch (error) {
            console.log("Catch error:", error);
            const errorMessages = error.response.data.messages;
            setStatus("error");
            setStatusMessage(errorMessages.join("\n"));
            return false;
        }
    };
    const onFinish = async (values)=>{
        const successfulRegistration = await registerNewUser(values);
        if (successfulRegistration) {
            setIsAuthenticated(true);
            navigate("/");
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (!isLoading) {
            if (isAuthenticated) navigate("/");
        }
    });
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c92d6609230c449a$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "loginContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Register"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
                name: "basic",
                labelCol: {
                    span: 8
                },
                wrapperCol: {
                    span: 14
                },
                initialValues: {
                    remember: true
                },
                onFinish: onFinish,
                onFinishFailed: $21eec0eb2da7c252$var$onFinishFailed,
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Email",
                        name: "email",
                        rules: [
                            {
                                required: true,
                                message: "Please enter your email"
                            },
                            {
                                type: "email",
                                message: "Please enter a valid email"
                            }
                        ],
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Username",
                        name: "username",
                        rules: [
                            {
                                required: true,
                                message: "Please enter a unique username"
                            },
                            {
                                min: 4,
                                message: "Username must be at least 4 characters long"
                            }
                        ],
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Password",
                        name: "password",
                        rules: [
                            {
                                required: true,
                                message: "Please enter a password"
                            }
                        ],
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Confirm Password",
                        name: "confirmPassword",
                        rules: [
                            {
                                required: true,
                                message: "Please confirm your password"
                            },
                            ({ getFieldValue: getFieldValue })=>({
                                    validator (_, value) {
                                        if (!value || getFieldValue("password") === value) return Promise.resolve();
                                        return Promise.reject(new Error("The passwords you entered do not match"));
                                    }
                                })
                        ],
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        wrapperCol: {
                            offset: 8,
                            span: 16
                        },
                        help: status === "error" || !status ? statusMessage : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                color: "green"
                            },
                            children: statusMessage
                        }),
                        validateStatus: status,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                type: "primary",
                                htmlType: "submit",
                                children: "Register"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Already have an account?",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: " Login here"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $21eec0eb2da7c252$export$2e2bcd8739ae039 = $21eec0eb2da7c252$var$Register;






var $acw62 = parcelRequire("acw62");



const $dd3360b4a2f9eb72$var$onFinishFailed = (errorInfo)=>{
    console.log("Failed:", errorInfo);
};
const $dd3360b4a2f9eb72$var$Login = ({ isAuthenticated: isAuthenticated, setIsAuthenticated: setIsAuthenticated, isLoading: isLoading })=>{
    const [statusMessage, setStatusMessage] = (0, $acw62.useState)(null);
    const [status, setStatus] = (0, $acw62.useState)(undefined);
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const { executeRecaptcha: executeRecaptcha } = (0, $7b9bf6be2b37a4cd$export$7f8feffd50fb5144)();
    const loginUser = (0, $acw62.useCallback)(async (formData)=>{
        if (!executeRecaptcha) {
            console.log("Recaptcha not loaded");
            return;
        }
        try {
            const token = await executeRecaptcha("login");
            const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/users/login", {
                ...formData,
                token: token
            }, {
                withCredentials: true
            });
            const data = response.data;
            setStatusMessage(data.messages.join("\n"));
            setStatus("success");
            return true;
        } catch (error) {
            console.log("Catch error:", error);
            const errorMessages = error.response.data.messages;
            setStatus("error");
            setStatusMessage(errorMessages.join("\n"));
            return false;
        }
    }, [
        executeRecaptcha
    ]);
    const onFinish = async (values)=>{
        const successfulLogin = await loginUser(values);
        if (successfulLogin) {
            setIsAuthenticated(true);
            navigate("/");
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (!isLoading) {
            if (isAuthenticated) navigate("/");
        }
    }, [
        isLoading
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c92d6609230c449a$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "loginContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "Login"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039), {
                name: "basic",
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 16
                },
                initialValues: {
                    remember: true
                },
                onFinish: onFinish,
                onFinishFailed: $dd3360b4a2f9eb72$var$onFinishFailed,
                autoComplete: "off",
                onSubmitCapture: (e)=>e.preventDefault(),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Username",
                        name: "username",
                        rules: [
                            {
                                required: true,
                                message: "Please input your username!"
                            }
                        ],
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        label: "Password",
                        name: "password",
                        rules: [
                            {
                                required: true,
                                message: "Please input your password!"
                            }
                        ],
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ad70426818bb52aa$export$2e2bcd8739ae039).Password, {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        name: "remember",
                        valuePropName: "checked",
                        wrapperCol: {
                            offset: 6,
                            span: 16
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da237ba92f78ed9a$export$2e2bcd8739ae039), {
                            children: "Remember me"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $38feeba41dc3d65b$export$2e2bcd8739ae039).Item, {
                        wrapperCol: {
                            offset: 6,
                            span: 16
                        },
                        help: status === "error" || !status ? statusMessage : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                color: "green"
                            },
                            children: statusMessage
                        }),
                        validateStatus: status,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                type: "primary",
                                htmlType: "submit",
                                children: "Log in"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    "Don't have an account?",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: "/register",
                                        children: " Register here"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $dd3360b4a2f9eb72$export$2e2bcd8739ae039 = $dd3360b4a2f9eb72$var$Login;




var $acw62 = parcelRequire("acw62");




const $cd4511523991f10d$var$ProtectedRoute = ({ children: children, isAuthenticated: isAuthenticated, setIsAuthenticated: setIsAuthenticated, isLoading: isLoading, setIsAdmin: setIsAdmin, setUsername: setUsername, setUserSettings: setUserSettings, setIsLoading: setIsLoading })=>{
    const { problem_id: problem_id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    (0, $acw62.useEffect)(()=>{
        const verifyAuthentication = async ()=>{
            const authenticationData = await (0, $3d74bff2846008b2$export$50e2e2a2bbf3f2dd)();
            setIsAuthenticated(authenticationData.is_authenticated);
            setIsAdmin(authenticationData.is_admin);
            setUsername(authenticationData.username);
            setUserSettings(authenticationData.userSettings);
            setIsLoading(false);
        };
        verifyAuthentication();
    }, [
        navigate
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isLoading) {
            if (!isAuthenticated) navigate("/login");
        }
    }, [
        isLoading
    ]);
    (0, $acw62.useEffect)(()=>{
        if (problem_id && problemContext) {
            const { setProblem_id: setProblem_id } = problemContext;
            setProblem_id(Number(problem_id));
        }
    }, [
        problem_id
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c92d6609230c449a$export$2e2bcd8739ae039), {});
    return isAuthenticated ? children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: "/login"
    });
};
var $cd4511523991f10d$export$2e2bcd8739ae039 = $cd4511523991f10d$var$ProtectedRoute;





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");


"use client";
var $c5716fc3f3b274e3$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $c5716fc3f3b274e3$var$Grid = (_a)=>{
    var { prefixCls: prefixCls, className: className, hoverable: hoverable = true } = _a, props = $c5716fc3f3b274e3$var$__rest(_a, [
        "prefixCls",
        "className",
        "hoverable"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls("card", prefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefix}-grid`, className, {
        [`${prefix}-grid-hoverable`]: hoverable
    });
    return /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, props, {
        className: classString
    }));
};
var $c5716fc3f3b274e3$export$2e2bcd8739ae039 = $c5716fc3f3b274e3$var$Grid;





// ============================== Styles ==============================
// ============================== Head ==============================
const $c1a74e45bd15dd4b$var$genCardHeadStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, headerHeight: headerHeight, cardPaddingBase: cardPaddingBase, tabsMarginBottom: tabsMarginBottom } = token;
    return Object.assign(Object.assign({
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: headerHeight,
        marginBottom: -1,
        padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(cardPaddingBase)}`,
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: token.headerFontSize,
        background: token.headerBg,
        borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`,
        borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
    }, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
        "&-wrapper": {
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        "&-title": Object.assign(Object.assign({
            display: "inline-block",
            flex: 1
        }, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)), {
            [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
                insetInlineStart: 0,
                marginTop: 0,
                marginBottom: 0
            }
        }),
        [`${antCls}-tabs-top`]: {
            clear: "both",
            marginBottom: tabsMarginBottom,
            color: token.colorText,
            fontWeight: "normal",
            fontSize: token.fontSize,
            "&-bar": {
                borderBottom: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`
            }
        }
    });
};
// ============================== Grid ==============================
const $c1a74e45bd15dd4b$var$genCardGridStyle = (token)=>{
    const { cardPaddingBase: cardPaddingBase, colorBorderSecondary: colorBorderSecondary, cardShadow: cardShadow, lineWidth: lineWidth } = token;
    return {
        width: "33.33%",
        padding: cardPaddingBase,
        border: 0,
        borderRadius: 0,
        boxShadow: `
      ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
        transition: `all ${token.motionDurationMid}`,
        "&-hoverable:hover": {
            position: "relative",
            zIndex: 1,
            boxShadow: cardShadow
        }
    };
};
// ============================== Actions ==============================
const $c1a74e45bd15dd4b$var$genCardActionsStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, actionsLiMargin: actionsLiMargin, cardActionsIconSize: cardActionsIconSize, colorBorderSecondary: colorBorderSecondary, actionsBg: actionsBg } = token;
    return Object.assign(Object.assign({
        margin: 0,
        padding: 0,
        listStyle: "none",
        background: actionsBg,
        borderTop: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
        display: "flex",
        borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)}`
    }, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
        "& > li": {
            margin: actionsLiMargin,
            color: token.colorTextDescription,
            textAlign: "center",
            "> span": {
                position: "relative",
                display: "block",
                minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                cursor: "pointer",
                "&:hover": {
                    color: token.colorPrimary,
                    transition: `color ${token.motionDurationMid}`
                },
                [`a:not(${componentCls}-btn), > ${iconCls}`]: {
                    display: "inline-block",
                    width: "100%",
                    color: token.colorTextDescription,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.fontHeight),
                    transition: `color ${token.motionDurationMid}`,
                    "&:hover": {
                        color: token.colorPrimary
                    }
                },
                [`> ${iconCls}`]: {
                    fontSize: cardActionsIconSize,
                    lineHeight: (0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
                }
            },
            "&:not(:last-child)": {
                borderInlineEnd: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`
            }
        }
    });
};
// ============================== Meta ==============================
const $c1a74e45bd15dd4b$var$genCardMetaStyle = (token)=>Object.assign(Object.assign({
        margin: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.calc(token.marginXXS).mul(-1).equal())} 0`,
        display: "flex"
    }, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()), {
        "&-avatar": {
            paddingInlineEnd: token.padding
        },
        "&-detail": {
            overflow: "hidden",
            flex: 1,
            "> div:not(:last-child)": {
                marginBottom: token.marginXS
            }
        },
        "&-title": Object.assign({
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            fontSize: token.fontSizeLG
        }, (0, $4733a3b3eb18f80d$export$b2b65df0d0824629)),
        "&-description": {
            color: token.colorTextDescription
        }
    });
// ============================== Inner ==============================
const $c1a74e45bd15dd4b$var$genCardTypeInnerStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingBase: cardPaddingBase, colorFillAlter: colorFillAlter } = token;
    return {
        [`${componentCls}-head`]: {
            padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(cardPaddingBase)}`,
            background: colorFillAlter,
            "&-title": {
                fontSize: token.fontSize
            }
        },
        [`${componentCls}-body`]: {
            padding: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.padding)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(cardPaddingBase)}`
        }
    };
};
// ============================== Loading ==============================
const $c1a74e45bd15dd4b$var$genCardLoadingStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        overflow: "hidden",
        [`${componentCls}-body`]: {
            userSelect: "none"
        }
    };
};
// ============================== Basic ==============================
const $c1a74e45bd15dd4b$var$genCardStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, cardShadow: cardShadow, cardHeadPadding: cardHeadPadding, colorBorderSecondary: colorBorderSecondary, boxShadowTertiary: boxShadowTertiary, cardPaddingBase: cardPaddingBase, extraColor: extraColor } = token;
    return {
        [componentCls]: Object.assign(Object.assign({}, (0, $4733a3b3eb18f80d$export$23997c3e44cc1c59)(token)), {
            position: "relative",
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            [`&:not(${componentCls}-bordered)`]: {
                boxShadow: boxShadowTertiary
            },
            [`${componentCls}-head`]: $c1a74e45bd15dd4b$var$genCardHeadStyle(token),
            [`${componentCls}-extra`]: {
                // https://stackoverflow.com/a/22429853/3040605
                marginInlineStart: "auto",
                color: extraColor,
                fontWeight: "normal",
                fontSize: token.fontSize
            },
            [`${componentCls}-body`]: Object.assign({
                padding: cardPaddingBase,
                borderRadius: `0 0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)}`
            }, (0, $4733a3b3eb18f80d$export$8c467e8859fdef13)()),
            [`${componentCls}-grid`]: $c1a74e45bd15dd4b$var$genCardGridStyle(token),
            [`${componentCls}-cover`]: {
                "> *": {
                    display: "block",
                    width: "100%"
                },
                [`img, img + ${antCls}-image-mask`]: {
                    borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                }
            },
            [`${componentCls}-actions`]: $c1a74e45bd15dd4b$var$genCardActionsStyle(token),
            [`${componentCls}-meta`]: $c1a74e45bd15dd4b$var$genCardMetaStyle(token)
        }),
        [`${componentCls}-bordered`]: {
            border: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
            [`${componentCls}-cover`]: {
                marginTop: -1,
                marginInlineStart: -1,
                marginInlineEnd: -1
            }
        },
        [`${componentCls}-hoverable`]: {
            cursor: "pointer",
            transition: `box-shadow ${token.motionDurationMid}, border-color ${token.motionDurationMid}`,
            "&:hover": {
                borderColor: "transparent",
                boxShadow: cardShadow
            }
        },
        [`${componentCls}-contain-grid`]: {
            borderRadius: `${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $f97444ff16d95e90$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 `,
            [`${componentCls}-body`]: {
                display: "flex",
                flexWrap: "wrap"
            },
            [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
                marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                padding: 0
            }
        },
        [`${componentCls}-contain-tabs`]: {
            [`> div${componentCls}-head`]: {
                minHeight: 0,
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: cardHeadPadding
                }
            }
        },
        [`${componentCls}-type-inner`]: $c1a74e45bd15dd4b$var$genCardTypeInnerStyle(token),
        [`${componentCls}-loading`]: $c1a74e45bd15dd4b$var$genCardLoadingStyle(token),
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        }
    };
};
// ============================== Size ==============================
const $c1a74e45bd15dd4b$var$genCardSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, headerHeightSM: headerHeightSM, headerFontSizeSM: headerFontSizeSM } = token;
    return {
        [`${componentCls}-small`]: {
            [`> ${componentCls}-head`]: {
                minHeight: headerHeightSM,
                padding: `0 ${(0, $f97444ff16d95e90$export$523c0b569236b342)(cardPaddingSM)}`,
                fontSize: headerFontSizeSM,
                [`> ${componentCls}-head-wrapper`]: {
                    [`> ${componentCls}-extra`]: {
                        fontSize: token.fontSize
                    }
                }
            },
            [`> ${componentCls}-body`]: {
                padding: cardPaddingSM
            }
        },
        [`${componentCls}-small${componentCls}-contain-tabs`]: {
            [`> ${componentCls}-head`]: {
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: 0,
                    display: "flex",
                    alignItems: "center"
                }
            }
        }
    };
};
const $c1a74e45bd15dd4b$export$9ca1be8807fe0675 = (token)=>({
        headerBg: "transparent",
        headerFontSize: token.fontSizeLG,
        headerFontSizeSM: token.fontSize,
        headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
        headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
        actionsBg: token.colorBgContainer,
        actionsLiMargin: `${token.paddingSM}px 0`,
        tabsMarginBottom: -token.padding - token.lineWidth,
        extraColor: token.colorText
    });
var // ============================== Export ==============================
$c1a74e45bd15dd4b$export$2e2bcd8739ae039 = (0, $099b764a368ed79c$export$51ec95de45185b42)("Card", (token)=>{
    const cardToken = (0, $2049919111d93bd2$export$4950aa0f605343fb)(token, {
        cardShadow: token.boxShadowCard,
        cardHeadPadding: token.padding,
        cardPaddingBase: token.paddingLG,
        cardActionsIconSize: token.fontSize,
        cardPaddingSM: 12 // Fixed padding.
    });
    return [
        // Style
        $c1a74e45bd15dd4b$var$genCardStyle(cardToken),
        // Size
        $c1a74e45bd15dd4b$var$genCardSizeStyle(cardToken)
    ];
}, $c1a74e45bd15dd4b$export$9ca1be8807fe0675);


"use client";
var $7da732e5b8f158a2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $7da732e5b8f158a2$var$ActionNode = (props)=>{
    const { actionClasses: actionClasses, actions: actions = [], actionStyle: actionStyle } = props;
    return /*#__PURE__*/ $acw62.createElement("ul", {
        className: actionClasses,
        style: actionStyle
    }, actions.map((action, index)=>{
        // Move this out since eslint not allow index key
        // And eslint-disable makes conflict with rollup
        // ref https://github.com/ant-design/ant-design/issues/46022
        const key = `action-${index}`;
        return /*#__PURE__*/ $acw62.createElement("li", {
            style: {
                width: `${100 / actions.length}%`
            },
            key: key
        }, /*#__PURE__*/ $acw62.createElement("span", null, action));
    }));
};
const $7da732e5b8f158a2$var$Card = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, extra: extra, headStyle: headStyle = {}, bodyStyle: bodyStyle = {}, title: title, loading: loading, bordered: bordered = true, size: customizeSize, type: type, cover: cover, actions: actions, tabList: tabList, children: children, activeTabKey: activeTabKey, defaultActiveTabKey: defaultActiveTabKey, tabBarExtraContent: tabBarExtraContent, hoverable: hoverable, tabProps: tabProps = {}, classNames: customClassNames, styles: customStyles } = props, others = $7da732e5b8f158a2$var$__rest(props, [
        "prefixCls",
        "className",
        "rootClassName",
        "style",
        "extra",
        "headStyle",
        "bodyStyle",
        "title",
        "loading",
        "bordered",
        "size",
        "type",
        "cover",
        "actions",
        "tabList",
        "children",
        "activeTabKey",
        "defaultActiveTabKey",
        "tabBarExtraContent",
        "hoverable",
        "tabProps",
        "classNames",
        "styles"
    ]);
    const { getPrefixCls: getPrefixCls, direction: direction, card: card } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    var _ref;
    const onTabChange = (key)=>{
        var _a;
        (_a = props.onTabChange) === null || _a === void 0 || _a.call(props, key);
    };
    const moduleClass = (moduleName)=>{
        var _a;
        return (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))((_a = card === null || card === void 0 ? void 0 : card.classNames) === null || _a === void 0 ? void 0 : _a[moduleName], customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames[moduleName]);
    };
    const moduleStyle = (moduleName)=>{
        var _a;
        return Object.assign(Object.assign({}, (_a = card === null || card === void 0 ? void 0 : card.styles) === null || _a === void 0 ? void 0 : _a[moduleName]), customStyles === null || customStyles === void 0 ? void 0 : customStyles[moduleName]);
    };
    const isContainGrid = $acw62.useMemo(()=>{
        let containGrid = false;
        $acw62.Children.forEach(children, (element)=>{
            if ((element === null || element === void 0 ? void 0 : element.type) === (0, $c5716fc3f3b274e3$export$2e2bcd8739ae039)) containGrid = true;
        });
        return containGrid;
    }, [
        children
    ]);
    const prefixCls = getPrefixCls("card", customizePrefixCls);
    const [wrapCSSVar, hashId, cssVarCls] = (0, $c1a74e45bd15dd4b$export$2e2bcd8739ae039)(prefixCls);
    const loadingBlock = /*#__PURE__*/ $acw62.createElement((0, $b9eb1d5949d003b0$export$2e2bcd8739ae039), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = Object.assign(Object.assign({}, tabProps), {
        [hasActiveTabKey ? "activeKey" : "defaultActiveKey"]: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
        tabBarExtraContent: tabBarExtraContent
    });
    let head;
    const mergedSize = (0, $086416f743106ac8$export$2e2bcd8739ae039)(customizeSize);
    const tabSize = !mergedSize || mergedSize === "default" ? "large" : mergedSize;
    const tabs = tabList ? /*#__PURE__*/ $acw62.createElement((0, $389d763730796d58$export$2e2bcd8739ae039), Object.assign({
        size: tabSize
    }, extraProps, {
        className: `${prefixCls}-head-tabs`,
        onChange: onTabChange,
        items: tabList.map((_a)=>{
            var { tab: tab } = _a, item = $7da732e5b8f158a2$var$__rest(_a, [
                "tab"
            ]);
            return Object.assign({
                label: tab
            }, item);
        })
    })) : null;
    if (title || extra || tabs) {
        const headClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-head`, moduleClass("header"));
        const titleClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-head-title`, moduleClass("title"));
        const extraClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-extra`, moduleClass("extra"));
        const mergedHeadStyle = Object.assign(Object.assign({}, headStyle), moduleStyle("header"));
        head = /*#__PURE__*/ $acw62.createElement("div", {
            className: headClasses,
            style: mergedHeadStyle
        }, /*#__PURE__*/ $acw62.createElement("div", {
            className: `${prefixCls}-head-wrapper`
        }, title && /*#__PURE__*/ $acw62.createElement("div", {
            className: titleClasses,
            style: moduleStyle("title")
        }, title), extra && /*#__PURE__*/ $acw62.createElement("div", {
            className: extraClasses,
            style: moduleStyle("extra")
        }, extra)), tabs);
    }
    const coverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-cover`, moduleClass("cover"));
    const coverDom = cover ? /*#__PURE__*/ $acw62.createElement("div", {
        className: coverClasses,
        style: moduleStyle("cover")
    }, cover) : null;
    const bodyClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-body`, moduleClass("body"));
    const mergedBodyStyle = Object.assign(Object.assign({}, bodyStyle), moduleStyle("body"));
    const body = /*#__PURE__*/ $acw62.createElement("div", {
        className: bodyClasses,
        style: mergedBodyStyle
    }, loading ? loadingBlock : children);
    const actionClasses = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-actions`, moduleClass("actions"));
    const actionDom = (actions === null || actions === void 0 ? void 0 : actions.length) ? /*#__PURE__*/ $acw62.createElement($7da732e5b8f158a2$var$ActionNode, {
        actionClasses: actionClasses,
        actionStyle: moduleStyle("actions"),
        actions: actions
    }) : null;
    const divProps = (0, $1061fbcb6f08086c$export$2e2bcd8739ae039)(others, [
        "onTabChange"
    ]);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(prefixCls, card === null || card === void 0 ? void 0 : card.className, {
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-bordered`]: bordered,
        [`${prefixCls}-hoverable`]: hoverable,
        [`${prefixCls}-contain-grid`]: isContainGrid,
        [`${prefixCls}-contain-tabs`]: tabList === null || tabList === void 0 ? void 0 : tabList.length,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-type-${type}`]: !!type,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId, cssVarCls);
    const mergedStyle = Object.assign(Object.assign({}, card === null || card === void 0 ? void 0 : card.style), style);
    return wrapCSSVar(/*#__PURE__*/ $acw62.createElement("div", Object.assign({
        ref: ref
    }, divProps, {
        className: classString,
        style: mergedStyle
    }), head, coverDom, body, actionDom));
});
var $7da732e5b8f158a2$export$2e2bcd8739ae039 = $7da732e5b8f158a2$var$Card;




var $acw62 = parcelRequire("acw62");


"use client";
var $f477fb231ccbb49c$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f477fb231ccbb49c$var$Meta = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description } = props, others = $f477fb231ccbb49c$var$__rest(props, [
        "prefixCls",
        "className",
        "avatar",
        "title",
        "description"
    ]);
    const { getPrefixCls: getPrefixCls } = $acw62.useContext((0, $a18b2f6f56546238$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("card", customizePrefixCls);
    const classString = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${prefixCls}-meta`, className);
    const avatarDom = avatar ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-avatar`
    }, avatar) : null;
    const titleDom = title ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-title`
    }, title) : null;
    const descriptionDom = description ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-description`
    }, description) : null;
    const MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $acw62.createElement("div", {
        className: `${prefixCls}-meta-detail`
    }, titleDom, descriptionDom) : null;
    return /*#__PURE__*/ $acw62.createElement("div", Object.assign({}, others, {
        className: classString
    }), avatarDom, MetaDetail);
};
var $f477fb231ccbb49c$export$2e2bcd8739ae039 = $f477fb231ccbb49c$var$Meta;


"use client";
const $e1c21a702bf20ca7$var$Card = (0, $7da732e5b8f158a2$export$2e2bcd8739ae039);
$e1c21a702bf20ca7$var$Card.Grid = (0, $c5716fc3f3b274e3$export$2e2bcd8739ae039);
$e1c21a702bf20ca7$var$Card.Meta = (0, $f477fb231ccbb49c$export$2e2bcd8739ae039);
var $e1c21a702bf20ca7$export$2e2bcd8739ae039 = $e1c21a702bf20ca7$var$Card;





const $bd9e5bb34b4358e4$var$ProblemSelection = ({ isAdmin: isAdmin, setIsAuthenticated: setIsAuthenticated, userSettings: userSettings, username: username })=>{
    const [problems, setProblems] = (0, $acw62.useState)([]);
    const [problem, setProblem] = (0, $acw62.useState)();
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const [loadingProblems, setLoadingProblems] = (0, $acw62.useState)(true);
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) throw new Error("ProblemContext not found");
    const { setProblem_id: setProblem_id } = problemContext;
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const handleCancel = ()=>{
        setIsModalOpen(false);
    };
    const goToProblem = (problem_id)=>{
        // Ensure they're trying to navigate to a valid problem
        const targetProblem = problems.find((problem)=>problem.id === problem_id);
        if (!targetProblem) return;
        // Check if the problem has been started, if so, open decision modal, otherwise go straight to description
        if (targetProblem.problem_status === "not started") navigate(`/problems/${problem_id}/description`);
        else {
            // Open modal asking whether to review problem description or resume problem
            setProblem(targetProblem);
            setIsModalOpen(true);
        }
    };
    const handleLogout = async ()=>{
        try {
            const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/users/logout", {}, {
                withCredentials: true
            });
            setIsAuthenticated(false);
            setProblem_id(undefined);
            navigate("/login");
        } catch (error) {
            console.log("Logout error ->", error);
        }
    };
    const getBadgeProps = (problem)=>{
        switch(problem.problem_status){
            case "in-progress":
                return {
                    text: "In-progress",
                    color: "yellow",
                    display: "block"
                };
            case "completed":
                return {
                    text: "Submitted",
                    color: "green",
                    display: "block"
                };
            default:
                return {
                    text: "",
                    color: "",
                    display: "none"
                };
        }
    };
    const handleKeyDown = (e, id)=>{
        if (e.key === "Enter") goToProblem(id);
    };
    (0, $acw62.useEffect)(()=>{
        // Perform an axios request to get the problems
        const fetchProblems = async ()=>{
            try {
                const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/problems/get-problems", {
                    withCredentials: true
                });
                setProblems(res.data);
                setLoadingProblems(false);
            } catch (error) {
                console.log(error);
            }
        };
        fetchProblems();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "mainContainer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e1c21a702bf20ca7$export$2e2bcd8739ae039), {
                className: "problemListContainer",
                title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    children: "Problems"
                }),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                        theme: {
                            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                        },
                        children: problems.map((problem)=>{
                            if (problem.adminOnly) {
                                if (!isAdmin) return null;
                            }
                            const date_submitted = new Date(problem.date_submitted || "");
                            const formattedDate = date_submitted.toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "long",
                                day: "numeric"
                            });
                            const badgeProps = getBadgeProps(problem);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1118404ffe351710$export$2e2bcd8739ae039).Ribbon, {
                                text: badgeProps.text,
                                color: badgeProps.color,
                                style: {
                                    display: badgeProps.display
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e1c21a702bf20ca7$export$2e2bcd8739ae039), {
                                    className: "problemCard",
                                    onClick: ()=>goToProblem(problem.id),
                                    onKeyDown: (e)=>handleKeyDown(e, problem.id),
                                    "aria-label": `View Problem ${problem.problem_number}`,
                                    tabIndex: 0,
                                    hoverable: true,
                                    children: [
                                        `Problem ${problem.problem_number} - ${problem.title}`,
                                        problem.attempt_number !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "attemptNumberText",
                                            children: problem.problem_status === "completed" ? `${problem.attempt_number} attempts` : `Attempt Number: ${problem.attempt_number + 1}`
                                        }),
                                        problem.problem_status !== "not started" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "problemSubmittedDateContainer",
                                            children: [
                                                problem.total_tasks > 0 && (!userSettings || userSettings?.taskbar_enabled) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "tasksCompletedText",
                                                    children: `${problem.completed_tasks}/${problem.total_tasks} Tasks completed`
                                                }),
                                                problem.problem_status === "completed" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "submittedDateText",
                                                    children: `Date Submitted: ${formattedDate}`
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, problem.id);
                        })
                    }),
                    loadingProblems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "loadingSpinnerContainer",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $26f1cf19d4dd7058$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                theme: {
                    algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "problemSelectionLogoutBtn",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                            children: [
                                "Current user: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "usernameBold",
                                    children: username
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                            onClick: handleLogout,
                            children: "Logout"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e47cb76d58815cb1$export$2e2bcd8739ae039), {
                className: "reviewDescriptionOrResumeProblemModal",
                title: problem && `Problem ${problem.problem_number} - ${problem.title}`,
                open: isModalOpen,
                onCancel: handleCancel,
                footer: null,
                style: {
                    textAlign: "center"
                },
                centered: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "customModalBody",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "modalParagraphText",
                            children: `Review the problem description or
                        ${problem?.problem_status === "completed" ? "view your submission" : "resume the problem"}?`
                        }),
                        problem && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "modalButtonContainer",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>navigate(`/problems/${problem.id}/description`),
                                    children: "Review Description"
                                }),
                                problem.problem_status === "completed" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>navigate(`/problems/${problem.id}/submission`),
                                    children: "View Submission"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                    onClick: ()=>navigate(`/problems/${problem.id}`),
                                    children: "Resume Problem"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $bd9e5bb34b4358e4$export$2e2bcd8739ae039 = $bd9e5bb34b4358e4$var$ProblemSelection;



// ProblemProvider.tsx


var $acw62 = parcelRequire("acw62");



const $49f72ad1047e4a8b$var$ProblemProvider = ({ children: children })=>{
    // const [completedTasks, setCompletedTasks] = useState<string[]>([]);
    const [tasks, setTasks] = (0, $acw62.useState)([]);
    const [problem, setProblem] = (0, $acw62.useState)();
    const [problem_id, setProblem_id] = (0, $acw62.useState)();
    const tasksRef = (0, $acw62.useRef)(tasks);
    const markTaskAsCompleted = (0, $acw62.useCallback)(async (action)=>{
        const task = tasksRef.current.find((task)=>task.action === action);
        if (!task) return;
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/tasks/complete-task", {
                task_id: task.id
            }, {
                withCredentials: true
            });
            if (res.status !== 200) throw new Error(`Failed to mark task ${action} as completed`);
            setTasks((prevTasks)=>prevTasks.map((task)=>task.action === action ? {
                        ...task,
                        task_status: "completed"
                    } : task));
        } catch (error) {
            console.log(error);
        }
    }, [
        tasks
    ]);
    const removeTaskFromCompleted = (0, $acw62.useCallback)(async (action)=>{
        const task = tasksRef.current.find((task)=>task.action === action);
        if (!task) return;
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/tasks/revoke-task", {
                task_id: task.id
            }, {
                withCredentials: true
            });
            if (res.status !== 200) throw new Error(`Failed to revoke task completion for ${action}`);
            setTasks((prevTasks)=>prevTasks.map((task)=>task.action === action ? {
                        ...task,
                        task_status: "not completed"
                    } : task));
        } catch (error) {
            console.log(error);
        }
    }, [
        tasks
    ]);
    const currentTask = (0, $acw62.useMemo)(()=>{
        // Find the index of the first step that is not completed
        const firstIncompleteTaskIndex = tasks.findIndex((task)=>task.task_status === "not completed");
        return firstIncompleteTaskIndex !== -1 ? firstIncompleteTaskIndex : tasks.length;
    }, [
        tasks
    ]);
    (0, $acw62.useEffect)(()=>{
        const getProblemData = async ()=>{
            try {
                const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get(`/api/problems/get-problem/${problem_id}`, {
                    withCredentials: true
                });
                const { tasks: tasks, ...problem } = res.data;
                const cleanProblemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($d349326c2b62c55f$exports))).sanitize(problem.description, {
                    ALLOWED_ATTR: [
                        "target",
                        "href",
                        "src",
                        "alt",
                        "title",
                        "rel"
                    ]
                });
                if (problem.problem_status === "not started") {
                    const eventData = {
                        problem_number: problem.problem_number,
                        date_started: new Date().toLocaleString()
                    };
                    const logData = {
                        action: "start_problem",
                        problem_id: problem_id,
                        eventData: eventData,
                        details: (0, $cfadb87391ca5e26$export$5e4dc5c899332621)("start_problem", eventData)
                    };
                    (0, $cfadb87391ca5e26$export$7e41d6135b9d82b9)(logData);
                }
                setProblem({
                    ...problem,
                    description: cleanProblemDescription
                });
                setTasks(tasks);
            } catch (error) {
                console.log(error);
            }
        };
        if (problem_id) getProblemData();
        else {
            setProblem(undefined);
            setTasks([]);
        }
    }, [
        problem_id
    ]);
    (0, $acw62.useEffect)(()=>{
        tasksRef.current = tasks;
    }, [
        tasks
    ]);
    // The value object that will be passed to the context
    const contextValue = {
        setProblem_id: setProblem_id,
        tasks: tasks,
        setTasks: setTasks,
        problem: problem,
        setProblem: setProblem,
        currentTask: currentTask,
        markTaskAsCompleted: markTaskAsCompleted,
        removeTaskFromCompleted: removeTaskFromCompleted
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: children
    });
};
var $49f72ad1047e4a8b$export$2e2bcd8739ae039 = $49f72ad1047e4a8b$var$ProblemProvider;




var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");


const $3ea12b0f72ecab43$var$SubmissionContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $3ea12b0f72ecab43$export$6a9bc7ec8fddbf5 = ()=>{
    const context = (0, $acw62.useContext)($3ea12b0f72ecab43$var$SubmissionContext);
    if (context === undefined) throw new Error("useSubmission must be used within a ProblemSubmissionProvider");
    return context;
};
const $3ea12b0f72ecab43$var$ProblemSubmissionProvider = ({ children: children })=>{
    const { problem_id: problem_id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const [isSubmitted, setIsSubmitted] = (0, $acw62.useState)(null);
    const [submissionDetails, setSubmissionDetails] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        const checkSubmissionStatus = async ()=>{
            setIsLoading(true);
            try {
                const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get(`/api/problems/get-problem/${problem_id}/submission-status`);
                setIsSubmitted(response.data.isSubmitted);
                setSubmissionDetails({
                    ...response.data.userProblemData
                });
            } catch (error) {
                console.error("Error fetching submission status:", error);
            } finally{
                setIsLoading(false);
            }
        };
        checkSubmissionStatus();
    }, [
        problem_id
    ]);
    const contextValue = {
        submissionDetails: submissionDetails,
        setSubmissionDetails: setSubmissionDetails,
        isSubmitted: !!isSubmitted,
        isLoading: isLoading
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3ea12b0f72ecab43$var$SubmissionContext.Provider, {
        value: contextValue,
        children: children
    });
};
var $3ea12b0f72ecab43$export$2e2bcd8739ae039 = $3ea12b0f72ecab43$var$ProblemSubmissionProvider;





var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $5b898d54ffe6c7ff$var$CloseCircleTwoTone = {
    "icon": function render(primaryColor, secondaryColor) {
        return {
            "tag": "svg",
            "attrs": {
                "viewBox": "64 64 896 896",
                "focusable": "false"
            },
            "children": [
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z",
                        "fill": primaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 01-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z",
                        "fill": secondaryColor
                    }
                },
                {
                    "tag": "path",
                    "attrs": {
                        "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z",
                        "fill": primaryColor
                    }
                }
            ]
        };
    },
    "name": "close-circle",
    "theme": "twotone"
};
var $5b898d54ffe6c7ff$export$2e2bcd8739ae039 = $5b898d54ffe6c7ff$var$CloseCircleTwoTone;



var $e3f7e5770d34a5fc$var$CloseCircleTwoTone = function CloseCircleTwoTone(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $5b898d54ffe6c7ff$export$2e2bcd8739ae039)
    }));
};
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIGZpbGw9IiMxNjc3ZmYiIC8+PHBhdGggZD0iTTUxMiAxNDBjLTIwNS40IDAtMzcyIDE2Ni42LTM3MiAzNzJzMTY2LjYgMzcyIDM3MiAzNzIgMzcyLTE2Ni42IDM3Mi0zNzItMTY2LjYtMzcyLTM3Mi0zNzJ6bTE3MS44IDUyNy4xYzEuMiAxLjUgMS45IDMuMyAxLjkgNS4yIDAgNC41LTMuNiA4LTggOGwtNjYtLjMtOTkuMy0xMTguNC05OS4zIDExOC41LTY2LjEuM2MtNC40IDAtOC0zLjYtOC04IDAtMS45LjctMy43IDEuOS01LjJMNDcxIDUxMi4zbC0xMzAuMS0xNTVhOC4zMiA4LjMyIDAgMDEtMS45LTUuMmMwLTQuNSAzLjYtOCA4LThsNjYuMS4zIDk5LjMgMTE4LjQgOTkuNC0xMTguNSA2Ni0uM2M0LjQgMCA4IDMuNiA4IDggMCAxLjktLjYgMy44LTEuOCA1LjJsLTEzMC4xIDE1NSAxMjkuOSAxNTQuOXoiIGZpbGw9IiNlNmY0ZmYiIC8+PHBhdGggZD0iTTY4NS44IDM1MmMwLTQuNC0zLjYtOC04LThsLTY2IC4zLTk5LjQgMTE4LjUtOTkuMy0xMTguNC02Ni4xLS4zYy00LjQgMC04IDMuNS04IDggMCAxLjkuNyAzLjcgMS45IDUuMmwxMzAuMSAxNTUtMTMwLjEgMTU0LjlhOC4zMiA4LjMyIDAgMDAtMS45IDUuMmMwIDQuNCAzLjYgOCA4IDhsNjYuMS0uMyA5OS4zLTExOC41TDYxMS43IDY4MGw2NiAuM2M0LjQgMCA4LTMuNSA4LTggMC0xLjktLjctMy43LTEuOS01LjJMNTUzLjkgNTEyLjJsMTMwLjEtMTU1YzEuMi0xLjQgMS44LTMuMyAxLjgtNS4yeiIgZmlsbD0iIzE2NzdmZiIgLz48L3N2Zz4=) */ var $e3f7e5770d34a5fc$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($e3f7e5770d34a5fc$var$CloseCircleTwoTone);
var $e3f7e5770d34a5fc$export$2e2bcd8739ae039 = $e3f7e5770d34a5fc$var$RefIcon;



var $acw62 = parcelRequire("acw62");
// This icon file is generated automatically.
var $785452596bc32fc2$var$ArrowRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
                }
            }
        ]
    },
    "name": "arrow-right",
    "theme": "outlined"
};
var $785452596bc32fc2$export$2e2bcd8739ae039 = $785452596bc32fc2$var$ArrowRightOutlined;



var $c4137a17be7847d6$var$ArrowRightOutlined = function ArrowRightOutlined(props, ref) {
    return /*#__PURE__*/ $acw62.createElement((0, $7714637e9c1f1f3f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        icon: (0, $785452596bc32fc2$export$2e2bcd8739ae039)
    }));
};
/**![arrow-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2OSA0ODcuOEw0OTEuMiAxNTkuOWMtMi45LTIuNS02LjYtMy45LTEwLjUtMy45aC04OC41Yy03LjQgMC0xMC44IDkuMi01LjIgMTRsMzUwLjIgMzA0SDE1MmMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg1ODUuMUwzODYuOSA4NTRjLTUuNiA0LjktMi4yIDE0IDUuMiAxNGg5MS41YzEuOSAwIDMuOC0uNyA1LjItMkw4NjkgNTM2LjJhMzIuMDcgMzIuMDcgMCAwMDAtNDguNHoiIC8+PC9zdmc+) */ var $c4137a17be7847d6$var$RefIcon = /*#__PURE__*/ $acw62.forwardRef($c4137a17be7847d6$var$ArrowRightOutlined);
var $c4137a17be7847d6$export$2e2bcd8739ae039 = $c4137a17be7847d6$var$RefIcon;








var $acw62 = parcelRequire("acw62");


const $fc50673a6e5a8c48$var$HideLargeControlDataNodes = [
    "Code Viewer",
    "Console Viewer"
];
const $fc50673a6e5a8c48$var$EditorStateNodeCard = ({ editorState: editorState, node: node })=>{
    const [inputs, setInputs] = (0, $acw62.useState)([]);
    const [outputs, setOutputs] = (0, $acw62.useState)([]);
    const [activeTab, setActiveTab] = (0, $acw62.useState)(node.controlData ? "nodeData" : "connections");
    const tabList = [
        node.controlData && {
            key: "nodeData",
            tab: "Options"
        },
        {
            key: "connections",
            tab: "Connections"
        }
    ];
    const contentList = {
        nodeData: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            children: Object.entries((0, $cfadb87391ca5e26$export$e568b92dd6d03d22)(node.controlData)).filter((item)=>item[1]) // Filter out empty values
            .map((item, index)=>{
                let [key, value] = item;
                if (Array.isArray(value)) value = value.join(", ");
                if ($fc50673a6e5a8c48$var$HideLargeControlDataNodes.includes(node.name)) value = "Too large to display, see full output below.";
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "boldText",
                            children: key
                        }),
                        `: ${value}`
                    ]
                }, key);
            })
        }, "controlData"),
        connections: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "usedNodeConnections",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "usedNodeInputOutputContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "boldText",
                            children: "Inputs"
                        }),
                        inputs.length > 0 ? inputs.map((input, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: input
                            }, index)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "noConnectionMessage",
                            children: "No inputs"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "usedNodeInputOutputContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "boldText",
                            children: "Outputs"
                        }),
                        outputs.length > 0 ? outputs.map((output, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: output
                            }, index)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            className: "noConnectionMessage",
                            children: "No outputs"
                        })
                    ]
                })
            ]
        }, "connectionData")
    };
    const handleTabChange = (key)=>{
        setActiveTab(key);
    };
    (0, $acw62.useEffect)(()=>{
        if (node) {
            setInputs(editorState.connections.filter((conn)=>conn.target.id === node.id).map((conn)=>conn.source.blockType));
            setOutputs(editorState.connections.filter((conn)=>conn.source.id === node.id).map((conn)=>conn.target.blockType));
        }
    }, [
        node
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
        theme: {
            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1c21a702bf20ca7$export$2e2bcd8739ae039), {
            className: "editorStateUsedNode",
            title: node.name,
            tabList: tabList,
            activeTabKey: activeTab,
            onTabChange: handleTabChange,
            children: contentList[activeTab]
        }, node.id)
    });
};
var $fc50673a6e5a8c48$export$2e2bcd8739ae039 = $fc50673a6e5a8c48$var$EditorStateNodeCard;


const $07cc7dc8e2c6a011$var$ProblemSubmissionSummary = ({ userSettings: userSettings, username: username })=>{
    const codeRef = (0, $acw62.useRef)(null);
    const [localDateStarted, setLocalDateStarted] = (0, $acw62.useState)(null);
    const [localDateSubmissionStarted, setLocalDateSubmissionStarted] = (0, $acw62.useState)(null);
    const [localDateCompleted, setLocalDateCompleted] = (0, $acw62.useState)(null);
    const [elapsedTime, setElapsedTime] = (0, $acw62.useState)(null);
    const [currentSubmissionElapsedTime, setCurrentSubmissionElapsedTime] = (0, $acw62.useState)(null);
    const [sortedCompleteTasks, setSortedCompleteTasks] = (0, $acw62.useState)([]);
    const [localProblem_id, setLocalProblem_id] = (0, $acw62.useState)(null);
    const { submissionDetails: submissionDetails, setSubmissionDetails: setSubmissionDetails } = (0, $3ea12b0f72ecab43$export$6a9bc7ec8fddbf5)();
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    if (!submissionDetails) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
    const { problem: problem, problem_submission: problem_submission, tasks: tasks, problem_submission_numbers: problem_submission_numbers, submission_images: submission_images } = submissionDetails;
    const { submission_number: submission_number, confidence: confidence, date_started: date_started, date_submission_started: date_submission_started, date_completed: date_completed, full_code: full_code, console_output: console_output, image_url: image_url, editor_state: editor_state } = problem_submission;
    const convertToLocalTime = (dateString)=>{
        const date = new Date(dateString);
        return date.toLocaleString();
    };
    const getElapsedTime = (dateStarted, dateCompleted)=>{
        const dateStartedObj = new Date(dateStarted);
        const dateCompletedObj = new Date(dateCompleted);
        const elapsedTime = dateCompletedObj.getTime() - dateStartedObj.getTime();
        const days = Math.floor(elapsedTime / 86400000);
        const hours = Math.floor(elapsedTime % 86400000 / 3600000);
        const minutes = Math.floor(elapsedTime % 3600000 / 60000);
        let result = "";
        if (days > 0) result += `${days} days, `;
        if (hours > 0 || days > 0) result += `${hours} hours, `;
        if (minutes > 0 || minutes === 0 && hours > 0) result += `${minutes} minutes`;
        else result += `less than a minute`;
        return result.trim();
    };
    const logSubmissionEvent = (action, eventData)=>{
        const logData = {
            action: action,
            problem_id: localProblem_id,
            eventData: eventData,
            details: (0, $cfadb87391ca5e26$export$5e4dc5c899332621)(action, eventData)
        };
        (0, $cfadb87391ca5e26$export$7e41d6135b9d82b9)(logData);
    };
    const handleNewSubmission = async ()=>{
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post(`/api/problems/mark-in-progress`, {
                problem_id: localProblem_id
            });
            if (problemContext) {
                const { setProblem: setProblem } = problemContext;
                setProblem((prev)=>{
                    if (prev) return {
                        ...prev,
                        problem_status: "in-progress"
                    };
                    return prev;
                });
            }
            if (problemContext) {
                const { problem: problem } = problemContext;
                const eventData = {
                    problem_number: problem?.problem_number,
                    submission_number: res.data.submission_number + 1,
                    date_submission_started: new Date(res.data.date_submission_started).toLocaleString()
                };
                logSubmissionEvent("start_new_submission", eventData);
            }
            navigate(`/problems/${localProblem_id}`);
        } catch (e) {
            console.log(e);
        }
    };
    const handleSubmissionChange = async (submissionNumber)=>{
        if (submissionNumber === submission_number.toString()) return;
        try {
            const res = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/problems/get-problem-submission", {
                submission_number: submissionNumber,
                problem_id: localProblem_id
            });
            const selectedSubmission = res.data.problem_submission;
            const selectedTasks = res.data.tasks;
            const eventData = {
                problem_number: problem.problem_number,
                submission_number: Number(submissionNumber),
                date_submission_started: new Date(selectedSubmission.date_submission_started).toLocaleString(),
                date_completed: new Date(selectedSubmission.date_completed).toLocaleString(),
                elapsed_time: getElapsedTime(selectedSubmission.date_submission_started, selectedSubmission.date_completed)
            };
            let action = "view_past_submission";
            if (selectedSubmission.submission_number === Math.max(...problem_submission_numbers)) action = "view_latest_submission";
            logSubmissionEvent(action, eventData);
            setSubmissionDetails((prev)=>{
                if (prev) return {
                    ...prev,
                    problem_submission: selectedSubmission,
                    submission_images: selectedSubmission.submission_images,
                    tasks: selectedTasks
                };
                return prev;
            });
        } catch (e) {
            console.log(e);
        }
    };
    (0, $acw62.useEffect)(()=>{
        const dateStartedString = convertToLocalTime(date_started);
        const dateSubmissionStartedString = date_submission_started ? convertToLocalTime(date_submission_started) : null;
        const dateCompletedString = convertToLocalTime(date_completed);
        const elapsedTimeString = getElapsedTime(date_started, date_completed);
        const currentSubmissionElapsedTimeString = date_submission_started ? getElapsedTime(date_submission_started, date_completed) : null;
        setLocalDateStarted(dateStartedString);
        setLocalDateSubmissionStarted(dateSubmissionStartedString);
        setLocalDateCompleted(dateCompletedString);
        setElapsedTime(elapsedTimeString);
        setCurrentSubmissionElapsedTime(currentSubmissionElapsedTimeString);
    }, [
        date_started,
        date_completed
    ]);
    (0, $acw62.useEffect)(()=>{
        if (full_code && codeRef.current) (0, (/*@__PURE__*/$parcel$interopDefault($1fddf034d74735a2$exports))).highlightElement(codeRef.current);
    }, [
        full_code
    ]);
    (0, $acw62.useEffect)(()=>{
        const tempSortedTasks = [
            ...tasks
        ].sort((a, b)=>a.task_number - b.task_number);
        setSortedCompleteTasks(tempSortedTasks.filter((task)=>task.is_completed));
    }, [
        tasks
    ]);
    (0, $acw62.useEffect)(()=>{
        if (problemContext) {
            const { problem: problem } = problemContext;
            if (problem) setLocalProblem_id(problem.id);
        }
    }, [
        problemContext
    ]);
    (0, $acw62.useEffect)(()=>{
        if (localProblem_id) setTimeout(()=>{
            logSubmissionEvent("view_latest_submission", {
                problem_number: problem.problem_number,
                submission_number: submission_number,
                localDateStarted: localDateStarted,
                localDateSubmissionStarted: localDateSubmissionStarted,
                localDateCompleted: localDateCompleted
            });
        }, 200);
    }, [
        localProblem_id
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "problemSubmissionMainContainer",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "referenceContainerForButtons",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                    theme: {
                        algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "problemSubmissionButtonPanel",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                onClick: ()=>navigate("/problems"),
                                children: "Go to Problems"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                onClick: ()=>navigate(`/problems/${localProblem_id}/description`),
                                children: "Problem Description"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                onClick: ()=>navigate(`/logout`),
                                children: "Logout"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "problemSubmissionInnerContainer",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "problemSubmissionSection",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "titleContainer",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h1", {
                                        children: [
                                            "Submission For: ",
                                            username
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                        children: `Problem ${problem.problem_number} - ${problem.title}`
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7ed5e10e08c170f8$export$2e2bcd8739ae039), {
                                        theme: {
                                            algorithm: (0, $a978954eaf874e83$export$2e2bcd8739ae039).darkAlgorithm
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "reSubmitProblemContainer",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3929aafb948ac62c$export$2e2bcd8739ae039), {
                                                        className: "reSubmitProblemButton",
                                                        onClick: handleNewSubmission,
                                                        children: "New Submission"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: "(Start from the most recent submission state)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "submissionSelectionContainer",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        children: "Currently Viewing"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039), {
                                                        defaultValue: submission_number.toString(),
                                                        onSelect: handleSubmissionChange,
                                                        className: "submissionSelect",
                                                        dropdownStyle: {
                                                            width: "135px"
                                                        },
                                                        children: problem_submission_numbers.map((submissionNumber)=>{
                                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b56c179e5783cdb$export$2e2bcd8739ae039).Option, {
                                                                value: submissionNumber.toString(),
                                                                children: `Submission ${submissionNumber}`
                                                            }, submissionNumber);
                                                        })
                                                    }),
                                                    submission_number === Math.max(...problem_submission_numbers) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: "(Latest submission)"
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                        children: "(Previous submission)"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "problemSubmissionDetailsContainer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Problem Start:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: `${localDateStarted}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Current Submission:"
                                                    }),
                                                    localDateSubmissionStarted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: `Date started: ${localDateSubmissionStarted}`
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: `Date submitted: ${localDateCompleted}`
                                                    }),
                                                    currentSubmissionElapsedTime && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: `Time elapsed: ${currentSubmissionElapsedTime}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: "Summary:"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: `Total time elapsed: ${elapsedTime}`
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        children: `Confidence: ${confidence}%`
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        tasks.length > 0 && (!userSettings || userSettings.taskbar_enabled) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "problemSubmissionSection",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: `Tasks (${`${sortedCompleteTasks.filter((task)=>task.is_completed).length}/${tasks.length}`})`
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                    className: "problemSubmissionDivider"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "problemTasksContainer",
                                    style: {
                                        justifyContent: `${sortedCompleteTasks.length !== tasks.length ? "space-evenly" : "flex-start"}`
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "completeTasksContainer",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: `Completed `
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                    children: sortedCompleteTasks.map((task)=>{
                                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                            className: "completedTaskItem",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6aa79cbfa41e2a73$export$2e2bcd8739ae039), {
                                                                    twoToneColor: "#52c41a"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                    children: task.title
                                                                })
                                                            ]
                                                        }, task.id);
                                                    })
                                                })
                                            ]
                                        }),
                                        sortedCompleteTasks.length !== tasks.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                                    type: "vertical",
                                                    style: {
                                                        height: "auto"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "incompleteTasksContainer",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                            children: "Incomplete"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                            children: tasks.filter((task)=>!task.is_completed).map((task)=>{
                                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                                    className: "completedTaskItem",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f7e5770d34a5fc$export$2e2bcd8739ae039), {
                                                                            twoToneColor: "#ff0000"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            children: task.title
                                                                        })
                                                                    ]
                                                                }, task.id);
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "problemSubmissionSection",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Snapshot of your submission"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                    className: "problemSubmissionDivider"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "editorScreenshotContainer",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039), {
                                        src: `${(0, $9d936a2aecb96285$export$b27b0287c31e45de)}${image_url}`,
                                        alt: "Editor Screenshot",
                                        title: "Click to expand",
                                        preview: {
                                            minScale: 1.25
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Blocks Used"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                    className: "problemSubmissionDivider"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "usedNodes",
                                    children: editor_state && editor_state.nodes.map((node)=>{
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc50673a6e5a8c48$export$2e2bcd8739ae039), {
                                            editorState: editor_state,
                                            node: node
                                        }, node.id);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "problemSubmissionSection",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Generated Code"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                    className: "problemSubmissionDivider"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                    className: "usedPaths",
                                    children: editor_state && editor_state.paths.map((path)=>{
                                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                    children: `Path ${path.pathNumber} Blocks`
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                    children: [
                                                        `${path.startNode}`,
                                                        " ",
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4137a17be7847d6$export$2e2bcd8739ae039), {}),
                                                        ` ${path.endNode}`
                                                    ]
                                                })
                                            ]
                                        }, path.pathNumber);
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                    className: "language-python problemSubmissionCode",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                        className: "language-python",
                                        ref: codeRef,
                                        children: full_code
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "problemSubmissionSection",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Console Output"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {
                                    className: "problemSubmissionDivider"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "console",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("pre", {
                                        children: console_output || "No output generated"
                                    })
                                })
                            ]
                        }),
                        submission_images.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "problemSubmissionSection",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: "Generated Images"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4728a501f42302e5$export$2e2bcd8739ae039), {}),
                                submission_images.map((image)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                children: `${image.image_title}`
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "editorScreenshotContainer",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdacfb30f3b10618$export$2e2bcd8739ae039), {
                                                    src: `${(0, $9d936a2aecb96285$export$b27b0287c31e45de)}${image.image_path}`,
                                                    alt: image.image_title,
                                                    title: "Click to expand",
                                                    preview: {
                                                        minScale: 1.25
                                                    }
                                                })
                                            })
                                        ]
                                    }, image.id))
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $07cc7dc8e2c6a011$export$2e2bcd8739ae039 = $07cc7dc8e2c6a011$var$ProblemSubmissionSummary;




parcelRequire("acw62");


const $a73eae1a81428fe5$var$SubmissionProtectedRoute = ({ children: children })=>{
    const { problem_id: problem_id } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const { isSubmitted: isSubmitted, isLoading: isLoading } = (0, $3ea12b0f72ecab43$export$6a9bc7ec8fddbf5)();
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
    if (!isSubmitted) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
        to: `/problems/${problem_id}`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
};
var $a73eae1a81428fe5$export$2e2bcd8739ae039 = $a73eae1a81428fe5$var$SubmissionProtectedRoute;




var $acw62 = parcelRequire("acw62");



const $466f6bde9a0147fa$var$LogoutComponent = ({ setIsAuthenticated: setIsAuthenticated })=>{
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const problemContext = (0, $acw62.useContext)((0, $4b757d6069fb0a9d$export$2e2bcd8739ae039));
    if (!problemContext) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "ProblemContext not found"
    });
    const { setProblem_id: setProblem_id } = problemContext;
    const handleLogout = async ()=>{
        try {
            const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).post("/api/users/logout", {}, {
                withCredentials: true
            });
            setIsAuthenticated(false);
            setProblem_id(undefined);
            navigate("/login");
        } catch (error) {
            console.log("Logout error ->", error);
        }
    };
    (0, $acw62.useEffect)(()=>{
        handleLogout();
    }, [
        problemContext
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Logging out..."
    });
};
var $466f6bde9a0147fa$export$2e2bcd8739ae039 = $466f6bde9a0147fa$var$LogoutComponent;




const $3d74bff2846008b2$export$50e2e2a2bbf3f2dd = async ()=>{
    try {
        const response = await (0, $cfadb87391ca5e26$export$155ec85c4e3b5e85).get("/api/users/verify-authentication", {
            withCredentials: true
        });
        const data = response.data;
        return {
            is_authenticated: data.is_authenticated,
            is_admin: data.is_admin,
            userSettings: data.userSettings,
            username: data.username
        };
    } catch (error) {
        return {
            is_authenticated: false,
            is_admin: false
        };
    }
};
function $3d74bff2846008b2$export$2e2bcd8739ae039() {
    const [isAuthenticated, setIsAuthenticated] = (0, $acw62.useState)(false);
    const [isAdmin, setIsAdmin] = (0, $acw62.useState)(false);
    const [username, setUsername] = (0, $acw62.useState)("");
    const [userSettings, setUserSettings] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    (0, $acw62.useEffect)(()=>{
        const verifyAuthentication = async ()=>{
            const authenticationData = await $3d74bff2846008b2$export$50e2e2a2bbf3f2dd();
            setIsAuthenticated(authenticationData.is_authenticated);
            setIsAdmin(authenticationData.is_admin);
            setUsername(authenticationData.username);
            setUserSettings(authenticationData.userSettings);
            setIsLoading(false);
        };
        verifyAuthentication();
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "App",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b9bf6be2b37a4cd$export$3d3872bfc53fd642), {
                reCaptchaKey: (0, $9d936a2aecb96285$export$f8a5930a19e52ae8),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49f72ad1047e4a8b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd4511523991f10d$export$2e2bcd8739ae039), {
                                    isAuthenticated: isAuthenticated,
                                    setIsAuthenticated: setIsAuthenticated,
                                    isLoading: isLoading,
                                    setIsAdmin: setIsAdmin,
                                    setUsername: setUsername,
                                    setUserSettings: setUserSettings,
                                    setIsLoading: setIsLoading,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd9e5bb34b4358e4$export$2e2bcd8739ae039), {
                                        isAdmin: isAdmin,
                                        setIsAuthenticated: setIsAuthenticated,
                                        userSettings: userSettings,
                                        username: username
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/problems/:problem_id",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd4511523991f10d$export$2e2bcd8739ae039), {
                                    isAuthenticated: isAuthenticated,
                                    setIsAuthenticated: setIsAuthenticated,
                                    isLoading: isLoading,
                                    setIsAdmin: setIsAdmin,
                                    setUsername: setUsername,
                                    setUserSettings: setUserSettings,
                                    setIsLoading: setIsLoading,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d8ac34042b67290$export$2e2bcd8739ae039), {
                                        isLoading: isLoading,
                                        setIsAuthenticated: setIsAuthenticated,
                                        isAdmin: isAdmin,
                                        userSettings: userSettings,
                                        username: username
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/problems/:problem_id/description",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd4511523991f10d$export$2e2bcd8739ae039), {
                                    isAuthenticated: isAuthenticated,
                                    setIsAuthenticated: setIsAuthenticated,
                                    isLoading: isLoading,
                                    setIsAdmin: setIsAdmin,
                                    setUsername: setUsername,
                                    setUserSettings: setUserSettings,
                                    setIsLoading: setIsLoading,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dc39e8dd1c90619b$export$2e2bcd8739ae039), {
                                        inDrawer: false,
                                        isAdmin: isAdmin
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/problems/:problem_id/submission",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd4511523991f10d$export$2e2bcd8739ae039), {
                                    isAuthenticated: isAuthenticated,
                                    setIsAuthenticated: setIsAuthenticated,
                                    isLoading: isLoading,
                                    setIsAdmin: setIsAdmin,
                                    setUsername: setUsername,
                                    setUserSettings: setUserSettings,
                                    setIsLoading: setIsLoading,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ea12b0f72ecab43$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a73eae1a81428fe5$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $07cc7dc8e2c6a011$export$2e2bcd8739ae039), {
                                                userSettings: userSettings,
                                                username: username
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/problems",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd4511523991f10d$export$2e2bcd8739ae039), {
                                    isAuthenticated: isAuthenticated,
                                    setIsAuthenticated: setIsAuthenticated,
                                    isLoading: isLoading,
                                    setIsAdmin: setIsAdmin,
                                    setUsername: setUsername,
                                    setUserSettings: setUserSettings,
                                    setIsLoading: setIsLoading,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd9e5bb34b4358e4$export$2e2bcd8739ae039), {
                                        isAdmin: isAdmin,
                                        setIsAuthenticated: setIsAuthenticated,
                                        userSettings: userSettings,
                                        username: username
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/login",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd3360b4a2f9eb72$export$2e2bcd8739ae039), {
                                    isAuthenticated: isAuthenticated,
                                    setIsAuthenticated: setIsAuthenticated,
                                    isLoading: isLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/register",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21eec0eb2da7c252$export$2e2bcd8739ae039), {
                                    isAuthenticated: isAuthenticated,
                                    setIsAuthenticated: setIsAuthenticated,
                                    isLoading: isLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/logout",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $466f6bde9a0147fa$export$2e2bcd8739ae039), {
                                    setIsAuthenticated: setIsAuthenticated
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
}


const $70fc9a727fa662ae$var$rootElement = document.getElementById("root");
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($70fc9a727fa662ae$var$rootElement);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d74bff2846008b2$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=index.a02563e7.js.map
